// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"8RSWf":[function(require,module,exports) {
// components barrel
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _notificationService = require("./services/notificationService");
var _pdqNotificationStack = require("./ui/pdq-notification-stack");
parcelHelpers.exportAll(_pdqNotificationStack, exports);
var _pdqConfirmDialog = require("./ui/pdq-confirm-dialog");
parcelHelpers.exportAll(_pdqConfirmDialog, exports);
parcelHelpers.exportAll(_pdqConfirmDialog, exports);
// export * from './ui/pdq-s3-file-metadata'
// export * from './ui/pdq-s3-upload'
var _pdqPdfViewer = require("./ui/pdq-pdf-viewer");
parcelHelpers.exportAll(_pdqPdfViewer, exports);
var _pdqIcon = require("./ui/pdq-icon");
parcelHelpers.exportAll(_pdqIcon, exports);
var _pdqTheme = require("./ui/pdq-theme");
parcelHelpers.exportAll(_pdqTheme, exports);
// flow
var _pdqJson = require("./flow/pdq-json");
parcelHelpers.exportAll(_pdqJson, exports);
var _pdqPerspectiveViewer = require("./flow/pdq-perspective-viewer");
parcelHelpers.exportAll(_pdqPerspectiveViewer, exports);
var _pdqView = require("./flow/pdq-view");
parcelHelpers.exportAll(_pdqView, exports);
var _pdqDump = require("./flow/pdq-dump");
parcelHelpers.exportAll(_pdqDump, exports);
var _pdqDataRequest = require("./flow/pdq-data-request");
parcelHelpers.exportAll(_pdqDataRequest, exports);
var _pdqToolbar = require("./flow/pdq-toolbar");
parcelHelpers.exportAll(_pdqToolbar, exports);
var _pdqDataModel = require("./flow/pdq-data-model");
parcelHelpers.exportAll(_pdqDataModel, exports);
var _pdqTransform = require("./flow/pdq-transform");
parcelHelpers.exportAll(_pdqTransform, exports);
var _pdqPagination = require("./flow/pdq-pagination");
parcelHelpers.exportAll(_pdqPagination, exports);
var _pdqTable = require("./flow/pdq-table");
parcelHelpers.exportAll(_pdqTable, exports);
// liquid
var _pdqLiquid = require("./liquid/pdq-liquid");
parcelHelpers.exportAll(_pdqLiquid, exports);
//export {PdqLiquidVariable} from "./liquid/pdq-liquid-variable";
//export {PdqLiquidVariableStack} from "./liquid/pdq-liquid-variable-stack";
// forms
var _pdqSchemaForm = require("./forms/pdq-schema-form");
parcelHelpers.exportAll(_pdqSchemaForm, exports);
// sqlite
var _index = require("./sqlite/index");
parcelHelpers.exportAll(_index, exports);
// monaco
var _pdqTextEditor = require("./text-editor/pdq-text-editor");
parcelHelpers.exportAll(_pdqTextEditor, exports);
// services barrel
parcelHelpers.exportAll(_notificationService, exports);
// export * from './services/PdqS3Service'
var _tableBroker = require("./services/TableBroker");
parcelHelpers.exportAll(_tableBroker, exports);
var _dataClient = require("./services/DataClient");
parcelHelpers.exportAll(_dataClient, exports);
// google
var _googleAuth = require("./google/googleAuth");
var _googleApi = require("./google/googleApi");
var _pdqGoogleAuth = require("./google/pdq-google-auth");
parcelHelpers.exportAll(_pdqGoogleAuth, exports);
var _pdqGoogleLoginButton = require("./google/pdq-google-login-button");
parcelHelpers.exportAll(_pdqGoogleLoginButton, exports);
var _pdqGoogleApi = require("./google/pdq-google-api");
parcelHelpers.exportAll(_pdqGoogleApi, exports);
var _pdqGoogleFileRequest = require("./google/pdq-google-file-request");
parcelHelpers.exportAll(_pdqGoogleFileRequest, exports);
var _pdqGoogleFileViewer = require("./google/pdq-google-file-viewer");
parcelHelpers.exportAll(_pdqGoogleFileViewer, exports);
var _pdqGoogleFilelistDatasource = require("./google/pdq-google-filelist-datasource");
parcelHelpers.exportAll(_pdqGoogleFilelistDatasource, exports);
// carbon
// Accordion components
var _indexJs = require("@carbon/web-components/es/components/accordion/index.js");
// import '@carbon/web-components/es/components/accordion/accordion.js';
// import '@carbon/web-components/es/components/accordion/accordion-item.js';
// Button components
var _indexJs1 = require("@carbon/web-components/es/components/button/index.js");
//import '@carbon/web-components/es/components/button/button.js';
// Checkbox components
var _indexJs2 = require("@carbon/web-components/es/components/checkbox/index.js");
//import '@carbon/web-components/es/components/checkbox/checkbox.js';
// CodeSnippet components
var _indexJs3 = require("@carbon/web-components/es/components/code-snippet/index.js");
//import '@carbon/web-components/es/components/code-snippet/code-snippet.js';
// Combobox components
var _indexJs4 = require("@carbon/web-components/es/components/combo-box/index.js");
// import '@carbon/web-components/es/components/combo-box/combo-box.js';
// import '@carbon/web-components/es/components/combo-box/combo-box-item.js';
// Data table components
var _indexJs5 = require("@carbon/web-components/es/components/data-table/index.js");
//import '@carbon/web-components/es/components/data-table/table.js';
//import '@carbon/web-components/es/components/data-table/table-header-cell.js';
//import '@carbon/web-components/es/components/data-table/table-header-row.js';
//import '@carbon/web-components/es/components/data-table/table-row.js';
//import '@carbon/web-components/es/components/data-table/table-cell.js';
//import '@carbon/web-components/es/components/data-table/table-toolbar.js';
//import '@carbon/web-components/es/components/data-table/table-toolbar-search.js';
//import '@carbon/web-components/es/components/data-table/table-toolbar-content.js';
//import '@carbon/web-components/es/components/data-table/table-toolbar-menu.js';
//import '@carbon/web-components/es/components/data-table/table-toolbar-action.js';
//import '@carbon/web-components/es/components/data-table/table-batch-actions.js';
//import '@carbon/web-components/es/components/data-table/table-batch-action.js';
// Date Picker components
var _indexJs6 = require("@carbon/web-components/es/components/date-picker/index.js");
// import '@carbon/web-components/es/components/date-picker/date-picker.js';
// import '@carbon/web-components/es/components/date-picker/date-picker-input.js';
//import '@carbon/web-components/es/components/date-picker/date-picker-dropdown.js';
// Dropdown components
var _indexJs7 = require("@carbon/web-components/es/components/dropdown/index.js");
// import '@carbon/web-components/es/components/dropdown/dropdown.js';
// import '@carbon/web-components/es/components/dropdown/dropdown-item.js';
//import '@carbon/web-components/es/components/dropdown/dropdown-item-group.js';
// File Uploader components
var _indexJs8 = require("@carbon/web-components/es/components/file-uploader/index.js");
// import '@carbon/web-components/es/components/file-uploader/file-uploader.js';
// import '@carbon/web-components/es/components/file-uploader/file-uploader-item.js';
// import '@carbon/web-components/es/components/file-uploader/file-uploader-drop-container.js';
// Form components
var _indexJs9 = require("@carbon/web-components/es/components/form/index.js");
//import '@carbon/web-components/es/components/form/form-item.js';
// Icon components
// import '@carbon/web-components/es/components/icon/icon.js';
// Inline Loading components
var _indexJs10 = require("@carbon/web-components/es/components/inline-loading/index.js");
//import '@carbon/web-components/es/components/inline-loading/inline-loading.js';
// Input components
var _indexJs11 = require("@carbon/web-components/es/components/text-input/index.js");
//import '@carbon/web-components/es/components/input/input.js';
// Link components
var _indexJs12 = require("@carbon/web-components/es/components/link/index.js");
//import '@carbon/web-components/es/components/link/link.js';
// List components
var _indexJs13 = require("@carbon/web-components/es/components/list/index.js");
//import '@carbon/web-components/es/components/list/list-item.js';
// Loading components
var _indexJs14 = require("@carbon/web-components/es/components/loading/index.js");
//import '@carbon/web-components/es/components/loading/loading.js';
// Modal components
var _indexJs15 = require("@carbon/web-components/es/components/modal/index.js");
//import '@carbon/web-components/es/components/modal/modal.js';
// Multi Select components
var _indexJs16 = require("@carbon/web-components/es/components/multi-select/index.js");
// import '@carbon/web-components/es/components/multi-select/multi-select.js';
// import '@carbon/web-components/es/components/multi-select/multi-select-item.js';
// Notification components
var _indexJs17 = require("@carbon/web-components/es/components/notification/index.js");
// import '@carbon/web-components/es/components/notification/inline-notification.js';
// import '@carbon/web-components/es/components/notification/toast-notification.js';
// Number Input components
var _indexJs18 = require("@carbon/web-components/es/components/number-input/index.js");
//import '@carbon/web-components/es/components/number-input/number-input.js';
// Overflow Menu components
var _indexJs19 = require("@carbon/web-components/es/components/overflow-menu/index.js");
// import '@carbon/web-components/es/components/overflow-menu/overflow-menu.js';
// import '@carbon/web-components/es/components/overflow-menu/overflow-menu-item.js';
// Pagination components
var _indexJs20 = require("@carbon/web-components/es/components/pagination/index.js");
//import '@carbon/web-components/es/components/pagination/pagination.js';
// Progress Indicator components
var _indexJs21 = require("@carbon/web-components/es/components/progress-indicator/index.js");
// import '@carbon/web-components/es/components/progress-indicator/progress-indicator.js';
// import '@carbon/web-components/es/components/progress-indicator/progress-step.js';
// Radio Button components
var _indexJs22 = require("@carbon/web-components/es/components/radio-button/index.js");
// import '@carbon/web-components/es/components/radio-button/radio-button.js';
// import '@carbon/web-components/es/components/radio-button/radio-button-group.js';
// Search components
var _indexJs23 = require("@carbon/web-components/es/components/search/index.js");
//import '@carbon/web-components/es/components/search/search.js';
// Select components
var _indexJs24 = require("@carbon/web-components/es/components/select/index.js");
// import '@carbon/web-components/es/components/select/select.js';
// import '@carbon/web-components/es/components/select/select-item.js';
// import '@carbon/web-components/es/components/select/select-item-group.js';
// Slider components
var _indexJs25 = require("@carbon/web-components/es/components/slider/index.js");
// import '@carbon/web-components/es/components/slider/slider.js';
// import '@carbon/web-components/es/components/slider/slider-input.js';
// Structured List components
var _indexJs26 = require("@carbon/web-components/es/components/structured-list/index.js");
// import '@carbon/web-components/es/components/structured-list/structured-list.js';
// import '@carbon/web-components/es/components/structured-list/structured-list-row.js';
// import '@carbon/web-components/es/components/structured-list/structured-list-header-row.js';
// import '@carbon/web-components/es/components/structured-list/structured-list-cell.js';
// Tabs components
var _indexJs27 = require("@carbon/web-components/es/components/tabs/index.js");
// import '@carbon/web-components/es/components/tabs/tabs.js';
// import '@carbon/web-components/es/components/tabs/tab.js';
//import '@carbon/web-components/es/components/tabs/tab-panel.js';
// Tag components
var _indexJs28 = require("@carbon/web-components/es/components/tag/index.js");
//import '@carbon/web-components/es/components/tag/tag.js';
// Text Area components
var _indexJs29 = require("@carbon/web-components/es/components/textarea/index.js");
//import '@carbon/web-components/es/components/text-input/text-input.js';
// Tile components
var _indexJs30 = require("@carbon/web-components/es/components/tile/index.js");
// import '@carbon/web-components/es/components/tile/tile.js';
// import '@carbon/web-components/es/components/tile/selectable-tile.js';
// import '@carbon/web-components/es/components/tile/expandable-tile.js';
// import '@carbon/web-components/es/components/tile/clickable-tile.js';
// import '@carbon/web-components/es/components/tile/radio-tile.js';
// Toggle components
var _indexJs31 = require("@carbon/web-components/es/components/toggle/index.js");
//import '@carbon/web-components/es/components/toggle/toggle.js';
// Tooltip components
var _indexJs32 = require("@carbon/web-components/es/components/tooltip/index.js");
// import '@carbon/web-components/es/components/tooltip/tooltip.js';
// import '@carbon/web-components/es/components/tooltip/tooltip-definition.js';
// import '@carbon/web-components/es/components/tooltip/tooltip-icon.js';
var _indexJs33 = require("@carbon/web-components/es/components/ui-shell/index.js");
var _indexJs34 = require("@carbon/web-components/es/components/floating-menu/index.js");
var _indexJs35 = require("@carbon/layout/es/index.js");
var _blobRegistry = require("./services/BlobRegistry");
var _blobCache = require("./services/BlobCache");
var _dataBroker = require("./services/DataBroker");
// Re-export all components - parcel not re-exporting with current config
// export * from '@carbon/web-components';
var _pdqSqliteClient = require("./sqlite/pdq-sqlite-client");
var _rxjs = require("rxjs");
if (window) window.pdq = {
    notificationService: (0, _notificationService.notificationService),
    blobRegistry: (0, _blobRegistry.blobRegistry),
    blobCache: (0, _blobCache.blobCache),
    tableBroker: (0, _tableBroker.tableBroker),
    dataClient: (0, _dataClient.dataClient),
    dataBroker: (0, _dataBroker.dataBroker),
    googleAuth: (0, _googleAuth.googleAuth),
    googleApi: (0, _googleApi.googleApi),
    PqdSqlClient: (0, _pdqSqliteClient.PqdSqlClient),
    Subject: (0, _rxjs.Subject),
    ReplaySubject: (0, _rxjs.ReplaySubject),
    BehaviorSubject: (0, _rxjs.BehaviorSubject),
    combineLatest: (0, _rxjs.combineLatest),
    from: (0, _rxjs.from),
    of: (0, _rxjs.of),
    firstValueFrom: (0, _rxjs.firstValueFrom)
};

},{"./services/notificationService":"2Yic8","./ui/pdq-notification-stack":"lOgHs","./ui/pdq-confirm-dialog":"anhGr","./ui/pdq-pdf-viewer":"cm0HP","./ui/pdq-icon":"jDleQ","./ui/pdq-theme":"iRpTl","./flow/pdq-json":"fA7mR","./flow/pdq-perspective-viewer":"kuRgh","./flow/pdq-view":"8aNDL","./flow/pdq-dump":"kw6Ih","./flow/pdq-data-request":"iNmdP","./flow/pdq-toolbar":"cire2","./flow/pdq-data-model":"hM146","./flow/pdq-transform":"ge1eF","./flow/pdq-pagination":"bcmsT","./flow/pdq-table":"3k4Ql","./liquid/pdq-liquid":"gXqJi","./forms/pdq-schema-form":"4Amn9","./sqlite/index":"hixV2","./text-editor/pdq-text-editor":"efG9a","./services/TableBroker":"kJzSP","./services/DataClient":"jd0ep","./google/googleAuth":"z2COH","./google/googleApi":"eOEG5","./google/pdq-google-auth":"hZ6Xd","./google/pdq-google-login-button":"jUQn4","./google/pdq-google-api":"1EVCV","./google/pdq-google-file-request":"380pF","./google/pdq-google-file-viewer":"aeg5P","./google/pdq-google-filelist-datasource":"gGHDA","@carbon/web-components/es/components/accordion/index.js":"kVOi5","@carbon/web-components/es/components/button/index.js":"cptjs","@carbon/web-components/es/components/checkbox/index.js":"lcFsF","@carbon/web-components/es/components/code-snippet/index.js":"2G8F5","@carbon/web-components/es/components/combo-box/index.js":"jT0Dn","@carbon/web-components/es/components/data-table/index.js":"cF8Zr","@carbon/web-components/es/components/date-picker/index.js":"7NQmV","@carbon/web-components/es/components/dropdown/index.js":"cSKNX","@carbon/web-components/es/components/file-uploader/index.js":"28Hqz","@carbon/web-components/es/components/form/index.js":"4JwcQ","@carbon/web-components/es/components/inline-loading/index.js":"ab5WP","@carbon/web-components/es/components/text-input/index.js":"hYM6R","@carbon/web-components/es/components/link/index.js":"f7VnJ","@carbon/web-components/es/components/list/index.js":"g3gxU","@carbon/web-components/es/components/loading/index.js":"fOxrn","@carbon/web-components/es/components/modal/index.js":"6x6o7","@carbon/web-components/es/components/multi-select/index.js":"1KZwa","@carbon/web-components/es/components/notification/index.js":"5iK9B","@carbon/web-components/es/components/number-input/index.js":"iXbVz","@carbon/web-components/es/components/overflow-menu/index.js":"hUifs","@carbon/web-components/es/components/pagination/index.js":"d4u0Z","@carbon/web-components/es/components/progress-indicator/index.js":"aHihW","@carbon/web-components/es/components/radio-button/index.js":"E51aG","@carbon/web-components/es/components/search/index.js":"3bVoZ","@carbon/web-components/es/components/select/index.js":"fhDAD","@carbon/web-components/es/components/slider/index.js":"g8w4O","@carbon/web-components/es/components/structured-list/index.js":"jzPDw","@carbon/web-components/es/components/tabs/index.js":"8gBtv","@carbon/web-components/es/components/tag/index.js":"6Wp6j","@carbon/web-components/es/components/textarea/index.js":"i8YTZ","@carbon/web-components/es/components/tile/index.js":"8kUeq","@carbon/web-components/es/components/toggle/index.js":"13iRn","@carbon/web-components/es/components/tooltip/index.js":"6Kuj6","@carbon/web-components/es/components/ui-shell/index.js":"1gjBp","@carbon/web-components/es/components/floating-menu/index.js":"66ETx","@carbon/layout/es/index.js":"5T85f","./services/BlobRegistry":"ammIH","./services/BlobCache":"cBC8K","./services/DataBroker":"kD6gB","./sqlite/pdq-sqlite-client":"1Fkjw","rxjs":"d4Szo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Yic8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationService", ()=>NotificationService);
parcelHelpers.export(exports, "notificationService", ()=>notificationService);
var _replaySubject = require("../observable/ReplaySubject");
class NotificationService {
    constructor(){
        this.notifications = new (0, _replaySubject.ReplaySubject)(1);
    // this.notifications.subscribe(i => console.log(i))
    }
    error(message) {
        this.notifications.next({
            type: "error",
            message
        });
    }
    info(message) {
        this.notifications.next({
            type: "info",
            message
        });
    }
    success(message) {
        this.notifications.next({
            type: "success",
            message
        });
    }
    warning(message) {
        this.notifications.next({
            type: "warning",
            message
        });
    }
    trace(message) {
        this.notifications.next({
            type: "trace",
            message
        });
    }
    async confirm(question, actions = [
        "Confirm",
        "Cancel"
    ], title = "Confirm Action") {
        return new Promise((resolve, reject)=>{
            const el = document.createElement("pdq-confirm-dialog");
            el.actions = actions;
            el.header = title;
            el.message = question;
            el.addEventListener("action-selected", (evt)=>{
                const event = evt;
                resolve(event.detail);
            });
            document.body.appendChild(el);
        });
    }
}
const notificationService = new NotificationService();

},{"../observable/ReplaySubject":"k5r8V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k5r8V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DONT_TRIGGER_UPDATE", ()=>DONT_TRIGGER_UPDATE);
parcelHelpers.export(exports, "ReplaySubject", ()=>ReplaySubject);
parcelHelpers.export(exports, "combine", ()=>combine);
parcelHelpers.export(exports, "distinct", ()=>distinct);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "one", ()=>one);
parcelHelpers.export(exports, "first", ()=>first);
parcelHelpers.export(exports, "staticObservable", ()=>staticObservable);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ReplaySubject_observers, _ReplaySubject_previousValues;
const log = (0, _debugDefault.default)("pdq:observable");
const DONT_TRIGGER_UPDATE = Symbol("DONT_TRIGGER_UPATE");
class LimitedLengthQueue {
    constructor(limit){
        this.queue = [];
        if (limit < 1) throw new Error("Limit must be at least 1");
        this.limit = limit;
    }
    push(item) {
        this.queue.push(item);
        while(this.queue.length > this.limit)this.queue.shift();
    }
    read() {
        return [
            ...this.queue
        ];
    }
}
class ReplaySubject {
    constructor(replays){
        _ReplaySubject_observers.set(this, void 0);
        _ReplaySubject_previousValues.set(this, void 0);
        __classPrivateFieldSet(this, _ReplaySubject_observers, [], "f");
        __classPrivateFieldSet(this, _ReplaySubject_previousValues, new LimitedLengthQueue(replays), "f");
    }
    next(value) {
        if (value == DONT_TRIGGER_UPDATE) return;
        __classPrivateFieldGet(this, _ReplaySubject_previousValues, "f").push(value);
        for (const o of __classPrivateFieldGet(this, _ReplaySubject_observers, "f"))o(value);
    }
    subscribe(observer) {
        __classPrivateFieldGet(this, _ReplaySubject_observers, "f").push(observer);
        for (const pv of __classPrivateFieldGet(this, _ReplaySubject_previousValues, "f").read())observer(pv);
        return ()=>{
            const index = __classPrivateFieldGet(this, _ReplaySubject_observers, "f").indexOf(observer);
            if (index !== -1) __classPrivateFieldGet(this, _ReplaySubject_observers, "f").splice(index, 1);
        };
    }
    currentValue() {
        return __classPrivateFieldGet(this, _ReplaySubject_previousValues, "f").read().pop();
    }
}
_ReplaySubject_observers = new WeakMap(), _ReplaySubject_previousValues = new WeakMap();
class Observer {
    constructor(subscribe){
        this._observers = [];
        this._publishedValue = undefined;
        this.currentValue = ()=>this._publishedValue;
        this.subscribe = subscribe;
    }
}
function combine(...sources) {
    function subscribe(observer) {
        this._observers.push(observer);
        const unsubscribe = ()=>{
            const index = this._observers.indexOf(observer);
            if (index !== -1) this._observers.splice(index, 1);
            if (this._observers.length === 0) subscriptions.forEach((unsubscribe)=>unsubscribe());
        };
        if (this._observers.length > 1) return unsubscribe;
        const values = new Array(sources.length).fill(undefined);
        const hasValue = new Array(sources.length).fill(false);
        let hasValuesFromAllSources = false;
        const checkCompletion = ()=>!hasValue.includes(false);
        const subscriptions = sources.map((source, index)=>source.subscribe((value)=>{
                log("combine:subscriptions", source, index, value);
                if (value === DONT_TRIGGER_UPDATE) return;
                values[index] = value;
                if (!hasValue[index]) {
                    hasValue[index] = true;
                    hasValuesFromAllSources = checkCompletion();
                }
                if (hasValuesFromAllSources) {
                    this._publishedValue = values;
                    for (const o of this._observers)o([
                        ...values
                    ]);
                }
            }));
        return unsubscribe;
    }
    return new Observer(subscribe);
}
function distinct(source) {
    const initialValueSymbol = Symbol("InitialValue");
    let lastValue = initialValueSymbol;
    let _unsub;
    function subscribe(observer) {
        this._observers.push(observer);
        const unsubscribe = ()=>{
            const index = this._observers.indexOf(observer);
            if (index !== -1) this._observers.splice(index, 1);
            if (this._observers.length === 0) _unsub();
        };
        if (this._observers.length > 1) return unsubscribe;
        _unsub = source.subscribe((value)=>{
            if (value !== lastValue && value !== DONT_TRIGGER_UPDATE) {
                lastValue = value;
                for (const o of this._observers){
                    this._publishedValue = value;
                    o(value);
                }
            }
        });
        return unsubscribe;
    }
    return new Observer(subscribe);
}
function map(source, mapper, awaitPromises = true) {
    const initialValueSymbol = Symbol("InitialValue");
    let lastValue = initialValueSymbol;
    let _unsub;
    const supersededPromises = new Map();
    function subscribe(observer) {
        this._observers.push(observer);
        async function unwrap(promiseOrValue) {
            while(promiseOrValue instanceof Promise){
                supersededPromises.set(promiseOrValue, false);
                const unwrapped = await promiseOrValue;
                const superseded = supersededPromises.get(promiseOrValue);
                supersededPromises.delete(promiseOrValue);
                if (superseded) return DONT_TRIGGER_UPDATE;
                promiseOrValue = unwrapped;
            }
            return promiseOrValue;
        }
        const unsubscribe = ()=>{
            const index = this._observers.indexOf(observer);
            if (index !== -1) this._observers.splice(index, 1);
            if (this._observers.length === 0) _unsub();
        };
        if (this._observers.length > 1) return unsubscribe;
        _unsub = source.subscribe(async (value)=>{
            for (const key of supersededPromises.keys())supersededPromises.set(key, true);
            if (awaitPromises) value = await unwrap(value);
            if (value === DONT_TRIGGER_UPDATE) {
                log("DONT_TRIGGER_UPDATE - stage 1");
                return;
            }
            let mapped = mapper(value);
            if (awaitPromises) mapped = await unwrap(mapped);
            if (mapped === DONT_TRIGGER_UPDATE) {
                log("DONT_TRIGGER_UPDATE - stage 2");
                return;
            }
            for (const o of this._observers){
                this._publishedValue = mapped;
                o(mapped);
            }
        });
        return unsubscribe;
    }
    return new Observer(subscribe);
}
function one(source) {
    let unsub;
    return new Promise((resolve, reject)=>{
        unsub = source.subscribe((i)=>{
            resolve(i);
            unsub();
        });
    });
}
function first(source, predicate = (x)=>!!x) {
    let unsub;
    return new Promise((resolve, reject)=>{
        unsub = source.subscribe((i)=>{
            if (!predicate(i)) return;
            resolve(i);
            unsub();
        });
    });
}
function staticObservable(value) {
    const rs = new ReplaySubject(1);
    rs.next(value);
    return rs;
}
map.DONT_TRIGGER_UPATE = DONT_TRIGGER_UPDATE;

},{"debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"17JIf":[function(require,module,exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ var process = require("12edbb1af7d8bd3b");
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === "%%") return;
        index++;
        if (match === "%c") // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem("debug", namespaces);
        else exports.storage.removeItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof process !== "undefined" && "env" in process) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
module.exports = require("d9172905aa5ed6c")(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
    }
};

},{"12edbb1af7d8bd3b":"5QIF0","d9172905aa5ed6c":"jMUBS"}],"5QIF0":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"jMUBS":[function(require,module,exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ function setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = require("5c5c8c8b1996f88f");
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") // Anything else let's inspect with %O
            args.unshift("%O");
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") return "%";
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === "function") createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            else createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>"-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === "*") return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = setup;

},{"5c5c8c8b1996f88f":"jpYf9"}],"jpYf9":[function(require,module,exports) {
/**
 * Helpers.
 */ var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? fmtLong(val) : fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * y;
        case "weeks":
        case "week":
        case "w":
            return n * w;
        case "days":
        case "day":
        case "d":
            return n * d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= d) return Math.round(ms / d) + "d";
    if (msAbs >= h) return Math.round(ms / h) + "h";
    if (msAbs >= m) return Math.round(ms / m) + "m";
    if (msAbs >= s) return Math.round(ms / s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= d) return plural(ms, msAbs, d, "day");
    if (msAbs >= h) return plural(ms, msAbs, h, "hour");
    if (msAbs >= m) return plural(ms, msAbs, m, "minute");
    if (msAbs >= s) return plural(ms, msAbs, s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

},{}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"lOgHs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqNotificationStack", ()=>PdqNotificationStack);
var _lit = require("lit");
var _decorators = require("lit/decorators");
var _notificationService = require("../services/notificationService");
var _indexJs = require("@carbon/web-components/es/components/notification/index.js");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var PdqNotificationStack_1;
const log = (0, _debugDefault.default)(`pdq:ui:pdq-notification-stack`);
let PdqNotificationStack = PdqNotificationStack_1 = class PdqNotificationStack extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.messages = [];
        (0, _notificationService.notificationService).notifications.subscribe((i)=>this.notify(i));
    }
    render() {
        return (0, _lit.html)`${this.messages.map((message)=>{
            let title = message.type[0].toLocaleUpperCase() + message.type.substring(1);
            let messageText = message.message;
            if (message.message.indexOf("|") !== -1) [title, messageText] = message.message.split("|");
            return (0, _lit.html)`
            <cds-inline-notification
                    id="pdq-notification-${message.id}"
                    style="width: 100%; flex-grow: 1"
                    class="toast ${message.type}" 
                    inline="true"
                    title="${title}"
                    kind="${message.type}"
                @cds-notification-beingclosed="${function(evt) {
                setTimeout(()=>message.close(), 499);
                evt.currentTarget?.classList.add("slide-out");
            }}" 
                @cds-notification-closed="${function(evt) {
                setTimeout(()=>message.close(), 499);
                evt.currentTarget?.classList.add("slide-out");
            }}">
                ${messageText}</cds-inline-notification>`;
        })}
        `;
    }
    close(id) {
        this.messages = this.messages.filter((m)=>m.id !== id);
        log(`removed ${id}`, this.messages);
        this.requestUpdate();
    }
    notify(notification) {
        const id = PdqNotificationStack_1._nextId++;
        this.messages.push({
            ...notification,
            id,
            close: ()=>this.close(id)
        });
        this.requestUpdate();
    }
};
PdqNotificationStack.styles = (0, _lit.css)`
      :host {
        --toast-margin: 10px;
        --toast-width: 800px;
        --toast-animation-duration: 0.5s;
          
        display: flex;
        flex-direction: column-reverse;
        position: fixed;
        right: 0;
        left:0;
        bottom: 0;
        padding: var(--toast-margin, 16px);
        z-index: 100;
      }
      
      .toast {
        display: flex;
        align-items: center;
        padding: 10px;
        animation: slide-up var(--toast-animation-duration, 0.5s) ease-out;
        z-index: 101;
      }
      .toast.slide-out {
        z-index: 99;
        pointer-events: none;
        animation: slide-out var(--toast-animation-duration, 0.5s) ease-out;
      }
      @keyframes slide-up {
        from {
          transform: translateY(100%);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }
            
    @keyframes slide-out {
      from {
        transform: translateY(0);
        opacity: 1;
      }
      to {
        transform: translateY(100%);
        opacity: 0;
      }
    }
  `;
PdqNotificationStack._nextId = 0;
__decorate([
    (0, _decorators.property)({
        type: Array
    }),
    __metadata("design:type", Array)
], PdqNotificationStack.prototype, "messages", void 0);
PdqNotificationStack = PdqNotificationStack_1 = __decorate([
    (0, _decorators.customElement)("pdq-notification-stack"),
    __metadata("design:paramtypes", [])
], PdqNotificationStack);

},{"lit":"aCmte","lit/decorators":"kQrIl","../services/notificationService":"2Yic8","@carbon/web-components/es/components/notification/index.js":"5iK9B","debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aCmte":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactiveElement = require("@lit/reactive-element");
var _litHtml = require("lit-html");
var _litElementJs = require("lit-element/lit-element.js");
parcelHelpers.exportAll(_litElementJs, exports);
var _isServerJs = require("lit-html/is-server.js");
parcelHelpers.exportAll(_isServerJs, exports);

},{"@lit/reactive-element":"hUcCl","lit-html":"4A25t","lit-element/lit-element.js":"8BOF1","lit-html/is-server.js":"2Mmwb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUcCl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSResult", ()=>(0, _cssTagJs.CSSResult));
parcelHelpers.export(exports, "adoptStyles", ()=>(0, _cssTagJs.adoptStyles));
parcelHelpers.export(exports, "css", ()=>(0, _cssTagJs.css));
parcelHelpers.export(exports, "getCompatibleStyle", ()=>(0, _cssTagJs.getCompatibleStyle));
parcelHelpers.export(exports, "supportsAdoptingStyleSheets", ()=>(0, _cssTagJs.supportsAdoptingStyleSheets));
parcelHelpers.export(exports, "unsafeCSS", ()=>(0, _cssTagJs.unsafeCSS));
parcelHelpers.export(exports, "ReactiveElement", ()=>b);
parcelHelpers.export(exports, "defaultConverter", ()=>u);
parcelHelpers.export(exports, "notEqual", ()=>f);
var _cssTagJs = require("./css-tag.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: i, defineProperty: e, getOwnPropertyDescriptor: r, getOwnPropertyNames: h, getOwnPropertySymbols: o, getPrototypeOf: n } = Object, a = globalThis, c = a.trustedTypes, l = c ? c.emptyScript : "", p = a.reactiveElementPolyfillSupport, d = (t, s)=>t, u = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, f = (t, s)=>!i(t, s), y = {
    attribute: !0,
    type: String,
    converter: u,
    reflect: !1,
    hasChanged: f
};
Symbol.metadata ??= Symbol("metadata"), a.litPropertyMetadata ??= new WeakMap;
class b extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? y;
    }
    static _$Ei() {
        if (this.hasOwnProperty(d("elementProperties"))) return;
        const t = n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty(d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(d("properties"))) {
            const t = this.properties, s = [
                ...h(t),
                ...o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, _cssTagJs.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, _cssTagJs.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, _cssTagJs.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : u).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : u;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? f)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
b.elementStyles = [], b.shadowRootOptions = {
    mode: "open"
}, b[d("elementProperties")] = new Map, b[d("finalized")] = new Map, p?.({
    ReactiveElement: b
}), (a.reactiveElementVersions ??= []).push("2.0.4");

},{"./css-tag.js":"gSCbb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gSCbb":[function(require,module,exports) {
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSResult", ()=>n);
parcelHelpers.export(exports, "adoptStyles", ()=>S);
parcelHelpers.export(exports, "css", ()=>i);
parcelHelpers.export(exports, "getCompatibleStyle", ()=>c);
parcelHelpers.export(exports, "supportsAdoptingStyleSheets", ()=>e);
parcelHelpers.export(exports, "unsafeCSS", ()=>r);
const t = globalThis, e = t.ShadowRoot && (void 0 === t.ShadyCSS || t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, s = Symbol(), o = new WeakMap;
class n {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if (e && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const r = (t)=>new n("string" == typeof t ? t : t + "", void 0, s), i = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new n(o, t, s);
}, S = (s, o)=>{
    if (e) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, c = e ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return r(e);
    })(t) : t;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4A25t":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_$LH", ()=>z);
parcelHelpers.export(exports, "html", ()=>x);
parcelHelpers.export(exports, "noChange", ()=>w);
parcelHelpers.export(exports, "nothing", ()=>T);
parcelHelpers.export(exports, "render", ()=>j);
parcelHelpers.export(exports, "svg", ()=>b);
const t = globalThis, i = t.trustedTypes, s = i ? i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, e = "$lit$", h = `lit$${Math.random().toFixed(9).slice(2)}$`, o = "?" + h, n = `<${o}>`, r = document, l = ()=>r.createComment(""), c = (t)=>null === t || "object" != typeof t && "function" != typeof t, a = Array.isArray, u = (t)=>a(t) || "function" == typeof t?.[Symbol.iterator], d = "[ 	\n\f\r]", f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, v = /-->/g, _ = />/g, m = RegExp(`>|${d}(?:([^\\s"'>=/]+)(${d}*=${d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), p = /'/g, g = /"/g, $ = /^(?:script|style|textarea|title)$/i, y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), x = y(1), b = y(2), w = Symbol.for("lit-noChange"), T = Symbol.for("lit-nothing"), A = new WeakMap, E = r.createTreeWalker(r, 129);
function C(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== s ? s.createHTML(i) : i;
}
const P = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : "", c = f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === f ? "!--" === u[1] ? c = v : void 0 !== u[1] ? c = _ : void 0 !== u[2] ? ($.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = m) : void 0 !== u[3] && (c = m) : c === m ? ">" === u[0] ? (c = r ?? f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? m : '"' === u[3] ? g : p) : c === g || c === p ? c = m : c === v || c === _ ? c = f : (c = m, r = void 0);
        const x = c === m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === f ? s + n : d >= 0 ? (o.push(a), s.slice(0, d) + e + s.slice(d) + h + x) : s + h + (-2 === d ? i : x);
    }
    return [
        C(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        o
    ];
};
class V {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = P(t, s);
        if (this.el = V.createElement(f, n), E.currentNode = this.el.content, 2 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = E.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith(e)) {
                    const i = v[a++], s = r.getAttribute(t).split(h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? k : "?" === e[1] ? H : "@" === e[1] ? I : R
                    }), r.removeAttribute(t);
                } else t.startsWith(h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($.test(r.tagName)) {
                    const t = r.textContent.split(h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = i ? i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], l()), E.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf(h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function N(t, i, s = t, e) {
    if (i === w) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = N(t, h._$AS(t, i.values), h, e)), i;
}
class S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? r).importNode(i, !0);
        E.currentNode = e;
        let h = E.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new M(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new L(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = E.nextNode(), o++);
        }
        return E.currentNode = r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class M {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = T, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = N(this, t, i), c(t) ? t === T || null == t || "" === t ? (this._$AH !== T && this._$AR(), this._$AH = T) : t !== this._$AH && t !== w && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : u(t) ? this.k(t) : this._(t);
    }
    S(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.S(t));
    }
    _(t) {
        this._$AH !== T && c(this._$AH) ? this._$AA.nextSibling.data = t : this.T(r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = V.createElement(C(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new S(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = A.get(t.strings);
        return void 0 === i && A.set(t.strings, i = new V(t)), i;
    }
    k(t) {
        a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new M(this.S(l()), this.S(l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = T, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = T;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = N(this, t, i, 0), o = !c(t) || t !== this._$AH && t !== w, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = N(this, e[s + n], i, n), r === w && (r = this._$AH[n]), o ||= !c(r) || r !== this._$AH[n], r === T ? t = T : t !== T && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === T ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class k extends R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === T ? void 0 : t;
    }
}
class H extends R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== T);
    }
}
class I extends R {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = N(this, t, i, 0) ?? T) === w) return;
        const s = this._$AH, e = t === T && s !== T || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== T && (s === T || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class L {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        N(this, t);
    }
}
const z = {
    P: e,
    A: h,
    C: o,
    M: 1,
    L: P,
    R: S,
    D: u,
    V: N,
    I: M,
    H: R,
    N: H,
    U: I,
    B: k,
    F: L
}, Z = t.litHtmlPolyfillSupport;
Z?.(V, M), (t.litHtmlVersions ??= []).push("3.1.4");
const j = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new M(i.insertBefore(l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8BOF1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LitElement", ()=>s);
parcelHelpers.export(exports, "_$LE", ()=>o);
var _reactiveElement = require("@lit/reactive-element");
parcelHelpers.exportAll(_reactiveElement, exports);
var _litHtml = require("lit-html");
parcelHelpers.exportAll(_litHtml, exports);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class s extends (0, _reactiveElement.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, _litHtml.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, _litHtml.noChange;
    }
}
s._$litElement$ = !0, s["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: s
});
const r = globalThis.litElementPolyfillSupport;
r?.({
    LitElement: s
});
const o = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.0.5");

},{"@lit/reactive-element":"hUcCl","lit-html":"4A25t","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Mmwb":[function(require,module,exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServer", ()=>o);
const o = !1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQrIl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _customElementJs = require("@lit/reactive-element/decorators/custom-element.js");
parcelHelpers.exportAll(_customElementJs, exports);
var _propertyJs = require("@lit/reactive-element/decorators/property.js");
parcelHelpers.exportAll(_propertyJs, exports);
var _stateJs = require("@lit/reactive-element/decorators/state.js");
parcelHelpers.exportAll(_stateJs, exports);
var _eventOptionsJs = require("@lit/reactive-element/decorators/event-options.js");
parcelHelpers.exportAll(_eventOptionsJs, exports);
var _queryJs = require("@lit/reactive-element/decorators/query.js");
parcelHelpers.exportAll(_queryJs, exports);
var _queryAllJs = require("@lit/reactive-element/decorators/query-all.js");
parcelHelpers.exportAll(_queryAllJs, exports);
var _queryAsyncJs = require("@lit/reactive-element/decorators/query-async.js");
parcelHelpers.exportAll(_queryAsyncJs, exports);
var _queryAssignedElementsJs = require("@lit/reactive-element/decorators/query-assigned-elements.js");
parcelHelpers.exportAll(_queryAssignedElementsJs, exports);
var _queryAssignedNodesJs = require("@lit/reactive-element/decorators/query-assigned-nodes.js");
parcelHelpers.exportAll(_queryAssignedNodesJs, exports);

},{"@lit/reactive-element/decorators/custom-element.js":"dYoHp","@lit/reactive-element/decorators/property.js":"dggVt","@lit/reactive-element/decorators/state.js":"dJKtr","@lit/reactive-element/decorators/event-options.js":"9SENf","@lit/reactive-element/decorators/query.js":"12Pya","@lit/reactive-element/decorators/query-all.js":"gzvjw","@lit/reactive-element/decorators/query-async.js":"kZTrS","@lit/reactive-element/decorators/query-assigned-elements.js":"6ZZSg","@lit/reactive-element/decorators/query-assigned-nodes.js":"l1UPB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dYoHp":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "customElement", ()=>t);
const t = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dggVt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "property", ()=>n);
parcelHelpers.export(exports, "standardProperty", ()=>r);
var _reactiveElementJs = require("../reactive-element.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const o = {
    attribute: !0,
    type: String,
    converter: (0, _reactiveElementJs.defaultConverter),
    reflect: !1,
    hasChanged: (0, _reactiveElementJs.notEqual)
}, r = (t = o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function n(t) {
    return (e, o)=>"object" == typeof o ? r(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

},{"../reactive-element.js":"hUcCl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJKtr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "state", ()=>r);
var _propertyJs = require("./property.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function r(r) {
    return (0, _propertyJs.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

},{"./property.js":"dggVt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9SENf":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventOptions", ()=>t);
function t(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"12Pya":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "query", ()=>e);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function e(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, _baseJs.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, _baseJs.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f4sFH":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "desc", ()=>e);
const e = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gzvjw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryAll", ()=>r);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let e;
function r(r) {
    return (n, o)=>(0, _baseJs.desc)(n, o, {
            get () {
                return (this.renderRoot ?? (e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kZTrS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryAsync", ()=>r);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function r(r) {
    return (n, e)=>(0, _baseJs.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ZZSg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryAssignedElements", ()=>o);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function o(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, _baseJs.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l1UPB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryAssignedNodes", ()=>n);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function n(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, _baseJs.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5iK9B":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _inlineNotificationJs = require("./inline-notification.js");
var _toastNotificationJs = require("./toast-notification.js");
var _actionableNotificationJs = require("./actionable-notification.js");
var _actionableNotificationButtonJs = require("./actionable-notification-button.js");

},{"./inline-notification.js":"jElO5","./toast-notification.js":"knpkJ","./actionable-notification.js":"lwHhz","./actionable-notification-button.js":"6aKiO"}],"jElO5":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NOTIFICATION_KIND", ()=>(0, _defsJs.NOTIFICATION_KIND));
parcelHelpers.export(exports, "NOTIFICATION_TYPE", ()=>(0, _defsJs.NOTIFICATION_TYPE));
parcelHelpers.export(exports, "default", ()=>CDSInlineNotification$1);
var _tslib = require("tslib");
var _20Js = require("../../icons/checkmark--filled/20.js");
var _20JsDefault = parcelHelpers.interopDefault(_20Js);
var _16Js = require("../../icons/close/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _20Js1 = require("../../icons/error--filled/20.js");
var _20JsDefault1 = parcelHelpers.interopDefault(_20Js1);
var _20Js2 = require("../../icons/information--filled/20.js");
var _20JsDefault2 = parcelHelpers.interopDefault(_20Js2);
var _20Js3 = require("../../icons/information--square--filled/20.js");
var _20JsDefault3 = parcelHelpers.interopDefault(_20Js3);
var _20Js4 = require("../../icons/warning--filled/20.js");
var _20JsDefault4 = parcelHelpers.interopDefault(_20Js4);
var _20Js5 = require("../../icons/warning--alt--filled/20.js");
var _20JsDefault5 = parcelHelpers.interopDefault(_20Js5);
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _defsJs = require("./defs.js");
var _inlineNotificationScssJs = require("./inline-notification.scss.js");
var _inlineNotificationScssJsDefault = parcelHelpers.interopDefault(_inlineNotificationScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The default icons, keyed by notification kind.
 */ const iconsForKinds = {
    [(0, _defsJs.NOTIFICATION_KIND).SUCCESS]: (0, _20JsDefault.default),
    [(0, _defsJs.NOTIFICATION_KIND).INFO]: (0, _20JsDefault2.default),
    [(0, _defsJs.NOTIFICATION_KIND).INFO_SQUARE]: (0, _20JsDefault3.default),
    [(0, _defsJs.NOTIFICATION_KIND).WARNING]: (0, _20JsDefault4.default),
    [(0, _defsJs.NOTIFICATION_KIND).WARNING_ALT]: (0, _20JsDefault5.default),
    [(0, _defsJs.NOTIFICATION_KIND).ERROR]: (0, _20JsDefault1.default)
};
/**
 * Inline notification.
 *
 * @element cds-inline-notification
 * @slot subtitle - The subtitle.
 * @slot title - The title.
 * @fires cds-notification-beingclosed
 *   The custom event fired before this notification is being closed upon a user gesture.
 *   Cancellation of this event stops the user-initiated action of closing this notification.
 * @fires cds-notification-closed - The custom event fired after this notification is closed upon a user gesture.
 */ let CDSInlineNotification = class CDSInlineNotification extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * Current timeout identifier
         */ this._timeoutID = null;
        /**
         * Notification type.
         */ this._type = (0, _defsJs.NOTIFICATION_TYPE).INLINE;
        /**
         * `true` to hide the close button.
         */ this.hideCloseButton = false;
        /**
         * Notification kind.
         */ this.kind = (0, _defsJs.NOTIFICATION_KIND).SUCCESS;
        /**
         * Low contrast mode
         */ this.lowContrast = false;
        /**
         * `true` if the notification should be open.
         */ this.open = true;
        /**
         * Specify an optional duration the notification should be closed in
         */ this.timeout = null;
        /**
         * The subtitle.
         */ this.subtitle = "";
        /**
         * The title.
         */ this.title = "";
    }
    /**
     * Cancels the current timeout configured for the notification
     *
     * @param timeoutID current timeout's identifier
     */ _cancelTimeout(timeoutID) {
        clearTimeout(timeoutID);
        this._timeoutID = null;
    }
    /**
     * Overrides (if exists) the timeout to close the notification
     *
     * @param timeout the time in ms
     */ _initializeTimeout(timeout) {
        if (this._timeoutID) this._cancelTimeout(this._timeoutID);
        this._timeoutID = setTimeout(this._handleUserOrTimerInitiatedClose.bind(this, null), timeout);
    }
    /**
     * Handles `click` event on the close button.
     *
     * @param event The event.
     * @param event.target The event target.
     */ _handleClickCloseButton({ target }) {
        this._handleUserOrTimerInitiatedClose(target);
    }
    /**
     * Handles user-initiated or through timer close request of this modal.
     *
     * @param triggeredBy The element that triggered this close request, if there is one.
     */ _handleUserOrTimerInitiatedClose(triggeredBy) {
        if (this.open) {
            const init = {
                bubbles: true,
                cancelable: true,
                composed: true,
                detail: {
                    triggeredBy
                }
            };
            if (this.dispatchEvent(new CustomEvent(this.constructor.eventBeforeClose, init))) {
                this.open = false;
                this.dispatchEvent(new CustomEvent(this.constructor.eventClose, init));
            }
        }
    }
    /**
     * @returns The template part for the close button.
     */ _renderButton() {
        const { ariaLabel, _type: type, _handleClickCloseButton: handleClickCloseButton } = this;
        return (0, _lit.html)`
      <button
        type="button"
        class="${0, _settingsJs.prefix}--${type}-notification__close-button"
        aria-label=${(0, _ifDefinedJs.ifDefined)(ariaLabel)}
        title=${(0, _ifDefinedJs.ifDefined)(ariaLabel)}
        @click="${handleClickCloseButton}">
        ${(0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--${type}-notification__close-icon`
        })}
      </button>
    `;
    }
    /**
     * @returns The template part for the text contents.
     */ _renderText() {
        const { subtitle, title, _type: type } = this;
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--${type}-notification__text-wrapper">
        <p class="${0, _settingsJs.prefix}--${type}-notification__title">
          ${title}<slot name="title"></slot>
        </p>
        <div class="${0, _settingsJs.prefix}--${type}-notification__subtitle">
          ${subtitle}<slot name="subtitle"></slot>
        </div>
        <slot></slot>
      </div>
    `;
    }
    /**
     * @returns The template part for the icon.
     */ _renderIcon() {
        const { statusIconDescription, kind, _type: type } = this;
        const { [kind]: icon } = iconsForKinds;
        return !icon ? undefined : icon({
            class: `${(0, _settingsJs.prefix)}--${type}-notification__icon`,
            children: !statusIconDescription ? undefined : (0, _lit.svg)`<title>${statusIconDescription}</title>`
        });
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "alert");
        super.connectedCallback();
    }
    updated(changedProperties) {
        const openChanged = changedProperties.has("open");
        const timeoutChanged = changedProperties.has("timeout");
        if (openChanged || timeoutChanged) {
            if (this.open && this.timeout) this._initializeTimeout(this.timeout);
            else if (!this.open && this._timeoutID) this._cancelTimeout(this._timeoutID);
        }
    }
    render() {
        const { _type: type } = this;
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--${type}-notification__details">
        ${this._renderIcon()}${this._renderText()}
      </div>
      ${this._renderButton()}
    `;
    }
    /**
     * The name of the custom event fired before this notification is being closed upon a user gesture.
     * Cancellation of this event stops the user-initiated action of closing this notification.
     */ static get eventBeforeClose() {
        return `${0, _settingsJs.prefix}-notification-beingclosed`;
    }
    /**
     * The name of the custom event fired after this notification is closed upon a user gesture.
     */ static get eventClose() {
        return `${0, _settingsJs.prefix}-notification-closed`;
    }
};
CDSInlineNotification.styles = (0, _inlineNotificationScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "aria-label"
    })
], CDSInlineNotification.prototype, "ariaLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "hide-close-button"
    })
], CDSInlineNotification.prototype, "hideCloseButton", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "status-icon-description"
    })
], CDSInlineNotification.prototype, "statusIconDescription", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSInlineNotification.prototype, "kind", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "low-contrast"
    })
], CDSInlineNotification.prototype, "lowContrast", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSInlineNotification.prototype, "open", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true
    })
], CDSInlineNotification.prototype, "timeout", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSInlineNotification.prototype, "subtitle", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSInlineNotification.prototype, "title", void 0);
CDSInlineNotification = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-inline-notification`)
], CDSInlineNotification);
var CDSInlineNotification$1 = CDSInlineNotification;

},{"tslib":"gBS4y","../../icons/checkmark--filled/20.js":"gQAfV","../../icons/close/16.js":"b7Sho","../../icons/error--filled/20.js":"4GThk","../../icons/information--filled/20.js":"ggsPm","../../icons/information--square--filled/20.js":"2jqak","../../icons/warning--filled/20.js":"hJU0G","../../icons/warning--alt--filled/20.js":"bXVtQ","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/if-defined.js":"hSgrS","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/mixins/focus.js":"5k7ow","./defs.js":"4N5Fz","./inline-notification.scss.js":"gTU3s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gBS4y":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", ()=>__rewriteRelativeImportExtension);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gQAfV":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20">${children}<path d="M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z"></path><path fill="none" d="M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z" data-icon-path="inner-path" opacity="0"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iXjMk":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
var _directiveJs = require("lit/directive.js");
var _asyncDirectiveJs = require("lit/async-directive.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Stores the ClassInfo object applied to a given AttributePart.
 * Used to unset existing values when a new ClassInfo object is applied.
 */ const attributesMapCache = new WeakMap();
/**
 * A directive that applies attributes from a key-value pairs.
 * This must be used in the `...` name and must be the only part used in the attribute.
 * It applies the key-value pairs in the `attributesInfo` argument
 * and sets them as attribute name/value pairs.
 *
 */ class SpreadDirective extends (0, _directiveJs.Directive) {
    /**
     * The update function that handles the attribute setting.
     *
     * @param part an object with an API to manage the element's DOM
     * @returns the render function
     */ update(part, [attributesInfo]) {
        const { element } = part;
        // Removes old attributes that are no longer there
        const oldAttributesInfo = attributesMapCache.get(part);
        if (oldAttributesInfo) Object.keys(oldAttributesInfo).forEach((name)=>{
            if (!(name in attributesInfo)) element.removeAttribute(name);
        });
        // Adds new attributes
        Object.keys(attributesInfo).forEach((name)=>{
            const value = attributesInfo[name];
            if ((!oldAttributesInfo || !Object.is(value, oldAttributesInfo[name])) && typeof value !== "undefined") element.setAttribute(name, value);
        });
        // Updates the cache
        attributesMapCache.set(part, attributesInfo);
        return this.render(attributesInfo);
    }
    /**
     * The rendering function that simply takes in the arguments to be used
     * in the update() function.
     *
     * @param attributesInfo The key-value pair to be set as the attribute name/value pairs.
     * @returns the attributes info
     */ render(attributesInfo) {
        return attributesInfo;
    }
}
const spread = (0, _asyncDirectiveJs.directive)(SpreadDirective);

},{"lit/directive.js":"ifKqw","lit/async-directive.js":"1Ulby","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ifKqw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _directiveJs = require("lit-html/directive.js");
parcelHelpers.exportAll(_directiveJs, exports);

},{"lit-html/directive.js":"k6ssg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k6ssg":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Directive", ()=>i);
parcelHelpers.export(exports, "PartType", ()=>t);
parcelHelpers.export(exports, "directive", ()=>e);
const t = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, e = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class i {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Ulby":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncDirectiveJs = require("lit-html/async-directive.js");
parcelHelpers.exportAll(_asyncDirectiveJs, exports);

},{"lit-html/async-directive.js":"4OsOd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4OsOd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "directive", ()=>(0, _directiveJs.directive));
parcelHelpers.export(exports, "AsyncDirective", ()=>f);
parcelHelpers.export(exports, "Directive", ()=>(0, _directiveJs.Directive));
parcelHelpers.export(exports, "PartType", ()=>(0, _directiveJs.PartType));
var _directiveHelpersJs = require("./directive-helpers.js");
var _directiveJs = require("./directive.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const s = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), s(i, t);
    return !0;
}, o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), c(t);
    }
};
function h(i) {
    void 0 !== this._$AN ? (o(this), this._$AM = i, r(this)) : this._$AM = i;
}
function n(i, t = !1, e = 0) {
    const r = this._$AH, h = this._$AN;
    if (void 0 !== h && 0 !== h.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)s(r[i], !1), o(r[i]);
            else null != r && (s(r, !1), o(r));
        } else s(this, i);
    }
}
const c = (i)=>{
    i.type == (0, _directiveJs.PartType).CHILD && (i._$AP ??= n, i._$AQ ??= h);
};
class f extends (0, _directiveJs.Directive) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && (s(this, i), o(this));
    }
    setValue(t) {
        if ((0, _directiveHelpersJs.isSingleExpression)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}

},{"./directive-helpers.js":"40nzJ","./directive.js":"k6ssg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"40nzJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TemplateResultType", ()=>n);
parcelHelpers.export(exports, "clearPart", ()=>j);
parcelHelpers.export(exports, "getCommittedValue", ()=>p);
parcelHelpers.export(exports, "getDirectiveClass", ()=>d);
parcelHelpers.export(exports, "insertPart", ()=>r);
parcelHelpers.export(exports, "isCompiledTemplateResult", ()=>l);
parcelHelpers.export(exports, "isDirectiveResult", ()=>c);
parcelHelpers.export(exports, "isPrimitive", ()=>i);
parcelHelpers.export(exports, "isSingleExpression", ()=>f);
parcelHelpers.export(exports, "isTemplateResult", ()=>e);
parcelHelpers.export(exports, "removePart", ()=>h);
parcelHelpers.export(exports, "setChildPartValue", ()=>v);
parcelHelpers.export(exports, "setCommittedValue", ()=>m);
var _litHtmlJs = require("./lit-html.js");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: t } = (0, _litHtmlJs._$LH), i = (o)=>null === o || "object" != typeof o && "function" != typeof o, n = {
    HTML: 1,
    SVG: 2
}, e = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, l = (o)=>null != o?._$litType$?.h, c = (o)=>void 0 !== o?._$litDirective$, d = (o)=>o?._$litDirective$, f = (o)=>void 0 === o.strings, s = ()=>document.createComment(""), r = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore(s(), l), c = e.insertBefore(s(), l);
        n = new t(i, c, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, c = i !== o;
        if (c) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || c) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, v = (o, t, i = o)=>(o._$AI(t, i), o), u = {}, m = (o, t = u)=>o._$AH = t, p = (o)=>o._$AH, h = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, j = (o)=>{
    o._$AR();
};

},{"./lit-html.js":"4A25t","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b7Sho":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M17.4141 16L24 9.4141 22.5859 8 16 14.5859 9.4143 8 8 9.4141 14.5859 16 8 22.5859 9.4143 24 16 17.4141 22.5859 24 24 22.5859 17.4141 16z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4GThk":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20">${children}<path d="M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z"></path><path d="M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z" data-icon-path="inner-path" opacity="0"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ggsPm":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path fill="none" d="M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z" data-icon-path="inner-path"></path><path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2jqak":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path fill="none" d="M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z" data-icon-path="inner-path"></path><path d="M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hJU0G":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20">${children}<path d="M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1	s1,0.4,1,1S10.6,16,10,16z"></path><path d="M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,16,10,16z" data-icon-path="inner-path" opacity="0"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bXVtQ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path fill="none" d="M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z" data-icon-path="inner-path"></path><path d="M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z"></path><path d="M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hSgrS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ifDefinedJs = require("lit-html/directives/if-defined.js");
parcelHelpers.exportAll(_ifDefinedJs, exports);

},{"lit-html/directives/if-defined.js":"aT61Y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aT61Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ifDefined", ()=>o);
var _litHtmlJs = require("../lit-html.js");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const o = (o)=>o ?? (0, _litHtmlJs.nothing);

},{"../lit-html.js":"4A25t","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"EipuL":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefix", ()=>prefix);
parcelHelpers.export(exports, "selectorTabbable", ()=>selectorTabbable);
const prefix = "cds";
/**
 * A selector selecting tabbable nodes.
 * Borrowed from `carbon-angular`. tabbable === focusable.
 */ const selectorTabbable = `
  a[href], area[href], input:not([disabled]):not([tabindex='-1']),
  button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),
  textarea:not([disabled]):not([tabindex='-1']),
  iframe, object, embed, *[tabindex]:not([tabindex='-1']), *[contenteditable=true],
  ${prefix}-accordion-item,
  ${prefix}-button,
  ${prefix}-breadcrumb-link,
  ${prefix}-checkbox,
  ${prefix}-code-snippet,
  ${prefix}-combo-box,
  ${prefix}-content-switcher-item,
  ${prefix}-copy-button,
  ${prefix}-table-header-row,
  ${prefix}-table-row,
  ${prefix}-table-toolbar-search,
  ${prefix}-date-picker-input,
  ${prefix}-dropdown,
  ${prefix}-input,
  ${prefix}-link,
  ${prefix}-number-input,
  ${prefix}-modal,
  ${prefix}-modal-close-button,
  ${prefix}-multi-select,
  ${prefix}-inline-notification,
  ${prefix}-toast-notification,
  ${prefix}-overflow-menu,
  ${prefix}-overflow-menu-item,
  ${prefix}-page-sizes-select,
  ${prefix}-pages-select,
  ${prefix}-progress-step,
  ${prefix}-radio-button,
  ${prefix}-search,
  ${prefix}-slider,
  ${prefix}-slider-input,
  ${prefix}-structured-list,
  ${prefix}-tab,
  ${prefix}-filter-tag,
  ${prefix}-textarea,
  ${prefix}-text-input,
  ${prefix}-clickable-tile,
  ${prefix}-expandable-tile,
  ${prefix}-radio-tile,
  ${prefix}-selectable-tile,
  ${prefix}-toggle,
  ${prefix}-tooltip,
  ${prefix}-tooltip-definition,
  ${prefix}-tooltip-icon,
  ${prefix}-header-menu,
  ${prefix}-header-menu-button,
  ${prefix}-header-menu-item,
  ${prefix}-header-name,
  ${prefix}-header-nav-item,
  ${prefix}-side-nav-link,
  ${prefix}-side-nav-menu,
  ${prefix}-side-nav-menu-item
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kNhLR":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2019, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "carbonElement", ()=>carbonElement);
const legacyCustomElement = (tagName, clazz)=>{
    try {
        customElements.define(tagName, clazz);
    } catch (error) {
        console.warn(`Attempting to re-define ${tagName}`);
    }
    // Cast as any because TS doesn't recognize the return type as being a
    // subtype of the decorated class when clazz is typed as
    // `Constructor<HTMLElement>` for some reason.
    // `Constructor<HTMLElement>` is helpful to make sure the decorator is
    // applied to elements however.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return clazz;
};
const standardCustomElement = (tagName, descriptor)=>{
    const { kind, elements } = descriptor;
    return {
        kind,
        elements,
        // This callback is called once the class is otherwise fully defined
        finisher (clazz) {
            try {
                customElements.define(tagName, clazz);
            } catch (error) {
                console.warn(`Attempting to re-define ${tagName}`);
            }
        }
    };
};
/**
 * Class decorator factory that defines the decorated class as a custom element.
 *
 * ```js
 * @customElement('my-element')
 * class MyElement extends LitElement {
 *   render() {
 *     return html``;
 *   }
 * }
 * ```
 *
 * @category Decorator
 * @param tagName The tag name of the custom element to define.
 */ const carbonElement = (tagName)=>(classOrDescriptor)=>typeof classOrDescriptor === "function" ? legacyCustomElement(tagName, classOrDescriptor) : standardCustomElement(tagName, classOrDescriptor);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5k7ow":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FocusMixin);
var _settingsJs = require("../settings.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param Base The base class.
 * @returns A mix-in implementing `.focus()` method that focuses on the first focusable element in the shadow DOM.
 */ const FocusMixin = (Base)=>class extends Base {
        /**
     * Focuses on the first focusable element in the shadow DOM.
     */ focus() {
            // @ts-ignore: Until `delegatesFocus` is added to `ShadowRoot` definition
            if (this.shadowRoot.delegatesFocus) super.focus();
            else {
                const delegateTarget = this.shadowRoot.querySelector((0, _settingsJs.selectorTabbable)) || this.querySelector((0, _settingsJs.selectorTabbable));
                if (delegateTarget) delegateTarget.focus();
                else super.focus();
            }
        }
    };

},{"../settings.js":"EipuL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4N5Fz":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Notification kinds.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NOTIFICATION_KIND", ()=>NOTIFICATION_KIND);
parcelHelpers.export(exports, "NOTIFICATION_TYPE", ()=>NOTIFICATION_TYPE);
var NOTIFICATION_KIND;
(function(NOTIFICATION_KIND) {
    /**
     * Notification to represent success state.
     */ NOTIFICATION_KIND["SUCCESS"] = "success";
    /**
     * Informational notification.
     */ NOTIFICATION_KIND["INFO"] = "info";
    /**
     * Informational square icon notification.
     */ NOTIFICATION_KIND["INFO_SQUARE"] = "info-square";
    /**
     * Warning notification.
     */ NOTIFICATION_KIND["WARNING"] = "warning";
    /**
     * Warning Alt notification.
     */ NOTIFICATION_KIND["WARNING_ALT"] = "warning-alt";
    /**
     * Error notification.
     */ NOTIFICATION_KIND["ERROR"] = "error";
})(NOTIFICATION_KIND || (NOTIFICATION_KIND = {}));
/**
 * Notification types.
 */ var NOTIFICATION_TYPE;
(function(NOTIFICATION_TYPE) {
    /**
     * Inline notification, which show up in task flows, to notify users of the status of an action.
     * They usually appear at the top of the primary content area.
     */ NOTIFICATION_TYPE["INLINE"] = "inline";
    /**
     * Toast notification, which is a non-modal, time-based window elements used to display short messages.
     * They usually appear at the bottom of the screen and disappear after a few seconds.
     */ NOTIFICATION_TYPE["TOAST"] = "toast";
    /**
     * Actionable notifications allow for interactive elements within a notification styled like an inline
     * or toast notification. Actionable notifications, since they require user interaction, take focus when
     * triggered and can be highly disruptive to screen readers and keyboard users. With actionable notifications,
     * only one action is allowed per notification. This action frequently takes users to a flow or page related
     * to the message, where they can resolve the notification.
     */ NOTIFICATION_TYPE["ACTIONABLE"] = "actionable";
})(NOTIFICATION_TYPE || (NOTIFICATION_TYPE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gTU3s":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--inline-notification.cds--inline-notification--low-contrast a:focus,:host(cds-inline-notification):host(cds-inline-notification[kind=error][low-contrast]) a:focus,:host(cds-inline-notification):host(cds-inline-notification[kind=info-square][low-contrast]) a:focus,:host(cds-inline-notification):host(cds-inline-notification[kind=info][low-contrast]) a:focus,:host(cds-inline-notification):host(cds-inline-notification[kind=success][low-contrast]) a:focus,:host(cds-inline-notification):host(cds-inline-notification[kind=warning-alt][low-contrast]) a:focus,:host(cds-inline-notification):host(cds-inline-notification[kind=warning][low-contrast]) a:focus,[low-contrast]:host(cds-inline-notification):host(cds-inline-notification[kind=warning-alt]) a:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--inline-notification.cds--inline-notification--low-contrast a:focus,:host(cds-inline-notification):host(cds-inline-notification[kind=error][low-contrast]) a:focus,:host(cds-inline-notification):host(cds-inline-notification[kind=info-square][low-contrast]) a:focus,:host(cds-inline-notification):host(cds-inline-notification[kind=info][low-contrast]) a:focus,:host(cds-inline-notification):host(cds-inline-notification[kind=success][low-contrast]) a:focus,:host(cds-inline-notification):host(cds-inline-notification[kind=warning-alt][low-contrast]) a:focus,:host(cds-inline-notification):host(cds-inline-notification[kind=warning][low-contrast]) a:focus,[low-contrast]:host(cds-inline-notification):host(cds-inline-notification[kind=warning-alt]) a:focus{outline-style:dotted}}.cds--inline-notification--error,:host(cds-inline-notification[kind=error]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-error-inverse,#fa4d56)}.cds--inline-notification--low-contrast.cds--inline-notification--error,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=error]),:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=error]),:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=error]),:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=error]),:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=error]),:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=error]){background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--toast-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=error]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=error]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=error]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=error]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=error]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=error]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=error]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=error]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=error]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=error]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=error]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=error]) .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}.cds--inline-notification--success,:host(cds-inline-notification[kind=success]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-success-inverse,#42be65)}.cds--inline-notification--low-contrast.cds--inline-notification--success,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=success]),:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=success]),:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=success]),:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=success]),:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=success]),:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=success]){background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--toast-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=success]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=success]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=success]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=success]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=success]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=success]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=success]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=success]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=success]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=success]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=success]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=success]) .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}.cds--inline-notification--info,.cds--inline-notification--info-square,:host(cds-inline-notification[kind=info-square]),:host(cds-inline-notification[kind=info]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-info-inverse,#4589ff)}.cds--inline-notification--low-contrast.cds--inline-notification--info,.cds--inline-notification--low-contrast.cds--inline-notification--info-square,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=info-square]),:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=info]),:host(cds-inline-notification[kind=info-square][low-contrast]),:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=info]),:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=info-square]),:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=info]),:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=info-square]),:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=info]),:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=info-square]),:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=info]){background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--toast-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--toast-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=info]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=info]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=info]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=info]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=info]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=info]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=info]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]):host(cds-inline-notification[kind=info]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=info]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=info]) .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}.cds--inline-notification--warning,.cds--inline-notification--warning-alt,:host(cds-inline-notification[kind=warning-alt]),:host(cds-inline-notification[kind=warning-alt])[low-contrast],:host(cds-inline-notification[kind=warning]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-warning-inverse,#f1c21b)}.cds--inline-notification--low-contrast.cds--inline-notification--warning,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=warning-alt]),:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=warning]),:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=warning-alt]),:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=warning]),:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=warning-alt]),:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=warning]),:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=warning-alt]),:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=warning]),:host(cds-inline-notification[kind=warning-alt][low-contrast]),:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=warning]){background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--toast-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--toast-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]):host(cds-inline-notification[kind=warning]) .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}.cds--toast-notification{block-size:auto;box-shadow:0 2px 6px 0 rgba(0,0,0,.2);color:var(--cds-text-inverse,#fff);display:flex;inline-size:18rem;padding-inline-start:.8125rem}.cds--toast-notification html{font-size:100%}.cds--toast-notification body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--toast-notification code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--toast-notification strong{font-weight:600}@media (min-width:99rem){.cds--toast-notification{inline-size:22rem}}.cds--toast-notification:not(.cds--toast-notification--low-contrast) a{color:var(--cds-link-inverse,#78a9ff)}.cds--toast-notification a{text-decoration:none}.cds--toast-notification a:hover{text-decoration:underline}.cds--toast-notification a:focus{outline:1px solid var(--cds-link-inverse,#78a9ff)}.cds--toast-notification.cds--toast-notification--low-contrast a:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--toast-notification.cds--toast-notification--low-contrast a:focus{outline-style:dotted}}.cds--toast-notification--low-contrast{color:var(--cds-text-primary,#161616)}.cds--toast-notification--error{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-error-inverse,#fa4d56)}.cds--toast-notification--error .cds--actionable-notification__icon,.cds--toast-notification--error .cds--inline-notification__icon,.cds--toast-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error-inverse,#fa4d56)}.cds--toast-notification--low-contrast.cds--toast-notification--error{background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}.cds--toast-notification--success{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-success-inverse,#42be65)}.cds--toast-notification--success .cds--actionable-notification__icon,.cds--toast-notification--success .cds--inline-notification__icon,.cds--toast-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success-inverse,#42be65)}.cds--toast-notification--low-contrast.cds--toast-notification--success{background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}.cds--toast-notification--info,.cds--toast-notification--info-square{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-info-inverse,#4589ff)}.cds--toast-notification--info .cds--actionable-notification__icon,.cds--toast-notification--info .cds--inline-notification__icon,.cds--toast-notification--info .cds--toast-notification__icon,.cds--toast-notification--info-square .cds--actionable-notification__icon,.cds--toast-notification--info-square .cds--inline-notification__icon,.cds--toast-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info-inverse,#4589ff)}.cds--toast-notification--low-contrast.cds--toast-notification--info,.cds--toast-notification--low-contrast.cds--toast-notification--info-square{background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--toast-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}.cds--toast-notification--warning,.cds--toast-notification--warning-alt{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-warning-inverse,#f1c21b)}.cds--toast-notification--warning .cds--actionable-notification__icon,.cds--toast-notification--warning .cds--inline-notification__icon,.cds--toast-notification--warning .cds--toast-notification__icon,.cds--toast-notification--warning-alt .cds--actionable-notification__icon,.cds--toast-notification--warning-alt .cds--inline-notification__icon,.cds--toast-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning-inverse,#f1c21b)}.cds--toast-notification--low-contrast.cds--toast-notification--warning,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt{background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--toast-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}.cds--toast-notification--warning .cds--toast-notification__icon path[opacity="0"],.cds--toast-notification--warning-alt .cds--toast-notification__icon path:first-of-type{fill:#000;opacity:1}.cds--toast-notification__icon{flex-shrink:0;margin-block-start:1rem;margin-inline-end:1rem}.cds--toast-notification__details{margin-block-end:1rem;margin-inline-end:1rem}.cds--toast-notification__close-button{align-items:center;background-color:transparent;block-size:3rem;border:none;cursor:pointer;display:flex;flex-direction:column;inline-size:3rem;justify-content:center;margin-inline-start:auto;min-block-size:3rem;min-inline-size:3rem;outline:2px solid transparent;outline-offset:-2px;padding:0;transition:outline .25s,background-color .25s}.cds--toast-notification__close-button:focus{outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--toast-notification__close-button .cds--toast-notification__close-icon{fill:var(--cds-icon-inverse,#fff)}.cds--toast-notification--low-contrast .cds--toast-notification__close-button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--toast-notification--low-contrast .cds--toast-notification__close-button:focus{outline-style:dotted}}.cds--toast-notification--low-contrast .cds--toast-notification__close-button .cds--toast-notification__close-icon{fill:var(--cds-icon-primary,#161616)}.cds--toast-notification__title{font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);font-weight:600;letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);margin-block-start:1rem;word-break:break-word}.cds--toast-notification__subtitle{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin-block:0 1rem;word-break:break-word}.cds--toast-notification--low-contrast .cds--toast-notification__subtitle{color:var(--cds-text-primary,#161616)}.cds--toast-notification__caption{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);padding-block-start:.5rem}.cds--toast-notification--low-contrast .cds--toast-notification__caption{color:var(--cds-text-primary,#161616)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--toast-notification{outline:1px solid transparent}.cds--toast-notification__close-button:focus{color:Highlight;outline:1px solid Highlight}.cds--toast-notification .cds--toast-notification__close-icon,.cds--toast-notification .cds--toast-notification__icon{fill:ButtonText}}.cds--actionable-notification{block-size:auto;color:var(--cds-text-inverse,#fff);display:flex;flex-wrap:wrap;inline-size:100%;max-inline-size:18rem;min-block-size:3rem;min-inline-size:18rem;position:relative}.cds--actionable-notification html{font-size:100%}.cds--actionable-notification body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--actionable-notification code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--actionable-notification strong{font-weight:600}@media (min-width:42rem){.cds--actionable-notification{flex-wrap:nowrap;max-inline-size:38rem}}@media (min-width:66rem){.cds--actionable-notification{max-inline-size:46rem}}@media (min-width:99rem){.cds--actionable-notification{max-inline-size:52rem}}.cds--actionable-notification--toast{box-shadow:0 2px 6px 0 rgba(0,0,0,.2);flex-wrap:wrap;max-inline-size:18rem;min-inline-size:18rem}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) a{color:var(--cds-link-inverse,#78a9ff)}.cds--actionable-notification a{text-decoration:none}.cds--actionable-notification a:hover{text-decoration:underline}.cds--actionable-notification a:focus{outline:1px solid var(--cds-focus-inverse,#fff)}.cds--actionable-notification.cds--actionable-notification--low-contrast a:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--actionable-notification.cds--actionable-notification--low-contrast a:focus{outline-style:dotted}}.cds--actionable-notification--low-contrast{color:var(--cds-text-primary,#161616)}.cds--actionable-notification--low-contrast:not(.cds--actionable-notification--toast):before{block-size:100%;border-style:solid;border-width:1px 1px 1px 0;box-sizing:border-box;content:"";filter:opacity(.4);inline-size:100%;inset-block-start:0;inset-inline-start:0;pointer-events:none;position:absolute}.cds--actionable-notification--error{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-error-inverse,#fa4d56)}.cds--actionable-notification--error .cds--actionable-notification__icon,.cds--actionable-notification--error .cds--inline-notification__icon,.cds--actionable-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error-inverse,#fa4d56)}.cds--actionable-notification--low-contrast.cds--actionable-notification--error{background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}.cds--actionable-notification--low-contrast.cds--actionable-notification--error:before{border-color:var(--cds-support-error,#da1e28)}.cds--actionable-notification--success{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-success-inverse,#42be65)}.cds--actionable-notification--success .cds--actionable-notification__icon,.cds--actionable-notification--success .cds--inline-notification__icon,.cds--actionable-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success-inverse,#42be65)}.cds--actionable-notification--low-contrast.cds--actionable-notification--success{background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}.cds--actionable-notification--low-contrast.cds--actionable-notification--success:before{border-color:var(--cds-support-success,#24a148)}.cds--actionable-notification--info,.cds--actionable-notification--info-square{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-info-inverse,#4589ff)}.cds--actionable-notification--info .cds--actionable-notification__icon,.cds--actionable-notification--info .cds--inline-notification__icon,.cds--actionable-notification--info .cds--toast-notification__icon,.cds--actionable-notification--info-square .cds--actionable-notification__icon,.cds--actionable-notification--info-square .cds--inline-notification__icon,.cds--actionable-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info-inverse,#4589ff)}.cds--actionable-notification--low-contrast.cds--actionable-notification--info,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square{background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--toast-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square:before,.cds--actionable-notification--low-contrast.cds--actionable-notification--info:before{border-color:var(--cds-support-info,#0043ce)}.cds--actionable-notification--warning,.cds--actionable-notification--warning-alt{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-warning-inverse,#f1c21b)}.cds--actionable-notification--warning .cds--actionable-notification__icon,.cds--actionable-notification--warning .cds--inline-notification__icon,.cds--actionable-notification--warning .cds--toast-notification__icon,.cds--actionable-notification--warning-alt .cds--actionable-notification__icon,.cds--actionable-notification--warning-alt .cds--inline-notification__icon,.cds--actionable-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning-inverse,#f1c21b)}.cds--actionable-notification--low-contrast.cds--actionable-notification--warning,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt{background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--toast-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt:before,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning:before{border-color:var(--cds-support-warning,#f1c21b)}.cds--actionable-notification--warning .cds--inline-notification__icon path[opacity="0"],.cds--actionable-notification--warning .cds--toast-notification__icon path[opacity="0"],.cds--actionable-notification--warning-alt .cds--inline-notification__icon path:first-of-type,.cds--actionable-notification--warning-alt .cds--toast-notification__icon path:first-of-type{fill:#000;opacity:1}.cds--actionable-notification__details{display:flex;flex-grow:1;margin-inline:.8125rem 3rem}@media (min-width:42rem){.cds--actionable-notification:not(.cds--actionable-notification--toast) .cds--actionable-notification__details{margin:0 .8125rem}}.cds--actionable-notification .cds--inline-notification__icon{flex-shrink:0;margin-block-start:.875rem;margin-inline-end:1rem}.cds--actionable-notification .cds--toast-notification__icon{flex-shrink:0;margin-block-start:1rem;margin-inline-end:1rem}.cds--actionable-notification__text-wrapper{display:flex;flex-wrap:wrap;padding:.9375rem 0}.cds--actionable-notification__button-wrapper{display:flex}.cds--actionable-notification--toast .cds--actionable-notification__text-wrapper{padding:.9375rem 0 1.4375rem}.cds--actionable-notification__content{display:flex;flex-wrap:wrap;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);word-break:break-word}.cds--actionable-notification--toast .cds--actionable-notification__content{display:block}.cds--actionable-notification__title{font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);font-weight:600;letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);margin-inline-end:.25rem;word-break:break-word}.cds--actionable-notification--toast .cds--actionable-notification__title{margin-inline-end:0}.cds--actionable-notification__subtitle{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin-block-start:0;word-break:break-word}.cds--actionable-notification--low-contrast .cds--actionable-notification__subtitle{color:var(--cds-text-primary,#161616)}.cds--actionable-notification__action-button.cds--btn--ghost{block-size:2rem;margin-block-end:.5rem;margin-inline-start:2.5rem}@media (min-width:42rem){.cds--actionable-notification__action-button.cds--btn--ghost{margin:.5rem 0}}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--ghost{color:var(--cds-link-inverse,#78a9ff)}.cds--actionable-notification__action-button.cds--btn--ghost:active,.cds--actionable-notification__action-button.cds--btn--ghost:hover{background-color:var(--cds-background-inverse-hover,#474747)}.cds--actionable-notification--low-contrast .cds--actionable-notification__action-button.cds--btn--ghost:active,.cds--actionable-notification--low-contrast .cds--actionable-notification__action-button.cds--btn--ghost:hover{background-color:var(--cds-notification-action-hover,#fff)}.cds--actionable-notification__action-button.cds--btn--ghost:focus{border-color:transparent;box-shadow:none;outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--actionable-notification--low-contrast .cds--actionable-notification__action-button.cds--btn--ghost:focus{outline-color:var(--cds-focus,#0f62fe)}.cds--actionable-notification--hide-close-button .cds--actionable-notification__action-button.cds--btn--ghost{margin-inline-end:.5rem}.cds--actionable-notification__action-button.cds--btn--tertiary{margin-block-end:1rem;margin-inline-start:3.125rem;padding-inline:1rem}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-notification-action-tertiary-inverse,#fff);border-style:solid;border-width:1px;color:var(--cds-notification-action-tertiary-inverse,#fff)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:hover{background-color:var(--cds-notification-action-tertiary-inverse-hover,#f4f4f4)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary .cds--btn__icon,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:hover{color:var(--cds-notification-action-tertiary-inverse-text,#161616)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:focus{background-color:var(--cds-notification-action-tertiary-inverse,#fff);border-color:var(--cds-focus-inverse,#fff);box-shadow:inset 0 0 0 1px var(--cds-focus-inverse,#fff),inset 0 0 0 2px var(--cds-background-inverse,#393939);color:var(--cds-notification-action-tertiary-inverse-text,#161616)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:active{background-color:var(--cds-notification-action-tertiary-inverse-active,#c6c6c6);border-color:transparent;color:var(--cds-notification-action-tertiary-inverse-text,#161616)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled:focus,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled:hover,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:disabled,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:focus:disabled,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-notification-action-tertiary-inverse-text-on-color-disabled,hsla(0,0%,100%,.25));outline:none}.cds--actionable-notification--hide-close-button .cds--actionable-notification__action-button.cds--btn--tertiary{margin-inline-end:.5rem}.cds--actionable-notification__close-button{align-items:center;background:transparent;block-size:3rem;border:none;cursor:pointer;display:flex;flex-direction:column;inline-size:3rem;inset-block-start:0;inset-inline-end:0;justify-content:center;max-inline-size:3rem;min-inline-size:3rem;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline .11s cubic-bezier(.2,0,.38,.9),background-color .11s cubic-bezier(.2,0,.38,.9)}.cds--actionable-notification__close-button:focus{outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--actionable-notification__close-button .cds--actionable-notification__close-icon{fill:var(--cds-icon-inverse,#fff)}@media (min-width:42rem){.cds--actionable-notification__close-button{position:static}.cds--actionable-notification--toast .cds--actionable-notification__close-button{position:absolute}}.cds--actionable-notification--low-contrast .cds--actionable-notification__close-button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--actionable-notification--low-contrast .cds--actionable-notification__close-button:focus{outline-style:dotted}}.cds--actionable-notification--low-contrast .cds--actionable-notification__close-button .cds--actionable-notification__close-icon{fill:var(--cds-icon-primary,#161616)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--actionable-notification{outline:1px solid transparent}.cds--actionable-notification__close-button:focus,.cds--btn.cds--btn--ghost.cds--actionable-notification__action-button:focus{color:Highlight;outline:1px solid Highlight}.cds--actionable-notification .cds--actionable-notification__close-icon,.cds--actionable-notification .cds--inline-notification__icon,.cds--actionable-notification .cds--toast-notification__icon{fill:ButtonText}}.cds--inline-notification,:host(cds-inline-notification){block-size:auto;color:var(--cds-text-inverse,#fff);display:flex;flex-wrap:wrap;inline-size:100%;max-inline-size:18rem;min-block-size:3rem;min-inline-size:18rem;position:relative}.cds--inline-notification html,:host(cds-inline-notification) html{font-size:100%}.cds--inline-notification body,:host(cds-inline-notification) body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--inline-notification code,:host(cds-inline-notification) code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--inline-notification strong,:host(cds-inline-notification) strong{font-weight:600}@media (min-width:42rem){.cds--inline-notification,:host(cds-inline-notification){flex-wrap:nowrap;max-inline-size:38rem}}@media (min-width:66rem){.cds--inline-notification,:host(cds-inline-notification){max-inline-size:46rem}}@media (min-width:99rem){.cds--inline-notification,:host(cds-inline-notification){max-inline-size:52rem}}.cds--inline-notification:not(.cds--inline-notification--low-contrast):not(:host(cds-inline-notification[kind=warning-alt])[low-contrast]) a,:not(.cds--inline-notification--low-contrast):not(:host(cds-inline-notification[kind=warning-alt])[low-contrast]):host(cds-inline-notification) a{color:var(--cds-link-inverse,#78a9ff)}.cds--inline-notification a,:host(cds-inline-notification) a{text-decoration:none}.cds--inline-notification a:hover,:host(cds-inline-notification) a:hover{text-decoration:underline}.cds--inline-notification a:focus,:host(cds-inline-notification) a:focus{outline:1px solid var(--cds-link-inverse,#78a9ff)}.cds--inline-notification.cds--inline-notification--low-contrast a:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--inline-notification.cds--inline-notification--low-contrast a:focus{outline-style:dotted}}.cds--inline-notification--low-contrast,:host(cds-inline-notification[kind=error][low-contrast]),:host(cds-inline-notification[kind=info-square][low-contrast]),:host(cds-inline-notification[kind=info][low-contrast]),:host(cds-inline-notification[kind=success][low-contrast]),:host(cds-inline-notification[kind=warning-alt])[low-contrast],:host(cds-inline-notification[kind=warning-alt][low-contrast]),:host(cds-inline-notification[kind=warning][low-contrast]){color:var(--cds-text-primary,#161616)}.cds--inline-notification--low-contrast:before{block-size:100%;border-style:solid;border-width:1px 1px 1px 0;box-sizing:border-box;content:"";filter:opacity(.4);inline-size:100%;inset-block-start:0;inset-inline-start:0;pointer-events:none;position:absolute}.cds--inline-notification--error,:host(cds-inline-notification[kind=error]),:host(cds-inline-notification[kind=error][low-contrast]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-error-inverse,#fa4d56)}.cds--inline-notification--error .cds--actionable-notification__icon,.cds--inline-notification--error .cds--inline-notification__icon,.cds--inline-notification--error .cds--toast-notification__icon,:host(cds-inline-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=error]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=error]) .cds--toast-notification__icon{fill:var(--cds-support-error-inverse,#fa4d56)}.cds--inline-notification--low-contrast.cds--inline-notification--error{background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}.cds--inline-notification--low-contrast.cds--inline-notification--error:before{border-color:var(--cds-support-error,#da1e28)}.cds--inline-notification--success,:host(cds-inline-notification[kind=success]),:host(cds-inline-notification[kind=success][low-contrast]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-success-inverse,#42be65)}.cds--inline-notification--success .cds--actionable-notification__icon,.cds--inline-notification--success .cds--inline-notification__icon,.cds--inline-notification--success .cds--toast-notification__icon,:host(cds-inline-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=success]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=success]) .cds--toast-notification__icon{fill:var(--cds-support-success-inverse,#42be65)}.cds--inline-notification--low-contrast.cds--inline-notification--success{background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}.cds--inline-notification--low-contrast.cds--inline-notification--success:before{border-color:var(--cds-support-success,#24a148)}.cds--inline-notification--info,.cds--inline-notification--info-square,:host(cds-inline-notification[kind=info-square]),:host(cds-inline-notification[kind=info-square][low-contrast]),:host(cds-inline-notification[kind=info]),:host(cds-inline-notification[kind=info][low-contrast]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-info-inverse,#4589ff)}.cds--inline-notification--info .cds--actionable-notification__icon,.cds--inline-notification--info .cds--inline-notification__icon,.cds--inline-notification--info .cds--toast-notification__icon,.cds--inline-notification--info-square .cds--actionable-notification__icon,.cds--inline-notification--info-square .cds--inline-notification__icon,.cds--inline-notification--info-square .cds--toast-notification__icon,:host(cds-inline-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info]) .cds--toast-notification__icon{fill:var(--cds-support-info-inverse,#4589ff)}.cds--inline-notification--low-contrast.cds--inline-notification--info,.cds--inline-notification--low-contrast.cds--inline-notification--info-square{background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--toast-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}.cds--inline-notification--low-contrast.cds--inline-notification--info-square:before,.cds--inline-notification--low-contrast.cds--inline-notification--info:before{border-color:var(--cds-support-info,#0043ce)}.cds--inline-notification--warning,.cds--inline-notification--warning-alt,:host(cds-inline-notification[kind=warning-alt]),:host(cds-inline-notification[kind=warning-alt])[low-contrast],:host(cds-inline-notification[kind=warning-alt][low-contrast]),:host(cds-inline-notification[kind=warning]),:host(cds-inline-notification[kind=warning][low-contrast]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-warning-inverse,#f1c21b)}.cds--inline-notification--warning .cds--actionable-notification__icon,.cds--inline-notification--warning .cds--inline-notification__icon,.cds--inline-notification--warning .cds--toast-notification__icon,.cds--inline-notification--warning-alt .cds--actionable-notification__icon,.cds--inline-notification--warning-alt .cds--inline-notification__icon,.cds--inline-notification--warning-alt .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning]) .cds--toast-notification__icon{fill:var(--cds-support-warning-inverse,#f1c21b)}.cds--inline-notification--low-contrast.cds--inline-notification--warning,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt{background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--toast-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt:before,.cds--inline-notification--low-contrast.cds--inline-notification--warning:before{border-color:var(--cds-support-warning,#f1c21b)}.cds--inline-notification--warning .cds--inline-notification__icon path[opacity="0"],.cds--inline-notification--warning-alt .cds--inline-notification__icon path:first-of-type,:host(cds-inline-notification[kind=warning-alt]) .cds--inline-notification__icon path:first-of-type,:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__icon path[opacity="0"],:host(cds-inline-notification[kind=warning]) .cds--inline-notification__icon path[opacity="0"]{fill:#000;opacity:1}.cds--inline-notification__details{display:flex;flex-grow:1;margin-inline:.8125rem 3rem}@media (min-width:42rem){.cds--inline-notification__details{margin:0 .8125rem}}.cds--inline-notification__icon{flex-shrink:0;margin-block-start:.875rem;margin-inline-end:1rem}.cds--inline-notification__text-wrapper{display:flex;flex-wrap:wrap;padding:.9375rem 0}.cds--inline-notification__title{font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);margin-inline-end:.25rem}.cds--inline-notification__subtitle{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);word-break:break-word}.cds--inline-notification__action-button.cds--btn--ghost{block-size:2rem;margin-block-end:.5rem;margin-inline-start:2.5rem}@media (min-width:42rem){.cds--inline-notification__action-button.cds--btn--ghost{margin:.5rem 0}}.cds--inline-notification:not(.cds--inline-notification--low-contrast):not(:host(cds-inline-notification[kind=warning-alt])[low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost,:not(.cds--inline-notification--low-contrast):not(:host(cds-inline-notification[kind=warning-alt])[low-contrast]):host(cds-inline-notification) .cds--inline-notification__action-button.cds--btn--ghost{color:var(--cds-link-inverse,#78a9ff)}.cds--inline-notification__action-button.cds--btn--ghost:active,.cds--inline-notification__action-button.cds--btn--ghost:hover{background-color:var(--cds-background-inverse-hover,#474747)}.cds--inline-notification--low-contrast .cds--inline-notification__action-button.cds--btn--ghost:active,.cds--inline-notification--low-contrast .cds--inline-notification__action-button.cds--btn--ghost:hover,:host(cds-inline-notification[kind=error][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:active,:host(cds-inline-notification[kind=error][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:hover,:host(cds-inline-notification[kind=info-square][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:active,:host(cds-inline-notification[kind=info-square][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:hover,:host(cds-inline-notification[kind=info][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:active,:host(cds-inline-notification[kind=info][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:hover,:host(cds-inline-notification[kind=success][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:active,:host(cds-inline-notification[kind=success][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:hover,:host(cds-inline-notification[kind=warning-alt])[low-contrast] .cds--inline-notification__action-button.cds--btn--ghost:active,:host(cds-inline-notification[kind=warning-alt])[low-contrast] .cds--inline-notification__action-button.cds--btn--ghost:hover,:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:active,:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:hover,:host(cds-inline-notification[kind=warning][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:active,:host(cds-inline-notification[kind=warning][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:hover{background-color:var(--cds-notification-action-hover,#fff)}.cds--inline-notification__action-button.cds--btn--ghost:focus{border-color:transparent;box-shadow:none;outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--inline-notification--low-contrast .cds--inline-notification__action-button.cds--btn--ghost:focus,:host(cds-inline-notification[kind=error][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:focus,:host(cds-inline-notification[kind=info-square][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:focus,:host(cds-inline-notification[kind=info][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:focus,:host(cds-inline-notification[kind=success][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:focus,:host(cds-inline-notification[kind=warning-alt])[low-contrast] .cds--inline-notification__action-button.cds--btn--ghost:focus,:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:focus,:host(cds-inline-notification[kind=warning][low-contrast]) .cds--inline-notification__action-button.cds--btn--ghost:focus{outline-color:var(--cds-focus,#0f62fe)}.cds--inline-notification--hide-close-button .cds--inline-notification__action-button.cds--btn--ghost{margin-inline-end:.5rem}.cds--inline-notification__close-button{align-items:center;background:transparent;block-size:3rem;border:none;cursor:pointer;display:flex;flex-direction:column;inline-size:3rem;inset-block-start:0;inset-inline-end:0;justify-content:center;max-inline-size:3rem;min-inline-size:3rem;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline .11s cubic-bezier(.2,0,.38,.9),background-color .11s cubic-bezier(.2,0,.38,.9)}.cds--inline-notification__close-button:focus{outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--inline-notification__close-button .cds--inline-notification__close-icon{fill:var(--cds-icon-inverse,#fff)}@media (min-width:42rem){.cds--inline-notification__close-button{position:static}}.cds--inline-notification--low-contrast .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=error][low-contrast]) .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=info-square][low-contrast]) .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=info][low-contrast]) .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=success][low-contrast]) .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=warning-alt])[low-contrast] .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=warning][low-contrast]) .cds--inline-notification__close-button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--inline-notification--low-contrast .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=error][low-contrast]) .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=info-square][low-contrast]) .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=info][low-contrast]) .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=success][low-contrast]) .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=warning-alt])[low-contrast] .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__close-button:focus,:host(cds-inline-notification[kind=warning][low-contrast]) .cds--inline-notification__close-button:focus{outline-style:dotted}}.cds--inline-notification--low-contrast .cds--inline-notification__close-button .cds--inline-notification__close-icon,:host(cds-inline-notification[kind=error][low-contrast]) .cds--inline-notification__close-button .cds--inline-notification__close-icon,:host(cds-inline-notification[kind=info-square][low-contrast]) .cds--inline-notification__close-button .cds--inline-notification__close-icon,:host(cds-inline-notification[kind=info][low-contrast]) .cds--inline-notification__close-button .cds--inline-notification__close-icon,:host(cds-inline-notification[kind=success][low-contrast]) .cds--inline-notification__close-button .cds--inline-notification__close-icon,:host(cds-inline-notification[kind=warning-alt])[low-contrast] .cds--inline-notification__close-button .cds--inline-notification__close-icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__close-button .cds--inline-notification__close-icon,:host(cds-inline-notification[kind=warning][low-contrast]) .cds--inline-notification__close-button .cds--inline-notification__close-icon{fill:var(--cds-icon-primary,#161616)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--inline-notification,:host(cds-inline-notification){outline:1px solid transparent}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn.cds--btn--ghost.cds--inline-notification__action-button:focus,.cds--inline-notification__close-button:focus{color:Highlight;outline:1px solid Highlight}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--inline-notification .cds--inline-notification__icon,:host(cds-inline-notification) .cds--inline-notification__icon{fill:ButtonText}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--inline-notification .cds--inline-notification__close-icon,:host(cds-inline-notification) .cds--inline-notification__close-icon{fill:ButtonText}}:host(cds-inline-notification){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;display:none;outline:none}:host(cds-inline-notification) .cds--inline-notification__close-button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){:host(cds-inline-notification) .cds--inline-notification__close-button:focus{outline-style:dotted}}:host(cds-inline-notification) .cds--inline-notification__title{margin-block:0}:host(cds-inline-notification[low-contrast]):before{block-size:100%;border-style:solid;border-width:1px 1px 1px 0;box-sizing:border-box;content:"";filter:opacity(.4);inline-size:100%;inset-block-start:0;inset-inline-start:0;pointer-events:none;position:absolute}:host(cds-inline-notification[open]){display:flex}:host(cds-inline-notification[hide-close-button]) .cds--inline-notification__close-button{display:none}:host(cds-inline-notification[kind=success][low-contrast]){background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}:host(cds-inline-notification[kind=success][low-contrast]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=success][low-contrast]) .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}:host(cds-inline-notification[kind=success][low-contrast]):before{border-color:var(--cds-support-success,#24a148)}:host(cds-inline-notification[kind=info-square][low-contrast]),:host(cds-inline-notification[kind=info][low-contrast]){background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}:host(cds-inline-notification[kind=info-square][low-contrast]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info-square][low-contrast]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=info][low-contrast]) .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}:host(cds-inline-notification[kind=info-square][low-contrast]):before,:host(cds-inline-notification[kind=info][low-contrast]):before{border-color:var(--cds-support-info,#0043ce)}:host(cds-inline-notification[kind=warning-alt]) .cds--inline-notification__icon path[data-icon-path=inner-path]{fill:#000}:host(cds-inline-notification[kind=warning-alt][low-contrast]),:host(cds-inline-notification[kind=warning][low-contrast]){background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=warning][low-contrast]) .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}:host(cds-inline-notification[kind=warning-alt][low-contrast]):before,:host(cds-inline-notification[kind=warning][low-contrast]):before{border-color:var(--cds-support-warning,#f1c21b)}:host(cds-inline-notification[kind=error][low-contrast]){background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}:host(cds-inline-notification[kind=error][low-contrast]) .cds--actionable-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]) .cds--inline-notification__icon,:host(cds-inline-notification[kind=error][low-contrast]) .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}:host(cds-inline-notification[kind=error][low-contrast]):before{border-color:var(--cds-support-error,#da1e28)}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"knpkJ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSToastNotification$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("./defs.js");
var _inlineNotificationJs = require("./inline-notification.js");
var _inlineNotificationJsDefault = parcelHelpers.interopDefault(_inlineNotificationJs);
var _toastNotificationScssJs = require("./toast-notification.scss.js");
var _toastNotificationScssJsDefault = parcelHelpers.interopDefault(_toastNotificationScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Toast notification.
 *
 * @element cds-toast-notification
 * @slot subtitle - The subtitle.
 * @slot title - The title.
 * @fires cds-notification-beingclosed
 *   The custom event fired before this notification is being closed upon a user gesture.
 *   Cancellation of this event stops the user-initiated action of closing this notification.
 * @fires cds-notification-closed - The custom event fired after this notification is closed upon a user gesture.
 */ let CDSToastNotification = class CDSToastNotification extends (0, _inlineNotificationJsDefault.default) {
    constructor(){
        super(...arguments);
        this._type = (0, _defsJs.NOTIFICATION_TYPE).TOAST;
        /**
         * Specify the caption
         */ this.caption = "";
    }
    _renderText() {
        const { caption, subtitle, title, _type: type } = this;
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--${type}-notification__details">
        <div class="${0, _settingsJs.prefix}--${type}-notification__title">
          ${title}<slot name="title"></slot>
        </div>
        <div class="${0, _settingsJs.prefix}--${type}-notification__subtitle">
          ${subtitle}<slot name="subtitle"></slot>
        </div>
        <div class="${0, _settingsJs.prefix}--${type}-notification__caption">
          ${caption}<slot name="caption"></slot>
        </div>
        <slot></slot>
      </div>
    `;
    }
    render() {
        const { _type: type } = this;
        return (0, _lit.html)`
      ${this._renderIcon()}
      <div class="${0, _settingsJs.prefix}--${type}-notification__details">
        ${this._renderText()}
      </div>
      ${this._renderButton()}
    `;
    }
};
CDSToastNotification.styles = (0, _toastNotificationScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSToastNotification.prototype, "caption", void 0);
CDSToastNotification = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-toast-notification`)
], CDSToastNotification);
var CDSToastNotification$1 = CDSToastNotification;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","./defs.js":"4N5Fz","./inline-notification.js":"jElO5","./toast-notification.scss.js":"8ETVq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8ETVq":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--inline-notification{block-size:auto;color:var(--cds-text-inverse,#fff);display:flex;flex-wrap:wrap;inline-size:100%;max-inline-size:18rem;min-block-size:3rem;min-inline-size:18rem;position:relative}.cds--inline-notification html{font-size:100%}.cds--inline-notification body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--inline-notification code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--inline-notification strong{font-weight:600}@media (min-width:42rem){.cds--inline-notification{flex-wrap:nowrap;max-inline-size:38rem}}@media (min-width:66rem){.cds--inline-notification{max-inline-size:46rem}}@media (min-width:99rem){.cds--inline-notification{max-inline-size:52rem}}.cds--inline-notification:not(.cds--inline-notification--low-contrast) a{color:var(--cds-link-inverse,#78a9ff)}.cds--inline-notification a{text-decoration:none}.cds--inline-notification a:hover{text-decoration:underline}.cds--inline-notification a:focus{outline:1px solid var(--cds-link-inverse,#78a9ff)}.cds--inline-notification.cds--inline-notification--low-contrast a:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--inline-notification.cds--inline-notification--low-contrast a:focus{outline-style:dotted}}.cds--inline-notification--low-contrast{color:var(--cds-text-primary,#161616)}.cds--inline-notification--low-contrast:before{block-size:100%;border-style:solid;border-width:1px 1px 1px 0;box-sizing:border-box;content:"";filter:opacity(.4);inline-size:100%;inset-block-start:0;inset-inline-start:0;pointer-events:none;position:absolute}.cds--inline-notification--error{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-error-inverse,#fa4d56)}.cds--inline-notification--error .cds--actionable-notification__icon,.cds--inline-notification--error .cds--inline-notification__icon,.cds--inline-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error-inverse,#fa4d56)}.cds--inline-notification--low-contrast.cds--inline-notification--error{background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}.cds--inline-notification--low-contrast.cds--inline-notification--error:before{border-color:var(--cds-support-error,#da1e28)}.cds--inline-notification--success{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-success-inverse,#42be65)}.cds--inline-notification--success .cds--actionable-notification__icon,.cds--inline-notification--success .cds--inline-notification__icon,.cds--inline-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success-inverse,#42be65)}.cds--inline-notification--low-contrast.cds--inline-notification--success{background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}.cds--inline-notification--low-contrast.cds--inline-notification--success:before{border-color:var(--cds-support-success,#24a148)}.cds--inline-notification--info,.cds--inline-notification--info-square{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-info-inverse,#4589ff)}.cds--inline-notification--info .cds--actionable-notification__icon,.cds--inline-notification--info .cds--inline-notification__icon,.cds--inline-notification--info .cds--toast-notification__icon,.cds--inline-notification--info-square .cds--actionable-notification__icon,.cds--inline-notification--info-square .cds--inline-notification__icon,.cds--inline-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info-inverse,#4589ff)}.cds--inline-notification--low-contrast.cds--inline-notification--info,.cds--inline-notification--low-contrast.cds--inline-notification--info-square{background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--toast-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}.cds--inline-notification--low-contrast.cds--inline-notification--info-square:before,.cds--inline-notification--low-contrast.cds--inline-notification--info:before{border-color:var(--cds-support-info,#0043ce)}.cds--inline-notification--warning,.cds--inline-notification--warning-alt{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-warning-inverse,#f1c21b)}.cds--inline-notification--warning .cds--actionable-notification__icon,.cds--inline-notification--warning .cds--inline-notification__icon,.cds--inline-notification--warning .cds--toast-notification__icon,.cds--inline-notification--warning-alt .cds--actionable-notification__icon,.cds--inline-notification--warning-alt .cds--inline-notification__icon,.cds--inline-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning-inverse,#f1c21b)}.cds--inline-notification--low-contrast.cds--inline-notification--warning,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt{background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--toast-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt:before,.cds--inline-notification--low-contrast.cds--inline-notification--warning:before{border-color:var(--cds-support-warning,#f1c21b)}.cds--inline-notification--warning .cds--inline-notification__icon path[opacity="0"],.cds--inline-notification--warning-alt .cds--inline-notification__icon path:first-of-type{fill:#000;opacity:1}.cds--inline-notification__details{display:flex;flex-grow:1;margin-inline:.8125rem 3rem}@media (min-width:42rem){.cds--inline-notification__details{margin:0 .8125rem}}.cds--inline-notification__icon{flex-shrink:0;margin-block-start:.875rem;margin-inline-end:1rem}.cds--inline-notification__text-wrapper{display:flex;flex-wrap:wrap;padding:.9375rem 0}.cds--inline-notification__title{font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);margin-inline-end:.25rem}.cds--inline-notification__subtitle{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);word-break:break-word}.cds--inline-notification__action-button.cds--btn--ghost{block-size:2rem;margin-block-end:.5rem;margin-inline-start:2.5rem}@media (min-width:42rem){.cds--inline-notification__action-button.cds--btn--ghost{margin:.5rem 0}}.cds--inline-notification:not(.cds--inline-notification--low-contrast) .cds--inline-notification__action-button.cds--btn--ghost{color:var(--cds-link-inverse,#78a9ff)}.cds--inline-notification__action-button.cds--btn--ghost:active,.cds--inline-notification__action-button.cds--btn--ghost:hover{background-color:var(--cds-background-inverse-hover,#474747)}.cds--inline-notification--low-contrast .cds--inline-notification__action-button.cds--btn--ghost:active,.cds--inline-notification--low-contrast .cds--inline-notification__action-button.cds--btn--ghost:hover{background-color:var(--cds-notification-action-hover,#fff)}.cds--inline-notification__action-button.cds--btn--ghost:focus{border-color:transparent;box-shadow:none;outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--inline-notification--low-contrast .cds--inline-notification__action-button.cds--btn--ghost:focus{outline-color:var(--cds-focus,#0f62fe)}.cds--inline-notification--hide-close-button .cds--inline-notification__action-button.cds--btn--ghost{margin-inline-end:.5rem}.cds--inline-notification__close-button{align-items:center;background:transparent;block-size:3rem;border:none;cursor:pointer;display:flex;flex-direction:column;inline-size:3rem;inset-block-start:0;inset-inline-end:0;justify-content:center;max-inline-size:3rem;min-inline-size:3rem;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline .11s cubic-bezier(.2,0,.38,.9),background-color .11s cubic-bezier(.2,0,.38,.9)}.cds--inline-notification__close-button:focus{outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--inline-notification__close-button .cds--inline-notification__close-icon{fill:var(--cds-icon-inverse,#fff)}@media (min-width:42rem){.cds--inline-notification__close-button{position:static}}.cds--inline-notification--low-contrast .cds--inline-notification__close-button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--inline-notification--low-contrast .cds--inline-notification__close-button:focus{outline-style:dotted}}.cds--inline-notification--low-contrast .cds--inline-notification__close-button .cds--inline-notification__close-icon{fill:var(--cds-icon-primary,#161616)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--inline-notification{outline:1px solid transparent}.cds--btn.cds--btn--ghost.cds--inline-notification__action-button:focus,.cds--inline-notification__close-button:focus{color:Highlight;outline:1px solid Highlight}.cds--inline-notification .cds--inline-notification__close-icon,.cds--inline-notification .cds--inline-notification__icon{fill:ButtonText}}.cds--toast-notification.cds--toast-notification--low-contrast a:focus,:host(cds-toast-notification):host(cds-toast-notification[kind=error][low-contrast]) a:focus,:host(cds-toast-notification):host(cds-toast-notification[kind=info-square][low-contrast]) a:focus,:host(cds-toast-notification):host(cds-toast-notification[kind=info][low-contrast]) a:focus,:host(cds-toast-notification):host(cds-toast-notification[kind=success][low-contrast]) a:focus,:host(cds-toast-notification):host(cds-toast-notification[kind=warning-alt][low-contrast]) a:focus,:host(cds-toast-notification):host(cds-toast-notification[kind=warning][low-contrast]) a:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--toast-notification.cds--toast-notification--low-contrast a:focus,:host(cds-toast-notification):host(cds-toast-notification[kind=error][low-contrast]) a:focus,:host(cds-toast-notification):host(cds-toast-notification[kind=info-square][low-contrast]) a:focus,:host(cds-toast-notification):host(cds-toast-notification[kind=info][low-contrast]) a:focus,:host(cds-toast-notification):host(cds-toast-notification[kind=success][low-contrast]) a:focus,:host(cds-toast-notification):host(cds-toast-notification[kind=warning-alt][low-contrast]) a:focus,:host(cds-toast-notification):host(cds-toast-notification[kind=warning][low-contrast]) a:focus{outline-style:dotted}}.cds--toast-notification--error,:host(cds-toast-notification[kind=error]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-error-inverse,#fa4d56)}.cds--toast-notification--low-contrast.cds--toast-notification--error,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=error]),:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=error]),:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=error]),:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=error]),:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=error]),:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=error]){background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--toast-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=error]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=error]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=error]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=error]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=error]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=error]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=error]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=error]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=error]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=error]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=error]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=error]) .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}.cds--toast-notification--success,:host(cds-toast-notification[kind=success]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-success-inverse,#42be65)}.cds--toast-notification--low-contrast.cds--toast-notification--success,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=success]),:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=success]),:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=success]),:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=success]),:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=success]),:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=success]){background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--toast-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=success]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=success]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=success]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=success]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=success]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=success]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=success]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=success]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=success]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=success]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=success]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=success]) .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}.cds--toast-notification--info,.cds--toast-notification--info-square,:host(cds-toast-notification[kind=info-square]),:host(cds-toast-notification[kind=info]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-info-inverse,#4589ff)}.cds--toast-notification--low-contrast.cds--toast-notification--info,.cds--toast-notification--low-contrast.cds--toast-notification--info-square,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=info-square]),:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=info]),:host(cds-toast-notification[kind=info-square][low-contrast]),:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=info]),:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=info-square]),:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=info]),:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=info-square]),:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=info]),:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=info-square]),:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=info]){background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--toast-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--toast-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=info]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=info]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=info]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=info]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=info]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=info]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=info]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]):host(cds-toast-notification[kind=info]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=info]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=info]) .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}.cds--toast-notification--warning,.cds--toast-notification--warning-alt,:host(cds-toast-notification[kind=warning-alt]),:host(cds-toast-notification[kind=warning]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-warning-inverse,#f1c21b)}.cds--toast-notification--low-contrast.cds--toast-notification--warning,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=warning-alt]),:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=warning]),:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=warning-alt]),:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=warning]),:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=warning-alt]),:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=warning]),:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=warning-alt]),:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=warning]),:host(cds-toast-notification[kind=warning-alt][low-contrast]),:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=warning]){background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--toast-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--toast-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]):host(cds-toast-notification[kind=warning]) .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}.cds--actionable-notification{block-size:auto;color:var(--cds-text-inverse,#fff);display:flex;flex-wrap:wrap;inline-size:100%;max-inline-size:18rem;min-block-size:3rem;min-inline-size:18rem;position:relative}.cds--actionable-notification html{font-size:100%}.cds--actionable-notification body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--actionable-notification code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--actionable-notification strong{font-weight:600}@media (min-width:42rem){.cds--actionable-notification{flex-wrap:nowrap;max-inline-size:38rem}}@media (min-width:66rem){.cds--actionable-notification{max-inline-size:46rem}}@media (min-width:99rem){.cds--actionable-notification{max-inline-size:52rem}}.cds--actionable-notification--toast{box-shadow:0 2px 6px 0 rgba(0,0,0,.2);flex-wrap:wrap;max-inline-size:18rem;min-inline-size:18rem}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) a{color:var(--cds-link-inverse,#78a9ff)}.cds--actionable-notification a{text-decoration:none}.cds--actionable-notification a:hover{text-decoration:underline}.cds--actionable-notification a:focus{outline:1px solid var(--cds-focus-inverse,#fff)}.cds--actionable-notification.cds--actionable-notification--low-contrast a:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--actionable-notification.cds--actionable-notification--low-contrast a:focus{outline-style:dotted}}.cds--actionable-notification--low-contrast{color:var(--cds-text-primary,#161616)}.cds--actionable-notification--low-contrast:not(.cds--actionable-notification--toast):before{block-size:100%;border-style:solid;border-width:1px 1px 1px 0;box-sizing:border-box;content:"";filter:opacity(.4);inline-size:100%;inset-block-start:0;inset-inline-start:0;pointer-events:none;position:absolute}.cds--actionable-notification--error{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-error-inverse,#fa4d56)}.cds--actionable-notification--error .cds--actionable-notification__icon,.cds--actionable-notification--error .cds--inline-notification__icon,.cds--actionable-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error-inverse,#fa4d56)}.cds--actionable-notification--low-contrast.cds--actionable-notification--error{background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}.cds--actionable-notification--low-contrast.cds--actionable-notification--error:before{border-color:var(--cds-support-error,#da1e28)}.cds--actionable-notification--success{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-success-inverse,#42be65)}.cds--actionable-notification--success .cds--actionable-notification__icon,.cds--actionable-notification--success .cds--inline-notification__icon,.cds--actionable-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success-inverse,#42be65)}.cds--actionable-notification--low-contrast.cds--actionable-notification--success{background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}.cds--actionable-notification--low-contrast.cds--actionable-notification--success:before{border-color:var(--cds-support-success,#24a148)}.cds--actionable-notification--info,.cds--actionable-notification--info-square{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-info-inverse,#4589ff)}.cds--actionable-notification--info .cds--actionable-notification__icon,.cds--actionable-notification--info .cds--inline-notification__icon,.cds--actionable-notification--info .cds--toast-notification__icon,.cds--actionable-notification--info-square .cds--actionable-notification__icon,.cds--actionable-notification--info-square .cds--inline-notification__icon,.cds--actionable-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info-inverse,#4589ff)}.cds--actionable-notification--low-contrast.cds--actionable-notification--info,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square{background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--toast-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square:before,.cds--actionable-notification--low-contrast.cds--actionable-notification--info:before{border-color:var(--cds-support-info,#0043ce)}.cds--actionable-notification--warning,.cds--actionable-notification--warning-alt{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-warning-inverse,#f1c21b)}.cds--actionable-notification--warning .cds--actionable-notification__icon,.cds--actionable-notification--warning .cds--inline-notification__icon,.cds--actionable-notification--warning .cds--toast-notification__icon,.cds--actionable-notification--warning-alt .cds--actionable-notification__icon,.cds--actionable-notification--warning-alt .cds--inline-notification__icon,.cds--actionable-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning-inverse,#f1c21b)}.cds--actionable-notification--low-contrast.cds--actionable-notification--warning,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt{background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--toast-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt:before,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning:before{border-color:var(--cds-support-warning,#f1c21b)}.cds--actionable-notification--warning .cds--inline-notification__icon path[opacity="0"],.cds--actionable-notification--warning .cds--toast-notification__icon path[opacity="0"],.cds--actionable-notification--warning-alt .cds--inline-notification__icon path:first-of-type,.cds--actionable-notification--warning-alt .cds--toast-notification__icon path:first-of-type{fill:#000;opacity:1}.cds--actionable-notification__details{display:flex;flex-grow:1;margin-inline:.8125rem 3rem}@media (min-width:42rem){.cds--actionable-notification:not(.cds--actionable-notification--toast) .cds--actionable-notification__details{margin:0 .8125rem}}.cds--actionable-notification .cds--inline-notification__icon{flex-shrink:0;margin-block-start:.875rem;margin-inline-end:1rem}.cds--actionable-notification .cds--toast-notification__icon{flex-shrink:0;margin-block-start:1rem;margin-inline-end:1rem}.cds--actionable-notification__text-wrapper{display:flex;flex-wrap:wrap;padding:.9375rem 0}.cds--actionable-notification__button-wrapper{display:flex}.cds--actionable-notification--toast .cds--actionable-notification__text-wrapper{padding:.9375rem 0 1.4375rem}.cds--actionable-notification__content{display:flex;flex-wrap:wrap;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);word-break:break-word}.cds--actionable-notification--toast .cds--actionable-notification__content{display:block}.cds--actionable-notification__title{font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);font-weight:600;letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);margin-inline-end:.25rem;word-break:break-word}.cds--actionable-notification--toast .cds--actionable-notification__title{margin-inline-end:0}.cds--actionable-notification__subtitle{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin-block-start:0;word-break:break-word}.cds--actionable-notification--low-contrast .cds--actionable-notification__subtitle{color:var(--cds-text-primary,#161616)}.cds--actionable-notification__action-button.cds--btn--ghost{block-size:2rem;margin-block-end:.5rem;margin-inline-start:2.5rem}@media (min-width:42rem){.cds--actionable-notification__action-button.cds--btn--ghost{margin:.5rem 0}}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--ghost{color:var(--cds-link-inverse,#78a9ff)}.cds--actionable-notification__action-button.cds--btn--ghost:active,.cds--actionable-notification__action-button.cds--btn--ghost:hover{background-color:var(--cds-background-inverse-hover,#474747)}.cds--actionable-notification--low-contrast .cds--actionable-notification__action-button.cds--btn--ghost:active,.cds--actionable-notification--low-contrast .cds--actionable-notification__action-button.cds--btn--ghost:hover{background-color:var(--cds-notification-action-hover,#fff)}.cds--actionable-notification__action-button.cds--btn--ghost:focus{border-color:transparent;box-shadow:none;outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--actionable-notification--low-contrast .cds--actionable-notification__action-button.cds--btn--ghost:focus{outline-color:var(--cds-focus,#0f62fe)}.cds--actionable-notification--hide-close-button .cds--actionable-notification__action-button.cds--btn--ghost{margin-inline-end:.5rem}.cds--actionable-notification__action-button.cds--btn--tertiary{margin-block-end:1rem;margin-inline-start:3.125rem;padding-inline:1rem}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-notification-action-tertiary-inverse,#fff);border-style:solid;border-width:1px;color:var(--cds-notification-action-tertiary-inverse,#fff)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:hover{background-color:var(--cds-notification-action-tertiary-inverse-hover,#f4f4f4)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary .cds--btn__icon,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:hover{color:var(--cds-notification-action-tertiary-inverse-text,#161616)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:focus{background-color:var(--cds-notification-action-tertiary-inverse,#fff);border-color:var(--cds-focus-inverse,#fff);box-shadow:inset 0 0 0 1px var(--cds-focus-inverse,#fff),inset 0 0 0 2px var(--cds-background-inverse,#393939);color:var(--cds-notification-action-tertiary-inverse-text,#161616)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:active{background-color:var(--cds-notification-action-tertiary-inverse-active,#c6c6c6);border-color:transparent;color:var(--cds-notification-action-tertiary-inverse-text,#161616)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled:focus,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled:hover,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:disabled,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:focus:disabled,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-notification-action-tertiary-inverse-text-on-color-disabled,hsla(0,0%,100%,.25));outline:none}.cds--actionable-notification--hide-close-button .cds--actionable-notification__action-button.cds--btn--tertiary{margin-inline-end:.5rem}.cds--actionable-notification__close-button{align-items:center;background:transparent;block-size:3rem;border:none;cursor:pointer;display:flex;flex-direction:column;inline-size:3rem;inset-block-start:0;inset-inline-end:0;justify-content:center;max-inline-size:3rem;min-inline-size:3rem;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline .11s cubic-bezier(.2,0,.38,.9),background-color .11s cubic-bezier(.2,0,.38,.9)}.cds--actionable-notification__close-button:focus{outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--actionable-notification__close-button .cds--actionable-notification__close-icon{fill:var(--cds-icon-inverse,#fff)}@media (min-width:42rem){.cds--actionable-notification__close-button{position:static}.cds--actionable-notification--toast .cds--actionable-notification__close-button{position:absolute}}.cds--actionable-notification--low-contrast .cds--actionable-notification__close-button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--actionable-notification--low-contrast .cds--actionable-notification__close-button:focus{outline-style:dotted}}.cds--actionable-notification--low-contrast .cds--actionable-notification__close-button .cds--actionable-notification__close-icon{fill:var(--cds-icon-primary,#161616)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--actionable-notification{outline:1px solid transparent}.cds--actionable-notification__close-button:focus,.cds--btn.cds--btn--ghost.cds--actionable-notification__action-button:focus{color:Highlight;outline:1px solid Highlight}.cds--actionable-notification .cds--actionable-notification__close-icon,.cds--actionable-notification .cds--inline-notification__icon,.cds--actionable-notification .cds--toast-notification__icon{fill:ButtonText}}.cds--toast-notification,:host(cds-toast-notification){block-size:auto;box-shadow:0 2px 6px 0 rgba(0,0,0,.2);color:var(--cds-text-inverse,#fff);display:flex;inline-size:18rem;padding-inline-start:.8125rem}.cds--toast-notification html,:host(cds-toast-notification) html{font-size:100%}.cds--toast-notification body,:host(cds-toast-notification) body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--toast-notification code,:host(cds-toast-notification) code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--toast-notification strong,:host(cds-toast-notification) strong{font-weight:600}@media (min-width:99rem){.cds--toast-notification,:host(cds-toast-notification){inline-size:22rem}}.cds--toast-notification:not(.cds--toast-notification--low-contrast) a,:not(.cds--toast-notification--low-contrast):host(cds-toast-notification) a{color:var(--cds-link-inverse,#78a9ff)}.cds--toast-notification a,:host(cds-toast-notification) a{text-decoration:none}.cds--toast-notification a:hover,:host(cds-toast-notification) a:hover{text-decoration:underline}.cds--toast-notification a:focus,:host(cds-toast-notification) a:focus{outline:1px solid var(--cds-link-inverse,#78a9ff)}.cds--toast-notification.cds--toast-notification--low-contrast a:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--toast-notification.cds--toast-notification--low-contrast a:focus{outline-style:dotted}}.cds--toast-notification--low-contrast,:host(cds-toast-notification[kind=error][low-contrast]),:host(cds-toast-notification[kind=info-square][low-contrast]),:host(cds-toast-notification[kind=info][low-contrast]),:host(cds-toast-notification[kind=success][low-contrast]),:host(cds-toast-notification[kind=warning-alt][low-contrast]),:host(cds-toast-notification[kind=warning][low-contrast]){color:var(--cds-text-primary,#161616)}.cds--toast-notification--error,:host(cds-toast-notification[kind=error]),:host(cds-toast-notification[kind=error][low-contrast]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-error-inverse,#fa4d56)}.cds--toast-notification--error .cds--actionable-notification__icon,.cds--toast-notification--error .cds--inline-notification__icon,.cds--toast-notification--error .cds--toast-notification__icon,:host(cds-toast-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=error]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=error]) .cds--toast-notification__icon{fill:var(--cds-support-error-inverse,#fa4d56)}.cds--toast-notification--low-contrast.cds--toast-notification--error{background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}.cds--toast-notification--success,:host(cds-toast-notification[kind=success]),:host(cds-toast-notification[kind=success][low-contrast]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-success-inverse,#42be65)}.cds--toast-notification--success .cds--actionable-notification__icon,.cds--toast-notification--success .cds--inline-notification__icon,.cds--toast-notification--success .cds--toast-notification__icon,:host(cds-toast-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=success]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=success]) .cds--toast-notification__icon{fill:var(--cds-support-success-inverse,#42be65)}.cds--toast-notification--low-contrast.cds--toast-notification--success{background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}.cds--toast-notification--info,.cds--toast-notification--info-square,:host(cds-toast-notification[kind=info-square]),:host(cds-toast-notification[kind=info-square][low-contrast]),:host(cds-toast-notification[kind=info]),:host(cds-toast-notification[kind=info][low-contrast]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-info-inverse,#4589ff)}.cds--toast-notification--info .cds--actionable-notification__icon,.cds--toast-notification--info .cds--inline-notification__icon,.cds--toast-notification--info .cds--toast-notification__icon,.cds--toast-notification--info-square .cds--actionable-notification__icon,.cds--toast-notification--info-square .cds--inline-notification__icon,.cds--toast-notification--info-square .cds--toast-notification__icon,:host(cds-toast-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info]) .cds--toast-notification__icon{fill:var(--cds-support-info-inverse,#4589ff)}.cds--toast-notification--low-contrast.cds--toast-notification--info,.cds--toast-notification--low-contrast.cds--toast-notification--info-square{background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--toast-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}.cds--toast-notification--warning,.cds--toast-notification--warning-alt,:host(cds-toast-notification[kind=warning-alt]),:host(cds-toast-notification[kind=warning-alt][low-contrast]),:host(cds-toast-notification[kind=warning]),:host(cds-toast-notification[kind=warning][low-contrast]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-warning-inverse,#f1c21b)}.cds--toast-notification--warning .cds--actionable-notification__icon,.cds--toast-notification--warning .cds--inline-notification__icon,.cds--toast-notification--warning .cds--toast-notification__icon,.cds--toast-notification--warning-alt .cds--actionable-notification__icon,.cds--toast-notification--warning-alt .cds--inline-notification__icon,.cds--toast-notification--warning-alt .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning]) .cds--toast-notification__icon{fill:var(--cds-support-warning-inverse,#f1c21b)}.cds--toast-notification--low-contrast.cds--toast-notification--warning,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt{background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--toast-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}.cds--toast-notification--warning .cds--toast-notification__icon path[opacity="0"],.cds--toast-notification--warning-alt .cds--toast-notification__icon path:first-of-type,:host(cds-toast-notification[kind=warning-alt]) .cds--toast-notification__icon path:first-of-type,:host(cds-toast-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__icon path[opacity="0"],:host(cds-toast-notification[kind=warning]) .cds--toast-notification__icon path[opacity="0"]{fill:#000;opacity:1}.cds--toast-notification__icon{flex-shrink:0;margin-block-start:1rem;margin-inline-end:1rem}.cds--toast-notification__details{margin-block-end:1rem;margin-inline-end:1rem}.cds--toast-notification__close-button{align-items:center;background-color:transparent;block-size:3rem;border:none;cursor:pointer;display:flex;flex-direction:column;inline-size:3rem;justify-content:center;margin-inline-start:auto;min-block-size:3rem;min-inline-size:3rem;outline:2px solid transparent;outline-offset:-2px;padding:0;transition:outline .25s,background-color .25s}.cds--toast-notification__close-button:focus{outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--toast-notification__close-button .cds--toast-notification__close-icon{fill:var(--cds-icon-inverse,#fff)}.cds--toast-notification--low-contrast .cds--toast-notification__close-button:focus,:host(cds-toast-notification[kind=error][low-contrast]) .cds--toast-notification__close-button:focus,:host(cds-toast-notification[kind=info-square][low-contrast]) .cds--toast-notification__close-button:focus,:host(cds-toast-notification[kind=info][low-contrast]) .cds--toast-notification__close-button:focus,:host(cds-toast-notification[kind=success][low-contrast]) .cds--toast-notification__close-button:focus,:host(cds-toast-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__close-button:focus,:host(cds-toast-notification[kind=warning][low-contrast]) .cds--toast-notification__close-button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--toast-notification--low-contrast .cds--toast-notification__close-button:focus,:host(cds-toast-notification[kind=error][low-contrast]) .cds--toast-notification__close-button:focus,:host(cds-toast-notification[kind=info-square][low-contrast]) .cds--toast-notification__close-button:focus,:host(cds-toast-notification[kind=info][low-contrast]) .cds--toast-notification__close-button:focus,:host(cds-toast-notification[kind=success][low-contrast]) .cds--toast-notification__close-button:focus,:host(cds-toast-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__close-button:focus,:host(cds-toast-notification[kind=warning][low-contrast]) .cds--toast-notification__close-button:focus{outline-style:dotted}}.cds--toast-notification--low-contrast .cds--toast-notification__close-button .cds--toast-notification__close-icon,:host(cds-toast-notification[kind=error][low-contrast]) .cds--toast-notification__close-button .cds--toast-notification__close-icon,:host(cds-toast-notification[kind=info-square][low-contrast]) .cds--toast-notification__close-button .cds--toast-notification__close-icon,:host(cds-toast-notification[kind=info][low-contrast]) .cds--toast-notification__close-button .cds--toast-notification__close-icon,:host(cds-toast-notification[kind=success][low-contrast]) .cds--toast-notification__close-button .cds--toast-notification__close-icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__close-button .cds--toast-notification__close-icon,:host(cds-toast-notification[kind=warning][low-contrast]) .cds--toast-notification__close-button .cds--toast-notification__close-icon{fill:var(--cds-icon-primary,#161616)}.cds--toast-notification__title{font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);font-weight:600;letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);margin-block-start:1rem;word-break:break-word}.cds--toast-notification__subtitle{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin-block:0 1rem;word-break:break-word}.cds--toast-notification--low-contrast .cds--toast-notification__subtitle,:host(cds-toast-notification[kind=error][low-contrast]) .cds--toast-notification__subtitle,:host(cds-toast-notification[kind=info-square][low-contrast]) .cds--toast-notification__subtitle,:host(cds-toast-notification[kind=info][low-contrast]) .cds--toast-notification__subtitle,:host(cds-toast-notification[kind=success][low-contrast]) .cds--toast-notification__subtitle,:host(cds-toast-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__subtitle,:host(cds-toast-notification[kind=warning][low-contrast]) .cds--toast-notification__subtitle{color:var(--cds-text-primary,#161616)}.cds--toast-notification__caption{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);padding-block-start:.5rem}.cds--toast-notification--low-contrast .cds--toast-notification__caption,:host(cds-toast-notification[kind=error][low-contrast]) .cds--toast-notification__caption,:host(cds-toast-notification[kind=info-square][low-contrast]) .cds--toast-notification__caption,:host(cds-toast-notification[kind=info][low-contrast]) .cds--toast-notification__caption,:host(cds-toast-notification[kind=success][low-contrast]) .cds--toast-notification__caption,:host(cds-toast-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__caption,:host(cds-toast-notification[kind=warning][low-contrast]) .cds--toast-notification__caption{color:var(--cds-text-primary,#161616)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--toast-notification,:host(cds-toast-notification){outline:1px solid transparent}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--toast-notification__close-button:focus{color:Highlight;outline:1px solid Highlight}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--toast-notification .cds--toast-notification__close-icon,:host(cds-toast-notification) .cds--toast-notification__close-icon{fill:ButtonText}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--toast-notification .cds--toast-notification__icon,:host(cds-toast-notification) .cds--toast-notification__icon{fill:ButtonText}}:host(cds-toast-notification){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;display:none;outline:none}:host(cds-toast-notification[open]){display:flex}:host(cds-toast-notification[hide-close-button]) .cds--toast-notification__close-button{display:none}:host(cds-toast-notification[kind=success][low-contrast]){background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}:host(cds-toast-notification[kind=success][low-contrast]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=success][low-contrast]) .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}:host(cds-toast-notification[kind=info-square][low-contrast]),:host(cds-toast-notification[kind=info][low-contrast]){background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}:host(cds-toast-notification[kind=info-square][low-contrast]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info-square][low-contrast]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=info][low-contrast]) .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}:host(cds-toast-notification[kind=warning-alt]) .cds--toast-notification__icon path[data-icon-path=inner-path]{fill:#000}:host(cds-toast-notification[kind=warning-alt][low-contrast]),:host(cds-toast-notification[kind=warning][low-contrast]){background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}:host(cds-toast-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=warning][low-contrast]) .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}:host(cds-toast-notification[kind=error][low-contrast]){background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}:host(cds-toast-notification[kind=error][low-contrast]) .cds--actionable-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]) .cds--inline-notification__icon,:host(cds-toast-notification[kind=error][low-contrast]) .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lwHhz":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSActionableNotification$1);
var _tslib = require("tslib");
var _20Js = require("../../icons/checkmark--filled/20.js");
var _20JsDefault = parcelHelpers.interopDefault(_20Js);
var _20Js1 = require("../../icons/error--filled/20.js");
var _20JsDefault1 = parcelHelpers.interopDefault(_20Js1);
var _20Js2 = require("../../icons/information--filled/20.js");
var _20JsDefault2 = parcelHelpers.interopDefault(_20Js2);
var _20Js3 = require("../../icons/information--square--filled/20.js");
var _20JsDefault3 = parcelHelpers.interopDefault(_20Js3);
var _20Js4 = require("../../icons/warning--filled/20.js");
var _20JsDefault4 = parcelHelpers.interopDefault(_20Js4);
var _20Js5 = require("../../icons/warning--alt--filled/20.js");
var _20JsDefault5 = parcelHelpers.interopDefault(_20Js5);
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("./defs.js");
var _inlineNotificationJs = require("./inline-notification.js");
var _inlineNotificationJsDefault = parcelHelpers.interopDefault(_inlineNotificationJs);
var _actionableNotificationScssJs = require("./actionable-notification.scss.js");
var _actionableNotificationScssJsDefault = parcelHelpers.interopDefault(_actionableNotificationScssJs);
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
/**
 * The default icons, keyed by notification kind.
 */ const iconsForKinds = {
    [(0, _defsJs.NOTIFICATION_KIND).SUCCESS]: (0, _20JsDefault.default),
    [(0, _defsJs.NOTIFICATION_KIND).INFO]: (0, _20JsDefault2.default),
    [(0, _defsJs.NOTIFICATION_KIND).INFO_SQUARE]: (0, _20JsDefault3.default),
    [(0, _defsJs.NOTIFICATION_KIND).WARNING]: (0, _20JsDefault4.default),
    [(0, _defsJs.NOTIFICATION_KIND).WARNING_ALT]: (0, _20JsDefault5.default),
    [(0, _defsJs.NOTIFICATION_KIND).ERROR]: (0, _20JsDefault1.default)
};
/**
 * Actionable notification.
 *
 * @element cds-actionable-notification
 * @slot subtitle - The subtitle.
 * @slot title - The title.
 * @fires cds-notification-beingclosed
 *   The custom event fired before this notification is being closed upon a user gesture.
 *   Cancellation of this event stops the user-initiated action of closing this notification.
 * @fires cds-notification-closed - The custom event fired after this notification is closed upon a user gesture.
 */ let CDSActionableNotification = class CDSActionableNotification extends (0, _hostListenerJsDefault1.default)((0, _inlineNotificationJsDefault.default)) {
    constructor(){
        super(...arguments);
        this._type = (0, _defsJs.NOTIFICATION_TYPE).ACTIONABLE;
        /**
         * Inline notification type.
         */ this.inline = false;
        /**
         * Pass in the action button label that will be rendered within the ActionableNotification.
         */ this.actionButtonLabel = "";
        /**
         * Specify if pressing the escape key should close notifications
         */ this.closeOnEscape = true;
        /**
         * Specify if focus should be moved to the component when the notification contains actions
         */ this.hasFocus = true;
        /**
         * Handles `keydown` event on this event.
         * Escape will close the notification if `closeOnEscape` is true
         */ this._handleKeyDown = async (event)=>{
            const { key } = event;
            if (this.closeOnEscape && key === "Escape") this.open = false;
        };
        /**
         * The caption.
         */ this.caption = "";
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "alertdialog");
        super.connectedCallback();
    }
    _renderIcon() {
        const { statusIconDescription, kind, inline } = this;
        const { [kind]: icon } = iconsForKinds;
        return !icon ? undefined : icon({
            class: `${(0, _settingsJs.prefix)}--${inline ? "inline" : "toast"}-notification__icon`,
            children: !statusIconDescription ? undefined : (0, _lit.svg)`<title>${statusIconDescription}</title>`
        });
    }
    _renderText() {
        const { subtitle, title, _type: type } = this;
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--${type}-notification__text-wrapper">
        <div class="${0, _settingsJs.prefix}--${type}-notification__content">
          <div class="${0, _settingsJs.prefix}--${type}-notification__title">
            ${title}<slot name="title"></slot>
          </div>
          <div class="${0, _settingsJs.prefix}--${type}-notification__subtitle">
            ${subtitle}<slot name="subtitle"></slot>
          </div>
          <slot></slot>
        </div>
      </div>
    `;
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        const button = this.querySelector(this.constructor.selectorActionButton);
        if (changedProperties.has("inline")) button === null || button === void 0 || button.setAttribute("kind", this.inline ? "ghost" : "tertiary");
        if (changedProperties.has("lowContrast")) {
            if (this.lowContrast) button === null || button === void 0 || button.setAttribute("low-contrast", "true");
            else button === null || button === void 0 || button.removeAttribute("low-contrast");
        }
        if (changedProperties.has("hideCloseButton")) {
            if (this.hideCloseButton) button === null || button === void 0 || button.setAttribute("hide-close-button", "true");
            else button === null || button === void 0 || button.removeAttribute("hide-close-button");
        }
        if (changedProperties.has("hasFocus")) {
            if (this.hasFocus) this.focus();
        }
    }
    render() {
        const { _type: type } = this;
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--${type}-notification__details">
        ${this._renderIcon()} ${this._renderText()}
      </div>
      <slot name="action"></slot>
      ${this._renderButton()}
    `;
    }
    /**
     * A selector that will return the action button element
     */ static get selectorActionButton() {
        return `${0, _settingsJs.prefix}-actionable-notification-button`;
    }
};
CDSActionableNotification.styles = (0, _actionableNotificationScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSActionableNotification.prototype, "inline", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        reflect: true,
        attribute: "action-button-label"
    })
], CDSActionableNotification.prototype, "actionButtonLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "close-on-escape"
    })
], CDSActionableNotification.prototype, "closeOnEscape", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "has-focus"
    })
], CDSActionableNotification.prototype, "hasFocus", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("keydown")
], CDSActionableNotification.prototype, "_handleKeyDown", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSActionableNotification.prototype, "caption", void 0);
CDSActionableNotification = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-actionable-notification`)
], CDSActionableNotification);
var CDSActionableNotification$1 = CDSActionableNotification;

},{"tslib":"gBS4y","../../icons/checkmark--filled/20.js":"gQAfV","../../icons/error--filled/20.js":"4GThk","../../icons/information--filled/20.js":"ggsPm","../../icons/information--square--filled/20.js":"2jqak","../../icons/warning--filled/20.js":"hJU0G","../../icons/warning--alt--filled/20.js":"bXVtQ","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","./defs.js":"4N5Fz","./inline-notification.js":"jElO5","./actionable-notification.scss.js":"i8Ckp","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/host-listener.js":"1SMUX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i8Ckp":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--inline-notification{block-size:auto;color:var(--cds-text-inverse,#fff);display:flex;flex-wrap:wrap;inline-size:100%;max-inline-size:18rem;min-block-size:3rem;min-inline-size:18rem;position:relative}.cds--inline-notification html{font-size:100%}.cds--inline-notification body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--inline-notification code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--inline-notification strong{font-weight:600}@media (min-width:42rem){.cds--inline-notification{flex-wrap:nowrap;max-inline-size:38rem}}@media (min-width:66rem){.cds--inline-notification{max-inline-size:46rem}}@media (min-width:99rem){.cds--inline-notification{max-inline-size:52rem}}.cds--inline-notification:not(.cds--inline-notification--low-contrast) a{color:var(--cds-link-inverse,#78a9ff)}.cds--inline-notification a{text-decoration:none}.cds--inline-notification a:hover{text-decoration:underline}.cds--inline-notification a:focus{outline:1px solid var(--cds-link-inverse,#78a9ff)}.cds--inline-notification.cds--inline-notification--low-contrast a:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--inline-notification.cds--inline-notification--low-contrast a:focus{outline-style:dotted}}.cds--inline-notification--low-contrast{color:var(--cds-text-primary,#161616)}.cds--inline-notification--low-contrast:before{block-size:100%;border-style:solid;border-width:1px 1px 1px 0;box-sizing:border-box;content:"";filter:opacity(.4);inline-size:100%;inset-block-start:0;inset-inline-start:0;pointer-events:none;position:absolute}.cds--inline-notification--error{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-error-inverse,#fa4d56)}.cds--inline-notification--error .cds--actionable-notification__icon,.cds--inline-notification--error .cds--inline-notification__icon,.cds--inline-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error-inverse,#fa4d56)}.cds--inline-notification--low-contrast.cds--inline-notification--error{background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}.cds--inline-notification--low-contrast.cds--inline-notification--error:before{border-color:var(--cds-support-error,#da1e28)}.cds--inline-notification--success{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-success-inverse,#42be65)}.cds--inline-notification--success .cds--actionable-notification__icon,.cds--inline-notification--success .cds--inline-notification__icon,.cds--inline-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success-inverse,#42be65)}.cds--inline-notification--low-contrast.cds--inline-notification--success{background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}.cds--inline-notification--low-contrast.cds--inline-notification--success:before{border-color:var(--cds-support-success,#24a148)}.cds--inline-notification--info,.cds--inline-notification--info-square{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-info-inverse,#4589ff)}.cds--inline-notification--info .cds--actionable-notification__icon,.cds--inline-notification--info .cds--inline-notification__icon,.cds--inline-notification--info .cds--toast-notification__icon,.cds--inline-notification--info-square .cds--actionable-notification__icon,.cds--inline-notification--info-square .cds--inline-notification__icon,.cds--inline-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info-inverse,#4589ff)}.cds--inline-notification--low-contrast.cds--inline-notification--info,.cds--inline-notification--low-contrast.cds--inline-notification--info-square{background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--toast-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}.cds--inline-notification--low-contrast.cds--inline-notification--info-square:before,.cds--inline-notification--low-contrast.cds--inline-notification--info:before{border-color:var(--cds-support-info,#0043ce)}.cds--inline-notification--warning,.cds--inline-notification--warning-alt{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-warning-inverse,#f1c21b)}.cds--inline-notification--warning .cds--actionable-notification__icon,.cds--inline-notification--warning .cds--inline-notification__icon,.cds--inline-notification--warning .cds--toast-notification__icon,.cds--inline-notification--warning-alt .cds--actionable-notification__icon,.cds--inline-notification--warning-alt .cds--inline-notification__icon,.cds--inline-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning-inverse,#f1c21b)}.cds--inline-notification--low-contrast.cds--inline-notification--warning,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt{background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--toast-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--actionable-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--inline-notification__icon,.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt:before,.cds--inline-notification--low-contrast.cds--inline-notification--warning:before{border-color:var(--cds-support-warning,#f1c21b)}.cds--inline-notification--warning .cds--inline-notification__icon path[opacity="0"],.cds--inline-notification--warning-alt .cds--inline-notification__icon path:first-of-type{fill:#000;opacity:1}.cds--inline-notification__details{display:flex;flex-grow:1;margin-inline:.8125rem 3rem}@media (min-width:42rem){.cds--inline-notification__details{margin:0 .8125rem}}.cds--inline-notification__icon{flex-shrink:0;margin-block-start:.875rem;margin-inline-end:1rem}.cds--inline-notification__text-wrapper{display:flex;flex-wrap:wrap;padding:.9375rem 0}.cds--inline-notification__title{font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);margin-inline-end:.25rem}.cds--inline-notification__subtitle{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);word-break:break-word}.cds--inline-notification__action-button.cds--btn--ghost{block-size:2rem;margin-block-end:.5rem;margin-inline-start:2.5rem}@media (min-width:42rem){.cds--inline-notification__action-button.cds--btn--ghost{margin:.5rem 0}}.cds--inline-notification:not(.cds--inline-notification--low-contrast) .cds--inline-notification__action-button.cds--btn--ghost{color:var(--cds-link-inverse,#78a9ff)}.cds--inline-notification__action-button.cds--btn--ghost:active,.cds--inline-notification__action-button.cds--btn--ghost:hover{background-color:var(--cds-background-inverse-hover,#474747)}.cds--inline-notification--low-contrast .cds--inline-notification__action-button.cds--btn--ghost:active,.cds--inline-notification--low-contrast .cds--inline-notification__action-button.cds--btn--ghost:hover{background-color:var(--cds-notification-action-hover,#fff)}.cds--inline-notification__action-button.cds--btn--ghost:focus{border-color:transparent;box-shadow:none;outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--inline-notification--low-contrast .cds--inline-notification__action-button.cds--btn--ghost:focus{outline-color:var(--cds-focus,#0f62fe)}.cds--inline-notification--hide-close-button .cds--inline-notification__action-button.cds--btn--ghost{margin-inline-end:.5rem}.cds--inline-notification__close-button{align-items:center;background:transparent;block-size:3rem;border:none;cursor:pointer;display:flex;flex-direction:column;inline-size:3rem;inset-block-start:0;inset-inline-end:0;justify-content:center;max-inline-size:3rem;min-inline-size:3rem;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline .11s cubic-bezier(.2,0,.38,.9),background-color .11s cubic-bezier(.2,0,.38,.9)}.cds--inline-notification__close-button:focus{outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--inline-notification__close-button .cds--inline-notification__close-icon{fill:var(--cds-icon-inverse,#fff)}@media (min-width:42rem){.cds--inline-notification__close-button{position:static}}.cds--inline-notification--low-contrast .cds--inline-notification__close-button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--inline-notification--low-contrast .cds--inline-notification__close-button:focus{outline-style:dotted}}.cds--inline-notification--low-contrast .cds--inline-notification__close-button .cds--inline-notification__close-icon{fill:var(--cds-icon-primary,#161616)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--inline-notification{outline:1px solid transparent}.cds--btn.cds--btn--ghost.cds--inline-notification__action-button:focus,.cds--inline-notification__close-button:focus{color:Highlight;outline:1px solid Highlight}.cds--inline-notification .cds--inline-notification__close-icon,.cds--inline-notification .cds--inline-notification__icon{fill:ButtonText}}.cds--toast-notification{block-size:auto;box-shadow:0 2px 6px 0 rgba(0,0,0,.2);color:var(--cds-text-inverse,#fff);display:flex;inline-size:18rem;padding-inline-start:.8125rem}.cds--toast-notification html{font-size:100%}.cds--toast-notification body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--toast-notification code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--toast-notification strong{font-weight:600}@media (min-width:99rem){.cds--toast-notification{inline-size:22rem}}.cds--toast-notification:not(.cds--toast-notification--low-contrast) a{color:var(--cds-link-inverse,#78a9ff)}.cds--toast-notification a{text-decoration:none}.cds--toast-notification a:hover{text-decoration:underline}.cds--toast-notification a:focus{outline:1px solid var(--cds-link-inverse,#78a9ff)}.cds--toast-notification.cds--toast-notification--low-contrast a:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--toast-notification.cds--toast-notification--low-contrast a:focus{outline-style:dotted}}.cds--toast-notification--low-contrast{color:var(--cds-text-primary,#161616)}.cds--toast-notification--error{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-error-inverse,#fa4d56)}.cds--toast-notification--error .cds--actionable-notification__icon,.cds--toast-notification--error .cds--inline-notification__icon,.cds--toast-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error-inverse,#fa4d56)}.cds--toast-notification--low-contrast.cds--toast-notification--error{background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}.cds--toast-notification--success{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-success-inverse,#42be65)}.cds--toast-notification--success .cds--actionable-notification__icon,.cds--toast-notification--success .cds--inline-notification__icon,.cds--toast-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success-inverse,#42be65)}.cds--toast-notification--low-contrast.cds--toast-notification--success{background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}.cds--toast-notification--info,.cds--toast-notification--info-square{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-info-inverse,#4589ff)}.cds--toast-notification--info .cds--actionable-notification__icon,.cds--toast-notification--info .cds--inline-notification__icon,.cds--toast-notification--info .cds--toast-notification__icon,.cds--toast-notification--info-square .cds--actionable-notification__icon,.cds--toast-notification--info-square .cds--inline-notification__icon,.cds--toast-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info-inverse,#4589ff)}.cds--toast-notification--low-contrast.cds--toast-notification--info,.cds--toast-notification--low-contrast.cds--toast-notification--info-square{background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--toast-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}.cds--toast-notification--warning,.cds--toast-notification--warning-alt{background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-warning-inverse,#f1c21b)}.cds--toast-notification--warning .cds--actionable-notification__icon,.cds--toast-notification--warning .cds--inline-notification__icon,.cds--toast-notification--warning .cds--toast-notification__icon,.cds--toast-notification--warning-alt .cds--actionable-notification__icon,.cds--toast-notification--warning-alt .cds--inline-notification__icon,.cds--toast-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning-inverse,#f1c21b)}.cds--toast-notification--low-contrast.cds--toast-notification--warning,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt{background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--toast-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--actionable-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--inline-notification__icon,.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}.cds--toast-notification--warning .cds--toast-notification__icon path[opacity="0"],.cds--toast-notification--warning-alt .cds--toast-notification__icon path:first-of-type{fill:#000;opacity:1}.cds--toast-notification__icon{flex-shrink:0;margin-block-start:1rem;margin-inline-end:1rem}.cds--toast-notification__details{margin-block-end:1rem;margin-inline-end:1rem}.cds--toast-notification__close-button{align-items:center;background-color:transparent;block-size:3rem;border:none;cursor:pointer;display:flex;flex-direction:column;inline-size:3rem;justify-content:center;margin-inline-start:auto;min-block-size:3rem;min-inline-size:3rem;outline:2px solid transparent;outline-offset:-2px;padding:0;transition:outline .25s,background-color .25s}.cds--toast-notification__close-button:focus{outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--toast-notification__close-button .cds--toast-notification__close-icon{fill:var(--cds-icon-inverse,#fff)}.cds--toast-notification--low-contrast .cds--toast-notification__close-button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--toast-notification--low-contrast .cds--toast-notification__close-button:focus{outline-style:dotted}}.cds--toast-notification--low-contrast .cds--toast-notification__close-button .cds--toast-notification__close-icon{fill:var(--cds-icon-primary,#161616)}.cds--toast-notification__title{font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);font-weight:600;letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);margin-block-start:1rem;word-break:break-word}.cds--toast-notification__subtitle{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin-block:0 1rem;word-break:break-word}.cds--toast-notification--low-contrast .cds--toast-notification__subtitle{color:var(--cds-text-primary,#161616)}.cds--toast-notification__caption{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);padding-block-start:.5rem}.cds--toast-notification--low-contrast .cds--toast-notification__caption{color:var(--cds-text-primary,#161616)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--toast-notification{outline:1px solid transparent}.cds--toast-notification__close-button:focus{color:Highlight;outline:1px solid Highlight}.cds--toast-notification .cds--toast-notification__close-icon,.cds--toast-notification .cds--toast-notification__icon{fill:ButtonText}}.cds--actionable-notification.cds--actionable-notification--low-contrast a:focus,:host(cds-actionable-notification):host(cds-actionable-notification[kind=error][low-contrast]) a:focus,:host(cds-actionable-notification):host(cds-actionable-notification[kind=info-square][low-contrast]) a:focus,:host(cds-actionable-notification):host(cds-actionable-notification[kind=info][low-contrast]) a:focus,:host(cds-actionable-notification):host(cds-actionable-notification[kind=success][low-contrast]) a:focus,:host(cds-actionable-notification):host(cds-actionable-notification[kind=warning-alt][low-contrast]) a:focus,:host(cds-actionable-notification):host(cds-actionable-notification[kind=warning][low-contrast]) a:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--actionable-notification.cds--actionable-notification--low-contrast a:focus,:host(cds-actionable-notification):host(cds-actionable-notification[kind=error][low-contrast]) a:focus,:host(cds-actionable-notification):host(cds-actionable-notification[kind=info-square][low-contrast]) a:focus,:host(cds-actionable-notification):host(cds-actionable-notification[kind=info][low-contrast]) a:focus,:host(cds-actionable-notification):host(cds-actionable-notification[kind=success][low-contrast]) a:focus,:host(cds-actionable-notification):host(cds-actionable-notification[kind=warning-alt][low-contrast]) a:focus,:host(cds-actionable-notification):host(cds-actionable-notification[kind=warning][low-contrast]) a:focus{outline-style:dotted}}.cds--actionable-notification--error,:host(cds-actionable-notification[kind=error]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-error-inverse,#fa4d56)}.cds--actionable-notification--low-contrast.cds--actionable-notification--error,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=error]),:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=error]),:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=error]),:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=error]),:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=error]),:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=error]){background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--toast-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=error]) .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}.cds--actionable-notification--success,:host(cds-actionable-notification[kind=success]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-success-inverse,#42be65)}.cds--actionable-notification--low-contrast.cds--actionable-notification--success,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=success]),:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=success]),:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=success]),:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=success]),:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=success]),:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=success]){background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--toast-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=success]) .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}.cds--actionable-notification--info,.cds--actionable-notification--info-square,:host(cds-actionable-notification[kind=info-square]),:host(cds-actionable-notification[kind=info]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-info-inverse,#4589ff)}.cds--actionable-notification--low-contrast.cds--actionable-notification--info,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=info-square]),:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=info]),:host(cds-actionable-notification[kind=info-square][low-contrast]),:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=info]),:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=info-square]),:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=info]),:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=info-square]),:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=info]),:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=info-square]),:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=info]){background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--toast-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--toast-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=info]) .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}.cds--actionable-notification--warning,.cds--actionable-notification--warning-alt,:host(cds-actionable-notification[kind=warning-alt]),:host(cds-actionable-notification[kind=warning]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-warning-inverse,#f1c21b)}.cds--actionable-notification--low-contrast.cds--actionable-notification--warning,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=warning-alt]),:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=warning]),:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=warning-alt]),:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=warning]),:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=warning-alt]),:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=warning]),:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=warning-alt]),:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=warning]),:host(cds-actionable-notification[kind=warning-alt][low-contrast]),:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=warning]){background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--toast-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--toast-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]):host(cds-actionable-notification[kind=warning]) .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}.cds--actionable-notification,:host(cds-actionable-notification){block-size:auto;color:var(--cds-text-inverse,#fff);display:flex;flex-wrap:wrap;inline-size:100%;max-inline-size:18rem;min-block-size:3rem;min-inline-size:18rem;position:relative}.cds--actionable-notification html,:host(cds-actionable-notification) html{font-size:100%}.cds--actionable-notification body,:host(cds-actionable-notification) body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--actionable-notification code,:host(cds-actionable-notification) code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--actionable-notification strong,:host(cds-actionable-notification) strong{font-weight:600}@media (min-width:42rem){.cds--actionable-notification,:host(cds-actionable-notification){flex-wrap:nowrap;max-inline-size:38rem}}@media (min-width:66rem){.cds--actionable-notification,:host(cds-actionable-notification){max-inline-size:46rem}}@media (min-width:99rem){.cds--actionable-notification,:host(cds-actionable-notification){max-inline-size:52rem}}.cds--actionable-notification--toast,:host(cds-actionable-notification:not([inline])){box-shadow:0 2px 6px 0 rgba(0,0,0,.2);flex-wrap:wrap;max-inline-size:18rem;min-inline-size:18rem}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) a,:not(.cds--actionable-notification--low-contrast):host(cds-actionable-notification) a{color:var(--cds-link-inverse,#78a9ff)}.cds--actionable-notification a,:host(cds-actionable-notification) a{text-decoration:none}.cds--actionable-notification a:hover,:host(cds-actionable-notification) a:hover{text-decoration:underline}.cds--actionable-notification a:focus,:host(cds-actionable-notification) a:focus{outline:1px solid var(--cds-focus-inverse,#fff)}.cds--actionable-notification.cds--actionable-notification--low-contrast a:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--actionable-notification.cds--actionable-notification--low-contrast a:focus{outline-style:dotted}}.cds--actionable-notification--low-contrast,:host(cds-actionable-notification[kind=error][low-contrast]),:host(cds-actionable-notification[kind=info-square][low-contrast]),:host(cds-actionable-notification[kind=info][low-contrast]),:host(cds-actionable-notification[kind=success][low-contrast]),:host(cds-actionable-notification[kind=warning-alt][low-contrast]),:host(cds-actionable-notification[kind=warning][low-contrast]){color:var(--cds-text-primary,#161616)}.cds--actionable-notification--low-contrast:not(.cds--actionable-notification--toast):before{block-size:100%;border-style:solid;border-width:1px 1px 1px 0;box-sizing:border-box;content:"";filter:opacity(.4);inline-size:100%;inset-block-start:0;inset-inline-start:0;pointer-events:none;position:absolute}.cds--actionable-notification--error,:host(cds-actionable-notification[kind=error]),:host(cds-actionable-notification[kind=error][low-contrast]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-error-inverse,#fa4d56)}.cds--actionable-notification--error .cds--actionable-notification__icon,.cds--actionable-notification--error .cds--inline-notification__icon,.cds--actionable-notification--error .cds--toast-notification__icon,:host(cds-actionable-notification[kind=error]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=error]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=error]) .cds--toast-notification__icon{fill:var(--cds-support-error-inverse,#fa4d56)}.cds--actionable-notification--low-contrast.cds--actionable-notification--error{background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}.cds--actionable-notification--low-contrast.cds--actionable-notification--error:before{border-color:var(--cds-support-error,#da1e28)}.cds--actionable-notification--success,:host(cds-actionable-notification[kind=success]),:host(cds-actionable-notification[kind=success][low-contrast]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-success-inverse,#42be65)}.cds--actionable-notification--success .cds--actionable-notification__icon,.cds--actionable-notification--success .cds--inline-notification__icon,.cds--actionable-notification--success .cds--toast-notification__icon,:host(cds-actionable-notification[kind=success]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=success]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=success]) .cds--toast-notification__icon{fill:var(--cds-support-success-inverse,#42be65)}.cds--actionable-notification--low-contrast.cds--actionable-notification--success{background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}.cds--actionable-notification--low-contrast.cds--actionable-notification--success:before{border-color:var(--cds-support-success,#24a148)}.cds--actionable-notification--info,.cds--actionable-notification--info-square,:host(cds-actionable-notification[kind=info-square]),:host(cds-actionable-notification[kind=info-square][low-contrast]),:host(cds-actionable-notification[kind=info]),:host(cds-actionable-notification[kind=info][low-contrast]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-info-inverse,#4589ff)}.cds--actionable-notification--info .cds--actionable-notification__icon,.cds--actionable-notification--info .cds--inline-notification__icon,.cds--actionable-notification--info .cds--toast-notification__icon,.cds--actionable-notification--info-square .cds--actionable-notification__icon,.cds--actionable-notification--info-square .cds--inline-notification__icon,.cds--actionable-notification--info-square .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info-square]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info-square]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info-square]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info]) .cds--toast-notification__icon{fill:var(--cds-support-info-inverse,#4589ff)}.cds--actionable-notification--low-contrast.cds--actionable-notification--info,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square{background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--toast-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square:before,.cds--actionable-notification--low-contrast.cds--actionable-notification--info:before{border-color:var(--cds-support-info,#0043ce)}.cds--actionable-notification--warning,.cds--actionable-notification--warning-alt,:host(cds-actionable-notification[kind=warning-alt]),:host(cds-actionable-notification[kind=warning-alt][low-contrast]),:host(cds-actionable-notification[kind=warning]),:host(cds-actionable-notification[kind=warning][low-contrast]){background:var(--cds-background-inverse,#393939);border-inline-start:3px solid var(--cds-support-warning-inverse,#f1c21b)}.cds--actionable-notification--warning .cds--actionable-notification__icon,.cds--actionable-notification--warning .cds--inline-notification__icon,.cds--actionable-notification--warning .cds--toast-notification__icon,.cds--actionable-notification--warning-alt .cds--actionable-notification__icon,.cds--actionable-notification--warning-alt .cds--inline-notification__icon,.cds--actionable-notification--warning-alt .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning-alt]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning-alt]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning-alt]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning]) .cds--toast-notification__icon{fill:var(--cds-support-warning-inverse,#f1c21b)}.cds--actionable-notification--low-contrast.cds--actionable-notification--warning,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt{background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--toast-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--actionable-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--inline-notification__icon,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt:before,.cds--actionable-notification--low-contrast.cds--actionable-notification--warning:before{border-color:var(--cds-support-warning,#f1c21b)}.cds--actionable-notification--warning .cds--toast-notification__icon path[opacity="0"],.cds--actionable-notification--warning-alt .cds--toast-notification__icon path:first-of-type,:host(cds-actionable-notification[kind=warning-alt]) .cds--toast-notification__icon path:first-of-type,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__icon path[opacity="0"],:host(cds-actionable-notification[kind=warning]) .cds--toast-notification__icon path[opacity="0"]{fill:#000;opacity:1}.cds--actionable-notification--warning .cds--inline-notification__icon path[opacity="0"],.cds--actionable-notification--warning-alt .cds--inline-notification__icon path:first-of-type,:host(cds-actionable-notification[kind=warning-alt]) .cds--inline-notification__icon path:first-of-type,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__icon path[opacity="0"],:host(cds-actionable-notification[kind=warning]) .cds--inline-notification__icon path[opacity="0"]{fill:#000;opacity:1}.cds--actionable-notification__details{display:flex;flex-grow:1;margin-inline:.8125rem 3rem}@media (min-width:42rem){.cds--actionable-notification:not(.cds--actionable-notification--toast) .cds--actionable-notification__details,:not(.cds--actionable-notification--toast):host(cds-actionable-notification) .cds--actionable-notification__details{margin:0 .8125rem}}.cds--actionable-notification .cds--inline-notification__icon,:host(cds-actionable-notification) .cds--inline-notification__icon{flex-shrink:0;margin-block-start:.875rem;margin-inline-end:1rem}.cds--actionable-notification .cds--toast-notification__icon,:host(cds-actionable-notification) .cds--toast-notification__icon{flex-shrink:0;margin-block-start:1rem;margin-inline-end:1rem}.cds--actionable-notification__text-wrapper{display:flex;flex-wrap:wrap;padding:.9375rem 0}.cds--actionable-notification__button-wrapper{display:flex}.cds--actionable-notification--toast .cds--actionable-notification__text-wrapper,:host(cds-actionable-notification:not([inline])) .cds--actionable-notification__text-wrapper{padding:.9375rem 0 1.4375rem}.cds--actionable-notification__content{display:flex;flex-wrap:wrap;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);word-break:break-word}.cds--actionable-notification--toast .cds--actionable-notification__content,:host(cds-actionable-notification:not([inline])) .cds--actionable-notification__content{display:block}.cds--actionable-notification__title{font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);font-weight:600;letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);margin-inline-end:.25rem;word-break:break-word}.cds--actionable-notification--toast .cds--actionable-notification__title,:host(cds-actionable-notification:not([inline])) .cds--actionable-notification__title{margin-inline-end:0}.cds--actionable-notification__subtitle{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin-block-start:0;word-break:break-word}.cds--actionable-notification--low-contrast .cds--actionable-notification__subtitle,:host(cds-actionable-notification[kind=error][low-contrast]) .cds--actionable-notification__subtitle,:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--actionable-notification__subtitle,:host(cds-actionable-notification[kind=info][low-contrast]) .cds--actionable-notification__subtitle,:host(cds-actionable-notification[kind=success][low-contrast]) .cds--actionable-notification__subtitle,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__subtitle,:host(cds-actionable-notification[kind=warning][low-contrast]) .cds--actionable-notification__subtitle{color:var(--cds-text-primary,#161616)}.cds--actionable-notification__action-button.cds--btn--ghost{block-size:2rem;margin-block-end:.5rem;margin-inline-start:2.5rem}@media (min-width:42rem){.cds--actionable-notification__action-button.cds--btn--ghost{margin:.5rem 0}}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--ghost,:not(.cds--actionable-notification--low-contrast):host(cds-actionable-notification) .cds--actionable-notification__action-button.cds--btn--ghost{color:var(--cds-link-inverse,#78a9ff)}.cds--actionable-notification__action-button.cds--btn--ghost:active,.cds--actionable-notification__action-button.cds--btn--ghost:hover{background-color:var(--cds-background-inverse-hover,#474747)}.cds--actionable-notification--low-contrast .cds--actionable-notification__action-button.cds--btn--ghost:active,.cds--actionable-notification--low-contrast .cds--actionable-notification__action-button.cds--btn--ghost:hover,:host(cds-actionable-notification[kind=error][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:active,:host(cds-actionable-notification[kind=error][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:hover,:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:active,:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:hover,:host(cds-actionable-notification[kind=info][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:active,:host(cds-actionable-notification[kind=info][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:hover,:host(cds-actionable-notification[kind=success][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:active,:host(cds-actionable-notification[kind=success][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:hover,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:active,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:hover,:host(cds-actionable-notification[kind=warning][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:active,:host(cds-actionable-notification[kind=warning][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:hover{background-color:var(--cds-notification-action-hover,#fff)}.cds--actionable-notification__action-button.cds--btn--ghost:focus{border-color:transparent;box-shadow:none;outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--actionable-notification--low-contrast .cds--actionable-notification__action-button.cds--btn--ghost:focus,:host(cds-actionable-notification[kind=error][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:focus,:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:focus,:host(cds-actionable-notification[kind=info][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:focus,:host(cds-actionable-notification[kind=success][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:focus,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:focus,:host(cds-actionable-notification[kind=warning][low-contrast]) .cds--actionable-notification__action-button.cds--btn--ghost:focus{outline-color:var(--cds-focus,#0f62fe)}.cds--actionable-notification--hide-close-button .cds--actionable-notification__action-button.cds--btn--ghost{margin-inline-end:.5rem}.cds--actionable-notification__action-button.cds--btn--tertiary{margin-block-end:1rem;margin-inline-start:3.125rem;padding-inline:1rem}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary,:not(.cds--actionable-notification--low-contrast):host(cds-actionable-notification) .cds--actionable-notification__action-button.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-notification-action-tertiary-inverse,#fff);border-style:solid;border-width:1px;color:var(--cds-notification-action-tertiary-inverse,#fff)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:hover,:not(.cds--actionable-notification--low-contrast):host(cds-actionable-notification) .cds--actionable-notification__action-button.cds--btn--tertiary:hover{background-color:var(--cds-notification-action-tertiary-inverse-hover,#f4f4f4)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:focus,:not(.cds--actionable-notification--low-contrast):host(cds-actionable-notification) .cds--actionable-notification__action-button.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary .cds--btn__icon,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:not(.cds--actionable-notification--low-contrast):host(cds-actionable-notification) .cds--actionable-notification__action-button.cds--btn--tertiary .cds--btn__icon,:not(.cds--actionable-notification--low-contrast):host(cds-actionable-notification) .cds--actionable-notification__action-button.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:hover,:not(.cds--actionable-notification--low-contrast):host(cds-actionable-notification) .cds--actionable-notification__action-button.cds--btn--tertiary:hover{color:var(--cds-notification-action-tertiary-inverse-text,#161616)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:focus,:not(.cds--actionable-notification--low-contrast):host(cds-actionable-notification) .cds--actionable-notification__action-button.cds--btn--tertiary:focus{background-color:var(--cds-notification-action-tertiary-inverse,#fff);border-color:var(--cds-focus-inverse,#fff);box-shadow:inset 0 0 0 1px var(--cds-focus-inverse,#fff),inset 0 0 0 2px var(--cds-background-inverse,#393939);color:var(--cds-notification-action-tertiary-inverse-text,#161616)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:active,:not(.cds--actionable-notification--low-contrast):host(cds-actionable-notification) .cds--actionable-notification__action-button.cds--btn--tertiary:active{background-color:var(--cds-notification-action-tertiary-inverse-active,#c6c6c6);border-color:transparent;color:var(--cds-notification-action-tertiary-inverse-text,#161616)}.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled:focus,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled:hover,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:disabled,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:focus:disabled,.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:hover:disabled,:not(.cds--actionable-notification--low-contrast):host(cds-actionable-notification) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled,:not(.cds--actionable-notification--low-contrast):host(cds-actionable-notification) .cds--actionable-notification__action-button.cds--btn--tertiary:disabled{background:transparent;color:var(--cds-notification-action-tertiary-inverse-text-on-color-disabled,hsla(0,0%,100%,.25));outline:none}.cds--actionable-notification--hide-close-button .cds--actionable-notification__action-button.cds--btn--tertiary{margin-inline-end:.5rem}.cds--actionable-notification__close-button{align-items:center;background:transparent;block-size:3rem;border:none;cursor:pointer;display:flex;flex-direction:column;inline-size:3rem;inset-block-start:0;inset-inline-end:0;justify-content:center;max-inline-size:3rem;min-inline-size:3rem;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline .11s cubic-bezier(.2,0,.38,.9),background-color .11s cubic-bezier(.2,0,.38,.9)}.cds--actionable-notification__close-button:focus{outline:2px solid var(--cds-focus-inverse,#fff);outline-offset:-2px}.cds--actionable-notification__close-button .cds--actionable-notification__close-icon{fill:var(--cds-icon-inverse,#fff)}@media (min-width:42rem){.cds--actionable-notification__close-button{position:static}}@media (min-width:42rem){.cds--actionable-notification--toast .cds--actionable-notification__close-button,:host(cds-actionable-notification:not([inline])) .cds--actionable-notification__close-button{position:absolute}}.cds--actionable-notification--low-contrast .cds--actionable-notification__close-button:focus,:host(cds-actionable-notification[kind=error][low-contrast]) .cds--actionable-notification__close-button:focus,:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--actionable-notification__close-button:focus,:host(cds-actionable-notification[kind=info][low-contrast]) .cds--actionable-notification__close-button:focus,:host(cds-actionable-notification[kind=success][low-contrast]) .cds--actionable-notification__close-button:focus,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__close-button:focus,:host(cds-actionable-notification[kind=warning][low-contrast]) .cds--actionable-notification__close-button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--actionable-notification--low-contrast .cds--actionable-notification__close-button:focus,:host(cds-actionable-notification[kind=error][low-contrast]) .cds--actionable-notification__close-button:focus,:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--actionable-notification__close-button:focus,:host(cds-actionable-notification[kind=info][low-contrast]) .cds--actionable-notification__close-button:focus,:host(cds-actionable-notification[kind=success][low-contrast]) .cds--actionable-notification__close-button:focus,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__close-button:focus,:host(cds-actionable-notification[kind=warning][low-contrast]) .cds--actionable-notification__close-button:focus{outline-style:dotted}}.cds--actionable-notification--low-contrast .cds--actionable-notification__close-button .cds--actionable-notification__close-icon,:host(cds-actionable-notification[kind=error][low-contrast]) .cds--actionable-notification__close-button .cds--actionable-notification__close-icon,:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--actionable-notification__close-button .cds--actionable-notification__close-icon,:host(cds-actionable-notification[kind=info][low-contrast]) .cds--actionable-notification__close-button .cds--actionable-notification__close-icon,:host(cds-actionable-notification[kind=success][low-contrast]) .cds--actionable-notification__close-button .cds--actionable-notification__close-icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__close-button .cds--actionable-notification__close-icon,:host(cds-actionable-notification[kind=warning][low-contrast]) .cds--actionable-notification__close-button .cds--actionable-notification__close-icon{fill:var(--cds-icon-primary,#161616)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--actionable-notification,:host(cds-actionable-notification){outline:1px solid transparent}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--actionable-notification__close-button:focus,.cds--btn.cds--btn--ghost.cds--actionable-notification__action-button:focus{color:Highlight;outline:1px solid Highlight}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--actionable-notification .cds--actionable-notification__close-icon,.cds--actionable-notification .cds--inline-notification__icon,.cds--actionable-notification .cds--toast-notification__icon,:host(cds-actionable-notification) .cds--actionable-notification__close-icon,:host(cds-actionable-notification) .cds--inline-notification__icon,:host(cds-actionable-notification) .cds--toast-notification__icon{fill:ButtonText}}:host(cds-actionable-notification){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;display:none;outline:none}:host(cds-actionable-notification-button:not([low-contrast])[kind=tertiary]) button{background-color:transparent;border-color:var(--cds-notification-action-tertiary-inverse,#fff);border-style:solid;border-width:1px;color:var(--cds-notification-action-tertiary-inverse,#fff)}:host(cds-actionable-notification-button:not([low-contrast])[kind=tertiary]) button:hover{background-color:var(--cds-notification-action-tertiary-inverse-hover,#f4f4f4)}:host(cds-actionable-notification-button:not([low-contrast])[kind=tertiary]) button:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}:host(cds-actionable-notification-button:not([low-contrast])[kind=tertiary]) button .cds--btn__icon,:host(cds-actionable-notification-button:not([low-contrast])[kind=tertiary]) button .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}:host(cds-actionable-notification-button:not([low-contrast])[kind=tertiary]) button:focus{background-color:var(--cds-notification-action-tertiary-inverse,#fff);border-color:var(--cds-focus-inverse,#fff);box-shadow:inset 0 0 0 1px var(--cds-focus-inverse,#fff),inset 0 0 0 2px var(--cds-background-inverse,#393939);color:var(--cds-notification-action-tertiary-inverse-text,#161616)}:host(cds-actionable-notification-button:not([low-contrast])[kind=tertiary]) button:hover{color:var(--cds-notification-action-tertiary-inverse-text,#161616)}:host(cds-actionable-notification-button:not([low-contrast])[kind=tertiary]) button:active{background-color:var(--cds-notification-action-tertiary-inverse-active,#c6c6c6);border-color:transparent;color:var(--cds-notification-action-tertiary-inverse-text,#161616)}:host(cds-actionable-notification-button[low-contrast][kind=ghost]) button:active,:host(cds-actionable-notification-button[low-contrast][kind=ghost]) button:hover{background-color:var(--cds-notification-action-hover,#fff)}:host(cds-actionable-notification-button[low-contrast][kind=ghost]) button:focus{outline-color:var(--cds-focus,#0f62fe)}:host(cds-actionable-notification-button:not([low-contrast])[kind=ghost]) button{color:var(--cds-link-inverse,#78a9ff)}:host(cds-actionable-notification-button[hide-close-button][kind=ghost]) button{margin-inline-end:.5rem}:host(cds-actionable-notification[inline][low-contrast]):before{block-size:100%;border-style:solid;border-width:1px 1px 1px 0;box-sizing:border-box;content:"";filter:opacity(.4);inline-size:100%;inset-block-start:0;inset-inline-start:0;pointer-events:none;position:absolute}:host(cds-actionable-notification[open]){display:flex}:host(cds-actionable-notification[hide-close-button]) .cds--actionable-notification__close-button{display:none}:host(cds-actionable-notification[kind=success][low-contrast]){background:var(--cds-notification-background-success,#defbe6);border-inline-start:3px solid var(--cds-support-success,#24a148)}:host(cds-actionable-notification[kind=success][low-contrast]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=success][low-contrast]) .cds--toast-notification__icon{fill:var(--cds-support-success,#24a148)}:host(cds-actionable-notification[kind=success][low-contrast]):before{border-color:var(--cds-support-success,#24a148)}:host(cds-actionable-notification[kind=info-square][low-contrast]),:host(cds-actionable-notification[kind=info][low-contrast]){background:var(--cds-notification-background-info,#edf5ff);border-inline-start:3px solid var(--cds-support-info,#0043ce)}:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info-square][low-contrast]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=info][low-contrast]) .cds--toast-notification__icon{fill:var(--cds-support-info,#0043ce)}:host(cds-actionable-notification[kind=info-square][low-contrast]):before,:host(cds-actionable-notification[kind=info][low-contrast]):before{border-color:var(--cds-support-info,#0043ce)}:host(cds-actionable-notification[kind=warning]) .cds--inline-notification__icon path[data-icon-path=inner-path]{fill:#000;opacity:1}:host(cds-actionable-notification[kind=warning-alt]) .cds--inline-notification__icon path[data-icon-path=inner-path],:host(cds-actionable-notification[kind=warning-alt]) .cds--toast-notification__icon path[data-icon-path=inner-path]{fill:#000;opacity:1}:host(cds-actionable-notification[kind=warning-alt][low-contrast]),:host(cds-actionable-notification[kind=warning][low-contrast]){background:var(--cds-notification-background-warning,#fcf4d6);border-inline-start:3px solid var(--cds-support-warning,#f1c21b)}:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning-alt][low-contrast]) .cds--toast-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=warning][low-contrast]) .cds--toast-notification__icon{fill:var(--cds-support-warning,#f1c21b)}:host(cds-actionable-notification[kind=warning-alt][low-contrast]):before,:host(cds-actionable-notification[kind=warning][low-contrast]):before{border-color:var(--cds-support-warning,#f1c21b)}:host(cds-actionable-notification[kind=error][low-contrast]){background:var(--cds-notification-background-error,#fff1f1);border-inline-start:3px solid var(--cds-support-error,#da1e28)}:host(cds-actionable-notification[kind=error][low-contrast]) .cds--actionable-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]) .cds--inline-notification__icon,:host(cds-actionable-notification[kind=error][low-contrast]) .cds--toast-notification__icon{fill:var(--cds-support-error,#da1e28)}:host(cds-actionable-notification[kind=error][low-contrast]):before{border-color:var(--cds-support-error,#da1e28)}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f95Mj":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2019, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Puts an event listener to an internal table for `@HostListener()`.
 *
 * @param type
 *   The event type. Can be prefixed with `document:` or `window:`.
 *   The event listener is attached to host element's owner document or its default view in such case.
 * @param options The event listener options.
 * @param Clazz The target class.
 * @param name The method name in the given target class that works as the event listener.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HostListener);
const setHostListener = (type, options, Clazz, name)=>{
    const hostListeners = Clazz._hostListeners;
    if (!hostListeners) throw new Error("The method `@HostListener()` is defined on has to be of a class that has `HostListerMixin`.");
    if (!hostListeners[name]) hostListeners[name] = {};
    hostListeners[name][type] = {
        options
    };
};
/**
 * @param type
 *   The event type. Can be prefixed with `document:` or `window:`.
 *   The event listener is attached to host element's owner document or its default view in such case.
 * @param options The event listener options.
 * @param descriptor The original class element descriptor of the event listener method.
 * @returns The updated class element descriptor with `@HostListener()` decorator.
 */ const HostListenerStandard = (type, options, descriptor)=>{
    const { kind, key, placement } = descriptor;
    if (!(kind === "method" && placement === "prototype" || kind === "field" && placement === "own")) throw new Error("`@HostListener()` must be defined on instance methods, but you may have defined it on static, field, etc.");
    return Object.assign(Object.assign({}, descriptor), {
        finisher (Clazz) {
            setHostListener(type, options, Clazz, key);
        }
    });
};
/**
 * A decorator to add event listener to the host element, or its `document`/`window`, of a custom element.
 * The `target` must extend `HostListenerMixin`.
 *
 * @param type
 *   The event type. Can be prefixed with `document:` or `window:`.
 *   The event listener is attached to host element's owner document or its default view in such case.
 * @param options The event listener options.
 */ const HostListener = (type, options)=>(targetOrDescriptor, name)=>typeof name !== "undefined" ? setHostListener(type, options, targetOrDescriptor.constructor, name) : HostListenerStandard(type, options, targetOrDescriptor);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1SMUX":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HostListenerMixin);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The format for the event name used by `@HostListener` decorator.
 */ const EVENT_NAME_FORMAT = /^((document|window|parentRoot|shadowRoot):)?([\w-]+)$/;
/**
 * @param Base The base class.
 * @returns A mix-in that sets up and cleans up event listeners defined by `@HostListener` decorator.
 */ const HostListenerMixin = (Base)=>{
    /**
     * A mix-in class that sets up and cleans up event listeners defined by `@HostListener` decorator.
     */ class HostListenerMixinImpl extends Base {
        constructor(){
            super(...arguments);
            /**
             * The list of handles managed by this mix-in.
             *
             * @private
             */ this._handles = new Set(); // Not using TypeScript `private` due to: microsoft/TypeScript#17744
        }
        connectedCallback() {
            // @ts-ignore: Until `connectedCallback` is added to `HTMLElement` definition
            super.connectedCallback();
            const hostListeners = this.constructor._hostListeners;
            Object.keys(hostListeners).forEach((listenerName)=>{
                Object.keys(hostListeners[listenerName]).forEach((type)=>{
                    var _a;
                    // Parses `document:click`/`window:click` format
                    const tokens = EVENT_NAME_FORMAT.exec(type);
                    if (!tokens) throw new Error(`Could not parse the event name: ${listenerName}`);
                    const [, , targetName, unprefixedType] = tokens;
                    const target = {
                        document: this.ownerDocument,
                        window: this.ownerDocument.defaultView,
                        parentRoot: this.getRootNode(),
                        shadowRoot: this.shadowRoot
                    }[targetName] || this;
                    const { options } = hostListeners[listenerName][type];
                    this._handles.add((0, _onJsDefault.default)(target, (_a = this.constructor[unprefixedType]) !== null && _a !== void 0 ? _a : unprefixedType, this[listenerName], options));
                });
            });
        }
        disconnectedCallback() {
            this._handles.forEach((handle)=>{
                handle.release();
                this._handles.delete(handle);
            });
            // @ts-ignore: Until `disconnectedCallback` is added to `HTMLElement` definition
            super.disconnectedCallback();
        }
    }
    /**
     * The map, keyed by method name, of event listeners that should be attached to host element or host document.
     *
     * @private
     */ HostListenerMixinImpl._hostListeners = {}; // Not using TypeScript `private` due to: microsoft/TypeScript#17744
    return HostListenerMixinImpl;
};

},{"./on.js":"hYHF3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hYHF3":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>on);
function on(element, ...args) {
    element.addEventListener(...args);
    return {
        release () {
            element.removeEventListener(...args);
            return null;
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6aKiO":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSActionableNotificationButton$1);
var _tslib = require("tslib");
var _settingsJs = require("../../globals/settings.js");
var _buttonJs = require("../button/button.js");
var _buttonJsDefault = parcelHelpers.interopDefault(_buttonJs);
var _actionableNotificationScssJs = require("./actionable-notification.scss.js");
var _actionableNotificationScssJsDefault = parcelHelpers.interopDefault(_actionableNotificationScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Actionable notification action button.
 *
 * @element cds-actionable-notification-button
 */ let CDSActionableNotificationButton = class CDSActionableNotificationButton extends (0, _buttonJsDefault.default) {
    update(changedProperties) {
        var _a;
        super.update(changedProperties);
        (_a = this.shadowRoot.getElementById("button")) === null || _a === void 0 || _a.classList.add(`${(0, _settingsJs.prefix)}--actionable-notification__action-button`);
        this.setAttribute("size", "sm");
    }
};
CDSActionableNotificationButton.styles = (0, _actionableNotificationScssJsDefault.default);
CDSActionableNotificationButton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-actionable-notification-button`)
], CDSActionableNotificationButton);
var CDSActionableNotificationButton$1 = CDSActionableNotificationButton;

},{"tslib":"gBS4y","../../globals/settings.js":"EipuL","../button/button.js":"ca52G","./actionable-notification.scss.js":"i8Ckp","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ca52G":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BUTTON_KIND", ()=>(0, _defsJs.BUTTON_KIND));
parcelHelpers.export(exports, "BUTTON_SIZE", ()=>(0, _defsJs.BUTTON_SIZE));
parcelHelpers.export(exports, "BUTTON_TOOLTIP_ALIGNMENT", ()=>(0, _defsJs.BUTTON_TOOLTIP_ALIGNMENT));
parcelHelpers.export(exports, "BUTTON_TOOLTIP_POSITION", ()=>(0, _defsJs.BUTTON_TOOLTIP_POSITION));
parcelHelpers.export(exports, "BUTTON_TYPE", ()=>(0, _defsJs.BUTTON_TYPE));
parcelHelpers.export(exports, "default", ()=>CDSButton$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _defsJs = require("./defs.js");
var _buttonScssJs = require("./button.scss.js");
var _buttonScssJsDefault = parcelHelpers.interopDefault(_buttonScssJs);
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Button.
 *
 * @element cds-button
 * @csspart button The button.
 */ let CDSButton = class CDSButton extends (0, _hostListenerJsDefault1.default)((0, _focusJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * `true` if there is an icon.
         */ this._hasIcon = false;
        this._handleOver = ()=>{
            this.openTooltip = true;
        };
        /**
         * Handles `keydown` event on this element.
         */ this._handleHoverOut = async ()=>{
            this.openTooltip = false;
        };
        /**
         * Handles `keydown` event on this element.
         * Space & enter will toggle state, Escape will only close.
         */ this._handleFocus = async ()=>{
            this.openTooltip = true;
        };
        /**
         * Handles `keydown` event on this element.
         * Space & enter will toggle state, Escape will only close.
         */ this._handleFocusout = async ()=>{
            this.openTooltip = false;
        };
        /**
         * `true` if the button should have input focus when the page loads.
         */ this.autofocus = false;
        /**
         * `true` if the button is being used within a data table batch action toolbar
         */ this.batchAction = false;
        /**
         * `true` if the button should be disabled.
         */ this.disabled = false;
        /**
         * `true` if there is a non-icon content.
         */ this.hasMainContent = false;
        /**
         * `true` if expressive theme enabled.
         */ this.isExpressive = false;
        /**
         * Specify whether the Button is currently selected.
         * Only applies to the Ghost variant.
         */ this.isSelected = false;
        /**
         * Button kind.
         */ this.kind = (0, _defsJs.BUTTON_KIND).PRIMARY;
        /**
         * The a11y role for `<a>`.
         */ this.linkRole = "button";
        /**
         * Boolean to determine if tooltip is open.
         */ this.openTooltip = false;
        /**
         * Button size.
         */ this.size = "lg";
        /**
         * Specify the alignment of the tooltip to the icon-only button.
         * Can be one of: start, center, or end.
         */ this.tooltipAlignment = (0, _defsJs.BUTTON_TOOLTIP_ALIGNMENT).CENTER;
        /**
         * Specify the direction of the tooltip for icon-only buttons.
         * Can be either top, right, bottom, or left.
         */ this.tooltipPosition = (0, _defsJs.BUTTON_TOOLTIP_POSITION).TOP;
        /**
         * Button type.
         */ this.type = (0, _defsJs.BUTTON_TYPE).BUTTON;
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const { name } = target;
        const hasContent = target.assignedNodes().some((node)=>node.nodeType !== Node.TEXT_NODE || node.textContent.trim());
        this[name === "icon" ? "_hasIcon" : "hasMainContent"] = hasContent;
        this.requestUpdate();
    }
    _handleDisabledClick(event) {
        const { disabled } = this;
        if (disabled) event.stopPropagation();
    }
    render() {
        const { autofocus, buttonClassName, dangerDescriptor, disabled, download, href, hreflang, kind, isExpressive, isSelected, linkRole, openTooltip, ping, rel, size, target, tooltipAlignment, tooltipPosition, tooltipText, type, _hasIcon: hasIcon, hasMainContent, _handleSlotChange: handleSlotChange } = this;
        let defaultClasses = {
            [`${0, _settingsJs.prefix}--btn`]: true,
            [`${0, _settingsJs.prefix}--btn--${kind}`]: kind,
            [`${0, _settingsJs.prefix}--btn--danger--tertiary`]: kind === (0, _defsJs.BUTTON_KIND).DANGER_TERTIARY,
            [`${0, _settingsJs.prefix}--btn--danger--ghost`]: kind === (0, _defsJs.BUTTON_KIND).DANGER_GHOST,
            [`${0, _settingsJs.prefix}--btn--disabled`]: disabled,
            [`${0, _settingsJs.prefix}--btn--icon-only`]: hasIcon && !hasMainContent,
            [`${0, _settingsJs.prefix}--btn--${size}`]: size,
            [`${0, _settingsJs.prefix}--layout--size-${size}`]: size,
            [`${0, _settingsJs.prefix}-ce--btn--has-icon`]: hasIcon,
            [`${0, _settingsJs.prefix}--btn--expressive`]: isExpressive,
            [`${0, _settingsJs.prefix}--btn--selected`]: isSelected && kind === "ghost"
        };
        if (buttonClassName) {
            const outputObject = {};
            buttonClassName === null || buttonClassName === void 0 || buttonClassName.split(" ").forEach((element)=>{
                outputObject[element] = true;
            });
            defaultClasses = Object.assign(Object.assign({}, defaultClasses), outputObject);
        }
        const classes = (0, _classMapJs.classMap)(defaultClasses);
        const isDanger = kind.includes("danger");
        if (href) return disabled ? (0, _lit.html)`
            <p id="button" part="button" class="${classes}">
              <slot @slotchange="${handleSlotChange}"></slot>
              <slot name="icon" @slotchange="${handleSlotChange}"></slot>
            </p>
          ` : (0, _lit.html)`
            <a
              id="button"
              part="button"
              role="${(0, _ifDefinedJs.ifDefined)(linkRole)}"
              class="${classes}"
              download="${(0, _ifDefinedJs.ifDefined)(download)}"
              href="${(0, _ifDefinedJs.ifDefined)(href)}"
              hreflang="${(0, _ifDefinedJs.ifDefined)(hreflang)}"
              ping="${(0, _ifDefinedJs.ifDefined)(ping)}"
              rel="${(0, _ifDefinedJs.ifDefined)(rel)}"
              target="${(0, _ifDefinedJs.ifDefined)(target)}"
              type="${(0, _ifDefinedJs.ifDefined)(type)}">
              <slot @slotchange="${handleSlotChange}"></slot>
              <slot name="icon" @slotchange="${handleSlotChange}"></slot>
            </a>
          `;
        const alignmentClass = tooltipAlignment && (tooltipPosition === (0, _defsJs.BUTTON_TOOLTIP_POSITION).TOP || tooltipPosition === (0, _defsJs.BUTTON_TOOLTIP_POSITION).BOTTOM) ? `-${tooltipAlignment}` : "";
        const tooltipClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--popover-container`]: true,
            [`${0, _settingsJs.prefix}--popover--caret`]: true,
            [`${0, _settingsJs.prefix}--popover--high-contrast`]: true,
            [`${0, _settingsJs.prefix}--tooltip`]: true,
            [`${0, _settingsJs.prefix}--icon-tooltip`]: hasIcon,
            [`${0, _settingsJs.prefix}--popover--open`]: openTooltip,
            [`${0, _settingsJs.prefix}--popover--${tooltipPosition}${alignmentClass}`]: tooltipText
        });
        return tooltipText && !disabled ? (0, _lit.html)`
          <span class="${tooltipClasses}">
            <button
              id="button"
              part="button"
              class="${classes}"
              ?autofocus="${autofocus}"
              ?disabled="${disabled}"
              type="${(0, _ifDefinedJs.ifDefined)(type)}"
              aria-label="${(0, _ifDefinedJs.ifDefined)(tooltipText)}">
              <slot @slotchange="${handleSlotChange}"></slot>
              <slot name="icon" @slotchange="${handleSlotChange}"></slot>
            </button>
            <span class="${0, _settingsJs.prefix}--popover">
              <span
                class="${0, _settingsJs.prefix}--popover-content ${0, _settingsJs.prefix}--tooltip-content">
                ${tooltipText}
              </span>
              <span class="${0, _settingsJs.prefix}--popover-caret"></span>
            </span>
          </span>
        ` : (0, _lit.html)`
          <button
            id="button"
            part="button"
            class="${classes}"
            ?autofocus="${autofocus}"
            ?disabled="${disabled}"
            type="${(0, _ifDefinedJs.ifDefined)(type)}">
            ${isDanger ? (0, _lit.html)`<span class="${0, _settingsJs.prefix}--visually-hidden"
                  >${dangerDescriptor}</span
                >` : ``}
            <slot @slotchange="${handleSlotChange}"></slot>
            <slot name="icon" @slotchange="${handleSlotChange}"></slot>
          </button>
        `;
    }
};
CDSButton.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSButton.styles = (0, _buttonScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("click", {
        capture: true
    })
], CDSButton.prototype, "_handleDisabledClick", null);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("mouseover")
], CDSButton.prototype, "_handleOver", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("mouseout")
], CDSButton.prototype, "_handleHoverOut", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("focus")
], CDSButton.prototype, "_handleFocus", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("focusout")
], CDSButton.prototype, "_handleFocusout", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSButton.prototype, "autofocus", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "batch-action"
    })
], CDSButton.prototype, "batchAction", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "button-class-name"
    })
], CDSButton.prototype, "buttonClassName", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "danger-descriptor"
    })
], CDSButton.prototype, "dangerDescriptor", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSButton.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSButton.prototype, "download", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "has-main-content",
        type: Boolean
    })
], CDSButton.prototype, "hasMainContent", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSButton.prototype, "href", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSButton.prototype, "hreflang", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSButton.prototype, "isExpressive", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSButton.prototype, "isSelected", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSButton.prototype, "kind", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "link-role"
    })
], CDSButton.prototype, "linkRole", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSButton.prototype, "openTooltip", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSButton.prototype, "ping", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSButton.prototype, "rel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSButton.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSButton.prototype, "target", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "tooltip-alignment"
    })
], CDSButton.prototype, "tooltipAlignment", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "tooltip-position"
    })
], CDSButton.prototype, "tooltipPosition", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "tooltip-text"
    })
], CDSButton.prototype, "tooltipText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSButton.prototype, "type", void 0);
CDSButton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-button`)
], CDSButton);
var CDSButton$1 = CDSButton;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit/directives/if-defined.js":"hSgrS","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./defs.js":"3XZFP","./button.scss.js":"ffMSy","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/host-listener.js":"1SMUX","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2fQud":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classMapJs = require("lit-html/directives/class-map.js");
parcelHelpers.exportAll(_classMapJs, exports);

},{"lit-html/directives/class-map.js":"8sJmQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8sJmQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "classMap", ()=>e);
var _litHtmlJs = require("../lit-html.js");
var _directiveJs = require("../directive.js");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const e = (0, _directiveJs.directive)(class extends (0, _directiveJs.Directive) {
    constructor(t){
        if (super(t), t.type !== (0, _directiveJs.PartType).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, _litHtmlJs.noChange;
    }
});

},{"../lit-html.js":"4A25t","../directive.js":"k6ssg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3XZFP":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Button kind.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BUTTON_KIND", ()=>BUTTON_KIND);
parcelHelpers.export(exports, "BUTTON_SIZE", ()=>BUTTON_SIZE);
parcelHelpers.export(exports, "BUTTON_TOOLTIP_ALIGNMENT", ()=>BUTTON_TOOLTIP_ALIGNMENT);
parcelHelpers.export(exports, "BUTTON_TOOLTIP_POSITION", ()=>BUTTON_TOOLTIP_POSITION);
parcelHelpers.export(exports, "BUTTON_TYPE", ()=>BUTTON_TYPE);
var BUTTON_KIND;
(function(BUTTON_KIND) {
    /**
     * Primary button.
     */ BUTTON_KIND["PRIMARY"] = "primary";
    /**
     * Secondary button.
     */ BUTTON_KIND["SECONDARY"] = "secondary";
    /**
     * Tertiary button.
     */ BUTTON_KIND["TERTIARY"] = "tertiary";
    /**
     * Ghost button.
     */ BUTTON_KIND["GHOST"] = "ghost";
    /**
     * Danger button.
     */ BUTTON_KIND["DANGER"] = "danger";
    /**
     * @deprecated use 'danger' kind
     * Danger primary button.
     */ BUTTON_KIND["DANGER_PRIMARY"] = "danger-primary";
    /**
     * Danger tertiary button.
     */ BUTTON_KIND["DANGER_TERTIARY"] = "danger-tertiary";
    /**
     * Danger ghost button,
     */ BUTTON_KIND["DANGER_GHOST"] = "danger-ghost";
})(BUTTON_KIND || (BUTTON_KIND = {}));
/**
 * Button type.
 */ var BUTTON_TYPE;
(function(BUTTON_TYPE) {
    /**
     * Default button type.
     */ BUTTON_TYPE["BUTTON"] = "button";
    /**
     * Reset button type.
     */ BUTTON_TYPE["RESET"] = "reset";
    /**
     * Submit button type.
     */ BUTTON_TYPE["SUBMIT"] = "submit";
})(BUTTON_TYPE || (BUTTON_TYPE = {}));
/**
 * Button size.
 */ var BUTTON_SIZE;
(function(BUTTON_SIZE) {
    /**
     * Small size.
     */ BUTTON_SIZE["SMALL"] = "sm";
    /**
     * Medium size.
     */ BUTTON_SIZE["MEDIUM"] = "md";
    /**
     * Large size.
     */ BUTTON_SIZE["LARGE"] = "lg";
    /**
     * X-Large size.
     */ BUTTON_SIZE["EXTRA_LARGE"] = "xl";
    /**
     * 2X-Large size.
     */ BUTTON_SIZE["EXTRA_EXTRA_LARGE"] = "2xl";
})(BUTTON_SIZE || (BUTTON_SIZE = {}));
/**
 * Button tooltip alignment.
 */ var BUTTON_TOOLTIP_ALIGNMENT;
(function(BUTTON_TOOLTIP_ALIGNMENT) {
    /**
     * Aligned to the start.
     */ BUTTON_TOOLTIP_ALIGNMENT["START"] = "left";
    /**
     * Aligned to the center.
     */ BUTTON_TOOLTIP_ALIGNMENT["CENTER"] = "";
    /**
     * Aligned to the end.
     */ BUTTON_TOOLTIP_ALIGNMENT["END"] = "right";
})(BUTTON_TOOLTIP_ALIGNMENT || (BUTTON_TOOLTIP_ALIGNMENT = {}));
/**
 * Button tooltip position.
 */ var BUTTON_TOOLTIP_POSITION;
(function(BUTTON_TOOLTIP_POSITION) {
    /**
     * Positioned on the top.
     */ BUTTON_TOOLTIP_POSITION["TOP"] = "top";
    /**
     * Positioned on the right.
     */ BUTTON_TOOLTIP_POSITION["RIGHT"] = "right";
    /**
     * Positioned on the bottom.
     */ BUTTON_TOOLTIP_POSITION["BOTTOM"] = "bottom";
    /**
     * Positined on the left.
     */ BUTTON_TOOLTIP_POSITION["LEFT"] = "left";
})(BUTTON_TOOLTIP_POSITION || (BUTTON_TOOLTIP_POSITION = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ffMSy":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buttonStyles);
var _lit = require("lit");
var buttonStyles = (0, _lit.css)([
    '.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon,:host(cds-button) .cds--btn ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn ::slotted([slot=icon]){block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--primary ::slotted([slot=icon]),:host(cds-button) .cds--btn--primary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--primary ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--primary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--secondary ::slotted([slot=icon]),:host(cds-button) .cds--btn--secondary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--secondary ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--secondary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--tertiary ::slotted([slot=icon]),:host(cds-button) .cds--btn--tertiary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--tertiary ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--tertiary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--ghost ::slotted([slot=icon]),:host(cds-button) .cds--btn--ghost ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--ghost ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--ghost ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon,:host(cds-button) .cds--btn--ghost ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--ghost ::slotted([slot=icon]){margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon,:host(cds-button) .cds--btn--icon-only ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--icon-only ::slotted([slot=icon]){position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon,:host(cds-button) .cds--btn--icon-only.cds--btn--danger--ghost ::slotted([slot=icon]),:host(cds-button) .cds--btn--icon-only.cds--btn--ghost ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--icon-only.cds--btn--danger--ghost ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--icon-only.cds--btn--ghost ::slotted([slot=icon]){margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon,:host(cds-button) .cds--btn--md:not(.cds--btn--icon-only) ::slotted([slot=icon]),:host(cds-button) .cds--btn--sm:not(.cds--btn--icon-only) ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--md:not(.cds--btn--icon-only) ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--sm:not(.cds--btn--icon-only) ::slotted([slot=icon]){margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]),:host(cds-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon,:host(cds-button) .cds--btn--ghost.cds--btn--icon-only[disabled] ::slotted([slot=icon]),:host(cds-button) .cds--btn--ghost.cds--btn--icon-only[disabled] ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--ghost.cds--btn--icon-only[disabled] ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--ghost.cds--btn--icon-only[disabled] ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--danger ::slotted([slot=icon]),:host(cds-button) .cds--btn--danger ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--danger ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--danger ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--danger--tertiary ::slotted([slot=icon]),:host(cds-button) .cds--btn--danger--tertiary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--danger--tertiary ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--danger--tertiary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--danger--ghost ::slotted([slot=icon]),:host(cds-button) .cds--btn--danger--ghost ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--danger--ghost ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--danger--ghost ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon,:host(cds-button) .cds--btn--danger--ghost ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--danger--ghost ::slotted([slot=icon]){margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon,:host(cds-button) .cds--btn.cds--btn--expressive ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn.cds--btn--expressive ::slotted([slot=icon]){block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive,:host(cds-button-set) .cds--btn.cds--btn--expressive,:host(cds-side-panel-button-set) .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set,:host(cds-button-set),:host(cds-side-panel-button-set){display:flex}.cds--btn-set--stacked,:host(cds-button-set[stacked]){flex-direction:column}.cds--btn-set .cds--btn,:host(cds-button-set) .cds--btn,:host(cds-side-panel-button-set) .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus),:host(cds-button-set) .cds--btn:not(:focus),:host(cds-side-panel-button-set) .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),:host(cds-button-set) .cds--btn:first-of-type:not(:focus),:host(cds-side-panel-button-set) .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn:focus+.cds--btn,:host(cds-button-set) .cds--btn:focus+.cds--btn,:host(cds-side-panel-button-set) .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus),:host(cds-button-set[stacked]) .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus),:host(cds-button-set[stacked]) .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled,:host(cds-button-set) .cds--btn.cds--btn--disabled,:host(cds-side-panel-button-set) .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type,:host(cds-button-set) .cds--btn.cds--btn--disabled:first-of-type,:host(cds-side-panel-button-set) .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled,:host(cds-button-set[stacked]) .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type,:host(cds-button-set[stacked]) .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading,:host(cds-button-set) .cds--btn.cds--btn--loading,:host(cds-side-panel-button-set) .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]),:host(cds-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus),[dir=rtl] :host(cds-button-set) .cds--btn:not(:focus),[dir=rtl] :host(cds-side-panel-button-set) .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--copy-btn{position:relative}.cds--copy-btn:hover{background-color:var(--cds-layer-hover)}.cds--copy-btn:active{background-color:var(--cds-layer-active)}.cds--copy-btn:before{block-size:0;border-style:solid;content:"";display:none;inline-size:0;position:absolute;z-index:6000}.cds--copy-btn .cds--copy-btn__feedback{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));box-sizing:content-box;color:var(--cds-text-inverse,#fff);display:none;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:auto;max-inline-size:13rem;min-inline-size:1.5rem;overflow:visible;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000;clip:auto}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--copy-btn .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-accelerator:true){.cds--copy-btn .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--copy-btn .cds--copy-btn__feedback{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--copy-btn .cds--copy-btn__feedback{border:1px solid transparent}}.cds--copy-btn.cds--copy-btn--animating .cds--copy-btn__feedback,.cds--copy-btn.cds--copy-btn--animating:before{display:block}.cds--copy-btn.cds--copy-btn--animating:before{border:none}.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-out .cds--copy-btn__feedback,.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-out:before{animation:cds--hide-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-in .cds--copy-btn__feedback,.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-in:before{animation:cds--show-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--copy-btn svg{fill:var(--cds-icon-primary,#161616)}.cds--copy{font-size:0}.cds--chat-btn{border-radius:1.5rem}.cds--chat-btn:not(.cds--chat-btn--with-icon){padding-inline-end:.9375rem}.cds--chat-btn.cds--btn--md{border-radius:1.25rem}.cds--chat-btn.cds--btn--sm{border-radius:1rem}.cds--chat-btn--quick-action{align-items:center;background:transparent;border:1px solid var(--cds-chat-button,#0f62fe);color:var(--cds-chat-button,#0f62fe)}.cds--chat-btn--quick-action:hover:not(:active):not([disabled]){background:var(--cds-chat-button-hover,hsla(0,0%,55%,.12));border-color:transparent;color:var(--cds-chat-button-text-hover,#0043ce)}.cds--chat-btn--quick-action:active{background:var(--cds-chat-button-active,hsla(0,0%,55%,.5));border-color:transparent;color:var(--cds-chat-button-text-hover,#0043ce)}.cds--chat-btn--quick-action.cds--btn--ghost:focus{border-color:var(--cds-focus,#0f62fe);box-shadow:inset 0 0 0 1px var(--cds-focus,#0f62fe)}.cds--chat-btn--quick-action.cds--btn--ghost:hover:focus{border-color:var(--cds-focus,#0f62fe);box-shadow:inset 0 0 0 1px var(--cds-focus-inset,#fff)}.cds--chat-btn--quick-action[disabled],.cds--chat-btn--quick-action[disabled]:hover{border-color:var(--cds-button-disabled,#c6c6c6);color:var(--cds-button-disabled,#c6c6c6)}.cds--chat-btn--quick-action--selected,.cds--chat-btn--quick-action--selected[disabled],.cds--chat-btn--quick-action--selected[disabled]:hover{background:var(--cds-chat-button-selected,hsla(0,0%,55%,.2));border-color:transparent;color:var(--cds-chat-button-text-selected,#525252)}.cds--chat-btn--quick-action.cds--chat-btn--quick-action--selected:not([disabled]):active,.cds--chat-btn--quick-action.cds--chat-btn--quick-action--selected:not([disabled]):hover{color:var(--cds-chat-button-text-selected,#525252)}.cds--chat-btn.cds--skeleton{overflow:hidden}.cds--snippet html{font-size:100%}.cds--snippet body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--snippet code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--snippet strong{font-weight:600}.cds--snippet--disabled,.cds--snippet--disabled .cds--btn.cds--snippet-btn--expand{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--snippet--disabled .cds--copy-btn,.cds--snippet--disabled .cds--copy-btn:hover,.cds--snippet--disabled .cds--snippet-btn--expand:hover{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--snippet--disabled .cds--snippet-btn--expand .cds--icon-chevron--down,.cds--snippet--disabled .cds--snippet__icon{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--snippet code{font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333)}.cds--snippet--inline{background-color:var(--cds-layer);border:1px solid transparent;border-radius:4px;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline;padding:0;position:relative}.cds--snippet--inline html{font-size:100%}.cds--snippet--inline body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--snippet--inline code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--snippet--inline strong{font-weight:600}.cds--snippet--inline:hover{background-color:var(--cds-layer-hover)}.cds--snippet--inline:active{background-color:var(--cds-layer-active)}.cds--snippet--inline:focus{border:1px solid var(--cds-focus,#0f62fe);outline:none}.cds--snippet--inline:before{block-size:0;border:none;content:"";display:none;inline-size:0;position:absolute;z-index:6000}.cds--snippet--inline .cds--copy-btn__feedback{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));box-sizing:content-box;color:var(--cds-text-inverse,#fff);display:none;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:auto;max-inline-size:13rem;min-inline-size:1.5rem;overflow:visible;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000;clip:auto}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--snippet--inline .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-accelerator:true){.cds--snippet--inline .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--snippet--inline .cds--copy-btn__feedback{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--snippet--inline .cds--copy-btn__feedback{border:1px solid transparent}}.cds--snippet--inline.cds--copy-btn--animating .cds--copy-btn__feedback,.cds--snippet--inline.cds--copy-btn--animating:before{display:block}.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-out .cds--copy-btn__feedback,.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-out:before{animation:cds--hide-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-in .cds--copy-btn__feedback,.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-in:before{animation:cds--show-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--snippet--inline code{padding:0 .5rem}.cds--snippet--inline.cds--snippet--no-copy{display:inline-block}.cds--snippet--inline.cds--snippet--no-copy:hover{background-color:var(--cds-layer);cursor:auto}.cds--snippet--light.cds--snippet--inline.cds--snippet--no-copy:hover{background-color:var(--cds-layer-hover);cursor:auto}.cds--snippet--single{align-items:center;background-color:var(--cds-layer);block-size:2.5rem;display:flex;font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);max-inline-size:48rem;padding-inline-end:2.5rem;position:relative}.cds--snippet--single.cds--snippet--no-copy{padding:0}.cds--snippet--single.cds--snippet--no-copy:after{inset-inline-end:1rem}.cds--snippet--single .cds--snippet-container{align-items:center;block-size:100%;display:flex;overflow-x:auto;padding-inline-start:1rem;position:relative}.cds--snippet--single .cds--snippet-container:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--snippet--single .cds--snippet-container:focus{outline-style:dotted}}.cds--snippet--single pre{font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);padding-inline-end:.5rem}.cds--snippet--inline code,.cds--snippet--single pre{white-space:pre}.cds--snippet--multi{background-color:var(--cds-layer);display:flex;font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);max-inline-size:48rem;padding:1rem;position:relative}.cds--snippet--multi .cds--snippet-container{max-block-size:100%;min-block-size:100%;order:1;overflow-y:auto;position:relative;transition:max-height .15s cubic-bezier(.2,0,.38,.9)}.cds--snippet--multi .cds--snippet-container:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;outline-offset:0}@media screen and (prefers-contrast){.cds--snippet--multi .cds--snippet-container:focus{outline-style:dotted}}.cds--snippet--multi.cds--snippet--expand .cds--snippet-container{padding-block-end:1rem;transition:max-height .15s cubic-bezier(.2,0,.38,.9)}.cds--snippet--multi.cds--snippet--wraptext pre{white-space:pre-wrap;word-wrap:break-word}.cds--snippet--multi .cds--snippet-container pre{padding-inline-end:2.5rem}.cds--snippet--multi.cds--snippet--no-copy .cds--snippet-container pre{padding-inline-end:0}.cds--snippet--multi.cds--snippet--has-right-overflow:after{background-image:linear-gradient(to right,transparent,var(--cds-layer));block-size:100%;content:"";inline-size:1rem;inset-block-start:0;inset-inline-end:1rem;position:absolute}[dir=rtl] .cds--snippet--multi.cds--snippet--has-right-overflow:after{background-image:linear-gradient(to left,transparent,var(--cds-layer))}.cds--snippet--multi .cds--snippet-container pre code{overflow:hidden}.cds--snippet__icon{block-size:1rem;fill:var(--cds-icon-primary,#161616);inline-size:1rem;transition:all 70ms cubic-bezier(.2,0,.38,.9)}.cds--btn>.cds--snippet__icon{margin-block-start:0}.cds--copy-btn{align-items:center;background-color:var(--cds-layer);border:none;cursor:pointer;display:flex;justify-content:center;outline:none;overflow:visible;padding:0}.cds--copy-btn html{font-size:100%}.cds--copy-btn body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--copy-btn code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--copy-btn strong{font-weight:600}.cds--copy-btn:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-color:var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--copy-btn:focus{outline-style:dotted}}.cds--snippet .cds--popover-container{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;inset-block-start:0;inset-inline-end:0;position:absolute}.cds--snippet--inline.cds--btn{block-size:1.25rem;inline-size:auto;max-inline-size:unset;min-block-size:1.25rem;padding-inline:0}.cds--snippet--inline.cds--btn.cds--btn--primary:hover{color:var(--cds-text-primary,#161616)}.cds--snippet.cds--snippet--multi .cds--popover-container{inset-block-start:.5rem;inset-inline-end:.5rem}.cds--snippet--multi .cds--copy-btn{z-index:10}.cds--snippet-btn--expand{align-items:center;background-color:var(--cds-layer);block-size:2rem;border:0;color:var(--cds-text-primary,#161616);display:inline-flex;font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inset-block-end:0;inset-inline-end:0;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);padding:.5rem 1rem;position:absolute;z-index:10}.cds--snippet-btn--expand .cds--snippet-btn--text{inset-block-start:-.0625rem;position:relative}.cds--snippet-btn--expand--hide.cds--snippet-btn--expand{display:none}.cds--snippet-btn--expand .cds--icon-chevron--down{fill:var(--cds-icon-primary,#161616);margin-inline-start:.5rem;transform:rotate(0deg);transition:.15s cubic-bezier(.2,0,.38,.9)}.cds--snippet-btn--expand:hover{background:var(--cds-layer-hover);color:var(--cds-text-primary,#161616)}.cds--snippet-btn--expand:active{background-color:var(--cds-layer-active)}.cds--snippet-btn--expand:focus{border-color:transparent;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--snippet-btn--expand:focus{outline-style:dotted}}.cds--snippet--expand .cds--snippet-btn--expand .cds--icon-chevron--down{transform:rotate(180deg);transition:transform .3s}.cds--snippet--light,.cds--snippet--light .cds--btn.cds--snippet-btn--expand,.cds--snippet--light .cds--copy-btn,.cds--snippet--light .cds--snippet-button{background-color:var(--cds-layer)}.cds--snippet--light .cds--btn.cds--snippet-btn--expand:hover,.cds--snippet--light .cds--copy-btn:hover,.cds--snippet--light .cds--snippet-button:hover,.cds--snippet--light.cds--snippet--inline:hover{background-color:var(--cds-layer-hover)}.cds--snippet--light .cds--btn.cds--snippet-btn--expand:active,.cds--snippet--light .cds--copy-btn:active,.cds--snippet--light .cds--snippet-button:active,.cds--snippet--light.cds--snippet--inline:active{background-color:var(--cds-layer-active)}.cds--snippet--light.cds--snippet--multi:after,.cds--snippet--light.cds--snippet--single:after{background-image:linear-gradient(to right,rgba(var(--cds-layer),0),var(--cds-layer))}.cds--snippet.cds--skeleton .cds--snippet-container{block-size:100%;inline-size:100%}.cds--snippet-button .cds--btn--copy__feedback{inset-block-start:3.175rem;inset-inline:50% auto}.cds--snippet-button .cds--btn--copy__feedback:before{inset-block-start:0}.cds--snippet-button .cds--btn--copy__feedback:after{inset-block-start:-.25rem}.cds--snippet--multi .cds--snippet-button .cds--btn--copy__feedback{inset-block-start:2.675rem}.cds--snippet--inline .cds--btn--copy__feedback{inset-block-start:calc(100% - .25rem);inset-inline:50% auto}.cds--snippet__overflow-indicator--left,.cds--snippet__overflow-indicator--right{flex:1 0 auto;inline-size:1rem;z-index:1}.cds--snippet__overflow-indicator--left{background-image:linear-gradient(to left,transparent,var(--cds-layer));margin-inline-end:-1rem;order:0}.cds--snippet__overflow-indicator--right{margin-inline-start:-1rem;order:2}.cds--snippet__overflow-indicator--right,[dir=rtl] .cds--snippet__overflow-indicator--left{background-image:linear-gradient(to right,transparent,var(--cds-layer))}[dir=rtl] .cds--snippet__overflow-indicator--right{background-image:linear-gradient(to left,transparent,var(--cds-layer))}.cds--snippet--single .cds--snippet__overflow-indicator--left,.cds--snippet--single .cds--snippet__overflow-indicator--right{block-size:calc(100% - .25rem);inline-size:2rem;position:absolute}.cds--snippet--single .cds--snippet__overflow-indicator--right{inset-inline-end:2.5rem}.cds--snippet--single.cds--snippet--no-copy .cds--snippet__overflow-indicator--right{inset-inline-end:0}.cds--snippet--single .cds--snippet-container:focus~.cds--snippet__overflow-indicator--right{inset-inline-end:2.625rem}.cds--snippet--single .cds--snippet-container:focus+.cds--snippet__overflow-indicator--left{inset-inline-start:.125rem}.cds--snippet--light .cds--snippet__overflow-indicator--left{background-image:linear-gradient(to left,transparent,var(--cds-layer))}.cds--snippet--light .cds--snippet__overflow-indicator--right{background-image:linear-gradient(to right,transparent,var(--cds-layer))}@media not all and (min-resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){.cds--snippet__overflow-indicator--left{background-image:linear-gradient(to left,rgba(var(--cds-layer),0),var(--cds-layer))}.cds--snippet__overflow-indicator--right{background-image:linear-gradient(to right,rgba(var(--cds-layer),0),var(--cds-layer))}}}.cds--snippet--multi.cds--skeleton{block-size:6.125rem}.cds--snippet--single.cds--skeleton{block-size:3.5rem}.cds--snippet.cds--skeleton span{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;display:block;inline-size:100%;margin-block-start:.5rem;padding:0;pointer-events:none;position:relative}.cds--snippet.cds--skeleton span:active,.cds--snippet.cds--skeleton span:focus,.cds--snippet.cds--skeleton span:hover{border:none;cursor:default;outline:none}.cds--snippet.cds--skeleton span:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--snippet.cds--skeleton span:before{animation:none}}.cds--snippet.cds--skeleton span:first-child{margin:0}.cds--snippet.cds--skeleton span:nth-child(2){inline-size:85%}.cds--snippet.cds--skeleton span:nth-child(3){inline-size:95%}.cds--snippet--single.cds--skeleton .cds--snippet-container{padding-block-end:0}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--snippet__icon{fill:ButtonText}.cds--snippet--inline:focus{color:Highlight;outline:1px solid Highlight}.cds--snippet--multi,.cds--snippet--single{outline:1px solid transparent}}:host(cds-button),:host(cds-modal-footer-button){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;display:inline-flex}:host(cds-button) .cds--btn,:host(cds-modal-footer-button) .cds--btn{flex-grow:1;max-inline-size:100%}:host(cds-button-skeleton){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}:host(cds-button[isExpressive]) ::slotted([slot=icon]),:host(cds-modal-footer-button[isExpressive]) ::slotted([slot=icon]){block-size:1.25rem;inline-size:1.25rem}:host(cds-button[pagination]) .cds--btn,:host(cds-modal-footer-button[pagination]) .cds--btn{border:none;border-inline-start:1px solid var(--cds-border-subtle);transition:none}:host(cds-button[pagination]) .cds--btn:focus,:host(cds-modal-footer-button[pagination]) .cds--btn:focus{border-inline-start:1px solid transparent;box-shadow:none;outline:.125rem solid var(--cds-focus,#0f62fe);outline-offset:-.125rem}:host(cds-button[pagination]:not([disabled])) .cds--btn,:host(cds-modal-footer-button[pagination]:not([disabled])) .cds--btn{color:var(--cds-icon-primary,#161616)}:host(cds-button[pagination]:not([disabled])) .cds--btn:active,:host(cds-modal-footer-button[pagination]:not([disabled])) .cds--btn:active{background-color:var(--cds-layer-hover)}:host(cds-button[pagination][batch-action]:not([disabled])) .cds--btn,:host(cds-modal-footer-button[pagination][batch-action]:not([disabled])) .cds--btn{padding:calc(.875rem - 3px) 1rem}:host(cds-button[pagination][batch-action]:not([disabled])) .cds--btn:focus,:host(cds-modal-footer-button[pagination][batch-action]:not([disabled])) .cds--btn:focus{outline:.125rem solid var(--cds-layer);outline-offset:-.125rem}:host(cds-button[pagination][batch-action]:not([disabled])) :host(cds-button[pagination][has-main-content]:not([disabled])) ::slotted([slot=icon]),:host(cds-button[pagination][batch-action]:not([disabled])) :host(cds-modal-footer-button[pagination][has-main-content]:not([disabled])) ::slotted([slot=icon]),:host(cds-modal-footer-button[pagination][batch-action]:not([disabled])) :host(cds-button[pagination][has-main-content]:not([disabled])) ::slotted([slot=icon]),:host(cds-modal-footer-button[pagination][batch-action]:not([disabled])) :host(cds-modal-footer-button[pagination][has-main-content]:not([disabled])) ::slotted([slot=icon]){margin-inline-start:.25rem;position:static}:host(cds-button[kind=ghost]) .cds--btn--ghost:active,:host(cds-button[kind=ghost]:hover) .cds--btn--ghost{outline:none}:host(cds-button-set) ::slotted(cds-button),:host(cds-side-panel-button-set) ::slotted(cds-button){inline-size:100%;max-inline-size:12.25rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"anhGr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqConfirmDialog", ()=>PdqConfirmDialog);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _modal = require("@carbon/web-components/es/components/modal");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let PdqConfirmDialog = class PdqConfirmDialog extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.actions = [
            "Confirm",
            "Cancel"
        ]; // Default actions
        this.header = "Confirm Action"; // Default header text
        this.message = "Are you sure you want to proceed?"; // Default message
    }
    buttonClicked(action) {
        this.dispatchEvent(new CustomEvent("action-selected", {
            detail: {
                action
            },
            bubbles: true,
            composed: true
        }));
        this.remove(); // Remove the modal from the DOM
    }
    render() {
        return (0, _lit.html)`
            <cds-layer>
            <cds-modal open>
                <cds-modal-header>
                    <cds-modal-label>Confirmation Required</cds-modal-label>
                    <cds-modal-heading>${this.header}</cds-modal-heading>
                </cds-modal-header>
                <cds-modal-body><p>
                    ${this.message}
                </p></cds-modal-body>
                <cds-modal-footer>
                    ${this.actions.map((action)=>(0, _lit.html)`<cds-modal-footer-button class="button" @click="${()=>this.buttonClicked(action)}">${action}</cds-modal-footer-button>`)}
                </cds-modal-footer>
            </cds-modal>
            </cds-layer>
        `;
    }
};
PdqConfirmDialog.styles = (0, _lit.css)`    
      :host {
        --cds-layer: rgba(244,244,244);
        --cds-text-primary: #161616;
      } 
     `;
__decorate([
    (0, _decorators.property)({
        type: Array
    }),
    __metadata("design:type", Array)
], PdqConfirmDialog.prototype, "actions", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqConfirmDialog.prototype, "header", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqConfirmDialog.prototype, "message", void 0);
PdqConfirmDialog = __decorate([
    (0, _decorators.customElement)("pdq-confirm-dialog")
], PdqConfirmDialog);

},{"lit/decorators":"kQrIl","lit":"aCmte","@carbon/web-components/es/components/modal":"6x6o7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6x6o7":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _modalJs = require("./modal.js");
var _modalBodyJs = require("./modal-body.js");
var _modalBodyContentJs = require("./modal-body-content.js");
var _modalCloseButtonJs = require("./modal-close-button.js");
var _modalFooterJs = require("./modal-footer.js");
var _modalFooterButtonJs = require("./modal-footer-button.js");
var _modalHeaderJs = require("./modal-header.js");
var _modalHeadingJs = require("./modal-heading.js");
var _modalLabelJs = require("./modal-label.js");

},{"./modal.js":"ftVD5","./modal-body.js":"jBYzH","./modal-body-content.js":"hNA0o","./modal-close-button.js":"9u6rj","./modal-footer.js":"ftnKE","./modal-footer-button.js":"12xRz","./modal-header.js":"huJsP","./modal-heading.js":"epB5m","./modal-label.js":"iZH2g"}],"ftVD5":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MODAL_SIZE", ()=>(0, _defsJs.MODAL_SIZE));
parcelHelpers.export(exports, "default", ()=>CDSModal$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _defsJs = require("./defs.js");
var _modalScssJs = require("./modal.scss.js");
var _modalScssJsDefault = parcelHelpers.interopDefault(_modalScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ // eslint-disable-next-line no-bitwise
const PRECEDING = Node.DOCUMENT_POSITION_PRECEDING | Node.DOCUMENT_POSITION_CONTAINS;
// eslint-disable-next-line no-bitwise
const FOLLOWING = Node.DOCUMENT_POSITION_FOLLOWING | Node.DOCUMENT_POSITION_CONTAINED_BY;
/**
 * Tries to focus on the given elements and bails out if one of them is successful.
 *
 * @param elems The elements.
 * @param reverse `true` to go through the list in reverse order.
 * @returns `true` if one of the attempts is successful, `false` otherwise.
 */ function tryFocusElems(elems, reverse = false) {
    if (!reverse) for(let i = 0; i < elems.length; ++i){
        const elem = elems[i];
        elem.focus();
        if (elem.ownerDocument.activeElement === elem) return true;
    }
    else for(let i = elems.length - 1; i >= 0; --i){
        const elem = elems[i];
        elem.focus();
        if (elem.ownerDocument.activeElement === elem) return true;
    }
    return false;
}
/**
 * Modal.
 *
 * @element cds-modal
 * @csspart dialog The dialog.
 * @fires cds-modal-beingclosed
 *   The custom event fired before this modal is being closed upon a user gesture.
 *   Cancellation of this event stops the user-initiated action of closing this modal.
 * @fires cds-modal-closed - The custom event fired after this modal is closed upon a user gesture.
 */ let CDSModal = class CDSModal extends (0, _hostListenerJsDefault1.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * The element that had focus before this modal gets open.
         */ this._launcher = null;
        /**
         * Handles `click` event on this element.
         *
         * @param event The event.
         */ this._handleClick = (event)=>{
            if (event.composedPath().indexOf(this.shadowRoot) < 0 && !this.preventCloseOnClickOutside) this._handleUserInitiatedClose(event.target);
        };
        /**
         * Handles `blur` event on this element.
         *
         * @param event The event.
         * @param event.target The event target.
         * @param event.relatedTarget The event relatedTarget.
         */ this._handleBlur = async ({ target, relatedTarget })=>{
            var _a;
            const { open, _startSentinelNode: startSentinelNode, _endSentinelNode: endSentinelNode } = this;
            const oldContains = target !== this && this.contains(target);
            const currentContains = relatedTarget !== this && (this.contains(relatedTarget) || ((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.contains(relatedTarget)) && relatedTarget !== endSentinelNode);
            // Performs focus wrapping if _all_ of the following is met:
            // * This modal is open
            // * The viewport still has focus
            // * Modal body used to have focus but no longer has focus
            const { selectorTabbable: selectorTabbableForModal } = this.constructor;
            if (open && relatedTarget && oldContains && !currentContains) {
                const comparisonResult = target.compareDocumentPosition(relatedTarget);
                // eslint-disable-next-line no-bitwise
                if (relatedTarget === startSentinelNode || comparisonResult & PRECEDING) {
                    await this.constructor._delay();
                    if (!tryFocusElems(this.querySelectorAll(selectorTabbableForModal), true) && relatedTarget !== this) this.focus();
                } else if (relatedTarget === endSentinelNode || comparisonResult & FOLLOWING) {
                    await this.constructor._delay();
                    if (!tryFocusElems(this.querySelectorAll(selectorTabbableForModal))) this.focus();
                }
            }
        };
        this._handleKeydown = ({ key, target })=>{
            if (key === "Esc" || key === "Escape") this._handleUserInitiatedClose(target);
        };
        /**
         * Specify whether the Modal is displaying an alert, error or warning.
         * Should go hand in hand with the danger prop.
         */ this.alert = false;
        /**
         * Specify text for the accessibility label of the header
         */ this.ariaLabel = "";
        /**
         * The additional CSS class names for the container <div> of the element.
         */ this.containerClass = "";
        /**
         * Specify whether or not the Modal content should have any inner padding.
         */ this.fullWidth = false;
        /**
         * Specify whether the modal contains scrolling content
         */ this.hasScrollingContent = false;
        /**
         * `true` if the modal should be open.
         */ this.open = false;
        /**
         * Modal size.
         */ this.size = (0, _defsJs.MODAL_SIZE).MEDIUM;
        /**
         * Prevent closing on click outside of modal
         */ this.preventCloseOnClickOutside = false;
        /**
         * Prevent the modal from closing after clicking the close button
         */ this.preventClose = false;
    }
    /**
     * Handles `click` event on the modal container.
     *
     * @param event The event.
     */ _handleClickContainer(event) {
        if (event.target.matches(this.constructor.selectorCloseButton) && !this.preventClose) this._handleUserInitiatedClose(event.target);
    }
    /**
     * Handles user-initiated close request of this modal.
     *
     * @param triggeredBy The element that triggered this close request.
     */ _handleUserInitiatedClose(triggeredBy) {
        if (this.open) {
            const init = {
                bubbles: true,
                cancelable: true,
                composed: true,
                detail: {
                    triggeredBy
                }
            };
            if (this.dispatchEvent(new CustomEvent(this.constructor.eventBeforeClose, init))) {
                this.open = false;
                this.dispatchEvent(new CustomEvent(this.constructor.eventClose, init));
            }
        }
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange() {
        this.querySelector(`${(0, _settingsJs.prefix)}-modal-footer`) ? this.setAttribute("has-footer", "") : this.removeAttribute("has-footer");
    }
    firstUpdated() {
        const body = this.querySelector(this.constructor.selectorModalBody);
        if (!body) {
            const bodyElement = document.createElement(this.constructor.selectorModalBody);
            this.appendChild(bodyElement);
        }
    }
    render() {
        const { alert, ariaLabel, size, hasScrollingContent } = this;
        const containerClass = this.containerClass.split(" ").filter(Boolean).reduce((acc, item)=>Object.assign(Object.assign({}, acc), {
                [item]: true
            }), {});
        const containerClasses = (0, _classMapJs.classMap)(Object.assign({
            [`${0, _settingsJs.prefix}--modal-container`]: true,
            [`${0, _settingsJs.prefix}--modal-container--${size}`]: size
        }, containerClass));
        return (0, _lit.html)`
      <a
        id="start-sentinel"
        class="${0, _settingsJs.prefix}--visually-hidden"
        href="javascript:void 0"
        role="navigation"></a>
      <div
        aria-label=${ariaLabel}
        part="dialog"
        class=${containerClasses}
        role="${alert ? "alert" : "dialog"}"
        tabindex="-1"
        @click=${this._handleClickContainer}>
        <slot @slotchange="${this._handleSlotChange}"></slot>
        ${hasScrollingContent ? (0, _lit.html)` <div class="cds--modal-content--overflow-indicator"></div> ` : ``}
      </div>
      <a
        id="end-sentinel"
        class="${0, _settingsJs.prefix}--visually-hidden"
        href="javascript:void 0"
        role="navigation"></a>
    `;
    }
    async updated(changedProperties) {
        if (changedProperties.has("open")) {
            if (this.open) {
                this._launcher = this.ownerDocument.activeElement;
                const primaryFocusNode = this.querySelector(this.constructor.selectorPrimaryFocus);
                await this.constructor._delay();
                if (primaryFocusNode) // For cases where a `carbon-web-components` component (e.g. `<cds-button>`) being `primaryFocusNode`,
                // where its first update/render cycle that makes it focusable happens after `<cds-modal>`'s first update/render cycle
                primaryFocusNode.focus();
                else if (!tryFocusElems(this.querySelectorAll(this.constructor.selectorTabbable), true)) this.focus();
            } else if (this._launcher && typeof this._launcher.focus === "function") {
                this._launcher.focus();
                this._launcher = null;
            }
        }
    }
    /**
     * @param ms The number of milliseconds.
     * @returns A promise that is resolves after the given milliseconds.
     */ static _delay(ms = 0) {
        return new Promise((resolve)=>{
            setTimeout(resolve, ms);
        });
    }
    /**
     * A selector selecting buttons that should close this modal.
     */ static get selectorCloseButton() {
        return `[data-modal-close],${0, _settingsJs.prefix}-modal-close-button`;
    }
    /**
     * A selector selecting tabbable nodes.
     */ static get selectorTabbable() {
        return 0, _settingsJs.selectorTabbable;
    }
    /**
     * A selector selecting the nodes that should be focused when modal gets open.
     */ static get selectorPrimaryFocus() {
        return `[data-modal-primary-focus],${0, _settingsJs.prefix}-modal-footer ${0, _settingsJs.prefix}-button[kind="primary"]`;
    }
    /**
     * A selector selecting the modal body component
     */ static get selectorModalBody() {
        return `${0, _settingsJs.prefix}-modal-body`;
    }
    /**
     * The name of the custom event fired before this modal is being closed upon a user gesture.
     * Cancellation of this event stops the user-initiated action of closing this modal.
     */ static get eventBeforeClose() {
        return `${0, _settingsJs.prefix}-modal-beingclosed`;
    }
    /**
     * The name of the custom event fired after this modal is closed upon a user gesture.
     */ static get eventClose() {
        return `${0, _settingsJs.prefix}-modal-closed`;
    }
};
CDSModal.styles = (0, _modalScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#start-sentinel")
], CDSModal.prototype, "_startSentinelNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#end-sentinel")
], CDSModal.prototype, "_endSentinelNode", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("click")
], CDSModal.prototype, "_handleClick", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("shadowRoot:focusout")
], CDSModal.prototype, "_handleBlur", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("document:keydown")
], CDSModal.prototype, "_handleKeydown", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSModal.prototype, "alert", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "aria-label"
    })
], CDSModal.prototype, "ariaLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "container-class"
    })
], CDSModal.prototype, "containerClass", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "full-width"
    })
], CDSModal.prototype, "fullWidth", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "has-scrolling-content"
    })
], CDSModal.prototype, "hasScrollingContent", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSModal.prototype, "open", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSModal.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "prevent-close-on-click-outside"
    })
], CDSModal.prototype, "preventCloseOnClickOutside", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "prevent-close"
    })
], CDSModal.prototype, "preventClose", void 0);
CDSModal = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-modal`)
], CDSModal);
var CDSModal$1 = CDSModal;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/host-listener.js":"1SMUX","./defs.js":"1FDpD","./modal.scss.js":"lHLCk","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1FDpD":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Modal size.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MODAL_SIZE", ()=>MODAL_SIZE);
var MODAL_SIZE;
(function(MODAL_SIZE) {
    /**
     * Extra small size.
     */ MODAL_SIZE["EXTRA_SMALL"] = "xs";
    /**
     * Small size.
     */ MODAL_SIZE["SMALL"] = "sm";
    /**
     * Medium size.
     */ MODAL_SIZE["MEDIUM"] = "md";
    /**
     * Large size.
     */ MODAL_SIZE["LARGE"] = "lg";
})(MODAL_SIZE || (MODAL_SIZE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lHLCk":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two,:host(cds-modal-body){--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--modal,:host(cds-modal){align-items:center;background-color:var(--cds-overlay,hsla(0,0%,9%,.5));block-size:100vh;content:"";display:flex;inline-size:100vw;inset-block-start:0;inset-inline-start:0;justify-content:center;opacity:0;position:fixed;transition:opacity .24s cubic-bezier(.4,.14,1,1),visibility 0ms linear .24s;visibility:hidden;z-index:9000}.cds--modal.is-visible{opacity:1;transition:opacity .24s cubic-bezier(0,0,.3,1),visibility 0ms linear;visibility:inherit}@media screen and (prefers-reduced-motion:reduce){.cds--modal.is-visible{transition:none}}.cds--modal .cds--date-picker--fluid .ccdsds--date-picker-input__wrapper .cds--date-picker__input,.cds--modal .cds--list-box__wrapper--fluid .cds--list-box,.cds--modal .cds--list-box__wrapper--fluid.cds--list-box__wrapper,.cds--modal .cds--number-input--fluid .cds--number__control-btn:after,.cds--modal .cds--number-input--fluid .cds--number__control-btn:before,.cds--modal .cds--number-input--fluid input[type=number],.cds--modal .cds--search--fluid .cds--search-input,.cds--modal .cds--select--fluid .cds--select-input,.cds--modal .cds--text-area--fluid .cds--text-area,.cds--modal .cds--text-area--fluid .cds--text-area__wrapper,.cds--modal .cds--text-area--fluid .cds--text-area__wrapper[data-invalid] .cds--text-area__divider+.cds--form-requirement,.cds--modal .cds--text-input--fluid .cds--text-input,:host(cds-modal) .cds--date-picker--fluid .ccdsds--date-picker-input__wrapper .cds--date-picker__input,:host(cds-modal) .cds--list-box__wrapper--fluid .cds--list-box,:host(cds-modal) .cds--list-box__wrapper--fluid.cds--list-box__wrapper,:host(cds-modal) .cds--number-input--fluid .cds--number__control-btn:after,:host(cds-modal) .cds--number-input--fluid .cds--number__control-btn:before,:host(cds-modal) .cds--number-input--fluid input[type=number],:host(cds-modal) .cds--search--fluid .cds--search-input,:host(cds-modal) .cds--select--fluid .cds--select-input,:host(cds-modal) .cds--text-area--fluid .cds--text-area,:host(cds-modal) .cds--text-area--fluid .cds--text-area__wrapper,:host(cds-modal) .cds--text-area--fluid .cds--text-area__wrapper[data-invalid] .cds--text-area__divider+.cds--form-requirement,:host(cds-modal) .cds--text-input--fluid .cds--text-input{background-color:var(--cds-field-01,#f4f4f4)}.cds--modal .cds--list-box__wrapper--fluid .cds--list-box__menu,:host(cds-modal) .cds--list-box__wrapper--fluid .cds--list-box__menu{background-color:var(--cds-layer-01,#f4f4f4)}.cds--modal .cds--list-box__menu-item:hover,:host(cds-modal) .cds--list-box__menu-item:hover{background-color:var(--cds-layer-hover-02,#e8e8e8)}.cds--modal .cds--list-box__menu-item--active,:host(cds-modal) .cds--list-box__menu-item--active{background-color:var(--cds-layer-selected-02,#e0e0e0)}.cds--modal .cds--list-box__menu-item--active:hover,:host(cds-modal) .cds--list-box__menu-item--active:hover{background-color:var(--cds-layer-selected-hover-02,#d1d1d1)}.cds--modal .cds--number-input--fluid .cds--number__control-btn:hover:after,.cds--modal .cds--number-input--fluid .cds--number__control-btn:hover:before,:host(cds-modal) .cds--number-input--fluid .cds--number__control-btn:hover:after,:host(cds-modal) .cds--number-input--fluid .cds--number__control-btn:hover:before{background-color:var(--cds-field-hover)}.cds--modal .cds--number-input--fluid .cds--number__control-btn:focus:after,.cds--modal .cds--number-input--fluid .cds--number__control-btn:focus:before,:host(cds-modal) .cds--number-input--fluid .cds--number__control-btn:focus:after,:host(cds-modal) .cds--number-input--fluid .cds--number__control-btn:focus:before{border-inline-start:2px solid var(--cds-focus,#0f62fe)}.cds--modal.is-visible .cds--modal-container{transform:translateZ(0);transition:transform .24s cubic-bezier(0,0,.3,1)}.cds--modal-container{background-color:var(--cds-layer);block-size:100%;display:grid;grid-template-columns:100%;grid-template-rows:auto 1fr auto;inline-size:100%;inset-block-start:0;max-block-size:100%;outline:3px solid transparent;outline-offset:-3px;position:fixed;transform:translate3d(0,-24px,0);transform-origin:top center;transition:transform .24s cubic-bezier(.4,.14,1,1)}@media (min-width:42rem){.cds--modal-container{block-size:auto;inline-size:84%;max-block-size:90%;position:static}}@media (min-width:66rem){.cds--modal-container{inline-size:60%;max-block-size:84%}}@media (min-width:82rem){.cds--modal-container{inline-size:48%}}.cds--modal-container .cds--modal-container-body{display:contents}.cds--modal-content,:host(cds-modal-body){color:var(--cds-text-primary,#161616);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);font-weight:400;grid-column:1/-1;grid-row:2/-2;letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);overflow-y:auto;padding-block:.5rem 3rem;padding-inline:1rem 1rem;position:relative}.cds--modal-content:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--modal-content:focus{outline-style:dotted}}.cds--modal-content .cds--form--fluid,:host(cds-modal-body) .cds--form--fluid{margin-inline:-2rem}.cds--modal-content>p,.cds--modal-content__regular-content,:host(cds-modal-body)>p{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);padding-inline-end:calc(20% - 2rem)}.cds--modal-content--with-form{padding-inline-end:1rem}.cds--modal-header,:host(cds-modal-header){grid-column:1/-1;grid-row:1/1;margin-block-end:.5rem;padding-block-start:1rem;padding-inline:1rem 3rem}.cds--modal-header__label,:host(cds-modal-label){border:0;box-sizing:border-box;color:var(--cds-text-secondary,#525252);font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;margin-block-end:.25rem;padding:0;vertical-align:baseline}.cds--modal-header__label *,.cds--modal-header__label :after,.cds--modal-header__label :before,:host(cds-modal-label) *,:host(cds-modal-label) :after,:host(cds-modal-label) :before{box-sizing:inherit}.cds--modal-header__heading,:host(cds-modal-heading){border:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);font-family:inherit;font-size:100%;font-size:var(--cds-heading-03-font-size,1.25rem);font-weight:var(--cds-heading-03-font-weight,400);letter-spacing:var(--cds-heading-03-letter-spacing,0);line-height:var(--cds-heading-03-line-height,1.4);margin:0;padding:0;padding-inline-end:calc(20% - 3rem);vertical-align:baseline}.cds--modal-header__heading *,.cds--modal-header__heading :after,.cds--modal-header__heading :before,:host(cds-modal-heading) *,:host(cds-modal-heading) :after,:host(cds-modal-heading) :before{box-sizing:inherit}.cds--modal-container--xs .cds--modal-content__regular-content{padding-inline-end:1rem}.cds--modal-container--xs .cds--modal-content>p,.cds--modal-container--xs :host(cds-modal-body)>p{padding-inline-end:0}@media (min-width:42rem){.cds--modal-container--xs{inline-size:48%}}@media (min-width:66rem){.cds--modal-container--xs{inline-size:32%;max-block-size:48%}}@media (min-width:82rem){.cds--modal-container--xs{inline-size:24%}}.cds--modal-container--sm .cds--modal-content__regular-content{padding-inline-end:1rem}.cds--modal-container--sm .cds--modal-content>p,.cds--modal-container--sm :host(cds-modal-body)>p{padding-inline-end:0}@media (min-width:42rem){.cds--modal-container--sm{inline-size:60%}}@media (min-width:66rem){.cds--modal-container--sm{inline-size:42%;max-block-size:72%}.cds--modal-container--sm .cds--modal-content>p,.cds--modal-container--sm .cds--modal-content__regular-content,.cds--modal-container--sm :host(cds-modal-body)>p{padding-inline-end:20%}}@media (min-width:82rem){.cds--modal-container--sm{inline-size:36%}}@media (min-width:42rem){.cds--modal-container--lg{inline-size:96%}}@media (min-width:66rem){.cds--modal-container--lg{inline-size:84%;max-block-size:96%}}@media (min-width:82rem){.cds--modal-container--lg{inline-size:72%}}.cds--modal-scroll-content,:host(cds-modal[has-scrolling-content]) ::slotted(cds-modal-body){border-block-end:2px solid transparent;-webkit-mask-image:linear-gradient(to bottom,var(--cds-layer) calc(100% - 80px),transparent calc(100% - 48px),transparent 100%),linear-gradient(to left,var(--cds-layer) 0,16px,transparent 16px),linear-gradient(to right,var(--cds-layer) 0,2px,transparent 2px),linear-gradient(to top,var(--cds-layer) 0,2px,transparent 2px);mask-image:linear-gradient(to bottom,var(--cds-layer) calc(100% - 80px),transparent calc(100% - 48px),transparent 100%),linear-gradient(to left,var(--cds-layer) 0,16px,transparent 16px),linear-gradient(to right,var(--cds-layer) 0,2px,transparent 2px),linear-gradient(to top,var(--cds-layer) 0,2px,transparent 2px)}.cds--modal-scroll-content:has(.cds--autoalign),:host(cds-modal[has-scrolling-content]) :has(.cds--autoalign)::slotted(cds-modal-body){-webkit-mask-image:none;mask-image:none}.cds--modal-scroll-content>:last-child,:host(cds-modal[has-scrolling-content]) ::slotted(cds-modal-body)>:last-child{margin-block-end:1.5rem}.cds--modal-footer,:host(cds-modal-footer){block-size:4rem;display:flex;grid-column:1/-1;grid-row:-1/-1;justify-content:flex-end;margin-block-start:auto}.cds--modal-footer .cds--btn,:host(cds-modal-footer) .cds--btn{align-items:baseline;block-size:4rem;flex:0 1 50%;margin:0;max-inline-size:none}.cds--modal-footer .cds--btn:not(.cds--skeleton),:host(cds-modal-footer) .cds--btn:not(.cds--skeleton){padding-block:.875rem 2rem}.cds--modal-footer--three-button .cds--btn,:host(cds-modal-footer[has-three-buttons]) .cds--btn{align-items:flex-start;flex:0 1 25%}.cds--modal-close-button,:host(cds-modal-close-button){inset-block-start:0;inset-inline-end:0;position:absolute}.cds--modal-close{background-color:transparent;block-size:3rem;border:2px solid transparent;cursor:pointer;inline-size:3rem;padding:.75rem;transition:background-color .11s cubic-bezier(.2,0,.38,.9)}.cds--modal-close:hover{background-color:var(--cds-layer-hover)}.cds--modal-close:focus{border-color:var(--cds-focus,#0f62fe);outline:none}.cds--modal-close::-moz-focus-inner{border:0}.cds--modal-close__icon{block-size:1.25rem;fill:var(--cds-icon-primary,#161616);inline-size:1.25rem}.cds--body--with-modal-open{overflow:hidden}.cds--body--with-modal-open .cds--modal .cds--overflow-menu-options,.cds--body--with-modal-open .cds--modal .cds--tooltip,.cds--body--with-modal-open .cds--overflow-menu-options,.cds--body--with-modal-open :host(cds-modal) .cds--tooltip{z-index:9000}.cds--modal-container--full-width .cds--modal-content,.cds--modal-container--full-width :host(cds-modal-body){margin:0;padding:0}.cds--modal--decorator:has(.cds--ai-label).cds--modal,.cds--modal--slug.cds--modal{background-color:var(--cds-ai-overlay,rgba(0,17,65,.5))}.cds--modal--decorator:has(.cds--ai-label) .cds--modal-container,.cds--modal--slug .cds--modal-container{background:linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)) 0,var(--cds-ai-aura-start,rgba(69,137,255,.1)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%) padding-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) padding-box,linear-gradient(to bottom,var(--cds-ai-border-start,rgba(166,200,255,.64)),var(--cds-ai-border-end,#78a9ff)) border-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) border-box;background-color:var(--cds-layer);border:1px solid transparent;box-shadow:inset 0 -80px 70px -65px var(--cds-ai-inner-shadow,rgba(69,137,255,.1)),0 24px 40px -24px var(--cds-ai-drop-shadow,rgba(15,98,254,.1))}.cds--modal--decorator:has(.cds--ai-label) .cds--modal-container:has(.cds--modal-footer,:host(cds-modal-footer)),.cds--modal--slug .cds--modal-container:has(.cds--modal-footer,:host(cds-modal-footer)){background:linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)) 64px,var(--cds-ai-aura-start,rgba(69,137,255,.1)) 64px,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%) padding-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) padding-box,linear-gradient(to bottom,var(--cds-ai-border-start,rgba(166,200,255,.64)),var(--cds-ai-border-end,#78a9ff)) border-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) border-box;box-shadow:inset 0 -80px 0 -16px var(--cds-layer),inset 0 -160px 70px -65px var(--cds-ai-inner-shadow,rgba(69,137,255,.1)),0 24px 40px -24px var(--cds-ai-drop-shadow,rgba(15,98,254,.1))}.cds--modal--decorator .cds--modal-content.cds--modal-scroll-content,.cds--modal--slug .cds--modal-content.cds--modal-scroll-content,:host(cds-modal[has-scrolling-content]) .cds--modal--decorator .cds--modal-content::slotted(cds-modal-body),:host(cds-modal[has-scrolling-content]) .cds--modal--decorator :host(cds-modal-body)::slotted(cds-modal-body),:host(cds-modal[has-scrolling-content]) .cds--modal--slug .cds--modal-content::slotted(cds-modal-body),:host(cds-modal[has-scrolling-content]) .cds--modal--slug :host(cds-modal-body)::slotted(cds-modal-body){-webkit-mask-image:linear-gradient(to bottom,var(--cds-layer) calc(100% - 80px),transparent calc(100% - 48px),transparent 100%),linear-gradient(to left,var(--cds-layer) 0,16px,transparent 16px),linear-gradient(to right,var(--cds-layer) 0,2px,transparent 2px),linear-gradient(to top,var(--cds-layer) 0,2px,transparent 2px);mask-image:linear-gradient(to bottom,var(--cds-layer) calc(100% - 80px),transparent calc(100% - 48px),transparent 100%),linear-gradient(to left,var(--cds-layer) 0,16px,transparent 16px),linear-gradient(to right,var(--cds-layer) 0,2px,transparent 2px),linear-gradient(to top,var(--cds-layer) 0,2px,transparent 2px)}.cds--modal--decorator .cds--modal-container-body>.cds--modal--inner__decorator>*,.cds--modal--slug .cds--modal-container-body>.cds--ai-label,.cds--modal--slug .cds--modal-container-body>.cds--slug,.cds--modal-header>.cds--ai-label:has(+.cds--modal-close-button,+:host(cds-modal-close-button)),.cds--modal-header>.cds--modal--inner__decorator:has(+.cds--modal-close-button,+:host(cds-modal-close-button))>*,.cds--modal-header>.cds--modal-close-button~.cds--ai-label,.cds--modal-header>.cds--modal-close-button~.cds--modal--inner__decorator>*,.cds--modal-header>.cds--modal-close-button~.cds--slug,.cds--modal-header>.cds--slug:has(+.cds--modal-close-button,+:host(cds-modal-close-button)),.cds--modal-header>:host(cds-modal-close-button)~.cds--ai-label,.cds--modal-header>:host(cds-modal-close-button)~.cds--modal--inner__decorator>*,.cds--modal-header>:host(cds-modal-close-button)~.cds--slug,:host(cds-modal-header)>.cds--ai-label:has(+.cds--modal-close-button,+:host(cds-modal-close-button)),:host(cds-modal-header)>.cds--modal--inner__decorator:has(+.cds--modal-close-button,+:host(cds-modal-close-button))>*,:host(cds-modal-header)>.cds--modal-close-button~.cds--ai-label,:host(cds-modal-header)>.cds--modal-close-button~.cds--modal--inner__decorator>*,:host(cds-modal-header)>.cds--modal-close-button~.cds--slug,:host(cds-modal-header)>.cds--slug:has(+.cds--modal-close-button,+:host(cds-modal-close-button)),:host(cds-modal-header)>:host(cds-modal-close-button)~.cds--ai-label,:host(cds-modal-header)>:host(cds-modal-close-button)~.cds--modal--inner__decorator>*,:host(cds-modal-header)>:host(cds-modal-close-button)~.cds--slug{inset-block-start:.625rem;inset-inline-end:3rem;position:absolute}.cds--modal-header>.cds--modal--inner__decorator:not(:has(.cds--ai-label))>*,:host(cds-modal-header)>.cds--modal--inner__decorator:not(:has(.cds--ai-label))>*{inset-block-start:1rem}.cds--modal-header>.cds--modal--inner__decorator:has(.cds--ai-label--revert)>*,:host(cds-modal-header)>.cds--modal--inner__decorator:has(.cds--ai-label--revert)>*{inset-block-start:1.475rem}.cds--modal--decorator .cds--modal-content--overflow-indicator,.cds--modal--decorator .cds--modal-content--overflow-indicator:before{display:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--modal-close__icon{fill:ButtonText}.cds--modal-close:focus{color:Highlight;outline:1px solid Highlight}}:host(cds-modal[open]){opacity:1;transition:opacity .24s cubic-bezier(0,0,.3,1),visibility 0ms linear;visibility:inherit}:host(cds-modal[open]) .cds--modal-container{transform:translateZ(0);transition:transform .24s cubic-bezier(0,0,.3,1)}@media screen and (prefers-reduced-motion:reduce){:host(cds-modal[open]){transition:none}}:host(cds-modal[full-width]) ::slotted(cds-modal-body){margin:0;padding:0}:host(cds-modal-close-button){outline:none}:host(cds-modal-heading),:host(cds-modal-label){display:block}:host(cds-modal-body) ::slotted(cds-form-item){margin-block-end:1rem}:host(cds-modal-body) ::slotted(cds-select:last-of-type){padding-block-end:0}:host(cds-modal-body) ::slotted(:last-child){padding-block-end:2rem}:host(cds-modal-body-content){display:block;font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);padding-inline-end:calc(20% - 2rem)}:host(cds-modal-body-content[description]){margin-block-end:1rem}:host(cds-modal-footer[has-three-buttons]) ::slotted(cds-modal-footer-button){flex:0 1 25%}:host(cds-modal-footer-button:first-of-type) .cds--btn{box-shadow:inherit}:host(cds-modal-footer-button) .cds--btn{block-size:100%;box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0);inline-size:100%;max-inline-size:none;padding-block:1rem 2rem}:host(cds-modal-footer-button) .cds--btn:focus{box-shadow:inset 0 0 0 1px var(--cds-focus,#0f62fe),inset 0 0 0 2px var(--cds-background,#fff)}:host(cds-modal-footer) ::slotted(cds-button),:host(cds-modal-footer-button){block-size:4rem;flex:0 1 50%;inline-size:50%;margin:0;max-inline-size:none}:host(cds-modal[ai-label]){background-color:var(--cds-ai-overlay,rgba(0,17,65,.5))}:host(cds-modal[ai-label]) .cds--modal-container{background:linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)) 0,var(--cds-ai-aura-start,rgba(69,137,255,.1)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%) padding-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) padding-box,linear-gradient(to bottom,var(--cds-ai-border-start,rgba(166,200,255,.64)),var(--cds-ai-border-end,#78a9ff)) border-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) border-box;background-color:var(--cds-layer);border:1px solid transparent;box-shadow:inset 0 -80px 70px -65px var(--cds-ai-inner-shadow,rgba(69,137,255,.1)),0 24px 40px -24px var(--cds-ai-drop-shadow,rgba(15,98,254,.1))}:host(cds-modal[ai-label][has-footer]) .cds--modal-container{background:linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)) 64px,var(--cds-ai-aura-start,rgba(69,137,255,.1)) 64px,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%) padding-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) padding-box,linear-gradient(to bottom,var(--cds-ai-border-start,rgba(166,200,255,.64)),var(--cds-ai-border-end,#78a9ff)) border-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) border-box;box-shadow:inset 0 -80px 0 -16px var(--cds-layer),inset 0 -160px 70px -65px var(--cds-ai-inner-shadow,rgba(69,137,255,.1)),0 24px 40px -24px var(--cds-ai-drop-shadow,rgba(15,98,254,.1))}:host(cds-modal[ai-label][has-scrolling-content]) ::slotted(cds-modal-body){-webkit-mask-image:linear-gradient(to bottom,var(--cds-layer) calc(100% - 80px),transparent calc(100% - 48px),transparent 100%),linear-gradient(to left,var(--cds-layer) 0,16px,transparent 16px),linear-gradient(to right,var(--cds-layer) 0,2px,transparent 2px),linear-gradient(to top,var(--cds-layer) 0,2px,transparent 2px);mask-image:linear-gradient(to bottom,var(--cds-layer) calc(100% - 80px),transparent calc(100% - 48px),transparent 100%),linear-gradient(to left,var(--cds-layer) 0,16px,transparent 16px),linear-gradient(to right,var(--cds-layer) 0,2px,transparent 2px),linear-gradient(to top,var(--cds-layer) 0,2px,transparent 2px)}:host(cds-modal[ai-label]) .cds--modal-content--overflow-indicator,:host(cds-modal[ai-label]) .cds--modal-content--overflow-indicator:before{display:none}:host(cds-modal-header) ::slotted(cds-ai-label),:host(cds-modal-header) ::slotted(cds-slug){inset-block-start:0;inset-inline-end:0;position:absolute}:host(cds-modal-header[close-button]) ::slotted(cds-ai-label),:host(cds-modal-header[close-button]) ::slotted(cds-slug){inset-block-start:.625rem;inset-inline-end:3rem;position:absolute}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jBYzH":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSModalBody$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _modalScssJs = require("./modal.scss.js");
var _modalScssJsDefault = parcelHelpers.interopDefault(_modalScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Modal body.
 *
 * @element cds-modal-body
 */ let CDSModalBody = class CDSModalBody extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSModalBody.styles = (0, _modalScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
CDSModalBody = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-modal-body`)
], CDSModalBody);
var CDSModalBody$1 = CDSModalBody;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./modal.scss.js":"lHLCk","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hNA0o":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSModalBodyContent$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _modalScssJs = require("./modal.scss.js");
var _modalScssJsDefault = parcelHelpers.interopDefault(_modalScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Modal body content
 *
 * @element cds-modal-body-content
 */ let CDSModalBodyContent = class CDSModalBodyContent extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)`<slot></slot>`;
    }
};
CDSModalBodyContent.styles = (0, _modalScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
CDSModalBodyContent = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-modal-body-content`)
], CDSModalBodyContent);
var CDSModalBodyContent$1 = CDSModalBodyContent;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./modal.scss.js":"lHLCk","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9u6rj":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSModalCloseButton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _20Js = require("../../icons/close/20.js");
var _20JsDefault = parcelHelpers.interopDefault(_20Js);
var _settingsJs = require("../../globals/settings.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _modalScssJs = require("./modal.scss.js");
var _modalScssJsDefault = parcelHelpers.interopDefault(_modalScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Modal close button.
 *
 * @element cds-modal-close-button
 * @csspart button The button.
 * @csspart close-icon The close icon.
 */ let CDSModalCloseButton = class CDSModalCloseButton extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * Specify a label for the close button of the modal; defaults to close
         */ this.closeButtonLabel = "Close";
    }
    updated() {
        var _a;
        (_a = this.parentElement) === null || _a === void 0 || _a.setAttribute("close-button", "");
    }
    render() {
        const { closeButtonLabel } = this;
        return (0, _lit.html)`
      <button
        part="button"
        aria-label="${(0, _ifDefinedJs.ifDefined)(closeButtonLabel)}"
        class="${0, _settingsJs.prefix}--modal-close"
        title="${(0, _ifDefinedJs.ifDefined)(closeButtonLabel)}">
        ${(0, _20JsDefault.default)({
            part: "close-icon",
            class: `${(0, _settingsJs.prefix)}--modal-close__icon`
        })}
      </button>
    `;
    }
};
CDSModalCloseButton.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSModalCloseButton.styles = (0, _modalScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom WebPack loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "close-button-label"
    })
], CDSModalCloseButton.prototype, "closeButtonLabel", void 0);
CDSModalCloseButton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-modal-close-button`)
], CDSModalCloseButton);
var CDSModalCloseButton$1 = CDSModalCloseButton;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/close/20.js":"4EJkx","../../globals/settings.js":"EipuL","lit/directives/if-defined.js":"hSgrS","../../globals/mixins/focus.js":"5k7ow","./modal.scss.js":"lHLCk","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4EJkx":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M17.4141 16L24 9.4141 22.5859 8 16 14.5859 9.4143 8 8 9.4141 14.5859 16 8 22.5859 9.4143 24 16 17.4141 22.5859 24 24 22.5859 17.4141 16z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ftnKE":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSModalFooter$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _modalScssJs = require("./modal.scss.js");
var _modalScssJsDefault = parcelHelpers.interopDefault(_modalScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Modal footer.
 *
 * @element cds-modal-footer
 */ let CDSModalFooter = class CDSModalFooter extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if this modal footer has more than two buttons.
         */ this.hasThreeButtons = false;
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange(event) {
        const { selectorButtons } = this.constructor;
        this.hasThreeButtons = event.target.assignedNodes().filter((node)=>node.nodeType === Node.ELEMENT_NODE && node.matches(selectorButtons)).length > 2;
        this.requestUpdate();
    }
    render() {
        return (0, _lit.html)` <slot @slotchange="${this._handleSlotChange}"></slot> `;
    }
    /**
     * A selector that selects the child buttons.
     */ static get selectorButtons() {
        return `${0, _settingsJs.prefix}-button,${0, _settingsJs.prefix}-modal-footer-button`;
    }
};
CDSModalFooter.styles = (0, _modalScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "has-three-buttons"
    })
], CDSModalFooter.prototype, "hasThreeButtons", void 0);
CDSModalFooter = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-modal-footer`)
], CDSModalFooter);
var CDSModalFooter$1 = CDSModalFooter;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./modal.scss.js":"lHLCk","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"12xRz":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSModalFooterButton$1);
var _tslib = require("tslib");
var _settingsJs = require("../../globals/settings.js");
var _buttonJs = require("../button/button.js");
var _buttonJsDefault = parcelHelpers.interopDefault(_buttonJs);
var _buttonScssJs = require("../button/button.scss.js");
var _buttonScssJsDefault = parcelHelpers.interopDefault(_buttonScssJs);
var _modalScssJs = require("./modal.scss.js");
var _modalScssJsDefault = parcelHelpers.interopDefault(_modalScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2021, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Modal footer button.
 *
 * @element cds-modal-footer-button
 */ let CDSModalFooterButton = class CDSModalFooterButton extends (0, _buttonJsDefault.default) {
};
CDSModalFooterButton.styles = [
    (0, _buttonScssJsDefault.default),
    (0, _modalScssJsDefault.default)
]; // `styles` here is a `CSSResult` generated by custom Vite loader
CDSModalFooterButton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-modal-footer-button`)
], CDSModalFooterButton);
var CDSModalFooterButton$1 = CDSModalFooterButton;

},{"tslib":"gBS4y","../../globals/settings.js":"EipuL","../button/button.js":"ca52G","../button/button.scss.js":"ffMSy","./modal.scss.js":"lHLCk","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"huJsP":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSModalHeader$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _modalScssJs = require("./modal.scss.js");
var _modalScssJsDefault = parcelHelpers.interopDefault(_modalScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Modal header.
 *
 * @element cds-modal-header
 */ let CDSModalHeader = class CDSModalHeader extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || // remove reference to slug in v12
            elem.matches(this.constructor.slugItem) : false);
        if (hasContent.length > 0) {
            this._hasAILabel = Boolean(hasContent);
            hasContent[0].setAttribute("size", "sm");
        }
        this.requestUpdate();
    }
    updated() {
        var _a, _b;
        if (this._hasAILabel) (_a = this.parentElement) === null || _a === void 0 || _a.setAttribute("ai-label", "");
        else (_b = this.parentElement) === null || _b === void 0 || _b.removeAttribute("ai-label");
    }
    render() {
        return (0, _lit.html)` <slot></slot>
      <slot name="ai-label" @slotchange="${this._handleSlotChange}"></slot>
      <slot name="slug" @slotchange="${this._handleSlotChange}"></slot>`;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
};
CDSModalHeader.styles = (0, _modalScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom WebPack loader
CDSModalHeader = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-modal-header`)
], CDSModalHeader);
var CDSModalHeader$1 = CDSModalHeader;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./modal.scss.js":"lHLCk","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"epB5m":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSModalHeading$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _modalScssJs = require("./modal.scss.js");
var _modalScssJsDefault = parcelHelpers.interopDefault(_modalScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Modal heading.
 *
 * @element cds-modal-heading
 */ let CDSModalHeading = class CDSModalHeading extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSModalHeading.styles = (0, _modalScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
CDSModalHeading = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-modal-heading`)
], CDSModalHeading);
var CDSModalHeading$1 = CDSModalHeading;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./modal.scss.js":"lHLCk","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iZH2g":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSModalLabel$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _modalScssJs = require("./modal.scss.js");
var _modalScssJsDefault = parcelHelpers.interopDefault(_modalScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Modal label.
 *
 * @element cds-modal-label
 */ let CDSModalLabel = class CDSModalLabel extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSModalLabel.styles = (0, _modalScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
CDSModalLabel = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-modal-label`)
], CDSModalLabel);
var CDSModalLabel$1 = CDSModalLabel;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./modal.scss.js":"lHLCk","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cm0HP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqPdfViewer", ()=>PdqPdfViewer);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _modal = require("@carbon/web-components/es/components/modal");
var _utils = require("../utils");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
const log = (0, _debugDefault.default)("pdq:ui:pdq-pdf-viewer");
const safeFireAndForget = (0, _utils.safeFireAndForgetFactory)(log);
let PdqPdfViewer = class PdqPdfViewer extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.pageNumber = 1;
        this.zoomLevel = "";
        this.viewMode = "Fit";
        this.search = "";
        this.pageMode = "none";
        this.toolbar = true;
        this.statusbar = true;
        this.viewrect = "";
        this.nameddest = "";
        this._blob = undefined;
        this._url = undefined;
    }
    get blob() {
        return this._blob;
    }
    set blob(value) {
        log("set blob");
        this._url = undefined;
        this._blob = value;
    }
    get url() {
        return this._url;
    }
    set url(value) {
        log("set url");
        this._url = value;
        this._blob = undefined;
        safeFireAndForget(this.loadUrl());
    }
    render() {
        if (!this._blob) return (0, _lit.html)``;
        const url = URL.createObjectURL(this._blob);
        const params = [];
        if (this.pageNumber) params.push(`page=${this.pageNumber}`);
        if (this.zoomLevel) params.push(`zoom=${this.zoomLevel}`);
        if (this.viewMode && !this.zoomLevel) params.push(`view=${this.viewMode}`);
        if (this.search) params.push(`search=${this.search}`);
        if (this.pageMode) params.push(`pagemode=${this.pageMode}`);
        if (!this.toolbar) params.push("toolbar=0");
        if (!this.statusbar) params.push("statusbar=0");
        if (this.viewrect) params.push(`viewrect=${this.viewrect}`);
        if (this.nameddest) params.push(`nameddest=${this.nameddest}`);
        const src = `${url}#${params.join("&")}`;
        this.shadowRoot.innerHTML = `<iframe 
      src="${src}"
      @load="${this._revokeBlobUrl}">
      ></iframe>`;
    }
    _revokeBlobUrl() {
        if (this._url) URL.revokeObjectURL(this._url);
    }
    async loadUrl() {
        log("loadUrl");
        if (!this.url) return;
        const response = await fetch(this.url);
        this._blob = await response.blob();
        this.requestUpdate("blob");
    }
};
PdqPdfViewer.styles = (0, _lit.css)`
    iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
  `;
__decorate([
    (0, _decorators.property)({
        type: Number
    }),
    __metadata("design:type", Object)
], PdqPdfViewer.prototype, "pageNumber", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqPdfViewer.prototype, "zoomLevel", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqPdfViewer.prototype, "viewMode", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqPdfViewer.prototype, "search", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqPdfViewer.prototype, "pageMode", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqPdfViewer.prototype, "toolbar", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqPdfViewer.prototype, "statusbar", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqPdfViewer.prototype, "viewrect", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqPdfViewer.prototype, "nameddest", void 0);
__decorate([
    (0, _decorators.property)({
        type: Object
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [
        Object
    ])
], PdqPdfViewer.prototype, "blob", null);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [
        Object
    ])
], PdqPdfViewer.prototype, "url", null);
__decorate([
    (0, _decorators.query)("#container"),
    __metadata("design:type", typeof (_c = typeof HTMLDivElement !== "undefined" && HTMLDivElement) === "function" ? _c : Object)
], PdqPdfViewer.prototype, "container", void 0);
PdqPdfViewer = __decorate([
    (0, _decorators.customElement)("pdq-pdf-viewer")
], PdqPdfViewer);

},{"lit/decorators":"kQrIl","lit":"aCmte","@carbon/web-components/es/components/modal":"6x6o7","../utils":"i8jxn","debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i8jxn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractTextFromScripts", ()=>extractTextFromScripts);
parcelHelpers.export(exports, "extractTextAndScripts", ()=>extractTextAndScripts);
parcelHelpers.export(exports, "getSha256", ()=>getSha256);
parcelHelpers.export(exports, "calculateFileMD5", ()=>calculateFileMD5);
parcelHelpers.export(exports, "safeSlugifyFilename", ()=>safeSlugifyFilename);
parcelHelpers.export(exports, "iterateFilename", ()=>iterateFilename);
parcelHelpers.export(exports, "stripSlashesFromRight", ()=>stripSlashesFromRight);
// const pica = new Pica();
// export function createThumbnail(file: any) {
//     return new Promise(async (resolve, reject)=>{
//         const reader = new FileReader();
//         reader.onload = function(event:any) {
//             const img = new Image();
//             img.onload = async function() {
//                 // Define maximum dimensions for the thumbnail
//                 const maxDimension = 100; // This is an example, adjust as needed
//
//                 // Calculate the scaling factor to maintain aspect ratio
//                 let scaleFactor = Math.min(maxDimension / img.width, maxDimension / img.height);
//                 let newWidth = img.width * scaleFactor;
//                 let newHeight = img.height * scaleFactor;
//
//                 const canvas = document.createElement('canvas');
//                 canvas.width = newWidth;
//                 canvas.height = newHeight;
//
//                 // Resize the image with Pica
//                 let q = 1;
//                 let blob: Blob;
//                 do {
//                     q -= 0.2
//                     blob = await picaResize(img, canvas, q);
//                 }while(q > 0 && blob.size > 1024);
//
//                 // Now you have a blob with your image
//                 console.log('Thumbnail created', blob.size);
//
//                 // Additional steps to use the blob (e.g., display it or upload it) go here
//                 // For example, to display the thumbnail:
//                 const url = URL.createObjectURL(blob);
//                 const imageElement = document.createElement('img');
//                 imageElement.src = url;
//                 document.body.appendChild(imageElement);
//
//             };
//             img.src = event.target.result;
//         };
//         reader.readAsDataURL(file);
//     })
//
//     async function picaResize(img: HTMLImageElement, canvas: HTMLCanvasElement, quality: number): Promise<Blob>{
//         console.log('Resizing image with quality', quality);
//         const resizedCanvas = await pica.resize(img, canvas);
//         return pica.toBlob(resizedCanvas, 'image/webp', quality);
//     }
//
// }
parcelHelpers.export(exports, "blobToArrayBuffer", ()=>blobToArrayBuffer);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "delay", ()=>delay);
parcelHelpers.export(exports, "safeFireAndForgetFactory", ()=>safeFireAndForgetFactory);
parcelHelpers.export(exports, "Mutex", ()=>Mutex);
parcelHelpers.export(exports, "blobToJson", ()=>blobToJson);
parcelHelpers.export(exports, "ThemeMode", ()=>ThemeMode);
parcelHelpers.export(exports, "getDefaultThemeMode", ()=>getDefaultThemeMode);
parcelHelpers.export(exports, "waitWithLogging", ()=>waitWithLogging);
var _cryptoJs = require("crypto-js");
var _slugify = require("slugify");
var _slugifyDefault = parcelHelpers.interopDefault(_slugify);
//import Pica from "pica";
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
function extractTextFromScripts(nodes) {
    let template = "";
    for (const n of nodes)switch(n.nodeType){
        case Node.ELEMENT_NODE:
            const el = n;
            if (el.tagName === "SCRIPT") template += el.textContent;
    }
    return template;
}
function extractTextAndScripts(nodes, template = "", scripts = []) {
    for (const n of nodes)switch(n.nodeType){
        case Node.TEXT_NODE:
            template += n.data;
            break;
        case Node.ELEMENT_NODE:
            const el = n;
            // console.log(el.tagName);
            switch(el.tagName){
                case "SCRIPT":
                    if (el.attributes.getNamedItem("type")?.value == "text/liquid") template += el.textContent;
                    else if (el.attributes.getNamedItem("type")?.value == "application/json") template += el.textContent;
                    else scripts.push(el.innerHTML);
                    continue;
                case "TEMPLATE":
                    //console.log('TEMPLATE:', el.outerHTML);
                    const outerHtml = el.outerHTML;
                    const startIndex = outerHtml.indexOf(">");
                    const endIndex = outerHtml.lastIndexOf("<");
                    template += outerHtml.substring(startIndex + 1, endIndex);
                    continue;
                // const t = el as HTMLTemplateElement;
                // const childNodesArray = Array.from(t.content.childNodes) as Node[]; // Convert to Node[]
                // const ret = extractTextAndScripts(childNodesArray, template, scripts);
                // template += ret.template;
                // scripts = ret.scripts;
                // continue;
                case "COMMENT":
                    console.log("TEMPLATE COMMENT:", el.outerHTML);
                default:
                    template += el.outerHTML;
            }
            break;
        default:
            const a = n;
            console.log(`n[${n.nodeType}]: innerHTML=${a.innerHTML} data=${a.data} textContent=${n.textContent} outerHTML=${a.outerHTML}`);
    }
    return {
        template,
        scripts
    };
}
async function getSha256(message) {
    let hashBuffer;
    if (message instanceof Blob) {
        const arrayBuffer = await message.arrayBuffer();
        hashBuffer = await crypto.subtle.digest("SHA-256", arrayBuffer);
    } else {
        const encoder = new TextEncoder();
        const data = encoder.encode(message);
        hashBuffer = await crypto.subtle.digest("SHA-256", data);
    }
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((byte)=>byte.toString(16).padStart(2, "0")).join("");
}
function calculateFileMD5(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = function(event) {
            const arrayBuffer = event.target.result;
            const wordArray = _cryptoJs.lib.WordArray.create(arrayBuffer);
            const hash = _cryptoJs.MD5(wordArray).toString();
            resolve(hash);
            console.log("MD5 Hash:", hash);
        };
        reader.onerror = function(error) {
            console.error("Error reading file:", error);
            reject(error);
        };
        reader.readAsArrayBuffer(file);
    });
}
function safeSlugifyFilename(filename) {
    const parts = filename.split(".");
    const extension = parts.pop(); // Remove and save the last part as the extension
    const baseName = parts.join("."); // Handle cases where there are multiple dots
    // Slugify options
    const options = {
        replacement: "-",
        remove: undefined,
        lower: true,
        strict: true,
        locale: "en",
        trim: true // trim leading and trailing replacement characters
    };
    // Only slugify the base name, and then append the original extension
    return `${(0, _slugifyDefault.default)(baseName, options)}.${extension}`;
}
function iterateFilename(filename) {
    // Regular expression to match the filename, an optional dash followed by a number, and the file extension
    const regex = /^(.*?)(-?)(\d+)?(\.[^.]+)$/;
    // Use the regular expression to extract parts of the filename
    const match = filename.match(regex);
    if (match) {
        const [, base, dash, number, extension] = match;
        let nextNumber;
        if (number) // If a number exists, increment it
        nextNumber = parseInt(number, 10) + 1;
        else // If no number exists, start with 2
        nextNumber = 2;
        // Return the new filename with the incremented number
        return `${base}-${nextNumber}${extension}`;
    } else // If the filename doesn't match the expected pattern, return it unchanged
    return filename;
}
function stripSlashesFromRight(str) {
    return str.replace(/\/+$/, "");
}
function blobToArrayBuffer(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = function(event) {
            try {
                const arrayBuffer = event.target?.result;
                if (!(arrayBuffer instanceof ArrayBuffer)) throw new Error("Failed to read blob. ArrayBuffer is null");
                resolve(arrayBuffer);
            // const uint8Array = new Uint8Array(arrayBuffer);
            // resolve(uint8Array);
            } catch (e) {
                reject(e);
            }
        };
        reader.readAsArrayBuffer(blob);
    });
}
function defer() {
    let res = undefined;
    let rej = undefined;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    const resolve = res;
    const reject = res;
    return {
        promise,
        resolve,
        reject
    };
}
function delay(delayMs = 1000) {
    return new Promise((resolve)=>setTimeout(resolve, delayMs));
}
function safeFireAndForgetFactory(log) {
    return function safeFireAndForget(promise, message = "operation completed") {
        promise.then(()=>log(message)).catch((e)=>log(message, e));
    };
}
const mutextLog = (0, _debugDefault.default)("pdq:mutex");
class Mutex {
    constructor(name){
        this.name = name;
        this.isLocked = ()=>this._locked;
        this.hasQueue = ()=>this._queue.length > 0;
        this._queue = [];
        this._locked = false;
    }
    lock() {
        const unlock = ()=>{
            mutextLog(`[${this.name}] unlocking... ${this._queue.length}`);
            this._locked = false;
            if (this._queue.length > 0) this._queue.shift()();
        };
        if (this._locked) {
            mutextLog(`[${this.name}] locked... adding to queue... ${this._queue.length}`);
            return new Promise((resolve)=>{
                this._queue.push(()=>resolve(unlock));
            });
        } else {
            mutextLog(`[${this.name}] locking... ${this._queue.length}`);
            this._locked = true;
            return Promise.resolve(unlock);
        }
    }
}
const blobToJson = (blob)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            try {
                const json = JSON.parse(reader.result);
                resolve(json);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = ()=>reject(reader.error);
        reader.readAsText(blob);
    });
};
var ThemeMode;
(function(ThemeMode) {
    ThemeMode[ThemeMode["light"] = 0] = "light";
    ThemeMode[ThemeMode["dark"] = 1] = "dark";
})(ThemeMode || (ThemeMode = {}));
function getDefaultThemeMode() {
    const body = document.body;
    if (body.classList.contains("cds-theme-zone-g90") || body.classList.contains("cds-theme-zone-g100")) return ThemeMode.dark;
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) return ThemeMode.dark;
    return ThemeMode.light;
}
async function waitWithLogging(log, promise, description = "Operation") {
    const startTime = Date.now();
    let hasLogged = false;
    const logTimeout = setTimeout(()=>{
        log(`${description} is taking longer than 30ms...`);
        hasLogged = true;
    }, 30);
    const intervalId = setInterval(()=>{
        const elapsed = (Date.now() - startTime) / 1000;
        log(`${description} still running after ${elapsed.toFixed(1)}s`);
    }, 30000);
    try {
        const result = await promise;
        return result;
    } finally{
        clearTimeout(logTimeout);
        clearInterval(intervalId);
        if (hasLogged) {
            const totalTime = (Date.now() - startTime) / 1000;
            log(`${description} completed after ${totalTime.toFixed(1)}s`);
        }
    }
}

},{"crypto-js":"4YsAU","slugify":"3zlVa","debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4YsAU":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("5eee6dbf972ff0c"), require("1ae7fff9f8fa4b2e"), require("5d5c6779507b6ecf"), require("8fed7daa3b4cc142"), require("789bad1b0dff9a96"), require("fb488ee151dd7943"), require("8ccb3bce525f169d"), require("f6a9495b1c254449"), require("fd2e65bc40b77537"), require("7fa06e499cf8a103"), require("c1cce0659b03adfe"), require("c5af184fa8c7874f"), require("4ae38a06cb259786"), require("c72e494c732a963f"), require("88bf72f2d872110"), require("89a6ccecb9711f00"), require("fe47fecb97678a27"), require("8494f33137888286"), require("a180680a3a0b6778"), require("5c9b46cec008dfa5"), require("4cba38335b9a1036"), require("52ef67a0df2f7b37"), require("1790c68efb06b110"), require("540eb4174417cc86"), require("e53c0db805905662"), require("cab1508d99737362"), require("c0ecce6689437d58"), require("5809aadf1a05b38"), require("72de7f0923a744f6"), require("8676fff60d27e6aa"), require("753c41c24ae9eb5b"), require("c4b3c473a798ab37"), require("64cf109d48a11849"), require("c44065b70e4f6cb8"), require("113273f8e2d4bebb"));
})(this, function(CryptoJS) {
    return CryptoJS;
});

},{"5eee6dbf972ff0c":"isPlo","1ae7fff9f8fa4b2e":"hv2ZZ","5d5c6779507b6ecf":"1JZDN","8fed7daa3b4cc142":"jGy47","789bad1b0dff9a96":"7G9uR","fb488ee151dd7943":"2x44X","8ccb3bce525f169d":"fzW7d","f6a9495b1c254449":"39xfW","fd2e65bc40b77537":"geCX9","7fa06e499cf8a103":"wtT9M","c1cce0659b03adfe":"lotkt","c5af184fa8c7874f":"9c54x","4ae38a06cb259786":"9CwDJ","c72e494c732a963f":"lsKgK","88bf72f2d872110":"ffTZ0","89a6ccecb9711f00":"lfgIo","fe47fecb97678a27":"8HKlY","8494f33137888286":"inDpW","a180680a3a0b6778":"id1jR","5c9b46cec008dfa5":"5A5s6","4cba38335b9a1036":"2eh9E","52ef67a0df2f7b37":"8Twub","1790c68efb06b110":"4bAaW","540eb4174417cc86":"8CpOC","e53c0db805905662":"aflvs","cab1508d99737362":"9tt4Q","c0ecce6689437d58":"3tegu","5809aadf1a05b38":"2HGq1","72de7f0923a744f6":"g96aD","8676fff60d27e6aa":"afzf0","753c41c24ae9eb5b":"izdbG","c4b3c473a798ab37":"33ZtO","64cf109d48a11849":"blsgg","c44065b70e4f6cb8":"jBbSq","113273f8e2d4bebb":"a8yHH"}],"isPlo":[function(require,module,exports) {
var global = arguments[3];
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof global !== "undefined" && global.crypto) crypto = global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = require("b7760e5f0b7216d4");
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

},{"b7760e5f0b7216d4":"13Pcp"}],"13Pcp":[function(require,module,exports) {
"use strict";

},{}],"hv2ZZ":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("d48fed549de80b2b"));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

},{"d48fed549de80b2b":"isPlo"}],"1JZDN":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("300da5cb0ae97e38"));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

},{"300da5cb0ae97e38":"isPlo"}],"jGy47":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("3d8e0cedd47ceed4"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

},{"3d8e0cedd47ceed4":"isPlo"}],"7G9uR":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("6c67d43f833ec62e"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

},{"6c67d43f833ec62e":"isPlo"}],"2x44X":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("7d66589bbaefbca4"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64url encoding strategy.
	     */ var Base64url = C_enc.Base64url = {
            /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */ stringify: function(wordArray, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = urlSafe ? this._safe_map : this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */ parse: function(base64Str, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = urlSafe ? this._safe_map : this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64url;
});

},{"7d66589bbaefbca4":"isPlo"}],"fzW7d":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("df297d5f1a7605f5"));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

},{"df297d5f1a7605f5":"isPlo"}],"39xfW":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("7b9891bafba06348"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

},{"7b9891bafba06348":"isPlo"}],"geCX9":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("cd9e8447cb14a145"));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

},{"cd9e8447cb14a145":"isPlo"}],"wtT9M":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("e8965157f10402b0"), require("422fd5a45e67fd9c"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

},{"e8965157f10402b0":"isPlo","422fd5a45e67fd9c":"geCX9"}],"lotkt":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("31d6ad3465d16167"), require("c6b2cb3d09716a55"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

},{"31d6ad3465d16167":"isPlo","c6b2cb3d09716a55":"hv2ZZ"}],"9c54x":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("b5fe0ebcfe1041bc"), require("a9e41ebd870c4542"), require("df3c8766d63d1a4"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

},{"b5fe0ebcfe1041bc":"isPlo","a9e41ebd870c4542":"hv2ZZ","df3c8766d63d1a4":"lotkt"}],"9CwDJ":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("50cd159714e45996"), require("93026947822c59d9"));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

},{"50cd159714e45996":"isPlo","93026947822c59d9":"hv2ZZ"}],"lsKgK":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("f465710c5187ca82"));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

},{"f465710c5187ca82":"isPlo"}],"ffTZ0":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("7479609d4f7429fa"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

},{"7479609d4f7429fa":"isPlo"}],"lfgIo":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("1c341b8fa9fa7ba5"), require("4451da4248a2ba9a"), require("d435910d805b159d"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA256
	         * @property {number} iterations The number of iterations to perform. Default: 250000
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA256,
                iterations: 250000
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

},{"1c341b8fa9fa7ba5":"isPlo","4451da4248a2ba9a":"geCX9","d435910d805b159d":"ffTZ0"}],"8HKlY":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("b3eece319621bd0d"), require("1519e429561ccd1a"), require("a4a8e103be66f413"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

},{"b3eece319621bd0d":"isPlo","1519e429561ccd1a":"39xfW","a4a8e103be66f413":"ffTZ0"}],"inDpW":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("cd9e7c148581f3f"), require("a566ab64a571fabc"));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

},{"cd9e7c148581f3f":"isPlo","a566ab64a571fabc":"8HKlY"}],"id1jR":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("2f52414e12ae6909"), require("1eb0a66f8f1f67cf"));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

},{"2f52414e12ae6909":"isPlo","1eb0a66f8f1f67cf":"inDpW"}],"5A5s6":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("8279613429749f72"), require("6366f0a420ff853a"));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

},{"8279613429749f72":"isPlo","6366f0a420ff853a":"inDpW"}],"2eh9E":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("1da69dc95c930e7b"), require("3c652faf883d007a"));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

},{"1da69dc95c930e7b":"isPlo","3c652faf883d007a":"inDpW"}],"8Twub":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("26be4bcd9270328c"), require("827fa2cf583dbf3f"));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

},{"26be4bcd9270328c":"isPlo","827fa2cf583dbf3f":"inDpW"}],"4bAaW":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("4bb76acc2aaa6fdd"), require("f7fd8399632190ae"));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

},{"4bb76acc2aaa6fdd":"isPlo","f7fd8399632190ae":"inDpW"}],"8CpOC":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("655f8cc9ca5eb2ce"), require("5c1782efee2c6874"));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

},{"655f8cc9ca5eb2ce":"isPlo","5c1782efee2c6874":"inDpW"}],"aflvs":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("5c66ff56d234cbf"), require("fcb5c1ae9ec239c4"));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

},{"5c66ff56d234cbf":"isPlo","fcb5c1ae9ec239c4":"inDpW"}],"9tt4Q":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("44479225b8698d21"), require("ef25b57e3868eb7f"));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

},{"44479225b8698d21":"isPlo","ef25b57e3868eb7f":"inDpW"}],"3tegu":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("87af21168aa44acb"), require("133ca1805bb6433e"));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

},{"87af21168aa44acb":"isPlo","133ca1805bb6433e":"inDpW"}],"2HGq1":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("aa3c737d0aca3c8c"), require("48009bd77daa7164"));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

},{"aa3c737d0aca3c8c":"isPlo","48009bd77daa7164":"inDpW"}],"g96aD":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("21b80cefb2d8bce5"), require("edcb376f8d1cabe8"));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

},{"21b80cefb2d8bce5":"isPlo","edcb376f8d1cabe8":"inDpW"}],"afzf0":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("16bcadd944502d8b"), require("5d6f4d12778ce0e2"), require("50eb63fc72836bd1"), require("7dfc9b682a0ce247"), require("3a168c81f3f01a90"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

},{"16bcadd944502d8b":"isPlo","5d6f4d12778ce0e2":"7G9uR","50eb63fc72836bd1":"fzW7d","7dfc9b682a0ce247":"8HKlY","3a168c81f3f01a90":"inDpW"}],"izdbG":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("62629f7fb07c1dd7"), require("feb8e609cc5885ca"), require("6ec5b2354b411f51"), require("b62ab3b1c080ae4c"), require("baa70509b18bd19a"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

},{"62629f7fb07c1dd7":"isPlo","feb8e609cc5885ca":"7G9uR","6ec5b2354b411f51":"fzW7d","b62ab3b1c080ae4c":"8HKlY","baa70509b18bd19a":"inDpW"}],"33ZtO":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("5adebd8db4e1f724"), require("d5eba26e964b3fe3"), require("be6b5d0f312e7e5b"), require("900f02bdbb6a3882"), require("ff3bd2d58928df2c"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

},{"5adebd8db4e1f724":"isPlo","d5eba26e964b3fe3":"7G9uR","be6b5d0f312e7e5b":"fzW7d","900f02bdbb6a3882":"8HKlY","ff3bd2d58928df2c":"inDpW"}],"blsgg":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("dce97015fe9c299f"), require("543b66e1a17bbf5f"), require("2dee0f2a2cc0a874"), require("6b6c48cc5ac6eba4"), require("6297c11c0d21147a"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

},{"dce97015fe9c299f":"isPlo","543b66e1a17bbf5f":"7G9uR","2dee0f2a2cc0a874":"fzW7d","6b6c48cc5ac6eba4":"8HKlY","6297c11c0d21147a":"inDpW"}],"jBbSq":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("4b15b17a67843352"), require("5fb7ffe89dc864c6"), require("2203652551377e3e"), require("5b0030ff2473b4d4"), require("7a115a0bc4f30748"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

},{"4b15b17a67843352":"isPlo","5fb7ffe89dc864c6":"7G9uR","2203652551377e3e":"fzW7d","5b0030ff2473b4d4":"8HKlY","7a115a0bc4f30748":"inDpW"}],"a8yHH":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("6c1b1f80a09547ea"), require("76a4278a3203b7b3"), require("31b1f7acda670f6"), require("c8a50eb69fdf3b02"), require("3c354e713d4cd19b"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        const N = 16;
        //Origin pbox and sbox, derived from PI
        const ORIG_P = [
            0x243F6A88,
            0x85A308D3,
            0x13198A2E,
            0x03707344,
            0xA4093822,
            0x299F31D0,
            0x082EFA98,
            0xEC4E6C89,
            0x452821E6,
            0x38D01377,
            0xBE5466CF,
            0x34E90C6C,
            0xC0AC29B7,
            0xC97C50DD,
            0x3F84D5B5,
            0xB5470917,
            0x9216D5D9,
            0x8979FB1B
        ];
        const ORIG_S = [
            [
                0xD1310BA6,
                0x98DFB5AC,
                0x2FFD72DB,
                0xD01ADFB7,
                0xB8E1AFED,
                0x6A267E96,
                0xBA7C9045,
                0xF12C7F99,
                0x24A19947,
                0xB3916CF7,
                0x0801F2E2,
                0x858EFC16,
                0x636920D8,
                0x71574E69,
                0xA458FEA3,
                0xF4933D7E,
                0x0D95748F,
                0x728EB658,
                0x718BCD58,
                0x82154AEE,
                0x7B54A41D,
                0xC25A59B5,
                0x9C30D539,
                0x2AF26013,
                0xC5D1B023,
                0x286085F0,
                0xCA417918,
                0xB8DB38EF,
                0x8E79DCB0,
                0x603A180E,
                0x6C9E0E8B,
                0xB01E8A3E,
                0xD71577C1,
                0xBD314B27,
                0x78AF2FDA,
                0x55605C60,
                0xE65525F3,
                0xAA55AB94,
                0x57489862,
                0x63E81440,
                0x55CA396A,
                0x2AAB10B6,
                0xB4CC5C34,
                0x1141E8CE,
                0xA15486AF,
                0x7C72E993,
                0xB3EE1411,
                0x636FBC2A,
                0x2BA9C55D,
                0x741831F6,
                0xCE5C3E16,
                0x9B87931E,
                0xAFD6BA33,
                0x6C24CF5C,
                0x7A325381,
                0x28958677,
                0x3B8F4898,
                0x6B4BB9AF,
                0xC4BFE81B,
                0x66282193,
                0x61D809CC,
                0xFB21A991,
                0x487CAC60,
                0x5DEC8032,
                0xEF845D5D,
                0xE98575B1,
                0xDC262302,
                0xEB651B88,
                0x23893E81,
                0xD396ACC5,
                0x0F6D6FF3,
                0x83F44239,
                0x2E0B4482,
                0xA4842004,
                0x69C8F04A,
                0x9E1F9B5E,
                0x21C66842,
                0xF6E96C9A,
                0x670C9C61,
                0xABD388F0,
                0x6A51A0D2,
                0xD8542F68,
                0x960FA728,
                0xAB5133A3,
                0x6EEF0B6C,
                0x137A3BE4,
                0xBA3BF050,
                0x7EFB2A98,
                0xA1F1651D,
                0x39AF0176,
                0x66CA593E,
                0x82430E88,
                0x8CEE8619,
                0x456F9FB4,
                0x7D84A5C3,
                0x3B8B5EBE,
                0xE06F75D8,
                0x85C12073,
                0x401A449F,
                0x56C16AA6,
                0x4ED3AA62,
                0x363F7706,
                0x1BFEDF72,
                0x429B023D,
                0x37D0D724,
                0xD00A1248,
                0xDB0FEAD3,
                0x49F1C09B,
                0x075372C9,
                0x80991B7B,
                0x25D479D8,
                0xF6E8DEF7,
                0xE3FE501A,
                0xB6794C3B,
                0x976CE0BD,
                0x04C006BA,
                0xC1A94FB6,
                0x409F60C4,
                0x5E5C9EC2,
                0x196A2463,
                0x68FB6FAF,
                0x3E6C53B5,
                0x1339B2EB,
                0x3B52EC6F,
                0x6DFC511F,
                0x9B30952C,
                0xCC814544,
                0xAF5EBD09,
                0xBEE3D004,
                0xDE334AFD,
                0x660F2807,
                0x192E4BB3,
                0xC0CBA857,
                0x45C8740F,
                0xD20B5F39,
                0xB9D3FBDB,
                0x5579C0BD,
                0x1A60320A,
                0xD6A100C6,
                0x402C7279,
                0x679F25FE,
                0xFB1FA3CC,
                0x8EA5E9F8,
                0xDB3222F8,
                0x3C7516DF,
                0xFD616B15,
                0x2F501EC8,
                0xAD0552AB,
                0x323DB5FA,
                0xFD238760,
                0x53317B48,
                0x3E00DF82,
                0x9E5C57BB,
                0xCA6F8CA0,
                0x1A87562E,
                0xDF1769DB,
                0xD542A8F6,
                0x287EFFC3,
                0xAC6732C6,
                0x8C4F5573,
                0x695B27B0,
                0xBBCA58C8,
                0xE1FFA35D,
                0xB8F011A0,
                0x10FA3D98,
                0xFD2183B8,
                0x4AFCB56C,
                0x2DD1D35B,
                0x9A53E479,
                0xB6F84565,
                0xD28E49BC,
                0x4BFB9790,
                0xE1DDF2DA,
                0xA4CB7E33,
                0x62FB1341,
                0xCEE4C6E8,
                0xEF20CADA,
                0x36774C01,
                0xD07E9EFE,
                0x2BF11FB4,
                0x95DBDA4D,
                0xAE909198,
                0xEAAD8E71,
                0x6B93D5A0,
                0xD08ED1D0,
                0xAFC725E0,
                0x8E3C5B2F,
                0x8E7594B7,
                0x8FF6E2FB,
                0xF2122B64,
                0x8888B812,
                0x900DF01C,
                0x4FAD5EA0,
                0x688FC31C,
                0xD1CFF191,
                0xB3A8C1AD,
                0x2F2F2218,
                0xBE0E1777,
                0xEA752DFE,
                0x8B021FA1,
                0xE5A0CC0F,
                0xB56F74E8,
                0x18ACF3D6,
                0xCE89E299,
                0xB4A84FE0,
                0xFD13E0B7,
                0x7CC43B81,
                0xD2ADA8D9,
                0x165FA266,
                0x80957705,
                0x93CC7314,
                0x211A1477,
                0xE6AD2065,
                0x77B5FA86,
                0xC75442F5,
                0xFB9D35CF,
                0xEBCDAF0C,
                0x7B3E89A0,
                0xD6411BD3,
                0xAE1E7E49,
                0x00250E2D,
                0x2071B35E,
                0x226800BB,
                0x57B8E0AF,
                0x2464369B,
                0xF009B91E,
                0x5563911D,
                0x59DFA6AA,
                0x78C14389,
                0xD95A537F,
                0x207D5BA2,
                0x02E5B9C5,
                0x83260376,
                0x6295CFA9,
                0x11C81968,
                0x4E734A41,
                0xB3472DCA,
                0x7B14A94A,
                0x1B510052,
                0x9A532915,
                0xD60F573F,
                0xBC9BC6E4,
                0x2B60A476,
                0x81E67400,
                0x08BA6FB5,
                0x571BE91F,
                0xF296EC6B,
                0x2A0DD915,
                0xB6636521,
                0xE7B9F9B6,
                0xFF34052E,
                0xC5855664,
                0x53B02D5D,
                0xA99F8FA1,
                0x08BA4799,
                0x6E85076A
            ],
            [
                0x4B7A70E9,
                0xB5B32944,
                0xDB75092E,
                0xC4192623,
                0xAD6EA6B0,
                0x49A7DF7D,
                0x9CEE60B8,
                0x8FEDB266,
                0xECAA8C71,
                0x699A17FF,
                0x5664526C,
                0xC2B19EE1,
                0x193602A5,
                0x75094C29,
                0xA0591340,
                0xE4183A3E,
                0x3F54989A,
                0x5B429D65,
                0x6B8FE4D6,
                0x99F73FD6,
                0xA1D29C07,
                0xEFE830F5,
                0x4D2D38E6,
                0xF0255DC1,
                0x4CDD2086,
                0x8470EB26,
                0x6382E9C6,
                0x021ECC5E,
                0x09686B3F,
                0x3EBAEFC9,
                0x3C971814,
                0x6B6A70A1,
                0x687F3584,
                0x52A0E286,
                0xB79C5305,
                0xAA500737,
                0x3E07841C,
                0x7FDEAE5C,
                0x8E7D44EC,
                0x5716F2B8,
                0xB03ADA37,
                0xF0500C0D,
                0xF01C1F04,
                0x0200B3FF,
                0xAE0CF51A,
                0x3CB574B2,
                0x25837A58,
                0xDC0921BD,
                0xD19113F9,
                0x7CA92FF6,
                0x94324773,
                0x22F54701,
                0x3AE5E581,
                0x37C2DADC,
                0xC8B57634,
                0x9AF3DDA7,
                0xA9446146,
                0x0FD0030E,
                0xECC8C73E,
                0xA4751E41,
                0xE238CD99,
                0x3BEA0E2F,
                0x3280BBA1,
                0x183EB331,
                0x4E548B38,
                0x4F6DB908,
                0x6F420D03,
                0xF60A04BF,
                0x2CB81290,
                0x24977C79,
                0x5679B072,
                0xBCAF89AF,
                0xDE9A771F,
                0xD9930810,
                0xB38BAE12,
                0xDCCF3F2E,
                0x5512721F,
                0x2E6B7124,
                0x501ADDE6,
                0x9F84CD87,
                0x7A584718,
                0x7408DA17,
                0xBC9F9ABC,
                0xE94B7D8C,
                0xEC7AEC3A,
                0xDB851DFA,
                0x63094366,
                0xC464C3D2,
                0xEF1C1847,
                0x3215D908,
                0xDD433B37,
                0x24C2BA16,
                0x12A14D43,
                0x2A65C451,
                0x50940002,
                0x133AE4DD,
                0x71DFF89E,
                0x10314E55,
                0x81AC77D6,
                0x5F11199B,
                0x043556F1,
                0xD7A3C76B,
                0x3C11183B,
                0x5924A509,
                0xF28FE6ED,
                0x97F1FBFA,
                0x9EBABF2C,
                0x1E153C6E,
                0x86E34570,
                0xEAE96FB1,
                0x860E5E0A,
                0x5A3E2AB3,
                0x771FE71C,
                0x4E3D06FA,
                0x2965DCB9,
                0x99E71D0F,
                0x803E89D6,
                0x5266C825,
                0x2E4CC978,
                0x9C10B36A,
                0xC6150EBA,
                0x94E2EA78,
                0xA5FC3C53,
                0x1E0A2DF4,
                0xF2F74EA7,
                0x361D2B3D,
                0x1939260F,
                0x19C27960,
                0x5223A708,
                0xF71312B6,
                0xEBADFE6E,
                0xEAC31F66,
                0xE3BC4595,
                0xA67BC883,
                0xB17F37D1,
                0x018CFF28,
                0xC332DDEF,
                0xBE6C5AA5,
                0x65582185,
                0x68AB9802,
                0xEECEA50F,
                0xDB2F953B,
                0x2AEF7DAD,
                0x5B6E2F84,
                0x1521B628,
                0x29076170,
                0xECDD4775,
                0x619F1510,
                0x13CCA830,
                0xEB61BD96,
                0x0334FE1E,
                0xAA0363CF,
                0xB5735C90,
                0x4C70A239,
                0xD59E9E0B,
                0xCBAADE14,
                0xEECC86BC,
                0x60622CA7,
                0x9CAB5CAB,
                0xB2F3846E,
                0x648B1EAF,
                0x19BDF0CA,
                0xA02369B9,
                0x655ABB50,
                0x40685A32,
                0x3C2AB4B3,
                0x319EE9D5,
                0xC021B8F7,
                0x9B540B19,
                0x875FA099,
                0x95F7997E,
                0x623D7DA8,
                0xF837889A,
                0x97E32D77,
                0x11ED935F,
                0x16681281,
                0x0E358829,
                0xC7E61FD6,
                0x96DEDFA1,
                0x7858BA99,
                0x57F584A5,
                0x1B227263,
                0x9B83C3FF,
                0x1AC24696,
                0xCDB30AEB,
                0x532E3054,
                0x8FD948E4,
                0x6DBC3128,
                0x58EBF2EF,
                0x34C6FFEA,
                0xFE28ED61,
                0xEE7C3C73,
                0x5D4A14D9,
                0xE864B7E3,
                0x42105D14,
                0x203E13E0,
                0x45EEE2B6,
                0xA3AAABEA,
                0xDB6C4F15,
                0xFACB4FD0,
                0xC742F442,
                0xEF6ABBB5,
                0x654F3B1D,
                0x41CD2105,
                0xD81E799E,
                0x86854DC7,
                0xE44B476A,
                0x3D816250,
                0xCF62A1F2,
                0x5B8D2646,
                0xFC8883A0,
                0xC1C7B6A3,
                0x7F1524C3,
                0x69CB7492,
                0x47848A0B,
                0x5692B285,
                0x095BBF00,
                0xAD19489D,
                0x1462B174,
                0x23820E00,
                0x58428D2A,
                0x0C55F5EA,
                0x1DADF43E,
                0x233F7061,
                0x3372F092,
                0x8D937E41,
                0xD65FECF1,
                0x6C223BDB,
                0x7CDE3759,
                0xCBEE7460,
                0x4085F2A7,
                0xCE77326E,
                0xA6078084,
                0x19F8509E,
                0xE8EFD855,
                0x61D99735,
                0xA969A7AA,
                0xC50C06C2,
                0x5A04ABFC,
                0x800BCADC,
                0x9E447A2E,
                0xC3453484,
                0xFDD56705,
                0x0E1E9EC9,
                0xDB73DBD3,
                0x105588CD,
                0x675FDA79,
                0xE3674340,
                0xC5C43465,
                0x713E38D8,
                0x3D28F89E,
                0xF16DFF20,
                0x153E21E7,
                0x8FB03D4A,
                0xE6E39F2B,
                0xDB83ADF7
            ],
            [
                0xE93D5A68,
                0x948140F7,
                0xF64C261C,
                0x94692934,
                0x411520F7,
                0x7602D4F7,
                0xBCF46B2E,
                0xD4A20068,
                0xD4082471,
                0x3320F46A,
                0x43B7D4B7,
                0x500061AF,
                0x1E39F62E,
                0x97244546,
                0x14214F74,
                0xBF8B8840,
                0x4D95FC1D,
                0x96B591AF,
                0x70F4DDD3,
                0x66A02F45,
                0xBFBC09EC,
                0x03BD9785,
                0x7FAC6DD0,
                0x31CB8504,
                0x96EB27B3,
                0x55FD3941,
                0xDA2547E6,
                0xABCA0A9A,
                0x28507825,
                0x530429F4,
                0x0A2C86DA,
                0xE9B66DFB,
                0x68DC1462,
                0xD7486900,
                0x680EC0A4,
                0x27A18DEE,
                0x4F3FFEA2,
                0xE887AD8C,
                0xB58CE006,
                0x7AF4D6B6,
                0xAACE1E7C,
                0xD3375FEC,
                0xCE78A399,
                0x406B2A42,
                0x20FE9E35,
                0xD9F385B9,
                0xEE39D7AB,
                0x3B124E8B,
                0x1DC9FAF7,
                0x4B6D1856,
                0x26A36631,
                0xEAE397B2,
                0x3A6EFA74,
                0xDD5B4332,
                0x6841E7F7,
                0xCA7820FB,
                0xFB0AF54E,
                0xD8FEB397,
                0x454056AC,
                0xBA489527,
                0x55533A3A,
                0x20838D87,
                0xFE6BA9B7,
                0xD096954B,
                0x55A867BC,
                0xA1159A58,
                0xCCA92963,
                0x99E1DB33,
                0xA62A4A56,
                0x3F3125F9,
                0x5EF47E1C,
                0x9029317C,
                0xFDF8E802,
                0x04272F70,
                0x80BB155C,
                0x05282CE3,
                0x95C11548,
                0xE4C66D22,
                0x48C1133F,
                0xC70F86DC,
                0x07F9C9EE,
                0x41041F0F,
                0x404779A4,
                0x5D886E17,
                0x325F51EB,
                0xD59BC0D1,
                0xF2BCC18F,
                0x41113564,
                0x257B7834,
                0x602A9C60,
                0xDFF8E8A3,
                0x1F636C1B,
                0x0E12B4C2,
                0x02E1329E,
                0xAF664FD1,
                0xCAD18115,
                0x6B2395E0,
                0x333E92E1,
                0x3B240B62,
                0xEEBEB922,
                0x85B2A20E,
                0xE6BA0D99,
                0xDE720C8C,
                0x2DA2F728,
                0xD0127845,
                0x95B794FD,
                0x647D0862,
                0xE7CCF5F0,
                0x5449A36F,
                0x877D48FA,
                0xC39DFD27,
                0xF33E8D1E,
                0x0A476341,
                0x992EFF74,
                0x3A6F6EAB,
                0xF4F8FD37,
                0xA812DC60,
                0xA1EBDDF8,
                0x991BE14C,
                0xDB6E6B0D,
                0xC67B5510,
                0x6D672C37,
                0x2765D43B,
                0xDCD0E804,
                0xF1290DC7,
                0xCC00FFA3,
                0xB5390F92,
                0x690FED0B,
                0x667B9FFB,
                0xCEDB7D9C,
                0xA091CF0B,
                0xD9155EA3,
                0xBB132F88,
                0x515BAD24,
                0x7B9479BF,
                0x763BD6EB,
                0x37392EB3,
                0xCC115979,
                0x8026E297,
                0xF42E312D,
                0x6842ADA7,
                0xC66A2B3B,
                0x12754CCC,
                0x782EF11C,
                0x6A124237,
                0xB79251E7,
                0x06A1BBE6,
                0x4BFB6350,
                0x1A6B1018,
                0x11CAEDFA,
                0x3D25BDD8,
                0xE2E1C3C9,
                0x44421659,
                0x0A121386,
                0xD90CEC6E,
                0xD5ABEA2A,
                0x64AF674E,
                0xDA86A85F,
                0xBEBFE988,
                0x64E4C3FE,
                0x9DBC8057,
                0xF0F7C086,
                0x60787BF8,
                0x6003604D,
                0xD1FD8346,
                0xF6381FB0,
                0x7745AE04,
                0xD736FCCC,
                0x83426B33,
                0xF01EAB71,
                0xB0804187,
                0x3C005E5F,
                0x77A057BE,
                0xBDE8AE24,
                0x55464299,
                0xBF582E61,
                0x4E58F48F,
                0xF2DDFDA2,
                0xF474EF38,
                0x8789BDC2,
                0x5366F9C3,
                0xC8B38E74,
                0xB475F255,
                0x46FCD9B9,
                0x7AEB2661,
                0x8B1DDF84,
                0x846A0E79,
                0x915F95E2,
                0x466E598E,
                0x20B45770,
                0x8CD55591,
                0xC902DE4C,
                0xB90BACE1,
                0xBB8205D0,
                0x11A86248,
                0x7574A99E,
                0xB77F19B6,
                0xE0A9DC09,
                0x662D09A1,
                0xC4324633,
                0xE85A1F02,
                0x09F0BE8C,
                0x4A99A025,
                0x1D6EFE10,
                0x1AB93D1D,
                0x0BA5A4DF,
                0xA186F20F,
                0x2868F169,
                0xDCB7DA83,
                0x573906FE,
                0xA1E2CE9B,
                0x4FCD7F52,
                0x50115E01,
                0xA70683FA,
                0xA002B5C4,
                0x0DE6D027,
                0x9AF88C27,
                0x773F8641,
                0xC3604C06,
                0x61A806B5,
                0xF0177A28,
                0xC0F586E0,
                0x006058AA,
                0x30DC7D62,
                0x11E69ED7,
                0x2338EA63,
                0x53C2DD94,
                0xC2C21634,
                0xBBCBEE56,
                0x90BCB6DE,
                0xEBFC7DA1,
                0xCE591D76,
                0x6F05E409,
                0x4B7C0188,
                0x39720A3D,
                0x7C927C24,
                0x86E3725F,
                0x724D9DB9,
                0x1AC15BB4,
                0xD39EB8FC,
                0xED545578,
                0x08FCA5B5,
                0xD83D7CD3,
                0x4DAD0FC4,
                0x1E50EF5E,
                0xB161E6F8,
                0xA28514D9,
                0x6C51133C,
                0x6FD5C7E7,
                0x56E14EC4,
                0x362ABFCE,
                0xDDC6C837,
                0xD79A3234,
                0x92638212,
                0x670EFA8E,
                0x406000E0
            ],
            [
                0x3A39CE37,
                0xD3FAF5CF,
                0xABC27737,
                0x5AC52D1B,
                0x5CB0679E,
                0x4FA33742,
                0xD3822740,
                0x99BC9BBE,
                0xD5118E9D,
                0xBF0F7315,
                0xD62D1C7E,
                0xC700C47B,
                0xB78C1B6B,
                0x21A19045,
                0xB26EB1BE,
                0x6A366EB4,
                0x5748AB2F,
                0xBC946E79,
                0xC6A376D2,
                0x6549C2C8,
                0x530FF8EE,
                0x468DDE7D,
                0xD5730A1D,
                0x4CD04DC6,
                0x2939BBDB,
                0xA9BA4650,
                0xAC9526E8,
                0xBE5EE304,
                0xA1FAD5F0,
                0x6A2D519A,
                0x63EF8CE2,
                0x9A86EE22,
                0xC089C2B8,
                0x43242EF6,
                0xA51E03AA,
                0x9CF2D0A4,
                0x83C061BA,
                0x9BE96A4D,
                0x8FE51550,
                0xBA645BD6,
                0x2826A2F9,
                0xA73A3AE1,
                0x4BA99586,
                0xEF5562E9,
                0xC72FEFD3,
                0xF752F7DA,
                0x3F046F69,
                0x77FA0A59,
                0x80E4A915,
                0x87B08601,
                0x9B09E6AD,
                0x3B3EE593,
                0xE990FD5A,
                0x9E34D797,
                0x2CF0B7D9,
                0x022B8B51,
                0x96D5AC3A,
                0x017DA67D,
                0xD1CF3ED6,
                0x7C7D2D28,
                0x1F9F25CF,
                0xADF2B89B,
                0x5AD6B472,
                0x5A88F54C,
                0xE029AC71,
                0xE019A5E6,
                0x47B0ACFD,
                0xED93FA9B,
                0xE8D3C48D,
                0x283B57CC,
                0xF8D56629,
                0x79132E28,
                0x785F0191,
                0xED756055,
                0xF7960E44,
                0xE3D35E8C,
                0x15056DD4,
                0x88F46DBA,
                0x03A16125,
                0x0564F0BD,
                0xC3EB9E15,
                0x3C9057A2,
                0x97271AEC,
                0xA93A072A,
                0x1B3F6D9B,
                0x1E6321F5,
                0xF59C66FB,
                0x26DCF319,
                0x7533D928,
                0xB155FDF5,
                0x03563482,
                0x8ABA3CBB,
                0x28517711,
                0xC20AD9F8,
                0xABCC5167,
                0xCCAD925F,
                0x4DE81751,
                0x3830DC8E,
                0x379D5862,
                0x9320F991,
                0xEA7A90C2,
                0xFB3E7BCE,
                0x5121CE64,
                0x774FBE32,
                0xA8B6E37E,
                0xC3293D46,
                0x48DE5369,
                0x6413E680,
                0xA2AE0810,
                0xDD6DB224,
                0x69852DFD,
                0x09072166,
                0xB39A460A,
                0x6445C0DD,
                0x586CDECF,
                0x1C20C8AE,
                0x5BBEF7DD,
                0x1B588D40,
                0xCCD2017F,
                0x6BB4E3BB,
                0xDDA26A7E,
                0x3A59FF45,
                0x3E350A44,
                0xBCB4CDD5,
                0x72EACEA8,
                0xFA6484BB,
                0x8D6612AE,
                0xBF3C6F47,
                0xD29BE463,
                0x542F5D9E,
                0xAEC2771B,
                0xF64E6370,
                0x740E0D8D,
                0xE75B1357,
                0xF8721671,
                0xAF537D5D,
                0x4040CB08,
                0x4EB4E2CC,
                0x34D2466A,
                0x0115AF84,
                0xE1B00428,
                0x95983A1D,
                0x06B89FB4,
                0xCE6EA048,
                0x6F3F3B82,
                0x3520AB82,
                0x011A1D4B,
                0x277227F8,
                0x611560B1,
                0xE7933FDC,
                0xBB3A792B,
                0x344525BD,
                0xA08839E1,
                0x51CE794B,
                0x2F32C9B7,
                0xA01FBAC9,
                0xE01CC87E,
                0xBCC7D1F6,
                0xCF0111C3,
                0xA1E8AAC7,
                0x1A908749,
                0xD44FBD9A,
                0xD0DADECB,
                0xD50ADA38,
                0x0339C32A,
                0xC6913667,
                0x8DF9317C,
                0xE0B12B4F,
                0xF79E59B7,
                0x43F5BB3A,
                0xF2D519FF,
                0x27D9459C,
                0xBF97222C,
                0x15E6FC2A,
                0x0F91FC71,
                0x9B941525,
                0xFAE59361,
                0xCEB69CEB,
                0xC2A86459,
                0x12BAA8D1,
                0xB6C1075E,
                0xE3056A0C,
                0x10D25065,
                0xCB03A442,
                0xE0EC6E0E,
                0x1698DB3B,
                0x4C98A0BE,
                0x3278E964,
                0x9F1F9532,
                0xE0D392DF,
                0xD3A0342B,
                0x8971F21E,
                0x1B0A7441,
                0x4BA3348C,
                0xC5BE7120,
                0xC37632D8,
                0xDF359F8D,
                0x9B992F2E,
                0xE60B6F47,
                0x0FE3F11D,
                0xE54CDA54,
                0x1EDAD891,
                0xCE6279CF,
                0xCD3E7E6F,
                0x1618B166,
                0xFD2C1D05,
                0x848FD2C5,
                0xF6FB2299,
                0xF523F357,
                0xA6327623,
                0x93A83531,
                0x56CCCD02,
                0xACF08162,
                0x5A75EBB5,
                0x6E163697,
                0x88D273CC,
                0xDE966292,
                0x81B949D0,
                0x4C50901B,
                0x71C65614,
                0xE6C6C7BD,
                0x327A140A,
                0x45E1D006,
                0xC3F27B9A,
                0xC9AA53FD,
                0x62A80F00,
                0xBB25BFE2,
                0x35BDD2F6,
                0x71126905,
                0xB2040222,
                0xB6CBCF7C,
                0xCD769C2B,
                0x53113EC0,
                0x1640E3D3,
                0x38ABBD60,
                0x2547ADF0,
                0xBA38209C,
                0xF746CE76,
                0x77AFA1C5,
                0x20756060,
                0x85CBFE4E,
                0x8AE88DD8,
                0x7AAAF9B0,
                0x4CF9AA7E,
                0x1948C25C,
                0x02FB8A8C,
                0x01C36AE4,
                0xD6EBE1F9,
                0x90D4F869,
                0xA65CDEA0,
                0x3F09252D,
                0xC208E69F,
                0xB74E6132,
                0xCE77E25B,
                0x578FDFE3,
                0x3AC372E6
            ]
        ];
        var BLOWFISH_CTX = {
            pbox: [],
            sbox: []
        };
        function F(ctx, x) {
            let a = x >> 24 & 0xFF;
            let b = x >> 16 & 0xFF;
            let c = x >> 8 & 0xFF;
            let d = x & 0xFF;
            let y = ctx.sbox[0][a] + ctx.sbox[1][b];
            y = y ^ ctx.sbox[2][c];
            y = y + ctx.sbox[3][d];
            return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = 0; i < N; ++i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[N];
            Xl = Xl ^ ctx.pbox[N + 1];
            return {
                left: Xl,
                right: Xr
            };
        }
        function BlowFish_Decrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = N + 1; i > 1; --i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[1];
            Xl = Xl ^ ctx.pbox[0];
            return {
                left: Xl,
                right: Xr
            };
        }
        /**
	     * Initialization ctx's pbox and sbox.
	     *
	     * @param {Object} ctx The object has pbox and sbox.
	     * @param {Array} key An array of 32-bit words.
	     * @param {int} keysize The length of the key.
	     *
	     * @example
	     *
	     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	     */ function BlowFishInit(ctx, key, keysize) {
            for(let Row = 0; Row < 4; Row++){
                ctx.sbox[Row] = [];
                for(let Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
            let keyIndex = 0;
            for(let index = 0; index < N + 2; index++){
                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                keyIndex++;
                if (keyIndex >= keysize) keyIndex = 0;
            }
            let Data1 = 0;
            let Data2 = 0;
            let res = 0;
            for(let i = 0; i < N + 2; i += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.pbox[i] = Data1;
                ctx.pbox[i + 1] = Data2;
            }
            for(let i = 0; i < 4; i++)for(let j = 0; j < 256; j += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.sbox[i][j] = Data1;
                ctx.sbox[i][j + 1] = Data2;
            }
            return true;
        }
        /**
	     * Blowfish block cipher algorithm.
	     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                //Initialization pbox and sbox
                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
            },
            encryptBlock: function(M, offset) {
                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            decryptBlock: function(M, offset) {
                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            blockSize: 2,
            keySize: 4,
            ivSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
    })();
    return CryptoJS.Blowfish;
});

},{"6c1b1f80a09547ea":"isPlo","76a4278a3203b7b3":"7G9uR","31b1f7acda670f6":"fzW7d","c8a50eb69fdf3b02":"8HKlY","3c354e713d4cd19b":"inDpW"}],"3zlVa":[function(require,module,exports) {
(function(name, root, factory) {
    module.exports = factory();
    module.exports["default"] = factory();
})("slugify", this, function() {
    var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","\xa2":"cent","\xa3":"pound","\xa4":"currency","\xa5":"yen","\xa9":"(c)","\xaa":"a","\xae":"(r)","\xba":"o","\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xc6":"AE","\xc7":"C","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xd0":"D","\xd1":"N","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xdd":"Y","\xde":"TH","\xdf":"ss","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xe6":"ae","\xe7":"c","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xf0":"d","\xf1":"n","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xfd":"y","\xfe":"th","\xff":"y","\u0100":"A","\u0101":"a","\u0102":"A","\u0103":"a","\u0104":"A","\u0105":"a","\u0106":"C","\u0107":"c","\u010C":"C","\u010D":"c","\u010E":"D","\u010F":"d","\u0110":"DJ","\u0111":"dj","\u0112":"E","\u0113":"e","\u0116":"E","\u0117":"e","\u0118":"e","\u0119":"e","\u011A":"E","\u011B":"e","\u011E":"G","\u011F":"g","\u0122":"G","\u0123":"g","\u0128":"I","\u0129":"i","\u012A":"i","\u012B":"i","\u012E":"I","\u012F":"i","\u0130":"I","\u0131":"i","\u0136":"k","\u0137":"k","\u013B":"L","\u013C":"l","\u013D":"L","\u013E":"l","\u0141":"L","\u0142":"l","\u0143":"N","\u0144":"n","\u0145":"N","\u0146":"n","\u0147":"N","\u0148":"n","\u014C":"O","\u014D":"o","\u0150":"O","\u0151":"o","\u0152":"OE","\u0153":"oe","\u0154":"R","\u0155":"r","\u0158":"R","\u0159":"r","\u015A":"S","\u015B":"s","\u015E":"S","\u015F":"s","\u0160":"S","\u0161":"s","\u0162":"T","\u0163":"t","\u0164":"T","\u0165":"t","\u0168":"U","\u0169":"u","\u016A":"u","\u016B":"u","\u016E":"U","\u016F":"u","\u0170":"U","\u0171":"u","\u0172":"U","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017A":"z","\u017B":"Z","\u017C":"z","\u017D":"Z","\u017E":"z","\u018F":"E","\u0192":"f","\u01A0":"O","\u01A1":"o","\u01AF":"U","\u01B0":"u","\u01C8":"LJ","\u01C9":"lj","\u01CB":"NJ","\u01CC":"nj","\u0218":"S","\u0219":"s","\u021A":"T","\u021B":"t","\u0259":"e","\u02DA":"o","\u0386":"A","\u0388":"E","\u0389":"H","\u038A":"I","\u038C":"O","\u038E":"Y","\u038F":"W","\u0390":"i","\u0391":"A","\u0392":"B","\u0393":"G","\u0394":"D","\u0395":"E","\u0396":"Z","\u0397":"H","\u0398":"8","\u0399":"I","\u039A":"K","\u039B":"L","\u039C":"M","\u039D":"N","\u039E":"3","\u039F":"O","\u03A0":"P","\u03A1":"R","\u03A3":"S","\u03A4":"T","\u03A5":"Y","\u03A6":"F","\u03A7":"X","\u03A8":"PS","\u03A9":"W","\u03AA":"I","\u03AB":"Y","\u03AC":"a","\u03AD":"e","\u03AE":"h","\u03AF":"i","\u03B0":"y","\u03B1":"a","\u03B2":"b","\u03B3":"g","\u03B4":"d","\u03B5":"e","\u03B6":"z","\u03B7":"h","\u03B8":"8","\u03B9":"i","\u03BA":"k","\u03BB":"l","\u03BC":"m","\u03BD":"n","\u03BE":"3","\u03BF":"o","\u03C0":"p","\u03C1":"r","\u03C2":"s","\u03C3":"s","\u03C4":"t","\u03C5":"y","\u03C6":"f","\u03C7":"x","\u03C8":"ps","\u03C9":"w","\u03CA":"i","\u03CB":"y","\u03CC":"o","\u03CD":"y","\u03CE":"w","\u0401":"Yo","\u0402":"DJ","\u0404":"Ye","\u0406":"I","\u0407":"Yi","\u0408":"J","\u0409":"LJ","\u040A":"NJ","\u040B":"C","\u040F":"DZ","\u0410":"A","\u0411":"B","\u0412":"V","\u0413":"G","\u0414":"D","\u0415":"E","\u0416":"Zh","\u0417":"Z","\u0418":"I","\u0419":"J","\u041A":"K","\u041B":"L","\u041C":"M","\u041D":"N","\u041E":"O","\u041F":"P","\u0420":"R","\u0421":"S","\u0422":"T","\u0423":"U","\u0424":"F","\u0425":"H","\u0426":"C","\u0427":"Ch","\u0428":"Sh","\u0429":"Sh","\u042A":"U","\u042B":"Y","\u042C":"","\u042D":"E","\u042E":"Yu","\u042F":"Ya","\u0430":"a","\u0431":"b","\u0432":"v","\u0433":"g","\u0434":"d","\u0435":"e","\u0436":"zh","\u0437":"z","\u0438":"i","\u0439":"j","\u043A":"k","\u043B":"l","\u043C":"m","\u043D":"n","\u043E":"o","\u043F":"p","\u0440":"r","\u0441":"s","\u0442":"t","\u0443":"u","\u0444":"f","\u0445":"h","\u0446":"c","\u0447":"ch","\u0448":"sh","\u0449":"sh","\u044A":"u","\u044B":"y","\u044C":"","\u044D":"e","\u044E":"yu","\u044F":"ya","\u0451":"yo","\u0452":"dj","\u0454":"ye","\u0456":"i","\u0457":"yi","\u0458":"j","\u0459":"lj","\u045A":"nj","\u045B":"c","\u045D":"u","\u045F":"dz","\u0490":"G","\u0491":"g","\u0492":"GH","\u0493":"gh","\u049A":"KH","\u049B":"kh","\u04A2":"NG","\u04A3":"ng","\u04AE":"UE","\u04AF":"ue","\u04B0":"U","\u04B1":"u","\u04BA":"H","\u04BB":"h","\u04D8":"AE","\u04D9":"ae","\u04E8":"OE","\u04E9":"oe","\u0531":"A","\u0532":"B","\u0533":"G","\u0534":"D","\u0535":"E","\u0536":"Z","\u0537":"E\'","\u0538":"Y\'","\u0539":"T\'","\u053A":"JH","\u053B":"I","\u053C":"L","\u053D":"X","\u053E":"C\'","\u053F":"K","\u0540":"H","\u0541":"D\'","\u0542":"GH","\u0543":"TW","\u0544":"M","\u0545":"Y","\u0546":"N","\u0547":"SH","\u0549":"CH","\u054A":"P","\u054B":"J","\u054C":"R\'","\u054D":"S","\u054E":"V","\u054F":"T","\u0550":"R","\u0551":"C","\u0553":"P\'","\u0554":"Q\'","\u0555":"O\'\'","\u0556":"F","\u0587":"EV","\u0621":"a","\u0622":"aa","\u0623":"a","\u0624":"u","\u0625":"i","\u0626":"e","\u0627":"a","\u0628":"b","\u0629":"h","\u062A":"t","\u062B":"th","\u062C":"j","\u062D":"h","\u062E":"kh","\u062F":"d","\u0630":"th","\u0631":"r","\u0632":"z","\u0633":"s","\u0634":"sh","\u0635":"s","\u0636":"dh","\u0637":"t","\u0638":"z","\u0639":"a","\u063A":"gh","\u0641":"f","\u0642":"q","\u0643":"k","\u0644":"l","\u0645":"m","\u0646":"n","\u0647":"h","\u0648":"w","\u0649":"a","\u064A":"y","\u064B":"an","\u064C":"on","\u064D":"en","\u064E":"a","\u064F":"u","\u0650":"e","\u0652":"","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u067E":"p","\u0686":"ch","\u0698":"zh","\u06A9":"k","\u06AF":"g","\u06CC":"y","\u06F0":"0","\u06F1":"1","\u06F2":"2","\u06F3":"3","\u06F4":"4","\u06F5":"5","\u06F6":"6","\u06F7":"7","\u06F8":"8","\u06F9":"9","\u0E3F":"baht","\u10D0":"a","\u10D1":"b","\u10D2":"g","\u10D3":"d","\u10D4":"e","\u10D5":"v","\u10D6":"z","\u10D7":"t","\u10D8":"i","\u10D9":"k","\u10DA":"l","\u10DB":"m","\u10DC":"n","\u10DD":"o","\u10DE":"p","\u10DF":"zh","\u10E0":"r","\u10E1":"s","\u10E2":"t","\u10E3":"u","\u10E4":"f","\u10E5":"k","\u10E6":"gh","\u10E7":"q","\u10E8":"sh","\u10E9":"ch","\u10EA":"ts","\u10EB":"dz","\u10EC":"ts","\u10ED":"ch","\u10EE":"kh","\u10EF":"j","\u10F0":"h","\u1E62":"S","\u1E63":"s","\u1E80":"W","\u1E81":"w","\u1E82":"W","\u1E83":"w","\u1E84":"W","\u1E85":"w","\u1E9E":"SS","\u1EA0":"A","\u1EA1":"a","\u1EA2":"A","\u1EA3":"a","\u1EA4":"A","\u1EA5":"a","\u1EA6":"A","\u1EA7":"a","\u1EA8":"A","\u1EA9":"a","\u1EAA":"A","\u1EAB":"a","\u1EAC":"A","\u1EAD":"a","\u1EAE":"A","\u1EAF":"a","\u1EB0":"A","\u1EB1":"a","\u1EB2":"A","\u1EB3":"a","\u1EB4":"A","\u1EB5":"a","\u1EB6":"A","\u1EB7":"a","\u1EB8":"E","\u1EB9":"e","\u1EBA":"E","\u1EBB":"e","\u1EBC":"E","\u1EBD":"e","\u1EBE":"E","\u1EBF":"e","\u1EC0":"E","\u1EC1":"e","\u1EC2":"E","\u1EC3":"e","\u1EC4":"E","\u1EC5":"e","\u1EC6":"E","\u1EC7":"e","\u1EC8":"I","\u1EC9":"i","\u1ECA":"I","\u1ECB":"i","\u1ECC":"O","\u1ECD":"o","\u1ECE":"O","\u1ECF":"o","\u1ED0":"O","\u1ED1":"o","\u1ED2":"O","\u1ED3":"o","\u1ED4":"O","\u1ED5":"o","\u1ED6":"O","\u1ED7":"o","\u1ED8":"O","\u1ED9":"o","\u1EDA":"O","\u1EDB":"o","\u1EDC":"O","\u1EDD":"o","\u1EDE":"O","\u1EDF":"o","\u1EE0":"O","\u1EE1":"o","\u1EE2":"O","\u1EE3":"o","\u1EE4":"U","\u1EE5":"u","\u1EE6":"U","\u1EE7":"u","\u1EE8":"U","\u1EE9":"u","\u1EEA":"U","\u1EEB":"u","\u1EEC":"U","\u1EED":"u","\u1EEE":"U","\u1EEF":"u","\u1EF0":"U","\u1EF1":"u","\u1EF2":"Y","\u1EF3":"y","\u1EF4":"Y","\u1EF5":"y","\u1EF6":"Y","\u1EF7":"y","\u1EF8":"Y","\u1EF9":"y","\u2013":"-","\u2018":"\'","\u2019":"\'","\u201C":"\\"","\u201D":"\\"","\u201E":"\\"","\u2020":"+","\u2022":"*","\u2026":"...","\u20A0":"ecu","\u20A2":"cruzeiro","\u20A3":"french franc","\u20A4":"lira","\u20A5":"mill","\u20A6":"naira","\u20A7":"peseta","\u20A8":"rupee","\u20A9":"won","\u20AA":"new shequel","\u20AB":"dong","\u20AC":"euro","\u20AD":"kip","\u20AE":"tugrik","\u20AF":"drachma","\u20B0":"penny","\u20B1":"peso","\u20B2":"guarani","\u20B3":"austral","\u20B4":"hryvnia","\u20B5":"cedi","\u20B8":"kazakhstani tenge","\u20B9":"indian rupee","\u20BA":"turkish lira","\u20BD":"russian ruble","\u20BF":"bitcoin","\u2120":"sm","\u2122":"tm","\u2202":"d","\u2206":"delta","\u2211":"sum","\u221E":"infinity","\u2665":"love","\u5143":"yuan","\u5186":"yen","\uFDFC":"rial","\uFEF5":"laa","\uFEF7":"laa","\uFEF9":"lai","\uFEFB":"la"}');
    var locales = JSON.parse('{"bg":{"\u0419":"Y","\u0426":"Ts","\u0429":"Sht","\u042A":"A","\u042C":"Y","\u0439":"y","\u0446":"ts","\u0449":"sht","\u044A":"a","\u044C":"y"},"de":{"\xc4":"AE","\xe4":"ae","\xd6":"OE","\xf6":"oe","\xdc":"UE","\xfc":"ue","\xdf":"ss","%":"prozent","&":"und","|":"oder","\u2211":"summe","\u221E":"unendlich","\u2665":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","\xa2":"centavos","\xa3":"libras","\xa4":"moneda","\u20A3":"francos","\u2211":"suma","\u221E":"infinito","\u2665":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","\xa2":"centime","\xa3":"livre","\xa4":"devise","\u20A3":"franc","\u2211":"somme","\u221E":"infini","\u2665":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","\xa2":"centavo","\u2211":"soma","\xa3":"libra","\u221E":"infinito","\u2665":"amor"},"uk":{"\u0418":"Y","\u0438":"y","\u0419":"Y","\u0439":"y","\u0426":"Ts","\u0446":"ts","\u0425":"Kh","\u0445":"kh","\u0429":"Shch","\u0449":"shch","\u0413":"H","\u0433":"h"},"vi":{"\u0110":"D","\u0111":"d"},"da":{"\xd8":"OE","\xf8":"oe","\xc5":"AA","\xe5":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"st\xf8rre end"},"nb":{"&":"og","\xc5":"AA","\xc6":"AE","\xd8":"OE","\xe5":"aa","\xe6":"ae","\xf8":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","\xc5":"AA","\xc4":"AE","\xd6":"OE","\xe5":"aa","\xe4":"ae","\xf6":"oe"}}');
    function replace(string, options) {
        if (typeof string !== "string") throw new Error("slugify: string argument expected");
        options = typeof options === "string" ? {
            replacement: options
        } : options || {};
        var locale = locales[options.locale] || {};
        var replacement = options.replacement === undefined ? "-" : options.replacement;
        var trim = options.trim === undefined ? true : options.trim;
        var slug = string.normalize().split("")// replace characters based on charMap
        .reduce(function(result, ch) {
            var appendChar = locale[ch];
            if (appendChar === undefined) appendChar = charMap[ch];
            if (appendChar === undefined) appendChar = ch;
            if (appendChar === replacement) appendChar = " ";
            return result + appendChar// remove not allowed characters
            .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        if (options.strict) slug = slug.replace(/[^A-Za-z0-9\s]/g, "");
        if (trim) slug = slug.trim();
        // Replace spaces with replacement character, treating multiple consecutive
        // spaces as a single space.
        slug = slug.replace(/\s+/g, replacement);
        if (options.lower) slug = slug.toLowerCase();
        return slug;
    }
    replace.extend = function(customMap) {
        Object.assign(charMap, customMap);
    };
    return replace;
});

},{}],"jDleQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "icons16", ()=>icons16);
parcelHelpers.export(exports, "icons20", ()=>icons20);
parcelHelpers.export(exports, "icons24", ()=>icons24);
parcelHelpers.export(exports, "icons32", ()=>icons32);
parcelHelpers.export(exports, "icons", ()=>icons);
parcelHelpers.export(exports, "PdqIcon", ()=>PdqIcon);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _16Js = require("@carbon/web-components/es/icons/add/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("@carbon/web-components/es/icons/arrow--right/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _16Js2 = require("@carbon/web-components/es/icons/arrow--left/16.js");
var _16JsDefault2 = parcelHelpers.interopDefault(_16Js2);
var _16Js3 = require("@carbon/web-components/es/icons/arrow--up/16.js");
var _16JsDefault3 = parcelHelpers.interopDefault(_16Js3);
var _16Js4 = require("@carbon/web-components/es/icons/arrow--down/16.js");
var _16JsDefault4 = parcelHelpers.interopDefault(_16Js4);
var _16Js5 = require("@carbon/web-components/es/icons/checkmark/16.js");
var _16JsDefault5 = parcelHelpers.interopDefault(_16Js5);
var _16Js6 = require("@carbon/web-components/es/icons/close/16.js");
var _16JsDefault6 = parcelHelpers.interopDefault(_16Js6);
var _16Js7 = require("@carbon/web-components/es/icons/delete/16.js");
var _16JsDefault7 = parcelHelpers.interopDefault(_16Js7);
var _16Js8 = require("@carbon/web-components/es/icons/download/16.js");
var _16JsDefault8 = parcelHelpers.interopDefault(_16Js8);
var _16Js9 = require("@carbon/web-components/es/icons/edit/16.js");
var _16JsDefault9 = parcelHelpers.interopDefault(_16Js9);
var _16Js10 = require("@carbon/web-components/es/icons/error/16.js");
var _16JsDefault10 = parcelHelpers.interopDefault(_16Js10);
var _16Js11 = require("@carbon/web-components/es/icons/help/16.js");
var _16JsDefault11 = parcelHelpers.interopDefault(_16Js11);
var _16Js12 = require("@carbon/web-components/es/icons/information/16.js");
var _16JsDefault12 = parcelHelpers.interopDefault(_16Js12);
var _16Js13 = require("@carbon/web-components/es/icons/menu/16.js");
var _16JsDefault13 = parcelHelpers.interopDefault(_16Js13);
var _16Js14 = require("@carbon/web-components/es/icons/overflow-menu--horizontal/16.js");
var _16JsDefault14 = parcelHelpers.interopDefault(_16Js14);
var _16Js15 = require("@carbon/web-components/es/icons/overflow-menu--vertical/16.js");
var _16JsDefault15 = parcelHelpers.interopDefault(_16Js15);
var _16Js16 = require("@carbon/web-components/es/icons/save/16.js");
var _16JsDefault16 = parcelHelpers.interopDefault(_16Js16);
var _16Js17 = require("@carbon/web-components/es/icons/search/16.js");
var _16JsDefault17 = parcelHelpers.interopDefault(_16Js17);
var _16Js18 = require("@carbon/web-components/es/icons/settings/16.js");
var _16JsDefault18 = parcelHelpers.interopDefault(_16Js18);
var _16Js19 = require("@carbon/web-components/es/icons/warning/16.js");
var _16JsDefault19 = parcelHelpers.interopDefault(_16Js19);
var _16Js20 = require("@carbon/web-components/es/icons/renew/16.js");
var _16JsDefault20 = parcelHelpers.interopDefault(_16Js20);
var _20Js = require("@carbon/web-components/es/icons/add/20.js");
var _20JsDefault = parcelHelpers.interopDefault(_20Js);
var _20Js1 = require("@carbon/web-components/es/icons/arrow--right/20.js");
var _20JsDefault1 = parcelHelpers.interopDefault(_20Js1);
var _20Js2 = require("@carbon/web-components/es/icons/arrow--left/20.js");
var _20JsDefault2 = parcelHelpers.interopDefault(_20Js2);
var _20Js3 = require("@carbon/web-components/es/icons/arrow--up/20.js");
var _20JsDefault3 = parcelHelpers.interopDefault(_20Js3);
var _20Js4 = require("@carbon/web-components/es/icons/arrow--down/20.js");
var _20JsDefault4 = parcelHelpers.interopDefault(_20Js4);
var _20Js5 = require("@carbon/web-components/es/icons/checkmark/20.js");
var _20JsDefault5 = parcelHelpers.interopDefault(_20Js5);
var _20Js6 = require("@carbon/web-components/es/icons/close/20.js");
var _20JsDefault6 = parcelHelpers.interopDefault(_20Js6);
var _20Js7 = require("@carbon/web-components/es/icons/delete/20.js");
var _20JsDefault7 = parcelHelpers.interopDefault(_20Js7);
var _20Js8 = require("@carbon/web-components/es/icons/download/20.js");
var _20JsDefault8 = parcelHelpers.interopDefault(_20Js8);
var _20Js9 = require("@carbon/web-components/es/icons/edit/20.js");
var _20JsDefault9 = parcelHelpers.interopDefault(_20Js9);
var _20Js10 = require("@carbon/web-components/es/icons/error/20.js");
var _20JsDefault10 = parcelHelpers.interopDefault(_20Js10);
var _20Js11 = require("@carbon/web-components/es/icons/help/20.js");
var _20JsDefault11 = parcelHelpers.interopDefault(_20Js11);
var _20Js12 = require("@carbon/web-components/es/icons/information/20.js");
var _20JsDefault12 = parcelHelpers.interopDefault(_20Js12);
var _20Js13 = require("@carbon/web-components/es/icons/menu/20.js");
var _20JsDefault13 = parcelHelpers.interopDefault(_20Js13);
var _20Js14 = require("@carbon/web-components/es/icons/overflow-menu--horizontal/20.js");
var _20JsDefault14 = parcelHelpers.interopDefault(_20Js14);
var _20Js15 = require("@carbon/web-components/es/icons/overflow-menu--vertical/20.js");
var _20JsDefault15 = parcelHelpers.interopDefault(_20Js15);
var _20Js16 = require("@carbon/web-components/es/icons/save/20.js");
var _20JsDefault16 = parcelHelpers.interopDefault(_20Js16);
var _20Js17 = require("@carbon/web-components/es/icons/search/20.js");
var _20JsDefault17 = parcelHelpers.interopDefault(_20Js17);
var _20Js18 = require("@carbon/web-components/es/icons/settings/20.js");
var _20JsDefault18 = parcelHelpers.interopDefault(_20Js18);
var _20Js19 = require("@carbon/web-components/es/icons/warning/20.js");
var _20JsDefault19 = parcelHelpers.interopDefault(_20Js19);
var _20Js20 = require("@carbon/web-components/es/icons/renew/20.js");
var _20JsDefault20 = parcelHelpers.interopDefault(_20Js20);
var _24Js = require("@carbon/web-components/es/icons/add/24.js");
var _24JsDefault = parcelHelpers.interopDefault(_24Js);
var _24Js1 = require("@carbon/web-components/es/icons/arrow--right/24.js");
var _24JsDefault1 = parcelHelpers.interopDefault(_24Js1);
var _24Js2 = require("@carbon/web-components/es/icons/arrow--left/24.js");
var _24JsDefault2 = parcelHelpers.interopDefault(_24Js2);
var _24Js3 = require("@carbon/web-components/es/icons/arrow--up/24.js");
var _24JsDefault3 = parcelHelpers.interopDefault(_24Js3);
var _24Js4 = require("@carbon/web-components/es/icons/arrow--down/24.js");
var _24JsDefault4 = parcelHelpers.interopDefault(_24Js4);
var _24Js5 = require("@carbon/web-components/es/icons/checkmark/24.js");
var _24JsDefault5 = parcelHelpers.interopDefault(_24Js5);
var _24Js6 = require("@carbon/web-components/es/icons/close/24.js");
var _24JsDefault6 = parcelHelpers.interopDefault(_24Js6);
var _24Js7 = require("@carbon/web-components/es/icons/delete/24.js");
var _24JsDefault7 = parcelHelpers.interopDefault(_24Js7);
var _24Js8 = require("@carbon/web-components/es/icons/download/24.js");
var _24JsDefault8 = parcelHelpers.interopDefault(_24Js8);
var _24Js9 = require("@carbon/web-components/es/icons/edit/24.js");
var _24JsDefault9 = parcelHelpers.interopDefault(_24Js9);
var _24Js10 = require("@carbon/web-components/es/icons/error/24.js");
var _24JsDefault10 = parcelHelpers.interopDefault(_24Js10);
var _24Js11 = require("@carbon/web-components/es/icons/help/24.js");
var _24JsDefault11 = parcelHelpers.interopDefault(_24Js11);
var _24Js12 = require("@carbon/web-components/es/icons/information/24.js");
var _24JsDefault12 = parcelHelpers.interopDefault(_24Js12);
var _24Js13 = require("@carbon/web-components/es/icons/menu/24.js");
var _24JsDefault13 = parcelHelpers.interopDefault(_24Js13);
var _24Js14 = require("@carbon/web-components/es/icons/overflow-menu--horizontal/24.js");
var _24JsDefault14 = parcelHelpers.interopDefault(_24Js14);
var _24Js15 = require("@carbon/web-components/es/icons/overflow-menu--vertical/24.js");
var _24JsDefault15 = parcelHelpers.interopDefault(_24Js15);
var _24Js16 = require("@carbon/web-components/es/icons/save/24.js");
var _24JsDefault16 = parcelHelpers.interopDefault(_24Js16);
var _24Js17 = require("@carbon/web-components/es/icons/search/24.js");
var _24JsDefault17 = parcelHelpers.interopDefault(_24Js17);
var _24Js18 = require("@carbon/web-components/es/icons/settings/24.js");
var _24JsDefault18 = parcelHelpers.interopDefault(_24Js18);
var _24Js19 = require("@carbon/web-components/es/icons/warning/24.js");
var _24JsDefault19 = parcelHelpers.interopDefault(_24Js19);
var _24Js20 = require("@carbon/web-components/es/icons/renew/24.js");
var _24JsDefault20 = parcelHelpers.interopDefault(_24Js20);
var _32Js = require("@carbon/web-components/es/icons/add/32.js");
var _32JsDefault = parcelHelpers.interopDefault(_32Js);
var _32Js1 = require("@carbon/web-components/es/icons/arrow--right/32.js");
var _32JsDefault1 = parcelHelpers.interopDefault(_32Js1);
var _32Js2 = require("@carbon/web-components/es/icons/arrow--left/32.js");
var _32JsDefault2 = parcelHelpers.interopDefault(_32Js2);
var _32Js3 = require("@carbon/web-components/es/icons/arrow--up/32.js");
var _32JsDefault3 = parcelHelpers.interopDefault(_32Js3);
var _32Js4 = require("@carbon/web-components/es/icons/arrow--down/32.js");
var _32JsDefault4 = parcelHelpers.interopDefault(_32Js4);
var _32Js5 = require("@carbon/web-components/es/icons/checkmark/32.js");
var _32JsDefault5 = parcelHelpers.interopDefault(_32Js5);
var _32Js6 = require("@carbon/web-components/es/icons/close/32.js");
var _32JsDefault6 = parcelHelpers.interopDefault(_32Js6);
var _32Js7 = require("@carbon/web-components/es/icons/delete/32.js");
var _32JsDefault7 = parcelHelpers.interopDefault(_32Js7);
var _32Js8 = require("@carbon/web-components/es/icons/download/32.js");
var _32JsDefault8 = parcelHelpers.interopDefault(_32Js8);
var _32Js9 = require("@carbon/web-components/es/icons/edit/32.js");
var _32JsDefault9 = parcelHelpers.interopDefault(_32Js9);
var _32Js10 = require("@carbon/web-components/es/icons/error/32.js");
var _32JsDefault10 = parcelHelpers.interopDefault(_32Js10);
var _32Js11 = require("@carbon/web-components/es/icons/help/32.js");
var _32JsDefault11 = parcelHelpers.interopDefault(_32Js11);
var _32Js12 = require("@carbon/web-components/es/icons/information/32.js");
var _32JsDefault12 = parcelHelpers.interopDefault(_32Js12);
var _32Js13 = require("@carbon/web-components/es/icons/menu/32.js");
var _32JsDefault13 = parcelHelpers.interopDefault(_32Js13);
var _32Js14 = require("@carbon/web-components/es/icons/overflow-menu--horizontal/32.js");
var _32JsDefault14 = parcelHelpers.interopDefault(_32Js14);
var _32Js15 = require("@carbon/web-components/es/icons/overflow-menu--vertical/32.js");
var _32JsDefault15 = parcelHelpers.interopDefault(_32Js15);
var _32Js16 = require("@carbon/web-components/es/icons/save/32.js");
var _32JsDefault16 = parcelHelpers.interopDefault(_32Js16);
var _32Js17 = require("@carbon/web-components/es/icons/search/32.js");
var _32JsDefault17 = parcelHelpers.interopDefault(_32Js17);
var _32Js18 = require("@carbon/web-components/es/icons/settings/32.js");
var _32JsDefault18 = parcelHelpers.interopDefault(_32Js18);
var _32Js19 = require("@carbon/web-components/es/icons/warning/32.js");
var _32JsDefault19 = parcelHelpers.interopDefault(_32Js19);
var _32Js20 = require("@carbon/web-components/es/icons/renew/32.js");
var _32JsDefault20 = parcelHelpers.interopDefault(_32Js20);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:ui:pdq-icon");
const icons16 = new Map([
    [
        "add",
        (0, _16JsDefault.default)
    ],
    [
        "arrowRight",
        (0, _16JsDefault1.default)
    ],
    [
        "arrowLeft",
        (0, _16JsDefault2.default)
    ],
    [
        "arrowUp",
        (0, _16JsDefault3.default)
    ],
    [
        "arrowDown",
        (0, _16JsDefault4.default)
    ],
    [
        "checkmark",
        (0, _16JsDefault5.default)
    ],
    [
        "close",
        (0, _16JsDefault6.default)
    ],
    [
        "delete",
        (0, _16JsDefault7.default)
    ],
    [
        "download",
        (0, _16JsDefault8.default)
    ],
    [
        "edit",
        (0, _16JsDefault9.default)
    ],
    [
        "error",
        (0, _16JsDefault10.default)
    ],
    [
        "help",
        (0, _16JsDefault11.default)
    ],
    [
        "information",
        (0, _16JsDefault12.default)
    ],
    [
        "menu",
        (0, _16JsDefault13.default)
    ],
    [
        "overflowMenuHorizontal",
        (0, _16JsDefault14.default)
    ],
    [
        "overflowMenuVertical",
        (0, _16JsDefault15.default)
    ],
    [
        "save",
        (0, _16JsDefault16.default)
    ],
    [
        "search",
        (0, _16JsDefault17.default)
    ],
    [
        "settings",
        (0, _16JsDefault18.default)
    ],
    [
        "warning",
        (0, _16JsDefault19.default)
    ],
    [
        "renew",
        (0, _16JsDefault20.default)
    ]
]);
const icons20 = new Map([
    [
        "add",
        (0, _20JsDefault.default)
    ],
    [
        "arrowRight",
        (0, _20JsDefault1.default)
    ],
    [
        "arrowLeft",
        (0, _20JsDefault2.default)
    ],
    [
        "arrowUp",
        (0, _20JsDefault3.default)
    ],
    [
        "arrowDown",
        (0, _20JsDefault4.default)
    ],
    [
        "checkmark",
        (0, _20JsDefault5.default)
    ],
    [
        "close",
        (0, _20JsDefault6.default)
    ],
    [
        "delete",
        (0, _20JsDefault7.default)
    ],
    [
        "download",
        (0, _20JsDefault8.default)
    ],
    [
        "edit",
        (0, _20JsDefault9.default)
    ],
    [
        "error",
        (0, _20JsDefault10.default)
    ],
    [
        "help",
        (0, _20JsDefault11.default)
    ],
    [
        "information",
        (0, _20JsDefault12.default)
    ],
    [
        "menu",
        (0, _20JsDefault13.default)
    ],
    [
        "overflowMenuHorizontal",
        (0, _20JsDefault14.default)
    ],
    [
        "overflowMenuVertical",
        (0, _20JsDefault15.default)
    ],
    [
        "save",
        (0, _20JsDefault16.default)
    ],
    [
        "search",
        (0, _20JsDefault17.default)
    ],
    [
        "settings",
        (0, _20JsDefault18.default)
    ],
    [
        "warning",
        (0, _20JsDefault19.default)
    ],
    [
        "renew",
        (0, _20JsDefault20.default)
    ]
]);
const icons24 = new Map([
    [
        "add",
        (0, _24JsDefault.default)
    ],
    [
        "arrowRight",
        (0, _24JsDefault1.default)
    ],
    [
        "arrowLeft",
        (0, _24JsDefault2.default)
    ],
    [
        "arrowUp",
        (0, _24JsDefault3.default)
    ],
    [
        "arrowDown",
        (0, _24JsDefault4.default)
    ],
    [
        "checkmark",
        (0, _24JsDefault5.default)
    ],
    [
        "close",
        (0, _24JsDefault6.default)
    ],
    [
        "delete",
        (0, _24JsDefault7.default)
    ],
    [
        "download",
        (0, _24JsDefault8.default)
    ],
    [
        "edit",
        (0, _24JsDefault9.default)
    ],
    [
        "error",
        (0, _24JsDefault10.default)
    ],
    [
        "help",
        (0, _24JsDefault11.default)
    ],
    [
        "information",
        (0, _24JsDefault12.default)
    ],
    [
        "menu",
        (0, _24JsDefault13.default)
    ],
    [
        "overflowMenuHorizontal",
        (0, _24JsDefault14.default)
    ],
    [
        "overflowMenuVertical",
        (0, _24JsDefault15.default)
    ],
    [
        "save",
        (0, _24JsDefault16.default)
    ],
    [
        "search",
        (0, _24JsDefault17.default)
    ],
    [
        "settings",
        (0, _24JsDefault18.default)
    ],
    [
        "warning",
        (0, _24JsDefault19.default)
    ],
    [
        "renew",
        (0, _24JsDefault20.default)
    ]
]);
const icons32 = new Map([
    [
        "add",
        (0, _32JsDefault.default)
    ],
    [
        "arrowRight",
        (0, _32JsDefault1.default)
    ],
    [
        "arrowLeft",
        (0, _32JsDefault2.default)
    ],
    [
        "arrowUp",
        (0, _32JsDefault3.default)
    ],
    [
        "arrowDown",
        (0, _32JsDefault4.default)
    ],
    [
        "checkmark",
        (0, _32JsDefault5.default)
    ],
    [
        "close",
        (0, _32JsDefault6.default)
    ],
    [
        "delete",
        (0, _32JsDefault7.default)
    ],
    [
        "download",
        (0, _32JsDefault8.default)
    ],
    [
        "edit",
        (0, _32JsDefault9.default)
    ],
    [
        "error",
        (0, _32JsDefault10.default)
    ],
    [
        "help",
        (0, _32JsDefault11.default)
    ],
    [
        "information",
        (0, _32JsDefault12.default)
    ],
    [
        "menu",
        (0, _32JsDefault13.default)
    ],
    [
        "overflowMenuHorizontal",
        (0, _32JsDefault14.default)
    ],
    [
        "overflowMenuVertical",
        (0, _32JsDefault15.default)
    ],
    [
        "save",
        (0, _32JsDefault16.default)
    ],
    [
        "search",
        (0, _32JsDefault17.default)
    ],
    [
        "settings",
        (0, _32JsDefault18.default)
    ],
    [
        "warning",
        (0, _32JsDefault19.default)
    ],
    [
        "renew",
        (0, _32JsDefault20.default)
    ]
]);
const icons = new Map([
    [
        16,
        icons16
    ],
    [
        20,
        icons20
    ],
    [
        24,
        icons24
    ],
    [
        32,
        icons32
    ]
]);
let PdqIcon = class PdqIcon extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this._iconFunc = null;
        this._icon = "";
        this.size = 16;
        this.options = {};
    }
    get icon() {
        return this._icon;
    }
    set icon(value) {
        this._icon = value;
        const collection = icons.get(this.size);
        if (!collection) {
            this.error("invalid size");
            return;
        }
        const icon = collection.get(value);
        if (!icon) {
            this.error("invalid icon name");
            return;
        }
        this._iconFunc = icon;
    }
    render() {
        if (!this._iconFunc) return 0, _lit.nothing;
        return (0, _lit.html)`${this._iconFunc(this.options)}`;
    }
    error(msg) {
        log("WARNING:" + msg);
        this.size = 16;
        this.icon = "warning";
    }
};
PdqIcon.styles = (0, _lit.css)``;
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [
        String
    ])
], PdqIcon.prototype, "icon", null);
__decorate([
    (0, _decorators.property)({
        type: Number
    }),
    __metadata("design:type", Object)
], PdqIcon.prototype, "size", void 0);
__decorate([
    (0, _decorators.property)({
        type: Object
    }),
    __metadata("design:type", Object)
], PdqIcon.prototype, "options", void 0);
PdqIcon = __decorate([
    (0, _decorators.customElement)("pdq-icon")
], PdqIcon);

},{"lit/decorators":"kQrIl","lit":"aCmte","@carbon/web-components/es/icons/add/16.js":"ks2lc","@carbon/web-components/es/icons/arrow--right/16.js":"58M6A","@carbon/web-components/es/icons/arrow--left/16.js":"3NGzq","@carbon/web-components/es/icons/arrow--up/16.js":"bJVi7","@carbon/web-components/es/icons/arrow--down/16.js":"gdQ1D","@carbon/web-components/es/icons/checkmark/16.js":"wAzn7","@carbon/web-components/es/icons/close/16.js":"b7Sho","@carbon/web-components/es/icons/delete/16.js":"35TaP","@carbon/web-components/es/icons/download/16.js":"3qmiG","@carbon/web-components/es/icons/edit/16.js":"8mJ6F","@carbon/web-components/es/icons/error/16.js":"McjxX","@carbon/web-components/es/icons/help/16.js":"b2t31","@carbon/web-components/es/icons/information/16.js":"egTgj","@carbon/web-components/es/icons/menu/16.js":"lCAJa","@carbon/web-components/es/icons/overflow-menu--horizontal/16.js":"aqZOZ","@carbon/web-components/es/icons/overflow-menu--vertical/16.js":"5HN3n","@carbon/web-components/es/icons/save/16.js":"atEnQ","@carbon/web-components/es/icons/search/16.js":"ba4X4","@carbon/web-components/es/icons/settings/16.js":"bJgrF","@carbon/web-components/es/icons/warning/16.js":"9PYbD","@carbon/web-components/es/icons/renew/16.js":"db9c0","@carbon/web-components/es/icons/add/20.js":"4sQ62","@carbon/web-components/es/icons/arrow--right/20.js":"7nzyM","@carbon/web-components/es/icons/arrow--left/20.js":"wTexx","@carbon/web-components/es/icons/arrow--up/20.js":"9z0IO","@carbon/web-components/es/icons/arrow--down/20.js":"dIMwo","@carbon/web-components/es/icons/checkmark/20.js":"iVOjS","@carbon/web-components/es/icons/close/20.js":"4EJkx","@carbon/web-components/es/icons/delete/20.js":"2TAT5","@carbon/web-components/es/icons/download/20.js":"7xXwf","@carbon/web-components/es/icons/edit/20.js":"etZLt","@carbon/web-components/es/icons/error/20.js":"dSe5Q","@carbon/web-components/es/icons/help/20.js":"en0jp","@carbon/web-components/es/icons/information/20.js":"9LJ4H","@carbon/web-components/es/icons/menu/20.js":"9yyPM","@carbon/web-components/es/icons/overflow-menu--horizontal/20.js":"6zarY","@carbon/web-components/es/icons/overflow-menu--vertical/20.js":"7fNlB","@carbon/web-components/es/icons/save/20.js":"7kTpr","@carbon/web-components/es/icons/search/20.js":"1Ae2V","@carbon/web-components/es/icons/settings/20.js":"lr0hR","@carbon/web-components/es/icons/warning/20.js":"8Mljg","@carbon/web-components/es/icons/renew/20.js":"4BFdT","@carbon/web-components/es/icons/add/24.js":"ddEvs","@carbon/web-components/es/icons/arrow--right/24.js":"jXjIS","@carbon/web-components/es/icons/arrow--left/24.js":"7L1mM","@carbon/web-components/es/icons/arrow--up/24.js":"fx7J5","@carbon/web-components/es/icons/arrow--down/24.js":"8fS7W","@carbon/web-components/es/icons/checkmark/24.js":"bQxZd","@carbon/web-components/es/icons/close/24.js":"bvc0r","@carbon/web-components/es/icons/delete/24.js":"iw1B0","@carbon/web-components/es/icons/download/24.js":"a6Lcp","@carbon/web-components/es/icons/edit/24.js":"bNhZB","@carbon/web-components/es/icons/error/24.js":"178Mx","@carbon/web-components/es/icons/help/24.js":"bzEye","@carbon/web-components/es/icons/information/24.js":"dDU8T","@carbon/web-components/es/icons/menu/24.js":"5MYgq","@carbon/web-components/es/icons/overflow-menu--horizontal/24.js":"l8Az4","@carbon/web-components/es/icons/overflow-menu--vertical/24.js":"50RBB","@carbon/web-components/es/icons/save/24.js":"ed46d","@carbon/web-components/es/icons/search/24.js":"i060d","@carbon/web-components/es/icons/settings/24.js":"k787x","@carbon/web-components/es/icons/warning/24.js":"eQkTJ","@carbon/web-components/es/icons/renew/24.js":"h2zXx","@carbon/web-components/es/icons/add/32.js":"68O4L","@carbon/web-components/es/icons/arrow--right/32.js":"5jT1p","@carbon/web-components/es/icons/arrow--left/32.js":"d0ghR","@carbon/web-components/es/icons/arrow--up/32.js":"1qzl9","@carbon/web-components/es/icons/arrow--down/32.js":"fJCLp","@carbon/web-components/es/icons/checkmark/32.js":"3KTfF","@carbon/web-components/es/icons/close/32.js":"aSuru","@carbon/web-components/es/icons/delete/32.js":"eq8XY","@carbon/web-components/es/icons/download/32.js":"gEmEL","@carbon/web-components/es/icons/edit/32.js":"fJRtg","@carbon/web-components/es/icons/error/32.js":"gqg9Q","@carbon/web-components/es/icons/help/32.js":"1cMCD","@carbon/web-components/es/icons/information/32.js":"cJo2m","@carbon/web-components/es/icons/menu/32.js":"8uu8L","@carbon/web-components/es/icons/overflow-menu--horizontal/32.js":"hcj8L","@carbon/web-components/es/icons/overflow-menu--vertical/32.js":"jhY95","@carbon/web-components/es/icons/save/32.js":"2SAHp","@carbon/web-components/es/icons/search/32.js":"4WvuZ","@carbon/web-components/es/icons/settings/32.js":"gUtHw","@carbon/web-components/es/icons/warning/32.js":"2bUvB","@carbon/web-components/es/icons/renew/32.js":"fwq5z","debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ks2lc":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"58M6A":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M9.3 3.7L13.1 7.5 1 7.5 1 8.5 13.1 8.5 9.3 12.3 10 13 15 8 10 3z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3NGzq":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M6.7 12.3L2.9 8.5 15 8.5 15 7.5 2.9 7.5 6.7 3.7 6 3 1 8 6 13z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bJVi7":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M3.7 6.7L7.5 2.9 7.5 15 8.5 15 8.5 2.9 12.3 6.7 13 6 8 1 3 6z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gdQ1D":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M12.3 9.3L8.5 13.1 8.5 1 7.5 1 7.5 13.1 3.7 9.3 3 10 8 15 13 10z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"wAzn7":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"35TaP":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="m29,26H12c-.2651,0-.5195-.1053-.707-.2928L2.293,16.7072c-.3906-.3906-.3906-1.0237,0-1.4143L11.293,6.2928c.1875-.1875.4419-.2928.707-.2928h17c.5522,0,1,.4478,1,1v18c0,.5522-.4478,1-1,1Zm-16.5857-2h15.5857V8h-15.5857l-8,8,8,8Z"></path><path d="M20.4141 16L25 11.4141 23.5859 10 19 14.5859 14.4143 10 13 11.4141 17.5859 16 13 20.5859 14.4143 22 19 17.4141 23.5859 22 25 20.5859 20.4141 16z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3qmiG":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M13 7L12.3 6.3 8.5 10.1 8.5 1 7.5 1 7.5 10.1 3.7 6.3 3 7 8 12zM13 12v2H3v-2H2v2l0 0c0 .6.4 1 1 1h10c.6 0 1-.4 1-1l0 0v-2H13z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8mJ6F":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M2 26H30V28H2zM25.4 9c.8-.8.8-2 0-2.8 0 0 0 0 0 0l-3.6-3.6c-.8-.8-2-.8-2.8 0 0 0 0 0 0 0l-15 15V24h6.4L25.4 9zM20.4 4L24 7.6l-3 3L17.4 7 20.4 4zM6 22v-3.6l10-10 3.6 3.6-10 10H6z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"McjxX":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b2t31":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"></path><circle cx="8" cy="11.8" r=".8"></circle><path d="M8.5,4H7.8C6.5,4,5.5,5,5.5,6.2c0,0,0,0,0,0v0.2h1V6.2C6.5,5.6,7.1,5,7.8,5h0.8c0.7,0,1.2,0.6,1.2,1.2S9.2,7.5,8.5,7.5h-1	v2.2h1V8.5c1.2,0,2.2-1,2.2-2.2S9.7,4,8.5,4z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"egTgj":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M8.5 11L8.5 6.5 6.5 6.5 6.5 7.5 7.5 7.5 7.5 11 6 11 6 12 10 12 10 11zM8 3.5c-.4 0-.8.3-.8.8S7.6 5 8 5c.4 0 .8-.3.8-.8S8.4 3.5 8 3.5z"></path><path d="M8,15c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S11.9,15,8,15z M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lCAJa":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M2 12H14V13H2zM2 9H14V10H2zM2 6H14V7H2zM2 3H14V4H2z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aqZOZ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<circle cx="8" cy="16" r="2"></circle><circle cx="16" cy="16" r="2"></circle><circle cx="24" cy="16" r="2"></circle></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5HN3n":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<circle cx="16" cy="8" r="2"></circle><circle cx="16" cy="16" r="2"></circle><circle cx="16" cy="24" r="2"></circle></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"atEnQ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M13.9,4.6l-2.5-2.5C11.3,2.1,11.1,2,11,2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V5	C14,4.9,13.9,4.7,13.9,4.6z M6,3h4v2H6V3z M10,13H6V9h4V13z M11,13V9c0-0.6-0.4-1-1-1H6C5.4,8,5,8.4,5,9v4H3V3h2v2c0,0.6,0.4,1,1,1	h4c0.6,0,1-0.4,1-1V3.2l2,2V13H11z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ba4X4":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5	C2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bJgrF":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M13.5,8.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4l1-0.8c0.4-0.3,0.4-0.9,0.2-1.3l-1.2-2C13.3,3.2,13,3,12.6,3	c-0.1,0-0.2,0-0.3,0.1l-1.2,0.4c-0.2-0.1-0.4-0.3-0.7-0.4l-0.3-1.3C10.1,1.3,9.7,1,9.2,1H6.8c-0.5,0-0.9,0.3-1,0.8L5.6,3.1	C5.3,3.2,5.1,3.3,4.9,3.4L3.7,3C3.6,3,3.5,3,3.4,3C3,3,2.7,3.2,2.5,3.5l-1.2,2C1.1,5.9,1.2,6.4,1.6,6.8l0.9,0.9c0,0.1,0,0.3,0,0.4	c0,0.1,0,0.3,0,0.4L1.6,9.2c-0.4,0.3-0.5,0.9-0.2,1.3l1.2,2C2.7,12.8,3,13,3.4,13c0.1,0,0.2,0,0.3-0.1l1.2-0.4	c0.2,0.1,0.4,0.3,0.7,0.4l0.3,1.3c0.1,0.5,0.5,0.8,1,0.8h2.4c0.5,0,0.9-0.3,1-0.8l0.3-1.3c0.2-0.1,0.4-0.2,0.7-0.4l1.2,0.4	c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.7-0.2,0.9-0.5l1.1-2c0.2-0.4,0.2-0.9-0.2-1.3L13.5,8.4z M12.6,12l-1.7-0.6c-0.4,0.3-0.9,0.6-1.4,0.8	L9.2,14H6.8l-0.4-1.8c-0.5-0.2-0.9-0.5-1.4-0.8L3.4,12l-1.2-2l1.4-1.2c-0.1-0.5-0.1-1.1,0-1.6L2.2,6l1.2-2l1.7,0.6	C5.5,4.2,6,4,6.5,3.8L6.8,2h2.4l0.4,1.8c0.5,0.2,0.9,0.5,1.4,0.8L12.6,4l1.2,2l-1.4,1.2c0.1,0.5,0.1,1.1,0,1.6l1.4,1.2L12.6,12z"></path><path d="M8,11c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3C11,9.6,9.7,11,8,11C8,11,8,11,8,11z M8,6C6.9,6,6,6.8,6,7.9C6,7.9,6,8,6,8	c0,1.1,0.8,2,1.9,2c0,0,0.1,0,0.1,0c1.1,0,2-0.8,2-1.9c0,0,0-0.1,0-0.1C10,6.9,9.2,6,8,6C8.1,6,8,6,8,6z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9PYbD":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"></path><path d="M7.5 4H8.5V9H7.5zM8 10.2c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.2 8 10.2z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"db9c0":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4sQ62":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7nzyM":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20">${children}<path d="M11.8 2.8L10.8 3.8 16.2 9.3 1 9.3 1 10.7 16.2 10.7 10.8 16.2 11.8 17.2 19 10z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"wTexx":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M14 26L15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9z0IO":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M16 4L6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dIMwo":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M24.59 16.59L17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iVOjS":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20">${children}<path d="M8 13.2L3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"></path><path d="M15.6 5.6L8 13.2 3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2TAT5":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="m29,26H12c-.2651,0-.5195-.1053-.707-.2928L2.293,16.7072c-.3906-.3906-.3906-1.0237,0-1.4143L11.293,6.2928c.1875-.1875.4419-.2928.707-.2928h17c.5522,0,1,.4478,1,1v18c0,.5522-.4478,1-1,1Zm-16.5857-2h15.5857V8h-15.5857l-8,8,8,8Z"></path><path d="M20.4141 16L25 11.4141 23.5859 10 19 14.5859 14.4143 10 13 11.4141 17.5859 16 13 20.5859 14.4143 22 19 17.4141 23.5859 22 25 20.5859 20.4141 16z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7xXwf":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M26 24v4H6V24H4v4H4a2 2 0 002 2H26a2 2 0 002-2h0V24zM26 14L24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"etZLt":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M2 26H30V28H2zM25.4 9c.8-.8.8-2 0-2.8 0 0 0 0 0 0l-3.6-3.6c-.8-.8-2-.8-2.8 0 0 0 0 0 0 0l-15 15V24h6.4L25.4 9zM20.4 4L24 7.6l-3 3L17.4 7 20.4 4zM6 22v-3.6l10-10 3.6 3.6-10 10H6z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dSe5Q":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"en0jp":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"></path><circle cx="16" cy="23.5" r="1.5"></circle><path d="M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9LJ4H":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"></path><path d="M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9yyPM":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20">${children}<path d="M2 14.8H18V16H2zM2 11.2H18V12.399999999999999H2zM2 7.6H18V8.799999999999999H2zM2 4H18V5.2H2z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6zarY":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<circle cx="8" cy="16" r="2"></circle><circle cx="16" cy="16" r="2"></circle><circle cx="24" cy="16" r="2"></circle></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7fNlB":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<circle cx="16" cy="8" r="2"></circle><circle cx="16" cy="16" r="2"></circle><circle cx="16" cy="24" r="2"></circle></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7kTpr":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20">${children}<path d="M17.8,5.5l-3.3-3.3C14.3,2.1,14.2,2,14,2H3.3C2.6,2,2,2.6,2,3.3v13.3C2,17.4,2.6,18,3.3,18h13.3c0.7,0,1.4-0.5,1.4-1.2V6.1	C18,5.7,17.9,5.7,17.8,5.5z M7.3,3.3h5.3v3.3H7.3V3.3z M12.7,16.7H7.3v-5.3h5.3L12.7,16.7L12.7,16.7z M14,16.7v-5.3	c0-0.7-0.6-1.3-1.3-1.3H7.3C6.6,10,6,10.6,6,11.3v5.3H3.3V3.3H6v3.3C6,7.4,6.6,8,7.3,8h5.3C13.4,8,14,7.4,14,6.7v-3l2.7,2.7v10.4	L14,16.7L14,16.7z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Ae2V":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lr0hR":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"></path><path d="M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Mljg":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"></path><path d="M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BFdT":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ddEvs":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jXjIS":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24">${children}<path d="M14 4L12.9 5.1 18.9 11.2 2 11.2 2 12.8 18.9 12.8 12.9 18.9 14 20 22 12z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7L1mM":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M14 26L15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fx7J5":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M16 4L6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8fS7W":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M24.59 16.59L17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bQxZd":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24">${children}<path d="M10 15.9L4.7 10.6 3.6 11.6 8.9 16.9 10 18 20.6 7.4 19.5 6.3z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bvc0r":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M17.4141 16L24 9.4141 22.5859 8 16 14.5859 9.4143 8 8 9.4141 14.5859 16 8 22.5859 9.4143 24 16 17.4141 22.5859 24 24 22.5859 17.4141 16z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iw1B0":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="m29,26H12c-.2651,0-.5195-.1053-.707-.2928L2.293,16.7072c-.3906-.3906-.3906-1.0237,0-1.4143L11.293,6.2928c.1875-.1875.4419-.2928.707-.2928h17c.5522,0,1,.4478,1,1v18c0,.5522-.4478,1-1,1Zm-16.5857-2h15.5857V8h-15.5857l-8,8,8,8Z"></path><path d="M20.4141 16L25 11.4141 23.5859 10 19 14.5859 14.4143 10 13 11.4141 17.5859 16 13 20.5859 14.4143 22 19 17.4141 23.5859 22 25 20.5859 20.4141 16z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a6Lcp":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M26 24v4H6V24H4v4H4a2 2 0 002 2H26a2 2 0 002-2h0V24zM26 14L24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bNhZB":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M2 26H30V28H2zM25.4 9c.8-.8.8-2 0-2.8 0 0 0 0 0 0l-3.6-3.6c-.8-.8-2-.8-2.8 0 0 0 0 0 0 0l-15 15V24h6.4L25.4 9zM20.4 4L24 7.6l-3 3L17.4 7 20.4 4zM6 22v-3.6l10-10 3.6 3.6-10 10H6z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"178Mx":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzEye":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"></path><circle cx="16" cy="23.5" r="1.5"></circle><path d="M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dDU8T":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"></path><path d="M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5MYgq":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24">${children}<path d="M3 18H21V19.5H3zM3 13.5H21V15H3zM3 9H21V10.5H3zM3 4.5H21V6H3z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l8Az4":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<circle cx="8" cy="16" r="2"></circle><circle cx="16" cy="16" r="2"></circle><circle cx="24" cy="16" r="2"></circle></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"50RBB":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<circle cx="16" cy="8" r="2"></circle><circle cx="16" cy="16" r="2"></circle><circle cx="16" cy="24" r="2"></circle></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ed46d":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24">${children}<path d="M20.8,7L17,3.2C16.9,3.1,16.7,3,16.5,3h-12C3.7,3,3,3.7,3,4.5v15C3,20.3,3.7,21,4.5,21h15c0.8,0,1.5-0.7,1.5-1.5v-12	C21,7.3,20.9,7.1,20.8,7z M9,4.5h6v3H9V4.5z M15,19.5H9v-6h6V19.5z M16.5,19.5v-6c0-0.8-0.7-1.5-1.5-1.5H9c-0.8,0-1.5,0.7-1.5,1.5v6	h-3v-15h3v3C7.5,8.3,8.2,9,9,9h6c0.8,0,1.5-0.7,1.5-1.5V4.8l3,3v11.7H16.5z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i060d":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k787x":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"></path><path d="M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eQkTJ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"></path><path d="M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h2zXx":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="24" height="24" viewBox="0 0 32 32">${children}<path d="M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"68O4L":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5jT1p":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M18 6L16.57 7.393 24.15 15 4 15 4 17 24.15 17 16.57 24.573 18 26 28 16 18 6z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d0ghR":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M14 26L15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1qzl9":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M16 4L6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fJCLp":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M24.59 16.59L17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3KTfF":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aSuru":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M17.4141 16L24 9.4141 22.5859 8 16 14.5859 9.4143 8 8 9.4141 14.5859 16 8 22.5859 9.4143 24 16 17.4141 22.5859 24 24 22.5859 17.4141 16z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eq8XY":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="m29,26H12c-.2651,0-.5195-.1053-.707-.2928L2.293,16.7072c-.3906-.3906-.3906-1.0237,0-1.4143L11.293,6.2928c.1875-.1875.4419-.2928.707-.2928h17c.5522,0,1,.4478,1,1v18c0,.5522-.4478,1-1,1Zm-16.5857-2h15.5857V8h-15.5857l-8,8,8,8Z"></path><path d="M20.4141 16L25 11.4141 23.5859 10 19 14.5859 14.4143 10 13 11.4141 17.5859 16 13 20.5859 14.4143 22 19 17.4141 23.5859 22 25 20.5859 20.4141 16z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gEmEL":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M26 24v4H6V24H4v4H4a2 2 0 002 2H26a2 2 0 002-2h0V24zM26 14L24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fJRtg":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M2 26H30V28H2zM25.4 9c.8-.8.8-2 0-2.8 0 0 0 0 0 0l-3.6-3.6c-.8-.8-2-.8-2.8 0 0 0 0 0 0 0l-15 15V24h6.4L25.4 9zM20.4 4L24 7.6l-3 3L17.4 7 20.4 4zM6 22v-3.6l10-10 3.6 3.6-10 10H6z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gqg9Q":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1cMCD":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"></path><circle cx="16" cy="23.5" r="1.5"></circle><path d="M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cJo2m":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"></path><path d="M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8uu8L":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M4 6H28V8H4zM4 24H28V26H4zM4 12H28V14H4zM4 18H28V20H4z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hcj8L":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<circle cx="8" cy="16" r="2"></circle><circle cx="16" cy="16" r="2"></circle><circle cx="24" cy="16" r="2"></circle></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jhY95":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<circle cx="16" cy="8" r="2"></circle><circle cx="16" cy="16" r="2"></circle><circle cx="16" cy="24" r="2"></circle></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2SAHp":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M27.71,9.29l-5-5A1,1,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V10A1,1,0,0,0,27.71,9.29ZM12,6h8v4H12Zm8,20H12V18h8Zm2,0V18a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V26Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4WvuZ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gUtHw":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"></path><path d="M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2bUvB":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"></path><path d="M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fwq5z":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iRpTl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqTheme", ()=>PdqTheme);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _16Js = require("@carbon/web-components/es/icons/overflow-menu--vertical/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _utils = require("../utils");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:ui:pdq-theme");
let PdqTheme = class PdqTheme extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.target = "body";
        this.theme = (0, _utils.getDefaultThemeMode)() == (0, _utils.ThemeMode).light ? "cds-theme-zone-white" : "cds-theme-zone-90";
        this.options = {
            "White": "cds-theme-zone-white",
            "Light": "cds-theme-zone-g10",
            "Dark": "cds-theme-zone-g90",
            "Black": "cds-theme-zone-g100"
        };
    // connectedCallback() {
    //   super.connectedCallback();
    //   this.observer = new MutationObserver((mutationsList) => {
    //     for (const mutation of mutationsList) {
    //       if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
    //         console.log('Class attribute changed:', mutation);
    //         const values = Object.values(this.options)
    //         if (!values.includes()) {
    //
    //         }
    //       }
    //     }
    //   });
    //
    //   this.observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    // }
    //
    // disconnectedCallback() {
    //   if (this.observer) {
    //     this.observer.disconnect();
    //   }
    //   super.disconnectedCallback();
    // }
    }
    render() {
        return (0, _lit.html)`
        <cds-overflow-menu>
          ${(0, _16JsDefault.default)({
            class: `cds--overflow-menu__icon`,
            slot: "icon"
        })}
          <span slot="tooltip-content"> Theme </span>
          <cds-overflow-menu-body style="background: var(--cds-layer-01, white);">
            ${Object.keys(this.options).map((key)=>{
            return (0, _lit.html)`<cds-button kind="secondary" size="sm" style="width: 100%"
                                      @click=${()=>this.themeChange(this.options[key])}>${key}</cds-button>`;
        })}
          </cds-overflow-menu-body>
        </cds-overflow-menu>
    `;
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.themeChange(this.theme);
    }
    themeChange(evt) {
        log(`themeChange called with ${evt}`);
        const el = document.querySelector(this.target);
        if (!el) {
            log(`target '${this.target}' not found`);
            return;
        }
        const values = Object.values(this.options);
        if (!values.includes(evt)) {
            log(`target '${this.target}' not found`);
            return;
        }
        this.theme = evt;
        values.map((i)=>el.classList.remove(i));
        el.classList.add(this.theme);
        log("themeChange changed to", evt);
    }
};
PdqTheme.styles = (0, _lit.css)`
    :host {
        position: relative;
    }
    cds-overflow-menu-body {
      background: var(--cds-layer-01, white);
    }
    cds-overflow-menu-item{
      background: var(--cds-layer-01, white);
    }
  `;
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqTheme.prototype, "target", void 0);
__decorate([
    (0, _decorators.property)({
        type: String,
        reflect: true
    }),
    __metadata("design:type", Object)
], PdqTheme.prototype, "theme", void 0);
__decorate([
    (0, _decorators.property)({
        type: Object,
        reflect: true
    }),
    __metadata("design:type", Object)
], PdqTheme.prototype, "options", void 0);
PdqTheme = __decorate([
    (0, _decorators.customElement)("pdq-theme")
], PdqTheme);

},{"lit/decorators":"kQrIl","lit":"aCmte","@carbon/web-components/es/icons/overflow-menu--vertical/16.js":"5HN3n","debug":"17JIf","../utils":"i8jxn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fA7mR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqJson", ()=>PdqJson);
var _lit = require("lit");
var _decorators = require("lit/decorators");
var _styles = require("../styles");
var _utils = require("../utils");
var _notificationService = require("../services/notificationService");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _indexJs = require("@carbon/web-components/es/components/copy-button/index.js");
var _indexJs1 = require("@carbon/web-components/es/components/icon-button/index.js");
var _indexJs2 = require("@carbon/web-components/es/components/textarea/index.js");
var _indexJs3 = require("@carbon/web-components/es/components/tag/index.js");
var _16Js = require("@carbon/web-components/es/icons/data-table/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("@carbon/web-components/es/icons/save/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _pdqHotkeyService = require("../services/PdqHotkeyService");
var _pdqHotkeyServiceDefault = parcelHelpers.interopDefault(_pdqHotkeyService);
var _pdqMixin = require("./_pdq-mixin");
var _defs = require("@carbon/web-components/es/components/tag/defs");
var _dataBroker = require("../services/DataBroker");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var PdqJson_1;
var _a;
const log = (0, _debugDefault.default)("pdq:flow:pdq-json");
let PdqJson = PdqJson_1 = class PdqJson extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.error = null;
        this.show = false;
        this.json = "";
        this.dataPreview = "no data";
        this._id = 0;
        this._onSlotChange = async (event)=>{
            console.log("slot change");
            log(`${this.id} - slot change`);
            const slot = event.target;
            const nodes = slot.assignedNodes({
                flatten: true
            });
            const template = (0, _utils.extractTextFromScripts)(nodes);
            try {
                const json = JSON.parse(template);
                if (this.dataPreview !== json) {
                    log(`${this.id} - slot change - setting data source`, json);
                    await (0, _dataBroker.dataBroker).setDataSource(this.id, json);
                    this.json = JSON.stringify(json, null, 2);
                    this.dataPreview = this.json;
                }
                this.error = null;
            } catch (e) {
                log(`${this.id} - slot change error`);
                console.log(e);
                (0, _notificationService.notificationService).error(`pdq-json: ${this.id} - Error parsing JSON: ${e.message}`);
                this.error = e.message ? e.message : e;
            }
        };
        this._id = PdqJson_1.next_id++;
    }
    render() {
        log(`${this.id} ${this.show} - render`);
        const slot = (0, _lit.html)`<slot id="pdq-json-${this._id}" class="hide ${this.error ? "error" : ""}" name="json" @slotchange="${this._onSlotChange}"></slot>`;
        const show = this.show || (0, _pdqHotkeyServiceDefault.default).showPdqData.currentValue();
        return (0, _lit.html)`
            ${slot}
            ${!!this.error ? (0, _lit.html)`<cds-inline-notification kind="error" title="PDQ Json" subtitle="${this.error} ${typeof this.error}"></cds-inline-notification>` : (0, _lit.nothing)}
            ${show ? (0, _lit.html)`
                <div class="col show ${this.error ? "error" : ""} m-1">
                    ${this.renderToolBar((0, _lit.html)`<cds-icon-button slot="tool-bar" @click="${this.save}" kind="primary" tooltip-text="Save">
                        ${(0, _16JsDefault1.default)({
            slot: "icon"
        })}
                    </cds-icon-button>`)}
                    <cds-textarea value="${this.json}">
                        <label slot="label-text">Config:</label>
                    </cds-textarea>
                </div>
                ` : (0, _lit.nothing)}`;
    }
    async save() {
        log("save");
        if (!this.textArea) return;
        try {
            const data = JSON.parse(this.textArea.value);
            await (0, _dataBroker.dataBroker).setDataSource(this.id, data);
            this.dataPreview = data;
        } catch (e) {
            log(`save error: ${e}`);
            (0, _notificationService.notificationService).error(`pdq-json: ${this.id} - Failed to save... Error parsing JSON: ${e.message}`);
        }
    }
};
PdqJson.styles = [
    (0, _styles.hide),
    (0, _styles.row),
    (0, _styles.col),
    (0, _styles.grow),
    (0, _styles.padding),
    (0, _styles.margin)
];
PdqJson.next_id = 0;
__decorate([
    (0, _decorators.query)("cds-textarea"),
    __metadata("design:type", Object)
], PdqJson.prototype, "textArea", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Object)
], PdqJson.prototype, "error", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Boolean)
], PdqJson.prototype, "show", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", String)
], PdqJson.prototype, "json", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Object)
], PdqJson.prototype, "dataPreview", void 0);
PdqJson = PdqJson_1 = __decorate([
    (0, _decorators.customElement)("pdq-json"),
    (0, _pdqMixin.pdqDiscoveryLayer)(log, (0, _16JsDefault.default), "pdq-json", "rgba(255, 236, 83, 0.13)", (0, _defs.TAG_TYPE).CYAN),
    __metadata("design:paramtypes", [])
], PdqJson);

},{"lit":"aCmte","lit/decorators":"kQrIl","../styles":"86IFJ","../utils":"i8jxn","../services/notificationService":"2Yic8","debug":"17JIf","@carbon/web-components/es/components/copy-button/index.js":"5DrQc","@carbon/web-components/es/components/icon-button/index.js":"hEDP1","@carbon/web-components/es/components/textarea/index.js":"i8YTZ","@carbon/web-components/es/components/tag/index.js":"6Wp6j","@carbon/web-components/es/icons/data-table/16.js":"4fHNP","@carbon/web-components/es/icons/save/16.js":"atEnQ","../services/PdqHotkeyService":"blgFb","./_pdq-mixin":"66yqo","@carbon/web-components/es/components/tag/defs":"ioe2X","../services/DataBroker":"kD6gB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"86IFJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "row", ()=>row);
parcelHelpers.export(exports, "col", ()=>col);
parcelHelpers.export(exports, "center", ()=>center);
parcelHelpers.export(exports, "grow", ()=>grow);
parcelHelpers.export(exports, "shrink", ()=>shrink);
parcelHelpers.export(exports, "wrap", ()=>wrap);
parcelHelpers.export(exports, "margin", ()=>margin);
parcelHelpers.export(exports, "marginLeft", ()=>marginLeft);
parcelHelpers.export(exports, "marginTop", ()=>marginTop);
parcelHelpers.export(exports, "marginRight", ()=>marginRight);
parcelHelpers.export(exports, "marginBottom", ()=>marginBottom);
parcelHelpers.export(exports, "marginAll", ()=>marginAll);
parcelHelpers.export(exports, "padding", ()=>padding);
parcelHelpers.export(exports, "paddingLeft", ()=>paddingLeft);
parcelHelpers.export(exports, "paddingTop", ()=>paddingTop);
parcelHelpers.export(exports, "paddingRight", ()=>paddingRight);
parcelHelpers.export(exports, "paddingBottom", ()=>paddingBottom);
parcelHelpers.export(exports, "paddingAll", ()=>paddingAll);
var _lit = require("lit");
const hide = (0, _lit.css)`
  .hide:not(show) {
    display: none;
  }
`;
const row = (0, _lit.css)`
  .row {
    display: flex;
    flex-direction: row;
  }
`;
const col = (0, _lit.css)`
  .col {
    display: flex;
    flex-direction: column;
  }
`;
const center = (0, _lit.css)`
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const grow = (0, _lit.css)`
    .grow {
        flex-grow: 1;
    }
`;
const shrink = (0, _lit.css)`
    .shrink {
        flex-shrink: 1;
    }
`;
const wrap = (0, _lit.css)`
    .wrap {
        flex-wrap: wrap;
    }
`;
const sizes = [
    0,
    8,
    16,
    24,
    32,
    48,
    64,
    80,
    96
];
const margin = sizes.map((size, idx)=>(0, _lit.css)`.m-${idx} { margin: ${size}px; }`);
const marginLeft = sizes.map((size, idx)=>(0, _lit.css)`.ml-${idx} { margin-left: ${size}px; }`);
const marginTop = sizes.map((size, idx)=>(0, _lit.css)`.mt-${idx} { margin-top: ${size}px; }`);
const marginRight = sizes.map((size, idx)=>(0, _lit.css)`.mr-${idx} { margin-right: ${size}px; }`);
const marginBottom = sizes.map((size, idx)=>(0, _lit.css)`.mb-${idx} { margin-bottom: ${size}px; }`);
const marginAll = [
    ...margin,
    ...marginLeft,
    ...marginTop,
    ...marginRight,
    ...marginBottom
];
const padding = sizes.map((size, idx)=>(0, _lit.css)`.p-${idx} { padding: ${size}px; }`);
const paddingLeft = sizes.map((size, idx)=>(0, _lit.css)`.p-${idx} { padding-left: ${size}px; }`);
const paddingTop = sizes.map((size, idx)=>(0, _lit.css)`.p-${idx} { padding-top: ${size}px; }`);
const paddingRight = sizes.map((size, idx)=>(0, _lit.css)`.p-${idx} { padding-right: ${size}px; }`);
const paddingBottom = sizes.map((size, idx)=>(0, _lit.css)`.p-${idx} { padding-bottom: ${size}px; }`);
const paddingAll = [
    ...padding,
    ...paddingLeft,
    ...paddingTop,
    ...paddingRight,
    ...paddingBottom
];

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5DrQc":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _copyButtonJs = require("./copy-button.js");

},{"./copy-button.js":"cyRrk"}],"cyRrk":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSCopyButton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _16Js = require("../../icons/copy/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _copyButtonScssJs = require("./copy-button.scss.js");
var _copyButtonScssJsDefault = parcelHelpers.interopDefault(_copyButtonScssJs);
var _copyJs = require("../copy/copy.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Copy button.
 *
 * @element cds-copy-button
 */ let CDSCopyButton = class CDSCopyButton extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if the button should be disabled.
         */ this.disabled = false;
        /**
         * Specify the string that is displayed when the button is clicked and the content is copi
         */ this.feedback = "Copied!";
        /**
         * The number in milliseconds to determine how long the tooltip should remain.
         */ this.feedbackTimeout = 2000;
    }
    render() {
        const { buttonClassName, disabled, feedback, feedbackTimeout } = this;
        let classes = `${(0, _settingsJs.prefix)}--copy-btn`;
        if (buttonClassName) classes += ` ${buttonClassName}`;
        return (0, _lit.html)`
      <cds-copy
        ?disabled=${disabled}
        feedback=${feedback}
        feedback-timeout=${feedbackTimeout}
        button-class-name=${classes}>
        ${(0, _16JsDefault.default)({
            slot: "icon",
            class: `${(0, _settingsJs.prefix)}--snippet__icon`
        })}
        <slot slot="tooltip-content"></slot>
      </cds-copy>
    `;
    }
};
CDSCopyButton.styles = (0, _copyButtonScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "button-class-name"
    })
], CDSCopyButton.prototype, "buttonClassName", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSCopyButton.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSCopyButton.prototype, "feedback", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        attribute: "feedback-timeout"
    })
], CDSCopyButton.prototype, "feedbackTimeout", void 0);
CDSCopyButton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-copy-button`)
], CDSCopyButton);
var CDSCopyButton$1 = CDSCopyButton;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/copy/16.js":"iG3T6","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./copy-button.scss.js":"eREad","../copy/copy.js":"iHWQT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iG3T6":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M28,10V28H10V10H28m0-2H10a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z"></path><path d="M4,18H2V4A2,2,0,0,1,4,2H18V4H4Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eREad":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--copy-btn{position:relative}.cds--copy-btn:hover{background-color:var(--cds-layer-hover)}.cds--copy-btn:active{background-color:var(--cds-layer-active)}.cds--copy-btn:before{block-size:0;border-style:solid;content:"";display:none;inline-size:0;position:absolute;z-index:6000}.cds--copy-btn .cds--copy-btn__feedback{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));box-sizing:content-box;color:var(--cds-text-inverse,#fff);display:none;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:auto;max-inline-size:13rem;min-inline-size:1.5rem;overflow:visible;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000;clip:auto}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--copy-btn .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-accelerator:true){.cds--copy-btn .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--copy-btn .cds--copy-btn__feedback{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--copy-btn .cds--copy-btn__feedback{border:1px solid transparent}}.cds--copy-btn.cds--copy-btn--animating .cds--copy-btn__feedback,.cds--copy-btn.cds--copy-btn--animating:before{display:block}.cds--copy-btn.cds--copy-btn--animating:before{border:none}.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-out .cds--copy-btn__feedback,.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-out:before{animation:cds--hide-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-in .cds--copy-btn__feedback,.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-in:before{animation:cds--show-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--copy-btn svg{fill:var(--cds-icon-primary,#161616)}.cds--copy{font-size:0}.cds--snippet html{font-size:100%}.cds--snippet body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--snippet code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--snippet strong{font-weight:600}.cds--snippet--disabled,.cds--snippet--disabled .cds--btn.cds--snippet-btn--expand{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--snippet--disabled .cds--copy-btn,.cds--snippet--disabled .cds--copy-btn:hover,.cds--snippet--disabled .cds--snippet-btn--expand:hover{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--snippet--disabled .cds--snippet-btn--expand .cds--icon-chevron--down,.cds--snippet--disabled .cds--snippet__icon{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--snippet code{font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333)}.cds--snippet--inline{background-color:var(--cds-layer);border:1px solid transparent;border-radius:4px;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline;padding:0;position:relative}.cds--snippet--inline html{font-size:100%}.cds--snippet--inline body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--snippet--inline code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--snippet--inline strong{font-weight:600}.cds--snippet--inline:hover{background-color:var(--cds-layer-hover)}.cds--snippet--inline:active{background-color:var(--cds-layer-active)}.cds--snippet--inline:focus{border:1px solid var(--cds-focus,#0f62fe);outline:none}.cds--snippet--inline:before{block-size:0;border:none;content:"";display:none;inline-size:0;position:absolute;z-index:6000}.cds--snippet--inline .cds--copy-btn__feedback{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));box-sizing:content-box;color:var(--cds-text-inverse,#fff);display:none;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:auto;max-inline-size:13rem;min-inline-size:1.5rem;overflow:visible;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000;clip:auto}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--snippet--inline .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-accelerator:true){.cds--snippet--inline .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--snippet--inline .cds--copy-btn__feedback{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--snippet--inline .cds--copy-btn__feedback{border:1px solid transparent}}.cds--snippet--inline.cds--copy-btn--animating .cds--copy-btn__feedback,.cds--snippet--inline.cds--copy-btn--animating:before{display:block}.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-out .cds--copy-btn__feedback,.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-out:before{animation:cds--hide-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-in .cds--copy-btn__feedback,.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-in:before{animation:cds--show-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--snippet--inline code{padding:0 .5rem}.cds--snippet--inline.cds--snippet--no-copy{display:inline-block}.cds--snippet--inline.cds--snippet--no-copy:hover{background-color:var(--cds-layer);cursor:auto}.cds--snippet--light.cds--snippet--inline.cds--snippet--no-copy:hover{background-color:var(--cds-layer-hover);cursor:auto}.cds--snippet--single{align-items:center;background-color:var(--cds-layer);block-size:2.5rem;display:flex;font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);max-inline-size:48rem;padding-inline-end:2.5rem;position:relative}.cds--snippet--single.cds--snippet--no-copy{padding:0}.cds--snippet--single.cds--snippet--no-copy:after{inset-inline-end:1rem}.cds--snippet--single .cds--snippet-container{align-items:center;block-size:100%;display:flex;overflow-x:auto;padding-inline-start:1rem;position:relative}.cds--snippet--single .cds--snippet-container:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--snippet--single .cds--snippet-container:focus{outline-style:dotted}}.cds--snippet--single pre{font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);padding-inline-end:.5rem}.cds--snippet--inline code,.cds--snippet--single pre{white-space:pre}.cds--snippet--multi{background-color:var(--cds-layer);display:flex;font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);max-inline-size:48rem;padding:1rem;position:relative}.cds--snippet--multi .cds--snippet-container{max-block-size:100%;min-block-size:100%;order:1;overflow-y:auto;position:relative;transition:max-height .15s cubic-bezier(.2,0,.38,.9)}.cds--snippet--multi .cds--snippet-container:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;outline-offset:0}@media screen and (prefers-contrast){.cds--snippet--multi .cds--snippet-container:focus{outline-style:dotted}}.cds--snippet--multi.cds--snippet--expand .cds--snippet-container{padding-block-end:1rem;transition:max-height .15s cubic-bezier(.2,0,.38,.9)}.cds--snippet--multi.cds--snippet--wraptext pre{white-space:pre-wrap;word-wrap:break-word}.cds--snippet--multi .cds--snippet-container pre{padding-inline-end:2.5rem}.cds--snippet--multi.cds--snippet--no-copy .cds--snippet-container pre{padding-inline-end:0}.cds--snippet--multi.cds--snippet--has-right-overflow:after{background-image:linear-gradient(to right,transparent,var(--cds-layer));block-size:100%;content:"";inline-size:1rem;inset-block-start:0;inset-inline-end:1rem;position:absolute}[dir=rtl] .cds--snippet--multi.cds--snippet--has-right-overflow:after{background-image:linear-gradient(to left,transparent,var(--cds-layer))}.cds--snippet--multi .cds--snippet-container pre code{overflow:hidden}.cds--btn>.cds--snippet__icon{margin-block-start:0}.cds--copy-btn{align-items:center;background-color:var(--cds-layer);border:none;cursor:pointer;display:flex;justify-content:center;outline:none;overflow:visible;padding:0}.cds--copy-btn html{font-size:100%}.cds--copy-btn body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--copy-btn code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--copy-btn strong{font-weight:600}.cds--copy-btn:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-color:var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--copy-btn:focus{outline-style:dotted}}.cds--snippet .cds--popover-container{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;inset-block-start:0;inset-inline-end:0;position:absolute}.cds--snippet--inline.cds--btn{block-size:1.25rem;inline-size:auto;max-inline-size:unset;min-block-size:1.25rem;padding-inline:0}.cds--snippet--inline.cds--btn.cds--btn--primary:hover{color:var(--cds-text-primary,#161616)}.cds--snippet.cds--snippet--multi .cds--popover-container{inset-block-start:.5rem;inset-inline-end:.5rem}.cds--snippet--multi .cds--copy-btn{z-index:10}.cds--snippet-btn--expand{align-items:center;background-color:var(--cds-layer);block-size:2rem;border:0;color:var(--cds-text-primary,#161616);display:inline-flex;font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inset-block-end:0;inset-inline-end:0;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);padding:.5rem 1rem;position:absolute;z-index:10}.cds--snippet-btn--expand .cds--snippet-btn--text{inset-block-start:-.0625rem;position:relative}.cds--snippet-btn--expand--hide.cds--snippet-btn--expand{display:none}.cds--snippet-btn--expand .cds--icon-chevron--down{fill:var(--cds-icon-primary,#161616);margin-inline-start:.5rem;transform:rotate(0deg);transition:.15s cubic-bezier(.2,0,.38,.9)}.cds--snippet-btn--expand:hover{background:var(--cds-layer-hover);color:var(--cds-text-primary,#161616)}.cds--snippet-btn--expand:active{background-color:var(--cds-layer-active)}.cds--snippet-btn--expand:focus{border-color:transparent;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--snippet-btn--expand:focus{outline-style:dotted}}.cds--snippet--expand .cds--snippet-btn--expand .cds--icon-chevron--down{transform:rotate(180deg);transition:transform .3s}.cds--snippet--light,.cds--snippet--light .cds--btn.cds--snippet-btn--expand,.cds--snippet--light .cds--copy-btn,.cds--snippet--light .cds--snippet-button{background-color:var(--cds-layer)}.cds--snippet--light .cds--btn.cds--snippet-btn--expand:hover,.cds--snippet--light .cds--copy-btn:hover,.cds--snippet--light .cds--snippet-button:hover,.cds--snippet--light.cds--snippet--inline:hover{background-color:var(--cds-layer-hover)}.cds--snippet--light .cds--btn.cds--snippet-btn--expand:active,.cds--snippet--light .cds--copy-btn:active,.cds--snippet--light .cds--snippet-button:active,.cds--snippet--light.cds--snippet--inline:active{background-color:var(--cds-layer-active)}.cds--snippet--light.cds--snippet--multi:after,.cds--snippet--light.cds--snippet--single:after{background-image:linear-gradient(to right,rgba(var(--cds-layer),0),var(--cds-layer))}.cds--snippet.cds--skeleton .cds--snippet-container{block-size:100%;inline-size:100%}.cds--snippet-button .cds--btn--copy__feedback{inset-block-start:3.175rem;inset-inline:50% auto}.cds--snippet-button .cds--btn--copy__feedback:before{inset-block-start:0}.cds--snippet-button .cds--btn--copy__feedback:after{inset-block-start:-.25rem}.cds--snippet--multi .cds--snippet-button .cds--btn--copy__feedback{inset-block-start:2.675rem}.cds--snippet--inline .cds--btn--copy__feedback{inset-block-start:calc(100% - .25rem);inset-inline:50% auto}.cds--snippet__overflow-indicator--left,.cds--snippet__overflow-indicator--right{flex:1 0 auto;inline-size:1rem;z-index:1}.cds--snippet__overflow-indicator--left{background-image:linear-gradient(to left,transparent,var(--cds-layer));margin-inline-end:-1rem;order:0}.cds--snippet__overflow-indicator--right{margin-inline-start:-1rem;order:2}.cds--snippet__overflow-indicator--right,[dir=rtl] .cds--snippet__overflow-indicator--left{background-image:linear-gradient(to right,transparent,var(--cds-layer))}[dir=rtl] .cds--snippet__overflow-indicator--right{background-image:linear-gradient(to left,transparent,var(--cds-layer))}.cds--snippet--single .cds--snippet__overflow-indicator--left,.cds--snippet--single .cds--snippet__overflow-indicator--right{block-size:calc(100% - .25rem);inline-size:2rem;position:absolute}.cds--snippet--single .cds--snippet__overflow-indicator--right{inset-inline-end:2.5rem}.cds--snippet--single.cds--snippet--no-copy .cds--snippet__overflow-indicator--right{inset-inline-end:0}.cds--snippet--single .cds--snippet-container:focus~.cds--snippet__overflow-indicator--right{inset-inline-end:2.625rem}.cds--snippet--single .cds--snippet-container:focus+.cds--snippet__overflow-indicator--left{inset-inline-start:.125rem}.cds--snippet--light .cds--snippet__overflow-indicator--left{background-image:linear-gradient(to left,transparent,var(--cds-layer))}.cds--snippet--light .cds--snippet__overflow-indicator--right{background-image:linear-gradient(to right,transparent,var(--cds-layer))}@media not all and (min-resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){.cds--snippet__overflow-indicator--left{background-image:linear-gradient(to left,rgba(var(--cds-layer),0),var(--cds-layer))}.cds--snippet__overflow-indicator--right{background-image:linear-gradient(to right,rgba(var(--cds-layer),0),var(--cds-layer))}}}.cds--snippet--multi.cds--skeleton{block-size:6.125rem}.cds--snippet--single.cds--skeleton{block-size:3.5rem}.cds--snippet.cds--skeleton span{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;display:block;inline-size:100%;margin-block-start:.5rem;padding:0;pointer-events:none;position:relative}.cds--snippet.cds--skeleton span:active,.cds--snippet.cds--skeleton span:focus,.cds--snippet.cds--skeleton span:hover{border:none;cursor:default;outline:none}.cds--snippet.cds--skeleton span:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--snippet.cds--skeleton span:before{animation:none}}.cds--snippet.cds--skeleton span:first-child{margin:0}.cds--snippet.cds--skeleton span:nth-child(2){inline-size:85%}.cds--snippet.cds--skeleton span:nth-child(3){inline-size:95%}.cds--snippet--single.cds--skeleton .cds--snippet-container{padding-block-end:0}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--snippet__icon{fill:ButtonText}.cds--snippet--inline:focus{color:Highlight;outline:1px solid Highlight}.cds--snippet--multi,.cds--snippet--single{outline:1px solid transparent}}:host(cds-copy-button){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;display:inline-flex;outline:none}.cds--snippet__icon{block-size:1rem;fill:var(--cds-icon-primary,#161616);inline-size:1rem;transition:all 70ms cubic-bezier(.2,0,.38,.9)}.cds--copy-btn--animating.cds--copy-btn--fade-out{animation:hide-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--copy-btn--animating.cds--copy-btn--fade-in{animation:show-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--snippet--disabled,.cds--snippet--disabled .cds--btn.cds--snippet-btn--expand{background-color:var(--cds-layer)!important;color:var(--cds-text-disabled,hsla(0,0%,9%,.25))!important}.cds--snippet--disabled .cds--btn.cds--snippet-btn--expand ::slotted([slot=icon]),.cds--snippet--disabled ::slotted([slot=icon]){fill:var(--cds-text-disabled,hsla(0,0%,9%,.25))!important}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iHWQT":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSCopy$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _copyButtonScssJs = require("../copy-button/copy-button.scss.js");
var _copyButtonScssJsDefault = parcelHelpers.interopDefault(_copyButtonScssJs);
var _iconButtonJs = require("../icon-button/icon-button.js");
var _iconButtonJsDefault = parcelHelpers.interopDefault(_iconButtonJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Copy.
 *
 * @element cds-copy
 */ let CDSCopy = class CDSCopy extends (0, _iconButtonJsDefault.default) {
    constructor(){
        super(...arguments);
        /**
         * `true` to show the feedback tooltip.
         */ this._showFeedback = false;
        /**
         * `true` to show the feedback tooltip.
         */ this._animation = "";
        this._createHandleFeedbackTooltip = ()=>{
            let timeoutId;
            return (timeout)=>{
                var _a, _b;
                const buttonClasses = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("button")) === null || _b === void 0 ? void 0 : _b.classList;
                if (timeoutId) {
                    clearTimeout(timeoutId);
                    timeoutId = undefined;
                }
                this._showFeedback = true;
                buttonClasses === null || buttonClasses === void 0 || buttonClasses.add(`${(0, _settingsJs.prefix)}--copy-btn--animating`);
                this._animation = "fade-in";
                buttonClasses === null || buttonClasses === void 0 || buttonClasses.add(`${(0, _settingsJs.prefix)}--copy-btn--${this._animation}`);
                this.requestUpdate();
                timeoutId = setTimeout(()=>{
                    this._showFeedback = false;
                    this._animation = "fade-out";
                    buttonClasses === null || buttonClasses === void 0 || buttonClasses.remove(`${(0, _settingsJs.prefix)}--copy-btn--fade-in`);
                    buttonClasses === null || buttonClasses === void 0 || buttonClasses.add(`${(0, _settingsJs.prefix)}--copy-btn--${this._animation}`);
                    this.requestUpdate();
                }, timeout);
            };
        };
        /**
         * Handles showing/hiding the feedback tooltip.
         */ this._handleFeedbackTooltip = this._createHandleFeedbackTooltip();
        /**
         * Specify the string that is displayed when the button is clicked and the content is copi
         */ this.feedback = "Copied!";
        /**
         * The number in milliseconds to determine how long the tooltip should remain.
         */ this.feedbackTimeout = 2000;
    }
    /**
     * Handles `click` event on the copy button.
     */ _handleClickButton() {
        this._handleFeedbackTooltip(this.feedbackTimeout);
    }
    // eslint-disable-next-line class-methods-use-this
    _renderTooltipContent() {
        return (0, _lit.html)`
      <cds-tooltip-content>
        ${this._showFeedback ? this.feedback : (0, _lit.html)`<slot name="tooltip-content"></slot>`}
      </cds-tooltip-content>
    `;
    }
    connectedCallback() {
        this.closeOnActivation = false;
        this.align = "bottom";
        this.addEventListener("click", this._handleClickButton);
        super.connectedCallback();
    }
    updated(changedProperties) {
        var _a, _b, _c, _d, _e;
        (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("button")) === null || _b === void 0 || _b.addEventListener("animationend", ()=>{
            var _a, _b;
            if (this._animation === "fade-out") {
                const buttonClasses = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("button")) === null || _b === void 0 ? void 0 : _b.classList;
                buttonClasses === null || buttonClasses === void 0 || buttonClasses.remove(`${(0, _settingsJs.prefix)}--copy-btn--animating`);
                buttonClasses === null || buttonClasses === void 0 || buttonClasses.remove(`${(0, _settingsJs.prefix)}--copy-btn--${this._animation}`);
                this._animation = "";
            }
        });
        super.updated(changedProperties);
        (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("button") // @ts-ignore: TS thinks `host` doesn't exist on `parentNode`
        ) === null || _d === void 0 || _d.setAttribute("aria-label", (_e = this.parentNode) === null || _e === void 0 ? void 0 : _e.host.textContent);
    }
};
CDSCopy.styles = (0, _copyButtonScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSCopy.prototype, "feedback", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        attribute: "feedback-timeout"
    })
], CDSCopy.prototype, "feedbackTimeout", void 0);
CDSCopy = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-copy`)
], CDSCopy);
var CDSCopy$1 = CDSCopy;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../copy-button/copy-button.scss.js":"eREad","../icon-button/icon-button.js":"8LTa1","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8LTa1":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ICON_BUTTON_SIZE", ()=>(0, _defsJs.ICON_BUTTON_SIZE));
parcelHelpers.export(exports, "ICON_BUTTON_TOOLTIP_ALIGNMENT", ()=>(0, _defsJs.ICON_BUTTON_TOOLTIP_ALIGNMENT));
parcelHelpers.export(exports, "default", ()=>CDSIconButton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _settingsJs = require("../../globals/settings.js");
var _tooltipJs = require("../tooltip/tooltip.js");
var _tooltipContentJs = require("../tooltip/tooltip-content.js");
var _buttonJs = require("../button/button.js");
var _buttonJsDefault = parcelHelpers.interopDefault(_buttonJs);
var _buttonSetJs = require("../button/button-set.js");
var _buttonSkeletonJs = require("../button/button-skeleton.js");
var _defsJs = require("./defs.js");
var _iconButtonScssJs = require("./icon-button.scss.js");
var _iconButtonScssJsDefault = parcelHelpers.interopDefault(_iconButtonScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Icon Button
 *
 */ let CDSIconButton = class CDSIconButton extends (0, _buttonJsDefault.default) {
    constructor(){
        super(...arguments);
        /**
         * Specify how the trigger should align with the tooltip
         */ this.align = "top";
        /**
         * Specify whether a auto align functionality should be applied
         */ this.autoalign = false;
        /**
         * Determines whether the tooltip should close when inner content is activated (click, Enter or Space)
         */ this.closeOnActivation = true;
        /**
         * Specify whether the tooltip should be open when it first renders
         */ this.defaultOpen = false;
        /**
         * Specify the duration in milliseconds to delay before displaying the tooltip
         */ this.enterDelayMs = 100;
        /**
         * Specify the duration in milliseconds to delay before hiding the tooltip
         */ this.leaveDelayMs = 300;
        /**
         * Specify the size of the Button. Defaults to `md`.
         */ this.size = "md";
    }
    updated(changedProperties) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (changedProperties) {
            (_d = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`${(0, _settingsJs.prefix)}-tooltip`)) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(`.${(0, _settingsJs.prefix)}--tooltip`)) === null || _d === void 0 || _d.classList.add(`${(0, _settingsJs.prefix)}--icon-tooltip`);
            const tooltipContent = (_e = this.querySelector("[slot=tooltip-content]")) === null || _e === void 0 ? void 0 : _e.textContent;
            (_h = (_g = (_f = this.shadowRoot) === null || _f === void 0 ? void 0 : _f.querySelector(`${(0, _settingsJs.prefix)}-tooltip`)) === null || _g === void 0 ? void 0 : _g.querySelector(`button`)) === null || _h === void 0 || _h.setAttribute("aria-label", String(tooltipContent));
        }
    }
    // eslint-disable-next-line class-methods-use-this
    _renderTooltipContent() {
        return (0, _lit.html)`
      <cds-tooltip-content>
        <slot name="tooltip-content"></slot>
      </cds-tooltip-content>
    `;
    }
    render() {
        const { align, autoalign, closeOnActivation, defaultOpen, enterDelayMs, leaveDelayMs } = this;
        return (0, _lit.html)`
      <cds-tooltip
        ?autoalign=${autoalign}
        align=${align}
        ?defaultOpen=${defaultOpen}
        close-on-activation="${closeOnActivation}"
        enter-delay-ms=${enterDelayMs}
        leave-delay-ms=${leaveDelayMs}>
        ${super.render()} ${this._renderTooltipContent()}
      </cds-tooltip>
    `;
    }
};
CDSIconButton.styles = (0, _iconButtonScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        type: String
    })
], CDSIconButton.prototype, "align", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSIconButton.prototype, "autoalign", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "close-on-activation",
        reflect: true,
        type: Boolean
    })
], CDSIconButton.prototype, "closeOnActivation", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        type: Boolean
    })
], CDSIconButton.prototype, "defaultOpen", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "enter-delay-ms",
        type: Number
    })
], CDSIconButton.prototype, "enterDelayMs", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "leave-delay-ms",
        type: Number
    })
], CDSIconButton.prototype, "leaveDelayMs", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSIconButton.prototype, "size", void 0);
CDSIconButton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-icon-button`)
], CDSIconButton);
var CDSIconButton$1 = CDSIconButton;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/settings.js":"EipuL","../tooltip/tooltip.js":"5I2D5","../tooltip/tooltip-content.js":"lAmrJ","../button/button.js":"ca52G","../button/button-set.js":"fcMCT","../button/button-skeleton.js":"cfoNU","./defs.js":"66VUf","./icon-button.scss.js":"jMs7p","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5I2D5":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTooltip$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _popoverJs = require("../popover/popover.js");
var _popoverJsDefault = parcelHelpers.interopDefault(_popoverJs);
var _popoverContentJs = require("../popover/popover-content.js");
var _tooltipScssJs = require("./tooltip.scss.js");
var _tooltipScssJsDefault = parcelHelpers.interopDefault(_tooltipScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Trigger button of tooltip.
 *
 * @element cds-tooltip
 */ let CDSTooltip = class CDSTooltip extends (0, _hostListenerJsDefault1.default)((0, _popoverJsDefault.default)) {
    constructor(){
        super(...arguments);
        /**
         * Specify how the trigger should align with the tooltip
         */ this.align = "top";
        /**
         * Specify whether a auto align functionality should be applied
         */ this.autoalign = false;
        /**
         * `true` if this tooltip is in a data table row
         */ this.dataTable = false;
        /**
         * Specify whether the tooltip should be closed when clicked
         */ this.closeOnActivation = false;
        /**
         * Specify whether the tooltip should be open when it first renders
         */ this.defaultOpen = false;
        /**
         * Specify the duration in milliseconds to delay before displaying the tooltip
         */ this.enterDelayMs = 100;
        /**
         * Specify the duration in milliseconds to delay before hiding the tooltip
         */ this.leaveDelayMs = 300;
        /**
         * Specify the size of the tooltip
         */ this.size = false;
        /**
         * Specify the timeout reference for the tooltip
         */ this.timeoutId = 0;
        /**
         * Specify whether the tooltip should be open when it first renders
         */ this.toolbarAction = false;
        /**
         * Handles `mouseover` event on this element.
         */ this._handleHover = async ()=>{
            window.clearTimeout(this.timeoutId);
            this.timeoutId = window.setTimeout(async ()=>{
                var _a;
                this.open = true;
                const { open, updateComplete } = this;
                if (open) {
                    await updateComplete;
                    const { selectorTooltipContent } = this.constructor;
                    (_a = this.querySelector(selectorTooltipContent)) === null || _a === void 0 || _a.focus();
                }
            }, this.enterDelayMs);
        };
        /**
         * Handles `mouseleave` event on this element.
         */ this._handleHoverOut = async ()=>{
            window.clearTimeout(this.timeoutId);
            this.timeoutId = window.setTimeout(async ()=>{
                const { open } = this;
                if (open) this.open = false;
            }, this.leaveDelayMs);
        };
        /**
         * Handles `click` event on this element.
         */ this._handleClick = async ()=>{
            if (this.closeOnActivation) this._handleHoverOut();
        };
        /**
         * Handles `keydown` event on this element.
         */ this._handleKeydown = async (event)=>{
            if (event.key === " " || event.key === "Enter" || event.key === "Escape") this._handleHoverOut();
        };
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const component = target.assignedNodes().filter((node)=>node.nodeType !== Node.TEXT_NODE || node.textContent.trim());
        if (!component[0]) return;
        component[0].addEventListener("focus", this._handleHover);
        component[0].addEventListener("focusout", this._handleHoverOut);
        component[0].addEventListener("mouseover", this._handleHover);
        component[0].addEventListener("mouseleave", this._handleHoverOut);
        this.requestUpdate();
    }
    connectedCallback() {
        if (!this.hasAttribute("highContrast")) this.setAttribute("highContrast", "");
        if (!this.shadowRoot) this.attachShadow({
            mode: "open"
        });
        super.connectedCallback();
    }
    updated(changedProperties) {
        var _a, _b;
        const { selectorTooltipContent } = this.constructor;
        const toolTipContent = this.querySelector(selectorTooltipContent);
        if (changedProperties.has("defaultOpen")) this.open = this.defaultOpen;
        if (changedProperties.has("open")) this.open ? toolTipContent === null || toolTipContent === void 0 || toolTipContent.setAttribute("open", "") : toolTipContent === null || toolTipContent === void 0 || toolTipContent.removeAttribute("open");
        [
            "align",
            "caret",
            "autoalign"
        ].forEach((name)=>{
            if (changedProperties.has(name)) {
                const { [name]: value } = this;
                toolTipContent[name] = value;
            }
        });
        (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.${(0, _settingsJs.prefix)}--popover-container`)) === null || _b === void 0 || _b.classList.add(`${(0, _settingsJs.prefix)}--tooltip`);
        super.updated(changedProperties);
    }
    /**
     * A selector that will return the CDSTooltipContent.
     */ static get selectorTooltipContent() {
        return `${0, _settingsJs.prefix}-tooltip-content`;
    }
    static get styles() {
        return (0, _lit.css)`
      ${super.styles}${0, _tooltipScssJsDefault.default}
    `;
    }
};
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        type: String
    })
], CDSTooltip.prototype, "align", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTooltip.prototype, "autoalign", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "data-table"
    })
], CDSTooltip.prototype, "dataTable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        type: Boolean
    })
], CDSTooltip.prototype, "closeOnActivation", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        type: Boolean
    })
], CDSTooltip.prototype, "defaultOpen", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "enter-delay-ms",
        type: Number
    })
], CDSTooltip.prototype, "enterDelayMs", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "leave-delay-ms",
        type: Number
    })
], CDSTooltip.prototype, "leaveDelayMs", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTooltip.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTooltip.prototype, "timeoutId", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "toolbar-action",
        type: Boolean
    })
], CDSTooltip.prototype, "toolbarAction", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("click")
], CDSTooltip.prototype, "_handleClick", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("click")
], CDSTooltip.prototype, "_handleKeydown", void 0);
CDSTooltip = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-tooltip`)
], CDSTooltip);
var CDSTooltip$1 = CDSTooltip;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/host-listener.js":"1SMUX","../popover/popover.js":"tOPYr","../popover/popover-content.js":"7MhEU","./tooltip.scss.js":"fcNWZ","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"tOPYr":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSPopover$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _settingsJs = require("../../globals/settings.js");
var _popoverScssJs = require("./popover.scss.js");
var _popoverScssJsDefault = parcelHelpers.interopDefault(_popoverScssJs);
var _popoverControllerJs = require("../../globals/controllers/popover-controller.js");
var _popoverControllerJsDefault = parcelHelpers.interopDefault(_popoverControllerJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var CDSPopover_1;
/**
 * Popover.
 *
 * @element cds-popover
 */ let CDSPopover = CDSPopover_1 = class CDSPopover extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Create popover controller instance
         */ this.popoverController = new (0, _popoverControllerJsDefault.default)(this);
        /**
         * Specify direction of alignment
         */ this.align = "";
        /**
         * Specify whether a auto align functionality should be applied
         */ this.autoalign = false;
        /**
         * Specify whether a caret should be rendered
         */ this.caret = true;
        /**
         * Specify whether a dropShadow should be rendered
         */ this.dropShadow = true;
        /**
         * Render the component using the high-contrast variant
         */ this.highContrast = false;
        /**
         * Specify whether the component is currently open or closed
         */ this.open = false;
        /**
         * Render the component using the tab tip variant
         */ this.tabTip = false;
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        if (this.tabTip) {
            const component = target.assignedNodes().filter((node)=>node.nodeType !== Node.TEXT_NODE || node.textContent.trim());
            component[0].classList.add(`${(0, _settingsJs.prefix)}--popover--tab-tip__button`);
        }
        this.requestUpdate();
    }
    updated(changedProperties) {
        var _a, _b, _c;
        const { selectorPopoverContent } = this.constructor;
        [
            "open",
            "align",
            "autoalign",
            "caret",
            "dropShadow",
            "tabTip"
        ].forEach((name)=>{
            if (changedProperties.has(name)) {
                const { [name]: value } = this;
                if (this.querySelector(selectorPopoverContent)) this.querySelector(selectorPopoverContent)[name] = value;
            }
        });
        if (this.autoalign && this.open) {
            // auto align functionality with @floating-ui/dom library
            const button = this._triggerSlotNode.assignedElements()[0];
            const content = this._contentSlotNode.assignedElements()[0];
            const tooltip = (_a = content === null || content === void 0 ? void 0 : content.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(CDSPopover_1.selectorPopoverContentClass);
            const arrowElement = (_b = content === null || content === void 0 ? void 0 : content.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(CDSPopover_1.selectorPopoverCaret);
            if (button && tooltip) (_c = this.popoverController) === null || _c === void 0 || _c.setPlacement({
                trigger: button,
                target: tooltip,
                arrowElement: this.caret && arrowElement ? arrowElement : undefined,
                caret: this.caret,
                flip: true,
                alignment: this.align
            });
        }
    }
    render() {
        const { dropShadow, highContrast, open, tabTip, _handleSlotChange: handleSlotChange } = this;
        if (tabTip) this.caret = tabTip ? false : true;
        this.align = this.align ? this.align : tabTip ? "bottom-left" : "bottom";
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--popover-container`]: true,
            [`${0, _settingsJs.prefix}--popover--caret`]: this.caret,
            [`${0, _settingsJs.prefix}--popover--drop-shadow`]: dropShadow,
            [`${0, _settingsJs.prefix}--popover--high-contrast`]: highContrast,
            [`${0, _settingsJs.prefix}--popover--open`]: open,
            [`${0, _settingsJs.prefix}--popover--${this.align}`]: true,
            [`${0, _settingsJs.prefix}--popover--tab-tip`]: tabTip
        });
        return (0, _lit.html)`
    <span class="${classes}">
      <slot @slotchange="${handleSlotChange}"></slot>
      <slot name="content"><slot>
    </span>
    `;
    }
    /**
     * A selector that will return popover content element within
     * CDSPopoverContent's shadowRoot.
     */ static get selectorPopoverContentClass() {
        return `.${0, _settingsJs.prefix}--popover-content`;
    }
    /**
     * A selector that will return popover caret element within
     * CDSPopoverContent's shadowRoot.
     */ static get selectorPopoverCaret() {
        return `.${0, _settingsJs.prefix}--popover-caret`;
    }
    /**
     * A selector that will return the CDSPopoverContent.
     */ static get selectorPopoverContent() {
        return `${0, _settingsJs.prefix}-popover-content`;
    }
};
CDSPopover.styles = (0, _popoverScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("slot")
], CDSPopover.prototype, "_triggerSlotNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)('slot[name="content"]')
], CDSPopover.prototype, "_contentSlotNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        type: String
    })
], CDSPopover.prototype, "align", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSPopover.prototype, "autoalign", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSPopover.prototype, "caret", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSPopover.prototype, "dropShadow", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSPopover.prototype, "highContrast", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSPopover.prototype, "open", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSPopover.prototype, "tabTip", void 0);
CDSPopover = CDSPopover_1 = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-popover`)
], CDSPopover);
var CDSPopover$1 = CDSPopover;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/settings.js":"EipuL","./popover.scss.js":"8k9gp","../../globals/controllers/popover-controller.js":"eaPRH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8k9gp":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover,.cds--popover--high-contrast :host(cds-popover-content),.cds--popover--high-contrast :host(cds-tooltip-content),:host(cds-popover[highContrast]) .cds--popover--high-contrast ::slotted(cds-popover-content),:host(cds-popover[highContrast]) .cds--popover--high-contrast ::slotted(cds-tooltip-content),:host(cds-tooltip[highContrast]) .cds--popover--high-contrast ::slotted(cds-popover-content),:host(cds-tooltip[highContrast]) .cds--popover--high-contrast ::slotted(cds-tooltip-content){--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content,.cds--popover--drop-shadow :host(cds-popover-content)>.cds--popover-content,.cds--popover--drop-shadow :host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--drop-shadow ::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--drop-shadow ::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--drop-shadow ::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--drop-shadow ::slotted(cds-tooltip-content)>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover,:host(cds-popover-content),:host(cds-popover[highContrast]) ::slotted(cds-popover-content),:host(cds-popover[highContrast]) ::slotted(cds-tooltip-content),:host(cds-tooltip-content),:host(cds-tooltip[highContrast]) ::slotted(cds-popover-content),:host(cds-tooltip[highContrast]) ::slotted(cds-tooltip-content){filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content,.cds--popover--open>:host(cds-popover-content)>.cds--popover-content,.cds--popover--open>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before,.cds--popover--open>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--open>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret,.cds--popover--caret.cds--popover--open>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--caret.cds--popover--open>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--caret.cds--popover--open>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--caret.cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--caret.cds--popover--open>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--caret.cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-caret{display:block}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--auto-align.cds--popover--caret.cds--popover--open>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--auto-align.cds--popover--caret.cds--popover--open>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--auto-align.cds--popover--caret.cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--auto-align.cds--popover--caret.cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--auto-align.cds--popover--caret.cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--auto-align.cds--popover--caret.cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret,.cds--popover--tab-tip>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--tab-tip>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--tab-tip>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--tab-tip>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--tab-tip>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--tab-tip>::slotted(cds-tooltip-content)>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-end>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom-end>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom-left>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom-right>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom-start>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-end>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom-end>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom-left>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom-right>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom-start>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret,.cds--popover--bottom>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-end>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-end>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>:host(cds-tooltip-content)>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-end.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-end.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-end>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top-end>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top-left>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top-right>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top-start>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before,.cds--popover--top>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top>::slotted(cds-tooltip-content)>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-end>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top-end>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-left>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top-left>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-right>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top-right>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top-start>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top-start>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret,.cds--popover--top>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top>::slotted(cds-tooltip-content)>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-end.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-end.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-bottom>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right-bottom>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right-end>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right-start>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right-top>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before,.cds--popover--right>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right>::slotted(cds-tooltip-content)>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-bottom.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-bottom.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-bottom>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left-bottom>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left-end>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left-start>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left-top>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before,.cds--popover--left>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left>::slotted(cds-tooltip-content)>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-bottom.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-bottom.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content,.cds--popover--tab-tip>:host(cds-popover-content)>.cds--popover-content,.cds--popover--tab-tip>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--tab-tip>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--tab-tip>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--tab-tip>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--tab-tip>::slotted(cds-tooltip-content)>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover,.cds--popover--tab-tip :host(cds-popover-content),.cds--popover--tab-tip :host(cds-tooltip-content),:host(cds-popover[highContrast]) .cds--popover--tab-tip ::slotted(cds-popover-content),:host(cds-popover[highContrast]) .cds--popover--tab-tip ::slotted(cds-tooltip-content),:host(cds-tooltip[highContrast]) .cds--popover--tab-tip ::slotted(cds-popover-content),:host(cds-tooltip[highContrast]) .cds--popover--tab-tip ::slotted(cds-tooltip-content){will-change:filter}.cds--popover--tab-tip__button,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button){align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button) *,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button) :after,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button) :before,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button) *,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button) :after,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button) :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus,:host(cds-popover) :focus::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) :focus::slotted(.cds--popover--tab-tip__button){outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus,:host(cds-popover) :focus::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) :focus::slotted(.cds--popover--tab-tip__button){outline-style:dotted}}.cds--popover--tab-tip__button:hover,:host(cds-popover) :hover::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) :hover::slotted(.cds--popover--tab-tip__button){background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button,:host(cds-popover) .cds--popover--tab-tip.cds--popover--open ::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) .cds--popover--tab-tip.cds--popover--open ::slotted(.cds--popover--tab-tip__button){background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button) svg,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button) svg{fill:var(--cds-icon-primary,#161616)}:host(cds-popover[tabTip][open]) ::slotted(.cds--popover--tab-tip__button,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button),:host(cds-popover) ::slotted(.cds--popover--tab-tip__button)){background:var(--cds-layer)!important;box-shadow:0 .125rem .125rem rgba(0,0,0,.2)}:host(cds-ai-label[open]) .cds--popover-content,:host(cds-popover-content[open]) .cds--popover-content,:host(cds-slug[open]) .cds--popover-content,:host(cds-toggletip[open]) .cds--popover-content,:host(cds-tooltip-content[open]) .cds--popover-content{display:block}:host(cds-popover-content[open][tabTip]) .cds--popover-content,:host(cds-tooltip-content[open][tabTip]) .cds--popover-content{background:var(--cds-layer);border-radius:0}:host(cds-ai-label[open]) .cds--popover-caret,:host(cds-popover-content[open][caret]) .cds--popover-caret,:host(cds-slug[open]) .cds--popover-caret,:host(cds-toggletip[open]) .cds--popover-caret,:host(cds-tooltip-content[open][caret]) .cds--popover-caret{display:block}:host(cds-popover-content[dropShadow]){--cds-popover-drop-shadow:drop-shadow(0 0.125rem 0.125rem rgba(0,0,0,.2))}:host(cds-ai-label[alignment^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-popover-content[align^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-toggletip[alignment^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-tooltip-content[align^=bottom]:not([autoalign])) .cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}:host(cds-ai-label[alignment^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=bottom]:not([autoalign])) .cds--popover-caret{clip-path:none}:host(cds-ai-label[alignment=bottom]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=bottom]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=bottom]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=bottom]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=bottom]:not([autoalign])) .cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment=bottom-left]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=bottom-left]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=bottom-left]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=bottom-left]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=bottom-left]:not([autoalign])) .cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment=bottom-right]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=bottom-right]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=bottom-right]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=bottom-right]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=bottom-right]:not([autoalign])) .cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment^=left]:not([autoalign])) .cds--popover-caret,:host(cds-popover-content[align^=left]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=left]:not([autoalign])) .cds--popover-caret,:host(cds-toggletip[alignment^=left]:not([autoalign])) .cds--popover-caret,:host(cds-tooltip-content[align^=left]:not([autoalign])) .cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}:host(cds-ai-label[alignment=left]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=left]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=left]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=left]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=left]:not([autoalign])) .cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}:host(cds-ai-label[alignment=left-bottom]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=left-bottom]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=left-bottom]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=left-bottom]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=left-bottom]:not([autoalign])) .cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 1rem))}:host(cds-ai-label[alignment=left-top]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=left-top]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=left-top]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=left-top]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=left-top]:not([autoalign])) .cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 1rem))}:host(cds-ai-label[alignment^=right]:not([autoalign])) .cds--popover-caret,:host(cds-popover-content[align^=right]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=right]:not([autoalign])) .cds--popover-caret,:host(cds-toggletip[alignment^=right]:not([autoalign])) .cds--popover-caret,:host(cds-tooltip-content[align^=right]:not([autoalign])) .cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}:host(cds-ai-label[alignment=right]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=right]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=right]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=right]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=right]:not([autoalign])) .cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}:host(cds-ai-label[alignment=right-bottom]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=right-bottom]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=right-bottom]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=right-bottom]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=right-bottom]:not([autoalign])) .cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}:host(cds-ai-label[alignment=right-top]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=right-top]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=right-top]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=right-top]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=right-top]:not([autoalign])) .cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}:host(cds-ai-label[alignment^=top]:not([autoalign])) .cds--popover-caret,:host(cds-popover-content[align^=top]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=top]:not([autoalign])) .cds--popover-caret,:host(cds-toggletip[alignment^=top]:not([autoalign])) .cds--popover-caret,:host(cds-tooltip-content[align^=top]:not([autoalign])) .cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}:host(cds-ai-label[alignment=top]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=top]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=top]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=top]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=top]:not([autoalign])) .cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment=top-left]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=top-left]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=top-left]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=top-left]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=top-left]:not([autoalign])) .cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment=top-right]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=top-right]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=top-right]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=top-right]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=top-right]:not([autoalign])) .cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-popover-content[autoalign]) .cds--popover-caret,:host(cds-toggletip[autoalign]) .cds--popover-caret,:host(cds-tooltip-content[autoalign]) .cds--popover-caret{block-size:8px;inline-size:8px;transform:rotate(45deg)}:host(cds-ai-label[autoalign]) .cds--popover-container,:host(cds-popover[autoalign]) .cds--popover-container,:host(cds-slug[autoalign]) .cds--popover-container,:host(cds-toggletip[autoalign]) .cds--popover-container,:host(cds-tooltip[autoalign]) .cds--popover-container{position:static}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eaPRH":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PopoverController);
var _dom = require("@floating-ui/dom");
/**
 * @license
 *
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ class PopoverController {
    /**
     * register with host component
     * @param host host component
     */ constructor(host){
        this.updatePlacement = ()=>{
            this.computePlacement();
        };
        (this.host = host).addController(this);
    }
    async setPlacement(options = this.options) {
        this.options = options;
        const { trigger, target } = options;
        this.cleanup = (0, _dom.autoUpdate)(trigger, target, this.updatePlacement);
    }
    async computePlacement() {
        var _a;
        const { arrowElement, alignment, caret, trigger, target } = this.options;
        let shimmedAlign;
        switch(alignment){
            case "top-left":
                shimmedAlign = "top-start";
                break;
            case "top-right":
                shimmedAlign = "top-end";
                break;
            case "bottom-left":
                shimmedAlign = "bottom-start";
                break;
            case "bottom-right":
                shimmedAlign = "bottom-end";
                break;
            case "left-bottom":
                shimmedAlign = "left-end";
                break;
            case "left-top":
                shimmedAlign = "left-start";
                break;
            case "right-bottom":
                shimmedAlign = "right-end";
                break;
            case "right-top":
                shimmedAlign = "right-start";
                break;
            default:
                shimmedAlign = alignment;
                break;
        }
        const middleware = [
            (0, _dom.flip)({
                fallbackAxisSideDirection: "start"
            }),
            (0, _dom.offset)(caret ? 10 : 0),
            ...caret && arrowElement ? [
                (0, _dom.arrow)({
                    element: arrowElement,
                    padding: 15
                })
            ] : []
        ];
        if (this.host.hasAttribute("open")) {
            const { x, y, placement, middlewareData, strategy } = await (0, _dom.computePosition)(trigger, target, {
                strategy: "fixed",
                middleware,
                placement: shimmedAlign
            });
            target.style.left = `${x}px`;
            target.style.top = `${y}px`;
            target.style.position = `${strategy}`;
            if (arrowElement) {
                // @ts-ignore
                const { x: arrowX, y: arrowY } = middlewareData.arrow;
                const staticSide = {
                    top: "bottom",
                    right: "left",
                    bottom: "top",
                    left: "right"
                }[placement.split("-")[0]];
                arrowElement.style.left = arrowX != null ? `${arrowX}px` : "";
                arrowElement.style.top = arrowY != null ? `${arrowY}px` : "";
                arrowElement.style.right = "";
                arrowElement.style.bottom = "";
                arrowElement.style[staticSide] = `${-arrowElement.offsetWidth / 2}px`;
            }
            // adding specific case here where the style of the caret/arrow
            // is dependent on the placement
            // TODO: remove reference to slug in v12
            if (this.host.tagName === "CDS-AI-LABEL" || this.host.tagName === "CDS-SLUG") (_a = this.host) === null || _a === void 0 || _a.setAttribute("alignment", placement);
        }
    }
    hostUpdated() {
        var _a;
        if (!this.host.hasAttribute("open")) {
            (_a = this.cleanup) === null || _a === void 0 || _a.call(this);
            this.cleanup = undefined;
        }
    }
    hostDisconnected() {
        var _a;
        (_a = this.cleanup) === null || _a === void 0 || _a.call(this);
        this.cleanup = undefined;
    }
}

},{"@floating-ui/dom":"dovGh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dovGh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "autoUpdate", ()=>autoUpdate);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "platform", ()=>platform);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    const css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, _dom.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
const noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    const win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, _dom.getWindow)(domElement);
        const offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, _dom.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
const topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function isTopLayer(element) {
    return topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements, rect, offsetParent, strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const topLayer = elements ? isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, _utils.createCoords)(1);
    const offsets = (0, _utils.createCoords)(0);
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== "body" || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if ((0, _dom.isHTMLElement)(offsetParent)) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + (0, _dom.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    const html = (0, _dom.getDocumentElement)(element);
    const scroll = (0, _dom.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === "rtl") x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
function getViewportRect(element, strategy) {
    const win = (0, _dom.getWindow)(element);
    const html = (0, _dom.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width,
        height,
        x,
        y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, _dom.getOverflowAncestors)(element, [], false).filter((el)=>(0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, _dom.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, _dom.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, _utils.max)(rect.top, accRect.top);
        accRect.right = (0, _utils.min)(rect.right, accRect.right);
        accRect.bottom = (0, _utils.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _utils.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    const { width, height } = getCssDimensions(element);
    return {
        width,
        height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, _utils.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== "body" || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x,
        y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const win = (0, _dom.getWindow)(element);
    if (isTopLayer(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        let svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
const getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === "rtl";
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left, top, width, height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, _utils.floor)(top);
        const insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, _utils.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === "function", layoutShift = typeof IntersectionObserver === "function", animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : [],
        ...(0, _dom.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, _core.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

},{"@floating-ui/core":"cwfEo","@floating-ui/utils":"hEn7B","@floating-ui/utils/dom":"9OhEP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cwfEo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", ()=>(0, _utils.rectToClientRect));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = (0, _utils.getSideAxis)(placement);
    const alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    const alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    const side = (0, _utils.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition = async (reference, floating, config)=>{
    const { placement = "bottom", strategy = "absolute", middleware = [], platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference,
        floating,
        strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name, fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data, reset } = await fn({
            x,
            y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy,
            middlewareData,
            rects,
            platform,
            elements: {
                reference,
                floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference,
                    floating,
                    strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x,
        y,
        placement: statefulPlacement,
        strategy,
        middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = "clippingAncestors", rootBoundary = "viewport", elementContext = "floating", altBoundary = false, padding = 0 } = (0, _utils.evaluate)(options, state);
    const paddingObject = (0, _utils.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, _utils.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary,
        rootBoundary,
        strategy
    }));
    const rect = elementContext === "floating" ? {
        x,
        y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, _utils.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements,
        rect,
        offsetParent,
        strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>({
        name: "arrow",
        options,
        async fn (state) {
            const { x, y, placement, rects, platform, elements, middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element, padding = 0 } = (0, _utils.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            const coords = {
                x,
                y
            };
            const axis = (0, _utils.getAlignmentAxis)(placement);
            const length = (0, _utils.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, _utils.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, _utils.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const { crossAxis = false, alignment, allowedPlacements = (0, _utils.placements), autoAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, _utils.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, _utils.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, _utils.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = "bestFit", fallbackAxisSideDirection = "none", flipAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, _utils.getSide)(placement);
            const isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, _utils.getOppositePlacement)(initialPlacement)
            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement,
                    overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options,
        async fn (state) {
            const { rects } = state;
            const { strategy = "referenceHidden", ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function getBoundingRect(rects) {
    const minX = (0, _utils.min)(...rects.map((rect)=>rect.left));
    const minY = (0, _utils.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, _utils.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, _utils.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, _utils.rectToClientRect)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options,
        async fn (state) {
            const { placement, elements, rects, platform, strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding = 2, x, y } = (0, _utils.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = getRectsByLine(nativeClientRects);
            const fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, _utils.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, _utils.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top,
                            bottom,
                            left,
                            right,
                            width,
                            height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, _utils.getSide)(placement) === "left";
                    const maxRight = (0, _utils.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, _utils.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top,
                        bottom,
                        left,
                        right,
                        width,
                        height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect
                },
                floating: elements.floating,
                strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, _utils.getSide)(placement);
    const alignment = (0, _utils.getAlignment)(placement);
    const isVertical = (0, _utils.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, _utils.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x, y, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options,
        async fn (state) {
            const { x, y, placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x,
                        y
                    };
                }
            }, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, _utils.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = function(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            const { x, y, placement, rects, middlewareData } = state;
            const { offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, _utils.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, _utils.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options,
        async fn (state) {
            const { placement, rects, platform, elements } = state;
            const { apply = ()=>{}, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const side = (0, _utils.getSide)(placement);
            const alignment = (0, _utils.getAlignment)(placement);
            const isYAxis = (0, _utils.getSideAxis)(placement) === "y";
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) availableWidth = alignment || noShift ? (0, _utils.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            else availableHeight = alignment || noShift ? (0, _utils.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, _utils.max)(overflow.left, 0);
                const xMax = (0, _utils.max)(overflow.right, 0);
                const yMin = (0, _utils.max)(overflow.top, 0);
                const yMax = (0, _utils.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth,
                availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

},{"@floating-ui/utils":"hEn7B","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hEn7B":[function(require,module,exports) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", ()=>alignments);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "createCoords", ()=>createCoords);
parcelHelpers.export(exports, "evaluate", ()=>evaluate);
parcelHelpers.export(exports, "expandPaddingObject", ()=>expandPaddingObject);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
parcelHelpers.export(exports, "getAlignmentAxis", ()=>getAlignmentAxis);
parcelHelpers.export(exports, "getAlignmentSides", ()=>getAlignmentSides);
parcelHelpers.export(exports, "getAxisLength", ()=>getAxisLength);
parcelHelpers.export(exports, "getExpandedPlacements", ()=>getExpandedPlacements);
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", ()=>getOppositeAlignmentPlacement);
parcelHelpers.export(exports, "getOppositeAxis", ()=>getOppositeAxis);
parcelHelpers.export(exports, "getOppositeAxisPlacements", ()=>getOppositeAxisPlacements);
parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
parcelHelpers.export(exports, "getPaddingObject", ()=>getPaddingObject);
parcelHelpers.export(exports, "getSide", ()=>getSide);
parcelHelpers.export(exports, "getSideAxis", ()=>getSideAxis);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "rectToClientRect", ()=>rectToClientRect);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sides", ()=>sides);
const sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const alignments = [
    "start",
    "end"
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
    return placement.split("-")[0];
}
function getAlignment(placement) {
    return placement.split("-")[1];
}
function getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = getAlignment(placement);
    let list = getSideList(getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function getPaddingObject(padding) {
    return typeof padding !== "number" ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    const { x, y, width, height } = rect;
    return {
        width,
        height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x,
        y
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9OhEP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getContainingBlock", ()=>getContainingBlock);
parcelHelpers.export(exports, "getDocumentElement", ()=>getDocumentElement);
parcelHelpers.export(exports, "getNearestOverflowAncestor", ()=>getNearestOverflowAncestor);
parcelHelpers.export(exports, "getNodeName", ()=>getNodeName);
parcelHelpers.export(exports, "getNodeScroll", ()=>getNodeScroll);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>getOverflowAncestors);
parcelHelpers.export(exports, "getParentNode", ()=>getParentNode);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "isContainingBlock", ()=>isContainingBlock);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isLastTraversableNode", ()=>isLastTraversableNode);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isOverflowElement", ()=>isOverflowElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isTableElement", ()=>isTableElement);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes(getNodeName(element));
}
function isContainingBlock(element) {
    const webkit = isWebKit();
    const css = getComputedStyle(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function getParentNode(node) {
    if (getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7MhEU":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSPopoverContent$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _settingsJs = require("../../globals/settings.js");
var _popoverScssJs = require("./popover.scss.js");
var _popoverScssJsDefault = parcelHelpers.interopDefault(_popoverScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Popover.
 *
 * @element cds-popover
 */ let CDSPopoverContent = class CDSPopoverContent extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Specify the popover alignment
         */ this.align = "";
        /**
         * Specify whether a auto align functionality should be applied
         */ this.autoalign = false;
        /**
         * Specify whether a dropShadow should be rendered
         */ this.dropShadow = true;
        /**
         * Specify whether the component is currently open or closed
         */ this.open = false;
        /**
         * Render the component using the tab tip variant
         */ this.tabTip = false;
        /**
         * The shadow slot this popover content should be in.
         */ this.slot = "content";
    }
    render() {
        if (this.autoalign) return (0, _lit.html)`
        <span class="${0, _settingsJs.prefix}--popover-content">
          <slot> </slot>
          <span class="${0, _settingsJs.prefix}--popover-caret"></span>
        </span>
      `;
        else return (0, _lit.html)`
        <span class="${0, _settingsJs.prefix}--popover-content">
          <slot> </slot>
        </span>
        <span class="${0, _settingsJs.prefix}--popover-caret"></span>
      `;
    }
};
CDSPopoverContent.styles = (0, _popoverScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        type: String
    })
], CDSPopoverContent.prototype, "align", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSPopoverContent.prototype, "autoalign", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSPopoverContent.prototype, "caret", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSPopoverContent.prototype, "dropShadow", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSPopoverContent.prototype, "open", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSPopoverContent.prototype, "tabTip", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSPopoverContent.prototype, "slot", void 0);
CDSPopoverContent = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-popover-content`)
], CDSPopoverContent);
var CDSPopoverContent$1 = CDSPopoverContent;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/settings.js":"EipuL","./popover.scss.js":"8k9gp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fcNWZ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover,.cds--popover--high-contrast :host(cds-popover-content),.cds--popover--high-contrast :host(cds-tooltip-content),:host(cds-popover[highContrast]) .cds--popover--high-contrast ::slotted(cds-popover-content),:host(cds-popover[highContrast]) .cds--popover--high-contrast ::slotted(cds-tooltip-content),:host(cds-tooltip[highContrast]) .cds--popover--high-contrast ::slotted(cds-popover-content),:host(cds-tooltip[highContrast]) .cds--popover--high-contrast ::slotted(cds-tooltip-content){--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content,.cds--popover--drop-shadow :host(cds-popover-content)>.cds--popover-content,.cds--popover--drop-shadow :host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--drop-shadow ::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--drop-shadow ::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--drop-shadow ::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--drop-shadow ::slotted(cds-tooltip-content)>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover,:host(cds-popover-content),:host(cds-popover[highContrast]) ::slotted(cds-popover-content),:host(cds-popover[highContrast]) ::slotted(cds-tooltip-content),:host(cds-tooltip-content),:host(cds-tooltip[highContrast]) ::slotted(cds-popover-content),:host(cds-tooltip[highContrast]) ::slotted(cds-tooltip-content){filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content,.cds--popover--open>:host(cds-popover-content)>.cds--popover-content,.cds--popover--open>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before,.cds--popover--open>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--open>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret,.cds--popover--caret.cds--popover--open>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--caret.cds--popover--open>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--caret.cds--popover--open>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--caret.cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--caret.cds--popover--open>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--caret.cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-caret{display:block}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--auto-align.cds--popover--caret.cds--popover--open>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--auto-align.cds--popover--caret.cds--popover--open>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--auto-align.cds--popover--caret.cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--auto-align.cds--popover--caret.cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--auto-align.cds--popover--caret.cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--auto-align.cds--popover--caret.cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret,.cds--popover--tab-tip>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--tab-tip>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--tab-tip>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--tab-tip>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--tab-tip>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--tab-tip>::slotted(cds-tooltip-content)>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-end>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom-end>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom-left>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom-right>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom-start>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-end>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom-end>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom-left>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom-right>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom-start>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret,.cds--popover--bottom>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-end>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-end>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>:host(cds-tooltip-content)>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-end.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-end.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-end>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top-end>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top-left>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top-right>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top-start>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before,.cds--popover--top>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top>::slotted(cds-tooltip-content)>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-end>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top-end>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-left>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top-left>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-right>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top-right>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top-start>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top-start>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret,.cds--popover--top>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top>::slotted(cds-tooltip-content)>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-end.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-end.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-bottom>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right-bottom>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right-end>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right-start>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right-top>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before,.cds--popover--right>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right>::slotted(cds-tooltip-content)>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-bottom.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-bottom.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-bottom>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left-bottom>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left-end>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left-start>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left-top>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before,.cds--popover--left>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left>::slotted(cds-tooltip-content)>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-bottom.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-bottom.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content,.cds--popover--tab-tip>:host(cds-popover-content)>.cds--popover-content,.cds--popover--tab-tip>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--tab-tip>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--tab-tip>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--tab-tip>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--tab-tip>::slotted(cds-tooltip-content)>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover,.cds--popover--tab-tip :host(cds-popover-content),.cds--popover--tab-tip :host(cds-tooltip-content),:host(cds-popover[highContrast]) .cds--popover--tab-tip ::slotted(cds-popover-content),:host(cds-popover[highContrast]) .cds--popover--tab-tip ::slotted(cds-tooltip-content),:host(cds-tooltip[highContrast]) .cds--popover--tab-tip ::slotted(cds-popover-content),:host(cds-tooltip[highContrast]) .cds--popover--tab-tip ::slotted(cds-tooltip-content){will-change:filter}.cds--popover--tab-tip__button,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button){align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button) *,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button) :after,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button) :before,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button) *,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button) :after,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button) :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus,:host(cds-popover) :focus::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) :focus::slotted(.cds--popover--tab-tip__button){outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus,:host(cds-popover) :focus::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) :focus::slotted(.cds--popover--tab-tip__button){outline-style:dotted}}.cds--popover--tab-tip__button:hover,:host(cds-popover) :hover::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) :hover::slotted(.cds--popover--tab-tip__button){background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button,:host(cds-popover) .cds--popover--tab-tip.cds--popover--open ::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) .cds--popover--tab-tip.cds--popover--open ::slotted(.cds--popover--tab-tip__button){background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button) svg,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button) svg{fill:var(--cds-icon-primary,#161616)}:host(cds-popover[tabTip][open]) ::slotted(.cds--popover--tab-tip__button,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button),:host(cds-popover) ::slotted(.cds--popover--tab-tip__button)){background:var(--cds-layer)!important;box-shadow:0 .125rem .125rem rgba(0,0,0,.2)}:host(cds-ai-label[open]) .cds--popover-content,:host(cds-popover-content[open]) .cds--popover-content,:host(cds-slug[open]) .cds--popover-content,:host(cds-toggletip[open]) .cds--popover-content,:host(cds-tooltip-content[open]) .cds--popover-content{display:block}:host(cds-popover-content[open][tabTip]) .cds--popover-content,:host(cds-tooltip-content[open][tabTip]) .cds--popover-content{background:var(--cds-layer);border-radius:0}:host(cds-ai-label[open]) .cds--popover-caret,:host(cds-popover-content[open][caret]) .cds--popover-caret,:host(cds-slug[open]) .cds--popover-caret,:host(cds-toggletip[open]) .cds--popover-caret,:host(cds-tooltip-content[open][caret]) .cds--popover-caret{display:block}:host(cds-popover-content[dropShadow]){--cds-popover-drop-shadow:drop-shadow(0 0.125rem 0.125rem rgba(0,0,0,.2))}:host(cds-ai-label[alignment^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-popover-content[align^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-toggletip[alignment^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-tooltip-content[align^=bottom]:not([autoalign])) .cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}:host(cds-ai-label[alignment^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=bottom]:not([autoalign])) .cds--popover-caret{clip-path:none}:host(cds-ai-label[alignment=bottom]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=bottom]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=bottom]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=bottom]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=bottom]:not([autoalign])) .cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment=bottom-left]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=bottom-left]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=bottom-left]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=bottom-left]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=bottom-left]:not([autoalign])) .cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment=bottom-right]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=bottom-right]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=bottom-right]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=bottom-right]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=bottom-right]:not([autoalign])) .cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment^=left]:not([autoalign])) .cds--popover-caret,:host(cds-popover-content[align^=left]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=left]:not([autoalign])) .cds--popover-caret,:host(cds-toggletip[alignment^=left]:not([autoalign])) .cds--popover-caret,:host(cds-tooltip-content[align^=left]:not([autoalign])) .cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}:host(cds-ai-label[alignment=left]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=left]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=left]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=left]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=left]:not([autoalign])) .cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}:host(cds-ai-label[alignment=left-bottom]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=left-bottom]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=left-bottom]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=left-bottom]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=left-bottom]:not([autoalign])) .cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 1rem))}:host(cds-ai-label[alignment=left-top]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=left-top]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=left-top]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=left-top]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=left-top]:not([autoalign])) .cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 1rem))}:host(cds-ai-label[alignment^=right]:not([autoalign])) .cds--popover-caret,:host(cds-popover-content[align^=right]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=right]:not([autoalign])) .cds--popover-caret,:host(cds-toggletip[alignment^=right]:not([autoalign])) .cds--popover-caret,:host(cds-tooltip-content[align^=right]:not([autoalign])) .cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}:host(cds-ai-label[alignment=right]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=right]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=right]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=right]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=right]:not([autoalign])) .cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}:host(cds-ai-label[alignment=right-bottom]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=right-bottom]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=right-bottom]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=right-bottom]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=right-bottom]:not([autoalign])) .cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}:host(cds-ai-label[alignment=right-top]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=right-top]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=right-top]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=right-top]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=right-top]:not([autoalign])) .cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}:host(cds-ai-label[alignment^=top]:not([autoalign])) .cds--popover-caret,:host(cds-popover-content[align^=top]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=top]:not([autoalign])) .cds--popover-caret,:host(cds-toggletip[alignment^=top]:not([autoalign])) .cds--popover-caret,:host(cds-tooltip-content[align^=top]:not([autoalign])) .cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}:host(cds-ai-label[alignment=top]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=top]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=top]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=top]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=top]:not([autoalign])) .cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment=top-left]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=top-left]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=top-left]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=top-left]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=top-left]:not([autoalign])) .cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment=top-right]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=top-right]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=top-right]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=top-right]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=top-right]:not([autoalign])) .cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-popover-content[autoalign]) .cds--popover-caret,:host(cds-toggletip[autoalign]) .cds--popover-caret,:host(cds-tooltip-content[autoalign]) .cds--popover-caret{block-size:8px;inline-size:8px;transform:rotate(45deg)}:host(cds-ai-label[autoalign]) .cds--popover-container,:host(cds-popover[autoalign]) .cds--popover-container,:host(cds-slug[autoalign]) .cds--popover-container,:host(cds-toggletip[autoalign]) .cds--popover-container,:host(cds-tooltip[autoalign]) .cds--popover-container{position:static}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content,:host(prefix-tooltip-content) ::slotted(.cds-tooltip-content){color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content,:host(prefix-tooltip-content) .cds--icon-tooltip ::slotted(.cds-tooltip-content){font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}:host(cds-tooltip[data-table]){display:contents}:host(cds-tooltip[data-table]):hover ::slotted(button){background-color:var(--cds-layer-selected-hover)!important}:host(cds-tooltip[data-table][size=sm]) ::slotted(button),:host(cds-tooltip[data-table][size=xs]) ::slotted(button){block-size:calc(100% + 1px)!important}:host(cds-tooltip[toolbar-action]) ::slotted(button){outline:none!important}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lAmrJ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTooltipContent$1);
var _tslib = require("tslib");
var _settingsJs = require("../../globals/settings.js");
var _popoverContentJs = require("../popover/popover-content.js");
var _popoverContentJsDefault = parcelHelpers.interopDefault(_popoverContentJs);
var _tooltipScssJs = require("./tooltip.scss.js");
var _tooltipScssJsDefault = parcelHelpers.interopDefault(_tooltipScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Tooltip content.
 */ let CDSTooltipContent = class CDSTooltipContent extends (0, _popoverContentJsDefault.default) {
    connectedCallback() {
        if (!this.hasAttribute("aria-hidden")) this.setAttribute("aria-hidden", "true");
        if (!this.hasAttribute("role")) this.setAttribute("role", "tooltip");
        super.connectedCallback();
    }
    updated() {
        var _a, _b;
        (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.${(0, _settingsJs.prefix)}--popover-content`)) === null || _b === void 0 || _b.classList.add(`${(0, _settingsJs.prefix)}--tooltip-content`);
    }
};
CDSTooltipContent.styles = (0, _tooltipScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
CDSTooltipContent = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-tooltip-content`)
], CDSTooltipContent);
var CDSTooltipContent$1 = CDSTooltipContent;

},{"tslib":"gBS4y","../../globals/settings.js":"EipuL","../popover/popover-content.js":"7MhEU","./tooltip.scss.js":"fcNWZ","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fcMCT":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSButtonSet$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _defsJs = require("./defs.js");
var _buttonScssJs = require("./button.scss.js");
var _buttonScssJsDefault = parcelHelpers.interopDefault(_buttonScssJs);
var _settingsJs = require("../../globals/settings.js");
var _buttonSetBaseJs = require("./button-set-base.js");
var _buttonSetBaseJsDefault = parcelHelpers.interopDefault(_buttonSetBaseJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Button set.
 *
 * @element cds-button-set
 */ let CDSButtonSet = class CDSButtonSet extends (0, _buttonSetBaseJsDefault.default) {
    /**
     * Handler for @slotchange, set the first cds-button to kind secondary and primary for the remaining ones
     *
     * @private
     */ _handleSlotChange(event) {
        const childItems = event.target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.selectorItem) : false);
        childItems.forEach((elem, index)=>{
            elem.setAttribute("kind", index === 0 ? (0, _defsJs.BUTTON_KIND).SECONDARY : (0, _defsJs.BUTTON_KIND).PRIMARY);
        });
        const update = new CustomEvent(`${(0, _settingsJs.prefix)}-btn-set-update`, {
            bubbles: true,
            cancelable: true,
            composed: true
        });
        this.dispatchEvent(update);
    }
    render() {
        return (0, _lit.html)` <slot @slotchange="${this._handleSlotChange}"></slot> `;
    }
    /**
     * A selector that will return the child items.
     */ static get selectorItem() {
        return `${0, _settingsJs.prefix}-button`;
    }
};
CDSButtonSet.styles = (0, _buttonScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
CDSButtonSet = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-button-set`)
], CDSButtonSet);
var CDSButtonSet$1 = CDSButtonSet;

},{"tslib":"gBS4y","lit":"aCmte","./defs.js":"3XZFP","./button.scss.js":"ffMSy","../../globals/settings.js":"EipuL","./button-set-base.js":"gwXcd","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gwXcd":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSButtonSetBase$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _buttonScssJs = require("./button.scss.js");
var _buttonScssJsDefault = parcelHelpers.interopDefault(_buttonScssJs);
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Button set without button checks
 *
 * @element cds-button-set-base
 */ let CDSButtonSetBase = class CDSButtonSetBase extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)`<slot></slot>`;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "list");
    }
};
CDSButtonSetBase.styles = (0, _buttonScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom WebPack loader
CDSButtonSetBase = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-button-set-base`)
], CDSButtonSetBase);
/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */ var CDSButtonSetBase$1 = CDSButtonSetBase;

},{"tslib":"gBS4y","lit":"aCmte","./button.scss.js":"ffMSy","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cfoNU":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSButtonSkeleton$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _buttonJs = require("./button.js");
var _buttonJsDefault = parcelHelpers.interopDefault(_buttonJs);
var _buttonScssJs = require("./button.scss.js");
var _buttonScssJsDefault = parcelHelpers.interopDefault(_buttonScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Button skeleton.
 */ let CDSButtonSkeleton = class CDSButtonSkeleton extends (0, _buttonJsDefault.default) {
    /**
     * Handles `click` event on the `<a>.
     *
     * @param event The event.
     */ _handleClickLinkSkeleton(event) {
        if (this.disabled) {
            event.preventDefault(); // Stop following the link
            event.stopPropagation(); // Stop firing `onClick`
        }
    }
    render() {
        const { autofocus, disabled, download, href, hreflang, ping, rel, size, target, type } = this;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--btn`]: true,
            [`${0, _settingsJs.prefix}--skeleton`]: true,
            [`${0, _settingsJs.prefix}--btn--${size}`]: size
        });
        return href ? (0, _lit.html)`
          <a
            id="button"
            role="button"
            class="${classes}"
            download="${(0, _ifDefinedJs.ifDefined)(download)}"
            href="${(0, _ifDefinedJs.ifDefined)(href)}"
            hreflang="${(0, _ifDefinedJs.ifDefined)(hreflang)}"
            ping="${(0, _ifDefinedJs.ifDefined)(ping)}"
            rel="${(0, _ifDefinedJs.ifDefined)(rel)}"
            target="${(0, _ifDefinedJs.ifDefined)(target)}"
            type="${(0, _ifDefinedJs.ifDefined)(type)}"
            @click="${this._handleClickLinkSkeleton}"></a>
        ` : (0, _lit.html)`
          <button
            id="button"
            class="${classes}"
            ?autofocus="${autofocus}"
            ?disabled="${disabled}"
            type="${(0, _ifDefinedJs.ifDefined)(type)}"></button>
        `;
    }
};
CDSButtonSkeleton.styles = (0, _buttonScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
CDSButtonSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-button-skeleton`)
], CDSButtonSkeleton);
var CDSButtonSkeleton$1 = CDSButtonSkeleton;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit/directives/if-defined.js":"hSgrS","lit":"aCmte","../../globals/settings.js":"EipuL","./button.js":"ca52G","./button.scss.js":"ffMSy","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"66VUf":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Icon Button size.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ICON_BUTTON_SIZE", ()=>ICON_BUTTON_SIZE);
parcelHelpers.export(exports, "ICON_BUTTON_TOOLTIP_ALIGNMENT", ()=>ICON_BUTTON_TOOLTIP_ALIGNMENT);
var ICON_BUTTON_SIZE;
(function(ICON_BUTTON_SIZE) {
    /**
     * Small size.
     */ ICON_BUTTON_SIZE["SMALL"] = "sm";
    /**
     * Medium size.
     */ ICON_BUTTON_SIZE["MEDIUM"] = "md";
    /**
     * Large size.
     */ ICON_BUTTON_SIZE["LARGE"] = "lg";
})(ICON_BUTTON_SIZE || (ICON_BUTTON_SIZE = {}));
/**
 * Icon Button Tooltip alignment.
 */ var ICON_BUTTON_TOOLTIP_ALIGNMENT;
(function(ICON_BUTTON_TOOLTIP_ALIGNMENT) {
    /**
     * Align the top position for the tooltip content.
     */ ICON_BUTTON_TOOLTIP_ALIGNMENT["TOP"] = "top";
    /**
     * Align the top-left position for the tooltip content.
     */ ICON_BUTTON_TOOLTIP_ALIGNMENT["TOP_LEFT"] = "top-left";
    /**
     * Align the top right position for the tooltip content.
     */ ICON_BUTTON_TOOLTIP_ALIGNMENT["TOP_RIGHT"] = "top-right";
    /**
     * Align the bottom position for the tooltip content.
     */ ICON_BUTTON_TOOLTIP_ALIGNMENT["BOTTOM"] = "bottom";
    /**
     * Align the bottom left position for the tooltip content.
     */ ICON_BUTTON_TOOLTIP_ALIGNMENT["BOTTOM_LEFT"] = "bottom-left";
    /**
     * Align the bottom right position for the tooltip content.
     */ ICON_BUTTON_TOOLTIP_ALIGNMENT["BOTTOM_RIGHT"] = "bottom-right";
    /**
     * Align the left position for the tooltip content.
     */ ICON_BUTTON_TOOLTIP_ALIGNMENT["LEFT"] = "left";
    /**
     * Align the right position for the tooltip content.
     */ ICON_BUTTON_TOOLTIP_ALIGNMENT["RIGHT"] = "right";
})(ICON_BUTTON_TOOLTIP_ALIGNMENT || (ICON_BUTTON_TOOLTIP_ALIGNMENT = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jMs7p":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover,.cds--popover--high-contrast :host(cds-popover-content),.cds--popover--high-contrast :host(cds-tooltip-content),:host(cds-popover[highContrast]) .cds--popover--high-contrast ::slotted(cds-popover-content),:host(cds-popover[highContrast]) .cds--popover--high-contrast ::slotted(cds-tooltip-content),:host(cds-tooltip[highContrast]) .cds--popover--high-contrast ::slotted(cds-popover-content),:host(cds-tooltip[highContrast]) .cds--popover--high-contrast ::slotted(cds-tooltip-content){--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content,.cds--popover--drop-shadow :host(cds-popover-content)>.cds--popover-content,.cds--popover--drop-shadow :host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--drop-shadow ::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--drop-shadow ::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--drop-shadow ::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--drop-shadow ::slotted(cds-tooltip-content)>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover,:host(cds-popover-content),:host(cds-popover[highContrast]) ::slotted(cds-popover-content),:host(cds-popover[highContrast]) ::slotted(cds-tooltip-content),:host(cds-tooltip-content),:host(cds-tooltip[highContrast]) ::slotted(cds-popover-content),:host(cds-tooltip[highContrast]) ::slotted(cds-tooltip-content){filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content,.cds--popover--open>:host(cds-popover-content)>.cds--popover-content,.cds--popover--open>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before,.cds--popover--open>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--open>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret,.cds--popover--caret.cds--popover--open>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--caret.cds--popover--open>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--caret.cds--popover--open>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--caret.cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--caret.cds--popover--open>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--caret.cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-caret{display:block}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--auto-align.cds--popover--caret.cds--popover--open>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--auto-align.cds--popover--caret.cds--popover--open>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--auto-align.cds--popover--caret.cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--auto-align.cds--popover--caret.cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--auto-align.cds--popover--caret.cds--popover--open>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--auto-align.cds--popover--caret.cds--popover--open>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret,.cds--popover--tab-tip>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--tab-tip>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--tab-tip>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--tab-tip>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--tab-tip>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--tab-tip>::slotted(cds-tooltip-content)>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-end>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom-end>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom-left>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom-right>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom-start>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--bottom>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-end>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom-end>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom-left>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom-right>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom-start>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret,.cds--popover--bottom>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--bottom>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--bottom>::slotted(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-end>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-end>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>:host(cds-tooltip-content)>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-end.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-end.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-end>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top-end>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top-left>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top-right>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top-start>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before,.cds--popover--top>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--top>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--top>::slotted(cds-tooltip-content)>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-end>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top-end>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-left>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top-left>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-right>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top-right>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top-start>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top-start>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret,.cds--popover--top>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--top>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-end>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-end>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-left>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-left>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-right>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-right>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-start>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-start>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top>::slotted(cds-tooltip-content)>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-end.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-end.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-bottom>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right-bottom>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right-end>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right-start>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right-top>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before,.cds--popover--right>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--right>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right-top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--right>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right-top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--right>::slotted(cds-tooltip-content)>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-bottom.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-bottom.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right-top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right-top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--right.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-bottom>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left-bottom>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left-end>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left-start>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left-top>:host(cds-tooltip-content)>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before,.cds--popover--left>:host(cds-popover-content)>.cds--popover-content:before,.cds--popover--left>:host(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left-top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-popover[highContrast]) .cds--popover--left>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-end>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-end>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-start>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-start>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-top>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left-top>::slotted(cds-tooltip-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left>::slotted(cds-popover-content)>.cds--popover-content:before,:host(cds-tooltip[highContrast]) .cds--popover--left>::slotted(cds-tooltip-content)>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-popover[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-popover-content)>.cds--popover-caret,:host(cds-tooltip[highContrast]) [dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>::slotted(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>:host(cds-popover-content)>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>:host(cds-tooltip-content)>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-bottom.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-bottom.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>:host(cds-popover-content)>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>:host(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left-top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-popover[highContrast]) .cds--popover--left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-bottom.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-end.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-end.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-start.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-start.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-top.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left-top.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left.cds--popover--auto-align>::slotted(cds-popover-content)>.cds--popover-content>.cds--popover-caret,:host(cds-tooltip[highContrast]) .cds--popover--left.cds--popover--auto-align>::slotted(cds-tooltip-content)>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content,.cds--popover--tab-tip>:host(cds-popover-content)>.cds--popover-content,.cds--popover--tab-tip>:host(cds-tooltip-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--tab-tip>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-popover[highContrast]) .cds--popover--tab-tip>::slotted(cds-tooltip-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--tab-tip>::slotted(cds-popover-content)>.cds--popover-content,:host(cds-tooltip[highContrast]) .cds--popover--tab-tip>::slotted(cds-tooltip-content)>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover,.cds--popover--tab-tip :host(cds-popover-content),.cds--popover--tab-tip :host(cds-tooltip-content),:host(cds-popover[highContrast]) .cds--popover--tab-tip ::slotted(cds-popover-content),:host(cds-popover[highContrast]) .cds--popover--tab-tip ::slotted(cds-tooltip-content),:host(cds-tooltip[highContrast]) .cds--popover--tab-tip ::slotted(cds-popover-content),:host(cds-tooltip[highContrast]) .cds--popover--tab-tip ::slotted(cds-tooltip-content){will-change:filter}.cds--popover--tab-tip__button,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button){align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button) *,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button) :after,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button) :before,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button) *,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button) :after,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button) :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus,:host(cds-popover) :focus::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) :focus::slotted(.cds--popover--tab-tip__button){outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus,:host(cds-popover) :focus::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) :focus::slotted(.cds--popover--tab-tip__button){outline-style:dotted}}.cds--popover--tab-tip__button:hover,:host(cds-popover) :hover::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) :hover::slotted(.cds--popover--tab-tip__button){background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button,:host(cds-popover) .cds--popover--tab-tip.cds--popover--open ::slotted(.cds--popover--tab-tip__button),:host(cds-tooltip) .cds--popover--tab-tip.cds--popover--open ::slotted(.cds--popover--tab-tip__button){background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg,:host(cds-popover) ::slotted(.cds--popover--tab-tip__button) svg,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button) svg{fill:var(--cds-icon-primary,#161616)}:host(cds-popover[tabTip][open]) ::slotted(.cds--popover--tab-tip__button,:host(cds-tooltip) ::slotted(.cds--popover--tab-tip__button),:host(cds-popover) ::slotted(.cds--popover--tab-tip__button)){background:var(--cds-layer)!important;box-shadow:0 .125rem .125rem rgba(0,0,0,.2)}:host(cds-ai-label[open]) .cds--popover-content,:host(cds-popover-content[open]) .cds--popover-content,:host(cds-slug[open]) .cds--popover-content,:host(cds-toggletip[open]) .cds--popover-content,:host(cds-tooltip-content[open]) .cds--popover-content{display:block}:host(cds-popover-content[open][tabTip]) .cds--popover-content,:host(cds-tooltip-content[open][tabTip]) .cds--popover-content{background:var(--cds-layer);border-radius:0}:host(cds-ai-label[open]) .cds--popover-caret,:host(cds-popover-content[open][caret]) .cds--popover-caret,:host(cds-slug[open]) .cds--popover-caret,:host(cds-toggletip[open]) .cds--popover-caret,:host(cds-tooltip-content[open][caret]) .cds--popover-caret{display:block}:host(cds-popover-content[dropShadow]){--cds-popover-drop-shadow:drop-shadow(0 0.125rem 0.125rem rgba(0,0,0,.2))}:host(cds-ai-label[alignment^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-popover-content[align^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-toggletip[alignment^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-tooltip-content[align^=bottom]:not([autoalign])) .cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}:host(cds-ai-label[alignment^=bottom]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=bottom]:not([autoalign])) .cds--popover-caret{clip-path:none}:host(cds-ai-label[alignment=bottom]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=bottom]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=bottom]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=bottom]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=bottom]:not([autoalign])) .cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment=bottom-left]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=bottom-left]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=bottom-left]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=bottom-left]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=bottom-left]:not([autoalign])) .cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment=bottom-right]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=bottom-right]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=bottom-right]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=bottom-right]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=bottom-right]:not([autoalign])) .cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment^=left]:not([autoalign])) .cds--popover-caret,:host(cds-popover-content[align^=left]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=left]:not([autoalign])) .cds--popover-caret,:host(cds-toggletip[alignment^=left]:not([autoalign])) .cds--popover-caret,:host(cds-tooltip-content[align^=left]:not([autoalign])) .cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}:host(cds-ai-label[alignment=left]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=left]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=left]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=left]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=left]:not([autoalign])) .cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}:host(cds-ai-label[alignment=left-bottom]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=left-bottom]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=left-bottom]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=left-bottom]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=left-bottom]:not([autoalign])) .cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 1rem))}:host(cds-ai-label[alignment=left-top]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=left-top]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=left-top]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=left-top]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=left-top]:not([autoalign])) .cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 1rem))}:host(cds-ai-label[alignment^=right]:not([autoalign])) .cds--popover-caret,:host(cds-popover-content[align^=right]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=right]:not([autoalign])) .cds--popover-caret,:host(cds-toggletip[alignment^=right]:not([autoalign])) .cds--popover-caret,:host(cds-tooltip-content[align^=right]:not([autoalign])) .cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}:host(cds-ai-label[alignment=right]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=right]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=right]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=right]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=right]:not([autoalign])) .cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}:host(cds-ai-label[alignment=right-bottom]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=right-bottom]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=right-bottom]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=right-bottom]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=right-bottom]:not([autoalign])) .cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}:host(cds-ai-label[alignment=right-top]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=right-top]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=right-top]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=right-top]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=right-top]:not([autoalign])) .cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}:host(cds-ai-label[alignment^=top]:not([autoalign])) .cds--popover-caret,:host(cds-popover-content[align^=top]:not([autoalign])) .cds--popover-caret,:host(cds-slug[alignment^=top]:not([autoalign])) .cds--popover-caret,:host(cds-toggletip[alignment^=top]:not([autoalign])) .cds--popover-caret,:host(cds-tooltip-content[align^=top]:not([autoalign])) .cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}:host(cds-ai-label[alignment=top]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=top]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=top]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=top]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=top]:not([autoalign])) .cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment=top-left]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=top-left]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=top-left]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=top-left]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=top-left]:not([autoalign])) .cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-ai-label[alignment=top-right]:not([autoalign])) .cds--popover-content,:host(cds-popover-content[align=top-right]:not([autoalign])) .cds--popover-content,:host(cds-slug[alignment=top-right]:not([autoalign])) .cds--popover-content,:host(cds-toggletip[alignment=top-right]:not([autoalign])) .cds--popover-content,:host(cds-tooltip-content[align=top-right]:not([autoalign])) .cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}:host(cds-popover-content[autoalign]) .cds--popover-caret,:host(cds-toggletip[autoalign]) .cds--popover-caret,:host(cds-tooltip-content[autoalign]) .cds--popover-caret{block-size:8px;inline-size:8px;transform:rotate(45deg)}:host(cds-ai-label[autoalign]) .cds--popover-container,:host(cds-popover[autoalign]) .cds--popover-container,:host(cds-slug[autoalign]) .cds--popover-container,:host(cds-toggletip[autoalign]) .cds--popover-container,:host(cds-tooltip[autoalign]) .cds--popover-container{position:static}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content,:host(prefix-tooltip-content) ::slotted(.cds-tooltip-content){color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content,:host(prefix-tooltip-content) .cds--icon-tooltip ::slotted(.cds-tooltip-content){font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}:host(cds-tooltip[data-table]){display:contents}:host(cds-tooltip[data-table]):hover ::slotted(button){background-color:var(--cds-layer-selected-hover)!important}:host(cds-tooltip[data-table][size=sm]) ::slotted(button),:host(cds-tooltip[data-table][size=xs]) ::slotted(button){block-size:calc(100% + 1px)!important}:host(cds-tooltip[toolbar-action]) ::slotted(button){outline:none!important}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon,:host(cds-button) .cds--btn ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn ::slotted([slot=icon]){block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--primary ::slotted([slot=icon]),:host(cds-button) .cds--btn--primary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--primary ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--primary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--secondary ::slotted([slot=icon]),:host(cds-button) .cds--btn--secondary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--secondary ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--secondary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--tertiary ::slotted([slot=icon]),:host(cds-button) .cds--btn--tertiary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--tertiary ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--tertiary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--ghost ::slotted([slot=icon]),:host(cds-button) .cds--btn--ghost ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--ghost ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--ghost ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon,:host(cds-button) .cds--btn--ghost ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--ghost ::slotted([slot=icon]){margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon,:host(cds-button) .cds--btn--icon-only ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--icon-only ::slotted([slot=icon]){position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon,:host(cds-button) .cds--btn--icon-only.cds--btn--danger--ghost ::slotted([slot=icon]),:host(cds-button) .cds--btn--icon-only.cds--btn--ghost ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--icon-only.cds--btn--danger--ghost ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--icon-only.cds--btn--ghost ::slotted([slot=icon]){margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon,:host(cds-button) .cds--btn--md:not(.cds--btn--icon-only) ::slotted([slot=icon]),:host(cds-button) .cds--btn--sm:not(.cds--btn--icon-only) ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--md:not(.cds--btn--icon-only) ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--sm:not(.cds--btn--icon-only) ::slotted([slot=icon]){margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]),:host(cds-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon,:host(cds-button) .cds--btn--ghost.cds--btn--icon-only[disabled] ::slotted([slot=icon]),:host(cds-button) .cds--btn--ghost.cds--btn--icon-only[disabled] ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--ghost.cds--btn--icon-only[disabled] ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--ghost.cds--btn--icon-only[disabled] ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--danger ::slotted([slot=icon]),:host(cds-button) .cds--btn--danger ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--danger ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--danger ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--danger--tertiary ::slotted([slot=icon]),:host(cds-button) .cds--btn--danger--tertiary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--danger--tertiary ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--danger--tertiary ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--danger--ghost ::slotted([slot=icon]),:host(cds-button) .cds--btn--danger--ghost ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--danger--ghost ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--danger--ghost ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon,:host(cds-button) .cds--btn--danger--ghost ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--danger--ghost ::slotted([slot=icon]){margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon,:host(cds-button) .cds--btn.cds--btn--expressive ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn.cds--btn--expressive ::slotted([slot=icon]){block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive,:host(cds-button-set) .cds--btn.cds--btn--expressive,:host(cds-side-panel-button-set) .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set,:host(cds-button-set),:host(cds-side-panel-button-set){display:flex}.cds--btn-set--stacked,:host(cds-button-set[stacked]){flex-direction:column}.cds--btn-set .cds--btn,:host(cds-button-set) .cds--btn,:host(cds-side-panel-button-set) .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus),:host(cds-button-set) .cds--btn:not(:focus),:host(cds-side-panel-button-set) .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),:host(cds-button-set) .cds--btn:first-of-type:not(:focus),:host(cds-side-panel-button-set) .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn:focus+.cds--btn,:host(cds-button-set) .cds--btn:focus+.cds--btn,:host(cds-side-panel-button-set) .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus),:host(cds-button-set[stacked]) .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus),:host(cds-button-set[stacked]) .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled,:host(cds-button-set) .cds--btn.cds--btn--disabled,:host(cds-side-panel-button-set) .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type,:host(cds-button-set) .cds--btn.cds--btn--disabled:first-of-type,:host(cds-side-panel-button-set) .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled,:host(cds-button-set[stacked]) .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type,:host(cds-button-set[stacked]) .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading,:host(cds-button-set) .cds--btn.cds--btn--loading,:host(cds-side-panel-button-set) .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]),:host(cds-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]),:host(cds-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]),:host(cds-modal-footer-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]),:host(cds-modal-footer-button) .cds--btn--ghost.cds--btn--icon-only ::slotted([slot=icon]) path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus),[dir=rtl] :host(cds-button-set) .cds--btn:not(:focus),[dir=rtl] :host(cds-side-panel-button-set) .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--copy-btn{position:relative}.cds--copy-btn:hover{background-color:var(--cds-layer-hover)}.cds--copy-btn:active{background-color:var(--cds-layer-active)}.cds--copy-btn:before{block-size:0;border-style:solid;content:"";display:none;inline-size:0;position:absolute;z-index:6000}.cds--copy-btn .cds--copy-btn__feedback{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));box-sizing:content-box;color:var(--cds-text-inverse,#fff);display:none;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:auto;max-inline-size:13rem;min-inline-size:1.5rem;overflow:visible;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000;clip:auto}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--copy-btn .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-accelerator:true){.cds--copy-btn .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--copy-btn .cds--copy-btn__feedback{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--copy-btn .cds--copy-btn__feedback{border:1px solid transparent}}.cds--copy-btn.cds--copy-btn--animating .cds--copy-btn__feedback,.cds--copy-btn.cds--copy-btn--animating:before{display:block}.cds--copy-btn.cds--copy-btn--animating:before{border:none}.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-out .cds--copy-btn__feedback,.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-out:before{animation:cds--hide-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-in .cds--copy-btn__feedback,.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-in:before{animation:cds--show-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--copy-btn svg{fill:var(--cds-icon-primary,#161616)}.cds--copy{font-size:0}.cds--chat-btn{border-radius:1.5rem}.cds--chat-btn:not(.cds--chat-btn--with-icon){padding-inline-end:.9375rem}.cds--chat-btn.cds--btn--md{border-radius:1.25rem}.cds--chat-btn.cds--btn--sm{border-radius:1rem}.cds--chat-btn--quick-action{align-items:center;background:transparent;border:1px solid var(--cds-chat-button,#0f62fe);color:var(--cds-chat-button,#0f62fe)}.cds--chat-btn--quick-action:hover:not(:active):not([disabled]){background:var(--cds-chat-button-hover,hsla(0,0%,55%,.12));border-color:transparent;color:var(--cds-chat-button-text-hover,#0043ce)}.cds--chat-btn--quick-action:active{background:var(--cds-chat-button-active,hsla(0,0%,55%,.5));border-color:transparent;color:var(--cds-chat-button-text-hover,#0043ce)}.cds--chat-btn--quick-action.cds--btn--ghost:focus{border-color:var(--cds-focus,#0f62fe);box-shadow:inset 0 0 0 1px var(--cds-focus,#0f62fe)}.cds--chat-btn--quick-action.cds--btn--ghost:hover:focus{border-color:var(--cds-focus,#0f62fe);box-shadow:inset 0 0 0 1px var(--cds-focus-inset,#fff)}.cds--chat-btn--quick-action[disabled],.cds--chat-btn--quick-action[disabled]:hover{border-color:var(--cds-button-disabled,#c6c6c6);color:var(--cds-button-disabled,#c6c6c6)}.cds--chat-btn--quick-action--selected,.cds--chat-btn--quick-action--selected[disabled],.cds--chat-btn--quick-action--selected[disabled]:hover{background:var(--cds-chat-button-selected,hsla(0,0%,55%,.2));border-color:transparent;color:var(--cds-chat-button-text-selected,#525252)}.cds--chat-btn--quick-action.cds--chat-btn--quick-action--selected:not([disabled]):active,.cds--chat-btn--quick-action.cds--chat-btn--quick-action--selected:not([disabled]):hover{color:var(--cds-chat-button-text-selected,#525252)}.cds--chat-btn.cds--skeleton{overflow:hidden}.cds--snippet html{font-size:100%}.cds--snippet body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--snippet code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--snippet strong{font-weight:600}.cds--snippet--disabled,.cds--snippet--disabled .cds--btn.cds--snippet-btn--expand{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--snippet--disabled .cds--copy-btn,.cds--snippet--disabled .cds--copy-btn:hover,.cds--snippet--disabled .cds--snippet-btn--expand:hover{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--snippet--disabled .cds--snippet-btn--expand .cds--icon-chevron--down,.cds--snippet--disabled .cds--snippet__icon{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--snippet code{font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333)}.cds--snippet--inline{background-color:var(--cds-layer);border:1px solid transparent;border-radius:4px;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline;padding:0;position:relative}.cds--snippet--inline html{font-size:100%}.cds--snippet--inline body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--snippet--inline code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--snippet--inline strong{font-weight:600}.cds--snippet--inline:hover{background-color:var(--cds-layer-hover)}.cds--snippet--inline:active{background-color:var(--cds-layer-active)}.cds--snippet--inline:focus{border:1px solid var(--cds-focus,#0f62fe);outline:none}.cds--snippet--inline:before{block-size:0;border:none;content:"";display:none;inline-size:0;position:absolute;z-index:6000}.cds--snippet--inline .cds--copy-btn__feedback{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));box-sizing:content-box;color:var(--cds-text-inverse,#fff);display:none;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:auto;max-inline-size:13rem;min-inline-size:1.5rem;overflow:visible;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000;clip:auto}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--snippet--inline .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-accelerator:true){.cds--snippet--inline .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--snippet--inline .cds--copy-btn__feedback{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--snippet--inline .cds--copy-btn__feedback{border:1px solid transparent}}.cds--snippet--inline.cds--copy-btn--animating .cds--copy-btn__feedback,.cds--snippet--inline.cds--copy-btn--animating:before{display:block}.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-out .cds--copy-btn__feedback,.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-out:before{animation:cds--hide-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-in .cds--copy-btn__feedback,.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-in:before{animation:cds--show-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--snippet--inline code{padding:0 .5rem}.cds--snippet--inline.cds--snippet--no-copy{display:inline-block}.cds--snippet--inline.cds--snippet--no-copy:hover{background-color:var(--cds-layer);cursor:auto}.cds--snippet--light.cds--snippet--inline.cds--snippet--no-copy:hover{background-color:var(--cds-layer-hover);cursor:auto}.cds--snippet--single{align-items:center;background-color:var(--cds-layer);block-size:2.5rem;display:flex;font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);max-inline-size:48rem;padding-inline-end:2.5rem;position:relative}.cds--snippet--single.cds--snippet--no-copy{padding:0}.cds--snippet--single.cds--snippet--no-copy:after{inset-inline-end:1rem}.cds--snippet--single .cds--snippet-container{align-items:center;block-size:100%;display:flex;overflow-x:auto;padding-inline-start:1rem;position:relative}.cds--snippet--single .cds--snippet-container:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--snippet--single .cds--snippet-container:focus{outline-style:dotted}}.cds--snippet--single pre{font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);padding-inline-end:.5rem}.cds--snippet--inline code,.cds--snippet--single pre{white-space:pre}.cds--snippet--multi{background-color:var(--cds-layer);display:flex;font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);max-inline-size:48rem;padding:1rem;position:relative}.cds--snippet--multi .cds--snippet-container{max-block-size:100%;min-block-size:100%;order:1;overflow-y:auto;position:relative;transition:max-height .15s cubic-bezier(.2,0,.38,.9)}.cds--snippet--multi .cds--snippet-container:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;outline-offset:0}@media screen and (prefers-contrast){.cds--snippet--multi .cds--snippet-container:focus{outline-style:dotted}}.cds--snippet--multi.cds--snippet--expand .cds--snippet-container{padding-block-end:1rem;transition:max-height .15s cubic-bezier(.2,0,.38,.9)}.cds--snippet--multi.cds--snippet--wraptext pre{white-space:pre-wrap;word-wrap:break-word}.cds--snippet--multi .cds--snippet-container pre{padding-inline-end:2.5rem}.cds--snippet--multi.cds--snippet--no-copy .cds--snippet-container pre{padding-inline-end:0}.cds--snippet--multi.cds--snippet--has-right-overflow:after{background-image:linear-gradient(to right,transparent,var(--cds-layer));block-size:100%;content:"";inline-size:1rem;inset-block-start:0;inset-inline-end:1rem;position:absolute}[dir=rtl] .cds--snippet--multi.cds--snippet--has-right-overflow:after{background-image:linear-gradient(to left,transparent,var(--cds-layer))}.cds--snippet--multi .cds--snippet-container pre code{overflow:hidden}.cds--snippet__icon{block-size:1rem;fill:var(--cds-icon-primary,#161616);inline-size:1rem;transition:all 70ms cubic-bezier(.2,0,.38,.9)}.cds--btn>.cds--snippet__icon{margin-block-start:0}.cds--copy-btn{align-items:center;background-color:var(--cds-layer);border:none;cursor:pointer;display:flex;justify-content:center;outline:none;overflow:visible;padding:0}.cds--copy-btn html{font-size:100%}.cds--copy-btn body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--copy-btn code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--copy-btn strong{font-weight:600}.cds--copy-btn:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-color:var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--copy-btn:focus{outline-style:dotted}}.cds--snippet .cds--popover-container{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;inset-block-start:0;inset-inline-end:0;position:absolute}.cds--snippet--inline.cds--btn{block-size:1.25rem;inline-size:auto;max-inline-size:unset;min-block-size:1.25rem;padding-inline:0}.cds--snippet--inline.cds--btn.cds--btn--primary:hover{color:var(--cds-text-primary,#161616)}.cds--snippet.cds--snippet--multi .cds--popover-container{inset-block-start:.5rem;inset-inline-end:.5rem}.cds--snippet--multi .cds--copy-btn{z-index:10}.cds--snippet-btn--expand{align-items:center;background-color:var(--cds-layer);block-size:2rem;border:0;color:var(--cds-text-primary,#161616);display:inline-flex;font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inset-block-end:0;inset-inline-end:0;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);padding:.5rem 1rem;position:absolute;z-index:10}.cds--snippet-btn--expand .cds--snippet-btn--text{inset-block-start:-.0625rem;position:relative}.cds--snippet-btn--expand--hide.cds--snippet-btn--expand{display:none}.cds--snippet-btn--expand .cds--icon-chevron--down{fill:var(--cds-icon-primary,#161616);margin-inline-start:.5rem;transform:rotate(0deg);transition:.15s cubic-bezier(.2,0,.38,.9)}.cds--snippet-btn--expand:hover{background:var(--cds-layer-hover);color:var(--cds-text-primary,#161616)}.cds--snippet-btn--expand:active{background-color:var(--cds-layer-active)}.cds--snippet-btn--expand:focus{border-color:transparent;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--snippet-btn--expand:focus{outline-style:dotted}}.cds--snippet--expand .cds--snippet-btn--expand .cds--icon-chevron--down{transform:rotate(180deg);transition:transform .3s}.cds--snippet--light,.cds--snippet--light .cds--btn.cds--snippet-btn--expand,.cds--snippet--light .cds--copy-btn,.cds--snippet--light .cds--snippet-button{background-color:var(--cds-layer)}.cds--snippet--light .cds--btn.cds--snippet-btn--expand:hover,.cds--snippet--light .cds--copy-btn:hover,.cds--snippet--light .cds--snippet-button:hover,.cds--snippet--light.cds--snippet--inline:hover{background-color:var(--cds-layer-hover)}.cds--snippet--light .cds--btn.cds--snippet-btn--expand:active,.cds--snippet--light .cds--copy-btn:active,.cds--snippet--light .cds--snippet-button:active,.cds--snippet--light.cds--snippet--inline:active{background-color:var(--cds-layer-active)}.cds--snippet--light.cds--snippet--multi:after,.cds--snippet--light.cds--snippet--single:after{background-image:linear-gradient(to right,rgba(var(--cds-layer),0),var(--cds-layer))}.cds--snippet.cds--skeleton .cds--snippet-container{block-size:100%;inline-size:100%}.cds--snippet-button .cds--btn--copy__feedback{inset-block-start:3.175rem;inset-inline:50% auto}.cds--snippet-button .cds--btn--copy__feedback:before{inset-block-start:0}.cds--snippet-button .cds--btn--copy__feedback:after{inset-block-start:-.25rem}.cds--snippet--multi .cds--snippet-button .cds--btn--copy__feedback{inset-block-start:2.675rem}.cds--snippet--inline .cds--btn--copy__feedback{inset-block-start:calc(100% - .25rem);inset-inline:50% auto}.cds--snippet__overflow-indicator--left,.cds--snippet__overflow-indicator--right{flex:1 0 auto;inline-size:1rem;z-index:1}.cds--snippet__overflow-indicator--left{background-image:linear-gradient(to left,transparent,var(--cds-layer));margin-inline-end:-1rem;order:0}.cds--snippet__overflow-indicator--right{margin-inline-start:-1rem;order:2}.cds--snippet__overflow-indicator--right,[dir=rtl] .cds--snippet__overflow-indicator--left{background-image:linear-gradient(to right,transparent,var(--cds-layer))}[dir=rtl] .cds--snippet__overflow-indicator--right{background-image:linear-gradient(to left,transparent,var(--cds-layer))}.cds--snippet--single .cds--snippet__overflow-indicator--left,.cds--snippet--single .cds--snippet__overflow-indicator--right{block-size:calc(100% - .25rem);inline-size:2rem;position:absolute}.cds--snippet--single .cds--snippet__overflow-indicator--right{inset-inline-end:2.5rem}.cds--snippet--single.cds--snippet--no-copy .cds--snippet__overflow-indicator--right{inset-inline-end:0}.cds--snippet--single .cds--snippet-container:focus~.cds--snippet__overflow-indicator--right{inset-inline-end:2.625rem}.cds--snippet--single .cds--snippet-container:focus+.cds--snippet__overflow-indicator--left{inset-inline-start:.125rem}.cds--snippet--light .cds--snippet__overflow-indicator--left{background-image:linear-gradient(to left,transparent,var(--cds-layer))}.cds--snippet--light .cds--snippet__overflow-indicator--right{background-image:linear-gradient(to right,transparent,var(--cds-layer))}@media not all and (min-resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){.cds--snippet__overflow-indicator--left{background-image:linear-gradient(to left,rgba(var(--cds-layer),0),var(--cds-layer))}.cds--snippet__overflow-indicator--right{background-image:linear-gradient(to right,rgba(var(--cds-layer),0),var(--cds-layer))}}}.cds--snippet--multi.cds--skeleton{block-size:6.125rem}.cds--snippet--single.cds--skeleton{block-size:3.5rem}.cds--snippet.cds--skeleton span{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;display:block;inline-size:100%;margin-block-start:.5rem;padding:0;pointer-events:none;position:relative}.cds--snippet.cds--skeleton span:active,.cds--snippet.cds--skeleton span:focus,.cds--snippet.cds--skeleton span:hover{border:none;cursor:default;outline:none}.cds--snippet.cds--skeleton span:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--snippet.cds--skeleton span:before{animation:none}}.cds--snippet.cds--skeleton span:first-child{margin:0}.cds--snippet.cds--skeleton span:nth-child(2){inline-size:85%}.cds--snippet.cds--skeleton span:nth-child(3){inline-size:95%}.cds--snippet--single.cds--skeleton .cds--snippet-container{padding-block-end:0}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--snippet__icon{fill:ButtonText}.cds--snippet--inline:focus{color:Highlight;outline:1px solid Highlight}.cds--snippet--multi,.cds--snippet--single{outline:1px solid transparent}}:host(cds-button),:host(cds-modal-footer-button){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;display:inline-flex}:host(cds-button) .cds--btn,:host(cds-modal-footer-button) .cds--btn{flex-grow:1;max-inline-size:100%}:host(cds-button-skeleton){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}:host(cds-button[isExpressive]) ::slotted([slot=icon]),:host(cds-modal-footer-button[isExpressive]) ::slotted([slot=icon]){block-size:1.25rem;inline-size:1.25rem}:host(cds-button[pagination]) .cds--btn,:host(cds-modal-footer-button[pagination]) .cds--btn{border:none;border-inline-start:1px solid var(--cds-border-subtle);transition:none}:host(cds-button[pagination]) .cds--btn:focus,:host(cds-modal-footer-button[pagination]) .cds--btn:focus{border-inline-start:1px solid transparent;box-shadow:none;outline:.125rem solid var(--cds-focus,#0f62fe);outline-offset:-.125rem}:host(cds-button[pagination]:not([disabled])) .cds--btn,:host(cds-modal-footer-button[pagination]:not([disabled])) .cds--btn{color:var(--cds-icon-primary,#161616)}:host(cds-button[pagination]:not([disabled])) .cds--btn:active,:host(cds-modal-footer-button[pagination]:not([disabled])) .cds--btn:active{background-color:var(--cds-layer-hover)}:host(cds-button[pagination][batch-action]:not([disabled])) .cds--btn,:host(cds-modal-footer-button[pagination][batch-action]:not([disabled])) .cds--btn{padding:calc(.875rem - 3px) 1rem}:host(cds-button[pagination][batch-action]:not([disabled])) .cds--btn:focus,:host(cds-modal-footer-button[pagination][batch-action]:not([disabled])) .cds--btn:focus{outline:.125rem solid var(--cds-layer);outline-offset:-.125rem}:host(cds-button[pagination][batch-action]:not([disabled])) :host(cds-button[pagination][has-main-content]:not([disabled])) ::slotted([slot=icon]),:host(cds-button[pagination][batch-action]:not([disabled])) :host(cds-modal-footer-button[pagination][has-main-content]:not([disabled])) ::slotted([slot=icon]),:host(cds-modal-footer-button[pagination][batch-action]:not([disabled])) :host(cds-button[pagination][has-main-content]:not([disabled])) ::slotted([slot=icon]),:host(cds-modal-footer-button[pagination][batch-action]:not([disabled])) :host(cds-modal-footer-button[pagination][has-main-content]:not([disabled])) ::slotted([slot=icon]){margin-inline-start:.25rem;position:static}:host(cds-button[kind=ghost]) .cds--btn--ghost:active,:host(cds-button[kind=ghost]:hover) .cds--btn--ghost{outline:none}:host(cds-button-set) ::slotted(cds-button),:host(cds-side-panel-button-set) ::slotted(cds-button){inline-size:100%;max-inline-size:12.25rem}:host(cds-icon-button){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}:host(cds-icon-button[kind=ghost]) ::slotted([slot=icon]){color:var(--cds-icon-primary,#161616)}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hEDP1":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _iconButtonJs = require("./icon-button.js");

},{"./icon-button.js":"8LTa1"}],"i8YTZ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _textareaJs = require("./textarea.js");
var _textareaSkeletonJs = require("./textarea-skeleton.js");

},{"./textarea.js":"2ZV7x","./textarea-skeleton.js":"6xCq6"}],"2ZV7x":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTextarea$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _classMapJs = require("lit/directives/class-map.js");
var _16Js = require("../../icons/warning--filled/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/warning--alt--filled/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _settingsJs = require("../../globals/settings.js");
var _ifNonEmptyJs = require("../../globals/directives/if-non-empty.js");
var _ifNonEmptyJsDefault = parcelHelpers.interopDefault(_ifNonEmptyJs);
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _textInputJs = require("../text-input/text-input.js");
var _textInputJsDefault = parcelHelpers.interopDefault(_textInputJs);
var _textareaScssJs = require("./textarea.scss.js");
var _textareaScssJsDefault = parcelHelpers.interopDefault(_textareaScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Text area.
 *
 * @element cds-textarea
 * @slot helper-text - The helper text.
 * @slot label-text - The label text.
 * @slot validity-message - The validity message. If present and non-empty, this input shows the UI of its invalid state.
 */ let CDSTextarea = class CDSTextarea extends (0, _textInputJsDefault.default) {
    constructor(){
        super(...arguments);
        /**
         * ID to link the `label` and `textarea`
         */ this.id = "";
        /**
         * Pattern to validate the textarea against for HTML validity checking
         */ this.pattern = "";
        /**
         * Boolean property to set the required status
         */ this.required = false;
        /**
         * The number of rows for the textarea to show by default
         */ this.rows = 4;
    }
    /**
     * Handles `oninput` event on the `<input>`.
     *
     * @param event The event.
     * @param event.target The event target.
     */ _handleInput({ target }) {
        this.value = target.value;
    }
    render() {
        var _a;
        const { enableCounter, maxCount } = this;
        const textCount = (_a = this.value) === null || _a === void 0 ? void 0 : _a.length;
        const invalidIcon = (0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--text-area__invalid-icon`
        });
        const warnIcon = (0, _16JsDefault1.default)({
            class: `${(0, _settingsJs.prefix)}--text-area__invalid-icon ${(0, _settingsJs.prefix)}--text-area__invalid-icon--warning`
        });
        const textareaClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--text-area`]: true,
            [`${0, _settingsJs.prefix}--text-area--warn`]: this.warn,
            [`${0, _settingsJs.prefix}--text-area--invalid`]: this.invalid
        });
        const textareaWrapperClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--text-area__wrapper`]: true,
            [`${0, _settingsJs.prefix}--text-area__wrapper--warn`]: this.warn,
            [`${0, _settingsJs.prefix}--text-area__wrapper--readonly`]: this.readonly,
            [`${0, _settingsJs.prefix}--text-area__wrapper--slug`]: this._hasAILabel
        });
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--label`]: true,
            [`${0, _settingsJs.prefix}--label--disabled`]: this.disabled
        });
        const helperTextClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--form__helper-text`]: true,
            [`${0, _settingsJs.prefix}--form__helper-text--disabled`]: this.disabled
        });
        const counter = enableCounter && maxCount ? (0, _lit.html)` <label class="${labelClasses}">
            <slot name="label-text">${textCount}/${maxCount}</slot>
          </label>` : null;
        const icon = ()=>{
            if (this.invalid) return invalidIcon;
            else if (this.warn && !this.invalid) return warnIcon;
            return null;
        };
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--text-area__label-wrapper">
        ${this.hideLabel ? (0, _lit.html)`` : (0, _lit.html)`
              <label class="${labelClasses}" for="input">
                <slot name="label-text"> ${this.label} </slot>
              </label>
            `}
        ${counter}
      </div>
      <div class="${textareaWrapperClasses}" ?data-invalid="${this.invalid}">
        ${icon()}
        <textarea
          autocomplete="${this.autocomplete}"
          ?autofocus="${this.autofocus}"
          class="${textareaClasses}"
          cols="${(0, _ifDefinedJs.ifDefined)(this.cols)}"
          ?data-invalid="${this.invalid}"
          ?disabled="${this.disabled}"
          id="input"
          name="${(0, _ifNonEmptyJsDefault.default)(this.name)}"
          pattern="${(0, _ifNonEmptyJsDefault.default)(this.pattern)}"
          placeholder="${(0, _ifNonEmptyJsDefault.default)(this.placeholder)}"
          ?readonly="${this.readonly}"
          ?required="${this.required}"
          rows="${(0, _ifDefinedJs.ifDefined)(this.rows)}"
          .value="${this.value}"
          maxlength="${(0, _ifNonEmptyJsDefault.default)(this.maxCount)}"
          @input="${this._handleInput}"></textarea>
        <slot name="ai-label" @slotchange="${this._handleSlotChange}"></slot>
        <slot name="slug" @slotchange="${this._handleSlotChange}"></slot>
      </div>
      <div class="${helperTextClasses}" ?hidden="${this.invalid || this.warn}">
        <slot name="helper-text"> ${this.helperText} </slot>
      </div>
      <div
        class="${0, _settingsJs.prefix}--form-requirement"
        ?hidden="${!this.invalid && !this.warn}">
        <slot name="${this.invalid ? "invalid-text" : "warn-text"}">
          ${this.invalid ? this.invalidText : this.warnText}
        </slot>
      </div>
    `;
    }
};
CDSTextarea.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSTextarea.styles = (0, _textareaScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number
    })
], CDSTextarea.prototype, "cols", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTextarea.prototype, "id", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTextarea.prototype, "pattern", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTextarea.prototype, "required", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTextarea.prototype, "rows", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("textarea")
], CDSTextarea.prototype, "_textarea", void 0);
CDSTextarea = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-textarea`)
], CDSTextarea);
var CDSTextarea$1 = CDSTextarea;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/class-map.js":"2fQud","../../icons/warning--filled/16.js":"ajngV","../../icons/warning--alt--filled/16.js":"21PDf","../../globals/settings.js":"EipuL","../../globals/directives/if-non-empty.js":"5Xlqk","lit/directives/if-defined.js":"hSgrS","../text-input/text-input.js":"lBj7P","./textarea.scss.js":"cLy8g","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ajngV":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2	c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z"></path><path d="M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8	c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z" data-icon-path="inner-path" opacity="0"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"21PDf":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path fill="none" d="M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z" data-icon-path="inner-path"></path><path d="M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z"></path><path d="M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Xlqk":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ifNonEmpty);
var _ifDefinedJs = require("lit/directives/if-defined.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * A variant of `if-non-null` which stops rendering if the given value is an emptry string in addition to `null`/`undefined`.
 *
 * @param value The value.
 */ var ifNonEmpty = (value)=>(0, _ifDefinedJs.ifDefined)(value === "" ? undefined : value !== null && value !== void 0 ? value : undefined);

},{"lit/directives/if-defined.js":"hSgrS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lBj7P":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INPUT_SIZE", ()=>(0, _defsJs.INPUT_SIZE));
parcelHelpers.export(exports, "INPUT_TOOLTIP_ALIGNMENT", ()=>(0, _defsJs.INPUT_TOOLTIP_ALIGNMENT));
parcelHelpers.export(exports, "INPUT_TOOLTIP_DIRECTION", ()=>(0, _defsJs.INPUT_TOOLTIP_DIRECTION));
parcelHelpers.export(exports, "INPUT_TYPE", ()=>(0, _defsJs.INPUT_TYPE));
parcelHelpers.export(exports, "INPUT_COLOR_SCHEME", ()=>(0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME));
parcelHelpers.export(exports, "default", ()=>CDSTextInput$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _classMapJs = require("lit/directives/class-map.js");
var _settingsJs = require("../../globals/settings.js");
var _16Js = require("../../icons/view/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/view--off/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _16Js2 = require("../../icons/warning--filled/16.js");
var _16JsDefault2 = parcelHelpers.interopDefault(_16Js2);
var _16Js3 = require("../../icons/warning--alt--filled/16.js");
var _16JsDefault3 = parcelHelpers.interopDefault(_16Js3);
var _ifNonEmptyJs = require("../../globals/directives/if-non-empty.js");
var _ifNonEmptyJsDefault = parcelHelpers.interopDefault(_ifNonEmptyJs);
var _formJs = require("../../globals/mixins/form.js");
var _formJsDefault = parcelHelpers.interopDefault(_formJs);
var _validityJs = require("../../globals/mixins/validity.js");
var _validityJsDefault = parcelHelpers.interopDefault(_validityJs);
var _defsJs = require("./defs.js");
var _textInputScssJs = require("./text-input.scss.js");
var _textInputScssJsDefault = parcelHelpers.interopDefault(_textInputScssJs);
var _sharedEnumsJs = require("../../globals/shared-enums.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Text Input element. Supports all the usual attributes for textual input types
 *
 * @element cds-text-input
 * @slot helper-text - The helper text.
 * @slot label-text - The label text.
 * @slot validity-message - The validity message. If present and non-empty, this input shows the UI of its invalid state.
 */ let CDSTextInput = class CDSTextInput extends (0, _validityJsDefault.default)((0, _formJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
        /**
         * The internal value.
         */ this._value = "";
        /**
         * May be any of the standard HTML autocomplete options
         */ this.autocomplete = "";
        /**
         * Sets the input to be focussed automatically on page load. Defaults to false
         */ this.autofocus = false;
        /**
         * Controls the disabled state of the input
         */ this.disabled = false;
        /**
         * Specify whether to display the character counter
         */ this.enableCounter = false;
        /**
         * The helper text.
         */ this.helperText = "";
        /**
         * Specify if the currently value is invalid.
         */ this.invalid = false;
        /**
         * Message which is displayed if the value is invalid.
         */ this.invalidText = "";
        /**
         * Specify whether the control is currently in warning state
         */ this.warn = false;
        /**
         * Provide the text that is displayed when the control is in warning state
         */ this.warnText = "";
        /**
         * Specify whether you want the underlying label to be visually hidden
         */ this.hideLabel = false;
        /**
         * Generic label that will be used as the textual representation of what this field is for
         */ this.label = "";
        /**
         * Name for the input in the `FormData`
         */ this.name = "";
        /**
         * Pattern to validate the input against for HTML validity checking
         */ this.pattern = "";
        /**
         * Value to display when the input has an empty `value`
         */ this.placeholder = "";
        /**
         * Specify if the component should be read-only
         */ this.readonly = false;
        /**
         * Boolean property to set the required status
         */ this.required = false;
        /**
         * The special validity message for `required`.
         */ this.requiredValidityMessage = "Please fill out this field.";
        /**
         * "Hide password" tooltip text on password visibility toggle
         */ this.hidePasswordLabel = "Hide password";
        /**
         * "Show password" tooltip text on password visibility toggle
         */ this.showPasswordLabel = "Show password";
        /**
         * Boolean property to render password visibility toggle
         */ this.showPasswordVisibilityToggle = false;
        /**
         * The input box size.
         */ this.size = (0, _defsJs.INPUT_SIZE).MEDIUM;
        /**
         * true to use the inline version.
         */ this.inline = false;
        /**
         * Specify the alignment of the tooltip to the icon-only button.
         * Can be one of: start, center, or end.
         */ this.tooltipAlignment = (0, _defsJs.INPUT_TOOLTIP_ALIGNMENT).CENTER;
        /**
         * Specify the direction of the tooltip for icon-only buttons.
         * Can be either top, right, bottom, or left.
         */ this.tooltipDirection = (0, _defsJs.INPUT_TOOLTIP_DIRECTION).BOTTOM;
        /**
         * The type of the input. Can be one of the types listed in the INPUT_TYPE enum
         */ this.type = (0, _defsJs.INPUT_TYPE).TEXT;
        /**
         * The validity message. If present and non-empty, this input shows the UI of its invalid state.
         */ this.validityMessage = "";
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || // remove reference to slug in v12
            elem.matches(this.constructor.slugItem) : false);
        this._hasAILabel = Boolean(hasContent);
        hasContent[0].setAttribute("size", "mini");
        this.requestUpdate();
    }
    /**
     * Handles `oninput` event on the `<input>`.
     *
     * @param event The event.
     * @param event.target The event target.
     */ _handleInput({ target }) {
        this.value = target.value;
    }
    _handleFormdata(event) {
        const { formData } = event; // TODO: Wait for `FormDataEvent` being available in `lib.dom.d.ts`
        const { disabled, name, value } = this;
        if (!disabled) formData.append(name, value);
    }
    /**
     * The value of the input.
     */ get value() {
        // FIXME: Figure out how to deal with TS2611
        // once we have the input we can directly query for the value
        if (this._input) return this._input.value;
        // but before then _value will work fine
        return this._value;
    }
    set value(value) {
        const oldValue = this._value;
        this._value = value;
        // make sure that lit-element updates the right properties
        this.requestUpdate("value", oldValue);
        // we set the value directly on the input (when available)
        // so that programatic manipulation updates the UI correctly
        if (this._input) this._input.value = value;
    }
    /**
     * Handles password visibility toggle button click
     */ handleTogglePasswordVisibility() {
        this.type = this.type === (0, _defsJs.INPUT_TYPE).PASSWORD ? (0, _defsJs.INPUT_TYPE).TEXT : (0, _defsJs.INPUT_TYPE).PASSWORD;
    }
    render() {
        const { disabled, enableCounter, helperText, hideLabel, inline, invalid, invalidText, label, maxCount, readonly, required, size, type, warn, warnText, value, _handleInput: handleInput, _hasAILabel: hasAILabel, _handleSlotChange: handleSlotChange } = this;
        const invalidIcon = (0, _16JsDefault2.default)({
            class: `${(0, _settingsJs.prefix)}--text-input__invalid-icon`
        });
        const warnIcon = (0, _16JsDefault3.default)({
            class: `${(0, _settingsJs.prefix)}--text-input__invalid-icon ${(0, _settingsJs.prefix)}--text-input__invalid-icon--warning`
        });
        const normalizedProps = {
            disabled: !readonly && disabled,
            invalid: !readonly && invalid,
            warn: !readonly && !invalid && warn,
            "slot-name": "",
            "slot-text": "",
            icon: null
        };
        if (normalizedProps.invalid) {
            normalizedProps.icon = invalidIcon;
            normalizedProps["slot-name"] = "invalid-text";
            normalizedProps["slot-text"] = invalidText;
        } else if (normalizedProps.warn) {
            normalizedProps.icon = warnIcon;
            normalizedProps["slot-name"] = "warn-text";
            normalizedProps["slot-text"] = warnText;
        }
        const counterClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--label`]: true,
            [`${0, _settingsJs.prefix}--text-input__label-counter`]: true,
            [`${0, _settingsJs.prefix}--label--disabled`]: disabled
        });
        const inputWrapperClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--form-item`]: true,
            [`${0, _settingsJs.prefix}--text-input-wrapper`]: true,
            [`${0, _settingsJs.prefix}--text-input-wrapper--inline`]: inline,
            [`${0, _settingsJs.prefix}--text-input-wrapper--readonly`]: readonly,
            [`${0, _settingsJs.prefix}--text-input-wrapper--inline--invalid`]: inline && normalizedProps.invalid
        });
        const inputClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--text-input`]: true,
            [`${0, _settingsJs.prefix}--text-input--invalid`]: normalizedProps.invalid,
            [`${0, _settingsJs.prefix}--text-input--warning`]: normalizedProps.warn,
            [`${0, _settingsJs.prefix}--text-input--${size}`]: size,
            [`${0, _settingsJs.prefix}--layout--size-${size}`]: size,
            [`${0, _settingsJs.prefix}--password-input`]: type === (0, _defsJs.INPUT_TYPE).PASSWORD
        });
        const fieldOuterWrapperClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--text-input__field-outer-wrapper`]: true,
            [`${0, _settingsJs.prefix}--text-input__field-outer-wrapper--inline`]: inline
        });
        const fieldWrapperClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--text-input__field-wrapper`]: true,
            [`${0, _settingsJs.prefix}--text-input__field-wrapper--warning`]: normalizedProps.warn,
            [`${0, _settingsJs.prefix}--text-input__field-wrapper--slug`]: hasAILabel
        });
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--label`]: true,
            [`${0, _settingsJs.prefix}--visually-hidden`]: hideLabel,
            [`${0, _settingsJs.prefix}--label--disabled`]: normalizedProps.disabled
        });
        const helperTextClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--form__helper-text`]: true,
            [`${0, _settingsJs.prefix}--form__helper-text--disabled`]: normalizedProps.disabled
        });
        const passwordIsVisible = type !== (0, _defsJs.INPUT_TYPE).PASSWORD;
        const passwordVisibilityIcon = passwordIsVisible ? (0, _16JsDefault1.default)({
            class: `${(0, _settingsJs.prefix)}--icon-visibility-off`
        }) : (0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--icon-visibility-on`
        });
        const passwordVisibilityToggleClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--text-input--password__visibility__toggle`]: true,
            [`${0, _settingsJs.prefix}--btn`]: true,
            [`${0, _settingsJs.prefix}--btn--icon-only`]: true,
            [`${0, _settingsJs.prefix}--tooltip__trigger`]: true,
            [`${0, _settingsJs.prefix}--tooltip--a11y`]: true,
            [`${0, _settingsJs.prefix}--btn--disabled`]: normalizedProps.disabled,
            [`${0, _settingsJs.prefix}--tooltip--${this.tooltipDirection}`]: this.tooltipDirection,
            [`${0, _settingsJs.prefix}--tooltip--align-${this.tooltipAlignment}`]: this.tooltipAlignment
        });
        const passwordButtonLabel = (0, _lit.html)`
      <span class="${(0, _settingsJs.prefix)}--assistive-text">
        ${passwordIsVisible ? this.hidePasswordLabel : this.showPasswordLabel}
      </span>
    `;
        const passwordVisibilityButton = ()=>(0, _lit.html)`
      <button
        type="button"
        class="${passwordVisibilityToggleClasses}"
        ?disabled="${normalizedProps.disabled}"
        @click="${this.handleTogglePasswordVisibility}">
        ${!normalizedProps.disabled ? passwordButtonLabel : null}
        ${passwordVisibilityIcon}
      </button>
    `;
        const textCount = value === null || value === void 0 ? void 0 : value.length;
        const counter = enableCounter && maxCount ? (0, _lit.html)` <label class="${counterClasses}">
            <slot name="label-text">${textCount}/${maxCount}</slot>
          </label>` : null;
        const labelText = label && !hideLabel ? (0, _lit.html)`<label class="${labelClasses}"> ${label} </label>` : null;
        const labelWrapper = (0, _lit.html)`<div class="${(0, _settingsJs.prefix)}--text-input__label-wrapper">
      ${labelText} ${counter}
    </div>`;
        const helper = helperText ? (0, _lit.html)`<div
          class="${helperTextClasses}"
          id="helper-text"
          ?hidden="${normalizedProps.invalid || normalizedProps.warn}">
          <slot name="helper-text"> ${helperText} </slot>
        </div>` : null;
        return (0, _lit.html)`
      <div class="${inputWrapperClasses}">
        ${!inline ? labelWrapper : (0, _lit.html)`<div class="${0, _settingsJs.prefix}--text-input__label-helper-wrapper">
              ${labelWrapper} ${helper}
            </div>`}
        <div class="${fieldOuterWrapperClasses}">
          <div class="${fieldWrapperClasses}" ?data-invalid="${invalid}">
            ${normalizedProps.icon}
            <input
              autocomplete="${this.autocomplete}"
              ?autofocus="${this.autofocus}"
              class="${inputClasses}"
              ?data-invalid="${invalid}"
              ?disabled="${disabled}"
              aria-describedby="helper-text"
              id="input"
              name="${(0, _ifNonEmptyJsDefault.default)(this.name)}"
              pattern="${(0, _ifNonEmptyJsDefault.default)(this.pattern)}"
              placeholder="${(0, _ifNonEmptyJsDefault.default)(this.placeholder)}"
              ?readonly="${readonly}"
              ?required="${required}"
              type="${(0, _ifNonEmptyJsDefault.default)(type)}"
              .value="${this._value}"
              maxlength="${(0, _ifNonEmptyJsDefault.default)(maxCount)}"
              @input="${handleInput}" />
            <slot name="ai-label" @slotchange="${handleSlotChange}"></slot>
            <slot name="slug" @slotchange="${handleSlotChange}"></slot>
            ${this.showPasswordVisibilityToggle && (type === (0, _defsJs.INPUT_TYPE).PASSWORD || type === (0, _defsJs.INPUT_TYPE).TEXT) ? passwordVisibilityButton() : null}
          </div>
          ${!inline ? helper : null}
          <div
            class="${0, _settingsJs.prefix}--form-requirement"
            ?hidden="${!normalizedProps.invalid && !normalizedProps.warn}">
            <slot name="${normalizedProps["slot-name"]}">
              ${normalizedProps["slot-text"]}
            </slot>
          </div>
        </div>
      </div>
    `;
    }
    updated() {
        var _a, _b, _c, _d, _e;
        const label = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("slot[name='ai-label']");
        if (label) label === null || label === void 0 || label.classList.toggle(`${(0, _settingsJs.prefix)}--slug--revert`, (_b = this.querySelector(`${(0, _settingsJs.prefix)}-ai-label`)) === null || _b === void 0 ? void 0 : _b.hasAttribute("revert-active"));
        else (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("slot[name='slug']")) === null || _d === void 0 || _d.classList.toggle(`${(0, _settingsJs.prefix)}--slug--revert`, (_e = this.querySelector(`${(0, _settingsJs.prefix)}-slug`)) === null || _e === void 0 ? void 0 : _e.hasAttribute("revert-active"));
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
};
CDSTextInput.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSTextInput.styles = (0, _textInputScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("input")
], CDSTextInput.prototype, "_input", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTextInput.prototype, "autocomplete", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSTextInput.prototype, "autofocus", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTextInput.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "enable-counter",
        reflect: true
    })
], CDSTextInput.prototype, "enableCounter", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "helper-text"
    })
], CDSTextInput.prototype, "helperText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTextInput.prototype, "invalid", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "invalid-text"
    })
], CDSTextInput.prototype, "invalidText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        attribute: "max-count",
        reflect: true
    })
], CDSTextInput.prototype, "maxCount", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTextInput.prototype, "warn", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "warn-text"
    })
], CDSTextInput.prototype, "warnText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "hide-label",
        type: Boolean,
        reflect: true
    })
], CDSTextInput.prototype, "hideLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label"
    })
], CDSTextInput.prototype, "label", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTextInput.prototype, "name", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTextInput.prototype, "pattern", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTextInput.prototype, "placeholder", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTextInput.prototype, "readonly", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTextInput.prototype, "required", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "required-validity-message"
    })
], CDSTextInput.prototype, "requiredValidityMessage", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTextInput.prototype, "hidePasswordLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTextInput.prototype, "showPasswordLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "show-password-visibility-toggle",
        reflect: true
    })
], CDSTextInput.prototype, "showPasswordVisibilityToggle", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTextInput.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTextInput.prototype, "inline", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTextInput.prototype, "tooltipAlignment", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTextInput.prototype, "tooltipDirection", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTextInput.prototype, "type", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "validity-message"
    })
], CDSTextInput.prototype, "validityMessage", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTextInput.prototype, "value", null);
CDSTextInput = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-text-input`)
], CDSTextInput);
var CDSTextInput$1 = CDSTextInput;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","lit/directives/class-map.js":"2fQud","../../globals/settings.js":"EipuL","../../icons/view/16.js":"lfVBT","../../icons/view--off/16.js":"auGg3","../../icons/warning--filled/16.js":"ajngV","../../icons/warning--alt--filled/16.js":"21PDf","../../globals/directives/if-non-empty.js":"5Xlqk","../../globals/mixins/form.js":"kISjL","../../globals/mixins/validity.js":"6QCpZ","./defs.js":"83oMb","./text-input.scss.js":"eXxnm","../../globals/shared-enums.js":"12kea","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lfVBT":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M15.5,7.8C14.3,4.7,11.3,2.6,8,2.5C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3c1.2,3.1,4.1,5.2,7.5,5.3	c3.3-0.1,6.3-2.2,7.5-5.3C15.5,8.1,15.5,7.9,15.5,7.8z M8,12.5c-2.7,0-5.4-2-6.5-4.5c1-2.5,3.8-4.5,6.5-4.5s5.4,2,6.5,4.5	C13.4,10.5,10.6,12.5,8,12.5z"></path><path d="M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z M8,10c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S9.1,10,8,10z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"auGg3":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M2.6,11.3l0.7-0.7C2.6,9.8,1.9,9,1.5,8c1-2.5,3.8-4.5,6.5-4.5c0.7,0,1.4,0.1,2,0.4l0.8-0.8C9.9,2.7,9,2.5,8,2.5	C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3C1,9.3,1.7,10.4,2.6,11.3z"></path><path d="M6 7.9c.1-1 .9-1.8 1.8-1.8l.9-.9C7.2 4.7 5.5 5.6 5.1 7.2 5 7.7 5 8.3 5.1 8.8L6 7.9zM15.5 7.8c-.6-1.5-1.6-2.8-2.9-3.7L15 1.7 14.3 1 1 14.3 1.7 15l2.6-2.6c1.1.7 2.4 1 3.7 1.1 3.3-.1 6.3-2.2 7.5-5.3C15.5 8.1 15.5 7.9 15.5 7.8zM10 8c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.3L9.7 7C9.9 7.3 10 7.6 10 8zM8 12.5c-1 0-2.1-.3-3-.8l1.3-1.3c1.4.9 3.2.6 4.2-.8.7-1 .7-2.4 0-3.4l1.4-1.4c1.1.8 2 1.9 2.6 3.2C13.4 10.5 10.6 12.5 8 12.5z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kISjL":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FormMixin);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param Base The base class.
 * @returns A mix-in to handle `formdata` event on the containing form.
 */ const FormMixin = (Base)=>{
    /**
     * A mix-in class to handle `formdata` event on the containing form.
     */ class FormMixinImpl extends Base {
        constructor(){
            super(...arguments);
            /**
             * The handle for `formdata` event listener on the containing form.
             *
             * @private
             */ this._hFormdata = null; // Not using TypeScript `private` due to: microsoft/TypeScript#17744
        }
        connectedCallback() {
            // @ts-ignore
            super.connectedCallback();
            const form = this.closest("form");
            if (form) this._hFormdata = (0, _onJsDefault.default)(form, "formdata", this._handleFormdata.bind(this));
        }
        disconnectedCallback() {
            if (this._hFormdata) this._hFormdata = this._hFormdata.release();
            // @ts-ignore
            super.disconnectedCallback();
        }
    }
    return FormMixinImpl;
};

},{"./on.js":"hYHF3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6QCpZ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Form validation status.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VALIDATION_STATUS", ()=>VALIDATION_STATUS);
parcelHelpers.export(exports, "default", ()=>ValidityMixin);
var VALIDATION_STATUS;
(function(VALIDATION_STATUS) {
    /**
     * One indicating no validation error.
     */ VALIDATION_STATUS["NO_ERROR"] = "";
    /**
     * One indicating missing required value.
     */ VALIDATION_STATUS["ERROR_REQUIRED"] = "required";
})(VALIDATION_STATUS || (VALIDATION_STATUS = {}));
/**
 * @param Base The base class.
 * @returns A mix-in implementing `.setCustomValidity()` method.
 */ const ValidityMixin = (Base)=>{
    class ValidityMixinImpl extends Base {
        // Not using TypeScript `protected` due to: microsoft/TypeScript#17744
        // Using `string` instead of `VALIDATION_STATUS` until we can require TypeScript 3.8
        /**
         * @param state The form validation status.
         * @returns The form validation error messages associated with the given status.
         * @protected
         */ _getValidityMessage(state) {
            return ({
                [VALIDATION_STATUS.NO_ERROR]: "",
                [VALIDATION_STATUS.ERROR_REQUIRED]: this.requiredValidityMessage
            })[state];
        }
        // Not using TypeScript `protected` due to: microsoft/TypeScript#17744
        // Using `string` instead of `VALIDATION_STATUS` until we can require TypeScript 3.8
        /**
         * Checks if the value meets the constraints.
         *
         * @returns `VALIDATION_STATUS.NO_ERROR` if the value meets the constraints. Some other values otherwise.
         * @protected
         */ _testValidity() {
            const { required, value } = this;
            return required && !value ? VALIDATION_STATUS.ERROR_REQUIRED : VALIDATION_STATUS.NO_ERROR;
        }
        /**
         * Checks if the value meets the constraints.
         * Fires cancelable `invalid` event if it doesn't.
         *
         * @returns `true` if the value meets the constraints. `false` otherwise.
         */ checkValidity() {
            const status = this._testValidity();
            if (status !== VALIDATION_STATUS.NO_ERROR) {
                if (this.dispatchEvent(new CustomEvent("invalid", {
                    bubbles: false,
                    cancelable: true,
                    composed: false
                }))) {
                    this.invalid = true;
                    this.validityMessage = this._getValidityMessage(status);
                }
                return false;
            }
            this.invalid = false;
            this.validityMessage = "";
            return true;
        }
        /**
         * Sets the given custom validity message.
         *
         * @param validityMessage The custom validity message
         */ setCustomValidity(validityMessage) {
            this.invalid = Boolean(validityMessage);
            this.validityMessage = validityMessage;
        }
    }
    return ValidityMixinImpl;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"83oMb":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INPUT_COLOR_SCHEME", ()=>(0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME));
parcelHelpers.export(exports, "INPUT_SIZE", ()=>INPUT_SIZE);
parcelHelpers.export(exports, "INPUT_TOOLTIP_ALIGNMENT", ()=>INPUT_TOOLTIP_ALIGNMENT);
parcelHelpers.export(exports, "INPUT_TOOLTIP_DIRECTION", ()=>INPUT_TOOLTIP_DIRECTION);
parcelHelpers.export(exports, "INPUT_TYPE", ()=>INPUT_TYPE);
var _sharedEnumsJs = require("../../globals/shared-enums.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Input size.
 */ var INPUT_SIZE;
(function(INPUT_SIZE) {
    /**
     * Small size.
     */ INPUT_SIZE["SMALL"] = "sm";
    /**
     * Regular size, same as medium size.
     */ INPUT_SIZE["MEDIUM"] = "md";
    /**
     * Large size.
     */ INPUT_SIZE["LARGE"] = "lg";
    // TODO: deprecate
    /**
     * Extra large size.
     */ INPUT_SIZE["EXTRA_LARGE"] = "xl";
})(INPUT_SIZE || (INPUT_SIZE = {}));
/**
 * Input tooltop alignment
 */ var INPUT_TOOLTIP_ALIGNMENT;
(function(INPUT_TOOLTIP_ALIGNMENT) {
    /**
     * Small size.
     */ INPUT_TOOLTIP_ALIGNMENT["START"] = "start";
    /**
     * Regular size, same as medium size.
     */ INPUT_TOOLTIP_ALIGNMENT["CENTER"] = "center";
    /**
     * Large size.
     */ INPUT_TOOLTIP_ALIGNMENT["END"] = "end";
})(INPUT_TOOLTIP_ALIGNMENT || (INPUT_TOOLTIP_ALIGNMENT = {}));
/**
 * Input tooltop direction
 */ var INPUT_TOOLTIP_DIRECTION;
(function(INPUT_TOOLTIP_DIRECTION) {
    /**
     * Small size.
     */ INPUT_TOOLTIP_DIRECTION["TOP"] = "top";
    /**
     * Regular size, same as medium size.
     */ INPUT_TOOLTIP_DIRECTION["RIGHT"] = "right";
    /**
     * Large size.
     */ INPUT_TOOLTIP_DIRECTION["BOTTOM"] = "bottom";
    /**
     * Regular size, same as medium size.
     */ INPUT_TOOLTIP_DIRECTION["LEFT"] = "left";
})(INPUT_TOOLTIP_DIRECTION || (INPUT_TOOLTIP_DIRECTION = {}));
/**
 * Supported input types.
 *
 * For this component we only support textual types
 */ var INPUT_TYPE;
(function(INPUT_TYPE) {
    INPUT_TYPE["EMAIL"] = "email";
    INPUT_TYPE["PASSWORD"] = "password";
    INPUT_TYPE["TEL"] = "tel";
    INPUT_TYPE["TEXT"] = "text";
    INPUT_TYPE["URL"] = "url";
})(INPUT_TYPE || (INPUT_TYPE = {}));

},{"../../globals/shared-enums.js":"12kea","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"12kea":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Color scheme for form elements.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FORM_ELEMENT_COLOR_SCHEME", ()=>FORM_ELEMENT_COLOR_SCHEME);
var FORM_ELEMENT_COLOR_SCHEME;
(function(FORM_ELEMENT_COLOR_SCHEME) {
    /**
     * Regular color scheme.
     */ FORM_ELEMENT_COLOR_SCHEME["REGULAR"] = "";
    /**
     * Light color scheme.
     */ FORM_ELEMENT_COLOR_SCHEME["LIGHT"] = "light";
})(FORM_ELEMENT_COLOR_SCHEME || (FORM_ELEMENT_COLOR_SCHEME = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eXxnm":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));background-color:var(--cds-field);block-size:var(--cds-layout-size-height-local);border:none;border-block-end:1px solid var(--cds-border-strong);box-sizing:border-box;color:var(--cds-text-primary,#161616);font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:2px solid transparent;outline-offset:-2px;padding:0;padding:0 var(--cds-layout-density-padding-inline-local);transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--text-input *,.cds--text-input :after,.cds--text-input :before{box-sizing:inherit}.cds--text-input:active,.cds--text-input:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input:active,.cds--text-input:focus{outline-style:dotted}}.cds--text-input-wrapper svg[hidden]{display:none}.cds--password-input{padding-inline-end:2.5rem}.cds--text-input--sm.cds--password-input{padding-inline-end:2rem}.cds--text-input--lg.cds--password-input{padding-inline-end:3rem}.cds--text-input::-moz-placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input::placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input--light{background-color:var(--cds-field-02,#fff)}.cds--text-input__field-wrapper{display:flex;inline-size:100%;position:relative}.cds--text-input__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:1rem;transform:translateY(-50%)}.cds--text-input__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--text-input__invalid-icon--warning path:first-of-type{fill:#000;opacity:1}.cds--text-input--password__visibility{align-items:center;cursor:pointer;display:inline-flex;overflow:visible;position:relative}.cds--text-input--password__visibility:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus{outline-style:dotted}}.cds--text-input--password__visibility:focus{outline:1px solid transparent}.cds--text-input--password__visibility:focus svg{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus svg{outline-style:dotted}}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{align-items:center;display:flex;opacity:0;pointer-events:none;position:absolute;z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{display:inline-block}}.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:opacity 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:none}}.cds--text-input--password__visibility.cds--tooltip--a11y:after,.cds--text-input--password__visibility.cds--tooltip--a11y:before{transition:none}.cds--text-input--password__visibility:before{block-size:0;border-style:solid;content:"";inline-size:0}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text{box-sizing:content-box;color:inherit;opacity:1;white-space:normal;word-break:break-word}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);max-inline-size:13rem;min-inline-size:1.5rem;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-accelerator:true){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{border:1px solid transparent}}.cds--text-input--password__visibility:after{content:attr(aria-label)}.cds--text-input--password__visibility.cds--tooltip--a11y:after{content:none}.cds--text-input--password__visibility.cds--tooltip--visible:after,.cds--text-input--password__visibility.cds--tooltip--visible:before,.cds--text-input--password__visibility:focus:after,.cds--text-input--password__visibility:focus:before,.cds--text-input--password__visibility:hover:after,.cds--text-input--password__visibility:hover:before{opacity:1}@keyframes cds--tooltip-fade{0%{opacity:0}to{opacity:1}}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text{margin:auto;overflow:visible;clip:auto}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible.cds--tooltip--a11y:before,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:focus.cds--tooltip--a11y:before,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text,.cds--text-input--password__visibility:hover.cds--tooltip--a11y:before{animation:cds--tooltip-fade 70ms cubic-bezier(.2,0,.38,.9)}.cds--text-input--password__visibility.cds--tooltip--hidden .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--hidden+.cds--assistive-text{margin:-1px;overflow:hidden;clip:rect(0,0,0,0)}.cds--text-input--password__visibility.cds--tooltip--hidden.cds--tooltip--a11y:before{animation:none;opacity:0}.cds--text-input--password__visibility .cds--assistive-text:after{block-size:.75rem;content:"";display:block;inline-size:100%;inset-block-start:-.75rem;inset-inline-start:0;position:absolute}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{inset-block-end:0;inset-inline-start:50%}.cds--text-input--password__visibility:before{border-color:transparent transparent var(--cds-background-inverse,#393939);border-width:0 .25rem .3125rem;inset-block-end:-.5rem;transform:translate(-50%,100%)}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inset-block-end:-.8125rem;transform:translate(-50%,100%)}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{align-items:center;background:none;block-size:100%;border:0;cursor:pointer;display:flex;inline-size:2.5rem;inset-inline-end:0;justify-content:center;min-block-size:auto;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--toggle-password-tooltip .cds--popover{inset-inline-start:-2.5rem}.cds--toggle-password-tooltip .cds--popover-content{min-inline-size:2.5rem}.cds--text-input--sm+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:2rem}.cds--text-input--lg+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:3rem}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252);transition:fill 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:ButtonText}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline-style:dotted}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus svg,.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-primary,#161616)}.cds--text-input--invalid,.cds--text-input--warning{padding-inline-end:2.5rem}.cds--text-input--invalid.cds--password-input{padding-inline-end:4rem}.cds--text-input--invalid+.cds--text-input--password__visibility__toggle{inset-inline-end:1rem}.cds--password-input-wrapper .cds--text-input__invalid-icon{inset-inline-end:2.5rem}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{cursor:not-allowed}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg:hover{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input__counter-alert{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px}.cds--text-input:disabled{background-color:var(--cds-field);border-block-end:1px solid transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;outline:2px solid transparent;outline-offset:-2px;-webkit-text-fill-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input--light:disabled{background-color:var(--cds-field-02,#fff)}.cds--text-input:disabled::-moz-placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input:disabled::placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input--invalid{box-shadow:none;outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input--invalid{outline-style:dotted}}.cds--text-input--invalid .cds--text-input--password__visibility__toggle{inset-inline-end:2.5rem}.cds--skeleton.cds--text-input{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;padding:0;pointer-events:none;position:relative}.cds--skeleton.cds--text-input:active,.cds--skeleton.cds--text-input:focus,.cds--skeleton.cds--text-input:hover{border:none;cursor:default;outline:none}.cds--skeleton.cds--text-input:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--skeleton.cds--text-input:before{animation:none}}.cds--form--fluid .cds--text-input-wrapper{background:var(--cds-field);position:relative;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--form--fluid .cds--label{align-items:center;block-size:1rem;display:flex;inset-block-start:.8125rem;inset-inline-start:1rem;margin:0;position:absolute;z-index:1}.cds--form--fluid .cds--form__helper-text{display:none}.cds--form--fluid .cds--text-input{min-block-size:4rem;padding:2rem 1rem .8125rem}.cds--form--fluid .cds--text-input__divider,.cds--text-input__divider{display:none}.cds--form--fluid .cds--text-input--invalid,.cds--form--fluid .cds--text-input--warning{border-block-end:none}.cds--form--fluid .cds--text-input--invalid+.cds--text-input__divider,.cds--form--fluid .cds--text-input--warning+.cds--text-input__divider{border-color:var(--cds-border-subtle);border-style:solid;border-block-end:none;display:block;margin:0 1rem}.cds--form--fluid .cds--text-input__invalid-icon{inset-block-start:5rem}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid{outline:none}.cds--form--fluid .cds--text-input__field-wrapper--warning{border-block-end:1px solid var(--cds-border-strong)}.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning:focus,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:focus{outline:none}.cds--text-input-wrapper.cds--text-input-wrapper--inline{flex-flow:row wrap}.cds--text-input-wrapper .cds--label--inline{flex:1;margin:.8125rem 0 0;overflow-wrap:break-word;word-break:break-word}.cds--text-input-wrapper .cds--label--inline--sm{margin-block-start:.5625rem}.cds--text-input-wrapper .cds--label--inline--lg{margin-block-start:1.0625rem}.cds--text-input__label-helper-wrapper{flex:2;flex-direction:column;margin-inline-end:1.5rem;max-inline-size:8rem;overflow-wrap:break-word}.cds--text-input-wrapper .cds--form__helper-text--inline{margin-block-start:.125rem}.cds--text-input__field-outer-wrapper{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;inline-size:100%}.cds--text-input__field-outer-wrapper--inline{flex:8;flex-direction:column}.cds--text-input-wrapper--inline .cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--text-input-wrapper--inline--invalid .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input-wrapper--readonly,.cds--text-input-wrapper--readonly .cds--text-input{background:transparent;border-block-end-color:var(--cds-border-subtle)}.cds--text-input__field-wrapper .cds--ai-label,.cds--text-input__field-wrapper .cds--slug,.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator>*{inset-block-start:50%;inset-inline-end:1rem;position:absolute;transform:translateY(-50%)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label):not(:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug):not(:has(~.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug){padding-inline-end:2.5rem}.cds--text-input--invalid:has(~.cds--ai-label),.cds--text-input--invalid:has(~.cds--slug),.cds--text-input--invalid:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input--warning:has(~.cds--ai-label),.cds--text-input--warning:has(~.cds--slug),.cds--text-input--warning:has(~.cds--text-input__field-inner-wrapper--decorator>*){padding-inline-end:4rem}.cds--text-input--invalid~.cds--ai-label,.cds--text-input--invalid~.cds--slug,.cds--text-input--invalid~.cds--text-input__field-inner-wrapper--decorator>*,.cds--text-input--warning~.cds--ai-label,.cds--text-input--warning~.cds--slug,.cds--text-input--warning~.cds--text-input__field-inner-wrapper--decorator>*{inset-inline-end:2.5rem}.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator:not(:has(.cds--ai-label))>*{block-size:1rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:ButtonText}}.cds--text-input__label-wrapper{display:flex;inline-size:100%;justify-content:space-between}.cds--text-input__label-wrapper .cds--text-input__label-counter{align-self:end}:host(cds-text-input){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;inline-size:100%;outline:none}:host(cds-text-input) ::slotted(cds-ai-label),:host(cds-text-input) ::slotted(cds-slug){inset-block-start:50%;inset-inline-end:1rem;position:absolute}:host(cds-text-input) ::slotted(cds-ai-label:not([revert-active])),:host(cds-text-input) ::slotted(cds-slug:not([revert-active])){transform:translateY(-50%)}:host(cds-text-input[show-password-visibility-toggle]) .cds--text-input{padding-inline-end:2.5rem}:host(cds-text-input[show-password-visibility-toggle])[size=sm] .cds--text-input__invalid-icon{inset-inline-end:2rem}:host(cds-text-input[show-password-visibility-toggle])[size=md] .cds--text-input__invalid-icon{inset-inline-end:2rem}:host(cds-text-input[show-password-visibility-toggle])[size=lg] .cds--text-input__invalid-icon{inset-inline-end:2rem}:host(cds-text-input[invalid]) .cds--text-input__field-wrapper--slug .cds--text-input,:host(cds-text-input[warn]) .cds--text-input__field-wrapper--slug .cds--text-input{padding-inline-end:4rem}:host(cds-text-input[invalid]) ::slotted(cds-ai-label),:host(cds-text-input[invalid]) ::slotted(cds-slug),:host(cds-text-input[warn]) ::slotted(cds-ai-label),:host(cds-text-input[warn]) ::slotted(cds-slug){inset-inline-end:2.5rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cLy8g":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-area{background-color:var(--cds-field);block-size:100%;border:none;border-block-end:1px solid var(--cds-border-strong);box-sizing:border-box;color:var(--cds-text-primary,#161616);font-family:inherit;font-size:100%;font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);margin:0;min-block-size:2.5rem;min-inline-size:10rem;outline:2px solid transparent;outline-offset:-2px;padding:0;padding:.6875rem var(--cds-layout-density-padding-inline-local);resize:vertical;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--text-area *,.cds--text-area :after,.cds--text-area :before{box-sizing:inherit}.cds--text-area:active,.cds--text-area:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-area:active,.cds--text-area:focus{outline-style:dotted}}.cds--text-area::-moz-placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);opacity:1}.cds--text-area::placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);opacity:1}.cds--text-area--light{background-color:var(--cds-field-02,#fff)}.cds--text-area--invalid{padding-inline-end:2.5rem}.cds--text-area__wrapper{--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));display:flex;inline-size:100%;max-inline-size:100%;position:relative}.cds--text-area__wrapper--cols{inline-size:auto}.cds--text-area__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:.75rem;inset-inline-end:var(--cds-layout-density-padding-inline-local)}.cds--text-area__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--text-area__invalid-icon--warning path[fill]{fill:#000;opacity:1}.cds--text-area__counter-alert{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px}.cds--text-area:disabled{background-color:var(--cds-field);border-block-end:1px solid transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;outline:none;resize:none}.cds--text-area:disabled::-moz-placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-area:disabled::placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-area__wrapper--readonly .cds--text-area{background:transparent;border-block-end-color:var(--cds-border-subtle)}.cds--text-area__wrapper--decorator .cds--text-area__inner-wrapper--decorator>*,.cds--text-area__wrapper--slug .cds--ai-label,.cds--text-area__wrapper--slug .cds--slug{inset-block-start:.75rem;inset-inline-end:1rem;position:absolute}.cds--text-area__wrapper--decorator .cds--ai-label.cds--ai-label--revert,.cds--text-area__wrapper--slug .cds--ai-label.cds--ai-label--revert,.cds--text-area__wrapper--slug .cds--slug.cds--slug--revert{inset-block-start:.25rem;inset-inline-end:.5rem;transform:translate(0)}.cds--text-area__wrapper--decorator .cds--text-area:has(~.cds--text-area__inner-wrapper--decorator .cds--ai-label):not(:has(~.cds--text-area__inner-wrapper--decorator .cds--ai-label--revert)),.cds--text-area__wrapper--slug .cds--text-area:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--text-area__wrapper--slug .cds--text-area:has(~.cds--slug):not(:has(~.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff)}.cds--text-area__wrapper--decorator .cds--text-area:has(~.cds--text-area__inner-wrapper--decorator>*),.cds--text-area__wrapper--slug .cds--text-area:has(~.cds--ai-label),.cds--text-area__wrapper--slug .cds--text-area:has(~.cds--slug){padding-inline-end:2.5rem}.cds--text-area--invalid:has(~.cds--ai-label),.cds--text-area--invalid:has(~.cds--slug),.cds--text-area--invalid:has(~.cds--text-area__inner-wrapper--decorator>*),.cds--text-area--warn:has(~.cds--ai-label),.cds--text-area--warn:has(~.cds--slug),.cds--text-area--warn:has(~.cds--text-area__inner-wrapper--decorator>*){padding-inline-end:4rem}.cds--text-area--invalid~.cds--ai-label,.cds--text-area--invalid~.cds--slug,.cds--text-area--invalid~.cds--text-area__inner-wrapper--decorator>*,.cds--text-area--warn~.cds--ai-label,.cds--text-area--warn~.cds--slug,.cds--text-area--warn~.cds--text-area__inner-wrapper--decorator>*{inset-inline-end:2.5rem}.cds--text-area--invalid~.cds--ai-label.cds--ai-label--revert,.cds--text-area--invalid~.cds--slug.cds--slug--revert,.cds--text-area--warn~.cds--ai-label.cds--ai-label--revert,.cds--text-area--warn~.cds--slug.cds--slug--revert{inset-inline-end:2rem}.cds--text-area.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:6.25rem;border:none;box-shadow:none;inline-size:100%;padding:0;pointer-events:none;position:relative}.cds--text-area.cds--skeleton:active,.cds--text-area.cds--skeleton:focus,.cds--text-area.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--text-area.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--text-area.cds--skeleton:before{animation:none}}.cds--text-area.cds--skeleton::-moz-placeholder{color:transparent}.cds--text-area.cds--skeleton::placeholder{color:transparent}.cds--text-area__label-wrapper{display:flex;inline-size:100%;justify-content:space-between}:host(cds-textarea){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;outline:none}:host(cds-textarea) ::slotted(cds-ai-label),:host(cds-textarea) ::slotted(cds-slug){inset-block-start:.75rem;inset-inline-end:1rem;position:absolute}:host(cds-textarea) ::slotted(cds-ai-label[revert-active]),:host(cds-textarea) ::slotted(cds-slug[revert-active]){inset-block-start:.25rem;inset-inline-end:.5rem;transform:translate(0)}:host(cds-textarea) textarea:not([cols]),:host(cds-textarea) textarea[cols="0"],:host(cds-textarea:not([cols])),:host(cds-textarea[cols="0"]){inline-size:100%}:host(cds-textarea[invalid]) .cds--text-area__wrapper--slug .cds--text-area,:host(cds-textarea[warn]) .cds--text-area__wrapper--slug .cds--text-area{padding-inline-end:4rem}:host(cds-textarea[invalid]) ::slotted(cds-ai-label),:host(cds-textarea[invalid]) ::slotted(cds-slug),:host(cds-textarea[warn]) ::slotted(cds-ai-label),:host(cds-textarea[warn]) ::slotted(cds-slug){inset-inline-end:2.5rem}:host(cds-textarea[invalid]) ::slotted(cds-ai-label[revert-active]),:host(cds-textarea[invalid]) ::slotted(cds-slug[revert-active]),:host(cds-textarea[warn]) ::slotted(cds-ai-label[revert-active]),:host(cds-textarea[warn]) ::slotted(cds-slug[revert-active]){inset-inline-end:2rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6xCq6":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTextareaSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _textareaScssJs = require("./textarea.scss.js");
var _textareaScssJsDefault = parcelHelpers.interopDefault(_textareaScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of text area.
 */ let CDSTextareaSkeleton = class CDSTextareaSkeleton extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)`
      <span class="${0, _settingsJs.prefix}--label ${0, _settingsJs.prefix}--skeleton"></span>
      <div class="${0, _settingsJs.prefix}--skeleton ${0, _settingsJs.prefix}--text-area"></div>
    `;
    }
};
CDSTextareaSkeleton.styles = (0, _textareaScssJsDefault.default);
CDSTextareaSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-textarea-skeleton`)
], CDSTextareaSkeleton);
var CDSTextareaSkeleton$1 = CDSTextareaSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./textarea.scss.js":"cLy8g","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Wp6j":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _tagJs = require("./tag.js");

},{"./tag.js":"36hMn"}],"36hMn":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TAG_SIZE", ()=>(0, _defsJs.TAG_SIZE));
parcelHelpers.export(exports, "TAG_TYPE", ()=>(0, _defsJs.TAG_TYPE));
parcelHelpers.export(exports, "default", ()=>CDSTag$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _16Js = require("../../icons/close/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _defsJs = require("./defs.js");
var _tagScssJs = require("./tag.scss.js");
var _tagScssJsDefault = parcelHelpers.interopDefault(_tagScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Tag.
 *
 * @fires cds-tag-beingclosed - The custom event fired as the element is being closed
 * @fires cds-tag-closed - The custom event fired after the element has been closed
 */ let CDSTag = class CDSTag extends (0, _hostListenerJsDefault1.default)((0, _focusJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * Handles `click` event on this element.
         *
         * @param event The event.
         */ this._handleClick = (event)=>{
            if (event.composedPath().indexOf(this._buttonNode) >= 0) {
                if (this.disabled) event.stopPropagation();
                else if (this.open) {
                    const init = {
                        bubbles: true,
                        cancelable: true,
                        composed: true,
                        detail: {
                            triggeredBy: event.target
                        }
                    };
                    if (this.dispatchEvent(new CustomEvent(this.constructor.eventBeforeClose, init))) {
                        this.open = false;
                        this.dispatchEvent(new CustomEvent(this.constructor.eventClose, init));
                    }
                }
            }
        };
        /**
         * Text to show on filter tag "clear" buttons. Corresponds to the attribute with the same name
         */ this.title = "Clear filter";
        /**
         * `true` if the tag should be disabled
         */ this.disabled = false;
        this.hasCustomIcon = false;
        /**
         * Determine if is a filter/chip
         */ this.filter = false;
        /**
         * `true` if the tag should be open.
         */ this.open = true;
        /**
         * The size of the tag.
         */ this.size = (0, _defsJs.TAG_SIZE).MEDIUM;
        /**
         * The type of the tag.
         */ this.type = (0, _defsJs.TAG_TYPE).GRAY;
    }
    /**
     * Handles `slotchange` event.
     */ _handleAILabelSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || // remove reference of slug in v12
            elem.matches(this.constructor.slugItem) : false);
        if (hasContent.length > 0) {
            hasContent[0].setAttribute("tag", `${this.type}`);
            hasContent[0].setAttribute("size", "sm");
            hasContent[0].setAttribute("kind", "inline");
        }
        this.requestUpdate();
    }
    render() {
        const { disabled, filter, _handleAILabelSlotChange: handleAILabelSlotChange, title } = this;
        return (0, _lit.html)`
      <slot name="icon"></slot>
      <slot></slot>
      <slot name="ai-label" @slotchange="${handleAILabelSlotChange}"></slot>
      <slot name="slug" @slotchange="${handleAILabelSlotChange}"></slot>
      ${filter ? (0, _lit.html)`
            <button class="${0, _settingsJs.prefix}--tag__close-icon" ?disabled=${disabled}>
              ${(0, _16JsDefault.default)({
            "aria-label": title
        })}
            </button>
          ` : ``}
    `;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
    /**
     * The name of the custom event fired before this tag is being closed upon a user gesture.
     * Cancellation of this event stops the user-initiated action of closing this tag.
     */ static get eventBeforeClose() {
        return `${0, _settingsJs.prefix}-tag-beingclosed`;
    }
    /**
     * The name of the custom event fired after this tag is closed upon a user gesture.
     */ static get eventClose() {
        return `${0, _settingsJs.prefix}-tag-closed`;
    }
};
CDSTag.styles = (0, _tagScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("button")
], CDSTag.prototype, "_buttonNode", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("shadowRoot:click")
], CDSTag.prototype, "_handleClick", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        reflect: true
    })
], CDSTag.prototype, "title", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTag.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSTag.prototype, "hasCustomIcon", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTag.prototype, "filter", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTag.prototype, "open", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTag.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTag.prototype, "type", void 0);
CDSTag = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-tag`)
], CDSTag);
var CDSTag$1 = CDSTag;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/close/16.js":"b7Sho","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/host-listener.js":"1SMUX","./defs.js":"ioe2X","./tag.scss.js":"h2qDr","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ioe2X":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Tag size.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TAG_SIZE", ()=>TAG_SIZE);
parcelHelpers.export(exports, "TAG_TYPE", ()=>TAG_TYPE);
var TAG_SIZE;
(function(TAG_SIZE) {
    /**
     * Medium size (default).
     */ TAG_SIZE["MEDIUM"] = "md";
    /**
     * Small size.
     */ TAG_SIZE["SMALL"] = "sm";
})(TAG_SIZE || (TAG_SIZE = {}));
var TAG_TYPE;
(function(TAG_TYPE) {
    /**
     * Red color.
     */ TAG_TYPE["RED"] = "red";
    /**
     * Magenta color.
     */ TAG_TYPE["MAGENTA"] = "magenta";
    /**
     * Purple color.
     */ TAG_TYPE["PURPLE"] = "purple";
    /**
     * Blue color.
     */ TAG_TYPE["BLUE"] = "blue";
    /**
     * Cyan color.
     */ TAG_TYPE["CYAN"] = "cyan";
    /**
     * Teal color.
     */ TAG_TYPE["TEAL"] = "teal";
    /**
     * Green color.
     */ TAG_TYPE["GREEN"] = "green";
    /**
     * Gray color.
     */ TAG_TYPE["GRAY"] = "gray";
    /**
     * Cool gray color.
     */ TAG_TYPE["COOL-GRAY"] = "cool-gray";
    /**
     * Warn gray color.
     */ TAG_TYPE["WARM-GRAY"] = "warm-gray";
})(TAG_TYPE || (TAG_TYPE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h2qDr":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm,:host(cds-tag[size=sm]){--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md,:host(cds-tag){--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--tag,:host(cds-tag){--cds-layout-size-height-xs:1.125rem;--cds-layout-size-height-sm:1.125rem;--cds-layout-size-height-md:1.5rem;--cds-layout-size-height-lg:2rem;--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));align-items:center;background-color:var(--cds-tag-background-gray,#e0e0e0);border-radius:1rem;color:var(--cds-tag-color-gray,#161616);cursor:default;display:inline-flex;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem;max-inline-size:13rem;min-block-size:var(--cds-layout-size-height-local);min-inline-size:2rem;padding-inline:.5rem;vertical-align:middle;word-break:break-word}.cds--layout--size-xs .cds--tag,.cds--layout--size-xs :host(cds-tag){--cds-layout-size-height:var(--cds-layout-size-height-xs)}.cds--layout--size-sm .cds--tag,.cds--layout--size-sm :host(cds-tag),:host(cds-tag[size=sm]) .cds--tag,:host(cds-tag[size=sm]) :host(cds-tag){--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--tag,.cds--layout--size-md :host(cds-tag),:host(cds-tag) .cds--tag,:host(cds-tag) :host(cds-tag){--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--tag,.cds--layout--size-lg :host(cds-tag){--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--tag.cds--tag--operational{border:1px solid var(--cds-tag-background-gray,#e0e0e0)}.cds--tag.cds--tag--operational:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1)}.cds--tag .cds--tag__close-icon:hover,:host(cds-tag) .cds--tag__close-icon:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1)}.cds--tag.cds--tag--lg{padding-inline-start:.75rem}.cds--tag:has(.cds--tag__custom-icon,:host(cds-tag) ::slotted([slot=icon])),:has(.cds--tag__custom-icon,:host(cds-tag) ::slotted([slot=icon])):host(cds-tag){padding-inline-start:.25rem}.cds--tag.cds--tag--lg:not(.cds--tag--filter){padding-inline:.75rem}.cds--tag.cds--tag--lg:has(.cds--tag__custom-icon,:host(cds-tag) ::slotted([slot=icon])){padding-inline-start:.5rem}.cds--tag:not(.cds--tag--selectable),:not(.cds--tag--selectable):host(cds-tag){border:0}.cds--tag:not(:first-child),:not(:first-child):host(cds-tag){margin-inline-start:0}.cds--tag--operational>span,.cds--tag--selectable>span,.cds--tag__label{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cds--tag--interactive:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--tag--filter,:host(cds-tag[filter]){padding-block:0;padding-inline-end:0}.cds--tag--filter:hover{outline:none}.cds--tag--selectable{background-color:var(--cds-layer);border:1px solid var(--cds-border-inverse,#161616);color:var(--cds-text-primary,#161616);cursor:pointer}.cds--tag--selectable:hover{background-color:var(--cds-layer-hover);outline:none}.cds--tag--selectable:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--tag--selectable-selected{color:var(--cds-text-inverse,#fff)}.cds--tag--selectable-selected,.cds--tag--selectable-selected:hover{background-color:var(--cds-layer-selected-inverse,#161616)}.cds--tag--operational{background-color:var(--cds-tag-background-gray,#e0e0e0);border:1px solid var(--cds-tag-border-gray,#a8a8a8);color:var(--cds-tag-color-gray,#161616);cursor:pointer}.cds--tag--operational:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1);outline:none}.cds--tag--operational:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--tag--red,:host(cds-tag[type=red]){background-color:var(--cds-tag-background-red,#ffd7d9);color:var(--cds-tag-color-red,#a2191f)}.cds--tag--red.cds--tag--operational{border:1px solid var(--cds-tag-border-red,#ff8389)}.cds--tag--red.cds--tag--operational:hover{background-color:var(--cds-tag-hover-red,#ffc2c5)}.cds--tag--red .cds--tag__close-icon:hover,:host(cds-tag[type=red]) .cds--tag__close-icon:hover{background-color:var(--cds-tag-hover-red,#ffc2c5)}.cds--tag--magenta,:host(cds-tag[type=magenta]){background-color:var(--cds-tag-background-magenta,#ffd6e8);color:var(--cds-tag-color-magenta,#9f1853)}.cds--tag--magenta.cds--tag--operational{border:1px solid var(--cds-tag-border-magenta,#ff7eb6)}.cds--tag--magenta.cds--tag--operational:hover{background-color:var(--cds-tag-hover-magenta,#ffbdda)}.cds--tag--magenta .cds--tag__close-icon:hover,:host(cds-tag[type=magenta]) .cds--tag__close-icon:hover{background-color:var(--cds-tag-hover-magenta,#ffbdda)}.cds--tag--purple,:host(cds-tag[type=purple]){background-color:var(--cds-tag-background-purple,#e8daff);color:var(--cds-tag-color-purple,#6929c4)}.cds--tag--purple.cds--tag--operational{border:1px solid var(--cds-tag-border-purple,#be95ff)}.cds--tag--purple.cds--tag--operational:hover{background-color:var(--cds-tag-hover-purple,#dcc7ff)}.cds--tag--purple .cds--tag__close-icon:hover,:host(cds-tag[type=purple]) .cds--tag__close-icon:hover{background-color:var(--cds-tag-hover-purple,#dcc7ff)}.cds--tag--blue,:host(cds-tag[type=blue]){background-color:var(--cds-tag-background-blue,#d0e2ff);color:var(--cds-tag-color-blue,#0043ce)}.cds--tag--blue.cds--tag--operational{border:1px solid var(--cds-tag-border-blue,#78a9ff)}.cds--tag--blue.cds--tag--operational:hover{background-color:var(--cds-tag-hover-blue,#b8d3ff)}.cds--tag--blue .cds--tag__close-icon:hover,:host(cds-tag[type=blue]) .cds--tag__close-icon:hover{background-color:var(--cds-tag-hover-blue,#b8d3ff)}.cds--tag--cyan,:host(cds-tag[type=cyan]){background-color:var(--cds-tag-background-cyan,#bae6ff);color:var(--cds-tag-color-cyan,#00539a)}.cds--tag--cyan.cds--tag--operational{border:1px solid var(--cds-tag-border-cyan,#33b1ff)}.cds--tag--cyan.cds--tag--operational:hover{background-color:var(--cds-tag-hover-cyan,#99daff)}.cds--tag--cyan .cds--tag__close-icon:hover,:host(cds-tag[type=cyan]) .cds--tag__close-icon:hover{background-color:var(--cds-tag-hover-cyan,#99daff)}.cds--tag--teal,:host(cds-tag[type=teal]){background-color:var(--cds-tag-background-teal,#9ef0f0);color:var(--cds-tag-color-teal,#005d5d)}.cds--tag--teal.cds--tag--operational{border:1px solid var(--cds-tag-border-teal,#08bdba)}.cds--tag--teal.cds--tag--operational:hover{background-color:var(--cds-tag-hover-teal,#57e5e5)}.cds--tag--teal .cds--tag__close-icon:hover,:host(cds-tag[type=teal]) .cds--tag__close-icon:hover{background-color:var(--cds-tag-hover-teal,#57e5e5)}.cds--tag--green,:host(cds-tag[type=green]){background-color:var(--cds-tag-background-green,#a7f0ba);color:var(--cds-tag-color-green,#0e6027)}.cds--tag--green.cds--tag--operational{border:1px solid var(--cds-tag-border-green,#42be65)}.cds--tag--green.cds--tag--operational:hover{background-color:var(--cds-tag-hover-green,#74e792)}.cds--tag--green .cds--tag__close-icon:hover,:host(cds-tag[type=green]) .cds--tag__close-icon:hover{background-color:var(--cds-tag-hover-green,#74e792)}.cds--tag--gray,:host(cds-tag[type=gray]){background-color:var(--cds-tag-background-gray,#e0e0e0);color:var(--cds-tag-color-gray,#161616)}.cds--tag--gray.cds--tag--operational{border:1px solid var(--cds-tag-border-gray,#a8a8a8)}.cds--tag--gray.cds--tag--operational:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1)}.cds--tag--gray .cds--tag__close-icon:hover,:host(cds-tag[type=gray]) .cds--tag__close-icon:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1)}.cds--tag--cool-gray,:host(cds-tag[type=cool-gray]){background-color:var(--cds-tag-background-cool-gray,#dde1e6);color:var(--cds-tag-color-cool-gray,#121619)}.cds--tag--cool-gray.cds--tag--operational{border:1px solid var(--cds-tag-border-cool-gray,#a2a9b0)}.cds--tag--cool-gray.cds--tag--operational:hover{background-color:var(--cds-tag-hover-cool-gray,#cdd3da)}.cds--tag--cool-gray .cds--tag__close-icon:hover,:host(cds-tag[type=cool-gray]) .cds--tag__close-icon:hover{background-color:var(--cds-tag-hover-cool-gray,#cdd3da)}.cds--tag--warm-gray,:host(cds-tag[type=warm-gray]){background-color:var(--cds-tag-background-warm-gray,#e5e0df);color:var(--cds-tag-color-warm-gray,#171414)}.cds--tag--warm-gray.cds--tag--operational{border:1px solid var(--cds-tag-border-warm-gray,#ada8a8)}.cds--tag--warm-gray.cds--tag--operational:hover{background-color:var(--cds-tag-hover-warm-gray,#d8d0cf)}.cds--tag--warm-gray .cds--tag__close-icon:hover,:host(cds-tag[type=warm-gray]) .cds--tag__close-icon:hover{background-color:var(--cds-tag-hover-warm-gray,#d8d0cf)}.cds--tag--high-contrast:not(.cds--tag--operational),:not(.cds--tag--operational):host(cds-tag[type=high-contrast]){background-color:var(--cds-background-inverse,#393939);color:var(--cds-text-inverse,#fff)}.cds--tag--high-contrast:not(.cds--tag--operational).cds--tag--operational{border:1px solid var(--cds-background-inverse,#393939)}.cds--tag--high-contrast:not(.cds--tag--operational).cds--tag--operational:hover{background-color:var(--cds-background-inverse-hover,#474747)}.cds--tag--high-contrast:not(.cds--tag--operational) .cds--tag__close-icon:hover,:not(.cds--tag--operational):host(cds-tag[type=high-contrast]) .cds--tag__close-icon:hover{background-color:var(--cds-background-inverse-hover,#474747)}.cds--multi-select--readonly .cds--tag--high-contrast:not(.cds--tag--operational) .cds--tag__close-icon:hover,.cds--multi-select--readonly :not(.cds--tag--operational):host(cds-tag[type=high-contrast]) .cds--tag__close-icon:hover{background-color:transparent}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]),:not(.cds--tag--operational):not(span):not([disabled]):host(cds-tag[type=outline]){background-color:var(--cds-background,#fff);color:var(--cds-text-primary,#161616);outline:1px solid var(--cds-background-inverse,#393939);outline-offset:-1px}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]).cds--tag--operational{border:1px solid var(--cds-background,#fff)}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]).cds--tag--operational:hover{background-color:var(--cds-layer-hover)}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]) .cds--tag__close-icon:hover,:not(.cds--tag--operational):not(span):not([disabled]):host(cds-tag[type=outline]) .cds--tag__close-icon:hover{background-color:var(--cds-layer-hover)}.cds--tag--disabled:not(.cds--tag--operational),.cds--tag--filter.cds--tag--disabled,.cds--tag--interactive.cds--tag--disabled,:host(cds-tag[filter]):host(cds-tag[disabled]),:not(.cds--tag--operational):host(cds-tag[disabled]){background-color:var(--cds-layer);box-shadow:none;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--tag--disabled:not(.cds--tag--operational).cds--tag--operational,.cds--tag--filter.cds--tag--disabled.cds--tag--operational,.cds--tag--interactive.cds--tag--disabled.cds--tag--operational{border:1px solid var(--cds-layer)}.cds--tag--disabled:not(.cds--tag--operational).cds--tag--operational:hover,.cds--tag--filter.cds--tag--disabled.cds--tag--operational:hover,.cds--tag--interactive.cds--tag--disabled.cds--tag--operational:hover{background-color:var(--cds-layer)}.cds--tag--disabled:not(.cds--tag--operational) .cds--tag__close-icon:hover,.cds--tag--filter.cds--tag--disabled .cds--tag__close-icon:hover,.cds--tag--interactive.cds--tag--disabled .cds--tag__close-icon:hover,:host(cds-tag[filter]):host(cds-tag[disabled]) .cds--tag__close-icon:hover,:not(.cds--tag--operational):host(cds-tag[disabled]) .cds--tag__close-icon:hover{background-color:var(--cds-layer)}.cds--tag--disabled:not(.cds--tag--operational):hover,.cds--tag--filter.cds--tag--disabled:hover,.cds--tag--interactive.cds--tag--disabled:hover{cursor:not-allowed}.cds--tag--disabled:not(.cds--tag--operational) .cds--tag__label,.cds--tag--filter.cds--tag--disabled .cds--tag__label,.cds--tag--interactive.cds--tag--disabled .cds--tag__label,:host(cds-tag[filter]):host(cds-tag[disabled]) .cds--tag__label,:not(.cds--tag--operational):host(cds-tag[disabled]) .cds--tag__label{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--tag--operational.cds--tag--disabled,.cds--tag--selectable.cds--tag--disabled{background-color:var(--cds-layer);border:1px solid var(--cds-border-disabled,#c6c6c6);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--tag--operational.cds--tag--disabled:hover,.cds--tag--selectable.cds--tag--disabled:hover{background-color:var(--cds-layer);cursor:not-allowed}.cds--tag--interactive{transition:background-color 70ms cubic-bezier(0,0,.38,.9)}.cds--tag__close-icon{align-items:center;background-color:transparent;block-size:var(--cds-layout-size-height-local);border:0;border-radius:50%;color:currentColor;cursor:pointer;display:flex;flex-shrink:0;inline-size:var(--cds-layout-size-height-local);justify-content:center;margin:0 0 0 .125rem;padding:0;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),box-shadow 70ms cubic-bezier(.2,0,.38,.9)}.cds--tag__close-icon svg{fill:currentColor}.cds--tag__custom-icon,:host(cds-tag) ::slotted([slot=icon]){background-color:transparent;block-size:1rem;border:0;color:currentColor;flex-shrink:0;inline-size:1rem;margin-inline-end:.25rem;outline:none;padding:0}.cds--tag__custom-icon svg,:host(cds-tag) ::slotted([slot=icon]) svg{fill:currentColor}.cds--tag--disabled .cds--tag__close-icon,:host(cds-tag[disabled]) .cds--tag__close-icon{cursor:not-allowed}.cds--tag__close-icon:focus{border-radius:50%;box-shadow:inset 0 0 0 1px var(--cds-focus,#0f62fe);outline:none;z-index:99999}.cds--tag--high-contrast .cds--tag__close-icon:focus,:host(cds-tag[type=high-contrast]) .cds--tag__close-icon:focus{box-shadow:inset 0 0 0 1px var(--cds-focus-inverse,#fff)}.cds--tag--filter.cds--tag--disabled .cds--tag__close-icon:hover,:host(cds-tag[filter]):host(cds-tag[disabled]) .cds--tag__close-icon:hover{background-color:transparent}.cds--tag--filter.cds--tag--disabled svg,:host(cds-tag[filter]):host(cds-tag[disabled]) svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--tag--sm.cds--tag--filter,:host(cds-tag[size=sm]):host(cds-tag[filter]){padding-inline-end:0}.cds--tag--sm .cds--tag__close-icon,:host(cds-tag[size=sm]) .cds--tag__close-icon{margin-inline-start:.3125rem}.cds--tag.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);background-color:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;color:var(--cds-text-primary,#161616);inline-size:3.75rem;overflow:hidden;padding:0;pointer-events:none;position:relative}.cds--tag.cds--skeleton:active,.cds--tag.cds--skeleton:focus,.cds--tag.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--tag.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--tag.cds--skeleton:before{animation:none}}.cds--tag.cds--skeleton.cds--tag--operational{border:1px solid var(--cds-skeleton-background,#e8e8e8)}.cds--tag.cds--skeleton .cds--tag__close-icon:hover,.cds--tag.cds--skeleton.cds--tag--operational:hover{background-color:var(--cds-skeleton-background,#e8e8e8)}@media not all and (min-resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){.cds--tag.cds--skeleton{transform:translateZ(0)}}}.cds--tag .cds--ai-label .cds--ai-label__button--inline,.cds--tag .cds--slug .cds--slug__button--inline,:host(cds-tag) .cds--ai-label .cds--ai-label__button--inline,:host(cds-tag) .cds--slug .cds--slug__button--inline{color:currentColor;margin-inline-start:.0625rem}.cds--tag .cds--ai-label .cds--ai-label__button--inline .cds--ai-label__text:before,.cds--tag .cds--slug .cds--slug__button--inline .cds--slug__text:before,:host(cds-tag) .cds--ai-label .cds--ai-label__button--inline .cds--ai-label__text:before,:host(cds-tag) .cds--slug .cds--slug__button--inline .cds--slug__text:before{background-color:currentColor}.cds--tag .cds--ai-label .cds--ai-label__button--inline:hover,.cds--tag .cds--slug .cds--slug__button--inline:hover,:host(cds-tag) .cds--ai-label .cds--ai-label__button--inline:hover,:host(cds-tag) .cds--slug .cds--slug__button--inline:hover{border-color:currentColor}.cds--tag--filter .cds--ai-label,.cds--tag--filter .cds--slug,.cds--tag--filter .cds--tag__decorator>*,:host(cds-tag[filter]) .cds--ai-label,:host(cds-tag[filter]) .cds--slug,:host(cds-tag[filter]) .cds--tag__decorator>*{min-inline-size:2.00875rem}.cds--tag .cds--tag__decorator:not(:has(.cds--ai-label)),:host(cds-tag) .cds--tag__decorator:not(:has(.cds--ai-label)){block-size:1rem;text-align:center}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--tag,:host(cds-tag){outline:1px solid transparent}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--tag__close-icon svg,.cds--tag__custom-icon svg,:host(cds-tag) ::slotted([slot=icon]) svg{fill:ButtonText}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--tag__close-icon:focus{color:Highlight;outline:1px solid Highlight}}.cds--tag-label-tooltip{max-inline-size:-webkit-fill-available}.cds--tag__custom-icon+.cds--tag-label-tooltip,:host(cds-tag) ::slotted([slot=icon])+.cds--tag-label-tooltip{max-inline-size:11rem}.cds--tag--filter .cds--tag__custom-icon+.cds--tag-label-tooltip,:host(cds-tag) .cds--tag--filter ::slotted([slot=icon])+.cds--tag-label-tooltip,:host(cds-tag):host(cds-tag[filter]) ::slotted([slot=icon])+.cds--tag-label-tooltip,:host(cds-tag[filter]) .cds--tag__custom-icon+.cds--tag-label-tooltip{max-inline-size:9.875rem}.cds--interactive--tag-children{display:inline-flex;max-inline-size:12.5rem;place-items:center}.cds--tag--filter .cds--tag__custom-icon+span>.cds--interactive--tag-children,:host(cds-tag) .cds--tag--filter ::slotted([slot=icon])+span>.cds--interactive--tag-children,:host(cds-tag):host(cds-tag[filter]) ::slotted([slot=icon])+span>.cds--interactive--tag-children,:host(cds-tag[filter]) .cds--tag__custom-icon+span>.cds--interactive--tag-children{max-inline-size:11.5rem}.cds--tag .cds--definition-term,:host(cds-tag) .cds--definition-term{border-block-end:none;cursor:default;max-inline-size:12rem}.cds--tag .cds--tag__custom-icon+span>.cds--definition-term,:host(cds-tag) .cds--tag__custom-icon+span>.cds--definition-term,:host(cds-tag) ::slotted([slot=icon])+span>.cds--definition-term{max-inline-size:11rem}.cds--tag>.cds--popover-container,:host(cds-tag)>.cds--popover-container{display:flex}.cds--toggletip-button:has(.cds--tag--operational.cds--tag--disabled){pointer-events:none}:host(cds-tag){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;--cds-layout-size-height-xs:1.125rem;--cds-layout-size-height-sm:1.125rem;--cds-layout-size-height-md:1.5rem}:host(cds-tag[size=sm]) .cds--tag__close-icon{block-size:1.125rem;inline-size:1.125rem;margin-inline-start:.3125rem}:host(cds-tag[filter]){display:none}:host(cds-tag[filter][size=sm]){padding-inline-end:0}:host(cds-tag[filter][open]){display:inline-flex}:host(cds-tag[filter][disabled]) .cds--tag__close-icon{cursor:not-allowed}:host(cds-tag[filter][disabled]) .cds--tag__close-icon,:host(cds-tag[filter][disabled]) .cds--tag__close-icon:hover{background-color:transparent}:host(cds-tag.cds--skeleton){background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:3.75rem;overflow:hidden;padding:0;pointer-events:none;position:relative}:host(cds-tag.cds--skeleton):active,:host(cds-tag.cds--skeleton):focus,:host(cds-tag.cds--skeleton):hover{border:none;cursor:default;outline:none}:host(cds-tag.cds--skeleton):before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){:host(cds-tag.cds--skeleton):before{animation:none}}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4fHNP":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z"></path><path d="M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"blgFb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqHotkeyService", ()=>PdqHotkeyService);
parcelHelpers.export(exports, "pdqHotkeyService", ()=>pdqHotkeyService);
var _replaySubject = require("../observable/ReplaySubject");
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PdqHotkeyService_showPdqData, _PdqHotkeyService_showPdqModel;
class PdqHotkeyService {
    constructor(){
        _PdqHotkeyService_showPdqData.set(this, new (0, _replaySubject.ReplaySubject)(1));
        _PdqHotkeyService_showPdqModel.set(this, new (0, _replaySubject.ReplaySubject)(1));
        this.toggled = false;
        this.showPdqData = (0, _replaySubject.distinct)(__classPrivateFieldGet(this, _PdqHotkeyService_showPdqData, "f"));
        this.showPdqModel = (0, _replaySubject.distinct)(__classPrivateFieldGet(this, _PdqHotkeyService_showPdqModel, "f"));
        document.addEventListener("keydown", (e)=>{
            if (e.altKey) __classPrivateFieldGet(this, _PdqHotkeyService_showPdqData, "f").next(true);
            if (e.altKey && e.ctrlKey) this.toggleView();
            if (e.altKey && e.shiftKey) this.toggleModel();
        });
        document.addEventListener("keyup", (e)=>{
            if (!this.toggled) __classPrivateFieldGet(this, _PdqHotkeyService_showPdqData, "f").next(false);
        });
    }
    toggleView() {
    // this.toggled = !this.toggled;
    // this.#showPdqData.next(this.toggled)
    }
    toggleModel() {
    //this.#showPdqModel.next(!this.#showPdqModel.currentValue())
    }
}
_PdqHotkeyService_showPdqData = new WeakMap(), _PdqHotkeyService_showPdqModel = new WeakMap();
const pdqHotkeyService = new PdqHotkeyService();
exports.default = pdqHotkeyService;

},{"../observable/ReplaySubject":"k5r8V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"66yqo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// no-op decorator
parcelHelpers.export(exports, "pdqDiscoveryLayer", ()=>pdqDiscoveryLayer);
var _lit = require("lit");
function pdqDiscoveryLayer(log, icon, name, color, tagColor) {
    return function(constructor) {
        class DecoratedClass extends constructor {
            constructor(){
                super(...arguments);
                this.showPdqDataSubscription = undefined;
            }
            renderToolBar(template = (0, _lit.nothing)) {
                return 0, _lit.nothing;
            }
            toggleVisible() {
            // donothing
            }
        }
        return DecoratedClass;
    };
}
 /*
export function pdqDiscoveryLayer <T extends Constructor<PdqDiscoverable>>(
  log: Debug.Debugger,
  icon: CarbonIcon,
  name: string,
  color: string,
  tagColor: TAG_TYPE
): (constructor: T) => T {
  return function (constructor: T): T {
    class DecoratedClass extends constructor implements PdqDiscoverable {
      protected showPdqDataSubscription: undefined|(() => void) = undefined;

      static get styles() {
        const originalStyles = super.styles as any;
        // Combine original styles with the injected styles
        return [originalStyles, row, col, grow, center, padding, marginAll,
          css`
          :host {
              border: solid 1px transparent;
          }
          :host(.config-layer-active) {
            display: block;
            border: solid 1px ${unsafeCSS(color)};
          }
          :host(.config-layer-active) .show {
              background: ${unsafeCSS(color)}
          }
          .toolbar {
            background: rgba(0,0,0, 0.1)
          }
        `];
      }
      connectedCallback() {
        super.connectedCallback();
        this.showPdqDataSubscription = pdqHotkeyService.showPdqData.subscribe((show: boolean) => {
          if(show) {
            this.classList.add('config-layer-active')
          } else {
            this.classList.remove('config-layer-active')
          }
          this.requestUpdate()
        })
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        if (this.showPdqDataSubscription)
          this.showPdqDataSubscription()
      }

      renderToolBar(template:TemplateResult|typeof nothing = nothing){
        return html`
        <div class="row toolbar" >
          <div class="row center ml-1 mr-1">
            ${icon()}
            <cds-tag type="${tagColor}" title="">${name}#${this.id}</cds-tag>
          </div>
          <div class="grow"></div>
          <slot name="tool-bar">${template}</slot>
          <cds-copy-button feedback="Copied!" feedback-timeout="2000" @click="${() => navigator.clipboard.writeText(this.dataPreview)}">
            ${this.dataPreview}
          </cds-copy-button>
          <cds-icon-button @click="${this.toggleVisible}" kind="${this.show ?'secondary' : 'primary'}">
            ${this.show ? ViewOff16({ slot: 'icon' }) : View16({ slot: 'icon' }) }
            <span slot="tooltip-content"> Toggle Visibility </span>
          </cds-icon-button>
        </div>
      `
      }
      toggleVisible(){
        this.show = !this.show;
        log(`${this.id} - toggle`, this.show)
      }
    }

    return DecoratedClass as Constructor<PdqDiscoverable> & T;
  }
};
*/  //
 // export const PdqDiscoveryLayer = <T extends PdqDiscoverableConstructor<LitElement>>(Base: T) => {
 //   abstract class PdqDiscoveryLayerBase extends Base {
 //     abstract id: string
 //     abstract log: Debug.Debugger
 //     abstract show: boolean
 //     abstract meta:PdqDiscoverableMeta
 //     abstract requestUpdate(): () => void;
 //     abstract dataPreview: string;
 //
 //     static styles = [
 //       ...(Base as any).styles as any,
 //       row, col, grow, padding, margin
 //     ];
 //
 //     protected constructor(...args: any[]) {
 //       super(args);
 //       pdqHotkeyService.showPdqData.subscribe((show: boolean) => {this.requestUpdate()})
 //
 //     }
 //
 //     renderToolBar(){
 //       return html `
 //         <div class="row">
 //           <div>
 //             ${this.meta.icon()}
 //             <cds-tag type="${this.meta.tagColor}">${this.meta.name}#${this.id}</cds-tag>
 //           </div>
 //           <div class="grow"></div>
 //           <cds-copy-button feedback="Copied!" feedback-timeout="2000">
 //             ${JSON.stringify(this.dataPreview, null, 2)}
 //           </cds-copy-button>
 //           <cds-icon-button @click="${this.toggle}" kind="${this.show ?'secondary' : 'primary'}">
 //             ${this.show ? ViewOff16({ slot: 'icon' }) : View16({ slot: 'icon' }) }
 //             <span slot="tooltip-content"> Toggle Visibility </span>
 //           </cds-icon-button>
 //         </div>
 //       `
 //     }
 //     toggle(){
 //       this.show = !this.show;
 //       this.log(`${this.id} - toggle`, this.show)
 //     }
 //   }
 //
 //   return PdqDiscoveryLayerBase as any as PdqDiscoverableConstructor<PdqDiscoveryLayerBase> & T;
 // };

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kD6gB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NO_VALUE_OR_NO_SUBSCRIPTION_YET", ()=>NO_VALUE_OR_NO_SUBSCRIPTION_YET);
parcelHelpers.export(exports, "DataBroker", ()=>DataBroker);
parcelHelpers.export(exports, "dataBroker", ()=>dataBroker);
var _rxjs = require("rxjs");
var _utils = require("src/utils");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
const log = (0, _debugDefault.default)("pdq:services:DataBroker");
const NO_VALUE_OR_NO_SUBSCRIPTION_YET = Symbol("NO_VALUE_OR_NO_SUBSCRIPTION_YET");
class DataBroker {
    constructor(){
        this._mutex = new (0, _utils.Mutex)("DataBroker");
        this._derivations = new Map();
        this._dataSources = new Map();
        this._dataSourcesChanged = new (0, _rxjs.Subject)();
        this._dataSourceAdded = new (0, _rxjs.Subject)();
        this._dataSourceChanged = new (0, _rxjs.Subject)();
        this._dataSourceRemoved = new (0, _rxjs.Subject)();
        this.dataSourcesChanged = this._dataSourcesChanged.pipe((0, _rxjs.share)());
        this.dataSourceAdded = this._dataSourceAdded.pipe((0, _rxjs.share)());
        this.dataSourceChanged = this._dataSourceChanged.pipe((0, _rxjs.share)());
        this.dataSourceRemoved = this._dataSourceRemoved.pipe((0, _rxjs.share)());
        this.dataSourcesChanged.subscribe((i)=>log(`dataSourcesChanged:${i}`));
        this.dataSourceAdded.subscribe((i)=>log(`dataSourceAdded:${i}`));
        this.dataSourceChanged.subscribe((i)=>log(`dataSourceChanged:${i}`));
        this.dataSourceRemoved.subscribe((i)=>log(`dataSourceRemoved:${i}`));
        log("DataBroker created");
    }
    getDataSource(name) {
        const ds = this._dataSources.get(name);
        if (!ds) return undefined;
        ds.sharedObservable.pipe((0, _rxjs.take)(1)).subscribe();
        return this._dataSources.get(name)?.lastValue;
    }
    async getNextDataSourceValue(name) {
        const ds = await this.getObservableDataSource(name);
        if (this._dataSources.get(name)?.lastValue !== NO_VALUE_OR_NO_SUBSCRIPTION_YET) return new Promise((resolve, reject)=>{
            ds.pipe((0, _rxjs.skip)(1)).pipe((0, _rxjs.take)(1)).subscribe((i)=>{
                resolve(i);
            });
        });
        return new Promise((resolve, reject)=>{
            ds.pipe((0, _rxjs.take)(1)).subscribe((i)=>{
                resolve(i);
            });
        });
    }
    async getObservableDataSource(name) {
        const unlock = await this._mutex.lock();
        try {
            log(`getObservableDataSource: ${name}`);
            let ds = this._dataSources.get(name);
            if (!ds) {
                log(`getObservableDataSource: ${name} - new datasource`);
                ds = this._setupDataSource(name);
                this._dataSourcesChanged.next([
                    ...this._dataSources.keys()
                ]);
            }
            return ds.sharedObservable;
        } finally{
            unlock();
        }
    }
    async setDataSource(name, data) {
        log("setDataSource", name, data);
        let ds;
        const unlock = await this._mutex.lock();
        try {
            ds = this._dataSources.get(name);
            if (!ds) {
                ds = this._setupDataSource(name);
                this._dataSourceAdded.next(name);
                this._dataSourcesChanged.next([
                    ...this._dataSources.keys()
                ]);
            }
            ds.subject.next(data);
            this._dataSourceChanged.next(name);
        } catch (e) {
            log(`error setting datasource ${name}: ${e}`);
        } finally{
            unlock();
        }
    }
    async removeDataSource(name) {
        log(`removeDataSource: ${name}`);
        const unlock = await this._mutex.lock();
        try {
            let ds = this._dataSources.get(name);
            if (ds) {
                ds.subject.complete();
                ds.subject.unsubscribe();
                this._dataSources.delete(name);
                this._dataSourceRemoved.next(name);
                this._dataSourcesChanged.next([
                    ...this._dataSources.keys()
                ]);
            }
        } finally{
            unlock();
        }
    }
    async upsertDerivation(key, sources, fn) {
        log("upsertDerivation", key, sources, fn);
        const sourcesObs = await Promise.all(sources.map((s)=>this.getObservableDataSource(s)));
        log(`upsertDerivation: ${key} sources: ${sources}`);
        const unlock = await this._mutex.lock();
        try {
            let isNew = false;
            let ds = this._derivations.get(key);
            let dds = {
                lastValue: undefined
            };
            if (ds) ds.sourceSubscription.unsubscribe();
            else {
                isNew = true;
                const rs = this._dataSources.get(key)?.subject || new (0, _rxjs.ReplaySubject)(1);
                ds = {
                    downStream: rs,
                    downSteamSharedObservable: rs.pipe((0, _rxjs.tap)((i)=>{
                        log(`>>>>>>>>>>>> ${i}`);
                        dds.lastValue = i;
                        ds.lastValue = i;
                    }), (0, _rxjs.shareReplay)(1)),
                    lastValue: undefined
                };
            }
            const pipeline = (0, _rxjs.combineLatest)(sourcesObs).pipe((0, _rxjs.mergeMap)((i)=>{
                return (0, _rxjs.from)(fn(i));
            })); //.pipe(shareReplay(1));
            ds.sourceSubscription = pipeline.subscribe((v)=>ds.downStream.next(v));
            ds.source = pipeline;
            if (isNew) {
                this._derivations.set(key, ds);
                dds.subject = ds.downStream;
                dds.sharedObservable = ds.downSteamSharedObservable;
                this._dataSources.set(key, dds);
                log(`upsertDerivation: ${key} - new datasource`);
                this._dataSourceAdded.next(key);
                this._dataSourcesChanged.next([
                    ...this._dataSources.keys()
                ]);
            }
            this._dataSourceChanged.next(key);
            return ds.downSteamSharedObservable;
        } finally{
            unlock();
        }
    }
    async removeDerivation(key) {
        log(`removeDerivation: ${key}`);
        const unlock = await this._mutex.lock();
        try {
            const ds = this._derivations.get(key);
            if (ds) {
                ds.sourceSubscription.unsubscribe();
                ds.downStream.complete();
                ds.downStream.unsubscribe();
                this._derivations.delete(key);
                this._dataSources.delete(key);
                this._dataSources.delete(key);
                this._dataSourceRemoved.next(key);
                this._dataSourcesChanged.next([
                    ...this._dataSources.keys()
                ]);
            }
        } finally{
            unlock();
        }
    }
    info() {
        const info = [];
        for (const [key, value] of this._dataSources.entries())info.push({
            id: key,
            data: value.lastValue
        });
        console.table(info);
    }
    async addBlobToData(id, file) {
        switch(file.type){
            case "application/json":
                try {
                    const json = await (0, _utils.blobToJson)(file);
                    log(`adding json blob with ${id}`);
                    await this.setDataSource(id, json);
                } catch (ex) {
                    log(`error adding json blob ${id} ${ex}`);
                }
                break;
            default:
                log(`not transforming blob ${id} of type ${file.type} keeping it as blob.`);
                await this.setDataSource(id, file);
        }
    }
    _setupDataSource(name) {
        let meta = this._dataSources.get(name);
        if (meta) return meta;
        log(`Creating data placeholder ${name}`);
        const subject = new (0, _rxjs.ReplaySubject)(1);
        const ds = {
            subject,
            sharedObservable: subject.pipe((0, _rxjs.tap)((i)=>{
                log("setDataSource", name, i);
                ds.lastValue = i;
            }), (0, _rxjs.shareReplay)(1)),
            lastValue: NO_VALUE_OR_NO_SUBSCRIPTION_YET
        };
        this._dataSources.set(name, ds);
        return ds;
    }
}
const dataBroker = new DataBroker();

},{"rxjs":"d4Szo","src/utils":"i8jxn","debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d4Szo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>(0, _observable.Observable));
parcelHelpers.export(exports, "ConnectableObservable", ()=>(0, _connectableObservable.ConnectableObservable));
parcelHelpers.export(exports, "observable", ()=>(0, _observable1.observable));
parcelHelpers.export(exports, "animationFrames", ()=>(0, _animationFrames.animationFrames));
parcelHelpers.export(exports, "Subject", ()=>(0, _subject.Subject));
parcelHelpers.export(exports, "BehaviorSubject", ()=>(0, _behaviorSubject.BehaviorSubject));
parcelHelpers.export(exports, "ReplaySubject", ()=>(0, _replaySubject.ReplaySubject));
parcelHelpers.export(exports, "AsyncSubject", ()=>(0, _asyncSubject.AsyncSubject));
parcelHelpers.export(exports, "asap", ()=>(0, _asap.asap));
parcelHelpers.export(exports, "asapScheduler", ()=>(0, _asap.asapScheduler));
parcelHelpers.export(exports, "async", ()=>(0, _async.async));
parcelHelpers.export(exports, "asyncScheduler", ()=>(0, _async.asyncScheduler));
parcelHelpers.export(exports, "queue", ()=>(0, _queue.queue));
parcelHelpers.export(exports, "queueScheduler", ()=>(0, _queue.queueScheduler));
parcelHelpers.export(exports, "animationFrame", ()=>(0, _animationFrame.animationFrame));
parcelHelpers.export(exports, "animationFrameScheduler", ()=>(0, _animationFrame.animationFrameScheduler));
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>(0, _virtualTimeScheduler.VirtualTimeScheduler));
parcelHelpers.export(exports, "VirtualAction", ()=>(0, _virtualTimeScheduler.VirtualAction));
parcelHelpers.export(exports, "Scheduler", ()=>(0, _scheduler.Scheduler));
parcelHelpers.export(exports, "Subscription", ()=>(0, _subscription.Subscription));
parcelHelpers.export(exports, "Subscriber", ()=>(0, _subscriber.Subscriber));
parcelHelpers.export(exports, "Notification", ()=>(0, _notification.Notification));
parcelHelpers.export(exports, "NotificationKind", ()=>(0, _notification.NotificationKind));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipe.pipe));
parcelHelpers.export(exports, "noop", ()=>(0, _noop.noop));
parcelHelpers.export(exports, "identity", ()=>(0, _identity.identity));
parcelHelpers.export(exports, "isObservable", ()=>(0, _isObservable.isObservable));
parcelHelpers.export(exports, "lastValueFrom", ()=>(0, _lastValueFrom.lastValueFrom));
parcelHelpers.export(exports, "firstValueFrom", ()=>(0, _firstValueFrom.firstValueFrom));
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>(0, _argumentOutOfRangeError.ArgumentOutOfRangeError));
parcelHelpers.export(exports, "EmptyError", ()=>(0, _emptyError.EmptyError));
parcelHelpers.export(exports, "NotFoundError", ()=>(0, _notFoundError.NotFoundError));
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>(0, _objectUnsubscribedError.ObjectUnsubscribedError));
parcelHelpers.export(exports, "SequenceError", ()=>(0, _sequenceError.SequenceError));
parcelHelpers.export(exports, "TimeoutError", ()=>(0, _timeout.TimeoutError));
parcelHelpers.export(exports, "UnsubscriptionError", ()=>(0, _unsubscriptionError.UnsubscriptionError));
parcelHelpers.export(exports, "bindCallback", ()=>(0, _bindCallback.bindCallback));
parcelHelpers.export(exports, "bindNodeCallback", ()=>(0, _bindNodeCallback.bindNodeCallback));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "connectable", ()=>(0, _connectable.connectable));
parcelHelpers.export(exports, "defer", ()=>(0, _defer.defer));
parcelHelpers.export(exports, "empty", ()=>(0, _empty.empty));
parcelHelpers.export(exports, "forkJoin", ()=>(0, _forkJoin.forkJoin));
parcelHelpers.export(exports, "from", ()=>(0, _from.from));
parcelHelpers.export(exports, "fromEvent", ()=>(0, _fromEvent.fromEvent));
parcelHelpers.export(exports, "fromEventPattern", ()=>(0, _fromEventPattern.fromEventPattern));
parcelHelpers.export(exports, "generate", ()=>(0, _generate.generate));
parcelHelpers.export(exports, "iif", ()=>(0, _iif.iif));
parcelHelpers.export(exports, "interval", ()=>(0, _interval.interval));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "never", ()=>(0, _never.never));
parcelHelpers.export(exports, "of", ()=>(0, _of.of));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairs.pairs));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "range", ()=>(0, _range.range));
parcelHelpers.export(exports, "throwError", ()=>(0, _throwError.throwError));
parcelHelpers.export(exports, "timer", ()=>(0, _timer.timer));
parcelHelpers.export(exports, "using", ()=>(0, _using.using));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "scheduled", ()=>(0, _scheduled.scheduled));
parcelHelpers.export(exports, "EMPTY", ()=>(0, _empty.EMPTY));
parcelHelpers.export(exports, "NEVER", ()=>(0, _never.NEVER));
parcelHelpers.export(exports, "config", ()=>(0, _config.config));
parcelHelpers.export(exports, "audit", ()=>(0, _audit.audit));
parcelHelpers.export(exports, "auditTime", ()=>(0, _auditTime.auditTime));
parcelHelpers.export(exports, "buffer", ()=>(0, _buffer.buffer));
parcelHelpers.export(exports, "bufferCount", ()=>(0, _bufferCount.bufferCount));
parcelHelpers.export(exports, "bufferTime", ()=>(0, _bufferTime.bufferTime));
parcelHelpers.export(exports, "bufferToggle", ()=>(0, _bufferToggle.bufferToggle));
parcelHelpers.export(exports, "bufferWhen", ()=>(0, _bufferWhen.bufferWhen));
parcelHelpers.export(exports, "catchError", ()=>(0, _catchError.catchError));
parcelHelpers.export(exports, "combineAll", ()=>(0, _combineAll.combineAll));
parcelHelpers.export(exports, "combineLatestAll", ()=>(0, _combineLatestAll.combineLatestAll));
parcelHelpers.export(exports, "combineLatestWith", ()=>(0, _combineLatestWith.combineLatestWith));
parcelHelpers.export(exports, "concatAll", ()=>(0, _concatAll.concatAll));
parcelHelpers.export(exports, "concatMap", ()=>(0, _concatMap.concatMap));
parcelHelpers.export(exports, "concatMapTo", ()=>(0, _concatMapTo.concatMapTo));
parcelHelpers.export(exports, "concatWith", ()=>(0, _concatWith.concatWith));
parcelHelpers.export(exports, "connect", ()=>(0, _connect.connect));
parcelHelpers.export(exports, "count", ()=>(0, _count.count));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounce.debounce));
parcelHelpers.export(exports, "debounceTime", ()=>(0, _debounceTime.debounceTime));
parcelHelpers.export(exports, "defaultIfEmpty", ()=>(0, _defaultIfEmpty.defaultIfEmpty));
parcelHelpers.export(exports, "delay", ()=>(0, _delay.delay));
parcelHelpers.export(exports, "delayWhen", ()=>(0, _delayWhen.delayWhen));
parcelHelpers.export(exports, "dematerialize", ()=>(0, _dematerialize.dematerialize));
parcelHelpers.export(exports, "distinct", ()=>(0, _distinct.distinct));
parcelHelpers.export(exports, "distinctUntilChanged", ()=>(0, _distinctUntilChanged.distinctUntilChanged));
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>(0, _distinctUntilKeyChanged.distinctUntilKeyChanged));
parcelHelpers.export(exports, "elementAt", ()=>(0, _elementAt.elementAt));
parcelHelpers.export(exports, "endWith", ()=>(0, _endWith.endWith));
parcelHelpers.export(exports, "every", ()=>(0, _every.every));
parcelHelpers.export(exports, "exhaust", ()=>(0, _exhaust.exhaust));
parcelHelpers.export(exports, "exhaustAll", ()=>(0, _exhaustAll.exhaustAll));
parcelHelpers.export(exports, "exhaustMap", ()=>(0, _exhaustMap.exhaustMap));
parcelHelpers.export(exports, "expand", ()=>(0, _expand.expand));
parcelHelpers.export(exports, "filter", ()=>(0, _filter.filter));
parcelHelpers.export(exports, "finalize", ()=>(0, _finalize.finalize));
parcelHelpers.export(exports, "find", ()=>(0, _find.find));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndex.findIndex));
parcelHelpers.export(exports, "first", ()=>(0, _first.first));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupBy.groupBy));
parcelHelpers.export(exports, "ignoreElements", ()=>(0, _ignoreElements.ignoreElements));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmpty.isEmpty));
parcelHelpers.export(exports, "last", ()=>(0, _last.last));
parcelHelpers.export(exports, "map", ()=>(0, _map.map));
parcelHelpers.export(exports, "mapTo", ()=>(0, _mapTo.mapTo));
parcelHelpers.export(exports, "materialize", ()=>(0, _materialize.materialize));
parcelHelpers.export(exports, "max", ()=>(0, _max.max));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAll.mergeAll));
parcelHelpers.export(exports, "flatMap", ()=>(0, _flatMap.flatMap));
parcelHelpers.export(exports, "mergeMap", ()=>(0, _mergeMap.mergeMap));
parcelHelpers.export(exports, "mergeMapTo", ()=>(0, _mergeMapTo.mergeMapTo));
parcelHelpers.export(exports, "mergeScan", ()=>(0, _mergeScan.mergeScan));
parcelHelpers.export(exports, "mergeWith", ()=>(0, _mergeWith.mergeWith));
parcelHelpers.export(exports, "min", ()=>(0, _min.min));
parcelHelpers.export(exports, "multicast", ()=>(0, _multicast.multicast));
parcelHelpers.export(exports, "observeOn", ()=>(0, _observeOn.observeOn));
parcelHelpers.export(exports, "onErrorResumeNextWith", ()=>(0, _onErrorResumeNextWith.onErrorResumeNextWith));
parcelHelpers.export(exports, "pairwise", ()=>(0, _pairwise.pairwise));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluck.pluck));
parcelHelpers.export(exports, "publish", ()=>(0, _publish.publish));
parcelHelpers.export(exports, "publishBehavior", ()=>(0, _publishBehavior.publishBehavior));
parcelHelpers.export(exports, "publishLast", ()=>(0, _publishLast.publishLast));
parcelHelpers.export(exports, "publishReplay", ()=>(0, _publishReplay.publishReplay));
parcelHelpers.export(exports, "raceWith", ()=>(0, _raceWith.raceWith));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduce.reduce));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeat.repeat));
parcelHelpers.export(exports, "repeatWhen", ()=>(0, _repeatWhen.repeatWhen));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "retryWhen", ()=>(0, _retryWhen.retryWhen));
parcelHelpers.export(exports, "refCount", ()=>(0, _refCount.refCount));
parcelHelpers.export(exports, "sample", ()=>(0, _sample.sample));
parcelHelpers.export(exports, "sampleTime", ()=>(0, _sampleTime.sampleTime));
parcelHelpers.export(exports, "scan", ()=>(0, _scan.scan));
parcelHelpers.export(exports, "sequenceEqual", ()=>(0, _sequenceEqual.sequenceEqual));
parcelHelpers.export(exports, "share", ()=>(0, _share.share));
parcelHelpers.export(exports, "shareReplay", ()=>(0, _shareReplay.shareReplay));
parcelHelpers.export(exports, "single", ()=>(0, _single.single));
parcelHelpers.export(exports, "skip", ()=>(0, _skip.skip));
parcelHelpers.export(exports, "skipLast", ()=>(0, _skipLast.skipLast));
parcelHelpers.export(exports, "skipUntil", ()=>(0, _skipUntil.skipUntil));
parcelHelpers.export(exports, "skipWhile", ()=>(0, _skipWhile.skipWhile));
parcelHelpers.export(exports, "startWith", ()=>(0, _startWith.startWith));
parcelHelpers.export(exports, "subscribeOn", ()=>(0, _subscribeOn.subscribeOn));
parcelHelpers.export(exports, "switchAll", ()=>(0, _switchAll.switchAll));
parcelHelpers.export(exports, "switchMap", ()=>(0, _switchMap.switchMap));
parcelHelpers.export(exports, "switchMapTo", ()=>(0, _switchMapTo.switchMapTo));
parcelHelpers.export(exports, "switchScan", ()=>(0, _switchScan.switchScan));
parcelHelpers.export(exports, "take", ()=>(0, _take.take));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLast.takeLast));
parcelHelpers.export(exports, "takeUntil", ()=>(0, _takeUntil.takeUntil));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhile.takeWhile));
parcelHelpers.export(exports, "tap", ()=>(0, _tap.tap));
parcelHelpers.export(exports, "throttle", ()=>(0, _throttle.throttle));
parcelHelpers.export(exports, "throttleTime", ()=>(0, _throttleTime.throttleTime));
parcelHelpers.export(exports, "throwIfEmpty", ()=>(0, _throwIfEmpty.throwIfEmpty));
parcelHelpers.export(exports, "timeInterval", ()=>(0, _timeInterval.timeInterval));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeout.timeout));
parcelHelpers.export(exports, "timeoutWith", ()=>(0, _timeoutWith.timeoutWith));
parcelHelpers.export(exports, "timestamp", ()=>(0, _timestamp.timestamp));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArray.toArray));
parcelHelpers.export(exports, "window", ()=>(0, _window.window));
parcelHelpers.export(exports, "windowCount", ()=>(0, _windowCount.windowCount));
parcelHelpers.export(exports, "windowTime", ()=>(0, _windowTime.windowTime));
parcelHelpers.export(exports, "windowToggle", ()=>(0, _windowToggle.windowToggle));
parcelHelpers.export(exports, "windowWhen", ()=>(0, _windowWhen.windowWhen));
parcelHelpers.export(exports, "withLatestFrom", ()=>(0, _withLatestFrom.withLatestFrom));
parcelHelpers.export(exports, "zipAll", ()=>(0, _zipAll.zipAll));
parcelHelpers.export(exports, "zipWith", ()=>(0, _zipWith.zipWith));
var _observable = require("./internal/Observable");
var _connectableObservable = require("./internal/observable/ConnectableObservable");
var _observable1 = require("./internal/symbol/observable");
var _animationFrames = require("./internal/observable/dom/animationFrames");
var _subject = require("./internal/Subject");
var _behaviorSubject = require("./internal/BehaviorSubject");
var _replaySubject = require("./internal/ReplaySubject");
var _asyncSubject = require("./internal/AsyncSubject");
var _asap = require("./internal/scheduler/asap");
var _async = require("./internal/scheduler/async");
var _queue = require("./internal/scheduler/queue");
var _animationFrame = require("./internal/scheduler/animationFrame");
var _virtualTimeScheduler = require("./internal/scheduler/VirtualTimeScheduler");
var _scheduler = require("./internal/Scheduler");
var _subscription = require("./internal/Subscription");
var _subscriber = require("./internal/Subscriber");
var _notification = require("./internal/Notification");
var _pipe = require("./internal/util/pipe");
var _noop = require("./internal/util/noop");
var _identity = require("./internal/util/identity");
var _isObservable = require("./internal/util/isObservable");
var _lastValueFrom = require("./internal/lastValueFrom");
var _firstValueFrom = require("./internal/firstValueFrom");
var _argumentOutOfRangeError = require("./internal/util/ArgumentOutOfRangeError");
var _emptyError = require("./internal/util/EmptyError");
var _notFoundError = require("./internal/util/NotFoundError");
var _objectUnsubscribedError = require("./internal/util/ObjectUnsubscribedError");
var _sequenceError = require("./internal/util/SequenceError");
var _timeout = require("./internal/operators/timeout");
var _unsubscriptionError = require("./internal/util/UnsubscriptionError");
var _bindCallback = require("./internal/observable/bindCallback");
var _bindNodeCallback = require("./internal/observable/bindNodeCallback");
var _combineLatest = require("./internal/observable/combineLatest");
var _concat = require("./internal/observable/concat");
var _connectable = require("./internal/observable/connectable");
var _defer = require("./internal/observable/defer");
var _empty = require("./internal/observable/empty");
var _forkJoin = require("./internal/observable/forkJoin");
var _from = require("./internal/observable/from");
var _fromEvent = require("./internal/observable/fromEvent");
var _fromEventPattern = require("./internal/observable/fromEventPattern");
var _generate = require("./internal/observable/generate");
var _iif = require("./internal/observable/iif");
var _interval = require("./internal/observable/interval");
var _merge = require("./internal/observable/merge");
var _never = require("./internal/observable/never");
var _of = require("./internal/observable/of");
var _onErrorResumeNext = require("./internal/observable/onErrorResumeNext");
var _pairs = require("./internal/observable/pairs");
var _partition = require("./internal/observable/partition");
var _race = require("./internal/observable/race");
var _range = require("./internal/observable/range");
var _throwError = require("./internal/observable/throwError");
var _timer = require("./internal/observable/timer");
var _using = require("./internal/observable/using");
var _zip = require("./internal/observable/zip");
var _scheduled = require("./internal/scheduled/scheduled");
var _types = require("./internal/types");
parcelHelpers.exportAll(_types, exports);
var _config = require("./internal/config");
var _audit = require("./internal/operators/audit");
var _auditTime = require("./internal/operators/auditTime");
var _buffer = require("./internal/operators/buffer");
var _bufferCount = require("./internal/operators/bufferCount");
var _bufferTime = require("./internal/operators/bufferTime");
var _bufferToggle = require("./internal/operators/bufferToggle");
var _bufferWhen = require("./internal/operators/bufferWhen");
var _catchError = require("./internal/operators/catchError");
var _combineAll = require("./internal/operators/combineAll");
var _combineLatestAll = require("./internal/operators/combineLatestAll");
var _combineLatestWith = require("./internal/operators/combineLatestWith");
var _concatAll = require("./internal/operators/concatAll");
var _concatMap = require("./internal/operators/concatMap");
var _concatMapTo = require("./internal/operators/concatMapTo");
var _concatWith = require("./internal/operators/concatWith");
var _connect = require("./internal/operators/connect");
var _count = require("./internal/operators/count");
var _debounce = require("./internal/operators/debounce");
var _debounceTime = require("./internal/operators/debounceTime");
var _defaultIfEmpty = require("./internal/operators/defaultIfEmpty");
var _delay = require("./internal/operators/delay");
var _delayWhen = require("./internal/operators/delayWhen");
var _dematerialize = require("./internal/operators/dematerialize");
var _distinct = require("./internal/operators/distinct");
var _distinctUntilChanged = require("./internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("./internal/operators/distinctUntilKeyChanged");
var _elementAt = require("./internal/operators/elementAt");
var _endWith = require("./internal/operators/endWith");
var _every = require("./internal/operators/every");
var _exhaust = require("./internal/operators/exhaust");
var _exhaustAll = require("./internal/operators/exhaustAll");
var _exhaustMap = require("./internal/operators/exhaustMap");
var _expand = require("./internal/operators/expand");
var _filter = require("./internal/operators/filter");
var _finalize = require("./internal/operators/finalize");
var _find = require("./internal/operators/find");
var _findIndex = require("./internal/operators/findIndex");
var _first = require("./internal/operators/first");
var _groupBy = require("./internal/operators/groupBy");
var _ignoreElements = require("./internal/operators/ignoreElements");
var _isEmpty = require("./internal/operators/isEmpty");
var _last = require("./internal/operators/last");
var _map = require("./internal/operators/map");
var _mapTo = require("./internal/operators/mapTo");
var _materialize = require("./internal/operators/materialize");
var _max = require("./internal/operators/max");
var _mergeAll = require("./internal/operators/mergeAll");
var _flatMap = require("./internal/operators/flatMap");
var _mergeMap = require("./internal/operators/mergeMap");
var _mergeMapTo = require("./internal/operators/mergeMapTo");
var _mergeScan = require("./internal/operators/mergeScan");
var _mergeWith = require("./internal/operators/mergeWith");
var _min = require("./internal/operators/min");
var _multicast = require("./internal/operators/multicast");
var _observeOn = require("./internal/operators/observeOn");
var _onErrorResumeNextWith = require("./internal/operators/onErrorResumeNextWith");
var _pairwise = require("./internal/operators/pairwise");
var _pluck = require("./internal/operators/pluck");
var _publish = require("./internal/operators/publish");
var _publishBehavior = require("./internal/operators/publishBehavior");
var _publishLast = require("./internal/operators/publishLast");
var _publishReplay = require("./internal/operators/publishReplay");
var _raceWith = require("./internal/operators/raceWith");
var _reduce = require("./internal/operators/reduce");
var _repeat = require("./internal/operators/repeat");
var _repeatWhen = require("./internal/operators/repeatWhen");
var _retry = require("./internal/operators/retry");
var _retryWhen = require("./internal/operators/retryWhen");
var _refCount = require("./internal/operators/refCount");
var _sample = require("./internal/operators/sample");
var _sampleTime = require("./internal/operators/sampleTime");
var _scan = require("./internal/operators/scan");
var _sequenceEqual = require("./internal/operators/sequenceEqual");
var _share = require("./internal/operators/share");
var _shareReplay = require("./internal/operators/shareReplay");
var _single = require("./internal/operators/single");
var _skip = require("./internal/operators/skip");
var _skipLast = require("./internal/operators/skipLast");
var _skipUntil = require("./internal/operators/skipUntil");
var _skipWhile = require("./internal/operators/skipWhile");
var _startWith = require("./internal/operators/startWith");
var _subscribeOn = require("./internal/operators/subscribeOn");
var _switchAll = require("./internal/operators/switchAll");
var _switchMap = require("./internal/operators/switchMap");
var _switchMapTo = require("./internal/operators/switchMapTo");
var _switchScan = require("./internal/operators/switchScan");
var _take = require("./internal/operators/take");
var _takeLast = require("./internal/operators/takeLast");
var _takeUntil = require("./internal/operators/takeUntil");
var _takeWhile = require("./internal/operators/takeWhile");
var _tap = require("./internal/operators/tap");
var _throttle = require("./internal/operators/throttle");
var _throttleTime = require("./internal/operators/throttleTime");
var _throwIfEmpty = require("./internal/operators/throwIfEmpty");
var _timeInterval = require("./internal/operators/timeInterval");
var _timeoutWith = require("./internal/operators/timeoutWith");
var _timestamp = require("./internal/operators/timestamp");
var _toArray = require("./internal/operators/toArray");
var _window = require("./internal/operators/window");
var _windowCount = require("./internal/operators/windowCount");
var _windowTime = require("./internal/operators/windowTime");
var _windowToggle = require("./internal/operators/windowToggle");
var _windowWhen = require("./internal/operators/windowWhen");
var _withLatestFrom = require("./internal/operators/withLatestFrom");
var _zipAll = require("./internal/operators/zipAll");
var _zipWith = require("./internal/operators/zipWith");

},{"./internal/Observable":false,"./internal/observable/ConnectableObservable":false,"./internal/symbol/observable":false,"./internal/observable/dom/animationFrames":false,"./internal/Subject":"d5Kv2","./internal/BehaviorSubject":"jgONC","./internal/ReplaySubject":"iEsym","./internal/AsyncSubject":false,"./internal/scheduler/asap":false,"./internal/scheduler/async":false,"./internal/scheduler/queue":false,"./internal/scheduler/animationFrame":false,"./internal/scheduler/VirtualTimeScheduler":false,"./internal/Scheduler":false,"./internal/Subscription":"783D3","./internal/Subscriber":false,"./internal/Notification":false,"./internal/util/pipe":false,"./internal/util/noop":false,"./internal/util/identity":false,"./internal/util/isObservable":false,"./internal/lastValueFrom":false,"./internal/firstValueFrom":"b8wo7","./internal/util/ArgumentOutOfRangeError":false,"./internal/util/EmptyError":false,"./internal/util/NotFoundError":false,"./internal/util/ObjectUnsubscribedError":false,"./internal/util/SequenceError":false,"./internal/operators/timeout":false,"./internal/util/UnsubscriptionError":false,"./internal/observable/bindCallback":false,"./internal/observable/bindNodeCallback":false,"./internal/observable/combineLatest":"8OL7i","./internal/observable/concat":false,"./internal/observable/connectable":false,"./internal/observable/defer":false,"./internal/observable/empty":false,"./internal/observable/forkJoin":false,"./internal/observable/from":"5eLL3","./internal/observable/fromEvent":false,"./internal/observable/fromEventPattern":false,"./internal/observable/generate":false,"./internal/observable/iif":false,"./internal/observable/interval":false,"./internal/observable/merge":false,"./internal/observable/never":false,"./internal/observable/of":"dQAyS","./internal/observable/onErrorResumeNext":false,"./internal/observable/pairs":false,"./internal/observable/partition":false,"./internal/observable/race":false,"./internal/observable/range":false,"./internal/observable/throwError":false,"./internal/observable/timer":false,"./internal/observable/using":false,"./internal/observable/zip":false,"./internal/scheduled/scheduled":false,"./internal/types":false,"./internal/config":false,"./internal/operators/audit":false,"./internal/operators/auditTime":false,"./internal/operators/buffer":false,"./internal/operators/bufferCount":false,"./internal/operators/bufferTime":false,"./internal/operators/bufferToggle":false,"./internal/operators/bufferWhen":false,"./internal/operators/catchError":"nFSWp","./internal/operators/combineAll":false,"./internal/operators/combineLatestAll":false,"./internal/operators/combineLatestWith":false,"./internal/operators/concatAll":false,"./internal/operators/concatMap":false,"./internal/operators/concatMapTo":false,"./internal/operators/concatWith":false,"./internal/operators/connect":false,"./internal/operators/count":false,"./internal/operators/debounce":false,"./internal/operators/debounceTime":"2tucH","./internal/operators/defaultIfEmpty":false,"./internal/operators/delay":"dSnAx","./internal/operators/delayWhen":false,"./internal/operators/dematerialize":false,"./internal/operators/distinct":false,"./internal/operators/distinctUntilChanged":"8vREQ","./internal/operators/distinctUntilKeyChanged":false,"./internal/operators/elementAt":false,"./internal/operators/endWith":false,"./internal/operators/every":false,"./internal/operators/exhaust":false,"./internal/operators/exhaustAll":false,"./internal/operators/exhaustMap":false,"./internal/operators/expand":false,"./internal/operators/filter":"6IL8Z","./internal/operators/finalize":false,"./internal/operators/find":false,"./internal/operators/findIndex":false,"./internal/operators/first":"51z75","./internal/operators/groupBy":false,"./internal/operators/ignoreElements":false,"./internal/operators/isEmpty":false,"./internal/operators/last":false,"./internal/operators/map":"7IXBR","./internal/operators/mapTo":false,"./internal/operators/materialize":false,"./internal/operators/max":false,"./internal/operators/mergeAll":false,"./internal/operators/flatMap":false,"./internal/operators/mergeMap":"6AnB0","./internal/operators/mergeMapTo":false,"./internal/operators/mergeScan":false,"./internal/operators/mergeWith":false,"./internal/operators/min":false,"./internal/operators/multicast":false,"./internal/operators/observeOn":false,"./internal/operators/onErrorResumeNextWith":false,"./internal/operators/pairwise":false,"./internal/operators/pluck":false,"./internal/operators/publish":false,"./internal/operators/publishBehavior":false,"./internal/operators/publishLast":false,"./internal/operators/publishReplay":false,"./internal/operators/raceWith":false,"./internal/operators/reduce":false,"./internal/operators/repeat":false,"./internal/operators/repeatWhen":false,"./internal/operators/retry":false,"./internal/operators/retryWhen":false,"./internal/operators/refCount":false,"./internal/operators/sample":false,"./internal/operators/sampleTime":false,"./internal/operators/scan":false,"./internal/operators/sequenceEqual":false,"./internal/operators/share":"jD4Nz","./internal/operators/shareReplay":"h1Hm0","./internal/operators/single":false,"./internal/operators/skip":"4RKKQ","./internal/operators/skipLast":false,"./internal/operators/skipUntil":false,"./internal/operators/skipWhile":false,"./internal/operators/startWith":false,"./internal/operators/subscribeOn":false,"./internal/operators/switchAll":false,"./internal/operators/switchMap":false,"./internal/operators/switchMapTo":false,"./internal/operators/switchScan":false,"./internal/operators/take":"3yY1T","./internal/operators/takeLast":false,"./internal/operators/takeUntil":false,"./internal/operators/takeWhile":false,"./internal/operators/tap":"jUXFG","./internal/operators/throttle":false,"./internal/operators/throttleTime":false,"./internal/operators/throwIfEmpty":false,"./internal/operators/timeInterval":false,"./internal/operators/timeoutWith":false,"./internal/operators/timestamp":false,"./internal/operators/toArray":false,"./internal/operators/window":false,"./internal/operators/windowCount":false,"./internal/operators/windowTime":false,"./internal/operators/windowToggle":false,"./internal/operators/windowWhen":false,"./internal/operators/withLatestFrom":false,"./internal/operators/zipAll":false,"./internal/operators/zipWith":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d1lwH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
var _subscriber = require("./Subscriber");
var _subscription = require("./Subscription");
var _observable = require("./symbol/observable");
var _pipe = require("./util/pipe");
var _config = require("./config");
var _isFunction = require("./util/isFunction");
var _errorContext = require("./util/errorContext");
var Observable = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new (0, _subscriber.SafeSubscriber)(observerOrNext, error, complete);
        (0, _errorContext.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, _subscriber.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, _observable.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, _pipe.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, _config.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
    return value && (0, _isFunction.isFunction)(value.next) && (0, _isFunction.isFunction)(value.error) && (0, _isFunction.isFunction)(value.complete);
}
function isSubscriber(value) {
    return value && value instanceof (0, _subscriber.Subscriber) || isObserver(value) && (0, _subscription.isSubscription)(value);
}

},{"./Subscriber":"kFxyr","./Subscription":"783D3","./symbol/observable":"jxt7D","./util/pipe":"5pY8j","./config":"82tBo","./util/isFunction":"lYl3l","./util/errorContext":"f15r2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kFxyr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscriber", ()=>Subscriber);
parcelHelpers.export(exports, "SafeSubscriber", ()=>SafeSubscriber);
parcelHelpers.export(exports, "EMPTY_OBSERVER", ()=>EMPTY_OBSERVER);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _subscription = require("./Subscription");
var _config = require("./config");
var _reportUnhandledError = require("./util/reportUnhandledError");
var _noop = require("./util/noop");
var _notificationFactories = require("./NotificationFactories");
var _timeoutProvider = require("./scheduler/timeoutProvider");
var _errorContext = require("./util/errorContext");
var Subscriber = function(_super) {
    (0, _tslib.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, _subscription.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = EMPTY_OBSERVER;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) handleStoppedNotification((0, _notificationFactories.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) handleStoppedNotification((0, _notificationFactories.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) handleStoppedNotification((0, _notificationFactories.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, _subscription.Subscription));
var _bind = Function.prototype.bind;
function bind(fn, thisArg) {
    return _bind.call(fn, thisArg);
}
var ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            handleUnhandledError(error);
        }
        else handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var SafeSubscriber = function(_super) {
    (0, _tslib.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, _isFunction.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, _config.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}(Subscriber);
function handleUnhandledError(error) {
    if ((0, _config.config).useDeprecatedSynchronousErrorHandling) (0, _errorContext.captureError)(error);
    else (0, _reportUnhandledError.reportUnhandledError)(error);
}
function defaultErrorHandler(err) {
    throw err;
}
function handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, _config.config).onStoppedNotification;
    onStoppedNotification && (0, _timeoutProvider.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var EMPTY_OBSERVER = {
    closed: true,
    next: (0, _noop.noop),
    error: defaultErrorHandler,
    complete: (0, _noop.noop)
};

},{"tslib":"gBS4y","./util/isFunction":"lYl3l","./Subscription":"783D3","./config":"82tBo","./util/reportUnhandledError":"8AXr5","./util/noop":"kHYqy","./NotificationFactories":"2ZvBe","./scheduler/timeoutProvider":"8SdfH","./util/errorContext":"f15r2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lYl3l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
function isFunction(value) {
    return typeof value === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"783D3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", ()=>Subscription);
parcelHelpers.export(exports, "EMPTY_SUBSCRIPTION", ()=>EMPTY_SUBSCRIPTION);
parcelHelpers.export(exports, "isSubscription", ()=>isSubscription);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _unsubscriptionError = require("./util/UnsubscriptionError");
var _arrRemove = require("./util/arrRemove");
var Subscription = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, _tslib.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, _isFunction.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, _unsubscriptionError.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, _tslib.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, _unsubscriptionError.UnsubscriptionError)) errors = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(errors)), (0, _tslib.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, _unsubscriptionError.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, _arrRemove.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, _arrRemove.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
    return value instanceof Subscription || value && "closed" in value && (0, _isFunction.isFunction)(value.remove) && (0, _isFunction.isFunction)(value.add) && (0, _isFunction.isFunction)(value.unsubscribe);
}
function execFinalizer(finalizer) {
    if ((0, _isFunction.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

},{"tslib":"gBS4y","./util/isFunction":"lYl3l","./util/UnsubscriptionError":"94t3n","./util/arrRemove":"8HmaR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"94t3n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsubscriptionError", ()=>UnsubscriptionError);
var _createErrorClass = require("./createErrorClass");
var UnsubscriptionError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});

},{"./createErrorClass":"9GyiB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9GyiB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createErrorClass", ()=>createErrorClass);
function createErrorClass(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8HmaR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrRemove", ()=>arrRemove);
function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"82tBo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", ()=>config);
var config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8AXr5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reportUnhandledError", ()=>reportUnhandledError);
var _config = require("../config");
var _timeoutProvider = require("../scheduler/timeoutProvider");
function reportUnhandledError(err) {
    (0, _timeoutProvider.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, _config.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

},{"../config":"82tBo","../scheduler/timeoutProvider":"8SdfH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8SdfH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutProvider", ()=>timeoutProvider);
var _tslib = require("tslib");
var timeoutProvider = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
        return setTimeout.apply(void 0, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

},{"tslib":"gBS4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kHYqy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ZvBe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COMPLETE_NOTIFICATION", ()=>COMPLETE_NOTIFICATION);
parcelHelpers.export(exports, "errorNotification", ()=>errorNotification);
parcelHelpers.export(exports, "nextNotification", ()=>nextNotification);
parcelHelpers.export(exports, "createNotification", ()=>createNotification);
var COMPLETE_NOTIFICATION = function() {
    return createNotification("C", undefined, undefined);
}();
function errorNotification(error) {
    return createNotification("E", undefined, error);
}
function nextNotification(value) {
    return createNotification("N", value, undefined);
}
function createNotification(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f15r2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorContext", ()=>errorContext);
parcelHelpers.export(exports, "captureError", ()=>captureError);
var _config = require("../config");
var context = null;
function errorContext(cb) {
    if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !context;
        if (isRoot) context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = context, errorThrown = _a.errorThrown, error = _a.error;
            context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function captureError(err) {
    if ((0, _config.config).useDeprecatedSynchronousErrorHandling && context) {
        context.errorThrown = true;
        context.error = err;
    }
}

},{"../config":"82tBo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jxt7D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observable", ()=>observable);
var observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5pY8j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
parcelHelpers.export(exports, "pipeFromArray", ()=>pipeFromArray);
var _identity = require("./identity");
function pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) return 0, _identity.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

},{"./identity":"g1HET","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g1HET":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d5Kv2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subject", ()=>Subject);
parcelHelpers.export(exports, "AnonymousSubject", ()=>AnonymousSubject);
var _tslib = require("tslib");
var _observable = require("./Observable");
var _subscription = require("./Subscription");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _arrRemove = require("./util/arrRemove");
var _errorContext = require("./util/errorContext");
var Subject = function(_super) {
    (0, _tslib.__extends)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, _errorContext.errorContext)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, _tslib.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, _errorContext.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, _errorContext.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, _subscription.EMPTY_SUBSCRIPTION;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, _subscription.Subscription)(function() {
            _this.currentObservers = null;
            (0, _arrRemove.arrRemove)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, _observable.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}((0, _observable.Observable));
var AnonymousSubject = function(_super) {
    (0, _tslib.__extends)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, _subscription.EMPTY_SUBSCRIPTION);
    };
    return AnonymousSubject;
}(Subject);

},{"tslib":"gBS4y","./Observable":"d1lwH","./Subscription":"783D3","./util/ObjectUnsubscribedError":"d71GJ","./util/arrRemove":"8HmaR","./util/errorContext":"f15r2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d71GJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>ObjectUnsubscribedError);
var _createErrorClass = require("./createErrorClass");
var ObjectUnsubscribedError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});

},{"./createErrorClass":"9GyiB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jgONC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BehaviorSubject", ()=>BehaviorSubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var BehaviorSubject = function(_super) {
    (0, _tslib.__extends)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, _subject.Subject));

},{"tslib":"gBS4y","./Subject":"d5Kv2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iEsym":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplaySubject", ()=>ReplaySubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _dateTimestampProvider = require("./scheduler/dateTimestampProvider");
var ReplaySubject = function(_super) {
    (0, _tslib.__extends)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, _dateTimestampProvider.dateTimestampProvider);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, _subject.Subject));

},{"tslib":"gBS4y","./Subject":"d5Kv2","./scheduler/dateTimestampProvider":"4qcjL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4qcjL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateTimestampProvider", ()=>dateTimestampProvider);
var dateTimestampProvider = {
    now: function() {
        return (dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5G8j8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asyncScheduler", ()=>asyncScheduler);
parcelHelpers.export(exports, "async", ()=>async);
var _asyncAction = require("./AsyncAction");
var _asyncScheduler = require("./AsyncScheduler");
var asyncScheduler = new (0, _asyncScheduler.AsyncScheduler)((0, _asyncAction.AsyncAction));
var async = asyncScheduler;

},{"./AsyncAction":"dvOX4","./AsyncScheduler":"34oXP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dvOX4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncAction", ()=>AsyncAction);
var _tslib = require("tslib");
var _action = require("./Action");
var _intervalProvider = require("./intervalProvider");
var _arrRemove = require("../util/arrRemove");
var AsyncAction = function(_super) {
    (0, _tslib.__extends)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, _intervalProvider.intervalProvider).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, _intervalProvider.intervalProvider).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error("Scheduled action threw falsy error");
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, _arrRemove.arrRemove)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, _action.Action));

},{"tslib":"gBS4y","./Action":"4twXz","./intervalProvider":"57R9E","../util/arrRemove":"8HmaR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4twXz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var Action = function(_super) {
    (0, _tslib.__extends)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, _subscription.Subscription));

},{"tslib":"gBS4y","../Subscription":"783D3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"57R9E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "intervalProvider", ()=>intervalProvider);
var _tslib = require("tslib");
var intervalProvider = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = intervalProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
        return setInterval.apply(void 0, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
    },
    clearInterval: function(handle) {
        var delegate = intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};

},{"tslib":"gBS4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"34oXP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncScheduler", ()=>AsyncScheduler);
var _tslib = require("tslib");
var _scheduler = require("../Scheduler");
var AsyncScheduler = function(_super) {
    (0, _tslib.__extends)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, _scheduler.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, _scheduler.Scheduler));

},{"tslib":"gBS4y","../Scheduler":"jktOr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jktOr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scheduler", ()=>Scheduler);
var _dateTimestampProvider = require("./scheduler/dateTimestampProvider");
var Scheduler = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, _dateTimestampProvider.dateTimestampProvider).now;
    return Scheduler;
}();

},{"./scheduler/dateTimestampProvider":"4qcjL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b8wo7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "firstValueFrom", ()=>firstValueFrom);
var _emptyError = require("./util/EmptyError");
var _subscriber = require("./Subscriber");
function firstValueFrom(source, config) {
    var hasConfig = typeof config === "object";
    return new Promise(function(resolve, reject) {
        var subscriber = new (0, _subscriber.SafeSubscriber)({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, _emptyError.EmptyError)());
            }
        });
        source.subscribe(subscriber);
    });
}

},{"./util/EmptyError":"86Im8","./Subscriber":"kFxyr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"86Im8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyError", ()=>EmptyError);
var _createErrorClass = require("./createErrorClass");
var EmptyError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = "EmptyError";
        this.message = "no elements in sequence";
    };
});

},{"./createErrorClass":"9GyiB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8OL7i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatest", ()=>combineLatest);
parcelHelpers.export(exports, "combineLatestInit", ()=>combineLatestInit);
var _observable = require("../Observable");
var _argsArgArrayOrObject = require("../util/argsArgArrayOrObject");
var _from = require("./from");
var _identity = require("../util/identity");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var _args = require("../util/args");
var _createObject = require("../util/createObject");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
var _executeSchedule = require("../util/executeSchedule");
function combineLatest() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    var resultSelector = (0, _args.popResultSelector)(args);
    var _a = (0, _argsArgArrayOrObject.argsArgArrayOrObject)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, _from.from)([], scheduler);
    var result = new (0, _observable.Observable)(combineLatestInit(observables, scheduler, keys ? function(values) {
        return (0, _createObject.createObject)(keys, values);
    } : (0, _identity.identity)));
    return resultSelector ? result.pipe((0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector)) : result;
}
function combineLatestInit(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, _identity.identity);
    return function(subscriber) {
        maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                maybeSchedule(scheduler, function() {
                    var source = (0, _from.from)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, _executeSchedule.executeSchedule)(subscription, scheduler, execute);
    else execute();
}

},{"../Observable":"d1lwH","../util/argsArgArrayOrObject":"hTEJd","./from":"5eLL3","../util/identity":"g1HET","../util/mapOneOrManyArgs":"7iSSi","../util/args":"gCY3B","../util/createObject":"hXbvU","../operators/OperatorSubscriber":"kt12R","../util/executeSchedule":"2l7jF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hTEJd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "argsArgArrayOrObject", ()=>argsArgArrayOrObject);
var isArray = Array.isArray;
var getPrototypeOf = Object.getPrototypeOf, objectProto = Object.prototype, getKeys = Object.keys;
function argsArgArrayOrObject(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if (isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if (isPOJO(first_1)) {
            var keys = getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function isPOJO(obj) {
    return obj && typeof obj === "object" && getPrototypeOf(obj) === objectProto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5eLL3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", ()=>from);
var _scheduled = require("../scheduled/scheduled");
var _innerFrom = require("./innerFrom");
function from(input, scheduler) {
    return scheduler ? (0, _scheduled.scheduled)(input, scheduler) : (0, _innerFrom.innerFrom)(input);
}

},{"../scheduled/scheduled":"3Ez9k","./innerFrom":"h01J1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Ez9k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduled", ()=>scheduled);
var _scheduleObservable = require("./scheduleObservable");
var _schedulePromise = require("./schedulePromise");
var _scheduleArray = require("./scheduleArray");
var _scheduleIterable = require("./scheduleIterable");
var _scheduleAsyncIterable = require("./scheduleAsyncIterable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isPromise = require("../util/isPromise");
var _isArrayLike = require("../util/isArrayLike");
var _isIterable = require("../util/isIterable");
var _isAsyncIterable = require("../util/isAsyncIterable");
var _throwUnobservableError = require("../util/throwUnobservableError");
var _isReadableStreamLike = require("../util/isReadableStreamLike");
var _scheduleReadableStreamLike = require("./scheduleReadableStreamLike");
function scheduled(input, scheduler) {
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return (0, _scheduleObservable.scheduleObservable)(input, scheduler);
        if ((0, _isArrayLike.isArrayLike)(input)) return (0, _scheduleArray.scheduleArray)(input, scheduler);
        if ((0, _isPromise.isPromise)(input)) return (0, _schedulePromise.schedulePromise)(input, scheduler);
        if ((0, _isAsyncIterable.isAsyncIterable)(input)) return (0, _scheduleAsyncIterable.scheduleAsyncIterable)(input, scheduler);
        if ((0, _isIterable.isIterable)(input)) return (0, _scheduleIterable.scheduleIterable)(input, scheduler);
        if ((0, _isReadableStreamLike.isReadableStreamLike)(input)) return (0, _scheduleReadableStreamLike.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, _throwUnobservableError.createInvalidObservableTypeError)(input);
}

},{"./scheduleObservable":"5dT5e","./schedulePromise":"iSyjq","./scheduleArray":"2U8p1","./scheduleIterable":"hlBAZ","./scheduleAsyncIterable":"jBHhC","../util/isInteropObservable":"3HSWo","../util/isPromise":"cs0fk","../util/isArrayLike":"h6xZY","../util/isIterable":"hZn9k","../util/isAsyncIterable":"irEL4","../util/throwUnobservableError":"ktZFr","../util/isReadableStreamLike":"j6Y2M","./scheduleReadableStreamLike":"e42As","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5dT5e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleObservable", ()=>scheduleObservable);
var _innerFrom = require("../observable/innerFrom");
var _observeOn = require("../operators/observeOn");
var _subscribeOn = require("../operators/subscribeOn");
function scheduleObservable(input, scheduler) {
    return (0, _innerFrom.innerFrom)(input).pipe((0, _subscribeOn.subscribeOn)(scheduler), (0, _observeOn.observeOn)(scheduler));
}

},{"../observable/innerFrom":"h01J1","../operators/observeOn":"2mMi7","../operators/subscribeOn":"ddiZG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h01J1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "innerFrom", ()=>innerFrom);
parcelHelpers.export(exports, "fromInteropObservable", ()=>fromInteropObservable);
parcelHelpers.export(exports, "fromArrayLike", ()=>fromArrayLike);
parcelHelpers.export(exports, "fromPromise", ()=>fromPromise);
parcelHelpers.export(exports, "fromIterable", ()=>fromIterable);
parcelHelpers.export(exports, "fromAsyncIterable", ()=>fromAsyncIterable);
parcelHelpers.export(exports, "fromReadableStreamLike", ()=>fromReadableStreamLike);
var _tslib = require("tslib");
var _isArrayLike = require("../util/isArrayLike");
var _isPromise = require("../util/isPromise");
var _observable = require("../Observable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isAsyncIterable = require("../util/isAsyncIterable");
var _throwUnobservableError = require("../util/throwUnobservableError");
var _isIterable = require("../util/isIterable");
var _isReadableStreamLike = require("../util/isReadableStreamLike");
var _isFunction = require("../util/isFunction");
var _reportUnhandledError = require("../util/reportUnhandledError");
var _observable1 = require("../symbol/observable");
function innerFrom(input) {
    if (input instanceof (0, _observable.Observable)) return input;
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return fromInteropObservable(input);
        if ((0, _isArrayLike.isArrayLike)(input)) return fromArrayLike(input);
        if ((0, _isPromise.isPromise)(input)) return fromPromise(input);
        if ((0, _isAsyncIterable.isAsyncIterable)(input)) return fromAsyncIterable(input);
        if ((0, _isIterable.isIterable)(input)) return fromIterable(input);
        if ((0, _isReadableStreamLike.isReadableStreamLike)(input)) return fromReadableStreamLike(input);
    }
    throw (0, _throwUnobservableError.createInvalidObservableTypeError)(input);
}
function fromInteropObservable(obj) {
    return new (0, _observable.Observable)(function(subscriber) {
        var obs = obj[0, _observable1.observable]();
        if ((0, _isFunction.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
}
function fromArrayLike(array) {
    return new (0, _observable.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function fromPromise(promise) {
    return new (0, _observable.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, _reportUnhandledError.reportUnhandledError));
    });
}
function fromIterable(iterable) {
    return new (0, _observable.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, _tslib.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function fromAsyncIterable(asyncIterable) {
    return new (0, _observable.Observable)(function(subscriber) {
        process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function fromReadableStreamLike(readableStream) {
    return fromAsyncIterable((0, _isReadableStreamLike.readableStreamLikeToAsyncGenerator)(readableStream));
}
function process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, _tslib.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

},{"tslib":"gBS4y","../util/isArrayLike":"h6xZY","../util/isPromise":"cs0fk","../Observable":"d1lwH","../util/isInteropObservable":"3HSWo","../util/isAsyncIterable":"irEL4","../util/throwUnobservableError":"ktZFr","../util/isIterable":"hZn9k","../util/isReadableStreamLike":"j6Y2M","../util/isFunction":"lYl3l","../util/reportUnhandledError":"8AXr5","../symbol/observable":"jxt7D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h6xZY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayLike", ()=>isArrayLike);
var isArrayLike = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cs0fk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
var _isFunction = require("./isFunction");
function isPromise(value) {
    return (0, _isFunction.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

},{"./isFunction":"lYl3l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3HSWo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInteropObservable", ()=>isInteropObservable);
var _observable = require("../symbol/observable");
var _isFunction = require("./isFunction");
function isInteropObservable(input) {
    return (0, _isFunction.isFunction)(input[0, _observable.observable]);
}

},{"../symbol/observable":"jxt7D","./isFunction":"lYl3l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"irEL4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAsyncIterable", ()=>isAsyncIterable);
var _isFunction = require("./isFunction");
function isAsyncIterable(obj) {
    return Symbol.asyncIterator && (0, _isFunction.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

},{"./isFunction":"lYl3l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ktZFr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInvalidObservableTypeError", ()=>createInvalidObservableTypeError);
function createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hZn9k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
var _iterator = require("../symbol/iterator");
var _isFunction = require("./isFunction");
function isIterable(input) {
    return (0, _isFunction.isFunction)(input === null || input === void 0 ? void 0 : input[0, _iterator.iterator]);
}

},{"../symbol/iterator":"axnWE","./isFunction":"lYl3l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"axnWE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSymbolIterator", ()=>getSymbolIterator);
parcelHelpers.export(exports, "iterator", ()=>iterator);
function getSymbolIterator() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var iterator = getSymbolIterator();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j6Y2M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readableStreamLikeToAsyncGenerator", ()=>readableStreamLikeToAsyncGenerator);
parcelHelpers.export(exports, "isReadableStreamLike", ()=>isReadableStreamLike);
var _tslib = require("tslib");
var _isFunction = require("./isFunction");
function readableStreamLikeToAsyncGenerator(readableStream) {
    return (0, _tslib.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, _tslib.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, _tslib.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, _tslib.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function isReadableStreamLike(obj) {
    return (0, _isFunction.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

},{"tslib":"gBS4y","./isFunction":"lYl3l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2mMi7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeOn", ()=>observeOn);
var _executeSchedule = require("../util/executeSchedule");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

},{"../util/executeSchedule":"2l7jF","../util/lift":"aMdoY","./OperatorSubscriber":"kt12R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2l7jF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "executeSchedule", ()=>executeSchedule);
function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aMdoY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasLift", ()=>hasLift);
parcelHelpers.export(exports, "operate", ()=>operate);
var _isFunction = require("./isFunction");
function hasLift(source) {
    return (0, _isFunction.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
    return function(source) {
        if (hasLift(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}

},{"./isFunction":"lYl3l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kt12R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOperatorSubscriber", ()=>createOperatorSubscriber);
parcelHelpers.export(exports, "OperatorSubscriber", ()=>OperatorSubscriber);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = function(_super) {
    (0, _tslib.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"kFxyr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ddiZG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeOn", ()=>subscribeOn);
var _lift = require("../util/lift");
function subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, _lift.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

},{"../util/lift":"aMdoY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iSyjq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schedulePromise", ()=>schedulePromise);
var _innerFrom = require("../observable/innerFrom");
var _observeOn = require("../operators/observeOn");
var _subscribeOn = require("../operators/subscribeOn");
function schedulePromise(input, scheduler) {
    return (0, _innerFrom.innerFrom)(input).pipe((0, _subscribeOn.subscribeOn)(scheduler), (0, _observeOn.observeOn)(scheduler));
}

},{"../observable/innerFrom":"h01J1","../operators/observeOn":"2mMi7","../operators/subscribeOn":"ddiZG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2U8p1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleArray", ()=>scheduleArray);
var _observable = require("../Observable");
function scheduleArray(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

},{"../Observable":"d1lwH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hlBAZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleIterable", ()=>scheduleIterable);
var _observable = require("../Observable");
var _iterator = require("../symbol/iterator");
var _isFunction = require("../util/isFunction");
var _executeSchedule = require("../util/executeSchedule");
function scheduleIterable(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var iterator;
        (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, _iterator.iterator]();
            (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, _isFunction.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

},{"../Observable":"d1lwH","../symbol/iterator":"axnWE","../util/isFunction":"lYl3l","../util/executeSchedule":"2l7jF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jBHhC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleAsyncIterable", ()=>scheduleAsyncIterable);
var _observable = require("../Observable");
var _executeSchedule = require("../util/executeSchedule");
function scheduleAsyncIterable(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, _observable.Observable)(function(subscriber) {
        (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

},{"../Observable":"d1lwH","../util/executeSchedule":"2l7jF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e42As":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleReadableStreamLike", ()=>scheduleReadableStreamLike);
var _scheduleAsyncIterable = require("./scheduleAsyncIterable");
var _isReadableStreamLike = require("../util/isReadableStreamLike");
function scheduleReadableStreamLike(input, scheduler) {
    return (0, _scheduleAsyncIterable.scheduleAsyncIterable)((0, _isReadableStreamLike.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

},{"./scheduleAsyncIterable":"jBHhC","../util/isReadableStreamLike":"j6Y2M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7iSSi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapOneOrManyArgs", ()=>mapOneOrManyArgs);
var _tslib = require("tslib");
var _map = require("../operators/map");
var isArray = Array.isArray;
function callOrApply(fn, args) {
    return isArray(args) ? fn.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args))) : fn(args);
}
function mapOneOrManyArgs(fn) {
    return (0, _map.map)(function(args) {
        return callOrApply(fn, args);
    });
}

},{"tslib":"gBS4y","../operators/map":"7IXBR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7IXBR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function map(project, thisArg) {
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

},{"../util/lift":"aMdoY","./OperatorSubscriber":"kt12R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gCY3B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popResultSelector", ()=>popResultSelector);
parcelHelpers.export(exports, "popScheduler", ()=>popScheduler);
parcelHelpers.export(exports, "popNumber", ()=>popNumber);
var _isFunction = require("./isFunction");
var _isScheduler = require("./isScheduler");
function last(arr) {
    return arr[arr.length - 1];
}
function popResultSelector(args) {
    return (0, _isFunction.isFunction)(last(args)) ? args.pop() : undefined;
}
function popScheduler(args) {
    return (0, _isScheduler.isScheduler)(last(args)) ? args.pop() : undefined;
}
function popNumber(args, defaultValue) {
    return typeof last(args) === "number" ? args.pop() : defaultValue;
}

},{"./isFunction":"lYl3l","./isScheduler":"lM8YO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lM8YO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScheduler", ()=>isScheduler);
var _isFunction = require("./isFunction");
function isScheduler(value) {
    return value && (0, _isFunction.isFunction)(value.schedule);
}

},{"./isFunction":"lYl3l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hXbvU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createObject", ()=>createObject);
function createObject(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Xcsd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
var _concatAll = require("../operators/concatAll");
var _args = require("../util/args");
var _from = require("./from");
function concat() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, _concatAll.concatAll)()((0, _from.from)(args, (0, _args.popScheduler)(args)));
}

},{"../operators/concatAll":"gkaLL","../util/args":"gCY3B","./from":"5eLL3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gkaLL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatAll", ()=>concatAll);
var _mergeAll = require("./mergeAll");
function concatAll() {
    return (0, _mergeAll.mergeAll)(1);
}

},{"./mergeAll":"gjk3I","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gjk3I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeAll", ()=>mergeAll);
var _mergeMap = require("./mergeMap");
var _identity = require("../util/identity");
function mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, _mergeMap.mergeMap)((0, _identity.identity), concurrent);
}

},{"./mergeMap":"6AnB0","../util/identity":"g1HET","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6AnB0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMap", ()=>mergeMap);
var _map = require("./map");
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _mergeInternals = require("./mergeInternals");
var _isFunction = require("../util/isFunction");
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, _isFunction.isFunction)(resultSelector)) return mergeMap(function(a, i) {
        return (0, _map.map)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, _innerFrom.innerFrom)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, _lift.operate)(function(source, subscriber) {
        return (0, _mergeInternals.mergeInternals)(source, subscriber, project, concurrent);
    });
}

},{"./map":"7IXBR","../observable/innerFrom":"h01J1","../util/lift":"aMdoY","./mergeInternals":"60UCu","../util/isFunction":"lYl3l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"60UCu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeInternals", ()=>mergeInternals);
var _innerFrom = require("../observable/innerFrom");
var _executeSchedule = require("../util/executeSchedule");
var _operatorSubscriber = require("./OperatorSubscriber");
function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, _innerFrom.innerFrom)(project(value, index++)).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, _executeSchedule.executeSchedule)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}

},{"../observable/innerFrom":"h01J1","../util/executeSchedule":"2l7jF","./OperatorSubscriber":"kt12R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kJmsR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY", ()=>EMPTY);
parcelHelpers.export(exports, "empty", ()=>empty);
var _observable = require("../Observable");
var EMPTY = new (0, _observable.Observable)(function(subscriber) {
    return subscriber.complete();
});
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

},{"../Observable":"d1lwH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dQAyS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "of", ()=>of);
var _args = require("../util/args");
var _from = require("./from");
function of() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    return (0, _from.from)(args, scheduler);
}

},{"../util/args":"gCY3B","./from":"5eLL3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lrwLy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timer", ()=>timer);
var _observable = require("../Observable");
var _async = require("../scheduler/async");
var _isScheduler = require("../util/isScheduler");
var _isDate = require("../util/isDate");
function timer(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, _async.async);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, _isScheduler.isScheduler)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, _observable.Observable)(function(subscriber) {
        var due = (0, _isDate.isValidDate)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}

},{"../Observable":"d1lwH","../scheduler/async":"5G8j8","../util/isScheduler":"lM8YO","../util/isDate":"7fw4E","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7fw4E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidDate", ()=>isValidDate);
function isValidDate(value) {
    return value instanceof Date && !isNaN(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"nFSWp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "catchError", ()=>catchError);
var _innerFrom = require("../observable/innerFrom");
var _operatorSubscriber = require("./OperatorSubscriber");
var _lift = require("../util/lift");
function catchError(selector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, _innerFrom.innerFrom)(selector(err, catchError(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}

},{"../observable/innerFrom":"h01J1","./OperatorSubscriber":"kt12R","../util/lift":"aMdoY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2tucH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounceTime", ()=>debounceTime);
var _async = require("../scheduler/async");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    return (0, _lift.operate)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}

},{"../scheduler/async":"5G8j8","../util/lift":"aMdoY","./OperatorSubscriber":"kt12R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7EaIS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultIfEmpty", ()=>defaultIfEmpty);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function defaultIfEmpty(defaultValue) {
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            if (!hasValue) subscriber.next(defaultValue);
            subscriber.complete();
        }));
    });
}

},{"../util/lift":"aMdoY","./OperatorSubscriber":"kt12R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dSnAx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", ()=>delay);
var _async = require("../scheduler/async");
var _delayWhen = require("./delayWhen");
var _timer = require("../observable/timer");
function delay(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    var duration = (0, _timer.timer)(due, scheduler);
    return (0, _delayWhen.delayWhen)(function() {
        return duration;
    });
}

},{"../scheduler/async":"5G8j8","./delayWhen":"8s6X0","../observable/timer":"lrwLy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8s6X0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delayWhen", ()=>delayWhen);
var _concat = require("../observable/concat");
var _take = require("./take");
var _ignoreElements = require("./ignoreElements");
var _mapTo = require("./mapTo");
var _mergeMap = require("./mergeMap");
var _innerFrom = require("../observable/innerFrom");
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return (0, _concat.concat)(subscriptionDelay.pipe((0, _take.take)(1), (0, _ignoreElements.ignoreElements)()), source.pipe(delayWhen(delayDurationSelector)));
    };
    return (0, _mergeMap.mergeMap)(function(value, index) {
        return (0, _innerFrom.innerFrom)(delayDurationSelector(value, index)).pipe((0, _take.take)(1), (0, _mapTo.mapTo)(value));
    });
}

},{"../observable/concat":"4Xcsd","./take":"3yY1T","./ignoreElements":"4BJGB","./mapTo":"51kPq","./mergeMap":"6AnB0","../observable/innerFrom":"h01J1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3yY1T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "take", ()=>take);
var _empty = require("../observable/empty");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function take(count) {
    return count <= 0 ? function() {
        return 0, _empty.EMPTY;
    } : (0, _lift.operate)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}

},{"../observable/empty":"kJmsR","../util/lift":"aMdoY","./OperatorSubscriber":"kt12R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BJGB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ignoreElements", ()=>ignoreElements);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _noop = require("../util/noop");
function ignoreElements() {
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, (0, _noop.noop)));
    });
}

},{"../util/lift":"aMdoY","./OperatorSubscriber":"kt12R","../util/noop":"kHYqy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"51kPq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapTo", ()=>mapTo);
var _map = require("./map");
function mapTo(value) {
    return (0, _map.map)(function() {
        return value;
    });
}

},{"./map":"7IXBR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8vREQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinctUntilChanged", ()=>distinctUntilChanged);
var _identity = require("../util/identity");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function distinctUntilChanged(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, _identity.identity);
    comparator = comparator !== null && comparator !== void 0 ? comparator : defaultCompare;
    return (0, _lift.operate)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function defaultCompare(a, b) {
    return a === b;
}

},{"../util/identity":"g1HET","../util/lift":"aMdoY","./OperatorSubscriber":"kt12R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6IL8Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function filter(predicate, thisArg) {
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

},{"../util/lift":"aMdoY","./OperatorSubscriber":"kt12R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"51z75":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "first", ()=>first);
var _emptyError = require("../util/EmptyError");
var _filter = require("./filter");
var _take = require("./take");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _throwIfEmpty = require("./throwIfEmpty");
var _identity = require("../util/identity");
function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, _filter.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, _identity.identity), (0, _take.take)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _emptyError.EmptyError)();
        }));
    };
}

},{"../util/EmptyError":"86Im8","./filter":"6IL8Z","./take":"3yY1T","./defaultIfEmpty":"7EaIS","./throwIfEmpty":"2ZHxH","../util/identity":"g1HET","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ZHxH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwIfEmpty", ()=>throwIfEmpty);
var _emptyError = require("../util/EmptyError");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) errorFactory = defaultErrorFactory;
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
    });
}
function defaultErrorFactory() {
    return new (0, _emptyError.EmptyError)();
}

},{"../util/EmptyError":"86Im8","../util/lift":"aMdoY","./OperatorSubscriber":"kt12R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jD4Nz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "share", ()=>share);
var _tslib = require("tslib");
var _innerFrom = require("../observable/innerFrom");
var _subject = require("../Subject");
var _subscriber = require("../Subscriber");
var _lift = require("../util/lift");
function share(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, _subject.Subject)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, _lift.operate)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, _subscriber.SafeSubscriber)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, _innerFrom.innerFrom)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, _subscriber.SafeSubscriber)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, _innerFrom.innerFrom)(on.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args)))).subscribe(onSubscriber);
}

},{"tslib":"gBS4y","../observable/innerFrom":"h01J1","../Subject":"d5Kv2","../Subscriber":"kFxyr","../util/lift":"aMdoY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h1Hm0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shareReplay", ()=>shareReplay);
var _replaySubject = require("../ReplaySubject");
var _share = require("./share");
function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === "object") _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return (0, _share.share)({
        connector: function() {
            return new (0, _replaySubject.ReplaySubject)(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}

},{"../ReplaySubject":"iEsym","./share":"jD4Nz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4RKKQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skip", ()=>skip);
var _filter = require("./filter");
function skip(count) {
    return (0, _filter.filter)(function(_, index) {
        return count <= index;
    });
}

},{"./filter":"6IL8Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"93G5G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMap", ()=>switchMap);
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function switchMap(project, resultSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, _innerFrom.innerFrom)(project(value, outerIndex)).subscribe(innerSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}

},{"../observable/innerFrom":"h01J1","../util/lift":"aMdoY","./OperatorSubscriber":"kt12R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jUXFG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tap", ()=>tap);
var _isFunction = require("../util/isFunction");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _identity = require("../util/identity");
function tap(observerOrNext, error, complete) {
    var tapObserver = (0, _isFunction.isFunction)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, _lift.operate)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, _identity.identity);
}

},{"../util/isFunction":"lYl3l","../util/lift":"aMdoY","./OperatorSubscriber":"kt12R","../util/identity":"g1HET","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kuRgh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqPerspectiveViewer", ()=>PdqPerspectiveViewer);
var _decoratorsJs = require("lit/decorators.js");
var _lit = require("lit");
var _tableBroker = require("../services/TableBroker");
var _perspectiveViewerInlineJs = require("@finos/perspective-viewer/dist/esm/perspective-viewer.inline.js");
var _perspectiveViewerDatagridJs = require("@finos/perspective-viewer-datagrid/dist/esm/perspective-viewer-datagrid.js");
var _indexJs = require("@carbon/web-components/es/components/copy-button/index.js");
var _indexJs1 = require("@carbon/web-components/es/components/icon-button/index.js");
var _indexJs2 = require("@carbon/web-components/es/components/textarea/index.js");
var _16Js = require("@carbon/web-components/es/icons/debug/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _styles = require("../styles");
var _pdqMixin = require("./_pdq-mixin");
var _defs = require("@carbon/web-components/es/components/tag/defs");
var _perspectiveViewerInline = require("@finos/perspective-viewer/dist/esm/perspective-viewer.inline");
var _themesCss = require("bundle-text:@finos/perspective-viewer/dist/css/themes.css");
var _themesCssDefault = parcelHelpers.interopDefault(_themesCss);
var _utils = require("../utils");
var _notificationService = require("../services/notificationService");
var _rxjs = require("rxjs");
var _dataBroker = require("../services/DataBroker");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _PdqPerspectiveViewer_table, _PdqPerspectiveViewer_perspectiveViewer, _PdqPerspectiveViewer_subscription;
var PdqPerspectiveViewer_1;
var _a, _b, _c;
const PRE_INIT = Symbol("PRE-INIT");
const log = (0, _debugDefault.default)("pdq:flow:perspective-viewer");
let PdqPerspectiveViewer = PdqPerspectiveViewer_1 = class PdqPerspectiveViewer extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this._perspectivePresent = (0, _utils.defer)();
        this._perspectiveLoaded = (0, _utils.defer)();
        this._loaded = false;
        this._id = PdqPerspectiveViewer_1.next_id++;
        this.id = `pdq-perspective-viewer-${this._id}`;
        this.show = false;
        this.theme = (0, _utils.getDefaultThemeMode)() == (0, _utils.ThemeMode).light ? "auto" : "Pro Dark";
        this.height = "500px";
        this.hideIndex = false;
        this.hiddenColumns = [];
        this.selectable = false;
        this.editable = false;
        this._slicers = [];
        this.dataPreview = "no data";
        _PdqPerspectiveViewer_table.set(this, undefined);
        this.error = null;
        this.config = {};
        _PdqPerspectiveViewer_perspectiveViewer.set(this, void 0);
        this._listenersAdded = false;
        this.syncConfigToPerspective = async ()=>{
            log("syncConfigToPerspective");
            try {
                this.config = JSON.parse(this.configEditor?.value || "");
                if (this.config) {
                    this.perspectiveViewer?.restore(this.config);
                    await this.hideColumnsAsRequired();
                    await this._updatePreview();
                }
            } catch (e) {
                log(`Failed to parse config: ${e}`);
                (0, _notificationService.notificationService).warning(`pdq-view#${this.id}|Error parsing JSON: \n${e?.message || e}`);
            }
        };
        this.syncConfigFromPerspective = async ()=>{
            log("syncConfigFromPerspective");
            await this._updatePreview();
        };
        _PdqPerspectiveViewer_subscription.set(this, (0, _rxjs.Subscription).EMPTY);
        this.hideColumnsAsRequired = async ()=>{
            if (!this.perspectiveViewer) return;
            if (!this.styleSheet) {
                const rg = this.perspectiveViewer?.querySelector("perspective-viewer-datagrid")?.shadowRoot;
                if (!rg) return;
                this.styleSheet = new CSSStyleSheet();
                rg.adoptedStyleSheets = [
                    ...rg.adoptedStyleSheets,
                    this.styleSheet
                ];
            }
            const table = (0, _tableBroker.tableBroker).getTableMeta(this.table);
            const colsToHide = [];
            const index = await table?.index;
            if (index && this.hideIndex) colsToHide.push(index);
            if (this.hiddenColumns && this.hiddenColumns.length > 0) colsToHide.push(...this.hiddenColumns);
            if (!this.config) return;
            const style = colsToHide.map((i)=>{
                let idx = this.config?.columns?.indexOf(i);
                if (idx === -1) return "";
                idx++;
                console.log(`hiding column ${String(i)} at index ${idx}`);
                return `
          th:nth-child(${idx}) {
            display: none;
          }
          td:nth-child(${idx}) {
            display: none;
          }
        `;
            }).join("");
            // console.log('style', style);
            this.styleSheet.replaceSync(style.toString());
        };
    }
    get slicers() {
        return this._slicers;
    }
    set slicers(value) {
        const oldValue = this._slicers;
        const s = [];
        for (const v of value){
            if (!v) continue;
            if (typeof v == "string") s.push({
                label: v,
                column: v,
                operator: "==",
                placeholder: "All",
                value: undefined
            });
            else if (v.column) s.push({
                label: v.label || v.column,
                column: v.column,
                operator: v.operator || "==",
                placeholder: v.placeholder || "All",
                value: v.value || undefined
            });
        }
        this._slicers = s;
        this.requestUpdate("slicers", oldValue);
    }
    get table() {
        return __classPrivateFieldGet(this, _PdqPerspectiveViewer_table, "f") || "";
    }
    set table(value) {
        __classPrivateFieldSet(this, _PdqPerspectiveViewer_table, value, "f");
        this.updateData();
    }
    get perspectiveViewer() {
        return __classPrivateFieldGet(this, _PdqPerspectiveViewer_perspectiveViewer, "f");
    }
    set perspectiveViewer(value) {
        if (value) __classPrivateFieldSet(this, _PdqPerspectiveViewer_perspectiveViewer, value, "f");
    }
    addEventListeners() {
        if (!this.perspectiveViewer) return;
        if (this._listenersAdded) return;
        this._listenersAdded = true;
        log("adding listeners");
        const tableName = __classPrivateFieldGet(this, _PdqPerspectiveViewer_table, "f");
        if (!tableName) return;
        (0, _dataBroker.dataBroker).upsertDerivation(`${this.id}:row`, [
            `${this.id}:selected`
        ], async ([row])=>{
            log(`###: ${this.id}:row - ${row}`);
            const table = await (0, _rxjs.firstValueFrom)((0, _tableBroker.tableBroker).getTable(tableName));
            const index = (0, _tableBroker.tableBroker).getTableMeta(tableName).index;
            const view = await table.view({
                filter: [
                    [
                        index,
                        "==",
                        row[0][index]
                    ]
                ]
            });
            const json = await view.to_json();
            log(`DATA ISSUES`, json);
            return json;
        });
        this.perspectiveViewer?.addEventListener("keydown", (evt)=>{
            try {
                if (evt.key === "Escape") // document.body.classList.remove('details-open')
                // document.querySelector('.detail').innerHTML = ''
                this.dispatchEvent(new CustomEvent("escape"));
                if (!this.selectable) return;
                if (evt.key === "ArrowDown") {
                    evt.preventDefault();
                    evt.stopPropagation();
                    try {
                        const cell = this.shadowRoot.querySelector("perspective-viewer-datagrid").shadowRoot.querySelector("regular-table").querySelector(".psp-row-selected");
                        if (!cell?.parentElement || !cell?.parentElement?.nextElementSibling) {
                            log("ArrowDown - no selected row");
                            return;
                        }
                        const nextSiblingElement = cell.parentElement.nextElementSibling;
                        if (nextSiblingElement) {
                            const event = new MouseEvent("mousedown", {
                                "bubbles": true,
                                "cancelable": true
                            });
                            nextSiblingElement.querySelector("td")?.dispatchEvent(event);
                            nextSiblingElement.scrollIntoView({
                                behavior: "instant",
                                block: "center",
                                inline: "start"
                            });
                        }
                    } catch (e) {
                        log(`ArrowDown - exception ${e}`);
                    }
                }
                if (evt.key === "ArrowUp") {
                    evt.preventDefault();
                    evt.stopPropagation();
                    try {
                        const cell = this.shadowRoot.querySelector("perspective-viewer-datagrid").shadowRoot.querySelector("regular-table").querySelector(".psp-row-selected");
                        if (!cell?.parentElement || !cell?.parentElement?.previousElementSibling) {
                            log("ArrowUp - no selected row");
                            return;
                        }
                        const nextSiblingElement = cell.parentElement.previousElementSibling;
                        if (nextSiblingElement) {
                            const event = new MouseEvent("mousedown", {
                                "bubbles": true,
                                "cancelable": true
                            });
                            nextSiblingElement.querySelector("td")?.dispatchEvent(event);
                            nextSiblingElement.scrollIntoView({
                                behavior: "instant",
                                block: "center",
                                inline: "start"
                            });
                        }
                    } catch (e) {
                        log(`ArrowUp - exception ${e}`);
                    }
                }
            } catch (e) {
                log(`keydown error: ${e?.message || e}`);
            }
        });
        this.perspectiveViewer?.addEventListener("perspective-config-update", (evt)=>{
            log("perspective-config-change", evt);
            this.dispatchEvent(new CustomEvent("perspective-config-update", {
                detail: evt.detail
            }));
        // this.config = evt.detail;
        // this._updatePreview();
        // this.hideColumnsAsRequired()
        });
        this.perspectiveViewer?.addEventListener("perspective-select", (event)=>{
            log("perspective-select", event);
            this.dispatchEvent(new CustomEvent("perspective-select", {
                detail: event.detail
            }));
            if (!this.id) return;
            (0, _dataBroker.dataBroker).setDataSource(`${this.id}:selected`, [
                {
                    ...event.detail.row
                }
            ]);
        });
        this.perspectiveViewer?.addEventListener("perspective-click", async (evt)=>{
            log("perspective-click", evt);
            this.dispatchEvent(new CustomEvent("perspective-click", {
                detail: evt.detail
            }));
        });
        this._perspectivePresent.resolve(true);
        (0, _tableBroker.tableBroker).addViewer(this.id, this);
        this.hideColumnsAsRequired();
    }
    render() {
        log(`pdq-data: ${this.id} ${this.show} - render`);
        //const show = this.show || pdqHotkeyService.showPdqData.currentValue();
        const slot = (0, _lit.html)`<slot name="config" @slotchange="${this._onSlotChange}"></slot>`;
        // const toolbar = html`
        //   <cds-icon-button slot="tool-bar" @click="${this.syncConfigFromPerspective}" kind="primary">
        //     <span slot="tooltip-content"> Sync config from perspective </span>
        //     ${Upload({ slot: 'icon' })}
        //   </cds-icon-button>
        //   <cds-icon-button slot="tool-bar" @click="${this.syncConfigToPerspective}" kind="primary">
        //     <span slot="tooltip-content"> Sync config to perspective </span>
        //     ${Download({ slot: 'icon' })}
        //   </cds-icon-button>
        // `;
        /*
        after slot - temp disable tool bar
    
          ${show ? html`
            <div class="show col ${this.error ? 'error' : ''} m-1">
              ${this.renderToolBar(toolbar)}
              <cds-textarea value="${JSON.stringify(this.config, null, 2)}">
                <label slot="label-text">Config</label>
              </cds-textarea>
            </div>` : nothing}
    
         */ return (0, _lit.html)`
      ${slot}
      <div class="row slicers">
        <slot name="toolbar-left"></slot>
        <slot name="toolbar-slicers">
          <cds-form-item class="row">
            ${this.slicers.map((i)=>(0, _lit.html)`<cds-select class="dpl-slicer" @cds-select-selected=${this.slicerChanged} data-slicer=${i.column} data-operator=${i.operator} inline label-text="${i.label}" placeholder="${i.placeholder}" size="md" value="${i.value}"></cds-select>`)}
          </cds-form-item>
        </slot>
        <slot name="toolbar-grow">
          <div class="grow"></div>
        </slot>
        <slot name="toolbar-right"></slot>
      </div>
      <perspective-viewer
        theme=${this.theme}
        style="height: ${this.height}; --column-drop-label--display: block"
        ?selectable="${this.selectable}"
        ?editable="${this.editable}"
        id="pdq-perspective-viewer-${this.id || this._id}">
      </perspective-viewer>
    `;
    }
    async updateData() {
        log("updateData");
        if (__classPrivateFieldGet(this, _PdqPerspectiveViewer_table, "f")) {
            __classPrivateFieldGet(this, _PdqPerspectiveViewer_subscription, "f").unsubscribe();
            log(`awaiting table: ${__classPrivateFieldGet(this, _PdqPerspectiveViewer_table, "f")}`);
            const table = await (0, _tableBroker.tableBroker).getTable(__classPrivateFieldGet(this, _PdqPerspectiveViewer_table, "f"));
            log(`acquired table: ${__classPrivateFieldGet(this, _PdqPerspectiveViewer_table, "f")}`);
            await this._perspectivePresent.promise;
            log("loading table");
            __classPrivateFieldSet(this, _PdqPerspectiveViewer_subscription, table.subscribe(async (t)=>{
                // this.#subscription.unsubscribe()
                // this.#subscription = table!.subscribe(async t => {
                //   log('table change');
                //   await this.perspectiveViewer?.load(t)
                //   await this.hideColumnsAsRequired();
                //   await this._updateSlicers(t)
                //   await this._updatePreview()
                // })
                log("table changed", this._loaded, this.__table === t, this.__table == t);
                this.__table = t;
                const config = this.config || {};
                // if(this._loaded) {
                //   await this.perspectiveViewer?.reset()
                // }
                await this.perspectiveViewer?.load(t);
                log("restoring config", config);
                await this.perspectiveViewer?.restore(config);
                this.config = config;
                await this.hideColumnsAsRequired();
                this._perspectiveLoaded.resolve(true);
                await this._updateSlicers(t);
                await this._updatePreview();
                this.perspectiveViewer?.setAttribute("theme", this.theme);
                this._loaded = true;
            }), "f");
        } else log("updateData: no table to load...");
    }
    async _onSlotChange(event) {
        log(`${this.id} - slot change`);
        const slot = event.target;
        const nodes = slot.assignedNodes({
            flatten: true
        });
        const text = (0, _utils.extractTextFromScripts)(nodes);
        if (!text.trim()) {
            log(`ignoring blank config`);
            return;
        }
        try {
            //debugger
            await this._perspectiveLoaded.promise;
            this.config = JSON.parse(text);
            await this.perspectiveViewer.restore(this.config);
            await this.hideColumnsAsRequired();
            await this._updatePreview();
        } catch (e) {
            log(`WARNING - pdq-view#${this.id}|Error parsing JSON: \n${e?.message || e}`);
            (0, _notificationService.notificationService).warning(`pdq-view#${this.id}|Error parsing JSON: \n${e?.message || e}`);
        }
    }
    async _updatePreview() {
        //log('update preview override...')
        // return
        // await this._perspectiveLoaded.promise
        log("update preview");
        this.config = await this.perspectiveViewer?.save();
        this.dataPreview = `<pdq-perspective-viewer${this.id ? (0, _lit.html)` id="${this.id}"` : ""}${this.table ? (0, _lit.html)` table="${this.table}"` : ""}><template>${JSON.stringify(this.config, null, 2)}</template></pdq-perspective-viewer>`;
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        // log('CHANGE', _changedProperties)
        this.addEventListeners();
        if (_changedProperties.has("config")) {
            if (this.config && this.perspectiveViewer && this._loaded) this.perspectiveViewer.restore(this.config);
        }
    }
    firstUpdated(props) {
        this.addEventListeners();
        this.updateTheme();
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateTheme();
    }
    disconnectedCallback() {
        __classPrivateFieldGet(this, _PdqPerspectiveViewer_subscription, "f").unsubscribe();
        (0, _tableBroker.tableBroker).removeViewer(this.id);
        super.disconnectedCallback();
    }
    async _updateSlicers(table) {
        if (this.slicers.length === 0) return;
        log("update slicers");
        const slicerElements = this.shadowRoot?.querySelectorAll(".dpl-slicer") || [];
        const innerFunc = async (slicer)=>{
            log("update slicers ... inner", slicer);
            try {
                const col = slicer.dataset.slicer;
                const config = {
                    "group_by": [
                        col
                    ],
                    "columns": [
                        col
                    ],
                    "aggregates": {}
                };
                config.aggregates[`${col}`] = "distinct count";
                const v = await table.view(config);
                const data = (await v.to_json()).map((i)=>i.__ROW_PATH__[0]);
                await v.delete();
                const viewConfig = await this.perspectiveViewer.save();
                if (!viewConfig.filter) viewConfig.filter = [];
                const existingFilter = viewConfig.filter.filter((i)=>i[0] === col);
                let selectedValue = undefined;
                if (existingFilter.length > 0) selectedValue = existingFilter[0][2];
                //console.log('data', data);
                [
                    ...slicer.options
                ].map((i)=>slicer.options.remove(i));
                data.forEach((i)=>{
                    //console.log(`"i" ${typeof i}`)
                    const item = document.createElement("option");
                    item.classList.add("cds--select-option");
                    item.setAttribute("value", i || null);
                    item.textContent = i === undefined ? "All" : i;
                    if (i === selectedValue) item.setAttribute("selected", "selected");
                    slicer.options.add(item);
                });
            } catch (e) {
                log(`update slicer failed: ${e}`, slicer);
            }
        };
        if (!table || !this.perspectiveViewer || !slicerElements || slicerElements.length == 0) return;
        const promises = [];
        for (const slicer of [
            ...slicerElements
        ])promises.push(innerFunc(slicer));
        await Promise.all(promises);
    }
    slicerChanged(evt) {
        const target = evt.target;
        const col = target.dataset["slicer"];
        const operator = target.dataset["operator"];
        const value = target.value;
        const filter = this.config.filter = [
            ...(this.config.filter || []).filter((i)=>i[0] != col)
        ];
        if (value !== null && value !== "null") filter.push([
            col,
            operator,
            value
        ]);
        const old = this.config;
        this.config = {
            ...this.config,
            filter
        };
        this.requestUpdate("config", old);
    }
    updateTheme() {
        if (this.theme != "auto") return;
        const themes = new Set([
            "cds-theme-zone-white",
            "cds-theme-zone-g10",
            "cds-theme-zone-g90",
            "cds-theme-zone-g100"
        ]);
        let theme = null;
        let el = this;
        while(theme == null && el){
            const classList = el.classList || [];
            for (const c of classList)if (themes.has(c)) {
                theme = c;
                break;
            }
            if (el.parentElement) el = el.parentElement;
            else if (el.parentNode instanceof ShadowRoot) el = el.parentNode.host;
            else el = null;
        }
        this.perspectiveViewer?.resetThemes([
            "Pro Light",
            "Pro Dark"
        ]);
        log(`closest outside theme = ${theme}`);
        switch(theme){
            case "cds-theme-zone-white":
            case "cds-theme-zone-g10":
                this.theme = "Pro Light";
                break;
            case "cds-theme-zone-g90":
            case "cds-theme-zone-g100":
                this.theme = "Pro Dark";
                break;
            default:
        }
        this.perspectiveViewer?.setAttribute("theme", this.theme);
        setTimeout(()=>{
            this.perspectiveViewer?.setAttribute("theme", this.theme);
        }, 300); // why needed?
    }
};
_PdqPerspectiveViewer_table = new WeakMap(), _PdqPerspectiveViewer_perspectiveViewer = new WeakMap(), _PdqPerspectiveViewer_subscription = new WeakMap();
PdqPerspectiveViewer.styles = [
    (0, _styles.hide),
    (0, _styles.row),
    (0, _styles.col),
    (0, _styles.grow),
    (0, _styles.padding),
    (0, _styles.margin),
    (0, _lit.unsafeCSS)((0, _themesCssDefault.default)),
    (0, _lit.css)`perspective-viewer {font-family: "IBM Plex Sans", "Helvetica Neue", Arial, sans-serif!important;}`,
    (0, _lit.css)`.dpl-slicer{width: 100%}`,
    (0, _lit.css)`
        td.psp-align-right,  td.psp-align-left, th.psp-align-right,  th.psp-align-left  {
            text-overflow: ellipsis;
            overflow-x: hidden;
        }
    `
];
PdqPerspectiveViewer.next_id = 0;
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqPerspectiveViewer.prototype, "id", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: Boolean
    }),
    __metadata("design:type", Boolean)
], PdqPerspectiveViewer.prototype, "show", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqPerspectiveViewer.prototype, "theme", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqPerspectiveViewer.prototype, "height", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: Boolean
    }),
    __metadata("design:type", Boolean)
], PdqPerspectiveViewer.prototype, "hideIndex", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: Array
    }),
    __metadata("design:type", Array)
], PdqPerspectiveViewer.prototype, "hiddenColumns", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: Boolean
    }),
    __metadata("design:type", Boolean)
], PdqPerspectiveViewer.prototype, "selectable", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: Boolean
    }),
    __metadata("design:type", Boolean)
], PdqPerspectiveViewer.prototype, "editable", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: Array
    }),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [
        Array
    ])
], PdqPerspectiveViewer.prototype, "slicers", null);
__decorate([
    (0, _decoratorsJs.state)(),
    __metadata("design:type", Object)
], PdqPerspectiveViewer.prototype, "dataPreview", void 0);
__decorate([
    (0, _decoratorsJs.property)(),
    __metadata("design:type", Object)
], PdqPerspectiveViewer.prototype, "error", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [
        String
    ])
], PdqPerspectiveViewer.prototype, "table", null);
__decorate([
    (0, _decoratorsJs.property)({
        type: Object
    }),
    __metadata("design:type", Object)
], PdqPerspectiveViewer.prototype, "config", void 0);
__decorate([
    (0, _decoratorsJs.query)("perspective-viewer"),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [
        Object
    ])
], PdqPerspectiveViewer.prototype, "perspectiveViewer", null);
__decorate([
    (0, _decoratorsJs.query)("cds-textarea"),
    __metadata("design:type", Object)
], PdqPerspectiveViewer.prototype, "configEditor", void 0);
PdqPerspectiveViewer = PdqPerspectiveViewer_1 = __decorate([
    (0, _decoratorsJs.customElement)("pdq-perspective-viewer"),
    (0, _pdqMixin.pdqDiscoveryLayer)(log, (0, _16JsDefault.default), "pdq-perspective-viewer", "rgba(83, 83, 236, 0.13)", (0, _defs.TAG_TYPE).PURPLE)
], PdqPerspectiveViewer);

},{"lit/decorators.js":"kQrIl","lit":"aCmte","../services/TableBroker":"kJzSP","@finos/perspective-viewer/dist/esm/perspective-viewer.inline.js":"25MzN","@finos/perspective-viewer-datagrid/dist/esm/perspective-viewer-datagrid.js":"2k5Dg","@carbon/web-components/es/components/copy-button/index.js":"5DrQc","@carbon/web-components/es/components/icon-button/index.js":"hEDP1","@carbon/web-components/es/components/textarea/index.js":"i8YTZ","@carbon/web-components/es/icons/debug/16.js":"ce58x","debug":"17JIf","../styles":"86IFJ","./_pdq-mixin":"66yqo","@carbon/web-components/es/components/tag/defs":"ioe2X","@finos/perspective-viewer/dist/esm/perspective-viewer.inline":"25MzN","bundle-text:@finos/perspective-viewer/dist/css/themes.css":"6iGjj","../utils":"i8jxn","../services/notificationService":"2Yic8","rxjs":"d4Szo","../services/DataBroker":"kD6gB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kJzSP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NO_TABLE_YET", ()=>NO_TABLE_YET);
parcelHelpers.export(exports, "NO_DATASOURCE_YET", ()=>NO_DATASOURCE_YET);
parcelHelpers.export(exports, "NO_INDEX_SETUP", ()=>NO_INDEX_SETUP);
parcelHelpers.export(exports, "TableBroker", ()=>TableBroker);
parcelHelpers.export(exports, "tableBroker", ()=>tableBroker);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _perspectiveInlineJs = require("@finos/perspective/dist/esm/perspective.inline.js");
var _perspectiveInlineJsDefault = parcelHelpers.interopDefault(_perspectiveInlineJs);
var _rxjs = require("rxjs");
var _utils = require("../utils");
var _dataBroker = require("./DataBroker");
const log = (0, _debugDefault.default)("pdq:services:TableBroker");
const NO_TABLE_YET = Symbol("NO_TABLE_YET");
const NO_DATASOURCE_YET = Symbol("NO_DATASOURCE_YET");
const NO_INDEX_SETUP = Symbol("NO_INDEX_SETUP");
class TableBroker {
    constructor(){
        this._worker = (0, _perspectiveInlineJsDefault.default).shared_worker();
        this._tables = new Map();
        this._tablesChanged = new (0, _rxjs.Subject)();
        this._tableRemoved = new (0, _rxjs.Subject)();
        this._tableAdded = new (0, _rxjs.Subject)();
        this._tableChanged = new (0, _rxjs.Subject)();
        this.tablesChanged = this._tablesChanged.pipe((0, _rxjs.debounceTime)(30), (0, _rxjs.share)());
        this.tableRemoved = this._tableRemoved.pipe((0, _rxjs.share)());
        this.tableAdded = this._tableAdded.pipe((0, _rxjs.debounceTime)(30), (0, _rxjs.share)());
        this.tableChanged = this._tableChanged.pipe((0, _rxjs.share)());
        this._viewers = new Map();
        log("TableBroker created");
        (0, _dataBroker.dataBroker).dataSourceRemoved.subscribe(this._purgeTables);
        this._tableChanged.subscribe((i)=>log(`table changed: ${i}`));
    }
    async createTableWithSchema(name, source, schema, index) {
        const existing = this._tables.get(name);
        if (existing && existing.datasource === source) {
            log(`Table ${name} already registered... skipping add`);
            return existing.sharedObservable;
        }
        log(`Creating table ${name}`);
        const meta = this._setupTable(name);
        if (meta.table !== NO_TABLE_YET) return;
        meta.table = await this._worker.table(schema, {
            index
        });
        const ds = await (0, _dataBroker.dataBroker).getObservableDataSource(source);
        this.subscribe(meta, ds, name, source, index);
    }
    async setTable(name, source, index = "") {
        const existing = this._tables.get(name);
        if (existing && existing.datasource === source) {
            log(`Table ${name} already registered... skipping add`);
            return existing.sharedObservable;
        }
        // console.group('setTable')
        log(`Adding table ${name} from ${source}`);
        {
            const ds = await (0, _dataBroker.dataBroker).getObservableDataSource(source);
            const meta = this._setupTable(name);
            this.subscribe(meta, ds, name, source, index);
            const existingValue = (0, _dataBroker.dataBroker).getDataSource(source);
            if (existingValue && existingValue != (0, _dataBroker.NO_VALUE_OR_NO_SUBSCRIPTION_YET)) this.tableDataChanged(meta, ds, name, source, index, existingValue).catch((e)=>log("failed to set existing data into new table", e));
            return meta.sharedObservable;
        }
    }
    subscribe(meta, ds, name, source, index) {
        meta.subscription = ds.pipe((0, _rxjs.tap)((i)=>log(`TAP: Adding table ${name} from ${source}`))).subscribe((i)=>this.tableDataChanged(meta, ds, name, source, index, i));
    }
    async tableDataChanged(meta, ds, name, source, index, i) {
        log(`data updated... updating table ${name}`, i);
        const data = await this.convertData(i);
        if (meta.table === NO_TABLE_YET) {
            log(`Creating table ${name}`);
            const table = await this._worker.table(data, {
                index
            });
            meta.dataKeys = data.length > 0 ? Object.keys(data[0]) : [];
            meta.table = table;
            meta.datasource = source;
            meta.references.add({
                from: {
                    type: "data",
                    name: source
                },
                to: {
                    type: "table",
                    name
                }
            });
            meta.index = index;
            this._tableAdded.next(name);
            this._tablesChanged.next([
                ...this._tables.keys()
            ]);
            meta.subject.next(table);
            return;
        }
        let table = meta.table;
        if (data.length === 0) {
            if (index) {
                await table.replace(i);
                meta.subject.next(table);
            }
            return;
        }
        const keys = Object.keys(data[0]);
        if (this.arraysDiffer(meta.dataKeys, keys)) {
            log(`table columns changed... recreating table ${name}`, meta.dataKeys, keys);
            table = await this._worker.table(data, {
                index
            });
            meta.table = table;
        }
        if (index) {
            log(`Updating table ${name}`);
            table.update(i);
            meta.subject.next(table);
        } else {
            log(`Replacing table ${name}`);
            await table.replace(i);
            meta.subject.next(table);
        }
        meta.schema = await table.schema();
        this._tableChanged.next(name);
    }
    clearTable(name) {
        const t = this._tables.get(name);
        if (t && t.table && t.table !== NO_TABLE_YET) t.table?.clear();
    }
    getTable(name) {
        const meta = this._setupTable(name);
        return meta.sharedObservable;
    }
    getTableMeta(name) {
        const meta = {
            ...this._tables.get(name)
        };
        delete meta.subject;
        return meta;
    }
    async convertData(data) {
        if (data instanceof Blob) return await (0, _utils.blobToArrayBuffer)(data);
        else return data;
    }
    _setupTable(name) {
        let meta = this._tables.get(name);
        if (meta) return meta;
        log(`Creating table placeholder ${name}`);
        const subject = new (0, _rxjs.ReplaySubject)(1);
        meta = {
            id: name,
            index: NO_INDEX_SETUP,
            table: NO_TABLE_YET,
            datasource: NO_DATASOURCE_YET,
            subscription: (0, _rxjs.Subscription).EMPTY,
            references: new Set(),
            subject: subject,
            sharedObservable: subject.pipe((0, _rxjs.shareReplay)(1))
        };
        this._tables.set(name, meta);
        this._tableAdded.next(name);
        return meta;
    }
    async _purgeTables(removedDataSource) {
        for (const [key, value] of this._tables)if (value.datasource == removedDataSource) {
            if (value.table !== NO_TABLE_YET) await value.table.delete();
            value.subject.complete();
            value.subscription.unsubscribe();
            this._tables.delete(key);
            this._tableRemoved.next(key);
            this._tablesChanged.next([
                ...this._tables.keys()
            ]);
        }
    }
    addViewer(id, v) {
        this._viewers.set(id, v);
    }
    getViewer(id) {
        return this._viewers.get(id);
    }
    removeViewer(id) {
        this._viewers.delete(id);
    }
    info() {
        console.log("TABLES");
        console.table([
            ...this._tables.entries()
        ].map((i)=>({
                ...i[1],
                key: i[0]
            })), [
            "id",
            "index",
            "references",
            "datasource"
        ]);
        console.log("VIEWERS");
        console.table([
            ...this._viewers.entries()
        ].map((i)=>({
                element: i[1],
                key: i[0]
            })), [
            "key",
            "element"
        ]);
    }
    schemasDiffer(schema1, schema2) {
        const keys1 = Object.keys(schema1);
        const keys2 = Object.keys(schema2);
        if (keys1.length !== keys2.length) return true;
        for(let i = 0; i < keys1.length; i++){
            if (keys1[i] !== keys2[i]) return true;
        }
        for (let key of keys1){
            if (schema1[key] !== schema2[key]) return true;
        }
        return false;
    }
    arraysDiffer(arr1, arr2) {
        if (arr1 === arr2) return false;
        if (!arr1 || !arr2) return true;
        const len = arr1.length;
        if (len !== arr2.length) return true;
        for(let i = 0; len > i; i++){
            if (arr1[i] != arr2[i]) return true;
        }
        return false;
    }
}
const tableBroker = new TableBroker();

},{"debug":"17JIf","@finos/perspective/dist/esm/perspective.inline.js":"2MYBx","rxjs":"d4Szo","../utils":"i8jxn","./DataBroker":"kD6gB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2MYBx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tt);
parcelHelpers.export(exports, "get_type_config", ()=>et);
parcelHelpers.export(exports, "override", ()=>me);
parcelHelpers.export(exports, "shared_worker", ()=>be);
parcelHelpers.export(exports, "websocket", ()=>Oe);
parcelHelpers.export(exports, "worker", ()=>ke);
var X = Object.create;
var m = Object.defineProperty;
var P = Object.getOwnPropertyDescriptor;
var Q = Object.getOwnPropertyNames;
var J = Object.getPrototypeOf, B = Object.prototype.hasOwnProperty;
var H = (r, e)=>()=>(e || r((e = {
            exports: {}
        }).exports, e), e.exports), W = (r, e)=>{
    for(var t in e)m(r, t, {
        get: e[t],
        enumerable: !0
    });
}, R = (r, e, t, n)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let i of Q(e))!B.call(r, i) && i !== t && m(r, i, {
        get: ()=>e[i],
        enumerable: !(n = P(e, i)) || n.enumerable
    });
    return r;
};
var ee = (r, e, t)=>(t = r != null ? X(J(r)) : {}, R(e || !r || !r.__esModule ? m(t, "default", {
        value: r,
        enumerable: !0
    }) : t, r));
var te = (()=>{
    for(var r = new Uint8Array(128), e = 0; e < 64; e++)r[e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e * 4 - 205] = e;
    return (t)=>{
        for(var n = t.length, i = new Uint8Array((n - (t[n - 1] == "=") - (t[n - 2] == "=")) * 3 / 4 | 0), l = 0, c = 0; l < n;){
            var f = r[t.charCodeAt(l++)], h = r[t.charCodeAt(l++)], F = r[t.charCodeAt(l++)], K = r[t.charCodeAt(l++)];
            i[c++] = f << 2 | h >> 4, i[c++] = h << 4 | F >> 2, i[c++] = F << 6 | K;
        }
        return i;
    };
})();
var C = H((Ce, S)=>{
    "use strict";
    S.exports = function() {
        throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
    };
});
var O = {};
W(O, {
    COLUMN_SEPARATOR_STRING: ()=>fe,
    CONFIG_ALIASES: ()=>ne,
    CONFIG_VALID_KEYS: ()=>ie,
    DATA_TYPES: ()=>re,
    FILTER_OPERATORS: ()=>o,
    SORT_ORDERS: ()=>oe,
    SORT_ORDER_IDS: ()=>ae,
    TYPE_AGGREGATES: ()=>ue,
    TYPE_FILTERS: ()=>he
});
var re = {
    integer: "integer",
    float: "float",
    string: "string",
    boolean: "boolean",
    date: "date",
    datetime: "datetime",
    object: "object"
}, ne = {
    row_pivot: "group_by",
    "row-pivot": "group_by",
    "row-pivots": "group_by",
    col_pivot: "split_by",
    col_pivots: "split_by",
    column_pivot: "split_by",
    "column-pivot": "split_by",
    "column-pivots": "split_by",
    filters: "filter",
    sorts: "sort"
}, ie = [
    "version",
    "viewport",
    "group_by",
    "split_by",
    "aggregates",
    "columns",
    "filter",
    "sort",
    "computed_columns",
    "expressions",
    "group_by_depth",
    "split_by_depth",
    "filter_op"
], q = [
    "any",
    "avg",
    "abs sum",
    "count",
    "distinct count",
    "dominant",
    "first by index",
    "last by index",
    "last minus first",
    "last",
    "high",
    "join",
    "low",
    "high minus low",
    "max",
    "mean",
    "median",
    "min",
    "pct sum parent",
    "pct sum grand total",
    "stddev",
    "sum",
    "sum abs",
    "sum not null",
    "unique",
    "var"
], k = [
    "any",
    "count",
    "distinct count",
    "distinct leaf",
    "dominant",
    "first by index",
    "join",
    "last by index",
    "last",
    "unique"
], se = [
    "any",
    "count",
    "distinct count",
    "distinct leaf",
    "dominant",
    "first by index",
    "last by index",
    "last",
    "unique"
], oe = [
    "none",
    "asc",
    "desc",
    "col asc",
    "col desc",
    "asc abs",
    "desc abs",
    "col asc abs",
    "col desc abs"
], ae = [
    2,
    0,
    1,
    0,
    1,
    3,
    4,
    3,
    4
], ue = {
    string: k,
    float: q,
    integer: q,
    boolean: se,
    datetime: k,
    date: k
}, o = {
    lessThan: "<",
    greaterThan: ">",
    equals: "==",
    lessThanOrEquals: "<=",
    greaterThanOrEquals: ">=",
    doesNotEqual: "!=",
    isNull: "is null",
    isNotNull: "is not null",
    isIn: "in",
    isNotIn: "not in",
    contains: "contains",
    bitwiseAnd: "&",
    bitwiseOr: "|",
    and: "and",
    or: "or",
    beginsWith: "begins with",
    endsWith: "ends with"
}, le = [
    o.bitwiseAnd,
    o.bitwiseOr,
    o.equals,
    o.doesNotEqual,
    o.or,
    o.and,
    o.isNull,
    o.isNotNull
], L = [
    o.lessThan,
    o.greaterThan,
    o.equals,
    o.lessThanOrEquals,
    o.greaterThanOrEquals,
    o.doesNotEqual,
    o.isNull,
    o.isNotNull
], ce = [
    o.equals,
    o.contains,
    o.doesNotEqual,
    o.isIn,
    o.isNotIn,
    o.beginsWith,
    o.endsWith,
    o.isNull,
    o.isNotNull
], U = [
    o.lessThan,
    o.greaterThan,
    o.equals,
    o.lessThanOrEquals,
    o.greaterThanOrEquals,
    o.doesNotEqual,
    o.isNull,
    o.isNotNull
], fe = "|", he = {
    string: ce,
    float: L,
    integer: L,
    boolean: le,
    datetime: U,
    date: U
};
var b = {
    types: {
        float: {
            filter_operator: "==",
            aggregate: "sum",
            format: {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        },
        string: {
            filter_operator: "==",
            aggregate: "count"
        },
        integer: {
            filter_operator: "==",
            aggregate: "sum",
            format: {}
        },
        boolean: {
            filter_operator: "==",
            aggregate: "count"
        },
        datetime: {
            filter_operator: "==",
            aggregate: "count",
            format: {
                dateStyle: "short",
                timeStyle: "medium"
            },
            null_value: -1
        },
        date: {
            filter_operator: "==",
            aggregate: "count",
            format: {
                dateStyle: "short"
            },
            null_value: -1
        }
    }
};
function V(r) {
    let e = {};
    if (p().types[r] && Object.assign(e, p().types[r]), e.type) {
        let t = V(e.type);
        return Object.assign(t, e), t;
    } else return e;
}
function w(r) {
    return r && typeof r == "object" && !Array.isArray(r);
}
function y(r, ...e) {
    if (!e.length) return r;
    let t = e.shift();
    if (w(r) && w(t)) for(let n in t)w(t[n]) ? (r[n] || Object.assign(r, {
        [n]: {}
    }), y(r[n], t[n])) : Object.assign(r, {
        [n]: t[n]
    });
    return y(r, ...e);
}
function I(r) {
    globalThis.__PERSPECTIVE_CONFIG__ && console.warn("Config already initialized!"), globalThis.__PERSPECTIVE_CONFIG__ = y(b, r);
}
function p() {
    return globalThis.__PERSPECTIVE_CONFIG__ || (globalThis.__PERSPECTIVE_CONFIG__ = y(b, globalThis.__TEMPLATE_CONFIG__ || {})), globalThis.__PERSPECTIVE_CONFIG__;
}
var Z = new WeakMap, N = 0;
function _(r, e) {
    return function() {
        let t, n = ()=>{}, i = Array.prototype.slice.call(arguments, 0, arguments.length);
        for(let f = i.length - 1; f >= 0; f--)typeof i[f] == "function" && (t = i.splice(f, 1)[0]);
        let l = Z.get(t);
        Z.delete(t);
        let c = {
            cmd: e || "view_method",
            name: this._name,
            method: r,
            args: i,
            subscribe: !0,
            callback_id: l
        };
        this._worker.post(c, t, n), this._worker.unsubscribe(e, t);
    };
}
function A(r, e) {
    return function() {
        let t, n = ()=>{}, i = Array.prototype.slice.call(arguments, 0, arguments.length);
        for(let c = i.length - 1; c >= 0; c--)typeof i[c] == "function" && (t = i.splice(c, 1)[0]);
        N++, Z.set(t, N);
        let l = {
            cmd: e || "view_method",
            name: this._name,
            method: r,
            args: i,
            subscribe: !0,
            callback_id: N
        };
        this._worker.post(l, t, n, !0);
    };
}
function s(r, e) {
    return function() {
        var t = Array.prototype.slice.call(arguments, 0, arguments.length);
        return new Promise((function(n, i) {
            var l = {
                cmd: e || "view_method",
                name: this._name,
                method: r,
                args: t,
                subscribe: !1
            };
            this._worker.post(l, n, i);
        }).bind(this));
    };
}
function a(r, e, t) {
    return new Promise((n, i)=>{
        this._worker = r, this._name = Math.random() + "", this._worker.post({
            cmd: "view",
            view_name: this._name,
            table_name: e,
            config: t
        }, ()=>{
            n(this);
        }, i), this._worker._initialized === !0 && !this._worker._features?.wait_for_response && n(this);
    });
}
function de(r, e) {
    this._worker = r, this._name = e;
}
de.prototype = a.prototype;
a.prototype.get_config = s("get_config");
a.prototype.get_min_max = s("get_min_max");
a.prototype.to_json = s("to_json");
a.prototype.to_arrow = s("to_arrow");
a.prototype.to_columns = s("to_columns");
a.prototype.to_columns_string = s("to_columns_string");
a.prototype.to_csv = s("to_csv");
a.prototype.schema = s("schema");
a.prototype.expression_schema = s("expression_schema");
a.prototype.column_paths = s("column_paths");
a.prototype.num_columns = s("num_columns");
a.prototype.num_rows = s("num_rows");
a.prototype.dimensions = s("dimensions");
a.prototype.set_depth = s("set_depth");
a.prototype.get_row_expanded = s("get_row_expanded");
a.prototype.expand = s("expand");
a.prototype.collapse = s("collapse");
a.prototype.delete = s("delete");
a.prototype.col_to_js_typed_array = s("col_to_js_typed_array");
a.prototype.on_update = A("on_update", "view_method", !0);
a.prototype.remove_update = _("remove_update", "view_method", !0);
a.prototype.on_delete = A("on_delete", "view_method", !0);
a.prototype.remove_delete = _("remove_delete", "view_method", !0);
function g(r) {
    let e = r;
    do for (let t of Object.getOwnPropertyNames(e)){
        let n = r[t];
        t !== "constructor" && typeof n == "function" && (r[t] = n.bind(r));
    }
    while (e = e !== Object && Object.getPrototypeOf(e));
}
String.prototype.includes || (String.prototype.includes = function(r, e) {
    return typeof e != "number" && (e = 0), e + r.length > this.length ? !1 : this.indexOf(r, e) !== -1;
});
Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", {
    value: function(r, e) {
        if (this == null) throw new TypeError('"this" is null or not defined');
        var t = Object(this), n = t.length >>> 0;
        if (n === 0) return !1;
        var i = e | 0, l = Math.max(i >= 0 ? i : n - Math.abs(i), 0);
        function c(f, h) {
            return f === h || typeof f == "number" && typeof h == "number" && isNaN(f) && isNaN(h);
        }
        for(; l < n;){
            if (c(t[l], r)) return !0;
            l++;
        }
        return !1;
    }
});
function u(r, e, t) {
    return new Promise((n, i)=>{
        this._worker = r, this._name = t.name || Math.random() + "", g(this), e.to_arrow ? (this._worker.post({
            cmd: "table",
            name: this._name,
            args: [],
            options: t || {}
        }), e.to_arrow().then((l)=>{
            this._worker.post({
                cmd: "table",
                name: this._name,
                args: [
                    l
                ],
                options: t || {}
            }, ()=>{
                e.on_update((c)=>{
                    this.update(c.delta);
                }, {
                    mode: "row"
                }), n(this);
            }, i);
        })) : this._worker.post({
            cmd: "table",
            name: this._name,
            args: [
                e
            ],
            options: t || {}
        }, ()=>{
            n(this);
        }, i), this._worker._initialized === !0 && !this._worker._features?.wait_for_response && n(this);
    });
}
u.prototype.type = "table";
function z(r, e) {
    this._worker = r, this._name = e;
}
z.prototype = u.prototype;
u.prototype.view = function(r) {
    return new a(this._worker, this._name, r);
};
u.prototype.query_columns = s("query_columns", "table_method");
u.prototype.get_index = s("get_index", "table_method");
u.prototype.get_limit = s("get_limit", "table_method");
u.prototype.get_num_views = s("get_num_views", "table_method");
u.prototype.make_port = s("make_port", "table_method");
u.prototype.remove_port = s("remove_port", "table_method");
u.prototype.schema = s("schema", "table_method");
u.prototype.validate_expressions = s("validate_expressions", "table_method");
u.prototype.is_valid_filter = s("is_valid_filter", "table_method");
u.prototype.size = s("size", "table_method");
u.prototype.num_rows = s("num_rows", "table_method");
u.prototype.num_columns = s("num_columns", "table_method");
u.prototype.columns = s("columns", "table_method");
u.prototype.clear = s("clear", "table_method");
u.prototype.replace = s("replace", "table_method");
u.prototype.delete = s("delete", "table_method");
u.prototype.on_delete = A("on_delete", "table_method", !0);
u.prototype.remove = s("remove", "table_method");
u.prototype.remove_delete = _("remove_delete", "table_method", !0);
u.prototype.update = function(r, e) {
    return new Promise((t, n)=>{
        this._worker.post({
            name: this._name,
            cmd: "table_method",
            method: "update",
            args: [
                r,
                e || {}
            ]
        }, t, n, !1);
    });
};
u.prototype.execute = function(r) {
    this._worker.post({
        cmd: "table_execute",
        name: this._name,
        f: r.toString()
    });
};
var d = class {
    constructor(){
        this._initialized = !1, this._worker = {
            initialized: {
                value: !1
            },
            transferable: !1,
            msg_id: 0,
            handlers: {},
            messages: []
        }, g(this);
    }
    unsubscribe(e, t) {
        for (let n of Object.keys(this._worker.handlers))this._worker.handlers[n].resolve === t && delete this._worker.handlers[n];
    }
    post(e, t, n, i = !1) {
        ++this._worker.msg_id, (t || n) && (this._worker.handlers[this._worker.msg_id] = {
            resolve: t,
            reject: n,
            keep_alive: i
        }), e.id = this._worker.msg_id, this._worker.initialized.value ? this.send(e) : this._worker.messages.push(()=>{
            this.send(e), (e.cmd === "table" || e.cmd === "view") && !this._features?.wait_for_response && t && t();
        });
    }
    async memory_usage() {
        return await new Promise((e, t)=>{
            this.post({
                cmd: "memory_usage"
            }, e, t);
        });
    }
    async get_hosted_table_names() {
        return await new Promise((e, t)=>{
            this.post({
                cmd: "get_hosted_table_names"
            }, e, t);
        });
    }
    initialize_profile_thread() {
        this._worker.initialized.value ? this.send({
            id: -1,
            cmd: "init_profile_thread"
        }) : this._worker.messages.push(()=>this.send({
                id: -1,
                cmd: "init_profile_thread"
            }));
    }
    send() {
        throw new Error("send() not implemented");
    }
    async open_table(e) {
        return new z(this, e);
    }
    _handle(e) {
        if (!this._worker.initialized.value) {
            this._initialized || (this._initialized = !0);
            let t = this._worker.messages;
            if (this._worker.initialized.value = !0, this._worker.messages = [], e.data?.data) {
                this._features = {};
                for (let n of e.data.data)this._features[n] = !0;
            }
            if (t) for(let n in t)t.hasOwnProperty(n) && t[n]();
        }
        if (e.data.id) {
            let t = this._worker.handlers[e.data.id];
            t && (e.data.error ? t.reject(e.data.error) : t.resolve(e.data.data), t.keep_alive || delete this._worker.handlers[e.data.id]);
        }
    }
    table(e, t) {
        return new u(this, e, t || {});
    }
    terminate() {
        this._worker.terminate(), this._worker = void 0;
    }
};
var T = ee(C()), _e = 3e4, v = class extends d {
    _ping() {
        this._ping_loop && this._ws.send("ping"), this._ping_loop = setTimeout(this._ping.bind(this), _e);
    }
    _close() {
        clearTimeout(this._ping_loop), this._ping_loop = void 0, this._on_close_callback?.();
    }
    _onmessage(e) {
        if (e.data !== "pong") {
            if (this._pending_binary) {
                let t = e.data;
                if (this._full_binary.set(new Uint8Array(t), this._total_chunk_length), this._total_chunk_length += t.byteLength, this._total_chunk_length === this._pending_binary_length) t = this._full_binary.buffer;
                else return;
                let n = {
                    data: {
                        id: this._pending_binary,
                        data: t
                    }
                };
                if (this._pending_port_id !== void 0) {
                    let i = {
                        port_id: this._pending_port_id,
                        delta: t
                    };
                    n.data.data = i;
                }
                this._handle(n), delete this._pending_binary, delete this._pending_binary_length, delete this._pending_port_id, this._total_chunk_length = 0, this._full_binary = null;
            } else e = JSON.parse(e.data), e.binary_length ? (this._pending_binary = e.id, this._pending_binary_length = e.binary_length, e.data && e.data.port_id !== void 0 && (this._pending_port_id = e.data.port_id), this._full_binary = new Uint8Array(this._pending_binary_length)) : this._handle({
                data: e
            });
        }
    }
    constructor(e){
        super(), this._ws = e, this._ws.binaryType = "arraybuffer", this._full_binary, this._total_chunk_length = 0, this._pending_binary_length = 0, this._ws.onopen = ()=>{
            this.send({
                id: -1,
                cmd: "init"
            });
        }, this._ping(), this._ws.onclose = this._close.bind(this), this._ws.onmessage = this._onmessage.bind(this);
    }
    send(e) {
        if (this._ws.readyState === T.default.CLOSED) {
            console.warn("Websocket connection is already closed.");
            return;
        }
        if (e.args && e.args.length > 0 && e.args[0] instanceof ArrayBuffer && e.args[0].byteLength !== void 0) {
            let t = e;
            e.binary_length = e.args[0].byteLength, this._ws.send(JSON.stringify(t)), this._ws.send(e.args[0]);
            return;
        }
        this._ws.send(JSON.stringify(e));
    }
    terminate() {
        return new Promise((e)=>{
            this._on_close_callback = e, this._ws.close();
        });
    }
};
var E = '(()=>{var zi=Object.defineProperty;var Gi=(m,o)=>{for(var a in o)zi(m,a,{get:o[a],enumerable:!0})};var Cr={},Bi=(()=>{var m=Cr.url;return function(o={}){var a=o,w,F;a.ready=new Promise((e,t)=>{w=e,F=t});var S=Object.assign({},a),k=[],W="./this.program",H=(e,t)=>{throw t},se=!0,O=!1,Q="";function ht(e){return a.locateFile?a.locateFile(e,Q):Q+e}var vt,Ce,Se;(se||O)&&(O?Q=self.location.href:typeof document<"u"&&document.currentScript&&(Q=document.currentScript.src),m&&(Q=m),Q.indexOf("blob:")!==0?Q=Q.substr(0,Q.replace(/[?#].*/,"").lastIndexOf("/")+1):Q="",vt=e=>{var t=new XMLHttpRequest;return t.open("GET",e,!1),t.send(null),t.responseText},O&&(Se=e=>{var t=new XMLHttpRequest;return t.open("GET",e,!1),t.responseType="arraybuffer",t.send(null),new Uint8Array(t.response)}),Ce=(e,t,r)=>{var n=new XMLHttpRequest;n.open("GET",e,!0),n.responseType="arraybuffer",n.onload=()=>{if(n.status==200||n.status==0&&n.response){t(n.response);return}r()},n.onerror=r,n.send(null)});var ke=a.print||console.log.bind(console),X=a.printErr||console.error.bind(console);Object.assign(a,S),S=null,a.arguments&&(k=a.arguments),a.thisProgram&&(W=a.thisProgram),a.quit&&(H=a.quit);var V;a.wasmBinary&&(V=a.wasmBinary),typeof WebAssembly!="object"&&Lt("no native wasm support detected");var Re,de=!1,we,K,q,i,s,l,_,v,b,T,y;function N(){var e=Re.buffer;a.HEAP8=K=new Int8Array(e),a.HEAP16=i=new Int16Array(e),a.HEAPU8=q=new Uint8Array(e),a.HEAPU16=s=new Uint16Array(e),a.HEAP32=l=new Int32Array(e),a.HEAPU32=_=new Uint32Array(e),a.HEAPF32=v=new Float32Array(e),a.HEAPF64=y=new Float64Array(e),a.HEAP64=b=new BigInt64Array(e),a.HEAPU64=T=new BigUint64Array(e)}var A=[],I=[],Y=[],le=[],L=!1;function re(){if(a.preRun)for(typeof a.preRun=="function"&&(a.preRun=[a.preRun]);a.preRun.length;)Vr(a.preRun.shift());qe(A)}function ce(){L=!0,qe(I)}function gt(){qe(Y)}function Be(){if(a.postRun)for(typeof a.postRun=="function"&&(a.postRun=[a.postRun]);a.postRun.length;)Dr(a.postRun.shift());qe(le)}function Vr(e){A.unshift(e)}function Dr(e){le.unshift(e)}var ge=0,mt=null,xe=null;function Ur(e){ge++,a.monitorRunDependencies&&a.monitorRunDependencies(ge)}function jr(e){if(ge--,a.monitorRunDependencies&&a.monitorRunDependencies(ge),ge==0&&(mt!==null&&(clearInterval(mt),mt=null),xe)){var t=xe;xe=null,t()}}function Lt(e){a.onAbort&&a.onAbort(e),e="Aborted("+e+")",X(e),de=!0,we=1,e+=". Build with -sASSERTIONS for more info.";var t=new WebAssembly.RuntimeError(e);throw F(t),t}var Wr="data:application/octet-stream;base64,",zt=e=>e.startsWith(Wr),me;a.locateFile?(me="perspective.cpp.wasm",zt(me)||(me=ht(me))):me=new URL("perspective.cpp.wasm",Cr.url).href;function Gt(e){if(e==me&&V)return new Uint8Array(V);if(Se)return Se(e);throw"both async and sync fetching of the wasm failed"}function Mr(e){return!V&&(se||O)&&typeof fetch=="function"?fetch(e,{credentials:"same-origin"}).then(t=>{if(!t.ok)throw"failed to load wasm binary file at \'"+e+"\'";return t.arrayBuffer()}).catch(()=>Gt(e)):Promise.resolve().then(()=>Gt(e))}function Bt(e,t,r){return Mr(e).then(n=>WebAssembly.instantiate(n,t)).then(n=>n).then(r,n=>{X(`failed to asynchronously prepare wasm: ${n}`),Lt(n)})}function Hr(e,t,r,n){return!e&&typeof WebAssembly.instantiateStreaming=="function"&&!zt(t)&&typeof fetch=="function"?fetch(t,{credentials:"same-origin"}).then(c=>{var u=WebAssembly.instantiateStreaming(c,r);return u.then(n,function(d){return X(`wasm streaming compile failed: ${d}`),X("falling back to ArrayBuffer instantiation"),Bt(t,r,n)})}):Bt(t,r,n)}function Lr(){var e={env:br,wasi_snapshot_preview1:br};function t(n,c){return Z=n.exports,Z=Mi(Z),Re=Z.memory,N(),ar=Z.__indirect_function_table,jr("wasm-instantiate"),Z}Ur("wasm-instantiate");function r(n){t(n.instance)}if(a.instantiateWasm)try{return a.instantiateWasm(e,t)}catch(n){X(`Module.instantiateWasm callback failed with error: ${n}`),F(n)}return Hr(V,me,e,r).catch(F),{}}var zr={847732:e=>{throw new Error(Fe(e))}};function qt(e){this.name="ExitStatus",this.message=`Program terminated with exit(${e})`,this.status=e}var qe=e=>{for(;e.length>0;)e.shift()(a)},Gr=a.noExitRuntime||!0,Yt=typeof TextDecoder<"u"?new TextDecoder("utf8"):void 0,Jt=(e,t,r)=>{t>>>=0;for(var n=t+r,c=t;e[c]&&!(c>=n);)++c;if(c-t>16&&e.buffer&&Yt)return Yt.decode(e.subarray(t,c));for(var u="";t<c;){var d=e[t++];if(!(d&128)){u+=String.fromCharCode(d);continue}var f=e[t++]&63;if((d&224)==192){u+=String.fromCharCode((d&31)<<6|f);continue}var h=e[t++]&63;if((d&240)==224?d=(d&15)<<12|f<<6|h:d=(d&7)<<18|f<<12|h<<6|e[t++]&63,d<65536)u+=String.fromCharCode(d);else{var p=d-65536;u+=String.fromCharCode(55296|p>>10,56320|p&1023)}}return u},Fe=(e,t)=>(e>>>=0,e?Jt(q,e,t):""),yt={varargs:void 0,get(){var e=l[+yt.varargs>>>2>>>0];return yt.varargs+=4,e},getp(){return yt.get()},getStr(e){var t=Fe(e);return t}},Br=9007199254740992,qr=-9007199254740992,bt=e=>e<qr||e>Br?NaN:Number(e);function Yr(e,t){t=bt(t)}var Xt=(e,t,r,n)=>{if(r>>>=0,!(n>0))return 0;for(var c=r,u=r+n-1,d=0;d<e.length;++d){var f=e.charCodeAt(d);if(f>=55296&&f<=57343){var h=e.charCodeAt(++d);f=65536+((f&1023)<<10)|h&1023}if(f<=127){if(r>=u)break;t[r++>>>0]=f}else if(f<=2047){if(r+1>=u)break;t[r++>>>0]=192|f>>6,t[r++>>>0]=128|f&63}else if(f<=65535){if(r+2>=u)break;t[r++>>>0]=224|f>>12,t[r++>>>0]=128|f>>6&63,t[r++>>>0]=128|f&63}else{if(r+3>=u)break;t[r++>>>0]=240|f>>18,t[r++>>>0]=128|f>>12&63,t[r++>>>0]=128|f>>6&63,t[r++>>>0]=128|f&63}}return t[r>>>0]=0,r-c},Jr=(e,t,r)=>Xt(e,q,t,r);function Xr(e,t,r){t>>>=0,r>>>=0}var Ye={},wt=e=>{for(;e.length;){var t=e.pop(),r=e.pop();r(t)}};function Tt(e){return this.fromWireType(l[e>>>2>>>0])}var Te={},ye={},Je={},Kt,Xe=e=>{throw new Kt(e)},pe=(e,t,r)=>{e.forEach(function(f){Je[f]=t});function n(f){var h=r(f);h.length!==e.length&&Xe("Mismatched type converter count");for(var p=0;p<e.length;++p)ne(e[p],h[p])}var c=new Array(t.length),u=[],d=0;t.forEach((f,h)=>{ye.hasOwnProperty(f)?c[h]=ye[f]:(u.push(f),Te.hasOwnProperty(f)||(Te[f]=[]),Te[f].push(()=>{c[h]=ye[f],++d,d===u.length&&n(c)}))}),u.length===0&&n(c)},Kr=function(e){e>>>=0;var t=Ye[e];delete Ye[e];var r=t.rawConstructor,n=t.rawDestructor,c=t.fields,u=c.map(d=>d.getterReturnType).concat(c.map(d=>d.setterArgumentType));pe([e],u,d=>{var f={};return c.forEach((h,p)=>{var g=h.fieldName,$=d[p],R=h.getter,C=h.getterContext,M=d[p+c.length],G=h.setter,B=h.setterContext;f[g]={read:P=>$.fromWireType(R(C,P)),write:(P,E)=>{var U=[];G(B,P,M.toWireType(U,E)),wt(U)}}}),[{name:t.name,fromWireType:h=>{var p={};for(var g in f)p[g]=f[g].read(h);return n(h),p},toWireType:(h,p)=>{for(var g in f)if(!(g in p))throw new TypeError(`Missing field: "${g}"`);var $=r();for(g in f)f[g].write($,p[g]);return h!==null&&h.push(n,$),$},argPackAdvance:ie,readValueFromPointer:Tt,destructorFunction:n}]})},Ne=e=>{if(e===null)return"null";var t=typeof e;return t==="object"||t==="array"||t==="function"?e.toString():""+e},Zr=()=>{for(var e=new Array(256),t=0;t<256;++t)e[t]=String.fromCharCode(t);Zt=e},Zt,z=e=>{for(var t="",r=e;q[r>>>0];)t+=Zt[q[r++>>>0]];return t},$e,D=e=>{throw new $e(e)};function Qr(e,t,r={}){var n=t.name;if(e||D(`type "${n}" must have a positive integer typeid pointer`),ye.hasOwnProperty(e)){if(r.ignoreDuplicateRegistrations)return;D(`Cannot register type \'${n}\' twice`)}if(ye[e]=t,delete Je[e],Te.hasOwnProperty(e)){var c=Te[e];delete Te[e],c.forEach(u=>u())}}function ne(e,t,r={}){if(!("argPackAdvance"in t))throw new TypeError("registerType registeredInstance requires argPackAdvance");return Qr(e,t,r)}var Qt=(e,t,r)=>{switch(t){case 1:return r?n=>K[n>>>0>>>0]:n=>q[n>>>0>>>0];case 2:return r?n=>i[n>>>1>>>0]:n=>s[n>>>1>>>0];case 4:return r?n=>l[n>>>2>>>0]:n=>_[n>>>2>>>0];case 8:return r?n=>b[n>>>3]:n=>T[n>>>3];default:throw new TypeError(`invalid integer width (${t}): ${e}`)}};function en(e,t,r,n,c){e>>>=0,t>>>=0,r>>>=0,t=z(t);var u=t.indexOf("u")!=-1;u&&(c=(1n<<64n)-1n),ne(e,{name:t,fromWireType:d=>d,toWireType:function(d,f){if(typeof f!="bigint"&&typeof f!="number")throw new TypeError(`Cannot convert "${Ne(f)}" to ${this.name}`);if(f<n||f>c)throw new TypeError(`Passing a number "${Ne(f)}" from JS side to C/C++ side to an argument of type "${t}", which is outside the valid range [${n}, ${c}]!`);return f},argPackAdvance:ie,readValueFromPointer:Qt(t,r,!u),destructorFunction:null})}var ie=8;function tn(e,t,r,n){e>>>=0,t>>>=0,t=z(t),ne(e,{name:t,fromWireType:function(c){return!!c},toWireType:function(c,u){return u?r:n},argPackAdvance:ie,readValueFromPointer:function(c){return this.fromWireType(q[c>>>0])},destructorFunction:null})}var rn=e=>({count:e.count,deleteScheduled:e.deleteScheduled,preservePointerOnDelete:e.preservePointerOnDelete,ptr:e.ptr,ptrType:e.ptrType,smartPtr:e.smartPtr,smartPtrType:e.smartPtrType}),$t=e=>{function t(r){return r.$$.ptrType.registeredClass.name}D(t(e)+" instance already deleted")},At=!1,er=e=>{},nn=e=>{e.smartPtr?e.smartPtrType.rawDestructor(e.smartPtr):e.ptrType.registeredClass.rawDestructor(e.ptr)},tr=e=>{e.count.value-=1;var t=e.count.value===0;t&&nn(e)},rr=(e,t,r)=>{if(t===r)return e;if(r.baseClass===void 0)return null;var n=rr(e,t,r.baseClass);return n===null?null:r.downcast(n)},nr={},sn=()=>Object.keys(De).length,on=()=>{var e=[];for(var t in De)De.hasOwnProperty(t)&&e.push(De[t]);return e},Ie=[],Et=()=>{for(;Ie.length;){var e=Ie.pop();e.$$.deleteScheduled=!1,e.delete()}},Ve,an=e=>{Ve=e,Ie.length&&Ve&&Ve(Et)},ln=()=>{a.getInheritedInstanceCount=sn,a.getLiveInheritedInstances=on,a.flushPendingDeletes=Et,a.setDelayFunction=an},De={},cn=(e,t)=>{for(t===void 0&&D("ptr should not be undefined");e.baseClass;)t=e.upcast(t),e=e.baseClass;return t},un=(e,t)=>(t=cn(e,t),De[t]),Ke=(e,t)=>{(!t.ptrType||!t.ptr)&&Xe("makeClassHandle requires ptr and ptrType");var r=!!t.smartPtrType,n=!!t.smartPtr;return r!==n&&Xe("Both smartPtrType and smartPtr must be specified"),t.count={value:1},Ue(Object.create(e,{$$:{value:t}}))};function fn(e){var t=this.getPointee(e);if(!t)return this.destructor(e),null;var r=un(this.registeredClass,t);if(r!==void 0){if(r.$$.count.value===0)return r.$$.ptr=t,r.$$.smartPtr=e,r.clone();var n=r.clone();return this.destructor(e),n}function c(){return this.isSmartPointer?Ke(this.registeredClass.instancePrototype,{ptrType:this.pointeeType,ptr:t,smartPtrType:this,smartPtr:e}):Ke(this.registeredClass.instancePrototype,{ptrType:this,ptr:e})}var u=this.registeredClass.getActualType(t),d=nr[u];if(!d)return c.call(this);var f;this.isConst?f=d.constPointerType:f=d.pointerType;var h=rr(t,this.registeredClass,f.registeredClass);return h===null?c.call(this):this.isSmartPointer?Ke(f.registeredClass.instancePrototype,{ptrType:f,ptr:h,smartPtrType:this,smartPtr:e}):Ke(f.registeredClass.instancePrototype,{ptrType:f,ptr:h})}var Ue=e=>typeof FinalizationRegistry>"u"?(Ue=t=>t,e):(At=new FinalizationRegistry(t=>{tr(t.$$)}),Ue=t=>{var r=t.$$,n=!!r.smartPtr;if(n){var c={$$:r};At.register(t,c,t)}return t},er=t=>At.unregister(t),Ue(e)),_n=()=>{Object.assign(Ze.prototype,{isAliasOf(e){if(!(this instanceof Ze)||!(e instanceof Ze))return!1;var t=this.$$.ptrType.registeredClass,r=this.$$.ptr;e.$$=e.$$;for(var n=e.$$.ptrType.registeredClass,c=e.$$.ptr;t.baseClass;)r=t.upcast(r),t=t.baseClass;for(;n.baseClass;)c=n.upcast(c),n=n.baseClass;return t===n&&r===c},clone(){if(this.$$.ptr||$t(this),this.$$.preservePointerOnDelete)return this.$$.count.value+=1,this;var e=Ue(Object.create(Object.getPrototypeOf(this),{$$:{value:rn(this.$$)}}));return e.$$.count.value+=1,e.$$.deleteScheduled=!1,e},delete(){this.$$.ptr||$t(this),this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete&&D("Object already scheduled for deletion"),er(this),tr(this.$$),this.$$.preservePointerOnDelete||(this.$$.smartPtr=void 0,this.$$.ptr=void 0)},isDeleted(){return!this.$$.ptr},deleteLater(){return this.$$.ptr||$t(this),this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete&&D("Object already scheduled for deletion"),Ie.push(this),Ie.length===1&&Ve&&Ve(Et),this.$$.deleteScheduled=!0,this}})};function Ze(){}var Ae=(e,t)=>Object.defineProperty(t,"name",{value:e}),ir=(e,t,r)=>{if(e[t].overloadTable===void 0){var n=e[t];e[t]=function(){return e[t].overloadTable.hasOwnProperty(arguments.length)||D(`Function \'${r}\' called with an invalid number of arguments (${arguments.length}) - expects one of (${e[t].overloadTable})!`),e[t].overloadTable[arguments.length].apply(this,arguments)},e[t].overloadTable=[],e[t].overloadTable[n.argCount]=n}},Pt=(e,t,r)=>{a.hasOwnProperty(e)?((r===void 0||a[e].overloadTable!==void 0&&a[e].overloadTable[r]!==void 0)&&D(`Cannot register public name \'${e}\' twice`),ir(a,e,e),a.hasOwnProperty(r)&&D(`Cannot register multiple overloads of a function with the same number of arguments (${r})!`),a[e].overloadTable[r]=t):(a[e]=t,r!==void 0&&(a[e].numArguments=r))},dn=48,pn=57,hn=e=>{if(e===void 0)return"_unknown";e=e.replace(/[^a-zA-Z0-9_]/g,"$");var t=e.charCodeAt(0);return t>=dn&&t<=pn?`_${e}`:e};function vn(e,t,r,n,c,u,d,f){this.name=e,this.constructor=t,this.instancePrototype=r,this.rawDestructor=n,this.baseClass=c,this.getActualType=u,this.upcast=d,this.downcast=f,this.pureVirtualFunctions=[]}var Ot=(e,t,r)=>{for(;t!==r;)t.upcast||D(`Expected null or instance of ${r.name}, got an instance of ${t.name}`),e=t.upcast(e),t=t.baseClass;return e};function gn(e,t){if(t===null)return this.isReference&&D(`null is not a valid ${this.name}`),0;t.$$||D(`Cannot pass "${Ne(t)}" as a ${this.name}`),t.$$.ptr||D(`Cannot pass deleted object as a pointer of type ${this.name}`);var r=t.$$.ptrType.registeredClass,n=Ot(t.$$.ptr,r,this.registeredClass);return n}function mn(e,t){var r;if(t===null)return this.isReference&&D(`null is not a valid ${this.name}`),this.isSmartPointer?(r=this.rawConstructor(),e!==null&&e.push(this.rawDestructor,r),r):0;t.$$||D(`Cannot pass "${Ne(t)}" as a ${this.name}`),t.$$.ptr||D(`Cannot pass deleted object as a pointer of type ${this.name}`),!this.isConst&&t.$$.ptrType.isConst&&D(`Cannot convert argument of type ${t.$$.smartPtrType?t.$$.smartPtrType.name:t.$$.ptrType.name} to parameter type ${this.name}`);var n=t.$$.ptrType.registeredClass;if(r=Ot(t.$$.ptr,n,this.registeredClass),this.isSmartPointer)switch(t.$$.smartPtr===void 0&&D("Passing raw pointer to smart pointer is illegal"),this.sharingPolicy){case 0:t.$$.smartPtrType===this?r=t.$$.smartPtr:D(`Cannot convert argument of type ${t.$$.smartPtrType?t.$$.smartPtrType.name:t.$$.ptrType.name} to parameter type ${this.name}`);break;case 1:r=t.$$.smartPtr;break;case 2:if(t.$$.smartPtrType===this)r=t.$$.smartPtr;else{var c=t.clone();r=this.rawShare(r,j.toHandle(()=>c.delete())),e!==null&&e.push(this.rawDestructor,r)}break;default:D("Unsupporting sharing policy")}return r}function yn(e,t){if(t===null)return this.isReference&&D(`null is not a valid ${this.name}`),0;t.$$||D(`Cannot pass "${Ne(t)}" as a ${this.name}`),t.$$.ptr||D(`Cannot pass deleted object as a pointer of type ${this.name}`),t.$$.ptrType.isConst&&D(`Cannot convert argument of type ${t.$$.ptrType.name} to parameter type ${this.name}`);var r=t.$$.ptrType.registeredClass,n=Ot(t.$$.ptr,r,this.registeredClass);return n}function sr(e){return this.fromWireType(_[e>>>2>>>0])}var bn=()=>{Object.assign(je.prototype,{getPointee(e){return this.rawGetPointee&&(e=this.rawGetPointee(e)),e},destructor(e){this.rawDestructor&&this.rawDestructor(e)},argPackAdvance:ie,readValueFromPointer:sr,deleteObject(e){e!==null&&e.delete()},fromWireType:fn})};function je(e,t,r,n,c,u,d,f,h,p,g){this.name=e,this.registeredClass=t,this.isReference=r,this.isConst=n,this.isSmartPointer=c,this.pointeeType=u,this.sharingPolicy=d,this.rawGetPointee=f,this.rawConstructor=h,this.rawShare=p,this.rawDestructor=g,!c&&t.baseClass===void 0?n?(this.toWireType=gn,this.destructorFunction=null):(this.toWireType=yn,this.destructorFunction=null):this.toWireType=mn}var or=(e,t,r)=>{a.hasOwnProperty(e)||Xe("Replacing nonexistant public symbol"),a[e].overloadTable!==void 0&&r!==void 0?a[e].overloadTable[r]=t:(a[e]=t,a[e].argCount=r)},Qe=[],ar,wn=e=>{var t=Qe[e];return t||(e>=Qe.length&&(Qe.length=e+1),Qe[e]=t=ar.get(e)),t},J=(e,t)=>{e=z(e);function r(){return wn(t)}var n=r();return typeof n!="function"&&D(`unknown function pointer with signature ${e}: ${t}`),n},Tn=(e,t)=>{var r=Ae(t,function(n){this.name=t,this.message=n;var c=new Error(n).stack;c!==void 0&&(this.stack=this.toString()+`\n`+c.replace(/^Error(:[^\\n]*)?\\n/,""))});return r.prototype=Object.create(e.prototype),r.prototype.constructor=r,r.prototype.toString=function(){return this.message===void 0?this.name:`${this.name}: ${this.message}`},r},lr,cr=e=>{var t=Tr(e),r=z(t);return ue(t),r},et=(e,t)=>{var r=[],n={};function c(u){if(!n[u]&&!ye[u]){if(Je[u]){Je[u].forEach(c);return}r.push(u),n[u]=!0}}throw t.forEach(c),new lr(`${e}: `+r.map(cr).join([", "]))};function $n(e,t,r,n,c,u,d,f,h,p,g,$,R){e>>>=0,t>>>=0,r>>>=0,n>>>=0,c>>>=0,u>>>=0,d>>>=0,f>>>=0,h>>>=0,p>>>=0,g>>>=0,$>>>=0,R>>>=0,g=z(g),u=J(c,u),f&&(f=J(d,f)),p&&(p=J(h,p)),R=J($,R);var C=hn(g);Pt(C,function(){et(`Cannot construct ${g} due to unbound types`,[n])}),pe([e,t,r],n?[n]:[],function(M){M=M[0];var G,B;n?(G=M.registeredClass,B=G.instancePrototype):B=Ze.prototype;var P=Ae(g,function(){if(Object.getPrototypeOf(this)!==E)throw new $e("Use \'new\' to construct "+g);if(U.constructor_body===void 0)throw new $e(g+" has no accessible constructor");var He=U.constructor_body[arguments.length];if(He===void 0)throw new $e(`Tried to invoke ctor of ${g} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(U.constructor_body).toString()}) parameters instead!`);return He.apply(this,arguments)}),E=Object.create(B,{constructor:{value:P}});P.prototype=E;var U=new vn(g,P,E,R,G,u,f,p);U.baseClass&&(U.baseClass.__derivedClasses===void 0&&(U.baseClass.__derivedClasses=[]),U.baseClass.__derivedClasses.push(U));var lt=new je(g,U,!0,!1,!1),be=new je(g+"*",U,!1,!1,!1),Me=new je(g+" const*",U,!1,!0,!1);return nr[e]={pointerType:be,constPointerType:Me},or(C,P),[lt,be,Me]})}var Ct=(e,t)=>{for(var r=[],n=0;n<e;n++)r.push(_[t+n*4>>>2>>>0]);return r};function ur(e,t){if(!(e instanceof Function))throw new TypeError(`new_ called with constructor type ${typeof e} which is not a function`);var r=Ae(e.name||"unknownFunctionName",function(){});r.prototype=e.prototype;var n=new r,c=e.apply(n,t);return c instanceof Object?c:n}function St(e,t,r,n,c,u){var d=t.length;d<2&&D("argTypes array size mismatch! Must at least get return value and \'this\' types!");for(var f=t[1]!==null&&r!==null,h=!1,p=1;p<t.length;++p)if(t[p]!==null&&t[p].destructorFunction===void 0){h=!0;break}for(var g=t[0].name!=="void",$="",R="",p=0;p<d-2;++p)$+=(p!==0?", ":"")+"arg"+p,R+=(p!==0?", ":"")+"arg"+p+"Wired";var C=`\n        return function (${$}) {\n        if (arguments.length !== ${d-2}) {\n          throwBindingError(\'function ${e} called with \' + arguments.length + \' arguments, expected ${d-2}\');\n        }`;h&&(C+=`var destructors = [];\n`);var M=h?"destructors":"null",G=["throwBindingError","invoker","fn","runDestructors","retType","classParam"],B=[D,n,c,wt,t[0],t[1]];f&&(C+="var thisWired = classParam.toWireType("+M+`, this);\n`);for(var p=0;p<d-2;++p)C+="var arg"+p+"Wired = argType"+p+".toWireType("+M+", arg"+p+"); // "+t[p+2].name+`\n`,G.push("argType"+p),B.push(t[p+2]);if(f&&(R="thisWired"+(R.length>0?", ":"")+R),C+=(g||u?"var rv = ":"")+"invoker(fn"+(R.length>0?", ":"")+R+`);\n`,h)C+=`runDestructors(destructors);\n`;else for(var p=f?1:2;p<t.length;++p){var P=p===1?"thisWired":"arg"+(p-2)+"Wired";t[p].destructorFunction!==null&&(C+=P+"_dtor("+P+"); // "+t[p].name+`\n`,G.push(P+"_dtor"),B.push(t[p].destructorFunction))}g&&(C+=`var ret = retType.fromWireType(rv);\nreturn ret;\n`),C+=`}\n`,G.push(C);var E=ur(Function,G).apply(null,B);return Ae(e,E)}function An(e,t,r,n,c,u){e>>>=0,r>>>=0,n>>>=0,c>>>=0,u>>>=0;var d=Ct(t,r);c=J(n,c),pe([],[e],function(f){f=f[0];var h=`constructor ${f.name}`;if(f.registeredClass.constructor_body===void 0&&(f.registeredClass.constructor_body=[]),f.registeredClass.constructor_body[t-1]!==void 0)throw new $e(`Cannot register multiple constructors with identical number of parameters (${t-1}) for class \'${f.name}\'! Overload resolution is currently only performed using the parameter count, not actual type info!`);return f.registeredClass.constructor_body[t-1]=()=>{et(`Cannot construct ${f.name} due to unbound types`,d)},pe([],d,p=>(p.splice(1,0,null),f.registeredClass.constructor_body[t-1]=St(h,p,null,c,u),[])),[]})}var fr=e=>{e=e.trim();let t=e.indexOf("(");return t!==-1?e.substr(0,t):e};function En(e,t,r,n,c,u,d,f,h){e>>>=0,t>>>=0,n>>>=0,c>>>=0,u>>>=0,d>>>=0;var p=Ct(r,n);t=z(t),t=fr(t),u=J(c,u),pe([],[e],function(g){g=g[0];var $=`${g.name}.${t}`;t.startsWith("@@")&&(t=Symbol[t.substring(2)]),f&&g.registeredClass.pureVirtualFunctions.push(t);function R(){et(`Cannot call ${$} due to unbound types`,p)}var C=g.registeredClass.instancePrototype,M=C[t];return M===void 0||M.overloadTable===void 0&&M.className!==g.name&&M.argCount===r-2?(R.argCount=r-2,R.className=g.name,C[t]=R):(ir(C,t,$),C[t].overloadTable[r-2]=R),pe([],p,function(G){var B=St($,G,g,u,d,h);return C[t].overloadTable===void 0?(B.argCount=r-2,C[t]=B):C[t].overloadTable[r-2]=B,[]}),[]})}function Pn(){Object.assign(_r.prototype,{get(e){return this.allocated[e]},has(e){return this.allocated[e]!==void 0},allocate(e){var t=this.freelist.pop()||this.allocated.length;return this.allocated[t]=e,t},free(e){this.allocated[e]=void 0,this.freelist.push(e)}})}function _r(){this.allocated=[void 0],this.freelist=[]}var ee=new _r;function kt(e){e>>>=0,e>=ee.reserved&&--ee.get(e).refcount===0&&ee.free(e)}var On=()=>{for(var e=0,t=ee.reserved;t<ee.allocated.length;++t)ee.allocated[t]!==void 0&&++e;return e},Cn=()=>{ee.allocated.push({value:void 0},{value:null},{value:!0},{value:!1}),ee.reserved=ee.allocated.length,a.count_emval_handles=On},j={toValue:e=>(e||D("Cannot use deleted val. handle = "+e),ee.get(e).value),toHandle:e=>{switch(e){case void 0:return 1;case null:return 2;case!0:return 3;case!1:return 4;default:return ee.allocate({refcount:1,value:e})}}},Sn=function(e,t){e>>>=0,t>>>=0,t=z(t),ne(e,{name:t,fromWireType:r=>{var n=j.toValue(r);return kt(r),n},toWireType:(r,n)=>j.toHandle(n),argPackAdvance:ie,readValueFromPointer:Tt,destructorFunction:null})},kn=(e,t,r)=>{switch(t){case 1:return r?function(n){return this.fromWireType(K[n>>>0>>>0])}:function(n){return this.fromWireType(q[n>>>0>>>0])};case 2:return r?function(n){return this.fromWireType(i[n>>>1>>>0])}:function(n){return this.fromWireType(s[n>>>1>>>0])};case 4:return r?function(n){return this.fromWireType(l[n>>>2>>>0])}:function(n){return this.fromWireType(_[n>>>2>>>0])};default:throw new TypeError(`invalid integer width (${t}): ${e}`)}};function Rn(e,t,r,n){e>>>=0,t>>>=0,r>>>=0,t=z(t);function c(){}c.values={},ne(e,{name:t,constructor:c,fromWireType:function(u){return this.constructor.values[u]},toWireType:(u,d)=>d.value,argPackAdvance:ie,readValueFromPointer:kn(t,r,n),destructorFunction:null}),Pt(t,c)}var tt=(e,t)=>{var r=ye[e];return r===void 0&&D(t+" has unknown type "+cr(e)),r};function xn(e,t,r){e>>>=0,t>>>=0,r>>>=0;var n=tt(e,"enum");t=z(t);var c=n.constructor,u=Object.create(n.constructor.prototype,{value:{value:r},constructor:{value:Ae(`${n.name}_${t}`,function(){})}});c.values[r]=u,c[t]=u}var Fn=(e,t)=>{switch(t){case 4:return function(r){return this.fromWireType(v[r>>>2>>>0])};case 8:return function(r){return this.fromWireType(y[r>>>3>>>0])};default:throw new TypeError(`invalid float width (${t}): ${e}`)}},Nn=function(e,t,r){e>>>=0,t>>>=0,r>>>=0,t=z(t),ne(e,{name:t,fromWireType:n=>n,toWireType:(n,c)=>c,argPackAdvance:ie,readValueFromPointer:Fn(t,r),destructorFunction:null})};function In(e,t,r,n,c,u,d){e>>>=0,r>>>=0,n>>>=0,c>>>=0,u>>>=0;var f=Ct(t,r);e=z(e),e=fr(e),c=J(n,c),Pt(e,function(){et(`Cannot call ${e} due to unbound types`,f)},t-1),pe([],f,function(h){var p=[h[0],null].concat(h.slice(1));return or(e,St(e,p,null,c,u,d),t-1),[]})}function Vn(e,t,r,n,c){e>>>=0,t>>>=0,r>>>=0,t=z(t),c===-1&&(c=4294967295);var u=g=>g;if(n===0){var d=32-8*r;u=g=>g<<d>>>d}var f=t.includes("unsigned"),h=(g,$)=>{},p;f?p=function(g,$){return h($,this.name),$>>>0}:p=function(g,$){return h($,this.name),$},ne(e,{name:t,fromWireType:u,toWireType:p,argPackAdvance:ie,readValueFromPointer:Qt(t,r,n!==0),destructorFunction:null})}function Dn(e,t,r){e>>>=0,r>>>=0;var n=[Int8Array,Uint8Array,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array,BigInt64Array,BigUint64Array],c=n[t];function u(d){var f=_[d>>>2>>>0],h=_[d+4>>>2>>>0];return new c(K.buffer,h,f)}r=z(r),ne(e,{name:r,fromWireType:u,argPackAdvance:ie,readValueFromPointer:u},{ignoreDuplicateRegistrations:!0})}function Un(e,t,r,n,c,u,d,f,h,p,g,$){e>>>=0,t>>>=0,r>>>=0,c>>>=0,u>>>=0,d>>>=0,f>>>=0,h>>>=0,p>>>=0,g>>>=0,$>>>=0,r=z(r),u=J(c,u),f=J(d,f),p=J(h,p),$=J(g,$),pe([e],[t],function(R){R=R[0];var C=new je(r,R.registeredClass,!1,!1,!0,R,n,u,f,p,$);return[C]})}var dr=e=>{for(var t=0,r=0;r<e.length;++r){var n=e.charCodeAt(r);n<=127?t++:n<=2047?t+=2:n>=55296&&n<=57343?(t+=4,++r):t+=3}return t};function jn(e,t){e>>>=0,t>>>=0,t=z(t);var r=t==="std::string";ne(e,{name:t,fromWireType(n){var c=_[n>>>2>>>0],u=n+4,d;if(r)for(var f=u,h=0;h<=c;++h){var p=u+h;if(h==c||q[p>>>0]==0){var g=p-f,$=Fe(f,g);d===void 0?d=$:(d+=String.fromCharCode(0),d+=$),f=p+1}}else{for(var R=new Array(c),h=0;h<c;++h)R[h]=String.fromCharCode(q[u+h>>>0]);d=R.join("")}return ue(n),d},toWireType(n,c){c instanceof ArrayBuffer&&(c=new Uint8Array(c));var u,d=typeof c=="string";d||c instanceof Uint8Array||c instanceof Uint8ClampedArray||c instanceof Int8Array||D("Cannot pass non-string to std::string"),r&&d?u=dr(c):u=c.length;var f=Nt(4+u+1),h=f+4;if(_[f>>>2>>>0]=u,r&&d)Jr(c,h,u+1);else if(d)for(var p=0;p<u;++p){var g=c.charCodeAt(p);g>255&&(ue(h),D("String has UTF-16 code units that do not fit in 8 bits")),q[h+p>>>0]=g}else for(var p=0;p<u;++p)q[h+p>>>0]=c[p];return n!==null&&n.push(ue,f),f},argPackAdvance:ie,readValueFromPointer:sr,destructorFunction(n){ue(n)}})}var pr=typeof TextDecoder<"u"?new TextDecoder("utf-16le"):void 0,Wn=(e,t)=>{for(var r=e,n=r>>1,c=n+t/2;!(n>=c)&&s[n>>>0];)++n;if(r=n<<1,r-e>32&&pr)return pr.decode(q.subarray(e>>>0,r>>>0));for(var u="",d=0;!(d>=t/2);++d){var f=i[e+d*2>>>1>>>0];if(f==0)break;u+=String.fromCharCode(f)}return u},Mn=(e,t,r)=>{if(r===void 0&&(r=2147483647),r<2)return 0;r-=2;for(var n=t,c=r<e.length*2?r/2:e.length,u=0;u<c;++u){var d=e.charCodeAt(u);i[t>>>1>>>0]=d,t+=2}return i[t>>>1>>>0]=0,t-n},Hn=e=>e.length*2,Ln=(e,t)=>{for(var r=0,n="";!(r>=t/4);){var c=l[e+r*4>>>2>>>0];if(c==0)break;if(++r,c>=65536){var u=c-65536;n+=String.fromCharCode(55296|u>>10,56320|u&1023)}else n+=String.fromCharCode(c)}return n},zn=(e,t,r)=>{if(t>>>=0,r===void 0&&(r=2147483647),r<4)return 0;for(var n=t,c=n+r-4,u=0;u<e.length;++u){var d=e.charCodeAt(u);if(d>=55296&&d<=57343){var f=e.charCodeAt(++u);d=65536+((d&1023)<<10)|f&1023}if(l[t>>>2>>>0]=d,t+=4,t+4>c)break}return l[t>>>2>>>0]=0,t-n},Gn=e=>{for(var t=0,r=0;r<e.length;++r){var n=e.charCodeAt(r);n>=55296&&n<=57343&&++r,t+=4}return t},Bn=function(e,t,r){e>>>=0,t>>>=0,r>>>=0,r=z(r);var n,c,u,d,f;t===2?(n=Wn,c=Mn,d=Hn,u=()=>s,f=1):t===4&&(n=Ln,c=zn,d=Gn,u=()=>_,f=2),ne(e,{name:r,fromWireType:h=>{for(var p=_[h>>>2>>>0],g=u(),$,R=h+4,C=0;C<=p;++C){var M=h+4+C*t;if(C==p||g[M>>>f]==0){var G=M-R,B=n(R,G);$===void 0?$=B:($+=String.fromCharCode(0),$+=B),R=M+t}}return ue(h),$},toWireType:(h,p)=>{typeof p!="string"&&D(`Cannot pass non-string to C++ string type ${r}`);var g=d(p),$=Nt(4+g+t);return _[$>>>2]=g>>f,c(p,$+4,g+t),h!==null&&h.push(ue,$),$},argPackAdvance:ie,readValueFromPointer:Tt,destructorFunction(h){ue(h)}})};function qn(e,t,r,n,c,u){e>>>=0,t>>>=0,r>>>=0,n>>>=0,c>>>=0,u>>>=0,Ye[e]={name:z(t),rawConstructor:J(r,n),rawDestructor:J(c,u),fields:[]}}function Yn(e,t,r,n,c,u,d,f,h,p){e>>>=0,t>>>=0,r>>>=0,n>>>=0,c>>>=0,u>>>=0,d>>>=0,f>>>=0,h>>>=0,p>>>=0,Ye[e].fields.push({fieldName:z(t),getterReturnType:r,getter:J(n,c),getterContext:u,setterArgumentType:d,setter:J(f,h),setterContext:p})}var Jn=function(e,t){e>>>=0,t>>>=0,t=z(t),ne(e,{isVoid:!0,name:t,argPackAdvance:0,fromWireType:()=>{},toWireType:(r,n)=>{}})},hr=(e,t,r)=>{var n=[],c=e.toWireType(n,r);return n.length&&(_[t>>>2>>>0]=j.toHandle(n)),c};function Xn(e,t,r){return e>>>=0,t>>>=0,r>>>=0,e=j.toValue(e),t=tt(t,"emval::as"),hr(t,r,e)}var rt=[];function Kn(e,t,r,n){return e>>>=0,t>>>=0,r>>>=0,n>>>=0,e=rt[e],t=j.toValue(t),e(null,t,r,n)}var Zn={},nt=e=>{var t=Zn[e];return t===void 0?z(e):t};function Qn(e,t,r,n,c){return e>>>=0,t>>>=0,r>>>=0,n>>>=0,c>>>=0,e=rt[e],t=j.toValue(t),r=nt(r),e(t,t[r],n,c)}var vr=()=>typeof globalThis=="object"?globalThis:function(){return Function}()("return this")();function ei(e){return e>>>=0,e===0?j.toHandle(vr()):(e=nt(e),j.toHandle(vr()[e]))}var ti=e=>{var t=rt.length;return rt.push(e),t},ri=(e,t)=>{for(var r=new Array(e),n=0;n<e;++n)r[n]=tt(_[t+n*4>>>2>>>0],"parameter "+n);return r},ns=Reflect.construct;function ni(e,t,r){t>>>=0;var n=ri(e,t),c=n.shift();e--;var u=`return function (obj, func, destructorsRef, args) {\n`,d=0,f=[];r===0&&f.push("obj");for(var h=["retType"],p=[c],g=0;g<e;++g)f.push("arg"+g),h.push("argType"+g),p.push(n[g]),u+=`  var arg${g} = argType${g}.readValueFromPointer(args${d?"+"+d:""});\n`,d+=n[g].argPackAdvance;var $=r===1?"new func":"func.call";u+=`  var rv = ${$}(${f.join(", ")});\n`;for(var g=0;g<e;++g)n[g].deleteObject&&(u+=`  argType${g}.deleteObject(arg${g});\n`);c.isVoid||(h.push("emval_returnValue"),p.push(hr),u+=`  return emval_returnValue(retType, destructorsRef, rv);\n`),u+=`};\n`,h.push(u);var R=ur(Function,h).apply(null,p),C=`methodCaller<(${n.map(M=>M.name).join(", ")}) => ${c.name}>`;return ti(Ae(C,R))}function ii(e){return e>>>=0,e=nt(e),j.toHandle(a[e])}function si(e,t){return e>>>=0,t>>>=0,e=j.toValue(e),t=j.toValue(t),j.toHandle(e[t])}function oi(e){e>>>=0,e>4&&(ee.get(e).refcount+=1)}function ai(e,t){return e>>>=0,t>>>=0,e=j.toValue(e),t=j.toValue(t),e instanceof t}function li(){return j.toHandle([])}function ci(e){return e>>>=0,j.toHandle(nt(e))}function ui(){return j.toHandle({})}function fi(e){e>>>=0;var t=j.toValue(e);wt(t),kt(e)}function _i(e,t,r){e>>>=0,t>>>=0,r>>>=0,e=j.toValue(e),t=j.toValue(t),r=j.toValue(r),e[t]=r}function di(e,t){e>>>=0,t>>>=0,e=tt(e,"_emval_take_value");var r=e.readValueFromPointer(t);return j.toHandle(r)}function pi(e){return e>>>=0,e=j.toValue(e),j.toHandle(typeof e)}var gr;gr=()=>performance.now();var hi=!0,vi=e=>e==0||e==1||e==2||e==3;function gi(e,t,r){if(t=bt(t),r>>>=0,!vi(e))return 28;var n;if(e===0)n=Date.now();else if(hi)n=gr();else return 52;var c=Math.round(n*1e3*1e3);return l[r>>>2>>>0]=c>>>0,l[r+4>>>2>>>0]=c/Math.pow(2,32)>>>0,0}var Rt=[],mi=(e,t)=>{Rt.length=0;for(var r;r=q[e++>>>0];){var n=r!=105;n&=r!=112,t+=n&&t%8?4:0,Rt.push(r==112?_[t>>>2>>>0]:r==106?b[t>>>3]:r==105?l[t>>>2>>>0]:y[t>>>3>>>0]),t+=n?8:4}return Rt},yi=(e,t,r)=>{var n=mi(t,r);return zr[e].apply(null,n)};function bi(e,t,r){return e>>>=0,t>>>=0,r>>>=0,yi(e,t,r)}function wi(e){e>>>=0,N()}var xt={},Ti=()=>W||"./this.program",We=()=>{if(!We.strings){var e=(typeof navigator=="object"&&navigator.languages&&navigator.languages[0]||"C").replace("-","_")+".UTF-8",t={USER:"web_user",LOGNAME:"web_user",PATH:"/",PWD:"/",HOME:"/home/web_user",LANG:e,_:Ti()};for(var r in xt)xt[r]===void 0?delete t[r]:t[r]=xt[r];var n=[];for(var r in t)n.push(`${r}=${t[r]}`);We.strings=n}return We.strings},$i=(e,t)=>{for(var r=0;r<e.length;++r)K[t++>>>0>>>0]=e.charCodeAt(r);K[t>>>0>>>0]=0},Ai=function(e,t){e>>>=0,t>>>=0;var r=0;return We().forEach((n,c)=>{var u=t+r;_[e+c*4>>>2>>>0]=u,$i(n,u),r+=n.length+1}),0},Ei=function(e,t){e>>>=0,t>>>=0;var r=We();_[e>>>2>>>0]=r.length;var n=0;return r.forEach(c=>n+=c.length+1),_[t>>>2>>>0]=n,0},Pi=e=>52;function Oi(e,t,r,n){return t>>>=0,r>>>=0,n>>>=0,52}function Ci(e,t,r,n){return t=bt(t),n>>>=0,70}var Si=[null,[],[]],ki=(e,t)=>{var r=Si[e];t===0||t===10?((e===1?ke:X)(Jt(r,0)),r.length=0):r.push(t)};function Ri(e,t,r,n){t>>>=0,r>>>=0,n>>>=0;for(var c=0,u=0;u<r;u++){var d=_[t>>>2>>>0],f=_[t+4>>>2>>>0];t+=8;for(var h=0;h<f;h++)ki(e,q[d+h>>>0]);c+=f}return _[n>>>2>>>0]=c,0}var xi=0,Fi=()=>Gr||xi>0,mr=e=>{we=e,Fi()||(a.onExit&&a.onExit(e),de=!0),H(e,new qt(e))},Ft=e=>e%4===0&&(e%100!==0||e%400===0),yr=(e,t)=>{for(var r=0,n=0;n<=t;r+=e[n++]);return r},it=[31,29,31,30,31,30,31,31,30,31,30,31],st=[31,28,31,30,31,30,31,31,30,31,30,31],ot=(e,t)=>{for(var r=new Date(e.getTime());t>0;){var n=Ft(r.getFullYear()),c=r.getMonth(),u=(n?it:st)[c];if(t>u-r.getDate())t-=u-r.getDate()+1,r.setDate(1),c<11?r.setMonth(c+1):(r.setMonth(0),r.setFullYear(r.getFullYear()+1));else return r.setDate(r.getDate()+t),r}return r},te=e=>parseInt(e);function Ni(e,t,r){var n=r>0?r:dr(e)+1,c=new Array(n),u=Xt(e,c,0,c.length);return t&&(c.length=u),c}function Ii(e,t,r){e>>>=0,t>>>=0,r>>>=0;for(var n=Fe(t),c="\\\\!@#$^&*()+=-[]/{}|:<>?,.",u=0,d=c.length;u<d;++u)n=n.replace(new RegExp("\\\\"+c[u],"g"),"\\\\"+c[u]);var f={"%A":"%a","%B":"%b","%c":"%a %b %d %H:%M:%S %Y","%D":"%m\\\\/%d\\\\/%y","%e":"%d","%F":"%Y-%m-%d","%h":"%b","%R":"%H\\\\:%M","%r":"%I\\\\:%M\\\\:%S\\\\s%p","%T":"%H\\\\:%M\\\\:%S","%x":"%m\\\\/%d\\\\/(?:%y|%Y)","%X":"%H\\\\:%M\\\\:%S"};for(var h in f)n=n.replace(h,f[h]);var p={"%a":"(?:Sun(?:day)?)|(?:Mon(?:day)?)|(?:Tue(?:sday)?)|(?:Wed(?:nesday)?)|(?:Thu(?:rsday)?)|(?:Fri(?:day)?)|(?:Sat(?:urday)?)","%b":"(?:Jan(?:uary)?)|(?:Feb(?:ruary)?)|(?:Mar(?:ch)?)|(?:Apr(?:il)?)|May|(?:Jun(?:e)?)|(?:Jul(?:y)?)|(?:Aug(?:ust)?)|(?:Sep(?:tember)?)|(?:Oct(?:ober)?)|(?:Nov(?:ember)?)|(?:Dec(?:ember)?)","%C":"\\\\d\\\\d","%d":"0[1-9]|[1-9](?!\\\\d)|1\\\\d|2\\\\d|30|31","%H":"\\\\d(?!\\\\d)|[0,1]\\\\d|20|21|22|23","%I":"\\\\d(?!\\\\d)|0\\\\d|10|11|12","%j":"00[1-9]|0?[1-9](?!\\\\d)|0?[1-9]\\\\d(?!\\\\d)|[1,2]\\\\d\\\\d|3[0-6]\\\\d","%m":"0[1-9]|[1-9](?!\\\\d)|10|11|12","%M":"0\\\\d|\\\\d(?!\\\\d)|[1-5]\\\\d","%n":"\\\\s","%p":"AM|am|PM|pm|A\\\\.M\\\\.|a\\\\.m\\\\.|P\\\\.M\\\\.|p\\\\.m\\\\.","%S":"0\\\\d|\\\\d(?!\\\\d)|[1-5]\\\\d|60","%U":"0\\\\d|\\\\d(?!\\\\d)|[1-4]\\\\d|50|51|52|53","%W":"0\\\\d|\\\\d(?!\\\\d)|[1-4]\\\\d|50|51|52|53","%w":"[0-6]","%y":"\\\\d\\\\d","%Y":"\\\\d\\\\d\\\\d\\\\d","%%":"%","%t":"\\\\s"},g={JAN:0,FEB:1,MAR:2,APR:3,MAY:4,JUN:5,JUL:6,AUG:7,SEP:8,OCT:9,NOV:10,DEC:11},$={SUN:0,MON:1,TUE:2,WED:3,THU:4,FRI:5,SAT:6},R={MON:0,TUE:1,WED:2,THU:3,FRI:4,SAT:5,SUN:6};for(var C in p)n=n.replace(C,"("+C+p[C]+")");for(var M=[],u=n.indexOf("%");u>=0;u=n.indexOf("%"))M.push(n[u+1]),n=n.replace(new RegExp("\\\\%"+n[u+1],"g"),"");var G=new RegExp("^"+n,"i").exec(Fe(e));function B(){function he(ve,It,Or){return typeof ve!="number"||isNaN(ve)?It:ve>=It?ve<=Or?ve:Or:It}return{year:he(l[r+20>>>2>>>0]+1900,1970,9999),month:he(l[r+16>>>2>>>0],0,11),day:he(l[r+12>>>2>>>0],1,31),hour:he(l[r+8>>>2>>>0],0,23),min:he(l[r+4>>>2>>>0],0,59),sec:he(l[r>>>2>>>0],0,59)}}if(G){var P=B(),E,U=he=>{var ve=M.indexOf(he);if(ve>=0)return G[ve+1]};if((E=U("S"))&&(P.sec=te(E)),(E=U("M"))&&(P.min=te(E)),E=U("H"))P.hour=te(E);else if(E=U("I")){var lt=te(E);(E=U("p"))&&(lt+=E.toUpperCase()[0]==="P"?12:0),P.hour=lt}if(E=U("Y"))P.year=te(E);else if(E=U("y")){var be=te(E);(E=U("C"))?be+=te(E)*100:be+=be<69?2e3:1900,P.year=be}if((E=U("m"))?P.month=te(E)-1:(E=U("b"))&&(P.month=g[E.substring(0,3).toUpperCase()]||0),E=U("d"))P.day=te(E);else if(E=U("j"))for(var Me=te(E),He=Ft(P.year),ct=0;ct<12;++ct){var Er=yr(He?it:st,ct-1);Me<=Er+(He?it:st)[ct]&&(P.day=Me-Er)}else if(E=U("a")){var Pr=E.substring(0,3).toUpperCase();if(E=U("U")){var Le=$[Pr],ze=te(E),fe=new Date(P.year,0,1),_e;fe.getDay()===0?_e=ot(fe,Le+7*(ze-1)):_e=ot(fe,7-fe.getDay()+Le+7*(ze-1)),P.day=_e.getDate(),P.month=_e.getMonth()}else if(E=U("W")){var Le=R[Pr],ze=te(E),fe=new Date(P.year,0,1),_e;fe.getDay()===1?_e=ot(fe,Le+7*(ze-1)):_e=ot(fe,7-fe.getDay()+1+Le+7*(ze-1)),P.day=_e.getDate(),P.month=_e.getMonth()}}var oe=new Date(P.year,P.month,P.day,P.hour,P.min,P.sec,0);return l[r>>>2>>>0]=oe.getSeconds(),l[r+4>>>2>>>0]=oe.getMinutes(),l[r+8>>>2>>>0]=oe.getHours(),l[r+12>>>2>>>0]=oe.getDate(),l[r+16>>>2>>>0]=oe.getMonth(),l[r+20>>>2>>>0]=oe.getFullYear()-1900,l[r+24>>>2>>>0]=oe.getDay(),l[r+28>>>2>>>0]=yr(Ft(oe.getFullYear())?it:st,oe.getMonth()-1)+oe.getDate()-1,l[r+32>>>2>>>0]=0,e+Ni(G[0]).length-1}return 0}var Vi=(e,t)=>{we=e,mr(e)},Di=e=>{if(e instanceof qt||e=="unwind")return we;H(1,e)};Kt=a.InternalError=class extends Error{constructor(t){super(t),this.name="InternalError"}},Zr(),$e=a.BindingError=class extends Error{constructor(t){super(t),this.name="BindingError"}},_n(),ln(),bn(),lr=a.UnboundTypeError=Tn(Error,"UnboundTypeError"),Pn(),Cn();var br={__syscall_ftruncate64:Yr,__syscall_getdents64:Xr,_embind_finalize_value_object:Kr,_embind_register_bigint:en,_embind_register_bool:tn,_embind_register_class:$n,_embind_register_class_constructor:An,_embind_register_class_function:En,_embind_register_emval:Sn,_embind_register_enum:Rn,_embind_register_enum_value:xn,_embind_register_float:Nn,_embind_register_function:In,_embind_register_integer:Vn,_embind_register_memory_view:Dn,_embind_register_smart_ptr:Un,_embind_register_std_string:jn,_embind_register_std_wstring:Bn,_embind_register_value_object:qn,_embind_register_value_object_field:Yn,_embind_register_void:Jn,_emval_as:Xn,_emval_call:Kn,_emval_call_method:Qn,_emval_decref:kt,_emval_get_global:ei,_emval_get_method_caller:ni,_emval_get_module_property:ii,_emval_get_property:si,_emval_incref:oi,_emval_instanceof:ai,_emval_new_array:li,_emval_new_cstring:ci,_emval_new_object:ui,_emval_run_destructors:fi,_emval_set_property:_i,_emval_take_value:di,_emval_typeof:pi,clock_time_get:gi,emscripten_asm_const_int:bi,emscripten_notify_memory_growth:wi,environ_get:Ai,environ_sizes_get:Ei,fd_close:Pi,fd_read:Oi,fd_seek:Ci,fd_write:Ri,proc_exit:mr,strptime:Ii},Z=Lr(),Nt=e=>(Nt=Z.malloc)(e),ue=e=>(ue=Z.free)(e),Ui=()=>(Ui=Z.__errno_location)(),wr=a.__initialize=()=>(wr=a.__initialize=Z._initialize)(),Tr=e=>(Tr=Z.__getTypeName)(e),ji=e=>(ji=Z.__cxa_increment_exception_refcount)(e),Wi=e=>(Wi=Z.__cxa_is_pointer_type)(e);function Mi(e){e=Object.assign({},e);var t=n=>c=>n(c)>>>0,r=n=>()=>n()>>>0;return e.malloc=t(e.malloc),e.__errno_location=r(e.__errno_location),e.__getTypeName=t(e.__getTypeName),e.stackSave=r(e.stackSave),e.stackAlloc=t(e.stackAlloc),e}var at,Hi=void 0;xe=function e(){at||$r(),at||(xe=e)};function Li(e=[]){var t=wr;Hi=[W].concat(e);try{t();var r=0;return Vi(r,!0),r}catch(n){return Di(n)}}function $r(e=k){if(ge>0||(re(),ge>0))return;function t(){at||(at=!0,a.calledRun=!0,!de&&(ce(),gt(),w(a),a.onRuntimeInitialized&&a.onRuntimeInitialized(),Ar&&Li(e),Be()))}a.setStatus?(a.setStatus("Running..."),setTimeout(function(){setTimeout(function(){a.setStatus("")},1),t()},1)):t()}if(a.preInit)for(typeof a.preInit=="function"&&(a.preInit=[a.preInit]);a.preInit.length>0;)a.preInit.pop()();var Ar=!0;return a.noInitialRun&&(Ar=!1),$r(),o.ready}})(),Sr=Bi;var ut={};Gi(ut,{COLUMN_SEPARATOR_STRING:()=>ae,CONFIG_ALIASES:()=>Ee,CONFIG_VALID_KEYS:()=>Dt,DATA_TYPES:()=>qi,FILTER_OPERATORS:()=>x,SORT_ORDERS:()=>Ji,SORT_ORDER_IDS:()=>Xi,TYPE_AGGREGATES:()=>Ki,TYPE_FILTERS:()=>es});var qi={integer:"integer",float:"float",string:"string",boolean:"boolean",date:"date",datetime:"datetime",object:"object"},Ee={row_pivot:"group_by","row-pivot":"group_by","row-pivots":"group_by",col_pivot:"split_by",col_pivots:"split_by",column_pivot:"split_by","column-pivot":"split_by","column-pivots":"split_by",filters:"filter",sorts:"sort"},Dt=["version","viewport","group_by","split_by","aggregates","columns","filter","sort","computed_columns","expressions","group_by_depth","split_by_depth","filter_op"],kr=["any","avg","abs sum","count","distinct count","dominant","first by index","last by index","last minus first","last","high","join","low","high minus low","max","mean","median","min","pct sum parent","pct sum grand total","stddev","sum","sum abs","sum not null","unique","var"],Vt=["any","count","distinct count","distinct leaf","dominant","first by index","join","last by index","last","unique"],Yi=["any","count","distinct count","distinct leaf","dominant","first by index","last by index","last","unique"],Ji=["none","asc","desc","col asc","col desc","asc abs","desc abs","col asc abs","col desc abs"],Xi=[2,0,1,0,1,3,4,3,4],Ki={string:Vt,float:kr,integer:kr,boolean:Yi,datetime:Vt,date:Vt},x={lessThan:"<",greaterThan:">",equals:"==",lessThanOrEquals:"<=",greaterThanOrEquals:">=",doesNotEqual:"!=",isNull:"is null",isNotNull:"is not null",isIn:"in",isNotIn:"not in",contains:"contains",bitwiseAnd:"&",bitwiseOr:"|",and:"and",or:"or",beginsWith:"begins with",endsWith:"ends with"},Zi=[x.bitwiseAnd,x.bitwiseOr,x.equals,x.doesNotEqual,x.or,x.and,x.isNull,x.isNotNull],Rr=[x.lessThan,x.greaterThan,x.equals,x.lessThanOrEquals,x.greaterThanOrEquals,x.doesNotEqual,x.isNull,x.isNotNull],Qi=[x.equals,x.contains,x.doesNotEqual,x.isIn,x.isNotIn,x.beginsWith,x.endsWith,x.isNull,x.isNotNull],xr=[x.lessThan,x.greaterThan,x.equals,x.lessThanOrEquals,x.greaterThanOrEquals,x.doesNotEqual,x.isNull,x.isNotNull],ae="|",es={string:Qi,float:Rr,integer:Rr,boolean:Zi,datetime:xr,date:xr};var Ut={types:{float:{filter_operator:"==",aggregate:"sum",format:{style:"decimal",minimumFractionDigits:2,maximumFractionDigits:2}},string:{filter_operator:"==",aggregate:"count"},integer:{filter_operator:"==",aggregate:"sum",format:{}},boolean:{filter_operator:"==",aggregate:"count"},datetime:{filter_operator:"==",aggregate:"count",format:{dateStyle:"short",timeStyle:"medium"},null_value:-1},date:{filter_operator:"==",aggregate:"count",format:{dateStyle:"short"},null_value:-1}}};function Pe(m){let o={};if(Fr().types[m]&&Object.assign(o,Fr().types[m]),o.type){let a=Pe(o.type);return Object.assign(a,o),a}else return o}function jt(m){return m&&typeof m=="object"&&!Array.isArray(m)}function ft(m,...o){if(!o.length)return m;let a=o.shift();if(jt(m)&&jt(a))for(let w in a)jt(a[w])?(m[w]||Object.assign(m,{[w]:{}}),ft(m[w],a[w])):Object.assign(m,{[w]:a[w]});return ft(m,...o)}function Nr(m){globalThis.__PERSPECTIVE_CONFIG__&&console.warn("Config already initialized!"),globalThis.__PERSPECTIVE_CONFIG__=ft(Ut,m)}function Fr(){return globalThis.__PERSPECTIVE_CONFIG__||(globalThis.__PERSPECTIVE_CONFIG__=ft(Ut,globalThis.__TEMPLATE_CONFIG__||{})),globalThis.__PERSPECTIVE_CONFIG__}function _t(m){if(m>=1&&m<=8)return"integer";if(m===19)return"string";if(m===10||m===9)return"float";if(m===11)return"boolean";if(m===12)return"datetime";if(m===13)return"date";console.warn(`Unknown type for value ${m} with JS type ${typeof m}`)}function Wt(m){let o=m;do for(let a of Object.getOwnPropertyNames(o)){let w=m[a];a!=="constructor"&&typeof w=="function"&&(m[a]=w.bind(m))}while(o=o!==Object&&Object.getPrototypeOf(o))}String.prototype.includes||(String.prototype.includes=function(m,o){return typeof o!="number"&&(o=0),o+m.length>this.length?!1:this.indexOf(m,o)!==-1});Array.prototype.includes||Object.defineProperty(Array.prototype,"includes",{value:function(m,o){if(this==null)throw new TypeError(\'"this" is null or not defined\');var a=Object(this),w=a.length>>>0;if(w===0)return!1;var F=o|0,S=Math.max(F>=0?F:w-Math.abs(F),0);function k(W,H){return W===H||typeof W=="number"&&typeof H=="number"&&isNaN(W)&&isNaN(H)}for(;S<w;){if(k(a[S],m))return!0;S++}return!1}});var dt=class{constructor(){this.data_formats={row:0,column:1,schema:2},this.format=void 0,this.data=void 0,this.names=void 0,this.types=void 0,this.row_count=void 0}is_format(o){if(Array.isArray(o))return this.data_formats.row;if(Array.isArray(o[Object.keys(o)[0]]))return this.data_formats.column;if(typeof o[Object.keys(o)[0]]=="string"||typeof o[Object.keys(o)[0]]=="function")return this.data_formats.schema;throw`Could not determine data format for ${JSON.stringify(o)}, with JS typeof ${typeof o}`}count_rows(o){return this.format===this.data_formats.row?o.length:this.format===this.data_formats.column?o[Object.keys(o)[0]].length:0}get_format(){return this.format}get(o,a){let w;if(this.format===this.data_formats.row){let F=this.data[a];F.hasOwnProperty(o)&&(w=F[o])}else if(this.format===this.data_formats.column)this.data.hasOwnProperty(o)&&(w=this.data[o][a]);else if(this.format===this.data_formats.schema)w=void 0;else throw`Could not get() from dataset - ${this.data} is poorly formatted.`;return w}marshal(o,a,w){let F=this.names[o],S=ts(this.get(F,a));if(S===null)return null;if(!(typeof S>"u")){switch(_t(w.value)){case"float":case"integer":{S=Number(S);break}case"boolean":{typeof S=="string"?S.toLowerCase()==="true"?S=!0:S=!1:S=!!S;break}case"datetime":case"date":break;default:S+=""}return S}}clean(){this.names=void 0,this.types=void 0}init(o){this.data=o,this.format=this.is_format(this.data),this.row_count=this.count_rows(this.data);let a={};if(this.format===this.data_formats.row)o.length>0?this.names=Object.keys(o[0]):this.clean.names=[];else if(this.format===this.data_formats.column)this.names=Object.keys(o);else if(this.format===this.data_formats.schema){this.names=Object.keys(o);for(let w of this.names){let F=Pe(o[w]);F.type&&(console.debug(`Converting "${o[w]}" to "${F.type}"`),a[w]=o[w],o[w]=F.type)}}else throw`Could not initialize - failed to determine format for ${o}`;return a}};function ts(m){return m===null||m==="null"?null:m===void 0||m==="undefined"?void 0:m}var Mt=function(m){let o=[];for(let a=0;a<m.size();a++){let w=m.get(a);o.push(w)}return m.delete(),o},Ht=function(m){let o={},a=m.keys();for(let w=0;w<a.size();w++){let F=a.get(w);o[F]=m.get(F)}return m.delete(),a.delete(),o},Oe=function(m,o){for(let a of o)m.push_back(a);return m};function rs(m){let o={};return typeof m!="string"?Object.getOwnPropertyNames(m).forEach(a=>{o[a]=m[a]},m):o.message=m,o}var Ge=class{constructor(o){this.perspective=o,this._tables={},this._views={},this._callback_cache=new Map}init(o){o.config&&Nr(o.config),o.data=["wait_for_response"],this.post(o)}post(o){throw new Error(`Posting ${o} failed - post() not implemented!`)}process(o,a){switch(o.cmd){case"init_profile_thread":this.perspective.initialize_profile_thread();break;case"get_hosted_table_names":this.post({id:o.id,data:Object.keys(this._tables)});break;case"memory_usage":this.post({id:o.id,data:this.perspective.memory_usage()});break;case"init":this.init(o);break;case"table":if(typeof o.args[0]>"u")this._tables[o.name]=[];else try{let k=this._tables[o.name],W=this.perspective.table(o.args[0],o.options);if(W&&W.then)W.then(H=>{if(this._tables[o.name]=H,k)for(let se of k)this.process(se);this.post({id:o.id,data:o.name})}).catch(H=>this.process_error(o,H));else{if(this._tables[o.name]=W,k)for(let H of k)this.process(H);this.post({id:o.id,data:o.name})}}catch(k){this.process_error(o,k);return}break;case"table_generate":(0,eval)(o.args)(function(k){this._tables[o.name]=k,this.post({id:o.id,data:"created!"})});break;case"table_execute":(0,eval)(o.f)(this._tables[o.name]);break;case"table_method":case"view_method":this.process_method_call(o);break;case"view":let S=this._tables[o.table_name];if(S&&Array.isArray(S))S.push(o),this._views[o.view_name]=[];else try{let k=this._views[o.view_name],W=this._tables[o.table_name].view(o.config);if(W&&W.then)W.then(H=>{if(this._views[o.view_name]=H,this._views[o.view_name].client_id=a,k)for(let se of k)this.process(se);this.post({id:o.id,data:o.view_name})}).catch(H=>this.process_error(o,H));else{if(this._views[o.view_name]=W,this._views[o.view_name].client_id=a,k)for(let H of k)this.process(H);this.post({id:o.id,data:o.view_name})}}catch(k){this.process_error(o,k);return}break}}process_subscribe(o,a){try{let w;o.method.slice(0,2)==="on"?(w=F=>{let S={id:o.id,data:F};try{if(o.args&&o.args[0]&&o.method==="on_update"&&o.args[0].mode==="row"){this.post(S,[F.delta]);return}this.post(S)}catch{console.error(`Removing failed callback to \\`${o.method}()\\` (presumably due to failed connection)`);let W=o.method.substring(3);a[`remove_${W}`](w)}},o.callback_id&&this._callback_cache.set(o.callback_id,w)):o.callback_id&&(w=this._callback_cache.get(o.callback_id),this._callback_cache.delete(o.callback_id)),w?a[o.method](w,...o.args):console.error(`Callback not found for remote call "${JSON.stringify(o)}"`)}catch(w){this.process_error(o,w);return}}process_method_call(o){let a,w,F=o.view_name||o.name;if(o.cmd==="table_method"?a=this._tables[F]:a=this._views[F],!a&&o.cmd==="view_method"){this.process_error(o,{message:"View method cancelled"});return}if(a&&a.push){a.push(o);return}try{if(o.subscribe){this.process_subscribe(o,a);return}else w=a[o.method].apply(a,o.args),w instanceof Promise?w.then(S=>this.process_method_call_response(o,S)).catch(S=>this.process_error(o,S)):this.process_method_call_response(o,w)}catch(S){this.process_error(o,S);return}}process_method_call_response(o,a){o.method==="delete"&&delete this._views[o.name],o.method==="to_arrow"?this.post({id:o.id,data:a},[a]):this.post({id:o.id,data:a})}process_error(o,a){try{this.post({id:o.id,error:rs(a)})}catch{console.error("Error handler failed: {}",a)}}clear_views(o){for(let a of Object.keys(this._views))if(this._views[a].client_id===o){try{this._views[a].delete()}catch(w){console.error(w)}delete this._views[a]}console.debug(`GC ${Object.keys(this._views).length} views in memory`)}};typeof self<"u"&&self.performance===void 0&&(self.performance={now:Date.now});var pt=new Set;function Ir(m){let o=m,a=new dt,w=["zero","one","two"],F={};function S(i,s){F[s]?i.delete():(F[s]=i,setTimeout(()=>k(s)))}function k(i){let s=F[i];s&&(s._process(),W(i))}function W(i){F[i]?.delete(),delete F[i]}function H(){let i=performance.memory?JSON.parse(JSON.stringify(performance.memory,["totalJSHeapSize","usedJSHeapSize","jsHeapSizeLimit"])):process.memoryUsage();return i.wasmHeap=o.HEAP8.length,i}function se(i,s,l,_,v,b,T,y,N){l||(l=""),_||(_=4294967295),s=o.make_table(s,i,_,l,v,b,T,y,N);let A=s.get_pool(),I=s.get_id();return b||v==o.t_op.OP_DELETE?S(A,I):(A._process(),A.delete()),s}function O(i,s,l,_,v){this.name=v,this._View=void 0,this.table=i,this.config=l||{},this.view_config=_||new _,this.is_unit_context=this.table.index===""&&s===0&&this.view_config.group_by.length===0&&this.view_config.split_by.length===0&&this.view_config.filter.length===0&&this.view_config.sort.length===0&&this.view_config.expressions.length===0,this.is_unit_context?this._View=o.make_view_unit(i._Table,v,ae,this.view_config,null):s===0?this._View=o.make_view_zero(i._Table,v,ae,this.view_config,null):s===1?this._View=o.make_view_one(i._Table,v,ae,this.view_config,null):s===2&&(this._View=o.make_view_two(i._Table,v,ae,this.view_config,null)),this.ctx=this._View.get_context(),this.column_only=this._View.is_column_only(),this.update_callbacks=this.table.update_callbacks,this.overridden_types=this.table.overridden_types,this._delete_callbacks=[],Wt(this)}O.prototype.get_config=function(){return JSON.parse(JSON.stringify(this.config))},O.prototype.delete=function(){W(this.table.get_id()),this._View.delete(),this.ctx.delete(),this.table.views.splice(this.table.views.indexOf(this),1),this.table=void 0;let i=0,s=0;for(;i<this.update_callbacks.length;){let l=this.update_callbacks[i];l.view!==this&&(this.update_callbacks[s++]=l),i++}this.update_callbacks.length=s,this._delete_callbacks.forEach(l=>l())},O.prototype.sides=function(){return this._View.sides()},O.prototype._num_hidden=function(){let i=0;for(let s of this.config.sort)this.config.columns.indexOf(s[0])===-1&&i++;return i};function Q(i){let s=[];for(let l=0;l<i.size();l++){let _=i.get(l);s.push(o.scalar_to_val(_,!1,!0)),_.delete()}return i.delete(),s}let ht=function(i){let s=[];for(let l=0;l<i.size();l++){let _=i.get(l);s.push(Q(_))}return i.delete(),s},vt=function(i){let s=[];for(let l=0;l<i.size();l++){let _=i.get(l),v=[];for(let b=0;b<_.size();b++){let T=_.get(b);v.push(T)}_.delete(),s.push(v)}return i.delete(),s};O.prototype.schema=function(i=!0){let s=Ht(this._View.schema());if(i)for(let l of Object.keys(s)){let _=l.split(ae);_=_[_.length-1],this.overridden_types[_]&&Pe(this.overridden_types[_]).type===s[l]&&(s[l]=this.overridden_types[_])}return s},O.prototype.expression_schema=function(i=!0){let s=Ht(this._View.expression_schema());if(i)for(let l of Object.keys(s)){let _=l.split(ae);_=_[_.length-1],this.overridden_types[_]&&Pe(this.overridden_types[_]).type===s[l]&&(s[l]=this.overridden_types[_])}return s},O.prototype._column_names=function(i=!1,s=0){return ht(this._View.column_names(i,s)).map(l=>l.join(ae))},O.prototype.column_paths=function(){return vt(this._View.column_paths()).map(i=>i.join(ae))},O.prototype.get_data_slice=function(i,s,l,_){if(this.is_unit_context)return o.get_data_slice_unit(this._View,i,s,l,_);{let v=this.sides(),b=w[v];return o[`get_data_slice_${b}`](this._View,i,s,l,_)}};let Ce=function(i){i=i||{};let s=this._View.num_columns()+(this.sides()===0?0:1),l=this._View.num_rows(),_=this._num_hidden(),v=this.sides()>0||this.column_only?1:0,b=this.config.viewport?this.config.viewport:{},T=i.start_row||(b.top?b.top:0),y=Math.min(l,i.end_row!==void 0?i.end_row:b.height?T+b.height:l),N=i.start_col||(b.left?b.left:0),A=Math.min(s,(i.end_col!==void 0?i.end_col+v:b.width?N+b.width:s)*(_+1));return i.start_row=Math.floor(T),i.end_row=Math.ceil(y),i.start_col=Math.floor(N),i.end_col=Math.ceil(A),i};O.prototype.get_min_max=function(i){if(this.is_unit_context)return o.get_min_max_unit(this._View,i);{let s=this.sides(),l=w[s];return o[`get_min_max_${l}`](this._View,i)}};let Se=function(i,s,l){let _=this.num_rows(),v=s.start_row||0,b=s.end_row||_,y=this._column_names().indexOf(i);if(y===-1)return;this.sides()>0&&y++;let A,I;s.data_slice?A=s.data_slice.get_column_slice(y):(I=this.get_data_slice(v,b,y,y+1),A=I.get_slice());let Y=this._View.get_column_dtype(y),le=l(A,Y,y);return A.delete(),I&&I.delete(),le};O.prototype.to_columns=function(i){return JSON.parse(this.to_columns_string(i))},O.prototype.to_columns_string=function(i){k(this.table.get_id()),i=Ce.bind(this)(i);let s=i.start_row,l=i.end_row,_=i.start_col,v=i.end_col,b=this._num_hidden(),T=i.formatted,y=!!i.index,N=!!i.id,A=!!i.leaves_only,I=this.sides(),Y=I!==0&&!this.column_only,le=w[I],L=this.get_config(),re=L.columns.length,ce=L.group_by.length;return this._View.to_columns(s,l,_,v,b,T,y,N,A,I,Y,le,re,ce)},O.prototype.to_json=function(i){let s=this.to_columns(i),l=Object.keys(s);return(s[l[0]]||[]).map((v,b)=>{let T={};for(let y of l)T[y]=s[y][b];return T})},O.prototype.to_csv=function(i){k(this.table.get_id()),i=Ce.bind(this)(i);let s=i.start_row,l=i.end_row,_=i.start_col,v=i.end_col,b=this.sides();if(this.is_unit_context)return o.to_csv_unit(this._View,s,l,_,v);if(b===0)return o.to_csv_zero(this._View,s,l,_,v);if(b===1)return o.to_csv_one(this._View,s,l,_,v);if(b===2)return o.to_csv_two(this._View,s,l,_,v)},O.prototype.col_to_js_typed_array=function(i,s={}){k(this.table.get_id());let l=o.col_to_js_typed_array;return Se.call(this,i,s,l)},O.prototype.to_arrow=function(i={}){k(this.table.get_id()),i=Ce.bind(this)(i);let s=i.start_row,l=i.end_row,_=i.start_col,v=i.end_col,b=this.sides(),T="compression"in i?i.compression==="lz4":!0;if(this.is_unit_context)return o.to_arrow_unit(this._View,s,l,_,v,T);if(b===0)return o.to_arrow_zero(this._View,s,l,_,v,T);if(b===1)return o.to_arrow_one(this._View,s,l,_,v,T);if(b===2)return o.to_arrow_two(this._View,s,l,_,v,T)},O.prototype.num_rows=function(){return k(this.table.get_id()),this._View.num_rows()},O.prototype.num_columns=function(){let i=this._View.num_columns(),s=this._num_hidden();return i-i/(this.config.columns.length+s)*s},O.prototype.dimensions=function(){return{num_table_rows:this.table.num_rows(),num_table_columns:this.table.num_columns(),num_view_rows:this._View.num_rows(),num_view_columns:this.num_columns()}},O.prototype.get_row_expanded=function(i){return this._View.get_row_expanded(i)},O.prototype.expand=function(i){return this._View.expand(i,this.config.group_by.length)},O.prototype.collapse=function(i){return this._View.collapse(i)},O.prototype.set_depth=function(i){return this._View.set_depth(i,this.config.group_by.length)},O.prototype._get_step_delta=async function(){let i=this._View.get_step_delta(0,2147483647),s;if(i.cells.size()===0)s=this.to_json();else{let l={};for(let v=0;v<i.cells.size();v++)l[i.cells.get(v).row]=!0;l=Object.keys(l);let _=l.map(v=>this.to_json({start_row:Number.parseInt(v),end_row:Number.parseInt(v)+1}));s=[].concat.apply([],_)}return i.cells.delete(),s},O.prototype._get_row_delta=async function(){if(this.is_unit_context)return o.get_row_delta_unit(this._View);{let i=this.sides(),s=w[i];return o[`get_row_delta_${s}`](this._View)}},O.prototype.on_update=function(i,{mode:s="none"}={}){if(k(this.table.get_id()),["none","row"].indexOf(s)===-1)throw new Error(`Invalid update mode "${s}" - valid modes are "none" and "row".`);s==="row"&&(this._View._get_deltas_enabled()||this._View._set_deltas_enabled(!0)),this.update_callbacks.push({view:this,orig_callback:i,callback:async(l,_)=>{_[l]===void 0&&(_[l]={});let v={port_id:l};s==="row"&&(_[l].row_delta===void 0&&(_[l].row_delta=await this._get_row_delta()),v.delta=_[l].row_delta),i(v)}})};function ke(i,s){let l=0,_=0;for(;l<i.length;){let v=i[l];s(v,l,i)&&(i[_++]=v),l++}return i.length=_,i}O.prototype.remove_update=function(i){k(this.table.get_id());let s=this.update_callbacks.length;ke(this.update_callbacks,l=>l.orig_callback!==i),console.assert(s>this.update_callbacks.length,\'"callback" does not match a registered updater\')},O.prototype.on_delete=function(i){this._delete_callbacks.push(i)},O.prototype.remove_delete=function(i){let s=this._delete_callbacks.length;ke(this._delete_callbacks,l=>l!==i),console.assert(s>this._delete_callbacks.length,\'"callback" does not match a registered delete callbacks\')};function X(i){this.group_by=i.group_by||[],this.split_by=i.split_by||[],this.aggregates=i.aggregates||{},this.columns=i.columns,this.filter=i.filter||[],this.sort=i.sort||[],this.expressions=i.expressions||[],this.filter_op=i.filter_op||"and",this.group_by_depth=i.group_by_depth,this.split_by_depth=i.split_by_depth}X.prototype.get_group_by=function(){let i=o.make_string_vector();return Oe(i,this.group_by)},X.prototype.get_split_by=function(){let i=o.make_string_vector();return Oe(i,this.split_by)},X.prototype.get_columns=function(){let i=o.make_string_vector();return Oe(i,this.columns)},X.prototype.get_filter=function(){let i=o.make_2d_val_vector();for(let s of this.filter){let l=o.make_val_vector(),_=Oe(l,s);i.push_back(_)}return i},X.prototype.get_sort=function(){let i=o.make_2d_string_vector();for(let s of this.sort){let l=o.make_string_vector(),_=Oe(l,s);i.push_back(_)}return i},X.prototype.get_expressions=function(){let i=o.make_2d_val_vector();for(let s of this.expressions){let l=o.make_val_vector();for(let _ of s)l.push_back(_);i.push_back(l)}return i};function V(i,s,l,_){this._Table=i;let v=this._Table.get_gnode();this.gnode_id=v.get_id(),v.delete();let b=this._Table.get_pool();b.set_update_delegate(this),b.delete(),this.name=Math.random()+"",this.initialized=!1,this.index=s,this.limit=l,this.update_callbacks=[],this._delete_callbacks=[],this.views=[],this.overridden_types=_,Wt(this)}V.prototype.get_id=function(){return this._Table.get_id()},V.prototype.get_pool=function(){return this._Table.get_pool()},V.prototype.make_port=function(){return this._Table.make_port()},V.prototype.remove_port=function(){this._Table.remove_port()},V.prototype._update_callback=function(i){let s={};for(let l in this.update_callbacks)this.update_callbacks[l].callback(i,s)},V.prototype.get_index=function(){return this.index},V.prototype.get_limit=function(){return this.limit},V.prototype.clear=function(){k(this.get_id()),this._Table.reset_gnode(this.gnode_id)},V.prototype.get_num_views=function(){return this.views.length},V.prototype.replace=function(i){W(this.get_id()),this._Table.reset_gnode(this.gnode_id),this.update(i),k(this.get_id())},V.prototype.delete=function(){if(this.views.length>0)throw`Cannot delete Table as it still has ${this.views.length} registered View(s).`;W(this.get_id()),this._Table.unregister_gnode(this.gnode_id),this._Table.delete();for(let i of this._delete_callbacks)i()},V.prototype.on_delete=function(i){this._delete_callbacks.push(i)},V.prototype.remove_delete=function(i){let s=this._delete_callbacks.length;ke(this._delete_callbacks,l=>l!==i),console.assert(s>this._delete_callbacks.length,\'"callback" does not match a registered delete callbacks\')},V.prototype.size=function(){return k(this._Table.get_id()),this._Table.size()},V.prototype.num_rows=function(){return this.size()},V.prototype.num_columns=function(){let i=this._Table.get_schema(),s=i.columns(),l=s.size();return s.delete(),i.delete(),l-1},V.prototype.schema=function(i=!0){let s=this._Table.get_schema(),l=s.columns(),_=s.types(),v={};for(let b=0;b<l.size();b++){let T=l.get(b);T!=="psp_okey"&&(i&&this.overridden_types[T]?v[T]=this.overridden_types[T]:v[T]=_t(_.get(b).value))}return s.delete(),l.delete(),_.delete(),v};function Re(i){let s=[],l={},_=!Array.isArray(i);for(let v of _?Object.keys(i):i){let b=v;_&&(v=i[v]);let T={},y={},N=0,A;if(_)A=b;else{let L=v.match(/^\\/\\/(?<alias>.+?)\\n/);L?.groups?.alias&&(A=L.groups.alias.trim()),(!A||A.length==0)&&(A=v)}let I=v.replace(/([a-zA-Z_]+[a-zA-Z0-9_]*)/g,L=>L=="true"?"True":L=="false"?"False":L);I=I.replace(/\\"(.*?[^\\\\])\\"/g,(L,re)=>{if(re=re.replace(/\\\\"/g,\'"\'),T[re]===void 0){let ce=`COLUMN${N}`;T[re]=ce,y[ce]=re}return N++,T[re]}),I=I.replace(/\'(.*?[^\\\\])\'/g,L=>`intern(${L})`);let Y=(L,re,ce,gt)=>{let Be=L.indexOf(ce);return`${L.substring(0,Be)}\'${gt}\'${L.substring(Be+ce.length)}`};I=I.replace(/(bucket|match|match_all|search|indexof)\\(.*?,\\s*(intern\\(\\\'(.+)\\\'\\)).*\\)/g,Y),I=I.replace(/(replace_all|replace)\\(.*?,\\s*(intern\\(\\\'(.*)\\\'\\)),.*\\)/g,Y);let le=[A,v,I,y];if(l[A]!==void 0){let L=l[A];s[L]=le}else s.push(le),l[A]=s.length-1}return s}V.prototype.validate_expressions=function(i,s=!0){let l={expression_schema:{},expression_alias:{},errors:{}};if(!i||Object.keys(i).length===0)return l;i=Re(i);let _=o.make_2d_val_vector();for(let A of i){let I=o.make_val_vector();for(let Y of A)I.push_back(Y);_.push_back(I),l.expression_alias[A[0]]=A[1]}let v=o.validate_expressions(this._Table,_),b=v.get_expression_schema(),T=v.get_expression_errors(),y=b.keys();for(let A=0;A<y.size();A++){let I=y.get(A),Y=b.get(I);s&&this.overridden_types[I]&&(Y=this.overridden_types[I]),l.expression_schema[I]=Y}let N=T.keys();for(let A=0;A<N.size();A++){let I=N.get(A),Y=T.get(I);l.errors[I]=Y}return N.delete(),y.delete(),T.delete(),b.delete(),v.delete(),l},V.prototype.is_valid_filter=function(i){if(i[1]===K.FILTER_OPERATORS.isNull||i[1]===K.FILTER_OPERATORS.isNotNull)return!0;let s=i[2];if(s===null)return!1;let l=this.schema();return l[i[0]]&&(l[i[0]]==="date"||l[i[0]]==="datetime")?o.is_valid_datetime(i[2]):typeof s<"u"&&s!==null},V.prototype.view=function(i={}){k(this._Table.get_id());let s={};for(let y of Object.keys(i))if(Ee[y])if(!s[Ee[y]])pt.has(y)||(console.warn(`Deprecated: "${y}" config parameter, please use "${Ee[y]}" instead`),pt.add(y)),s[Ee[y]]=i[y];else throw new Error(`Duplicate configuration parameter "${y}"`);else if(y==="aggregate"){pt.has("aggregate")||(console.warn(\'Deprecated: "aggregate" config parameter has been replaced by "aggregates" and "columns"\'),pt.add("aggregate")),s.aggregates={},s.columns=[];for(let N of i.aggregate)s.aggregates[N.column]=N.op,s.columns.push(N.column)}else if(Dt.indexOf(y)>-1)s[y]=i[y];else throw new Error(`Unrecognized config parameter "${y}"`);s.group_by=s.group_by||[],s.split_by=s.split_by||[],s.aggregates=s.aggregates||{},s.filter=s.filter||[],s.sort=s.sort||[],s.expressions=s.expressions||{};let l=this.schema();if(s.expressions!==void 0&&(Array.isArray(s.expressions)&&console.warn("Legacy `expressions` format: "+JSON.stringify(s.expressions)),s.expressions=Re(s.expressions)),s.columns===void 0&&(s.columns=this.columns(),s.expressions!=null))for(let y of s.expressions)s.columns.push(y[0]);if(s.filter.length>0)for(let y of s.filter){let N=l[y[0]];y[1]!==K.FILTER_OPERATORS.isNull&&y[1]!==K.FILTER_OPERATORS.isNotNull&&(N==="date"||N==="datetime")&&(y[2]=new Date(y[2]))}let _=Math.random()+"",v;s.group_by.length>0||s.split_by.length>0?s.split_by&&s.split_by.length>0?v=2:v=1:v=0;let b=new X(s),T=new O(this,v,s,b,_);return this.views.push(T),T};let de;function we(){if(de===void 0){let i=0,s=performance.now();setTimeout(function l(){let _=performance.now();console.log(`${(1e3*i/(_-s)).toFixed(2)} msgs/sec`),i=0,s=_,setTimeout(l,5e3)},5e3),de=function(_){i+=_},console.log("Profiling initialized")}}V.prototype.query_columns=function(i,s){let l=this.view(i),_=l.to_columns(s);return l.delete(),_},V.prototype.update=function(i,s){s=s||{},s.port_id=s.port_id||0;let l,_=this.columns(),v=this._Table.get_schema(),b=v.types(),T=!1,y=!1;if(l=a,i instanceof ArrayBuffer?(l=new Uint8Array(i),T=!0):typeof i=="string"?(i[0]===","&&(i="_"+i),y=!0,T=!0,l=i):(a.init(i),a.names=_.concat(a.names.filter(N=>N==="__INDEX__")),a.types=Mt(b).slice(0,_.length),de&&de(a.row_count)),!T){if(l.row_count===0){console.warn("table.update called with no data - ignoring");return}a.names.indexOf("__INDEX__")!=-1&&(!!this.index?a.types.push(a.types[a.names.indexOf(this.index)]):a.types.push(o.t_dtype.DTYPE_INT32))}try{let N=o.t_op.OP_INSERT;se(l,this._Table,this.index,this.limit,N,!0,T,y,s.port_id).delete(),this.initialized=!0}catch(N){console.error(`Update failed: ${N}`)}finally{v.delete()}},V.prototype.remove=function(i,s){if(!this.index){console.error("Cannot call `remove()` on a Table without a user-specified index.");return}s=s||{},s.port_id=s.port_id||0;let l,_=this.columns(),v=this._Table.get_schema(),b=v.types(),T=!1;i=i.map(y=>({[this.index]:y})),i instanceof ArrayBuffer?(l=new Uint8Array(i),T=!0):(a.init(i),a.names=[this.index],a.types=[Mt(b)[_.indexOf(this.index)]],l=a);try{let y=o.t_op.OP_DELETE;se(l,this._Table,this.index,this.limit,y,!1,T,!1,s.port_id).delete(),this.initialized=!0}catch(y){console.error("Remove failed",y)}finally{v.delete()}},V.prototype.columns=function(){let i=this._Table.get_schema(),s=i.columns(),l=[];for(let _=0;_<s.size();_++){let v=s.get(_);v!=="psp_okey"&&l.push(v)}return i.delete(),s.delete(),l},V.prototype.execute=function(i){i(this)};let K={__module__:o,Server:Ge,worker:function(){return this},initialize_profile_thread:we,memory_usage:H,table:function(i,s){s=s||{},s.index=s.index||null,s.limit=s.limit||null;let l,_=!1,v={},b=!1;if(i instanceof ArrayBuffer||typeof Buffer<"u"&&i instanceof Buffer?(l=new Uint8Array(i),_=!0):typeof i=="string"?(i[0]===","&&(i="_"+i),b=!0,_=!0,l=i):(a.clean(),v=a.init(i),l=a),s.index&&s.limit)throw`Cannot specify both index \'${s.index}\' and limit \'${s.limit}\'.`;let T;try{let y=o.t_op.OP_INSERT;return T=se(l,void 0,s.index,s.limit,y,!1,_,b,0),new V(T,s.index,s.limit,v)}catch(y){throw T&&T.delete(),console.error(`Table initialization failed: ${y}`),y}}};for(let i of Object.keys(ut))K[i]=ut[i];class q extends Ge{constructor(s){super(s),self.addEventListener("message",l=>this.process(l.data),!1)}post(s,l){self.postMessage(s,l)}async init(s){let l=s.buffer,v=(await WebAssembly.instantiate(l)).instance.exports,b=v.size(),T=v.offset();l=new Uint8Array(v.memory.buffer).slice(T,T+b),o=await o({wasmBinary:l,wasmJSMethod:"native-wasm",locateFile:N=>N}),o.init(),super.init(s)}}return typeof self<"u"&&self.addEventListener&&new q(K),K}var Ps=globalThis.perspective=Ir(Sr);})();\n//# sourceMappingURL=perspective.worker.js.map\n';
function Y(r, e) {
    function t(i, l) {
        r.push(l);
    }
    function n(i) {
        if (Object.keys(i).length > 0) for (let l of e)l({
            data: i
        });
    }
    return {
        addEventListener: t,
        postMessage: n,
        location: {
            href: ""
        }
    };
}
function ye(r, e) {
    console.error("Running perspective in single-threaded mode due to error initializing Web Worker:", e);
    let t = Function("const self = arguments[0];" + r), n = [], i = [];
    return t(Y(n, i)), Y(i, n);
}
var pe = async function() {
    try {
        let r = new Blob([
            E
        ], {
            type: "application/javascript"
        }), e = URL.createObjectURL(r);
        return new Worker(e, {
            type: "module"
        });
    } catch (r) {
        return window.location.protocol.startsWith("file") ? console.warn("file:// protocol does not support Web Workers") : console.error("Error instantiating Web Worker"), ye(E, r);
    }
}, $ = pe;
var ge = {};
W(ge, {
    default: ()=>x
});
var x = te("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");
var G = Promise.resolve(x);
var D = !1, M = function() {
    let r;
    return function() {
        return r || (r = new class {
            async worker() {
                return await $();
            }
            async wasm() {
                let e = await G;
                if (e instanceof ArrayBuffer && !e.buffer && (e = new Uint8Array(e)), e.buffer && e.buffer instanceof ArrayBuffer) D = !0, length = e.byteLength, this._wasm = e;
                else if (e instanceof ArrayBuffer) length = e.byteLength, this._wasm = new Uint8Array(e);
                else {
                    let t = await fetch(e);
                    this._wasm = await t.arrayBuffer();
                }
                return this._wasm;
            }
        }), r;
    };
}(), j = class extends d {
    constructor(e){
        e && I(e), super(), this.register();
    }
    async register() {
        let e, t = {
            cmd: "init",
            config: p()
        };
        if (typeof WebAssembly > "u") throw new Error("WebAssembly not supported.");
        [e, t.buffer] = await Promise.all([
            M().worker(),
            M().wasm()
        ]);
        for(var n in this._worker)e[n] = this._worker[n];
        this._worker = e, this._worker.addEventListener("message", this._handle.bind(this)), this._worker.postMessage(t), this._detect_transferable();
    }
    send(e) {
        this._worker.transferable && e.args && e.args[0] instanceof ArrayBuffer ? this._worker.postMessage(e, [
            e.args[0]
        ]) : this._worker.postMessage(e);
    }
    terminate() {
        this._worker.terminate(), this._worker = void 0;
    }
    get transferable() {
        return this._worker?.transferable || !1;
    }
    get inline() {
        return D;
    }
    _detect_transferable() {
        var e = new ArrayBuffer(1);
        this._worker.postMessage(e, [
            e
        ]), this._worker.transferable = e.byteLength === 0;
    }
}, je = function() {
    let r, e;
    return {
        getInstance: function(t) {
            r === void 0 && (r = new j(t));
            let n = JSON.stringify(t);
            if (e && n !== e) throw new Error("Configuration object for shared_worker() has changed - this is probably a bug in your application.");
            return e = n, r;
        }
    };
}(), et = V;
function me(r) {
    return M().set(r);
}
function ke(r) {
    return new j(r);
}
function Oe(r = window.location.origin.replace("http", "ws")) {
    return new v(new WebSocket(r));
}
function be(r) {
    return je.getInstance(r);
}
var tt = {
    override: me,
    worker: ke,
    websocket: Oe,
    shared_worker: be,
    ...Object.keys(O)
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"25MzN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLPerspectiveViewerPluginElement", ()=>G);
parcelHelpers.export(exports, "chain", ()=>C);
parcelHelpers.export(exports, "convert", ()=>It);
parcelHelpers.export(exports, "default", ()=>Xt);
var global = arguments[3];
var je = Object.defineProperty;
var ne = (n, e)=>{
    for(var t in e)je(n, t, {
        get: e[t],
        enumerable: !0
    });
};
var ve = (()=>{
    for(var n = new Uint8Array(128), e = 0; e < 64; e++)n[e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e * 4 - 205] = e;
    return (t)=>{
        for(var r = t.length, o = new Uint8Array((r - (t[r - 1] == "=") - (t[r - 2] == "=")) * 3 / 4 | 0), s = 0, u = 0; s < r;){
            var f = n[t.charCodeAt(s++)], l = n[t.charCodeAt(s++)], m = n[t.charCodeAt(s++)], v = n[t.charCodeAt(s++)];
            o[u++] = f << 2 | l >> 4, o[u++] = l << 4 | m >> 2, o[u++] = m << 6 | v;
        }
        return o;
    };
})();
var G = class extends HTMLElement {
    constructor(){
        super();
    }
    get name() {
        return "Debug";
    }
    get select_mode() {
        return "select";
    }
    get min_config_columns() {}
    get config_column_names() {}
    get priority() {
        return 0;
    }
    can_render_column_styles() {
        return !1;
    }
    column_style_config() {}
    async update(e) {
        return this.draw(e);
    }
    async draw(e) {
        this.style.backgroundColor = "#fff";
        let t = await e.to_csv(), r = "margin:0;overflow:scroll;position:absolute;width:100%;height:100%";
        this.innerHTML = `<pre style='${r}'>${t}</pre>`;
    }
    async clear() {
        this.innerHTML = "";
    }
    async resize() {}
    async restyle() {}
    async save() {}
    async restore() {}
    async delete() {}
};
document.createElement("perspective-viewer-plugin").constructor === HTMLElement && window.customElements.define("perspective-viewer-plugin", G);
var h = {};
ne(h, {
    ColumnDropDownElement: ()=>Q,
    CopyDropDownMenuElement: ()=>K,
    ExportDropDownMenuElement: ()=>x,
    FilterDropDownElement: ()=>X,
    FunctionDropDownElement: ()=>T,
    PerspectiveDebugPluginElement: ()=>q,
    PerspectiveViewerElement: ()=>k,
    default: ()=>D,
    defineWebComponents: ()=>S,
    getExprTKCommands: ()=>Ve,
    initSync: ()=>Ge,
    registerPlugin: ()=>Le
});
var re = window.ClipboardItem;
var _e = window.IntersectionObserver;
var oe = window.ResizeObserver;
function ie(n, e, t, r) {
    let o = n[t], s = o.prototype;
    class u extends HTMLElement {
        constructor(){
            super(), this._instance = new o(this);
        }
    }
    let f = Object.getOwnPropertyNames(s);
    for (let l of f)"get" in Object.getOwnPropertyDescriptor(s, l) ? Object.defineProperty(u.prototype, l, {
        get: function() {
            return this._instance[l];
        }
    }) : Object.defineProperty(u.prototype, l, {
        value: function(...m) {
            return this._instance[l].call(this._instance, ...m);
        }
    });
    for (let l of r)Object.defineProperty(u, l, {
        value: function(...m) {
            return n[l].call(n, ...m);
        }
    });
    customElements.define(e, u);
}
var c, y = new Array(128).fill(void 0);
y.push(void 0, null, !0, !1);
function _(n) {
    return y[n];
}
function b(n) {
    return n == null;
}
var W = null;
function ue() {
    return (W === null || W.byteLength === 0) && (W = new Float64Array(c.memory.buffer)), W;
}
var N = null;
function a() {
    return (N === null || N.byteLength === 0) && (N = new Int32Array(c.memory.buffer)), N;
}
var d = 0, F = null;
function Z() {
    return (F === null || F.byteLength === 0) && (F = new Uint8Array(c.memory.buffer)), F;
}
var M = typeof TextEncoder < "u" ? new TextEncoder("utf-8") : {
    encode: ()=>{
        throw Error("TextEncoder not available");
    }
}, ye = typeof M.encodeInto == "function" ? function(n, e) {
    return M.encodeInto(n, e);
} : function(n, e) {
    let t = M.encode(n);
    return e.set(t), {
        read: n.length,
        written: t.length
    };
};
function p(n, e, t) {
    if (t === void 0) {
        let f = M.encode(n), l = e(f.length, 1) >>> 0;
        return Z().subarray(l, l + f.length).set(f), d = f.length, l;
    }
    let r = n.length, o = e(r, 1) >>> 0, s = Z(), u = 0;
    for(; u < r; u++){
        let f = n.charCodeAt(u);
        if (f > 127) break;
        s[o + u] = f;
    }
    if (u !== r) {
        u !== 0 && (n = n.slice(u)), o = t(o, r, r = u + n.length * 3, 1) >>> 0;
        let f = Z().subarray(o + u, o + r);
        u += ye(n, f).written;
    }
    return d = u, o;
}
var I = y.length;
function i(n) {
    I === y.length && y.push(y.length + 1);
    let e = I;
    return I = y[e], y[e] = n, e;
}
var Ae = typeof TextDecoder < "u" ? new TextDecoder("utf-8", {
    ignoreBOM: !0,
    fatal: !0
}) : {
    decode: ()=>{
        throw Error("TextDecoder not available");
    }
};
typeof TextDecoder < "u" && Ae.decode();
function g(n, e) {
    return n = n >>> 0, Ae.decode(Z().subarray(n, n + e));
}
function ke(n) {
    n < 132 || (y[n] = I, I = n);
}
function w(n) {
    let e = _(n);
    return ke(n), e;
}
var L = null;
function he() {
    return (L === null || L.byteLength === 0) && (L = new BigInt64Array(c.memory.buffer)), L;
}
function Y(n) {
    let e = typeof n;
    if (e == "number" || e == "boolean" || n == null) return `${n}`;
    if (e == "string") return `"${n}"`;
    if (e == "symbol") {
        let o = n.description;
        return o == null ? "Symbol" : `Symbol(${o})`;
    }
    if (e == "function") {
        let o = n.name;
        return typeof o == "string" && o.length > 0 ? `Function(${o})` : "Function";
    }
    if (Array.isArray(n)) {
        let o = n.length, s = "[";
        o > 0 && (s += Y(n[0]));
        for(let u = 1; u < o; u++)s += ", " + Y(n[u]);
        return s += "]", s;
    }
    let t = /\[object ([^\]]+)\]/.exec(toString.call(n)), r;
    if (t.length > 1) r = t[1];
    else return toString.call(n);
    if (r == "Object") try {
        return "Object(" + JSON.stringify(n) + ")";
    } catch  {
        return "Object";
    }
    return n instanceof Error ? `${n.name}: ${n.message}
${n.stack}` : r;
}
function O(n, e, t, r) {
    let o = {
        a: n,
        b: e,
        cnt: 1,
        dtor: t
    }, s = (...u)=>{
        o.cnt++;
        let f = o.a;
        o.a = 0;
        try {
            return r(f, o.b, ...u);
        } finally{
            --o.cnt === 0 ? c.__wbindgen_export_2.get(o.dtor)(f, o.b) : o.a = f;
        }
    };
    return s.original = o, s;
}
function ce(n, e, t) {
    c.__wbindgen_export_3(n, e, i(t));
}
function z(n, e, t, r) {
    let o = {
        a: n,
        b: e,
        cnt: 1,
        dtor: t
    }, s = (...u)=>{
        o.cnt++;
        try {
            return r(o.a, o.b, ...u);
        } finally{
            --o.cnt === 0 && (c.__wbindgen_export_2.get(o.dtor)(o.a, o.b), o.a = 0);
        }
    };
    return s.original = o, s;
}
function se(n, e, t) {
    c.__wbindgen_export_4(n, e, i(t));
}
function Ke(n, e) {
    try {
        let o = c.__wbindgen_add_to_stack_pointer(-16);
        c.__wbindgen_export_5(o, n, e);
        var t = a()[o / 4 + 0], r = a()[o / 4 + 1];
        if (r) throw w(t);
    } finally{
        c.__wbindgen_add_to_stack_pointer(16);
    }
}
function xe(n, e, t) {
    let r = c.__wbindgen_export_6(n, e, i(t));
    return w(r);
}
var J = 128;
function qe(n) {
    if (J == 1) throw new Error("out of js stack");
    return y[--J] = n, J;
}
function Oe(n, e, t) {
    try {
        c.__wbindgen_export_7(n, e, qe(t));
    } finally{
        y[J++] = void 0;
    }
}
function We(n, e) {
    c.__wbindgen_export_8(n, e);
}
function Ne(n, e, t) {
    c.__wbindgen_export_9(n, e, i(t));
}
var V = null;
function ae() {
    return (V === null || V.byteLength === 0) && (V = new Uint32Array(c.memory.buffer)), V;
}
function Fe(n, e) {
    let t = e(n.length * 4, 4) >>> 0, r = ae();
    for(let o = 0; o < n.length; o++)r[t / 4 + o] = i(n[o]);
    return d = n.length, t;
}
function A(n, e) {
    try {
        return n.apply(this, e);
    } catch (t) {
        c.__wbindgen_export_11(i(t));
    }
}
function Le(n) {
    let e = p(n, c.__wbindgen_export_0, c.__wbindgen_export_1), t = d;
    c.registerPlugin(e, t);
}
function be(n, e) {
    n = n >>> 0;
    let r = ae().subarray(n / 4, n / 4 + e), o = [];
    for(let s = 0; s < r.length; s++)o.push(w(r[s]));
    return o;
}
function Ve() {
    try {
        let s = c.__wbindgen_add_to_stack_pointer(-16);
        c.getExprTKCommands(s);
        var n = a()[s / 4 + 0], e = a()[s / 4 + 1], t = a()[s / 4 + 2], r = a()[s / 4 + 3];
        if (r) throw w(t);
        var o = be(n, e).slice();
        return c.__wbindgen_export_10(n, e * 4), o;
    } finally{
        c.__wbindgen_add_to_stack_pointer(16);
    }
}
function S() {
    c.defineWebComponents();
}
function Ie(n, e, t, r) {
    c.__wbindgen_export_12(n, e, i(t), i(r));
}
var Q = class {
    __destroy_into_raw() {
        let e = this.__wbg_ptr;
        return this.__wbg_ptr = 0, e;
    }
    free() {
        let e = this.__destroy_into_raw();
        c.__wbg_columndropdownelement_free(e);
    }
}, K = class {
    static __wrap(e) {
        e = e >>> 0;
        let t = Object.create(K.prototype);
        return t.__wbg_ptr = e, t;
    }
    __destroy_into_raw() {
        let e = this.__wbg_ptr;
        return this.__wbg_ptr = 0, e;
    }
    free() {
        let e = this.__destroy_into_raw();
        c.__wbg_copydropdownmenuelement_free(e);
    }
    constructor(e){
        let t = c.copydropdownmenuelement_new(i(e));
        return K.__wrap(t);
    }
    open(e) {
        c.copydropdownmenuelement_open(this.__wbg_ptr, i(e));
    }
    hide() {
        try {
            let r = c.__wbindgen_add_to_stack_pointer(-16);
            c.copydropdownmenuelement_hide(r, this.__wbg_ptr);
            var e = a()[r / 4 + 0], t = a()[r / 4 + 1];
            if (t) throw w(e);
        } finally{
            c.__wbindgen_add_to_stack_pointer(16);
        }
    }
    unsafe_set_model(e) {
        c.copydropdownmenuelement_unsafe_set_model(this.__wbg_ptr, e);
    }
    connected_callback() {
        c.copydropdownmenuelement_connected_callback(this.__wbg_ptr);
    }
}, x = class {
    static __wrap(e) {
        e = e >>> 0;
        let t = Object.create(x.prototype);
        return t.__wbg_ptr = e, t;
    }
    __destroy_into_raw() {
        let e = this.__wbg_ptr;
        return this.__wbg_ptr = 0, e;
    }
    free() {
        let e = this.__destroy_into_raw();
        c.__wbg_exportdropdownmenuelement_free(e);
    }
    constructor(e){
        let t = c.copydropdownmenuelement_new(i(e));
        return x.__wrap(t);
    }
    open(e) {
        c.exportdropdownmenuelement_open(this.__wbg_ptr, i(e));
    }
    hide() {
        try {
            let r = c.__wbindgen_add_to_stack_pointer(-16);
            c.exportdropdownmenuelement_hide(r, this.__wbg_ptr);
            var e = a()[r / 4 + 0], t = a()[r / 4 + 1];
            if (t) throw w(e);
        } finally{
            c.__wbindgen_add_to_stack_pointer(16);
        }
    }
    unsafe_set_model(e) {
        c.exportdropdownmenuelement_unsafe_set_model(this.__wbg_ptr, e);
    }
    connected_callback() {
        c.copydropdownmenuelement_connected_callback(this.__wbg_ptr);
    }
}, X = class {
    __destroy_into_raw() {
        let e = this.__wbg_ptr;
        return this.__wbg_ptr = 0, e;
    }
    free() {
        let e = this.__destroy_into_raw();
        c.__wbg_filterdropdownelement_free(e);
    }
}, T = class {
    __destroy_into_raw() {
        let e = this.__wbg_ptr;
        return this.__wbg_ptr = 0, e;
    }
    free() {
        let e = this.__destroy_into_raw();
        c.__wbg_functiondropdownelement_free(e);
    }
}, q = class {
    static __wrap(e) {
        e = e >>> 0;
        let t = Object.create(q.prototype);
        return t.__wbg_ptr = e, t;
    }
    __destroy_into_raw() {
        let e = this.__wbg_ptr;
        return this.__wbg_ptr = 0, e;
    }
    free() {
        let e = this.__destroy_into_raw();
        c.__wbg_perspectivedebugpluginelement_free(e);
    }
    constructor(e){
        let t = c.perspectivedebugpluginelement_new(i(e));
        return q.__wrap(t);
    }
    get name() {
        let e, t;
        try {
            let s = c.__wbindgen_add_to_stack_pointer(-16);
            c.perspectivedebugpluginelement_name(s, this.__wbg_ptr);
            var r = a()[s / 4 + 0], o = a()[s / 4 + 1];
            return e = r, t = o, g(r, o);
        } finally{
            c.__wbindgen_add_to_stack_pointer(16), c.__wbindgen_export_10(e, t, 1);
        }
    }
    get select_mode() {
        let e, t;
        try {
            let s = c.__wbindgen_add_to_stack_pointer(-16);
            c.perspectivedebugpluginelement_select_mode(s, this.__wbg_ptr);
            var r = a()[s / 4 + 0], o = a()[s / 4 + 1];
            return e = r, t = o, g(r, o);
        } finally{
            c.__wbindgen_add_to_stack_pointer(16), c.__wbindgen_export_10(e, t, 1);
        }
    }
    get min_config_columns() {
        let e = c.perspectivedebugpluginelement_config_column_names(this.__wbg_ptr);
        return w(e);
    }
    get config_column_names() {
        let e = c.perspectivedebugpluginelement_config_column_names(this.__wbg_ptr);
        return w(e);
    }
    update(e) {
        let t = c.perspectivedebugpluginelement_draw(this.__wbg_ptr, i(e));
        return w(t);
    }
    draw(e) {
        let t = c.perspectivedebugpluginelement_draw(this.__wbg_ptr, i(e));
        return w(t);
    }
    clear() {
        let e = c.perspectivedebugpluginelement_clear(this.__wbg_ptr);
        return w(e);
    }
    resize() {
        let e = c.perspectivedebugpluginelement_clear(this.__wbg_ptr);
        return w(e);
    }
    restyle() {
        let e = c.perspectivedebugpluginelement_clear(this.__wbg_ptr);
        return w(e);
    }
    save() {
        let e = c.perspectivedebugpluginelement_clear(this.__wbg_ptr);
        return w(e);
    }
    restore() {
        let e = c.perspectivedebugpluginelement_clear(this.__wbg_ptr);
        return w(e);
    }
    delete() {
        let e = c.perspectivedebugpluginelement_clear(this.__wbg_ptr);
        return w(e);
    }
    connectedCallback() {
        c.copydropdownmenuelement_connected_callback(this.__wbg_ptr);
    }
}, k = class {
    static __wrap(e) {
        e = e >>> 0;
        let t = Object.create(k.prototype);
        return t.__wbg_ptr = e, t;
    }
    __destroy_into_raw() {
        let e = this.__wbg_ptr;
        return this.__wbg_ptr = 0, e;
    }
    free() {
        let e = this.__destroy_into_raw();
        c.__wbg_perspectiveviewerelement_free(e);
    }
    constructor(e){
        let t = c.perspectiveviewerelement_new(i(e));
        return k.__wrap(t);
    }
    connectedCallback() {
        c.copydropdownmenuelement_connected_callback(this.__wbg_ptr);
    }
    load(e) {
        let t = c.perspectiveviewerelement_load(this.__wbg_ptr, i(e));
        return w(t);
    }
    delete() {
        let e = c.perspectiveviewerelement_delete(this.__wbg_ptr);
        return w(e);
    }
    getView() {
        let e = c.perspectiveviewerelement_getView(this.__wbg_ptr);
        return w(e);
    }
    getTable(e) {
        let t = c.perspectiveviewerelement_getTable(this.__wbg_ptr, b(e) ? 16777215 : e ? 1 : 0);
        return w(t);
    }
    getRenderStats() {
        try {
            let o = c.__wbindgen_add_to_stack_pointer(-16);
            c.perspectiveviewerelement_getRenderStats(o, this.__wbg_ptr);
            var e = a()[o / 4 + 0], t = a()[o / 4 + 1], r = a()[o / 4 + 2];
            if (r) throw w(t);
            return w(e);
        } finally{
            c.__wbindgen_add_to_stack_pointer(16);
        }
    }
    flush() {
        let e = c.perspectiveviewerelement_flush(this.__wbg_ptr);
        return w(e);
    }
    restore(e) {
        let t = c.perspectiveviewerelement_restore(this.__wbg_ptr, i(e));
        return w(t);
    }
    save(e) {
        var t = b(e) ? 0 : p(e, c.__wbindgen_export_0, c.__wbindgen_export_1), r = d;
        let o = c.perspectiveviewerelement_save(this.__wbg_ptr, t, r);
        return w(o);
    }
    download(e) {
        let t = c.perspectiveviewerelement_download(this.__wbg_ptr, b(e) ? 16777215 : e ? 1 : 0);
        return w(t);
    }
    copy(e) {
        let t = c.perspectiveviewerelement_copy(this.__wbg_ptr, b(e) ? 16777215 : e ? 1 : 0);
        return w(t);
    }
    reset(e) {
        let t = c.perspectiveviewerelement_reset(this.__wbg_ptr, b(e) ? 16777215 : e ? 1 : 0);
        return w(t);
    }
    notifyResize(e) {
        let t = c.perspectiveviewerelement_notifyResize(this.__wbg_ptr, b(e) ? 16777215 : e ? 1 : 0);
        return w(t);
    }
    setAutoSize(e) {
        c.perspectiveviewerelement_setAutoSize(this.__wbg_ptr, e);
    }
    setAutoPause(e) {
        c.perspectiveviewerelement_setAutoPause(this.__wbg_ptr, e);
    }
    getEditPort() {
        try {
            let o = c.__wbindgen_add_to_stack_pointer(-16);
            c.perspectiveviewerelement_getEditPort(o, this.__wbg_ptr);
            var e = ue()[o / 8 + 0], t = a()[o / 4 + 2], r = a()[o / 4 + 3];
            if (r) throw w(t);
            return e;
        } finally{
            c.__wbindgen_add_to_stack_pointer(16);
        }
    }
    restyleElement() {
        let e = c.perspectiveviewerelement_restyleElement(this.__wbg_ptr);
        return w(e);
    }
    resetThemes(e) {
        var t = b(e) ? 0 : Fe(e, c.__wbindgen_export_0), r = d;
        let o = c.perspectiveviewerelement_resetThemes(this.__wbg_ptr, t, r);
        return w(o);
    }
    setThrottle(e) {
        c.perspectiveviewerelement_setThrottle(this.__wbg_ptr, !b(e), b(e) ? 0 : e);
    }
    toggleConfig(e) {
        let t = c.perspectiveviewerelement_toggleConfig(this.__wbg_ptr, b(e) ? 16777215 : e ? 1 : 0);
        return w(t);
    }
    getAllPlugins() {
        let e = c.perspectiveviewerelement_getAllPlugins(this.__wbg_ptr);
        return w(e);
    }
    getPlugin(e) {
        try {
            let f = c.__wbindgen_add_to_stack_pointer(-16);
            var t = b(e) ? 0 : p(e, c.__wbindgen_export_0, c.__wbindgen_export_1), r = d;
            c.perspectiveviewerelement_getPlugin(f, this.__wbg_ptr, t, r);
            var o = a()[f / 4 + 0], s = a()[f / 4 + 1], u = a()[f / 4 + 2];
            if (u) throw w(s);
            return w(o);
        } finally{
            c.__wbindgen_add_to_stack_pointer(16);
        }
    }
    unsafeGetModel() {
        return c.perspectiveviewerelement_unsafeGetModel(this.__wbg_ptr);
    }
    toggleColumnSettings(e) {
        let t = p(e, c.__wbindgen_export_0, c.__wbindgen_export_1), r = d, o = c.perspectiveviewerelement_toggleColumnSettings(this.__wbg_ptr, t, r);
        return w(o);
    }
    openColumnSettings(e, t) {
        var r = b(e) ? 0 : p(e, c.__wbindgen_export_0, c.__wbindgen_export_1), o = d;
        let s = c.perspectiveviewerelement_openColumnSettings(this.__wbg_ptr, r, o, b(t) ? 16777215 : t ? 1 : 0);
        return w(s);
    }
};
async function Ee(n, e) {
    if (typeof Response == "function" && n instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming == "function") try {
            return await WebAssembly.instantiateStreaming(n, e);
        } catch (r) {
            if (n.headers.get("Content-Type") != "application/wasm") console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", r);
            else throw r;
        }
        let t = await n.arrayBuffer();
        return await WebAssembly.instantiate(t, e);
    } else {
        let t = await WebAssembly.instantiate(n, e);
        return t instanceof WebAssembly.Instance ? {
            instance: t,
            module: n
        } : t;
    }
}
function ge() {
    let n = {};
    return n.wbg = {}, n.wbg.__wbindgen_is_undefined = function(e) {
        return _(e) === void 0;
    }, n.wbg.__wbindgen_in = function(e, t) {
        return _(e) in _(t);
    }, n.wbg.__wbindgen_number_get = function(e, t) {
        let r = _(t), o = typeof r == "number" ? r : void 0;
        ue()[e / 8 + 1] = b(o) ? 0 : o, a()[e / 4 + 0] = !b(o);
    }, n.wbg.__wbindgen_boolean_get = function(e) {
        let t = _(e);
        return typeof t == "boolean" ? t ? 1 : 0 : 2;
    }, n.wbg.__wbindgen_string_get = function(e, t) {
        let r = _(t), o = typeof r == "string" ? r : void 0;
        var s = b(o) ? 0 : p(o, c.__wbindgen_export_0, c.__wbindgen_export_1), u = d;
        a()[e / 4 + 1] = u, a()[e / 4 + 0] = s;
    }, n.wbg.__wbindgen_is_bigint = function(e) {
        return typeof _(e) == "bigint";
    }, n.wbg.__wbindgen_is_object = function(e) {
        let t = _(e);
        return typeof t == "object" && t !== null;
    }, n.wbg.__wbindgen_is_string = function(e) {
        return typeof _(e) == "string";
    }, n.wbg.__wbindgen_bigint_from_i64 = function(e) {
        return i(e);
    }, n.wbg.__wbindgen_bigint_from_u64 = function(e) {
        let t = BigInt.asUintN(64, e);
        return i(t);
    }, n.wbg.__wbindgen_error_new = function(e, t) {
        let r = new Error(g(e, t));
        return i(r);
    }, n.wbg.__wbg_static_accessor_PSP_c3dbc79b238dc06b = function() {
        return i(h);
    }, n.wbg.__wbindgen_object_clone_ref = function(e) {
        let t = _(e);
        return i(t);
    }, n.wbg.__wbg_getminmax_8982292064ae3e18 = function() {
        return A(function(e, t) {
            let r = _(e).get_min_max(w(t));
            return i(r);
        }, arguments);
    }, n.wbg.__wbindgen_jsval_eq = function(e, t) {
        return _(e) === _(t);
    }, n.wbg.__wbindgen_string_new = function(e, t) {
        let r = g(e, t);
        return i(r);
    }, n.wbg.__wbg_supportedValuesOf_c2da3a2bdcbeb90b = function(e) {
        let t = Intl.supportedValuesOf(_(e));
        return i(t);
    }, n.wbg.__wbindgen_object_drop_ref = function(e) {
        w(e);
    }, n.wbg.__wbindgen_cb_drop = function(e) {
        let t = w(e).original;
        return t.cnt-- == 1 ? (t.a = 0, !0) : !1;
    }, n.wbg.__wbindgen_as_number = function(e) {
        return +_(e);
    }, n.wbg.__wbindgen_number_new = function(e) {
        return i(e);
    }, n.wbg.__wbg_save_8a361244d5c1f18c = function(e) {
        let t = _(e).save();
        return i(t);
    }, n.wbg.__wbg_new_dc2134dab8727f80 = function(e) {
        let t = new re(_(e));
        return i(t);
    }, n.wbg.__wbindgen_is_null = function(e) {
        return _(e) === null;
    }, n.wbg.__wbg_contentRect_a305e7edcb9d4abe = function(e) {
        let t = _(e).contentRect;
        return i(t);
    }, n.wbg.__wbg_draw_ddd3c4011cd62231 = function() {
        return A(function(e, t, r, o, s, u, f) {
            let l = _(e).draw(_(t), r === 0 ? void 0 : o >>> 0, s === 0 ? void 0 : u >>> 0, f !== 0);
            return i(l);
        }, arguments);
    }, n.wbg.__wbg_update_cd54a24cc17c0c7c = function() {
        return A(function(e, t, r, o, s, u, f) {
            let l = _(e).update(_(t), r === 0 ? void 0 : o >>> 0, s === 0 ? void 0 : u >>> 0, f !== 0);
            return i(l);
        }, arguments);
    }, n.wbg.__wbg_delete_c2ef1699a3cfcc7f = function(e) {
        _(e).delete();
    }, n.wbg.__wbg_setrenderwarning_81697f8db3c3f592 = function(e, t) {
        _(e).render_warning = t !== 0;
    }, n.wbg.__wbg_size_db20efad248b40e2 = function() {
        return A(function(e) {
            let t = _(e).size();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_columns_802f4b7f115fd802 = function() {
        return A(function(e) {
            let t = _(e).columns();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_schema_79818752c2a04c3c = function() {
        return A(function(e) {
            let t = _(e).schema();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_makeport_1d732cb43a49e508 = function() {
        return A(function(e) {
            let t = _(e).make_port();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_numtablerows_8ebcfc773cdfcac5 = function(e) {
        return _(e).num_table_rows;
    }, n.wbg.__wbg_numtablecolumns_4a47101a5cdcac71 = function(e) {
        return _(e).num_table_columns;
    }, n.wbg.__wbg_numviewrows_1ca2d2ab5799901d = function(e) {
        return _(e).num_view_rows;
    }, n.wbg.__wbg_numviewcolumns_20cd29cc6fa45fb6 = function(e) {
        return _(e).num_view_columns;
    }, n.wbg.__wbg_errors_47d231581231b9ee = function(e) {
        let t = _(e).errors;
        return i(t);
    }, n.wbg.__wbg_tocolumns_d788c6e12e1cf716 = function() {
        return A(function(e) {
            let t = _(e).to_columns();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_new_7373c50d13bd70ab = function(e) {
        let t = new _e(_(e));
        return i(t);
    }, n.wbg.__wbg_observe_55aa345f4357bbee = function(e, t) {
        _(e).observe(_(t));
    }, n.wbg.__wbg_unobserve_497d11e151918149 = function(e, t) {
        _(e).unobserve(_(t));
    }, n.wbg.__wbg_isIntersecting_ca42d4734d493015 = function(e) {
        return _(e).isIntersecting;
    }, n.wbg.__wbg_onupdate_ea3f628dfb2fd96d = function(e, t) {
        _(e).on_update(_(t));
    }, n.wbg.__wbg_removeupdate_e5c12e2adce298f5 = function(e, t) {
        _(e).remove_update(_(t));
    }, n.wbg.__wbg_expressionschema_8e157e4dbe8a4e20 = function(e) {
        let t = _(e).expression_schema;
        return i(t);
    }, n.wbg.__wbg_expressionalias_13097a17c590bc5c = function(e) {
        let t = _(e).expression_alias;
        return i(t);
    }, n.wbg.__wbg_validateexpressions_5cb6d1ebbb5e85b7 = function() {
        return A(function(e, t) {
            let r = _(e).validate_expressions(w(t));
            return i(r);
        }, arguments);
    }, n.wbg.__wbg_view_b7f3d62373289f40 = function() {
        return A(function(e, t) {
            let r = _(e).view(_(t));
            return i(r);
        }, arguments);
    }, n.wbg.__wbg_tocsv_0f8724b95955f71c = function() {
        return A(function(e, t) {
            let r = _(e).to_csv(w(t));
            return i(r);
        }, arguments);
    }, n.wbg.__wbg_toarrow_bc92507ca83c6e2f = function() {
        return A(function(e) {
            let t = _(e).to_arrow();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_dimensions_4eb96a0acbae98b6 = function() {
        return A(function(e) {
            let t = _(e).dimensions();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_schema_48c9fc5a96004123 = function() {
        return A(function(e) {
            let t = _(e).schema();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_delete_5cb7627a3c4696c5 = function() {
        return A(function(e) {
            let t = _(e).delete();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_name_b603fa7213eb3d60 = function(e, t) {
        let r = _(t).name, o = p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbg_category_87ce826c77262e57 = function(e, t) {
        let r = _(t).category;
        var o = b(r) ? 0 : p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbg_maxcolumns_890e6ded91a21f6a = function(e, t) {
        let r = _(t).max_columns;
        a()[e / 4 + 1] = b(r) ? 0 : r, a()[e / 4 + 0] = !b(r);
    }, n.wbg.__wbg_maxcells_20b1a2fa51091651 = function(e, t) {
        let r = _(t).max_cells;
        a()[e / 4 + 1] = b(r) ? 0 : r, a()[e / 4 + 0] = !b(r);
    }, n.wbg.__wbg_renderwarning_74f32122d78f3650 = function(e) {
        let t = _(e).render_warning;
        return b(t) ? 16777215 : t ? 1 : 0;
    }, n.wbg.__wbg_selectmode_bc6e88fc286903e9 = function(e) {
        let t = _(e).select_mode;
        return i(t);
    }, n.wbg.__wbg_minconfigcolumns_944816c7a5b67ad3 = function(e, t) {
        let r = _(t).min_config_columns;
        a()[e / 4 + 1] = b(r) ? 0 : r, a()[e / 4 + 0] = !b(r);
    }, n.wbg.__wbg_configcolumnnames_8d4c9194bdba61df = function(e) {
        let t = _(e).config_column_names;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_priority_c2fc87cc826d94a6 = function(e, t) {
        let r = _(t).priority;
        a()[e / 4 + 1] = b(r) ? 0 : r, a()[e / 4 + 0] = !b(r);
    }, n.wbg.__wbg_canrendercolumnstyles_ee96d42508af27df = function() {
        return A(function(e, t, r, o, s) {
            return _(e).can_render_column_styles(g(t, r), o === 0 ? void 0 : g(o, s));
        }, arguments);
    }, n.wbg.__wbg_columnstylecontrols_e440ffeeeb1c3089 = function() {
        return A(function(e, t, r, o, s) {
            let u = _(e).column_style_controls(g(t, r), o === 0 ? void 0 : g(o, s));
            return i(u);
        }, arguments);
    }, n.wbg.__wbg_restore_3a8a2cb91fb6a885 = function(e, t, r) {
        _(e).restore(_(t), _(r));
    }, n.wbg.__wbg_restyle_d9eb953e15200abb = function() {
        return A(function(e, t) {
            let r = _(e).restyle(_(t));
            return i(r);
        }, arguments);
    }, n.wbg.__wbg_resize_fc13023933c6d8f9 = function() {
        return A(function(e) {
            let t = _(e).resize();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_new_faa69f2aa7aeef61 = function(e) {
        let t = new oe(_(e));
        return i(t);
    }, n.wbg.__wbg_observe_6b94b413c30a2cdf = function(e, t) {
        _(e).observe(_(t));
    }, n.wbg.__wbg_unobserve_cad54e8cb10840dd = function(e, t) {
        _(e).unobserve(_(t));
    }, n.wbg.__wbg_bootstrap_5be3beb85d758b99 = function(e, t, r, o, s, u) {
        let f = ie(_(e), g(t, r), g(o, s), w(u));
        return i(f);
    }, n.wbg.__wbg_listenerid_6dcf1c62b7b7de58 = function(e, t) {
        let r = _(t).__yew_listener_id;
        a()[e / 4 + 1] = b(r) ? 0 : r, a()[e / 4 + 0] = !b(r);
    }, n.wbg.__wbg_setlistenerid_f2e783343fa0cec1 = function(e, t) {
        _(e).__yew_listener_id = t >>> 0;
    }, n.wbg.__wbg_setsubtreeid_e1fab6b578c800cf = function(e, t) {
        _(e).__yew_subtree_id = t >>> 0;
    }, n.wbg.__wbg_setcachekey_75bcd45312087529 = function(e, t) {
        _(e).__yew_subtree_cache_key = t >>> 0;
    }, n.wbg.__wbg_subtreeid_e80a1798fee782f9 = function(e, t) {
        let r = _(t).__yew_subtree_id;
        a()[e / 4 + 1] = b(r) ? 0 : r, a()[e / 4 + 0] = !b(r);
    }, n.wbg.__wbg_cachekey_b81c1aacc6a0645c = function(e, t) {
        let r = _(t).__yew_subtree_cache_key;
        a()[e / 4 + 1] = b(r) ? 0 : r, a()[e / 4 + 0] = !b(r);
    }, n.wbg.__wbg_new_abda76e883ba8a5f = function() {
        let e = new Error;
        return i(e);
    }, n.wbg.__wbg_stack_658279fe44541cf6 = function(e, t) {
        let r = _(t).stack, o = p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbg_error_f851667af71bcfc6 = function(e, t) {
        let r, o;
        try {
            r = e, o = t, console.error(g(e, t));
        } finally{
            c.__wbindgen_export_10(r, o, 1);
        }
    }, n.wbg.__wbindgen_jsval_loose_eq = function(e, t) {
        return _(e) == _(t);
    }, n.wbg.__wbg_String_917f38a1211cf44b = function(e, t) {
        let r = String(_(t)), o = p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbg_getwithrefkey_3b3c46ba20582127 = function(e, t) {
        let r = _(e)[_(t)];
        return i(r);
    }, n.wbg.__wbg_set_8761474ad72b9bf1 = function(e, t, r) {
        _(e)[w(t)] = w(r);
    }, n.wbg.__wbg_error_a526fb08a0205972 = function(e, t) {
        var r = be(e, t).slice();
        c.__wbindgen_export_10(e, t * 4), console.error(...r);
    }, n.wbg.__wbg_newwithu8arraysequence_6951fb5a516ffb36 = function() {
        return A(function(e) {
            let t = new Blob(_(e));
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_newwithstrsequenceandoptions_fd88a547f6d15707 = function() {
        return A(function(e, t) {
            let r = new Blob(_(e), _(t));
            return i(r);
        }, arguments);
    }, n.wbg.__wbg_readText_73c9e15981b9d163 = function(e) {
        let t = _(e).readText();
        return i(t);
    }, n.wbg.__wbg_write_50931fbeecc46371 = function(e, t) {
        let r = _(e).write(_(t));
        return i(r);
    }, n.wbg.__wbg_length_3179cc234ec61f82 = function(e) {
        return _(e).length;
    }, n.wbg.__wbg_item_951718a65579db41 = function(e, t) {
        let r = _(e).item(t >>> 0);
        return b(r) ? 0 : i(r);
    }, n.wbg.__wbg_length_65d94e80342551ba = function(e) {
        return _(e).length;
    }, n.wbg.__wbg_getPropertyValue_45480a940d0053a0 = function() {
        return A(function(e, t, r, o) {
            let s = _(t).getPropertyValue(g(r, o)), u = p(s, c.__wbindgen_export_0, c.__wbindgen_export_1), f = d;
            a()[e / 4 + 1] = f, a()[e / 4 + 0] = u;
        }, arguments);
    }, n.wbg.__wbg_item_039e5e5417c0ad11 = function(e, t, r) {
        let o = _(t).item(r >>> 0), s = p(o, c.__wbindgen_export_0, c.__wbindgen_export_1), u = d;
        a()[e / 4 + 1] = u, a()[e / 4 + 0] = s;
    }, n.wbg.__wbg_setProperty_b95ef63ab852879e = function() {
        return A(function(e, t, r, o, s) {
            _(e).setProperty(g(t, r), g(o, s));
        }, arguments);
    }, n.wbg.__wbg_instanceof_CssStyleRule_5c64447c7de8b7da = function(e) {
        let t;
        try {
            t = _(e) instanceof CSSStyleRule;
        } catch  {
            t = !1;
        }
        return t;
    }, n.wbg.__wbg_selectorText_d3da424c30db7e19 = function(e, t) {
        let r = _(t).selectorText, o = p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbg_style_48dc15f7825db66e = function(e) {
        let t = _(e).style;
        return i(t);
    }, n.wbg.__wbg_cssRules_a82a7edbf9263eac = function() {
        return A(function(e) {
            let t = _(e).cssRules;
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_new_8f6e8c9c9518a2bd = function() {
        return A(function(e, t) {
            let r = new CustomEvent(g(e, t));
            return i(r);
        }, arguments);
    }, n.wbg.__wbg_newwitheventinitdict_4e9208842a1bd356 = function() {
        return A(function(e, t, r) {
            let o = new CustomEvent(g(e, t), _(r));
            return i(o);
        }, arguments);
    }, n.wbg.__wbg_setdropEffect_d191909e581a0725 = function(e, t, r) {
        _(e).dropEffect = g(t, r);
    }, n.wbg.__wbg_setData_929b1326a597cfbe = function() {
        return A(function(e, t, r, o, s) {
            _(e).setData(g(t, r), g(o, s));
        }, arguments);
    }, n.wbg.__wbg_setDragImage_78a56a018979df82 = function(e, t, r, o) {
        _(e).setDragImage(_(t), r, o);
    }, n.wbg.__wbg_readyState_92826bbbfb1989df = function(e, t) {
        let r = _(t).readyState, o = p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbg_body_674aec4c1c0910cd = function(e) {
        let t = _(e).body;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_activeElement_2cf540415b6fcd5c = function(e) {
        let t = _(e).activeElement;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_styleSheets_61fe3de30d6b9eb0 = function(e) {
        let t = _(e).styleSheets;
        return i(t);
    }, n.wbg.__wbg_fonts_a96627ca3c0cc00f = function(e) {
        let t = _(e).fonts;
        return i(t);
    }, n.wbg.__wbg_createElement_4891554b28d3388b = function() {
        return A(function(e, t, r) {
            let o = _(e).createElement(g(t, r));
            return i(o);
        }, arguments);
    }, n.wbg.__wbg_createElementNS_119acf9e82482041 = function() {
        return A(function(e, t, r, o, s) {
            let u = _(e).createElementNS(t === 0 ? void 0 : g(t, r), g(o, s));
            return i(u);
        }, arguments);
    }, n.wbg.__wbg_createTextNode_2fd22cd7e543f938 = function(e, t, r) {
        let o = _(e).createTextNode(g(t, r));
        return i(o);
    }, n.wbg.__wbg_width_e0c6b79d8cdd8897 = function(e) {
        return _(e).width;
    }, n.wbg.__wbg_height_bed51746e072a118 = function(e) {
        return _(e).height;
    }, n.wbg.__wbg_width_5728ff70a76f27ac = function(e) {
        return _(e).width;
    }, n.wbg.__wbg_height_7fd80bb9bbf69d8c = function(e) {
        return _(e).height;
    }, n.wbg.__wbg_top_98ff0408c018d25e = function(e) {
        return _(e).top;
    }, n.wbg.__wbg_left_23a613d619fb4206 = function(e) {
        return _(e).left;
    }, n.wbg.__wbg_get_3c8b4af713d11e93 = function(e, t, r, o) {
        let s = _(t)[g(r, o)];
        var u = b(s) ? 0 : p(s, c.__wbindgen_export_0, c.__wbindgen_export_1), f = d;
        a()[e / 4 + 1] = f, a()[e / 4 + 0] = u;
    }, n.wbg.__wbg_set_f614c140462d8c74 = function() {
        return A(function(e, t, r, o, s) {
            _(e)[g(t, r)] = g(o, s);
        }, arguments);
    }, n.wbg.__wbg_delete_2f353eb7e557282d = function(e, t, r) {
        delete _(e)[g(t, r)];
    }, n.wbg.__wbg_add_e7de92885d30face = function() {
        return A(function(e, t) {
            _(e).add(..._(t));
        }, arguments);
    }, n.wbg.__wbg_add_3eafedc4b2a28db0 = function() {
        return A(function(e, t, r) {
            _(e).add(g(t, r));
        }, arguments);
    }, n.wbg.__wbg_remove_65fa2c242ec681ef = function() {
        return A(function(e, t) {
            _(e).remove(..._(t));
        }, arguments);
    }, n.wbg.__wbg_remove_8ae45e50cb58bb66 = function() {
        return A(function(e, t, r) {
            _(e).remove(g(t, r));
        }, arguments);
    }, n.wbg.__wbg_toggle_67753a6c894f758d = function() {
        return A(function(e, t, r) {
            return _(e).toggle(g(t, r));
        }, arguments);
    }, n.wbg.__wbg_dataTransfer_bac494821ce31837 = function(e) {
        let t = _(e).dataTransfer;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_instanceof_Element_4622f5da1249a3eb = function(e) {
        let t;
        try {
            t = _(e) instanceof Element;
        } catch  {
            t = !1;
        }
        return t;
    }, n.wbg.__wbg_namespaceURI_31718ed49b5343a3 = function(e, t) {
        let r = _(t).namespaceURI;
        var o = b(r) ? 0 : p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbg_tagName_5d48e5a3ca410385 = function(e, t) {
        let r = _(t).tagName, o = p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbg_classList_5f2fc1d67656292e = function(e) {
        let t = _(e).classList;
        return i(t);
    }, n.wbg.__wbg_scrollTop_5011470bb5e739a2 = function(e) {
        return _(e).scrollTop;
    }, n.wbg.__wbg_scrollLeft_ea915614eac6bbeb = function(e) {
        return _(e).scrollLeft;
    }, n.wbg.__wbg_setscrollLeft_71b27cc3cbd7b6a7 = function(e, t) {
        _(e).scrollLeft = t;
    }, n.wbg.__wbg_clientWidth_51ec21e3189f5656 = function(e) {
        return _(e).clientWidth;
    }, n.wbg.__wbg_clientHeight_09ec0b524d59c367 = function(e) {
        return _(e).clientHeight;
    }, n.wbg.__wbg_setinnerHTML_b089587252408b67 = function(e, t, r) {
        _(e).innerHTML = g(t, r);
    }, n.wbg.__wbg_children_27ed308801b57d3f = function(e) {
        let t = _(e).children;
        return i(t);
    }, n.wbg.__wbg_attachShadow_6a91e6c017a447ba = function() {
        return A(function(e, t) {
            let r = _(e).attachShadow(_(t));
            return i(r);
        }, arguments);
    }, n.wbg.__wbg_getAttribute_3d8fcc9eaea35a17 = function(e, t, r, o) {
        let s = _(t).getAttribute(g(r, o));
        var u = b(s) ? 0 : p(s, c.__wbindgen_export_0, c.__wbindgen_export_1), f = d;
        a()[e / 4 + 1] = f, a()[e / 4 + 0] = u;
    }, n.wbg.__wbg_getBoundingClientRect_ac9db8cf97ca8083 = function(e) {
        let t = _(e).getBoundingClientRect();
        return i(t);
    }, n.wbg.__wbg_hasAttribute_a7d05690680041c9 = function(e, t, r) {
        return _(e).hasAttribute(g(t, r));
    }, n.wbg.__wbg_matches_716ab231f92ea8c6 = function() {
        return A(function(e, t, r) {
            return _(e).matches(g(t, r));
        }, arguments);
    }, n.wbg.__wbg_releasePointerCapture_c36c2b5804654f8b = function() {
        return A(function(e, t) {
            _(e).releasePointerCapture(t);
        }, arguments);
    }, n.wbg.__wbg_removeAttribute_d8404da431968808 = function() {
        return A(function(e, t, r) {
            _(e).removeAttribute(g(t, r));
        }, arguments);
    }, n.wbg.__wbg_setAttribute_e7e80b478b7b8b2f = function() {
        return A(function(e, t, r, o, s) {
            _(e).setAttribute(g(t, r), g(o, s));
        }, arguments);
    }, n.wbg.__wbg_setPointerCapture_e7c29336490bba19 = function() {
        return A(function(e, t) {
            _(e).setPointerCapture(t);
        }, arguments);
    }, n.wbg.__wbg_toggleAttribute_a74de5e50b5cae82 = function() {
        return A(function(e, t, r, o) {
            return _(e).toggleAttribute(g(t, r), o !== 0);
        }, arguments);
    }, n.wbg.__wbg_target_f171e89c61e2bccf = function(e) {
        let t = _(e).target;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_bubbles_63572b91f3885ef1 = function(e) {
        return _(e).bubbles;
    }, n.wbg.__wbg_cancelBubble_90d1c3aa2a76cbeb = function(e) {
        return _(e).cancelBubble;
    }, n.wbg.__wbg_composedPath_cf1bb5b8bcff496f = function(e) {
        let t = _(e).composedPath();
        return i(t);
    }, n.wbg.__wbg_preventDefault_24104f3f0a54546a = function(e) {
        _(e).preventDefault();
    }, n.wbg.__wbg_stopPropagation_55539cfa2506c867 = function(e) {
        _(e).stopPropagation();
    }, n.wbg.__wbg_addEventListener_5651108fc3ffeb6e = function() {
        return A(function(e, t, r, o) {
            _(e).addEventListener(g(t, r), _(o));
        }, arguments);
    }, n.wbg.__wbg_addEventListener_a5963e26cd7b176b = function() {
        return A(function(e, t, r, o, s) {
            _(e).addEventListener(g(t, r), _(o), _(s));
        }, arguments);
    }, n.wbg.__wbg_dispatchEvent_a622a6455be582eb = function() {
        return A(function(e, t) {
            return _(e).dispatchEvent(_(t));
        }, arguments);
    }, n.wbg.__wbg_removeEventListener_5de660c02ed784e4 = function() {
        return A(function(e, t, r, o) {
            _(e).removeEventListener(g(t, r), _(o));
        }, arguments);
    }, n.wbg.__wbg_instanceof_FontFace_490eb4a907ee634b = function(e) {
        let t;
        try {
            t = _(e) instanceof FontFace;
        } catch  {
            t = !1;
        }
        return t;
    }, n.wbg.__wbg_family_d28cb65d31f2cd13 = function(e, t) {
        let r = _(t).family, o = p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbg_weight_5a05e0b24e1dbc22 = function(e, t) {
        let r = _(t).weight, o = p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbg_loaded_8b7295ea3d9a264f = function() {
        return A(function(e) {
            let t = _(e).loaded;
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_values_c8fb3ce467f0661c = function(e) {
        let t = _(e).values();
        return i(t);
    }, n.wbg.__wbg_next_2f195e2857296bee = function() {
        return A(function(e) {
            let t = _(e).next();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_item_3364fbfadbf2cf08 = function(e, t) {
        let r = _(e).item(t >>> 0);
        return b(r) ? 0 : i(r);
    }, n.wbg.__wbg_getwithindex_a41abfefef0f0eb7 = function(e, t) {
        let r = _(e)[t >>> 0];
        return b(r) ? 0 : i(r);
    }, n.wbg.__wbg_scrollTop_9e5ce77431551404 = function(e) {
        return _(e).scrollTop;
    }, n.wbg.__wbg_setscrollTop_3ac526446d755a1e = function(e, t) {
        _(e).scrollTop = t;
    }, n.wbg.__wbg_dataset_6b4e19567ec0651f = function(e) {
        let t = _(e).dataset;
        return i(t);
    }, n.wbg.__wbg_style_3801009b2339aa94 = function(e) {
        let t = _(e).style;
        return i(t);
    }, n.wbg.__wbg_offsetParent_290832c400c7cc6c = function(e) {
        let t = _(e).offsetParent;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_offsetWidth_4e9930121c69297f = function(e) {
        return _(e).offsetWidth;
    }, n.wbg.__wbg_offsetHeight_aa809a38421d42e3 = function(e) {
        return _(e).offsetHeight;
    }, n.wbg.__wbg_blur_53431c003c82bf53 = function() {
        return A(function(e) {
            _(e).blur();
        }, arguments);
    }, n.wbg.__wbg_click_9f2ce0ac84b1ce73 = function(e) {
        _(e).click();
    }, n.wbg.__wbg_focus_dbcbbbb2a04c0e1f = function() {
        return A(function(e) {
            _(e).focus();
        }, arguments);
    }, n.wbg.__wbg_checked_5ccb3a66eb054121 = function(e) {
        return _(e).checked;
    }, n.wbg.__wbg_setchecked_e5a50baea447b8a8 = function(e, t) {
        _(e).checked = t !== 0;
    }, n.wbg.__wbg_value_9423da9d988ee8cf = function(e, t) {
        let r = _(t).value, o = p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbg_setvalue_1f95e61cbc382f7f = function(e, t, r) {
        _(e).value = g(t, r);
    }, n.wbg.__wbg_valueAsNumber_c5b647430655b1f5 = function(e) {
        return _(e).valueAsNumber;
    }, n.wbg.__wbg_selectedIndex_bceec31ccc0d7767 = function(e) {
        return _(e).selectedIndex;
    }, n.wbg.__wbg_setvalue_4c8843ef308f3553 = function(e, t, r) {
        _(e).value = g(t, r);
    }, n.wbg.__wbg_value_3c5f08ffc2b7d6f9 = function(e, t) {
        let r = _(t).value, o = p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbg_setvalue_0dc100d4b9908028 = function(e, t, r) {
        _(e).value = g(t, r);
    }, n.wbg.__wbg_setselectionStart_517073c440938d81 = function() {
        return A(function(e, t, r) {
            _(e).selectionStart = t === 0 ? void 0 : r >>> 0;
        }, arguments);
    }, n.wbg.__wbg_selectionEnd_4a7befb6ce3bda9a = function() {
        return A(function(e, t) {
            let r = _(t).selectionEnd;
            a()[e / 4 + 1] = b(r) ? 0 : r, a()[e / 4 + 0] = !b(r);
        }, arguments);
    }, n.wbg.__wbg_setselectionEnd_52811328cd685103 = function() {
        return A(function(e, t, r) {
            _(e).selectionEnd = t === 0 ? void 0 : r >>> 0;
        }, arguments);
    }, n.wbg.__wbg_keyCode_dfa86be31f5ef90c = function(e) {
        return _(e).keyCode;
    }, n.wbg.__wbg_shiftKey_48e8701355d8e2d4 = function(e) {
        return _(e).shiftKey;
    }, n.wbg.__wbg_clientX_1a480606ab0cabaa = function(e) {
        return _(e).clientX;
    }, n.wbg.__wbg_clientY_9c7878f7faf3900f = function(e) {
        return _(e).clientY;
    }, n.wbg.__wbg_offsetX_5a58f16f6c3a41b6 = function(e) {
        return _(e).offsetX;
    }, n.wbg.__wbg_offsetY_c45b4956f6429a95 = function(e) {
        return _(e).offsetY;
    }, n.wbg.__wbg_shiftKey_8a070ab6169b5fa4 = function(e) {
        return _(e).shiftKey;
    }, n.wbg.__wbg_button_7a095234b69de930 = function(e) {
        return _(e).button;
    }, n.wbg.__wbg_relatedTarget_41b8cc5c499518af = function(e) {
        let t = _(e).relatedTarget;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_clipboard_47d5c6d7496034ae = function(e) {
        let t = _(e).clipboard;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_languages_4ab80469955a57f7 = function(e) {
        let t = _(e).languages;
        return i(t);
    }, n.wbg.__wbg_isConnected_584a7a7119428e2c = function(e) {
        return _(e).isConnected;
    }, n.wbg.__wbg_parentNode_9e53f8b17eb98c9d = function(e) {
        let t = _(e).parentNode;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_parentElement_c75962bc9997ea5f = function(e) {
        let t = _(e).parentElement;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_childNodes_64dab37cf9d252dd = function(e) {
        let t = _(e).childNodes;
        return i(t);
    }, n.wbg.__wbg_lastChild_0cee692010bac6c2 = function(e) {
        let t = _(e).lastChild;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_nextSibling_304d9aac7c2774ae = function(e) {
        let t = _(e).nextSibling;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_setnodeValue_d1c8382910b45e04 = function(e, t, r) {
        _(e).nodeValue = t === 0 ? void 0 : g(t, r);
    }, n.wbg.__wbg_settextContent_28d80502cf08bde7 = function(e, t, r) {
        _(e).textContent = t === 0 ? void 0 : g(t, r);
    }, n.wbg.__wbg_appendChild_51339d4cde00ee22 = function() {
        return A(function(e, t) {
            let r = _(e).appendChild(_(t));
            return i(r);
        }, arguments);
    }, n.wbg.__wbg_cloneNode_1f7cce4ea8b708e2 = function() {
        return A(function(e) {
            let t = _(e).cloneNode();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_cloneNode_270bc5a29f27e929 = function() {
        return A(function(e, t) {
            let r = _(e).cloneNode(t !== 0);
            return i(r);
        }, arguments);
    }, n.wbg.__wbg_contains_fab0394bee511df3 = function(e, t) {
        return _(e).contains(_(t));
    }, n.wbg.__wbg_getRootNode_a048b91714805811 = function(e) {
        let t = _(e).getRootNode();
        return i(t);
    }, n.wbg.__wbg_insertBefore_ffa01d4b747c95fc = function() {
        return A(function(e, t, r) {
            let o = _(e).insertBefore(_(t), _(r));
            return i(o);
        }, arguments);
    }, n.wbg.__wbg_removeChild_973429f368206138 = function() {
        return A(function(e, t) {
            let r = _(e).removeChild(_(t));
            return i(r);
        }, arguments);
    }, n.wbg.__wbg_getEntriesByName_ede90ef3e380dfc0 = function(e, t, r, o, s) {
        let u = _(e).getEntriesByName(g(t, r), g(o, s));
        return i(u);
    }, n.wbg.__wbg_mark_5fe2e199adb6244e = function() {
        return A(function(e, t, r) {
            _(e).mark(g(t, r));
        }, arguments);
    }, n.wbg.__wbg_measure_1200cbb479d26c69 = function() {
        return A(function(e, t, r, o, s) {
            _(e).measure(g(t, r), g(o, s));
        }, arguments);
    }, n.wbg.__wbg_now_0cfdc90c97d0c24b = function(e) {
        return _(e).now();
    }, n.wbg.__wbg_startTime_f4237cec7cb73530 = function(e) {
        return _(e).startTime;
    }, n.wbg.__wbg_pointerId_701aab7b4fb073ff = function(e) {
        return _(e).pointerId;
    }, n.wbg.__wbg_instanceof_ShadowRoot_b64337370f59fe2d = function(e) {
        let t;
        try {
            t = _(e) instanceof ShadowRoot;
        } catch  {
            t = !1;
        }
        return t;
    }, n.wbg.__wbg_host_e1c47c33975060d3 = function(e) {
        let t = _(e).host;
        return i(t);
    }, n.wbg.__wbg_length_f0d60728a0b63310 = function(e) {
        return _(e).length;
    }, n.wbg.__wbg_item_130a058fb0686ec7 = function(e, t) {
        let r = _(e).item(t >>> 0);
        return b(r) ? 0 : i(r);
    }, n.wbg.__wbg_which_c9430257b4adad75 = function(e) {
        return _(e).which;
    }, n.wbg.__wbg_createObjectURL_d82f2880bada6a1d = function() {
        return A(function(e, t) {
            let r = URL.createObjectURL(_(t)), o = p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
            a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
        }, arguments);
    }, n.wbg.__wbg_instanceof_Window_9029196b662bc42a = function(e) {
        let t;
        try {
            t = _(e) instanceof Window;
        } catch  {
            t = !1;
        }
        return t;
    }, n.wbg.__wbg_document_f7ace2b956f30a4f = function(e) {
        let t = _(e).document;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_navigator_7c9103698acde322 = function(e) {
        let t = _(e).navigator;
        return i(t);
    }, n.wbg.__wbg_innerWidth_ebe07ce5463ff293 = function() {
        return A(function(e) {
            let t = _(e).innerWidth;
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_innerHeight_2dd06d8cf68f1d7d = function() {
        return A(function(e) {
            let t = _(e).innerHeight;
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_performance_2c295061c8b01e0b = function(e) {
        let t = _(e).performance;
        return b(t) ? 0 : i(t);
    }, n.wbg.__wbg_getComputedStyle_09fd3af3edcbbc36 = function() {
        return A(function(e, t) {
            let r = _(e).getComputedStyle(_(t));
            return b(r) ? 0 : i(r);
        }, arguments);
    }, n.wbg.__wbg_get_cb7c1c2da725c920 = function(e, t, r) {
        let o = _(e)[g(t, r)];
        return b(o) ? 0 : i(o);
    }, n.wbg.__wbg_requestAnimationFrame_d082200514b6674d = function() {
        return A(function(e, t) {
            return _(e).requestAnimationFrame(_(t));
        }, arguments);
    }, n.wbg.__wbg_setTimeout_eb1a0d116c26d9f6 = function() {
        return A(function(e, t, r) {
            return _(e).setTimeout(_(t), r);
        }, arguments);
    }, n.wbg.__wbg_debug_9a6b3243fbbebb61 = function(e) {
        console.debug(_(e));
    }, n.wbg.__wbg_debug_9b8701f894da9929 = function(e, t, r, o) {
        console.debug(_(e), _(t), _(r), _(o));
    }, n.wbg.__wbg_error_788ae33f81d3b84b = function(e) {
        console.error(_(e));
    }, n.wbg.__wbg_error_cc121a8b7a240029 = function(e, t, r) {
        console.error(_(e), _(t), _(r));
    }, n.wbg.__wbg_error_d9bce418caafb712 = function(e, t, r, o) {
        console.error(_(e), _(t), _(r), _(o));
    }, n.wbg.__wbg_info_2e30e8204b29d91d = function(e) {
        console.info(_(e));
    }, n.wbg.__wbg_info_bb52f40b06f679de = function(e, t, r, o) {
        console.info(_(e), _(t), _(r), _(o));
    }, n.wbg.__wbg_trace_2fe09a8becaefa14 = function(e) {
        console.trace(_(e));
    }, n.wbg.__wbg_trace_8f88b836b1876a39 = function(e, t, r, o) {
        console.trace(_(e), _(t), _(r), _(o));
    }, n.wbg.__wbg_warn_d60e832f9882c1b2 = function(e) {
        console.warn(_(e));
    }, n.wbg.__wbg_warn_dfc0e0cf544a13bd = function(e, t, r, o) {
        console.warn(_(e), _(t), _(r), _(o));
    }, n.wbg.__wbindgen_is_function = function(e) {
        return typeof _(e) == "function";
    }, n.wbg.__wbg_self_1ff1d729e9aae938 = function() {
        return A(function() {
            let e = self.self;
            return i(e);
        }, arguments);
    }, n.wbg.__wbg_window_5f4faef6c12b79ec = function() {
        return A(function() {
            let e = window.window;
            return i(e);
        }, arguments);
    }, n.wbg.__wbg_globalThis_1d39714405582d3c = function() {
        return A(function() {
            let e = globalThis.globalThis;
            return i(e);
        }, arguments);
    }, n.wbg.__wbg_global_651f05c6a0944d1c = function() {
        return A(function() {
            let e = global.global;
            return i(e);
        }, arguments);
    }, n.wbg.__wbg_newnoargs_581967eacc0e2604 = function(e, t) {
        let r = new Function(g(e, t));
        return i(r);
    }, n.wbg.__wbg_length_fff51ee6522a1a18 = function(e) {
        return _(e).length;
    }, n.wbg.__wbg_new_898a68150f225f2e = function() {
        let e = new Array;
        return i(e);
    }, n.wbg.__wbg_new_56693dbed0c32988 = function() {
        return i(new Map);
    }, n.wbg.__wbg_next_526fc47e980da008 = function(e) {
        let t = _(e).next;
        return i(t);
    }, n.wbg.__wbg_value_1695675138684bd5 = function(e) {
        let t = _(e).value;
        return i(t);
    }, n.wbg.__wbg_iterator_97f0c81209c6c35a = function() {
        return i(Symbol.iterator);
    }, n.wbg.__wbg_new_b51585de1b234aff = function() {
        let e = new Object;
        return i(e);
    }, n.wbg.__wbg_new_520d435cdd007a3c = function(e, t) {
        let r = new Intl.DateTimeFormat(_(e), _(t));
        return i(r);
    }, n.wbg.__wbg_new_dc43d068b9d54bba = function(e, t) {
        let r = new Intl.NumberFormat(_(e), _(t));
        return i(r);
    }, n.wbg.__wbg_at_f175831507f8dd5a = function(e, t) {
        let r = _(e).at(t);
        return i(r);
    }, n.wbg.__wbg_get_44be0491f933a435 = function(e, t) {
        let r = _(e)[t >>> 0];
        return i(r);
    }, n.wbg.__wbg_set_502d29070ea18557 = function(e, t, r) {
        _(e)[t >>> 0] = w(r);
    }, n.wbg.__wbg_from_d7c216d4616bb368 = function(e) {
        let t = Array.from(_(e));
        return i(t);
    }, n.wbg.__wbg_isArray_4c24b343cb13cfb1 = function(e) {
        return Array.isArray(_(e));
    }, n.wbg.__wbg_push_ca1c26067ef907ac = function(e, t) {
        return _(e).push(_(t));
    }, n.wbg.__wbg_instanceof_ArrayBuffer_39ac22089b74fddb = function(e) {
        let t;
        try {
            t = _(e) instanceof ArrayBuffer;
        } catch  {
            t = !1;
        }
        return t;
    }, n.wbg.__wbg_slice_bfe6611c590b4e68 = function(e, t, r) {
        let o = _(e).slice(t >>> 0, r >>> 0);
        return i(o);
    }, n.wbg.__wbg_instanceof_Error_ab19e20608ea43c7 = function(e) {
        let t;
        try {
            t = _(e) instanceof Error;
        } catch  {
            t = !1;
        }
        return t;
    }, n.wbg.__wbg_message_48bacc5ea57d74ee = function(e) {
        let t = _(e).message;
        return i(t);
    }, n.wbg.__wbg_call_cb65541d95d71282 = function() {
        return A(function(e, t) {
            let r = _(e).call(_(t));
            return i(r);
        }, arguments);
    }, n.wbg.__wbg_call_01734de55d61e11d = function() {
        return A(function(e, t, r) {
            let o = _(e).call(_(t), _(r));
            return i(o);
        }, arguments);
    }, n.wbg.__wbg_set_bedc3d02d0f05eb0 = function(e, t, r) {
        let o = _(e).set(_(t), _(r));
        return i(o);
    }, n.wbg.__wbg_next_ddb3312ca1c4e32a = function() {
        return A(function(e) {
            let t = _(e).next();
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_done_5c1f01fb660d73b5 = function(e) {
        return _(e).done;
    }, n.wbg.__wbg_isSafeInteger_bb8e18dd21c97288 = function(e) {
        return Number.isSafeInteger(_(e));
    }, n.wbg.__wbg_getTimezoneOffset_8aee3445f323973e = function(e) {
        return _(e).getTimezoneOffset();
    }, n.wbg.__wbg_new_cd59bfc8881f487b = function(e) {
        let t = new Date(_(e));
        return i(t);
    }, n.wbg.__wbg_entries_e51f29c7bba0c054 = function(e) {
        let t = Object.entries(_(e));
        return i(t);
    }, n.wbg.__wbg_is_205d914af04a8faa = function(e, t) {
        return Object.is(_(e), _(t));
    }, n.wbg.__wbg_keys_386d224d0262f361 = function(e) {
        let t = Object.keys(_(e));
        return i(t);
    }, n.wbg.__wbg_get_97b561fb56f034b5 = function() {
        return A(function(e, t) {
            let r = Reflect.get(_(e), _(t));
            return i(r);
        }, arguments);
    }, n.wbg.__wbg_has_c5fcd020291e56b8 = function() {
        return A(function(e, t) {
            return Reflect.has(_(e), _(t));
        }, arguments);
    }, n.wbg.__wbg_set_092e06b0f9d71865 = function() {
        return A(function(e, t, r) {
            return Reflect.set(_(e), _(t), _(r));
        }, arguments);
    }, n.wbg.__wbg_buffer_085ec1f694018c4f = function(e) {
        let t = _(e).buffer;
        return i(t);
    }, n.wbg.__wbg_stringify_e25465938f3f611f = function() {
        return A(function(e) {
            let t = JSON.stringify(_(e));
            return i(t);
        }, arguments);
    }, n.wbg.__wbg_stringify_9149e50ff714fcc6 = function() {
        return A(function(e, t, r) {
            let o = JSON.stringify(_(e), _(t), _(r));
            return i(o);
        }, arguments);
    }, n.wbg.__wbg_resolvedOptions_ca1f2808dccec127 = function(e) {
        let t = _(e).resolvedOptions();
        return i(t);
    }, n.wbg.__wbg_format_d0ead309c8492f71 = function(e) {
        let t = _(e).format;
        return i(t);
    }, n.wbg.__wbg_instanceof_Promise_0e98a5bf082e090f = function(e) {
        let t;
        try {
            t = _(e) instanceof Promise;
        } catch  {
            t = !1;
        }
        return t;
    }, n.wbg.__wbg_new_43f1b47c28813cbd = function(e, t) {
        try {
            var r = {
                a: e,
                b: t
            }, o = (u, f)=>{
                let l = r.a;
                r.a = 0;
                try {
                    return Ie(l, r.b, u, f);
                } finally{
                    r.a = l;
                }
            };
            let s = new Promise(o);
            return i(s);
        } finally{
            r.a = r.b = 0;
        }
    }, n.wbg.__wbg_resolve_53698b95aaf7fcf8 = function(e) {
        let t = Promise.resolve(_(e));
        return i(t);
    }, n.wbg.__wbg_then_f7e06ee3c11698eb = function(e, t) {
        let r = _(e).then(_(t));
        return i(r);
    }, n.wbg.__wbg_then_b2267541e2a73865 = function(e, t, r) {
        let o = _(e).then(_(t), _(r));
        return i(o);
    }, n.wbg.__wbg_newwithbyteoffsetandlength_6da8e527659b86aa = function(e, t, r) {
        let o = new Uint8Array(_(e), t >>> 0, r >>> 0);
        return i(o);
    }, n.wbg.__wbg_new_8125e318e6245eed = function(e) {
        let t = new Uint8Array(_(e));
        return i(t);
    }, n.wbg.__wbg_instanceof_Uint8Array_d8d9cb2b8e8ac1d4 = function(e) {
        let t;
        try {
            t = _(e) instanceof Uint8Array;
        } catch  {
            t = !1;
        }
        return t;
    }, n.wbg.__wbg_buffer_f5b7059c439f330d = function(e) {
        let t = _(e).buffer;
        return i(t);
    }, n.wbg.__wbg_length_72e2208bbc0efc61 = function(e) {
        return _(e).length;
    }, n.wbg.__wbg_byteLength_47d11fa79875dee3 = function(e) {
        return _(e).byteLength;
    }, n.wbg.__wbg_byteOffset_79dc6cc49d3d92d8 = function(e) {
        return _(e).byteOffset;
    }, n.wbg.__wbg_set_5cf90238115182c3 = function(e, t, r) {
        _(e).set(_(t), r >>> 0);
    }, n.wbg.__wbindgen_bigint_get_as_i64 = function(e, t) {
        let r = _(t), o = typeof r == "bigint" ? r : void 0;
        he()[e / 8 + 1] = b(o) ? BigInt(0) : o, a()[e / 4 + 0] = !b(o);
    }, n.wbg.__wbindgen_debug_string = function(e, t) {
        let r = Y(_(t)), o = p(r, c.__wbindgen_export_0, c.__wbindgen_export_1), s = d;
        a()[e / 4 + 1] = s, a()[e / 4 + 0] = o;
    }, n.wbg.__wbindgen_throw = function(e, t) {
        throw new Error(g(e, t));
    }, n.wbg.__wbindgen_memory = function() {
        let e = c.memory;
        return i(e);
    }, n.wbg.__wbindgen_closure_wrapper6378 = function(e, t, r) {
        let o = O(e, t, 79, ce);
        return i(o);
    }, n.wbg.__wbindgen_closure_wrapper6380 = function(e, t, r) {
        let o = z(e, t, 79, se);
        return i(o);
    }, n.wbg.__wbindgen_closure_wrapper6382 = function(e, t, r) {
        let o = z(e, t, 79, se);
        return i(o);
    }, n.wbg.__wbindgen_closure_wrapper6384 = function(e, t, r) {
        let o = O(e, t, 77, Ke);
        return i(o);
    }, n.wbg.__wbindgen_closure_wrapper6386 = function(e, t, r) {
        let o = O(e, t, 79, ce);
        return i(o);
    }, n.wbg.__wbindgen_closure_wrapper6388 = function(e, t, r) {
        let o = z(e, t, 79, xe);
        return i(o);
    }, n.wbg.__wbindgen_closure_wrapper13824 = function(e, t, r) {
        let o = z(e, t, 3694, Oe);
        return i(o);
    }, n.wbg.__wbindgen_closure_wrapper14726 = function(e, t, r) {
        let o = O(e, t, 3790, We);
        return i(o);
    }, n.wbg.__wbindgen_closure_wrapper14783 = function(e, t, r) {
        let o = O(e, t, 3795, Ne);
        return i(o);
    }, n;
}
function fe(n, e) {
    return c = n.exports, we.__wbindgen_wasm_module = e, L = null, W = null, N = null, V = null, F = null, c;
}
function Ge(n) {
    if (c !== void 0) return c;
    let e = ge();
    n instanceof WebAssembly.Module || (n = new WebAssembly.Module(n));
    let t = new WebAssembly.Instance(n, e);
    return fe(t, n);
}
async function we(n) {
    if (c !== void 0) return c;
    let e = ge();
    (typeof n == "string" || typeof Request == "function" && n instanceof Request || typeof URL == "function" && n instanceof URL) && (n = fetch(n));
    let { instance: t, module: r } = await Ee(await n, e);
    return fe(t, r);
}
var D = we;
function* ze() {
    for(;;)yield null;
}
var j = class {
    constructor(e){
        if (typeof e != "string") return this.major = e.major, this.minor = e.minor, this.patch = e.patch, this.build = e.build, this;
        let t = /(\d+)\.(\d+)\.(\d+)(\+.+)?/, [r, o, s, u, f] = e.match(t), [l, m, v, te] = f?.match(t) ?? ze(), me = m && v && te ? {
            major: Number(m),
            minor: Number(v),
            patch: Number(te)
        } : null;
        return this.major = Number(o), this.minor = Number(s), this.patch = Number(u), this.build = me, this;
    }
    to_string() {
        return `${this.major}.${this.minor}.${this.patch}`;
    }
    gt(e) {
        let t = new j(e);
        return this.major > t.major || this.major === t.major && this.minor > t.minor || this.major === t.major && this.minor === t.minor && this.patch > t.patch;
    }
    eq(e) {
        let t = new j(e);
        return this.major === t.major && this.minor == t.minor && this.patch == t.patch;
    }
    ge(e) {
        let t = new j(e);
        return this.eq(t) || this.gt(t);
    }
};
function U(n, e) {
    let t = e.version_chain.shift();
    if (n.version?.gt(t)) return n;
    e.warn && console.warn(`Migrating Legacy -> ${t}`);
    let r = C(n, [
        Me,
        Je,
        Ye,
        Te,
        e.replace_defaults ? Ze : (o)=>o,
        Se,
        De,
        Xe,
        He,
        e.omit_attributes ? Ce : $e,
        (o)=>(o.version = new j("0.0.0"), o)
    ], e);
    return e.verbose && console.log(r), r;
}
function Ze(n, e) {
    for (let t of [
        "group_by",
        "split_by",
        "filter",
        "sort"
    ])n[t] === null && (n[t] = [], e.warn && console.warn(`Deprecated perspective missing attribute "${t}" set to default"`)), "aggregates" in n && n.aggregates === null && (n.aggregates = {}, e.warn && console.warn('Deprecated perspective missing attribute "aggregates" set to default"'));
    return n;
}
function $(n, e) {
    return function(t, r) {
        let o = 0;
        for (let s of e)if (s in t) {
            if (o++ > 0) throw new Error(`Duplicate "${n}" fields`);
            t[n] = t[s], s !== n && (delete t[s], r.warn && console.warn(`Deprecated perspective attribute "${s}" renamed "${n}"`));
        }
        return t;
    };
}
var Me = $("group_by", [
    "group_by",
    "row_pivots",
    "row-pivot",
    "row-pivots",
    "row_pivot"
]), Je = $("split_by", [
    "split_by",
    "column_pivots",
    "column-pivot",
    "column-pivots",
    "column_pivot",
    "col_pivots",
    "col-pivot",
    "col-pivots",
    "col_pivot"
]), Ye = $("filter", [
    "filter",
    "filters"
]);
function Qe(n, e, t, r, o) {
    if (n.test(t)) {
        let s = t.replace(n, e);
        o.warn && console.warn(`Deprecated perspective "expression" attribute value "${t}" updated to "${s}"`);
        for (let u of [
            "group_by",
            "split_by"
        ])if (u in r) for(let f in r[u])r[u][f] === t.replace(/"/g, "") && (r[u][f] = s, o.warn && console.warn(`Deprecated perspective expression in "${u}" attribute "${t}" replaced with "${s}"`));
        for (let u of r.filter || [])u[0] === t.replace(/"/g, "") && (u[0] = s, o.warn && console.warn(`Deprecated perspective expression in "filter" attribute "${t}" replaced with "${s}"`));
        for (let u of r.sort || [])u[0] === t.replace(/"/g, "") && (u[0] = s, o.warn && console.warn(`Deprecated perspective expression in "sort" attribute "${t}" replaced with "${s}"`));
        return s;
    } else return t;
}
function Xe(n) {
    return n.title === void 0 && (n.title = null), n;
}
function Te(n, e) {
    if (n["computed-columns"]) {
        if ("expressions" in n) throw new Error('Duplicate "expressions" and "computed-columns');
        n.expressions = n["computed-columns"], delete n["computed-columns"], e.warn && console.warn('Deprecated perspective attribute "computed-columns" renamed "expressions"');
        let t = [
            [
                /^year_bucket\("(.+?)"\)/,
                `bucket("$1", 'y')`
            ],
            [
                /^month_bucket\("(.+?)"\)/,
                `bucket("$1", 'M')`
            ],
            [
                /^day_bucket\("(.+?)"\)/,
                `bucket("$1", 'd')`
            ],
            [
                /^hour_bucket\("(.+?)"\)/,
                `bucket("$1", 'h')`
            ],
            [
                /^minute_bucket\("(.+?)"\)/,
                `bucket("$1", 'm')`
            ],
            [
                /^second_bucket\("(.+?)"\)/,
                `bucket("$1", 's')`
            ]
        ];
        for(let r in n.expressions){
            let o = n.expressions[r];
            for (let [s, u] of t)o = Qe(s, u, o, n, e);
            n.expressions[r] = o;
        }
    }
    return n;
}
function Se(n, e) {
    let t = {
        datagrid: "Datagrid",
        Datagrid: "Datagrid",
        d3_y_area: "Y Area",
        "Y Area": "Y Area",
        d3_y_line: "Y Line",
        "Y Line": "Y Line",
        d3_xy_line: "X/Y Line",
        "X/Y Line": "X/Y Line",
        d3_y_scatter: "Y Scatter",
        "Y Scatter": "Y Scatter",
        d3_xy_scatter: "X/Y Scatter",
        "X/Y Scatter": "X/Y Scatter",
        d3_x_bar: "X Bar",
        "X Bar": "X Bar",
        d3_y_bar: "Y Bar",
        "Y Bar": "Y Bar",
        d3_heatmap: "Heatmap",
        Heatmap: "Heatmap",
        d3_treemap: "Treemap",
        Treemap: "Treemap",
        d3_sunburst: "Sunburst",
        Sunburst: "Sunburst"
    };
    return "plugin" in n && n.plugin in t && n.plugin !== t[n.plugin] && (n.plugin = t[n.plugin], e.warn && console.warn(`Deprecated perspective "plugin" attribute value "${n.plugin}" updated to "${t[n.plugin]}"`)), n;
}
function De(n, e) {
    return !!n.plugin_config && n.plugin === "Datagrid" ? Ue(n, e) : n;
}
function Ue(n, e) {
    if (!n.plugin_config.columns) {
        e.warn && console.warn('Deprecated perspective attribute "plugin_config" moved to "plugin_config.columns"');
        let t = {};
        for (let r of Object.keys(n.plugin_config)){
            let o = n.plugin_config[r];
            delete n.plugin_config[r], typeof o.color_mode == "string" && (o.color_mode === "foreground" ? o.number_fg_mode = "color" : o.color_mode === "bar" ? o.number_fg_mode = "bar" : o.color_mode === "background" ? o.number_bg_mode = "color" : o.color_mode === "gradient" ? o.number_bg_mode = "gradient" : console.warn(`Unknown color_mode ${o.color_mode}`), delete o.color_mode, e.warn && console.warn('Deprecated perspective attribute "color_mode" renamed "number_bg_mode"')), t[r] = o;
        }
        n.plugin_config.columns = t, e.replace_defaults && (n.plugin_config.editable = !1, n.plugin_config.scroll_lock = !0);
    }
    for (let t of Object.keys(n.plugin_config.columns)){
        let r = n.plugin_config.columns[t];
        typeof r.number_color_mode == "string" && (r.number_color_mode === "foreground" ? r.number_fg_mode = "color" : r.number_color_mode === "bar" ? r.number_fg_mode = "bar" : r.number_color_mode === "background" ? r.number_bg_mode = "color" : r.number_color_mode === "gradient" && (r.number_bg_mode = "gradient"), delete r.number_color_mode, e.warn && console.warn('Deprecated perspective attribute "number_color_mode" renamed "number_bg_mode"')), r.gradient !== void 0 && (r.number_bg_mode === "gradient" ? r.bg_gradient = r.gradient : r.number_fg_mode === "bar" && (r.fg_gradient = r.gradient), delete r.gradient, e.warn && console.warn('Deprecated perspective attribute "gradient" renamed "bg_gradient"')), r.pos_color !== void 0 && (r.number_bg_mode !== void 0 ? r.pos_bg_color = r.pos_color : r.number_fg_mode !== void 0 && (r.pos_fg_color = r.pos_color), delete r.pos_color, e.warn && console.warn('Deprecated perspective attribute "pos_color" renamed "pos_bg_color"')), r.neg_color !== void 0 && (r.number_bg_mode !== void 0 ? r.neg_bg_color = r.neg_color : r.number_fg_mode !== void 0 && (r.neg_fg_color = r.neg_color), delete r.neg_color, e.warn && console.warn('Deprecated perspective attribute "neg_color" renamed "neg_bg_color"'));
    }
    return n;
}
function $e(n, e) {
    let t = [
        "editable",
        "selectable",
        "name",
        "table",
        "master",
        "linked"
    ];
    for (let r of t)r in n && (delete n[r], e.warn && console.warn(`Deprecated perspective attribute "${r}" removed`));
    return n;
}
function Ce(n, e) {
    let t = [
        "editable",
        "selectable",
        "name",
        "table",
        "master",
        "linked"
    ];
    for (let r of t)r in n && n[r] === null && (delete n[r], e.warn && console.warn(`Deprecated perspective attribute "${r}" removed`));
    return n;
}
function He(n, e) {
    return "name" in n && ("title" in n && n.title !== void 0 && (n.title = n.name, e.warn && console.warn('"name" conflicts with "title"')), delete n.name, e.warn && console.warn('"name" unified with "title"')), n;
}
function H(n, e) {
    let t = e.version_chain.shift();
    if (n.version?.gt(t)) return n;
    if (e.warn && console.warn(`Migrating 2.6.1 -> ${t}`), n.version = new j(t), n.plugin === "X/Y Scatter" && typeof n.plugin_config?.columns == "object") for(let r in n.plugin_config.columns){
        let s = Object.entries(n.plugin_config.columns[r]).map(([u, f])=>{
            if (u === "symbols" && Array.isArray(f)) {
                e.warn && console.warn(`Replacing depcrecated X/Y Scatter Plot symbol config ${f}`);
                let l = {};
                for(let m in f){
                    let v = f[m];
                    l[v.key] = v.value;
                }
                f = l;
            }
            return [
                u,
                f
            ];
        });
        n.plugin_config.columns[r] = Object.fromEntries(s);
    }
    if (Array.isArray(n.expressions)) {
        let r = {};
        for(let o in n.expressions)if (typeof n.expressions[o] == "string") {
            e.warn && console.warn("Replacing deprecated string expression with object");
            let s = n.expressions[o], [u, f, l] = s.match(/\/\/\s*([^\n]+)\n(.*)/) ?? [
                s,
                null,
                null
            ];
            f && l ? r[f] = l : r[u] = u;
        }
        n.expressions = r;
    }
    return e.verbose && console.log(n), n;
}
function B(n, e) {
    let t = e.version_chain.shift();
    if (n.version?.gt(t)) return n;
    e.warn && console.warn(`Migrating 2.7.1 -> ${t}`), n.version = new j(t), n.columns_config = n.columns_config ?? {};
    let r = !!n.plugin_config?.columns, o = n.plugin === "Datagrid" || n.plugin === "X/Y Scatter";
    if (r && o) {
        e.warn && console.warn("Migrating plugin_config to columns_config!"), n.columns_config = n.columns_config ?? {};
        let s = Object.entries(n.plugin_config.columns);
        for (let [u, f] of s)if (n.columns_config[u] = n.columns_config[u] ?? {}, n.plugin === "X/Y Scatter") n.columns_config[u].symbols = n.plugin_config.columns[u]?.symbols ?? {}, delete n.plugin_config.columns[u];
        else {
            let l = n.plugin_config.columns[u].column_width_override;
            delete n.plugin_config.columns[u].column_width_override;
            for (let [m, v] of Object.entries(f)){
                switch(m){
                    case "format":
                        if (v !== "custom") break;
                    case "timeZone":
                    case "fractionalSecondDigits":
                    case "second":
                    case "minute":
                    case "hour":
                    case "day":
                    case "weekday":
                    case "month":
                    case "year":
                    case "hour12":
                    case "dateStyle":
                    case "timeStyle":
                        n.columns_config[u] = n.columns_config[u] ?? {}, n.columns_config[u].date_format = n.columns_config[u].date_format ?? {}, n.columns_config[u].date_format[m] = v, delete n.plugin_config.columns[u][m];
                        continue;
                    case "fixed":
                        n.columns_config[u] = n.columns_config[u] ?? {}, n.columns_config[u].number_format = n.columns_config[u].number_format ?? {}, n.columns_config[u].number_format.minimumFractionDigits = v, n.columns_config[u].number_format.maximumFractionDigits = v, delete n.plugin_config.columns[u][m];
                        continue;
                    default:
                }
                n.columns_config[u] = n.columns_config[u] ?? {}, n.columns_config[u][m] = v, delete n.plugin_config.columns[u][m];
            }
            l ? n.plugin_config.columns[u] = {
                column_width_override: l
            } : delete n.plugin_config.columns[u];
        }
        n.plugin === "X/Y Scatter" && Object.keys(n.plugin_config?.columns).length === 0 && delete n.plugin_config?.columns;
    }
    return e.verbose && console.log(n), n;
}
var le = {
    name: "@finos/perspective",
    version: "2.10.1",
    description: "Perspective.js",
    repository: {
        type: "git",
        url: "https://github.com/finos/perspective"
    },
    author: "",
    license: "Apache-2.0",
    unpkg: "dist/cdn/perspective.js",
    jsdelivr: "dist/cdn/perspective.js",
    exports: {
        ".": {
            types: "./index.d.ts",
            node: "./dist/cjs/perspective.node.js",
            default: "./dist/esm/perspective.inline.js"
        },
        "./dist/*": "./dist/*",
        "./src/*": "./src/*",
        "./package.json": "./package.json"
    },
    publishConfig: {
        access: "public"
    },
    engines: {
        node: ">=14"
    },
    files: [
        "dist/**/*",
        "src/**/*",
        "index.d.ts"
    ],
    types: "index.d.ts",
    scripts: {
        build: "node build.js",
        docs: "npm-run-all docs:jsdoc docs:deploy",
        "docs:jsdoc": "jsdoc2md src/js/perspective.js -p list --separators --no-gfm > README.md",
        "docs:deploy": `mkdir -p ../../docs/docs/obj && (echo "---
id: perspective
title: perspective API
---

"; cat README.md) > ../../docs/docs/obj/perspective.md`,
        "test:run": "jest --color --ci --rootDir=. --config=../../tools/perspective-test/jest.config.js",
        test: "npm-run-all test:run",
        clean: "rimraf dist"
    },
    dependencies: {
        stoppable: "1.1.0",
        ws: "^6.1.2"
    },
    devDependencies: {
        "@finos/perspective-cpp": "workspace:^",
        "@finos/perspective-esbuild-plugin": "workspace:^",
        cpy: "^9.0.1",
        jsverify: "^0.8.4",
        lodash: "^4.17.4",
        moment: "^2.19.1",
        "superstore-arrow": "^3.0.0"
    }
};
var R = le.version;
function It(n, { warn: e = !0, verbose: t = !1, replace_defaults: r = !1 } = {}) {
    if (typeof n == "object" && !(n instanceof ArrayBuffer)) {
        let o = JSON.parse(JSON.stringify(n)), s = {
            warn: t ? !0 : e,
            verbose: t,
            replace_defaults: r
        };
        return "viewers" in o && "detail" in o ? Re(o, s) : de(o, !1, s);
    } else return n;
}
function Re(n, e) {
    for(let t in n.viewers)n.viewers[t] = de(n.viewers[t], !0, e), "master" in n.viewers[t] || (n.viewers[t].master = !1, e.warn && console.warn('Deprecated perspective missing attribute "master" set to default')), "linked" in n.viewers[t] || (n.viewers[t].linked = !1, e.warn && console.warn('Deprecated perspective missing attribute "linked" set to default'));
    return n;
}
function de(n, e, t) {
    n.version = n.version ? new j(n.version) : new j("0.0.0"), t.omit_attributes = e, t.version_chain = [
        "2.6.1",
        "2.7.1",
        "2.8.0"
    ], t.version_chain.push(R);
    let r = C(n, [
        U,
        H,
        B,
        Pe,
        (o)=>({
                ...o,
                version: o.version.to_string()
            })
    ], t);
    return t.verbose && console.log("Final result -> ", r), r;
}
function Pe(n) {
    if (n.version.gt(R)) throw new Error("Migrated version is newer than package version!");
    return n.version = new j(R), n;
}
function C(n, e, t) {
    for (let r of e)n = r(n, t);
    return n;
}
var et = {};
ne(et, {
    default: ()=>P
});
var P = ve("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");
var pe = Promise.resolve(P);
window.addEventListener("unhandledrejection", (n)=>{
    n.reason?.message === "View method cancelled" && n.preventDefault();
});
async function nt(n) {
    return n instanceof URL || typeof n == "string" ? await WebAssembly.instantiateStreaming(fetch(n)) : await WebAssembly.instantiate(n);
}
async function rt() {
    let n = await pe, t = (await nt(n)).instance.exports, r = t.size(), o = t.offset(), u = new Uint8Array(t.memory.buffer).slice(o, o + r);
    return await D(u), S(), h;
}
var ee = rt();
var E = class extends HTMLElement {
    constructor(){
        super();
        this.__load_wasm();
    }
    async __load_wasm() {
        await ee, this._instance === void 0 && (this._instance = new k(this));
    }
}, _t = k.prototype, ot = Object.getOwnPropertyNames(_t);
for (let n of ot)Object.defineProperty(E.prototype, n, {
    value: async function(...e) {
        return await this.__load_wasm(), await this._instance[n].call(this._instance, ...e);
    }
});
for (let n of [
    "registerPlugin",
    "getExprTKCommands"
])Object.defineProperty(E, n, {
    value: async function(...e) {
        let t = await ee;
        return t[n].call(t, ...e);
    }
});
customElements.define("perspective-viewer", E);
var Xt = {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2k5Dg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _regularTable = require("regular-table");
var _chromaJs = require("chroma-js");
var _chromaJsDefault = parcelHelpers.interopDefault(_chromaJs);
var _indexJs = require("@finos/perspective/src/js/config/index.js");
var Be = Object.defineProperty;
var We = (t, e, r)=>e in t ? Be(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r;
var te = (t, e, r)=>(We(t, typeof e != "symbol" ? e + "" : e, r), r), re = (t, e, r)=>{
    if (!e.has(t)) throw TypeError("Cannot " + r);
};
var P = (t, e, r)=>(re(t, e, "read from private field"), r ? r.call(t) : e.get(t)), oe = (t, e, r)=>{
    if (e.has(t)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(t) : e.set(t, r);
}, se = (t, e, r, s)=>(re(t, e, "write to private field"), s ? s.call(t, r) : e.set(t, r), r);
var I = 'regular-table{padding:0;margin:12px 0 0 12px;font-family:inherit;--rt-hover--border-color:var(--inactive--color,#c5c9d080);}regular-table div[tabindex]{outline:none;}regular-table>div{position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;}regular-table th{text-align:center;}regular-table thead tr:not(.rt-autosize) th{overflow:hidden;max-width:0px;}regular-table thead tr:last-child .rt-float,regular-table tbody .rt-float{text-align:right;}regular-table thead .rt-integer,regular-table tbody .rt-integer{text-align:right;}regular-table tbody th{text-align:left;}regular-table span.rt-tree-container{display:flex;align-items:center;height:100%;}regular-table thead .rt-string,regular-table tbody .rt-string,regular-table thead .rt-date,regular-table tbody .rt-date,regular-table thead .rt-datetime,regular-table tbody .rt-datetime{text-align:left;}regular-table thead tr:last-child th{border-bottom:1px solid#8b868045;}regular-table tbody tr:first-child td,regular-table tbody tr:first-child th{border-top:1px solid transparent!important;}regular-table th{position:relative;}regular-table tr th span.rt-tree-group{margin-left:5px;margin-right:15px;border-left:1px solid#eee;height:100%;}regular-table td,regular-table th{white-space:nowrap;font-size:12px;padding-right:5px;padding-left:5px;padding-top:0px;padding-bottom:0px;height:19px;}regular-table table *{box-sizing:border-box;}regular-table table{position:absolute;color:#666;outline:none;}regular-table span.rt-row-header-icon{color:#aaa;padding-right:4px;font-family:var(--button--font-family);}regular-table span.rt-column-header-icon{font-size:10px;padding-left:3px;display:inline-block;width:10px;font-family:var(--button--font-family);}regular-table span.rt-row-header-icon:hover{color:#1a7da1;text-shadow:0px 0px 3px#1a7da1;}regular-table .rt-selected td{background-color:#eee;}regular-table .rt-cell-clip{overflow:hidden;text-overflow:ellipsis;}regular-table td span.rt-group-name,regular-table th span.rt-group-name{margin-right:-5px;padding-right:5px;padding-left:8px;flex:1;height:100%;}regular-table th span.rt-group-name{text-align:left;}regular-table td th span.rt-group-leaf,regular-table th span.rt-group-leaf{margin-left:16px;height:100%;}regular-table .rt-column-resize{height:100%;width:10px;position:absolute;top:0;right:0;cursor:col-resize;}regular-table a{color:var(--rt-pos-cell--color);}regular-table a:visited{color:var(--active--color);}.psp-header-border:not(.psp-is-top):not(.psp-header-leaf){box-shadow:1px 0px var(--inactive--border-color,#8b868045);}.psp-header-group{box-shadow:0px 10px 0 -9px var(--inactive--border-color,#8b868045);}.psp-is-top{box-shadow:5px 4px 0px -4px var(--inactive--border-color,#8b868045);}.psp-is-top.psp-header-group:not(.psp-header-group-corner){box-shadow:5px 4px 0px -4px var(--inactive--border-color,#8b868045),0px 10px 0 -9px var(--inactive--border-color,#8b868045);}.psp-header-border.psp-header-group:not(.psp-is-top):not(.psp-header-group-corner){box-shadow:1px 0px var(--inactive--border-color,#8b868045),0px 10px 0 -9px var(--inactive--border-color,#8b868045);}perspective-viewer[settings] tr.rt-autosize .psp-header-leaf.psp-header-border:not(.psp-menu-enabled){box-shadow:1px 0px var(--inactive--border-color,#8b868045);}:host-context(perspective-viewer[settings]) tr.rt-autosize .psp-header-leaf.psp-header-border:not(.psp-menu-enabled){box-shadow:1px 0px var(--inactive--border-color,#8b868045);}.psp-header-leaf.psp-header-border{box-shadow:5px -4px 0px -4px var(--inactive--border-color,#8b868045);}tr:only-child th{box-shadow:none!important;}regular-table tbody tr:hover th.psp-tree-leaf:not(.psp-row-selected):not(.psp-row-subselected),regular-table tbody tr:hover th.psp-tree-label:not(.psp-row-selected):not(.psp-row-subselected),regular-table tbody tr:hover td:not(.psp-row-selected):not(.psp-row-subselected),regular-table tbody tr:hover:after{border-color:var(--rt-hover--border-color,#c5c9d080)!important;background-color:transparent;box-shadow:0px 1px 0px var(--rt-hover--border-color,#c5c9d080),0px 3px 0px rgba(0,0,0,0.05),0px 5px 0px rgba(0,0,0,0.01);}regular-table tbody tr:hover th.psp-tree-leaf.psp-menu-open:not(.psp-row-selected):not(.psp-row-subselected),regular-table tbody tr:hover th.psp-tree-label.psp-menu-open:not(.psp-row-selected):not(.psp-row-subselected),regular-table tbody tr:hover td.psp-menu-open:not(.psp-row-selected):not(.psp-row-subselected),regular-table tbody tr.psp-menu-open:hover:after{box-shadow:inset -2px 0px 0px var(--icon--color),inset 2px 0px 0px var(--icon--color),0px 1px 0px var(--rt-hover--border-color,#c5c9d080),0px 3px 0px rgba(0,0,0,0.05),0px 5px 0px rgba(0,0,0,0.01);}regular-table tbody tr:last-child:hover td.psp-menu-open:not(.psp-row-selected):not(.psp-row-subselected){box-shadow:inset -2px 0px 0px var(--icon--color),inset 2px 0px 0px var(--icon--color),inset 0px -2px 0px var(--icon--color),0px 1px 0px var(--rt-hover--border-color,#c5c9d080),0px 3px 0px rgba(0,0,0,0.05),0px 5px 0px rgba(0,0,0,0.01);}regular-table tbody tr:hover+tr th.psp-tree-leaf:not(.psp-row-selected):not(.psp-row-subselected),regular-table tbody tr:hover+tr th.psp-tree-label:not(.psp-row-selected):not(.psp-row-subselected),regular-table tbody tr:hover+tr td:not(.psp-row-selected):not(.psp-row-subselected){border-top-color:transparent;}regular-table tbody tr th:first-child:not(:empty),regular-table tbody tr th:first-child:empty+th:not(:empty),regular-table tbody tr th:first-child:empty~th:empty+th:not(:empty),regular-table tbody tr td:first-child{border-left-width:1px;border-left-color:transparent;}regular-table tbody tr th:last-child,regular-table tbody tr td:last-child{border-right-width:0px;border-right-color:transparent;}regular-table tbody tr:hover{color:inherit;}regular-table tbody tr:hover th:first-child:not(:empty),regular-table tbody tr:hover th:first-child:empty+th:not(:empty),regular-table tbody tr:hover th:first-child:empty~th:empty+th:not(:empty),regular-table tbody tr:hover td:first-child{border-left-color:var(--rt-hover--border-color,#c5c9d080)!important;}regular-table tbody tr:hover th:last-child,regular-table tbody tr:hover td:last-child{border-right-color:var(--rt-hover--border-color,#c5c9d080)!important;}perspective-viewer-datagrid:not(.sub-cell-scroll-disabled) regular-table table tbody td,perspective-viewer-datagrid:not(.sub-cell-scroll-disabled) regular-table table thead th:not(.rt-group-corner),:host(:not(.sub-cell-scroll-disabled)) regular-table table tbody td,:host(:not(.sub-cell-scroll-disabled)) regular-table table thead th:not(.rt-group-corner){transform:translate(var(--regular-table--transform-x,0px));}perspective-viewer-datagrid:not(.sub-cell-scroll-disabled) regular-table table tbody,:host(:not(.sub-cell-scroll-disabled)) regular-table table tbody{transform:translate(0,var(--regular-table--transform-y,0px));}perspective-viewer-datagrid:not(.sub-cell-scroll-disabled) regular-table table tbody tr:first-child td,perspective-viewer-datagrid:not(.sub-cell-scroll-disabled) regular-table table tbody tr:first-child th,:host(:not(.sub-cell-scroll-disabled)) regular-table table tbody tr:first-child td,:host(:not(.sub-cell-scroll-disabled)) regular-table table tbody tr:first-child th{clip-path:polygon(0 var(--regular-table--clip-y,0),0 200%,200% 200%,200% var(--regular-table--clip-y,0));}perspective-viewer-datagrid:not(.sub-cell-scroll-disabled) regular-table table tbody tr td:first-of-type,:host(:not(.sub-cell-scroll-disabled)) regular-table table tbody tr td:first-of-type{clip-path:polygon(var(--regular-table--clip-x,0)0,var(--regular-table--clip-x,0)200%,200% 200%,200% 0);}perspective-viewer-datagrid:not(.sub-cell-scroll-disabled) regular-table table tbody tr:first-child td:first-of-type,:host(:not(.sub-cell-scroll-disabled)) regular-table table tbody tr:first-child td:first-of-type{clip-path:polygon(var(--regular-table--clip-x,0)var(--regular-table--clip-y,0),var(--regular-table--clip-x,0)200%,200% 200%,200% var(--regular-table--clip-y,0));}perspective-viewer-datagrid:not(.sub-cell-scroll-disabled) regular-table table thead tr:last-child:after,:host(:not(.sub-cell-scroll-disabled)) regular-table table thead tr:last-child:after{transform:translate(var(--regular-table--transform-x,0px));}perspective-viewer-datagrid:not(.sub-cell-scroll-disabled) regular-table table tbody tr:not(:first-child):after,:host(:not(.sub-cell-scroll-disabled)) regular-table table tbody tr:not(:first-child):after{transform:translate(var(--regular-table--transform-x,0px));}perspective-viewer-datagrid:not(.sub-cell-scroll-disabled) regular-table table tbody tr:hover:first-child:after,:host(:not(.sub-cell-scroll-disabled)) regular-table table tbody tr:hover:first-child:after{clip-path:polygon(0 var(--regular-table--clip-y,0),0 200%,200% 200%,200% var(--regular-table--clip-y,0));}perspective-viewer-datagrid:not(.sub-cell-scroll-disabled) regular-table table thead tr th.rt-group-corner+th:not(.rt-group-corner),:host(:not(.sub-cell-scroll-disabled)) regular-table table thead tr th.rt-group-corner+th:not(.rt-group-corner){clip-path:polygon(var(--regular-table--clip-x,0)0,var(--regular-table--clip-x,0)200%,200% 200%,200% 0);}regular-table{outline:none;}regular-table::-webkit-scrollbar,regular-table::-webkit-scrollbar-corner{background-color:transparent;height:12px;width:12px;}regular-table::-webkit-scrollbar-thumb{background-clip:content-box;background:var(--icon--color);border:5.5px solid var(--plugin--background);max-height:50%;max-width:50%;min-width:10%;min-height:10%;}perspective-viewer:not([settings]) regular-table table tr.rt-autosize+tr th{height:0px;}perspective-viewer:not([settings]) regular-table table tr.rt-autosize+tr th span{display:none;}:host-context(perspective-viewer:not([settings])) regular-table table tr.rt-autosize+tr th{height:0px;}:host-context(perspective-viewer:not([settings])) regular-table table tr.rt-autosize+tr th span{display:none;}perspective-viewer[settings] .psp-menu-enabled{padding:0 6px;font-size:8px;border-radius:3px 3px 0 0;}perspective-viewer[settings] .psp-menu-enabled:hover,perspective-viewer[settings] tr:not(.rt-autosize) th.psp-menu-open{color:var(--plugin--background);background-color:var(--icon--color);border-bottom-color:var(--icon--color);cursor:pointer;}perspective-viewer[settings] tr:not(.rt-autosize) th.psp-menu-open:before{background-repeat:no-repeat;background-color:var(--icon--color);content:"";display:inline-block;-webkit-mask-size:cover;mask-size:cover;height:8px;width:10px;-webkit-mask-image:var(--column-settings-icon--mask-image);mask-image:var(--column-settings-icon--mask-image);margin-right:4px;background-color:var(--plugin--background);}perspective-viewer[settings] td.psp-menu-open{box-shadow:inset -2px 0px 0px var(--icon--color),inset 2px 0px 0px var(--icon--color);}perspective-viewer[settings] tr:first-child td.psp-menu-open{border-top-color:var(--icon--color)!important;}perspective-viewer[settings] tr:last-child td.psp-menu-open{box-shadow:inset -2px 0px 0px var(--icon--color),inset 2px 0px 0px var(--icon--color),inset 0px -2px 0px var(--icon--color);}:host-context(perspective-viewer[settings]) .psp-menu-enabled{padding:0 6px;font-size:8px;border-radius:3px 3px 0 0;}:host-context(perspective-viewer[settings]) .psp-menu-enabled:hover,:host-context(perspective-viewer[settings]) tr:not(.rt-autosize) th.psp-menu-open{color:var(--plugin--background);background-color:var(--icon--color);border-bottom-color:var(--icon--color);cursor:pointer;}:host-context(perspective-viewer[settings]) tr:not(.rt-autosize) th.psp-menu-open:before{background-repeat:no-repeat;background-color:var(--icon--color);content:"";display:inline-block;-webkit-mask-size:cover;mask-size:cover;height:8px;width:10px;-webkit-mask-image:var(--column-settings-icon--mask-image);mask-image:var(--column-settings-icon--mask-image);margin-right:4px;background-color:var(--plugin--background);}:host-context(perspective-viewer[settings]) td.psp-menu-open{box-shadow:inset -2px 0px 0px var(--icon--color),inset 2px 0px 0px var(--icon--color);}:host-context(perspective-viewer[settings]) tr:first-child td.psp-menu-open{border-top-color:var(--icon--color)!important;}:host-context(perspective-viewer[settings]) tr:last-child td.psp-menu-open{box-shadow:inset -2px 0px 0px var(--icon--color),inset 2px 0px 0px var(--icon--color),inset 0px -2px 0px var(--icon--color);}perspective-viewer regular-table table thead tr:last-child th{border-bottom-width:1px;border-bottom-color:var(--inactive--border-color,#8b868045);}:host-context(perspective-viewer) regular-table table thead tr:last-child th{border-bottom-width:1px;border-bottom-color:var(--inactive--border-color,#8b868045);}.psp-sort-enabled:hover{cursor:pointer;}.psp-row-selected,:hover .psp-row-selected,:hover th.psp-tree-leaf.psp-row-selected,:hover th.psp-tree-label.psp-row-selected{color:white!important;background-color:#ea7319!important;border-color:#ea7319!important;}.psp-row-selected.psp-tree-label:not(:hover):before{color:white;}.psp-row-subselected,:hover .psp-row-subselected,:hover th.psp-tree-leaf.psp-row-subselected,:hover th.psp-tree-label.psp-row-subselected{background:rgba(234,115,25,0.2)!important;}.psp-error{color:red;}td:focus{outline:#666;outline-style:dotted;outline-width:1px;}perspective-viewer.dragging regular-table{pointer-events:none;}:host-context(perspective-viewer.dragging) regular-table{pointer-events:none;}.psp-header-border:last-child{border-right-width:0px;}.psp-header-sort-desc:after{background-repeat:no-repeat;background-color:var(--icon--color);content:"";display:inline-block;-webkit-mask-size:cover;mask-size:cover;width:14px;height:12px;-webkit-mask-image:var(--sort-desc-icon--mask-image);mask-image:var(--sort-desc-icon--mask-image);}.psp-header-sort-asc:after{background-repeat:no-repeat;background-color:var(--icon--color);content:"";display:inline-block;-webkit-mask-size:cover;mask-size:cover;width:14px;height:12px;-webkit-mask-image:var(--sort-asc-icon--mask-image);mask-image:var(--sort-asc-icon--mask-image);}.psp-header-sort-col-desc:after{background-repeat:no-repeat;background-color:var(--icon--color);content:"";display:inline-block;-webkit-mask-size:cover;mask-size:cover;width:14px;height:12px;-webkit-mask-image:var(--sort-col-desc-icon--mask-image);mask-image:var(--sort-col-desc-icon--mask-image);}.psp-header-sort-col-asc:after{background-repeat:no-repeat;background-color:var(--icon--color);content:"";display:inline-block;-webkit-mask-size:cover;mask-size:cover;width:14px;height:12px;-webkit-mask-image:var(--sort-col-asc-icon--mask-image);mask-image:var(--sort-col-asc-icon--mask-image);}tbody th:last-of-type{border-right:1px solid var(--inactive--border-color,#8b868045);overflow:hidden;text-overflow:ellipsis;}tbody th:empty{background-image:linear-gradient(to right,transparent 9px,var(--inactive--border-color,#eee)10px,transparent 11px);background-repeat:no-repeat;min-width:20px;max-width:20px;pointer-events:none;}.psp-tree-label{max-width:0px;min-width:0px;}.psp-tree-label:before{color:var(--icon--color);font-family:var(--button--font-family,inherit);padding-right:11px;}.psp-tree-label-expand:before{content:var(--tree-label-expand--content,"+");}.psp-tree-label-collapse:before{content:var(--tree-label-collapse--content,"-");}.psp-tree-label-expand,.psp-tree-label-collapse{cursor:pointer;}.psp-tree-label:hover:before{color:var(--active--color);text-shadow:0px 0px 5px var(--active--color);}.psp-tree-leaf{padding-left:24px;}.psp-align-right{text-align:right;}.psp-align-left{text-align:left;}.psp-positive:not(:focus){color:var(--rt-pos-cell--color);}.psp-negative:not(:focus){color:var(--rt-neg-cell--color);}regular-table table tbody td{min-width:52px!important;}.psp-is-width-override .rt-column-resize,.rt-column-resize:hover{border:1px dashed#999;border-bottom-width:0px;border-left-width:0px;}.boolean-editable{cursor:pointer;}regular-table table{user-select:none;color:inherit;border-collapse:separate;}regular-table table th{font-weight:400;}regular-table table td,regular-table table th{border-color:var(--inactive--border-color,#8b868045);height:23px;}regular-table table .psp-header-group{text-overflow:ellipsis;}regular-table table th.psp-header-leaf{border-bottom-width:0px;}regular-table table th.psp-header-leaf span{height:23px;min-height:23px;}regular-table table td,regular-table table th.psp-tree-label,regular-table table th.psp-tree-label,regular-table table th.psp-tree-leaf,regular-table table tbody tr:first-child th{border-style:solid;border-width:0px;border-top-width:1px;}regular-table table tbody th:empty{background-position:0px -10px;}regular-table #psp-column-edit-buttons th:not(.rt-group-corner) span:not(.rt-column-resize):before{content:var(--datagrid-column-edit-button--content,"Edit");}perspective-viewer:not([settings]) regular-table #psp-column-edit-buttons:after{content:none;}:host-context(perspective-viewer:not([settings])) regular-table #psp-column-edit-buttons:after{content:none;}regular-table table thead tr:last-child:after{width:10000px;box-sizing:border-box;display:block;height:23px;content:" ";border-bottom:1px solid var(--inactive--border-color);}regular-table table tbody tr:after{width:10000px;box-sizing:border-box;display:block;height:23px;content:" ";border-top:1px solid transparent;}regular-table table tbody tr:not(:first-child):after{border-top:1px solid var(--inactive--border-color);}regular-table table tbody tr:hover:not(:first-child):after{border-top:1px solid var(--rt-hover--border-color);}regular-table table tbody tr:hover+tr:after{border-top:1px solid var(--rt-hover--border-color);}@keyframes pulse_pos{0%{background-color:var(--pulse--background-color-start,rgba(0,128,255,0.5));}100%{background-color:var(--pulse--background-color-end,rgba(0,128,255,0));}}@keyframes pulse_pos2{0%{background-color:var(--pulse--background-color-start,rgba(0,128,255,0.5));}100%{background-color:var(--pulse--background-color-end,rgba(0,128,255,0));}}@keyframes pulse_neg{0%{background-color:var(--pulse--background-color-start,rgba(255,25,0,0.5));}100%{background-color:var(--pulse--background-color-end,rgba(255,25,0,0));}}@keyframes pulse_neg2{0%{background-color:var(--pulse--background-color-start,rgba(255,25,0,0.5));}100%{background-color:var(--pulse--background-color-end,rgba(255,25,0,0));}}';
function Ye(t) {
    return t.x >= 0 ? this._column_types[t.x] : this._row_header_types[t.row_header_x - 1];
}
function G(t, e, r) {
    let s = Array.from(t.children[0].children[0].children), o = s.length, l = e.hasAttribute("settings");
    if (o <= 1 ? s[0]?.removeAttribute("id") : s.forEach((i, a)=>{
        let n = l ? 1 : 0, c = a === o - (n + 1) ? "psp-column-titles" : a === o - n ? "psp-column-edit-buttons" : null;
        c ? i.setAttribute("id", c) : i.removeAttribute("id");
    }), e.classList.toggle("psp-menu-open", !!r), l && o >= 2) {
        let i = Array.from(s[o - 2].children), a = Array.from(s[o - 1].children);
        if (i && a) {
            s.slice(0, o - 2).forEach((n)=>{
                Array.from(n.children).forEach((c)=>{
                    c.classList.toggle("psp-menu-open", !1);
                });
            });
            for(let n = 0; n < i.length; n++){
                let c = i[n], d = a[n], p = c.textContent === r;
                if (c.classList.toggle("psp-menu-open", p), d.classList.toggle("psp-menu-open", p), this._config.columns.length > 1) for (let u of t.querySelectorAll("td")){
                    let h = t.getMeta(u), g = h.column_header[h.column_header.length - 2] === r;
                    u.classList.toggle("psp-menu-open", g);
                }
            }
        }
    }
}
function ie(t, e) {
    let r = Array.from(t.children[0].children[0].children);
    if (r.length > 0) {
        G.call(this, t, e, this._column_settings_selected_column);
        let [s] = r.splice(this._config.split_by.length, 1);
        le.call(this, t, s, !1);
        let [o] = r.splice(this._config.split_by.length, 1);
        o && le.call(this, t, o, !0);
    }
}
function le(t, e, r) {
    let s = t._view_cache.config.row_pivots.length - 1;
    for (let o of e?.children){
        let l = t.getMeta(o), i = l.column_header?.[this._config.split_by.length], a = this._config.sort.find((_)=>_[0] === i), n = l.row_header_x === s, c = typeof l.x > "u";
        n = n || (l.x + 1) % this._config.columns.length === 0, o.classList.toggle("psp-header-border", n), o.classList.toggle("psp-header-group", !1), o.classList.toggle("psp-header-leaf", !0), o.classList.toggle("psp-is-top", !1), o.classList.toggle("psp-header-corner", c), o.classList.toggle("psp-header-sort-asc", !r && !!a && a[1] === "asc"), o.classList.toggle("psp-header-sort-desc", !r && !!a && a[1] === "desc"), o.classList.toggle("psp-header-sort-col-asc", !r && !!a && a[1] === "col asc"), o.classList.toggle("psp-header-sort-col-desc", !r && !!a && a[1] === "col desc");
        let d = Ye.call(this, l), p = d === "integer" || d === "float", u = d === "string", h = d === "date", g = d === "datetime";
        o.classList.toggle("psp-align-right", p), o.classList.toggle("psp-align-left", !p), o.classList.toggle("psp-menu-enabled", (u || p || h || g) && !c && l.column_header_y == this._config.split_by.length + 1), o.classList.toggle("psp-sort-enabled", (u || p || h || g) && !c && l.column_header_y === this._config.split_by.length), o.classList.toggle("psp-is-width-override", t._column_sizes?.override[l.size_key] !== void 0);
    }
}
function ae(t) {
    let e = t._view_cache.config.row_pivots.length - 1, r = Array.from(t.children[0].children[0].children), s = [], o = new Set, l = t.children[0];
    for(let i = 0; i < r.length; i++){
        let a = l.rows[i], n = new Set;
        for(let c = 0; c < a.cells.length; c++){
            let d = a.cells[c];
            d.style.backgroundColor = "";
            let p = t.getMeta(d), u = p.row_header_x === e || p.x >= 0;
            d.classList.toggle("psp-align-right", !1), d.classList.toggle("psp-align-left", !1), d.classList.toggle("psp-header-group", !0), d.classList.toggle("psp-header-leaf", !1), d.classList.toggle("psp-header-border", u), d.classList.toggle("psp-header-group-corner", typeof p.x > "u"), d.classList.toggle("psp-color-mode-bar", !1), d.classList.toggle("psp-header-sort-asc", !1), d.classList.toggle("psp-header-sort-desc", !1), d.classList.toggle("psp-header-sort-col-asc", !1), d.classList.toggle("psp-header-sort-col-desc", !1), d.classList.toggle("psp-sort-enabled", !1);
            let h = a.cells[c], g = c, _, f;
            for(; s[i] && s[i][g]; ++g);
            for(n.add(g), _ = g; _ < g + h.colSpan; ++_)for(f = i; f < i + h.rowSpan; ++f)s[f] || (s[f] = []), s[f][_] = !0;
            h.classList.toggle("psp-is-top", i === 0 || !o.has(_));
        }
        o = n;
    }
}
var k = Symbol("Plugin Symbol");
function ne(t, e, [, , , , , r, s], [, , , , , o, l], i) {
    let a = this._ids?.[t.dy]?.join("|"), n = (i ? t.column_header.slice(0, -1) : t.column_header).join("|");
    if (this.last_reverse_columns?.has(n) && this.last_reverse_ids?.has(a)) {
        let c = this.last_reverse_ids?.get(a), d = this.last_reverse_columns.get(n);
        this._is_old_viewport ? this.last_meta?.[d]?.[c] > t.user ? (e.style.setProperty("--pulse--background-color-start", o), e.style.setProperty("--pulse--background-color-end", l), e.style.animationName === "pulse_neg" ? e.style.animation = "pulse_neg2 0.5s linear" : e.style.animation = "pulse_neg 0.5s linear") : this.last_meta?.[d]?.[c] < t.user ? (e.style.setProperty("--pulse--background-color-start", r), e.style.setProperty("--pulse--background-color-end", s), e.style.animationName === "pulse_pos" ? e.style.animation = "pulse_pos2 0.5s linear" : e.style.animation = "pulse_pos 0.5s linear") : c !== t.dy && (e.style.animation = "") : e.style.animation = "";
    } else e.style.animation = "";
}
function J(t, e) {
    return (0, _chromaJsDefault.default).mix(t, `rgb(${e[0]},${e[1]},${e[2]})`, .5).hex();
}
function S([t, e, r, s], o = [
    255,
    255,
    255
]) {
    function l(i, a) {
        return ((1 - s) * (o[i] / 255) + s * (a / 255)) * 255;
    }
    return [
        l(0, t),
        l(1, e),
        l(2, r)
    ];
}
function E([t, e, r]) {
    return Math.sqrt(t * t * .299 + e * e * .587 + r * r * .114) > 130 ? "#161616" : "#ffffff";
}
function Ue(t) {
    let [e, r, s] = t.rgb(), [o, l, i] = t.set("hsl.h", (t.get("hsl.h") - 15) % 360).rgb(), [a, n, c] = t.set("hsl.h", (t.get("hsl.h") + 15) % 360).rgb();
    return `linear-gradient(to right top,rgb(${o},${l},${i}),rgb(${e},${r},${s}) 50%,rgb(${a},${n},${c}))`;
}
function w(t) {
    let e = (0, _chromaJsDefault.default)(t), r = Ue(e), s = e.rgb();
    return [
        t,
        ...s,
        r,
        `rgba(${s[0]},${s[1]},${s[2]},1)`,
        `rgba(${s[0]},${s[1]},${s[2]},0)`
    ];
}
function de(t, e, r, s) {
    let o = r.user > 0, l = r.user < 0, i;
    t?.pos_bg_color !== void 0 ? i = t.pos_bg_color : i = this._pos_bg_color;
    let a;
    t?.neg_bg_color !== void 0 ? a = t.neg_bg_color : a = this._neg_bg_color;
    let n = o ? i : l ? a : [
        "",
        ...this._plugin_background,
        ""
    ];
    {
        let [g, _, f, m, v] = n;
        if (e.style.position = "", t?.number_bg_mode === "color") e.style.animation = "", e.style.backgroundColor = g;
        else if (t?.number_bg_mode === "gradient") {
            let b = Math.max(0, Math.min(1, Math.abs(r.user / t.bg_gradient))), x = this._plugin_background, y = E(S([
                _,
                f,
                m,
                b
            ], x));
            e.style.animation = "", e.style.color = y, e.style.backgroundColor = `rgba(${_},${f},${m},${b})`;
        } else t?.number_bg_mode === "pulse" ? (ne.call(this, r, e, i, a, s), e.style.backgroundColor = "") : (t?.number_bg_mode === "disabled" || t?.number_bg_mode, e.style.animation = "", e.style.backgroundColor = "");
    }
    let [c, d, p, u, h] = (()=>t?.pos_fg_color !== void 0 ? o ? t.pos_fg_color : l ? t.neg_fg_color : [
            "",
            ...this._plugin_background,
            ""
        ] : o ? this._pos_fg_color : l ? this._neg_fg_color : [
            "",
            ...this._plugin_background,
            ""
        ])();
    if (t?.number_fg_mode === "disabled") {
        if (t?.number_bg_mode === "color") {
            let g = this._plugin_background, _ = E(S([
                n[1],
                n[2],
                n[3],
                1
            ], g));
            e.style.color = _;
        } else t?.number_bg_mode === "gradient" || (e.style.color = "");
    } else t?.number_fg_mode === "bar" ? (e.style.color = "", e.style.position = "relative", h !== "" && e.children.length > 0 && e.children[0].nodeType === Node.ELEMENT_NODE && (e.children[0].style.background = h)) : (t?.number_fg_mode === "color" || !t?.number_fg_mode) && (e.style.color = c);
}
function ge(t, e, r) {
    let s = r.column_header?.[this._config.split_by.length], [o, l, i, a, n] = (()=>t?.color !== void 0 ? t.color : this._color)();
    if (t?.string_color_mode === "foreground" && r.user !== null) e.style.color = o, e.style.backgroundColor = "", t?.format === "link" && (e.children[0].style.color = o);
    else if (t?.string_color_mode === "background" && r.user !== null) {
        let c = this._plugin_background, d = E(S([
            l,
            i,
            a,
            1
        ], c));
        e.style.color = d, e.style.backgroundColor = o;
    } else if (t?.string_color_mode === "series" && r.user !== null) {
        this._series_color_map.has(s) || (this._series_color_map.set(s, new Map), this._series_color_seed.set(s, 0));
        let c = this._series_color_map.get(s);
        if (!c.has(r.user)) {
            let y = this._series_color_seed.get(s);
            c.set(r.user, y), this._series_color_seed.set(s, y + 1);
        }
        let d = c.get(r.user), [p, u, h] = (0, _chromaJsDefault.default)(o).hsl();
        p = p + d * 150 % 360;
        let g = (0, _chromaJsDefault.default)(p, u, h, "hsl"), [_, f, m] = g.rgb(), v = g.hex(), b = this._plugin_background, x = E(S([
            _,
            f,
            m,
            1
        ], b));
        e.style.color = x, e.style.backgroundColor = v;
    } else e.style.backgroundColor = "", e.style.color = "";
}
function he(t, e, r) {
    let s = r.column_header?.[this._config.split_by.length], [o, l, i, a, n] = (()=>t?.color !== void 0 ? t.color : this._color)();
    if (t?.datetime_color_mode === "foreground" && r.user !== null) e.style.color = o, e.style.backgroundColor = "";
    else if (t?.datetime_color_mode === "background" && r.user !== null) {
        let c = this._plugin_background, d = E(S([
            l,
            i,
            a,
            1
        ], c));
        e.style.color = d, e.style.backgroundColor = o;
    } else e.style.backgroundColor = "", e.style.color = "";
}
function _e(t, e, r) {
    let [s] = r.user === !0 ? this._pos_fg_color : r.user === !1 ? this._neg_fg_color : [
        "",
        0,
        0,
        0,
        ""
    ];
    e.style.backgroundColor = "", e.style.color = s;
}
function ue(t, e, r) {
    let s = ((r.value, r.value), r.value?.toString()?.trim().length > 0), o = r.row_header_x >= this._config.group_by.length, l = t.getMeta({
        dx: 0,
        dy: r.y - r.y0 + 1
    }), i = l && l.row_header && typeof l.row_header[r.row_header_x + 1] < "u";
    e.classList.toggle("psp-tree-label", s && !o), e.classList.toggle("psp-tree-label-expand", s && !o && !i), e.classList.toggle("psp-tree-label-collapse", s && !o && i), e.classList.toggle("psp-tree-leaf", s && o);
}
function Ge(t) {
    return t.x >= 0 ? this._column_types[t.x] : this._row_header_types[t.row_header_x - 1];
}
function be(t, e) {
    let r = t[k] || {}, s = e.hasAttribute("settings");
    for (let o of t.children[0].children[1].children)for (let l of o.children){
        let i = t.getMeta(l), a = i.column_header?.[this._config.split_by.length], n = Ge.call(this, i), c = r[a], d = n === "integer" || n === "float";
        d ? de.call(this, c, l, i, s) : n === "boolean" ? _e.call(this, c, l, i) : n === "string" ? ge.call(this, c, l, i) : n === "date" || n === "datetime" ? he.call(this, c, l, i) : (l.style.backgroundColor = "", l.style.color = ""), l.classList.toggle("psp-bool-type", n === "boolean" && i.user !== null);
        let p = l.tagName === "TH";
        p && ue.call(this, t, l, i), l.classList.toggle("psp-align-right", !p && d), l.classList.toggle("psp-align-left", p || !d), l.classList.toggle("psp-color-mode-bar", c?.number_fg_mode === "bar" && d);
    }
}
async function fe(t, e, r, s) {
    let l = t.getMeta(s).column_header[this._config.split_by.length], a = (r.shiftKey ? Je : Ve).call(this, l);
    this._preserve_focus_state = !0, await e.restore({
        sort: a
    });
}
function Je(t) {
    let e = [], r = !1;
    for (let s of this._config.sort){
        let [o, l] = s;
        if (o === t) {
            r = !0;
            let i = me.call(this, t, l);
            i && e.push(i);
        } else e.push(s);
    }
    return r || e.push([
        t,
        "desc"
    ]), e;
}
function Ve(t) {
    for (let [e, r] of this._config.sort)if (e === t) {
        let s = me.call(this, t, r);
        return s ? [
            s
        ] : [];
    }
    return [
        [
            t,
            "desc"
        ]
    ];
}
function me(t, e) {
    let s = this._config.split_by.length > 0 ? Ze : Ke, o = e ? s[e] : "desc";
    if (o) return [
        t,
        o
    ];
}
var Ke = {
    desc: "asc",
    asc: void 0
}, Ze = {
    desc: "asc",
    asc: "col desc",
    "col desc": "col asc",
    "col asc": void 0
};
async function xe(t, e) {
    let r = t.getMeta(e.target), s = e.target.classList.contains("psp-tree-label-collapse");
    e.shiftKey && s ? this._view.set_depth(r.row_header.filter((o)=>o !== void 0).length - 2) : e.shiftKey ? this._view.set_depth(r.row_header.filter((o)=>o !== void 0).length - 1) : s ? this._view.collapse(r.y) : this._view.expand(r.y), this._num_rows = await this._view.num_rows(), this._num_columns = await this._view.num_columns(), t.draw();
}
async function ye(t, e, r) {
    if (r.which !== 1) return;
    let s = r.target;
    if (s.tagName !== "A") {
        for(; s.tagName !== "TD" && s.tagName !== "TH";)if (s = s.parentElement, !t.contains(s)) return;
        if (s.classList.contains("psp-tree-label")) {
            xe.call(this, t, r), r.stopImmediatePropagation();
            return;
        }
        if (s.classList.contains("psp-menu-enabled")) {
            let l = t.getMeta(s).column_header?.[this._config.split_by.length];
            await e.toggleColumnSettings(l), r.preventDefault(), r.stopImmediatePropagation();
        } else s.classList.contains("psp-sort-enabled") && (fe.call(this, t, e, r, s), r.stopImmediatePropagation());
    }
}
function ve(t, e) {
    if (e.which !== 1) return;
    let r = e.target;
    for(; r.tagName !== "TD" && r.tagName !== "TH";)if (r = r.parentElement, !t.contains(r)) return;
    (r.classList.contains("psp-tree-label") && e.offsetX < 26 || r.classList.contains("psp-header-leaf") && !r.classList.contains("psp-header-corner")) && e.stopImmediatePropagation();
}
function we(t, e = !1) {
    let r = this._config.group_by.length === 0 && this._config.split_by.length === 0, s = t.hasAttribute("selectable"), o = e || !!t.children[0]._is_edit_mode;
    return r && !s && o;
}
function ke(t, e, r) {
    let s = t[k] || {}, o = we.call(this, e);
    r.classList.toggle("edit-mode-allowed", we.call(this, e, !0));
    for (let l of t.querySelectorAll("td")){
        let i = t.getMeta(l), a = this.get_psp_type(i);
        if (o && this._is_editable[i.x]) {
            let n = i.column_header[this._config.split_by.length];
            a === "string" && s[n]?.format === "link" ? (l.toggleAttribute("contenteditable", !1), l.classList.toggle("boolean-editable", !1)) : a === "boolean" ? (l.toggleAttribute("contenteditable", !1), l.classList.toggle("boolean-editable", i.user !== null)) : (o !== l.hasAttribute("contenteditable") && l.toggleAttribute("contenteditable", o), l.classList.toggle("boolean-editable", !1));
        } else l.toggleAttribute("contenteditable", !1), l.classList.toggle("boolean-editable", !1);
    }
}
var D = (t, e, r)=>{
    let s = t.querySelectorAll("td"), o = r.get(t), l = t.getRootNode();
    if (o) {
        for (let i of s){
            let a = t.getMeta(i);
            if (a.x === o.x && a.y === o.y) return l.activeElement !== i && i.focus({
                preventScroll: !0
            }), !0;
        }
        document.activeElement !== document.body && t.contains(l.activeElement) && l.activeElement.blur();
    }
};
function Xe(t) {
    let e;
    return async function(...r) {
        if (!!e && await e && !!e) return;
        let s;
        e = new Promise((o)=>s = o), await t.apply(this, r), e = void 0, s();
    };
}
function Le() {
    if (this.isContentEditable) {
        let t = this.getRootNode().getSelection().getRangeAt(0), e = t.cloneRange();
        return e.selectNodeContents(this), e.setEnd(t.endContainer, t.endOffset), e.toString().length;
    } else return this.target.selectionStart;
}
function V(t, e, r) {
    let s = t.getMeta(r), o = e._schema[e._column_paths[s.x]];
    if (s) {
        let l = r.textContent, i = e._ids[s.y - s.y0];
        if (o === "float" || o === "integer") {
            if (l = parseFloat(l.replace(/,/g, "")), isNaN(l)) return !1;
        } else if (o === "date" || o === "datetime") {
            if (l = Date.parse(l), isNaN(l)) return !1;
        } else o === "boolean" && (l = l === "true" ? !1 : l === "false" ? !0 : null);
        let a = {
            __INDEX__: i,
            [e._column_paths[s.x]]: l
        };
        return e._table.update([
            a
        ], {
            port_id: e._edit_port
        }), !0;
    }
}
function $(t, e = !1) {
    let r = this._config.group_by.length === 0 && this._config.split_by.length === 0, s = t.hasAttribute("selectable"), o = e || !!t.children[0]._is_edit_mode;
    return r && !s && o;
}
var A = Xe(async function(t, e, r, s, o) {
    let l = t.getMeta(r), i = this._column_paths.length, a = this._num_rows, n = e.get(t);
    if (!n) return;
    l.x + s < i && 0 <= l.x + s && (n.x = l.x + s), l.y + o < a && 0 <= l.y + o && (n.y = l.y + o);
    let c = Math.max(l.x0 - 10, 0), d = Math.min(l.x0 + 10, i), p = Math.max(l.y0 - 5, 0), u = Math.min(l.y0 + 10, a), h = l.x0 + s, g = l.y0 + o;
    for(; !D(t, void 0, e) && h >= c && h < d && g >= p && g < u;)await t.scrollToCell(h, g, i, a), e.set(t, n), h += s, g += o;
});
function Se(t, e, r, s) {
    if (!$.call(this, e)) return;
    let o = t.getRootNode().activeElement;
    switch(s.target.classList.remove("psp-error"), s.key){
        case "Enter":
            s.preventDefault(), s.shiftKey ? A.call(this, t, r, o, 0, -1) : A.call(this, t, r, o, 0, 1);
            break;
        case "ArrowLeft":
            Le.call(o) == 0 && (s.preventDefault(), A.call(this, t, r, o, -1, 0));
            break;
        case "ArrowUp":
            s.preventDefault(), A.call(this, t, r, o, 0, -1);
            break;
        case "ArrowRight":
            Le.call(o) == o.textContent.length && (s.preventDefault(), A.call(this, t, r, o, 1, 0));
            break;
        case "ArrowDown":
            s.preventDefault(), A.call(this, t, r, o, 0, 1);
            break;
        default:
    }
}
function Ee(t, e, r) {
    let s = t.getMeta(r.target);
    if (typeof s?.x < "u") {
        let o = $.call(this, e), l = this._is_editable[s.x], i = this.get_psp_type(s) === "boolean", a = r.target.textContent === "-";
        o && l && i && !a && V(t, this, r.target);
    }
}
function ze(t, e, r, s) {
    if ($.call(this, e) && r.has(t)) {
        s.target.classList.remove("psp-error");
        let o = r.get(t);
        r.delete(t), o.content !== s.target.textContent && (V(t, this, s.target) || (s.target.textContent = o.content, s.target.classList.add("psp-error"), s.target.focus()));
    }
}
function Ae(t, e, r, s) {
    let o = t.getMeta(s.target);
    if (o) {
        let l = {
            x: o.x,
            y: o.y,
            content: s.target.textContent
        };
        r.set(t, l);
    }
}
async function O({ _view: t, _config: e }, r, s) {
    let o = e.group_by, l = e.split_by, i = r >= 0 ? r : 0, a = i + 1, n = await t.to_json({
        start_row: i,
        end_row: a
    }), d = n.map((m)=>m.__ROW_PATH__)[0] || [], p = o.map((m, v)=>{
        let b = d[v];
        return b ? [
            m,
            "==",
            b
        ] : void 0;
    }).filter((m)=>m), u = o.length > 0 ? s + 1 : s, h = Object.keys(n[0])[u], g = {
        row: n[0]
    }, _ = [];
    if (h) {
        let m = h.split("|");
        g.column_names = [
            m[l.length]
        ], _ = l.map((v, b)=>{
            let x = m[b];
            return x ? [
                v,
                "==",
                x
            ] : void 0;
        }).filter((v)=>v).filter(([, , v])=>v !== "__ROW_PATH__");
    }
    let f = e.filter.concat(p).concat(_);
    return g.config = {
        filter: f
    }, g;
}
async function Ce(t, e, r, s) {
    let o = t.getMeta(s.target);
    if (!e.hasAttribute("selectable") || s.handled || s.which !== 1 || !o) return;
    let l = this._ids[o.y - o.y0];
    if (o && o.y >= 0) {
        let i = r.get(t), a = !!i && i.reduce((h, g, _)=>h && g === l[_], !0), n = !!i && l.length === i.length && a, c = {
            selected: !n
        }, { row: d, column_names: p, config: u } = await O(this, o.y, o.x);
        n ? (r.delete(t), c = {
            ...c,
            row: d,
            config: {
                filter: structuredClone(this._config.filter)
            }
        }) : (r.set(t, l), c = {
            ...c,
            row: d,
            column_names: p,
            config: u
        }), await t.draw({
            preserve_width: !0
        }), s.handled = !0, e.dispatchEvent(new CustomEvent("perspective-select", {
            bubbles: !0,
            composed: !0,
            detail: c
        }));
    }
}
function Me(t, e, r) {
    if (!e.hasAttribute("selectable")) return;
    let s = r.has(t), o = r.get(t);
    for (let l of t.querySelectorAll("td"))if (!s) l.classList.toggle("psp-row-selected", !1), l.classList.toggle("psp-row-subselected", !1);
    else {
        let i = t.getMeta(l), a = this._ids[i.y - i.y0], n = o.reduce((c, d, p)=>c && d === a[p], !0);
        l.classList.toggle("psp-row-selected", a.length === o.length && n), l.classList.toggle("psp-row-subselected", a.length !== o.length && n);
    }
    for (let l of t.querySelectorAll("tbody th")){
        let i = t.getMeta(l), a = this._ids[i.y - i.y0];
        if (!s || !!a[i.row_header_x]) l.classList.toggle("psp-row-selected", !1), l.classList.toggle("psp-row-subselected", !1);
        else {
            let n = o.reduce((c, d, p)=>c && d === a[p], !0);
            l.classList.toggle("psp-row-selected", a.length === o.length && n), l.classList.toggle("psp-row-subselected", a.length !== o.length && n);
        }
    }
}
async function Oe(t, e, r) {
    r.delete(t);
    for (let s of t.querySelectorAll("td,th"))s.classList.toggle("psp-row-selected", !1), s.classList.toggle("psp-row-subselected", !1);
}
var Re = {
    datetime: Intl.DateTimeFormat,
    date: Intl.DateTimeFormat,
    integer: Intl.NumberFormat,
    float: Intl.NumberFormat,
    boolean: class {
        format(t) {
            return t ? "true" : "false";
        }
    }
}, F = class {
    constructor(){
        this._formatters = new Map;
    }
    create_datetime_formatter(e, r) {
        let s = (0, _indexJs.get_type_config)(e);
        if (e === "datetime") {
            if (r.date_format?.format !== "custom") {
                let o = {
                    ...s.format,
                    timeZone: r.date_format?.timeZone,
                    dateStyle: r.date_format?.dateStyle,
                    timeStyle: r.date_format?.timeStyle
                };
                return o.dateStyle === "disabled" ? o.dateStyle = void 0 : o.dateStyle === void 0 && (o.dateStyle = s.format.dateStyle), o.timeStyle === "disabled" ? o.timeStyle = void 0 : o.timeStyle === void 0 && (o.timeStyle = s.format.timeStyle), new Intl.DateTimeFormat(navigator.languages, o);
            } else {
                let o = {
                    timeZone: r.date_format?.timeZone,
                    second: r.date_format?.second,
                    minute: r.date_format?.minute,
                    hour: r.date_format?.hour,
                    day: r.date_format?.day,
                    weekday: r.date_format?.weekday,
                    month: r.date_format?.month,
                    year: r.date_format?.year,
                    hour12: r.date_format?.hour12,
                    fractionalSecondDigits: r.date_format?.fractionalSecondDigits
                };
                return o.year === "disabled" ? o.year = void 0 : o.year === void 0 && (o.year = "2-digit"), o.month === "disabled" ? o.month = void 0 : o.month === void 0 && (o.month = "numeric"), o.day === "disabled" ? o.day = void 0 : o.day === void 0 && (o.day = "numeric"), o.weekday === "disabled" && (o.weekday = void 0), o.hour === "disabled" ? o.hour = void 0 : o.hour === void 0 && (o.hour = "numeric"), o.minute === "disabled" ? o.minute = void 0 : o.minute === void 0 && (o.minute = "numeric"), o.second === "disabled" ? o.second = void 0 : o.second === void 0 && (o.second = "numeric"), o.hour12 === void 0 && (o.hour12 = !0), new Intl.DateTimeFormat(navigator.languages, o);
            }
        } else {
            let o = {
                ...s.format,
                dateStyle: r.date_format?.dateStyle
            };
            return o.dateStyle === "disabled" ? o.dateStyle = void 0 : o.dateStyle === void 0 && (o.dateStyle = s.format.dateStyle), new Intl.DateTimeFormat(navigator.languages, o);
        }
    }
    create_number_formatter(e, r) {
        let { format: s } = (0, _indexJs.get_type_config)(e);
        return r.number_format !== void 0 && (s = r.number_format), new Re[e](navigator.languages, s);
    }
    create_boolean_formatter(e, r) {
        let s = (0, _indexJs.get_type_config)(e);
        return new Re[e](navigator.languages, s.format);
    }
    get(e, r) {
        let s = [
            e,
            ...Object.values(r.date_format ?? {}),
            ...Object.values(r.number_format ?? {})
        ].join("-");
        if (!this._formatters.has(s)) {
            let o = (0, _indexJs.get_type_config)(e);
            e === "date" || e === "datetime" ? this._formatters.set(s, this.create_datetime_formatter(e, r)) : e === "integer" || e === "float" ? this._formatters.set(s, this.create_number_formatter(e, r)) : e === "boolean" ? this._formatters.set(s, this.create_boolean_formatter(e, r)) : this._formatters.set(s, !1);
        }
        return this._formatters.get(s);
    }
};
var Qe = new F, Ne = 1;
function H(t, e, r = {}, s = !1) {
    if (e === null) return "-";
    let o = s && this._table_schema[t] || this._schema[t] || "string", l = r[t] || {};
    if ((o === "integer" || o === "float") && l?.number_fg_mode === "bar") {
        let a = Math.max(0, Math.min(Ne, Math.abs(e / l.fg_gradient) * Ne)), n = this._div_factory.get(), c = e >= 0 ? "left" : "right", d = (a * 100).toFixed(2);
        return n.setAttribute("style", `width:calc(${d}% - 4px);position:absolute;${c}:2px;height:80%;top:10%;pointer-events:none;`), n;
    } else if (l?.format === "link" && o === "string") {
        let a = document.createElement("a");
        return a.setAttribute("href", e), a.setAttribute("target", "_blank"), a.textContent = e, a;
    } else if (l?.format === "bold" && o === "string") {
        let a = document.createElement("b");
        return a.textContent = e, a;
    } else if (l?.format === "italics" && o === "string") {
        let a = document.createElement("i");
        return a.textContent = e, a;
    } else {
        let a = Qe.get(o, l);
        return a ? a.format(e) : e;
    }
}
function* Pe(t = [], e, r) {
    let s = r[k];
    for (let o of t){
        o = [
            "TOTAL",
            ...o
        ];
        let l = o[o.length - 1];
        o = o.slice(0, o.length - 1).fill("");
        let i = H.call(this, e[o.length - 1], l, s, !0);
        i instanceof HTMLElement ? o = o.concat(i) : o = o.concat({
            toString: ()=>i
        }), o.length = e.length + 1, yield o;
    }
}
function Ie(t) {
    let e, r, s, o, l;
    return async function(a, n, c, d, p) {
        let u = {}, h;
        d - n > 0 && p - c > 0 ? (this._is_old_viewport = this._last_window?.start_row === c && this._last_window?.end_row === p && this._last_window?.start_col === n && this._last_window?.end_col === d, h = {
            start_row: c,
            start_col: n,
            end_row: p,
            end_col: d,
            id: !0
        }, u = JSON.parse(await this._view.to_columns_string(h)), this._last_window = h, this._ids = u.__ID__, this._reverse_columns = this._column_paths.slice(n, d).reduce((b, x, y)=>(b.set(x, y), b), new Map), this._reverse_ids = this._ids.reduce((b, x, y)=>(b.set(x?.join("|"), y), b), new Map)) : this._div_factory.clear();
        let g = [], _ = [], f = [], m = [], v = t.hasAttribute("settings");
        for(let b = n; b < Math.min(d, this._column_paths.length); ++b){
            let x = this._column_paths[b], y = x.split("|"), M = u[x] || new Array(p - c).fill(null);
            g.push(M.map((R)=>H.call(this, y[this._config.split_by.length], R, a[k]))), _.push(M), v && y.push(""), f.push(y), m.push(x);
        }
        return d - n > 0 && p - c > 0 && (this.last_column_paths = r, this.last_meta = e, this.last_ids = s, this.last_reverse_ids = o, this.last_reverse_columns = l, r = m, e = _, s = this._ids, o = this._reverse_ids, l = this._reverse_columns), {
            num_rows: this._num_rows,
            num_columns: this._column_paths.length,
            row_headers: Array.from(Pe.call(this, u.__ROW_PATH__, this._config.group_by, a)),
            column_headers: f,
            data: g,
            metadata: _,
            column_header_merge_depth: Math.max(0, this._config.split_by.length)
        };
    };
}
function j(t, e, r) {
    let s = window.getComputedStyle(t).getPropertyValue(e).trim();
    return s.length > 0 ? s : r;
}
var K = class {
    constructor(e){
        this._name = e, this._elements = [], this._index = 0;
    }
    clear() {
        this._index = 0;
    }
    get() {
        this._elements[this._index] || (this._elements[this._index] = document.createElement(this._name));
        let e = this._elements[this._index];
        return this._index += 1, e;
    }
};
function tt(t) {
    return t.x >= 0 ? this._column_types[t.x] : this._row_header_types[t.row_header_x - 1];
}
async function Z(t, e, r, s = {}) {
    let o = await r.get_config(), l = Object.fromEntries(o.expressions.map((L)=>[
            L[0],
            L[1]
        ])), [i, a, n, c, d, p, u] = await Promise.all([
        e.schema(),
        e.validate_expressions(l),
        r.num_rows(),
        r.schema(),
        r.expression_schema(),
        r.column_paths(),
        this.parentElement.getEditPort()
    ]), h = (0, _chromaJsDefault.default)(j(t, "--plugin--background", "#FFFFFF")).rgb(), g = w(j(t, "--rt-pos-cell--color", "#338DCD")), _ = w(j(t, "--rt-neg-cell--color", "#FF5942")), f = w(J(g[0], h)), m = w(J(_[0], h)), v = w(j(t, "--active--color", "#ff0000")), b = {
        ...c,
        ...d
    }, x = {
        ...i,
        ...a.expression_schema
    }, y = p.filter((L)=>L !== "__ROW_PATH__" && L !== "__ID__"), M = [], R = [];
    for (let L of y){
        let ee = L.split("|")[o.split_by.length];
        R.push(b[ee]), M.push(!!i[ee]);
    }
    let N = Object.assign(s, {
        _edit_port: u,
        _view: r,
        _table: e,
        _table_schema: x,
        _config: o,
        _num_rows: n,
        _schema: b,
        _ids: [],
        _plugin_background: h,
        _color: v,
        _pos_fg_color: g,
        _neg_fg_color: _,
        _pos_bg_color: f,
        _neg_bg_color: m,
        _column_paths: y,
        _column_types: R,
        _is_editable: M,
        _row_header_types: o.group_by.map((L)=>x[L]),
        _series_color_map: new Map,
        _series_color_seed: new Map,
        get_psp_type: tt
    });
    return N._div_factory = N._div_factory || new K("div"), t.setDataListener(Ie(this.parentElement).bind(N, t), {
        virtual_mode: window.getComputedStyle(t).getPropertyValue("--datagrid-virtual-mode")?.trim() || "both"
    }), N;
}
async function De(t, e, r) {
    let s = t.getMeta(r.target);
    if (!s) return;
    let { x: o, y: l } = s, { row: i, column_names: a, config: n } = await O(this, l, o);
    e.dispatchEvent(new CustomEvent("perspective-click", {
        bubbles: !0,
        composed: !0,
        detail: {
            row: i,
            column_names: a,
            config: n
        }
    }));
}
async function $e(t) {
    let e = this.parentElement, r = await e.getTable(!0);
    if (this._initialized) await Z.call(this, this.regular_table, r, t, this.model);
    else {
        this.innerHTML = "", this.shadowRoot ? this.shadowRoot.appendChild(this.regular_table) : this.appendChild(this.regular_table), this.model = await Z.call(this, this.regular_table, r, t), this.regular_table.addStyleListener(be.bind(this.model, this.regular_table, e)), this.regular_table.addStyleListener(ae.bind(this.model, this.regular_table)), this.regular_table.addStyleListener(ie.bind(this.model, this.regular_table, e)), this.regular_table.addEventListener("click", ve.bind(this.model, this.regular_table)), this.regular_table.addEventListener("mousedown", ye.bind(this.model, this.regular_table, e));
        let s = new WeakMap;
        this.regular_table.addStyleListener(Me.bind(this.model, this.regular_table, e, s)), this.regular_table.addEventListener("mousedown", Ce.bind(this.model, this.regular_table, e, s)), this.regular_table.addEventListener("psp-deselect-all", Oe.bind(this.model, this.regular_table, e, s)), this.regular_table.addEventListener("click", De.bind(this.model, this.regular_table, e));
        let o = new WeakMap;
        this.regular_table.addStyleListener(ke.bind(this.model, this.regular_table, e, this)), this.regular_table.addStyleListener(D.bind(this.model, this.regular_table, e, o)), this.regular_table.addEventListener("click", Ee.bind(this.model, this.regular_table, e)), this.regular_table.addEventListener("focusin", Ae.bind(this.model, this.regular_table, e, o)), this.regular_table.addEventListener("focusout", ze.bind(this.model, this.regular_table, e, o)), this.regular_table.addEventListener("keydown", Se.bind(this.model, this.regular_table, e, o)), e.addEventListener("perspective-toggle-column-settings", (l)=>{
            if (this.isConnected) {
                if (G.call(this.model, this.regular_table, e, l.detail.column_name), !l.detail.open) {
                    this.model._column_settings_selected_column = null;
                    return;
                }
                this.model._column_settings_selected_column = l.detail.column_name;
            }
        }), this._initialized = !0;
    }
}
function B(t, e = !1) {
    if (!this._initialized) return;
    e && (this._cached_column_sizes = t);
    let r = {}, { group_by: s, columns: o } = this.model._config, l = s?.length > 0 ? s.length + 1 : 0;
    for (let i of Object.keys(t))if (i === "__ROW_PATH__") r[l - 1] = t[i];
    else {
        let a = this.model._column_paths.indexOf(i);
        r[a + l] = t[i];
    }
    this.regular_table._column_sizes.override = r;
}
function W() {
    if (!this._initialized) return [];
    if (this._cached_column_sizes) {
        let l = this._cached_column_sizes;
        return this._cached_column_sizes = void 0, l;
    }
    let t = this.regular_table._column_sizes.override, { group_by: e, columns: r } = this.model._config, s = e?.length > 0 ? e.length + 1 : 0, o = {};
    for (let l of Object.keys(t))if (t[l] !== void 0) {
        let i = l - s;
        i > -1 ? o[this.model._column_paths[i]] = t[l] : i === -1 && (o.__ROW_PATH__ = t[l]);
    }
    return o;
}
function q(t) {
    typeof t > "u" && (t = !this._is_edit_mode), this._is_edit_mode = t, this.classList.toggle("editable", t), this._edit_mode !== void 0 && this._edit_mode.classList.toggle("editable", t);
}
function Y(t) {
    typeof t > "u" && (t = !this._is_scroll_lock), this._is_scroll_lock = t, this.classList.toggle("sub-cell-scroll-disabled", t), this._scroll_lock !== void 0 && this._scroll_lock.classList.toggle("lock-scroll", t);
}
function Te(t, e) {
    t = JSON.parse(JSON.stringify(t)), e = JSON.parse(JSON.stringify(e));
    let r = {};
    if (t.columns) for (let [l, i] of Object.entries(t.columns))i.column_size_override !== void 0 && (r[l] = i.column_size_override, delete i.column_size_override);
    let s = {};
    if (e) for (let [l, i] of Object.entries(e))s[l] = {
        ...i,
        pos_fg_color: i.pos_fg_color ? w(i.pos_fg_color) : void 0,
        neg_fg_color: i.neg_fg_color ? w(i.neg_fg_color) : void 0,
        pos_bg_color: i.pos_bg_color ? w(i.pos_bg_color) : void 0,
        neg_bg_color: i.neg_bg_color ? w(i.neg_bg_color) : void 0,
        color: i.color ? w(i.color) : void 0
    };
    "editable" in t && q.call(this, t.editable), "scroll_lock" in t && Y.call(this, t.scroll_lock);
    let o = this.regular_table;
    B.call(this, r, !0), o[k] = s;
}
function Fe() {
    if (this.regular_table) {
        let t = {
            columns: {},
            scroll_lock: !!this._is_scroll_lock,
            editable: !!this._is_edit_mode
        }, e = W.call(this);
        for (let r of Object.keys(e || {}))t.columns[r] || (t.columns[r] = {}), t.columns[r].column_size_override = e[r];
        return JSON.parse(JSON.stringify(t));
    }
    return {};
}
async function He(t) {
    if (this.parentElement && await this.activate(t), !this.isConnected || this.offsetParent == null) return;
    let e = W.call(this), r = this.regular_table.draw({
        invalid_columns: !0
    });
    this.model._preserve_focus_state ? this.model._preserve_focus_state = !1 : (this.regular_table.scrollTop = 0, this.regular_table.scrollLeft = 0, this.regular_table.dispatchEvent(new CustomEvent("psp-deselect-all", {
        bubbles: !1
    })), this.regular_table._resetAutoSize()), B.call(this, e), await r, this._toolbar.classList.toggle("aggregated", this.model._config.group_by.length > 0 || this.model._config.split_by.length > 0);
}
function X(t, e) {
    return t === "integer" || t === "float" ? {
        datagrid_number_style: {
            fg_gradient: 0,
            pos_fg_color: this.model._pos_fg_color[0],
            neg_fg_color: this.model._neg_fg_color[0],
            number_fg_mode: "color",
            bg_gradient: 0,
            pos_bg_color: this.model._pos_bg_color[0],
            neg_bg_color: this.model._neg_bg_color[0],
            number_bg_mode: "disabled"
        },
        number_string_format: !0
    } : t === "date" || t === "datetime" || t === "string" ? {
        [t === "date" || t === "datetime" ? "datagrid_datetime_style" : "datagrid_string_style"]: {
            color: this.model._color[0],
            bg_color: this.model._color[0]
        }
    } : null;
}
var z, Q = class extends HTMLElement {
    constructor(){
        super(), this.regular_table = document.createElement("regular-table"), this.regular_table.part = "regular-table", this._is_scroll_lock = !1;
        let e = Q;
        e.renderTarget == "shadow" && (P(e, z) || (se(e, z, new CSSStyleSheet), P(e, z).replaceSync(I)), this.attachShadow({
            mode: "open"
        }).adoptedStyleSheets.push(P(e, z)));
    }
    connectedCallback() {
        this._toolbar || (this._toolbar = document.createElement("perspective-viewer-datagrid-toolbar"));
        let e = this.parentElement;
        e && e.appendChild(this._toolbar);
    }
    disconnectedCallback() {
        this._toolbar.parentElement.removeChild(this._toolbar);
    }
    async activate(e) {
        return await $e.call(this, e);
    }
    get name() {
        return "Datagrid";
    }
    get category() {
        return "Basic";
    }
    get select_mode() {
        return "toggle";
    }
    get min_config_columns() {}
    get config_column_names() {
        return [
            "Columns"
        ];
    }
    get priority() {
        return 1;
    }
    can_render_column_styles(e, r) {
        return e !== "boolean";
    }
    column_style_controls(e, r) {
        return X.call(this, e, r);
    }
    async draw(e) {
        return await He.call(this, e);
    }
    async update(e) {
        this.model._num_rows = await e.num_rows(), await this.regular_table.draw();
    }
    async resize() {
        !this.isConnected || this.offsetParent == null || this._initialized && await this.regular_table.draw();
    }
    async clear() {
        this.regular_table._resetAutoSize(), this.regular_table.clear();
    }
    save() {
        return Fe.call(this);
    }
    restore(e, r) {
        return Te.call(this, e, r);
    }
    async restyle(e) {
        await this.draw(e);
    }
    delete() {
        this.regular_table.table_model && this.regular_table._resetAutoSize(), this.regular_table.clear();
    }
}, C = Q;
z = new WeakMap, te(C, "renderTarget", window.CSS?.supports && window.CSS?.supports("selector(:host-context(foo))") ? "shadow" : "light"), oe(C, z, void 0);
var je = ':host{position:relative;display:block;}:host #container{position:absolute;display:flex;flex-direction:column;justify-content:stretch;align-items:stretch;top:0;left:0;right:0;bottom:0;}:host #toolbar{display:flex;align-items:center;height:36px;}:host #slot-container{flex:1;position:relative;}#scroll_lock.lock-scroll:before{-webkit-mask-image:var(--toolbar-scroll-lock-active--content);}#scroll_lock:before{-webkit-mask-image:var(--toolbar-scroll-lock--content);}#select_mode:before{content:"highlight_alt";}#edit_mode:before{-webkit-mask-image:var(--toolbar-edit-mode--content);}#edit_mode.editable:before{-webkit-mask-image:var(--toolbar-edit-mode-active--content);}#edit_mode span:before{content:var(--edit-mode-toggle--content,"Read Only");}#edit_mode.editable span:before{content:var(--edit-mode-alt-toggle--content,"Editable");}#scroll_lock span:before{content:var(--scroll-lock-toggle--content,"Free Scroll");}#scroll_lock.lock-scroll span:before{content:var(--scroll-lock-alt-toggle--content,"Align Scroll");}:host(.aggregated) #toolbar #edit_mode{display:none;}.button:before{width:25px;height:21px;content:"";-webkit-mask-image:cover;mask-image:cover;background-color:var(--icon--color,#ccc);margin:0 5px;}.button.editable:before,.button.lock-scroll:before{color:inherit;}.button{align-items:center;border-radius:3px;border:1px solid transparent;box-sizing:border-box;display:inline-flex;font-size:var(--label--font-size,0.75em);height:22px;user-select:none;white-space:nowrap;width:37px;}.button>span{display:none;margin:0;padding:0;}.button:hover{background-color:var(--icon--color);color:var(--plugin--background);opacity:1;display:flex;align-items:center;cursor:pointer;min-width:var(--button--min-width,105px);}.button:hover:before{background-color:var(--plugin--background);margin:0 5px 0 5px;}.button:hover>span{display:contents;line-height:36px;}';
var U = class extends HTMLElement {
    connectedCallback() {
        if (this._initialized) return;
        this._initialized = !0, this.setAttribute("slot", "plugin-settings"), this.attachShadow({
            mode: "open"
        }), this.shadowRoot.innerHTML = `
            <style>
                ${je}
            </style>
            <div id="toolbar">
                <span id="scroll_lock" class="button">
                    <span></span>
                </span>
                <span id="edit_mode" class="button"><span></span></span>
            </div>
        `;
        let e = this.parentElement, r = e.querySelector("perspective-viewer-datagrid");
        r._scroll_lock = this.shadowRoot.querySelector("#scroll_lock"), r._scroll_lock.addEventListener("click", ()=>Y.call(r)), r._edit_mode = this.shadowRoot.querySelector("#edit_mode"), r._edit_mode.addEventListener("click", ()=>{
            q.call(r), r.regular_table.draw(), e.dispatchEvent(new Event("perspective-config-update"));
        });
    }
};
function ot() {
    let t = document.createElement("style");
    t.textContent = I, document.head.insertBefore(t, document.head.firstChild);
}
async function st() {
    customElements.define("perspective-viewer-datagrid-toolbar", U), customElements.define("perspective-viewer-datagrid", C), await customElements.whenDefined("perspective-viewer"), customElements.get("perspective-viewer").registerPlugin("perspective-viewer-datagrid");
}
st();
ot();

},{"regular-table":"eYdOL","chroma-js":"5QOZM","@finos/perspective/src/js/config/index.js":"bFzCy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eYdOL":[function(require,module,exports) {
var T = new WeakMap, et = !0, ft = navigator.userAgent.toLowerCase().indexOf("firefox") > -1, lt = ft ? 5e6 : 1e7;
var Y = 0, I = 0, at = performance.now();
function _t() {
    let c = performance.now(), t = c - at, e = Y, i = I * 1e3 / t, s = 1e3 / e, o = I;
    return Y = 0, I = 0, at = c, {
        avg: e,
        real_fps: i,
        virtual_fps: s,
        num_frames: o,
        elapsed: t
    };
}
function rt(c) {
    Y = (Y * I + c) / (I + 1), I += 1;
}
var j = (c, ...t)=>c.map((e, i)=>[
            e,
            t[i]
        ]).flat().filter((e)=>!!e).join(""), mt = ()=>{
    let c, t = new Promise((e)=>{
        c = e;
    });
    return t.resolve = c, t;
}, D = new Map;
async function nt(c) {
    return await new Promise(requestAnimationFrame), await D.get(c);
}
async function q(c, t) {
    if (D.has(c) && (await D.get(c), D.has(c))) {
        await D.get(c);
        return;
    }
    D.set(c, mt());
    try {
        return await t();
    } finally{
        let e = D.get(c);
        D.delete(c), e.resolve();
    }
}
var ht = ":host{position:absolute;top:0px;left:0px;right:0px;bottom:0px;overflow:scroll;overflow-anchor:none;overscroll-behavior:none;-webkit-overflow-scrolling:touch;}div.rt-virtual-panel{position:absolute;top:0;left:0;right:0;pointer-events:none;}div.rt-scroll-table-clip{position:sticky;contain:strict;overflow-anchor:none;width:100%;height:100%;}div.rt-tree-container{display:flex;align-items:center;height:100%;}slot{position:absolute;overflow:hidden;overflow-anchor:none;}";
var ct = ":host ::slotted(table){--regular-table--transform-x:0px;--regular-table--transform-y:0px;--regular-table--clip-x:0px;--regular-table--clip-y:0px;}";
var U = class extends HTMLElement {
    create_shadow_dom() {
        this.attachShadow({
            mode: "open"
        });
        let t = "<slot></slot>";
        this.shadowRoot.innerHTML = j`
            <style>
                ${ht}
            </style>
            <style>
                ${ct}
            </style>
            <div class="rt-virtual-panel"></div>
            <div class="rt-scroll-table-clip">
                ${t}
            </div>
        `;
        let [, e, i, s] = this.shadowRoot.children;
        this._sub_cell_style = e, this._table_clip = s, this._virtual_panel = i, this._setup_virtual_scroll();
    }
    _setup_virtual_scroll() {
        this._table_clip && (this._virtual_mode === "both" || this._virtual_mode === "vertical" ? this._table_clip.style.top = "0px" : this._table_clip.style.removeProperty("top"), this._virtual_mode === "both" || this._virtual_mode === "horizontal" ? this._table_clip.style.left = "0px" : this._table_clip.style.removeProperty("left"), this._virtual_mode !== "both" ? this._table_clip.style.contain = "none" : this._table_clip.style.removeProperty("contain"));
    }
    _calculate_viewport(t, e) {
        let { start_row: i, end_row: s } = this._calculate_row_range(t), { start_col: o, end_col: l } = this._calculate_column_range(e);
        return this._nrows = t, {
            start_col: o,
            end_col: l,
            start_row: i,
            end_row: s
        };
    }
    _calculate_row_range(t) {
        let { height: e } = this._container_size, i = this._column_sizes.row_height || 19, s = this._view_cache.config.column_pivots.length, o = Math.max(1, this._virtual_panel.offsetHeight - this.clientHeight), l = Math.max(Math.ceil(this.scrollTop), 0) / o, _ = e / i - s, f = Math.max(0, Math.ceil((t || 0) - _)) * l, n = Math.max(0, Math.min(f + _, t));
        return {
            start_row: f,
            end_row: n
        };
    }
    _calc_start_column() {
        let t = this._view_cache.config.row_pivots.length, e = 0, i = 0, s = 0;
        for(; i < this.scrollLeft;){
            let o = this._column_sizes.indices[e + t];
            s = this.scrollLeft - i, e += 1, i += o !== void 0 ? o : 60;
        }
        return e += s / (this._column_sizes.indices[e + t - 1] || 60), Math.max(0, e - 1);
    }
    _calculate_column_range(t) {
        if (this._virtual_mode === "none" || this._virtual_mode === "vertical") return {
            start_col: 0,
            end_col: 1 / 0
        };
        {
            let e = this._calc_start_column(), i = this.table_model.num_columns() || Math.min(t, Math.ceil(this._container_size.width / 60)), s = e + i + 1;
            return {
                start_col: e,
                end_col: s
            };
        }
    }
    _max_scroll_column(t) {
        let e = 0;
        if (this._view_cache.config.row_pivots.length > 0) for (let o of this._column_sizes.indices.slice(0, this._view_cache.config.row_pivots.length))e += o;
        let i = this._view_cache.config.row_pivots.length, s = t;
        for(; e < this._container_size.width && s >= 0;)s--, e += this._column_sizes.indices[s + i] || 60;
        return Math.min(t - 1, s + 1);
    }
    _validate_viewport({ start_col: t, end_col: e, start_row: i, end_row: s }) {
        i = Math.floor(i), s = Math.ceil(s), t = Math.floor(t), e = Math.ceil(e);
        let o = this._start_col !== t, l = this._start_row !== i || this._end_row !== s || this._end_col !== e;
        return this._start_col = t, this._end_col = e, this._start_row = i, this._end_row = s, {
            invalid_column: o,
            invalid_row: l
        };
    }
    _calc_scrollable_column_width(t) {
        let e = this._view_cache.config.row_pivots.length, i = this._max_scroll_column(t), s = e, o = 0;
        for(; s < i + e;)o += this._column_sizes.indices[s] || 60, s++;
        return o;
    }
    _update_virtual_panel_width(t, e) {
        if (t) {
            if (this._virtual_mode === "vertical" || this._virtual_mode === "none") this._virtual_panel.style.width = this._column_sizes.indices.reduce((i, s)=>i + s, 0) + "px";
            else {
                let i = this._calc_scrollable_column_width(e);
                if (i !== 0) {
                    let s = this._container_size.width + i + 2;
                    this._virtual_panel.style.width = s + "px";
                } else this._virtual_panel.style.width = "1px";
            }
        }
    }
    _update_virtual_panel_height(t) {
        let { row_height: e = 19 } = this._column_sizes, i = this._view_cache.config.column_pivots.length * e, s;
        if (this._virtual_mode === "horizontal" || this._virtual_mode === "none") s = t * e + i;
        else {
            let o = this.clientHeight / (this._table_clip.offsetHeight - i);
            s = Math.min(lt, t * e * o);
        }
        this._virtual_panel.style.height = `${s}px`;
    }
    async draw(t = {}) {
        return typeof t.throttle < "u" && !t.throttle ? await dt.call(this, t) : await q(this, ()=>dt.call(this, t));
    }
    async _draw_flush() {
        await nt(this);
    }
    update_sub_cell_offset(t) {
        let e = this._column_sizes.row_height * (t.start_row % 1) || 0, i = this._column_sizes.indices[(this.table_model._row_headers_length || 0) + Math.floor(t.start_col)] * (t.start_col % 1) || 0, s = this._sub_cell_style.sheet?.cssRules[0].style;
        s && (s.setProperty("--regular-table--clip-x", `${i}px`), s.setProperty("--regular-table--clip-y", `${e}px`), s.setProperty("--regular-table--transform-x", `-${i}px`), s.setProperty("--regular-table--transform-y", `-${e}px`));
    }
};
async function dt(c) {
    let t = et && performance.now(), { invalid_viewport: e = !0, preserve_width: i = !1 } = c, { num_columns: s, num_rows: o, row_height: l } = await this._view_cache.view(0, 0, 0, 0);
    this._container_size = {
        width: this._virtual_mode === "none" || this._virtual_mode === "vertical" ? 1 / 0 : this._table_clip.clientWidth,
        height: this._virtual_mode === "none" || this._virtual_mode === "horizontal" ? 1 / 0 : this._table_clip.clientHeight
    }, this._update_virtual_panel_height(o), i || this._update_virtual_panel_width(e, s);
    let _ = this._calculate_viewport(o, s), { invalid_row: a, invalid_column: d } = this._validate_viewport(_);
    if (this._invalid_schema || a || d || e) {
        let f = [], n = !0;
        for await (let r of this.table_model.draw(this._container_size, this._view_cache, this._selected_id, i, _, s)){
            r !== void 0 && (f = f.concat(r)), n && (this.update_sub_cell_offset(_), n = !1), this._is_styling = !0;
            let w = this._style_callbacks;
            for (let b of w)await b({
                detail: this
            });
            if (this._is_styling = !1, !this._invalidated && r !== void 0) break;
            this._invalidated = !1;
        }
        this.table_model.autosize_cells(f, l), this.table_model.header.reset_header_cache(), i || this._update_virtual_panel_width(this._invalid_schema || d, s), this._invalid_schema = !1;
    } else this.update_sub_cell_offset(_);
    et && rt(performance.now() - t);
}
var gt = !1, K = class extends U {
    register_listeners() {
        this.addEventListener("mousedown", this._on_click_or_dblclick.bind(this)), this.addEventListener("scroll", this._on_scroll.bind(this), {
            passive: !0
        }), this._register_glitch_scroll_listeners();
    }
    async _on_scroll(t) {
        t.stopPropagation(), await this.draw({
            invalid_viewport: !1
        }), this.dispatchEvent(new CustomEvent("regular-table-scroll"));
    }
    _register_glitch_scroll_listeners() {
        this.addEventListener("mousewheel", this._on_mousewheel.bind(this)), gt && (this.addEventListener("touchmove", this._on_touchmove.bind(this)), this.addEventListener("touchstart", this._on_touchstart.bind(this), {
            passive: !0
        }));
    }
    _on_mousewheel(t) {
        if (!window.safari) return;
        let { clientWidth: e, clientHeight: i, scrollTop: s, scrollLeft: o } = this;
        t.preventDefault(), t.returnValue = !1;
        let l = Math.max(1, this._virtual_panel.offsetHeight - i), _ = Math.max(1, this._virtual_panel.offsetWidth - e);
        this.scrollTop = Math.max(0, Math.min(l, s + t.deltaY)), this.scrollLeft = Math.max(0, Math.min(_, o + t.deltaX)), this._on_scroll(t);
    }
    _on_touchmove(t) {
        t.stopPropagation(), t.preventDefault(), t.returnValue = !1;
        let { clientWidth: e, clientHeight: i } = this, s = Math.max(1, this._virtual_panel.offsetHeight - i), o = Math.max(1, this._virtual_panel.offsetWidth - e);
        this.scrollTop = Math.min(s, this._memo_scroll_top + (this._memo_touch_startY - t.touches[0].pageY)), this.scrollLeft = Math.min(o, this._memo_scroll_left + (this._memo_touch_startX - t.touches[0].pageX)), this._on_scroll(t);
    }
    _on_touchstart(t) {
        this._memo_touch_startY = t.touches[0].pageY, this._memo_touch_startX = t.touches[0].pageX, this._memo_scroll_top = this.scrollTop, this._memo_scroll_left = this.scrollLeft;
    }
    async _on_dblclick(t) {
        let e = t.target;
        for(; e.tagName !== "TD" && e.tagName !== "TH";)if (e = e.parentElement, !this.contains(e)) return;
        let i = t.target.classList.contains("rt-column-resize"), s = T.get(e);
        if (i) {
            t.stopImmediatePropagation(), e.style.minWidth = "", e.style.maxWidth = "", t.shiftKey ? (this._column_sizes.override = [], this._column_sizes.auto = [], this._column_sizes.indices = []) : (this._column_sizes.override[s.size_key] = void 0, this._column_sizes.auto[s.size_key] = void 0, this._column_sizes.indices[s.size_key] = void 0);
            for (let o of t.shiftKey ? [
                this.table_model.header.cells[this.table_model.header.cells.length - 1],
                ...this.table_model.body.cells
            ] : this.table_model.body.cells)for (let l of t.shiftKey ? o : [
                o[s._virtual_x]
            ])l && (l.style.minWidth = "", l.style.maxWidth = "", l.classList.remove("rt-cell-clip"));
            await this.draw();
        }
    }
    async _on_click(t) {
        if (t.button !== 0) return;
        let e = t.target;
        for(; e.tagName !== "TD" && e.tagName !== "TH";)if (e = e.parentElement, !this.contains(e)) return;
        let i = t.target.classList.contains("rt-column-resize"), s = T.get(e);
        i && (this._on_resize_column(t, e, s), t.stopImmediatePropagation());
    }
    async _on_click_or_dblclick(t) {
        let e = performance.now();
        this._last_clicked_time && e - this._last_clicked_time < 500 ? (this._last_clicked_time = e, await this._on_dblclick(t)) : (this._last_clicked_time = e, await this._on_click(t));
    }
    _on_resize_column(t, e, i) {
        let { _virtual_x: s, size_key: o } = i, l = t.pageX, _ = s + e.colSpan - 1, a = this.table_model.header.get_column_header(_), d = this._column_sizes.indices[o], f = (r)=>q(this, async ()=>await this._on_resize_column_move(r, a, l, d, o, _)), n = ()=>{
            document.removeEventListener("mousemove", f), document.removeEventListener("mouseup", n);
            let r = this._column_sizes.override[o], w = this._column_sizes.indices[o] !== r;
            this._column_sizes.indices[o] = r, w && this.draw();
        };
        document.addEventListener("mousemove", f), document.addEventListener("mouseup", n);
    }
    async _on_resize_column_move(t, e, i, s, o, l) {
        await new Promise(requestAnimationFrame);
        let _ = t.pageX - i, a = Math.max(1, s + _);
        if (this._column_sizes.override[o] = a, _ < 0) await this.draw({
            preserve_width: !0,
            throttle: !1
        });
        else {
            e.style.minWidth = a + "px", e.style.maxWidth = a + "px";
            let d = this._column_sizes.auto[o];
            for (let f of this.table_model.body.cells){
                let n = f[l];
                n && (n.style.maxWidth = n.style.minWidth = a + "px", n.classList.toggle("rt-cell-clip", d > a));
            }
        }
    }
};
var it = class {
    constructor(t){
        this._name = t, this._elements = [], this._index = 0;
    }
    reset() {
        this._index = 0;
    }
    get() {
        this._elements[this._index] || (this._elements[this._index] = document.createElement(this._name));
        let t = this._elements[this._index];
        return this._index += 1, t;
    }
}, O = class {
    constructor(t, e, i){
        this._column_sizes = t, this._container = e, this._span_factory = new it("span"), this.table = i, this.cells = [], this.rows = [];
    }
    num_columns() {
        return this._get_row(Math.max(0, this.rows.length - 1)).row_container.length;
    }
    num_rows() {
        return this.cells.length;
    }
    _set_metadata(t, e) {
        T.set(t, e);
    }
    _get_or_create_metadata(t) {
        if (t === void 0) return {};
        if (T.has(t)) return T.get(t);
        {
            let e = {};
            return T.set(t, e), e;
        }
    }
    _replace_cell(t, e) {
        let { tr: i, row_container: s } = this._get_row(t), o = s[e];
        return o && (i.removeChild(o), s.splice(e, 1, void 0)), o;
    }
    _fetch_cell(t, e) {
        if (!(t < 0 || e < 0)) return this.cells[t]?.[e];
    }
    _get_row(t) {
        let e = this.rows[t];
        e || (e = this.rows[t] = document.createElement("tr"), this.table.appendChild(e));
        let i = this.cells[t];
        return i || (i = this.cells[t] = []), {
            tr: e,
            row_container: i
        };
    }
    _get_cell(t = "TD", e, i) {
        let { tr: s, row_container: o } = this._get_row(e), l = o[i];
        if (l || (i < o.length ? (l = o[i] = document.createElement(t), s.insertBefore(l, o.slice(i + 1).find((_)=>_))) : (l = o[i] = document.createElement(t), s.appendChild(l))), l.tagName !== t) {
            let _ = document.createElement(t);
            s.replaceChild(_, l), this.cells[e].splice(i, 1, _), l = _;
        }
        return l;
    }
    _clean_columns(t) {
        for(let e = 0; e < this.rows.length; e++){
            let i = this.rows[e], s = this.cells[e];
            this.cells[e] = s.slice(0, t[e] || t);
            let o = this.cells[e].filter((l)=>l !== void 0).length;
            for(; i.children[o];)i.removeChild(i.children[o]);
        }
    }
    _clean_rows(t) {
        for(; this.table.children[t];)this.table.removeChild(this.table.children[t]);
        this.rows = this.rows.slice(0, t), this.cells = this.cells.slice(0, t);
    }
};
var J = class extends O {
    constructor(...t){
        super(...t), this._group_header_cache = [], this._offset_cache = [];
    }
    _draw_group_th(t, e, i) {
        let s = this._get_cell("TH", e, t[e] || 0);
        if (t[e] += 1, s.removeAttribute("colspan"), s.style.minWidth = "0", s.textContent = "", i instanceof HTMLElement) s.appendChild(i);
        else {
            let l = this._span_factory.get("span");
            l.textContent = i, s.appendChild(l);
        }
        let o = this._span_factory.get("span");
        return o.className = "rt-column-resize", s.appendChild(o), s;
    }
    _draw_group(t, e, i) {
        let s = this._get_or_create_metadata(i);
        return s.column_header = t, s.value = e, s.value = e, s;
    }
    _draw_th(t, e, i, s, o) {
        let l = this._get_or_create_metadata(i);
        if (l.column_header = t, l.value = e, l.size_key = o.length ? o[0] : o, !(o.length > 1)) {
            let _ = this._column_sizes.override[l.size_key], a = this._column_sizes.auto[l.size_key];
            _ ? (i.classList.toggle("rt-cell-clip", a > _), i.style.minWidth = _ + "px", i.style.maxWidth = _ + "px") : a ? (i.classList.remove("rt-cell-clip"), i.style.maxWidth = "", i.style.minWidth = a + "px") : (i.style.maxWidth = "", i.style.maxWidth = "");
        }
        return l;
    }
    get_column_header(t) {
        return this._get_cell("TH", this.num_rows() - 1, t);
    }
    draw(t, e, i, s, o, l, _, a, d) {
        let f = e?.length;
        if (f === 0) return;
        let n, r, w, b;
        a = typeof a > "u" ? f - 1 : a;
        for(let u = 0; u < f; u++){
            if (w = e[u] ? e[u] : "", this._offset_cache[u] = this._offset_cache[u] || 0, u < a) d && this._group_header_cache?.[u]?.[0]?.value === w ? (n = this._group_header_cache[u][1], this._group_header_cache[u][2] += 1, i === 1 && (this._group_header_cache[u][0].row_header_x = o), n.setAttribute("colspan", this._group_header_cache[u][2])) : (n = this._draw_group_th(this._offset_cache, u, w), r = this._draw_group(e, w, n), this._group_header_cache[u] = [
                r,
                n,
                1
            ]);
            else {
                n = this._draw_group_th(this._offset_cache, u, w), r = this._draw_th(t || e, w, n, s, o), typeof b > "u" && (b = {
                    th: n,
                    metadata: r
                });
                for (let [A] of this._group_header_cache)A.size_key = r.size_key;
                n.removeAttribute("colspan");
            }
            this._get_row(u).tr.classList.toggle("rt-autosize", u === a), n.classList.toggle("rt-group-corner", s === void 0), r && (r.x = typeof s > "u" ? s : Math.floor(s), r.column_header_y = u, r.x0 = Math.floor(l), r._virtual_x = _, i === 1 && (r.row_header_x = o));
        }
        return this._clean_rows(this._offset_cache.length), b = b || {
            th: n,
            metadata: r
        }, b;
    }
    clean() {
        this._clean_columns(this._offset_cache);
    }
    reset_header_cache() {
        this._offset_cache = [], this._group_header_cache = [];
    }
};
var Q = class extends O {
    _draw_td(t, e, i, s, { column_name: o }, { ridx_offset: l }, _) {
        let a = this._get_cell(t, e, s), d = this._get_or_create_metadata(a);
        d.y = e + Math.floor(l), d.size_key = _, t === "TD" && (d.column_header = o);
        let f = this._column_sizes.override[d.size_key];
        if (f) {
            let n = this._column_sizes.auto[d.size_key];
            a.classList.toggle("rt-cell-clip", n > f), a.style.minWidth = f + "px", a.style.maxWidth = f + "px";
        } else a.classList.remove("rt-cell-clip"), a.style.minWidth = "", a.style.maxWidth = "";
        return d.value !== i && (i instanceof HTMLElement ? (a.textContent = "", a.appendChild(i)) : a.textContent = i), d.value = i, {
            td: a,
            metadata: d
        };
    }
    draw(t, e, i, s = !1, o, l, _, a) {
        let { cidx: d, column_data: f, row_headers: n, column_data_listener_metadata: r } = e, { row_height: w } = i, b, u = [], A = [], m = 0, E = [];
        for(let g = 0; g < (s ? i.row_headers_length : 1); g++){
            m = 0;
            for (let x of f){
                let Z = n?.[m], h;
                if (s) {
                    let S = x[g], p = this._fetch_cell(m - (u[g] || 1), d + g), z = this._get_or_create_metadata(p), y = this._fetch_cell(m, d + g - (E[m] || 1)), C = this._get_or_create_metadata(y);
                    a && y && (C.value === S || S === void 0) && !y.hasAttribute("rowspan") ? (E[m] = E[m] ? E[m] + 1 : 2, y.setAttribute("colspan", E[m]), this._replace_cell(m, d + g)) : a && p && z.value === S && !p.hasAttribute("colspan") ? (u[g] = u[g] ? u[g] + 1 : 2, p.setAttribute("rowspan", u[g]), this._replace_cell(m, d + g)) : (h = this._draw_td("TH", m, S, d + g, e, i, g), h.td.style.display = "", h.td.removeAttribute("rowspan"), h.td.removeAttribute("colspan"), h.metadata.row_header = x, h.metadata.row_header_x = g, h.metadata.y0 = Math.floor(i.ridx_offset), h.metadata.y1 = Math.ceil(i.y1), h.metadata._virtual_x = g, typeof l < "u" && (h.metadata.x0 = Math.floor(l)), u[g] = 1, E[m] = 1, A[g] = h);
                } else h = this._draw_td("TD", m, x, d, e, i, _), r && (h.metadata.user = r[m]), h.metadata.x = typeof o > "u" ? o : Math.floor(o), h.metadata.x1 = Math.ceil(i.x1), h.metadata.row_header = Z || [], h.metadata.y0 = Math.floor(i.ridx_offset), h.metadata.y1 = Math.ceil(i.y1), h.metadata.dx = Math.floor(o - l), h.metadata.dy = h.metadata.y - Math.floor(h.metadata.y0), h.metadata._virtual_x = d, typeof l < "u" && (h.metadata.x0 = Math.floor(l)), A[0] = h;
                if (m++, b = h ? h.metadata : b, w = w || h?.td.offsetHeight, m * w > t) break;
            }
        }
        return this._clean_rows(m), {
            tds: A,
            ridx: m,
            metadata: b,
            row_height: w
        };
    }
    clean({ ridx: t, cidx: e }) {
        this._clean_rows(t), this._clean_columns(e);
    }
};
var V = class {
    constructor(t, e, i){
        this.clear(i);
        let [s] = i.children, [o, l] = s.children;
        this.table = s, this._column_sizes = e, this.header = new J(e, t, o), this.body = new Q(e, t, l), this.fragment = document.createDocumentFragment();
    }
    num_columns() {
        return this.header.num_columns();
    }
    clear(t) {
        t.innerHTML = j`
            <table cellspacing="0">
                <thead></thead>
                <tbody></tbody>
            </table>
        `;
    }
    autosize_cells(t, e) {
        for(; t.length > 0;){
            let [i, s] = t.pop(), o = i.getBoundingClientRect();
            this._column_sizes.row_height = e || Math.max(10, Math.min(this._column_sizes.row_height || o.height, o.height)), this._column_sizes.indices[s.size_key] = o.width;
            let l = this._column_sizes.override[s.size_key] !== void 0;
            o.width && !l && (this._column_sizes.auto[s.size_key] = o.width), i.style.minWidth === "0px" && (i.style.minWidth = `${o.width}px`);
        }
    }
    async *draw(t, e, i, s, o, l) {
        let { width: _, height: a } = t, { view: d, config: f } = e, { data: n, row_headers: r, column_headers: w, metadata: b, column_header_merge_depth: u, merge_headers: A = "both" } = await d(Math.floor(o.start_col), Math.floor(o.start_row), Math.ceil(o.end_col), Math.ceil(o.end_row)), m = A === "both" || A === "row", E = A === "both" || A === "column", { start_row: g = 0, start_col: x = 0, end_col: Z = 0, end_row: h = 0 } = o;
        r && (this._row_headers_length = r.reduce((v, $)=>Math.max(v, $.length), 0), r = r.map((v)=>(v.length = this._row_headers_length, v))), e.config.column_pivots = Array.from(Array(w?.[0]?.length || 0).keys()), e.config.row_pivots = Array.from(Array(r?.[0]?.length || 0).keys());
        let S = this._column_sizes.indices[(this._row_headers_length || 0) + Math.floor(o.start_col)] || 0, p = {
            viewport_width: 0,
            selected_id: i,
            ridx_offset: g,
            sub_cell_offset: S,
            x0: x,
            x1: Z,
            y1: h,
            row_height: this._column_sizes.row_height,
            row_headers_length: this._row_headers_length
        }, z, y = 0, C = [], F = !0;
        if (r?.length > 0) {
            let v = f.row_pivots.join(","), $ = {
                column_name: v,
                cidx: 0,
                column_data: r,
                row_headers: r,
                first_col: F
            }, N = y + Math.floor(x);
            z = this.body.draw(a, $, {
                ...p,
                x0: 0
            }, !0, void 0, void 0, N, m);
            let X = [];
            for(let M = 0; M < e.config.row_pivots.length; M++){
                let W = this.header.draw(v, Array(e.config.column_pivots.length).fill(""), 1, void 0, M, x, M, u, E);
                W && X.push(W);
            }
            if (F = !1, p.viewport_width += X.reduce((M, { th: W }, R)=>M + (this._column_sizes.indices[R] || W.offsetWidth), 0), p.row_height = p.row_height || z.row_height, y = r[0].length, !s) for(let M = 0; M < e.config.row_pivots.length; M++){
                let { td: W, metadata: R } = z.tds[M] || {}, { th: B, metadata: G } = X[M] || {};
                (W || B) && C.push([
                    B || W,
                    G || R
                ]);
            }
        }
        try {
            let v = 0, $ = l - o.start_col;
            for(; v < $;){
                if (!n[v]) {
                    let H = Math.max(o.end_col, 0);
                    o.start_col = H;
                    let P = 0, tt = 0;
                    for(; this._column_sizes.indices.length > y + x + P + 1 && tt + p.viewport_width < _;)P++, tt += this._column_sizes.indices[y + x + P];
                    if (tt + p.viewport_width < _) {
                        let k = Math.min(l, H + 5);
                        o.end_col = Math.max(1, Math.min(l, k));
                    } else o.end_col = Math.max(1, Math.min(l, H + P));
                    let ut = d(Math.floor(o.start_col), Math.floor(o.start_row), Math.ceil(o.end_col), Math.ceil(o.end_row));
                    yield void 0;
                    let L = await ut;
                    if (typeof L.column_header_merge_depth < "u" && (u = L.column_header_merge_depth), typeof L.merge_headers < "u" && (A = L.merge_headers), L.data.length === 0) {
                        yield C;
                        return;
                    }
                    o.end_col = o.start_col + L.data.length;
                    for(let k = 0; k < L.data.length; k++)n[v + k] = L.data[k], L.metadata && (b[v + k] = L.metadata[k]), w && (w[v + k] = L.column_headers?.[k]);
                }
                let N = w?.[v] || "", X = n[v], M = b?.[v], W = {
                    column_name: N,
                    cidx: y,
                    column_data: X,
                    column_data_listener_metadata: M,
                    row_headers: r,
                    first_col: F
                }, R = v + x, B = y + Math.floor(x), G = this.header.draw(void 0, N, void 0, R, B, x, y, u, E);
                if (z = this.body.draw(a, W, p, !1, R, x, B, m), F = !1, !s) for (let { td: H, metadata: P } of z.tds)C.push([
                    G?.th || H,
                    G?.metadata || P
                ]);
                let ot = this._column_sizes.indices[y + Math.floor(x)];
                if (ot ? p.viewport_width += ot : p.viewport_width += G?.th?.offsetWidth || z.tds.reduce((H, P)=>H + P.td?.offsetWidth, 0), p.row_height = p.row_height || z.row_height, y++, v++, p.viewport_width - p.sub_cell_offset > _) {
                    this.body.clean({
                        ridx: z?.ridx || 0,
                        cidx: y
                    }), this.header.clean(), yield C, p.viewport_width = 0;
                    for (let [H] of C)p.viewport_width += H.offsetWidth;
                    if (p.viewport_width - p.sub_cell_offset > _) return;
                }
            }
            this.body.clean({
                ridx: z?.ridx || 0,
                cidx: y
            }), this.header.clean(), yield C;
        } finally{
            this.body.clean({
                ridx: z?.ridx || 0,
                cidx: y
            }), this.header.clean(), this.body._span_factory.reset(), this.header._span_factory.reset();
        }
    }
};
var vt = [
    "both",
    "horizontal",
    "vertical",
    "none"
], st = class extends K {
    constructor(){
        super(), this._column_sizes = {
            auto: [],
            override: [],
            indices: []
        }, this._style_callbacks = [], this._initialized = !1;
    }
    connectedCallback() {
        this._initialized || (this.create_shadow_dom(), this.register_listeners(), this.setAttribute("tabindex", "0"), this._initialized = !0, this.table_model = new V(this._table_clip, this._column_sizes, this));
    }
    _reset_viewport() {
        this._start_row = void 0, this._end_row = void 0, this._start_col = void 0, this._end_col = void 0;
    }
    _reset_scroll() {
        this._column_sizes.indices = [], this.scrollTop = 0, this.scrollLeft = 0, this._reset_viewport();
    }
    _resetAutoSize() {
        this._column_sizes.auto = [], this._column_sizes.override = [], this._column_sizes.indices = [];
        for(let t = 0; t < this.table_model.header.num_columns(); t++){
            let e = this.table_model.header.get_column_header(t);
            e.style.minWidth = "", e.style.maxWidth = "";
        }
    }
    clear() {
        this.table_model = new V(this._table_clip, this._column_sizes, this);
    }
    addStyleListener(t) {
        this._style_callbacks = this._style_callbacks.concat(t);
        let e = !0;
        return ()=>{
            if (!e) return;
            e = !1;
            let s = this._style_callbacks = this._style_callbacks.slice(), o = s.indexOf(t);
            s.splice(o, 1);
        };
    }
    invalidate() {
        if (!this._is_styling) throw new Error("Cannot call `invalidate()` outside of a `StyleListener`");
        this._invalidated = !0;
    }
    getMeta(t) {
        if (!(typeof t > "u")) {
            if (t instanceof HTMLElement) return T.get(t);
            if (t.row_header_x >= 0) {
                if (t.row_header_x < this._view_cache.config.row_pivots.length) {
                    let e = this.table_model.body._fetch_cell(t.y, t.row_header_x);
                    return this.getMeta(e);
                }
            } else if (t.column_header_y >= 0) {
                if (t.column_header_y < this._view_cache.config.column_pivots.length) {
                    let e = this.table_model.body._fetch_cell(t.column_header_y, t.y);
                    return this.getMeta(e);
                }
            } else return this.getMeta(this.table_model.body._fetch_cell(t.dy, t.dx + this.table_model._row_headers_length));
        }
    }
    getDrawFPS() {
        return _t();
    }
    async scrollToCell(t, e) {
        if (!this._view_cache) {
            console.warn("data listener not configured");
            return;
        }
        let i = this._column_sizes.row_height || 19, s = this._view_cache.config.column_pivots.length * i, l = (this._table_clip.offsetHeight - s) % i, _ = (this._virtual_panel.offsetHeight - l) / this._nrows;
        this.scrollTop = Math.ceil(_ * e);
        let a = 0;
        for(; t > 0;)t--, a += this._column_sizes.indices[t + this._view_cache.config.row_pivots.length] || 60;
        this.scrollLeft = Math.ceil(a), await new Promise(requestAnimationFrame), await this._draw_flush();
    }
    setDataListener(t, { virtual_mode: e = "both" } = {}) {
        let i = {}, s = {
            row_pivots: [],
            column_pivots: []
        };
        console.assert(vt.indexOf(e) > -1, `Unknown virtual_mode ${e};  valid options are "both" (default), "horizontal", "vertical" or "none"`), this._virtual_mode = e, this._invalid_schema = !0, this._view_cache = {
            view: t,
            config: s,
            schema: i
        }, this._setup_virtual_scroll();
    }
    __noop_jsdoc_hints() {}
};
document.createElement("regular-table").constructor === HTMLElement && window.customElements.define("regular-table", st);

},{}],"5QOZM":[function(require,module,exports) {
/**
 * @license
 *
 * chroma.js - JavaScript library for color conversions
 * 
 * Copyright (c) 2011-2017, Gregor Aisch
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 * 
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 * 
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 *    derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */ (function() {
    var Color, DEG2RAD, LAB_CONSTANTS, PI, PITHIRD, RAD2DEG, TWOPI, _average_lrgb, _guess_formats, _guess_formats_sorted, _input, _interpolators, abs, atan2, bezier, blend, blend_f, brewer, burn, chroma, clip_rgb, cmyk2rgb, colors, cos, css2rgb, darken, dodge, each, floor, hcg2rgb, hex2rgb, hsi2rgb, hsl2css, hsl2rgb, hsv2rgb, interpolate, interpolate_hsx, interpolate_lab, interpolate_lrgb, interpolate_num, interpolate_rgb, lab2lch, lab2rgb, lab_xyz, lch2lab, lch2rgb, lighten, limit, log, luminance_x, m, max, multiply, normal, num2rgb, overlay, pow, rgb2cmyk, rgb2css, rgb2hcg, rgb2hex, rgb2hsi, rgb2hsl, rgb2hsv, rgb2lab, rgb2lch, rgb2luminance, rgb2num, rgb2temperature, rgb2xyz, rgb_xyz, rnd, root, round, screen, sin, sqrt, temperature2rgb, type, unpack, w3cx11, xyz_lab, xyz_rgb, slice = [].slice;
    type = function() {
        /*
    for browser-safe type checking+
    ported from jQuery's $.type
     */ var classToType, len, name, o, ref;
        classToType = {};
        ref = "Boolean Number String Function Array Date RegExp Undefined Null".split(" ");
        for(o = 0, len = ref.length; o < len; o++){
            name = ref[o];
            classToType["[object " + name + "]"] = name.toLowerCase();
        }
        return function(obj) {
            var strType;
            strType = Object.prototype.toString.call(obj);
            return classToType[strType] || "object";
        };
    }();
    limit = function(x, min, max) {
        if (min == null) min = 0;
        if (max == null) max = 1;
        if (x < min) x = min;
        if (x > max) x = max;
        return x;
    };
    unpack = function(args) {
        if (args.length >= 3) return Array.prototype.slice.call(args);
        else return args[0];
    };
    clip_rgb = function(rgb) {
        var i, o;
        rgb._clipped = false;
        rgb._unclipped = rgb.slice(0);
        for(i = o = 0; o < 3; i = ++o){
            if (i < 3) {
                if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
                if (rgb[i] < 0) rgb[i] = 0;
                if (rgb[i] > 255) rgb[i] = 255;
            } else if (i === 3) {
                if (rgb[i] < 0) rgb[i] = 0;
                if (rgb[i] > 1) rgb[i] = 1;
            }
        }
        if (!rgb._clipped) delete rgb._unclipped;
        return rgb;
    };
    PI = Math.PI, round = Math.round, cos = Math.cos, floor = Math.floor, pow = Math.pow, log = Math.log, sin = Math.sin, sqrt = Math.sqrt, atan2 = Math.atan2, max = Math.max, abs = Math.abs;
    TWOPI = PI * 2;
    PITHIRD = PI / 3;
    DEG2RAD = PI / 180;
    RAD2DEG = 180 / PI;
    chroma = function() {
        if (arguments[0] instanceof Color) return arguments[0];
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, arguments, function() {});
    };
    chroma["default"] = chroma;
    _interpolators = [];
    if (module !== null && module.exports != null) module.exports = chroma;
    if (typeof define === "function" && define.amd) define([], function() {
        return chroma;
    });
    else {
        root = exports !== null ? exports : this;
        root.chroma = chroma;
    }
    chroma.version = "1.4.1";
    _input = {};
    _guess_formats = [];
    _guess_formats_sorted = false;
    Color = function() {
        function Color() {
            var arg, args, chk, len, len1, me, mode, o, w;
            me = this;
            args = [];
            for(o = 0, len = arguments.length; o < len; o++){
                arg = arguments[o];
                if (arg != null) args.push(arg);
            }
            if (args.length > 1) mode = args[args.length - 1];
            if (_input[mode] != null) me._rgb = clip_rgb(_input[mode](unpack(args.slice(0, -1))));
            else {
                if (!_guess_formats_sorted) {
                    _guess_formats = _guess_formats.sort(function(a, b) {
                        return b.p - a.p;
                    });
                    _guess_formats_sorted = true;
                }
                for(w = 0, len1 = _guess_formats.length; w < len1; w++){
                    chk = _guess_formats[w];
                    mode = chk.test.apply(chk, args);
                    if (mode) break;
                }
                if (mode) me._rgb = clip_rgb(_input[mode].apply(_input, args));
            }
            if (me._rgb == null) console.warn("unknown format: " + args);
            if (me._rgb == null) me._rgb = [
                0,
                0,
                0
            ];
            if (me._rgb.length === 3) me._rgb.push(1);
        }
        Color.prototype.toString = function() {
            return this.hex();
        };
        return Color;
    }();
    chroma._input = _input;
    /**
  	ColorBrewer colors for chroma.js
  
  	Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The 
  	Pennsylvania State University.
  
  	Licensed under the Apache License, Version 2.0 (the "License"); 
  	you may not use this file except in compliance with the License.
  	You may obtain a copy of the License at	
  	http://www.apache.org/licenses/LICENSE-2.0
  
  	Unless required by applicable law or agreed to in writing, software distributed
  	under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  	CONDITIONS OF ANY KIND, either express or implied. See the License for the
  	specific language governing permissions and limitations under the License.
  
      @preserve
   */ chroma.brewer = brewer = {
        OrRd: [
            "#fff7ec",
            "#fee8c8",
            "#fdd49e",
            "#fdbb84",
            "#fc8d59",
            "#ef6548",
            "#d7301f",
            "#b30000",
            "#7f0000"
        ],
        PuBu: [
            "#fff7fb",
            "#ece7f2",
            "#d0d1e6",
            "#a6bddb",
            "#74a9cf",
            "#3690c0",
            "#0570b0",
            "#045a8d",
            "#023858"
        ],
        BuPu: [
            "#f7fcfd",
            "#e0ecf4",
            "#bfd3e6",
            "#9ebcda",
            "#8c96c6",
            "#8c6bb1",
            "#88419d",
            "#810f7c",
            "#4d004b"
        ],
        Oranges: [
            "#fff5eb",
            "#fee6ce",
            "#fdd0a2",
            "#fdae6b",
            "#fd8d3c",
            "#f16913",
            "#d94801",
            "#a63603",
            "#7f2704"
        ],
        BuGn: [
            "#f7fcfd",
            "#e5f5f9",
            "#ccece6",
            "#99d8c9",
            "#66c2a4",
            "#41ae76",
            "#238b45",
            "#006d2c",
            "#00441b"
        ],
        YlOrBr: [
            "#ffffe5",
            "#fff7bc",
            "#fee391",
            "#fec44f",
            "#fe9929",
            "#ec7014",
            "#cc4c02",
            "#993404",
            "#662506"
        ],
        YlGn: [
            "#ffffe5",
            "#f7fcb9",
            "#d9f0a3",
            "#addd8e",
            "#78c679",
            "#41ab5d",
            "#238443",
            "#006837",
            "#004529"
        ],
        Reds: [
            "#fff5f0",
            "#fee0d2",
            "#fcbba1",
            "#fc9272",
            "#fb6a4a",
            "#ef3b2c",
            "#cb181d",
            "#a50f15",
            "#67000d"
        ],
        RdPu: [
            "#fff7f3",
            "#fde0dd",
            "#fcc5c0",
            "#fa9fb5",
            "#f768a1",
            "#dd3497",
            "#ae017e",
            "#7a0177",
            "#49006a"
        ],
        Greens: [
            "#f7fcf5",
            "#e5f5e0",
            "#c7e9c0",
            "#a1d99b",
            "#74c476",
            "#41ab5d",
            "#238b45",
            "#006d2c",
            "#00441b"
        ],
        YlGnBu: [
            "#ffffd9",
            "#edf8b1",
            "#c7e9b4",
            "#7fcdbb",
            "#41b6c4",
            "#1d91c0",
            "#225ea8",
            "#253494",
            "#081d58"
        ],
        Purples: [
            "#fcfbfd",
            "#efedf5",
            "#dadaeb",
            "#bcbddc",
            "#9e9ac8",
            "#807dba",
            "#6a51a3",
            "#54278f",
            "#3f007d"
        ],
        GnBu: [
            "#f7fcf0",
            "#e0f3db",
            "#ccebc5",
            "#a8ddb5",
            "#7bccc4",
            "#4eb3d3",
            "#2b8cbe",
            "#0868ac",
            "#084081"
        ],
        Greys: [
            "#ffffff",
            "#f0f0f0",
            "#d9d9d9",
            "#bdbdbd",
            "#969696",
            "#737373",
            "#525252",
            "#252525",
            "#000000"
        ],
        YlOrRd: [
            "#ffffcc",
            "#ffeda0",
            "#fed976",
            "#feb24c",
            "#fd8d3c",
            "#fc4e2a",
            "#e31a1c",
            "#bd0026",
            "#800026"
        ],
        PuRd: [
            "#f7f4f9",
            "#e7e1ef",
            "#d4b9da",
            "#c994c7",
            "#df65b0",
            "#e7298a",
            "#ce1256",
            "#980043",
            "#67001f"
        ],
        Blues: [
            "#f7fbff",
            "#deebf7",
            "#c6dbef",
            "#9ecae1",
            "#6baed6",
            "#4292c6",
            "#2171b5",
            "#08519c",
            "#08306b"
        ],
        PuBuGn: [
            "#fff7fb",
            "#ece2f0",
            "#d0d1e6",
            "#a6bddb",
            "#67a9cf",
            "#3690c0",
            "#02818a",
            "#016c59",
            "#014636"
        ],
        Viridis: [
            "#440154",
            "#482777",
            "#3f4a8a",
            "#31678e",
            "#26838f",
            "#1f9d8a",
            "#6cce5a",
            "#b6de2b",
            "#fee825"
        ],
        Spectral: [
            "#9e0142",
            "#d53e4f",
            "#f46d43",
            "#fdae61",
            "#fee08b",
            "#ffffbf",
            "#e6f598",
            "#abdda4",
            "#66c2a5",
            "#3288bd",
            "#5e4fa2"
        ],
        RdYlGn: [
            "#a50026",
            "#d73027",
            "#f46d43",
            "#fdae61",
            "#fee08b",
            "#ffffbf",
            "#d9ef8b",
            "#a6d96a",
            "#66bd63",
            "#1a9850",
            "#006837"
        ],
        RdBu: [
            "#67001f",
            "#b2182b",
            "#d6604d",
            "#f4a582",
            "#fddbc7",
            "#f7f7f7",
            "#d1e5f0",
            "#92c5de",
            "#4393c3",
            "#2166ac",
            "#053061"
        ],
        PiYG: [
            "#8e0152",
            "#c51b7d",
            "#de77ae",
            "#f1b6da",
            "#fde0ef",
            "#f7f7f7",
            "#e6f5d0",
            "#b8e186",
            "#7fbc41",
            "#4d9221",
            "#276419"
        ],
        PRGn: [
            "#40004b",
            "#762a83",
            "#9970ab",
            "#c2a5cf",
            "#e7d4e8",
            "#f7f7f7",
            "#d9f0d3",
            "#a6dba0",
            "#5aae61",
            "#1b7837",
            "#00441b"
        ],
        RdYlBu: [
            "#a50026",
            "#d73027",
            "#f46d43",
            "#fdae61",
            "#fee090",
            "#ffffbf",
            "#e0f3f8",
            "#abd9e9",
            "#74add1",
            "#4575b4",
            "#313695"
        ],
        BrBG: [
            "#543005",
            "#8c510a",
            "#bf812d",
            "#dfc27d",
            "#f6e8c3",
            "#f5f5f5",
            "#c7eae5",
            "#80cdc1",
            "#35978f",
            "#01665e",
            "#003c30"
        ],
        RdGy: [
            "#67001f",
            "#b2182b",
            "#d6604d",
            "#f4a582",
            "#fddbc7",
            "#ffffff",
            "#e0e0e0",
            "#bababa",
            "#878787",
            "#4d4d4d",
            "#1a1a1a"
        ],
        PuOr: [
            "#7f3b08",
            "#b35806",
            "#e08214",
            "#fdb863",
            "#fee0b6",
            "#f7f7f7",
            "#d8daeb",
            "#b2abd2",
            "#8073ac",
            "#542788",
            "#2d004b"
        ],
        Set2: [
            "#66c2a5",
            "#fc8d62",
            "#8da0cb",
            "#e78ac3",
            "#a6d854",
            "#ffd92f",
            "#e5c494",
            "#b3b3b3"
        ],
        Accent: [
            "#7fc97f",
            "#beaed4",
            "#fdc086",
            "#ffff99",
            "#386cb0",
            "#f0027f",
            "#bf5b17",
            "#666666"
        ],
        Set1: [
            "#e41a1c",
            "#377eb8",
            "#4daf4a",
            "#984ea3",
            "#ff7f00",
            "#ffff33",
            "#a65628",
            "#f781bf",
            "#999999"
        ],
        Set3: [
            "#8dd3c7",
            "#ffffb3",
            "#bebada",
            "#fb8072",
            "#80b1d3",
            "#fdb462",
            "#b3de69",
            "#fccde5",
            "#d9d9d9",
            "#bc80bd",
            "#ccebc5",
            "#ffed6f"
        ],
        Dark2: [
            "#1b9e77",
            "#d95f02",
            "#7570b3",
            "#e7298a",
            "#66a61e",
            "#e6ab02",
            "#a6761d",
            "#666666"
        ],
        Paired: [
            "#a6cee3",
            "#1f78b4",
            "#b2df8a",
            "#33a02c",
            "#fb9a99",
            "#e31a1c",
            "#fdbf6f",
            "#ff7f00",
            "#cab2d6",
            "#6a3d9a",
            "#ffff99",
            "#b15928"
        ],
        Pastel2: [
            "#b3e2cd",
            "#fdcdac",
            "#cbd5e8",
            "#f4cae4",
            "#e6f5c9",
            "#fff2ae",
            "#f1e2cc",
            "#cccccc"
        ],
        Pastel1: [
            "#fbb4ae",
            "#b3cde3",
            "#ccebc5",
            "#decbe4",
            "#fed9a6",
            "#ffffcc",
            "#e5d8bd",
            "#fddaec",
            "#f2f2f2"
        ]
    };
    (function() {
        var key, results;
        results = [];
        for(key in brewer)results.push(brewer[key.toLowerCase()] = brewer[key]);
        return results;
    })();
    /**
  	X11 color names
  
  	http://www.w3.org/TR/css3-color/#svg-color
   */ w3cx11 = {
        aliceblue: "#f0f8ff",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueviolet: "#8a2be2",
        brown: "#a52a2a",
        burlywood: "#deb887",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        cornflower: "#6495ed",
        cornflowerblue: "#6495ed",
        cornsilk: "#fff8dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkseagreen: "#8fbc8f",
        darkslateblue: "#483d8b",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        darkturquoise: "#00ced1",
        darkviolet: "#9400d3",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1e90ff",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        forestgreen: "#228b22",
        fuchsia: "#ff00ff",
        gainsboro: "#dcdcdc",
        ghostwhite: "#f8f8ff",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#adff2f",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        laserlemon: "#ffff54",
        lavender: "#e6e6fa",
        lavenderblush: "#fff0f5",
        lawngreen: "#7cfc00",
        lemonchiffon: "#fffacd",
        lightblue: "#add8e6",
        lightcoral: "#f08080",
        lightcyan: "#e0ffff",
        lightgoldenrod: "#fafad2",
        lightgoldenrodyellow: "#fafad2",
        lightgray: "#d3d3d3",
        lightgreen: "#90ee90",
        lightgrey: "#d3d3d3",
        lightpink: "#ffb6c1",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        lightskyblue: "#87cefa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#b0c4de",
        lightyellow: "#ffffe0",
        lime: "#00ff00",
        limegreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        maroon2: "#7f0000",
        maroon3: "#b03060",
        mediumaquamarine: "#66cdaa",
        mediumblue: "#0000cd",
        mediumorchid: "#ba55d3",
        mediumpurple: "#9370db",
        mediumseagreen: "#3cb371",
        mediumslateblue: "#7b68ee",
        mediumspringgreen: "#00fa9a",
        mediumturquoise: "#48d1cc",
        mediumvioletred: "#c71585",
        midnightblue: "#191970",
        mintcream: "#f5fffa",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        navajowhite: "#ffdead",
        navy: "#000080",
        oldlace: "#fdf5e6",
        olive: "#808000",
        olivedrab: "#6b8e23",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        palegoldenrod: "#eee8aa",
        palegreen: "#98fb98",
        paleturquoise: "#afeeee",
        palevioletred: "#db7093",
        papayawhip: "#ffefd5",
        peachpuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderblue: "#b0e0e6",
        purple: "#800080",
        purple2: "#7f007f",
        purple3: "#a020f0",
        rebeccapurple: "#663399",
        red: "#ff0000",
        rosybrown: "#bc8f8f",
        royalblue: "#4169e1",
        saddlebrown: "#8b4513",
        salmon: "#fa8072",
        sandybrown: "#f4a460",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyblue: "#87ceeb",
        slateblue: "#6a5acd",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#fffafa",
        springgreen: "#00ff7f",
        steelblue: "#4682b4",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        tomato: "#ff6347",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whitesmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowgreen: "#9acd32"
    };
    chroma.colors = colors = w3cx11;
    lab2rgb = function() {
        var a, args, b, g, l, r, x, y, z;
        args = unpack(arguments);
        l = args[0], a = args[1], b = args[2];
        y = (l + 16) / 116;
        x = isNaN(a) ? y : y + a / 500;
        z = isNaN(b) ? y : y - b / 200;
        y = LAB_CONSTANTS.Yn * lab_xyz(y);
        x = LAB_CONSTANTS.Xn * lab_xyz(x);
        z = LAB_CONSTANTS.Zn * lab_xyz(z);
        r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);
        g = xyz_rgb(-0.969266 * x + 1.8760108 * y + 0.0415560 * z);
        b = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    xyz_rgb = function(r) {
        return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow(r, 1 / 2.4) - 0.055);
    };
    lab_xyz = function(t) {
        if (t > LAB_CONSTANTS.t1) return t * t * t;
        else return LAB_CONSTANTS.t2 * (t - LAB_CONSTANTS.t0);
    };
    LAB_CONSTANTS = {
        Kn: 18,
        Xn: 0.950470,
        Yn: 1,
        Zn: 1.088830,
        t0: 0.137931034,
        t1: 0.206896552,
        t2: 0.12841855,
        t3: 0.008856452
    };
    rgb2lab = function() {
        var b, g, r, ref, ref1, x, y, z;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        ref1 = rgb2xyz(r, g, b), x = ref1[0], y = ref1[1], z = ref1[2];
        return [
            116 * y - 16,
            500 * (x - y),
            200 * (y - z)
        ];
    };
    rgb_xyz = function(r) {
        if ((r /= 255) <= 0.04045) return r / 12.92;
        else return pow((r + 0.055) / 1.055, 2.4);
    };
    xyz_lab = function(t) {
        if (t > LAB_CONSTANTS.t3) return pow(t, 1 / 3);
        else return t / LAB_CONSTANTS.t2 + LAB_CONSTANTS.t0;
    };
    rgb2xyz = function() {
        var b, g, r, ref, x, y, z;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        r = rgb_xyz(r);
        g = rgb_xyz(g);
        b = rgb_xyz(b);
        x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / LAB_CONSTANTS.Xn);
        y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / LAB_CONSTANTS.Yn);
        z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / LAB_CONSTANTS.Zn);
        return [
            x,
            y,
            z
        ];
    };
    chroma.lab = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "lab"
        ]), function() {});
    };
    _input.lab = lab2rgb;
    Color.prototype.lab = function() {
        return rgb2lab(this._rgb);
    };
    bezier = function(colors) {
        var I, I0, I1, c, lab0, lab1, lab2, lab3, ref, ref1, ref2;
        colors = function() {
            var len, o, results;
            results = [];
            for(o = 0, len = colors.length; o < len; o++){
                c = colors[o];
                results.push(chroma(c));
            }
            return results;
        }();
        if (colors.length === 2) {
            ref = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = colors.length; o < len; o++){
                    c = colors[o];
                    results.push(c.lab());
                }
                return results;
            }(), lab0 = ref[0], lab1 = ref[1];
            I = function(t) {
                var i, lab;
                lab = function() {
                    var o, results;
                    results = [];
                    for(i = o = 0; o <= 2; i = ++o)results.push(lab0[i] + t * (lab1[i] - lab0[i]));
                    return results;
                }();
                return chroma.lab.apply(chroma, lab);
            };
        } else if (colors.length === 3) {
            ref1 = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = colors.length; o < len; o++){
                    c = colors[o];
                    results.push(c.lab());
                }
                return results;
            }(), lab0 = ref1[0], lab1 = ref1[1], lab2 = ref1[2];
            I = function(t) {
                var i, lab;
                lab = function() {
                    var o, results;
                    results = [];
                    for(i = o = 0; o <= 2; i = ++o)results.push((1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
                    return results;
                }();
                return chroma.lab.apply(chroma, lab);
            };
        } else if (colors.length === 4) {
            ref2 = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = colors.length; o < len; o++){
                    c = colors[o];
                    results.push(c.lab());
                }
                return results;
            }(), lab0 = ref2[0], lab1 = ref2[1], lab2 = ref2[2], lab3 = ref2[3];
            I = function(t) {
                var i, lab;
                lab = function() {
                    var o, results;
                    results = [];
                    for(i = o = 0; o <= 2; i = ++o)results.push((1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
                    return results;
                }();
                return chroma.lab.apply(chroma, lab);
            };
        } else if (colors.length === 5) {
            I0 = bezier(colors.slice(0, 3));
            I1 = bezier(colors.slice(2, 5));
            I = function(t) {
                if (t < 0.5) return I0(t * 2);
                else return I1((t - 0.5) * 2);
            };
        }
        return I;
    };
    chroma.bezier = function(colors) {
        var f;
        f = bezier(colors);
        f.scale = function() {
            return chroma.scale(f);
        };
        return f;
    };
    chroma.cubehelix = function(start, rotations, hue, gamma, lightness) {
        var dh, dl, f;
        if (start == null) start = 300;
        if (rotations == null) rotations = -1.5;
        if (hue == null) hue = 1;
        if (gamma == null) gamma = 1;
        if (lightness == null) lightness = [
            0,
            1
        ];
        dh = 0;
        if (type(lightness) === "array") dl = lightness[1] - lightness[0];
        else {
            dl = 0;
            lightness = [
                lightness,
                lightness
            ];
        }
        f = function(fract) {
            var a, amp, b, cos_a, g, h, l, r, sin_a;
            a = TWOPI * ((start + 120) / 360 + rotations * fract);
            l = pow(lightness[0] + dl * fract, gamma);
            h = dh !== 0 ? hue[0] + fract * dh : hue;
            amp = h * l * (1 - l) / 2;
            cos_a = cos(a);
            sin_a = sin(a);
            r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
            g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
            b = l + amp * (1.97294 * cos_a);
            return chroma(clip_rgb([
                r * 255,
                g * 255,
                b * 255,
                1
            ]));
        };
        f.start = function(s) {
            if (s == null) return start;
            start = s;
            return f;
        };
        f.rotations = function(r) {
            if (r == null) return rotations;
            rotations = r;
            return f;
        };
        f.gamma = function(g) {
            if (g == null) return gamma;
            gamma = g;
            return f;
        };
        f.hue = function(h) {
            if (h == null) return hue;
            hue = h;
            if (type(hue) === "array") {
                dh = hue[1] - hue[0];
                if (dh === 0) hue = hue[1];
            } else dh = 0;
            return f;
        };
        f.lightness = function(h) {
            if (h == null) return lightness;
            if (type(h) === "array") {
                lightness = h;
                dl = h[1] - h[0];
            } else {
                lightness = [
                    h,
                    h
                ];
                dl = 0;
            }
            return f;
        };
        f.scale = function() {
            return chroma.scale(f);
        };
        f.hue(hue);
        return f;
    };
    chroma.random = function() {
        var code, digits, i, o;
        digits = "0123456789abcdef";
        code = "#";
        for(i = o = 0; o < 6; i = ++o)code += digits.charAt(floor(Math.random() * 16));
        return new Color(code);
    };
    _interpolators = [];
    interpolate = function(col1, col2, f, m) {
        var interpol, len, o, res;
        if (f == null) f = 0.5;
        if (m == null) m = "rgb";
        /*
    interpolates between colors
    f = 0 --> me
    f = 1 --> col
     */ if (type(col1) !== "object") col1 = chroma(col1);
        if (type(col2) !== "object") col2 = chroma(col2);
        for(o = 0, len = _interpolators.length; o < len; o++){
            interpol = _interpolators[o];
            if (m === interpol[0]) {
                res = interpol[1](col1, col2, f, m);
                break;
            }
        }
        if (res == null) throw "color mode " + m + " is not supported";
        return res.alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
    };
    chroma.interpolate = interpolate;
    Color.prototype.interpolate = function(col2, f, m) {
        return interpolate(this, col2, f, m);
    };
    chroma.mix = interpolate;
    Color.prototype.mix = Color.prototype.interpolate;
    _input.rgb = function() {
        var k, ref, results, v;
        ref = unpack(arguments);
        results = [];
        for(k in ref){
            v = ref[k];
            results.push(v);
        }
        return results;
    };
    chroma.rgb = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "rgb"
        ]), function() {});
    };
    Color.prototype.rgb = function(round) {
        if (round == null) round = true;
        if (round) return this._rgb.map(Math.round).slice(0, 3);
        else return this._rgb.slice(0, 3);
    };
    Color.prototype.rgba = function(round) {
        if (round == null) round = true;
        if (!round) return this._rgb.slice(0);
        return [
            Math.round(this._rgb[0]),
            Math.round(this._rgb[1]),
            Math.round(this._rgb[2]),
            this._rgb[3]
        ];
    };
    _guess_formats.push({
        p: 3,
        test: function(n) {
            var a;
            a = unpack(arguments);
            if (type(a) === "array" && a.length === 3) return "rgb";
            if (a.length === 4 && type(a[3]) === "number" && a[3] >= 0 && a[3] <= 1) return "rgb";
        }
    });
    _input.lrgb = _input.rgb;
    interpolate_lrgb = function(col1, col2, f, m) {
        var xyz0, xyz1;
        xyz0 = col1._rgb;
        xyz1 = col2._rgb;
        return new Color(sqrt(pow(xyz0[0], 2) * (1 - f) + pow(xyz1[0], 2) * f), sqrt(pow(xyz0[1], 2) * (1 - f) + pow(xyz1[1], 2) * f), sqrt(pow(xyz0[2], 2) * (1 - f) + pow(xyz1[2], 2) * f), m);
    };
    _average_lrgb = function(colors) {
        var col, f, len, o, rgb, xyz;
        f = 1 / colors.length;
        xyz = [
            0,
            0,
            0,
            0
        ];
        for(o = 0, len = colors.length; o < len; o++){
            col = colors[o];
            rgb = col._rgb;
            xyz[0] += pow(rgb[0], 2) * f;
            xyz[1] += pow(rgb[1], 2) * f;
            xyz[2] += pow(rgb[2], 2) * f;
            xyz[3] += rgb[3] * f;
        }
        xyz[0] = sqrt(xyz[0]);
        xyz[1] = sqrt(xyz[1]);
        xyz[2] = sqrt(xyz[2]);
        if (xyz[3] > 1) xyz[3] = 1;
        return new Color(clip_rgb(xyz));
    };
    _interpolators.push([
        "lrgb",
        interpolate_lrgb
    ]);
    chroma.average = function(colors, mode) {
        var A, alpha, c, cnt, dx, dy, first, i, l, len, o, xyz, xyz2;
        if (mode == null) mode = "rgb";
        l = colors.length;
        colors = colors.map(function(c) {
            return chroma(c);
        });
        first = colors.splice(0, 1)[0];
        if (mode === "lrgb") return _average_lrgb(colors);
        xyz = first.get(mode);
        cnt = [];
        dx = 0;
        dy = 0;
        for(i in xyz){
            xyz[i] = xyz[i] || 0;
            cnt.push(isNaN(xyz[i]) ? 0 : 1);
            if (mode.charAt(i) === "h" && !isNaN(xyz[i])) {
                A = xyz[i] / 180 * PI;
                dx += cos(A);
                dy += sin(A);
            }
        }
        alpha = first.alpha();
        for(o = 0, len = colors.length; o < len; o++){
            c = colors[o];
            xyz2 = c.get(mode);
            alpha += c.alpha();
            for(i in xyz)if (!isNaN(xyz2[i])) {
                cnt[i] += 1;
                if (mode.charAt(i) === "h") {
                    A = xyz2[i] / 180 * PI;
                    dx += cos(A);
                    dy += sin(A);
                } else xyz[i] += xyz2[i];
            }
        }
        for(i in xyz)if (mode.charAt(i) === "h") {
            A = atan2(dy / cnt[i], dx / cnt[i]) / PI * 180;
            while(A < 0)A += 360;
            while(A >= 360)A -= 360;
            xyz[i] = A;
        } else xyz[i] = xyz[i] / cnt[i];
        return chroma(xyz, mode).alpha(alpha / l);
    };
    hex2rgb = function(hex) {
        var a, b, g, r, rgb, u;
        if (hex.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
            if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
            if (hex.length === 3) {
                hex = hex.split("");
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            u = parseInt(hex, 16);
            r = u >> 16;
            g = u >> 8 & 0xFF;
            b = u & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        if (hex.match(/^#?([A-Fa-f0-9]{8})$/)) {
            if (hex.length === 9) hex = hex.substr(1);
            u = parseInt(hex, 16);
            r = u >> 24 & 0xFF;
            g = u >> 16 & 0xFF;
            b = u >> 8 & 0xFF;
            a = round((u & 0xFF) / 0xFF * 100) / 100;
            return [
                r,
                g,
                b,
                a
            ];
        }
        if (_input.css != null && (rgb = _input.css(hex))) return rgb;
        throw "unknown color: " + hex;
    };
    rgb2hex = function(channels, mode) {
        var a, b, g, hxa, r, str, u;
        if (mode == null) mode = "auto";
        r = channels[0], g = channels[1], b = channels[2], a = channels[3];
        if (mode === "auto") mode = a < 1 ? "rgba" : "rgb";
        r = Math.round(r);
        g = Math.round(g);
        b = Math.round(b);
        u = r << 16 | g << 8 | b;
        str = "000000" + u.toString(16);
        str = str.substr(str.length - 6);
        hxa = "0" + round(a * 255).toString(16);
        hxa = hxa.substr(hxa.length - 2);
        return "#" + function() {
            switch(mode.toLowerCase()){
                case "rgba":
                    return str + hxa;
                case "argb":
                    return hxa + str;
                default:
                    return str;
            }
        }();
    };
    _input.hex = function(h) {
        return hex2rgb(h);
    };
    chroma.hex = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "hex"
        ]), function() {});
    };
    Color.prototype.hex = function(mode) {
        if (mode == null) mode = "auto";
        return rgb2hex(this._rgb, mode);
    };
    _guess_formats.push({
        p: 4,
        test: function(n) {
            if (arguments.length === 1 && type(n) === "string") return "hex";
        }
    });
    hsl2rgb = function() {
        var args, b, c, g, h, i, l, o, r, ref, s, t1, t2, t3;
        args = unpack(arguments);
        h = args[0], s = args[1], l = args[2];
        if (s === 0) r = g = b = l * 255;
        else {
            t3 = [
                0,
                0,
                0
            ];
            c = [
                0,
                0,
                0
            ];
            t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
            t1 = 2 * l - t2;
            h /= 360;
            t3[0] = h + 1 / 3;
            t3[1] = h;
            t3[2] = h - 1 / 3;
            for(i = o = 0; o <= 2; i = ++o){
                if (t3[i] < 0) t3[i] += 1;
                if (t3[i] > 1) t3[i] -= 1;
                if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
                else if (2 * t3[i] < 1) c[i] = t2;
                else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
                else c[i] = t1;
            }
            ref = [
                round(c[0] * 255),
                round(c[1] * 255),
                round(c[2] * 255)
            ], r = ref[0], g = ref[1], b = ref[2];
        }
        if (args.length > 3) return [
            r,
            g,
            b,
            args[3]
        ];
        else return [
            r,
            g,
            b
        ];
    };
    rgb2hsl = function(r, g, b) {
        var h, l, min, ref, s;
        if (r !== void 0 && r.length >= 3) ref = r, r = ref[0], g = ref[1], b = ref[2];
        r /= 255;
        g /= 255;
        b /= 255;
        min = Math.min(r, g, b);
        max = Math.max(r, g, b);
        l = (max + min) / 2;
        if (max === min) {
            s = 0;
            h = Number.NaN;
        } else s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
        if (r === max) h = (g - b) / (max - min);
        else if (g === max) h = 2 + (b - r) / (max - min);
        else if (b === max) h = 4 + (r - g) / (max - min);
        h *= 60;
        if (h < 0) h += 360;
        return [
            h,
            s,
            l
        ];
    };
    chroma.hsl = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "hsl"
        ]), function() {});
    };
    _input.hsl = hsl2rgb;
    Color.prototype.hsl = function() {
        return rgb2hsl(this._rgb);
    };
    hsv2rgb = function() {
        var args, b, f, g, h, i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, s, t, v;
        args = unpack(arguments);
        h = args[0], s = args[1], v = args[2];
        v *= 255;
        if (s === 0) r = g = b = v;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            i = floor(h);
            f = h - i;
            p = v * (1 - s);
            q = v * (1 - s * f);
            t = v * (1 - s * (1 - f));
            switch(i){
                case 0:
                    ref = [
                        v,
                        t,
                        p
                    ], r = ref[0], g = ref[1], b = ref[2];
                    break;
                case 1:
                    ref1 = [
                        q,
                        v,
                        p
                    ], r = ref1[0], g = ref1[1], b = ref1[2];
                    break;
                case 2:
                    ref2 = [
                        p,
                        v,
                        t
                    ], r = ref2[0], g = ref2[1], b = ref2[2];
                    break;
                case 3:
                    ref3 = [
                        p,
                        q,
                        v
                    ], r = ref3[0], g = ref3[1], b = ref3[2];
                    break;
                case 4:
                    ref4 = [
                        t,
                        p,
                        v
                    ], r = ref4[0], g = ref4[1], b = ref4[2];
                    break;
                case 5:
                    ref5 = [
                        v,
                        p,
                        q
                    ], r = ref5[0], g = ref5[1], b = ref5[2];
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    rgb2hsv = function() {
        var b, delta, g, h, min, r, ref, s, v;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        min = Math.min(r, g, b);
        max = Math.max(r, g, b);
        delta = max - min;
        v = max / 255.0;
        if (max === 0) {
            h = Number.NaN;
            s = 0;
        } else {
            s = delta / max;
            if (r === max) h = (g - b) / delta;
            if (g === max) h = 2 + (b - r) / delta;
            if (b === max) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            s,
            v
        ];
    };
    chroma.hsv = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "hsv"
        ]), function() {});
    };
    _input.hsv = hsv2rgb;
    Color.prototype.hsv = function() {
        return rgb2hsv(this._rgb);
    };
    num2rgb = function(num) {
        var b, g, r;
        if (type(num) === "number" && num >= 0 && num <= 0xFFFFFF) {
            r = num >> 16;
            g = num >> 8 & 0xFF;
            b = num & 0xFF;
            return [
                r,
                g,
                b,
                1
            ];
        }
        console.warn("unknown num color: " + num);
        return [
            0,
            0,
            0,
            1
        ];
    };
    rgb2num = function() {
        var b, g, r, ref;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        return (r << 16) + (g << 8) + b;
    };
    chroma.num = function(num) {
        return new Color(num, "num");
    };
    Color.prototype.num = function(mode) {
        if (mode == null) mode = "rgb";
        return rgb2num(this._rgb, mode);
    };
    _input.num = num2rgb;
    _guess_formats.push({
        p: 1,
        test: function(n) {
            if (arguments.length === 1 && type(n) === "number" && n >= 0 && n <= 0xFFFFFF) return "num";
        }
    });
    hcg2rgb = function() {
        var _c, _g, args, b, c, f, g, h, i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, t, v;
        args = unpack(arguments);
        h = args[0], c = args[1], _g = args[2];
        c = c / 100;
        g = g / 100 * 255;
        _c = c * 255;
        if (c === 0) r = g = b = _g;
        else {
            if (h === 360) h = 0;
            if (h > 360) h -= 360;
            if (h < 0) h += 360;
            h /= 60;
            i = floor(h);
            f = h - i;
            p = _g * (1 - c);
            q = p + _c * (1 - f);
            t = p + _c * f;
            v = p + _c;
            switch(i){
                case 0:
                    ref = [
                        v,
                        t,
                        p
                    ], r = ref[0], g = ref[1], b = ref[2];
                    break;
                case 1:
                    ref1 = [
                        q,
                        v,
                        p
                    ], r = ref1[0], g = ref1[1], b = ref1[2];
                    break;
                case 2:
                    ref2 = [
                        p,
                        v,
                        t
                    ], r = ref2[0], g = ref2[1], b = ref2[2];
                    break;
                case 3:
                    ref3 = [
                        p,
                        q,
                        v
                    ], r = ref3[0], g = ref3[1], b = ref3[2];
                    break;
                case 4:
                    ref4 = [
                        t,
                        p,
                        v
                    ], r = ref4[0], g = ref4[1], b = ref4[2];
                    break;
                case 5:
                    ref5 = [
                        v,
                        p,
                        q
                    ], r = ref5[0], g = ref5[1], b = ref5[2];
            }
        }
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    rgb2hcg = function() {
        var _g, b, c, delta, g, h, min, r, ref;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        min = Math.min(r, g, b);
        max = Math.max(r, g, b);
        delta = max - min;
        c = delta * 100 / 255;
        _g = min / (255 - delta) * 100;
        if (delta === 0) h = Number.NaN;
        else {
            if (r === max) h = (g - b) / delta;
            if (g === max) h = 2 + (b - r) / delta;
            if (b === max) h = 4 + (r - g) / delta;
            h *= 60;
            if (h < 0) h += 360;
        }
        return [
            h,
            c,
            _g
        ];
    };
    chroma.hcg = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "hcg"
        ]), function() {});
    };
    _input.hcg = hcg2rgb;
    Color.prototype.hcg = function() {
        return rgb2hcg(this._rgb);
    };
    css2rgb = function(css) {
        var aa, ab, hsl, i, m, o, rgb, w;
        css = css.toLowerCase();
        if (chroma.colors != null && chroma.colors[css]) return hex2rgb(chroma.colors[css]);
        if (m = css.match(/rgb\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*\)/)) {
            rgb = m.slice(1, 4);
            for(i = o = 0; o <= 2; i = ++o)rgb[i] = +rgb[i];
            rgb[3] = 1;
        } else if (m = css.match(/rgba\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*,\s*([01]|[01]?\.\d+)\)/)) {
            rgb = m.slice(1, 5);
            for(i = w = 0; w <= 3; i = ++w)rgb[i] = +rgb[i];
        } else if (m = css.match(/rgb\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
            rgb = m.slice(1, 4);
            for(i = aa = 0; aa <= 2; i = ++aa)rgb[i] = round(rgb[i] * 2.55);
            rgb[3] = 1;
        } else if (m = css.match(/rgba\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
            rgb = m.slice(1, 5);
            for(i = ab = 0; ab <= 2; i = ++ab)rgb[i] = round(rgb[i] * 2.55);
            rgb[3] = +rgb[3];
        } else if (m = css.match(/hsl\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
            hsl = m.slice(1, 4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            rgb = hsl2rgb(hsl);
            rgb[3] = 1;
        } else if (m = css.match(/hsla\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
            hsl = m.slice(1, 4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            rgb = hsl2rgb(hsl);
            rgb[3] = +m[4];
        }
        return rgb;
    };
    rgb2css = function(rgba) {
        var mode;
        mode = rgba[3] < 1 ? "rgba" : "rgb";
        if (mode === "rgb") return mode + "(" + rgba.slice(0, 3).map(round).join(",") + ")";
        else if (mode === "rgba") return mode + "(" + rgba.slice(0, 3).map(round).join(",") + "," + rgba[3] + ")";
    };
    rnd = function(a) {
        return round(a * 100) / 100;
    };
    hsl2css = function(hsl, alpha) {
        var mode;
        mode = alpha < 1 ? "hsla" : "hsl";
        hsl[0] = rnd(hsl[0] || 0);
        hsl[1] = rnd(hsl[1] * 100) + "%";
        hsl[2] = rnd(hsl[2] * 100) + "%";
        if (mode === "hsla") hsl[3] = alpha;
        return mode + "(" + hsl.join(",") + ")";
    };
    _input.css = function(h) {
        return css2rgb(h);
    };
    chroma.css = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "css"
        ]), function() {});
    };
    Color.prototype.css = function(mode) {
        if (mode == null) mode = "rgb";
        if (mode.slice(0, 3) === "rgb") return rgb2css(this._rgb);
        else if (mode.slice(0, 3) === "hsl") return hsl2css(this.hsl(), this.alpha());
    };
    _input.named = function(name) {
        return hex2rgb(w3cx11[name]);
    };
    _guess_formats.push({
        p: 5,
        test: function(n) {
            if (arguments.length === 1 && w3cx11[n] != null) return "named";
        }
    });
    Color.prototype.name = function(n) {
        var h, k;
        if (arguments.length) {
            if (w3cx11[n]) this._rgb = hex2rgb(w3cx11[n]);
            this._rgb[3] = 1;
            this;
        }
        h = this.hex("rgb");
        for(k in w3cx11){
            if (h === w3cx11[k]) return k;
        }
        return h;
    };
    lch2lab = function() {
        /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.
    
    A saturation multiplier was added by Gregor Aisch
     */ var c, h, l, ref;
        ref = unpack(arguments), l = ref[0], c = ref[1], h = ref[2];
        h = h * DEG2RAD;
        return [
            l,
            cos(h) * c,
            sin(h) * c
        ];
    };
    lch2rgb = function() {
        var L, a, args, b, c, g, h, l, r, ref, ref1;
        args = unpack(arguments);
        l = args[0], c = args[1], h = args[2];
        ref = lch2lab(l, c, h), L = ref[0], a = ref[1], b = ref[2];
        ref1 = lab2rgb(L, a, b), r = ref1[0], g = ref1[1], b = ref1[2];
        return [
            r,
            g,
            b,
            args.length > 3 ? args[3] : 1
        ];
    };
    lab2lch = function() {
        var a, b, c, h, l, ref;
        ref = unpack(arguments), l = ref[0], a = ref[1], b = ref[2];
        c = sqrt(a * a + b * b);
        h = (atan2(b, a) * RAD2DEG + 360) % 360;
        if (round(c * 10000) === 0) h = Number.NaN;
        return [
            l,
            c,
            h
        ];
    };
    rgb2lch = function() {
        var a, b, g, l, r, ref, ref1;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        ref1 = rgb2lab(r, g, b), l = ref1[0], a = ref1[1], b = ref1[2];
        return lab2lch(l, a, b);
    };
    chroma.lch = function() {
        var args;
        args = unpack(arguments);
        return new Color(args, "lch");
    };
    chroma.hcl = function() {
        var args;
        args = unpack(arguments);
        return new Color(args, "hcl");
    };
    _input.lch = lch2rgb;
    _input.hcl = function() {
        var c, h, l, ref;
        ref = unpack(arguments), h = ref[0], c = ref[1], l = ref[2];
        return lch2rgb([
            l,
            c,
            h
        ]);
    };
    Color.prototype.lch = function() {
        return rgb2lch(this._rgb);
    };
    Color.prototype.hcl = function() {
        return rgb2lch(this._rgb).reverse();
    };
    rgb2cmyk = function(mode) {
        var b, c, f, g, k, m, r, ref, y;
        if (mode == null) mode = "rgb";
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        r = r / 255;
        g = g / 255;
        b = b / 255;
        k = 1 - Math.max(r, Math.max(g, b));
        f = k < 1 ? 1 / (1 - k) : 0;
        c = (1 - r - k) * f;
        m = (1 - g - k) * f;
        y = (1 - b - k) * f;
        return [
            c,
            m,
            y,
            k
        ];
    };
    cmyk2rgb = function() {
        var alpha, args, b, c, g, k, m, r, y;
        args = unpack(arguments);
        c = args[0], m = args[1], y = args[2], k = args[3];
        alpha = args.length > 4 ? args[4] : 1;
        if (k === 1) return [
            0,
            0,
            0,
            alpha
        ];
        r = c >= 1 ? 0 : 255 * (1 - c) * (1 - k);
        g = m >= 1 ? 0 : 255 * (1 - m) * (1 - k);
        b = y >= 1 ? 0 : 255 * (1 - y) * (1 - k);
        return [
            r,
            g,
            b,
            alpha
        ];
    };
    _input.cmyk = function() {
        return cmyk2rgb(unpack(arguments));
    };
    chroma.cmyk = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "cmyk"
        ]), function() {});
    };
    Color.prototype.cmyk = function() {
        return rgb2cmyk(this._rgb);
    };
    _input.gl = function() {
        var i, k, o, rgb, v;
        rgb = (function() {
            var ref, results;
            ref = unpack(arguments);
            results = [];
            for(k in ref){
                v = ref[k];
                results.push(v);
            }
            return results;
        }).apply(this, arguments);
        for(i = o = 0; o <= 2; i = ++o)rgb[i] *= 255;
        return rgb;
    };
    chroma.gl = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "gl"
        ]), function() {});
    };
    Color.prototype.gl = function() {
        var rgb;
        rgb = this._rgb;
        return [
            rgb[0] / 255,
            rgb[1] / 255,
            rgb[2] / 255,
            rgb[3]
        ];
    };
    rgb2luminance = function(r, g, b) {
        var ref;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        r = luminance_x(r);
        g = luminance_x(g);
        b = luminance_x(b);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };
    luminance_x = function(x) {
        x /= 255;
        if (x <= 0.03928) return x / 12.92;
        else return pow((x + 0.055) / 1.055, 2.4);
    };
    interpolate_rgb = function(col1, col2, f, m) {
        var xyz0, xyz1;
        xyz0 = col1._rgb;
        xyz1 = col2._rgb;
        return new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
    };
    _interpolators.push([
        "rgb",
        interpolate_rgb
    ]);
    Color.prototype.luminance = function(lum, mode) {
        var cur_lum, eps, max_iter, rgba, test;
        if (mode == null) mode = "rgb";
        if (!arguments.length) return rgb2luminance(this._rgb);
        rgba = this._rgb;
        if (lum === 0) rgba = [
            0,
            0,
            0,
            this._rgb[3]
        ];
        else if (lum === 1) rgba = [
            255,
            255,
            255,
            this[3]
        ];
        else {
            cur_lum = rgb2luminance(this._rgb);
            eps = 1e-7;
            max_iter = 20;
            test = function(l, h) {
                var lm, m;
                m = l.interpolate(h, 0.5, mode);
                lm = m.luminance();
                if (Math.abs(lum - lm) < eps || !max_iter--) return m;
                if (lm > lum) return test(l, m);
                return test(m, h);
            };
            if (cur_lum > lum) rgba = test(chroma("black"), this).rgba();
            else rgba = test(this, chroma("white")).rgba();
        }
        return chroma(rgba).alpha(this.alpha());
    };
    temperature2rgb = function(kelvin) {
        var b, g, r, temp;
        temp = kelvin / 100;
        if (temp < 66) {
            r = 255;
            g = -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * log(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * log(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * log(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * log(g);
            b = 255;
        }
        return [
            r,
            g,
            b
        ];
    };
    rgb2temperature = function() {
        var b, eps, g, maxTemp, minTemp, r, ref, rgb, temp;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        minTemp = 1000;
        maxTemp = 40000;
        eps = 0.4;
        while(maxTemp - minTemp > eps){
            temp = (maxTemp + minTemp) * 0.5;
            rgb = temperature2rgb(temp);
            if (rgb[2] / rgb[0] >= b / r) maxTemp = temp;
            else minTemp = temp;
        }
        return round(temp);
    };
    chroma.temperature = chroma.kelvin = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "temperature"
        ]), function() {});
    };
    _input.temperature = _input.kelvin = _input.K = temperature2rgb;
    Color.prototype.temperature = function() {
        return rgb2temperature(this._rgb);
    };
    Color.prototype.kelvin = Color.prototype.temperature;
    chroma.contrast = function(a, b) {
        var l1, l2, ref, ref1;
        if ((ref = type(a)) === "string" || ref === "number") a = new Color(a);
        if ((ref1 = type(b)) === "string" || ref1 === "number") b = new Color(b);
        l1 = a.luminance();
        l2 = b.luminance();
        if (l1 > l2) return (l1 + 0.05) / (l2 + 0.05);
        else return (l2 + 0.05) / (l1 + 0.05);
    };
    chroma.distance = function(a, b, mode) {
        var d, i, l1, l2, ref, ref1, sum_sq;
        if (mode == null) mode = "lab";
        if ((ref = type(a)) === "string" || ref === "number") a = new Color(a);
        if ((ref1 = type(b)) === "string" || ref1 === "number") b = new Color(b);
        l1 = a.get(mode);
        l2 = b.get(mode);
        sum_sq = 0;
        for(i in l1){
            d = (l1[i] || 0) - (l2[i] || 0);
            sum_sq += d * d;
        }
        return Math.sqrt(sum_sq);
    };
    chroma.deltaE = function(a, b, L, C) {
        var L1, L2, a1, a2, b1, b2, c1, c2, c4, dH2, delA, delB, delC, delL, f, h1, ref, ref1, ref2, ref3, sc, sh, sl, t, v1, v2, v3;
        if (L == null) L = 1;
        if (C == null) C = 1;
        if ((ref = type(a)) === "string" || ref === "number") a = new Color(a);
        if ((ref1 = type(b)) === "string" || ref1 === "number") b = new Color(b);
        ref2 = a.lab(), L1 = ref2[0], a1 = ref2[1], b1 = ref2[2];
        ref3 = b.lab(), L2 = ref3[0], a2 = ref3[1], b2 = ref3[2];
        c1 = sqrt(a1 * a1 + b1 * b1);
        c2 = sqrt(a2 * a2 + b2 * b2);
        sl = L1 < 16.0 ? 0.511 : 0.040975 * L1 / (1.0 + 0.01765 * L1);
        sc = 0.0638 * c1 / (1.0 + 0.0131 * c1) + 0.638;
        h1 = c1 < 0.000001 ? 0.0 : atan2(b1, a1) * 180.0 / PI;
        while(h1 < 0)h1 += 360;
        while(h1 >= 360)h1 -= 360;
        t = h1 >= 164.0 && h1 <= 345.0 ? 0.56 + abs(0.2 * cos(PI * (h1 + 168.0) / 180.0)) : 0.36 + abs(0.4 * cos(PI * (h1 + 35.0) / 180.0));
        c4 = c1 * c1 * c1 * c1;
        f = sqrt(c4 / (c4 + 1900.0));
        sh = sc * (f * t + 1.0 - f);
        delL = L1 - L2;
        delC = c1 - c2;
        delA = a1 - a2;
        delB = b1 - b2;
        dH2 = delA * delA + delB * delB - delC * delC;
        v1 = delL / (L * sl);
        v2 = delC / (C * sc);
        v3 = sh;
        return sqrt(v1 * v1 + v2 * v2 + dH2 / (v3 * v3));
    };
    Color.prototype.get = function(modechan) {
        var channel, i, me, mode, ref, src;
        me = this;
        ref = modechan.split("."), mode = ref[0], channel = ref[1];
        src = me[mode]();
        if (channel) {
            i = mode.indexOf(channel);
            if (i > -1) return src[i];
            else return console.warn("unknown channel " + channel + " in mode " + mode);
        } else return src;
    };
    Color.prototype.set = function(modechan, value) {
        var channel, i, me, mode, ref, src;
        me = this;
        ref = modechan.split("."), mode = ref[0], channel = ref[1];
        if (channel) {
            src = me[mode]();
            i = mode.indexOf(channel);
            if (i > -1) {
                if (type(value) === "string") switch(value.charAt(0)){
                    case "+":
                        src[i] += +value;
                        break;
                    case "-":
                        src[i] += +value;
                        break;
                    case "*":
                        src[i] *= +value.substr(1);
                        break;
                    case "/":
                        src[i] /= +value.substr(1);
                        break;
                    default:
                        src[i] = +value;
                }
                else src[i] = value;
            } else console.warn("unknown channel " + channel + " in mode " + mode);
        } else src = value;
        return chroma(src, mode).alpha(me.alpha());
    };
    Color.prototype.clipped = function() {
        return this._rgb._clipped || false;
    };
    Color.prototype.alpha = function(a) {
        if (arguments.length) return chroma.rgb([
            this._rgb[0],
            this._rgb[1],
            this._rgb[2],
            a
        ]);
        return this._rgb[3];
    };
    Color.prototype.darken = function(amount) {
        var lab, me;
        if (amount == null) amount = 1;
        me = this;
        lab = me.lab();
        lab[0] -= LAB_CONSTANTS.Kn * amount;
        return chroma.lab(lab).alpha(me.alpha());
    };
    Color.prototype.brighten = function(amount) {
        if (amount == null) amount = 1;
        return this.darken(-amount);
    };
    Color.prototype.darker = Color.prototype.darken;
    Color.prototype.brighter = Color.prototype.brighten;
    Color.prototype.saturate = function(amount) {
        var lch, me;
        if (amount == null) amount = 1;
        me = this;
        lch = me.lch();
        lch[1] += amount * LAB_CONSTANTS.Kn;
        if (lch[1] < 0) lch[1] = 0;
        return chroma.lch(lch).alpha(me.alpha());
    };
    Color.prototype.desaturate = function(amount) {
        if (amount == null) amount = 1;
        return this.saturate(-amount);
    };
    Color.prototype.premultiply = function() {
        var a, rgb;
        rgb = this.rgb();
        a = this.alpha();
        return chroma(rgb[0] * a, rgb[1] * a, rgb[2] * a, a);
    };
    blend = function(bottom, top, mode) {
        if (!blend[mode]) throw "unknown blend mode " + mode;
        return blend[mode](bottom, top);
    };
    blend_f = function(f) {
        return function(bottom, top) {
            var c0, c1;
            c0 = chroma(top).rgb();
            c1 = chroma(bottom).rgb();
            return chroma(f(c0, c1), "rgb");
        };
    };
    each = function(f) {
        return function(c0, c1) {
            var i, o, out;
            out = [];
            for(i = o = 0; o <= 3; i = ++o)out[i] = f(c0[i], c1[i]);
            return out;
        };
    };
    normal = function(a, b) {
        return a;
    };
    multiply = function(a, b) {
        return a * b / 255;
    };
    darken = function(a, b) {
        if (a > b) return b;
        else return a;
    };
    lighten = function(a, b) {
        if (a > b) return a;
        else return b;
    };
    screen = function(a, b) {
        return 255 * (1 - (1 - a / 255) * (1 - b / 255));
    };
    overlay = function(a, b) {
        if (b < 128) return 2 * a * b / 255;
        else return 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
    };
    burn = function(a, b) {
        return 255 * (1 - (1 - b / 255) / (a / 255));
    };
    dodge = function(a, b) {
        if (a === 255) return 255;
        a = 255 * (b / 255) / (1 - a / 255);
        if (a > 255) return 255;
        else return a;
    };
    blend.normal = blend_f(each(normal));
    blend.multiply = blend_f(each(multiply));
    blend.screen = blend_f(each(screen));
    blend.overlay = blend_f(each(overlay));
    blend.darken = blend_f(each(darken));
    blend.lighten = blend_f(each(lighten));
    blend.dodge = blend_f(each(dodge));
    blend.burn = blend_f(each(burn));
    chroma.blend = blend;
    chroma.analyze = function(data) {
        var len, o, r, val;
        r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE * -1,
            sum: 0,
            values: [],
            count: 0
        };
        for(o = 0, len = data.length; o < len; o++){
            val = data[o];
            if (val != null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) r.min = val;
                if (val > r.max) r.max = val;
                r.count += 1;
            }
        }
        r.domain = [
            r.min,
            r.max
        ];
        r.limits = function(mode, num) {
            return chroma.limits(r, mode, num);
        };
        return r;
    };
    chroma.scale = function(colors, positions) {
        var _classes, _colorCache, _colors, _correctLightness, _domain, _fixed, _gamma, _max, _min, _mode, _nacol, _out, _padding, _pos, _spread, _useCache, classifyValue, f, getClass, getColor, resetCache, setColors, tmap;
        _mode = "rgb";
        _nacol = chroma("#ccc");
        _spread = 0;
        _fixed = false;
        _domain = [
            0,
            1
        ];
        _pos = [];
        _padding = [
            0,
            0
        ];
        _classes = false;
        _colors = [];
        _out = false;
        _min = 0;
        _max = 1;
        _correctLightness = false;
        _colorCache = {};
        _useCache = true;
        _gamma = 1;
        setColors = function(colors) {
            var c, col, o, ref, ref1, w;
            if (colors == null) colors = [
                "#fff",
                "#000"
            ];
            if (colors != null && type(colors) === "string" && chroma.brewer != null) colors = chroma.brewer[colors] || chroma.brewer[colors.toLowerCase()] || colors;
            if (type(colors) === "array") {
                if (colors.length === 1) colors = [
                    colors[0],
                    colors[0]
                ];
                colors = colors.slice(0);
                for(c = o = 0, ref = colors.length - 1; 0 <= ref ? o <= ref : o >= ref; c = 0 <= ref ? ++o : --o){
                    col = colors[c];
                    if (type(col) === "string") colors[c] = chroma(col);
                }
                _pos.length = 0;
                for(c = w = 0, ref1 = colors.length - 1; 0 <= ref1 ? w <= ref1 : w >= ref1; c = 0 <= ref1 ? ++w : --w)_pos.push(c / (colors.length - 1));
            }
            resetCache();
            return _colors = colors;
        };
        getClass = function(value) {
            var i, n;
            if (_classes != null) {
                n = _classes.length - 1;
                i = 0;
                while(i < n && value >= _classes[i])i++;
                return i - 1;
            }
            return 0;
        };
        tmap = function(t) {
            return t;
        };
        classifyValue = function(value) {
            var i, maxc, minc, n, val;
            val = value;
            if (_classes.length > 2) {
                n = _classes.length - 1;
                i = getClass(value);
                minc = _classes[0] + (_classes[1] - _classes[0]) * (0 + _spread * 0.5);
                maxc = _classes[n - 1] + (_classes[n] - _classes[n - 1]) * (1 - _spread * 0.5);
                val = _min + (_classes[i] + (_classes[i + 1] - _classes[i]) * 0.5 - minc) / (maxc - minc) * (_max - _min);
            }
            return val;
        };
        getColor = function(val, bypassMap) {
            var c, col, i, k, o, p, ref, t;
            if (bypassMap == null) bypassMap = false;
            if (isNaN(val) || val === null) return _nacol;
            if (!bypassMap) {
                if (_classes && _classes.length > 2) {
                    c = getClass(val);
                    t = c / (_classes.length - 2);
                } else if (_max !== _min) t = (val - _min) / (_max - _min);
                else t = 1;
            } else t = val;
            if (!bypassMap) t = tmap(t);
            if (_gamma !== 1) t = pow(t, _gamma);
            t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
            t = Math.min(1, Math.max(0, t));
            k = Math.floor(t * 10000);
            if (_useCache && _colorCache[k]) col = _colorCache[k];
            else {
                if (type(_colors) === "array") for(i = o = 0, ref = _pos.length - 1; 0 <= ref ? o <= ref : o >= ref; i = 0 <= ref ? ++o : --o){
                    p = _pos[i];
                    if (t <= p) {
                        col = _colors[i];
                        break;
                    }
                    if (t >= p && i === _pos.length - 1) {
                        col = _colors[i];
                        break;
                    }
                    if (t > p && t < _pos[i + 1]) {
                        t = (t - p) / (_pos[i + 1] - p);
                        col = chroma.interpolate(_colors[i], _colors[i + 1], t, _mode);
                        break;
                    }
                }
                else if (type(_colors) === "function") col = _colors(t);
                if (_useCache) _colorCache[k] = col;
            }
            return col;
        };
        resetCache = function() {
            return _colorCache = {};
        };
        setColors(colors);
        f = function(v) {
            var c;
            c = chroma(getColor(v));
            if (_out && c[_out]) return c[_out]();
            else return c;
        };
        f.classes = function(classes) {
            var d;
            if (classes != null) {
                if (type(classes) === "array") {
                    _classes = classes;
                    _domain = [
                        classes[0],
                        classes[classes.length - 1]
                    ];
                } else {
                    d = chroma.analyze(_domain);
                    if (classes === 0) _classes = [
                        d.min,
                        d.max
                    ];
                    else _classes = chroma.limits(d, "e", classes);
                }
                return f;
            }
            return _classes;
        };
        f.domain = function(domain) {
            var c, d, k, len, o, ref, w;
            if (!arguments.length) return _domain;
            _min = domain[0];
            _max = domain[domain.length - 1];
            _pos = [];
            k = _colors.length;
            if (domain.length === k && _min !== _max) for(o = 0, len = domain.length; o < len; o++){
                d = domain[o];
                _pos.push((d - _min) / (_max - _min));
            }
            else for(c = w = 0, ref = k - 1; 0 <= ref ? w <= ref : w >= ref; c = 0 <= ref ? ++w : --w)_pos.push(c / (k - 1));
            _domain = [
                _min,
                _max
            ];
            return f;
        };
        f.mode = function(_m) {
            if (!arguments.length) return _mode;
            _mode = _m;
            resetCache();
            return f;
        };
        f.range = function(colors, _pos) {
            setColors(colors, _pos);
            return f;
        };
        f.out = function(_o) {
            _out = _o;
            return f;
        };
        f.spread = function(val) {
            if (!arguments.length) return _spread;
            _spread = val;
            return f;
        };
        f.correctLightness = function(v) {
            if (v == null) v = true;
            _correctLightness = v;
            resetCache();
            if (_correctLightness) tmap = function(t) {
                var L0, L1, L_actual, L_diff, L_ideal, max_iter, pol, t0, t1;
                L0 = getColor(0, true).lab()[0];
                L1 = getColor(1, true).lab()[0];
                pol = L0 > L1;
                L_actual = getColor(t, true).lab()[0];
                L_ideal = L0 + (L1 - L0) * t;
                L_diff = L_actual - L_ideal;
                t0 = 0;
                t1 = 1;
                max_iter = 20;
                while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                    if (pol) L_diff *= -1;
                    if (L_diff < 0) {
                        t0 = t;
                        t += (t1 - t) * 0.5;
                    } else {
                        t1 = t;
                        t += (t0 - t) * 0.5;
                    }
                    L_actual = getColor(t, true).lab()[0];
                    return L_diff = L_actual - L_ideal;
                })();
                return t;
            };
            else tmap = function(t) {
                return t;
            };
            return f;
        };
        f.padding = function(p) {
            if (p != null) {
                if (type(p) === "number") p = [
                    p,
                    p
                ];
                _padding = p;
                return f;
            } else return _padding;
        };
        f.colors = function(numColors, out) {
            var dd, dm, i, o, ref, result, results, samples, w;
            if (arguments.length < 2) out = "hex";
            result = [];
            if (arguments.length === 0) result = _colors.slice(0);
            else if (numColors === 1) result = [
                f(0.5)
            ];
            else if (numColors > 1) {
                dm = _domain[0];
                dd = _domain[1] - dm;
                result = (function() {
                    results = [];
                    for(var o = 0; 0 <= numColors ? o < numColors : o > numColors; 0 <= numColors ? o++ : o--)results.push(o);
                    return results;
                }).apply(this).map(function(i) {
                    return f(dm + i / (numColors - 1) * dd);
                });
            } else {
                colors = [];
                samples = [];
                if (_classes && _classes.length > 2) for(i = w = 1, ref = _classes.length; 1 <= ref ? w < ref : w > ref; i = 1 <= ref ? ++w : --w)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
                else samples = _domain;
                result = samples.map(function(v) {
                    return f(v);
                });
            }
            if (chroma[out]) result = result.map(function(c) {
                return c[out]();
            });
            return result;
        };
        f.cache = function(c) {
            if (c != null) {
                _useCache = c;
                return f;
            } else return _useCache;
        };
        f.gamma = function(g) {
            if (g != null) {
                _gamma = g;
                return f;
            } else return _gamma;
        };
        f.nodata = function(d) {
            if (d != null) {
                _nacol = chroma(d);
                return f;
            } else return _nacol;
        };
        return f;
    };
    if (chroma.scales == null) chroma.scales = {};
    chroma.scales.cool = function() {
        return chroma.scale([
            chroma.hsl(180, 1, .9),
            chroma.hsl(250, .7, .4)
        ]);
    };
    chroma.scales.hot = function() {
        return chroma.scale([
            "#000",
            "#f00",
            "#ff0",
            "#fff"
        ], [
            0,
            .25,
            .75,
            1
        ]).mode("rgb");
    };
    chroma.analyze = function(data, key, filter) {
        var add, k, len, o, r, val, visit;
        r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE * -1,
            sum: 0,
            values: [],
            count: 0
        };
        if (filter == null) filter = function() {
            return true;
        };
        add = function(val) {
            if (val != null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) r.min = val;
                if (val > r.max) r.max = val;
                r.count += 1;
            }
        };
        visit = function(val, k) {
            if (filter(val, k)) {
                if (key != null && type(key) === "function") return add(key(val));
                else if (key != null && type(key) === "string" || type(key) === "number") return add(val[key]);
                else return add(val);
            }
        };
        if (type(data) === "array") for(o = 0, len = data.length; o < len; o++){
            val = data[o];
            visit(val);
        }
        else for(k in data){
            val = data[k];
            visit(val, k);
        }
        r.domain = [
            r.min,
            r.max
        ];
        r.limits = function(mode, num) {
            return chroma.limits(r, mode, num);
        };
        return r;
    };
    chroma.limits = function(data, mode, num) {
        var aa, ab, ac, ad, ae, af, ag, ah, ai, aj, ak, al, am, assignments, best, centroids, cluster, clusterSizes, dist, i, j, kClusters, limits, max_log, min, min_log, mindist, n, nb_iters, newCentroids, o, p, pb, pr, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, repeat, sum, tmpKMeansBreaks, v, value, values, w;
        if (mode == null) mode = "equal";
        if (num == null) num = 7;
        if (type(data) === "array") data = chroma.analyze(data);
        min = data.min;
        max = data.max;
        sum = data.sum;
        values = data.values.sort(function(a, b) {
            return a - b;
        });
        if (num === 1) return [
            min,
            max
        ];
        limits = [];
        if (mode.substr(0, 1) === "c") {
            limits.push(min);
            limits.push(max);
        }
        if (mode.substr(0, 1) === "e") {
            limits.push(min);
            for(i = o = 1, ref = num - 1; 1 <= ref ? o <= ref : o >= ref; i = 1 <= ref ? ++o : --o)limits.push(min + i / num * (max - min));
            limits.push(max);
        } else if (mode.substr(0, 1) === "l") {
            if (min <= 0) throw "Logarithmic scales are only possible for values > 0";
            min_log = Math.LOG10E * log(min);
            max_log = Math.LOG10E * log(max);
            limits.push(min);
            for(i = w = 1, ref1 = num - 1; 1 <= ref1 ? w <= ref1 : w >= ref1; i = 1 <= ref1 ? ++w : --w)limits.push(pow(10, min_log + i / num * (max_log - min_log)));
            limits.push(max);
        } else if (mode.substr(0, 1) === "q") {
            limits.push(min);
            for(i = aa = 1, ref2 = num - 1; 1 <= ref2 ? aa <= ref2 : aa >= ref2; i = 1 <= ref2 ? ++aa : --aa){
                p = (values.length - 1) * i / num;
                pb = floor(p);
                if (pb === p) limits.push(values[pb]);
                else {
                    pr = p - pb;
                    limits.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
                }
            }
            limits.push(max);
        } else if (mode.substr(0, 1) === "k") {
            /*
      implementation based on
      http://code.google.com/p/figue/source/browse/trunk/figue.js#336
      simplified for 1-d input values
       */ n = values.length;
            assignments = new Array(n);
            clusterSizes = new Array(num);
            repeat = true;
            nb_iters = 0;
            centroids = null;
            centroids = [];
            centroids.push(min);
            for(i = ab = 1, ref3 = num - 1; 1 <= ref3 ? ab <= ref3 : ab >= ref3; i = 1 <= ref3 ? ++ab : --ab)centroids.push(min + i / num * (max - min));
            centroids.push(max);
            while(repeat){
                for(j = ac = 0, ref4 = num - 1; 0 <= ref4 ? ac <= ref4 : ac >= ref4; j = 0 <= ref4 ? ++ac : --ac)clusterSizes[j] = 0;
                for(i = ad = 0, ref5 = n - 1; 0 <= ref5 ? ad <= ref5 : ad >= ref5; i = 0 <= ref5 ? ++ad : --ad){
                    value = values[i];
                    mindist = Number.MAX_VALUE;
                    for(j = ae = 0, ref6 = num - 1; 0 <= ref6 ? ae <= ref6 : ae >= ref6; j = 0 <= ref6 ? ++ae : --ae){
                        dist = abs(centroids[j] - value);
                        if (dist < mindist) {
                            mindist = dist;
                            best = j;
                        }
                    }
                    clusterSizes[best]++;
                    assignments[i] = best;
                }
                newCentroids = new Array(num);
                for(j = af = 0, ref7 = num - 1; 0 <= ref7 ? af <= ref7 : af >= ref7; j = 0 <= ref7 ? ++af : --af)newCentroids[j] = null;
                for(i = ag = 0, ref8 = n - 1; 0 <= ref8 ? ag <= ref8 : ag >= ref8; i = 0 <= ref8 ? ++ag : --ag){
                    cluster = assignments[i];
                    if (newCentroids[cluster] === null) newCentroids[cluster] = values[i];
                    else newCentroids[cluster] += values[i];
                }
                for(j = ah = 0, ref9 = num - 1; 0 <= ref9 ? ah <= ref9 : ah >= ref9; j = 0 <= ref9 ? ++ah : --ah)newCentroids[j] *= 1 / clusterSizes[j];
                repeat = false;
                for(j = ai = 0, ref10 = num - 1; 0 <= ref10 ? ai <= ref10 : ai >= ref10; j = 0 <= ref10 ? ++ai : --ai)if (newCentroids[j] !== centroids[i]) {
                    repeat = true;
                    break;
                }
                centroids = newCentroids;
                nb_iters++;
                if (nb_iters > 200) repeat = false;
            }
            kClusters = {};
            for(j = aj = 0, ref11 = num - 1; 0 <= ref11 ? aj <= ref11 : aj >= ref11; j = 0 <= ref11 ? ++aj : --aj)kClusters[j] = [];
            for(i = ak = 0, ref12 = n - 1; 0 <= ref12 ? ak <= ref12 : ak >= ref12; i = 0 <= ref12 ? ++ak : --ak){
                cluster = assignments[i];
                kClusters[cluster].push(values[i]);
            }
            tmpKMeansBreaks = [];
            for(j = al = 0, ref13 = num - 1; 0 <= ref13 ? al <= ref13 : al >= ref13; j = 0 <= ref13 ? ++al : --al){
                tmpKMeansBreaks.push(kClusters[j][0]);
                tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
            }
            tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a, b) {
                return a - b;
            });
            limits.push(tmpKMeansBreaks[0]);
            for(i = am = 1, ref14 = tmpKMeansBreaks.length - 1; am <= ref14; i = am += 2){
                v = tmpKMeansBreaks[i];
                if (!isNaN(v) && limits.indexOf(v) === -1) limits.push(v);
            }
        }
        return limits;
    };
    hsi2rgb = function(h, s, i) {
        /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
     */ var args, b, g, r;
        args = unpack(arguments);
        h = args[0], s = args[1], i = args[2];
        if (isNaN(h)) h = 0;
        h /= 360;
        if (h < 1 / 3) {
            b = (1 - s) / 3;
            r = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
            g = 1 - (b + r);
        } else if (h < 2 / 3) {
            h -= 1 / 3;
            r = (1 - s) / 3;
            g = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
            b = 1 - (r + g);
        } else {
            h -= 2 / 3;
            g = (1 - s) / 3;
            b = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
            r = 1 - (g + b);
        }
        r = limit(i * r * 3);
        g = limit(i * g * 3);
        b = limit(i * b * 3);
        return [
            r * 255,
            g * 255,
            b * 255,
            args.length > 3 ? args[3] : 1
        ];
    };
    rgb2hsi = function() {
        /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
     */ var b, g, h, i, min, r, ref, s;
        ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
        TWOPI = Math.PI * 2;
        r /= 255;
        g /= 255;
        b /= 255;
        min = Math.min(r, g, b);
        i = (r + g + b) / 3;
        s = 1 - min / i;
        if (s === 0) h = 0;
        else {
            h = (r - g + (r - b)) / 2;
            h /= Math.sqrt((r - g) * (r - g) + (r - b) * (g - b));
            h = Math.acos(h);
            if (b > g) h = TWOPI - h;
            h /= TWOPI;
        }
        return [
            h * 360,
            s,
            i
        ];
    };
    chroma.hsi = function() {
        return function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
        }(Color, slice.call(arguments).concat([
            "hsi"
        ]), function() {});
    };
    _input.hsi = hsi2rgb;
    Color.prototype.hsi = function() {
        return rgb2hsi(this._rgb);
    };
    interpolate_hsx = function(col1, col2, f, m) {
        var dh, hue, hue0, hue1, lbv, lbv0, lbv1, res, sat, sat0, sat1, xyz0, xyz1;
        if (m === "hsl") {
            xyz0 = col1.hsl();
            xyz1 = col2.hsl();
        } else if (m === "hsv") {
            xyz0 = col1.hsv();
            xyz1 = col2.hsv();
        } else if (m === "hcg") {
            xyz0 = col1.hcg();
            xyz1 = col2.hcg();
        } else if (m === "hsi") {
            xyz0 = col1.hsi();
            xyz1 = col2.hsi();
        } else if (m === "lch" || m === "hcl") {
            m = "hcl";
            xyz0 = col1.hcl();
            xyz1 = col2.hcl();
        }
        if (m.substr(0, 1) === "h") {
            hue0 = xyz0[0], sat0 = xyz0[1], lbv0 = xyz0[2];
            hue1 = xyz1[0], sat1 = xyz1[1], lbv1 = xyz1[2];
        }
        if (!isNaN(hue0) && !isNaN(hue1)) {
            if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
            else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
            else dh = hue1 - hue0;
            hue = hue0 + f * dh;
        } else if (!isNaN(hue0)) {
            hue = hue0;
            if ((lbv1 === 1 || lbv1 === 0) && m !== "hsv") sat = sat0;
        } else if (!isNaN(hue1)) {
            hue = hue1;
            if ((lbv0 === 1 || lbv0 === 0) && m !== "hsv") sat = sat1;
        } else hue = Number.NaN;
        if (sat == null) sat = sat0 + f * (sat1 - sat0);
        lbv = lbv0 + f * (lbv1 - lbv0);
        return res = chroma[m](hue, sat, lbv);
    };
    _interpolators = _interpolators.concat(function() {
        var len, o, ref, results;
        ref = [
            "hsv",
            "hsl",
            "hsi",
            "hcl",
            "lch",
            "hcg"
        ];
        results = [];
        for(o = 0, len = ref.length; o < len; o++){
            m = ref[o];
            results.push([
                m,
                interpolate_hsx
            ]);
        }
        return results;
    }());
    interpolate_num = function(col1, col2, f, m) {
        var n1, n2;
        n1 = col1.num();
        n2 = col2.num();
        return chroma.num(n1 + (n2 - n1) * f, "num");
    };
    _interpolators.push([
        "num",
        interpolate_num
    ]);
    interpolate_lab = function(col1, col2, f, m) {
        var res, xyz0, xyz1;
        xyz0 = col1.lab();
        xyz1 = col2.lab();
        return res = new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
    };
    _interpolators.push([
        "lab",
        interpolate_lab
    ]);
}).call(this);

},{}],"bFzCy":[function(require,module,exports) {
// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
// ┃ ██████ ██████ ██████       █      █      █      █      █ █▄  ▀███ █       ┃
// ┃ ▄▄▄▄▄█ █▄▄▄▄▄ ▄▄▄▄▄█  ▀▀▀▀▀█▀▀▀▀▀ █ ▀▀▀▀▀█ ████████▌▐███ ███▄  ▀█ █ ▀▀▀▀▀ ┃
// ┃ █▀▀▀▀▀ █▀▀▀▀▀ █▀██▀▀ ▄▄▄▄▄ █ ▄▄▄▄▄█ ▄▄▄▄▄█ ████████▌▐███ █████▄   █ ▄▄▄▄▄ ┃
// ┃ █      ██████ █  ▀█▄       █ ██████      █      ███▌▐███ ███████▄ █       ┃
// ┣━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┫
// ┃ Copyright (c) 2017, the Perspective Authors.                              ┃
// ┃ ╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌ ┃
// ┃ This file is part of the Perspective library, distributed under the terms ┃
// ┃ of the [Apache License 2.0](https://www.apache.org/licenses/LICENSE-2.0). ┃
// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "get_types", ()=>get_types);
parcelHelpers.export(exports, "get_type_config", ()=>get_type_config);
parcelHelpers.export(exports, "override_config", ()=>override_config);
parcelHelpers.export(exports, "get_config", ()=>get_config);
var _settingsJs = require("./settings.js");
var _settingsJsDefault = parcelHelpers.interopDefault(_settingsJs);
function get_types() {
    return Object.keys(get_config().types);
}
function get_type_config(type) {
    const config = {};
    if (get_config().types[type]) Object.assign(config, get_config().types[type]);
    if (config.type) {
        const props = get_type_config(config.type);
        Object.assign(props, config);
        return props;
    } else return config;
}
function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}
function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (isObject(target) && isObject(source)) {
        for(const key in source)if (isObject(source[key])) {
            if (!target[key]) Object.assign(target, {
                [key]: {}
            });
            mergeDeep(target[key], source[key]);
        } else Object.assign(target, {
            [key]: source[key]
        });
    }
    return mergeDeep(target, ...sources);
}
function override_config(config) {
    if (globalThis.__PERSPECTIVE_CONFIG__) console.warn("Config already initialized!");
    globalThis.__PERSPECTIVE_CONFIG__ = mergeDeep((0, _settingsJsDefault.default), config);
}
function get_config() {
    if (!globalThis.__PERSPECTIVE_CONFIG__) globalThis.__PERSPECTIVE_CONFIG__ = mergeDeep((0, _settingsJsDefault.default), globalThis.__TEMPLATE_CONFIG__ || {});
    return globalThis.__PERSPECTIVE_CONFIG__;
}

},{"./settings.js":"4CL7I","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4CL7I":[function(require,module,exports) {
// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
// ┃ ██████ ██████ ██████       █      █      █      █      █ █▄  ▀███ █       ┃
// ┃ ▄▄▄▄▄█ █▄▄▄▄▄ ▄▄▄▄▄█  ▀▀▀▀▀█▀▀▀▀▀ █ ▀▀▀▀▀█ ████████▌▐███ ███▄  ▀█ █ ▀▀▀▀▀ ┃
// ┃ █▀▀▀▀▀ █▀▀▀▀▀ █▀██▀▀ ▄▄▄▄▄ █ ▄▄▄▄▄█ ▄▄▄▄▄█ ████████▌▐███ █████▄   █ ▄▄▄▄▄ ┃
// ┃ █      ██████ █  ▀█▄       █ ██████      █      ███▌▐███ ███████▄ █       ┃
// ┣━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┫
// ┃ Copyright (c) 2017, the Perspective Authors.                              ┃
// ┃ ╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌ ┃
// ┃ This file is part of the Perspective library, distributed under the terms ┃
// ┃ of the [Apache License 2.0](https://www.apache.org/licenses/LICENSE-2.0). ┃
// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛
/**
 * The default settings which populate `perspective.config.js`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    /**
     * `types` are the type-specific configuration options.  Each key is the
     * name of a perspective type; their values are configuration objects for
     * that type.
     */ types: {
        float: {
            /**
             * Which filter operator should be the default when a column of this
             * type is pivotted.
             */ filter_operator: "==",
            /**
             * Which aggregate should be the default when a column of this type
             * is pivotted.
             */ aggregate: "sum",
            /**
             * The format object for this type.  Can be either an
             * `toLocaleString()` `options` object for this type (or supertype),
             * or a function which returns the formatted string for this type.
             */ format: {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        },
        string: {
            filter_operator: "==",
            aggregate: "count"
        },
        integer: {
            filter_operator: "==",
            aggregate: "sum",
            format: {}
        },
        boolean: {
            filter_operator: "==",
            aggregate: "count"
        },
        datetime: {
            filter_operator: "==",
            aggregate: "count",
            format: {
                dateStyle: "short",
                timeStyle: "medium"
            },
            null_value: -1
        },
        date: {
            filter_operator: "==",
            aggregate: "count",
            format: {
                dateStyle: "short"
            },
            null_value: -1
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ce58x":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M29.83,20l.34-2L25,17.15V13c0-.08,0-.15,0-.23l5.06-1.36-.51-1.93-4.83,1.29A9,9,0,0,0,20,5V2H18V4.23a8.81,8.81,0,0,0-4,0V2H12V5a9,9,0,0,0-4.71,5.82L2.46,9.48,2,11.41,7,12.77c0,.08,0,.15,0,.23v4.15L1.84,18l.32,2L7,19.18a8.9,8.9,0,0,0,.82,3.57L3.29,27.29l1.42,1.42,4.19-4.2a9,9,0,0,0,14.2,0l4.19,4.2,1.42-1.42-4.54-4.54A8.9,8.9,0,0,0,25,19.18ZM15,25.92A7,7,0,0,1,9,19V13h6ZM9.29,11a7,7,0,0,1,13.42,0ZM23,19a7,7,0,0,1-6,6.92V13h6Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6iGjj":[function(require,module,exports) {
module.exports = "@include perspective-viewer-vaporwave--fonts;@include perspective-viewer-gruvbox-light--animation;@include perspective-viewer-gruvbox-light--fonts;@include perspective-viewer-gruvbox-dark--animation;@include perspective-viewer-gruvbox-dark--fonts;@include perspective-viewer-dracula--animation;@include perspective-viewer-dracula--fonts;perspective-viewer,perspective-copy-menu,perspective-export-menu,perspective-dropdown,perspective-date-column-style,perspective-datetime-column-style,perspective-number-column-style,perspective-string-column-style{--column-type-integer--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxwYXRoIGQ9Ik0gNy4xMzYgNy42NyBMIDUuNDE4IDcuNjcgTCA1LjkwMiA1LjU5NCBMIDcuNjIgNS41OTQgTCA3LjEzNiA3LjY3IFogTSA2LjUxMyAxMC4yNjQgTCA3LjMyIDEwLjI2NCBMIDcuNzgyIDguMzM4IEwgOS4xODggOC4zMzggTCA5LjMwNCA3LjY3IEwgNy45NDMgNy42NyBMIDguNDI3IDUuNTk0IEwgOS42NzMgNS41OTQgTCA5Ljc5OSA0LjkxNCBMIDguNTg5IDQuOTE0IEwgOS4wNSAzIEwgOC4yNDMgMyBMIDcuNzgyIDQuOTE0IEwgNi4wNjMgNC45MTQgTCA2LjUyNSAzIEwgNS43MTggMyBMIDUuMjU2IDQuOTE0IEwgMy44NjEgNC45MTQgTCAzLjczNCA1LjU5NCBMIDUuMDk1IDUuNTk0IEwgNC42MTEgNy42NyBMIDMuMzY1IDcuNjcgTCAzLjI1IDguMzM4IEwgNC40NDkgOC4zMzggTCAzLjk4OCAxMC4yNjQgTCA0Ljc5NSAxMC4yNjQgTCA1LjI1NiA4LjMzOCBMIDYuOTc0IDguMzM4IEwgNi41MTMgMTAuMjY0IFoiIGZpbGw9ImJsYWNrIj48L3BhdGg+Cjwvc3ZnPg==);--column-type-float--mask-image:var(--column-type-integer--mask-image);--column-type-string--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxwYXRoIGQ9Ik0gNi4yODMgNS4yNzUgTCA2LjMwOSA1LjI3NSBMIDYuNzkyIDYuODU1IEwgNS44MDYgNi44NTUgTCA2LjI4MyA1LjI3NSBaIE0gNy4yOTUgOC41MDEgTCA4LjE0NCA4LjUwMSBMIDYuODI1IDQuMzg3IEwgNS44MTkgNC4zODcgTCA0LjUgOC41MDEgTCA1LjMwMyA4LjUwMSBMIDUuNjEgNy40ODkgTCA2Ljk4OCA3LjQ4OSBMIDcuMjk1IDguNTAxIFoiIGZpbGw9IiMwNDIxMjEiPjwvcGF0aD4KICAgIDxtYXNrIGlkPSJwYXRoLTItaW5zaWRlLTFfNzIwXzc4NjciIGZpbGw9IndoaXRlIj4KICAgICAgICA8cmVjdCB3aWR0aD0iMTAiIGhlaWdodD0iOSIgcng9IjAuODMzIiB4PSIxLjUiIHk9IjIiPjwvcmVjdD4KICAgIDwvbWFzaz4KICAgIDxyZWN0IHdpZHRoPSIxMCIgaGVpZ2h0PSI5IiByeD0iMC44MzMiIHN0cm9rZT0iIzA0MjEyMSIgc3Ryb2tlLXdpZHRoPSIyIiBtYXNrPSJ1cmwoI3BhdGgtMi1pbnNpZGUtMV83MjBfNzg2NykiIHg9IjEuNSIgeT0iMiI+PC9yZWN0Pgo8L3N2Zz4=);--column-type-date--mask-image:url(data:image/svg+xml;base64,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);--column-type-boolean--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNSA1LjhWOEMwLjUgOC44Mjg0MyAxLjE3MTU3IDkuNSAyIDkuNUg0LjhDNS42Mjg0MyA5LjUgNi4zIDguODI4NDMgNi4zIDhWNy4yQzYuMyA2LjkyMzg2IDYuNTIzODYgNi43IDYuOCA2LjdIOEM4LjgyODQzIDYuNyA5LjUgNi4wMjg0MyA5LjUgNS4yVjNDOS41IDIuMTcxNTcgOC44Mjg0MyAxLjUgOCAxLjVINS4yQzQuMzcxNTcgMS41IDMuNyAyLjE3MTU3IDMuNyAzVjMuOEMzLjcgNC4wNzYxNCAzLjQ3NjE0IDQuMyAzLjIgNC4zSDJDMS4xNzE1NyA0LjMgMC41IDQuOTcxNTcgMC41IDUuOFoiIHN0cm9rZT0iIzA0MjEyMSIvPgo8L3N2Zz4K);--column-type-datetime--mask-image:var(--column-type-date--mask-image);--column-drag-handle--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDUgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjMuNDk5OTYiIGN5PSIxMS4wMDAxIiByPSIwLjgzMzMzMyIgZmlsbD0iIzZFNkU2RSIvPgo8Y2lyY2xlIGN4PSIwLjgzMzMzMyIgY3k9IjExLjAwMDEiIHI9IjAuODMzMzMzIiBmaWxsPSIjNkU2RTZFIi8+CjxjaXJjbGUgY3g9IjMuNDk5OTYiIGN5PSI3LjY2NjgzIiByPSIwLjgzMzMzMyIgZmlsbD0iIzZFNkU2RSIvPgo8Y2lyY2xlIGN4PSIwLjgzMzMzMyIgY3k9IjcuNjY2ODMiIHI9IjAuODMzMzMzIiBmaWxsPSIjNkU2RTZFIi8+CjxjaXJjbGUgY3g9IjMuNDk5OTYiIGN5PSI0LjMzMzMzIiByPSIwLjgzMzMzMyIgZmlsbD0iIzZFNkU2RSIvPgo8Y2lyY2xlIGN4PSIwLjgzMzMzMyIgY3k9IjQuMzMzMzMiIHI9IjAuODMzMzMzIiBmaWxsPSIjNkU2RTZFIi8+CjxjaXJjbGUgY3g9IjMuNDk5OTYiIGN5PSIxLjAwMDA4IiByPSIwLjgzMzMzMyIgZmlsbD0iIzZFNkU2RSIvPgo8Y2lyY2xlIGN4PSIwLjgzMzMzMyIgY3k9IjEuMDAwMDgiIHI9IjAuODMzMzMzIiBmaWxsPSIjNkU2RTZFIi8+Cjwvc3ZnPgo=);--column-radio-on--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjUuNSIgY3k9IjUuNSIgcj0iMy41IiBmaWxsPSIjM0Y0MzQzIi8+CiAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiByeD0iNSIgc3Ryb2tlPSIjM0Y0MzQzIi8+Cjwvc3ZnPgo=);--column-radio-hover--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjUuNSIgY3k9IjUuNSIgcj0iMi41IiBmaWxsPSIjM0Y0MzQzIi8+CiAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiByeD0iNSIgc3Ryb2tlPSIjM0Y0MzQzIi8+Cjwvc3ZnPgo=);--column-radio-off--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjUuNSIgY3k9IjUuNSIgcj0iMyIgc3Ryb2tlPSIjM0Y0MzQzIiAvPgo8L3N2Zz4=);--column-checkbox-on--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyIgcng9IjEuNSIgc3Ryb2tlPSIjM0Y0MzQzIi8+CjxyZWN0IHg9IjIiIHk9IjIiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgcng9IjIiIGZpbGw9IiMzRjQzNDMiLz4KPC9zdmc+Cg==);--column-checkbox-hover--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyIgcng9IjEuNSIgc3Ryb2tlPSIjM0Y0MzQzIi8+CjxyZWN0IHg9IjQiIHk9IjQiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIyIiBmaWxsPSIjM0Y0MzQzIi8+Cjwvc3ZnPgo=);--column-checkbox-off--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyIgcng9IjEuNSIgc3Ryb2tlPSIjM0Y0MzQzIi8+CjxyZWN0IHg9IjUiIHk9IjUiIHdpZHRoPSI0IiBoZWlnaHQ9IjQiIHJ4PSIyIiBmaWxsPSIjM0Y0MzQzIi8+Cjwvc3ZnPgo=);--column-settings-icon--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNSAzTDQuNSAxMSIgc3Ryb2tlPSIjMDQyMTIxIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTkuNSAzTDkuNSAxMSIgc3Ryb2tlPSIjMDQyMTIxIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTYgOC41QzYgOS4zMjg0MyA1LjMyODQzIDEwIDQuNSAxMEMzLjY3MTU3IDEwIDMgOS4zMjg0MyAzIDguNUMzIDcuNjcxNTcgMy42NzE1NyA3IDQuNSA3QzUuMzI4NDMgNyA2IDcuNjcxNTcgNiA4LjVaIiBmaWxsPSIjRkRGRkZEIiBzdHJva2U9IiMwNDIxMjEiLz4KPHBhdGggZD0iTTExIDUuNUMxMSA2LjMyODQzIDEwLjMyODQgNyA5LjUgN0M4LjY3MTU3IDcgOCA2LjMyODQzIDggNS41QzggNC42NzE1NyA4LjY3MTU3IDQgOS41IDRDMTAuMzI4NCA0IDExIDQuNjcxNTcgMTEgNS41WiIgZmlsbD0iI0ZERkZGRCIgc3Ryb2tlPSIjMDQyMTIxIi8+Cjwvc3ZnPgo=);--sort-asc-icon--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguODU0MTQgOS4wOTM5OUM4Ljg1NDE0IDkuMzk4NTMgOC42MDcyNyA5LjY0NTQgOC4zMDI3MyA5LjY0NTRDNy45OTgyIDkuNjQ1NCA3Ljc1MTMzIDkuMzk4NTMgNy43NTEzMyA5LjA5Mzk5TDguODU0MTQgOS4wOTM5OVpNNy45MTI4MyAyLjkxODZDOC4xMjgxNyAyLjcwMzI2IDguNDc3MyAyLjcwMzI2IDguNjkyNjQgMi45MTg2TDEyLjIwMTggNi40Mjc3M0MxMi40MTcxIDYuNjQzMDcgMTIuNDE3MSA2Ljk5MjIgMTIuMjAxOCA3LjIwNzUzQzExLjk4NjQgNy40MjI4NyAxMS42MzczIDcuNDIyODcgMTEuNDIyIDcuMjA3NTNMOC4zMDI3MyA0LjA4ODMxTDUuMTgzNTEgNy4yMDc1M0M0Ljk2ODE3IDcuNDIyODcgNC42MTkwNCA3LjQyMjg3IDQuNDAzNyA3LjIwNzUzQzQuMTg4MzcgNi45OTIyIDQuMTg4MzcgNi42NDMwNyA0LjQwMzcgNi40Mjc3M0w3LjkxMjgzIDIuOTE4NlpNNy43NTEzMyA5LjA5Mzk5TDcuNzUxMzMgMy4zMDg1TDguODU0MTQgMy4zMDg1TDguODU0MTQgOS4wOTM5OUw3Ljc1MTMzIDkuMDkzOTlaIiBmaWxsPSIjMDQyMTIxIi8+CjxsaW5lIHgxPSIzLjg5MTM2IiB5MT0iMTEuNTc5NSIgeDI9IjEyLjcxMzkiIHkyPSIxMS41Nzk1IiBzdHJva2U9IiMwNDIxMjEiIHN0cm9rZS13aWR0aD0iMS4xMDI4MSIvPgo8L3N2Zz4K);--sort-desc-icon--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMTY4MzIgNi4zNDU0NkM3LjE2ODMyIDYuMDQwOTMgNy40MTUxOSA1Ljc5NDA1IDcuNzE5NzMgNS43OTQwNUM4LjAyNDI2IDUuNzk0MDUgOC4yNzExMyA2LjA0MDkzIDguMjcxMTMgNi4zNDU0Nkw3LjE2ODMyIDYuMzQ1NDZaTTguMTA5NjMgMTIuNTIwOUM3Ljg5NDI5IDEyLjczNjIgNy41NDUxNiAxMi43MzYyIDcuMzI5ODIgMTIuNTIwOUwzLjgyMDcgOS4wMTE3MkMzLjYwNTM2IDguNzk2MzkgMy42MDUzNiA4LjQ0NzI2IDMuODIwNyA4LjIzMTkyQzQuMDM2MDMgOC4wMTY1OCA0LjM4NTE2IDguMDE2NTggNC42MDA1IDguMjMxOTJMNy43MTk3MyAxMS4zNTExTDEwLjgzOSA4LjIzMTkyQzExLjA1NDMgOC4wMTY1OCAxMS40MDM0IDguMDE2NTggMTEuNjE4OCA4LjIzMTkyQzExLjgzNDEgOC40NDcyNiAxMS44MzQxIDguNzk2MzkgMTEuNjE4OCA5LjAxMTcyTDguMTA5NjMgMTIuNTIwOVpNOC4yNzExMyA2LjM0NTQ2TDguMjcxMTMgMTIuMTMwOUw3LjE2ODMyIDEyLjEzMDlMNy4xNjgzMiA2LjM0NTQ2TDguMjcxMTMgNi4zNDU0NloiIGZpbGw9IiMwNDIxMjEiLz4KPGxpbmUgeDE9IjEyLjEzMDkiIHkxPSIzLjg1OTc2IiB4Mj0iMy4zMDgzNiIgeTI9IjMuODU5NzYiIHN0cm9rZT0iIzA0MjEyMSIgc3Ryb2tlLXdpZHRoPSIxLjEwMjgxIi8+Cjwvc3ZnPgo=);--sort-col-asc-icon--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMTU3OTYgOC4zNzM5MkM2Ljg1MzQzIDguMzczOTIgNi42MDY1NSA4LjEyNzA0IDYuNjA2NTUgNy44MjI1MUM2LjYwNjU1IDcuNTE3OTggNi44NTM0MyA3LjI3MTEgNy4xNTc5NiA3LjI3MTFMNy4xNTc5NiA4LjM3MzkyWk0xMy4zMzM0IDcuNDMyNjFDMTMuNTQ4NyA3LjY0Nzk0IDEzLjU0ODcgNy45OTcwNyAxMy4zMzM0IDguMjEyNDFMOS44MjQyMyAxMS43MjE1QzkuNjA4ODkgMTEuOTM2OSA5LjI1OTc2IDExLjkzNjkgOS4wNDQ0MiAxMS43MjE1QzguODI5MDggMTEuNTA2MiA4LjgyOTA4IDExLjE1NzEgOS4wNDQ0MiAxMC45NDE3TDEyLjE2MzYgNy44MjI1MUw5LjA0NDQyIDQuNzAzMjlDOC44MjkwOCA0LjQ4Nzk1IDguODI5MDggNC4xMzg4MiA5LjA0NDQyIDMuOTIzNDhDOS4yNTk3NiAzLjcwODE0IDkuNjA4ODkgMy43MDgxNCA5LjgyNDIyIDMuOTIzNDhMMTMuMzMzNCA3LjQzMjYxWk03LjE1Nzk2IDcuMjcxMUwxMi45NDM0IDcuMjcxMUwxMi45NDM0IDguMzczOTJMNy4xNTc5NiA4LjM3MzkyTDcuMTU3OTYgNy4yNzExWiIgZmlsbD0iIzA0MjEyMSIvPgo8bGluZSB4MT0iNC42NzIyNiIgeTE9IjMuNDExMTMiIHgyPSI0LjY3MjI2IiB5Mj0iMTIuMjMzNiIgc3Ryb2tlPSIjMDQyMTIxIiBzdHJva2Utd2lkdGg9IjEuMTAyODEiLz4KPC9zdmc+Cg==);--sort-col-desc-icon--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuOTk5MjcgNy4yNzExQzEwLjMwMzggNy4yNzExIDEwLjU1MDcgNy41MTc5OCAxMC41NTA3IDcuODIyNTFDMTAuNTUwNyA4LjEyNzA0IDEwLjMwMzggOC4zNzM5MiA5Ljk5OTI3IDguMzczOTJMOS45OTkyNyA3LjI3MTFaTTMuODIzODcgOC4yMTI0MUMzLjYwODU0IDcuOTk3MDggMy42MDg1NCA3LjY0Nzk1IDMuODIzODcgNy40MzI2MUw3LjMzMyAzLjkyMzQ4QzcuNTQ4MzQgMy43MDgxNCA3Ljg5NzQ3IDMuNzA4MTQgOC4xMTI4MSAzLjkyMzQ4QzguMzI4MTQgNC4xMzg4MiA4LjMyODE0IDQuNDg3OTUgOC4xMTI4MSA0LjcwMzI5TDQuOTkzNTggNy44MjI1MUw4LjExMjgxIDEwLjk0MTdDOC4zMjgxNSAxMS4xNTcxIDguMzI4MTUgMTEuNTA2MiA4LjExMjgxIDExLjcyMTVDNy44OTc0NyAxMS45MzY5IDcuNTQ4MzQgMTEuOTM2OSA3LjMzMyAxMS43MjE1TDMuODIzODcgOC4yMTI0MVpNOS45OTkyNyA4LjM3MzkyTDQuMjEzNzggOC4zNzM5Mkw0LjIxMzc4IDcuMjcxMUw5Ljk5OTI3IDcuMjcxMUw5Ljk5OTI3IDguMzczOTJaIiBmaWxsPSIjMDQyMTIxIi8+CjxsaW5lIHgxPSIxMi40ODQ3IiB5MT0iMTIuMjMzNiIgeDI9IjEyLjQ4NDciIHkyPSIzLjQxMTE0IiBzdHJva2U9IiMwNDIxMjEiIHN0cm9rZS13aWR0aD0iMS4xMDI4MSIvPgo8L3N2Zz4K);--sort-abs-asc-icon--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNjc5OTYgMTIuMjMzNkg3LjE5ODYzVjguMzczNzlINS4xMzA4Nkw4LjQzOTMgMy40MTExM0wxMS43NDc3IDguMzczNzlIOS42Nzk5NlYxMi4yMzM2WiIgc3Ryb2tlPSIjMDQyMTIxIiBzdHJva2Utd2lkdGg9IjEuMTAyODEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K);--sort-abs-desc-icon--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMTA1OTMgMy40MTExNEw5LjU4NzI2IDMuNDExMTRMOS41ODcyNiA3LjI3MDk5TDExLjY1NSA3LjI3MDk5TDguMzQ2NTkgMTIuMjMzNkw1LjAzODE1IDcuMjcwOTlMNy4xMDU5MyA3LjI3MDk5TDcuMTA1OTMgMy40MTExNFoiIHN0cm9rZT0iIzA0MjEyMSIgc3Ryb2tlLXdpZHRoPSIxLjEwMjgxIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==);--sort-abs-col-asc-icon--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNzQ3ODEgOS4wNjMwMkwzLjc0NzgxIDYuNTgxNjlMNy42MDc2NiA2LjU4MTY5TDcuNjA3NjYgNC41MTM5MkwxMi41NzAzIDcuODIyMzVMNy42MDc2NiAxMS4xMzA4TDcuNjA3NjYgOS4wNjMwMkwzLjc0NzgxIDkuMDYzMDJaIiBzdHJva2U9IiMwNDIxMjEiIHN0cm9rZS13aWR0aD0iMS4xMDI4MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=);--sort-abs-col-desc-icon--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjY2MzEgNi41ODE3NkwxMi42NjMxIDkuMDYzMDlMOC44MDMyMyA5LjA2MzA5TDguODAzMjMgMTEuMTMwOUwzLjg0MDU4IDcuODIyNDJMOC44MDMyMyA0LjUxMzk5TDguODAzMjMgNi41ODE3NkwxMi42NjMxIDYuNTgxNzZaIiBzdHJva2U9IiMwNDIxMjEiIHN0cm9rZS13aWR0aD0iMS4xMDI4MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=);--sort-none-icon--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeDE9IjMuOTg0MTMiIHkxPSI4LjI3MTEiIHgyPSIxMi44MDY2IiB5Mj0iOC4yNzExIiBzdHJva2U9IiMwNDIxMjEiIHN0cm9rZS13aWR0aD0iMS4xMDI4MSIvPgo8L3N2Zz4K);--add-expression-icon--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxwYXRoIGQ9Ik0gMTUuOTE1IDguNTU1IEwgMTAuMjEzIDE0LjI1NyIgc3Ryb2tlLXdpZHRoPSIxLjAwNDkxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0eWxlPSJzdHJva2U6ICMwNDIxMjEiPgogICAgPC9wYXRoPgogICAgPHBhdGgKICAgICAgICBkPSJNIDEuNjE2IDE0LjMzIEwgMy4yNTEgMTQuMzMgQyA0LjI4IDE0LjMzIDUuMTU4IDEzLjU4NiA1LjMyNyAxMi41NzEgTCA2LjU4NCA0Ljk5MiBDIDYuNzUyIDMuOTc2IDcuNjMgMy4yMzIgOC42NiAzLjIzMiBMIDExLjM0NyAzLjIzMiIKICAgICAgICBzdHJva2Utd2lkdGg9IjEuMDA0OTEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3R5bGU9InN0cm9rZTojMDQyMTIxIj48L3BhdGg+CiAgICA8cGF0aCBkPSJNIDEwLjIxMiA4LjU1NSBMIDE1LjkxNCAxNC4yNTciIHN0cm9rZS13aWR0aD0iMS4wMDQ5MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHlsZT0ic3Ryb2tlOiAjMDQyMTIxIj4KICAgIDwvcGF0aD4KPC9zdmc+);--close-icon--mask-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxsaW5lIHkxPSItMC41IiB4Mj0iMTMuNDUzNiIgeTI9Ii0wLjUiIHRyYW5zZm9ybT0ibWF0cml4KDAuNjY4OTY1IDAuNzQzMjk0IC0wLjY2ODk2NSAwLjc0MzI5NCA2IDYpIgogICAgICAgIHN0cm9rZT0iIzA0MjEyMSIgLz4KICAgIDxsaW5lIHkxPSItMC41IiB4Mj0iMTMuNDUzNiIgeTI9Ii0wLjUiIHRyYW5zZm9ybT0ibWF0cml4KC0wLjY2ODk2NSAwLjc0MzI5NCAwLjY2ODk2NSAwLjc0MzI5NCAxNiA2KSIKICAgICAgICBzdHJva2U9IiMwNDIxMjEiIC8+Cjwvc3ZnPg==);--inactive-column-selector--content:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHJ4PSIxLjUiIHN0cm9rZT0iI0ZGRkZGRiIgLz4KPC9zdmc+);--active-column-selector--content:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxwYXRoCiAgICAgICAgZD0iTSAyIDAgTCAxMiAwIEMgMTMuMTA1IDAgMTQgMC44OTUgMTQgMiBMIDE0IDEyIEMgMTQgMTMuMTA1IDEzLjEwNSAxNCAxMiAxNCBMIDIgMTQgQyAwLjg5NSAxNCAwIDEzLjEwNSAwIDEyIEwgMCAyIEMgMCAwLjg5NSAwLjg5NSAwIDIgMCBaIE0gMy42NDYgNy4zNTQgTCA1LjY0NiA5LjM1NCBMIDYgOS43MDcgTCA2LjM1NCA5LjM1NCBMIDEwLjg1NCA0Ljg1NCBMIDEwLjE0NiA0LjE0NiBMIDYgOC4yOTMgTCA0LjM1NCA2LjY0NiBaIgogICAgICAgIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgIDxwYXRoIGQ9Ik00IDdMNiA5TDEwLjUgNC41IiBzdHlsZT0idmlzaWJpbGl0eTogaGlkZGVuOyI+PC9wYXRoPgo8L3N2Zz4=);--overflow-hint-icon--content:\"!\";--reset-button-icon--content:\"refresh\";--save-button-icon--content:\"save\";color:#161616;--icon--color:#161616;--inactive--color:#ababab;--inactive--border-color:#dadada;--root--background:#fff;--active--color:#2670a9;--error--color:#ff471e;--plugin--background:#fff;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:#042121;--warning--color:#fdfffd;--column-style-open-button--content:\"style\";--column-style-close-button--content:\"> style\";--tree-label-collapse--content:\"-\";--tree-label-expand--content:\"+\";--toolbar-scroll-lock--content:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNi41IiB5PSI4LjUiIHdpZHRoPSI4IiBoZWlnaHQ9IjciIHN0cm9rZT0iIzA0MjEyMSIvPgo8cGF0aCBkPSJNOCA4VjcuODA3NzZDOCA2LjI1NzA4IDkuMjU3MDggNSAxMC44MDc4IDVIMTAuOTM4NEMxMi4xNSA1IDEzLjIwNjEgNS44MjQ1OSAxMy41IDdWNyIgc3Ryb2tlPSIjMDQyMTIxIi8+CjxwYXRoIGQ9Ik0xMS41IDEyQzExLjUgMTIuNTUyMyAxMS4wNTIzIDEzIDEwLjUgMTNDOS45NDc3MiAxMyA5LjUgMTIuNTUyMyA5LjUgMTJDOS41IDExLjQ0NzcgOS45NDc3MiAxMSAxMC41IDExQzExLjA1MjMgMTEgMTEuNSAxMS40NDc3IDExLjUgMTJaIiBmaWxsPSIjMDQyMTIxIi8+Cjwvc3ZnPgo=);--toolbar-scroll-lock-active--content:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNi41IiB5PSI5LjUiIHdpZHRoPSI4IiBoZWlnaHQ9IjciIHN0cm9rZT0iIzA0MjEyMSIvPgo8cGF0aCBkPSJNMTMgOVY4LjVDMTMgNy4xMTkyOSAxMS44ODA3IDYgMTAuNSA2VjZDOS4xMTkyOSA2IDggNy4xMTkyOSA4IDguNVY5IiBzdHJva2U9IiMwNDIxMjEiLz4KPHBhdGggZD0iTTExLjQ5MTEgMTNDMTEuNDkxMSAxMy41NTIzIDExLjA0MzQgMTQgMTAuNDkxMSAxNEM5LjkzODc4IDE0IDkuNDkxMDcgMTMuNTUyMyA5LjQ5MTA3IDEzQzkuNDkxMDcgMTIuNDQ3NyA5LjkzODc4IDEyIDEwLjQ5MTEgMTJDMTEuMDQzNCAxMiAxMS40OTExIDEyLjQ0NzcgMTEuNDkxMSAxM1oiIGZpbGw9IiMwNDIxMjEiLz4KPGxpbmUgeDE9IjQuNSIgeTE9IjUiIHgyPSI0LjUiIHkyPSIxNyIgc3Ryb2tlPSIjMDQyMTIxIi8+CjxsaW5lIHgxPSIxNi41IiB5MT0iNSIgeDI9IjE2LjUiIHkyPSIxNyIgc3Ryb2tlPSIjMDQyMTIxIi8+Cjwvc3ZnPgo=);--toolbar-edit-mode--content:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgNkwxNC41IDE1LjUiIHN0cm9rZT0iIzA0MjEyMSIvPgo8cGF0aCBkPSJNOSAxMEw1IDE0VjE2SDdMMTEgMTIiIHN0cm9rZT0iIzA0MjEyMSIvPgo8cGF0aCBkPSJNMTMgMTAuNUwxMC41IDhMMTIgNi41TDE0LjUgOUwxMyAxMC41WiIgZmlsbD0iIzA0MjEyMSIvPgo8cGF0aCBkPSJNMTUgOC41TDEyLjUgNkwxMy43OTI5IDQuNzA3MTFDMTQuMTgzNCA0LjMxNjU4IDE0LjgxNjYgNC4zMTY1OCAxNS4yMDcxIDQuNzA3MTFMMTYuMjkyOSA1Ljc5Mjg5QzE2LjY4MzQgNi4xODM0MiAxNi42ODM0IDYuODE2NTggMTYuMjkyOSA3LjIwNzExTDE1IDguNVoiIGZpbGw9IiMwNDIxMjEiLz4KPC9zdmc+Cg==);--toolbar-edit-mode-active--content:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMTRMMTMuNzkyOSA1LjIwNzExQzE0LjE4MzQgNC44MTY1OCAxNC44MTY2IDQuODE2NTggMTUuMjA3MSA1LjIwNzExTDE1Ljc5MjkgNS43OTI4OUMxNi4xODM0IDYuMTgzNDIgMTYuMTgzNCA2LjgxNjU4IDE1Ljc5MjkgNy4yMDcxMUw3IDE2SDVWMTRaIiBzdHJva2U9IiMwNDIxMjEiLz4KPHBhdGggZD0iTTEzIDEwLjVMMTAuNSA4TDEyIDYuNUwxNC41IDlMMTMgMTAuNVoiIGZpbGw9IiMwNDIxMjEiLz4KPHBhdGggZD0iTTE1IDguNUwxMi41IDZMMTMuNzkyOSA0LjcwNzExQzE0LjE4MzQgNC4zMTY1OCAxNC44MTY2IDQuMzE2NTggMTUuMjA3MSA0LjcwNzExTDE2LjI5MjkgNS43OTI4OUMxNi42ODM0IDYuMTgzNDIgMTYuNjgzNCA2LjgxNjU4IDE2LjI5MjkgNy4yMDcxMUwxNSA4LjVaIiBmaWxsPSIjMDQyMTIxIi8+Cjwvc3ZnPgo=);background-color:#0000}perspective-viewer,perspective-viewer[theme=Pro\\ Light]{--theme-name:\"Pro Light\"}perspective-viewer[theme=Pro\\ Light]{--button--font-size:16px;--config-button--padding:15px 8px 6px 8px;--column-drop-label--font-size:8px;--column-drop-container--padding:0px;--column-drop-label--display:inline-block;--column-selector--width:20px;--column-selector--font-size:16px;--column_type--width:25px;--select--padding:0px;--side-panel--padding:0px 0px 0px 4px;--top-panel--padding:0px 0px 12px 0px;--top-panel-row--display:inline-flex;--button--min-width:110px;color:#161616;--icon--color:#161616;--inactive--color:#ababab;--inactive--border-color:#dadada;--root--background:#fff;--active--color:#2670a9;--error--color:#ff471e;--plugin--background:#fff;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:#042121;--warning--color:#fdfffd;--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;--d3fc-y1-label--content:\"arrow_upward\";--d3fc-y2-label--content:\"arrow_downward\";--d3fc-treedata-axis--lines:none;--d3fc-tooltip--background--color:#9b9b9bcc;--d3fc-tooltip--color:#161616;--d3fc-tooltip--border-color:#fff;--d3fc-tooltip--box-shadow:0 2px 4px 0 #0000001a;--d3fc-gridline--color:#eaedef;--d3fc-axis-ticks--color:#161616;--d3fc-axis--lines:#c5c9d0;--d3fc-legend--background:var(--plugin--background);--d3fc-series:#1f77b4cc;--d3fc-series-1:#0366d6;--d3fc-series-2:#ff7f0e;--d3fc-series-3:#2ca02c;--d3fc-series-4:#d62728;--d3fc-series-5:#9467bd;--d3fc-series-6:#8c564b;--d3fc-series-7:#e377c2;--d3fc-series-8:#7f7f7f;--d3fc-series-9:#bcbd22;--d3fc-series-10:#17becf;--d3fc-full--gradient:linear-gradient(#4d342f 0%,#e4521b 22.5%,#feeb65 42.5%,#f0f0f0 50%,#dcedc8 57.5%,#42b3d5 67.5%,#1a237e 100%);--d3fc-positive--gradient:linear-gradient(#f0f0f0 0%,#dcedc8 10%,#42b3d5 50%,#1a237e 100%);--d3fc-negative--gradient:linear-gradient(#4d342f 0%,#e4521b 50%,#feeb65 90%,#f0f0f0 100%);--rt-pos-cell--color:#338dcd;--rt-neg-cell--color:#ff471e;--map-tile-url:\"http://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png\";--map-element-background:#fff;--map-category-1:#0366d6;--map-category-2:#ff7f0e;--map-category-3:#2ca02c;--map-category-4:#d62728;--map-category-5:#9467bd;--map-category-6:#8c564b;--map-category-7:#e377c2;--map-category-8:#7f7f7f;--map-category-9:#bcbd22;--map-category-10:#17becf;--map-gradient:linear-gradient(#4d342f 0%,#e4521b 22.5%,#feeb65 42.5%,#f0f0f0 50%,#dcedc8 57.5%,#42b3d5 67.5%,#1a237e 100%);background-color:#0000;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace}perspective-copy-menu[theme=Pro\\ Light],perspective-export-menu[theme=Pro\\ Light],perspective-dropdown[theme=Pro\\ Light],perspective-date-column-style[theme=Pro\\ Light],perspective-datetime-column-style[theme=Pro\\ Light],perspective-number-column-style[theme=Pro\\ Light],perspective-string-column-style[theme=Pro\\ Light]{border:1px solid var(--inactive--color);--column-style-pos-color--content:\"+\";--column-style-neg-color--content:\"-\";--save-button-icon--content:\"save\";--reset-button-icon--content:\"refresh\";--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;color:#161616;--icon--color:#161616;--inactive--color:#ababab;--inactive--border-color:#dadada;--root--background:#fff;--active--color:#2670a9;--error--color:#ff471e;--plugin--background:#fff;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:#042121;--warning--color:#fdfffd;background-color:#fff;border-radius:0 0 2px 2px;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace}perspective-viewer,perspective-viewer[theme=Pro\\ Dark]{--theme-name:\"Pro Dark\"}perspective-viewer[theme=Pro\\ Dark]{--button--font-size:16px;--config-button--padding:15px 8px 6px 8px;--column-drop-label--font-size:8px;--column-drop-container--padding:0px;--column-drop-label--display:inline-block;--column-selector--width:20px;--column-selector--font-size:16px;--column_type--width:25px;--select--padding:0px;--side-panel--padding:0px 0px 0px 4px;--top-panel--padding:0px 0px 12px 0px;--top-panel-row--display:inline-flex;--button--min-width:110px;color:#fff;--icon--color:white;--inactive--color:#61656e;--inactive--border-color:#4c505b;--root--background:#fff;--active--color:#2770a9;--error--color:#ff9485;--plugin--background:#242526;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:var(--icon--color);--warning--color:#242526;--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;--d3fc-y1-label--content:\"arrow_upward\";--d3fc-y2-label--content:\"arrow_downward\";--d3fc-treedata-axis--lines:none;--d3fc-tooltip--background--color:#9b9b9bcc;--d3fc-tooltip--color:white;--d3fc-tooltip--border-color:#242526;--d3fc-tooltip--box-shadow:0 2px 4px 0 #0000001a;--d3fc-gridline--color:#3b3f46;--d3fc-axis-ticks--color:#c5c9d0;--d3fc-axis--lines:#61656e;--d3fc-legend--background:var(--plugin--background);--d3fc-series:#4778c2;--d3fc-series-1:#4778c2;--d3fc-series-2:#cc7830;--d3fc-series-3:#9e54c0;--d3fc-series-4:#339699;--d3fc-series-5:#66728f;--d3fc-series-6:#d367bd;--d3fc-series-7:#6d7c4d;--d3fc-series-8:#dd6367;--d3fc-series-9:#7868ce;--d3fc-series-10:#17a67b;--d3fc-full--gradient:linear-gradient(#dd6367 0%,#242526 50%,#3289c8 100%);--d3fc-positive--gradient:linear-gradient(#242526 0%,#3289c8 100%);--d3fc-negative--gradient:linear-gradient(#dd6367 0%,#242526 100%);--rt-pos-cell--color:#7dc3f0;--rt-neg-cell--color:#ff9485;--map-tile-url:\"http://{a-c}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png\";--map-element-background:#212c2f;--map-category-1:#4778c2;--map-category-2:#cc7830;--map-category-3:#9e54c0;--map-category-4:#339699;--map-category-5:#66728f;--map-category-6:#d367bd;--map-category-7:#6d7c4d;--map-category-8:#dd6367;--map-category-9:#7868ce;--map-category-10:#17a67b;--map-gradient:linear-gradient(#dd6367 0%,#242526 50%,#3289c8 100%);--modal-target--background:#ffffff0d;--active--background:#2771aa80;--expression--operator-color:#c5c9d0;--expression--function-color:#22a0ce;--expression--error-color:#f88;--calendar--filter:invert(1);--float--column-type--color:#7dc3f0;--string--column-type--color:#ff9485;--date--column-type--color:@green50;--boolean--column-type--color:@orange50;--code-editor-symbol--color:white;--code-editor-literal--color:#7dc3f0;--code-editor-operator--color:#17a67b;--code-editor-comment--color:#cc7830;--code-editor-column--color:#e18ee1;--d3fc-legend--text:#c5c9d0;--d3fc-treedata--labels:white;--d3fc-treedata--hover-highlight:white;--d3fc-tooltip--background:#2a2c2f;--map-attribution--filter:invert(1)hue-rotate(180deg);background-color:#242526;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace}perspective-copy-menu[theme=Pro\\ Dark],perspective-export-menu[theme=Pro\\ Dark],perspective-dropdown[theme=Pro\\ Dark],perspective-date-column-style[theme=Pro\\ Dark],perspective-datetime-column-style[theme=Pro\\ Dark],perspective-number-column-style[theme=Pro\\ Dark],perspective-string-column-style[theme=Pro\\ Dark]{border:1px solid var(--inactive--color);--column-style-pos-color--content:\"+\";--column-style-neg-color--content:\"-\";--save-button-icon--content:\"save\";--reset-button-icon--content:\"refresh\";--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;color:#fff;--icon--color:white;--inactive--color:#61656e;--inactive--border-color:#4c505b;--root--background:#fff;--active--color:#2770a9;--error--color:#ff9485;--plugin--background:#242526;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:var(--icon--color);--warning--color:#242526;--modal-target--background:#ffffff0d;--active--background:#2771aa80;--expression--operator-color:#c5c9d0;--expression--function-color:#22a0ce;--expression--error-color:#f88;--calendar--filter:invert(1);--float--column-type--color:#7dc3f0;--string--column-type--color:#ff9485;--date--column-type--color:@green50;--boolean--column-type--color:@orange50;--code-editor-symbol--color:white;--code-editor-literal--color:#7dc3f0;--code-editor-operator--color:#17a67b;--code-editor-comment--color:#cc7830;--code-editor-column--color:#e18ee1;background-color:#242526;border:1px solid #4c505b;border-radius:0 0 2px 2px;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace}perspective-viewer,perspective-viewer[theme=Monokai]{--theme-name:\"Monokai\"}perspective-viewer[theme=Monokai]{--button--font-size:16px;--config-button--padding:15px 8px 6px 8px;--column-drop-label--font-size:8px;--column-drop-container--padding:0px;--column-drop-label--display:inline-block;--column-selector--width:20px;--column-selector--font-size:16px;--column_type--width:25px;--select--padding:0px;--side-panel--padding:0px 0px 0px 4px;--top-panel--padding:0px 0px 12px 0px;--top-panel-row--display:inline-flex;--button--min-width:110px;color:#d6d6d6;--icon--color:white;--inactive--color:#797979;--inactive--border-color:#666;--root--background:#fff;--active--color:#78dce8;--error--color:#ff6188;--plugin--background:#2d2a2e;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:#ffd866;--warning--color:#242526;--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;--d3fc-y1-label--content:\"arrow_upward\";--d3fc-y2-label--content:\"arrow_downward\";--d3fc-treedata-axis--lines:none;--d3fc-tooltip--background--color:#9b9b9bcc;--d3fc-tooltip--color:white;--d3fc-tooltip--border-color:#242526;--d3fc-tooltip--box-shadow:0 2px 4px 0 #0000001a;--d3fc-gridline--color:#3b3f46;--d3fc-axis-ticks--color:#c5c9d0;--d3fc-axis--lines:#61656e;--d3fc-legend--background:var(--plugin--background);--d3fc-series:#4778c2;--d3fc-series-1:#4778c2;--d3fc-series-2:#cc7830;--d3fc-series-3:#9e54c0;--d3fc-series-4:#339699;--d3fc-series-5:#66728f;--d3fc-series-6:#d367bd;--d3fc-series-7:#6d7c4d;--d3fc-series-8:#dd6367;--d3fc-series-9:#7868ce;--d3fc-series-10:#17a67b;--d3fc-full--gradient:linear-gradient(#dd6367 0%,#242526 50%,#3289c8 100%);--d3fc-positive--gradient:linear-gradient(#242526 0%,#3289c8 100%);--d3fc-negative--gradient:linear-gradient(#dd6367 0%,#242526 100%);--rt-pos-cell--color:#7dc3f0;--rt-neg-cell--color:#ff9485;--map-tile-url:\"http://{a-c}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png\";--map-element-background:#212c2f;--map-category-1:#4778c2;--map-category-2:#cc7830;--map-category-3:#9e54c0;--map-category-4:#339699;--map-category-5:#66728f;--map-category-6:#d367bd;--map-category-7:#6d7c4d;--map-category-8:#dd6367;--map-category-9:#7868ce;--map-category-10:#17a67b;--map-gradient:linear-gradient(#dd6367 0%,#242526 50%,#3289c8 100%);--modal-target--background:#ffffff0d;--active--background:#2771aa80;--expression--operator-color:#c5c9d0;--expression--function-color:#22a0ce;--expression--error-color:#f88;--calendar--filter:invert(1);--float--column-type--color:#78dce8;--string--column-type--color:#ff6188;--date--column-type--color:#a9dc76;--boolean--column-type--color:#ffd866;--code-editor-symbol--color:white;--code-editor-literal--color:#7dc3f0;--code-editor-operator--color:#17a67b;--code-editor-comment--color:#cc7830;--code-editor-column--color:#e18ee1;--d3fc-legend--text:#c5c9d0;--d3fc-treedata--labels:white;--d3fc-treedata--hover-highlight:white;--d3fc-tooltip--background:#2a2c2f;--map-attribution--filter:invert(1)hue-rotate(180deg);--rt--border-color:#444;background-color:#2d2a2e;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace;--rt-pos-cell--color:#78dce8!important;--rt-neg-cell--color:#ff6188!important}perspective-viewer[theme=Monokai] regular-table table tbody th:empty{background:linear-gradient(90deg,#0000 9px,#444 10px,#0000 11px)}perspective-viewer[theme=Monokai]{--d3fc-treedata--labels:#d6d6d6;--d3fc-treedata--hover-highlight:#2d2a2e;--d3fc-axis-ticks--color:#d6d6d6;--d3fc-gridline--color:#444;--d3fc-series:#78dce8;--d3fc-series-1:#78dce8;--d3fc-series-2:#ff6188;--d3fc-series-3:#fc9867;--d3fc-series-4:#ffd866;--d3fc-series-5:#a9dc76;--d3fc-series-6:#ab9df2;--d3fc-series-7:#66d9ef;--d3fc-series-8:#f92672;--d3fc-series-9:#fd971f;--d3fc-series-10:#e6db74;--d3fc-series-11:#a6e22e;--d3fc-series-12:#ae81ff;--d3fc-negative--gradient:linear-gradient(#272822 0%,#ff6188 100%);--d3fc-positive--gradient:linear-gradient(#272822 0%,#78dce8 100%);--d3fc-full--gradient:linear-gradient(#ff6188 0%,#272822 50%,#78dce8 100%)}perspective-copy-menu[theme=Monokai],perspective-export-menu[theme=Monokai],perspective-dropdown[theme=Monokai],perspective-date-column-style[theme=Monokai],perspective-datetime-column-style[theme=Monokai],perspective-number-column-style[theme=Monokai],perspective-string-column-style[theme=Monokai]{border:1px solid var(--inactive--color);--column-style-pos-color--content:\"+\";--column-style-neg-color--content:\"-\";--save-button-icon--content:\"save\";--reset-button-icon--content:\"refresh\";--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;color:#d6d6d6;--icon--color:white;--inactive--color:#797979;--inactive--border-color:#666;--root--background:#fff;--active--color:#78dce8;--error--color:#ff6188;--plugin--background:#2d2a2e;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:#ffd866;--warning--color:#242526;--modal-target--background:#ffffff0d;--active--background:#2771aa80;--expression--operator-color:#c5c9d0;--expression--function-color:#22a0ce;--expression--error-color:#f88;--calendar--filter:invert(1);--float--column-type--color:#78dce8;--string--column-type--color:#ff6188;--date--column-type--color:#a9dc76;--boolean--column-type--color:#ffd866;--code-editor-symbol--color:white;--code-editor-literal--color:#7dc3f0;--code-editor-operator--color:#17a67b;--code-editor-comment--color:#cc7830;--code-editor-column--color:#e18ee1;background-color:#2d2a2e;border:1px solid #797979;border-radius:0 0 2px 2px;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace}perspective-viewer,perspective-viewer[theme=Solarized]{--theme-name:\"Solarized\"}perspective-viewer[theme=Solarized]{--button--font-size:16px;--config-button--padding:15px 8px 6px 8px;--column-drop-label--font-size:8px;--column-drop-container--padding:0px;--column-drop-label--display:inline-block;--column-selector--width:20px;--column-selector--font-size:16px;--column_type--width:25px;--select--padding:0px;--side-panel--padding:0px 0px 0px 4px;--top-panel--padding:0px 0px 12px 0px;--top-panel-row--display:inline-flex;--button--min-width:110px;color:#586e75;--icon--color:#586e75;--inactive--color:#93a1a1;--inactive--border-color:var(--inactive--color);--root--background:#fff;--active--color:#268bd2;--error--color:#cb4b16;--plugin--background:#fdf6e3;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:#042121;--warning--color:#fdfffd;--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;--d3fc-y1-label--content:\"arrow_upward\";--d3fc-y2-label--content:\"arrow_downward\";--d3fc-treedata-axis--lines:none;--d3fc-tooltip--background--color:#9b9b9bcc;--d3fc-tooltip--color:#161616;--d3fc-tooltip--border-color:#fff;--d3fc-tooltip--box-shadow:0 2px 4px 0 #0000001a;--d3fc-gridline--color:#eee8d5;--d3fc-axis-ticks--color:#586e75;--d3fc-axis--lines:#c5c9d0;--d3fc-legend--background:var(--plugin--background);--d3fc-series:#268bd2;--d3fc-series-1:#268bd2;--d3fc-series-2:#cb4b16;--d3fc-series-3:#b58900;--d3fc-series-4:#859900;--d3fc-series-5:#2aa198;--d3fc-series-6:#6c71c4;--d3fc-series-7:#d33682;--d3fc-series-8:#7f7f7f;--d3fc-series-9:#bcbd22;--d3fc-series-10:#17becf;--d3fc-full--gradient:linear-gradient(#4d342f 0%,#e4521b 22.5%,#feeb65 42.5%,#f0f0f0 50%,#dcedc8 57.5%,#42b3d5 67.5%,#1a237e 100%);--d3fc-positive--gradient:linear-gradient(#268bd2 0%,#2aa198,#859900,#b58900,#cb4b16,#dc322f,#d33682 100%);--d3fc-negative--gradient:linear-gradient(#4d342f 0%,#e4521b 50%,#feeb65 90%,#f0f0f0 100%);--rt-pos-cell--color:#338dcd;--rt-neg-cell--color:#ff471e;--map-tile-url:\"http://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png\";--map-element-background:#fff;--map-category-1:#0366d6;--map-category-2:#ff7f0e;--map-category-3:#2ca02c;--map-category-4:#d62728;--map-category-5:#9467bd;--map-category-6:#8c564b;--map-category-7:#e377c2;--map-category-8:#7f7f7f;--map-category-9:#bcbd22;--map-category-10:#17becf;--map-gradient:linear-gradient(#4d342f 0%,#e4521b 22.5%,#feeb65 42.5%,#f0f0f0 50%,#dcedc8 57.5%,#42b3d5 67.5%,#1a237e 100%);--float--column-type--color:#268bd2;--string--column-type--color:#cb4b16;--date--column-type--color:#2aa198;--boolean--column-type--color:#b58900;--rt-hover--border-color:#ccc;--rt--border-color:#93a1a1;--d3fc-treedata--labels:black;--d3fc-treedata--hover-highlight:black;background-color:#eee8d5;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace;--rt-pos-cell--color:#268bd2!important;--rt-neg-cell--color:#cb4b16!important}perspective-copy-menu[theme=Solarized],perspective-export-menu[theme=Solarized],perspective-dropdown[theme=Solarized],perspective-date-column-style[theme=Solarized],perspective-datetime-column-style[theme=Solarized],perspective-number-column-style[theme=Solarized],perspective-string-column-style[theme=Solarized]{border:1px solid var(--inactive--color);--column-style-pos-color--content:\"+\";--column-style-neg-color--content:\"-\";--save-button-icon--content:\"save\";--reset-button-icon--content:\"refresh\";--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;color:#586e75;--icon--color:#586e75;--inactive--color:#93a1a1;--inactive--border-color:var(--inactive--color);--root--background:#fff;--active--color:#268bd2;--error--color:#cb4b16;--plugin--background:#fdf6e3;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:#042121;--warning--color:#fdfffd;--float--column-type--color:#268bd2;--string--column-type--color:#cb4b16;--date--column-type--color:#2aa198;--boolean--column-type--color:#b58900;background-color:#fdf6e3;border-radius:0 0 2px 2px;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace}x{color:#cb4b16}perspective-viewer,perspective-viewer[theme=Solarized\\ Dark]{--theme-name:\"Solarized Dark\"}perspective-viewer[theme=Solarized\\ Dark]{color:#93a1a1;--icon--color:#586e75;--active--color:#268bd2;--error--color:#cb4b16;--inactive--color:#586e75;--inactive--border-color:var(--inactive--color);--plugin--background:#073642;--modal-target--background:#ffffff0d;--active--background:#2771aa80;--expression--operator-color:#c5c9d0;--expression--function-color:#22a0ce;--expression--error-color:#f88;--calendar--filter:invert(1);--warning--color:#fdfffd;--warning--background:#042121;--float--column-type--color:#268bd2;--string--column-type--color:#cb4b16;--date--column-type--color:#2aa198;--boolean--column-type--color:#b58900;--code-editor-symbol--color:white;--code-editor-literal--color:#7dc3f0;--code-editor-operator--color:#17a67b;--code-editor-comment--color:#cc7830;--code-editor-column--color:#e18ee1;--button--font-size:16px;--config-button--padding:15px 8px 6px 8px;--column-drop-label--font-size:8px;--column-drop-container--padding:0px;--column-drop-label--display:inline-block;--column-selector--width:20px;--column-selector--font-size:16px;--column_type--width:25px;--select--padding:0px;--side-panel--padding:0px 0px 0px 4px;--top-panel--padding:0px 0px 12px 0px;--top-panel-row--display:inline-flex;--button--min-width:110px;--root--background:#fff;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;--d3fc-y1-label--content:\"arrow_upward\";--d3fc-y2-label--content:\"arrow_downward\";--d3fc-treedata-axis--lines:none;--d3fc-tooltip--background--color:#9b9b9bcc;--d3fc-tooltip--color:#161616;--d3fc-tooltip--border-color:#fff;--d3fc-tooltip--box-shadow:0 2px 4px 0 #0000001a;--d3fc-gridline--color:#002b36;--d3fc-axis-ticks--color:#93a1a1;--d3fc-axis--lines:#93a1a1;--d3fc-legend--background:var(--plugin--background);--d3fc-series:#268bd2;--d3fc-series-1:#268bd2;--d3fc-series-2:#cb4b16;--d3fc-series-3:#b58900;--d3fc-series-4:#859900;--d3fc-series-5:#2aa198;--d3fc-series-6:#6c71c4;--d3fc-series-7:#d33682;--d3fc-series-8:#7f7f7f;--d3fc-series-9:#bcbd22;--d3fc-series-10:#17becf;--d3fc-full--gradient:linear-gradient(#cb4b16 0%,#073642 50%,#268bd2 100%);--d3fc-positive--gradient:linear-gradient(#268bd2 0%,#2aa198,#859900,#b58900,#cb4b16,#dc322f,#d33682 100%);--d3fc-negative--gradient:linear-gradient(#cb4b16 0%,#073642 100%);--rt-pos-cell--color:#338dcd;--rt-neg-cell--color:#ff471e;--map-tile-url:\"http://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png\";--map-element-background:#fff;--map-category-1:#0366d6;--map-category-2:#ff7f0e;--map-category-3:#2ca02c;--map-category-4:#d62728;--map-category-5:#9467bd;--map-category-6:#8c564b;--map-category-7:#e377c2;--map-category-8:#7f7f7f;--map-category-9:#bcbd22;--map-category-10:#17becf;--map-gradient:linear-gradient(#4d342f 0%,#e4521b 22.5%,#feeb65 42.5%,#f0f0f0 50%,#dcedc8 57.5%,#42b3d5 67.5%,#1a237e 100%);--rt-hover--border-color:#ccc;--rt--border-color:#93a1a1;--d3fc-treedata--labels:white;--d3fc-treedata--hover-highlight:white;--d3fc-legend--text:#93a1a1;background-color:#002b36;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace;--rt-pos-cell--color:#268bd2!important;--rt-neg-cell--color:#cb4b16!important}perspective-copy-menu[theme=Solarized\\ Dark],perspective-export-menu[theme=Solarized\\ Dark],perspective-dropdown[theme=Solarized\\ Dark],perspective-date-column-style[theme=Solarized\\ Dark],perspective-datetime-column-style[theme=Solarized\\ Dark],perspective-number-column-style[theme=Solarized\\ Dark],perspective-string-column-style[theme=Solarized\\ Dark]{border:1px solid var(--inactive--color);--column-style-pos-color--content:\"+\";--column-style-neg-color--content:\"-\";--save-button-icon--content:\"save\";--reset-button-icon--content:\"refresh\";--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;color:#93a1a1;--icon--color:#586e75;--inactive--color:#586e75;--inactive--border-color:var(--inactive--color);--root--background:#fff;--active--color:#268bd2;--error--color:#cb4b16;--plugin--background:#073642;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:#042121;--warning--color:#fdfffd;--float--column-type--color:#268bd2;--string--column-type--color:#cb4b16;--date--column-type--color:#2aa198;--boolean--column-type--color:#b58900;background-color:#073642;border-radius:0 0 2px 2px;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace}perspective-viewer,perspective-viewer[theme=Vaporwave]{--theme-name:\"Vaporwave\"}perspective-viewer[theme=Vaporwave]{--button--font-size:16px;--config-button--padding:15px 8px 6px 8px;--column-drop-label--font-size:8px;--column-drop-container--padding:0px;--column-drop-label--display:inline-block;--column-selector--width:20px;--column-selector--font-size:16px;--column_type--width:25px;--select--padding:0px;--side-panel--padding:0px 0px 0px 4px;--top-panel--padding:0px 0px 12px 0px;--top-panel-row--display:inline-flex;--button--min-width:110px;color:#49acff;--icon--color:#49acff;--inactive--color:#61656e;--inactive--border-color:var(--inactive--color);--root--background:#fff;--active--color:#2770a9;--error--color:#ff9485;--plugin--background:#242526;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:var(--icon--color);--warning--color:#242526;--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;--d3fc-y1-label--content:\"arrow_upward\";--d3fc-y2-label--content:\"arrow_downward\";--d3fc-treedata-axis--lines:none;--d3fc-tooltip--background--color:#9b9b9bcc;--d3fc-tooltip--color:white;--d3fc-tooltip--border-color:#242526;--d3fc-tooltip--box-shadow:0 2px 4px 0 #0000001a;--d3fc-gridline--color:#3b3f46;--d3fc-axis-ticks--color:#c5c9d0;--d3fc-axis--lines:#61656e;--d3fc-legend--background:var(--plugin--background);--d3fc-series:#4778c2;--d3fc-series-1:#4778c2;--d3fc-series-2:#cc7830;--d3fc-series-3:#9e54c0;--d3fc-series-4:#339699;--d3fc-series-5:#66728f;--d3fc-series-6:#d367bd;--d3fc-series-7:#6d7c4d;--d3fc-series-8:#dd6367;--d3fc-series-9:#7868ce;--d3fc-series-10:#17a67b;--d3fc-full--gradient:linear-gradient(#dd6367 0%,#242526 50%,#3289c8 100%);--d3fc-positive--gradient:linear-gradient(#242526 0%,#3289c8 100%);--d3fc-negative--gradient:linear-gradient(#dd6367 0%,#242526 100%);--rt-pos-cell--color:#7dc3f0;--rt-neg-cell--color:#ff9485;--map-tile-url:\"http://{a-c}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png\";--map-element-background:#212c2f;--map-category-1:#4778c2;--map-category-2:#cc7830;--map-category-3:#9e54c0;--map-category-4:#339699;--map-category-5:#66728f;--map-category-6:#d367bd;--map-category-7:#6d7c4d;--map-category-8:#dd6367;--map-category-9:#7868ce;--map-category-10:#17a67b;--map-gradient:linear-gradient(#dd6367 0%,#242526 50%,#3289c8 100%);--modal-target--background:#ffffff0d;--active--background:#2771aa80;--expression--operator-color:#c5c9d0;--expression--function-color:#22a0ce;--expression--error-color:#f88;--calendar--filter:invert(1);--float--column-type--color:#7dc3f0;--string--column-type--color:#ff9485;--date--column-type--color:@green50;--boolean--column-type--color:@orange50;--code-editor-symbol--color:white;--code-editor-literal--color:#7dc3f0;--code-editor-operator--color:#17a67b;--code-editor-comment--color:#cc7830;--code-editor-column--color:#e18ee1;--d3fc-legend--text:#c5c9d0;--d3fc-treedata--labels:white;--d3fc-treedata--hover-highlight:white;--d3fc-tooltip--background:#2a2c2f;--map-attribution--filter:invert(1)hue-rotate(180deg);--status-icon-updating-keyframes-start--filter:opacity(1);--status-icon-updating-keyframes-end--filter:opacity(0);--status-icon-updating-keyframes-start--transform:scale(1);--status-icon-updating-keyframes-end--transform:scale(.5);--status-icon-keyframes-start--transform:scale(1.25);--status-icon-keyframes-end--transform:scale(1);--pp-color-1:#092132;--pp-color-2:#42b6e6;background-color:#242526;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace;--inactive--color:#132132!important;--plugin--background:#07081d!important;--rt-pos-cell--color:#42b6e6!important;--rt-hover--border-color:var(--pp-color-1)!important;background-color:#07081d!important}perspective-viewer[theme=Vaporwave] regular-table table tbody th:empty{background:linear-gradient(90deg,#0000 9px,#132132 10px,#0000 11px) 0 -10px no-repeat}perspective-viewer[theme=Vaporwave]{--d3fc-axis-ticks--color:#49acff;--d3fc-gridline--color:#132132;--d3fc-series:#01cdfe;--d3fc-series-1:#01cdfe;--d3fc-series-2:#ff71ce;--d3fc-series-3:#05ffa1;--d3fc-series-4:#b967ff;--d3fc-series-5:#fffb96;--d3fc-series-6:#01667f;--d3fc-series-7:#b80077;--d3fc-series-8:#01667f;--d3fc-series-9:#00804f;--d3fc-series-10:#5f00b3;--d3fc-negative--gradient:linear-gradient(#f3d431,#efb92d,#ed9c25,#eb7e20,#e75d1e,#d14632,#b03e38,#8c3a36,#643633,#07081d)!important;--d3fc-positive--gradient:linear-gradient(#07081d,#2e4463,#1e588a,#086da7,#0082b9,#039ac7,#12b1d4,#2bc8e2,#3ddff0,#61f4fb)!important;--d3fc-full--gradient:linear-gradient(#f3d431,#efb92d,#ed9c25,#eb7e20,#e75d1e,#d14632,#b03e38,#8c3a36,#643633,#07081d,#2e4463,#1e588a,#086da7,#0082b9,#039ac7,#12b1d4,#2bc8e2,#3ddff0,#61f4fb)!important}perspective-copy-menu[theme=Vaporwave],perspective-export-menu[theme=Vaporwave],perspective-dropdown[theme=Vaporwave],perspective-date-column-style[theme=Vaporwave],perspective-datetime-column-style[theme=Vaporwave],perspective-number-column-style[theme=Vaporwave],perspective-string-column-style[theme=Vaporwave]{border:1px solid var(--inactive--color);--column-style-pos-color--content:\"+\";--column-style-neg-color--content:\"-\";--save-button-icon--content:\"save\";--reset-button-icon--content:\"refresh\";--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;color:#49acff;--icon--color:#49acff;--inactive--color:#61656e;--inactive--border-color:var(--inactive--color);--root--background:#fff;--active--color:#2770a9;--error--color:#ff9485;--plugin--background:#242526;--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:var(--icon--color);--warning--color:#242526;--modal-target--background:#ffffff0d;--active--background:#2771aa80;--expression--operator-color:#c5c9d0;--expression--function-color:#22a0ce;--expression--error-color:#f88;--calendar--filter:invert(1);--float--column-type--color:#7dc3f0;--string--column-type--color:#ff9485;--date--column-type--color:@green50;--boolean--column-type--color:@orange50;--code-editor-symbol--color:white;--code-editor-literal--color:#7dc3f0;--code-editor-operator--color:#17a67b;--code-editor-comment--color:#cc7830;--code-editor-column--color:#e18ee1;background-color:#07081d;border:1px solid #4c505b;border-radius:0 0 2px 2px;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace;--inactive--color:#132132!important;--plugin--background:#07081d!important;background-color:#07081d!important}perspective-viewer,perspective-viewer[theme=Gruvbox\\ Light]{--theme-name:\"Gruvbox Light\"}perspective-viewer[theme=Gruvbox\\ Light]{--button--font-size:16px;--config-button--padding:15px 8px 6px 8px;--column-drop-label--font-size:8px;--column-drop-container--padding:0px;--column-drop-label--display:inline-block;--column-selector--width:20px;--column-selector--font-size:16px;--column_type--width:25px;--select--padding:0px;--side-panel--padding:0px 0px 0px 4px;--top-panel--padding:0px 0px 12px 0px;--top-panel-row--display:inline-flex;--button--min-width:110px;color:var(--theme-fg1);--icon--color:var(--theme-fg0);--inactive--color:var(--theme-fg2);--inactive--border-color:var(--theme-bg2);--root--background:#fff;--active--color:#2670a9;--error--color:#ff471e;--plugin--background:var(--theme-bg0);--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:#042121;--warning--color:#fdfffd;--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;--d3fc-y1-label--content:\"arrow_upward\";--d3fc-y2-label--content:\"arrow_downward\";--d3fc-treedata-axis--lines:none;--d3fc-tooltip--background--color:#9b9b9bcc;--d3fc-tooltip--color:#161616;--d3fc-tooltip--border-color:#fff;--d3fc-tooltip--box-shadow:0 2px 4px 0 #0000001a;--d3fc-gridline--color:var(--theme-bg2);--d3fc-axis-ticks--color:var(--theme-fg1);--d3fc-axis--lines:#c5c9d0;--d3fc-legend--background:var(--plugin--background);--d3fc-series:var(--theme-blue);--d3fc-series-1:var(--theme-blue);--d3fc-series-2:var(--theme-red);--d3fc-series-3:var(--theme-green);--d3fc-series-4:var(--theme-purple);--d3fc-series-5:var(--theme-aqua);--d3fc-series-6:var(--theme-alt-blue);--d3fc-series-7:var(--theme-alt-red);--d3fc-series-8:var(--theme-alt-green);--d3fc-series-9:var(--theme-alt-purple);--d3fc-series-10:var(--theme-alt-aqua);--d3fc-full--gradient:linear-gradient(#4d342f 0%,#e4521b 22.5%,#feeb65 42.5%,#f0f0f0 50%,#dcedc8 57.5%,#42b3d5 67.5%,#1a237e 100%);--d3fc-positive--gradient:linear-gradient(#f0f0f0 0%,#dcedc8 10%,#42b3d5 50%,#1a237e 100%);--d3fc-negative--gradient:linear-gradient(#4d342f 0%,#e4521b 50%,#feeb65 90%,#f0f0f0 100%);--rt-pos-cell--color:var(--theme-blue);--rt-neg-cell--color:var(--theme-red);--map-tile-url:\"http://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png\";--map-element-background:#fff;--map-category-1:#0366d6;--map-category-2:#ff7f0e;--map-category-3:#2ca02c;--map-category-4:#d62728;--map-category-5:#9467bd;--map-category-6:#8c564b;--map-category-7:#e377c2;--map-category-8:#7f7f7f;--map-category-9:#bcbd22;--map-category-10:#17becf;--map-gradient:linear-gradient(#4d342f 0%,#e4521b 22.5%,#feeb65 42.5%,#f0f0f0 50%,#dcedc8 57.5%,#42b3d5 67.5%,#1a237e 100%);--theme-fg0:#282828;--theme-fg1:#3c3836;--theme-fg2:#7c6f64;--theme-gray:#928374;--theme-bg0:#fbf1c7;--theme-bg1:#ebdbb2;--theme-bg2:#a89984;--theme-red:#cc241d;--theme-green:#98871a;--theme-yellow:#d79921;--theme-blue:#458588;--theme-purple:#b16286;--theme-aqua:#689d5a;--theme-orange:#d65d0e;--theme-alt-red:#9d0006;--theme-alt-green:#79740e;--theme-alt-yellow:#b57614;--theme-alt-blue:#076678;--theme-alt-purple:#8f3f71;--theme-alt-aqua:#427b58;--theme-alt-orange:#af3a03;background-color:#0000;background-color:var(--theme-bg1);--status-icon-connected--color:var(--theme-aqua);--status-icon-initializing--color:var(--theme-yellow);--status-icon-error--color:var(--theme-red);font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace;--d3fc-negative--gradient:linear-gradient(var(--theme-bg1),var(--theme-red),var(--theme-alt-red))!important;--d3fc-positive--gradient:linear-gradient(var(--theme-bg1),var(--theme-blue),var(--theme-alt-blue))!important;--d3fc-full--gradient:linear-gradient(var(--theme-alt-red),var(--theme-red),var(--theme-bg1),var(--theme-blue),var(--theme-alt-blue))!important}perspective-copy-menu[theme=Gruvbox\\ Light],perspective-export-menu[theme=Gruvbox\\ Light],perspective-dropdown[theme=Gruvbox\\ Light]{border:1px solid var(--inactive--color);--column-style-pos-color--content:\"+\";--column-style-neg-color--content:\"-\";--save-button-icon--content:\"save\";--reset-button-icon--content:\"refresh\";--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;color:var(--theme-fg1);--icon--color:var(--theme-fg0);--inactive--color:var(--theme-fg2);--inactive--border-color:var(--theme-bg2);--root--background:#fff;--active--color:#2670a9;--error--color:#ff471e;--plugin--background:var(--theme-bg0);--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:#042121;--warning--color:#fdfffd;--theme-fg0:#282828;--theme-fg1:#3c3836;--theme-fg2:#7c6f64;--theme-gray:#928374;--theme-bg0:#fbf1c7;--theme-bg1:#ebdbb2;--theme-bg2:#a89984;--theme-red:#cc241d;--theme-green:#98871a;--theme-yellow:#d79921;--theme-blue:#458588;--theme-purple:#b16286;--theme-aqua:#689d5a;--theme-orange:#d65d0e;--theme-alt-red:#9d0006;--theme-alt-green:#79740e;--theme-alt-yellow:#b57614;--theme-alt-blue:#076678;--theme-alt-purple:#8f3f71;--theme-alt-aqua:#427b58;--theme-alt-orange:#af3a03;background-color:#0000;background-color:var(--theme-bg1);--status-icon-connected--color:var(--theme-aqua);--status-icon-initializing--color:var(--theme-yellow);--status-icon-error--color:var(--theme-red);background-color:var(--theme-bg0);border-radius:0 0 2px 2px;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace}perspective-viewer,perspective-viewer[theme=Gruvbox\\ Dark]{--theme-name:\"Gruvbox Dark\"}perspective-viewer[theme=Gruvbox\\ Dark]{--button--font-size:16px;--config-button--padding:15px 8px 6px 8px;--column-drop-label--font-size:8px;--column-drop-container--padding:0px;--column-drop-label--display:inline-block;--column-selector--width:20px;--column-selector--font-size:16px;--column_type--width:25px;--select--padding:0px;--side-panel--padding:0px 0px 0px 4px;--top-panel--padding:0px 0px 12px 0px;--top-panel-row--display:inline-flex;--button--min-width:110px;color:var(--theme-fg0);--icon--color:var(--theme-fg1);--inactive--color:var(--theme-fg2);--inactive--border-color:var(--theme-bg2);--root--background:#fff;--active--color:#2770a9;--error--color:#ff9485;--plugin--background:var(--theme-bg1);--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:var(--icon--color);--warning--color:#242526;--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;--d3fc-y1-label--content:\"arrow_upward\";--d3fc-y2-label--content:\"arrow_downward\";--d3fc-treedata-axis--lines:none;--d3fc-tooltip--background--color:#9b9b9bcc;--d3fc-tooltip--color:white;--d3fc-tooltip--border-color:#242526;--d3fc-tooltip--box-shadow:0 2px 4px 0 #0000001a;--d3fc-gridline--color:var(--theme-bg2);--d3fc-axis-ticks--color:var(--theme-fg1);--d3fc-axis--lines:#61656e;--d3fc-legend--background:var(--plugin--background);--d3fc-series:var(--theme-blue);--d3fc-series-1:var(--theme-blue);--d3fc-series-2:var(--theme-red);--d3fc-series-3:var(--theme-green);--d3fc-series-4:var(--theme-purple);--d3fc-series-5:var(--theme-aqua);--d3fc-series-6:var(--theme-alt-blue);--d3fc-series-7:var(--theme-alt-red);--d3fc-series-8:var(--theme-alt-green);--d3fc-series-9:var(--theme-alt-purple);--d3fc-series-10:var(--theme-alt-aqua);--d3fc-full--gradient:linear-gradient(#dd6367 0%,#242526 50%,#3289c8 100%);--d3fc-positive--gradient:linear-gradient(#242526 0%,#3289c8 100%);--d3fc-negative--gradient:linear-gradient(#dd6367 0%,#242526 100%);--rt-pos-cell--color:var(--theme-alt-blue);--rt-neg-cell--color:var(--theme-alt-red);--map-tile-url:\"http://{a-c}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png\";--map-element-background:#212c2f;--map-category-1:#4778c2;--map-category-2:#cc7830;--map-category-3:#9e54c0;--map-category-4:#339699;--map-category-5:#66728f;--map-category-6:#d367bd;--map-category-7:#6d7c4d;--map-category-8:#dd6367;--map-category-9:#7868ce;--map-category-10:#17a67b;--map-gradient:linear-gradient(#dd6367 0%,#242526 50%,#3289c8 100%);--modal-target--background:#ffffff0d;--active--background:#2771aa80;--expression--operator-color:#c5c9d0;--expression--function-color:#22a0ce;--expression--error-color:#f88;--calendar--filter:invert(1);--float--column-type--color:#7dc3f0;--string--column-type--color:#ff9485;--date--column-type--color:@green50;--boolean--column-type--color:@orange50;--code-editor-symbol--color:white;--code-editor-literal--color:#7dc3f0;--code-editor-operator--color:#17a67b;--code-editor-comment--color:#cc7830;--code-editor-column--color:#e18ee1;--d3fc-legend--text:#c5c9d0;--d3fc-treedata--labels:white;--d3fc-treedata--hover-highlight:white;--d3fc-tooltip--background:#2a2c2f;--map-attribution--filter:invert(1)hue-rotate(180deg);--theme-bg0:#282828;--theme-bg1:#3c3836;--theme-bg2:#7c6f64;--theme-gray:#928374;--theme-fg0:#fbf1c7;--theme-fg1:#ebdbb2;--theme-fg2:#a89984;--theme-red:#cc241d;--theme-green:#98871a;--theme-yellow:#d79921;--theme-blue:#458588;--theme-purple:#b16286;--theme-aqua:#689d5a;--theme-orange:#d65d0e;--theme-alt-red:#fb4934;--theme-alt-green:#b8bb26;--theme-alt-yellow:#fabd2f;--theme-alt-blue:#83a598;--theme-alt-purple:#d3869b;--theme-alt-aqua:#8ec07c;--theme-alt-orange:#fe8019;background-color:#242526;background-color:var(--theme-bg0);--status-icon-connected--color:var(--theme-aqua);--status-icon-initializing--color:var(--theme-yellow);--status-icon-error--color:var(--theme-red);font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace;--d3fc-negative--gradient:linear-gradient(var(--theme-bg0),var(--theme-red),var(--theme-alt-red))!important;--d3fc-positive--gradient:linear-gradient(var(--theme-bg0),var(--theme-blue),var(--theme-alt-blue))!important;--d3fc-full--gradient:linear-gradient(var(--theme-alt-red),var(--theme-red),var(--theme-bg0),var(--theme-blue),var(--theme-alt-blue))!important}perspective-copy-menu[theme=Gruvbox\\ Dark],perspective-export-menu[theme=Gruvbox\\ Dark],perspective-dropdown[theme=Gruvbox\\ Dark]{border:1px solid var(--inactive--color);--column-style-pos-color--content:\"+\";--column-style-neg-color--content:\"-\";--save-button-icon--content:\"save\";--reset-button-icon--content:\"refresh\";--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;color:var(--theme-fg0);--icon--color:var(--theme-fg1);--inactive--color:var(--theme-fg2);--inactive--border-color:var(--theme-bg2);--root--background:#fff;--active--color:#2770a9;--error--color:#ff9485;--plugin--background:var(--theme-bg1);--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:var(--icon--color);--warning--color:#242526;--modal-target--background:#ffffff0d;--active--background:#2771aa80;--expression--operator-color:#c5c9d0;--expression--function-color:#22a0ce;--expression--error-color:#f88;--calendar--filter:invert(1);--float--column-type--color:#7dc3f0;--string--column-type--color:#ff9485;--date--column-type--color:@green50;--boolean--column-type--color:@orange50;--code-editor-symbol--color:white;--code-editor-literal--color:#7dc3f0;--code-editor-operator--color:#17a67b;--code-editor-comment--color:#cc7830;--code-editor-column--color:#e18ee1;--theme-bg0:#282828;--theme-bg1:#3c3836;--theme-bg2:#7c6f64;--theme-gray:#928374;--theme-fg0:#fbf1c7;--theme-fg1:#ebdbb2;--theme-fg2:#a89984;--theme-red:#cc241d;--theme-green:#98871a;--theme-yellow:#d79921;--theme-blue:#458588;--theme-purple:#b16286;--theme-aqua:#689d5a;--theme-orange:#d65d0e;--theme-alt-red:#fb4934;--theme-alt-green:#b8bb26;--theme-alt-yellow:#fabd2f;--theme-alt-blue:#83a598;--theme-alt-purple:#d3869b;--theme-alt-aqua:#8ec07c;--theme-alt-orange:#fe8019;background-color:#242526;background-color:var(--theme-bg0);--status-icon-connected--color:var(--theme-aqua);--status-icon-initializing--color:var(--theme-yellow);--status-icon-error--color:var(--theme-red);background-color:var(--theme-bg0);border:1px solid #4c505b;border-radius:0 0 2px 2px;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace}perspective-viewer,perspective-viewer[theme=Dracula]{--theme-name:\"Dracula\"}perspective-viewer[theme=Dracula]{--button--font-size:16px;--config-button--padding:15px 8px 6px 8px;--column-drop-label--font-size:8px;--column-drop-container--padding:0px;--column-drop-label--display:inline-block;--column-selector--width:20px;--column-selector--font-size:16px;--column_type--width:25px;--select--padding:0px;--side-panel--padding:0px 0px 0px 4px;--top-panel--padding:0px 0px 12px 0px;--top-panel-row--display:inline-flex;--button--min-width:110px;color:var(--theme-fg0);--icon--color:var(--theme-fg1);--inactive--color:var(--theme-fg2);--inactive--border-color:var(--theme-bg2);--root--background:#fff;--active--color:#2770a9;--error--color:#ff9485;--plugin--background:var(--theme-bg1);--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:var(--icon--color);--warning--color:#242526;--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;--d3fc-y1-label--content:\"arrow_upward\";--d3fc-y2-label--content:\"arrow_downward\";--d3fc-treedata-axis--lines:none;--d3fc-tooltip--background--color:#9b9b9bcc;--d3fc-tooltip--color:white;--d3fc-tooltip--border-color:#242526;--d3fc-tooltip--box-shadow:0 2px 4px 0 #0000001a;--d3fc-gridline--color:var(--theme-bg2);--d3fc-axis-ticks--color:var(--theme-fg1);--d3fc-axis--lines:#61656e;--d3fc-legend--background:var(--plugin--background);--d3fc-series:var(--theme-blue);--d3fc-series-1:var(--theme-blue);--d3fc-series-2:var(--theme-red);--d3fc-series-3:var(--theme-green);--d3fc-series-4:var(--theme-yellow);--d3fc-series-5:var(--theme-purple);--d3fc-series-6:var(--theme-pink);--d3fc-series-7:var(--theme-orange);--d3fc-series-8:#dd6367;--d3fc-series-9:#7868ce;--d3fc-series-10:#17a67b;--d3fc-full--gradient:linear-gradient(#dd6367 0%,#242526 50%,#3289c8 100%);--d3fc-positive--gradient:linear-gradient(#242526 0%,#3289c8 100%);--d3fc-negative--gradient:linear-gradient(#dd6367 0%,#242526 100%);--rt-pos-cell--color:var(--theme-blue);--rt-neg-cell--color:var(--theme-red);--map-tile-url:\"http://{a-c}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png\";--map-element-background:#212c2f;--map-category-1:#4778c2;--map-category-2:#cc7830;--map-category-3:#9e54c0;--map-category-4:#339699;--map-category-5:#66728f;--map-category-6:#d367bd;--map-category-7:#6d7c4d;--map-category-8:#dd6367;--map-category-9:#7868ce;--map-category-10:#17a67b;--map-gradient:linear-gradient(#dd6367 0%,#242526 50%,#3289c8 100%);--modal-target--background:#ffffff0d;--active--background:#2771aa80;--expression--operator-color:#c5c9d0;--expression--function-color:#22a0ce;--expression--error-color:#f88;--calendar--filter:invert(1);--float--column-type--color:#7dc3f0;--string--column-type--color:#ff9485;--date--column-type--color:@green50;--boolean--column-type--color:@orange50;--code-editor-symbol--color:white;--code-editor-literal--color:#7dc3f0;--code-editor-operator--color:#17a67b;--code-editor-comment--color:#cc7830;--code-editor-column--color:#e18ee1;--d3fc-legend--text:#c5c9d0;--d3fc-treedata--labels:white;--d3fc-treedata--hover-highlight:white;--d3fc-tooltip--background:#2a2c2f;--map-attribution--filter:invert(1)hue-rotate(180deg);--theme-bg0:#191a22;--theme-bg1:#282a36;--theme-bg2:#44475a;--theme-gray:#928374;--theme-fg0:#f8f8f2;--theme-fg1:#6272a4;--theme-fg2:#44475a;--theme-red:#f55;--theme-green:#50fa7b;--theme-yellow:#f1fa8c;--theme-blue:#8be9fd;--theme-purple:#bd93f9;--theme-orange:#ffb86c;--theme-pink:#ff79c6;background-color:#242526;background-color:var(--theme-bg0);--status-icon-connected--color:var(--theme-green);--status-icon-initializing--color:var(--theme-yellow);--status-icon-error--color:var(--theme-red);font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace;--d3fc-negative--gradient:linear-gradient(var(--theme-bg0),var(--theme-red))!important;--d3fc-positive--gradient:linear-gradient(var(--theme-bg0),var(--theme-blue))!important;--d3fc-full--gradient:linear-gradient(var(--theme-red),var(--theme-bg0),var(--theme-blue))!important}perspective-copy-menu[theme=Dracula],perspective-export-menu[theme=Dracula],perspective-dropdown[theme=Dracula]{border:1px solid var(--inactive--color);--column-style-pos-color--content:\"+\";--column-style-neg-color--content:\"-\";--save-button-icon--content:\"save\";--reset-button-icon--content:\"refresh\";--interface-monospace--font-family:\"ui-monospace\",\"SFMono-Regular\",\"SF Mono\",\"Menlo\",\"Consolas\",\"Liberation Mono\",monospace;color:var(--theme-fg0);--icon--color:var(--theme-fg1);--inactive--color:var(--theme-fg2);--inactive--border-color:var(--theme-bg2);--root--background:#fff;--active--color:#2770a9;--error--color:#ff9485;--plugin--background:var(--theme-bg1);--overflow-hint-icon--color:#fdfffd;--select--background-color:none;--column-drop-container--background:none;--warning--background:var(--icon--color);--warning--color:#242526;--modal-target--background:#ffffff0d;--active--background:#2771aa80;--expression--operator-color:#c5c9d0;--expression--function-color:#22a0ce;--expression--error-color:#f88;--calendar--filter:invert(1);--float--column-type--color:#7dc3f0;--string--column-type--color:#ff9485;--date--column-type--color:@green50;--boolean--column-type--color:@orange50;--code-editor-symbol--color:white;--code-editor-literal--color:#7dc3f0;--code-editor-operator--color:#17a67b;--code-editor-comment--color:#cc7830;--code-editor-column--color:#e18ee1;--theme-bg0:#191a22;--theme-bg1:#282a36;--theme-bg2:#44475a;--theme-gray:#928374;--theme-fg0:#f8f8f2;--theme-fg1:#6272a4;--theme-fg2:#44475a;--theme-red:#f55;--theme-green:#50fa7b;--theme-yellow:#f1fa8c;--theme-blue:#8be9fd;--theme-purple:#bd93f9;--theme-orange:#ffb86c;--theme-pink:#ff79c6;background-color:#242526;background-color:var(--theme-bg0);--status-icon-connected--color:var(--theme-green);--status-icon-initializing--color:var(--theme-yellow);--status-icon-error--color:var(--theme-red);background-color:var(--theme-bg0);border:1px solid #4c505b;border-radius:0 0 2px 2px;font-family:\"ui-monospace\",SFMono-Regular,SF Mono,Menlo,Consolas,Liberation Mono,monospace}";

},{}],"8aNDL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqView", ()=>PdqView);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _styles = require("../styles");
var _utils = require("../utils");
var _tableBroker = require("../services/TableBroker");
var _notificationService = require("../services/notificationService");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _pdqHotkeyService = require("../services/PdqHotkeyService");
var _pdqHotkeyServiceDefault = parcelHelpers.interopDefault(_pdqHotkeyService);
var _16 = require("@carbon/web-components/es/icons/data--view/16");
var _16Default = parcelHelpers.interopDefault(_16);
var _16Js = require("@carbon/web-components/es/icons/save/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _indexJs = require("@carbon/web-components/es/components/tag/index.js");
var _pdqMixin = require("./_pdq-mixin");
var _defs = require("@carbon/web-components/es/components/tag/defs");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var PdqView_1;
var _a;
const log = (0, _debugDefault.default)("pdq:flow:pdq-view");
let PdqView = PdqView_1 = class PdqView extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.table = undefined;
        this.error = null;
        this.show = false;
        this.dataPreview = "loading...";
        this.config = "loading...";
        this._id = PdqView_1._nextId++;
        (0, _pdqHotkeyServiceDefault.default).showPdqData.subscribe((show)=>{
            this.requestUpdate();
        });
    }
    render() {
        log(`pdq-data: ${this.id} ${this.show} - render`);
        const slot = (0, _lit.html)`<slot id="pdq-view-${this._id}" class="hide"  @slotchange="${this._onSlotChange}"></slot>`;
        const show = this.show || (0, _pdqHotkeyServiceDefault.default).showPdqData.currentValue();
        return (0, _lit.html)`
            ${slot}
            ${show ? (0, _lit.html)`
            <div class="show col ${this.error ? "error" : ""} m-1">
                ${this.renderToolBar((0, _lit.html)`<cds-icon-button slot="tool-bar" @click="${this.save}" kind="primary" tooltip-text="Save">
                        ${(0, _16JsDefault.default)({
            slot: "icon"
        })}
                    </cds-icon-button>`)}
                <cds-textarea value="${this.config}">
                    <label slot="label-text">Config:</label>
                </cds-textarea>
            </div>` : (0, _lit.nothing)}
        `;
    }
    async save() {
        log("save");
        if (!this.textArea) return;
        this._update(this.textArea.value);
    }
    toggle() {
        this.show = !this.show;
        log(`${this.id} - toggle`, this.show);
    }
    async _onSlotChange(event) {
        log(`${this.id} - slot change`);
        const slot = event.target;
        const nodes = slot.assignedNodes({
            flatten: true
        });
        const { template, scripts } = (0, _utils.extractTextAndScripts)(nodes);
        if (template) await this._update(template);
        else if (scripts.length == 1) await this._update(scripts[0]);
    }
    async _update(template) {
        if (!this.table) {
            (0, _notificationService.notificationService).error(`pdq-view: ${this.id} - table attribute is required`);
            throw new Error(`pdq-view: ${this.id} - table attribute is required`);
        }
        try {
            const json = JSON.parse(template);
            const view = await (0, _tableBroker.tableBroker).getOrCreateView(this.id, this.table, json);
            this.config = JSON.stringify(json, null, 2);
            this.dataPreview = `<pdq-view id="${this.id}" table="${this.table}"><template>\n${this.config}\n</template></pdq-view>`;
            this.error = null;
        } catch (e) {
            (0, _notificationService.notificationService).error(`pdq-view#${this.id}|Error parsing JSON: \n${e.message}`);
            this.error = e.message;
        }
    }
};
PdqView.styles = [
    (0, _styles.hide),
    (0, _styles.row),
    (0, _styles.col),
    (0, _styles.grow),
    (0, _styles.padding),
    (0, _styles.margin)
];
PdqView._nextId = 0;
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Object)
], PdqView.prototype, "table", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Object)
], PdqView.prototype, "error", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Boolean)
], PdqView.prototype, "show", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", String)
], PdqView.prototype, "dataPreview", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", String)
], PdqView.prototype, "config", void 0);
__decorate([
    (0, _decorators.query)("cds-textarea"),
    __metadata("design:type", Object)
], PdqView.prototype, "textArea", void 0);
PdqView = PdqView_1 = __decorate([
    (0, _decorators.customElement)("pdq-view"),
    (0, _pdqMixin.pdqDiscoveryLayer)(log, (0, _16Default.default), "pdq-view", "rgba(83,236,255,0.13)", (0, _defs.TAG_TYPE).BLUE),
    __metadata("design:paramtypes", [])
], PdqView);

},{"lit/decorators":"kQrIl","lit":"aCmte","../styles":"86IFJ","../utils":"i8jxn","../services/TableBroker":"kJzSP","../services/notificationService":"2Yic8","debug":"17JIf","../services/PdqHotkeyService":"blgFb","@carbon/web-components/es/icons/data--view/16":"3f0p2","@carbon/web-components/es/icons/save/16.js":"atEnQ","@carbon/web-components/es/components/tag/index.js":"6Wp6j","./_pdq-mixin":"66yqo","@carbon/web-components/es/components/tag/defs":"ioe2X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3f0p2":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<circle cx="22" cy="24" r="2"></circle><path d="M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"></path><circle cx="8" cy="8" r="1"></circle><circle cx="8" cy="16" r="1"></circle><circle cx="8" cy="24" r="1"></circle><path d="M5,21h7V19H5V13H21v3h2V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2h7V27H5ZM5,5H21v6H5Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kw6Ih":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqDump", ()=>PdqDump);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _tableBroker = require("../services/TableBroker");
var _indexJs = require("@carbon/web-components/es/components/copy-button/index.js");
var _indexJs1 = require("@carbon/web-components/es/components/icon-button/index.js");
var _indexJs2 = require("@carbon/web-components/es/components/textarea/index.js");
var _16Js = require("@carbon/web-components/es/icons/debug/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _styles = require("../styles");
var _pdqHotkeyService = require("../services/PdqHotkeyService");
var _pdqHotkeyServiceDefault = parcelHelpers.interopDefault(_pdqHotkeyService);
var _pdqMixin = require("./_pdq-mixin");
var _defs = require("@carbon/web-components/es/components/tag/defs");
var _rxjs = require("rxjs");
var _dataBroker = require("../services/DataBroker");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _PdqDump_view, _PdqDump_table, _PdqDump_source, _PdqDump_subscription, _PdqDump_vSubscription;
const log = (0, _debugDefault.default)("pdq:flow:pdq-dump");
let PdqDump = class PdqDump extends (0, _lit.LitElement) {
    get view() {
        return __classPrivateFieldGet(this, _PdqDump_view, "f") || "";
    }
    set view(value) {
        __classPrivateFieldSet(this, _PdqDump_view, value, "f");
        this.updateData();
    }
    get table() {
        return __classPrivateFieldGet(this, _PdqDump_table, "f") || "";
    }
    set table(value) {
        __classPrivateFieldSet(this, _PdqDump_table, value, "f");
        this.updateData();
    }
    get source() {
        return __classPrivateFieldGet(this, _PdqDump_source, "f") || "";
    }
    set source(value) {
        __classPrivateFieldSet(this, _PdqDump_source, value, "f");
        this.updateData();
    }
    constructor(){
        super();
        this.show = false;
        this.dataPreview = "no data";
        _PdqDump_view.set(this, undefined);
        _PdqDump_table.set(this, undefined);
        this.error = null;
        _PdqDump_source.set(this, "");
        this.dsId = null;
        _PdqDump_subscription.set(this, (0, _rxjs.Subscription).EMPTY);
        _PdqDump_vSubscription.set(this, (0, _rxjs.Subscription).EMPTY);
    }
    render() {
        log(`pdq-data: ${this.id} ${this.show} - render`);
        if (this.show || (0, _pdqHotkeyServiceDefault.default).showPdqData.currentValue()) return (0, _lit.html)`
                <div class="show col ${this.error ? "error" : ""} m-1">
                    ${this.renderToolBar()}
                    <cds-textarea style="--cds-body-01-font-size:.6rem" value="${this.dataPreview}">
                        <label slot="label-text">Dump:</label>
                    </cds-textarea>
                </div>
            `;
        return 0, _lit.nothing;
    }
    async updateData() {
        if (__classPrivateFieldGet(this, _PdqDump_table, "f")) {
            __classPrivateFieldGet(this, _PdqDump_subscription, "f").unsubscribe();
            const ds = (0, _tableBroker.tableBroker).getTable(__classPrivateFieldGet(this, _PdqDump_table, "f"));
            __classPrivateFieldSet(this, _PdqDump_subscription, ds.subscribe(async (view)=>{
                const data = await view.to_json();
                this.dataPreview = JSON.stringify(data, null, 2);
                this.requestUpdate();
                __classPrivateFieldSet(this, _PdqDump_vSubscription, view.on_update(async ()=>{
                    const data = await view.to_json();
                    this.dataPreview = JSON.stringify(data, null, 2);
                    this.requestUpdate();
                }), "f");
            }), "f");
        } else if (this.source) {
            __classPrivateFieldGet(this, _PdqDump_subscription, "f").unsubscribe();
            const ds = await (0, _dataBroker.dataBroker).getObservableDataSource(this.source);
            __classPrivateFieldSet(this, _PdqDump_subscription, ds.subscribe((data)=>{
                console.log("data", data);
                this.dataPreview = JSON.stringify(data, null, 2);
                this.requestUpdate();
            }), "f");
        }
    }
};
_PdqDump_view = new WeakMap(), _PdqDump_table = new WeakMap(), _PdqDump_source = new WeakMap(), _PdqDump_subscription = new WeakMap(), _PdqDump_vSubscription = new WeakMap();
PdqDump.styles = [
    (0, _styles.hide),
    (0, _styles.row),
    (0, _styles.col),
    (0, _styles.grow),
    (0, _styles.padding),
    (0, _styles.margin)
];
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Boolean)
], PdqDump.prototype, "show", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Object)
], PdqDump.prototype, "dataPreview", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Object)
], PdqDump.prototype, "error", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [
        String
    ])
], PdqDump.prototype, "view", null);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [
        String
    ])
], PdqDump.prototype, "table", null);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [
        String
    ])
], PdqDump.prototype, "source", null);
PdqDump = __decorate([
    (0, _decorators.customElement)("pdq-dump"),
    (0, _pdqMixin.pdqDiscoveryLayer)(log, (0, _16JsDefault.default), "pdq-dump", "rgba(255, 83, 236, 0.13)", (0, _defs.TAG_TYPE).GREEN),
    __metadata("design:paramtypes", [])
], PdqDump);

},{"lit/decorators":"kQrIl","lit":"aCmte","../services/TableBroker":"kJzSP","@carbon/web-components/es/components/copy-button/index.js":"5DrQc","@carbon/web-components/es/components/icon-button/index.js":"hEDP1","@carbon/web-components/es/components/textarea/index.js":"i8YTZ","@carbon/web-components/es/icons/debug/16.js":"ce58x","debug":"17JIf","../styles":"86IFJ","../services/PdqHotkeyService":"blgFb","./_pdq-mixin":"66yqo","@carbon/web-components/es/components/tag/defs":"ioe2X","rxjs":"d4Szo","../services/DataBroker":"kD6gB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iNmdP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqDataRequest", ()=>PdqDataRequest);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _indexJs = require("@carbon/web-components/es/components/copy-button/index.js");
var _indexJs1 = require("@carbon/web-components/es/components/icon-button/index.js");
var _indexJs2 = require("@carbon/web-components/es/components/textarea/index.js");
var _indexJs3 = require("@carbon/web-components/es/components/text-input/index.js");
var _ = require("@carbon/web-components/es/components/select/");
var _16Js = require("@carbon/web-components/es/icons/fetch-upload/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("@carbon/web-components/es/icons/save/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _16Js2 = require("@carbon/web-components/es/icons/arrow--right/16.js");
var _16JsDefault2 = parcelHelpers.interopDefault(_16Js2);
var _16Js3 = require("@carbon/web-components/es/icons/restart/16.js");
var _16JsDefault3 = parcelHelpers.interopDefault(_16Js3);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _styles = require("../styles");
var _pdqHotkeyService = require("../services/PdqHotkeyService");
var _pdqHotkeyServiceDefault = parcelHelpers.interopDefault(_pdqHotkeyService);
var _pdqMixin = require("./_pdq-mixin");
var _defs = require("@carbon/web-components/es/components/tag/defs");
var _dataClient = require("../services/DataClient");
var _dataBroker = require("../services/DataBroker");
var _utils = require("../utils");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const tagName = "pdq-data-request";
const log = (0, _debugDefault.default)(`pdq:flow:${tagName}`);
let PdqDataRequest = class PdqDataRequest extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.show = false;
        this.dataPreview = "no data";
        this.url = "";
        this.strategy = (0, _dataClient.CacheStrategies).useStale;
        this.dataType = (0, _dataClient.DataProcessors).json;
        this.fetchOptions = {};
        this.index = undefined;
        this.jmespath = undefined;
        this.error = "No url provided";
        this.loading = false;
        this.data = undefined;
        this.dirty = false;
        this._unsubs = [];
        this._changeKey = "inital-value";
    }
    render() {
        // log(`pdq-data-request: ${this.id} ${this.show} - render`, this.dataPreview)
        if (this.show || (0, _pdqHotkeyServiceDefault.default).showPdqData.currentValue()) {
            const toolbar = (0, _lit.html)`
                    <div class="row center ml-1 mr-1" style="height: 100%">
                        ${this.dirty ? (0, _lit.html)`
                            <cds-tag type="${(0, _defs.TAG_TYPE).TEAL}">
                              Click save to update the data source ${(0, _16JsDefault2.default)()}
                            </cds-tag>` : (0, _lit.nothing)}
                        <cds-icon-button slot="tool-bar" @click="${this.save}" kind="primary" ?disabled="${!this.dirty}" >
                            <span slot="tooltip-content"> Save </span>
                            ${(0, _16JsDefault1.default)({
                slot: "icon"
            })}
                        </cds-icon-button>
                        <cds-icon-button slot="tool-bar" @click="${this.refresh}" kind="primary" >
                            <span slot="tooltip-content"> Refresh </span>
                            ${(0, _16JsDefault3.default)({
                slot: "icon"
            })}
                        </cds-icon-button>
                    </div>
                `;
            return (0, _lit.html)`
                <div class="show col ${this.error ? "error" : ""}">
                    ${this.renderToolBar(toolbar)}
                    ${this.loading ? (0, _lit.html)`
                        <cds-inline-loading class="m-2" status="active">Loading data...</cds-inline-loading>` : (0, _lit.nothing)}

                    <div class="m-2">
                        <cds-text-input
                                label="Url"
                                value="${this.url}"
                                @onChange="${this.onUrlChange}"
                        >
                        </cds-text-input>
    
                        <cds-select label-text="Cache Strategy" 
                                    @change="${this.onStrategyChange}" 
                                    value="${this.strategy}">
                                ${Object.entries((0, _dataClient.CacheStrategies)).map(([key, value])=>(0, _lit.html)`
                                    <cds-select-item  value="${value}">${key}</cds-select-item>
                                `)}
                        </cds-select>
    
                        <cds-select label-text="Data Type" 
                                    @cds-select-selected="${this.onProcessorChange}" 
                                    value="${this.dataType}">
                                ${Object.entries((0, _dataClient.DataProcessors)).map(([key, value])=>(0, _lit.html)`
                                    <cds-select-item value="${value}">${key}</cds-select-item>
                                `)}
                        </cds-select>
    
    
                        <cds-textarea value="${this.dataPreview}">
                            <label slot="label-text">Html:</label>
                        </cds-textarea>
                    </div>
                </div>
            `;
        }
        return 0, _lit.nothing;
    }
    async refresh(obayStrategy = false) {
        log("refresh");
        this._unsubs.forEach((u)=>u());
        let fetchOptions = undefined;
        if (this.fetchOptions) {
            if (typeof this.fetchOptions === "string") fetchOptions = JSON.parse(this.fetchOptions);
            else fetchOptions = this.fetchOptions;
        }
        const resp = await (0, _dataClient.dataClient).get(this.url, obayStrategy ? this.strategy : (0, _dataClient.CacheStrategies).neverCache, this.dataType, fetchOptions);
        const d = (0, _utils.defer)();
        this._unsubs = [
            resp.loading.subscribe((i)=>{
                log(`refresh - loading: ${i}`);
            }),
            resp.error.subscribe((i)=>{
                if (!i) return;
                log(`refresh - error: ${i}`);
                d.reject(i);
            }),
            resp.data.subscribe(async (i)=>{
                log(`refresh - data received: ${i}`);
                try {
                    await (0, _dataBroker.dataBroker).setDataSource(this.id, i);
                    d.resolve(i);
                } catch (e) {
                    log(`refresh - failed`, e);
                    d.reject(e);
                }
            })
        ];
        await d.promise;
        log("refresh - complete");
    }
    save() {
        this.url = this.newState.url || this.url;
        this.strategy = this.newState.strategy || this.strategy;
        this.dataType = this.newState.dataType || this.dataType;
        this.dirty = false;
    }
    onUrlChange(event) {
        this.dirty = true;
        this.newState = {
            ...this.newState,
            url: event.target?.value
        };
    }
    onStrategyChange(event) {
        this.dirty = true;
        this.newState = {
            ...this.newState,
            strategy: event.target?.value
        };
    }
    onProcessorChange(event) {
        this.dirty = true;
        this.newState = {
            ...this.newState,
            dataType: event.target?.value
        };
    }
    async willUpdate() {
        const changeKey = `${this.url}|${this.strategy}|${this.dataType}|${this.index}`;
        log(`pdq-data-request[${this.id}] (${this._changeKey === changeKey}) ${changeKey}`);
        if (this._changeKey === changeKey) return;
        this._changeKey = changeKey;
        if (!this.url) {
            this.error = "no url provided";
            this.loading = false;
            this.data = undefined;
            return;
        }
        this.dataPreview = `
<pdq-data-request 
    id="${this.id}" 
    url="${this.url}"
    strategy="${this.strategy}"
    data-type="${this.dataType}"
    ${this.fetchOptions ? `\n\tfetch-options='${JSON.stringify(this.fetchOptions)}'` : ""}${this.jmespath ? `\n\tjmespath='${this.jmespath}'` : ""}
></pdq-data-request>
        `;
        this.refresh(true);
    }
};
PdqDataRequest.styles = [
    (0, _styles.hide),
    (0, _styles.row),
    (0, _styles.col),
    (0, _styles.grow),
    (0, _styles.padding),
    (0, _styles.margin)
];
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Boolean)
], PdqDataRequest.prototype, "show", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Object)
], PdqDataRequest.prototype, "dataPreview", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqDataRequest.prototype, "url", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqDataRequest.prototype, "strategy", void 0);
__decorate([
    (0, _decorators.property)({
        attribute: "data-type",
        type: String
    }),
    __metadata("design:type", Object)
], PdqDataRequest.prototype, "dataType", void 0);
__decorate([
    (0, _decorators.property)({
        attribute: "fetch-options",
        type: Object
    }),
    __metadata("design:type", Object)
], PdqDataRequest.prototype, "fetchOptions", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqDataRequest.prototype, "index", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqDataRequest.prototype, "jmespath", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqDataRequest.prototype, "error", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Boolean)
], PdqDataRequest.prototype, "loading", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Object)
], PdqDataRequest.prototype, "data", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Boolean)
], PdqDataRequest.prototype, "dirty", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Object)
], PdqDataRequest.prototype, "newState", void 0);
PdqDataRequest = __decorate([
    (0, _decorators.customElement)(tagName),
    (0, _pdqMixin.pdqDiscoveryLayer)(log, (0, _16JsDefault.default), tagName, "rgba(255, 236, 83, 0.13)", (0, _defs.TAG_TYPE).TEAL),
    __metadata("design:paramtypes", [])
], PdqDataRequest);

},{"lit/decorators":"kQrIl","lit":"aCmte","@carbon/web-components/es/components/copy-button/index.js":"5DrQc","@carbon/web-components/es/components/icon-button/index.js":"hEDP1","@carbon/web-components/es/components/textarea/index.js":"i8YTZ","@carbon/web-components/es/components/text-input/index.js":"hYM6R","@carbon/web-components/es/components/select/":"fhDAD","@carbon/web-components/es/icons/fetch-upload/16.js":"01ecK","@carbon/web-components/es/icons/save/16.js":"atEnQ","@carbon/web-components/es/icons/arrow--right/16.js":"58M6A","@carbon/web-components/es/icons/restart/16.js":"adOlK","debug":"17JIf","../styles":"86IFJ","../services/PdqHotkeyService":"blgFb","./_pdq-mixin":"66yqo","@carbon/web-components/es/components/tag/defs":"ioe2X","../services/DataClient":"jd0ep","../services/DataBroker":"kD6gB","../utils":"i8jxn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hYM6R":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _textInputJs = require("./text-input.js");
var _textInputSkeletonJs = require("./text-input-skeleton.js");

},{"./text-input.js":"lBj7P","./text-input-skeleton.js":"3KmyV"}],"3KmyV":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTextInputSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _settingsJs = require("../../globals/settings.js");
var _textInputScssJs = require("./text-input.scss.js");
var _textInputScssJsDefault = parcelHelpers.interopDefault(_textInputScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of number input.
 */ let CDSTextInputSkeleton = class CDSTextInputSkeleton extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Specify whether the label should be hidden, or not
         */ this.hideLabel = false;
    }
    render() {
        const { hideLabel } = this;
        return (0, _lit.html)`
      ${!hideLabel && (0, _lit.html)` <span class="${0, _settingsJs.prefix}--label ${0, _settingsJs.prefix}--skeleton"></span> `}
      <div class="${0, _settingsJs.prefix}--text-input ${0, _settingsJs.prefix}--skeleton"></div>
    `;
    }
};
CDSTextInputSkeleton.styles = (0, _textInputScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "hide-label"
    })
], CDSTextInputSkeleton.prototype, "hideLabel", void 0);
CDSTextInputSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-text-input-skeleton`)
], CDSTextInputSkeleton);
var CDSTextInputSkeleton$1 = CDSTextInputSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/settings.js":"EipuL","./text-input.scss.js":"eXxnm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fhDAD":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _selectJs = require("./select.js");
var _selectItemJs = require("./select-item.js");
var _selectItemGroupJs = require("./select-item-group.js");
var _selectSkeletonJs = require("./select-skeleton.js");

},{"./select.js":"8lIGI","./select-item.js":"2uF8Y","./select-item-group.js":"DeIuX","./select-skeleton.js":"8EiZM"}],"8lIGI":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSelect$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _classMapJs = require("lit/directives/class-map.js");
var _16Js = require("../../icons/chevron--down/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/warning--filled/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _16Js2 = require("../../icons/warning--alt--filled/16.js");
var _16JsDefault2 = parcelHelpers.interopDefault(_16Js2);
var _settingsJs = require("../../globals/settings.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _formJs = require("../../globals/mixins/form.js");
var _formJsDefault = parcelHelpers.interopDefault(_formJs);
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _textInputJs = require("../text-input/text-input.js");
var _selectScssJs = require("./select.scss.js");
var _selectScssJsDefault = parcelHelpers.interopDefault(_selectScssJs);
var _ifNonEmptyJs = require("../../globals/directives/if-non-empty.js");
var _ifNonEmptyJsDefault = parcelHelpers.interopDefault(_ifNonEmptyJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("../text-input/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Select box.
 *
 * @element cds-select
 * @fires cds-select-selected
 *   The name of the custom event fired after an item is selected.
 * @slot helper-text - The helper text.
 * @slot label-text - The label text.
 * @slot validity-message - The validity message. If present and non-empty, this input shows the UI of its invalid state.
 */ let CDSSelect = class CDSSelect extends (0, _formJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
        /**
         * The mutation observer DOM mutation.
         */ this._observerMutation = null;
        /**
         * The `value` for placeholder `<option>`.
         */ this._placeholderItemValue = `__${0, _settingsJs.prefix}-select-placeholder_${Math.random().toString(36).slice(2)}`;
        /**
         * Handles DOM mutation of `<cds-select-item>` or `<cds-select-item-group>` put in `<cds-select>`, or their changes.
         * In such event, `<cds-select>` creates the corresponding `<option>` and `<optgroup>`, respectively, into shadow DOM,
         * with `._renderItems()`.
         * Doing so allows the shadow DOM style of `<cds-select>` to control the style of the `<option>` and `<optgroup>`,
         * notably the disabled ones.
         */ this._handleMutation = ()=>{
            this.requestUpdate();
        };
        /**
         * Sets the select to be focussed automatically on page load. Defaults to false
         */ this.autofocus = false;
        /**
         * Controls the disabled state of the select
         */ this.disabled = false;
        /**
         * The helper text.
         */ this.helperText = "";
        /**
         * Specify whether the label should be hidden, or not
         */ this.hideLabel = false;
        /**
         * ID to link the `label` and `select`
         */ this.id = "";
        /**
         * Specify if the currently value is invalid.
         */ this.invalid = false;
        /**
         * Message which is displayed if the value is invalid.
         */ this.invalidText = "";
        /**
         * Specify if the currently value is warn.
         */ this.warn = false;
        /**
         * Message which is displayed if the value is warn.
         */ this.warnText = "";
        /**
         * The label text.
         */ this.labelText = "";
        /**
         * Specify whether you want the inline version of this control
         */ this.inline = false;
        /**
         * Name for the select in the `FormData`
         */ this.name = "";
        /**
         * Pattern to validate the select against for HTML validity checking
         */ this.pattern = "";
        /**
         * Value to display when the select has an empty `value`
         */ this.placeholder = "";
        /**
         * Controls the readonly state of the select
         */ this.readonly = false;
        /**
         * Boolean property to set the required status
         */ this.required = false;
        /**
         * The special validity message for `required`.
         */ this.requiredValidityMessage = "Please fill out this field.";
        /**
         * The input box size.
         */ this.size = (0, _defsJs.INPUT_SIZE).MEDIUM;
        /**
         * The value of the text area.
         */ this.value = "";
    }
    /**
     * Handles `oninput` event on the `<input>`.
     *
     * @param event The event.
     * @param event.target The event target.
     */ _handleInput({ target }) {
        const { value } = target;
        this.value = value;
        const { eventSelect } = this.constructor;
        this.dispatchEvent(new CustomEvent(eventSelect, {
            bubbles: true,
            composed: true,
            detail: {
                value
            }
        }));
    }
    /**
     * @param element The parent element containing pseudo `<optgroup>`/`<option>`.
     * @returns The template containing child `<optgroup>`/`<option>` that will be rendered to shadow DOM.
     */ _renderItems(element) {
        const { selectorItem, selectorLeafItem } = this.constructor;
        // Harvests attributes from `<cds-select-item>` and `<cds-select-item-group>`.
        // Does not use properties to avoid delay in attribute to property mapping, which runs in custom element reaction cycle:
        // https://html.spec.whatwg.org/multipage/custom-elements.html#custom-element-reactions
        return (0, _lit.html)`
      ${(0, _collectionHelpersJs.filter)(element.childNodes, (item)=>item.nodeType === Node.ELEMENT_NODE && item.matches(selectorItem)).map((item)=>{
            const disabled = item.hasAttribute("disabled");
            const label = item.getAttribute("label");
            const selected = item.hasAttribute("selected");
            const value = item.getAttribute("value");
            const { textContent } = item;
            return item.matches(selectorLeafItem) ? (0, _lit.html)`
              <option
                class="${0, _settingsJs.prefix}--select-option"
                ?disabled="${disabled}"
                label="${(0, _ifNonEmptyJsDefault.default)(label)}"
                ?selected="${selected}"
                value="${(0, _ifDefinedJs.ifDefined)(value)}">
                ${textContent}
              </option>
            ` : (0, _lit.html)`
              <optgroup
                class="${0, _settingsJs.prefix}--select-optgroup"
                ?disabled="${disabled}"
                label="${(0, _ifDefinedJs.ifDefined)(label)}">
                ${this._renderItems(item)}
              </optgroup>
            `;
        })}
    `;
    }
    _handleFormdata(event) {
        const { formData } = event; // TODO: Wait for `FormDataEvent` being available in `lib.dom.d.ts`
        const { disabled, name, value } = this;
        if (!disabled) formData.append(name, value);
    }
    /**
     * Handles `slotchange` event.
     */ _handleAILabelSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || // remove reference to slug in v12
            elem.matches(this.constructor.slugItem) : false);
        this._hasAILabel = Boolean(hasContent);
        hasContent[0].setAttribute("size", "mini");
        this.requestUpdate();
    }
    /**
     * The count of child `<option>`s.
     * If the placeholder is in effect, it includes the `<option>` for the placeholder.
     */ get length() {
        return this._selectNode.length;
    }
    /**
     * The child `<option>`s.
     */ get options() {
        return this._selectNode.options;
    }
    /**
     * This form control's type.
     */ get type() {
        return this._selectNode.type;
    }
    /**
     * `true` to enable multiple selection.
     */ get multiple() {
        return false;
    }
    /**
     * The selected index.
     */ get selectedIndex() {
        var _a;
        return (_a = this._selectNode) === null || _a === void 0 ? void 0 : _a.selectedIndex;
    }
    set selectedIndex(value) {
        this._selectNode.selectedIndex = value;
        this.value = this._selectNode.value;
    }
    connectedCallback() {
        super.connectedCallback();
        this._observerMutation = new MutationObserver(this._handleMutation);
        this._observerMutation.observe(this, {
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnectedCallback() {
        if (this._observerMutation) {
            this._observerMutation.disconnect();
            this._observerMutation = null;
        }
        super.disconnectedCallback();
    }
    updated(changedProperties) {
        var _a, _b, _c, _d, _e;
        if (changedProperties.has("value")) {
            const { value, _placeholderItemValue: placeholderItemValue } = this;
            // Ensures setting the `value` after rendering child `<option>`s/`<optgroup>`s when there is a change in `value`,
            // given reflecting `value` requires child `<option>`s/`<optgroup>`s being there beforehand
            this._selectNode.value = !value ? placeholderItemValue : value;
        }
        const label = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("slot[name='ai-label']");
        if (label) label === null || label === void 0 || label.classList.toggle(`${(0, _settingsJs.prefix)}--slug--revert`, (_b = this.querySelector(`${(0, _settingsJs.prefix)}-ai-label`)) === null || _b === void 0 ? void 0 : _b.hasAttribute("revert-active"));
        else (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("slot[name='slug']")) === null || _d === void 0 || _d.classList.toggle(`${(0, _settingsJs.prefix)}--slug--revert`, (_e = this.querySelector(`${(0, _settingsJs.prefix)}-slug`)) === null || _e === void 0 ? void 0 : _e.hasAttribute("revert-active"));
    }
    render() {
        const { disabled, helperText, hideLabel, inline, invalid, invalidText, labelText, placeholder, readonly, size, warn, warnText, value, _placeholderItemValue: placeholderItemValue, _handleInput: handleInput, _handleAILabelSlotChange: handleAILabelSlotChange, _hasAILabel: hasAILabel } = this;
        const selectClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--select`]: true,
            [`${0, _settingsJs.prefix}--select--inline`]: inline,
            [`${0, _settingsJs.prefix}--select--invalid`]: invalid,
            [`${0, _settingsJs.prefix}--select--warning`]: warn,
            [`${0, _settingsJs.prefix}--select--disabled`]: disabled,
            [`${0, _settingsJs.prefix}--select--readonly`]: readonly,
            [`${0, _settingsJs.prefix}--select--slug`]: hasAILabel
        });
        const inputClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--select-input`]: true,
            [`${0, _settingsJs.prefix}--select-input--${size}`]: size
        });
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--label`]: true,
            [`${0, _settingsJs.prefix}--label--disabled`]: disabled
        });
        const helperTextClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--form__helper-text`]: true,
            [`${0, _settingsJs.prefix}--form__helper-text--disabled`]: disabled
        });
        const supplementalText = helperText ? (0, _lit.html)`
          <div class="${helperTextClasses}">
            <slot name="helper-text"> ${helperText} </slot>
          </div>
        ` : null;
        const errorText = invalid || warn ? (0, _lit.html)` <div class="${0, _settingsJs.prefix}--form-requirement">
            ${invalid ? invalidText : warnText}
          </div>` : null;
        const input = (0, _lit.html)`
      <select
        id="input"
        class="${inputClasses}"
        ?disabled="${disabled}"
        aria-readonly="${String(Boolean(readonly))}"
        aria-invalid="${String(Boolean(invalid))}"
        aria-describedby="${(0, _ifDefinedJs.ifDefined)(!invalid ? undefined : "invalid-text")}"
        @input="${handleInput}">
        ${!placeholder || value ? undefined : (0, _lit.html)`
              <option
                disabled
                hidden
                class="${0, _settingsJs.prefix}--select-option"
                value="${placeholderItemValue}"
                selected>
                ${placeholder}
              </option>
            `}
        ${this._renderItems(this)}
      </select>
      ${(0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--select__arrow`
        })}
      <slot name="ai-label" @slotchange=${handleAILabelSlotChange}></slot>
      <slot name="slug" @slotchange=${handleAILabelSlotChange}></slot>
      ${!invalid ? undefined : (0, _16JsDefault1.default)({
            class: `${(0, _settingsJs.prefix)}--select__invalid-icon`
        })}
      ${!invalid && warn ? (0, _16JsDefault2.default)({
            class: `${(0, _settingsJs.prefix)}--select__invalid-icon ${(0, _settingsJs.prefix)}--select__invalid-icon--warning`
        }) : null}
    `;
        return (0, _lit.html)`
      <div class="${selectClasses}">
        ${!hideLabel ? (0, _lit.html)`<label class="${labelClasses}" for="input">
              <slot name="label-text"> ${labelText} </slot>
            </label>` : null}
        ${inline ? (0, _lit.html)`<div class="${0, _settingsJs.prefix}--select-input--inline__wrapper">
              <div
                class="${0, _settingsJs.prefix}--select-input__wrapper"
                ?data-invalid="${invalid}">
                ${input}
              </div>
              ${errorText}
            </div>` : (0, _lit.html)`<div
              class="${0, _settingsJs.prefix}--select-input__wrapper"
              ?data-invalid="${invalid}">
              ${input}
            </div> `}
        ${!inline && errorText ? errorText : supplementalText}
      </div>
    `;
    }
    /**
     * A selector selecting child pseudo `<optgroup>`/`<option>`.
     */ static get selectorItem() {
        return `${0, _settingsJs.prefix}-select-item-group,${0, _settingsJs.prefix}-select-item`;
    }
    /**
     * A selector selecting child pseudo `<option>`.
     */ static get selectorLeafItem() {
        return `${0, _settingsJs.prefix}-select-item`;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
    /**
     * The name of the custom event fired after item is selected.
     */ static get eventSelect() {
        return `${0, _settingsJs.prefix}-select-selected`;
    }
};
CDSSelect.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSSelect.styles = (0, _selectScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("select")
], CDSSelect.prototype, "_selectNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSSelect.prototype, "autofocus", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSelect.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "helper-text"
    })
], CDSSelect.prototype, "helperText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "hide-label"
    })
], CDSSelect.prototype, "hideLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSelect.prototype, "id", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSelect.prototype, "invalid", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "invalid-text"
    })
], CDSSelect.prototype, "invalidText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSelect.prototype, "warn", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "warn-text"
    })
], CDSSelect.prototype, "warnText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label-text"
    })
], CDSSelect.prototype, "labelText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSelect.prototype, "inline", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSSelect.prototype, "multiple", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSelect.prototype, "name", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSelect.prototype, "pattern", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSSelect.prototype, "placeholder", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSelect.prototype, "readonly", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSelect.prototype, "required", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "required-validity-message"
    })
], CDSSelect.prototype, "requiredValidityMessage", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number
    })
], CDSSelect.prototype, "selectedIndex", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSSelect.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSSelect.prototype, "value", void 0);
CDSSelect = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-select`)
], CDSSelect);
var CDSSelect$1 = CDSSelect;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/class-map.js":"2fQud","../../icons/chevron--down/16.js":"kXGdJ","../../icons/warning--filled/16.js":"ajngV","../../icons/warning--alt--filled/16.js":"21PDf","../../globals/settings.js":"EipuL","lit/directives/if-defined.js":"hSgrS","../../globals/mixins/form.js":"kISjL","../../globals/internal/collection-helpers.js":"4aZkz","../text-input/text-input.js":"lBj7P","./select.scss.js":"7NmlU","../../globals/directives/if-non-empty.js":"5Xlqk","../../globals/decorators/carbon-element.js":"kNhLR","../text-input/defs.js":"83oMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kXGdJ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4aZkz":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2019, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param a A DOM collection.
 * @param predicate The callback function.
 * @param [thisObject] The context object for the given callback function.
 * @returns A new array with all elements where `predicate` returns truthy.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
parcelHelpers.export(exports, "find", ()=>find);
parcelHelpers.export(exports, "findIndex", ()=>findIndex);
parcelHelpers.export(exports, "forEach", ()=>forEach);
parcelHelpers.export(exports, "indexOf", ()=>indexOf);
const filter = (a, predicate, thisObject)=>Array.prototype.filter.call(a, predicate, thisObject);
/**
 * @param a A DOM collection.
 * @param predicate The callback function.
 * @param [thisObject] The context object for the given callback function.
 * @returns The index of the first item in the given collection where `predicate` returns `true`. `-1` if no such item is found.
 */ const findIndex = (a, predicate, thisObject)=>Array.prototype.findIndex.call(a, predicate, thisObject);
/**
 * @param a A DOM collection.
 * @param predicate The callback function.
 * @param [thisObject] The context object for the given callback function.
 * @returns The first item in the given collection where `predicate` returns `true`. `null` if no such item is found.
 */ const find = (a, predicate, thisObject)=>Array.prototype.find.call(a, predicate, thisObject);
/**
 * Walks through the given DOM collection and runs the given callback.
 *
 * @param a A DOM collection.
 * @param predicate The callback function.
 * @param [thisObject] The context object for the given callback function.
 */ const forEach = (a, predicate, thisObject)=>Array.prototype.forEach.call(a, predicate, thisObject);
/**
 * @param a A DOM collection.
 * @param item An item in the DOM collection.
 * @returns The index of the first occurence of the given item in the given collection. `-1` if no such item is found.
 */ const indexOf = (a, item)=>Array.prototype.indexOf.call(a, item);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7NmlU":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--select,:host(cds-select){align-items:flex-start;border:0;box-sizing:border-box;display:flex;flex-direction:column;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;position:relative;vertical-align:baseline}.cds--select *,.cds--select :after,.cds--select :before,:host(cds-select) *,:host(cds-select) :after,:host(cds-select) :before{box-sizing:inherit}.cds--select-input__wrapper{align-items:center;display:flex;inline-size:100%;position:relative}.cds--select-input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--cds-field);block-size:2.5rem;border:none;border-block-end:1px solid var(--cds-border-strong);border-radius:0;color:var(--cds-text-primary,#161616);cursor:pointer;display:block;font-family:inherit;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);opacity:1;outline:2px solid transparent;outline-offset:-2px;padding-block:0;padding-inline:1rem 3rem;text-overflow:ellipsis;transition:outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--select-input:hover{background-color:var(--cds-field-hover)}.cds--select-input::-ms-expand{display:none}@document url-prefix(){.cds--select-input:-moz-focusring,.cds--select-input::-moz-focus-inner{background-image:none;color:transparent;text-shadow:0 0 0 #000}}.cds--select-input:focus{color:var(--cds-text-primary,#161616);outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--select-input:focus{outline-style:dotted}}.cds--select-input:disabled,.cds--select-input:hover:disabled{background-color:var(--cds-field);border-block-end-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--select-input--sm{block-size:2rem;max-block-size:2rem}.cds--select-input--lg{block-size:3rem;max-block-size:3rem}.cds--select--disabled .cds--form__helper-text,.cds--select--disabled .cds--label,:host(cds-select[disabled]) .cds--form__helper-text,:host(cds-select[disabled]) .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--select--warning .cds--select-input,.cds--select-input__wrapper[data-invalid] .cds--select-input{padding-inline-end:4rem}.cds--select-input:disabled~.cds--select__arrow{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--select--light .cds--select-input{background-color:var(--cds-field-02,#fff)}.cds--select--light .cds--select-input:hover{background-color:var(--cds-field-hover)}.cds--select--light .cds--select-input:disabled,.cds--select--light .cds--select-input:hover:disabled{background-color:var(--cds-field-02,#fff);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--select__arrow{block-size:100%;position:absolute;fill:var(--cds-icon-primary,#161616);inset-block-start:0;inset-inline-end:1rem;pointer-events:none}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--select__arrow path{fill:ButtonText}}.cds--select__invalid-icon{inset-inline-end:2.5rem;position:absolute}.cds--select-input__wrapper[data-invalid] .cds--select-input~.cds--select__invalid-icon{fill:var(--cds-support-error,#da1e28)}.cds--select__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--select__invalid-icon--warning path[fill]{fill:#000;opacity:1}.cds--select-option,optgroup.cds--select-optgroup{background-color:var(--cds-layer-hover);color:var(--cds-text-primary,#161616)}.cds--select-option:disabled,optgroup.cds--select-optgroup:disabled{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--select--inline{align-items:center;display:flex;flex-direction:row}.cds--select--inline.cds--select--invalid .cds--form__helper-text,.cds--select--inline.cds--select--invalid .cds--label{align-self:flex-start;margin-block-start:.8125rem}.cds--select--inline .cds--form__helper-text{margin-block-end:0;margin-inline-start:.5rem}.cds--select--inline .cds--label{margin:0 .5rem 0 0;white-space:nowrap}.cds--select--inline .cds--select-input{background-color:transparent;border-block-end:none;color:var(--cds-text-primary,#161616);inline-size:auto;padding-inline:.5rem 2rem}.cds--select--inline .cds--select-input:focus,.cds--select--inline .cds--select-input:focus optgroup,.cds--select--inline .cds--select-input:focus option{background-color:var(--cds-background,#fff)}.cds--select--inline .cds--select-input[disabled],.cds--select--inline .cds--select-input[disabled]:hover{background-color:var(--cds-field)}.cds--select--inline .cds--select__arrow{inset-inline-end:.5rem}.cds--select--inline.cds--select--invalid .cds--select-input{padding-inline-end:3.5rem}.cds--select--inline.cds--select--invalid .cds--select-input~.cds--select__invalid-icon{inset-inline-end:2rem}.cds--select--inline .cds--select-input:disabled{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--select--inline .cds--select-input:disabled~*{cursor:not-allowed}.cds--select--readonly .cds--select-input{background-color:transparent;border-block-end-color:var(--cds-border-subtle);cursor:default}.cds--select--readonly .cds--select__arrow{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--select.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:2.5rem;border:none;box-shadow:none;inline-size:100%;padding:0;pointer-events:none;position:relative}.cds--select.cds--skeleton:active,.cds--select.cds--skeleton:focus,.cds--select.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--select.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--select.cds--skeleton:before{animation:none}}.cds--select.cds--skeleton .cds--select-input{display:none}.cds--select--slug .cds--ai-label,.cds--select--slug .cds--slug{inset-block-start:50%;inset-inline-end:calc(2.5rem + 9px);margin-block-start:.03125rem;position:absolute;transform:translateY(-50%)}.cds--select--slug .cds--ai-label:after,.cds--select--slug .cds--ai-label:before,.cds--select--slug .cds--slug:after,.cds--select--slug .cds--slug:before{background-color:var(--cds-border-subtle-01,#c6c6c6);block-size:1rem;content:"";inline-size:.0625rem;position:absolute}.cds--select--slug .cds--ai-label:before,.cds--select--slug .cds--slug:before{display:none;inset-inline-start:calc(-.5rem - 1px)}.cds--select--slug .cds--ai-label:after,.cds--select--slug .cds--slug:after{display:block;inset-inline-end:calc(-.5rem - 1px)}.cds--select--slug .cds--ai-label--revert:after,.cds--select--slug .cds--slug--revert:after{inset-block-start:.5rem;inset-inline-end:-.0625rem}.cds--select--slug .cds--select-input:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--select--slug .cds--select-input:has(~.cds--slug):not(:has(~.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff);padding-inline-end:4rem}.cds--select--slug:has(.cds--select__invalid-icon) .cds--select-input:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--select--slug:has(.cds--select__invalid-icon) .cds--select-input:has(~.cds--slug):not(:has(~.cds--slug--revert)){padding-inline-end:6rem}.cds--select--slug:has(.cds--select__invalid-icon) .cds--ai-label:before,.cds--select--slug:has(.cds--select__invalid-icon) .cds--slug:before{display:block}.cds--select--slug .cds--select-input__wrapper .cds--select-input~.cds--select__invalid-icon,.cds--select--slug .cds--select-input__wrapper[data-invalid] .cds--select-input~.cds--select__invalid-icon{inset-inline-end:5rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--select__arrow{fill:ButtonText}}:host(cds-select){outline:none}:host(cds-select) ::slotted(cds-ai-label),:host(cds-select) ::slotted(cds-slug){inset-block-start:50%;inset-inline-end:2.5rem;position:absolute}:host(cds-select) ::slotted(cds-ai-label:not([revert-active])),:host(cds-select) ::slotted(cds-slug:not([revert-active])){transform:translateY(-50%)}:host(cds-select[readonly]) select{pointer-events:none}:host(cds-select[inline][warn]) .cds--form__helper-text,:host(cds-select[inline][warn]) .cds--label{align-self:flex-start;margin-block-start:.8125rem}:host(cds-select[inline][warn]) select{padding-inline-end:3.5rem}:host(cds-select[inline][warn]) .cds--select__invalid-icon--warning{inset-inline-end:2rem}:host(cds-select[pagination]) .cds--label{margin:0}:host(cds-select[pagination]) .cds--select-input{padding:0 2.25rem 0 1rem}:host(cds-select[pagination]) .cds--select-input:focus{background-color:transparent}:host(cds-select[pagination]) .cds--select__arrow{inset-block-start:50%;transform:translate(-.5rem,-50%)}:host(cds-select[pagination][left-select]) .cds--select-input{border-inline-end:1px solid var(--cds-border-subtle)}:host(cds-select[invalid]) ::slotted(cds-ai-label),:host(cds-select[invalid]) ::slotted(cds-slug),:host(cds-select[warn]) ::slotted(cds-ai-label),:host(cds-select[warn]) ::slotted(cds-slug){inset-inline-end:4rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2uF8Y":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSelectItem$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * An option in select box.
 *
 * @element cds-select-item
 */ let CDSSelectItem = class CDSSelectItem extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` to disable this option.
         */ this.disabled = false;
        /**
         * The label. If this is not specified, the child text content is used.
         */ this.label = "";
        /**
         * `true` to select this option.
         */ this.selected = false;
        /**
         * The value.
         */ this.value = "";
    }
};
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSelectItem.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSSelectItem.prototype, "label", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSelectItem.prototype, "selected", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSSelectItem.prototype, "value", void 0);
CDSSelectItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-select-item`)
], CDSSelectItem);
var CDSSelectItem$1 = CDSSelectItem;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"DeIuX":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSelectItemGroup$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * An option group in select box.
 *
 * @element cds-select-item-group
 */ let CDSSelectItemGroup = class CDSSelectItemGroup extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` to disable this option.
         */ this.disabled = false;
        /**
         * The label.
         */ this.label = "";
    }
};
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSelectItemGroup.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSSelectItemGroup.prototype, "label", void 0);
CDSSelectItemGroup = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-select-item-group`)
], CDSSelectItemGroup);
var CDSSelectItemGroup$1 = CDSSelectItemGroup;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8EiZM":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSelectSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _settingsJs = require("../../globals/settings.js");
var _selectScssJs = require("./select.scss.js");
var _selectScssJsDefault = parcelHelpers.interopDefault(_selectScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of number input.
 */ let CDSSelectSkeleton = class CDSSelectSkeleton extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if the label should be hidden. Corresponds to the attribute with the same name.
         */ this.hideLabel = false;
    }
    render() {
        const { hideLabel } = this;
        return (0, _lit.html)`
      ${!hideLabel && (0, _lit.html)` <span class="${0, _settingsJs.prefix}--label ${0, _settingsJs.prefix}--skeleton"></span> `}
      <div class="${0, _settingsJs.prefix}--select ${0, _settingsJs.prefix}--skeleton"></div>
    `;
    }
};
CDSSelectSkeleton.styles = (0, _selectScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "hide-label"
    })
], CDSSelectSkeleton.prototype, "hideLabel", void 0);
CDSSelectSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-select-skeleton`)
], CDSSelectSkeleton);
var CDSSelectSkeleton$1 = CDSSelectSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/settings.js":"EipuL","./select.scss.js":"7NmlU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"01ecK":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M16,7,6,17l1.41,1.41L15,10.83V28H2v2H15a2,2,0,0,0,2-2V10.83l7.59,7.58L26,17Z"></path><path d="M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"adOlK":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M13,9c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5h3.1L9.3,5.8L10,6.5l3-3l-3-3L9.3,1.2L11.1,3H8C4.7,3,2,5.7,2,9s2.7,6,6,6	s6-2.7,6-6H13z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jd0ep":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheStrategies", ()=>CacheStrategies);
parcelHelpers.export(exports, "DataProcessors", ()=>DataProcessors);
parcelHelpers.export(exports, "DataResponseMeta", ()=>DataResponseMeta);
parcelHelpers.export(exports, "DataClient", ()=>DataClient);
parcelHelpers.export(exports, "dataClient", ()=>dataClient);
var _replaySubject = require("../observable/ReplaySubject");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _notificationService = require("./notificationService");
const log = (0, _debugDefault.default)("pdq:services:PdqDataClient");
const CacheStrategies = {
    useStale: "useStale",
    alwaysCheck: "alwaysCheck",
    neverCache: "neverCache"
};
const DataProcessors = {
    json: "json",
    blob: "blob",
    rawResponse: "rawResponse"
};
class DataResponseMeta {
    constructor(){
        this.data = new (0, _replaySubject.ReplaySubject)(1);
        this.loading = new (0, _replaySubject.ReplaySubject)(1);
        this.error = new (0, _replaySubject.ReplaySubject)(1);
    }
}
class DataClient {
    constructor(){
        this._observedRequests = new Map();
        this._cache = caches.open("pdq");
    }
    async get(url, strategy = CacheStrategies.useStale, processor = DataProcessors.json, fetchOptions = {}) {
        log(`Getting ${url} with strategy: ${strategy} and processor: ${processor}`);
        const dr = this._observedRequests.get(url) || this._newDataRequest(url, strategy, processor, fetchOptions);
        dr.response.loading.next(true);
        let response = null;
        switch(dr.strategy){
            case CacheStrategies.alwaysCheck:
                response = await this._updateCacheIfNeeded(dr);
                break;
            case CacheStrategies.neverCache:
                response = await this._fetch(dr);
                break;
            case CacheStrategies.useStale:
                response = await this._getCachedResponse(dr);
                if (response) this._updateCacheIfNeeded(dr).then((i)=>dr.processor(dr, i));
                else response = await this._cacheFile(dr);
                break;
            default:
                throw new Error(`${dr.strategy} not found`);
        }
        dr.processor(dr, response);
        return dr.response;
    }
    async _fetch(dr) {
        log("starting fetch", dr);
        const response = await fetch(dr.url, dr.fetchOptions);
        log("fetch complete", dr);
        return response;
    }
    async _cacheFile(dr) {
        const cache = await this._cache;
        const response = await this._fetch(dr);
        if (response.status === 200) await cache.put(dr.url, response.clone());
        return response;
    }
    async _getCachedResponse(dr) {
        const cache = await this._cache;
        return await cache.match(dr.url);
    }
    async _updateCacheIfNeeded(dr) {
        const cache = await this._cache;
        const cachedResponse = await this._getCachedResponse(dr);
        if (cachedResponse) {
            const etag = cachedResponse.headers.get("ETag");
            dr.fetchOptions = {
                ...dr.fetchOptions || {},
                headers: {
                    ...dr.fetchOptions?.headers || {},
                    "If-None-Match": etag
                }
            };
            const response = await this._fetch(dr);
            if (response.status === 304) {
                log("Cached version is up to date.");
                return cachedResponse;
            }
            // not all servers support If-None-Match / return 304, so we need to check the etag before pulling body
            const newEtag = response.headers.get("ETag");
            if (!etag || etag !== newEtag) {
                log(`Updating cache for: ${dr.url} old eTag=${etag} newETag=${newEtag}`);
                await cache.put(dr.url, response.clone());
                return response;
            }
            log("Cached version is up to date.");
            return cachedResponse;
        } else {
            log("No cached version found, caching now.");
            return await this._cacheFile(dr);
        }
    }
    _newDataRequest(url, strategy, processorType, fetchOptions) {
        let processor = null;
        const response = new DataResponseMeta();
        const updateSuccess = function(m, data) {
            m.response.data.next(data);
            m.response.loading.next(false);
            m.response.error.next(undefined);
        };
        const updateError = function(m, error) {
            m.response.data.next(undefined);
            m.response.loading.next(false);
            m.response.error.next(error);
        };
        switch(processorType){
            case DataProcessors.json:
                processor = async (dr, r)=>{
                    if (r.status >= 200 && r.status < 300) return r.json().then((i)=>updateSuccess(dr, i), (e)=>updateError(dr, e));
                    try {
                        const body = await r.text();
                        updateError(dr, `Request Failed. Server returned: ${r.status}: ${r.statusText}\n${body}`);
                    } catch (e) {
                        updateError(dr, `Request Failed. Server returned: ${r.status}: ${r.statusText}`);
                    }
                };
                break;
            case DataProcessors.blob:
                processor = async (dr, r)=>r.blob().then((i)=>{
                        response.data.next(i);
                        response.loading.next(false);
                        response.error.next(undefined);
                    }, (e)=>{
                        (0, _notificationService.notificationService).warning(`Request: ${dr.url} failed to parse. Error: ${e}`);
                        response.data.next(undefined);
                        response.loading.next(false);
                        response.error.next(`Request: ${dr.url} failed to parse. Error: ${e}`);
                    });
                break;
            case DataProcessors.rawResponse:
                processor = async (dr, r)=>{
                    response.data.next(r);
                    response.loading.next(false);
                    response.error.next(undefined);
                };
                break;
            default:
                throw new Error(`Unknown Processor "${processorType}"`);
        }
        const dr = {
            url,
            strategy,
            fetchOptions,
            processor,
            response
        };
        this._observedRequests.set(url, dr);
        return dr;
    }
}
const dataClient = new DataClient();

},{"../observable/ReplaySubject":"k5r8V","debug":"17JIf","./notificationService":"2Yic8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cire2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqToolbar", ()=>PdqToolbar);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _styles = require("../styles");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _pdqHotkeyService = require("../services/PdqHotkeyService");
var _pdqHotkeyServiceDefault = parcelHelpers.interopDefault(_pdqHotkeyService);
var _16Js = require("@carbon/web-components/es/icons/view--off/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("@carbon/web-components/es/icons/view/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _16Js2 = require("@carbon/web-components/es/icons/table/16.js");
var _16JsDefault2 = parcelHelpers.interopDefault(_16Js2);
var _indexJs = require("@carbon/web-components/es/components/tag/index.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:flow:toolbar");
let PdqToolbar = class PdqToolbar extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.icon = (0, _16JsDefault1.default);
        (0, _pdqHotkeyServiceDefault.default).showPdqData.subscribe((show)=>{
            this.icon = show ? (0, _16JsDefault.default) : (0, _16JsDefault1.default);
            this.requestUpdate();
        });
    }
    render() {
        return (0, _lit.html)`
            <cds-icon-button kind="secondary" @click="${()=>(0, _pdqHotkeyServiceDefault.default).toggleView()}" tooltip-position="bottom" tooltip-text="test">
              <span slot="tooltip-content">Toggle Config Layer</span>
              ${this.icon({
            slot: "icon"
        })}
            </cds-icon-button>
            <cds-icon-button kind="secondary" @click="${()=>(0, _pdqHotkeyServiceDefault.default).toggleModel()}">
              <span slot="tooltip-content" tooltip-position="bottom" >Toggle Model Layer</span>
              ${(0, _16JsDefault2.default)({
            slot: "icon"
        })}
            </cds-icon-button>
        `;
    }
};
PdqToolbar.styles = [
    (0, _styles.hide),
    (0, _styles.row),
    (0, _styles.col),
    (0, _styles.grow),
    (0, _styles.padding),
    (0, _styles.margin),
    (0, _lit.css)`
        :host {
            position: fixed;
            bottom: 16px;
            left: 16px;
            z-index: 1001;
        }
    `
];
PdqToolbar = __decorate([
    (0, _decorators.customElement)("pdq-toolbar"),
    __metadata("design:paramtypes", [])
], PdqToolbar);

},{"lit/decorators":"kQrIl","lit":"aCmte","../styles":"86IFJ","debug":"17JIf","../services/PdqHotkeyService":"blgFb","@carbon/web-components/es/icons/view--off/16.js":"auGg3","@carbon/web-components/es/icons/view/16.js":"lfVBT","@carbon/web-components/es/icons/table/16.js":"3wF0T","@carbon/web-components/es/components/tag/index.js":"6Wp6j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3wF0T":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M29,5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2ZM27,5V9H5V5Zm0,22H5V23H27Zm0-6H5V17H27Zm0-6H5V11H27Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hM146":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqDataModel", ()=>PdqDataModel);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _tableBroker = require("../services/TableBroker");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _pdqHotkeyService = require("../services/PdqHotkeyService");
var _pdqHotkeyServiceDefault = parcelHelpers.interopDefault(_pdqHotkeyService);
var _buttonJs = require("@carbon/web-components/es/components/button/button.js");
var _20Js = require("@carbon/web-components/es/icons/close/20.js");
var _20JsDefault = parcelHelpers.interopDefault(_20Js);
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
const log = (0, _debugDefault.default)("pdq:flow:pdq-data-model");
let PdqDataModel = class PdqDataModel extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.model = [];
        this.show = false;
        log("present on the page");
        const defaultOverflow = document.body.style.overflow;
        const show = ()=>{
            log("Showing data model");
            this.style.zIndex = "1000";
            this.style.visibility = "visible";
            this.style.inset = "0px";
            this.style.setProperty("--display", "block");
            document.body.style.overflow = "hidden";
            this.updateSvg();
        };
        const hide = ()=>{
            log("Hiding data model");
            this.style.zIndex = "-1000";
            this.style.visibility = "hidden";
            this.style.top = "-10000px";
            this.style.left = "-10000px";
            this.style.right = "10000px";
            this.style.bottom = "10000px";
            this.style.setProperty("--display", "none");
            document.body.style.overflow = defaultOverflow;
        };
        hide();
        (0, _tableBroker.tableBroker).tablesChanged.subscribe((i)=>this.model = i);
        (0, _pdqHotkeyServiceDefault.default).showPdqModel.subscribe((i)=>i ? show() : hide());
    }
    render() {
        return (0, _lit.html)`
      <cds-icon-button id="pdq-data-model-open-button" kind="danger" @click=${()=>(0, _pdqHotkeyServiceDefault.default).toggleModel()}>
        <span slot="tooltip-content"> Toggle Visibility </span>
        ${(0, _20JsDefault.default)({
            slot: "icon"
        })}
      </cds-icon-button>
      <svg id="diagram"/> `;
    }
    async updateSvg() {
        if (!this.d3) this.d3 = await require("a5a283ef272005a9");
        if (!this.d3 || !this.svg) {
            log(`not rendering, requirements not met: d3=${!!this.d3}, svg=${!!this.svg}`);
            return;
        }
        const model = this.model;
        log("Updating SVG", model);
        try {
            const margin = {
                top: 20,
                right: 290,
                bottom: 30,
                left: 90
            }, width = window.innerWidth - margin.left - margin.right, height = window.innerHeight - margin.top - margin.bottom;
            const d3 = this.d3;
            const svg = this.d3.select(this.svg);
            svg.html("");
            const g = svg.append("g");
            svg.attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).attr("preserveAspectRatio", "xMidYMid meet");
            g.attr("transform", "translate(" + margin.left + "," + margin.top + ")").attr("width", width).attr("height", height);
            const zoom = d3.zoom().on("zoom", (event)=>{
                g.attr("transform", event.transform);
            });
            svg.call(zoom);
            const drag = d3.drag().on("drag", function(event) {
                let dx = event.dx, dy = event.dy, currentTransform = d3.zoomTransform(svg.node());
                svg.call(zoom.transform, currentTransform.translate(dx, dy));
            });
            svg.call(drag);
            const dataTree = buildTree(model);
            if (!dataTree) return;
            const data = d3.hierarchy(dataTree);
            const treemap = d3.tree().size([
                height,
                width
            ]);
            let nodes = d3.hierarchy(data, (d)=>d.children);
            nodes = treemap(nodes);
            const link = g.selectAll(".link").data(nodes.descendants().slice(1)).enter().append("path").attr("class", "link").style("stroke", (d)=>d.data.level).attr("d", (d)=>{
                return "M" + d.y + "," + d.x + "C" + (d.y + d.parent.y) / 2 + "," + d.x + " " + (d.y + d.parent.y) / 2 + "," + d.parent.x + " " + d.parent.y + "," + d.parent.x;
            });
            // adds each node as a group
            const node = g.selectAll(".node").data(nodes.descendants()).enter().append("g").attr("class", (d)=>"node" + (d.children ? " node--internal" : " node--leaf")).attr("transform", (d)=>"translate(" + d.y + "," + d.x + ")");
            // adds the circle to the node
            node.append("circle");
            // .attr("r", (d: any) => d.data.value)
            // .style("stroke", (d: any) => d.data.type)
            // .style("fill", (d: any) => d.data.level);
            // adds the text to the node
            node.append("text")//.attr("dy", ".35em")
            //.attr("x", (d: any) => 0)
            //.attr("y", (d: any) => d.children?.length > 0 ? -10 : 0)
            .style("text-anchor", (d)=>d.children ? "end" : "start").text((d)=>{
                return d.data.data.name;
            });
            log("Updated SVG");
        } catch (e) {
            log(`Failed to update SVG: ${e}`);
        }
    }
};
PdqDataModel.styles = [
    (0, _lit.css)`
      :host {
          position: fixed;
          top: -10000px;
          left: -10000px;
          right: 10000px;
          bottom: 10000px;
          background-color: rgba(255, 255, 255, 0.9);
          z-index: 1000;
      }
      #pdq-data-model-open-button {
          position: fixed;
          top: 0;
          right: 0;
          z-index: 1001;
          display: var(--display, 'none')!important;
      }
      svg {
          shape-rendering: auto;
      }
      text {
          text-rendering: optimizeLegibility;
          font-smoothing: antialiased;
      }
      .node circle {
          fill: #fff;
          stroke: steelblue;
          stroke-width: 3px;
      }
      .node text { font: 16px sans-serif; }
      .link {
          fill: none;
          stroke: #ccc;
          stroke-width: 2px;
      }
  `
];
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Object)
], PdqDataModel.prototype, "show", void 0);
__decorate([
    (0, _decorators.query)("svg#diagram"),
    __metadata("design:type", typeof (_a = typeof SVGElement !== "undefined" && SVGElement) === "function" ? _a : Object)
], PdqDataModel.prototype, "svg", void 0);
PdqDataModel = __decorate([
    (0, _decorators.customElement)("pdq-data-model"),
    __metadata("design:paramtypes", [])
], PdqDataModel);
function buildTree(items) {
    const root = {
        name: "model",
        children: [],
        source: {
            id: "model",
            parents: new Set()
        },
        type: "ROOT"
    };
    if (!items || items.length === 0) return root;
    const nodes = new Map();
    nodes.set("model", root);
    // Create nodes for each item
    items.forEach((item)=>{
        const node = {
            name: item.id,
            children: [],
            source: item,
            type: item.view ? "VIEW" : "TABLE"
        };
        nodes.set(item.id, node);
    });
    // Link nodes to form the tree
    items.forEach((item)=>{
        const node = nodes.get(item.id);
        if (!node) {
            console.error("Node not found for item", item);
            return;
        }
        const parentIds = Array.from(item.parents);
        const primaryParentId = parentIds.length > 0 ? parentIds[0] : "model"; // If no parent, attach to model
        const parentNode = nodes.get(primaryParentId);
        if (!parentNode) {
            console.error("Parent node not found for item", item);
            return;
        }
        parentNode.children.push(node);
    });
    return root;
}

},{"lit/decorators":"kQrIl","lit":"aCmte","../services/TableBroker":"kJzSP","debug":"17JIf","../services/PdqHotkeyService":"blgFb","@carbon/web-components/es/components/button/button.js":"ca52G","@carbon/web-components/es/icons/close/20.js":"4EJkx","a5a283ef272005a9":"ds9eg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ds9eg":[function(require,module,exports) {
module.exports = require("365970a9e7709c54")(require("9aa0d3f9d0e5a4f0").resolve("fTzux")).then(()=>module.bundle.root("NOfVI"));

},{"365970a9e7709c54":"hpx0h","9aa0d3f9d0e5a4f0":"fyJL2"}],"hpx0h":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"1uYxD"}],"1uYxD":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"ge1eF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqTransform", ()=>PdqTransform);
var _lit = require("lit");
var _decorators = require("lit/decorators");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _utils = require("../utils");
var _blobRegistry = require("../services/BlobRegistry");
var _dataBroker = require("../services/DataBroker");
var _notificationService = require("../services/notificationService");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:flow:pdq-transform");
let PdqTransform = class PdqTransform extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.id = "";
        this.sources = [];
        this.cacheKey = "";
        this._onSlotChange = async (event)=>{
            log(`transform script changed`);
            const slot = event.target;
            const nodes = slot.assignedNodes({
                flatten: true
            });
            const script = (0, _utils.extractTextFromScripts)(nodes);
            if (!script?.trim()) {
                log(`no script found in slot`);
                return;
            }
            const meta = await (0, _blobRegistry.blobRegistry).registerStringAsBlob(script, "application/javascript");
            let module;
            try {
                 this.script = {
                    meta,
                    module: await import(meta.url)
                };
             } catch (e) {
                log(`WARNING: failed to import script: ${e}`);
                console.log(`WARNING: failed to import script: ${e}`, script, e);
                return;
            }
        };
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.sync();
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        this.sync();
    }
    async sync() {
        if ((this.sources?.length || 0) < 1 || !this.script || !this.id) {
            log("name, sources or module not set, sync not required");
            return;
        }
        const nKey = await (0, _utils.getSha256)(this.sources.join("") + this.script.meta.hash);
        if (this.cacheKey == nKey) {
            log("sync not required");
            return;
        }
        this.cacheKey = nKey;
        log("cacheKey changed, syncing");
        if (!this.script.module.transform) {
            log("script does not export a transform function... sync aborted.");
            return;
        }
        const sources = new Set(this.sources);
        if (sources.has(this.id)) {
            log("sources includes self... sync aborted.");
            return;
        }
        log("adding derivation");
        try {
            await (0, _dataBroker.dataBroker).upsertDerivation(this.id, [
                ...sources
            ], this.script.module.transform);
        } catch (e) {
            log(`failed to add derivation: ${e}`);
            (0, _notificationService.notificationService).warning(`failed to add derivation ${this.id}: ${e}`);
        }
    }
    render() {
        return (0, _lit.html)`<slot style="display: none;" name="transform" @slotchange="${this._onSlotChange}"></slot>`;
    }
};
PdqTransform.styles = [];
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqTransform.prototype, "id", void 0);
__decorate([
    (0, _decorators.property)({
        type: Array
    }),
    __metadata("design:type", Array)
], PdqTransform.prototype, "sources", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Object)
], PdqTransform.prototype, "script", void 0);
PdqTransform = __decorate([
    (0, _decorators.customElement)("pdq-transform")
], PdqTransform);

},{"lit":"aCmte","lit/decorators":"kQrIl","debug":"17JIf","../utils":"i8jxn","../services/BlobRegistry":"ammIH","../services/DataBroker":"kD6gB","../services/notificationService":"2Yic8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ammIH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlogRegistry", ()=>BlogRegistry);
parcelHelpers.export(exports, "blobRegistry", ()=>blobRegistry);
var _utils = require("../utils");
class BlogRegistry {
    constructor(){
        this.blobsByHash = new Map();
        this.blobsByUrl = new Map();
        this.mutex = new (0, _utils.Mutex)("BlobRegistry");
    }
    async getBlobByHash(hash) {
        return this.blobsByHash.get(hash);
    }
    async getBlobByUri(hash) {
        return this.blobsByUrl.get(hash);
    }
    async unregisterBlobByHash(hash) {
        this.blobsByUrl.get(hash)?.unregister();
    }
    async unregisterBlobByUrl(url) {
        this.blobsByUrl.get(url)?.unregister();
    }
    async registerBlob(blob) {
        const hash = await (0, _utils.getSha256)(blob);
        const unlock = await this.mutex.lock();
        try {
            if (this.blobsByHash.has(hash)) return {
                ...this.blobsByHash.get(hash),
                added: false
            };
            const url = URL.createObjectURL(blob);
            const meta = {
                url,
                hash,
                blob,
                unregister: ()=>{
                    URL.revokeObjectURL(url);
                    this.blobsByHash.delete(hash);
                    this.blobsByUrl.delete(url);
                }
            };
            this.blobsByHash.set(hash, meta);
            this.blobsByUrl.set(url, meta);
            return {
                ...meta,
                added: true
            };
        } finally{
            unlock();
        }
    }
    async registerStringAsBlob(msg, mimeType) {
        const blob = new Blob([
            msg
        ], {
            type: mimeType
        });
        return this.registerBlob(blob);
    }
}
const blobRegistry = new BlogRegistry();

},{"../utils":"i8jxn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bcmsT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqPagination", ()=>PdqPagination);
var _lit = require("lit");
var _decorators = require("lit/decorators");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _dataBroker = require("../services/DataBroker");
var _notificationService = require("../services/notificationService");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:flow:pdq-pagination");
let PdqPagination = class PdqPagination extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this._configKey = "";
        this.id = "";
        this.source = "";
        this._page = 1;
        this._pageSize = 100;
        this._cacheKey = "";
        this.render = ()=>(0, _lit.nothing);
    }
    get page() {
        return this._page;
    }
    set page(value) {
        log(`set page=${value}`);
        if (value != this._page && value > 0) {
            this._page = value;
            if (this._configKey) (0, _dataBroker.dataBroker).setDataSource(this._configKey, {
                page: this._page,
                pageSize: this.pageSize
            }).catch((e)=>log(`failed to set datasource[${this._configKey}] - ${e}`));
        }
    }
    get pageSize() {
        return this._pageSize;
    }
    set pageSize(value) {
        log(`set pageSize=${value}`);
        if (value != this._pageSize && value > 0) {
            this._pageSize = value;
            if (this._configKey) (0, _dataBroker.dataBroker).setDataSource(this._configKey, {
                page: this._page,
                pageSize: this.pageSize
            }).catch((e)=>log(`failed to set datasource[${this._configKey}] - ${e}`));
        }
    }
    firstUpdated(_changedProperties) {
        log(`firstUpdated`);
        super.firstUpdated(_changedProperties);
        this.sync().catch((e)=>log(`failed to set sync - ${e}`));
    }
    updated(_changedProperties) {
        log(`updated`);
        super.updated(_changedProperties);
        this.sync().catch((e)=>log(`failed to set sync - ${e}`));
    }
    async sync() {
        log(`sync`, this.id, this.source);
        if (!this.source || !this.id) {
            log("source or id not set, sync not required");
            return;
        }
        if (this._cacheKey == `${this.source}##${this.id}`) return;
        this._cacheKey = `${this.source}##${this.id}`;
        this._configKey = `${this.id}__page_config`;
        try {
            log(`setting DataSource for pageConfig`);
            await (0, _dataBroker.dataBroker).setDataSource(this._configKey, {
                page: this._page,
                pageSize: this.pageSize
            });
            log("adding derivation");
            await (0, _dataBroker.dataBroker).upsertDerivation(this.id, [
                this._configKey,
                this.source
            ], this.paginate);
            log(`sync complete`);
        } catch (e) {
            log(`failed to add derivation: ${e}`);
            (0, _notificationService.notificationService).warning(`failed to add derivation ${this.id}: ${e}`);
        }
    }
    async paginate(args) {
        const [{ page, pageSize }, data] = args;
        const start = (page - 1) * pageSize;
        const end = page * pageSize;
        return {
            page,
            pageSize,
            start,
            end,
            totalItems: data.length,
            items: data.slice(start, end)
        };
    }
};
PdqPagination.styles = [];
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqPagination.prototype, "id", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqPagination.prototype, "source", void 0);
__decorate([
    (0, _decorators.property)({
        type: Number,
        reflect: true
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [
        Object
    ])
], PdqPagination.prototype, "page", null);
__decorate([
    (0, _decorators.property)({
        type: Number,
        reflect: true,
        attribute: "page-size"
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [
        Object
    ])
], PdqPagination.prototype, "pageSize", null);
PdqPagination = __decorate([
    (0, _decorators.customElement)("pdq-pagination")
], PdqPagination);

},{"lit":"aCmte","lit/decorators":"kQrIl","debug":"17JIf","../services/DataBroker":"kD6gB","../services/notificationService":"2Yic8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3k4Ql":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqTable", ()=>PdqTable);
var _lit = require("lit");
var _decorators = require("lit/decorators");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _tableBroker = require("../services/TableBroker");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:flow:pdq-table");
let PdqTable = class PdqTable extends (0, _lit.LitElement) {
    // @property({type: Number})
    // limit: number|undefined
    constructor(){
        super();
        this.id = "";
        this.subscription = undefined;
        this.cacheKey = "";
        log("created");
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        log("firstUpdated");
        this.sync();
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        log("updated");
        this.sync();
    }
    async sync() {
        const nKey = this.id + "|" + this.source;
        log(`sync: ${nKey}`);
        if (!this.id || !this.source) {
            log("missing id or source... skipping");
            return;
        }
        if (this.cacheKey === nKey) {
            log("no change... skipping");
            return;
        }
        this.cacheKey = nKey;
        if (this.subscription) {
            log("unsubscribing from old data");
            this.subscription.unsubscribe();
        }
        if (this.schema) {
            log(`creating table with schema: ${this.id}, source: ${this.source}, index: ${this.index}`);
            await (0, _tableBroker.tableBroker).createTableWithSchema(this.id, this.source, this.schema, this.index || "");
        } else {
            log(`upserting table: ${this.id}, source: ${this.source}, index: ${this.index}`);
            await (0, _tableBroker.tableBroker).setTable(this.id, this.source, this.index || "");
        }
    // try {
    //   this.subscription = (await dataBroker.getObservableDataSource(this.source)).subscribe((data) => {
    //     log('updating table data', data)
    //     tableBroker.updateDataSource(this.id!, data, this.index, this.limit);
    //   })
    //
    // } catch (e) {
    //   log(`failed to table: ${e}`)
    //   notificationService.warning(`failed to add table ${this.id}: ${e}`)
    // }
    }
    render() {
        return 0, _lit.nothing;
    }
};
PdqTable.styles = [];
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqTable.prototype, "id", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqTable.prototype, "source", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqTable.prototype, "index", void 0);
__decorate([
    (0, _decorators.property)({
        type: Object
    }),
    __metadata("design:type", Object)
], PdqTable.prototype, "schema", void 0);
PdqTable = __decorate([
    (0, _decorators.customElement)("pdq-table"),
    __metadata("design:paramtypes", [])
], PdqTable);

},{"lit":"aCmte","lit/decorators":"kQrIl","debug":"17JIf","../services/TableBroker":"kJzSP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gXqJi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STREAM_START", ()=>STREAM_START);
parcelHelpers.export(exports, "PdqLiquid", ()=>PdqLiquid);
var _lit = require("lit");
var _decorators = require("lit/decorators");
var _styles = require("../styles");
var _utils = require("../utils");
var _notificationService = require("../services/notificationService");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _indexJs = require("@carbon/web-components/es/components/copy-button/index.js");
var _indexJs1 = require("@carbon/web-components/es/components/icon-button/index.js");
var _indexJs2 = require("@carbon/web-components/es/components/textarea/index.js");
var _indexJs3 = require("@carbon/web-components/es/components/tag/index.js");
var _indexJs4 = require("@carbon/web-components/es/components/form-group/index.js");
var _indexJs5 = require("@carbon/web-components/es/components/select/index.js");
var _selectItemJs = require("@carbon/web-components/es/components/select/select-item.js");
var _indexJs6 = require("@carbon/web-components/es/components/text-input/index.js");
var _16Js = require("@carbon/web-components/es/icons/data-table/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("@carbon/web-components/es/icons/save/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _pdqHotkeyService = require("../services/PdqHotkeyService");
var _pdqHotkeyServiceDefault = parcelHelpers.interopDefault(_pdqHotkeyService);
var _pdqMixin = require("../flow/_pdq-mixin");
var _defs = require("@carbon/web-components/es/components/tag/defs");
var _liquidjs = require("liquidjs");
var _unsafeHtml = require("lit-html/directives/unsafe-html");
var _pdqLiquidVariable = require("./pdq-liquid-variable");
var _pdqLiquidVariableStack = require("./pdq-liquid-variable-stack");
var _blobRegistry = require("../services/BlobRegistry");
var _dataBroker = require("../services/DataBroker");
var _rxjs = require("rxjs");
var _tableBroker = require("../services/TableBroker");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
const liquid = new (0, _liquidjs.Liquid)();
const log = (0, _debugDefault.default)("pdq:liquid:pdq-liquid");
const STREAM_START = Symbol("STREAM_START");
let PdqLiquid = class PdqLiquid extends (0, _lit.LitElement) {
    get template() {
        return this._template$.value;
    }
    set template(value) {
        this._template$.next(value);
    }
    get variables() {
        return this._variables$.value;
    }
    set variables(value) {
        this._variables$.next(value);
    }
    constructor(){
        super();
        this._template$ = new (0, _rxjs.BehaviorSubject)("Loading...");
        this._variables$ = new (0, _rxjs.BehaviorSubject)([]);
        this._data$ = new (0, _rxjs.BehaviorSubject)([]);
        this.error = null;
        this.show = false;
        this._subscription = (0, _rxjs.Subscription).EMPTY;
        this._script = "";
        this.dataPreview = "no data";
        this.rendered = "loading...";
        this._oldViews = new Map();
        this._tableSubjects = new Map();
        this._oldDataSubs = new Map();
        this._dataSubjects = new Map();
        this.scriptAbortController = new AbortController();
        this.signal = this.scriptAbortController.signal;
        this._firstScript = true;
        this.updated = async ()=>{
            if (this._script !== "") {
                // todo - show this be split and triggered by rendered or liquid rendered?
                const meta = await (0, _blobRegistry.blobRegistry).registerStringAsBlob(this._script, "application/javascript");
                let module;
                try {
                     module = await import(meta.url);
                 } catch (e) {
                    log(`WARNING: failed to import script: ${e}`);
                    console.log(`WARNING: failed to import script: ${e}`, this._script, e);
                    return;
                }
                if ((meta.added || this._firstScript) && module.init) {
                    log("script found for the first time... calling init...");
                    try {
                        module.init.call(this, this);
                    } catch (e) {
                        log(`WARNING: init script failed: ${e}`);
                        console.log(`WARNING: init script failed: ${e}`);
                    }
                } else if (!module.init) log(`INFO: no init function exported from script`);
                if (module.rendered) try {
                    this.scriptAbortController.abort();
                    this.scriptAbortController = new AbortController();
                    this.signal = this.scriptAbortController.signal;
                    module.rendered.call(this, this);
                } catch (e) {
                    log(`WARNING: rendered script failed: ${e}`);
                    console.log(`WARNING: rendered script failed: ${e}`);
                }
                else log(`WARNING: no rendered function exported from script`);
                this._firstScript = false;
            }
        };
        const mappedVars$ = this._variables$.pipe((0, _rxjs.map)((i)=>this._resolveVariables(i)), (0, _rxjs.mergeMap)((resolvedVars)=>(0, _rxjs.combineLatest)(resolvedVars).pipe((0, _rxjs.catchError)((e, c)=>{
                log(`PIPELINE ERROR: ${e}`, e, c);
                return (0, _rxjs.of)([]);
            }))), (0, _rxjs.catchError)((e, c)=>{
            log(`PIPELINE ERROR: ${e} ${c}`, e, c);
            return (0, _rxjs.of)([]);
        }));
        const passedTemplate$ = this._template$.pipe((0, _rxjs.map)((i)=>liquid.parse(i)), (0, _rxjs.tap)(()=>log("passedTemplate$: updated")), (0, _rxjs.shareReplay)(1));
        this._subscription = (0, _rxjs.combineLatest)([
            passedTemplate$,
            mappedVars$
        ]).pipe((0, _rxjs.tap)((i)=>log("render liquid triggered", i[0], i[1])), (0, _rxjs.distinctUntilChanged)(), // distinctUntilChanged((curr, prev) => {
        //   if (curr[0] != prev[0])
        //     return false;
        //   if (curr[1].length != prev[1].length)
        //     return false;
        //   for (const s in curr[1])
        //     if (curr[1][s] != prev[1][s])
        //       return false;
        //   return true
        // }),
        (0, _rxjs.tap)(()=>log("render liquid throttling")), (0, _rxjs.debounceTime)(30), (0, _rxjs.tap)(()=>log("render liquid proceeding"))).subscribe(([tmpl, vars])=>{
            (0, _utils.safeFireAndForgetFactory)(log)(this._renderLiquid([
                tmpl,
                vars
            ]), "liquid render complete");
        });
    }
    _resolveVariables(variable) {
        if (variable.length === 0) return (0, _rxjs.of)([]);
        return variable.map((i)=>this._resolveVariable(i));
    }
    _resolveVariable(variable) {
        log(`Resolving variable: ${variable.name}`);
        if (variable.source) {
            let subject = this._tableSubjects.get(variable.source);
            if (!subject) {
                subject = new (0, _rxjs.ReplaySubject)(1);
                subject.next(STREAM_START);
                this._tableSubjects.set(variable.source, subject);
                this._oldDataSubs.set(variable.source, (0, _rxjs.Subscription).EMPTY);
            }
            (0, _dataBroker.dataBroker).getObservableDataSource(variable.source).then((data)=>{
                this._oldDataSubs.get(variable.source)?.unsubscribe();
                this._oldDataSubs.set(variable.source, data.subscribe((data)=>{
                    subject.next({
                        ...variable,
                        value: data
                    });
                }));
            });
            return subject;
        }
        if (variable.table) return (0, _tableBroker.tableBroker).getTable(variable.table).pipe((0, _rxjs.mergeMap)((table)=>{
            const oldView = this._oldViews.get(variable.table);
            if (oldView) oldView.delete();
            let subject = this._tableSubjects.get(variable.table);
            if (!subject) {
                subject = new (0, _rxjs.Subject)();
                this._tableSubjects.set(variable.table, subject);
            }
            async function GetData() {
                const view = await table.view();
                view.on_update(async ()=>{
                    subject.next(await view.to_json());
                });
                subject.next(await view.to_json());
            }
            return subject;
        }));
        if (typeof variable.value !== "undefined") return (0, _rxjs.of)(variable);
        log(`Variable not resolved: ${variable.name}`, variable);
        throw new Error("Variable not resolved");
    }
    async _renderLiquid([template, variables]) {
        log("rendering liquid", template, variables);
        const model = {};
        variables.forEach((i)=>{
            model[i.name] = i.value;
        });
        const oldRendered = this.rendered;
        console.log("rendering liquid", template, model);
        this.rendered = await liquid.render(template, model);
        this._data$.next(model);
        this.requestUpdate("rendered", oldRendered);
    }
    render() {
        log(`${this.id} ${this.show} - render`, this.rendered);
        const slot = (0, _lit.html)`
      <slot style="display: none;" name="liquid" @slotchange="${this._onSlotChange}"></slot>`;
        const variablesSlot = (0, _lit.html)`
      <slot style="display: none;" name="variables" class="hide" @slotchange="${this._onVariablesSlotChange}"></slot>`;
        const scriptSlot = (0, _lit.html)`
      <slot style="display: none;" name="script" class="hide" @slotchange="${this._onScriptsSlotChange}"></slot>`;
        const show = this.show || (0, _pdqHotkeyServiceDefault.default).showPdqData.currentValue();
        return (0, _lit.html)`
      ${slot}
      ${variablesSlot}
      ${scriptSlot}
      ${!!this.error ? (0, _lit.html)`
        <cds-inline-notification kind="error" title="Liquid Template"
                                 subtitle="${this.error} ${typeof this.error}"></cds-inline-notification>` : (0, _lit.nothing)}
      ${show ? (0, _lit.html)`
        <div class="col show ${this.error ? "error" : ""}">
          ${this.renderToolBar((0, _lit.html)`
            <cds-icon-button slot="tool-bar" @click="${this.save}" kind="primary">
              <span slot="tooltip-content">Save</span>
              ${(0, _16JsDefault1.default)({
            slot: "icon"
        })}
            </cds-icon-button>
          `)}
          <div class="m-2">
            <pdq-liquid-variable-stack
              @pdq-liquid-variables-saved="${this._variablesChanged}"
              .variables="${this.variables}"
            >
            </pdq-liquid-variable-stack>
            <cds-textarea class="template" value="${this.template?.trim()}"><label slot="label-text">Liquid
              Template:</label></cds-textarea>
          </div>
        </div>
        <hr>
      ` : (0, _lit.nothing)}${(0, _unsafeHtml.unsafeHTML)(this.rendered)}`;
    }
    async _variablesChanged(evt) {
        log("variablesChanged", evt.detail);
        this._variables$.next(evt.detail);
    }
    async _onSlotChange(event) {
        log(`${this.id} - slot change`);
        const slot = event.target;
        const nodes = slot.assignedNodes({
            flatten: true
        });
        const template = (0, _utils.extractTextFromScripts)(nodes);
        log(`template: ${template}`);
        this._template$.next(template.replace(/xscript/g, "script"));
        this.requestUpdate("template");
    }
    async _onScriptsSlotChange(event) {
        log(`${this.id} - slot change`);
        const slot = event.target;
        const nodes = slot.assignedNodes({
            flatten: true
        });
        this._script = (0, _utils.extractTextFromScripts)(nodes);
        this.requestUpdate();
    }
    async _onVariablesSlotChange(event) {
        log(`${this.id} - variables slot change`);
        const slot = event.target;
        const nodes = slot.assignedNodes({
            flatten: true
        });
        const template = (0, _utils.extractTextFromScripts)(nodes);
        try {
            const vars = JSON.parse(template);
            if (Array.isArray(vars)) {
                log("variables switching to", vars);
                this._variables$.next(vars);
            } else log("variables not an array... ignoring...", vars);
        } catch (e) {
            log(`Error parsing JSON: \n${e?.message || e}`);
            (0, _notificationService.notificationService).error(`pdq-liquid#${this.id}|Error parsing JSON: \n${e?.message || e}`);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this._template$.complete();
        this._variables$.complete();
        this._oldViews.forEach((i)=>i.delete());
        this._tableSubjects.forEach((i)=>i.complete());
        this._dataSubjects.forEach((i)=>i.complete());
        this._subscription.unsubscribe();
    }
};
PdqLiquid.styles = [
    (0, _styles.hide),
    (0, _styles.row),
    (0, _styles.col),
    (0, _styles.grow),
    (0, _styles.padding),
    (0, _styles.margin)
];
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Object)
], PdqLiquid.prototype, "error", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Boolean)
], PdqLiquid.prototype, "show", void 0);
__decorate([
    (0, _decorators.property)({
        type: Array,
        reflect: true
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [
        String
    ])
], PdqLiquid.prototype, "template", null);
__decorate([
    (0, _decorators.property)({
        type: Array,
        reflect: true
    }),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [
        Array
    ])
], PdqLiquid.prototype, "variables", null);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Object)
], PdqLiquid.prototype, "dataPreview", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Object)
], PdqLiquid.prototype, "rendered", void 0);
__decorate([
    (0, _decorators.query)(`cds-textarea.template`),
    __metadata("design:type", Object)
], PdqLiquid.prototype, "templateTextArea", void 0);
PdqLiquid = __decorate([
    (0, _decorators.customElement)("pdq-liquid"),
    (0, _pdqMixin.pdqDiscoveryLayer)(log, (0, _16JsDefault.default), "pdq-liquid", "rgba(236, 255, 83, 0.13)", (0, _defs.TAG_TYPE).CYAN),
    __metadata("design:paramtypes", [])
], PdqLiquid);

},{"lit":"aCmte","lit/decorators":"kQrIl","../styles":"86IFJ","../utils":"i8jxn","../services/notificationService":"2Yic8","debug":"17JIf","@carbon/web-components/es/components/copy-button/index.js":"5DrQc","@carbon/web-components/es/components/icon-button/index.js":"hEDP1","@carbon/web-components/es/components/textarea/index.js":"i8YTZ","@carbon/web-components/es/components/tag/index.js":"6Wp6j","@carbon/web-components/es/components/form-group/index.js":"3wGK9","@carbon/web-components/es/components/select/index.js":"fhDAD","@carbon/web-components/es/components/select/select-item.js":"2uF8Y","@carbon/web-components/es/components/text-input/index.js":"hYM6R","@carbon/web-components/es/icons/data-table/16.js":"4fHNP","@carbon/web-components/es/icons/save/16.js":"atEnQ","../services/PdqHotkeyService":"blgFb","../flow/_pdq-mixin":"66yqo","@carbon/web-components/es/components/tag/defs":"ioe2X","liquidjs":"ejjgD","lit-html/directives/unsafe-html":"4DFR8","./pdq-liquid-variable":"8eQLC","./pdq-liquid-variable-stack":"gIrvP","../services/BlobRegistry":"ammIH","../services/DataBroker":"kD6gB","rxjs":"d4Szo","../services/TableBroker":"kJzSP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3wGK9":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _formGroupJs = require("./form-group.js");

},{"./form-group.js":"51K3q"}],"51K3q":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSFormGroup$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _settingsJs = require("../../globals/settings.js");
var _formGroupScssJs = require("./form-group.scss.js");
var _formGroupScssJsDefault = parcelHelpers.interopDefault(_formGroupScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The shell UI for file uploader.
 *
 * @element cds-form-group
 * @slot label-title.
 * @slot lebel-description.
 */ let CDSFormGroup = class CDSFormGroup extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Specify whether the Form Group is invalid
         */ this.invalid = false;
        /**
         * Specify whether the message should be displayed in the Form Group
         */ this.message = false;
    }
    render() {
        const { invalid, legendId, legendText, message, messageText } = this;
        return (0, _lit.html)`
      <fieldset
        class="${0, _settingsJs.prefix}--fieldset"
        ?data-invalid=${invalid}
        aria-labelledby="${legendId}">
        <legend class="${0, _settingsJs.prefix}--label" id=${legendId}>${legendText}</legend>
        <slot></slot>
        ${message ? (0, _lit.html)`<div class="${0, _settingsJs.prefix}--form__requirements">
              ${messageText}
            </div>` : null}
      </fieldset>
    `;
    }
};
CDSFormGroup.styles = (0, _formGroupScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSFormGroup.prototype, "invalid", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "legend-id"
    })
], CDSFormGroup.prototype, "legendId", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "legend-text"
    })
], CDSFormGroup.prototype, "legendText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSFormGroup.prototype, "message", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        attribute: "message-text",
        reflect: true
    })
], CDSFormGroup.prototype, "messageText", void 0);
CDSFormGroup = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-form-group`)
], CDSFormGroup);
var CDSFormGroup$1 = CDSFormGroup;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/settings.js":"EipuL","./form-group.scss.js":"bJ2PT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bJ2PT":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset,:host(cds-form-group) fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before,:host(cds-form-group) fieldset *,:host(cds-form-group) fieldset :after,:host(cds-form-group) fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}:host(cds-form-group) fieldset{border:0;font:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ejjgD":[function(require,module,exports) {
/*
 * liquidjs@10.13.1, https://github.com/harttle/liquidjs
 * (c) 2016-2024 harttle
 * Released under the MIT License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AssertionError", ()=>AssertionError);
parcelHelpers.export(exports, "AssignTag", ()=>AssignTag);
parcelHelpers.export(exports, "BlockTag", ()=>BlockTag);
parcelHelpers.export(exports, "BreakTag", ()=>BreakTag);
parcelHelpers.export(exports, "CaptureTag", ()=>CaptureTag);
parcelHelpers.export(exports, "CaseTag", ()=>CaseTag);
parcelHelpers.export(exports, "CommentTag", ()=>CommentTag);
parcelHelpers.export(exports, "Context", ()=>Context);
parcelHelpers.export(exports, "ContinueTag", ()=>ContinueTag);
parcelHelpers.export(exports, "CycleTag", ()=>CycleTag);
parcelHelpers.export(exports, "DecrementTag", ()=>DecrementTag);
parcelHelpers.export(exports, "Drop", ()=>Drop);
parcelHelpers.export(exports, "EchoTag", ()=>EchoTag);
parcelHelpers.export(exports, "Expression", ()=>Expression);
parcelHelpers.export(exports, "Filter", ()=>Filter);
parcelHelpers.export(exports, "ForTag", ()=>ForTag);
parcelHelpers.export(exports, "Hash", ()=>Hash);
parcelHelpers.export(exports, "IfTag", ()=>IfTag);
parcelHelpers.export(exports, "IncludeTag", ()=>IncludeTag);
parcelHelpers.export(exports, "IncrementTag", ()=>IncrementTag);
parcelHelpers.export(exports, "InlineCommentTag", ()=>InlineCommentTag);
parcelHelpers.export(exports, "LayoutTag", ()=>LayoutTag);
parcelHelpers.export(exports, "Liquid", ()=>Liquid);
parcelHelpers.export(exports, "LiquidError", ()=>LiquidError);
parcelHelpers.export(exports, "LiquidTag", ()=>LiquidTag);
parcelHelpers.export(exports, "Output", ()=>Output);
parcelHelpers.export(exports, "ParseError", ()=>ParseError);
parcelHelpers.export(exports, "ParseStream", ()=>ParseStream);
parcelHelpers.export(exports, "RawTag", ()=>RawTag);
parcelHelpers.export(exports, "RenderError", ()=>RenderError);
parcelHelpers.export(exports, "RenderTag", ()=>RenderTag);
parcelHelpers.export(exports, "TablerowTag", ()=>TablerowTag);
parcelHelpers.export(exports, "Tag", ()=>Tag);
parcelHelpers.export(exports, "TagToken", ()=>TagToken);
parcelHelpers.export(exports, "TimezoneDate", ()=>TimezoneDate);
parcelHelpers.export(exports, "Token", ()=>Token);
parcelHelpers.export(exports, "TokenKind", ()=>TokenKind);
parcelHelpers.export(exports, "TokenizationError", ()=>TokenizationError);
parcelHelpers.export(exports, "Tokenizer", ()=>Tokenizer);
parcelHelpers.export(exports, "TypeGuards", ()=>typeGuards);
parcelHelpers.export(exports, "UndefinedVariableError", ()=>UndefinedVariableError);
parcelHelpers.export(exports, "UnlessTag", ()=>UnlessTag);
parcelHelpers.export(exports, "Value", ()=>Value);
parcelHelpers.export(exports, "assert", ()=>assert);
parcelHelpers.export(exports, "createTrie", ()=>createTrie);
parcelHelpers.export(exports, "defaultOperators", ()=>defaultOperators);
parcelHelpers.export(exports, "defaultOptions", ()=>defaultOptions);
parcelHelpers.export(exports, "evalQuotedToken", ()=>evalQuotedToken);
parcelHelpers.export(exports, "evalToken", ()=>evalToken);
parcelHelpers.export(exports, "filters", ()=>filters);
parcelHelpers.export(exports, "isFalsy", ()=>isFalsy);
parcelHelpers.export(exports, "isTruthy", ()=>isTruthy);
parcelHelpers.export(exports, "tags", ()=>tags);
parcelHelpers.export(exports, "toPromise", ()=>toPromise);
parcelHelpers.export(exports, "toValue", ()=>toValue);
parcelHelpers.export(exports, "toValueSync", ()=>toValueSync);
parcelHelpers.export(exports, "version", ()=>version);
class Token {
    constructor(kind, input, begin, end, file){
        this.kind = kind;
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
    }
    getText() {
        return this.input.slice(this.begin, this.end);
    }
    getPosition() {
        let [row, col] = [
            1,
            1
        ];
        for(let i = 0; i < this.begin; i++)if (this.input[i] === "\n") {
            row++;
            col = 1;
        } else col++;
        return [
            row,
            col
        ];
    }
    size() {
        return this.end - this.begin;
    }
}
class Drop {
    liquidMethodMissing(key) {
        return undefined;
    }
}
const toString$1 = Object.prototype.toString;
const toLowerCase = String.prototype.toLowerCase;
const hasOwnProperty = Object.hasOwnProperty;
function isString(value) {
    return typeof value === "string";
}
// eslint-disable-next-line @typescript-eslint/ban-types
function isFunction(value) {
    return typeof value === "function";
}
function isPromise(val) {
    return val && isFunction(val.then);
}
function isIterator(val) {
    return val && isFunction(val.next) && isFunction(val.throw) && isFunction(val.return);
}
function escapeRegex(str) {
    return str.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function stringify(value) {
    value = toValue(value);
    if (isString(value)) return value;
    if (isNil(value)) return "";
    if (isArray(value)) return value.map((x)=>stringify(x)).join("");
    return String(value);
}
function toEnumerable(val) {
    val = toValue(val);
    if (isArray(val)) return val;
    if (isString(val) && val.length > 0) return [
        val
    ];
    if (isIterable(val)) return Array.from(val);
    if (isObject(val)) return Object.keys(val).map((key)=>[
            key,
            val[key]
        ]);
    return [];
}
function toArray(val) {
    val = toValue(val);
    if (isNil(val)) return [];
    if (isArray(val)) return val;
    return [
        val
    ];
}
function toValue(value) {
    return value instanceof Drop && isFunction(value.valueOf) ? value.valueOf() : value;
}
function isNumber(value) {
    return typeof value === "number";
}
function toLiquid(value) {
    if (value && isFunction(value.toLiquid)) return toLiquid(value.toLiquid());
    return value;
}
function isNil(value) {
    return value == null;
}
function isUndefined(value) {
    return value === undefined;
}
function isArray(value) {
    // be compatible with IE 8
    return toString$1.call(value) === "[object Array]";
}
function isIterable(value) {
    return isObject(value) && Symbol.iterator in value;
}
/*
 * Iterates over own enumerable string keyed properties of an object and invokes iteratee for each property.
 * The iteratee is invoked with three arguments: (value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning false.
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @return {Object} Returns object.
 */ function forOwn(obj, iteratee) {
    obj = obj || {};
    for(const k in obj)if (hasOwnProperty.call(obj, k)) {
        if (iteratee(obj[k], k, obj) === false) break;
    }
    return obj;
}
function last(arr) {
    return arr[arr.length - 1];
}
/*
 * Checks if value is the language type of Object.
 * (e.g. arrays, functions, objects, regexes, new Number(0), and new String(''))
 * @param {any} value The value to check.
 * @return {Boolean} Returns true if value is an object, else false.
 */ function isObject(value) {
    const type = typeof value;
    return value !== null && (type === "object" || type === "function");
}
function range(start, stop, step = 1) {
    const arr = [];
    for(let i = start; i < stop; i += step)arr.push(i);
    return arr;
}
function padStart(str, length, ch = " ") {
    return pad(str, length, ch, (str, ch)=>ch + str);
}
function padEnd(str, length, ch = " ") {
    return pad(str, length, ch, (str, ch)=>str + ch);
}
function pad(str, length, ch, add) {
    str = String(str);
    let n = length - str.length;
    while(n-- > 0)str = add(str, ch);
    return str;
}
function identify(val) {
    return val;
}
function changeCase(str) {
    const hasLowerCase = [
        ...str
    ].some((ch)=>ch >= "a" && ch <= "z");
    return hasLowerCase ? str.toUpperCase() : str.toLowerCase();
}
function ellipsis(str, N) {
    return str.length > N ? str.slice(0, N - 3) + "..." : str;
}
// compare string in case-insensitive way, undefined values to the tail
function caseInsensitiveCompare(a, b) {
    if (a == null && b == null) return 0;
    if (a == null) return 1;
    if (b == null) return -1;
    a = toLowerCase.call(a);
    b = toLowerCase.call(b);
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function argumentsToValue(fn) {
    return (...args)=>fn(...args.map(toValue));
}
function escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
/**
 * targeting ES5, extends Error won't create a proper prototype chain, need a trait to kee track of classes
 */ const TRAIT = "__liquidClass__";
class LiquidError extends Error {
    constructor(err, token){
        /**
         * note: for ES5 targeting, `this` will be replaced by return value of Error(),
         * thus everything on `this` will be lost, avoid calling `LiquidError` methods here
         */ super(typeof err === "string" ? err : err.message);
        this.context = "";
        if (typeof err !== "string") Object.defineProperty(this, "originalError", {
            value: err,
            enumerable: false
        });
        Object.defineProperty(this, "token", {
            value: token,
            enumerable: false
        });
        Object.defineProperty(this, TRAIT, {
            value: "LiquidError",
            enumerable: false
        });
    }
    update() {
        Object.defineProperty(this, "context", {
            value: mkContext(this.token),
            enumerable: false
        });
        this.message = mkMessage(this.message, this.token);
        this.stack = this.message + "\n" + this.context + "\n" + this.stack;
        if (this.originalError) this.stack += "\nFrom " + this.originalError.stack;
    }
    static is(obj) {
        return (obj === null || obj === void 0 ? void 0 : obj[TRAIT]) === "LiquidError";
    }
}
class TokenizationError extends LiquidError {
    constructor(message, token){
        super(message, token);
        this.name = "TokenizationError";
        super.update();
    }
}
class ParseError extends LiquidError {
    constructor(err, token){
        super(err, token);
        this.name = "ParseError";
        this.message = err.message;
        super.update();
    }
}
class RenderError extends LiquidError {
    constructor(err, tpl){
        super(err, tpl.token);
        this.name = "RenderError";
        this.message = err.message;
        super.update();
    }
    static is(obj) {
        return obj.name === "RenderError";
    }
}
class UndefinedVariableError extends LiquidError {
    constructor(err, token){
        super(err, token);
        this.name = "UndefinedVariableError";
        this.message = err.message;
        super.update();
    }
}
// only used internally; raised where we don't have token information,
// so it can't be an UndefinedVariableError.
class InternalUndefinedVariableError extends Error {
    constructor(variableName){
        super(`undefined variable: ${variableName}`);
        this.name = "InternalUndefinedVariableError";
        this.variableName = variableName;
    }
}
class AssertionError extends Error {
    constructor(message){
        super(message);
        this.name = "AssertionError";
        this.message = message + "";
    }
}
function mkContext(token) {
    const [line, col] = token.getPosition();
    const lines = token.input.split("\n");
    const begin = Math.max(line - 2, 1);
    const end = Math.min(line + 3, lines.length);
    const context = range(begin, end + 1).map((lineNumber)=>{
        const rowIndicator = lineNumber === line ? ">> " : "   ";
        const num = padStart(String(lineNumber), String(end).length);
        let text = `${rowIndicator}${num}| `;
        const colIndicator = lineNumber === line ? "\n" + padStart("^", col + text.length) : "";
        text += lines[lineNumber - 1];
        text += colIndicator;
        return text;
    }).join("\n");
    return context;
}
function mkMessage(msg, token) {
    if (token.file) msg += `, file:${token.file}`;
    const [line, col] = token.getPosition();
    msg += `, line:${line}, col:${col}`;
    return msg;
}
// **DO NOT CHANGE THIS FILE**
//
// This file is generated by bin/character-gen.js
// bitmask character types to boost performance
const TYPES = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    4,
    4,
    4,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    2,
    8,
    0,
    0,
    0,
    0,
    8,
    0,
    0,
    0,
    64,
    0,
    65,
    0,
    0,
    33,
    33,
    33,
    33,
    33,
    33,
    33,
    33,
    33,
    33,
    0,
    0,
    2,
    2,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0
];
const WORD = 1;
const BLANK = 4;
const QUOTE = 8;
const INLINE_BLANK = 16;
const NUMBER = 32;
const SIGN = 64;
const PUNCTUATION = 128;
function isWord(char) {
    const code = char.charCodeAt(0);
    return code >= 128 ? !TYPES[code] : !!(TYPES[code] & WORD);
}
TYPES[160] = TYPES[5760] = TYPES[6158] = TYPES[8192] = TYPES[8193] = TYPES[8194] = TYPES[8195] = TYPES[8196] = TYPES[8197] = TYPES[8198] = TYPES[8199] = TYPES[8200] = TYPES[8201] = TYPES[8202] = TYPES[8232] = TYPES[8233] = TYPES[8239] = TYPES[8287] = TYPES[12288] = BLANK;
TYPES[8220] = TYPES[8221] = PUNCTUATION;
function assert(predicate, message) {
    if (!predicate) {
        const msg = typeof message === "function" ? message() : message || `expect ${predicate} to be true`;
        throw new AssertionError(msg);
    }
}
class NullDrop extends Drop {
    equals(value) {
        return isNil(toValue(value));
    }
    gt() {
        return false;
    }
    geq() {
        return false;
    }
    lt() {
        return false;
    }
    leq() {
        return false;
    }
    valueOf() {
        return null;
    }
}
class EmptyDrop extends Drop {
    equals(value) {
        if (value instanceof EmptyDrop) return false;
        value = toValue(value);
        if (isString(value) || isArray(value)) return value.length === 0;
        if (isObject(value)) return Object.keys(value).length === 0;
        return false;
    }
    gt() {
        return false;
    }
    geq() {
        return false;
    }
    lt() {
        return false;
    }
    leq() {
        return false;
    }
    valueOf() {
        return "";
    }
}
class BlankDrop extends EmptyDrop {
    equals(value) {
        if (value === false) return true;
        if (isNil(toValue(value))) return true;
        if (isString(value)) return /^\s*$/.test(value);
        return super.equals(value);
    }
}
class ForloopDrop extends Drop {
    constructor(length, collection, variable){
        super();
        this.i = 0;
        this.length = length;
        this.name = `${variable}-${collection}`;
    }
    next() {
        this.i++;
    }
    index0() {
        return this.i;
    }
    index() {
        return this.i + 1;
    }
    first() {
        return this.i === 0;
    }
    last() {
        return this.i === this.length - 1;
    }
    rindex() {
        return this.length - this.i;
    }
    rindex0() {
        return this.length - this.i - 1;
    }
    valueOf() {
        return JSON.stringify(this);
    }
}
class BlockDrop extends Drop {
    constructor(// the block render from layout template
    superBlockRender = ()=>""){
        super();
        this.superBlockRender = superBlockRender;
    }
    /**
     * Provide parent access in child block by
     * {{ block.super }}
     */ super() {
        return this.superBlockRender();
    }
}
function isComparable(arg) {
    return arg && isFunction(arg.equals) && isFunction(arg.gt) && isFunction(arg.geq) && isFunction(arg.lt) && isFunction(arg.leq);
}
const nil = new NullDrop();
const literalValues = {
    "true": true,
    "false": false,
    "nil": nil,
    "null": nil,
    "empty": new EmptyDrop(),
    "blank": new BlankDrop()
};
function createTrie(input) {
    const trie = {};
    for (const [name, data] of Object.entries(input)){
        let node = trie;
        for(let i = 0; i < name.length; i++){
            const c = name[i];
            node[c] = node[c] || {};
            if (i === name.length - 1 && isWord(name[i])) node[c].needBoundary = true;
            node = node[c];
        }
        node.data = data;
        node.end = true;
    }
    return trie;
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
// convert an async iterator to a Promise
function toPromise(val) {
    return __awaiter(this, void 0, void 0, function*() {
        if (!isIterator(val)) return val;
        let value;
        let done = false;
        let next = "next";
        do {
            const state = val[next](value);
            done = state.done;
            value = state.value;
            next = "next";
            try {
                if (isIterator(value)) value = toPromise(value);
                if (isPromise(value)) value = yield value;
            } catch (err) {
                next = "throw";
                value = err;
            }
        }while (!done);
        return value;
    });
}
// convert an async iterator to a value in a synchronous manner
function toValueSync(val) {
    if (!isIterator(val)) return val;
    let value;
    let done = false;
    let next = "next";
    do {
        const state = val[next](value);
        done = state.done;
        value = state.value;
        next = "next";
        if (isIterator(value)) try {
            value = toValueSync(value);
        } catch (err) {
            next = "throw";
            value = err;
        }
    }while (!done);
    return value;
}
const rFormat = /%([-_0^#:]+)?(\d+)?([EO])?(.)/;
const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const monthNamesShort = monthNames.map(abbr);
const dayNamesShort = dayNames.map(abbr);
function abbr(str) {
    return str.slice(0, 3);
}
// prototype extensions
function daysInMonth(d) {
    const feb = isLeapYear(d) ? 29 : 28;
    return [
        31,
        feb,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
}
function getDayOfYear(d) {
    let num = 0;
    for(let i = 0; i < d.getMonth(); ++i)num += daysInMonth(d)[i];
    return num + d.getDate();
}
function getWeekOfYear(d, startDay) {
    // Skip to startDay of this week
    const now = getDayOfYear(d) + (startDay - d.getDay());
    // Find the first startDay of the year
    const jan1 = new Date(d.getFullYear(), 0, 1);
    const then = 7 - jan1.getDay() + startDay;
    return String(Math.floor((now - then) / 7) + 1);
}
function isLeapYear(d) {
    const year = d.getFullYear();
    return !!((year & 3) === 0 && (year % 100 || year % 400 === 0 && year));
}
function ordinal(d) {
    const date = d.getDate();
    if ([
        11,
        12,
        13
    ].includes(date)) return "th";
    switch(date % 10){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
}
function century(d) {
    return parseInt(d.getFullYear().toString().substring(0, 2), 10);
}
// default to 0
const padWidths = {
    d: 2,
    e: 2,
    H: 2,
    I: 2,
    j: 3,
    k: 2,
    l: 2,
    L: 3,
    m: 2,
    M: 2,
    S: 2,
    U: 2,
    W: 2
};
// default to '0'
const padChars = {
    a: " ",
    A: " ",
    b: " ",
    B: " ",
    c: " ",
    e: " ",
    k: " ",
    l: " ",
    p: " ",
    P: " "
};
function getTimezoneOffset(d, opts) {
    const nOffset = Math.abs(d.getTimezoneOffset());
    const h = Math.floor(nOffset / 60);
    const m = nOffset % 60;
    return (d.getTimezoneOffset() > 0 ? "-" : "+") + padStart(h, 2, "0") + (opts.flags[":"] ? ":" : "") + padStart(m, 2, "0");
}
const formatCodes = {
    a: (d)=>dayNamesShort[d.getDay()],
    A: (d)=>dayNames[d.getDay()],
    b: (d)=>monthNamesShort[d.getMonth()],
    B: (d)=>monthNames[d.getMonth()],
    c: (d)=>d.toLocaleString(),
    C: (d)=>century(d),
    d: (d)=>d.getDate(),
    e: (d)=>d.getDate(),
    H: (d)=>d.getHours(),
    I: (d)=>String(d.getHours() % 12 || 12),
    j: (d)=>getDayOfYear(d),
    k: (d)=>d.getHours(),
    l: (d)=>String(d.getHours() % 12 || 12),
    L: (d)=>d.getMilliseconds(),
    m: (d)=>d.getMonth() + 1,
    M: (d)=>d.getMinutes(),
    N: (d, opts)=>{
        const width = Number(opts.width) || 9;
        const str = String(d.getMilliseconds()).slice(0, width);
        return padEnd(str, width, "0");
    },
    p: (d)=>d.getHours() < 12 ? "AM" : "PM",
    P: (d)=>d.getHours() < 12 ? "am" : "pm",
    q: (d)=>ordinal(d),
    s: (d)=>Math.round(d.getTime() / 1000),
    S: (d)=>d.getSeconds(),
    u: (d)=>d.getDay() || 7,
    U: (d)=>getWeekOfYear(d, 0),
    w: (d)=>d.getDay(),
    W: (d)=>getWeekOfYear(d, 1),
    x: (d)=>d.toLocaleDateString(),
    X: (d)=>d.toLocaleTimeString(),
    y: (d)=>d.getFullYear().toString().slice(2, 4),
    Y: (d)=>d.getFullYear(),
    z: getTimezoneOffset,
    Z: (d, opts)=>{
        if (d.getTimezoneName) return d.getTimezoneName() || getTimezoneOffset(d, opts);
        return typeof Intl !== "undefined" ? Intl.DateTimeFormat().resolvedOptions().timeZone : "";
    },
    "t": ()=>"	",
    "n": ()=>"\n",
    "%": ()=>"%"
};
formatCodes.h = formatCodes.b;
function strftime(d, formatStr) {
    let output = "";
    let remaining = formatStr;
    let match;
    while(match = rFormat.exec(remaining)){
        output += remaining.slice(0, match.index);
        remaining = remaining.slice(match.index + match[0].length);
        output += format(d, match);
    }
    return output + remaining;
}
function format(d, match) {
    const [input, flagStr = "", width, modifier, conversion] = match;
    const convert = formatCodes[conversion];
    if (!convert) return input;
    const flags = {};
    for (const flag of flagStr)flags[flag] = true;
    let ret = String(convert(d, {
        flags,
        width,
        modifier
    }));
    let padChar = padChars[conversion] || "0";
    let padWidth = width || padWidths[conversion] || 0;
    if (flags["^"]) ret = ret.toUpperCase();
    else if (flags["#"]) ret = changeCase(ret);
    if (flags["_"]) padChar = " ";
    else if (flags["0"]) padChar = "0";
    if (flags["-"]) padWidth = 0;
    return padStart(ret, padWidth, padChar);
}
// one minute in milliseconds
const OneMinute = 60000;
const ISO8601_TIMEZONE_PATTERN = /([zZ]|([+-])(\d{2}):(\d{2}))$/;
/**
 * A date implementation with timezone info, just like Ruby date
 *
 * Implementation:
 * - create a Date offset by it's timezone difference, avoiding overriding a bunch of methods
 * - rewrite getTimezoneOffset() to trick strftime
 */ class TimezoneDate {
    constructor(init, timezone){
        this.date = init instanceof TimezoneDate ? init.date : new Date(init);
        this.timezoneOffset = isString(timezone) ? TimezoneDate.getTimezoneOffset(timezone, this.date) : timezone;
        this.timezoneName = isString(timezone) ? timezone : "";
        const diff = (this.date.getTimezoneOffset() - this.timezoneOffset) * OneMinute;
        const time = this.date.getTime() + diff;
        this.displayDate = new Date(time);
    }
    getTime() {
        return this.displayDate.getTime();
    }
    getMilliseconds() {
        return this.displayDate.getMilliseconds();
    }
    getSeconds() {
        return this.displayDate.getSeconds();
    }
    getMinutes() {
        return this.displayDate.getMinutes();
    }
    getHours() {
        return this.displayDate.getHours();
    }
    getDay() {
        return this.displayDate.getDay();
    }
    getDate() {
        return this.displayDate.getDate();
    }
    getMonth() {
        return this.displayDate.getMonth();
    }
    getFullYear() {
        return this.displayDate.getFullYear();
    }
    toLocaleString(locale, init) {
        if (init === null || init === void 0 ? void 0 : init.timeZone) return this.date.toLocaleString(locale, init);
        return this.displayDate.toLocaleString(locale, init);
    }
    toLocaleTimeString(locale) {
        return this.displayDate.toLocaleTimeString(locale);
    }
    toLocaleDateString(locale) {
        return this.displayDate.toLocaleDateString(locale);
    }
    getTimezoneOffset() {
        return this.timezoneOffset;
    }
    getTimezoneName() {
        return this.timezoneName;
    }
    /**
     * Create a Date object fixed to it's declared Timezone. Both
     * - 2021-08-06T02:29:00.000Z and
     * - 2021-08-06T02:29:00.000+08:00
     * will always be displayed as
     * - 2021-08-06 02:29:00
     * regardless timezoneOffset in JavaScript realm
     *
     * The implementation hack:
     * Instead of calling `.getMonth()`/`.getUTCMonth()` respect to `preserveTimezones`,
     * we create a different Date to trick strftime, it's both simpler and more performant.
     * Given that a template is expected to be parsed fewer times than rendered.
     */ static createDateFixedToTimezone(dateString) {
        const m = dateString.match(ISO8601_TIMEZONE_PATTERN);
        // representing a UTC timestamp
        if (m && m[1] === "Z") return new TimezoneDate(+new Date(dateString), 0);
        // has a timezone specified
        if (m && m[2] && m[3] && m[4]) {
            const [, , sign, hours, minutes] = m;
            const offset = (sign === "+" ? -1 : 1) * (parseInt(hours, 10) * 60 + parseInt(minutes, 10));
            return new TimezoneDate(+new Date(dateString), offset);
        }
        return new Date(dateString);
    }
    static getTimezoneOffset(timezoneName, date = new Date()) {
        const localDateString = date.toLocaleString("en-US", {
            timeZone: timezoneName
        });
        const utcDateString = date.toLocaleString("en-US", {
            timeZone: "UTC"
        });
        const localDate = new Date(localDateString);
        const utcDate = new Date(utcDateString);
        return (+utcDate - +localDate) / 60000;
    }
}
class DelimitedToken extends Token {
    constructor(kind, [contentBegin, contentEnd], input, begin, end, trimLeft, trimRight, file){
        super(kind, input, begin, end, file);
        this.trimLeft = false;
        this.trimRight = false;
        const tl = input[contentBegin] === "-";
        const tr = input[contentEnd - 1] === "-";
        let l = tl ? contentBegin + 1 : contentBegin;
        let r = tr ? contentEnd - 1 : contentEnd;
        while(l < r && TYPES[input.charCodeAt(l)] & BLANK)l++;
        while(r > l && TYPES[input.charCodeAt(r - 1)] & BLANK)r--;
        this.contentRange = [
            l,
            r
        ];
        this.trimLeft = tl || trimLeft;
        this.trimRight = tr || trimRight;
    }
    get content() {
        return this.input.slice(this.contentRange[0], this.contentRange[1]);
    }
}
class TagToken extends DelimitedToken {
    constructor(input, begin, end, options, file){
        const { trimTagLeft, trimTagRight, tagDelimiterLeft, tagDelimiterRight } = options;
        const [valueBegin, valueEnd] = [
            begin + tagDelimiterLeft.length,
            end - tagDelimiterRight.length
        ];
        super(TokenKind.Tag, [
            valueBegin,
            valueEnd
        ], input, begin, end, trimTagLeft, trimTagRight, file);
        this.tokenizer = new Tokenizer(input, options.operators, file, this.contentRange);
        this.name = this.tokenizer.readTagName();
        this.tokenizer.assert(this.name, `illegal tag syntax, tag name expected`);
        this.tokenizer.skipBlank();
    }
    get args() {
        return this.tokenizer.input.slice(this.tokenizer.p, this.contentRange[1]);
    }
}
class OutputToken extends DelimitedToken {
    constructor(input, begin, end, options, file){
        const { trimOutputLeft, trimOutputRight, outputDelimiterLeft, outputDelimiterRight } = options;
        const valueRange = [
            begin + outputDelimiterLeft.length,
            end - outputDelimiterRight.length
        ];
        super(TokenKind.Output, valueRange, input, begin, end, trimOutputLeft, trimOutputRight, file);
    }
}
class HTMLToken extends Token {
    constructor(input, begin, end, file){
        super(TokenKind.HTML, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
        this.trimLeft = 0;
        this.trimRight = 0;
    }
    getContent() {
        return this.input.slice(this.begin + this.trimLeft, this.end - this.trimRight);
    }
}
class NumberToken extends Token {
    constructor(input, begin, end, file){
        super(TokenKind.Number, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
        this.content = Number(this.getText());
    }
}
class IdentifierToken extends Token {
    constructor(input, begin, end, file){
        super(TokenKind.Word, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
        this.content = this.getText();
    }
    isNumber(allowSign = false) {
        const begin = allowSign && TYPES[this.input.charCodeAt(this.begin)] & SIGN ? this.begin + 1 : this.begin;
        for(let i = begin; i < this.end; i++){
            if (!(TYPES[this.input.charCodeAt(i)] & NUMBER)) return false;
        }
        return true;
    }
}
class LiteralToken extends Token {
    constructor(input, begin, end, file){
        super(TokenKind.Literal, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
        this.literal = this.getText();
        this.content = literalValues[this.literal];
    }
}
const operatorPrecedences = {
    "==": 2,
    "!=": 2,
    ">": 2,
    "<": 2,
    ">=": 2,
    "<=": 2,
    "contains": 2,
    "not": 1,
    "and": 0,
    "or": 0
};
const operatorTypes = {
    "==": 0 /* OperatorType.Binary */ ,
    "!=": 0 /* OperatorType.Binary */ ,
    ">": 0 /* OperatorType.Binary */ ,
    "<": 0 /* OperatorType.Binary */ ,
    ">=": 0 /* OperatorType.Binary */ ,
    "<=": 0 /* OperatorType.Binary */ ,
    "contains": 0 /* OperatorType.Binary */ ,
    "not": 1 /* OperatorType.Unary */ ,
    "and": 0 /* OperatorType.Binary */ ,
    "or": 0 /* OperatorType.Binary */ 
};
class OperatorToken extends Token {
    constructor(input, begin, end, file){
        super(TokenKind.Operator, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
        this.operator = this.getText();
    }
    getPrecedence() {
        const key = this.getText();
        return key in operatorPrecedences ? operatorPrecedences[key] : 1;
    }
}
class PropertyAccessToken extends Token {
    constructor(variable, props, input, begin, end, file){
        super(TokenKind.PropertyAccess, input, begin, end, file);
        this.variable = variable;
        this.props = props;
    }
}
class FilterToken extends Token {
    constructor(name, args, input, begin, end, file){
        super(TokenKind.Filter, input, begin, end, file);
        this.name = name;
        this.args = args;
    }
}
class HashToken extends Token {
    constructor(input, begin, end, name, value, file){
        super(TokenKind.Hash, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.name = name;
        this.value = value;
        this.file = file;
    }
}
const rHex = /[\da-fA-F]/;
const rOct = /[0-7]/;
const escapeChar = {
    b: "\b",
    f: "\f",
    n: "\n",
    r: "\r",
    t: "	",
    v: "\v"
};
function hexVal(c) {
    const code = c.charCodeAt(0);
    if (code >= 97) return code - 87;
    if (code >= 65) return code - 55;
    return code - 48;
}
function parseStringLiteral(str) {
    let ret = "";
    for(let i = 1; i < str.length - 1; i++){
        if (str[i] !== "\\") {
            ret += str[i];
            continue;
        }
        if (escapeChar[str[i + 1]] !== undefined) ret += escapeChar[str[++i]];
        else if (str[i + 1] === "u") {
            let val = 0;
            let j = i + 2;
            while(j <= i + 5 && rHex.test(str[j]))val = val * 16 + hexVal(str[j++]);
            i = j - 1;
            ret += String.fromCharCode(val);
        } else if (!rOct.test(str[i + 1])) ret += str[++i];
        else {
            let j = i + 1;
            let val = 0;
            while(j <= i + 3 && rOct.test(str[j]))val = val * 8 + hexVal(str[j++]);
            i = j - 1;
            ret += String.fromCharCode(val);
        }
    }
    return ret;
}
class QuotedToken extends Token {
    constructor(input, begin, end, file){
        super(TokenKind.Quoted, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
        this.content = parseStringLiteral(this.getText());
    }
}
class RangeToken extends Token {
    constructor(input, begin, end, lhs, rhs, file){
        super(TokenKind.Range, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.lhs = lhs;
        this.rhs = rhs;
        this.file = file;
    }
}
/**
 * LiquidTagToken is different from TagToken by not having delimiters `{%` or `%}`
 */ class LiquidTagToken extends DelimitedToken {
    constructor(input, begin, end, options, file){
        super(TokenKind.Tag, [
            begin,
            end
        ], input, begin, end, false, false, file);
        this.tokenizer = new Tokenizer(input, options.operators, file, this.contentRange);
        this.name = this.tokenizer.readTagName();
        this.tokenizer.assert(this.name, "illegal liquid tag syntax");
        this.tokenizer.skipBlank();
        this.args = this.tokenizer.remaining();
    }
}
/**
 * value expression with optional filters
 * e.g.
 * {% assign foo="bar" | append: "coo" %}
 */ class FilteredValueToken extends Token {
    constructor(initial, filters, input, begin, end, file){
        super(TokenKind.FilteredValue, input, begin, end, file);
        this.initial = initial;
        this.filters = filters;
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
    }
}
class SimpleEmitter {
    constructor(){
        this.buffer = "";
    }
    write(html) {
        this.buffer += stringify(html);
    }
}
class StreamedEmitter {
    constructor(){
        this.buffer = "";
        this.stream = null;
        throw new Error("streaming not supported in browser");
    }
}
class KeepingTypeEmitter {
    constructor(){
        this.buffer = "";
    }
    write(html) {
        html = toValue(html);
        // This will only preserve the type if the value is isolated.
        // I.E:
        // {{ my-port }} -> 42
        // {{ my-host }}:{{ my-port }} -> 'host:42'
        if (typeof html !== "string" && this.buffer === "") this.buffer = html;
        else this.buffer = stringify(this.buffer) + stringify(html);
    }
}
class Render {
    renderTemplatesToNodeStream(templates, ctx) {
        const emitter = new StreamedEmitter();
        Promise.resolve().then(()=>toPromise(this.renderTemplates(templates, ctx, emitter))).then(()=>emitter.end(), (err)=>emitter.error(err));
        return emitter.stream;
    }
    *renderTemplates(templates, ctx, emitter) {
        if (!emitter) emitter = ctx.opts.keepOutputType ? new KeepingTypeEmitter() : new SimpleEmitter();
        for (const tpl of templates)try {
            // if tpl.render supports emitter, it'll return empty `html`
            const html = yield tpl.render(ctx, emitter);
            // if not, it'll return an `html`, write to the emitter for it
            html && emitter.write(html);
            if (emitter["break"] || emitter["continue"]) break;
        } catch (e) {
            const err = RenderError.is(e) ? e : new RenderError(e, tpl);
            throw err;
        }
        return emitter.buffer;
    }
}
class Expression {
    constructor(tokens){
        this.postfix = [
            ...toPostfix(tokens)
        ];
    }
    *evaluate(ctx, lenient) {
        assert(ctx, "unable to evaluate: context not defined");
        const operands = [];
        for (const token of this.postfix)if (isOperatorToken(token)) {
            const r = operands.pop();
            let result;
            if (operatorTypes[token.operator] === 1 /* OperatorType.Unary */ ) result = yield ctx.opts.operators[token.operator](r, ctx);
            else {
                const l = operands.pop();
                result = yield ctx.opts.operators[token.operator](l, r, ctx);
            }
            operands.push(result);
        } else operands.push((yield evalToken(token, ctx, lenient)));
        return operands[0];
    }
    valid() {
        return !!this.postfix.length;
    }
}
function* evalToken(token, ctx, lenient = false) {
    if (!token) return;
    if ("content" in token) return token.content;
    if (isPropertyAccessToken(token)) return yield evalPropertyAccessToken(token, ctx, lenient);
    if (isRangeToken(token)) return yield evalRangeToken(token, ctx);
}
function* evalPropertyAccessToken(token, ctx, lenient) {
    const props = [];
    for (const prop of token.props)props.push((yield evalToken(prop, ctx, false)));
    try {
        if (token.variable) {
            const variable = yield evalToken(token.variable, ctx, lenient);
            return yield ctx._getFromScope(variable, props);
        } else return yield ctx._get(props);
    } catch (e) {
        if (lenient && e.name === "InternalUndefinedVariableError") return null;
        throw new UndefinedVariableError(e, token);
    }
}
function evalQuotedToken(token) {
    return token.content;
}
function* evalRangeToken(token, ctx) {
    const low = yield evalToken(token.lhs, ctx);
    const high = yield evalToken(token.rhs, ctx);
    return range(+low, +high + 1);
}
function* toPostfix(tokens) {
    const ops = [];
    for (const token of tokens)if (isOperatorToken(token)) {
        while(ops.length && ops[ops.length - 1].getPrecedence() > token.getPrecedence())yield ops.pop();
        ops.push(token);
    } else yield token;
    while(ops.length)yield ops.pop();
}
function isTruthy(val, ctx) {
    return !isFalsy(val, ctx);
}
function isFalsy(val, ctx) {
    if (ctx.opts.jsTruthy) return !val;
    else return val === false || undefined === val || val === null;
}
const defaultOperators = {
    "==": equals,
    "!=": (l, r)=>!equals(l, r),
    ">": (l, r)=>{
        if (isComparable(l)) return l.gt(r);
        if (isComparable(r)) return r.lt(l);
        return toValue(l) > toValue(r);
    },
    "<": (l, r)=>{
        if (isComparable(l)) return l.lt(r);
        if (isComparable(r)) return r.gt(l);
        return toValue(l) < toValue(r);
    },
    ">=": (l, r)=>{
        if (isComparable(l)) return l.geq(r);
        if (isComparable(r)) return r.leq(l);
        return toValue(l) >= toValue(r);
    },
    "<=": (l, r)=>{
        if (isComparable(l)) return l.leq(r);
        if (isComparable(r)) return r.geq(l);
        return toValue(l) <= toValue(r);
    },
    "contains": (l, r)=>{
        l = toValue(l);
        if (isArray(l)) return l.some((i)=>equals(i, r));
        if (isFunction(l === null || l === void 0 ? void 0 : l.indexOf)) return l.indexOf(toValue(r)) > -1;
        return false;
    },
    "not": (v, ctx)=>isFalsy(toValue(v), ctx),
    "and": (l, r, ctx)=>isTruthy(toValue(l), ctx) && isTruthy(toValue(r), ctx),
    "or": (l, r, ctx)=>isTruthy(toValue(l), ctx) || isTruthy(toValue(r), ctx)
};
function equals(lhs, rhs) {
    if (isComparable(lhs)) return lhs.equals(rhs);
    if (isComparable(rhs)) return rhs.equals(lhs);
    lhs = toValue(lhs);
    rhs = toValue(rhs);
    if (isArray(lhs)) return isArray(rhs) && arrayEquals(lhs, rhs);
    return lhs === rhs;
}
function arrayEquals(lhs, rhs) {
    if (lhs.length !== rhs.length) return false;
    return !lhs.some((value, i)=>!equals(value, rhs[i]));
}
class Node {
    constructor(key, value, next, prev){
        this.key = key;
        this.value = value;
        this.next = next;
        this.prev = prev;
    }
}
class LRU {
    constructor(limit, size = 0){
        this.limit = limit;
        this.size = size;
        this.cache = {};
        this.head = new Node("HEAD", null, null, null);
        this.tail = new Node("TAIL", null, null, null);
        this.head.next = this.tail;
        this.tail.prev = this.head;
    }
    write(key, value) {
        if (this.cache[key]) this.cache[key].value = value;
        else {
            const node = new Node(key, value, this.head.next, this.head);
            this.head.next.prev = node;
            this.head.next = node;
            this.cache[key] = node;
            this.size++;
            this.ensureLimit();
        }
    }
    read(key) {
        if (!this.cache[key]) return;
        const { value } = this.cache[key];
        this.remove(key);
        this.write(key, value);
        return value;
    }
    remove(key) {
        const node = this.cache[key];
        node.prev.next = node.next;
        node.next.prev = node.prev;
        delete this.cache[key];
        this.size--;
    }
    clear() {
        this.head.next = this.tail;
        this.tail.prev = this.head;
        this.size = 0;
        this.cache = {};
    }
    ensureLimit() {
        if (this.size > this.limit) this.remove(this.tail.prev.key);
    }
}
function domResolve(root, path) {
    const base = document.createElement("base");
    base.href = root;
    const head = document.getElementsByTagName("head")[0];
    head.insertBefore(base, head.firstChild);
    const a = document.createElement("a");
    a.href = path;
    const resolved = a.href;
    head.removeChild(base);
    return resolved;
}
function resolve(root, filepath, ext) {
    if (root.length && last(root) !== "/") root += "/";
    const url = domResolve(root, filepath);
    return url.replace(/^(\w+:\/\/[^/]+)(\/[^?]+)/, (str, origin, path)=>{
        const last = path.split("/").pop();
        if (/\.\w+$/.test(last)) return str;
        return origin + path + ext;
    });
}
function readFile(url) {
    return __awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onload = ()=>{
                if (xhr.status >= 200 && xhr.status < 300) resolve(xhr.responseText);
                else reject(new Error(xhr.statusText));
            };
            xhr.onerror = ()=>{
                reject(new Error("An error occurred whilst receiving the response."));
            };
            xhr.open("GET", url);
            xhr.send();
        });
    });
}
function readFileSync(url) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, false);
    xhr.send();
    if (xhr.status < 200 || xhr.status >= 300) throw new Error(xhr.statusText);
    return xhr.responseText;
}
function exists(filepath) {
    return __awaiter(this, void 0, void 0, function*() {
        return true;
    });
}
function existsSync(filepath) {
    return true;
}
function dirname(filepath) {
    return domResolve(filepath, ".");
}
const sep = "/";
var fs = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    resolve: resolve,
    readFile: readFile,
    readFileSync: readFileSync,
    exists: exists,
    existsSync: existsSync,
    dirname: dirname,
    sep: sep
});
function defaultFilter(value, defaultValue, ...args) {
    value = toValue(value);
    if (isArray(value) || isString(value)) return value.length ? value : defaultValue;
    if (value === false && new Map(args).get("allow_false")) return false;
    return isFalsy(value, this.context) ? defaultValue : value;
}
function json(value, space = 0) {
    return JSON.stringify(value, null, space);
}
function inspect(value, space = 0) {
    const ancestors = [];
    return JSON.stringify(value, function(_key, value) {
        if (typeof value !== "object" || value === null) return value;
        // `this` is the object that value is contained in, i.e., its direct parent.
        while(ancestors.length > 0 && ancestors[ancestors.length - 1] !== this)ancestors.pop();
        if (ancestors.includes(value)) return "[Circular]";
        ancestors.push(value);
        return value;
    }, space);
}
function to_integer(value) {
    return Number(value);
}
const raw = {
    raw: true,
    handler: identify
};
var misc = {
    default: defaultFilter,
    raw,
    jsonify: json,
    to_integer,
    json,
    inspect
};
const escapeMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&#34;",
    "'": "&#39;"
};
const unescapeMap = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&#34;": '"',
    "&#39;": "'"
};
function escape(str) {
    return stringify(str).replace(/&|<|>|"|'/g, (m)=>escapeMap[m]);
}
function xml_escape(str) {
    return escape(str);
}
function unescape(str) {
    return stringify(str).replace(/&(amp|lt|gt|#34|#39);/g, (m)=>unescapeMap[m]);
}
function escape_once(str) {
    return escape(unescape(stringify(str)));
}
function newline_to_br(v) {
    return stringify(v).replace(/\r?\n/gm, "<br />\n");
}
function strip_html(v) {
    return stringify(v).replace(/<script[\s\S]*?<\/script>|<style[\s\S]*?<\/style>|<.*?>|<!--[\s\S]*?-->/g, "");
}
var htmlFilters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    escape: escape,
    xml_escape: xml_escape,
    escape_once: escape_once,
    newline_to_br: newline_to_br,
    strip_html: strip_html
});
const defaultOptions = {
    root: [
        "."
    ],
    layouts: [
        "."
    ],
    partials: [
        "."
    ],
    relativeReference: true,
    jekyllInclude: false,
    cache: undefined,
    extname: "",
    fs: fs,
    dynamicPartials: true,
    jsTruthy: false,
    dateFormat: "%A, %B %-e, %Y at %-l:%M %P %z",
    trimTagRight: false,
    trimTagLeft: false,
    trimOutputRight: false,
    trimOutputLeft: false,
    greedy: true,
    tagDelimiterLeft: "{%",
    tagDelimiterRight: "%}",
    outputDelimiterLeft: "{{",
    outputDelimiterRight: "}}",
    preserveTimezones: false,
    strictFilters: false,
    strictVariables: false,
    ownPropertyOnly: true,
    lenientIf: false,
    globals: {},
    keepOutputType: false,
    operators: defaultOperators
};
function normalize(options) {
    if (options.hasOwnProperty("root")) {
        if (!options.hasOwnProperty("partials")) options.partials = options.root;
        if (!options.hasOwnProperty("layouts")) options.layouts = options.root;
    }
    if (options.hasOwnProperty("cache")) {
        let cache;
        if (typeof options.cache === "number") cache = options.cache > 0 ? new LRU(options.cache) : undefined;
        else if (typeof options.cache === "object") cache = options.cache;
        else cache = options.cache ? new LRU(1024) : undefined;
        options.cache = cache;
    }
    options = Object.assign(Object.assign(Object.assign({}, defaultOptions), options.jekyllInclude ? {
        dynamicPartials: false
    } : {}), options);
    if ((!options.fs.dirname || !options.fs.sep) && options.relativeReference) {
        console.warn("[LiquidJS] `fs.dirname` and `fs.sep` are required for relativeReference, set relativeReference to `false` to suppress this warning");
        options.relativeReference = false;
    }
    options.root = normalizeDirectoryList(options.root);
    options.partials = normalizeDirectoryList(options.partials);
    options.layouts = normalizeDirectoryList(options.layouts);
    options.outputEscape = options.outputEscape && getOutputEscapeFunction(options.outputEscape);
    return options;
}
function getOutputEscapeFunction(nameOrFunction) {
    if (nameOrFunction === "escape") return escape;
    if (nameOrFunction === "json") return misc.json;
    assert(isFunction(nameOrFunction), "`outputEscape` need to be of type string or function");
    return nameOrFunction;
}
function normalizeDirectoryList(value) {
    let list = [];
    if (isArray(value)) list = value;
    if (isString(value)) list = [
        value
    ];
    return list;
}
function whiteSpaceCtrl(tokens, options) {
    let inRaw = false;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        if (!isDelimitedToken(token)) continue;
        if (!inRaw && token.trimLeft) trimLeft(tokens[i - 1], options.greedy);
        if (isTagToken(token)) {
            if (token.name === "raw") inRaw = true;
            else if (token.name === "endraw") inRaw = false;
        }
        if (!inRaw && token.trimRight) trimRight(tokens[i + 1], options.greedy);
    }
}
function trimLeft(token, greedy) {
    if (!token || !isHTMLToken(token)) return;
    const mask = greedy ? BLANK : INLINE_BLANK;
    while(TYPES[token.input.charCodeAt(token.end - 1 - token.trimRight)] & mask)token.trimRight++;
}
function trimRight(token, greedy) {
    if (!token || !isHTMLToken(token)) return;
    const mask = greedy ? BLANK : INLINE_BLANK;
    while(TYPES[token.input.charCodeAt(token.begin + token.trimLeft)] & mask)token.trimLeft++;
    if (token.input.charAt(token.begin + token.trimLeft) === "\n") token.trimLeft++;
}
class Tokenizer {
    constructor(input, operators = defaultOptions.operators, file, range){
        this.input = input;
        this.file = file;
        this.rawBeginAt = -1;
        this.p = range ? range[0] : 0;
        this.N = range ? range[1] : input.length;
        this.opTrie = createTrie(operators);
        this.literalTrie = createTrie(literalValues);
    }
    readExpression() {
        return new Expression(this.readExpressionTokens());
    }
    *readExpressionTokens() {
        while(this.p < this.N){
            const operator = this.readOperator();
            if (operator) {
                yield operator;
                continue;
            }
            const operand = this.readValue();
            if (operand) {
                yield operand;
                continue;
            }
            return;
        }
    }
    readOperator() {
        this.skipBlank();
        const end = this.matchTrie(this.opTrie);
        if (end === -1) return;
        return new OperatorToken(this.input, this.p, this.p = end, this.file);
    }
    matchTrie(trie) {
        let node = trie;
        let i = this.p;
        let info;
        while(node[this.input[i]] && i < this.N){
            node = node[this.input[i++]];
            if (node["end"]) info = node;
        }
        if (!info) return -1;
        if (info["needBoundary"] && isWord(this.peek(i - this.p))) return -1;
        return i;
    }
    readFilteredValue() {
        const begin = this.p;
        const initial = this.readExpression();
        this.assert(initial.valid(), `invalid value expression: ${this.snapshot()}`);
        const filters = this.readFilters();
        return new FilteredValueToken(initial, filters, this.input, begin, this.p, this.file);
    }
    readFilters() {
        const filters = [];
        while(true){
            const filter = this.readFilter();
            if (!filter) return filters;
            filters.push(filter);
        }
    }
    readFilter() {
        this.skipBlank();
        if (this.end()) return null;
        this.assert(this.peek() === "|", `expected "|" before filter`);
        this.p++;
        const begin = this.p;
        const name = this.readIdentifier();
        if (!name.size()) {
            this.assert(this.end(), `expected filter name`);
            return null;
        }
        const args = [];
        this.skipBlank();
        if (this.peek() === ":") do {
            ++this.p;
            const arg = this.readFilterArg();
            arg && args.push(arg);
            this.skipBlank();
            this.assert(this.end() || this.peek() === "," || this.peek() === "|", ()=>`unexpected character ${this.snapshot()}`);
        }while (this.peek() === ",");
        else if (this.peek() === "|" || this.end()) ;
        else throw this.error('expected ":" after filter name');
        return new FilterToken(name.getText(), args, this.input, begin, this.p, this.file);
    }
    readFilterArg() {
        const key = this.readValue();
        if (!key) return;
        this.skipBlank();
        if (this.peek() !== ":") return key;
        ++this.p;
        const value = this.readValue();
        return [
            key.getText(),
            value
        ];
    }
    readTopLevelTokens(options = defaultOptions) {
        const tokens = [];
        while(this.p < this.N){
            const token = this.readTopLevelToken(options);
            tokens.push(token);
        }
        whiteSpaceCtrl(tokens, options);
        return tokens;
    }
    readTopLevelToken(options) {
        const { tagDelimiterLeft, outputDelimiterLeft } = options;
        if (this.rawBeginAt > -1) return this.readEndrawOrRawContent(options);
        if (this.match(tagDelimiterLeft)) return this.readTagToken(options);
        if (this.match(outputDelimiterLeft)) return this.readOutputToken(options);
        return this.readHTMLToken([
            tagDelimiterLeft,
            outputDelimiterLeft
        ]);
    }
    readHTMLToken(stopStrings) {
        const begin = this.p;
        while(this.p < this.N){
            if (stopStrings.some((str)=>this.match(str))) break;
            ++this.p;
        }
        return new HTMLToken(this.input, begin, this.p, this.file);
    }
    readTagToken(options = defaultOptions) {
        const { file, input } = this;
        const begin = this.p;
        if (this.readToDelimiter(options.tagDelimiterRight) === -1) throw this.error(`tag ${this.snapshot(begin)} not closed`, begin);
        const token = new TagToken(input, begin, this.p, options, file);
        if (token.name === "raw") this.rawBeginAt = begin;
        return token;
    }
    readToDelimiter(delimiter, respectQuoted = false) {
        this.skipBlank();
        while(this.p < this.N){
            if (respectQuoted && this.peekType() & QUOTE) {
                this.readQuoted();
                continue;
            }
            ++this.p;
            if (this.rmatch(delimiter)) return this.p;
        }
        return -1;
    }
    readOutputToken(options = defaultOptions) {
        const { file, input } = this;
        const { outputDelimiterRight } = options;
        const begin = this.p;
        if (this.readToDelimiter(outputDelimiterRight, true) === -1) throw this.error(`output ${this.snapshot(begin)} not closed`, begin);
        return new OutputToken(input, begin, this.p, options, file);
    }
    readEndrawOrRawContent(options) {
        const { tagDelimiterLeft, tagDelimiterRight } = options;
        const begin = this.p;
        let leftPos = this.readTo(tagDelimiterLeft) - tagDelimiterLeft.length;
        while(this.p < this.N){
            if (this.readIdentifier().getText() !== "endraw") {
                leftPos = this.readTo(tagDelimiterLeft) - tagDelimiterLeft.length;
                continue;
            }
            while(this.p <= this.N){
                if (this.rmatch(tagDelimiterRight)) {
                    const end = this.p;
                    if (begin === leftPos) {
                        this.rawBeginAt = -1;
                        return new TagToken(this.input, begin, end, options, this.file);
                    } else {
                        this.p = leftPos;
                        return new HTMLToken(this.input, begin, leftPos, this.file);
                    }
                }
                if (this.rmatch(tagDelimiterLeft)) break;
                this.p++;
            }
        }
        throw this.error(`raw ${this.snapshot(this.rawBeginAt)} not closed`, begin);
    }
    readLiquidTagTokens(options = defaultOptions) {
        const tokens = [];
        while(this.p < this.N){
            const token = this.readLiquidTagToken(options);
            token && tokens.push(token);
        }
        return tokens;
    }
    readLiquidTagToken(options) {
        this.skipBlank();
        if (this.end()) return;
        const begin = this.p;
        this.readToDelimiter("\n");
        const end = this.p;
        return new LiquidTagToken(this.input, begin, end, options, this.file);
    }
    error(msg, pos = this.p) {
        return new TokenizationError(msg, new IdentifierToken(this.input, pos, this.N, this.file));
    }
    assert(pred, msg, pos) {
        if (!pred) throw this.error(typeof msg === "function" ? msg() : msg, pos);
    }
    snapshot(begin = this.p) {
        return JSON.stringify(ellipsis(this.input.slice(begin, this.N), 32));
    }
    /**
     * @deprecated use #readIdentifier instead
     */ readWord() {
        return this.readIdentifier();
    }
    readIdentifier() {
        this.skipBlank();
        const begin = this.p;
        while(!this.end() && isWord(this.peek()))++this.p;
        return new IdentifierToken(this.input, begin, this.p, this.file);
    }
    readNonEmptyIdentifier() {
        const id = this.readIdentifier();
        return id.size() ? id : undefined;
    }
    readTagName() {
        this.skipBlank();
        // Handle inline comment tags
        if (this.input[this.p] === "#") return this.input.slice(this.p, ++this.p);
        return this.readIdentifier().getText();
    }
    readHashes(jekyllStyle) {
        const hashes = [];
        while(true){
            const hash = this.readHash(jekyllStyle);
            if (!hash) return hashes;
            hashes.push(hash);
        }
    }
    readHash(jekyllStyle) {
        this.skipBlank();
        if (this.peek() === ",") ++this.p;
        const begin = this.p;
        const name = this.readNonEmptyIdentifier();
        if (!name) return;
        let value;
        this.skipBlank();
        const sep = jekyllStyle ? "=" : ":";
        if (this.peek() === sep) {
            ++this.p;
            value = this.readValue();
        }
        return new HashToken(this.input, begin, this.p, name, value, this.file);
    }
    remaining() {
        return this.input.slice(this.p, this.N);
    }
    advance(step = 1) {
        this.p += step;
    }
    end() {
        return this.p >= this.N;
    }
    readTo(end) {
        while(this.p < this.N){
            ++this.p;
            if (this.rmatch(end)) return this.p;
        }
        return -1;
    }
    readValue() {
        this.skipBlank();
        const begin = this.p;
        const variable = this.readLiteral() || this.readQuoted() || this.readRange() || this.readNumber();
        const props = this.readProperties(!variable);
        if (!props.length) return variable;
        return new PropertyAccessToken(variable, props, this.input, begin, this.p);
    }
    readScopeValue() {
        this.skipBlank();
        const begin = this.p;
        const props = this.readProperties();
        if (!props.length) return undefined;
        return new PropertyAccessToken(undefined, props, this.input, begin, this.p);
    }
    readProperties(isBegin = true) {
        const props = [];
        while(true){
            if (this.peek() === "[") {
                this.p++;
                const prop = this.readValue() || new IdentifierToken(this.input, this.p, this.p, this.file);
                this.assert(this.readTo("]") !== -1, "[ not closed");
                props.push(prop);
                continue;
            }
            if (isBegin && !props.length) {
                const prop = this.readNonEmptyIdentifier();
                if (prop) {
                    props.push(prop);
                    continue;
                }
            }
            if (this.peek() === "." && this.peek(1) !== ".") {
                this.p++;
                const prop = this.readNonEmptyIdentifier();
                if (!prop) break;
                props.push(prop);
                continue;
            }
            break;
        }
        return props;
    }
    readNumber() {
        this.skipBlank();
        let decimalFound = false;
        let digitFound = false;
        let n = 0;
        if (this.peekType() & SIGN) n++;
        while(this.p + n <= this.N){
            if (this.peekType(n) & NUMBER) {
                digitFound = true;
                n++;
            } else if (this.peek(n) === "." && this.peek(n + 1) !== ".") {
                if (decimalFound || !digitFound) return;
                decimalFound = true;
                n++;
            } else break;
        }
        if (digitFound && !isWord(this.peek(n))) {
            const num = new NumberToken(this.input, this.p, this.p + n, this.file);
            this.advance(n);
            return num;
        }
    }
    readLiteral() {
        this.skipBlank();
        const end = this.matchTrie(this.literalTrie);
        if (end === -1) return;
        const literal = new LiteralToken(this.input, this.p, end, this.file);
        this.p = end;
        return literal;
    }
    readRange() {
        this.skipBlank();
        const begin = this.p;
        if (this.peek() !== "(") return;
        ++this.p;
        const lhs = this.readValueOrThrow();
        this.p += 2;
        const rhs = this.readValueOrThrow();
        ++this.p;
        return new RangeToken(this.input, begin, this.p, lhs, rhs, this.file);
    }
    readValueOrThrow() {
        const value = this.readValue();
        this.assert(value, ()=>`unexpected token ${this.snapshot()}, value expected`);
        return value;
    }
    readQuoted() {
        this.skipBlank();
        const begin = this.p;
        if (!(this.peekType() & QUOTE)) return;
        ++this.p;
        let escaped = false;
        while(this.p < this.N){
            ++this.p;
            if (this.input[this.p - 1] === this.input[begin] && !escaped) break;
            if (escaped) escaped = false;
            else if (this.input[this.p - 1] === "\\") escaped = true;
        }
        return new QuotedToken(this.input, begin, this.p, this.file);
    }
    *readFileNameTemplate(options) {
        const { outputDelimiterLeft } = options;
        const htmlStopStrings = [
            ",",
            " ",
            outputDelimiterLeft
        ];
        const htmlStopStringSet = new Set(htmlStopStrings);
        // break on ',' and ' ', outputDelimiterLeft only stops HTML token
        while(this.p < this.N && !htmlStopStringSet.has(this.peek()))yield this.match(outputDelimiterLeft) ? this.readOutputToken(options) : this.readHTMLToken(htmlStopStrings);
    }
    match(word) {
        for(let i = 0; i < word.length; i++){
            if (word[i] !== this.input[this.p + i]) return false;
        }
        return true;
    }
    rmatch(pattern) {
        for(let i = 0; i < pattern.length; i++){
            if (pattern[pattern.length - 1 - i] !== this.input[this.p - 1 - i]) return false;
        }
        return true;
    }
    peekType(n = 0) {
        return this.p + n >= this.N ? 0 : TYPES[this.input.charCodeAt(this.p + n)];
    }
    peek(n = 0) {
        return this.p + n >= this.N ? "" : this.input[this.p + n];
    }
    skipBlank() {
        while(this.peekType() & BLANK)++this.p;
    }
}
class ParseStream {
    constructor(tokens, parseToken){
        this.handlers = {};
        this.stopRequested = false;
        this.tokens = tokens;
        this.parseToken = parseToken;
    }
    on(name, cb) {
        this.handlers[name] = cb;
        return this;
    }
    trigger(event, arg) {
        const h = this.handlers[event];
        return h ? (h.call(this, arg), true) : false;
    }
    start() {
        this.trigger("start");
        let token;
        while(!this.stopRequested && (token = this.tokens.shift())){
            if (this.trigger("token", token)) continue;
            if (isTagToken(token) && this.trigger(`tag:${token.name}`, token)) continue;
            const template = this.parseToken(token, this.tokens);
            this.trigger("template", template);
        }
        if (!this.stopRequested) this.trigger("end");
        return this;
    }
    stop() {
        this.stopRequested = true;
        return this;
    }
}
class TemplateImpl {
    constructor(token){
        this.token = token;
    }
}
class Tag extends TemplateImpl {
    constructor(token, remainTokens, liquid){
        super(token);
        this.name = token.name;
        this.liquid = liquid;
        this.tokenizer = token.tokenizer;
    }
}
/**
 * Key-Value Pairs Representing Tag Arguments
 * Example:
 *    For the markup `, foo:'bar', coo:2 reversed %}`,
 *    hash['foo'] === 'bar'
 *    hash['coo'] === 2
 *    hash['reversed'] === undefined
 */ class Hash {
    constructor(markup, jekyllStyle){
        this.hash = {};
        const tokenizer = new Tokenizer(markup, {});
        for (const hash of tokenizer.readHashes(jekyllStyle))this.hash[hash.name.content] = hash.value;
    }
    *render(ctx) {
        const hash = {};
        for (const key of Object.keys(this.hash))hash[key] = this.hash[key] === undefined ? true : yield evalToken(this.hash[key], ctx);
        return hash;
    }
}
function createTagClass(options) {
    return class extends Tag {
        constructor(token, tokens, liquid){
            super(token, tokens, liquid);
            if (isFunction(options.parse)) options.parse.call(this, token, tokens);
        }
        *render(ctx, emitter) {
            const hash = yield new Hash(this.token.args).render(ctx);
            return yield options.render.call(this, ctx, emitter, hash);
        }
    };
}
function isKeyValuePair(arr) {
    return isArray(arr);
}
class Filter {
    constructor(name, options, args, liquid){
        this.name = name;
        this.handler = isFunction(options) ? options : isFunction(options === null || options === void 0 ? void 0 : options.handler) ? options.handler : identify;
        this.raw = !isFunction(options) && !!(options === null || options === void 0 ? void 0 : options.raw);
        this.args = args;
        this.liquid = liquid;
    }
    *render(value, context) {
        const argv = [];
        for (const arg of this.args)if (isKeyValuePair(arg)) argv.push([
            arg[0],
            (yield evalToken(arg[1], context))
        ]);
        else argv.push((yield evalToken(arg, context)));
        return yield this.handler.apply({
            context,
            liquid: this.liquid
        }, [
            value,
            ...argv
        ]);
    }
}
class Value {
    /**
     * @param str the value to be valuated, eg.: "foobar" | truncate: 3
     */ constructor(input, liquid){
        this.filters = [];
        const token = typeof input === "string" ? new Tokenizer(input, liquid.options.operators).readFilteredValue() : input;
        this.initial = token.initial;
        this.filters = token.filters.map(({ name, args })=>new Filter(name, this.getFilter(liquid, name), args, liquid));
    }
    *value(ctx, lenient) {
        lenient = lenient || ctx.opts.lenientIf && this.filters.length > 0 && this.filters[0].name === "default";
        let val = yield this.initial.evaluate(ctx, lenient);
        for (const filter of this.filters)val = yield filter.render(val, ctx);
        return val;
    }
    getFilter(liquid, name) {
        const impl = liquid.filters[name];
        assert(impl || !liquid.options.strictFilters, ()=>`undefined filter: ${name}`);
        return impl;
    }
}
class Output extends TemplateImpl {
    constructor(token, liquid){
        var _a;
        super(token);
        const tokenizer = new Tokenizer(token.input, liquid.options.operators, token.file, token.contentRange);
        this.value = new Value(tokenizer.readFilteredValue(), liquid);
        const filters = this.value.filters;
        const outputEscape = liquid.options.outputEscape;
        if (!((_a = filters[filters.length - 1]) === null || _a === void 0 ? void 0 : _a.raw) && outputEscape) filters.push(new Filter(toString.call(outputEscape), outputEscape, [], liquid));
    }
    *render(ctx, emitter) {
        const val = yield this.value.value(ctx, false);
        emitter.write(val);
    }
}
class HTML extends TemplateImpl {
    constructor(token){
        super(token);
        this.str = token.getContent();
    }
    *render(ctx, emitter) {
        emitter.write(this.str);
    }
}
var LookupType;
(function(LookupType) {
    LookupType["Partials"] = "partials";
    LookupType["Layouts"] = "layouts";
    LookupType["Root"] = "root";
})(LookupType || (LookupType = {}));
class Loader {
    constructor(options){
        this.options = options;
        if (options.relativeReference) {
            const sep = options.fs.sep;
            assert(sep, "`fs.sep` is required for relative reference");
            const rRelativePath = new RegExp([
                "." + sep,
                ".." + sep,
                "./",
                "../"
            ].map((prefix)=>escapeRegex(prefix)).join("|"));
            this.shouldLoadRelative = (referencedFile)=>rRelativePath.test(referencedFile);
        } else this.shouldLoadRelative = (referencedFile)=>false;
        this.contains = this.options.fs.contains || (()=>true);
    }
    *lookup(file, type, sync, currentFile) {
        const { fs } = this.options;
        const dirs = this.options[type];
        for (const filepath of this.candidates(file, dirs, currentFile, type !== LookupType.Root)){
            if (sync ? fs.existsSync(filepath) : yield fs.exists(filepath)) return filepath;
        }
        throw this.lookupError(file, dirs);
    }
    *candidates(file, dirs, currentFile, enforceRoot) {
        const { fs, extname } = this.options;
        if (this.shouldLoadRelative(file) && currentFile) {
            const referenced = fs.resolve(this.dirname(currentFile), file, extname);
            for (const dir of dirs)if (!enforceRoot || this.contains(dir, referenced)) {
                // the relatively referenced file is within one of root dirs
                yield referenced;
                break;
            }
        }
        for (const dir of dirs){
            const referenced = fs.resolve(dir, file, extname);
            if (!enforceRoot || this.contains(dir, referenced)) yield referenced;
        }
        if (fs.fallback !== undefined) {
            const filepath = fs.fallback(file);
            if (filepath !== undefined) yield filepath;
        }
    }
    dirname(path) {
        const fs = this.options.fs;
        assert(fs.dirname, "`fs.dirname` is required for relative reference");
        return fs.dirname(path);
    }
    lookupError(file, roots) {
        const err = new Error("ENOENT");
        err.message = `ENOENT: Failed to lookup "${file}" in "${roots}"`;
        err.code = "ENOENT";
        return err;
    }
}
class Parser {
    constructor(liquid){
        this.liquid = liquid;
        this.cache = this.liquid.options.cache;
        this.fs = this.liquid.options.fs;
        this.parseFile = this.cache ? this._parseFileCached : this._parseFile;
        this.loader = new Loader(this.liquid.options);
    }
    parse(html, filepath) {
        const tokenizer = new Tokenizer(html, this.liquid.options.operators, filepath);
        const tokens = tokenizer.readTopLevelTokens(this.liquid.options);
        return this.parseTokens(tokens);
    }
    parseTokens(tokens) {
        let token;
        const templates = [];
        while(token = tokens.shift())templates.push(this.parseToken(token, tokens));
        return templates;
    }
    parseToken(token, remainTokens) {
        try {
            if (isTagToken(token)) {
                const TagClass = this.liquid.tags[token.name];
                assert(TagClass, `tag "${token.name}" not found`);
                return new TagClass(token, remainTokens, this.liquid);
            }
            if (isOutputToken(token)) return new Output(token, this.liquid);
            return new HTML(token);
        } catch (e) {
            if (LiquidError.is(e)) throw e;
            throw new ParseError(e, token);
        }
    }
    parseStream(tokens) {
        return new ParseStream(tokens, (token, tokens)=>this.parseToken(token, tokens));
    }
    *_parseFileCached(file, sync, type = LookupType.Root, currentFile) {
        const cache = this.cache;
        const key = this.loader.shouldLoadRelative(file) ? currentFile + "," + file : type + ":" + file;
        const tpls = yield cache.read(key);
        if (tpls) return tpls;
        const task = this._parseFile(file, sync, type, currentFile);
        // sync mode: exec the task and cache the result
        // async mode: cache the task before exec
        const taskOrTpl = sync ? yield task : toPromise(task);
        cache.write(key, taskOrTpl);
        // note: concurrent tasks will be reused, cache for failed task is removed until its end
        try {
            return yield taskOrTpl;
        } catch (err) {
            cache.remove(key);
            throw err;
        }
    }
    *_parseFile(file, sync, type = LookupType.Root, currentFile) {
        const filepath = yield this.loader.lookup(file, type, sync, currentFile);
        return this.liquid.parse(sync ? this.fs.readFileSync(filepath) : yield this.fs.readFile(filepath), filepath);
    }
}
var TokenKind;
(function(TokenKind) {
    TokenKind[TokenKind["Number"] = 1] = "Number";
    TokenKind[TokenKind["Literal"] = 2] = "Literal";
    TokenKind[TokenKind["Tag"] = 4] = "Tag";
    TokenKind[TokenKind["Output"] = 8] = "Output";
    TokenKind[TokenKind["HTML"] = 16] = "HTML";
    TokenKind[TokenKind["Filter"] = 32] = "Filter";
    TokenKind[TokenKind["Hash"] = 64] = "Hash";
    TokenKind[TokenKind["PropertyAccess"] = 128] = "PropertyAccess";
    TokenKind[TokenKind["Word"] = 256] = "Word";
    TokenKind[TokenKind["Range"] = 512] = "Range";
    TokenKind[TokenKind["Quoted"] = 1024] = "Quoted";
    TokenKind[TokenKind["Operator"] = 2048] = "Operator";
    TokenKind[TokenKind["FilteredValue"] = 4096] = "FilteredValue";
    TokenKind[TokenKind["Delimited"] = 12] = "Delimited";
})(TokenKind || (TokenKind = {}));
function isDelimitedToken(val) {
    return !!(getKind(val) & TokenKind.Delimited);
}
function isOperatorToken(val) {
    return getKind(val) === TokenKind.Operator;
}
function isHTMLToken(val) {
    return getKind(val) === TokenKind.HTML;
}
function isOutputToken(val) {
    return getKind(val) === TokenKind.Output;
}
function isTagToken(val) {
    return getKind(val) === TokenKind.Tag;
}
function isQuotedToken(val) {
    return getKind(val) === TokenKind.Quoted;
}
function isLiteralToken(val) {
    return getKind(val) === TokenKind.Literal;
}
function isNumberToken(val) {
    return getKind(val) === TokenKind.Number;
}
function isPropertyAccessToken(val) {
    return getKind(val) === TokenKind.PropertyAccess;
}
function isWordToken(val) {
    return getKind(val) === TokenKind.Word;
}
function isRangeToken(val) {
    return getKind(val) === TokenKind.Range;
}
function getKind(val) {
    return val ? val.kind : -1;
}
var typeGuards = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    isDelimitedToken: isDelimitedToken,
    isOperatorToken: isOperatorToken,
    isHTMLToken: isHTMLToken,
    isOutputToken: isOutputToken,
    isTagToken: isTagToken,
    isQuotedToken: isQuotedToken,
    isLiteralToken: isLiteralToken,
    isNumberToken: isNumberToken,
    isPropertyAccessToken: isPropertyAccessToken,
    isWordToken: isWordToken,
    isRangeToken: isRangeToken
});
class Context {
    constructor(env = {}, opts = defaultOptions, renderOptions = {}){
        var _a, _b, _c;
        /**
         * insert a Context-level empty scope,
         * for tags like `{% capture %}` `{% assign %}` to operate
         */ this.scopes = [
            {}
        ];
        this.registers = {};
        this.sync = !!renderOptions.sync;
        this.opts = opts;
        this.globals = (_a = renderOptions.globals) !== null && _a !== void 0 ? _a : opts.globals;
        this.environments = isObject(env) ? env : Object(env);
        this.strictVariables = (_b = renderOptions.strictVariables) !== null && _b !== void 0 ? _b : this.opts.strictVariables;
        this.ownPropertyOnly = (_c = renderOptions.ownPropertyOnly) !== null && _c !== void 0 ? _c : opts.ownPropertyOnly;
    }
    getRegister(key) {
        return this.registers[key] = this.registers[key] || {};
    }
    setRegister(key, value) {
        return this.registers[key] = value;
    }
    saveRegister(...keys) {
        return keys.map((key)=>[
                key,
                this.getRegister(key)
            ]);
    }
    restoreRegister(keyValues) {
        return keyValues.forEach(([key, value])=>this.setRegister(key, value));
    }
    getAll() {
        return [
            this.globals,
            this.environments,
            ...this.scopes
        ].reduce((ctx, val)=>__assign(ctx, val), {});
    }
    /**
     * @deprecated use `_get()` or `getSync()` instead
     */ get(paths) {
        return this.getSync(paths);
    }
    getSync(paths) {
        return toValueSync(this._get(paths));
    }
    *_get(paths) {
        const scope = this.findScope(paths[0]);
        return yield this._getFromScope(scope, paths);
    }
    /**
     * @deprecated use `_get()` instead
     */ getFromScope(scope, paths) {
        return toValueSync(this._getFromScope(scope, paths));
    }
    *_getFromScope(scope, paths, strictVariables = this.strictVariables) {
        if (isString(paths)) paths = paths.split(".");
        for(let i = 0; i < paths.length; i++){
            scope = yield readProperty(scope, paths[i], this.ownPropertyOnly);
            if (strictVariables && isUndefined(scope)) throw new InternalUndefinedVariableError(paths.slice(0, i + 1).join("."));
        }
        return scope;
    }
    push(ctx) {
        return this.scopes.push(ctx);
    }
    pop() {
        return this.scopes.pop();
    }
    bottom() {
        return this.scopes[0];
    }
    findScope(key) {
        for(let i = this.scopes.length - 1; i >= 0; i--){
            const candidate = this.scopes[i];
            if (key in candidate) return candidate;
        }
        if (key in this.environments) return this.environments;
        return this.globals;
    }
}
function readProperty(obj, key, ownPropertyOnly) {
    obj = toLiquid(obj);
    if (isNil(obj)) return obj;
    if (isArray(obj) && key < 0) return obj[obj.length + +key];
    const value = readJSProperty(obj, key, ownPropertyOnly);
    if (value === undefined && obj instanceof Drop) return obj.liquidMethodMissing(key);
    if (isFunction(value)) return value.call(obj);
    if (key === "size") return readSize(obj);
    else if (key === "first") return readFirst(obj);
    else if (key === "last") return readLast(obj);
    return value;
}
function readJSProperty(obj, key, ownPropertyOnly) {
    if (ownPropertyOnly && !Object.hasOwnProperty.call(obj, key) && !(obj instanceof Drop)) return undefined;
    return obj[key];
}
function readFirst(obj) {
    if (isArray(obj)) return obj[0];
    return obj["first"];
}
function readLast(obj) {
    if (isArray(obj)) return obj[obj.length - 1];
    return obj["last"];
}
function readSize(obj) {
    if (obj.hasOwnProperty("size") || obj["size"] !== undefined) return obj["size"];
    if (isArray(obj) || isString(obj)) return obj.length;
    if (typeof obj === "object") return Object.keys(obj).length;
}
var BlockMode;
(function(BlockMode) {
    /* store rendered html into blocks */ BlockMode[BlockMode["OUTPUT"] = 0] = "OUTPUT";
    /* output rendered html directly */ BlockMode[BlockMode["STORE"] = 1] = "STORE";
})(BlockMode || (BlockMode = {}));
const abs = argumentsToValue(Math.abs);
const at_least = argumentsToValue(Math.max);
const at_most = argumentsToValue(Math.min);
const ceil = argumentsToValue(Math.ceil);
const divided_by = argumentsToValue((dividend, divisor, integerArithmetic = false)=>integerArithmetic ? Math.floor(dividend / divisor) : dividend / divisor);
const floor = argumentsToValue(Math.floor);
const minus = argumentsToValue((v, arg)=>v - arg);
const modulo = argumentsToValue((v, arg)=>v % arg);
const times = argumentsToValue((v, arg)=>v * arg);
function round(v, arg = 0) {
    v = toValue(v);
    arg = toValue(arg);
    const amp = Math.pow(10, arg);
    return Math.round(v * amp) / amp;
}
function plus(v, arg) {
    v = toValue(v);
    arg = toValue(arg);
    return Number(v) + Number(arg);
}
var mathFilters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    abs: abs,
    at_least: at_least,
    at_most: at_most,
    ceil: ceil,
    divided_by: divided_by,
    floor: floor,
    minus: minus,
    modulo: modulo,
    times: times,
    round: round,
    plus: plus
});
const url_decode = (x)=>decodeURIComponent(stringify(x)).replace(/\+/g, " ");
const url_encode = (x)=>encodeURIComponent(stringify(x)).replace(/%20/g, "+");
const cgi_escape = (x)=>encodeURIComponent(stringify(x)).replace(/%20/g, "+").replace(/[!'()*]/g, (c)=>"%" + c.charCodeAt(0).toString(16).toUpperCase());
const uri_escape = (x)=>encodeURI(stringify(x)).replace(/%5B/g, "[").replace(/%5D/g, "]");
const rSlugifyDefault = /[^\p{M}\p{L}\p{Nd}]+/ug;
const rSlugifyReplacers = {
    "raw": /\s+/g,
    "default": rSlugifyDefault,
    "pretty": /[^\p{M}\p{L}\p{Nd}._~!$&'()+,;=@]+/ug,
    "ascii": /[^A-Za-z0-9]+/g,
    "latin": rSlugifyDefault,
    "none": null
};
function slugify(str, mode = "default", cased = false) {
    str = stringify(str);
    const replacer = rSlugifyReplacers[mode];
    if (replacer) {
        if (mode === "latin") str = removeAccents(str);
        str = str.replace(replacer, "-").replace(/^-|-$/g, "");
    }
    return cased ? str : str.toLowerCase();
}
function removeAccents(str) {
    return str.replace(/[àáâãäå]/g, "a").replace(/[æ]/g, "ae").replace(/[ç]/g, "c").replace(/[èéêë]/g, "e").replace(/[ìíîï]/g, "i").replace(/[ð]/g, "d").replace(/[ñ]/g, "n").replace(/[òóôõöø]/g, "o").replace(/[ùúûü]/g, "u").replace(/[ýÿ]/g, "y").replace(/[ß]/g, "ss").replace(/[œ]/g, "oe").replace(/[þ]/g, "th").replace(/[ẞ]/g, "SS").replace(/[Œ]/g, "OE").replace(/[Þ]/g, "TH");
}
var urlFilters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    url_decode: url_decode,
    url_encode: url_encode,
    cgi_escape: cgi_escape,
    uri_escape: uri_escape,
    slugify: slugify
});
const join = argumentsToValue((v, arg)=>toArray(v).join(arg === undefined ? " " : arg));
const last$1 = argumentsToValue((v)=>isArray(v) ? last(v) : "");
const first = argumentsToValue((v)=>isArray(v) ? v[0] : "");
const reverse = argumentsToValue((v)=>[
        ...toArray(v)
    ].reverse());
function* sort(arr, property) {
    const values = [];
    for (const item of toArray(arr))values.push([
        item,
        property ? yield this.context._getFromScope(item, stringify(property).split("."), false) : item
    ]);
    return values.sort((lhs, rhs)=>{
        const lvalue = lhs[1];
        const rvalue = rhs[1];
        return lvalue < rvalue ? -1 : lvalue > rvalue ? 1 : 0;
    }).map((tuple)=>tuple[0]);
}
function sort_natural(input, property) {
    const propertyString = stringify(property);
    const compare = property === undefined ? caseInsensitiveCompare : (lhs, rhs)=>caseInsensitiveCompare(lhs[propertyString], rhs[propertyString]);
    return [
        ...toArray(input)
    ].sort(compare);
}
const size = (v)=>v && v.length || 0;
function* map(arr, property) {
    const results = [];
    for (const item of toArray(arr))results.push((yield this.context._getFromScope(item, stringify(property), false)));
    return results;
}
function* sum(arr, property) {
    let sum = 0;
    for (const item of toArray(arr)){
        const data = Number(property ? yield this.context._getFromScope(item, stringify(property), false) : item);
        sum += Number.isNaN(data) ? 0 : data;
    }
    return sum;
}
function compact(arr) {
    return toArray(arr).filter((x)=>!isNil(toValue(x)));
}
function concat(v, arg = []) {
    return toArray(v).concat(toArray(arg));
}
function push(v, arg) {
    return concat(v, [
        arg
    ]);
}
function unshift(v, arg) {
    const clone = [
        ...toArray(v)
    ];
    clone.unshift(arg);
    return clone;
}
function pop(v) {
    const clone = [
        ...toArray(v)
    ];
    clone.pop();
    return clone;
}
function shift(v) {
    const clone = [
        ...toArray(v)
    ];
    clone.shift();
    return clone;
}
function slice(v, begin, length = 1) {
    v = toValue(v);
    if (isNil(v)) return [];
    if (!isArray(v)) v = stringify(v);
    begin = begin < 0 ? v.length + begin : begin;
    return v.slice(begin, begin + length);
}
function* where(arr, property, expected) {
    const values = [];
    arr = toArray(arr);
    const token = new Tokenizer(stringify(property)).readScopeValue();
    for (const item of arr)values.push((yield evalToken(token, new Context(item))));
    return arr.filter((_, i)=>{
        if (expected === undefined) return isTruthy(values[i], this.context);
        return equals(values[i], expected);
    });
}
function* where_exp(arr, itemName, exp) {
    const filtered = [];
    const keyTemplate = new Value(stringify(exp), this.liquid);
    for (const item of toArray(arr)){
        const value = yield keyTemplate.value(new Context({
            [itemName]: item
        }));
        if (value) filtered.push(item);
    }
    return filtered;
}
function* group_by(arr, property) {
    const map = new Map();
    arr = toArray(arr);
    const token = new Tokenizer(stringify(property)).readScopeValue();
    for (const item of arr){
        const key = yield evalToken(token, new Context(item));
        if (!map.has(key)) map.set(key, []);
        map.get(key).push(item);
    }
    return [
        ...map.entries()
    ].map(([name, items])=>({
            name,
            items
        }));
}
function* group_by_exp(arr, itemName, exp) {
    const map = new Map();
    const keyTemplate = new Value(stringify(exp), this.liquid);
    for (const item of toArray(arr)){
        const key = yield keyTemplate.value(new Context({
            [itemName]: item
        }));
        if (!map.has(key)) map.set(key, []);
        map.get(key).push(item);
    }
    return [
        ...map.entries()
    ].map(([name, items])=>({
            name,
            items
        }));
}
function* find(arr, property, expected) {
    const token = new Tokenizer(stringify(property)).readScopeValue();
    for (const item of toArray(arr)){
        const value = yield evalToken(token, new Context(item));
        if (equals(value, expected)) return item;
    }
    return null;
}
function* find_exp(arr, itemName, exp) {
    const predicate = new Value(stringify(exp), this.liquid);
    for (const item of toArray(arr)){
        const value = yield predicate.value(new Context({
            [itemName]: item
        }));
        if (value) return item;
    }
    return null;
}
function uniq(arr) {
    arr = toValue(arr);
    const u = {};
    return (arr || []).filter((val)=>{
        if (hasOwnProperty.call(u, String(val))) return false;
        u[String(val)] = true;
        return true;
    });
}
function sample(v, count = 1) {
    v = toValue(v);
    if (isNil(v)) return [];
    if (!isArray(v)) v = stringify(v);
    const shuffled = [
        ...v
    ].sort(()=>Math.random() - 0.5);
    if (count === 1) return shuffled[0];
    return shuffled.slice(0, count);
}
var arrayFilters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    join: join,
    last: last$1,
    first: first,
    reverse: reverse,
    sort: sort,
    sort_natural: sort_natural,
    size: size,
    map: map,
    sum: sum,
    compact: compact,
    concat: concat,
    push: push,
    unshift: unshift,
    pop: pop,
    shift: shift,
    slice: slice,
    where: where,
    where_exp: where_exp,
    group_by: group_by,
    group_by_exp: group_by_exp,
    find: find,
    find_exp: find_exp,
    uniq: uniq,
    sample: sample
});
function date(v, format, timezoneOffset) {
    const date = parseDate(v, this.context.opts, timezoneOffset);
    if (!date) return v;
    format = toValue(format);
    format = isNil(format) ? this.context.opts.dateFormat : stringify(format);
    return strftime(date, format);
}
function date_to_xmlschema(v) {
    return date.call(this, v, "%Y-%m-%dT%H:%M:%S%:z");
}
function date_to_rfc822(v) {
    return date.call(this, v, "%a, %d %b %Y %H:%M:%S %z");
}
function date_to_string(v, type, style) {
    return stringify_date.call(this, v, "%b", type, style);
}
function date_to_long_string(v, type, style) {
    return stringify_date.call(this, v, "%B", type, style);
}
function stringify_date(v, month_type, type, style) {
    const date = parseDate(v, this.context.opts);
    if (!date) return v;
    if (type === "ordinal") {
        const d = date.getDate();
        return style === "US" ? strftime(date, `${month_type} ${d}%q, %Y`) : strftime(date, `${d}%q ${month_type} %Y`);
    }
    return strftime(date, `%d ${month_type} %Y`);
}
function parseDate(v, opts, timezoneOffset) {
    let date;
    v = toValue(v);
    if (v === "now" || v === "today") date = new Date();
    else if (isNumber(v)) date = new Date(v * 1000);
    else if (isString(v)) {
        if (/^\d+$/.test(v)) date = new Date(+v * 1000);
        else if (opts.preserveTimezones) date = TimezoneDate.createDateFixedToTimezone(v);
        else date = new Date(v);
    } else date = v;
    if (!isValidDate(date)) return;
    if (timezoneOffset !== undefined) date = new TimezoneDate(date, timezoneOffset);
    else if (!(date instanceof TimezoneDate) && opts.timezoneOffset !== undefined) date = new TimezoneDate(date, opts.timezoneOffset);
    return date;
}
function isValidDate(date) {
    return (date instanceof Date || date instanceof TimezoneDate) && !isNaN(date.getTime());
}
var dateFilters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    date: date,
    date_to_xmlschema: date_to_xmlschema,
    date_to_rfc822: date_to_rfc822,
    date_to_string: date_to_string,
    date_to_long_string: date_to_long_string
});
/**
 * String related filters
 *
 * * prefer stringify() to String() since `undefined`, `null` should eval ''
 */ const rCJKWord = /[\u4E00-\u9FFF\uF900-\uFAFF\u3400-\u4DBF\u3040-\u309F\u30A0-\u30FF\uAC00-\uD7AF]/gu;
// Word boundary followed by word characters (for detecting words)
const rNonCJKWord = /[^\u4E00-\u9FFF\uF900-\uFAFF\u3400-\u4DBF\u3040-\u309F\u30A0-\u30FF\uAC00-\uD7AF\s]+/gu;
function append(v, arg) {
    assert(arguments.length === 2, "append expect 2 arguments");
    return stringify(v) + stringify(arg);
}
function prepend(v, arg) {
    assert(arguments.length === 2, "prepend expect 2 arguments");
    return stringify(arg) + stringify(v);
}
function lstrip(v, chars) {
    if (chars) {
        chars = escapeRegExp(stringify(chars));
        return stringify(v).replace(new RegExp(`^[${chars}]+`, "g"), "");
    }
    return stringify(v).replace(/^\s+/, "");
}
function downcase(v) {
    return stringify(v).toLowerCase();
}
function upcase(str) {
    return stringify(str).toUpperCase();
}
function remove(v, arg) {
    return stringify(v).split(stringify(arg)).join("");
}
function remove_first(v, l) {
    return stringify(v).replace(stringify(l), "");
}
function remove_last(v, l) {
    const str = stringify(v);
    const pattern = stringify(l);
    const index = str.lastIndexOf(pattern);
    if (index === -1) return str;
    return str.substring(0, index) + str.substring(index + pattern.length);
}
function rstrip(str, chars) {
    if (chars) {
        chars = escapeRegExp(stringify(chars));
        return stringify(str).replace(new RegExp(`[${chars}]+$`, "g"), "");
    }
    return stringify(str).replace(/\s+$/, "");
}
function split(v, arg) {
    const arr = stringify(v).split(stringify(arg));
    // align to ruby split, which is the behavior of shopify/liquid
    // see: https://ruby-doc.org/core-2.4.0/String.html#method-i-split
    while(arr.length && arr[arr.length - 1] === "")arr.pop();
    return arr;
}
function strip(v, chars) {
    if (chars) {
        chars = escapeRegExp(stringify(chars));
        return stringify(v).replace(new RegExp(`^[${chars}]+`, "g"), "").replace(new RegExp(`[${chars}]+$`, "g"), "");
    }
    return stringify(v).trim();
}
function strip_newlines(v) {
    return stringify(v).replace(/\r?\n/gm, "");
}
function capitalize(str) {
    str = stringify(str);
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
function replace(v, pattern, replacement) {
    return stringify(v).split(stringify(pattern)).join(replacement);
}
function replace_first(v, arg1, arg2) {
    return stringify(v).replace(stringify(arg1), arg2);
}
function replace_last(v, arg1, arg2) {
    const str = stringify(v);
    const pattern = stringify(arg1);
    const index = str.lastIndexOf(pattern);
    if (index === -1) return str;
    const replacement = stringify(arg2);
    return str.substring(0, index) + replacement + str.substring(index + pattern.length);
}
function truncate(v, l = 50, o = "...") {
    v = stringify(v);
    if (v.length <= l) return v;
    return v.substring(0, l - o.length) + o;
}
function truncatewords(v, words = 15, o = "...") {
    const arr = stringify(v).split(/\s+/);
    if (words <= 0) words = 1;
    let ret = arr.slice(0, words).join(" ");
    if (arr.length >= words) ret += o;
    return ret;
}
function normalize_whitespace(v) {
    v = stringify(v);
    return v.replace(/\s+/g, " ");
}
function number_of_words(input, mode) {
    input = stringify(input).trim();
    if (!input) return 0;
    switch(mode){
        case "cjk":
            // Count CJK characters and words
            return (input.match(rCJKWord) || []).length + (input.match(rNonCJKWord) || []).length;
        case "auto":
            // Count CJK characters, if none, count words
            return rCJKWord.test(input) ? input.match(rCJKWord).length + (input.match(rNonCJKWord) || []).length : input.split(/\s+/).length;
        default:
            // Count words only
            return input.split(/\s+/).length;
    }
}
function array_to_sentence_string(array, connector = "and") {
    switch(array.length){
        case 0:
            return "";
        case 1:
            return array[0];
        case 2:
            return `${array[0]} ${connector} ${array[1]}`;
        default:
            return `${array.slice(0, -1).join(", ")}, ${connector} ${array[array.length - 1]}`;
    }
}
var stringFilters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    append: append,
    prepend: prepend,
    lstrip: lstrip,
    downcase: downcase,
    upcase: upcase,
    remove: remove,
    remove_first: remove_first,
    remove_last: remove_last,
    rstrip: rstrip,
    split: split,
    strip: strip,
    strip_newlines: strip_newlines,
    capitalize: capitalize,
    replace: replace,
    replace_first: replace_first,
    replace_last: replace_last,
    truncate: truncate,
    truncatewords: truncatewords,
    normalize_whitespace: normalize_whitespace,
    number_of_words: number_of_words,
    array_to_sentence_string: array_to_sentence_string
});
const filters = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, htmlFilters), mathFilters), urlFilters), arrayFilters), dateFilters), stringFilters), misc);
class AssignTag extends Tag {
    constructor(token, remainTokens, liquid){
        super(token, remainTokens, liquid);
        this.key = this.tokenizer.readIdentifier().content;
        this.tokenizer.assert(this.key, "expected variable name");
        this.tokenizer.skipBlank();
        this.tokenizer.assert(this.tokenizer.peek() === "=", 'expected "="');
        this.tokenizer.advance();
        this.value = new Value(this.tokenizer.readFilteredValue(), this.liquid);
    }
    *render(ctx) {
        ctx.bottom()[this.key] = yield this.value.value(ctx, this.liquid.options.lenientIf);
    }
}
const MODIFIERS = [
    "offset",
    "limit",
    "reversed"
];
class ForTag extends Tag {
    constructor(token, remainTokens, liquid){
        super(token, remainTokens, liquid);
        const variable = this.tokenizer.readIdentifier();
        const inStr = this.tokenizer.readIdentifier();
        const collection = this.tokenizer.readValue();
        if (!variable.size() || inStr.content !== "in" || !collection) throw new Error(`illegal tag: ${token.getText()}`);
        this.variable = variable.content;
        this.collection = collection;
        this.hash = new Hash(this.tokenizer.remaining());
        this.templates = [];
        this.elseTemplates = [];
        let p;
        const stream = this.liquid.parser.parseStream(remainTokens).on("start", ()=>p = this.templates).on("tag:else", ()=>p = this.elseTemplates).on("tag:endfor", ()=>stream.stop()).on("template", (tpl)=>p.push(tpl)).on("end", ()=>{
            throw new Error(`tag ${token.getText()} not closed`);
        });
        stream.start();
    }
    *render(ctx, emitter) {
        const r = this.liquid.renderer;
        let collection = toEnumerable((yield evalToken(this.collection, ctx)));
        if (!collection.length) {
            yield r.renderTemplates(this.elseTemplates, ctx, emitter);
            return;
        }
        const continueKey = "continue-" + this.variable + "-" + this.collection.getText();
        ctx.push({
            continue: ctx.getRegister(continueKey)
        });
        const hash = yield this.hash.render(ctx);
        ctx.pop();
        const modifiers = this.liquid.options.orderedFilterParameters ? Object.keys(hash).filter((x)=>MODIFIERS.includes(x)) : MODIFIERS.filter((x)=>hash[x] !== undefined);
        collection = modifiers.reduce((collection, modifier)=>{
            if (modifier === "offset") return offset(collection, hash["offset"]);
            if (modifier === "limit") return limit(collection, hash["limit"]);
            return reversed(collection);
        }, collection);
        ctx.setRegister(continueKey, (hash["offset"] || 0) + collection.length);
        const scope = {
            forloop: new ForloopDrop(collection.length, this.collection.getText(), this.variable)
        };
        ctx.push(scope);
        for (const item of collection){
            scope[this.variable] = item;
            yield r.renderTemplates(this.templates, ctx, emitter);
            if (emitter["break"]) {
                emitter["break"] = false;
                break;
            }
            emitter["continue"] = false;
            scope.forloop.next();
        }
        ctx.pop();
    }
}
function reversed(arr) {
    return [
        ...arr
    ].reverse();
}
function offset(arr, count) {
    return arr.slice(count);
}
function limit(arr, count) {
    return arr.slice(0, count);
}
class CaptureTag extends Tag {
    constructor(tagToken, remainTokens, liquid){
        super(tagToken, remainTokens, liquid);
        this.templates = [];
        this.variable = this.readVariableName();
        while(remainTokens.length){
            const token = remainTokens.shift();
            if (isTagToken(token) && token.name === "endcapture") return;
            this.templates.push(liquid.parser.parseToken(token, remainTokens));
        }
        throw new Error(`tag ${tagToken.getText()} not closed`);
    }
    *render(ctx) {
        const r = this.liquid.renderer;
        const html = yield r.renderTemplates(this.templates, ctx);
        ctx.bottom()[this.variable] = html;
    }
    readVariableName() {
        const word = this.tokenizer.readIdentifier().content;
        if (word) return word;
        const quoted = this.tokenizer.readQuoted();
        if (quoted) return evalQuotedToken(quoted);
        throw this.tokenizer.error("invalid capture name");
    }
}
class CaseTag extends Tag {
    constructor(tagToken, remainTokens, liquid){
        super(tagToken, remainTokens, liquid);
        this.branches = [];
        this.elseTemplates = [];
        this.value = new Value(this.tokenizer.readFilteredValue(), this.liquid);
        this.elseTemplates = [];
        let p = [];
        let elseCount = 0;
        const stream = this.liquid.parser.parseStream(remainTokens).on("tag:when", (token)=>{
            if (elseCount > 0) return;
            p = [];
            const values = [];
            while(!token.tokenizer.end()){
                values.push(token.tokenizer.readValueOrThrow());
                token.tokenizer.skipBlank();
                if (token.tokenizer.peek() === ",") token.tokenizer.readTo(",");
                else token.tokenizer.readTo("or");
            }
            this.branches.push({
                values,
                templates: p
            });
        }).on("tag:else", ()=>{
            elseCount++;
            p = this.elseTemplates;
        }).on("tag:endcase", ()=>stream.stop()).on("template", (tpl)=>{
            if (p !== this.elseTemplates || elseCount === 1) p.push(tpl);
        }).on("end", ()=>{
            throw new Error(`tag ${tagToken.getText()} not closed`);
        });
        stream.start();
    }
    *render(ctx, emitter) {
        const r = this.liquid.renderer;
        const target = toValue((yield this.value.value(ctx, ctx.opts.lenientIf)));
        let branchHit = false;
        for (const branch of this.branches)for (const valueToken of branch.values){
            const value = yield evalToken(valueToken, ctx, ctx.opts.lenientIf);
            if (equals(target, value)) {
                yield r.renderTemplates(branch.templates, ctx, emitter);
                branchHit = true;
                break;
            }
        }
        if (!branchHit) yield r.renderTemplates(this.elseTemplates, ctx, emitter);
    }
}
class CommentTag extends Tag {
    constructor(tagToken, remainTokens, liquid){
        super(tagToken, remainTokens, liquid);
        while(remainTokens.length){
            const token = remainTokens.shift();
            if (isTagToken(token) && token.name === "endcomment") return;
        }
        throw new Error(`tag ${tagToken.getText()} not closed`);
    }
    render() {}
}
class RenderTag extends Tag {
    constructor(token, remainTokens, liquid){
        super(token, remainTokens, liquid);
        const tokenizer = this.tokenizer;
        this.file = parseFilePath(tokenizer, this.liquid);
        this.currentFile = token.file;
        while(!tokenizer.end()){
            tokenizer.skipBlank();
            const begin = tokenizer.p;
            const keyword = tokenizer.readIdentifier();
            if (keyword.content === "with" || keyword.content === "for") {
                tokenizer.skipBlank();
                // can be normal key/value pair, like "with: true"
                if (tokenizer.peek() !== ":") {
                    const value = tokenizer.readValue();
                    // can be normal key, like "with,"
                    if (value) {
                        const beforeAs = tokenizer.p;
                        const asStr = tokenizer.readIdentifier();
                        let alias;
                        if (asStr.content === "as") alias = tokenizer.readIdentifier();
                        else tokenizer.p = beforeAs;
                        this[keyword.content] = {
                            value,
                            alias: alias && alias.content
                        };
                        tokenizer.skipBlank();
                        if (tokenizer.peek() === ",") tokenizer.advance();
                        continue; // matched!
                    }
                }
            }
            /**
             * restore cursor if with/for not matched
             */ tokenizer.p = begin;
            break;
        }
        this.hash = new Hash(tokenizer.remaining());
    }
    *render(ctx, emitter) {
        const { liquid, hash } = this;
        const filepath = yield renderFilePath(this["file"], ctx, liquid);
        assert(filepath, ()=>`illegal file path "${filepath}"`);
        const childCtx = new Context({}, ctx.opts, {
            sync: ctx.sync,
            globals: ctx.globals,
            strictVariables: ctx.strictVariables
        });
        const scope = childCtx.bottom();
        __assign(scope, (yield hash.render(ctx)));
        if (this["with"]) {
            const { value, alias } = this["with"];
            scope[alias || filepath] = yield evalToken(value, ctx);
        }
        if (this["for"]) {
            const { value, alias } = this["for"];
            const collection = toEnumerable((yield evalToken(value, ctx)));
            scope["forloop"] = new ForloopDrop(collection.length, value.getText(), alias);
            for (const item of collection){
                scope[alias] = item;
                const templates = yield liquid._parsePartialFile(filepath, childCtx.sync, this["currentFile"]);
                yield liquid.renderer.renderTemplates(templates, childCtx, emitter);
                scope["forloop"].next();
            }
        } else {
            const templates = yield liquid._parsePartialFile(filepath, childCtx.sync, this["currentFile"]);
            yield liquid.renderer.renderTemplates(templates, childCtx, emitter);
        }
    }
}
/**
 * @return null for "none",
 * @return Template[] for quoted with tags and/or filters
 * @return Token for expression (not quoted)
 * @throws TypeError if cannot read next token
 */ function parseFilePath(tokenizer, liquid) {
    if (liquid.options.dynamicPartials) {
        const file = tokenizer.readValue();
        tokenizer.assert(file, "illegal file path");
        if (file.getText() === "none") return;
        if (isQuotedToken(file)) {
            // for filenames like "files/{{file}}", eval as liquid template
            const templates = liquid.parse(evalQuotedToken(file));
            return optimize(templates);
        }
        return file;
    }
    const tokens = [
        ...tokenizer.readFileNameTemplate(liquid.options)
    ];
    const templates = optimize(liquid.parser.parseTokens(tokens));
    return templates === "none" ? undefined : templates;
}
function optimize(templates) {
    // for filenames like "files/file.liquid", extract the string directly
    if (templates.length === 1 && isHTMLToken(templates[0].token)) return templates[0].token.getContent();
    return templates;
}
function* renderFilePath(file, ctx, liquid) {
    if (typeof file === "string") return file;
    if (Array.isArray(file)) return liquid.renderer.renderTemplates(file, ctx);
    return yield evalToken(file, ctx);
}
class IncludeTag extends Tag {
    constructor(token, remainTokens, liquid){
        super(token, remainTokens, liquid);
        const { tokenizer } = token;
        this["file"] = parseFilePath(tokenizer, this.liquid);
        this["currentFile"] = token.file;
        const begin = tokenizer.p;
        const withStr = tokenizer.readIdentifier();
        if (withStr.content === "with") {
            tokenizer.skipBlank();
            if (tokenizer.peek() !== ":") this.withVar = tokenizer.readValue();
            else tokenizer.p = begin;
        } else tokenizer.p = begin;
        this.hash = new Hash(tokenizer.remaining(), this.liquid.options.jekyllInclude);
    }
    *render(ctx, emitter) {
        const { liquid, hash, withVar } = this;
        const { renderer } = liquid;
        const filepath = yield renderFilePath(this["file"], ctx, liquid);
        assert(filepath, ()=>`illegal file path "${filepath}"`);
        const saved = ctx.saveRegister("blocks", "blockMode");
        ctx.setRegister("blocks", {});
        ctx.setRegister("blockMode", BlockMode.OUTPUT);
        const scope = yield hash.render(ctx);
        if (withVar) scope[filepath] = yield evalToken(withVar, ctx);
        const templates = yield liquid._parsePartialFile(filepath, ctx.sync, this["currentFile"]);
        ctx.push(ctx.opts.jekyllInclude ? {
            include: scope
        } : scope);
        yield renderer.renderTemplates(templates, ctx, emitter);
        ctx.pop();
        ctx.restoreRegister(saved);
    }
}
class DecrementTag extends Tag {
    constructor(token, remainTokens, liquid){
        super(token, remainTokens, liquid);
        this.variable = this.tokenizer.readIdentifier().content;
    }
    render(context, emitter) {
        const scope = context.environments;
        if (!isNumber(scope[this.variable])) scope[this.variable] = 0;
        emitter.write(stringify(--scope[this.variable]));
    }
}
class CycleTag extends Tag {
    constructor(token, remainTokens, liquid){
        super(token, remainTokens, liquid);
        this.candidates = [];
        const group = this.tokenizer.readValue();
        this.tokenizer.skipBlank();
        if (group) {
            if (this.tokenizer.peek() === ":") {
                this.group = group;
                this.tokenizer.advance();
            } else this.candidates.push(group);
        }
        while(!this.tokenizer.end()){
            const value = this.tokenizer.readValue();
            if (value) this.candidates.push(value);
            this.tokenizer.readTo(",");
        }
        this.tokenizer.assert(this.candidates.length, ()=>`empty candidates: "${token.getText()}"`);
    }
    *render(ctx, emitter) {
        const group = yield evalToken(this.group, ctx);
        const fingerprint = `cycle:${group}:` + this.candidates.join(",");
        const groups = ctx.getRegister("cycle");
        let idx = groups[fingerprint];
        if (idx === undefined) idx = groups[fingerprint] = 0;
        const candidate = this.candidates[idx];
        idx = (idx + 1) % this.candidates.length;
        groups[fingerprint] = idx;
        return yield evalToken(candidate, ctx);
    }
}
class IfTag extends Tag {
    constructor(tagToken, remainTokens, liquid){
        super(tagToken, remainTokens, liquid);
        this.branches = [];
        this.elseTemplates = [];
        let p = [];
        let elseCount = 0;
        liquid.parser.parseStream(remainTokens).on("start", ()=>this.branches.push({
                value: new Value(tagToken.args, this.liquid),
                templates: p = []
            })).on("tag:elsif", (token)=>{
            if (elseCount > 0) {
                p = [];
                return;
            }
            this.branches.push({
                value: new Value(token.args, this.liquid),
                templates: p = []
            });
        }).on("tag:else", ()=>{
            elseCount++;
            p = this.elseTemplates;
        }).on("tag:endif", function() {
            this.stop();
        }).on("template", (tpl)=>{
            if (p !== this.elseTemplates || elseCount === 1) p.push(tpl);
        }).on("end", ()=>{
            throw new Error(`tag ${tagToken.getText()} not closed`);
        }).start();
    }
    *render(ctx, emitter) {
        const r = this.liquid.renderer;
        for (const { value, templates } of this.branches){
            const v = yield value.value(ctx, ctx.opts.lenientIf);
            if (isTruthy(v, ctx)) {
                yield r.renderTemplates(templates, ctx, emitter);
                return;
            }
        }
        yield r.renderTemplates(this.elseTemplates, ctx, emitter);
    }
}
class IncrementTag extends Tag {
    constructor(token, remainTokens, liquid){
        super(token, remainTokens, liquid);
        this.variable = this.tokenizer.readIdentifier().content;
    }
    render(context, emitter) {
        const scope = context.environments;
        if (!isNumber(scope[this.variable])) scope[this.variable] = 0;
        const val = scope[this.variable];
        scope[this.variable]++;
        emitter.write(stringify(val));
    }
}
class LayoutTag extends Tag {
    constructor(token, remainTokens, liquid){
        super(token, remainTokens, liquid);
        this.file = parseFilePath(this.tokenizer, this.liquid);
        this["currentFile"] = token.file;
        this.args = new Hash(this.tokenizer.remaining());
        this.templates = this.liquid.parser.parseTokens(remainTokens);
    }
    *render(ctx, emitter) {
        const { liquid, args, file } = this;
        const { renderer } = liquid;
        if (file === undefined) {
            ctx.setRegister("blockMode", BlockMode.OUTPUT);
            yield renderer.renderTemplates(this.templates, ctx, emitter);
            return;
        }
        const filepath = yield renderFilePath(this.file, ctx, liquid);
        assert(filepath, ()=>`illegal file path "${filepath}"`);
        const templates = yield liquid._parseLayoutFile(filepath, ctx.sync, this["currentFile"]);
        // render remaining contents and store rendered results
        ctx.setRegister("blockMode", BlockMode.STORE);
        const html = yield renderer.renderTemplates(this.templates, ctx);
        const blocks = ctx.getRegister("blocks");
        // set whole content to anonymous block if anonymous doesn't specified
        if (blocks[""] === undefined) blocks[""] = (parent, emitter)=>emitter.write(html);
        ctx.setRegister("blockMode", BlockMode.OUTPUT);
        // render the layout file use stored blocks
        ctx.push((yield args.render(ctx)));
        yield renderer.renderTemplates(templates, ctx, emitter);
        ctx.pop();
    }
}
class BlockTag extends Tag {
    constructor(token, remainTokens, liquid){
        super(token, remainTokens, liquid);
        this.templates = [];
        const match = /\w+/.exec(token.args);
        this.block = match ? match[0] : "";
        while(remainTokens.length){
            const token = remainTokens.shift();
            if (isTagToken(token) && token.name === "endblock") return;
            const template = liquid.parser.parseToken(token, remainTokens);
            this.templates.push(template);
        }
        throw new Error(`tag ${token.getText()} not closed`);
    }
    *render(ctx, emitter) {
        const blockRender = this.getBlockRender(ctx);
        if (ctx.getRegister("blockMode") === BlockMode.STORE) ctx.getRegister("blocks")[this.block] = blockRender;
        else yield blockRender(new BlockDrop(), emitter);
    }
    getBlockRender(ctx) {
        const { liquid, templates } = this;
        const renderChild = ctx.getRegister("blocks")[this.block];
        const renderCurrent = function*(superBlock, emitter) {
            // add {{ block.super }} support when rendering
            ctx.push({
                block: superBlock
            });
            yield liquid.renderer.renderTemplates(templates, ctx, emitter);
            ctx.pop();
        };
        return renderChild ? (superBlock, emitter)=>renderChild(new BlockDrop(()=>renderCurrent(superBlock, emitter)), emitter) : renderCurrent;
    }
}
class RawTag extends Tag {
    constructor(tagToken, remainTokens, liquid){
        super(tagToken, remainTokens, liquid);
        this.tokens = [];
        while(remainTokens.length){
            const token = remainTokens.shift();
            if (isTagToken(token) && token.name === "endraw") return;
            this.tokens.push(token);
        }
        throw new Error(`tag ${tagToken.getText()} not closed`);
    }
    render() {
        return this.tokens.map((token)=>token.getText()).join("");
    }
}
class TablerowloopDrop extends ForloopDrop {
    constructor(length, cols, collection, variable){
        super(length, collection, variable);
        this.length = length;
        this.cols = cols;
    }
    row() {
        return Math.floor(this.i / this.cols) + 1;
    }
    col0() {
        return this.i % this.cols;
    }
    col() {
        return this.col0() + 1;
    }
    col_first() {
        return this.col0() === 0;
    }
    col_last() {
        return this.col() === this.cols;
    }
}
class TablerowTag extends Tag {
    constructor(tagToken, remainTokens, liquid){
        super(tagToken, remainTokens, liquid);
        const variable = this.tokenizer.readIdentifier();
        this.tokenizer.skipBlank();
        const predicate = this.tokenizer.readIdentifier();
        const collectionToken = this.tokenizer.readValue();
        if (predicate.content !== "in" || !collectionToken) throw new Error(`illegal tag: ${tagToken.getText()}`);
        this.variable = variable.content;
        this.collection = collectionToken;
        this.args = new Hash(this.tokenizer.remaining());
        this.templates = [];
        let p;
        const stream = this.liquid.parser.parseStream(remainTokens).on("start", ()=>p = this.templates).on("tag:endtablerow", ()=>stream.stop()).on("template", (tpl)=>p.push(tpl)).on("end", ()=>{
            throw new Error(`tag ${tagToken.getText()} not closed`);
        });
        stream.start();
    }
    *render(ctx, emitter) {
        let collection = toEnumerable((yield evalToken(this.collection, ctx)));
        const args = yield this.args.render(ctx);
        const offset = args.offset || 0;
        const limit = args.limit === undefined ? collection.length : args.limit;
        collection = collection.slice(offset, offset + limit);
        const cols = args.cols || collection.length;
        const r = this.liquid.renderer;
        const tablerowloop = new TablerowloopDrop(collection.length, cols, this.collection.getText(), this.variable);
        const scope = {
            tablerowloop
        };
        ctx.push(scope);
        for(let idx = 0; idx < collection.length; idx++, tablerowloop.next()){
            scope[this.variable] = collection[idx];
            if (tablerowloop.col0() === 0) {
                if (tablerowloop.row() !== 1) emitter.write("</tr>");
                emitter.write(`<tr class="row${tablerowloop.row()}">`);
            }
            emitter.write(`<td class="col${tablerowloop.col()}">`);
            yield r.renderTemplates(this.templates, ctx, emitter);
            emitter.write("</td>");
        }
        if (collection.length) emitter.write("</tr>");
        ctx.pop();
    }
}
class UnlessTag extends Tag {
    constructor(tagToken, remainTokens, liquid){
        super(tagToken, remainTokens, liquid);
        this.branches = [];
        this.elseTemplates = [];
        let p = [];
        let elseCount = 0;
        this.liquid.parser.parseStream(remainTokens).on("start", ()=>this.branches.push({
                value: new Value(tagToken.args, this.liquid),
                test: isFalsy,
                templates: p = []
            })).on("tag:elsif", (token)=>{
            if (elseCount > 0) {
                p = [];
                return;
            }
            this.branches.push({
                value: new Value(token.args, this.liquid),
                test: isTruthy,
                templates: p = []
            });
        }).on("tag:else", ()=>{
            elseCount++;
            p = this.elseTemplates;
        }).on("tag:endunless", function() {
            this.stop();
        }).on("template", (tpl)=>{
            if (p !== this.elseTemplates || elseCount === 1) p.push(tpl);
        }).on("end", ()=>{
            throw new Error(`tag ${tagToken.getText()} not closed`);
        }).start();
    }
    *render(ctx, emitter) {
        const r = this.liquid.renderer;
        for (const { value, test, templates } of this.branches){
            const v = yield value.value(ctx, ctx.opts.lenientIf);
            if (test(v, ctx)) {
                yield r.renderTemplates(templates, ctx, emitter);
                return;
            }
        }
        yield r.renderTemplates(this.elseTemplates, ctx, emitter);
    }
}
class BreakTag extends Tag {
    render(ctx, emitter) {
        emitter["break"] = true;
    }
}
class ContinueTag extends Tag {
    render(ctx, emitter) {
        emitter["continue"] = true;
    }
}
class EchoTag extends Tag {
    constructor(token, remainTokens, liquid){
        super(token, remainTokens, liquid);
        this.tokenizer.skipBlank();
        if (!this.tokenizer.end()) this.value = new Value(this.tokenizer.readFilteredValue(), this.liquid);
    }
    *render(ctx, emitter) {
        if (!this.value) return;
        const val = yield this.value.value(ctx, false);
        emitter.write(val);
    }
}
class LiquidTag extends Tag {
    constructor(token, remainTokens, liquid){
        super(token, remainTokens, liquid);
        const tokens = this.tokenizer.readLiquidTagTokens(this.liquid.options);
        this.templates = this.liquid.parser.parseTokens(tokens);
    }
    *render(ctx, emitter) {
        yield this.liquid.renderer.renderTemplates(this.templates, ctx, emitter);
    }
}
class InlineCommentTag extends Tag {
    constructor(tagToken, remainTokens, liquid){
        super(tagToken, remainTokens, liquid);
        if (tagToken.args.search(/\n\s*[^#\s]/g) !== -1) throw new Error("every line of an inline comment must start with a '#' character");
    }
    render() {}
}
const tags = {
    assign: AssignTag,
    "for": ForTag,
    capture: CaptureTag,
    "case": CaseTag,
    comment: CommentTag,
    include: IncludeTag,
    render: RenderTag,
    decrement: DecrementTag,
    increment: IncrementTag,
    cycle: CycleTag,
    "if": IfTag,
    layout: LayoutTag,
    block: BlockTag,
    raw: RawTag,
    tablerow: TablerowTag,
    unless: UnlessTag,
    "break": BreakTag,
    "continue": ContinueTag,
    echo: EchoTag,
    liquid: LiquidTag,
    "#": InlineCommentTag
};
class Liquid {
    constructor(opts = {}){
        this.renderer = new Render();
        this.filters = {};
        this.tags = {};
        this.options = normalize(opts);
        this.parser = new Parser(this);
        forOwn(tags, (conf, name)=>this.registerTag(name, conf));
        forOwn(filters, (handler, name)=>this.registerFilter(name, handler));
    }
    parse(html, filepath) {
        return this.parser.parse(html, filepath);
    }
    _render(tpl, scope, renderOptions) {
        const ctx = scope instanceof Context ? scope : new Context(scope, this.options, renderOptions);
        return this.renderer.renderTemplates(tpl, ctx);
    }
    render(tpl, scope, renderOptions) {
        return __awaiter(this, void 0, void 0, function*() {
            return toPromise(this._render(tpl, scope, Object.assign(Object.assign({}, renderOptions), {
                sync: false
            })));
        });
    }
    renderSync(tpl, scope, renderOptions) {
        return toValueSync(this._render(tpl, scope, Object.assign(Object.assign({}, renderOptions), {
            sync: true
        })));
    }
    renderToNodeStream(tpl, scope, renderOptions = {}) {
        const ctx = new Context(scope, this.options, renderOptions);
        return this.renderer.renderTemplatesToNodeStream(tpl, ctx);
    }
    _parseAndRender(html, scope, renderOptions) {
        const tpl = this.parse(html);
        return this._render(tpl, scope, renderOptions);
    }
    parseAndRender(html, scope, renderOptions) {
        return __awaiter(this, void 0, void 0, function*() {
            return toPromise(this._parseAndRender(html, scope, Object.assign(Object.assign({}, renderOptions), {
                sync: false
            })));
        });
    }
    parseAndRenderSync(html, scope, renderOptions) {
        return toValueSync(this._parseAndRender(html, scope, Object.assign(Object.assign({}, renderOptions), {
            sync: true
        })));
    }
    _parsePartialFile(file, sync, currentFile) {
        return this.parser.parseFile(file, sync, LookupType.Partials, currentFile);
    }
    _parseLayoutFile(file, sync, currentFile) {
        return this.parser.parseFile(file, sync, LookupType.Layouts, currentFile);
    }
    _parseFile(file, sync, lookupType, currentFile) {
        return this.parser.parseFile(file, sync, lookupType, currentFile);
    }
    parseFile(file, lookupType) {
        return __awaiter(this, void 0, void 0, function*() {
            return toPromise(this.parser.parseFile(file, false, lookupType));
        });
    }
    parseFileSync(file, lookupType) {
        return toValueSync(this.parser.parseFile(file, true, lookupType));
    }
    *_renderFile(file, ctx, renderFileOptions) {
        const templates = yield this._parseFile(file, renderFileOptions.sync, renderFileOptions.lookupType);
        return yield this._render(templates, ctx, renderFileOptions);
    }
    renderFile(file, ctx, renderFileOptions) {
        return __awaiter(this, void 0, void 0, function*() {
            return toPromise(this._renderFile(file, ctx, Object.assign(Object.assign({}, renderFileOptions), {
                sync: false
            })));
        });
    }
    renderFileSync(file, ctx, renderFileOptions) {
        return toValueSync(this._renderFile(file, ctx, Object.assign(Object.assign({}, renderFileOptions), {
            sync: true
        })));
    }
    renderFileToNodeStream(file, scope, renderOptions) {
        return __awaiter(this, void 0, void 0, function*() {
            const templates = yield this.parseFile(file);
            return this.renderToNodeStream(templates, scope, renderOptions);
        });
    }
    _evalValue(str, scope) {
        const value = new Value(str, this);
        const ctx = scope instanceof Context ? scope : new Context(scope, this.options);
        return value.value(ctx);
    }
    evalValue(str, scope) {
        return __awaiter(this, void 0, void 0, function*() {
            return toPromise(this._evalValue(str, scope));
        });
    }
    evalValueSync(str, scope) {
        return toValueSync(this._evalValue(str, scope));
    }
    registerFilter(name, filter) {
        this.filters[name] = filter;
    }
    registerTag(name, tag) {
        this.tags[name] = isFunction(tag) ? tag : createTagClass(tag);
    }
    plugin(plugin) {
        return plugin.call(this, Liquid);
    }
    express() {
        const self = this; // eslint-disable-line
        let firstCall = true;
        return function(filePath, ctx, callback) {
            if (firstCall) {
                firstCall = false;
                const dirs = normalizeDirectoryList(this.root);
                self.options.root.unshift(...dirs);
                self.options.layouts.unshift(...dirs);
                self.options.partials.unshift(...dirs);
            }
            self.renderFile(filePath, ctx).then((html)=>callback(null, html), callback);
        };
    }
}
/* istanbul ignore file */ const version = "10.13.1";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4DFR8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsafeHTMLDirective", ()=>e);
parcelHelpers.export(exports, "unsafeHTML", ()=>o);
var _litHtmlJs = require("../lit-html.js");
var _directiveJs = require("../directive.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class e extends (0, _directiveJs.Directive) {
    constructor(i){
        if (super(i), this.it = (0, _litHtmlJs.nothing), i.type !== (0, _directiveJs.PartType).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, _litHtmlJs.nothing) || null == r) return this._t = void 0, this.it = r;
        if (r === (0, _litHtmlJs.noChange)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.it) return this._t;
        this.it = r;
        const s = [
            r
        ];
        return s.raw = s, this._t = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
}
e.directiveName = "unsafeHTML", e.resultType = 1;
const o = (0, _directiveJs.directive)(e);

},{"../lit-html.js":"4A25t","../directive.js":"k6ssg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8eQLC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqLiquidVariable", ()=>PdqLiquidVariable);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _styles = require("../styles");
var _tableBroker = require("../services/TableBroker");
var _16 = require("@carbon/web-components/es/icons/value--variable/16");
var _16Default = parcelHelpers.interopDefault(_16);
var _161 = require("@carbon/web-components/es/icons/trash-can/16");
var _16Default1 = parcelHelpers.interopDefault(_161);
var _16Js = require("@carbon/web-components/es/icons/save/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:liquid:pdq-liquid-variable");
// <pdq-liquid-variable id="0" number="0" name="variable" view="view"></pdq-liquid-variable>
let PdqLiquidVariable = class PdqLiquidVariable extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.number = NaN;
        this.name = "";
        this.source = "";
        this.value = "";
        this.dirty = false;
    }
    render() {
        return (0, _lit.html)`
        <div class="row center ${this.dirty ? "dirty" : ""}">
            <div>${(0, _16Default.default)()}</div>
            <cds-text-input
                    size="sm"
                    placeholder="Variable Name"
                    .value=${this.name}
                    @input=${this.nameChange}
            ></cds-text-input>
            <cds-select size="sm" placeholder="Source Name" .value="${this.source}" @change="${this.sourceChange}" class="mr-1">
                ${(0, _tableBroker.tableBroker).getViewNames().map((i)=>(0, _lit.html)`<cds-select-item value="${i}">${i}</cds-select-item>`)}
            </cds-select>
            <cds-text-input
              size="sm"
              placeholder="Static Value"
              .value=${this.value}
              @input=${this.valueChange}
            ></cds-text-input>
            <cds-button @click="${this.dispatchDelete}" size="sm" kind="danger">
                ${(0, _16Default1.default)({
            slot: "icon"
        })}
            </cds-button>
            <cds-button @click="${this.dispatchChange}" size="sm" class="mr-1">
                ${(0, _16JsDefault.default)({
            slot: "icon"
        })}
            </cds-button>
            <div style="min-width: 100px;">
               <span class="${this.dirty ? "" : "hide"}">Save required</span>
            </div>
            <div class="grow" style="width: 100%"></div>
        </div>
    `;
    }
    nameChange(evt) {
        this.name = evt.target?.value;
        this.dirty = true;
    }
    valueChange(evt) {
        this.value = evt.target?.value;
        this.dirty = true;
    }
    sourceChange(evt) {
        this.source = evt.target?.value;
        this.dirty = true;
    }
    dispatchChange() {
        log("dispatchChange");
        const event = new CustomEvent("pdq-liquid-variable-change", {
            detail: {
                id: this.id,
                name: this.name,
                source: this.source,
                value: this.value
            }
        });
        this.dispatchEvent(event);
        this.dirty = false;
    }
    dispatchDelete() {
        log("dispatchDelete");
        const event = new CustomEvent("pdq-liquid-variable-remove", {
            detail: {
                id: this.id
            }
        });
        this.dispatchEvent(event);
    }
};
PdqLiquidVariable.styles = [
    (0, _styles.row),
    (0, _styles.col),
    (0, _styles.hide),
    (0, _styles.grow),
    (0, _styles.padding),
    (0, _styles.marginRight),
    (0, _styles.center)
];
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Number)
], PdqLiquidVariable.prototype, "number", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", String)
], PdqLiquidVariable.prototype, "name", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Object)
], PdqLiquidVariable.prototype, "source", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Object)
], PdqLiquidVariable.prototype, "value", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Boolean)
], PdqLiquidVariable.prototype, "dirty", void 0);
PdqLiquidVariable = __decorate([
    (0, _decorators.customElement)("pdq-liquid-variable")
], PdqLiquidVariable);

},{"lit/decorators":"kQrIl","lit":"aCmte","../styles":"86IFJ","../services/TableBroker":"kJzSP","@carbon/web-components/es/icons/value--variable/16":"faqPj","@carbon/web-components/es/icons/trash-can/16":"1Qzh3","@carbon/web-components/es/icons/save/16.js":"atEnQ","debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"faqPj":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M26 28H22V26h4V6H22V4h4a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM20 11L18 11 16 14.897 14 11 12 11 14.905 16 12 21 14 21 16 17.201 18 21 20 21 17.098 16 20 11zM10 28H6a2.0021 2.0021 0 01-2-2V6A2.0021 2.0021 0 016 4h4V6H6V26h4z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Qzh3":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M12 12H14V24H12zM18 12H20V24H18z"></path><path d="M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gIrvP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqLiquidVariableStack", ()=>PdqLiquidVariableStack);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _styles = require("../styles");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var PdqLiquidVariableStack_1;
const log = (0, _debugDefault.default)("pdq:liquid:pdq-liquid-variable-stack");
let PdqLiquidVariableStack = PdqLiquidVariableStack_1 = class PdqLiquidVariableStack extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.variables = [];
    }
    render() {
        return (0, _lit.html)`
        <cds-form-group legend-text="Variables & Data Mapping" style="margin-bottom: 15px">
            <div class="col">
              ${this.variables.length > 0 ? (0, _lit.html)`
              <div class="row center">
                <div>Variable Name</div>
                <div>Data Source (table or view)</div>
                <div>Static Value</div>
              </div>` : (0, _lit.nothing)}
                ${this.variables.map((v)=>(0, _lit.html)`
                        <pdq-liquid-variable 
                          id="${v.id}" 
                          name="${v.name}" 
                          view="${v.source}"
                          value="${v.value}"
                          @pdq-liquid-variable-change="${(e)=>this.updateVariable(e.detail.id, e.detail.name, e.detail.source, e.detail.value)}"
                          @pdq-liquid-variable-remove="${(e)=>this.removeVariable(e.detail.id)}"
                        ></pdq-liquid-variable>
                    `)}
                <div class="row">
                    <cds-button size="sm" @click="${this.addVariable}">Add Variable</cds-button>
                </div>
            </div>
        </cds-form-group>
    `;
    }
    addVariable() {
        log("addVariable");
        this.variables.push({
            id: PdqLiquidVariableStack_1.nextId++,
            name: "",
            source: "",
            value: undefined
        });
        this.requestUpdate();
    }
    removeVariable(id) {
        log(`removeVariable: ${id}`);
        this.variables = this.variables.filter((v)=>v.id != id);
        this.dispatchChange();
        this.requestUpdate();
    }
    updateVariable(id, name, source, value) {
        log(`updateVariable: ${id}, ${name}, ${source},${value}`);
        const variable = this.variables.find((v)=>v.id == id);
        if (variable) {
            variable.name = name;
            variable.source = source;
            variable.value = value;
        }
        this.saveVariables();
    }
    dispatchChange() {
        log("dispatchChange: pdq-liquid-variables-changed");
        const event = new CustomEvent("pdq-liquid-variables-changed", {
            detail: this.variables
        });
        this.dispatchEvent(event);
    }
    saveVariables() {
        log(`saveVariables`);
        const event = new CustomEvent("pdq-liquid-variables-saved", {
            detail: this.variables
        });
        this.dispatchEvent(event);
    }
};
PdqLiquidVariableStack.styles = [
    (0, _styles.col),
    (0, _styles.row),
    (0, _styles.center)
];
PdqLiquidVariableStack.nextId = 0;
__decorate([
    (0, _decorators.property)({
        type: Array
    }),
    __metadata("design:type", Array)
], PdqLiquidVariableStack.prototype, "variables", void 0);
PdqLiquidVariableStack = PdqLiquidVariableStack_1 = __decorate([
    (0, _decorators.customElement)("pdq-liquid-variable-stack")
], PdqLiquidVariableStack);

},{"lit/decorators":"kQrIl","lit":"aCmte","../styles":"86IFJ","debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Amn9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqSchemaForm", ()=>PdqSchemaForm);
var _lit = require("lit");
var _react = require("react");
var _client = require("react-dom/client");
var _validatorAjv8 = require("@rjsf/validator-ajv8");
var _validatorAjv8Default = parcelHelpers.interopDefault(_validatorAjv8);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _decoratorsJs = require("lit/decorators.js");
var _utils = require("../utils");
var _decorators = require("lit/decorators");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
const default_schema = {};
const log = (0, _debugDefault.default)("pdq:forms:pdq-schema-form");
let PdqSchemaForm = class PdqSchemaForm extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.schema = default_schema;
        this.uiSchema = {};
        this.theme = "bootstrap-3";
        this.showErrorList = false;
        this.acceptcharset = "UTF-8";
        this.action = "";
        this.autoComplete = "off";
        this.className = "";
        this.disabled = false;
        this.readonly = false;
        this.enctype = "application/json";
        this.extraErrors = {};
        this.extraErrorsBlockSubmit = false;
        this.fields = {};
        this.focusOnFirstError = true;
        this.formContext = {};
        this.id = "";
        this.idPrefix = "root";
        this.idSeparator = "_";
        this.liveOmit = false;
        this.liveValidate = false;
        this.method = "post";
        this.name = "";
        this.noHtml5Validate = false;
        this.noValidate = false;
        this.omitExtraData = false;
        this.tagName = "form";
        this.target = "";
        this.onError = (errors)=>{
            this.dispatchEvent(new CustomEvent("formError", {
                detail: {
                    errors
                }
            }));
        };
        this.onSubmit = ({ formData }, event)=>{
            this.dispatchEvent(new CustomEvent("formSubmit", {
                detail: {
                    formData,
                    sourceEvent: event
                }
            }));
        };
        this.onChange = ({ formData }, id)=>{
            this._formData = formData;
            this.dispatchEvent(new CustomEvent("formChange", {
                detail: {
                    formData,
                    id
                }
            }));
        };
        this.onFocus = (event)=>{
            this.dispatchEvent(new CustomEvent("formFocus", {
                detail: {
                    sourceEvent: event
                }
            }));
        };
        this.onBlur = (event)=>{
            this.dispatchEvent(new CustomEvent("formBlur", {
                detail: {
                    sourceEvent: event
                }
            }));
        };
    }
    get formData() {
        return this._formData;
    }
    set formData(value) {
        const oldValue = this._formData;
        console.log(this._formData, value);
        if (typeof value === "string") try {
            value = JSON.parse(value);
        } catch (e) {
            console.warn(`Failed to parse formData: ${value}`, e);
            log(`formData is a string but is not valid json, failed to parse formData: ${value}`);
            value = {};
        }
        this._formData = value;
        this.requestUpdate("formData", oldValue);
    }
    async firstUpdated() {
        if (!this.root) this.root = (0, _client.createRoot)(this.reactRoot);
        const Form = await this.getThemedForm(this.theme);
        this.reactElement = (0, _react.createElement)(Form, {
            schema: this.schema,
            uiSchema: this.uiSchema,
            validator: (0, _validatorAjv8Default.default),
            showErrorList: this.showErrorList,
            acceptcharset: this.acceptcharset,
            action: this.action,
            autoComplete: this.autoComplete,
            className: this.className,
            disabled: this.disabled,
            readonly: this.readonly,
            enctype: this.enctype,
            extraErrors: this.extraErrors,
            extraErrorsBlockSubmit: this.extraErrorsBlockSubmit,
            fields: this.fields,
            focusOnFirstError: this.focusOnFirstError,
            formContext: this.formContext,
            formData: this.formData,
            id: this.id,
            idPrefix: this.idPrefix,
            idSeparator: this.idSeparator,
            liveOmit: this.liveOmit,
            liveValidate: this.liveValidate,
            method: this.method,
            name: this.name,
            noHtml5Validate: this.noHtml5Validate,
            noValidate: this.noValidate,
            omitExtraData: this.omitExtraData,
            tagName: this.tagName,
            target: this.target,
            onChange: this.onChange,
            onError: this.onError,
            onSubmit: this.onSubmit,
            onFocus: this.onFocus,
            onBlur: this.onBlur
        });
        this.root.render(this.reactElement);
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (this.reactElement && changedProperties.size > 0) {
            const newProps = Array.from(changedProperties.keys()).reduce((props, key)=>{
                props[key] = this[key];
                return props;
            }, {});
            this.root?.render((0, _react.createElement)(this.reactElement.type, {
                ...this.reactElement.props,
                ...newProps
            }));
        }
    }
    render() {
        return (0, _lit.html)`
            <slot style="display: none" name="schema" @slotchange="${this._onSchemaSlotChange}"></slot>
            <slot style="display: none" name="uiSchema" @slotchange="${this._onUiSchemaSlotChange}"></slot>
            <slot style="display: none" name="formData" @slotchange="${this._onFormDataSlotChange}"></slot>
            <link id="theme-style" rel="stylesheet">
            <div id="react-root"></div>
        `;
    }
    async getThemedForm(theme) {
        const cssLink = this.shadowRoot?.querySelector("#theme-style");
        let module;
        switch(theme){
            case "bootstrap-3":
                cssLink.href = "https://cdn.jsdelivr.net/npm/bootstrap@3.4.1/dist/css/bootstrap.min.css";
                module = await require("acf695c18dec582");
                return module.default;
            case "bootstrap-4":
                cssLink.href = "https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css";
                module = await require("cb7b917b06cdb7d9");
                return module.default;
            case "antd":
                cssLink.href = "https://cdnjs.cloudflare.com/ajax/libs/antd/4.6.6/antd.min.css";
                module = await require("c96b0cb2cc9ff408");
                return module.default;
            default:
                cssLink.href = "https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.7/css/bootstrap.min.css";
                console.warn(`theme '${theme}' not found... valid themes are: bootstrap-3, bootstrap-4, antd`);
                module = await require("acf695c18dec582");
                return module.default;
        }
    }
    _processSlot(event, slotName) {
        let templateForLog = "failed to read content";
        try {
            const slot = event.target;
            const nodes = slot.assignedNodes({
                flatten: true
            });
            const template = (0, _utils.extractTextFromScripts)(nodes);
            templateForLog = template;
            const oldValue = this[slotName];
            this[slotName] = JSON.parse(template);
            this.requestUpdate(slotName, oldValue);
            log(`slot  ${slotName} content changed to ${template}`);
        } catch (e) {
            console.error(`Failed to parse form ${slotName}, \n${templateForLog}`, e);
        }
    }
    _onSchemaSlotChange(event) {
        this._processSlot(event, "schema");
    }
    _onUiSchemaSlotChange(event) {
        this._processSlot(event, "uiSchema");
    }
    _onFormDataSlotChange(event) {
        this._processSlot(event, "formData");
    }
};
PdqSchemaForm.styles = (0, _lit.css)`
    legend {
        color: var(--cds-text-primary, #161616);
    }
    #react-root {
        color: var(--cds-text-primary, #161616);
        background: var(--cds-background, white);
    }
      
  `;
__decorate([
    (0, _decorators.property)({
        type: Object
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "schema", void 0);
__decorate([
    (0, _decorators.property)({
        type: Object
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "uiSchema", void 0);
__decorate([
    (0, _decorators.property)({
        type: Object
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [
        Object
    ])
], PdqSchemaForm.prototype, "formData", null);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "theme", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "showErrorList", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "acceptcharset", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "action", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "autoComplete", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "className", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "disabled", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "readonly", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "enctype", void 0);
__decorate([
    (0, _decorators.property)({
        type: Object
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "extraErrors", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "extraErrorsBlockSubmit", void 0);
__decorate([
    (0, _decorators.property)({
        type: Object
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "fields", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "focusOnFirstError", void 0);
__decorate([
    (0, _decorators.property)({
        type: Object
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "formContext", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "id", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "idPrefix", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "idSeparator", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "liveOmit", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "liveValidate", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "method", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "name", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "noHtml5Validate", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "noValidate", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "omitExtraData", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "tagName", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSchemaForm.prototype, "target", void 0);
__decorate([
    (0, _decorators.query)("#react-root"),
    __metadata("design:type", typeof (_a = typeof HTMLElement !== "undefined" && HTMLElement) === "function" ? _a : Object)
], PdqSchemaForm.prototype, "reactRoot", void 0);
PdqSchemaForm = __decorate([
    (0, _decoratorsJs.customElement)("pdq-schema-form")
], PdqSchemaForm);

},{"lit":"aCmte","react":"6uln9","react-dom/client":"5ccwt","@rjsf/validator-ajv8":"2lN71","debug":"17JIf","lit/decorators.js":"kQrIl","../utils":"i8jxn","lit/decorators":"kQrIl","acf695c18dec582":"4TsYa","cb7b917b06cdb7d9":"aClb8","c96b0cb2cc9ff408":"2cFGR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6uln9":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"8n7Eb"}],"8n7Eb":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"5ccwt":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"b8T3j"}],"b8T3j":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"bO0Ia"}],"bO0Ia":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"6uln9","ece50e903283a22f":"jNZm8"}],"jNZm8":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"izQ2Z"}],"izQ2Z":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"2lN71":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "customizeValidator", ()=>(0, _customizeValidatorDefault.default));
parcelHelpers.export(exports, "createPrecompiledValidator", ()=>(0, _createPrecompiledValidatorDefault.default));
var _customizeValidator = require("./customizeValidator");
var _customizeValidatorDefault = parcelHelpers.interopDefault(_customizeValidator);
var _createPrecompiledValidator = require("./createPrecompiledValidator");
var _createPrecompiledValidatorDefault = parcelHelpers.interopDefault(_createPrecompiledValidator);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
exports.default = (0, _customizeValidatorDefault.default)();

},{"./customizeValidator":"GEffV","./createPrecompiledValidator":"b2BcN","./types":"jgQxz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"GEffV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>customizeValidator);
var _validator = require("./validator");
var _validatorDefault = parcelHelpers.interopDefault(_validator);
function customizeValidator(options = {}, localizer) {
    return new (0, _validatorDefault.default)(options, localizer);
}

},{"./validator":"akbQR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"akbQR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@rjsf/utils");
var _createAjvInstance = require("./createAjvInstance");
var _createAjvInstanceDefault = parcelHelpers.interopDefault(_createAjvInstance);
var _processRawValidationErrors = require("./processRawValidationErrors");
var _processRawValidationErrorsDefault = parcelHelpers.interopDefault(_processRawValidationErrors);
class AJV8Validator {
    /** Constructs an `AJV8Validator` instance using the `options`
     *
     * @param options - The `CustomValidatorOptionsType` options that are used to create the AJV instance
     * @param [localizer] - If provided, is used to localize a list of Ajv `ErrorObject`s
     */ constructor(options, localizer){
        const { additionalMetaSchemas, customFormats, ajvOptionsOverrides, ajvFormatOptions, AjvClass } = options;
        this.ajv = (0, _createAjvInstanceDefault.default)(additionalMetaSchemas, customFormats, ajvOptionsOverrides, ajvFormatOptions, AjvClass);
        this.localizer = localizer;
    }
    /** Converts an `errorSchema` into a list of `RJSFValidationErrors`
     *
     * @param errorSchema - The `ErrorSchema` instance to convert
     * @param [fieldPath=[]] - The current field path, defaults to [] if not specified
     * @deprecated - Use the `toErrorList()` function provided by `@rjsf/utils` instead. This function will be removed in
     *        the next major release.
     */ toErrorList(errorSchema, fieldPath = []) {
        return (0, _utils.toErrorList)(errorSchema, fieldPath);
    }
    /** Runs the pure validation of the `schema` and `formData` without any of the RJSF functionality. Provided for use
     * by the playground. Returns the `errors` from the validation
     *
     * @param schema - The schema against which to validate the form data   * @param schema
     * @param formData - The form data to validate
     */ rawValidation(schema, formData) {
        let compilationError = undefined;
        let compiledValidator;
        if (schema[0, _utils.ID_KEY]) compiledValidator = this.ajv.getSchema(schema[0, _utils.ID_KEY]);
        try {
            if (compiledValidator === undefined) compiledValidator = this.ajv.compile(schema);
            compiledValidator(formData);
        } catch (err) {
            compilationError = err;
        }
        let errors;
        if (compiledValidator) {
            if (typeof this.localizer === "function") this.localizer(compiledValidator.errors);
            errors = compiledValidator.errors || undefined;
            // Clear errors to prevent persistent errors, see #1104
            compiledValidator.errors = null;
        }
        return {
            errors: errors,
            validationError: compilationError
        };
    }
    /** This function processes the `formData` with an optional user contributed `customValidate` function, which receives
     * the form data and a `errorHandler` function that will be used to add custom validation errors for each field. Also
     * supports a `transformErrors` function that will take the raw AJV validation errors, prior to custom validation and
     * transform them in what ever way it chooses.
     *
     * @param formData - The form data to validate
     * @param schema - The schema against which to validate the form data
     * @param [customValidate] - An optional function that is used to perform custom validation
     * @param [transformErrors] - An optional function that is used to transform errors after AJV validation
     * @param [uiSchema] - An optional uiSchema that is passed to `transformErrors` and `customValidate`
     */ validateFormData(formData, schema, customValidate, transformErrors, uiSchema) {
        const rawErrors = this.rawValidation(schema, formData);
        return (0, _processRawValidationErrorsDefault.default)(this, rawErrors, formData, schema, customValidate, transformErrors, uiSchema);
    }
    /** Validates data against a schema, returning true if the data is valid, or
     * false otherwise. If the schema is invalid, then this function will return
     * false.
     *
     * @param schema - The schema against which to validate the form data
     * @param formData - The form data to validate
     * @param rootSchema - The root schema used to provide $ref resolutions
     */ isValid(schema, formData, rootSchema) {
        var _a, _b;
        const rootSchemaId = (_a = rootSchema[0, _utils.ID_KEY]) !== null && _a !== void 0 ? _a : (0, _utils.ROOT_SCHEMA_PREFIX);
        try {
            // add the rootSchema ROOT_SCHEMA_PREFIX as id.
            // then rewrite the schema ref's to point to the rootSchema
            // this accounts for the case where schema have references to models
            // that lives in the rootSchema but not in the schema in question.
            // if (this.ajv.getSchema(rootSchemaId) === undefined) {
            // TODO restore the commented out `if` above when the TODO in the `finally` is completed
            this.ajv.addSchema(rootSchema, rootSchemaId);
            // }
            const schemaWithIdRefPrefix = (0, _utils.withIdRefPrefix)(schema);
            const schemaId = (_b = schemaWithIdRefPrefix[0, _utils.ID_KEY]) !== null && _b !== void 0 ? _b : (0, _utils.hashForSchema)(schemaWithIdRefPrefix);
            let compiledValidator;
            compiledValidator = this.ajv.getSchema(schemaId);
            if (compiledValidator === undefined) // Add schema by an explicit ID so it can be fetched later
            // Fall back to using compile if necessary
            // https://ajv.js.org/guide/managing-schemas.html#pre-adding-all-schemas-vs-adding-on-demand
            compiledValidator = this.ajv.addSchema(schemaWithIdRefPrefix, schemaId).getSchema(schemaId) || this.ajv.compile(schemaWithIdRefPrefix);
            const result = compiledValidator(formData);
            return result;
        } catch (e) {
            console.warn("Error encountered compiling schema:", e);
            return false;
        } finally{
            // TODO: A function should be called if the root schema changes so we don't have to remove and recompile the schema every run.
            // make sure we remove the rootSchema from the global ajv instance
            this.ajv.removeSchema(rootSchemaId);
        }
    }
}
exports.default = AJV8Validator;

},{"@rjsf/utils":"dblzs","./createAjvInstance":"ig5zI","./processRawValidationErrors":"1DTFJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dblzs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "allowAdditionalItems", ()=>(0, _allowAdditionalItemsDefault.default));
parcelHelpers.export(exports, "ariaDescribedByIds", ()=>(0, _idGenerators.ariaDescribedByIds));
parcelHelpers.export(exports, "asNumber", ()=>(0, _asNumberDefault.default));
parcelHelpers.export(exports, "canExpand", ()=>(0, _canExpandDefault.default));
parcelHelpers.export(exports, "createErrorHandler", ()=>(0, _createErrorHandlerDefault.default));
parcelHelpers.export(exports, "createSchemaUtils", ()=>(0, _createSchemaUtilsDefault.default));
parcelHelpers.export(exports, "dataURItoBlob", ()=>(0, _dataURItoBlobDefault.default));
parcelHelpers.export(exports, "deepEquals", ()=>(0, _deepEqualsDefault.default));
parcelHelpers.export(exports, "descriptionId", ()=>(0, _idGenerators.descriptionId));
parcelHelpers.export(exports, "englishStringTranslator", ()=>(0, _englishStringTranslatorDefault.default));
parcelHelpers.export(exports, "enumOptionsDeselectValue", ()=>(0, _enumOptionsDeselectValueDefault.default));
parcelHelpers.export(exports, "enumOptionsIndexForValue", ()=>(0, _enumOptionsIndexForValueDefault.default));
parcelHelpers.export(exports, "enumOptionsIsSelected", ()=>(0, _enumOptionsIsSelectedDefault.default));
parcelHelpers.export(exports, "enumOptionsSelectValue", ()=>(0, _enumOptionsSelectValueDefault.default));
parcelHelpers.export(exports, "enumOptionsValueForIndex", ()=>(0, _enumOptionsValueForIndexDefault.default));
parcelHelpers.export(exports, "errorId", ()=>(0, _idGenerators.errorId));
parcelHelpers.export(exports, "examplesId", ()=>(0, _idGenerators.examplesId));
parcelHelpers.export(exports, "ErrorSchemaBuilder", ()=>(0, _errorSchemaBuilderDefault.default));
parcelHelpers.export(exports, "findSchemaDefinition", ()=>(0, _findSchemaDefinitionDefault.default));
parcelHelpers.export(exports, "getDateElementProps", ()=>(0, _getDateElementPropsDefault.default));
parcelHelpers.export(exports, "getDiscriminatorFieldFromSchema", ()=>(0, _getDiscriminatorFieldFromSchemaDefault.default));
parcelHelpers.export(exports, "getInputProps", ()=>(0, _getInputPropsDefault.default));
parcelHelpers.export(exports, "getOptionMatchingSimpleDiscriminator", ()=>(0, _getOptionMatchingSimpleDiscriminatorDefault.default));
parcelHelpers.export(exports, "getSchemaType", ()=>(0, _getSchemaTypeDefault.default));
parcelHelpers.export(exports, "getSubmitButtonOptions", ()=>(0, _getSubmitButtonOptionsDefault.default));
parcelHelpers.export(exports, "getTemplate", ()=>(0, _getTemplateDefault.default));
parcelHelpers.export(exports, "getUiOptions", ()=>(0, _getUiOptionsDefault.default));
parcelHelpers.export(exports, "getWidget", ()=>(0, _getWidgetDefault.default));
parcelHelpers.export(exports, "guessType", ()=>(0, _guessTypeDefault.default));
parcelHelpers.export(exports, "hasWidget", ()=>(0, _hasWidgetDefault.default));
parcelHelpers.export(exports, "hashForSchema", ()=>(0, _hashForSchemaDefault.default));
parcelHelpers.export(exports, "helpId", ()=>(0, _idGenerators.helpId));
parcelHelpers.export(exports, "isConstant", ()=>(0, _isConstantDefault.default));
parcelHelpers.export(exports, "isCustomWidget", ()=>(0, _isCustomWidgetDefault.default));
parcelHelpers.export(exports, "isFixedItems", ()=>(0, _isFixedItemsDefault.default));
parcelHelpers.export(exports, "isObject", ()=>(0, _isObjectDefault.default));
parcelHelpers.export(exports, "labelValue", ()=>(0, _labelValueDefault.default));
parcelHelpers.export(exports, "localToUTC", ()=>(0, _localToUTCDefault.default));
parcelHelpers.export(exports, "mergeDefaultsWithFormData", ()=>(0, _mergeDefaultsWithFormDataDefault.default));
parcelHelpers.export(exports, "mergeObjects", ()=>(0, _mergeObjectsDefault.default));
parcelHelpers.export(exports, "mergeSchemas", ()=>(0, _mergeSchemasDefault.default));
parcelHelpers.export(exports, "optionId", ()=>(0, _idGenerators.optionId));
parcelHelpers.export(exports, "optionsList", ()=>(0, _optionsListDefault.default));
parcelHelpers.export(exports, "orderProperties", ()=>(0, _orderPropertiesDefault.default));
parcelHelpers.export(exports, "pad", ()=>(0, _padDefault.default));
parcelHelpers.export(exports, "parseDateString", ()=>(0, _parseDateStringDefault.default));
parcelHelpers.export(exports, "rangeSpec", ()=>(0, _rangeSpecDefault.default));
parcelHelpers.export(exports, "replaceStringParameters", ()=>(0, _replaceStringParametersDefault.default));
parcelHelpers.export(exports, "schemaRequiresTrueValue", ()=>(0, _schemaRequiresTrueValueDefault.default));
parcelHelpers.export(exports, "shouldRender", ()=>(0, _shouldRenderDefault.default));
parcelHelpers.export(exports, "titleId", ()=>(0, _idGenerators.titleId));
parcelHelpers.export(exports, "toConstant", ()=>(0, _toConstantDefault.default));
parcelHelpers.export(exports, "toDateString", ()=>(0, _toDateStringDefault.default));
parcelHelpers.export(exports, "toErrorList", ()=>(0, _toErrorListDefault.default));
parcelHelpers.export(exports, "toErrorSchema", ()=>(0, _toErrorSchemaDefault.default));
parcelHelpers.export(exports, "unwrapErrorHandler", ()=>(0, _unwrapErrorHandlerDefault.default));
parcelHelpers.export(exports, "utcToLocal", ()=>(0, _utcToLocalDefault.default));
parcelHelpers.export(exports, "validationDataMerge", ()=>(0, _validationDataMergeDefault.default));
parcelHelpers.export(exports, "withIdRefPrefix", ()=>(0, _withIdRefPrefixDefault.default));
var _allowAdditionalItems = require("./allowAdditionalItems");
var _allowAdditionalItemsDefault = parcelHelpers.interopDefault(_allowAdditionalItems);
var _asNumber = require("./asNumber");
var _asNumberDefault = parcelHelpers.interopDefault(_asNumber);
var _canExpand = require("./canExpand");
var _canExpandDefault = parcelHelpers.interopDefault(_canExpand);
var _createErrorHandler = require("./createErrorHandler");
var _createErrorHandlerDefault = parcelHelpers.interopDefault(_createErrorHandler);
var _createSchemaUtils = require("./createSchemaUtils");
var _createSchemaUtilsDefault = parcelHelpers.interopDefault(_createSchemaUtils);
var _dataURItoBlob = require("./dataURItoBlob");
var _dataURItoBlobDefault = parcelHelpers.interopDefault(_dataURItoBlob);
var _deepEquals = require("./deepEquals");
var _deepEqualsDefault = parcelHelpers.interopDefault(_deepEquals);
var _englishStringTranslator = require("./englishStringTranslator");
var _englishStringTranslatorDefault = parcelHelpers.interopDefault(_englishStringTranslator);
var _enumOptionsDeselectValue = require("./enumOptionsDeselectValue");
var _enumOptionsDeselectValueDefault = parcelHelpers.interopDefault(_enumOptionsDeselectValue);
var _enumOptionsIndexForValue = require("./enumOptionsIndexForValue");
var _enumOptionsIndexForValueDefault = parcelHelpers.interopDefault(_enumOptionsIndexForValue);
var _enumOptionsIsSelected = require("./enumOptionsIsSelected");
var _enumOptionsIsSelectedDefault = parcelHelpers.interopDefault(_enumOptionsIsSelected);
var _enumOptionsSelectValue = require("./enumOptionsSelectValue");
var _enumOptionsSelectValueDefault = parcelHelpers.interopDefault(_enumOptionsSelectValue);
var _enumOptionsValueForIndex = require("./enumOptionsValueForIndex");
var _enumOptionsValueForIndexDefault = parcelHelpers.interopDefault(_enumOptionsValueForIndex);
var _errorSchemaBuilder = require("./ErrorSchemaBuilder");
var _errorSchemaBuilderDefault = parcelHelpers.interopDefault(_errorSchemaBuilder);
var _findSchemaDefinition = require("./findSchemaDefinition");
var _findSchemaDefinitionDefault = parcelHelpers.interopDefault(_findSchemaDefinition);
var _getDateElementProps = require("./getDateElementProps");
var _getDateElementPropsDefault = parcelHelpers.interopDefault(_getDateElementProps);
var _getDiscriminatorFieldFromSchema = require("./getDiscriminatorFieldFromSchema");
var _getDiscriminatorFieldFromSchemaDefault = parcelHelpers.interopDefault(_getDiscriminatorFieldFromSchema);
var _getInputProps = require("./getInputProps");
var _getInputPropsDefault = parcelHelpers.interopDefault(_getInputProps);
var _getSchemaType = require("./getSchemaType");
var _getSchemaTypeDefault = parcelHelpers.interopDefault(_getSchemaType);
var _getSubmitButtonOptions = require("./getSubmitButtonOptions");
var _getSubmitButtonOptionsDefault = parcelHelpers.interopDefault(_getSubmitButtonOptions);
var _getTemplate = require("./getTemplate");
var _getTemplateDefault = parcelHelpers.interopDefault(_getTemplate);
var _getUiOptions = require("./getUiOptions");
var _getUiOptionsDefault = parcelHelpers.interopDefault(_getUiOptions);
var _getWidget = require("./getWidget");
var _getWidgetDefault = parcelHelpers.interopDefault(_getWidget);
var _guessType = require("./guessType");
var _guessTypeDefault = parcelHelpers.interopDefault(_guessType);
var _hashForSchema = require("./hashForSchema");
var _hashForSchemaDefault = parcelHelpers.interopDefault(_hashForSchema);
var _hasWidget = require("./hasWidget");
var _hasWidgetDefault = parcelHelpers.interopDefault(_hasWidget);
var _idGenerators = require("./idGenerators");
var _isConstant = require("./isConstant");
var _isConstantDefault = parcelHelpers.interopDefault(_isConstant);
var _isCustomWidget = require("./isCustomWidget");
var _isCustomWidgetDefault = parcelHelpers.interopDefault(_isCustomWidget);
var _isFixedItems = require("./isFixedItems");
var _isFixedItemsDefault = parcelHelpers.interopDefault(_isFixedItems);
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _labelValue = require("./labelValue");
var _labelValueDefault = parcelHelpers.interopDefault(_labelValue);
var _localToUTC = require("./localToUTC");
var _localToUTCDefault = parcelHelpers.interopDefault(_localToUTC);
var _mergeDefaultsWithFormData = require("./mergeDefaultsWithFormData");
var _mergeDefaultsWithFormDataDefault = parcelHelpers.interopDefault(_mergeDefaultsWithFormData);
var _mergeObjects = require("./mergeObjects");
var _mergeObjectsDefault = parcelHelpers.interopDefault(_mergeObjects);
var _mergeSchemas = require("./mergeSchemas");
var _mergeSchemasDefault = parcelHelpers.interopDefault(_mergeSchemas);
var _optionsList = require("./optionsList");
var _optionsListDefault = parcelHelpers.interopDefault(_optionsList);
var _orderProperties = require("./orderProperties");
var _orderPropertiesDefault = parcelHelpers.interopDefault(_orderProperties);
var _pad = require("./pad");
var _padDefault = parcelHelpers.interopDefault(_pad);
var _parseDateString = require("./parseDateString");
var _parseDateStringDefault = parcelHelpers.interopDefault(_parseDateString);
var _rangeSpec = require("./rangeSpec");
var _rangeSpecDefault = parcelHelpers.interopDefault(_rangeSpec);
var _replaceStringParameters = require("./replaceStringParameters");
var _replaceStringParametersDefault = parcelHelpers.interopDefault(_replaceStringParameters);
var _schemaRequiresTrueValue = require("./schemaRequiresTrueValue");
var _schemaRequiresTrueValueDefault = parcelHelpers.interopDefault(_schemaRequiresTrueValue);
var _shouldRender = require("./shouldRender");
var _shouldRenderDefault = parcelHelpers.interopDefault(_shouldRender);
var _toConstant = require("./toConstant");
var _toConstantDefault = parcelHelpers.interopDefault(_toConstant);
var _toDateString = require("./toDateString");
var _toDateStringDefault = parcelHelpers.interopDefault(_toDateString);
var _toErrorList = require("./toErrorList");
var _toErrorListDefault = parcelHelpers.interopDefault(_toErrorList);
var _toErrorSchema = require("./toErrorSchema");
var _toErrorSchemaDefault = parcelHelpers.interopDefault(_toErrorSchema);
var _unwrapErrorHandler = require("./unwrapErrorHandler");
var _unwrapErrorHandlerDefault = parcelHelpers.interopDefault(_unwrapErrorHandler);
var _utcToLocal = require("./utcToLocal");
var _utcToLocalDefault = parcelHelpers.interopDefault(_utcToLocal);
var _validationDataMerge = require("./validationDataMerge");
var _validationDataMergeDefault = parcelHelpers.interopDefault(_validationDataMerge);
var _withIdRefPrefix = require("./withIdRefPrefix");
var _withIdRefPrefixDefault = parcelHelpers.interopDefault(_withIdRefPrefix);
var _getOptionMatchingSimpleDiscriminator = require("./getOptionMatchingSimpleDiscriminator");
var _getOptionMatchingSimpleDiscriminatorDefault = parcelHelpers.interopDefault(_getOptionMatchingSimpleDiscriminator);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _enums = require("./enums");
parcelHelpers.exportAll(_enums, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _parser = require("./parser");
parcelHelpers.exportAll(_parser, exports);
var _schema = require("./schema");
parcelHelpers.exportAll(_schema, exports);

},{"./allowAdditionalItems":"hS0hI","./asNumber":"ho7tu","./canExpand":"fTUgd","./createErrorHandler":"i5X0D","./createSchemaUtils":"gu6uT","./dataURItoBlob":"9eYC1","./deepEquals":"aPOCr","./englishStringTranslator":"Vvutm","./enumOptionsDeselectValue":"2Rv59","./enumOptionsIndexForValue":"4mngm","./enumOptionsIsSelected":"lNily","./enumOptionsSelectValue":"eSFXc","./enumOptionsValueForIndex":"67dpy","./ErrorSchemaBuilder":"ffpV1","./findSchemaDefinition":"6Ii9d","./getDateElementProps":"7kPzQ","./getDiscriminatorFieldFromSchema":"guLol","./getInputProps":"8U2MT","./getSchemaType":"emxZR","./getSubmitButtonOptions":"aQRT7","./getTemplate":"7Eslw","./getUiOptions":"ecGOw","./getWidget":"ggI8e","./guessType":"aoWoo","./hashForSchema":"kvlp9","./hasWidget":"aJJn6","./idGenerators":"2MXL4","./isConstant":"d20uW","./isCustomWidget":"1tXNR","./isFixedItems":"FI6RK","./isObject":"fyldM","./labelValue":"eNF0G","./localToUTC":"1Axej","./mergeDefaultsWithFormData":"lU5Qu","./mergeObjects":"kAdf0","./mergeSchemas":"dXj9f","./optionsList":"lprfh","./orderProperties":"5uQS0","./pad":"65FmP","./parseDateString":"5Dlwy","./rangeSpec":"3gz6q","./replaceStringParameters":"ern13","./schemaRequiresTrueValue":"kWjb7","./shouldRender":"22cEc","./toConstant":"8iXDc","./toDateString":"knMkZ","./toErrorList":"lMK8U","./toErrorSchema":"1FML1","./unwrapErrorHandler":"k2o85","./utcToLocal":"j1Ke2","./validationDataMerge":"e591F","./withIdRefPrefix":"6LZYt","./getOptionMatchingSimpleDiscriminator":"4VEsa","./types":"xA7kA","./enums":"gZxhh","./constants":"a1fVD","./parser":"6IIgK","./schema":"eCkgn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hS0hI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>allowAdditionalItems);
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function allowAdditionalItems(schema) {
    if (schema.additionalItems === true) console.warn("additionalItems=true is currently not supported");
    return (0, _isObjectDefault.default)(schema.additionalItems);
}

},{"./isObject":"fyldM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fyldM":[function(require,module,exports) {
/** Determines whether a `thing` is an object for the purposes of RSJF. In this case, `thing` is an object if it has
 * the type `object` but is NOT null, an array or a File.
 *
 * @param thing - The thing to check to see whether it is an object
 * @returns - True if it is a non-null, non-array, non-File object
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isObject);
function isObject(thing) {
    if (typeof File !== "undefined" && thing instanceof File) return false;
    if (typeof Date !== "undefined" && thing instanceof Date) return false;
    return typeof thing === "object" && thing !== null && !Array.isArray(thing);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ho7tu":[function(require,module,exports) {
/** Attempts to convert the string into a number. If an empty string is provided, then `undefined` is returned. If a
 * `null` is provided, it is returned. If the string ends in a `.` then the string is returned because the user may be
 * in the middle of typing a float number. If a number ends in a pattern like `.0`, `.20`, `.030`, string is returned
 * because the user may be typing number that will end in a non-zero digit. Otherwise, the string is wrapped by
 * `Number()` and if that result is not `NaN`, that number will be returned, otherwise the string `value` will be.
 *
 * @param value - The string or null value to convert to a number
 * @returns - The `value` converted to a number when appropriate, otherwise the `value`
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>asNumber);
function asNumber(value) {
    if (value === "") return undefined;
    if (value === null) return null;
    if (/\.$/.test(value)) // '3.' can't really be considered a number even if it parses in js. The
    // user is most likely entering a float.
    return value;
    if (/\.0$/.test(value)) // we need to return this as a string here, to allow for input like 3.07
    return value;
    if (/\.\d*0$/.test(value)) // It's a number, that's cool - but we need it as a string so it doesn't screw
    // with the user when entering dollar amounts or other values (such as those with
    // specific precision or number of significant digits)
    return value;
    const n = Number(value);
    const valid = typeof n === "number" && !Number.isNaN(n);
    return valid ? n : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fTUgd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>canExpand);
var _getUiOptions = require("./getUiOptions");
var _getUiOptionsDefault = parcelHelpers.interopDefault(_getUiOptions);
function canExpand(schema, uiSchema = {}, formData) {
    if (!schema.additionalProperties) return false;
    const { expandable = true } = (0, _getUiOptionsDefault.default)(uiSchema);
    if (expandable === false) return expandable;
    // if ui:options.expandable was not explicitly set to false, we can add
    // another property if we have not exceeded maxProperties yet
    if (schema.maxProperties !== undefined && formData) return Object.keys(formData).length < schema.maxProperties;
    return true;
}

},{"./getUiOptions":"ecGOw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ecGOw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUiOptions);
var _constants = require("./constants");
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function getUiOptions(uiSchema = {}, globalOptions = {}) {
    return Object.keys(uiSchema).filter((key)=>key.indexOf("ui:") === 0).reduce((options, key)=>{
        const value = uiSchema[key];
        if (key === (0, _constants.UI_WIDGET_KEY) && (0, _isObjectDefault.default)(value)) {
            console.error("Setting options via ui:widget object is no longer supported, use ui:options instead");
            return options;
        }
        if (key === (0, _constants.UI_OPTIONS_KEY) && (0, _isObjectDefault.default)(value)) return {
            ...options,
            ...value
        };
        return {
            ...options,
            [key.substring(3)]: value
        };
    }, {
        ...globalOptions
    });
}

},{"./constants":"a1fVD","./isObject":"fyldM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a1fVD":[function(require,module,exports) {
/** Below are the list of all the keys into various elements of a RJSFSchema or UiSchema that are used by the various
 * utility functions. In addition to those keys, there are the special `ADDITIONAL_PROPERTY_FLAG` and
 * `RJSF_ADDITIONAL_PROPERTIES_FLAG` flags that is added to a schema under certain conditions by the `retrieveSchema()`
 * utility.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ADDITIONAL_PROPERTY_FLAG", ()=>ADDITIONAL_PROPERTY_FLAG);
parcelHelpers.export(exports, "ADDITIONAL_PROPERTIES_KEY", ()=>ADDITIONAL_PROPERTIES_KEY);
parcelHelpers.export(exports, "ALL_OF_KEY", ()=>ALL_OF_KEY);
parcelHelpers.export(exports, "ANY_OF_KEY", ()=>ANY_OF_KEY);
parcelHelpers.export(exports, "CONST_KEY", ()=>CONST_KEY);
parcelHelpers.export(exports, "DEFAULT_KEY", ()=>DEFAULT_KEY);
parcelHelpers.export(exports, "DEFINITIONS_KEY", ()=>DEFINITIONS_KEY);
parcelHelpers.export(exports, "DEPENDENCIES_KEY", ()=>DEPENDENCIES_KEY);
parcelHelpers.export(exports, "ENUM_KEY", ()=>ENUM_KEY);
parcelHelpers.export(exports, "ERRORS_KEY", ()=>ERRORS_KEY);
parcelHelpers.export(exports, "ID_KEY", ()=>ID_KEY);
parcelHelpers.export(exports, "IF_KEY", ()=>IF_KEY);
parcelHelpers.export(exports, "ITEMS_KEY", ()=>ITEMS_KEY);
parcelHelpers.export(exports, "JUNK_OPTION_ID", ()=>JUNK_OPTION_ID);
parcelHelpers.export(exports, "NAME_KEY", ()=>NAME_KEY);
parcelHelpers.export(exports, "ONE_OF_KEY", ()=>ONE_OF_KEY);
parcelHelpers.export(exports, "PROPERTIES_KEY", ()=>PROPERTIES_KEY);
parcelHelpers.export(exports, "REQUIRED_KEY", ()=>REQUIRED_KEY);
parcelHelpers.export(exports, "SUBMIT_BTN_OPTIONS_KEY", ()=>SUBMIT_BTN_OPTIONS_KEY);
parcelHelpers.export(exports, "REF_KEY", ()=>REF_KEY);
parcelHelpers.export(exports, "RJSF_ADDITONAL_PROPERTIES_FLAG", ()=>RJSF_ADDITONAL_PROPERTIES_FLAG);
parcelHelpers.export(exports, "RJSF_ADDITIONAL_PROPERTIES_FLAG", ()=>RJSF_ADDITIONAL_PROPERTIES_FLAG);
parcelHelpers.export(exports, "ROOT_SCHEMA_PREFIX", ()=>ROOT_SCHEMA_PREFIX);
parcelHelpers.export(exports, "UI_FIELD_KEY", ()=>UI_FIELD_KEY);
parcelHelpers.export(exports, "UI_WIDGET_KEY", ()=>UI_WIDGET_KEY);
parcelHelpers.export(exports, "UI_OPTIONS_KEY", ()=>UI_OPTIONS_KEY);
parcelHelpers.export(exports, "UI_GLOBAL_OPTIONS_KEY", ()=>UI_GLOBAL_OPTIONS_KEY);
const ADDITIONAL_PROPERTY_FLAG = "__additional_property";
const ADDITIONAL_PROPERTIES_KEY = "additionalProperties";
const ALL_OF_KEY = "allOf";
const ANY_OF_KEY = "anyOf";
const CONST_KEY = "const";
const DEFAULT_KEY = "default";
const DEFINITIONS_KEY = "definitions";
const DEPENDENCIES_KEY = "dependencies";
const ENUM_KEY = "enum";
const ERRORS_KEY = "__errors";
const ID_KEY = "$id";
const IF_KEY = "if";
const ITEMS_KEY = "items";
const JUNK_OPTION_ID = "_$junk_option_schema_id$_";
const NAME_KEY = "$name";
const ONE_OF_KEY = "oneOf";
const PROPERTIES_KEY = "properties";
const REQUIRED_KEY = "required";
const SUBMIT_BTN_OPTIONS_KEY = "submitButtonOptions";
const REF_KEY = "$ref";
const RJSF_ADDITONAL_PROPERTIES_FLAG = "__rjsf_additionalProperties";
const RJSF_ADDITIONAL_PROPERTIES_FLAG = "__rjsf_additionalProperties";
const ROOT_SCHEMA_PREFIX = "__rjsf_rootSchema";
const UI_FIELD_KEY = "ui:field";
const UI_WIDGET_KEY = "ui:widget";
const UI_OPTIONS_KEY = "ui:options";
const UI_GLOBAL_OPTIONS_KEY = "ui:globalOptions";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i5X0D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createErrorHandler);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _constants = require("./constants");
function createErrorHandler(formData) {
    const handler = {
        // We store the list of errors for this node in a property named __errors
        // to avoid name collision with a possible sub schema field named
        // 'errors' (see `utils.toErrorSchema`).
        [(0, _constants.ERRORS_KEY)]: [],
        addError (message) {
            this[0, _constants.ERRORS_KEY].push(message);
        }
    };
    if (Array.isArray(formData)) return formData.reduce((acc, value, key)=>{
        return {
            ...acc,
            [key]: createErrorHandler(value)
        };
    }, handler);
    if ((0, _isPlainObjectDefault.default)(formData)) {
        const formObject = formData;
        return Object.keys(formObject).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: createErrorHandler(formObject[key])
            };
        }, handler);
    }
    return handler;
}

},{"lodash/isPlainObject":"aYsgZ","./constants":"a1fVD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aYsgZ":[function(require,module,exports) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"fQG2h","2ca5b85a120835de":"lvQrI","963b65e043435612":"5TH1N"}],"fQG2h":[function(require,module,exports) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"e0ngr","9b2aaf31b7bdd837":"5XmKh","46d5beb3375f8a28":"fT5CU"}],"e0ngr":[function(require,module,exports) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"iGWPT"}],"iGWPT":[function(require,module,exports) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"cd92e8811deaabf5":"hw1wy"}],"hw1wy":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"5XmKh":[function(require,module,exports) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"e0ngr"}],"fT5CU":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"lvQrI":[function(require,module,exports) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"5rEQb"}],"5rEQb":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"5TH1N":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"gu6uT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSchemaUtils);
var _deepEquals = require("./deepEquals");
var _deepEqualsDefault = parcelHelpers.interopDefault(_deepEquals);
var _schema = require("./schema");
/** The `SchemaUtils` class provides a wrapper around the publicly exported APIs in the `utils/schema` directory such
 * that one does not have to explicitly pass the `validator`, `rootSchema`, or `experimental_defaultFormStateBehavior` to each method.
 * Since these generally do not change across a `Form`, this allows for providing a simplified set of APIs to the
 * `@rjsf/core` components and the various themes as well. This class implements the `SchemaUtilsType` interface.
 */ class SchemaUtils {
    /** Constructs the `SchemaUtils` instance with the given `validator` and `rootSchema` stored as instance variables
     *
     * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
     * @param rootSchema - The root schema that will be forwarded to all the APIs
     * @param experimental_defaultFormStateBehavior - Configuration flags to allow users to override default form state behavior
     */ constructor(validator, rootSchema, experimental_defaultFormStateBehavior){
        this.rootSchema = rootSchema;
        this.validator = validator;
        this.experimental_defaultFormStateBehavior = experimental_defaultFormStateBehavior;
    }
    /** Returns the `ValidatorType` in the `SchemaUtilsType`
     *
     * @returns - The `ValidatorType`
     */ getValidator() {
        return this.validator;
    }
    /** Determines whether either the `validator` and `rootSchema` differ from the ones associated with this instance of
     * the `SchemaUtilsType`. If either `validator` or `rootSchema` are falsy, then return false to prevent the creation
     * of a new `SchemaUtilsType` with incomplete properties.
     *
     * @param validator - An implementation of the `ValidatorType` interface that will be compared against the current one
     * @param rootSchema - The root schema that will be compared against the current one
     * @param [experimental_defaultFormStateBehavior] Optional configuration object, if provided, allows users to override default form state behavior
     * @returns - True if the `SchemaUtilsType` differs from the given `validator` or `rootSchema`
     */ doesSchemaUtilsDiffer(validator, rootSchema, experimental_defaultFormStateBehavior = {}) {
        if (!validator || !rootSchema) return false;
        return this.validator !== validator || !(0, _deepEqualsDefault.default)(this.rootSchema, rootSchema) || !(0, _deepEqualsDefault.default)(this.experimental_defaultFormStateBehavior, experimental_defaultFormStateBehavior);
    }
    /** Returns the superset of `formData` that includes the given set updated to include any missing fields that have
     * computed to have defaults provided in the `schema`.
     *
     * @param schema - The schema for which the default state is desired
     * @param [formData] - The current formData, if any, onto which to provide any missing defaults
     * @param [includeUndefinedValues=false] - Optional flag, if true, cause undefined values to be added as defaults.
     *          If "excludeObjectChildren", pass `includeUndefinedValues` as false when computing defaults for any nested
     *          object properties.
     * @returns - The resulting `formData` with all the defaults provided
     */ getDefaultFormState(schema, formData, includeUndefinedValues = false) {
        return (0, _schema.getDefaultFormState)(this.validator, schema, formData, this.rootSchema, includeUndefinedValues, this.experimental_defaultFormStateBehavior);
    }
    /** Determines whether the combination of `schema` and `uiSchema` properties indicates that the label for the `schema`
     * should be displayed in a UI.
     *
     * @param schema - The schema for which the display label flag is desired
     * @param [uiSchema] - The UI schema from which to derive potentially displayable information
     * @param [globalOptions={}] - The optional Global UI Schema from which to get any fallback `xxx` options
     * @returns - True if the label should be displayed or false if it should not
     */ getDisplayLabel(schema, uiSchema, globalOptions) {
        return (0, _schema.getDisplayLabel)(this.validator, schema, uiSchema, this.rootSchema, globalOptions);
    }
    /** Determines which of the given `options` provided most closely matches the `formData`.
     * Returns the index of the option that is valid and is the closest match, or 0 if there is no match.
     *
     * The closest match is determined using the number of matching properties, and more heavily favors options with
     * matching readOnly, default, or const values.
     *
     * @param formData - The form data associated with the schema
     * @param options - The list of options that can be selected from
     * @param [selectedOption] - The index of the currently selected option, defaulted to -1 if not specified
     * @param [discriminatorField] - The optional name of the field within the options object whose value is used to
     *          determine which option is selected
     * @returns - The index of the option that is the closest match to the `formData` or the `selectedOption` if no match
     */ getClosestMatchingOption(formData, options, selectedOption, discriminatorField) {
        return (0, _schema.getClosestMatchingOption)(this.validator, this.rootSchema, formData, options, selectedOption, discriminatorField);
    }
    /** Given the `formData` and list of `options`, attempts to find the index of the first option that matches the data.
     * Always returns the first option if there is nothing that matches.
     *
     * @param formData - The current formData, if any, used to figure out a match
     * @param options - The list of options to find a matching options from
     * @param [discriminatorField] - The optional name of the field within the options object whose value is used to
     *          determine which option is selected
     * @returns - The firstindex of the matched option or 0 if none is available
     */ getFirstMatchingOption(formData, options, discriminatorField) {
        return (0, _schema.getFirstMatchingOption)(this.validator, formData, options, this.rootSchema, discriminatorField);
    }
    /** Given the `formData` and list of `options`, attempts to find the index of the option that best matches the data.
     * Deprecated, use `getFirstMatchingOption()` instead.
     *
     * @param formData - The current formData, if any, onto which to provide any missing defaults
     * @param options - The list of options to find a matching options from
     * @param [discriminatorField] - The optional name of the field within the options object whose value is used to
     *          determine which option is selected
     * @returns - The index of the matched option or 0 if none is available
     * @deprecated
     */ getMatchingOption(formData, options, discriminatorField) {
        return (0, _schema.getMatchingOption)(this.validator, formData, options, this.rootSchema, discriminatorField);
    }
    /** Checks to see if the `schema` and `uiSchema` combination represents an array of files
     *
     * @param schema - The schema for which check for array of files flag is desired
     * @param [uiSchema] - The UI schema from which to check the widget
     * @returns - True if schema/uiSchema contains an array of files, otherwise false
     */ isFilesArray(schema, uiSchema) {
        return (0, _schema.isFilesArray)(this.validator, schema, uiSchema, this.rootSchema);
    }
    /** Checks to see if the `schema` combination represents a multi-select
     *
     * @param schema - The schema for which check for a multi-select flag is desired
     * @returns - True if schema contains a multi-select, otherwise false
     */ isMultiSelect(schema) {
        return (0, _schema.isMultiSelect)(this.validator, schema, this.rootSchema);
    }
    /** Checks to see if the `schema` combination represents a select
     *
     * @param schema - The schema for which check for a select flag is desired
     * @returns - True if schema contains a select, otherwise false
     */ isSelect(schema) {
        return (0, _schema.isSelect)(this.validator, schema, this.rootSchema);
    }
    /** Merges the errors in `additionalErrorSchema` into the existing `validationData` by combining the hierarchies in
     * the two `ErrorSchema`s and then appending the error list from the `additionalErrorSchema` obtained by calling
     * `getValidator().toErrorList()` onto the `errors` in the `validationData`. If no `additionalErrorSchema` is passed,
     * then `validationData` is returned.
     *
     * @param validationData - The current `ValidationData` into which to merge the additional errors
     * @param [additionalErrorSchema] - The additional set of errors
     * @returns - The `validationData` with the additional errors from `additionalErrorSchema` merged into it, if provided.
     * @deprecated - Use the `validationDataMerge()` function exported from `@rjsf/utils` instead. This function will be
     *        removed in the next major release.
     */ mergeValidationData(validationData, additionalErrorSchema) {
        return (0, _schema.mergeValidationData)(this.validator, validationData, additionalErrorSchema);
    }
    /** Retrieves an expanded schema that has had all of its conditions, additional properties, references and
     * dependencies resolved and merged into the `schema` given a `rawFormData` that is used to do the potentially
     * recursive resolution.
     *
     * @param schema - The schema for which retrieving a schema is desired
     * @param [rawFormData] - The current formData, if any, to assist retrieving a schema
     * @returns - The schema having its conditions, additional properties, references and dependencies resolved
     */ retrieveSchema(schema, rawFormData) {
        return (0, _schema.retrieveSchema)(this.validator, schema, this.rootSchema, rawFormData);
    }
    /** Sanitize the `data` associated with the `oldSchema` so it is considered appropriate for the `newSchema`. If the
     * new schema does not contain any properties, then `undefined` is returned to clear all the form data. Due to the
     * nature of schemas, this sanitization happens recursively for nested objects of data. Also, any properties in the
     * old schemas that are non-existent in the new schema are set to `undefined`.
     *
     * @param [newSchema] - The new schema for which the data is being sanitized
     * @param [oldSchema] - The old schema from which the data originated
     * @param [data={}] - The form data associated with the schema, defaulting to an empty object when undefined
     * @returns - The new form data, with all the fields uniquely associated with the old schema set
     *      to `undefined`. Will return `undefined` if the new schema is not an object containing properties.
     */ sanitizeDataForNewSchema(newSchema, oldSchema, data) {
        return (0, _schema.sanitizeDataForNewSchema)(this.validator, this.rootSchema, newSchema, oldSchema, data);
    }
    /** Generates an `IdSchema` object for the `schema`, recursively
     *
     * @param schema - The schema for which the display label flag is desired
     * @param [id] - The base id for the schema
     * @param [formData] - The current formData, if any, onto which to provide any missing defaults
     * @param [idPrefix='root'] - The prefix to use for the id
     * @param [idSeparator='_'] - The separator to use for the path segments in the id
     * @returns - The `IdSchema` object for the `schema`
     */ toIdSchema(schema, id, formData, idPrefix = "root", idSeparator = "_") {
        return (0, _schema.toIdSchema)(this.validator, schema, id, this.rootSchema, formData, idPrefix, idSeparator);
    }
    /** Generates an `PathSchema` object for the `schema`, recursively
     *
     * @param schema - The schema for which the display label flag is desired
     * @param [name] - The base name for the schema
     * @param [formData] - The current formData, if any, onto which to provide any missing defaults
     * @returns - The `PathSchema` object for the `schema`
     */ toPathSchema(schema, name, formData) {
        return (0, _schema.toPathSchema)(this.validator, schema, name, this.rootSchema, formData);
    }
}
function createSchemaUtils(validator, rootSchema, experimental_defaultFormStateBehavior = {}) {
    return new SchemaUtils(validator, rootSchema, experimental_defaultFormStateBehavior);
}

},{"./deepEquals":"aPOCr","./schema":"eCkgn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aPOCr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deepEquals);
var _isEqualWith = require("lodash/isEqualWith");
var _isEqualWithDefault = parcelHelpers.interopDefault(_isEqualWith);
function deepEquals(a, b) {
    return (0, _isEqualWithDefault.default)(a, b, (obj, other)=>{
        if (typeof obj === "function" && typeof other === "function") // Assume all functions are equivalent
        // see https://github.com/rjsf-team/react-jsonschema-form/issues/255
        return true;
        return undefined; // fallback to default isEquals behavior
    });
}

},{"lodash/isEqualWith":"aIz40","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aIz40":[function(require,module,exports) {
var baseIsEqual = require("9aa86f93cc374370");
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == "function" ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
}
module.exports = isEqualWith;

},{"9aa86f93cc374370":"dlEAt"}],"dlEAt":[function(require,module,exports) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"r2v0A","809bbb0c20650dbc":"5TH1N"}],"r2v0A":[function(require,module,exports) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"l4EdS","96bc8a1825db53a5":"bkKEb","8bdece495e87fb69":"9yVQH","bb94920432a68eca":"dyiCQ","45495edff98e5837":"4Ug8n","18256411ae9e2858":"2VsjV","e5ba7abf54247fc5":"kfeDT","50d786bb5c7366af":"hUF8Z"}],"l4EdS":[function(require,module,exports) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"ir7KE","ceda2a63c77c915":"92jMT","91ee1b348d9d7172":"2g39u","3fe28318f65b9332":"92pwm","724ca4def8b84e06":"5tWRo","e9ceacb40d9582bd":"8ZwWL"}],"ir7KE":[function(require,module,exports) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"aBOjQ","b700cb849df2c166":"h9Obe","d76dd90eead6cced":"54rSv","3d210628ba60ec8":"92w7f","76026bf2d4cfff93":"lyKsn"}],"aBOjQ":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"h9Obe":[function(require,module,exports) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"2KENa"}],"2KENa":[function(require,module,exports) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"5Gmi2"}],"5Gmi2":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"54rSv":[function(require,module,exports) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"2KENa"}],"92w7f":[function(require,module,exports) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"2KENa"}],"lyKsn":[function(require,module,exports) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"2KENa"}],"92jMT":[function(require,module,exports) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"ir7KE"}],"2g39u":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"92pwm":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"5tWRo":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"8ZwWL":[function(require,module,exports) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"ir7KE","1494efbafafa9552":"lXR3t","6049e8027fe9407f":"67IRc"}],"lXR3t":[function(require,module,exports) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"ed0752fe9f482107":"g9yTj","29224713b8d411e6":"iGWPT"}],"g9yTj":[function(require,module,exports) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"gWgLs","16db51a0e009bd8c":"d6JxY"}],"gWgLs":[function(require,module,exports) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"i4ymb","cabbc2adfaeb27d9":"g1GOZ","cbb5703fe1562e7f":"3TlAp","388b819f47a43aa5":"cLkAM"}],"i4ymb":[function(require,module,exports) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"fQG2h","3cba3c966459d528":"3TlAp"}],"3TlAp":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"g1GOZ":[function(require,module,exports) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"jCWEv"}],"jCWEv":[function(require,module,exports) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"iGWPT"}],"cLkAM":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"d6JxY":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"67IRc":[function(require,module,exports) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"bZLK5","d2967b0e32ccfa56":"kHXyp","ca21409ea89624c0":"hS1Js","f88fd07f8dd1f67d":"bP5Zp","dbf3eae765642a3b":"6Akd8"}],"bZLK5":[function(require,module,exports) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"8N0eH","a07dcf3fd3097a0c":"ir7KE","92c01c953ef00ded":"lXR3t"}],"8N0eH":[function(require,module,exports) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"3EYtf","bc25d439ccd1fb47":"FE0rA","f096b37295a92ab0":"6U8zb","d88173cbc6a133c8":"ixguK","afb9b3bae0461cbf":"hrsbU"}],"3EYtf":[function(require,module,exports) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"fvAny"}],"fvAny":[function(require,module,exports) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"g9yTj"}],"FE0rA":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"6U8zb":[function(require,module,exports) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"fvAny"}],"ixguK":[function(require,module,exports) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"fvAny"}],"hrsbU":[function(require,module,exports) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"fvAny"}],"kHXyp":[function(require,module,exports) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"63JpK"}],"63JpK":[function(require,module,exports) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"bgeHb"}],"bgeHb":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"hS1Js":[function(require,module,exports) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"63JpK"}],"bP5Zp":[function(require,module,exports) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"63JpK"}],"6Akd8":[function(require,module,exports) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"63JpK"}],"bkKEb":[function(require,module,exports) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"8LOJe","1ee20de911db0cb0":"hq9nh","defff3d81be91b23":"tTji9"}],"8LOJe":[function(require,module,exports) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"67IRc","9a831e81e9a1f98c":"2MVws","1a2b6c8a7399c39f":"1jkgz"}],"2MVws":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"1jkgz":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"hq9nh":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"tTji9":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"9yVQH":[function(require,module,exports) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"e0ngr","dbf6aa5033a0f48":"5fXsE","539966708f906e61":"5Gmi2","8142d4017f0a425f":"bkKEb","48cddf732eff33ba":"fkuVq","9dc78b26c5daba20":"29rq3"}],"5fXsE":[function(require,module,exports) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"iGWPT"}],"fkuVq":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"29rq3":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"dyiCQ":[function(require,module,exports) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"glOnZ"}],"glOnZ":[function(require,module,exports) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"b9Wvk","aa79b69a13f924db":"6Cz6a","e3ad83e53433bc8a":"cu4o9"}],"b9Wvk":[function(require,module,exports) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"gD9AH","148b85918856c33a":"2VsjV"}],"gD9AH":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"2VsjV":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"6Cz6a":[function(require,module,exports) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"hZr2f","6b1c62cea92cdb9":"1ayha"}],"hZr2f":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"1ayha":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"cu4o9":[function(require,module,exports) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"2dYEW","e8453365fdacc8da":"cUzQF","7760b47b02971dfa":"5uWOF"}],"2dYEW":[function(require,module,exports) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"gWKTt","9cdb51ffa56f149b":"asnYU","38cd49f1e493b3d7":"2VsjV","b379831fe1873fed":"kfeDT","f362a34cd8321bb7":"9uPJ6","c019db5297494469":"hUF8Z"}],"gWKTt":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"asnYU":[function(require,module,exports) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"b56e5b7d86069686":"crxEa","bead821d6af018b5":"5TH1N"}],"crxEa":[function(require,module,exports) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"fQG2h","b6cdbe52dcf709f8":"5TH1N"}],"kfeDT":[function(require,module,exports) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"iGWPT","a1e87b138cf75d1d":"9OHNT"}],"9OHNT":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"9uPJ6":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"hUF8Z":[function(require,module,exports) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"9IaoX","903f50eb1c16d257":"993qv","fa49853a82034c30":"ihImP"}],"9IaoX":[function(require,module,exports) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"fQG2h","f661b3a120d7a4cb":"g5LO3","cdd86c83797c0618":"5TH1N"}],"g5LO3":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"993qv":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"ihImP":[function(require,module,exports) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"hw1wy"}],"cUzQF":[function(require,module,exports) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"hcjX5","3ec652610d8dd5d3":"2HmXG"}],"hcjX5":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"2HmXG":[function(require,module,exports) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"5rEQb"}],"5uWOF":[function(require,module,exports) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"i4ymb","f3db08d4d1110aaf":"g5LO3"}],"4Ug8n":[function(require,module,exports) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"lRQg2","28e3344aae951f13":"lXR3t","b286298be5b1d9a4":"gLnFZ","3ae50c158f89813":"9vgKa","9f458755f627d456":"86FKS","8e9160b373d7fe66":"fQG2h","b210627dd951641f":"cLkAM"}],"lRQg2":[function(require,module,exports) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"a6517d0448dad786":"g9yTj","f83c375075418382":"iGWPT"}],"gLnFZ":[function(require,module,exports) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"6940648d854355b5":"g9yTj","a5c6637bac681a0":"iGWPT"}],"9vgKa":[function(require,module,exports) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"56b792d64741a4ff":"g9yTj","ca486d41cdf819d4":"iGWPT"}],"86FKS":[function(require,module,exports) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"4507415bd8810d3c":"g9yTj","7a9a6581834a8452":"iGWPT"}],"eCkgn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultFormState", ()=>(0, _getDefaultFormStateDefault.default));
parcelHelpers.export(exports, "getDisplayLabel", ()=>(0, _getDisplayLabelDefault.default));
parcelHelpers.export(exports, "getClosestMatchingOption", ()=>(0, _getClosestMatchingOptionDefault.default));
parcelHelpers.export(exports, "getFirstMatchingOption", ()=>(0, _getFirstMatchingOptionDefault.default));
parcelHelpers.export(exports, "getMatchingOption", ()=>(0, _getMatchingOptionDefault.default));
parcelHelpers.export(exports, "isFilesArray", ()=>(0, _isFilesArrayDefault.default));
parcelHelpers.export(exports, "isMultiSelect", ()=>(0, _isMultiSelectDefault.default));
parcelHelpers.export(exports, "isSelect", ()=>(0, _isSelectDefault.default));
parcelHelpers.export(exports, "mergeValidationData", ()=>(0, _mergeValidationDataDefault.default));
parcelHelpers.export(exports, "retrieveSchema", ()=>(0, _retrieveSchemaDefault.default));
parcelHelpers.export(exports, "sanitizeDataForNewSchema", ()=>(0, _sanitizeDataForNewSchemaDefault.default));
parcelHelpers.export(exports, "toIdSchema", ()=>(0, _toIdSchemaDefault.default));
parcelHelpers.export(exports, "toPathSchema", ()=>(0, _toPathSchemaDefault.default));
var _getDefaultFormState = require("./getDefaultFormState");
var _getDefaultFormStateDefault = parcelHelpers.interopDefault(_getDefaultFormState);
var _getDisplayLabel = require("./getDisplayLabel");
var _getDisplayLabelDefault = parcelHelpers.interopDefault(_getDisplayLabel);
var _getClosestMatchingOption = require("./getClosestMatchingOption");
var _getClosestMatchingOptionDefault = parcelHelpers.interopDefault(_getClosestMatchingOption);
var _getFirstMatchingOption = require("./getFirstMatchingOption");
var _getFirstMatchingOptionDefault = parcelHelpers.interopDefault(_getFirstMatchingOption);
var _getMatchingOption = require("./getMatchingOption");
var _getMatchingOptionDefault = parcelHelpers.interopDefault(_getMatchingOption);
var _isFilesArray = require("./isFilesArray");
var _isFilesArrayDefault = parcelHelpers.interopDefault(_isFilesArray);
var _isMultiSelect = require("./isMultiSelect");
var _isMultiSelectDefault = parcelHelpers.interopDefault(_isMultiSelect);
var _isSelect = require("./isSelect");
var _isSelectDefault = parcelHelpers.interopDefault(_isSelect);
var _mergeValidationData = require("./mergeValidationData");
var _mergeValidationDataDefault = parcelHelpers.interopDefault(_mergeValidationData);
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
var _sanitizeDataForNewSchema = require("./sanitizeDataForNewSchema");
var _sanitizeDataForNewSchemaDefault = parcelHelpers.interopDefault(_sanitizeDataForNewSchema);
var _toIdSchema = require("./toIdSchema");
var _toIdSchemaDefault = parcelHelpers.interopDefault(_toIdSchema);
var _toPathSchema = require("./toPathSchema");
var _toPathSchemaDefault = parcelHelpers.interopDefault(_toPathSchema);

},{"./getDefaultFormState":"kfSWp","./getDisplayLabel":"kdwtv","./getClosestMatchingOption":"ll5Tj","./getFirstMatchingOption":"2G1kR","./getMatchingOption":"07V0H","./isFilesArray":"gSDmg","./isMultiSelect":"9Mj3e","./isSelect":"40xEi","./mergeValidationData":"cVzXf","./retrieveSchema":"jAKxQ","./sanitizeDataForNewSchema":"hiNFP","./toIdSchema":"ie8gc","./toPathSchema":"b8JdB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kfSWp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdditionalItemsHandling", ()=>AdditionalItemsHandling);
/** Given a `schema` will return an inner schema that for an array item. This is computed differently based on the
 * `additionalItems` enum and the value of `idx`. There are four possible returns:
 * 1. If `idx` is >= 0, then if `schema.items` is an array the `idx`th element of the array is returned if it is a valid
 *    index and not a boolean, otherwise it falls through to 3.
 * 2. If `schema.items` is not an array AND truthy and not a boolean, then `schema.items` is returned since it actually
 *    is a schema, otherwise it falls through to 3.
 * 3. If `additionalItems` is not `AdditionalItemsHandling.Ignore` and `schema.additionalItems` is an object, then
 *    `schema.additionalItems` is returned since it actually is a schema, otherwise it falls through to 4.
 * 4. {} is returned representing an empty schema
 *
 * @param schema - The schema from which to get the particular item
 * @param [additionalItems=AdditionalItemsHandling.Ignore] - How do we want to handle additional items?
 * @param [idx=-1] - Index, if non-negative, will be used to return the idx-th element in a `schema.items` array
 * @returns - The best fit schema object from the `schema` given the `additionalItems` and `idx` modifiers
 */ parcelHelpers.export(exports, "getInnerSchemaForArrayItem", ()=>getInnerSchemaForArrayItem);
/** Computes the defaults for the current `schema` given the `rawFormData` and `parentDefaults` if any. This drills into
 * each level of the schema, recursively, to fill out every level of defaults provided by the schema.
 *
 * @param validator - an implementation of the `ValidatorType` interface that will be used when necessary
 * @param rawSchema - The schema for which the default state is desired
 * @param [props] - Optional props for this function
 * @param [props.parentDefaults] - Any defaults provided by the parent field in the schema
 * @param [props.rootSchema] - The options root schema, used to primarily to look up `$ref`s
 * @param [props.rawFormData] - The current formData, if any, onto which to provide any missing defaults
 * @param [props.includeUndefinedValues=false] - Optional flag, if true, cause undefined values to be added as defaults.
 *          If "excludeObjectChildren", cause undefined values for this object and pass `includeUndefinedValues` as
 *          false when computing defaults for any nested object properties.
 * @param [props._recurseList=[]] - The list of ref names currently being recursed, used to prevent infinite recursion
 * @param [props.experimental_defaultFormStateBehavior] Optional configuration object, if provided, allows users to override default form state behavior
 * @param [props.required] - Optional flag, if true, indicates this schema was required in the parent schema.
 * @returns - The resulting `formData` with all the defaults provided
 */ parcelHelpers.export(exports, "computeDefaults", ()=>computeDefaults);
parcelHelpers.export(exports, "default", ()=>getDefaultFormState);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _constants = require("../constants");
var _findSchemaDefinition = require("../findSchemaDefinition");
var _findSchemaDefinitionDefault = parcelHelpers.interopDefault(_findSchemaDefinition);
var _getClosestMatchingOption = require("./getClosestMatchingOption");
var _getClosestMatchingOptionDefault = parcelHelpers.interopDefault(_getClosestMatchingOption);
var _getDiscriminatorFieldFromSchema = require("../getDiscriminatorFieldFromSchema");
var _getDiscriminatorFieldFromSchemaDefault = parcelHelpers.interopDefault(_getDiscriminatorFieldFromSchema);
var _getSchemaType = require("../getSchemaType");
var _getSchemaTypeDefault = parcelHelpers.interopDefault(_getSchemaType);
var _isObject = require("../isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _isFixedItems = require("../isFixedItems");
var _isFixedItemsDefault = parcelHelpers.interopDefault(_isFixedItems);
var _mergeDefaultsWithFormData = require("../mergeDefaultsWithFormData");
var _mergeDefaultsWithFormDataDefault = parcelHelpers.interopDefault(_mergeDefaultsWithFormData);
var _mergeObjects = require("../mergeObjects");
var _mergeObjectsDefault = parcelHelpers.interopDefault(_mergeObjects);
var _mergeSchemas = require("../mergeSchemas");
var _mergeSchemasDefault = parcelHelpers.interopDefault(_mergeSchemas);
var _isMultiSelect = require("./isMultiSelect");
var _isMultiSelectDefault = parcelHelpers.interopDefault(_isMultiSelect);
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
var AdditionalItemsHandling;
(function(AdditionalItemsHandling) {
    AdditionalItemsHandling[AdditionalItemsHandling["Ignore"] = 0] = "Ignore";
    AdditionalItemsHandling[AdditionalItemsHandling["Invert"] = 1] = "Invert";
    AdditionalItemsHandling[AdditionalItemsHandling["Fallback"] = 2] = "Fallback";
})(AdditionalItemsHandling || (AdditionalItemsHandling = {}));
function getInnerSchemaForArrayItem(schema, additionalItems = AdditionalItemsHandling.Ignore, idx = -1) {
    if (idx >= 0) {
        if (Array.isArray(schema.items) && idx < schema.items.length) {
            const item = schema.items[idx];
            if (typeof item !== "boolean") return item;
        }
    } else if (schema.items && !Array.isArray(schema.items) && typeof schema.items !== "boolean") return schema.items;
    if (additionalItems !== AdditionalItemsHandling.Ignore && (0, _isObjectDefault.default)(schema.additionalItems)) return schema.additionalItems;
    return {};
}
/** Either add `computedDefault` at `key` into `obj` or not add it based on its value, the value of
 * `includeUndefinedValues`, the value of `emptyObjectFields` and if its parent field is required. Generally undefined
 * `computedDefault` values are added only when `includeUndefinedValues` is either true/"excludeObjectChildren". If `
 * includeUndefinedValues` is false and `emptyObjectFields` is not "skipDefaults", then non-undefined and non-empty-object
 * values will be added based on certain conditions.
 *
 * @param obj - The object into which the computed default may be added
 * @param key - The key into the object at which the computed default may be added
 * @param computedDefault - The computed default value that maybe should be added to the obj
 * @param includeUndefinedValues - Optional flag, if true, cause undefined values to be added as defaults.
 *          If "excludeObjectChildren", cause undefined values for this object and pass `includeUndefinedValues` as
 *          false when computing defaults for any nested object properties. If "allowEmptyObject", prevents undefined
 *          values in this object while allow the object itself to be empty and passing `includeUndefinedValues` as
 *          false when computing defaults for any nested object properties.
 * @param isParentRequired - The optional boolean that indicates whether the parent field is required
 * @param requiredFields - The list of fields that are required
 * @param experimental_defaultFormStateBehavior - Optional configuration object, if provided, allows users to override
 *        default form state behavior
 */ function maybeAddDefaultToObject(obj, key, computedDefault, includeUndefinedValues, isParentRequired, requiredFields = [], experimental_defaultFormStateBehavior = {}) {
    const { emptyObjectFields = "populateAllDefaults" } = experimental_defaultFormStateBehavior;
    if (includeUndefinedValues) obj[key] = computedDefault;
    else if (emptyObjectFields !== "skipDefaults") {
        if ((0, _isObjectDefault.default)(computedDefault)) {
            // If isParentRequired is undefined, then we are at the root level of the schema so defer to the requiredness of
            // the field key itself in the `requiredField` list
            const isSelfOrParentRequired = isParentRequired === undefined ? requiredFields.includes(key) : isParentRequired;
            // If emptyObjectFields 'skipEmptyDefaults' store computedDefault if it's a non-empty object(e.g. not {})
            if (emptyObjectFields === "skipEmptyDefaults") {
                if (!(0, _isEmptyDefault.default)(computedDefault)) obj[key] = computedDefault;
            } else if ((!(0, _isEmptyDefault.default)(computedDefault) || requiredFields.includes(key)) && (isSelfOrParentRequired || emptyObjectFields !== "populateRequiredDefaults")) obj[key] = computedDefault;
        } else if (// Store computedDefault if it's a defined primitive (e.g., true) and satisfies certain conditions
        // Condition 1: computedDefault is not undefined
        // Condition 2: If emptyObjectFields is 'populateAllDefaults' or 'skipEmptyDefaults) or if the key is a required field
        computedDefault !== undefined && (emptyObjectFields === "populateAllDefaults" || emptyObjectFields === "skipEmptyDefaults" || requiredFields.includes(key))) obj[key] = computedDefault;
    }
}
function computeDefaults(validator, rawSchema, { parentDefaults, rawFormData, rootSchema = {}, includeUndefinedValues = false, _recurseList = [], experimental_defaultFormStateBehavior, required } = {}) {
    var _a, _b, _c, _d;
    const formData = (0, _isObjectDefault.default)(rawFormData) ? rawFormData : {};
    const schema = (0, _isObjectDefault.default)(rawSchema) ? rawSchema : {};
    // Compute the defaults recursively: give highest priority to deepest nodes.
    let defaults = parentDefaults;
    // If we get a new schema, then we need to recompute defaults again for the new schema found.
    let schemaToCompute = null;
    let updatedRecurseList = _recurseList;
    if ((0, _isObjectDefault.default)(defaults) && (0, _isObjectDefault.default)(schema.default)) // For object defaults, only override parent defaults that are defined in
    // schema.default.
    defaults = (0, _mergeObjectsDefault.default)(defaults, schema.default);
    else if ((0, _constants.DEFAULT_KEY) in schema) defaults = schema.default;
    else if ((0, _constants.REF_KEY) in schema) {
        const refName = schema[0, _constants.REF_KEY];
        // Use referenced schema defaults for this node.
        if (!_recurseList.includes(refName)) {
            updatedRecurseList = _recurseList.concat(refName);
            schemaToCompute = (0, _findSchemaDefinitionDefault.default)(refName, rootSchema);
        }
    } else if ((0, _constants.DEPENDENCIES_KEY) in schema) {
        const resolvedSchema = (0, _retrieveSchema.resolveDependencies)(validator, schema, rootSchema, false, [], formData);
        schemaToCompute = resolvedSchema[0]; // pick the first element from resolve dependencies
    } else if ((0, _isFixedItemsDefault.default)(schema)) defaults = schema.items.map((itemSchema, idx)=>computeDefaults(validator, itemSchema, {
            rootSchema,
            includeUndefinedValues,
            _recurseList,
            experimental_defaultFormStateBehavior,
            parentDefaults: Array.isArray(parentDefaults) ? parentDefaults[idx] : undefined,
            rawFormData: formData,
            required
        }));
    else if ((0, _constants.ONE_OF_KEY) in schema) {
        const { oneOf, ...remaining } = schema;
        if (oneOf.length === 0) return undefined;
        const discriminator = (0, _getDiscriminatorFieldFromSchemaDefault.default)(schema);
        schemaToCompute = oneOf[(0, _getClosestMatchingOptionDefault.default)(validator, rootSchema, (0, _isEmptyDefault.default)(formData) ? undefined : formData, oneOf, 0, discriminator)];
        schemaToCompute = (0, _mergeSchemasDefault.default)(remaining, schemaToCompute);
    } else if ((0, _constants.ANY_OF_KEY) in schema) {
        const { anyOf, ...remaining } = schema;
        if (anyOf.length === 0) return undefined;
        const discriminator = (0, _getDiscriminatorFieldFromSchemaDefault.default)(schema);
        schemaToCompute = anyOf[(0, _getClosestMatchingOptionDefault.default)(validator, rootSchema, (0, _isEmptyDefault.default)(formData) ? undefined : formData, anyOf, 0, discriminator)];
        schemaToCompute = (0, _mergeSchemasDefault.default)(remaining, schemaToCompute);
    }
    if (schemaToCompute) return computeDefaults(validator, schemaToCompute, {
        rootSchema,
        includeUndefinedValues,
        _recurseList: updatedRecurseList,
        experimental_defaultFormStateBehavior,
        parentDefaults: defaults,
        rawFormData: formData,
        required
    });
    // No defaults defined for this node, fallback to generic typed ones.
    if (defaults === undefined) defaults = schema.default;
    switch((0, _getSchemaTypeDefault.default)(schema)){
        // We need to recurse for object schema inner default values.
        case "object":
            {
                // This is a custom addition that fixes this issue:
                // https://github.com/rjsf-team/react-jsonschema-form/issues/3832
                const retrievedSchema = (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.allOf) === "populateDefaults" && (0, _constants.ALL_OF_KEY) in schema ? (0, _retrieveSchemaDefault.default)(validator, schema, rootSchema, formData) : schema;
                const objectDefaults = Object.keys(retrievedSchema.properties || {}).reduce((acc, key)=>{
                    var _a;
                    // Compute the defaults for this node, with the parent defaults we might
                    // have from a previous run: defaults[key].
                    const computedDefault = computeDefaults(validator, (0, _getDefault.default)(retrievedSchema, [
                        (0, _constants.PROPERTIES_KEY),
                        key
                    ]), {
                        rootSchema,
                        _recurseList,
                        experimental_defaultFormStateBehavior,
                        includeUndefinedValues: includeUndefinedValues === true,
                        parentDefaults: (0, _getDefault.default)(defaults, [
                            key
                        ]),
                        rawFormData: (0, _getDefault.default)(formData, [
                            key
                        ]),
                        required: (_a = retrievedSchema.required) === null || _a === void 0 ? void 0 : _a.includes(key)
                    });
                    maybeAddDefaultToObject(acc, key, computedDefault, includeUndefinedValues, required, retrievedSchema.required, experimental_defaultFormStateBehavior);
                    return acc;
                }, {});
                if (retrievedSchema.additionalProperties) {
                    // as per spec additionalProperties may be either schema or boolean
                    const additionalPropertiesSchema = (0, _isObjectDefault.default)(retrievedSchema.additionalProperties) ? retrievedSchema.additionalProperties : {};
                    const keys = new Set();
                    if ((0, _isObjectDefault.default)(defaults)) Object.keys(defaults).filter((key)=>!retrievedSchema.properties || !retrievedSchema.properties[key]).forEach((key)=>keys.add(key));
                    const formDataRequired = [];
                    Object.keys(formData).filter((key)=>!retrievedSchema.properties || !retrievedSchema.properties[key]).forEach((key)=>{
                        keys.add(key);
                        formDataRequired.push(key);
                    });
                    keys.forEach((key)=>{
                        var _a;
                        const computedDefault = computeDefaults(validator, additionalPropertiesSchema, {
                            rootSchema,
                            _recurseList,
                            experimental_defaultFormStateBehavior,
                            includeUndefinedValues: includeUndefinedValues === true,
                            parentDefaults: (0, _getDefault.default)(defaults, [
                                key
                            ]),
                            rawFormData: (0, _getDefault.default)(formData, [
                                key
                            ]),
                            required: (_a = retrievedSchema.required) === null || _a === void 0 ? void 0 : _a.includes(key)
                        });
                        // Since these are additional properties we don't need to add the `experimental_defaultFormStateBehavior` prop
                        maybeAddDefaultToObject(objectDefaults, key, computedDefault, includeUndefinedValues, required, formDataRequired);
                    });
                }
                return objectDefaults;
            }
        case "array":
            {
                const neverPopulate = ((_a = experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) === null || _a === void 0 ? void 0 : _a.populate) === "never";
                const ignoreMinItemsFlagSet = ((_b = experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) === null || _b === void 0 ? void 0 : _b.populate) === "requiredOnly";
                const isSkipEmptyDefaults = (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.emptyObjectFields) === "skipEmptyDefaults";
                const computeSkipPopulate = (_d = (_c = experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) === null || _c === void 0 ? void 0 : _c.computeSkipPopulate) !== null && _d !== void 0 ? _d : ()=>false;
                const emptyDefault = isSkipEmptyDefaults ? undefined : [];
                // Inject defaults into existing array defaults
                if (Array.isArray(defaults)) defaults = defaults.map((item, idx)=>{
                    const schemaItem = getInnerSchemaForArrayItem(schema, AdditionalItemsHandling.Fallback, idx);
                    return computeDefaults(validator, schemaItem, {
                        rootSchema,
                        _recurseList,
                        experimental_defaultFormStateBehavior,
                        parentDefaults: item,
                        required
                    });
                });
                // Deeply inject defaults into already existing form data
                if (Array.isArray(rawFormData)) {
                    const schemaItem = getInnerSchemaForArrayItem(schema);
                    if (neverPopulate) defaults = rawFormData;
                    else defaults = rawFormData.map((item, idx)=>{
                        return computeDefaults(validator, schemaItem, {
                            rootSchema,
                            _recurseList,
                            experimental_defaultFormStateBehavior,
                            rawFormData: item,
                            parentDefaults: (0, _getDefault.default)(defaults, [
                                idx
                            ]),
                            required
                        });
                    });
                }
                if (neverPopulate) return defaults !== null && defaults !== void 0 ? defaults : emptyDefault;
                if (ignoreMinItemsFlagSet && !required) // If no form data exists or defaults are set leave the field empty/non-existent, otherwise
                // return form data/defaults
                return defaults ? defaults : undefined;
                const defaultsLength = Array.isArray(defaults) ? defaults.length : 0;
                if (!schema.minItems || (0, _isMultiSelectDefault.default)(validator, schema, rootSchema) || computeSkipPopulate(validator, schema, rootSchema) || schema.minItems <= defaultsLength) return defaults ? defaults : emptyDefault;
                const defaultEntries = defaults || [];
                const fillerSchema = getInnerSchemaForArrayItem(schema, AdditionalItemsHandling.Invert);
                const fillerDefault = fillerSchema.default;
                // Calculate filler entries for remaining items (minItems - existing raw data/defaults)
                const fillerEntries = new Array(schema.minItems - defaultsLength).fill(computeDefaults(validator, fillerSchema, {
                    parentDefaults: fillerDefault,
                    rootSchema,
                    _recurseList,
                    experimental_defaultFormStateBehavior,
                    required
                }));
                // then fill up the rest with either the item default or empty, up to minItems
                return defaultEntries.concat(fillerEntries);
            }
    }
    return defaults;
}
function getDefaultFormState(validator, theSchema, formData, rootSchema, includeUndefinedValues = false, experimental_defaultFormStateBehavior) {
    if (!(0, _isObjectDefault.default)(theSchema)) throw new Error("Invalid schema: " + theSchema);
    const schema = (0, _retrieveSchemaDefault.default)(validator, theSchema, rootSchema, formData);
    const defaults = computeDefaults(validator, schema, {
        rootSchema,
        includeUndefinedValues,
        experimental_defaultFormStateBehavior,
        rawFormData: formData
    });
    if (formData === undefined || formData === null || typeof formData === "number" && isNaN(formData)) // No form data? Use schema defaults.
    return defaults;
    const { mergeExtraDefaults } = (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) || {};
    if ((0, _isObjectDefault.default)(formData)) return (0, _mergeDefaultsWithFormDataDefault.default)(defaults, formData, mergeExtraDefaults);
    if (Array.isArray(formData)) return (0, _mergeDefaultsWithFormDataDefault.default)(defaults, formData, mergeExtraDefaults);
    return formData;
}

},{"lodash/get":"8z6tS","lodash/isEmpty":"7pljj","../constants":"a1fVD","../findSchemaDefinition":"6Ii9d","./getClosestMatchingOption":"ll5Tj","../getDiscriminatorFieldFromSchema":"guLol","../getSchemaType":"emxZR","../isObject":"fyldM","../isFixedItems":"FI6RK","../mergeDefaultsWithFormData":"lU5Qu","../mergeObjects":"kAdf0","../mergeSchemas":"dXj9f","./isMultiSelect":"9Mj3e","./retrieveSchema":"jAKxQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8z6tS":[function(require,module,exports) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"51EsY"}],"51EsY":[function(require,module,exports) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"Q3Xos","c3296f04fad32769":"e9p91"}],"Q3Xos":[function(require,module,exports) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"2VsjV","e823e604d75f975b":"cGRli","f5fff1c342107fbd":"l2nFh","b04e8cc634273c23":"j8269"}],"cGRli":[function(require,module,exports) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"2VsjV","4cdff6c9e9ff5d38":"3DsXL"}],"3DsXL":[function(require,module,exports) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"fQG2h","74644060ad1a1d3c":"5TH1N"}],"l2nFh":[function(require,module,exports) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"5bPHz"}],"5bPHz":[function(require,module,exports) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"ahhD4"}],"ahhD4":[function(require,module,exports) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"67IRc"}],"j8269":[function(require,module,exports) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"hnBbf"}],"hnBbf":[function(require,module,exports) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"e0ngr","8439a3a1551d0706":"fahvZ","4b12c9f502d3288a":"2VsjV","a0ebd327d618908a":"3DsXL"}],"fahvZ":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"e9p91":[function(require,module,exports) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"3DsXL"}],"7pljj":[function(require,module,exports) {
var baseKeys = require("a008df59f82d2c8f"), getTag = require("d63799a808049d04"), isArguments = require("1f4ee6aee3a7eae0"), isArray = require("b708be4f72c2a706"), isArrayLike = require("ab4b4eaf96f9163a"), isBuffer = require("80b58ade5ee2f70"), isPrototype = require("3a444e8bd8b275f2"), isTypedArray = require("6af418b3352c301b");
/** `Object#toString` result references. */ var mapTag = "[object Map]", setTag = "[object Set]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if (isPrototype(value)) return !baseKeys(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = isEmpty;

},{"a008df59f82d2c8f":"cUzQF","d63799a808049d04":"4Ug8n","1f4ee6aee3a7eae0":"asnYU","b708be4f72c2a706":"2VsjV","ab4b4eaf96f9163a":"5uWOF","80b58ade5ee2f70":"kfeDT","3a444e8bd8b275f2":"hcjX5","6af418b3352c301b":"hUF8Z"}],"6Ii9d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Splits out the value at the `key` in `object` from the `object`, returning an array that contains in the first
 * location, the `object` minus the `key: value` and in the second location the `value`.
 *
 * @param key - The key from the object to extract
 * @param object - The object from which to extract the element
 * @returns - An array with the first value being the object minus the `key` element and the second element being the
 *      value from `object[key]`
 */ parcelHelpers.export(exports, "splitKeyElementFromObject", ()=>splitKeyElementFromObject);
/** Given the name of a `$ref` from within a schema, using the `rootSchema`, recursively look up and return the
 * sub-schema using the path provided by that reference. If `#` is not the first character of the reference, the path
 * does not exist in the schema, or the reference resolves circularly back to itself, then throw an Error.
 * Otherwise return the sub-schema. Also deals with nested `$ref`s in the sub-schema.
 *
 * @param $ref - The ref string for which the schema definition is desired
 * @param [rootSchema={}] - The root schema in which to search for the definition
 * @param recurseList - List of $refs already resolved to prevent recursion
 * @returns - The sub-schema within the `rootSchema` which matches the `$ref` if it exists
 * @throws - Error indicating that no schema for that reference could be resolved
 */ parcelHelpers.export(exports, "findSchemaDefinitionRecursive", ()=>findSchemaDefinitionRecursive);
parcelHelpers.export(exports, "default", ()=>findSchemaDefinition);
var _jsonpointer = require("jsonpointer");
var _jsonpointerDefault = parcelHelpers.interopDefault(_jsonpointer);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _constants = require("./constants");
function splitKeyElementFromObject(key, object) {
    const value = object[key];
    const remaining = (0, _omitDefault.default)(object, [
        key
    ]);
    return [
        remaining,
        value
    ];
}
function findSchemaDefinitionRecursive($ref, rootSchema = {}, recurseList = []) {
    const ref = $ref || "";
    let decodedRef;
    if (ref.startsWith("#")) // Decode URI fragment representation.
    decodedRef = decodeURIComponent(ref.substring(1));
    else throw new Error(`Could not find a definition for ${$ref}.`);
    const current = (0, _jsonpointerDefault.default).get(rootSchema, decodedRef);
    if (current === undefined) throw new Error(`Could not find a definition for ${$ref}.`);
    const nextRef = current[0, _constants.REF_KEY];
    if (nextRef) {
        // Check for circular references.
        if (recurseList.includes(nextRef)) {
            if (recurseList.length === 1) throw new Error(`Definition for ${$ref} is a circular reference`);
            const [firstRef, ...restRefs] = recurseList;
            const circularPath = [
                ...restRefs,
                ref,
                firstRef
            ].join(" -> ");
            throw new Error(`Definition for ${firstRef} contains a circular reference through ${circularPath}`);
        }
        const [remaining, theRef] = splitKeyElementFromObject((0, _constants.REF_KEY), current);
        const subSchema = findSchemaDefinitionRecursive(theRef, rootSchema, [
            ...recurseList,
            ref
        ]);
        if (Object.keys(remaining).length > 0) return {
            ...remaining,
            ...subSchema
        };
        return subSchema;
    }
    return current;
}
function findSchemaDefinition($ref, rootSchema = {}) {
    const recurseList = [];
    return findSchemaDefinitionRecursive($ref, rootSchema, recurseList);
}

},{"jsonpointer":"9DXnq","lodash/omit":"kaoh9","./constants":"a1fVD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9DXnq":[function(require,module,exports) {
var hasExcape = /~/;
var escapeMatcher = /~[01]/g;
function escapeReplacer(m) {
    switch(m){
        case "~1":
            return "/";
        case "~0":
            return "~";
    }
    throw new Error("Invalid tilde escape: " + m);
}
function untilde(str) {
    if (!hasExcape.test(str)) return str;
    return str.replace(escapeMatcher, escapeReplacer);
}
function setter(obj, pointer, value) {
    var part;
    var hasNextPart;
    for(var p = 1, len = pointer.length; p < len;){
        if (pointer[p] === "constructor" || pointer[p] === "prototype" || pointer[p] === "__proto__") return obj;
        part = untilde(pointer[p++]);
        hasNextPart = len > p;
        if (typeof obj[part] === "undefined") {
            // support setting of /-
            if (Array.isArray(obj) && part === "-") part = obj.length;
            // support nested objects/array when setting values
            if (hasNextPart) {
                if (pointer[p] !== "" && pointer[p] < Infinity || pointer[p] === "-") obj[part] = [];
                else obj[part] = {};
            }
        }
        if (!hasNextPart) break;
        obj = obj[part];
    }
    var oldValue = obj[part];
    if (value === undefined) delete obj[part];
    else obj[part] = value;
    return oldValue;
}
function compilePointer(pointer) {
    if (typeof pointer === "string") {
        pointer = pointer.split("/");
        if (pointer[0] === "") return pointer;
        throw new Error("Invalid JSON pointer.");
    } else if (Array.isArray(pointer)) {
        for (const part of pointer){
            if (typeof part !== "string" && typeof part !== "number") throw new Error("Invalid JSON pointer. Must be of type string or number.");
        }
        return pointer;
    }
    throw new Error("Invalid JSON pointer.");
}
function get(obj, pointer) {
    if (typeof obj !== "object") throw new Error("Invalid input object.");
    pointer = compilePointer(pointer);
    var len = pointer.length;
    if (len === 1) return obj;
    for(var p = 1; p < len;){
        obj = obj[untilde(pointer[p++])];
        if (len === p) return obj;
        if (typeof obj !== "object" || obj === null) return undefined;
    }
}
function set(obj, pointer, value) {
    if (typeof obj !== "object") throw new Error("Invalid input object.");
    pointer = compilePointer(pointer);
    if (pointer.length === 0) throw new Error("Invalid JSON pointer for set.");
    return setter(obj, pointer, value);
}
function compile(pointer) {
    var compiled = compilePointer(pointer);
    return {
        get: function(object) {
            return get(object, compiled);
        },
        set: function(object, value) {
            return set(object, compiled, value);
        }
    };
}
exports.get = get;
exports.set = set;
exports.compile = compile;

},{}],"kaoh9":[function(require,module,exports) {
var arrayMap = require("edf8d2f2f36e65cf"), baseClone = require("dd27ddc2340179e5"), baseUnset = require("589767d435c41297"), castPath = require("565c158f6d380e60"), copyObject = require("9b4f3122fc9cc1a6"), customOmitClone = require("1c19467b6c51de37"), flatRest = require("24ab2b6e4b71312a"), getAllKeysIn = require("e20a1a7cbb58999e");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var omit = flatRest(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    copyObject(object, getAllKeysIn(object), result);
    if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
    var length = paths.length;
    while(length--)baseUnset(result, paths[length]);
    return result;
});
module.exports = omit;

},{"edf8d2f2f36e65cf":"fahvZ","dd27ddc2340179e5":"an1MV","589767d435c41297":"27Wat","565c158f6d380e60":"Q3Xos","9b4f3122fc9cc1a6":"d4hzg","1c19467b6c51de37":"6IwDc","24ab2b6e4b71312a":"er0dC","e20a1a7cbb58999e":"7yR5S"}],"an1MV":[function(require,module,exports) {
var Stack = require("c3256a0a192955f9"), arrayEach = require("3a79976eb46af94a"), assignValue = require("bc83a05a4f99d69b"), baseAssign = require("e6b4c3e6c85df6bb"), baseAssignIn = require("f340cc553ba5643c"), cloneBuffer = require("e72e99883a50402d"), copyArray = require("dc840ead07f1054"), copySymbols = require("309288e8ee190af0"), copySymbolsIn = require("687fa30fede0b048"), getAllKeys = require("bb0ba724f98b094d"), getAllKeysIn = require("12bae1dca0e83064"), getTag = require("4c3204eaea28d680"), initCloneArray = require("fd7741200b462cdf"), initCloneByTag = require("f93a1d24ac08e076"), initCloneObject = require("630039e80f692f17"), isArray = require("f37949484ab52dae"), isBuffer = require("ac876cc65d29c86e"), isMap = require("1056c031d98783c0"), isObject = require("1800fb3122907fc2"), isSet = require("31f022f648037bd3"), keys = require("5f3267fbd9848a7d"), keysIn = require("7d3f3bdc4f2e7bb8");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"c3256a0a192955f9":"l4EdS","3a79976eb46af94a":"inYRG","bc83a05a4f99d69b":"9tFgZ","e6b4c3e6c85df6bb":"ajj4d","f340cc553ba5643c":"67pKN","e72e99883a50402d":"36agR","dc840ead07f1054":"7vKch","309288e8ee190af0":"5qpN6","687fa30fede0b048":"6r021","bb0ba724f98b094d":"glOnZ","12bae1dca0e83064":"7yR5S","4c3204eaea28d680":"4Ug8n","fd7741200b462cdf":"cPo3n","f93a1d24ac08e076":"ayIKS","630039e80f692f17":"eUm3n","f37949484ab52dae":"2VsjV","ac876cc65d29c86e":"kfeDT","1056c031d98783c0":"1jnKE","1800fb3122907fc2":"3TlAp","31f022f648037bd3":"jR6kB","5f3267fbd9848a7d":"cu4o9","7d3f3bdc4f2e7bb8":"1kPzt"}],"inYRG":[function(require,module,exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"9tFgZ":[function(require,module,exports) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"4b75V","b62ef95b3cf1cde1":"5Gmi2"}],"4b75V":[function(require,module,exports) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"51SSX"}],"51SSX":[function(require,module,exports) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"g9yTj"}],"ajj4d":[function(require,module,exports) {
var copyObject = require("c7567f70ddd05963"), keys = require("fcf23a0242ef0da9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"c7567f70ddd05963":"d4hzg","fcf23a0242ef0da9":"cu4o9"}],"d4hzg":[function(require,module,exports) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"9tFgZ","9cddf6ac1a092765":"4b75V"}],"67pKN":[function(require,module,exports) {
var copyObject = require("6f2a44bcb454186d"), keysIn = require("7697a1565646c93");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"6f2a44bcb454186d":"d4hzg","7697a1565646c93":"1kPzt"}],"1kPzt":[function(require,module,exports) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"2dYEW","194eb1a802636842":"4Tg9i","ac15afdc3ddd76cd":"5uWOF"}],"4Tg9i":[function(require,module,exports) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"3TlAp","f7d53cd92b2b977b":"hcjX5","c039208a16eb68bd":"krurR"}],"krurR":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"36agR":[function(require,module,exports) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"iGWPT"}],"7vKch":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"5qpN6":[function(require,module,exports) {
var copyObject = require("4cc37626612884ad"), getSymbols = require("39cbde2205d9399c");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"4cc37626612884ad":"d4hzg","39cbde2205d9399c":"6Cz6a"}],"6r021":[function(require,module,exports) {
var copyObject = require("73fd77060a6bfcff"), getSymbolsIn = require("9b660e6b0c20d303");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"73fd77060a6bfcff":"d4hzg","9b660e6b0c20d303":"4719b"}],"4719b":[function(require,module,exports) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"gD9AH","6ccae2aa7cfa3c66":"lvQrI","bdb501682ee9305d":"6Cz6a","7641fe4ae6d2cc96":"1ayha"}],"7yR5S":[function(require,module,exports) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"b9Wvk","feede5d0a2d06427":"4719b","287f70f798405911":"1kPzt"}],"cPo3n":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"ayIKS":[function(require,module,exports) {
var cloneArrayBuffer = require("d24f0b9a34d2e38a"), cloneDataView = require("dbf04edaab2ae376"), cloneRegExp = require("763300f2dd9bdaf3"), cloneSymbol = require("c30e64d90e4b92d1"), cloneTypedArray = require("d1edd8349e9ad54d");
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"d24f0b9a34d2e38a":"1MB0T","dbf04edaab2ae376":"3fsub","763300f2dd9bdaf3":"gLzHu","c30e64d90e4b92d1":"j15fj","d1edd8349e9ad54d":"iCbSW"}],"1MB0T":[function(require,module,exports) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"5fXsE"}],"3fsub":[function(require,module,exports) {
var cloneArrayBuffer = require("55b473c4a5622b5a");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"55b473c4a5622b5a":"1MB0T"}],"gLzHu":[function(require,module,exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"j15fj":[function(require,module,exports) {
var Symbol = require("b88cf659c1f1d984");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"b88cf659c1f1d984":"e0ngr"}],"iCbSW":[function(require,module,exports) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"1MB0T"}],"eUm3n":[function(require,module,exports) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"9zHQ7","8c92276927b7c3e0":"lvQrI","e939f15d7a0f64a5":"hcjX5"}],"9zHQ7":[function(require,module,exports) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"3TlAp"}],"1jnKE":[function(require,module,exports) {
var baseIsMap = require("bcb4b5290583d129"), baseUnary = require("6a7e6b1a2d9fb1d5"), nodeUtil = require("7d4f449dd306450f");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"bcb4b5290583d129":"UJ564","6a7e6b1a2d9fb1d5":"993qv","7d4f449dd306450f":"ihImP"}],"UJ564":[function(require,module,exports) {
var getTag = require("f59b9932854175ea"), isObjectLike = require("88260e33e0003386");
/** `Object#toString` result references. */ var mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"f59b9932854175ea":"4Ug8n","88260e33e0003386":"5TH1N"}],"jR6kB":[function(require,module,exports) {
var baseIsSet = require("efa5963001bed2f4"), baseUnary = require("3cb35dba719c68b1"), nodeUtil = require("7a3e899a332ff7be");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"efa5963001bed2f4":"5xVyE","3cb35dba719c68b1":"993qv","7a3e899a332ff7be":"ihImP"}],"5xVyE":[function(require,module,exports) {
var getTag = require("3451ecb010f954cc"), isObjectLike = require("b6fc875bc5f351c9");
/** `Object#toString` result references. */ var setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"3451ecb010f954cc":"4Ug8n","b6fc875bc5f351c9":"5TH1N"}],"27Wat":[function(require,module,exports) {
var castPath = require("f9ed36b4ad99fc49"), last = require("bbfbe3a50d8efe39"), parent = require("b7b0084465c39aec"), toKey = require("7b9792fcc4179101");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function baseUnset(object, path) {
    path = castPath(path, object);
    object = parent(object, path);
    return object == null || delete object[toKey(last(path))];
}
module.exports = baseUnset;

},{"f9ed36b4ad99fc49":"Q3Xos","bbfbe3a50d8efe39":"5Gv7h","b7b0084465c39aec":"9RpVb","7b9792fcc4179101":"e9p91"}],"5Gv7h":[function(require,module,exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"9RpVb":[function(require,module,exports) {
var baseGet = require("cbcb75b7339c1ad"), baseSlice = require("3443758a32fd0de1");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function parent(object, path) {
    return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}
module.exports = parent;

},{"cbcb75b7339c1ad":"51EsY","3443758a32fd0de1":"5Vnb5"}],"5Vnb5":[function(require,module,exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"6IwDc":[function(require,module,exports) {
var isPlainObject = require("e34ef634df1bf68a");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function customOmitClone(value) {
    return isPlainObject(value) ? undefined : value;
}
module.exports = customOmitClone;

},{"e34ef634df1bf68a":"aYsgZ"}],"er0dC":[function(require,module,exports) {
var flatten = require("199f7cbd69032298"), overRest = require("aa5c38699e42775a"), setToString = require("6a66c8b3fbd122d5");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + "");
}
module.exports = flatRest;

},{"199f7cbd69032298":"cBlpT","aa5c38699e42775a":"atctO","6a66c8b3fbd122d5":"dubzo"}],"cBlpT":[function(require,module,exports) {
var baseFlatten = require("a35d6abfacb4b52b");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
}
module.exports = flatten;

},{"a35d6abfacb4b52b":"9VsYJ"}],"9VsYJ":[function(require,module,exports) {
var arrayPush = require("d752582e5b174691"), isFlattenable = require("ec5f080ebf5764e8");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"d752582e5b174691":"gD9AH","ec5f080ebf5764e8":"bz1Mj"}],"bz1Mj":[function(require,module,exports) {
var Symbol = require("dde07f6ab8ba5eb5"), isArguments = require("ee6f325d7f5309b1"), isArray = require("ff8d93236e335297");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"dde07f6ab8ba5eb5":"e0ngr","ee6f325d7f5309b1":"asnYU","ff8d93236e335297":"2VsjV"}],"atctO":[function(require,module,exports) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"ibr7y"}],"ibr7y":[function(require,module,exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"dubzo":[function(require,module,exports) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"aUcbM","9114f59293388d49":"j9OR0"}],"aUcbM":[function(require,module,exports) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"hrIfL","eff1240bc0447727":"51SSX","b00d1e57326793e1":"71tSl"}],"hrIfL":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"71tSl":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"j9OR0":[function(require,module,exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"ll5Tj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JUNK_OPTION", ()=>JUNK_OPTION);
/** Recursive function that calculates the score of a `formData` against the given `schema`. The computation is fairly
 * simple. Initially the total score is 0. When `schema.properties` object exists, then all the `key/value` pairs within
 * the object are processed as follows after obtaining the formValue from `formData` using the `key`:
 * - If the `value` contains a `$ref`, `calculateIndexScore()` is called recursively with the formValue and the new
 *   schema that is the result of the ref in the schema being resolved and that sub-schema's resulting score is added to
 *   the total.
 * - If the `value` contains a `oneOf` and there is a formValue, then score based on the index returned from calling
 *   `getClosestMatchingOption()` of that oneOf.
 * - If the type of the `value` is 'object', `calculateIndexScore()` is called recursively with the formValue and the
 *   `value` itself as the sub-schema, and the score is added to the total.
 * - If the type of the `value` matches the guessed-type of the `formValue`, the score is incremented by 1, UNLESS the
 *   value has a `default` or `const`. In those case, if the `default` or `const` and the `formValue` match, the score
 *   is incremented by another 1 otherwise it is decremented by 1.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used when necessary
 * @param rootSchema - The root JSON schema of the entire form
 * @param schema - The schema for which the score is being calculated
 * @param formData - The form data associated with the schema, used to calculate the score
 * @returns - The score a schema against the formData
 */ parcelHelpers.export(exports, "calculateIndexScore", ()=>calculateIndexScore);
parcelHelpers.export(exports, "default", ()=>getClosestMatchingOption);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _has = require("lodash/has");
var _hasDefault = parcelHelpers.interopDefault(_has);
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _reduce = require("lodash/reduce");
var _reduceDefault = parcelHelpers.interopDefault(_reduce);
var _times = require("lodash/times");
var _timesDefault = parcelHelpers.interopDefault(_times);
var _getFirstMatchingOption = require("./getFirstMatchingOption");
var _getFirstMatchingOptionDefault = parcelHelpers.interopDefault(_getFirstMatchingOption);
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
var _constants = require("../constants");
var _guessType = require("../guessType");
var _guessTypeDefault = parcelHelpers.interopDefault(_guessType);
var _getDiscriminatorFieldFromSchema = require("../getDiscriminatorFieldFromSchema");
var _getDiscriminatorFieldFromSchemaDefault = parcelHelpers.interopDefault(_getDiscriminatorFieldFromSchema);
var _getOptionMatchingSimpleDiscriminator = require("../getOptionMatchingSimpleDiscriminator");
var _getOptionMatchingSimpleDiscriminatorDefault = parcelHelpers.interopDefault(_getOptionMatchingSimpleDiscriminator);
const JUNK_OPTION = {
    type: "object",
    $id: (0, _constants.JUNK_OPTION_ID),
    properties: {
        __not_really_there__: {
            type: "number"
        }
    }
};
function calculateIndexScore(validator, rootSchema, schema, formData = {}) {
    let totalScore = 0;
    if (schema) {
        if ((0, _isObjectDefault.default)(schema.properties)) totalScore += (0, _reduceDefault.default)(schema.properties, (score, value, key)=>{
            const formValue = (0, _getDefault.default)(formData, key);
            if (typeof value === "boolean") return score;
            if ((0, _hasDefault.default)(value, (0, _constants.REF_KEY))) {
                const newSchema = (0, _retrieveSchemaDefault.default)(validator, value, rootSchema, formValue);
                return score + calculateIndexScore(validator, rootSchema, newSchema, formValue || {});
            }
            if (((0, _hasDefault.default)(value, (0, _constants.ONE_OF_KEY)) || (0, _hasDefault.default)(value, (0, _constants.ANY_OF_KEY))) && formValue) {
                const key = (0, _hasDefault.default)(value, (0, _constants.ONE_OF_KEY)) ? (0, _constants.ONE_OF_KEY) : (0, _constants.ANY_OF_KEY);
                const discriminator = (0, _getDiscriminatorFieldFromSchemaDefault.default)(value);
                return score + getClosestMatchingOption(validator, rootSchema, formValue, (0, _getDefault.default)(value, key), -1, discriminator);
            }
            if (value.type === "object") return score + calculateIndexScore(validator, rootSchema, value, formValue || {});
            if (value.type === (0, _guessTypeDefault.default)(formValue)) {
                // If the types match, then we bump the score by one
                let newScore = score + 1;
                if (value.default) // If the schema contains a readonly default value score the value that matches the default higher and
                // any non-matching value lower
                newScore += formValue === value.default ? 1 : -1;
                else if (value.const) // If the schema contains a const value score the value that matches the default higher and
                // any non-matching value lower
                newScore += formValue === value.const ? 1 : -1;
                // TODO eventually, deal with enums/arrays
                return newScore;
            }
            return score;
        }, 0);
        else if ((0, _isStringDefault.default)(schema.type) && schema.type === (0, _guessTypeDefault.default)(formData)) totalScore += 1;
    }
    return totalScore;
}
function getClosestMatchingOption(validator, rootSchema, formData, options, selectedOption = -1, discriminatorField) {
    // First resolve any refs in the options
    const resolvedOptions = options.map((option)=>{
        return (0, _retrieveSchema.resolveAllReferences)(option, rootSchema, []);
    });
    const simpleDiscriminatorMatch = (0, _getOptionMatchingSimpleDiscriminatorDefault.default)(formData, options, discriminatorField);
    if ((0, _isNumberDefault.default)(simpleDiscriminatorMatch)) return simpleDiscriminatorMatch;
    // Reduce the array of options down to a list of the indexes that are considered matching options
    const allValidIndexes = resolvedOptions.reduce((validList, option, index)=>{
        const testOptions = [
            JUNK_OPTION,
            option
        ];
        const match = (0, _getFirstMatchingOptionDefault.default)(validator, formData, testOptions, rootSchema, discriminatorField);
        // The match is the real option, so add its index to list of valid indexes
        if (match === 1) validList.push(index);
        return validList;
    }, []);
    // There is only one valid index, so return it!
    if (allValidIndexes.length === 1) return allValidIndexes[0];
    if (!allValidIndexes.length) // No indexes were valid, so we'll score all the options, add all the indexes
    (0, _timesDefault.default)(resolvedOptions.length, (i)=>allValidIndexes.push(i));
    const scoreCount = new Set();
    // Score all the options in the list of valid indexes and return the index with the best score
    const { bestIndex } = allValidIndexes.reduce((scoreData, index)=>{
        const { bestScore } = scoreData;
        const option = resolvedOptions[index];
        const score = calculateIndexScore(validator, rootSchema, option, formData);
        scoreCount.add(score);
        if (score > bestScore) return {
            bestIndex: index,
            bestScore: score
        };
        return scoreData;
    }, {
        bestIndex: selectedOption,
        bestScore: 0
    });
    // if all scores are the same go with selectedOption
    if (scoreCount.size === 1 && selectedOption >= 0) return selectedOption;
    return bestIndex;
}

},{"lodash/get":"8z6tS","lodash/has":"7IGwP","lodash/isNumber":"kxW10","lodash/isObject":"3TlAp","lodash/isString":"hjD1s","lodash/reduce":"02DJm","lodash/times":"1Lual","./getFirstMatchingOption":"2G1kR","./retrieveSchema":"jAKxQ","../constants":"a1fVD","../guessType":"aoWoo","../getDiscriminatorFieldFromSchema":"guLol","../getOptionMatchingSimpleDiscriminator":"4VEsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7IGwP":[function(require,module,exports) {
var baseHas = require("adf86b651ea78123"), hasPath = require("d1ab8f0895b2d3d5");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function has(object, path) {
    return object != null && hasPath(object, path, baseHas);
}
module.exports = has;

},{"adf86b651ea78123":"e7zWg","d1ab8f0895b2d3d5":"fgUQM"}],"e7zWg":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHas(object, key) {
    return object != null && hasOwnProperty.call(object, key);
}
module.exports = baseHas;

},{}],"fgUQM":[function(require,module,exports) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"Q3Xos","47ffafdab3ba0d6f":"asnYU","93ebd263ff0131c1":"2VsjV","252ef74480e01958":"9uPJ6","23c2f64e75e90a2":"g5LO3","af5ade297cb685ee":"e9p91"}],"kxW10":[function(require,module,exports) {
var baseGetTag = require("d5df50bb79e32710"), isObjectLike = require("6ae0825ac2dae50f");
/** `Object#toString` result references. */ var numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function isNumber(value) {
    return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
}
module.exports = isNumber;

},{"d5df50bb79e32710":"fQG2h","6ae0825ac2dae50f":"5TH1N"}],"hjD1s":[function(require,module,exports) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"fQG2h","46fdd4d2c5d7b4ab":"2VsjV","36ebbb6a9d8b3fe4":"5TH1N"}],"02DJm":[function(require,module,exports) {
var arrayReduce = require("8772d9c160085222"), baseEach = require("7c156122a905f02e"), baseIteratee = require("288ce78b1e338692"), baseReduce = require("7941e51212237a70"), isArray = require("b7d00545ad8400ba");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function reduce(collection, iteratee, accumulator) {
    var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
    return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}
module.exports = reduce;

},{"8772d9c160085222":"jYE9T","7c156122a905f02e":"ghpxV","288ce78b1e338692":"l2cSI","7941e51212237a70":"bab3Q","b7d00545ad8400ba":"2VsjV"}],"jYE9T":[function(require,module,exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = arrayReduce;

},{}],"ghpxV":[function(require,module,exports) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"jQLMG","f1e3fc84161ef3ec":"iDiyk"}],"jQLMG":[function(require,module,exports) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"5bb9g","1fb77c53defe5720":"cu4o9"}],"5bb9g":[function(require,module,exports) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"j0gVu"}],"j0gVu":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"iDiyk":[function(require,module,exports) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"5uWOF"}],"l2cSI":[function(require,module,exports) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"1axkc","4f010869f7b63154":"4bdBt","28f06147d1eb9502":"71tSl","3c56f88c4debf449":"2VsjV","aee920e0ef5bf111":"hmrRQ"}],"1axkc":[function(require,module,exports) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"iJrlC","89e9034a8071e297":"352C8","782598b150762386":"1bMIB"}],"iJrlC":[function(require,module,exports) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"l4EdS","9003c0cc8ac007b6":"dlEAt"}],"352C8":[function(require,module,exports) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"lmVXb","94ffded3a85af2f6":"cu4o9"}],"lmVXb":[function(require,module,exports) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"3TlAp"}],"1bMIB":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"4bdBt":[function(require,module,exports) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"dlEAt","d5ca180f7d6f956a":"8z6tS","3462bb3f546fa1f7":"8Kjtp","f5fef07966a1c4ee":"cGRli","2a1cd212d48516":"lmVXb","885e72ee7fc6d296":"1bMIB","cd65eaf4a3af29f6":"e9p91"}],"8Kjtp":[function(require,module,exports) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"eYqz9","b0aefd36de99e579":"fgUQM"}],"eYqz9":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"hmrRQ":[function(require,module,exports) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"1XbWK","abf31da39349df22":"2dhqt","a387ef4a4373de2c":"cGRli","9315973458389ae7":"e9p91"}],"1XbWK":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"2dhqt":[function(require,module,exports) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"51EsY"}],"bab3Q":[function(require,module,exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = baseReduce;

},{}],"1Lual":[function(require,module,exports) {
var baseTimes = require("c53ee78be6207d9e"), castFunction = require("ee0d1e8cec6d9709"), toInteger = require("71e7e31e9a6f7634");
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function times(n, iteratee) {
    n = toInteger(n);
    if (n < 1 || n > MAX_SAFE_INTEGER) return [];
    var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
    iteratee = castFunction(iteratee);
    n -= MAX_ARRAY_LENGTH;
    var result = baseTimes(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
module.exports = times;

},{"c53ee78be6207d9e":"gWKTt","ee0d1e8cec6d9709":"6fHR7","71e7e31e9a6f7634":"1UilV"}],"6fHR7":[function(require,module,exports) {
var identity = require("c0eaa1c5ad52cc2f");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == "function" ? value : identity;
}
module.exports = castFunction;

},{"c0eaa1c5ad52cc2f":"71tSl"}],"1UilV":[function(require,module,exports) {
var toFinite = require("e624a4916a3de577");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

},{"e624a4916a3de577":"cFsQz"}],"cFsQz":[function(require,module,exports) {
var toNumber = require("90c5878489629896");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"90c5878489629896":"cxaMo"}],"cxaMo":[function(require,module,exports) {
var baseTrim = require("261e89907fb89d78"), isObject = require("faaa289d287a34a5"), isSymbol = require("47b3bd23f771891");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"261e89907fb89d78":"alvlj","faaa289d287a34a5":"3TlAp","47b3bd23f771891":"3DsXL"}],"alvlj":[function(require,module,exports) {
var trimmedEndIndex = require("985d3c9be7b51937");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
module.exports = baseTrim;

},{"985d3c9be7b51937":"dM3wT"}],"dM3wT":[function(require,module,exports) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"2G1kR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFirstMatchingOption);
var _getMatchingOption = require("./getMatchingOption");
var _getMatchingOptionDefault = parcelHelpers.interopDefault(_getMatchingOption);
function getFirstMatchingOption(validator, formData, options, rootSchema, discriminatorField) {
    return (0, _getMatchingOptionDefault.default)(validator, formData, options, rootSchema, discriminatorField);
}

},{"./getMatchingOption":"07V0H","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"07V0H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMatchingOption);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _has = require("lodash/has");
var _hasDefault = parcelHelpers.interopDefault(_has);
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var _constants = require("../constants");
var _getOptionMatchingSimpleDiscriminator = require("../getOptionMatchingSimpleDiscriminator");
var _getOptionMatchingSimpleDiscriminatorDefault = parcelHelpers.interopDefault(_getOptionMatchingSimpleDiscriminator);
function getMatchingOption(validator, formData, options, rootSchema, discriminatorField) {
    // For performance, skip validating subschemas if formData is undefined. We just
    // want to get the first option in that case.
    if (formData === undefined) return 0;
    const simpleDiscriminatorMatch = (0, _getOptionMatchingSimpleDiscriminatorDefault.default)(formData, options, discriminatorField);
    if ((0, _isNumberDefault.default)(simpleDiscriminatorMatch)) return simpleDiscriminatorMatch;
    for(let i = 0; i < options.length; i++){
        const option = options[i];
        // If we have a discriminator field, then we will use this to make the determination
        if (discriminatorField && (0, _hasDefault.default)(option, [
            (0, _constants.PROPERTIES_KEY),
            discriminatorField
        ])) {
            const value = (0, _getDefault.default)(formData, discriminatorField);
            const discriminator = (0, _getDefault.default)(option, [
                (0, _constants.PROPERTIES_KEY),
                discriminatorField
            ], {});
            if (validator.isValid(discriminator, value, rootSchema)) return i;
        } else if (option[0, _constants.PROPERTIES_KEY]) {
            // If the schema describes an object then we need to add slightly more
            // strict matching to the schema, because unless the schema uses the
            // "requires" keyword, an object will match the schema as long as it
            // doesn't have matching keys with a conflicting type. To do this we use an
            // "anyOf" with an array of requires. This augmentation expresses that the
            // schema should match if any of the keys in the schema are present on the
            // object and pass validation.
            //
            // Create an "anyOf" schema that requires at least one of the keys in the
            // "properties" object
            const requiresAnyOf = {
                anyOf: Object.keys(option[0, _constants.PROPERTIES_KEY]).map((key)=>({
                        required: [
                            key
                        ]
                    }))
            };
            let augmentedSchema;
            // If the "anyOf" keyword already exists, wrap the augmentation in an "allOf"
            if (option.anyOf) {
                // Create a shallow clone of the option
                const { ...shallowClone } = option;
                if (!shallowClone.allOf) shallowClone.allOf = [];
                else // If "allOf" already exists, shallow clone the array
                shallowClone.allOf = shallowClone.allOf.slice();
                shallowClone.allOf.push(requiresAnyOf);
                augmentedSchema = shallowClone;
            } else augmentedSchema = Object.assign({}, option, requiresAnyOf);
            // Remove the "required" field as it's likely that not all fields have
            // been filled in yet, which will mean that the schema is not valid
            delete augmentedSchema.required;
            if (validator.isValid(augmentedSchema, formData, rootSchema)) return i;
        } else if (validator.isValid(option, formData, rootSchema)) return i;
    }
    return 0;
}

},{"lodash/get":"8z6tS","lodash/has":"7IGwP","lodash/isNumber":"kxW10","../constants":"a1fVD","../getOptionMatchingSimpleDiscriminator":"4VEsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4VEsa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOptionMatchingSimpleDiscriminator);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _constants = require("./constants");
function getOptionMatchingSimpleDiscriminator(formData, options, discriminatorField) {
    var _a;
    if (formData && discriminatorField) {
        const value = (0, _getDefault.default)(formData, discriminatorField);
        if (value === undefined) return;
        for(let i = 0; i < options.length; i++){
            const option = options[i];
            const discriminator = (0, _getDefault.default)(option, [
                (0, _constants.PROPERTIES_KEY),
                discriminatorField
            ], {});
            if (discriminator.type === "object" || discriminator.type === "array") continue;
            if (discriminator.const === value) return i;
            if ((_a = discriminator.enum) === null || _a === void 0 ? void 0 : _a.includes(value)) return i;
        }
    }
    return;
}

},{"lodash/get":"8z6tS","./constants":"a1fVD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jAKxQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>retrieveSchema);
/** Resolves a conditional block (if/else/then) by removing the condition and merging the appropriate conditional branch
 * with the rest of the schema. If `expandAllBranches` is true, then the `retrieveSchemaInteral()` results for both
 * conditions will be returned.
 *
 * @param validator - An implementation of the `ValidatorType` interface that is used to detect valid schema conditions
 * @param schema - The schema for which resolving a condition is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and
 *          dependencies as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData to assist retrieving a schema
 * @returns - A list of schemas with the appropriate conditions resolved, possibly with all branches expanded
 */ parcelHelpers.export(exports, "resolveCondition", ()=>resolveCondition);
/** Given a list of lists of allOf, anyOf or oneOf values, create a list of lists of all permutations of the values. The
 * `listOfLists` is expected to be all resolved values of the 1st...nth schemas within an `allOf`, `anyOf` or `oneOf`.
 * From those lists, build a matrix for each `xxxOf` where there is more than one schema for a row in the list of lists.
 *
 * For example:
 * - If there are three xxxOf rows (A, B, C) and they have been resolved such that there is only one A, two B and three
 *   C schemas then:
 *   - The permutation for the first row is `[[A]]`
 *   - The permutations for the second row are `[[A,B1], [A,B2]]`
 *   - The permutations for the third row are `[[A,B1,C1], [A,B1,C2], [A,B1,C3], [A,B2,C1], [A,B2,C2], [A,B2,C3]]`
 *
 * @param listOfLists - The list of lists of elements that represent the allOf, anyOf or oneOf resolved values in order
 * @returns - The list of all permutations of schemas for a set of `xxxOf`s
 */ parcelHelpers.export(exports, "getAllPermutationsOfXxxOf", ()=>getAllPermutationsOfXxxOf);
/** Resolves references and dependencies within a schema and its 'allOf' children. Passes the `expandAllBranches` flag
 * down to the `retrieveSchemaInternal()`, `resolveReference()` and `resolveDependencies()` helper calls. If
 * `expandAllBranches` is true, then all possible dependencies and/or allOf branches are returned.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which resolving a schema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @returns - The list of schemas having its references, dependencies and allOf schemas resolved
 */ parcelHelpers.export(exports, "resolveSchema", ()=>resolveSchema);
/** Resolves all references within a schema and then returns the `retrieveSchemaInternal()` if the resolved schema is
 * actually different than the original. Passes the `expandAllBranches` flag down to the `retrieveSchemaInternal()`
 * helper call.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which resolving a reference is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @returns - The list schemas retrieved after having all references resolved
 */ parcelHelpers.export(exports, "resolveReference", ()=>resolveReference);
/** Resolves all references within the schema itself as well as any of its properties and array items.
 *
 * @param schema - The schema for which resolving all references is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param recurseList - List of $refs already resolved to prevent recursion
 * @returns - given schema will all references resolved or the original schema if no internal `$refs` were resolved
 */ parcelHelpers.export(exports, "resolveAllReferences", ()=>resolveAllReferences);
/** Creates new 'properties' items for each key in the `formData`
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used when necessary
 * @param theSchema - The schema for which the existing additional properties is desired
 * @param [rootSchema] - The root schema, used to primarily to look up `$ref`s * @param validator
 * @param [aFormData] - The current formData, if any, to assist retrieving a schema
 * @returns - The updated schema with additional properties stubbed
 */ parcelHelpers.export(exports, "stubExistingAdditionalProperties", ()=>stubExistingAdditionalProperties);
/** Internal handler that retrieves an expanded schema that has had all of its conditions, additional properties,
 * references and dependencies resolved and merged into the `schema` given a `validator`, `rootSchema` and `rawFormData`
 * that is used to do the potentially recursive resolution. If `expandAllBranches` is true, then all possible branches
 * of the schema and its references, conditions and dependencies are returned.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which retrieving a schema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param [rawFormData] - The current formData, if any, to assist retrieving a schema
 * @param [expandAllBranches=false] - Flag, if true, will return all possible branches of conditions, any/oneOf and
 *          dependencies as a list of schemas
 * @param [recurseList=[]] - The optional, list of recursive references already processed
 * @returns - The schema(s) resulting from having its conditions, additional properties, references and dependencies
 *          resolved. Multiple schemas may be returned if `expandAllBranches` is true.
 */ parcelHelpers.export(exports, "retrieveSchemaInternal", ()=>retrieveSchemaInternal);
/** Resolves an `anyOf` or `oneOf` within a schema (if present) to the list of schemas returned from
 * `retrieveSchemaInternal()` for the best matching option. If `expandAllBranches` is true, then a list of schemas for ALL
 * options are retrieved and returned.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which retrieving a schema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param [rawFormData] - The current formData, if any, to assist retrieving a schema, defaults to an empty object
 * @returns - Either an array containing the best matching option or all options if `expandAllBranches` is true
 */ parcelHelpers.export(exports, "resolveAnyOrOneOfSchemas", ()=>resolveAnyOrOneOfSchemas);
/** Resolves dependencies within a schema and its 'anyOf/oneOf' children. Passes the `expandAllBranches` flag down to
 * the `resolveAnyOrOneOfSchema()` and `processDependencies()` helper calls.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which resolving a dependency is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @returns - The list of schemas with their dependencies resolved
 */ parcelHelpers.export(exports, "resolveDependencies", ()=>resolveDependencies);
/** Processes all the `dependencies` recursively into the list of `resolvedSchema`s as needed. Passes the
 * `expandAllBranches` flag down to the `withDependentSchema()` and the recursive `processDependencies()` helper calls.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param dependencies - The set of dependencies that needs to be processed
 * @param resolvedSchema - The schema for which processing dependencies is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @returns - The schema with the `dependencies` resolved into it
 */ parcelHelpers.export(exports, "processDependencies", ()=>processDependencies);
/** Updates a schema with additionally required properties added
 *
 * @param schema - The schema for which resolving a dependent properties is desired
 * @param [additionallyRequired] - An optional array of additionally required names
 * @returns - The schema with the additional required values merged in
 */ parcelHelpers.export(exports, "withDependentProperties", ()=>withDependentProperties);
/** Merges a dependent schema into the `schema` dealing with oneOfs and references. Passes the `expandAllBranches` flag
 * down to the `retrieveSchemaInternal()`, `resolveReference()` and `withExactlyOneSubschema()` helper calls.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which resolving a dependent schema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param dependencyKey - The key name of the dependency
 * @param dependencyValue - The potentially dependent schema
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData]- The current formData to assist retrieving a schema
 * @returns - The list of schemas with the dependent schema resolved into them
 */ parcelHelpers.export(exports, "withDependentSchema", ()=>withDependentSchema);
/** Returns a list of `schema`s with the best choice from the `oneOf` options merged into it. If `expandAllBranches` is
 * true, then a list of schemas for ALL options are retrieved and returned. Passes the `expandAllBranches` flag down to
 * the `retrieveSchemaInternal()` helper call.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used to validate oneOf options
 * @param schema - The schema for which resolving a oneOf subschema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param dependencyKey - The key name of the oneOf dependency
 * @param oneOf - The list of schemas representing the oneOf options
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData to assist retrieving a schema
 * @returns - Either an array containing the best matching option or all options if `expandAllBranches` is true
 */ parcelHelpers.export(exports, "withExactlyOneSubschema", ()=>withExactlyOneSubschema);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _times = require("lodash/times");
var _timesDefault = parcelHelpers.interopDefault(_times);
var _transform = require("lodash/transform");
var _transformDefault = parcelHelpers.interopDefault(_transform);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _flattenDeep = require("lodash/flattenDeep");
var _flattenDeepDefault = parcelHelpers.interopDefault(_flattenDeep);
var _uniq = require("lodash/uniq");
var _uniqDefault = parcelHelpers.interopDefault(_uniq);
var _jsonSchemaMergeAllof = require("json-schema-merge-allof");
var _jsonSchemaMergeAllofDefault = parcelHelpers.interopDefault(_jsonSchemaMergeAllof);
var _constants = require("../constants");
var _findSchemaDefinition = require("../findSchemaDefinition");
var _findSchemaDefinitionDefault = parcelHelpers.interopDefault(_findSchemaDefinition);
var _getDiscriminatorFieldFromSchema = require("../getDiscriminatorFieldFromSchema");
var _getDiscriminatorFieldFromSchemaDefault = parcelHelpers.interopDefault(_getDiscriminatorFieldFromSchema);
var _guessType = require("../guessType");
var _guessTypeDefault = parcelHelpers.interopDefault(_guessType);
var _isObject = require("../isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _mergeSchemas = require("../mergeSchemas");
var _mergeSchemasDefault = parcelHelpers.interopDefault(_mergeSchemas);
var _getFirstMatchingOption = require("./getFirstMatchingOption");
var _getFirstMatchingOptionDefault = parcelHelpers.interopDefault(_getFirstMatchingOption);
function retrieveSchema(validator, schema, rootSchema = {}, rawFormData) {
    return retrieveSchemaInternal(validator, schema, rootSchema, rawFormData)[0];
}
function resolveCondition(validator, schema, rootSchema, expandAllBranches, recurseList, formData) {
    const { if: expression, then, else: otherwise, ...resolvedSchemaLessConditional } = schema;
    const conditionValue = validator.isValid(expression, formData || {}, rootSchema);
    let resolvedSchemas = [
        resolvedSchemaLessConditional
    ];
    let schemas = [];
    if (expandAllBranches) {
        if (then && typeof then !== "boolean") schemas = schemas.concat(retrieveSchemaInternal(validator, then, rootSchema, formData, expandAllBranches, recurseList));
        if (otherwise && typeof otherwise !== "boolean") schemas = schemas.concat(retrieveSchemaInternal(validator, otherwise, rootSchema, formData, expandAllBranches, recurseList));
    } else {
        const conditionalSchema = conditionValue ? then : otherwise;
        if (conditionalSchema && typeof conditionalSchema !== "boolean") schemas = schemas.concat(retrieveSchemaInternal(validator, conditionalSchema, rootSchema, formData, expandAllBranches, recurseList));
    }
    if (schemas.length) resolvedSchemas = schemas.map((s)=>(0, _mergeSchemasDefault.default)(resolvedSchemaLessConditional, s));
    return resolvedSchemas.flatMap((s)=>retrieveSchemaInternal(validator, s, rootSchema, formData, expandAllBranches, recurseList));
}
function getAllPermutationsOfXxxOf(listOfLists) {
    const allPermutations = listOfLists.reduce((permutations, list)=>{
        // When there are more than one set of schemas for a row, duplicate the set of permutations and add in the values
        if (list.length > 1) return list.flatMap((element)=>(0, _timesDefault.default)(permutations.length, (i)=>[
                    ...permutations[i]
                ].concat(element)));
        // Otherwise just push in the single value into the current set of permutations
        permutations.forEach((permutation)=>permutation.push(list[0]));
        return permutations;
    }, [
        []
    ] // Start with an empty list
    );
    return allPermutations;
}
function resolveSchema(validator, schema, rootSchema, expandAllBranches, recurseList, formData) {
    const updatedSchemas = resolveReference(validator, schema, rootSchema, expandAllBranches, recurseList, formData);
    if (updatedSchemas.length > 1 || updatedSchemas[0] !== schema) // return the updatedSchemas array if it has either multiple schemas within it
    // OR the first schema is not the same as the original schema
    return updatedSchemas;
    if ((0, _constants.DEPENDENCIES_KEY) in schema) {
        const resolvedSchemas = resolveDependencies(validator, schema, rootSchema, expandAllBranches, recurseList, formData);
        return resolvedSchemas.flatMap((s)=>{
            return retrieveSchemaInternal(validator, s, rootSchema, formData, expandAllBranches, recurseList);
        });
    }
    if ((0, _constants.ALL_OF_KEY) in schema && Array.isArray(schema.allOf)) {
        const allOfSchemaElements = schema.allOf.map((allOfSubschema)=>retrieveSchemaInternal(validator, allOfSubschema, rootSchema, formData, expandAllBranches, recurseList));
        const allPermutations = getAllPermutationsOfXxxOf(allOfSchemaElements);
        return allPermutations.map((permutation)=>({
                ...schema,
                allOf: permutation
            }));
    }
    // No $ref or dependencies or allOf attribute was found, returning the original schema.
    return [
        schema
    ];
}
function resolveReference(validator, schema, rootSchema, expandAllBranches, recurseList, formData) {
    const updatedSchema = resolveAllReferences(schema, rootSchema, recurseList);
    if (updatedSchema !== schema) // Only call this if the schema was actually changed by the `resolveAllReferences()` function
    return retrieveSchemaInternal(validator, updatedSchema, rootSchema, formData, expandAllBranches, recurseList);
    return [
        schema
    ];
}
function resolveAllReferences(schema, rootSchema, recurseList) {
    if (!(0, _isObjectDefault.default)(schema)) return schema;
    let resolvedSchema = schema;
    // resolve top level ref
    if ((0, _constants.REF_KEY) in resolvedSchema) {
        const { $ref, ...localSchema } = resolvedSchema;
        // Check for a recursive reference and stop the loop
        if (recurseList.includes($ref)) return resolvedSchema;
        recurseList.push($ref);
        // Retrieve the referenced schema definition.
        const refSchema = (0, _findSchemaDefinitionDefault.default)($ref, rootSchema);
        resolvedSchema = {
            ...refSchema,
            ...localSchema
        };
    }
    if ((0, _constants.PROPERTIES_KEY) in resolvedSchema) {
        const childrenLists = [];
        const updatedProps = (0, _transformDefault.default)(resolvedSchema[0, _constants.PROPERTIES_KEY], (result, value, key)=>{
            const childList = [
                ...recurseList
            ];
            result[key] = resolveAllReferences(value, rootSchema, childList);
            childrenLists.push(childList);
        }, {});
        (0, _mergeDefault.default)(recurseList, (0, _uniqDefault.default)((0, _flattenDeepDefault.default)(childrenLists)));
        resolvedSchema = {
            ...resolvedSchema,
            [(0, _constants.PROPERTIES_KEY)]: updatedProps
        };
    }
    if ((0, _constants.ITEMS_KEY) in resolvedSchema && !Array.isArray(resolvedSchema.items) && typeof resolvedSchema.items !== "boolean") resolvedSchema = {
        ...resolvedSchema,
        items: resolveAllReferences(resolvedSchema.items, rootSchema, recurseList)
    };
    return (0, _isEqualDefault.default)(schema, resolvedSchema) ? schema : resolvedSchema;
}
function stubExistingAdditionalProperties(validator, theSchema, rootSchema, aFormData) {
    // Clone the schema so that we don't ruin the consumer's original
    const schema = {
        ...theSchema,
        properties: {
            ...theSchema.properties
        }
    };
    // make sure formData is an object
    const formData = aFormData && (0, _isObjectDefault.default)(aFormData) ? aFormData : {};
    Object.keys(formData).forEach((key)=>{
        if (key in schema.properties) // No need to stub, our schema already has the property
        return;
        let additionalProperties = {};
        if (typeof schema.additionalProperties !== "boolean") {
            if ((0, _constants.REF_KEY) in schema.additionalProperties) additionalProperties = retrieveSchema(validator, {
                $ref: (0, _getDefault.default)(schema.additionalProperties, [
                    (0, _constants.REF_KEY)
                ])
            }, rootSchema, formData);
            else if ("type" in schema.additionalProperties) additionalProperties = {
                ...schema.additionalProperties
            };
            else if ((0, _constants.ANY_OF_KEY) in schema.additionalProperties || (0, _constants.ONE_OF_KEY) in schema.additionalProperties) additionalProperties = {
                type: "object",
                ...schema.additionalProperties
            };
            else additionalProperties = {
                type: (0, _guessTypeDefault.default)((0, _getDefault.default)(formData, [
                    key
                ]))
            };
        } else additionalProperties = {
            type: (0, _guessTypeDefault.default)((0, _getDefault.default)(formData, [
                key
            ]))
        };
        // The type of our new key should match the additionalProperties value;
        schema.properties[key] = additionalProperties;
        // Set our additional property flag so we know it was dynamically added
        (0, _setDefault.default)(schema.properties, [
            key,
            (0, _constants.ADDITIONAL_PROPERTY_FLAG)
        ], true);
    });
    return schema;
}
function retrieveSchemaInternal(validator, schema, rootSchema, rawFormData, expandAllBranches = false, recurseList = []) {
    if (!(0, _isObjectDefault.default)(schema)) return [
        {}
    ];
    const resolvedSchemas = resolveSchema(validator, schema, rootSchema, expandAllBranches, recurseList, rawFormData);
    return resolvedSchemas.flatMap((s)=>{
        let resolvedSchema = s;
        if ((0, _constants.IF_KEY) in resolvedSchema) return resolveCondition(validator, resolvedSchema, rootSchema, expandAllBranches, recurseList, rawFormData);
        if ((0, _constants.ALL_OF_KEY) in resolvedSchema) {
            // resolve allOf schemas
            if (expandAllBranches) {
                const { allOf, ...restOfSchema } = resolvedSchema;
                return [
                    ...allOf,
                    restOfSchema
                ];
            }
            try {
                resolvedSchema = (0, _jsonSchemaMergeAllofDefault.default)(resolvedSchema, {
                    deep: false
                });
            } catch (e) {
                console.warn("could not merge subschemas in allOf:\n", e);
                const { allOf, ...resolvedSchemaWithoutAllOf } = resolvedSchema;
                return resolvedSchemaWithoutAllOf;
            }
        }
        const hasAdditionalProperties = (0, _constants.ADDITIONAL_PROPERTIES_KEY) in resolvedSchema && resolvedSchema.additionalProperties !== false;
        if (hasAdditionalProperties) return stubExistingAdditionalProperties(validator, resolvedSchema, rootSchema, rawFormData);
        return resolvedSchema;
    });
}
function resolveAnyOrOneOfSchemas(validator, schema, rootSchema, expandAllBranches, rawFormData) {
    let anyOrOneOf;
    const { oneOf, anyOf, ...remaining } = schema;
    if (Array.isArray(oneOf)) anyOrOneOf = oneOf;
    else if (Array.isArray(anyOf)) anyOrOneOf = anyOf;
    if (anyOrOneOf) {
        // Ensure that during expand all branches we pass an object rather than undefined so that all options are interrogated
        const formData = rawFormData === undefined && expandAllBranches ? {} : rawFormData;
        const discriminator = (0, _getDiscriminatorFieldFromSchemaDefault.default)(schema);
        anyOrOneOf = anyOrOneOf.map((s)=>{
            // Due to anyOf/oneOf possibly using the same $ref we always pass a fresh recurse list array so that each option
            // can resolve recursive references independently
            return resolveAllReferences(s, rootSchema, []);
        });
        // Call this to trigger the set of isValid() calls that the schema parser will need
        const option = (0, _getFirstMatchingOptionDefault.default)(validator, formData, anyOrOneOf, rootSchema, discriminator);
        if (expandAllBranches) return anyOrOneOf.map((item)=>(0, _mergeSchemasDefault.default)(remaining, item));
        schema = (0, _mergeSchemasDefault.default)(remaining, anyOrOneOf[option]);
    }
    return [
        schema
    ];
}
function resolveDependencies(validator, schema, rootSchema, expandAllBranches, recurseList, formData) {
    // Drop the dependencies from the source schema.
    const { dependencies, ...remainingSchema } = schema;
    const resolvedSchemas = resolveAnyOrOneOfSchemas(validator, remainingSchema, rootSchema, expandAllBranches, formData);
    return resolvedSchemas.flatMap((resolvedSchema)=>processDependencies(validator, dependencies, resolvedSchema, rootSchema, expandAllBranches, recurseList, formData));
}
function processDependencies(validator, dependencies, resolvedSchema, rootSchema, expandAllBranches, recurseList, formData) {
    let schemas = [
        resolvedSchema
    ];
    // Process dependencies updating the local schema properties as appropriate.
    for(const dependencyKey in dependencies){
        // Skip this dependency if its trigger property is not present.
        if (!expandAllBranches && (0, _getDefault.default)(formData, [
            dependencyKey
        ]) === undefined) continue;
        // Skip this dependency if it is not included in the schema (such as when dependencyKey is itself a hidden dependency.)
        if (resolvedSchema.properties && !(dependencyKey in resolvedSchema.properties)) continue;
        const [remainingDependencies, dependencyValue] = (0, _findSchemaDefinition.splitKeyElementFromObject)(dependencyKey, dependencies);
        if (Array.isArray(dependencyValue)) schemas[0] = withDependentProperties(resolvedSchema, dependencyValue);
        else if ((0, _isObjectDefault.default)(dependencyValue)) schemas = withDependentSchema(validator, resolvedSchema, rootSchema, dependencyKey, dependencyValue, expandAllBranches, recurseList, formData);
        return schemas.flatMap((schema)=>processDependencies(validator, remainingDependencies, schema, rootSchema, expandAllBranches, recurseList, formData));
    }
    return schemas;
}
function withDependentProperties(schema, additionallyRequired) {
    if (!additionallyRequired) return schema;
    const required = Array.isArray(schema.required) ? Array.from(new Set([
        ...schema.required,
        ...additionallyRequired
    ])) : additionallyRequired;
    return {
        ...schema,
        required: required
    };
}
function withDependentSchema(validator, schema, rootSchema, dependencyKey, dependencyValue, expandAllBranches, recurseList, formData) {
    const dependentSchemas = retrieveSchemaInternal(validator, dependencyValue, rootSchema, formData, expandAllBranches, recurseList);
    return dependentSchemas.flatMap((dependent)=>{
        const { oneOf, ...dependentSchema } = dependent;
        schema = (0, _mergeSchemasDefault.default)(schema, dependentSchema);
        // Since it does not contain oneOf, we return the original schema.
        if (oneOf === undefined) return schema;
        // Resolve $refs inside oneOf.
        const resolvedOneOfs = oneOf.map((subschema)=>{
            if (typeof subschema === "boolean" || !((0, _constants.REF_KEY) in subschema)) return [
                subschema
            ];
            return resolveReference(validator, subschema, rootSchema, expandAllBranches, recurseList, formData);
        });
        const allPermutations = getAllPermutationsOfXxxOf(resolvedOneOfs);
        return allPermutations.flatMap((resolvedOneOf)=>withExactlyOneSubschema(validator, schema, rootSchema, dependencyKey, resolvedOneOf, expandAllBranches, recurseList, formData));
    });
}
function withExactlyOneSubschema(validator, schema, rootSchema, dependencyKey, oneOf, expandAllBranches, recurseList, formData) {
    const validSubschemas = oneOf.filter((subschema)=>{
        if (typeof subschema === "boolean" || !subschema || !subschema.properties) return false;
        const { [dependencyKey]: conditionPropertySchema } = subschema.properties;
        if (conditionPropertySchema) {
            const conditionSchema = {
                type: "object",
                properties: {
                    [dependencyKey]: conditionPropertySchema
                }
            };
            return validator.isValid(conditionSchema, formData, rootSchema) || expandAllBranches;
        }
        return false;
    });
    if (!expandAllBranches && validSubschemas.length !== 1) {
        console.warn("ignoring oneOf in dependencies because there isn't exactly one subschema that is valid");
        return [
            schema
        ];
    }
    return validSubschemas.flatMap((s)=>{
        const subschema = s;
        const [dependentSubschema] = (0, _findSchemaDefinition.splitKeyElementFromObject)(dependencyKey, subschema.properties);
        const dependentSchema = {
            ...subschema,
            properties: dependentSubschema
        };
        const schemas = retrieveSchemaInternal(validator, dependentSchema, rootSchema, formData, expandAllBranches, recurseList);
        return schemas.map((s)=>(0, _mergeSchemasDefault.default)(schema, s));
    });
}

},{"lodash/get":"8z6tS","lodash/isEqual":"64pmh","lodash/set":"dUuaa","lodash/times":"1Lual","lodash/transform":"e1NDM","lodash/merge":"68Goo","lodash/flattenDeep":"9LFpg","lodash/uniq":"z30nX","json-schema-merge-allof":"6jCao","../constants":"a1fVD","../findSchemaDefinition":"6Ii9d","../getDiscriminatorFieldFromSchema":"guLol","../guessType":"aoWoo","../isObject":"fyldM","../mergeSchemas":"dXj9f","./getFirstMatchingOption":"2G1kR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"64pmh":[function(require,module,exports) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"dlEAt"}],"dUuaa":[function(require,module,exports) {
var baseSet = require("a003324b62105673");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function set(object, path, value) {
    return object == null ? object : baseSet(object, path, value);
}
module.exports = set;

},{"a003324b62105673":"k40cK"}],"k40cK":[function(require,module,exports) {
var assignValue = require("a01f3b7ce097c710"), castPath = require("56e0b8a492d56399"), isIndex = require("d1eb8acc5a65dc38"), isObject = require("dfb182b16ef275c0"), toKey = require("6a51dc787ca5b6e3");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"a01f3b7ce097c710":"9tFgZ","56e0b8a492d56399":"Q3Xos","d1eb8acc5a65dc38":"9uPJ6","dfb182b16ef275c0":"3TlAp","6a51dc787ca5b6e3":"e9p91"}],"e1NDM":[function(require,module,exports) {
var arrayEach = require("d57417dcea9d94ef"), baseCreate = require("ae8b9c2d0de74697"), baseForOwn = require("e8007e2f3ceb005"), baseIteratee = require("476d1d83c8d574f1"), getPrototype = require("acfb4accdf68465"), isArray = require("88449cb98c9006a6"), isBuffer = require("7c5216b8ad5bca12"), isFunction = require("476eb3f3ee868a2c"), isObject = require("500add944347d34f"), isTypedArray = require("f3f8e3916066083f");
/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function transform(object, iteratee, accumulator) {
    var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
    iteratee = baseIteratee(iteratee, 4);
    if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) accumulator = isArr ? new Ctor : [];
        else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        else accumulator = {};
    }
    (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
    });
    return accumulator;
}
module.exports = transform;

},{"d57417dcea9d94ef":"inYRG","ae8b9c2d0de74697":"9zHQ7","e8007e2f3ceb005":"jQLMG","476d1d83c8d574f1":"l2cSI","acfb4accdf68465":"lvQrI","88449cb98c9006a6":"2VsjV","7c5216b8ad5bca12":"kfeDT","476eb3f3ee868a2c":"i4ymb","500add944347d34f":"3TlAp","f3f8e3916066083f":"hUF8Z"}],"68Goo":[function(require,module,exports) {
var baseMerge = require("7b601c4be119b25d"), createAssigner = require("e87a09d93c0fc32d");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;

},{"7b601c4be119b25d":"fmzk3","e87a09d93c0fc32d":"6yvTP"}],"fmzk3":[function(require,module,exports) {
var Stack = require("49ff021be75c93ea"), assignMergeValue = require("76e9fd6386317324"), baseFor = require("e7dca58bcfe9c669"), baseMergeDeep = require("4ea46d88599071ec"), isObject = require("c52c932be04280cc"), keysIn = require("27adf66142f57b4b"), safeGet = require("564385b2292facea");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"49ff021be75c93ea":"l4EdS","76e9fd6386317324":"aiqBb","e7dca58bcfe9c669":"5bb9g","4ea46d88599071ec":"9D0e6","c52c932be04280cc":"3TlAp","27adf66142f57b4b":"1kPzt","564385b2292facea":"82z3k"}],"aiqBb":[function(require,module,exports) {
var baseAssignValue = require("30a6c72f04f5134"), eq = require("7d9c95e1ffdd4f16");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"30a6c72f04f5134":"4b75V","7d9c95e1ffdd4f16":"5Gmi2"}],"9D0e6":[function(require,module,exports) {
var assignMergeValue = require("4af3e5b0ee4c14f6"), cloneBuffer = require("ec8e1b90277c5e12"), cloneTypedArray = require("4b1a2b5090faf247"), copyArray = require("d7675bdf0a02bffc"), initCloneObject = require("1067a6f3f6bd5986"), isArguments = require("2238139506f6727b"), isArray = require("290c774b41e416bb"), isArrayLikeObject = require("f481819c40e5b527"), isBuffer = require("6532fda6a198015f"), isFunction = require("7f306c94b573f977"), isObject = require("32c89e763261c579"), isPlainObject = require("ff359d315efefc4f"), isTypedArray = require("61ce92c01fd411fe"), safeGet = require("abfa8f7e72201edb"), toPlainObject = require("c54d414b219fa287");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"4af3e5b0ee4c14f6":"aiqBb","ec8e1b90277c5e12":"36agR","4b1a2b5090faf247":"iCbSW","d7675bdf0a02bffc":"7vKch","1067a6f3f6bd5986":"eUm3n","2238139506f6727b":"asnYU","290c774b41e416bb":"2VsjV","f481819c40e5b527":"hn1J7","6532fda6a198015f":"kfeDT","7f306c94b573f977":"i4ymb","32c89e763261c579":"3TlAp","ff359d315efefc4f":"aYsgZ","61ce92c01fd411fe":"hUF8Z","abfa8f7e72201edb":"82z3k","c54d414b219fa287":"d7D9A"}],"hn1J7":[function(require,module,exports) {
var isArrayLike = require("9ce7efb3ed8cb283"), isObjectLike = require("639a4883b097af28");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"9ce7efb3ed8cb283":"5uWOF","639a4883b097af28":"5TH1N"}],"82z3k":[function(require,module,exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = safeGet;

},{}],"d7D9A":[function(require,module,exports) {
var copyObject = require("6377e94c7c46b197"), keysIn = require("437a3e3814017158");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"6377e94c7c46b197":"d4hzg","437a3e3814017158":"1kPzt"}],"6yvTP":[function(require,module,exports) {
var baseRest = require("b91f3c8e236f389b"), isIterateeCall = require("4f5832110eba92d3");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"b91f3c8e236f389b":"9p3xS","4f5832110eba92d3":"hr6A6"}],"9p3xS":[function(require,module,exports) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"71tSl","ff7d23ff2a2ea6f8":"atctO","a11d545e809d14f7":"dubzo"}],"hr6A6":[function(require,module,exports) {
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"a8ec2a011d2eca69":"5Gmi2","616bc732534dffe0":"5uWOF","e781332a36d1bd7":"9uPJ6","c8548bf6929b8a5d":"3TlAp"}],"9LFpg":[function(require,module,exports) {
var baseFlatten = require("57782bd3a8a372a0");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, INFINITY) : [];
}
module.exports = flattenDeep;

},{"57782bd3a8a372a0":"9VsYJ"}],"z30nX":[function(require,module,exports) {
var baseUniq = require("8e268641906a92b2");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function uniq(array) {
    return array && array.length ? baseUniq(array) : [];
}
module.exports = uniq;

},{"8e268641906a92b2":"gPtnc"}],"gPtnc":[function(require,module,exports) {
var SetCache = require("56c8470806d11628"), arrayIncludes = require("a1d85be956e037a9"), arrayIncludesWith = require("8cd18f86a4a2c118"), cacheHas = require("3acf9f4a3a78c511"), createSet = require("19b77385b4f7775a"), setToArray = require("4568580f7416eb83");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseUniq;

},{"56c8470806d11628":"8LOJe","a1d85be956e037a9":"894B4","8cd18f86a4a2c118":"7U6V2","3acf9f4a3a78c511":"tTji9","19b77385b4f7775a":"b31ml","4568580f7416eb83":"29rq3"}],"894B4":[function(require,module,exports) {
var baseIndexOf = require("277b2d1a618f2b2f");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
module.exports = arrayIncludes;

},{"277b2d1a618f2b2f":"b5Lpi"}],"b5Lpi":[function(require,module,exports) {
var baseFindIndex = require("badcebec79c8cd4"), baseIsNaN = require("c991ed2b82d165b"), strictIndexOf = require("c0bb8190b05a00a5");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"badcebec79c8cd4":"bwy2b","c991ed2b82d165b":"76EiO","c0bb8190b05a00a5":"3vTtq"}],"bwy2b":[function(require,module,exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"76EiO":[function(require,module,exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"3vTtq":[function(require,module,exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"7U6V2":[function(require,module,exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = arrayIncludesWith;

},{}],"b31ml":[function(require,module,exports) {
var Set = require("17777365baf8e16"), noop = require("a02c367b3608ccee"), setToArray = require("cd8d0af6a14b2f7d");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
module.exports = createSet;

},{"17777365baf8e16":"9vgKa","a02c367b3608ccee":"8qs1l","cd8d0af6a14b2f7d":"29rq3"}],"8qs1l":[function(require,module,exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"6jCao":[function(require,module,exports) {
const cloneDeep = require("eaede3ab6d27e129");
const compare = require("1a2afe8d0c610fb0");
const computeLcm = require("442e4feed98e459");
const defaultsDeep = require("e25f416854cb8173");
const flatten = require("ac7f62997984c20c");
const flattenDeep = require("88b49ca963adb703");
const intersection = require("6c293d3bddf92666");
const intersectionWith = require("7ea3115b810a7014");
const isEqual = require("4d5667d6f26039ba");
const isPlainObject = require("fbc0c1d2257f94b");
const pullAll = require("838199c0d6d6c4e5");
const sortBy = require("33f995abdc38f788");
const uniq = require("71ac4cce2884b18c");
const uniqWith = require("c445257c25fff161");
const propertiesResolver = require("94c0843ee6bd2bdc");
const itemsResolver = require("35db618df5ee8d2e");
const contains = (arr, val)=>arr.indexOf(val) !== -1;
const isSchema = (val)=>isPlainObject(val) || val === true || val === false;
const isFalse = (val)=>val === false;
const isTrue = (val)=>val === true;
const schemaResolver = (compacted, key, mergeSchemas)=>mergeSchemas(compacted);
const stringArray = (values)=>sortBy(uniq(flattenDeep(values)));
const notUndefined = (val)=>val !== undefined;
const allUniqueKeys = (arr)=>uniq(flattenDeep(arr.map(keys)));
// resolvers
const first = (compacted)=>compacted[0];
const required = (compacted)=>stringArray(compacted);
const maximumValue = (compacted)=>Math.max.apply(Math, compacted);
const minimumValue = (compacted)=>Math.min.apply(Math, compacted);
const uniqueItems = (compacted)=>compacted.some(isTrue);
const examples = (compacted)=>uniqWith(flatten(compacted), isEqual);
function compareProp(key) {
    return function(a, b) {
        return compare({
            [key]: a
        }, {
            [key]: b
        });
    };
}
function getAllOf(schema) {
    let { allOf = [], ...copy } = schema;
    copy = isPlainObject(schema) ? copy : schema // if schema is boolean
    ;
    return [
        copy,
        ...allOf.map(getAllOf)
    ];
}
function getValues(schemas, key) {
    return schemas.map((schema)=>schema && schema[key]);
}
function tryMergeSchemaGroups(schemaGroups, mergeSchemas) {
    return schemaGroups.map(function(schemas, index) {
        try {
            return mergeSchemas(schemas, index);
        } catch (e) {
            return undefined;
        }
    }).filter(notUndefined);
}
function keys(obj) {
    if (isPlainObject(obj) || Array.isArray(obj)) return Object.keys(obj);
    else return [];
}
function getAnyOfCombinations(arrOfArrays, combinations) {
    combinations = combinations || [];
    if (!arrOfArrays.length) return combinations;
    const values = arrOfArrays.slice(0).shift();
    const rest = arrOfArrays.slice(1);
    if (combinations.length) return getAnyOfCombinations(rest, flatten(combinations.map((combination)=>values.map((item)=>[
                item
            ].concat(combination)))));
    return getAnyOfCombinations(rest, values.map((item)=>item));
}
function throwIncompatible(values, paths) {
    let asJSON;
    try {
        asJSON = values.map(function(val) {
            return JSON.stringify(val, null, 2);
        }).join("\n");
    } catch (variable) {
        asJSON = values.join(", ");
    }
    throw new Error('Could not resolve values for path:"' + paths.join(".") + '". They are probably incompatible. Values: \n' + asJSON);
}
function callGroupResolver(complexKeywords, resolverName, schemas, mergeSchemas, options, parents) {
    if (complexKeywords.length) {
        const resolverConfig = options.complexResolvers[resolverName];
        if (!resolverConfig || !resolverConfig.resolver) throw new Error("No resolver found for " + resolverName);
        // extract all keywords from all the schemas that have one or more
        // then remove all undefined ones and not unique
        const extractedKeywordsOnly = schemas.map((schema)=>complexKeywords.reduce((all, key)=>{
                if (schema[key] !== undefined) all[key] = schema[key];
                return all;
            }, {}));
        const unique = uniqWith(extractedKeywordsOnly, compare);
        // create mergers that automatically add the path of the keyword for use in the complex resolver
        const mergers = resolverConfig.keywords.reduce((all, key)=>({
                ...all,
                [key]: (schemas, extraKey = [])=>mergeSchemas(schemas, null, parents.concat(key, extraKey))
            }), {});
        const result = resolverConfig.resolver(unique, parents.concat(resolverName), mergers, options);
        if (!isPlainObject(result)) throwIncompatible(unique, parents.concat(resolverName));
        return result;
    }
}
function createRequiredMetaArray(arr) {
    return {
        required: arr
    };
}
const schemaGroupProps = [
    "properties",
    "patternProperties",
    "definitions",
    "dependencies"
];
const schemaArrays = [
    "anyOf",
    "oneOf"
];
const schemaProps = [
    "additionalProperties",
    "additionalItems",
    "contains",
    "propertyNames",
    "not",
    "items"
];
const defaultResolvers = {
    type (compacted) {
        if (compacted.some(Array.isArray)) {
            const normalized = compacted.map(function(val) {
                return Array.isArray(val) ? val : [
                    val
                ];
            });
            const common = intersection.apply(null, normalized);
            if (common.length === 1) return common[0];
            else if (common.length > 1) return uniq(common);
        }
    },
    dependencies (compacted, paths, mergeSchemas) {
        const allChildren = allUniqueKeys(compacted);
        return allChildren.reduce(function(all, childKey) {
            const childSchemas = getValues(compacted, childKey);
            let innerCompacted = uniqWith(childSchemas.filter(notUndefined), isEqual);
            // to support dependencies
            const innerArrays = innerCompacted.filter(Array.isArray);
            if (innerArrays.length) {
                if (innerArrays.length === innerCompacted.length) all[childKey] = stringArray(innerCompacted);
                else {
                    const innerSchemas = innerCompacted.filter(isSchema);
                    const arrayMetaScheams = innerArrays.map(createRequiredMetaArray);
                    all[childKey] = mergeSchemas(innerSchemas.concat(arrayMetaScheams), childKey);
                }
                return all;
            }
            innerCompacted = uniqWith(innerCompacted, compare);
            all[childKey] = mergeSchemas(innerCompacted, childKey);
            return all;
        }, {});
    },
    oneOf (compacted, paths, mergeSchemas) {
        const combinations = getAnyOfCombinations(cloneDeep(compacted));
        const result = tryMergeSchemaGroups(combinations, mergeSchemas);
        const unique = uniqWith(result, compare);
        if (unique.length) return unique;
    },
    not (compacted) {
        return {
            anyOf: compacted
        };
    },
    pattern (compacted) {
        return compacted.map((r)=>"(?=" + r + ")").join("");
    },
    multipleOf (compacted) {
        let integers = compacted.slice(0);
        let factor = 1;
        while(integers.some((n)=>!Number.isInteger(n))){
            integers = integers.map((n)=>n * 10);
            factor = factor * 10;
        }
        return computeLcm(integers) / factor;
    },
    enum (compacted) {
        const enums = intersectionWith.apply(null, compacted.concat(isEqual));
        if (enums.length) return sortBy(enums);
    }
};
defaultResolvers.$id = first;
defaultResolvers.$ref = first;
defaultResolvers.$schema = first;
defaultResolvers.additionalItems = schemaResolver;
defaultResolvers.additionalProperties = schemaResolver;
defaultResolvers.anyOf = defaultResolvers.oneOf;
defaultResolvers.contains = schemaResolver;
defaultResolvers.default = first;
defaultResolvers.definitions = defaultResolvers.dependencies;
defaultResolvers.description = first;
defaultResolvers.examples = examples;
defaultResolvers.exclusiveMaximum = minimumValue;
defaultResolvers.exclusiveMinimum = maximumValue;
defaultResolvers.items = itemsResolver;
defaultResolvers.maximum = minimumValue;
defaultResolvers.maxItems = minimumValue;
defaultResolvers.maxLength = minimumValue;
defaultResolvers.maxProperties = minimumValue;
defaultResolvers.minimum = maximumValue;
defaultResolvers.minItems = maximumValue;
defaultResolvers.minLength = maximumValue;
defaultResolvers.minProperties = maximumValue;
defaultResolvers.properties = propertiesResolver;
defaultResolvers.propertyNames = schemaResolver;
defaultResolvers.required = required;
defaultResolvers.title = first;
defaultResolvers.uniqueItems = uniqueItems;
const defaultComplexResolvers = {
    properties: propertiesResolver,
    items: itemsResolver
};
function merger(rootSchema, options, totalSchemas) {
    totalSchemas = totalSchemas || [];
    options = defaultsDeep(options, {
        ignoreAdditionalProperties: false,
        resolvers: defaultResolvers,
        complexResolvers: defaultComplexResolvers,
        deep: true
    });
    const complexResolvers = Object.entries(options.complexResolvers);
    function mergeSchemas(schemas, base, parents) {
        schemas = cloneDeep(schemas.filter(notUndefined));
        parents = parents || [];
        const merged = isPlainObject(base) ? base : {};
        // return undefined, an empty schema
        if (!schemas.length) return;
        if (schemas.some(isFalse)) return false;
        if (schemas.every(isTrue)) return true;
        // there are no false and we don't need the true ones as they accept everything
        schemas = schemas.filter(isPlainObject);
        const allKeys = allUniqueKeys(schemas);
        if (options.deep && contains(allKeys, "allOf")) return merger({
            allOf: schemas
        }, options, totalSchemas);
        const complexKeysArr = complexResolvers.map(([mainKeyWord, resolverConf])=>allKeys.filter((k)=>resolverConf.keywords.includes(k)));
        // remove all complex keys before simple resolvers
        complexKeysArr.forEach((keys)=>pullAll(allKeys, keys));
        // call all simple resolvers for relevant keywords
        allKeys.forEach(function(key) {
            const values = getValues(schemas, key);
            const compacted = uniqWith(values.filter(notUndefined), compareProp(key));
            // arrayprops like anyOf and oneOf must be merged first, as they contains schemas
            // allOf is treated differently alltogether
            if (compacted.length === 1 && contains(schemaArrays, key)) merged[key] = compacted[0].map((schema)=>mergeSchemas([
                    schema
                ], schema));
            else if (compacted.length === 1 && !contains(schemaGroupProps, key) && !contains(schemaProps, key)) merged[key] = compacted[0];
            else {
                const resolver = options.resolvers[key] || options.resolvers.defaultResolver;
                if (!resolver) throw new Error("No resolver found for key " + key + ". You can provide a resolver for this keyword in the options, or provide a default resolver.");
                const merger = (schemas, extraKey = [])=>mergeSchemas(schemas, null, parents.concat(key, extraKey));
                merged[key] = resolver(compacted, parents.concat(key), merger, options);
                if (merged[key] === undefined) throwIncompatible(compacted, parents.concat(key));
                else if (merged[key] === undefined) delete merged[key];
            }
        });
        return complexResolvers.reduce((all, [resolverKeyword, config], index)=>({
                ...all,
                ...callGroupResolver(complexKeysArr[index], resolverKeyword, schemas, mergeSchemas, options, parents)
            }), merged);
    }
    const allSchemas = flattenDeep(getAllOf(rootSchema));
    const merged = mergeSchemas(allSchemas);
    return merged;
}
merger.options = {
    resolvers: defaultResolvers
};
module.exports = merger;

},{"eaede3ab6d27e129":"caEbI","1a2afe8d0c610fb0":"7TY1K","442e4feed98e459":"2aiSk","e25f416854cb8173":"3APHD","ac7f62997984c20c":"cBlpT","88b49ca963adb703":"9LFpg","6c293d3bddf92666":"40oKe","7ea3115b810a7014":"fcoDh","4d5667d6f26039ba":"64pmh","fbc0c1d2257f94b":"aYsgZ","838199c0d6d6c4e5":"9DyyZ","33f995abdc38f788":"8KMzB","71ac4cce2884b18c":"z30nX","c445257c25fff161":"3ig0N","94c0843ee6bd2bdc":"aKl8Y","35db618df5ee8d2e":"iQXlZ"}],"caEbI":[function(require,module,exports) {
var baseClone = require("9b38cc9a3ba32230");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
module.exports = cloneDeep;

},{"9b38cc9a3ba32230":"an1MV"}],"7TY1K":[function(require,module,exports) {
var isEqual = require("564e952241636b94");
var sortBy = require("992b689f14f0eabc");
var uniq = require("e2e33f108d75d07b");
var uniqWith = require("b08be2df2fb7ba0e");
var defaults = require("b8566f0fc1895145");
var intersectionWith = require("a2c664647fd57a85");
var isPlainObject = require("a1a13e3894746ebe");
var isBoolean = require("f47d147a22f42074");
var normalizeArray = (val)=>Array.isArray(val) ? val : [
        val
    ];
var undef = (val)=>val === undefined;
var keys = (obj)=>isPlainObject(obj) || Array.isArray(obj) ? Object.keys(obj) : [];
var has = (obj, key)=>obj.hasOwnProperty(key);
var stringArray = (arr)=>sortBy(uniq(arr));
var undefEmpty = (val)=>undef(val) || Array.isArray(val) && val.length === 0;
var keyValEqual = (a, b, key, compare)=>b && has(b, key) && a && has(a, key) && compare(a[key], b[key]);
var undefAndZero = (a, b)=>undef(a) && b === 0 || undef(b) && a === 0 || isEqual(a, b);
var falseUndefined = (a, b)=>undef(a) && b === false || undef(b) && a === false || isEqual(a, b);
var emptySchema = (schema)=>undef(schema) || isEqual(schema, {}) || schema === true;
var emptyObjUndef = (schema)=>undef(schema) || isEqual(schema, {});
var isSchema = (val)=>undef(val) || isPlainObject(val) || val === true || val === false;
function undefArrayEqual(a, b) {
    if (undefEmpty(a) && undefEmpty(b)) return true;
    else return isEqual(stringArray(a), stringArray(b));
}
function unsortedNormalizedArray(a, b) {
    a = normalizeArray(a);
    b = normalizeArray(b);
    return isEqual(stringArray(a), stringArray(b));
}
function schemaGroup(a, b, key, compare) {
    var allProps = uniq(keys(a).concat(keys(b)));
    if (emptyObjUndef(a) && emptyObjUndef(b)) return true;
    else if (emptyObjUndef(a) && keys(b).length) return false;
    else if (emptyObjUndef(b) && keys(a).length) return false;
    return allProps.every(function(key) {
        var aVal = a[key];
        var bVal = b[key];
        if (Array.isArray(aVal) && Array.isArray(bVal)) return isEqual(stringArray(a), stringArray(b));
        else if (Array.isArray(aVal) && !Array.isArray(bVal)) return false;
        else if (Array.isArray(bVal) && !Array.isArray(aVal)) return false;
        return keyValEqual(a, b, key, compare);
    });
}
function items(a, b, key, compare) {
    if (isPlainObject(a) && isPlainObject(b)) return compare(a, b);
    else if (Array.isArray(a) && Array.isArray(b)) return schemaGroup(a, b, key, compare);
    else return isEqual(a, b);
}
function unsortedArray(a, b, key, compare) {
    var uniqueA = uniqWith(a, compare);
    var uniqueB = uniqWith(b, compare);
    var inter = intersectionWith(uniqueA, uniqueB, compare);
    return inter.length === Math.max(uniqueA.length, uniqueB.length);
}
var comparers = {
    title: isEqual,
    uniqueItems: falseUndefined,
    minLength: undefAndZero,
    minItems: undefAndZero,
    minProperties: undefAndZero,
    required: undefArrayEqual,
    enum: undefArrayEqual,
    type: unsortedNormalizedArray,
    items: items,
    anyOf: unsortedArray,
    allOf: unsortedArray,
    oneOf: unsortedArray,
    properties: schemaGroup,
    patternProperties: schemaGroup,
    dependencies: schemaGroup
};
var acceptsUndefined = [
    "properties",
    "patternProperties",
    "dependencies",
    "uniqueItems",
    "minLength",
    "minItems",
    "minProperties",
    "required"
];
var schemaProps = [
    "additionalProperties",
    "additionalItems",
    "contains",
    "propertyNames",
    "not"
];
function compare(a, b, options) {
    options = defaults(options, {
        ignore: []
    });
    if (emptySchema(a) && emptySchema(b)) return true;
    if (!isSchema(a) || !isSchema(b)) throw new Error("Either of the values are not a JSON schema.");
    if (a === b) return true;
    if (isBoolean(a) && isBoolean(b)) return a === b;
    if (a === undefined && b === false || b === undefined && a === false) return false;
    if (undef(a) && !undef(b) || !undef(a) && undef(b)) return false;
    var allKeys = uniq(Object.keys(a).concat(Object.keys(b)));
    if (options.ignore.length) allKeys = allKeys.filter((k)=>options.ignore.indexOf(k) === -1);
    if (!allKeys.length) return true;
    function innerCompare(a, b) {
        return compare(a, b, options);
    }
    return allKeys.every(function(key) {
        var aValue = a[key];
        var bValue = b[key];
        if (schemaProps.indexOf(key) !== -1) return compare(aValue, bValue, options);
        var comparer = comparers[key];
        if (!comparer) comparer = isEqual;
        // do simple lodash check first
        if (isEqual(aValue, bValue)) return true;
        if (acceptsUndefined.indexOf(key) === -1) {
            if (!has(a, key) && has(b, key) || has(a, key) && !has(b, key)) return aValue === bValue;
        }
        var result = comparer(aValue, bValue, key, innerCompare);
        if (!isBoolean(result)) throw new Error("Comparer must return true or false");
        return result;
    });
}
module.exports = compare;

},{"564e952241636b94":"64pmh","992b689f14f0eabc":"8KMzB","e2e33f108d75d07b":"z30nX","b08be2df2fb7ba0e":"3ig0N","b8566f0fc1895145":"a3XSr","a2c664647fd57a85":"fcoDh","a1a13e3894746ebe":"aYsgZ","f47d147a22f42074":"cDCsR"}],"8KMzB":[function(require,module,exports) {
var baseFlatten = require("7dd3b18d381f1f29"), baseOrderBy = require("2553e45e897c3cba"), baseRest = require("9df1e918b0eea173"), isIterateeCall = require("36218471fd8f4dda");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var sortBy = baseRest(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
module.exports = sortBy;

},{"7dd3b18d381f1f29":"9VsYJ","2553e45e897c3cba":"5dJj0","9df1e918b0eea173":"9p3xS","36218471fd8f4dda":"hr6A6"}],"5dJj0":[function(require,module,exports) {
var arrayMap = require("8b3be8ab05c5c021"), baseGet = require("56eb179604ce4d19"), baseIteratee = require("41950d167c7e12b5"), baseMap = require("b09740a39499ec43"), baseSortBy = require("35a9013ca73ef017"), baseUnary = require("b387a5b76e29e664"), compareMultiple = require("2ab709818f44804c"), identity = require("5cb379329c706719"), isArray = require("8acdbb462385356c");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray(iteratee)) return function(value) {
            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        identity
    ];
    var index = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
    });
}
module.exports = baseOrderBy;

},{"8b3be8ab05c5c021":"fahvZ","56eb179604ce4d19":"51EsY","41950d167c7e12b5":"l2cSI","b09740a39499ec43":"8gzMu","35a9013ca73ef017":"4AUGS","b387a5b76e29e664":"993qv","2ab709818f44804c":"kezKB","5cb379329c706719":"71tSl","8acdbb462385356c":"2VsjV"}],"8gzMu":[function(require,module,exports) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"ghpxV","2924e2db4bb5430d":"5uWOF"}],"4AUGS":[function(require,module,exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = baseSortBy;

},{}],"kezKB":[function(require,module,exports) {
var compareAscending = require("dd5e23e02b1cd726");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = compareMultiple;

},{"dd5e23e02b1cd726":"e59ti"}],"e59ti":[function(require,module,exports) {
var isSymbol = require("a51b63ee8daeecee");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = compareAscending;

},{"a51b63ee8daeecee":"3DsXL"}],"3ig0N":[function(require,module,exports) {
var baseUniq = require("5c64b423b6ad4c59");
/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */ function uniqWith(array, comparator) {
    comparator = typeof comparator == "function" ? comparator : undefined;
    return array && array.length ? baseUniq(array, undefined, comparator) : [];
}
module.exports = uniqWith;

},{"5c64b423b6ad4c59":"gPtnc"}],"a3XSr":[function(require,module,exports) {
var baseRest = require("7185e90d741afd2a"), eq = require("c7442b0697635fa9"), isIterateeCall = require("4bcb10da45efc3b8"), keysIn = require("4217ca21be56753d");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var defaults = baseRest(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = defaults;

},{"7185e90d741afd2a":"9p3xS","c7442b0697635fa9":"5Gmi2","4bcb10da45efc3b8":"hr6A6","4217ca21be56753d":"1kPzt"}],"fcoDh":[function(require,module,exports) {
var arrayMap = require("939e78cd71d9dc7"), baseIntersection = require("f6a959711bf8ce02"), baseRest = require("5641df5b02bcbdf6"), castArrayLikeObject = require("26d16185c6ed7ee7"), last = require("914d9b37eb9cd0f6");
/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */ var intersectionWith = baseRest(function(arrays) {
    var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
    comparator = typeof comparator == "function" ? comparator : undefined;
    if (comparator) mapped.pop();
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
});
module.exports = intersectionWith;

},{"939e78cd71d9dc7":"fahvZ","f6a959711bf8ce02":"7rZF8","5641df5b02bcbdf6":"9p3xS","26d16185c6ed7ee7":"jkEi1","914d9b37eb9cd0f6":"5Gv7h"}],"7rZF8":[function(require,module,exports) {
var SetCache = require("7070c945ceea62ce"), arrayIncludes = require("ea93e7f7041da225"), arrayIncludesWith = require("95ac92fc6b845c29"), arrayMap = require("96e97fb8c1f62c2a"), baseUnary = require("cfcf6ce49738e1b2"), cacheHas = require("27c425d77edc5a7b");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseIntersection;

},{"7070c945ceea62ce":"8LOJe","ea93e7f7041da225":"894B4","95ac92fc6b845c29":"7U6V2","96e97fb8c1f62c2a":"fahvZ","cfcf6ce49738e1b2":"993qv","27c425d77edc5a7b":"tTji9"}],"jkEi1":[function(require,module,exports) {
var isArrayLikeObject = require("36f79b126a48f510");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function castArrayLikeObject(value) {
    return isArrayLikeObject(value) ? value : [];
}
module.exports = castArrayLikeObject;

},{"36f79b126a48f510":"hn1J7"}],"cDCsR":[function(require,module,exports) {
var baseGetTag = require("763d54281423d9ac"), isObjectLike = require("37c1c7912587466b");
/** `Object#toString` result references. */ var boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function isBoolean(value) {
    return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
}
module.exports = isBoolean;

},{"763d54281423d9ac":"fQG2h","37c1c7912587466b":"5TH1N"}],"2aiSk":[function(require,module,exports) {
"use strict";
// MODULES //
var gcd = require("3ea38b1b362dbeb0"), isArray = require("d89d45b81303b812"), isIntegerArray = require("8619c72ba74e5ebd"), isFunction = require("3a79b6f86033bff");
// LEAST COMMON MULTIPLE //
/**
* FUNCTION: lcm( arr[, clbk] )
*	Computes the least common multiple (lcm).
*
* @param {Number[]|Number} arr - input array of integers
* @param {Function|Number} [accessor] - accessor function for accessing array values
* @returns {Number|Null} least common multiple or null
*/ function lcm() {
    var nargs = arguments.length, args, clbk, arr, len, a, b, i;
    // Copy the input arguments to an array...
    args = new Array(nargs);
    for(i = 0; i < nargs; i++)args[i] = arguments[i];
    // Have we been provided with integer arguments?
    if (isIntegerArray(args)) {
        if (nargs === 2) {
            a = args[0];
            b = args[1];
            if (a < 0) a = -a;
            if (b < 0) b = -b;
            if (a === 0 || b === 0) return 0;
            return a / gcd(a, b) * b;
        }
        arr = args;
    } else if (!isArray(args[0])) throw new TypeError("lcm()::invalid input argument. Must provide an array of integers. Value: `" + args[0] + "`.");
    else if (nargs > 1) {
        arr = args[0];
        clbk = args[1];
        if (!isFunction(clbk)) throw new TypeError("lcm()::invalid input argument. Accessor must be a function. Value: `" + clbk + "`.");
    } else arr = args[0];
    len = arr.length;
    // Check if a sufficient number of values have been provided...
    if (len < 2) return null;
    // If an accessor is provided, extract the array values...
    if (clbk) {
        a = new Array(len);
        for(i = 0; i < len; i++)a[i] = clbk(arr[i], i);
        arr = a;
    }
    // Given an input array, ensure all array values are integers...
    if (nargs < 3) {
        if (!isIntegerArray(arr)) throw new TypeError("lcm()::invalid input argument. Accessed array values must be integers. Value: `" + arr + "`.");
    }
    // Convert any negative integers to positive integers...
    for(i = 0; i < len; i++){
        a = arr[i];
        if (a < 0) arr[i] = -a;
    }
    // Exploit the fact that the lcm is an associative function...
    a = arr[0];
    for(i = 1; i < len; i++){
        b = arr[i];
        if (a === 0 || b === 0) return 0;
        a = a / gcd(a, b) * b;
    }
    return a;
} // end FUNCTION lcm()
// EXPORTS //
module.exports = lcm;

},{"3ea38b1b362dbeb0":"4ubGn","d89d45b81303b812":"dwws1","8619c72ba74e5ebd":"e6ry0","3a79b6f86033bff":"dzmJT"}],"4ubGn":[function(require,module,exports) {
"use strict";
// MODULES //
var isArray = require("22f194d5a3afec12"), isIntegerArray = require("1b91b82798457561"), isFunction = require("20defc9a8b93f093");
// VARIABLES //
var MAXINT = Math.pow(2, 31) - 1;
// FUNCTIONS //
/**
* FUNCTION: gcd( a, b )
*	Computes the greatest common divisor of two integers `a` and `b`, using the binary GCD algorithm.
*
* @param {Number} a - integer
* @param {Number} b - integer
* @returns {Number} greatest common divisor
*/ function gcd(a, b) {
    var k = 1, t;
    // Simple cases:
    if (a === 0) return b;
    if (b === 0) return a;
    // Reduce `a` and/or `b` to odd numbers and keep track of the greatest power of 2 dividing both `a` and `b`...
    while(a % 2 === 0 && b % 2 === 0){
        a = a / 2; // right shift
        b = b / 2; // right shift
        k = k * 2; // left shift
    }
    // Reduce `a` to an odd number...
    while(a % 2 === 0)a = a / 2; // right shift
    // Henceforth, `a` is always odd...
    while(b){
        // Remove all factors of 2 in `b`, as they are not common...
        while(b % 2 === 0)b = b / 2; // right shift
        // `a` and `b` are both odd. Swap values such that `b` is the larger of the two values, and then set `b` to the difference (which is even)...
        if (a > b) {
            t = b;
            b = a;
            a = t;
        }
        b = b - a; // b=0 iff b=a
    }
    // Restore common factors of 2...
    return k * a;
} // end FUNCTION gcd()
/**
* FUNCTION: bitwise( a, b )
*	Computes the greatest common divisor of two integers `a` and `b`, using the binary GCD algorithm and bitwise operations.
*
* @param {Number} a - safe integer
* @param {Number} b - safe integer
* @returns {Number} greatest common divisor
*/ function bitwise(a, b) {
    var k = 0, t;
    // Simple cases:
    if (a === 0) return b;
    if (b === 0) return a;
    // Reduce `a` and/or `b` to odd numbers and keep track of the greatest power of 2 dividing both `a` and `b`...
    while((a & 1) === 0 && (b & 1) === 0){
        a >>>= 1; // right shift
        b >>>= 1; // right shift
        k++;
    }
    // Reduce `a` to an odd number...
    while((a & 1) === 0)a >>>= 1; // right shift
    // Henceforth, `a` is always odd...
    while(b){
        // Remove all factors of 2 in `b`, as they are not common...
        while((b & 1) === 0)b >>>= 1; // right shift
        // `a` and `b` are both odd. Swap values such that `b` is the larger of the two values, and then set `b` to the difference (which is even)...
        if (a > b) {
            t = b;
            b = a;
            a = t;
        }
        b = b - a; // b=0 iff b=a
    }
    // Restore common factors of 2...
    return a << k;
} // end FUNCTION bitwise()
// GREATEST COMMON DIVISOR //
/**
* FUNCTION: compute( arr[, clbk] )
*	Computes the greatest common divisor.
*
* @param {Number[]|Number} arr - input array of integers
* @param {Function|Number} [clbk] - accessor function for accessing array values
* @returns {Number|Null} greatest common divisor or null
*/ function compute() {
    var nargs = arguments.length, args, clbk, arr, len, a, b, i;
    // Copy the input arguments to an array...
    args = new Array(nargs);
    for(i = 0; i < nargs; i++)args[i] = arguments[i];
    // Have we been provided with integer arguments?
    if (isIntegerArray(args)) {
        if (nargs === 2) {
            a = args[0];
            b = args[1];
            if (a < 0) a = -a;
            if (b < 0) b = -b;
            if (a <= MAXINT && b <= MAXINT) return bitwise(a, b);
            else return gcd(a, b);
        }
        arr = args;
    } else if (!isArray(args[0])) throw new TypeError("gcd()::invalid input argument. Must provide an array of integers. Value: `" + args[0] + "`.");
    else if (nargs > 1) {
        arr = args[0];
        clbk = args[1];
        if (!isFunction(clbk)) throw new TypeError("gcd()::invalid input argument. Accessor must be a function. Value: `" + clbk + "`.");
    } else arr = args[0];
    len = arr.length;
    // Check if a sufficient number of values have been provided...
    if (len < 2) return null;
    // If an accessor is provided, extract the array values...
    if (clbk) {
        a = new Array(len);
        for(i = 0; i < len; i++)a[i] = clbk(arr[i], i);
        arr = a;
    }
    // Given an input array, ensure all array values are integers...
    if (nargs < 3) {
        if (!isIntegerArray(arr)) throw new TypeError("gcd()::invalid input argument. Accessed array values must be integers. Value: `" + arr + "`.");
    }
    // Convert any negative integers to positive integers...
    for(i = 0; i < len; i++){
        a = arr[i];
        if (a < 0) arr[i] = -a;
    }
    // Exploit the fact that the gcd is an associative function...
    a = arr[0];
    for(i = 1; i < len; i++){
        b = arr[i];
        if (b <= MAXINT && a <= MAXINT) a = bitwise(a, b);
        else a = gcd(a, b);
    }
    return a;
} // end FUNCTION compute()
// EXPORTS //
module.exports = compute;

},{"22f194d5a3afec12":"dwws1","1b91b82798457561":"e6ry0","20defc9a8b93f093":"dzmJT"}],"dwws1":[function(require,module,exports) {
"use strict";
/**
* FUNCTION: isArray( value )
*	Validates if a value is an array.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating whether value is an array
*/ function isArray(value) {
    return Object.prototype.toString.call(value) === "[object Array]";
} // end FUNCTION isArray()
// EXPORTS //
module.exports = Array.isArray || isArray;

},{}],"e6ry0":[function(require,module,exports) {
/**
*
*	VALIDATE: integer-array
*
*
*	DESCRIPTION:
*		- Validates if a value is an integer array.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2015. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2015.
*
*/ "use strict";
// MODULES //
var isArray = require("bd6887385d1682bc"), isInteger = require("15ad048fb6c282e6");
// IS INTEGER ARRAY //
/**
* FUNCTION: isIntegerArray( value )
*	Validates if a value is an integer array.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating if a value is an integer array
*/ function isIntegerArray(value) {
    var len;
    if (!isArray(value)) return false;
    len = value.length;
    if (!len) return false;
    for(var i = 0; i < len; i++){
        if (!isInteger(value[i])) return false;
    }
    return true;
} // end FUNCTION isIntegerArray()
// EXPORTS //
module.exports = isIntegerArray;

},{"bd6887385d1682bc":"dwws1","15ad048fb6c282e6":"3mlaa"}],"3mlaa":[function(require,module,exports) {
/**
*
*	VALIDATE: integer
*
*
*	DESCRIPTION:
*		- Validates if a value is an integer.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2014. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2014.
*
*/ "use strict";
// MODULES //
var isNumber = require("ba0d3ce27a1c2850");
// ISINTEGER //
/**
* FUNCTION: isInteger( value )
*	Validates if a value is an integer.
*
* @param {Number} value - value to be validated
* @returns {Boolean} boolean indicating whether value is an integer
*/ function isInteger(value) {
    return isNumber(value) && value % 1 === 0;
} // end FUNCTION isInteger()
// EXPORTS //
module.exports = isInteger;

},{"ba0d3ce27a1c2850":"lURyg"}],"lURyg":[function(require,module,exports) {
/**
*
*	VALIDATE: number
*
*
*	DESCRIPTION:
*		- Validates if a value is a number.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2014. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2014.
*
*/ "use strict";
/**
* FUNCTION: isNumber( value )
*	Validates if a value is a number.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating whether value is a number
*/ function isNumber(value) {
    return (typeof value === "number" || Object.prototype.toString.call(value) === "[object Number]") && value.valueOf() === value.valueOf();
} // end FUNCTION isNumber()
// EXPORTS //
module.exports = isNumber;

},{}],"dzmJT":[function(require,module,exports) {
/**
*
*	VALIDATE: function
*
*
*	DESCRIPTION:
*		- Validates if a value is a function.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2014. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2014.
*
*/ "use strict";
/**
* FUNCTION: isFunction( value )
*	Validates if a value is a function.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating whether value is a function
*/ function isFunction(value) {
    return typeof value === "function";
} // end FUNCTION isFunction()
// EXPORTS //
module.exports = isFunction;

},{}],"3APHD":[function(require,module,exports) {
var apply = require("22a11e8cef4c515a"), baseRest = require("a535b85c1e935c35"), customDefaultsMerge = require("1b6265fdf2b2becb"), mergeWith = require("23dda4f4ca071ecb");
/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var defaultsDeep = baseRest(function(args) {
    args.push(undefined, customDefaultsMerge);
    return apply(mergeWith, undefined, args);
});
module.exports = defaultsDeep;

},{"22a11e8cef4c515a":"ibr7y","a535b85c1e935c35":"9p3xS","1b6265fdf2b2becb":"8yPzL","23dda4f4ca071ecb":"8ITew"}],"8yPzL":[function(require,module,exports) {
var baseMerge = require("df69673e1974f60f"), isObject = require("184af3126e981d10");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack["delete"](srcValue);
    }
    return objValue;
}
module.exports = customDefaultsMerge;

},{"df69673e1974f60f":"fmzk3","184af3126e981d10":"3TlAp"}],"8ITew":[function(require,module,exports) {
var baseMerge = require("534a42b3db0d10f3"), createAssigner = require("1dd402ac842b0276");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
module.exports = mergeWith;

},{"534a42b3db0d10f3":"fmzk3","1dd402ac842b0276":"6yvTP"}],"40oKe":[function(require,module,exports) {
var arrayMap = require("6a250a20b4b08a64"), baseIntersection = require("a82701bebbafe8d6"), baseRest = require("a4c4fe36b8bc714c"), castArrayLikeObject = require("a81a4617d84f59b5");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var intersection = baseRest(function(arrays) {
    var mapped = arrayMap(arrays, castArrayLikeObject);
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
});
module.exports = intersection;

},{"6a250a20b4b08a64":"fahvZ","a82701bebbafe8d6":"7rZF8","a4c4fe36b8bc714c":"9p3xS","a81a4617d84f59b5":"jkEi1"}],"9DyyZ":[function(require,module,exports) {
var basePullAll = require("ac3106171ce4858");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function pullAll(array, values) {
    return array && array.length && values && values.length ? basePullAll(array, values) : array;
}
module.exports = pullAll;

},{"ac3106171ce4858":"5LQ5X"}],"5LQ5X":[function(require,module,exports) {
var arrayMap = require("a353916a8217d76c"), baseIndexOf = require("bb22bfc11f13e432"), baseIndexOfWith = require("6cda42a127972471"), baseUnary = require("8164bbbe2998b4c8"), copyArray = require("79c1d6a76564e4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
    if (array === values) values = copyArray(values);
    if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) splice.call(seen, fromIndex, 1);
            splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = basePullAll;

},{"a353916a8217d76c":"fahvZ","bb22bfc11f13e432":"b5Lpi","6cda42a127972471":"htmvA","8164bbbe2998b4c8":"993qv","79c1d6a76564e4f":"7vKch"}],"htmvA":[function(require,module,exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = baseIndexOfWith;

},{}],"aKl8Y":[function(require,module,exports) {
const compare = require("dbfeade8bb096b46");
const forEach = require("cef7246235a2a902");
const { allUniqueKeys, deleteUndefinedProps, getValues, keys, notUndefined, uniqWith, withoutArr } = require("33200a4a5dcc19d6");
function removeFalseSchemas(target) {
    forEach(target, function(schema, prop) {
        if (schema === false) delete target[prop];
    });
}
function mergeSchemaGroup(group, mergeSchemas) {
    const allKeys = allUniqueKeys(group);
    return allKeys.reduce(function(all, key) {
        const schemas = getValues(group, key);
        const compacted = uniqWith(schemas.filter(notUndefined), compare);
        all[key] = mergeSchemas(compacted, key);
        return all;
    }, {});
}
module.exports = {
    keywords: [
        "properties",
        "patternProperties",
        "additionalProperties"
    ],
    resolver (values, parents, mergers, options) {
        // first get rid of all non permitted properties
        if (!options.ignoreAdditionalProperties) {
            values.forEach(function(subSchema) {
                const otherSubSchemas = values.filter((s)=>s !== subSchema);
                const ownKeys = keys(subSchema.properties);
                const ownPatternKeys = keys(subSchema.patternProperties);
                const ownPatterns = ownPatternKeys.map((k)=>new RegExp(k));
                otherSubSchemas.forEach(function(other) {
                    const allOtherKeys = keys(other.properties);
                    const keysMatchingPattern = allOtherKeys.filter((k)=>ownPatterns.some((pk)=>pk.test(k)));
                    const additionalKeys = withoutArr(allOtherKeys, ownKeys, keysMatchingPattern);
                    additionalKeys.forEach(function(key) {
                        other.properties[key] = mergers.properties([
                            other.properties[key],
                            subSchema.additionalProperties
                        ], key);
                    });
                });
            });
            // remove disallowed patternProperties
            values.forEach(function(subSchema) {
                const otherSubSchemas = values.filter((s)=>s !== subSchema);
                const ownPatternKeys = keys(subSchema.patternProperties);
                if (subSchema.additionalProperties === false) otherSubSchemas.forEach(function(other) {
                    const allOtherPatterns = keys(other.patternProperties);
                    const additionalPatternKeys = withoutArr(allOtherPatterns, ownPatternKeys);
                    additionalPatternKeys.forEach((key)=>delete other.patternProperties[key]);
                });
            });
        }
        const returnObject = {
            additionalProperties: mergers.additionalProperties(values.map((s)=>s.additionalProperties)),
            patternProperties: mergeSchemaGroup(values.map((s)=>s.patternProperties), mergers.patternProperties),
            properties: mergeSchemaGroup(values.map((s)=>s.properties), mergers.properties)
        };
        if (returnObject.additionalProperties === false) removeFalseSchemas(returnObject.properties);
        return deleteUndefinedProps(returnObject);
    }
};

},{"dbfeade8bb096b46":"7TY1K","cef7246235a2a902":"5vh4L","33200a4a5dcc19d6":"1K7NJ"}],"5vh4L":[function(require,module,exports) {
var arrayEach = require("5dbec210c3629ee5"), baseEach = require("8e0dc727d328c3d7"), castFunction = require("759fcc4330a9fea9"), isArray = require("38760405c7e16565");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forEach(collection, iteratee) {
    var func = isArray(collection) ? arrayEach : baseEach;
    return func(collection, castFunction(iteratee));
}
module.exports = forEach;

},{"5dbec210c3629ee5":"inYRG","8e0dc727d328c3d7":"ghpxV","759fcc4330a9fea9":"6fHR7","38760405c7e16565":"2VsjV"}],"1K7NJ":[function(require,module,exports) {
const flatten = require("98c863903e5632e2");
const flattenDeep = require("6cb31a86da238c87");
const isPlainObject = require("e45175d98a537aa6");
const uniq = require("46d84a9a1886d4e0");
const uniqWith = require("53243ce33a134685");
const without = require("90628609344b4fd6");
function deleteUndefinedProps(returnObject) {
    // cleanup empty
    for(const prop in returnObject)if (has(returnObject, prop) && isEmptySchema(returnObject[prop])) delete returnObject[prop];
    return returnObject;
}
const allUniqueKeys = (arr)=>uniq(flattenDeep(arr.map(keys)));
const getValues = (schemas, key)=>schemas.map((schema)=>schema && schema[key]);
const has = (obj, propName)=>Object.prototype.hasOwnProperty.call(obj, propName);
const keys = (obj)=>{
    if (isPlainObject(obj) || Array.isArray(obj)) return Object.keys(obj);
    else return [];
};
const notUndefined = (val)=>val !== undefined;
const isSchema = (val)=>isPlainObject(val) || val === true || val === false;
const isEmptySchema = (obj)=>!keys(obj).length && obj !== false && obj !== true;
const withoutArr = (arr, ...rest)=>without.apply(null, [
        arr
    ].concat(flatten(rest)));
module.exports = {
    allUniqueKeys,
    deleteUndefinedProps,
    getValues,
    has,
    isEmptySchema,
    isSchema,
    keys,
    notUndefined,
    uniqWith,
    withoutArr
};

},{"98c863903e5632e2":"cBlpT","6cb31a86da238c87":"9LFpg","e45175d98a537aa6":"aYsgZ","46d84a9a1886d4e0":"z30nX","53243ce33a134685":"3ig0N","90628609344b4fd6":"ctz6Y"}],"ctz6Y":[function(require,module,exports) {
var baseDifference = require("4db0cb250ff88e72"), baseRest = require("b2f01aa6851573dc"), isArrayLikeObject = require("15809c5e06486880");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var without = baseRest(function(array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, values) : [];
});
module.exports = without;

},{"4db0cb250ff88e72":"bT2tm","b2f01aa6851573dc":"9p3xS","15809c5e06486880":"hn1J7"}],"bT2tm":[function(require,module,exports) {
var SetCache = require("24f4b9cbc81696e0"), arrayIncludes = require("81e4fe535468d831"), arrayIncludesWith = require("90bb2140eaac029e"), arrayMap = require("7436ea7dfb9a8bab"), baseUnary = require("c466a3eeaa8c48da"), cacheHas = require("aea8a6a021670ce5");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = arrayMap(values, baseUnary(iteratee));
    if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
    } else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = baseDifference;

},{"24f4b9cbc81696e0":"8LOJe","81e4fe535468d831":"894B4","90bb2140eaac029e":"7U6V2","7436ea7dfb9a8bab":"fahvZ","c466a3eeaa8c48da":"993qv","aea8a6a021670ce5":"tTji9"}],"iQXlZ":[function(require,module,exports) {
const compare = require("15e6aa3e8464c524");
const forEach = require("5d03020cec9cd603");
const { allUniqueKeys, deleteUndefinedProps, has, isSchema, notUndefined, uniqWith } = require("adfbf5b29a9aa7c8");
function removeFalseSchemasFromArray(target) {
    forEach(target, function(schema, index) {
        if (schema === false) target.splice(index, 1);
    });
}
function getItemSchemas(subSchemas, key) {
    return subSchemas.map(function(sub) {
        if (!sub) return undefined;
        if (Array.isArray(sub.items)) {
            const schemaAtPos = sub.items[key];
            if (isSchema(schemaAtPos)) return schemaAtPos;
            else if (has(sub, "additionalItems")) return sub.additionalItems;
        } else return sub.items;
        return undefined;
    });
}
function getAdditionalSchemas(subSchemas) {
    return subSchemas.map(function(sub) {
        if (!sub) return undefined;
        if (Array.isArray(sub.items)) return sub.additionalItems;
        return sub.items;
    });
}
// Provide source when array
function mergeItems(group, mergeSchemas, items) {
    const allKeys = allUniqueKeys(items);
    return allKeys.reduce(function(all, key) {
        const schemas = getItemSchemas(group, key);
        const compacted = uniqWith(schemas.filter(notUndefined), compare);
        all[key] = mergeSchemas(compacted, key);
        return all;
    }, []);
}
module.exports = {
    keywords: [
        "items",
        "additionalItems"
    ],
    resolver (values, parents, mergers) {
        // const createSubMerger = groupKey => (schemas, key) => mergeSchemas(schemas, parents.concat(groupKey, key))
        const items = values.map((s)=>s.items);
        const itemsCompacted = items.filter(notUndefined);
        const returnObject = {};
        // if all items keyword values are schemas, we can merge them as simple schemas
        // if not we need to merge them as mixed
        if (itemsCompacted.every(isSchema)) returnObject.items = mergers.items(items);
        else returnObject.items = mergeItems(values, mergers.items, items);
        let schemasAtLastPos;
        if (itemsCompacted.every(Array.isArray)) schemasAtLastPos = values.map((s)=>s.additionalItems);
        else if (itemsCompacted.some(Array.isArray)) schemasAtLastPos = getAdditionalSchemas(values);
        if (schemasAtLastPos) returnObject.additionalItems = mergers.additionalItems(schemasAtLastPos);
        if (returnObject.additionalItems === false && Array.isArray(returnObject.items)) removeFalseSchemasFromArray(returnObject.items);
        return deleteUndefinedProps(returnObject);
    }
};

},{"15e6aa3e8464c524":"7TY1K","5d03020cec9cd603":"5vh4L","adfbf5b29a9aa7c8":"1K7NJ"}],"guLol":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDiscriminatorFieldFromSchema);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
function getDiscriminatorFieldFromSchema(schema) {
    let discriminator;
    const maybeString = (0, _getDefault.default)(schema, "discriminator.propertyName", undefined);
    if ((0, _isStringDefault.default)(maybeString)) discriminator = maybeString;
    else if (maybeString !== undefined) console.warn(`Expecting discriminator to be a string, got "${typeof maybeString}" instead`);
    return discriminator;
}

},{"lodash/get":"8z6tS","lodash/isString":"hjD1s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aoWoo":[function(require,module,exports) {
/** Given a specific `value` attempts to guess the type of a schema element. In the case where we have to implicitly
 *  create a schema, it is useful to know what type to use based on the data we are defining.
 *
 * @param value - The value from which to guess the type
 * @returns - The best guess for the object type
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>guessType);
function guessType(value) {
    if (Array.isArray(value)) return "array";
    if (typeof value === "string") return "string";
    if (value == null) return "null";
    if (typeof value === "boolean") return "boolean";
    if (!isNaN(value)) return "number";
    if (typeof value === "object") return "object";
    // Default to string if we can't figure it out
    return "string";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dXj9f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeSchemas);
var _union = require("lodash/union");
var _unionDefault = parcelHelpers.interopDefault(_union);
var _constants = require("./constants");
var _getSchemaType = require("./getSchemaType");
var _getSchemaTypeDefault = parcelHelpers.interopDefault(_getSchemaType);
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function mergeSchemas(obj1, obj2) {
    const acc = Object.assign({}, obj1); // Prevent mutation of source object.
    return Object.keys(obj2).reduce((acc, key)=>{
        const left = obj1 ? obj1[key] : {}, right = obj2[key];
        if (obj1 && key in obj1 && (0, _isObjectDefault.default)(right)) acc[key] = mergeSchemas(left, right);
        else if (obj1 && obj2 && ((0, _getSchemaTypeDefault.default)(obj1) === "object" || (0, _getSchemaTypeDefault.default)(obj2) === "object") && key === (0, _constants.REQUIRED_KEY) && Array.isArray(left) && Array.isArray(right)) // Don't include duplicate values when merging 'required' fields.
        acc[key] = (0, _unionDefault.default)(left, right);
        else acc[key] = right;
        return acc;
    }, acc);
}

},{"lodash/union":"emXcs","./constants":"a1fVD","./getSchemaType":"emxZR","./isObject":"fyldM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"emXcs":[function(require,module,exports) {
var baseFlatten = require("4c6a8d1d22b46f1e"), baseRest = require("3c5b68a5bd4cb3c4"), baseUniq = require("d4a39eace292bbe3"), isArrayLikeObject = require("b9956cfd928a69da");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var union = baseRest(function(arrays) {
    return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});
module.exports = union;

},{"4c6a8d1d22b46f1e":"9VsYJ","3c5b68a5bd4cb3c4":"9p3xS","d4a39eace292bbe3":"gPtnc","b9956cfd928a69da":"hn1J7"}],"emxZR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getSchemaType);
var _guessType = require("./guessType");
var _guessTypeDefault = parcelHelpers.interopDefault(_guessType);
function getSchemaType(schema) {
    let { type } = schema;
    if (!type && schema.const) return (0, _guessTypeDefault.default)(schema.const);
    if (!type && schema.enum) return "string";
    if (!type && (schema.properties || schema.additionalProperties)) return "object";
    if (Array.isArray(type)) {
        if (type.length === 2 && type.includes("null")) type = type.find((type)=>type !== "null");
        else type = type[0];
    }
    return type;
}

},{"./guessType":"aoWoo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"FI6RK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isFixedItems);
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function isFixedItems(schema) {
    return Array.isArray(schema.items) && schema.items.length > 0 && schema.items.every((item)=>(0, _isObjectDefault.default)(item));
}

},{"./isObject":"fyldM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lU5Qu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeDefaultsWithFormData);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function mergeDefaultsWithFormData(defaults, formData, mergeExtraArrayDefaults = false) {
    if (Array.isArray(formData)) {
        const defaultsArray = Array.isArray(defaults) ? defaults : [];
        const mapped = formData.map((value, idx)=>{
            if (defaultsArray[idx]) return mergeDefaultsWithFormData(defaultsArray[idx], value, mergeExtraArrayDefaults);
            return value;
        });
        // Merge any extra defaults when mergeExtraArrayDefaults is true
        if (mergeExtraArrayDefaults && mapped.length < defaultsArray.length) mapped.push(...defaultsArray.slice(mapped.length));
        return mapped;
    }
    if ((0, _isObjectDefault.default)(formData)) {
        const acc = Object.assign({}, defaults); // Prevent mutation of source object.
        return Object.keys(formData).reduce((acc, key)=>{
            acc[key] = mergeDefaultsWithFormData(defaults ? (0, _getDefault.default)(defaults, key) : {}, (0, _getDefault.default)(formData, key), mergeExtraArrayDefaults);
            return acc;
        }, acc);
    }
    return formData;
}

},{"lodash/get":"8z6tS","./isObject":"fyldM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kAdf0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeObjects);
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function mergeObjects(obj1, obj2, concatArrays = false) {
    return Object.keys(obj2).reduce((acc, key)=>{
        const left = obj1 ? obj1[key] : {}, right = obj2[key];
        if (obj1 && key in obj1 && (0, _isObjectDefault.default)(right)) acc[key] = mergeObjects(left, right, concatArrays);
        else if (concatArrays && Array.isArray(left) && Array.isArray(right)) {
            let toMerge = right;
            if (concatArrays === "preventDuplicates") toMerge = right.reduce((result, value)=>{
                if (!left.includes(value)) result.push(value);
                return result;
            }, []);
            acc[key] = left.concat(toMerge);
        } else acc[key] = right;
        return acc;
    }, Object.assign({}, obj1)); // Prevent mutation of source object.
}

},{"./isObject":"fyldM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Mj3e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isMultiSelect);
var _isSelect = require("./isSelect");
var _isSelectDefault = parcelHelpers.interopDefault(_isSelect);
function isMultiSelect(validator, schema, rootSchema) {
    if (!schema.uniqueItems || !schema.items || typeof schema.items === "boolean") return false;
    return (0, _isSelectDefault.default)(validator, schema.items, rootSchema);
}

},{"./isSelect":"40xEi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"40xEi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSelect);
var _isConstant = require("../isConstant");
var _isConstantDefault = parcelHelpers.interopDefault(_isConstant);
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
function isSelect(validator, theSchema, rootSchema = {}) {
    const schema = (0, _retrieveSchemaDefault.default)(validator, theSchema, rootSchema, undefined);
    const altSchemas = schema.oneOf || schema.anyOf;
    if (Array.isArray(schema.enum)) return true;
    if (Array.isArray(altSchemas)) return altSchemas.every((altSchemas)=>typeof altSchemas !== "boolean" && (0, _isConstantDefault.default)(altSchemas));
    return false;
}

},{"../isConstant":"d20uW","./retrieveSchema":"jAKxQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d20uW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isConstant);
var _constants = require("./constants");
function isConstant(schema) {
    return Array.isArray(schema.enum) && schema.enum.length === 1 || (0, _constants.CONST_KEY) in schema;
}

},{"./constants":"a1fVD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kdwtv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDisplayLabel);
var _constants = require("../constants");
var _getSchemaType = require("../getSchemaType");
var _getSchemaTypeDefault = parcelHelpers.interopDefault(_getSchemaType);
var _getUiOptions = require("../getUiOptions");
var _getUiOptionsDefault = parcelHelpers.interopDefault(_getUiOptions);
var _isCustomWidget = require("../isCustomWidget");
var _isCustomWidgetDefault = parcelHelpers.interopDefault(_isCustomWidget);
var _isFilesArray = require("./isFilesArray");
var _isFilesArrayDefault = parcelHelpers.interopDefault(_isFilesArray);
var _isMultiSelect = require("./isMultiSelect");
var _isMultiSelectDefault = parcelHelpers.interopDefault(_isMultiSelect);
function getDisplayLabel(validator, schema, uiSchema = {}, rootSchema, globalOptions) {
    const uiOptions = (0, _getUiOptionsDefault.default)(uiSchema, globalOptions);
    const { label = true } = uiOptions;
    let displayLabel = !!label;
    const schemaType = (0, _getSchemaTypeDefault.default)(schema);
    if (schemaType === "array") displayLabel = (0, _isMultiSelectDefault.default)(validator, schema, rootSchema) || (0, _isFilesArrayDefault.default)(validator, schema, uiSchema, rootSchema) || (0, _isCustomWidgetDefault.default)(uiSchema);
    if (schemaType === "object") displayLabel = false;
    if (schemaType === "boolean" && !uiSchema[0, _constants.UI_WIDGET_KEY]) displayLabel = false;
    if (uiSchema[0, _constants.UI_FIELD_KEY]) displayLabel = false;
    return displayLabel;
}

},{"../constants":"a1fVD","../getSchemaType":"emxZR","../getUiOptions":"ecGOw","../isCustomWidget":"1tXNR","./isFilesArray":"gSDmg","./isMultiSelect":"9Mj3e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1tXNR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCustomWidget);
var _getUiOptions = require("./getUiOptions");
var _getUiOptionsDefault = parcelHelpers.interopDefault(_getUiOptions);
function isCustomWidget(uiSchema = {}) {
    return(// TODO: Remove the `&& uiSchema['ui:widget'] !== 'hidden'` once we support hidden widgets for arrays.
    // https://rjsf-team.github.io/react-jsonschema-form/docs/usage/widgets/#hidden-widgets
    "widget" in (0, _getUiOptionsDefault.default)(uiSchema) && (0, _getUiOptionsDefault.default)(uiSchema)["widget"] !== "hidden");
}

},{"./getUiOptions":"ecGOw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gSDmg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isFilesArray);
var _constants = require("../constants");
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
function isFilesArray(validator, schema, uiSchema = {}, rootSchema) {
    if (uiSchema[0, _constants.UI_WIDGET_KEY] === "files") return true;
    if (schema.items) {
        const itemsSchema = (0, _retrieveSchemaDefault.default)(validator, schema.items, rootSchema);
        return itemsSchema.type === "string" && itemsSchema.format === "data-url";
    }
    return false;
}

},{"../constants":"a1fVD","./retrieveSchema":"jAKxQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cVzXf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeValidationData);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _mergeObjects = require("../mergeObjects");
var _mergeObjectsDefault = parcelHelpers.interopDefault(_mergeObjects);
function mergeValidationData(validator, validationData, additionalErrorSchema) {
    if (!additionalErrorSchema) return validationData;
    const { errors: oldErrors, errorSchema: oldErrorSchema } = validationData;
    let errors = validator.toErrorList(additionalErrorSchema);
    let errorSchema = additionalErrorSchema;
    if (!(0, _isEmptyDefault.default)(oldErrorSchema)) {
        errorSchema = (0, _mergeObjectsDefault.default)(oldErrorSchema, additionalErrorSchema, true);
        errors = [
            ...oldErrors
        ].concat(errors);
    }
    return {
        errorSchema,
        errors
    };
}

},{"lodash/isEmpty":"7pljj","../mergeObjects":"kAdf0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hiNFP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sanitizeDataForNewSchema);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _has = require("lodash/has");
var _hasDefault = parcelHelpers.interopDefault(_has);
var _constants = require("../constants");
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
const NO_VALUE = Symbol("no Value");
function sanitizeDataForNewSchema(validator, rootSchema, newSchema, oldSchema, data = {}) {
    // By default, we will clear the form data
    let newFormData;
    // If the new schema is of type object and that object contains a list of properties
    if ((0, _hasDefault.default)(newSchema, (0, _constants.PROPERTIES_KEY))) {
        // Create an object containing root-level keys in the old schema, setting each key to undefined to remove the data
        const removeOldSchemaData = {};
        if ((0, _hasDefault.default)(oldSchema, (0, _constants.PROPERTIES_KEY))) {
            const properties = (0, _getDefault.default)(oldSchema, (0, _constants.PROPERTIES_KEY), {});
            Object.keys(properties).forEach((key)=>{
                if ((0, _hasDefault.default)(data, key)) removeOldSchemaData[key] = undefined;
            });
        }
        const keys = Object.keys((0, _getDefault.default)(newSchema, (0, _constants.PROPERTIES_KEY), {}));
        // Create a place to store nested data that will be a side-effect of the filter
        const nestedData = {};
        keys.forEach((key)=>{
            const formValue = (0, _getDefault.default)(data, key);
            let oldKeyedSchema = (0, _getDefault.default)(oldSchema, [
                (0, _constants.PROPERTIES_KEY),
                key
            ], {});
            let newKeyedSchema = (0, _getDefault.default)(newSchema, [
                (0, _constants.PROPERTIES_KEY),
                key
            ], {});
            // Resolve the refs if they exist
            if ((0, _hasDefault.default)(oldKeyedSchema, (0, _constants.REF_KEY))) oldKeyedSchema = (0, _retrieveSchemaDefault.default)(validator, oldKeyedSchema, rootSchema, formValue);
            if ((0, _hasDefault.default)(newKeyedSchema, (0, _constants.REF_KEY))) newKeyedSchema = (0, _retrieveSchemaDefault.default)(validator, newKeyedSchema, rootSchema, formValue);
            // Now get types and see if they are the same
            const oldSchemaTypeForKey = (0, _getDefault.default)(oldKeyedSchema, "type");
            const newSchemaTypeForKey = (0, _getDefault.default)(newKeyedSchema, "type");
            // Check if the old option has the same key with the same type
            if (!oldSchemaTypeForKey || oldSchemaTypeForKey === newSchemaTypeForKey) {
                if ((0, _hasDefault.default)(removeOldSchemaData, key)) // SIDE-EFFECT: remove the undefined value for a key that has the same type between the old and new schemas
                delete removeOldSchemaData[key];
                // If it is an object, we'll recurse and store the resulting sanitized data for the key
                if (newSchemaTypeForKey === "object" || newSchemaTypeForKey === "array" && Array.isArray(formValue)) {
                    // SIDE-EFFECT: process the new schema type of object recursively to save iterations
                    const itemData = sanitizeDataForNewSchema(validator, rootSchema, newKeyedSchema, oldKeyedSchema, formValue);
                    if (itemData !== undefined || newSchemaTypeForKey === "array") // only put undefined values for the array type and not the object type
                    nestedData[key] = itemData;
                } else {
                    // Ok, the non-object types match, let's make sure that a default or a const of a different value is replaced
                    // with the new default or const. This allows the case where two schemas differ that only by the default/const
                    // value to be properly selected
                    const newOptionDefault = (0, _getDefault.default)(newKeyedSchema, "default", NO_VALUE);
                    const oldOptionDefault = (0, _getDefault.default)(oldKeyedSchema, "default", NO_VALUE);
                    if (newOptionDefault !== NO_VALUE && newOptionDefault !== formValue) {
                        if (oldOptionDefault === formValue) // If the old default matches the formValue, we'll update the new value to match the new default
                        removeOldSchemaData[key] = newOptionDefault;
                        else if ((0, _getDefault.default)(newKeyedSchema, "readOnly") === true) // If the new schema has the default set to read-only, treat it like a const and remove the value
                        removeOldSchemaData[key] = undefined;
                    }
                    const newOptionConst = (0, _getDefault.default)(newKeyedSchema, "const", NO_VALUE);
                    const oldOptionConst = (0, _getDefault.default)(oldKeyedSchema, "const", NO_VALUE);
                    if (newOptionConst !== NO_VALUE && newOptionConst !== formValue) // Since this is a const, if the old value matches, replace the value with the new const otherwise clear it
                    removeOldSchemaData[key] = oldOptionConst === formValue ? newOptionConst : undefined;
                }
            }
        });
        newFormData = {
            ...typeof data == "string" || Array.isArray(data) ? undefined : data,
            ...removeOldSchemaData,
            ...nestedData
        };
    // First apply removing the old schema data, then apply the nested data, then apply the old data keys to keep
    } else if ((0, _getDefault.default)(oldSchema, "type") === "array" && (0, _getDefault.default)(newSchema, "type") === "array" && Array.isArray(data)) {
        let oldSchemaItems = (0, _getDefault.default)(oldSchema, "items");
        let newSchemaItems = (0, _getDefault.default)(newSchema, "items");
        // If any of the array types `items` are arrays (remember arrays are objects) then we'll just drop the data
        // Eventually, we may want to deal with when either of the `items` are arrays since those tuple validations
        if (typeof oldSchemaItems === "object" && typeof newSchemaItems === "object" && !Array.isArray(oldSchemaItems) && !Array.isArray(newSchemaItems)) {
            if ((0, _hasDefault.default)(oldSchemaItems, (0, _constants.REF_KEY))) oldSchemaItems = (0, _retrieveSchemaDefault.default)(validator, oldSchemaItems, rootSchema, data);
            if ((0, _hasDefault.default)(newSchemaItems, (0, _constants.REF_KEY))) newSchemaItems = (0, _retrieveSchemaDefault.default)(validator, newSchemaItems, rootSchema, data);
            // Now get types and see if they are the same
            const oldSchemaType = (0, _getDefault.default)(oldSchemaItems, "type");
            const newSchemaType = (0, _getDefault.default)(newSchemaItems, "type");
            // Check if the old option has the same key with the same type
            if (!oldSchemaType || oldSchemaType === newSchemaType) {
                const maxItems = (0, _getDefault.default)(newSchema, "maxItems", -1);
                if (newSchemaType === "object") newFormData = data.reduce((newValue, aValue)=>{
                    const itemValue = sanitizeDataForNewSchema(validator, rootSchema, newSchemaItems, oldSchemaItems, aValue);
                    if (itemValue !== undefined && (maxItems < 0 || newValue.length < maxItems)) newValue.push(itemValue);
                    return newValue;
                }, []);
                else newFormData = maxItems > 0 && data.length > maxItems ? data.slice(0, maxItems) : data;
            }
        } else if (typeof oldSchemaItems === "boolean" && typeof newSchemaItems === "boolean" && oldSchemaItems === newSchemaItems) // If they are both booleans and have the same value just return the data as is otherwise fall-thru to undefined
        newFormData = data;
    // Also probably want to deal with `prefixItems` as tuples with the latest 2020 draft
    }
    return newFormData;
}

},{"lodash/get":"8z6tS","lodash/has":"7IGwP","../constants":"a1fVD","./retrieveSchema":"jAKxQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ie8gc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toIdSchema);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _constants = require("../constants");
var _isObject = require("../isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
var _getSchemaType = require("../getSchemaType");
var _getSchemaTypeDefault = parcelHelpers.interopDefault(_getSchemaType);
/** An internal helper that generates an `IdSchema` object for the `schema`, recursively with protection against
 * infinite recursion
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used when necessary
 * @param schema - The schema for which the `IdSchema` is desired
 * @param idPrefix - The prefix to use for the id
 * @param idSeparator - The separator to use for the path segments in the id
 * @param [id] - The base id for the schema
 * @param [rootSchema] - The root schema, used to primarily to look up `$ref`s
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @param [_recurseList=[]] - The list of retrieved schemas currently being recursed, used to prevent infinite recursion
 * @returns - The `IdSchema` object for the `schema`
 */ function toIdSchemaInternal(validator, schema, idPrefix, idSeparator, id, rootSchema, formData, _recurseList = []) {
    if ((0, _constants.REF_KEY) in schema || (0, _constants.DEPENDENCIES_KEY) in schema || (0, _constants.ALL_OF_KEY) in schema) {
        const _schema = (0, _retrieveSchemaDefault.default)(validator, schema, rootSchema, formData);
        const sameSchemaIndex = _recurseList.findIndex((item)=>(0, _isEqualDefault.default)(item, _schema));
        if (sameSchemaIndex === -1) return toIdSchemaInternal(validator, _schema, idPrefix, idSeparator, id, rootSchema, formData, _recurseList.concat(_schema));
    }
    if ((0, _constants.ITEMS_KEY) in schema && !(0, _getDefault.default)(schema, [
        (0, _constants.ITEMS_KEY),
        (0, _constants.REF_KEY)
    ])) return toIdSchemaInternal(validator, (0, _getDefault.default)(schema, (0, _constants.ITEMS_KEY)), idPrefix, idSeparator, id, rootSchema, formData, _recurseList);
    const $id = id || idPrefix;
    const idSchema = {
        $id
    };
    if ((0, _getSchemaTypeDefault.default)(schema) === "object" && (0, _constants.PROPERTIES_KEY) in schema) for(const name in schema.properties){
        const field = (0, _getDefault.default)(schema, [
            (0, _constants.PROPERTIES_KEY),
            name
        ]);
        const fieldId = idSchema[0, _constants.ID_KEY] + idSeparator + name;
        idSchema[name] = toIdSchemaInternal(validator, (0, _isObjectDefault.default)(field) ? field : {}, idPrefix, idSeparator, fieldId, rootSchema, // It's possible that formData is not an object -- this can happen if an
        // array item has just been added, but not populated with data yet
        (0, _getDefault.default)(formData, [
            name
        ]), _recurseList);
    }
    return idSchema;
}
function toIdSchema(validator, schema, id, rootSchema, formData, idPrefix = "root", idSeparator = "_") {
    return toIdSchemaInternal(validator, schema, idPrefix, idSeparator, id, rootSchema, formData);
}

},{"lodash/get":"8z6tS","lodash/isEqual":"64pmh","../constants":"a1fVD","../isObject":"fyldM","./retrieveSchema":"jAKxQ","../getSchemaType":"emxZR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b8JdB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPathSchema);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _constants = require("../constants");
var _getDiscriminatorFieldFromSchema = require("../getDiscriminatorFieldFromSchema");
var _getDiscriminatorFieldFromSchemaDefault = parcelHelpers.interopDefault(_getDiscriminatorFieldFromSchema);
var _getClosestMatchingOption = require("./getClosestMatchingOption");
var _getClosestMatchingOptionDefault = parcelHelpers.interopDefault(_getClosestMatchingOption);
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
/** An internal helper that generates an `PathSchema` object for the `schema`, recursively with protection against
 * infinite recursion
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used when necessary
 * @param schema - The schema for which the `PathSchema` is desired
 * @param [name=''] - The base name for the schema
 * @param [rootSchema] - The root schema, used to primarily to look up `$ref`s
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @param [_recurseList=[]] - The list of retrieved schemas currently being recursed, used to prevent infinite recursion
 * @returns - The `PathSchema` object for the `schema`
 */ function toPathSchemaInternal(validator, schema, name, rootSchema, formData, _recurseList = []) {
    if ((0, _constants.REF_KEY) in schema || (0, _constants.DEPENDENCIES_KEY) in schema || (0, _constants.ALL_OF_KEY) in schema) {
        const _schema = (0, _retrieveSchemaDefault.default)(validator, schema, rootSchema, formData);
        const sameSchemaIndex = _recurseList.findIndex((item)=>(0, _isEqualDefault.default)(item, _schema));
        if (sameSchemaIndex === -1) return toPathSchemaInternal(validator, _schema, name, rootSchema, formData, _recurseList.concat(_schema));
    }
    let pathSchema = {
        [(0, _constants.NAME_KEY)]: name.replace(/^\./, "")
    };
    if ((0, _constants.ONE_OF_KEY) in schema || (0, _constants.ANY_OF_KEY) in schema) {
        const xxxOf = (0, _constants.ONE_OF_KEY) in schema ? schema.oneOf : schema.anyOf;
        const discriminator = (0, _getDiscriminatorFieldFromSchemaDefault.default)(schema);
        const index = (0, _getClosestMatchingOptionDefault.default)(validator, rootSchema, formData, xxxOf, 0, discriminator);
        const _schema = xxxOf[index];
        pathSchema = {
            ...pathSchema,
            ...toPathSchemaInternal(validator, _schema, name, rootSchema, formData, _recurseList)
        };
    }
    if ((0, _constants.ADDITIONAL_PROPERTIES_KEY) in schema && schema[0, _constants.ADDITIONAL_PROPERTIES_KEY] !== false) (0, _setDefault.default)(pathSchema, (0, _constants.RJSF_ADDITIONAL_PROPERTIES_FLAG), true);
    if ((0, _constants.ITEMS_KEY) in schema && Array.isArray(formData)) {
        const { items: schemaItems, additionalItems: schemaAdditionalItems } = schema;
        if (Array.isArray(schemaItems)) formData.forEach((element, i)=>{
            if (schemaItems[i]) pathSchema[i] = toPathSchemaInternal(validator, schemaItems[i], `${name}.${i}`, rootSchema, element, _recurseList);
            else if (schemaAdditionalItems) pathSchema[i] = toPathSchemaInternal(validator, schemaAdditionalItems, `${name}.${i}`, rootSchema, element, _recurseList);
            else console.warn(`Unable to generate path schema for "${name}.${i}". No schema defined for it`);
        });
        else formData.forEach((element, i)=>{
            pathSchema[i] = toPathSchemaInternal(validator, schemaItems, `${name}.${i}`, rootSchema, element, _recurseList);
        });
    } else if ((0, _constants.PROPERTIES_KEY) in schema) for(const property in schema.properties){
        const field = (0, _getDefault.default)(schema, [
            (0, _constants.PROPERTIES_KEY),
            property
        ]);
        pathSchema[property] = toPathSchemaInternal(validator, field, `${name}.${property}`, rootSchema, // It's possible that formData is not an object -- this can happen if an
        // array item has just been added, but not populated with data yet
        (0, _getDefault.default)(formData, [
            property
        ]), _recurseList);
    }
    return pathSchema;
}
function toPathSchema(validator, schema, name = "", rootSchema, formData) {
    return toPathSchemaInternal(validator, schema, name, rootSchema, formData);
}

},{"lodash/get":"8z6tS","lodash/isEqual":"64pmh","lodash/set":"dUuaa","../constants":"a1fVD","../getDiscriminatorFieldFromSchema":"guLol","./getClosestMatchingOption":"ll5Tj","./retrieveSchema":"jAKxQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9eYC1":[function(require,module,exports) {
/** Given the `FileReader.readAsDataURL()` based `dataURI` extracts that data into an actual Blob along with the name
 * of that Blob if provided in the URL. If no name is provided, then the name falls back to `unknown`.
 *
 * @param dataURI - The `DataUrl` potentially containing name and raw data to be converted to a Blob
 * @returns - an object containing a Blob and its name, extracted from the URI
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dataURItoBlob);
function dataURItoBlob(dataURILike) {
    var _a;
    // check if is dataURI
    if (dataURILike.indexOf("data:") === -1) throw new Error("File is invalid: URI must be a dataURI");
    const dataURI = dataURILike.slice(5);
    // split the dataURI into media and base64, with the base64 signature
    const splitted = dataURI.split(";base64,");
    // if the base64 signature is not present, the latter part will become empty
    if (splitted.length !== 2) throw new Error("File is invalid: dataURI must be base64");
    // extract the mime type, media parameters including the name, and the base64 string
    const [media, base64] = splitted;
    const [mime, ...mediaparams] = media.split(";");
    const type = mime || "";
    // extract the name from the parameters
    const name = decodeURI(// parse the parameters into key-value pairs, find a key, and extract a value
    // if no key is found, then the name is unknown
    ((_a = mediaparams.map((param)=>param.split("=")).find(([key])=>key === "name")) === null || _a === void 0 ? void 0 : _a[1]) || "unknown");
    // Built the Uint8Array Blob parameter from the base64 string.
    try {
        const binary = atob(base64);
        const array = new Array(binary.length);
        for(let i = 0; i < binary.length; i++)array[i] = binary.charCodeAt(i);
        // Create the blob object
        const blob = new window.Blob([
            new Uint8Array(array)
        ], {
            type
        });
        return {
            blob,
            name
        };
    } catch (error) {
        throw new Error("File is invalid: " + error.message);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Vvutm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>englishStringTranslator);
var _replaceStringParameters = require("./replaceStringParameters");
var _replaceStringParametersDefault = parcelHelpers.interopDefault(_replaceStringParameters);
function englishStringTranslator(stringToTranslate, params) {
    return (0, _replaceStringParametersDefault.default)(stringToTranslate, params);
}

},{"./replaceStringParameters":"ern13","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ern13":[function(require,module,exports) {
/** Potentially substitutes all replaceable parameters with the associated value(s) from the `params` if available. When
 * a `params` array is provided, each value in the array is used to replace any of the replaceable parameters in the
 * `inputString` using the `%1`, `%2`, etc. replacement specifiers.
 *
 * @param inputString - The string which will be potentially updated with replacement parameters
 * @param params - The optional list of replaceable parameter values to substitute into the english string
 * @returns - The updated string with any replacement specifiers replaced
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>replaceStringParameters);
function replaceStringParameters(inputString, params) {
    let output = inputString;
    if (Array.isArray(params)) {
        const parts = output.split(/(%\d)/);
        params.forEach((param, index)=>{
            const partIndex = parts.findIndex((part)=>part === `%${index + 1}`);
            if (partIndex >= 0) parts[partIndex] = param;
        });
        output = parts.join("");
    }
    return output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Rv59":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>enumOptionsDeselectValue);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _enumOptionsValueForIndex = require("./enumOptionsValueForIndex");
var _enumOptionsValueForIndexDefault = parcelHelpers.interopDefault(_enumOptionsValueForIndex);
function enumOptionsDeselectValue(valueIndex, selected, allEnumOptions = []) {
    const value = (0, _enumOptionsValueForIndexDefault.default)(valueIndex, allEnumOptions);
    if (Array.isArray(selected)) return selected.filter((v)=>!(0, _isEqualDefault.default)(v, value));
    return (0, _isEqualDefault.default)(value, selected) ? undefined : selected;
}

},{"lodash/isEqual":"64pmh","./enumOptionsValueForIndex":"67dpy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"67dpy":[function(require,module,exports) {
/** Returns the value(s) from `allEnumOptions` at the index(es) provided by `valueIndex`. If `valueIndex` is not an
 * array AND the index is not valid for `allEnumOptions`, `emptyValue` is returned. If `valueIndex` is an array, AND it
 * contains an invalid index, the returned array will have the resulting undefined values filtered out, leaving only
 * valid values or in the worst case, an empty array.
 *
 * @param valueIndex - The index(es) of the value(s) that should be returned
 * @param [allEnumOptions=[]] - The list of all the known enumOptions
 * @param [emptyValue] - The value to return when the non-array `valueIndex` does not refer to a real option
 * @returns - The single or list of values specified by the single or list of indexes if they are valid. Otherwise,
 *        `emptyValue` or an empty list.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>enumOptionsValueForIndex);
function enumOptionsValueForIndex(valueIndex, allEnumOptions = [], emptyValue) {
    if (Array.isArray(valueIndex)) return valueIndex.map((index)=>enumOptionsValueForIndex(index, allEnumOptions))// Since the recursive call returns `emptyValue` when we get a bad option, only filter those out
    .filter((val)=>val !== emptyValue);
    // So Number(null) and Number('') both return 0, so use emptyValue for those two values
    const index = valueIndex === "" || valueIndex === null ? -1 : Number(valueIndex);
    const option = allEnumOptions[index];
    return option ? option.value : emptyValue;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4mngm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>enumOptionsIndexForValue);
var _enumOptionsIsSelected = require("./enumOptionsIsSelected");
var _enumOptionsIsSelectedDefault = parcelHelpers.interopDefault(_enumOptionsIsSelected);
function enumOptionsIndexForValue(value, allEnumOptions = [], multiple = false) {
    const selectedIndexes = allEnumOptions.map((opt, index)=>(0, _enumOptionsIsSelectedDefault.default)(opt.value, value) ? String(index) : undefined).filter((opt)=>typeof opt !== "undefined");
    if (!multiple) return selectedIndexes[0];
    return selectedIndexes;
}

},{"./enumOptionsIsSelected":"lNily","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lNily":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>enumOptionsIsSelected);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
function enumOptionsIsSelected(value, selected) {
    if (Array.isArray(selected)) return selected.some((sel)=>(0, _isEqualDefault.default)(sel, value));
    return (0, _isEqualDefault.default)(selected, value);
}

},{"lodash/isEqual":"64pmh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eSFXc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>enumOptionsSelectValue);
var _enumOptionsValueForIndex = require("./enumOptionsValueForIndex");
var _enumOptionsValueForIndexDefault = parcelHelpers.interopDefault(_enumOptionsValueForIndex);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
function enumOptionsSelectValue(valueIndex, selected, allEnumOptions = []) {
    const value = (0, _enumOptionsValueForIndexDefault.default)(valueIndex, allEnumOptions);
    if (!(0, _isNilDefault.default)(value)) {
        const index = allEnumOptions.findIndex((opt)=>value === opt.value);
        const all = allEnumOptions.map(({ value: val })=>val);
        const updated = selected.slice(0, index).concat(value, selected.slice(index));
        // As inserting values at predefined index positions doesn't work with empty
        // arrays, we need to reorder the updated selection to match the initial order
        return updated.sort((a, b)=>Number(all.indexOf(a) > all.indexOf(b)));
    }
    return selected;
}

},{"./enumOptionsValueForIndex":"67dpy","lodash/isNil":"22Z0b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"22Z0b":[function(require,module,exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function isNil(value) {
    return value == null;
}
module.exports = isNil;

},{}],"ffpV1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneDeep = require("lodash/cloneDeep");
var _cloneDeepDefault = parcelHelpers.interopDefault(_cloneDeep);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _constants = require("./constants");
class ErrorSchemaBuilder {
    /** Construct an `ErrorSchemaBuilder` with an optional initial set of errors in an `ErrorSchema`.
     *
     * @param [initialSchema] - The optional set of initial errors, that will be cloned into the class
     */ constructor(initialSchema){
        /** The error schema being built
         *
         * @private
         */ this.errorSchema = {};
        this.resetAllErrors(initialSchema);
    }
    /** Returns the `ErrorSchema` that has been updated by the methods of the `ErrorSchemaBuilder`
     */ get ErrorSchema() {
        return this.errorSchema;
    }
    /** Will get an existing `ErrorSchema` at the specified `pathOfError` or create and return one.
     *
     * @param [pathOfError] - The optional path into the `ErrorSchema` at which to add the error(s)
     * @returns - The error block for the given `pathOfError` or the root if not provided
     * @private
     */ getOrCreateErrorBlock(pathOfError) {
        const hasPath = Array.isArray(pathOfError) && pathOfError.length > 0 || typeof pathOfError === "string";
        let errorBlock = hasPath ? (0, _getDefault.default)(this.errorSchema, pathOfError) : this.errorSchema;
        if (!errorBlock && pathOfError) {
            errorBlock = {};
            (0, _setDefault.default)(this.errorSchema, pathOfError, errorBlock);
        }
        return errorBlock;
    }
    /** Resets all errors in the `ErrorSchemaBuilder` back to the `initialSchema` if provided, otherwise an empty set.
     *
     * @param [initialSchema] - The optional set of initial errors, that will be cloned into the class
     * @returns - The `ErrorSchemaBuilder` object for chaining purposes
     */ resetAllErrors(initialSchema) {
        this.errorSchema = initialSchema ? (0, _cloneDeepDefault.default)(initialSchema) : {};
        return this;
    }
    /** Adds the `errorOrList` to the list of errors in the `ErrorSchema` at either the root level or the location within
     * the schema described by the `pathOfError`. For more information about how to specify the path see the
     * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
     *
     * @param errorOrList - The error or list of errors to add into the `ErrorSchema`
     * @param [pathOfError] - The optional path into the `ErrorSchema` at which to add the error(s)
     * @returns - The `ErrorSchemaBuilder` object for chaining purposes
     */ addErrors(errorOrList, pathOfError) {
        const errorBlock = this.getOrCreateErrorBlock(pathOfError);
        let errorsList = (0, _getDefault.default)(errorBlock, (0, _constants.ERRORS_KEY));
        if (!Array.isArray(errorsList)) {
            errorsList = [];
            errorBlock[0, _constants.ERRORS_KEY] = errorsList;
        }
        if (Array.isArray(errorOrList)) errorsList.push(...errorOrList);
        else errorsList.push(errorOrList);
        return this;
    }
    /** Sets/replaces the `errorOrList` as the error(s) in the `ErrorSchema` at either the root level or the location
     * within the schema described by the `pathOfError`. For more information about how to specify the path see the
     * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
     *
     * @param errorOrList - The error or list of errors to set into the `ErrorSchema`
     * @param [pathOfError] - The optional path into the `ErrorSchema` at which to set the error(s)
     * @returns - The `ErrorSchemaBuilder` object for chaining purposes
     */ setErrors(errorOrList, pathOfError) {
        const errorBlock = this.getOrCreateErrorBlock(pathOfError);
        // Effectively clone the array being given to prevent accidental outside manipulation of the given list
        const listToAdd = Array.isArray(errorOrList) ? [
            ...errorOrList
        ] : [
            errorOrList
        ];
        (0, _setDefault.default)(errorBlock, (0, _constants.ERRORS_KEY), listToAdd);
        return this;
    }
    /** Clears the error(s) in the `ErrorSchema` at either the root level or the location within the schema described by
     * the `pathOfError`. For more information about how to specify the path see the
     * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
     *
     * @param [pathOfError] - The optional path into the `ErrorSchema` at which to clear the error(s)
     * @returns - The `ErrorSchemaBuilder` object for chaining purposes
     */ clearErrors(pathOfError) {
        const errorBlock = this.getOrCreateErrorBlock(pathOfError);
        (0, _setDefault.default)(errorBlock, (0, _constants.ERRORS_KEY), []);
        return this;
    }
}
exports.default = ErrorSchemaBuilder;

},{"lodash/cloneDeep":"caEbI","lodash/get":"8z6tS","lodash/set":"dUuaa","./constants":"a1fVD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7kPzQ":[function(require,module,exports) {
/** Given date & time information with optional yearRange & format, returns props for DateElement
 *
 * @param date - Object containing date with optional time information
 * @param time - Determines whether to include time or not
 * @param [yearRange=[1900, new Date().getFullYear() + 2]] - Controls the list of years to be displayed
 * @param [format='YMD'] - Controls the order in which day, month and year input element will be displayed
 * @returns Array of props for DateElement
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDateElementProps);
function getDateElementProps(date, time, yearRange = [
    1900,
    new Date().getFullYear() + 2
], format = "YMD") {
    const { day, month, year, hour, minute, second } = date;
    const dayObj = {
        type: "day",
        range: [
            1,
            31
        ],
        value: day
    };
    const monthObj = {
        type: "month",
        range: [
            1,
            12
        ],
        value: month
    };
    const yearObj = {
        type: "year",
        range: yearRange,
        value: year
    };
    const dateElementProp = [];
    switch(format){
        case "MDY":
            dateElementProp.push(monthObj, dayObj, yearObj);
            break;
        case "DMY":
            dateElementProp.push(dayObj, monthObj, yearObj);
            break;
        case "YMD":
        default:
            dateElementProp.push(yearObj, monthObj, dayObj);
    }
    if (time) dateElementProp.push({
        type: "hour",
        range: [
            0,
            23
        ],
        value: hour
    }, {
        type: "minute",
        range: [
            0,
            59
        ],
        value: minute
    }, {
        type: "second",
        range: [
            0,
            59
        ],
        value: second
    });
    return dateElementProp;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8U2MT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getInputProps);
var _rangeSpec = require("./rangeSpec");
var _rangeSpecDefault = parcelHelpers.interopDefault(_rangeSpec);
function getInputProps(schema, defaultType, options = {}, autoDefaultStepAny = true) {
    const inputProps = {
        type: defaultType || "text",
        ...(0, _rangeSpecDefault.default)(schema)
    };
    // If options.inputType is set use that as the input type
    if (options.inputType) inputProps.type = options.inputType;
    else if (!defaultType) {
        // If the schema is of type number or integer, set the input type to number
        if (schema.type === "number") {
            inputProps.type = "number";
            // Only add step if one isn't already defined and we are auto-defaulting the "any" step
            if (autoDefaultStepAny && inputProps.step === undefined) // Setting step to 'any' fixes a bug in Safari where decimals are not
            // allowed in number inputs
            inputProps.step = "any";
        } else if (schema.type === "integer") {
            inputProps.type = "number";
            // Only add step if one isn't already defined
            if (inputProps.step === undefined) // Since this is integer, you always want to step up or down in multiples of 1
            inputProps.step = 1;
        }
    }
    if (options.autocomplete) inputProps.autoComplete = options.autocomplete;
    return inputProps;
}

},{"./rangeSpec":"3gz6q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3gz6q":[function(require,module,exports) {
/** Extracts the range spec information `{ step?: number, min?: number, max?: number }` that can be spread onto an HTML
 * input from the range analog in the schema `{ multipleOf?: number, minimum?: number, maximum?: number }`.
 *
 * @param schema - The schema from which to extract the range spec
 * @returns - A range specification from the schema
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rangeSpec);
function rangeSpec(schema) {
    const spec = {};
    if (schema.multipleOf) spec.step = schema.multipleOf;
    if (schema.minimum || schema.minimum === 0) spec.min = schema.minimum;
    if (schema.maximum || schema.maximum === 0) spec.max = schema.maximum;
    return spec;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aQRT7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_OPTIONS", ()=>DEFAULT_OPTIONS);
parcelHelpers.export(exports, "default", ()=>getSubmitButtonOptions);
var _constants = require("./constants");
var _getUiOptions = require("./getUiOptions");
var _getUiOptionsDefault = parcelHelpers.interopDefault(_getUiOptions);
const DEFAULT_OPTIONS = {
    props: {
        disabled: false
    },
    submitText: "Submit",
    norender: false
};
function getSubmitButtonOptions(uiSchema = {}) {
    const uiOptions = (0, _getUiOptionsDefault.default)(uiSchema);
    if (uiOptions && uiOptions[0, _constants.SUBMIT_BTN_OPTIONS_KEY]) {
        const options = uiOptions[0, _constants.SUBMIT_BTN_OPTIONS_KEY];
        return {
            ...DEFAULT_OPTIONS,
            ...options
        };
    }
    return DEFAULT_OPTIONS;
}

},{"./constants":"a1fVD","./getUiOptions":"ecGOw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Eslw":[function(require,module,exports) {
/** Returns the template with the given `name` from either the `uiSchema` if it is defined or from the `registry`
 * otherwise. NOTE, since `ButtonTemplates` are not overridden in `uiSchema` only those in the `registry` are returned.
 *
 * @param name - The name of the template to fetch, restricted to the keys of `TemplatesType`
 * @param registry - The `Registry` from which to read the template
 * @param [uiOptions={}] - The `UIOptionsType` from which to read an alternate template
 * @returns - The template from either the `uiSchema` or `registry` for the `name`
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTemplate);
function getTemplate(name, registry, uiOptions = {}) {
    const { templates } = registry;
    if (name === "ButtonTemplates") return templates[name];
    return(// Evaluating uiOptions[name] results in TS2590: Expression produces a union type that is too complex to represent
    // To avoid that, we cast uiOptions to `any` before accessing the name field
    uiOptions[name] || templates[name]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ggI8e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactIs = require("react-is");
var _reactIsDefault = parcelHelpers.interopDefault(_reactIs);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _getSchemaType = require("./getSchemaType");
var _getSchemaTypeDefault = parcelHelpers.interopDefault(_getSchemaType);
/** The map of schema types to widget type to widget name
 */ const widgetMap = {
    boolean: {
        checkbox: "CheckboxWidget",
        radio: "RadioWidget",
        select: "SelectWidget",
        hidden: "HiddenWidget"
    },
    string: {
        text: "TextWidget",
        password: "PasswordWidget",
        email: "EmailWidget",
        hostname: "TextWidget",
        ipv4: "TextWidget",
        ipv6: "TextWidget",
        uri: "URLWidget",
        "data-url": "FileWidget",
        radio: "RadioWidget",
        select: "SelectWidget",
        textarea: "TextareaWidget",
        hidden: "HiddenWidget",
        date: "DateWidget",
        datetime: "DateTimeWidget",
        "date-time": "DateTimeWidget",
        "alt-date": "AltDateWidget",
        "alt-datetime": "AltDateTimeWidget",
        time: "TimeWidget",
        color: "ColorWidget",
        file: "FileWidget"
    },
    number: {
        text: "TextWidget",
        select: "SelectWidget",
        updown: "UpDownWidget",
        range: "RangeWidget",
        radio: "RadioWidget",
        hidden: "HiddenWidget"
    },
    integer: {
        text: "TextWidget",
        select: "SelectWidget",
        updown: "UpDownWidget",
        range: "RangeWidget",
        radio: "RadioWidget",
        hidden: "HiddenWidget"
    },
    array: {
        select: "SelectWidget",
        checkboxes: "CheckboxesWidget",
        files: "FileWidget",
        hidden: "HiddenWidget"
    }
};
/** Wraps the given widget with stateless functional component that will merge any `defaultProps.options` with the
 * `options` that are provided in the props. It will add the wrapper component as a `MergedWidget` property onto the
 * `Widget` so that future attempts to wrap `AWidget` will return the already existing wrapper.
 *
 * @param AWidget - A widget that will be wrapped or one that is already wrapped
 * @returns - The wrapper widget
 */ function mergeWidgetOptions(AWidget) {
    let MergedWidget = (0, _getDefault.default)(AWidget, "MergedWidget");
    // cache return value as property of widget for proper react reconciliation
    if (!MergedWidget) {
        const defaultOptions = AWidget.defaultProps && AWidget.defaultProps.options || {};
        MergedWidget = ({ options, ...props })=>{
            return (0, _jsxRuntime.jsx)(AWidget, {
                options: {
                    ...defaultOptions,
                    ...options
                },
                ...props
            });
        };
        (0, _setDefault.default)(AWidget, "MergedWidget", MergedWidget);
    }
    return MergedWidget;
}
function getWidget(schema, widget, registeredWidgets = {}) {
    const type = (0, _getSchemaTypeDefault.default)(schema);
    if (typeof widget === "function" || widget && (0, _reactIsDefault.default).isForwardRef((0, _react.createElement)(widget)) || (0, _reactIsDefault.default).isMemo(widget)) return mergeWidgetOptions(widget);
    if (typeof widget !== "string") throw new Error(`Unsupported widget definition: ${typeof widget}`);
    if (widget in registeredWidgets) {
        const registeredWidget = registeredWidgets[widget];
        return getWidget(schema, registeredWidget, registeredWidgets);
    }
    if (typeof type === "string") {
        if (!(type in widgetMap)) throw new Error(`No widget for type '${type}'`);
        if (widget in widgetMap[type]) {
            const registeredWidget = registeredWidgets[widgetMap[type][widget]];
            return getWidget(schema, registeredWidget, registeredWidgets);
        }
    }
    throw new Error(`No widget '${widget}' for type '${type}'`);
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-is":"aUAsc","lodash/get":"8z6tS","lodash/set":"dUuaa","./getSchemaType":"emxZR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaGEj":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"kbpKW"}],"kbpKW":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"6uln9"}],"aUAsc":[function(require,module,exports) {
"use strict";
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"1Qg5l"}],"1Qg5l":[function(require,module,exports) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"kvlp9":[function(require,module,exports) {
/** JS has no built-in hashing function, so rolling our own
 *  based on Java's hashing fn:
 *  http://www.java2s.com/example/nodejs-utility-method/string-hash/hashcode-4dc2b.html
 *
 * @param string - The string for which to get the hash
 * @returns - The resulting hash of the string in hex format
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hashForSchema);
function hashString(string) {
    let hash = 0;
    for(let i = 0; i < string.length; i += 1){
        const chr = string.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash.toString(16);
}
function hashForSchema(schema) {
    const allKeys = new Set();
    // solution source: https://stackoverflow.com/questions/16167581/sort-object-properties-and-json-stringify/53593328#53593328
    JSON.stringify(schema, (key, value)=>(allKeys.add(key), value));
    return hashString(JSON.stringify(schema, Array.from(allKeys).sort()));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aJJn6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasWidget);
var _getWidget = require("./getWidget");
var _getWidgetDefault = parcelHelpers.interopDefault(_getWidget);
function hasWidget(schema, widget, registeredWidgets = {}) {
    try {
        (0, _getWidgetDefault.default)(schema, widget, registeredWidgets);
        return true;
    } catch (e) {
        const err = e;
        if (err.message && (err.message.startsWith("No widget") || err.message.startsWith("Unsupported widget"))) return false;
        throw e;
    }
}

},{"./getWidget":"ggI8e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2MXL4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Return a consistent `id` for the field description element
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @returns - The consistent id for the field description element from the given `id`
 */ parcelHelpers.export(exports, "descriptionId", ()=>descriptionId);
/** Return a consistent `id` for the field error element
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @returns - The consistent id for the field error element from the given `id`
 */ parcelHelpers.export(exports, "errorId", ()=>errorId);
/** Return a consistent `id` for the field examples element
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @returns - The consistent id for the field examples element from the given `id`
 */ parcelHelpers.export(exports, "examplesId", ()=>examplesId);
/** Return a consistent `id` for the field help element
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @returns - The consistent id for the field help element from the given `id`
 */ parcelHelpers.export(exports, "helpId", ()=>helpId);
/** Return a consistent `id` for the field title element
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @returns - The consistent id for the field title element from the given `id`
 */ parcelHelpers.export(exports, "titleId", ()=>titleId);
/** Return a list of element ids that contain additional information about the field that can be used to as the aria
 * description of the field. This is correctly omitting `titleId` which would be "labeling" rather than "describing" the
 * element.
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @param [includeExamples=false] - Optional flag, if true, will add the `examplesId` into the list
 * @returns - The string containing the list of ids for use in an `aria-describedBy` attribute
 */ parcelHelpers.export(exports, "ariaDescribedByIds", ()=>ariaDescribedByIds);
/** Return a consistent `id` for the `optionIndex`s of a `Radio` or `Checkboxes` widget
 *
 * @param id - The id of the parent component for the option
 * @param optionIndex - The index of the option for which the id is desired
 * @returns - An id for the option index based on the parent `id`
 */ parcelHelpers.export(exports, "optionId", ()=>optionId);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _constants = require("./constants");
/** Generates a consistent `id` pattern for a given `id` and a `suffix`
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @param suffix - The suffix to append to the id
 */ function idGenerator(id, suffix) {
    const theId = (0, _isStringDefault.default)(id) ? id : id[0, _constants.ID_KEY];
    return `${theId}__${suffix}`;
}
function descriptionId(id) {
    return idGenerator(id, "description");
}
function errorId(id) {
    return idGenerator(id, "error");
}
function examplesId(id) {
    return idGenerator(id, "examples");
}
function helpId(id) {
    return idGenerator(id, "help");
}
function titleId(id) {
    return idGenerator(id, "title");
}
function ariaDescribedByIds(id, includeExamples = false) {
    const examples = includeExamples ? ` ${examplesId(id)}` : "";
    return `${errorId(id)} ${descriptionId(id)} ${helpId(id)}${examples}`;
}
function optionId(id, optionIndex) {
    return `${id}-${optionIndex}`;
}

},{"lodash/isString":"hjD1s","./constants":"a1fVD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eNF0G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>labelValue);
function labelValue(label, hideLabel, fallback) {
    return hideLabel ? fallback : label;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Axej":[function(require,module,exports) {
/** Converts a local Date string into a UTC date string
 *
 * @param dateString - The string representation of a date as accepted by the `Date()` constructor
 * @returns - A UTC date string if `dateString` is truthy, otherwise undefined
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>localToUTC);
function localToUTC(dateString) {
    return dateString ? new Date(dateString).toJSON() : undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lprfh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>optionsList);
var _toConstant = require("./toConstant");
var _toConstantDefault = parcelHelpers.interopDefault(_toConstant);
function optionsList(schema) {
    // enumNames was deprecated in v5 and is intentionally omitted from the RJSFSchema type.
    // Cast the type to include enumNames so the feature still works.
    const schemaWithEnumNames = schema;
    schemaWithEnumNames.enumNames;
    if (schema.enum) return schema.enum.map((value, i)=>{
        const label = schemaWithEnumNames.enumNames && schemaWithEnumNames.enumNames[i] || String(value);
        return {
            label,
            value
        };
    });
    const altSchemas = schema.oneOf || schema.anyOf;
    return altSchemas && altSchemas.map((aSchemaDef)=>{
        const aSchema = aSchemaDef;
        const value = (0, _toConstantDefault.default)(aSchema);
        const label = aSchema.title || String(value);
        return {
            schema: aSchema,
            label,
            value
        };
    });
}

},{"./toConstant":"8iXDc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8iXDc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toConstant);
var _constants = require("./constants");
function toConstant(schema) {
    if ((0, _constants.ENUM_KEY) in schema && Array.isArray(schema.enum) && schema.enum.length === 1) return schema.enum[0];
    if ((0, _constants.CONST_KEY) in schema) return schema.const;
    throw new Error("schema cannot be inferred as a constant");
}

},{"./constants":"a1fVD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5uQS0":[function(require,module,exports) {
/** Given a list of `properties` and an `order` list, returns a list that contains the `properties` ordered correctly.
 * If `order` is not an array, then the untouched `properties` list is returned. Otherwise `properties` is ordered per
 * the `order` list. If `order` contains a '*' then any `properties` that are not mentioned explicity in `order` will be
 * places in the location of the `*`.
 *
 * @param properties - The list of property keys to be ordered
 * @param order - An array of property keys to be ordered first, with an optional '*' property
 * @returns - A list with the `properties` ordered
 * @throws - Error when the properties cannot be ordered correctly
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderProperties);
function orderProperties(properties, order) {
    if (!Array.isArray(order)) return properties;
    const arrayToHash = (arr)=>arr.reduce((prev, curr)=>{
            prev[curr] = true;
            return prev;
        }, {});
    const errorPropList = (arr)=>arr.length > 1 ? `properties '${arr.join("', '")}'` : `property '${arr[0]}'`;
    const propertyHash = arrayToHash(properties);
    const orderFiltered = order.filter((prop)=>prop === "*" || propertyHash[prop]);
    const orderHash = arrayToHash(orderFiltered);
    const rest = properties.filter((prop)=>!orderHash[prop]);
    const restIndex = orderFiltered.indexOf("*");
    if (restIndex === -1) {
        if (rest.length) throw new Error(`uiSchema order list does not contain ${errorPropList(rest)}`);
        return orderFiltered;
    }
    if (restIndex !== orderFiltered.lastIndexOf("*")) throw new Error("uiSchema order list contains more than one wildcard item");
    const complete = [
        ...orderFiltered
    ];
    complete.splice(restIndex, 1, ...rest);
    return complete;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"65FmP":[function(require,module,exports) {
/** Returns a string representation of the `num` that is padded with leading "0"s if necessary
 *
 * @param num - The number to pad
 * @param width - The width of the string at which no lead padding is necessary
 * @returns - The number converted to a string with leading zero padding if the number of digits is less than `width`
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pad);
function pad(num, width) {
    let s = String(num);
    while(s.length < width)s = "0" + s;
    return s;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Dlwy":[function(require,module,exports) {
/** Parses the `dateString` into a `DateObject`, including the time information when `includeTime` is true
 *
 * @param dateString - The date string to parse into a DateObject
 * @param [includeTime=true] - Optional flag, if false, will not include the time data into the object
 * @returns - The date string converted to a `DateObject`
 * @throws - Error when the date cannot be parsed from the string
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseDateString);
function parseDateString(dateString, includeTime = true) {
    if (!dateString) return {
        year: -1,
        month: -1,
        day: -1,
        hour: includeTime ? -1 : 0,
        minute: includeTime ? -1 : 0,
        second: includeTime ? -1 : 0
    };
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) throw new Error("Unable to parse date " + dateString);
    return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        day: date.getUTCDate(),
        hour: includeTime ? date.getUTCHours() : 0,
        minute: includeTime ? date.getUTCMinutes() : 0,
        second: includeTime ? date.getUTCSeconds() : 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kWjb7":[function(require,module,exports) {
/** Check to see if a `schema` specifies that a value must be true. This happens when:
 * - `schema.const` is truthy
 * - `schema.enum` == `[true]`
 * - `schema.anyOf` or `schema.oneOf` has a single value which recursively returns true
 * - `schema.allOf` has at least one value which recursively returns true
 *
 * @param schema - The schema to check
 * @returns - True if the schema specifies a value that must be true, false otherwise
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>schemaRequiresTrueValue);
function schemaRequiresTrueValue(schema) {
    // Check if const is a truthy value
    if (schema.const) return true;
    // Check if an enum has a single value of true
    if (schema.enum && schema.enum.length === 1 && schema.enum[0] === true) return true;
    // If anyOf has a single value, evaluate the subschema
    if (schema.anyOf && schema.anyOf.length === 1) return schemaRequiresTrueValue(schema.anyOf[0]);
    // If oneOf has a single value, evaluate the subschema
    if (schema.oneOf && schema.oneOf.length === 1) return schemaRequiresTrueValue(schema.oneOf[0]);
    // Evaluate each subschema in allOf, to see if one of them requires a true value
    if (schema.allOf) {
        const schemaSome = (subSchema)=>schemaRequiresTrueValue(subSchema);
        return schema.allOf.some(schemaSome);
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"22cEc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shouldRender);
var _deepEquals = require("./deepEquals");
var _deepEqualsDefault = parcelHelpers.interopDefault(_deepEquals);
function shouldRender(component, nextProps, nextState) {
    const { props, state } = component;
    return !(0, _deepEqualsDefault.default)(props, nextProps) || !(0, _deepEqualsDefault.default)(state, nextState);
}

},{"./deepEquals":"aPOCr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"knMkZ":[function(require,module,exports) {
/** Returns a UTC date string for the given `dateObject`. If `time` is false, then the time portion of the string is
 * removed.
 *
 * @param dateObject - The `DateObject` to convert to a date string
 * @param [time=true] - Optional flag used to remove the time portion of the date string if false
 * @returns - The UTC date string
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDateString);
function toDateString(dateObject, time = true) {
    const { year, month, day, hour = 0, minute = 0, second = 0 } = dateObject;
    const utcTime = Date.UTC(year, month - 1, day, hour, minute, second);
    const datetime = new Date(utcTime).toJSON();
    return time ? datetime : datetime.slice(0, 10);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lMK8U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toErrorList);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _constants = require("./constants");
function toErrorList(errorSchema, fieldPath = []) {
    if (!errorSchema) return [];
    let errorList = [];
    if ((0, _constants.ERRORS_KEY) in errorSchema) errorList = errorList.concat(errorSchema[0, _constants.ERRORS_KEY].map((message)=>{
        const property = `.${fieldPath.join(".")}`;
        return {
            property,
            message,
            stack: `${property} ${message}`
        };
    }));
    return Object.keys(errorSchema).reduce((acc, key)=>{
        if (key !== (0, _constants.ERRORS_KEY)) {
            const childSchema = errorSchema[key];
            if ((0, _isPlainObjectDefault.default)(childSchema)) acc = acc.concat(toErrorList(childSchema, [
                ...fieldPath,
                key
            ]));
        }
        return acc;
    }, errorList);
}

},{"lodash/isPlainObject":"aYsgZ","./constants":"a1fVD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1FML1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toErrorSchema);
var _toPath = require("lodash/toPath");
var _toPathDefault = parcelHelpers.interopDefault(_toPath);
var _errorSchemaBuilder = require("./ErrorSchemaBuilder");
var _errorSchemaBuilderDefault = parcelHelpers.interopDefault(_errorSchemaBuilder);
function toErrorSchema(errors) {
    const builder = new (0, _errorSchemaBuilderDefault.default)();
    if (errors.length) errors.forEach((error)=>{
        const { property, message } = error;
        // When the property is the root element, just use an empty array for the path
        const path = property === "." ? [] : (0, _toPathDefault.default)(property);
        // If the property is at the root (.level1) then toPath creates
        // an empty array element at the first index. Remove it.
        if (path.length > 0 && path[0] === "") path.splice(0, 1);
        if (message) builder.addErrors(message, path);
    });
    return builder.ErrorSchema;
}

},{"lodash/toPath":"3LAmY","./ErrorSchemaBuilder":"ffpV1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3LAmY":[function(require,module,exports) {
var arrayMap = require("7ba7869940617745"), copyArray = require("8a8afdd7f66c30d3"), isArray = require("1326c29ab72d9c5a"), isSymbol = require("a182054f85505cf4"), stringToPath = require("e75722fcac9a080"), toKey = require("43c6affe82c9fa11"), toString = require("b80a77da9aba90a8");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function toPath(value) {
    if (isArray(value)) return arrayMap(value, toKey);
    return isSymbol(value) ? [
        value
    ] : copyArray(stringToPath(toString(value)));
}
module.exports = toPath;

},{"7ba7869940617745":"fahvZ","8a8afdd7f66c30d3":"7vKch","1326c29ab72d9c5a":"2VsjV","a182054f85505cf4":"3DsXL","e75722fcac9a080":"l2nFh","43c6affe82c9fa11":"e9p91","b80a77da9aba90a8":"j8269"}],"k2o85":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unwrapErrorHandler);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
function unwrapErrorHandler(errorHandler) {
    return Object.keys(errorHandler).reduce((acc, key)=>{
        if (key === "addError") return acc;
        else {
            const childSchema = errorHandler[key];
            if ((0, _isPlainObjectDefault.default)(childSchema)) return {
                ...acc,
                [key]: unwrapErrorHandler(childSchema)
            };
            return {
                ...acc,
                [key]: childSchema
            };
        }
    }, {});
}

},{"lodash/isPlainObject":"aYsgZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j1Ke2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>utcToLocal);
var _pad = require("./pad");
var _padDefault = parcelHelpers.interopDefault(_pad);
function utcToLocal(jsonDate) {
    if (!jsonDate) return "";
    // required format of `'yyyy-MM-ddThh:mm' followed by optional ':ss' or ':ss.SSS'
    // https://html.spec.whatwg.org/multipage/input.html#local-date-and-time-state-(type%3Ddatetime-local)
    // > should be a _valid local date and time string_ (not GMT)
    // Note - date constructor passed local ISO-8601 does not correctly
    // change time to UTC in node pre-8
    const date = new Date(jsonDate);
    const yyyy = (0, _padDefault.default)(date.getFullYear(), 4);
    const MM = (0, _padDefault.default)(date.getMonth() + 1, 2);
    const dd = (0, _padDefault.default)(date.getDate(), 2);
    const hh = (0, _padDefault.default)(date.getHours(), 2);
    const mm = (0, _padDefault.default)(date.getMinutes(), 2);
    const ss = (0, _padDefault.default)(date.getSeconds(), 2);
    const SSS = (0, _padDefault.default)(date.getMilliseconds(), 3);
    return `${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}.${SSS}`;
}

},{"./pad":"65FmP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e591F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>validationDataMerge);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _mergeObjects = require("./mergeObjects");
var _mergeObjectsDefault = parcelHelpers.interopDefault(_mergeObjects);
var _toErrorList = require("./toErrorList");
var _toErrorListDefault = parcelHelpers.interopDefault(_toErrorList);
function validationDataMerge(validationData, additionalErrorSchema) {
    if (!additionalErrorSchema) return validationData;
    const { errors: oldErrors, errorSchema: oldErrorSchema } = validationData;
    let errors = (0, _toErrorListDefault.default)(additionalErrorSchema);
    let errorSchema = additionalErrorSchema;
    if (!(0, _isEmptyDefault.default)(oldErrorSchema)) {
        errorSchema = (0, _mergeObjectsDefault.default)(oldErrorSchema, additionalErrorSchema, true);
        errors = [
            ...oldErrors
        ].concat(errors);
    }
    return {
        errorSchema,
        errors
    };
}

},{"lodash/isEmpty":"7pljj","./mergeObjects":"kAdf0","./toErrorList":"lMK8U","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6LZYt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>withIdRefPrefix);
var _constants = require("./constants");
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
/** Takes a `node` object and transforms any contained `$ref` node variables with a prefix, recursively calling
 * `withIdRefPrefix` for any other elements.
 *
 * @param node - The object node to which a ROOT_SCHEMA_PREFIX is added when a REF_KEY is part of it
 */ function withIdRefPrefixObject(node) {
    for(const key in node){
        const realObj = node;
        const value = realObj[key];
        if (key === (0, _constants.REF_KEY) && typeof value === "string" && value.startsWith("#")) realObj[key] = (0, _constants.ROOT_SCHEMA_PREFIX) + value;
        else realObj[key] = withIdRefPrefix(value);
    }
    return node;
}
/** Takes a `node` object list and transforms any contained `$ref` node variables with a prefix, recursively calling
 * `withIdRefPrefix` for any other elements.
 *
 * @param node - The list of object nodes to which a ROOT_SCHEMA_PREFIX is added when a REF_KEY is part of it
 */ function withIdRefPrefixArray(node) {
    for(let i = 0; i < node.length; i++)node[i] = withIdRefPrefix(node[i]);
    return node;
}
function withIdRefPrefix(schemaNode) {
    if (Array.isArray(schemaNode)) return withIdRefPrefixArray([
        ...schemaNode
    ]);
    if ((0, _isObjectDefault.default)(schemaNode)) return withIdRefPrefixObject({
        ...schemaNode
    });
    return schemaNode;
}

},{"./constants":"a1fVD","lodash/isObject":"3TlAp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"xA7kA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gZxhh":[function(require,module,exports) {
/** An enumeration of all the translatable strings used by `@rjsf/core` and its themes. The value of each of the
 * enumeration keys is expected to be the actual english string. Some strings contain replaceable parameter values
 * as indicated by `%1`, `%2`, etc. The number after the `%` indicates the order of the parameter. The ordering of
 * parameters is important because some languages may choose to put the second parameter before the first in its
 * translation. Also, some strings are rendered using `markdown-to-jsx` and thus support markdown and inline html.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TranslatableString", ()=>TranslatableString);
var TranslatableString;
(function(TranslatableString) {
    /** Fallback title of an array item, used by ArrayField */ TranslatableString["ArrayItemTitle"] = "Item";
    /** Missing items reason, used by ArrayField */ TranslatableString["MissingItems"] = "Missing items definition";
    /** Yes label, used by BooleanField */ TranslatableString["YesLabel"] = "Yes";
    /** No label, used by BooleanField */ TranslatableString["NoLabel"] = "No";
    /** Close label, used by ErrorList */ TranslatableString["CloseLabel"] = "Close";
    /** Errors label, used by ErrorList */ TranslatableString["ErrorsLabel"] = "Errors";
    /** New additionalProperties string default value, used by ObjectField */ TranslatableString["NewStringDefault"] = "New Value";
    /** Add button title, used by AddButton */ TranslatableString["AddButton"] = "Add";
    /** Add button title, used by AddButton */ TranslatableString["AddItemButton"] = "Add Item";
    /** Copy button title, used by IconButton */ TranslatableString["CopyButton"] = "Copy";
    /** Move down button title, used by IconButton */ TranslatableString["MoveDownButton"] = "Move down";
    /** Move up button title, used by IconButton */ TranslatableString["MoveUpButton"] = "Move up";
    /** Remove button title, used by IconButton */ TranslatableString["RemoveButton"] = "Remove";
    /** Now label, used by AltDateWidget */ TranslatableString["NowLabel"] = "Now";
    /** Clear label, used by AltDateWidget */ TranslatableString["ClearLabel"] = "Clear";
    /** Aria date label, used by DateWidget */ TranslatableString["AriaDateLabel"] = "Select a date";
    /** File preview label, used by FileWidget */ TranslatableString["PreviewLabel"] = "Preview";
    /** Decrement button aria label, used by UpDownWidget */ TranslatableString["DecrementAriaLabel"] = "Decrease value by 1";
    /** Increment button aria label, used by UpDownWidget */ TranslatableString["IncrementAriaLabel"] = "Increase value by 1";
    // Strings with replaceable parameters
    /** Unknown field type reason, where %1 will be replaced with the type as provided by SchemaField */ TranslatableString["UnknownFieldType"] = "Unknown field type %1";
    /** Option prefix, where %1 will be replaced with the option index as provided by MultiSchemaField */ TranslatableString["OptionPrefix"] = "Option %1";
    /** Option prefix, where %1 and %2 will be replaced by the schema title and option index, respectively as provided by
     * MultiSchemaField
     */ TranslatableString["TitleOptionPrefix"] = "%1 option %2";
    /** Key label, where %1 will be replaced by the label as provided by WrapIfAdditionalTemplate */ TranslatableString["KeyLabel"] = "%1 Key";
    // Strings with replaceable parameters AND/OR that support markdown and html
    /** Invalid object field configuration as provided by the ObjectField */ TranslatableString["InvalidObjectField"] = 'Invalid "%1" object field configuration: <em>%2</em>.';
    /** Unsupported field schema, used by UnsupportedField */ TranslatableString["UnsupportedField"] = "Unsupported field schema.";
    /** Unsupported field schema, where %1 will be replaced by the idSchema.$id as provided by UnsupportedField */ TranslatableString["UnsupportedFieldWithId"] = "Unsupported field schema for field <code>%1</code>.";
    /** Unsupported field schema, where %1 will be replaced by the reason string as provided by UnsupportedField */ TranslatableString["UnsupportedFieldWithReason"] = "Unsupported field schema: <em>%1</em>.";
    /** Unsupported field schema, where %1 and %2 will be replaced by the idSchema.$id and reason strings, respectively,
     * as provided by UnsupportedField
     */ TranslatableString["UnsupportedFieldWithIdAndReason"] = "Unsupported field schema for field <code>%1</code>: <em>%2</em>.";
    /** File name, type and size info, where %1, %2 and %3 will be replaced by the file name, file type and file size as
     * provided by FileWidget
     */ TranslatableString["FilesInfo"] = "**%1** (%2, %3 bytes)";
})(TranslatableString || (TranslatableString = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6IIgK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemaParser", ()=>(0, _schemaParserDefault.default));
var _schemaParser = require("./schemaParser");
var _schemaParserDefault = parcelHelpers.interopDefault(_schemaParser);

},{"./schemaParser":"lqH1l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lqH1l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>schemaParser);
var _forEach = require("lodash/forEach");
var _forEachDefault = parcelHelpers.interopDefault(_forEach);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _constants = require("../constants");
var _parserValidator = require("./ParserValidator");
var _parserValidatorDefault = parcelHelpers.interopDefault(_parserValidator);
var _retrieveSchema = require("../schema/retrieveSchema");
/** Recursive function used to parse the given `schema` belonging to the `rootSchema`. The `validator` is used to
 * capture the sub-schemas that the `isValid()` function is called with. For each schema returned by the
 * `retrieveSchemaInternal()`, the `resolveAnyOrOneOfSchemas()` function is called. For each of the schemas returned
 * from THAT call have `properties`, then each of the sub-schema property objects are then recursively parsed.
 *
 * @param validator - The `ParserValidator` implementation used to capture `isValid()` calls during parsing
 * @param recurseList - The list of schemas returned from the `retrieveSchemaInternal`, preventing infinite recursion
 * @param rootSchema - The root schema from which the schema parsing began
 * @param schema - The current schema element being parsed
 */ function parseSchema(validator, recurseList, rootSchema, schema) {
    const schemas = (0, _retrieveSchema.retrieveSchemaInternal)(validator, schema, rootSchema, undefined, true);
    schemas.forEach((schema)=>{
        const sameSchemaIndex = recurseList.findIndex((item)=>(0, _isEqualDefault.default)(item, schema));
        if (sameSchemaIndex === -1) {
            recurseList.push(schema);
            const allOptions = (0, _retrieveSchema.resolveAnyOrOneOfSchemas)(validator, schema, rootSchema, true);
            allOptions.forEach((s)=>{
                if ((0, _constants.PROPERTIES_KEY) in s && s[0, _constants.PROPERTIES_KEY]) (0, _forEachDefault.default)(schema[0, _constants.PROPERTIES_KEY], (value)=>{
                    parseSchema(validator, recurseList, rootSchema, value);
                });
            });
            if ((0, _constants.ITEMS_KEY) in schema && !Array.isArray(schema.items) && typeof schema.items !== "boolean") parseSchema(validator, recurseList, rootSchema, schema.items);
        }
    });
}
function schemaParser(rootSchema) {
    const validator = new (0, _parserValidatorDefault.default)(rootSchema);
    const recurseList = [];
    parseSchema(validator, recurseList, rootSchema, rootSchema);
    return validator.getSchemaMap();
}

},{"lodash/forEach":"5vh4L","lodash/isEqual":"64pmh","../constants":"a1fVD","./ParserValidator":"67N30","../schema/retrieveSchema":"jAKxQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"67N30":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _constants = require("../constants");
var _hashForSchema = require("../hashForSchema");
var _hashForSchemaDefault = parcelHelpers.interopDefault(_hashForSchema);
class ParserValidator {
    /** Construct the ParserValidator for the given `rootSchema`. This `rootSchema` will be stashed in the `schemaMap`
     * first.
     *
     * @param rootSchema - The root schema against which this validator will be executed
     */ constructor(rootSchema){
        /** The map of schemas encountered by the ParserValidator */ this.schemaMap = {};
        this.rootSchema = rootSchema;
        this.addSchema(rootSchema, (0, _hashForSchemaDefault.default)(rootSchema));
    }
    /** Adds the given `schema` to the `schemaMap` keyed by the `hash` or `ID_KEY` if present on the `schema`. If the
     * schema does not have an `ID_KEY`, then the `hash` will be added as the `ID_KEY` to allow the schema to be
     * associated with it's `hash` for future use (by a schema compiler).
     *
     * @param schema - The schema which is to be added to the map
     * @param hash - The hash value at which to map the schema
     */ addSchema(schema, hash) {
        const key = (0, _getDefault.default)(schema, (0, _constants.ID_KEY), hash);
        const identifiedSchema = {
            ...schema,
            [(0, _constants.ID_KEY)]: key
        };
        const existing = this.schemaMap[key];
        if (!existing) this.schemaMap[key] = identifiedSchema;
        else if (!(0, _isEqualDefault.default)(existing, identifiedSchema)) {
            console.error("existing schema:", JSON.stringify(existing, null, 2));
            console.error("new schema:", JSON.stringify(identifiedSchema, null, 2));
            throw new Error(`Two different schemas exist with the same key ${key}! What a bad coincidence. If possible, try adding an $id to one of the schemas`);
        }
    }
    /** Returns the current `schemaMap` to the caller
     */ getSchemaMap() {
        return this.schemaMap;
    }
    /** Implements the `ValidatorType` `isValid()` method to capture the `schema` in the `schemaMap`. Throws an error when
     * the `rootSchema` is not the same as the root schema provided during construction.
     *
     * @param schema - The schema to record in the `schemaMap`
     * @param _formData - The formData parameter that is ignored
     * @param rootSchema - The root schema associated with the schema
     * @throws - Error when the given `rootSchema` differs from the root schema provided during construction
     */ isValid(schema, _formData, rootSchema) {
        if (!(0, _isEqualDefault.default)(rootSchema, this.rootSchema)) throw new Error("Unexpectedly calling isValid() with a rootSchema that differs from the construction rootSchema");
        this.addSchema(schema, (0, _hashForSchemaDefault.default)(schema));
        return false;
    }
    /** Implements the `ValidatorType` `rawValidation()` method to throw an error since it is never supposed to be called
     *
     * @param _schema - The schema parameter that is ignored
     * @param _formData - The formData parameter that is ignored
     */ rawValidation(_schema, _formData) {
        throw new Error("Unexpectedly calling the `rawValidation()` method during schema parsing");
    }
    /** Implements the `ValidatorType` `toErrorList()` method to throw an error since it is never supposed to be called
     *
     * @param _errorSchema - The error schema parameter that is ignored
     * @param _fieldPath - The field path parameter that is ignored
     */ toErrorList(_errorSchema, _fieldPath) {
        throw new Error("Unexpectedly calling the `toErrorList()` method during schema parsing");
    }
    /** Implements the `ValidatorType` `validateFormData()` method to throw an error since it is never supposed to be
     * called
     *
     * @param _formData - The formData parameter that is ignored
     * @param _schema - The schema parameter that is ignored
     * @param _customValidate - The customValidate parameter that is ignored
     * @param _transformErrors - The transformErrors parameter that is ignored
     * @param _uiSchema - The uiSchema parameter that is ignored
     */ validateFormData(_formData, _schema, _customValidate, _transformErrors, _uiSchema) {
        throw new Error("Unexpectedly calling the `validateFormData()` method during schema parsing");
    }
}
exports.default = ParserValidator;

},{"lodash/get":"8z6tS","lodash/isEqual":"64pmh","../constants":"a1fVD","../hashForSchema":"kvlp9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ig5zI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AJV_CONFIG", ()=>AJV_CONFIG);
parcelHelpers.export(exports, "COLOR_FORMAT_REGEX", ()=>COLOR_FORMAT_REGEX);
parcelHelpers.export(exports, "DATA_URL_FORMAT_REGEX", ()=>DATA_URL_FORMAT_REGEX);
parcelHelpers.export(exports, "default", ()=>createAjvInstance);
var _ajv = require("ajv");
var _ajvDefault = parcelHelpers.interopDefault(_ajv);
var _ajvFormats = require("ajv-formats");
var _ajvFormatsDefault = parcelHelpers.interopDefault(_ajvFormats);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _utils = require("@rjsf/utils");
const AJV_CONFIG = {
    allErrors: true,
    multipleOfPrecision: 8,
    strict: false,
    verbose: true
};
const COLOR_FORMAT_REGEX = /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/;
const DATA_URL_FORMAT_REGEX = /^data:([a-z]+\/[a-z0-9-+.]+)?;(?:name=(.*);)?base64,(.*)$/;
function createAjvInstance(additionalMetaSchemas, customFormats, ajvOptionsOverrides = {}, ajvFormatOptions, AjvClass = (0, _ajvDefault.default)) {
    const ajv = new AjvClass({
        ...AJV_CONFIG,
        ...ajvOptionsOverrides
    });
    if (ajvFormatOptions) (0, _ajvFormatsDefault.default)(ajv, ajvFormatOptions);
    else if (ajvFormatOptions !== false) (0, _ajvFormatsDefault.default)(ajv);
    // add custom formats
    ajv.addFormat("data-url", DATA_URL_FORMAT_REGEX);
    ajv.addFormat("color", COLOR_FORMAT_REGEX);
    // Add RJSF-specific additional properties keywords so Ajv doesn't report errors if strict is enabled.
    ajv.addKeyword((0, _utils.ADDITIONAL_PROPERTY_FLAG));
    ajv.addKeyword((0, _utils.RJSF_ADDITIONAL_PROPERTIES_FLAG));
    // add more schemas to validate against
    if (Array.isArray(additionalMetaSchemas)) ajv.addMetaSchema(additionalMetaSchemas);
    // add more custom formats to validate against
    if ((0, _isObjectDefault.default)(customFormats)) Object.keys(customFormats).forEach((formatName)=>{
        ajv.addFormat(formatName, customFormats[formatName]);
    });
    return ajv;
}

},{"ajv":"8ShSS","ajv-formats":"5gilL","lodash/isObject":"3TlAp","@rjsf/utils":"dblzs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8ShSS":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = exports.Ajv = void 0;
const core_1 = require("f64656127e08982d");
const draft7_1 = require("f1543da9385b944c");
const discriminator_1 = require("be8496814b704dbb");
const draft7MetaSchema = require("38bd7a84a0bf1522");
const META_SUPPORT_DATA = [
    "/properties"
];
const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
class Ajv extends core_1.default {
    _addVocabularies() {
        super._addVocabularies();
        draft7_1.default.forEach((v)=>this.addVocabulary(v));
        if (this.opts.discriminator) this.addKeyword(discriminator_1.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        if (!this.opts.meta) return;
        const metaSchema = this.opts.$data ? this.$dataMetaSchema(draft7MetaSchema, META_SUPPORT_DATA) : draft7MetaSchema;
        this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
}
exports.Ajv = Ajv;
module.exports = exports = Ajv;
module.exports.Ajv = Ajv;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv;
var validate_1 = require("e0cfa52b6e683bc7");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return validate_1.KeywordCxt;
    }
});
var codegen_1 = require("3d074431b417a468");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return codegen_1._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return codegen_1.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return codegen_1.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return codegen_1.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return codegen_1.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return codegen_1.CodeGen;
    }
});
var validation_error_1 = require("dc5ef56e4c544902");
Object.defineProperty(exports, "ValidationError", {
    enumerable: true,
    get: function() {
        return validation_error_1.default;
    }
});
var ref_error_1 = require("1f676e068a0a0b03");
Object.defineProperty(exports, "MissingRefError", {
    enumerable: true,
    get: function() {
        return ref_error_1.default;
    }
});

},{"f64656127e08982d":"2qhHh","f1543da9385b944c":"2Ynjz","be8496814b704dbb":"i1vpu","38bd7a84a0bf1522":"1i0St","e0cfa52b6e683bc7":"2Fvud","3d074431b417a468":"5E3CJ","dc5ef56e4c544902":"eZiGZ","1f676e068a0a0b03":"8Strz"}],"2qhHh":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;
var validate_1 = require("8eae9e8df37feb7a");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return validate_1.KeywordCxt;
    }
});
var codegen_1 = require("ffa9e7efa8fd1e4a");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return codegen_1._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return codegen_1.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return codegen_1.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return codegen_1.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return codegen_1.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return codegen_1.CodeGen;
    }
});
const validation_error_1 = require("eaa88e3aaccf251");
const ref_error_1 = require("f63f87f091d36ef7");
const rules_1 = require("5a4bc288296cc41c");
const compile_1 = require("2ea5240ba3b7911d");
const codegen_2 = require("ffa9e7efa8fd1e4a");
const resolve_1 = require("d28de041b2cba4fb");
const dataType_1 = require("53d10d85530b6b99");
const util_1 = require("66ed8b4de95754e9");
const $dataRefSchema = require("420a5d11860e6768");
const uri_1 = require("fe7cd4bb08eb811");
const defaultRegExp = (str, flags)=>new RegExp(str, flags);
defaultRegExp.code = "new RegExp";
const META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes"
];
const EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
]);
const removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
};
const deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
};
const MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : uri_1.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? {
            ...o.code,
            optimize,
            regExp
        } : {
            optimize,
            regExp
        },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver
    };
}
class Ajv {
    constructor(opts = {}){
        this.schemas = {};
        this.refs = {};
        this.formats = {};
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = {
            ...opts,
            ...requiredOptions(opts)
        };
        const { es5, lines } = this.opts.code;
        this.scope = new codegen_2.ValueScope({
            scope: {},
            prefixes: EXT_SCOPE_NAMES,
            es5,
            lines
        });
        this.logger = getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, rules_1.getRules)();
        checkOptions.call(this, removedOptions, opts, "NOT SUPPORTED");
        checkOptions.call(this, deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = getMetaSchemaOptions.call(this);
        if (opts.formats) addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords) addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
        addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data, meta, schemaId } = this.opts;
        let _dataRefSchema = $dataRefSchema;
        if (schemaId === "id") {
            _dataRefSchema = {
                ...$dataRefSchema
            };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data) this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta, schemaId } = this.opts;
        return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined;
    }
    validate(schemaKeyRef, // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v) throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        } else v = this.compile(schemaKeyRef);
        const valid = v(data);
        if (!("$async" in v)) this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return sch.validate || this._compileSchemaEnv(sch);
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
        const { loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) await runCompileAsync.call(this, {
                $ref
            }, true);
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            } catch (e) {
                if (!(e instanceof ref_error_1.default)) throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef }) {
            if (this.refs[ref]) throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref]) await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref]) this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p) return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            } finally{
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, key, _meta, _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") throw new Error(`schema ${schemaId} must be string`);
        }
        key = (0, resolve_1.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean") return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log") this.logger.error(message);
            else throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while(typeof (sch = getSchEnv.call(this, keyRef)) == "string")keyRef = sch;
        if (sch === undefined) {
            const { schemaId } = this.opts;
            const root = new compile_1.SchemaEnv({
                schema: {},
                schemaId
            });
            sch = compile_1.resolveSchema.call(this, root, keyRef);
            if (!sch) return;
            this.refs[keyRef] = sch;
        }
        return sch.validate || this._compileSchemaEnv(sch);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch(typeof schemaKeyRef){
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string":
                {
                    const sch = getSchEnv.call(this, schemaKeyRef);
                    if (typeof sch == "object") this._cache.delete(sch.schema);
                    delete this.schemas[schemaKeyRef];
                    delete this.refs[schemaKeyRef];
                    return this;
                }
            case "object":
                {
                    const cacheKey = schemaKeyRef;
                    this._cache.delete(cacheKey);
                    let id = schemaKeyRef[this.opts.schemaId];
                    if (id) {
                        id = (0, resolve_1.normalizeId)(id);
                        delete this.schemas[id];
                        delete this.refs[id];
                    }
                    return this;
                }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        } else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) throw new Error("addKeywords: keyword must be string or non-empty array");
        } else throw new Error("invalid addKeywords parameters");
        checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, util_1.eachItem)(keyword, (kwd)=>addRule.call(this, kwd));
            return this;
        }
        keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, dataType_1.getJSONTypes)(def.type),
            schemaType: (0, dataType_1.getJSONTypes)(def.schemaType)
        };
        (0, util_1.eachItem)(keyword, definition.type.length === 0 ? (k)=>addRule.call(this, k, definition) : (k)=>definition.type.forEach((t)=>addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules){
            const i = group.rules.findIndex((rule)=>rule.keyword === keyword);
            if (i >= 0) group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string") format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, { separator = ", ", dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0) return "No errors";
        return errors.map((e)=>`${dataVar}${e.instancePath} ${e.message}`).reduce((text, msg)=>text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers){
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)keywords = keywords[seg];
            for(const key in rules){
                const rule = rules[key];
                if (typeof rule != "object") continue;
                const { $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema) keywords[key] = schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for(const keyRef in schemas){
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") delete schemas[keyRef];
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId } = this.opts;
        if (typeof schema == "object") id = schema[schemaId];
        else {
            if (this.opts.jtd) throw new Error("schema must be object");
            else if (typeof schema != "boolean") throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined) return sch;
        baseId = (0, resolve_1.normalizeId)(id || baseId);
        const localRefs = resolve_1.getSchemaRefs.call(this, schema, baseId);
        sch = new compile_1.SchemaEnv({
            schema,
            schemaId,
            meta,
            baseId,
            localRefs
        });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId) this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema) this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) throw new Error(`schema with key or id "${id}" already exists`);
    }
    _compileSchemaEnv(sch) {
        if (sch.meta) this._compileMetaSchema(sch);
        else compile_1.compileSchema.call(this, sch);
        /* istanbul ignore if */ if (!sch.validate) throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            compile_1.compileSchema.call(this, sch);
        } finally{
            this.opts = currentOpts;
        }
    }
}
Ajv.ValidationError = validation_error_1.default;
Ajv.MissingRefError = ref_error_1.default;
exports.default = Ajv;
function checkOptions(checkOpts, options, msg, log = "error") {
    for(const key in checkOpts){
        const opt = key;
        if (opt in options) this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function getSchEnv(keyRef) {
    keyRef = (0, resolve_1.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) this.addSchema(optsSchemas);
    else for(const key in optsSchemas)this.addSchema(optsSchemas[key], key);
}
function addInitialFormats() {
    for(const name in this.opts.formats){
        const format = this.opts.formats[name];
        if (format) this.addFormat(name, format);
    }
}
function addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for(const keyword in defs){
        const def = defs[keyword];
        if (!def.keyword) def.keyword = keyword;
        this.addKeyword(def);
    }
}
function getMetaSchemaOptions() {
    const metaOpts = {
        ...this.opts
    };
    for (const opt of META_IGNORE_OPTIONS)delete metaOpts[opt];
    return metaOpts;
}
const noLogs = {
    log () {},
    warn () {},
    error () {}
};
function getLogger(logger) {
    if (logger === false) return noLogs;
    if (logger === undefined) return console;
    if (logger.log && logger.warn && logger.error) return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function checkKeyword(keyword, def) {
    const { RULES } = this;
    (0, util_1.eachItem)(keyword, (kwd)=>{
        if (RULES.keywords[kwd]) throw new Error(`Keyword ${kwd} is already defined`);
        if (!KEYWORD_NAME.test(kwd)) throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def) return;
    if (def.$data && !("code" in def || "validate" in def)) throw new Error('$data keyword must have "code" or "validate" function');
}
function addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post) throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t })=>t === dataType);
    if (!ruleGroup) {
        ruleGroup = {
            type: dataType,
            rules: []
        };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition) return;
    const rule = {
        keyword,
        definition: {
            ...definition,
            type: (0, dataType_1.getJSONTypes)(definition.type),
            schemaType: (0, dataType_1.getJSONTypes)(definition.schemaType)
        }
    };
    if (definition.before) addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 || _a.forEach((kwd)=>this.addKeyword(kwd));
}
function addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule)=>_rule.keyword === before);
    if (i >= 0) ruleGroup.rules.splice(i, 0, rule);
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function keywordMetaschema(def) {
    let { metaSchema } = def;
    if (metaSchema === undefined) return;
    if (def.$data && this.opts.$data) metaSchema = schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
};
function schemaOrData(schema) {
    return {
        anyOf: [
            schema,
            $dataRef
        ]
    };
}

},{"8eae9e8df37feb7a":"2Fvud","ffa9e7efa8fd1e4a":"5E3CJ","eaa88e3aaccf251":"eZiGZ","f63f87f091d36ef7":"8Strz","5a4bc288296cc41c":"4nAEP","2ea5240ba3b7911d":"82s90","d28de041b2cba4fb":"dIPgO","53d10d85530b6b99":"2BpoV","66ed8b4de95754e9":"hqTFh","420a5d11860e6768":"4YSud","fe7cd4bb08eb811":"7rBAw"}],"2Fvud":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getData = exports.KeywordCxt = exports.validateFunctionCode = void 0;
const boolSchema_1 = require("1872624698c52350");
const dataType_1 = require("30e941be85fe7fe1");
const applicability_1 = require("4efae0989d707fc9");
const dataType_2 = require("30e941be85fe7fe1");
const defaults_1 = require("59b5b06ee813874");
const keyword_1 = require("833ade6d8e5d7ac7");
const subschema_1 = require("721d23bc0d70f9c5");
const codegen_1 = require("dd369f53d36c1331");
const names_1 = require("3b360641a0a45156");
const resolve_1 = require("c00dd44166cd9602");
const util_1 = require("b5aac0cdec5ecfd");
const errors_1 = require("eda806e054ff0f41");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function validateFunctionCode(it) {
    if (isSchemaObj(it)) {
        checkKeywords(it);
        if (schemaCxtHasRules(it)) {
            topSchemaObjCode(it);
            return;
        }
    }
    validateFunction(it, ()=>(0, boolSchema_1.topBoolOrEmptySchema)(it));
}
exports.validateFunctionCode = validateFunctionCode;
function validateFunction({ gen, validateName, schema, schemaEnv, opts }, body) {
    if (opts.code.es5) gen.func(validateName, (0, codegen_1._)`${names_1.default.data}, ${names_1.default.valCxt}`, schemaEnv.$async, ()=>{
        gen.code((0, codegen_1._)`"use strict"; ${funcSourceUrl(schema, opts)}`);
        destructureValCxtES5(gen, opts);
        gen.code(body);
    });
    else gen.func(validateName, (0, codegen_1._)`${names_1.default.data}, ${destructureValCxt(opts)}`, schemaEnv.$async, ()=>gen.code(funcSourceUrl(schema, opts)).code(body));
}
function destructureValCxt(opts) {
    return (0, codegen_1._)`{${names_1.default.instancePath}="", ${names_1.default.parentData}, ${names_1.default.parentDataProperty}, ${names_1.default.rootData}=${names_1.default.data}${opts.dynamicRef ? (0, codegen_1._)`, ${names_1.default.dynamicAnchors}={}` : codegen_1.nil}}={}`;
}
function destructureValCxtES5(gen, opts) {
    gen.if(names_1.default.valCxt, ()=>{
        gen.var(names_1.default.instancePath, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.instancePath}`);
        gen.var(names_1.default.parentData, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.parentData}`);
        gen.var(names_1.default.parentDataProperty, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.parentDataProperty}`);
        gen.var(names_1.default.rootData, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.rootData}`);
        if (opts.dynamicRef) gen.var(names_1.default.dynamicAnchors, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.dynamicAnchors}`);
    }, ()=>{
        gen.var(names_1.default.instancePath, (0, codegen_1._)`""`);
        gen.var(names_1.default.parentData, (0, codegen_1._)`undefined`);
        gen.var(names_1.default.parentDataProperty, (0, codegen_1._)`undefined`);
        gen.var(names_1.default.rootData, names_1.default.data);
        if (opts.dynamicRef) gen.var(names_1.default.dynamicAnchors, (0, codegen_1._)`{}`);
    });
}
function topSchemaObjCode(it) {
    const { schema, opts, gen } = it;
    validateFunction(it, ()=>{
        if (opts.$comment && schema.$comment) commentKeyword(it);
        checkNoDefault(it);
        gen.let(names_1.default.vErrors, null);
        gen.let(names_1.default.errors, 0);
        if (opts.unevaluated) resetEvaluated(it);
        typeAndKeywords(it);
        returnResults(it);
    });
    return;
}
function resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen, validateName } = it;
    it.evaluated = gen.const("evaluated", (0, codegen_1._)`${validateName}.evaluated`);
    gen.if((0, codegen_1._)`${it.evaluated}.dynamicProps`, ()=>gen.assign((0, codegen_1._)`${it.evaluated}.props`, (0, codegen_1._)`undefined`));
    gen.if((0, codegen_1._)`${it.evaluated}.dynamicItems`, ()=>gen.assign((0, codegen_1._)`${it.evaluated}.items`, (0, codegen_1._)`undefined`));
}
function funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, codegen_1._)`/*# sourceURL=${schId} */` : codegen_1.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function subschemaCode(it, valid) {
    if (isSchemaObj(it)) {
        checkKeywords(it);
        if (schemaCxtHasRules(it)) {
            subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, boolSchema_1.boolOrEmptySchema)(it, valid);
}
function schemaCxtHasRules({ schema, self }) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (self.RULES.all[key]) return true;
    return false;
}
function isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function subSchemaObjCode(it, valid) {
    const { schema, gen, opts } = it;
    if (opts.$comment && schema.$comment) commentKeyword(it);
    updateContext(it);
    checkAsyncSchema(it);
    const errsCount = gen.const("_errs", names_1.default.errors);
    typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, codegen_1._)`${errsCount} === ${names_1.default.errors}`);
}
function checkKeywords(it) {
    (0, util_1.checkUnknownRules)(it);
    checkRefsAndKeywords(it);
}
function typeAndKeywords(it, errsCount) {
    if (it.opts.jtd) return schemaKeywords(it, [], false, errsCount);
    const types = (0, dataType_1.getSchemaTypes)(it.schema);
    const checkedTypes = (0, dataType_1.coerceAndCheckDataType)(it, types);
    schemaKeywords(it, types, !checkedTypes, errsCount);
}
function checkRefsAndKeywords(it) {
    const { schema, errSchemaPath, opts, self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, util_1.schemaHasRulesButRef)(schema, self.RULES)) self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
}
function checkNoDefault(it) {
    const { schema, opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) (0, util_1.checkStrictMode)(it, "default is ignored in the schema root");
}
function updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId) it.baseId = (0, resolve_1.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}
function commentKeyword({ gen, schemaEnv, schema, errSchemaPath, opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) gen.code((0, codegen_1._)`${names_1.default.self}.logger.log(${msg})`);
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, codegen_1.str)`${errSchemaPath}/$comment`;
        const rootName = gen.scopeValue("root", {
            ref: schemaEnv.root
        });
        gen.code((0, codegen_1._)`${names_1.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
    }
}
function returnResults(it) {
    const { gen, schemaEnv, validateName, ValidationError, opts } = it;
    if (schemaEnv.$async) // TODO assign unevaluated
    gen.if((0, codegen_1._)`${names_1.default.errors} === 0`, ()=>gen.return(names_1.default.data), ()=>gen.throw((0, codegen_1._)`new ${ValidationError}(${names_1.default.vErrors})`));
    else {
        gen.assign((0, codegen_1._)`${validateName}.errors`, names_1.default.vErrors);
        if (opts.unevaluated) assignEvaluated(it);
        gen.return((0, codegen_1._)`${names_1.default.errors} === 0`);
    }
}
function assignEvaluated({ gen, evaluated, props, items }) {
    if (props instanceof codegen_1.Name) gen.assign((0, codegen_1._)`${evaluated}.props`, props);
    if (items instanceof codegen_1.Name) gen.assign((0, codegen_1._)`${evaluated}.items`, items);
}
function schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen, schema, data, allErrors, opts, self } = it;
    const { RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, util_1.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(()=>keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd) checkStrictTypes(it, types);
    gen.block(()=>{
        for (const group of RULES.rules)groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, applicability_1.shouldUseGroup)(schema, group)) return;
        if (group.type) {
            gen.if((0, dataType_2.checkDataType)(group.type, data, opts.strictNumbers));
            iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, dataType_2.reportTypeError)(it);
            }
            gen.endIf();
        } else iterateKeywords(it, group);
        // TODO make it "ok" call?
        if (!allErrors) gen.if((0, codegen_1._)`${names_1.default.errors} === ${errsCount || 0}`);
    }
}
function iterateKeywords(it, group) {
    const { gen, schema, opts: { useDefaults } } = it;
    if (useDefaults) (0, defaults_1.assignDefaults)(it, group.type);
    gen.block(()=>{
        for (const rule of group.rules)if ((0, applicability_1.shouldUseRule)(schema, rule)) keywordCode(it, rule.keyword, rule.definition, group.type);
    });
}
function checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes) return;
    checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes) checkMultipleTypes(it, types);
    checkKeywordTypes(it, it.dataTypes);
}
function checkContextTypes(it, types) {
    if (!types.length) return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t)=>{
        if (!includesType(it.dataTypes, t)) strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
    });
    narrowSchemaTypes(it, types);
}
function checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) strictTypesError(it, "use allowUnionTypes to allow union type keyword");
}
function checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for(const keyword in rules){
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, applicability_1.shouldUseRule)(it.schema, rule)) {
            const { type } = rule.definition;
            if (type.length && !type.some((t)=>hasApplicableType(ts, t))) strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
        }
    }
}
function hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function includesType(ts, t) {
    return ts.includes(t) || t === "integer" && ts.includes("number");
}
function narrowSchemaTypes(it, withTypes) {
    const ts = [];
    for (const t of it.dataTypes){
        if (includesType(withTypes, t)) ts.push(t);
        else if (withTypes.includes("integer") && t === "number") ts.push("integer");
    }
    it.dataTypes = ts;
}
function strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, util_1.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class KeywordCxt {
    constructor(it, def, keyword){
        (0, keyword_1.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, util_1.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) this.schemaCode = it.gen.const("vSchema", getData(this.$data, it));
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, keyword_1.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) this.errsCount = it.gen.const("_errs", names_1.default.errors);
    }
    result(condition, successAction, failAction) {
        this.failResult((0, codegen_1.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction) failAction();
        else this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors) this.gen.endIf();
        } else if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    pass(condition, failAction) {
        this.failResult((0, codegen_1.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data) return this.fail(condition);
        const { schemaCode } = this;
        this.fail((0, codegen_1._)`${schemaCode} !== undefined && (${(0, codegen_1.or)(this.invalid$data(), condition)})`);
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        (append ? errors_1.reportExtraError : errors_1.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, errors_1.reportError)(this, this.def.$dataError || errors_1.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
        (0, errors_1.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors) this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign) Object.assign(this.params, obj);
        else this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = codegen_1.nil) {
        this.gen.block(()=>{
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = codegen_1.nil, $dataValid = codegen_1.nil) {
        if (!this.$data) return;
        const { gen, schemaCode, schemaType, def } = this;
        gen.if((0, codegen_1.or)((0, codegen_1._)`${schemaCode} === undefined`, $dataValid));
        if (valid !== codegen_1.nil) gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== codegen_1.nil) gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen, schemaCode, schemaType, def, it } = this;
        return (0, codegen_1.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */ if (!(schemaCode instanceof codegen_1.Name)) throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [
                    schemaType
                ];
                return (0, codegen_1._)`${(0, dataType_2.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, dataType_2.DataType.Wrong)}`;
            }
            return codegen_1.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", {
                    ref: def.validateSchema
                }); // TODO value.code for standalone
                return (0, codegen_1._)`!${validateSchemaRef}(${schemaCode})`;
            }
            return codegen_1.nil;
        }
    }
    subschema(appl, valid) {
        const subschema = (0, subschema_1.getSubschema)(this.it, appl);
        (0, subschema_1.extendSubschemaData)(subschema, this.it, appl);
        (0, subschema_1.extendSubschemaMode)(subschema, appl);
        const nextContext = {
            ...this.it,
            ...subschema,
            items: undefined,
            props: undefined
        };
        subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it, gen } = this;
        if (!it.opts.unevaluated) return;
        if (it.props !== true && schemaCxt.props !== undefined) it.props = util_1.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        if (it.items !== true && schemaCxt.items !== undefined) it.items = util_1.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it, gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, ()=>this.mergeEvaluated(schemaCxt, codegen_1.Name));
            return true;
        }
    }
}
exports.KeywordCxt = KeywordCxt;
function keywordCode(it, keyword, def, ruleType) {
    const cxt = new KeywordCxt(it, def, keyword);
    if ("code" in def) def.code(cxt, ruleType);
    else if (cxt.$data && def.validate) (0, keyword_1.funcKeywordCode)(cxt, def);
    else if ("macro" in def) (0, keyword_1.macroKeywordCode)(cxt, def);
    else if (def.compile || def.validate) (0, keyword_1.funcKeywordCode)(cxt, def);
}
const JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function getData($data, { dataLevel, dataNames, dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "") return names_1.default.rootData;
    if ($data[0] === "/") {
        if (!JSON_POINTER.test($data)) throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = names_1.default.rootData;
    } else {
        const matches = RELATIVE_JSON_POINTER.exec($data);
        if (!matches) throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel) throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer) return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments)if (segment) {
        data = (0, codegen_1._)`${data}${(0, codegen_1.getProperty)((0, util_1.unescapeJsonPointer)(segment))}`;
        expr = (0, codegen_1._)`${expr} && ${data}`;
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}
exports.getData = getData;

},{"1872624698c52350":"jhlMt","30e941be85fe7fe1":"2BpoV","4efae0989d707fc9":"4bPUa","59b5b06ee813874":"a2YRR","833ade6d8e5d7ac7":"9JbMh","721d23bc0d70f9c5":"1fj2K","dd369f53d36c1331":"5E3CJ","3b360641a0a45156":"eZ3V6","c00dd44166cd9602":"dIPgO","b5aac0cdec5ecfd":"hqTFh","eda806e054ff0f41":"ftDQV"}],"jhlMt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.boolOrEmptySchema = exports.topBoolOrEmptySchema = void 0;
const errors_1 = require("7ae78570b5c98751");
const codegen_1 = require("382afaf0f5449a0b");
const names_1 = require("b14bdfeaa9e2911c");
const boolError = {
    message: "boolean schema is false"
};
function topBoolOrEmptySchema(it) {
    const { gen, schema, validateName } = it;
    if (schema === false) falseSchemaError(it, false);
    else if (typeof schema == "object" && schema.$async === true) gen.return(names_1.default.data);
    else {
        gen.assign((0, codegen_1._)`${validateName}.errors`, null);
        gen.return(true);
    }
}
exports.topBoolOrEmptySchema = topBoolOrEmptySchema;
function boolOrEmptySchema(it, valid) {
    const { gen, schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        falseSchemaError(it);
    } else gen.var(valid, true); // TODO var
}
exports.boolOrEmptySchema = boolOrEmptySchema;
function falseSchemaError(it, overrideAllErrors) {
    const { gen, data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen,
        keyword: "false schema",
        data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it
    };
    (0, errors_1.reportError)(cxt, boolError, undefined, overrideAllErrors);
}

},{"7ae78570b5c98751":"ftDQV","382afaf0f5449a0b":"5E3CJ","b14bdfeaa9e2911c":"eZ3V6"}],"ftDQV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extendErrors = exports.resetErrorsCount = exports.reportExtraError = exports.reportError = exports.keyword$DataError = exports.keywordError = void 0;
const codegen_1 = require("b0db63a8d522181c");
const util_1 = require("2ba06fec19fee9a0");
const names_1 = require("e68108f0fa66567d");
exports.keywordError = {
    message: ({ keyword })=>(0, codegen_1.str)`must pass "${keyword}" keyword validation`
};
exports.keyword$DataError = {
    message: ({ keyword, schemaType })=>schemaType ? (0, codegen_1.str)`"${keyword}" keyword must be ${schemaType} ($data)` : (0, codegen_1.str)`"${keyword}" keyword is invalid ($data)`
};
function reportError(cxt, error = exports.keywordError, errorPaths, overrideAllErrors) {
    const { it } = cxt;
    const { gen, compositeRule, allErrors } = it;
    const errObj = errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) addError(gen, errObj);
    else returnErrors(it, (0, codegen_1._)`[${errObj}]`);
}
exports.reportError = reportError;
function reportExtraError(cxt, error = exports.keywordError, errorPaths) {
    const { it } = cxt;
    const { gen, compositeRule, allErrors } = it;
    const errObj = errorObjectCode(cxt, error, errorPaths);
    addError(gen, errObj);
    if (!(compositeRule || allErrors)) returnErrors(it, names_1.default.vErrors);
}
exports.reportExtraError = reportExtraError;
function resetErrorsCount(gen, errsCount) {
    gen.assign(names_1.default.errors, errsCount);
    gen.if((0, codegen_1._)`${names_1.default.vErrors} !== null`, ()=>gen.if(errsCount, ()=>gen.assign((0, codegen_1._)`${names_1.default.vErrors}.length`, errsCount), ()=>gen.assign(names_1.default.vErrors, null)));
}
exports.resetErrorsCount = resetErrorsCount;
function extendErrors({ gen, keyword, schemaValue, data, errsCount, it }) {
    /* istanbul ignore if */ if (errsCount === undefined) throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, names_1.default.errors, (i)=>{
        gen.const(err, (0, codegen_1._)`${names_1.default.vErrors}[${i}]`);
        gen.if((0, codegen_1._)`${err}.instancePath === undefined`, ()=>gen.assign((0, codegen_1._)`${err}.instancePath`, (0, codegen_1.strConcat)(names_1.default.instancePath, it.errorPath)));
        gen.assign((0, codegen_1._)`${err}.schemaPath`, (0, codegen_1.str)`${it.errSchemaPath}/${keyword}`);
        if (it.opts.verbose) {
            gen.assign((0, codegen_1._)`${err}.schema`, schemaValue);
            gen.assign((0, codegen_1._)`${err}.data`, data);
        }
    });
}
exports.extendErrors = extendErrors;
function addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, codegen_1._)`${names_1.default.vErrors} === null`, ()=>gen.assign(names_1.default.vErrors, (0, codegen_1._)`[${err}]`), (0, codegen_1._)`${names_1.default.vErrors}.push(${err})`);
    gen.code((0, codegen_1._)`${names_1.default.errors}++`);
}
function returnErrors(it, errs) {
    const { gen, validateName, schemaEnv } = it;
    if (schemaEnv.$async) gen.throw((0, codegen_1._)`new ${it.ValidationError}(${errs})`);
    else {
        gen.assign((0, codegen_1._)`${validateName}.errors`, errs);
        gen.return(false);
    }
}
const E = {
    keyword: new codegen_1.Name("keyword"),
    schemaPath: new codegen_1.Name("schemaPath"),
    params: new codegen_1.Name("params"),
    propertyName: new codegen_1.Name("propertyName"),
    message: new codegen_1.Name("message"),
    schema: new codegen_1.Name("schema"),
    parentSchema: new codegen_1.Name("parentSchema")
};
function errorObjectCode(cxt, error, errorPaths) {
    const { createErrors } = cxt.it;
    if (createErrors === false) return (0, codegen_1._)`{}`;
    return errorObject(cxt, error, errorPaths);
}
function errorObject(cxt, error, errorPaths = {}) {
    const { gen, it } = cxt;
    const keyValues = [
        errorInstancePath(it, errorPaths),
        errorSchemaPath(cxt, errorPaths)
    ];
    extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function errorInstancePath({ errorPath }, { instancePath }) {
    const instPath = instancePath ? (0, codegen_1.str)`${errorPath}${(0, util_1.getErrorPath)(instancePath, util_1.Type.Str)}` : errorPath;
    return [
        names_1.default.instancePath,
        (0, codegen_1.strConcat)(names_1.default.instancePath, instPath)
    ];
}
function errorSchemaPath({ keyword, it: { errSchemaPath } }, { schemaPath, parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, codegen_1.str)`${errSchemaPath}/${keyword}`;
    if (schemaPath) schPath = (0, codegen_1.str)`${schPath}${(0, util_1.getErrorPath)(schemaPath, util_1.Type.Str)}`;
    return [
        E.schemaPath,
        schPath
    ];
}
function extraErrorProps(cxt, { params, message }, keyValues) {
    const { keyword, data, schemaValue, it } = cxt;
    const { opts, propertyName, topSchemaRef, schemaPath } = it;
    keyValues.push([
        E.keyword,
        keyword
    ], [
        E.params,
        typeof params == "function" ? params(cxt) : params || (0, codegen_1._)`{}`
    ]);
    if (opts.messages) keyValues.push([
        E.message,
        typeof message == "function" ? message(cxt) : message
    ]);
    if (opts.verbose) keyValues.push([
        E.schema,
        schemaValue
    ], [
        E.parentSchema,
        (0, codegen_1._)`${topSchemaRef}${schemaPath}`
    ], [
        names_1.default.data,
        data
    ]);
    if (propertyName) keyValues.push([
        E.propertyName,
        propertyName
    ]);
}

},{"b0db63a8d522181c":"5E3CJ","2ba06fec19fee9a0":"hqTFh","e68108f0fa66567d":"eZ3V6"}],"5E3CJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.or = exports.and = exports.not = exports.CodeGen = exports.operators = exports.varKinds = exports.ValueScopeName = exports.ValueScope = exports.Scope = exports.Name = exports.regexpCode = exports.stringify = exports.getProperty = exports.nil = exports.strConcat = exports.str = exports._ = void 0;
const code_1 = require("3a923f104f0d1cf0");
const scope_1 = require("f2814f3db5f7131a");
var code_2 = require("3a923f104f0d1cf0");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return code_2._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return code_2.str;
    }
});
Object.defineProperty(exports, "strConcat", {
    enumerable: true,
    get: function() {
        return code_2.strConcat;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return code_2.nil;
    }
});
Object.defineProperty(exports, "getProperty", {
    enumerable: true,
    get: function() {
        return code_2.getProperty;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return code_2.stringify;
    }
});
Object.defineProperty(exports, "regexpCode", {
    enumerable: true,
    get: function() {
        return code_2.regexpCode;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return code_2.Name;
    }
});
var scope_2 = require("f2814f3db5f7131a");
Object.defineProperty(exports, "Scope", {
    enumerable: true,
    get: function() {
        return scope_2.Scope;
    }
});
Object.defineProperty(exports, "ValueScope", {
    enumerable: true,
    get: function() {
        return scope_2.ValueScope;
    }
});
Object.defineProperty(exports, "ValueScopeName", {
    enumerable: true,
    get: function() {
        return scope_2.ValueScopeName;
    }
});
Object.defineProperty(exports, "varKinds", {
    enumerable: true,
    get: function() {
        return scope_2.varKinds;
    }
});
exports.operators = {
    GT: new code_1._Code(">"),
    GTE: new code_1._Code(">="),
    LT: new code_1._Code("<"),
    LTE: new code_1._Code("<="),
    EQ: new code_1._Code("==="),
    NEQ: new code_1._Code("!=="),
    NOT: new code_1._Code("!"),
    OR: new code_1._Code("||"),
    AND: new code_1._Code("&&"),
    ADD: new code_1._Code("+")
};
class Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class Def extends Node {
    constructor(varKind, name, rhs){
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
    render({ es5, _n }) {
        const varKind = es5 ? scope_1.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str]) return;
        if (this.rhs) this.rhs = optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof code_1._CodeOrName ? this.rhs.names : {};
    }
}
class Assign extends Node {
    constructor(lhs, rhs, sideEffects){
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
    render({ _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof code_1.Name && !names[this.lhs.str] && !this.sideEffects) return;
        this.rhs = optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof code_1.Name ? {} : {
            ...this.lhs.names
        };
        return addExprNames(names, this.rhs);
    }
}
class AssignOp extends Assign {
    constructor(lhs, op, rhs, sideEffects){
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
    render({ _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
}
class Label extends Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n }) {
        return `${this.label}:` + _n;
    }
}
class Break extends Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
}
class Throw extends Node {
    constructor(error){
        super();
        this.error = error;
    }
    render({ _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
}
class AnyCode extends Node {
    constructor(code){
        super();
        this.code = code;
    }
    render({ _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof code_1._CodeOrName ? this.code.names : {};
    }
}
class ParentNode extends Node {
    constructor(nodes = []){
        super();
        this.nodes = nodes;
    }
    render(opts) {
        return this.nodes.reduce((code, n)=>code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes } = this;
        let i = nodes.length;
        while(i--){
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n)) nodes.splice(i, 1, ...n);
            else if (n) nodes[i] = n;
            else nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes } = this;
        let i = nodes.length;
        while(i--){
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants)) continue;
            subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n)=>addNames(names, n.names), {});
    }
}
class BlockNode extends ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class Root extends ParentNode {
}
class Else extends BlockNode {
}
Else.kind = "else";
class If extends BlockNode {
    constructor(condition, nodes){
        super(nodes);
        this.condition = condition;
    }
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else) code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true) return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new Else(ns) : ns;
        }
        if (e) {
            if (cond === false) return e instanceof If ? e : e.nodes;
            if (this.nodes.length) return this;
            return new If(not(cond), e instanceof If ? [
                e
            ] : e.nodes);
        }
        if (cond === false || !this.nodes.length) return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else)) return;
        this.condition = optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        addExprNames(names, this.condition);
        if (this.else) addNames(names, this.else.names);
        return names;
    }
}
If.kind = "if";
class For extends BlockNode {
}
For.kind = "for";
class ForLoop extends For {
    constructor(iteration){
        super();
        this.iteration = iteration;
    }
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iteration = optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return addNames(super.names, this.iteration.names);
    }
}
class ForRange extends For {
    constructor(varKind, name, from, to){
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
    render(opts) {
        const varKind = opts.es5 ? scope_1.varKinds.var : this.varKind;
        const { name, from, to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = addExprNames(super.names, this.from);
        return addExprNames(names, this.to);
    }
}
class ForIter extends For {
    constructor(loop, varKind, name, iterable){
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iterable = optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return addNames(super.names, this.iterable.names);
    }
}
class Func extends BlockNode {
    constructor(name, args, async){
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
}
Func.kind = "func";
class Return extends ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
Return.kind = "return";
class Try extends BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch) code += this.catch.render(opts);
        if (this.finally) code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch) addNames(names, this.catch.names);
        if (this.finally) addNames(names, this.finally.names);
        return names;
    }
}
class Catch extends BlockNode {
    constructor(error){
        super();
        this.error = error;
    }
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
}
Catch.kind = "catch";
class Finally extends BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
Finally.kind = "finally";
class CodeGen {
    constructor(extScope, opts = {}){
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = {
            ...opts,
            _n: opts.lines ? "\n" : ""
        };
        this._extScope = extScope;
        this._scope = new scope_1.Scope({
            parent: extScope
        });
        this._nodes = [
            new Root()
        ];
    }
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant) this._constants[name.str] = rhs;
        this._leafNode(new Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def(scope_1.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def(scope_1.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def(scope_1.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new AssignOp(lhs, exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function") c();
        else if (c !== code_1.nil) this._leafNode(new AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = [
            "{"
        ];
        for (const [key, value] of keyValues){
            if (code.length > 1) code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, code_1.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new code_1._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new If(condition));
        if (thenBody && elseBody) this.code(thenBody).else().code(elseBody).endIf();
        else if (thenBody) this.code(thenBody).endIf();
        else if (elseBody) throw new Error('CodeGen: "else" body without "then" body');
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode(If, Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody) this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new ForRange(varKind, name, from, to), ()=>forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = scope_1.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof code_1.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, code_1._)`${arr}.length`, (i)=>{
                this.var(name, (0, code_1._)`${arr}[${i}]`);
                forBody(name);
            });
        }
        return this._for(new ForIter("of", varKind, name, iterable), ()=>forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.const) {
        if (this.opts.ownProperties) return this.forOf(nameOrPrefix, (0, code_1._)`Object.keys(${obj})`, forBody);
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new ForIter("in", varKind, name, obj), ()=>forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode(For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new Break(label));
    }
    // `return` statement
    return(value) {
        const node = new Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1) throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode(Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode) throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode(Catch, Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body) this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined) throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || nodeCount !== undefined && toClose !== nodeCount) throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = code_1.nil, async, funcBody) {
        this._blockNode(new Func(name, args, async));
        if (funcBody) this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode(Func);
    }
    optimize(n = 1) {
        while(n-- > 0){
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || N2 && n instanceof N2) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof If)) throw new Error('CodeGen: "else" without "if"');
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
}
exports.CodeGen = CodeGen;
function addNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function addExprNames(names, from) {
    return from instanceof code_1._CodeOrName ? addNames(names, from.names) : names;
}
function optimizeExpr(expr, names, constants) {
    if (expr instanceof code_1.Name) return replaceName(expr);
    if (!canOptimize(expr)) return expr;
    return new code_1._Code(expr._items.reduce((items, c)=>{
        if (c instanceof code_1.Name) c = replaceName(c);
        if (c instanceof code_1._Code) items.push(...c._items);
        else items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1) return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return e instanceof code_1._Code && e._items.some((c)=>c instanceof code_1.Name && names[c.str] === 1 && constants[c.str] !== undefined);
    }
}
function subtractNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) - (from[n] || 0);
}
function not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, code_1._)`!${par(x)}`;
}
exports.not = not;
const andCode = mappend(exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function and(...args) {
    return args.reduce(andCode);
}
exports.and = and;
const orCode = mappend(exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function or(...args) {
    return args.reduce(orCode);
}
exports.or = or;
function mappend(op) {
    return (x, y)=>x === code_1.nil ? y : y === code_1.nil ? x : (0, code_1._)`${par(x)} ${op} ${par(y)}`;
}
function par(x) {
    return x instanceof code_1.Name ? x : (0, code_1._)`(${x})`;
}

},{"3a923f104f0d1cf0":"I9coQ","f2814f3db5f7131a":"fdBm5"}],"I9coQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.regexpCode = exports.getEsmExportName = exports.getProperty = exports.safeStringify = exports.stringify = exports.strConcat = exports.addCodeArg = exports.str = exports._ = exports.nil = exports._Code = exports.Name = exports.IDENTIFIER = exports._CodeOrName = void 0;
class _CodeOrName {
}
exports._CodeOrName = _CodeOrName;
exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class Name extends _CodeOrName {
    constructor(s){
        super();
        if (!exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return {
            [this.str]: 1
        };
    }
}
exports.Name = Name;
class _Code extends _CodeOrName {
    constructor(code){
        super();
        this._items = typeof code === "string" ? [
            code
        ] : code;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1) return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce((s, c)=>`${s}${c}`, "");
    }
    get names() {
        var _a;
        return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce((names, c)=>{
            if (c instanceof Name) names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {});
    }
}
exports._Code = _Code;
exports.nil = new _Code("");
function _(strs, ...args) {
    const code = [
        strs[0]
    ];
    let i = 0;
    while(i < args.length){
        addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new _Code(code);
}
exports._ = _;
const plus = new _Code("+");
function str(strs, ...args) {
    const expr = [
        safeStringify(strs[0])
    ];
    let i = 0;
    while(i < args.length){
        expr.push(plus);
        addCodeArg(expr, args[i]);
        expr.push(plus, safeStringify(strs[++i]));
    }
    optimize(expr);
    return new _Code(expr);
}
exports.str = str;
function addCodeArg(code, arg) {
    if (arg instanceof _Code) code.push(...arg._items);
    else if (arg instanceof Name) code.push(arg);
    else code.push(interpolate(arg));
}
exports.addCodeArg = addCodeArg;
function optimize(expr) {
    let i = 1;
    while(i < expr.length - 1){
        if (expr[i] === plus) {
            const res = mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function mergeExprItems(a, b) {
    if (b === '""') return a;
    if (a === '""') return b;
    if (typeof a == "string") {
        if (b instanceof Name || a[a.length - 1] !== '"') return;
        if (typeof b != "string") return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof Name)) return `"${a}${b.slice(1)}`;
    return;
}
function strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : str`${c1}${c2}`;
}
exports.strConcat = strConcat;
// TODO do not allow arrays here
function interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null ? x : safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function stringify(x) {
    return new _Code(safeStringify(x));
}
exports.stringify = stringify;
function safeStringify(x) {
    return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
exports.safeStringify = safeStringify;
function getProperty(key) {
    return typeof key == "string" && exports.IDENTIFIER.test(key) ? new _Code(`.${key}`) : _`[${key}]`;
}
exports.getProperty = getProperty;
//Does best effort to format the name properly
function getEsmExportName(key) {
    if (typeof key == "string" && exports.IDENTIFIER.test(key)) return new _Code(`${key}`);
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
exports.getEsmExportName = getEsmExportName;
function regexpCode(rx) {
    return new _Code(rx.toString());
}
exports.regexpCode = regexpCode;

},{}],"fdBm5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ValueScope = exports.ValueScopeName = exports.Scope = exports.varKinds = exports.UsedValueState = void 0;
const code_1 = require("fe3b9fbcf3b5938");
class ValueError extends Error {
    constructor(name){
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var UsedValueState;
(function(UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})(UsedValueState || (exports.UsedValueState = UsedValueState = {}));
exports.varKinds = {
    const: new code_1.Name("const"),
    let: new code_1.Name("let"),
    var: new code_1.Name("var")
};
class Scope {
    constructor({ prefixes, parent } = {}){
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof code_1.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new code_1.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        return this._names[prefix] = {
            prefix,
            index: 0
        };
    }
}
exports.Scope = Scope;
class ValueScopeName extends code_1.Name {
    constructor(prefix, nameStr){
        super(nameStr);
        this.prefix = prefix;
    }
    setValue(value, { property, itemIndex }) {
        this.value = value;
        this.scopePath = (0, code_1._)`.${new code_1.Name(property)}[${itemIndex}]`;
    }
}
exports.ValueScopeName = ValueScopeName;
const line = (0, code_1._)`\n`;
class ValueScope extends Scope {
    constructor(opts){
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = {
            ...opts,
            _n: opts.lines ? line : code_1.nil
        };
    }
    get() {
        return this._scope;
    }
    name(prefix) {
        return new ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name) return _name;
        } else vs = this._values[prefix] = new Map();
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, {
            property: prefix,
            itemIndex
        });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs) return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name)=>{
            if (name.scopePath === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, code_1._)`${scopeName}${name.scopePath}`;
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name)=>{
            if (name.value === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = code_1.nil;
        for(const prefix in values){
            const vs = values[prefix];
            if (!vs) continue;
            const nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
            vs.forEach((name)=>{
                if (nameSet.has(name)) return;
                nameSet.set(name, UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? exports.varKinds.var : exports.varKinds.const;
                    code = (0, code_1._)`${code}${def} ${name} = ${c};${this.opts._n}`;
                } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) code = (0, code_1._)`${code}${c}${this.opts._n}`;
                else throw new ValueError(name);
                nameSet.set(name, UsedValueState.Completed);
            });
        }
        return code;
    }
}
exports.ValueScope = ValueScope;

},{"fe3b9fbcf3b5938":"I9coQ"}],"hqTFh":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkStrictMode = exports.getErrorPath = exports.Type = exports.useFunc = exports.setEvaluated = exports.evaluatedPropsToName = exports.mergeEvaluated = exports.eachItem = exports.unescapeJsonPointer = exports.escapeJsonPointer = exports.escapeFragment = exports.unescapeFragment = exports.schemaRefOrVal = exports.schemaHasRulesButRef = exports.schemaHasRules = exports.checkUnknownRules = exports.alwaysValidSchema = exports.toHash = void 0;
const codegen_1 = require("1fed95e2ef43e8be");
const code_1 = require("9f52dff5cd4050ce");
// TODO refactor to use Set
function toHash(arr) {
    const hash = {};
    for (const item of arr)hash[item] = true;
    return hash;
}
exports.toHash = toHash;
function alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean") return schema;
    if (Object.keys(schema).length === 0) return true;
    checkUnknownRules(it, schema);
    return !schemaHasRules(schema, it.self.RULES.all);
}
exports.alwaysValidSchema = alwaysValidSchema;
function checkUnknownRules(it, schema = it.schema) {
    const { opts, self } = it;
    if (!opts.strictSchema) return;
    if (typeof schema === "boolean") return;
    const rules = self.RULES.keywords;
    for(const key in schema)if (!rules[key]) checkStrictMode(it, `unknown keyword: "${key}"`);
}
exports.checkUnknownRules = checkUnknownRules;
function schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (rules[key]) return true;
    return false;
}
exports.schemaHasRules = schemaHasRules;
function schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (key !== "$ref" && RULES.all[key]) return true;
    return false;
}
exports.schemaHasRulesButRef = schemaHasRulesButRef;
function schemaRefOrVal({ topSchemaRef, schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean") return schema;
        if (typeof schema == "string") return (0, codegen_1._)`${schema}`;
    }
    return (0, codegen_1._)`${topSchemaRef}${schemaPath}${(0, codegen_1.getProperty)(keyword)}`;
}
exports.schemaRefOrVal = schemaRefOrVal;
function unescapeFragment(str) {
    return unescapeJsonPointer(decodeURIComponent(str));
}
exports.unescapeFragment = unescapeFragment;
function escapeFragment(str) {
    return encodeURIComponent(escapeJsonPointer(str));
}
exports.escapeFragment = escapeFragment;
function escapeJsonPointer(str) {
    if (typeof str == "number") return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
exports.escapeJsonPointer = escapeJsonPointer;
function unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
exports.unescapeJsonPointer = unescapeJsonPointer;
function eachItem(xs, f) {
    if (Array.isArray(xs)) for (const x of xs)f(x);
    else f(xs);
}
exports.eachItem = eachItem;
function makeMergeEvaluated({ mergeNames, mergeToName, mergeValues, resultToName }) {
    return (gen, from, to, toName)=>{
        const res = to === undefined ? from : to instanceof codegen_1.Name ? (from instanceof codegen_1.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to) : from instanceof codegen_1.Name ? (mergeToName(gen, to, from), from) : mergeValues(from, to);
        return toName === codegen_1.Name && !(res instanceof codegen_1.Name) ? resultToName(gen, res) : res;
    };
}
exports.mergeEvaluated = {
    props: makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, codegen_1._)`${to} !== true && ${from} !== undefined`, ()=>{
                gen.if((0, codegen_1._)`${from} === true`, ()=>gen.assign(to, true), ()=>gen.assign(to, (0, codegen_1._)`${to} || {}`).code((0, codegen_1._)`Object.assign(${to}, ${from})`));
            }),
        mergeToName: (gen, from, to)=>gen.if((0, codegen_1._)`${to} !== true`, ()=>{
                if (from === true) gen.assign(to, true);
                else {
                    gen.assign(to, (0, codegen_1._)`${to} || {}`);
                    setEvaluated(gen, to, from);
                }
            }),
        mergeValues: (from, to)=>from === true ? true : {
                ...from,
                ...to
            },
        resultToName: evaluatedPropsToName
    }),
    items: makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, codegen_1._)`${to} !== true && ${from} !== undefined`, ()=>gen.assign(to, (0, codegen_1._)`${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
        mergeToName: (gen, from, to)=>gen.if((0, codegen_1._)`${to} !== true`, ()=>gen.assign(to, from === true ? true : (0, codegen_1._)`${to} > ${from} ? ${to} : ${from}`)),
        mergeValues: (from, to)=>from === true ? true : Math.max(from, to),
        resultToName: (gen, items)=>gen.var("items", items)
    })
};
function evaluatedPropsToName(gen, ps) {
    if (ps === true) return gen.var("props", true);
    const props = gen.var("props", (0, codegen_1._)`{}`);
    if (ps !== undefined) setEvaluated(gen, props, ps);
    return props;
}
exports.evaluatedPropsToName = evaluatedPropsToName;
function setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p)=>gen.assign((0, codegen_1._)`${props}${(0, codegen_1.getProperty)(p)}`, true));
}
exports.setEvaluated = setEvaluated;
const snippets = {};
function useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: snippets[f.code] || (snippets[f.code] = new code_1._Code(f.code))
    });
}
exports.useFunc = useFunc;
var Type;
(function(Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})(Type || (exports.Type = Type = {}));
function getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof codegen_1.Name) {
        const isNumber = dataPropType === Type.Num;
        return jsPropertySyntax ? isNumber ? (0, codegen_1._)`"[" + ${dataProp} + "]"` : (0, codegen_1._)`"['" + ${dataProp} + "']"` : isNumber ? (0, codegen_1._)`"/" + ${dataProp}` : (0, codegen_1._)`"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, codegen_1.getProperty)(dataProp).toString() : "/" + escapeJsonPointer(dataProp);
}
exports.getErrorPath = getErrorPath;
function checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode) return;
    msg = `strict mode: ${msg}`;
    if (mode === true) throw new Error(msg);
    it.self.logger.warn(msg);
}
exports.checkStrictMode = checkStrictMode;

},{"1fed95e2ef43e8be":"5E3CJ","9f52dff5cd4050ce":"I9coQ"}],"eZ3V6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("39d82176e02d4399");
const names = {
    // validation function arguments
    data: new codegen_1.Name("data"),
    // args passed from referencing schema
    valCxt: new codegen_1.Name("valCxt"),
    instancePath: new codegen_1.Name("instancePath"),
    parentData: new codegen_1.Name("parentData"),
    parentDataProperty: new codegen_1.Name("parentDataProperty"),
    rootData: new codegen_1.Name("rootData"),
    dynamicAnchors: new codegen_1.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new codegen_1.Name("vErrors"),
    errors: new codegen_1.Name("errors"),
    this: new codegen_1.Name("this"),
    // "globals"
    self: new codegen_1.Name("self"),
    scope: new codegen_1.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new codegen_1.Name("json"),
    jsonPos: new codegen_1.Name("jsonPos"),
    jsonLen: new codegen_1.Name("jsonLen"),
    jsonPart: new codegen_1.Name("jsonPart")
};
exports.default = names;

},{"39d82176e02d4399":"5E3CJ"}],"2BpoV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportTypeError = exports.checkDataTypes = exports.checkDataType = exports.coerceAndCheckDataType = exports.getJSONTypes = exports.getSchemaTypes = exports.DataType = void 0;
const rules_1 = require("4089f5f8b045add0");
const applicability_1 = require("dd5ec382536e9238");
const errors_1 = require("88cdfb931f80e7b5");
const codegen_1 = require("3415e851a7f8c325");
const util_1 = require("7e9cd5ad0634b02b");
var DataType;
(function(DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})(DataType || (exports.DataType = DataType = {}));
function getSchemaTypes(schema) {
    const types = getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false) throw new Error("type: null contradicts nullable: false");
    } else {
        if (!types.length && schema.nullable !== undefined) throw new Error('"nullable" cannot be used without "type"');
        if (schema.nullable === true) types.push("null");
    }
    return types;
}
exports.getSchemaTypes = getSchemaTypes;
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
function getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [
        ts
    ] : [];
    if (types.every(rules_1.isJSONType)) return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
exports.getJSONTypes = getJSONTypes;
function coerceAndCheckDataType(it, types) {
    const { gen, data, opts } = it;
    const coerceTo = coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 && !(coerceTo.length === 0 && types.length === 1 && (0, applicability_1.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = checkDataTypes(types, data, opts.strictNumbers, DataType.Wrong);
        gen.if(wrongType, ()=>{
            if (coerceTo.length) coerceData(it, types, coerceTo);
            else reportTypeError(it);
        });
    }
    return checkTypes;
}
exports.coerceAndCheckDataType = coerceAndCheckDataType;
const COERCIBLE = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function coerceToTypes(types, coerceTypes) {
    return coerceTypes ? types.filter((t)=>COERCIBLE.has(t) || coerceTypes === "array" && t === "array") : [];
}
function coerceData(it, types, coerceTo) {
    const { gen, data, opts } = it;
    const dataType = gen.let("dataType", (0, codegen_1._)`typeof ${data}`);
    const coerced = gen.let("coerced", (0, codegen_1._)`undefined`);
    if (opts.coerceTypes === "array") gen.if((0, codegen_1._)`${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, ()=>gen.assign(data, (0, codegen_1._)`${data}[0]`).assign(dataType, (0, codegen_1._)`typeof ${data}`).if(checkDataTypes(types, data, opts.strictNumbers), ()=>gen.assign(coerced, data)));
    gen.if((0, codegen_1._)`${coerced} !== undefined`);
    for (const t of coerceTo)if (COERCIBLE.has(t) || t === "array" && opts.coerceTypes === "array") coerceSpecificType(t);
    gen.else();
    reportTypeError(it);
    gen.endIf();
    gen.if((0, codegen_1._)`${coerced} !== undefined`, ()=>{
        gen.assign(data, coerced);
        assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch(t){
            case "string":
                gen.elseIf((0, codegen_1._)`${dataType} == "number" || ${dataType} == "boolean"`).assign(coerced, (0, codegen_1._)`"" + ${data}`).elseIf((0, codegen_1._)`${data} === null`).assign(coerced, (0, codegen_1._)`""`);
                return;
            case "number":
                gen.elseIf((0, codegen_1._)`${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`).assign(coerced, (0, codegen_1._)`+${data}`);
                return;
            case "integer":
                gen.elseIf((0, codegen_1._)`${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`).assign(coerced, (0, codegen_1._)`+${data}`);
                return;
            case "boolean":
                gen.elseIf((0, codegen_1._)`${data} === "false" || ${data} === 0 || ${data} === null`).assign(coerced, false).elseIf((0, codegen_1._)`${data} === "true" || ${data} === 1`).assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, codegen_1._)`${data} === "" || ${data} === 0 || ${data} === false`);
                gen.assign(coerced, null);
                return;
            case "array":
                gen.elseIf((0, codegen_1._)`${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`).assign(coerced, (0, codegen_1._)`[${data}]`);
        }
    }
}
function assignParentData({ gen, parentData, parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, codegen_1._)`${parentData} !== undefined`, ()=>gen.assign((0, codegen_1._)`${parentData}[${parentDataProperty}]`, expr));
}
function checkDataType(dataType, data, strictNums, correct = DataType.Correct) {
    const EQ = correct === DataType.Correct ? codegen_1.operators.EQ : codegen_1.operators.NEQ;
    let cond;
    switch(dataType){
        case "null":
            return (0, codegen_1._)`${data} ${EQ} null`;
        case "array":
            cond = (0, codegen_1._)`Array.isArray(${data})`;
            break;
        case "object":
            cond = (0, codegen_1._)`${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
        case "integer":
            cond = numCond((0, codegen_1._)`!(${data} % 1) && !isNaN(${data})`);
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, codegen_1._)`typeof ${data} ${EQ} ${dataType}`;
    }
    return correct === DataType.Correct ? cond : (0, codegen_1.not)(cond);
    function numCond(_cond = codegen_1.nil) {
        return (0, codegen_1.and)((0, codegen_1._)`typeof ${data} == "number"`, _cond, strictNums ? (0, codegen_1._)`isFinite(${data})` : codegen_1.nil);
    }
}
exports.checkDataType = checkDataType;
function checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) return checkDataType(dataTypes[0], data, strictNums, correct);
    let cond;
    const types = (0, util_1.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, codegen_1._)`typeof ${data} != "object"`;
        cond = types.null ? notObj : (0, codegen_1._)`!${data} || ${notObj}`;
        delete types.null;
        delete types.array;
        delete types.object;
    } else cond = codegen_1.nil;
    if (types.number) delete types.integer;
    for(const t in types)cond = (0, codegen_1.and)(cond, checkDataType(t, data, strictNums, correct));
    return cond;
}
exports.checkDataTypes = checkDataTypes;
const typeError = {
    message: ({ schema })=>`must be ${schema}`,
    params: ({ schema, schemaValue })=>typeof schema == "string" ? (0, codegen_1._)`{type: ${schema}}` : (0, codegen_1._)`{type: ${schemaValue}}`
};
function reportTypeError(it) {
    const cxt = getTypeErrorContext(it);
    (0, errors_1.reportError)(cxt, typeError);
}
exports.reportTypeError = reportTypeError;
function getTypeErrorContext(it) {
    const { gen, data, schema } = it;
    const schemaCode = (0, util_1.schemaRefOrVal)(it, schema, "type");
    return {
        gen,
        keyword: "type",
        data,
        schema: schema.type,
        schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it
    };
}

},{"4089f5f8b045add0":"4nAEP","dd5ec382536e9238":"4bPUa","88cdfb931f80e7b5":"ftDQV","3415e851a7f8c325":"5E3CJ","7e9cd5ad0634b02b":"hqTFh"}],"4nAEP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRules = exports.isJSONType = void 0;
const _jsonTypes = [
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
];
const jsonTypes = new Set(_jsonTypes);
function isJSONType(x) {
    return typeof x == "string" && jsonTypes.has(x);
}
exports.isJSONType = isJSONType;
function getRules() {
    const groups = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: {
            ...groups,
            integer: true,
            boolean: true,
            null: true
        },
        rules: [
            {
                rules: []
            },
            groups.number,
            groups.string,
            groups.array,
            groups.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
}
exports.getRules = getRules;

},{}],"4bPUa":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shouldUseRule = exports.shouldUseGroup = exports.schemaHasRulesForType = void 0;
function schemaHasRulesForType({ schema, self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && shouldUseGroup(schema, group);
}
exports.schemaHasRulesForType = schemaHasRulesForType;
function shouldUseGroup(schema, group) {
    return group.rules.some((rule)=>shouldUseRule(schema, rule));
}
exports.shouldUseGroup = shouldUseGroup;
function shouldUseRule(schema, rule) {
    var _a;
    return schema[rule.keyword] !== undefined || ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd)=>schema[kwd] !== undefined));
}
exports.shouldUseRule = shouldUseRule;

},{}],"a2YRR":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.assignDefaults = void 0;
const codegen_1 = require("cc7174703daf515");
const util_1 = require("a2721282ac596cf5");
function assignDefaults(it, ty) {
    const { properties, items } = it.schema;
    if (ty === "object" && properties) for(const key in properties)assignDefault(it, key, properties[key].default);
    else if (ty === "array" && Array.isArray(items)) items.forEach((sch, i)=>assignDefault(it, i, sch.default));
}
exports.assignDefaults = assignDefaults;
function assignDefault(it, prop, defaultValue) {
    const { gen, compositeRule, data, opts } = it;
    if (defaultValue === undefined) return;
    const childData = (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(prop)}`;
    if (compositeRule) {
        (0, util_1.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, codegen_1._)`${childData} === undefined`;
    if (opts.useDefaults === "empty") condition = (0, codegen_1._)`${condition} || ${childData} === null || ${childData} === ""`;
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, codegen_1._)`${childData} = ${(0, codegen_1.stringify)(defaultValue)}`);
}

},{"cc7174703daf515":"5E3CJ","a2721282ac596cf5":"hqTFh"}],"9JbMh":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateKeywordUsage = exports.validSchemaType = exports.funcKeywordCode = exports.macroKeywordCode = void 0;
const codegen_1 = require("18e33341eef58f18");
const names_1 = require("e12c11aac04b7418");
const code_1 = require("adc32b068f541871");
const errors_1 = require("bc193073814b6e5f");
function macroKeywordCode(cxt, def) {
    const { gen, keyword, schema, parentSchema, it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false) it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: codegen_1.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true
    }, valid);
    cxt.pass(valid, ()=>cxt.error(true));
}
exports.macroKeywordCode = macroKeywordCode;
function funcKeywordCode(cxt, def) {
    var _a;
    const { gen, keyword, schema, parentSchema, $data, it } = cxt;
    checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying) modifyData(cxt);
            reportErrs(()=>cxt.error());
        } else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying) modifyData(cxt);
            reportErrs(()=>addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(()=>assignValid((0, codegen_1._)`await `), (e)=>gen.assign(valid, false).if((0, codegen_1._)`${e} instanceof ${it.ValidationError}`, ()=>gen.assign(ruleErrs, (0, codegen_1._)`${e}.errors`), ()=>gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, codegen_1._)`${validateRef}.errors`;
        gen.assign(validateErrs, null);
        assignValid(codegen_1.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, codegen_1._)`await ` : codegen_1.nil) {
        const passCxt = it.opts.passContext ? names_1.default.this : names_1.default.self;
        const passSchema = !("compile" in def && !$data || def.schema === false);
        gen.assign(valid, (0, codegen_1._)`${_await}${(0, code_1.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, codegen_1.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
exports.funcKeywordCode = funcKeywordCode;
function modifyData(cxt) {
    const { gen, data, it } = cxt;
    gen.if(it.parentData, ()=>gen.assign(data, (0, codegen_1._)`${it.parentData}[${it.parentDataProperty}]`));
}
function addErrs(cxt, errs) {
    const { gen } = cxt;
    gen.if((0, codegen_1._)`Array.isArray(${errs})`, ()=>{
        gen.assign(names_1.default.vErrors, (0, codegen_1._)`${names_1.default.vErrors} === null ? ${errs} : ${names_1.default.vErrors}.concat(${errs})`).assign(names_1.default.errors, (0, codegen_1._)`${names_1.default.vErrors}.length`);
        (0, errors_1.extendErrors)(cxt);
    }, ()=>cxt.error());
}
function checkAsyncKeyword({ schemaEnv }, def) {
    if (def.async && !schemaEnv.$async) throw new Error("async keyword in sync schema");
}
function useKeyword(gen, keyword, result) {
    if (result === undefined) throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? {
        ref: result
    } : {
        ref: result,
        code: (0, codegen_1.stringify)(result)
    });
}
function validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return !schemaType.length || schemaType.some((st)=>st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined");
}
exports.validSchemaType = validSchemaType;
function validateKeywordUsage({ schema, opts, self, errSchemaPath }, def, keyword) {
    /* istanbul ignore if */ if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) throw new Error("ajv implementation error");
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd)=>!Object.prototype.hasOwnProperty.call(schema, kwd))) throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` + self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log") self.logger.error(msg);
            else throw new Error(msg);
        }
    }
}
exports.validateKeywordUsage = validateKeywordUsage;

},{"18e33341eef58f18":"5E3CJ","e12c11aac04b7418":"eZ3V6","adc32b068f541871":"k0GaT","bc193073814b6e5f":"ftDQV"}],"k0GaT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateUnion = exports.validateArray = exports.usePattern = exports.callValidateCode = exports.schemaProperties = exports.allSchemaProperties = exports.noPropertyInData = exports.propertyInData = exports.isOwnProperty = exports.hasPropFunc = exports.reportMissingProp = exports.checkMissingProp = exports.checkReportMissingProp = void 0;
const codegen_1 = require("c5b9cfa38882b736");
const util_1 = require("6bd31a3c9b2fd469");
const names_1 = require("875dcb82ae7c724a");
const util_2 = require("6bd31a3c9b2fd469");
function checkReportMissingProp(cxt, prop) {
    const { gen, data, it } = cxt;
    gen.if(noPropertyInData(gen, data, prop, it.opts.ownProperties), ()=>{
        cxt.setParams({
            missingProperty: (0, codegen_1._)`${prop}`
        }, true);
        cxt.error();
    });
}
exports.checkReportMissingProp = checkReportMissingProp;
function checkMissingProp({ gen, data, it: { opts } }, properties, missing) {
    return (0, codegen_1.or)(...properties.map((prop)=>(0, codegen_1.and)(noPropertyInData(gen, data, prop, opts.ownProperties), (0, codegen_1._)`${missing} = ${prop}`)));
}
exports.checkMissingProp = checkMissingProp;
function reportMissingProp(cxt, missing) {
    cxt.setParams({
        missingProperty: missing
    }, true);
    cxt.error();
}
exports.reportMissingProp = reportMissingProp;
function hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, codegen_1._)`Object.prototype.hasOwnProperty`
    });
}
exports.hasPropFunc = hasPropFunc;
function isOwnProperty(gen, data, property) {
    return (0, codegen_1._)`${hasPropFunc(gen)}.call(${data}, ${property})`;
}
exports.isOwnProperty = isOwnProperty;
function propertyInData(gen, data, property, ownProperties) {
    const cond = (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(property)} !== undefined`;
    return ownProperties ? (0, codegen_1._)`${cond} && ${isOwnProperty(gen, data, property)}` : cond;
}
exports.propertyInData = propertyInData;
function noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(property)} === undefined`;
    return ownProperties ? (0, codegen_1.or)(cond, (0, codegen_1.not)(isOwnProperty(gen, data, property))) : cond;
}
exports.noPropertyInData = noPropertyInData;
function allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p)=>p !== "__proto__") : [];
}
exports.allSchemaProperties = allSchemaProperties;
function schemaProperties(it, schemaMap) {
    return allSchemaProperties(schemaMap).filter((p)=>!(0, util_1.alwaysValidSchema)(it, schemaMap[p]));
}
exports.schemaProperties = schemaProperties;
function callValidateCode({ schemaCode, data, it: { gen, topSchemaRef, schemaPath, errorPath }, it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, codegen_1._)`${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
    const valCxt = [
        [
            names_1.default.instancePath,
            (0, codegen_1.strConcat)(names_1.default.instancePath, errorPath)
        ],
        [
            names_1.default.parentData,
            it.parentData
        ],
        [
            names_1.default.parentDataProperty,
            it.parentDataProperty
        ],
        [
            names_1.default.rootData,
            names_1.default.rootData
        ]
    ];
    if (it.opts.dynamicRef) valCxt.push([
        names_1.default.dynamicAnchors,
        names_1.default.dynamicAnchors
    ]);
    const args = (0, codegen_1._)`${dataAndSchema}, ${gen.object(...valCxt)}`;
    return context !== codegen_1.nil ? (0, codegen_1._)`${func}.call(${context}, ${args})` : (0, codegen_1._)`${func}(${args})`;
}
exports.callValidateCode = callValidateCode;
const newRegExp = (0, codegen_1._)`new RegExp`;
function usePattern({ gen, it: { opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, codegen_1._)`${regExp.code === "new RegExp" ? newRegExp : (0, util_2.useFunc)(gen, regExp)}(${pattern}, ${u})`
    });
}
exports.usePattern = usePattern;
function validateArray(cxt) {
    const { gen, data, keyword, it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(()=>gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(()=>gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, codegen_1._)`${data}.length`);
        gen.forRange("i", 0, len, (i)=>{
            cxt.subschema({
                keyword,
                dataProp: i,
                dataPropType: util_1.Type.Num
            }, valid);
            gen.if((0, codegen_1.not)(valid), notValid);
        });
    }
}
exports.validateArray = validateArray;
function validateUnion(cxt) {
    const { gen, schema, keyword, it } = cxt;
    /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
    const alwaysValid = schema.some((sch)=>(0, util_1.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated) return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(()=>schema.forEach((_sch, i)=>{
            const schCxt = cxt.subschema({
                keyword,
                schemaProp: i,
                compositeRule: true
            }, schValid);
            gen.assign(valid, (0, codegen_1._)`${valid} || ${schValid}`);
            const merged = cxt.mergeValidEvaluated(schCxt, schValid);
            // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
            // or if all properties and items were evaluated (it.props === true && it.items === true)
            if (!merged) gen.if((0, codegen_1.not)(valid));
        }));
    cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
}
exports.validateUnion = validateUnion;

},{"c5b9cfa38882b736":"5E3CJ","6bd31a3c9b2fd469":"hqTFh","875dcb82ae7c724a":"eZ3V6"}],"1fj2K":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extendSubschemaMode = exports.extendSubschemaData = exports.getSubschema = void 0;
const codegen_1 = require("aa9b081156c973ca");
const util_1 = require("f65cedb2b5f71713");
function getSubschema(it, { keyword, schemaProp, schema, schemaPath, errSchemaPath, topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined ? {
            schema: sch,
            schemaPath: (0, codegen_1._)`${it.schemaPath}${(0, codegen_1.getProperty)(keyword)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}`
        } : {
            schema: sch[schemaProp],
            schemaPath: (0, codegen_1._)`${it.schemaPath}${(0, codegen_1.getProperty)(keyword)}${(0, codegen_1.getProperty)(schemaProp)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, util_1.escapeFragment)(schemaProp)}`
        };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        return {
            schema,
            schemaPath,
            topSchemaRef,
            errSchemaPath
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
exports.getSubschema = getSubschema;
function extendSubschemaData(subschema, it, { dataProp, dataPropType: dpType, data, dataTypes, propertyName }) {
    if (data !== undefined && dataProp !== undefined) throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen } = it;
    if (dataProp !== undefined) {
        const { errorPath, dataPathArr, opts } = it;
        const nextData = gen.let("data", (0, codegen_1._)`${it.data}${(0, codegen_1.getProperty)(dataProp)}`, true);
        dataContextProps(nextData);
        subschema.errorPath = (0, codegen_1.str)`${errorPath}${(0, util_1.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
        subschema.parentDataProperty = (0, codegen_1._)`${dataProp}`;
        subschema.dataPathArr = [
            ...dataPathArr,
            subschema.parentDataProperty
        ];
    }
    if (data !== undefined) {
        const nextData = data instanceof codegen_1.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined) subschema.propertyName = propertyName;
    // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes) subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [
            ...it.dataNames,
            _nextData
        ];
    }
}
exports.extendSubschemaData = extendSubschemaData;
function extendSubschemaMode(subschema, { jtdDiscriminator, jtdMetadata, compositeRule, createErrors, allErrors }) {
    if (compositeRule !== undefined) subschema.compositeRule = compositeRule;
    if (createErrors !== undefined) subschema.createErrors = createErrors;
    if (allErrors !== undefined) subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
exports.extendSubschemaMode = extendSubschemaMode;

},{"aa9b081156c973ca":"5E3CJ","f65cedb2b5f71713":"hqTFh"}],"dIPgO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSchemaRefs = exports.resolveUrl = exports.normalizeId = exports._getFullPath = exports.getFullPath = exports.inlineRef = void 0;
const util_1 = require("272bb8b278b5bdbb");
const equal = require("4cbbead361e56e33");
const traverse = require("7533283b2784ffaa");
// TODO refactor to use keyword definitions
const SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
function inlineRef(schema, limit = true) {
    if (typeof schema == "boolean") return true;
    if (limit === true) return !hasRef(schema);
    if (!limit) return false;
    return countKeys(schema) <= limit;
}
exports.inlineRef = inlineRef;
const REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function hasRef(schema) {
    for(const key in schema){
        if (REF_KEYWORDS.has(key)) return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some(hasRef)) return true;
        if (typeof sch == "object" && hasRef(sch)) return true;
    }
    return false;
}
function countKeys(schema) {
    let count = 0;
    for(const key in schema){
        if (key === "$ref") return Infinity;
        count++;
        if (SIMPLE_INLINED.has(key)) continue;
        if (typeof schema[key] == "object") (0, util_1.eachItem)(schema[key], (sch)=>count += countKeys(sch));
        if (count === Infinity) return Infinity;
    }
    return count;
}
function getFullPath(resolver, id = "", normalize) {
    if (normalize !== false) id = normalizeId(id);
    const p = resolver.parse(id);
    return _getFullPath(resolver, p);
}
exports.getFullPath = getFullPath;
function _getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
exports._getFullPath = _getFullPath;
const TRAILING_SLASH_HASH = /#\/?$/;
function normalizeId(id) {
    return id ? id.replace(TRAILING_SLASH_HASH, "") : "";
}
exports.normalizeId = normalizeId;
function resolveUrl(resolver, baseId, id) {
    id = normalizeId(id);
    return resolver.resolve(baseId, id);
}
exports.resolveUrl = resolveUrl;
const ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean") return {};
    const { schemaId, uriResolver } = this.opts;
    const schId = normalizeId(schema[schemaId] || baseId);
    const baseIds = {
        "": schId
    };
    const pathPrefix = getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    traverse(schema, {
        allKeys: true
    }, (sch, jsonPtr, _, parentJsonPtr)=>{
        if (parentJsonPtr === undefined) return;
        const fullPath = pathPrefix + jsonPtr;
        let innerBaseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string") innerBaseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = innerBaseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = normalizeId(innerBaseId ? _resolve(innerBaseId, ref) : ref);
            if (schemaRefs.has(ref)) throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string") schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") checkAmbiguosRef(sch, schOrRef.schema, ref);
            else if (ref !== normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                } else this.refs[ref] = fullPath;
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!ANCHOR.test(anchor)) throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !equal(sch1, sch2)) throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}
exports.getSchemaRefs = getSchemaRefs;

},{"272bb8b278b5bdbb":"hqTFh","4cbbead361e56e33":"blc55","7533283b2784ffaa":"h6xT2"}],"blc55":[function(require,module,exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

},{}],"h6xT2":[function(require,module,exports) {
"use strict";
var traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == "function") {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == "function" ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    _traverse(opts, pre, post, schema, "", schema);
};
traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
traverse.propsKeywords = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function _traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == "object" && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)_traverse(opts, pre, post, sch[i], jsonPtr + "/" + key + "/" + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in traverse.propsKeywords) {
                if (sch && typeof sch == "object") for(var prop in sch)_traverse(opts, pre, post, sch[prop], jsonPtr + "/" + key + "/" + escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in traverse.keywords || opts.allKeys && !(key in traverse.skipKeywords)) _traverse(opts, pre, post, sch, jsonPtr + "/" + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function escapeJsonPtr(str) {
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}

},{}],"eZiGZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
class ValidationError extends Error {
    constructor(errors){
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
exports.default = ValidationError;

},{}],"8Strz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const resolve_1 = require("96fb41608b61ab2d");
class MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg){
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, resolve_1.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, resolve_1.normalizeId)((0, resolve_1.getFullPath)(resolver, this.missingRef));
    }
}
exports.default = MissingRefError;

},{"96fb41608b61ab2d":"dIPgO"}],"82s90":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resolveSchema = exports.getCompilingSchema = exports.resolveRef = exports.compileSchema = exports.SchemaEnv = void 0;
const codegen_1 = require("6040b29f803efe21");
const validation_error_1 = require("84e7c50527309eb3");
const names_1 = require("bb7dbfc63c27004d");
const resolve_1 = require("cd18dcd881afb39c");
const util_1 = require("6ba7949df35e27ab");
const validate_1 = require("dddb82f3af9e275e");
class SchemaEnv {
    constructor(env){
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object") schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, resolve_1.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
exports.SchemaEnv = SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const rootId = (0, resolve_1.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5, lines } = this.opts.code;
    const { ownProperties } = this.opts;
    const gen = new codegen_1.CodeGen(this.scope, {
        es5,
        lines,
        ownProperties
    });
    let _ValidationError;
    if (sch.$async) _ValidationError = gen.scopeValue("Error", {
        ref: validation_error_1.default,
        code: (0, codegen_1._)`require("ajv/dist/runtime/validation_error").default`
    });
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen,
        allErrors: this.opts.allErrors,
        data: names_1.default.data,
        parentData: names_1.default.parentData,
        parentDataProperty: names_1.default.parentDataProperty,
        dataNames: [
            names_1.default.data
        ],
        dataPathArr: [
            codegen_1.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? {
            ref: sch.schema,
            code: (0, codegen_1.stringify)(sch.schema)
        } : {
            ref: sch.schema
        }),
        validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId,
        baseId: sch.baseId || rootId,
        schemaPath: codegen_1.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, codegen_1._)`""`,
        opts: this.opts,
        self: this
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, validate_1.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `${gen.scopeRefs(names_1.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process) sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${names_1.default.self}`, `${names_1.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, {
            ref: validate
        });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async) validate.$async = true;
        if (this.opts.code.source === true) validate.source = {
            validateName,
            validateCode,
            scopeValues: gen._values
        };
        if (this.opts.unevaluated) {
            const { props, items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof codegen_1.Name ? undefined : props,
                items: items instanceof codegen_1.Name ? undefined : items,
                dynamicProps: props instanceof codegen_1.Name,
                dynamicItems: items instanceof codegen_1.Name
            };
            if (validate.source) validate.source.evaluated = (0, codegen_1.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    } catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode) this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
}
exports.compileSchema = compileSchema;
function resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, ref);
    const schOrFunc = root.refs[ref];
    if (schOrFunc) return schOrFunc;
    let _sch = resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId } = this.opts;
        if (schema) _sch = new SchemaEnv({
            schema,
            schemaId,
            root,
            baseId
        });
    }
    if (_sch === undefined) return;
    return root.refs[ref] = inlineOrCompile.call(this, _sch);
}
exports.resolveRef = resolveRef;
function inlineOrCompile(sch) {
    if ((0, resolve_1.inlineRef)(sch.schema, this.opts.inlineRefs)) return sch.schema;
    return sch.validate ? sch : compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function getCompilingSchema(schEnv) {
    for (const sch of this._compilations){
        if (sameSchemaEnv(sch, schEnv)) return sch;
    }
}
exports.getCompilingSchema = getCompilingSchema;
function sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function resolve(root, ref // reference to resolve
) {
    let sch;
    while(typeof (sch = this.refs[ref]) == "string")ref = sch;
    return sch || this.schemas[ref] || resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function resolveSchema(root, ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, resolve_1._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, resolve_1.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) return getJsonPointer.call(this, p, root);
    const id = (0, resolve_1.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object") return;
        return getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object") return;
    if (!schOrRef.validate) compileSchema.call(this, schOrRef);
    if (id === (0, resolve_1.normalizeId)(ref)) {
        const { schema } = schOrRef;
        const { schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId) baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new SchemaEnv({
            schema,
            schemaId,
            root,
            baseId
        });
    }
    return getJsonPointer.call(this, p, schOrRef);
}
exports.resolveSchema = resolveSchema;
const PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function getJsonPointer(parsedRef, { baseId, schema, root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/") return;
    for (const part of parsedRef.fragment.slice(1).split("/")){
        if (typeof schema === "boolean") return;
        const partSchema = schema[(0, util_1.unescapeFragment)(part)];
        if (partSchema === undefined) return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!PREVENT_SCOPE_CHANGE.has(part) && schId) baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, util_1.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId } = this.opts;
    env = env || new SchemaEnv({
        schema,
        schemaId,
        root,
        baseId
    });
    if (env.schema !== env.root.schema) return env;
    return undefined;
}

},{"6040b29f803efe21":"5E3CJ","84e7c50527309eb3":"eZiGZ","bb7dbfc63c27004d":"eZ3V6","cd18dcd881afb39c":"dIPgO","6ba7949df35e27ab":"hqTFh","dddb82f3af9e275e":"2Fvud"}],"4YSud":[function(require,module,exports) {
module.exports = JSON.parse('{"$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON AnySchema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');

},{}],"7rBAw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const uri = require("17cfab9bbcc1a9d4");
uri.code = 'require("ajv/dist/runtime/uri").default';
exports.default = uri;

},{"17cfab9bbcc1a9d4":"9Dah9"}],"9Dah9":[function(require,module,exports) {
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */ (function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    "use strict";
    function merge() {
        for(var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++)sets[_key] = arguments[_key];
        if (sets.length > 1) {
            sets[0] = sets[0].slice(0, -1);
            var xl = sets.length - 1;
            for(var x = 1; x < xl; ++x)sets[x] = sets[x].slice(1, -1);
            sets[xl] = sets[xl].slice(1);
            return sets.join("");
        } else return sets[0];
    }
    function subexp(str) {
        return "(?:" + str + ")";
    }
    function typeOf(o) {
        return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
    }
    function toUpperCase(str) {
        return str.toUpperCase();
    }
    function toArray(obj) {
        return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [
            obj
        ] : Array.prototype.slice.call(obj) : [];
    }
    function assign(target, source) {
        var obj = target;
        if (source) for(var key in source)obj[key] = source[key];
        return obj;
    }
    function buildExps(isIRI) {
        var ALPHA$$ = "[A-Za-z]", CR$ = "[\\x0D]", DIGIT$$ = "[0-9]", DQUOTE$$ = "[\\x22]", HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"), //case-insensitive
        LF$$ = "[\\x0A]", SP$$ = "[\\x20]", PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)), //expanded
        GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", //subset, excludes bidi control characters
        IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]", //subset
        UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$), SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"), USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"), DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$), DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), //relaxed parsing rules
        IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$ + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), //                           6( h16 ":" ) ls32
        IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), //                      "::" 5( h16 ":" ) ls32
        IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), //[               h16 ] "::" 4( h16 ":" ) ls32
        IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
        IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
        IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
        IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), //[ *4( h16 ":" ) h16 ] "::"              ls32
        IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), //[ *5( h16 ":" ) h16 ] "::"              h16
        IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), //[ *6( h16 ":" ) h16 ] "::"
        IPV6ADDRESS$ = subexp([
            IPV6ADDRESS1$,
            IPV6ADDRESS2$,
            IPV6ADDRESS3$,
            IPV6ADDRESS4$,
            IPV6ADDRESS5$,
            IPV6ADDRESS6$,
            IPV6ADDRESS7$,
            IPV6ADDRESS8$,
            IPV6ADDRESS9$
        ].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"), //RFC 6874
        IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$), //RFC 6874
        IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$), //RFC 6874, with relaxed parsing rules
        IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"), IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"), //RFC 6874
        REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"), HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$), PORT$ = subexp(DIGIT$$ + "*"), AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"), PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")), SEGMENT$ = subexp(PCHAR$ + "*"), SEGMENT_NZ$ = subexp(PCHAR$ + "+"), SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"), PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"), PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"), //simplified
        PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$), //simplified
        PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$), //simplified
        PATH_EMPTY$ = "(?!" + PCHAR$ + ")", PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"), FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"), HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$), RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$), ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"), GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$", SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
        return {
            NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
            NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            UNRESERVED: new RegExp(UNRESERVED$$, "g"),
            OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
            PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
            IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
        };
    }
    var URI_PROTOCOL = buildExps(false);
    var IRI_PROTOCOL = buildExps(true);
    var slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var toConsumableArray = function(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    };
    /** Highest positive signed 32-bit float value */ var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
    /** Bootstring parameters */ var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128; // 0x80
    var delimiter = "-"; // '\x2D'
    /** Regular expressions */ var regexPunycode = /^xn--/;
    var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
    var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
    /** Error messages */ var errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    };
    /** Convenience shortcuts */ var baseMinusTMin = base - tMin;
    var floor = Math.floor;
    var stringFromCharCode = String.fromCharCode;
    /*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function error$1(type) {
        throw new RangeError(errors[type]);
    }
    /**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function map(array, fn) {
        var result = [];
        var length = array.length;
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        while(counter < length){
            var value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // It's a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // Low surrogate.
                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // It's an unmatched surrogate; only append this code unit, in case the
                    // next code unit is the high surrogate of a surrogate pair.
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ var ucs2encode = function ucs2encode(array) {
        return String.fromCodePoint.apply(String, toConsumableArray(array));
    };
    /**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ var basicToDigit = function basicToDigit(codePoint) {
        if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
        if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
        if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
        return base;
    };
    /**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ var digitToBasic = function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    /**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ var adapt = function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    };
    /**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ var decode = function decode(input) {
        // Don't use UCS-2.
        var output = [];
        var inputLength = input.length;
        var i = 0;
        var n = initialN;
        var bias = initialBias;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        var basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(var j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error$1("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(var index = basic > 0 ? basic + 1 : 0; index < inputLength;)/* no final expression */ {
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            var oldi = i;
            for(var w = 1, k = base;; k += base){
                if (index >= inputLength) error$1("invalid-input");
                var digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error$1("overflow");
                i += digit * w;
                var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                var baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error$1("overflow");
                w *= baseMinusT;
            }
            var out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error$1("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output.
            output.splice(i++, 0, n);
        }
        return String.fromCodePoint.apply(String, output);
    };
    /**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ var encode = function encode(input) {
        var output = [];
        // Convert the input in UCS-2 to an array of Unicode code points.
        input = ucs2decode(input);
        // Cache the length.
        var inputLength = input.length;
        // Initialize the state.
        var n = initialN;
        var delta = 0;
        var bias = initialBias;
        // Handle the basic code points.
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _currentValue2 = _step.value;
                if (_currentValue2 < 0x80) output.push(stringFromCharCode(_currentValue2));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        var basicLength = output.length;
        var handledCPCount = basicLength;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string with a delimiter unless it's empty.
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            var m = maxInt;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;
            try {
                for(var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var currentValue = _step2.value;
                    if (currentValue >= n && currentValue < m) m = currentValue;
                }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow.
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                } finally{
                    if (_didIteratorError2) throw _iteratorError2;
                }
            }
            var handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error$1("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;
            try {
                for(var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _currentValue = _step3.value;
                    if (_currentValue < n && ++delta > maxInt) error$1("overflow");
                    if (_currentValue == n) {
                        // Represent delta as a generalized variable-length integer.
                        var q = delta;
                        for(var k = base;; k += base){
                            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                            if (q < t) break;
                            var qMinusT = q - t;
                            var baseMinusT = base - t;
                            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                            q = floor(qMinusT / baseMinusT);
                        }
                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                        delta = 0;
                        ++handledCPCount;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                } finally{
                    if (_didIteratorError3) throw _iteratorError3;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    };
    /**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ var toUnicode = function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    };
    /**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ var toASCII = function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    };
    /*--------------------------------------------------------------------------*/ /** Define the public API */ var punycode = {
        /**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */ "version": "2.1.0",
        /**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */ /**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */ var SCHEMES = {};
    function pctEncChar(chr) {
        var c = chr.charCodeAt(0);
        var e = void 0;
        if (c < 16) e = "%0" + c.toString(16).toUpperCase();
        else if (c < 128) e = "%" + c.toString(16).toUpperCase();
        else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        return e;
    }
    function pctDecChars(str) {
        var newStr = "";
        var i = 0;
        var il = str.length;
        while(i < il){
            var c = parseInt(str.substr(i + 1, 2), 16);
            if (c < 128) {
                newStr += String.fromCharCode(c);
                i += 3;
            } else if (c >= 194 && c < 224) {
                if (il - i >= 6) {
                    var c2 = parseInt(str.substr(i + 4, 2), 16);
                    newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
                } else newStr += str.substr(i, 6);
                i += 6;
            } else if (c >= 224) {
                if (il - i >= 9) {
                    var _c = parseInt(str.substr(i + 4, 2), 16);
                    var c3 = parseInt(str.substr(i + 7, 2), 16);
                    newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
                } else newStr += str.substr(i, 9);
                i += 9;
            } else {
                newStr += str.substr(i, 3);
                i += 3;
            }
        }
        return newStr;
    }
    function _normalizeComponentEncoding(components, protocol) {
        function decodeUnreserved(str) {
            var decStr = pctDecChars(str);
            return !decStr.match(protocol.UNRESERVED) ? str : decStr;
        }
        if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
        if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        return components;
    }
    function _stripLeadingZeros(str) {
        return str.replace(/^0*(.*)/, "$1") || "0";
    }
    function _normalizeIPv4(host, protocol) {
        var matches = host.match(protocol.IPV4ADDRESS) || [];
        var _matches = slicedToArray(matches, 2), address = _matches[1];
        if (address) return address.split(".").map(_stripLeadingZeros).join(".");
        else return host;
    }
    function _normalizeIPv6(host, protocol) {
        var matches = host.match(protocol.IPV6ADDRESS) || [];
        var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
        if (address) {
            var _address$toLowerCase$ = address.toLowerCase().split("::").reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
            var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
            var lastFields = last.split(":").map(_stripLeadingZeros);
            var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
            var fieldCount = isLastFieldIPv4Address ? 7 : 8;
            var lastFieldsStart = lastFields.length - fieldCount;
            var fields = Array(fieldCount);
            for(var x = 0; x < fieldCount; ++x)fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || "";
            if (isLastFieldIPv4Address) fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
            var allZeroFields = fields.reduce(function(acc, field, index) {
                if (!field || field === "0") {
                    var lastLongest = acc[acc.length - 1];
                    if (lastLongest && lastLongest.index + lastLongest.length === index) lastLongest.length++;
                    else acc.push({
                        index: index,
                        length: 1
                    });
                }
                return acc;
            }, []);
            var longestZeroFields = allZeroFields.sort(function(a, b) {
                return b.length - a.length;
            })[0];
            var newHost = void 0;
            if (longestZeroFields && longestZeroFields.length > 1) {
                var newFirst = fields.slice(0, longestZeroFields.index);
                var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
                newHost = newFirst.join(":") + "::" + newLast.join(":");
            } else newHost = fields.join(":");
            if (zone) newHost += "%" + zone;
            return newHost;
        } else return host;
    }
    var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
    var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
    function parse(uriString) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var components = {};
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
        var matches = uriString.match(URI_PARSE);
        if (matches) {
            if (NO_MATCH_IS_UNDEFINED) {
                //store each component
                components.scheme = matches[1];
                components.userinfo = matches[3];
                components.host = matches[4];
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = matches[7];
                components.fragment = matches[8];
                //fix port number
                if (isNaN(components.port)) components.port = matches[5];
            } else {
                //IE FIX for improper RegExp matching
                //store each component
                components.scheme = matches[1] || undefined;
                components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
                components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
                components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
                //fix port number
                if (isNaN(components.port)) components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
            if (components.host) //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
            //determine reference type
            if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) components.reference = "same-document";
            else if (components.scheme === undefined) components.reference = "relative";
            else if (components.fragment === undefined) components.reference = "absolute";
            else components.reference = "uri";
            //check for reference errors
            if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) components.error = components.error || "URI is not a " + options.reference + " reference.";
            //find scheme handler
            var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
            //check if scheme can't handle IRIs
            if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
                //if host component is a domain name
                if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
                //convert IRI -> URI
                _normalizeComponentEncoding(components, URI_PROTOCOL);
            } else //normalize encodings
            _normalizeComponentEncoding(components, protocol);
            //perform scheme specific parsing
            if (schemeHandler && schemeHandler.parse) schemeHandler.parse(components, options);
        } else components.error = components.error || "URI can not be parsed.";
        return components;
    }
    function _recomposeAuthority(components, options) {
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        if (components.userinfo !== undefined) {
            uriTokens.push(components.userinfo);
            uriTokens.push("@");
        }
        if (components.host !== undefined) //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
        if (typeof components.port === "number" || typeof components.port === "string") {
            uriTokens.push(":");
            uriTokens.push(String(components.port));
        }
        return uriTokens.length ? uriTokens.join("") : undefined;
    }
    var RDS1 = /^\.\.?\//;
    var RDS2 = /^\/\.(\/|$)/;
    var RDS3 = /^\/\.\.(\/|$)/;
    var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function removeDotSegments(input) {
        var output = [];
        while(input.length){
            if (input.match(RDS1)) input = input.replace(RDS1, "");
            else if (input.match(RDS2)) input = input.replace(RDS2, "/");
            else if (input.match(RDS3)) {
                input = input.replace(RDS3, "/");
                output.pop();
            } else if (input === "." || input === "..") input = "";
            else {
                var im = input.match(RDS5);
                if (im) {
                    var s = im[0];
                    input = input.slice(s.length);
                    output.push(s);
                } else throw new Error("Unexpected dot segment condition");
            }
        }
        return output.join("");
    }
    function serialize(components) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //perform scheme specific serialization
        if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
        if (components.host) {
            //if host component is an IPv6 address
            if (protocol.IPV6ADDRESS.test(components.host)) ;
            else if (options.domainHost || schemeHandler && schemeHandler.domainHost) //convert IDN via punycode
            try {
                components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
            } catch (e) {
                components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
        }
        //normalize encoding
        _normalizeComponentEncoding(components, protocol);
        if (options.reference !== "suffix" && components.scheme) {
            uriTokens.push(components.scheme);
            uriTokens.push(":");
        }
        var authority = _recomposeAuthority(components, options);
        if (authority !== undefined) {
            if (options.reference !== "suffix") uriTokens.push("//");
            uriTokens.push(authority);
            if (components.path && components.path.charAt(0) !== "/") uriTokens.push("/");
        }
        if (components.path !== undefined) {
            var s = components.path;
            if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = removeDotSegments(s);
            if (authority === undefined) s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
            uriTokens.push(s);
        }
        if (components.query !== undefined) {
            uriTokens.push("?");
            uriTokens.push(components.query);
        }
        if (components.fragment !== undefined) {
            uriTokens.push("#");
            uriTokens.push(components.fragment);
        }
        return uriTokens.join(""); //merge tokens into a string
    }
    function resolveComponents(base, relative) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var skipNormalization = arguments[3];
        var target = {};
        if (!skipNormalization) {
            base = parse(serialize(base, options), options); //normalize base components
            relative = parse(serialize(relative, options), options); //normalize relative components
        }
        options = options || {};
        if (!options.tolerant && relative.scheme) {
            target.scheme = relative.scheme;
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
                //target.authority = relative.authority;
                target.userinfo = relative.userinfo;
                target.host = relative.host;
                target.port = relative.port;
                target.path = removeDotSegments(relative.path || "");
                target.query = relative.query;
            } else {
                if (!relative.path) {
                    target.path = base.path;
                    if (relative.query !== undefined) target.query = relative.query;
                    else target.query = base.query;
                } else {
                    if (relative.path.charAt(0) === "/") target.path = removeDotSegments(relative.path);
                    else {
                        if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = "/" + relative.path;
                        else if (!base.path) target.path = relative.path;
                        else target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                        target.path = removeDotSegments(target.path);
                    }
                    target.query = relative.query;
                }
                //target.authority = base.authority;
                target.userinfo = base.userinfo;
                target.host = base.host;
                target.port = base.port;
            }
            target.scheme = base.scheme;
        }
        target.fragment = relative.fragment;
        return target;
    }
    function resolve(baseURI, relativeURI, options) {
        var schemelessOptions = assign({
            scheme: "null"
        }, options);
        return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
    }
    function normalize(uri, options) {
        if (typeof uri === "string") uri = serialize(parse(uri, options), options);
        else if (typeOf(uri) === "object") uri = parse(serialize(uri, options), options);
        return uri;
    }
    function equal(uriA, uriB, options) {
        if (typeof uriA === "string") uriA = serialize(parse(uriA, options), options);
        else if (typeOf(uriA) === "object") uriA = serialize(uriA, options);
        if (typeof uriB === "string") uriB = serialize(parse(uriB, options), options);
        else if (typeOf(uriB) === "object") uriB = serialize(uriB, options);
        return uriA === uriB;
    }
    function escapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
    }
    function unescapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
    }
    var handler = {
        scheme: "http",
        domainHost: true,
        parse: function parse(components, options) {
            //report missing host
            if (!components.host) components.error = components.error || "HTTP URIs must have a host.";
            return components;
        },
        serialize: function serialize(components, options) {
            var secure = String(components.scheme).toLowerCase() === "https";
            //normalize the default port
            if (components.port === (secure ? 443 : 80) || components.port === "") components.port = undefined;
            //normalize the empty path
            if (!components.path) components.path = "/";
            //NOTE: We do not parse query strings for HTTP URIs
            //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
            //and not the HTTP spec.
            return components;
        }
    };
    var handler$1 = {
        scheme: "https",
        domainHost: handler.domainHost,
        parse: handler.parse,
        serialize: handler.serialize
    };
    function isSecure(wsComponents) {
        return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
    }
    //RFC 6455
    var handler$2 = {
        scheme: "ws",
        domainHost: true,
        parse: function parse(components, options) {
            var wsComponents = components;
            //indicate if the secure flag is set
            wsComponents.secure = isSecure(wsComponents);
            //construct resouce name
            wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
            wsComponents.path = undefined;
            wsComponents.query = undefined;
            return wsComponents;
        },
        serialize: function serialize(wsComponents, options) {
            //normalize the default port
            if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") wsComponents.port = undefined;
            //ensure scheme matches secure flag
            if (typeof wsComponents.secure === "boolean") {
                wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
                wsComponents.secure = undefined;
            }
            //reconstruct path from resource name
            if (wsComponents.resourceName) {
                var _wsComponents$resourc = wsComponents.resourceName.split("?"), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
                wsComponents.path = path && path !== "/" ? path : undefined;
                wsComponents.query = query;
                wsComponents.resourceName = undefined;
            }
            //forbid fragment component
            wsComponents.fragment = undefined;
            return wsComponents;
        }
    };
    var handler$3 = {
        scheme: "wss",
        domainHost: handler$2.domainHost,
        parse: handler$2.parse,
        serialize: handler$2.serialize
    };
    var O = {};
    var isIRI = true;
    //RFC 3986
    var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
    var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
    var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
    //RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
    //const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
    //const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
    //const VCHAR$$ = "[\\x21-\\x7E]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
    //const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
    //const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
    //const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
    var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
    var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
    var VCHAR$$ = merge(QTEXT$$, '[\\"\\\\]');
    var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
    var UNRESERVED = new RegExp(UNRESERVED$$, "g");
    var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
    var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
    var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
    var NOT_HFVALUE = NOT_HFNAME;
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(UNRESERVED) ? str : decStr;
    }
    var handler$4 = {
        scheme: "mailto",
        parse: function parse$$1(components, options) {
            var mailtoComponents = components;
            var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
            mailtoComponents.path = undefined;
            if (mailtoComponents.query) {
                var unknownHeaders = false;
                var headers = {};
                var hfields = mailtoComponents.query.split("&");
                for(var x = 0, xl = hfields.length; x < xl; ++x){
                    var hfield = hfields[x].split("=");
                    switch(hfield[0]){
                        case "to":
                            var toAddrs = hfield[1].split(",");
                            for(var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x)to.push(toAddrs[_x]);
                            break;
                        case "subject":
                            mailtoComponents.subject = unescapeComponent(hfield[1], options);
                            break;
                        case "body":
                            mailtoComponents.body = unescapeComponent(hfield[1], options);
                            break;
                        default:
                            unknownHeaders = true;
                            headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                            break;
                    }
                }
                if (unknownHeaders) mailtoComponents.headers = headers;
            }
            mailtoComponents.query = undefined;
            for(var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2){
                var addr = to[_x2].split("@");
                addr[0] = unescapeComponent(addr[0]);
                if (!options.unicodeSupport) //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
                else addr[1] = unescapeComponent(addr[1], options).toLowerCase();
                to[_x2] = addr.join("@");
            }
            return mailtoComponents;
        },
        serialize: function serialize$$1(mailtoComponents, options) {
            var components = mailtoComponents;
            var to = toArray(mailtoComponents.to);
            if (to) {
                for(var x = 0, xl = to.length; x < xl; ++x){
                    var toAddr = String(to[x]);
                    var atIdx = toAddr.lastIndexOf("@");
                    var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                    var domain = toAddr.slice(atIdx + 1);
                    //convert IDN via punycode
                    try {
                        domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                    } catch (e) {
                        components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                    }
                    to[x] = localPart + "@" + domain;
                }
                components.path = to.join(",");
            }
            var headers = mailtoComponents.headers = mailtoComponents.headers || {};
            if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
            if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
            var fields = [];
            for(var name in headers)if (headers[name] !== O[name]) fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            if (fields.length) components.query = fields.join("&");
            return components;
        }
    };
    var URN_PARSE = /^([^\:]+)\:(.*)/;
    //RFC 2141
    var handler$5 = {
        scheme: "urn",
        parse: function parse$$1(components, options) {
            var matches = components.path && components.path.match(URN_PARSE);
            var urnComponents = components;
            if (matches) {
                var scheme = options.scheme || urnComponents.scheme || "urn";
                var nid = matches[1].toLowerCase();
                var nss = matches[2];
                var urnScheme = scheme + ":" + (options.nid || nid);
                var schemeHandler = SCHEMES[urnScheme];
                urnComponents.nid = nid;
                urnComponents.nss = nss;
                urnComponents.path = undefined;
                if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
            } else urnComponents.error = urnComponents.error || "URN can not be parsed.";
            return urnComponents;
        },
        serialize: function serialize$$1(urnComponents, options) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = urnComponents.nid;
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
            var uriComponents = urnComponents;
            var nss = urnComponents.nss;
            uriComponents.path = (nid || options.nid) + ":" + nss;
            return uriComponents;
        }
    };
    var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
    //RFC 4122
    var handler$6 = {
        scheme: "urn:uuid",
        parse: function parse(urnComponents, options) {
            var uuidComponents = urnComponents;
            uuidComponents.uuid = uuidComponents.nss;
            uuidComponents.nss = undefined;
            if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) uuidComponents.error = uuidComponents.error || "UUID is not valid.";
            return uuidComponents;
        },
        serialize: function serialize(uuidComponents, options) {
            var urnComponents = uuidComponents;
            //normalize UUID
            urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
            return urnComponents;
        }
    };
    SCHEMES[handler.scheme] = handler;
    SCHEMES[handler$1.scheme] = handler$1;
    SCHEMES[handler$2.scheme] = handler$2;
    SCHEMES[handler$3.scheme] = handler$3;
    SCHEMES[handler$4.scheme] = handler$4;
    SCHEMES[handler$5.scheme] = handler$5;
    SCHEMES[handler$6.scheme] = handler$6;
    exports1.SCHEMES = SCHEMES;
    exports1.pctEncChar = pctEncChar;
    exports1.pctDecChars = pctDecChars;
    exports1.parse = parse;
    exports1.removeDotSegments = removeDotSegments;
    exports1.serialize = serialize;
    exports1.resolveComponents = resolveComponents;
    exports1.resolve = resolve;
    exports1.normalize = normalize;
    exports1.equal = equal;
    exports1.escapeComponent = escapeComponent;
    exports1.unescapeComponent = unescapeComponent;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

},{}],"2Ynjz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const core_1 = require("82be42ec8d7157f1");
const validation_1 = require("cc2ce53aed8875dc");
const applicator_1 = require("577e40ebaf3a827f");
const format_1 = require("c0c18bcb9a1ae0aa");
const metadata_1 = require("aeecf34ae6128131");
const draft7Vocabularies = [
    core_1.default,
    validation_1.default,
    (0, applicator_1.default)(),
    format_1.default,
    metadata_1.metadataVocabulary,
    metadata_1.contentVocabulary
];
exports.default = draft7Vocabularies;

},{"82be42ec8d7157f1":"PPgXr","cc2ce53aed8875dc":"4hv5m","577e40ebaf3a827f":"6pPGW","c0c18bcb9a1ae0aa":"jN3RE","aeecf34ae6128131":"dVfzF"}],"PPgXr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const id_1 = require("4520fec7a881165e");
const ref_1 = require("4dca9df0743851d");
const core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    {
        keyword: "$comment"
    },
    "definitions",
    id_1.default,
    ref_1.default
];
exports.default = core;

},{"4520fec7a881165e":"iZoCF","4dca9df0743851d":"f8lMc"}],"iZoCF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const def = {
    keyword: "id",
    code () {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
};
exports.default = def;

},{}],"f8lMc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.callRef = exports.getValidate = void 0;
const ref_error_1 = require("8f71514fa79201e2");
const code_1 = require("1b8a04b4c06a79cd");
const codegen_1 = require("db023c7b20018a60");
const names_1 = require("63402100a762e61c");
const compile_1 = require("a9b1b3190fc949f5");
const util_1 = require("ba94d65897c2c00f");
const def = {
    keyword: "$ref",
    schemaType: "string",
    code (cxt) {
        const { gen, schema: $ref, it } = cxt;
        const { baseId, schemaEnv: env, validateName, opts, self } = it;
        const { root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId) return callRootRef();
        const schOrEnv = compile_1.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined) throw new ref_error_1.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof compile_1.SchemaEnv) return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root) return callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", {
                ref: root
            });
            return callRef(cxt, (0, codegen_1._)`${rootName}.validate`, root, root.$async);
        }
        function callValidate(sch) {
            const v = getValidate(cxt, sch);
            callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? {
                ref: sch,
                code: (0, codegen_1.stringify)(sch)
            } : {
                ref: sch
            });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: codegen_1.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    }
};
function getValidate(cxt, sch) {
    const { gen } = cxt;
    return sch.validate ? gen.scopeValue("validate", {
        ref: sch.validate
    }) : (0, codegen_1._)`${gen.scopeValue("wrapper", {
        ref: sch
    })}.validate`;
}
exports.getValidate = getValidate;
function callRef(cxt, v, sch, $async) {
    const { gen, it } = cxt;
    const { allErrors, schemaEnv: env, opts } = it;
    const passCxt = opts.passContext ? names_1.default.this : codegen_1.nil;
    if ($async) callAsyncRef();
    else callSyncRef();
    function callAsyncRef() {
        if (!env.$async) throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(()=>{
            gen.code((0, codegen_1._)`await ${(0, code_1.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors) gen.assign(valid, true);
        }, (e)=>{
            gen.if((0, codegen_1._)`!(${e} instanceof ${it.ValidationError})`, ()=>gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors) gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        cxt.result((0, code_1.callValidateCode)(cxt, v, passCxt), ()=>addEvaluatedFrom(v), ()=>addErrorsFrom(v));
    }
    function addErrorsFrom(source) {
        const errs = (0, codegen_1._)`${source}.errors`;
        gen.assign(names_1.default.vErrors, (0, codegen_1._)`${names_1.default.vErrors} === null ? ${errs} : ${names_1.default.vErrors}.concat(${errs})`); // TODO tagged
        gen.assign(names_1.default.errors, (0, codegen_1._)`${names_1.default.vErrors}.length`);
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated) return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) it.props = util_1.mergeEvaluated.props(gen, schEvaluated.props, it.props);
            } else {
                const props = gen.var("props", (0, codegen_1._)`${source}.evaluated.props`);
                it.props = util_1.mergeEvaluated.props(gen, props, it.props, codegen_1.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) it.items = util_1.mergeEvaluated.items(gen, schEvaluated.items, it.items);
            } else {
                const items = gen.var("items", (0, codegen_1._)`${source}.evaluated.items`);
                it.items = util_1.mergeEvaluated.items(gen, items, it.items, codegen_1.Name);
            }
        }
    }
}
exports.callRef = callRef;
exports.default = def;

},{"8f71514fa79201e2":"8Strz","1b8a04b4c06a79cd":"k0GaT","db023c7b20018a60":"5E3CJ","63402100a762e61c":"eZ3V6","a9b1b3190fc949f5":"82s90","ba94d65897c2c00f":"hqTFh"}],"4hv5m":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const limitNumber_1 = require("e79930f981e2a364");
const multipleOf_1 = require("be0f39f028edf7dc");
const limitLength_1 = require("61dc60dc2ba14401");
const pattern_1 = require("69222616ff1794f6");
const limitProperties_1 = require("8519a67240d2796c");
const required_1 = require("e263f38fd14c2b9b");
const limitItems_1 = require("e21029958ad3c333");
const uniqueItems_1 = require("d0365586fa25458b");
const const_1 = require("8e7e1dc62c0964f3");
const enum_1 = require("89b207411a0537ee");
const validation = [
    // number
    limitNumber_1.default,
    multipleOf_1.default,
    // string
    limitLength_1.default,
    pattern_1.default,
    // object
    limitProperties_1.default,
    required_1.default,
    // array
    limitItems_1.default,
    uniqueItems_1.default,
    // any
    {
        keyword: "type",
        schemaType: [
            "string",
            "array"
        ]
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    },
    const_1.default,
    enum_1.default
];
exports.default = validation;

},{"e79930f981e2a364":"iAqrm","be0f39f028edf7dc":"3SVsI","61dc60dc2ba14401":"eBJRT","69222616ff1794f6":"4nZAt","8519a67240d2796c":"6UGMl","e263f38fd14c2b9b":"b6X7e","e21029958ad3c333":"c9Cah","d0365586fa25458b":"dvI3Q","8e7e1dc62c0964f3":"brL9I","89b207411a0537ee":"6ddRu"}],"iAqrm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("3648731dfccfca27");
const ops = codegen_1.operators;
const KWDs = {
    maximum: {
        okStr: "<=",
        ok: ops.LTE,
        fail: ops.GT
    },
    minimum: {
        okStr: ">=",
        ok: ops.GTE,
        fail: ops.LT
    },
    exclusiveMaximum: {
        okStr: "<",
        ok: ops.LT,
        fail: ops.GTE
    },
    exclusiveMinimum: {
        okStr: ">",
        ok: ops.GT,
        fail: ops.LTE
    }
};
const error = {
    message: ({ keyword, schemaCode })=>(0, codegen_1.str)`must be ${KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword, schemaCode })=>(0, codegen_1._)`{comparison: ${KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
const def = {
    keyword: Object.keys(KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error,
    code (cxt) {
        const { keyword, data, schemaCode } = cxt;
        cxt.fail$data((0, codegen_1._)`${data} ${KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
    }
};
exports.default = def;

},{"3648731dfccfca27":"5E3CJ"}],"3SVsI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("f398ecd84b20a400");
const error = {
    message: ({ schemaCode })=>(0, codegen_1.str)`must be multiple of ${schemaCode}`,
    params: ({ schemaCode })=>(0, codegen_1._)`{multipleOf: ${schemaCode}}`
};
const def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error,
    code (cxt) {
        const { gen, data, schemaCode, it } = cxt;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        const prec = it.opts.multipleOfPrecision;
        const res = gen.let("res");
        const invalid = prec ? (0, codegen_1._)`Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}` : (0, codegen_1._)`${res} !== parseInt(${res})`;
        cxt.fail$data((0, codegen_1._)`(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
    }
};
exports.default = def;

},{"f398ecd84b20a400":"5E3CJ"}],"eBJRT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("4968f787adbf82e3");
const util_1 = require("78694b7562e4dec7");
const ucs2length_1 = require("b64e80003c676177");
const error = {
    message ({ keyword, schemaCode }) {
        const comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, codegen_1.str)`must NOT have ${comp} than ${schemaCode} characters`;
    },
    params: ({ schemaCode })=>(0, codegen_1._)`{limit: ${schemaCode}}`
};
const def = {
    keyword: [
        "maxLength",
        "minLength"
    ],
    type: "string",
    schemaType: "number",
    $data: true,
    error,
    code (cxt) {
        const { keyword, data, schemaCode, it } = cxt;
        const op = keyword === "maxLength" ? codegen_1.operators.GT : codegen_1.operators.LT;
        const len = it.opts.unicode === false ? (0, codegen_1._)`${data}.length` : (0, codegen_1._)`${(0, util_1.useFunc)(cxt.gen, ucs2length_1.default)}(${data})`;
        cxt.fail$data((0, codegen_1._)`${len} ${op} ${schemaCode}`);
    }
};
exports.default = def;

},{"4968f787adbf82e3":"5E3CJ","78694b7562e4dec7":"hqTFh","b64e80003c676177":"fruo7"}],"fruo7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00) pos++; // low surrogate
        }
    }
    return length;
}
exports.default = ucs2length;
ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';

},{}],"4nZAt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const code_1 = require("6423c5f9606c4253");
const codegen_1 = require("c67e4d0ce9d0e145");
const error = {
    message: ({ schemaCode })=>(0, codegen_1.str)`must match pattern "${schemaCode}"`,
    params: ({ schemaCode })=>(0, codegen_1._)`{pattern: ${schemaCode}}`
};
const def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error,
    code (cxt) {
        const { data, $data, schema, schemaCode, it } = cxt;
        // TODO regexp should be wrapped in try/catchs
        const u = it.opts.unicodeRegExp ? "u" : "";
        const regExp = $data ? (0, codegen_1._)`(new RegExp(${schemaCode}, ${u}))` : (0, code_1.usePattern)(cxt, schema);
        cxt.fail$data((0, codegen_1._)`!${regExp}.test(${data})`);
    }
};
exports.default = def;

},{"6423c5f9606c4253":"k0GaT","c67e4d0ce9d0e145":"5E3CJ"}],"6UGMl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("717f2905edcd1d4b");
const error = {
    message ({ keyword, schemaCode }) {
        const comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, codegen_1.str)`must NOT have ${comp} than ${schemaCode} properties`;
    },
    params: ({ schemaCode })=>(0, codegen_1._)`{limit: ${schemaCode}}`
};
const def = {
    keyword: [
        "maxProperties",
        "minProperties"
    ],
    type: "object",
    schemaType: "number",
    $data: true,
    error,
    code (cxt) {
        const { keyword, data, schemaCode } = cxt;
        const op = keyword === "maxProperties" ? codegen_1.operators.GT : codegen_1.operators.LT;
        cxt.fail$data((0, codegen_1._)`Object.keys(${data}).length ${op} ${schemaCode}`);
    }
};
exports.default = def;

},{"717f2905edcd1d4b":"5E3CJ"}],"b6X7e":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const code_1 = require("8116de00ceb2e17c");
const codegen_1 = require("8c79527b91c9aa24");
const util_1 = require("4644f2feebf1f3d7");
const error = {
    message: ({ params: { missingProperty } })=>(0, codegen_1.str)`must have required property '${missingProperty}'`,
    params: ({ params: { missingProperty } })=>(0, codegen_1._)`{missingProperty: ${missingProperty}}`
};
const def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error,
    code (cxt) {
        const { gen, schema, schemaCode, data, $data, it } = cxt;
        const { opts } = it;
        if (!$data && schema.length === 0) return;
        const useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors) allErrorsMode();
        else exitOnErrorMode();
        if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties } = cxt.it;
            for (const requiredKey of schema)if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                (0, util_1.checkStrictMode)(it, msg, it.opts.strictRequired);
            }
        }
        function allErrorsMode() {
            if (useLoop || $data) cxt.block$data(codegen_1.nil, loopAllRequired);
            else for (const prop of schema)(0, code_1.checkReportMissingProp)(cxt, prop);
        }
        function exitOnErrorMode() {
            const missing = gen.let("missing");
            if (useLoop || $data) {
                const valid = gen.let("valid", true);
                cxt.block$data(valid, ()=>loopUntilMissing(missing, valid));
                cxt.ok(valid);
            } else {
                gen.if((0, code_1.checkMissingProp)(cxt, schema, missing));
                (0, code_1.reportMissingProp)(cxt, missing);
                gen.else();
            }
        }
        function loopAllRequired() {
            gen.forOf("prop", schemaCode, (prop)=>{
                cxt.setParams({
                    missingProperty: prop
                });
                gen.if((0, code_1.noPropertyInData)(gen, data, prop, opts.ownProperties), ()=>cxt.error());
            });
        }
        function loopUntilMissing(missing, valid) {
            cxt.setParams({
                missingProperty: missing
            });
            gen.forOf(missing, schemaCode, ()=>{
                gen.assign(valid, (0, code_1.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, codegen_1.not)(valid), ()=>{
                    cxt.error();
                    gen.break();
                });
            }, codegen_1.nil);
        }
    }
};
exports.default = def;

},{"8116de00ceb2e17c":"k0GaT","8c79527b91c9aa24":"5E3CJ","4644f2feebf1f3d7":"hqTFh"}],"c9Cah":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("8bf6dd0bbe5ea2bf");
const error = {
    message ({ keyword, schemaCode }) {
        const comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, codegen_1.str)`must NOT have ${comp} than ${schemaCode} items`;
    },
    params: ({ schemaCode })=>(0, codegen_1._)`{limit: ${schemaCode}}`
};
const def = {
    keyword: [
        "maxItems",
        "minItems"
    ],
    type: "array",
    schemaType: "number",
    $data: true,
    error,
    code (cxt) {
        const { keyword, data, schemaCode } = cxt;
        const op = keyword === "maxItems" ? codegen_1.operators.GT : codegen_1.operators.LT;
        cxt.fail$data((0, codegen_1._)`${data}.length ${op} ${schemaCode}`);
    }
};
exports.default = def;

},{"8bf6dd0bbe5ea2bf":"5E3CJ"}],"dvI3Q":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const dataType_1 = require("ed18d6a195747bcd");
const codegen_1 = require("59db147f18482486");
const util_1 = require("498e1140d56af1ce");
const equal_1 = require("4ac1230a4bed5e97");
const error = {
    message: ({ params: { i, j } })=>(0, codegen_1.str)`must NOT have duplicate items (items ## ${j} and ${i} are identical)`,
    params: ({ params: { i, j } })=>(0, codegen_1._)`{i: ${i}, j: ${j}}`
};
const def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error,
    code (cxt) {
        const { gen, data, $data, schema, parentSchema, schemaCode, it } = cxt;
        if (!$data && !schema) return;
        const valid = gen.let("valid");
        const itemTypes = parentSchema.items ? (0, dataType_1.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, codegen_1._)`${schemaCode} === false`);
        cxt.ok(valid);
        function validateUniqueItems() {
            const i = gen.let("i", (0, codegen_1._)`${data}.length`);
            const j = gen.let("j");
            cxt.setParams({
                i,
                j
            });
            gen.assign(valid, true);
            gen.if((0, codegen_1._)`${i} > 1`, ()=>(canOptimize() ? loopN : loopN2)(i, j));
        }
        function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t)=>t === "object" || t === "array");
        }
        function loopN(i, j) {
            const item = gen.name("item");
            const wrongType = (0, dataType_1.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, dataType_1.DataType.Wrong);
            const indices = gen.const("indices", (0, codegen_1._)`{}`);
            gen.for((0, codegen_1._)`;${i}--;`, ()=>{
                gen.let(item, (0, codegen_1._)`${data}[${i}]`);
                gen.if(wrongType, (0, codegen_1._)`continue`);
                if (itemTypes.length > 1) gen.if((0, codegen_1._)`typeof ${item} == "string"`, (0, codegen_1._)`${item} += "_"`);
                gen.if((0, codegen_1._)`typeof ${indices}[${item}] == "number"`, ()=>{
                    gen.assign(j, (0, codegen_1._)`${indices}[${item}]`);
                    cxt.error();
                    gen.assign(valid, false).break();
                }).code((0, codegen_1._)`${indices}[${item}] = ${i}`);
            });
        }
        function loopN2(i, j) {
            const eql = (0, util_1.useFunc)(gen, equal_1.default);
            const outer = gen.name("outer");
            gen.label(outer).for((0, codegen_1._)`;${i}--;`, ()=>gen.for((0, codegen_1._)`${j} = ${i}; ${j}--;`, ()=>gen.if((0, codegen_1._)`${eql}(${data}[${i}], ${data}[${j}])`, ()=>{
                        cxt.error();
                        gen.assign(valid, false).break(outer);
                    })));
        }
    }
};
exports.default = def;

},{"ed18d6a195747bcd":"2BpoV","59db147f18482486":"5E3CJ","498e1140d56af1ce":"hqTFh","4ac1230a4bed5e97":"MpTPM"}],"MpTPM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
// https://github.com/ajv-validator/ajv/issues/889
const equal = require("d2bcd64c511fbbef");
equal.code = 'require("ajv/dist/runtime/equal").default';
exports.default = equal;

},{"d2bcd64c511fbbef":"blc55"}],"brL9I":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("8fa4a24917fa8620");
const util_1 = require("c4ea43af4f833fd0");
const equal_1 = require("4c12131dd960a69d");
const error = {
    message: "must be equal to constant",
    params: ({ schemaCode })=>(0, codegen_1._)`{allowedValue: ${schemaCode}}`
};
const def = {
    keyword: "const",
    $data: true,
    error,
    code (cxt) {
        const { gen, data, $data, schemaCode, schema } = cxt;
        if ($data || schema && typeof schema == "object") cxt.fail$data((0, codegen_1._)`!${(0, util_1.useFunc)(gen, equal_1.default)}(${data}, ${schemaCode})`);
        else cxt.fail((0, codegen_1._)`${schema} !== ${data}`);
    }
};
exports.default = def;

},{"8fa4a24917fa8620":"5E3CJ","c4ea43af4f833fd0":"hqTFh","4c12131dd960a69d":"MpTPM"}],"6ddRu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("8ec7518cb324f27e");
const util_1 = require("39b1cf68009dfa22");
const equal_1 = require("10c2bc8aede4ad0d");
const error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode })=>(0, codegen_1._)`{allowedValues: ${schemaCode}}`
};
const def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error,
    code (cxt) {
        const { gen, data, $data, schema, schemaCode, it } = cxt;
        if (!$data && schema.length === 0) throw new Error("enum must have non-empty array");
        const useLoop = schema.length >= it.opts.loopEnum;
        let eql;
        const getEql = ()=>eql !== null && eql !== void 0 ? eql : eql = (0, util_1.useFunc)(gen, equal_1.default);
        let valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        } else {
            /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
            const vSchema = gen.const("vSchema", schemaCode);
            valid = (0, codegen_1.or)(...schema.map((_x, i)=>equalCode(vSchema, i)));
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, (v)=>gen.if((0, codegen_1._)`${getEql()}(${data}, ${v})`, ()=>gen.assign(valid, true).break()));
        }
        function equalCode(vSchema, i) {
            const sch = schema[i];
            return typeof sch === "object" && sch !== null ? (0, codegen_1._)`${getEql()}(${data}, ${vSchema}[${i}])` : (0, codegen_1._)`${data} === ${sch}`;
        }
    }
};
exports.default = def;

},{"8ec7518cb324f27e":"5E3CJ","39b1cf68009dfa22":"hqTFh","10c2bc8aede4ad0d":"MpTPM"}],"6pPGW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const additionalItems_1 = require("852ecdb59a1c7f37");
const prefixItems_1 = require("df3c3ff1822476c2");
const items_1 = require("f9f856923d6846d7");
const items2020_1 = require("41bc048b170c0123");
const contains_1 = require("4858cbd3be266c5b");
const dependencies_1 = require("e0d2483cbd78911");
const propertyNames_1 = require("5699fcf3532a8e6");
const additionalProperties_1 = require("7d87cea7a44d8ef7");
const properties_1 = require("ce6cdda651f72186");
const patternProperties_1 = require("ead3f0c5b555155e");
const not_1 = require("94b5a3265efdbfcb");
const anyOf_1 = require("563f9088d71dbdc9");
const oneOf_1 = require("c21d69c42fd736c4");
const allOf_1 = require("2ff5e3cd187ba6ce");
const if_1 = require("24b31258da87b1d9");
const thenElse_1 = require("f656ec3d192aed31");
function getApplicator(draft2020 = false) {
    const applicator = [
        // any
        not_1.default,
        anyOf_1.default,
        oneOf_1.default,
        allOf_1.default,
        if_1.default,
        thenElse_1.default,
        // object
        propertyNames_1.default,
        additionalProperties_1.default,
        dependencies_1.default,
        properties_1.default,
        patternProperties_1.default
    ];
    // array
    if (draft2020) applicator.push(prefixItems_1.default, items2020_1.default);
    else applicator.push(additionalItems_1.default, items_1.default);
    applicator.push(contains_1.default);
    return applicator;
}
exports.default = getApplicator;

},{"852ecdb59a1c7f37":"1ivc6","df3c3ff1822476c2":"dCT0W","f9f856923d6846d7":"bfutL","41bc048b170c0123":"3lfX3","4858cbd3be266c5b":"tYn2t","e0d2483cbd78911":"gokzc","5699fcf3532a8e6":"7FF9V","7d87cea7a44d8ef7":"0Odrb","ce6cdda651f72186":"lMxai","ead3f0c5b555155e":"iisTg","94b5a3265efdbfcb":"6bFct","563f9088d71dbdc9":"8jTtb","c21d69c42fd736c4":"84q8J","2ff5e3cd187ba6ce":"fHr3P","24b31258da87b1d9":"4V2UV","f656ec3d192aed31":"aV8T6"}],"1ivc6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateAdditionalItems = void 0;
const codegen_1 = require("eb920d79977d5a0c");
const util_1 = require("1dd12bfced7c65d9");
const error = {
    message: ({ params: { len } })=>(0, codegen_1.str)`must NOT have more than ${len} items`,
    params: ({ params: { len } })=>(0, codegen_1._)`{limit: ${len}}`
};
const def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    before: "uniqueItems",
    error,
    code (cxt) {
        const { parentSchema, it } = cxt;
        const { items } = parentSchema;
        if (!Array.isArray(items)) {
            (0, util_1.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        validateAdditionalItems(cxt, items);
    }
};
function validateAdditionalItems(cxt, items) {
    const { gen, schema, data, keyword, it } = cxt;
    it.items = true;
    const len = gen.const("len", (0, codegen_1._)`${data}.length`);
    if (schema === false) {
        cxt.setParams({
            len: items.length
        });
        cxt.pass((0, codegen_1._)`${len} <= ${items.length}`);
    } else if (typeof schema == "object" && !(0, util_1.alwaysValidSchema)(it, schema)) {
        const valid = gen.var("valid", (0, codegen_1._)`${len} <= ${items.length}`); // TODO var
        gen.if((0, codegen_1.not)(valid), ()=>validateItems(valid));
        cxt.ok(valid);
    }
    function validateItems(valid) {
        gen.forRange("i", items.length, len, (i)=>{
            cxt.subschema({
                keyword,
                dataProp: i,
                dataPropType: util_1.Type.Num
            }, valid);
            if (!it.allErrors) gen.if((0, codegen_1.not)(valid), ()=>gen.break());
        });
    }
}
exports.validateAdditionalItems = validateAdditionalItems;
exports.default = def;

},{"eb920d79977d5a0c":"5E3CJ","1dd12bfced7c65d9":"hqTFh"}],"dCT0W":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const items_1 = require("6693fcd262f960ad");
const def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: [
        "array"
    ],
    before: "uniqueItems",
    code: (cxt)=>(0, items_1.validateTuple)(cxt, "items")
};
exports.default = def;

},{"6693fcd262f960ad":"bfutL"}],"bfutL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateTuple = void 0;
const codegen_1 = require("4c4c4ade5ab2262f");
const util_1 = require("892bb718945120f3");
const code_1 = require("31b7fa79ab304a2f");
const def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "array",
        "boolean"
    ],
    before: "uniqueItems",
    code (cxt) {
        const { schema, it } = cxt;
        if (Array.isArray(schema)) return validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, util_1.alwaysValidSchema)(it, schema)) return;
        cxt.ok((0, code_1.validateArray)(cxt));
    }
};
function validateTuple(cxt, extraItems, schArr = cxt.schema) {
    const { gen, parentSchema, data, keyword, it } = cxt;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) it.items = util_1.mergeEvaluated.items(gen, schArr.length, it.items);
    const valid = gen.name("valid");
    const len = gen.const("len", (0, codegen_1._)`${data}.length`);
    schArr.forEach((sch, i)=>{
        if ((0, util_1.alwaysValidSchema)(it, sch)) return;
        gen.if((0, codegen_1._)`${len} > ${i}`, ()=>cxt.subschema({
                keyword,
                schemaProp: i,
                dataProp: i
            }, valid));
        cxt.ok(valid);
    });
    function checkStrictTuple(sch) {
        const { opts, errSchemaPath } = it;
        const l = schArr.length;
        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, util_1.checkStrictMode)(it, msg, opts.strictTuples);
        }
    }
}
exports.validateTuple = validateTuple;
exports.default = def;

},{"4c4c4ade5ab2262f":"5E3CJ","892bb718945120f3":"hqTFh","31b7fa79ab304a2f":"k0GaT"}],"3lfX3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("5557b85368f11dc8");
const util_1 = require("251bc8960022628");
const code_1 = require("19c76f7b8b158257");
const additionalItems_1 = require("8a1f5b42b3c3a3e8");
const error = {
    message: ({ params: { len } })=>(0, codegen_1.str)`must NOT have more than ${len} items`,
    params: ({ params: { len } })=>(0, codegen_1._)`{limit: ${len}}`
};
const def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    error,
    code (cxt) {
        const { schema, parentSchema, it } = cxt;
        const { prefixItems } = parentSchema;
        it.items = true;
        if ((0, util_1.alwaysValidSchema)(it, schema)) return;
        if (prefixItems) (0, additionalItems_1.validateAdditionalItems)(cxt, prefixItems);
        else cxt.ok((0, code_1.validateArray)(cxt));
    }
};
exports.default = def;

},{"5557b85368f11dc8":"5E3CJ","251bc8960022628":"hqTFh","19c76f7b8b158257":"k0GaT","8a1f5b42b3c3a3e8":"1ivc6"}],"tYn2t":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("2321a147ffbf5137");
const util_1 = require("fe1a6ecfd865147e");
const error = {
    message: ({ params: { min, max } })=>max === undefined ? (0, codegen_1.str)`must contain at least ${min} valid item(s)` : (0, codegen_1.str)`must contain at least ${min} and no more than ${max} valid item(s)`,
    params: ({ params: { min, max } })=>max === undefined ? (0, codegen_1._)`{minContains: ${min}}` : (0, codegen_1._)`{minContains: ${min}, maxContains: ${max}}`
};
const def = {
    keyword: "contains",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    trackErrors: true,
    error,
    code (cxt) {
        const { gen, schema, parentSchema, data, it } = cxt;
        let min;
        let max;
        const { minContains, maxContains } = parentSchema;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        } else min = 1;
        const len = gen.const("len", (0, codegen_1._)`${data}.length`);
        cxt.setParams({
            min,
            max
        });
        if (max === undefined && min === 0) {
            (0, util_1.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
        }
        if (max !== undefined && min > max) {
            (0, util_1.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
        }
        if ((0, util_1.alwaysValidSchema)(it, schema)) {
            let cond = (0, codegen_1._)`${len} >= ${min}`;
            if (max !== undefined) cond = (0, codegen_1._)`${cond} && ${len} <= ${max}`;
            cxt.pass(cond);
            return;
        }
        it.items = true;
        const valid = gen.name("valid");
        if (max === undefined && min === 1) validateItems(valid, ()=>gen.if(valid, ()=>gen.break()));
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined) gen.if((0, codegen_1._)`${data}.length > 0`, validateItemsWithCount);
        } else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, ()=>cxt.reset());
        function validateItemsWithCount() {
            const schValid = gen.name("_valid");
            const count = gen.let("count", 0);
            validateItems(schValid, ()=>gen.if(schValid, ()=>checkLimits(count)));
        }
        function validateItems(_valid, block) {
            gen.forRange("i", 0, len, (i)=>{
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: util_1.Type.Num,
                    compositeRule: true
                }, _valid);
                block();
            });
        }
        function checkLimits(count) {
            gen.code((0, codegen_1._)`${count}++`);
            if (max === undefined) gen.if((0, codegen_1._)`${count} >= ${min}`, ()=>gen.assign(valid, true).break());
            else {
                gen.if((0, codegen_1._)`${count} > ${max}`, ()=>gen.assign(valid, false).break());
                if (min === 1) gen.assign(valid, true);
                else gen.if((0, codegen_1._)`${count} >= ${min}`, ()=>gen.assign(valid, true));
            }
        }
    }
};
exports.default = def;

},{"2321a147ffbf5137":"5E3CJ","fe1a6ecfd865147e":"hqTFh"}],"gokzc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateSchemaDeps = exports.validatePropertyDeps = exports.error = void 0;
const codegen_1 = require("2c9520ddb7668753");
const util_1 = require("8cb82fc3be8f4c85");
const code_1 = require("294e23f220ec6a41");
exports.error = {
    message: ({ params: { property, depsCount, deps } })=>{
        const property_ies = depsCount === 1 ? "property" : "properties";
        return (0, codegen_1.str)`must have ${property_ies} ${deps} when property ${property} is present`;
    },
    params: ({ params: { property, depsCount, deps, missingProperty } })=>(0, codegen_1._)`{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`
};
const def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: exports.error,
    code (cxt) {
        const [propDeps, schDeps] = splitDependencies(cxt);
        validatePropertyDeps(cxt, propDeps);
        validateSchemaDeps(cxt, schDeps);
    }
};
function splitDependencies({ schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for(const key in schema){
        if (key === "__proto__") continue;
        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [
        propertyDeps,
        schemaDeps
    ];
}
function validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen, data, it } = cxt;
    if (Object.keys(propertyDeps).length === 0) return;
    const missing = gen.let("missing");
    for(const prop in propertyDeps){
        const deps = propertyDeps[prop];
        if (deps.length === 0) continue;
        const hasProperty = (0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", ")
        });
        if (it.allErrors) gen.if(hasProperty, ()=>{
            for (const depProp of deps)(0, code_1.checkReportMissingProp)(cxt, depProp);
        });
        else {
            gen.if((0, codegen_1._)`${hasProperty} && (${(0, code_1.checkMissingProp)(cxt, deps, missing)})`);
            (0, code_1.reportMissingProp)(cxt, missing);
            gen.else();
        }
    }
}
exports.validatePropertyDeps = validatePropertyDeps;
function validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen, data, keyword, it } = cxt;
    const valid = gen.name("valid");
    for(const prop in schemaDeps){
        if ((0, util_1.alwaysValidSchema)(it, schemaDeps[prop])) continue;
        gen.if((0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties), ()=>{
            const schCxt = cxt.subschema({
                keyword,
                schemaProp: prop
            }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, ()=>gen.var(valid, true) // TODO var
        );
        cxt.ok(valid);
    }
}
exports.validateSchemaDeps = validateSchemaDeps;
exports.default = def;

},{"2c9520ddb7668753":"5E3CJ","8cb82fc3be8f4c85":"hqTFh","294e23f220ec6a41":"k0GaT"}],"7FF9V":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("e22ae7089ab50628");
const util_1 = require("6845a7aec2d16d80");
const error = {
    message: "property name must be valid",
    params: ({ params })=>(0, codegen_1._)`{propertyName: ${params.propertyName}}`
};
const def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: [
        "object",
        "boolean"
    ],
    error,
    code (cxt) {
        const { gen, schema, data, it } = cxt;
        if ((0, util_1.alwaysValidSchema)(it, schema)) return;
        const valid = gen.name("valid");
        gen.forIn("key", data, (key)=>{
            cxt.setParams({
                propertyName: key
            });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: [
                    "string"
                ],
                propertyName: key,
                compositeRule: true
            }, valid);
            gen.if((0, codegen_1.not)(valid), ()=>{
                cxt.error(true);
                if (!it.allErrors) gen.break();
            });
        });
        cxt.ok(valid);
    }
};
exports.default = def;

},{"e22ae7089ab50628":"5E3CJ","6845a7aec2d16d80":"hqTFh"}],"0Odrb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const code_1 = require("8bf946811345dd52");
const codegen_1 = require("94acb9afd0a38d");
const names_1 = require("12d5afb68c79d933");
const util_1 = require("431cae49e29b7ef5");
const error = {
    message: "must NOT have additional properties",
    params: ({ params })=>(0, codegen_1._)`{additionalProperty: ${params.additionalProperty}}`
};
const def = {
    keyword: "additionalProperties",
    type: [
        "object"
    ],
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: true,
    trackErrors: true,
    error,
    code (cxt) {
        const { gen, schema, parentSchema, data, errsCount, it } = cxt;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        const { allErrors, opts } = it;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, util_1.alwaysValidSchema)(it, schema)) return;
        const props = (0, code_1.allSchemaProperties)(parentSchema.properties);
        const patProps = (0, code_1.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, codegen_1._)`${errsCount} === ${names_1.default.errors}`);
        function checkAdditionalProperties() {
            gen.forIn("key", data, (key)=>{
                if (!props.length && !patProps.length) additionalPropertyCode(key);
                else gen.if(isAdditional(key), ()=>additionalPropertyCode(key));
            });
        }
        function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                const propsSchema = (0, util_1.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, code_1.isOwnProperty)(gen, propsSchema, key);
            } else if (props.length) definedProp = (0, codegen_1.or)(...props.map((p)=>(0, codegen_1._)`${key} === ${p}`));
            else definedProp = codegen_1.nil;
            if (patProps.length) definedProp = (0, codegen_1.or)(definedProp, ...patProps.map((p)=>(0, codegen_1._)`${(0, code_1.usePattern)(cxt, p)}.test(${key})`));
            return (0, codegen_1.not)(definedProp);
        }
        function deleteAdditional(key) {
            gen.code((0, codegen_1._)`delete ${data}[${key}]`);
        }
        function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({
                    additionalProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, util_1.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, codegen_1.not)(valid), ()=>{
                        cxt.reset();
                        deleteAdditional(key);
                    });
                } else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors) gen.if((0, codegen_1.not)(valid), ()=>gen.break());
                }
            }
        }
        function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: util_1.Type.Str
            };
            if (errors === false) Object.assign(subschema, {
                compositeRule: true,
                createErrors: false,
                allErrors: false
            });
            cxt.subschema(subschema, valid);
        }
    }
};
exports.default = def;

},{"8bf946811345dd52":"k0GaT","94acb9afd0a38d":"5E3CJ","12d5afb68c79d933":"eZ3V6","431cae49e29b7ef5":"hqTFh"}],"lMxai":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const validate_1 = require("ab627bdec169a4e1");
const code_1 = require("275f1f775c313f6b");
const util_1 = require("e244aaf97f728bb4");
const additionalProperties_1 = require("feedf7db6cffec15");
const def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen, schema, parentSchema, data, it } = cxt;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) additionalProperties_1.default.code(new validate_1.KeywordCxt(it, additionalProperties_1.default, "additionalProperties"));
        const allProps = (0, code_1.allSchemaProperties)(schema);
        for (const prop of allProps)it.definedProperties.add(prop);
        if (it.opts.unevaluated && allProps.length && it.props !== true) it.props = util_1.mergeEvaluated.props(gen, (0, util_1.toHash)(allProps), it.props);
        const properties = allProps.filter((p)=>!(0, util_1.alwaysValidSchema)(it, schema[p]));
        if (properties.length === 0) return;
        const valid = gen.name("valid");
        for (const prop of properties){
            if (hasDefault(prop)) applyPropertySchema(prop);
            else {
                gen.if((0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties));
                applyPropertySchema(prop);
                if (!it.allErrors) gen.else().var(valid, true);
                gen.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
        }
        function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        }
        function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop
            }, valid);
        }
    }
};
exports.default = def;

},{"ab627bdec169a4e1":"2Fvud","275f1f775c313f6b":"k0GaT","e244aaf97f728bb4":"hqTFh","feedf7db6cffec15":"0Odrb"}],"iisTg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const code_1 = require("f8f8e6b0407fdd9d");
const codegen_1 = require("1b967c2cac1b0609");
const util_1 = require("7cbde610b4fe826");
const util_2 = require("7cbde610b4fe826");
const def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen, schema, data, parentSchema, it } = cxt;
        const { opts } = it;
        const patterns = (0, code_1.allSchemaProperties)(schema);
        const alwaysValidPatterns = patterns.filter((p)=>(0, util_1.alwaysValidSchema)(it, schema[p]));
        if (patterns.length === 0 || alwaysValidPatterns.length === patterns.length && (!it.opts.unevaluated || it.props === true)) return;
        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        const valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof codegen_1.Name)) it.props = (0, util_2.evaluatedPropsToName)(gen, it.props);
        const { props } = it;
        validatePatternProperties();
        function validatePatternProperties() {
            for (const pat of patterns){
                if (checkProperties) checkMatchingProperties(pat);
                if (it.allErrors) validateProperties(pat);
                else {
                    gen.var(valid, true); // TODO var
                    validateProperties(pat);
                    gen.if(valid);
                }
            }
        }
        function checkMatchingProperties(pat) {
            for(const prop in checkProperties)if (new RegExp(pat).test(prop)) (0, util_1.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
        }
        function validateProperties(pat) {
            gen.forIn("key", data, (key)=>{
                gen.if((0, codegen_1._)`${(0, code_1.usePattern)(cxt, pat)}.test(${key})`, ()=>{
                    const alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) cxt.subschema({
                        keyword: "patternProperties",
                        schemaProp: pat,
                        dataProp: key,
                        dataPropType: util_2.Type.Str
                    }, valid);
                    if (it.opts.unevaluated && props !== true) gen.assign((0, codegen_1._)`${props}[${key}]`, true);
                    else if (!alwaysValid && !it.allErrors) // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                    // or if all properties were evaluated (props === true)
                    gen.if((0, codegen_1.not)(valid), ()=>gen.break());
                });
            });
        }
    }
};
exports.default = def;

},{"f8f8e6b0407fdd9d":"k0GaT","1b967c2cac1b0609":"5E3CJ","7cbde610b4fe826":"hqTFh"}],"6bFct":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const util_1 = require("321d2980c88a2039");
const def = {
    keyword: "not",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    code (cxt) {
        const { gen, schema, it } = cxt;
        if ((0, util_1.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false
        }, valid);
        cxt.failResult(valid, ()=>cxt.reset(), ()=>cxt.error());
    },
    error: {
        message: "must NOT be valid"
    }
};
exports.default = def;

},{"321d2980c88a2039":"hqTFh"}],"8jTtb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const code_1 = require("5ca71c3dd49a479d");
const def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: code_1.validateUnion,
    error: {
        message: "must match a schema in anyOf"
    }
};
exports.default = def;

},{"5ca71c3dd49a479d":"k0GaT"}],"84q8J":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("a652e853645ba701");
const util_1 = require("29f5768d6c5f5eed");
const error = {
    message: "must match exactly one schema in oneOf",
    params: ({ params })=>(0, codegen_1._)`{passingSchemas: ${params.passing}}`
};
const def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error,
    code (cxt) {
        const { gen, schema, parentSchema, it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator) return;
        const schArr = schema;
        const valid = gen.let("valid", false);
        const passing = gen.let("passing", null);
        const schValid = gen.name("_valid");
        cxt.setParams({
            passing
        });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
        function validateOneOf() {
            schArr.forEach((sch, i)=>{
                let schCxt;
                if ((0, util_1.alwaysValidSchema)(it, sch)) gen.var(schValid, true);
                else schCxt = cxt.subschema({
                    keyword: "oneOf",
                    schemaProp: i,
                    compositeRule: true
                }, schValid);
                if (i > 0) gen.if((0, codegen_1._)`${schValid} && ${valid}`).assign(valid, false).assign(passing, (0, codegen_1._)`[${passing}, ${i}]`).else();
                gen.if(schValid, ()=>{
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt) cxt.mergeEvaluated(schCxt, codegen_1.Name);
                });
            });
        }
    }
};
exports.default = def;

},{"a652e853645ba701":"5E3CJ","29f5768d6c5f5eed":"hqTFh"}],"fHr3P":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const util_1 = require("4e4e6d6b236c3461");
const def = {
    keyword: "allOf",
    schemaType: "array",
    code (cxt) {
        const { gen, schema, it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        const valid = gen.name("valid");
        schema.forEach((sch, i)=>{
            if ((0, util_1.alwaysValidSchema)(it, sch)) return;
            const schCxt = cxt.subschema({
                keyword: "allOf",
                schemaProp: i
            }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    }
};
exports.default = def;

},{"4e4e6d6b236c3461":"hqTFh"}],"4V2UV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("1f1df645617c98a4");
const util_1 = require("389e0a8c918cc15");
const error = {
    message: ({ params })=>(0, codegen_1.str)`must match "${params.ifClause}" schema`,
    params: ({ params })=>(0, codegen_1._)`{failingKeyword: ${params.ifClause}}`
};
const def = {
    keyword: "if",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    error,
    code (cxt) {
        const { gen, parentSchema, it } = cxt;
        if (parentSchema.then === undefined && parentSchema.else === undefined) (0, util_1.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        const hasThen = hasSchema(it, "then");
        const hasElse = hasSchema(it, "else");
        if (!hasThen && !hasElse) return;
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            const ifClause = gen.let("ifClause");
            cxt.setParams({
                ifClause
            });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        } else if (hasThen) gen.if(schValid, validateClause("then"));
        else gen.if((0, codegen_1.not)(schValid), validateClause("else"));
        cxt.pass(valid, ()=>cxt.error(true));
        function validateIf() {
            const schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        }
        function validateClause(keyword, ifClause) {
            return ()=>{
                const schCxt = cxt.subschema({
                    keyword
                }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause) gen.assign(ifClause, (0, codegen_1._)`${keyword}`);
                else cxt.setParams({
                    ifClause: keyword
                });
            };
        }
    }
};
function hasSchema(it, keyword) {
    const schema = it.schema[keyword];
    return schema !== undefined && !(0, util_1.alwaysValidSchema)(it, schema);
}
exports.default = def;

},{"1f1df645617c98a4":"5E3CJ","389e0a8c918cc15":"hqTFh"}],"aV8T6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const util_1 = require("52fed7dcddf6df58");
const def = {
    keyword: [
        "then",
        "else"
    ],
    schemaType: [
        "object",
        "boolean"
    ],
    code ({ keyword, parentSchema, it }) {
        if (parentSchema.if === undefined) (0, util_1.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
    }
};
exports.default = def;

},{"52fed7dcddf6df58":"hqTFh"}],"jN3RE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const format_1 = require("2deff6405afcac83");
const format = [
    format_1.default
];
exports.default = format;

},{"2deff6405afcac83":"jtWkZ"}],"jtWkZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("a382a355cf5a78c5");
const error = {
    message: ({ schemaCode })=>(0, codegen_1.str)`must match format "${schemaCode}"`,
    params: ({ schemaCode })=>(0, codegen_1._)`{format: ${schemaCode}}`
};
const def = {
    keyword: "format",
    type: [
        "number",
        "string"
    ],
    schemaType: "string",
    $data: true,
    error,
    code (cxt, ruleType) {
        const { gen, data, $data, schema, schemaCode, it } = cxt;
        const { opts, errSchemaPath, schemaEnv, self } = it;
        if (!opts.validateFormats) return;
        if ($data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fDef = gen.const("fDef", (0, codegen_1._)`${fmts}[${schemaCode}]`);
            const fType = gen.let("fType");
            const format = gen.let("format");
            // TODO simplify
            gen.if((0, codegen_1._)`typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, ()=>gen.assign(fType, (0, codegen_1._)`${fDef}.type || "string"`).assign(format, (0, codegen_1._)`${fDef}.validate`), ()=>gen.assign(fType, (0, codegen_1._)`"string"`).assign(format, fDef));
            cxt.fail$data((0, codegen_1.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false) return codegen_1.nil;
                return (0, codegen_1._)`${schemaCode} && !${format}`;
            }
            function invalidFmt() {
                const callFormat = schemaEnv.$async ? (0, codegen_1._)`(${fDef}.async ? await ${format}(${data}) : ${format}(${data}))` : (0, codegen_1._)`${format}(${data})`;
                const validData = (0, codegen_1._)`(typeof ${format} == "function" ? ${callFormat} : ${format}.test(${data}))`;
                return (0, codegen_1._)`${format} && ${format} !== true && ${fType} === ${ruleType} && !${validData}`;
            }
        }
        function validateFormat() {
            const formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true) return;
            const [fmtType, format, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType) cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
                }
            }
            function getFormat(fmtDef) {
                const code = fmtDef instanceof RegExp ? (0, codegen_1.regexpCode)(fmtDef) : opts.code.formats ? (0, codegen_1._)`${opts.code.formats}${(0, codegen_1.getProperty)(schema)}` : undefined;
                const fmt = gen.scopeValue("formats", {
                    key: schema,
                    ref: fmtDef,
                    code
                });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) return [
                    fmtDef.type || "string",
                    fmtDef.validate,
                    (0, codegen_1._)`${fmt}.validate`
                ];
                return [
                    "string",
                    fmtDef,
                    fmt
                ];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async) throw new Error("async format in sync schema");
                    return (0, codegen_1._)`await ${fmtRef}(${data})`;
                }
                return typeof format == "function" ? (0, codegen_1._)`${fmtRef}(${data})` : (0, codegen_1._)`${fmtRef}.test(${data})`;
            }
        }
    }
};
exports.default = def;

},{"a382a355cf5a78c5":"5E3CJ"}],"dVfzF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contentVocabulary = exports.metadataVocabulary = void 0;
exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
];
exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
];

},{}],"i1vpu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("8118642cff1383ec");
const types_1 = require("ed348f6ae981731b");
const compile_1 = require("19cbb21371b9e8ba");
const ref_error_1 = require("19e9c6e270af4b01");
const util_1 = require("bbc8b0a18b75a1fa");
const error = {
    message: ({ params: { discrError, tagName } })=>discrError === types_1.DiscrError.Tag ? `tag "${tagName}" must be string` : `value of tag "${tagName}" must be in oneOf`,
    params: ({ params: { discrError, tag, tagName } })=>(0, codegen_1._)`{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`
};
const def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error,
    code (cxt) {
        const { gen, data, schema, parentSchema, it } = cxt;
        const { oneOf } = parentSchema;
        if (!it.opts.discriminator) throw new Error("discriminator: requires discriminator option");
        const tagName = schema.propertyName;
        if (typeof tagName != "string") throw new Error("discriminator: requires propertyName");
        if (schema.mapping) throw new Error("discriminator: mapping is not supported");
        if (!oneOf) throw new Error("discriminator: requires oneOf keyword");
        const valid = gen.let("valid", false);
        const tag = gen.const("tag", (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(tagName)}`);
        gen.if((0, codegen_1._)`typeof ${tag} == "string"`, ()=>validateMapping(), ()=>cxt.error(false, {
                discrError: types_1.DiscrError.Tag,
                tag,
                tagName
            }));
        cxt.ok(valid);
        function validateMapping() {
            const mapping = getMapping();
            gen.if(false);
            for(const tagValue in mapping){
                gen.elseIf((0, codegen_1._)`${tag} === ${tagValue}`);
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, {
                discrError: types_1.DiscrError.Mapping,
                tag,
                tagName
            });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            const schCxt = cxt.subschema({
                keyword: "oneOf",
                schemaProp
            }, _valid);
            cxt.mergeEvaluated(schCxt, codegen_1.Name);
            return _valid;
        }
        function getMapping() {
            var _a;
            const oneOfMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for(let i = 0; i < oneOf.length; i++){
                let sch = oneOf[i];
                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, util_1.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    const ref = sch.$ref;
                    sch = compile_1.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, ref);
                    if (sch instanceof compile_1.SchemaEnv) sch = sch.schema;
                    if (sch === undefined) throw new ref_error_1.default(it.opts.uriResolver, it.baseId, ref);
                }
                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired) throw new Error(`discriminator: "${tagName}" must be required`);
            return oneOfMapping;
            function hasRequired({ required }) {
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                if (sch.const) addMapping(sch.const, i);
                else if (sch.enum) for (const tagValue of sch.enum)addMapping(tagValue, i);
                else throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in oneOfMapping) throw new Error(`discriminator: "${tagName}" values must be unique strings`);
                oneOfMapping[tagValue] = i;
            }
        }
    }
};
exports.default = def;

},{"8118642cff1383ec":"5E3CJ","ed348f6ae981731b":"led3d","19cbb21371b9e8ba":"82s90","19e9c6e270af4b01":"8Strz","bbc8b0a18b75a1fa":"hqTFh"}],"led3d":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DiscrError = void 0;
var DiscrError;
(function(DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})(DiscrError || (exports.DiscrError = DiscrError = {}));

},{}],"1i0St":[function(require,module,exports) {
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');

},{}],"5gilL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const formats_1 = require("8e45a5020f87f10");
const limit_1 = require("986e4a17998057f7");
const codegen_1 = require("6f742ec7ce55ffb3");
const fullName = new codegen_1.Name("fullFormats");
const fastName = new codegen_1.Name("fastFormats");
const formatsPlugin = (ajv, opts = {
    keywords: true
})=>{
    if (Array.isArray(opts)) {
        addFormats(ajv, opts, formats_1.fullFormats, fullName);
        return ajv;
    }
    const [formats, exportName] = opts.mode === "fast" ? [
        formats_1.fastFormats,
        fastName
    ] : [
        formats_1.fullFormats,
        fullName
    ];
    const list = opts.formats || formats_1.formatNames;
    addFormats(ajv, list, formats, exportName);
    if (opts.keywords) limit_1.default(ajv);
    return ajv;
};
formatsPlugin.get = (name, mode = "full")=>{
    const formats = mode === "fast" ? formats_1.fastFormats : formats_1.fullFormats;
    const f = formats[name];
    if (!f) throw new Error(`Unknown format "${name}"`);
    return f;
};
function addFormats(ajv, list, fs, exportName) {
    var _a;
    var _b;
    (_a = (_b = ajv.opts.code).formats) !== null && _a !== void 0 ? _a : _b.formats = codegen_1._`require("ajv-formats/dist/formats").${exportName}`;
    for (const f of list)ajv.addFormat(f, fs[f]);
}
module.exports = exports = formatsPlugin;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatsPlugin;

},{"8e45a5020f87f10":"kOwhN","986e4a17998057f7":"1W3fo","6f742ec7ce55ffb3":"5E3CJ"}],"kOwhN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatNames = exports.fastFormats = exports.fullFormats = void 0;
function fmtDef(validate, compare) {
    return {
        validate,
        compare
    };
}
exports.fullFormats = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: fmtDef(date, compareDate),
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: fmtDef(time, compareTime),
    "date-time": fmtDef(date_time, compareDateTime),
    // duration: https://tools.ietf.org/html/rfc3339#appendix-A
    duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
    uri,
    "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
    // uri-template: https://tools.ietf.org/html/rfc6570
    "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
    // For the source: https://gist.github.com/dperini/729294
    // For test cases: https://mathiasbynens.be/demo/url-regex
    url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
    regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
    "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
    // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
    // byte: https://github.com/miguelmota/is-base64
    byte,
    // signed 32 bit integer
    int32: {
        type: "number",
        validate: validateInt32
    },
    // signed 64 bit integer
    int64: {
        type: "number",
        validate: validateInt64
    },
    // C-type float
    float: {
        type: "number",
        validate: validateNumber
    },
    // C-type double
    double: {
        type: "number",
        validate: validateNumber
    },
    // hint to the UI to hide input strings
    password: true,
    // unchecked string payload
    binary: true
};
exports.fastFormats = {
    ...exports.fullFormats,
    date: fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, compareDate),
    time: fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, compareTime),
    "date-time": fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, compareDateTime),
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
};
exports.formatNames = Object.keys(exports.fullFormats);
function isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
const DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
const DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    const matches = DATE.exec(str);
    if (!matches) return false;
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month === 2 && isLeapYear(year) ? 29 : DAYS[month]);
}
function compareDate(d1, d2) {
    if (!(d1 && d2)) return undefined;
    if (d1 > d2) return 1;
    if (d1 < d2) return -1;
    return 0;
}
const TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
function time(str, withTimeZone) {
    const matches = TIME.exec(str);
    if (!matches) return false;
    const hour = +matches[1];
    const minute = +matches[2];
    const second = +matches[3];
    const timeZone = matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour === 23 && minute === 59 && second === 60) && (!withTimeZone || timeZone !== "");
}
function compareTime(t1, t2) {
    if (!(t1 && t2)) return undefined;
    const a1 = TIME.exec(t1);
    const a2 = TIME.exec(t2);
    if (!(a1 && a2)) return undefined;
    t1 = a1[1] + a1[2] + a1[3] + (a1[4] || "");
    t2 = a2[1] + a2[2] + a2[3] + (a2[4] || "");
    if (t1 > t2) return 1;
    if (t1 < t2) return -1;
    return 0;
}
const DATE_TIME_SEPARATOR = /t|\s/i;
function date_time(str) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    const dateTime = str.split(DATE_TIME_SEPARATOR);
    return dateTime.length === 2 && date(dateTime[0]) && time(dateTime[1], true);
}
function compareDateTime(dt1, dt2) {
    if (!(dt1 && dt2)) return undefined;
    const [d1, t1] = dt1.split(DATE_TIME_SEPARATOR);
    const [d2, t2] = dt2.split(DATE_TIME_SEPARATOR);
    const res = compareDate(d1, d2);
    if (res === undefined) return undefined;
    return res || compareTime(t1, t2);
}
const NOT_URI_FRAGMENT = /\/|:/;
const URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
function uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return NOT_URI_FRAGMENT.test(str) && URI.test(str);
}
const BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
function byte(str) {
    BYTE.lastIndex = 0;
    return BYTE.test(str);
}
const MIN_INT32 = -(2 ** 31);
const MAX_INT32 = 2 ** 31 - 1;
function validateInt32(value) {
    return Number.isInteger(value) && value <= MAX_INT32 && value >= MIN_INT32;
}
function validateInt64(value) {
    // JSON and javascript max Int is 2**53, so any int that passes isInteger is valid for Int64
    return Number.isInteger(value);
}
function validateNumber() {
    return true;
}
const Z_ANCHOR = /[^\\]\\Z/;
function regex(str) {
    if (Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str);
        return true;
    } catch (e) {
        return false;
    }
}

},{}],"1W3fo":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatLimitDefinition = void 0;
const ajv_1 = require("edcb7aada7165da4");
const codegen_1 = require("88bf256dbec21ab0");
const ops = codegen_1.operators;
const KWDs = {
    formatMaximum: {
        okStr: "<=",
        ok: ops.LTE,
        fail: ops.GT
    },
    formatMinimum: {
        okStr: ">=",
        ok: ops.GTE,
        fail: ops.LT
    },
    formatExclusiveMaximum: {
        okStr: "<",
        ok: ops.LT,
        fail: ops.GTE
    },
    formatExclusiveMinimum: {
        okStr: ">",
        ok: ops.GT,
        fail: ops.LTE
    }
};
const error = {
    message: ({ keyword, schemaCode })=>codegen_1.str`should be ${KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword, schemaCode })=>codegen_1._`{comparison: ${KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
exports.formatLimitDefinition = {
    keyword: Object.keys(KWDs),
    type: "string",
    schemaType: "string",
    $data: true,
    error,
    code (cxt) {
        const { gen, data, schemaCode, keyword, it } = cxt;
        const { opts, self } = it;
        if (!opts.validateFormats) return;
        const fCxt = new ajv_1.KeywordCxt(it, self.RULES.all.format.definition, "format");
        if (fCxt.$data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fmt = gen.const("fmt", codegen_1._`${fmts}[${fCxt.schemaCode}]`);
            cxt.fail$data(codegen_1.or(codegen_1._`typeof ${fmt} != "object"`, codegen_1._`${fmt} instanceof RegExp`, codegen_1._`typeof ${fmt}.compare != "function"`, compareCode(fmt)));
        }
        function validateFormat() {
            const format = fCxt.schema;
            const fmtDef = self.formats[format];
            if (!fmtDef || fmtDef === true) return;
            if (typeof fmtDef != "object" || fmtDef instanceof RegExp || typeof fmtDef.compare != "function") throw new Error(`"${keyword}": format "${format}" does not define "compare" function`);
            const fmt = gen.scopeValue("formats", {
                key: format,
                ref: fmtDef,
                code: opts.code.formats ? codegen_1._`${opts.code.formats}${codegen_1.getProperty(format)}` : undefined
            });
            cxt.fail$data(compareCode(fmt));
        }
        function compareCode(fmt) {
            return codegen_1._`${fmt}.compare(${data}, ${schemaCode}) ${KWDs[keyword].fail} 0`;
        }
    },
    dependencies: [
        "format"
    ]
};
const formatLimitPlugin = (ajv)=>{
    ajv.addKeyword(exports.formatLimitDefinition);
    return ajv;
};
exports.default = formatLimitPlugin;

},{"edcb7aada7165da4":"8ShSS","88bf256dbec21ab0":"5E3CJ"}],"1DTFJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Transforming the error output from ajv to format used by @rjsf/utils.
 * At some point, components should be updated to support ajv.
 *
 * @param errors - The list of AJV errors to convert to `RJSFValidationErrors`
 * @param [uiSchema] - An optional uiSchema that is passed to `transformErrors` and `customValidate`
 */ parcelHelpers.export(exports, "transformRJSFValidationErrors", ()=>transformRJSFValidationErrors);
parcelHelpers.export(exports, "default", ()=>processRawValidationErrors);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _utils = require("@rjsf/utils");
function transformRJSFValidationErrors(errors = [], uiSchema) {
    return errors.map((e)=>{
        const { instancePath, keyword, params, schemaPath, parentSchema, ...rest } = e;
        let { message = "" } = rest;
        let property = instancePath.replace(/\//g, ".");
        let stack = `${property} ${message}`.trim();
        if ("missingProperty" in params) {
            property = property ? `${property}.${params.missingProperty}` : params.missingProperty;
            const currentProperty = params.missingProperty;
            const uiSchemaTitle = (0, _utils.getUiOptions)((0, _getDefault.default)(uiSchema, `${property.replace(/^\./, "")}`)).title;
            if (uiSchemaTitle) message = message.replace(currentProperty, uiSchemaTitle);
            else {
                const parentSchemaTitle = (0, _getDefault.default)(parentSchema, [
                    (0, _utils.PROPERTIES_KEY),
                    currentProperty,
                    "title"
                ]);
                if (parentSchemaTitle) message = message.replace(currentProperty, parentSchemaTitle);
            }
            stack = message;
        } else {
            const uiSchemaTitle = (0, _utils.getUiOptions)((0, _getDefault.default)(uiSchema, `${property.replace(/^\./, "")}`)).title;
            if (uiSchemaTitle) stack = `'${uiSchemaTitle}' ${message}`.trim();
            else {
                const parentSchemaTitle = parentSchema === null || parentSchema === void 0 ? void 0 : parentSchema.title;
                if (parentSchemaTitle) stack = `'${parentSchemaTitle}' ${message}`.trim();
            }
        }
        // put data in expected format
        return {
            name: keyword,
            property,
            message,
            params,
            stack,
            schemaPath
        };
    });
}
function processRawValidationErrors(validator, rawErrors, formData, schema, customValidate, transformErrors, uiSchema) {
    const { validationError: invalidSchemaError } = rawErrors;
    let errors = transformRJSFValidationErrors(rawErrors.errors, uiSchema);
    if (invalidSchemaError) errors = [
        ...errors,
        {
            stack: invalidSchemaError.message
        }
    ];
    if (typeof transformErrors === "function") errors = transformErrors(errors, uiSchema);
    let errorSchema = (0, _utils.toErrorSchema)(errors);
    if (invalidSchemaError) errorSchema = {
        ...errorSchema,
        $schema: {
            __errors: [
                invalidSchemaError.message
            ]
        }
    };
    if (typeof customValidate !== "function") return {
        errors,
        errorSchema
    };
    // Include form data with undefined values, which is required for custom validation.
    const newFormData = (0, _utils.getDefaultFormState)(validator, schema, formData, schema, true);
    const errorHandler = customValidate(newFormData, (0, _utils.createErrorHandler)(newFormData), uiSchema);
    const userErrorSchema = (0, _utils.unwrapErrorHandler)(errorHandler);
    return (0, _utils.validationDataMerge)({
        errors,
        errorSchema
    }, userErrorSchema);
}

},{"lodash/get":"8z6tS","@rjsf/utils":"dblzs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b2BcN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createPrecompiledValidator);
var _precompiledValidator = require("./precompiledValidator");
var _precompiledValidatorDefault = parcelHelpers.interopDefault(_precompiledValidator);
function createPrecompiledValidator(validateFns, rootSchema, localizer) {
    return new (0, _precompiledValidatorDefault.default)(validateFns, rootSchema, localizer);
}

},{"./precompiledValidator":"hbpwm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hbpwm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _utils = require("@rjsf/utils");
var _processRawValidationErrors = require("./processRawValidationErrors");
var _processRawValidationErrorsDefault = parcelHelpers.interopDefault(_processRawValidationErrors);
class AJV8PrecompiledValidator {
    /** Constructs an `AJV8PrecompiledValidator` instance using the `validateFns` and `rootSchema`
     *
     * @param validateFns - The map of the validation functions that are generated by the `schemaCompile()` function
     * @param rootSchema - The root schema that was used with the `compileSchema()` function
     * @param [localizer] - If provided, is used to localize a list of Ajv `ErrorObject`s
     * @throws - Error when the base schema of the precompiled validator does not have a matching validator function
     */ constructor(validateFns, rootSchema, localizer){
        this.rootSchema = rootSchema;
        this.validateFns = validateFns;
        this.localizer = localizer;
        this.mainValidator = this.getValidator(rootSchema);
    }
    /** Returns the precompiled validator associated with the given `schema` from the map of precompiled validator
     * functions.
     *
     * @param schema - The schema for which a precompiled validator function is desired
     * @returns - The precompiled validator function associated with this schema
     */ getValidator(schema) {
        const key = (0, _getDefault.default)(schema, (0, _utils.ID_KEY)) || (0, _utils.hashForSchema)(schema);
        const validator = this.validateFns[key];
        if (!validator) throw new Error(`No precompiled validator function was found for the given schema for "${key}"`);
        return validator;
    }
    /** Ensures that the validator is using the same schema as the root schema used to construct the precompiled
     * validator. It first compares the given `schema` against the root schema and if they aren't the same, then it
     * checks against the resolved root schema, on the chance that a resolved version of the root schema was passed in
     * instead of the raw root schema.
     *
     * @param schema - The schema against which to validate the form data
     * @param [formData] - The form data to validate if any
     */ ensureSameRootSchema(schema, formData) {
        if (!(0, _isEqualDefault.default)(schema, this.rootSchema)) {
            // Resolve the root schema with the passed in form data since that may affect the resolution
            const resolvedRootSchema = (0, _utils.retrieveSchema)(this, this.rootSchema, this.rootSchema, formData);
            if (!(0, _isEqualDefault.default)(schema, resolvedRootSchema)) throw new Error("The schema associated with the precompiled validator differs from the rootSchema provided for validation");
        }
        return true;
    }
    /** Converts an `errorSchema` into a list of `RJSFValidationErrors`
     *
     * @param errorSchema - The `ErrorSchema` instance to convert
     * @param [fieldPath=[]] - The current field path, defaults to [] if not specified
     * @deprecated - Use the `toErrorList()` function provided by `@rjsf/utils` instead. This function will be removed in
     *        the next major release.
     */ toErrorList(errorSchema, fieldPath = []) {
        return (0, _utils.toErrorList)(errorSchema, fieldPath);
    }
    /** Runs the pure validation of the `schema` and `formData` without any of the RJSF functionality. Provided for use
     * by the playground. Returns the `errors` from the validation
     *
     * @param schema - The schema against which to validate the form data
     * @param [formData] - The form data to validate, if any
     * @throws - Error when the schema provided does not match the base schema of the precompiled validator
     */ rawValidation(schema, formData) {
        this.ensureSameRootSchema(schema, formData);
        this.mainValidator(formData);
        if (typeof this.localizer === "function") this.localizer(this.mainValidator.errors);
        const errors = this.mainValidator.errors || undefined;
        // Clear errors to prevent persistent errors, see #1104
        this.mainValidator.errors = null;
        return {
            errors: errors
        };
    }
    /** This function processes the `formData` with an optional user contributed `customValidate` function, which receives
     * the form data and a `errorHandler` function that will be used to add custom validation errors for each field. Also
     * supports a `transformErrors` function that will take the raw AJV validation errors, prior to custom validation and
     * transform them in what ever way it chooses.
     *
     * @param formData - The form data to validate
     * @param schema - The schema against which to validate the form data
     * @param [customValidate] - An optional function that is used to perform custom validation
     * @param [transformErrors] - An optional function that is used to transform errors after AJV validation
     * @param [uiSchema] - An optional uiSchema that is passed to `transformErrors` and `customValidate`
     */ validateFormData(formData, schema, customValidate, transformErrors, uiSchema) {
        const rawErrors = this.rawValidation(schema, formData);
        return (0, _processRawValidationErrorsDefault.default)(this, rawErrors, formData, schema, customValidate, transformErrors, uiSchema);
    }
    /** Validates data against a schema, returning true if the data is valid, or false otherwise. If the schema is
     * invalid, then this function will return false.
     *
     * @param schema - The schema against which to validate the form data
     * @param formData - The form data to validate
     * @param rootSchema - The root schema used to provide $ref resolutions
     * @returns - true if the formData validates against the schema, false otherwise
     * @throws - Error when the schema provided does not match the base schema of the precompiled validator OR if there
     *        isn't a precompiled validator function associated with the schema
     */ isValid(schema, formData, rootSchema) {
        this.ensureSameRootSchema(rootSchema, formData);
        if ((0, _getDefault.default)(schema, (0, _utils.ID_KEY)) === (0, _utils.JUNK_OPTION_ID)) return false;
        const validator = this.getValidator(schema);
        return validator(formData);
    }
}
exports.default = AJV8PrecompiledValidator;

},{"lodash/get":"8z6tS","lodash/isEqual":"64pmh","@rjsf/utils":"dblzs","./processRawValidationErrors":"1DTFJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jgQxz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4TsYa":[function(require,module,exports) {
module.exports = require("18bfa566320aca91")(require("98ccc6696748ec7f").resolve("f5vAc")).then(()=>module.bundle.root("7jEkY"));

},{"18bfa566320aca91":"hpx0h","98ccc6696748ec7f":"fyJL2"}],"aClb8":[function(require,module,exports) {
module.exports = Promise.all([
    require("c0a6f04a40917d54")(require("c9f6542087d336a8").resolve("f5vAc")),
    require("c0a6f04a40917d54")(require("c9f6542087d336a8").resolve("iIEy7"))
]).then(()=>module.bundle.root("hdthc"));

},{"c0a6f04a40917d54":"hpx0h","c9f6542087d336a8":"fyJL2"}],"2cFGR":[function(require,module,exports) {
module.exports = Promise.all([
    require("3b3abff59e85ab69")(require("6f7ec0925b6115f5").resolve("f5vAc")),
    require("3b3abff59e85ab69")(require("6f7ec0925b6115f5").resolve("43ZJp"))
]).then(()=>module.bundle.root("5omjc"));

},{"3b3abff59e85ab69":"hpx0h","6f7ec0925b6115f5":"fyJL2"}],"hixV2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pdqSqliteStatement = require("./pdq-sqlite-statement");
parcelHelpers.exportAll(_pdqSqliteStatement, exports);
var _pdqSqliteQuery = require("./pdq-sqlite-query");
parcelHelpers.exportAll(_pdqSqliteQuery, exports);
var _pdqSqliteClient = require("./pdq-sqlite-client");
parcelHelpers.exportAll(_pdqSqliteClient, exports);
var _pdqSqlitePerspectiveLink = require("./pdq-sqlite-perspective-link");
parcelHelpers.exportAll(_pdqSqlitePerspectiveLink, exports);
var _pdqSqliteImport = require("./pdq-sqlite-import");
parcelHelpers.exportAll(_pdqSqliteImport, exports);
var _pdqSqliteDownload = require("./pdq-sqlite-download");
parcelHelpers.exportAll(_pdqSqliteDownload, exports);

},{"./pdq-sqlite-statement":"8nPtI","./pdq-sqlite-query":"gpQUm","./pdq-sqlite-client":"1Fkjw","./pdq-sqlite-perspective-link":"cefJT","./pdq-sqlite-import":"4vMRm","./pdq-sqlite-download":"5aiD1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8nPtI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqSqliteStatement", ()=>PdqSqliteStatement);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _utils = require("../utils");
var _sqliteBroker = require("../services/SqliteBroker");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:sqlite:statement");
let PdqSqliteStatement = class PdqSqliteStatement extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.alias = "main";
    }
    updated(changedProperties) {
        super.updated(changedProperties);
    }
    render() {
        return (0, _lit.html)`
      <slot style="display: none" name="statement" @slotchange="${this._onSlotChange}"></slot>
    `;
    }
    async _onSlotChange(event) {
        if (!this.database) {
            log(`WARNING: database is not set, statement cannot be applied`);
            return;
        }
        try {
            const slot = event.target;
            const nodes = slot.assignedNodes({
                flatten: true
            });
            const statement = (0, _utils.extractTextFromScripts)(nodes);
            await (0, _utils.waitWithLogging)(log, (0, _sqliteBroker.sqliteBroker).getDatabaseReadyPromise(this.database), `Waiting for database[${this.database}] to be ready...`);
            const start = performance.now();
            log(`statement changed to ${statement}`);
            const client = await (0, _sqliteBroker.sqliteBroker).getDatabaseClient(this.database, this.alias, `pdq:sqlite:statement`);
            log(`got client`);
            await client.query(statement);
            log(`statement executed in ${performance.now() - start}ms`);
        } catch (e) {
            console.error(`Failed to parse statement`, e);
        }
    }
};
PdqSqliteStatement.styles = (0, _lit.css)``;
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSqliteStatement.prototype, "database", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSqliteStatement.prototype, "alias", void 0);
PdqSqliteStatement = __decorate([
    (0, _decoratorsJs.customElement)("pdq-sqlite-statement")
], PdqSqliteStatement);

},{"debug":"17JIf","lit":"aCmte","lit/decorators.js":"kQrIl","../utils":"i8jxn","../services/SqliteBroker":"l00em","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l00em":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SqliteBroker", ()=>SqliteBroker);
parcelHelpers.export(exports, "sqliteBroker", ()=>sqliteBroker);
var _pdqSqliteClient = require("../sqlite/pdq-sqlite-client");
var _utils = require("../utils");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _rxjs = require("rxjs");
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SqliteBroker_databasesReadyMap;
const log = (0, _debugDefault.default)("pdq:sqlite:SqliteBroker");
class SqliteBroker {
    get tableUpdated() {
        return this._tableUpdatedSubject;
    }
    constructor(){
        this._client = new Map;
        this._mutex = new (0, _utils.Mutex)("SqliteBroker");
        this.tableUpdatedSubject = new (0, _rxjs.Subject)();
        this._tableUpdatedSubject = this.tableUpdatedSubject.asObservable();
        _SqliteBroker_databasesReadyMap.set(this, new Map());
        this._tableUpdatedSubject.subscribe((i)=>{
            log(`table updated`, i);
        });
    }
    async getDatabaseClient(path, alias = "main", note = "-") {
        log(`getDatabaseClient`, path, alias, note);
        const unlock = await this._mutex.lock();
        try {
            let client = this._client.get(path);
            if (!client) {
                log(`creating new client for ${path}`);
                client = new (0, _pdqSqliteClient.PqdSqlClient)(path);
                this._client.set(path, client);
            }
            return client;
        // if (!this._client)
        //   throw new Error('init the main database first...') // todo -- await a main db promise here?
        //
        // const dbs = await this._client.query('PRAAGMA database_list');
        // if (dbs.filter(i => i.name == alias)) {
        //   return this._client!
        // }
        //
        // await this._client.query(`ATTACH DATABASE '${path}' AS ${alias}`);
        // return this._client
        } finally{
            unlock();
        }
    }
    notifyTableUpdated(database, table) {
        this.tableUpdatedSubject.next({
            database,
            table
        });
    }
    getDatabaseReadyPromise(opfsPath) {
        let existing = __classPrivateFieldGet(this, _SqliteBroker_databasesReadyMap, "f").get(opfsPath);
        if (existing) return existing.promise;
        let resolve = ()=>{};
        const promise = new Promise((r)=>resolve = r);
        __classPrivateFieldGet(this, _SqliteBroker_databasesReadyMap, "f").set(opfsPath, {
            promise,
            resolve
        });
        return promise;
    }
    setDatabaseReady(opfsPath) {
        log(`setDatabaseReady:${opfsPath}`);
        let existing = __classPrivateFieldGet(this, _SqliteBroker_databasesReadyMap, "f").get(opfsPath);
        if (existing) return existing.resolve();
        let resolve = ()=>{};
        const promise = new Promise((r)=>resolve = r);
        __classPrivateFieldGet(this, _SqliteBroker_databasesReadyMap, "f").set(opfsPath, {
            promise,
            resolve
        });
        resolve();
    }
}
_SqliteBroker_databasesReadyMap = new WeakMap();
const sqliteBroker = new SqliteBroker();
log(`SqliteBroker created`);

},{"../sqlite/pdq-sqlite-client":"1Fkjw","../utils":"i8jxn","debug":"17JIf","rxjs":"d4Szo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Fkjw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PqdSqlClient", ()=>PqdSqlClient);
parcelHelpers.export(exports, "PdfSqlitePreparedRunStatement", ()=>PdfSqlitePreparedRunStatement);
parcelHelpers.export(exports, "PdfSqlitePreparedRunBulkStatement", ()=>PdfSqlitePreparedRunBulkStatement);
parcelHelpers.export(exports, "PdfSqlitePreparedGetStatement", ()=>PdfSqlitePreparedGetStatement);
parcelHelpers.export(exports, "PdfSqlitePreparedAllStatement", ()=>PdfSqlitePreparedAllStatement);
parcelHelpers.export(exports, "PdfSqlitePreparedBindStatement", ()=>PdfSqlitePreparedBindStatement);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _PqdSqlClient_opfsPath, _PqdSqlClient_worker, _PqdSqlClient_messageId, _PqdSqlClient_subscribers, _PqdSqlClient_ready, _PqdSqlClient_onmessage;
const log = (0, _debugDefault.default)("pdq:sqlite:client");
const useShared = true;
let port;
class PqdSqlClient {
    get ready() {
        return __classPrivateFieldGet(this, _PqdSqlClient_ready, "f");
    }
    constructor(opfsPath){
        _PqdSqlClient_opfsPath.set(this, void 0);
        _PqdSqlClient_worker.set(this, void 0);
        _PqdSqlClient_messageId.set(this, 0);
        _PqdSqlClient_subscribers.set(this, new Map());
        _PqdSqlClient_ready.set(this, void 0);
        _PqdSqlClient_onmessage.set(this, (evt)=>{
            log("onmessage", evt.data);
            const { id, action, error, result } = evt.data;
            switch(action){
                case "ready":
                    port.postMessage({
                        id: -1,
                        action: "open",
                        payload: {
                            path: __classPrivateFieldGet(this, _PqdSqlClient_opfsPath, "f")
                        }
                    });
                    break;
                case "open-result":
                    log("database open");
                    __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").get(id)?.resolve(result);
                    __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").delete(id);
                    break;
                case "query-result":
                case "download-result":
                case "prepare-result":
                    __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").get(id)?.resolve(result);
                    __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").delete(id);
                    break;
                case "error":
                    const sub = __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").get(id);
                    if (sub) {
                        sub.reject({
                            error: error,
                            sql: sub.sql
                        });
                        __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").delete(id);
                    } else console.error(error);
                    break;
            }
        });
        log(`ctor: ${opfsPath}`);
        __classPrivateFieldSet(this, _PqdSqlClient_opfsPath, opfsPath, "f");
        const workerUrl = new URL(`./pdq-sqlite-worker.js`, location.href.substring(0, location.href.lastIndexOf("/") + 1));
        if (useShared) {
            __classPrivateFieldSet(this, _PqdSqlClient_worker, new SharedWorker(workerUrl, {
                type: "module"
            }), "f");
            __classPrivateFieldGet(this, _PqdSqlClient_worker, "f").port.onmessage = __classPrivateFieldGet(this, _PqdSqlClient_onmessage, "f");
            port = __classPrivateFieldGet(this, _PqdSqlClient_worker, "f").port;
        } else {
            __classPrivateFieldSet(this, _PqdSqlClient_worker, new Worker(workerUrl, {
                type: "module"
            }), "f");
            __classPrivateFieldGet(this, _PqdSqlClient_worker, "f").onmessage = __classPrivateFieldGet(this, _PqdSqlClient_onmessage, "f");
            port = __classPrivateFieldGet(this, _PqdSqlClient_worker, "f");
        }
    }
    query(sql, params) {
        var _a, _b;
        const msgId = (__classPrivateFieldSet(this, _PqdSqlClient_messageId, (_b = __classPrivateFieldGet(this, _PqdSqlClient_messageId, "f"), _a = _b++, _b), "f"), _a);
        let start;
        if (log.enabled) {
            start = performance.now();
            log(`query:[${msgId}] "${sql}"`, params);
        }
        return new Promise(async (resolve, reject)=>{
            __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").set(msgId, {
                sql,
                resolve: (resp)=>{
                    if (log.enabled) log(`query:[${msgId}] success in ${performance.now() - start}ms`, resp);
                    resolve(resp);
                },
                reject: (e)=>{
                    if (log.enabled) log(`query:[${msgId}] failed in ${performance.now() - start}ms`, e);
                    reject(e);
                }
            });
            await __classPrivateFieldGet(this, _PqdSqlClient_ready, "f");
            port.postMessage({
                id: msgId,
                action: "query",
                payload: {
                    path: __classPrivateFieldGet(this, _PqdSqlClient_opfsPath, "f"),
                    sql,
                    params
                }
            });
        });
    }
    async prepare(verb, sql) {
        var _a, _b;
        const msgId = (__classPrivateFieldSet(this, _PqdSqlClient_messageId, (_b = __classPrivateFieldGet(this, _PqdSqlClient_messageId, "f"), _a = _b++, _b), "f"), _a);
        return new Promise(async (resolve, reject)=>{
            __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").set(msgId, {
                resolve: (i)=>{
                    resolve(i.id);
                },
                reject
            });
            await __classPrivateFieldGet(this, _PqdSqlClient_ready, "f");
            port.postMessage({
                id: msgId,
                action: "prepare-statement",
                payload: {
                    path: __classPrivateFieldGet(this, _PqdSqlClient_opfsPath, "f"),
                    sql,
                    verb
                }
            });
        });
    }
    executeStatement(statement) {
        var _a, _b;
        const msgId = (__classPrivateFieldSet(this, _PqdSqlClient_messageId, (_b = __classPrivateFieldGet(this, _PqdSqlClient_messageId, "f"), _a = _b++, _b), "f"), _a);
        return new Promise(async (resolve, reject)=>{
            __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").set(msgId, {
                resolve,
                reject
            });
            await __classPrivateFieldGet(this, _PqdSqlClient_ready, "f");
            log("executeStatement:", statement, statement.getPayload());
            port.postMessage({
                id: msgId,
                action: "execute-prepared-statement",
                payload: statement.getPayload()
            });
        });
    }
    finalizeStatement(statement) {
        var _a, _b;
        const msgId = (__classPrivateFieldSet(this, _PqdSqlClient_messageId, (_b = __classPrivateFieldGet(this, _PqdSqlClient_messageId, "f"), _a = _b++, _b), "f"), _a);
        return new Promise(async (resolve, reject)=>{
            __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").set(msgId, {
                resolve,
                reject
            });
            await __classPrivateFieldGet(this, _PqdSqlClient_ready, "f");
            port.postMessage({
                id: msgId,
                action: "finalize-prepared-statement",
                payload: {
                    id: statement.id,
                    path: __classPrivateFieldGet(this, _PqdSqlClient_opfsPath, "f")
                }
            });
        });
    }
    async download(url, path, overwrite = true) {
        var _a, _b;
        const msgId = (__classPrivateFieldSet(this, _PqdSqlClient_messageId, (_b = __classPrivateFieldGet(this, _PqdSqlClient_messageId, "f"), _a = _b++, _b), "f"), _a);
        return new Promise(async (resolve, reject)=>{
            __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").set(msgId, {
                url,
                resolve,
                reject
            });
            await __classPrivateFieldGet(this, _PqdSqlClient_ready, "f");
            port.postMessage({
                id: msgId,
                action: "download",
                payload: {
                    url,
                    path,
                    overwrite
                }
            });
        });
    }
    async import(path, blob, overwrite = true) {
        var _a, _b;
        const msgId = (__classPrivateFieldSet(this, _PqdSqlClient_messageId, (_b = __classPrivateFieldGet(this, _PqdSqlClient_messageId, "f"), _a = _b++, _b), "f"), _a);
        return new Promise(async (resolve, reject)=>{
            __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").set(msgId, {
                path,
                resolve,
                reject
            });
            await __classPrivateFieldGet(this, _PqdSqlClient_ready, "f");
            port.postMessage({
                id: msgId,
                action: "import",
                payload: {
                    path,
                    blob,
                    overwrite
                }
            });
        });
    }
    async open(path) {
        var _a, _b;
        const msgId = (__classPrivateFieldSet(this, _PqdSqlClient_messageId, (_b = __classPrivateFieldGet(this, _PqdSqlClient_messageId, "f"), _a = _b++, _b), "f"), _a);
        return new Promise(async (resolve, reject)=>{
            __classPrivateFieldGet(this, _PqdSqlClient_subscribers, "f").set(msgId, {
                path,
                resolve,
                reject
            });
            await __classPrivateFieldGet(this, _PqdSqlClient_ready, "f");
            port.postMessage({
                id: msgId,
                action: "open",
                payload: {
                    path: __classPrivateFieldGet(this, _PqdSqlClient_opfsPath, "f")
                }
            });
        });
    }
    async prepareRun(sql) {
        const id = await this.prepare("run", sql);
        return new PdfSqlitePreparedRunStatement(this, id, "run", __classPrivateFieldGet(this, _PqdSqlClient_opfsPath, "f"));
    }
    async prepareRunBulk(sql) {
        const id = await this.prepare("run-bulk", sql);
        return new PdfSqlitePreparedRunBulkStatement(this, id, "run-bulk", __classPrivateFieldGet(this, _PqdSqlClient_opfsPath, "f"));
    }
    async prepareGet(sql) {
        const id = await this.prepare("get", sql);
        return new PdfSqlitePreparedGetStatement(this, id, "get", __classPrivateFieldGet(this, _PqdSqlClient_opfsPath, "f"));
    }
    async prepareAll(sql) {
        const id = await this.prepare("all", sql);
        return new PdfSqlitePreparedAllStatement(this, id, "all", __classPrivateFieldGet(this, _PqdSqlClient_opfsPath, "f"));
    }
    async prepareBind(sql) {
        const id = await this.prepare("all", sql);
        return new PdfSqlitePreparedBindStatement(this, id, "all", __classPrivateFieldGet(this, _PqdSqlClient_opfsPath, "f"));
    }
}
_PqdSqlClient_opfsPath = new WeakMap(), _PqdSqlClient_worker = new WeakMap(), _PqdSqlClient_messageId = new WeakMap(), _PqdSqlClient_subscribers = new WeakMap(), _PqdSqlClient_ready = new WeakMap(), _PqdSqlClient_onmessage = new WeakMap();
class PdqSqlitePreparedStatement {
    get id() {
        return this._id;
    }
    get verb() {
        return this._verb;
    }
    get path() {
        return this._path;
    }
    constructor(_client, _id, _verb, _path){
        this._client = _client;
        this._id = _id;
        this._verb = _verb;
        this._path = _path;
        log(`PREPARED STATEMENT - ${this._id}`);
    }
    async dispose() {
        await this._client.finalizeStatement(this);
    }
}
class PdfSqlitePreparedRunStatement extends PdqSqlitePreparedStatement {
    constructor(){
        super(...arguments);
        this._params = undefined;
    }
    run(params) {
        this._params = params;
        return this._client.executeStatement(this);
    }
    getPayload() {
        return {
            id: 0,
            params: this._params,
            verb: this._verb,
            path: this._path
        };
    }
}
class PdfSqlitePreparedRunBulkStatement extends PdqSqlitePreparedStatement {
    constructor(){
        super(...arguments);
        this._params = undefined;
    }
    run(params) {
        const start = performance.now();
        try {
            this._params = params;
            return this._client.executeStatement(this);
        } finally{
            log(`PdfSqlitePreparedRunBulkStatement: run took ${performance.now() - start}ms`);
        }
    }
    getPayload() {
        return {
            id: this._id,
            params: this._params,
            verb: this._verb,
            path: this._path
        };
    }
}
class PdfSqlitePreparedGetStatement extends PdqSqlitePreparedStatement {
    constructor(){
        super(...arguments);
        this._params = undefined;
    }
    get(params) {
        this._params = params;
        return this._client.executeStatement(this);
    }
    getPayload() {
        return {
            id: this._id,
            params: this._params,
            verb: this._verb,
            path: this._path
        };
    }
}
class PdfSqlitePreparedAllStatement extends PdqSqlitePreparedStatement {
    constructor(){
        super(...arguments);
        this._params = undefined;
    }
    all(params) {
        this._params = params;
        return this._client.executeStatement(this);
    }
    getPayload() {
        return {
            id: this._id,
            params: this._params,
            verb: this._verb,
            path: this._path
        };
    }
}
class PdfSqlitePreparedBindStatement extends PdqSqlitePreparedStatement {
    constructor(){
        super(...arguments);
        this._params = undefined;
        this._bound = false;
        this._nextVerb = "bind";
    }
    bind(params) {
        this._bound = true;
        this._params = params;
        return this._client.executeStatement(this);
    }
    run() {
        this._checkBinding();
        this._nextVerb = "run";
        return this._client.executeStatement(this);
    }
    get() {
        this._checkBinding();
        this._nextVerb = "get";
        return this._client.executeStatement(this);
    }
    all() {
        this._checkBinding();
        this._nextVerb = "all";
        return this._client.executeStatement(this);
    }
    getPayload() {
        return {
            id: this._id,
            params: this._params,
            verb: this._nextVerb,
            path: this._path
        };
    }
    _checkBinding() {
        if (!this._bound) throw new Error("Failed to execute... bind must be called first");
    }
}

},{"debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gpQUm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqSqliteQuery", ()=>PdqSqliteQuery);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _utils = require("../utils");
var _sqliteBroker = require("../services/SqliteBroker");
var _pdqSqliteStatement = require("./pdq-sqlite-statement");
var _tableBroker = require("../services/TableBroker");
var _dataBroker = require("../services/DataBroker");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:sqlite:query");
let PdqSqliteQuery = class PdqSqliteQuery extends (0, _pdqSqliteStatement.PdqSqliteStatement) {
    constructor(){
        super(...arguments);
        this.query = "";
        this.tableUpdatedUnsubscribe = ()=>{};
    }
    get table() {
        return this._table;
    }
    get datasource() {
        return this._datasource;
    }
    get sqliteTable() {
        return this._sqliteTable;
    }
    set table(value) {
        this._table = value;
        this.refresh();
    }
    set datasource(value) {
        this._datasource = value;
        this.refresh();
    }
    set sqliteTable(value) {
        this._sqliteTable = value;
        this.refresh();
    }
    render() {
        log("refresh");
        return (0, _lit.html)`
      <slot style="display: none" name="query" @slotchange="${this._onSlotChange}"></slot>
    `;
    }
    async refresh() {
        log("refresh");
        if (!this.query) {
            log(`query is not set, skipping...`);
            return;
        }
        if (!this.database) {
            log(`WARNING: database is not set, query cannot be executed`);
            return;
        }
        if (!this.table && !this.datasource) {
            log(`WARNING: both datasource and table are unset, no where to save the query results... skipping`);
            return;
        }
        await (0, _utils.waitWithLogging)(log, (0, _sqliteBroker.sqliteBroker).getDatabaseReadyPromise(this.database), `Waiting for database[${this.database}] to be ready...`);
        const start = performance.now();
        const client = await (0, _sqliteBroker.sqliteBroker).getDatabaseClient(this.database, this.alias, `pdq:sqlite:query[${this.datasource}/${this.table}]`);
        log(`got client`);
        try {
            const data = await client?.query(this.query);
            log(`query "${this.query}" executed in ${performance.now() - start}ms found ${data.length} rows`);
            await (0, _dataBroker.dataBroker).setDataSource(this.datasource, data);
            if (this.table) await (0, _tableBroker.tableBroker).setTable(this.table, this.datasource, this.index || "");
        } catch (e) {
            log("query failed", e);
        }
        this.tableUpdatedUnsubscribe();
        this.tableUpdatedUnsubscribe = (0, _sqliteBroker.sqliteBroker).tableUpdated.subscribe((i)=>{
            if (i.database == this.database && i.table == this.sqliteTable) {
                log(`table ${this.table} updated... refreshing`);
                this.refresh();
            }
        }).unsubscribe;
    }
    async _onSlotChange(event) {
        log("_onSlotChange");
        if (!this.database) {
            log(`WARNING: database is not set, query cannot be executed`);
            return;
        }
        if (!this.table && !this.datasource) {
            log(`WARNING: both datasource and table are unset, no where to save the query results... skipping`);
            return;
        }
        if (!this.datasource) {
            this.datasource = `${this.table}-ds`;
            log(`using auto datasource name: "${this.datasource}"`);
        }
        try {
            log(`query setting...`);
            const slot = event.target;
            const nodes = slot.assignedNodes({
                flatten: true
            });
            this.query = (0, _utils.extractTextFromScripts)(nodes);
            log(`query changed to ${this.query}`);
            this.refresh();
        } catch (e) {
            console.error(`Failed to parse statement`, e);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.tableUpdatedUnsubscribe();
    }
};
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [
        Object
    ])
], PdqSqliteQuery.prototype, "table", null);
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSqliteQuery.prototype, "index", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [
        Object
    ])
], PdqSqliteQuery.prototype, "datasource", null);
__decorate([
    (0, _decoratorsJs.property)({
        type: String,
        attribute: "sqlite-table"
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [
        Object
    ])
], PdqSqliteQuery.prototype, "sqliteTable", null);
PdqSqliteQuery = __decorate([
    (0, _decoratorsJs.customElement)("pdq-sqlite-query")
], PdqSqliteQuery);

},{"debug":"17JIf","lit":"aCmte","lit/decorators.js":"kQrIl","../utils":"i8jxn","../services/SqliteBroker":"l00em","./pdq-sqlite-statement":"8nPtI","../services/TableBroker":"kJzSP","../services/DataBroker":"kD6gB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cefJT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqSqlitePerspectiveLinkStatus", ()=>PdqSqlitePerspectiveLinkStatus);
parcelHelpers.export(exports, "PdqSqlitePerspectiveLink", ()=>PdqSqlitePerspectiveLink);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _sqliteBroker = require("../services/SqliteBroker");
var _pdqSqliteStatement = require("./pdq-sqlite-statement");
var _tableBroker = require("../services/TableBroker");
var _utils = require("../utils");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var PdqSqlitePerspectiveLinkStatus;
(function(PdqSqlitePerspectiveLinkStatus) {
    PdqSqlitePerspectiveLinkStatus[PdqSqlitePerspectiveLinkStatus["NOT_LOADED"] = 0] = "NOT_LOADED";
    PdqSqlitePerspectiveLinkStatus[PdqSqlitePerspectiveLinkStatus["SQLITE_READY"] = 1] = "SQLITE_READY";
    PdqSqlitePerspectiveLinkStatus[PdqSqlitePerspectiveLinkStatus["PERSPECTIVE_VIEW_READY"] = 2] = "PERSPECTIVE_VIEW_READY";
    PdqSqlitePerspectiveLinkStatus[PdqSqlitePerspectiveLinkStatus["SCHEMA_APPLIED"] = 4] = "SCHEMA_APPLIED";
    PdqSqlitePerspectiveLinkStatus[PdqSqlitePerspectiveLinkStatus["SCHEMA_ERROR"] = 8] = "SCHEMA_ERROR";
})(PdqSqlitePerspectiveLinkStatus || (PdqSqlitePerspectiveLinkStatus = {}));
const internalLog = (0, _debugDefault.default)("pdq:sqlite:link");
const log = (status, msg, ...args)=>internalLog(`[${logStatus(status)}] ${msg}`, status, ...args);
let PdqSqlitePerspectiveLink = class PdqSqlitePerspectiveLink extends (0, _pdqSqliteStatement.PdqSqliteStatement) {
    constructor(){
        super(...arguments);
        this._refreshMutex = new (0, _utils.Mutex)("pdq:sqlite:refresh");
        this._refreshPromise = null;
        this._firstUpdateComplete = false;
        this._tableSubscriptionUnsubscribe = ()=>{};
        this._status = PdqSqlitePerspectiveLinkStatus.NOT_LOADED;
    }
    get table() {
        return this._table;
    }
    set table(value) {
        log(this._status, `Setting table to ${value}`);
        this._table = value;
        this.setupTableSubscription(value).catch((e)=>log(this._status, `Error setting up table subscription: ${e}`));
    }
    get sqliteTable() {
        return this._sqliteTable;
    }
    set sqliteTable(value) {
        log(this._status, `Setting sqlite table to ${value}`);
        this._sqliteTable = value;
        this.setupSqliteTable();
    }
    render() {
        return (0, _lit.html)`
      <slot style="display: none" name="query" @slotchange="${this._onSlotChange}"></slot>
    `;
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        log(this._status, "firstUpdated");
        this._firstUpdateComplete = true;
        this.refresh();
    }
    async refresh() {
        const unlock = await this._refreshMutex.lock();
        try {
            if (this._refreshPromise) return await this._refreshPromise;
            this._refreshPromise = this._refresh();
            await this._refreshPromise;
        } finally{
            this._refreshPromise = null;
            unlock();
        }
    }
    async _refresh() {
        if (!this._firstUpdateComplete || !(this._status & PdqSqlitePerspectiveLinkStatus.PERSPECTIVE_VIEW_READY) || !(this._status & PdqSqlitePerspectiveLinkStatus.SQLITE_READY)) return;
        if (this._status & PdqSqlitePerspectiveLinkStatus.SCHEMA_ERROR) {
            log(this._status, `WARNING: schema error, skipping refresh`);
            return;
        }
        if (!this._client) {
            log(this._status, `WARNING: database is not set, query cannot be executed`);
            return;
        }
        if (!this._schema) {
            log(this._status, `WARNING:  table are unset, no where to save the query results... skipping`);
            return;
        }
        await (0, _utils.waitWithLogging)((...args)=>log(this._status, ...args), (0, _sqliteBroker.sqliteBroker).getDatabaseReadyPromise(this.database), `Waiting for database[${this.database}] to be ready...`);
        const start = performance.now();
        try {
            if (!(this._status & PdqSqlitePerspectiveLinkStatus.SCHEMA_APPLIED)) {
                log(this._status, "applying schema to sqlite");
                await this.updateTableSchema();
            }
            await this.insertRows(this._client, this.sqliteTable, this._data);
            this.dispatchEvent(new CustomEvent("reload", {
                detail: {
                    table: this.table,
                    schema: this._schema
                }
            }));
            if (this.database && this.table) (0, _sqliteBroker.sqliteBroker).notifyTableUpdated(this.database, this.table);
            log(this._status, `Refreshed in ${performance.now() - start}ms`);
        } catch (e) {
            log(this._status, `Refresh failed in ${performance.now() - start}ms - error:`, e);
        }
    }
    async setupTableSubscription(value) {
        this._status &= ~PdqSqlitePerspectiveLinkStatus.PERSPECTIVE_VIEW_READY;
        this._status &= ~PdqSqlitePerspectiveLinkStatus.SCHEMA_APPLIED;
        this._tableSubscriptionUnsubscribe();
        let tableSubscription = {
            unsubscribe: ()=>{}
        };
        tableSubscription = (0, _tableBroker.tableBroker).getTable(value).subscribe(async (table)=>{
            log(this._status, `Got table ${value}`);
            const view = await table.view();
            [this._schema, this._data] = await Promise.all([
                table.schema(),
                view.to_json()
            ]);
            this._status |= PdqSqlitePerspectiveLinkStatus.PERSPECTIVE_VIEW_READY;
            view.on_update((i)=>{
                log(this._status, `view data updated - TODO!!!!`);
            // debugger
            });
            view.on_delete(()=>{
                log(this._status, `view deleted - TODO!!!!`);
            // debugger
            });
            await this.refresh();
            this._tableSubscriptionUnsubscribe = async ()=>{
                await view.delete();
                tableSubscription.unsubscribe();
            };
        });
    }
    async setupSqliteTable() {
        this._client = await (0, _sqliteBroker.sqliteBroker).getDatabaseClient(this.database, this.alias, `pdq:sqlite:link[${this.table}/${this.sqliteTable}]`);
        this._status |= PdqSqlitePerspectiveLinkStatus.SQLITE_READY;
        await this.refresh();
    }
    async insertRows(client, table, rows) {
        log(this._status, `Inserting ${rows.length} rows into ${table}`);
        // await client.query("BEGIN TRANSACTION");
        // try {
        //   for (const row of rows) {
        //     const param = {} as any
        //     for (const c in row) {
        //       param[`:${c}`] = row[c]
        //     }
        //     log(this._status, "PARAM!", param);
        //     await client.query(this._insertStatement, param);
        //   }
        //   await client.query("COMMIT");
        // } catch (error) {
        //   await client.query("ROLLBACK");
        //   throw error;
        // }
        await this._insertStatement?.run(rows.map((row)=>{
            const param = {};
            for(const c in row)param[`:${c}`] = row[c];
            return param;
        }));
    }
    toSqlType(perspectiveType) {
        const typeMap = {
            "int": "INTEGER",
            "float": "REAL",
            "string": "TEXT",
            "boolean": "INTEGER",
            "datetime": "TEXT",
            "date": "TEXT",
            "object": "TEXT",
            "decimal": "NUMERIC",
            "list": "TEXT" // Serialized JSON string.
        };
        return typeMap[perspectiveType] || "TEXT"; // Default to TEXT for unknown types.
    }
    async updateTableSchema() {
        log(this._status, "updateTableSchema");
        this._status &= ~PdqSqlitePerspectiveLinkStatus.SCHEMA_ERROR;
        this._status |= PdqSqlitePerspectiveLinkStatus.SCHEMA_APPLIED;
        if (this._insertStatement) await this._insertStatement.dispose();
        const client = this._client;
        await client.query(`DROP TABLE IF EXISTS [${this.sqliteTable}]`);
        const schema = this._schema;
        const colDefs = [];
        const colNames = [];
        for(const colName in schema){
            const type = schema[colName];
            const sqlType = this.toSqlType(type);
            colDefs.push(`[${colName}] ${sqlType}`);
            colNames.push(colName);
        }
        if (colDefs.length === 0) {
            this._status |= PdqSqlitePerspectiveLinkStatus.SCHEMA_ERROR;
            throw new Error(`No columns in schema`);
        }
        await client.query(`CREATE TABLE IF NOT EXISTS [${this.sqliteTable}]  (${colDefs.join(", ")})`);
        this._insertStatement = await client.prepareRunBulk(`INSERT INTO [${this.sqliteTable}] 
  (${colNames.map((i)=>`[${i}]`).join(", ")}) 
VALUES 
  (${colNames.map((i)=>`:${i}`).join(", ")})`);
    }
    disconnectedCallback() {
        log(this._status, `disconnectedCallback: removing any subscriptions`);
        this._tableSubscriptionUnsubscribe();
        if (this._insertStatement) this._insertStatement.dispose().catch((e)=>log(this._status, `failed to dispose statement: ${e}`));
        super.disconnectedCallback();
    }
};
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [
        Object
    ])
], PdqSqlitePerspectiveLink.prototype, "table", null);
__decorate([
    (0, _decoratorsJs.property)({
        type: String,
        attribute: "sqlite-table"
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [
        Object
    ])
], PdqSqlitePerspectiveLink.prototype, "sqliteTable", null);
PdqSqlitePerspectiveLink = __decorate([
    (0, _decoratorsJs.customElement)("pdq-sqlite-perspective-link")
], PdqSqlitePerspectiveLink);
function logStatus(status) {
    if (status === PdqSqlitePerspectiveLinkStatus.NOT_LOADED) return "NOT_LOADED";
    return Object.keys(PdqSqlitePerspectiveLinkStatus).filter((key)=>isNaN(Number(key))) // Filter out numeric keys
    .filter((key)=>{
        const value = PdqSqlitePerspectiveLinkStatus[key];
        return (status & value) !== 0;
    }).join(", ");
}

},{"debug":"17JIf","lit":"aCmte","lit/decorators.js":"kQrIl","../services/SqliteBroker":"l00em","./pdq-sqlite-statement":"8nPtI","../services/TableBroker":"kJzSP","../utils":"i8jxn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4vMRm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqSqliteImport", ()=>PdqSqliteImport);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _dataBroker = require("../services/DataBroker");
var _sqliteBroker = require("../services/SqliteBroker");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:sqlite:import");
let PdqSqliteImport = class PdqSqliteImport extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.overwrite = true;
        this.cleanup = ()=>{};
        this.render = ()=>(0, _lit.nothing);
        this.cacheKey = "";
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.refresh().catch((e)=>log(`failed to refresh - ${e}`));
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        this.refresh().catch((e)=>log(`failed to refresh - ${e}`));
    }
    disconnectedCallback() {
        this.cleanup();
    }
    async refresh() {
        if (!this.blobName) {
            log(`refresh failed... no blobName`);
            return;
        }
        if (!this.database) {
            log(`refresh failed... no database path / name`);
            return;
        }
        const ck = `${this.blobName}##${this.database}`;
        if (this.cacheKey == ck) return;
        this.cacheKey = ck;
        log(`subscribing to blob[${this.blobName}]`);
        const blob$ = await (0, _dataBroker.dataBroker).getObservableDataSource(this.blobName);
        const sub = blob$.subscribe(async (blob)=>{
            log(`blob[${this.blobName}] received...`);
            if (blob instanceof Blob) {
                const c = await (0, _sqliteBroker.sqliteBroker).getDatabaseClient(this.database);
                await c.import(this.database, blob, this.overwrite);
                await c.open(this.database);
                const d = await c.query("SELECT * FROM sqlite_master");
                (0, _sqliteBroker.sqliteBroker).setDatabaseReady(this.database);
            } else log(`refresh failed... no blob found for ${this.blobName} - found type ${typeof blob}`);
        });
        this.cleanup = ()=>sub.unsubscribe();
    }
};
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSqliteImport.prototype, "database", void 0);
__decorate([
    (0, _decorators.property)({
        type: String,
        attribute: "blob-name"
    }),
    __metadata("design:type", Object)
], PdqSqliteImport.prototype, "blobName", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqSqliteImport.prototype, "overwrite", void 0);
PdqSqliteImport = __decorate([
    (0, _decorators.customElement)("pdq-sqlite-import")
], PdqSqliteImport);

},{"debug":"17JIf","lit/decorators":"kQrIl","lit":"aCmte","../services/DataBroker":"kD6gB","../services/SqliteBroker":"l00em","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5aiD1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqSqliteDownload", ()=>PdqSqliteDownload);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _pdqSqliteClient = require("./pdq-sqlite-client");
var _sqliteBroker = require("../services/SqliteBroker");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:sqlite:download");
let PdqSqliteDownload = class PdqSqliteDownload extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.overwrite = true;
        this.render = ()=>(0, _lit.nothing);
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
    }
    async refresh() {
        log("refreshing");
        if (!this.url) {
            log(`refresh failed... no url`);
            return;
        }
        if (!this.database) {
            log(`refresh failed... no database path / name`);
            return;
        }
        const c = new (0, _pdqSqliteClient.PqdSqlClient)(this.database);
        await c.download(this.url, this.database, this.overwrite);
        await c.open(this.database);
        (0, _sqliteBroker.sqliteBroker).setDatabaseReady(this.database);
    }
};
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSqliteDownload.prototype, "database", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqSqliteDownload.prototype, "url", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqSqliteDownload.prototype, "overwrite", void 0);
PdqSqliteDownload = __decorate([
    (0, _decorators.customElement)("pdq-sqlite-download")
], PdqSqliteDownload);

},{"debug":"17JIf","lit/decorators":"kQrIl","lit":"aCmte","./pdq-sqlite-client":"1Fkjw","../services/SqliteBroker":"l00em","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"efG9a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqTextEditor", ()=>PdqTextEditor);
var _monacoEditor = require("monaco-editor");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _utils = require("../utils");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
const log = (0, _debugDefault.default)("pdq:monaco");
self.MonacoEnvironment = {
    getWorkerUrl: function(moduleId, label) {
        console.log("getWorkerUrl", moduleId, label);
        if (label === "json") return "./monaco/json.worker.js";
        if (label === "css" || label === "scss" || label === "less") return "./monaco/css.worker.js";
        if (label === "html" || label === "handlebars" || label === "razor") return "./monaco/html.worker.js";
        if (label === "typescript" || label === "javascript") return "./monaco/ts.worker.js";
        if (label === "sql") return "./monaco/sql.worker.js";
        return "./monaco/editor.worker.js";
    }
};
let PdqTextEditor = class PdqTextEditor extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this._monacoEditor = null;
        this._schema = [];
        this.value = "";
        this.theme = (0, _utils.getDefaultThemeMode)() == (0, _utils.ThemeMode).light ? "vs" : "vs-dark";
        this.language = "json";
        this.modelUri = `inmemory://monaco-${performance.now()}`;
    }
    get height() {
        return this.style.height;
    }
    set height(value) {
        log(`pdq-monaco: changing height from ${this.style.height} to ${value}`);
        this.style.height = value;
    }
    get editor() {
        return this._monacoEditor;
    }
    get model() {
        return this._monacoEditor?.getModel();
    }
    get selectedText() {
        if (!this._monacoEditor) return "";
        return this._monacoEditor.getModel()?.getValueInRange(this._monacoEditor.getSelection()) || "";
    }
    addJsonSchema(uri, schema, validate = true, fileMatch) {
        const newSchema = {
            uri,
            schema
        };
        if (fileMatch) newSchema.fileMatch = [
            (0, _monacoEditor.Uri).parse(fileMatch).toString()
        ];
        this._schema.push(newSchema);
        (0, _monacoEditor.languages).json.jsonDefaults.setDiagnosticsOptions({
            validate,
            schemas: this._schema
        });
    }
    setModel(value, language, uri) {
        this.model?.dispose();
        const model = (0, _monacoEditor.editor).createModel(value, language, typeof uri === "string" ? (0, _monacoEditor.Uri).parse(uri) : uri);
        this._monacoEditor?.setModel(model);
    }
    setOptions(options) {
        this._monacoEditor?.updateOptions(options);
    }
    createRenderRoot() {
        const root = this.attachShadow({
            mode: "open"
        });
        document.querySelectorAll("link[rel='stylesheet']").forEach((i)=>root.appendChild(i.cloneNode(true)));
        this.style.boxSizing = "border-box";
        this.style.display = "flex";
        this.style.alignItems = "stretch";
        this.style.justifyContent = "stretch";
        this.style.overflow = "hidden";
        this.style.position = "relative";
        this.style.width = "100%";
        const container = document.createElement("div");
        container.id = "container";
        container.style.display = "flex";
        container.style.overflow = "hidden";
        container.style.flexGrow = "1";
        container.style.position = "absolute";
        container.style.boxSizing = "border-box";
        const s = document.createElement("style");
        s.innerHTML = "* {box-sizing: border-box!important;}";
        root.appendChild(s);
        container.style.left = "0";
        container.style.top = "0";
        container.style.right = "0";
        container.style.bottom = "0";
        const slot = document.createElement("slot");
        slot.name = "text";
        slot.style.display = "none";
        slot.addEventListener("slotchange", this._onSlotChange.bind(this));
        root.append(container, slot);
        this.container = container;
        const model = (0, _monacoEditor.editor).createModel(this.value, this.language, (0, _monacoEditor.Uri).parse(this.modelUri));
        const opts = {
            automaticLayout: true,
            theme: this.theme,
            model
        };
        const possibleOpts = {
            automaticLayout: "automatic-layout",
            lineNumbers: "line-numbers",
            roundedSelection: "rounded-selection",
            scrollBeyondLastLine: "scroll-beyond-last-line",
            readOnly: "read-only",
            wordWrap: "word-wrap",
            wordWrapColumn: "word-wrap-column",
            wrappingIndent: "wrapping-indent"
        };
        for(const key in possibleOpts){
            const value = this.getAttribute(possibleOpts[key]);
            if (value) opts[key] = value;
        }
        this._monacoEditor = (0, _monacoEditor.editor).create(this.container, opts);
        this.dispatchEvent(new CustomEvent("ready", {
            detail: {
                element: this,
                editor: this._monacoEditor
            }
        }));
        return root;
    }
    async _onSlotChange(event) {
        log("slot change", event.target);
        try {
            const slot = event.target;
            const nodes = slot.assignedNodes({
                flatten: true
            });
            const value = (0, _utils.extractTextFromScripts)(nodes);
            log(`slot value changed:`, value);
            this.editor?.setValue(value);
            this._monacoEditor?.layout();
        } catch (e) {
            console.error(`Failed to parse statement`, e);
        }
    }
};
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [
        String
    ])
], PdqTextEditor.prototype, "height", null);
__decorate([
    (0, _decoratorsJs.state)(),
    __metadata("design:type", Object)
], PdqTextEditor.prototype, "_monacoEditor", void 0);
__decorate([
    (0, _decoratorsJs.state)(),
    __metadata("design:type", typeof (_b = typeof Array !== "undefined" && Array) === "function" ? _b : Object)
], PdqTextEditor.prototype, "_schema", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqTextEditor.prototype, "value", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqTextEditor.prototype, "theme", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqTextEditor.prototype, "language", void 0);
__decorate([
    (0, _decoratorsJs.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqTextEditor.prototype, "modelUri", void 0);
PdqTextEditor = __decorate([
    (0, _decoratorsJs.customElement)("pdq-text-editor")
], PdqTextEditor);

},{"monaco-editor":"5LDmH","lit":"aCmte","lit/decorators.js":"kQrIl","../utils":"i8jxn","debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5LDmH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _monacoContribution = require("../basic-languages/monaco.contribution");
var _monacoContribution1 = require("../language/css/monaco.contribution");
var _monacoContribution2 = require("../language/html/monaco.contribution");
var _monacoContribution3 = require("../language/json/monaco.contribution");
var _monacoContribution4 = require("../language/typescript/monaco.contribution");
var _edcoreMain = require("./edcore.main");
parcelHelpers.exportAll(_edcoreMain, exports);

},{"../basic-languages/monaco.contribution":"dBQfA","../language/css/monaco.contribution":"fp5U4","../language/html/monaco.contribution":"kwTBc","../language/json/monaco.contribution":"8ZBNP","../language/typescript/monaco.contribution":"jS83e","./edcore.main":"4wiGa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dBQfA":[function(require,module,exports) {
var _editorApiJs = require("../editor/editor.api.js");
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/monaco.contribution.ts
var _abapContributionJs = require("./abap/abap.contribution.js");
var _apexContributionJs = require("./apex/apex.contribution.js");
var _azcliContributionJs = require("./azcli/azcli.contribution.js");
var _batContributionJs = require("./bat/bat.contribution.js");
var _bicepContributionJs = require("./bicep/bicep.contribution.js");
var _cameligoContributionJs = require("./cameligo/cameligo.contribution.js");
var _clojureContributionJs = require("./clojure/clojure.contribution.js");
var _coffeeContributionJs = require("./coffee/coffee.contribution.js");
var _cppContributionJs = require("./cpp/cpp.contribution.js");
var _csharpContributionJs = require("./csharp/csharp.contribution.js");
var _cspContributionJs = require("./csp/csp.contribution.js");
var _cssContributionJs = require("./css/css.contribution.js");
var _cypherContributionJs = require("./cypher/cypher.contribution.js");
var _dartContributionJs = require("./dart/dart.contribution.js");
var _dockerfileContributionJs = require("./dockerfile/dockerfile.contribution.js");
var _eclContributionJs = require("./ecl/ecl.contribution.js");
var _elixirContributionJs = require("./elixir/elixir.contribution.js");
var _flow9ContributionJs = require("./flow9/flow9.contribution.js");
var _fsharpContributionJs = require("./fsharp/fsharp.contribution.js");
var _freemarker2ContributionJs = require("./freemarker2/freemarker2.contribution.js");
var _goContributionJs = require("./go/go.contribution.js");
var _graphqlContributionJs = require("./graphql/graphql.contribution.js");
var _handlebarsContributionJs = require("./handlebars/handlebars.contribution.js");
var _hclContributionJs = require("./hcl/hcl.contribution.js");
var _htmlContributionJs = require("./html/html.contribution.js");
var _iniContributionJs = require("./ini/ini.contribution.js");
var _javaContributionJs = require("./java/java.contribution.js");
var _javascriptContributionJs = require("./javascript/javascript.contribution.js");
var _juliaContributionJs = require("./julia/julia.contribution.js");
var _kotlinContributionJs = require("./kotlin/kotlin.contribution.js");
var _lessContributionJs = require("./less/less.contribution.js");
var _lexonContributionJs = require("./lexon/lexon.contribution.js");
var _luaContributionJs = require("./lua/lua.contribution.js");
var _liquidContributionJs = require("./liquid/liquid.contribution.js");
var _m3ContributionJs = require("./m3/m3.contribution.js");
var _markdownContributionJs = require("./markdown/markdown.contribution.js");
var _mdxContributionJs = require("./mdx/mdx.contribution.js");
var _mipsContributionJs = require("./mips/mips.contribution.js");
var _msdaxContributionJs = require("./msdax/msdax.contribution.js");
var _mysqlContributionJs = require("./mysql/mysql.contribution.js");
var _objectiveCContributionJs = require("./objective-c/objective-c.contribution.js");
var _pascalContributionJs = require("./pascal/pascal.contribution.js");
var _pascaligoContributionJs = require("./pascaligo/pascaligo.contribution.js");
var _perlContributionJs = require("./perl/perl.contribution.js");
var _pgsqlContributionJs = require("./pgsql/pgsql.contribution.js");
var _phpContributionJs = require("./php/php.contribution.js");
var _plaContributionJs = require("./pla/pla.contribution.js");
var _postiatsContributionJs = require("./postiats/postiats.contribution.js");
var _powerqueryContributionJs = require("./powerquery/powerquery.contribution.js");
var _powershellContributionJs = require("./powershell/powershell.contribution.js");
var _protobufContributionJs = require("./protobuf/protobuf.contribution.js");
var _pugContributionJs = require("./pug/pug.contribution.js");
var _pythonContributionJs = require("./python/python.contribution.js");
var _qsharpContributionJs = require("./qsharp/qsharp.contribution.js");
var _rContributionJs = require("./r/r.contribution.js");
var _razorContributionJs = require("./razor/razor.contribution.js");
var _redisContributionJs = require("./redis/redis.contribution.js");
var _redshiftContributionJs = require("./redshift/redshift.contribution.js");
var _restructuredtextContributionJs = require("./restructuredtext/restructuredtext.contribution.js");
var _rubyContributionJs = require("./ruby/ruby.contribution.js");
var _rustContributionJs = require("./rust/rust.contribution.js");
var _sbContributionJs = require("./sb/sb.contribution.js");
var _scalaContributionJs = require("./scala/scala.contribution.js");
var _schemeContributionJs = require("./scheme/scheme.contribution.js");
var _scssContributionJs = require("./scss/scss.contribution.js");
var _shellContributionJs = require("./shell/shell.contribution.js");
var _solidityContributionJs = require("./solidity/solidity.contribution.js");
var _sophiaContributionJs = require("./sophia/sophia.contribution.js");
var _sparqlContributionJs = require("./sparql/sparql.contribution.js");
var _sqlContributionJs = require("./sql/sql.contribution.js");
var _stContributionJs = require("./st/st.contribution.js");
var _swiftContributionJs = require("./swift/swift.contribution.js");
var _systemverilogContributionJs = require("./systemverilog/systemverilog.contribution.js");
var _tclContributionJs = require("./tcl/tcl.contribution.js");
var _twigContributionJs = require("./twig/twig.contribution.js");
var _typescriptContributionJs = require("./typescript/typescript.contribution.js");
var _typespecContributionJs = require("./typespec/typespec.contribution.js");
var _vbContributionJs = require("./vb/vb.contribution.js");
var _wgslContributionJs = require("./wgsl/wgsl.contribution.js");
var _xmlContributionJs = require("./xml/xml.contribution.js");
var _yamlContributionJs = require("./yaml/yaml.contribution.js");

},{"../editor/editor.api.js":"6ZKre","./abap/abap.contribution.js":"2dMNq","./apex/apex.contribution.js":"aIJxm","./azcli/azcli.contribution.js":"hR5SX","./bat/bat.contribution.js":"6pvNu","./bicep/bicep.contribution.js":"bsW2d","./cameligo/cameligo.contribution.js":"6QIeS","./clojure/clojure.contribution.js":"2xcYZ","./coffee/coffee.contribution.js":"lkHLO","./cpp/cpp.contribution.js":"f6aFI","./csharp/csharp.contribution.js":"ipo4C","./csp/csp.contribution.js":"jTIxM","./css/css.contribution.js":"3MHh1","./cypher/cypher.contribution.js":"1UryK","./dart/dart.contribution.js":"aEAhS","./dockerfile/dockerfile.contribution.js":"iycQb","./ecl/ecl.contribution.js":"cpJGX","./elixir/elixir.contribution.js":"e8IP3","./flow9/flow9.contribution.js":"aBW57","./fsharp/fsharp.contribution.js":"3YSwZ","./freemarker2/freemarker2.contribution.js":"efjiP","./go/go.contribution.js":"6jHMX","./graphql/graphql.contribution.js":"aluC5","./handlebars/handlebars.contribution.js":"b1elH","./hcl/hcl.contribution.js":"8kc2v","./html/html.contribution.js":"204Ie","./ini/ini.contribution.js":"1m7Vv","./java/java.contribution.js":"3Uhe4","./javascript/javascript.contribution.js":"eA4tD","./julia/julia.contribution.js":"fUXOu","./kotlin/kotlin.contribution.js":"59qRo","./less/less.contribution.js":"4Oalt","./lexon/lexon.contribution.js":"3PJLk","./lua/lua.contribution.js":"gq6GN","./liquid/liquid.contribution.js":"aXTOQ","./m3/m3.contribution.js":"3FagO","./markdown/markdown.contribution.js":"ecOVg","./mdx/mdx.contribution.js":"3egkJ","./mips/mips.contribution.js":"cd0iA","./msdax/msdax.contribution.js":"iExEi","./mysql/mysql.contribution.js":"5PFvy","./objective-c/objective-c.contribution.js":"16w3a","./pascal/pascal.contribution.js":"fjpb6","./pascaligo/pascaligo.contribution.js":"6sB0J","./perl/perl.contribution.js":"ghPSZ","./pgsql/pgsql.contribution.js":"i6tpJ","./php/php.contribution.js":"4i4gW","./pla/pla.contribution.js":"431De","./postiats/postiats.contribution.js":"3m24o","./powerquery/powerquery.contribution.js":"jXVSe","./powershell/powershell.contribution.js":"jbbQX","./protobuf/protobuf.contribution.js":"hfJ7w","./pug/pug.contribution.js":"kLesd","./python/python.contribution.js":"gV2x1","./qsharp/qsharp.contribution.js":"8tcMV","./r/r.contribution.js":"l7xXX","./razor/razor.contribution.js":"iNdbf","./redis/redis.contribution.js":"3Agir","./redshift/redshift.contribution.js":"7pYrZ","./restructuredtext/restructuredtext.contribution.js":"g4w2c","./ruby/ruby.contribution.js":"b42Ma","./rust/rust.contribution.js":"85Y1o","./sb/sb.contribution.js":"gIto7","./scala/scala.contribution.js":"RHgyA","./scheme/scheme.contribution.js":"fUrhd","./scss/scss.contribution.js":"2pDOL","./shell/shell.contribution.js":"bz7hw","./solidity/solidity.contribution.js":"8cSrk","./sophia/sophia.contribution.js":"dYLqL","./sparql/sparql.contribution.js":"b0Fi2","./sql/sql.contribution.js":"iu8C4","./st/st.contribution.js":"9SSPf","./swift/swift.contribution.js":"iMrGT","./systemverilog/systemverilog.contribution.js":"i49tc","./tcl/tcl.contribution.js":"dmtNI","./twig/twig.contribution.js":"fvUfE","./typescript/typescript.contribution.js":"blUbq","./typespec/typespec.contribution.js":"ftccF","./vb/vb.contribution.js":"jAJ4M","./wgsl/wgsl.contribution.js":"dS5Rp","./xml/xml.contribution.js":"fdU34","./yaml/yaml.contribution.js":"gZr02"}],"6ZKre":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancellationTokenSource", ()=>CancellationTokenSource);
parcelHelpers.export(exports, "Emitter", ()=>Emitter);
parcelHelpers.export(exports, "KeyCode", ()=>KeyCode);
parcelHelpers.export(exports, "KeyMod", ()=>KeyMod);
parcelHelpers.export(exports, "Position", ()=>Position);
parcelHelpers.export(exports, "Range", ()=>Range);
parcelHelpers.export(exports, "Selection", ()=>Selection);
parcelHelpers.export(exports, "SelectionDirection", ()=>SelectionDirection);
parcelHelpers.export(exports, "MarkerSeverity", ()=>MarkerSeverity);
parcelHelpers.export(exports, "MarkerTag", ()=>MarkerTag);
parcelHelpers.export(exports, "Uri", ()=>Uri);
parcelHelpers.export(exports, "Token", ()=>Token);
parcelHelpers.export(exports, "editor", ()=>editor);
parcelHelpers.export(exports, "languages", ()=>languages);
var _editorOptionsJs = require("./common/config/editorOptions.js");
var _editorBaseApiJs = require("./common/services/editorBaseApi.js");
var _standaloneEditorJs = require("./standalone/browser/standaloneEditor.js");
var _standaloneLanguagesJs = require("./standalone/browser/standaloneLanguages.js");
var _formatJs = require("./contrib/format/browser/format.js");
// Set defaults for standalone editor
(0, _editorOptionsJs.EditorOptions).wrappingIndent.defaultValue = 0 /* WrappingIndent.None */ ;
(0, _editorOptionsJs.EditorOptions).glyphMargin.defaultValue = false;
(0, _editorOptionsJs.EditorOptions).autoIndent.defaultValue = 3 /* EditorAutoIndentStrategy.Advanced */ ;
(0, _editorOptionsJs.EditorOptions).overviewRulerLanes.defaultValue = 2;
// We need to register a formatter selector which simply picks the first available formatter.
// See https://github.com/microsoft/monaco-editor/issues/2327
(0, _formatJs.FormattingConflicts).setFormatterSelector((formatter, document, mode)=>Promise.resolve(formatter[0]));
const api = (0, _editorBaseApiJs.createMonacoBaseAPI)();
api.editor = (0, _standaloneEditorJs.createMonacoEditorAPI)();
api.languages = (0, _standaloneLanguagesJs.createMonacoLanguagesAPI)();
const CancellationTokenSource = api.CancellationTokenSource;
const Emitter = api.Emitter;
const KeyCode = api.KeyCode;
const KeyMod = api.KeyMod;
const Position = api.Position;
const Range = api.Range;
const Selection = api.Selection;
const SelectionDirection = api.SelectionDirection;
const MarkerSeverity = api.MarkerSeverity;
const MarkerTag = api.MarkerTag;
const Uri = api.Uri;
const Token = api.Token;
const editor = api.editor;
const languages = api.languages;
const monacoEnvironment = globalThis.MonacoEnvironment;
if (monacoEnvironment?.globalAPI || typeof define === "function" && define.amd) globalThis.monaco = api;
if (typeof globalThis.require !== "undefined" && typeof globalThis.require.config === "function") globalThis.require.config({
    ignoreDuplicateModules: [
        "vscode-languageserver-types",
        "vscode-languageserver-types/main",
        "vscode-languageserver-textdocument",
        "vscode-languageserver-textdocument/main",
        "vscode-nls",
        "vscode-nls/vscode-nls",
        "jsonc-parser",
        "jsonc-parser/main",
        "vscode-uri",
        "vscode-uri/index",
        "vs/basic-languages/typescript/typescript"
    ]
});

},{"./common/config/editorOptions.js":"3Xi00","./common/services/editorBaseApi.js":"jf9LT","./standalone/browser/standaloneEditor.js":"hcZNh","./standalone/browser/standaloneLanguages.js":"eQn4G","./contrib/format/browser/format.js":"cATs8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Xi00":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MINIMAP_GUTTER_WIDTH", ()=>MINIMAP_GUTTER_WIDTH);
//#endregion
/**
 * An event describing that the configuration of the editor has changed.
 */ parcelHelpers.export(exports, "ConfigurationChangedEvent", ()=>ConfigurationChangedEvent);
/**
 * @internal
 */ parcelHelpers.export(exports, "ComputeOptionsMemory", ()=>ComputeOptionsMemory);
parcelHelpers.export(exports, "ApplyUpdateResult", ()=>ApplyUpdateResult);
/**
 * @internal
 */ parcelHelpers.export(exports, "boolean", ()=>boolean);
/**
 * @internal
 */ parcelHelpers.export(exports, "clampedInt", ()=>clampedInt);
/**
 * @internal
 */ parcelHelpers.export(exports, "clampedFloat", ()=>clampedFloat);
/**
 * @internal
 */ parcelHelpers.export(exports, "stringSet", ()=>stringSet);
parcelHelpers.export(exports, "TextEditorCursorStyle", ()=>TextEditorCursorStyle);
//#endregion
//#region fontLigatures
/**
 * @internal
 */ parcelHelpers.export(exports, "EditorFontLigatures", ()=>EditorFontLigatures);
//#endregion
//#region fontVariations
/**
 * @internal
 */ parcelHelpers.export(exports, "EditorFontVariations", ()=>EditorFontVariations);
/**
 * @internal
 */ parcelHelpers.export(exports, "EditorLayoutInfoComputer", ()=>EditorLayoutInfoComputer);
parcelHelpers.export(exports, "ShowLightbulbIconMode", ()=>ShowLightbulbIconMode);
//#endregion
//#region renderValidationDecorations
/**
 * @internal
 */ parcelHelpers.export(exports, "filterValidationDecorations", ()=>filterValidationDecorations);
parcelHelpers.export(exports, "inUntrustedWorkspace", ()=>inUntrustedWorkspace);
parcelHelpers.export(exports, "unicodeHighlightConfigKeys", ()=>unicodeHighlightConfigKeys);
parcelHelpers.export(exports, "EDITOR_FONT_DEFAULTS", ()=>EDITOR_FONT_DEFAULTS);
parcelHelpers.export(exports, "editorOptionsRegistry", ()=>editorOptionsRegistry);
parcelHelpers.export(exports, "EditorOptions", ()=>EditorOptions);
var _arraysJs = require("../../../base/common/arrays.js");
var _objectsJs = require("../../../base/common/objects.js");
var _platformJs = require("../../../base/common/platform.js");
var _textModelDefaultsJs = require("../core/textModelDefaults.js");
var _wordHelperJs = require("../core/wordHelper.js");
var _nlsJs = require("../../../nls.js");
const MINIMAP_GUTTER_WIDTH = 8;
class ConfigurationChangedEvent {
    /**
     * @internal
     */ constructor(values){
        this._values = values;
    }
    hasChanged(id) {
        return this._values[id];
    }
}
class ComputeOptionsMemory {
    constructor(){
        this.stableMinimapLayoutInput = null;
        this.stableFitMaxMinimapScale = 0;
        this.stableFitRemainingWidth = 0;
    }
}
/**
 * @internal
 */ class BaseEditorOption {
    constructor(id, name, defaultValue, schema){
        this.id = id;
        this.name = name;
        this.defaultValue = defaultValue;
        this.schema = schema;
    }
    applyUpdate(value, update) {
        return applyUpdate(value, update);
    }
    compute(env, options, value) {
        return value;
    }
}
class ApplyUpdateResult {
    constructor(newValue, didChange){
        this.newValue = newValue;
        this.didChange = didChange;
    }
}
function applyUpdate(value, update) {
    if (typeof value !== "object" || typeof update !== "object" || !value || !update) return new ApplyUpdateResult(update, value !== update);
    if (Array.isArray(value) || Array.isArray(update)) {
        const arrayEquals = Array.isArray(value) && Array.isArray(update) && _arraysJs.equals(value, update);
        return new ApplyUpdateResult(update, !arrayEquals);
    }
    let didChange = false;
    for(const key in update)if (update.hasOwnProperty(key)) {
        const result = applyUpdate(value[key], update[key]);
        if (result.didChange) {
            value[key] = result.newValue;
            didChange = true;
        }
    }
    return new ApplyUpdateResult(value, didChange);
}
/**
 * @internal
 */ class ComputedEditorOption {
    constructor(id){
        this.schema = undefined;
        this.id = id;
        this.name = "_never_";
        this.defaultValue = undefined;
    }
    applyUpdate(value, update) {
        return applyUpdate(value, update);
    }
    validate(input) {
        return this.defaultValue;
    }
}
class SimpleEditorOption {
    constructor(id, name, defaultValue, schema){
        this.id = id;
        this.name = name;
        this.defaultValue = defaultValue;
        this.schema = schema;
    }
    applyUpdate(value, update) {
        return applyUpdate(value, update);
    }
    validate(input) {
        if (typeof input === "undefined") return this.defaultValue;
        return input;
    }
    compute(env, options, value) {
        return value;
    }
}
function boolean(value, defaultValue) {
    if (typeof value === "undefined") return defaultValue;
    if (value === "false") // treat the string 'false' as false
    return false;
    return Boolean(value);
}
class EditorBooleanOption extends SimpleEditorOption {
    constructor(id, name, defaultValue, schema){
        if (typeof schema !== "undefined") {
            schema.type = "boolean";
            schema.default = defaultValue;
        }
        super(id, name, defaultValue, schema);
    }
    validate(input) {
        return boolean(input, this.defaultValue);
    }
}
function clampedInt(value, defaultValue, minimum, maximum) {
    if (typeof value === "undefined") return defaultValue;
    let r = parseInt(value, 10);
    if (isNaN(r)) return defaultValue;
    r = Math.max(minimum, r);
    r = Math.min(maximum, r);
    return r | 0;
}
class EditorIntOption extends SimpleEditorOption {
    static clampedInt(value, defaultValue, minimum, maximum) {
        return clampedInt(value, defaultValue, minimum, maximum);
    }
    constructor(id, name, defaultValue, minimum, maximum, schema){
        if (typeof schema !== "undefined") {
            schema.type = "integer";
            schema.default = defaultValue;
            schema.minimum = minimum;
            schema.maximum = maximum;
        }
        super(id, name, defaultValue, schema);
        this.minimum = minimum;
        this.maximum = maximum;
    }
    validate(input) {
        return EditorIntOption.clampedInt(input, this.defaultValue, this.minimum, this.maximum);
    }
}
function clampedFloat(value, defaultValue, minimum, maximum) {
    if (typeof value === "undefined") return defaultValue;
    const r = EditorFloatOption.float(value, defaultValue);
    return EditorFloatOption.clamp(r, minimum, maximum);
}
class EditorFloatOption extends SimpleEditorOption {
    static clamp(n, min, max) {
        if (n < min) return min;
        if (n > max) return max;
        return n;
    }
    static float(value, defaultValue) {
        if (typeof value === "number") return value;
        if (typeof value === "undefined") return defaultValue;
        const r = parseFloat(value);
        return isNaN(r) ? defaultValue : r;
    }
    constructor(id, name, defaultValue, validationFn, schema){
        if (typeof schema !== "undefined") {
            schema.type = "number";
            schema.default = defaultValue;
        }
        super(id, name, defaultValue, schema);
        this.validationFn = validationFn;
    }
    validate(input) {
        return this.validationFn(EditorFloatOption.float(input, this.defaultValue));
    }
}
class EditorStringOption extends SimpleEditorOption {
    static string(value, defaultValue) {
        if (typeof value !== "string") return defaultValue;
        return value;
    }
    constructor(id, name, defaultValue, schema){
        if (typeof schema !== "undefined") {
            schema.type = "string";
            schema.default = defaultValue;
        }
        super(id, name, defaultValue, schema);
    }
    validate(input) {
        return EditorStringOption.string(input, this.defaultValue);
    }
}
function stringSet(value, defaultValue, allowedValues, renamedValues) {
    if (typeof value !== "string") return defaultValue;
    if (renamedValues && value in renamedValues) return renamedValues[value];
    if (allowedValues.indexOf(value) === -1) return defaultValue;
    return value;
}
class EditorStringEnumOption extends SimpleEditorOption {
    constructor(id, name, defaultValue, allowedValues, schema){
        if (typeof schema !== "undefined") {
            schema.type = "string";
            schema.enum = allowedValues;
            schema.default = defaultValue;
        }
        super(id, name, defaultValue, schema);
        this._allowedValues = allowedValues;
    }
    validate(input) {
        return stringSet(input, this.defaultValue, this._allowedValues);
    }
}
class EditorEnumOption extends BaseEditorOption {
    constructor(id, name, defaultValue, defaultStringValue, allowedValues, convert, schema){
        if (typeof schema !== "undefined") {
            schema.type = "string";
            schema.enum = allowedValues;
            schema.default = defaultStringValue;
        }
        super(id, name, defaultValue, schema);
        this._allowedValues = allowedValues;
        this._convert = convert;
    }
    validate(input) {
        if (typeof input !== "string") return this.defaultValue;
        if (this._allowedValues.indexOf(input) === -1) return this.defaultValue;
        return this._convert(input);
    }
}
//#endregion
//#region autoIndent
function _autoIndentFromString(autoIndent) {
    switch(autoIndent){
        case "none":
            return 0 /* EditorAutoIndentStrategy.None */ ;
        case "keep":
            return 1 /* EditorAutoIndentStrategy.Keep */ ;
        case "brackets":
            return 2 /* EditorAutoIndentStrategy.Brackets */ ;
        case "advanced":
            return 3 /* EditorAutoIndentStrategy.Advanced */ ;
        case "full":
            return 4 /* EditorAutoIndentStrategy.Full */ ;
    }
}
//#endregion
//#region accessibilitySupport
class EditorAccessibilitySupport extends BaseEditorOption {
    constructor(){
        super(2 /* EditorOption.accessibilitySupport */ , "accessibilitySupport", 0 /* AccessibilitySupport.Unknown */ , {
            type: "string",
            enum: [
                "auto",
                "on",
                "off"
            ],
            enumDescriptions: [
                _nlsJs.localize("accessibilitySupport.auto", "Use platform APIs to detect when a Screen Reader is attached."),
                _nlsJs.localize("accessibilitySupport.on", "Optimize for usage with a Screen Reader."),
                _nlsJs.localize("accessibilitySupport.off", "Assume a screen reader is not attached.")
            ],
            default: "auto",
            tags: [
                "accessibility"
            ],
            description: _nlsJs.localize("accessibilitySupport", "Controls if the UI should run in a mode where it is optimized for screen readers.")
        });
    }
    validate(input) {
        switch(input){
            case "auto":
                return 0 /* AccessibilitySupport.Unknown */ ;
            case "off":
                return 1 /* AccessibilitySupport.Disabled */ ;
            case "on":
                return 2 /* AccessibilitySupport.Enabled */ ;
        }
        return this.defaultValue;
    }
    compute(env, options, value) {
        if (value === 0 /* AccessibilitySupport.Unknown */ ) // The editor reads the `accessibilitySupport` from the environment
        return env.accessibilitySupport;
        return value;
    }
}
class EditorComments extends BaseEditorOption {
    constructor(){
        const defaults = {
            insertSpace: true,
            ignoreEmptyLines: true
        };
        super(23 /* EditorOption.comments */ , "comments", defaults, {
            "editor.comments.insertSpace": {
                type: "boolean",
                default: defaults.insertSpace,
                description: _nlsJs.localize("comments.insertSpace", "Controls whether a space character is inserted when commenting.")
            },
            "editor.comments.ignoreEmptyLines": {
                type: "boolean",
                default: defaults.ignoreEmptyLines,
                description: _nlsJs.localize("comments.ignoreEmptyLines", "Controls if empty lines should be ignored with toggle, add or remove actions for line comments.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            insertSpace: boolean(input.insertSpace, this.defaultValue.insertSpace),
            ignoreEmptyLines: boolean(input.ignoreEmptyLines, this.defaultValue.ignoreEmptyLines)
        };
    }
}
function _cursorBlinkingStyleFromString(cursorBlinkingStyle) {
    switch(cursorBlinkingStyle){
        case "blink":
            return 1 /* TextEditorCursorBlinkingStyle.Blink */ ;
        case "smooth":
            return 2 /* TextEditorCursorBlinkingStyle.Smooth */ ;
        case "phase":
            return 3 /* TextEditorCursorBlinkingStyle.Phase */ ;
        case "expand":
            return 4 /* TextEditorCursorBlinkingStyle.Expand */ ;
        case "solid":
            return 5 /* TextEditorCursorBlinkingStyle.Solid */ ;
    }
}
var TextEditorCursorStyle;
(function(TextEditorCursorStyle) {
    /**
     * As a vertical line (sitting between two characters).
     */ TextEditorCursorStyle[TextEditorCursorStyle["Line"] = 1] = "Line";
    /**
     * As a block (sitting on top of a character).
     */ TextEditorCursorStyle[TextEditorCursorStyle["Block"] = 2] = "Block";
    /**
     * As a horizontal line (sitting under a character).
     */ TextEditorCursorStyle[TextEditorCursorStyle["Underline"] = 3] = "Underline";
    /**
     * As a thin vertical line (sitting between two characters).
     */ TextEditorCursorStyle[TextEditorCursorStyle["LineThin"] = 4] = "LineThin";
    /**
     * As an outlined block (sitting on top of a character).
     */ TextEditorCursorStyle[TextEditorCursorStyle["BlockOutline"] = 5] = "BlockOutline";
    /**
     * As a thin horizontal line (sitting under a character).
     */ TextEditorCursorStyle[TextEditorCursorStyle["UnderlineThin"] = 6] = "UnderlineThin";
})(TextEditorCursorStyle || (TextEditorCursorStyle = {}));
function _cursorStyleFromString(cursorStyle) {
    switch(cursorStyle){
        case "line":
            return TextEditorCursorStyle.Line;
        case "block":
            return TextEditorCursorStyle.Block;
        case "underline":
            return TextEditorCursorStyle.Underline;
        case "line-thin":
            return TextEditorCursorStyle.LineThin;
        case "block-outline":
            return TextEditorCursorStyle.BlockOutline;
        case "underline-thin":
            return TextEditorCursorStyle.UnderlineThin;
    }
}
//#endregion
//#region editorClassName
class EditorClassName extends ComputedEditorOption {
    constructor(){
        super(143 /* EditorOption.editorClassName */ );
    }
    compute(env, options, _) {
        const classNames = [
            "monaco-editor"
        ];
        if (options.get(39 /* EditorOption.extraEditorClassName */ )) classNames.push(options.get(39 /* EditorOption.extraEditorClassName */ ));
        if (env.extraEditorClassName) classNames.push(env.extraEditorClassName);
        if (options.get(74 /* EditorOption.mouseStyle */ ) === "default") classNames.push("mouse-default");
        else if (options.get(74 /* EditorOption.mouseStyle */ ) === "copy") classNames.push("mouse-copy");
        if (options.get(112 /* EditorOption.showUnused */ )) classNames.push("showUnused");
        if (options.get(141 /* EditorOption.showDeprecated */ )) classNames.push("showDeprecated");
        return classNames.join(" ");
    }
}
//#endregion
//#region emptySelectionClipboard
class EditorEmptySelectionClipboard extends EditorBooleanOption {
    constructor(){
        super(37 /* EditorOption.emptySelectionClipboard */ , "emptySelectionClipboard", true, {
            description: _nlsJs.localize("emptySelectionClipboard", "Controls whether copying without a selection copies the current line.")
        });
    }
    compute(env, options, value) {
        return value && env.emptySelectionClipboard;
    }
}
class EditorFind extends BaseEditorOption {
    constructor(){
        const defaults = {
            cursorMoveOnType: true,
            seedSearchStringFromSelection: "always",
            autoFindInSelection: "never",
            globalFindClipboard: false,
            addExtraSpaceOnTop: true,
            loop: true
        };
        super(41 /* EditorOption.find */ , "find", defaults, {
            "editor.find.cursorMoveOnType": {
                type: "boolean",
                default: defaults.cursorMoveOnType,
                description: _nlsJs.localize("find.cursorMoveOnType", "Controls whether the cursor should jump to find matches while typing.")
            },
            "editor.find.seedSearchStringFromSelection": {
                type: "string",
                enum: [
                    "never",
                    "always",
                    "selection"
                ],
                default: defaults.seedSearchStringFromSelection,
                enumDescriptions: [
                    _nlsJs.localize("editor.find.seedSearchStringFromSelection.never", "Never seed search string from the editor selection."),
                    _nlsJs.localize("editor.find.seedSearchStringFromSelection.always", "Always seed search string from the editor selection, including word at cursor position."),
                    _nlsJs.localize("editor.find.seedSearchStringFromSelection.selection", "Only seed search string from the editor selection.")
                ],
                description: _nlsJs.localize("find.seedSearchStringFromSelection", "Controls whether the search string in the Find Widget is seeded from the editor selection.")
            },
            "editor.find.autoFindInSelection": {
                type: "string",
                enum: [
                    "never",
                    "always",
                    "multiline"
                ],
                default: defaults.autoFindInSelection,
                enumDescriptions: [
                    _nlsJs.localize("editor.find.autoFindInSelection.never", "Never turn on Find in Selection automatically (default)."),
                    _nlsJs.localize("editor.find.autoFindInSelection.always", "Always turn on Find in Selection automatically."),
                    _nlsJs.localize("editor.find.autoFindInSelection.multiline", "Turn on Find in Selection automatically when multiple lines of content are selected.")
                ],
                description: _nlsJs.localize("find.autoFindInSelection", "Controls the condition for turning on Find in Selection automatically.")
            },
            "editor.find.globalFindClipboard": {
                type: "boolean",
                default: defaults.globalFindClipboard,
                description: _nlsJs.localize("find.globalFindClipboard", "Controls whether the Find Widget should read or modify the shared find clipboard on macOS."),
                included: _platformJs.isMacintosh
            },
            "editor.find.addExtraSpaceOnTop": {
                type: "boolean",
                default: defaults.addExtraSpaceOnTop,
                description: _nlsJs.localize("find.addExtraSpaceOnTop", "Controls whether the Find Widget should add extra lines on top of the editor. When true, you can scroll beyond the first line when the Find Widget is visible.")
            },
            "editor.find.loop": {
                type: "boolean",
                default: defaults.loop,
                description: _nlsJs.localize("find.loop", "Controls whether the search automatically restarts from the beginning (or the end) when no further matches can be found.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            cursorMoveOnType: boolean(input.cursorMoveOnType, this.defaultValue.cursorMoveOnType),
            seedSearchStringFromSelection: typeof _input.seedSearchStringFromSelection === "boolean" ? _input.seedSearchStringFromSelection ? "always" : "never" : stringSet(input.seedSearchStringFromSelection, this.defaultValue.seedSearchStringFromSelection, [
                "never",
                "always",
                "selection"
            ]),
            autoFindInSelection: typeof _input.autoFindInSelection === "boolean" ? _input.autoFindInSelection ? "always" : "never" : stringSet(input.autoFindInSelection, this.defaultValue.autoFindInSelection, [
                "never",
                "always",
                "multiline"
            ]),
            globalFindClipboard: boolean(input.globalFindClipboard, this.defaultValue.globalFindClipboard),
            addExtraSpaceOnTop: boolean(input.addExtraSpaceOnTop, this.defaultValue.addExtraSpaceOnTop),
            loop: boolean(input.loop, this.defaultValue.loop)
        };
    }
}
class EditorFontLigatures extends BaseEditorOption {
    static{
        this.OFF = '"liga" off, "calt" off';
    }
    static{
        this.ON = '"liga" on, "calt" on';
    }
    constructor(){
        super(51 /* EditorOption.fontLigatures */ , "fontLigatures", EditorFontLigatures.OFF, {
            anyOf: [
                {
                    type: "boolean",
                    description: _nlsJs.localize("fontLigatures", "Enables/Disables font ligatures ('calt' and 'liga' font features). Change this to a string for fine-grained control of the 'font-feature-settings' CSS property.")
                },
                {
                    type: "string",
                    description: _nlsJs.localize("fontFeatureSettings", "Explicit 'font-feature-settings' CSS property. A boolean can be passed instead if one only needs to turn on/off ligatures.")
                }
            ],
            description: _nlsJs.localize("fontLigaturesGeneral", "Configures font ligatures or font features. Can be either a boolean to enable/disable ligatures or a string for the value of the CSS 'font-feature-settings' property."),
            default: false
        });
    }
    validate(input) {
        if (typeof input === "undefined") return this.defaultValue;
        if (typeof input === "string") {
            if (input === "false" || input.length === 0) return EditorFontLigatures.OFF;
            if (input === "true") return EditorFontLigatures.ON;
            return input;
        }
        if (Boolean(input)) return EditorFontLigatures.ON;
        return EditorFontLigatures.OFF;
    }
}
class EditorFontVariations extends BaseEditorOption {
    // Text is laid out using default settings.
    static{
        this.OFF = "normal";
    }
    // Translate `fontWeight` config to the `font-variation-settings` CSS property.
    static{
        this.TRANSLATE = "translate";
    }
    constructor(){
        super(54 /* EditorOption.fontVariations */ , "fontVariations", EditorFontVariations.OFF, {
            anyOf: [
                {
                    type: "boolean",
                    description: _nlsJs.localize("fontVariations", "Enables/Disables the translation from font-weight to font-variation-settings. Change this to a string for fine-grained control of the 'font-variation-settings' CSS property.")
                },
                {
                    type: "string",
                    description: _nlsJs.localize("fontVariationSettings", "Explicit 'font-variation-settings' CSS property. A boolean can be passed instead if one only needs to translate font-weight to font-variation-settings.")
                }
            ],
            description: _nlsJs.localize("fontVariationsGeneral", "Configures font variations. Can be either a boolean to enable/disable the translation from font-weight to font-variation-settings or a string for the value of the CSS 'font-variation-settings' property."),
            default: false
        });
    }
    validate(input) {
        if (typeof input === "undefined") return this.defaultValue;
        if (typeof input === "string") {
            if (input === "false") return EditorFontVariations.OFF;
            if (input === "true") return EditorFontVariations.TRANSLATE;
            return input;
        }
        if (Boolean(input)) return EditorFontVariations.TRANSLATE;
        return EditorFontVariations.OFF;
    }
    compute(env, options, value) {
        // The value is computed from the fontWeight if it is true.
        // So take the result from env.fontInfo
        return env.fontInfo.fontVariationSettings;
    }
}
//#endregion
//#region fontInfo
class EditorFontInfo extends ComputedEditorOption {
    constructor(){
        super(50 /* EditorOption.fontInfo */ );
    }
    compute(env, options, _) {
        return env.fontInfo;
    }
}
//#endregion
//#region fontSize
class EditorFontSize extends SimpleEditorOption {
    constructor(){
        super(52 /* EditorOption.fontSize */ , "fontSize", EDITOR_FONT_DEFAULTS.fontSize, {
            type: "number",
            minimum: 6,
            maximum: 100,
            default: EDITOR_FONT_DEFAULTS.fontSize,
            description: _nlsJs.localize("fontSize", "Controls the font size in pixels.")
        });
    }
    validate(input) {
        const r = EditorFloatOption.float(input, this.defaultValue);
        if (r === 0) return EDITOR_FONT_DEFAULTS.fontSize;
        return EditorFloatOption.clamp(r, 6, 100);
    }
    compute(env, options, value) {
        // The final fontSize respects the editor zoom level.
        // So take the result from env.fontInfo
        return env.fontInfo.fontSize;
    }
}
//#endregion
//#region fontWeight
class EditorFontWeight extends BaseEditorOption {
    static{
        this.SUGGESTION_VALUES = [
            "normal",
            "bold",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
        ];
    }
    static{
        this.MINIMUM_VALUE = 1;
    }
    static{
        this.MAXIMUM_VALUE = 1000;
    }
    constructor(){
        super(53 /* EditorOption.fontWeight */ , "fontWeight", EDITOR_FONT_DEFAULTS.fontWeight, {
            anyOf: [
                {
                    type: "number",
                    minimum: EditorFontWeight.MINIMUM_VALUE,
                    maximum: EditorFontWeight.MAXIMUM_VALUE,
                    errorMessage: _nlsJs.localize("fontWeightErrorMessage", 'Only "normal" and "bold" keywords or numbers between 1 and 1000 are allowed.')
                },
                {
                    type: "string",
                    pattern: "^(normal|bold|1000|[1-9][0-9]{0,2})$"
                },
                {
                    enum: EditorFontWeight.SUGGESTION_VALUES
                }
            ],
            default: EDITOR_FONT_DEFAULTS.fontWeight,
            description: _nlsJs.localize("fontWeight", 'Controls the font weight. Accepts "normal" and "bold" keywords or numbers between 1 and 1000.')
        });
    }
    validate(input) {
        if (input === "normal" || input === "bold") return input;
        return String(EditorIntOption.clampedInt(input, EDITOR_FONT_DEFAULTS.fontWeight, EditorFontWeight.MINIMUM_VALUE, EditorFontWeight.MAXIMUM_VALUE));
    }
}
class EditorGoToLocation extends BaseEditorOption {
    constructor(){
        const defaults = {
            multiple: "peek",
            multipleDefinitions: "peek",
            multipleTypeDefinitions: "peek",
            multipleDeclarations: "peek",
            multipleImplementations: "peek",
            multipleReferences: "peek",
            multipleTests: "peek",
            alternativeDefinitionCommand: "editor.action.goToReferences",
            alternativeTypeDefinitionCommand: "editor.action.goToReferences",
            alternativeDeclarationCommand: "editor.action.goToReferences",
            alternativeImplementationCommand: "",
            alternativeReferenceCommand: "",
            alternativeTestsCommand: ""
        };
        const jsonSubset = {
            type: "string",
            enum: [
                "peek",
                "gotoAndPeek",
                "goto"
            ],
            default: defaults.multiple,
            enumDescriptions: [
                _nlsJs.localize("editor.gotoLocation.multiple.peek", "Show Peek view of the results (default)"),
                _nlsJs.localize("editor.gotoLocation.multiple.gotoAndPeek", "Go to the primary result and show a Peek view"),
                _nlsJs.localize("editor.gotoLocation.multiple.goto", "Go to the primary result and enable Peek-less navigation to others")
            ]
        };
        const alternativeCommandOptions = [
            "",
            "editor.action.referenceSearch.trigger",
            "editor.action.goToReferences",
            "editor.action.peekImplementation",
            "editor.action.goToImplementation",
            "editor.action.peekTypeDefinition",
            "editor.action.goToTypeDefinition",
            "editor.action.peekDeclaration",
            "editor.action.revealDeclaration",
            "editor.action.peekDefinition",
            "editor.action.revealDefinitionAside",
            "editor.action.revealDefinition"
        ];
        super(58 /* EditorOption.gotoLocation */ , "gotoLocation", defaults, {
            "editor.gotoLocation.multiple": {
                deprecationMessage: _nlsJs.localize("editor.gotoLocation.multiple.deprecated", "This setting is deprecated, please use separate settings like 'editor.editor.gotoLocation.multipleDefinitions' or 'editor.editor.gotoLocation.multipleImplementations' instead.")
            },
            "editor.gotoLocation.multipleDefinitions": {
                description: _nlsJs.localize("editor.editor.gotoLocation.multipleDefinitions", "Controls the behavior the 'Go to Definition'-command when multiple target locations exist."),
                ...jsonSubset
            },
            "editor.gotoLocation.multipleTypeDefinitions": {
                description: _nlsJs.localize("editor.editor.gotoLocation.multipleTypeDefinitions", "Controls the behavior the 'Go to Type Definition'-command when multiple target locations exist."),
                ...jsonSubset
            },
            "editor.gotoLocation.multipleDeclarations": {
                description: _nlsJs.localize("editor.editor.gotoLocation.multipleDeclarations", "Controls the behavior the 'Go to Declaration'-command when multiple target locations exist."),
                ...jsonSubset
            },
            "editor.gotoLocation.multipleImplementations": {
                description: _nlsJs.localize("editor.editor.gotoLocation.multipleImplemenattions", "Controls the behavior the 'Go to Implementations'-command when multiple target locations exist."),
                ...jsonSubset
            },
            "editor.gotoLocation.multipleReferences": {
                description: _nlsJs.localize("editor.editor.gotoLocation.multipleReferences", "Controls the behavior the 'Go to References'-command when multiple target locations exist."),
                ...jsonSubset
            },
            "editor.gotoLocation.alternativeDefinitionCommand": {
                type: "string",
                default: defaults.alternativeDefinitionCommand,
                enum: alternativeCommandOptions,
                description: _nlsJs.localize("alternativeDefinitionCommand", "Alternative command id that is being executed when the result of 'Go to Definition' is the current location.")
            },
            "editor.gotoLocation.alternativeTypeDefinitionCommand": {
                type: "string",
                default: defaults.alternativeTypeDefinitionCommand,
                enum: alternativeCommandOptions,
                description: _nlsJs.localize("alternativeTypeDefinitionCommand", "Alternative command id that is being executed when the result of 'Go to Type Definition' is the current location.")
            },
            "editor.gotoLocation.alternativeDeclarationCommand": {
                type: "string",
                default: defaults.alternativeDeclarationCommand,
                enum: alternativeCommandOptions,
                description: _nlsJs.localize("alternativeDeclarationCommand", "Alternative command id that is being executed when the result of 'Go to Declaration' is the current location.")
            },
            "editor.gotoLocation.alternativeImplementationCommand": {
                type: "string",
                default: defaults.alternativeImplementationCommand,
                enum: alternativeCommandOptions,
                description: _nlsJs.localize("alternativeImplementationCommand", "Alternative command id that is being executed when the result of 'Go to Implementation' is the current location.")
            },
            "editor.gotoLocation.alternativeReferenceCommand": {
                type: "string",
                default: defaults.alternativeReferenceCommand,
                enum: alternativeCommandOptions,
                description: _nlsJs.localize("alternativeReferenceCommand", "Alternative command id that is being executed when the result of 'Go to Reference' is the current location.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            multiple: stringSet(input.multiple, this.defaultValue.multiple, [
                "peek",
                "gotoAndPeek",
                "goto"
            ]),
            multipleDefinitions: input.multipleDefinitions ?? stringSet(input.multipleDefinitions, "peek", [
                "peek",
                "gotoAndPeek",
                "goto"
            ]),
            multipleTypeDefinitions: input.multipleTypeDefinitions ?? stringSet(input.multipleTypeDefinitions, "peek", [
                "peek",
                "gotoAndPeek",
                "goto"
            ]),
            multipleDeclarations: input.multipleDeclarations ?? stringSet(input.multipleDeclarations, "peek", [
                "peek",
                "gotoAndPeek",
                "goto"
            ]),
            multipleImplementations: input.multipleImplementations ?? stringSet(input.multipleImplementations, "peek", [
                "peek",
                "gotoAndPeek",
                "goto"
            ]),
            multipleReferences: input.multipleReferences ?? stringSet(input.multipleReferences, "peek", [
                "peek",
                "gotoAndPeek",
                "goto"
            ]),
            multipleTests: input.multipleTests ?? stringSet(input.multipleTests, "peek", [
                "peek",
                "gotoAndPeek",
                "goto"
            ]),
            alternativeDefinitionCommand: EditorStringOption.string(input.alternativeDefinitionCommand, this.defaultValue.alternativeDefinitionCommand),
            alternativeTypeDefinitionCommand: EditorStringOption.string(input.alternativeTypeDefinitionCommand, this.defaultValue.alternativeTypeDefinitionCommand),
            alternativeDeclarationCommand: EditorStringOption.string(input.alternativeDeclarationCommand, this.defaultValue.alternativeDeclarationCommand),
            alternativeImplementationCommand: EditorStringOption.string(input.alternativeImplementationCommand, this.defaultValue.alternativeImplementationCommand),
            alternativeReferenceCommand: EditorStringOption.string(input.alternativeReferenceCommand, this.defaultValue.alternativeReferenceCommand),
            alternativeTestsCommand: EditorStringOption.string(input.alternativeTestsCommand, this.defaultValue.alternativeTestsCommand)
        };
    }
}
class EditorHover extends BaseEditorOption {
    constructor(){
        const defaults = {
            enabled: true,
            delay: 300,
            hidingDelay: 300,
            sticky: true,
            above: true
        };
        super(60 /* EditorOption.hover */ , "hover", defaults, {
            "editor.hover.enabled": {
                type: "boolean",
                default: defaults.enabled,
                description: _nlsJs.localize("hover.enabled", "Controls whether the hover is shown.")
            },
            "editor.hover.delay": {
                type: "number",
                default: defaults.delay,
                minimum: 0,
                maximum: 10000,
                description: _nlsJs.localize("hover.delay", "Controls the delay in milliseconds after which the hover is shown.")
            },
            "editor.hover.sticky": {
                type: "boolean",
                default: defaults.sticky,
                description: _nlsJs.localize("hover.sticky", "Controls whether the hover should remain visible when mouse is moved over it.")
            },
            "editor.hover.hidingDelay": {
                type: "integer",
                minimum: 0,
                default: defaults.hidingDelay,
                description: _nlsJs.localize("hover.hidingDelay", "Controls the delay in milliseconds after which the hover is hidden. Requires `editor.hover.sticky` to be enabled.")
            },
            "editor.hover.above": {
                type: "boolean",
                default: defaults.above,
                description: _nlsJs.localize("hover.above", "Prefer showing hovers above the line, if there's space.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            enabled: boolean(input.enabled, this.defaultValue.enabled),
            delay: EditorIntOption.clampedInt(input.delay, this.defaultValue.delay, 0, 10000),
            sticky: boolean(input.sticky, this.defaultValue.sticky),
            hidingDelay: EditorIntOption.clampedInt(input.hidingDelay, this.defaultValue.hidingDelay, 0, 600000),
            above: boolean(input.above, this.defaultValue.above)
        };
    }
}
class EditorLayoutInfoComputer extends ComputedEditorOption {
    constructor(){
        super(146 /* EditorOption.layoutInfo */ );
    }
    compute(env, options, _) {
        return EditorLayoutInfoComputer.computeLayout(options, {
            memory: env.memory,
            outerWidth: env.outerWidth,
            outerHeight: env.outerHeight,
            isDominatedByLongLines: env.isDominatedByLongLines,
            lineHeight: env.fontInfo.lineHeight,
            viewLineCount: env.viewLineCount,
            lineNumbersDigitCount: env.lineNumbersDigitCount,
            typicalHalfwidthCharacterWidth: env.fontInfo.typicalHalfwidthCharacterWidth,
            maxDigitWidth: env.fontInfo.maxDigitWidth,
            pixelRatio: env.pixelRatio,
            glyphMarginDecorationLaneCount: env.glyphMarginDecorationLaneCount
        });
    }
    static computeContainedMinimapLineCount(input) {
        const typicalViewportLineCount = input.height / input.lineHeight;
        const extraLinesBeforeFirstLine = Math.floor(input.paddingTop / input.lineHeight);
        let extraLinesBeyondLastLine = Math.floor(input.paddingBottom / input.lineHeight);
        if (input.scrollBeyondLastLine) extraLinesBeyondLastLine = Math.max(extraLinesBeyondLastLine, typicalViewportLineCount - 1);
        const desiredRatio = (extraLinesBeforeFirstLine + input.viewLineCount + extraLinesBeyondLastLine) / (input.pixelRatio * input.height);
        const minimapLineCount = Math.floor(input.viewLineCount / desiredRatio);
        return {
            typicalViewportLineCount,
            extraLinesBeforeFirstLine,
            extraLinesBeyondLastLine,
            desiredRatio,
            minimapLineCount
        };
    }
    static _computeMinimapLayout(input, memory) {
        const outerWidth = input.outerWidth;
        const outerHeight = input.outerHeight;
        const pixelRatio = input.pixelRatio;
        if (!input.minimap.enabled) return {
            renderMinimap: 0 /* RenderMinimap.None */ ,
            minimapLeft: 0,
            minimapWidth: 0,
            minimapHeightIsEditorHeight: false,
            minimapIsSampling: false,
            minimapScale: 1,
            minimapLineHeight: 1,
            minimapCanvasInnerWidth: 0,
            minimapCanvasInnerHeight: Math.floor(pixelRatio * outerHeight),
            minimapCanvasOuterWidth: 0,
            minimapCanvasOuterHeight: outerHeight
        };
        // Can use memory if only the `viewLineCount` and `remainingWidth` have changed
        const stableMinimapLayoutInput = memory.stableMinimapLayoutInput;
        const couldUseMemory = stableMinimapLayoutInput && input.outerHeight === stableMinimapLayoutInput.outerHeight && input.lineHeight === stableMinimapLayoutInput.lineHeight && input.typicalHalfwidthCharacterWidth === stableMinimapLayoutInput.typicalHalfwidthCharacterWidth && input.pixelRatio === stableMinimapLayoutInput.pixelRatio && input.scrollBeyondLastLine === stableMinimapLayoutInput.scrollBeyondLastLine && input.paddingTop === stableMinimapLayoutInput.paddingTop && input.paddingBottom === stableMinimapLayoutInput.paddingBottom && input.minimap.enabled === stableMinimapLayoutInput.minimap.enabled && input.minimap.side === stableMinimapLayoutInput.minimap.side && input.minimap.size === stableMinimapLayoutInput.minimap.size && input.minimap.showSlider === stableMinimapLayoutInput.minimap.showSlider && input.minimap.renderCharacters === stableMinimapLayoutInput.minimap.renderCharacters && input.minimap.maxColumn === stableMinimapLayoutInput.minimap.maxColumn && input.minimap.scale === stableMinimapLayoutInput.minimap.scale && input.verticalScrollbarWidth === stableMinimapLayoutInput.verticalScrollbarWidth && input.isViewportWrapping === stableMinimapLayoutInput.isViewportWrapping;
        const lineHeight = input.lineHeight;
        const typicalHalfwidthCharacterWidth = input.typicalHalfwidthCharacterWidth;
        const scrollBeyondLastLine = input.scrollBeyondLastLine;
        const minimapRenderCharacters = input.minimap.renderCharacters;
        let minimapScale = pixelRatio >= 2 ? Math.round(input.minimap.scale * 2) : input.minimap.scale;
        const minimapMaxColumn = input.minimap.maxColumn;
        const minimapSize = input.minimap.size;
        const minimapSide = input.minimap.side;
        const verticalScrollbarWidth = input.verticalScrollbarWidth;
        const viewLineCount = input.viewLineCount;
        const remainingWidth = input.remainingWidth;
        const isViewportWrapping = input.isViewportWrapping;
        const baseCharHeight = minimapRenderCharacters ? 2 : 3;
        let minimapCanvasInnerHeight = Math.floor(pixelRatio * outerHeight);
        const minimapCanvasOuterHeight = minimapCanvasInnerHeight / pixelRatio;
        let minimapHeightIsEditorHeight = false;
        let minimapIsSampling = false;
        let minimapLineHeight = baseCharHeight * minimapScale;
        let minimapCharWidth = minimapScale / pixelRatio;
        let minimapWidthMultiplier = 1;
        if (minimapSize === "fill" || minimapSize === "fit") {
            const { typicalViewportLineCount, extraLinesBeforeFirstLine, extraLinesBeyondLastLine, desiredRatio, minimapLineCount } = EditorLayoutInfoComputer.computeContainedMinimapLineCount({
                viewLineCount: viewLineCount,
                scrollBeyondLastLine: scrollBeyondLastLine,
                paddingTop: input.paddingTop,
                paddingBottom: input.paddingBottom,
                height: outerHeight,
                lineHeight: lineHeight,
                pixelRatio: pixelRatio
            });
            // ratio is intentionally not part of the layout to avoid the layout changing all the time
            // when doing sampling
            const ratio = viewLineCount / minimapLineCount;
            if (ratio > 1) {
                minimapHeightIsEditorHeight = true;
                minimapIsSampling = true;
                minimapScale = 1;
                minimapLineHeight = 1;
                minimapCharWidth = minimapScale / pixelRatio;
            } else {
                let fitBecomesFill = false;
                let maxMinimapScale = minimapScale + 1;
                if (minimapSize === "fit") {
                    const effectiveMinimapHeight = Math.ceil((extraLinesBeforeFirstLine + viewLineCount + extraLinesBeyondLastLine) * minimapLineHeight);
                    if (isViewportWrapping && couldUseMemory && remainingWidth <= memory.stableFitRemainingWidth) {
                        // There is a loop when using `fit` and viewport wrapping:
                        // - view line count impacts minimap layout
                        // - minimap layout impacts viewport width
                        // - viewport width impacts view line count
                        // To break the loop, once we go to a smaller minimap scale, we try to stick with it.
                        fitBecomesFill = true;
                        maxMinimapScale = memory.stableFitMaxMinimapScale;
                    } else fitBecomesFill = effectiveMinimapHeight > minimapCanvasInnerHeight;
                }
                if (minimapSize === "fill" || fitBecomesFill) {
                    minimapHeightIsEditorHeight = true;
                    const configuredMinimapScale = minimapScale;
                    minimapLineHeight = Math.min(lineHeight * pixelRatio, Math.max(1, Math.floor(1 / desiredRatio)));
                    if (isViewportWrapping && couldUseMemory && remainingWidth <= memory.stableFitRemainingWidth) // There is a loop when using `fill` and viewport wrapping:
                    // - view line count impacts minimap layout
                    // - minimap layout impacts viewport width
                    // - viewport width impacts view line count
                    // To break the loop, once we go to a smaller minimap scale, we try to stick with it.
                    maxMinimapScale = memory.stableFitMaxMinimapScale;
                    minimapScale = Math.min(maxMinimapScale, Math.max(1, Math.floor(minimapLineHeight / baseCharHeight)));
                    if (minimapScale > configuredMinimapScale) minimapWidthMultiplier = Math.min(2, minimapScale / configuredMinimapScale);
                    minimapCharWidth = minimapScale / pixelRatio / minimapWidthMultiplier;
                    minimapCanvasInnerHeight = Math.ceil(Math.max(typicalViewportLineCount, extraLinesBeforeFirstLine + viewLineCount + extraLinesBeyondLastLine) * minimapLineHeight);
                    if (isViewportWrapping) {
                        // remember for next time
                        memory.stableMinimapLayoutInput = input;
                        memory.stableFitRemainingWidth = remainingWidth;
                        memory.stableFitMaxMinimapScale = minimapScale;
                    } else {
                        memory.stableMinimapLayoutInput = null;
                        memory.stableFitRemainingWidth = 0;
                    }
                }
            }
        }
        // Given:
        // (leaving 2px for the cursor to have space after the last character)
        // viewportColumn = (contentWidth - verticalScrollbarWidth - 2) / typicalHalfwidthCharacterWidth
        // minimapWidth = viewportColumn * minimapCharWidth
        // contentWidth = remainingWidth - minimapWidth
        // What are good values for contentWidth and minimapWidth ?
        // minimapWidth = ((contentWidth - verticalScrollbarWidth - 2) / typicalHalfwidthCharacterWidth) * minimapCharWidth
        // typicalHalfwidthCharacterWidth * minimapWidth = (contentWidth - verticalScrollbarWidth - 2) * minimapCharWidth
        // typicalHalfwidthCharacterWidth * minimapWidth = (remainingWidth - minimapWidth - verticalScrollbarWidth - 2) * minimapCharWidth
        // (typicalHalfwidthCharacterWidth + minimapCharWidth) * minimapWidth = (remainingWidth - verticalScrollbarWidth - 2) * minimapCharWidth
        // minimapWidth = ((remainingWidth - verticalScrollbarWidth - 2) * minimapCharWidth) / (typicalHalfwidthCharacterWidth + minimapCharWidth)
        const minimapMaxWidth = Math.floor(minimapMaxColumn * minimapCharWidth);
        const minimapWidth = Math.min(minimapMaxWidth, Math.max(0, Math.floor((remainingWidth - verticalScrollbarWidth - 2) * minimapCharWidth / (typicalHalfwidthCharacterWidth + minimapCharWidth))) + MINIMAP_GUTTER_WIDTH);
        let minimapCanvasInnerWidth = Math.floor(pixelRatio * minimapWidth);
        const minimapCanvasOuterWidth = minimapCanvasInnerWidth / pixelRatio;
        minimapCanvasInnerWidth = Math.floor(minimapCanvasInnerWidth * minimapWidthMultiplier);
        const renderMinimap = minimapRenderCharacters ? 1 /* RenderMinimap.Text */  : 2 /* RenderMinimap.Blocks */ ;
        const minimapLeft = minimapSide === "left" ? 0 : outerWidth - minimapWidth - verticalScrollbarWidth;
        return {
            renderMinimap,
            minimapLeft,
            minimapWidth,
            minimapHeightIsEditorHeight,
            minimapIsSampling,
            minimapScale,
            minimapLineHeight,
            minimapCanvasInnerWidth,
            minimapCanvasInnerHeight,
            minimapCanvasOuterWidth,
            minimapCanvasOuterHeight
        };
    }
    static computeLayout(options, env) {
        const outerWidth = env.outerWidth | 0;
        const outerHeight = env.outerHeight | 0;
        const lineHeight = env.lineHeight | 0;
        const lineNumbersDigitCount = env.lineNumbersDigitCount | 0;
        const typicalHalfwidthCharacterWidth = env.typicalHalfwidthCharacterWidth;
        const maxDigitWidth = env.maxDigitWidth;
        const pixelRatio = env.pixelRatio;
        const viewLineCount = env.viewLineCount;
        const wordWrapOverride2 = options.get(138 /* EditorOption.wordWrapOverride2 */ );
        const wordWrapOverride1 = wordWrapOverride2 === "inherit" ? options.get(137 /* EditorOption.wordWrapOverride1 */ ) : wordWrapOverride2;
        const wordWrap = wordWrapOverride1 === "inherit" ? options.get(133 /* EditorOption.wordWrap */ ) : wordWrapOverride1;
        const wordWrapColumn = options.get(136 /* EditorOption.wordWrapColumn */ );
        const isDominatedByLongLines = env.isDominatedByLongLines;
        const showGlyphMargin = options.get(57 /* EditorOption.glyphMargin */ );
        const showLineNumbers = options.get(68 /* EditorOption.lineNumbers */ ).renderType !== 0 /* RenderLineNumbersType.Off */ ;
        const lineNumbersMinChars = options.get(69 /* EditorOption.lineNumbersMinChars */ );
        const scrollBeyondLastLine = options.get(106 /* EditorOption.scrollBeyondLastLine */ );
        const padding = options.get(84 /* EditorOption.padding */ );
        const minimap = options.get(73 /* EditorOption.minimap */ );
        const scrollbar = options.get(104 /* EditorOption.scrollbar */ );
        const verticalScrollbarWidth = scrollbar.verticalScrollbarSize;
        const verticalScrollbarHasArrows = scrollbar.verticalHasArrows;
        const scrollbarArrowSize = scrollbar.arrowSize;
        const horizontalScrollbarHeight = scrollbar.horizontalScrollbarSize;
        const folding = options.get(43 /* EditorOption.folding */ );
        const showFoldingDecoration = options.get(111 /* EditorOption.showFoldingControls */ ) !== "never";
        let lineDecorationsWidth = options.get(66 /* EditorOption.lineDecorationsWidth */ );
        if (folding && showFoldingDecoration) lineDecorationsWidth += 16;
        let lineNumbersWidth = 0;
        if (showLineNumbers) {
            const digitCount = Math.max(lineNumbersDigitCount, lineNumbersMinChars);
            lineNumbersWidth = Math.round(digitCount * maxDigitWidth);
        }
        let glyphMarginWidth = 0;
        if (showGlyphMargin) glyphMarginWidth = lineHeight * env.glyphMarginDecorationLaneCount;
        let glyphMarginLeft = 0;
        let lineNumbersLeft = glyphMarginLeft + glyphMarginWidth;
        let decorationsLeft = lineNumbersLeft + lineNumbersWidth;
        let contentLeft = decorationsLeft + lineDecorationsWidth;
        const remainingWidth = outerWidth - glyphMarginWidth - lineNumbersWidth - lineDecorationsWidth;
        let isWordWrapMinified = false;
        let isViewportWrapping = false;
        let wrappingColumn = -1;
        if (wordWrapOverride1 === "inherit" && isDominatedByLongLines) {
            // Force viewport width wrapping if model is dominated by long lines
            isWordWrapMinified = true;
            isViewportWrapping = true;
        } else if (wordWrap === "on" || wordWrap === "bounded") isViewportWrapping = true;
        else if (wordWrap === "wordWrapColumn") wrappingColumn = wordWrapColumn;
        const minimapLayout = EditorLayoutInfoComputer._computeMinimapLayout({
            outerWidth: outerWidth,
            outerHeight: outerHeight,
            lineHeight: lineHeight,
            typicalHalfwidthCharacterWidth: typicalHalfwidthCharacterWidth,
            pixelRatio: pixelRatio,
            scrollBeyondLastLine: scrollBeyondLastLine,
            paddingTop: padding.top,
            paddingBottom: padding.bottom,
            minimap: minimap,
            verticalScrollbarWidth: verticalScrollbarWidth,
            viewLineCount: viewLineCount,
            remainingWidth: remainingWidth,
            isViewportWrapping: isViewportWrapping
        }, env.memory || new ComputeOptionsMemory());
        if (minimapLayout.renderMinimap !== 0 /* RenderMinimap.None */  && minimapLayout.minimapLeft === 0) {
            // the minimap is rendered to the left, so move everything to the right
            glyphMarginLeft += minimapLayout.minimapWidth;
            lineNumbersLeft += minimapLayout.minimapWidth;
            decorationsLeft += minimapLayout.minimapWidth;
            contentLeft += minimapLayout.minimapWidth;
        }
        const contentWidth = remainingWidth - minimapLayout.minimapWidth;
        // (leaving 2px for the cursor to have space after the last character)
        const viewportColumn = Math.max(1, Math.floor((contentWidth - verticalScrollbarWidth - 2) / typicalHalfwidthCharacterWidth));
        const verticalArrowSize = verticalScrollbarHasArrows ? scrollbarArrowSize : 0;
        if (isViewportWrapping) {
            // compute the actual wrappingColumn
            wrappingColumn = Math.max(1, viewportColumn);
            if (wordWrap === "bounded") wrappingColumn = Math.min(wrappingColumn, wordWrapColumn);
        }
        return {
            width: outerWidth,
            height: outerHeight,
            glyphMarginLeft: glyphMarginLeft,
            glyphMarginWidth: glyphMarginWidth,
            glyphMarginDecorationLaneCount: env.glyphMarginDecorationLaneCount,
            lineNumbersLeft: lineNumbersLeft,
            lineNumbersWidth: lineNumbersWidth,
            decorationsLeft: decorationsLeft,
            decorationsWidth: lineDecorationsWidth,
            contentLeft: contentLeft,
            contentWidth: contentWidth,
            minimap: minimapLayout,
            viewportColumn: viewportColumn,
            isWordWrapMinified: isWordWrapMinified,
            isViewportWrapping: isViewportWrapping,
            wrappingColumn: wrappingColumn,
            verticalScrollbarWidth: verticalScrollbarWidth,
            horizontalScrollbarHeight: horizontalScrollbarHeight,
            overviewRuler: {
                top: verticalArrowSize,
                width: verticalScrollbarWidth,
                height: outerHeight - 2 * verticalArrowSize,
                right: 0
            }
        };
    }
}
//#endregion
//#region WrappingStrategy
class WrappingStrategy extends BaseEditorOption {
    constructor(){
        super(140 /* EditorOption.wrappingStrategy */ , "wrappingStrategy", "simple", {
            "editor.wrappingStrategy": {
                enumDescriptions: [
                    _nlsJs.localize("wrappingStrategy.simple", "Assumes that all characters are of the same width. This is a fast algorithm that works correctly for monospace fonts and certain scripts (like Latin characters) where glyphs are of equal width."),
                    _nlsJs.localize("wrappingStrategy.advanced", "Delegates wrapping points computation to the browser. This is a slow algorithm, that might cause freezes for large files, but it works correctly in all cases.")
                ],
                type: "string",
                enum: [
                    "simple",
                    "advanced"
                ],
                default: "simple",
                description: _nlsJs.localize("wrappingStrategy", "Controls the algorithm that computes wrapping points. Note that when in accessibility mode, advanced will be used for the best experience.")
            }
        });
    }
    validate(input) {
        return stringSet(input, "simple", [
            "simple",
            "advanced"
        ]);
    }
    compute(env, options, value) {
        const accessibilitySupport = options.get(2 /* EditorOption.accessibilitySupport */ );
        if (accessibilitySupport === 2 /* AccessibilitySupport.Enabled */ ) // if we know for a fact that a screen reader is attached, we switch our strategy to advanced to
        // help that the editor's wrapping points match the textarea's wrapping points
        return "advanced";
        return value;
    }
}
var ShowLightbulbIconMode;
(function(ShowLightbulbIconMode) {
    ShowLightbulbIconMode["Off"] = "off";
    ShowLightbulbIconMode["OnCode"] = "onCode";
    ShowLightbulbIconMode["On"] = "on";
})(ShowLightbulbIconMode || (ShowLightbulbIconMode = {}));
class EditorLightbulb extends BaseEditorOption {
    constructor(){
        const defaults = {
            enabled: ShowLightbulbIconMode.OnCode
        };
        super(65 /* EditorOption.lightbulb */ , "lightbulb", defaults, {
            "editor.lightbulb.enabled": {
                type: "string",
                tags: [
                    "experimental"
                ],
                enum: [
                    ShowLightbulbIconMode.Off,
                    ShowLightbulbIconMode.OnCode,
                    ShowLightbulbIconMode.On
                ],
                default: defaults.enabled,
                enumDescriptions: [
                    _nlsJs.localize("editor.lightbulb.enabled.off", "Disable the code action menu."),
                    _nlsJs.localize("editor.lightbulb.enabled.onCode", "Show the code action menu when the cursor is on lines with code."),
                    _nlsJs.localize("editor.lightbulb.enabled.on", "Show the code action menu when the cursor is on lines with code or on empty lines.")
                ],
                description: _nlsJs.localize("enabled", "Enables the Code Action lightbulb in the editor.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            enabled: stringSet(input.enabled, this.defaultValue.enabled, [
                ShowLightbulbIconMode.Off,
                ShowLightbulbIconMode.OnCode,
                ShowLightbulbIconMode.On
            ])
        };
    }
}
class EditorStickyScroll extends BaseEditorOption {
    constructor(){
        const defaults = {
            enabled: true,
            maxLineCount: 5,
            defaultModel: "outlineModel",
            scrollWithEditor: true
        };
        super(116 /* EditorOption.stickyScroll */ , "stickyScroll", defaults, {
            "editor.stickyScroll.enabled": {
                type: "boolean",
                default: defaults.enabled,
                description: _nlsJs.localize("editor.stickyScroll.enabled", "Shows the nested current scopes during the scroll at the top of the editor."),
                tags: [
                    "experimental"
                ]
            },
            "editor.stickyScroll.maxLineCount": {
                type: "number",
                default: defaults.maxLineCount,
                minimum: 1,
                maximum: 20,
                description: _nlsJs.localize("editor.stickyScroll.maxLineCount", "Defines the maximum number of sticky lines to show.")
            },
            "editor.stickyScroll.defaultModel": {
                type: "string",
                enum: [
                    "outlineModel",
                    "foldingProviderModel",
                    "indentationModel"
                ],
                default: defaults.defaultModel,
                description: _nlsJs.localize("editor.stickyScroll.defaultModel", "Defines the model to use for determining which lines to stick. If the outline model does not exist, it will fall back on the folding provider model which falls back on the indentation model. This order is respected in all three cases.")
            },
            "editor.stickyScroll.scrollWithEditor": {
                type: "boolean",
                default: defaults.scrollWithEditor,
                description: _nlsJs.localize("editor.stickyScroll.scrollWithEditor", "Enable scrolling of Sticky Scroll with the editor's horizontal scrollbar.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            enabled: boolean(input.enabled, this.defaultValue.enabled),
            maxLineCount: EditorIntOption.clampedInt(input.maxLineCount, this.defaultValue.maxLineCount, 1, 20),
            defaultModel: stringSet(input.defaultModel, this.defaultValue.defaultModel, [
                "outlineModel",
                "foldingProviderModel",
                "indentationModel"
            ]),
            scrollWithEditor: boolean(input.scrollWithEditor, this.defaultValue.scrollWithEditor)
        };
    }
}
class EditorInlayHints extends BaseEditorOption {
    constructor(){
        const defaults = {
            enabled: "on",
            fontSize: 0,
            fontFamily: "",
            padding: false
        };
        super(142 /* EditorOption.inlayHints */ , "inlayHints", defaults, {
            "editor.inlayHints.enabled": {
                type: "string",
                default: defaults.enabled,
                description: _nlsJs.localize("inlayHints.enable", "Enables the inlay hints in the editor."),
                enum: [
                    "on",
                    "onUnlessPressed",
                    "offUnlessPressed",
                    "off"
                ],
                markdownEnumDescriptions: [
                    _nlsJs.localize("editor.inlayHints.on", "Inlay hints are enabled"),
                    _nlsJs.localize("editor.inlayHints.onUnlessPressed", "Inlay hints are showing by default and hide when holding {0}", _platformJs.isMacintosh ? `Ctrl+Option` : `Ctrl+Alt`),
                    _nlsJs.localize("editor.inlayHints.offUnlessPressed", "Inlay hints are hidden by default and show when holding {0}", _platformJs.isMacintosh ? `Ctrl+Option` : `Ctrl+Alt`),
                    _nlsJs.localize("editor.inlayHints.off", "Inlay hints are disabled")
                ]
            },
            "editor.inlayHints.fontSize": {
                type: "number",
                default: defaults.fontSize,
                markdownDescription: _nlsJs.localize("inlayHints.fontSize", "Controls font size of inlay hints in the editor. As default the {0} is used when the configured value is less than {1} or greater than the editor font size.", "`#editor.fontSize#`", "`5`")
            },
            "editor.inlayHints.fontFamily": {
                type: "string",
                default: defaults.fontFamily,
                markdownDescription: _nlsJs.localize("inlayHints.fontFamily", "Controls font family of inlay hints in the editor. When set to empty, the {0} is used.", "`#editor.fontFamily#`")
            },
            "editor.inlayHints.padding": {
                type: "boolean",
                default: defaults.padding,
                description: _nlsJs.localize("inlayHints.padding", "Enables the padding around the inlay hints in the editor.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        if (typeof input.enabled === "boolean") input.enabled = input.enabled ? "on" : "off";
        return {
            enabled: stringSet(input.enabled, this.defaultValue.enabled, [
                "on",
                "off",
                "offUnlessPressed",
                "onUnlessPressed"
            ]),
            fontSize: EditorIntOption.clampedInt(input.fontSize, this.defaultValue.fontSize, 0, 100),
            fontFamily: EditorStringOption.string(input.fontFamily, this.defaultValue.fontFamily),
            padding: boolean(input.padding, this.defaultValue.padding)
        };
    }
}
//#endregion
//#region lineDecorationsWidth
class EditorLineDecorationsWidth extends BaseEditorOption {
    constructor(){
        super(66 /* EditorOption.lineDecorationsWidth */ , "lineDecorationsWidth", 10);
    }
    validate(input) {
        if (typeof input === "string" && /^\d+(\.\d+)?ch$/.test(input)) {
            const multiple = parseFloat(input.substring(0, input.length - 2));
            return -multiple; // negative numbers signal a multiple
        } else return EditorIntOption.clampedInt(input, this.defaultValue, 0, 1000);
    }
    compute(env, options, value) {
        if (value < 0) // negative numbers signal a multiple
        return EditorIntOption.clampedInt(-value * env.fontInfo.typicalHalfwidthCharacterWidth, this.defaultValue, 0, 1000);
        else return value;
    }
}
//#endregion
//#region lineHeight
class EditorLineHeight extends EditorFloatOption {
    constructor(){
        super(67 /* EditorOption.lineHeight */ , "lineHeight", EDITOR_FONT_DEFAULTS.lineHeight, (x)=>EditorFloatOption.clamp(x, 0, 150), {
            markdownDescription: _nlsJs.localize("lineHeight", "Controls the line height. \n - Use 0 to automatically compute the line height from the font size.\n - Values between 0 and 8 will be used as a multiplier with the font size.\n - Values greater than or equal to 8 will be used as effective values.")
        });
    }
    compute(env, options, value) {
        // The lineHeight is computed from the fontSize if it is 0.
        // Moreover, the final lineHeight respects the editor zoom level.
        // So take the result from env.fontInfo
        return env.fontInfo.lineHeight;
    }
}
class EditorMinimap extends BaseEditorOption {
    constructor(){
        const defaults = {
            enabled: true,
            size: "proportional",
            side: "right",
            showSlider: "mouseover",
            autohide: false,
            renderCharacters: true,
            maxColumn: 120,
            scale: 1,
            showRegionSectionHeaders: true,
            showMarkSectionHeaders: true,
            sectionHeaderFontSize: 9,
            sectionHeaderLetterSpacing: 1
        };
        super(73 /* EditorOption.minimap */ , "minimap", defaults, {
            "editor.minimap.enabled": {
                type: "boolean",
                default: defaults.enabled,
                description: _nlsJs.localize("minimap.enabled", "Controls whether the minimap is shown.")
            },
            "editor.minimap.autohide": {
                type: "boolean",
                default: defaults.autohide,
                description: _nlsJs.localize("minimap.autohide", "Controls whether the minimap is hidden automatically.")
            },
            "editor.minimap.size": {
                type: "string",
                enum: [
                    "proportional",
                    "fill",
                    "fit"
                ],
                enumDescriptions: [
                    _nlsJs.localize("minimap.size.proportional", "The minimap has the same size as the editor contents (and might scroll)."),
                    _nlsJs.localize("minimap.size.fill", "The minimap will stretch or shrink as necessary to fill the height of the editor (no scrolling)."),
                    _nlsJs.localize("minimap.size.fit", "The minimap will shrink as necessary to never be larger than the editor (no scrolling).")
                ],
                default: defaults.size,
                description: _nlsJs.localize("minimap.size", "Controls the size of the minimap.")
            },
            "editor.minimap.side": {
                type: "string",
                enum: [
                    "left",
                    "right"
                ],
                default: defaults.side,
                description: _nlsJs.localize("minimap.side", "Controls the side where to render the minimap.")
            },
            "editor.minimap.showSlider": {
                type: "string",
                enum: [
                    "always",
                    "mouseover"
                ],
                default: defaults.showSlider,
                description: _nlsJs.localize("minimap.showSlider", "Controls when the minimap slider is shown.")
            },
            "editor.minimap.scale": {
                type: "number",
                default: defaults.scale,
                minimum: 1,
                maximum: 3,
                enum: [
                    1,
                    2,
                    3
                ],
                description: _nlsJs.localize("minimap.scale", "Scale of content drawn in the minimap: 1, 2 or 3.")
            },
            "editor.minimap.renderCharacters": {
                type: "boolean",
                default: defaults.renderCharacters,
                description: _nlsJs.localize("minimap.renderCharacters", "Render the actual characters on a line as opposed to color blocks.")
            },
            "editor.minimap.maxColumn": {
                type: "number",
                default: defaults.maxColumn,
                description: _nlsJs.localize("minimap.maxColumn", "Limit the width of the minimap to render at most a certain number of columns.")
            },
            "editor.minimap.showRegionSectionHeaders": {
                type: "boolean",
                default: defaults.showRegionSectionHeaders,
                description: _nlsJs.localize("minimap.showRegionSectionHeaders", "Controls whether named regions are shown as section headers in the minimap.")
            },
            "editor.minimap.showMarkSectionHeaders": {
                type: "boolean",
                default: defaults.showMarkSectionHeaders,
                description: _nlsJs.localize("minimap.showMarkSectionHeaders", "Controls whether MARK: comments are shown as section headers in the minimap.")
            },
            "editor.minimap.sectionHeaderFontSize": {
                type: "number",
                default: defaults.sectionHeaderFontSize,
                description: _nlsJs.localize("minimap.sectionHeaderFontSize", "Controls the font size of section headers in the minimap.")
            },
            "editor.minimap.sectionHeaderLetterSpacing": {
                type: "number",
                default: defaults.sectionHeaderLetterSpacing,
                description: _nlsJs.localize("minimap.sectionHeaderLetterSpacing", "Controls the amount of space (in pixels) between characters of section header. This helps the readability of the header in small font sizes.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            enabled: boolean(input.enabled, this.defaultValue.enabled),
            autohide: boolean(input.autohide, this.defaultValue.autohide),
            size: stringSet(input.size, this.defaultValue.size, [
                "proportional",
                "fill",
                "fit"
            ]),
            side: stringSet(input.side, this.defaultValue.side, [
                "right",
                "left"
            ]),
            showSlider: stringSet(input.showSlider, this.defaultValue.showSlider, [
                "always",
                "mouseover"
            ]),
            renderCharacters: boolean(input.renderCharacters, this.defaultValue.renderCharacters),
            scale: EditorIntOption.clampedInt(input.scale, 1, 1, 3),
            maxColumn: EditorIntOption.clampedInt(input.maxColumn, this.defaultValue.maxColumn, 1, 10000),
            showRegionSectionHeaders: boolean(input.showRegionSectionHeaders, this.defaultValue.showRegionSectionHeaders),
            showMarkSectionHeaders: boolean(input.showMarkSectionHeaders, this.defaultValue.showMarkSectionHeaders),
            sectionHeaderFontSize: EditorFloatOption.clamp(input.sectionHeaderFontSize ?? this.defaultValue.sectionHeaderFontSize, 4, 32),
            sectionHeaderLetterSpacing: EditorFloatOption.clamp(input.sectionHeaderLetterSpacing ?? this.defaultValue.sectionHeaderLetterSpacing, 0, 5)
        };
    }
}
//#endregion
//#region multiCursorModifier
function _multiCursorModifierFromString(multiCursorModifier) {
    if (multiCursorModifier === "ctrlCmd") return _platformJs.isMacintosh ? "metaKey" : "ctrlKey";
    return "altKey";
}
class EditorPadding extends BaseEditorOption {
    constructor(){
        super(84 /* EditorOption.padding */ , "padding", {
            top: 0,
            bottom: 0
        }, {
            "editor.padding.top": {
                type: "number",
                default: 0,
                minimum: 0,
                maximum: 1000,
                description: _nlsJs.localize("padding.top", "Controls the amount of space between the top edge of the editor and the first line.")
            },
            "editor.padding.bottom": {
                type: "number",
                default: 0,
                minimum: 0,
                maximum: 1000,
                description: _nlsJs.localize("padding.bottom", "Controls the amount of space between the bottom edge of the editor and the last line.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            top: EditorIntOption.clampedInt(input.top, 0, 0, 1000),
            bottom: EditorIntOption.clampedInt(input.bottom, 0, 0, 1000)
        };
    }
}
class EditorParameterHints extends BaseEditorOption {
    constructor(){
        const defaults = {
            enabled: true,
            cycle: true
        };
        super(86 /* EditorOption.parameterHints */ , "parameterHints", defaults, {
            "editor.parameterHints.enabled": {
                type: "boolean",
                default: defaults.enabled,
                description: _nlsJs.localize("parameterHints.enabled", "Enables a pop-up that shows parameter documentation and type information as you type.")
            },
            "editor.parameterHints.cycle": {
                type: "boolean",
                default: defaults.cycle,
                description: _nlsJs.localize("parameterHints.cycle", "Controls whether the parameter hints menu cycles or closes when reaching the end of the list.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            enabled: boolean(input.enabled, this.defaultValue.enabled),
            cycle: boolean(input.cycle, this.defaultValue.cycle)
        };
    }
}
//#endregion
//#region pixelRatio
class EditorPixelRatio extends ComputedEditorOption {
    constructor(){
        super(144 /* EditorOption.pixelRatio */ );
    }
    compute(env, options, _) {
        return env.pixelRatio;
    }
}
//#endregion
//#region
class PlaceholderOption extends BaseEditorOption {
    constructor(){
        super(88 /* EditorOption.placeholder */ , "placeholder", undefined);
    }
    validate(input) {
        if (typeof input === "undefined") return this.defaultValue;
        if (typeof input === "string") return input;
        return this.defaultValue;
    }
}
class EditorQuickSuggestions extends BaseEditorOption {
    constructor(){
        const defaults = {
            other: "on",
            comments: "off",
            strings: "off"
        };
        const types = [
            {
                type: "boolean"
            },
            {
                type: "string",
                enum: [
                    "on",
                    "inline",
                    "off"
                ],
                enumDescriptions: [
                    _nlsJs.localize("on", "Quick suggestions show inside the suggest widget"),
                    _nlsJs.localize("inline", "Quick suggestions show as ghost text"),
                    _nlsJs.localize("off", "Quick suggestions are disabled")
                ]
            }
        ];
        super(90 /* EditorOption.quickSuggestions */ , "quickSuggestions", defaults, {
            type: "object",
            additionalProperties: false,
            properties: {
                strings: {
                    anyOf: types,
                    default: defaults.strings,
                    description: _nlsJs.localize("quickSuggestions.strings", "Enable quick suggestions inside strings.")
                },
                comments: {
                    anyOf: types,
                    default: defaults.comments,
                    description: _nlsJs.localize("quickSuggestions.comments", "Enable quick suggestions inside comments.")
                },
                other: {
                    anyOf: types,
                    default: defaults.other,
                    description: _nlsJs.localize("quickSuggestions.other", "Enable quick suggestions outside of strings and comments.")
                }
            },
            default: defaults,
            markdownDescription: _nlsJs.localize("quickSuggestions", "Controls whether suggestions should automatically show up while typing. This can be controlled for typing in comments, strings, and other code. Quick suggestion can be configured to show as ghost text or with the suggest widget. Also be aware of the {0}-setting which controls if suggestions are triggered by special characters.", "`#editor.suggestOnTriggerCharacters#`")
        });
        this.defaultValue = defaults;
    }
    validate(input) {
        if (typeof input === "boolean") {
            // boolean -> all on/off
            const value = input ? "on" : "off";
            return {
                comments: value,
                strings: value,
                other: value
            };
        }
        if (!input || typeof input !== "object") // invalid object
        return this.defaultValue;
        const { other, comments, strings } = input;
        const allowedValues = [
            "on",
            "inline",
            "off"
        ];
        let validatedOther;
        let validatedComments;
        let validatedStrings;
        if (typeof other === "boolean") validatedOther = other ? "on" : "off";
        else validatedOther = stringSet(other, this.defaultValue.other, allowedValues);
        if (typeof comments === "boolean") validatedComments = comments ? "on" : "off";
        else validatedComments = stringSet(comments, this.defaultValue.comments, allowedValues);
        if (typeof strings === "boolean") validatedStrings = strings ? "on" : "off";
        else validatedStrings = stringSet(strings, this.defaultValue.strings, allowedValues);
        return {
            other: validatedOther,
            comments: validatedComments,
            strings: validatedStrings
        };
    }
}
class EditorRenderLineNumbersOption extends BaseEditorOption {
    constructor(){
        super(68 /* EditorOption.lineNumbers */ , "lineNumbers", {
            renderType: 1 /* RenderLineNumbersType.On */ ,
            renderFn: null
        }, {
            type: "string",
            enum: [
                "off",
                "on",
                "relative",
                "interval"
            ],
            enumDescriptions: [
                _nlsJs.localize("lineNumbers.off", "Line numbers are not rendered."),
                _nlsJs.localize("lineNumbers.on", "Line numbers are rendered as absolute number."),
                _nlsJs.localize("lineNumbers.relative", "Line numbers are rendered as distance in lines to cursor position."),
                _nlsJs.localize("lineNumbers.interval", "Line numbers are rendered every 10 lines.")
            ],
            default: "on",
            description: _nlsJs.localize("lineNumbers", "Controls the display of line numbers.")
        });
    }
    validate(lineNumbers) {
        let renderType = this.defaultValue.renderType;
        let renderFn = this.defaultValue.renderFn;
        if (typeof lineNumbers !== "undefined") {
            if (typeof lineNumbers === "function") {
                renderType = 4 /* RenderLineNumbersType.Custom */ ;
                renderFn = lineNumbers;
            } else if (lineNumbers === "interval") renderType = 3 /* RenderLineNumbersType.Interval */ ;
            else if (lineNumbers === "relative") renderType = 2 /* RenderLineNumbersType.Relative */ ;
            else if (lineNumbers === "on") renderType = 1 /* RenderLineNumbersType.On */ ;
            else renderType = 0 /* RenderLineNumbersType.Off */ ;
        }
        return {
            renderType,
            renderFn
        };
    }
}
function filterValidationDecorations(options) {
    const renderValidationDecorations = options.get(99 /* EditorOption.renderValidationDecorations */ );
    if (renderValidationDecorations === "editable") return options.get(92 /* EditorOption.readOnly */ );
    return renderValidationDecorations === "on" ? false : true;
}
class EditorRulers extends BaseEditorOption {
    constructor(){
        const defaults = [];
        const columnSchema = {
            type: "number",
            description: _nlsJs.localize("rulers.size", "Number of monospace characters at which this editor ruler will render.")
        };
        super(103 /* EditorOption.rulers */ , "rulers", defaults, {
            type: "array",
            items: {
                anyOf: [
                    columnSchema,
                    {
                        type: [
                            "object"
                        ],
                        properties: {
                            column: columnSchema,
                            color: {
                                type: "string",
                                description: _nlsJs.localize("rulers.color", "Color of this editor ruler."),
                                format: "color-hex"
                            }
                        }
                    }
                ]
            },
            default: defaults,
            description: _nlsJs.localize("rulers", "Render vertical rulers after a certain number of monospace characters. Use multiple values for multiple rulers. No rulers are drawn if array is empty.")
        });
    }
    validate(input) {
        if (Array.isArray(input)) {
            const rulers = [];
            for (const _element of input){
                if (typeof _element === "number") rulers.push({
                    column: EditorIntOption.clampedInt(_element, 0, 0, 10000),
                    color: null
                });
                else if (_element && typeof _element === "object") {
                    const element = _element;
                    rulers.push({
                        column: EditorIntOption.clampedInt(element.column, 0, 0, 10000),
                        color: element.color
                    });
                }
            }
            rulers.sort((a, b)=>a.column - b.column);
            return rulers;
        }
        return this.defaultValue;
    }
}
//#endregion
//#region readonly
/**
 * Configuration options for readonly message
 */ class ReadonlyMessage extends BaseEditorOption {
    constructor(){
        const defaults = undefined;
        super(93 /* EditorOption.readOnlyMessage */ , "readOnlyMessage", defaults);
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        return _input;
    }
}
function _scrollbarVisibilityFromString(visibility, defaultValue) {
    if (typeof visibility !== "string") return defaultValue;
    switch(visibility){
        case "hidden":
            return 2 /* ScrollbarVisibility.Hidden */ ;
        case "visible":
            return 3 /* ScrollbarVisibility.Visible */ ;
        default:
            return 1 /* ScrollbarVisibility.Auto */ ;
    }
}
class EditorScrollbar extends BaseEditorOption {
    constructor(){
        const defaults = {
            vertical: 1 /* ScrollbarVisibility.Auto */ ,
            horizontal: 1 /* ScrollbarVisibility.Auto */ ,
            arrowSize: 11,
            useShadows: true,
            verticalHasArrows: false,
            horizontalHasArrows: false,
            horizontalScrollbarSize: 12,
            horizontalSliderSize: 12,
            verticalScrollbarSize: 14,
            verticalSliderSize: 14,
            handleMouseWheel: true,
            alwaysConsumeMouseWheel: true,
            scrollByPage: false,
            ignoreHorizontalScrollbarInContentHeight: false
        };
        super(104 /* EditorOption.scrollbar */ , "scrollbar", defaults, {
            "editor.scrollbar.vertical": {
                type: "string",
                enum: [
                    "auto",
                    "visible",
                    "hidden"
                ],
                enumDescriptions: [
                    _nlsJs.localize("scrollbar.vertical.auto", "The vertical scrollbar will be visible only when necessary."),
                    _nlsJs.localize("scrollbar.vertical.visible", "The vertical scrollbar will always be visible."),
                    _nlsJs.localize("scrollbar.vertical.fit", "The vertical scrollbar will always be hidden.")
                ],
                default: "auto",
                description: _nlsJs.localize("scrollbar.vertical", "Controls the visibility of the vertical scrollbar.")
            },
            "editor.scrollbar.horizontal": {
                type: "string",
                enum: [
                    "auto",
                    "visible",
                    "hidden"
                ],
                enumDescriptions: [
                    _nlsJs.localize("scrollbar.horizontal.auto", "The horizontal scrollbar will be visible only when necessary."),
                    _nlsJs.localize("scrollbar.horizontal.visible", "The horizontal scrollbar will always be visible."),
                    _nlsJs.localize("scrollbar.horizontal.fit", "The horizontal scrollbar will always be hidden.")
                ],
                default: "auto",
                description: _nlsJs.localize("scrollbar.horizontal", "Controls the visibility of the horizontal scrollbar.")
            },
            "editor.scrollbar.verticalScrollbarSize": {
                type: "number",
                default: defaults.verticalScrollbarSize,
                description: _nlsJs.localize("scrollbar.verticalScrollbarSize", "The width of the vertical scrollbar.")
            },
            "editor.scrollbar.horizontalScrollbarSize": {
                type: "number",
                default: defaults.horizontalScrollbarSize,
                description: _nlsJs.localize("scrollbar.horizontalScrollbarSize", "The height of the horizontal scrollbar.")
            },
            "editor.scrollbar.scrollByPage": {
                type: "boolean",
                default: defaults.scrollByPage,
                description: _nlsJs.localize("scrollbar.scrollByPage", "Controls whether clicks scroll by page or jump to click position.")
            },
            "editor.scrollbar.ignoreHorizontalScrollbarInContentHeight": {
                type: "boolean",
                default: defaults.ignoreHorizontalScrollbarInContentHeight,
                description: _nlsJs.localize("scrollbar.ignoreHorizontalScrollbarInContentHeight", "When set, the horizontal scrollbar will not increase the size of the editor's content.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        const horizontalScrollbarSize = EditorIntOption.clampedInt(input.horizontalScrollbarSize, this.defaultValue.horizontalScrollbarSize, 0, 1000);
        const verticalScrollbarSize = EditorIntOption.clampedInt(input.verticalScrollbarSize, this.defaultValue.verticalScrollbarSize, 0, 1000);
        return {
            arrowSize: EditorIntOption.clampedInt(input.arrowSize, this.defaultValue.arrowSize, 0, 1000),
            vertical: _scrollbarVisibilityFromString(input.vertical, this.defaultValue.vertical),
            horizontal: _scrollbarVisibilityFromString(input.horizontal, this.defaultValue.horizontal),
            useShadows: boolean(input.useShadows, this.defaultValue.useShadows),
            verticalHasArrows: boolean(input.verticalHasArrows, this.defaultValue.verticalHasArrows),
            horizontalHasArrows: boolean(input.horizontalHasArrows, this.defaultValue.horizontalHasArrows),
            handleMouseWheel: boolean(input.handleMouseWheel, this.defaultValue.handleMouseWheel),
            alwaysConsumeMouseWheel: boolean(input.alwaysConsumeMouseWheel, this.defaultValue.alwaysConsumeMouseWheel),
            horizontalScrollbarSize: horizontalScrollbarSize,
            horizontalSliderSize: EditorIntOption.clampedInt(input.horizontalSliderSize, horizontalScrollbarSize, 0, 1000),
            verticalScrollbarSize: verticalScrollbarSize,
            verticalSliderSize: EditorIntOption.clampedInt(input.verticalSliderSize, verticalScrollbarSize, 0, 1000),
            scrollByPage: boolean(input.scrollByPage, this.defaultValue.scrollByPage),
            ignoreHorizontalScrollbarInContentHeight: boolean(input.ignoreHorizontalScrollbarInContentHeight, this.defaultValue.ignoreHorizontalScrollbarInContentHeight)
        };
    }
}
const inUntrustedWorkspace = "inUntrustedWorkspace";
const unicodeHighlightConfigKeys = {
    allowedCharacters: "editor.unicodeHighlight.allowedCharacters",
    invisibleCharacters: "editor.unicodeHighlight.invisibleCharacters",
    nonBasicASCII: "editor.unicodeHighlight.nonBasicASCII",
    ambiguousCharacters: "editor.unicodeHighlight.ambiguousCharacters",
    includeComments: "editor.unicodeHighlight.includeComments",
    includeStrings: "editor.unicodeHighlight.includeStrings",
    allowedLocales: "editor.unicodeHighlight.allowedLocales"
};
class UnicodeHighlight extends BaseEditorOption {
    constructor(){
        const defaults = {
            nonBasicASCII: inUntrustedWorkspace,
            invisibleCharacters: true,
            ambiguousCharacters: true,
            includeComments: inUntrustedWorkspace,
            includeStrings: true,
            allowedCharacters: {},
            allowedLocales: {
                _os: true,
                _vscode: true
            }
        };
        super(126 /* EditorOption.unicodeHighlighting */ , "unicodeHighlight", defaults, {
            [unicodeHighlightConfigKeys.nonBasicASCII]: {
                restricted: true,
                type: [
                    "boolean",
                    "string"
                ],
                enum: [
                    true,
                    false,
                    inUntrustedWorkspace
                ],
                default: defaults.nonBasicASCII,
                description: _nlsJs.localize("unicodeHighlight.nonBasicASCII", "Controls whether all non-basic ASCII characters are highlighted. Only characters between U+0020 and U+007E, tab, line-feed and carriage-return are considered basic ASCII.")
            },
            [unicodeHighlightConfigKeys.invisibleCharacters]: {
                restricted: true,
                type: "boolean",
                default: defaults.invisibleCharacters,
                description: _nlsJs.localize("unicodeHighlight.invisibleCharacters", "Controls whether characters that just reserve space or have no width at all are highlighted.")
            },
            [unicodeHighlightConfigKeys.ambiguousCharacters]: {
                restricted: true,
                type: "boolean",
                default: defaults.ambiguousCharacters,
                description: _nlsJs.localize("unicodeHighlight.ambiguousCharacters", "Controls whether characters are highlighted that can be confused with basic ASCII characters, except those that are common in the current user locale.")
            },
            [unicodeHighlightConfigKeys.includeComments]: {
                restricted: true,
                type: [
                    "boolean",
                    "string"
                ],
                enum: [
                    true,
                    false,
                    inUntrustedWorkspace
                ],
                default: defaults.includeComments,
                description: _nlsJs.localize("unicodeHighlight.includeComments", "Controls whether characters in comments should also be subject to Unicode highlighting.")
            },
            [unicodeHighlightConfigKeys.includeStrings]: {
                restricted: true,
                type: [
                    "boolean",
                    "string"
                ],
                enum: [
                    true,
                    false,
                    inUntrustedWorkspace
                ],
                default: defaults.includeStrings,
                description: _nlsJs.localize("unicodeHighlight.includeStrings", "Controls whether characters in strings should also be subject to Unicode highlighting.")
            },
            [unicodeHighlightConfigKeys.allowedCharacters]: {
                restricted: true,
                type: "object",
                default: defaults.allowedCharacters,
                description: _nlsJs.localize("unicodeHighlight.allowedCharacters", "Defines allowed characters that are not being highlighted."),
                additionalProperties: {
                    type: "boolean"
                }
            },
            [unicodeHighlightConfigKeys.allowedLocales]: {
                restricted: true,
                type: "object",
                additionalProperties: {
                    type: "boolean"
                },
                default: defaults.allowedLocales,
                description: _nlsJs.localize("unicodeHighlight.allowedLocales", "Unicode characters that are common in allowed locales are not being highlighted.")
            }
        });
    }
    applyUpdate(value, update) {
        let didChange = false;
        if (update.allowedCharacters && value) // Treat allowedCharacters atomically
        {
            if (!_objectsJs.equals(value.allowedCharacters, update.allowedCharacters)) {
                value = {
                    ...value,
                    allowedCharacters: update.allowedCharacters
                };
                didChange = true;
            }
        }
        if (update.allowedLocales && value) // Treat allowedLocales atomically
        {
            if (!_objectsJs.equals(value.allowedLocales, update.allowedLocales)) {
                value = {
                    ...value,
                    allowedLocales: update.allowedLocales
                };
                didChange = true;
            }
        }
        const result = super.applyUpdate(value, update);
        if (didChange) return new ApplyUpdateResult(result.newValue, true);
        return result;
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            nonBasicASCII: primitiveSet(input.nonBasicASCII, inUntrustedWorkspace, [
                true,
                false,
                inUntrustedWorkspace
            ]),
            invisibleCharacters: boolean(input.invisibleCharacters, this.defaultValue.invisibleCharacters),
            ambiguousCharacters: boolean(input.ambiguousCharacters, this.defaultValue.ambiguousCharacters),
            includeComments: primitiveSet(input.includeComments, inUntrustedWorkspace, [
                true,
                false,
                inUntrustedWorkspace
            ]),
            includeStrings: primitiveSet(input.includeStrings, inUntrustedWorkspace, [
                true,
                false,
                inUntrustedWorkspace
            ]),
            allowedCharacters: this.validateBooleanMap(_input.allowedCharacters, this.defaultValue.allowedCharacters),
            allowedLocales: this.validateBooleanMap(_input.allowedLocales, this.defaultValue.allowedLocales)
        };
    }
    validateBooleanMap(map, defaultValue) {
        if (typeof map !== "object" || !map) return defaultValue;
        const result = {};
        for (const [key, value] of Object.entries(map))if (value === true) result[key] = true;
        return result;
    }
}
/**
 * Configuration options for inline suggestions
 */ class InlineEditorSuggest extends BaseEditorOption {
    constructor(){
        const defaults = {
            enabled: true,
            mode: "subwordSmart",
            showToolbar: "onHover",
            suppressSuggestions: false,
            keepOnBlur: false,
            fontFamily: "default"
        };
        super(62 /* EditorOption.inlineSuggest */ , "inlineSuggest", defaults, {
            "editor.inlineSuggest.enabled": {
                type: "boolean",
                default: defaults.enabled,
                description: _nlsJs.localize("inlineSuggest.enabled", "Controls whether to automatically show inline suggestions in the editor.")
            },
            "editor.inlineSuggest.showToolbar": {
                type: "string",
                default: defaults.showToolbar,
                enum: [
                    "always",
                    "onHover",
                    "never"
                ],
                enumDescriptions: [
                    _nlsJs.localize("inlineSuggest.showToolbar.always", "Show the inline suggestion toolbar whenever an inline suggestion is shown."),
                    _nlsJs.localize("inlineSuggest.showToolbar.onHover", "Show the inline suggestion toolbar when hovering over an inline suggestion."),
                    _nlsJs.localize("inlineSuggest.showToolbar.never", "Never show the inline suggestion toolbar.")
                ],
                description: _nlsJs.localize("inlineSuggest.showToolbar", "Controls when to show the inline suggestion toolbar.")
            },
            "editor.inlineSuggest.suppressSuggestions": {
                type: "boolean",
                default: defaults.suppressSuggestions,
                description: _nlsJs.localize("inlineSuggest.suppressSuggestions", "Controls how inline suggestions interact with the suggest widget. If enabled, the suggest widget is not shown automatically when inline suggestions are available.")
            },
            "editor.inlineSuggest.fontFamily": {
                type: "string",
                default: defaults.fontFamily,
                description: _nlsJs.localize("inlineSuggest.fontFamily", "Controls the font family of the inline suggestions.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            enabled: boolean(input.enabled, this.defaultValue.enabled),
            mode: stringSet(input.mode, this.defaultValue.mode, [
                "prefix",
                "subword",
                "subwordSmart"
            ]),
            showToolbar: stringSet(input.showToolbar, this.defaultValue.showToolbar, [
                "always",
                "onHover",
                "never"
            ]),
            suppressSuggestions: boolean(input.suppressSuggestions, this.defaultValue.suppressSuggestions),
            keepOnBlur: boolean(input.keepOnBlur, this.defaultValue.keepOnBlur),
            fontFamily: EditorStringOption.string(input.fontFamily, this.defaultValue.fontFamily)
        };
    }
}
class InlineEditorEdit extends BaseEditorOption {
    constructor(){
        const defaults = {
            enabled: false,
            showToolbar: "onHover",
            fontFamily: "default",
            keepOnBlur: false
        };
        super(63 /* EditorOption.inlineEdit */ , "experimentalInlineEdit", defaults, {
            "editor.experimentalInlineEdit.enabled": {
                type: "boolean",
                default: defaults.enabled,
                description: _nlsJs.localize("inlineEdit.enabled", "Controls whether to show inline edits in the editor.")
            },
            "editor.experimentalInlineEdit.showToolbar": {
                type: "string",
                default: defaults.showToolbar,
                enum: [
                    "always",
                    "onHover",
                    "never"
                ],
                enumDescriptions: [
                    _nlsJs.localize("inlineEdit.showToolbar.always", "Show the inline edit toolbar whenever an inline suggestion is shown."),
                    _nlsJs.localize("inlineEdit.showToolbar.onHover", "Show the inline edit toolbar when hovering over an inline suggestion."),
                    _nlsJs.localize("inlineEdit.showToolbar.never", "Never show the inline edit toolbar.")
                ],
                description: _nlsJs.localize("inlineEdit.showToolbar", "Controls when to show the inline edit toolbar.")
            },
            "editor.experimentalInlineEdit.fontFamily": {
                type: "string",
                default: defaults.fontFamily,
                description: _nlsJs.localize("inlineEdit.fontFamily", "Controls the font family of the inline edit.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            enabled: boolean(input.enabled, this.defaultValue.enabled),
            showToolbar: stringSet(input.showToolbar, this.defaultValue.showToolbar, [
                "always",
                "onHover",
                "never"
            ]),
            fontFamily: EditorStringOption.string(input.fontFamily, this.defaultValue.fontFamily),
            keepOnBlur: boolean(input.keepOnBlur, this.defaultValue.keepOnBlur)
        };
    }
}
/**
 * Configuration options for inline suggestions
 */ class BracketPairColorization extends BaseEditorOption {
    constructor(){
        const defaults = {
            enabled: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).bracketPairColorizationOptions.enabled,
            independentColorPoolPerBracketType: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).bracketPairColorizationOptions.independentColorPoolPerBracketType
        };
        super(15 /* EditorOption.bracketPairColorization */ , "bracketPairColorization", defaults, {
            "editor.bracketPairColorization.enabled": {
                type: "boolean",
                default: defaults.enabled,
                markdownDescription: _nlsJs.localize("bracketPairColorization.enabled", "Controls whether bracket pair colorization is enabled or not. Use {0} to override the bracket highlight colors.", "`#workbench.colorCustomizations#`")
            },
            "editor.bracketPairColorization.independentColorPoolPerBracketType": {
                type: "boolean",
                default: defaults.independentColorPoolPerBracketType,
                description: _nlsJs.localize("bracketPairColorization.independentColorPoolPerBracketType", "Controls whether each bracket type has its own independent color pool.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            enabled: boolean(input.enabled, this.defaultValue.enabled),
            independentColorPoolPerBracketType: boolean(input.independentColorPoolPerBracketType, this.defaultValue.independentColorPoolPerBracketType)
        };
    }
}
/**
 * Configuration options for inline suggestions
 */ class GuideOptions extends BaseEditorOption {
    constructor(){
        const defaults = {
            bracketPairs: false,
            bracketPairsHorizontal: "active",
            highlightActiveBracketPair: true,
            indentation: true,
            highlightActiveIndentation: true
        };
        super(16 /* EditorOption.guides */ , "guides", defaults, {
            "editor.guides.bracketPairs": {
                type: [
                    "boolean",
                    "string"
                ],
                enum: [
                    true,
                    "active",
                    false
                ],
                enumDescriptions: [
                    _nlsJs.localize("editor.guides.bracketPairs.true", "Enables bracket pair guides."),
                    _nlsJs.localize("editor.guides.bracketPairs.active", "Enables bracket pair guides only for the active bracket pair."),
                    _nlsJs.localize("editor.guides.bracketPairs.false", "Disables bracket pair guides.")
                ],
                default: defaults.bracketPairs,
                description: _nlsJs.localize("editor.guides.bracketPairs", "Controls whether bracket pair guides are enabled or not.")
            },
            "editor.guides.bracketPairsHorizontal": {
                type: [
                    "boolean",
                    "string"
                ],
                enum: [
                    true,
                    "active",
                    false
                ],
                enumDescriptions: [
                    _nlsJs.localize("editor.guides.bracketPairsHorizontal.true", "Enables horizontal guides as addition to vertical bracket pair guides."),
                    _nlsJs.localize("editor.guides.bracketPairsHorizontal.active", "Enables horizontal guides only for the active bracket pair."),
                    _nlsJs.localize("editor.guides.bracketPairsHorizontal.false", "Disables horizontal bracket pair guides.")
                ],
                default: defaults.bracketPairsHorizontal,
                description: _nlsJs.localize("editor.guides.bracketPairsHorizontal", "Controls whether horizontal bracket pair guides are enabled or not.")
            },
            "editor.guides.highlightActiveBracketPair": {
                type: "boolean",
                default: defaults.highlightActiveBracketPair,
                description: _nlsJs.localize("editor.guides.highlightActiveBracketPair", "Controls whether the editor should highlight the active bracket pair.")
            },
            "editor.guides.indentation": {
                type: "boolean",
                default: defaults.indentation,
                description: _nlsJs.localize("editor.guides.indentation", "Controls whether the editor should render indent guides.")
            },
            "editor.guides.highlightActiveIndentation": {
                type: [
                    "boolean",
                    "string"
                ],
                enum: [
                    true,
                    "always",
                    false
                ],
                enumDescriptions: [
                    _nlsJs.localize("editor.guides.highlightActiveIndentation.true", "Highlights the active indent guide."),
                    _nlsJs.localize("editor.guides.highlightActiveIndentation.always", "Highlights the active indent guide even if bracket guides are highlighted."),
                    _nlsJs.localize("editor.guides.highlightActiveIndentation.false", "Do not highlight the active indent guide.")
                ],
                default: defaults.highlightActiveIndentation,
                description: _nlsJs.localize("editor.guides.highlightActiveIndentation", "Controls whether the editor should highlight the active indent guide.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            bracketPairs: primitiveSet(input.bracketPairs, this.defaultValue.bracketPairs, [
                true,
                false,
                "active"
            ]),
            bracketPairsHorizontal: primitiveSet(input.bracketPairsHorizontal, this.defaultValue.bracketPairsHorizontal, [
                true,
                false,
                "active"
            ]),
            highlightActiveBracketPair: boolean(input.highlightActiveBracketPair, this.defaultValue.highlightActiveBracketPair),
            indentation: boolean(input.indentation, this.defaultValue.indentation),
            highlightActiveIndentation: primitiveSet(input.highlightActiveIndentation, this.defaultValue.highlightActiveIndentation, [
                true,
                false,
                "always"
            ])
        };
    }
}
function primitiveSet(value, defaultValue, allowedValues) {
    const idx = allowedValues.indexOf(value);
    if (idx === -1) return defaultValue;
    return allowedValues[idx];
}
class EditorSuggest extends BaseEditorOption {
    constructor(){
        const defaults = {
            insertMode: "insert",
            filterGraceful: true,
            snippetsPreventQuickSuggestions: false,
            localityBonus: false,
            shareSuggestSelections: false,
            selectionMode: "always",
            showIcons: true,
            showStatusBar: false,
            preview: false,
            previewMode: "subwordSmart",
            showInlineDetails: true,
            showMethods: true,
            showFunctions: true,
            showConstructors: true,
            showDeprecated: true,
            matchOnWordStartOnly: true,
            showFields: true,
            showVariables: true,
            showClasses: true,
            showStructs: true,
            showInterfaces: true,
            showModules: true,
            showProperties: true,
            showEvents: true,
            showOperators: true,
            showUnits: true,
            showValues: true,
            showConstants: true,
            showEnums: true,
            showEnumMembers: true,
            showKeywords: true,
            showWords: true,
            showColors: true,
            showFiles: true,
            showReferences: true,
            showFolders: true,
            showTypeParameters: true,
            showSnippets: true,
            showUsers: true,
            showIssues: true
        };
        super(119 /* EditorOption.suggest */ , "suggest", defaults, {
            "editor.suggest.insertMode": {
                type: "string",
                enum: [
                    "insert",
                    "replace"
                ],
                enumDescriptions: [
                    _nlsJs.localize("suggest.insertMode.insert", "Insert suggestion without overwriting text right of the cursor."),
                    _nlsJs.localize("suggest.insertMode.replace", "Insert suggestion and overwrite text right of the cursor.")
                ],
                default: defaults.insertMode,
                description: _nlsJs.localize("suggest.insertMode", "Controls whether words are overwritten when accepting completions. Note that this depends on extensions opting into this feature.")
            },
            "editor.suggest.filterGraceful": {
                type: "boolean",
                default: defaults.filterGraceful,
                description: _nlsJs.localize("suggest.filterGraceful", "Controls whether filtering and sorting suggestions accounts for small typos.")
            },
            "editor.suggest.localityBonus": {
                type: "boolean",
                default: defaults.localityBonus,
                description: _nlsJs.localize("suggest.localityBonus", "Controls whether sorting favors words that appear close to the cursor.")
            },
            "editor.suggest.shareSuggestSelections": {
                type: "boolean",
                default: defaults.shareSuggestSelections,
                markdownDescription: _nlsJs.localize("suggest.shareSuggestSelections", "Controls whether remembered suggestion selections are shared between multiple workspaces and windows (needs `#editor.suggestSelection#`).")
            },
            "editor.suggest.selectionMode": {
                type: "string",
                enum: [
                    "always",
                    "never",
                    "whenTriggerCharacter",
                    "whenQuickSuggestion"
                ],
                enumDescriptions: [
                    _nlsJs.localize("suggest.insertMode.always", "Always select a suggestion when automatically triggering IntelliSense."),
                    _nlsJs.localize("suggest.insertMode.never", "Never select a suggestion when automatically triggering IntelliSense."),
                    _nlsJs.localize("suggest.insertMode.whenTriggerCharacter", "Select a suggestion only when triggering IntelliSense from a trigger character."),
                    _nlsJs.localize("suggest.insertMode.whenQuickSuggestion", "Select a suggestion only when triggering IntelliSense as you type.")
                ],
                default: defaults.selectionMode,
                markdownDescription: _nlsJs.localize("suggest.selectionMode", "Controls whether a suggestion is selected when the widget shows. Note that this only applies to automatically triggered suggestions ({0} and {1}) and that a suggestion is always selected when explicitly invoked, e.g via `Ctrl+Space`.", "`#editor.quickSuggestions#`", "`#editor.suggestOnTriggerCharacters#`")
            },
            "editor.suggest.snippetsPreventQuickSuggestions": {
                type: "boolean",
                default: defaults.snippetsPreventQuickSuggestions,
                description: _nlsJs.localize("suggest.snippetsPreventQuickSuggestions", "Controls whether an active snippet prevents quick suggestions.")
            },
            "editor.suggest.showIcons": {
                type: "boolean",
                default: defaults.showIcons,
                description: _nlsJs.localize("suggest.showIcons", "Controls whether to show or hide icons in suggestions.")
            },
            "editor.suggest.showStatusBar": {
                type: "boolean",
                default: defaults.showStatusBar,
                description: _nlsJs.localize("suggest.showStatusBar", "Controls the visibility of the status bar at the bottom of the suggest widget.")
            },
            "editor.suggest.preview": {
                type: "boolean",
                default: defaults.preview,
                description: _nlsJs.localize("suggest.preview", "Controls whether to preview the suggestion outcome in the editor.")
            },
            "editor.suggest.showInlineDetails": {
                type: "boolean",
                default: defaults.showInlineDetails,
                description: _nlsJs.localize("suggest.showInlineDetails", "Controls whether suggest details show inline with the label or only in the details widget.")
            },
            "editor.suggest.maxVisibleSuggestions": {
                type: "number",
                deprecationMessage: _nlsJs.localize("suggest.maxVisibleSuggestions.dep", "This setting is deprecated. The suggest widget can now be resized.")
            },
            "editor.suggest.filteredTypes": {
                type: "object",
                deprecationMessage: _nlsJs.localize("deprecated", "This setting is deprecated, please use separate settings like 'editor.suggest.showKeywords' or 'editor.suggest.showSnippets' instead.")
            },
            "editor.suggest.showMethods": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showMethods", "When enabled IntelliSense shows `method`-suggestions.")
            },
            "editor.suggest.showFunctions": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showFunctions", "When enabled IntelliSense shows `function`-suggestions.")
            },
            "editor.suggest.showConstructors": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showConstructors", "When enabled IntelliSense shows `constructor`-suggestions.")
            },
            "editor.suggest.showDeprecated": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showDeprecated", "When enabled IntelliSense shows `deprecated`-suggestions.")
            },
            "editor.suggest.matchOnWordStartOnly": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.matchOnWordStartOnly", "When enabled IntelliSense filtering requires that the first character matches on a word start. For example, `c` on `Console` or `WebContext` but _not_ on `description`. When disabled IntelliSense will show more results but still sorts them by match quality.")
            },
            "editor.suggest.showFields": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showFields", "When enabled IntelliSense shows `field`-suggestions.")
            },
            "editor.suggest.showVariables": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showVariables", "When enabled IntelliSense shows `variable`-suggestions.")
            },
            "editor.suggest.showClasses": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showClasss", "When enabled IntelliSense shows `class`-suggestions.")
            },
            "editor.suggest.showStructs": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showStructs", "When enabled IntelliSense shows `struct`-suggestions.")
            },
            "editor.suggest.showInterfaces": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showInterfaces", "When enabled IntelliSense shows `interface`-suggestions.")
            },
            "editor.suggest.showModules": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showModules", "When enabled IntelliSense shows `module`-suggestions.")
            },
            "editor.suggest.showProperties": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showPropertys", "When enabled IntelliSense shows `property`-suggestions.")
            },
            "editor.suggest.showEvents": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showEvents", "When enabled IntelliSense shows `event`-suggestions.")
            },
            "editor.suggest.showOperators": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showOperators", "When enabled IntelliSense shows `operator`-suggestions.")
            },
            "editor.suggest.showUnits": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showUnits", "When enabled IntelliSense shows `unit`-suggestions.")
            },
            "editor.suggest.showValues": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showValues", "When enabled IntelliSense shows `value`-suggestions.")
            },
            "editor.suggest.showConstants": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showConstants", "When enabled IntelliSense shows `constant`-suggestions.")
            },
            "editor.suggest.showEnums": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showEnums", "When enabled IntelliSense shows `enum`-suggestions.")
            },
            "editor.suggest.showEnumMembers": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showEnumMembers", "When enabled IntelliSense shows `enumMember`-suggestions.")
            },
            "editor.suggest.showKeywords": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showKeywords", "When enabled IntelliSense shows `keyword`-suggestions.")
            },
            "editor.suggest.showWords": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showTexts", "When enabled IntelliSense shows `text`-suggestions.")
            },
            "editor.suggest.showColors": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showColors", "When enabled IntelliSense shows `color`-suggestions.")
            },
            "editor.suggest.showFiles": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showFiles", "When enabled IntelliSense shows `file`-suggestions.")
            },
            "editor.suggest.showReferences": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showReferences", "When enabled IntelliSense shows `reference`-suggestions.")
            },
            "editor.suggest.showCustomcolors": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showCustomcolors", "When enabled IntelliSense shows `customcolor`-suggestions.")
            },
            "editor.suggest.showFolders": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showFolders", "When enabled IntelliSense shows `folder`-suggestions.")
            },
            "editor.suggest.showTypeParameters": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showTypeParameters", "When enabled IntelliSense shows `typeParameter`-suggestions.")
            },
            "editor.suggest.showSnippets": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showSnippets", "When enabled IntelliSense shows `snippet`-suggestions.")
            },
            "editor.suggest.showUsers": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showUsers", "When enabled IntelliSense shows `user`-suggestions.")
            },
            "editor.suggest.showIssues": {
                type: "boolean",
                default: true,
                markdownDescription: _nlsJs.localize("editor.suggest.showIssues", "When enabled IntelliSense shows `issues`-suggestions.")
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            insertMode: stringSet(input.insertMode, this.defaultValue.insertMode, [
                "insert",
                "replace"
            ]),
            filterGraceful: boolean(input.filterGraceful, this.defaultValue.filterGraceful),
            snippetsPreventQuickSuggestions: boolean(input.snippetsPreventQuickSuggestions, this.defaultValue.filterGraceful),
            localityBonus: boolean(input.localityBonus, this.defaultValue.localityBonus),
            shareSuggestSelections: boolean(input.shareSuggestSelections, this.defaultValue.shareSuggestSelections),
            selectionMode: stringSet(input.selectionMode, this.defaultValue.selectionMode, [
                "always",
                "never",
                "whenQuickSuggestion",
                "whenTriggerCharacter"
            ]),
            showIcons: boolean(input.showIcons, this.defaultValue.showIcons),
            showStatusBar: boolean(input.showStatusBar, this.defaultValue.showStatusBar),
            preview: boolean(input.preview, this.defaultValue.preview),
            previewMode: stringSet(input.previewMode, this.defaultValue.previewMode, [
                "prefix",
                "subword",
                "subwordSmart"
            ]),
            showInlineDetails: boolean(input.showInlineDetails, this.defaultValue.showInlineDetails),
            showMethods: boolean(input.showMethods, this.defaultValue.showMethods),
            showFunctions: boolean(input.showFunctions, this.defaultValue.showFunctions),
            showConstructors: boolean(input.showConstructors, this.defaultValue.showConstructors),
            showDeprecated: boolean(input.showDeprecated, this.defaultValue.showDeprecated),
            matchOnWordStartOnly: boolean(input.matchOnWordStartOnly, this.defaultValue.matchOnWordStartOnly),
            showFields: boolean(input.showFields, this.defaultValue.showFields),
            showVariables: boolean(input.showVariables, this.defaultValue.showVariables),
            showClasses: boolean(input.showClasses, this.defaultValue.showClasses),
            showStructs: boolean(input.showStructs, this.defaultValue.showStructs),
            showInterfaces: boolean(input.showInterfaces, this.defaultValue.showInterfaces),
            showModules: boolean(input.showModules, this.defaultValue.showModules),
            showProperties: boolean(input.showProperties, this.defaultValue.showProperties),
            showEvents: boolean(input.showEvents, this.defaultValue.showEvents),
            showOperators: boolean(input.showOperators, this.defaultValue.showOperators),
            showUnits: boolean(input.showUnits, this.defaultValue.showUnits),
            showValues: boolean(input.showValues, this.defaultValue.showValues),
            showConstants: boolean(input.showConstants, this.defaultValue.showConstants),
            showEnums: boolean(input.showEnums, this.defaultValue.showEnums),
            showEnumMembers: boolean(input.showEnumMembers, this.defaultValue.showEnumMembers),
            showKeywords: boolean(input.showKeywords, this.defaultValue.showKeywords),
            showWords: boolean(input.showWords, this.defaultValue.showWords),
            showColors: boolean(input.showColors, this.defaultValue.showColors),
            showFiles: boolean(input.showFiles, this.defaultValue.showFiles),
            showReferences: boolean(input.showReferences, this.defaultValue.showReferences),
            showFolders: boolean(input.showFolders, this.defaultValue.showFolders),
            showTypeParameters: boolean(input.showTypeParameters, this.defaultValue.showTypeParameters),
            showSnippets: boolean(input.showSnippets, this.defaultValue.showSnippets),
            showUsers: boolean(input.showUsers, this.defaultValue.showUsers),
            showIssues: boolean(input.showIssues, this.defaultValue.showIssues)
        };
    }
}
class SmartSelect extends BaseEditorOption {
    constructor(){
        super(114 /* EditorOption.smartSelect */ , "smartSelect", {
            selectLeadingAndTrailingWhitespace: true,
            selectSubwords: true
        }, {
            "editor.smartSelect.selectLeadingAndTrailingWhitespace": {
                description: _nlsJs.localize("selectLeadingAndTrailingWhitespace", "Whether leading and trailing whitespace should always be selected."),
                default: true,
                type: "boolean"
            },
            "editor.smartSelect.selectSubwords": {
                description: _nlsJs.localize("selectSubwords", "Whether subwords (like 'foo' in 'fooBar' or 'foo_bar') should be selected."),
                default: true,
                type: "boolean"
            }
        });
    }
    validate(input) {
        if (!input || typeof input !== "object") return this.defaultValue;
        return {
            selectLeadingAndTrailingWhitespace: boolean(input.selectLeadingAndTrailingWhitespace, this.defaultValue.selectLeadingAndTrailingWhitespace),
            selectSubwords: boolean(input.selectSubwords, this.defaultValue.selectSubwords)
        };
    }
}
//#endregion
//#region wordSegmenterLocales
/**
 * Locales used for segmenting lines into words when doing word related navigations or operations.
 *
 * Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.).
 */ class WordSegmenterLocales extends BaseEditorOption {
    constructor(){
        const defaults = [];
        super(131 /* EditorOption.wordSegmenterLocales */ , "wordSegmenterLocales", defaults, {
            anyOf: [
                {
                    description: _nlsJs.localize("wordSegmenterLocales", "Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.)."),
                    type: "string"
                },
                {
                    description: _nlsJs.localize("wordSegmenterLocales", "Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.)."),
                    type: "array",
                    items: {
                        type: "string"
                    }
                }
            ]
        });
    }
    validate(input) {
        if (typeof input === "string") input = [
            input
        ];
        if (Array.isArray(input)) {
            const validLocales = [];
            for (const locale of input){
                if (typeof locale === "string") try {
                    if (Intl.Segmenter.supportedLocalesOf(locale).length > 0) validLocales.push(locale);
                } catch  {
                // ignore invalid locales
                }
            }
            return validLocales;
        }
        return this.defaultValue;
    }
}
class WrappingIndentOption extends BaseEditorOption {
    constructor(){
        super(139 /* EditorOption.wrappingIndent */ , "wrappingIndent", 1 /* WrappingIndent.Same */ , {
            "editor.wrappingIndent": {
                type: "string",
                enum: [
                    "none",
                    "same",
                    "indent",
                    "deepIndent"
                ],
                enumDescriptions: [
                    _nlsJs.localize("wrappingIndent.none", "No indentation. Wrapped lines begin at column 1."),
                    _nlsJs.localize("wrappingIndent.same", "Wrapped lines get the same indentation as the parent."),
                    _nlsJs.localize("wrappingIndent.indent", "Wrapped lines get +1 indentation toward the parent."),
                    _nlsJs.localize("wrappingIndent.deepIndent", "Wrapped lines get +2 indentation toward the parent.")
                ],
                description: _nlsJs.localize("wrappingIndent", "Controls the indentation of wrapped lines."),
                default: "same"
            }
        });
    }
    validate(input) {
        switch(input){
            case "none":
                return 0 /* WrappingIndent.None */ ;
            case "same":
                return 1 /* WrappingIndent.Same */ ;
            case "indent":
                return 2 /* WrappingIndent.Indent */ ;
            case "deepIndent":
                return 3 /* WrappingIndent.DeepIndent */ ;
        }
        return 1 /* WrappingIndent.Same */ ;
    }
    compute(env, options, value) {
        const accessibilitySupport = options.get(2 /* EditorOption.accessibilitySupport */ );
        if (accessibilitySupport === 2 /* AccessibilitySupport.Enabled */ ) // if we know for a fact that a screen reader is attached, we use no indent wrapping to
        // help that the editor's wrapping points match the textarea's wrapping points
        return 0 /* WrappingIndent.None */ ;
        return value;
    }
}
class EditorWrappingInfoComputer extends ComputedEditorOption {
    constructor(){
        super(147 /* EditorOption.wrappingInfo */ );
    }
    compute(env, options, _) {
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        return {
            isDominatedByLongLines: env.isDominatedByLongLines,
            isWordWrapMinified: layoutInfo.isWordWrapMinified,
            isViewportWrapping: layoutInfo.isViewportWrapping,
            wrappingColumn: layoutInfo.wrappingColumn
        };
    }
}
class EditorDropIntoEditor extends BaseEditorOption {
    constructor(){
        const defaults = {
            enabled: true,
            showDropSelector: "afterDrop"
        };
        super(36 /* EditorOption.dropIntoEditor */ , "dropIntoEditor", defaults, {
            "editor.dropIntoEditor.enabled": {
                type: "boolean",
                default: defaults.enabled,
                markdownDescription: _nlsJs.localize("dropIntoEditor.enabled", "Controls whether you can drag and drop a file into a text editor by holding down the `Shift` key (instead of opening the file in an editor).")
            },
            "editor.dropIntoEditor.showDropSelector": {
                type: "string",
                markdownDescription: _nlsJs.localize("dropIntoEditor.showDropSelector", "Controls if a widget is shown when dropping files into the editor. This widget lets you control how the file is dropped."),
                enum: [
                    "afterDrop",
                    "never"
                ],
                enumDescriptions: [
                    _nlsJs.localize("dropIntoEditor.showDropSelector.afterDrop", "Show the drop selector widget after a file is dropped into the editor."),
                    _nlsJs.localize("dropIntoEditor.showDropSelector.never", "Never show the drop selector widget. Instead the default drop provider is always used.")
                ],
                default: "afterDrop"
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            enabled: boolean(input.enabled, this.defaultValue.enabled),
            showDropSelector: stringSet(input.showDropSelector, this.defaultValue.showDropSelector, [
                "afterDrop",
                "never"
            ])
        };
    }
}
class EditorPasteAs extends BaseEditorOption {
    constructor(){
        const defaults = {
            enabled: true,
            showPasteSelector: "afterPaste"
        };
        super(85 /* EditorOption.pasteAs */ , "pasteAs", defaults, {
            "editor.pasteAs.enabled": {
                type: "boolean",
                default: defaults.enabled,
                markdownDescription: _nlsJs.localize("pasteAs.enabled", "Controls whether you can paste content in different ways.")
            },
            "editor.pasteAs.showPasteSelector": {
                type: "string",
                markdownDescription: _nlsJs.localize("pasteAs.showPasteSelector", "Controls if a widget is shown when pasting content in to the editor. This widget lets you control how the file is pasted."),
                enum: [
                    "afterPaste",
                    "never"
                ],
                enumDescriptions: [
                    _nlsJs.localize("pasteAs.showPasteSelector.afterPaste", "Show the paste selector widget after content is pasted into the editor."),
                    _nlsJs.localize("pasteAs.showPasteSelector.never", "Never show the paste selector widget. Instead the default pasting behavior is always used.")
                ],
                default: "afterPaste"
            }
        });
    }
    validate(_input) {
        if (!_input || typeof _input !== "object") return this.defaultValue;
        const input = _input;
        return {
            enabled: boolean(input.enabled, this.defaultValue.enabled),
            showPasteSelector: stringSet(input.showPasteSelector, this.defaultValue.showPasteSelector, [
                "afterPaste",
                "never"
            ])
        };
    }
}
//#endregion
const DEFAULT_WINDOWS_FONT_FAMILY = "Consolas, 'Courier New', monospace";
const DEFAULT_MAC_FONT_FAMILY = "Menlo, Monaco, 'Courier New', monospace";
const DEFAULT_LINUX_FONT_FAMILY = "'Droid Sans Mono', 'monospace', monospace";
const EDITOR_FONT_DEFAULTS = {
    fontFamily: _platformJs.isMacintosh ? DEFAULT_MAC_FONT_FAMILY : _platformJs.isLinux ? DEFAULT_LINUX_FONT_FAMILY : DEFAULT_WINDOWS_FONT_FAMILY,
    fontWeight: "normal",
    fontSize: _platformJs.isMacintosh ? 12 : 14,
    lineHeight: 0,
    letterSpacing: 0
};
const editorOptionsRegistry = [];
function register(option) {
    editorOptionsRegistry[option.id] = option;
    return option;
}
const EditorOptions = {
    acceptSuggestionOnCommitCharacter: register(new EditorBooleanOption(0 /* EditorOption.acceptSuggestionOnCommitCharacter */ , "acceptSuggestionOnCommitCharacter", true, {
        markdownDescription: _nlsJs.localize("acceptSuggestionOnCommitCharacter", "Controls whether suggestions should be accepted on commit characters. For example, in JavaScript, the semi-colon (`;`) can be a commit character that accepts a suggestion and types that character.")
    })),
    acceptSuggestionOnEnter: register(new EditorStringEnumOption(1 /* EditorOption.acceptSuggestionOnEnter */ , "acceptSuggestionOnEnter", "on", [
        "on",
        "smart",
        "off"
    ], {
        markdownEnumDescriptions: [
            "",
            _nlsJs.localize("acceptSuggestionOnEnterSmart", "Only accept a suggestion with `Enter` when it makes a textual change."),
            ""
        ],
        markdownDescription: _nlsJs.localize("acceptSuggestionOnEnter", "Controls whether suggestions should be accepted on `Enter`, in addition to `Tab`. Helps to avoid ambiguity between inserting new lines or accepting suggestions.")
    })),
    accessibilitySupport: register(new EditorAccessibilitySupport()),
    accessibilityPageSize: register(new EditorIntOption(3 /* EditorOption.accessibilityPageSize */ , "accessibilityPageSize", 10, 1, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ , {
        description: _nlsJs.localize("accessibilityPageSize", "Controls the number of lines in the editor that can be read out by a screen reader at once. When we detect a screen reader we automatically set the default to be 500. Warning: this has a performance implication for numbers larger than the default."),
        tags: [
            "accessibility"
        ]
    })),
    ariaLabel: register(new EditorStringOption(4 /* EditorOption.ariaLabel */ , "ariaLabel", _nlsJs.localize("editorViewAccessibleLabel", "Editor content"))),
    ariaRequired: register(new EditorBooleanOption(5 /* EditorOption.ariaRequired */ , "ariaRequired", false, undefined)),
    screenReaderAnnounceInlineSuggestion: register(new EditorBooleanOption(8 /* EditorOption.screenReaderAnnounceInlineSuggestion */ , "screenReaderAnnounceInlineSuggestion", true, {
        description: _nlsJs.localize("screenReaderAnnounceInlineSuggestion", "Control whether inline suggestions are announced by a screen reader."),
        tags: [
            "accessibility"
        ]
    })),
    autoClosingBrackets: register(new EditorStringEnumOption(6 /* EditorOption.autoClosingBrackets */ , "autoClosingBrackets", "languageDefined", [
        "always",
        "languageDefined",
        "beforeWhitespace",
        "never"
    ], {
        enumDescriptions: [
            "",
            _nlsJs.localize("editor.autoClosingBrackets.languageDefined", "Use language configurations to determine when to autoclose brackets."),
            _nlsJs.localize("editor.autoClosingBrackets.beforeWhitespace", "Autoclose brackets only when the cursor is to the left of whitespace."),
            ""
        ],
        description: _nlsJs.localize("autoClosingBrackets", "Controls whether the editor should automatically close brackets after the user adds an opening bracket.")
    })),
    autoClosingComments: register(new EditorStringEnumOption(7 /* EditorOption.autoClosingComments */ , "autoClosingComments", "languageDefined", [
        "always",
        "languageDefined",
        "beforeWhitespace",
        "never"
    ], {
        enumDescriptions: [
            "",
            _nlsJs.localize("editor.autoClosingComments.languageDefined", "Use language configurations to determine when to autoclose comments."),
            _nlsJs.localize("editor.autoClosingComments.beforeWhitespace", "Autoclose comments only when the cursor is to the left of whitespace."),
            ""
        ],
        description: _nlsJs.localize("autoClosingComments", "Controls whether the editor should automatically close comments after the user adds an opening comment.")
    })),
    autoClosingDelete: register(new EditorStringEnumOption(9 /* EditorOption.autoClosingDelete */ , "autoClosingDelete", "auto", [
        "always",
        "auto",
        "never"
    ], {
        enumDescriptions: [
            "",
            _nlsJs.localize("editor.autoClosingDelete.auto", "Remove adjacent closing quotes or brackets only if they were automatically inserted."),
            ""
        ],
        description: _nlsJs.localize("autoClosingDelete", "Controls whether the editor should remove adjacent closing quotes or brackets when deleting.")
    })),
    autoClosingOvertype: register(new EditorStringEnumOption(10 /* EditorOption.autoClosingOvertype */ , "autoClosingOvertype", "auto", [
        "always",
        "auto",
        "never"
    ], {
        enumDescriptions: [
            "",
            _nlsJs.localize("editor.autoClosingOvertype.auto", "Type over closing quotes or brackets only if they were automatically inserted."),
            ""
        ],
        description: _nlsJs.localize("autoClosingOvertype", "Controls whether the editor should type over closing quotes or brackets.")
    })),
    autoClosingQuotes: register(new EditorStringEnumOption(11 /* EditorOption.autoClosingQuotes */ , "autoClosingQuotes", "languageDefined", [
        "always",
        "languageDefined",
        "beforeWhitespace",
        "never"
    ], {
        enumDescriptions: [
            "",
            _nlsJs.localize("editor.autoClosingQuotes.languageDefined", "Use language configurations to determine when to autoclose quotes."),
            _nlsJs.localize("editor.autoClosingQuotes.beforeWhitespace", "Autoclose quotes only when the cursor is to the left of whitespace."),
            ""
        ],
        description: _nlsJs.localize("autoClosingQuotes", "Controls whether the editor should automatically close quotes after the user adds an opening quote.")
    })),
    autoIndent: register(new EditorEnumOption(12 /* EditorOption.autoIndent */ , "autoIndent", 4 /* EditorAutoIndentStrategy.Full */ , "full", [
        "none",
        "keep",
        "brackets",
        "advanced",
        "full"
    ], _autoIndentFromString, {
        enumDescriptions: [
            _nlsJs.localize("editor.autoIndent.none", "The editor will not insert indentation automatically."),
            _nlsJs.localize("editor.autoIndent.keep", "The editor will keep the current line's indentation."),
            _nlsJs.localize("editor.autoIndent.brackets", "The editor will keep the current line's indentation and honor language defined brackets."),
            _nlsJs.localize("editor.autoIndent.advanced", "The editor will keep the current line's indentation, honor language defined brackets and invoke special onEnterRules defined by languages."),
            _nlsJs.localize("editor.autoIndent.full", "The editor will keep the current line's indentation, honor language defined brackets, invoke special onEnterRules defined by languages, and honor indentationRules defined by languages.")
        ],
        description: _nlsJs.localize("autoIndent", "Controls whether the editor should automatically adjust the indentation when users type, paste, move or indent lines.")
    })),
    automaticLayout: register(new EditorBooleanOption(13 /* EditorOption.automaticLayout */ , "automaticLayout", false)),
    autoSurround: register(new EditorStringEnumOption(14 /* EditorOption.autoSurround */ , "autoSurround", "languageDefined", [
        "languageDefined",
        "quotes",
        "brackets",
        "never"
    ], {
        enumDescriptions: [
            _nlsJs.localize("editor.autoSurround.languageDefined", "Use language configurations to determine when to automatically surround selections."),
            _nlsJs.localize("editor.autoSurround.quotes", "Surround with quotes but not brackets."),
            _nlsJs.localize("editor.autoSurround.brackets", "Surround with brackets but not quotes."),
            ""
        ],
        description: _nlsJs.localize("autoSurround", "Controls whether the editor should automatically surround selections when typing quotes or brackets.")
    })),
    bracketPairColorization: register(new BracketPairColorization()),
    bracketPairGuides: register(new GuideOptions()),
    stickyTabStops: register(new EditorBooleanOption(117 /* EditorOption.stickyTabStops */ , "stickyTabStops", false, {
        description: _nlsJs.localize("stickyTabStops", "Emulate selection behavior of tab characters when using spaces for indentation. Selection will stick to tab stops.")
    })),
    codeLens: register(new EditorBooleanOption(17 /* EditorOption.codeLens */ , "codeLens", true, {
        description: _nlsJs.localize("codeLens", "Controls whether the editor shows CodeLens.")
    })),
    codeLensFontFamily: register(new EditorStringOption(18 /* EditorOption.codeLensFontFamily */ , "codeLensFontFamily", "", {
        description: _nlsJs.localize("codeLensFontFamily", "Controls the font family for CodeLens.")
    })),
    codeLensFontSize: register(new EditorIntOption(19 /* EditorOption.codeLensFontSize */ , "codeLensFontSize", 0, 0, 100, {
        type: "number",
        default: 0,
        minimum: 0,
        maximum: 100,
        markdownDescription: _nlsJs.localize("codeLensFontSize", "Controls the font size in pixels for CodeLens. When set to 0, 90% of `#editor.fontSize#` is used.")
    })),
    colorDecorators: register(new EditorBooleanOption(20 /* EditorOption.colorDecorators */ , "colorDecorators", true, {
        description: _nlsJs.localize("colorDecorators", "Controls whether the editor should render the inline color decorators and color picker.")
    })),
    colorDecoratorActivatedOn: register(new EditorStringEnumOption(149 /* EditorOption.colorDecoratorsActivatedOn */ , "colorDecoratorsActivatedOn", "clickAndHover", [
        "clickAndHover",
        "hover",
        "click"
    ], {
        enumDescriptions: [
            _nlsJs.localize("editor.colorDecoratorActivatedOn.clickAndHover", "Make the color picker appear both on click and hover of the color decorator"),
            _nlsJs.localize("editor.colorDecoratorActivatedOn.hover", "Make the color picker appear on hover of the color decorator"),
            _nlsJs.localize("editor.colorDecoratorActivatedOn.click", "Make the color picker appear on click of the color decorator")
        ],
        description: _nlsJs.localize("colorDecoratorActivatedOn", "Controls the condition to make a color picker appear from a color decorator")
    })),
    colorDecoratorsLimit: register(new EditorIntOption(21 /* EditorOption.colorDecoratorsLimit */ , "colorDecoratorsLimit", 500, 1, 1000000, {
        markdownDescription: _nlsJs.localize("colorDecoratorsLimit", "Controls the max number of color decorators that can be rendered in an editor at once.")
    })),
    columnSelection: register(new EditorBooleanOption(22 /* EditorOption.columnSelection */ , "columnSelection", false, {
        description: _nlsJs.localize("columnSelection", "Enable that the selection with the mouse and keys is doing column selection.")
    })),
    comments: register(new EditorComments()),
    contextmenu: register(new EditorBooleanOption(24 /* EditorOption.contextmenu */ , "contextmenu", true)),
    copyWithSyntaxHighlighting: register(new EditorBooleanOption(25 /* EditorOption.copyWithSyntaxHighlighting */ , "copyWithSyntaxHighlighting", true, {
        description: _nlsJs.localize("copyWithSyntaxHighlighting", "Controls whether syntax highlighting should be copied into the clipboard.")
    })),
    cursorBlinking: register(new EditorEnumOption(26 /* EditorOption.cursorBlinking */ , "cursorBlinking", 1 /* TextEditorCursorBlinkingStyle.Blink */ , "blink", [
        "blink",
        "smooth",
        "phase",
        "expand",
        "solid"
    ], _cursorBlinkingStyleFromString, {
        description: _nlsJs.localize("cursorBlinking", "Control the cursor animation style.")
    })),
    cursorSmoothCaretAnimation: register(new EditorStringEnumOption(27 /* EditorOption.cursorSmoothCaretAnimation */ , "cursorSmoothCaretAnimation", "off", [
        "off",
        "explicit",
        "on"
    ], {
        enumDescriptions: [
            _nlsJs.localize("cursorSmoothCaretAnimation.off", "Smooth caret animation is disabled."),
            _nlsJs.localize("cursorSmoothCaretAnimation.explicit", "Smooth caret animation is enabled only when the user moves the cursor with an explicit gesture."),
            _nlsJs.localize("cursorSmoothCaretAnimation.on", "Smooth caret animation is always enabled.")
        ],
        description: _nlsJs.localize("cursorSmoothCaretAnimation", "Controls whether the smooth caret animation should be enabled.")
    })),
    cursorStyle: register(new EditorEnumOption(28 /* EditorOption.cursorStyle */ , "cursorStyle", TextEditorCursorStyle.Line, "line", [
        "line",
        "block",
        "underline",
        "line-thin",
        "block-outline",
        "underline-thin"
    ], _cursorStyleFromString, {
        description: _nlsJs.localize("cursorStyle", "Controls the cursor style.")
    })),
    cursorSurroundingLines: register(new EditorIntOption(29 /* EditorOption.cursorSurroundingLines */ , "cursorSurroundingLines", 0, 0, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ , {
        description: _nlsJs.localize("cursorSurroundingLines", "Controls the minimal number of visible leading lines (minimum 0) and trailing lines (minimum 1) surrounding the cursor. Known as 'scrollOff' or 'scrollOffset' in some other editors.")
    })),
    cursorSurroundingLinesStyle: register(new EditorStringEnumOption(30 /* EditorOption.cursorSurroundingLinesStyle */ , "cursorSurroundingLinesStyle", "default", [
        "default",
        "all"
    ], {
        enumDescriptions: [
            _nlsJs.localize("cursorSurroundingLinesStyle.default", "`cursorSurroundingLines` is enforced only when triggered via the keyboard or API."),
            _nlsJs.localize("cursorSurroundingLinesStyle.all", "`cursorSurroundingLines` is enforced always.")
        ],
        markdownDescription: _nlsJs.localize("cursorSurroundingLinesStyle", "Controls when `#editor.cursorSurroundingLines#` should be enforced.")
    })),
    cursorWidth: register(new EditorIntOption(31 /* EditorOption.cursorWidth */ , "cursorWidth", 0, 0, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ , {
        markdownDescription: _nlsJs.localize("cursorWidth", "Controls the width of the cursor when `#editor.cursorStyle#` is set to `line`.")
    })),
    disableLayerHinting: register(new EditorBooleanOption(32 /* EditorOption.disableLayerHinting */ , "disableLayerHinting", false)),
    disableMonospaceOptimizations: register(new EditorBooleanOption(33 /* EditorOption.disableMonospaceOptimizations */ , "disableMonospaceOptimizations", false)),
    domReadOnly: register(new EditorBooleanOption(34 /* EditorOption.domReadOnly */ , "domReadOnly", false)),
    dragAndDrop: register(new EditorBooleanOption(35 /* EditorOption.dragAndDrop */ , "dragAndDrop", true, {
        description: _nlsJs.localize("dragAndDrop", "Controls whether the editor should allow moving selections via drag and drop.")
    })),
    emptySelectionClipboard: register(new EditorEmptySelectionClipboard()),
    dropIntoEditor: register(new EditorDropIntoEditor()),
    stickyScroll: register(new EditorStickyScroll()),
    experimentalWhitespaceRendering: register(new EditorStringEnumOption(38 /* EditorOption.experimentalWhitespaceRendering */ , "experimentalWhitespaceRendering", "svg", [
        "svg",
        "font",
        "off"
    ], {
        enumDescriptions: [
            _nlsJs.localize("experimentalWhitespaceRendering.svg", "Use a new rendering method with svgs."),
            _nlsJs.localize("experimentalWhitespaceRendering.font", "Use a new rendering method with font characters."),
            _nlsJs.localize("experimentalWhitespaceRendering.off", "Use the stable rendering method.")
        ],
        description: _nlsJs.localize("experimentalWhitespaceRendering", "Controls whether whitespace is rendered with a new, experimental method.")
    })),
    extraEditorClassName: register(new EditorStringOption(39 /* EditorOption.extraEditorClassName */ , "extraEditorClassName", "")),
    fastScrollSensitivity: register(new EditorFloatOption(40 /* EditorOption.fastScrollSensitivity */ , "fastScrollSensitivity", 5, (x)=>x <= 0 ? 5 : x, {
        markdownDescription: _nlsJs.localize("fastScrollSensitivity", "Scrolling speed multiplier when pressing `Alt`.")
    })),
    find: register(new EditorFind()),
    fixedOverflowWidgets: register(new EditorBooleanOption(42 /* EditorOption.fixedOverflowWidgets */ , "fixedOverflowWidgets", false)),
    folding: register(new EditorBooleanOption(43 /* EditorOption.folding */ , "folding", true, {
        description: _nlsJs.localize("folding", "Controls whether the editor has code folding enabled.")
    })),
    foldingStrategy: register(new EditorStringEnumOption(44 /* EditorOption.foldingStrategy */ , "foldingStrategy", "auto", [
        "auto",
        "indentation"
    ], {
        enumDescriptions: [
            _nlsJs.localize("foldingStrategy.auto", "Use a language-specific folding strategy if available, else the indentation-based one."),
            _nlsJs.localize("foldingStrategy.indentation", "Use the indentation-based folding strategy.")
        ],
        description: _nlsJs.localize("foldingStrategy", "Controls the strategy for computing folding ranges.")
    })),
    foldingHighlight: register(new EditorBooleanOption(45 /* EditorOption.foldingHighlight */ , "foldingHighlight", true, {
        description: _nlsJs.localize("foldingHighlight", "Controls whether the editor should highlight folded ranges.")
    })),
    foldingImportsByDefault: register(new EditorBooleanOption(46 /* EditorOption.foldingImportsByDefault */ , "foldingImportsByDefault", false, {
        description: _nlsJs.localize("foldingImportsByDefault", "Controls whether the editor automatically collapses import ranges.")
    })),
    foldingMaximumRegions: register(new EditorIntOption(47 /* EditorOption.foldingMaximumRegions */ , "foldingMaximumRegions", 5000, 10, 65000, {
        description: _nlsJs.localize("foldingMaximumRegions", "The maximum number of foldable regions. Increasing this value may result in the editor becoming less responsive when the current source has a large number of foldable regions.")
    })),
    unfoldOnClickAfterEndOfLine: register(new EditorBooleanOption(48 /* EditorOption.unfoldOnClickAfterEndOfLine */ , "unfoldOnClickAfterEndOfLine", false, {
        description: _nlsJs.localize("unfoldOnClickAfterEndOfLine", "Controls whether clicking on the empty content after a folded line will unfold the line.")
    })),
    fontFamily: register(new EditorStringOption(49 /* EditorOption.fontFamily */ , "fontFamily", EDITOR_FONT_DEFAULTS.fontFamily, {
        description: _nlsJs.localize("fontFamily", "Controls the font family.")
    })),
    fontInfo: register(new EditorFontInfo()),
    fontLigatures2: register(new EditorFontLigatures()),
    fontSize: register(new EditorFontSize()),
    fontWeight: register(new EditorFontWeight()),
    fontVariations: register(new EditorFontVariations()),
    formatOnPaste: register(new EditorBooleanOption(55 /* EditorOption.formatOnPaste */ , "formatOnPaste", false, {
        description: _nlsJs.localize("formatOnPaste", "Controls whether the editor should automatically format the pasted content. A formatter must be available and the formatter should be able to format a range in a document.")
    })),
    formatOnType: register(new EditorBooleanOption(56 /* EditorOption.formatOnType */ , "formatOnType", false, {
        description: _nlsJs.localize("formatOnType", "Controls whether the editor should automatically format the line after typing.")
    })),
    glyphMargin: register(new EditorBooleanOption(57 /* EditorOption.glyphMargin */ , "glyphMargin", true, {
        description: _nlsJs.localize("glyphMargin", "Controls whether the editor should render the vertical glyph margin. Glyph margin is mostly used for debugging.")
    })),
    gotoLocation: register(new EditorGoToLocation()),
    hideCursorInOverviewRuler: register(new EditorBooleanOption(59 /* EditorOption.hideCursorInOverviewRuler */ , "hideCursorInOverviewRuler", false, {
        description: _nlsJs.localize("hideCursorInOverviewRuler", "Controls whether the cursor should be hidden in the overview ruler.")
    })),
    hover: register(new EditorHover()),
    inDiffEditor: register(new EditorBooleanOption(61 /* EditorOption.inDiffEditor */ , "inDiffEditor", false)),
    letterSpacing: register(new EditorFloatOption(64 /* EditorOption.letterSpacing */ , "letterSpacing", EDITOR_FONT_DEFAULTS.letterSpacing, (x)=>EditorFloatOption.clamp(x, -5, 20), {
        description: _nlsJs.localize("letterSpacing", "Controls the letter spacing in pixels.")
    })),
    lightbulb: register(new EditorLightbulb()),
    lineDecorationsWidth: register(new EditorLineDecorationsWidth()),
    lineHeight: register(new EditorLineHeight()),
    lineNumbers: register(new EditorRenderLineNumbersOption()),
    lineNumbersMinChars: register(new EditorIntOption(69 /* EditorOption.lineNumbersMinChars */ , "lineNumbersMinChars", 5, 1, 300)),
    linkedEditing: register(new EditorBooleanOption(70 /* EditorOption.linkedEditing */ , "linkedEditing", false, {
        description: _nlsJs.localize("linkedEditing", "Controls whether the editor has linked editing enabled. Depending on the language, related symbols such as HTML tags, are updated while editing.")
    })),
    links: register(new EditorBooleanOption(71 /* EditorOption.links */ , "links", true, {
        description: _nlsJs.localize("links", "Controls whether the editor should detect links and make them clickable.")
    })),
    matchBrackets: register(new EditorStringEnumOption(72 /* EditorOption.matchBrackets */ , "matchBrackets", "always", [
        "always",
        "near",
        "never"
    ], {
        description: _nlsJs.localize("matchBrackets", "Highlight matching brackets.")
    })),
    minimap: register(new EditorMinimap()),
    mouseStyle: register(new EditorStringEnumOption(74 /* EditorOption.mouseStyle */ , "mouseStyle", "text", [
        "text",
        "default",
        "copy"
    ])),
    mouseWheelScrollSensitivity: register(new EditorFloatOption(75 /* EditorOption.mouseWheelScrollSensitivity */ , "mouseWheelScrollSensitivity", 1, (x)=>x === 0 ? 1 : x, {
        markdownDescription: _nlsJs.localize("mouseWheelScrollSensitivity", "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.")
    })),
    mouseWheelZoom: register(new EditorBooleanOption(76 /* EditorOption.mouseWheelZoom */ , "mouseWheelZoom", false, {
        markdownDescription: _platformJs.isMacintosh ? _nlsJs.localize("mouseWheelZoom.mac", "Zoom the font of the editor when using mouse wheel and holding `Cmd`.") : _nlsJs.localize("mouseWheelZoom", "Zoom the font of the editor when using mouse wheel and holding `Ctrl`.")
    })),
    multiCursorMergeOverlapping: register(new EditorBooleanOption(77 /* EditorOption.multiCursorMergeOverlapping */ , "multiCursorMergeOverlapping", true, {
        description: _nlsJs.localize("multiCursorMergeOverlapping", "Merge multiple cursors when they are overlapping.")
    })),
    multiCursorModifier: register(new EditorEnumOption(78 /* EditorOption.multiCursorModifier */ , "multiCursorModifier", "altKey", "alt", [
        "ctrlCmd",
        "alt"
    ], _multiCursorModifierFromString, {
        markdownEnumDescriptions: [
            _nlsJs.localize("multiCursorModifier.ctrlCmd", "Maps to `Control` on Windows and Linux and to `Command` on macOS."),
            _nlsJs.localize("multiCursorModifier.alt", "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")
        ],
        markdownDescription: _nlsJs.localize({
            key: "multiCursorModifier",
            comment: [
                "- `ctrlCmd` refers to a value the setting can take and should not be localized.",
                "- `Control` and `Command` refer to the modifier keys Ctrl or Cmd on the keyboard and can be localized."
            ]
        }, "The modifier to be used to add multiple cursors with the mouse. The Go to Definition and Open Link mouse gestures will adapt such that they do not conflict with the [multicursor modifier](https://code.visualstudio.com/docs/editor/codebasics#_multicursor-modifier).")
    })),
    multiCursorPaste: register(new EditorStringEnumOption(79 /* EditorOption.multiCursorPaste */ , "multiCursorPaste", "spread", [
        "spread",
        "full"
    ], {
        markdownEnumDescriptions: [
            _nlsJs.localize("multiCursorPaste.spread", "Each cursor pastes a single line of the text."),
            _nlsJs.localize("multiCursorPaste.full", "Each cursor pastes the full text.")
        ],
        markdownDescription: _nlsJs.localize("multiCursorPaste", "Controls pasting when the line count of the pasted text matches the cursor count.")
    })),
    multiCursorLimit: register(new EditorIntOption(80 /* EditorOption.multiCursorLimit */ , "multiCursorLimit", 10000, 1, 100000, {
        markdownDescription: _nlsJs.localize("multiCursorLimit", "Controls the max number of cursors that can be in an active editor at once.")
    })),
    occurrencesHighlight: register(new EditorStringEnumOption(81 /* EditorOption.occurrencesHighlight */ , "occurrencesHighlight", "singleFile", [
        "off",
        "singleFile",
        "multiFile"
    ], {
        markdownEnumDescriptions: [
            _nlsJs.localize("occurrencesHighlight.off", "Does not highlight occurrences."),
            _nlsJs.localize("occurrencesHighlight.singleFile", "Highlights occurrences only in the current file."),
            _nlsJs.localize("occurrencesHighlight.multiFile", "Experimental: Highlights occurrences across all valid open files.")
        ],
        markdownDescription: _nlsJs.localize("occurrencesHighlight", "Controls whether occurrences should be highlighted across open files.")
    })),
    overviewRulerBorder: register(new EditorBooleanOption(82 /* EditorOption.overviewRulerBorder */ , "overviewRulerBorder", true, {
        description: _nlsJs.localize("overviewRulerBorder", "Controls whether a border should be drawn around the overview ruler.")
    })),
    overviewRulerLanes: register(new EditorIntOption(83 /* EditorOption.overviewRulerLanes */ , "overviewRulerLanes", 3, 0, 3)),
    padding: register(new EditorPadding()),
    pasteAs: register(new EditorPasteAs()),
    parameterHints: register(new EditorParameterHints()),
    peekWidgetDefaultFocus: register(new EditorStringEnumOption(87 /* EditorOption.peekWidgetDefaultFocus */ , "peekWidgetDefaultFocus", "tree", [
        "tree",
        "editor"
    ], {
        enumDescriptions: [
            _nlsJs.localize("peekWidgetDefaultFocus.tree", "Focus the tree when opening peek"),
            _nlsJs.localize("peekWidgetDefaultFocus.editor", "Focus the editor when opening peek")
        ],
        description: _nlsJs.localize("peekWidgetDefaultFocus", "Controls whether to focus the inline editor or the tree in the peek widget.")
    })),
    placeholder: register(new PlaceholderOption()),
    definitionLinkOpensInPeek: register(new EditorBooleanOption(89 /* EditorOption.definitionLinkOpensInPeek */ , "definitionLinkOpensInPeek", false, {
        description: _nlsJs.localize("definitionLinkOpensInPeek", "Controls whether the Go to Definition mouse gesture always opens the peek widget.")
    })),
    quickSuggestions: register(new EditorQuickSuggestions()),
    quickSuggestionsDelay: register(new EditorIntOption(91 /* EditorOption.quickSuggestionsDelay */ , "quickSuggestionsDelay", 10, 0, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ , {
        description: _nlsJs.localize("quickSuggestionsDelay", "Controls the delay in milliseconds after which quick suggestions will show up.")
    })),
    readOnly: register(new EditorBooleanOption(92 /* EditorOption.readOnly */ , "readOnly", false)),
    readOnlyMessage: register(new ReadonlyMessage()),
    renameOnType: register(new EditorBooleanOption(94 /* EditorOption.renameOnType */ , "renameOnType", false, {
        description: _nlsJs.localize("renameOnType", "Controls whether the editor auto renames on type."),
        markdownDeprecationMessage: _nlsJs.localize("renameOnTypeDeprecate", "Deprecated, use `editor.linkedEditing` instead.")
    })),
    renderControlCharacters: register(new EditorBooleanOption(95 /* EditorOption.renderControlCharacters */ , "renderControlCharacters", true, {
        description: _nlsJs.localize("renderControlCharacters", "Controls whether the editor should render control characters."),
        restricted: true
    })),
    renderFinalNewline: register(new EditorStringEnumOption(96 /* EditorOption.renderFinalNewline */ , "renderFinalNewline", _platformJs.isLinux ? "dimmed" : "on", [
        "off",
        "on",
        "dimmed"
    ], {
        description: _nlsJs.localize("renderFinalNewline", "Render last line number when the file ends with a newline.")
    })),
    renderLineHighlight: register(new EditorStringEnumOption(97 /* EditorOption.renderLineHighlight */ , "renderLineHighlight", "line", [
        "none",
        "gutter",
        "line",
        "all"
    ], {
        enumDescriptions: [
            "",
            "",
            "",
            _nlsJs.localize("renderLineHighlight.all", "Highlights both the gutter and the current line.")
        ],
        description: _nlsJs.localize("renderLineHighlight", "Controls how the editor should render the current line highlight.")
    })),
    renderLineHighlightOnlyWhenFocus: register(new EditorBooleanOption(98 /* EditorOption.renderLineHighlightOnlyWhenFocus */ , "renderLineHighlightOnlyWhenFocus", false, {
        description: _nlsJs.localize("renderLineHighlightOnlyWhenFocus", "Controls if the editor should render the current line highlight only when the editor is focused.")
    })),
    renderValidationDecorations: register(new EditorStringEnumOption(99 /* EditorOption.renderValidationDecorations */ , "renderValidationDecorations", "editable", [
        "editable",
        "on",
        "off"
    ])),
    renderWhitespace: register(new EditorStringEnumOption(100 /* EditorOption.renderWhitespace */ , "renderWhitespace", "selection", [
        "none",
        "boundary",
        "selection",
        "trailing",
        "all"
    ], {
        enumDescriptions: [
            "",
            _nlsJs.localize("renderWhitespace.boundary", "Render whitespace characters except for single spaces between words."),
            _nlsJs.localize("renderWhitespace.selection", "Render whitespace characters only on selected text."),
            _nlsJs.localize("renderWhitespace.trailing", "Render only trailing whitespace characters."),
            ""
        ],
        description: _nlsJs.localize("renderWhitespace", "Controls how the editor should render whitespace characters.")
    })),
    revealHorizontalRightPadding: register(new EditorIntOption(101 /* EditorOption.revealHorizontalRightPadding */ , "revealHorizontalRightPadding", 15, 0, 1000)),
    roundedSelection: register(new EditorBooleanOption(102 /* EditorOption.roundedSelection */ , "roundedSelection", true, {
        description: _nlsJs.localize("roundedSelection", "Controls whether selections should have rounded corners.")
    })),
    rulers: register(new EditorRulers()),
    scrollbar: register(new EditorScrollbar()),
    scrollBeyondLastColumn: register(new EditorIntOption(105 /* EditorOption.scrollBeyondLastColumn */ , "scrollBeyondLastColumn", 4, 0, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ , {
        description: _nlsJs.localize("scrollBeyondLastColumn", "Controls the number of extra characters beyond which the editor will scroll horizontally.")
    })),
    scrollBeyondLastLine: register(new EditorBooleanOption(106 /* EditorOption.scrollBeyondLastLine */ , "scrollBeyondLastLine", true, {
        description: _nlsJs.localize("scrollBeyondLastLine", "Controls whether the editor will scroll beyond the last line.")
    })),
    scrollPredominantAxis: register(new EditorBooleanOption(107 /* EditorOption.scrollPredominantAxis */ , "scrollPredominantAxis", true, {
        description: _nlsJs.localize("scrollPredominantAxis", "Scroll only along the predominant axis when scrolling both vertically and horizontally at the same time. Prevents horizontal drift when scrolling vertically on a trackpad.")
    })),
    selectionClipboard: register(new EditorBooleanOption(108 /* EditorOption.selectionClipboard */ , "selectionClipboard", true, {
        description: _nlsJs.localize("selectionClipboard", "Controls whether the Linux primary clipboard should be supported."),
        included: _platformJs.isLinux
    })),
    selectionHighlight: register(new EditorBooleanOption(109 /* EditorOption.selectionHighlight */ , "selectionHighlight", true, {
        description: _nlsJs.localize("selectionHighlight", "Controls whether the editor should highlight matches similar to the selection.")
    })),
    selectOnLineNumbers: register(new EditorBooleanOption(110 /* EditorOption.selectOnLineNumbers */ , "selectOnLineNumbers", true)),
    showFoldingControls: register(new EditorStringEnumOption(111 /* EditorOption.showFoldingControls */ , "showFoldingControls", "mouseover", [
        "always",
        "never",
        "mouseover"
    ], {
        enumDescriptions: [
            _nlsJs.localize("showFoldingControls.always", "Always show the folding controls."),
            _nlsJs.localize("showFoldingControls.never", "Never show the folding controls and reduce the gutter size."),
            _nlsJs.localize("showFoldingControls.mouseover", "Only show the folding controls when the mouse is over the gutter.")
        ],
        description: _nlsJs.localize("showFoldingControls", "Controls when the folding controls on the gutter are shown.")
    })),
    showUnused: register(new EditorBooleanOption(112 /* EditorOption.showUnused */ , "showUnused", true, {
        description: _nlsJs.localize("showUnused", "Controls fading out of unused code.")
    })),
    showDeprecated: register(new EditorBooleanOption(141 /* EditorOption.showDeprecated */ , "showDeprecated", true, {
        description: _nlsJs.localize("showDeprecated", "Controls strikethrough deprecated variables.")
    })),
    inlayHints: register(new EditorInlayHints()),
    snippetSuggestions: register(new EditorStringEnumOption(113 /* EditorOption.snippetSuggestions */ , "snippetSuggestions", "inline", [
        "top",
        "bottom",
        "inline",
        "none"
    ], {
        enumDescriptions: [
            _nlsJs.localize("snippetSuggestions.top", "Show snippet suggestions on top of other suggestions."),
            _nlsJs.localize("snippetSuggestions.bottom", "Show snippet suggestions below other suggestions."),
            _nlsJs.localize("snippetSuggestions.inline", "Show snippets suggestions with other suggestions."),
            _nlsJs.localize("snippetSuggestions.none", "Do not show snippet suggestions.")
        ],
        description: _nlsJs.localize("snippetSuggestions", "Controls whether snippets are shown with other suggestions and how they are sorted.")
    })),
    smartSelect: register(new SmartSelect()),
    smoothScrolling: register(new EditorBooleanOption(115 /* EditorOption.smoothScrolling */ , "smoothScrolling", false, {
        description: _nlsJs.localize("smoothScrolling", "Controls whether the editor will scroll using an animation.")
    })),
    stopRenderingLineAfter: register(new EditorIntOption(118 /* EditorOption.stopRenderingLineAfter */ , "stopRenderingLineAfter", 10000, -1, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ )),
    suggest: register(new EditorSuggest()),
    inlineSuggest: register(new InlineEditorSuggest()),
    inlineEdit: register(new InlineEditorEdit()),
    inlineCompletionsAccessibilityVerbose: register(new EditorBooleanOption(150 /* EditorOption.inlineCompletionsAccessibilityVerbose */ , "inlineCompletionsAccessibilityVerbose", false, {
        description: _nlsJs.localize("inlineCompletionsAccessibilityVerbose", "Controls whether the accessibility hint should be provided to screen reader users when an inline completion is shown.")
    })),
    suggestFontSize: register(new EditorIntOption(120 /* EditorOption.suggestFontSize */ , "suggestFontSize", 0, 0, 1000, {
        markdownDescription: _nlsJs.localize("suggestFontSize", "Font size for the suggest widget. When set to {0}, the value of {1} is used.", "`0`", "`#editor.fontSize#`")
    })),
    suggestLineHeight: register(new EditorIntOption(121 /* EditorOption.suggestLineHeight */ , "suggestLineHeight", 0, 0, 1000, {
        markdownDescription: _nlsJs.localize("suggestLineHeight", "Line height for the suggest widget. When set to {0}, the value of {1} is used. The minimum value is 8.", "`0`", "`#editor.lineHeight#`")
    })),
    suggestOnTriggerCharacters: register(new EditorBooleanOption(122 /* EditorOption.suggestOnTriggerCharacters */ , "suggestOnTriggerCharacters", true, {
        description: _nlsJs.localize("suggestOnTriggerCharacters", "Controls whether suggestions should automatically show up when typing trigger characters.")
    })),
    suggestSelection: register(new EditorStringEnumOption(123 /* EditorOption.suggestSelection */ , "suggestSelection", "first", [
        "first",
        "recentlyUsed",
        "recentlyUsedByPrefix"
    ], {
        markdownEnumDescriptions: [
            _nlsJs.localize("suggestSelection.first", "Always select the first suggestion."),
            _nlsJs.localize("suggestSelection.recentlyUsed", "Select recent suggestions unless further typing selects one, e.g. `console.| -> console.log` because `log` has been completed recently."),
            _nlsJs.localize("suggestSelection.recentlyUsedByPrefix", "Select suggestions based on previous prefixes that have completed those suggestions, e.g. `co -> console` and `con -> const`.")
        ],
        description: _nlsJs.localize("suggestSelection", "Controls how suggestions are pre-selected when showing the suggest list.")
    })),
    tabCompletion: register(new EditorStringEnumOption(124 /* EditorOption.tabCompletion */ , "tabCompletion", "off", [
        "on",
        "off",
        "onlySnippets"
    ], {
        enumDescriptions: [
            _nlsJs.localize("tabCompletion.on", "Tab complete will insert the best matching suggestion when pressing tab."),
            _nlsJs.localize("tabCompletion.off", "Disable tab completions."),
            _nlsJs.localize("tabCompletion.onlySnippets", "Tab complete snippets when their prefix match. Works best when 'quickSuggestions' aren't enabled.")
        ],
        description: _nlsJs.localize("tabCompletion", "Enables tab completions.")
    })),
    tabIndex: register(new EditorIntOption(125 /* EditorOption.tabIndex */ , "tabIndex", 0, -1, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ )),
    unicodeHighlight: register(new UnicodeHighlight()),
    unusualLineTerminators: register(new EditorStringEnumOption(127 /* EditorOption.unusualLineTerminators */ , "unusualLineTerminators", "prompt", [
        "auto",
        "off",
        "prompt"
    ], {
        enumDescriptions: [
            _nlsJs.localize("unusualLineTerminators.auto", "Unusual line terminators are automatically removed."),
            _nlsJs.localize("unusualLineTerminators.off", "Unusual line terminators are ignored."),
            _nlsJs.localize("unusualLineTerminators.prompt", "Unusual line terminators prompt to be removed.")
        ],
        description: _nlsJs.localize("unusualLineTerminators", "Remove unusual line terminators that might cause problems.")
    })),
    useShadowDOM: register(new EditorBooleanOption(128 /* EditorOption.useShadowDOM */ , "useShadowDOM", true)),
    useTabStops: register(new EditorBooleanOption(129 /* EditorOption.useTabStops */ , "useTabStops", true, {
        description: _nlsJs.localize("useTabStops", "Spaces and tabs are inserted and deleted in alignment with tab stops.")
    })),
    wordBreak: register(new EditorStringEnumOption(130 /* EditorOption.wordBreak */ , "wordBreak", "normal", [
        "normal",
        "keepAll"
    ], {
        markdownEnumDescriptions: [
            _nlsJs.localize("wordBreak.normal", "Use the default line break rule."),
            _nlsJs.localize("wordBreak.keepAll", "Word breaks should not be used for Chinese/Japanese/Korean (CJK) text. Non-CJK text behavior is the same as for normal.")
        ],
        description: _nlsJs.localize("wordBreak", "Controls the word break rules used for Chinese/Japanese/Korean (CJK) text.")
    })),
    wordSegmenterLocales: register(new WordSegmenterLocales()),
    wordSeparators: register(new EditorStringOption(132 /* EditorOption.wordSeparators */ , "wordSeparators", (0, _wordHelperJs.USUAL_WORD_SEPARATORS), {
        description: _nlsJs.localize("wordSeparators", "Characters that will be used as word separators when doing word related navigations or operations.")
    })),
    wordWrap: register(new EditorStringEnumOption(133 /* EditorOption.wordWrap */ , "wordWrap", "off", [
        "off",
        "on",
        "wordWrapColumn",
        "bounded"
    ], {
        markdownEnumDescriptions: [
            _nlsJs.localize("wordWrap.off", "Lines will never wrap."),
            _nlsJs.localize("wordWrap.on", "Lines will wrap at the viewport width."),
            _nlsJs.localize({
                key: "wordWrap.wordWrapColumn",
                comment: [
                    "- `editor.wordWrapColumn` refers to a different setting and should not be localized."
                ]
            }, "Lines will wrap at `#editor.wordWrapColumn#`."),
            _nlsJs.localize({
                key: "wordWrap.bounded",
                comment: [
                    "- viewport means the edge of the visible window size.",
                    "- `editor.wordWrapColumn` refers to a different setting and should not be localized."
                ]
            }, "Lines will wrap at the minimum of viewport and `#editor.wordWrapColumn#`.")
        ],
        description: _nlsJs.localize({
            key: "wordWrap",
            comment: [
                "- 'off', 'on', 'wordWrapColumn' and 'bounded' refer to values the setting can take and should not be localized.",
                "- `editor.wordWrapColumn` refers to a different setting and should not be localized."
            ]
        }, "Controls how lines should wrap.")
    })),
    wordWrapBreakAfterCharacters: register(new EditorStringOption(134 /* EditorOption.wordWrapBreakAfterCharacters */ , "wordWrapBreakAfterCharacters", // allow-any-unicode-next-line
    " 	})]?|/&.,;\xa2\xb0\u2032\u2033\u2030\u2103\u3001\u3002\uFF61\uFF64\uFFE0\uFF0C\uFF0E\uFF1A\uFF1B\uFF1F\uFF01\uFF05\u30FB\uFF65\u309D\u309E\u30FD\u30FE\u30FC\u30A1\u30A3\u30A5\u30A7\u30A9\u30C3\u30E3\u30E5\u30E7\u30EE\u30F5\u30F6\u3041\u3043\u3045\u3047\u3049\u3063\u3083\u3085\u3087\u308E\u3095\u3096\u31F0\u31F1\u31F2\u31F3\u31F4\u31F5\u31F6\u31F7\u31F8\u31F9\u31FA\u31FB\u31FC\u31FD\u31FE\u31FF\u3005\u303B\uFF67\uFF68\uFF69\uFF6A\uFF6B\uFF6C\uFF6D\uFF6E\uFF6F\uFF70\u201D\u3009\u300B\u300D\u300F\u3011\u3015\uFF09\uFF3D\uFF5D\uFF63")),
    wordWrapBreakBeforeCharacters: register(new EditorStringOption(135 /* EditorOption.wordWrapBreakBeforeCharacters */ , "wordWrapBreakBeforeCharacters", // allow-any-unicode-next-line
    "([{\u2018\u201C\u3008\u300A\u300C\u300E\u3010\u3014\uFF08\uFF3B\uFF5B\uFF62\xa3\xa5\uFF04\uFFE1\uFFE5+\uFF0B")),
    wordWrapColumn: register(new EditorIntOption(136 /* EditorOption.wordWrapColumn */ , "wordWrapColumn", 80, 1, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ , {
        markdownDescription: _nlsJs.localize({
            key: "wordWrapColumn",
            comment: [
                "- `editor.wordWrap` refers to a different setting and should not be localized.",
                "- 'wordWrapColumn' and 'bounded' refer to values the different setting can take and should not be localized."
            ]
        }, "Controls the wrapping column of the editor when `#editor.wordWrap#` is `wordWrapColumn` or `bounded`.")
    })),
    wordWrapOverride1: register(new EditorStringEnumOption(137 /* EditorOption.wordWrapOverride1 */ , "wordWrapOverride1", "inherit", [
        "off",
        "on",
        "inherit"
    ])),
    wordWrapOverride2: register(new EditorStringEnumOption(138 /* EditorOption.wordWrapOverride2 */ , "wordWrapOverride2", "inherit", [
        "off",
        "on",
        "inherit"
    ])),
    // Leave these at the end (because they have dependencies!)
    editorClassName: register(new EditorClassName()),
    defaultColorDecorators: register(new EditorBooleanOption(148 /* EditorOption.defaultColorDecorators */ , "defaultColorDecorators", false, {
        markdownDescription: _nlsJs.localize("defaultColorDecorators", "Controls whether inline color decorations should be shown using the default document color provider")
    })),
    pixelRatio: register(new EditorPixelRatio()),
    tabFocusMode: register(new EditorBooleanOption(145 /* EditorOption.tabFocusMode */ , "tabFocusMode", false, {
        markdownDescription: _nlsJs.localize("tabFocusMode", "Controls whether the editor receives tabs or defers them to the workbench for navigation.")
    })),
    layoutInfo: register(new EditorLayoutInfoComputer()),
    wrappingInfo: register(new EditorWrappingInfoComputer()),
    wrappingIndent: register(new WrappingIndentOption()),
    wrappingStrategy: register(new WrappingStrategy())
};

},{"../../../base/common/arrays.js":"DECei","../../../base/common/objects.js":"j84mT","../../../base/common/platform.js":"7maJO","../core/textModelDefaults.js":"esbOV","../core/wordHelper.js":"9FjxX","../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"DECei":[function(require,module,exports) {
/**
 * Returns the last element of an array.
 * @param array The array.
 * @param n Which element from the end (default is zero).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tail", ()=>tail);
parcelHelpers.export(exports, "tail2", ()=>tail2);
parcelHelpers.export(exports, "equals", ()=>equals);
/**
 * Remove the element at `index` by replacing it with the last element. This is faster than `splice`
 * but changes the order of the array
 */ parcelHelpers.export(exports, "removeFastWithoutKeepingOrder", ()=>removeFastWithoutKeepingOrder);
/**
 * Performs a binary search algorithm over a sorted array.
 *
 * @param array The array being searched.
 * @param key The value we search for.
 * @param comparator A function that takes two array elements and returns zero
 *   if they are equal, a negative number if the first element precedes the
 *   second one in the sorting order, or a positive number if the second element
 *   precedes the first one.
 * @return See {@link binarySearch2}
 */ parcelHelpers.export(exports, "binarySearch", ()=>binarySearch);
/**
 * Performs a binary search algorithm over a sorted collection. Useful for cases
 * when we need to perform a binary search over something that isn't actually an
 * array, and converting data to an array would defeat the use of binary search
 * in the first place.
 *
 * @param length The collection length.
 * @param compareToKey A function that takes an index of an element in the
 *   collection and returns zero if the value at this index is equal to the
 *   search key, a negative number if the value precedes the search key in the
 *   sorting order, or a positive number if the search key precedes the value.
 * @return A non-negative index of an element, if found. If not found, the
 *   result is -(n+1) (or ~n, using bitwise notation), where n is the index
 *   where the key should be inserted to maintain the sorting order.
 */ parcelHelpers.export(exports, "binarySearch2", ()=>binarySearch2);
parcelHelpers.export(exports, "quickSelect", ()=>quickSelect);
parcelHelpers.export(exports, "groupBy", ()=>groupBy);
/**
 * Splits the given items into a list of (non-empty) groups.
 * `shouldBeGrouped` is used to decide if two consecutive items should be in the same group.
 * The order of the items is preserved.
 */ parcelHelpers.export(exports, "groupAdjacentBy", ()=>groupAdjacentBy);
parcelHelpers.export(exports, "forEachAdjacent", ()=>forEachAdjacent);
parcelHelpers.export(exports, "forEachWithNeighbors", ()=>forEachWithNeighbors);
/**
 * @returns New array with all falsy values removed. The original array IS NOT modified.
 */ parcelHelpers.export(exports, "coalesce", ()=>coalesce);
/**
 * Remove all falsy values from `array`. The original array IS modified.
 */ parcelHelpers.export(exports, "coalesceInPlace", ()=>coalesceInPlace);
/**
 * @returns false if the provided object is an array and not empty.
 */ parcelHelpers.export(exports, "isFalsyOrEmpty", ()=>isFalsyOrEmpty);
parcelHelpers.export(exports, "isNonEmptyArray", ()=>isNonEmptyArray);
/**
 * Removes duplicates from the given array. The optional keyFn allows to specify
 * how elements are checked for equality by returning an alternate value for each.
 */ parcelHelpers.export(exports, "distinct", ()=>distinct);
parcelHelpers.export(exports, "firstOrDefault", ()=>firstOrDefault);
parcelHelpers.export(exports, "range", ()=>range);
/**
 * Insert `insertArr` inside `target` at `insertIndex`.
 * Please don't touch unless you understand https://jsperf.com/inserting-an-array-within-an-array
 */ parcelHelpers.export(exports, "arrayInsert", ()=>arrayInsert);
/**
 * Pushes an element to the start of the array, if found.
 */ parcelHelpers.export(exports, "pushToStart", ()=>pushToStart);
/**
 * Pushes an element to the end of the array, if found.
 */ parcelHelpers.export(exports, "pushToEnd", ()=>pushToEnd);
parcelHelpers.export(exports, "pushMany", ()=>pushMany);
parcelHelpers.export(exports, "asArray", ()=>asArray);
/**
 * Insert the new items in the array.
 * @param array The original array.
 * @param start The zero-based location in the array from which to start inserting elements.
 * @param newItems The items to be inserted
 */ parcelHelpers.export(exports, "insertInto", ()=>insertInto);
/**
 * Removes elements from an array and inserts new elements in their place, returning the deleted elements. Alternative to the native Array.splice method, it
 * can only support limited number of items due to the maximum call stack size limit.
 * @param array The original array.
 * @param start The zero-based location in the array from which to start removing elements.
 * @param deleteCount The number of elements to remove.
 * @returns An array containing the elements that were deleted.
 */ parcelHelpers.export(exports, "splice", ()=>splice);
parcelHelpers.export(exports, "CompareResult", ()=>CompareResult);
parcelHelpers.export(exports, "compareBy", ()=>compareBy);
parcelHelpers.export(exports, "tieBreakComparators", ()=>tieBreakComparators);
parcelHelpers.export(exports, "numberComparator", ()=>numberComparator);
parcelHelpers.export(exports, "booleanComparator", ()=>booleanComparator);
parcelHelpers.export(exports, "reverseOrder", ()=>reverseOrder);
parcelHelpers.export(exports, "ArrayQueue", ()=>ArrayQueue);
/**
 * This class is faster than an iterator and array for lazy computed data.
*/ parcelHelpers.export(exports, "CallbackIterable", ()=>CallbackIterable);
/**
 * Represents a re-arrangement of items in an array.
 */ parcelHelpers.export(exports, "Permutation", ()=>Permutation);
function tail(array, n = 0) {
    return array[array.length - (1 + n)];
}
function tail2(arr) {
    if (arr.length === 0) throw new Error("Invalid tail call");
    return [
        arr.slice(0, arr.length - 1),
        arr[arr.length - 1]
    ];
}
function equals(one, other, itemEquals = (a, b)=>a === b) {
    if (one === other) return true;
    if (!one || !other) return false;
    if (one.length !== other.length) return false;
    for(let i = 0, len = one.length; i < len; i++){
        if (!itemEquals(one[i], other[i])) return false;
    }
    return true;
}
function removeFastWithoutKeepingOrder(array, index) {
    const last = array.length - 1;
    if (index < last) array[index] = array[last];
    array.pop();
}
function binarySearch(array, key, comparator) {
    return binarySearch2(array.length, (i)=>comparator(array[i], key));
}
function binarySearch2(length, compareToKey) {
    let low = 0, high = length - 1;
    while(low <= high){
        const mid = (low + high) / 2 | 0;
        const comp = compareToKey(mid);
        if (comp < 0) low = mid + 1;
        else if (comp > 0) high = mid - 1;
        else return mid;
    }
    return -(low + 1);
}
function quickSelect(nth, data, compare) {
    nth = nth | 0;
    if (nth >= data.length) throw new TypeError("invalid index");
    const pivotValue = data[Math.floor(data.length * Math.random())];
    const lower = [];
    const higher = [];
    const pivots = [];
    for (const value of data){
        const val = compare(value, pivotValue);
        if (val < 0) lower.push(value);
        else if (val > 0) higher.push(value);
        else pivots.push(value);
    }
    if (nth < lower.length) return quickSelect(nth, lower, compare);
    else if (nth < lower.length + pivots.length) return pivots[0];
    else return quickSelect(nth - (lower.length + pivots.length), higher, compare);
}
function groupBy(data, compare) {
    const result = [];
    let currentGroup = undefined;
    for (const element of data.slice(0).sort(compare))if (!currentGroup || compare(currentGroup[0], element) !== 0) {
        currentGroup = [
            element
        ];
        result.push(currentGroup);
    } else currentGroup.push(element);
    return result;
}
function* groupAdjacentBy(items, shouldBeGrouped) {
    let currentGroup;
    let last;
    for (const item of items){
        if (last !== undefined && shouldBeGrouped(last, item)) currentGroup.push(item);
        else {
            if (currentGroup) yield currentGroup;
            currentGroup = [
                item
            ];
        }
        last = item;
    }
    if (currentGroup) yield currentGroup;
}
function forEachAdjacent(arr, f) {
    for(let i = 0; i <= arr.length; i++)f(i === 0 ? undefined : arr[i - 1], i === arr.length ? undefined : arr[i]);
}
function forEachWithNeighbors(arr, f) {
    for(let i = 0; i < arr.length; i++)f(i === 0 ? undefined : arr[i - 1], arr[i], i + 1 === arr.length ? undefined : arr[i + 1]);
}
function coalesce(array) {
    return array.filter((e)=>!!e);
}
function coalesceInPlace(array) {
    let to = 0;
    for(let i = 0; i < array.length; i++)if (!!array[i]) {
        array[to] = array[i];
        to += 1;
    }
    array.length = to;
}
function isFalsyOrEmpty(obj) {
    return !Array.isArray(obj) || obj.length === 0;
}
function isNonEmptyArray(obj) {
    return Array.isArray(obj) && obj.length > 0;
}
function distinct(array, keyFn = (value)=>value) {
    const seen = new Set();
    return array.filter((element)=>{
        const key = keyFn(element);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}
function firstOrDefault(array, notFoundValue) {
    return array.length > 0 ? array[0] : notFoundValue;
}
function range(arg, to) {
    let from = typeof to === "number" ? arg : 0;
    if (typeof to === "number") from = arg;
    else {
        from = 0;
        to = arg;
    }
    const result = [];
    if (from <= to) for(let i = from; i < to; i++)result.push(i);
    else for(let i = from; i > to; i--)result.push(i);
    return result;
}
function arrayInsert(target, insertIndex, insertArr) {
    const before = target.slice(0, insertIndex);
    const after = target.slice(insertIndex);
    return before.concat(insertArr, after);
}
function pushToStart(arr, value) {
    const index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
        arr.unshift(value);
    }
}
function pushToEnd(arr, value) {
    const index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
        arr.push(value);
    }
}
function pushMany(arr, items) {
    for (const item of items)arr.push(item);
}
function asArray(x) {
    return Array.isArray(x) ? x : [
        x
    ];
}
function insertInto(array, start, newItems) {
    const startIdx = getActualStartIndex(array, start);
    const originalLength = array.length;
    const newItemsLength = newItems.length;
    array.length = originalLength + newItemsLength;
    // Move the items after the start index, start from the end so that we don't overwrite any value.
    for(let i = originalLength - 1; i >= startIdx; i--)array[i + newItemsLength] = array[i];
    for(let i = 0; i < newItemsLength; i++)array[i + startIdx] = newItems[i];
}
function splice(array, start, deleteCount, newItems) {
    const index = getActualStartIndex(array, start);
    let result = array.splice(index, deleteCount);
    if (result === undefined) // see https://bugs.webkit.org/show_bug.cgi?id=261140
    result = [];
    insertInto(array, index, newItems);
    return result;
}
/**
 * Determine the actual start index (same logic as the native splice() or slice())
 * If greater than the length of the array, start will be set to the length of the array. In this case, no element will be deleted but the method will behave as an adding function, adding as many element as item[n*] provided.
 * If negative, it will begin that many elements from the end of the array. (In this case, the origin -1, meaning -n is the index of the nth last element, and is therefore equivalent to the index of array.length - n.) If array.length + start is less than 0, it will begin from index 0.
 * @param array The target array.
 * @param start The operation index.
 */ function getActualStartIndex(array, start) {
    return start < 0 ? Math.max(start + array.length, 0) : Math.min(start, array.length);
}
var CompareResult;
(function(CompareResult) {
    function isLessThan(result) {
        return result < 0;
    }
    CompareResult.isLessThan = isLessThan;
    function isLessThanOrEqual(result) {
        return result <= 0;
    }
    CompareResult.isLessThanOrEqual = isLessThanOrEqual;
    function isGreaterThan(result) {
        return result > 0;
    }
    CompareResult.isGreaterThan = isGreaterThan;
    function isNeitherLessOrGreaterThan(result) {
        return result === 0;
    }
    CompareResult.isNeitherLessOrGreaterThan = isNeitherLessOrGreaterThan;
    CompareResult.greaterThan = 1;
    CompareResult.lessThan = -1;
    CompareResult.neitherLessOrGreaterThan = 0;
})(CompareResult || (CompareResult = {}));
function compareBy(selector, comparator) {
    return (a, b)=>comparator(selector(a), selector(b));
}
function tieBreakComparators(...comparators) {
    return (item1, item2)=>{
        for (const comparator of comparators){
            const result = comparator(item1, item2);
            if (!CompareResult.isNeitherLessOrGreaterThan(result)) return result;
        }
        return CompareResult.neitherLessOrGreaterThan;
    };
}
const numberComparator = (a, b)=>a - b;
const booleanComparator = (a, b)=>numberComparator(a ? 1 : 0, b ? 1 : 0);
function reverseOrder(comparator) {
    return (a, b)=>-comparator(a, b);
}
class ArrayQueue {
    /**
     * Constructs a queue that is backed by the given array. Runtime is O(1).
    */ constructor(items){
        this.items = items;
        this.firstIdx = 0;
        this.lastIdx = this.items.length - 1;
    }
    get length() {
        return this.lastIdx - this.firstIdx + 1;
    }
    /**
     * Consumes elements from the beginning of the queue as long as the predicate returns true.
     * If no elements were consumed, `null` is returned. Has a runtime of O(result.length).
    */ takeWhile(predicate) {
        // P(k) := k <= this.lastIdx && predicate(this.items[k])
        // Find s := min { k | k >= this.firstIdx && !P(k) } and return this.data[this.firstIdx...s)
        let startIdx = this.firstIdx;
        while(startIdx < this.items.length && predicate(this.items[startIdx]))startIdx++;
        const result = startIdx === this.firstIdx ? null : this.items.slice(this.firstIdx, startIdx);
        this.firstIdx = startIdx;
        return result;
    }
    /**
     * Consumes elements from the end of the queue as long as the predicate returns true.
     * If no elements were consumed, `null` is returned.
     * The result has the same order as the underlying array!
    */ takeFromEndWhile(predicate) {
        // P(k) := this.firstIdx >= k && predicate(this.items[k])
        // Find s := max { k | k <= this.lastIdx && !P(k) } and return this.data(s...this.lastIdx]
        let endIdx = this.lastIdx;
        while(endIdx >= 0 && predicate(this.items[endIdx]))endIdx--;
        const result = endIdx === this.lastIdx ? null : this.items.slice(endIdx + 1, this.lastIdx + 1);
        this.lastIdx = endIdx;
        return result;
    }
    peek() {
        if (this.length === 0) return undefined;
        return this.items[this.firstIdx];
    }
    dequeue() {
        const result = this.items[this.firstIdx];
        this.firstIdx++;
        return result;
    }
    takeCount(count) {
        const result = this.items.slice(this.firstIdx, this.firstIdx + count);
        this.firstIdx += count;
        return result;
    }
}
class CallbackIterable {
    static{
        this.empty = new CallbackIterable((_callback)=>{});
    }
    constructor(/**
     * Calls the callback for every item.
     * Stops when the callback returns false.
    */ iterate){
        this.iterate = iterate;
    }
    toArray() {
        const result = [];
        this.iterate((item)=>{
            result.push(item);
            return true;
        });
        return result;
    }
    filter(predicate) {
        return new CallbackIterable((cb)=>this.iterate((item)=>predicate(item) ? cb(item) : true));
    }
    map(mapFn) {
        return new CallbackIterable((cb)=>this.iterate((item)=>cb(mapFn(item))));
    }
    findLast(predicate) {
        let result;
        this.iterate((item)=>{
            if (predicate(item)) result = item;
            return true;
        });
        return result;
    }
    findLastMaxBy(comparator) {
        let result;
        let first = true;
        this.iterate((item)=>{
            if (first || CompareResult.isGreaterThan(comparator(item, result))) {
                first = false;
                result = item;
            }
            return true;
        });
        return result;
    }
}
class Permutation {
    constructor(_indexMap){
        this._indexMap = _indexMap;
    }
    /**
     * Returns a permutation that sorts the given array according to the given compare function.
     */ static createSortPermutation(arr, compareFn) {
        const sortIndices = Array.from(arr.keys()).sort((index1, index2)=>compareFn(arr[index1], arr[index2]));
        return new Permutation(sortIndices);
    }
    /**
     * Returns a new array with the elements of the given array re-arranged according to this permutation.
     */ apply(arr) {
        return arr.map((_, index)=>arr[this._indexMap[index]]);
    }
    /**
     * Returns a new permutation that undoes the re-arrangement of this permutation.
    */ inverse() {
        const inverseIndexMap = this._indexMap.slice();
        for(let i = 0; i < this._indexMap.length; i++)inverseIndexMap[this._indexMap[i]] = i;
        return new Permutation(inverseIndexMap);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j84mT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepClone", ()=>deepClone);
parcelHelpers.export(exports, "deepFreeze", ()=>deepFreeze);
parcelHelpers.export(exports, "cloneAndChange", ()=>cloneAndChange);
/**
 * Copies all properties of source into destination. The optional parameter "overwrite" allows to control
 * if existing properties on the destination should be overwritten or not. Defaults to true (overwrite).
 */ parcelHelpers.export(exports, "mixin", ()=>mixin);
parcelHelpers.export(exports, "equals", ()=>equals);
parcelHelpers.export(exports, "getAllPropertyNames", ()=>getAllPropertyNames);
parcelHelpers.export(exports, "getAllMethodNames", ()=>getAllMethodNames);
parcelHelpers.export(exports, "createProxyObject", ()=>createProxyObject);
var _typesJs = require("./types.js");
function deepClone(obj) {
    if (!obj || typeof obj !== "object") return obj;
    if (obj instanceof RegExp) return obj;
    const result = Array.isArray(obj) ? [] : {};
    Object.entries(obj).forEach(([key, value])=>{
        result[key] = value && typeof value === "object" ? deepClone(value) : value;
    });
    return result;
}
function deepFreeze(obj) {
    if (!obj || typeof obj !== "object") return obj;
    const stack = [
        obj
    ];
    while(stack.length > 0){
        const obj = stack.shift();
        Object.freeze(obj);
        for(const key in obj)if (_hasOwnProperty.call(obj, key)) {
            const prop = obj[key];
            if (typeof prop === "object" && !Object.isFrozen(prop) && !(0, _typesJs.isTypedArray)(prop)) stack.push(prop);
        }
    }
    return obj;
}
const _hasOwnProperty = Object.prototype.hasOwnProperty;
function cloneAndChange(obj, changer) {
    return _cloneAndChange(obj, changer, new Set());
}
function _cloneAndChange(obj, changer, seen) {
    if ((0, _typesJs.isUndefinedOrNull)(obj)) return obj;
    const changed = changer(obj);
    if (typeof changed !== "undefined") return changed;
    if (Array.isArray(obj)) {
        const r1 = [];
        for (const e of obj)r1.push(_cloneAndChange(e, changer, seen));
        return r1;
    }
    if ((0, _typesJs.isObject)(obj)) {
        if (seen.has(obj)) throw new Error("Cannot clone recursive data-structure");
        seen.add(obj);
        const r2 = {};
        for(const i2 in obj)if (_hasOwnProperty.call(obj, i2)) r2[i2] = _cloneAndChange(obj[i2], changer, seen);
        seen.delete(obj);
        return r2;
    }
    return obj;
}
function mixin(destination, source, overwrite = true) {
    if (!(0, _typesJs.isObject)(destination)) return source;
    if ((0, _typesJs.isObject)(source)) Object.keys(source).forEach((key)=>{
        if (key in destination) {
            if (overwrite) {
                if ((0, _typesJs.isObject)(destination[key]) && (0, _typesJs.isObject)(source[key])) mixin(destination[key], source[key], overwrite);
                else destination[key] = source[key];
            }
        } else destination[key] = source[key];
    });
    return destination;
}
function equals(one, other) {
    if (one === other) return true;
    if (one === null || one === undefined || other === null || other === undefined) return false;
    if (typeof one !== typeof other) return false;
    if (typeof one !== "object") return false;
    if (Array.isArray(one) !== Array.isArray(other)) return false;
    let i;
    let key;
    if (Array.isArray(one)) {
        if (one.length !== other.length) return false;
        for(i = 0; i < one.length; i++){
            if (!equals(one[i], other[i])) return false;
        }
    } else {
        const oneKeys = [];
        for(key in one)oneKeys.push(key);
        oneKeys.sort();
        const otherKeys = [];
        for(key in other)otherKeys.push(key);
        otherKeys.sort();
        if (!equals(oneKeys, otherKeys)) return false;
        for(i = 0; i < oneKeys.length; i++){
            if (!equals(one[oneKeys[i]], other[oneKeys[i]])) return false;
        }
    }
    return true;
}
function getAllPropertyNames(obj) {
    let res = [];
    while(Object.prototype !== obj){
        res = res.concat(Object.getOwnPropertyNames(obj));
        obj = Object.getPrototypeOf(obj);
    }
    return res;
}
function getAllMethodNames(obj) {
    const methods = [];
    for (const prop of getAllPropertyNames(obj))if (typeof obj[prop] === "function") methods.push(prop);
    return methods;
}
function createProxyObject(methodNames, invoke) {
    const createProxyMethod = (method)=>{
        return function() {
            const args = Array.prototype.slice.call(arguments, 0);
            return invoke(method, args);
        };
    };
    const result = {};
    for (const methodName of methodNames)result[methodName] = createProxyMethod(methodName);
    return result;
}

},{"./types.js":"fb5yx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fb5yx":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 * @returns whether the provided parameter is a JavaScript String or not.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isString", ()=>isString);
/**
 * @returns whether the provided parameter is of type `object` but **not**
 *	`null`, an `array`, a `regexp`, nor a `date`.
 */ parcelHelpers.export(exports, "isObject", ()=>isObject);
/**
 * @returns whether the provided parameter is of type `Buffer` or Uint8Array dervived type
 */ parcelHelpers.export(exports, "isTypedArray", ()=>isTypedArray);
/**
 * In **contrast** to just checking `typeof` this will return `false` for `NaN`.
 * @returns whether the provided parameter is a JavaScript Number or not.
 */ parcelHelpers.export(exports, "isNumber", ()=>isNumber);
/**
 * @returns whether the provided parameter is an Iterable, casting to the given generic
 */ parcelHelpers.export(exports, "isIterable", ()=>isIterable);
/**
 * @returns whether the provided parameter is a JavaScript Boolean or not.
 */ parcelHelpers.export(exports, "isBoolean", ()=>isBoolean);
/**
 * @returns whether the provided parameter is undefined.
 */ parcelHelpers.export(exports, "isUndefined", ()=>isUndefined);
/**
 * @returns whether the provided parameter is defined.
 */ parcelHelpers.export(exports, "isDefined", ()=>isDefined);
/**
 * @returns whether the provided parameter is undefined or null.
 */ parcelHelpers.export(exports, "isUndefinedOrNull", ()=>isUndefinedOrNull);
parcelHelpers.export(exports, "assertType", ()=>assertType);
/**
 * Asserts that the argument passed in is neither undefined nor null.
 */ parcelHelpers.export(exports, "assertIsDefined", ()=>assertIsDefined);
/**
 * @returns whether the provided parameter is a JavaScript Function or not.
 */ parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "validateConstraints", ()=>validateConstraints);
parcelHelpers.export(exports, "validateConstraint", ()=>validateConstraint);
function isString(str) {
    return typeof str === "string";
}
function isObject(obj) {
    // The method can't do a type cast since there are type (like strings) which
    // are subclasses of any put not positvely matched by the function. Hence type
    // narrowing results in wrong results.
    return typeof obj === "object" && obj !== null && !Array.isArray(obj) && !(obj instanceof RegExp) && !(obj instanceof Date);
}
function isTypedArray(obj) {
    const TypedArray = Object.getPrototypeOf(Uint8Array);
    return typeof obj === "object" && obj instanceof TypedArray;
}
function isNumber(obj) {
    return typeof obj === "number" && !isNaN(obj);
}
function isIterable(obj) {
    return !!obj && typeof obj[Symbol.iterator] === "function";
}
function isBoolean(obj) {
    return obj === true || obj === false;
}
function isUndefined(obj) {
    return typeof obj === "undefined";
}
function isDefined(arg) {
    return !isUndefinedOrNull(arg);
}
function isUndefinedOrNull(obj) {
    return isUndefined(obj) || obj === null;
}
function assertType(condition, type) {
    if (!condition) throw new Error(type ? `Unexpected type, expected '${type}'` : "Unexpected type");
}
function assertIsDefined(arg) {
    if (isUndefinedOrNull(arg)) throw new Error("Assertion Failed: argument is undefined or null");
    return arg;
}
function isFunction(obj) {
    return typeof obj === "function";
}
function validateConstraints(args, constraints) {
    const len = Math.min(args.length, constraints.length);
    for(let i = 0; i < len; i++)validateConstraint(args[i], constraints[i]);
}
function validateConstraint(arg, constraint) {
    if (isString(constraint)) {
        if (typeof arg !== constraint) throw new Error(`argument does not match constraint: typeof ${constraint}`);
    } else if (isFunction(constraint)) {
        try {
            if (arg instanceof constraint) return;
        } catch  {
        // ignore
        }
        if (!isUndefinedOrNull(arg) && arg.constructor === constraint) return;
        if (constraint.length === 1 && constraint.call(undefined, arg) === true) return;
        throw new Error(`argument does not match one of these constraints: arg instanceof constraint, arg.constructor === constraint, nor constraint(arg) === true`);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7maJO":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LANGUAGE_DEFAULT", ()=>LANGUAGE_DEFAULT);
parcelHelpers.export(exports, "isWindows", ()=>isWindows);
parcelHelpers.export(exports, "isMacintosh", ()=>isMacintosh);
parcelHelpers.export(exports, "isLinux", ()=>isLinux);
parcelHelpers.export(exports, "isNative", ()=>isNative);
parcelHelpers.export(exports, "isWeb", ()=>isWeb);
parcelHelpers.export(exports, "isWebWorker", ()=>isWebWorker);
parcelHelpers.export(exports, "webWorkerOrigin", ()=>webWorkerOrigin);
parcelHelpers.export(exports, "isIOS", ()=>isIOS);
parcelHelpers.export(exports, "isMobile", ()=>isMobile);
parcelHelpers.export(exports, "userAgent", ()=>userAgent);
parcelHelpers.export(exports, "language", ()=>language);
parcelHelpers.export(exports, "setTimeout0IsFaster", ()=>setTimeout0IsFaster);
parcelHelpers.export(exports, "setTimeout0", ()=>setTimeout0);
parcelHelpers.export(exports, "OS", ()=>OS);
parcelHelpers.export(exports, "isLittleEndian", ()=>isLittleEndian);
parcelHelpers.export(exports, "isChrome", ()=>isChrome);
parcelHelpers.export(exports, "isFirefox", ()=>isFirefox);
parcelHelpers.export(exports, "isSafari", ()=>isSafari);
parcelHelpers.export(exports, "isEdge", ()=>isEdge);
parcelHelpers.export(exports, "isAndroid", ()=>isAndroid);
var _nlsJs = require("../../nls.js");
var process = require("c568f9aa2888cdea");
const LANGUAGE_DEFAULT = "en";
let _isWindows = false;
let _isMacintosh = false;
let _isLinux = false;
let _isLinuxSnap = false;
let _isNative = false;
let _isWeb = false;
let _isElectron = false;
let _isIOS = false;
let _isCI = false;
let _isMobile = false;
let _locale = undefined;
let _language = LANGUAGE_DEFAULT;
let _platformLocale = LANGUAGE_DEFAULT;
let _translationsConfigFile = undefined;
let _userAgent = undefined;
const $globalThis = globalThis;
let nodeProcess = undefined;
if (typeof $globalThis.vscode !== "undefined" && typeof $globalThis.vscode.process !== "undefined") // Native environment (sandboxed)
nodeProcess = $globalThis.vscode.process;
else if (typeof process !== "undefined" && typeof process?.versions?.node === "string") // Native environment (non-sandboxed)
nodeProcess = process;
const isElectronProcess = typeof nodeProcess?.versions?.electron === "string";
const isElectronRenderer = isElectronProcess && nodeProcess?.type === "renderer";
// Native environment
if (typeof nodeProcess === "object") {
    _isWindows = nodeProcess.platform === "win32";
    _isMacintosh = nodeProcess.platform === "darwin";
    _isLinux = nodeProcess.platform === "linux";
    _isLinuxSnap = _isLinux && !!nodeProcess.env["SNAP"] && !!nodeProcess.env["SNAP_REVISION"];
    _isElectron = isElectronProcess;
    _isCI = !!nodeProcess.env["CI"] || !!nodeProcess.env["BUILD_ARTIFACTSTAGINGDIRECTORY"];
    _locale = LANGUAGE_DEFAULT;
    _language = LANGUAGE_DEFAULT;
    const rawNlsConfig = nodeProcess.env["VSCODE_NLS_CONFIG"];
    if (rawNlsConfig) try {
        const nlsConfig = JSON.parse(rawNlsConfig);
        _locale = nlsConfig.userLocale;
        _platformLocale = nlsConfig.osLocale;
        _language = nlsConfig.resolvedLanguage || LANGUAGE_DEFAULT;
        _translationsConfigFile = nlsConfig.languagePack?.translationsConfigFile;
    } catch (e) {}
    _isNative = true;
} else if (typeof navigator === "object" && !isElectronRenderer) {
    _userAgent = navigator.userAgent;
    _isWindows = _userAgent.indexOf("Windows") >= 0;
    _isMacintosh = _userAgent.indexOf("Macintosh") >= 0;
    _isIOS = (_userAgent.indexOf("Macintosh") >= 0 || _userAgent.indexOf("iPad") >= 0 || _userAgent.indexOf("iPhone") >= 0) && !!navigator.maxTouchPoints && navigator.maxTouchPoints > 0;
    _isLinux = _userAgent.indexOf("Linux") >= 0;
    _isMobile = _userAgent?.indexOf("Mobi") >= 0;
    _isWeb = true;
    _language = _nlsJs.getNLSLanguage() || LANGUAGE_DEFAULT;
    _locale = navigator.language.toLowerCase();
    _platformLocale = _locale;
} else console.error("Unable to resolve platform.");
let _platform = 0 /* Platform.Web */ ;
if (_isMacintosh) _platform = 1 /* Platform.Mac */ ;
else if (_isWindows) _platform = 3 /* Platform.Windows */ ;
else if (_isLinux) _platform = 2 /* Platform.Linux */ ;
const isWindows = _isWindows;
const isMacintosh = _isMacintosh;
const isLinux = _isLinux;
const isNative = _isNative;
const isWeb = _isWeb;
const isWebWorker = _isWeb && typeof $globalThis.importScripts === "function";
const webWorkerOrigin = isWebWorker ? $globalThis.origin : undefined;
const isIOS = _isIOS;
const isMobile = _isMobile;
const userAgent = _userAgent;
const language = _language;
const setTimeout0IsFaster = typeof $globalThis.postMessage === "function" && !$globalThis.importScripts;
const setTimeout0 = (()=>{
    if (setTimeout0IsFaster) {
        const pending = [];
        $globalThis.addEventListener("message", (e)=>{
            if (e.data && e.data.vscodeScheduleAsyncWork) for(let i = 0, len = pending.length; i < len; i++){
                const candidate = pending[i];
                if (candidate.id === e.data.vscodeScheduleAsyncWork) {
                    pending.splice(i, 1);
                    candidate.callback();
                    return;
                }
            }
        });
        let lastId = 0;
        return (callback)=>{
            const myId = ++lastId;
            pending.push({
                id: myId,
                callback: callback
            });
            $globalThis.postMessage({
                vscodeScheduleAsyncWork: myId
            }, "*");
        };
    }
    return (callback)=>setTimeout(callback);
})();
const OS = _isMacintosh || _isIOS ? 2 /* OperatingSystem.Macintosh */  : _isWindows ? 1 /* OperatingSystem.Windows */  : 3 /* OperatingSystem.Linux */ ;
let _isLittleEndian = true;
let _isLittleEndianComputed = false;
function isLittleEndian() {
    if (!_isLittleEndianComputed) {
        _isLittleEndianComputed = true;
        const test = new Uint8Array(2);
        test[0] = 1;
        test[1] = 2;
        const view = new Uint16Array(test.buffer);
        _isLittleEndian = view[0] === 513;
    }
    return _isLittleEndian;
}
const isChrome = !!(userAgent && userAgent.indexOf("Chrome") >= 0);
const isFirefox = !!(userAgent && userAgent.indexOf("Firefox") >= 0);
const isSafari = !!(!isChrome && userAgent && userAgent.indexOf("Safari") >= 0);
const isEdge = !!(userAgent && userAgent.indexOf("Edg/") >= 0);
const isAndroid = !!(userAgent && userAgent.indexOf("Android") >= 0);

},{"c568f9aa2888cdea":"13Pcp","../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l617d":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ // eslint-disable-next-line local/code-import-patterns
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line local/code-import-patterns
parcelHelpers.export(exports, "getNLSLanguage", ()=>(0, _nlsMessagesJs.getNLSLanguage));
parcelHelpers.export(exports, "getNLSMessages", ()=>(0, _nlsMessagesJs.getNLSMessages));
/**
 * @skipMangle
 */ parcelHelpers.export(exports, "localize", ()=>localize);
/**
 * @skipMangle
 */ parcelHelpers.export(exports, "localize2", ()=>localize2);
var _nlsMessagesJs = require("./nls.messages.js");
const isPseudo = (0, _nlsMessagesJs.getNLSLanguage)() === "pseudo" || typeof document !== "undefined" && document.location && document.location.hash.indexOf("pseudo=true") >= 0;
function _format(message, args) {
    let result;
    if (args.length === 0) result = message;
    else result = message.replace(/\{(\d+)\}/g, (match, rest)=>{
        const index = rest[0];
        const arg = args[index];
        let result = match;
        if (typeof arg === "string") result = arg;
        else if (typeof arg === "number" || typeof arg === "boolean" || arg === void 0 || arg === null) result = String(arg);
        return result;
    });
    if (isPseudo) // FF3B and FF3D is the Unicode zenkaku representation for [ and ]
    result = "\uFF3B" + result.replace(/[aouei]/g, "$&$&") + "\uFF3D";
    return result;
}
function localize(data /* | number when built */ , message /* | null when built */ , ...args) {
    if (typeof data === "number") return _format(lookupMessage(data, message), args);
    return _format(message, args);
}
/**
 * Only used when built: Looks up the message in the global NLS table.
 * This table is being made available as a global through bootstrapping
 * depending on the target context.
 */ function lookupMessage(index, fallback) {
    const message = (0, _nlsMessagesJs.getNLSMessages)()?.[index];
    if (typeof message !== "string") {
        if (typeof fallback === "string") return fallback;
        throw new Error(`!!! NLS MISSING: ${index} !!!`);
    }
    return message;
}
function localize2(data /* | number when built */ , originalMessage, ...args) {
    let message;
    if (typeof data === "number") message = lookupMessage(data, originalMessage);
    else message = originalMessage;
    const value = _format(message, args);
    return {
        value,
        original: originalMessage === message ? value : _format(originalMessage, args)
    };
}

},{"./nls.messages.js":"k145s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k145s":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /*
 * This module exists so that the AMD build of the monaco editor can replace this with an async loader plugin.
 * If you add new functions to this module make sure that they are also provided in the AMD build of the monaco editor.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNLSMessages", ()=>getNLSMessages);
parcelHelpers.export(exports, "getNLSLanguage", ()=>getNLSLanguage);
function getNLSMessages() {
    return globalThis._VSCODE_NLS_MESSAGES;
}
function getNLSLanguage() {
    return globalThis._VSCODE_NLS_LANGUAGE;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"esbOV":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EDITOR_MODEL_DEFAULTS", ()=>EDITOR_MODEL_DEFAULTS);
const EDITOR_MODEL_DEFAULTS = {
    tabSize: 4,
    indentSize: 4,
    insertSpaces: true,
    detectIndentation: true,
    trimAutoWhitespace: true,
    largeFileOptimizations: true,
    bracketPairColorizationOptions: {
        enabled: true,
        independentColorPoolPerBracketType: false
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9FjxX":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USUAL_WORD_SEPARATORS", ()=>USUAL_WORD_SEPARATORS);
parcelHelpers.export(exports, "DEFAULT_WORD_REGEXP", ()=>DEFAULT_WORD_REGEXP);
parcelHelpers.export(exports, "ensureValidWordDefinition", ()=>ensureValidWordDefinition);
parcelHelpers.export(exports, "getWordAtText", ()=>getWordAtText);
var _iteratorJs = require("../../../base/common/iterator.js");
var _linkedListJs = require("../../../base/common/linkedList.js");
const USUAL_WORD_SEPARATORS = "`~!@#$%^&*()-=+[{]}\\|;:'\",.<>/?";
/**
 * Create a word definition regular expression based on default word separators.
 * Optionally provide allowed separators that should be included in words.
 *
 * The default would look like this:
 * /(-?\d*\.\d\w*)|([^\`\~\!\@\#\$\%\^\&\*\(\)\-\=\+\[\{\]\}\\\|\;\:\'\"\,\.\<\>\/\?\s]+)/g
 */ function createWordRegExp(allowInWords = "") {
    let source = "(-?\\d*\\.\\d\\w*)|([^";
    for (const sep of USUAL_WORD_SEPARATORS){
        if (allowInWords.indexOf(sep) >= 0) continue;
        source += "\\" + sep;
    }
    source += "\\s]+)";
    return new RegExp(source, "g");
}
const DEFAULT_WORD_REGEXP = createWordRegExp();
function ensureValidWordDefinition(wordDefinition) {
    let result = DEFAULT_WORD_REGEXP;
    if (wordDefinition && wordDefinition instanceof RegExp) {
        if (!wordDefinition.global) {
            let flags = "g";
            if (wordDefinition.ignoreCase) flags += "i";
            if (wordDefinition.multiline) flags += "m";
            if (wordDefinition.unicode) flags += "u";
            result = new RegExp(wordDefinition.source, flags);
        } else result = wordDefinition;
    }
    result.lastIndex = 0;
    return result;
}
const _defaultConfig = new (0, _linkedListJs.LinkedList)();
_defaultConfig.unshift({
    maxLen: 1000,
    windowSize: 15,
    timeBudget: 150
});
function getWordAtText(column, wordDefinition, text, textOffset, config) {
    // Ensure the regex has the 'g' flag, otherwise this will loop forever
    wordDefinition = ensureValidWordDefinition(wordDefinition);
    if (!config) config = (0, _iteratorJs.Iterable).first(_defaultConfig);
    if (text.length > config.maxLen) {
        // don't throw strings that long at the regexp
        // but use a sub-string in which a word must occur
        let start = column - config.maxLen / 2;
        if (start < 0) start = 0;
        else textOffset += start;
        text = text.substring(start, column + config.maxLen / 2);
        return getWordAtText(column, wordDefinition, text, textOffset, config);
    }
    const t1 = Date.now();
    const pos = column - 1 - textOffset;
    let prevRegexIndex = -1;
    let match = null;
    for(let i = 1;; i++){
        // check time budget
        if (Date.now() - t1 >= config.timeBudget) break;
        // reset the index at which the regexp should start matching, also know where it
        // should stop so that subsequent search don't repeat previous searches
        const regexIndex = pos - config.windowSize * i;
        wordDefinition.lastIndex = Math.max(0, regexIndex);
        const thisMatch = _findRegexMatchEnclosingPosition(wordDefinition, text, pos, prevRegexIndex);
        if (!thisMatch && match) break;
        match = thisMatch;
        // stop: searched at start
        if (regexIndex <= 0) break;
        prevRegexIndex = regexIndex;
    }
    if (match) {
        const result = {
            word: match[0],
            startColumn: textOffset + 1 + match.index,
            endColumn: textOffset + 1 + match.index + match[0].length
        };
        wordDefinition.lastIndex = 0;
        return result;
    }
    return null;
}
function _findRegexMatchEnclosingPosition(wordDefinition, text, pos, stopPos) {
    let match;
    while(match = wordDefinition.exec(text)){
        const matchIndex = match.index || 0;
        if (matchIndex <= pos && wordDefinition.lastIndex >= pos) return match;
        else if (stopPos > 0 && matchIndex > stopPos) return null;
    }
    return null;
}

},{"../../../base/common/iterator.js":"2FiS0","../../../base/common/linkedList.js":"kv7Rg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2FiS0":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Iterable", ()=>Iterable);
var Iterable;
(function(Iterable) {
    function is(thing) {
        return thing && typeof thing === "object" && typeof thing[Symbol.iterator] === "function";
    }
    Iterable.is = is;
    const _empty = Object.freeze([]);
    function empty() {
        return _empty;
    }
    Iterable.empty = empty;
    function* single(element) {
        yield element;
    }
    Iterable.single = single;
    function wrap(iterableOrElement) {
        if (is(iterableOrElement)) return iterableOrElement;
        else return single(iterableOrElement);
    }
    Iterable.wrap = wrap;
    function from(iterable) {
        return iterable || _empty;
    }
    Iterable.from = from;
    function* reverse(array) {
        for(let i = array.length - 1; i >= 0; i--)yield array[i];
    }
    Iterable.reverse = reverse;
    function isEmpty(iterable) {
        return !iterable || iterable[Symbol.iterator]().next().done === true;
    }
    Iterable.isEmpty = isEmpty;
    function first(iterable) {
        return iterable[Symbol.iterator]().next().value;
    }
    Iterable.first = first;
    function some(iterable, predicate) {
        let i = 0;
        for (const element of iterable){
            if (predicate(element, i++)) return true;
        }
        return false;
    }
    Iterable.some = some;
    function find(iterable, predicate) {
        for (const element of iterable){
            if (predicate(element)) return element;
        }
        return undefined;
    }
    Iterable.find = find;
    function* filter(iterable, predicate) {
        for (const element of iterable)if (predicate(element)) yield element;
    }
    Iterable.filter = filter;
    function* map(iterable, fn) {
        let index = 0;
        for (const element of iterable)yield fn(element, index++);
    }
    Iterable.map = map;
    function* flatMap(iterable, fn) {
        let index = 0;
        for (const element of iterable)yield* fn(element, index++);
    }
    Iterable.flatMap = flatMap;
    function* concat(...iterables) {
        for (const iterable of iterables)yield* iterable;
    }
    Iterable.concat = concat;
    function reduce(iterable, reducer, initialValue) {
        let value = initialValue;
        for (const element of iterable)value = reducer(value, element);
        return value;
    }
    Iterable.reduce = reduce;
    /**
     * Returns an iterable slice of the array, with the same semantics as `array.slice()`.
     */ function* slice(arr, from, to = arr.length) {
        if (from < 0) from += arr.length;
        if (to < 0) to += arr.length;
        else if (to > arr.length) to = arr.length;
        for(; from < to; from++)yield arr[from];
    }
    Iterable.slice = slice;
    /**
     * Consumes `atMost` elements from iterable and returns the consumed elements,
     * and an iterable for the rest of the elements.
     */ function consume(iterable, atMost = Number.POSITIVE_INFINITY) {
        const consumed = [];
        if (atMost === 0) return [
            consumed,
            iterable
        ];
        const iterator = iterable[Symbol.iterator]();
        for(let i = 0; i < atMost; i++){
            const next = iterator.next();
            if (next.done) return [
                consumed,
                Iterable.empty()
            ];
            consumed.push(next.value);
        }
        return [
            consumed,
            {
                [Symbol.iterator] () {
                    return iterator;
                }
            }
        ];
    }
    Iterable.consume = consume;
    async function asyncToArray(iterable) {
        const result = [];
        for await (const item of iterable)result.push(item);
        return Promise.resolve(result);
    }
    Iterable.asyncToArray = asyncToArray;
})(Iterable || (Iterable = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kv7Rg":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkedList", ()=>LinkedList);
class Node {
    static{
        this.Undefined = new Node(undefined);
    }
    constructor(element){
        this.element = element;
        this.next = Node.Undefined;
        this.prev = Node.Undefined;
    }
}
class LinkedList {
    constructor(){
        this._first = Node.Undefined;
        this._last = Node.Undefined;
        this._size = 0;
    }
    get size() {
        return this._size;
    }
    isEmpty() {
        return this._first === Node.Undefined;
    }
    clear() {
        let node = this._first;
        while(node !== Node.Undefined){
            const next = node.next;
            node.prev = Node.Undefined;
            node.next = Node.Undefined;
            node = next;
        }
        this._first = Node.Undefined;
        this._last = Node.Undefined;
        this._size = 0;
    }
    unshift(element) {
        return this._insert(element, false);
    }
    push(element) {
        return this._insert(element, true);
    }
    _insert(element, atTheEnd) {
        const newNode = new Node(element);
        if (this._first === Node.Undefined) {
            this._first = newNode;
            this._last = newNode;
        } else if (atTheEnd) {
            // push
            const oldLast = this._last;
            this._last = newNode;
            newNode.prev = oldLast;
            oldLast.next = newNode;
        } else {
            // unshift
            const oldFirst = this._first;
            this._first = newNode;
            newNode.next = oldFirst;
            oldFirst.prev = newNode;
        }
        this._size += 1;
        let didRemove = false;
        return ()=>{
            if (!didRemove) {
                didRemove = true;
                this._remove(newNode);
            }
        };
    }
    shift() {
        if (this._first === Node.Undefined) return undefined;
        else {
            const res = this._first.element;
            this._remove(this._first);
            return res;
        }
    }
    pop() {
        if (this._last === Node.Undefined) return undefined;
        else {
            const res = this._last.element;
            this._remove(this._last);
            return res;
        }
    }
    _remove(node) {
        if (node.prev !== Node.Undefined && node.next !== Node.Undefined) {
            // middle
            const anchor = node.prev;
            anchor.next = node.next;
            node.next.prev = anchor;
        } else if (node.prev === Node.Undefined && node.next === Node.Undefined) {
            // only node
            this._first = Node.Undefined;
            this._last = Node.Undefined;
        } else if (node.next === Node.Undefined) {
            // last
            this._last = this._last.prev;
            this._last.next = Node.Undefined;
        } else if (node.prev === Node.Undefined) {
            // first
            this._first = this._first.next;
            this._first.prev = Node.Undefined;
        }
        // done
        this._size -= 1;
    }
    *[Symbol.iterator]() {
        let node = this._first;
        while(node !== Node.Undefined){
            yield node.element;
            node = node.next;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jf9LT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyMod", ()=>KeyMod);
parcelHelpers.export(exports, "createMonacoBaseAPI", ()=>createMonacoBaseAPI);
var _cancellationJs = require("../../../base/common/cancellation.js");
var _eventJs = require("../../../base/common/event.js");
var _keyCodesJs = require("../../../base/common/keyCodes.js");
var _uriJs = require("../../../base/common/uri.js");
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
var _selectionJs = require("../core/selection.js");
var _languagesJs = require("../languages.js");
var _standaloneEnumsJs = require("../standalone/standaloneEnums.js");
class KeyMod {
    static{
        this.CtrlCmd = 2048 /* ConstKeyMod.CtrlCmd */ ;
    }
    static{
        this.Shift = 1024 /* ConstKeyMod.Shift */ ;
    }
    static{
        this.Alt = 512 /* ConstKeyMod.Alt */ ;
    }
    static{
        this.WinCtrl = 256 /* ConstKeyMod.WinCtrl */ ;
    }
    static chord(firstPart, secondPart) {
        return (0, _keyCodesJs.KeyChord)(firstPart, secondPart);
    }
}
function createMonacoBaseAPI() {
    return {
        editor: undefined,
        languages: undefined,
        CancellationTokenSource: (0, _cancellationJs.CancellationTokenSource),
        Emitter: (0, _eventJs.Emitter),
        KeyCode: _standaloneEnumsJs.KeyCode,
        KeyMod: KeyMod,
        Position: (0, _positionJs.Position),
        Range: (0, _rangeJs.Range),
        Selection: (0, _selectionJs.Selection),
        SelectionDirection: _standaloneEnumsJs.SelectionDirection,
        MarkerSeverity: _standaloneEnumsJs.MarkerSeverity,
        MarkerTag: _standaloneEnumsJs.MarkerTag,
        Uri: (0, _uriJs.URI),
        Token: (0, _languagesJs.Token)
    };
}

},{"../../../base/common/cancellation.js":"hoVxw","../../../base/common/event.js":"4Zi8b","../../../base/common/keyCodes.js":"bHiG9","../../../base/common/uri.js":"7qGS3","../core/position.js":"lvrPe","../core/range.js":"jmUPh","../core/selection.js":"kcwzU","../languages.js":"g5n96","../standalone/standaloneEnums.js":"7JLc0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hoVxw":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancellationToken", ()=>CancellationToken);
parcelHelpers.export(exports, "CancellationTokenSource", ()=>CancellationTokenSource);
parcelHelpers.export(exports, "cancelOnDispose", ()=>cancelOnDispose);
var _eventJs = require("./event.js");
const shortcutEvent = Object.freeze(function(callback, context) {
    const handle = setTimeout(callback.bind(context), 0);
    return {
        dispose () {
            clearTimeout(handle);
        }
    };
});
var CancellationToken;
(function(CancellationToken) {
    function isCancellationToken(thing) {
        if (thing === CancellationToken.None || thing === CancellationToken.Cancelled) return true;
        if (thing instanceof MutableToken) return true;
        if (!thing || typeof thing !== "object") return false;
        return typeof thing.isCancellationRequested === "boolean" && typeof thing.onCancellationRequested === "function";
    }
    CancellationToken.isCancellationToken = isCancellationToken;
    CancellationToken.None = Object.freeze({
        isCancellationRequested: false,
        onCancellationRequested: (0, _eventJs.Event).None
    });
    CancellationToken.Cancelled = Object.freeze({
        isCancellationRequested: true,
        onCancellationRequested: shortcutEvent
    });
})(CancellationToken || (CancellationToken = {}));
class MutableToken {
    constructor(){
        this._isCancelled = false;
        this._emitter = null;
    }
    cancel() {
        if (!this._isCancelled) {
            this._isCancelled = true;
            if (this._emitter) {
                this._emitter.fire(undefined);
                this.dispose();
            }
        }
    }
    get isCancellationRequested() {
        return this._isCancelled;
    }
    get onCancellationRequested() {
        if (this._isCancelled) return shortcutEvent;
        if (!this._emitter) this._emitter = new (0, _eventJs.Emitter)();
        return this._emitter.event;
    }
    dispose() {
        if (this._emitter) {
            this._emitter.dispose();
            this._emitter = null;
        }
    }
}
class CancellationTokenSource {
    constructor(parent){
        this._token = undefined;
        this._parentListener = undefined;
        this._parentListener = parent && parent.onCancellationRequested(this.cancel, this);
    }
    get token() {
        if (!this._token) // be lazy and create the token only when
        // actually needed
        this._token = new MutableToken();
        return this._token;
    }
    cancel() {
        if (!this._token) // save an object by returning the default
        // cancelled token when cancellation happens
        // before someone asks for the token
        this._token = CancellationToken.Cancelled;
        else if (this._token instanceof MutableToken) // actually cancel
        this._token.cancel();
    }
    dispose(cancel = false) {
        if (cancel) this.cancel();
        this._parentListener?.dispose();
        if (!this._token) // ensure to initialize with an empty token if we had none
        this._token = CancellationToken.None;
        else if (this._token instanceof MutableToken) // actually dispose
        this._token.dispose();
    }
}
function cancelOnDispose(store) {
    const source = new CancellationTokenSource();
    store.add({
        dispose () {
            source.cancel();
        }
    });
    return source.token;
}

},{"./event.js":"4Zi8b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Zi8b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Event", ()=>Event);
parcelHelpers.export(exports, "EventProfiling", ()=>EventProfiling);
// error that is logged when going over the configured listener threshold
parcelHelpers.export(exports, "ListenerLeakError", ()=>ListenerLeakError);
// SEVERE error that is logged when having gone way over the configured listener
// threshold so that the emitter refuses to accept more listeners
parcelHelpers.export(exports, "ListenerRefusalError", ()=>ListenerRefusalError);
/**
 * The Emitter can be used to expose an Event to the public
 * to fire it from the insides.
 * Sample:
    class Document {

        private readonly _onDidChange = new Emitter<(value:string)=>any>();

        public onDidChange = this._onDidChange.event;

        // getter-style
        // get onDidChange(): Event<(value:string)=>any> {
        // 	return this._onDidChange.event;
        // }

        private _doIt() {
            //...
            this._onDidChange.fire(value);
        }
    }
 */ parcelHelpers.export(exports, "Emitter", ()=>Emitter);
parcelHelpers.export(exports, "createEventDeliveryQueue", ()=>createEventDeliveryQueue);
parcelHelpers.export(exports, "PauseableEmitter", ()=>PauseableEmitter);
parcelHelpers.export(exports, "DebounceEmitter", ()=>DebounceEmitter);
/**
 * An emitter which queue all events and then process them at the
 * end of the event loop.
 */ parcelHelpers.export(exports, "MicrotaskEmitter", ()=>MicrotaskEmitter);
/**
 * An event emitter that multiplexes many events into a single event.
 *
 * @example Listen to the `onData` event of all `Thing`s, dynamically adding and removing `Thing`s
 * to the multiplexer as needed.
 *
 * ```typescript
 * const anythingDataMultiplexer = new EventMultiplexer<{ data: string }>();
 *
 * const thingListeners = DisposableMap<Thing, IDisposable>();
 *
 * thingService.onDidAddThing(thing => {
 *   thingListeners.set(thing, anythingDataMultiplexer.add(thing.onData);
 * });
 * thingService.onDidRemoveThing(thing => {
 *   thingListeners.deleteAndDispose(thing);
 * });
 *
 * anythingDataMultiplexer.event(e => {
 *   console.log('Something fired data ' + e.data)
 * });
 * ```
 */ parcelHelpers.export(exports, "EventMultiplexer", ()=>EventMultiplexer);
/**
 * The EventBufferer is useful in situations in which you want
 * to delay firing your events during some code.
 * You can wrap that code and be sure that the event will not
 * be fired during that wrap.
 *
 * ```
 * const emitter: Emitter;
 * const delayer = new EventDelayer();
 * const delayedEvent = delayer.wrapEvent(emitter.event);
 *
 * delayedEvent(console.log);
 *
 * delayer.bufferEvents(() => {
 *   emitter.fire(); // event will not be fired yet
 * });
 *
 * // event will only be fired at this point
 * ```
 */ parcelHelpers.export(exports, "EventBufferer", ()=>EventBufferer);
/**
 * A Relay is an event forwarder which functions as a replugabble event pipe.
 * Once created, you can connect an input event to it and it will simply forward
 * events from that input event through its own `event` property. The `input`
 * can be changed at any point in time.
 */ parcelHelpers.export(exports, "Relay", ()=>Relay);
var _errorsJs = require("./errors.js");
var _functionalJs = require("./functional.js");
var _lifecycleJs = require("./lifecycle.js");
var _linkedListJs = require("./linkedList.js");
var _stopwatchJs = require("./stopwatch.js");
// -----------------------------------------------------------------------------------------------------------------------
// Uncomment the next line to print warnings whenever a listener is GC'ed without having been disposed. This is a LEAK.
// -----------------------------------------------------------------------------------------------------------------------
const _enableListenerGCedWarning = false;
// -----------------------------------------------------------------------------------------------------------------------
// Uncomment the next line to print warnings whenever an emitter with listeners is disposed. That is a sign of code smell.
// -----------------------------------------------------------------------------------------------------------------------
const _enableDisposeWithListenerWarning = false;
// -----------------------------------------------------------------------------------------------------------------------
// Uncomment the next line to print warnings whenever a snapshotted event is used repeatedly without cleanup.
// See https://github.com/microsoft/vscode/issues/142851
// -----------------------------------------------------------------------------------------------------------------------
const _enableSnapshotPotentialLeakWarning = false;
var Event;
(function(Event) {
    Event.None = ()=>(0, _lifecycleJs.Disposable).None;
    function _addLeakageTraceLogic(options) {
        if (_enableSnapshotPotentialLeakWarning) {
            const { onDidAddListener: origListenerDidAdd } = options;
            const stack = Stacktrace.create();
            let count = 0;
            options.onDidAddListener = ()=>{
                if (++count === 2) {
                    console.warn("snapshotted emitter LIKELY used public and SHOULD HAVE BEEN created with DisposableStore. snapshotted here");
                    stack.print();
                }
                origListenerDidAdd?.();
            };
        }
    }
    /**
     * Given an event, returns another event which debounces calls and defers the listeners to a later task via a shared
     * `setTimeout`. The event is converted into a signal (`Event<void>`) to avoid additional object creation as a
     * result of merging events and to try prevent race conditions that could arise when using related deferred and
     * non-deferred events.
     *
     * This is useful for deferring non-critical work (eg. general UI updates) to ensure it does not block critical work
     * (eg. latency of keypress to text rendered).
     *
     * *NOTE* that this function returns an `Event` and it MUST be called with a `DisposableStore` whenever the returned
     * event is accessible to "third parties", e.g the event is a public property. Otherwise a leaked listener on the
     * returned event causes this utility to leak a listener on the original event.
     *
     * @param event The event source for the new event.
     * @param disposable A disposable store to add the new EventEmitter to.
     */ function defer(event, disposable) {
        return debounce(event, ()=>void 0, 0, undefined, true, undefined, disposable);
    }
    Event.defer = defer;
    /**
     * Given an event, returns another event which only fires once.
     *
     * @param event The event source for the new event.
     */ function once(event) {
        return (listener, thisArgs = null, disposables)=>{
            // we need this, in case the event fires during the listener call
            let didFire = false;
            let result = undefined;
            result = event((e)=>{
                if (didFire) return;
                else if (result) result.dispose();
                else didFire = true;
                return listener.call(thisArgs, e);
            }, null, disposables);
            if (didFire) result.dispose();
            return result;
        };
    }
    Event.once = once;
    /**
     * Given an event, returns another event which only fires once, and only when the condition is met.
     *
     * @param event The event source for the new event.
     */ function onceIf(event, condition) {
        return Event.once(Event.filter(event, condition));
    }
    Event.onceIf = onceIf;
    /**
     * Maps an event of one type into an event of another type using a mapping function, similar to how
     * `Array.prototype.map` works.
     *
     * *NOTE* that this function returns an `Event` and it MUST be called with a `DisposableStore` whenever the returned
     * event is accessible to "third parties", e.g the event is a public property. Otherwise a leaked listener on the
     * returned event causes this utility to leak a listener on the original event.
     *
     * @param event The event source for the new event.
     * @param map The mapping function.
     * @param disposable A disposable store to add the new EventEmitter to.
     */ function map(event, map, disposable) {
        return snapshot((listener, thisArgs = null, disposables)=>event((i)=>listener.call(thisArgs, map(i)), null, disposables), disposable);
    }
    Event.map = map;
    /**
     * Wraps an event in another event that performs some function on the event object before firing.
     *
     * *NOTE* that this function returns an `Event` and it MUST be called with a `DisposableStore` whenever the returned
     * event is accessible to "third parties", e.g the event is a public property. Otherwise a leaked listener on the
     * returned event causes this utility to leak a listener on the original event.
     *
     * @param event The event source for the new event.
     * @param each The function to perform on the event object.
     * @param disposable A disposable store to add the new EventEmitter to.
     */ function forEach(event, each, disposable) {
        return snapshot((listener, thisArgs = null, disposables)=>event((i)=>{
                each(i);
                listener.call(thisArgs, i);
            }, null, disposables), disposable);
    }
    Event.forEach = forEach;
    function filter(event, filter, disposable) {
        return snapshot((listener, thisArgs = null, disposables)=>event((e)=>filter(e) && listener.call(thisArgs, e), null, disposables), disposable);
    }
    Event.filter = filter;
    /**
     * Given an event, returns the same event but typed as `Event<void>`.
     */ function signal(event) {
        return event;
    }
    Event.signal = signal;
    function any(...events) {
        return (listener, thisArgs = null, disposables)=>{
            const disposable = (0, _lifecycleJs.combinedDisposable)(...events.map((event)=>event((e)=>listener.call(thisArgs, e))));
            return addAndReturnDisposable(disposable, disposables);
        };
    }
    Event.any = any;
    /**
     * *NOTE* that this function returns an `Event` and it MUST be called with a `DisposableStore` whenever the returned
     * event is accessible to "third parties", e.g the event is a public property. Otherwise a leaked listener on the
     * returned event causes this utility to leak a listener on the original event.
     */ function reduce(event, merge, initial, disposable) {
        let output = initial;
        return map(event, (e)=>{
            output = merge(output, e);
            return output;
        }, disposable);
    }
    Event.reduce = reduce;
    function snapshot(event, disposable) {
        let listener;
        const options = {
            onWillAddFirstListener () {
                listener = event(emitter.fire, emitter);
            },
            onDidRemoveLastListener () {
                listener?.dispose();
            }
        };
        if (!disposable) _addLeakageTraceLogic(options);
        const emitter = new Emitter(options);
        disposable?.add(emitter);
        return emitter.event;
    }
    /**
     * Adds the IDisposable to the store if it's set, and returns it. Useful to
     * Event function implementation.
     */ function addAndReturnDisposable(d, store) {
        if (store instanceof Array) store.push(d);
        else if (store) store.add(d);
        return d;
    }
    function debounce(event, merge, delay = 100, leading = false, flushOnListenerRemove = false, leakWarningThreshold, disposable) {
        let subscription;
        let output = undefined;
        let handle = undefined;
        let numDebouncedCalls = 0;
        let doFire;
        const options = {
            leakWarningThreshold,
            onWillAddFirstListener () {
                subscription = event((cur)=>{
                    numDebouncedCalls++;
                    output = merge(output, cur);
                    if (leading && !handle) {
                        emitter.fire(output);
                        output = undefined;
                    }
                    doFire = ()=>{
                        const _output = output;
                        output = undefined;
                        handle = undefined;
                        if (!leading || numDebouncedCalls > 1) emitter.fire(_output);
                        numDebouncedCalls = 0;
                    };
                    if (typeof delay === "number") {
                        clearTimeout(handle);
                        handle = setTimeout(doFire, delay);
                    } else if (handle === undefined) {
                        handle = 0;
                        queueMicrotask(doFire);
                    }
                });
            },
            onWillRemoveListener () {
                if (flushOnListenerRemove && numDebouncedCalls > 0) doFire?.();
            },
            onDidRemoveLastListener () {
                doFire = undefined;
                subscription.dispose();
            }
        };
        if (!disposable) _addLeakageTraceLogic(options);
        const emitter = new Emitter(options);
        disposable?.add(emitter);
        return emitter.event;
    }
    Event.debounce = debounce;
    /**
     * Debounces an event, firing after some delay (default=0) with an array of all event original objects.
     *
     * *NOTE* that this function returns an `Event` and it MUST be called with a `DisposableStore` whenever the returned
     * event is accessible to "third parties", e.g the event is a public property. Otherwise a leaked listener on the
     * returned event causes this utility to leak a listener on the original event.
     */ function accumulate(event, delay = 0, disposable) {
        return Event.debounce(event, (last, e)=>{
            if (!last) return [
                e
            ];
            last.push(e);
            return last;
        }, delay, undefined, true, undefined, disposable);
    }
    Event.accumulate = accumulate;
    /**
     * Filters an event such that some condition is _not_ met more than once in a row, effectively ensuring duplicate
     * event objects from different sources do not fire the same event object.
     *
     * *NOTE* that this function returns an `Event` and it MUST be called with a `DisposableStore` whenever the returned
     * event is accessible to "third parties", e.g the event is a public property. Otherwise a leaked listener on the
     * returned event causes this utility to leak a listener on the original event.
     *
     * @param event The event source for the new event.
     * @param equals The equality condition.
     * @param disposable A disposable store to add the new EventEmitter to.
     *
     * @example
     * ```
     * // Fire only one time when a single window is opened or focused
     * Event.latch(Event.any(onDidOpenWindow, onDidFocusWindow))
     * ```
     */ function latch(event, equals = (a, b)=>a === b, disposable) {
        let firstCall = true;
        let cache;
        return filter(event, (value)=>{
            const shouldEmit = firstCall || !equals(value, cache);
            firstCall = false;
            cache = value;
            return shouldEmit;
        }, disposable);
    }
    Event.latch = latch;
    /**
     * Splits an event whose parameter is a union type into 2 separate events for each type in the union.
     *
     * *NOTE* that this function returns an `Event` and it MUST be called with a `DisposableStore` whenever the returned
     * event is accessible to "third parties", e.g the event is a public property. Otherwise a leaked listener on the
     * returned event causes this utility to leak a listener on the original event.
     *
     * @example
     * ```
     * const event = new EventEmitter<number | undefined>().event;
     * const [numberEvent, undefinedEvent] = Event.split(event, isUndefined);
     * ```
     *
     * @param event The event source for the new event.
     * @param isT A function that determines what event is of the first type.
     * @param disposable A disposable store to add the new EventEmitter to.
     */ function split(event, isT, disposable) {
        return [
            Event.filter(event, isT, disposable),
            Event.filter(event, (e)=>!isT(e), disposable)
        ];
    }
    Event.split = split;
    /**
     * Buffers an event until it has a listener attached.
     *
     * *NOTE* that this function returns an `Event` and it MUST be called with a `DisposableStore` whenever the returned
     * event is accessible to "third parties", e.g the event is a public property. Otherwise a leaked listener on the
     * returned event causes this utility to leak a listener on the original event.
     *
     * @param event The event source for the new event.
     * @param flushAfterTimeout Determines whether to flush the buffer after a timeout immediately or after a
     * `setTimeout` when the first event listener is added.
     * @param _buffer Internal: A source event array used for tests.
     *
     * @example
     * ```
     * // Start accumulating events, when the first listener is attached, flush
     * // the event after a timeout such that multiple listeners attached before
     * // the timeout would receive the event
     * this.onInstallExtension = Event.buffer(service.onInstallExtension, true);
     * ```
     */ function buffer(event, flushAfterTimeout = false, _buffer = [], disposable) {
        let buffer = _buffer.slice();
        let listener = event((e)=>{
            if (buffer) buffer.push(e);
            else emitter.fire(e);
        });
        if (disposable) disposable.add(listener);
        const flush = ()=>{
            buffer?.forEach((e)=>emitter.fire(e));
            buffer = null;
        };
        const emitter = new Emitter({
            onWillAddFirstListener () {
                if (!listener) {
                    listener = event((e)=>emitter.fire(e));
                    if (disposable) disposable.add(listener);
                }
            },
            onDidAddFirstListener () {
                if (buffer) {
                    if (flushAfterTimeout) setTimeout(flush);
                    else flush();
                }
            },
            onDidRemoveLastListener () {
                if (listener) listener.dispose();
                listener = null;
            }
        });
        if (disposable) disposable.add(emitter);
        return emitter.event;
    }
    Event.buffer = buffer;
    /**
     * Wraps the event in an {@link IChainableEvent}, allowing a more functional programming style.
     *
     * @example
     * ```
     * // Normal
     * const onEnterPressNormal = Event.filter(
     *   Event.map(onKeyPress.event, e => new StandardKeyboardEvent(e)),
     *   e.keyCode === KeyCode.Enter
     * ).event;
     *
     * // Using chain
     * const onEnterPressChain = Event.chain(onKeyPress.event, $ => $
     *   .map(e => new StandardKeyboardEvent(e))
     *   .filter(e => e.keyCode === KeyCode.Enter)
     * );
     * ```
     */ function chain(event, sythensize) {
        const fn = (listener, thisArgs, disposables)=>{
            const cs = sythensize(new ChainableSynthesis());
            return event(function(value) {
                const result = cs.evaluate(value);
                if (result !== HaltChainable) listener.call(thisArgs, result);
            }, undefined, disposables);
        };
        return fn;
    }
    Event.chain = chain;
    const HaltChainable = Symbol("HaltChainable");
    class ChainableSynthesis {
        constructor(){
            this.steps = [];
        }
        map(fn) {
            this.steps.push(fn);
            return this;
        }
        forEach(fn) {
            this.steps.push((v)=>{
                fn(v);
                return v;
            });
            return this;
        }
        filter(fn) {
            this.steps.push((v)=>fn(v) ? v : HaltChainable);
            return this;
        }
        reduce(merge, initial) {
            let last = initial;
            this.steps.push((v)=>{
                last = merge(last, v);
                return last;
            });
            return this;
        }
        latch(equals = (a, b)=>a === b) {
            let firstCall = true;
            let cache;
            this.steps.push((value)=>{
                const shouldEmit = firstCall || !equals(value, cache);
                firstCall = false;
                cache = value;
                return shouldEmit ? value : HaltChainable;
            });
            return this;
        }
        evaluate(value) {
            for (const step of this.steps){
                value = step(value);
                if (value === HaltChainable) break;
            }
            return value;
        }
    }
    /**
     * Creates an {@link Event} from a node event emitter.
     */ function fromNodeEventEmitter(emitter, eventName, map = (id)=>id) {
        const fn = (...args)=>result.fire(map(...args));
        const onFirstListenerAdd = ()=>emitter.on(eventName, fn);
        const onLastListenerRemove = ()=>emitter.removeListener(eventName, fn);
        const result = new Emitter({
            onWillAddFirstListener: onFirstListenerAdd,
            onDidRemoveLastListener: onLastListenerRemove
        });
        return result.event;
    }
    Event.fromNodeEventEmitter = fromNodeEventEmitter;
    /**
     * Creates an {@link Event} from a DOM event emitter.
     */ function fromDOMEventEmitter(emitter, eventName, map = (id)=>id) {
        const fn = (...args)=>result.fire(map(...args));
        const onFirstListenerAdd = ()=>emitter.addEventListener(eventName, fn);
        const onLastListenerRemove = ()=>emitter.removeEventListener(eventName, fn);
        const result = new Emitter({
            onWillAddFirstListener: onFirstListenerAdd,
            onDidRemoveLastListener: onLastListenerRemove
        });
        return result.event;
    }
    Event.fromDOMEventEmitter = fromDOMEventEmitter;
    /**
     * Creates a promise out of an event, using the {@link Event.once} helper.
     */ function toPromise(event) {
        return new Promise((resolve)=>once(event)(resolve));
    }
    Event.toPromise = toPromise;
    /**
     * Creates an event out of a promise that fires once when the promise is
     * resolved with the result of the promise or `undefined`.
     */ function fromPromise(promise) {
        const result = new Emitter();
        promise.then((res)=>{
            result.fire(res);
        }, ()=>{
            result.fire(undefined);
        }).finally(()=>{
            result.dispose();
        });
        return result.event;
    }
    Event.fromPromise = fromPromise;
    /**
     * A convenience function for forwarding an event to another emitter which
     * improves readability.
     *
     * This is similar to {@link Relay} but allows instantiating and forwarding
     * on a single line and also allows for multiple source events.
     * @param from The event to forward.
     * @param to The emitter to forward the event to.
     * @example
     * Event.forward(event, emitter);
     * // equivalent to
     * event(e => emitter.fire(e));
     * // equivalent to
     * event(emitter.fire, emitter);
     */ function forward(from, to) {
        return from((e)=>to.fire(e));
    }
    Event.forward = forward;
    function runAndSubscribe(event, handler, initial) {
        handler(initial);
        return event((e)=>handler(e));
    }
    Event.runAndSubscribe = runAndSubscribe;
    class EmitterObserver {
        constructor(_observable, store){
            this._observable = _observable;
            this._counter = 0;
            this._hasChanged = false;
            const options = {
                onWillAddFirstListener: ()=>{
                    _observable.addObserver(this);
                    // Communicate to the observable that we received its current value and would like to be notified about future changes.
                    this._observable.reportChanges();
                },
                onDidRemoveLastListener: ()=>{
                    _observable.removeObserver(this);
                }
            };
            if (!store) _addLeakageTraceLogic(options);
            this.emitter = new Emitter(options);
            if (store) store.add(this.emitter);
        }
        beginUpdate(_observable) {
            // assert(_observable === this.obs);
            this._counter++;
        }
        handlePossibleChange(_observable) {
        // assert(_observable === this.obs);
        }
        handleChange(_observable, _change) {
            // assert(_observable === this.obs);
            this._hasChanged = true;
        }
        endUpdate(_observable) {
            // assert(_observable === this.obs);
            this._counter--;
            if (this._counter === 0) {
                this._observable.reportChanges();
                if (this._hasChanged) {
                    this._hasChanged = false;
                    this.emitter.fire(this._observable.get());
                }
            }
        }
    }
    /**
     * Creates an event emitter that is fired when the observable changes.
     * Each listeners subscribes to the emitter.
     */ function fromObservable(obs, store) {
        const observer = new EmitterObserver(obs, store);
        return observer.emitter.event;
    }
    Event.fromObservable = fromObservable;
    /**
     * Each listener is attached to the observable directly.
     */ function fromObservableLight(observable) {
        return (listener, thisArgs, disposables)=>{
            let count = 0;
            let didChange = false;
            const observer = {
                beginUpdate () {
                    count++;
                },
                endUpdate () {
                    count--;
                    if (count === 0) {
                        observable.reportChanges();
                        if (didChange) {
                            didChange = false;
                            listener.call(thisArgs);
                        }
                    }
                },
                handlePossibleChange () {
                // noop
                },
                handleChange () {
                    didChange = true;
                }
            };
            observable.addObserver(observer);
            observable.reportChanges();
            const disposable = {
                dispose () {
                    observable.removeObserver(observer);
                }
            };
            if (disposables instanceof (0, _lifecycleJs.DisposableStore)) disposables.add(disposable);
            else if (Array.isArray(disposables)) disposables.push(disposable);
            return disposable;
        };
    }
    Event.fromObservableLight = fromObservableLight;
})(Event || (Event = {}));
class EventProfiling {
    static{
        this.all = new Set();
    }
    static{
        this._idPool = 0;
    }
    constructor(name){
        this.listenerCount = 0;
        this.invocationCount = 0;
        this.elapsedOverall = 0;
        this.durations = [];
        this.name = `${name}_${EventProfiling._idPool++}`;
        EventProfiling.all.add(this);
    }
    start(listenerCount) {
        this._stopWatch = new (0, _stopwatchJs.StopWatch)();
        this.listenerCount = listenerCount;
    }
    stop() {
        if (this._stopWatch) {
            const elapsed = this._stopWatch.elapsed();
            this.durations.push(elapsed);
            this.elapsedOverall += elapsed;
            this.invocationCount += 1;
            this._stopWatch = undefined;
        }
    }
}
let _globalLeakWarningThreshold = -1;
class LeakageMonitor {
    static{
        this._idPool = 1;
    }
    constructor(_errorHandler, threshold, name = (LeakageMonitor._idPool++).toString(16).padStart(3, "0")){
        this._errorHandler = _errorHandler;
        this.threshold = threshold;
        this.name = name;
        this._warnCountdown = 0;
    }
    dispose() {
        this._stacks?.clear();
    }
    check(stack, listenerCount) {
        const threshold = this.threshold;
        if (threshold <= 0 || listenerCount < threshold) return undefined;
        if (!this._stacks) this._stacks = new Map();
        const count = this._stacks.get(stack.value) || 0;
        this._stacks.set(stack.value, count + 1);
        this._warnCountdown -= 1;
        if (this._warnCountdown <= 0) {
            // only warn on first exceed and then every time the limit
            // is exceeded by 50% again
            this._warnCountdown = threshold * 0.5;
            const [topStack, topCount] = this.getMostFrequentStack();
            const message = `[${this.name}] potential listener LEAK detected, having ${listenerCount} listeners already. MOST frequent listener (${topCount}):`;
            console.warn(message);
            console.warn(topStack);
            const error = new ListenerLeakError(message, topStack);
            this._errorHandler(error);
        }
        return ()=>{
            const count = this._stacks.get(stack.value) || 0;
            this._stacks.set(stack.value, count - 1);
        };
    }
    getMostFrequentStack() {
        if (!this._stacks) return undefined;
        let topStack;
        let topCount = 0;
        for (const [stack, count] of this._stacks)if (!topStack || topCount < count) {
            topStack = [
                stack,
                count
            ];
            topCount = count;
        }
        return topStack;
    }
}
class Stacktrace {
    static create() {
        const err = new Error();
        return new Stacktrace(err.stack ?? "");
    }
    constructor(value){
        this.value = value;
    }
    print() {
        console.warn(this.value.split("\n").slice(2).join("\n"));
    }
}
class ListenerLeakError extends Error {
    constructor(message, stack){
        super(message);
        this.name = "ListenerLeakError";
        this.stack = stack;
    }
}
class ListenerRefusalError extends Error {
    constructor(message, stack){
        super(message);
        this.name = "ListenerRefusalError";
        this.stack = stack;
    }
}
class UniqueContainer {
    constructor(value){
        this.value = value;
    }
}
const compactionThreshold = 2;
const forEachListener = (listeners, fn)=>{
    if (listeners instanceof UniqueContainer) fn(listeners);
    else for(let i = 0; i < listeners.length; i++){
        const l = listeners[i];
        if (l) fn(l);
    }
};
let _listenerFinalizers;
if (_enableListenerGCedWarning) {
    const leaks = [];
    setInterval(()=>{
        if (leaks.length === 0) return;
        console.warn("[LEAKING LISTENERS] GC'ed these listeners that were NOT yet disposed:");
        console.warn(leaks.join("\n"));
        leaks.length = 0;
    }, 3000);
    _listenerFinalizers = new FinalizationRegistry((heldValue)=>{
        if (typeof heldValue === "string") leaks.push(heldValue);
    });
}
class Emitter {
    constructor(options){
        this._size = 0;
        this._options = options;
        this._leakageMon = _globalLeakWarningThreshold > 0 || this._options?.leakWarningThreshold ? new LeakageMonitor(options?.onListenerError ?? (0, _errorsJs.onUnexpectedError), this._options?.leakWarningThreshold ?? _globalLeakWarningThreshold) : undefined;
        this._perfMon = this._options?._profName ? new EventProfiling(this._options._profName) : undefined;
        this._deliveryQueue = this._options?.deliveryQueue;
    }
    dispose() {
        if (!this._disposed) {
            this._disposed = true;
            // It is bad to have listeners at the time of disposing an emitter, it is worst to have listeners keep the emitter
            // alive via the reference that's embedded in their disposables. Therefore we loop over all remaining listeners and
            // unset their subscriptions/disposables. Looping and blaming remaining listeners is done on next tick because the
            // the following programming pattern is very popular:
            //
            // const someModel = this._disposables.add(new ModelObject()); // (1) create and register model
            // this._disposables.add(someModel.onDidChange(() => { ... }); // (2) subscribe and register model-event listener
            // ...later...
            // this._disposables.dispose(); disposes (1) then (2): don't warn after (1) but after the "overall dispose" is done
            if (this._deliveryQueue?.current === this) this._deliveryQueue.reset();
            if (this._listeners) {
                if (_enableDisposeWithListenerWarning) {
                    const listeners = this._listeners;
                    queueMicrotask(()=>{
                        forEachListener(listeners, (l)=>l.stack?.print());
                    });
                }
                this._listeners = undefined;
                this._size = 0;
            }
            this._options?.onDidRemoveLastListener?.();
            this._leakageMon?.dispose();
        }
    }
    /**
     * For the public to allow to subscribe
     * to events from this Emitter
     */ get event() {
        this._event ??= (callback, thisArgs, disposables)=>{
            if (this._leakageMon && this._size > this._leakageMon.threshold ** 2) {
                const message = `[${this._leakageMon.name}] REFUSES to accept new listeners because it exceeded its threshold by far (${this._size} vs ${this._leakageMon.threshold})`;
                console.warn(message);
                const tuple = this._leakageMon.getMostFrequentStack() ?? [
                    "UNKNOWN stack",
                    -1
                ];
                const error = new ListenerRefusalError(`${message}. HINT: Stack shows most frequent listener (${tuple[1]}-times)`, tuple[0]);
                const errorHandler = this._options?.onListenerError || (0, _errorsJs.onUnexpectedError);
                errorHandler(error);
                return (0, _lifecycleJs.Disposable).None;
            }
            if (this._disposed) // todo: should we warn if a listener is added to a disposed emitter? This happens often
            return (0, _lifecycleJs.Disposable).None;
            if (thisArgs) callback = callback.bind(thisArgs);
            const contained = new UniqueContainer(callback);
            let removeMonitor;
            let stack;
            if (this._leakageMon && this._size >= Math.ceil(this._leakageMon.threshold * 0.2)) {
                // check and record this emitter for potential leakage
                contained.stack = Stacktrace.create();
                removeMonitor = this._leakageMon.check(contained.stack, this._size + 1);
            }
            if (_enableDisposeWithListenerWarning) contained.stack = stack ?? Stacktrace.create();
            if (!this._listeners) {
                this._options?.onWillAddFirstListener?.(this);
                this._listeners = contained;
                this._options?.onDidAddFirstListener?.(this);
            } else if (this._listeners instanceof UniqueContainer) {
                this._deliveryQueue ??= new EventDeliveryQueuePrivate();
                this._listeners = [
                    this._listeners,
                    contained
                ];
            } else this._listeners.push(contained);
            this._size++;
            const result = (0, _lifecycleJs.toDisposable)(()=>{
                _listenerFinalizers?.unregister(result);
                removeMonitor?.();
                this._removeListener(contained);
            });
            if (disposables instanceof (0, _lifecycleJs.DisposableStore)) disposables.add(result);
            else if (Array.isArray(disposables)) disposables.push(result);
            if (_listenerFinalizers) {
                const stack = new Error().stack.split("\n").slice(2, 3).join("\n").trim();
                const match = /(file:|vscode-file:\/\/vscode-app)?(\/[^:]*:\d+:\d+)/.exec(stack);
                _listenerFinalizers.register(result, match?.[2] ?? stack, result);
            }
            return result;
        };
        return this._event;
    }
    _removeListener(listener) {
        this._options?.onWillRemoveListener?.(this);
        if (!this._listeners) return; // expected if a listener gets disposed
        if (this._size === 1) {
            this._listeners = undefined;
            this._options?.onDidRemoveLastListener?.(this);
            this._size = 0;
            return;
        }
        // size > 1 which requires that listeners be a list:
        const listeners = this._listeners;
        const index = listeners.indexOf(listener);
        if (index === -1) {
            console.log("disposed?", this._disposed);
            console.log("size?", this._size);
            console.log("arr?", JSON.stringify(this._listeners));
            throw new Error("Attempted to dispose unknown listener");
        }
        this._size--;
        listeners[index] = undefined;
        const adjustDeliveryQueue = this._deliveryQueue.current === this;
        if (this._size * compactionThreshold <= listeners.length) {
            let n = 0;
            for(let i = 0; i < listeners.length; i++){
                if (listeners[i]) listeners[n++] = listeners[i];
                else if (adjustDeliveryQueue) {
                    this._deliveryQueue.end--;
                    if (n < this._deliveryQueue.i) this._deliveryQueue.i--;
                }
            }
            listeners.length = n;
        }
    }
    _deliver(listener, value) {
        if (!listener) return;
        const errorHandler = this._options?.onListenerError || (0, _errorsJs.onUnexpectedError);
        if (!errorHandler) {
            listener.value(value);
            return;
        }
        try {
            listener.value(value);
        } catch (e) {
            errorHandler(e);
        }
    }
    /** Delivers items in the queue. Assumes the queue is ready to go. */ _deliverQueue(dq) {
        const listeners = dq.current._listeners;
        while(dq.i < dq.end)// important: dq.i is incremented before calling deliver() because it might reenter deliverQueue()
        this._deliver(listeners[dq.i++], dq.value);
        dq.reset();
    }
    /**
     * To be kept private to fire an event to
     * subscribers
     */ fire(event) {
        if (this._deliveryQueue?.current) {
            this._deliverQueue(this._deliveryQueue);
            this._perfMon?.stop(); // last fire() will have starting perfmon, stop it before starting the next dispatch
        }
        this._perfMon?.start(this._size);
        if (!this._listeners) ;
        else if (this._listeners instanceof UniqueContainer) this._deliver(this._listeners, event);
        else {
            const dq = this._deliveryQueue;
            dq.enqueue(this, event, this._listeners.length);
            this._deliverQueue(dq);
        }
        this._perfMon?.stop();
    }
    hasListeners() {
        return this._size > 0;
    }
}
const createEventDeliveryQueue = ()=>new EventDeliveryQueuePrivate();
class EventDeliveryQueuePrivate {
    constructor(){
        /**
         * Index in current's listener list.
         */ this.i = -1;
        /**
         * The last index in the listener's list to deliver.
         */ this.end = 0;
    }
    enqueue(emitter, value, end) {
        this.i = 0;
        this.end = end;
        this.current = emitter;
        this.value = value;
    }
    reset() {
        this.i = this.end; // force any current emission loop to stop, mainly for during dispose
        this.current = undefined;
        this.value = undefined;
    }
}
class PauseableEmitter extends Emitter {
    constructor(options){
        super(options);
        this._isPaused = 0;
        this._eventQueue = new (0, _linkedListJs.LinkedList)();
        this._mergeFn = options?.merge;
    }
    pause() {
        this._isPaused++;
    }
    resume() {
        if (this._isPaused !== 0 && --this._isPaused === 0) {
            if (this._mergeFn) // use the merge function to create a single composite
            // event. make a copy in case firing pauses this emitter
            {
                if (this._eventQueue.size > 0) {
                    const events = Array.from(this._eventQueue);
                    this._eventQueue.clear();
                    super.fire(this._mergeFn(events));
                }
            } else // no merging, fire each event individually and test
            // that this emitter isn't paused halfway through
            while(!this._isPaused && this._eventQueue.size !== 0)super.fire(this._eventQueue.shift());
        }
    }
    fire(event) {
        if (this._size) {
            if (this._isPaused !== 0) this._eventQueue.push(event);
            else super.fire(event);
        }
    }
}
class DebounceEmitter extends PauseableEmitter {
    constructor(options){
        super(options);
        this._delay = options.delay ?? 100;
    }
    fire(event) {
        if (!this._handle) {
            this.pause();
            this._handle = setTimeout(()=>{
                this._handle = undefined;
                this.resume();
            }, this._delay);
        }
        super.fire(event);
    }
}
class MicrotaskEmitter extends Emitter {
    constructor(options){
        super(options);
        this._queuedEvents = [];
        this._mergeFn = options?.merge;
    }
    fire(event) {
        if (!this.hasListeners()) return;
        this._queuedEvents.push(event);
        if (this._queuedEvents.length === 1) queueMicrotask(()=>{
            if (this._mergeFn) super.fire(this._mergeFn(this._queuedEvents));
            else this._queuedEvents.forEach((e)=>super.fire(e));
            this._queuedEvents = [];
        });
    }
}
class EventMultiplexer {
    constructor(){
        this.hasListeners = false;
        this.events = [];
        this.emitter = new Emitter({
            onWillAddFirstListener: ()=>this.onFirstListenerAdd(),
            onDidRemoveLastListener: ()=>this.onLastListenerRemove()
        });
    }
    get event() {
        return this.emitter.event;
    }
    add(event) {
        const e = {
            event: event,
            listener: null
        };
        this.events.push(e);
        if (this.hasListeners) this.hook(e);
        const dispose = ()=>{
            if (this.hasListeners) this.unhook(e);
            const idx = this.events.indexOf(e);
            this.events.splice(idx, 1);
        };
        return (0, _lifecycleJs.toDisposable)((0, _functionalJs.createSingleCallFunction)(dispose));
    }
    onFirstListenerAdd() {
        this.hasListeners = true;
        this.events.forEach((e)=>this.hook(e));
    }
    onLastListenerRemove() {
        this.hasListeners = false;
        this.events.forEach((e)=>this.unhook(e));
    }
    hook(e) {
        e.listener = e.event((r)=>this.emitter.fire(r));
    }
    unhook(e) {
        e.listener?.dispose();
        e.listener = null;
    }
    dispose() {
        this.emitter.dispose();
        for (const e of this.events)e.listener?.dispose();
        this.events = [];
    }
}
class EventBufferer {
    constructor(){
        this.data = [];
    }
    wrapEvent(event, reduce, initial) {
        return (listener, thisArgs, disposables)=>{
            return event((i)=>{
                const data = this.data[this.data.length - 1];
                // Non-reduce scenario
                if (!reduce) {
                    // Buffering case
                    if (data) data.buffers.push(()=>listener.call(thisArgs, i));
                    else // Not buffering case
                    listener.call(thisArgs, i);
                    return;
                }
                // Reduce scenario
                const reduceData = data;
                // Not buffering case
                if (!reduceData) {
                    // TODO: Is there a way to cache this reduce call for all listeners?
                    listener.call(thisArgs, reduce(initial, i));
                    return;
                }
                // Buffering case
                reduceData.items ??= [];
                reduceData.items.push(i);
                if (reduceData.buffers.length === 0) // Include a single buffered function that will reduce all events when we're done buffering events
                data.buffers.push(()=>{
                    // cache the reduced result so that the value can be shared across all listeners
                    reduceData.reducedResult ??= initial ? reduceData.items.reduce(reduce, initial) : reduceData.items.reduce(reduce);
                    listener.call(thisArgs, reduceData.reducedResult);
                });
            }, undefined, disposables);
        };
    }
    bufferEvents(fn) {
        const data = {
            buffers: new Array()
        };
        this.data.push(data);
        const r = fn();
        this.data.pop();
        data.buffers.forEach((flush)=>flush());
        return r;
    }
}
class Relay {
    constructor(){
        this.listening = false;
        this.inputEvent = Event.None;
        this.inputEventListener = (0, _lifecycleJs.Disposable).None;
        this.emitter = new Emitter({
            onDidAddFirstListener: ()=>{
                this.listening = true;
                this.inputEventListener = this.inputEvent(this.emitter.fire, this.emitter);
            },
            onDidRemoveLastListener: ()=>{
                this.listening = false;
                this.inputEventListener.dispose();
            }
        });
        this.event = this.emitter.event;
    }
    set input(event) {
        this.inputEvent = event;
        if (this.listening) {
            this.inputEventListener.dispose();
            this.inputEventListener = event(this.emitter.fire, this.emitter);
        }
    }
    dispose() {
        this.inputEventListener.dispose();
        this.emitter.dispose();
    }
}

},{"./errors.js":"divX8","./functional.js":"75R2i","./lifecycle.js":"9kg8d","./linkedList.js":"kv7Rg","./stopwatch.js":"77PF9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"divX8":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ // Avoid circular dependency on EventEmitter by implementing a subset of the interface.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorHandler", ()=>ErrorHandler);
parcelHelpers.export(exports, "errorHandler", ()=>errorHandler);
parcelHelpers.export(exports, "onUnexpectedError", ()=>onUnexpectedError);
parcelHelpers.export(exports, "onUnexpectedExternalError", ()=>onUnexpectedExternalError);
parcelHelpers.export(exports, "transformErrorForSerialization", ()=>transformErrorForSerialization);
/**
 * Checks if the given error is a promise in canceled state
 */ parcelHelpers.export(exports, "isCancellationError", ()=>isCancellationError);
// !!!IMPORTANT!!!
// Do NOT change this class because it is also used as an API-type.
parcelHelpers.export(exports, "CancellationError", ()=>CancellationError);
/**
 * @deprecated use {@link CancellationError `new CancellationError()`} instead
 */ parcelHelpers.export(exports, "canceled", ()=>canceled);
parcelHelpers.export(exports, "illegalArgument", ()=>illegalArgument);
parcelHelpers.export(exports, "illegalState", ()=>illegalState);
parcelHelpers.export(exports, "NotSupportedError", ()=>NotSupportedError);
/**
 * Error that when thrown won't be logged in telemetry as an unhandled error.
 */ parcelHelpers.export(exports, "ErrorNoTelemetry", ()=>ErrorNoTelemetry);
/**
 * This error indicates a bug.
 * Do not throw this for invalid user input.
 * Only catch this error to recover gracefully from bugs.
 */ parcelHelpers.export(exports, "BugIndicatingError", ()=>BugIndicatingError);
class ErrorHandler {
    constructor(){
        this.listeners = [];
        this.unexpectedErrorHandler = function(e) {
            setTimeout(()=>{
                if (e.stack) {
                    if (ErrorNoTelemetry.isErrorNoTelemetry(e)) throw new ErrorNoTelemetry(e.message + "\n\n" + e.stack);
                    throw new Error(e.message + "\n\n" + e.stack);
                }
                throw e;
            }, 0);
        };
    }
    emit(e) {
        this.listeners.forEach((listener)=>{
            listener(e);
        });
    }
    onUnexpectedError(e) {
        this.unexpectedErrorHandler(e);
        this.emit(e);
    }
    // For external errors, we don't want the listeners to be called
    onUnexpectedExternalError(e) {
        this.unexpectedErrorHandler(e);
    }
}
const errorHandler = new ErrorHandler();
function onUnexpectedError(e) {
    // ignore errors from cancelled promises
    if (!isCancellationError(e)) errorHandler.onUnexpectedError(e);
    return undefined;
}
function onUnexpectedExternalError(e) {
    // ignore errors from cancelled promises
    if (!isCancellationError(e)) errorHandler.onUnexpectedExternalError(e);
    return undefined;
}
function transformErrorForSerialization(error) {
    if (error instanceof Error) {
        const { name, message } = error;
        const stack = error.stacktrace || error.stack;
        return {
            $isError: true,
            name,
            message,
            stack,
            noTelemetry: ErrorNoTelemetry.isErrorNoTelemetry(error)
        };
    }
    // return as is
    return error;
}
const canceledName = "Canceled";
function isCancellationError(error) {
    if (error instanceof CancellationError) return true;
    return error instanceof Error && error.name === canceledName && error.message === canceledName;
}
class CancellationError extends Error {
    constructor(){
        super(canceledName);
        this.name = this.message;
    }
}
function canceled() {
    const error = new Error(canceledName);
    error.name = error.message;
    return error;
}
function illegalArgument(name) {
    if (name) return new Error(`Illegal argument: ${name}`);
    else return new Error("Illegal argument");
}
function illegalState(name) {
    if (name) return new Error(`Illegal state: ${name}`);
    else return new Error("Illegal state");
}
class NotSupportedError extends Error {
    constructor(message){
        super("NotSupported");
        if (message) this.message = message;
    }
}
class ErrorNoTelemetry extends Error {
    constructor(msg){
        super(msg);
        this.name = "CodeExpectedError";
    }
    static fromError(err) {
        if (err instanceof ErrorNoTelemetry) return err;
        const result = new ErrorNoTelemetry();
        result.message = err.message;
        result.stack = err.stack;
        return result;
    }
    static isErrorNoTelemetry(err) {
        return err.name === "CodeExpectedError";
    }
}
class BugIndicatingError extends Error {
    constructor(message){
        super(message || "An unexpected bug occurred.");
        Object.setPrototypeOf(this, BugIndicatingError.prototype);
    // Because we know for sure only buggy code throws this,
    // we definitely want to break here and fix the bug.
    // eslint-disable-next-line no-debugger
    // debugger;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"75R2i":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 * Given a function, returns a function that is only calling that function once.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSingleCallFunction", ()=>createSingleCallFunction);
function createSingleCallFunction(fn, fnDidRunCallback) {
    const _this = this;
    let didCall = false;
    let result;
    return function() {
        if (didCall) return result;
        didCall = true;
        if (fnDidRunCallback) try {
            result = fn.apply(_this, arguments);
        } finally{
            fnDidRunCallback();
        }
        else result = fn.apply(_this, arguments);
        return result;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9kg8d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setDisposableTracker", ()=>setDisposableTracker);
parcelHelpers.export(exports, "trackDisposable", ()=>trackDisposable);
parcelHelpers.export(exports, "markAsDisposed", ()=>markAsDisposed);
/**
 * Indicates that the given object is a singleton which does not need to be disposed.
*/ parcelHelpers.export(exports, "markAsSingleton", ()=>markAsSingleton);
/**
 * Check if `thing` is {@link IDisposable disposable}.
 */ parcelHelpers.export(exports, "isDisposable", ()=>isDisposable);
parcelHelpers.export(exports, "dispose", ()=>dispose);
/**
 * Combine multiple disposable values into a single {@link IDisposable}.
 */ parcelHelpers.export(exports, "combinedDisposable", ()=>combinedDisposable);
/**
 * Turn a function that implements dispose into an {@link IDisposable}.
 *
 * @param fn Clean up function, guaranteed to be called only **once**.
 */ parcelHelpers.export(exports, "toDisposable", ()=>toDisposable);
/**
 * Manages a collection of disposable values.
 *
 * This is the preferred way to manage multiple disposables. A `DisposableStore` is safer to work with than an
 * `IDisposable[]` as it considers edge cases, such as registering the same value multiple times or adding an item to a
 * store that has already been disposed of.
 */ parcelHelpers.export(exports, "DisposableStore", ()=>DisposableStore);
/**
 * Abstract base class for a {@link IDisposable disposable} object.
 *
 * Subclasses can {@linkcode _register} disposables that will be automatically cleaned up when this object is disposed of.
 */ parcelHelpers.export(exports, "Disposable", ()=>Disposable);
/**
 * Manages the lifecycle of a disposable value that may be changed.
 *
 * This ensures that when the disposable value is changed, the previously held disposable is disposed of. You can
 * also register a `MutableDisposable` on a `Disposable` to ensure it is automatically cleaned up.
 */ parcelHelpers.export(exports, "MutableDisposable", ()=>MutableDisposable);
parcelHelpers.export(exports, "RefCountedDisposable", ()=>RefCountedDisposable);
parcelHelpers.export(exports, "ImmortalReference", ()=>ImmortalReference);
/**
 * A map the manages the lifecycle of the values that it stores.
 */ parcelHelpers.export(exports, "DisposableMap", ()=>DisposableMap);
var _functionalJs = require("./functional.js");
var _iteratorJs = require("./iterator.js");
// #region Disposable Tracking
/**
 * Enables logging of potentially leaked disposables.
 *
 * A disposable is considered leaked if it is not disposed or not registered as the child of
 * another disposable. This tracking is very simple an only works for classes that either
 * extend Disposable or use a DisposableStore. This means there are a lot of false positives.
 */ const TRACK_DISPOSABLES = false;
let disposableTracker = null;
function setDisposableTracker(tracker) {
    disposableTracker = tracker;
}
if (TRACK_DISPOSABLES) {
    const __is_disposable_tracked__ = "__is_disposable_tracked__";
    setDisposableTracker(new class {
        trackDisposable(x) {
            const stack = new Error("Potentially leaked disposable").stack;
            setTimeout(()=>{
                if (!x[__is_disposable_tracked__]) console.log(stack);
            }, 3000);
        }
        setParent(child, parent) {
            if (child && child !== Disposable.None) try {
                child[__is_disposable_tracked__] = true;
            } catch  {
            // noop
            }
        }
        markAsDisposed(disposable) {
            if (disposable && disposable !== Disposable.None) try {
                disposable[__is_disposable_tracked__] = true;
            } catch  {
            // noop
            }
        }
        markAsSingleton(disposable) {}
    });
}
function trackDisposable(x) {
    disposableTracker?.trackDisposable(x);
    return x;
}
function markAsDisposed(disposable) {
    disposableTracker?.markAsDisposed(disposable);
}
function setParentOfDisposable(child, parent) {
    disposableTracker?.setParent(child, parent);
}
function setParentOfDisposables(children, parent) {
    if (!disposableTracker) return;
    for (const child of children)disposableTracker.setParent(child, parent);
}
function markAsSingleton(singleton) {
    disposableTracker?.markAsSingleton(singleton);
    return singleton;
}
function isDisposable(thing) {
    return typeof thing === "object" && thing !== null && typeof thing.dispose === "function" && thing.dispose.length === 0;
}
function dispose(arg) {
    if ((0, _iteratorJs.Iterable).is(arg)) {
        const errors = [];
        for (const d of arg){
            if (d) try {
                d.dispose();
            } catch (e) {
                errors.push(e);
            }
        }
        if (errors.length === 1) throw errors[0];
        else if (errors.length > 1) throw new AggregateError(errors, "Encountered errors while disposing of store");
        return Array.isArray(arg) ? [] : arg;
    } else if (arg) {
        arg.dispose();
        return arg;
    }
}
function combinedDisposable(...disposables) {
    const parent = toDisposable(()=>dispose(disposables));
    setParentOfDisposables(disposables, parent);
    return parent;
}
function toDisposable(fn) {
    const self = trackDisposable({
        dispose: (0, _functionalJs.createSingleCallFunction)(()=>{
            markAsDisposed(self);
            fn();
        })
    });
    return self;
}
class DisposableStore {
    static{
        this.DISABLE_DISPOSED_WARNING = false;
    }
    constructor(){
        this._toDispose = new Set();
        this._isDisposed = false;
        trackDisposable(this);
    }
    /**
     * Dispose of all registered disposables and mark this object as disposed.
     *
     * Any future disposables added to this object will be disposed of on `add`.
     */ dispose() {
        if (this._isDisposed) return;
        markAsDisposed(this);
        this._isDisposed = true;
        this.clear();
    }
    /**
     * @return `true` if this object has been disposed of.
     */ get isDisposed() {
        return this._isDisposed;
    }
    /**
     * Dispose of all registered disposables but do not mark this object as disposed.
     */ clear() {
        if (this._toDispose.size === 0) return;
        try {
            dispose(this._toDispose);
        } finally{
            this._toDispose.clear();
        }
    }
    /**
     * Add a new {@link IDisposable disposable} to the collection.
     */ add(o) {
        if (!o) return o;
        if (o === this) throw new Error("Cannot register a disposable on itself!");
        setParentOfDisposable(o, this);
        if (this._isDisposed) {
            if (!DisposableStore.DISABLE_DISPOSED_WARNING) console.warn(new Error("Trying to add a disposable to a DisposableStore that has already been disposed of. The added object will be leaked!").stack);
        } else this._toDispose.add(o);
        return o;
    }
    /**
     * Deletes the value from the store, but does not dispose it.
     */ deleteAndLeak(o) {
        if (!o) return;
        if (this._toDispose.has(o)) {
            this._toDispose.delete(o);
            setParentOfDisposable(o, null);
        }
    }
}
class Disposable {
    /**
     * A disposable that does nothing when it is disposed of.
     *
     * TODO: This should not be a static property.
     */ static{
        this.None = Object.freeze({
            dispose () {}
        });
    }
    constructor(){
        this._store = new DisposableStore();
        trackDisposable(this);
        setParentOfDisposable(this._store, this);
    }
    dispose() {
        markAsDisposed(this);
        this._store.dispose();
    }
    /**
     * Adds `o` to the collection of disposables managed by this object.
     */ _register(o) {
        if (o === this) throw new Error("Cannot register a disposable on itself!");
        return this._store.add(o);
    }
}
class MutableDisposable {
    constructor(){
        this._isDisposed = false;
        trackDisposable(this);
    }
    get value() {
        return this._isDisposed ? undefined : this._value;
    }
    set value(value) {
        if (this._isDisposed || value === this._value) return;
        this._value?.dispose();
        if (value) setParentOfDisposable(value, this);
        this._value = value;
    }
    /**
     * Resets the stored value and disposed of the previously stored value.
     */ clear() {
        this.value = undefined;
    }
    dispose() {
        this._isDisposed = true;
        markAsDisposed(this);
        this._value?.dispose();
        this._value = undefined;
    }
}
class RefCountedDisposable {
    constructor(_disposable){
        this._disposable = _disposable;
        this._counter = 1;
    }
    acquire() {
        this._counter++;
        return this;
    }
    release() {
        if (--this._counter === 0) this._disposable.dispose();
        return this;
    }
}
class ImmortalReference {
    constructor(object){
        this.object = object;
    }
    dispose() {}
}
class DisposableMap {
    constructor(){
        this._store = new Map();
        this._isDisposed = false;
        trackDisposable(this);
    }
    /**
     * Disposes of all stored values and mark this object as disposed.
     *
     * Trying to use this object after it has been disposed of is an error.
     */ dispose() {
        markAsDisposed(this);
        this._isDisposed = true;
        this.clearAndDisposeAll();
    }
    /**
     * Disposes of all stored values and clear the map, but DO NOT mark this object as disposed.
     */ clearAndDisposeAll() {
        if (!this._store.size) return;
        try {
            dispose(this._store.values());
        } finally{
            this._store.clear();
        }
    }
    get(key) {
        return this._store.get(key);
    }
    set(key, value, skipDisposeOnOverwrite = false) {
        if (this._isDisposed) console.warn(new Error("Trying to add a disposable to a DisposableMap that has already been disposed of. The added object will be leaked!").stack);
        if (!skipDisposeOnOverwrite) this._store.get(key)?.dispose();
        this._store.set(key, value);
    }
    /**
     * Delete the value stored for `key` from this map and also dispose of it.
     */ deleteAndDispose(key) {
        this._store.get(key)?.dispose();
        this._store.delete(key);
    }
    [Symbol.iterator]() {
        return this._store[Symbol.iterator]();
    }
}

},{"./functional.js":"75R2i","./iterator.js":"2FiS0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"77PF9":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StopWatch", ()=>StopWatch);
const hasPerformanceNow = globalThis.performance && typeof globalThis.performance.now === "function";
class StopWatch {
    static create(highResolution) {
        return new StopWatch(highResolution);
    }
    constructor(highResolution){
        this._now = hasPerformanceNow && highResolution === false ? Date.now : globalThis.performance.now.bind(globalThis.performance);
        this._startTime = this._now();
        this._stopTime = -1;
    }
    stop() {
        this._stopTime = this._now();
    }
    reset() {
        this._startTime = this._now();
        this._stopTime = -1;
    }
    elapsed() {
        if (this._stopTime !== -1) return this._stopTime - this._startTime;
        return this._now() - this._startTime;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bHiG9":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EVENT_KEY_CODE_MAP", ()=>EVENT_KEY_CODE_MAP);
parcelHelpers.export(exports, "NATIVE_WINDOWS_KEY_CODE_TO_KEY_CODE", ()=>NATIVE_WINDOWS_KEY_CODE_TO_KEY_CODE);
parcelHelpers.export(exports, "IMMUTABLE_CODE_TO_KEY_CODE", ()=>IMMUTABLE_CODE_TO_KEY_CODE);
parcelHelpers.export(exports, "IMMUTABLE_KEY_CODE_TO_CODE", ()=>IMMUTABLE_KEY_CODE_TO_CODE);
parcelHelpers.export(exports, "KeyCodeUtils", ()=>KeyCodeUtils);
parcelHelpers.export(exports, "KeyChord", ()=>KeyChord);
class KeyCodeStrMap {
    constructor(){
        this._keyCodeToStr = [];
        this._strToKeyCode = Object.create(null);
    }
    define(keyCode, str) {
        this._keyCodeToStr[keyCode] = str;
        this._strToKeyCode[str.toLowerCase()] = keyCode;
    }
    keyCodeToStr(keyCode) {
        return this._keyCodeToStr[keyCode];
    }
    strToKeyCode(str) {
        return this._strToKeyCode[str.toLowerCase()] || 0 /* KeyCode.Unknown */ ;
    }
}
const uiMap = new KeyCodeStrMap();
const userSettingsUSMap = new KeyCodeStrMap();
const userSettingsGeneralMap = new KeyCodeStrMap();
const EVENT_KEY_CODE_MAP = new Array(230);
const NATIVE_WINDOWS_KEY_CODE_TO_KEY_CODE = {};
const scanCodeIntToStr = [];
const scanCodeStrToInt = Object.create(null);
const scanCodeLowerCaseStrToInt = Object.create(null);
const IMMUTABLE_CODE_TO_KEY_CODE = [];
const IMMUTABLE_KEY_CODE_TO_CODE = [];
for(let i = 0; i <= 193 /* ScanCode.MAX_VALUE */ ; i++)IMMUTABLE_CODE_TO_KEY_CODE[i] = -1 /* KeyCode.DependsOnKbLayout */ ;
for(let i = 0; i <= 132 /* KeyCode.MAX_VALUE */ ; i++)IMMUTABLE_KEY_CODE_TO_CODE[i] = -1 /* ScanCode.DependsOnKbLayout */ ;
(function() {
    // See https://msdn.microsoft.com/en-us/library/windows/desktop/dd375731(v=vs.85).aspx
    // See https://github.com/microsoft/node-native-keymap/blob/88c0b0e5/deps/chromium/keyboard_codes_win.h
    const empty = "";
    const mappings = [
        // immutable, scanCode, scanCodeStr, keyCode, keyCodeStr, eventKeyCode, vkey, usUserSettingsLabel, generalUserSettingsLabel
        [
            1,
            0 /* ScanCode.None */ ,
            "None",
            0 /* KeyCode.Unknown */ ,
            "unknown",
            0,
            "VK_UNKNOWN",
            empty,
            empty
        ],
        [
            1,
            1 /* ScanCode.Hyper */ ,
            "Hyper",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            2 /* ScanCode.Super */ ,
            "Super",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            3 /* ScanCode.Fn */ ,
            "Fn",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            4 /* ScanCode.FnLock */ ,
            "FnLock",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            5 /* ScanCode.Suspend */ ,
            "Suspend",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            6 /* ScanCode.Resume */ ,
            "Resume",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            7 /* ScanCode.Turbo */ ,
            "Turbo",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            8 /* ScanCode.Sleep */ ,
            "Sleep",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_SLEEP",
            empty,
            empty
        ],
        [
            1,
            9 /* ScanCode.WakeUp */ ,
            "WakeUp",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            0,
            10 /* ScanCode.KeyA */ ,
            "KeyA",
            31 /* KeyCode.KeyA */ ,
            "A",
            65,
            "VK_A",
            empty,
            empty
        ],
        [
            0,
            11 /* ScanCode.KeyB */ ,
            "KeyB",
            32 /* KeyCode.KeyB */ ,
            "B",
            66,
            "VK_B",
            empty,
            empty
        ],
        [
            0,
            12 /* ScanCode.KeyC */ ,
            "KeyC",
            33 /* KeyCode.KeyC */ ,
            "C",
            67,
            "VK_C",
            empty,
            empty
        ],
        [
            0,
            13 /* ScanCode.KeyD */ ,
            "KeyD",
            34 /* KeyCode.KeyD */ ,
            "D",
            68,
            "VK_D",
            empty,
            empty
        ],
        [
            0,
            14 /* ScanCode.KeyE */ ,
            "KeyE",
            35 /* KeyCode.KeyE */ ,
            "E",
            69,
            "VK_E",
            empty,
            empty
        ],
        [
            0,
            15 /* ScanCode.KeyF */ ,
            "KeyF",
            36 /* KeyCode.KeyF */ ,
            "F",
            70,
            "VK_F",
            empty,
            empty
        ],
        [
            0,
            16 /* ScanCode.KeyG */ ,
            "KeyG",
            37 /* KeyCode.KeyG */ ,
            "G",
            71,
            "VK_G",
            empty,
            empty
        ],
        [
            0,
            17 /* ScanCode.KeyH */ ,
            "KeyH",
            38 /* KeyCode.KeyH */ ,
            "H",
            72,
            "VK_H",
            empty,
            empty
        ],
        [
            0,
            18 /* ScanCode.KeyI */ ,
            "KeyI",
            39 /* KeyCode.KeyI */ ,
            "I",
            73,
            "VK_I",
            empty,
            empty
        ],
        [
            0,
            19 /* ScanCode.KeyJ */ ,
            "KeyJ",
            40 /* KeyCode.KeyJ */ ,
            "J",
            74,
            "VK_J",
            empty,
            empty
        ],
        [
            0,
            20 /* ScanCode.KeyK */ ,
            "KeyK",
            41 /* KeyCode.KeyK */ ,
            "K",
            75,
            "VK_K",
            empty,
            empty
        ],
        [
            0,
            21 /* ScanCode.KeyL */ ,
            "KeyL",
            42 /* KeyCode.KeyL */ ,
            "L",
            76,
            "VK_L",
            empty,
            empty
        ],
        [
            0,
            22 /* ScanCode.KeyM */ ,
            "KeyM",
            43 /* KeyCode.KeyM */ ,
            "M",
            77,
            "VK_M",
            empty,
            empty
        ],
        [
            0,
            23 /* ScanCode.KeyN */ ,
            "KeyN",
            44 /* KeyCode.KeyN */ ,
            "N",
            78,
            "VK_N",
            empty,
            empty
        ],
        [
            0,
            24 /* ScanCode.KeyO */ ,
            "KeyO",
            45 /* KeyCode.KeyO */ ,
            "O",
            79,
            "VK_O",
            empty,
            empty
        ],
        [
            0,
            25 /* ScanCode.KeyP */ ,
            "KeyP",
            46 /* KeyCode.KeyP */ ,
            "P",
            80,
            "VK_P",
            empty,
            empty
        ],
        [
            0,
            26 /* ScanCode.KeyQ */ ,
            "KeyQ",
            47 /* KeyCode.KeyQ */ ,
            "Q",
            81,
            "VK_Q",
            empty,
            empty
        ],
        [
            0,
            27 /* ScanCode.KeyR */ ,
            "KeyR",
            48 /* KeyCode.KeyR */ ,
            "R",
            82,
            "VK_R",
            empty,
            empty
        ],
        [
            0,
            28 /* ScanCode.KeyS */ ,
            "KeyS",
            49 /* KeyCode.KeyS */ ,
            "S",
            83,
            "VK_S",
            empty,
            empty
        ],
        [
            0,
            29 /* ScanCode.KeyT */ ,
            "KeyT",
            50 /* KeyCode.KeyT */ ,
            "T",
            84,
            "VK_T",
            empty,
            empty
        ],
        [
            0,
            30 /* ScanCode.KeyU */ ,
            "KeyU",
            51 /* KeyCode.KeyU */ ,
            "U",
            85,
            "VK_U",
            empty,
            empty
        ],
        [
            0,
            31 /* ScanCode.KeyV */ ,
            "KeyV",
            52 /* KeyCode.KeyV */ ,
            "V",
            86,
            "VK_V",
            empty,
            empty
        ],
        [
            0,
            32 /* ScanCode.KeyW */ ,
            "KeyW",
            53 /* KeyCode.KeyW */ ,
            "W",
            87,
            "VK_W",
            empty,
            empty
        ],
        [
            0,
            33 /* ScanCode.KeyX */ ,
            "KeyX",
            54 /* KeyCode.KeyX */ ,
            "X",
            88,
            "VK_X",
            empty,
            empty
        ],
        [
            0,
            34 /* ScanCode.KeyY */ ,
            "KeyY",
            55 /* KeyCode.KeyY */ ,
            "Y",
            89,
            "VK_Y",
            empty,
            empty
        ],
        [
            0,
            35 /* ScanCode.KeyZ */ ,
            "KeyZ",
            56 /* KeyCode.KeyZ */ ,
            "Z",
            90,
            "VK_Z",
            empty,
            empty
        ],
        [
            0,
            36 /* ScanCode.Digit1 */ ,
            "Digit1",
            22 /* KeyCode.Digit1 */ ,
            "1",
            49,
            "VK_1",
            empty,
            empty
        ],
        [
            0,
            37 /* ScanCode.Digit2 */ ,
            "Digit2",
            23 /* KeyCode.Digit2 */ ,
            "2",
            50,
            "VK_2",
            empty,
            empty
        ],
        [
            0,
            38 /* ScanCode.Digit3 */ ,
            "Digit3",
            24 /* KeyCode.Digit3 */ ,
            "3",
            51,
            "VK_3",
            empty,
            empty
        ],
        [
            0,
            39 /* ScanCode.Digit4 */ ,
            "Digit4",
            25 /* KeyCode.Digit4 */ ,
            "4",
            52,
            "VK_4",
            empty,
            empty
        ],
        [
            0,
            40 /* ScanCode.Digit5 */ ,
            "Digit5",
            26 /* KeyCode.Digit5 */ ,
            "5",
            53,
            "VK_5",
            empty,
            empty
        ],
        [
            0,
            41 /* ScanCode.Digit6 */ ,
            "Digit6",
            27 /* KeyCode.Digit6 */ ,
            "6",
            54,
            "VK_6",
            empty,
            empty
        ],
        [
            0,
            42 /* ScanCode.Digit7 */ ,
            "Digit7",
            28 /* KeyCode.Digit7 */ ,
            "7",
            55,
            "VK_7",
            empty,
            empty
        ],
        [
            0,
            43 /* ScanCode.Digit8 */ ,
            "Digit8",
            29 /* KeyCode.Digit8 */ ,
            "8",
            56,
            "VK_8",
            empty,
            empty
        ],
        [
            0,
            44 /* ScanCode.Digit9 */ ,
            "Digit9",
            30 /* KeyCode.Digit9 */ ,
            "9",
            57,
            "VK_9",
            empty,
            empty
        ],
        [
            0,
            45 /* ScanCode.Digit0 */ ,
            "Digit0",
            21 /* KeyCode.Digit0 */ ,
            "0",
            48,
            "VK_0",
            empty,
            empty
        ],
        [
            1,
            46 /* ScanCode.Enter */ ,
            "Enter",
            3 /* KeyCode.Enter */ ,
            "Enter",
            13,
            "VK_RETURN",
            empty,
            empty
        ],
        [
            1,
            47 /* ScanCode.Escape */ ,
            "Escape",
            9 /* KeyCode.Escape */ ,
            "Escape",
            27,
            "VK_ESCAPE",
            empty,
            empty
        ],
        [
            1,
            48 /* ScanCode.Backspace */ ,
            "Backspace",
            1 /* KeyCode.Backspace */ ,
            "Backspace",
            8,
            "VK_BACK",
            empty,
            empty
        ],
        [
            1,
            49 /* ScanCode.Tab */ ,
            "Tab",
            2 /* KeyCode.Tab */ ,
            "Tab",
            9,
            "VK_TAB",
            empty,
            empty
        ],
        [
            1,
            50 /* ScanCode.Space */ ,
            "Space",
            10 /* KeyCode.Space */ ,
            "Space",
            32,
            "VK_SPACE",
            empty,
            empty
        ],
        [
            0,
            51 /* ScanCode.Minus */ ,
            "Minus",
            88 /* KeyCode.Minus */ ,
            "-",
            189,
            "VK_OEM_MINUS",
            "-",
            "OEM_MINUS"
        ],
        [
            0,
            52 /* ScanCode.Equal */ ,
            "Equal",
            86 /* KeyCode.Equal */ ,
            "=",
            187,
            "VK_OEM_PLUS",
            "=",
            "OEM_PLUS"
        ],
        [
            0,
            53 /* ScanCode.BracketLeft */ ,
            "BracketLeft",
            92 /* KeyCode.BracketLeft */ ,
            "[",
            219,
            "VK_OEM_4",
            "[",
            "OEM_4"
        ],
        [
            0,
            54 /* ScanCode.BracketRight */ ,
            "BracketRight",
            94 /* KeyCode.BracketRight */ ,
            "]",
            221,
            "VK_OEM_6",
            "]",
            "OEM_6"
        ],
        [
            0,
            55 /* ScanCode.Backslash */ ,
            "Backslash",
            93 /* KeyCode.Backslash */ ,
            "\\",
            220,
            "VK_OEM_5",
            "\\",
            "OEM_5"
        ],
        [
            0,
            56 /* ScanCode.IntlHash */ ,
            "IntlHash",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            0,
            57 /* ScanCode.Semicolon */ ,
            "Semicolon",
            85 /* KeyCode.Semicolon */ ,
            ";",
            186,
            "VK_OEM_1",
            ";",
            "OEM_1"
        ],
        [
            0,
            58 /* ScanCode.Quote */ ,
            "Quote",
            95 /* KeyCode.Quote */ ,
            "'",
            222,
            "VK_OEM_7",
            "'",
            "OEM_7"
        ],
        [
            0,
            59 /* ScanCode.Backquote */ ,
            "Backquote",
            91 /* KeyCode.Backquote */ ,
            "`",
            192,
            "VK_OEM_3",
            "`",
            "OEM_3"
        ],
        [
            0,
            60 /* ScanCode.Comma */ ,
            "Comma",
            87 /* KeyCode.Comma */ ,
            ",",
            188,
            "VK_OEM_COMMA",
            ",",
            "OEM_COMMA"
        ],
        [
            0,
            61 /* ScanCode.Period */ ,
            "Period",
            89 /* KeyCode.Period */ ,
            ".",
            190,
            "VK_OEM_PERIOD",
            ".",
            "OEM_PERIOD"
        ],
        [
            0,
            62 /* ScanCode.Slash */ ,
            "Slash",
            90 /* KeyCode.Slash */ ,
            "/",
            191,
            "VK_OEM_2",
            "/",
            "OEM_2"
        ],
        [
            1,
            63 /* ScanCode.CapsLock */ ,
            "CapsLock",
            8 /* KeyCode.CapsLock */ ,
            "CapsLock",
            20,
            "VK_CAPITAL",
            empty,
            empty
        ],
        [
            1,
            64 /* ScanCode.F1 */ ,
            "F1",
            59 /* KeyCode.F1 */ ,
            "F1",
            112,
            "VK_F1",
            empty,
            empty
        ],
        [
            1,
            65 /* ScanCode.F2 */ ,
            "F2",
            60 /* KeyCode.F2 */ ,
            "F2",
            113,
            "VK_F2",
            empty,
            empty
        ],
        [
            1,
            66 /* ScanCode.F3 */ ,
            "F3",
            61 /* KeyCode.F3 */ ,
            "F3",
            114,
            "VK_F3",
            empty,
            empty
        ],
        [
            1,
            67 /* ScanCode.F4 */ ,
            "F4",
            62 /* KeyCode.F4 */ ,
            "F4",
            115,
            "VK_F4",
            empty,
            empty
        ],
        [
            1,
            68 /* ScanCode.F5 */ ,
            "F5",
            63 /* KeyCode.F5 */ ,
            "F5",
            116,
            "VK_F5",
            empty,
            empty
        ],
        [
            1,
            69 /* ScanCode.F6 */ ,
            "F6",
            64 /* KeyCode.F6 */ ,
            "F6",
            117,
            "VK_F6",
            empty,
            empty
        ],
        [
            1,
            70 /* ScanCode.F7 */ ,
            "F7",
            65 /* KeyCode.F7 */ ,
            "F7",
            118,
            "VK_F7",
            empty,
            empty
        ],
        [
            1,
            71 /* ScanCode.F8 */ ,
            "F8",
            66 /* KeyCode.F8 */ ,
            "F8",
            119,
            "VK_F8",
            empty,
            empty
        ],
        [
            1,
            72 /* ScanCode.F9 */ ,
            "F9",
            67 /* KeyCode.F9 */ ,
            "F9",
            120,
            "VK_F9",
            empty,
            empty
        ],
        [
            1,
            73 /* ScanCode.F10 */ ,
            "F10",
            68 /* KeyCode.F10 */ ,
            "F10",
            121,
            "VK_F10",
            empty,
            empty
        ],
        [
            1,
            74 /* ScanCode.F11 */ ,
            "F11",
            69 /* KeyCode.F11 */ ,
            "F11",
            122,
            "VK_F11",
            empty,
            empty
        ],
        [
            1,
            75 /* ScanCode.F12 */ ,
            "F12",
            70 /* KeyCode.F12 */ ,
            "F12",
            123,
            "VK_F12",
            empty,
            empty
        ],
        [
            1,
            76 /* ScanCode.PrintScreen */ ,
            "PrintScreen",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            77 /* ScanCode.ScrollLock */ ,
            "ScrollLock",
            84 /* KeyCode.ScrollLock */ ,
            "ScrollLock",
            145,
            "VK_SCROLL",
            empty,
            empty
        ],
        [
            1,
            78 /* ScanCode.Pause */ ,
            "Pause",
            7 /* KeyCode.PauseBreak */ ,
            "PauseBreak",
            19,
            "VK_PAUSE",
            empty,
            empty
        ],
        [
            1,
            79 /* ScanCode.Insert */ ,
            "Insert",
            19 /* KeyCode.Insert */ ,
            "Insert",
            45,
            "VK_INSERT",
            empty,
            empty
        ],
        [
            1,
            80 /* ScanCode.Home */ ,
            "Home",
            14 /* KeyCode.Home */ ,
            "Home",
            36,
            "VK_HOME",
            empty,
            empty
        ],
        [
            1,
            81 /* ScanCode.PageUp */ ,
            "PageUp",
            11 /* KeyCode.PageUp */ ,
            "PageUp",
            33,
            "VK_PRIOR",
            empty,
            empty
        ],
        [
            1,
            82 /* ScanCode.Delete */ ,
            "Delete",
            20 /* KeyCode.Delete */ ,
            "Delete",
            46,
            "VK_DELETE",
            empty,
            empty
        ],
        [
            1,
            83 /* ScanCode.End */ ,
            "End",
            13 /* KeyCode.End */ ,
            "End",
            35,
            "VK_END",
            empty,
            empty
        ],
        [
            1,
            84 /* ScanCode.PageDown */ ,
            "PageDown",
            12 /* KeyCode.PageDown */ ,
            "PageDown",
            34,
            "VK_NEXT",
            empty,
            empty
        ],
        [
            1,
            85 /* ScanCode.ArrowRight */ ,
            "ArrowRight",
            17 /* KeyCode.RightArrow */ ,
            "RightArrow",
            39,
            "VK_RIGHT",
            "Right",
            empty
        ],
        [
            1,
            86 /* ScanCode.ArrowLeft */ ,
            "ArrowLeft",
            15 /* KeyCode.LeftArrow */ ,
            "LeftArrow",
            37,
            "VK_LEFT",
            "Left",
            empty
        ],
        [
            1,
            87 /* ScanCode.ArrowDown */ ,
            "ArrowDown",
            18 /* KeyCode.DownArrow */ ,
            "DownArrow",
            40,
            "VK_DOWN",
            "Down",
            empty
        ],
        [
            1,
            88 /* ScanCode.ArrowUp */ ,
            "ArrowUp",
            16 /* KeyCode.UpArrow */ ,
            "UpArrow",
            38,
            "VK_UP",
            "Up",
            empty
        ],
        [
            1,
            89 /* ScanCode.NumLock */ ,
            "NumLock",
            83 /* KeyCode.NumLock */ ,
            "NumLock",
            144,
            "VK_NUMLOCK",
            empty,
            empty
        ],
        [
            1,
            90 /* ScanCode.NumpadDivide */ ,
            "NumpadDivide",
            113 /* KeyCode.NumpadDivide */ ,
            "NumPad_Divide",
            111,
            "VK_DIVIDE",
            empty,
            empty
        ],
        [
            1,
            91 /* ScanCode.NumpadMultiply */ ,
            "NumpadMultiply",
            108 /* KeyCode.NumpadMultiply */ ,
            "NumPad_Multiply",
            106,
            "VK_MULTIPLY",
            empty,
            empty
        ],
        [
            1,
            92 /* ScanCode.NumpadSubtract */ ,
            "NumpadSubtract",
            111 /* KeyCode.NumpadSubtract */ ,
            "NumPad_Subtract",
            109,
            "VK_SUBTRACT",
            empty,
            empty
        ],
        [
            1,
            93 /* ScanCode.NumpadAdd */ ,
            "NumpadAdd",
            109 /* KeyCode.NumpadAdd */ ,
            "NumPad_Add",
            107,
            "VK_ADD",
            empty,
            empty
        ],
        [
            1,
            94 /* ScanCode.NumpadEnter */ ,
            "NumpadEnter",
            3 /* KeyCode.Enter */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            95 /* ScanCode.Numpad1 */ ,
            "Numpad1",
            99 /* KeyCode.Numpad1 */ ,
            "NumPad1",
            97,
            "VK_NUMPAD1",
            empty,
            empty
        ],
        [
            1,
            96 /* ScanCode.Numpad2 */ ,
            "Numpad2",
            100 /* KeyCode.Numpad2 */ ,
            "NumPad2",
            98,
            "VK_NUMPAD2",
            empty,
            empty
        ],
        [
            1,
            97 /* ScanCode.Numpad3 */ ,
            "Numpad3",
            101 /* KeyCode.Numpad3 */ ,
            "NumPad3",
            99,
            "VK_NUMPAD3",
            empty,
            empty
        ],
        [
            1,
            98 /* ScanCode.Numpad4 */ ,
            "Numpad4",
            102 /* KeyCode.Numpad4 */ ,
            "NumPad4",
            100,
            "VK_NUMPAD4",
            empty,
            empty
        ],
        [
            1,
            99 /* ScanCode.Numpad5 */ ,
            "Numpad5",
            103 /* KeyCode.Numpad5 */ ,
            "NumPad5",
            101,
            "VK_NUMPAD5",
            empty,
            empty
        ],
        [
            1,
            100 /* ScanCode.Numpad6 */ ,
            "Numpad6",
            104 /* KeyCode.Numpad6 */ ,
            "NumPad6",
            102,
            "VK_NUMPAD6",
            empty,
            empty
        ],
        [
            1,
            101 /* ScanCode.Numpad7 */ ,
            "Numpad7",
            105 /* KeyCode.Numpad7 */ ,
            "NumPad7",
            103,
            "VK_NUMPAD7",
            empty,
            empty
        ],
        [
            1,
            102 /* ScanCode.Numpad8 */ ,
            "Numpad8",
            106 /* KeyCode.Numpad8 */ ,
            "NumPad8",
            104,
            "VK_NUMPAD8",
            empty,
            empty
        ],
        [
            1,
            103 /* ScanCode.Numpad9 */ ,
            "Numpad9",
            107 /* KeyCode.Numpad9 */ ,
            "NumPad9",
            105,
            "VK_NUMPAD9",
            empty,
            empty
        ],
        [
            1,
            104 /* ScanCode.Numpad0 */ ,
            "Numpad0",
            98 /* KeyCode.Numpad0 */ ,
            "NumPad0",
            96,
            "VK_NUMPAD0",
            empty,
            empty
        ],
        [
            1,
            105 /* ScanCode.NumpadDecimal */ ,
            "NumpadDecimal",
            112 /* KeyCode.NumpadDecimal */ ,
            "NumPad_Decimal",
            110,
            "VK_DECIMAL",
            empty,
            empty
        ],
        [
            0,
            106 /* ScanCode.IntlBackslash */ ,
            "IntlBackslash",
            97 /* KeyCode.IntlBackslash */ ,
            "OEM_102",
            226,
            "VK_OEM_102",
            empty,
            empty
        ],
        [
            1,
            107 /* ScanCode.ContextMenu */ ,
            "ContextMenu",
            58 /* KeyCode.ContextMenu */ ,
            "ContextMenu",
            93,
            empty,
            empty,
            empty
        ],
        [
            1,
            108 /* ScanCode.Power */ ,
            "Power",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            109 /* ScanCode.NumpadEqual */ ,
            "NumpadEqual",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            110 /* ScanCode.F13 */ ,
            "F13",
            71 /* KeyCode.F13 */ ,
            "F13",
            124,
            "VK_F13",
            empty,
            empty
        ],
        [
            1,
            111 /* ScanCode.F14 */ ,
            "F14",
            72 /* KeyCode.F14 */ ,
            "F14",
            125,
            "VK_F14",
            empty,
            empty
        ],
        [
            1,
            112 /* ScanCode.F15 */ ,
            "F15",
            73 /* KeyCode.F15 */ ,
            "F15",
            126,
            "VK_F15",
            empty,
            empty
        ],
        [
            1,
            113 /* ScanCode.F16 */ ,
            "F16",
            74 /* KeyCode.F16 */ ,
            "F16",
            127,
            "VK_F16",
            empty,
            empty
        ],
        [
            1,
            114 /* ScanCode.F17 */ ,
            "F17",
            75 /* KeyCode.F17 */ ,
            "F17",
            128,
            "VK_F17",
            empty,
            empty
        ],
        [
            1,
            115 /* ScanCode.F18 */ ,
            "F18",
            76 /* KeyCode.F18 */ ,
            "F18",
            129,
            "VK_F18",
            empty,
            empty
        ],
        [
            1,
            116 /* ScanCode.F19 */ ,
            "F19",
            77 /* KeyCode.F19 */ ,
            "F19",
            130,
            "VK_F19",
            empty,
            empty
        ],
        [
            1,
            117 /* ScanCode.F20 */ ,
            "F20",
            78 /* KeyCode.F20 */ ,
            "F20",
            131,
            "VK_F20",
            empty,
            empty
        ],
        [
            1,
            118 /* ScanCode.F21 */ ,
            "F21",
            79 /* KeyCode.F21 */ ,
            "F21",
            132,
            "VK_F21",
            empty,
            empty
        ],
        [
            1,
            119 /* ScanCode.F22 */ ,
            "F22",
            80 /* KeyCode.F22 */ ,
            "F22",
            133,
            "VK_F22",
            empty,
            empty
        ],
        [
            1,
            120 /* ScanCode.F23 */ ,
            "F23",
            81 /* KeyCode.F23 */ ,
            "F23",
            134,
            "VK_F23",
            empty,
            empty
        ],
        [
            1,
            121 /* ScanCode.F24 */ ,
            "F24",
            82 /* KeyCode.F24 */ ,
            "F24",
            135,
            "VK_F24",
            empty,
            empty
        ],
        [
            1,
            122 /* ScanCode.Open */ ,
            "Open",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            123 /* ScanCode.Help */ ,
            "Help",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            124 /* ScanCode.Select */ ,
            "Select",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            125 /* ScanCode.Again */ ,
            "Again",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            126 /* ScanCode.Undo */ ,
            "Undo",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            127 /* ScanCode.Cut */ ,
            "Cut",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            128 /* ScanCode.Copy */ ,
            "Copy",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            129 /* ScanCode.Paste */ ,
            "Paste",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            130 /* ScanCode.Find */ ,
            "Find",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            131 /* ScanCode.AudioVolumeMute */ ,
            "AudioVolumeMute",
            117 /* KeyCode.AudioVolumeMute */ ,
            "AudioVolumeMute",
            173,
            "VK_VOLUME_MUTE",
            empty,
            empty
        ],
        [
            1,
            132 /* ScanCode.AudioVolumeUp */ ,
            "AudioVolumeUp",
            118 /* KeyCode.AudioVolumeUp */ ,
            "AudioVolumeUp",
            175,
            "VK_VOLUME_UP",
            empty,
            empty
        ],
        [
            1,
            133 /* ScanCode.AudioVolumeDown */ ,
            "AudioVolumeDown",
            119 /* KeyCode.AudioVolumeDown */ ,
            "AudioVolumeDown",
            174,
            "VK_VOLUME_DOWN",
            empty,
            empty
        ],
        [
            1,
            134 /* ScanCode.NumpadComma */ ,
            "NumpadComma",
            110 /* KeyCode.NUMPAD_SEPARATOR */ ,
            "NumPad_Separator",
            108,
            "VK_SEPARATOR",
            empty,
            empty
        ],
        [
            0,
            135 /* ScanCode.IntlRo */ ,
            "IntlRo",
            115 /* KeyCode.ABNT_C1 */ ,
            "ABNT_C1",
            193,
            "VK_ABNT_C1",
            empty,
            empty
        ],
        [
            1,
            136 /* ScanCode.KanaMode */ ,
            "KanaMode",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            0,
            137 /* ScanCode.IntlYen */ ,
            "IntlYen",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            138 /* ScanCode.Convert */ ,
            "Convert",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            139 /* ScanCode.NonConvert */ ,
            "NonConvert",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            140 /* ScanCode.Lang1 */ ,
            "Lang1",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            141 /* ScanCode.Lang2 */ ,
            "Lang2",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            142 /* ScanCode.Lang3 */ ,
            "Lang3",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            143 /* ScanCode.Lang4 */ ,
            "Lang4",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            144 /* ScanCode.Lang5 */ ,
            "Lang5",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            145 /* ScanCode.Abort */ ,
            "Abort",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            146 /* ScanCode.Props */ ,
            "Props",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            147 /* ScanCode.NumpadParenLeft */ ,
            "NumpadParenLeft",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            148 /* ScanCode.NumpadParenRight */ ,
            "NumpadParenRight",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            149 /* ScanCode.NumpadBackspace */ ,
            "NumpadBackspace",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            150 /* ScanCode.NumpadMemoryStore */ ,
            "NumpadMemoryStore",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            151 /* ScanCode.NumpadMemoryRecall */ ,
            "NumpadMemoryRecall",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            152 /* ScanCode.NumpadMemoryClear */ ,
            "NumpadMemoryClear",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            153 /* ScanCode.NumpadMemoryAdd */ ,
            "NumpadMemoryAdd",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            154 /* ScanCode.NumpadMemorySubtract */ ,
            "NumpadMemorySubtract",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            155 /* ScanCode.NumpadClear */ ,
            "NumpadClear",
            131 /* KeyCode.Clear */ ,
            "Clear",
            12,
            "VK_CLEAR",
            empty,
            empty
        ],
        [
            1,
            156 /* ScanCode.NumpadClearEntry */ ,
            "NumpadClearEntry",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            5 /* KeyCode.Ctrl */ ,
            "Ctrl",
            17,
            "VK_CONTROL",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            4 /* KeyCode.Shift */ ,
            "Shift",
            16,
            "VK_SHIFT",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            6 /* KeyCode.Alt */ ,
            "Alt",
            18,
            "VK_MENU",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            57 /* KeyCode.Meta */ ,
            "Meta",
            91,
            "VK_COMMAND",
            empty,
            empty
        ],
        [
            1,
            157 /* ScanCode.ControlLeft */ ,
            "ControlLeft",
            5 /* KeyCode.Ctrl */ ,
            empty,
            0,
            "VK_LCONTROL",
            empty,
            empty
        ],
        [
            1,
            158 /* ScanCode.ShiftLeft */ ,
            "ShiftLeft",
            4 /* KeyCode.Shift */ ,
            empty,
            0,
            "VK_LSHIFT",
            empty,
            empty
        ],
        [
            1,
            159 /* ScanCode.AltLeft */ ,
            "AltLeft",
            6 /* KeyCode.Alt */ ,
            empty,
            0,
            "VK_LMENU",
            empty,
            empty
        ],
        [
            1,
            160 /* ScanCode.MetaLeft */ ,
            "MetaLeft",
            57 /* KeyCode.Meta */ ,
            empty,
            0,
            "VK_LWIN",
            empty,
            empty
        ],
        [
            1,
            161 /* ScanCode.ControlRight */ ,
            "ControlRight",
            5 /* KeyCode.Ctrl */ ,
            empty,
            0,
            "VK_RCONTROL",
            empty,
            empty
        ],
        [
            1,
            162 /* ScanCode.ShiftRight */ ,
            "ShiftRight",
            4 /* KeyCode.Shift */ ,
            empty,
            0,
            "VK_RSHIFT",
            empty,
            empty
        ],
        [
            1,
            163 /* ScanCode.AltRight */ ,
            "AltRight",
            6 /* KeyCode.Alt */ ,
            empty,
            0,
            "VK_RMENU",
            empty,
            empty
        ],
        [
            1,
            164 /* ScanCode.MetaRight */ ,
            "MetaRight",
            57 /* KeyCode.Meta */ ,
            empty,
            0,
            "VK_RWIN",
            empty,
            empty
        ],
        [
            1,
            165 /* ScanCode.BrightnessUp */ ,
            "BrightnessUp",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            166 /* ScanCode.BrightnessDown */ ,
            "BrightnessDown",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            167 /* ScanCode.MediaPlay */ ,
            "MediaPlay",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            168 /* ScanCode.MediaRecord */ ,
            "MediaRecord",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            169 /* ScanCode.MediaFastForward */ ,
            "MediaFastForward",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            170 /* ScanCode.MediaRewind */ ,
            "MediaRewind",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            171 /* ScanCode.MediaTrackNext */ ,
            "MediaTrackNext",
            124 /* KeyCode.MediaTrackNext */ ,
            "MediaTrackNext",
            176,
            "VK_MEDIA_NEXT_TRACK",
            empty,
            empty
        ],
        [
            1,
            172 /* ScanCode.MediaTrackPrevious */ ,
            "MediaTrackPrevious",
            125 /* KeyCode.MediaTrackPrevious */ ,
            "MediaTrackPrevious",
            177,
            "VK_MEDIA_PREV_TRACK",
            empty,
            empty
        ],
        [
            1,
            173 /* ScanCode.MediaStop */ ,
            "MediaStop",
            126 /* KeyCode.MediaStop */ ,
            "MediaStop",
            178,
            "VK_MEDIA_STOP",
            empty,
            empty
        ],
        [
            1,
            174 /* ScanCode.Eject */ ,
            "Eject",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            175 /* ScanCode.MediaPlayPause */ ,
            "MediaPlayPause",
            127 /* KeyCode.MediaPlayPause */ ,
            "MediaPlayPause",
            179,
            "VK_MEDIA_PLAY_PAUSE",
            empty,
            empty
        ],
        [
            1,
            176 /* ScanCode.MediaSelect */ ,
            "MediaSelect",
            128 /* KeyCode.LaunchMediaPlayer */ ,
            "LaunchMediaPlayer",
            181,
            "VK_MEDIA_LAUNCH_MEDIA_SELECT",
            empty,
            empty
        ],
        [
            1,
            177 /* ScanCode.LaunchMail */ ,
            "LaunchMail",
            129 /* KeyCode.LaunchMail */ ,
            "LaunchMail",
            180,
            "VK_MEDIA_LAUNCH_MAIL",
            empty,
            empty
        ],
        [
            1,
            178 /* ScanCode.LaunchApp2 */ ,
            "LaunchApp2",
            130 /* KeyCode.LaunchApp2 */ ,
            "LaunchApp2",
            183,
            "VK_MEDIA_LAUNCH_APP2",
            empty,
            empty
        ],
        [
            1,
            179 /* ScanCode.LaunchApp1 */ ,
            "LaunchApp1",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_MEDIA_LAUNCH_APP1",
            empty,
            empty
        ],
        [
            1,
            180 /* ScanCode.SelectTask */ ,
            "SelectTask",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            181 /* ScanCode.LaunchScreenSaver */ ,
            "LaunchScreenSaver",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            182 /* ScanCode.BrowserSearch */ ,
            "BrowserSearch",
            120 /* KeyCode.BrowserSearch */ ,
            "BrowserSearch",
            170,
            "VK_BROWSER_SEARCH",
            empty,
            empty
        ],
        [
            1,
            183 /* ScanCode.BrowserHome */ ,
            "BrowserHome",
            121 /* KeyCode.BrowserHome */ ,
            "BrowserHome",
            172,
            "VK_BROWSER_HOME",
            empty,
            empty
        ],
        [
            1,
            184 /* ScanCode.BrowserBack */ ,
            "BrowserBack",
            122 /* KeyCode.BrowserBack */ ,
            "BrowserBack",
            166,
            "VK_BROWSER_BACK",
            empty,
            empty
        ],
        [
            1,
            185 /* ScanCode.BrowserForward */ ,
            "BrowserForward",
            123 /* KeyCode.BrowserForward */ ,
            "BrowserForward",
            167,
            "VK_BROWSER_FORWARD",
            empty,
            empty
        ],
        [
            1,
            186 /* ScanCode.BrowserStop */ ,
            "BrowserStop",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_BROWSER_STOP",
            empty,
            empty
        ],
        [
            1,
            187 /* ScanCode.BrowserRefresh */ ,
            "BrowserRefresh",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_BROWSER_REFRESH",
            empty,
            empty
        ],
        [
            1,
            188 /* ScanCode.BrowserFavorites */ ,
            "BrowserFavorites",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_BROWSER_FAVORITES",
            empty,
            empty
        ],
        [
            1,
            189 /* ScanCode.ZoomToggle */ ,
            "ZoomToggle",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            190 /* ScanCode.MailReply */ ,
            "MailReply",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            191 /* ScanCode.MailForward */ ,
            "MailForward",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        [
            1,
            192 /* ScanCode.MailSend */ ,
            "MailSend",
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            empty,
            empty,
            empty
        ],
        // See https://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
        // If an Input Method Editor is processing key input and the event is keydown, return 229.
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            114 /* KeyCode.KEY_IN_COMPOSITION */ ,
            "KeyInComposition",
            229,
            empty,
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            116 /* KeyCode.ABNT_C2 */ ,
            "ABNT_C2",
            194,
            "VK_ABNT_C2",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            96 /* KeyCode.OEM_8 */ ,
            "OEM_8",
            223,
            "VK_OEM_8",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_KANA",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_HANGUL",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_JUNJA",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_FINAL",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_HANJA",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_KANJI",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_CONVERT",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_NONCONVERT",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_ACCEPT",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_MODECHANGE",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_SELECT",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_PRINT",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_EXECUTE",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_SNAPSHOT",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_HELP",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_APPS",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_PROCESSKEY",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_PACKET",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_DBE_SBCSCHAR",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_DBE_DBCSCHAR",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_ATTN",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_CRSEL",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_EXSEL",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_EREOF",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_PLAY",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_ZOOM",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_NONAME",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_PA1",
            empty,
            empty
        ],
        [
            1,
            0 /* ScanCode.None */ ,
            empty,
            0 /* KeyCode.Unknown */ ,
            empty,
            0,
            "VK_OEM_CLEAR",
            empty,
            empty
        ]
    ];
    const seenKeyCode = [];
    const seenScanCode = [];
    for (const mapping of mappings){
        const [immutable, scanCode, scanCodeStr, keyCode, keyCodeStr, eventKeyCode, vkey, usUserSettingsLabel, generalUserSettingsLabel] = mapping;
        if (!seenScanCode[scanCode]) {
            seenScanCode[scanCode] = true;
            scanCodeIntToStr[scanCode] = scanCodeStr;
            scanCodeStrToInt[scanCodeStr] = scanCode;
            scanCodeLowerCaseStrToInt[scanCodeStr.toLowerCase()] = scanCode;
            if (immutable) {
                IMMUTABLE_CODE_TO_KEY_CODE[scanCode] = keyCode;
                if (keyCode !== 0 /* KeyCode.Unknown */  && keyCode !== 3 /* KeyCode.Enter */  && keyCode !== 5 /* KeyCode.Ctrl */  && keyCode !== 4 /* KeyCode.Shift */  && keyCode !== 6 /* KeyCode.Alt */  && keyCode !== 57 /* KeyCode.Meta */ ) IMMUTABLE_KEY_CODE_TO_CODE[keyCode] = scanCode;
            }
        }
        if (!seenKeyCode[keyCode]) {
            seenKeyCode[keyCode] = true;
            if (!keyCodeStr) throw new Error(`String representation missing for key code ${keyCode} around scan code ${scanCodeStr}`);
            uiMap.define(keyCode, keyCodeStr);
            userSettingsUSMap.define(keyCode, usUserSettingsLabel || keyCodeStr);
            userSettingsGeneralMap.define(keyCode, generalUserSettingsLabel || usUserSettingsLabel || keyCodeStr);
        }
        if (eventKeyCode) EVENT_KEY_CODE_MAP[eventKeyCode] = keyCode;
        if (vkey) NATIVE_WINDOWS_KEY_CODE_TO_KEY_CODE[vkey] = keyCode;
    }
    // Manually added due to the exclusion above (due to duplication with NumpadEnter)
    IMMUTABLE_KEY_CODE_TO_CODE[3 /* KeyCode.Enter */ ] = 46 /* ScanCode.Enter */ ;
})();
var KeyCodeUtils;
(function(KeyCodeUtils) {
    function toString(keyCode) {
        return uiMap.keyCodeToStr(keyCode);
    }
    KeyCodeUtils.toString = toString;
    function fromString(key) {
        return uiMap.strToKeyCode(key);
    }
    KeyCodeUtils.fromString = fromString;
    function toUserSettingsUS(keyCode) {
        return userSettingsUSMap.keyCodeToStr(keyCode);
    }
    KeyCodeUtils.toUserSettingsUS = toUserSettingsUS;
    function toUserSettingsGeneral(keyCode) {
        return userSettingsGeneralMap.keyCodeToStr(keyCode);
    }
    KeyCodeUtils.toUserSettingsGeneral = toUserSettingsGeneral;
    function fromUserSettings(key) {
        return userSettingsUSMap.strToKeyCode(key) || userSettingsGeneralMap.strToKeyCode(key);
    }
    KeyCodeUtils.fromUserSettings = fromUserSettings;
    function toElectronAccelerator(keyCode) {
        if (keyCode >= 98 /* KeyCode.Numpad0 */  && keyCode <= 113 /* KeyCode.NumpadDivide */ ) // [Electron Accelerators] Electron is able to parse numpad keys, but unfortunately it
        // renders them just as regular keys in menus. For example, num0 is rendered as "0",
        // numdiv is rendered as "/", numsub is rendered as "-".
        //
        // This can lead to incredible confusion, as it makes numpad based keybindings indistinguishable
        // from keybindings based on regular keys.
        //
        // We therefore need to fall back to custom rendering for numpad keys.
        return null;
        switch(keyCode){
            case 16 /* KeyCode.UpArrow */ :
                return "Up";
            case 18 /* KeyCode.DownArrow */ :
                return "Down";
            case 15 /* KeyCode.LeftArrow */ :
                return "Left";
            case 17 /* KeyCode.RightArrow */ :
                return "Right";
        }
        return uiMap.keyCodeToStr(keyCode);
    }
    KeyCodeUtils.toElectronAccelerator = toElectronAccelerator;
})(KeyCodeUtils || (KeyCodeUtils = {}));
function KeyChord(firstPart, secondPart) {
    const chordPart = (secondPart & 0x0000FFFF) << 16 >>> 0;
    return (firstPart | chordPart) >>> 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7qGS3":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Uniform Resource Identifier (URI) http://tools.ietf.org/html/rfc3986.
 * This class is a simple parser which creates the basic component parts
 * (http://tools.ietf.org/html/rfc3986#section-3) with minimal validation
 * and encoding.
 *
 * ```txt
 *       foo://example.com:8042/over/there?name=ferret#nose
 *       \_/   \______________/\_________/ \_________/ \__/
 *        |           |            |            |        |
 *     scheme     authority       path        query   fragment
 *        |   _____________________|__
 *       / \ /                        \
 *       urn:example:animal:ferret:nose
 * ```
 */ parcelHelpers.export(exports, "URI", ()=>URI);
/**
 * Compute `fsPath` for the given uri
 */ parcelHelpers.export(exports, "uriToFsPath", ()=>uriToFsPath);
var _pathJs = require("./path.js");
var _platformJs = require("./platform.js");
const _schemePattern = /^\w[\w\d+.-]*$/;
const _singleSlashStart = /^\//;
const _doubleSlashStart = /^\/\//;
function _validateUri(ret, _strict) {
    // scheme, must be set
    if (!ret.scheme && _strict) throw new Error(`[UriError]: Scheme is missing: {scheme: "", authority: "${ret.authority}", path: "${ret.path}", query: "${ret.query}", fragment: "${ret.fragment}"}`);
    // scheme, https://tools.ietf.org/html/rfc3986#section-3.1
    // ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
    if (ret.scheme && !_schemePattern.test(ret.scheme)) throw new Error("[UriError]: Scheme contains illegal characters.");
    // path, http://tools.ietf.org/html/rfc3986#section-3.3
    // If a URI contains an authority component, then the path component
    // must either be empty or begin with a slash ("/") character.  If a URI
    // does not contain an authority component, then the path cannot begin
    // with two slash characters ("//").
    if (ret.path) {
        if (ret.authority) {
            if (!_singleSlashStart.test(ret.path)) throw new Error('[UriError]: If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character');
        } else {
            if (_doubleSlashStart.test(ret.path)) throw new Error('[UriError]: If a URI does not contain an authority component, then the path cannot begin with two slash characters ("//")');
        }
    }
}
// for a while we allowed uris *without* schemes and this is the migration
// for them, e.g. an uri without scheme and without strict-mode warns and falls
// back to the file-scheme. that should cause the least carnage and still be a
// clear warning
function _schemeFix(scheme, _strict) {
    if (!scheme && !_strict) return "file";
    return scheme;
}
// implements a bit of https://tools.ietf.org/html/rfc3986#section-5
function _referenceResolution(scheme, path) {
    // the slash-character is our 'default base' as we don't
    // support constructing URIs relative to other URIs. This
    // also means that we alter and potentially break paths.
    // see https://tools.ietf.org/html/rfc3986#section-5.1.4
    switch(scheme){
        case "https":
        case "http":
        case "file":
            if (!path) path = _slash;
            else if (path[0] !== _slash) path = _slash + path;
            break;
    }
    return path;
}
const _empty = "";
const _slash = "/";
const _regexp = /^(([^:/?#]+?):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
class URI {
    static isUri(thing) {
        if (thing instanceof URI) return true;
        if (!thing) return false;
        return typeof thing.authority === "string" && typeof thing.fragment === "string" && typeof thing.path === "string" && typeof thing.query === "string" && typeof thing.scheme === "string" && typeof thing.fsPath === "string" && typeof thing.with === "function" && typeof thing.toString === "function";
    }
    /**
     * @internal
     */ constructor(schemeOrData, authority, path, query, fragment, _strict = false){
        if (typeof schemeOrData === "object") {
            this.scheme = schemeOrData.scheme || _empty;
            this.authority = schemeOrData.authority || _empty;
            this.path = schemeOrData.path || _empty;
            this.query = schemeOrData.query || _empty;
            this.fragment = schemeOrData.fragment || _empty;
        // no validation because it's this URI
        // that creates uri components.
        // _validateUri(this);
        } else {
            this.scheme = _schemeFix(schemeOrData, _strict);
            this.authority = authority || _empty;
            this.path = _referenceResolution(this.scheme, path || _empty);
            this.query = query || _empty;
            this.fragment = fragment || _empty;
            _validateUri(this, _strict);
        }
    }
    // ---- filesystem path -----------------------
    /**
     * Returns a string representing the corresponding file system path of this URI.
     * Will handle UNC paths, normalizes windows drive letters to lower-case, and uses the
     * platform specific path separator.
     *
     * * Will *not* validate the path for invalid characters and semantics.
     * * Will *not* look at the scheme of this URI.
     * * The result shall *not* be used for display purposes but for accessing a file on disk.
     *
     *
     * The *difference* to `URI#path` is the use of the platform specific separator and the handling
     * of UNC paths. See the below sample of a file-uri with an authority (UNC path).
     *
     * ```ts
        const u = URI.parse('file://server/c$/folder/file.txt')
        u.authority === 'server'
        u.path === '/shares/c$/file.txt'
        u.fsPath === '\\server\c$\folder\file.txt'
    ```
     *
     * Using `URI#path` to read a file (using fs-apis) would not be enough because parts of the path,
     * namely the server name, would be missing. Therefore `URI#fsPath` exists - it's sugar to ease working
     * with URIs that represent files on disk (`file` scheme).
     */ get fsPath() {
        // if (this.scheme !== 'file') {
        // 	console.warn(`[UriError] calling fsPath with scheme ${this.scheme}`);
        // }
        return uriToFsPath(this, false);
    }
    // ---- modify to new -------------------------
    with(change) {
        if (!change) return this;
        let { scheme, authority, path, query, fragment } = change;
        if (scheme === undefined) scheme = this.scheme;
        else if (scheme === null) scheme = _empty;
        if (authority === undefined) authority = this.authority;
        else if (authority === null) authority = _empty;
        if (path === undefined) path = this.path;
        else if (path === null) path = _empty;
        if (query === undefined) query = this.query;
        else if (query === null) query = _empty;
        if (fragment === undefined) fragment = this.fragment;
        else if (fragment === null) fragment = _empty;
        if (scheme === this.scheme && authority === this.authority && path === this.path && query === this.query && fragment === this.fragment) return this;
        return new Uri(scheme, authority, path, query, fragment);
    }
    // ---- parse & validate ------------------------
    /**
     * Creates a new URI from a string, e.g. `http://www.example.com/some/path`,
     * `file:///usr/home`, or `scheme:with/path`.
     *
     * @param value A string which represents an URI (see `URI#toString`).
     */ static parse(value, _strict = false) {
        const match = _regexp.exec(value);
        if (!match) return new Uri(_empty, _empty, _empty, _empty, _empty);
        return new Uri(match[2] || _empty, percentDecode(match[4] || _empty), percentDecode(match[5] || _empty), percentDecode(match[7] || _empty), percentDecode(match[9] || _empty), _strict);
    }
    /**
     * Creates a new URI from a file system path, e.g. `c:\my\files`,
     * `/usr/home`, or `\\server\share\some\path`.
     *
     * The *difference* between `URI#parse` and `URI#file` is that the latter treats the argument
     * as path, not as stringified-uri. E.g. `URI.file(path)` is **not the same as**
     * `URI.parse('file://' + path)` because the path might contain characters that are
     * interpreted (# and ?). See the following sample:
     * ```ts
    const good = URI.file('/coding/c#/project1');
    good.scheme === 'file';
    good.path === '/coding/c#/project1';
    good.fragment === '';
    const bad = URI.parse('file://' + '/coding/c#/project1');
    bad.scheme === 'file';
    bad.path === '/coding/c'; // path is now broken
    bad.fragment === '/project1';
    ```
     *
     * @param path A file system path (see `URI#fsPath`)
     */ static file(path) {
        let authority = _empty;
        // normalize to fwd-slashes on windows,
        // on other systems bwd-slashes are valid
        // filename character, eg /f\oo/ba\r.txt
        if (0, _platformJs.isWindows) path = path.replace(/\\/g, _slash);
        // check for authority as used in UNC shares
        // or use the path as given
        if (path[0] === _slash && path[1] === _slash) {
            const idx = path.indexOf(_slash, 2);
            if (idx === -1) {
                authority = path.substring(2);
                path = _slash;
            } else {
                authority = path.substring(2, idx);
                path = path.substring(idx) || _slash;
            }
        }
        return new Uri("file", authority, path, _empty, _empty);
    }
    /**
     * Creates new URI from uri components.
     *
     * Unless `strict` is `true` the scheme is defaults to be `file`. This function performs
     * validation and should be used for untrusted uri components retrieved from storage,
     * user input, command arguments etc
     */ static from(components, strict) {
        const result = new Uri(components.scheme, components.authority, components.path, components.query, components.fragment, strict);
        return result;
    }
    /**
     * Join a URI path with path fragments and normalizes the resulting path.
     *
     * @param uri The input URI.
     * @param pathFragment The path fragment to add to the URI path.
     * @returns The resulting URI.
     */ static joinPath(uri, ...pathFragment) {
        if (!uri.path) throw new Error(`[UriError]: cannot call joinPath on URI without path`);
        let newPath;
        if ((0, _platformJs.isWindows) && uri.scheme === "file") newPath = URI.file(_pathJs.win32.join(uriToFsPath(uri, true), ...pathFragment)).path;
        else newPath = _pathJs.posix.join(uri.path, ...pathFragment);
        return uri.with({
            path: newPath
        });
    }
    // ---- printing/externalize ---------------------------
    /**
     * Creates a string representation for this URI. It's guaranteed that calling
     * `URI.parse` with the result of this function creates an URI which is equal
     * to this URI.
     *
     * * The result shall *not* be used for display purposes but for externalization or transport.
     * * The result will be encoded using the percentage encoding and encoding happens mostly
     * ignore the scheme-specific encoding rules.
     *
     * @param skipEncoding Do not encode the result, default is `false`
     */ toString(skipEncoding = false) {
        return _asFormatted(this, skipEncoding);
    }
    toJSON() {
        return this;
    }
    static revive(data) {
        if (!data) return data;
        else if (data instanceof URI) return data;
        else {
            const result = new Uri(data);
            result._formatted = data.external ?? null;
            result._fsPath = data._sep === _pathSepMarker ? data.fsPath ?? null : null;
            return result;
        }
    }
}
const _pathSepMarker = (0, _platformJs.isWindows) ? 1 : undefined;
// This class exists so that URI is compatible with vscode.Uri (API).
class Uri extends URI {
    constructor(){
        super(...arguments);
        this._formatted = null;
        this._fsPath = null;
    }
    get fsPath() {
        if (!this._fsPath) this._fsPath = uriToFsPath(this, false);
        return this._fsPath;
    }
    toString(skipEncoding = false) {
        if (!skipEncoding) {
            if (!this._formatted) this._formatted = _asFormatted(this, false);
            return this._formatted;
        } else // we don't cache that
        return _asFormatted(this, true);
    }
    toJSON() {
        const res = {
            $mid: 1 /* MarshalledId.Uri */ 
        };
        // cached state
        if (this._fsPath) {
            res.fsPath = this._fsPath;
            res._sep = _pathSepMarker;
        }
        if (this._formatted) res.external = this._formatted;
        //--- uri components
        if (this.path) res.path = this.path;
        // TODO
        // this isn't correct and can violate the UriComponents contract but
        // this is part of the vscode.Uri API and we shouldn't change how that
        // works anymore
        if (this.scheme) res.scheme = this.scheme;
        if (this.authority) res.authority = this.authority;
        if (this.query) res.query = this.query;
        if (this.fragment) res.fragment = this.fragment;
        return res;
    }
}
// reserved characters: https://tools.ietf.org/html/rfc3986#section-2.2
const encodeTable = {
    [58 /* CharCode.Colon */ ]: "%3A",
    [47 /* CharCode.Slash */ ]: "%2F",
    [63 /* CharCode.QuestionMark */ ]: "%3F",
    [35 /* CharCode.Hash */ ]: "%23",
    [91 /* CharCode.OpenSquareBracket */ ]: "%5B",
    [93 /* CharCode.CloseSquareBracket */ ]: "%5D",
    [64 /* CharCode.AtSign */ ]: "%40",
    [33 /* CharCode.ExclamationMark */ ]: "%21",
    [36 /* CharCode.DollarSign */ ]: "%24",
    [38 /* CharCode.Ampersand */ ]: "%26",
    [39 /* CharCode.SingleQuote */ ]: "%27",
    [40 /* CharCode.OpenParen */ ]: "%28",
    [41 /* CharCode.CloseParen */ ]: "%29",
    [42 /* CharCode.Asterisk */ ]: "%2A",
    [43 /* CharCode.Plus */ ]: "%2B",
    [44 /* CharCode.Comma */ ]: "%2C",
    [59 /* CharCode.Semicolon */ ]: "%3B",
    [61 /* CharCode.Equals */ ]: "%3D",
    [32 /* CharCode.Space */ ]: "%20"
};
function encodeURIComponentFast(uriComponent, isPath, isAuthority) {
    let res = undefined;
    let nativeEncodePos = -1;
    for(let pos = 0; pos < uriComponent.length; pos++){
        const code = uriComponent.charCodeAt(pos);
        // unreserved characters: https://tools.ietf.org/html/rfc3986#section-2.3
        if (code >= 97 /* CharCode.a */  && code <= 122 /* CharCode.z */  || code >= 65 /* CharCode.A */  && code <= 90 /* CharCode.Z */  || code >= 48 /* CharCode.Digit0 */  && code <= 57 /* CharCode.Digit9 */  || code === 45 /* CharCode.Dash */  || code === 46 /* CharCode.Period */  || code === 95 /* CharCode.Underline */  || code === 126 /* CharCode.Tilde */  || isPath && code === 47 /* CharCode.Slash */  || isAuthority && code === 91 /* CharCode.OpenSquareBracket */  || isAuthority && code === 93 /* CharCode.CloseSquareBracket */  || isAuthority && code === 58 /* CharCode.Colon */ ) {
            // check if we are delaying native encode
            if (nativeEncodePos !== -1) {
                res += encodeURIComponent(uriComponent.substring(nativeEncodePos, pos));
                nativeEncodePos = -1;
            }
            // check if we write into a new string (by default we try to return the param)
            if (res !== undefined) res += uriComponent.charAt(pos);
        } else {
            // encoding needed, we need to allocate a new string
            if (res === undefined) res = uriComponent.substr(0, pos);
            // check with default table first
            const escaped = encodeTable[code];
            if (escaped !== undefined) {
                // check if we are delaying native encode
                if (nativeEncodePos !== -1) {
                    res += encodeURIComponent(uriComponent.substring(nativeEncodePos, pos));
                    nativeEncodePos = -1;
                }
                // append escaped variant to result
                res += escaped;
            } else if (nativeEncodePos === -1) // use native encode only when needed
            nativeEncodePos = pos;
        }
    }
    if (nativeEncodePos !== -1) res += encodeURIComponent(uriComponent.substring(nativeEncodePos));
    return res !== undefined ? res : uriComponent;
}
function encodeURIComponentMinimal(path) {
    let res = undefined;
    for(let pos = 0; pos < path.length; pos++){
        const code = path.charCodeAt(pos);
        if (code === 35 /* CharCode.Hash */  || code === 63 /* CharCode.QuestionMark */ ) {
            if (res === undefined) res = path.substr(0, pos);
            res += encodeTable[code];
        } else if (res !== undefined) res += path[pos];
    }
    return res !== undefined ? res : path;
}
function uriToFsPath(uri, keepDriveLetterCasing) {
    let value;
    if (uri.authority && uri.path.length > 1 && uri.scheme === "file") // unc path: file://shares/c$/far/boo
    value = `//${uri.authority}${uri.path}`;
    else if (uri.path.charCodeAt(0) === 47 /* CharCode.Slash */  && (uri.path.charCodeAt(1) >= 65 /* CharCode.A */  && uri.path.charCodeAt(1) <= 90 /* CharCode.Z */  || uri.path.charCodeAt(1) >= 97 /* CharCode.a */  && uri.path.charCodeAt(1) <= 122 /* CharCode.z */ ) && uri.path.charCodeAt(2) === 58 /* CharCode.Colon */ ) {
        if (!keepDriveLetterCasing) // windows drive letter: file:///c:/far/boo
        value = uri.path[1].toLowerCase() + uri.path.substr(2);
        else value = uri.path.substr(1);
    } else // other path
    value = uri.path;
    if (0, _platformJs.isWindows) value = value.replace(/\//g, "\\");
    return value;
}
/**
 * Create the external version of a uri
 */ function _asFormatted(uri, skipEncoding) {
    const encoder = !skipEncoding ? encodeURIComponentFast : encodeURIComponentMinimal;
    let res = "";
    let { scheme, authority, path, query, fragment } = uri;
    if (scheme) {
        res += scheme;
        res += ":";
    }
    if (authority || scheme === "file") {
        res += _slash;
        res += _slash;
    }
    if (authority) {
        let idx = authority.indexOf("@");
        if (idx !== -1) {
            // <user>@<auth>
            const userinfo = authority.substr(0, idx);
            authority = authority.substr(idx + 1);
            idx = userinfo.lastIndexOf(":");
            if (idx === -1) res += encoder(userinfo, false, false);
            else {
                // <user>:<pass>@<auth>
                res += encoder(userinfo.substr(0, idx), false, false);
                res += ":";
                res += encoder(userinfo.substr(idx + 1), false, true);
            }
            res += "@";
        }
        authority = authority.toLowerCase();
        idx = authority.lastIndexOf(":");
        if (idx === -1) res += encoder(authority, false, true);
        else {
            // <auth>:<port>
            res += encoder(authority.substr(0, idx), false, true);
            res += authority.substr(idx);
        }
    }
    if (path) {
        // lower-case windows drive letters in /C:/fff or C:/fff
        if (path.length >= 3 && path.charCodeAt(0) === 47 /* CharCode.Slash */  && path.charCodeAt(2) === 58 /* CharCode.Colon */ ) {
            const code = path.charCodeAt(1);
            if (code >= 65 /* CharCode.A */  && code <= 90 /* CharCode.Z */ ) path = `/${String.fromCharCode(code + 32)}:${path.substr(3)}`; // "/c:".length === 3
        } else if (path.length >= 2 && path.charCodeAt(1) === 58 /* CharCode.Colon */ ) {
            const code = path.charCodeAt(0);
            if (code >= 65 /* CharCode.A */  && code <= 90 /* CharCode.Z */ ) path = `${String.fromCharCode(code + 32)}:${path.substr(2)}`; // "/c:".length === 3
        }
        // encode the rest of the path
        res += encoder(path, true, false);
    }
    if (query) {
        res += "?";
        res += encoder(query, false, false);
    }
    if (fragment) {
        res += "#";
        res += !skipEncoding ? encodeURIComponentFast(fragment, false, false) : fragment;
    }
    return res;
}
// --- decode
function decodeURIComponentGraceful(str) {
    try {
        return decodeURIComponent(str);
    } catch  {
        if (str.length > 3) return str.substr(0, 3) + decodeURIComponentGraceful(str.substr(3));
        else return str;
    }
}
const _rEncodedAsHex = /(%[0-9A-Za-z][0-9A-Za-z])+/g;
function percentDecode(str) {
    if (!str.match(_rEncodedAsHex)) return str;
    return str.replace(_rEncodedAsHex, (match)=>decodeURIComponentGraceful(match));
}

},{"./path.js":"vyRKJ","./platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"vyRKJ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ // NOTE: VSCode's copy of nodejs path library to be usable in common (non-node) namespace
// Copied from: https://github.com/nodejs/node/commits/v20.9.0/lib/path.js
// Excluding: the change that adds primordials
// (https://github.com/nodejs/node/commit/187a862d221dec42fa9a5c4214e7034d9092792f and others)
/**
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "win32", ()=>win32);
parcelHelpers.export(exports, "posix", ()=>posix);
parcelHelpers.export(exports, "normalize", ()=>normalize);
parcelHelpers.export(exports, "join", ()=>join);
parcelHelpers.export(exports, "resolve", ()=>resolve);
parcelHelpers.export(exports, "relative", ()=>relative);
parcelHelpers.export(exports, "dirname", ()=>dirname);
parcelHelpers.export(exports, "basename", ()=>basename);
parcelHelpers.export(exports, "extname", ()=>extname);
parcelHelpers.export(exports, "sep", ()=>sep);
var _processJs = require("./process.js");
const CHAR_UPPERCASE_A = 65; /* A */ 
const CHAR_LOWERCASE_A = 97; /* a */ 
const CHAR_UPPERCASE_Z = 90; /* Z */ 
const CHAR_LOWERCASE_Z = 122; /* z */ 
const CHAR_DOT = 46; /* . */ 
const CHAR_FORWARD_SLASH = 47; /* / */ 
const CHAR_BACKWARD_SLASH = 92; /* \ */ 
const CHAR_COLON = 58; /* : */ 
const CHAR_QUESTION_MARK = 63; /* ? */ 
class ErrorInvalidArgType extends Error {
    constructor(name, expected, actual){
        // determiner: 'must be' or 'must not be'
        let determiner;
        if (typeof expected === "string" && expected.indexOf("not ") === 0) {
            determiner = "must not be";
            expected = expected.replace(/^not /, "");
        } else determiner = "must be";
        const type = name.indexOf(".") !== -1 ? "property" : "argument";
        let msg = `The "${name}" ${type} ${determiner} of type ${expected}`;
        msg += `. Received type ${typeof actual}`;
        super(msg);
        this.code = "ERR_INVALID_ARG_TYPE";
    }
}
function validateObject(pathObject, name) {
    if (pathObject === null || typeof pathObject !== "object") throw new ErrorInvalidArgType(name, "Object", pathObject);
}
function validateString(value, name) {
    if (typeof value !== "string") throw new ErrorInvalidArgType(name, "string", value);
}
const platformIsWin32 = _processJs.platform === "win32";
function isPathSeparator(code) {
    return code === CHAR_FORWARD_SLASH || code === CHAR_BACKWARD_SLASH;
}
function isPosixPathSeparator(code) {
    return code === CHAR_FORWARD_SLASH;
}
function isWindowsDeviceRoot(code) {
    return code >= CHAR_UPPERCASE_A && code <= CHAR_UPPERCASE_Z || code >= CHAR_LOWERCASE_A && code <= CHAR_LOWERCASE_Z;
}
// Resolves . and .. elements in a path with directory names
function normalizeString(path, allowAboveRoot, separator, isPathSeparator) {
    let res = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let code = 0;
    for(let i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (isPathSeparator(code)) break;
        else code = CHAR_FORWARD_SLASH;
        if (isPathSeparator(code)) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== CHAR_DOT || res.charCodeAt(res.length - 2) !== CHAR_DOT) {
                    if (res.length > 2) {
                        const lastSlashIndex = res.lastIndexOf(separator);
                        if (lastSlashIndex === -1) {
                            res = "";
                            lastSegmentLength = 0;
                        } else {
                            res = res.slice(0, lastSlashIndex);
                            lastSegmentLength = res.length - 1 - res.lastIndexOf(separator);
                        }
                        lastSlash = i;
                        dots = 0;
                        continue;
                    } else if (res.length !== 0) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    res += res.length > 0 ? `${separator}..` : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += `${separator}${path.slice(lastSlash + 1, i)}`;
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === CHAR_DOT && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function formatExt(ext) {
    return ext ? `${ext[0] === "." ? "" : "."}${ext}` : "";
}
function _format(sep, pathObject) {
    validateObject(pathObject, "pathObject");
    const dir = pathObject.dir || pathObject.root;
    const base = pathObject.base || `${pathObject.name || ""}${formatExt(pathObject.ext)}`;
    if (!dir) return base;
    return dir === pathObject.root ? `${dir}${base}` : `${dir}${sep}${base}`;
}
const win32 = {
    // path.resolve([from ...], to)
    resolve (...pathSegments) {
        let resolvedDevice = "";
        let resolvedTail = "";
        let resolvedAbsolute = false;
        for(let i = pathSegments.length - 1; i >= -1; i--){
            let path;
            if (i >= 0) {
                path = pathSegments[i];
                validateString(path, `paths[${i}]`);
                // Skip empty entries
                if (path.length === 0) continue;
            } else if (resolvedDevice.length === 0) path = _processJs.cwd();
            else {
                // Windows has the concept of drive-specific current working
                // directories. If we've resolved a drive letter but not yet an
                // absolute path, get cwd for that drive, or the process cwd if
                // the drive cwd is not available. We're sure the device is not
                // a UNC path at this points, because UNC paths are always absolute.
                path = _processJs.env[`=${resolvedDevice}`] || _processJs.cwd();
                // Verify that a cwd was found and that it actually points
                // to our drive. If not, default to the drive's root.
                if (path === undefined || path.slice(0, 2).toLowerCase() !== resolvedDevice.toLowerCase() && path.charCodeAt(2) === CHAR_BACKWARD_SLASH) path = `${resolvedDevice}\\`;
            }
            const len = path.length;
            let rootEnd = 0;
            let device = "";
            let isAbsolute = false;
            const code = path.charCodeAt(0);
            // Try to match a root
            if (len === 1) {
                if (isPathSeparator(code)) {
                    // `path` contains just a path separator
                    rootEnd = 1;
                    isAbsolute = true;
                }
            } else if (isPathSeparator(code)) {
                // Possible UNC root
                // If we started with a separator, we know we at least have an
                // absolute path of some kind (UNC or otherwise)
                isAbsolute = true;
                if (isPathSeparator(path.charCodeAt(1))) {
                    // Matched double path separator at beginning
                    let j = 2;
                    let last = j;
                    // Match 1 or more non-path separators
                    while(j < len && !isPathSeparator(path.charCodeAt(j)))j++;
                    if (j < len && j !== last) {
                        const firstPart = path.slice(last, j);
                        // Matched!
                        last = j;
                        // Match 1 or more path separators
                        while(j < len && isPathSeparator(path.charCodeAt(j)))j++;
                        if (j < len && j !== last) {
                            // Matched!
                            last = j;
                            // Match 1 or more non-path separators
                            while(j < len && !isPathSeparator(path.charCodeAt(j)))j++;
                            if (j === len || j !== last) {
                                // We matched a UNC root
                                device = `\\\\${firstPart}\\${path.slice(last, j)}`;
                                rootEnd = j;
                            }
                        }
                    }
                } else rootEnd = 1;
            } else if (isWindowsDeviceRoot(code) && path.charCodeAt(1) === CHAR_COLON) {
                // Possible device root
                device = path.slice(0, 2);
                rootEnd = 2;
                if (len > 2 && isPathSeparator(path.charCodeAt(2))) {
                    // Treat separator following drive name as an absolute path
                    // indicator
                    isAbsolute = true;
                    rootEnd = 3;
                }
            }
            if (device.length > 0) {
                if (resolvedDevice.length > 0) {
                    if (device.toLowerCase() !== resolvedDevice.toLowerCase()) continue;
                } else resolvedDevice = device;
            }
            if (resolvedAbsolute) {
                if (resolvedDevice.length > 0) break;
            } else {
                resolvedTail = `${path.slice(rootEnd)}\\${resolvedTail}`;
                resolvedAbsolute = isAbsolute;
                if (isAbsolute && resolvedDevice.length > 0) break;
            }
        }
        // At this point the path should be resolved to a full absolute path,
        // but handle relative paths to be safe (might happen when process.cwd()
        // fails)
        // Normalize the tail path
        resolvedTail = normalizeString(resolvedTail, !resolvedAbsolute, "\\", isPathSeparator);
        return resolvedAbsolute ? `${resolvedDevice}\\${resolvedTail}` : `${resolvedDevice}${resolvedTail}` || ".";
    },
    normalize (path) {
        validateString(path, "path");
        const len = path.length;
        if (len === 0) return ".";
        let rootEnd = 0;
        let device;
        let isAbsolute = false;
        const code = path.charCodeAt(0);
        // Try to match a root
        if (len === 1) // `path` contains just a single char, exit early to avoid
        // unnecessary work
        return isPosixPathSeparator(code) ? "\\" : path;
        if (isPathSeparator(code)) {
            // Possible UNC root
            // If we started with a separator, we know we at least have an absolute
            // path of some kind (UNC or otherwise)
            isAbsolute = true;
            if (isPathSeparator(path.charCodeAt(1))) {
                // Matched double path separator at beginning
                let j = 2;
                let last = j;
                // Match 1 or more non-path separators
                while(j < len && !isPathSeparator(path.charCodeAt(j)))j++;
                if (j < len && j !== last) {
                    const firstPart = path.slice(last, j);
                    // Matched!
                    last = j;
                    // Match 1 or more path separators
                    while(j < len && isPathSeparator(path.charCodeAt(j)))j++;
                    if (j < len && j !== last) {
                        // Matched!
                        last = j;
                        // Match 1 or more non-path separators
                        while(j < len && !isPathSeparator(path.charCodeAt(j)))j++;
                        if (j === len) // We matched a UNC root only
                        // Return the normalized version of the UNC root since there
                        // is nothing left to process
                        return `\\\\${firstPart}\\${path.slice(last)}\\`;
                        if (j !== last) {
                            // We matched a UNC root with leftovers
                            device = `\\\\${firstPart}\\${path.slice(last, j)}`;
                            rootEnd = j;
                        }
                    }
                }
            } else rootEnd = 1;
        } else if (isWindowsDeviceRoot(code) && path.charCodeAt(1) === CHAR_COLON) {
            // Possible device root
            device = path.slice(0, 2);
            rootEnd = 2;
            if (len > 2 && isPathSeparator(path.charCodeAt(2))) {
                // Treat separator following drive name as an absolute path
                // indicator
                isAbsolute = true;
                rootEnd = 3;
            }
        }
        let tail = rootEnd < len ? normalizeString(path.slice(rootEnd), !isAbsolute, "\\", isPathSeparator) : "";
        if (tail.length === 0 && !isAbsolute) tail = ".";
        if (tail.length > 0 && isPathSeparator(path.charCodeAt(len - 1))) tail += "\\";
        if (device === undefined) return isAbsolute ? `\\${tail}` : tail;
        return isAbsolute ? `${device}\\${tail}` : `${device}${tail}`;
    },
    isAbsolute (path) {
        validateString(path, "path");
        const len = path.length;
        if (len === 0) return false;
        const code = path.charCodeAt(0);
        return isPathSeparator(code) || // Possible device root
        len > 2 && isWindowsDeviceRoot(code) && path.charCodeAt(1) === CHAR_COLON && isPathSeparator(path.charCodeAt(2));
    },
    join (...paths) {
        if (paths.length === 0) return ".";
        let joined;
        let firstPart;
        for(let i = 0; i < paths.length; ++i){
            const arg = paths[i];
            validateString(arg, "path");
            if (arg.length > 0) {
                if (joined === undefined) joined = firstPart = arg;
                else joined += `\\${arg}`;
            }
        }
        if (joined === undefined) return ".";
        // Make sure that the joined path doesn't start with two slashes, because
        // normalize() will mistake it for a UNC path then.
        //
        // This step is skipped when it is very clear that the user actually
        // intended to point at a UNC path. This is assumed when the first
        // non-empty string arguments starts with exactly two slashes followed by
        // at least one more non-slash character.
        //
        // Note that for normalize() to treat a path as a UNC path it needs to
        // have at least 2 components, so we don't filter for that here.
        // This means that the user can use join to construct UNC paths from
        // a server name and a share name; for example:
        //   path.join('//server', 'share') -> '\\\\server\\share\\')
        let needsReplace = true;
        let slashCount = 0;
        if (typeof firstPart === "string" && isPathSeparator(firstPart.charCodeAt(0))) {
            ++slashCount;
            const firstLen = firstPart.length;
            if (firstLen > 1 && isPathSeparator(firstPart.charCodeAt(1))) {
                ++slashCount;
                if (firstLen > 2) {
                    if (isPathSeparator(firstPart.charCodeAt(2))) ++slashCount;
                    else // We matched a UNC path in the first part
                    needsReplace = false;
                }
            }
        }
        if (needsReplace) {
            // Find any more consecutive slashes we need to replace
            while(slashCount < joined.length && isPathSeparator(joined.charCodeAt(slashCount)))slashCount++;
            // Replace the slashes if needed
            if (slashCount >= 2) joined = `\\${joined.slice(slashCount)}`;
        }
        return win32.normalize(joined);
    },
    // It will solve the relative path from `from` to `to`, for instance:
    //  from = 'C:\\orandea\\test\\aaa'
    //  to = 'C:\\orandea\\impl\\bbb'
    // The output of the function should be: '..\\..\\impl\\bbb'
    relative (from, to) {
        validateString(from, "from");
        validateString(to, "to");
        if (from === to) return "";
        const fromOrig = win32.resolve(from);
        const toOrig = win32.resolve(to);
        if (fromOrig === toOrig) return "";
        from = fromOrig.toLowerCase();
        to = toOrig.toLowerCase();
        if (from === to) return "";
        // Trim any leading backslashes
        let fromStart = 0;
        while(fromStart < from.length && from.charCodeAt(fromStart) === CHAR_BACKWARD_SLASH)fromStart++;
        // Trim trailing backslashes (applicable to UNC paths only)
        let fromEnd = from.length;
        while(fromEnd - 1 > fromStart && from.charCodeAt(fromEnd - 1) === CHAR_BACKWARD_SLASH)fromEnd--;
        const fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        let toStart = 0;
        while(toStart < to.length && to.charCodeAt(toStart) === CHAR_BACKWARD_SLASH)toStart++;
        // Trim trailing backslashes (applicable to UNC paths only)
        let toEnd = to.length;
        while(toEnd - 1 > toStart && to.charCodeAt(toEnd - 1) === CHAR_BACKWARD_SLASH)toEnd--;
        const toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        const length = fromLen < toLen ? fromLen : toLen;
        let lastCommonSep = -1;
        let i = 0;
        for(; i < length; i++){
            const fromCode = from.charCodeAt(fromStart + i);
            if (fromCode !== to.charCodeAt(toStart + i)) break;
            else if (fromCode === CHAR_BACKWARD_SLASH) lastCommonSep = i;
        }
        // We found a mismatch before the first common path separator was seen, so
        // return the original `to`.
        if (i !== length) {
            if (lastCommonSep === -1) return toOrig;
        } else {
            if (toLen > length) {
                if (to.charCodeAt(toStart + i) === CHAR_BACKWARD_SLASH) // We get here if `from` is the exact base path for `to`.
                // For example: from='C:\\foo\\bar'; to='C:\\foo\\bar\\baz'
                return toOrig.slice(toStart + i + 1);
                if (i === 2) // We get here if `from` is the device root.
                // For example: from='C:\\'; to='C:\\foo'
                return toOrig.slice(toStart + i);
            }
            if (fromLen > length) {
                if (from.charCodeAt(fromStart + i) === CHAR_BACKWARD_SLASH) // We get here if `to` is the exact base path for `from`.
                // For example: from='C:\\foo\\bar'; to='C:\\foo'
                lastCommonSep = i;
                else if (i === 2) // We get here if `to` is the device root.
                // For example: from='C:\\foo\\bar'; to='C:\\'
                lastCommonSep = 3;
            }
            if (lastCommonSep === -1) lastCommonSep = 0;
        }
        let out = "";
        // Generate the relative path based on the path difference between `to` and
        // `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === CHAR_BACKWARD_SLASH) out += out.length === 0 ? ".." : "\\..";
        toStart += lastCommonSep;
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return `${out}${toOrig.slice(toStart, toEnd)}`;
        if (toOrig.charCodeAt(toStart) === CHAR_BACKWARD_SLASH) ++toStart;
        return toOrig.slice(toStart, toEnd);
    },
    toNamespacedPath (path) {
        // Note: this will *probably* throw somewhere.
        if (typeof path !== "string" || path.length === 0) return path;
        const resolvedPath = win32.resolve(path);
        if (resolvedPath.length <= 2) return path;
        if (resolvedPath.charCodeAt(0) === CHAR_BACKWARD_SLASH) // Possible UNC root
        {
            if (resolvedPath.charCodeAt(1) === CHAR_BACKWARD_SLASH) {
                const code = resolvedPath.charCodeAt(2);
                if (code !== CHAR_QUESTION_MARK && code !== CHAR_DOT) // Matched non-long UNC root, convert the path to a long UNC path
                return `\\\\?\\UNC\\${resolvedPath.slice(2)}`;
            }
        } else if (isWindowsDeviceRoot(resolvedPath.charCodeAt(0)) && resolvedPath.charCodeAt(1) === CHAR_COLON && resolvedPath.charCodeAt(2) === CHAR_BACKWARD_SLASH) // Matched device root, convert the path to a long UNC path
        return `\\\\?\\${resolvedPath}`;
        return path;
    },
    dirname (path) {
        validateString(path, "path");
        const len = path.length;
        if (len === 0) return ".";
        let rootEnd = -1;
        let offset = 0;
        const code = path.charCodeAt(0);
        if (len === 1) // `path` contains just a path separator, exit early to avoid
        // unnecessary work or a dot.
        return isPathSeparator(code) ? path : ".";
        // Try to match a root
        if (isPathSeparator(code)) {
            // Possible UNC root
            rootEnd = offset = 1;
            if (isPathSeparator(path.charCodeAt(1))) {
                // Matched double path separator at beginning
                let j = 2;
                let last = j;
                // Match 1 or more non-path separators
                while(j < len && !isPathSeparator(path.charCodeAt(j)))j++;
                if (j < len && j !== last) {
                    // Matched!
                    last = j;
                    // Match 1 or more path separators
                    while(j < len && isPathSeparator(path.charCodeAt(j)))j++;
                    if (j < len && j !== last) {
                        // Matched!
                        last = j;
                        // Match 1 or more non-path separators
                        while(j < len && !isPathSeparator(path.charCodeAt(j)))j++;
                        if (j === len) // We matched a UNC root only
                        return path;
                        if (j !== last) // We matched a UNC root with leftovers
                        // Offset by 1 to include the separator after the UNC root to
                        // treat it as a "normal root" on top of a (UNC) root
                        rootEnd = offset = j + 1;
                    }
                }
            }
        // Possible device root
        } else if (isWindowsDeviceRoot(code) && path.charCodeAt(1) === CHAR_COLON) {
            rootEnd = len > 2 && isPathSeparator(path.charCodeAt(2)) ? 3 : 2;
            offset = rootEnd;
        }
        let end = -1;
        let matchedSlash = true;
        for(let i = len - 1; i >= offset; --i){
            if (isPathSeparator(path.charCodeAt(i))) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) {
            if (rootEnd === -1) return ".";
            end = rootEnd;
        }
        return path.slice(0, end);
    },
    basename (path, suffix) {
        if (suffix !== undefined) validateString(suffix, "suffix");
        validateString(path, "path");
        let start = 0;
        let end = -1;
        let matchedSlash = true;
        let i;
        // Check for a drive letter prefix so as not to mistake the following
        // path separator as an extra separator at the end of the path that can be
        // disregarded
        if (path.length >= 2 && isWindowsDeviceRoot(path.charCodeAt(0)) && path.charCodeAt(1) === CHAR_COLON) start = 2;
        if (suffix !== undefined && suffix.length > 0 && suffix.length <= path.length) {
            if (suffix === path) return "";
            let extIdx = suffix.length - 1;
            let firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= start; --i){
                const code = path.charCodeAt(i);
                if (isPathSeparator(code)) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === suffix.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        }
        for(i = path.length - 1; i >= start; --i){
            if (isPathSeparator(path.charCodeAt(i))) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            {
                if (!matchedSlash) {
                    start = i + 1;
                    break;
                }
            } else if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // path component
                matchedSlash = false;
                end = i + 1;
            }
        }
        if (end === -1) return "";
        return path.slice(start, end);
    },
    extname (path) {
        validateString(path, "path");
        let start = 0;
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        let preDotState = 0;
        // Check for a drive letter prefix so as not to mistake the following
        // path separator as an extra separator at the end of the path that can be
        // disregarded
        if (path.length >= 2 && path.charCodeAt(1) === CHAR_COLON && isWindowsDeviceRoot(path.charCodeAt(0))) start = startPart = 2;
        for(let i = path.length - 1; i >= start; --i){
            const code = path.charCodeAt(i);
            if (isPathSeparator(code)) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === CHAR_DOT) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: _format.bind(null, "\\"),
    parse (path) {
        validateString(path, "path");
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        const len = path.length;
        let rootEnd = 0;
        let code = path.charCodeAt(0);
        if (len === 1) {
            if (isPathSeparator(code)) {
                // `path` contains just a path separator, exit early to avoid
                // unnecessary work
                ret.root = ret.dir = path;
                return ret;
            }
            ret.base = ret.name = path;
            return ret;
        }
        // Try to match a root
        if (isPathSeparator(code)) {
            // Possible UNC root
            rootEnd = 1;
            if (isPathSeparator(path.charCodeAt(1))) {
                // Matched double path separator at beginning
                let j = 2;
                let last = j;
                // Match 1 or more non-path separators
                while(j < len && !isPathSeparator(path.charCodeAt(j)))j++;
                if (j < len && j !== last) {
                    // Matched!
                    last = j;
                    // Match 1 or more path separators
                    while(j < len && isPathSeparator(path.charCodeAt(j)))j++;
                    if (j < len && j !== last) {
                        // Matched!
                        last = j;
                        // Match 1 or more non-path separators
                        while(j < len && !isPathSeparator(path.charCodeAt(j)))j++;
                        if (j === len) // We matched a UNC root only
                        rootEnd = j;
                        else if (j !== last) // We matched a UNC root with leftovers
                        rootEnd = j + 1;
                    }
                }
            }
        } else if (isWindowsDeviceRoot(code) && path.charCodeAt(1) === CHAR_COLON) {
            // Possible device root
            if (len <= 2) {
                // `path` contains just a drive root, exit early to avoid
                // unnecessary work
                ret.root = ret.dir = path;
                return ret;
            }
            rootEnd = 2;
            if (isPathSeparator(path.charCodeAt(2))) {
                if (len === 3) {
                    // `path` contains just a drive root, exit early to avoid
                    // unnecessary work
                    ret.root = ret.dir = path;
                    return ret;
                }
                rootEnd = 3;
            }
        }
        if (rootEnd > 0) ret.root = path.slice(0, rootEnd);
        let startDot = -1;
        let startPart = rootEnd;
        let end = -1;
        let matchedSlash = true;
        let i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        let preDotState = 0;
        // Get non-dir info
        for(; i >= rootEnd; --i){
            code = path.charCodeAt(i);
            if (isPathSeparator(code)) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === CHAR_DOT) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (end !== -1) {
            if (startDot === -1 || // We saw a non-dot character immediately before the dot
            preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
            preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) ret.base = ret.name = path.slice(startPart, end);
            else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
                ret.ext = path.slice(startDot, end);
            }
        }
        // If the directory is the root, use the entire root as the `dir` including
        // the trailing slash if any (`C:\abc` -> `C:\`). Otherwise, strip out the
        // trailing slash (`C:\abc\def` -> `C:\abc`).
        if (startPart > 0 && startPart !== rootEnd) ret.dir = path.slice(0, startPart - 1);
        else ret.dir = ret.root;
        return ret;
    },
    sep: "\\",
    delimiter: ";",
    win32: null,
    posix: null
};
const posixCwd = (()=>{
    if (platformIsWin32) {
        // Converts Windows' backslash path separators to POSIX forward slashes
        // and truncates any drive indicator
        const regexp = /\\/g;
        return ()=>{
            const cwd = _processJs.cwd().replace(regexp, "/");
            return cwd.slice(cwd.indexOf("/"));
        };
    }
    // We're already on POSIX, no need for any transformations
    return ()=>_processJs.cwd();
})();
const posix = {
    // path.resolve([from ...], to)
    resolve (...pathSegments) {
        let resolvedPath = "";
        let resolvedAbsolute = false;
        for(let i = pathSegments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            const path = i >= 0 ? pathSegments[i] : posixCwd();
            validateString(path, `paths[${i}]`);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = `${path}/${resolvedPath}`;
            resolvedAbsolute = path.charCodeAt(0) === CHAR_FORWARD_SLASH;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = normalizeString(resolvedPath, !resolvedAbsolute, "/", isPosixPathSeparator);
        if (resolvedAbsolute) return `/${resolvedPath}`;
        return resolvedPath.length > 0 ? resolvedPath : ".";
    },
    normalize (path) {
        validateString(path, "path");
        if (path.length === 0) return ".";
        const isAbsolute = path.charCodeAt(0) === CHAR_FORWARD_SLASH;
        const trailingSeparator = path.charCodeAt(path.length - 1) === CHAR_FORWARD_SLASH;
        // Normalize the path
        path = normalizeString(path, !isAbsolute, "/", isPosixPathSeparator);
        if (path.length === 0) {
            if (isAbsolute) return "/";
            return trailingSeparator ? "./" : ".";
        }
        if (trailingSeparator) path += "/";
        return isAbsolute ? `/${path}` : path;
    },
    isAbsolute (path) {
        validateString(path, "path");
        return path.length > 0 && path.charCodeAt(0) === CHAR_FORWARD_SLASH;
    },
    join (...paths) {
        if (paths.length === 0) return ".";
        let joined;
        for(let i = 0; i < paths.length; ++i){
            const arg = paths[i];
            validateString(arg, "path");
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += `/${arg}`;
            }
        }
        if (joined === undefined) return ".";
        return posix.normalize(joined);
    },
    relative (from, to) {
        validateString(from, "from");
        validateString(to, "to");
        if (from === to) return "";
        // Trim leading forward slashes.
        from = posix.resolve(from);
        to = posix.resolve(to);
        if (from === to) return "";
        const fromStart = 1;
        const fromEnd = from.length;
        const fromLen = fromEnd - fromStart;
        const toStart = 1;
        const toLen = to.length - toStart;
        // Compare paths to find the longest common path from root
        const length = fromLen < toLen ? fromLen : toLen;
        let lastCommonSep = -1;
        let i = 0;
        for(; i < length; i++){
            const fromCode = from.charCodeAt(fromStart + i);
            if (fromCode !== to.charCodeAt(toStart + i)) break;
            else if (fromCode === CHAR_FORWARD_SLASH) lastCommonSep = i;
        }
        if (i === length) {
            if (toLen > length) {
                if (to.charCodeAt(toStart + i) === CHAR_FORWARD_SLASH) // We get here if `from` is the exact base path for `to`.
                // For example: from='/foo/bar'; to='/foo/bar/baz'
                return to.slice(toStart + i + 1);
                if (i === 0) // We get here if `from` is the root
                // For example: from='/'; to='/foo'
                return to.slice(toStart + i);
            } else if (fromLen > length) {
                if (from.charCodeAt(fromStart + i) === CHAR_FORWARD_SLASH) // We get here if `to` is the exact base path for `from`.
                // For example: from='/foo/bar/baz'; to='/foo/bar'
                lastCommonSep = i;
                else if (i === 0) // We get here if `to` is the root.
                // For example: from='/foo/bar'; to='/'
                lastCommonSep = 0;
            }
        }
        let out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`.
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === CHAR_FORWARD_SLASH) out += out.length === 0 ? ".." : "/..";
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts.
        return `${out}${to.slice(toStart + lastCommonSep)}`;
    },
    toNamespacedPath (path) {
        // Non-op on posix systems
        return path;
    },
    dirname (path) {
        validateString(path, "path");
        if (path.length === 0) return ".";
        const hasRoot = path.charCodeAt(0) === CHAR_FORWARD_SLASH;
        let end = -1;
        let matchedSlash = true;
        for(let i = path.length - 1; i >= 1; --i){
            if (path.charCodeAt(i) === CHAR_FORWARD_SLASH) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename (path, suffix) {
        if (suffix !== undefined) validateString(suffix, "ext");
        validateString(path, "path");
        let start = 0;
        let end = -1;
        let matchedSlash = true;
        let i;
        if (suffix !== undefined && suffix.length > 0 && suffix.length <= path.length) {
            if (suffix === path) return "";
            let extIdx = suffix.length - 1;
            let firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                const code = path.charCodeAt(i);
                if (code === CHAR_FORWARD_SLASH) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === suffix.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        }
        for(i = path.length - 1; i >= 0; --i){
            if (path.charCodeAt(i) === CHAR_FORWARD_SLASH) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            {
                if (!matchedSlash) {
                    start = i + 1;
                    break;
                }
            } else if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // path component
                matchedSlash = false;
                end = i + 1;
            }
        }
        if (end === -1) return "";
        return path.slice(start, end);
    },
    extname (path) {
        validateString(path, "path");
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        let preDotState = 0;
        for(let i = path.length - 1; i >= 0; --i){
            const code = path.charCodeAt(i);
            if (code === CHAR_FORWARD_SLASH) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === CHAR_DOT) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: _format.bind(null, "/"),
    parse (path) {
        validateString(path, "path");
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        const isAbsolute = path.charCodeAt(0) === CHAR_FORWARD_SLASH;
        let start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        let preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            const code = path.charCodeAt(i);
            if (code === CHAR_FORWARD_SLASH) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === CHAR_DOT) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (end !== -1) {
            const start = startPart === 0 && isAbsolute ? 1 : startPart;
            if (startDot === -1 || // We saw a non-dot character immediately before the dot
            preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
            preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) ret.base = ret.name = path.slice(start, end);
            else {
                ret.name = path.slice(start, startDot);
                ret.base = path.slice(start, end);
                ret.ext = path.slice(startDot, end);
            }
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
posix.win32 = win32.win32 = win32;
posix.posix = win32.posix = posix;
const normalize = platformIsWin32 ? win32.normalize : posix.normalize;
const join = platformIsWin32 ? win32.join : posix.join;
const resolve = platformIsWin32 ? win32.resolve : posix.resolve;
const relative = platformIsWin32 ? win32.relative : posix.relative;
const dirname = platformIsWin32 ? win32.dirname : posix.dirname;
const basename = platformIsWin32 ? win32.basename : posix.basename;
const extname = platformIsWin32 ? win32.extname : posix.extname;
const sep = platformIsWin32 ? win32.sep : posix.sep;

},{"./process.js":"fWvKM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fWvKM":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cwd", ()=>cwd);
parcelHelpers.export(exports, "env", ()=>env);
parcelHelpers.export(exports, "platform", ()=>platform);
var _platformJs = require("./platform.js");
var process = require("74401bc707f3d6b8");
let safeProcess;
// Native sandbox environment
const vscodeGlobal = globalThis.vscode;
if (typeof vscodeGlobal !== "undefined" && typeof vscodeGlobal.process !== "undefined") {
    const sandboxProcess = vscodeGlobal.process;
    safeProcess = {
        get platform () {
            return sandboxProcess.platform;
        },
        get arch () {
            return sandboxProcess.arch;
        },
        get env () {
            return sandboxProcess.env;
        },
        cwd () {
            return sandboxProcess.cwd();
        }
    };
} else if (typeof process !== "undefined" && typeof process?.versions?.node === "string") safeProcess = {
    get platform () {
        return process.platform;
    },
    get arch () {
        return process.arch;
    },
    get env () {
        return process.env;
    },
    cwd () {
        return process.cwd();
    }
};
else safeProcess = {
    // Supported
    get platform () {
        return (0, _platformJs.isWindows) ? "win32" : (0, _platformJs.isMacintosh) ? "darwin" : "linux";
    },
    get arch () {
        return undefined; /* arch is undefined in web */ 
    },
    // Unsupported
    get env () {
        return {};
    },
    cwd () {
        return "/";
    }
};
const cwd = safeProcess.cwd;
const env = safeProcess.env;
const platform = safeProcess.platform;

},{"74401bc707f3d6b8":"13Pcp","./platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lvrPe":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 * A position in the editor.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Position", ()=>Position);
class Position {
    constructor(lineNumber, column){
        this.lineNumber = lineNumber;
        this.column = column;
    }
    /**
     * Create a new position from this position.
     *
     * @param newLineNumber new line number
     * @param newColumn new column
     */ with(newLineNumber = this.lineNumber, newColumn = this.column) {
        if (newLineNumber === this.lineNumber && newColumn === this.column) return this;
        else return new Position(newLineNumber, newColumn);
    }
    /**
     * Derive a new position from this position.
     *
     * @param deltaLineNumber line number delta
     * @param deltaColumn column delta
     */ delta(deltaLineNumber = 0, deltaColumn = 0) {
        return this.with(this.lineNumber + deltaLineNumber, this.column + deltaColumn);
    }
    /**
     * Test if this position equals other position
     */ equals(other) {
        return Position.equals(this, other);
    }
    /**
     * Test if position `a` equals position `b`
     */ static equals(a, b) {
        if (!a && !b) return true;
        return !!a && !!b && a.lineNumber === b.lineNumber && a.column === b.column;
    }
    /**
     * Test if this position is before other position.
     * If the two positions are equal, the result will be false.
     */ isBefore(other) {
        return Position.isBefore(this, other);
    }
    /**
     * Test if position `a` is before position `b`.
     * If the two positions are equal, the result will be false.
     */ static isBefore(a, b) {
        if (a.lineNumber < b.lineNumber) return true;
        if (b.lineNumber < a.lineNumber) return false;
        return a.column < b.column;
    }
    /**
     * Test if this position is before other position.
     * If the two positions are equal, the result will be true.
     */ isBeforeOrEqual(other) {
        return Position.isBeforeOrEqual(this, other);
    }
    /**
     * Test if position `a` is before position `b`.
     * If the two positions are equal, the result will be true.
     */ static isBeforeOrEqual(a, b) {
        if (a.lineNumber < b.lineNumber) return true;
        if (b.lineNumber < a.lineNumber) return false;
        return a.column <= b.column;
    }
    /**
     * A function that compares positions, useful for sorting
     */ static compare(a, b) {
        const aLineNumber = a.lineNumber | 0;
        const bLineNumber = b.lineNumber | 0;
        if (aLineNumber === bLineNumber) {
            const aColumn = a.column | 0;
            const bColumn = b.column | 0;
            return aColumn - bColumn;
        }
        return aLineNumber - bLineNumber;
    }
    /**
     * Clone this position.
     */ clone() {
        return new Position(this.lineNumber, this.column);
    }
    /**
     * Convert to a human-readable representation.
     */ toString() {
        return "(" + this.lineNumber + "," + this.column + ")";
    }
    // ---
    /**
     * Create a `Position` from an `IPosition`.
     */ static lift(pos) {
        return new Position(pos.lineNumber, pos.column);
    }
    /**
     * Test if `obj` is an `IPosition`.
     */ static isIPosition(obj) {
        return obj && typeof obj.lineNumber === "number" && typeof obj.column === "number";
    }
    toJSON() {
        return {
            lineNumber: this.lineNumber,
            column: this.column
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jmUPh":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A range in the editor. (startLineNumber,startColumn) is <= (endLineNumber,endColumn)
 */ parcelHelpers.export(exports, "Range", ()=>Range);
var _positionJs = require("./position.js");
class Range {
    constructor(startLineNumber, startColumn, endLineNumber, endColumn){
        if (startLineNumber > endLineNumber || startLineNumber === endLineNumber && startColumn > endColumn) {
            this.startLineNumber = endLineNumber;
            this.startColumn = endColumn;
            this.endLineNumber = startLineNumber;
            this.endColumn = startColumn;
        } else {
            this.startLineNumber = startLineNumber;
            this.startColumn = startColumn;
            this.endLineNumber = endLineNumber;
            this.endColumn = endColumn;
        }
    }
    /**
     * Test if this range is empty.
     */ isEmpty() {
        return Range.isEmpty(this);
    }
    /**
     * Test if `range` is empty.
     */ static isEmpty(range) {
        return range.startLineNumber === range.endLineNumber && range.startColumn === range.endColumn;
    }
    /**
     * Test if position is in this range. If the position is at the edges, will return true.
     */ containsPosition(position) {
        return Range.containsPosition(this, position);
    }
    /**
     * Test if `position` is in `range`. If the position is at the edges, will return true.
     */ static containsPosition(range, position) {
        if (position.lineNumber < range.startLineNumber || position.lineNumber > range.endLineNumber) return false;
        if (position.lineNumber === range.startLineNumber && position.column < range.startColumn) return false;
        if (position.lineNumber === range.endLineNumber && position.column > range.endColumn) return false;
        return true;
    }
    /**
     * Test if `position` is in `range`. If the position is at the edges, will return false.
     * @internal
     */ static strictContainsPosition(range, position) {
        if (position.lineNumber < range.startLineNumber || position.lineNumber > range.endLineNumber) return false;
        if (position.lineNumber === range.startLineNumber && position.column <= range.startColumn) return false;
        if (position.lineNumber === range.endLineNumber && position.column >= range.endColumn) return false;
        return true;
    }
    /**
     * Test if range is in this range. If the range is equal to this range, will return true.
     */ containsRange(range) {
        return Range.containsRange(this, range);
    }
    /**
     * Test if `otherRange` is in `range`. If the ranges are equal, will return true.
     */ static containsRange(range, otherRange) {
        if (otherRange.startLineNumber < range.startLineNumber || otherRange.endLineNumber < range.startLineNumber) return false;
        if (otherRange.startLineNumber > range.endLineNumber || otherRange.endLineNumber > range.endLineNumber) return false;
        if (otherRange.startLineNumber === range.startLineNumber && otherRange.startColumn < range.startColumn) return false;
        if (otherRange.endLineNumber === range.endLineNumber && otherRange.endColumn > range.endColumn) return false;
        return true;
    }
    /**
     * Test if `range` is strictly in this range. `range` must start after and end before this range for the result to be true.
     */ strictContainsRange(range) {
        return Range.strictContainsRange(this, range);
    }
    /**
     * Test if `otherRange` is strictly in `range` (must start after, and end before). If the ranges are equal, will return false.
     */ static strictContainsRange(range, otherRange) {
        if (otherRange.startLineNumber < range.startLineNumber || otherRange.endLineNumber < range.startLineNumber) return false;
        if (otherRange.startLineNumber > range.endLineNumber || otherRange.endLineNumber > range.endLineNumber) return false;
        if (otherRange.startLineNumber === range.startLineNumber && otherRange.startColumn <= range.startColumn) return false;
        if (otherRange.endLineNumber === range.endLineNumber && otherRange.endColumn >= range.endColumn) return false;
        return true;
    }
    /**
     * A reunion of the two ranges.
     * The smallest position will be used as the start point, and the largest one as the end point.
     */ plusRange(range) {
        return Range.plusRange(this, range);
    }
    /**
     * A reunion of the two ranges.
     * The smallest position will be used as the start point, and the largest one as the end point.
     */ static plusRange(a, b) {
        let startLineNumber;
        let startColumn;
        let endLineNumber;
        let endColumn;
        if (b.startLineNumber < a.startLineNumber) {
            startLineNumber = b.startLineNumber;
            startColumn = b.startColumn;
        } else if (b.startLineNumber === a.startLineNumber) {
            startLineNumber = b.startLineNumber;
            startColumn = Math.min(b.startColumn, a.startColumn);
        } else {
            startLineNumber = a.startLineNumber;
            startColumn = a.startColumn;
        }
        if (b.endLineNumber > a.endLineNumber) {
            endLineNumber = b.endLineNumber;
            endColumn = b.endColumn;
        } else if (b.endLineNumber === a.endLineNumber) {
            endLineNumber = b.endLineNumber;
            endColumn = Math.max(b.endColumn, a.endColumn);
        } else {
            endLineNumber = a.endLineNumber;
            endColumn = a.endColumn;
        }
        return new Range(startLineNumber, startColumn, endLineNumber, endColumn);
    }
    /**
     * A intersection of the two ranges.
     */ intersectRanges(range) {
        return Range.intersectRanges(this, range);
    }
    /**
     * A intersection of the two ranges.
     */ static intersectRanges(a, b) {
        let resultStartLineNumber = a.startLineNumber;
        let resultStartColumn = a.startColumn;
        let resultEndLineNumber = a.endLineNumber;
        let resultEndColumn = a.endColumn;
        const otherStartLineNumber = b.startLineNumber;
        const otherStartColumn = b.startColumn;
        const otherEndLineNumber = b.endLineNumber;
        const otherEndColumn = b.endColumn;
        if (resultStartLineNumber < otherStartLineNumber) {
            resultStartLineNumber = otherStartLineNumber;
            resultStartColumn = otherStartColumn;
        } else if (resultStartLineNumber === otherStartLineNumber) resultStartColumn = Math.max(resultStartColumn, otherStartColumn);
        if (resultEndLineNumber > otherEndLineNumber) {
            resultEndLineNumber = otherEndLineNumber;
            resultEndColumn = otherEndColumn;
        } else if (resultEndLineNumber === otherEndLineNumber) resultEndColumn = Math.min(resultEndColumn, otherEndColumn);
        // Check if selection is now empty
        if (resultStartLineNumber > resultEndLineNumber) return null;
        if (resultStartLineNumber === resultEndLineNumber && resultStartColumn > resultEndColumn) return null;
        return new Range(resultStartLineNumber, resultStartColumn, resultEndLineNumber, resultEndColumn);
    }
    /**
     * Test if this range equals other.
     */ equalsRange(other) {
        return Range.equalsRange(this, other);
    }
    /**
     * Test if range `a` equals `b`.
     */ static equalsRange(a, b) {
        if (!a && !b) return true;
        return !!a && !!b && a.startLineNumber === b.startLineNumber && a.startColumn === b.startColumn && a.endLineNumber === b.endLineNumber && a.endColumn === b.endColumn;
    }
    /**
     * Return the end position (which will be after or equal to the start position)
     */ getEndPosition() {
        return Range.getEndPosition(this);
    }
    /**
     * Return the end position (which will be after or equal to the start position)
     */ static getEndPosition(range) {
        return new (0, _positionJs.Position)(range.endLineNumber, range.endColumn);
    }
    /**
     * Return the start position (which will be before or equal to the end position)
     */ getStartPosition() {
        return Range.getStartPosition(this);
    }
    /**
     * Return the start position (which will be before or equal to the end position)
     */ static getStartPosition(range) {
        return new (0, _positionJs.Position)(range.startLineNumber, range.startColumn);
    }
    /**
     * Transform to a user presentable string representation.
     */ toString() {
        return "[" + this.startLineNumber + "," + this.startColumn + " -> " + this.endLineNumber + "," + this.endColumn + "]";
    }
    /**
     * Create a new range using this range's start position, and using endLineNumber and endColumn as the end position.
     */ setEndPosition(endLineNumber, endColumn) {
        return new Range(this.startLineNumber, this.startColumn, endLineNumber, endColumn);
    }
    /**
     * Create a new range using this range's end position, and using startLineNumber and startColumn as the start position.
     */ setStartPosition(startLineNumber, startColumn) {
        return new Range(startLineNumber, startColumn, this.endLineNumber, this.endColumn);
    }
    /**
     * Create a new empty range using this range's start position.
     */ collapseToStart() {
        return Range.collapseToStart(this);
    }
    /**
     * Create a new empty range using this range's start position.
     */ static collapseToStart(range) {
        return new Range(range.startLineNumber, range.startColumn, range.startLineNumber, range.startColumn);
    }
    /**
     * Create a new empty range using this range's end position.
     */ collapseToEnd() {
        return Range.collapseToEnd(this);
    }
    /**
     * Create a new empty range using this range's end position.
     */ static collapseToEnd(range) {
        return new Range(range.endLineNumber, range.endColumn, range.endLineNumber, range.endColumn);
    }
    /**
     * Moves the range by the given amount of lines.
     */ delta(lineCount) {
        return new Range(this.startLineNumber + lineCount, this.startColumn, this.endLineNumber + lineCount, this.endColumn);
    }
    // ---
    static fromPositions(start, end = start) {
        return new Range(start.lineNumber, start.column, end.lineNumber, end.column);
    }
    static lift(range) {
        if (!range) return null;
        return new Range(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
    }
    /**
     * Test if `obj` is an `IRange`.
     */ static isIRange(obj) {
        return obj && typeof obj.startLineNumber === "number" && typeof obj.startColumn === "number" && typeof obj.endLineNumber === "number" && typeof obj.endColumn === "number";
    }
    /**
     * Test if the two ranges are touching in any way.
     */ static areIntersectingOrTouching(a, b) {
        // Check if `a` is before `b`
        if (a.endLineNumber < b.startLineNumber || a.endLineNumber === b.startLineNumber && a.endColumn < b.startColumn) return false;
        // Check if `b` is before `a`
        if (b.endLineNumber < a.startLineNumber || b.endLineNumber === a.startLineNumber && b.endColumn < a.startColumn) return false;
        // These ranges must intersect
        return true;
    }
    /**
     * Test if the two ranges are intersecting. If the ranges are touching it returns true.
     */ static areIntersecting(a, b) {
        // Check if `a` is before `b`
        if (a.endLineNumber < b.startLineNumber || a.endLineNumber === b.startLineNumber && a.endColumn <= b.startColumn) return false;
        // Check if `b` is before `a`
        if (b.endLineNumber < a.startLineNumber || b.endLineNumber === a.startLineNumber && b.endColumn <= a.startColumn) return false;
        // These ranges must intersect
        return true;
    }
    /**
     * A function that compares ranges, useful for sorting ranges
     * It will first compare ranges on the startPosition and then on the endPosition
     */ static compareRangesUsingStarts(a, b) {
        if (a && b) {
            const aStartLineNumber = a.startLineNumber | 0;
            const bStartLineNumber = b.startLineNumber | 0;
            if (aStartLineNumber === bStartLineNumber) {
                const aStartColumn = a.startColumn | 0;
                const bStartColumn = b.startColumn | 0;
                if (aStartColumn === bStartColumn) {
                    const aEndLineNumber = a.endLineNumber | 0;
                    const bEndLineNumber = b.endLineNumber | 0;
                    if (aEndLineNumber === bEndLineNumber) {
                        const aEndColumn = a.endColumn | 0;
                        const bEndColumn = b.endColumn | 0;
                        return aEndColumn - bEndColumn;
                    }
                    return aEndLineNumber - bEndLineNumber;
                }
                return aStartColumn - bStartColumn;
            }
            return aStartLineNumber - bStartLineNumber;
        }
        const aExists = a ? 1 : 0;
        const bExists = b ? 1 : 0;
        return aExists - bExists;
    }
    /**
     * A function that compares ranges, useful for sorting ranges
     * It will first compare ranges on the endPosition and then on the startPosition
     */ static compareRangesUsingEnds(a, b) {
        if (a.endLineNumber === b.endLineNumber) {
            if (a.endColumn === b.endColumn) {
                if (a.startLineNumber === b.startLineNumber) return a.startColumn - b.startColumn;
                return a.startLineNumber - b.startLineNumber;
            }
            return a.endColumn - b.endColumn;
        }
        return a.endLineNumber - b.endLineNumber;
    }
    /**
     * Test if the range spans multiple lines.
     */ static spansMultipleLines(range) {
        return range.endLineNumber > range.startLineNumber;
    }
    toJSON() {
        return this;
    }
}

},{"./position.js":"lvrPe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kcwzU":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A selection in the editor.
 * The selection is a range that has an orientation.
 */ parcelHelpers.export(exports, "Selection", ()=>Selection);
var _positionJs = require("./position.js");
var _rangeJs = require("./range.js");
class Selection extends (0, _rangeJs.Range) {
    constructor(selectionStartLineNumber, selectionStartColumn, positionLineNumber, positionColumn){
        super(selectionStartLineNumber, selectionStartColumn, positionLineNumber, positionColumn);
        this.selectionStartLineNumber = selectionStartLineNumber;
        this.selectionStartColumn = selectionStartColumn;
        this.positionLineNumber = positionLineNumber;
        this.positionColumn = positionColumn;
    }
    /**
     * Transform to a human-readable representation.
     */ toString() {
        return "[" + this.selectionStartLineNumber + "," + this.selectionStartColumn + " -> " + this.positionLineNumber + "," + this.positionColumn + "]";
    }
    /**
     * Test if equals other selection.
     */ equalsSelection(other) {
        return Selection.selectionsEqual(this, other);
    }
    /**
     * Test if the two selections are equal.
     */ static selectionsEqual(a, b) {
        return a.selectionStartLineNumber === b.selectionStartLineNumber && a.selectionStartColumn === b.selectionStartColumn && a.positionLineNumber === b.positionLineNumber && a.positionColumn === b.positionColumn;
    }
    /**
     * Get directions (LTR or RTL).
     */ getDirection() {
        if (this.selectionStartLineNumber === this.startLineNumber && this.selectionStartColumn === this.startColumn) return 0 /* SelectionDirection.LTR */ ;
        return 1 /* SelectionDirection.RTL */ ;
    }
    /**
     * Create a new selection with a different `positionLineNumber` and `positionColumn`.
     */ setEndPosition(endLineNumber, endColumn) {
        if (this.getDirection() === 0 /* SelectionDirection.LTR */ ) return new Selection(this.startLineNumber, this.startColumn, endLineNumber, endColumn);
        return new Selection(endLineNumber, endColumn, this.startLineNumber, this.startColumn);
    }
    /**
     * Get the position at `positionLineNumber` and `positionColumn`.
     */ getPosition() {
        return new (0, _positionJs.Position)(this.positionLineNumber, this.positionColumn);
    }
    /**
     * Get the position at the start of the selection.
    */ getSelectionStart() {
        return new (0, _positionJs.Position)(this.selectionStartLineNumber, this.selectionStartColumn);
    }
    /**
     * Create a new selection with a different `selectionStartLineNumber` and `selectionStartColumn`.
     */ setStartPosition(startLineNumber, startColumn) {
        if (this.getDirection() === 0 /* SelectionDirection.LTR */ ) return new Selection(startLineNumber, startColumn, this.endLineNumber, this.endColumn);
        return new Selection(this.endLineNumber, this.endColumn, startLineNumber, startColumn);
    }
    // ----
    /**
     * Create a `Selection` from one or two positions
     */ static fromPositions(start, end = start) {
        return new Selection(start.lineNumber, start.column, end.lineNumber, end.column);
    }
    /**
     * Creates a `Selection` from a range, given a direction.
     */ static fromRange(range, direction) {
        if (direction === 0 /* SelectionDirection.LTR */ ) return new Selection(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
        else return new Selection(range.endLineNumber, range.endColumn, range.startLineNumber, range.startColumn);
    }
    /**
     * Create a `Selection` from an `ISelection`.
     */ static liftSelection(sel) {
        return new Selection(sel.selectionStartLineNumber, sel.selectionStartColumn, sel.positionLineNumber, sel.positionColumn);
    }
    /**
     * `a` equals `b`.
     */ static selectionsArrEqual(a, b) {
        if (a && !b || !a && b) return false;
        if (!a && !b) return true;
        if (a.length !== b.length) return false;
        for(let i = 0, len = a.length; i < len; i++){
            if (!this.selectionsEqual(a[i], b[i])) return false;
        }
        return true;
    }
    /**
     * Test if `obj` is an `ISelection`.
     */ static isISelection(obj) {
        return obj && typeof obj.selectionStartLineNumber === "number" && typeof obj.selectionStartColumn === "number" && typeof obj.positionLineNumber === "number" && typeof obj.positionColumn === "number";
    }
    /**
     * Create with a direction.
     */ static createWithDirection(startLineNumber, startColumn, endLineNumber, endColumn, direction) {
        if (direction === 0 /* SelectionDirection.LTR */ ) return new Selection(startLineNumber, startColumn, endLineNumber, endColumn);
        return new Selection(endLineNumber, endColumn, startLineNumber, startColumn);
    }
}

},{"./position.js":"lvrPe","./range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g5n96":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Token", ()=>Token);
/**
 * @internal
 */ parcelHelpers.export(exports, "TokenizationResult", ()=>TokenizationResult);
/**
 * @internal
 */ parcelHelpers.export(exports, "EncodedTokenizationResult", ()=>EncodedTokenizationResult);
parcelHelpers.export(exports, "HoverVerbosityAction", ()=>HoverVerbosityAction);
parcelHelpers.export(exports, "CompletionItemKinds", ()=>CompletionItemKinds);
parcelHelpers.export(exports, "InlineCompletionTriggerKind", ()=>InlineCompletionTriggerKind);
parcelHelpers.export(exports, "SelectedSuggestionInfo", ()=>SelectedSuggestionInfo);
parcelHelpers.export(exports, "DocumentPasteTriggerKind", ()=>DocumentPasteTriggerKind);
parcelHelpers.export(exports, "SignatureHelpTriggerKind", ()=>SignatureHelpTriggerKind);
parcelHelpers.export(exports, "DocumentHighlightKind", ()=>DocumentHighlightKind);
/**
 * @internal
 */ parcelHelpers.export(exports, "isLocationLink", ()=>isLocationLink);
parcelHelpers.export(exports, "symbolKindNames", ()=>symbolKindNames);
/**
 * @internal
 */ parcelHelpers.export(exports, "getAriaLabelForSymbol", ()=>getAriaLabelForSymbol);
parcelHelpers.export(exports, "SymbolKinds", ()=>SymbolKinds);
/** @internal */ parcelHelpers.export(exports, "TextEdit", ()=>TextEdit);
parcelHelpers.export(exports, "FoldingRangeKind", ()=>FoldingRangeKind);
parcelHelpers.export(exports, "NewSymbolNameTag", ()=>NewSymbolNameTag);
parcelHelpers.export(exports, "NewSymbolNameTriggerKind", ()=>NewSymbolNameTriggerKind);
parcelHelpers.export(exports, "Command", ()=>Command);
parcelHelpers.export(exports, "InlayHintKind", ()=>InlayHintKind);
/**
 * @internal
 */ parcelHelpers.export(exports, "LazyTokenizationSupport", ()=>LazyTokenizationSupport);
parcelHelpers.export(exports, "TokenizationRegistry", ()=>TokenizationRegistry);
parcelHelpers.export(exports, "TreeSitterTokenizationRegistry", ()=>TreeSitterTokenizationRegistry);
parcelHelpers.export(exports, "InlineEditTriggerKind", ()=>InlineEditTriggerKind);
var _codiconsJs = require("../../base/common/codicons.js");
var _uriJs = require("../../base/common/uri.js");
var _rangeJs = require("./core/range.js");
var _tokenizationRegistryJs = require("./tokenizationRegistry.js");
var _nlsJs = require("../../nls.js");
class Token {
    constructor(offset, type, language){
        this.offset = offset;
        this.type = type;
        this.language = language;
        this._tokenBrand = undefined;
    }
    toString() {
        return "(" + this.offset + ", " + this.type + ")";
    }
}
class TokenizationResult {
    constructor(tokens, endState){
        this.tokens = tokens;
        this.endState = endState;
        this._tokenizationResultBrand = undefined;
    }
}
class EncodedTokenizationResult {
    constructor(/**
     * The tokens in binary format. Each token occupies two array indices. For token i:
     *  - at offset 2*i => startIndex
     *  - at offset 2*i + 1 => metadata
     *
     */ tokens, endState){
        this.tokens = tokens;
        this.endState = endState;
        this._encodedTokenizationResultBrand = undefined;
    }
}
var HoverVerbosityAction;
(function(HoverVerbosityAction) {
    /**
     * Increase the verbosity of the hover
     */ HoverVerbosityAction[HoverVerbosityAction["Increase"] = 0] = "Increase";
    /**
     * Decrease the verbosity of the hover
     */ HoverVerbosityAction[HoverVerbosityAction["Decrease"] = 1] = "Decrease";
})(HoverVerbosityAction || (HoverVerbosityAction = {}));
var CompletionItemKinds;
(function(CompletionItemKinds) {
    const byKind = new Map();
    byKind.set(0 /* CompletionItemKind.Method */ , (0, _codiconsJs.Codicon).symbolMethod);
    byKind.set(1 /* CompletionItemKind.Function */ , (0, _codiconsJs.Codicon).symbolFunction);
    byKind.set(2 /* CompletionItemKind.Constructor */ , (0, _codiconsJs.Codicon).symbolConstructor);
    byKind.set(3 /* CompletionItemKind.Field */ , (0, _codiconsJs.Codicon).symbolField);
    byKind.set(4 /* CompletionItemKind.Variable */ , (0, _codiconsJs.Codicon).symbolVariable);
    byKind.set(5 /* CompletionItemKind.Class */ , (0, _codiconsJs.Codicon).symbolClass);
    byKind.set(6 /* CompletionItemKind.Struct */ , (0, _codiconsJs.Codicon).symbolStruct);
    byKind.set(7 /* CompletionItemKind.Interface */ , (0, _codiconsJs.Codicon).symbolInterface);
    byKind.set(8 /* CompletionItemKind.Module */ , (0, _codiconsJs.Codicon).symbolModule);
    byKind.set(9 /* CompletionItemKind.Property */ , (0, _codiconsJs.Codicon).symbolProperty);
    byKind.set(10 /* CompletionItemKind.Event */ , (0, _codiconsJs.Codicon).symbolEvent);
    byKind.set(11 /* CompletionItemKind.Operator */ , (0, _codiconsJs.Codicon).symbolOperator);
    byKind.set(12 /* CompletionItemKind.Unit */ , (0, _codiconsJs.Codicon).symbolUnit);
    byKind.set(13 /* CompletionItemKind.Value */ , (0, _codiconsJs.Codicon).symbolValue);
    byKind.set(15 /* CompletionItemKind.Enum */ , (0, _codiconsJs.Codicon).symbolEnum);
    byKind.set(14 /* CompletionItemKind.Constant */ , (0, _codiconsJs.Codicon).symbolConstant);
    byKind.set(15 /* CompletionItemKind.Enum */ , (0, _codiconsJs.Codicon).symbolEnum);
    byKind.set(16 /* CompletionItemKind.EnumMember */ , (0, _codiconsJs.Codicon).symbolEnumMember);
    byKind.set(17 /* CompletionItemKind.Keyword */ , (0, _codiconsJs.Codicon).symbolKeyword);
    byKind.set(27 /* CompletionItemKind.Snippet */ , (0, _codiconsJs.Codicon).symbolSnippet);
    byKind.set(18 /* CompletionItemKind.Text */ , (0, _codiconsJs.Codicon).symbolText);
    byKind.set(19 /* CompletionItemKind.Color */ , (0, _codiconsJs.Codicon).symbolColor);
    byKind.set(20 /* CompletionItemKind.File */ , (0, _codiconsJs.Codicon).symbolFile);
    byKind.set(21 /* CompletionItemKind.Reference */ , (0, _codiconsJs.Codicon).symbolReference);
    byKind.set(22 /* CompletionItemKind.Customcolor */ , (0, _codiconsJs.Codicon).symbolCustomColor);
    byKind.set(23 /* CompletionItemKind.Folder */ , (0, _codiconsJs.Codicon).symbolFolder);
    byKind.set(24 /* CompletionItemKind.TypeParameter */ , (0, _codiconsJs.Codicon).symbolTypeParameter);
    byKind.set(25 /* CompletionItemKind.User */ , (0, _codiconsJs.Codicon).account);
    byKind.set(26 /* CompletionItemKind.Issue */ , (0, _codiconsJs.Codicon).issues);
    /**
     * @internal
     */ function toIcon(kind) {
        let codicon = byKind.get(kind);
        if (!codicon) {
            console.info("No codicon found for CompletionItemKind " + kind);
            codicon = (0, _codiconsJs.Codicon).symbolProperty;
        }
        return codicon;
    }
    CompletionItemKinds.toIcon = toIcon;
    const data = new Map();
    data.set("method", 0 /* CompletionItemKind.Method */ );
    data.set("function", 1 /* CompletionItemKind.Function */ );
    data.set("constructor", 2 /* CompletionItemKind.Constructor */ );
    data.set("field", 3 /* CompletionItemKind.Field */ );
    data.set("variable", 4 /* CompletionItemKind.Variable */ );
    data.set("class", 5 /* CompletionItemKind.Class */ );
    data.set("struct", 6 /* CompletionItemKind.Struct */ );
    data.set("interface", 7 /* CompletionItemKind.Interface */ );
    data.set("module", 8 /* CompletionItemKind.Module */ );
    data.set("property", 9 /* CompletionItemKind.Property */ );
    data.set("event", 10 /* CompletionItemKind.Event */ );
    data.set("operator", 11 /* CompletionItemKind.Operator */ );
    data.set("unit", 12 /* CompletionItemKind.Unit */ );
    data.set("value", 13 /* CompletionItemKind.Value */ );
    data.set("constant", 14 /* CompletionItemKind.Constant */ );
    data.set("enum", 15 /* CompletionItemKind.Enum */ );
    data.set("enum-member", 16 /* CompletionItemKind.EnumMember */ );
    data.set("enumMember", 16 /* CompletionItemKind.EnumMember */ );
    data.set("keyword", 17 /* CompletionItemKind.Keyword */ );
    data.set("snippet", 27 /* CompletionItemKind.Snippet */ );
    data.set("text", 18 /* CompletionItemKind.Text */ );
    data.set("color", 19 /* CompletionItemKind.Color */ );
    data.set("file", 20 /* CompletionItemKind.File */ );
    data.set("reference", 21 /* CompletionItemKind.Reference */ );
    data.set("customcolor", 22 /* CompletionItemKind.Customcolor */ );
    data.set("folder", 23 /* CompletionItemKind.Folder */ );
    data.set("type-parameter", 24 /* CompletionItemKind.TypeParameter */ );
    data.set("typeParameter", 24 /* CompletionItemKind.TypeParameter */ );
    data.set("account", 25 /* CompletionItemKind.User */ );
    data.set("issue", 26 /* CompletionItemKind.Issue */ );
    /**
     * @internal
     */ function fromString(value, strict) {
        let res = data.get(value);
        if (typeof res === "undefined" && !strict) res = 9 /* CompletionItemKind.Property */ ;
        return res;
    }
    CompletionItemKinds.fromString = fromString;
})(CompletionItemKinds || (CompletionItemKinds = {}));
var InlineCompletionTriggerKind;
(function(InlineCompletionTriggerKind) {
    /**
     * Completion was triggered automatically while editing.
     * It is sufficient to return a single completion item in this case.
     */ InlineCompletionTriggerKind[InlineCompletionTriggerKind["Automatic"] = 0] = "Automatic";
    /**
     * Completion was triggered explicitly by a user gesture.
     * Return multiple completion items to enable cycling through them.
     */ InlineCompletionTriggerKind[InlineCompletionTriggerKind["Explicit"] = 1] = "Explicit";
})(InlineCompletionTriggerKind || (InlineCompletionTriggerKind = {}));
class SelectedSuggestionInfo {
    constructor(range, text, completionKind, isSnippetText){
        this.range = range;
        this.text = text;
        this.completionKind = completionKind;
        this.isSnippetText = isSnippetText;
    }
    equals(other) {
        return (0, _rangeJs.Range).lift(this.range).equalsRange(other.range) && this.text === other.text && this.completionKind === other.completionKind && this.isSnippetText === other.isSnippetText;
    }
}
var DocumentPasteTriggerKind;
(function(DocumentPasteTriggerKind) {
    DocumentPasteTriggerKind[DocumentPasteTriggerKind["Automatic"] = 0] = "Automatic";
    DocumentPasteTriggerKind[DocumentPasteTriggerKind["PasteAs"] = 1] = "PasteAs";
})(DocumentPasteTriggerKind || (DocumentPasteTriggerKind = {}));
var SignatureHelpTriggerKind;
(function(SignatureHelpTriggerKind) {
    SignatureHelpTriggerKind[SignatureHelpTriggerKind["Invoke"] = 1] = "Invoke";
    SignatureHelpTriggerKind[SignatureHelpTriggerKind["TriggerCharacter"] = 2] = "TriggerCharacter";
    SignatureHelpTriggerKind[SignatureHelpTriggerKind["ContentChange"] = 3] = "ContentChange";
})(SignatureHelpTriggerKind || (SignatureHelpTriggerKind = {}));
var DocumentHighlightKind;
(function(DocumentHighlightKind) {
    /**
     * A textual occurrence.
     */ DocumentHighlightKind[DocumentHighlightKind["Text"] = 0] = "Text";
    /**
     * Read-access of a symbol, like reading a variable.
     */ DocumentHighlightKind[DocumentHighlightKind["Read"] = 1] = "Read";
    /**
     * Write-access of a symbol, like writing to a variable.
     */ DocumentHighlightKind[DocumentHighlightKind["Write"] = 2] = "Write";
})(DocumentHighlightKind || (DocumentHighlightKind = {}));
function isLocationLink(thing) {
    return thing && (0, _uriJs.URI).isUri(thing.uri) && (0, _rangeJs.Range).isIRange(thing.range) && ((0, _rangeJs.Range).isIRange(thing.originSelectionRange) || (0, _rangeJs.Range).isIRange(thing.targetSelectionRange));
}
const symbolKindNames = {
    [17 /* SymbolKind.Array */ ]: (0, _nlsJs.localize)("Array", "array"),
    [16 /* SymbolKind.Boolean */ ]: (0, _nlsJs.localize)("Boolean", "boolean"),
    [4 /* SymbolKind.Class */ ]: (0, _nlsJs.localize)("Class", "class"),
    [13 /* SymbolKind.Constant */ ]: (0, _nlsJs.localize)("Constant", "constant"),
    [8 /* SymbolKind.Constructor */ ]: (0, _nlsJs.localize)("Constructor", "constructor"),
    [9 /* SymbolKind.Enum */ ]: (0, _nlsJs.localize)("Enum", "enumeration"),
    [21 /* SymbolKind.EnumMember */ ]: (0, _nlsJs.localize)("EnumMember", "enumeration member"),
    [23 /* SymbolKind.Event */ ]: (0, _nlsJs.localize)("Event", "event"),
    [7 /* SymbolKind.Field */ ]: (0, _nlsJs.localize)("Field", "field"),
    [0 /* SymbolKind.File */ ]: (0, _nlsJs.localize)("File", "file"),
    [11 /* SymbolKind.Function */ ]: (0, _nlsJs.localize)("Function", "function"),
    [10 /* SymbolKind.Interface */ ]: (0, _nlsJs.localize)("Interface", "interface"),
    [19 /* SymbolKind.Key */ ]: (0, _nlsJs.localize)("Key", "key"),
    [5 /* SymbolKind.Method */ ]: (0, _nlsJs.localize)("Method", "method"),
    [1 /* SymbolKind.Module */ ]: (0, _nlsJs.localize)("Module", "module"),
    [2 /* SymbolKind.Namespace */ ]: (0, _nlsJs.localize)("Namespace", "namespace"),
    [20 /* SymbolKind.Null */ ]: (0, _nlsJs.localize)("Null", "null"),
    [15 /* SymbolKind.Number */ ]: (0, _nlsJs.localize)("Number", "number"),
    [18 /* SymbolKind.Object */ ]: (0, _nlsJs.localize)("Object", "object"),
    [24 /* SymbolKind.Operator */ ]: (0, _nlsJs.localize)("Operator", "operator"),
    [3 /* SymbolKind.Package */ ]: (0, _nlsJs.localize)("Package", "package"),
    [6 /* SymbolKind.Property */ ]: (0, _nlsJs.localize)("Property", "property"),
    [14 /* SymbolKind.String */ ]: (0, _nlsJs.localize)("String", "string"),
    [22 /* SymbolKind.Struct */ ]: (0, _nlsJs.localize)("Struct", "struct"),
    [25 /* SymbolKind.TypeParameter */ ]: (0, _nlsJs.localize)("TypeParameter", "type parameter"),
    [12 /* SymbolKind.Variable */ ]: (0, _nlsJs.localize)("Variable", "variable")
};
function getAriaLabelForSymbol(symbolName, kind) {
    return (0, _nlsJs.localize)("symbolAriaLabel", "{0} ({1})", symbolName, symbolKindNames[kind]);
}
var SymbolKinds;
(function(SymbolKinds) {
    const byKind = new Map();
    byKind.set(0 /* SymbolKind.File */ , (0, _codiconsJs.Codicon).symbolFile);
    byKind.set(1 /* SymbolKind.Module */ , (0, _codiconsJs.Codicon).symbolModule);
    byKind.set(2 /* SymbolKind.Namespace */ , (0, _codiconsJs.Codicon).symbolNamespace);
    byKind.set(3 /* SymbolKind.Package */ , (0, _codiconsJs.Codicon).symbolPackage);
    byKind.set(4 /* SymbolKind.Class */ , (0, _codiconsJs.Codicon).symbolClass);
    byKind.set(5 /* SymbolKind.Method */ , (0, _codiconsJs.Codicon).symbolMethod);
    byKind.set(6 /* SymbolKind.Property */ , (0, _codiconsJs.Codicon).symbolProperty);
    byKind.set(7 /* SymbolKind.Field */ , (0, _codiconsJs.Codicon).symbolField);
    byKind.set(8 /* SymbolKind.Constructor */ , (0, _codiconsJs.Codicon).symbolConstructor);
    byKind.set(9 /* SymbolKind.Enum */ , (0, _codiconsJs.Codicon).symbolEnum);
    byKind.set(10 /* SymbolKind.Interface */ , (0, _codiconsJs.Codicon).symbolInterface);
    byKind.set(11 /* SymbolKind.Function */ , (0, _codiconsJs.Codicon).symbolFunction);
    byKind.set(12 /* SymbolKind.Variable */ , (0, _codiconsJs.Codicon).symbolVariable);
    byKind.set(13 /* SymbolKind.Constant */ , (0, _codiconsJs.Codicon).symbolConstant);
    byKind.set(14 /* SymbolKind.String */ , (0, _codiconsJs.Codicon).symbolString);
    byKind.set(15 /* SymbolKind.Number */ , (0, _codiconsJs.Codicon).symbolNumber);
    byKind.set(16 /* SymbolKind.Boolean */ , (0, _codiconsJs.Codicon).symbolBoolean);
    byKind.set(17 /* SymbolKind.Array */ , (0, _codiconsJs.Codicon).symbolArray);
    byKind.set(18 /* SymbolKind.Object */ , (0, _codiconsJs.Codicon).symbolObject);
    byKind.set(19 /* SymbolKind.Key */ , (0, _codiconsJs.Codicon).symbolKey);
    byKind.set(20 /* SymbolKind.Null */ , (0, _codiconsJs.Codicon).symbolNull);
    byKind.set(21 /* SymbolKind.EnumMember */ , (0, _codiconsJs.Codicon).symbolEnumMember);
    byKind.set(22 /* SymbolKind.Struct */ , (0, _codiconsJs.Codicon).symbolStruct);
    byKind.set(23 /* SymbolKind.Event */ , (0, _codiconsJs.Codicon).symbolEvent);
    byKind.set(24 /* SymbolKind.Operator */ , (0, _codiconsJs.Codicon).symbolOperator);
    byKind.set(25 /* SymbolKind.TypeParameter */ , (0, _codiconsJs.Codicon).symbolTypeParameter);
    /**
     * @internal
     */ function toIcon(kind) {
        let icon = byKind.get(kind);
        if (!icon) {
            console.info("No codicon found for SymbolKind " + kind);
            icon = (0, _codiconsJs.Codicon).symbolProperty;
        }
        return icon;
    }
    SymbolKinds.toIcon = toIcon;
})(SymbolKinds || (SymbolKinds = {}));
class TextEdit {
}
class FoldingRangeKind {
    /**
     * Kind for folding range representing a comment. The value of the kind is 'comment'.
     */ static{
        this.Comment = new FoldingRangeKind("comment");
    }
    /**
     * Kind for folding range representing a import. The value of the kind is 'imports'.
     */ static{
        this.Imports = new FoldingRangeKind("imports");
    }
    /**
     * Kind for folding range representing regions (for example marked by `#region`, `#endregion`).
     * The value of the kind is 'region'.
     */ static{
        this.Region = new FoldingRangeKind("region");
    }
    /**
     * Returns a {@link FoldingRangeKind} for the given value.
     *
     * @param value of the kind.
     */ static fromValue(value) {
        switch(value){
            case "comment":
                return FoldingRangeKind.Comment;
            case "imports":
                return FoldingRangeKind.Imports;
            case "region":
                return FoldingRangeKind.Region;
        }
        return new FoldingRangeKind(value);
    }
    /**
     * Creates a new {@link FoldingRangeKind}.
     *
     * @param value of the kind.
     */ constructor(value){
        this.value = value;
    }
}
var NewSymbolNameTag;
(function(NewSymbolNameTag) {
    NewSymbolNameTag[NewSymbolNameTag["AIGenerated"] = 1] = "AIGenerated";
})(NewSymbolNameTag || (NewSymbolNameTag = {}));
var NewSymbolNameTriggerKind;
(function(NewSymbolNameTriggerKind) {
    NewSymbolNameTriggerKind[NewSymbolNameTriggerKind["Invoke"] = 0] = "Invoke";
    NewSymbolNameTriggerKind[NewSymbolNameTriggerKind["Automatic"] = 1] = "Automatic";
})(NewSymbolNameTriggerKind || (NewSymbolNameTriggerKind = {}));
var Command;
(function(Command) {
    /**
     * @internal
     */ function is(obj) {
        if (!obj || typeof obj !== "object") return false;
        return typeof obj.id === "string" && typeof obj.title === "string";
    }
    Command.is = is;
})(Command || (Command = {}));
var InlayHintKind;
(function(InlayHintKind) {
    InlayHintKind[InlayHintKind["Type"] = 1] = "Type";
    InlayHintKind[InlayHintKind["Parameter"] = 2] = "Parameter";
})(InlayHintKind || (InlayHintKind = {}));
class LazyTokenizationSupport {
    constructor(createSupport){
        this.createSupport = createSupport;
        this._tokenizationSupport = null;
    }
    dispose() {
        if (this._tokenizationSupport) this._tokenizationSupport.then((support)=>{
            if (support) support.dispose();
        });
    }
    get tokenizationSupport() {
        if (!this._tokenizationSupport) this._tokenizationSupport = this.createSupport();
        return this._tokenizationSupport;
    }
}
const TokenizationRegistry = new (0, _tokenizationRegistryJs.TokenizationRegistry)();
const TreeSitterTokenizationRegistry = new (0, _tokenizationRegistryJs.TokenizationRegistry)();
var InlineEditTriggerKind;
(function(InlineEditTriggerKind) {
    InlineEditTriggerKind[InlineEditTriggerKind["Invoke"] = 0] = "Invoke";
    InlineEditTriggerKind[InlineEditTriggerKind["Automatic"] = 1] = "Automatic";
})(InlineEditTriggerKind || (InlineEditTriggerKind = {}));

},{"../../base/common/codicons.js":"hWYNf","../../base/common/uri.js":"7qGS3","./core/range.js":"jmUPh","./tokenizationRegistry.js":"kqBdY","../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hWYNf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "codiconsDerived", ()=>codiconsDerived);
parcelHelpers.export(exports, "Codicon", ()=>Codicon);
var _codiconsUtilJs = require("./codiconsUtil.js");
var _codiconsLibraryJs = require("./codiconsLibrary.js");
const codiconsDerived = {
    dialogError: (0, _codiconsUtilJs.register)("dialog-error", "error"),
    dialogWarning: (0, _codiconsUtilJs.register)("dialog-warning", "warning"),
    dialogInfo: (0, _codiconsUtilJs.register)("dialog-info", "info"),
    dialogClose: (0, _codiconsUtilJs.register)("dialog-close", "close"),
    treeItemExpanded: (0, _codiconsUtilJs.register)("tree-item-expanded", "chevron-down"),
    treeFilterOnTypeOn: (0, _codiconsUtilJs.register)("tree-filter-on-type-on", "list-filter"),
    treeFilterOnTypeOff: (0, _codiconsUtilJs.register)("tree-filter-on-type-off", "list-selection"),
    treeFilterClear: (0, _codiconsUtilJs.register)("tree-filter-clear", "close"),
    treeItemLoading: (0, _codiconsUtilJs.register)("tree-item-loading", "loading"),
    menuSelection: (0, _codiconsUtilJs.register)("menu-selection", "check"),
    menuSubmenu: (0, _codiconsUtilJs.register)("menu-submenu", "chevron-right"),
    menuBarMore: (0, _codiconsUtilJs.register)("menubar-more", "more"),
    scrollbarButtonLeft: (0, _codiconsUtilJs.register)("scrollbar-button-left", "triangle-left"),
    scrollbarButtonRight: (0, _codiconsUtilJs.register)("scrollbar-button-right", "triangle-right"),
    scrollbarButtonUp: (0, _codiconsUtilJs.register)("scrollbar-button-up", "triangle-up"),
    scrollbarButtonDown: (0, _codiconsUtilJs.register)("scrollbar-button-down", "triangle-down"),
    toolBarMore: (0, _codiconsUtilJs.register)("toolbar-more", "more"),
    quickInputBack: (0, _codiconsUtilJs.register)("quick-input-back", "arrow-left"),
    dropDownButton: (0, _codiconsUtilJs.register)("drop-down-button", 0xeab4),
    symbolCustomColor: (0, _codiconsUtilJs.register)("symbol-customcolor", 0xeb5c),
    exportIcon: (0, _codiconsUtilJs.register)("export", 0xebac),
    workspaceUnspecified: (0, _codiconsUtilJs.register)("workspace-unspecified", 0xebc3),
    newLine: (0, _codiconsUtilJs.register)("newline", 0xebea),
    thumbsDownFilled: (0, _codiconsUtilJs.register)("thumbsdown-filled", 0xec13),
    thumbsUpFilled: (0, _codiconsUtilJs.register)("thumbsup-filled", 0xec14),
    gitFetch: (0, _codiconsUtilJs.register)("git-fetch", 0xec1d),
    lightbulbSparkleAutofix: (0, _codiconsUtilJs.register)("lightbulb-sparkle-autofix", 0xec1f),
    debugBreakpointPending: (0, _codiconsUtilJs.register)("debug-breakpoint-pending", 0xebd9)
};
const Codicon = {
    ...(0, _codiconsLibraryJs.codiconsLibrary),
    ...codiconsDerived
};

},{"./codiconsUtil.js":"6g8vy","./codiconsLibrary.js":"kQyK0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6g8vy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "register", ()=>register);
/**
 * Only to be used by the iconRegistry.
 */ parcelHelpers.export(exports, "getCodiconFontCharacters", ()=>getCodiconFontCharacters);
var _typesJs = require("./types.js");
const _codiconFontCharacters = Object.create(null);
function register(id, fontCharacter) {
    if ((0, _typesJs.isString)(fontCharacter)) {
        const val = _codiconFontCharacters[fontCharacter];
        if (val === undefined) throw new Error(`${id} references an unknown codicon: ${fontCharacter}`);
        fontCharacter = val;
    }
    _codiconFontCharacters[id] = fontCharacter;
    return {
        id
    };
}
function getCodiconFontCharacters() {
    return _codiconFontCharacters;
}

},{"./types.js":"fb5yx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQyK0":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "codiconsLibrary", ()=>codiconsLibrary);
var _codiconsUtilJs = require("./codiconsUtil.js");
const codiconsLibrary = {
    add: (0, _codiconsUtilJs.register)("add", 0xea60),
    plus: (0, _codiconsUtilJs.register)("plus", 0xea60),
    gistNew: (0, _codiconsUtilJs.register)("gist-new", 0xea60),
    repoCreate: (0, _codiconsUtilJs.register)("repo-create", 0xea60),
    lightbulb: (0, _codiconsUtilJs.register)("lightbulb", 0xea61),
    lightBulb: (0, _codiconsUtilJs.register)("light-bulb", 0xea61),
    repo: (0, _codiconsUtilJs.register)("repo", 0xea62),
    repoDelete: (0, _codiconsUtilJs.register)("repo-delete", 0xea62),
    gistFork: (0, _codiconsUtilJs.register)("gist-fork", 0xea63),
    repoForked: (0, _codiconsUtilJs.register)("repo-forked", 0xea63),
    gitPullRequest: (0, _codiconsUtilJs.register)("git-pull-request", 0xea64),
    gitPullRequestAbandoned: (0, _codiconsUtilJs.register)("git-pull-request-abandoned", 0xea64),
    recordKeys: (0, _codiconsUtilJs.register)("record-keys", 0xea65),
    keyboard: (0, _codiconsUtilJs.register)("keyboard", 0xea65),
    tag: (0, _codiconsUtilJs.register)("tag", 0xea66),
    gitPullRequestLabel: (0, _codiconsUtilJs.register)("git-pull-request-label", 0xea66),
    tagAdd: (0, _codiconsUtilJs.register)("tag-add", 0xea66),
    tagRemove: (0, _codiconsUtilJs.register)("tag-remove", 0xea66),
    person: (0, _codiconsUtilJs.register)("person", 0xea67),
    personFollow: (0, _codiconsUtilJs.register)("person-follow", 0xea67),
    personOutline: (0, _codiconsUtilJs.register)("person-outline", 0xea67),
    personFilled: (0, _codiconsUtilJs.register)("person-filled", 0xea67),
    gitBranch: (0, _codiconsUtilJs.register)("git-branch", 0xea68),
    gitBranchCreate: (0, _codiconsUtilJs.register)("git-branch-create", 0xea68),
    gitBranchDelete: (0, _codiconsUtilJs.register)("git-branch-delete", 0xea68),
    sourceControl: (0, _codiconsUtilJs.register)("source-control", 0xea68),
    mirror: (0, _codiconsUtilJs.register)("mirror", 0xea69),
    mirrorPublic: (0, _codiconsUtilJs.register)("mirror-public", 0xea69),
    star: (0, _codiconsUtilJs.register)("star", 0xea6a),
    starAdd: (0, _codiconsUtilJs.register)("star-add", 0xea6a),
    starDelete: (0, _codiconsUtilJs.register)("star-delete", 0xea6a),
    starEmpty: (0, _codiconsUtilJs.register)("star-empty", 0xea6a),
    comment: (0, _codiconsUtilJs.register)("comment", 0xea6b),
    commentAdd: (0, _codiconsUtilJs.register)("comment-add", 0xea6b),
    alert: (0, _codiconsUtilJs.register)("alert", 0xea6c),
    warning: (0, _codiconsUtilJs.register)("warning", 0xea6c),
    search: (0, _codiconsUtilJs.register)("search", 0xea6d),
    searchSave: (0, _codiconsUtilJs.register)("search-save", 0xea6d),
    logOut: (0, _codiconsUtilJs.register)("log-out", 0xea6e),
    signOut: (0, _codiconsUtilJs.register)("sign-out", 0xea6e),
    logIn: (0, _codiconsUtilJs.register)("log-in", 0xea6f),
    signIn: (0, _codiconsUtilJs.register)("sign-in", 0xea6f),
    eye: (0, _codiconsUtilJs.register)("eye", 0xea70),
    eyeUnwatch: (0, _codiconsUtilJs.register)("eye-unwatch", 0xea70),
    eyeWatch: (0, _codiconsUtilJs.register)("eye-watch", 0xea70),
    circleFilled: (0, _codiconsUtilJs.register)("circle-filled", 0xea71),
    primitiveDot: (0, _codiconsUtilJs.register)("primitive-dot", 0xea71),
    closeDirty: (0, _codiconsUtilJs.register)("close-dirty", 0xea71),
    debugBreakpoint: (0, _codiconsUtilJs.register)("debug-breakpoint", 0xea71),
    debugBreakpointDisabled: (0, _codiconsUtilJs.register)("debug-breakpoint-disabled", 0xea71),
    debugHint: (0, _codiconsUtilJs.register)("debug-hint", 0xea71),
    terminalDecorationSuccess: (0, _codiconsUtilJs.register)("terminal-decoration-success", 0xea71),
    primitiveSquare: (0, _codiconsUtilJs.register)("primitive-square", 0xea72),
    edit: (0, _codiconsUtilJs.register)("edit", 0xea73),
    pencil: (0, _codiconsUtilJs.register)("pencil", 0xea73),
    info: (0, _codiconsUtilJs.register)("info", 0xea74),
    issueOpened: (0, _codiconsUtilJs.register)("issue-opened", 0xea74),
    gistPrivate: (0, _codiconsUtilJs.register)("gist-private", 0xea75),
    gitForkPrivate: (0, _codiconsUtilJs.register)("git-fork-private", 0xea75),
    lock: (0, _codiconsUtilJs.register)("lock", 0xea75),
    mirrorPrivate: (0, _codiconsUtilJs.register)("mirror-private", 0xea75),
    close: (0, _codiconsUtilJs.register)("close", 0xea76),
    removeClose: (0, _codiconsUtilJs.register)("remove-close", 0xea76),
    x: (0, _codiconsUtilJs.register)("x", 0xea76),
    repoSync: (0, _codiconsUtilJs.register)("repo-sync", 0xea77),
    sync: (0, _codiconsUtilJs.register)("sync", 0xea77),
    clone: (0, _codiconsUtilJs.register)("clone", 0xea78),
    desktopDownload: (0, _codiconsUtilJs.register)("desktop-download", 0xea78),
    beaker: (0, _codiconsUtilJs.register)("beaker", 0xea79),
    microscope: (0, _codiconsUtilJs.register)("microscope", 0xea79),
    vm: (0, _codiconsUtilJs.register)("vm", 0xea7a),
    deviceDesktop: (0, _codiconsUtilJs.register)("device-desktop", 0xea7a),
    file: (0, _codiconsUtilJs.register)("file", 0xea7b),
    fileText: (0, _codiconsUtilJs.register)("file-text", 0xea7b),
    more: (0, _codiconsUtilJs.register)("more", 0xea7c),
    ellipsis: (0, _codiconsUtilJs.register)("ellipsis", 0xea7c),
    kebabHorizontal: (0, _codiconsUtilJs.register)("kebab-horizontal", 0xea7c),
    mailReply: (0, _codiconsUtilJs.register)("mail-reply", 0xea7d),
    reply: (0, _codiconsUtilJs.register)("reply", 0xea7d),
    organization: (0, _codiconsUtilJs.register)("organization", 0xea7e),
    organizationFilled: (0, _codiconsUtilJs.register)("organization-filled", 0xea7e),
    organizationOutline: (0, _codiconsUtilJs.register)("organization-outline", 0xea7e),
    newFile: (0, _codiconsUtilJs.register)("new-file", 0xea7f),
    fileAdd: (0, _codiconsUtilJs.register)("file-add", 0xea7f),
    newFolder: (0, _codiconsUtilJs.register)("new-folder", 0xea80),
    fileDirectoryCreate: (0, _codiconsUtilJs.register)("file-directory-create", 0xea80),
    trash: (0, _codiconsUtilJs.register)("trash", 0xea81),
    trashcan: (0, _codiconsUtilJs.register)("trashcan", 0xea81),
    history: (0, _codiconsUtilJs.register)("history", 0xea82),
    clock: (0, _codiconsUtilJs.register)("clock", 0xea82),
    folder: (0, _codiconsUtilJs.register)("folder", 0xea83),
    fileDirectory: (0, _codiconsUtilJs.register)("file-directory", 0xea83),
    symbolFolder: (0, _codiconsUtilJs.register)("symbol-folder", 0xea83),
    logoGithub: (0, _codiconsUtilJs.register)("logo-github", 0xea84),
    markGithub: (0, _codiconsUtilJs.register)("mark-github", 0xea84),
    github: (0, _codiconsUtilJs.register)("github", 0xea84),
    terminal: (0, _codiconsUtilJs.register)("terminal", 0xea85),
    console: (0, _codiconsUtilJs.register)("console", 0xea85),
    repl: (0, _codiconsUtilJs.register)("repl", 0xea85),
    zap: (0, _codiconsUtilJs.register)("zap", 0xea86),
    symbolEvent: (0, _codiconsUtilJs.register)("symbol-event", 0xea86),
    error: (0, _codiconsUtilJs.register)("error", 0xea87),
    stop: (0, _codiconsUtilJs.register)("stop", 0xea87),
    variable: (0, _codiconsUtilJs.register)("variable", 0xea88),
    symbolVariable: (0, _codiconsUtilJs.register)("symbol-variable", 0xea88),
    array: (0, _codiconsUtilJs.register)("array", 0xea8a),
    symbolArray: (0, _codiconsUtilJs.register)("symbol-array", 0xea8a),
    symbolModule: (0, _codiconsUtilJs.register)("symbol-module", 0xea8b),
    symbolPackage: (0, _codiconsUtilJs.register)("symbol-package", 0xea8b),
    symbolNamespace: (0, _codiconsUtilJs.register)("symbol-namespace", 0xea8b),
    symbolObject: (0, _codiconsUtilJs.register)("symbol-object", 0xea8b),
    symbolMethod: (0, _codiconsUtilJs.register)("symbol-method", 0xea8c),
    symbolFunction: (0, _codiconsUtilJs.register)("symbol-function", 0xea8c),
    symbolConstructor: (0, _codiconsUtilJs.register)("symbol-constructor", 0xea8c),
    symbolBoolean: (0, _codiconsUtilJs.register)("symbol-boolean", 0xea8f),
    symbolNull: (0, _codiconsUtilJs.register)("symbol-null", 0xea8f),
    symbolNumeric: (0, _codiconsUtilJs.register)("symbol-numeric", 0xea90),
    symbolNumber: (0, _codiconsUtilJs.register)("symbol-number", 0xea90),
    symbolStructure: (0, _codiconsUtilJs.register)("symbol-structure", 0xea91),
    symbolStruct: (0, _codiconsUtilJs.register)("symbol-struct", 0xea91),
    symbolParameter: (0, _codiconsUtilJs.register)("symbol-parameter", 0xea92),
    symbolTypeParameter: (0, _codiconsUtilJs.register)("symbol-type-parameter", 0xea92),
    symbolKey: (0, _codiconsUtilJs.register)("symbol-key", 0xea93),
    symbolText: (0, _codiconsUtilJs.register)("symbol-text", 0xea93),
    symbolReference: (0, _codiconsUtilJs.register)("symbol-reference", 0xea94),
    goToFile: (0, _codiconsUtilJs.register)("go-to-file", 0xea94),
    symbolEnum: (0, _codiconsUtilJs.register)("symbol-enum", 0xea95),
    symbolValue: (0, _codiconsUtilJs.register)("symbol-value", 0xea95),
    symbolRuler: (0, _codiconsUtilJs.register)("symbol-ruler", 0xea96),
    symbolUnit: (0, _codiconsUtilJs.register)("symbol-unit", 0xea96),
    activateBreakpoints: (0, _codiconsUtilJs.register)("activate-breakpoints", 0xea97),
    archive: (0, _codiconsUtilJs.register)("archive", 0xea98),
    arrowBoth: (0, _codiconsUtilJs.register)("arrow-both", 0xea99),
    arrowDown: (0, _codiconsUtilJs.register)("arrow-down", 0xea9a),
    arrowLeft: (0, _codiconsUtilJs.register)("arrow-left", 0xea9b),
    arrowRight: (0, _codiconsUtilJs.register)("arrow-right", 0xea9c),
    arrowSmallDown: (0, _codiconsUtilJs.register)("arrow-small-down", 0xea9d),
    arrowSmallLeft: (0, _codiconsUtilJs.register)("arrow-small-left", 0xea9e),
    arrowSmallRight: (0, _codiconsUtilJs.register)("arrow-small-right", 0xea9f),
    arrowSmallUp: (0, _codiconsUtilJs.register)("arrow-small-up", 0xeaa0),
    arrowUp: (0, _codiconsUtilJs.register)("arrow-up", 0xeaa1),
    bell: (0, _codiconsUtilJs.register)("bell", 0xeaa2),
    bold: (0, _codiconsUtilJs.register)("bold", 0xeaa3),
    book: (0, _codiconsUtilJs.register)("book", 0xeaa4),
    bookmark: (0, _codiconsUtilJs.register)("bookmark", 0xeaa5),
    debugBreakpointConditionalUnverified: (0, _codiconsUtilJs.register)("debug-breakpoint-conditional-unverified", 0xeaa6),
    debugBreakpointConditional: (0, _codiconsUtilJs.register)("debug-breakpoint-conditional", 0xeaa7),
    debugBreakpointConditionalDisabled: (0, _codiconsUtilJs.register)("debug-breakpoint-conditional-disabled", 0xeaa7),
    debugBreakpointDataUnverified: (0, _codiconsUtilJs.register)("debug-breakpoint-data-unverified", 0xeaa8),
    debugBreakpointData: (0, _codiconsUtilJs.register)("debug-breakpoint-data", 0xeaa9),
    debugBreakpointDataDisabled: (0, _codiconsUtilJs.register)("debug-breakpoint-data-disabled", 0xeaa9),
    debugBreakpointLogUnverified: (0, _codiconsUtilJs.register)("debug-breakpoint-log-unverified", 0xeaaa),
    debugBreakpointLog: (0, _codiconsUtilJs.register)("debug-breakpoint-log", 0xeaab),
    debugBreakpointLogDisabled: (0, _codiconsUtilJs.register)("debug-breakpoint-log-disabled", 0xeaab),
    briefcase: (0, _codiconsUtilJs.register)("briefcase", 0xeaac),
    broadcast: (0, _codiconsUtilJs.register)("broadcast", 0xeaad),
    browser: (0, _codiconsUtilJs.register)("browser", 0xeaae),
    bug: (0, _codiconsUtilJs.register)("bug", 0xeaaf),
    calendar: (0, _codiconsUtilJs.register)("calendar", 0xeab0),
    caseSensitive: (0, _codiconsUtilJs.register)("case-sensitive", 0xeab1),
    check: (0, _codiconsUtilJs.register)("check", 0xeab2),
    checklist: (0, _codiconsUtilJs.register)("checklist", 0xeab3),
    chevronDown: (0, _codiconsUtilJs.register)("chevron-down", 0xeab4),
    chevronLeft: (0, _codiconsUtilJs.register)("chevron-left", 0xeab5),
    chevronRight: (0, _codiconsUtilJs.register)("chevron-right", 0xeab6),
    chevronUp: (0, _codiconsUtilJs.register)("chevron-up", 0xeab7),
    chromeClose: (0, _codiconsUtilJs.register)("chrome-close", 0xeab8),
    chromeMaximize: (0, _codiconsUtilJs.register)("chrome-maximize", 0xeab9),
    chromeMinimize: (0, _codiconsUtilJs.register)("chrome-minimize", 0xeaba),
    chromeRestore: (0, _codiconsUtilJs.register)("chrome-restore", 0xeabb),
    circleOutline: (0, _codiconsUtilJs.register)("circle-outline", 0xeabc),
    circle: (0, _codiconsUtilJs.register)("circle", 0xeabc),
    debugBreakpointUnverified: (0, _codiconsUtilJs.register)("debug-breakpoint-unverified", 0xeabc),
    terminalDecorationIncomplete: (0, _codiconsUtilJs.register)("terminal-decoration-incomplete", 0xeabc),
    circleSlash: (0, _codiconsUtilJs.register)("circle-slash", 0xeabd),
    circuitBoard: (0, _codiconsUtilJs.register)("circuit-board", 0xeabe),
    clearAll: (0, _codiconsUtilJs.register)("clear-all", 0xeabf),
    clippy: (0, _codiconsUtilJs.register)("clippy", 0xeac0),
    closeAll: (0, _codiconsUtilJs.register)("close-all", 0xeac1),
    cloudDownload: (0, _codiconsUtilJs.register)("cloud-download", 0xeac2),
    cloudUpload: (0, _codiconsUtilJs.register)("cloud-upload", 0xeac3),
    code: (0, _codiconsUtilJs.register)("code", 0xeac4),
    collapseAll: (0, _codiconsUtilJs.register)("collapse-all", 0xeac5),
    colorMode: (0, _codiconsUtilJs.register)("color-mode", 0xeac6),
    commentDiscussion: (0, _codiconsUtilJs.register)("comment-discussion", 0xeac7),
    creditCard: (0, _codiconsUtilJs.register)("credit-card", 0xeac9),
    dash: (0, _codiconsUtilJs.register)("dash", 0xeacc),
    dashboard: (0, _codiconsUtilJs.register)("dashboard", 0xeacd),
    database: (0, _codiconsUtilJs.register)("database", 0xeace),
    debugContinue: (0, _codiconsUtilJs.register)("debug-continue", 0xeacf),
    debugDisconnect: (0, _codiconsUtilJs.register)("debug-disconnect", 0xead0),
    debugPause: (0, _codiconsUtilJs.register)("debug-pause", 0xead1),
    debugRestart: (0, _codiconsUtilJs.register)("debug-restart", 0xead2),
    debugStart: (0, _codiconsUtilJs.register)("debug-start", 0xead3),
    debugStepInto: (0, _codiconsUtilJs.register)("debug-step-into", 0xead4),
    debugStepOut: (0, _codiconsUtilJs.register)("debug-step-out", 0xead5),
    debugStepOver: (0, _codiconsUtilJs.register)("debug-step-over", 0xead6),
    debugStop: (0, _codiconsUtilJs.register)("debug-stop", 0xead7),
    debug: (0, _codiconsUtilJs.register)("debug", 0xead8),
    deviceCameraVideo: (0, _codiconsUtilJs.register)("device-camera-video", 0xead9),
    deviceCamera: (0, _codiconsUtilJs.register)("device-camera", 0xeada),
    deviceMobile: (0, _codiconsUtilJs.register)("device-mobile", 0xeadb),
    diffAdded: (0, _codiconsUtilJs.register)("diff-added", 0xeadc),
    diffIgnored: (0, _codiconsUtilJs.register)("diff-ignored", 0xeadd),
    diffModified: (0, _codiconsUtilJs.register)("diff-modified", 0xeade),
    diffRemoved: (0, _codiconsUtilJs.register)("diff-removed", 0xeadf),
    diffRenamed: (0, _codiconsUtilJs.register)("diff-renamed", 0xeae0),
    diff: (0, _codiconsUtilJs.register)("diff", 0xeae1),
    diffSidebyside: (0, _codiconsUtilJs.register)("diff-sidebyside", 0xeae1),
    discard: (0, _codiconsUtilJs.register)("discard", 0xeae2),
    editorLayout: (0, _codiconsUtilJs.register)("editor-layout", 0xeae3),
    emptyWindow: (0, _codiconsUtilJs.register)("empty-window", 0xeae4),
    exclude: (0, _codiconsUtilJs.register)("exclude", 0xeae5),
    extensions: (0, _codiconsUtilJs.register)("extensions", 0xeae6),
    eyeClosed: (0, _codiconsUtilJs.register)("eye-closed", 0xeae7),
    fileBinary: (0, _codiconsUtilJs.register)("file-binary", 0xeae8),
    fileCode: (0, _codiconsUtilJs.register)("file-code", 0xeae9),
    fileMedia: (0, _codiconsUtilJs.register)("file-media", 0xeaea),
    filePdf: (0, _codiconsUtilJs.register)("file-pdf", 0xeaeb),
    fileSubmodule: (0, _codiconsUtilJs.register)("file-submodule", 0xeaec),
    fileSymlinkDirectory: (0, _codiconsUtilJs.register)("file-symlink-directory", 0xeaed),
    fileSymlinkFile: (0, _codiconsUtilJs.register)("file-symlink-file", 0xeaee),
    fileZip: (0, _codiconsUtilJs.register)("file-zip", 0xeaef),
    files: (0, _codiconsUtilJs.register)("files", 0xeaf0),
    filter: (0, _codiconsUtilJs.register)("filter", 0xeaf1),
    flame: (0, _codiconsUtilJs.register)("flame", 0xeaf2),
    foldDown: (0, _codiconsUtilJs.register)("fold-down", 0xeaf3),
    foldUp: (0, _codiconsUtilJs.register)("fold-up", 0xeaf4),
    fold: (0, _codiconsUtilJs.register)("fold", 0xeaf5),
    folderActive: (0, _codiconsUtilJs.register)("folder-active", 0xeaf6),
    folderOpened: (0, _codiconsUtilJs.register)("folder-opened", 0xeaf7),
    gear: (0, _codiconsUtilJs.register)("gear", 0xeaf8),
    gift: (0, _codiconsUtilJs.register)("gift", 0xeaf9),
    gistSecret: (0, _codiconsUtilJs.register)("gist-secret", 0xeafa),
    gist: (0, _codiconsUtilJs.register)("gist", 0xeafb),
    gitCommit: (0, _codiconsUtilJs.register)("git-commit", 0xeafc),
    gitCompare: (0, _codiconsUtilJs.register)("git-compare", 0xeafd),
    compareChanges: (0, _codiconsUtilJs.register)("compare-changes", 0xeafd),
    gitMerge: (0, _codiconsUtilJs.register)("git-merge", 0xeafe),
    githubAction: (0, _codiconsUtilJs.register)("github-action", 0xeaff),
    githubAlt: (0, _codiconsUtilJs.register)("github-alt", 0xeb00),
    globe: (0, _codiconsUtilJs.register)("globe", 0xeb01),
    grabber: (0, _codiconsUtilJs.register)("grabber", 0xeb02),
    graph: (0, _codiconsUtilJs.register)("graph", 0xeb03),
    gripper: (0, _codiconsUtilJs.register)("gripper", 0xeb04),
    heart: (0, _codiconsUtilJs.register)("heart", 0xeb05),
    home: (0, _codiconsUtilJs.register)("home", 0xeb06),
    horizontalRule: (0, _codiconsUtilJs.register)("horizontal-rule", 0xeb07),
    hubot: (0, _codiconsUtilJs.register)("hubot", 0xeb08),
    inbox: (0, _codiconsUtilJs.register)("inbox", 0xeb09),
    issueReopened: (0, _codiconsUtilJs.register)("issue-reopened", 0xeb0b),
    issues: (0, _codiconsUtilJs.register)("issues", 0xeb0c),
    italic: (0, _codiconsUtilJs.register)("italic", 0xeb0d),
    jersey: (0, _codiconsUtilJs.register)("jersey", 0xeb0e),
    json: (0, _codiconsUtilJs.register)("json", 0xeb0f),
    kebabVertical: (0, _codiconsUtilJs.register)("kebab-vertical", 0xeb10),
    key: (0, _codiconsUtilJs.register)("key", 0xeb11),
    law: (0, _codiconsUtilJs.register)("law", 0xeb12),
    lightbulbAutofix: (0, _codiconsUtilJs.register)("lightbulb-autofix", 0xeb13),
    linkExternal: (0, _codiconsUtilJs.register)("link-external", 0xeb14),
    link: (0, _codiconsUtilJs.register)("link", 0xeb15),
    listOrdered: (0, _codiconsUtilJs.register)("list-ordered", 0xeb16),
    listUnordered: (0, _codiconsUtilJs.register)("list-unordered", 0xeb17),
    liveShare: (0, _codiconsUtilJs.register)("live-share", 0xeb18),
    loading: (0, _codiconsUtilJs.register)("loading", 0xeb19),
    location: (0, _codiconsUtilJs.register)("location", 0xeb1a),
    mailRead: (0, _codiconsUtilJs.register)("mail-read", 0xeb1b),
    mail: (0, _codiconsUtilJs.register)("mail", 0xeb1c),
    markdown: (0, _codiconsUtilJs.register)("markdown", 0xeb1d),
    megaphone: (0, _codiconsUtilJs.register)("megaphone", 0xeb1e),
    mention: (0, _codiconsUtilJs.register)("mention", 0xeb1f),
    milestone: (0, _codiconsUtilJs.register)("milestone", 0xeb20),
    gitPullRequestMilestone: (0, _codiconsUtilJs.register)("git-pull-request-milestone", 0xeb20),
    mortarBoard: (0, _codiconsUtilJs.register)("mortar-board", 0xeb21),
    move: (0, _codiconsUtilJs.register)("move", 0xeb22),
    multipleWindows: (0, _codiconsUtilJs.register)("multiple-windows", 0xeb23),
    mute: (0, _codiconsUtilJs.register)("mute", 0xeb24),
    noNewline: (0, _codiconsUtilJs.register)("no-newline", 0xeb25),
    note: (0, _codiconsUtilJs.register)("note", 0xeb26),
    octoface: (0, _codiconsUtilJs.register)("octoface", 0xeb27),
    openPreview: (0, _codiconsUtilJs.register)("open-preview", 0xeb28),
    package: (0, _codiconsUtilJs.register)("package", 0xeb29),
    paintcan: (0, _codiconsUtilJs.register)("paintcan", 0xeb2a),
    pin: (0, _codiconsUtilJs.register)("pin", 0xeb2b),
    play: (0, _codiconsUtilJs.register)("play", 0xeb2c),
    run: (0, _codiconsUtilJs.register)("run", 0xeb2c),
    plug: (0, _codiconsUtilJs.register)("plug", 0xeb2d),
    preserveCase: (0, _codiconsUtilJs.register)("preserve-case", 0xeb2e),
    preview: (0, _codiconsUtilJs.register)("preview", 0xeb2f),
    project: (0, _codiconsUtilJs.register)("project", 0xeb30),
    pulse: (0, _codiconsUtilJs.register)("pulse", 0xeb31),
    question: (0, _codiconsUtilJs.register)("question", 0xeb32),
    quote: (0, _codiconsUtilJs.register)("quote", 0xeb33),
    radioTower: (0, _codiconsUtilJs.register)("radio-tower", 0xeb34),
    reactions: (0, _codiconsUtilJs.register)("reactions", 0xeb35),
    references: (0, _codiconsUtilJs.register)("references", 0xeb36),
    refresh: (0, _codiconsUtilJs.register)("refresh", 0xeb37),
    regex: (0, _codiconsUtilJs.register)("regex", 0xeb38),
    remoteExplorer: (0, _codiconsUtilJs.register)("remote-explorer", 0xeb39),
    remote: (0, _codiconsUtilJs.register)("remote", 0xeb3a),
    remove: (0, _codiconsUtilJs.register)("remove", 0xeb3b),
    replaceAll: (0, _codiconsUtilJs.register)("replace-all", 0xeb3c),
    replace: (0, _codiconsUtilJs.register)("replace", 0xeb3d),
    repoClone: (0, _codiconsUtilJs.register)("repo-clone", 0xeb3e),
    repoForcePush: (0, _codiconsUtilJs.register)("repo-force-push", 0xeb3f),
    repoPull: (0, _codiconsUtilJs.register)("repo-pull", 0xeb40),
    repoPush: (0, _codiconsUtilJs.register)("repo-push", 0xeb41),
    report: (0, _codiconsUtilJs.register)("report", 0xeb42),
    requestChanges: (0, _codiconsUtilJs.register)("request-changes", 0xeb43),
    rocket: (0, _codiconsUtilJs.register)("rocket", 0xeb44),
    rootFolderOpened: (0, _codiconsUtilJs.register)("root-folder-opened", 0xeb45),
    rootFolder: (0, _codiconsUtilJs.register)("root-folder", 0xeb46),
    rss: (0, _codiconsUtilJs.register)("rss", 0xeb47),
    ruby: (0, _codiconsUtilJs.register)("ruby", 0xeb48),
    saveAll: (0, _codiconsUtilJs.register)("save-all", 0xeb49),
    saveAs: (0, _codiconsUtilJs.register)("save-as", 0xeb4a),
    save: (0, _codiconsUtilJs.register)("save", 0xeb4b),
    screenFull: (0, _codiconsUtilJs.register)("screen-full", 0xeb4c),
    screenNormal: (0, _codiconsUtilJs.register)("screen-normal", 0xeb4d),
    searchStop: (0, _codiconsUtilJs.register)("search-stop", 0xeb4e),
    server: (0, _codiconsUtilJs.register)("server", 0xeb50),
    settingsGear: (0, _codiconsUtilJs.register)("settings-gear", 0xeb51),
    settings: (0, _codiconsUtilJs.register)("settings", 0xeb52),
    shield: (0, _codiconsUtilJs.register)("shield", 0xeb53),
    smiley: (0, _codiconsUtilJs.register)("smiley", 0xeb54),
    sortPrecedence: (0, _codiconsUtilJs.register)("sort-precedence", 0xeb55),
    splitHorizontal: (0, _codiconsUtilJs.register)("split-horizontal", 0xeb56),
    splitVertical: (0, _codiconsUtilJs.register)("split-vertical", 0xeb57),
    squirrel: (0, _codiconsUtilJs.register)("squirrel", 0xeb58),
    starFull: (0, _codiconsUtilJs.register)("star-full", 0xeb59),
    starHalf: (0, _codiconsUtilJs.register)("star-half", 0xeb5a),
    symbolClass: (0, _codiconsUtilJs.register)("symbol-class", 0xeb5b),
    symbolColor: (0, _codiconsUtilJs.register)("symbol-color", 0xeb5c),
    symbolConstant: (0, _codiconsUtilJs.register)("symbol-constant", 0xeb5d),
    symbolEnumMember: (0, _codiconsUtilJs.register)("symbol-enum-member", 0xeb5e),
    symbolField: (0, _codiconsUtilJs.register)("symbol-field", 0xeb5f),
    symbolFile: (0, _codiconsUtilJs.register)("symbol-file", 0xeb60),
    symbolInterface: (0, _codiconsUtilJs.register)("symbol-interface", 0xeb61),
    symbolKeyword: (0, _codiconsUtilJs.register)("symbol-keyword", 0xeb62),
    symbolMisc: (0, _codiconsUtilJs.register)("symbol-misc", 0xeb63),
    symbolOperator: (0, _codiconsUtilJs.register)("symbol-operator", 0xeb64),
    symbolProperty: (0, _codiconsUtilJs.register)("symbol-property", 0xeb65),
    wrench: (0, _codiconsUtilJs.register)("wrench", 0xeb65),
    wrenchSubaction: (0, _codiconsUtilJs.register)("wrench-subaction", 0xeb65),
    symbolSnippet: (0, _codiconsUtilJs.register)("symbol-snippet", 0xeb66),
    tasklist: (0, _codiconsUtilJs.register)("tasklist", 0xeb67),
    telescope: (0, _codiconsUtilJs.register)("telescope", 0xeb68),
    textSize: (0, _codiconsUtilJs.register)("text-size", 0xeb69),
    threeBars: (0, _codiconsUtilJs.register)("three-bars", 0xeb6a),
    thumbsdown: (0, _codiconsUtilJs.register)("thumbsdown", 0xeb6b),
    thumbsup: (0, _codiconsUtilJs.register)("thumbsup", 0xeb6c),
    tools: (0, _codiconsUtilJs.register)("tools", 0xeb6d),
    triangleDown: (0, _codiconsUtilJs.register)("triangle-down", 0xeb6e),
    triangleLeft: (0, _codiconsUtilJs.register)("triangle-left", 0xeb6f),
    triangleRight: (0, _codiconsUtilJs.register)("triangle-right", 0xeb70),
    triangleUp: (0, _codiconsUtilJs.register)("triangle-up", 0xeb71),
    twitter: (0, _codiconsUtilJs.register)("twitter", 0xeb72),
    unfold: (0, _codiconsUtilJs.register)("unfold", 0xeb73),
    unlock: (0, _codiconsUtilJs.register)("unlock", 0xeb74),
    unmute: (0, _codiconsUtilJs.register)("unmute", 0xeb75),
    unverified: (0, _codiconsUtilJs.register)("unverified", 0xeb76),
    verified: (0, _codiconsUtilJs.register)("verified", 0xeb77),
    versions: (0, _codiconsUtilJs.register)("versions", 0xeb78),
    vmActive: (0, _codiconsUtilJs.register)("vm-active", 0xeb79),
    vmOutline: (0, _codiconsUtilJs.register)("vm-outline", 0xeb7a),
    vmRunning: (0, _codiconsUtilJs.register)("vm-running", 0xeb7b),
    watch: (0, _codiconsUtilJs.register)("watch", 0xeb7c),
    whitespace: (0, _codiconsUtilJs.register)("whitespace", 0xeb7d),
    wholeWord: (0, _codiconsUtilJs.register)("whole-word", 0xeb7e),
    window: (0, _codiconsUtilJs.register)("window", 0xeb7f),
    wordWrap: (0, _codiconsUtilJs.register)("word-wrap", 0xeb80),
    zoomIn: (0, _codiconsUtilJs.register)("zoom-in", 0xeb81),
    zoomOut: (0, _codiconsUtilJs.register)("zoom-out", 0xeb82),
    listFilter: (0, _codiconsUtilJs.register)("list-filter", 0xeb83),
    listFlat: (0, _codiconsUtilJs.register)("list-flat", 0xeb84),
    listSelection: (0, _codiconsUtilJs.register)("list-selection", 0xeb85),
    selection: (0, _codiconsUtilJs.register)("selection", 0xeb85),
    listTree: (0, _codiconsUtilJs.register)("list-tree", 0xeb86),
    debugBreakpointFunctionUnverified: (0, _codiconsUtilJs.register)("debug-breakpoint-function-unverified", 0xeb87),
    debugBreakpointFunction: (0, _codiconsUtilJs.register)("debug-breakpoint-function", 0xeb88),
    debugBreakpointFunctionDisabled: (0, _codiconsUtilJs.register)("debug-breakpoint-function-disabled", 0xeb88),
    debugStackframeActive: (0, _codiconsUtilJs.register)("debug-stackframe-active", 0xeb89),
    circleSmallFilled: (0, _codiconsUtilJs.register)("circle-small-filled", 0xeb8a),
    debugStackframeDot: (0, _codiconsUtilJs.register)("debug-stackframe-dot", 0xeb8a),
    terminalDecorationMark: (0, _codiconsUtilJs.register)("terminal-decoration-mark", 0xeb8a),
    debugStackframe: (0, _codiconsUtilJs.register)("debug-stackframe", 0xeb8b),
    debugStackframeFocused: (0, _codiconsUtilJs.register)("debug-stackframe-focused", 0xeb8b),
    debugBreakpointUnsupported: (0, _codiconsUtilJs.register)("debug-breakpoint-unsupported", 0xeb8c),
    symbolString: (0, _codiconsUtilJs.register)("symbol-string", 0xeb8d),
    debugReverseContinue: (0, _codiconsUtilJs.register)("debug-reverse-continue", 0xeb8e),
    debugStepBack: (0, _codiconsUtilJs.register)("debug-step-back", 0xeb8f),
    debugRestartFrame: (0, _codiconsUtilJs.register)("debug-restart-frame", 0xeb90),
    debugAlt: (0, _codiconsUtilJs.register)("debug-alt", 0xeb91),
    callIncoming: (0, _codiconsUtilJs.register)("call-incoming", 0xeb92),
    callOutgoing: (0, _codiconsUtilJs.register)("call-outgoing", 0xeb93),
    menu: (0, _codiconsUtilJs.register)("menu", 0xeb94),
    expandAll: (0, _codiconsUtilJs.register)("expand-all", 0xeb95),
    feedback: (0, _codiconsUtilJs.register)("feedback", 0xeb96),
    gitPullRequestReviewer: (0, _codiconsUtilJs.register)("git-pull-request-reviewer", 0xeb96),
    groupByRefType: (0, _codiconsUtilJs.register)("group-by-ref-type", 0xeb97),
    ungroupByRefType: (0, _codiconsUtilJs.register)("ungroup-by-ref-type", 0xeb98),
    account: (0, _codiconsUtilJs.register)("account", 0xeb99),
    gitPullRequestAssignee: (0, _codiconsUtilJs.register)("git-pull-request-assignee", 0xeb99),
    bellDot: (0, _codiconsUtilJs.register)("bell-dot", 0xeb9a),
    debugConsole: (0, _codiconsUtilJs.register)("debug-console", 0xeb9b),
    library: (0, _codiconsUtilJs.register)("library", 0xeb9c),
    output: (0, _codiconsUtilJs.register)("output", 0xeb9d),
    runAll: (0, _codiconsUtilJs.register)("run-all", 0xeb9e),
    syncIgnored: (0, _codiconsUtilJs.register)("sync-ignored", 0xeb9f),
    pinned: (0, _codiconsUtilJs.register)("pinned", 0xeba0),
    githubInverted: (0, _codiconsUtilJs.register)("github-inverted", 0xeba1),
    serverProcess: (0, _codiconsUtilJs.register)("server-process", 0xeba2),
    serverEnvironment: (0, _codiconsUtilJs.register)("server-environment", 0xeba3),
    pass: (0, _codiconsUtilJs.register)("pass", 0xeba4),
    issueClosed: (0, _codiconsUtilJs.register)("issue-closed", 0xeba4),
    stopCircle: (0, _codiconsUtilJs.register)("stop-circle", 0xeba5),
    playCircle: (0, _codiconsUtilJs.register)("play-circle", 0xeba6),
    record: (0, _codiconsUtilJs.register)("record", 0xeba7),
    debugAltSmall: (0, _codiconsUtilJs.register)("debug-alt-small", 0xeba8),
    vmConnect: (0, _codiconsUtilJs.register)("vm-connect", 0xeba9),
    cloud: (0, _codiconsUtilJs.register)("cloud", 0xebaa),
    merge: (0, _codiconsUtilJs.register)("merge", 0xebab),
    export: (0, _codiconsUtilJs.register)("export", 0xebac),
    graphLeft: (0, _codiconsUtilJs.register)("graph-left", 0xebad),
    magnet: (0, _codiconsUtilJs.register)("magnet", 0xebae),
    notebook: (0, _codiconsUtilJs.register)("notebook", 0xebaf),
    redo: (0, _codiconsUtilJs.register)("redo", 0xebb0),
    checkAll: (0, _codiconsUtilJs.register)("check-all", 0xebb1),
    pinnedDirty: (0, _codiconsUtilJs.register)("pinned-dirty", 0xebb2),
    passFilled: (0, _codiconsUtilJs.register)("pass-filled", 0xebb3),
    circleLargeFilled: (0, _codiconsUtilJs.register)("circle-large-filled", 0xebb4),
    circleLarge: (0, _codiconsUtilJs.register)("circle-large", 0xebb5),
    circleLargeOutline: (0, _codiconsUtilJs.register)("circle-large-outline", 0xebb5),
    combine: (0, _codiconsUtilJs.register)("combine", 0xebb6),
    gather: (0, _codiconsUtilJs.register)("gather", 0xebb6),
    table: (0, _codiconsUtilJs.register)("table", 0xebb7),
    variableGroup: (0, _codiconsUtilJs.register)("variable-group", 0xebb8),
    typeHierarchy: (0, _codiconsUtilJs.register)("type-hierarchy", 0xebb9),
    typeHierarchySub: (0, _codiconsUtilJs.register)("type-hierarchy-sub", 0xebba),
    typeHierarchySuper: (0, _codiconsUtilJs.register)("type-hierarchy-super", 0xebbb),
    gitPullRequestCreate: (0, _codiconsUtilJs.register)("git-pull-request-create", 0xebbc),
    runAbove: (0, _codiconsUtilJs.register)("run-above", 0xebbd),
    runBelow: (0, _codiconsUtilJs.register)("run-below", 0xebbe),
    notebookTemplate: (0, _codiconsUtilJs.register)("notebook-template", 0xebbf),
    debugRerun: (0, _codiconsUtilJs.register)("debug-rerun", 0xebc0),
    workspaceTrusted: (0, _codiconsUtilJs.register)("workspace-trusted", 0xebc1),
    workspaceUntrusted: (0, _codiconsUtilJs.register)("workspace-untrusted", 0xebc2),
    workspaceUnknown: (0, _codiconsUtilJs.register)("workspace-unknown", 0xebc3),
    terminalCmd: (0, _codiconsUtilJs.register)("terminal-cmd", 0xebc4),
    terminalDebian: (0, _codiconsUtilJs.register)("terminal-debian", 0xebc5),
    terminalLinux: (0, _codiconsUtilJs.register)("terminal-linux", 0xebc6),
    terminalPowershell: (0, _codiconsUtilJs.register)("terminal-powershell", 0xebc7),
    terminalTmux: (0, _codiconsUtilJs.register)("terminal-tmux", 0xebc8),
    terminalUbuntu: (0, _codiconsUtilJs.register)("terminal-ubuntu", 0xebc9),
    terminalBash: (0, _codiconsUtilJs.register)("terminal-bash", 0xebca),
    arrowSwap: (0, _codiconsUtilJs.register)("arrow-swap", 0xebcb),
    copy: (0, _codiconsUtilJs.register)("copy", 0xebcc),
    personAdd: (0, _codiconsUtilJs.register)("person-add", 0xebcd),
    filterFilled: (0, _codiconsUtilJs.register)("filter-filled", 0xebce),
    wand: (0, _codiconsUtilJs.register)("wand", 0xebcf),
    debugLineByLine: (0, _codiconsUtilJs.register)("debug-line-by-line", 0xebd0),
    inspect: (0, _codiconsUtilJs.register)("inspect", 0xebd1),
    layers: (0, _codiconsUtilJs.register)("layers", 0xebd2),
    layersDot: (0, _codiconsUtilJs.register)("layers-dot", 0xebd3),
    layersActive: (0, _codiconsUtilJs.register)("layers-active", 0xebd4),
    compass: (0, _codiconsUtilJs.register)("compass", 0xebd5),
    compassDot: (0, _codiconsUtilJs.register)("compass-dot", 0xebd6),
    compassActive: (0, _codiconsUtilJs.register)("compass-active", 0xebd7),
    azure: (0, _codiconsUtilJs.register)("azure", 0xebd8),
    issueDraft: (0, _codiconsUtilJs.register)("issue-draft", 0xebd9),
    gitPullRequestClosed: (0, _codiconsUtilJs.register)("git-pull-request-closed", 0xebda),
    gitPullRequestDraft: (0, _codiconsUtilJs.register)("git-pull-request-draft", 0xebdb),
    debugAll: (0, _codiconsUtilJs.register)("debug-all", 0xebdc),
    debugCoverage: (0, _codiconsUtilJs.register)("debug-coverage", 0xebdd),
    runErrors: (0, _codiconsUtilJs.register)("run-errors", 0xebde),
    folderLibrary: (0, _codiconsUtilJs.register)("folder-library", 0xebdf),
    debugContinueSmall: (0, _codiconsUtilJs.register)("debug-continue-small", 0xebe0),
    beakerStop: (0, _codiconsUtilJs.register)("beaker-stop", 0xebe1),
    graphLine: (0, _codiconsUtilJs.register)("graph-line", 0xebe2),
    graphScatter: (0, _codiconsUtilJs.register)("graph-scatter", 0xebe3),
    pieChart: (0, _codiconsUtilJs.register)("pie-chart", 0xebe4),
    bracket: (0, _codiconsUtilJs.register)("bracket", 0xeb0f),
    bracketDot: (0, _codiconsUtilJs.register)("bracket-dot", 0xebe5),
    bracketError: (0, _codiconsUtilJs.register)("bracket-error", 0xebe6),
    lockSmall: (0, _codiconsUtilJs.register)("lock-small", 0xebe7),
    azureDevops: (0, _codiconsUtilJs.register)("azure-devops", 0xebe8),
    verifiedFilled: (0, _codiconsUtilJs.register)("verified-filled", 0xebe9),
    newline: (0, _codiconsUtilJs.register)("newline", 0xebea),
    layout: (0, _codiconsUtilJs.register)("layout", 0xebeb),
    layoutActivitybarLeft: (0, _codiconsUtilJs.register)("layout-activitybar-left", 0xebec),
    layoutActivitybarRight: (0, _codiconsUtilJs.register)("layout-activitybar-right", 0xebed),
    layoutPanelLeft: (0, _codiconsUtilJs.register)("layout-panel-left", 0xebee),
    layoutPanelCenter: (0, _codiconsUtilJs.register)("layout-panel-center", 0xebef),
    layoutPanelJustify: (0, _codiconsUtilJs.register)("layout-panel-justify", 0xebf0),
    layoutPanelRight: (0, _codiconsUtilJs.register)("layout-panel-right", 0xebf1),
    layoutPanel: (0, _codiconsUtilJs.register)("layout-panel", 0xebf2),
    layoutSidebarLeft: (0, _codiconsUtilJs.register)("layout-sidebar-left", 0xebf3),
    layoutSidebarRight: (0, _codiconsUtilJs.register)("layout-sidebar-right", 0xebf4),
    layoutStatusbar: (0, _codiconsUtilJs.register)("layout-statusbar", 0xebf5),
    layoutMenubar: (0, _codiconsUtilJs.register)("layout-menubar", 0xebf6),
    layoutCentered: (0, _codiconsUtilJs.register)("layout-centered", 0xebf7),
    target: (0, _codiconsUtilJs.register)("target", 0xebf8),
    indent: (0, _codiconsUtilJs.register)("indent", 0xebf9),
    recordSmall: (0, _codiconsUtilJs.register)("record-small", 0xebfa),
    errorSmall: (0, _codiconsUtilJs.register)("error-small", 0xebfb),
    terminalDecorationError: (0, _codiconsUtilJs.register)("terminal-decoration-error", 0xebfb),
    arrowCircleDown: (0, _codiconsUtilJs.register)("arrow-circle-down", 0xebfc),
    arrowCircleLeft: (0, _codiconsUtilJs.register)("arrow-circle-left", 0xebfd),
    arrowCircleRight: (0, _codiconsUtilJs.register)("arrow-circle-right", 0xebfe),
    arrowCircleUp: (0, _codiconsUtilJs.register)("arrow-circle-up", 0xebff),
    layoutSidebarRightOff: (0, _codiconsUtilJs.register)("layout-sidebar-right-off", 0xec00),
    layoutPanelOff: (0, _codiconsUtilJs.register)("layout-panel-off", 0xec01),
    layoutSidebarLeftOff: (0, _codiconsUtilJs.register)("layout-sidebar-left-off", 0xec02),
    blank: (0, _codiconsUtilJs.register)("blank", 0xec03),
    heartFilled: (0, _codiconsUtilJs.register)("heart-filled", 0xec04),
    map: (0, _codiconsUtilJs.register)("map", 0xec05),
    mapHorizontal: (0, _codiconsUtilJs.register)("map-horizontal", 0xec05),
    foldHorizontal: (0, _codiconsUtilJs.register)("fold-horizontal", 0xec05),
    mapFilled: (0, _codiconsUtilJs.register)("map-filled", 0xec06),
    mapHorizontalFilled: (0, _codiconsUtilJs.register)("map-horizontal-filled", 0xec06),
    foldHorizontalFilled: (0, _codiconsUtilJs.register)("fold-horizontal-filled", 0xec06),
    circleSmall: (0, _codiconsUtilJs.register)("circle-small", 0xec07),
    bellSlash: (0, _codiconsUtilJs.register)("bell-slash", 0xec08),
    bellSlashDot: (0, _codiconsUtilJs.register)("bell-slash-dot", 0xec09),
    commentUnresolved: (0, _codiconsUtilJs.register)("comment-unresolved", 0xec0a),
    gitPullRequestGoToChanges: (0, _codiconsUtilJs.register)("git-pull-request-go-to-changes", 0xec0b),
    gitPullRequestNewChanges: (0, _codiconsUtilJs.register)("git-pull-request-new-changes", 0xec0c),
    searchFuzzy: (0, _codiconsUtilJs.register)("search-fuzzy", 0xec0d),
    commentDraft: (0, _codiconsUtilJs.register)("comment-draft", 0xec0e),
    send: (0, _codiconsUtilJs.register)("send", 0xec0f),
    sparkle: (0, _codiconsUtilJs.register)("sparkle", 0xec10),
    insert: (0, _codiconsUtilJs.register)("insert", 0xec11),
    mic: (0, _codiconsUtilJs.register)("mic", 0xec12),
    thumbsdownFilled: (0, _codiconsUtilJs.register)("thumbsdown-filled", 0xec13),
    thumbsupFilled: (0, _codiconsUtilJs.register)("thumbsup-filled", 0xec14),
    coffee: (0, _codiconsUtilJs.register)("coffee", 0xec15),
    snake: (0, _codiconsUtilJs.register)("snake", 0xec16),
    game: (0, _codiconsUtilJs.register)("game", 0xec17),
    vr: (0, _codiconsUtilJs.register)("vr", 0xec18),
    chip: (0, _codiconsUtilJs.register)("chip", 0xec19),
    piano: (0, _codiconsUtilJs.register)("piano", 0xec1a),
    music: (0, _codiconsUtilJs.register)("music", 0xec1b),
    micFilled: (0, _codiconsUtilJs.register)("mic-filled", 0xec1c),
    repoFetch: (0, _codiconsUtilJs.register)("repo-fetch", 0xec1d),
    copilot: (0, _codiconsUtilJs.register)("copilot", 0xec1e),
    lightbulbSparkle: (0, _codiconsUtilJs.register)("lightbulb-sparkle", 0xec1f),
    robot: (0, _codiconsUtilJs.register)("robot", 0xec20),
    sparkleFilled: (0, _codiconsUtilJs.register)("sparkle-filled", 0xec21),
    diffSingle: (0, _codiconsUtilJs.register)("diff-single", 0xec22),
    diffMultiple: (0, _codiconsUtilJs.register)("diff-multiple", 0xec23),
    surroundWith: (0, _codiconsUtilJs.register)("surround-with", 0xec24),
    share: (0, _codiconsUtilJs.register)("share", 0xec25),
    gitStash: (0, _codiconsUtilJs.register)("git-stash", 0xec26),
    gitStashApply: (0, _codiconsUtilJs.register)("git-stash-apply", 0xec27),
    gitStashPop: (0, _codiconsUtilJs.register)("git-stash-pop", 0xec28),
    vscode: (0, _codiconsUtilJs.register)("vscode", 0xec29),
    vscodeInsiders: (0, _codiconsUtilJs.register)("vscode-insiders", 0xec2a),
    codeOss: (0, _codiconsUtilJs.register)("code-oss", 0xec2b),
    runCoverage: (0, _codiconsUtilJs.register)("run-coverage", 0xec2c),
    runAllCoverage: (0, _codiconsUtilJs.register)("run-all-coverage", 0xec2d),
    coverage: (0, _codiconsUtilJs.register)("coverage", 0xec2e),
    githubProject: (0, _codiconsUtilJs.register)("github-project", 0xec2f),
    mapVertical: (0, _codiconsUtilJs.register)("map-vertical", 0xec30),
    foldVertical: (0, _codiconsUtilJs.register)("fold-vertical", 0xec30),
    mapVerticalFilled: (0, _codiconsUtilJs.register)("map-vertical-filled", 0xec31),
    foldVerticalFilled: (0, _codiconsUtilJs.register)("fold-vertical-filled", 0xec31),
    goToSearch: (0, _codiconsUtilJs.register)("go-to-search", 0xec32),
    percentage: (0, _codiconsUtilJs.register)("percentage", 0xec33),
    sortPercentage: (0, _codiconsUtilJs.register)("sort-percentage", 0xec33),
    attach: (0, _codiconsUtilJs.register)("attach", 0xec34)
};

},{"./codiconsUtil.js":"6g8vy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kqBdY":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenizationRegistry", ()=>TokenizationRegistry);
var _eventJs = require("../../base/common/event.js");
var _lifecycleJs = require("../../base/common/lifecycle.js");
class TokenizationRegistry {
    constructor(){
        this._tokenizationSupports = new Map();
        this._factories = new Map();
        this._onDidChange = new (0, _eventJs.Emitter)();
        this.onDidChange = this._onDidChange.event;
        this._colorMap = null;
    }
    handleChange(languageIds) {
        this._onDidChange.fire({
            changedLanguages: languageIds,
            changedColorMap: false
        });
    }
    register(languageId, support) {
        this._tokenizationSupports.set(languageId, support);
        this.handleChange([
            languageId
        ]);
        return (0, _lifecycleJs.toDisposable)(()=>{
            if (this._tokenizationSupports.get(languageId) !== support) return;
            this._tokenizationSupports.delete(languageId);
            this.handleChange([
                languageId
            ]);
        });
    }
    get(languageId) {
        return this._tokenizationSupports.get(languageId) || null;
    }
    registerFactory(languageId, factory) {
        this._factories.get(languageId)?.dispose();
        const myData = new TokenizationSupportFactoryData(this, languageId, factory);
        this._factories.set(languageId, myData);
        return (0, _lifecycleJs.toDisposable)(()=>{
            const v = this._factories.get(languageId);
            if (!v || v !== myData) return;
            this._factories.delete(languageId);
            v.dispose();
        });
    }
    async getOrCreate(languageId) {
        // check first if the support is already set
        const tokenizationSupport = this.get(languageId);
        if (tokenizationSupport) return tokenizationSupport;
        const factory = this._factories.get(languageId);
        if (!factory || factory.isResolved) // no factory or factory.resolve already finished
        return null;
        await factory.resolve();
        return this.get(languageId);
    }
    isResolved(languageId) {
        const tokenizationSupport = this.get(languageId);
        if (tokenizationSupport) return true;
        const factory = this._factories.get(languageId);
        if (!factory || factory.isResolved) return true;
        return false;
    }
    setColorMap(colorMap) {
        this._colorMap = colorMap;
        this._onDidChange.fire({
            changedLanguages: Array.from(this._tokenizationSupports.keys()),
            changedColorMap: true
        });
    }
    getColorMap() {
        return this._colorMap;
    }
    getDefaultBackground() {
        if (this._colorMap && this._colorMap.length > 2 /* ColorId.DefaultBackground */ ) return this._colorMap[2 /* ColorId.DefaultBackground */ ];
        return null;
    }
}
class TokenizationSupportFactoryData extends (0, _lifecycleJs.Disposable) {
    get isResolved() {
        return this._isResolved;
    }
    constructor(_registry, _languageId, _factory){
        super();
        this._registry = _registry;
        this._languageId = _languageId;
        this._factory = _factory;
        this._isDisposed = false;
        this._resolvePromise = null;
        this._isResolved = false;
    }
    dispose() {
        this._isDisposed = true;
        super.dispose();
    }
    async resolve() {
        if (!this._resolvePromise) this._resolvePromise = this._create();
        return this._resolvePromise;
    }
    async _create() {
        const value = await this._factory.tokenizationSupport;
        this._isResolved = true;
        if (value && !this._isDisposed) this._register(this._registry.register(this._languageId, value));
    }
}

},{"../../base/common/event.js":"4Zi8b","../../base/common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7JLc0":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ // THIS IS A GENERATED FILE. DO NOT EDIT DIRECTLY.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessibilitySupport", ()=>AccessibilitySupport);
parcelHelpers.export(exports, "CodeActionTriggerType", ()=>CodeActionTriggerType);
parcelHelpers.export(exports, "CompletionItemInsertTextRule", ()=>CompletionItemInsertTextRule);
parcelHelpers.export(exports, "CompletionItemKind", ()=>CompletionItemKind);
parcelHelpers.export(exports, "CompletionItemTag", ()=>CompletionItemTag);
parcelHelpers.export(exports, "CompletionTriggerKind", ()=>CompletionTriggerKind);
parcelHelpers.export(exports, "ContentWidgetPositionPreference", ()=>ContentWidgetPositionPreference);
parcelHelpers.export(exports, "CursorChangeReason", ()=>CursorChangeReason);
parcelHelpers.export(exports, "DefaultEndOfLine", ()=>DefaultEndOfLine);
parcelHelpers.export(exports, "DocumentHighlightKind", ()=>DocumentHighlightKind);
parcelHelpers.export(exports, "EditorAutoIndentStrategy", ()=>EditorAutoIndentStrategy);
parcelHelpers.export(exports, "EditorOption", ()=>EditorOption);
parcelHelpers.export(exports, "EndOfLinePreference", ()=>EndOfLinePreference);
parcelHelpers.export(exports, "EndOfLineSequence", ()=>EndOfLineSequence);
parcelHelpers.export(exports, "GlyphMarginLane", ()=>GlyphMarginLane);
parcelHelpers.export(exports, "HoverVerbosityAction", ()=>HoverVerbosityAction);
parcelHelpers.export(exports, "IndentAction", ()=>IndentAction);
parcelHelpers.export(exports, "InjectedTextCursorStops", ()=>InjectedTextCursorStops);
parcelHelpers.export(exports, "InlayHintKind", ()=>InlayHintKind);
parcelHelpers.export(exports, "InlineCompletionTriggerKind", ()=>InlineCompletionTriggerKind);
parcelHelpers.export(exports, "InlineEditTriggerKind", ()=>InlineEditTriggerKind);
parcelHelpers.export(exports, "KeyCode", ()=>KeyCode);
parcelHelpers.export(exports, "MarkerSeverity", ()=>MarkerSeverity);
parcelHelpers.export(exports, "MarkerTag", ()=>MarkerTag);
parcelHelpers.export(exports, "MinimapPosition", ()=>MinimapPosition);
parcelHelpers.export(exports, "MinimapSectionHeaderStyle", ()=>MinimapSectionHeaderStyle);
parcelHelpers.export(exports, "MouseTargetType", ()=>MouseTargetType);
parcelHelpers.export(exports, "NewSymbolNameTag", ()=>NewSymbolNameTag);
parcelHelpers.export(exports, "NewSymbolNameTriggerKind", ()=>NewSymbolNameTriggerKind);
parcelHelpers.export(exports, "OverlayWidgetPositionPreference", ()=>OverlayWidgetPositionPreference);
parcelHelpers.export(exports, "OverviewRulerLane", ()=>OverviewRulerLane);
parcelHelpers.export(exports, "PartialAcceptTriggerKind", ()=>PartialAcceptTriggerKind);
parcelHelpers.export(exports, "PositionAffinity", ()=>PositionAffinity);
parcelHelpers.export(exports, "RenderLineNumbersType", ()=>RenderLineNumbersType);
parcelHelpers.export(exports, "RenderMinimap", ()=>RenderMinimap);
parcelHelpers.export(exports, "ScrollType", ()=>ScrollType);
parcelHelpers.export(exports, "ScrollbarVisibility", ()=>ScrollbarVisibility);
parcelHelpers.export(exports, "SelectionDirection", ()=>SelectionDirection);
parcelHelpers.export(exports, "ShowLightbulbIconMode", ()=>ShowLightbulbIconMode);
parcelHelpers.export(exports, "SignatureHelpTriggerKind", ()=>SignatureHelpTriggerKind);
parcelHelpers.export(exports, "SymbolKind", ()=>SymbolKind);
parcelHelpers.export(exports, "SymbolTag", ()=>SymbolTag);
parcelHelpers.export(exports, "TextEditorCursorBlinkingStyle", ()=>TextEditorCursorBlinkingStyle);
parcelHelpers.export(exports, "TextEditorCursorStyle", ()=>TextEditorCursorStyle);
parcelHelpers.export(exports, "TrackedRangeStickiness", ()=>TrackedRangeStickiness);
parcelHelpers.export(exports, "WrappingIndent", ()=>WrappingIndent);
var AccessibilitySupport;
(function(AccessibilitySupport) {
    /**
     * This should be the browser case where it is not known if a screen reader is attached or no.
     */ AccessibilitySupport[AccessibilitySupport["Unknown"] = 0] = "Unknown";
    AccessibilitySupport[AccessibilitySupport["Disabled"] = 1] = "Disabled";
    AccessibilitySupport[AccessibilitySupport["Enabled"] = 2] = "Enabled";
})(AccessibilitySupport || (AccessibilitySupport = {}));
var CodeActionTriggerType;
(function(CodeActionTriggerType) {
    CodeActionTriggerType[CodeActionTriggerType["Invoke"] = 1] = "Invoke";
    CodeActionTriggerType[CodeActionTriggerType["Auto"] = 2] = "Auto";
})(CodeActionTriggerType || (CodeActionTriggerType = {}));
var CompletionItemInsertTextRule;
(function(CompletionItemInsertTextRule) {
    CompletionItemInsertTextRule[CompletionItemInsertTextRule["None"] = 0] = "None";
    /**
     * Adjust whitespace/indentation of multiline insert texts to
     * match the current line indentation.
     */ CompletionItemInsertTextRule[CompletionItemInsertTextRule["KeepWhitespace"] = 1] = "KeepWhitespace";
    /**
     * `insertText` is a snippet.
     */ CompletionItemInsertTextRule[CompletionItemInsertTextRule["InsertAsSnippet"] = 4] = "InsertAsSnippet";
})(CompletionItemInsertTextRule || (CompletionItemInsertTextRule = {}));
var CompletionItemKind;
(function(CompletionItemKind) {
    CompletionItemKind[CompletionItemKind["Method"] = 0] = "Method";
    CompletionItemKind[CompletionItemKind["Function"] = 1] = "Function";
    CompletionItemKind[CompletionItemKind["Constructor"] = 2] = "Constructor";
    CompletionItemKind[CompletionItemKind["Field"] = 3] = "Field";
    CompletionItemKind[CompletionItemKind["Variable"] = 4] = "Variable";
    CompletionItemKind[CompletionItemKind["Class"] = 5] = "Class";
    CompletionItemKind[CompletionItemKind["Struct"] = 6] = "Struct";
    CompletionItemKind[CompletionItemKind["Interface"] = 7] = "Interface";
    CompletionItemKind[CompletionItemKind["Module"] = 8] = "Module";
    CompletionItemKind[CompletionItemKind["Property"] = 9] = "Property";
    CompletionItemKind[CompletionItemKind["Event"] = 10] = "Event";
    CompletionItemKind[CompletionItemKind["Operator"] = 11] = "Operator";
    CompletionItemKind[CompletionItemKind["Unit"] = 12] = "Unit";
    CompletionItemKind[CompletionItemKind["Value"] = 13] = "Value";
    CompletionItemKind[CompletionItemKind["Constant"] = 14] = "Constant";
    CompletionItemKind[CompletionItemKind["Enum"] = 15] = "Enum";
    CompletionItemKind[CompletionItemKind["EnumMember"] = 16] = "EnumMember";
    CompletionItemKind[CompletionItemKind["Keyword"] = 17] = "Keyword";
    CompletionItemKind[CompletionItemKind["Text"] = 18] = "Text";
    CompletionItemKind[CompletionItemKind["Color"] = 19] = "Color";
    CompletionItemKind[CompletionItemKind["File"] = 20] = "File";
    CompletionItemKind[CompletionItemKind["Reference"] = 21] = "Reference";
    CompletionItemKind[CompletionItemKind["Customcolor"] = 22] = "Customcolor";
    CompletionItemKind[CompletionItemKind["Folder"] = 23] = "Folder";
    CompletionItemKind[CompletionItemKind["TypeParameter"] = 24] = "TypeParameter";
    CompletionItemKind[CompletionItemKind["User"] = 25] = "User";
    CompletionItemKind[CompletionItemKind["Issue"] = 26] = "Issue";
    CompletionItemKind[CompletionItemKind["Snippet"] = 27] = "Snippet";
})(CompletionItemKind || (CompletionItemKind = {}));
var CompletionItemTag;
(function(CompletionItemTag) {
    CompletionItemTag[CompletionItemTag["Deprecated"] = 1] = "Deprecated";
})(CompletionItemTag || (CompletionItemTag = {}));
var CompletionTriggerKind;
(function(CompletionTriggerKind) {
    CompletionTriggerKind[CompletionTriggerKind["Invoke"] = 0] = "Invoke";
    CompletionTriggerKind[CompletionTriggerKind["TriggerCharacter"] = 1] = "TriggerCharacter";
    CompletionTriggerKind[CompletionTriggerKind["TriggerForIncompleteCompletions"] = 2] = "TriggerForIncompleteCompletions";
})(CompletionTriggerKind || (CompletionTriggerKind = {}));
var ContentWidgetPositionPreference;
(function(ContentWidgetPositionPreference) {
    /**
     * Place the content widget exactly at a position
     */ ContentWidgetPositionPreference[ContentWidgetPositionPreference["EXACT"] = 0] = "EXACT";
    /**
     * Place the content widget above a position
     */ ContentWidgetPositionPreference[ContentWidgetPositionPreference["ABOVE"] = 1] = "ABOVE";
    /**
     * Place the content widget below a position
     */ ContentWidgetPositionPreference[ContentWidgetPositionPreference["BELOW"] = 2] = "BELOW";
})(ContentWidgetPositionPreference || (ContentWidgetPositionPreference = {}));
var CursorChangeReason;
(function(CursorChangeReason) {
    /**
     * Unknown or not set.
     */ CursorChangeReason[CursorChangeReason["NotSet"] = 0] = "NotSet";
    /**
     * A `model.setValue()` was called.
     */ CursorChangeReason[CursorChangeReason["ContentFlush"] = 1] = "ContentFlush";
    /**
     * The `model` has been changed outside of this cursor and the cursor recovers its position from associated markers.
     */ CursorChangeReason[CursorChangeReason["RecoverFromMarkers"] = 2] = "RecoverFromMarkers";
    /**
     * There was an explicit user gesture.
     */ CursorChangeReason[CursorChangeReason["Explicit"] = 3] = "Explicit";
    /**
     * There was a Paste.
     */ CursorChangeReason[CursorChangeReason["Paste"] = 4] = "Paste";
    /**
     * There was an Undo.
     */ CursorChangeReason[CursorChangeReason["Undo"] = 5] = "Undo";
    /**
     * There was a Redo.
     */ CursorChangeReason[CursorChangeReason["Redo"] = 6] = "Redo";
})(CursorChangeReason || (CursorChangeReason = {}));
var DefaultEndOfLine;
(function(DefaultEndOfLine) {
    /**
     * Use line feed (\n) as the end of line character.
     */ DefaultEndOfLine[DefaultEndOfLine["LF"] = 1] = "LF";
    /**
     * Use carriage return and line feed (\r\n) as the end of line character.
     */ DefaultEndOfLine[DefaultEndOfLine["CRLF"] = 2] = "CRLF";
})(DefaultEndOfLine || (DefaultEndOfLine = {}));
var DocumentHighlightKind;
(function(DocumentHighlightKind) {
    /**
     * A textual occurrence.
     */ DocumentHighlightKind[DocumentHighlightKind["Text"] = 0] = "Text";
    /**
     * Read-access of a symbol, like reading a variable.
     */ DocumentHighlightKind[DocumentHighlightKind["Read"] = 1] = "Read";
    /**
     * Write-access of a symbol, like writing to a variable.
     */ DocumentHighlightKind[DocumentHighlightKind["Write"] = 2] = "Write";
})(DocumentHighlightKind || (DocumentHighlightKind = {}));
var EditorAutoIndentStrategy;
(function(EditorAutoIndentStrategy) {
    EditorAutoIndentStrategy[EditorAutoIndentStrategy["None"] = 0] = "None";
    EditorAutoIndentStrategy[EditorAutoIndentStrategy["Keep"] = 1] = "Keep";
    EditorAutoIndentStrategy[EditorAutoIndentStrategy["Brackets"] = 2] = "Brackets";
    EditorAutoIndentStrategy[EditorAutoIndentStrategy["Advanced"] = 3] = "Advanced";
    EditorAutoIndentStrategy[EditorAutoIndentStrategy["Full"] = 4] = "Full";
})(EditorAutoIndentStrategy || (EditorAutoIndentStrategy = {}));
var EditorOption;
(function(EditorOption) {
    EditorOption[EditorOption["acceptSuggestionOnCommitCharacter"] = 0] = "acceptSuggestionOnCommitCharacter";
    EditorOption[EditorOption["acceptSuggestionOnEnter"] = 1] = "acceptSuggestionOnEnter";
    EditorOption[EditorOption["accessibilitySupport"] = 2] = "accessibilitySupport";
    EditorOption[EditorOption["accessibilityPageSize"] = 3] = "accessibilityPageSize";
    EditorOption[EditorOption["ariaLabel"] = 4] = "ariaLabel";
    EditorOption[EditorOption["ariaRequired"] = 5] = "ariaRequired";
    EditorOption[EditorOption["autoClosingBrackets"] = 6] = "autoClosingBrackets";
    EditorOption[EditorOption["autoClosingComments"] = 7] = "autoClosingComments";
    EditorOption[EditorOption["screenReaderAnnounceInlineSuggestion"] = 8] = "screenReaderAnnounceInlineSuggestion";
    EditorOption[EditorOption["autoClosingDelete"] = 9] = "autoClosingDelete";
    EditorOption[EditorOption["autoClosingOvertype"] = 10] = "autoClosingOvertype";
    EditorOption[EditorOption["autoClosingQuotes"] = 11] = "autoClosingQuotes";
    EditorOption[EditorOption["autoIndent"] = 12] = "autoIndent";
    EditorOption[EditorOption["automaticLayout"] = 13] = "automaticLayout";
    EditorOption[EditorOption["autoSurround"] = 14] = "autoSurround";
    EditorOption[EditorOption["bracketPairColorization"] = 15] = "bracketPairColorization";
    EditorOption[EditorOption["guides"] = 16] = "guides";
    EditorOption[EditorOption["codeLens"] = 17] = "codeLens";
    EditorOption[EditorOption["codeLensFontFamily"] = 18] = "codeLensFontFamily";
    EditorOption[EditorOption["codeLensFontSize"] = 19] = "codeLensFontSize";
    EditorOption[EditorOption["colorDecorators"] = 20] = "colorDecorators";
    EditorOption[EditorOption["colorDecoratorsLimit"] = 21] = "colorDecoratorsLimit";
    EditorOption[EditorOption["columnSelection"] = 22] = "columnSelection";
    EditorOption[EditorOption["comments"] = 23] = "comments";
    EditorOption[EditorOption["contextmenu"] = 24] = "contextmenu";
    EditorOption[EditorOption["copyWithSyntaxHighlighting"] = 25] = "copyWithSyntaxHighlighting";
    EditorOption[EditorOption["cursorBlinking"] = 26] = "cursorBlinking";
    EditorOption[EditorOption["cursorSmoothCaretAnimation"] = 27] = "cursorSmoothCaretAnimation";
    EditorOption[EditorOption["cursorStyle"] = 28] = "cursorStyle";
    EditorOption[EditorOption["cursorSurroundingLines"] = 29] = "cursorSurroundingLines";
    EditorOption[EditorOption["cursorSurroundingLinesStyle"] = 30] = "cursorSurroundingLinesStyle";
    EditorOption[EditorOption["cursorWidth"] = 31] = "cursorWidth";
    EditorOption[EditorOption["disableLayerHinting"] = 32] = "disableLayerHinting";
    EditorOption[EditorOption["disableMonospaceOptimizations"] = 33] = "disableMonospaceOptimizations";
    EditorOption[EditorOption["domReadOnly"] = 34] = "domReadOnly";
    EditorOption[EditorOption["dragAndDrop"] = 35] = "dragAndDrop";
    EditorOption[EditorOption["dropIntoEditor"] = 36] = "dropIntoEditor";
    EditorOption[EditorOption["emptySelectionClipboard"] = 37] = "emptySelectionClipboard";
    EditorOption[EditorOption["experimentalWhitespaceRendering"] = 38] = "experimentalWhitespaceRendering";
    EditorOption[EditorOption["extraEditorClassName"] = 39] = "extraEditorClassName";
    EditorOption[EditorOption["fastScrollSensitivity"] = 40] = "fastScrollSensitivity";
    EditorOption[EditorOption["find"] = 41] = "find";
    EditorOption[EditorOption["fixedOverflowWidgets"] = 42] = "fixedOverflowWidgets";
    EditorOption[EditorOption["folding"] = 43] = "folding";
    EditorOption[EditorOption["foldingStrategy"] = 44] = "foldingStrategy";
    EditorOption[EditorOption["foldingHighlight"] = 45] = "foldingHighlight";
    EditorOption[EditorOption["foldingImportsByDefault"] = 46] = "foldingImportsByDefault";
    EditorOption[EditorOption["foldingMaximumRegions"] = 47] = "foldingMaximumRegions";
    EditorOption[EditorOption["unfoldOnClickAfterEndOfLine"] = 48] = "unfoldOnClickAfterEndOfLine";
    EditorOption[EditorOption["fontFamily"] = 49] = "fontFamily";
    EditorOption[EditorOption["fontInfo"] = 50] = "fontInfo";
    EditorOption[EditorOption["fontLigatures"] = 51] = "fontLigatures";
    EditorOption[EditorOption["fontSize"] = 52] = "fontSize";
    EditorOption[EditorOption["fontWeight"] = 53] = "fontWeight";
    EditorOption[EditorOption["fontVariations"] = 54] = "fontVariations";
    EditorOption[EditorOption["formatOnPaste"] = 55] = "formatOnPaste";
    EditorOption[EditorOption["formatOnType"] = 56] = "formatOnType";
    EditorOption[EditorOption["glyphMargin"] = 57] = "glyphMargin";
    EditorOption[EditorOption["gotoLocation"] = 58] = "gotoLocation";
    EditorOption[EditorOption["hideCursorInOverviewRuler"] = 59] = "hideCursorInOverviewRuler";
    EditorOption[EditorOption["hover"] = 60] = "hover";
    EditorOption[EditorOption["inDiffEditor"] = 61] = "inDiffEditor";
    EditorOption[EditorOption["inlineSuggest"] = 62] = "inlineSuggest";
    EditorOption[EditorOption["inlineEdit"] = 63] = "inlineEdit";
    EditorOption[EditorOption["letterSpacing"] = 64] = "letterSpacing";
    EditorOption[EditorOption["lightbulb"] = 65] = "lightbulb";
    EditorOption[EditorOption["lineDecorationsWidth"] = 66] = "lineDecorationsWidth";
    EditorOption[EditorOption["lineHeight"] = 67] = "lineHeight";
    EditorOption[EditorOption["lineNumbers"] = 68] = "lineNumbers";
    EditorOption[EditorOption["lineNumbersMinChars"] = 69] = "lineNumbersMinChars";
    EditorOption[EditorOption["linkedEditing"] = 70] = "linkedEditing";
    EditorOption[EditorOption["links"] = 71] = "links";
    EditorOption[EditorOption["matchBrackets"] = 72] = "matchBrackets";
    EditorOption[EditorOption["minimap"] = 73] = "minimap";
    EditorOption[EditorOption["mouseStyle"] = 74] = "mouseStyle";
    EditorOption[EditorOption["mouseWheelScrollSensitivity"] = 75] = "mouseWheelScrollSensitivity";
    EditorOption[EditorOption["mouseWheelZoom"] = 76] = "mouseWheelZoom";
    EditorOption[EditorOption["multiCursorMergeOverlapping"] = 77] = "multiCursorMergeOverlapping";
    EditorOption[EditorOption["multiCursorModifier"] = 78] = "multiCursorModifier";
    EditorOption[EditorOption["multiCursorPaste"] = 79] = "multiCursorPaste";
    EditorOption[EditorOption["multiCursorLimit"] = 80] = "multiCursorLimit";
    EditorOption[EditorOption["occurrencesHighlight"] = 81] = "occurrencesHighlight";
    EditorOption[EditorOption["overviewRulerBorder"] = 82] = "overviewRulerBorder";
    EditorOption[EditorOption["overviewRulerLanes"] = 83] = "overviewRulerLanes";
    EditorOption[EditorOption["padding"] = 84] = "padding";
    EditorOption[EditorOption["pasteAs"] = 85] = "pasteAs";
    EditorOption[EditorOption["parameterHints"] = 86] = "parameterHints";
    EditorOption[EditorOption["peekWidgetDefaultFocus"] = 87] = "peekWidgetDefaultFocus";
    EditorOption[EditorOption["placeholder"] = 88] = "placeholder";
    EditorOption[EditorOption["definitionLinkOpensInPeek"] = 89] = "definitionLinkOpensInPeek";
    EditorOption[EditorOption["quickSuggestions"] = 90] = "quickSuggestions";
    EditorOption[EditorOption["quickSuggestionsDelay"] = 91] = "quickSuggestionsDelay";
    EditorOption[EditorOption["readOnly"] = 92] = "readOnly";
    EditorOption[EditorOption["readOnlyMessage"] = 93] = "readOnlyMessage";
    EditorOption[EditorOption["renameOnType"] = 94] = "renameOnType";
    EditorOption[EditorOption["renderControlCharacters"] = 95] = "renderControlCharacters";
    EditorOption[EditorOption["renderFinalNewline"] = 96] = "renderFinalNewline";
    EditorOption[EditorOption["renderLineHighlight"] = 97] = "renderLineHighlight";
    EditorOption[EditorOption["renderLineHighlightOnlyWhenFocus"] = 98] = "renderLineHighlightOnlyWhenFocus";
    EditorOption[EditorOption["renderValidationDecorations"] = 99] = "renderValidationDecorations";
    EditorOption[EditorOption["renderWhitespace"] = 100] = "renderWhitespace";
    EditorOption[EditorOption["revealHorizontalRightPadding"] = 101] = "revealHorizontalRightPadding";
    EditorOption[EditorOption["roundedSelection"] = 102] = "roundedSelection";
    EditorOption[EditorOption["rulers"] = 103] = "rulers";
    EditorOption[EditorOption["scrollbar"] = 104] = "scrollbar";
    EditorOption[EditorOption["scrollBeyondLastColumn"] = 105] = "scrollBeyondLastColumn";
    EditorOption[EditorOption["scrollBeyondLastLine"] = 106] = "scrollBeyondLastLine";
    EditorOption[EditorOption["scrollPredominantAxis"] = 107] = "scrollPredominantAxis";
    EditorOption[EditorOption["selectionClipboard"] = 108] = "selectionClipboard";
    EditorOption[EditorOption["selectionHighlight"] = 109] = "selectionHighlight";
    EditorOption[EditorOption["selectOnLineNumbers"] = 110] = "selectOnLineNumbers";
    EditorOption[EditorOption["showFoldingControls"] = 111] = "showFoldingControls";
    EditorOption[EditorOption["showUnused"] = 112] = "showUnused";
    EditorOption[EditorOption["snippetSuggestions"] = 113] = "snippetSuggestions";
    EditorOption[EditorOption["smartSelect"] = 114] = "smartSelect";
    EditorOption[EditorOption["smoothScrolling"] = 115] = "smoothScrolling";
    EditorOption[EditorOption["stickyScroll"] = 116] = "stickyScroll";
    EditorOption[EditorOption["stickyTabStops"] = 117] = "stickyTabStops";
    EditorOption[EditorOption["stopRenderingLineAfter"] = 118] = "stopRenderingLineAfter";
    EditorOption[EditorOption["suggest"] = 119] = "suggest";
    EditorOption[EditorOption["suggestFontSize"] = 120] = "suggestFontSize";
    EditorOption[EditorOption["suggestLineHeight"] = 121] = "suggestLineHeight";
    EditorOption[EditorOption["suggestOnTriggerCharacters"] = 122] = "suggestOnTriggerCharacters";
    EditorOption[EditorOption["suggestSelection"] = 123] = "suggestSelection";
    EditorOption[EditorOption["tabCompletion"] = 124] = "tabCompletion";
    EditorOption[EditorOption["tabIndex"] = 125] = "tabIndex";
    EditorOption[EditorOption["unicodeHighlighting"] = 126] = "unicodeHighlighting";
    EditorOption[EditorOption["unusualLineTerminators"] = 127] = "unusualLineTerminators";
    EditorOption[EditorOption["useShadowDOM"] = 128] = "useShadowDOM";
    EditorOption[EditorOption["useTabStops"] = 129] = "useTabStops";
    EditorOption[EditorOption["wordBreak"] = 130] = "wordBreak";
    EditorOption[EditorOption["wordSegmenterLocales"] = 131] = "wordSegmenterLocales";
    EditorOption[EditorOption["wordSeparators"] = 132] = "wordSeparators";
    EditorOption[EditorOption["wordWrap"] = 133] = "wordWrap";
    EditorOption[EditorOption["wordWrapBreakAfterCharacters"] = 134] = "wordWrapBreakAfterCharacters";
    EditorOption[EditorOption["wordWrapBreakBeforeCharacters"] = 135] = "wordWrapBreakBeforeCharacters";
    EditorOption[EditorOption["wordWrapColumn"] = 136] = "wordWrapColumn";
    EditorOption[EditorOption["wordWrapOverride1"] = 137] = "wordWrapOverride1";
    EditorOption[EditorOption["wordWrapOverride2"] = 138] = "wordWrapOverride2";
    EditorOption[EditorOption["wrappingIndent"] = 139] = "wrappingIndent";
    EditorOption[EditorOption["wrappingStrategy"] = 140] = "wrappingStrategy";
    EditorOption[EditorOption["showDeprecated"] = 141] = "showDeprecated";
    EditorOption[EditorOption["inlayHints"] = 142] = "inlayHints";
    EditorOption[EditorOption["editorClassName"] = 143] = "editorClassName";
    EditorOption[EditorOption["pixelRatio"] = 144] = "pixelRatio";
    EditorOption[EditorOption["tabFocusMode"] = 145] = "tabFocusMode";
    EditorOption[EditorOption["layoutInfo"] = 146] = "layoutInfo";
    EditorOption[EditorOption["wrappingInfo"] = 147] = "wrappingInfo";
    EditorOption[EditorOption["defaultColorDecorators"] = 148] = "defaultColorDecorators";
    EditorOption[EditorOption["colorDecoratorsActivatedOn"] = 149] = "colorDecoratorsActivatedOn";
    EditorOption[EditorOption["inlineCompletionsAccessibilityVerbose"] = 150] = "inlineCompletionsAccessibilityVerbose";
})(EditorOption || (EditorOption = {}));
var EndOfLinePreference;
(function(EndOfLinePreference) {
    /**
     * Use the end of line character identified in the text buffer.
     */ EndOfLinePreference[EndOfLinePreference["TextDefined"] = 0] = "TextDefined";
    /**
     * Use line feed (\n) as the end of line character.
     */ EndOfLinePreference[EndOfLinePreference["LF"] = 1] = "LF";
    /**
     * Use carriage return and line feed (\r\n) as the end of line character.
     */ EndOfLinePreference[EndOfLinePreference["CRLF"] = 2] = "CRLF";
})(EndOfLinePreference || (EndOfLinePreference = {}));
var EndOfLineSequence;
(function(EndOfLineSequence) {
    /**
     * Use line feed (\n) as the end of line character.
     */ EndOfLineSequence[EndOfLineSequence["LF"] = 0] = "LF";
    /**
     * Use carriage return and line feed (\r\n) as the end of line character.
     */ EndOfLineSequence[EndOfLineSequence["CRLF"] = 1] = "CRLF";
})(EndOfLineSequence || (EndOfLineSequence = {}));
var GlyphMarginLane;
(function(GlyphMarginLane) {
    GlyphMarginLane[GlyphMarginLane["Left"] = 1] = "Left";
    GlyphMarginLane[GlyphMarginLane["Center"] = 2] = "Center";
    GlyphMarginLane[GlyphMarginLane["Right"] = 3] = "Right";
})(GlyphMarginLane || (GlyphMarginLane = {}));
var HoverVerbosityAction;
(function(HoverVerbosityAction) {
    /**
     * Increase the verbosity of the hover
     */ HoverVerbosityAction[HoverVerbosityAction["Increase"] = 0] = "Increase";
    /**
     * Decrease the verbosity of the hover
     */ HoverVerbosityAction[HoverVerbosityAction["Decrease"] = 1] = "Decrease";
})(HoverVerbosityAction || (HoverVerbosityAction = {}));
var IndentAction;
(function(IndentAction) {
    /**
     * Insert new line and copy the previous line's indentation.
     */ IndentAction[IndentAction["None"] = 0] = "None";
    /**
     * Insert new line and indent once (relative to the previous line's indentation).
     */ IndentAction[IndentAction["Indent"] = 1] = "Indent";
    /**
     * Insert two new lines:
     *  - the first one indented which will hold the cursor
     *  - the second one at the same indentation level
     */ IndentAction[IndentAction["IndentOutdent"] = 2] = "IndentOutdent";
    /**
     * Insert new line and outdent once (relative to the previous line's indentation).
     */ IndentAction[IndentAction["Outdent"] = 3] = "Outdent";
})(IndentAction || (IndentAction = {}));
var InjectedTextCursorStops;
(function(InjectedTextCursorStops) {
    InjectedTextCursorStops[InjectedTextCursorStops["Both"] = 0] = "Both";
    InjectedTextCursorStops[InjectedTextCursorStops["Right"] = 1] = "Right";
    InjectedTextCursorStops[InjectedTextCursorStops["Left"] = 2] = "Left";
    InjectedTextCursorStops[InjectedTextCursorStops["None"] = 3] = "None";
})(InjectedTextCursorStops || (InjectedTextCursorStops = {}));
var InlayHintKind;
(function(InlayHintKind) {
    InlayHintKind[InlayHintKind["Type"] = 1] = "Type";
    InlayHintKind[InlayHintKind["Parameter"] = 2] = "Parameter";
})(InlayHintKind || (InlayHintKind = {}));
var InlineCompletionTriggerKind;
(function(InlineCompletionTriggerKind) {
    /**
     * Completion was triggered automatically while editing.
     * It is sufficient to return a single completion item in this case.
     */ InlineCompletionTriggerKind[InlineCompletionTriggerKind["Automatic"] = 0] = "Automatic";
    /**
     * Completion was triggered explicitly by a user gesture.
     * Return multiple completion items to enable cycling through them.
     */ InlineCompletionTriggerKind[InlineCompletionTriggerKind["Explicit"] = 1] = "Explicit";
})(InlineCompletionTriggerKind || (InlineCompletionTriggerKind = {}));
var InlineEditTriggerKind;
(function(InlineEditTriggerKind) {
    InlineEditTriggerKind[InlineEditTriggerKind["Invoke"] = 0] = "Invoke";
    InlineEditTriggerKind[InlineEditTriggerKind["Automatic"] = 1] = "Automatic";
})(InlineEditTriggerKind || (InlineEditTriggerKind = {}));
var KeyCode;
(function(KeyCode) {
    KeyCode[KeyCode["DependsOnKbLayout"] = -1] = "DependsOnKbLayout";
    /**
     * Placed first to cover the 0 value of the enum.
     */ KeyCode[KeyCode["Unknown"] = 0] = "Unknown";
    KeyCode[KeyCode["Backspace"] = 1] = "Backspace";
    KeyCode[KeyCode["Tab"] = 2] = "Tab";
    KeyCode[KeyCode["Enter"] = 3] = "Enter";
    KeyCode[KeyCode["Shift"] = 4] = "Shift";
    KeyCode[KeyCode["Ctrl"] = 5] = "Ctrl";
    KeyCode[KeyCode["Alt"] = 6] = "Alt";
    KeyCode[KeyCode["PauseBreak"] = 7] = "PauseBreak";
    KeyCode[KeyCode["CapsLock"] = 8] = "CapsLock";
    KeyCode[KeyCode["Escape"] = 9] = "Escape";
    KeyCode[KeyCode["Space"] = 10] = "Space";
    KeyCode[KeyCode["PageUp"] = 11] = "PageUp";
    KeyCode[KeyCode["PageDown"] = 12] = "PageDown";
    KeyCode[KeyCode["End"] = 13] = "End";
    KeyCode[KeyCode["Home"] = 14] = "Home";
    KeyCode[KeyCode["LeftArrow"] = 15] = "LeftArrow";
    KeyCode[KeyCode["UpArrow"] = 16] = "UpArrow";
    KeyCode[KeyCode["RightArrow"] = 17] = "RightArrow";
    KeyCode[KeyCode["DownArrow"] = 18] = "DownArrow";
    KeyCode[KeyCode["Insert"] = 19] = "Insert";
    KeyCode[KeyCode["Delete"] = 20] = "Delete";
    KeyCode[KeyCode["Digit0"] = 21] = "Digit0";
    KeyCode[KeyCode["Digit1"] = 22] = "Digit1";
    KeyCode[KeyCode["Digit2"] = 23] = "Digit2";
    KeyCode[KeyCode["Digit3"] = 24] = "Digit3";
    KeyCode[KeyCode["Digit4"] = 25] = "Digit4";
    KeyCode[KeyCode["Digit5"] = 26] = "Digit5";
    KeyCode[KeyCode["Digit6"] = 27] = "Digit6";
    KeyCode[KeyCode["Digit7"] = 28] = "Digit7";
    KeyCode[KeyCode["Digit8"] = 29] = "Digit8";
    KeyCode[KeyCode["Digit9"] = 30] = "Digit9";
    KeyCode[KeyCode["KeyA"] = 31] = "KeyA";
    KeyCode[KeyCode["KeyB"] = 32] = "KeyB";
    KeyCode[KeyCode["KeyC"] = 33] = "KeyC";
    KeyCode[KeyCode["KeyD"] = 34] = "KeyD";
    KeyCode[KeyCode["KeyE"] = 35] = "KeyE";
    KeyCode[KeyCode["KeyF"] = 36] = "KeyF";
    KeyCode[KeyCode["KeyG"] = 37] = "KeyG";
    KeyCode[KeyCode["KeyH"] = 38] = "KeyH";
    KeyCode[KeyCode["KeyI"] = 39] = "KeyI";
    KeyCode[KeyCode["KeyJ"] = 40] = "KeyJ";
    KeyCode[KeyCode["KeyK"] = 41] = "KeyK";
    KeyCode[KeyCode["KeyL"] = 42] = "KeyL";
    KeyCode[KeyCode["KeyM"] = 43] = "KeyM";
    KeyCode[KeyCode["KeyN"] = 44] = "KeyN";
    KeyCode[KeyCode["KeyO"] = 45] = "KeyO";
    KeyCode[KeyCode["KeyP"] = 46] = "KeyP";
    KeyCode[KeyCode["KeyQ"] = 47] = "KeyQ";
    KeyCode[KeyCode["KeyR"] = 48] = "KeyR";
    KeyCode[KeyCode["KeyS"] = 49] = "KeyS";
    KeyCode[KeyCode["KeyT"] = 50] = "KeyT";
    KeyCode[KeyCode["KeyU"] = 51] = "KeyU";
    KeyCode[KeyCode["KeyV"] = 52] = "KeyV";
    KeyCode[KeyCode["KeyW"] = 53] = "KeyW";
    KeyCode[KeyCode["KeyX"] = 54] = "KeyX";
    KeyCode[KeyCode["KeyY"] = 55] = "KeyY";
    KeyCode[KeyCode["KeyZ"] = 56] = "KeyZ";
    KeyCode[KeyCode["Meta"] = 57] = "Meta";
    KeyCode[KeyCode["ContextMenu"] = 58] = "ContextMenu";
    KeyCode[KeyCode["F1"] = 59] = "F1";
    KeyCode[KeyCode["F2"] = 60] = "F2";
    KeyCode[KeyCode["F3"] = 61] = "F3";
    KeyCode[KeyCode["F4"] = 62] = "F4";
    KeyCode[KeyCode["F5"] = 63] = "F5";
    KeyCode[KeyCode["F6"] = 64] = "F6";
    KeyCode[KeyCode["F7"] = 65] = "F7";
    KeyCode[KeyCode["F8"] = 66] = "F8";
    KeyCode[KeyCode["F9"] = 67] = "F9";
    KeyCode[KeyCode["F10"] = 68] = "F10";
    KeyCode[KeyCode["F11"] = 69] = "F11";
    KeyCode[KeyCode["F12"] = 70] = "F12";
    KeyCode[KeyCode["F13"] = 71] = "F13";
    KeyCode[KeyCode["F14"] = 72] = "F14";
    KeyCode[KeyCode["F15"] = 73] = "F15";
    KeyCode[KeyCode["F16"] = 74] = "F16";
    KeyCode[KeyCode["F17"] = 75] = "F17";
    KeyCode[KeyCode["F18"] = 76] = "F18";
    KeyCode[KeyCode["F19"] = 77] = "F19";
    KeyCode[KeyCode["F20"] = 78] = "F20";
    KeyCode[KeyCode["F21"] = 79] = "F21";
    KeyCode[KeyCode["F22"] = 80] = "F22";
    KeyCode[KeyCode["F23"] = 81] = "F23";
    KeyCode[KeyCode["F24"] = 82] = "F24";
    KeyCode[KeyCode["NumLock"] = 83] = "NumLock";
    KeyCode[KeyCode["ScrollLock"] = 84] = "ScrollLock";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the ';:' key
     */ KeyCode[KeyCode["Semicolon"] = 85] = "Semicolon";
    /**
     * For any country/region, the '+' key
     * For the US standard keyboard, the '=+' key
     */ KeyCode[KeyCode["Equal"] = 86] = "Equal";
    /**
     * For any country/region, the ',' key
     * For the US standard keyboard, the ',<' key
     */ KeyCode[KeyCode["Comma"] = 87] = "Comma";
    /**
     * For any country/region, the '-' key
     * For the US standard keyboard, the '-_' key
     */ KeyCode[KeyCode["Minus"] = 88] = "Minus";
    /**
     * For any country/region, the '.' key
     * For the US standard keyboard, the '.>' key
     */ KeyCode[KeyCode["Period"] = 89] = "Period";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the '/?' key
     */ KeyCode[KeyCode["Slash"] = 90] = "Slash";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the '`~' key
     */ KeyCode[KeyCode["Backquote"] = 91] = "Backquote";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the '[{' key
     */ KeyCode[KeyCode["BracketLeft"] = 92] = "BracketLeft";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the '\|' key
     */ KeyCode[KeyCode["Backslash"] = 93] = "Backslash";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the ']}' key
     */ KeyCode[KeyCode["BracketRight"] = 94] = "BracketRight";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     * For the US standard keyboard, the ''"' key
     */ KeyCode[KeyCode["Quote"] = 95] = "Quote";
    /**
     * Used for miscellaneous characters; it can vary by keyboard.
     */ KeyCode[KeyCode["OEM_8"] = 96] = "OEM_8";
    /**
     * Either the angle bracket key or the backslash key on the RT 102-key keyboard.
     */ KeyCode[KeyCode["IntlBackslash"] = 97] = "IntlBackslash";
    KeyCode[KeyCode["Numpad0"] = 98] = "Numpad0";
    KeyCode[KeyCode["Numpad1"] = 99] = "Numpad1";
    KeyCode[KeyCode["Numpad2"] = 100] = "Numpad2";
    KeyCode[KeyCode["Numpad3"] = 101] = "Numpad3";
    KeyCode[KeyCode["Numpad4"] = 102] = "Numpad4";
    KeyCode[KeyCode["Numpad5"] = 103] = "Numpad5";
    KeyCode[KeyCode["Numpad6"] = 104] = "Numpad6";
    KeyCode[KeyCode["Numpad7"] = 105] = "Numpad7";
    KeyCode[KeyCode["Numpad8"] = 106] = "Numpad8";
    KeyCode[KeyCode["Numpad9"] = 107] = "Numpad9";
    KeyCode[KeyCode["NumpadMultiply"] = 108] = "NumpadMultiply";
    KeyCode[KeyCode["NumpadAdd"] = 109] = "NumpadAdd";
    KeyCode[KeyCode["NUMPAD_SEPARATOR"] = 110] = "NUMPAD_SEPARATOR";
    KeyCode[KeyCode["NumpadSubtract"] = 111] = "NumpadSubtract";
    KeyCode[KeyCode["NumpadDecimal"] = 112] = "NumpadDecimal";
    KeyCode[KeyCode["NumpadDivide"] = 113] = "NumpadDivide";
    /**
     * Cover all key codes when IME is processing input.
     */ KeyCode[KeyCode["KEY_IN_COMPOSITION"] = 114] = "KEY_IN_COMPOSITION";
    KeyCode[KeyCode["ABNT_C1"] = 115] = "ABNT_C1";
    KeyCode[KeyCode["ABNT_C2"] = 116] = "ABNT_C2";
    KeyCode[KeyCode["AudioVolumeMute"] = 117] = "AudioVolumeMute";
    KeyCode[KeyCode["AudioVolumeUp"] = 118] = "AudioVolumeUp";
    KeyCode[KeyCode["AudioVolumeDown"] = 119] = "AudioVolumeDown";
    KeyCode[KeyCode["BrowserSearch"] = 120] = "BrowserSearch";
    KeyCode[KeyCode["BrowserHome"] = 121] = "BrowserHome";
    KeyCode[KeyCode["BrowserBack"] = 122] = "BrowserBack";
    KeyCode[KeyCode["BrowserForward"] = 123] = "BrowserForward";
    KeyCode[KeyCode["MediaTrackNext"] = 124] = "MediaTrackNext";
    KeyCode[KeyCode["MediaTrackPrevious"] = 125] = "MediaTrackPrevious";
    KeyCode[KeyCode["MediaStop"] = 126] = "MediaStop";
    KeyCode[KeyCode["MediaPlayPause"] = 127] = "MediaPlayPause";
    KeyCode[KeyCode["LaunchMediaPlayer"] = 128] = "LaunchMediaPlayer";
    KeyCode[KeyCode["LaunchMail"] = 129] = "LaunchMail";
    KeyCode[KeyCode["LaunchApp2"] = 130] = "LaunchApp2";
    /**
     * VK_CLEAR, 0x0C, CLEAR key
     */ KeyCode[KeyCode["Clear"] = 131] = "Clear";
    /**
     * Placed last to cover the length of the enum.
     * Please do not depend on this value!
     */ KeyCode[KeyCode["MAX_VALUE"] = 132] = "MAX_VALUE";
})(KeyCode || (KeyCode = {}));
var MarkerSeverity;
(function(MarkerSeverity) {
    MarkerSeverity[MarkerSeverity["Hint"] = 1] = "Hint";
    MarkerSeverity[MarkerSeverity["Info"] = 2] = "Info";
    MarkerSeverity[MarkerSeverity["Warning"] = 4] = "Warning";
    MarkerSeverity[MarkerSeverity["Error"] = 8] = "Error";
})(MarkerSeverity || (MarkerSeverity = {}));
var MarkerTag;
(function(MarkerTag) {
    MarkerTag[MarkerTag["Unnecessary"] = 1] = "Unnecessary";
    MarkerTag[MarkerTag["Deprecated"] = 2] = "Deprecated";
})(MarkerTag || (MarkerTag = {}));
var MinimapPosition;
(function(MinimapPosition) {
    MinimapPosition[MinimapPosition["Inline"] = 1] = "Inline";
    MinimapPosition[MinimapPosition["Gutter"] = 2] = "Gutter";
})(MinimapPosition || (MinimapPosition = {}));
var MinimapSectionHeaderStyle;
(function(MinimapSectionHeaderStyle) {
    MinimapSectionHeaderStyle[MinimapSectionHeaderStyle["Normal"] = 1] = "Normal";
    MinimapSectionHeaderStyle[MinimapSectionHeaderStyle["Underlined"] = 2] = "Underlined";
})(MinimapSectionHeaderStyle || (MinimapSectionHeaderStyle = {}));
var MouseTargetType;
(function(MouseTargetType) {
    /**
     * Mouse is on top of an unknown element.
     */ MouseTargetType[MouseTargetType["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Mouse is on top of the textarea used for input.
     */ MouseTargetType[MouseTargetType["TEXTAREA"] = 1] = "TEXTAREA";
    /**
     * Mouse is on top of the glyph margin
     */ MouseTargetType[MouseTargetType["GUTTER_GLYPH_MARGIN"] = 2] = "GUTTER_GLYPH_MARGIN";
    /**
     * Mouse is on top of the line numbers
     */ MouseTargetType[MouseTargetType["GUTTER_LINE_NUMBERS"] = 3] = "GUTTER_LINE_NUMBERS";
    /**
     * Mouse is on top of the line decorations
     */ MouseTargetType[MouseTargetType["GUTTER_LINE_DECORATIONS"] = 4] = "GUTTER_LINE_DECORATIONS";
    /**
     * Mouse is on top of the whitespace left in the gutter by a view zone.
     */ MouseTargetType[MouseTargetType["GUTTER_VIEW_ZONE"] = 5] = "GUTTER_VIEW_ZONE";
    /**
     * Mouse is on top of text in the content.
     */ MouseTargetType[MouseTargetType["CONTENT_TEXT"] = 6] = "CONTENT_TEXT";
    /**
     * Mouse is on top of empty space in the content (e.g. after line text or below last line)
     */ MouseTargetType[MouseTargetType["CONTENT_EMPTY"] = 7] = "CONTENT_EMPTY";
    /**
     * Mouse is on top of a view zone in the content.
     */ MouseTargetType[MouseTargetType["CONTENT_VIEW_ZONE"] = 8] = "CONTENT_VIEW_ZONE";
    /**
     * Mouse is on top of a content widget.
     */ MouseTargetType[MouseTargetType["CONTENT_WIDGET"] = 9] = "CONTENT_WIDGET";
    /**
     * Mouse is on top of the decorations overview ruler.
     */ MouseTargetType[MouseTargetType["OVERVIEW_RULER"] = 10] = "OVERVIEW_RULER";
    /**
     * Mouse is on top of a scrollbar.
     */ MouseTargetType[MouseTargetType["SCROLLBAR"] = 11] = "SCROLLBAR";
    /**
     * Mouse is on top of an overlay widget.
     */ MouseTargetType[MouseTargetType["OVERLAY_WIDGET"] = 12] = "OVERLAY_WIDGET";
    /**
     * Mouse is outside of the editor.
     */ MouseTargetType[MouseTargetType["OUTSIDE_EDITOR"] = 13] = "OUTSIDE_EDITOR";
})(MouseTargetType || (MouseTargetType = {}));
var NewSymbolNameTag;
(function(NewSymbolNameTag) {
    NewSymbolNameTag[NewSymbolNameTag["AIGenerated"] = 1] = "AIGenerated";
})(NewSymbolNameTag || (NewSymbolNameTag = {}));
var NewSymbolNameTriggerKind;
(function(NewSymbolNameTriggerKind) {
    NewSymbolNameTriggerKind[NewSymbolNameTriggerKind["Invoke"] = 0] = "Invoke";
    NewSymbolNameTriggerKind[NewSymbolNameTriggerKind["Automatic"] = 1] = "Automatic";
})(NewSymbolNameTriggerKind || (NewSymbolNameTriggerKind = {}));
var OverlayWidgetPositionPreference;
(function(OverlayWidgetPositionPreference) {
    /**
     * Position the overlay widget in the top right corner
     */ OverlayWidgetPositionPreference[OverlayWidgetPositionPreference["TOP_RIGHT_CORNER"] = 0] = "TOP_RIGHT_CORNER";
    /**
     * Position the overlay widget in the bottom right corner
     */ OverlayWidgetPositionPreference[OverlayWidgetPositionPreference["BOTTOM_RIGHT_CORNER"] = 1] = "BOTTOM_RIGHT_CORNER";
    /**
     * Position the overlay widget in the top center
     */ OverlayWidgetPositionPreference[OverlayWidgetPositionPreference["TOP_CENTER"] = 2] = "TOP_CENTER";
})(OverlayWidgetPositionPreference || (OverlayWidgetPositionPreference = {}));
var OverviewRulerLane;
(function(OverviewRulerLane) {
    OverviewRulerLane[OverviewRulerLane["Left"] = 1] = "Left";
    OverviewRulerLane[OverviewRulerLane["Center"] = 2] = "Center";
    OverviewRulerLane[OverviewRulerLane["Right"] = 4] = "Right";
    OverviewRulerLane[OverviewRulerLane["Full"] = 7] = "Full";
})(OverviewRulerLane || (OverviewRulerLane = {}));
var PartialAcceptTriggerKind;
(function(PartialAcceptTriggerKind) {
    PartialAcceptTriggerKind[PartialAcceptTriggerKind["Word"] = 0] = "Word";
    PartialAcceptTriggerKind[PartialAcceptTriggerKind["Line"] = 1] = "Line";
    PartialAcceptTriggerKind[PartialAcceptTriggerKind["Suggest"] = 2] = "Suggest";
})(PartialAcceptTriggerKind || (PartialAcceptTriggerKind = {}));
var PositionAffinity;
(function(PositionAffinity) {
    /**
     * Prefers the left most position.
    */ PositionAffinity[PositionAffinity["Left"] = 0] = "Left";
    /**
     * Prefers the right most position.
    */ PositionAffinity[PositionAffinity["Right"] = 1] = "Right";
    /**
     * No preference.
    */ PositionAffinity[PositionAffinity["None"] = 2] = "None";
    /**
     * If the given position is on injected text, prefers the position left of it.
    */ PositionAffinity[PositionAffinity["LeftOfInjectedText"] = 3] = "LeftOfInjectedText";
    /**
     * If the given position is on injected text, prefers the position right of it.
    */ PositionAffinity[PositionAffinity["RightOfInjectedText"] = 4] = "RightOfInjectedText";
})(PositionAffinity || (PositionAffinity = {}));
var RenderLineNumbersType;
(function(RenderLineNumbersType) {
    RenderLineNumbersType[RenderLineNumbersType["Off"] = 0] = "Off";
    RenderLineNumbersType[RenderLineNumbersType["On"] = 1] = "On";
    RenderLineNumbersType[RenderLineNumbersType["Relative"] = 2] = "Relative";
    RenderLineNumbersType[RenderLineNumbersType["Interval"] = 3] = "Interval";
    RenderLineNumbersType[RenderLineNumbersType["Custom"] = 4] = "Custom";
})(RenderLineNumbersType || (RenderLineNumbersType = {}));
var RenderMinimap;
(function(RenderMinimap) {
    RenderMinimap[RenderMinimap["None"] = 0] = "None";
    RenderMinimap[RenderMinimap["Text"] = 1] = "Text";
    RenderMinimap[RenderMinimap["Blocks"] = 2] = "Blocks";
})(RenderMinimap || (RenderMinimap = {}));
var ScrollType;
(function(ScrollType) {
    ScrollType[ScrollType["Smooth"] = 0] = "Smooth";
    ScrollType[ScrollType["Immediate"] = 1] = "Immediate";
})(ScrollType || (ScrollType = {}));
var ScrollbarVisibility;
(function(ScrollbarVisibility) {
    ScrollbarVisibility[ScrollbarVisibility["Auto"] = 1] = "Auto";
    ScrollbarVisibility[ScrollbarVisibility["Hidden"] = 2] = "Hidden";
    ScrollbarVisibility[ScrollbarVisibility["Visible"] = 3] = "Visible";
})(ScrollbarVisibility || (ScrollbarVisibility = {}));
var SelectionDirection;
(function(SelectionDirection) {
    /**
     * The selection starts above where it ends.
     */ SelectionDirection[SelectionDirection["LTR"] = 0] = "LTR";
    /**
     * The selection starts below where it ends.
     */ SelectionDirection[SelectionDirection["RTL"] = 1] = "RTL";
})(SelectionDirection || (SelectionDirection = {}));
var ShowLightbulbIconMode;
(function(ShowLightbulbIconMode) {
    ShowLightbulbIconMode["Off"] = "off";
    ShowLightbulbIconMode["OnCode"] = "onCode";
    ShowLightbulbIconMode["On"] = "on";
})(ShowLightbulbIconMode || (ShowLightbulbIconMode = {}));
var SignatureHelpTriggerKind;
(function(SignatureHelpTriggerKind) {
    SignatureHelpTriggerKind[SignatureHelpTriggerKind["Invoke"] = 1] = "Invoke";
    SignatureHelpTriggerKind[SignatureHelpTriggerKind["TriggerCharacter"] = 2] = "TriggerCharacter";
    SignatureHelpTriggerKind[SignatureHelpTriggerKind["ContentChange"] = 3] = "ContentChange";
})(SignatureHelpTriggerKind || (SignatureHelpTriggerKind = {}));
var SymbolKind;
(function(SymbolKind) {
    SymbolKind[SymbolKind["File"] = 0] = "File";
    SymbolKind[SymbolKind["Module"] = 1] = "Module";
    SymbolKind[SymbolKind["Namespace"] = 2] = "Namespace";
    SymbolKind[SymbolKind["Package"] = 3] = "Package";
    SymbolKind[SymbolKind["Class"] = 4] = "Class";
    SymbolKind[SymbolKind["Method"] = 5] = "Method";
    SymbolKind[SymbolKind["Property"] = 6] = "Property";
    SymbolKind[SymbolKind["Field"] = 7] = "Field";
    SymbolKind[SymbolKind["Constructor"] = 8] = "Constructor";
    SymbolKind[SymbolKind["Enum"] = 9] = "Enum";
    SymbolKind[SymbolKind["Interface"] = 10] = "Interface";
    SymbolKind[SymbolKind["Function"] = 11] = "Function";
    SymbolKind[SymbolKind["Variable"] = 12] = "Variable";
    SymbolKind[SymbolKind["Constant"] = 13] = "Constant";
    SymbolKind[SymbolKind["String"] = 14] = "String";
    SymbolKind[SymbolKind["Number"] = 15] = "Number";
    SymbolKind[SymbolKind["Boolean"] = 16] = "Boolean";
    SymbolKind[SymbolKind["Array"] = 17] = "Array";
    SymbolKind[SymbolKind["Object"] = 18] = "Object";
    SymbolKind[SymbolKind["Key"] = 19] = "Key";
    SymbolKind[SymbolKind["Null"] = 20] = "Null";
    SymbolKind[SymbolKind["EnumMember"] = 21] = "EnumMember";
    SymbolKind[SymbolKind["Struct"] = 22] = "Struct";
    SymbolKind[SymbolKind["Event"] = 23] = "Event";
    SymbolKind[SymbolKind["Operator"] = 24] = "Operator";
    SymbolKind[SymbolKind["TypeParameter"] = 25] = "TypeParameter";
})(SymbolKind || (SymbolKind = {}));
var SymbolTag;
(function(SymbolTag) {
    SymbolTag[SymbolTag["Deprecated"] = 1] = "Deprecated";
})(SymbolTag || (SymbolTag = {}));
var TextEditorCursorBlinkingStyle;
(function(TextEditorCursorBlinkingStyle) {
    /**
     * Hidden
     */ TextEditorCursorBlinkingStyle[TextEditorCursorBlinkingStyle["Hidden"] = 0] = "Hidden";
    /**
     * Blinking
     */ TextEditorCursorBlinkingStyle[TextEditorCursorBlinkingStyle["Blink"] = 1] = "Blink";
    /**
     * Blinking with smooth fading
     */ TextEditorCursorBlinkingStyle[TextEditorCursorBlinkingStyle["Smooth"] = 2] = "Smooth";
    /**
     * Blinking with prolonged filled state and smooth fading
     */ TextEditorCursorBlinkingStyle[TextEditorCursorBlinkingStyle["Phase"] = 3] = "Phase";
    /**
     * Expand collapse animation on the y axis
     */ TextEditorCursorBlinkingStyle[TextEditorCursorBlinkingStyle["Expand"] = 4] = "Expand";
    /**
     * No-Blinking
     */ TextEditorCursorBlinkingStyle[TextEditorCursorBlinkingStyle["Solid"] = 5] = "Solid";
})(TextEditorCursorBlinkingStyle || (TextEditorCursorBlinkingStyle = {}));
var TextEditorCursorStyle;
(function(TextEditorCursorStyle) {
    /**
     * As a vertical line (sitting between two characters).
     */ TextEditorCursorStyle[TextEditorCursorStyle["Line"] = 1] = "Line";
    /**
     * As a block (sitting on top of a character).
     */ TextEditorCursorStyle[TextEditorCursorStyle["Block"] = 2] = "Block";
    /**
     * As a horizontal line (sitting under a character).
     */ TextEditorCursorStyle[TextEditorCursorStyle["Underline"] = 3] = "Underline";
    /**
     * As a thin vertical line (sitting between two characters).
     */ TextEditorCursorStyle[TextEditorCursorStyle["LineThin"] = 4] = "LineThin";
    /**
     * As an outlined block (sitting on top of a character).
     */ TextEditorCursorStyle[TextEditorCursorStyle["BlockOutline"] = 5] = "BlockOutline";
    /**
     * As a thin horizontal line (sitting under a character).
     */ TextEditorCursorStyle[TextEditorCursorStyle["UnderlineThin"] = 6] = "UnderlineThin";
})(TextEditorCursorStyle || (TextEditorCursorStyle = {}));
var TrackedRangeStickiness;
(function(TrackedRangeStickiness) {
    TrackedRangeStickiness[TrackedRangeStickiness["AlwaysGrowsWhenTypingAtEdges"] = 0] = "AlwaysGrowsWhenTypingAtEdges";
    TrackedRangeStickiness[TrackedRangeStickiness["NeverGrowsWhenTypingAtEdges"] = 1] = "NeverGrowsWhenTypingAtEdges";
    TrackedRangeStickiness[TrackedRangeStickiness["GrowsOnlyWhenTypingBefore"] = 2] = "GrowsOnlyWhenTypingBefore";
    TrackedRangeStickiness[TrackedRangeStickiness["GrowsOnlyWhenTypingAfter"] = 3] = "GrowsOnlyWhenTypingAfter";
})(TrackedRangeStickiness || (TrackedRangeStickiness = {}));
var WrappingIndent;
(function(WrappingIndent) {
    /**
     * No indentation => wrapped lines begin at column 1.
     */ WrappingIndent[WrappingIndent["None"] = 0] = "None";
    /**
     * Same => wrapped lines get the same indentation as the parent.
     */ WrappingIndent[WrappingIndent["Same"] = 1] = "Same";
    /**
     * Indent => wrapped lines get +1 indentation toward the parent.
     */ WrappingIndent[WrappingIndent["Indent"] = 2] = "Indent";
    /**
     * DeepIndent => wrapped lines get +2 indentation toward the parent.
     */ WrappingIndent[WrappingIndent["DeepIndent"] = 3] = "DeepIndent";
})(WrappingIndent || (WrappingIndent = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hcZNh":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a new editor under `domElement`.
 * `domElement` should be empty (not contain other dom nodes).
 * The editor will read the size of `domElement`.
 */ parcelHelpers.export(exports, "create", ()=>create);
/**
 * Emitted when an editor is created.
 * Creating a diff editor might cause this listener to be invoked with the two editors.
 * @event
 */ parcelHelpers.export(exports, "onDidCreateEditor", ()=>onDidCreateEditor);
/**
 * Emitted when an diff editor is created.
 * @event
 */ parcelHelpers.export(exports, "onDidCreateDiffEditor", ()=>onDidCreateDiffEditor);
/**
 * Get all the created editors.
 */ parcelHelpers.export(exports, "getEditors", ()=>getEditors);
/**
 * Get all the created diff editors.
 */ parcelHelpers.export(exports, "getDiffEditors", ()=>getDiffEditors);
/**
 * Create a new diff editor under `domElement`.
 * `domElement` should be empty (not contain other dom nodes).
 * The editor will read the size of `domElement`.
 */ parcelHelpers.export(exports, "createDiffEditor", ()=>createDiffEditor);
parcelHelpers.export(exports, "createMultiFileDiffEditor", ()=>createMultiFileDiffEditor);
/**
 * Add a command.
 */ parcelHelpers.export(exports, "addCommand", ()=>addCommand);
/**
 * Add an action to all editors.
 */ parcelHelpers.export(exports, "addEditorAction", ()=>addEditorAction);
/**
 * Add a keybinding rule.
 */ parcelHelpers.export(exports, "addKeybindingRule", ()=>addKeybindingRule);
/**
 * Add keybinding rules.
 */ parcelHelpers.export(exports, "addKeybindingRules", ()=>addKeybindingRules);
/**
 * Create a new editor model.
 * You can specify the language that should be set for this model or let the language be inferred from the `uri`.
 */ parcelHelpers.export(exports, "createModel", ()=>createModel);
/**
 * Change the language for a model.
 */ parcelHelpers.export(exports, "setModelLanguage", ()=>setModelLanguage);
/**
 * Set the markers for a model.
 */ parcelHelpers.export(exports, "setModelMarkers", ()=>setModelMarkers);
/**
 * Remove all markers of an owner.
 */ parcelHelpers.export(exports, "removeAllMarkers", ()=>removeAllMarkers);
/**
 * Get markers for owner and/or resource
 *
 * @returns list of markers
 */ parcelHelpers.export(exports, "getModelMarkers", ()=>getModelMarkers);
/**
 * Emitted when markers change for a model.
 * @event
 */ parcelHelpers.export(exports, "onDidChangeMarkers", ()=>onDidChangeMarkers);
/**
 * Get the model that has `uri` if it exists.
 */ parcelHelpers.export(exports, "getModel", ()=>getModel);
/**
 * Get all the created models.
 */ parcelHelpers.export(exports, "getModels", ()=>getModels);
/**
 * Emitted when a model is created.
 * @event
 */ parcelHelpers.export(exports, "onDidCreateModel", ()=>onDidCreateModel);
/**
 * Emitted right before a model is disposed.
 * @event
 */ parcelHelpers.export(exports, "onWillDisposeModel", ()=>onWillDisposeModel);
/**
 * Emitted when a different language is set to a model.
 * @event
 */ parcelHelpers.export(exports, "onDidChangeModelLanguage", ()=>onDidChangeModelLanguage);
/**
 * Create a new web worker that has model syncing capabilities built in.
 * Specify an AMD module to load that will `create` an object that will be proxied.
 */ parcelHelpers.export(exports, "createWebWorker", ()=>createWebWorker);
/**
 * Colorize the contents of `domNode` using attribute `data-lang`.
 */ parcelHelpers.export(exports, "colorizeElement", ()=>colorizeElement);
/**
 * Colorize `text` using language `languageId`.
 */ parcelHelpers.export(exports, "colorize", ()=>colorize);
/**
 * Colorize a line in a model.
 */ parcelHelpers.export(exports, "colorizeModelLine", ()=>colorizeModelLine);
/**
 * Tokenize `text` using language `languageId`
 */ parcelHelpers.export(exports, "tokenize", ()=>tokenize);
/**
 * Define a new theme or update an existing theme.
 */ parcelHelpers.export(exports, "defineTheme", ()=>defineTheme);
/**
 * Switches to a theme.
 */ parcelHelpers.export(exports, "setTheme", ()=>setTheme);
/**
 * Clears all cached font measurements and triggers re-measurement.
 */ parcelHelpers.export(exports, "remeasureFonts", ()=>remeasureFonts);
/**
 * Register a command.
 */ parcelHelpers.export(exports, "registerCommand", ()=>registerCommand);
/**
 * Registers a handler that is called when a link is opened in any editor. The handler callback should return `true` if the link was handled and `false` otherwise.
 * The handler that was registered last will be called first when a link is opened.
 *
 * Returns a disposable that can unregister the opener again.
 */ parcelHelpers.export(exports, "registerLinkOpener", ()=>registerLinkOpener);
/**
 * Registers a handler that is called when a resource other than the current model should be opened in the editor (e.g. "go to definition").
 * The handler callback should return `true` if the request was handled and `false` otherwise.
 *
 * Returns a disposable that can unregister the opener again.
 *
 * If no handler is registered the default behavior is to do nothing for models other than the currently attached one.
 */ parcelHelpers.export(exports, "registerEditorOpener", ()=>registerEditorOpener);
/**
 * @internal
 */ parcelHelpers.export(exports, "createMonacoEditorAPI", ()=>createMonacoEditorAPI);
var _windowJs = require("../../../base/browser/window.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _stringsJs = require("../../../base/common/strings.js");
var _uriJs = require("../../../base/common/uri.js");
var _standaloneTokensCss = require("./standalone-tokens.css");
var _fontMeasurementsJs = require("../../browser/config/fontMeasurements.js");
var _editorExtensionsJs = require("../../browser/editorExtensions.js");
var _codeEditorServiceJs = require("../../browser/services/codeEditorService.js");
var _standaloneWebWorkerJs = require("./standaloneWebWorker.js");
var _editorOptionsJs = require("../../common/config/editorOptions.js");
var _editorZoomJs = require("../../common/config/editorZoom.js");
var _fontInfoJs = require("../../common/config/fontInfo.js");
var _editorCommonJs = require("../../common/editorCommon.js");
var _languagesJs = require("../../common/languages.js");
var _languageJs = require("../../common/languages/language.js");
var _modesRegistryJs = require("../../common/languages/modesRegistry.js");
var _nullTokenizeJs = require("../../common/languages/nullTokenize.js");
var _modelJs = require("../../common/model.js");
var _modelJs1 = require("../../common/services/model.js");
var _standaloneEnumsJs = require("../../common/standalone/standaloneEnums.js");
var _colorizerJs = require("./colorizer.js");
var _standaloneCodeEditorJs = require("./standaloneCodeEditor.js");
var _standaloneServicesJs = require("./standaloneServices.js");
var _standaloneThemeJs = require("../common/standaloneTheme.js");
var _actionsJs = require("../../../platform/actions/common/actions.js");
var _commandsJs = require("../../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../../platform/contextkey/common/contextkey.js");
var _keybindingJs = require("../../../platform/keybinding/common/keybinding.js");
var _markersJs = require("../../../platform/markers/common/markers.js");
var _openerJs = require("../../../platform/opener/common/opener.js");
var _multiDiffEditorWidgetJs = require("../../browser/widget/multiDiffEditor/multiDiffEditorWidget.js");
function create(domElement, options, override) {
    const instantiationService = (0, _standaloneServicesJs.StandaloneServices).initialize(override || {});
    return instantiationService.createInstance((0, _standaloneCodeEditorJs.StandaloneEditor), domElement, options);
}
function onDidCreateEditor(listener) {
    const codeEditorService = (0, _standaloneServicesJs.StandaloneServices).get((0, _codeEditorServiceJs.ICodeEditorService));
    return codeEditorService.onCodeEditorAdd((editor)=>{
        listener(editor);
    });
}
function onDidCreateDiffEditor(listener) {
    const codeEditorService = (0, _standaloneServicesJs.StandaloneServices).get((0, _codeEditorServiceJs.ICodeEditorService));
    return codeEditorService.onDiffEditorAdd((editor)=>{
        listener(editor);
    });
}
function getEditors() {
    const codeEditorService = (0, _standaloneServicesJs.StandaloneServices).get((0, _codeEditorServiceJs.ICodeEditorService));
    return codeEditorService.listCodeEditors();
}
function getDiffEditors() {
    const codeEditorService = (0, _standaloneServicesJs.StandaloneServices).get((0, _codeEditorServiceJs.ICodeEditorService));
    return codeEditorService.listDiffEditors();
}
function createDiffEditor(domElement, options, override) {
    const instantiationService = (0, _standaloneServicesJs.StandaloneServices).initialize(override || {});
    return instantiationService.createInstance((0, _standaloneCodeEditorJs.StandaloneDiffEditor2), domElement, options);
}
function createMultiFileDiffEditor(domElement, override) {
    const instantiationService = (0, _standaloneServicesJs.StandaloneServices).initialize(override || {});
    return new (0, _multiDiffEditorWidgetJs.MultiDiffEditorWidget)(domElement, {}, instantiationService);
}
function addCommand(descriptor) {
    if (typeof descriptor.id !== "string" || typeof descriptor.run !== "function") throw new Error("Invalid command descriptor, `id` and `run` are required properties!");
    return (0, _commandsJs.CommandsRegistry).registerCommand(descriptor.id, descriptor.run);
}
function addEditorAction(descriptor) {
    if (typeof descriptor.id !== "string" || typeof descriptor.label !== "string" || typeof descriptor.run !== "function") throw new Error("Invalid action descriptor, `id`, `label` and `run` are required properties!");
    const precondition = (0, _contextkeyJs.ContextKeyExpr).deserialize(descriptor.precondition);
    const run = (accessor, ...args)=>{
        return (0, _editorExtensionsJs.EditorCommand).runEditorCommand(accessor, args, precondition, (accessor, editor, args)=>Promise.resolve(descriptor.run(editor, ...args)));
    };
    const toDispose = new (0, _lifecycleJs.DisposableStore)();
    // Register the command
    toDispose.add((0, _commandsJs.CommandsRegistry).registerCommand(descriptor.id, run));
    // Register the context menu item
    if (descriptor.contextMenuGroupId) {
        const menuItem = {
            command: {
                id: descriptor.id,
                title: descriptor.label
            },
            when: precondition,
            group: descriptor.contextMenuGroupId,
            order: descriptor.contextMenuOrder || 0
        };
        toDispose.add((0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).EditorContext, menuItem));
    }
    // Register the keybindings
    if (Array.isArray(descriptor.keybindings)) {
        const keybindingService = (0, _standaloneServicesJs.StandaloneServices).get((0, _keybindingJs.IKeybindingService));
        if (!(keybindingService instanceof (0, _standaloneServicesJs.StandaloneKeybindingService))) console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService");
        else {
            const keybindingsWhen = (0, _contextkeyJs.ContextKeyExpr).and(precondition, (0, _contextkeyJs.ContextKeyExpr).deserialize(descriptor.keybindingContext));
            toDispose.add(keybindingService.addDynamicKeybindings(descriptor.keybindings.map((keybinding)=>{
                return {
                    keybinding,
                    command: descriptor.id,
                    when: keybindingsWhen
                };
            })));
        }
    }
    return toDispose;
}
function addKeybindingRule(rule) {
    return addKeybindingRules([
        rule
    ]);
}
function addKeybindingRules(rules) {
    const keybindingService = (0, _standaloneServicesJs.StandaloneServices).get((0, _keybindingJs.IKeybindingService));
    if (!(keybindingService instanceof (0, _standaloneServicesJs.StandaloneKeybindingService))) {
        console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService");
        return (0, _lifecycleJs.Disposable).None;
    }
    return keybindingService.addDynamicKeybindings(rules.map((rule)=>{
        return {
            keybinding: rule.keybinding,
            command: rule.command,
            commandArgs: rule.commandArgs,
            when: (0, _contextkeyJs.ContextKeyExpr).deserialize(rule.when)
        };
    }));
}
function createModel(value, language, uri) {
    const languageService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageJs.ILanguageService));
    const languageId = languageService.getLanguageIdByMimeType(language) || language;
    return (0, _standaloneCodeEditorJs.createTextModel)((0, _standaloneServicesJs.StandaloneServices).get((0, _modelJs1.IModelService)), languageService, value, languageId, uri);
}
function setModelLanguage(model, mimeTypeOrLanguageId) {
    const languageService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageJs.ILanguageService));
    const languageId = languageService.getLanguageIdByMimeType(mimeTypeOrLanguageId) || mimeTypeOrLanguageId || (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID);
    model.setLanguage(languageService.createById(languageId));
}
function setModelMarkers(model, owner, markers) {
    if (model) {
        const markerService = (0, _standaloneServicesJs.StandaloneServices).get((0, _markersJs.IMarkerService));
        markerService.changeOne(owner, model.uri, markers);
    }
}
function removeAllMarkers(owner) {
    const markerService = (0, _standaloneServicesJs.StandaloneServices).get((0, _markersJs.IMarkerService));
    markerService.changeAll(owner, []);
}
function getModelMarkers(filter) {
    const markerService = (0, _standaloneServicesJs.StandaloneServices).get((0, _markersJs.IMarkerService));
    return markerService.read(filter);
}
function onDidChangeMarkers(listener) {
    const markerService = (0, _standaloneServicesJs.StandaloneServices).get((0, _markersJs.IMarkerService));
    return markerService.onMarkerChanged(listener);
}
function getModel(uri) {
    const modelService = (0, _standaloneServicesJs.StandaloneServices).get((0, _modelJs1.IModelService));
    return modelService.getModel(uri);
}
function getModels() {
    const modelService = (0, _standaloneServicesJs.StandaloneServices).get((0, _modelJs1.IModelService));
    return modelService.getModels();
}
function onDidCreateModel(listener) {
    const modelService = (0, _standaloneServicesJs.StandaloneServices).get((0, _modelJs1.IModelService));
    return modelService.onModelAdded(listener);
}
function onWillDisposeModel(listener) {
    const modelService = (0, _standaloneServicesJs.StandaloneServices).get((0, _modelJs1.IModelService));
    return modelService.onModelRemoved(listener);
}
function onDidChangeModelLanguage(listener) {
    const modelService = (0, _standaloneServicesJs.StandaloneServices).get((0, _modelJs1.IModelService));
    return modelService.onModelLanguageChanged((e)=>{
        listener({
            model: e.model,
            oldLanguage: e.oldLanguageId
        });
    });
}
function createWebWorker(opts) {
    return (0, _standaloneWebWorkerJs.createWebWorker)((0, _standaloneServicesJs.StandaloneServices).get((0, _modelJs1.IModelService)), opts);
}
function colorizeElement(domNode, options) {
    const languageService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageJs.ILanguageService));
    const themeService = (0, _standaloneServicesJs.StandaloneServices).get((0, _standaloneThemeJs.IStandaloneThemeService));
    return (0, _colorizerJs.Colorizer).colorizeElement(themeService, languageService, domNode, options).then(()=>{
        themeService.registerEditorContainer(domNode);
    });
}
function colorize(text, languageId, options) {
    const languageService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageJs.ILanguageService));
    const themeService = (0, _standaloneServicesJs.StandaloneServices).get((0, _standaloneThemeJs.IStandaloneThemeService));
    themeService.registerEditorContainer((0, _windowJs.mainWindow).document.body);
    return (0, _colorizerJs.Colorizer).colorize(languageService, text, languageId, options);
}
function colorizeModelLine(model, lineNumber, tabSize = 4) {
    const themeService = (0, _standaloneServicesJs.StandaloneServices).get((0, _standaloneThemeJs.IStandaloneThemeService));
    themeService.registerEditorContainer((0, _windowJs.mainWindow).document.body);
    return (0, _colorizerJs.Colorizer).colorizeModelLine(model, lineNumber, tabSize);
}
/**
 * @internal
 */ function getSafeTokenizationSupport(language) {
    const tokenizationSupport = _languagesJs.TokenizationRegistry.get(language);
    if (tokenizationSupport) return tokenizationSupport;
    return {
        getInitialState: ()=>(0, _nullTokenizeJs.NullState),
        tokenize: (line, hasEOL, state)=>(0, _nullTokenizeJs.nullTokenize)(language, state)
    };
}
function tokenize(text, languageId) {
    // Needed in order to get the mode registered for subsequent look-ups
    _languagesJs.TokenizationRegistry.getOrCreate(languageId);
    const tokenizationSupport = getSafeTokenizationSupport(languageId);
    const lines = (0, _stringsJs.splitLines)(text);
    const result = [];
    let state = tokenizationSupport.getInitialState();
    for(let i = 0, len = lines.length; i < len; i++){
        const line = lines[i];
        const tokenizationResult = tokenizationSupport.tokenize(line, true, state);
        result[i] = tokenizationResult.tokens;
        state = tokenizationResult.endState;
    }
    return result;
}
function defineTheme(themeName, themeData) {
    const standaloneThemeService = (0, _standaloneServicesJs.StandaloneServices).get((0, _standaloneThemeJs.IStandaloneThemeService));
    standaloneThemeService.defineTheme(themeName, themeData);
}
function setTheme(themeName) {
    const standaloneThemeService = (0, _standaloneServicesJs.StandaloneServices).get((0, _standaloneThemeJs.IStandaloneThemeService));
    standaloneThemeService.setTheme(themeName);
}
function remeasureFonts() {
    (0, _fontMeasurementsJs.FontMeasurements).clearAllFontInfos();
}
function registerCommand(id, handler) {
    return (0, _commandsJs.CommandsRegistry).registerCommand({
        id,
        handler
    });
}
function registerLinkOpener(opener) {
    const openerService = (0, _standaloneServicesJs.StandaloneServices).get((0, _openerJs.IOpenerService));
    return openerService.registerOpener({
        async open (resource) {
            if (typeof resource === "string") resource = (0, _uriJs.URI).parse(resource);
            return opener.open(resource);
        }
    });
}
function registerEditorOpener(opener) {
    const codeEditorService = (0, _standaloneServicesJs.StandaloneServices).get((0, _codeEditorServiceJs.ICodeEditorService));
    return codeEditorService.registerCodeEditorOpenHandler(async (input, source, sideBySide)=>{
        if (!source) return null;
        const selection = input.options?.selection;
        let selectionOrPosition;
        if (selection && typeof selection.endLineNumber === "number" && typeof selection.endColumn === "number") selectionOrPosition = selection;
        else if (selection) selectionOrPosition = {
            lineNumber: selection.startLineNumber,
            column: selection.startColumn
        };
        if (await opener.openCodeEditor(source, input.resource, selectionOrPosition)) return source; // return source editor to indicate that this handler has successfully handled the opening
        return null; // fallback to other registered handlers
    });
}
function createMonacoEditorAPI() {
    return {
        // methods
        create: create,
        getEditors: getEditors,
        getDiffEditors: getDiffEditors,
        onDidCreateEditor: onDidCreateEditor,
        onDidCreateDiffEditor: onDidCreateDiffEditor,
        createDiffEditor: createDiffEditor,
        addCommand: addCommand,
        addEditorAction: addEditorAction,
        addKeybindingRule: addKeybindingRule,
        addKeybindingRules: addKeybindingRules,
        createModel: createModel,
        setModelLanguage: setModelLanguage,
        setModelMarkers: setModelMarkers,
        getModelMarkers: getModelMarkers,
        removeAllMarkers: removeAllMarkers,
        onDidChangeMarkers: onDidChangeMarkers,
        getModels: getModels,
        getModel: getModel,
        onDidCreateModel: onDidCreateModel,
        onWillDisposeModel: onWillDisposeModel,
        onDidChangeModelLanguage: onDidChangeModelLanguage,
        createWebWorker: createWebWorker,
        colorizeElement: colorizeElement,
        colorize: colorize,
        colorizeModelLine: colorizeModelLine,
        tokenize: tokenize,
        defineTheme: defineTheme,
        setTheme: setTheme,
        remeasureFonts: remeasureFonts,
        registerCommand: registerCommand,
        registerLinkOpener: registerLinkOpener,
        registerEditorOpener: registerEditorOpener,
        // enums
        AccessibilitySupport: _standaloneEnumsJs.AccessibilitySupport,
        ContentWidgetPositionPreference: _standaloneEnumsJs.ContentWidgetPositionPreference,
        CursorChangeReason: _standaloneEnumsJs.CursorChangeReason,
        DefaultEndOfLine: _standaloneEnumsJs.DefaultEndOfLine,
        EditorAutoIndentStrategy: _standaloneEnumsJs.EditorAutoIndentStrategy,
        EditorOption: _standaloneEnumsJs.EditorOption,
        EndOfLinePreference: _standaloneEnumsJs.EndOfLinePreference,
        EndOfLineSequence: _standaloneEnumsJs.EndOfLineSequence,
        MinimapPosition: _standaloneEnumsJs.MinimapPosition,
        MinimapSectionHeaderStyle: _standaloneEnumsJs.MinimapSectionHeaderStyle,
        MouseTargetType: _standaloneEnumsJs.MouseTargetType,
        OverlayWidgetPositionPreference: _standaloneEnumsJs.OverlayWidgetPositionPreference,
        OverviewRulerLane: _standaloneEnumsJs.OverviewRulerLane,
        GlyphMarginLane: _standaloneEnumsJs.GlyphMarginLane,
        RenderLineNumbersType: _standaloneEnumsJs.RenderLineNumbersType,
        RenderMinimap: _standaloneEnumsJs.RenderMinimap,
        ScrollbarVisibility: _standaloneEnumsJs.ScrollbarVisibility,
        ScrollType: _standaloneEnumsJs.ScrollType,
        TextEditorCursorBlinkingStyle: _standaloneEnumsJs.TextEditorCursorBlinkingStyle,
        TextEditorCursorStyle: _standaloneEnumsJs.TextEditorCursorStyle,
        TrackedRangeStickiness: _standaloneEnumsJs.TrackedRangeStickiness,
        WrappingIndent: _standaloneEnumsJs.WrappingIndent,
        InjectedTextCursorStops: _standaloneEnumsJs.InjectedTextCursorStops,
        PositionAffinity: _standaloneEnumsJs.PositionAffinity,
        ShowLightbulbIconMode: _standaloneEnumsJs.ShowLightbulbIconMode,
        // classes
        ConfigurationChangedEvent: (0, _editorOptionsJs.ConfigurationChangedEvent),
        BareFontInfo: (0, _fontInfoJs.BareFontInfo),
        FontInfo: (0, _fontInfoJs.FontInfo),
        TextModelResolvedOptions: (0, _modelJs.TextModelResolvedOptions),
        FindMatch: (0, _modelJs.FindMatch),
        ApplyUpdateResult: (0, _editorOptionsJs.ApplyUpdateResult),
        EditorZoom: (0, _editorZoomJs.EditorZoom),
        createMultiFileDiffEditor: createMultiFileDiffEditor,
        // vars
        EditorType: (0, _editorCommonJs.EditorType),
        EditorOptions: (0, _editorOptionsJs.EditorOptions)
    };
}

},{"../../../base/browser/window.js":"aJBhQ","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/strings.js":"aA9I1","../../../base/common/uri.js":"7qGS3","./standalone-tokens.css":"5Wpsw","../../browser/config/fontMeasurements.js":"3umX2","../../browser/editorExtensions.js":"kC3w6","../../browser/services/codeEditorService.js":"bOWtl","./standaloneWebWorker.js":"gYnFO","../../common/config/editorOptions.js":"3Xi00","../../common/config/editorZoom.js":"7PVxj","../../common/config/fontInfo.js":"68pxu","../../common/editorCommon.js":"681Ll","../../common/languages.js":"g5n96","../../common/languages/language.js":"ka2JQ","../../common/languages/modesRegistry.js":"gqkb7","../../common/languages/nullTokenize.js":"ekzGB","../../common/model.js":"1CSIB","../../common/services/model.js":"aciVm","../../common/standalone/standaloneEnums.js":"7JLc0","./colorizer.js":"kb2bg","./standaloneCodeEditor.js":"1KZsU","./standaloneServices.js":"3py7i","../common/standaloneTheme.js":"exW2E","../../../platform/actions/common/actions.js":"kyMtp","../../../platform/commands/common/commands.js":"ho6ic","../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../platform/keybinding/common/keybinding.js":"25pLT","../../../platform/markers/common/markers.js":"aaeXc","../../../platform/opener/common/opener.js":"d3tj1","../../browser/widget/multiDiffEditor/multiDiffEditorWidget.js":"4RRPk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aJBhQ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensureCodeWindow", ()=>ensureCodeWindow);
parcelHelpers.export(exports, "mainWindow", ()=>mainWindow);
function ensureCodeWindow(targetWindow, fallbackWindowId) {
    const codeWindow = targetWindow;
    if (typeof codeWindow.vscodeWindowId !== "number") Object.defineProperty(codeWindow, "vscodeWindowId", {
        get: ()=>fallbackWindowId
    });
}
const mainWindow = window;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aA9I1":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFalsyOrWhitespace", ()=>isFalsyOrWhitespace);
/**
 * Helper to produce a string with a variable number of arguments. Insert variable segments
 * into the string using the {n} notation where N is the index of the argument following the string.
 * @param value string to which formatting is applied
 * @param args replacements for {n}-entries
 */ parcelHelpers.export(exports, "format", ()=>format);
/**
 * Encodes the given value so that it can be used as literal value in html attributes.
 *
 * In other words, computes `$val`, such that `attr` in `<div attr="$val" />` has the runtime value `value`.
 * This prevents XSS injection.
 */ parcelHelpers.export(exports, "htmlAttributeEncodeValue", ()=>htmlAttributeEncodeValue);
/**
 * Converts HTML characters inside the string to use entities instead. Makes the string safe from
 * being used e.g. in HTMLElement.innerHTML.
 */ parcelHelpers.export(exports, "escape", ()=>escape);
/**
 * Escapes regular expression characters in a given string
 */ parcelHelpers.export(exports, "escapeRegExpCharacters", ()=>escapeRegExpCharacters);
/**
 * Removes all occurrences of needle from the beginning and end of haystack.
 * @param haystack string to trim
 * @param needle the thing to trim (default is a blank)
 */ parcelHelpers.export(exports, "trim", ()=>trim);
/**
 * Removes all occurrences of needle from the beginning of haystack.
 * @param haystack string to trim
 * @param needle the thing to trim
 */ parcelHelpers.export(exports, "ltrim", ()=>ltrim);
/**
 * Removes all occurrences of needle from the end of haystack.
 * @param haystack string to trim
 * @param needle the thing to trim
 */ parcelHelpers.export(exports, "rtrim", ()=>rtrim);
parcelHelpers.export(exports, "convertSimple2RegExpPattern", ()=>convertSimple2RegExpPattern);
parcelHelpers.export(exports, "stripWildcards", ()=>stripWildcards);
parcelHelpers.export(exports, "createRegExp", ()=>createRegExp);
parcelHelpers.export(exports, "regExpLeadsToEndlessLoop", ()=>regExpLeadsToEndlessLoop);
parcelHelpers.export(exports, "splitLines", ()=>splitLines);
parcelHelpers.export(exports, "splitLinesIncludeSeparators", ()=>splitLinesIncludeSeparators);
/**
 * Returns first index of the string that is not whitespace.
 * If string is empty or contains only whitespaces, returns -1
 */ parcelHelpers.export(exports, "firstNonWhitespaceIndex", ()=>firstNonWhitespaceIndex);
/**
 * Returns the leading whitespace of the string.
 * If the string contains only whitespaces, returns entire string
 */ parcelHelpers.export(exports, "getLeadingWhitespace", ()=>getLeadingWhitespace);
/**
 * Returns last index of the string that is not whitespace.
 * If string is empty or contains only whitespaces, returns -1
 */ parcelHelpers.export(exports, "lastNonWhitespaceIndex", ()=>lastNonWhitespaceIndex);
parcelHelpers.export(exports, "compare", ()=>compare);
parcelHelpers.export(exports, "compareSubstring", ()=>compareSubstring);
parcelHelpers.export(exports, "compareIgnoreCase", ()=>compareIgnoreCase);
parcelHelpers.export(exports, "compareSubstringIgnoreCase", ()=>compareSubstringIgnoreCase);
parcelHelpers.export(exports, "isAsciiDigit", ()=>isAsciiDigit);
parcelHelpers.export(exports, "isLowerAsciiLetter", ()=>isLowerAsciiLetter);
parcelHelpers.export(exports, "isUpperAsciiLetter", ()=>isUpperAsciiLetter);
parcelHelpers.export(exports, "equalsIgnoreCase", ()=>equalsIgnoreCase);
parcelHelpers.export(exports, "startsWithIgnoreCase", ()=>startsWithIgnoreCase);
/**
 * @returns the length of the common prefix of the two strings.
 */ parcelHelpers.export(exports, "commonPrefixLength", ()=>commonPrefixLength);
/**
 * @returns the length of the common suffix of the two strings.
 */ parcelHelpers.export(exports, "commonSuffixLength", ()=>commonSuffixLength);
/**
 * See http://en.wikipedia.org/wiki/Surrogate_pair
 */ parcelHelpers.export(exports, "isHighSurrogate", ()=>isHighSurrogate);
/**
 * See http://en.wikipedia.org/wiki/Surrogate_pair
 */ parcelHelpers.export(exports, "isLowSurrogate", ()=>isLowSurrogate);
/**
 * See http://en.wikipedia.org/wiki/Surrogate_pair
 */ parcelHelpers.export(exports, "computeCodePoint", ()=>computeCodePoint);
/**
 * get the code point that begins at offset `offset`
 */ parcelHelpers.export(exports, "getNextCodePoint", ()=>getNextCodePoint);
parcelHelpers.export(exports, "CodePointIterator", ()=>CodePointIterator);
parcelHelpers.export(exports, "GraphemeIterator", ()=>GraphemeIterator);
parcelHelpers.export(exports, "nextCharLength", ()=>nextCharLength);
parcelHelpers.export(exports, "prevCharLength", ()=>prevCharLength);
parcelHelpers.export(exports, "getCharContainingOffset", ()=>getCharContainingOffset);
/**
 * Returns true if `str` contains any Unicode character that is classified as "R" or "AL".
 */ parcelHelpers.export(exports, "containsRTL", ()=>containsRTL);
/**
 * Returns true if `str` contains only basic ASCII characters in the range 32 - 126 (including 32 and 126) or \n, \r, \t
 */ parcelHelpers.export(exports, "isBasicASCII", ()=>isBasicASCII);
parcelHelpers.export(exports, "UNUSUAL_LINE_TERMINATORS", ()=>UNUSUAL_LINE_TERMINATORS);
/**
 * Returns true if `str` contains unusual line terminators, like LS or PS
 */ parcelHelpers.export(exports, "containsUnusualLineTerminators", ()=>containsUnusualLineTerminators);
parcelHelpers.export(exports, "isFullWidthCharacter", ()=>isFullWidthCharacter);
/**
 * A fast function (therefore imprecise) to check if code points are emojis.
 * Generated using https://github.com/alexdima/unicode-utils/blob/main/emoji-test.js
 */ parcelHelpers.export(exports, "isEmojiImprecise", ()=>isEmojiImprecise);
parcelHelpers.export(exports, "UTF8_BOM_CHARACTER", ()=>UTF8_BOM_CHARACTER);
parcelHelpers.export(exports, "startsWithUTF8BOM", ()=>startsWithUTF8BOM);
parcelHelpers.export(exports, "containsUppercaseCharacter", ()=>containsUppercaseCharacter);
/**
 * Produces 'a'-'z', followed by 'A'-'Z'... followed by 'a'-'z', etc.
 */ parcelHelpers.export(exports, "singleLetterHash", ()=>singleLetterHash);
//#endregion
/**
 * Computes the offset after performing a left delete on the given string,
 * while considering unicode grapheme/emoji rules.
*/ parcelHelpers.export(exports, "getLeftDeleteOffset", ()=>getLeftDeleteOffset);
parcelHelpers.export(exports, "noBreakWhitespace", ()=>noBreakWhitespace);
parcelHelpers.export(exports, "AmbiguousCharacters", ()=>AmbiguousCharacters);
parcelHelpers.export(exports, "InvisibleCharacters", ()=>InvisibleCharacters);
var _cacheJs = require("./cache.js");
var _lazyJs = require("./lazy.js");
function isFalsyOrWhitespace(str) {
    if (!str || typeof str !== "string") return true;
    return str.trim().length === 0;
}
const _formatRegexp = /{(\d+)}/g;
function format(value, ...args) {
    if (args.length === 0) return value;
    return value.replace(_formatRegexp, function(match, group) {
        const idx = parseInt(group, 10);
        return isNaN(idx) || idx < 0 || idx >= args.length ? match : args[idx];
    });
}
function htmlAttributeEncodeValue(value) {
    return value.replace(/[<>"'&]/g, (ch)=>{
        switch(ch){
            case "<":
                return "&lt;";
            case ">":
                return "&gt;";
            case '"':
                return "&quot;";
            case "'":
                return "&apos;";
            case "&":
                return "&amp;";
        }
        return ch;
    });
}
function escape(html) {
    return html.replace(/[<>&]/g, function(match) {
        switch(match){
            case "<":
                return "&lt;";
            case ">":
                return "&gt;";
            case "&":
                return "&amp;";
            default:
                return match;
        }
    });
}
function escapeRegExpCharacters(value) {
    return value.replace(/[\\\{\}\*\+\?\|\^\$\.\[\]\(\)]/g, "\\$&");
}
function trim(haystack, needle = " ") {
    const trimmed = ltrim(haystack, needle);
    return rtrim(trimmed, needle);
}
function ltrim(haystack, needle) {
    if (!haystack || !needle) return haystack;
    const needleLen = needle.length;
    if (needleLen === 0 || haystack.length === 0) return haystack;
    let offset = 0;
    while(haystack.indexOf(needle, offset) === offset)offset = offset + needleLen;
    return haystack.substring(offset);
}
function rtrim(haystack, needle) {
    if (!haystack || !needle) return haystack;
    const needleLen = needle.length, haystackLen = haystack.length;
    if (needleLen === 0 || haystackLen === 0) return haystack;
    let offset = haystackLen, idx = -1;
    while(true){
        idx = haystack.lastIndexOf(needle, offset - 1);
        if (idx === -1 || idx + needleLen !== offset) break;
        if (idx === 0) return "";
        offset = idx;
    }
    return haystack.substring(0, offset);
}
function convertSimple2RegExpPattern(pattern) {
    return pattern.replace(/[\-\\\{\}\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, "\\$&").replace(/[\*]/g, ".*");
}
function stripWildcards(pattern) {
    return pattern.replace(/\*/g, "");
}
function createRegExp(searchString, isRegex, options = {}) {
    if (!searchString) throw new Error("Cannot create regex from empty string");
    if (!isRegex) searchString = escapeRegExpCharacters(searchString);
    if (options.wholeWord) {
        if (!/\B/.test(searchString.charAt(0))) searchString = "\\b" + searchString;
        if (!/\B/.test(searchString.charAt(searchString.length - 1))) searchString = searchString + "\\b";
    }
    let modifiers = "";
    if (options.global) modifiers += "g";
    if (!options.matchCase) modifiers += "i";
    if (options.multiline) modifiers += "m";
    if (options.unicode) modifiers += "u";
    return new RegExp(searchString, modifiers);
}
function regExpLeadsToEndlessLoop(regexp) {
    // Exit early if it's one of these special cases which are meant to match
    // against an empty string
    if (regexp.source === "^" || regexp.source === "^$" || regexp.source === "$" || regexp.source === "^\\s*$") return false;
    // We check against an empty string. If the regular expression doesn't advance
    // (e.g. ends in an endless loop) it will match an empty string.
    const match = regexp.exec("");
    return !!(match && regexp.lastIndex === 0);
}
function splitLines(str) {
    return str.split(/\r\n|\r|\n/);
}
function splitLinesIncludeSeparators(str) {
    const linesWithSeparators = [];
    const splitLinesAndSeparators = str.split(/(\r\n|\r|\n)/);
    for(let i = 0; i < Math.ceil(splitLinesAndSeparators.length / 2); i++)linesWithSeparators.push(splitLinesAndSeparators[2 * i] + (splitLinesAndSeparators[2 * i + 1] ?? ""));
    return linesWithSeparators;
}
function firstNonWhitespaceIndex(str) {
    for(let i = 0, len = str.length; i < len; i++){
        const chCode = str.charCodeAt(i);
        if (chCode !== 32 /* CharCode.Space */  && chCode !== 9 /* CharCode.Tab */ ) return i;
    }
    return -1;
}
function getLeadingWhitespace(str, start = 0, end = str.length) {
    for(let i = start; i < end; i++){
        const chCode = str.charCodeAt(i);
        if (chCode !== 32 /* CharCode.Space */  && chCode !== 9 /* CharCode.Tab */ ) return str.substring(start, i);
    }
    return str.substring(start, end);
}
function lastNonWhitespaceIndex(str, startIndex = str.length - 1) {
    for(let i = startIndex; i >= 0; i--){
        const chCode = str.charCodeAt(i);
        if (chCode !== 32 /* CharCode.Space */  && chCode !== 9 /* CharCode.Tab */ ) return i;
    }
    return -1;
}
function compare(a, b) {
    if (a < b) return -1;
    else if (a > b) return 1;
    else return 0;
}
function compareSubstring(a, b, aStart = 0, aEnd = a.length, bStart = 0, bEnd = b.length) {
    for(; aStart < aEnd && bStart < bEnd; aStart++, bStart++){
        const codeA = a.charCodeAt(aStart);
        const codeB = b.charCodeAt(bStart);
        if (codeA < codeB) return -1;
        else if (codeA > codeB) return 1;
    }
    const aLen = aEnd - aStart;
    const bLen = bEnd - bStart;
    if (aLen < bLen) return -1;
    else if (aLen > bLen) return 1;
    return 0;
}
function compareIgnoreCase(a, b) {
    return compareSubstringIgnoreCase(a, b, 0, a.length, 0, b.length);
}
function compareSubstringIgnoreCase(a, b, aStart = 0, aEnd = a.length, bStart = 0, bEnd = b.length) {
    for(; aStart < aEnd && bStart < bEnd; aStart++, bStart++){
        let codeA = a.charCodeAt(aStart);
        let codeB = b.charCodeAt(bStart);
        if (codeA === codeB) continue;
        if (codeA >= 128 || codeB >= 128) // not ASCII letters -> fallback to lower-casing strings
        return compareSubstring(a.toLowerCase(), b.toLowerCase(), aStart, aEnd, bStart, bEnd);
        // mapper lower-case ascii letter onto upper-case varinats
        // [97-122] (lower ascii) --> [65-90] (upper ascii)
        if (isLowerAsciiLetter(codeA)) codeA -= 32;
        if (isLowerAsciiLetter(codeB)) codeB -= 32;
        // compare both code points
        const diff = codeA - codeB;
        if (diff === 0) continue;
        return diff;
    }
    const aLen = aEnd - aStart;
    const bLen = bEnd - bStart;
    if (aLen < bLen) return -1;
    else if (aLen > bLen) return 1;
    return 0;
}
function isAsciiDigit(code) {
    return code >= 48 /* CharCode.Digit0 */  && code <= 57 /* CharCode.Digit9 */ ;
}
function isLowerAsciiLetter(code) {
    return code >= 97 /* CharCode.a */  && code <= 122 /* CharCode.z */ ;
}
function isUpperAsciiLetter(code) {
    return code >= 65 /* CharCode.A */  && code <= 90 /* CharCode.Z */ ;
}
function equalsIgnoreCase(a, b) {
    return a.length === b.length && compareSubstringIgnoreCase(a, b) === 0;
}
function startsWithIgnoreCase(str, candidate) {
    const candidateLength = candidate.length;
    if (candidate.length > str.length) return false;
    return compareSubstringIgnoreCase(str, candidate, 0, candidateLength) === 0;
}
function commonPrefixLength(a, b) {
    const len = Math.min(a.length, b.length);
    let i;
    for(i = 0; i < len; i++){
        if (a.charCodeAt(i) !== b.charCodeAt(i)) return i;
    }
    return len;
}
function commonSuffixLength(a, b) {
    const len = Math.min(a.length, b.length);
    let i;
    const aLastIndex = a.length - 1;
    const bLastIndex = b.length - 1;
    for(i = 0; i < len; i++){
        if (a.charCodeAt(aLastIndex - i) !== b.charCodeAt(bLastIndex - i)) return i;
    }
    return len;
}
function isHighSurrogate(charCode) {
    return 0xD800 <= charCode && charCode <= 0xDBFF;
}
function isLowSurrogate(charCode) {
    return 0xDC00 <= charCode && charCode <= 0xDFFF;
}
function computeCodePoint(highSurrogate, lowSurrogate) {
    return (highSurrogate - 0xD800 << 10) + (lowSurrogate - 0xDC00) + 0x10000;
}
function getNextCodePoint(str, len, offset) {
    const charCode = str.charCodeAt(offset);
    if (isHighSurrogate(charCode) && offset + 1 < len) {
        const nextCharCode = str.charCodeAt(offset + 1);
        if (isLowSurrogate(nextCharCode)) return computeCodePoint(charCode, nextCharCode);
    }
    return charCode;
}
/**
 * get the code point that ends right before offset `offset`
 */ function getPrevCodePoint(str, offset) {
    const charCode = str.charCodeAt(offset - 1);
    if (isLowSurrogate(charCode) && offset > 1) {
        const prevCharCode = str.charCodeAt(offset - 2);
        if (isHighSurrogate(prevCharCode)) return computeCodePoint(prevCharCode, charCode);
    }
    return charCode;
}
class CodePointIterator {
    get offset() {
        return this._offset;
    }
    constructor(str, offset = 0){
        this._str = str;
        this._len = str.length;
        this._offset = offset;
    }
    setOffset(offset) {
        this._offset = offset;
    }
    prevCodePoint() {
        const codePoint = getPrevCodePoint(this._str, this._offset);
        this._offset -= codePoint >= 65536 /* Constants.UNICODE_SUPPLEMENTARY_PLANE_BEGIN */  ? 2 : 1;
        return codePoint;
    }
    nextCodePoint() {
        const codePoint = getNextCodePoint(this._str, this._len, this._offset);
        this._offset += codePoint >= 65536 /* Constants.UNICODE_SUPPLEMENTARY_PLANE_BEGIN */  ? 2 : 1;
        return codePoint;
    }
    eol() {
        return this._offset >= this._len;
    }
}
class GraphemeIterator {
    get offset() {
        return this._iterator.offset;
    }
    constructor(str, offset = 0){
        this._iterator = new CodePointIterator(str, offset);
    }
    nextGraphemeLength() {
        const graphemeBreakTree = GraphemeBreakTree.getInstance();
        const iterator = this._iterator;
        const initialOffset = iterator.offset;
        let graphemeBreakType = graphemeBreakTree.getGraphemeBreakType(iterator.nextCodePoint());
        while(!iterator.eol()){
            const offset = iterator.offset;
            const nextGraphemeBreakType = graphemeBreakTree.getGraphemeBreakType(iterator.nextCodePoint());
            if (breakBetweenGraphemeBreakType(graphemeBreakType, nextGraphemeBreakType)) {
                // move iterator back
                iterator.setOffset(offset);
                break;
            }
            graphemeBreakType = nextGraphemeBreakType;
        }
        return iterator.offset - initialOffset;
    }
    prevGraphemeLength() {
        const graphemeBreakTree = GraphemeBreakTree.getInstance();
        const iterator = this._iterator;
        const initialOffset = iterator.offset;
        let graphemeBreakType = graphemeBreakTree.getGraphemeBreakType(iterator.prevCodePoint());
        while(iterator.offset > 0){
            const offset = iterator.offset;
            const prevGraphemeBreakType = graphemeBreakTree.getGraphemeBreakType(iterator.prevCodePoint());
            if (breakBetweenGraphemeBreakType(prevGraphemeBreakType, graphemeBreakType)) {
                // move iterator back
                iterator.setOffset(offset);
                break;
            }
            graphemeBreakType = prevGraphemeBreakType;
        }
        return initialOffset - iterator.offset;
    }
    eol() {
        return this._iterator.eol();
    }
}
function nextCharLength(str, initialOffset) {
    const iterator = new GraphemeIterator(str, initialOffset);
    return iterator.nextGraphemeLength();
}
function prevCharLength(str, initialOffset) {
    const iterator = new GraphemeIterator(str, initialOffset);
    return iterator.prevGraphemeLength();
}
function getCharContainingOffset(str, offset) {
    if (offset > 0 && isLowSurrogate(str.charCodeAt(offset))) offset--;
    const endOffset = offset + nextCharLength(str, offset);
    const startOffset = endOffset - prevCharLength(str, endOffset);
    return [
        startOffset,
        endOffset
    ];
}
let CONTAINS_RTL = undefined;
function makeContainsRtl() {
    // Generated using https://github.com/alexdima/unicode-utils/blob/main/rtl-test.js
    return /(?:[\u05BE\u05C0\u05C3\u05C6\u05D0-\u05F4\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u0710\u0712-\u072F\u074D-\u07A5\u07B1-\u07EA\u07F4\u07F5\u07FA\u07FE-\u0815\u081A\u0824\u0828\u0830-\u0858\u085E-\u088E\u08A0-\u08C9\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFD3D\uFD50-\uFDC7\uFDF0-\uFDFC\uFE70-\uFEFC]|\uD802[\uDC00-\uDD1B\uDD20-\uDE00\uDE10-\uDE35\uDE40-\uDEE4\uDEEB-\uDF35\uDF40-\uDFFF]|\uD803[\uDC00-\uDD23\uDE80-\uDEA9\uDEAD-\uDF45\uDF51-\uDF81\uDF86-\uDFF6]|\uD83A[\uDC00-\uDCCF\uDD00-\uDD43\uDD4B-\uDFFF]|\uD83B[\uDC00-\uDEBB])/;
}
function containsRTL(str) {
    if (!CONTAINS_RTL) CONTAINS_RTL = makeContainsRtl();
    return CONTAINS_RTL.test(str);
}
const IS_BASIC_ASCII = /^[\t\n\r\x20-\x7E]*$/;
function isBasicASCII(str) {
    return IS_BASIC_ASCII.test(str);
}
const UNUSUAL_LINE_TERMINATORS = /[\u2028\u2029]/; // LINE SEPARATOR (LS) or PARAGRAPH SEPARATOR (PS)
function containsUnusualLineTerminators(str) {
    return UNUSUAL_LINE_TERMINATORS.test(str);
}
function isFullWidthCharacter(charCode) {
    // Do a cheap trick to better support wrapping of wide characters, treat them as 2 columns
    // http://jrgraphix.net/research/unicode_blocks.php
    //          2E80 - 2EFF   CJK Radicals Supplement
    //          2F00 - 2FDF   Kangxi Radicals
    //          2FF0 - 2FFF   Ideographic Description Characters
    //          3000 - 303F   CJK Symbols and Punctuation
    //          3040 - 309F   Hiragana
    //          30A0 - 30FF   Katakana
    //          3100 - 312F   Bopomofo
    //          3130 - 318F   Hangul Compatibility Jamo
    //          3190 - 319F   Kanbun
    //          31A0 - 31BF   Bopomofo Extended
    //          31F0 - 31FF   Katakana Phonetic Extensions
    //          3200 - 32FF   Enclosed CJK Letters and Months
    //          3300 - 33FF   CJK Compatibility
    //          3400 - 4DBF   CJK Unified Ideographs Extension A
    //          4DC0 - 4DFF   Yijing Hexagram Symbols
    //          4E00 - 9FFF   CJK Unified Ideographs
    //          A000 - A48F   Yi Syllables
    //          A490 - A4CF   Yi Radicals
    //          AC00 - D7AF   Hangul Syllables
    // [IGNORE] D800 - DB7F   High Surrogates
    // [IGNORE] DB80 - DBFF   High Private Use Surrogates
    // [IGNORE] DC00 - DFFF   Low Surrogates
    // [IGNORE] E000 - F8FF   Private Use Area
    //          F900 - FAFF   CJK Compatibility Ideographs
    // [IGNORE] FB00 - FB4F   Alphabetic Presentation Forms
    // [IGNORE] FB50 - FDFF   Arabic Presentation Forms-A
    // [IGNORE] FE00 - FE0F   Variation Selectors
    // [IGNORE] FE20 - FE2F   Combining Half Marks
    // [IGNORE] FE30 - FE4F   CJK Compatibility Forms
    // [IGNORE] FE50 - FE6F   Small Form Variants
    // [IGNORE] FE70 - FEFF   Arabic Presentation Forms-B
    //          FF00 - FFEF   Halfwidth and Fullwidth Forms
    //               [https://en.wikipedia.org/wiki/Halfwidth_and_fullwidth_forms]
    //               of which FF01 - FF5E fullwidth ASCII of 21 to 7E
    // [IGNORE]    and FF65 - FFDC halfwidth of Katakana and Hangul
    // [IGNORE] FFF0 - FFFF   Specials
    return charCode >= 0x2E80 && charCode <= 0xD7AF || charCode >= 0xF900 && charCode <= 0xFAFF || charCode >= 0xFF01 && charCode <= 0xFF5E;
}
function isEmojiImprecise(x) {
    return x >= 0x1F1E6 && x <= 0x1F1FF || x === 8986 || x === 8987 || x === 9200 || x === 9203 || x >= 9728 && x <= 10175 || x === 11088 || x === 11093 || x >= 127744 && x <= 128591 || x >= 128640 && x <= 128764 || x >= 128992 && x <= 129008 || x >= 129280 && x <= 129535 || x >= 129648 && x <= 129782;
}
const UTF8_BOM_CHARACTER = String.fromCharCode(65279 /* CharCode.UTF8_BOM */ );
function startsWithUTF8BOM(str) {
    return !!(str && str.length > 0 && str.charCodeAt(0) === 65279 /* CharCode.UTF8_BOM */ );
}
function containsUppercaseCharacter(target, ignoreEscapedChars = false) {
    if (!target) return false;
    if (ignoreEscapedChars) target = target.replace(/\\./g, "");
    return target.toLowerCase() !== target;
}
function singleLetterHash(n) {
    const LETTERS_CNT = 26;
    n = n % (2 * LETTERS_CNT);
    if (n < LETTERS_CNT) return String.fromCharCode(97 /* CharCode.a */  + n);
    return String.fromCharCode(65 /* CharCode.A */  + n - LETTERS_CNT);
}
function breakBetweenGraphemeBreakType(breakTypeA, breakTypeB) {
    // http://www.unicode.org/reports/tr29/#Grapheme_Cluster_Boundary_Rules
    // !!! Let's make the common case a bit faster
    if (breakTypeA === 0 /* GraphemeBreakType.Other */ ) // see https://www.unicode.org/Public/13.0.0/ucd/auxiliary/GraphemeBreakTest-13.0.0d10.html#table
    return breakTypeB !== 5 /* GraphemeBreakType.Extend */  && breakTypeB !== 7 /* GraphemeBreakType.SpacingMark */ ;
    // Do not break between a CR and LF. Otherwise, break before and after controls.
    // GB3                                        CR × LF
    // GB4                       (Control | CR | LF) ÷
    // GB5                                           ÷ (Control | CR | LF)
    if (breakTypeA === 2 /* GraphemeBreakType.CR */ ) {
        if (breakTypeB === 3 /* GraphemeBreakType.LF */ ) return false; // GB3
    }
    if (breakTypeA === 4 /* GraphemeBreakType.Control */  || breakTypeA === 2 /* GraphemeBreakType.CR */  || breakTypeA === 3 /* GraphemeBreakType.LF */ ) return true; // GB4
    if (breakTypeB === 4 /* GraphemeBreakType.Control */  || breakTypeB === 2 /* GraphemeBreakType.CR */  || breakTypeB === 3 /* GraphemeBreakType.LF */ ) return true; // GB5
    // Do not break Hangul syllable sequences.
    // GB6                                         L × (L | V | LV | LVT)
    // GB7                                  (LV | V) × (V | T)
    // GB8                                 (LVT | T) × T
    if (breakTypeA === 8 /* GraphemeBreakType.L */ ) {
        if (breakTypeB === 8 /* GraphemeBreakType.L */  || breakTypeB === 9 /* GraphemeBreakType.V */  || breakTypeB === 11 /* GraphemeBreakType.LV */  || breakTypeB === 12 /* GraphemeBreakType.LVT */ ) return false; // GB6
    }
    if (breakTypeA === 11 /* GraphemeBreakType.LV */  || breakTypeA === 9 /* GraphemeBreakType.V */ ) {
        if (breakTypeB === 9 /* GraphemeBreakType.V */  || breakTypeB === 10 /* GraphemeBreakType.T */ ) return false; // GB7
    }
    if (breakTypeA === 12 /* GraphemeBreakType.LVT */  || breakTypeA === 10 /* GraphemeBreakType.T */ ) {
        if (breakTypeB === 10 /* GraphemeBreakType.T */ ) return false; // GB8
    }
    // Do not break before extending characters or ZWJ.
    // GB9                                           × (Extend | ZWJ)
    if (breakTypeB === 5 /* GraphemeBreakType.Extend */  || breakTypeB === 13 /* GraphemeBreakType.ZWJ */ ) return false; // GB9
    // The GB9a and GB9b rules only apply to extended grapheme clusters:
    // Do not break before SpacingMarks, or after Prepend characters.
    // GB9a                                          × SpacingMark
    // GB9b                                  Prepend ×
    if (breakTypeB === 7 /* GraphemeBreakType.SpacingMark */ ) return false; // GB9a
    if (breakTypeA === 1 /* GraphemeBreakType.Prepend */ ) return false; // GB9b
    // Do not break within emoji modifier sequences or emoji zwj sequences.
    // GB11    \p{Extended_Pictographic} Extend* ZWJ × \p{Extended_Pictographic}
    if (breakTypeA === 13 /* GraphemeBreakType.ZWJ */  && breakTypeB === 14 /* GraphemeBreakType.Extended_Pictographic */ ) // Note: we are not implementing the rule entirely here to avoid introducing states
    return false; // GB11
    // GB12                          sot (RI RI)* RI × RI
    // GB13                        [^RI] (RI RI)* RI × RI
    if (breakTypeA === 6 /* GraphemeBreakType.Regional_Indicator */  && breakTypeB === 6 /* GraphemeBreakType.Regional_Indicator */ ) // Note: we are not implementing the rule entirely here to avoid introducing states
    return false; // GB12 & GB13
    // GB999                                     Any ÷ Any
    return true;
}
class GraphemeBreakTree {
    static{
        this._INSTANCE = null;
    }
    static getInstance() {
        if (!GraphemeBreakTree._INSTANCE) GraphemeBreakTree._INSTANCE = new GraphemeBreakTree();
        return GraphemeBreakTree._INSTANCE;
    }
    constructor(){
        this._data = getGraphemeBreakRawData();
    }
    getGraphemeBreakType(codePoint) {
        // !!! Let's make 7bit ASCII a bit faster: 0..31
        if (codePoint < 32) {
            if (codePoint === 10 /* CharCode.LineFeed */ ) return 3 /* GraphemeBreakType.LF */ ;
            if (codePoint === 13 /* CharCode.CarriageReturn */ ) return 2 /* GraphemeBreakType.CR */ ;
            return 4 /* GraphemeBreakType.Control */ ;
        }
        // !!! Let's make 7bit ASCII a bit faster: 32..126
        if (codePoint < 127) return 0 /* GraphemeBreakType.Other */ ;
        const data = this._data;
        const nodeCount = data.length / 3;
        let nodeIndex = 1;
        while(nodeIndex <= nodeCount){
            if (codePoint < data[3 * nodeIndex]) // go left
            nodeIndex = 2 * nodeIndex;
            else if (codePoint > data[3 * nodeIndex + 1]) // go right
            nodeIndex = 2 * nodeIndex + 1;
            else // hit
            return data[3 * nodeIndex + 2];
        }
        return 0 /* GraphemeBreakType.Other */ ;
    }
}
function getGraphemeBreakRawData() {
    // generated using https://github.com/alexdima/unicode-utils/blob/main/grapheme-break.js
    return JSON.parse("[0,0,0,51229,51255,12,44061,44087,12,127462,127487,6,7083,7085,5,47645,47671,12,54813,54839,12,128678,128678,14,3270,3270,5,9919,9923,14,45853,45879,12,49437,49463,12,53021,53047,12,71216,71218,7,128398,128399,14,129360,129374,14,2519,2519,5,4448,4519,9,9742,9742,14,12336,12336,14,44957,44983,12,46749,46775,12,48541,48567,12,50333,50359,12,52125,52151,12,53917,53943,12,69888,69890,5,73018,73018,5,127990,127990,14,128558,128559,14,128759,128760,14,129653,129655,14,2027,2035,5,2891,2892,7,3761,3761,5,6683,6683,5,8293,8293,4,9825,9826,14,9999,9999,14,43452,43453,5,44509,44535,12,45405,45431,12,46301,46327,12,47197,47223,12,48093,48119,12,48989,49015,12,49885,49911,12,50781,50807,12,51677,51703,12,52573,52599,12,53469,53495,12,54365,54391,12,65279,65279,4,70471,70472,7,72145,72147,7,119173,119179,5,127799,127818,14,128240,128244,14,128512,128512,14,128652,128652,14,128721,128722,14,129292,129292,14,129445,129450,14,129734,129743,14,1476,1477,5,2366,2368,7,2750,2752,7,3076,3076,5,3415,3415,5,4141,4144,5,6109,6109,5,6964,6964,5,7394,7400,5,9197,9198,14,9770,9770,14,9877,9877,14,9968,9969,14,10084,10084,14,43052,43052,5,43713,43713,5,44285,44311,12,44733,44759,12,45181,45207,12,45629,45655,12,46077,46103,12,46525,46551,12,46973,46999,12,47421,47447,12,47869,47895,12,48317,48343,12,48765,48791,12,49213,49239,12,49661,49687,12,50109,50135,12,50557,50583,12,51005,51031,12,51453,51479,12,51901,51927,12,52349,52375,12,52797,52823,12,53245,53271,12,53693,53719,12,54141,54167,12,54589,54615,12,55037,55063,12,69506,69509,5,70191,70193,5,70841,70841,7,71463,71467,5,72330,72342,5,94031,94031,5,123628,123631,5,127763,127765,14,127941,127941,14,128043,128062,14,128302,128317,14,128465,128467,14,128539,128539,14,128640,128640,14,128662,128662,14,128703,128703,14,128745,128745,14,129004,129007,14,129329,129330,14,129402,129402,14,129483,129483,14,129686,129704,14,130048,131069,14,173,173,4,1757,1757,1,2200,2207,5,2434,2435,7,2631,2632,5,2817,2817,5,3008,3008,5,3201,3201,5,3387,3388,5,3542,3542,5,3902,3903,7,4190,4192,5,6002,6003,5,6439,6440,5,6765,6770,7,7019,7027,5,7154,7155,7,8205,8205,13,8505,8505,14,9654,9654,14,9757,9757,14,9792,9792,14,9852,9853,14,9890,9894,14,9937,9937,14,9981,9981,14,10035,10036,14,11035,11036,14,42654,42655,5,43346,43347,7,43587,43587,5,44006,44007,7,44173,44199,12,44397,44423,12,44621,44647,12,44845,44871,12,45069,45095,12,45293,45319,12,45517,45543,12,45741,45767,12,45965,45991,12,46189,46215,12,46413,46439,12,46637,46663,12,46861,46887,12,47085,47111,12,47309,47335,12,47533,47559,12,47757,47783,12,47981,48007,12,48205,48231,12,48429,48455,12,48653,48679,12,48877,48903,12,49101,49127,12,49325,49351,12,49549,49575,12,49773,49799,12,49997,50023,12,50221,50247,12,50445,50471,12,50669,50695,12,50893,50919,12,51117,51143,12,51341,51367,12,51565,51591,12,51789,51815,12,52013,52039,12,52237,52263,12,52461,52487,12,52685,52711,12,52909,52935,12,53133,53159,12,53357,53383,12,53581,53607,12,53805,53831,12,54029,54055,12,54253,54279,12,54477,54503,12,54701,54727,12,54925,54951,12,55149,55175,12,68101,68102,5,69762,69762,7,70067,70069,7,70371,70378,5,70720,70721,7,71087,71087,5,71341,71341,5,71995,71996,5,72249,72249,7,72850,72871,5,73109,73109,5,118576,118598,5,121505,121519,5,127245,127247,14,127568,127569,14,127777,127777,14,127872,127891,14,127956,127967,14,128015,128016,14,128110,128172,14,128259,128259,14,128367,128368,14,128424,128424,14,128488,128488,14,128530,128532,14,128550,128551,14,128566,128566,14,128647,128647,14,128656,128656,14,128667,128673,14,128691,128693,14,128715,128715,14,128728,128732,14,128752,128752,14,128765,128767,14,129096,129103,14,129311,129311,14,129344,129349,14,129394,129394,14,129413,129425,14,129466,129471,14,129511,129535,14,129664,129666,14,129719,129722,14,129760,129767,14,917536,917631,5,13,13,2,1160,1161,5,1564,1564,4,1807,1807,1,2085,2087,5,2307,2307,7,2382,2383,7,2497,2500,5,2563,2563,7,2677,2677,5,2763,2764,7,2879,2879,5,2914,2915,5,3021,3021,5,3142,3144,5,3263,3263,5,3285,3286,5,3398,3400,7,3530,3530,5,3633,3633,5,3864,3865,5,3974,3975,5,4155,4156,7,4229,4230,5,5909,5909,7,6078,6085,7,6277,6278,5,6451,6456,7,6744,6750,5,6846,6846,5,6972,6972,5,7074,7077,5,7146,7148,7,7222,7223,5,7416,7417,5,8234,8238,4,8417,8417,5,9000,9000,14,9203,9203,14,9730,9731,14,9748,9749,14,9762,9763,14,9776,9783,14,9800,9811,14,9831,9831,14,9872,9873,14,9882,9882,14,9900,9903,14,9929,9933,14,9941,9960,14,9974,9974,14,9989,9989,14,10006,10006,14,10062,10062,14,10160,10160,14,11647,11647,5,12953,12953,14,43019,43019,5,43232,43249,5,43443,43443,5,43567,43568,7,43696,43696,5,43765,43765,7,44013,44013,5,44117,44143,12,44229,44255,12,44341,44367,12,44453,44479,12,44565,44591,12,44677,44703,12,44789,44815,12,44901,44927,12,45013,45039,12,45125,45151,12,45237,45263,12,45349,45375,12,45461,45487,12,45573,45599,12,45685,45711,12,45797,45823,12,45909,45935,12,46021,46047,12,46133,46159,12,46245,46271,12,46357,46383,12,46469,46495,12,46581,46607,12,46693,46719,12,46805,46831,12,46917,46943,12,47029,47055,12,47141,47167,12,47253,47279,12,47365,47391,12,47477,47503,12,47589,47615,12,47701,47727,12,47813,47839,12,47925,47951,12,48037,48063,12,48149,48175,12,48261,48287,12,48373,48399,12,48485,48511,12,48597,48623,12,48709,48735,12,48821,48847,12,48933,48959,12,49045,49071,12,49157,49183,12,49269,49295,12,49381,49407,12,49493,49519,12,49605,49631,12,49717,49743,12,49829,49855,12,49941,49967,12,50053,50079,12,50165,50191,12,50277,50303,12,50389,50415,12,50501,50527,12,50613,50639,12,50725,50751,12,50837,50863,12,50949,50975,12,51061,51087,12,51173,51199,12,51285,51311,12,51397,51423,12,51509,51535,12,51621,51647,12,51733,51759,12,51845,51871,12,51957,51983,12,52069,52095,12,52181,52207,12,52293,52319,12,52405,52431,12,52517,52543,12,52629,52655,12,52741,52767,12,52853,52879,12,52965,52991,12,53077,53103,12,53189,53215,12,53301,53327,12,53413,53439,12,53525,53551,12,53637,53663,12,53749,53775,12,53861,53887,12,53973,53999,12,54085,54111,12,54197,54223,12,54309,54335,12,54421,54447,12,54533,54559,12,54645,54671,12,54757,54783,12,54869,54895,12,54981,55007,12,55093,55119,12,55243,55291,10,66045,66045,5,68325,68326,5,69688,69702,5,69817,69818,5,69957,69958,7,70089,70092,5,70198,70199,5,70462,70462,5,70502,70508,5,70750,70750,5,70846,70846,7,71100,71101,5,71230,71230,7,71351,71351,5,71737,71738,5,72000,72000,7,72160,72160,5,72273,72278,5,72752,72758,5,72882,72883,5,73031,73031,5,73461,73462,7,94192,94193,7,119149,119149,7,121403,121452,5,122915,122916,5,126980,126980,14,127358,127359,14,127535,127535,14,127759,127759,14,127771,127771,14,127792,127793,14,127825,127867,14,127897,127899,14,127945,127945,14,127985,127986,14,128000,128007,14,128021,128021,14,128066,128100,14,128184,128235,14,128249,128252,14,128266,128276,14,128335,128335,14,128379,128390,14,128407,128419,14,128444,128444,14,128481,128481,14,128499,128499,14,128526,128526,14,128536,128536,14,128543,128543,14,128556,128556,14,128564,128564,14,128577,128580,14,128643,128645,14,128649,128649,14,128654,128654,14,128660,128660,14,128664,128664,14,128675,128675,14,128686,128689,14,128695,128696,14,128705,128709,14,128717,128719,14,128725,128725,14,128736,128741,14,128747,128748,14,128755,128755,14,128762,128762,14,128981,128991,14,129009,129023,14,129160,129167,14,129296,129304,14,129320,129327,14,129340,129342,14,129356,129356,14,129388,129392,14,129399,129400,14,129404,129407,14,129432,129442,14,129454,129455,14,129473,129474,14,129485,129487,14,129648,129651,14,129659,129660,14,129671,129679,14,129709,129711,14,129728,129730,14,129751,129753,14,129776,129782,14,917505,917505,4,917760,917999,5,10,10,3,127,159,4,768,879,5,1471,1471,5,1536,1541,1,1648,1648,5,1767,1768,5,1840,1866,5,2070,2073,5,2137,2139,5,2274,2274,1,2363,2363,7,2377,2380,7,2402,2403,5,2494,2494,5,2507,2508,7,2558,2558,5,2622,2624,7,2641,2641,5,2691,2691,7,2759,2760,5,2786,2787,5,2876,2876,5,2881,2884,5,2901,2902,5,3006,3006,5,3014,3016,7,3072,3072,5,3134,3136,5,3157,3158,5,3260,3260,5,3266,3266,5,3274,3275,7,3328,3329,5,3391,3392,7,3405,3405,5,3457,3457,5,3536,3537,7,3551,3551,5,3636,3642,5,3764,3772,5,3895,3895,5,3967,3967,7,3993,4028,5,4146,4151,5,4182,4183,7,4226,4226,5,4253,4253,5,4957,4959,5,5940,5940,7,6070,6070,7,6087,6088,7,6158,6158,4,6432,6434,5,6448,6449,7,6679,6680,5,6742,6742,5,6754,6754,5,6783,6783,5,6912,6915,5,6966,6970,5,6978,6978,5,7042,7042,7,7080,7081,5,7143,7143,7,7150,7150,7,7212,7219,5,7380,7392,5,7412,7412,5,8203,8203,4,8232,8232,4,8265,8265,14,8400,8412,5,8421,8432,5,8617,8618,14,9167,9167,14,9200,9200,14,9410,9410,14,9723,9726,14,9733,9733,14,9745,9745,14,9752,9752,14,9760,9760,14,9766,9766,14,9774,9774,14,9786,9786,14,9794,9794,14,9823,9823,14,9828,9828,14,9833,9850,14,9855,9855,14,9875,9875,14,9880,9880,14,9885,9887,14,9896,9897,14,9906,9916,14,9926,9927,14,9935,9935,14,9939,9939,14,9962,9962,14,9972,9972,14,9978,9978,14,9986,9986,14,9997,9997,14,10002,10002,14,10017,10017,14,10055,10055,14,10071,10071,14,10133,10135,14,10548,10549,14,11093,11093,14,12330,12333,5,12441,12442,5,42608,42610,5,43010,43010,5,43045,43046,5,43188,43203,7,43302,43309,5,43392,43394,5,43446,43449,5,43493,43493,5,43571,43572,7,43597,43597,7,43703,43704,5,43756,43757,5,44003,44004,7,44009,44010,7,44033,44059,12,44089,44115,12,44145,44171,12,44201,44227,12,44257,44283,12,44313,44339,12,44369,44395,12,44425,44451,12,44481,44507,12,44537,44563,12,44593,44619,12,44649,44675,12,44705,44731,12,44761,44787,12,44817,44843,12,44873,44899,12,44929,44955,12,44985,45011,12,45041,45067,12,45097,45123,12,45153,45179,12,45209,45235,12,45265,45291,12,45321,45347,12,45377,45403,12,45433,45459,12,45489,45515,12,45545,45571,12,45601,45627,12,45657,45683,12,45713,45739,12,45769,45795,12,45825,45851,12,45881,45907,12,45937,45963,12,45993,46019,12,46049,46075,12,46105,46131,12,46161,46187,12,46217,46243,12,46273,46299,12,46329,46355,12,46385,46411,12,46441,46467,12,46497,46523,12,46553,46579,12,46609,46635,12,46665,46691,12,46721,46747,12,46777,46803,12,46833,46859,12,46889,46915,12,46945,46971,12,47001,47027,12,47057,47083,12,47113,47139,12,47169,47195,12,47225,47251,12,47281,47307,12,47337,47363,12,47393,47419,12,47449,47475,12,47505,47531,12,47561,47587,12,47617,47643,12,47673,47699,12,47729,47755,12,47785,47811,12,47841,47867,12,47897,47923,12,47953,47979,12,48009,48035,12,48065,48091,12,48121,48147,12,48177,48203,12,48233,48259,12,48289,48315,12,48345,48371,12,48401,48427,12,48457,48483,12,48513,48539,12,48569,48595,12,48625,48651,12,48681,48707,12,48737,48763,12,48793,48819,12,48849,48875,12,48905,48931,12,48961,48987,12,49017,49043,12,49073,49099,12,49129,49155,12,49185,49211,12,49241,49267,12,49297,49323,12,49353,49379,12,49409,49435,12,49465,49491,12,49521,49547,12,49577,49603,12,49633,49659,12,49689,49715,12,49745,49771,12,49801,49827,12,49857,49883,12,49913,49939,12,49969,49995,12,50025,50051,12,50081,50107,12,50137,50163,12,50193,50219,12,50249,50275,12,50305,50331,12,50361,50387,12,50417,50443,12,50473,50499,12,50529,50555,12,50585,50611,12,50641,50667,12,50697,50723,12,50753,50779,12,50809,50835,12,50865,50891,12,50921,50947,12,50977,51003,12,51033,51059,12,51089,51115,12,51145,51171,12,51201,51227,12,51257,51283,12,51313,51339,12,51369,51395,12,51425,51451,12,51481,51507,12,51537,51563,12,51593,51619,12,51649,51675,12,51705,51731,12,51761,51787,12,51817,51843,12,51873,51899,12,51929,51955,12,51985,52011,12,52041,52067,12,52097,52123,12,52153,52179,12,52209,52235,12,52265,52291,12,52321,52347,12,52377,52403,12,52433,52459,12,52489,52515,12,52545,52571,12,52601,52627,12,52657,52683,12,52713,52739,12,52769,52795,12,52825,52851,12,52881,52907,12,52937,52963,12,52993,53019,12,53049,53075,12,53105,53131,12,53161,53187,12,53217,53243,12,53273,53299,12,53329,53355,12,53385,53411,12,53441,53467,12,53497,53523,12,53553,53579,12,53609,53635,12,53665,53691,12,53721,53747,12,53777,53803,12,53833,53859,12,53889,53915,12,53945,53971,12,54001,54027,12,54057,54083,12,54113,54139,12,54169,54195,12,54225,54251,12,54281,54307,12,54337,54363,12,54393,54419,12,54449,54475,12,54505,54531,12,54561,54587,12,54617,54643,12,54673,54699,12,54729,54755,12,54785,54811,12,54841,54867,12,54897,54923,12,54953,54979,12,55009,55035,12,55065,55091,12,55121,55147,12,55177,55203,12,65024,65039,5,65520,65528,4,66422,66426,5,68152,68154,5,69291,69292,5,69633,69633,5,69747,69748,5,69811,69814,5,69826,69826,5,69932,69932,7,70016,70017,5,70079,70080,7,70095,70095,5,70196,70196,5,70367,70367,5,70402,70403,7,70464,70464,5,70487,70487,5,70709,70711,7,70725,70725,7,70833,70834,7,70843,70844,7,70849,70849,7,71090,71093,5,71103,71104,5,71227,71228,7,71339,71339,5,71344,71349,5,71458,71461,5,71727,71735,5,71985,71989,7,71998,71998,5,72002,72002,7,72154,72155,5,72193,72202,5,72251,72254,5,72281,72283,5,72344,72345,5,72766,72766,7,72874,72880,5,72885,72886,5,73023,73029,5,73104,73105,5,73111,73111,5,92912,92916,5,94095,94098,5,113824,113827,4,119142,119142,7,119155,119162,4,119362,119364,5,121476,121476,5,122888,122904,5,123184,123190,5,125252,125258,5,127183,127183,14,127340,127343,14,127377,127386,14,127491,127503,14,127548,127551,14,127744,127756,14,127761,127761,14,127769,127769,14,127773,127774,14,127780,127788,14,127796,127797,14,127820,127823,14,127869,127869,14,127894,127895,14,127902,127903,14,127943,127943,14,127947,127950,14,127972,127972,14,127988,127988,14,127992,127994,14,128009,128011,14,128019,128019,14,128023,128041,14,128064,128064,14,128102,128107,14,128174,128181,14,128238,128238,14,128246,128247,14,128254,128254,14,128264,128264,14,128278,128299,14,128329,128330,14,128348,128359,14,128371,128377,14,128392,128393,14,128401,128404,14,128421,128421,14,128433,128434,14,128450,128452,14,128476,128478,14,128483,128483,14,128495,128495,14,128506,128506,14,128519,128520,14,128528,128528,14,128534,128534,14,128538,128538,14,128540,128542,14,128544,128549,14,128552,128555,14,128557,128557,14,128560,128563,14,128565,128565,14,128567,128576,14,128581,128591,14,128641,128642,14,128646,128646,14,128648,128648,14,128650,128651,14,128653,128653,14,128655,128655,14,128657,128659,14,128661,128661,14,128663,128663,14,128665,128666,14,128674,128674,14,128676,128677,14,128679,128685,14,128690,128690,14,128694,128694,14,128697,128702,14,128704,128704,14,128710,128714,14,128716,128716,14,128720,128720,14,128723,128724,14,128726,128727,14,128733,128735,14,128742,128744,14,128746,128746,14,128749,128751,14,128753,128754,14,128756,128758,14,128761,128761,14,128763,128764,14,128884,128895,14,128992,129003,14,129008,129008,14,129036,129039,14,129114,129119,14,129198,129279,14,129293,129295,14,129305,129310,14,129312,129319,14,129328,129328,14,129331,129338,14,129343,129343,14,129351,129355,14,129357,129359,14,129375,129387,14,129393,129393,14,129395,129398,14,129401,129401,14,129403,129403,14,129408,129412,14,129426,129431,14,129443,129444,14,129451,129453,14,129456,129465,14,129472,129472,14,129475,129482,14,129484,129484,14,129488,129510,14,129536,129647,14,129652,129652,14,129656,129658,14,129661,129663,14,129667,129670,14,129680,129685,14,129705,129708,14,129712,129718,14,129723,129727,14,129731,129733,14,129744,129750,14,129754,129759,14,129768,129775,14,129783,129791,14,917504,917504,4,917506,917535,4,917632,917759,4,918000,921599,4,0,9,4,11,12,4,14,31,4,169,169,14,174,174,14,1155,1159,5,1425,1469,5,1473,1474,5,1479,1479,5,1552,1562,5,1611,1631,5,1750,1756,5,1759,1764,5,1770,1773,5,1809,1809,5,1958,1968,5,2045,2045,5,2075,2083,5,2089,2093,5,2192,2193,1,2250,2273,5,2275,2306,5,2362,2362,5,2364,2364,5,2369,2376,5,2381,2381,5,2385,2391,5,2433,2433,5,2492,2492,5,2495,2496,7,2503,2504,7,2509,2509,5,2530,2531,5,2561,2562,5,2620,2620,5,2625,2626,5,2635,2637,5,2672,2673,5,2689,2690,5,2748,2748,5,2753,2757,5,2761,2761,7,2765,2765,5,2810,2815,5,2818,2819,7,2878,2878,5,2880,2880,7,2887,2888,7,2893,2893,5,2903,2903,5,2946,2946,5,3007,3007,7,3009,3010,7,3018,3020,7,3031,3031,5,3073,3075,7,3132,3132,5,3137,3140,7,3146,3149,5,3170,3171,5,3202,3203,7,3262,3262,7,3264,3265,7,3267,3268,7,3271,3272,7,3276,3277,5,3298,3299,5,3330,3331,7,3390,3390,5,3393,3396,5,3402,3404,7,3406,3406,1,3426,3427,5,3458,3459,7,3535,3535,5,3538,3540,5,3544,3550,7,3570,3571,7,3635,3635,7,3655,3662,5,3763,3763,7,3784,3789,5,3893,3893,5,3897,3897,5,3953,3966,5,3968,3972,5,3981,3991,5,4038,4038,5,4145,4145,7,4153,4154,5,4157,4158,5,4184,4185,5,4209,4212,5,4228,4228,7,4237,4237,5,4352,4447,8,4520,4607,10,5906,5908,5,5938,5939,5,5970,5971,5,6068,6069,5,6071,6077,5,6086,6086,5,6089,6099,5,6155,6157,5,6159,6159,5,6313,6313,5,6435,6438,7,6441,6443,7,6450,6450,5,6457,6459,5,6681,6682,7,6741,6741,7,6743,6743,7,6752,6752,5,6757,6764,5,6771,6780,5,6832,6845,5,6847,6862,5,6916,6916,7,6965,6965,5,6971,6971,7,6973,6977,7,6979,6980,7,7040,7041,5,7073,7073,7,7078,7079,7,7082,7082,7,7142,7142,5,7144,7145,5,7149,7149,5,7151,7153,5,7204,7211,7,7220,7221,7,7376,7378,5,7393,7393,7,7405,7405,5,7415,7415,7,7616,7679,5,8204,8204,5,8206,8207,4,8233,8233,4,8252,8252,14,8288,8292,4,8294,8303,4,8413,8416,5,8418,8420,5,8482,8482,14,8596,8601,14,8986,8987,14,9096,9096,14,9193,9196,14,9199,9199,14,9201,9202,14,9208,9210,14,9642,9643,14,9664,9664,14,9728,9729,14,9732,9732,14,9735,9741,14,9743,9744,14,9746,9746,14,9750,9751,14,9753,9756,14,9758,9759,14,9761,9761,14,9764,9765,14,9767,9769,14,9771,9773,14,9775,9775,14,9784,9785,14,9787,9791,14,9793,9793,14,9795,9799,14,9812,9822,14,9824,9824,14,9827,9827,14,9829,9830,14,9832,9832,14,9851,9851,14,9854,9854,14,9856,9861,14,9874,9874,14,9876,9876,14,9878,9879,14,9881,9881,14,9883,9884,14,9888,9889,14,9895,9895,14,9898,9899,14,9904,9905,14,9917,9918,14,9924,9925,14,9928,9928,14,9934,9934,14,9936,9936,14,9938,9938,14,9940,9940,14,9961,9961,14,9963,9967,14,9970,9971,14,9973,9973,14,9975,9977,14,9979,9980,14,9982,9985,14,9987,9988,14,9992,9996,14,9998,9998,14,10000,10001,14,10004,10004,14,10013,10013,14,10024,10024,14,10052,10052,14,10060,10060,14,10067,10069,14,10083,10083,14,10085,10087,14,10145,10145,14,10175,10175,14,11013,11015,14,11088,11088,14,11503,11505,5,11744,11775,5,12334,12335,5,12349,12349,14,12951,12951,14,42607,42607,5,42612,42621,5,42736,42737,5,43014,43014,5,43043,43044,7,43047,43047,7,43136,43137,7,43204,43205,5,43263,43263,5,43335,43345,5,43360,43388,8,43395,43395,7,43444,43445,7,43450,43451,7,43454,43456,7,43561,43566,5,43569,43570,5,43573,43574,5,43596,43596,5,43644,43644,5,43698,43700,5,43710,43711,5,43755,43755,7,43758,43759,7,43766,43766,5,44005,44005,5,44008,44008,5,44012,44012,7,44032,44032,11,44060,44060,11,44088,44088,11,44116,44116,11,44144,44144,11,44172,44172,11,44200,44200,11,44228,44228,11,44256,44256,11,44284,44284,11,44312,44312,11,44340,44340,11,44368,44368,11,44396,44396,11,44424,44424,11,44452,44452,11,44480,44480,11,44508,44508,11,44536,44536,11,44564,44564,11,44592,44592,11,44620,44620,11,44648,44648,11,44676,44676,11,44704,44704,11,44732,44732,11,44760,44760,11,44788,44788,11,44816,44816,11,44844,44844,11,44872,44872,11,44900,44900,11,44928,44928,11,44956,44956,11,44984,44984,11,45012,45012,11,45040,45040,11,45068,45068,11,45096,45096,11,45124,45124,11,45152,45152,11,45180,45180,11,45208,45208,11,45236,45236,11,45264,45264,11,45292,45292,11,45320,45320,11,45348,45348,11,45376,45376,11,45404,45404,11,45432,45432,11,45460,45460,11,45488,45488,11,45516,45516,11,45544,45544,11,45572,45572,11,45600,45600,11,45628,45628,11,45656,45656,11,45684,45684,11,45712,45712,11,45740,45740,11,45768,45768,11,45796,45796,11,45824,45824,11,45852,45852,11,45880,45880,11,45908,45908,11,45936,45936,11,45964,45964,11,45992,45992,11,46020,46020,11,46048,46048,11,46076,46076,11,46104,46104,11,46132,46132,11,46160,46160,11,46188,46188,11,46216,46216,11,46244,46244,11,46272,46272,11,46300,46300,11,46328,46328,11,46356,46356,11,46384,46384,11,46412,46412,11,46440,46440,11,46468,46468,11,46496,46496,11,46524,46524,11,46552,46552,11,46580,46580,11,46608,46608,11,46636,46636,11,46664,46664,11,46692,46692,11,46720,46720,11,46748,46748,11,46776,46776,11,46804,46804,11,46832,46832,11,46860,46860,11,46888,46888,11,46916,46916,11,46944,46944,11,46972,46972,11,47000,47000,11,47028,47028,11,47056,47056,11,47084,47084,11,47112,47112,11,47140,47140,11,47168,47168,11,47196,47196,11,47224,47224,11,47252,47252,11,47280,47280,11,47308,47308,11,47336,47336,11,47364,47364,11,47392,47392,11,47420,47420,11,47448,47448,11,47476,47476,11,47504,47504,11,47532,47532,11,47560,47560,11,47588,47588,11,47616,47616,11,47644,47644,11,47672,47672,11,47700,47700,11,47728,47728,11,47756,47756,11,47784,47784,11,47812,47812,11,47840,47840,11,47868,47868,11,47896,47896,11,47924,47924,11,47952,47952,11,47980,47980,11,48008,48008,11,48036,48036,11,48064,48064,11,48092,48092,11,48120,48120,11,48148,48148,11,48176,48176,11,48204,48204,11,48232,48232,11,48260,48260,11,48288,48288,11,48316,48316,11,48344,48344,11,48372,48372,11,48400,48400,11,48428,48428,11,48456,48456,11,48484,48484,11,48512,48512,11,48540,48540,11,48568,48568,11,48596,48596,11,48624,48624,11,48652,48652,11,48680,48680,11,48708,48708,11,48736,48736,11,48764,48764,11,48792,48792,11,48820,48820,11,48848,48848,11,48876,48876,11,48904,48904,11,48932,48932,11,48960,48960,11,48988,48988,11,49016,49016,11,49044,49044,11,49072,49072,11,49100,49100,11,49128,49128,11,49156,49156,11,49184,49184,11,49212,49212,11,49240,49240,11,49268,49268,11,49296,49296,11,49324,49324,11,49352,49352,11,49380,49380,11,49408,49408,11,49436,49436,11,49464,49464,11,49492,49492,11,49520,49520,11,49548,49548,11,49576,49576,11,49604,49604,11,49632,49632,11,49660,49660,11,49688,49688,11,49716,49716,11,49744,49744,11,49772,49772,11,49800,49800,11,49828,49828,11,49856,49856,11,49884,49884,11,49912,49912,11,49940,49940,11,49968,49968,11,49996,49996,11,50024,50024,11,50052,50052,11,50080,50080,11,50108,50108,11,50136,50136,11,50164,50164,11,50192,50192,11,50220,50220,11,50248,50248,11,50276,50276,11,50304,50304,11,50332,50332,11,50360,50360,11,50388,50388,11,50416,50416,11,50444,50444,11,50472,50472,11,50500,50500,11,50528,50528,11,50556,50556,11,50584,50584,11,50612,50612,11,50640,50640,11,50668,50668,11,50696,50696,11,50724,50724,11,50752,50752,11,50780,50780,11,50808,50808,11,50836,50836,11,50864,50864,11,50892,50892,11,50920,50920,11,50948,50948,11,50976,50976,11,51004,51004,11,51032,51032,11,51060,51060,11,51088,51088,11,51116,51116,11,51144,51144,11,51172,51172,11,51200,51200,11,51228,51228,11,51256,51256,11,51284,51284,11,51312,51312,11,51340,51340,11,51368,51368,11,51396,51396,11,51424,51424,11,51452,51452,11,51480,51480,11,51508,51508,11,51536,51536,11,51564,51564,11,51592,51592,11,51620,51620,11,51648,51648,11,51676,51676,11,51704,51704,11,51732,51732,11,51760,51760,11,51788,51788,11,51816,51816,11,51844,51844,11,51872,51872,11,51900,51900,11,51928,51928,11,51956,51956,11,51984,51984,11,52012,52012,11,52040,52040,11,52068,52068,11,52096,52096,11,52124,52124,11,52152,52152,11,52180,52180,11,52208,52208,11,52236,52236,11,52264,52264,11,52292,52292,11,52320,52320,11,52348,52348,11,52376,52376,11,52404,52404,11,52432,52432,11,52460,52460,11,52488,52488,11,52516,52516,11,52544,52544,11,52572,52572,11,52600,52600,11,52628,52628,11,52656,52656,11,52684,52684,11,52712,52712,11,52740,52740,11,52768,52768,11,52796,52796,11,52824,52824,11,52852,52852,11,52880,52880,11,52908,52908,11,52936,52936,11,52964,52964,11,52992,52992,11,53020,53020,11,53048,53048,11,53076,53076,11,53104,53104,11,53132,53132,11,53160,53160,11,53188,53188,11,53216,53216,11,53244,53244,11,53272,53272,11,53300,53300,11,53328,53328,11,53356,53356,11,53384,53384,11,53412,53412,11,53440,53440,11,53468,53468,11,53496,53496,11,53524,53524,11,53552,53552,11,53580,53580,11,53608,53608,11,53636,53636,11,53664,53664,11,53692,53692,11,53720,53720,11,53748,53748,11,53776,53776,11,53804,53804,11,53832,53832,11,53860,53860,11,53888,53888,11,53916,53916,11,53944,53944,11,53972,53972,11,54000,54000,11,54028,54028,11,54056,54056,11,54084,54084,11,54112,54112,11,54140,54140,11,54168,54168,11,54196,54196,11,54224,54224,11,54252,54252,11,54280,54280,11,54308,54308,11,54336,54336,11,54364,54364,11,54392,54392,11,54420,54420,11,54448,54448,11,54476,54476,11,54504,54504,11,54532,54532,11,54560,54560,11,54588,54588,11,54616,54616,11,54644,54644,11,54672,54672,11,54700,54700,11,54728,54728,11,54756,54756,11,54784,54784,11,54812,54812,11,54840,54840,11,54868,54868,11,54896,54896,11,54924,54924,11,54952,54952,11,54980,54980,11,55008,55008,11,55036,55036,11,55064,55064,11,55092,55092,11,55120,55120,11,55148,55148,11,55176,55176,11,55216,55238,9,64286,64286,5,65056,65071,5,65438,65439,5,65529,65531,4,66272,66272,5,68097,68099,5,68108,68111,5,68159,68159,5,68900,68903,5,69446,69456,5,69632,69632,7,69634,69634,7,69744,69744,5,69759,69761,5,69808,69810,7,69815,69816,7,69821,69821,1,69837,69837,1,69927,69931,5,69933,69940,5,70003,70003,5,70018,70018,7,70070,70078,5,70082,70083,1,70094,70094,7,70188,70190,7,70194,70195,7,70197,70197,7,70206,70206,5,70368,70370,7,70400,70401,5,70459,70460,5,70463,70463,7,70465,70468,7,70475,70477,7,70498,70499,7,70512,70516,5,70712,70719,5,70722,70724,5,70726,70726,5,70832,70832,5,70835,70840,5,70842,70842,5,70845,70845,5,70847,70848,5,70850,70851,5,71088,71089,7,71096,71099,7,71102,71102,7,71132,71133,5,71219,71226,5,71229,71229,5,71231,71232,5,71340,71340,7,71342,71343,7,71350,71350,7,71453,71455,5,71462,71462,7,71724,71726,7,71736,71736,7,71984,71984,5,71991,71992,7,71997,71997,7,71999,71999,1,72001,72001,1,72003,72003,5,72148,72151,5,72156,72159,7,72164,72164,7,72243,72248,5,72250,72250,1,72263,72263,5,72279,72280,7,72324,72329,1,72343,72343,7,72751,72751,7,72760,72765,5,72767,72767,5,72873,72873,7,72881,72881,7,72884,72884,7,73009,73014,5,73020,73021,5,73030,73030,1,73098,73102,7,73107,73108,7,73110,73110,7,73459,73460,5,78896,78904,4,92976,92982,5,94033,94087,7,94180,94180,5,113821,113822,5,118528,118573,5,119141,119141,5,119143,119145,5,119150,119154,5,119163,119170,5,119210,119213,5,121344,121398,5,121461,121461,5,121499,121503,5,122880,122886,5,122907,122913,5,122918,122922,5,123566,123566,5,125136,125142,5,126976,126979,14,126981,127182,14,127184,127231,14,127279,127279,14,127344,127345,14,127374,127374,14,127405,127461,14,127489,127490,14,127514,127514,14,127538,127546,14,127561,127567,14,127570,127743,14,127757,127758,14,127760,127760,14,127762,127762,14,127766,127768,14,127770,127770,14,127772,127772,14,127775,127776,14,127778,127779,14,127789,127791,14,127794,127795,14,127798,127798,14,127819,127819,14,127824,127824,14,127868,127868,14,127870,127871,14,127892,127893,14,127896,127896,14,127900,127901,14,127904,127940,14,127942,127942,14,127944,127944,14,127946,127946,14,127951,127955,14,127968,127971,14,127973,127984,14,127987,127987,14,127989,127989,14,127991,127991,14,127995,127999,5,128008,128008,14,128012,128014,14,128017,128018,14,128020,128020,14,128022,128022,14,128042,128042,14,128063,128063,14,128065,128065,14,128101,128101,14,128108,128109,14,128173,128173,14,128182,128183,14,128236,128237,14,128239,128239,14,128245,128245,14,128248,128248,14,128253,128253,14,128255,128258,14,128260,128263,14,128265,128265,14,128277,128277,14,128300,128301,14,128326,128328,14,128331,128334,14,128336,128347,14,128360,128366,14,128369,128370,14,128378,128378,14,128391,128391,14,128394,128397,14,128400,128400,14,128405,128406,14,128420,128420,14,128422,128423,14,128425,128432,14,128435,128443,14,128445,128449,14,128453,128464,14,128468,128475,14,128479,128480,14,128482,128482,14,128484,128487,14,128489,128494,14,128496,128498,14,128500,128505,14,128507,128511,14,128513,128518,14,128521,128525,14,128527,128527,14,128529,128529,14,128533,128533,14,128535,128535,14,128537,128537,14]");
}
function getLeftDeleteOffset(offset, str) {
    if (offset === 0) return 0;
    // Try to delete emoji part.
    const emojiOffset = getOffsetBeforeLastEmojiComponent(offset, str);
    if (emojiOffset !== undefined) return emojiOffset;
    // Otherwise, just skip a single code point.
    const iterator = new CodePointIterator(str, offset);
    iterator.prevCodePoint();
    return iterator.offset;
}
function getOffsetBeforeLastEmojiComponent(initialOffset, str) {
    // See https://www.unicode.org/reports/tr51/tr51-14.html#EBNF_and_Regex for the
    // structure of emojis.
    const iterator = new CodePointIterator(str, initialOffset);
    let codePoint = iterator.prevCodePoint();
    // Skip modifiers
    while(isEmojiModifier(codePoint) || codePoint === 65039 /* CodePoint.emojiVariantSelector */  || codePoint === 8419 /* CodePoint.enclosingKeyCap */ ){
        if (iterator.offset === 0) // Cannot skip modifier, no preceding emoji base.
        return undefined;
        codePoint = iterator.prevCodePoint();
    }
    // Expect base emoji
    if (!isEmojiImprecise(codePoint)) // Unexpected code point, not a valid emoji.
    return undefined;
    let resultOffset = iterator.offset;
    if (resultOffset > 0) {
        // Skip optional ZWJ code points that combine multiple emojis.
        // In theory, we should check if that ZWJ actually combines multiple emojis
        // to prevent deleting ZWJs in situations we didn't account for.
        const optionalZwjCodePoint = iterator.prevCodePoint();
        if (optionalZwjCodePoint === 8205 /* CodePoint.zwj */ ) resultOffset = iterator.offset;
    }
    return resultOffset;
}
function isEmojiModifier(codePoint) {
    return 0x1F3FB <= codePoint && codePoint <= 0x1F3FF;
}
const noBreakWhitespace = "\xa0";
class AmbiguousCharacters {
    static{
        this.ambiguousCharacterData = new (0, _lazyJs.Lazy)(()=>{
            // Generated using https://github.com/hediet/vscode-unicode-data
            // Stored as key1, value1, key2, value2, ...
            return JSON.parse('{"_common":[8232,32,8233,32,5760,32,8192,32,8193,32,8194,32,8195,32,8196,32,8197,32,8198,32,8200,32,8201,32,8202,32,8287,32,8199,32,8239,32,2042,95,65101,95,65102,95,65103,95,8208,45,8209,45,8210,45,65112,45,1748,45,8259,45,727,45,8722,45,10134,45,11450,45,1549,44,1643,44,8218,44,184,44,42233,44,894,59,2307,58,2691,58,1417,58,1795,58,1796,58,5868,58,65072,58,6147,58,6153,58,8282,58,1475,58,760,58,42889,58,8758,58,720,58,42237,58,451,33,11601,33,660,63,577,63,2429,63,5038,63,42731,63,119149,46,8228,46,1793,46,1794,46,42510,46,68176,46,1632,46,1776,46,42232,46,1373,96,65287,96,8219,96,8242,96,1370,96,1523,96,8175,96,65344,96,900,96,8189,96,8125,96,8127,96,8190,96,697,96,884,96,712,96,714,96,715,96,756,96,699,96,701,96,700,96,702,96,42892,96,1497,96,2036,96,2037,96,5194,96,5836,96,94033,96,94034,96,65339,91,10088,40,10098,40,12308,40,64830,40,65341,93,10089,41,10099,41,12309,41,64831,41,10100,123,119060,123,10101,125,65342,94,8270,42,1645,42,8727,42,66335,42,5941,47,8257,47,8725,47,8260,47,9585,47,10187,47,10744,47,119354,47,12755,47,12339,47,11462,47,20031,47,12035,47,65340,92,65128,92,8726,92,10189,92,10741,92,10745,92,119311,92,119355,92,12756,92,20022,92,12034,92,42872,38,708,94,710,94,5869,43,10133,43,66203,43,8249,60,10094,60,706,60,119350,60,5176,60,5810,60,5120,61,11840,61,12448,61,42239,61,8250,62,10095,62,707,62,119351,62,5171,62,94015,62,8275,126,732,126,8128,126,8764,126,65372,124,65293,45,120784,50,120794,50,120804,50,120814,50,120824,50,130034,50,42842,50,423,50,1000,50,42564,50,5311,50,42735,50,119302,51,120785,51,120795,51,120805,51,120815,51,120825,51,130035,51,42923,51,540,51,439,51,42858,51,11468,51,1248,51,94011,51,71882,51,120786,52,120796,52,120806,52,120816,52,120826,52,130036,52,5070,52,71855,52,120787,53,120797,53,120807,53,120817,53,120827,53,130037,53,444,53,71867,53,120788,54,120798,54,120808,54,120818,54,120828,54,130038,54,11474,54,5102,54,71893,54,119314,55,120789,55,120799,55,120809,55,120819,55,120829,55,130039,55,66770,55,71878,55,2819,56,2538,56,2666,56,125131,56,120790,56,120800,56,120810,56,120820,56,120830,56,130040,56,547,56,546,56,66330,56,2663,57,2920,57,2541,57,3437,57,120791,57,120801,57,120811,57,120821,57,120831,57,130041,57,42862,57,11466,57,71884,57,71852,57,71894,57,9082,97,65345,97,119834,97,119886,97,119938,97,119990,97,120042,97,120094,97,120146,97,120198,97,120250,97,120302,97,120354,97,120406,97,120458,97,593,97,945,97,120514,97,120572,97,120630,97,120688,97,120746,97,65313,65,119808,65,119860,65,119912,65,119964,65,120016,65,120068,65,120120,65,120172,65,120224,65,120276,65,120328,65,120380,65,120432,65,913,65,120488,65,120546,65,120604,65,120662,65,120720,65,5034,65,5573,65,42222,65,94016,65,66208,65,119835,98,119887,98,119939,98,119991,98,120043,98,120095,98,120147,98,120199,98,120251,98,120303,98,120355,98,120407,98,120459,98,388,98,5071,98,5234,98,5551,98,65314,66,8492,66,119809,66,119861,66,119913,66,120017,66,120069,66,120121,66,120173,66,120225,66,120277,66,120329,66,120381,66,120433,66,42932,66,914,66,120489,66,120547,66,120605,66,120663,66,120721,66,5108,66,5623,66,42192,66,66178,66,66209,66,66305,66,65347,99,8573,99,119836,99,119888,99,119940,99,119992,99,120044,99,120096,99,120148,99,120200,99,120252,99,120304,99,120356,99,120408,99,120460,99,7428,99,1010,99,11429,99,43951,99,66621,99,128844,67,71922,67,71913,67,65315,67,8557,67,8450,67,8493,67,119810,67,119862,67,119914,67,119966,67,120018,67,120174,67,120226,67,120278,67,120330,67,120382,67,120434,67,1017,67,11428,67,5087,67,42202,67,66210,67,66306,67,66581,67,66844,67,8574,100,8518,100,119837,100,119889,100,119941,100,119993,100,120045,100,120097,100,120149,100,120201,100,120253,100,120305,100,120357,100,120409,100,120461,100,1281,100,5095,100,5231,100,42194,100,8558,68,8517,68,119811,68,119863,68,119915,68,119967,68,120019,68,120071,68,120123,68,120175,68,120227,68,120279,68,120331,68,120383,68,120435,68,5024,68,5598,68,5610,68,42195,68,8494,101,65349,101,8495,101,8519,101,119838,101,119890,101,119942,101,120046,101,120098,101,120150,101,120202,101,120254,101,120306,101,120358,101,120410,101,120462,101,43826,101,1213,101,8959,69,65317,69,8496,69,119812,69,119864,69,119916,69,120020,69,120072,69,120124,69,120176,69,120228,69,120280,69,120332,69,120384,69,120436,69,917,69,120492,69,120550,69,120608,69,120666,69,120724,69,11577,69,5036,69,42224,69,71846,69,71854,69,66182,69,119839,102,119891,102,119943,102,119995,102,120047,102,120099,102,120151,102,120203,102,120255,102,120307,102,120359,102,120411,102,120463,102,43829,102,42905,102,383,102,7837,102,1412,102,119315,70,8497,70,119813,70,119865,70,119917,70,120021,70,120073,70,120125,70,120177,70,120229,70,120281,70,120333,70,120385,70,120437,70,42904,70,988,70,120778,70,5556,70,42205,70,71874,70,71842,70,66183,70,66213,70,66853,70,65351,103,8458,103,119840,103,119892,103,119944,103,120048,103,120100,103,120152,103,120204,103,120256,103,120308,103,120360,103,120412,103,120464,103,609,103,7555,103,397,103,1409,103,119814,71,119866,71,119918,71,119970,71,120022,71,120074,71,120126,71,120178,71,120230,71,120282,71,120334,71,120386,71,120438,71,1292,71,5056,71,5107,71,42198,71,65352,104,8462,104,119841,104,119945,104,119997,104,120049,104,120101,104,120153,104,120205,104,120257,104,120309,104,120361,104,120413,104,120465,104,1211,104,1392,104,5058,104,65320,72,8459,72,8460,72,8461,72,119815,72,119867,72,119919,72,120023,72,120179,72,120231,72,120283,72,120335,72,120387,72,120439,72,919,72,120494,72,120552,72,120610,72,120668,72,120726,72,11406,72,5051,72,5500,72,42215,72,66255,72,731,105,9075,105,65353,105,8560,105,8505,105,8520,105,119842,105,119894,105,119946,105,119998,105,120050,105,120102,105,120154,105,120206,105,120258,105,120310,105,120362,105,120414,105,120466,105,120484,105,618,105,617,105,953,105,8126,105,890,105,120522,105,120580,105,120638,105,120696,105,120754,105,1110,105,42567,105,1231,105,43893,105,5029,105,71875,105,65354,106,8521,106,119843,106,119895,106,119947,106,119999,106,120051,106,120103,106,120155,106,120207,106,120259,106,120311,106,120363,106,120415,106,120467,106,1011,106,1112,106,65322,74,119817,74,119869,74,119921,74,119973,74,120025,74,120077,74,120129,74,120181,74,120233,74,120285,74,120337,74,120389,74,120441,74,42930,74,895,74,1032,74,5035,74,5261,74,42201,74,119844,107,119896,107,119948,107,120000,107,120052,107,120104,107,120156,107,120208,107,120260,107,120312,107,120364,107,120416,107,120468,107,8490,75,65323,75,119818,75,119870,75,119922,75,119974,75,120026,75,120078,75,120130,75,120182,75,120234,75,120286,75,120338,75,120390,75,120442,75,922,75,120497,75,120555,75,120613,75,120671,75,120729,75,11412,75,5094,75,5845,75,42199,75,66840,75,1472,108,8739,73,9213,73,65512,73,1633,108,1777,73,66336,108,125127,108,120783,73,120793,73,120803,73,120813,73,120823,73,130033,73,65321,73,8544,73,8464,73,8465,73,119816,73,119868,73,119920,73,120024,73,120128,73,120180,73,120232,73,120284,73,120336,73,120388,73,120440,73,65356,108,8572,73,8467,108,119845,108,119897,108,119949,108,120001,108,120053,108,120105,73,120157,73,120209,73,120261,73,120313,73,120365,73,120417,73,120469,73,448,73,120496,73,120554,73,120612,73,120670,73,120728,73,11410,73,1030,73,1216,73,1493,108,1503,108,1575,108,126464,108,126592,108,65166,108,65165,108,1994,108,11599,73,5825,73,42226,73,93992,73,66186,124,66313,124,119338,76,8556,76,8466,76,119819,76,119871,76,119923,76,120027,76,120079,76,120131,76,120183,76,120235,76,120287,76,120339,76,120391,76,120443,76,11472,76,5086,76,5290,76,42209,76,93974,76,71843,76,71858,76,66587,76,66854,76,65325,77,8559,77,8499,77,119820,77,119872,77,119924,77,120028,77,120080,77,120132,77,120184,77,120236,77,120288,77,120340,77,120392,77,120444,77,924,77,120499,77,120557,77,120615,77,120673,77,120731,77,1018,77,11416,77,5047,77,5616,77,5846,77,42207,77,66224,77,66321,77,119847,110,119899,110,119951,110,120003,110,120055,110,120107,110,120159,110,120211,110,120263,110,120315,110,120367,110,120419,110,120471,110,1400,110,1404,110,65326,78,8469,78,119821,78,119873,78,119925,78,119977,78,120029,78,120081,78,120185,78,120237,78,120289,78,120341,78,120393,78,120445,78,925,78,120500,78,120558,78,120616,78,120674,78,120732,78,11418,78,42208,78,66835,78,3074,111,3202,111,3330,111,3458,111,2406,111,2662,111,2790,111,3046,111,3174,111,3302,111,3430,111,3664,111,3792,111,4160,111,1637,111,1781,111,65359,111,8500,111,119848,111,119900,111,119952,111,120056,111,120108,111,120160,111,120212,111,120264,111,120316,111,120368,111,120420,111,120472,111,7439,111,7441,111,43837,111,959,111,120528,111,120586,111,120644,111,120702,111,120760,111,963,111,120532,111,120590,111,120648,111,120706,111,120764,111,11423,111,4351,111,1413,111,1505,111,1607,111,126500,111,126564,111,126596,111,65259,111,65260,111,65258,111,65257,111,1726,111,64428,111,64429,111,64427,111,64426,111,1729,111,64424,111,64425,111,64423,111,64422,111,1749,111,3360,111,4125,111,66794,111,71880,111,71895,111,66604,111,1984,79,2534,79,2918,79,12295,79,70864,79,71904,79,120782,79,120792,79,120802,79,120812,79,120822,79,130032,79,65327,79,119822,79,119874,79,119926,79,119978,79,120030,79,120082,79,120134,79,120186,79,120238,79,120290,79,120342,79,120394,79,120446,79,927,79,120502,79,120560,79,120618,79,120676,79,120734,79,11422,79,1365,79,11604,79,4816,79,2848,79,66754,79,42227,79,71861,79,66194,79,66219,79,66564,79,66838,79,9076,112,65360,112,119849,112,119901,112,119953,112,120005,112,120057,112,120109,112,120161,112,120213,112,120265,112,120317,112,120369,112,120421,112,120473,112,961,112,120530,112,120544,112,120588,112,120602,112,120646,112,120660,112,120704,112,120718,112,120762,112,120776,112,11427,112,65328,80,8473,80,119823,80,119875,80,119927,80,119979,80,120031,80,120083,80,120187,80,120239,80,120291,80,120343,80,120395,80,120447,80,929,80,120504,80,120562,80,120620,80,120678,80,120736,80,11426,80,5090,80,5229,80,42193,80,66197,80,119850,113,119902,113,119954,113,120006,113,120058,113,120110,113,120162,113,120214,113,120266,113,120318,113,120370,113,120422,113,120474,113,1307,113,1379,113,1382,113,8474,81,119824,81,119876,81,119928,81,119980,81,120032,81,120084,81,120188,81,120240,81,120292,81,120344,81,120396,81,120448,81,11605,81,119851,114,119903,114,119955,114,120007,114,120059,114,120111,114,120163,114,120215,114,120267,114,120319,114,120371,114,120423,114,120475,114,43847,114,43848,114,7462,114,11397,114,43905,114,119318,82,8475,82,8476,82,8477,82,119825,82,119877,82,119929,82,120033,82,120189,82,120241,82,120293,82,120345,82,120397,82,120449,82,422,82,5025,82,5074,82,66740,82,5511,82,42211,82,94005,82,65363,115,119852,115,119904,115,119956,115,120008,115,120060,115,120112,115,120164,115,120216,115,120268,115,120320,115,120372,115,120424,115,120476,115,42801,115,445,115,1109,115,43946,115,71873,115,66632,115,65331,83,119826,83,119878,83,119930,83,119982,83,120034,83,120086,83,120138,83,120190,83,120242,83,120294,83,120346,83,120398,83,120450,83,1029,83,1359,83,5077,83,5082,83,42210,83,94010,83,66198,83,66592,83,119853,116,119905,116,119957,116,120009,116,120061,116,120113,116,120165,116,120217,116,120269,116,120321,116,120373,116,120425,116,120477,116,8868,84,10201,84,128872,84,65332,84,119827,84,119879,84,119931,84,119983,84,120035,84,120087,84,120139,84,120191,84,120243,84,120295,84,120347,84,120399,84,120451,84,932,84,120507,84,120565,84,120623,84,120681,84,120739,84,11430,84,5026,84,42196,84,93962,84,71868,84,66199,84,66225,84,66325,84,119854,117,119906,117,119958,117,120010,117,120062,117,120114,117,120166,117,120218,117,120270,117,120322,117,120374,117,120426,117,120478,117,42911,117,7452,117,43854,117,43858,117,651,117,965,117,120534,117,120592,117,120650,117,120708,117,120766,117,1405,117,66806,117,71896,117,8746,85,8899,85,119828,85,119880,85,119932,85,119984,85,120036,85,120088,85,120140,85,120192,85,120244,85,120296,85,120348,85,120400,85,120452,85,1357,85,4608,85,66766,85,5196,85,42228,85,94018,85,71864,85,8744,118,8897,118,65366,118,8564,118,119855,118,119907,118,119959,118,120011,118,120063,118,120115,118,120167,118,120219,118,120271,118,120323,118,120375,118,120427,118,120479,118,7456,118,957,118,120526,118,120584,118,120642,118,120700,118,120758,118,1141,118,1496,118,71430,118,43945,118,71872,118,119309,86,1639,86,1783,86,8548,86,119829,86,119881,86,119933,86,119985,86,120037,86,120089,86,120141,86,120193,86,120245,86,120297,86,120349,86,120401,86,120453,86,1140,86,11576,86,5081,86,5167,86,42719,86,42214,86,93960,86,71840,86,66845,86,623,119,119856,119,119908,119,119960,119,120012,119,120064,119,120116,119,120168,119,120220,119,120272,119,120324,119,120376,119,120428,119,120480,119,7457,119,1121,119,1309,119,1377,119,71434,119,71438,119,71439,119,43907,119,71919,87,71910,87,119830,87,119882,87,119934,87,119986,87,120038,87,120090,87,120142,87,120194,87,120246,87,120298,87,120350,87,120402,87,120454,87,1308,87,5043,87,5076,87,42218,87,5742,120,10539,120,10540,120,10799,120,65368,120,8569,120,119857,120,119909,120,119961,120,120013,120,120065,120,120117,120,120169,120,120221,120,120273,120,120325,120,120377,120,120429,120,120481,120,5441,120,5501,120,5741,88,9587,88,66338,88,71916,88,65336,88,8553,88,119831,88,119883,88,119935,88,119987,88,120039,88,120091,88,120143,88,120195,88,120247,88,120299,88,120351,88,120403,88,120455,88,42931,88,935,88,120510,88,120568,88,120626,88,120684,88,120742,88,11436,88,11613,88,5815,88,42219,88,66192,88,66228,88,66327,88,66855,88,611,121,7564,121,65369,121,119858,121,119910,121,119962,121,120014,121,120066,121,120118,121,120170,121,120222,121,120274,121,120326,121,120378,121,120430,121,120482,121,655,121,7935,121,43866,121,947,121,8509,121,120516,121,120574,121,120632,121,120690,121,120748,121,1199,121,4327,121,71900,121,65337,89,119832,89,119884,89,119936,89,119988,89,120040,89,120092,89,120144,89,120196,89,120248,89,120300,89,120352,89,120404,89,120456,89,933,89,978,89,120508,89,120566,89,120624,89,120682,89,120740,89,11432,89,1198,89,5033,89,5053,89,42220,89,94019,89,71844,89,66226,89,119859,122,119911,122,119963,122,120015,122,120067,122,120119,122,120171,122,120223,122,120275,122,120327,122,120379,122,120431,122,120483,122,7458,122,43923,122,71876,122,66293,90,71909,90,65338,90,8484,90,8488,90,119833,90,119885,90,119937,90,119989,90,120041,90,120197,90,120249,90,120301,90,120353,90,120405,90,120457,90,918,90,120493,90,120551,90,120609,90,120667,90,120725,90,5059,90,42204,90,71849,90,65282,34,65284,36,65285,37,65286,38,65290,42,65291,43,65294,46,65295,47,65296,48,65297,49,65298,50,65299,51,65300,52,65301,53,65302,54,65303,55,65304,56,65305,57,65308,60,65309,61,65310,62,65312,64,65316,68,65318,70,65319,71,65324,76,65329,81,65330,82,65333,85,65334,86,65335,87,65343,95,65346,98,65348,100,65350,102,65355,107,65357,109,65358,110,65361,113,65362,114,65364,116,65365,117,65367,119,65370,122,65371,123,65373,125,119846,109],"_default":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"cs":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"de":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"es":[8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"fr":[65374,126,65306,58,65281,33,8216,96,8245,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"it":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"ja":[8211,45,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65292,44,65307,59],"ko":[8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"pl":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"pt-BR":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"qps-ploc":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"ru":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,305,105,921,73,1009,112,215,120,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"tr":[160,32,8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"zh-hans":[65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65288,40,65289,41],"zh-hant":[8211,45,65374,126,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65307,59]}');
        });
    }
    static{
        this.cache = new (0, _cacheJs.LRUCachedFunction)({
            getCacheKey: JSON.stringify
        }, (locales)=>{
            function arrayToMap(arr) {
                const result = new Map();
                for(let i = 0; i < arr.length; i += 2)result.set(arr[i], arr[i + 1]);
                return result;
            }
            function mergeMaps(map1, map2) {
                const result = new Map(map1);
                for (const [key, value] of map2)result.set(key, value);
                return result;
            }
            function intersectMaps(map1, map2) {
                if (!map1) return map2;
                const result = new Map();
                for (const [key, value] of map1)if (map2.has(key)) result.set(key, value);
                return result;
            }
            const data = this.ambiguousCharacterData.value;
            let filteredLocales = locales.filter((l)=>!l.startsWith("_") && l in data);
            if (filteredLocales.length === 0) filteredLocales = [
                "_default"
            ];
            let languageSpecificMap = undefined;
            for (const locale of filteredLocales){
                const map = arrayToMap(data[locale]);
                languageSpecificMap = intersectMaps(languageSpecificMap, map);
            }
            const commonMap = arrayToMap(data["_common"]);
            const map = mergeMaps(commonMap, languageSpecificMap);
            return new AmbiguousCharacters(map);
        });
    }
    static getInstance(locales) {
        return AmbiguousCharacters.cache.get(Array.from(locales));
    }
    static{
        this._locales = new (0, _lazyJs.Lazy)(()=>Object.keys(AmbiguousCharacters.ambiguousCharacterData.value).filter((k)=>!k.startsWith("_")));
    }
    static getLocales() {
        return AmbiguousCharacters._locales.value;
    }
    constructor(confusableDictionary){
        this.confusableDictionary = confusableDictionary;
    }
    isAmbiguous(codePoint) {
        return this.confusableDictionary.has(codePoint);
    }
    /**
     * Returns the non basic ASCII code point that the given code point can be confused,
     * or undefined if such code point does note exist.
     */ getPrimaryConfusable(codePoint) {
        return this.confusableDictionary.get(codePoint);
    }
    getConfusableCodePoints() {
        return new Set(this.confusableDictionary.keys());
    }
}
class InvisibleCharacters {
    static getRawData() {
        // Generated using https://github.com/hediet/vscode-unicode-data
        return JSON.parse("[9,10,11,12,13,32,127,160,173,847,1564,4447,4448,6068,6069,6155,6156,6157,6158,7355,7356,8192,8193,8194,8195,8196,8197,8198,8199,8200,8201,8202,8203,8204,8205,8206,8207,8234,8235,8236,8237,8238,8239,8287,8288,8289,8290,8291,8292,8293,8294,8295,8296,8297,8298,8299,8300,8301,8302,8303,10240,12288,12644,65024,65025,65026,65027,65028,65029,65030,65031,65032,65033,65034,65035,65036,65037,65038,65039,65279,65440,65520,65521,65522,65523,65524,65525,65526,65527,65528,65532,78844,119155,119156,119157,119158,119159,119160,119161,119162,917504,917505,917506,917507,917508,917509,917510,917511,917512,917513,917514,917515,917516,917517,917518,917519,917520,917521,917522,917523,917524,917525,917526,917527,917528,917529,917530,917531,917532,917533,917534,917535,917536,917537,917538,917539,917540,917541,917542,917543,917544,917545,917546,917547,917548,917549,917550,917551,917552,917553,917554,917555,917556,917557,917558,917559,917560,917561,917562,917563,917564,917565,917566,917567,917568,917569,917570,917571,917572,917573,917574,917575,917576,917577,917578,917579,917580,917581,917582,917583,917584,917585,917586,917587,917588,917589,917590,917591,917592,917593,917594,917595,917596,917597,917598,917599,917600,917601,917602,917603,917604,917605,917606,917607,917608,917609,917610,917611,917612,917613,917614,917615,917616,917617,917618,917619,917620,917621,917622,917623,917624,917625,917626,917627,917628,917629,917630,917631,917760,917761,917762,917763,917764,917765,917766,917767,917768,917769,917770,917771,917772,917773,917774,917775,917776,917777,917778,917779,917780,917781,917782,917783,917784,917785,917786,917787,917788,917789,917790,917791,917792,917793,917794,917795,917796,917797,917798,917799,917800,917801,917802,917803,917804,917805,917806,917807,917808,917809,917810,917811,917812,917813,917814,917815,917816,917817,917818,917819,917820,917821,917822,917823,917824,917825,917826,917827,917828,917829,917830,917831,917832,917833,917834,917835,917836,917837,917838,917839,917840,917841,917842,917843,917844,917845,917846,917847,917848,917849,917850,917851,917852,917853,917854,917855,917856,917857,917858,917859,917860,917861,917862,917863,917864,917865,917866,917867,917868,917869,917870,917871,917872,917873,917874,917875,917876,917877,917878,917879,917880,917881,917882,917883,917884,917885,917886,917887,917888,917889,917890,917891,917892,917893,917894,917895,917896,917897,917898,917899,917900,917901,917902,917903,917904,917905,917906,917907,917908,917909,917910,917911,917912,917913,917914,917915,917916,917917,917918,917919,917920,917921,917922,917923,917924,917925,917926,917927,917928,917929,917930,917931,917932,917933,917934,917935,917936,917937,917938,917939,917940,917941,917942,917943,917944,917945,917946,917947,917948,917949,917950,917951,917952,917953,917954,917955,917956,917957,917958,917959,917960,917961,917962,917963,917964,917965,917966,917967,917968,917969,917970,917971,917972,917973,917974,917975,917976,917977,917978,917979,917980,917981,917982,917983,917984,917985,917986,917987,917988,917989,917990,917991,917992,917993,917994,917995,917996,917997,917998,917999]");
    }
    static{
        this._data = undefined;
    }
    static getData() {
        if (!this._data) this._data = new Set(InvisibleCharacters.getRawData());
        return this._data;
    }
    static isInvisibleCharacter(codePoint) {
        return InvisibleCharacters.getData().has(codePoint);
    }
    static get codePoints() {
        return InvisibleCharacters.getData();
    }
}

},{"./cache.js":"e83Ii","./lazy.js":"6e57N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e83Ii":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
/**
 * Uses a LRU cache to make a given parametrized function cached.
 * Caches just the last key/value.
*/ parcelHelpers.export(exports, "LRUCachedFunction", ()=>LRUCachedFunction);
/**
 * Uses an unbounded cache to memoize the results of the given function.
*/ parcelHelpers.export(exports, "CachedFunction", ()=>CachedFunction);
function identity(t) {
    return t;
}
class LRUCachedFunction {
    constructor(arg1, arg2){
        this.lastCache = undefined;
        this.lastArgKey = undefined;
        if (typeof arg1 === "function") {
            this._fn = arg1;
            this._computeKey = identity;
        } else {
            this._fn = arg2;
            this._computeKey = arg1.getCacheKey;
        }
    }
    get(arg) {
        const key = this._computeKey(arg);
        if (this.lastArgKey !== key) {
            this.lastArgKey = key;
            this.lastCache = this._fn(arg);
        }
        return this.lastCache;
    }
}
class CachedFunction {
    get cachedValues() {
        return this._map;
    }
    constructor(arg1, arg2){
        this._map = new Map();
        this._map2 = new Map();
        if (typeof arg1 === "function") {
            this._fn = arg1;
            this._computeKey = identity;
        } else {
            this._fn = arg2;
            this._computeKey = arg1.getCacheKey;
        }
    }
    get(arg) {
        const key = this._computeKey(arg);
        if (this._map2.has(key)) return this._map2.get(key);
        const value = this._fn(arg);
        this._map.set(arg, value);
        this._map2.set(key, value);
        return value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6e57N":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lazy", ()=>Lazy);
class Lazy {
    constructor(executor){
        this.executor = executor;
        this._didRun = false;
    }
    /**
     * Get the wrapped value.
     *
     * This will force evaluation of the lazy value if it has not been resolved yet. Lazy values are only
     * resolved once. `getValue` will re-throw exceptions that are hit while resolving the value
     */ get value() {
        if (!this._didRun) try {
            this._value = this.executor();
        } catch (err) {
            this._error = err;
        } finally{
            this._didRun = true;
        }
        if (this._error) throw this._error;
        return this._value;
    }
    /**
     * Get the wrapped value without forcing evaluation.
     */ get rawValue() {
        return this._value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Wpsw":[function() {},{}],"3umX2":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FontMeasurementsImpl", ()=>FontMeasurementsImpl);
parcelHelpers.export(exports, "FontMeasurements", ()=>FontMeasurements);
var _domJs = require("../../../base/browser/dom.js");
var _pixelRatioJs = require("../../../base/browser/pixelRatio.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _charWidthReaderJs = require("./charWidthReader.js");
var _editorOptionsJs = require("../../common/config/editorOptions.js");
var _fontInfoJs = require("../../common/config/fontInfo.js");
class FontMeasurementsImpl extends (0, _lifecycleJs.Disposable) {
    constructor(){
        super(...arguments);
        this._cache = new Map();
        this._evictUntrustedReadingsTimeout = -1;
        this._onDidChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidChange = this._onDidChange.event;
    }
    dispose() {
        if (this._evictUntrustedReadingsTimeout !== -1) {
            clearTimeout(this._evictUntrustedReadingsTimeout);
            this._evictUntrustedReadingsTimeout = -1;
        }
        super.dispose();
    }
    /**
     * Clear all cached font information and trigger a change event.
     */ clearAllFontInfos() {
        this._cache.clear();
        this._onDidChange.fire();
    }
    _ensureCache(targetWindow) {
        const windowId = (0, _domJs.getWindowId)(targetWindow);
        let cache = this._cache.get(windowId);
        if (!cache) {
            cache = new FontMeasurementsCache();
            this._cache.set(windowId, cache);
        }
        return cache;
    }
    _writeToCache(targetWindow, item, value) {
        const cache = this._ensureCache(targetWindow);
        cache.put(item, value);
        if (!value.isTrusted && this._evictUntrustedReadingsTimeout === -1) // Try reading again after some time
        this._evictUntrustedReadingsTimeout = targetWindow.setTimeout(()=>{
            this._evictUntrustedReadingsTimeout = -1;
            this._evictUntrustedReadings(targetWindow);
        }, 5000);
    }
    _evictUntrustedReadings(targetWindow) {
        const cache = this._ensureCache(targetWindow);
        const values = cache.getValues();
        let somethingRemoved = false;
        for (const item of values)if (!item.isTrusted) {
            somethingRemoved = true;
            cache.remove(item);
        }
        if (somethingRemoved) this._onDidChange.fire();
    }
    /**
     * Read font information.
     */ readFontInfo(targetWindow, bareFontInfo) {
        const cache = this._ensureCache(targetWindow);
        if (!cache.has(bareFontInfo)) {
            let readConfig = this._actualReadFontInfo(targetWindow, bareFontInfo);
            if (readConfig.typicalHalfwidthCharacterWidth <= 2 || readConfig.typicalFullwidthCharacterWidth <= 2 || readConfig.spaceWidth <= 2 || readConfig.maxDigitWidth <= 2) // Hey, it's Bug 14341 ... we couldn't read
            readConfig = new (0, _fontInfoJs.FontInfo)({
                pixelRatio: (0, _pixelRatioJs.PixelRatio).getInstance(targetWindow).value,
                fontFamily: readConfig.fontFamily,
                fontWeight: readConfig.fontWeight,
                fontSize: readConfig.fontSize,
                fontFeatureSettings: readConfig.fontFeatureSettings,
                fontVariationSettings: readConfig.fontVariationSettings,
                lineHeight: readConfig.lineHeight,
                letterSpacing: readConfig.letterSpacing,
                isMonospace: readConfig.isMonospace,
                typicalHalfwidthCharacterWidth: Math.max(readConfig.typicalHalfwidthCharacterWidth, 5),
                typicalFullwidthCharacterWidth: Math.max(readConfig.typicalFullwidthCharacterWidth, 5),
                canUseHalfwidthRightwardsArrow: readConfig.canUseHalfwidthRightwardsArrow,
                spaceWidth: Math.max(readConfig.spaceWidth, 5),
                middotWidth: Math.max(readConfig.middotWidth, 5),
                wsmiddotWidth: Math.max(readConfig.wsmiddotWidth, 5),
                maxDigitWidth: Math.max(readConfig.maxDigitWidth, 5)
            }, false);
            this._writeToCache(targetWindow, bareFontInfo, readConfig);
        }
        return cache.get(bareFontInfo);
    }
    _createRequest(chr, type, all, monospace) {
        const result = new (0, _charWidthReaderJs.CharWidthRequest)(chr, type);
        all.push(result);
        monospace?.push(result);
        return result;
    }
    _actualReadFontInfo(targetWindow, bareFontInfo) {
        const all = [];
        const monospace = [];
        const typicalHalfwidthCharacter = this._createRequest("n", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        const typicalFullwidthCharacter = this._createRequest("\uFF4D", 0 /* CharWidthRequestType.Regular */ , all, null);
        const space = this._createRequest(" ", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        const digit0 = this._createRequest("0", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        const digit1 = this._createRequest("1", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        const digit2 = this._createRequest("2", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        const digit3 = this._createRequest("3", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        const digit4 = this._createRequest("4", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        const digit5 = this._createRequest("5", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        const digit6 = this._createRequest("6", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        const digit7 = this._createRequest("7", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        const digit8 = this._createRequest("8", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        const digit9 = this._createRequest("9", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        // monospace test: used for whitespace rendering
        const rightwardsArrow = this._createRequest("\u2192", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        const halfwidthRightwardsArrow = this._createRequest("\uFFEB", 0 /* CharWidthRequestType.Regular */ , all, null);
        // U+00B7 - MIDDLE DOT
        const middot = this._createRequest("\xb7", 0 /* CharWidthRequestType.Regular */ , all, monospace);
        // U+2E31 - WORD SEPARATOR MIDDLE DOT
        const wsmiddotWidth = this._createRequest(String.fromCharCode(0x2E31), 0 /* CharWidthRequestType.Regular */ , all, null);
        // monospace test: some characters
        const monospaceTestChars = "|/-_ilm%";
        for(let i = 0, len = monospaceTestChars.length; i < len; i++){
            this._createRequest(monospaceTestChars.charAt(i), 0 /* CharWidthRequestType.Regular */ , all, monospace);
            this._createRequest(monospaceTestChars.charAt(i), 1 /* CharWidthRequestType.Italic */ , all, monospace);
            this._createRequest(monospaceTestChars.charAt(i), 2 /* CharWidthRequestType.Bold */ , all, monospace);
        }
        (0, _charWidthReaderJs.readCharWidths)(targetWindow, bareFontInfo, all);
        const maxDigitWidth = Math.max(digit0.width, digit1.width, digit2.width, digit3.width, digit4.width, digit5.width, digit6.width, digit7.width, digit8.width, digit9.width);
        let isMonospace = bareFontInfo.fontFeatureSettings === (0, _editorOptionsJs.EditorFontLigatures).OFF;
        const referenceWidth = monospace[0].width;
        for(let i = 1, len = monospace.length; isMonospace && i < len; i++){
            const diff = referenceWidth - monospace[i].width;
            if (diff < -0.001 || diff > 0.001) {
                isMonospace = false;
                break;
            }
        }
        let canUseHalfwidthRightwardsArrow = true;
        if (isMonospace && halfwidthRightwardsArrow.width !== referenceWidth) // using a halfwidth rightwards arrow would break monospace...
        canUseHalfwidthRightwardsArrow = false;
        if (halfwidthRightwardsArrow.width > rightwardsArrow.width) // using a halfwidth rightwards arrow would paint a larger arrow than a regular rightwards arrow
        canUseHalfwidthRightwardsArrow = false;
        return new (0, _fontInfoJs.FontInfo)({
            pixelRatio: (0, _pixelRatioJs.PixelRatio).getInstance(targetWindow).value,
            fontFamily: bareFontInfo.fontFamily,
            fontWeight: bareFontInfo.fontWeight,
            fontSize: bareFontInfo.fontSize,
            fontFeatureSettings: bareFontInfo.fontFeatureSettings,
            fontVariationSettings: bareFontInfo.fontVariationSettings,
            lineHeight: bareFontInfo.lineHeight,
            letterSpacing: bareFontInfo.letterSpacing,
            isMonospace: isMonospace,
            typicalHalfwidthCharacterWidth: typicalHalfwidthCharacter.width,
            typicalFullwidthCharacterWidth: typicalFullwidthCharacter.width,
            canUseHalfwidthRightwardsArrow: canUseHalfwidthRightwardsArrow,
            spaceWidth: space.width,
            middotWidth: middot.width,
            wsmiddotWidth: wsmiddotWidth.width,
            maxDigitWidth: maxDigitWidth
        }, true);
    }
}
class FontMeasurementsCache {
    constructor(){
        this._keys = Object.create(null);
        this._values = Object.create(null);
    }
    has(item) {
        const itemId = item.getId();
        return !!this._values[itemId];
    }
    get(item) {
        const itemId = item.getId();
        return this._values[itemId];
    }
    put(item, value) {
        const itemId = item.getId();
        this._keys[itemId] = item;
        this._values[itemId] = value;
    }
    remove(item) {
        const itemId = item.getId();
        delete this._keys[itemId];
        delete this._values[itemId];
    }
    getValues() {
        return Object.keys(this._keys).map((id)=>this._values[id]);
    }
}
const FontMeasurements = new FontMeasurementsImpl();

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/pixelRatio.js":"2Kvgn","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","./charWidthReader.js":"jrP7f","../../common/config/editorOptions.js":"3Xi00","../../common/config/fontInfo.js":"68pxu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bnqsM":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerWindow", ()=>registerWindow);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "getDocument", ()=>getDocument);
parcelHelpers.export(exports, "getWindows", ()=>getWindows);
parcelHelpers.export(exports, "getWindowsCount", ()=>getWindowsCount);
parcelHelpers.export(exports, "getWindowId", ()=>getWindowId);
parcelHelpers.export(exports, "getWindowById", ()=>getWindowById);
parcelHelpers.export(exports, "hasWindow", ()=>hasWindow);
parcelHelpers.export(exports, "onDidRegisterWindow", ()=>onDidRegisterWindow);
parcelHelpers.export(exports, "onWillUnregisterWindow", ()=>onWillUnregisterWindow);
parcelHelpers.export(exports, "onDidUnregisterWindow", ()=>onDidUnregisterWindow);
//#endregion
parcelHelpers.export(exports, "clearNode", ()=>clearNode);
parcelHelpers.export(exports, "addDisposableListener", ()=>addDisposableListener);
parcelHelpers.export(exports, "addStandardDisposableListener", ()=>addStandardDisposableListener);
parcelHelpers.export(exports, "addStandardDisposableGenericMouseDownListener", ()=>addStandardDisposableGenericMouseDownListener);
parcelHelpers.export(exports, "addStandardDisposableGenericMouseUpListener", ()=>addStandardDisposableGenericMouseUpListener);
parcelHelpers.export(exports, "addDisposableGenericMouseDownListener", ()=>addDisposableGenericMouseDownListener);
parcelHelpers.export(exports, "addDisposableGenericMouseUpListener", ()=>addDisposableGenericMouseUpListener);
/**
 * Execute the callback the next time the browser is idle, returning an
 * {@link IDisposable} that will cancel the callback when disposed. This wraps
 * [requestIdleCallback] so it will fallback to [setTimeout] if the environment
 * doesn't support it.
 *
 * @param targetWindow The window for which to run the idle callback
 * @param callback The callback to run when idle, this includes an
 * [IdleDeadline] that provides the time alloted for the idle callback by the
 * browser. Not respecting this deadline will result in a degraded user
 * experience.
 * @param timeout A timeout at which point to queue no longer wait for an idle
 * callback but queue it on the regular event loop (like setTimeout). Typically
 * this should not be used.
 *
 * [IdleDeadline]: https://developer.mozilla.org/en-US/docs/Web/API/IdleDeadline
 * [requestIdleCallback]: https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback
 * [setTimeout]: https://developer.mozilla.org/en-US/docs/Web/API/Window/setTimeout
 */ parcelHelpers.export(exports, "runWhenWindowIdle", ()=>runWhenWindowIdle);
/**
 * An implementation of the "idle-until-urgent"-strategy as introduced
 * here: https://philipwalton.com/articles/idle-until-urgent/
 */ parcelHelpers.export(exports, "WindowIdleValue", ()=>WindowIdleValue);
parcelHelpers.export(exports, "runAtThisOrScheduleAtNextAnimationFrame", ()=>runAtThisOrScheduleAtNextAnimationFrame);
parcelHelpers.export(exports, "scheduleAtNextAnimationFrame", ()=>scheduleAtNextAnimationFrame);
parcelHelpers.export(exports, "WindowIntervalTimer", ()=>WindowIntervalTimer);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getClientArea", ()=>getClientArea);
parcelHelpers.export(exports, "Dimension", ()=>Dimension);
parcelHelpers.export(exports, "getTopLeftOffset", ()=>getTopLeftOffset);
parcelHelpers.export(exports, "size", ()=>size);
/**
 * Returns the position of a dom node relative to the entire page.
 */ parcelHelpers.export(exports, "getDomNodePagePosition", ()=>getDomNodePagePosition);
/**
 * Returns the effective zoom on a given element before window zoom level is applied
 */ parcelHelpers.export(exports, "getDomNodeZoomLevel", ()=>getDomNodeZoomLevel);
// Adapted from WinJS
// Gets the width of the element, including margins.
parcelHelpers.export(exports, "getTotalWidth", ()=>getTotalWidth);
parcelHelpers.export(exports, "getContentWidth", ()=>getContentWidth);
// Adapted from WinJS
// Gets the height of the content of the specified element. The content height does not include borders or padding.
parcelHelpers.export(exports, "getContentHeight", ()=>getContentHeight);
// Adapted from WinJS
// Gets the height of the element, including its margins.
parcelHelpers.export(exports, "getTotalHeight", ()=>getTotalHeight);
// ----------------------------------------------------------------------------------------
parcelHelpers.export(exports, "isAncestor", ()=>isAncestor);
parcelHelpers.export(exports, "findParentWithClass", ()=>findParentWithClass);
parcelHelpers.export(exports, "hasParentWithClass", ()=>hasParentWithClass);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isInShadowDOM", ()=>isInShadowDOM);
parcelHelpers.export(exports, "getShadowRoot", ()=>getShadowRoot);
/**
 * Returns the active element across all child windows
 * based on document focus. Falls back to the main
 * window if no window has focus.
 */ parcelHelpers.export(exports, "getActiveElement", ()=>getActiveElement);
/**
 * Returns true if the focused window active element matches
 * the provided element. Falls back to the main window if no
 * window has focus.
 */ parcelHelpers.export(exports, "isActiveElement", ()=>isActiveElement);
/**
 * Returns true if the focused window active element is contained in
 * `ancestor`. Falls back to the main window if no window has focus.
 */ parcelHelpers.export(exports, "isAncestorOfActiveElement", ()=>isAncestorOfActiveElement);
/**
 * Returns the active document across main and child windows.
 * Prefers the window with focus, otherwise falls back to
 * the main windows document.
 */ parcelHelpers.export(exports, "getActiveDocument", ()=>getActiveDocument);
/**
 * Returns the active window across main and child windows.
 * Prefers the window with focus, otherwise falls back to
 * the main window.
 */ parcelHelpers.export(exports, "getActiveWindow", ()=>getActiveWindow);
/**
 * A version of createStyleSheet which has a unified API to initialize/set the style content.
 */ parcelHelpers.export(exports, "createStyleSheet2", ()=>createStyleSheet2);
parcelHelpers.export(exports, "createStyleSheet", ()=>createStyleSheet);
parcelHelpers.export(exports, "sharedMutationObserver", ()=>sharedMutationObserver);
parcelHelpers.export(exports, "createCSSRule", ()=>createCSSRule);
parcelHelpers.export(exports, "removeCSSRulesContainingSelector", ()=>removeCSSRulesContainingSelector);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isHTMLAnchorElement", ()=>isHTMLAnchorElement);
parcelHelpers.export(exports, "isSVGElement", ()=>isSVGElement);
parcelHelpers.export(exports, "isMouseEvent", ()=>isMouseEvent);
parcelHelpers.export(exports, "isKeyboardEvent", ()=>isKeyboardEvent);
parcelHelpers.export(exports, "EventType", ()=>EventType);
parcelHelpers.export(exports, "isEventLike", ()=>isEventLike);
parcelHelpers.export(exports, "EventHelper", ()=>EventHelper);
parcelHelpers.export(exports, "saveParentsScrollTop", ()=>saveParentsScrollTop);
parcelHelpers.export(exports, "restoreParentsScrollTop", ()=>restoreParentsScrollTop);
/**
 * Creates a new `IFocusTracker` instance that tracks focus changes on the given `element` and its descendants.
 *
 * @param element The `HTMLElement` or `Window` to track focus changes on.
 * @returns An `IFocusTracker` instance.
 */ parcelHelpers.export(exports, "trackFocus", ()=>trackFocus);
parcelHelpers.export(exports, "after", ()=>after);
parcelHelpers.export(exports, "append", ()=>append);
parcelHelpers.export(exports, "prepend", ()=>prepend);
/**
 * Removes all children from `parent` and appends `children`
 */ parcelHelpers.export(exports, "reset", ()=>reset);
parcelHelpers.export(exports, "Namespace", ()=>Namespace);
parcelHelpers.export(exports, "$", ()=>$);
parcelHelpers.export(exports, "setVisibility", ()=>setVisibility);
parcelHelpers.export(exports, "show", ()=>show);
parcelHelpers.export(exports, "hide", ()=>hide);
/**
 * Find a value usable for a dom node size such that the likelihood that it would be
 * displayed with constant screen pixels size is as high as possible.
 *
 * e.g. We would desire for the cursors to be 2px (CSS px) wide. Under a devicePixelRatio
 * of 1.25, the cursor will be 2.5 screen pixels wide. Depending on how the dom node aligns/"snaps"
 * with the screen pixels, it will sometimes be rendered with 2 screen pixels, and sometimes with 3 screen pixels.
 */ parcelHelpers.export(exports, "computeScreenAwareSize", ()=>computeScreenAwareSize);
/**
 * Open safely a new window. This is the best way to do so, but you cannot tell
 * if the window was opened or if it was blocked by the browser's popup blocker.
 * If you want to tell if the browser blocked the new window, use {@link windowOpenWithSuccess}.
 *
 * See https://github.com/microsoft/monaco-editor/issues/601
 * To protect against malicious code in the linked site, particularly phishing attempts,
 * the window.opener should be set to null to prevent the linked site from having access
 * to change the location of the current page.
 * See https://mathiasbynens.github.io/rel-noopener/
 */ parcelHelpers.export(exports, "windowOpenNoOpener", ()=>windowOpenNoOpener);
parcelHelpers.export(exports, "animate", ()=>animate);
/**
 * returns url('...')
 */ parcelHelpers.export(exports, "asCSSUrl", ()=>asCSSUrl);
parcelHelpers.export(exports, "asCSSPropertyValue", ()=>asCSSPropertyValue);
parcelHelpers.export(exports, "asCssValueWithDefault", ()=>asCssValueWithDefault);
// -- sanitize and trusted html
/**
 * Hooks dompurify using `afterSanitizeAttributes` to check that all `href` and `src`
 * attributes are valid.
 */ parcelHelpers.export(exports, "hookDomPurifyHrefAndSrcSanitizer", ()=>hookDomPurifyHrefAndSrcSanitizer);
parcelHelpers.export(exports, "basicMarkupHtmlTags", ()=>basicMarkupHtmlTags);
parcelHelpers.export(exports, "ModifierKeyEmitter", ()=>ModifierKeyEmitter);
parcelHelpers.export(exports, "DragAndDropObserver", ()=>DragAndDropObserver);
parcelHelpers.export(exports, "h", ()=>h);
parcelHelpers.export(exports, "svgElem", ()=>svgElem);
var _browserJs = require("./browser.js");
var _canIUseJs = require("./canIUse.js");
var _keyboardEventJs = require("./keyboardEvent.js");
var _mouseEventJs = require("./mouseEvent.js");
var _asyncJs = require("../common/async.js");
var _errorsJs = require("../common/errors.js");
var _eventJs = require("../common/event.js");
var _dompurifyJs = require("./dompurify/dompurify.js");
var _lifecycleJs = require("../common/lifecycle.js");
var _networkJs = require("../common/network.js");
var _platformJs = require("../common/platform.js");
var _hashJs = require("../common/hash.js");
var _windowJs = require("./window.js");
const { registerWindow, getWindow, getDocument, getWindows, getWindowsCount, getWindowId, getWindowById, hasWindow, onDidRegisterWindow, onWillUnregisterWindow, onDidUnregisterWindow } = function() {
    const windows = new Map();
    (0, _windowJs.ensureCodeWindow)((0, _windowJs.mainWindow), 1);
    const mainWindowRegistration = {
        window: (0, _windowJs.mainWindow),
        disposables: new (0, _lifecycleJs.DisposableStore)()
    };
    windows.set((0, _windowJs.mainWindow).vscodeWindowId, mainWindowRegistration);
    const onDidRegisterWindow = new _eventJs.Emitter();
    const onDidUnregisterWindow = new _eventJs.Emitter();
    const onWillUnregisterWindow = new _eventJs.Emitter();
    function getWindowById(windowId, fallbackToMain) {
        const window = typeof windowId === "number" ? windows.get(windowId) : undefined;
        return window ?? (fallbackToMain ? mainWindowRegistration : undefined);
    }
    return {
        onDidRegisterWindow: onDidRegisterWindow.event,
        onWillUnregisterWindow: onWillUnregisterWindow.event,
        onDidUnregisterWindow: onDidUnregisterWindow.event,
        registerWindow (window) {
            if (windows.has(window.vscodeWindowId)) return (0, _lifecycleJs.Disposable).None;
            const disposables = new (0, _lifecycleJs.DisposableStore)();
            const registeredWindow = {
                window,
                disposables: disposables.add(new (0, _lifecycleJs.DisposableStore)())
            };
            windows.set(window.vscodeWindowId, registeredWindow);
            disposables.add((0, _lifecycleJs.toDisposable)(()=>{
                windows.delete(window.vscodeWindowId);
                onDidUnregisterWindow.fire(window);
            }));
            disposables.add(addDisposableListener(window, EventType.BEFORE_UNLOAD, ()=>{
                onWillUnregisterWindow.fire(window);
            }));
            onDidRegisterWindow.fire(registeredWindow);
            return disposables;
        },
        getWindows () {
            return windows.values();
        },
        getWindowsCount () {
            return windows.size;
        },
        getWindowId (targetWindow) {
            return targetWindow.vscodeWindowId;
        },
        hasWindow (windowId) {
            return windows.has(windowId);
        },
        getWindowById,
        getWindow (e) {
            const candidateNode = e;
            if (candidateNode?.ownerDocument?.defaultView) return candidateNode.ownerDocument.defaultView.window;
            const candidateEvent = e;
            if (candidateEvent?.view) return candidateEvent.view.window;
            return 0, _windowJs.mainWindow;
        },
        getDocument (e) {
            const candidateNode = e;
            return getWindow(candidateNode).document;
        }
    };
}();
function clearNode(node) {
    while(node.firstChild)node.firstChild.remove();
}
class DomListener {
    constructor(node, type, handler, options){
        this._node = node;
        this._type = type;
        this._handler = handler;
        this._options = options || false;
        this._node.addEventListener(this._type, this._handler, this._options);
    }
    dispose() {
        if (!this._handler) // Already disposed
        return;
        this._node.removeEventListener(this._type, this._handler, this._options);
        // Prevent leakers from holding on to the dom or handler func
        this._node = null;
        this._handler = null;
    }
}
function addDisposableListener(node, type, handler, useCaptureOrOptions) {
    return new DomListener(node, type, handler, useCaptureOrOptions);
}
function _wrapAsStandardMouseEvent(targetWindow, handler) {
    return function(e) {
        return handler(new (0, _mouseEventJs.StandardMouseEvent)(targetWindow, e));
    };
}
function _wrapAsStandardKeyboardEvent(handler) {
    return function(e) {
        return handler(new (0, _keyboardEventJs.StandardKeyboardEvent)(e));
    };
}
const addStandardDisposableListener = function addStandardDisposableListener(node, type, handler, useCapture) {
    let wrapHandler = handler;
    if (type === "click" || type === "mousedown" || type === "contextmenu") wrapHandler = _wrapAsStandardMouseEvent(getWindow(node), handler);
    else if (type === "keydown" || type === "keypress" || type === "keyup") wrapHandler = _wrapAsStandardKeyboardEvent(handler);
    return addDisposableListener(node, type, wrapHandler, useCapture);
};
const addStandardDisposableGenericMouseDownListener = function addStandardDisposableListener(node, handler, useCapture) {
    const wrapHandler = _wrapAsStandardMouseEvent(getWindow(node), handler);
    return addDisposableGenericMouseDownListener(node, wrapHandler, useCapture);
};
const addStandardDisposableGenericMouseUpListener = function addStandardDisposableListener(node, handler, useCapture) {
    const wrapHandler = _wrapAsStandardMouseEvent(getWindow(node), handler);
    return addDisposableGenericMouseUpListener(node, wrapHandler, useCapture);
};
function addDisposableGenericMouseDownListener(node, handler, useCapture) {
    return addDisposableListener(node, _platformJs.isIOS && (0, _canIUseJs.BrowserFeatures).pointerEvents ? EventType.POINTER_DOWN : EventType.MOUSE_DOWN, handler, useCapture);
}
function addDisposableGenericMouseUpListener(node, handler, useCapture) {
    return addDisposableListener(node, _platformJs.isIOS && (0, _canIUseJs.BrowserFeatures).pointerEvents ? EventType.POINTER_UP : EventType.MOUSE_UP, handler, useCapture);
}
function runWhenWindowIdle(targetWindow, callback, timeout) {
    return (0, _asyncJs._runWhenIdle)(targetWindow, callback, timeout);
}
class WindowIdleValue extends (0, _asyncJs.AbstractIdleValue) {
    constructor(targetWindow, executor){
        super(targetWindow, executor);
    }
}
let runAtThisOrScheduleAtNextAnimationFrame;
let scheduleAtNextAnimationFrame;
class WindowIntervalTimer extends (0, _asyncJs.IntervalTimer) {
    /**
     *
     * @param node The optional node from which the target window is determined
     */ constructor(node){
        super();
        this.defaultTarget = node && getWindow(node);
    }
    cancelAndSet(runner, interval, targetWindow) {
        return super.cancelAndSet(runner, interval, targetWindow ?? this.defaultTarget);
    }
}
class AnimationFrameQueueItem {
    constructor(runner, priority = 0){
        this._runner = runner;
        this.priority = priority;
        this._canceled = false;
    }
    dispose() {
        this._canceled = true;
    }
    execute() {
        if (this._canceled) return;
        try {
            this._runner();
        } catch (e) {
            (0, _errorsJs.onUnexpectedError)(e);
        }
    }
    // Sort by priority (largest to lowest)
    static sort(a, b) {
        return b.priority - a.priority;
    }
}
(function() {
    /**
     * The runners scheduled at the next animation frame
     */ const NEXT_QUEUE = new Map();
    /**
     * The runners scheduled at the current animation frame
     */ const CURRENT_QUEUE = new Map();
    /**
     * A flag to keep track if the native requestAnimationFrame was already called
     */ const animFrameRequested = new Map();
    /**
     * A flag to indicate if currently handling a native requestAnimationFrame callback
     */ const inAnimationFrameRunner = new Map();
    const animationFrameRunner = (targetWindowId)=>{
        animFrameRequested.set(targetWindowId, false);
        const currentQueue = NEXT_QUEUE.get(targetWindowId) ?? [];
        CURRENT_QUEUE.set(targetWindowId, currentQueue);
        NEXT_QUEUE.set(targetWindowId, []);
        inAnimationFrameRunner.set(targetWindowId, true);
        while(currentQueue.length > 0){
            currentQueue.sort(AnimationFrameQueueItem.sort);
            const top = currentQueue.shift();
            top.execute();
        }
        inAnimationFrameRunner.set(targetWindowId, false);
    };
    scheduleAtNextAnimationFrame = (targetWindow, runner, priority = 0)=>{
        const targetWindowId = getWindowId(targetWindow);
        const item = new AnimationFrameQueueItem(runner, priority);
        let nextQueue = NEXT_QUEUE.get(targetWindowId);
        if (!nextQueue) {
            nextQueue = [];
            NEXT_QUEUE.set(targetWindowId, nextQueue);
        }
        nextQueue.push(item);
        if (!animFrameRequested.get(targetWindowId)) {
            animFrameRequested.set(targetWindowId, true);
            targetWindow.requestAnimationFrame(()=>animationFrameRunner(targetWindowId));
        }
        return item;
    };
    runAtThisOrScheduleAtNextAnimationFrame = (targetWindow, runner, priority)=>{
        const targetWindowId = getWindowId(targetWindow);
        if (inAnimationFrameRunner.get(targetWindowId)) {
            const item = new AnimationFrameQueueItem(runner, priority);
            let currentQueue = CURRENT_QUEUE.get(targetWindowId);
            if (!currentQueue) {
                currentQueue = [];
                CURRENT_QUEUE.set(targetWindowId, currentQueue);
            }
            currentQueue.push(item);
            return item;
        } else return scheduleAtNextAnimationFrame(targetWindow, runner, priority);
    };
})();
function getComputedStyle(el) {
    return getWindow(el).getComputedStyle(el, null);
}
function getClientArea(element, fallback) {
    const elWindow = getWindow(element);
    const elDocument = elWindow.document;
    // Try with DOM clientWidth / clientHeight
    if (element !== elDocument.body) return new Dimension(element.clientWidth, element.clientHeight);
    // If visual view port exits and it's on mobile, it should be used instead of window innerWidth / innerHeight, or document.body.clientWidth / document.body.clientHeight
    if (_platformJs.isIOS && elWindow?.visualViewport) return new Dimension(elWindow.visualViewport.width, elWindow.visualViewport.height);
    // Try innerWidth / innerHeight
    if (elWindow?.innerWidth && elWindow.innerHeight) return new Dimension(elWindow.innerWidth, elWindow.innerHeight);
    // Try with document.body.clientWidth / document.body.clientHeight
    if (elDocument.body && elDocument.body.clientWidth && elDocument.body.clientHeight) return new Dimension(elDocument.body.clientWidth, elDocument.body.clientHeight);
    // Try with document.documentElement.clientWidth / document.documentElement.clientHeight
    if (elDocument.documentElement && elDocument.documentElement.clientWidth && elDocument.documentElement.clientHeight) return new Dimension(elDocument.documentElement.clientWidth, elDocument.documentElement.clientHeight);
    if (fallback) return getClientArea(fallback);
    throw new Error("Unable to figure out browser width and height");
}
class SizeUtils {
    // Adapted from WinJS
    // Converts a CSS positioning string for the specified element to pixels.
    static convertToPixels(element, value) {
        return parseFloat(value) || 0;
    }
    static getDimension(element, cssPropertyName, jsPropertyName) {
        const computedStyle = getComputedStyle(element);
        const value = computedStyle ? computedStyle.getPropertyValue(cssPropertyName) : "0";
        return SizeUtils.convertToPixels(element, value);
    }
    static getBorderLeftWidth(element) {
        return SizeUtils.getDimension(element, "border-left-width", "borderLeftWidth");
    }
    static getBorderRightWidth(element) {
        return SizeUtils.getDimension(element, "border-right-width", "borderRightWidth");
    }
    static getBorderTopWidth(element) {
        return SizeUtils.getDimension(element, "border-top-width", "borderTopWidth");
    }
    static getBorderBottomWidth(element) {
        return SizeUtils.getDimension(element, "border-bottom-width", "borderBottomWidth");
    }
    static getPaddingLeft(element) {
        return SizeUtils.getDimension(element, "padding-left", "paddingLeft");
    }
    static getPaddingRight(element) {
        return SizeUtils.getDimension(element, "padding-right", "paddingRight");
    }
    static getPaddingTop(element) {
        return SizeUtils.getDimension(element, "padding-top", "paddingTop");
    }
    static getPaddingBottom(element) {
        return SizeUtils.getDimension(element, "padding-bottom", "paddingBottom");
    }
    static getMarginLeft(element) {
        return SizeUtils.getDimension(element, "margin-left", "marginLeft");
    }
    static getMarginTop(element) {
        return SizeUtils.getDimension(element, "margin-top", "marginTop");
    }
    static getMarginRight(element) {
        return SizeUtils.getDimension(element, "margin-right", "marginRight");
    }
    static getMarginBottom(element) {
        return SizeUtils.getDimension(element, "margin-bottom", "marginBottom");
    }
}
class Dimension {
    static{
        this.None = new Dimension(0, 0);
    }
    constructor(width, height){
        this.width = width;
        this.height = height;
    }
    with(width = this.width, height = this.height) {
        if (width !== this.width || height !== this.height) return new Dimension(width, height);
        else return this;
    }
    static is(obj) {
        return typeof obj === "object" && typeof obj.height === "number" && typeof obj.width === "number";
    }
    static lift(obj) {
        if (obj instanceof Dimension) return obj;
        else return new Dimension(obj.width, obj.height);
    }
    static equals(a, b) {
        if (a === b) return true;
        if (!a || !b) return false;
        return a.width === b.width && a.height === b.height;
    }
}
function getTopLeftOffset(element) {
    // Adapted from WinJS.Utilities.getPosition
    // and added borders to the mix
    let offsetParent = element.offsetParent;
    let top = element.offsetTop;
    let left = element.offsetLeft;
    while((element = element.parentNode) !== null && element !== element.ownerDocument.body && element !== element.ownerDocument.documentElement){
        top -= element.scrollTop;
        const c = isShadowRoot(element) ? null : getComputedStyle(element);
        if (c) left -= c.direction !== "rtl" ? element.scrollLeft : -element.scrollLeft;
        if (element === offsetParent) {
            left += SizeUtils.getBorderLeftWidth(element);
            top += SizeUtils.getBorderTopWidth(element);
            top += element.offsetTop;
            left += element.offsetLeft;
            offsetParent = element.offsetParent;
        }
    }
    return {
        left: left,
        top: top
    };
}
function size(element, width, height) {
    if (typeof width === "number") element.style.width = `${width}px`;
    if (typeof height === "number") element.style.height = `${height}px`;
}
function getDomNodePagePosition(domNode) {
    const bb = domNode.getBoundingClientRect();
    const window = getWindow(domNode);
    return {
        left: bb.left + window.scrollX,
        top: bb.top + window.scrollY,
        width: bb.width,
        height: bb.height
    };
}
function getDomNodeZoomLevel(domNode) {
    let testElement = domNode;
    let zoom = 1.0;
    do {
        const elementZoomLevel = getComputedStyle(testElement).zoom;
        if (elementZoomLevel !== null && elementZoomLevel !== undefined && elementZoomLevel !== "1") zoom *= elementZoomLevel;
        testElement = testElement.parentElement;
    }while (testElement !== null && testElement !== testElement.ownerDocument.documentElement);
    return zoom;
}
function getTotalWidth(element) {
    const margin = SizeUtils.getMarginLeft(element) + SizeUtils.getMarginRight(element);
    return element.offsetWidth + margin;
}
function getContentWidth(element) {
    const border = SizeUtils.getBorderLeftWidth(element) + SizeUtils.getBorderRightWidth(element);
    const padding = SizeUtils.getPaddingLeft(element) + SizeUtils.getPaddingRight(element);
    return element.offsetWidth - border - padding;
}
function getContentHeight(element) {
    const border = SizeUtils.getBorderTopWidth(element) + SizeUtils.getBorderBottomWidth(element);
    const padding = SizeUtils.getPaddingTop(element) + SizeUtils.getPaddingBottom(element);
    return element.offsetHeight - border - padding;
}
function getTotalHeight(element) {
    const margin = SizeUtils.getMarginTop(element) + SizeUtils.getMarginBottom(element);
    return element.offsetHeight + margin;
}
function isAncestor(testChild, testAncestor) {
    return Boolean(testAncestor?.contains(testChild));
}
function findParentWithClass(node, clazz, stopAtClazzOrNode) {
    while(node && node.nodeType === node.ELEMENT_NODE){
        if (node.classList.contains(clazz)) return node;
        if (stopAtClazzOrNode) {
            if (typeof stopAtClazzOrNode === "string") {
                if (node.classList.contains(stopAtClazzOrNode)) return null;
            } else {
                if (node === stopAtClazzOrNode) return null;
            }
        }
        node = node.parentNode;
    }
    return null;
}
function hasParentWithClass(node, clazz, stopAtClazzOrNode) {
    return !!findParentWithClass(node, clazz, stopAtClazzOrNode);
}
function isShadowRoot(node) {
    return node && !!node.host && !!node.mode;
}
function isInShadowDOM(domNode) {
    return !!getShadowRoot(domNode);
}
function getShadowRoot(domNode) {
    while(domNode.parentNode){
        if (domNode === domNode.ownerDocument?.body) // reached the body
        return null;
        domNode = domNode.parentNode;
    }
    return isShadowRoot(domNode) ? domNode : null;
}
function getActiveElement() {
    let result = getActiveDocument().activeElement;
    while(result?.shadowRoot)result = result.shadowRoot.activeElement;
    return result;
}
function isActiveElement(element) {
    return getActiveElement() === element;
}
function isAncestorOfActiveElement(ancestor) {
    return isAncestor(getActiveElement(), ancestor);
}
function getActiveDocument() {
    if (getWindowsCount() <= 1) return (0, _windowJs.mainWindow).document;
    const documents = Array.from(getWindows()).map(({ window })=>window.document);
    return documents.find((doc)=>doc.hasFocus()) ?? (0, _windowJs.mainWindow).document;
}
function getActiveWindow() {
    const document1 = getActiveDocument();
    return document1.defaultView?.window ?? (0, _windowJs.mainWindow);
}
const globalStylesheets = new Map();
function createStyleSheet2() {
    return new WrappedStyleElement();
}
class WrappedStyleElement {
    constructor(){
        this._currentCssStyle = "";
        this._styleSheet = undefined;
    }
    setStyle(cssStyle) {
        if (cssStyle === this._currentCssStyle) return;
        this._currentCssStyle = cssStyle;
        if (!this._styleSheet) this._styleSheet = createStyleSheet((0, _windowJs.mainWindow).document.head, (s)=>s.innerText = cssStyle);
        else this._styleSheet.innerText = cssStyle;
    }
    dispose() {
        if (this._styleSheet) {
            this._styleSheet.remove();
            this._styleSheet = undefined;
        }
    }
}
function createStyleSheet(container = (0, _windowJs.mainWindow).document.head, beforeAppend, disposableStore) {
    const style = document.createElement("style");
    style.type = "text/css";
    style.media = "screen";
    beforeAppend?.(style);
    container.appendChild(style);
    if (disposableStore) disposableStore.add((0, _lifecycleJs.toDisposable)(()=>style.remove()));
    // With <head> as container, the stylesheet becomes global and is tracked
    // to support auxiliary windows to clone the stylesheet.
    if (container === (0, _windowJs.mainWindow).document.head) {
        const globalStylesheetClones = new Set();
        globalStylesheets.set(style, globalStylesheetClones);
        for (const { window: targetWindow, disposables } of getWindows()){
            if (targetWindow === (0, _windowJs.mainWindow)) continue; // main window is already tracked
            const cloneDisposable = disposables.add(cloneGlobalStyleSheet(style, globalStylesheetClones, targetWindow));
            disposableStore?.add(cloneDisposable);
        }
    }
    return style;
}
function cloneGlobalStyleSheet(globalStylesheet, globalStylesheetClones, targetWindow) {
    const disposables = new (0, _lifecycleJs.DisposableStore)();
    const clone = globalStylesheet.cloneNode(true);
    targetWindow.document.head.appendChild(clone);
    disposables.add((0, _lifecycleJs.toDisposable)(()=>clone.remove()));
    for (const rule of getDynamicStyleSheetRules(globalStylesheet))clone.sheet?.insertRule(rule.cssText, clone.sheet?.cssRules.length);
    disposables.add(sharedMutationObserver.observe(globalStylesheet, disposables, {
        childList: true
    })(()=>{
        clone.textContent = globalStylesheet.textContent;
    }));
    globalStylesheetClones.add(clone);
    disposables.add((0, _lifecycleJs.toDisposable)(()=>globalStylesheetClones.delete(clone)));
    return disposables;
}
const sharedMutationObserver = new class {
    constructor(){
        this.mutationObservers = new Map();
    }
    observe(target, disposables, options) {
        let mutationObserversPerTarget = this.mutationObservers.get(target);
        if (!mutationObserversPerTarget) {
            mutationObserversPerTarget = new Map();
            this.mutationObservers.set(target, mutationObserversPerTarget);
        }
        const optionsHash = (0, _hashJs.hash)(options);
        let mutationObserverPerOptions = mutationObserversPerTarget.get(optionsHash);
        if (!mutationObserverPerOptions) {
            const onDidMutate = new _eventJs.Emitter();
            const observer = new MutationObserver((mutations)=>onDidMutate.fire(mutations));
            observer.observe(target, options);
            const resolvedMutationObserverPerOptions = mutationObserverPerOptions = {
                users: 1,
                observer,
                onDidMutate: onDidMutate.event
            };
            disposables.add((0, _lifecycleJs.toDisposable)(()=>{
                resolvedMutationObserverPerOptions.users -= 1;
                if (resolvedMutationObserverPerOptions.users === 0) {
                    onDidMutate.dispose();
                    observer.disconnect();
                    mutationObserversPerTarget?.delete(optionsHash);
                    if (mutationObserversPerTarget?.size === 0) this.mutationObservers.delete(target);
                }
            }));
            mutationObserversPerTarget.set(optionsHash, mutationObserverPerOptions);
        } else mutationObserverPerOptions.users += 1;
        return mutationObserverPerOptions.onDidMutate;
    }
};
let _sharedStyleSheet = null;
function getSharedStyleSheet() {
    if (!_sharedStyleSheet) _sharedStyleSheet = createStyleSheet();
    return _sharedStyleSheet;
}
function getDynamicStyleSheetRules(style) {
    if (style?.sheet?.rules) // Chrome, IE
    return style.sheet.rules;
    if (style?.sheet?.cssRules) // FF
    return style.sheet.cssRules;
    return [];
}
function createCSSRule(selector, cssText, style = getSharedStyleSheet()) {
    if (!style || !cssText) return;
    style.sheet?.insertRule(`${selector} {${cssText}}`, 0);
    // Apply rule also to all cloned global stylesheets
    for (const clonedGlobalStylesheet of globalStylesheets.get(style) ?? [])createCSSRule(selector, cssText, clonedGlobalStylesheet);
}
function removeCSSRulesContainingSelector(ruleName, style = getSharedStyleSheet()) {
    if (!style) return;
    const rules = getDynamicStyleSheetRules(style);
    const toDelete = [];
    for(let i = 0; i < rules.length; i++){
        const rule = rules[i];
        if (isCSSStyleRule(rule) && rule.selectorText.indexOf(ruleName) !== -1) toDelete.push(i);
    }
    for(let i = toDelete.length - 1; i >= 0; i--)style.sheet?.deleteRule(toDelete[i]);
    // Remove rules also from all cloned global stylesheets
    for (const clonedGlobalStylesheet of globalStylesheets.get(style) ?? [])removeCSSRulesContainingSelector(ruleName, clonedGlobalStylesheet);
}
function isCSSStyleRule(rule) {
    return typeof rule.selectorText === "string";
}
function isHTMLElement(e) {
    // eslint-disable-next-line no-restricted-syntax
    return e instanceof HTMLElement || e instanceof getWindow(e).HTMLElement;
}
function isHTMLAnchorElement(e) {
    // eslint-disable-next-line no-restricted-syntax
    return e instanceof HTMLAnchorElement || e instanceof getWindow(e).HTMLAnchorElement;
}
function isSVGElement(e) {
    // eslint-disable-next-line no-restricted-syntax
    return e instanceof SVGElement || e instanceof getWindow(e).SVGElement;
}
function isMouseEvent(e) {
    // eslint-disable-next-line no-restricted-syntax
    return e instanceof MouseEvent || e instanceof getWindow(e).MouseEvent;
}
function isKeyboardEvent(e) {
    // eslint-disable-next-line no-restricted-syntax
    return e instanceof KeyboardEvent || e instanceof getWindow(e).KeyboardEvent;
}
const EventType = {
    // Mouse
    CLICK: "click",
    AUXCLICK: "auxclick",
    DBLCLICK: "dblclick",
    MOUSE_UP: "mouseup",
    MOUSE_DOWN: "mousedown",
    MOUSE_OVER: "mouseover",
    MOUSE_MOVE: "mousemove",
    MOUSE_OUT: "mouseout",
    MOUSE_ENTER: "mouseenter",
    MOUSE_LEAVE: "mouseleave",
    MOUSE_WHEEL: "wheel",
    POINTER_UP: "pointerup",
    POINTER_DOWN: "pointerdown",
    POINTER_MOVE: "pointermove",
    POINTER_LEAVE: "pointerleave",
    CONTEXT_MENU: "contextmenu",
    WHEEL: "wheel",
    // Keyboard
    KEY_DOWN: "keydown",
    KEY_PRESS: "keypress",
    KEY_UP: "keyup",
    // HTML Document
    LOAD: "load",
    BEFORE_UNLOAD: "beforeunload",
    UNLOAD: "unload",
    PAGE_SHOW: "pageshow",
    PAGE_HIDE: "pagehide",
    PASTE: "paste",
    ABORT: "abort",
    ERROR: "error",
    RESIZE: "resize",
    SCROLL: "scroll",
    FULLSCREEN_CHANGE: "fullscreenchange",
    WK_FULLSCREEN_CHANGE: "webkitfullscreenchange",
    // Form
    SELECT: "select",
    CHANGE: "change",
    SUBMIT: "submit",
    RESET: "reset",
    FOCUS: "focus",
    FOCUS_IN: "focusin",
    FOCUS_OUT: "focusout",
    BLUR: "blur",
    INPUT: "input",
    // Local Storage
    STORAGE: "storage",
    // Drag
    DRAG_START: "dragstart",
    DRAG: "drag",
    DRAG_ENTER: "dragenter",
    DRAG_LEAVE: "dragleave",
    DRAG_OVER: "dragover",
    DROP: "drop",
    DRAG_END: "dragend",
    // Animation
    ANIMATION_START: _browserJs.isWebKit ? "webkitAnimationStart" : "animationstart",
    ANIMATION_END: _browserJs.isWebKit ? "webkitAnimationEnd" : "animationend",
    ANIMATION_ITERATION: _browserJs.isWebKit ? "webkitAnimationIteration" : "animationiteration"
};
function isEventLike(obj) {
    const candidate = obj;
    return !!(candidate && typeof candidate.preventDefault === "function" && typeof candidate.stopPropagation === "function");
}
const EventHelper = {
    stop: (e, cancelBubble)=>{
        e.preventDefault();
        if (cancelBubble) e.stopPropagation();
        return e;
    }
};
function saveParentsScrollTop(node) {
    const r = [];
    for(let i = 0; node && node.nodeType === node.ELEMENT_NODE; i++){
        r[i] = node.scrollTop;
        node = node.parentNode;
    }
    return r;
}
function restoreParentsScrollTop(node, state) {
    for(let i = 0; node && node.nodeType === node.ELEMENT_NODE; i++){
        if (node.scrollTop !== state[i]) node.scrollTop = state[i];
        node = node.parentNode;
    }
}
class FocusTracker extends (0, _lifecycleJs.Disposable) {
    static hasFocusWithin(element) {
        if (isHTMLElement(element)) {
            const shadowRoot = getShadowRoot(element);
            const activeElement = shadowRoot ? shadowRoot.activeElement : element.ownerDocument.activeElement;
            return isAncestor(activeElement, element);
        } else {
            const window = element;
            return isAncestor(window.document.activeElement, window.document);
        }
    }
    constructor(element){
        super();
        this._onDidFocus = this._register(new _eventJs.Emitter());
        this.onDidFocus = this._onDidFocus.event;
        this._onDidBlur = this._register(new _eventJs.Emitter());
        this.onDidBlur = this._onDidBlur.event;
        let hasFocus = FocusTracker.hasFocusWithin(element);
        let loosingFocus = false;
        const onFocus = ()=>{
            loosingFocus = false;
            if (!hasFocus) {
                hasFocus = true;
                this._onDidFocus.fire();
            }
        };
        const onBlur = ()=>{
            if (hasFocus) {
                loosingFocus = true;
                (isHTMLElement(element) ? getWindow(element) : element).setTimeout(()=>{
                    if (loosingFocus) {
                        loosingFocus = false;
                        hasFocus = false;
                        this._onDidBlur.fire();
                    }
                }, 0);
            }
        };
        this._refreshStateHandler = ()=>{
            const currentNodeHasFocus = FocusTracker.hasFocusWithin(element);
            if (currentNodeHasFocus !== hasFocus) {
                if (hasFocus) onBlur();
                else onFocus();
            }
        };
        this._register(addDisposableListener(element, EventType.FOCUS, onFocus, true));
        this._register(addDisposableListener(element, EventType.BLUR, onBlur, true));
        if (isHTMLElement(element)) {
            this._register(addDisposableListener(element, EventType.FOCUS_IN, ()=>this._refreshStateHandler()));
            this._register(addDisposableListener(element, EventType.FOCUS_OUT, ()=>this._refreshStateHandler()));
        }
    }
}
function trackFocus(element) {
    return new FocusTracker(element);
}
function after(sibling, child) {
    sibling.after(child);
    return child;
}
function append(parent, ...children) {
    parent.append(...children);
    if (children.length === 1 && typeof children[0] !== "string") return children[0];
}
function prepend(parent, child) {
    parent.insertBefore(child, parent.firstChild);
    return child;
}
function reset(parent, ...children) {
    parent.innerText = "";
    append(parent, ...children);
}
const SELECTOR_REGEX = /([\w\-]+)?(#([\w\-]+))?((\.([\w\-]+))*)/;
var Namespace;
(function(Namespace) {
    Namespace["HTML"] = "http://www.w3.org/1999/xhtml";
    Namespace["SVG"] = "http://www.w3.org/2000/svg";
})(Namespace || (Namespace = {}));
function _$(namespace, description, attrs, ...children) {
    const match = SELECTOR_REGEX.exec(description);
    if (!match) throw new Error("Bad use of emmet");
    const tagName = match[1] || "div";
    let result;
    if (namespace !== Namespace.HTML) result = document.createElementNS(namespace, tagName);
    else result = document.createElement(tagName);
    if (match[3]) result.id = match[3];
    if (match[4]) result.className = match[4].replace(/\./g, " ").trim();
    if (attrs) Object.entries(attrs).forEach(([name, value])=>{
        if (typeof value === "undefined") return;
        if (/^on\w+$/.test(name)) result[name] = value;
        else if (name === "selected") {
            if (value) result.setAttribute(name, "true");
        } else result.setAttribute(name, value);
    });
    result.append(...children);
    return result;
}
function $(description, attrs, ...children) {
    return _$(Namespace.HTML, description, attrs, ...children);
}
$.SVG = function(description, attrs, ...children) {
    return _$(Namespace.SVG, description, attrs, ...children);
};
function setVisibility(visible, ...elements) {
    if (visible) show(...elements);
    else hide(...elements);
}
function show(...elements) {
    for (const element of elements){
        element.style.display = "";
        element.removeAttribute("aria-hidden");
    }
}
function hide(...elements) {
    for (const element of elements){
        element.style.display = "none";
        element.setAttribute("aria-hidden", "true");
    }
}
function computeScreenAwareSize(window, cssPx) {
    const screenPx = window.devicePixelRatio * cssPx;
    return Math.max(1, Math.floor(screenPx)) / window.devicePixelRatio;
}
function windowOpenNoOpener(url) {
    // By using 'noopener' in the `windowFeatures` argument, the newly created window will
    // not be able to use `window.opener` to reach back to the current page.
    // See https://stackoverflow.com/a/46958731
    // See https://developer.mozilla.org/en-US/docs/Web/API/Window/open#noopener
    // However, this also doesn't allow us to realize if the browser blocked
    // the creation of the window.
    (0, _windowJs.mainWindow).open(url, "_blank", "noopener");
}
function animate(targetWindow, fn) {
    const step = ()=>{
        fn();
        stepDisposable = scheduleAtNextAnimationFrame(targetWindow, step);
    };
    let stepDisposable = scheduleAtNextAnimationFrame(targetWindow, step);
    return (0, _lifecycleJs.toDisposable)(()=>stepDisposable.dispose());
}
(0, _networkJs.RemoteAuthorities).setPreferredWebSchema(/^https:/.test((0, _windowJs.mainWindow).location.href) ? "https" : "http");
function asCSSUrl(uri) {
    if (!uri) return `url('')`;
    return `url('${(0, _networkJs.FileAccess).uriToBrowserUri(uri).toString(true).replace(/'/g, "%27")}')`;
}
function asCSSPropertyValue(value) {
    return `'${value.replace(/'/g, "%27")}'`;
}
function asCssValueWithDefault(cssPropertyValue, dflt) {
    if (cssPropertyValue !== undefined) {
        const variableMatch = cssPropertyValue.match(/^\s*var\((.+)\)$/);
        if (variableMatch) {
            const varArguments = variableMatch[1].split(",", 2);
            if (varArguments.length === 2) dflt = asCssValueWithDefault(varArguments[1].trim(), dflt);
            return `var(${varArguments[0]}, ${dflt})`;
        }
        return cssPropertyValue;
    }
    return dflt;
}
function hookDomPurifyHrefAndSrcSanitizer(allowedProtocols, allowDataImages = false) {
    // https://github.com/cure53/DOMPurify/blob/main/demos/hooks-scheme-allowlist.html
    // build an anchor to map URLs to
    const anchor = document.createElement("a");
    _dompurifyJs.addHook("afterSanitizeAttributes", (node)=>{
        // check all href/src attributes for validity
        for (const attr of [
            "href",
            "src"
        ])if (node.hasAttribute(attr)) {
            const attrValue = node.getAttribute(attr);
            if (attr === "href" && attrValue.startsWith("#")) continue;
            anchor.href = attrValue;
            if (!allowedProtocols.includes(anchor.protocol.replace(/:$/, ""))) {
                if (allowDataImages && attr === "src" && anchor.href.startsWith("data:")) continue;
                node.removeAttribute(attr);
            }
        }
    });
    return (0, _lifecycleJs.toDisposable)(()=>{
        _dompurifyJs.removeHook("afterSanitizeAttributes");
    });
}
const basicMarkupHtmlTags = Object.freeze([
    "a",
    "abbr",
    "b",
    "bdo",
    "blockquote",
    "br",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "dd",
    "del",
    "details",
    "dfn",
    "div",
    "dl",
    "dt",
    "em",
    "figcaption",
    "figure",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "i",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "li",
    "mark",
    "ol",
    "p",
    "pre",
    "q",
    "rp",
    "rt",
    "ruby",
    "samp",
    "small",
    "small",
    "source",
    "span",
    "strike",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr"
]);
const defaultDomPurifyConfig = Object.freeze({
    ALLOWED_TAGS: [
        "a",
        "button",
        "blockquote",
        "code",
        "div",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hr",
        "input",
        "label",
        "li",
        "p",
        "pre",
        "select",
        "small",
        "span",
        "strong",
        "textarea",
        "ul",
        "ol"
    ],
    ALLOWED_ATTR: [
        "href",
        "data-href",
        "data-command",
        "target",
        "title",
        "name",
        "src",
        "alt",
        "class",
        "id",
        "role",
        "tabindex",
        "style",
        "data-code",
        "width",
        "height",
        "align",
        "x-dispatch",
        "required",
        "checked",
        "placeholder",
        "type",
        "start"
    ],
    RETURN_DOM: false,
    RETURN_DOM_FRAGMENT: false,
    RETURN_TRUSTED_TYPE: true
});
class ModifierKeyEmitter extends _eventJs.Emitter {
    constructor(){
        super();
        this._subscriptions = new (0, _lifecycleJs.DisposableStore)();
        this._keyStatus = {
            altKey: false,
            shiftKey: false,
            ctrlKey: false,
            metaKey: false
        };
        this._subscriptions.add(_eventJs.Event.runAndSubscribe(onDidRegisterWindow, ({ window, disposables })=>this.registerListeners(window, disposables), {
            window: (0, _windowJs.mainWindow),
            disposables: this._subscriptions
        }));
    }
    registerListeners(window, disposables) {
        disposables.add(addDisposableListener(window, "keydown", (e)=>{
            if (e.defaultPrevented) return;
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            // If Alt-key keydown event is repeated, ignore it #112347
            // Only known to be necessary for Alt-Key at the moment #115810
            if (event.keyCode === 6 /* KeyCode.Alt */  && e.repeat) return;
            if (e.altKey && !this._keyStatus.altKey) this._keyStatus.lastKeyPressed = "alt";
            else if (e.ctrlKey && !this._keyStatus.ctrlKey) this._keyStatus.lastKeyPressed = "ctrl";
            else if (e.metaKey && !this._keyStatus.metaKey) this._keyStatus.lastKeyPressed = "meta";
            else if (e.shiftKey && !this._keyStatus.shiftKey) this._keyStatus.lastKeyPressed = "shift";
            else if (event.keyCode !== 6 /* KeyCode.Alt */ ) this._keyStatus.lastKeyPressed = undefined;
            else return;
            this._keyStatus.altKey = e.altKey;
            this._keyStatus.ctrlKey = e.ctrlKey;
            this._keyStatus.metaKey = e.metaKey;
            this._keyStatus.shiftKey = e.shiftKey;
            if (this._keyStatus.lastKeyPressed) {
                this._keyStatus.event = e;
                this.fire(this._keyStatus);
            }
        }, true));
        disposables.add(addDisposableListener(window, "keyup", (e)=>{
            if (e.defaultPrevented) return;
            if (!e.altKey && this._keyStatus.altKey) this._keyStatus.lastKeyReleased = "alt";
            else if (!e.ctrlKey && this._keyStatus.ctrlKey) this._keyStatus.lastKeyReleased = "ctrl";
            else if (!e.metaKey && this._keyStatus.metaKey) this._keyStatus.lastKeyReleased = "meta";
            else if (!e.shiftKey && this._keyStatus.shiftKey) this._keyStatus.lastKeyReleased = "shift";
            else this._keyStatus.lastKeyReleased = undefined;
            if (this._keyStatus.lastKeyPressed !== this._keyStatus.lastKeyReleased) this._keyStatus.lastKeyPressed = undefined;
            this._keyStatus.altKey = e.altKey;
            this._keyStatus.ctrlKey = e.ctrlKey;
            this._keyStatus.metaKey = e.metaKey;
            this._keyStatus.shiftKey = e.shiftKey;
            if (this._keyStatus.lastKeyReleased) {
                this._keyStatus.event = e;
                this.fire(this._keyStatus);
            }
        }, true));
        disposables.add(addDisposableListener(window.document.body, "mousedown", ()=>{
            this._keyStatus.lastKeyPressed = undefined;
        }, true));
        disposables.add(addDisposableListener(window.document.body, "mouseup", ()=>{
            this._keyStatus.lastKeyPressed = undefined;
        }, true));
        disposables.add(addDisposableListener(window.document.body, "mousemove", (e)=>{
            if (e.buttons) this._keyStatus.lastKeyPressed = undefined;
        }, true));
        disposables.add(addDisposableListener(window, "blur", ()=>{
            this.resetKeyStatus();
        }));
    }
    get keyStatus() {
        return this._keyStatus;
    }
    /**
     * Allows to explicitly reset the key status based on more knowledge (#109062)
     */ resetKeyStatus() {
        this.doResetKeyStatus();
        this.fire(this._keyStatus);
    }
    doResetKeyStatus() {
        this._keyStatus = {
            altKey: false,
            shiftKey: false,
            ctrlKey: false,
            metaKey: false
        };
    }
    static getInstance() {
        if (!ModifierKeyEmitter.instance) ModifierKeyEmitter.instance = new ModifierKeyEmitter();
        return ModifierKeyEmitter.instance;
    }
    dispose() {
        super.dispose();
        this._subscriptions.dispose();
    }
}
class DragAndDropObserver extends (0, _lifecycleJs.Disposable) {
    constructor(element, callbacks){
        super();
        this.element = element;
        this.callbacks = callbacks;
        // A helper to fix issues with repeated DRAG_ENTER / DRAG_LEAVE
        // calls see https://github.com/microsoft/vscode/issues/14470
        // when the element has child elements where the events are fired
        // repeadedly.
        this.counter = 0;
        // Allows to measure the duration of the drag operation.
        this.dragStartTime = 0;
        this.registerListeners();
    }
    registerListeners() {
        if (this.callbacks.onDragStart) this._register(addDisposableListener(this.element, EventType.DRAG_START, (e)=>{
            this.callbacks.onDragStart?.(e);
        }));
        if (this.callbacks.onDrag) this._register(addDisposableListener(this.element, EventType.DRAG, (e)=>{
            this.callbacks.onDrag?.(e);
        }));
        this._register(addDisposableListener(this.element, EventType.DRAG_ENTER, (e)=>{
            this.counter++;
            this.dragStartTime = e.timeStamp;
            this.callbacks.onDragEnter?.(e);
        }));
        this._register(addDisposableListener(this.element, EventType.DRAG_OVER, (e)=>{
            e.preventDefault(); // needed so that the drop event fires (https://stackoverflow.com/questions/21339924/drop-event-not-firing-in-chrome)
            this.callbacks.onDragOver?.(e, e.timeStamp - this.dragStartTime);
        }));
        this._register(addDisposableListener(this.element, EventType.DRAG_LEAVE, (e)=>{
            this.counter--;
            if (this.counter === 0) {
                this.dragStartTime = 0;
                this.callbacks.onDragLeave?.(e);
            }
        }));
        this._register(addDisposableListener(this.element, EventType.DRAG_END, (e)=>{
            this.counter = 0;
            this.dragStartTime = 0;
            this.callbacks.onDragEnd?.(e);
        }));
        this._register(addDisposableListener(this.element, EventType.DROP, (e)=>{
            this.counter = 0;
            this.dragStartTime = 0;
            this.callbacks.onDrop?.(e);
        }));
    }
}
const H_REGEX = /(?<tag>[\w\-]+)?(?:#(?<id>[\w\-]+))?(?<class>(?:\.(?:[\w\-]+))*)(?:@(?<name>(?:[\w\_])+))?/;
function h(tag, ...args) {
    let attributes;
    let children;
    if (Array.isArray(args[0])) {
        attributes = {};
        children = args[0];
    } else {
        attributes = args[0] || {};
        children = args[1];
    }
    const match = H_REGEX.exec(tag);
    if (!match || !match.groups) throw new Error("Bad use of h");
    const tagName = match.groups["tag"] || "div";
    const el = document.createElement(tagName);
    if (match.groups["id"]) el.id = match.groups["id"];
    const classNames = [];
    if (match.groups["class"]) {
        for (const className of match.groups["class"].split("."))if (className !== "") classNames.push(className);
    }
    if (attributes.className !== undefined) {
        for (const className of attributes.className.split("."))if (className !== "") classNames.push(className);
    }
    if (classNames.length > 0) el.className = classNames.join(" ");
    const result = {};
    if (match.groups["name"]) result[match.groups["name"]] = el;
    if (children) for (const c of children){
        if (isHTMLElement(c)) el.appendChild(c);
        else if (typeof c === "string") el.append(c);
        else if ("root" in c) {
            Object.assign(result, c);
            el.appendChild(c.root);
        }
    }
    for (const [key, value] of Object.entries(attributes)){
        if (key === "className") continue;
        else if (key === "style") for (const [cssKey, cssValue] of Object.entries(value))el.style.setProperty(camelCaseToHyphenCase(cssKey), typeof cssValue === "number" ? cssValue + "px" : "" + cssValue);
        else if (key === "tabIndex") el.tabIndex = value;
        else el.setAttribute(camelCaseToHyphenCase(key), value.toString());
    }
    result["root"] = el;
    return result;
}
function svgElem(tag, ...args) {
    let attributes;
    let children;
    if (Array.isArray(args[0])) {
        attributes = {};
        children = args[0];
    } else {
        attributes = args[0] || {};
        children = args[1];
    }
    const match = H_REGEX.exec(tag);
    if (!match || !match.groups) throw new Error("Bad use of h");
    const tagName = match.groups["tag"] || "div";
    const el = document.createElementNS("http://www.w3.org/2000/svg", tagName);
    if (match.groups["id"]) el.id = match.groups["id"];
    const classNames = [];
    if (match.groups["class"]) {
        for (const className of match.groups["class"].split("."))if (className !== "") classNames.push(className);
    }
    if (attributes.className !== undefined) {
        for (const className of attributes.className.split("."))if (className !== "") classNames.push(className);
    }
    if (classNames.length > 0) el.className = classNames.join(" ");
    const result = {};
    if (match.groups["name"]) result[match.groups["name"]] = el;
    if (children) for (const c of children){
        if (isHTMLElement(c)) el.appendChild(c);
        else if (typeof c === "string") el.append(c);
        else if ("root" in c) {
            Object.assign(result, c);
            el.appendChild(c.root);
        }
    }
    for (const [key, value] of Object.entries(attributes)){
        if (key === "className") continue;
        else if (key === "style") for (const [cssKey, cssValue] of Object.entries(value))el.style.setProperty(camelCaseToHyphenCase(cssKey), typeof cssValue === "number" ? cssValue + "px" : "" + cssValue);
        else if (key === "tabIndex") el.tabIndex = value;
        else el.setAttribute(camelCaseToHyphenCase(key), value.toString());
    }
    result["root"] = el;
    return result;
}
function camelCaseToHyphenCase(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}

},{"./browser.js":"4Zquf","./canIUse.js":"h5HmQ","./keyboardEvent.js":"bxU9U","./mouseEvent.js":"4jTdu","../common/async.js":"4GJc4","../common/errors.js":"divX8","../common/event.js":"4Zi8b","./dompurify/dompurify.js":"8OdMj","../common/lifecycle.js":"9kg8d","../common/network.js":"2c1AD","../common/platform.js":"7maJO","../common/hash.js":"hXc0q","./window.js":"aJBhQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Zquf":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addMatchMediaChangeListener", ()=>addMatchMediaChangeListener);
/** The zoom scale for an index, e.g. 1, 1.2, 1.4 */ parcelHelpers.export(exports, "getZoomFactor", ()=>getZoomFactor);
parcelHelpers.export(exports, "isFirefox", ()=>isFirefox);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
parcelHelpers.export(exports, "isChrome", ()=>isChrome);
parcelHelpers.export(exports, "isSafari", ()=>isSafari);
parcelHelpers.export(exports, "isWebkitWebView", ()=>isWebkitWebView);
parcelHelpers.export(exports, "isElectron", ()=>isElectron);
parcelHelpers.export(exports, "isAndroid", ()=>isAndroid);
parcelHelpers.export(exports, "isStandalone", ()=>isStandalone);
var _windowJs = require("./window.js");
class WindowManager {
    constructor(){
        // --- Zoom Factor
        this.mapWindowIdToZoomFactor = new Map();
    }
    static{
        this.INSTANCE = new WindowManager();
    }
    getZoomFactor(targetWindow) {
        return this.mapWindowIdToZoomFactor.get(this.getWindowId(targetWindow)) ?? 1;
    }
    getWindowId(targetWindow) {
        return targetWindow.vscodeWindowId;
    }
}
function addMatchMediaChangeListener(targetWindow, query, callback) {
    if (typeof query === "string") query = targetWindow.matchMedia(query);
    query.addEventListener("change", callback);
}
function getZoomFactor(targetWindow) {
    return WindowManager.INSTANCE.getZoomFactor(targetWindow);
}
const userAgent = navigator.userAgent;
const isFirefox = userAgent.indexOf("Firefox") >= 0;
const isWebKit = userAgent.indexOf("AppleWebKit") >= 0;
const isChrome = userAgent.indexOf("Chrome") >= 0;
const isSafari = !isChrome && userAgent.indexOf("Safari") >= 0;
const isWebkitWebView = !isChrome && !isSafari && isWebKit;
const isElectron = userAgent.indexOf("Electron/") >= 0;
const isAndroid = userAgent.indexOf("Android") >= 0;
let standalone = false;
if (typeof (0, _windowJs.mainWindow).matchMedia === "function") {
    const standaloneMatchMedia = (0, _windowJs.mainWindow).matchMedia("(display-mode: standalone) or (display-mode: window-controls-overlay)");
    const fullScreenMatchMedia = (0, _windowJs.mainWindow).matchMedia("(display-mode: fullscreen)");
    standalone = standaloneMatchMedia.matches;
    addMatchMediaChangeListener((0, _windowJs.mainWindow), standaloneMatchMedia, ({ matches })=>{
        // entering fullscreen would change standaloneMatchMedia.matches to false
        // if standalone is true (running as PWA) and entering fullscreen, skip this change
        if (standalone && fullScreenMatchMedia.matches) return;
        // otherwise update standalone (browser to PWA or PWA to browser)
        standalone = matches;
    });
}
function isStandalone() {
    return standalone;
}

},{"./window.js":"aJBhQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h5HmQ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserFeatures", ()=>BrowserFeatures);
var _browserJs = require("./browser.js");
var _windowJs = require("./window.js");
var _platformJs = require("../common/platform.js");
const BrowserFeatures = {
    clipboard: {
        writeText: _platformJs.isNative || document.queryCommandSupported && document.queryCommandSupported("copy") || !!(navigator && navigator.clipboard && navigator.clipboard.writeText),
        readText: _platformJs.isNative || !!(navigator && navigator.clipboard && navigator.clipboard.readText)
    },
    keyboard: (()=>{
        if (_platformJs.isNative || _browserJs.isStandalone()) return 0 /* KeyboardSupport.Always */ ;
        if (navigator.keyboard || _browserJs.isSafari) return 1 /* KeyboardSupport.FullScreen */ ;
        return 2 /* KeyboardSupport.None */ ;
    })(),
    // 'ontouchstart' in window always evaluates to true with typescript's modern typings. This causes `window` to be
    // `never` later in `window.navigator`. That's why we need the explicit `window as Window` cast
    touch: "ontouchstart" in (0, _windowJs.mainWindow) || navigator.maxTouchPoints > 0,
    pointerEvents: (0, _windowJs.mainWindow).PointerEvent && ("ontouchstart" in (0, _windowJs.mainWindow) || navigator.maxTouchPoints > 0)
};

},{"./browser.js":"4Zquf","./window.js":"aJBhQ","../common/platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bxU9U":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandardKeyboardEvent", ()=>StandardKeyboardEvent);
var _browserJs = require("./browser.js");
var _keyCodesJs = require("../common/keyCodes.js");
var _keybindingsJs = require("../common/keybindings.js");
var _platformJs = require("../common/platform.js");
function extractKeyCode(e) {
    if (e.charCode) {
        // "keypress" events mostly
        const char = String.fromCharCode(e.charCode).toUpperCase();
        return (0, _keyCodesJs.KeyCodeUtils).fromString(char);
    }
    const keyCode = e.keyCode;
    // browser quirks
    if (keyCode === 3) return 7 /* KeyCode.PauseBreak */ ;
    else if (_browserJs.isFirefox) switch(keyCode){
        case 59:
            return 85 /* KeyCode.Semicolon */ ;
        case 60:
            if (_platformJs.isLinux) return 97 /* KeyCode.IntlBackslash */ ;
            break;
        case 61:
            return 86 /* KeyCode.Equal */ ;
        // based on: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode#numpad_keys
        case 107:
            return 109 /* KeyCode.NumpadAdd */ ;
        case 109:
            return 111 /* KeyCode.NumpadSubtract */ ;
        case 173:
            return 88 /* KeyCode.Minus */ ;
        case 224:
            if (_platformJs.isMacintosh) return 57 /* KeyCode.Meta */ ;
            break;
    }
    else if (_browserJs.isWebKit) {
        if (_platformJs.isMacintosh && keyCode === 93) // the two meta keys in the Mac have different key codes (91 and 93)
        return 57 /* KeyCode.Meta */ ;
        else if (!_platformJs.isMacintosh && keyCode === 92) return 57 /* KeyCode.Meta */ ;
    }
    // cross browser keycodes:
    return (0, _keyCodesJs.EVENT_KEY_CODE_MAP)[keyCode] || 0 /* KeyCode.Unknown */ ;
}
const ctrlKeyMod = _platformJs.isMacintosh ? 256 /* KeyMod.WinCtrl */  : 2048 /* KeyMod.CtrlCmd */ ;
const altKeyMod = 512 /* KeyMod.Alt */ ;
const shiftKeyMod = 1024 /* KeyMod.Shift */ ;
const metaKeyMod = _platformJs.isMacintosh ? 2048 /* KeyMod.CtrlCmd */  : 256 /* KeyMod.WinCtrl */ ;
class StandardKeyboardEvent {
    constructor(source){
        this._standardKeyboardEventBrand = true;
        const e = source;
        this.browserEvent = e;
        this.target = e.target;
        this.ctrlKey = e.ctrlKey;
        this.shiftKey = e.shiftKey;
        this.altKey = e.altKey;
        this.metaKey = e.metaKey;
        this.altGraphKey = e.getModifierState?.("AltGraph");
        this.keyCode = extractKeyCode(e);
        this.code = e.code;
        // console.info(e.type + ": keyCode: " + e.keyCode + ", which: " + e.which + ", charCode: " + e.charCode + ", detail: " + e.detail + " ====> " + this.keyCode + ' -- ' + KeyCode[this.keyCode]);
        this.ctrlKey = this.ctrlKey || this.keyCode === 5 /* KeyCode.Ctrl */ ;
        this.altKey = this.altKey || this.keyCode === 6 /* KeyCode.Alt */ ;
        this.shiftKey = this.shiftKey || this.keyCode === 4 /* KeyCode.Shift */ ;
        this.metaKey = this.metaKey || this.keyCode === 57 /* KeyCode.Meta */ ;
        this._asKeybinding = this._computeKeybinding();
        this._asKeyCodeChord = this._computeKeyCodeChord();
    // console.log(`code: ${e.code}, keyCode: ${e.keyCode}, key: ${e.key}`);
    }
    preventDefault() {
        if (this.browserEvent && this.browserEvent.preventDefault) this.browserEvent.preventDefault();
    }
    stopPropagation() {
        if (this.browserEvent && this.browserEvent.stopPropagation) this.browserEvent.stopPropagation();
    }
    toKeyCodeChord() {
        return this._asKeyCodeChord;
    }
    equals(other) {
        return this._asKeybinding === other;
    }
    _computeKeybinding() {
        let key = 0 /* KeyCode.Unknown */ ;
        if (this.keyCode !== 5 /* KeyCode.Ctrl */  && this.keyCode !== 4 /* KeyCode.Shift */  && this.keyCode !== 6 /* KeyCode.Alt */  && this.keyCode !== 57 /* KeyCode.Meta */ ) key = this.keyCode;
        let result = 0;
        if (this.ctrlKey) result |= ctrlKeyMod;
        if (this.altKey) result |= altKeyMod;
        if (this.shiftKey) result |= shiftKeyMod;
        if (this.metaKey) result |= metaKeyMod;
        result |= key;
        return result;
    }
    _computeKeyCodeChord() {
        let key = 0 /* KeyCode.Unknown */ ;
        if (this.keyCode !== 5 /* KeyCode.Ctrl */  && this.keyCode !== 4 /* KeyCode.Shift */  && this.keyCode !== 6 /* KeyCode.Alt */  && this.keyCode !== 57 /* KeyCode.Meta */ ) key = this.keyCode;
        return new (0, _keybindingsJs.KeyCodeChord)(this.ctrlKey, this.shiftKey, this.altKey, this.metaKey, key);
    }
}

},{"./browser.js":"4Zquf","../common/keyCodes.js":"bHiG9","../common/keybindings.js":"cQ6F5","../common/platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cQ6F5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeKeybinding", ()=>decodeKeybinding);
parcelHelpers.export(exports, "createSimpleKeybinding", ()=>createSimpleKeybinding);
/**
 * Represents a chord which uses the `keyCode` field of keyboard events.
 * A chord is a combination of keys pressed simultaneously.
 */ parcelHelpers.export(exports, "KeyCodeChord", ()=>KeyCodeChord);
/**
 * Represents a chord which uses the `code` field of keyboard events.
 * A chord is a combination of keys pressed simultaneously.
 */ parcelHelpers.export(exports, "ScanCodeChord", ()=>ScanCodeChord);
/**
 * A keybinding is a sequence of chords.
 */ parcelHelpers.export(exports, "Keybinding", ()=>Keybinding);
parcelHelpers.export(exports, "ResolvedChord", ()=>ResolvedChord);
/**
 * A resolved keybinding. Consists of one or multiple chords.
 */ parcelHelpers.export(exports, "ResolvedKeybinding", ()=>ResolvedKeybinding);
var _errorsJs = require("./errors.js");
function decodeKeybinding(keybinding, OS) {
    if (typeof keybinding === "number") {
        if (keybinding === 0) return null;
        const firstChord = (keybinding & 0x0000FFFF) >>> 0;
        const secondChord = (keybinding & 0xFFFF0000) >>> 16;
        if (secondChord !== 0) return new Keybinding([
            createSimpleKeybinding(firstChord, OS),
            createSimpleKeybinding(secondChord, OS)
        ]);
        return new Keybinding([
            createSimpleKeybinding(firstChord, OS)
        ]);
    } else {
        const chords = [];
        for(let i = 0; i < keybinding.length; i++)chords.push(createSimpleKeybinding(keybinding[i], OS));
        return new Keybinding(chords);
    }
}
function createSimpleKeybinding(keybinding, OS) {
    const ctrlCmd = keybinding & 2048 /* BinaryKeybindingsMask.CtrlCmd */  ? true : false;
    const winCtrl = keybinding & 256 /* BinaryKeybindingsMask.WinCtrl */  ? true : false;
    const ctrlKey = OS === 2 /* OperatingSystem.Macintosh */  ? winCtrl : ctrlCmd;
    const shiftKey = keybinding & 1024 /* BinaryKeybindingsMask.Shift */  ? true : false;
    const altKey = keybinding & 512 /* BinaryKeybindingsMask.Alt */  ? true : false;
    const metaKey = OS === 2 /* OperatingSystem.Macintosh */  ? ctrlCmd : winCtrl;
    const keyCode = keybinding & 255 /* BinaryKeybindingsMask.KeyCode */ ;
    return new KeyCodeChord(ctrlKey, shiftKey, altKey, metaKey, keyCode);
}
class KeyCodeChord {
    constructor(ctrlKey, shiftKey, altKey, metaKey, keyCode){
        this.ctrlKey = ctrlKey;
        this.shiftKey = shiftKey;
        this.altKey = altKey;
        this.metaKey = metaKey;
        this.keyCode = keyCode;
    }
    equals(other) {
        return other instanceof KeyCodeChord && this.ctrlKey === other.ctrlKey && this.shiftKey === other.shiftKey && this.altKey === other.altKey && this.metaKey === other.metaKey && this.keyCode === other.keyCode;
    }
    isModifierKey() {
        return this.keyCode === 0 /* KeyCode.Unknown */  || this.keyCode === 5 /* KeyCode.Ctrl */  || this.keyCode === 57 /* KeyCode.Meta */  || this.keyCode === 6 /* KeyCode.Alt */  || this.keyCode === 4 /* KeyCode.Shift */ ;
    }
    /**
     * Does this keybinding refer to the key code of a modifier and it also has the modifier flag?
     */ isDuplicateModifierCase() {
        return this.ctrlKey && this.keyCode === 5 /* KeyCode.Ctrl */  || this.shiftKey && this.keyCode === 4 /* KeyCode.Shift */  || this.altKey && this.keyCode === 6 /* KeyCode.Alt */  || this.metaKey && this.keyCode === 57 /* KeyCode.Meta */ ;
    }
}
class ScanCodeChord {
    constructor(ctrlKey, shiftKey, altKey, metaKey, scanCode){
        this.ctrlKey = ctrlKey;
        this.shiftKey = shiftKey;
        this.altKey = altKey;
        this.metaKey = metaKey;
        this.scanCode = scanCode;
    }
    /**
     * Does this keybinding refer to the key code of a modifier and it also has the modifier flag?
     */ isDuplicateModifierCase() {
        return this.ctrlKey && (this.scanCode === 157 /* ScanCode.ControlLeft */  || this.scanCode === 161 /* ScanCode.ControlRight */ ) || this.shiftKey && (this.scanCode === 158 /* ScanCode.ShiftLeft */  || this.scanCode === 162 /* ScanCode.ShiftRight */ ) || this.altKey && (this.scanCode === 159 /* ScanCode.AltLeft */  || this.scanCode === 163 /* ScanCode.AltRight */ ) || this.metaKey && (this.scanCode === 160 /* ScanCode.MetaLeft */  || this.scanCode === 164 /* ScanCode.MetaRight */ );
    }
}
class Keybinding {
    constructor(chords){
        if (chords.length === 0) throw (0, _errorsJs.illegalArgument)(`chords`);
        this.chords = chords;
    }
}
class ResolvedChord {
    constructor(ctrlKey, shiftKey, altKey, metaKey, keyLabel, keyAriaLabel){
        this.ctrlKey = ctrlKey;
        this.shiftKey = shiftKey;
        this.altKey = altKey;
        this.metaKey = metaKey;
        this.keyLabel = keyLabel;
        this.keyAriaLabel = keyAriaLabel;
    }
}
class ResolvedKeybinding {
}

},{"./errors.js":"divX8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4jTdu":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandardMouseEvent", ()=>StandardMouseEvent);
parcelHelpers.export(exports, "StandardWheelEvent", ()=>StandardWheelEvent);
var _browserJs = require("./browser.js");
var _iframeJs = require("./iframe.js");
var _platformJs = require("../common/platform.js");
class StandardMouseEvent {
    constructor(targetWindow, e){
        this.timestamp = Date.now();
        this.browserEvent = e;
        this.leftButton = e.button === 0;
        this.middleButton = e.button === 1;
        this.rightButton = e.button === 2;
        this.buttons = e.buttons;
        this.target = e.target;
        this.detail = e.detail || 1;
        if (e.type === "dblclick") this.detail = 2;
        this.ctrlKey = e.ctrlKey;
        this.shiftKey = e.shiftKey;
        this.altKey = e.altKey;
        this.metaKey = e.metaKey;
        if (typeof e.pageX === "number") {
            this.posx = e.pageX;
            this.posy = e.pageY;
        } else {
            // Probably hit by MSGestureEvent
            this.posx = e.clientX + this.target.ownerDocument.body.scrollLeft + this.target.ownerDocument.documentElement.scrollLeft;
            this.posy = e.clientY + this.target.ownerDocument.body.scrollTop + this.target.ownerDocument.documentElement.scrollTop;
        }
        // Find the position of the iframe this code is executing in relative to the iframe where the event was captured.
        const iframeOffsets = (0, _iframeJs.IframeUtils).getPositionOfChildWindowRelativeToAncestorWindow(targetWindow, e.view);
        this.posx -= iframeOffsets.left;
        this.posy -= iframeOffsets.top;
    }
    preventDefault() {
        this.browserEvent.preventDefault();
    }
    stopPropagation() {
        this.browserEvent.stopPropagation();
    }
}
class StandardWheelEvent {
    constructor(e, deltaX = 0, deltaY = 0){
        this.browserEvent = e || null;
        this.target = e ? e.target || e.targetNode || e.srcElement : null;
        this.deltaY = deltaY;
        this.deltaX = deltaX;
        let shouldFactorDPR = false;
        if (_browserJs.isChrome) {
            // Chrome version >= 123 contains the fix to factor devicePixelRatio into the wheel event.
            // See https://chromium.googlesource.com/chromium/src.git/+/be51b448441ff0c9d1f17e0f25c4bf1ab3f11f61
            const chromeVersionMatch = navigator.userAgent.match(/Chrome\/(\d+)/);
            const chromeMajorVersion = chromeVersionMatch ? parseInt(chromeVersionMatch[1]) : 123;
            shouldFactorDPR = chromeMajorVersion <= 122;
        }
        if (e) {
            // Old (deprecated) wheel events
            const e1 = e;
            const e2 = e;
            const devicePixelRatio = e.view?.devicePixelRatio || 1;
            // vertical delta scroll
            if (typeof e1.wheelDeltaY !== "undefined") {
                if (shouldFactorDPR) // Refs https://github.com/microsoft/vscode/issues/146403#issuecomment-1854538928
                this.deltaY = e1.wheelDeltaY / (120 * devicePixelRatio);
                else this.deltaY = e1.wheelDeltaY / 120;
            } else if (typeof e2.VERTICAL_AXIS !== "undefined" && e2.axis === e2.VERTICAL_AXIS) this.deltaY = -e2.detail / 3;
            else if (e.type === "wheel") {
                // Modern wheel event
                // https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent
                const ev = e;
                if (ev.deltaMode === ev.DOM_DELTA_LINE) {
                    // the deltas are expressed in lines
                    if (_browserJs.isFirefox && !_platformJs.isMacintosh) this.deltaY = -e.deltaY / 3;
                    else this.deltaY = -e.deltaY;
                } else this.deltaY = -e.deltaY / 40;
            }
            // horizontal delta scroll
            if (typeof e1.wheelDeltaX !== "undefined") {
                if (_browserJs.isSafari && _platformJs.isWindows) this.deltaX = -(e1.wheelDeltaX / 120);
                else if (shouldFactorDPR) // Refs https://github.com/microsoft/vscode/issues/146403#issuecomment-1854538928
                this.deltaX = e1.wheelDeltaX / (120 * devicePixelRatio);
                else this.deltaX = e1.wheelDeltaX / 120;
            } else if (typeof e2.HORIZONTAL_AXIS !== "undefined" && e2.axis === e2.HORIZONTAL_AXIS) this.deltaX = -e.detail / 3;
            else if (e.type === "wheel") {
                // Modern wheel event
                // https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent
                const ev = e;
                if (ev.deltaMode === ev.DOM_DELTA_LINE) {
                    // the deltas are expressed in lines
                    if (_browserJs.isFirefox && !_platformJs.isMacintosh) this.deltaX = -e.deltaX / 3;
                    else this.deltaX = -e.deltaX;
                } else this.deltaX = -e.deltaX / 40;
            }
            // Assume a vertical scroll if nothing else worked
            if (this.deltaY === 0 && this.deltaX === 0 && e.wheelDelta) {
                if (shouldFactorDPR) // Refs https://github.com/microsoft/vscode/issues/146403#issuecomment-1854538928
                this.deltaY = e.wheelDelta / (120 * devicePixelRatio);
                else this.deltaY = e.wheelDelta / 120;
            }
        }
    }
    preventDefault() {
        this.browserEvent?.preventDefault();
    }
    stopPropagation() {
        this.browserEvent?.stopPropagation();
    }
}

},{"./browser.js":"4Zquf","./iframe.js":"fU9X7","../common/platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fU9X7":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IframeUtils", ()=>IframeUtils);
const sameOriginWindowChainCache = new WeakMap();
function getParentWindowIfSameOrigin(w) {
    if (!w.parent || w.parent === w) return null;
    // Cannot really tell if we have access to the parent window unless we try to access something in it
    try {
        const location = w.location;
        const parentLocation = w.parent.location;
        if (location.origin !== "null" && parentLocation.origin !== "null" && location.origin !== parentLocation.origin) return null;
    } catch (e) {
        return null;
    }
    return w.parent;
}
class IframeUtils {
    /**
     * Returns a chain of embedded windows with the same origin (which can be accessed programmatically).
     * Having a chain of length 1 might mean that the current execution environment is running outside of an iframe or inside an iframe embedded in a window with a different origin.
     */ static getSameOriginWindowChain(targetWindow) {
        let windowChainCache = sameOriginWindowChainCache.get(targetWindow);
        if (!windowChainCache) {
            windowChainCache = [];
            sameOriginWindowChainCache.set(targetWindow, windowChainCache);
            let w = targetWindow;
            let parent;
            do {
                parent = getParentWindowIfSameOrigin(w);
                if (parent) windowChainCache.push({
                    window: new WeakRef(w),
                    iframeElement: w.frameElement || null
                });
                else windowChainCache.push({
                    window: new WeakRef(w),
                    iframeElement: null
                });
                w = parent;
            }while (w);
        }
        return windowChainCache.slice(0);
    }
    /**
     * Returns the position of `childWindow` relative to `ancestorWindow`
     */ static getPositionOfChildWindowRelativeToAncestorWindow(childWindow, ancestorWindow) {
        if (!ancestorWindow || childWindow === ancestorWindow) return {
            top: 0,
            left: 0
        };
        let top = 0, left = 0;
        const windowChain = this.getSameOriginWindowChain(childWindow);
        for (const windowChainEl of windowChain){
            const windowInChain = windowChainEl.window.deref();
            top += windowInChain?.scrollY ?? 0;
            left += windowInChain?.scrollX ?? 0;
            if (windowInChain === ancestorWindow) break;
            if (!windowChainEl.iframeElement) break;
            const boundingRect = windowChainEl.iframeElement.getBoundingClientRect();
            top += boundingRect.top;
            left += boundingRect.left;
        }
        return {
            top: top,
            left: left
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4GJc4":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isThenable", ()=>isThenable);
parcelHelpers.export(exports, "createCancelablePromise", ()=>createCancelablePromise);
parcelHelpers.export(exports, "raceCancellation", ()=>raceCancellation);
/**
 * A helper to prevent accumulation of sequential async tasks.
 *
 * Imagine a mail man with the sole task of delivering letters. As soon as
 * a letter submitted for delivery, he drives to the destination, delivers it
 * and returns to his base. Imagine that during the trip, N more letters were submitted.
 * When the mail man returns, he picks those N letters and delivers them all in a
 * single trip. Even though N+1 submissions occurred, only 2 deliveries were made.
 *
 * The throttler implements this via the queue() method, by providing it a task
 * factory. Following the example:
 *
 * 		const throttler = new Throttler();
 * 		const letters = [];
 *
 * 		function deliver() {
 * 			const lettersToDeliver = letters;
 * 			letters = [];
 * 			return makeTheTrip(lettersToDeliver);
 * 		}
 *
 * 		function onLetterReceived(l) {
 * 			letters.push(l);
 * 			throttler.queue(deliver);
 * 		}
 */ parcelHelpers.export(exports, "Throttler", ()=>Throttler);
/**
 * A helper to delay (debounce) execution of a task that is being requested often.
 *
 * Following the throttler, now imagine the mail man wants to optimize the number of
 * trips proactively. The trip itself can be long, so he decides not to make the trip
 * as soon as a letter is submitted. Instead he waits a while, in case more
 * letters are submitted. After said waiting period, if no letters were submitted, he
 * decides to make the trip. Imagine that N more letters were submitted after the first
 * one, all within a short period of time between each other. Even though N+1
 * submissions occurred, only 1 delivery was made.
 *
 * The delayer offers this behavior via the trigger() method, into which both the task
 * to be executed and the waiting period (delay) must be passed in as arguments. Following
 * the example:
 *
 * 		const delayer = new Delayer(WAITING_PERIOD);
 * 		const letters = [];
 *
 * 		function letterReceived(l) {
 * 			letters.push(l);
 * 			delayer.trigger(() => { return makeTheTrip(); });
 * 		}
 */ parcelHelpers.export(exports, "Delayer", ()=>Delayer);
/**
 * A helper to delay execution of a task that is being requested often, while
 * preventing accumulation of consecutive executions, while the task runs.
 *
 * The mail man is clever and waits for a certain amount of time, before going
 * out to deliver letters. While the mail man is going out, more letters arrive
 * and can only be delivered once he is back. Once he is back the mail man will
 * do one more trip to deliver the letters that have accumulated while he was out.
 */ parcelHelpers.export(exports, "ThrottledDelayer", ()=>ThrottledDelayer);
parcelHelpers.export(exports, "timeout", ()=>timeout);
/**
 * Creates a timeout that can be disposed using its returned value.
 * @param handler The timeout handler.
 * @param timeout An optional timeout in milliseconds.
 * @param store An optional {@link DisposableStore} that will have the timeout disposable managed automatically.
 *
 * @example
 * const store = new DisposableStore;
 * // Call the timeout after 1000ms at which point it will be automatically
 * // evicted from the store.
 * const timeoutDisposable = disposableTimeout(() => {}, 1000, store);
 *
 * if (foo) {
 *   // Cancel the timeout and evict it from store.
 *   timeoutDisposable.dispose();
 * }
 */ parcelHelpers.export(exports, "disposableTimeout", ()=>disposableTimeout);
parcelHelpers.export(exports, "first", ()=>first);
parcelHelpers.export(exports, "TimeoutTimer", ()=>TimeoutTimer);
parcelHelpers.export(exports, "IntervalTimer", ()=>IntervalTimer);
parcelHelpers.export(exports, "RunOnceScheduler", ()=>RunOnceScheduler);
parcelHelpers.export(exports, "runWhenGlobalIdle", ()=>runWhenGlobalIdle);
parcelHelpers.export(exports, "_runWhenIdle", ()=>_runWhenIdle);
parcelHelpers.export(exports, "AbstractIdleValue", ()=>AbstractIdleValue);
/**
 * An `IdleValue` that always uses the current window (which might be throttled or inactive)
 *
 * **Note** that there is `dom.ts#WindowIdleValue` which is better suited when running inside a browser
 * context
 */ parcelHelpers.export(exports, "GlobalIdleValue", ()=>GlobalIdleValue);
/**
 * Creates a promise whose resolution or rejection can be controlled imperatively.
 */ parcelHelpers.export(exports, "DeferredPromise", ()=>DeferredPromise);
parcelHelpers.export(exports, "Promises", ()=>Promises);
/**
 * A rich implementation for an `AsyncIterable<T>`.
 */ parcelHelpers.export(exports, "AsyncIterableObject", ()=>AsyncIterableObject);
parcelHelpers.export(exports, "CancelableAsyncIterableObject", ()=>CancelableAsyncIterableObject);
parcelHelpers.export(exports, "createCancelableAsyncIterable", ()=>createCancelableAsyncIterable) //#endregion
;
var _cancellationJs = require("./cancellation.js");
var _errorsJs = require("./errors.js");
var _eventJs = require("./event.js");
var _lifecycleJs = require("./lifecycle.js");
var _platformJs = require("./platform.js");
var _symbolsJs = require("./symbols.js");
function isThenable(obj) {
    return !!obj && typeof obj.then === "function";
}
function createCancelablePromise(callback) {
    const source = new (0, _cancellationJs.CancellationTokenSource)();
    const thenable = callback(source.token);
    const promise = new Promise((resolve, reject)=>{
        const subscription = source.token.onCancellationRequested(()=>{
            subscription.dispose();
            reject(new (0, _errorsJs.CancellationError)());
        });
        Promise.resolve(thenable).then((value)=>{
            subscription.dispose();
            source.dispose();
            resolve(value);
        }, (err)=>{
            subscription.dispose();
            source.dispose();
            reject(err);
        });
    });
    return new class {
        cancel() {
            source.cancel();
            source.dispose();
        }
        then(resolve, reject) {
            return promise.then(resolve, reject);
        }
        catch(reject) {
            return this.then(undefined, reject);
        }
        finally(onfinally) {
            return promise.finally(onfinally);
        }
    };
}
function raceCancellation(promise, token, defaultValue) {
    return new Promise((resolve, reject)=>{
        const ref = token.onCancellationRequested(()=>{
            ref.dispose();
            resolve(defaultValue);
        });
        promise.then(resolve, reject).finally(()=>ref.dispose());
    });
}
class Throttler {
    constructor(){
        this.isDisposed = false;
        this.activePromise = null;
        this.queuedPromise = null;
        this.queuedPromiseFactory = null;
    }
    queue(promiseFactory) {
        if (this.isDisposed) return Promise.reject(new Error("Throttler is disposed"));
        if (this.activePromise) {
            this.queuedPromiseFactory = promiseFactory;
            if (!this.queuedPromise) {
                const onComplete = ()=>{
                    this.queuedPromise = null;
                    if (this.isDisposed) return;
                    const result = this.queue(this.queuedPromiseFactory);
                    this.queuedPromiseFactory = null;
                    return result;
                };
                this.queuedPromise = new Promise((resolve)=>{
                    this.activePromise.then(onComplete, onComplete).then(resolve);
                });
            }
            return new Promise((resolve, reject)=>{
                this.queuedPromise.then(resolve, reject);
            });
        }
        this.activePromise = promiseFactory();
        return new Promise((resolve, reject)=>{
            this.activePromise.then((result)=>{
                this.activePromise = null;
                resolve(result);
            }, (err)=>{
                this.activePromise = null;
                reject(err);
            });
        });
    }
    dispose() {
        this.isDisposed = true;
    }
}
const timeoutDeferred = (timeout, fn)=>{
    let scheduled = true;
    const handle = setTimeout(()=>{
        scheduled = false;
        fn();
    }, timeout);
    return {
        isTriggered: ()=>scheduled,
        dispose: ()=>{
            clearTimeout(handle);
            scheduled = false;
        }
    };
};
const microtaskDeferred = (fn)=>{
    let scheduled = true;
    queueMicrotask(()=>{
        if (scheduled) {
            scheduled = false;
            fn();
        }
    });
    return {
        isTriggered: ()=>scheduled,
        dispose: ()=>{
            scheduled = false;
        }
    };
};
class Delayer {
    constructor(defaultDelay){
        this.defaultDelay = defaultDelay;
        this.deferred = null;
        this.completionPromise = null;
        this.doResolve = null;
        this.doReject = null;
        this.task = null;
    }
    trigger(task, delay = this.defaultDelay) {
        this.task = task;
        this.cancelTimeout();
        if (!this.completionPromise) this.completionPromise = new Promise((resolve, reject)=>{
            this.doResolve = resolve;
            this.doReject = reject;
        }).then(()=>{
            this.completionPromise = null;
            this.doResolve = null;
            if (this.task) {
                const task = this.task;
                this.task = null;
                return task();
            }
            return undefined;
        });
        const fn = ()=>{
            this.deferred = null;
            this.doResolve?.(null);
        };
        this.deferred = delay === (0, _symbolsJs.MicrotaskDelay) ? microtaskDeferred(fn) : timeoutDeferred(delay, fn);
        return this.completionPromise;
    }
    isTriggered() {
        return !!this.deferred?.isTriggered();
    }
    cancel() {
        this.cancelTimeout();
        if (this.completionPromise) {
            this.doReject?.(new (0, _errorsJs.CancellationError)());
            this.completionPromise = null;
        }
    }
    cancelTimeout() {
        this.deferred?.dispose();
        this.deferred = null;
    }
    dispose() {
        this.cancel();
    }
}
class ThrottledDelayer {
    constructor(defaultDelay){
        this.delayer = new Delayer(defaultDelay);
        this.throttler = new Throttler();
    }
    trigger(promiseFactory, delay) {
        return this.delayer.trigger(()=>this.throttler.queue(promiseFactory), delay);
    }
    cancel() {
        this.delayer.cancel();
    }
    dispose() {
        this.delayer.dispose();
        this.throttler.dispose();
    }
}
function timeout(millis, token) {
    if (!token) return createCancelablePromise((token)=>timeout(millis, token));
    return new Promise((resolve, reject)=>{
        const handle = setTimeout(()=>{
            disposable.dispose();
            resolve();
        }, millis);
        const disposable = token.onCancellationRequested(()=>{
            clearTimeout(handle);
            disposable.dispose();
            reject(new (0, _errorsJs.CancellationError)());
        });
    });
}
function disposableTimeout(handler, timeout = 0, store) {
    const timer = setTimeout(()=>{
        handler();
        if (store) disposable.dispose();
    }, timeout);
    const disposable = (0, _lifecycleJs.toDisposable)(()=>{
        clearTimeout(timer);
        store?.deleteAndLeak(disposable);
    });
    store?.add(disposable);
    return disposable;
}
function first(promiseFactories, shouldStop = (t)=>!!t, defaultValue = null) {
    let index = 0;
    const len = promiseFactories.length;
    const loop = ()=>{
        if (index >= len) return Promise.resolve(defaultValue);
        const factory = promiseFactories[index++];
        const promise = Promise.resolve(factory());
        return promise.then((result)=>{
            if (shouldStop(result)) return Promise.resolve(result);
            return loop();
        });
    };
    return loop();
}
class TimeoutTimer {
    constructor(runner, timeout){
        this._isDisposed = false;
        this._token = -1;
        if (typeof runner === "function" && typeof timeout === "number") this.setIfNotSet(runner, timeout);
    }
    dispose() {
        this.cancel();
        this._isDisposed = true;
    }
    cancel() {
        if (this._token !== -1) {
            clearTimeout(this._token);
            this._token = -1;
        }
    }
    cancelAndSet(runner, timeout) {
        if (this._isDisposed) throw new (0, _errorsJs.BugIndicatingError)(`Calling 'cancelAndSet' on a disposed TimeoutTimer`);
        this.cancel();
        this._token = setTimeout(()=>{
            this._token = -1;
            runner();
        }, timeout);
    }
    setIfNotSet(runner, timeout) {
        if (this._isDisposed) throw new (0, _errorsJs.BugIndicatingError)(`Calling 'setIfNotSet' on a disposed TimeoutTimer`);
        if (this._token !== -1) // timer is already set
        return;
        this._token = setTimeout(()=>{
            this._token = -1;
            runner();
        }, timeout);
    }
}
class IntervalTimer {
    constructor(){
        this.disposable = undefined;
        this.isDisposed = false;
    }
    cancel() {
        this.disposable?.dispose();
        this.disposable = undefined;
    }
    cancelAndSet(runner, interval, context = globalThis) {
        if (this.isDisposed) throw new (0, _errorsJs.BugIndicatingError)(`Calling 'cancelAndSet' on a disposed IntervalTimer`);
        this.cancel();
        const handle = context.setInterval(()=>{
            runner();
        }, interval);
        this.disposable = (0, _lifecycleJs.toDisposable)(()=>{
            context.clearInterval(handle);
            this.disposable = undefined;
        });
    }
    dispose() {
        this.cancel();
        this.isDisposed = true;
    }
}
class RunOnceScheduler {
    constructor(runner, delay){
        this.timeoutToken = -1;
        this.runner = runner;
        this.timeout = delay;
        this.timeoutHandler = this.onTimeout.bind(this);
    }
    /**
     * Dispose RunOnceScheduler
     */ dispose() {
        this.cancel();
        this.runner = null;
    }
    /**
     * Cancel current scheduled runner (if any).
     */ cancel() {
        if (this.isScheduled()) {
            clearTimeout(this.timeoutToken);
            this.timeoutToken = -1;
        }
    }
    /**
     * Cancel previous runner (if any) & schedule a new runner.
     */ schedule(delay = this.timeout) {
        this.cancel();
        this.timeoutToken = setTimeout(this.timeoutHandler, delay);
    }
    get delay() {
        return this.timeout;
    }
    set delay(value) {
        this.timeout = value;
    }
    /**
     * Returns true if scheduled.
     */ isScheduled() {
        return this.timeoutToken !== -1;
    }
    onTimeout() {
        this.timeoutToken = -1;
        if (this.runner) this.doRun();
    }
    doRun() {
        this.runner?.();
    }
}
let runWhenGlobalIdle;
let _runWhenIdle;
(function() {
    if (typeof globalThis.requestIdleCallback !== "function" || typeof globalThis.cancelIdleCallback !== "function") _runWhenIdle = (_targetWindow, runner)=>{
        (0, _platformJs.setTimeout0)(()=>{
            if (disposed) return;
            const end = Date.now() + 15; // one frame at 64fps
            const deadline = {
                didTimeout: true,
                timeRemaining () {
                    return Math.max(0, end - Date.now());
                }
            };
            runner(Object.freeze(deadline));
        });
        let disposed = false;
        return {
            dispose () {
                if (disposed) return;
                disposed = true;
            }
        };
    };
    else _runWhenIdle = (targetWindow, runner, timeout)=>{
        const handle = targetWindow.requestIdleCallback(runner, typeof timeout === "number" ? {
            timeout
        } : undefined);
        let disposed = false;
        return {
            dispose () {
                if (disposed) return;
                disposed = true;
                targetWindow.cancelIdleCallback(handle);
            }
        };
    };
    runWhenGlobalIdle = (runner)=>_runWhenIdle(globalThis, runner);
})();
class AbstractIdleValue {
    constructor(targetWindow, executor){
        this._didRun = false;
        this._executor = ()=>{
            try {
                this._value = executor();
            } catch (err) {
                this._error = err;
            } finally{
                this._didRun = true;
            }
        };
        this._handle = _runWhenIdle(targetWindow, ()=>this._executor());
    }
    dispose() {
        this._handle.dispose();
    }
    get value() {
        if (!this._didRun) {
            this._handle.dispose();
            this._executor();
        }
        if (this._error) throw this._error;
        return this._value;
    }
    get isInitialized() {
        return this._didRun;
    }
}
class GlobalIdleValue extends AbstractIdleValue {
    constructor(executor){
        super(globalThis, executor);
    }
}
class DeferredPromise {
    get isRejected() {
        return this.outcome?.outcome === 1 /* DeferredOutcome.Rejected */ ;
    }
    get isSettled() {
        return !!this.outcome;
    }
    constructor(){
        this.p = new Promise((c, e)=>{
            this.completeCallback = c;
            this.errorCallback = e;
        });
    }
    complete(value) {
        return new Promise((resolve)=>{
            this.completeCallback(value);
            this.outcome = {
                outcome: 0 /* DeferredOutcome.Resolved */ ,
                value
            };
            resolve();
        });
    }
    error(err) {
        return new Promise((resolve)=>{
            this.errorCallback(err);
            this.outcome = {
                outcome: 1 /* DeferredOutcome.Rejected */ ,
                value: err
            };
            resolve();
        });
    }
    cancel() {
        return this.error(new (0, _errorsJs.CancellationError)());
    }
}
var Promises;
(function(Promises) {
    /**
     * A drop-in replacement for `Promise.all` with the only difference
     * that the method awaits every promise to either fulfill or reject.
     *
     * Similar to `Promise.all`, only the first error will be returned
     * if any.
     */ async function settled(promises) {
        let firstError = undefined;
        const result = await Promise.all(promises.map((promise)=>promise.then((value)=>value, (error)=>{
                if (!firstError) firstError = error;
                return undefined; // do not rethrow so that other promises can settle
            })));
        if (typeof firstError !== "undefined") throw firstError;
        return result; // cast is needed and protected by the `throw` above
    }
    Promises.settled = settled;
    /**
     * A helper to create a new `Promise<T>` with a body that is a promise
     * itself. By default, an error that raises from the async body will
     * end up as a unhandled rejection, so this utility properly awaits the
     * body and rejects the promise as a normal promise does without async
     * body.
     *
     * This method should only be used in rare cases where otherwise `async`
     * cannot be used (e.g. when callbacks are involved that require this).
     */ function withAsyncBody(bodyFn) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject)=>{
            try {
                await bodyFn(resolve, reject);
            } catch (error) {
                reject(error);
            }
        });
    }
    Promises.withAsyncBody = withAsyncBody;
})(Promises || (Promises = {}));
class AsyncIterableObject {
    static fromArray(items) {
        return new AsyncIterableObject((writer)=>{
            writer.emitMany(items);
        });
    }
    static fromPromise(promise) {
        return new AsyncIterableObject(async (emitter)=>{
            emitter.emitMany(await promise);
        });
    }
    static fromPromises(promises) {
        return new AsyncIterableObject(async (emitter)=>{
            await Promise.all(promises.map(async (p)=>emitter.emitOne(await p)));
        });
    }
    static merge(iterables) {
        return new AsyncIterableObject(async (emitter)=>{
            await Promise.all(iterables.map(async (iterable)=>{
                for await (const item of iterable)emitter.emitOne(item);
            }));
        });
    }
    static{
        this.EMPTY = AsyncIterableObject.fromArray([]);
    }
    constructor(executor, onReturn){
        this._state = 0 /* AsyncIterableSourceState.Initial */ ;
        this._results = [];
        this._error = null;
        this._onReturn = onReturn;
        this._onStateChanged = new (0, _eventJs.Emitter)();
        queueMicrotask(async ()=>{
            const writer = {
                emitOne: (item)=>this.emitOne(item),
                emitMany: (items)=>this.emitMany(items),
                reject: (error)=>this.reject(error)
            };
            try {
                await Promise.resolve(executor(writer));
                this.resolve();
            } catch (err) {
                this.reject(err);
            } finally{
                writer.emitOne = undefined;
                writer.emitMany = undefined;
                writer.reject = undefined;
            }
        });
    }
    [Symbol.asyncIterator]() {
        let i = 0;
        return {
            next: async ()=>{
                do {
                    if (this._state === 2 /* AsyncIterableSourceState.DoneError */ ) throw this._error;
                    if (i < this._results.length) return {
                        done: false,
                        value: this._results[i++]
                    };
                    if (this._state === 1 /* AsyncIterableSourceState.DoneOK */ ) return {
                        done: true,
                        value: undefined
                    };
                    await (0, _eventJs.Event).toPromise(this._onStateChanged.event);
                }while (true);
            },
            return: async ()=>{
                this._onReturn?.();
                return {
                    done: true,
                    value: undefined
                };
            }
        };
    }
    static map(iterable, mapFn) {
        return new AsyncIterableObject(async (emitter)=>{
            for await (const item of iterable)emitter.emitOne(mapFn(item));
        });
    }
    map(mapFn) {
        return AsyncIterableObject.map(this, mapFn);
    }
    static filter(iterable, filterFn) {
        return new AsyncIterableObject(async (emitter)=>{
            for await (const item of iterable)if (filterFn(item)) emitter.emitOne(item);
        });
    }
    filter(filterFn) {
        return AsyncIterableObject.filter(this, filterFn);
    }
    static coalesce(iterable) {
        return AsyncIterableObject.filter(iterable, (item)=>!!item);
    }
    coalesce() {
        return AsyncIterableObject.coalesce(this);
    }
    static async toPromise(iterable) {
        const result = [];
        for await (const item of iterable)result.push(item);
        return result;
    }
    toPromise() {
        return AsyncIterableObject.toPromise(this);
    }
    /**
     * The value will be appended at the end.
     *
     * **NOTE** If `resolve()` or `reject()` have already been called, this method has no effect.
     */ emitOne(value) {
        if (this._state !== 0 /* AsyncIterableSourceState.Initial */ ) return;
        // it is important to add new values at the end,
        // as we may have iterators already running on the array
        this._results.push(value);
        this._onStateChanged.fire();
    }
    /**
     * The values will be appended at the end.
     *
     * **NOTE** If `resolve()` or `reject()` have already been called, this method has no effect.
     */ emitMany(values) {
        if (this._state !== 0 /* AsyncIterableSourceState.Initial */ ) return;
        // it is important to add new values at the end,
        // as we may have iterators already running on the array
        this._results = this._results.concat(values);
        this._onStateChanged.fire();
    }
    /**
     * Calling `resolve()` will mark the result array as complete.
     *
     * **NOTE** `resolve()` must be called, otherwise all consumers of this iterable will hang indefinitely, similar to a non-resolved promise.
     * **NOTE** If `resolve()` or `reject()` have already been called, this method has no effect.
     */ resolve() {
        if (this._state !== 0 /* AsyncIterableSourceState.Initial */ ) return;
        this._state = 1 /* AsyncIterableSourceState.DoneOK */ ;
        this._onStateChanged.fire();
    }
    /**
     * Writing an error will permanently invalidate this iterable.
     * The current users will receive an error thrown, as will all future users.
     *
     * **NOTE** If `resolve()` or `reject()` have already been called, this method has no effect.
     */ reject(error) {
        if (this._state !== 0 /* AsyncIterableSourceState.Initial */ ) return;
        this._state = 2 /* AsyncIterableSourceState.DoneError */ ;
        this._error = error;
        this._onStateChanged.fire();
    }
}
class CancelableAsyncIterableObject extends AsyncIterableObject {
    constructor(_source, executor){
        super(executor);
        this._source = _source;
    }
    cancel() {
        this._source.cancel();
    }
}
function createCancelableAsyncIterable(callback) {
    const source = new (0, _cancellationJs.CancellationTokenSource)();
    const innerIterable = callback(source.token);
    return new CancelableAsyncIterableObject(source, async (emitter)=>{
        const subscription = source.token.onCancellationRequested(()=>{
            subscription.dispose();
            source.dispose();
            emitter.reject(new (0, _errorsJs.CancellationError)());
        });
        try {
            for await (const item of innerIterable){
                if (source.token.isCancellationRequested) // canceled in the meantime
                return;
                emitter.emitOne(item);
            }
            subscription.dispose();
            source.dispose();
        } catch (err) {
            subscription.dispose();
            source.dispose();
            emitter.reject(err);
        }
    });
}

},{"./cancellation.js":"hoVxw","./errors.js":"divX8","./event.js":"4Zi8b","./lifecycle.js":"9kg8d","./platform.js":"7maJO","./symbols.js":"2bzCZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2bzCZ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 * Can be passed into the Delayed to defer using a microtask
 * */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MicrotaskDelay", ()=>MicrotaskDelay);
const MicrotaskDelay = Symbol("MicrotaskDelay");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8OdMj":[function(require,module,exports) {
/*! @license DOMPurify 3.0.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.5/LICENSE */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "isSupported", ()=>isSupported);
parcelHelpers.export(exports, "sanitize", ()=>sanitize);
parcelHelpers.export(exports, "setConfig", ()=>setConfig);
parcelHelpers.export(exports, "clearConfig", ()=>clearConfig);
parcelHelpers.export(exports, "isValidAttribute", ()=>isValidAttribute);
parcelHelpers.export(exports, "addHook", ()=>addHook);
parcelHelpers.export(exports, "removeHook", ()=>removeHook);
parcelHelpers.export(exports, "removeHooks", ()=>removeHooks);
parcelHelpers.export(exports, "removeAllHooks", ()=>removeAllHooks);
const { entries, setPrototypeOf, isFrozen, getPrototypeOf, getOwnPropertyDescriptor } = Object;
let { freeze, seal, create } = Object; // eslint-disable-line import/no-mutable-exports
let { apply, construct } = typeof Reflect !== "undefined" && Reflect;
if (!apply) apply = function apply(fun, thisValue, args) {
    return fun.apply(thisValue, args);
};
if (!freeze) freeze = function freeze(x) {
    return x;
};
if (!seal) seal = function seal(x) {
    return x;
};
if (!construct) construct = function construct(Func, args) {
    return new Func(...args);
};
const arrayForEach = unapply(Array.prototype.forEach);
const arrayPop = unapply(Array.prototype.pop);
const arrayPush = unapply(Array.prototype.push);
const stringToLowerCase = unapply(String.prototype.toLowerCase);
const stringToString = unapply(String.prototype.toString);
const stringMatch = unapply(String.prototype.match);
const stringReplace = unapply(String.prototype.replace);
const stringIndexOf = unapply(String.prototype.indexOf);
const stringTrim = unapply(String.prototype.trim);
const regExpTest = unapply(RegExp.prototype.test);
const typeErrorCreate = unconstruct(TypeError);
function unapply(func) {
    return function(thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return apply(func, thisArg, args);
    };
}
function unconstruct(func) {
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return construct(func, args);
    };
}
/* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
    var _transformCaseFunc;
    transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
    if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    setPrototypeOf(set, null);
    let l = array.length;
    while(l--){
        let element = array[l];
        if (typeof element === "string") {
            const lcElement = transformCaseFunc(element);
            if (lcElement !== element) {
                // Config presets (e.g. tags.js, attrs.js) are immutable.
                if (!isFrozen(array)) array[l] = lcElement;
                element = lcElement;
            }
        }
        set[element] = true;
    }
    return set;
}
/* Shallow clone an object */ function clone(object) {
    const newObject = create(null);
    for (const [property, value] of entries(object))newObject[property] = value;
    return newObject;
}
/* This method automatically checks if the prop is function
 * or getter and behaves accordingly. */ function lookupGetter(object, prop) {
    while(object !== null){
        const desc = getOwnPropertyDescriptor(object, prop);
        if (desc) {
            if (desc.get) return unapply(desc.get);
            if (typeof desc.value === "function") return unapply(desc.value);
        }
        object = getPrototypeOf(object);
    }
    function fallbackValue(element) {
        console.warn("fallback value for", element);
        return null;
    }
    return fallbackValue;
}
const html$1 = freeze([
    "a",
    "abbr",
    "acronym",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "bdi",
    "bdo",
    "big",
    "blink",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "center",
    "cite",
    "code",
    "col",
    "colgroup",
    "content",
    "data",
    "datalist",
    "dd",
    "decorator",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "element",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "font",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meter",
    "nav",
    "nobr",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "section",
    "select",
    "shadow",
    "small",
    "source",
    "spacer",
    "span",
    "strike",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr"
]); // SVG
const svg$1 = freeze([
    "svg",
    "a",
    "altglyph",
    "altglyphdef",
    "altglyphitem",
    "animatecolor",
    "animatemotion",
    "animatetransform",
    "circle",
    "clippath",
    "defs",
    "desc",
    "ellipse",
    "filter",
    "font",
    "g",
    "glyph",
    "glyphref",
    "hkern",
    "image",
    "line",
    "lineargradient",
    "marker",
    "mask",
    "metadata",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialgradient",
    "rect",
    "stop",
    "style",
    "switch",
    "symbol",
    "text",
    "textpath",
    "title",
    "tref",
    "tspan",
    "view",
    "vkern"
]);
const svgFilters = freeze([
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence"
]); // List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const svgDisallowed = freeze([
    "animate",
    "color-profile",
    "cursor",
    "discard",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignobject",
    "hatch",
    "hatchpath",
    "mesh",
    "meshgradient",
    "meshpatch",
    "meshrow",
    "missing-glyph",
    "script",
    "set",
    "solidcolor",
    "unknown",
    "use"
]);
const mathMl$1 = freeze([
    "math",
    "menclose",
    "merror",
    "mfenced",
    "mfrac",
    "mglyph",
    "mi",
    "mlabeledtr",
    "mmultiscripts",
    "mn",
    "mo",
    "mover",
    "mpadded",
    "mphantom",
    "mroot",
    "mrow",
    "ms",
    "mspace",
    "msqrt",
    "mstyle",
    "msub",
    "msup",
    "msubsup",
    "mtable",
    "mtd",
    "mtext",
    "mtr",
    "munder",
    "munderover",
    "mprescripts"
]); // Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const mathMlDisallowed = freeze([
    "maction",
    "maligngroup",
    "malignmark",
    "mlongdiv",
    "mscarries",
    "mscarry",
    "msgroup",
    "mstack",
    "msline",
    "msrow",
    "semantics",
    "annotation",
    "annotation-xml",
    "mprescripts",
    "none"
]);
const text = freeze([
    "#text"
]);
const html = freeze([
    "accept",
    "action",
    "align",
    "alt",
    "autocapitalize",
    "autocomplete",
    "autopictureinpicture",
    "autoplay",
    "background",
    "bgcolor",
    "border",
    "capture",
    "cellpadding",
    "cellspacing",
    "checked",
    "cite",
    "class",
    "clear",
    "color",
    "cols",
    "colspan",
    "controls",
    "controlslist",
    "coords",
    "crossorigin",
    "datetime",
    "decoding",
    "default",
    "dir",
    "disabled",
    "disablepictureinpicture",
    "disableremoteplayback",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "face",
    "for",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "id",
    "inputmode",
    "integrity",
    "ismap",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "loop",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "multiple",
    "muted",
    "name",
    "nonce",
    "noshade",
    "novalidate",
    "nowrap",
    "open",
    "optimum",
    "pattern",
    "placeholder",
    "playsinline",
    "poster",
    "preload",
    "pubdate",
    "radiogroup",
    "readonly",
    "rel",
    "required",
    "rev",
    "reversed",
    "role",
    "rows",
    "rowspan",
    "spellcheck",
    "scope",
    "selected",
    "shape",
    "size",
    "sizes",
    "span",
    "srclang",
    "start",
    "src",
    "srcset",
    "step",
    "style",
    "summary",
    "tabindex",
    "title",
    "translate",
    "type",
    "usemap",
    "valign",
    "value",
    "width",
    "xmlns",
    "slot"
]);
const svg = freeze([
    "accent-height",
    "accumulate",
    "additive",
    "alignment-baseline",
    "ascent",
    "attributename",
    "attributetype",
    "azimuth",
    "basefrequency",
    "baseline-shift",
    "begin",
    "bias",
    "by",
    "class",
    "clip",
    "clippathunits",
    "clip-path",
    "clip-rule",
    "color",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "cx",
    "cy",
    "d",
    "dx",
    "dy",
    "diffuseconstant",
    "direction",
    "display",
    "divisor",
    "dur",
    "edgemode",
    "elevation",
    "end",
    "fill",
    "fill-opacity",
    "fill-rule",
    "filter",
    "filterunits",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyph-name",
    "glyphref",
    "gradientunits",
    "gradienttransform",
    "height",
    "href",
    "id",
    "image-rendering",
    "in",
    "in2",
    "k",
    "k1",
    "k2",
    "k3",
    "k4",
    "kerning",
    "keypoints",
    "keysplines",
    "keytimes",
    "lang",
    "lengthadjust",
    "letter-spacing",
    "kernelmatrix",
    "kernelunitlength",
    "lighting-color",
    "local",
    "marker-end",
    "marker-mid",
    "marker-start",
    "markerheight",
    "markerunits",
    "markerwidth",
    "maskcontentunits",
    "maskunits",
    "max",
    "mask",
    "media",
    "method",
    "mode",
    "min",
    "name",
    "numoctaves",
    "offset",
    "operator",
    "opacity",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "paint-order",
    "path",
    "pathlength",
    "patterncontentunits",
    "patterntransform",
    "patternunits",
    "points",
    "preservealpha",
    "preserveaspectratio",
    "primitiveunits",
    "r",
    "rx",
    "ry",
    "radius",
    "refx",
    "refy",
    "repeatcount",
    "repeatdur",
    "restart",
    "result",
    "rotate",
    "scale",
    "seed",
    "shape-rendering",
    "specularconstant",
    "specularexponent",
    "spreadmethod",
    "startoffset",
    "stddeviation",
    "stitchtiles",
    "stop-color",
    "stop-opacity",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke",
    "stroke-width",
    "style",
    "surfacescale",
    "systemlanguage",
    "tabindex",
    "targetx",
    "targety",
    "transform",
    "transform-origin",
    "text-anchor",
    "text-decoration",
    "text-rendering",
    "textlength",
    "type",
    "u1",
    "u2",
    "unicode",
    "values",
    "viewbox",
    "visibility",
    "version",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "width",
    "word-spacing",
    "wrap",
    "writing-mode",
    "xchannelselector",
    "ychannelselector",
    "x",
    "x1",
    "x2",
    "xmlns",
    "y",
    "y1",
    "y2",
    "z",
    "zoomandpan"
]);
const mathMl = freeze([
    "accent",
    "accentunder",
    "align",
    "bevelled",
    "close",
    "columnsalign",
    "columnlines",
    "columnspan",
    "denomalign",
    "depth",
    "dir",
    "display",
    "displaystyle",
    "encoding",
    "fence",
    "frame",
    "height",
    "href",
    "id",
    "largeop",
    "length",
    "linethickness",
    "lspace",
    "lquote",
    "mathbackground",
    "mathcolor",
    "mathsize",
    "mathvariant",
    "maxsize",
    "minsize",
    "movablelimits",
    "notation",
    "numalign",
    "open",
    "rowalign",
    "rowlines",
    "rowspacing",
    "rowspan",
    "rspace",
    "rquote",
    "scriptlevel",
    "scriptminsize",
    "scriptsizemultiplier",
    "selection",
    "separator",
    "separators",
    "stretchy",
    "subscriptshift",
    "supscriptshift",
    "symmetric",
    "voffset",
    "width",
    "xmlns"
]);
const xml = freeze([
    "xlink:href",
    "xml:id",
    "xlink:title",
    "xml:space",
    "xmlns:xlink"
]);
const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
const TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const DOCTYPE_NAME = seal(/^html$/i);
var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MUSTACHE_EXPR: MUSTACHE_EXPR,
    ERB_EXPR: ERB_EXPR,
    TMPLIT_EXPR: TMPLIT_EXPR,
    DATA_ATTR: DATA_ATTR,
    ARIA_ATTR: ARIA_ATTR,
    IS_ALLOWED_URI: IS_ALLOWED_URI,
    IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
    ATTR_WHITESPACE: ATTR_WHITESPACE,
    DOCTYPE_NAME: DOCTYPE_NAME
});
const getGlobal = ()=>typeof window === "undefined" ? null : window;
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
 * @param {HTMLScriptElement} purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
     // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    let suffix = null;
    const ATTR_NAME = "data-tt-policy-suffix";
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
    const policyName = "dompurify" + (suffix ? "#" + suffix : "");
    try {
        return trustedTypes.createPolicy(policyName, {
            createHTML (html) {
                return html;
            },
            createScriptURL (scriptUrl) {
                return scriptUrl;
            }
        });
    } catch (_) {
        // Policy creation failed (most likely another DOMPurify script has
        // already run). Skip creating the policy, as this will only cause errors
        // if TT are enforced.
        console.warn("TrustedTypes policy " + policyName + " could not be created.");
        return null;
    }
};
function createDOMPurify() {
    let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
    const DOMPurify = (root)=>createDOMPurify(root);
    /**
	 * Version label, exposed for easier checks
	 * if DOMPurify is up to date or not
	 */ DOMPurify.version = "3.0.5";
    /**
	 * Array of elements that DOMPurify removed during sanitation.
	 * Empty if nothing was removed.
	 */ DOMPurify.removed = [];
    if (!window1 || !window1.document || window1.document.nodeType !== 9) {
        // Not running in a browser, provide a factory function
        // so that you can pass your own Window
        DOMPurify.isSupported = false;
        return DOMPurify;
    }
    const originalDocument = window1.document;
    const currentScript = originalDocument.currentScript;
    let { document } = window1;
    const { DocumentFragment, HTMLTemplateElement, Node, Element, NodeFilter, NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement, DOMParser, trustedTypes } = window1;
    const ElementPrototype = Element.prototype;
    const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
    const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
    const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
    const getParentNode = lookupGetter(ElementPrototype, "parentNode"); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === "function") {
        const template = document.createElement("template");
        if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
    }
    let trustedTypesPolicy;
    let emptyHTML = "";
    const { implementation, createNodeIterator, createDocumentFragment, getElementsByTagName } = document;
    const { importNode } = originalDocument;
    let hooks = {};
    /**
	 * Expose whether this browser supports running the full DOMPurify.
	 */ DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== undefined;
    const { MUSTACHE_EXPR, ERB_EXPR, TMPLIT_EXPR, DATA_ATTR, ARIA_ATTR, IS_SCRIPT_OR_DATA, ATTR_WHITESPACE } = EXPRESSIONS;
    let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
    /**
	 * We consider the elements and attributes below to be safe. Ideally
	 * don't add any new ones but feel free to remove unwanted ones.
	 */ /* allowed element names */ let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = addToSet({}, [
        ...html$1,
        ...svg$1,
        ...svgFilters,
        ...mathMl$1,
        ...text
    ]);
    /* Allowed attribute names */ let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = addToSet({}, [
        ...html,
        ...svg,
        ...mathMl,
        ...xml
    ]);
    /*
	 * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
	 * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
	 * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
	 * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
	 */ let CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
        tagNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        allowCustomizedBuiltInElements: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: false
        }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
	 * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
	 * This means, DOMPurify removes data attributes, mustaches and ERB
	 */ let SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
	 * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
	 * string (or a TrustedHTML object if Trusted Types are supported).
	 * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
	 */ let RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
	 * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
	 * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
	 * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
	 */ let SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
	 * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
	 *
	 * HTML/DOM spec rules that enable DOM Clobbering:
	 *   - Named Access on Window (§7.3.3)
	 *   - DOM Tree Accessors (§3.1.5)
	 *   - Form Element Parent-Child Relations (§4.10.3)
	 *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
	 *   - HTMLCollection (§4.2.10.2)
	 *
	 * Namespace isolation is implemented by prefixing `id` and `name` attributes
	 * with a constant string, i.e., `user-content-`
	 */ let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
    /* Keep element content when removing element? */ let KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
	 * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = addToSet({}, [
        "annotation-xml",
        "audio",
        "colgroup",
        "desc",
        "foreignobject",
        "head",
        "iframe",
        "math",
        "mi",
        "mn",
        "mo",
        "ms",
        "mtext",
        "noembed",
        "noframes",
        "noscript",
        "plaintext",
        "script",
        "style",
        "svg",
        "template",
        "thead",
        "title",
        "video",
        "xmp"
    ]);
    /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = addToSet({}, [
        "audio",
        "video",
        "img",
        "source",
        "image",
        "track"
    ]);
    /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
        "alt",
        "class",
        "for",
        "id",
        "label",
        "name",
        "pattern",
        "placeholder",
        "role",
        "summary",
        "title",
        "value",
        "style",
        "xmlns"
    ]);
    const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
    const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
        MATHML_NAMESPACE,
        SVG_NAMESPACE,
        HTML_NAMESPACE
    ], stringToString);
    /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE;
    const SUPPORTED_PARSER_MEDIA_TYPES = [
        "application/xhtml+xml",
        "text/html"
    ];
    const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
    let transformCaseFunc;
    /* Keep a reference to config to pass to hooks */ let CONFIG = null;
    /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement("form");
    const isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
	 * _parseConfig
	 *
	 * @param  {Object} cfg optional config literal
	 */ // eslint-disable-next-line complexity
    const _parseConfig = function _parseConfig(cfg) {
        if (CONFIG && CONFIG === cfg) return;
        /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== "object") cfg = {};
        /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
        PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
        transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
        /* Set configuration parameters */ ALLOWED_TAGS = "ALLOWED_TAGS" in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
        ALLOWED_ATTR = "ALLOWED_ATTR" in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
        ALLOWED_NAMESPACES = "ALLOWED_NAMESPACES" in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
        URI_SAFE_ATTRIBUTES = "ADD_URI_SAFE_ATTR" in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc // eslint-disable-line indent
        ) // eslint-disable-line indent
         : DEFAULT_URI_SAFE_ATTRIBUTES;
        DATA_URI_TAGS = "ADD_DATA_URI_TAGS" in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc // eslint-disable-line indent
        ) // eslint-disable-line indent
         : DEFAULT_DATA_URI_TAGS;
        FORBID_CONTENTS = "FORBID_CONTENTS" in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
        FORBID_TAGS = "FORBID_TAGS" in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
        FORBID_ATTR = "FORBID_ATTR" in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
        USE_PROFILES = "USE_PROFILES" in cfg ? cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
        RETURN_DOM = cfg.RETURN_DOM || false; // Default false
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
        FORCE_BODY = cfg.FORCE_BODY || false; // Default false
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
        IN_PLACE = cfg.IN_PLACE || false; // Default false
        IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
        NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
        CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
        if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
        if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
        if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
        /* Parse profile info */ if (USE_PROFILES) {
            ALLOWED_TAGS = addToSet({}, [
                ...text
            ]);
            ALLOWED_ATTR = [];
            if (USE_PROFILES.html === true) {
                addToSet(ALLOWED_TAGS, html$1);
                addToSet(ALLOWED_ATTR, html);
            }
            if (USE_PROFILES.svg === true) {
                addToSet(ALLOWED_TAGS, svg$1);
                addToSet(ALLOWED_ATTR, svg);
                addToSet(ALLOWED_ATTR, xml);
            }
            if (USE_PROFILES.svgFilters === true) {
                addToSet(ALLOWED_TAGS, svgFilters);
                addToSet(ALLOWED_ATTR, svg);
                addToSet(ALLOWED_ATTR, xml);
            }
            if (USE_PROFILES.mathMl === true) {
                addToSet(ALLOWED_TAGS, mathMl$1);
                addToSet(ALLOWED_ATTR, mathMl);
                addToSet(ALLOWED_ATTR, xml);
            }
        }
        /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
            if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
            addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
        }
        if (cfg.ADD_ATTR) {
            if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
            addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
        }
        if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
        if (cfg.FORBID_CONTENTS) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
            addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
        }
        /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
        /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
            "html",
            "head",
            "body"
        ]);
        /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
            addToSet(ALLOWED_TAGS, [
                "tbody"
            ]);
            delete FORBID_TAGS.tbody;
        }
        if (cfg.TRUSTED_TYPES_POLICY) {
            if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
            if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
             // Overwrite existing TrustedTypes policy.
            trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY; // Sign local variables required by `sanitize`.
            emptyHTML = trustedTypesPolicy.createHTML("");
        } else {
            // Uninitialized policy, attempt to initialize the internal dompurify policy.
            if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
             // If creating the internal policy succeeded sign internal variables.
            if (trustedTypesPolicy !== null && typeof emptyHTML === "string") emptyHTML = trustedTypesPolicy.createHTML("");
        } // Prevent further manipulation of configuration.
        // Not available in IE8, Safari 5, etc.
        if (freeze) freeze(cfg);
        CONFIG = cfg;
    };
    const MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
        "mi",
        "mo",
        "mn",
        "ms",
        "mtext"
    ]);
    const HTML_INTEGRATION_POINTS = addToSet({}, [
        "foreignobject",
        "desc",
        "title",
        "annotation-xml"
    ]); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
        "title",
        "style",
        "font",
        "a",
        "script"
    ]);
    /* Keep track of all possible SVG and MathML tags
	 * so that we can perform the namespace checks
	 * correctly. */ const ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    const ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
	 *
	 *
	 * @param  {Element} element a DOM element whose namespace is being checked
	 * @returns {boolean} Return false if the element has a
	 *  namespace that a spec-compliant parser would never
	 *  return. Return true otherwise.
	 */ const _checkValidNamespace = function _checkValidNamespace(element) {
        let parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
        // can be null. We just simulate parent in this case.
        if (!parent || !parent.tagName) parent = {
            namespaceURI: NAMESPACE,
            tagName: "template"
        };
        const tagName = stringToLowerCase(element.tagName);
        const parentTagName = stringToLowerCase(parent.tagName);
        if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
        if (element.namespaceURI === SVG_NAMESPACE) {
            // The only way to switch from HTML namespace to SVG
            // is via <svg>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
             // The only way to switch from MathML to SVG is via`
            // svg if parent is either <annotation-xml> or MathML
            // text integration points.
            if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
             // We only allow elements that are defined in SVG
            // spec. All others are disallowed in SVG namespace.
            return Boolean(ALL_SVG_TAGS[tagName]);
        }
        if (element.namespaceURI === MATHML_NAMESPACE) {
            // The only way to switch from HTML namespace to MathML
            // is via <math>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
             // The only way to switch from SVG to MathML is via
            // <math> and HTML integration points
            if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
             // We only allow elements that are defined in MathML
            // spec. All others are disallowed in MathML namespace.
            return Boolean(ALL_MATHML_TAGS[tagName]);
        }
        if (element.namespaceURI === HTML_NAMESPACE) {
            // The only way to switch from SVG to HTML is via
            // HTML integration points, and from MathML to HTML
            // is via MathML text integration points
            if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
            if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
             // We disallow tags that are specific for MathML
            // or SVG and should never appear in HTML namespace
            return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        } // For XHTML and XML documents that support custom namespaces
        if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
         // The code should never reach this place (this means
        // that the element somehow got namespace that is not
        // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
        // Return false just in case.
        return false;
    };
    /**
	 * _forceRemove
	 *
	 * @param  {Node} node a DOM node
	 */ const _forceRemove = function _forceRemove(node) {
        arrayPush(DOMPurify.removed, {
            element: node
        });
        try {
            // eslint-disable-next-line unicorn/prefer-dom-node-remove
            node.parentNode.removeChild(node);
        } catch (_) {
            node.remove();
        }
    };
    /**
	 * _removeAttribute
	 *
	 * @param  {String} name an Attribute name
	 * @param  {Node} node a DOM node
	 */ const _removeAttribute = function _removeAttribute(name, node) {
        try {
            arrayPush(DOMPurify.removed, {
                attribute: node.getAttributeNode(name),
                from: node
            });
        } catch (_) {
            arrayPush(DOMPurify.removed, {
                attribute: null,
                from: node
            });
        }
        node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes
        if (name === "is" && !ALLOWED_ATTR[name]) {
            if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                _forceRemove(node);
            } catch (_) {}
            else try {
                node.setAttribute(name, "");
            } catch (_) {}
        }
    };
    /**
	 * _initDocument
	 *
	 * @param  {String} dirty a string of dirty markup
	 * @return {Document} a DOM, filled with the dirty markup
	 */ const _initDocument = function _initDocument(dirty) {
        /* Create a HTML document */ let doc;
        let leadingWhitespace;
        if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
        else {
            /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
            leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
        const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
        /*
		 * Use the DOMParser API by default, fallback later if needs be
		 * DOMParser not work for svg when has multiple root element.
		 */ if (NAMESPACE === HTML_NAMESPACE) try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
        /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
            doc = implementation.createDocument(NAMESPACE, "template", null);
            try {
                doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
            } catch (_) {}
        }
        const body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
        return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
	 * _createIterator
	 *
	 * @param  {Document} root document/fragment to create iterator for
	 * @return {Iterator} iterator instance
	 */ const _createIterator = function _createIterator(root) {
        return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
	 * _isClobbered
	 *
	 * @param  {Node} elm element to check for clobbering attacks
	 * @return {Boolean} true if clobbered, false if safe
	 */ const _isClobbered = function _isClobbered(elm) {
        return elm instanceof HTMLFormElement && (typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function" || typeof elm.hasChildNodes !== "function");
    };
    /**
	 * _isNode
	 *
	 * @param  {Node} obj object to check whether it's a DOM node
	 * @return {Boolean} true is object is a DOM node
	 */ const _isNode = function _isNode(object) {
        return typeof Node === "object" ? object instanceof Node : object && typeof object === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string";
    };
    /**
	 * _executeHook
	 * Execute user configurable hooks
	 *
	 * @param  {String} entryPoint  Name of the hook's entry point
	 * @param  {Node} currentNode node to work on with the hook
	 * @param  {Object} data additional hook parameters
	 */ const _executeHook = function _executeHook(entryPoint, currentNode, data) {
        if (!hooks[entryPoint]) return;
        arrayForEach(hooks[entryPoint], (hook)=>{
            hook.call(DOMPurify, currentNode, data, CONFIG);
        });
    };
    /**
	 * _sanitizeElements
	 *
	 * @protect nodeName
	 * @protect textContent
	 * @protect removeChild
	 *
	 * @param   {Node} currentNode to check for permission to exist
	 * @return  {Boolean} true if node was killed, false if left alive
	 */ const _sanitizeElements = function _sanitizeElements(currentNode) {
        let content;
        /* Execute a hook if present */ _executeHook("beforeSanitizeElements", currentNode, null);
        /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
        /* Execute a hook if present */ _executeHook("uponSanitizeElement", currentNode, {
            tagName,
            allowedTags: ALLOWED_TAGS
        });
        /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
            }
            /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                if (childNodes && parentNode) {
                    const childCount = childNodes.length;
                    for(let i = childCount - 1; i >= 0; --i)parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
                }
            }
            _forceRemove(currentNode);
            return true;
        }
        /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
            /* Get the element's text content */ content = currentNode.textContent;
            content = stringReplace(content, MUSTACHE_EXPR, " ");
            content = stringReplace(content, ERB_EXPR, " ");
            content = stringReplace(content, TMPLIT_EXPR, " ");
            if (currentNode.textContent !== content) {
                arrayPush(DOMPurify.removed, {
                    element: currentNode.cloneNode()
                });
                currentNode.textContent = content;
            }
        }
        /* Execute a hook if present */ _executeHook("afterSanitizeElements", currentNode, null);
        return false;
    };
    /**
	 * _isValidAttribute
	 *
	 * @param  {string} lcTag Lowercase tag name of containing element.
	 * @param  {string} lcName Lowercase attribute name.
	 * @param  {string} value Attribute value.
	 * @return {Boolean} Returns true if `value` is valid, otherwise false.
	 */ // eslint-disable-next-line complexity
    const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
        /* Allow valid data-* attributes: At least one character after "-"
				(https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
				XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
				We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
        else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
        else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
            if (// b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
            else return false;
        /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
        else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ""))) ;
        else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
        else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ""))) ;
        else if (value) return false;
        return true;
    };
    /**
	 * _basicCustomElementCheck
	 * checks if at least one dash is included in tagName, and it's not the first char
	 * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
	 * @param {string} tagName name of the tag of the node to sanitize
	 */ const _basicCustomElementTest = function _basicCustomElementTest(tagName) {
        return tagName.indexOf("-") > 0;
    };
    /**
	 * _sanitizeAttributes
	 *
	 * @protect attributes
	 * @protect nodeName
	 * @protect removeAttribute
	 * @protect setAttribute
	 *
	 * @param  {Node} currentNode to sanitize
	 */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        let attr;
        let value;
        let lcName;
        let l;
        /* Execute a hook if present */ _executeHook("beforeSanitizeAttributes", currentNode, null);
        const { attributes } = currentNode;
        /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
        const hookEvent = {
            attrName: "",
            attrValue: "",
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR
        };
        l = attributes.length;
        /* Go backwards over all attributes; safely remove bad ones */ while(l--){
            attr = attributes[l];
            const { name, namespaceURI } = attr;
            value = name === "value" ? attr.value : stringTrim(attr.value);
            lcName = transformCaseFunc(name);
            /* Execute a hook if present */ hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
            _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
            value = hookEvent.attrValue;
            /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
            /* Remove attribute */ _removeAttribute(name, currentNode);
            /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
            /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                value = stringReplace(value, MUSTACHE_EXPR, " ");
                value = stringReplace(value, ERB_EXPR, " ");
                value = stringReplace(value, TMPLIT_EXPR, " ");
            }
            /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
            if (!_isValidAttribute(lcTag, lcName, value)) continue;
            /* Full DOM Clobbering protection via namespace isolation,
			 * Prefix id and name attributes with `user-content-`
			 */ if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
                // Remove the attribute with this value
                _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value
                value = SANITIZE_NAMED_PROPS_PREFIX + value;
            }
            /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function") {
                if (namespaceURI) ;
                else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                    case "TrustedHTML":
                        value = trustedTypesPolicy.createHTML(value);
                        break;
                    case "TrustedScriptURL":
                        value = trustedTypesPolicy.createScriptURL(value);
                        break;
                }
            }
            /* Handle invalid data-* attribute set by try-catching it */ try {
                if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                arrayPop(DOMPurify.removed);
            } catch (_) {}
        }
        /* Execute a hook if present */ _executeHook("afterSanitizeAttributes", currentNode, null);
    };
    /**
	 * _sanitizeShadowDOM
	 *
	 * @param  {DocumentFragment} fragment to iterate over recursively
	 */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
        let shadowNode;
        const shadowIterator = _createIterator(fragment);
        /* Execute a hook if present */ _executeHook("beforeSanitizeShadowDOM", fragment, null);
        while(shadowNode = shadowIterator.nextNode()){
            /* Execute a hook if present */ _executeHook("uponSanitizeShadowNode", shadowNode, null);
            /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
            /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
        }
        /* Execute a hook if present */ _executeHook("afterSanitizeShadowDOM", fragment, null);
    };
    /**
	 * Sanitize
	 * Public method providing core sanitation functionality
	 *
	 * @param {String|Node} dirty string or DOM node
	 * @param {Object} configuration object
	 */ // eslint-disable-next-line complexity
    DOMPurify.sanitize = function(dirty) {
        let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let body;
        let importedNode;
        let currentNode;
        let returnNode;
        /* Make sure we have a string to sanitize.
			DO NOT return early, as this will return the wrong type if
			the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) dirty = "<!-->";
        /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
            if (typeof dirty.toString === "function") {
                dirty = dirty.toString();
                if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
            } else throw typeErrorCreate("toString is not a function");
        }
        /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
        /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
        /* Clean up removed elements */ DOMPurify.removed = [];
        /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
        if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
            if (dirty.nodeName) {
                const tagName = transformCaseFunc(dirty.nodeName);
                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
            }
        } else if (dirty instanceof Node) {
            /* If dirty is a DOM element, append to an empty document to avoid
				 elements being stripped by the parser */ body = _initDocument("<!---->");
            importedNode = body.ownerDocument.importNode(dirty, true);
            if (importedNode.nodeType === 1 && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
            else if (importedNode.nodeName === "HTML") body = importedNode;
            else // eslint-disable-next-line unicorn/prefer-dom-node-append
            body.appendChild(importedNode);
        } else {
            /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
            dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /* Initialize the document to work on */ body = _initDocument(dirty);
            /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
        }
        /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
        /* Get node iterator */ const nodeIterator = _createIterator(IN_PLACE ? dirty : body);
        /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
            /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
            /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
        }
        /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
        /* Return sanitized string or DOM */ if (RETURN_DOM) {
            if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);
                while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                returnNode.appendChild(body.firstChild);
            } else returnNode = body;
            if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
					AdoptNode() is not used because internal state is not reset
					(e.g. the past names map of a HTMLFormElement), this is safe
					in theory but we would rather not risk another attack vector.
					The state that is cloned by importNode() is explicitly defined
					by the specs.
				*/ returnNode = importNode.call(originalDocument, returnNode, true);
            return returnNode;
        }
        let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
        /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
            serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR, " ");
            serializedHTML = stringReplace(serializedHTML, ERB_EXPR, " ");
            serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR, " ");
        }
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
	 * Public method to set the configuration once
	 * setConfig
	 *
	 * @param {Object} cfg configuration object
	 */ DOMPurify.setConfig = function(cfg) {
        _parseConfig(cfg);
        SET_CONFIG = true;
    };
    /**
	 * Public method to remove the configuration
	 * clearConfig
	 *
	 */ DOMPurify.clearConfig = function() {
        CONFIG = null;
        SET_CONFIG = false;
    };
    /**
	 * Public method to check if an attribute value is valid.
	 * Uses last set config, if any. Otherwise, uses config defaults.
	 * isValidAttribute
	 *
	 * @param  {string} tag Tag name of containing element.
	 * @param  {string} attr Attribute name.
	 * @param  {string} value Attribute value.
	 * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
	 */ DOMPurify.isValidAttribute = function(tag, attr, value) {
        /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
        const lcTag = transformCaseFunc(tag);
        const lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
    };
    /**
	 * AddHook
	 * Public method to add DOMPurify hooks
	 *
	 * @param {String} entryPoint entry point for the hook to add
	 * @param {Function} hookFunction function to execute
	 */ DOMPurify.addHook = function(entryPoint, hookFunction) {
        if (typeof hookFunction !== "function") return;
        hooks[entryPoint] = hooks[entryPoint] || [];
        arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
	 * RemoveHook
	 * Public method to remove a DOMPurify hook at a given entryPoint
	 * (pops it from the stack of hooks if more are present)
	 *
	 * @param {String} entryPoint entry point for the hook to remove
	 * @return {Function} removed(popped) hook
	 */ DOMPurify.removeHook = function(entryPoint) {
        if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
    };
    /**
	 * RemoveHooks
	 * Public method to remove all DOMPurify hooks at a given entryPoint
	 *
	 * @param  {String} entryPoint entry point for the hooks to remove
	 */ DOMPurify.removeHooks = function(entryPoint) {
        if (hooks[entryPoint]) hooks[entryPoint] = [];
    };
    /**
	 * RemoveAllHooks
	 * Public method to remove all DOMPurify hooks
	 *
	 */ DOMPurify.removeAllHooks = function() {
        hooks = {};
    };
    return DOMPurify;
}
var purify = createDOMPurify();
// ESM-comment-begin
// define(function () { return purify; });
// ESM-comment-end
// ESM-uncomment-begin
exports.default = purify;
const version = purify.version;
const isSupported = purify.isSupported;
const sanitize = purify.sanitize;
const setConfig = purify.setConfig;
const clearConfig = purify.clearConfig;
const isValidAttribute = purify.isValidAttribute;
const addHook = purify.addHook;
const removeHook = purify.removeHook;
const removeHooks = purify.removeHooks;
const removeAllHooks = purify.removeAllHooks; // ESM-uncomment-end

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2c1AD":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Schemas", ()=>Schemas);
parcelHelpers.export(exports, "matchesScheme", ()=>matchesScheme);
parcelHelpers.export(exports, "matchesSomeScheme", ()=>matchesSomeScheme);
parcelHelpers.export(exports, "connectionTokenQueryName", ()=>connectionTokenQueryName);
parcelHelpers.export(exports, "RemoteAuthorities", ()=>RemoteAuthorities);
parcelHelpers.export(exports, "VSCODE_AUTHORITY", ()=>VSCODE_AUTHORITY);
parcelHelpers.export(exports, "FileAccess", ()=>FileAccess);
parcelHelpers.export(exports, "COI", ()=>COI);
var _errorsJs = require("./errors.js");
var _platformJs = require("./platform.js");
var _stringsJs = require("./strings.js");
var _uriJs = require("./uri.js");
var _pathJs = require("./path.js");
var Schemas;
(function(Schemas) {
    /**
     * A schema that is used for models that exist in memory
     * only and that have no correspondence on a server or such.
     */ Schemas.inMemory = "inmemory";
    /**
     * A schema that is used for setting files
     */ Schemas.vscode = "vscode";
    /**
     * A schema that is used for internal private files
     */ Schemas.internal = "private";
    /**
     * A walk-through document.
     */ Schemas.walkThrough = "walkThrough";
    /**
     * An embedded code snippet.
     */ Schemas.walkThroughSnippet = "walkThroughSnippet";
    Schemas.http = "http";
    Schemas.https = "https";
    Schemas.file = "file";
    Schemas.mailto = "mailto";
    Schemas.untitled = "untitled";
    Schemas.data = "data";
    Schemas.command = "command";
    Schemas.vscodeRemote = "vscode-remote";
    Schemas.vscodeRemoteResource = "vscode-remote-resource";
    Schemas.vscodeManagedRemoteResource = "vscode-managed-remote-resource";
    Schemas.vscodeUserData = "vscode-userdata";
    Schemas.vscodeCustomEditor = "vscode-custom-editor";
    Schemas.vscodeNotebookCell = "vscode-notebook-cell";
    Schemas.vscodeNotebookCellMetadata = "vscode-notebook-cell-metadata";
    Schemas.vscodeNotebookCellMetadataDiff = "vscode-notebook-cell-metadata-diff";
    Schemas.vscodeNotebookCellOutput = "vscode-notebook-cell-output";
    Schemas.vscodeNotebookCellOutputDiff = "vscode-notebook-cell-output-diff";
    Schemas.vscodeNotebookMetadata = "vscode-notebook-metadata";
    Schemas.vscodeInteractiveInput = "vscode-interactive-input";
    Schemas.vscodeSettings = "vscode-settings";
    Schemas.vscodeWorkspaceTrust = "vscode-workspace-trust";
    Schemas.vscodeTerminal = "vscode-terminal";
    /** Scheme used for code blocks in chat. */ Schemas.vscodeChatCodeBlock = "vscode-chat-code-block";
    /** Scheme used for LHS of code compare (aka diff) blocks in chat. */ Schemas.vscodeChatCodeCompareBlock = "vscode-chat-code-compare-block";
    /** Scheme used for the chat input editor. */ Schemas.vscodeChatSesssion = "vscode-chat-editor";
    /**
     * Scheme used internally for webviews that aren't linked to a resource (i.e. not custom editors)
     */ Schemas.webviewPanel = "webview-panel";
    /**
     * Scheme used for loading the wrapper html and script in webviews.
     */ Schemas.vscodeWebview = "vscode-webview";
    /**
     * Scheme used for extension pages
     */ Schemas.extension = "extension";
    /**
     * Scheme used as a replacement of `file` scheme to load
     * files with our custom protocol handler (desktop only).
     */ Schemas.vscodeFileResource = "vscode-file";
    /**
     * Scheme used for temporary resources
     */ Schemas.tmp = "tmp";
    /**
     * Scheme used vs live share
     */ Schemas.vsls = "vsls";
    /**
     * Scheme used for the Source Control commit input's text document
     */ Schemas.vscodeSourceControl = "vscode-scm";
    /**
     * Scheme used for input box for creating comments.
     */ Schemas.commentsInput = "comment";
    /**
     * Scheme used for special rendering of settings in the release notes
     */ Schemas.codeSetting = "code-setting";
    /**
     * Scheme used for output panel resources
     */ Schemas.outputChannel = "output";
})(Schemas || (Schemas = {}));
function matchesScheme(target, scheme) {
    if ((0, _uriJs.URI).isUri(target)) return (0, _stringsJs.equalsIgnoreCase)(target.scheme, scheme);
    else return (0, _stringsJs.startsWithIgnoreCase)(target, scheme + ":");
}
function matchesSomeScheme(target, ...schemes) {
    return schemes.some((scheme)=>matchesScheme(target, scheme));
}
const connectionTokenQueryName = "tkn";
class RemoteAuthoritiesImpl {
    constructor(){
        this._hosts = Object.create(null);
        this._ports = Object.create(null);
        this._connectionTokens = Object.create(null);
        this._preferredWebSchema = "http";
        this._delegate = null;
        this._serverRootPath = "/";
    }
    setPreferredWebSchema(schema) {
        this._preferredWebSchema = schema;
    }
    get _remoteResourcesPath() {
        return _pathJs.posix.join(this._serverRootPath, Schemas.vscodeRemoteResource);
    }
    rewrite(uri) {
        if (this._delegate) try {
            return this._delegate(uri);
        } catch (err) {
            _errorsJs.onUnexpectedError(err);
            return uri;
        }
        const authority = uri.authority;
        let host = this._hosts[authority];
        if (host && host.indexOf(":") !== -1 && host.indexOf("[") === -1) host = `[${host}]`;
        const port = this._ports[authority];
        const connectionToken = this._connectionTokens[authority];
        let query = `path=${encodeURIComponent(uri.path)}`;
        if (typeof connectionToken === "string") query += `&${connectionTokenQueryName}=${encodeURIComponent(connectionToken)}`;
        return (0, _uriJs.URI).from({
            scheme: _platformJs.isWeb ? this._preferredWebSchema : Schemas.vscodeRemoteResource,
            authority: `${host}:${port}`,
            path: this._remoteResourcesPath,
            query
        });
    }
}
const RemoteAuthorities = new RemoteAuthoritiesImpl();
const VSCODE_AUTHORITY = "vscode-app";
class FileAccessImpl {
    static{
        this.FALLBACK_AUTHORITY = VSCODE_AUTHORITY;
    }
    /**
     * Returns a URI to use in contexts where the browser is responsible
     * for loading (e.g. fetch()) or when used within the DOM.
     *
     * **Note:** use `dom.ts#asCSSUrl` whenever the URL is to be used in CSS context.
     */ asBrowserUri(resourcePath) {
        // ESM-comment-begin
        // 		const uri = this.toUri(resourcePath, require);
        // ESM-comment-end
        // ESM-uncomment-begin
        const uri = this.toUri(resourcePath);
        // ESM-uncomment-end
        return this.uriToBrowserUri(uri);
    }
    /**
     * Returns a URI to use in contexts where the browser is responsible
     * for loading (e.g. fetch()) or when used within the DOM.
     *
     * **Note:** use `dom.ts#asCSSUrl` whenever the URL is to be used in CSS context.
     */ uriToBrowserUri(uri) {
        // Handle remote URIs via `RemoteAuthorities`
        if (uri.scheme === Schemas.vscodeRemote) return RemoteAuthorities.rewrite(uri);
        // Convert to `vscode-file` resource..
        if (// ...only ever for `file` resources
        uri.scheme === Schemas.file && // ...and we run in native environments
        (_platformJs.isNative || // ...or web worker extensions on desktop
        _platformJs.webWorkerOrigin === `${Schemas.vscodeFileResource}://${FileAccessImpl.FALLBACK_AUTHORITY}`)) return uri.with({
            scheme: Schemas.vscodeFileResource,
            // We need to provide an authority here so that it can serve
            // as origin for network and loading matters in chromium.
            // If the URI is not coming with an authority already, we
            // add our own
            authority: uri.authority || FileAccessImpl.FALLBACK_AUTHORITY,
            query: null,
            fragment: null
        });
        return uri;
    }
    toUri(uriOrModule, moduleIdToUrl) {
        if ((0, _uriJs.URI).isUri(uriOrModule)) return uriOrModule;
        if (globalThis._VSCODE_FILE_ROOT) {
            const rootUriOrPath = globalThis._VSCODE_FILE_ROOT;
            // File URL (with scheme)
            if (/^\w[\w\d+.-]*:\/\//.test(rootUriOrPath)) return (0, _uriJs.URI).joinPath((0, _uriJs.URI).parse(rootUriOrPath, true), uriOrModule);
            // File Path (no scheme)
            const modulePath = _pathJs.join(rootUriOrPath, uriOrModule);
            return (0, _uriJs.URI).file(modulePath);
        }
        return (0, _uriJs.URI).parse(moduleIdToUrl.toUrl(uriOrModule));
    }
}
const FileAccess = new FileAccessImpl();
var COI;
(function(COI) {
    const coiHeaders = new Map([
        [
            "1",
            {
                "Cross-Origin-Opener-Policy": "same-origin"
            }
        ],
        [
            "2",
            {
                "Cross-Origin-Embedder-Policy": "require-corp"
            }
        ],
        [
            "3",
            {
                "Cross-Origin-Opener-Policy": "same-origin",
                "Cross-Origin-Embedder-Policy": "require-corp"
            }
        ]
    ]);
    COI.CoopAndCoep = Object.freeze(coiHeaders.get("3"));
    const coiSearchParamName = "vscode-coi";
    /**
     * Extract desired headers from `vscode-coi` invocation
     */ function getHeadersFromQuery(url) {
        let params;
        if (typeof url === "string") params = new URL(url).searchParams;
        else if (url instanceof URL) params = url.searchParams;
        else if ((0, _uriJs.URI).isUri(url)) params = new URL(url.toString(true)).searchParams;
        const value = params?.get(coiSearchParamName);
        if (!value) return undefined;
        return coiHeaders.get(value);
    }
    COI.getHeadersFromQuery = getHeadersFromQuery;
    /**
     * Add the `vscode-coi` query attribute based on wanting `COOP` and `COEP`. Will be a noop when `crossOriginIsolated`
     * isn't enabled the current context
     */ function addSearchParam(urlOrSearch, coop, coep) {
        if (!globalThis.crossOriginIsolated) // depends on the current context being COI
        return;
        const value = coop && coep ? "3" : coep ? "2" : "1";
        if (urlOrSearch instanceof URLSearchParams) urlOrSearch.set(coiSearchParamName, value);
        else urlOrSearch[coiSearchParamName] = value;
    }
    COI.addSearchParam = addSearchParam;
})(COI || (COI = {}));

},{"./errors.js":"divX8","./platform.js":"7maJO","./strings.js":"aA9I1","./uri.js":"7qGS3","./path.js":"vyRKJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hXc0q":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return a hash value for an object.
 */ parcelHelpers.export(exports, "hash", ()=>hash);
parcelHelpers.export(exports, "doHash", ()=>doHash);
parcelHelpers.export(exports, "numberHash", ()=>numberHash);
parcelHelpers.export(exports, "stringHash", ()=>stringHash);
parcelHelpers.export(exports, "toHexString", ()=>toHexString);
/**
 * A SHA1 implementation that works with strings and does not allocate.
 */ parcelHelpers.export(exports, "StringSHA1", ()=>StringSHA1);
var _stringsJs = require("./strings.js");
function hash(obj) {
    return doHash(obj, 0);
}
function doHash(obj, hashVal) {
    switch(typeof obj){
        case "object":
            if (obj === null) return numberHash(349, hashVal);
            else if (Array.isArray(obj)) return arrayHash(obj, hashVal);
            return objectHash(obj, hashVal);
        case "string":
            return stringHash(obj, hashVal);
        case "boolean":
            return booleanHash(obj, hashVal);
        case "number":
            return numberHash(obj, hashVal);
        case "undefined":
            return numberHash(937, hashVal);
        default:
            return numberHash(617, hashVal);
    }
}
function numberHash(val, initialHashVal) {
    return (initialHashVal << 5) - initialHashVal + val | 0; // hashVal * 31 + ch, keep as int32
}
function booleanHash(b, initialHashVal) {
    return numberHash(b ? 433 : 863, initialHashVal);
}
function stringHash(s, hashVal) {
    hashVal = numberHash(149417, hashVal);
    for(let i = 0, length = s.length; i < length; i++)hashVal = numberHash(s.charCodeAt(i), hashVal);
    return hashVal;
}
function arrayHash(arr, initialHashVal) {
    initialHashVal = numberHash(104579, initialHashVal);
    return arr.reduce((hashVal, item)=>doHash(item, hashVal), initialHashVal);
}
function objectHash(obj, initialHashVal) {
    initialHashVal = numberHash(181387, initialHashVal);
    return Object.keys(obj).sort().reduce((hashVal, key)=>{
        hashVal = stringHash(key, hashVal);
        return doHash(obj[key], hashVal);
    }, initialHashVal);
}
function leftRotate(value, bits, totalBits = 32) {
    // delta + bits = totalBits
    const delta = totalBits - bits;
    // All ones, expect `delta` zeros aligned to the right
    const mask = ~((1 << delta) - 1);
    // Join (value left-shifted `bits` bits) with (masked value right-shifted `delta` bits)
    return (value << bits | (mask & value) >>> delta) >>> 0;
}
function fill(dest, index = 0, count = dest.byteLength, value = 0) {
    for(let i = 0; i < count; i++)dest[index + i] = value;
}
function leftPad(value, length, char = "0") {
    while(value.length < length)value = char + value;
    return value;
}
function toHexString(bufferOrValue, bitsize = 32) {
    if (bufferOrValue instanceof ArrayBuffer) return Array.from(new Uint8Array(bufferOrValue)).map((b)=>b.toString(16).padStart(2, "0")).join("");
    return leftPad((bufferOrValue >>> 0).toString(16), bitsize / 4);
}
class StringSHA1 {
    static{
        this._bigBlock32 = new DataView(new ArrayBuffer(320));
    }
    constructor(){
        this._h0 = 0x67452301;
        this._h1 = 0xEFCDAB89;
        this._h2 = 0x98BADCFE;
        this._h3 = 0x10325476;
        this._h4 = 0xC3D2E1F0;
        this._buff = new Uint8Array(67 /* to fit any utf-8 */ );
        this._buffDV = new DataView(this._buff.buffer);
        this._buffLen = 0;
        this._totalLen = 0;
        this._leftoverHighSurrogate = 0;
        this._finished = false;
    }
    update(str) {
        const strLen = str.length;
        if (strLen === 0) return;
        const buff = this._buff;
        let buffLen = this._buffLen;
        let leftoverHighSurrogate = this._leftoverHighSurrogate;
        let charCode;
        let offset;
        if (leftoverHighSurrogate !== 0) {
            charCode = leftoverHighSurrogate;
            offset = -1;
            leftoverHighSurrogate = 0;
        } else {
            charCode = str.charCodeAt(0);
            offset = 0;
        }
        while(true){
            let codePoint = charCode;
            if (_stringsJs.isHighSurrogate(charCode)) {
                if (offset + 1 < strLen) {
                    const nextCharCode = str.charCodeAt(offset + 1);
                    if (_stringsJs.isLowSurrogate(nextCharCode)) {
                        offset++;
                        codePoint = _stringsJs.computeCodePoint(charCode, nextCharCode);
                    } else // illegal => unicode replacement character
                    codePoint = 65533 /* SHA1Constant.UNICODE_REPLACEMENT */ ;
                } else {
                    // last character is a surrogate pair
                    leftoverHighSurrogate = charCode;
                    break;
                }
            } else if (_stringsJs.isLowSurrogate(charCode)) // illegal => unicode replacement character
            codePoint = 65533 /* SHA1Constant.UNICODE_REPLACEMENT */ ;
            buffLen = this._push(buff, buffLen, codePoint);
            offset++;
            if (offset < strLen) charCode = str.charCodeAt(offset);
            else break;
        }
        this._buffLen = buffLen;
        this._leftoverHighSurrogate = leftoverHighSurrogate;
    }
    _push(buff, buffLen, codePoint) {
        if (codePoint < 0x0080) buff[buffLen++] = codePoint;
        else if (codePoint < 0x0800) {
            buff[buffLen++] = 192 | (codePoint & 1984) >>> 6;
            buff[buffLen++] = 128 | (codePoint & 63) >>> 0;
        } else if (codePoint < 0x10000) {
            buff[buffLen++] = 224 | (codePoint & 61440) >>> 12;
            buff[buffLen++] = 128 | (codePoint & 4032) >>> 6;
            buff[buffLen++] = 128 | (codePoint & 63) >>> 0;
        } else {
            buff[buffLen++] = 240 | (codePoint & 1835008) >>> 18;
            buff[buffLen++] = 128 | (codePoint & 258048) >>> 12;
            buff[buffLen++] = 128 | (codePoint & 4032) >>> 6;
            buff[buffLen++] = 128 | (codePoint & 63) >>> 0;
        }
        if (buffLen >= 64 /* SHA1Constant.BLOCK_SIZE */ ) {
            this._step();
            buffLen -= 64 /* SHA1Constant.BLOCK_SIZE */ ;
            this._totalLen += 64 /* SHA1Constant.BLOCK_SIZE */ ;
            // take last 3 in case of UTF8 overflow
            buff[0] = buff[64];
            buff[1] = buff[65];
            buff[2] = buff[66];
        }
        return buffLen;
    }
    digest() {
        if (!this._finished) {
            this._finished = true;
            if (this._leftoverHighSurrogate) {
                // illegal => unicode replacement character
                this._leftoverHighSurrogate = 0;
                this._buffLen = this._push(this._buff, this._buffLen, 65533 /* SHA1Constant.UNICODE_REPLACEMENT */ );
            }
            this._totalLen += this._buffLen;
            this._wrapUp();
        }
        return toHexString(this._h0) + toHexString(this._h1) + toHexString(this._h2) + toHexString(this._h3) + toHexString(this._h4);
    }
    _wrapUp() {
        this._buff[this._buffLen++] = 0x80;
        fill(this._buff, this._buffLen);
        if (this._buffLen > 56) {
            this._step();
            fill(this._buff);
        }
        // this will fit because the mantissa can cover up to 52 bits
        const ml = 8 * this._totalLen;
        this._buffDV.setUint32(56, Math.floor(ml / 4294967296), false);
        this._buffDV.setUint32(60, ml % 4294967296, false);
        this._step();
    }
    _step() {
        const bigBlock32 = StringSHA1._bigBlock32;
        const data = this._buffDV;
        for(let j = 0; j < 64 /* 16*4 */ ; j += 4)bigBlock32.setUint32(j, data.getUint32(j, false), false);
        for(let j = 64; j < 320 /* 80*4 */ ; j += 4)bigBlock32.setUint32(j, leftRotate(bigBlock32.getUint32(j - 12, false) ^ bigBlock32.getUint32(j - 32, false) ^ bigBlock32.getUint32(j - 56, false) ^ bigBlock32.getUint32(j - 64, false), 1), false);
        let a = this._h0;
        let b = this._h1;
        let c = this._h2;
        let d = this._h3;
        let e = this._h4;
        let f, k;
        let temp;
        for(let j = 0; j < 80; j++){
            if (j < 20) {
                f = b & c | ~b & d;
                k = 0x5A827999;
            } else if (j < 40) {
                f = b ^ c ^ d;
                k = 0x6ED9EBA1;
            } else if (j < 60) {
                f = b & c | b & d | c & d;
                k = 0x8F1BBCDC;
            } else {
                f = b ^ c ^ d;
                k = 0xCA62C1D6;
            }
            temp = leftRotate(a, 5) + f + e + k + bigBlock32.getUint32(j * 4, false) & 0xffffffff;
            e = d;
            d = c;
            c = leftRotate(b, 30);
            b = a;
            a = temp;
        }
        this._h0 = this._h0 + a & 0xffffffff;
        this._h1 = this._h1 + b & 0xffffffff;
        this._h2 = this._h2 + c & 0xffffffff;
        this._h3 = this._h3 + d & 0xffffffff;
        this._h4 = this._h4 + e & 0xffffffff;
    }
}

},{"./strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Kvgn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixelRatio", ()=>PixelRatio);
var _domJs = require("./dom.js");
var _eventJs = require("../common/event.js");
var _lifecycleJs = require("../common/lifecycle.js");
/**
 * See https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio#monitoring_screen_resolution_or_zoom_level_changes
 */ class DevicePixelRatioMonitor extends (0, _lifecycleJs.Disposable) {
    constructor(targetWindow){
        super();
        this._onDidChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidChange = this._onDidChange.event;
        this._listener = ()=>this._handleChange(targetWindow, true);
        this._mediaQueryList = null;
        this._handleChange(targetWindow, false);
    }
    _handleChange(targetWindow, fireEvent) {
        this._mediaQueryList?.removeEventListener("change", this._listener);
        this._mediaQueryList = targetWindow.matchMedia(`(resolution: ${targetWindow.devicePixelRatio}dppx)`);
        this._mediaQueryList.addEventListener("change", this._listener);
        if (fireEvent) this._onDidChange.fire();
    }
}
class PixelRatioMonitorImpl extends (0, _lifecycleJs.Disposable) {
    get value() {
        return this._value;
    }
    constructor(targetWindow){
        super();
        this._onDidChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidChange = this._onDidChange.event;
        this._value = this._getPixelRatio(targetWindow);
        const dprMonitor = this._register(new DevicePixelRatioMonitor(targetWindow));
        this._register(dprMonitor.onDidChange(()=>{
            this._value = this._getPixelRatio(targetWindow);
            this._onDidChange.fire(this._value);
        }));
    }
    _getPixelRatio(targetWindow) {
        const ctx = document.createElement("canvas").getContext("2d");
        const dpr = targetWindow.devicePixelRatio || 1;
        const bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
        return dpr / bsr;
    }
}
class PixelRatioMonitorFacade {
    constructor(){
        this.mapWindowIdToPixelRatioMonitor = new Map();
    }
    _getOrCreatePixelRatioMonitor(targetWindow) {
        const targetWindowId = (0, _domJs.getWindowId)(targetWindow);
        let pixelRatioMonitor = this.mapWindowIdToPixelRatioMonitor.get(targetWindowId);
        if (!pixelRatioMonitor) {
            pixelRatioMonitor = (0, _lifecycleJs.markAsSingleton)(new PixelRatioMonitorImpl(targetWindow));
            this.mapWindowIdToPixelRatioMonitor.set(targetWindowId, pixelRatioMonitor);
            (0, _lifecycleJs.markAsSingleton)((0, _eventJs.Event).once((0, _domJs.onDidUnregisterWindow))(({ vscodeWindowId })=>{
                if (vscodeWindowId === targetWindowId) {
                    pixelRatioMonitor?.dispose();
                    this.mapWindowIdToPixelRatioMonitor.delete(targetWindowId);
                }
            }));
        }
        return pixelRatioMonitor;
    }
    getInstance(targetWindow) {
        return this._getOrCreatePixelRatioMonitor(targetWindow);
    }
}
const PixelRatio = new PixelRatioMonitorFacade();

},{"./dom.js":"bnqsM","../common/event.js":"4Zi8b","../common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jrP7f":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CharWidthRequest", ()=>CharWidthRequest);
parcelHelpers.export(exports, "readCharWidths", ()=>readCharWidths);
var _domFontInfoJs = require("./domFontInfo.js");
class CharWidthRequest {
    constructor(chr, type){
        this.chr = chr;
        this.type = type;
        this.width = 0;
    }
    fulfill(width) {
        this.width = width;
    }
}
class DomCharWidthReader {
    constructor(bareFontInfo, requests){
        this._bareFontInfo = bareFontInfo;
        this._requests = requests;
        this._container = null;
        this._testElements = null;
    }
    read(targetWindow) {
        // Create a test container with all these test elements
        this._createDomElements();
        // Add the container to the DOM
        targetWindow.document.body.appendChild(this._container);
        // Read character widths
        this._readFromDomElements();
        // Remove the container from the DOM
        this._container?.remove();
        this._container = null;
        this._testElements = null;
    }
    _createDomElements() {
        const container = document.createElement("div");
        container.style.position = "absolute";
        container.style.top = "-50000px";
        container.style.width = "50000px";
        const regularDomNode = document.createElement("div");
        (0, _domFontInfoJs.applyFontInfo)(regularDomNode, this._bareFontInfo);
        container.appendChild(regularDomNode);
        const boldDomNode = document.createElement("div");
        (0, _domFontInfoJs.applyFontInfo)(boldDomNode, this._bareFontInfo);
        boldDomNode.style.fontWeight = "bold";
        container.appendChild(boldDomNode);
        const italicDomNode = document.createElement("div");
        (0, _domFontInfoJs.applyFontInfo)(italicDomNode, this._bareFontInfo);
        italicDomNode.style.fontStyle = "italic";
        container.appendChild(italicDomNode);
        const testElements = [];
        for (const request of this._requests){
            let parent;
            if (request.type === 0 /* CharWidthRequestType.Regular */ ) parent = regularDomNode;
            if (request.type === 2 /* CharWidthRequestType.Bold */ ) parent = boldDomNode;
            if (request.type === 1 /* CharWidthRequestType.Italic */ ) parent = italicDomNode;
            parent.appendChild(document.createElement("br"));
            const testElement = document.createElement("span");
            DomCharWidthReader._render(testElement, request);
            parent.appendChild(testElement);
            testElements.push(testElement);
        }
        this._container = container;
        this._testElements = testElements;
    }
    static _render(testElement, request) {
        if (request.chr === " ") {
            let htmlString = "\xa0";
            // Repeat character 256 (2^8) times
            for(let i = 0; i < 8; i++)htmlString += htmlString;
            testElement.innerText = htmlString;
        } else {
            let testString = request.chr;
            // Repeat character 256 (2^8) times
            for(let i = 0; i < 8; i++)testString += testString;
            testElement.textContent = testString;
        }
    }
    _readFromDomElements() {
        for(let i = 0, len = this._requests.length; i < len; i++){
            const request = this._requests[i];
            const testElement = this._testElements[i];
            request.fulfill(testElement.offsetWidth / 256);
        }
    }
}
function readCharWidths(targetWindow, bareFontInfo, requests) {
    const reader = new DomCharWidthReader(bareFontInfo, requests);
    reader.read(targetWindow);
}

},{"./domFontInfo.js":"fQezv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fQezv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyFontInfo", ()=>applyFontInfo);
var _fastDomNodeJs = require("../../../base/browser/fastDomNode.js");
function applyFontInfo(domNode, fontInfo) {
    if (domNode instanceof (0, _fastDomNodeJs.FastDomNode)) {
        domNode.setFontFamily(fontInfo.getMassagedFontFamily());
        domNode.setFontWeight(fontInfo.fontWeight);
        domNode.setFontSize(fontInfo.fontSize);
        domNode.setFontFeatureSettings(fontInfo.fontFeatureSettings);
        domNode.setFontVariationSettings(fontInfo.fontVariationSettings);
        domNode.setLineHeight(fontInfo.lineHeight);
        domNode.setLetterSpacing(fontInfo.letterSpacing);
    } else {
        domNode.style.fontFamily = fontInfo.getMassagedFontFamily();
        domNode.style.fontWeight = fontInfo.fontWeight;
        domNode.style.fontSize = fontInfo.fontSize + "px";
        domNode.style.fontFeatureSettings = fontInfo.fontFeatureSettings;
        domNode.style.fontVariationSettings = fontInfo.fontVariationSettings;
        domNode.style.lineHeight = fontInfo.lineHeight + "px";
        domNode.style.letterSpacing = fontInfo.letterSpacing + "px";
    }
}

},{"../../../base/browser/fastDomNode.js":"2SADf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2SADf":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FastDomNode", ()=>FastDomNode);
parcelHelpers.export(exports, "createFastDomNode", ()=>createFastDomNode);
class FastDomNode {
    constructor(domNode){
        this.domNode = domNode;
        this._maxWidth = "";
        this._width = "";
        this._height = "";
        this._top = "";
        this._left = "";
        this._bottom = "";
        this._right = "";
        this._paddingLeft = "";
        this._fontFamily = "";
        this._fontWeight = "";
        this._fontSize = "";
        this._fontStyle = "";
        this._fontFeatureSettings = "";
        this._fontVariationSettings = "";
        this._textDecoration = "";
        this._lineHeight = "";
        this._letterSpacing = "";
        this._className = "";
        this._display = "";
        this._position = "";
        this._visibility = "";
        this._color = "";
        this._backgroundColor = "";
        this._layerHint = false;
        this._contain = "none";
        this._boxShadow = "";
    }
    setMaxWidth(_maxWidth) {
        const maxWidth = numberAsPixels(_maxWidth);
        if (this._maxWidth === maxWidth) return;
        this._maxWidth = maxWidth;
        this.domNode.style.maxWidth = this._maxWidth;
    }
    setWidth(_width) {
        const width = numberAsPixels(_width);
        if (this._width === width) return;
        this._width = width;
        this.domNode.style.width = this._width;
    }
    setHeight(_height) {
        const height = numberAsPixels(_height);
        if (this._height === height) return;
        this._height = height;
        this.domNode.style.height = this._height;
    }
    setTop(_top) {
        const top = numberAsPixels(_top);
        if (this._top === top) return;
        this._top = top;
        this.domNode.style.top = this._top;
    }
    setLeft(_left) {
        const left = numberAsPixels(_left);
        if (this._left === left) return;
        this._left = left;
        this.domNode.style.left = this._left;
    }
    setBottom(_bottom) {
        const bottom = numberAsPixels(_bottom);
        if (this._bottom === bottom) return;
        this._bottom = bottom;
        this.domNode.style.bottom = this._bottom;
    }
    setRight(_right) {
        const right = numberAsPixels(_right);
        if (this._right === right) return;
        this._right = right;
        this.domNode.style.right = this._right;
    }
    setPaddingLeft(_paddingLeft) {
        const paddingLeft = numberAsPixels(_paddingLeft);
        if (this._paddingLeft === paddingLeft) return;
        this._paddingLeft = paddingLeft;
        this.domNode.style.paddingLeft = this._paddingLeft;
    }
    setFontFamily(fontFamily) {
        if (this._fontFamily === fontFamily) return;
        this._fontFamily = fontFamily;
        this.domNode.style.fontFamily = this._fontFamily;
    }
    setFontWeight(fontWeight) {
        if (this._fontWeight === fontWeight) return;
        this._fontWeight = fontWeight;
        this.domNode.style.fontWeight = this._fontWeight;
    }
    setFontSize(_fontSize) {
        const fontSize = numberAsPixels(_fontSize);
        if (this._fontSize === fontSize) return;
        this._fontSize = fontSize;
        this.domNode.style.fontSize = this._fontSize;
    }
    setFontStyle(fontStyle) {
        if (this._fontStyle === fontStyle) return;
        this._fontStyle = fontStyle;
        this.domNode.style.fontStyle = this._fontStyle;
    }
    setFontFeatureSettings(fontFeatureSettings) {
        if (this._fontFeatureSettings === fontFeatureSettings) return;
        this._fontFeatureSettings = fontFeatureSettings;
        this.domNode.style.fontFeatureSettings = this._fontFeatureSettings;
    }
    setFontVariationSettings(fontVariationSettings) {
        if (this._fontVariationSettings === fontVariationSettings) return;
        this._fontVariationSettings = fontVariationSettings;
        this.domNode.style.fontVariationSettings = this._fontVariationSettings;
    }
    setTextDecoration(textDecoration) {
        if (this._textDecoration === textDecoration) return;
        this._textDecoration = textDecoration;
        this.domNode.style.textDecoration = this._textDecoration;
    }
    setLineHeight(_lineHeight) {
        const lineHeight = numberAsPixels(_lineHeight);
        if (this._lineHeight === lineHeight) return;
        this._lineHeight = lineHeight;
        this.domNode.style.lineHeight = this._lineHeight;
    }
    setLetterSpacing(_letterSpacing) {
        const letterSpacing = numberAsPixels(_letterSpacing);
        if (this._letterSpacing === letterSpacing) return;
        this._letterSpacing = letterSpacing;
        this.domNode.style.letterSpacing = this._letterSpacing;
    }
    setClassName(className) {
        if (this._className === className) return;
        this._className = className;
        this.domNode.className = this._className;
    }
    toggleClassName(className, shouldHaveIt) {
        this.domNode.classList.toggle(className, shouldHaveIt);
        this._className = this.domNode.className;
    }
    setDisplay(display) {
        if (this._display === display) return;
        this._display = display;
        this.domNode.style.display = this._display;
    }
    setPosition(position) {
        if (this._position === position) return;
        this._position = position;
        this.domNode.style.position = this._position;
    }
    setVisibility(visibility) {
        if (this._visibility === visibility) return;
        this._visibility = visibility;
        this.domNode.style.visibility = this._visibility;
    }
    setColor(color) {
        if (this._color === color) return;
        this._color = color;
        this.domNode.style.color = this._color;
    }
    setBackgroundColor(backgroundColor) {
        if (this._backgroundColor === backgroundColor) return;
        this._backgroundColor = backgroundColor;
        this.domNode.style.backgroundColor = this._backgroundColor;
    }
    setLayerHinting(layerHint) {
        if (this._layerHint === layerHint) return;
        this._layerHint = layerHint;
        this.domNode.style.transform = this._layerHint ? "translate3d(0px, 0px, 0px)" : "";
    }
    setBoxShadow(boxShadow) {
        if (this._boxShadow === boxShadow) return;
        this._boxShadow = boxShadow;
        this.domNode.style.boxShadow = boxShadow;
    }
    setContain(contain) {
        if (this._contain === contain) return;
        this._contain = contain;
        this.domNode.style.contain = this._contain;
    }
    setAttribute(name, value) {
        this.domNode.setAttribute(name, value);
    }
    removeAttribute(name) {
        this.domNode.removeAttribute(name);
    }
    appendChild(child) {
        this.domNode.appendChild(child.domNode);
    }
    removeChild(child) {
        this.domNode.removeChild(child.domNode);
    }
}
function numberAsPixels(value) {
    return typeof value === "number" ? `${value}px` : value;
}
function createFastDomNode(domNode) {
    return new FastDomNode(domNode);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"68pxu":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BareFontInfo", ()=>BareFontInfo);
parcelHelpers.export(exports, "SERIALIZED_FONT_INFO_VERSION", ()=>SERIALIZED_FONT_INFO_VERSION);
parcelHelpers.export(exports, "FontInfo", ()=>FontInfo);
var _platformJs = require("../../../base/common/platform.js");
var _editorOptionsJs = require("./editorOptions.js");
var _editorZoomJs = require("./editorZoom.js");
/**
 * Determined from empirical observations.
 * @internal
 */ const GOLDEN_LINE_HEIGHT_RATIO = _platformJs.isMacintosh ? 1.5 : 1.35;
/**
 * @internal
 */ const MINIMUM_LINE_HEIGHT = 8;
class BareFontInfo {
    /**
     * @internal
     */ static createFromValidatedSettings(options, pixelRatio, ignoreEditorZoom) {
        const fontFamily = options.get(49 /* EditorOption.fontFamily */ );
        const fontWeight = options.get(53 /* EditorOption.fontWeight */ );
        const fontSize = options.get(52 /* EditorOption.fontSize */ );
        const fontFeatureSettings = options.get(51 /* EditorOption.fontLigatures */ );
        const fontVariationSettings = options.get(54 /* EditorOption.fontVariations */ );
        const lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        const letterSpacing = options.get(64 /* EditorOption.letterSpacing */ );
        return BareFontInfo._create(fontFamily, fontWeight, fontSize, fontFeatureSettings, fontVariationSettings, lineHeight, letterSpacing, pixelRatio, ignoreEditorZoom);
    }
    /**
     * @internal
     */ static _create(fontFamily, fontWeight, fontSize, fontFeatureSettings, fontVariationSettings, lineHeight, letterSpacing, pixelRatio, ignoreEditorZoom) {
        if (lineHeight === 0) lineHeight = GOLDEN_LINE_HEIGHT_RATIO * fontSize;
        else if (lineHeight < MINIMUM_LINE_HEIGHT) // Values too small to be line heights in pixels are in ems.
        lineHeight = lineHeight * fontSize;
        // Enforce integer, minimum constraints
        lineHeight = Math.round(lineHeight);
        if (lineHeight < MINIMUM_LINE_HEIGHT) lineHeight = MINIMUM_LINE_HEIGHT;
        const editorZoomLevelMultiplier = 1 + (ignoreEditorZoom ? 0 : (0, _editorZoomJs.EditorZoom).getZoomLevel() * 0.1);
        fontSize *= editorZoomLevelMultiplier;
        lineHeight *= editorZoomLevelMultiplier;
        if (fontVariationSettings === (0, _editorOptionsJs.EditorFontVariations).TRANSLATE) {
            if (fontWeight === "normal" || fontWeight === "bold") fontVariationSettings = (0, _editorOptionsJs.EditorFontVariations).OFF;
            else {
                const fontWeightAsNumber = parseInt(fontWeight, 10);
                fontVariationSettings = `'wght' ${fontWeightAsNumber}`;
                fontWeight = "normal";
            }
        }
        return new BareFontInfo({
            pixelRatio: pixelRatio,
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: fontSize,
            fontFeatureSettings: fontFeatureSettings,
            fontVariationSettings,
            lineHeight: lineHeight,
            letterSpacing: letterSpacing
        });
    }
    /**
     * @internal
     */ constructor(opts){
        this._bareFontInfoBrand = undefined;
        this.pixelRatio = opts.pixelRatio;
        this.fontFamily = String(opts.fontFamily);
        this.fontWeight = String(opts.fontWeight);
        this.fontSize = opts.fontSize;
        this.fontFeatureSettings = opts.fontFeatureSettings;
        this.fontVariationSettings = opts.fontVariationSettings;
        this.lineHeight = opts.lineHeight | 0;
        this.letterSpacing = opts.letterSpacing;
    }
    /**
     * @internal
     */ getId() {
        return `${this.pixelRatio}-${this.fontFamily}-${this.fontWeight}-${this.fontSize}-${this.fontFeatureSettings}-${this.fontVariationSettings}-${this.lineHeight}-${this.letterSpacing}`;
    }
    /**
     * @internal
     */ getMassagedFontFamily() {
        const fallbackFontFamily = (0, _editorOptionsJs.EDITOR_FONT_DEFAULTS).fontFamily;
        const fontFamily = BareFontInfo._wrapInQuotes(this.fontFamily);
        if (fallbackFontFamily && this.fontFamily !== fallbackFontFamily) return `${fontFamily}, ${fallbackFontFamily}`;
        return fontFamily;
    }
    static _wrapInQuotes(fontFamily) {
        if (/[,"']/.test(fontFamily)) // Looks like the font family might be already escaped
        return fontFamily;
        if (/[+ ]/.test(fontFamily)) // Wrap a font family using + or <space> with quotes
        return `"${fontFamily}"`;
        return fontFamily;
    }
}
const SERIALIZED_FONT_INFO_VERSION = 2;
class FontInfo extends BareFontInfo {
    /**
     * @internal
     */ constructor(opts, isTrusted){
        super(opts);
        this._editorStylingBrand = undefined;
        this.version = SERIALIZED_FONT_INFO_VERSION;
        this.isTrusted = isTrusted;
        this.isMonospace = opts.isMonospace;
        this.typicalHalfwidthCharacterWidth = opts.typicalHalfwidthCharacterWidth;
        this.typicalFullwidthCharacterWidth = opts.typicalFullwidthCharacterWidth;
        this.canUseHalfwidthRightwardsArrow = opts.canUseHalfwidthRightwardsArrow;
        this.spaceWidth = opts.spaceWidth;
        this.middotWidth = opts.middotWidth;
        this.wsmiddotWidth = opts.wsmiddotWidth;
        this.maxDigitWidth = opts.maxDigitWidth;
    }
    /**
     * @internal
     */ equals(other) {
        return this.fontFamily === other.fontFamily && this.fontWeight === other.fontWeight && this.fontSize === other.fontSize && this.fontFeatureSettings === other.fontFeatureSettings && this.fontVariationSettings === other.fontVariationSettings && this.lineHeight === other.lineHeight && this.letterSpacing === other.letterSpacing && this.typicalHalfwidthCharacterWidth === other.typicalHalfwidthCharacterWidth && this.typicalFullwidthCharacterWidth === other.typicalFullwidthCharacterWidth && this.canUseHalfwidthRightwardsArrow === other.canUseHalfwidthRightwardsArrow && this.spaceWidth === other.spaceWidth && this.middotWidth === other.middotWidth && this.wsmiddotWidth === other.wsmiddotWidth && this.maxDigitWidth === other.maxDigitWidth;
    }
}

},{"../../../base/common/platform.js":"7maJO","./editorOptions.js":"3Xi00","./editorZoom.js":"7PVxj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7PVxj":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorZoom", ()=>EditorZoom);
var _eventJs = require("../../../base/common/event.js");
const EditorZoom = new class {
    constructor(){
        this._zoomLevel = 0;
        this._onDidChangeZoomLevel = new (0, _eventJs.Emitter)();
        this.onDidChangeZoomLevel = this._onDidChangeZoomLevel.event;
    }
    getZoomLevel() {
        return this._zoomLevel;
    }
    setZoomLevel(zoomLevel) {
        zoomLevel = Math.min(Math.max(-5, zoomLevel), 20);
        if (this._zoomLevel === zoomLevel) return;
        this._zoomLevel = zoomLevel;
        this._onDidChangeZoomLevel.fire(this._zoomLevel);
    }
};

},{"../../../base/common/event.js":"4Zi8b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kC3w6":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", ()=>Command);
parcelHelpers.export(exports, "MultiCommand", ()=>MultiCommand);
//#endregion
/**
 * A command that delegates to another command's implementation.
 *
 * This lets different commands be registered but share the same implementation
 */ parcelHelpers.export(exports, "ProxyCommand", ()=>ProxyCommand);
parcelHelpers.export(exports, "EditorCommand", ()=>EditorCommand);
parcelHelpers.export(exports, "EditorAction", ()=>EditorAction);
parcelHelpers.export(exports, "MultiEditorAction", ()=>MultiEditorAction);
//#endregion EditorAction
//#region EditorAction2
parcelHelpers.export(exports, "EditorAction2", ()=>EditorAction2);
//#endregion
// --- Registration of commands and actions
parcelHelpers.export(exports, "registerModelAndPositionCommand", ()=>registerModelAndPositionCommand);
parcelHelpers.export(exports, "registerEditorCommand", ()=>registerEditorCommand);
parcelHelpers.export(exports, "registerEditorAction", ()=>registerEditorAction);
parcelHelpers.export(exports, "registerMultiEditorAction", ()=>registerMultiEditorAction);
parcelHelpers.export(exports, "registerInstantiatedEditorAction", ()=>registerInstantiatedEditorAction);
/**
 * Registers an editor contribution. Editor contributions have a lifecycle which is bound
 * to a specific code editor instance.
 */ parcelHelpers.export(exports, "registerEditorContribution", ()=>registerEditorContribution);
parcelHelpers.export(exports, "EditorExtensionsRegistry", ()=>EditorExtensionsRegistry);
parcelHelpers.export(exports, "UndoCommand", ()=>UndoCommand);
parcelHelpers.export(exports, "RedoCommand", ()=>RedoCommand);
parcelHelpers.export(exports, "SelectAllCommand", ()=>SelectAllCommand);
var _nlsJs = require("../../nls.js");
var _uriJs = require("../../base/common/uri.js");
var _codeEditorServiceJs = require("./services/codeEditorService.js");
var _positionJs = require("../common/core/position.js");
var _modelJs = require("../common/services/model.js");
var _resolverServiceJs = require("../common/services/resolverService.js");
var _actionsJs = require("../../platform/actions/common/actions.js");
var _commandsJs = require("../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../platform/instantiation/common/instantiation.js");
var _keybindingsRegistryJs = require("../../platform/keybinding/common/keybindingsRegistry.js");
var _platformJs = require("../../platform/registry/common/platform.js");
var _telemetryJs = require("../../platform/telemetry/common/telemetry.js");
var _typesJs = require("../../base/common/types.js");
var _logJs = require("../../platform/log/common/log.js");
var _domJs = require("../../base/browser/dom.js");
class Command {
    constructor(opts){
        this.id = opts.id;
        this.precondition = opts.precondition;
        this._kbOpts = opts.kbOpts;
        this._menuOpts = opts.menuOpts;
        this.metadata = opts.metadata;
    }
    register() {
        if (Array.isArray(this._menuOpts)) this._menuOpts.forEach(this._registerMenuItem, this);
        else if (this._menuOpts) this._registerMenuItem(this._menuOpts);
        if (this._kbOpts) {
            const kbOptsArr = Array.isArray(this._kbOpts) ? this._kbOpts : [
                this._kbOpts
            ];
            for (const kbOpts of kbOptsArr){
                let kbWhen = kbOpts.kbExpr;
                if (this.precondition) {
                    if (kbWhen) kbWhen = (0, _contextkeyJs.ContextKeyExpr).and(kbWhen, this.precondition);
                    else kbWhen = this.precondition;
                }
                const desc = {
                    id: this.id,
                    weight: kbOpts.weight,
                    args: kbOpts.args,
                    when: kbWhen,
                    primary: kbOpts.primary,
                    secondary: kbOpts.secondary,
                    win: kbOpts.win,
                    linux: kbOpts.linux,
                    mac: kbOpts.mac
                };
                (0, _keybindingsRegistryJs.KeybindingsRegistry).registerKeybindingRule(desc);
            }
        }
        (0, _commandsJs.CommandsRegistry).registerCommand({
            id: this.id,
            handler: (accessor, args)=>this.runCommand(accessor, args),
            metadata: this.metadata
        });
    }
    _registerMenuItem(item) {
        (0, _actionsJs.MenuRegistry).appendMenuItem(item.menuId, {
            group: item.group,
            command: {
                id: this.id,
                title: item.title,
                icon: item.icon,
                precondition: this.precondition
            },
            when: item.when,
            order: item.order
        });
    }
}
class MultiCommand extends Command {
    constructor(){
        super(...arguments);
        this._implementations = [];
    }
    /**
     * A higher priority gets to be looked at first
     */ addImplementation(priority, name, implementation, when) {
        this._implementations.push({
            priority,
            name,
            implementation,
            when
        });
        this._implementations.sort((a, b)=>b.priority - a.priority);
        return {
            dispose: ()=>{
                for(let i = 0; i < this._implementations.length; i++)if (this._implementations[i].implementation === implementation) {
                    this._implementations.splice(i, 1);
                    return;
                }
            }
        };
    }
    runCommand(accessor, args) {
        const logService = accessor.get((0, _logJs.ILogService));
        const contextKeyService = accessor.get((0, _contextkeyJs.IContextKeyService));
        logService.trace(`Executing Command '${this.id}' which has ${this._implementations.length} bound.`);
        for (const impl of this._implementations){
            if (impl.when) {
                const context = contextKeyService.getContext((0, _domJs.getActiveElement)());
                const value = impl.when.evaluate(context);
                if (!value) continue;
            }
            const result = impl.implementation(accessor, args);
            if (result) {
                logService.trace(`Command '${this.id}' was handled by '${impl.name}'.`);
                if (typeof result === "boolean") return;
                return result;
            }
        }
        logService.trace(`The Command '${this.id}' was not handled by any implementation.`);
    }
}
class ProxyCommand extends Command {
    constructor(command, opts){
        super(opts);
        this.command = command;
    }
    runCommand(accessor, args) {
        return this.command.runCommand(accessor, args);
    }
}
class EditorCommand extends Command {
    /**
     * Create a command class that is bound to a certain editor contribution.
     */ static bindToContribution(controllerGetter) {
        return class EditorControllerCommandImpl extends EditorCommand {
            constructor(opts){
                super(opts);
                this._callback = opts.handler;
            }
            runEditorCommand(accessor, editor, args) {
                const controller = controllerGetter(editor);
                if (controller) this._callback(controller, args);
            }
        };
    }
    static runEditorCommand(accessor, args, precondition, runner) {
        const codeEditorService = accessor.get((0, _codeEditorServiceJs.ICodeEditorService));
        // Find the editor with text focus or active
        const editor = codeEditorService.getFocusedCodeEditor() || codeEditorService.getActiveCodeEditor();
        if (!editor) // well, at least we tried...
        return;
        return editor.invokeWithinContext((editorAccessor)=>{
            const kbService = editorAccessor.get((0, _contextkeyJs.IContextKeyService));
            if (!kbService.contextMatchesRules(precondition ?? undefined)) // precondition does not hold
            return;
            return runner(editorAccessor, editor, args);
        });
    }
    runCommand(accessor, args) {
        return EditorCommand.runEditorCommand(accessor, args, this.precondition, (accessor, editor, args)=>this.runEditorCommand(accessor, editor, args));
    }
}
class EditorAction extends EditorCommand {
    static convertOptions(opts) {
        let menuOpts;
        if (Array.isArray(opts.menuOpts)) menuOpts = opts.menuOpts;
        else if (opts.menuOpts) menuOpts = [
            opts.menuOpts
        ];
        else menuOpts = [];
        function withDefaults(item) {
            if (!item.menuId) item.menuId = (0, _actionsJs.MenuId).EditorContext;
            if (!item.title) item.title = opts.label;
            item.when = (0, _contextkeyJs.ContextKeyExpr).and(opts.precondition, item.when);
            return item;
        }
        if (Array.isArray(opts.contextMenuOpts)) menuOpts.push(...opts.contextMenuOpts.map(withDefaults));
        else if (opts.contextMenuOpts) menuOpts.push(withDefaults(opts.contextMenuOpts));
        opts.menuOpts = menuOpts;
        return opts;
    }
    constructor(opts){
        super(EditorAction.convertOptions(opts));
        this.label = opts.label;
        this.alias = opts.alias;
    }
    runEditorCommand(accessor, editor, args) {
        this.reportTelemetry(accessor, editor);
        return this.run(accessor, editor, args || {});
    }
    reportTelemetry(accessor, editor) {
        accessor.get((0, _telemetryJs.ITelemetryService)).publicLog2("editorActionInvoked", {
            name: this.label,
            id: this.id
        });
    }
}
class MultiEditorAction extends EditorAction {
    constructor(){
        super(...arguments);
        this._implementations = [];
    }
    /**
     * A higher priority gets to be looked at first
     */ addImplementation(priority, implementation) {
        this._implementations.push([
            priority,
            implementation
        ]);
        this._implementations.sort((a, b)=>b[0] - a[0]);
        return {
            dispose: ()=>{
                for(let i = 0; i < this._implementations.length; i++)if (this._implementations[i][1] === implementation) {
                    this._implementations.splice(i, 1);
                    return;
                }
            }
        };
    }
    run(accessor, editor, args) {
        for (const impl of this._implementations){
            const result = impl[1](accessor, editor, args);
            if (result) {
                if (typeof result === "boolean") return;
                return result;
            }
        }
    }
}
class EditorAction2 extends (0, _actionsJs.Action2) {
    run(accessor, ...args) {
        // Find the editor with text focus or active
        const codeEditorService = accessor.get((0, _codeEditorServiceJs.ICodeEditorService));
        const editor = codeEditorService.getFocusedCodeEditor() || codeEditorService.getActiveCodeEditor();
        if (!editor) // well, at least we tried...
        return;
        // precondition does hold
        return editor.invokeWithinContext((editorAccessor)=>{
            const kbService = editorAccessor.get((0, _contextkeyJs.IContextKeyService));
            const logService = editorAccessor.get((0, _logJs.ILogService));
            const enabled = kbService.contextMatchesRules(this.desc.precondition ?? undefined);
            if (!enabled) {
                logService.debug(`[EditorAction2] NOT running command because its precondition is FALSE`, this.desc.id, this.desc.precondition?.serialize());
                return;
            }
            return this.runEditorCommand(editorAccessor, editor, ...args);
        });
    }
}
function registerModelAndPositionCommand(id, handler) {
    (0, _commandsJs.CommandsRegistry).registerCommand(id, function(accessor, ...args) {
        const instaService = accessor.get((0, _instantiationJs.IInstantiationService));
        const [resource, position] = args;
        (0, _typesJs.assertType)((0, _uriJs.URI).isUri(resource));
        (0, _typesJs.assertType)((0, _positionJs.Position).isIPosition(position));
        const model = accessor.get((0, _modelJs.IModelService)).getModel(resource);
        if (model) {
            const editorPosition = (0, _positionJs.Position).lift(position);
            return instaService.invokeFunction(handler, model, editorPosition, ...args.slice(2));
        }
        return accessor.get((0, _resolverServiceJs.ITextModelService)).createModelReference(resource).then((reference)=>{
            return new Promise((resolve, reject)=>{
                try {
                    const result = instaService.invokeFunction(handler, reference.object.textEditorModel, (0, _positionJs.Position).lift(position), args.slice(2));
                    resolve(result);
                } catch (err) {
                    reject(err);
                }
            }).finally(()=>{
                reference.dispose();
            });
        });
    });
}
function registerEditorCommand(editorCommand) {
    EditorContributionRegistry.INSTANCE.registerEditorCommand(editorCommand);
    return editorCommand;
}
function registerEditorAction(ctor) {
    const action = new ctor();
    EditorContributionRegistry.INSTANCE.registerEditorAction(action);
    return action;
}
function registerMultiEditorAction(action) {
    EditorContributionRegistry.INSTANCE.registerEditorAction(action);
    return action;
}
function registerInstantiatedEditorAction(editorAction) {
    EditorContributionRegistry.INSTANCE.registerEditorAction(editorAction);
}
function registerEditorContribution(id, ctor, instantiation) {
    EditorContributionRegistry.INSTANCE.registerEditorContribution(id, ctor, instantiation);
}
var EditorExtensionsRegistry;
(function(EditorExtensionsRegistry) {
    function getEditorCommand(commandId) {
        return EditorContributionRegistry.INSTANCE.getEditorCommand(commandId);
    }
    EditorExtensionsRegistry.getEditorCommand = getEditorCommand;
    function getEditorActions() {
        return EditorContributionRegistry.INSTANCE.getEditorActions();
    }
    EditorExtensionsRegistry.getEditorActions = getEditorActions;
    function getEditorContributions() {
        return EditorContributionRegistry.INSTANCE.getEditorContributions();
    }
    EditorExtensionsRegistry.getEditorContributions = getEditorContributions;
    function getSomeEditorContributions(ids) {
        return EditorContributionRegistry.INSTANCE.getEditorContributions().filter((c)=>ids.indexOf(c.id) >= 0);
    }
    EditorExtensionsRegistry.getSomeEditorContributions = getSomeEditorContributions;
    function getDiffEditorContributions() {
        return EditorContributionRegistry.INSTANCE.getDiffEditorContributions();
    }
    EditorExtensionsRegistry.getDiffEditorContributions = getDiffEditorContributions;
})(EditorExtensionsRegistry || (EditorExtensionsRegistry = {}));
// Editor extension points
const Extensions = {
    EditorCommonContributions: "editor.contributions"
};
class EditorContributionRegistry {
    static{
        this.INSTANCE = new EditorContributionRegistry();
    }
    constructor(){
        this.editorContributions = [];
        this.diffEditorContributions = [];
        this.editorActions = [];
        this.editorCommands = Object.create(null);
    }
    registerEditorContribution(id, ctor, instantiation) {
        this.editorContributions.push({
            id,
            ctor: ctor,
            instantiation
        });
    }
    getEditorContributions() {
        return this.editorContributions.slice(0);
    }
    getDiffEditorContributions() {
        return this.diffEditorContributions.slice(0);
    }
    registerEditorAction(action) {
        action.register();
        this.editorActions.push(action);
    }
    getEditorActions() {
        return this.editorActions;
    }
    registerEditorCommand(editorCommand) {
        editorCommand.register();
        this.editorCommands[editorCommand.id] = editorCommand;
    }
    getEditorCommand(commandId) {
        return this.editorCommands[commandId] || null;
    }
}
(0, _platformJs.Registry).add(Extensions.EditorCommonContributions, EditorContributionRegistry.INSTANCE);
function registerCommand(command) {
    command.register();
    return command;
}
const UndoCommand = registerCommand(new MultiCommand({
    id: "undo",
    precondition: undefined,
    kbOpts: {
        weight: 0 /* KeybindingWeight.EditorCore */ ,
        primary: 2104 /* KeyCode.KeyZ */ 
    },
    menuOpts: [
        {
            menuId: (0, _actionsJs.MenuId).MenubarEditMenu,
            group: "1_do",
            title: _nlsJs.localize({
                key: "miUndo",
                comment: [
                    "&& denotes a mnemonic"
                ]
            }, "&&Undo"),
            order: 1
        },
        {
            menuId: (0, _actionsJs.MenuId).CommandPalette,
            group: "",
            title: _nlsJs.localize("undo", "Undo"),
            order: 1
        }
    ]
}));
registerCommand(new ProxyCommand(UndoCommand, {
    id: "default:undo",
    precondition: undefined
}));
const RedoCommand = registerCommand(new MultiCommand({
    id: "redo",
    precondition: undefined,
    kbOpts: {
        weight: 0 /* KeybindingWeight.EditorCore */ ,
        primary: 2103 /* KeyCode.KeyY */ ,
        secondary: [
            3128 /* KeyCode.KeyZ */ 
        ],
        mac: {
            primary: 3128 /* KeyCode.KeyZ */ 
        }
    },
    menuOpts: [
        {
            menuId: (0, _actionsJs.MenuId).MenubarEditMenu,
            group: "1_do",
            title: _nlsJs.localize({
                key: "miRedo",
                comment: [
                    "&& denotes a mnemonic"
                ]
            }, "&&Redo"),
            order: 2
        },
        {
            menuId: (0, _actionsJs.MenuId).CommandPalette,
            group: "",
            title: _nlsJs.localize("redo", "Redo"),
            order: 1
        }
    ]
}));
registerCommand(new ProxyCommand(RedoCommand, {
    id: "default:redo",
    precondition: undefined
}));
const SelectAllCommand = registerCommand(new MultiCommand({
    id: "editor.action.selectAll",
    precondition: undefined,
    kbOpts: {
        weight: 0 /* KeybindingWeight.EditorCore */ ,
        kbExpr: null,
        primary: 2079 /* KeyCode.KeyA */ 
    },
    menuOpts: [
        {
            menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
            group: "1_basic",
            title: _nlsJs.localize({
                key: "miSelectAll",
                comment: [
                    "&& denotes a mnemonic"
                ]
            }, "&&Select All"),
            order: 1
        },
        {
            menuId: (0, _actionsJs.MenuId).CommandPalette,
            group: "",
            title: _nlsJs.localize("selectAll", "Select All"),
            order: 1
        }
    ]
}));

},{"../../nls.js":"l617d","../../base/common/uri.js":"7qGS3","./services/codeEditorService.js":"bOWtl","../common/core/position.js":"lvrPe","../common/services/model.js":"aciVm","../common/services/resolverService.js":"ezAtF","../../platform/actions/common/actions.js":"kyMtp","../../platform/commands/common/commands.js":"ho6ic","../../platform/contextkey/common/contextkey.js":"gXuBD","../../platform/instantiation/common/instantiation.js":"fjwWx","../../platform/keybinding/common/keybindingsRegistry.js":"h9qfk","../../platform/registry/common/platform.js":"dzx11","../../platform/telemetry/common/telemetry.js":"7vW8j","../../base/common/types.js":"fb5yx","../../platform/log/common/log.js":"ieJUF","../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bOWtl":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ICodeEditorService", ()=>ICodeEditorService);
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
const ICodeEditorService = (0, _instantiationJs.createDecorator)("codeEditorService");

},{"../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fjwWx":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ // ------ internal util
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_util", ()=>_util);
parcelHelpers.export(exports, "IInstantiationService", ()=>IInstantiationService);
/**
 * The *only* valid way to create a {{ServiceIdentifier}}.
 */ parcelHelpers.export(exports, "createDecorator", ()=>createDecorator);
var _util;
(function(_util) {
    _util.serviceIds = new Map();
    _util.DI_TARGET = "$di$target";
    _util.DI_DEPENDENCIES = "$di$dependencies";
    function getServiceDependencies(ctor) {
        return ctor[_util.DI_DEPENDENCIES] || [];
    }
    _util.getServiceDependencies = getServiceDependencies;
})(_util || (_util = {}));
const IInstantiationService = createDecorator("instantiationService");
function storeServiceDependency(id, target, index) {
    if (target[_util.DI_TARGET] === target) target[_util.DI_DEPENDENCIES].push({
        id,
        index
    });
    else {
        target[_util.DI_DEPENDENCIES] = [
            {
                id,
                index
            }
        ];
        target[_util.DI_TARGET] = target;
    }
}
function createDecorator(serviceId) {
    if (_util.serviceIds.has(serviceId)) return _util.serviceIds.get(serviceId);
    const id = function(target, key, index) {
        if (arguments.length !== 3) throw new Error("@IServiceName-decorator can only be used to decorate a parameter");
        storeServiceDependency(id, target, index);
    };
    id.toString = ()=>serviceId;
    _util.serviceIds.set(serviceId, id);
    return id;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aciVm":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IModelService", ()=>IModelService);
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
const IModelService = (0, _instantiationJs.createDecorator)("modelService");

},{"../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ezAtF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ITextModelService", ()=>ITextModelService);
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
const ITextModelService = (0, _instantiationJs.createDecorator)("textModelService");

},{"../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kyMtp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIMenuItem", ()=>isIMenuItem);
parcelHelpers.export(exports, "isISubmenuItem", ()=>isISubmenuItem);
parcelHelpers.export(exports, "MenuId", ()=>MenuId);
parcelHelpers.export(exports, "IMenuService", ()=>IMenuService);
parcelHelpers.export(exports, "MenuRegistry", ()=>MenuRegistry);
parcelHelpers.export(exports, "SubmenuItemAction", ()=>SubmenuItemAction);
parcelHelpers.export(exports, "MenuItemAction", ()=>MenuItemAction);
parcelHelpers.export(exports, "Action2", ()=>Action2);
parcelHelpers.export(exports, "registerAction2", ()=>registerAction2) //#endregion
;
var _actionsJs = require("../../../base/common/actions.js");
var _themablesJs = require("../../../base/common/themables.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _linkedListJs = require("../../../base/common/linkedList.js");
var _commandsJs = require("../../commands/common/commands.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var _keybindingsRegistryJs = require("../../keybinding/common/keybindingsRegistry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var MenuItemAction_1;
function isIMenuItem(item) {
    return item.command !== undefined;
}
function isISubmenuItem(item) {
    return item.submenu !== undefined;
}
class MenuId {
    static{
        this._instances = new Map();
    }
    static{
        this.CommandPalette = new MenuId("CommandPalette");
    }
    static{
        this.DebugBreakpointsContext = new MenuId("DebugBreakpointsContext");
    }
    static{
        this.DebugCallStackContext = new MenuId("DebugCallStackContext");
    }
    static{
        this.DebugConsoleContext = new MenuId("DebugConsoleContext");
    }
    static{
        this.DebugVariablesContext = new MenuId("DebugVariablesContext");
    }
    static{
        this.NotebookVariablesContext = new MenuId("NotebookVariablesContext");
    }
    static{
        this.DebugHoverContext = new MenuId("DebugHoverContext");
    }
    static{
        this.DebugWatchContext = new MenuId("DebugWatchContext");
    }
    static{
        this.DebugToolBar = new MenuId("DebugToolBar");
    }
    static{
        this.DebugToolBarStop = new MenuId("DebugToolBarStop");
    }
    static{
        this.DebugCallStackToolbar = new MenuId("DebugCallStackToolbar");
    }
    static{
        this.DebugCreateConfiguration = new MenuId("DebugCreateConfiguration");
    }
    static{
        this.EditorContext = new MenuId("EditorContext");
    }
    static{
        this.SimpleEditorContext = new MenuId("SimpleEditorContext");
    }
    static{
        this.EditorContent = new MenuId("EditorContent");
    }
    static{
        this.EditorLineNumberContext = new MenuId("EditorLineNumberContext");
    }
    static{
        this.EditorContextCopy = new MenuId("EditorContextCopy");
    }
    static{
        this.EditorContextPeek = new MenuId("EditorContextPeek");
    }
    static{
        this.EditorContextShare = new MenuId("EditorContextShare");
    }
    static{
        this.EditorTitle = new MenuId("EditorTitle");
    }
    static{
        this.EditorTitleRun = new MenuId("EditorTitleRun");
    }
    static{
        this.EditorTitleContext = new MenuId("EditorTitleContext");
    }
    static{
        this.EditorTitleContextShare = new MenuId("EditorTitleContextShare");
    }
    static{
        this.EmptyEditorGroup = new MenuId("EmptyEditorGroup");
    }
    static{
        this.EmptyEditorGroupContext = new MenuId("EmptyEditorGroupContext");
    }
    static{
        this.EditorTabsBarContext = new MenuId("EditorTabsBarContext");
    }
    static{
        this.EditorTabsBarShowTabsSubmenu = new MenuId("EditorTabsBarShowTabsSubmenu");
    }
    static{
        this.EditorTabsBarShowTabsZenModeSubmenu = new MenuId("EditorTabsBarShowTabsZenModeSubmenu");
    }
    static{
        this.EditorActionsPositionSubmenu = new MenuId("EditorActionsPositionSubmenu");
    }
    static{
        this.ExplorerContext = new MenuId("ExplorerContext");
    }
    static{
        this.ExplorerContextShare = new MenuId("ExplorerContextShare");
    }
    static{
        this.ExtensionContext = new MenuId("ExtensionContext");
    }
    static{
        this.GlobalActivity = new MenuId("GlobalActivity");
    }
    static{
        this.CommandCenter = new MenuId("CommandCenter");
    }
    static{
        this.CommandCenterCenter = new MenuId("CommandCenterCenter");
    }
    static{
        this.LayoutControlMenuSubmenu = new MenuId("LayoutControlMenuSubmenu");
    }
    static{
        this.LayoutControlMenu = new MenuId("LayoutControlMenu");
    }
    static{
        this.MenubarMainMenu = new MenuId("MenubarMainMenu");
    }
    static{
        this.MenubarAppearanceMenu = new MenuId("MenubarAppearanceMenu");
    }
    static{
        this.MenubarDebugMenu = new MenuId("MenubarDebugMenu");
    }
    static{
        this.MenubarEditMenu = new MenuId("MenubarEditMenu");
    }
    static{
        this.MenubarCopy = new MenuId("MenubarCopy");
    }
    static{
        this.MenubarFileMenu = new MenuId("MenubarFileMenu");
    }
    static{
        this.MenubarGoMenu = new MenuId("MenubarGoMenu");
    }
    static{
        this.MenubarHelpMenu = new MenuId("MenubarHelpMenu");
    }
    static{
        this.MenubarLayoutMenu = new MenuId("MenubarLayoutMenu");
    }
    static{
        this.MenubarNewBreakpointMenu = new MenuId("MenubarNewBreakpointMenu");
    }
    static{
        this.PanelAlignmentMenu = new MenuId("PanelAlignmentMenu");
    }
    static{
        this.PanelPositionMenu = new MenuId("PanelPositionMenu");
    }
    static{
        this.ActivityBarPositionMenu = new MenuId("ActivityBarPositionMenu");
    }
    static{
        this.MenubarPreferencesMenu = new MenuId("MenubarPreferencesMenu");
    }
    static{
        this.MenubarRecentMenu = new MenuId("MenubarRecentMenu");
    }
    static{
        this.MenubarSelectionMenu = new MenuId("MenubarSelectionMenu");
    }
    static{
        this.MenubarShare = new MenuId("MenubarShare");
    }
    static{
        this.MenubarSwitchEditorMenu = new MenuId("MenubarSwitchEditorMenu");
    }
    static{
        this.MenubarSwitchGroupMenu = new MenuId("MenubarSwitchGroupMenu");
    }
    static{
        this.MenubarTerminalMenu = new MenuId("MenubarTerminalMenu");
    }
    static{
        this.MenubarViewMenu = new MenuId("MenubarViewMenu");
    }
    static{
        this.MenubarHomeMenu = new MenuId("MenubarHomeMenu");
    }
    static{
        this.OpenEditorsContext = new MenuId("OpenEditorsContext");
    }
    static{
        this.OpenEditorsContextShare = new MenuId("OpenEditorsContextShare");
    }
    static{
        this.ProblemsPanelContext = new MenuId("ProblemsPanelContext");
    }
    static{
        this.SCMInputBox = new MenuId("SCMInputBox");
    }
    static{
        this.SCMChangesSeparator = new MenuId("SCMChangesSeparator");
    }
    static{
        this.SCMChangesContext = new MenuId("SCMChangesContext");
    }
    static{
        this.SCMIncomingChanges = new MenuId("SCMIncomingChanges");
    }
    static{
        this.SCMIncomingChangesContext = new MenuId("SCMIncomingChangesContext");
    }
    static{
        this.SCMIncomingChangesSetting = new MenuId("SCMIncomingChangesSetting");
    }
    static{
        this.SCMOutgoingChanges = new MenuId("SCMOutgoingChanges");
    }
    static{
        this.SCMOutgoingChangesContext = new MenuId("SCMOutgoingChangesContext");
    }
    static{
        this.SCMOutgoingChangesSetting = new MenuId("SCMOutgoingChangesSetting");
    }
    static{
        this.SCMIncomingChangesAllChangesContext = new MenuId("SCMIncomingChangesAllChangesContext");
    }
    static{
        this.SCMIncomingChangesHistoryItemContext = new MenuId("SCMIncomingChangesHistoryItemContext");
    }
    static{
        this.SCMOutgoingChangesAllChangesContext = new MenuId("SCMOutgoingChangesAllChangesContext");
    }
    static{
        this.SCMOutgoingChangesHistoryItemContext = new MenuId("SCMOutgoingChangesHistoryItemContext");
    }
    static{
        this.SCMChangeContext = new MenuId("SCMChangeContext");
    }
    static{
        this.SCMResourceContext = new MenuId("SCMResourceContext");
    }
    static{
        this.SCMResourceContextShare = new MenuId("SCMResourceContextShare");
    }
    static{
        this.SCMResourceFolderContext = new MenuId("SCMResourceFolderContext");
    }
    static{
        this.SCMResourceGroupContext = new MenuId("SCMResourceGroupContext");
    }
    static{
        this.SCMSourceControl = new MenuId("SCMSourceControl");
    }
    static{
        this.SCMSourceControlInline = new MenuId("SCMSourceControlInline");
    }
    static{
        this.SCMSourceControlTitle = new MenuId("SCMSourceControlTitle");
    }
    static{
        this.SCMHistoryTitle = new MenuId("SCMHistoryTitle");
    }
    static{
        this.SCMTitle = new MenuId("SCMTitle");
    }
    static{
        this.SearchContext = new MenuId("SearchContext");
    }
    static{
        this.SearchActionMenu = new MenuId("SearchActionContext");
    }
    static{
        this.StatusBarWindowIndicatorMenu = new MenuId("StatusBarWindowIndicatorMenu");
    }
    static{
        this.StatusBarRemoteIndicatorMenu = new MenuId("StatusBarRemoteIndicatorMenu");
    }
    static{
        this.StickyScrollContext = new MenuId("StickyScrollContext");
    }
    static{
        this.TestItem = new MenuId("TestItem");
    }
    static{
        this.TestItemGutter = new MenuId("TestItemGutter");
    }
    static{
        this.TestProfilesContext = new MenuId("TestProfilesContext");
    }
    static{
        this.TestMessageContext = new MenuId("TestMessageContext");
    }
    static{
        this.TestMessageContent = new MenuId("TestMessageContent");
    }
    static{
        this.TestPeekElement = new MenuId("TestPeekElement");
    }
    static{
        this.TestPeekTitle = new MenuId("TestPeekTitle");
    }
    static{
        this.TestCallStack = new MenuId("TestCallStack");
    }
    static{
        this.TouchBarContext = new MenuId("TouchBarContext");
    }
    static{
        this.TitleBarContext = new MenuId("TitleBarContext");
    }
    static{
        this.TitleBarTitleContext = new MenuId("TitleBarTitleContext");
    }
    static{
        this.TunnelContext = new MenuId("TunnelContext");
    }
    static{
        this.TunnelPrivacy = new MenuId("TunnelPrivacy");
    }
    static{
        this.TunnelProtocol = new MenuId("TunnelProtocol");
    }
    static{
        this.TunnelPortInline = new MenuId("TunnelInline");
    }
    static{
        this.TunnelTitle = new MenuId("TunnelTitle");
    }
    static{
        this.TunnelLocalAddressInline = new MenuId("TunnelLocalAddressInline");
    }
    static{
        this.TunnelOriginInline = new MenuId("TunnelOriginInline");
    }
    static{
        this.ViewItemContext = new MenuId("ViewItemContext");
    }
    static{
        this.ViewContainerTitle = new MenuId("ViewContainerTitle");
    }
    static{
        this.ViewContainerTitleContext = new MenuId("ViewContainerTitleContext");
    }
    static{
        this.ViewTitle = new MenuId("ViewTitle");
    }
    static{
        this.ViewTitleContext = new MenuId("ViewTitleContext");
    }
    static{
        this.CommentEditorActions = new MenuId("CommentEditorActions");
    }
    static{
        this.CommentThreadTitle = new MenuId("CommentThreadTitle");
    }
    static{
        this.CommentThreadActions = new MenuId("CommentThreadActions");
    }
    static{
        this.CommentThreadAdditionalActions = new MenuId("CommentThreadAdditionalActions");
    }
    static{
        this.CommentThreadTitleContext = new MenuId("CommentThreadTitleContext");
    }
    static{
        this.CommentThreadCommentContext = new MenuId("CommentThreadCommentContext");
    }
    static{
        this.CommentTitle = new MenuId("CommentTitle");
    }
    static{
        this.CommentActions = new MenuId("CommentActions");
    }
    static{
        this.CommentsViewThreadActions = new MenuId("CommentsViewThreadActions");
    }
    static{
        this.InteractiveToolbar = new MenuId("InteractiveToolbar");
    }
    static{
        this.InteractiveCellTitle = new MenuId("InteractiveCellTitle");
    }
    static{
        this.InteractiveCellDelete = new MenuId("InteractiveCellDelete");
    }
    static{
        this.InteractiveCellExecute = new MenuId("InteractiveCellExecute");
    }
    static{
        this.InteractiveInputExecute = new MenuId("InteractiveInputExecute");
    }
    static{
        this.InteractiveInputConfig = new MenuId("InteractiveInputConfig");
    }
    static{
        this.ReplInputExecute = new MenuId("ReplInputExecute");
    }
    static{
        this.IssueReporter = new MenuId("IssueReporter");
    }
    static{
        this.NotebookToolbar = new MenuId("NotebookToolbar");
    }
    static{
        this.NotebookStickyScrollContext = new MenuId("NotebookStickyScrollContext");
    }
    static{
        this.NotebookCellTitle = new MenuId("NotebookCellTitle");
    }
    static{
        this.NotebookCellDelete = new MenuId("NotebookCellDelete");
    }
    static{
        this.NotebookCellInsert = new MenuId("NotebookCellInsert");
    }
    static{
        this.NotebookCellBetween = new MenuId("NotebookCellBetween");
    }
    static{
        this.NotebookCellListTop = new MenuId("NotebookCellTop");
    }
    static{
        this.NotebookCellExecute = new MenuId("NotebookCellExecute");
    }
    static{
        this.NotebookCellExecuteGoTo = new MenuId("NotebookCellExecuteGoTo");
    }
    static{
        this.NotebookCellExecutePrimary = new MenuId("NotebookCellExecutePrimary");
    }
    static{
        this.NotebookDiffCellInputTitle = new MenuId("NotebookDiffCellInputTitle");
    }
    static{
        this.NotebookDiffCellMetadataTitle = new MenuId("NotebookDiffCellMetadataTitle");
    }
    static{
        this.NotebookDiffCellOutputsTitle = new MenuId("NotebookDiffCellOutputsTitle");
    }
    static{
        this.NotebookOutputToolbar = new MenuId("NotebookOutputToolbar");
    }
    static{
        this.NotebookOutlineFilter = new MenuId("NotebookOutlineFilter");
    }
    static{
        this.NotebookOutlineActionMenu = new MenuId("NotebookOutlineActionMenu");
    }
    static{
        this.NotebookEditorLayoutConfigure = new MenuId("NotebookEditorLayoutConfigure");
    }
    static{
        this.NotebookKernelSource = new MenuId("NotebookKernelSource");
    }
    static{
        this.BulkEditTitle = new MenuId("BulkEditTitle");
    }
    static{
        this.BulkEditContext = new MenuId("BulkEditContext");
    }
    static{
        this.TimelineItemContext = new MenuId("TimelineItemContext");
    }
    static{
        this.TimelineTitle = new MenuId("TimelineTitle");
    }
    static{
        this.TimelineTitleContext = new MenuId("TimelineTitleContext");
    }
    static{
        this.TimelineFilterSubMenu = new MenuId("TimelineFilterSubMenu");
    }
    static{
        this.AccountsContext = new MenuId("AccountsContext");
    }
    static{
        this.SidebarTitle = new MenuId("SidebarTitle");
    }
    static{
        this.PanelTitle = new MenuId("PanelTitle");
    }
    static{
        this.AuxiliaryBarTitle = new MenuId("AuxiliaryBarTitle");
    }
    static{
        this.AuxiliaryBarHeader = new MenuId("AuxiliaryBarHeader");
    }
    static{
        this.TerminalInstanceContext = new MenuId("TerminalInstanceContext");
    }
    static{
        this.TerminalEditorInstanceContext = new MenuId("TerminalEditorInstanceContext");
    }
    static{
        this.TerminalNewDropdownContext = new MenuId("TerminalNewDropdownContext");
    }
    static{
        this.TerminalTabContext = new MenuId("TerminalTabContext");
    }
    static{
        this.TerminalTabEmptyAreaContext = new MenuId("TerminalTabEmptyAreaContext");
    }
    static{
        this.TerminalStickyScrollContext = new MenuId("TerminalStickyScrollContext");
    }
    static{
        this.WebviewContext = new MenuId("WebviewContext");
    }
    static{
        this.InlineCompletionsActions = new MenuId("InlineCompletionsActions");
    }
    static{
        this.InlineEditsActions = new MenuId("InlineEditsActions");
    }
    static{
        this.InlineEditActions = new MenuId("InlineEditActions");
    }
    static{
        this.NewFile = new MenuId("NewFile");
    }
    static{
        this.MergeInput1Toolbar = new MenuId("MergeToolbar1Toolbar");
    }
    static{
        this.MergeInput2Toolbar = new MenuId("MergeToolbar2Toolbar");
    }
    static{
        this.MergeBaseToolbar = new MenuId("MergeBaseToolbar");
    }
    static{
        this.MergeInputResultToolbar = new MenuId("MergeToolbarResultToolbar");
    }
    static{
        this.InlineSuggestionToolbar = new MenuId("InlineSuggestionToolbar");
    }
    static{
        this.InlineEditToolbar = new MenuId("InlineEditToolbar");
    }
    static{
        this.ChatContext = new MenuId("ChatContext");
    }
    static{
        this.ChatCodeBlock = new MenuId("ChatCodeblock");
    }
    static{
        this.ChatCompareBlock = new MenuId("ChatCompareBlock");
    }
    static{
        this.ChatMessageTitle = new MenuId("ChatMessageTitle");
    }
    static{
        this.ChatExecute = new MenuId("ChatExecute");
    }
    static{
        this.ChatExecuteSecondary = new MenuId("ChatExecuteSecondary");
    }
    static{
        this.ChatInputSide = new MenuId("ChatInputSide");
    }
    static{
        this.AccessibleView = new MenuId("AccessibleView");
    }
    static{
        this.MultiDiffEditorFileToolbar = new MenuId("MultiDiffEditorFileToolbar");
    }
    static{
        this.DiffEditorHunkToolbar = new MenuId("DiffEditorHunkToolbar");
    }
    static{
        this.DiffEditorSelectionToolbar = new MenuId("DiffEditorSelectionToolbar");
    }
    /**
     * Create a new `MenuId` with the unique identifier. Will throw if a menu
     * with the identifier already exists, use `MenuId.for(ident)` or a unique
     * identifier
     */ constructor(identifier){
        if (MenuId._instances.has(identifier)) throw new TypeError(`MenuId with identifier '${identifier}' already exists. Use MenuId.for(ident) or a unique identifier`);
        MenuId._instances.set(identifier, this);
        this.id = identifier;
    }
}
const IMenuService = (0, _instantiationJs.createDecorator)("menuService");
class MenuRegistryChangeEvent {
    static{
        this._all = new Map();
    }
    static for(id) {
        let value = this._all.get(id);
        if (!value) {
            value = new MenuRegistryChangeEvent(id);
            this._all.set(id, value);
        }
        return value;
    }
    static merge(events) {
        const ids = new Set();
        for (const item of events)if (item instanceof MenuRegistryChangeEvent) ids.add(item.id);
        return ids;
    }
    constructor(id){
        this.id = id;
        this.has = (candidate)=>candidate === id;
    }
}
const MenuRegistry = new class {
    constructor(){
        this._commands = new Map();
        this._menuItems = new Map();
        this._onDidChangeMenu = new (0, _eventJs.MicrotaskEmitter)({
            merge: MenuRegistryChangeEvent.merge
        });
        this.onDidChangeMenu = this._onDidChangeMenu.event;
    }
    addCommand(command) {
        this._commands.set(command.id, command);
        this._onDidChangeMenu.fire(MenuRegistryChangeEvent.for(MenuId.CommandPalette));
        return (0, _lifecycleJs.toDisposable)(()=>{
            if (this._commands.delete(command.id)) this._onDidChangeMenu.fire(MenuRegistryChangeEvent.for(MenuId.CommandPalette));
        });
    }
    getCommand(id) {
        return this._commands.get(id);
    }
    getCommands() {
        const map = new Map();
        this._commands.forEach((value, key)=>map.set(key, value));
        return map;
    }
    appendMenuItem(id, item) {
        let list = this._menuItems.get(id);
        if (!list) {
            list = new (0, _linkedListJs.LinkedList)();
            this._menuItems.set(id, list);
        }
        const rm = list.push(item);
        this._onDidChangeMenu.fire(MenuRegistryChangeEvent.for(id));
        return (0, _lifecycleJs.toDisposable)(()=>{
            rm();
            this._onDidChangeMenu.fire(MenuRegistryChangeEvent.for(id));
        });
    }
    appendMenuItems(items) {
        const result = new (0, _lifecycleJs.DisposableStore)();
        for (const { id, item } of items)result.add(this.appendMenuItem(id, item));
        return result;
    }
    getMenuItems(id) {
        let result;
        if (this._menuItems.has(id)) result = [
            ...this._menuItems.get(id)
        ];
        else result = [];
        if (id === MenuId.CommandPalette) // CommandPalette is special because it shows
        // all commands by default
        this._appendImplicitItems(result);
        return result;
    }
    _appendImplicitItems(result) {
        const set = new Set();
        for (const item of result)if (isIMenuItem(item)) {
            set.add(item.command.id);
            if (item.alt) set.add(item.alt.id);
        }
        this._commands.forEach((command, id)=>{
            if (!set.has(id)) result.push({
                command
            });
        });
    }
};
class SubmenuItemAction extends (0, _actionsJs.SubmenuAction) {
    constructor(item, hideActions, actions){
        super(`submenuitem.${item.submenu.id}`, typeof item.title === "string" ? item.title : item.title.value, actions, "submenu");
        this.item = item;
        this.hideActions = hideActions;
    }
}
// implements IAction, does NOT extend Action, so that no one
// subscribes to events of Action or modified properties
let MenuItemAction = MenuItemAction_1 = class MenuItemAction {
    static label(action, options) {
        return options?.renderShortTitle && action.shortTitle ? typeof action.shortTitle === "string" ? action.shortTitle : action.shortTitle.value : typeof action.title === "string" ? action.title : action.title.value;
    }
    constructor(item, alt, options, hideActions, menuKeybinding, contextKeyService, _commandService){
        this.hideActions = hideActions;
        this.menuKeybinding = menuKeybinding;
        this._commandService = _commandService;
        this.id = item.id;
        this.label = MenuItemAction_1.label(item, options);
        this.tooltip = (typeof item.tooltip === "string" ? item.tooltip : item.tooltip?.value) ?? "";
        this.enabled = !item.precondition || contextKeyService.contextMatchesRules(item.precondition);
        this.checked = undefined;
        let icon;
        if (item.toggled) {
            const toggled = item.toggled.condition ? item.toggled : {
                condition: item.toggled
            };
            this.checked = contextKeyService.contextMatchesRules(toggled.condition);
            if (this.checked && toggled.tooltip) this.tooltip = typeof toggled.tooltip === "string" ? toggled.tooltip : toggled.tooltip.value;
            if (this.checked && (0, _themablesJs.ThemeIcon).isThemeIcon(toggled.icon)) icon = toggled.icon;
            if (this.checked && toggled.title) this.label = typeof toggled.title === "string" ? toggled.title : toggled.title.value;
        }
        if (!icon) icon = (0, _themablesJs.ThemeIcon).isThemeIcon(item.icon) ? item.icon : undefined;
        this.item = item;
        this.alt = alt ? new MenuItemAction_1(alt, undefined, options, hideActions, undefined, contextKeyService, _commandService) : undefined;
        this._options = options;
        this.class = icon && (0, _themablesJs.ThemeIcon).asClassName(icon);
    }
    run(...args) {
        let runArgs = [];
        if (this._options?.arg) runArgs = [
            ...runArgs,
            this._options.arg
        ];
        if (this._options?.shouldForwardArgs) runArgs = [
            ...runArgs,
            ...args
        ];
        return this._commandService.executeCommand(this.id, ...runArgs);
    }
};
MenuItemAction = MenuItemAction_1 = __decorate([
    __param(5, (0, _contextkeyJs.IContextKeyService)),
    __param(6, (0, _commandsJs.ICommandService))
], MenuItemAction);
class Action2 {
    constructor(desc){
        this.desc = desc;
    }
}
function registerAction2(ctor) {
    const disposables = []; // not using `DisposableStore` to reduce startup perf cost
    const action = new ctor();
    const { f1, menu, keybinding, ...command } = action.desc;
    if ((0, _commandsJs.CommandsRegistry).getCommand(command.id)) throw new Error(`Cannot register two commands with the same id: ${command.id}`);
    // command
    disposables.push((0, _commandsJs.CommandsRegistry).registerCommand({
        id: command.id,
        handler: (accessor, ...args)=>action.run(accessor, ...args),
        metadata: command.metadata
    }));
    // menu
    if (Array.isArray(menu)) for (const item of menu)disposables.push(MenuRegistry.appendMenuItem(item.id, {
        command: {
            ...command,
            precondition: item.precondition === null ? undefined : command.precondition
        },
        ...item
    }));
    else if (menu) disposables.push(MenuRegistry.appendMenuItem(menu.id, {
        command: {
            ...command,
            precondition: menu.precondition === null ? undefined : command.precondition
        },
        ...menu
    }));
    if (f1) {
        disposables.push(MenuRegistry.appendMenuItem(MenuId.CommandPalette, {
            command,
            when: command.precondition
        }));
        disposables.push(MenuRegistry.addCommand(command));
    }
    // keybinding
    if (Array.isArray(keybinding)) for (const item of keybinding)disposables.push((0, _keybindingsRegistryJs.KeybindingsRegistry).registerKeybindingRule({
        ...item,
        id: command.id,
        when: command.precondition ? (0, _contextkeyJs.ContextKeyExpr).and(command.precondition, item.when) : item.when
    }));
    else if (keybinding) disposables.push((0, _keybindingsRegistryJs.KeybindingsRegistry).registerKeybindingRule({
        ...keybinding,
        id: command.id,
        when: command.precondition ? (0, _contextkeyJs.ContextKeyExpr).and(command.precondition, keybinding.when) : keybinding.when
    }));
    return {
        dispose () {
            (0, _lifecycleJs.dispose)(disposables);
        }
    };
}

},{"../../../base/common/actions.js":"5GjLb","../../../base/common/themables.js":"hgyHi","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/linkedList.js":"kv7Rg","../../commands/common/commands.js":"ho6ic","../../contextkey/common/contextkey.js":"gXuBD","../../instantiation/common/instantiation.js":"fjwWx","../../keybinding/common/keybindingsRegistry.js":"h9qfk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5GjLb":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "ActionRunner", ()=>ActionRunner);
parcelHelpers.export(exports, "Separator", ()=>Separator);
parcelHelpers.export(exports, "SubmenuAction", ()=>SubmenuAction);
parcelHelpers.export(exports, "EmptySubmenuAction", ()=>EmptySubmenuAction);
parcelHelpers.export(exports, "toAction", ()=>toAction);
var _eventJs = require("./event.js");
var _lifecycleJs = require("./lifecycle.js");
var _nlsJs = require("../../nls.js");
class Action extends (0, _lifecycleJs.Disposable) {
    constructor(id, label = "", cssClass = "", enabled = true, actionCallback){
        super();
        this._onDidChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidChange = this._onDidChange.event;
        this._enabled = true;
        this._id = id;
        this._label = label;
        this._cssClass = cssClass;
        this._enabled = enabled;
        this._actionCallback = actionCallback;
    }
    get id() {
        return this._id;
    }
    get label() {
        return this._label;
    }
    set label(value) {
        this._setLabel(value);
    }
    _setLabel(value) {
        if (this._label !== value) {
            this._label = value;
            this._onDidChange.fire({
                label: value
            });
        }
    }
    get tooltip() {
        return this._tooltip || "";
    }
    set tooltip(value) {
        this._setTooltip(value);
    }
    _setTooltip(value) {
        if (this._tooltip !== value) {
            this._tooltip = value;
            this._onDidChange.fire({
                tooltip: value
            });
        }
    }
    get class() {
        return this._cssClass;
    }
    set class(value) {
        this._setClass(value);
    }
    _setClass(value) {
        if (this._cssClass !== value) {
            this._cssClass = value;
            this._onDidChange.fire({
                class: value
            });
        }
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        this._setEnabled(value);
    }
    _setEnabled(value) {
        if (this._enabled !== value) {
            this._enabled = value;
            this._onDidChange.fire({
                enabled: value
            });
        }
    }
    get checked() {
        return this._checked;
    }
    set checked(value) {
        this._setChecked(value);
    }
    _setChecked(value) {
        if (this._checked !== value) {
            this._checked = value;
            this._onDidChange.fire({
                checked: value
            });
        }
    }
    async run(event, data) {
        if (this._actionCallback) await this._actionCallback(event);
    }
}
class ActionRunner extends (0, _lifecycleJs.Disposable) {
    constructor(){
        super(...arguments);
        this._onWillRun = this._register(new (0, _eventJs.Emitter)());
        this.onWillRun = this._onWillRun.event;
        this._onDidRun = this._register(new (0, _eventJs.Emitter)());
        this.onDidRun = this._onDidRun.event;
    }
    async run(action, context) {
        if (!action.enabled) return;
        this._onWillRun.fire({
            action
        });
        let error = undefined;
        try {
            await this.runAction(action, context);
        } catch (e) {
            error = e;
        }
        this._onDidRun.fire({
            action,
            error
        });
    }
    async runAction(action, context) {
        await action.run(context);
    }
}
class Separator {
    constructor(){
        this.id = Separator.ID;
        this.label = "";
        this.tooltip = "";
        this.class = "separator";
        this.enabled = false;
        this.checked = false;
    }
    /**
     * Joins all non-empty lists of actions with separators.
     */ static join(...actionLists) {
        let out = [];
        for (const list of actionLists){
            if (!list.length) ;
            else if (out.length) out = [
                ...out,
                new Separator(),
                ...list
            ];
            else out = list;
        }
        return out;
    }
    static{
        this.ID = "vs.actions.separator";
    }
    async run() {}
}
class SubmenuAction {
    get actions() {
        return this._actions;
    }
    constructor(id, label, actions, cssClass){
        this.tooltip = "";
        this.enabled = true;
        this.checked = undefined;
        this.id = id;
        this.label = label;
        this.class = cssClass;
        this._actions = actions;
    }
    async run() {}
}
class EmptySubmenuAction extends Action {
    static{
        this.ID = "vs.actions.empty";
    }
    constructor(){
        super(EmptySubmenuAction.ID, _nlsJs.localize("submenu.empty", "(empty)"), undefined, false);
    }
}
function toAction(props) {
    return {
        id: props.id,
        label: props.label,
        tooltip: props.tooltip ?? props.label,
        class: props.class,
        enabled: props.enabled ?? true,
        checked: props.checked,
        run: async (...args)=>props.run(...args)
    };
}

},{"./event.js":"4Zi8b","./lifecycle.js":"9kg8d","../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hgyHi":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeColor", ()=>ThemeColor);
parcelHelpers.export(exports, "ThemeIcon", ()=>ThemeIcon);
var _codiconsJs = require("./codicons.js");
var ThemeColor;
(function(ThemeColor) {
    function isThemeColor(obj) {
        return obj && typeof obj === "object" && typeof obj.id === "string";
    }
    ThemeColor.isThemeColor = isThemeColor;
})(ThemeColor || (ThemeColor = {}));
var ThemeIcon;
(function(ThemeIcon) {
    ThemeIcon.iconNameSegment = "[A-Za-z0-9]+";
    ThemeIcon.iconNameExpression = "[A-Za-z0-9-]+";
    ThemeIcon.iconModifierExpression = "~[A-Za-z]+";
    ThemeIcon.iconNameCharacter = "[A-Za-z0-9~-]";
    const ThemeIconIdRegex = new RegExp(`^(${ThemeIcon.iconNameExpression})(${ThemeIcon.iconModifierExpression})?$`);
    function asClassNameArray(icon) {
        const match = ThemeIconIdRegex.exec(icon.id);
        if (!match) return asClassNameArray((0, _codiconsJs.Codicon).error);
        const [, id, modifier] = match;
        const classNames = [
            "codicon",
            "codicon-" + id
        ];
        if (modifier) classNames.push("codicon-modifier-" + modifier.substring(1));
        return classNames;
    }
    ThemeIcon.asClassNameArray = asClassNameArray;
    function asClassName(icon) {
        return asClassNameArray(icon).join(" ");
    }
    ThemeIcon.asClassName = asClassName;
    function asCSSSelector(icon) {
        return "." + asClassNameArray(icon).join(".");
    }
    ThemeIcon.asCSSSelector = asCSSSelector;
    function isThemeIcon(obj) {
        return obj && typeof obj === "object" && typeof obj.id === "string" && (typeof obj.color === "undefined" || ThemeColor.isThemeColor(obj.color));
    }
    ThemeIcon.isThemeIcon = isThemeIcon;
    const _regexFromString = new RegExp(`^\\$\\((${ThemeIcon.iconNameExpression}(?:${ThemeIcon.iconModifierExpression})?)\\)$`);
    function fromString(str) {
        const match = _regexFromString.exec(str);
        if (!match) return undefined;
        const [, name] = match;
        return {
            id: name
        };
    }
    ThemeIcon.fromString = fromString;
    function fromId(id) {
        return {
            id
        };
    }
    ThemeIcon.fromId = fromId;
    function modify(icon, modifier) {
        let id = icon.id;
        const tildeIndex = id.lastIndexOf("~");
        if (tildeIndex !== -1) id = id.substring(0, tildeIndex);
        if (modifier) id = `${id}~${modifier}`;
        return {
            id
        };
    }
    ThemeIcon.modify = modify;
    function getModifier(icon) {
        const tildeIndex = icon.id.lastIndexOf("~");
        if (tildeIndex !== -1) return icon.id.substring(tildeIndex + 1);
        return undefined;
    }
    ThemeIcon.getModifier = getModifier;
    function isEqual(ti1, ti2) {
        return ti1.id === ti2.id && ti1.color?.id === ti2.color?.id;
    }
    ThemeIcon.isEqual = isEqual;
})(ThemeIcon || (ThemeIcon = {}));

},{"./codicons.js":"hWYNf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ho6ic":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ICommandService", ()=>ICommandService);
parcelHelpers.export(exports, "CommandsRegistry", ()=>CommandsRegistry);
var _eventJs = require("../../../base/common/event.js");
var _iteratorJs = require("../../../base/common/iterator.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _linkedListJs = require("../../../base/common/linkedList.js");
var _typesJs = require("../../../base/common/types.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const ICommandService = (0, _instantiationJs.createDecorator)("commandService");
const CommandsRegistry = new class {
    constructor(){
        this._commands = new Map();
        this._onDidRegisterCommand = new (0, _eventJs.Emitter)();
        this.onDidRegisterCommand = this._onDidRegisterCommand.event;
    }
    registerCommand(idOrCommand, handler) {
        if (!idOrCommand) throw new Error(`invalid command`);
        if (typeof idOrCommand === "string") {
            if (!handler) throw new Error(`invalid command`);
            return this.registerCommand({
                id: idOrCommand,
                handler
            });
        }
        // add argument validation if rich command metadata is provided
        if (idOrCommand.metadata && Array.isArray(idOrCommand.metadata.args)) {
            const constraints = [];
            for (const arg of idOrCommand.metadata.args)constraints.push(arg.constraint);
            const actualHandler = idOrCommand.handler;
            idOrCommand.handler = function(accessor, ...args) {
                (0, _typesJs.validateConstraints)(args, constraints);
                return actualHandler(accessor, ...args);
            };
        }
        // find a place to store the command
        const { id } = idOrCommand;
        let commands = this._commands.get(id);
        if (!commands) {
            commands = new (0, _linkedListJs.LinkedList)();
            this._commands.set(id, commands);
        }
        const removeFn = commands.unshift(idOrCommand);
        const ret = (0, _lifecycleJs.toDisposable)(()=>{
            removeFn();
            const command = this._commands.get(id);
            if (command?.isEmpty()) this._commands.delete(id);
        });
        // tell the world about this command
        this._onDidRegisterCommand.fire(id);
        return ret;
    }
    registerCommandAlias(oldId, newId) {
        return CommandsRegistry.registerCommand(oldId, (accessor, ...args)=>accessor.get(ICommandService).executeCommand(newId, ...args));
    }
    getCommand(id) {
        const list = this._commands.get(id);
        if (!list || list.isEmpty()) return undefined;
        return (0, _iteratorJs.Iterable).first(list);
    }
    getCommands() {
        const result = new Map();
        for (const key of this._commands.keys()){
            const command = this.getCommand(key);
            if (command) result.set(key, command);
        }
        return result;
    }
};
CommandsRegistry.registerCommand("noop", ()=>{});

},{"../../../base/common/event.js":"4Zi8b","../../../base/common/iterator.js":"2FiS0","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/linkedList.js":"kv7Rg","../../../base/common/types.js":"fb5yx","../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gXuBD":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A parser for context key expressions.
 *
 * Example:
 * ```ts
 * const parser = new Parser();
 * const expr = parser.parse('foo == "bar" && baz == true');
 *
 * if (expr === undefined) {
 * 	// there were lexing or parsing errors
 * 	// process lexing errors with `parser.lexingErrors`
 *  // process parsing errors with `parser.parsingErrors`
 * } else {
 * 	// expr is a valid expression
 * }
 * ```
 */ parcelHelpers.export(exports, "Parser", ()=>Parser);
parcelHelpers.export(exports, "ContextKeyExpr", ()=>ContextKeyExpr);
parcelHelpers.export(exports, "expressionsAreEqualWithConstantSubstitution", ()=>expressionsAreEqualWithConstantSubstitution);
parcelHelpers.export(exports, "ContextKeyFalseExpr", ()=>ContextKeyFalseExpr);
parcelHelpers.export(exports, "ContextKeyTrueExpr", ()=>ContextKeyTrueExpr);
parcelHelpers.export(exports, "ContextKeyDefinedExpr", ()=>ContextKeyDefinedExpr);
parcelHelpers.export(exports, "ContextKeyEqualsExpr", ()=>ContextKeyEqualsExpr);
parcelHelpers.export(exports, "ContextKeyInExpr", ()=>ContextKeyInExpr);
parcelHelpers.export(exports, "ContextKeyNotInExpr", ()=>ContextKeyNotInExpr);
parcelHelpers.export(exports, "ContextKeyNotEqualsExpr", ()=>ContextKeyNotEqualsExpr);
parcelHelpers.export(exports, "ContextKeyNotExpr", ()=>ContextKeyNotExpr);
parcelHelpers.export(exports, "ContextKeyGreaterExpr", ()=>ContextKeyGreaterExpr);
parcelHelpers.export(exports, "ContextKeyGreaterEqualsExpr", ()=>ContextKeyGreaterEqualsExpr);
parcelHelpers.export(exports, "ContextKeySmallerExpr", ()=>ContextKeySmallerExpr);
parcelHelpers.export(exports, "ContextKeySmallerEqualsExpr", ()=>ContextKeySmallerEqualsExpr);
parcelHelpers.export(exports, "ContextKeyRegexExpr", ()=>ContextKeyRegexExpr);
parcelHelpers.export(exports, "ContextKeyNotRegexExpr", ()=>ContextKeyNotRegexExpr);
parcelHelpers.export(exports, "ContextKeyAndExpr", ()=>ContextKeyAndExpr);
parcelHelpers.export(exports, "ContextKeyOrExpr", ()=>ContextKeyOrExpr);
parcelHelpers.export(exports, "RawContextKey", ()=>RawContextKey);
parcelHelpers.export(exports, "IContextKeyService", ()=>IContextKeyService);
/**
 * Returns true if it is provable `p` implies `q`.
 */ parcelHelpers.export(exports, "implies", ()=>implies);
var _platformJs = require("../../../base/common/platform.js");
var _stringsJs = require("../../../base/common/strings.js");
var _scannerJs = require("./scanner.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var _nlsJs = require("../../../nls.js");
const CONSTANT_VALUES = new Map();
CONSTANT_VALUES.set("false", false);
CONSTANT_VALUES.set("true", true);
CONSTANT_VALUES.set("isMac", (0, _platformJs.isMacintosh));
CONSTANT_VALUES.set("isLinux", (0, _platformJs.isLinux));
CONSTANT_VALUES.set("isWindows", (0, _platformJs.isWindows));
CONSTANT_VALUES.set("isWeb", (0, _platformJs.isWeb));
CONSTANT_VALUES.set("isMacNative", (0, _platformJs.isMacintosh) && !(0, _platformJs.isWeb));
CONSTANT_VALUES.set("isEdge", (0, _platformJs.isEdge));
CONSTANT_VALUES.set("isFirefox", (0, _platformJs.isFirefox));
CONSTANT_VALUES.set("isChrome", (0, _platformJs.isChrome));
CONSTANT_VALUES.set("isSafari", (0, _platformJs.isSafari));
const hasOwnProperty = Object.prototype.hasOwnProperty;
const defaultConfig = {
    regexParsingWithErrorRecovery: true
};
const errorEmptyString = (0, _nlsJs.localize)("contextkey.parser.error.emptyString", "Empty context key expression");
const hintEmptyString = (0, _nlsJs.localize)("contextkey.parser.error.emptyString.hint", "Did you forget to write an expression? You can also put 'false' or 'true' to always evaluate to false or true, respectively.");
const errorNoInAfterNot = (0, _nlsJs.localize)("contextkey.parser.error.noInAfterNot", "'in' after 'not'.");
const errorClosingParenthesis = (0, _nlsJs.localize)("contextkey.parser.error.closingParenthesis", "closing parenthesis ')'");
const errorUnexpectedToken = (0, _nlsJs.localize)("contextkey.parser.error.unexpectedToken", "Unexpected token");
const hintUnexpectedToken = (0, _nlsJs.localize)("contextkey.parser.error.unexpectedToken.hint", "Did you forget to put && or || before the token?");
const errorUnexpectedEOF = (0, _nlsJs.localize)("contextkey.parser.error.unexpectedEOF", "Unexpected end of expression");
const hintUnexpectedEOF = (0, _nlsJs.localize)("contextkey.parser.error.unexpectedEOF.hint", "Did you forget to put a context key?");
class Parser {
    // Note: this doesn't produce an exact syntax tree but a normalized one
    // ContextKeyExpression's that we use as AST nodes do not expose constructors that do not normalize
    static{
        this._parseError = new Error();
    }
    constructor(_config = defaultConfig){
        this._config = _config;
        // lifetime note: `_scanner` lives as long as the parser does, i.e., is not reset between calls to `parse`
        this._scanner = new (0, _scannerJs.Scanner)();
        // lifetime note: `_tokens`, `_current`, and `_parsingErrors` must be reset between calls to `parse`
        this._tokens = [];
        this._current = 0; // invariant: 0 <= this._current < this._tokens.length ; any incrementation of this value must first call `_isAtEnd`
        this._parsingErrors = [];
        this._flagsGYRe = /g|y/g;
    }
    /**
     * Parse a context key expression.
     *
     * @param input the expression to parse
     * @returns the parsed expression or `undefined` if there's an error - call `lexingErrors` and `parsingErrors` to see the errors
     */ parse(input) {
        if (input === "") {
            this._parsingErrors.push({
                message: errorEmptyString,
                offset: 0,
                lexeme: "",
                additionalInfo: hintEmptyString
            });
            return undefined;
        }
        this._tokens = this._scanner.reset(input).scan();
        // @ulugbekna: we do not stop parsing if there are lexing errors to be able to reconstruct regexes with unescaped slashes; TODO@ulugbekna: make this respect config option for recovery
        this._current = 0;
        this._parsingErrors = [];
        try {
            const expr = this._expr();
            if (!this._isAtEnd()) {
                const peek = this._peek();
                const additionalInfo = peek.type === 17 /* TokenType.Str */  ? hintUnexpectedToken : undefined;
                this._parsingErrors.push({
                    message: errorUnexpectedToken,
                    offset: peek.offset,
                    lexeme: (0, _scannerJs.Scanner).getLexeme(peek),
                    additionalInfo
                });
                throw Parser._parseError;
            }
            return expr;
        } catch (e) {
            if (!(e === Parser._parseError)) throw e;
            return undefined;
        }
    }
    _expr() {
        return this._or();
    }
    _or() {
        const expr = [
            this._and()
        ];
        while(this._matchOne(16 /* TokenType.Or */ )){
            const right = this._and();
            expr.push(right);
        }
        return expr.length === 1 ? expr[0] : ContextKeyExpr.or(...expr);
    }
    _and() {
        const expr = [
            this._term()
        ];
        while(this._matchOne(15 /* TokenType.And */ )){
            const right = this._term();
            expr.push(right);
        }
        return expr.length === 1 ? expr[0] : ContextKeyExpr.and(...expr);
    }
    _term() {
        if (this._matchOne(2 /* TokenType.Neg */ )) {
            const peek = this._peek();
            switch(peek.type){
                case 11 /* TokenType.True */ :
                    this._advance();
                    return ContextKeyFalseExpr.INSTANCE;
                case 12 /* TokenType.False */ :
                    this._advance();
                    return ContextKeyTrueExpr.INSTANCE;
                case 0 /* TokenType.LParen */ :
                    {
                        this._advance();
                        const expr = this._expr();
                        this._consume(1 /* TokenType.RParen */ , errorClosingParenthesis);
                        return expr?.negate();
                    }
                case 17 /* TokenType.Str */ :
                    this._advance();
                    return ContextKeyNotExpr.create(peek.lexeme);
                default:
                    throw this._errExpectedButGot(`KEY | true | false | '(' expression ')'`, peek);
            }
        }
        return this._primary();
    }
    _primary() {
        const peek = this._peek();
        switch(peek.type){
            case 11 /* TokenType.True */ :
                this._advance();
                return ContextKeyExpr.true();
            case 12 /* TokenType.False */ :
                this._advance();
                return ContextKeyExpr.false();
            case 0 /* TokenType.LParen */ :
                {
                    this._advance();
                    const expr = this._expr();
                    this._consume(1 /* TokenType.RParen */ , errorClosingParenthesis);
                    return expr;
                }
            case 17 /* TokenType.Str */ :
                {
                    // KEY
                    const key = peek.lexeme;
                    this._advance();
                    // =~ regex
                    if (this._matchOne(9 /* TokenType.RegexOp */ )) {
                        // @ulugbekna: we need to reconstruct the regex from the tokens because some extensions use unescaped slashes in regexes
                        const expr = this._peek();
                        if (!this._config.regexParsingWithErrorRecovery) {
                            this._advance();
                            if (expr.type !== 10 /* TokenType.RegexStr */ ) throw this._errExpectedButGot(`REGEX`, expr);
                            const regexLexeme = expr.lexeme;
                            const closingSlashIndex = regexLexeme.lastIndexOf("/");
                            const flags = closingSlashIndex === regexLexeme.length - 1 ? undefined : this._removeFlagsGY(regexLexeme.substring(closingSlashIndex + 1));
                            let regexp;
                            try {
                                regexp = new RegExp(regexLexeme.substring(1, closingSlashIndex), flags);
                            } catch (e) {
                                throw this._errExpectedButGot(`REGEX`, expr);
                            }
                            return ContextKeyRegexExpr.create(key, regexp);
                        }
                        switch(expr.type){
                            case 10 /* TokenType.RegexStr */ :
                            case 19 /* TokenType.Error */ :
                                {
                                    const lexemeReconstruction = [
                                        expr.lexeme
                                    ]; // /REGEX/ or /REGEX/FLAGS
                                    this._advance();
                                    let followingToken = this._peek();
                                    let parenBalance = 0;
                                    for(let i = 0; i < expr.lexeme.length; i++){
                                        if (expr.lexeme.charCodeAt(i) === 40 /* CharCode.OpenParen */ ) parenBalance++;
                                        else if (expr.lexeme.charCodeAt(i) === 41 /* CharCode.CloseParen */ ) parenBalance--;
                                    }
                                    while(!this._isAtEnd() && followingToken.type !== 15 /* TokenType.And */  && followingToken.type !== 16 /* TokenType.Or */ ){
                                        switch(followingToken.type){
                                            case 0 /* TokenType.LParen */ :
                                                parenBalance++;
                                                break;
                                            case 1 /* TokenType.RParen */ :
                                                parenBalance--;
                                                break;
                                            case 10 /* TokenType.RegexStr */ :
                                            case 18 /* TokenType.QuotedStr */ :
                                                for(let i = 0; i < followingToken.lexeme.length; i++){
                                                    if (followingToken.lexeme.charCodeAt(i) === 40 /* CharCode.OpenParen */ ) parenBalance++;
                                                    else if (expr.lexeme.charCodeAt(i) === 41 /* CharCode.CloseParen */ ) parenBalance--;
                                                }
                                        }
                                        if (parenBalance < 0) break;
                                        lexemeReconstruction.push((0, _scannerJs.Scanner).getLexeme(followingToken));
                                        this._advance();
                                        followingToken = this._peek();
                                    }
                                    const regexLexeme = lexemeReconstruction.join("");
                                    const closingSlashIndex = regexLexeme.lastIndexOf("/");
                                    const flags = closingSlashIndex === regexLexeme.length - 1 ? undefined : this._removeFlagsGY(regexLexeme.substring(closingSlashIndex + 1));
                                    let regexp;
                                    try {
                                        regexp = new RegExp(regexLexeme.substring(1, closingSlashIndex), flags);
                                    } catch (e) {
                                        throw this._errExpectedButGot(`REGEX`, expr);
                                    }
                                    return ContextKeyExpr.regex(key, regexp);
                                }
                            case 18 /* TokenType.QuotedStr */ :
                                {
                                    const serializedValue = expr.lexeme;
                                    this._advance();
                                    // replicate old regex parsing behavior
                                    let regex = null;
                                    if (!(0, _stringsJs.isFalsyOrWhitespace)(serializedValue)) {
                                        const start = serializedValue.indexOf("/");
                                        const end = serializedValue.lastIndexOf("/");
                                        if (start !== end && start >= 0) {
                                            const value = serializedValue.slice(start + 1, end);
                                            const caseIgnoreFlag = serializedValue[end + 1] === "i" ? "i" : "";
                                            try {
                                                regex = new RegExp(value, caseIgnoreFlag);
                                            } catch (_e) {
                                                throw this._errExpectedButGot(`REGEX`, expr);
                                            }
                                        }
                                    }
                                    if (regex === null) throw this._errExpectedButGot("REGEX", expr);
                                    return ContextKeyRegexExpr.create(key, regex);
                                }
                            default:
                                throw this._errExpectedButGot("REGEX", this._peek());
                        }
                    }
                    // [ 'not' 'in' value ]
                    if (this._matchOne(14 /* TokenType.Not */ )) {
                        this._consume(13 /* TokenType.In */ , errorNoInAfterNot);
                        const right = this._value();
                        return ContextKeyExpr.notIn(key, right);
                    }
                    // [ ('==' | '!=' | '<' | '<=' | '>' | '>=' | 'in') value ]
                    const maybeOp = this._peek().type;
                    switch(maybeOp){
                        case 3 /* TokenType.Eq */ :
                            {
                                this._advance();
                                const right = this._value();
                                if (this._previous().type === 18 /* TokenType.QuotedStr */ ) return ContextKeyExpr.equals(key, right);
                                switch(right){
                                    case "true":
                                        return ContextKeyExpr.has(key);
                                    case "false":
                                        return ContextKeyExpr.not(key);
                                    default:
                                        return ContextKeyExpr.equals(key, right);
                                }
                            }
                        case 4 /* TokenType.NotEq */ :
                            {
                                this._advance();
                                const right = this._value();
                                if (this._previous().type === 18 /* TokenType.QuotedStr */ ) return ContextKeyExpr.notEquals(key, right);
                                switch(right){
                                    case "true":
                                        return ContextKeyExpr.not(key);
                                    case "false":
                                        return ContextKeyExpr.has(key);
                                    default:
                                        return ContextKeyExpr.notEquals(key, right);
                                }
                            }
                        // TODO: ContextKeyExpr.smaller(key, right) accepts only `number` as `right` AND during eval of this node, we just eval to `false` if `right` is not a number
                        // consequently, package.json linter should _warn_ the user if they're passing undesired things to ops
                        case 5 /* TokenType.Lt */ :
                            this._advance();
                            return ContextKeySmallerExpr.create(key, this._value());
                        case 6 /* TokenType.LtEq */ :
                            this._advance();
                            return ContextKeySmallerEqualsExpr.create(key, this._value());
                        case 7 /* TokenType.Gt */ :
                            this._advance();
                            return ContextKeyGreaterExpr.create(key, this._value());
                        case 8 /* TokenType.GtEq */ :
                            this._advance();
                            return ContextKeyGreaterEqualsExpr.create(key, this._value());
                        case 13 /* TokenType.In */ :
                            this._advance();
                            return ContextKeyExpr.in(key, this._value());
                        default:
                            return ContextKeyExpr.has(key);
                    }
                }
            case 20 /* TokenType.EOF */ :
                this._parsingErrors.push({
                    message: errorUnexpectedEOF,
                    offset: peek.offset,
                    lexeme: "",
                    additionalInfo: hintUnexpectedEOF
                });
                throw Parser._parseError;
            default:
                throw this._errExpectedButGot(`true | false | KEY \n\t| KEY '=~' REGEX \n\t| KEY ('==' | '!=' | '<' | '<=' | '>' | '>=' | 'in' | 'not' 'in') value`, this._peek());
        }
    }
    _value() {
        const token = this._peek();
        switch(token.type){
            case 17 /* TokenType.Str */ :
            case 18 /* TokenType.QuotedStr */ :
                this._advance();
                return token.lexeme;
            case 11 /* TokenType.True */ :
                this._advance();
                return "true";
            case 12 /* TokenType.False */ :
                this._advance();
                return "false";
            case 13 /* TokenType.In */ :
                this._advance();
                return "in";
            default:
                // this allows "when": "foo == " which's used by existing extensions
                // we do not call `_advance` on purpose - we don't want to eat unintended tokens
                return "";
        }
    }
    _removeFlagsGY(flags) {
        return flags.replaceAll(this._flagsGYRe, "");
    }
    // careful: this can throw if current token is the initial one (ie index = 0)
    _previous() {
        return this._tokens[this._current - 1];
    }
    _matchOne(token) {
        if (this._check(token)) {
            this._advance();
            return true;
        }
        return false;
    }
    _advance() {
        if (!this._isAtEnd()) this._current++;
        return this._previous();
    }
    _consume(type, message) {
        if (this._check(type)) return this._advance();
        throw this._errExpectedButGot(message, this._peek());
    }
    _errExpectedButGot(expected, got, additionalInfo) {
        const message = (0, _nlsJs.localize)("contextkey.parser.error.expectedButGot", "Expected: {0}\nReceived: '{1}'.", expected, (0, _scannerJs.Scanner).getLexeme(got));
        const offset = got.offset;
        const lexeme = (0, _scannerJs.Scanner).getLexeme(got);
        this._parsingErrors.push({
            message,
            offset,
            lexeme,
            additionalInfo
        });
        return Parser._parseError;
    }
    _check(type) {
        return this._peek().type === type;
    }
    _peek() {
        return this._tokens[this._current];
    }
    _isAtEnd() {
        return this._peek().type === 20 /* TokenType.EOF */ ;
    }
}
class ContextKeyExpr {
    static false() {
        return ContextKeyFalseExpr.INSTANCE;
    }
    static true() {
        return ContextKeyTrueExpr.INSTANCE;
    }
    static has(key) {
        return ContextKeyDefinedExpr.create(key);
    }
    static equals(key, value) {
        return ContextKeyEqualsExpr.create(key, value);
    }
    static notEquals(key, value) {
        return ContextKeyNotEqualsExpr.create(key, value);
    }
    static regex(key, value) {
        return ContextKeyRegexExpr.create(key, value);
    }
    static in(key, value) {
        return ContextKeyInExpr.create(key, value);
    }
    static notIn(key, value) {
        return ContextKeyNotInExpr.create(key, value);
    }
    static not(key) {
        return ContextKeyNotExpr.create(key);
    }
    static and(...expr) {
        return ContextKeyAndExpr.create(expr, null, true);
    }
    static or(...expr) {
        return ContextKeyOrExpr.create(expr, null, true);
    }
    static{
        this._parser = new Parser({
            regexParsingWithErrorRecovery: false
        });
    }
    static deserialize(serialized) {
        if (serialized === undefined || serialized === null) return undefined;
        const expr = this._parser.parse(serialized);
        return expr;
    }
}
function expressionsAreEqualWithConstantSubstitution(a, b) {
    const aExpr = a ? a.substituteConstants() : undefined;
    const bExpr = b ? b.substituteConstants() : undefined;
    if (!aExpr && !bExpr) return true;
    if (!aExpr || !bExpr) return false;
    return aExpr.equals(bExpr);
}
function cmp(a, b) {
    return a.cmp(b);
}
class ContextKeyFalseExpr {
    static{
        this.INSTANCE = new ContextKeyFalseExpr();
    }
    constructor(){
        this.type = 0 /* ContextKeyExprType.False */ ;
    }
    cmp(other) {
        return this.type - other.type;
    }
    equals(other) {
        return other.type === this.type;
    }
    substituteConstants() {
        return this;
    }
    evaluate(context) {
        return false;
    }
    serialize() {
        return "false";
    }
    keys() {
        return [];
    }
    negate() {
        return ContextKeyTrueExpr.INSTANCE;
    }
}
class ContextKeyTrueExpr {
    static{
        this.INSTANCE = new ContextKeyTrueExpr();
    }
    constructor(){
        this.type = 1 /* ContextKeyExprType.True */ ;
    }
    cmp(other) {
        return this.type - other.type;
    }
    equals(other) {
        return other.type === this.type;
    }
    substituteConstants() {
        return this;
    }
    evaluate(context) {
        return true;
    }
    serialize() {
        return "true";
    }
    keys() {
        return [];
    }
    negate() {
        return ContextKeyFalseExpr.INSTANCE;
    }
}
class ContextKeyDefinedExpr {
    static create(key, negated = null) {
        const constantValue = CONSTANT_VALUES.get(key);
        if (typeof constantValue === "boolean") return constantValue ? ContextKeyTrueExpr.INSTANCE : ContextKeyFalseExpr.INSTANCE;
        return new ContextKeyDefinedExpr(key, negated);
    }
    constructor(key, negated){
        this.key = key;
        this.negated = negated;
        this.type = 2 /* ContextKeyExprType.Defined */ ;
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        return cmp1(this.key, other.key);
    }
    equals(other) {
        if (other.type === this.type) return this.key === other.key;
        return false;
    }
    substituteConstants() {
        const constantValue = CONSTANT_VALUES.get(this.key);
        if (typeof constantValue === "boolean") return constantValue ? ContextKeyTrueExpr.INSTANCE : ContextKeyFalseExpr.INSTANCE;
        return this;
    }
    evaluate(context) {
        return !!context.getValue(this.key);
    }
    serialize() {
        return this.key;
    }
    keys() {
        return [
            this.key
        ];
    }
    negate() {
        if (!this.negated) this.negated = ContextKeyNotExpr.create(this.key, this);
        return this.negated;
    }
}
class ContextKeyEqualsExpr {
    static create(key, value, negated = null) {
        if (typeof value === "boolean") return value ? ContextKeyDefinedExpr.create(key, negated) : ContextKeyNotExpr.create(key, negated);
        const constantValue = CONSTANT_VALUES.get(key);
        if (typeof constantValue === "boolean") {
            const trueValue = constantValue ? "true" : "false";
            return value === trueValue ? ContextKeyTrueExpr.INSTANCE : ContextKeyFalseExpr.INSTANCE;
        }
        return new ContextKeyEqualsExpr(key, value, negated);
    }
    constructor(key, value, negated){
        this.key = key;
        this.value = value;
        this.negated = negated;
        this.type = 4 /* ContextKeyExprType.Equals */ ;
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        return cmp2(this.key, this.value, other.key, other.value);
    }
    equals(other) {
        if (other.type === this.type) return this.key === other.key && this.value === other.value;
        return false;
    }
    substituteConstants() {
        const constantValue = CONSTANT_VALUES.get(this.key);
        if (typeof constantValue === "boolean") {
            const trueValue = constantValue ? "true" : "false";
            return this.value === trueValue ? ContextKeyTrueExpr.INSTANCE : ContextKeyFalseExpr.INSTANCE;
        }
        return this;
    }
    evaluate(context) {
        // Intentional ==
        // eslint-disable-next-line eqeqeq
        return context.getValue(this.key) == this.value;
    }
    serialize() {
        return `${this.key} == '${this.value}'`;
    }
    keys() {
        return [
            this.key
        ];
    }
    negate() {
        if (!this.negated) this.negated = ContextKeyNotEqualsExpr.create(this.key, this.value, this);
        return this.negated;
    }
}
class ContextKeyInExpr {
    static create(key, valueKey) {
        return new ContextKeyInExpr(key, valueKey);
    }
    constructor(key, valueKey){
        this.key = key;
        this.valueKey = valueKey;
        this.type = 10 /* ContextKeyExprType.In */ ;
        this.negated = null;
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        return cmp2(this.key, this.valueKey, other.key, other.valueKey);
    }
    equals(other) {
        if (other.type === this.type) return this.key === other.key && this.valueKey === other.valueKey;
        return false;
    }
    substituteConstants() {
        return this;
    }
    evaluate(context) {
        const source = context.getValue(this.valueKey);
        const item = context.getValue(this.key);
        if (Array.isArray(source)) return source.includes(item);
        if (typeof item === "string" && typeof source === "object" && source !== null) return hasOwnProperty.call(source, item);
        return false;
    }
    serialize() {
        return `${this.key} in '${this.valueKey}'`;
    }
    keys() {
        return [
            this.key,
            this.valueKey
        ];
    }
    negate() {
        if (!this.negated) this.negated = ContextKeyNotInExpr.create(this.key, this.valueKey);
        return this.negated;
    }
}
class ContextKeyNotInExpr {
    static create(key, valueKey) {
        return new ContextKeyNotInExpr(key, valueKey);
    }
    constructor(key, valueKey){
        this.key = key;
        this.valueKey = valueKey;
        this.type = 11 /* ContextKeyExprType.NotIn */ ;
        this._negated = ContextKeyInExpr.create(key, valueKey);
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        return this._negated.cmp(other._negated);
    }
    equals(other) {
        if (other.type === this.type) return this._negated.equals(other._negated);
        return false;
    }
    substituteConstants() {
        return this;
    }
    evaluate(context) {
        return !this._negated.evaluate(context);
    }
    serialize() {
        return `${this.key} not in '${this.valueKey}'`;
    }
    keys() {
        return this._negated.keys();
    }
    negate() {
        return this._negated;
    }
}
class ContextKeyNotEqualsExpr {
    static create(key, value, negated = null) {
        if (typeof value === "boolean") {
            if (value) return ContextKeyNotExpr.create(key, negated);
            return ContextKeyDefinedExpr.create(key, negated);
        }
        const constantValue = CONSTANT_VALUES.get(key);
        if (typeof constantValue === "boolean") {
            const falseValue = constantValue ? "true" : "false";
            return value === falseValue ? ContextKeyFalseExpr.INSTANCE : ContextKeyTrueExpr.INSTANCE;
        }
        return new ContextKeyNotEqualsExpr(key, value, negated);
    }
    constructor(key, value, negated){
        this.key = key;
        this.value = value;
        this.negated = negated;
        this.type = 5 /* ContextKeyExprType.NotEquals */ ;
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        return cmp2(this.key, this.value, other.key, other.value);
    }
    equals(other) {
        if (other.type === this.type) return this.key === other.key && this.value === other.value;
        return false;
    }
    substituteConstants() {
        const constantValue = CONSTANT_VALUES.get(this.key);
        if (typeof constantValue === "boolean") {
            const falseValue = constantValue ? "true" : "false";
            return this.value === falseValue ? ContextKeyFalseExpr.INSTANCE : ContextKeyTrueExpr.INSTANCE;
        }
        return this;
    }
    evaluate(context) {
        // Intentional !=
        // eslint-disable-next-line eqeqeq
        return context.getValue(this.key) != this.value;
    }
    serialize() {
        return `${this.key} != '${this.value}'`;
    }
    keys() {
        return [
            this.key
        ];
    }
    negate() {
        if (!this.negated) this.negated = ContextKeyEqualsExpr.create(this.key, this.value, this);
        return this.negated;
    }
}
class ContextKeyNotExpr {
    static create(key, negated = null) {
        const constantValue = CONSTANT_VALUES.get(key);
        if (typeof constantValue === "boolean") return constantValue ? ContextKeyFalseExpr.INSTANCE : ContextKeyTrueExpr.INSTANCE;
        return new ContextKeyNotExpr(key, negated);
    }
    constructor(key, negated){
        this.key = key;
        this.negated = negated;
        this.type = 3 /* ContextKeyExprType.Not */ ;
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        return cmp1(this.key, other.key);
    }
    equals(other) {
        if (other.type === this.type) return this.key === other.key;
        return false;
    }
    substituteConstants() {
        const constantValue = CONSTANT_VALUES.get(this.key);
        if (typeof constantValue === "boolean") return constantValue ? ContextKeyFalseExpr.INSTANCE : ContextKeyTrueExpr.INSTANCE;
        return this;
    }
    evaluate(context) {
        return !context.getValue(this.key);
    }
    serialize() {
        return `!${this.key}`;
    }
    keys() {
        return [
            this.key
        ];
    }
    negate() {
        if (!this.negated) this.negated = ContextKeyDefinedExpr.create(this.key, this);
        return this.negated;
    }
}
function withFloatOrStr(value, callback) {
    if (typeof value === "string") {
        const n = parseFloat(value);
        if (!isNaN(n)) value = n;
    }
    if (typeof value === "string" || typeof value === "number") return callback(value);
    return ContextKeyFalseExpr.INSTANCE;
}
class ContextKeyGreaterExpr {
    static create(key, _value, negated = null) {
        return withFloatOrStr(_value, (value)=>new ContextKeyGreaterExpr(key, value, negated));
    }
    constructor(key, value, negated){
        this.key = key;
        this.value = value;
        this.negated = negated;
        this.type = 12 /* ContextKeyExprType.Greater */ ;
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        return cmp2(this.key, this.value, other.key, other.value);
    }
    equals(other) {
        if (other.type === this.type) return this.key === other.key && this.value === other.value;
        return false;
    }
    substituteConstants() {
        return this;
    }
    evaluate(context) {
        if (typeof this.value === "string") return false;
        return parseFloat(context.getValue(this.key)) > this.value;
    }
    serialize() {
        return `${this.key} > ${this.value}`;
    }
    keys() {
        return [
            this.key
        ];
    }
    negate() {
        if (!this.negated) this.negated = ContextKeySmallerEqualsExpr.create(this.key, this.value, this);
        return this.negated;
    }
}
class ContextKeyGreaterEqualsExpr {
    static create(key, _value, negated = null) {
        return withFloatOrStr(_value, (value)=>new ContextKeyGreaterEqualsExpr(key, value, negated));
    }
    constructor(key, value, negated){
        this.key = key;
        this.value = value;
        this.negated = negated;
        this.type = 13 /* ContextKeyExprType.GreaterEquals */ ;
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        return cmp2(this.key, this.value, other.key, other.value);
    }
    equals(other) {
        if (other.type === this.type) return this.key === other.key && this.value === other.value;
        return false;
    }
    substituteConstants() {
        return this;
    }
    evaluate(context) {
        if (typeof this.value === "string") return false;
        return parseFloat(context.getValue(this.key)) >= this.value;
    }
    serialize() {
        return `${this.key} >= ${this.value}`;
    }
    keys() {
        return [
            this.key
        ];
    }
    negate() {
        if (!this.negated) this.negated = ContextKeySmallerExpr.create(this.key, this.value, this);
        return this.negated;
    }
}
class ContextKeySmallerExpr {
    static create(key, _value, negated = null) {
        return withFloatOrStr(_value, (value)=>new ContextKeySmallerExpr(key, value, negated));
    }
    constructor(key, value, negated){
        this.key = key;
        this.value = value;
        this.negated = negated;
        this.type = 14 /* ContextKeyExprType.Smaller */ ;
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        return cmp2(this.key, this.value, other.key, other.value);
    }
    equals(other) {
        if (other.type === this.type) return this.key === other.key && this.value === other.value;
        return false;
    }
    substituteConstants() {
        return this;
    }
    evaluate(context) {
        if (typeof this.value === "string") return false;
        return parseFloat(context.getValue(this.key)) < this.value;
    }
    serialize() {
        return `${this.key} < ${this.value}`;
    }
    keys() {
        return [
            this.key
        ];
    }
    negate() {
        if (!this.negated) this.negated = ContextKeyGreaterEqualsExpr.create(this.key, this.value, this);
        return this.negated;
    }
}
class ContextKeySmallerEqualsExpr {
    static create(key, _value, negated = null) {
        return withFloatOrStr(_value, (value)=>new ContextKeySmallerEqualsExpr(key, value, negated));
    }
    constructor(key, value, negated){
        this.key = key;
        this.value = value;
        this.negated = negated;
        this.type = 15 /* ContextKeyExprType.SmallerEquals */ ;
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        return cmp2(this.key, this.value, other.key, other.value);
    }
    equals(other) {
        if (other.type === this.type) return this.key === other.key && this.value === other.value;
        return false;
    }
    substituteConstants() {
        return this;
    }
    evaluate(context) {
        if (typeof this.value === "string") return false;
        return parseFloat(context.getValue(this.key)) <= this.value;
    }
    serialize() {
        return `${this.key} <= ${this.value}`;
    }
    keys() {
        return [
            this.key
        ];
    }
    negate() {
        if (!this.negated) this.negated = ContextKeyGreaterExpr.create(this.key, this.value, this);
        return this.negated;
    }
}
class ContextKeyRegexExpr {
    static create(key, regexp) {
        return new ContextKeyRegexExpr(key, regexp);
    }
    constructor(key, regexp){
        this.key = key;
        this.regexp = regexp;
        this.type = 7 /* ContextKeyExprType.Regex */ ;
        this.negated = null;
    //
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        if (this.key < other.key) return -1;
        if (this.key > other.key) return 1;
        const thisSource = this.regexp ? this.regexp.source : "";
        const otherSource = other.regexp ? other.regexp.source : "";
        if (thisSource < otherSource) return -1;
        if (thisSource > otherSource) return 1;
        return 0;
    }
    equals(other) {
        if (other.type === this.type) {
            const thisSource = this.regexp ? this.regexp.source : "";
            const otherSource = other.regexp ? other.regexp.source : "";
            return this.key === other.key && thisSource === otherSource;
        }
        return false;
    }
    substituteConstants() {
        return this;
    }
    evaluate(context) {
        const value = context.getValue(this.key);
        return this.regexp ? this.regexp.test(value) : false;
    }
    serialize() {
        const value = this.regexp ? `/${this.regexp.source}/${this.regexp.flags}` : "/invalid/";
        return `${this.key} =~ ${value}`;
    }
    keys() {
        return [
            this.key
        ];
    }
    negate() {
        if (!this.negated) this.negated = ContextKeyNotRegexExpr.create(this);
        return this.negated;
    }
}
class ContextKeyNotRegexExpr {
    static create(actual) {
        return new ContextKeyNotRegexExpr(actual);
    }
    constructor(_actual){
        this._actual = _actual;
        this.type = 8 /* ContextKeyExprType.NotRegex */ ;
    //
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        return this._actual.cmp(other._actual);
    }
    equals(other) {
        if (other.type === this.type) return this._actual.equals(other._actual);
        return false;
    }
    substituteConstants() {
        return this;
    }
    evaluate(context) {
        return !this._actual.evaluate(context);
    }
    serialize() {
        return `!(${this._actual.serialize()})`;
    }
    keys() {
        return this._actual.keys();
    }
    negate() {
        return this._actual;
    }
}
/**
 * @returns the same instance if nothing changed.
 */ function eliminateConstantsInArray(arr) {
    // Allocate array only if there is a difference
    let newArr = null;
    for(let i = 0, len = arr.length; i < len; i++){
        const newExpr = arr[i].substituteConstants();
        if (arr[i] !== newExpr) // something has changed!
        // allocate array on first difference
        {
            if (newArr === null) {
                newArr = [];
                for(let j = 0; j < i; j++)newArr[j] = arr[j];
            }
        }
        if (newArr !== null) newArr[i] = newExpr;
    }
    if (newArr === null) return arr;
    return newArr;
}
class ContextKeyAndExpr {
    static create(_expr, negated, extraRedundantCheck) {
        return ContextKeyAndExpr._normalizeArr(_expr, negated, extraRedundantCheck);
    }
    constructor(expr, negated){
        this.expr = expr;
        this.negated = negated;
        this.type = 6 /* ContextKeyExprType.And */ ;
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        if (this.expr.length < other.expr.length) return -1;
        if (this.expr.length > other.expr.length) return 1;
        for(let i = 0, len = this.expr.length; i < len; i++){
            const r = cmp(this.expr[i], other.expr[i]);
            if (r !== 0) return r;
        }
        return 0;
    }
    equals(other) {
        if (other.type === this.type) {
            if (this.expr.length !== other.expr.length) return false;
            for(let i = 0, len = this.expr.length; i < len; i++){
                if (!this.expr[i].equals(other.expr[i])) return false;
            }
            return true;
        }
        return false;
    }
    substituteConstants() {
        const exprArr = eliminateConstantsInArray(this.expr);
        if (exprArr === this.expr) // no change
        return this;
        return ContextKeyAndExpr.create(exprArr, this.negated, false);
    }
    evaluate(context) {
        for(let i = 0, len = this.expr.length; i < len; i++){
            if (!this.expr[i].evaluate(context)) return false;
        }
        return true;
    }
    static _normalizeArr(arr, negated, extraRedundantCheck) {
        const expr = [];
        let hasTrue = false;
        for (const e of arr){
            if (!e) continue;
            if (e.type === 1 /* ContextKeyExprType.True */ ) {
                // anything && true ==> anything
                hasTrue = true;
                continue;
            }
            if (e.type === 0 /* ContextKeyExprType.False */ ) // anything && false ==> false
            return ContextKeyFalseExpr.INSTANCE;
            if (e.type === 6 /* ContextKeyExprType.And */ ) {
                expr.push(...e.expr);
                continue;
            }
            expr.push(e);
        }
        if (expr.length === 0 && hasTrue) return ContextKeyTrueExpr.INSTANCE;
        if (expr.length === 0) return undefined;
        if (expr.length === 1) return expr[0];
        expr.sort(cmp);
        // eliminate duplicate terms
        for(let i = 1; i < expr.length; i++)if (expr[i - 1].equals(expr[i])) {
            expr.splice(i, 1);
            i--;
        }
        if (expr.length === 1) return expr[0];
        // We must distribute any OR expression because we don't support parens
        // OR extensions will be at the end (due to sorting rules)
        while(expr.length > 1){
            const lastElement = expr[expr.length - 1];
            if (lastElement.type !== 9 /* ContextKeyExprType.Or */ ) break;
            // pop the last element
            expr.pop();
            // pop the second to last element
            const secondToLastElement = expr.pop();
            const isFinished = expr.length === 0;
            // distribute `lastElement` over `secondToLastElement`
            const resultElement = ContextKeyOrExpr.create(lastElement.expr.map((el)=>ContextKeyAndExpr.create([
                    el,
                    secondToLastElement
                ], null, extraRedundantCheck)), null, isFinished);
            if (resultElement) {
                expr.push(resultElement);
                expr.sort(cmp);
            }
        }
        if (expr.length === 1) return expr[0];
        // resolve false AND expressions
        if (extraRedundantCheck) {
            for(let i = 0; i < expr.length; i++)for(let j = i + 1; j < expr.length; j++){
                if (expr[i].negate().equals(expr[j])) // A && !A case
                return ContextKeyFalseExpr.INSTANCE;
            }
            if (expr.length === 1) return expr[0];
        }
        return new ContextKeyAndExpr(expr, negated);
    }
    serialize() {
        return this.expr.map((e)=>e.serialize()).join(" && ");
    }
    keys() {
        const result = [];
        for (const expr of this.expr)result.push(...expr.keys());
        return result;
    }
    negate() {
        if (!this.negated) {
            const result = [];
            for (const expr of this.expr)result.push(expr.negate());
            this.negated = ContextKeyOrExpr.create(result, this, true);
        }
        return this.negated;
    }
}
class ContextKeyOrExpr {
    static create(_expr, negated, extraRedundantCheck) {
        return ContextKeyOrExpr._normalizeArr(_expr, negated, extraRedundantCheck);
    }
    constructor(expr, negated){
        this.expr = expr;
        this.negated = negated;
        this.type = 9 /* ContextKeyExprType.Or */ ;
    }
    cmp(other) {
        if (other.type !== this.type) return this.type - other.type;
        if (this.expr.length < other.expr.length) return -1;
        if (this.expr.length > other.expr.length) return 1;
        for(let i = 0, len = this.expr.length; i < len; i++){
            const r = cmp(this.expr[i], other.expr[i]);
            if (r !== 0) return r;
        }
        return 0;
    }
    equals(other) {
        if (other.type === this.type) {
            if (this.expr.length !== other.expr.length) return false;
            for(let i = 0, len = this.expr.length; i < len; i++){
                if (!this.expr[i].equals(other.expr[i])) return false;
            }
            return true;
        }
        return false;
    }
    substituteConstants() {
        const exprArr = eliminateConstantsInArray(this.expr);
        if (exprArr === this.expr) // no change
        return this;
        return ContextKeyOrExpr.create(exprArr, this.negated, false);
    }
    evaluate(context) {
        for(let i = 0, len = this.expr.length; i < len; i++){
            if (this.expr[i].evaluate(context)) return true;
        }
        return false;
    }
    static _normalizeArr(arr, negated, extraRedundantCheck) {
        let expr = [];
        let hasFalse = false;
        if (arr) {
            for(let i = 0, len = arr.length; i < len; i++){
                const e = arr[i];
                if (!e) continue;
                if (e.type === 0 /* ContextKeyExprType.False */ ) {
                    // anything || false ==> anything
                    hasFalse = true;
                    continue;
                }
                if (e.type === 1 /* ContextKeyExprType.True */ ) // anything || true ==> true
                return ContextKeyTrueExpr.INSTANCE;
                if (e.type === 9 /* ContextKeyExprType.Or */ ) {
                    expr = expr.concat(e.expr);
                    continue;
                }
                expr.push(e);
            }
            if (expr.length === 0 && hasFalse) return ContextKeyFalseExpr.INSTANCE;
            expr.sort(cmp);
        }
        if (expr.length === 0) return undefined;
        if (expr.length === 1) return expr[0];
        // eliminate duplicate terms
        for(let i = 1; i < expr.length; i++)if (expr[i - 1].equals(expr[i])) {
            expr.splice(i, 1);
            i--;
        }
        if (expr.length === 1) return expr[0];
        // resolve true OR expressions
        if (extraRedundantCheck) {
            for(let i = 0; i < expr.length; i++)for(let j = i + 1; j < expr.length; j++){
                if (expr[i].negate().equals(expr[j])) // A || !A case
                return ContextKeyTrueExpr.INSTANCE;
            }
            if (expr.length === 1) return expr[0];
        }
        return new ContextKeyOrExpr(expr, negated);
    }
    serialize() {
        return this.expr.map((e)=>e.serialize()).join(" || ");
    }
    keys() {
        const result = [];
        for (const expr of this.expr)result.push(...expr.keys());
        return result;
    }
    negate() {
        if (!this.negated) {
            const result = [];
            for (const expr of this.expr)result.push(expr.negate());
            // We don't support parens, so here we distribute the AND over the OR terminals
            // We always take the first 2 AND pairs and distribute them
            while(result.length > 1){
                const LEFT = result.shift();
                const RIGHT = result.shift();
                const all = [];
                for (const left of getTerminals(LEFT))for (const right of getTerminals(RIGHT))all.push(ContextKeyAndExpr.create([
                    left,
                    right
                ], null, false));
                result.unshift(ContextKeyOrExpr.create(all, null, false));
            }
            this.negated = ContextKeyOrExpr.create(result, this, true);
        }
        return this.negated;
    }
}
class RawContextKey extends ContextKeyDefinedExpr {
    static{
        this._info = [];
    }
    static all() {
        return RawContextKey._info.values();
    }
    constructor(key, defaultValue, metaOrHide){
        super(key, null);
        this._defaultValue = defaultValue;
        // collect all context keys into a central place
        if (typeof metaOrHide === "object") RawContextKey._info.push({
            ...metaOrHide,
            key
        });
        else if (metaOrHide !== true) RawContextKey._info.push({
            key,
            description: metaOrHide,
            type: defaultValue !== null && defaultValue !== undefined ? typeof defaultValue : undefined
        });
    }
    bindTo(target) {
        return target.createKey(this.key, this._defaultValue);
    }
    getValue(target) {
        return target.getContextKeyValue(this.key);
    }
    toNegated() {
        return this.negate();
    }
    isEqualTo(value) {
        return ContextKeyEqualsExpr.create(this.key, value);
    }
}
const IContextKeyService = (0, _instantiationJs.createDecorator)("contextKeyService");
function cmp1(key1, key2) {
    if (key1 < key2) return -1;
    if (key1 > key2) return 1;
    return 0;
}
function cmp2(key1, value1, key2, value2) {
    if (key1 < key2) return -1;
    if (key1 > key2) return 1;
    if (value1 < value2) return -1;
    if (value1 > value2) return 1;
    return 0;
}
function implies(p, q) {
    if (p.type === 0 /* ContextKeyExprType.False */  || q.type === 1 /* ContextKeyExprType.True */ ) // false implies anything
    // anything implies true
    return true;
    if (p.type === 9 /* ContextKeyExprType.Or */ ) {
        if (q.type === 9 /* ContextKeyExprType.Or */ ) // `a || b || c` can only imply something like `a || b || c || d`
        return allElementsIncluded(p.expr, q.expr);
        return false;
    }
    if (q.type === 9 /* ContextKeyExprType.Or */ ) {
        for (const element of q.expr){
            if (implies(p, element)) return true;
        }
        return false;
    }
    if (p.type === 6 /* ContextKeyExprType.And */ ) {
        if (q.type === 6 /* ContextKeyExprType.And */ ) // `a && b && c` implies `a && c`
        return allElementsIncluded(q.expr, p.expr);
        for (const element of p.expr){
            if (implies(element, q)) return true;
        }
        return false;
    }
    return p.equals(q);
}
/**
 * Returns true if all elements in `p` are also present in `q`.
 * The two arrays are assumed to be sorted
 */ function allElementsIncluded(p, q) {
    let pIndex = 0;
    let qIndex = 0;
    while(pIndex < p.length && qIndex < q.length){
        const cmp = p[pIndex].cmp(q[qIndex]);
        if (cmp < 0) // an element from `p` is missing from `q`
        return false;
        else if (cmp === 0) {
            pIndex++;
            qIndex++;
        } else qIndex++;
    }
    return pIndex === p.length;
}
function getTerminals(node) {
    if (node.type === 9 /* ContextKeyExprType.Or */ ) return node.expr;
    return [
        node
    ];
}

},{"../../../base/common/platform.js":"7maJO","../../../base/common/strings.js":"aA9I1","./scanner.js":"j3WUk","../../instantiation/common/instantiation.js":"fjwWx","../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j3WUk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A simple scanner for context keys.
 *
 * Example:
 *
 * ```ts
 * const scanner = new Scanner().reset('resourceFileName =~ /docker/ && !config.docker.enabled');
 * const tokens = [...scanner];
 * if (scanner.errorTokens.length > 0) {
 *     scanner.errorTokens.forEach(err => console.error(`Unexpected token at ${err.offset}: ${err.lexeme}\nHint: ${err.additional}`));
 * } else {
 *     // process tokens
 * }
 * ```
 */ parcelHelpers.export(exports, "Scanner", ()=>Scanner);
var _errorsJs = require("../../../base/common/errors.js");
var _nlsJs = require("../../../nls.js");
function hintDidYouMean(...meant) {
    switch(meant.length){
        case 1:
            return (0, _nlsJs.localize)("contextkey.scanner.hint.didYouMean1", "Did you mean {0}?", meant[0]);
        case 2:
            return (0, _nlsJs.localize)("contextkey.scanner.hint.didYouMean2", "Did you mean {0} or {1}?", meant[0], meant[1]);
        case 3:
            return (0, _nlsJs.localize)("contextkey.scanner.hint.didYouMean3", "Did you mean {0}, {1} or {2}?", meant[0], meant[1], meant[2]);
        default:
            return undefined;
    }
}
const hintDidYouForgetToOpenOrCloseQuote = (0, _nlsJs.localize)("contextkey.scanner.hint.didYouForgetToOpenOrCloseQuote", "Did you forget to open or close the quote?");
const hintDidYouForgetToEscapeSlash = (0, _nlsJs.localize)("contextkey.scanner.hint.didYouForgetToEscapeSlash", "Did you forget to escape the '/' (slash) character? Put two backslashes before it to escape, e.g., '\\\\/'.");
class Scanner {
    constructor(){
        this._input = "";
        this._start = 0;
        this._current = 0;
        this._tokens = [];
        this._errors = [];
        // u - unicode, y - sticky // TODO@ulugbekna: we accept double quotes as part of the string rather than as a delimiter (to preserve old parser's behavior)
        this.stringRe = /[a-zA-Z0-9_<>\-\./\\:\*\?\+\[\]\^,#@;"%\$\p{L}-]+/uy;
    }
    static getLexeme(token) {
        switch(token.type){
            case 0 /* TokenType.LParen */ :
                return "(";
            case 1 /* TokenType.RParen */ :
                return ")";
            case 2 /* TokenType.Neg */ :
                return "!";
            case 3 /* TokenType.Eq */ :
                return token.isTripleEq ? "===" : "==";
            case 4 /* TokenType.NotEq */ :
                return token.isTripleEq ? "!==" : "!=";
            case 5 /* TokenType.Lt */ :
                return "<";
            case 6 /* TokenType.LtEq */ :
                return "<=";
            case 7 /* TokenType.Gt */ :
                return ">=";
            case 8 /* TokenType.GtEq */ :
                return ">=";
            case 9 /* TokenType.RegexOp */ :
                return "=~";
            case 10 /* TokenType.RegexStr */ :
                return token.lexeme;
            case 11 /* TokenType.True */ :
                return "true";
            case 12 /* TokenType.False */ :
                return "false";
            case 13 /* TokenType.In */ :
                return "in";
            case 14 /* TokenType.Not */ :
                return "not";
            case 15 /* TokenType.And */ :
                return "&&";
            case 16 /* TokenType.Or */ :
                return "||";
            case 17 /* TokenType.Str */ :
                return token.lexeme;
            case 18 /* TokenType.QuotedStr */ :
                return token.lexeme;
            case 19 /* TokenType.Error */ :
                return token.lexeme;
            case 20 /* TokenType.EOF */ :
                return "EOF";
            default:
                throw (0, _errorsJs.illegalState)(`unhandled token type: ${JSON.stringify(token)}; have you forgotten to add a case?`);
        }
    }
    static{
        this._regexFlags = new Set([
            "i",
            "g",
            "s",
            "m",
            "y",
            "u"
        ].map((ch)=>ch.charCodeAt(0)));
    }
    static{
        this._keywords = new Map([
            [
                "not",
                14 /* TokenType.Not */ 
            ],
            [
                "in",
                13 /* TokenType.In */ 
            ],
            [
                "false",
                12 /* TokenType.False */ 
            ],
            [
                "true",
                11 /* TokenType.True */ 
            ]
        ]);
    }
    reset(value) {
        this._input = value;
        this._start = 0;
        this._current = 0;
        this._tokens = [];
        this._errors = [];
        return this;
    }
    scan() {
        while(!this._isAtEnd()){
            this._start = this._current;
            const ch = this._advance();
            switch(ch){
                case 40 /* CharCode.OpenParen */ :
                    this._addToken(0 /* TokenType.LParen */ );
                    break;
                case 41 /* CharCode.CloseParen */ :
                    this._addToken(1 /* TokenType.RParen */ );
                    break;
                case 33 /* CharCode.ExclamationMark */ :
                    if (this._match(61 /* CharCode.Equals */ )) {
                        const isTripleEq = this._match(61 /* CharCode.Equals */ ); // eat last `=` if `!==`
                        this._tokens.push({
                            type: 4 /* TokenType.NotEq */ ,
                            offset: this._start,
                            isTripleEq
                        });
                    } else this._addToken(2 /* TokenType.Neg */ );
                    break;
                case 39 /* CharCode.SingleQuote */ :
                    this._quotedString();
                    break;
                case 47 /* CharCode.Slash */ :
                    this._regex();
                    break;
                case 61 /* CharCode.Equals */ :
                    if (this._match(61 /* CharCode.Equals */ )) {
                        const isTripleEq = this._match(61 /* CharCode.Equals */ ); // eat last `=` if `===`
                        this._tokens.push({
                            type: 3 /* TokenType.Eq */ ,
                            offset: this._start,
                            isTripleEq
                        });
                    } else if (this._match(126 /* CharCode.Tilde */ )) this._addToken(9 /* TokenType.RegexOp */ );
                    else this._error(hintDidYouMean("==", "=~"));
                    break;
                case 60 /* CharCode.LessThan */ :
                    this._addToken(this._match(61 /* CharCode.Equals */ ) ? 6 /* TokenType.LtEq */  : 5 /* TokenType.Lt */ );
                    break;
                case 62 /* CharCode.GreaterThan */ :
                    this._addToken(this._match(61 /* CharCode.Equals */ ) ? 8 /* TokenType.GtEq */  : 7 /* TokenType.Gt */ );
                    break;
                case 38 /* CharCode.Ampersand */ :
                    if (this._match(38 /* CharCode.Ampersand */ )) this._addToken(15 /* TokenType.And */ );
                    else this._error(hintDidYouMean("&&"));
                    break;
                case 124 /* CharCode.Pipe */ :
                    if (this._match(124 /* CharCode.Pipe */ )) this._addToken(16 /* TokenType.Or */ );
                    else this._error(hintDidYouMean("||"));
                    break;
                // TODO@ulugbekna: 1) rewrite using a regex 2) reconsider what characters are considered whitespace, including unicode, nbsp, etc.
                case 32 /* CharCode.Space */ :
                case 13 /* CharCode.CarriageReturn */ :
                case 9 /* CharCode.Tab */ :
                case 10 /* CharCode.LineFeed */ :
                case 160 /* CharCode.NoBreakSpace */ :
                    break;
                default:
                    this._string();
            }
        }
        this._start = this._current;
        this._addToken(20 /* TokenType.EOF */ );
        return Array.from(this._tokens);
    }
    _match(expected) {
        if (this._isAtEnd()) return false;
        if (this._input.charCodeAt(this._current) !== expected) return false;
        this._current++;
        return true;
    }
    _advance() {
        return this._input.charCodeAt(this._current++);
    }
    _peek() {
        return this._isAtEnd() ? 0 /* CharCode.Null */  : this._input.charCodeAt(this._current);
    }
    _addToken(type) {
        this._tokens.push({
            type,
            offset: this._start
        });
    }
    _error(additional) {
        const offset = this._start;
        const lexeme = this._input.substring(this._start, this._current);
        const errToken = {
            type: 19 /* TokenType.Error */ ,
            offset: this._start,
            lexeme
        };
        this._errors.push({
            offset,
            lexeme,
            additionalInfo: additional
        });
        this._tokens.push(errToken);
    }
    _string() {
        this.stringRe.lastIndex = this._start;
        const match = this.stringRe.exec(this._input);
        if (match) {
            this._current = this._start + match[0].length;
            const lexeme = this._input.substring(this._start, this._current);
            const keyword = Scanner._keywords.get(lexeme);
            if (keyword) this._addToken(keyword);
            else this._tokens.push({
                type: 17 /* TokenType.Str */ ,
                lexeme,
                offset: this._start
            });
        }
    }
    // captures the lexeme without the leading and trailing '
    _quotedString() {
        while(this._peek() !== 39 /* CharCode.SingleQuote */  && !this._isAtEnd())this._advance();
        if (this._isAtEnd()) {
            this._error(hintDidYouForgetToOpenOrCloseQuote);
            return;
        }
        // consume the closing '
        this._advance();
        this._tokens.push({
            type: 18 /* TokenType.QuotedStr */ ,
            lexeme: this._input.substring(this._start + 1, this._current - 1),
            offset: this._start + 1
        });
    }
    /*
     * Lexing a regex expression: /.../[igsmyu]*
     * Based on https://github.com/microsoft/TypeScript/blob/9247ef115e617805983740ba795d7a8164babf89/src/compiler/scanner.ts#L2129-L2181
     *
     * Note that we want slashes within a regex to be escaped, e.g., /file:\\/\\/\\// should match `file:///`
     */ _regex() {
        let p = this._current;
        let inEscape = false;
        let inCharacterClass = false;
        while(true){
            if (p >= this._input.length) {
                this._current = p;
                this._error(hintDidYouForgetToEscapeSlash);
                return;
            }
            const ch = this._input.charCodeAt(p);
            if (inEscape) inEscape = false;
            else if (ch === 47 /* CharCode.Slash */  && !inCharacterClass) {
                p++;
                break;
            } else if (ch === 91 /* CharCode.OpenSquareBracket */ ) inCharacterClass = true;
            else if (ch === 92 /* CharCode.Backslash */ ) inEscape = true;
            else if (ch === 93 /* CharCode.CloseSquareBracket */ ) inCharacterClass = false;
            p++;
        }
        // Consume flags // TODO@ulugbekna: use regex instead
        while(p < this._input.length && Scanner._regexFlags.has(this._input.charCodeAt(p)))p++;
        this._current = p;
        const lexeme = this._input.substring(this._start, this._current);
        this._tokens.push({
            type: 10 /* TokenType.RegexStr */ ,
            lexeme,
            offset: this._start
        });
    }
    _isAtEnd() {
        return this._current >= this._input.length;
    }
}

},{"../../../base/common/errors.js":"divX8","../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h9qfk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeybindingsRegistry", ()=>KeybindingsRegistry);
parcelHelpers.export(exports, "Extensions", ()=>Extensions);
var _keybindingsJs = require("../../../base/common/keybindings.js");
var _platformJs = require("../../../base/common/platform.js");
var _commandsJs = require("../../commands/common/commands.js");
var _platformJs1 = require("../../registry/common/platform.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _linkedListJs = require("../../../base/common/linkedList.js");
/**
 * Stores all built-in and extension-provided keybindings (but not ones that user defines themselves)
 */ class KeybindingsRegistryImpl {
    constructor(){
        this._coreKeybindings = new (0, _linkedListJs.LinkedList)();
        this._extensionKeybindings = [];
        this._cachedMergedKeybindings = null;
    }
    /**
     * Take current platform into account and reduce to primary & secondary.
     */ static bindToCurrentPlatform(kb) {
        if ((0, _platformJs.OS) === 1 /* OperatingSystem.Windows */ ) {
            if (kb && kb.win) return kb.win;
        } else if ((0, _platformJs.OS) === 2 /* OperatingSystem.Macintosh */ ) {
            if (kb && kb.mac) return kb.mac;
        } else {
            if (kb && kb.linux) return kb.linux;
        }
        return kb;
    }
    registerKeybindingRule(rule) {
        const actualKb = KeybindingsRegistryImpl.bindToCurrentPlatform(rule);
        const result = new (0, _lifecycleJs.DisposableStore)();
        if (actualKb && actualKb.primary) {
            const kk = (0, _keybindingsJs.decodeKeybinding)(actualKb.primary, (0, _platformJs.OS));
            if (kk) result.add(this._registerDefaultKeybinding(kk, rule.id, rule.args, rule.weight, 0, rule.when));
        }
        if (actualKb && Array.isArray(actualKb.secondary)) for(let i = 0, len = actualKb.secondary.length; i < len; i++){
            const k = actualKb.secondary[i];
            const kk = (0, _keybindingsJs.decodeKeybinding)(k, (0, _platformJs.OS));
            if (kk) result.add(this._registerDefaultKeybinding(kk, rule.id, rule.args, rule.weight, -i - 1, rule.when));
        }
        return result;
    }
    registerCommandAndKeybindingRule(desc) {
        return (0, _lifecycleJs.combinedDisposable)(this.registerKeybindingRule(desc), (0, _commandsJs.CommandsRegistry).registerCommand(desc));
    }
    _registerDefaultKeybinding(keybinding, commandId, commandArgs, weight1, weight2, when) {
        const remove = this._coreKeybindings.push({
            keybinding: keybinding,
            command: commandId,
            commandArgs: commandArgs,
            when: when,
            weight1: weight1,
            weight2: weight2,
            extensionId: null,
            isBuiltinExtension: false
        });
        this._cachedMergedKeybindings = null;
        return (0, _lifecycleJs.toDisposable)(()=>{
            remove();
            this._cachedMergedKeybindings = null;
        });
    }
    getDefaultKeybindings() {
        if (!this._cachedMergedKeybindings) {
            this._cachedMergedKeybindings = Array.from(this._coreKeybindings).concat(this._extensionKeybindings);
            this._cachedMergedKeybindings.sort(sorter);
        }
        return this._cachedMergedKeybindings.slice(0);
    }
}
const KeybindingsRegistry = new KeybindingsRegistryImpl();
const Extensions = {
    EditorModes: "platform.keybindingsRegistry"
};
(0, _platformJs1.Registry).add(Extensions.EditorModes, KeybindingsRegistry);
function sorter(a, b) {
    if (a.weight1 !== b.weight1) return a.weight1 - b.weight1;
    if (a.command && b.command) {
        if (a.command < b.command) return -1;
        if (a.command > b.command) return 1;
    }
    return a.weight2 - b.weight2;
}

},{"../../../base/common/keybindings.js":"cQ6F5","../../../base/common/platform.js":"7maJO","../../commands/common/commands.js":"ho6ic","../../registry/common/platform.js":"dzx11","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/linkedList.js":"kv7Rg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dzx11":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Registry", ()=>Registry);
var _assertJs = require("../../../base/common/assert.js");
var _typesJs = require("../../../base/common/types.js");
class RegistryImpl {
    constructor(){
        this.data = new Map();
    }
    add(id, data) {
        _assertJs.ok(_typesJs.isString(id));
        _assertJs.ok(_typesJs.isObject(data));
        _assertJs.ok(!this.data.has(id), "There is already an extension with this id");
        this.data.set(id, data);
    }
    as(id) {
        return this.data.get(id) || null;
    }
}
const Registry = new RegistryImpl();

},{"../../../base/common/assert.js":"1nPIE","../../../base/common/types.js":"fb5yx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1nPIE":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Throws an error with the provided message if the provided value does not evaluate to a true Javascript value.
 *
 * @deprecated Use `assert(...)` instead.
 * This method is usually used like this:
 * ```ts
 * import * as assert from 'vs/base/common/assert';
 * assert.ok(...);
 * ```
 *
 * However, `assert` in that example is a user chosen name.
 * There is no tooling for generating such an import statement.
 * Thus, the `assert(...)` function should be used instead.
 */ parcelHelpers.export(exports, "ok", ()=>ok);
parcelHelpers.export(exports, "assertNever", ()=>assertNever);
/**
 * Like assert, but doesn't throw.
 */ parcelHelpers.export(exports, "softAssert", ()=>softAssert);
/**
 * condition must be side-effect free!
 */ parcelHelpers.export(exports, "assertFn", ()=>assertFn);
parcelHelpers.export(exports, "checkAdjacentItems", ()=>checkAdjacentItems);
var _errorsJs = require("./errors.js");
function ok(value, message) {
    if (!value) throw new Error(message ? `Assertion failed (${message})` : "Assertion Failed");
}
function assertNever(value, message = "Unreachable") {
    throw new Error(message);
}
function softAssert(condition) {
    if (!condition) (0, _errorsJs.onUnexpectedError)(new (0, _errorsJs.BugIndicatingError)("Soft Assertion Failed"));
}
function assertFn(condition) {
    if (!condition()) {
        // eslint-disable-next-line no-debugger
        debugger;
        // Reevaluate `condition` again to make debugging easier
        condition();
        (0, _errorsJs.onUnexpectedError)(new (0, _errorsJs.BugIndicatingError)("Assertion Failed"));
    }
}
function checkAdjacentItems(items, predicate) {
    let i = 0;
    while(i < items.length - 1){
        const a = items[i];
        const b = items[i + 1];
        if (!predicate(a, b)) return false;
        i++;
    }
    return true;
}

},{"./errors.js":"divX8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7vW8j":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ITelemetryService", ()=>ITelemetryService);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const ITelemetryService = (0, _instantiationJs.createDecorator)("telemetryService");

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ieJUF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ILogService", ()=>ILogService);
parcelHelpers.export(exports, "LogLevel", ()=>LogLevel);
parcelHelpers.export(exports, "DEFAULT_LOG_LEVEL", ()=>DEFAULT_LOG_LEVEL);
parcelHelpers.export(exports, "AbstractLogger", ()=>AbstractLogger);
parcelHelpers.export(exports, "ConsoleLogger", ()=>ConsoleLogger);
parcelHelpers.export(exports, "MultiplexLogger", ()=>MultiplexLogger);
parcelHelpers.export(exports, "LogLevelToString", ()=>LogLevelToString);
parcelHelpers.export(exports, "CONTEXT_LOG_LEVEL", ()=>CONTEXT_LOG_LEVEL);
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const ILogService = (0, _instantiationJs.createDecorator)("logService");
var LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["Off"] = 0] = "Off";
    LogLevel[LogLevel["Trace"] = 1] = "Trace";
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    LogLevel[LogLevel["Info"] = 3] = "Info";
    LogLevel[LogLevel["Warning"] = 4] = "Warning";
    LogLevel[LogLevel["Error"] = 5] = "Error";
})(LogLevel || (LogLevel = {}));
const DEFAULT_LOG_LEVEL = LogLevel.Info;
class AbstractLogger extends (0, _lifecycleJs.Disposable) {
    constructor(){
        super(...arguments);
        this.level = DEFAULT_LOG_LEVEL;
        this._onDidChangeLogLevel = this._register(new (0, _eventJs.Emitter)());
        this.onDidChangeLogLevel = this._onDidChangeLogLevel.event;
    }
    setLevel(level) {
        if (this.level !== level) {
            this.level = level;
            this._onDidChangeLogLevel.fire(this.level);
        }
    }
    getLevel() {
        return this.level;
    }
    checkLogLevel(level) {
        return this.level !== LogLevel.Off && this.level <= level;
    }
}
class ConsoleLogger extends AbstractLogger {
    constructor(logLevel = DEFAULT_LOG_LEVEL, useColors = true){
        super();
        this.useColors = useColors;
        this.setLevel(logLevel);
    }
    trace(message, ...args) {
        if (this.checkLogLevel(LogLevel.Trace)) {
            if (this.useColors) console.log("%cTRACE", "color: #888", message, ...args);
            else console.log(message, ...args);
        }
    }
    debug(message, ...args) {
        if (this.checkLogLevel(LogLevel.Debug)) {
            if (this.useColors) console.log("%cDEBUG", "background: #eee; color: #888", message, ...args);
            else console.log(message, ...args);
        }
    }
    info(message, ...args) {
        if (this.checkLogLevel(LogLevel.Info)) {
            if (this.useColors) console.log("%c INFO", "color: #33f", message, ...args);
            else console.log(message, ...args);
        }
    }
    warn(message, ...args) {
        if (this.checkLogLevel(LogLevel.Warning)) {
            if (this.useColors) console.log("%c WARN", "color: #993", message, ...args);
            else console.log(message, ...args);
        }
    }
    error(message, ...args) {
        if (this.checkLogLevel(LogLevel.Error)) {
            if (this.useColors) console.log("%c  ERR", "color: #f33", message, ...args);
            else console.error(message, ...args);
        }
    }
}
class MultiplexLogger extends AbstractLogger {
    constructor(loggers){
        super();
        this.loggers = loggers;
        if (loggers.length) this.setLevel(loggers[0].getLevel());
    }
    setLevel(level) {
        for (const logger of this.loggers)logger.setLevel(level);
        super.setLevel(level);
    }
    trace(message, ...args) {
        for (const logger of this.loggers)logger.trace(message, ...args);
    }
    debug(message, ...args) {
        for (const logger of this.loggers)logger.debug(message, ...args);
    }
    info(message, ...args) {
        for (const logger of this.loggers)logger.info(message, ...args);
    }
    warn(message, ...args) {
        for (const logger of this.loggers)logger.warn(message, ...args);
    }
    error(message, ...args) {
        for (const logger of this.loggers)logger.error(message, ...args);
    }
    dispose() {
        for (const logger of this.loggers)logger.dispose();
        super.dispose();
    }
}
function LogLevelToString(logLevel) {
    switch(logLevel){
        case LogLevel.Trace:
            return "trace";
        case LogLevel.Debug:
            return "debug";
        case LogLevel.Info:
            return "info";
        case LogLevel.Warning:
            return "warn";
        case LogLevel.Error:
            return "error";
        case LogLevel.Off:
            return "off";
    }
}
const CONTEXT_LOG_LEVEL = new (0, _contextkeyJs.RawContextKey)("logLevel", LogLevelToString(LogLevel.Info));

},{"../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../contextkey/common/contextkey.js":"gXuBD","../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gYnFO":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a new web worker that has model syncing capabilities built in.
 * Specify an AMD module to load that will `create` an object that will be proxied.
 */ parcelHelpers.export(exports, "createWebWorker", ()=>createWebWorker);
var _objectsJs = require("../../../base/common/objects.js");
var _editorWorkerServiceJs = require("../../browser/services/editorWorkerService.js");
var _standaloneServicesJs = require("./standaloneServices.js");
function createWebWorker(modelService, opts) {
    return new MonacoWebWorkerImpl(modelService, opts);
}
class MonacoWebWorkerImpl extends (0, _editorWorkerServiceJs.EditorWorkerClient) {
    constructor(modelService, opts){
        const workerDescriptor = {
            amdModuleId: (0, _standaloneServicesJs.standaloneEditorWorkerDescriptor).amdModuleId,
            esmModuleLocation: (0, _standaloneServicesJs.standaloneEditorWorkerDescriptor).esmModuleLocation,
            label: opts.label
        };
        super(workerDescriptor, opts.keepIdleModels || false, modelService);
        this._foreignModuleId = opts.moduleId;
        this._foreignModuleCreateData = opts.createData || null;
        this._foreignModuleHost = opts.host || null;
        this._foreignProxy = null;
    }
    // foreign host request
    fhr(method, args) {
        if (!this._foreignModuleHost || typeof this._foreignModuleHost[method] !== "function") return Promise.reject(new Error("Missing method " + method + " or missing main thread foreign host."));
        try {
            return Promise.resolve(this._foreignModuleHost[method].apply(this._foreignModuleHost, args));
        } catch (e) {
            return Promise.reject(e);
        }
    }
    _getForeignProxy() {
        if (!this._foreignProxy) this._foreignProxy = this._getProxy().then((proxy)=>{
            const foreignHostMethods = this._foreignModuleHost ? (0, _objectsJs.getAllMethodNames)(this._foreignModuleHost) : [];
            return proxy.$loadForeignModule(this._foreignModuleId, this._foreignModuleCreateData, foreignHostMethods).then((foreignMethods)=>{
                this._foreignModuleCreateData = null;
                const proxyMethodRequest = (method, args)=>{
                    return proxy.$fmr(method, args);
                };
                const createProxyMethod = (method, proxyMethodRequest)=>{
                    return function() {
                        const args = Array.prototype.slice.call(arguments, 0);
                        return proxyMethodRequest(method, args);
                    };
                };
                const foreignProxy = {};
                for (const foreignMethod of foreignMethods)foreignProxy[foreignMethod] = createProxyMethod(foreignMethod, proxyMethodRequest);
                return foreignProxy;
            });
        });
        return this._foreignProxy;
    }
    getProxy() {
        return this._getForeignProxy();
    }
    withSyncedResources(resources) {
        return this.workerWithSyncedResources(resources).then((_)=>this.getProxy());
    }
}

},{"../../../base/common/objects.js":"j84mT","../../browser/services/editorWorkerService.js":"Dlnvt","./standaloneServices.js":"3py7i","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Dlnvt":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorWorkerService", ()=>EditorWorkerService);
parcelHelpers.export(exports, "EditorWorkerClient", ()=>EditorWorkerClient);
var _asyncJs = require("../../../base/common/async.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _simpleWorkerJs = require("../../../base/common/worker/simpleWorker.js");
var _defaultWorkerFactoryJs = require("../../../base/browser/defaultWorkerFactory.js");
var _rangeJs = require("../../common/core/range.js");
var _languageConfigurationRegistryJs = require("../../common/languages/languageConfigurationRegistry.js");
var _editorSimpleWorkerJs = require("../../common/services/editorSimpleWorker.js");
var _modelJs = require("../../common/services/model.js");
var _textResourceConfigurationJs = require("../../common/services/textResourceConfiguration.js");
var _arraysJs = require("../../../base/common/arrays.js");
var _logJs = require("../../../platform/log/common/log.js");
var _stopwatchJs = require("../../../base/common/stopwatch.js");
var _errorsJs = require("../../../base/common/errors.js");
var _languageFeaturesJs = require("../../common/services/languageFeatures.js");
var _linesDiffComputerJs = require("../../common/diff/linesDiffComputer.js");
var _rangeMappingJs = require("../../common/diff/rangeMapping.js");
var _lineRangeJs = require("../../common/core/lineRange.js");
var _windowJs = require("../../../base/browser/window.js");
var _domJs = require("../../../base/browser/dom.js");
var _textModelSyncImplJs = require("../../common/services/textModelSync/textModelSync.impl.js");
var _editorWorkerHostJs = require("../../common/services/editorWorkerHost.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
/**
 * Stop the worker if it was not needed for 5 min.
 */ const STOP_WORKER_DELTA_TIME_MS = 300000;
function canSyncModel(modelService, resource) {
    const model = modelService.getModel(resource);
    if (!model) return false;
    if (model.isTooLargeForSyncing()) return false;
    return true;
}
let EditorWorkerService = class EditorWorkerService extends (0, _lifecycleJs.Disposable) {
    constructor(workerDescriptor, modelService, configurationService, logService, _languageConfigurationService, languageFeaturesService){
        super();
        this._languageConfigurationService = _languageConfigurationService;
        this._modelService = modelService;
        this._workerManager = this._register(new WorkerManager(workerDescriptor, this._modelService));
        this._logService = logService;
        // register default link-provider and default completions-provider
        this._register(languageFeaturesService.linkProvider.register({
            language: "*",
            hasAccessToAllModels: true
        }, {
            provideLinks: async (model, token)=>{
                if (!canSyncModel(this._modelService, model.uri)) return Promise.resolve({
                    links: []
                }); // File too large
                const worker = await this._workerWithResources([
                    model.uri
                ]);
                const links = await worker.$computeLinks(model.uri.toString());
                return links && {
                    links
                };
            }
        }));
        this._register(languageFeaturesService.completionProvider.register("*", new WordBasedCompletionItemProvider(this._workerManager, configurationService, this._modelService, this._languageConfigurationService)));
    }
    dispose() {
        super.dispose();
    }
    canComputeUnicodeHighlights(uri) {
        return canSyncModel(this._modelService, uri);
    }
    async computedUnicodeHighlights(uri, options, range) {
        const worker = await this._workerWithResources([
            uri
        ]);
        return worker.$computeUnicodeHighlights(uri.toString(), options, range);
    }
    async computeDiff(original, modified, options, algorithm) {
        const worker = await this._workerWithResources([
            original,
            modified
        ], /* forceLargeModels */ true);
        const result = await worker.$computeDiff(original.toString(), modified.toString(), options, algorithm);
        if (!result) return null;
        // Convert from space efficient JSON data to rich objects.
        const diff = {
            identical: result.identical,
            quitEarly: result.quitEarly,
            changes: toLineRangeMappings(result.changes),
            moves: result.moves.map((m)=>new (0, _linesDiffComputerJs.MovedText)(new (0, _rangeMappingJs.LineRangeMapping)(new (0, _lineRangeJs.LineRange)(m[0], m[1]), new (0, _lineRangeJs.LineRange)(m[2], m[3])), toLineRangeMappings(m[4])))
        };
        return diff;
        function toLineRangeMappings(changes) {
            return changes.map((c)=>new (0, _rangeMappingJs.DetailedLineRangeMapping)(new (0, _lineRangeJs.LineRange)(c[0], c[1]), new (0, _lineRangeJs.LineRange)(c[2], c[3]), c[4]?.map((c)=>new (0, _rangeMappingJs.RangeMapping)(new (0, _rangeJs.Range)(c[0], c[1], c[2], c[3]), new (0, _rangeJs.Range)(c[4], c[5], c[6], c[7])))));
        }
    }
    async computeMoreMinimalEdits(resource, edits, pretty = false) {
        if ((0, _arraysJs.isNonEmptyArray)(edits)) {
            if (!canSyncModel(this._modelService, resource)) return Promise.resolve(edits); // File too large
            const sw = (0, _stopwatchJs.StopWatch).create();
            const result = this._workerWithResources([
                resource
            ]).then((worker)=>worker.$computeMoreMinimalEdits(resource.toString(), edits, pretty));
            result.finally(()=>this._logService.trace("FORMAT#computeMoreMinimalEdits", resource.toString(true), sw.elapsed()));
            return Promise.race([
                result,
                (0, _asyncJs.timeout)(1000).then(()=>edits)
            ]);
        } else return Promise.resolve(undefined);
    }
    canNavigateValueSet(resource) {
        return canSyncModel(this._modelService, resource);
    }
    async navigateValueSet(resource, range, up) {
        const model = this._modelService.getModel(resource);
        if (!model) return null;
        const wordDefRegExp = this._languageConfigurationService.getLanguageConfiguration(model.getLanguageId()).getWordDefinition();
        const wordDef = wordDefRegExp.source;
        const wordDefFlags = wordDefRegExp.flags;
        const worker = await this._workerWithResources([
            resource
        ]);
        return worker.$navigateValueSet(resource.toString(), range, up, wordDef, wordDefFlags);
    }
    canComputeWordRanges(resource) {
        return canSyncModel(this._modelService, resource);
    }
    async computeWordRanges(resource, range) {
        const model = this._modelService.getModel(resource);
        if (!model) return Promise.resolve(null);
        const wordDefRegExp = this._languageConfigurationService.getLanguageConfiguration(model.getLanguageId()).getWordDefinition();
        const wordDef = wordDefRegExp.source;
        const wordDefFlags = wordDefRegExp.flags;
        const worker = await this._workerWithResources([
            resource
        ]);
        return worker.$computeWordRanges(resource.toString(), range, wordDef, wordDefFlags);
    }
    async findSectionHeaders(uri, options) {
        const worker = await this._workerWithResources([
            uri
        ]);
        return worker.$findSectionHeaders(uri.toString(), options);
    }
    async computeDefaultDocumentColors(uri) {
        const worker = await this._workerWithResources([
            uri
        ]);
        return worker.$computeDefaultDocumentColors(uri.toString());
    }
    async _workerWithResources(resources, forceLargeModels = false) {
        const worker = await this._workerManager.withWorker();
        return await worker.workerWithSyncedResources(resources, forceLargeModels);
    }
};
EditorWorkerService = __decorate([
    __param(1, (0, _modelJs.IModelService)),
    __param(2, (0, _textResourceConfigurationJs.ITextResourceConfigurationService)),
    __param(3, (0, _logJs.ILogService)),
    __param(4, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService)),
    __param(5, (0, _languageFeaturesJs.ILanguageFeaturesService))
], EditorWorkerService);
class WordBasedCompletionItemProvider {
    constructor(workerManager, configurationService, modelService, languageConfigurationService){
        this.languageConfigurationService = languageConfigurationService;
        this._debugDisplayName = "wordbasedCompletions";
        this._workerManager = workerManager;
        this._configurationService = configurationService;
        this._modelService = modelService;
    }
    async provideCompletionItems(model, position) {
        const config = this._configurationService.getValue(model.uri, position, "editor");
        if (config.wordBasedSuggestions === "off") return undefined;
        const models = [];
        if (config.wordBasedSuggestions === "currentDocument") // only current file and only if not too large
        {
            if (canSyncModel(this._modelService, model.uri)) models.push(model.uri);
        } else // either all files or files of same language
        for (const candidate of this._modelService.getModels()){
            if (!canSyncModel(this._modelService, candidate.uri)) continue;
            if (candidate === model) models.unshift(candidate.uri);
            else if (config.wordBasedSuggestions === "allDocuments" || candidate.getLanguageId() === model.getLanguageId()) models.push(candidate.uri);
        }
        if (models.length === 0) return undefined; // File too large, no other files
        const wordDefRegExp = this.languageConfigurationService.getLanguageConfiguration(model.getLanguageId()).getWordDefinition();
        const word = model.getWordAtPosition(position);
        const replace = !word ? (0, _rangeJs.Range).fromPositions(position) : new (0, _rangeJs.Range)(position.lineNumber, word.startColumn, position.lineNumber, word.endColumn);
        const insert = replace.setEndPosition(position.lineNumber, position.column);
        const client = await this._workerManager.withWorker();
        const data = await client.textualSuggest(models, word?.word, wordDefRegExp);
        if (!data) return undefined;
        return {
            duration: data.duration,
            suggestions: data.words.map((word)=>{
                return {
                    kind: 18 /* languages.CompletionItemKind.Text */ ,
                    label: word,
                    insertText: word,
                    range: {
                        insert,
                        replace
                    }
                };
            })
        };
    }
}
let WorkerManager = class WorkerManager extends (0, _lifecycleJs.Disposable) {
    constructor(_workerDescriptor, modelService){
        super();
        this._workerDescriptor = _workerDescriptor;
        this._modelService = modelService;
        this._editorWorkerClient = null;
        this._lastWorkerUsedTime = new Date().getTime();
        const stopWorkerInterval = this._register(new (0, _domJs.WindowIntervalTimer)());
        stopWorkerInterval.cancelAndSet(()=>this._checkStopIdleWorker(), Math.round(STOP_WORKER_DELTA_TIME_MS / 2), (0, _windowJs.mainWindow));
        this._register(this._modelService.onModelRemoved((_)=>this._checkStopEmptyWorker()));
    }
    dispose() {
        if (this._editorWorkerClient) {
            this._editorWorkerClient.dispose();
            this._editorWorkerClient = null;
        }
        super.dispose();
    }
    /**
     * Check if the model service has no more models and stop the worker if that is the case.
     */ _checkStopEmptyWorker() {
        if (!this._editorWorkerClient) return;
        const models = this._modelService.getModels();
        if (models.length === 0) {
            // There are no more models => nothing possible for me to do
            this._editorWorkerClient.dispose();
            this._editorWorkerClient = null;
        }
    }
    /**
     * Check if the worker has been idle for a while and then stop it.
     */ _checkStopIdleWorker() {
        if (!this._editorWorkerClient) return;
        const timeSinceLastWorkerUsedTime = new Date().getTime() - this._lastWorkerUsedTime;
        if (timeSinceLastWorkerUsedTime > STOP_WORKER_DELTA_TIME_MS) {
            this._editorWorkerClient.dispose();
            this._editorWorkerClient = null;
        }
    }
    withWorker() {
        this._lastWorkerUsedTime = new Date().getTime();
        if (!this._editorWorkerClient) this._editorWorkerClient = new EditorWorkerClient(this._workerDescriptor, false, this._modelService);
        return Promise.resolve(this._editorWorkerClient);
    }
};
WorkerManager = __decorate([
    __param(1, (0, _modelJs.IModelService))
], WorkerManager);
class SynchronousWorkerClient {
    constructor(instance){
        this._instance = instance;
        this.proxy = this._instance;
    }
    dispose() {
        this._instance.dispose();
    }
    setChannel(channel, handler) {
        throw new Error(`Not supported`);
    }
}
let EditorWorkerClient = class EditorWorkerClient extends (0, _lifecycleJs.Disposable) {
    constructor(_workerDescriptor, keepIdleModels, modelService){
        super();
        this._workerDescriptor = _workerDescriptor;
        this._disposed = false;
        this._modelService = modelService;
        this._keepIdleModels = keepIdleModels;
        this._worker = null;
        this._modelManager = null;
    }
    // foreign host request
    fhr(method, args) {
        throw new Error(`Not implemented!`);
    }
    _getOrCreateWorker() {
        if (!this._worker) try {
            this._worker = this._register((0, _defaultWorkerFactoryJs.createWebWorker)(this._workerDescriptor));
            (0, _editorWorkerHostJs.EditorWorkerHost).setChannel(this._worker, this._createEditorWorkerHost());
        } catch (err) {
            (0, _simpleWorkerJs.logOnceWebWorkerWarning)(err);
            this._worker = this._createFallbackLocalWorker();
        }
        return this._worker;
    }
    async _getProxy() {
        try {
            const proxy = this._getOrCreateWorker().proxy;
            await proxy.$ping();
            return proxy;
        } catch (err) {
            (0, _simpleWorkerJs.logOnceWebWorkerWarning)(err);
            this._worker = this._createFallbackLocalWorker();
            return this._worker.proxy;
        }
    }
    _createFallbackLocalWorker() {
        return new SynchronousWorkerClient(new (0, _editorSimpleWorkerJs.EditorSimpleWorker)(this._createEditorWorkerHost(), null));
    }
    _createEditorWorkerHost() {
        return {
            $fhr: (method, args)=>this.fhr(method, args)
        };
    }
    _getOrCreateModelManager(proxy) {
        if (!this._modelManager) this._modelManager = this._register(new (0, _textModelSyncImplJs.WorkerTextModelSyncClient)(proxy, this._modelService, this._keepIdleModels));
        return this._modelManager;
    }
    async workerWithSyncedResources(resources, forceLargeModels = false) {
        if (this._disposed) return Promise.reject((0, _errorsJs.canceled)());
        const proxy = await this._getProxy();
        this._getOrCreateModelManager(proxy).ensureSyncedResources(resources, forceLargeModels);
        return proxy;
    }
    async textualSuggest(resources, leadingWord, wordDefRegExp) {
        const proxy = await this.workerWithSyncedResources(resources);
        const wordDef = wordDefRegExp.source;
        const wordDefFlags = wordDefRegExp.flags;
        return proxy.$textualSuggest(resources.map((r)=>r.toString()), leadingWord, wordDef, wordDefFlags);
    }
    dispose() {
        super.dispose();
        this._disposed = true;
    }
};
EditorWorkerClient = __decorate([
    __param(2, (0, _modelJs.IModelService))
], EditorWorkerClient);

},{"../../../base/common/async.js":"4GJc4","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/worker/simpleWorker.js":"6ILMq","../../../base/browser/defaultWorkerFactory.js":"aUlUM","../../common/core/range.js":"jmUPh","../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../common/services/editorSimpleWorker.js":"iRWuk","../../common/services/model.js":"aciVm","../../common/services/textResourceConfiguration.js":"4yrEB","../../../base/common/arrays.js":"DECei","../../../platform/log/common/log.js":"ieJUF","../../../base/common/stopwatch.js":"77PF9","../../../base/common/errors.js":"divX8","../../common/services/languageFeatures.js":"2IAko","../../common/diff/linesDiffComputer.js":"kUXV1","../../common/diff/rangeMapping.js":"7QuJJ","../../common/core/lineRange.js":"cmnMs","../../../base/browser/window.js":"aJBhQ","../../../base/browser/dom.js":"bnqsM","../../common/services/textModelSync/textModelSync.impl.js":"d5ZUa","../../common/services/editorWorkerHost.js":"dbMbx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ILMq":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logOnceWebWorkerWarning", ()=>logOnceWebWorkerWarning);
/**
 * Main thread side
 */ parcelHelpers.export(exports, "SimpleWorkerClient", ()=>SimpleWorkerClient);
/**
 * Worker side
 */ parcelHelpers.export(exports, "SimpleWorkerServer", ()=>SimpleWorkerServer);
/**
 * Defines the worker entry point. Must be exported and named `create`.
 * @skipMangle
 */ parcelHelpers.export(exports, "create", ()=>create);
var _errorsJs = require("../errors.js");
var _eventJs = require("../event.js");
var _lifecycleJs = require("../lifecycle.js");
var _networkJs = require("../network.js");
var _platformJs = require("../platform.js");
var _stringsJs = require("../strings.js");
// ESM-comment-begin
// const isESM = false;
// ESM-comment-end
// ESM-uncomment-begin
const isESM = true;
// ESM-uncomment-end
const DEFAULT_CHANNEL = "default";
const INITIALIZE = "$initialize";
let webWorkerWarningLogged = false;
function logOnceWebWorkerWarning(err) {
    if (!(0, _platformJs.isWeb)) // running tests
    return;
    if (!webWorkerWarningLogged) {
        webWorkerWarningLogged = true;
        console.warn("Could not create web worker(s). Falling back to loading web worker code in main thread, which might cause UI freezes. Please see https://github.com/microsoft/monaco-editor#faq");
    }
    console.warn(err.message);
}
class RequestMessage {
    constructor(vsWorker, req, channel, method, args){
        this.vsWorker = vsWorker;
        this.req = req;
        this.channel = channel;
        this.method = method;
        this.args = args;
        this.type = 0 /* MessageType.Request */ ;
    }
}
class ReplyMessage {
    constructor(vsWorker, seq, res, err){
        this.vsWorker = vsWorker;
        this.seq = seq;
        this.res = res;
        this.err = err;
        this.type = 1 /* MessageType.Reply */ ;
    }
}
class SubscribeEventMessage {
    constructor(vsWorker, req, channel, eventName, arg){
        this.vsWorker = vsWorker;
        this.req = req;
        this.channel = channel;
        this.eventName = eventName;
        this.arg = arg;
        this.type = 2 /* MessageType.SubscribeEvent */ ;
    }
}
class EventMessage {
    constructor(vsWorker, req, event){
        this.vsWorker = vsWorker;
        this.req = req;
        this.event = event;
        this.type = 3 /* MessageType.Event */ ;
    }
}
class UnsubscribeEventMessage {
    constructor(vsWorker, req){
        this.vsWorker = vsWorker;
        this.req = req;
        this.type = 4 /* MessageType.UnsubscribeEvent */ ;
    }
}
class SimpleWorkerProtocol {
    constructor(handler){
        this._workerId = -1;
        this._handler = handler;
        this._lastSentReq = 0;
        this._pendingReplies = Object.create(null);
        this._pendingEmitters = new Map();
        this._pendingEvents = new Map();
    }
    setWorkerId(workerId) {
        this._workerId = workerId;
    }
    sendMessage(channel, method, args) {
        const req = String(++this._lastSentReq);
        return new Promise((resolve, reject)=>{
            this._pendingReplies[req] = {
                resolve: resolve,
                reject: reject
            };
            this._send(new RequestMessage(this._workerId, req, channel, method, args));
        });
    }
    listen(channel, eventName, arg) {
        let req = null;
        const emitter = new (0, _eventJs.Emitter)({
            onWillAddFirstListener: ()=>{
                req = String(++this._lastSentReq);
                this._pendingEmitters.set(req, emitter);
                this._send(new SubscribeEventMessage(this._workerId, req, channel, eventName, arg));
            },
            onDidRemoveLastListener: ()=>{
                this._pendingEmitters.delete(req);
                this._send(new UnsubscribeEventMessage(this._workerId, req));
                req = null;
            }
        });
        return emitter.event;
    }
    handleMessage(message) {
        if (!message || !message.vsWorker) return;
        if (this._workerId !== -1 && message.vsWorker !== this._workerId) return;
        this._handleMessage(message);
    }
    createProxyToRemoteChannel(channel, sendMessageBarrier) {
        const handler = {
            get: (target, name)=>{
                if (typeof name === "string" && !target[name]) {
                    if (propertyIsDynamicEvent(name)) target[name] = (arg)=>{
                        return this.listen(channel, name, arg);
                    };
                    else if (propertyIsEvent(name)) target[name] = this.listen(channel, name, undefined);
                    else if (name.charCodeAt(0) === 36 /* CharCode.DollarSign */ ) target[name] = async (...myArgs)=>{
                        await sendMessageBarrier?.();
                        return this.sendMessage(channel, name, myArgs);
                    };
                }
                return target[name];
            }
        };
        return new Proxy(Object.create(null), handler);
    }
    _handleMessage(msg) {
        switch(msg.type){
            case 1 /* MessageType.Reply */ :
                return this._handleReplyMessage(msg);
            case 0 /* MessageType.Request */ :
                return this._handleRequestMessage(msg);
            case 2 /* MessageType.SubscribeEvent */ :
                return this._handleSubscribeEventMessage(msg);
            case 3 /* MessageType.Event */ :
                return this._handleEventMessage(msg);
            case 4 /* MessageType.UnsubscribeEvent */ :
                return this._handleUnsubscribeEventMessage(msg);
        }
    }
    _handleReplyMessage(replyMessage) {
        if (!this._pendingReplies[replyMessage.seq]) {
            console.warn("Got reply to unknown seq");
            return;
        }
        const reply = this._pendingReplies[replyMessage.seq];
        delete this._pendingReplies[replyMessage.seq];
        if (replyMessage.err) {
            let err = replyMessage.err;
            if (replyMessage.err.$isError) {
                err = new Error();
                err.name = replyMessage.err.name;
                err.message = replyMessage.err.message;
                err.stack = replyMessage.err.stack;
            }
            reply.reject(err);
            return;
        }
        reply.resolve(replyMessage.res);
    }
    _handleRequestMessage(requestMessage) {
        const req = requestMessage.req;
        const result = this._handler.handleMessage(requestMessage.channel, requestMessage.method, requestMessage.args);
        result.then((r)=>{
            this._send(new ReplyMessage(this._workerId, req, r, undefined));
        }, (e)=>{
            if (e.detail instanceof Error) // Loading errors have a detail property that points to the actual error
            e.detail = (0, _errorsJs.transformErrorForSerialization)(e.detail);
            this._send(new ReplyMessage(this._workerId, req, undefined, (0, _errorsJs.transformErrorForSerialization)(e)));
        });
    }
    _handleSubscribeEventMessage(msg) {
        const req = msg.req;
        const disposable = this._handler.handleEvent(msg.channel, msg.eventName, msg.arg)((event)=>{
            this._send(new EventMessage(this._workerId, req, event));
        });
        this._pendingEvents.set(req, disposable);
    }
    _handleEventMessage(msg) {
        if (!this._pendingEmitters.has(msg.req)) {
            console.warn("Got event for unknown req");
            return;
        }
        this._pendingEmitters.get(msg.req).fire(msg.event);
    }
    _handleUnsubscribeEventMessage(msg) {
        if (!this._pendingEvents.has(msg.req)) {
            console.warn("Got unsubscribe for unknown req");
            return;
        }
        this._pendingEvents.get(msg.req).dispose();
        this._pendingEvents.delete(msg.req);
    }
    _send(msg) {
        const transfer = [];
        if (msg.type === 0 /* MessageType.Request */ ) {
            for(let i = 0; i < msg.args.length; i++)if (msg.args[i] instanceof ArrayBuffer) transfer.push(msg.args[i]);
        } else if (msg.type === 1 /* MessageType.Reply */ ) {
            if (msg.res instanceof ArrayBuffer) transfer.push(msg.res);
        }
        this._handler.sendMessage(msg, transfer);
    }
}
class SimpleWorkerClient extends (0, _lifecycleJs.Disposable) {
    constructor(workerFactory, workerDescriptor){
        super();
        this._localChannels = new Map();
        this._worker = this._register(workerFactory.create({
            amdModuleId: "vs/base/common/worker/simpleWorker",
            esmModuleLocation: workerDescriptor.esmModuleLocation,
            label: workerDescriptor.label
        }, (msg)=>{
            this._protocol.handleMessage(msg);
        }, (err)=>{
            // in Firefox, web workers fail lazily :(
            // we will reject the proxy
            (0, _errorsJs.onUnexpectedError)(err);
        }));
        this._protocol = new SimpleWorkerProtocol({
            sendMessage: (msg, transfer)=>{
                this._worker.postMessage(msg, transfer);
            },
            handleMessage: (channel, method, args)=>{
                return this._handleMessage(channel, method, args);
            },
            handleEvent: (channel, eventName, arg)=>{
                return this._handleEvent(channel, eventName, arg);
            }
        });
        this._protocol.setWorkerId(this._worker.getId());
        // Gather loader configuration
        let loaderConfiguration = null;
        const globalRequire = globalThis.require;
        if (typeof globalRequire !== "undefined" && typeof globalRequire.getConfig === "function") // Get the configuration from the Monaco AMD Loader
        loaderConfiguration = globalRequire.getConfig();
        else if (typeof globalThis.requirejs !== "undefined") // Get the configuration from requirejs
        loaderConfiguration = globalThis.requirejs.s.contexts._.config;
        // Send initialize message
        this._onModuleLoaded = this._protocol.sendMessage(DEFAULT_CHANNEL, INITIALIZE, [
            this._worker.getId(),
            JSON.parse(JSON.stringify(loaderConfiguration)),
            workerDescriptor.amdModuleId
        ]);
        this.proxy = this._protocol.createProxyToRemoteChannel(DEFAULT_CHANNEL, async ()=>{
            await this._onModuleLoaded;
        });
        this._onModuleLoaded.catch((e)=>{
            this._onError("Worker failed to load " + workerDescriptor.amdModuleId, e);
        });
    }
    _handleMessage(channelName, method, args) {
        const channel = this._localChannels.get(channelName);
        if (!channel) return Promise.reject(new Error(`Missing channel ${channelName} on main thread`));
        if (typeof channel[method] !== "function") return Promise.reject(new Error(`Missing method ${method} on main thread channel ${channelName}`));
        try {
            return Promise.resolve(channel[method].apply(channel, args));
        } catch (e) {
            return Promise.reject(e);
        }
    }
    _handleEvent(channelName, eventName, arg) {
        const channel = this._localChannels.get(channelName);
        if (!channel) throw new Error(`Missing channel ${channelName} on main thread`);
        if (propertyIsDynamicEvent(eventName)) {
            const event = channel[eventName].call(channel, arg);
            if (typeof event !== "function") throw new Error(`Missing dynamic event ${eventName} on main thread channel ${channelName}.`);
            return event;
        }
        if (propertyIsEvent(eventName)) {
            const event = channel[eventName];
            if (typeof event !== "function") throw new Error(`Missing event ${eventName} on main thread channel ${channelName}.`);
            return event;
        }
        throw new Error(`Malformed event name ${eventName}`);
    }
    setChannel(channel, handler) {
        this._localChannels.set(channel, handler);
    }
    _onError(message, error) {
        console.error(message);
        console.info(error);
    }
}
function propertyIsEvent(name) {
    // Assume a property is an event if it has a form of "onSomething"
    return name[0] === "o" && name[1] === "n" && _stringsJs.isUpperAsciiLetter(name.charCodeAt(2));
}
function propertyIsDynamicEvent(name) {
    // Assume a property is a dynamic event (a method that returns an event) if it has a form of "onDynamicSomething"
    return /^onDynamic/.test(name) && _stringsJs.isUpperAsciiLetter(name.charCodeAt(9));
}
class SimpleWorkerServer {
    constructor(postMessage, requestHandlerFactory){
        this._localChannels = new Map();
        this._remoteChannels = new Map();
        this._requestHandlerFactory = requestHandlerFactory;
        this._requestHandler = null;
        this._protocol = new SimpleWorkerProtocol({
            sendMessage: (msg, transfer)=>{
                postMessage(msg, transfer);
            },
            handleMessage: (channel, method, args)=>this._handleMessage(channel, method, args),
            handleEvent: (channel, eventName, arg)=>this._handleEvent(channel, eventName, arg)
        });
    }
    onmessage(msg) {
        this._protocol.handleMessage(msg);
    }
    _handleMessage(channel, method, args) {
        if (channel === DEFAULT_CHANNEL && method === INITIALIZE) return this.initialize(args[0], args[1], args[2]);
        const requestHandler = channel === DEFAULT_CHANNEL ? this._requestHandler : this._localChannels.get(channel);
        if (!requestHandler) return Promise.reject(new Error(`Missing channel ${channel} on worker thread`));
        if (typeof requestHandler[method] !== "function") return Promise.reject(new Error(`Missing method ${method} on worker thread channel ${channel}`));
        try {
            return Promise.resolve(requestHandler[method].apply(requestHandler, args));
        } catch (e) {
            return Promise.reject(e);
        }
    }
    _handleEvent(channel, eventName, arg) {
        const requestHandler = channel === DEFAULT_CHANNEL ? this._requestHandler : this._localChannels.get(channel);
        if (!requestHandler) throw new Error(`Missing channel ${channel} on worker thread`);
        if (propertyIsDynamicEvent(eventName)) {
            const event = requestHandler[eventName].call(requestHandler, arg);
            if (typeof event !== "function") throw new Error(`Missing dynamic event ${eventName} on request handler.`);
            return event;
        }
        if (propertyIsEvent(eventName)) {
            const event = requestHandler[eventName];
            if (typeof event !== "function") throw new Error(`Missing event ${eventName} on request handler.`);
            return event;
        }
        throw new Error(`Malformed event name ${eventName}`);
    }
    getChannel(channel) {
        if (!this._remoteChannels.has(channel)) {
            const inst = this._protocol.createProxyToRemoteChannel(channel);
            this._remoteChannels.set(channel, inst);
        }
        return this._remoteChannels.get(channel);
    }
    async initialize(workerId, loaderConfig, moduleId) {
        this._protocol.setWorkerId(workerId);
        if (this._requestHandlerFactory) {
            // static request handler
            this._requestHandler = this._requestHandlerFactory(this);
            return;
        }
        if (loaderConfig) {
            // Remove 'baseUrl', handling it is beyond scope for now
            if (typeof loaderConfig.baseUrl !== "undefined") delete loaderConfig["baseUrl"];
            if (typeof loaderConfig.paths !== "undefined") {
                if (typeof loaderConfig.paths.vs !== "undefined") delete loaderConfig.paths["vs"];
            }
            if (typeof loaderConfig.trustedTypesPolicy !== "undefined") // don't use, it has been destroyed during serialize
            delete loaderConfig["trustedTypesPolicy"];
            // Since this is in a web worker, enable catching errors
            loaderConfig.catchError = true;
            globalThis.require.config(loaderConfig);
        }
        if (isESM) {
            const url = (0, _networkJs.FileAccess).asBrowserUri(`${moduleId}.js`).toString(true);
            return require(`${url}`).then((module)=>{
                this._requestHandler = module.create(this);
                if (!this._requestHandler) throw new Error(`No RequestHandler!`);
            });
        }
        return new Promise((resolve, reject)=>{
            // Use the global require to be sure to get the global config
            // ESM-comment-begin
            // 			const req = (globalThis.require || require);
            // ESM-comment-end
            // ESM-uncomment-begin
            const req = globalThis.require;
            // ESM-uncomment-end
            req([
                moduleId
            ], (module)=>{
                this._requestHandler = module.create(this);
                if (!this._requestHandler) {
                    reject(new Error(`No RequestHandler!`));
                    return;
                }
                resolve();
            }, reject);
        });
    }
}
function create(postMessage) {
    return new SimpleWorkerServer(postMessage, null);
}

},{"../errors.js":"divX8","../event.js":"4Zi8b","../lifecycle.js":"9kg8d","../network.js":"2c1AD","../platform.js":"7maJO","../strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aUlUM":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WorkerDescriptor", ()=>WorkerDescriptor);
parcelHelpers.export(exports, "createWebWorker", ()=>createWebWorker);
var _trustedTypesJs = require("./trustedTypes.js");
var _errorsJs = require("../common/errors.js");
var _networkJs = require("../common/network.js");
var _simpleWorkerJs = require("../common/worker/simpleWorker.js");
var _lifecycleJs = require("../common/lifecycle.js");
var _arraysJs = require("../common/arrays.js");
var _nlsJs = require("../../nls.js");
// ESM-comment-begin
// const isESM = false;
// ESM-comment-end
// ESM-uncomment-begin
const isESM = true;
// ESM-uncomment-end
// Reuse the trusted types policy defined from worker bootstrap
// when available.
// Refs https://github.com/microsoft/vscode/issues/222193
let ttPolicy;
if (typeof self === "object" && self.constructor && self.constructor.name === "DedicatedWorkerGlobalScope" && globalThis.workerttPolicy !== undefined) ttPolicy = globalThis.workerttPolicy;
else ttPolicy = (0, _trustedTypesJs.createTrustedTypesPolicy)("defaultWorkerFactory", {
    createScriptURL: (value)=>value
});
function getWorker(esmWorkerLocation, label) {
    const monacoEnvironment = globalThis.MonacoEnvironment;
    if (monacoEnvironment) {
        if (typeof monacoEnvironment.getWorker === "function") return monacoEnvironment.getWorker("workerMain.js", label);
        if (typeof monacoEnvironment.getWorkerUrl === "function") {
            const workerUrl = monacoEnvironment.getWorkerUrl("workerMain.js", label);
            return new Worker(ttPolicy ? ttPolicy.createScriptURL(workerUrl) : workerUrl, {
                name: label,
                type: isESM ? "module" : undefined
            });
        }
    }
    // ESM-comment-begin
    // 	if (typeof require === 'function') {
    // 		const workerMainLocation = require.toUrl('vs/base/worker/workerMain.js'); // explicitly using require.toUrl(), see https://github.com/microsoft/vscode/issues/107440#issuecomment-698982321
    // 		const factoryModuleId = 'vs/base/worker/defaultWorkerFactory.js';
    // 		const workerBaseUrl = require.toUrl(factoryModuleId).slice(0, -factoryModuleId.length); // explicitly using require.toUrl(), see https://github.com/microsoft/vscode/issues/107440#issuecomment-698982321
    // 		const workerUrl = getWorkerBootstrapUrl(label, workerMainLocation, workerBaseUrl);
    // 		return new Worker(ttPolicy ? ttPolicy.createScriptURL(workerUrl) as unknown as string : workerUrl, { name: label, type: isESM ? 'module' : undefined });
    // 	}
    // ESM-comment-end
    if (esmWorkerLocation) {
        const workerUrl = getWorkerBootstrapUrl(label, esmWorkerLocation.toString(true));
        const worker = new Worker(ttPolicy ? ttPolicy.createScriptURL(workerUrl) : workerUrl, {
            name: label,
            type: isESM ? "module" : undefined
        });
        if (isESM) return whenESMWorkerReady(worker);
        else return worker;
    }
    throw new Error(`You must define a function MonacoEnvironment.getWorkerUrl or MonacoEnvironment.getWorker`);
}
function getWorkerBootstrapUrl(label, workerScriptUrl, workerBaseUrl) {
    const workerScriptUrlIsAbsolute = /^((http:)|(https:)|(file:)|(vscode-file:))/.test(workerScriptUrl);
    if (workerScriptUrlIsAbsolute && workerScriptUrl.substring(0, globalThis.origin.length) !== globalThis.origin) ;
    else {
        const start = workerScriptUrl.lastIndexOf("?");
        const end = workerScriptUrl.lastIndexOf("#", start);
        const params = start > 0 ? new URLSearchParams(workerScriptUrl.substring(start + 1, ~end ? end : undefined)) : new URLSearchParams();
        (0, _networkJs.COI).addSearchParam(params, true, true);
        const search = params.toString();
        if (!search) workerScriptUrl = `${workerScriptUrl}#${label}`;
        else workerScriptUrl = `${workerScriptUrl}?${params.toString()}#${label}`;
    }
    if (!isESM && !workerScriptUrlIsAbsolute) // we have to convert relative script URLs to the origin because importScripts
    // does not work unless the script URL is absolute
    workerScriptUrl = new URL(workerScriptUrl, globalThis.origin).toString();
    const blob = new Blob([
        (0, _arraysJs.coalesce)([
            `/*${label}*/`,
            workerBaseUrl ? `globalThis.MonacoEnvironment = { baseUrl: '${workerBaseUrl}' };` : undefined,
            `globalThis._VSCODE_NLS_MESSAGES = ${JSON.stringify((0, _nlsJs.getNLSMessages)())};`,
            `globalThis._VSCODE_NLS_LANGUAGE = ${JSON.stringify((0, _nlsJs.getNLSLanguage)())};`,
            `globalThis._VSCODE_FILE_ROOT = '${globalThis._VSCODE_FILE_ROOT}';`,
            `const ttPolicy = globalThis.trustedTypes?.createPolicy('defaultWorkerFactory', { createScriptURL: value => value });`,
            `globalThis.workerttPolicy = ttPolicy;`,
            isESM ? `await import(ttPolicy?.createScriptURL('${workerScriptUrl}') ?? '${workerScriptUrl}');` : `importScripts(ttPolicy?.createScriptURL('${workerScriptUrl}') ?? '${workerScriptUrl}');`,
            isESM ? `globalThis.postMessage({ type: 'vscode-worker-ready' });` : undefined,
            `/*${label}*/`
        ]).join("")
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(blob);
}
function whenESMWorkerReady(worker) {
    return new Promise((resolve, reject)=>{
        worker.onmessage = function(e) {
            if (e.data.type === "vscode-worker-ready") {
                worker.onmessage = null;
                resolve(worker);
            }
        };
        worker.onerror = reject;
    });
}
function isPromiseLike(obj) {
    if (typeof obj.then === "function") return true;
    return false;
}
/**
 * A worker that uses HTML5 web workers so that is has
 * its own global scope and its own thread.
 */ class WebWorker extends (0, _lifecycleJs.Disposable) {
    constructor(esmWorkerLocation, amdModuleId, id, label, onMessageCallback, onErrorCallback){
        super();
        this.id = id;
        this.label = label;
        const workerOrPromise = getWorker(esmWorkerLocation, label);
        if (isPromiseLike(workerOrPromise)) this.worker = workerOrPromise;
        else this.worker = Promise.resolve(workerOrPromise);
        this.postMessage(amdModuleId, []);
        this.worker.then((w)=>{
            w.onmessage = function(ev) {
                onMessageCallback(ev.data);
            };
            w.onmessageerror = onErrorCallback;
            if (typeof w.addEventListener === "function") w.addEventListener("error", onErrorCallback);
        });
        this._register((0, _lifecycleJs.toDisposable)(()=>{
            this.worker?.then((w)=>{
                w.onmessage = null;
                w.onmessageerror = null;
                w.removeEventListener("error", onErrorCallback);
                w.terminate();
            });
            this.worker = null;
        }));
    }
    getId() {
        return this.id;
    }
    postMessage(message, transfer) {
        this.worker?.then((w)=>{
            try {
                w.postMessage(message, transfer);
            } catch (err) {
                (0, _errorsJs.onUnexpectedError)(err);
                (0, _errorsJs.onUnexpectedError)(new Error(`FAILED to post message to '${this.label}'-worker`, {
                    cause: err
                }));
            }
        });
    }
}
class WorkerDescriptor {
    constructor(amdModuleId, label){
        this.amdModuleId = amdModuleId;
        this.label = label;
        this.esmModuleLocation = isESM ? (0, _networkJs.FileAccess).asBrowserUri(`${amdModuleId}.esm.js`) : undefined;
    }
}
class DefaultWorkerFactory {
    static{
        this.LAST_WORKER_ID = 0;
    }
    constructor(){
        this._webWorkerFailedBeforeError = false;
    }
    create(desc, onMessageCallback, onErrorCallback) {
        const workerId = ++DefaultWorkerFactory.LAST_WORKER_ID;
        if (this._webWorkerFailedBeforeError) throw this._webWorkerFailedBeforeError;
        return new WebWorker(desc.esmModuleLocation, desc.amdModuleId, workerId, desc.label || "anonymous" + workerId, onMessageCallback, (err)=>{
            (0, _simpleWorkerJs.logOnceWebWorkerWarning)(err);
            this._webWorkerFailedBeforeError = err;
            onErrorCallback(err);
        });
    }
}
function createWebWorker(arg0, arg1) {
    const workerDescriptor = typeof arg0 === "string" ? new WorkerDescriptor(arg0, arg1) : arg0;
    return new (0, _simpleWorkerJs.SimpleWorkerClient)(new DefaultWorkerFactory(), workerDescriptor);
}

},{"./trustedTypes.js":"bgQyv","../common/errors.js":"divX8","../common/network.js":"2c1AD","../common/worker/simpleWorker.js":"6ILMq","../common/lifecycle.js":"9kg8d","../common/arrays.js":"DECei","../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bgQyv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createTrustedTypesPolicy", ()=>createTrustedTypesPolicy);
var _errorsJs = require("../common/errors.js");
function createTrustedTypesPolicy(policyName, policyOptions) {
    const monacoEnvironment = globalThis.MonacoEnvironment;
    if (monacoEnvironment?.createTrustedTypesPolicy) try {
        return monacoEnvironment.createTrustedTypesPolicy(policyName, policyOptions);
    } catch (err) {
        (0, _errorsJs.onUnexpectedError)(err);
        return undefined;
    }
    try {
        return globalThis.trustedTypes?.createPolicy(policyName, policyOptions);
    } catch (err) {
        (0, _errorsJs.onUnexpectedError)(err);
        return undefined;
    }
}

},{"../common/errors.js":"divX8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Lk9v":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LanguageConfigurationServiceChangeEvent", ()=>LanguageConfigurationServiceChangeEvent);
parcelHelpers.export(exports, "ILanguageConfigurationService", ()=>ILanguageConfigurationService);
parcelHelpers.export(exports, "LanguageConfigurationService", ()=>LanguageConfigurationService);
parcelHelpers.export(exports, "getIndentationAtPosition", ()=>getIndentationAtPosition);
parcelHelpers.export(exports, "LanguageConfigurationChangeEvent", ()=>LanguageConfigurationChangeEvent);
parcelHelpers.export(exports, "LanguageConfigurationRegistry", ()=>LanguageConfigurationRegistry);
/**
 * Immutable.
*/ parcelHelpers.export(exports, "ResolvedLanguageConfiguration", ()=>ResolvedLanguageConfiguration);
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _stringsJs = require("../../../base/common/strings.js");
var _wordHelperJs = require("../core/wordHelper.js");
var _languageConfigurationJs = require("./languageConfiguration.js");
var _characterPairJs = require("./supports/characterPair.js");
var _electricCharacterJs = require("./supports/electricCharacter.js");
var _indentRulesJs = require("./supports/indentRules.js");
var _onEnterJs = require("./supports/onEnter.js");
var _richEditBracketsJs = require("./supports/richEditBrackets.js");
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
var _configurationJs = require("../../../platform/configuration/common/configuration.js");
var _languageJs = require("./language.js");
var _extensionsJs = require("../../../platform/instantiation/common/extensions.js");
var _modesRegistryJs = require("./modesRegistry.js");
var _languageBracketsConfigurationJs = require("./supports/languageBracketsConfiguration.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class LanguageConfigurationServiceChangeEvent {
    constructor(languageId){
        this.languageId = languageId;
    }
    affects(languageId) {
        return !this.languageId ? true : this.languageId === languageId;
    }
}
const ILanguageConfigurationService = (0, _instantiationJs.createDecorator)("languageConfigurationService");
let LanguageConfigurationService = class LanguageConfigurationService extends (0, _lifecycleJs.Disposable) {
    constructor(configurationService, languageService){
        super();
        this.configurationService = configurationService;
        this.languageService = languageService;
        this._registry = this._register(new LanguageConfigurationRegistry());
        this.onDidChangeEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onDidChange = this.onDidChangeEmitter.event;
        this.configurations = new Map();
        const languageConfigKeys = new Set(Object.values(customizedLanguageConfigKeys));
        this._register(this.configurationService.onDidChangeConfiguration((e)=>{
            const globalConfigChanged = e.change.keys.some((k)=>languageConfigKeys.has(k));
            const localConfigChanged = e.change.overrides.filter(([overrideLangName, keys])=>keys.some((k)=>languageConfigKeys.has(k))).map(([overrideLangName])=>overrideLangName);
            if (globalConfigChanged) {
                this.configurations.clear();
                this.onDidChangeEmitter.fire(new LanguageConfigurationServiceChangeEvent(undefined));
            } else {
                for (const languageId of localConfigChanged)if (this.languageService.isRegisteredLanguageId(languageId)) {
                    this.configurations.delete(languageId);
                    this.onDidChangeEmitter.fire(new LanguageConfigurationServiceChangeEvent(languageId));
                }
            }
        }));
        this._register(this._registry.onDidChange((e)=>{
            this.configurations.delete(e.languageId);
            this.onDidChangeEmitter.fire(new LanguageConfigurationServiceChangeEvent(e.languageId));
        }));
    }
    register(languageId, configuration, priority) {
        return this._registry.register(languageId, configuration, priority);
    }
    getLanguageConfiguration(languageId) {
        let result = this.configurations.get(languageId);
        if (!result) {
            result = computeConfig(languageId, this._registry, this.configurationService, this.languageService);
            this.configurations.set(languageId, result);
        }
        return result;
    }
};
LanguageConfigurationService = __decorate([
    __param(0, (0, _configurationJs.IConfigurationService)),
    __param(1, (0, _languageJs.ILanguageService))
], LanguageConfigurationService);
function computeConfig(languageId, registry, configurationService, languageService) {
    let languageConfig = registry.getLanguageConfiguration(languageId);
    if (!languageConfig) {
        if (!languageService.isRegisteredLanguageId(languageId)) // this happens for the null language, which can be returned by monarch.
        // Instead of throwing an error, we just return a default config.
        return new ResolvedLanguageConfiguration(languageId, {});
        languageConfig = new ResolvedLanguageConfiguration(languageId, {});
    }
    const customizedConfig = getCustomizedLanguageConfig(languageConfig.languageId, configurationService);
    const data = combineLanguageConfigurations([
        languageConfig.underlyingConfig,
        customizedConfig
    ]);
    const config = new ResolvedLanguageConfiguration(languageConfig.languageId, data);
    return config;
}
const customizedLanguageConfigKeys = {
    brackets: "editor.language.brackets",
    colorizedBracketPairs: "editor.language.colorizedBracketPairs"
};
function getCustomizedLanguageConfig(languageId, configurationService) {
    const brackets = configurationService.getValue(customizedLanguageConfigKeys.brackets, {
        overrideIdentifier: languageId
    });
    const colorizedBracketPairs = configurationService.getValue(customizedLanguageConfigKeys.colorizedBracketPairs, {
        overrideIdentifier: languageId
    });
    return {
        brackets: validateBracketPairs(brackets),
        colorizedBracketPairs: validateBracketPairs(colorizedBracketPairs)
    };
}
function validateBracketPairs(data) {
    if (!Array.isArray(data)) return undefined;
    return data.map((pair)=>{
        if (!Array.isArray(pair) || pair.length !== 2) return undefined;
        return [
            pair[0],
            pair[1]
        ];
    }).filter((p)=>!!p);
}
function getIndentationAtPosition(model, lineNumber, column) {
    const lineText = model.getLineContent(lineNumber);
    let indentation = _stringsJs.getLeadingWhitespace(lineText);
    if (indentation.length > column - 1) indentation = indentation.substring(0, column - 1);
    return indentation;
}
class ComposedLanguageConfiguration {
    constructor(languageId){
        this.languageId = languageId;
        this._resolved = null;
        this._entries = [];
        this._order = 0;
        this._resolved = null;
    }
    register(configuration, priority) {
        const entry = new LanguageConfigurationContribution(configuration, priority, ++this._order);
        this._entries.push(entry);
        this._resolved = null;
        return (0, _lifecycleJs.toDisposable)(()=>{
            for(let i = 0; i < this._entries.length; i++)if (this._entries[i] === entry) {
                this._entries.splice(i, 1);
                this._resolved = null;
                break;
            }
        });
    }
    getResolvedConfiguration() {
        if (!this._resolved) {
            const config = this._resolve();
            if (config) this._resolved = new ResolvedLanguageConfiguration(this.languageId, config);
        }
        return this._resolved;
    }
    _resolve() {
        if (this._entries.length === 0) return null;
        this._entries.sort(LanguageConfigurationContribution.cmp);
        return combineLanguageConfigurations(this._entries.map((e)=>e.configuration));
    }
}
function combineLanguageConfigurations(configs) {
    let result = {
        comments: undefined,
        brackets: undefined,
        wordPattern: undefined,
        indentationRules: undefined,
        onEnterRules: undefined,
        autoClosingPairs: undefined,
        surroundingPairs: undefined,
        autoCloseBefore: undefined,
        folding: undefined,
        colorizedBracketPairs: undefined,
        __electricCharacterSupport: undefined
    };
    for (const entry of configs)result = {
        comments: entry.comments || result.comments,
        brackets: entry.brackets || result.brackets,
        wordPattern: entry.wordPattern || result.wordPattern,
        indentationRules: entry.indentationRules || result.indentationRules,
        onEnterRules: entry.onEnterRules || result.onEnterRules,
        autoClosingPairs: entry.autoClosingPairs || result.autoClosingPairs,
        surroundingPairs: entry.surroundingPairs || result.surroundingPairs,
        autoCloseBefore: entry.autoCloseBefore || result.autoCloseBefore,
        folding: entry.folding || result.folding,
        colorizedBracketPairs: entry.colorizedBracketPairs || result.colorizedBracketPairs,
        __electricCharacterSupport: entry.__electricCharacterSupport || result.__electricCharacterSupport
    };
    return result;
}
class LanguageConfigurationContribution {
    constructor(configuration, priority, order){
        this.configuration = configuration;
        this.priority = priority;
        this.order = order;
    }
    static cmp(a, b) {
        if (a.priority === b.priority) // higher order last
        return a.order - b.order;
        // higher priority last
        return a.priority - b.priority;
    }
}
class LanguageConfigurationChangeEvent {
    constructor(languageId){
        this.languageId = languageId;
    }
}
class LanguageConfigurationRegistry extends (0, _lifecycleJs.Disposable) {
    constructor(){
        super();
        this._entries = new Map();
        this._onDidChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidChange = this._onDidChange.event;
        this._register(this.register((0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID), {
            brackets: [
                [
                    "(",
                    ")"
                ],
                [
                    "[",
                    "]"
                ],
                [
                    "{",
                    "}"
                ]
            ],
            surroundingPairs: [
                {
                    open: "{",
                    close: "}"
                },
                {
                    open: "[",
                    close: "]"
                },
                {
                    open: "(",
                    close: ")"
                },
                {
                    open: "<",
                    close: ">"
                },
                {
                    open: '"',
                    close: '"'
                },
                {
                    open: "'",
                    close: "'"
                },
                {
                    open: "`",
                    close: "`"
                }
            ],
            colorizedBracketPairs: [],
            folding: {
                offSide: true
            }
        }, 0));
    }
    /**
     * @param priority Use a higher number for higher priority
     */ register(languageId, configuration, priority = 0) {
        let entries = this._entries.get(languageId);
        if (!entries) {
            entries = new ComposedLanguageConfiguration(languageId);
            this._entries.set(languageId, entries);
        }
        const disposable = entries.register(configuration, priority);
        this._onDidChange.fire(new LanguageConfigurationChangeEvent(languageId));
        return (0, _lifecycleJs.toDisposable)(()=>{
            disposable.dispose();
            this._onDidChange.fire(new LanguageConfigurationChangeEvent(languageId));
        });
    }
    getLanguageConfiguration(languageId) {
        const entries = this._entries.get(languageId);
        return entries?.getResolvedConfiguration() || null;
    }
}
class ResolvedLanguageConfiguration {
    constructor(languageId, underlyingConfig){
        this.languageId = languageId;
        this.underlyingConfig = underlyingConfig;
        this._brackets = null;
        this._electricCharacter = null;
        this._onEnterSupport = this.underlyingConfig.brackets || this.underlyingConfig.indentationRules || this.underlyingConfig.onEnterRules ? new (0, _onEnterJs.OnEnterSupport)(this.underlyingConfig) : null;
        this.comments = ResolvedLanguageConfiguration._handleComments(this.underlyingConfig);
        this.characterPair = new (0, _characterPairJs.CharacterPairSupport)(this.underlyingConfig);
        this.wordDefinition = this.underlyingConfig.wordPattern || (0, _wordHelperJs.DEFAULT_WORD_REGEXP);
        this.indentationRules = this.underlyingConfig.indentationRules;
        if (this.underlyingConfig.indentationRules) this.indentRulesSupport = new (0, _indentRulesJs.IndentRulesSupport)(this.underlyingConfig.indentationRules);
        else this.indentRulesSupport = null;
        this.foldingRules = this.underlyingConfig.folding || {};
        this.bracketsNew = new (0, _languageBracketsConfigurationJs.LanguageBracketsConfiguration)(languageId, this.underlyingConfig);
    }
    getWordDefinition() {
        return (0, _wordHelperJs.ensureValidWordDefinition)(this.wordDefinition);
    }
    get brackets() {
        if (!this._brackets && this.underlyingConfig.brackets) this._brackets = new (0, _richEditBracketsJs.RichEditBrackets)(this.languageId, this.underlyingConfig.brackets);
        return this._brackets;
    }
    get electricCharacter() {
        if (!this._electricCharacter) this._electricCharacter = new (0, _electricCharacterJs.BracketElectricCharacterSupport)(this.brackets);
        return this._electricCharacter;
    }
    onEnter(autoIndent, previousLineText, beforeEnterText, afterEnterText) {
        if (!this._onEnterSupport) return null;
        return this._onEnterSupport.onEnter(autoIndent, previousLineText, beforeEnterText, afterEnterText);
    }
    getAutoClosingPairs() {
        return new (0, _languageConfigurationJs.AutoClosingPairs)(this.characterPair.getAutoClosingPairs());
    }
    getAutoCloseBeforeSet(forQuotes) {
        return this.characterPair.getAutoCloseBeforeSet(forQuotes);
    }
    getSurroundingPairs() {
        return this.characterPair.getSurroundingPairs();
    }
    static _handleComments(conf) {
        const commentRule = conf.comments;
        if (!commentRule) return null;
        // comment configuration
        const comments = {};
        if (commentRule.lineComment) comments.lineCommentToken = commentRule.lineComment;
        if (commentRule.blockComment) {
            const [blockStart, blockEnd] = commentRule.blockComment;
            comments.blockCommentStartToken = blockStart;
            comments.blockCommentEndToken = blockEnd;
        }
        return comments;
    }
}
(0, _extensionsJs.registerSingleton)(ILanguageConfigurationService, LanguageConfigurationService, 1 /* InstantiationType.Delayed */ );

},{"../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/strings.js":"aA9I1","../core/wordHelper.js":"9FjxX","./languageConfiguration.js":"1ojaS","./supports/characterPair.js":"gfcS7","./supports/electricCharacter.js":"iqpkc","./supports/indentRules.js":"9SUpA","./supports/onEnter.js":"1alJG","./supports/richEditBrackets.js":"hHyd8","../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../platform/configuration/common/configuration.js":"dXkjq","./language.js":"ka2JQ","../../../platform/instantiation/common/extensions.js":"6WJLq","./modesRegistry.js":"gqkb7","./supports/languageBracketsConfiguration.js":"evcBn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ojaS":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 * Describes what to do with the indentation when pressing Enter.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IndentAction", ()=>IndentAction);
/**
 * @internal
 */ parcelHelpers.export(exports, "StandardAutoClosingPairConditional", ()=>StandardAutoClosingPairConditional);
/**
 * @internal
 */ parcelHelpers.export(exports, "AutoClosingPairs", ()=>AutoClosingPairs);
var IndentAction;
(function(IndentAction) {
    /**
     * Insert new line and copy the previous line's indentation.
     */ IndentAction[IndentAction["None"] = 0] = "None";
    /**
     * Insert new line and indent once (relative to the previous line's indentation).
     */ IndentAction[IndentAction["Indent"] = 1] = "Indent";
    /**
     * Insert two new lines:
     *  - the first one indented which will hold the cursor
     *  - the second one at the same indentation level
     */ IndentAction[IndentAction["IndentOutdent"] = 2] = "IndentOutdent";
    /**
     * Insert new line and outdent once (relative to the previous line's indentation).
     */ IndentAction[IndentAction["Outdent"] = 3] = "Outdent";
})(IndentAction || (IndentAction = {}));
class StandardAutoClosingPairConditional {
    constructor(source){
        this._neutralCharacter = null;
        this._neutralCharacterSearched = false;
        this.open = source.open;
        this.close = source.close;
        // initially allowed in all tokens
        this._inString = true;
        this._inComment = true;
        this._inRegEx = true;
        if (Array.isArray(source.notIn)) for(let i = 0, len = source.notIn.length; i < len; i++){
            const notIn = source.notIn[i];
            switch(notIn){
                case "string":
                    this._inString = false;
                    break;
                case "comment":
                    this._inComment = false;
                    break;
                case "regex":
                    this._inRegEx = false;
                    break;
            }
        }
    }
    isOK(standardToken) {
        switch(standardToken){
            case 0 /* StandardTokenType.Other */ :
                return true;
            case 1 /* StandardTokenType.Comment */ :
                return this._inComment;
            case 2 /* StandardTokenType.String */ :
                return this._inString;
            case 3 /* StandardTokenType.RegEx */ :
                return this._inRegEx;
        }
    }
    shouldAutoClose(context, column) {
        // Always complete on empty line
        if (context.getTokenCount() === 0) return true;
        const tokenIndex = context.findTokenIndexAtOffset(column - 2);
        const standardTokenType = context.getStandardTokenType(tokenIndex);
        return this.isOK(standardTokenType);
    }
    _findNeutralCharacterInRange(fromCharCode, toCharCode) {
        for(let charCode = fromCharCode; charCode <= toCharCode; charCode++){
            const character = String.fromCharCode(charCode);
            if (!this.open.includes(character) && !this.close.includes(character)) return character;
        }
        return null;
    }
    /**
     * Find a character in the range [0-9a-zA-Z] that does not appear in the open or close
     */ findNeutralCharacter() {
        if (!this._neutralCharacterSearched) {
            this._neutralCharacterSearched = true;
            if (!this._neutralCharacter) this._neutralCharacter = this._findNeutralCharacterInRange(48 /* CharCode.Digit0 */ , 57 /* CharCode.Digit9 */ );
            if (!this._neutralCharacter) this._neutralCharacter = this._findNeutralCharacterInRange(97 /* CharCode.a */ , 122 /* CharCode.z */ );
            if (!this._neutralCharacter) this._neutralCharacter = this._findNeutralCharacterInRange(65 /* CharCode.A */ , 90 /* CharCode.Z */ );
        }
        return this._neutralCharacter;
    }
}
class AutoClosingPairs {
    constructor(autoClosingPairs){
        this.autoClosingPairsOpenByStart = new Map();
        this.autoClosingPairsOpenByEnd = new Map();
        this.autoClosingPairsCloseByStart = new Map();
        this.autoClosingPairsCloseByEnd = new Map();
        this.autoClosingPairsCloseSingleChar = new Map();
        for (const pair of autoClosingPairs){
            appendEntry(this.autoClosingPairsOpenByStart, pair.open.charAt(0), pair);
            appendEntry(this.autoClosingPairsOpenByEnd, pair.open.charAt(pair.open.length - 1), pair);
            appendEntry(this.autoClosingPairsCloseByStart, pair.close.charAt(0), pair);
            appendEntry(this.autoClosingPairsCloseByEnd, pair.close.charAt(pair.close.length - 1), pair);
            if (pair.close.length === 1 && pair.open.length === 1) appendEntry(this.autoClosingPairsCloseSingleChar, pair.close, pair);
        }
    }
}
function appendEntry(target, key, value) {
    if (target.has(key)) target.get(key).push(value);
    else target.set(key, [
        value
    ]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gfcS7":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CharacterPairSupport", ()=>CharacterPairSupport);
var _languageConfigurationJs = require("../languageConfiguration.js");
class CharacterPairSupport {
    static{
        this.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_QUOTES = ";:.,=}])> \n	";
    }
    static{
        this.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_BRACKETS = "'\"`;:.,=}])> \n	";
    }
    constructor(config){
        if (config.autoClosingPairs) this._autoClosingPairs = config.autoClosingPairs.map((el)=>new (0, _languageConfigurationJs.StandardAutoClosingPairConditional)(el));
        else if (config.brackets) this._autoClosingPairs = config.brackets.map((b)=>new (0, _languageConfigurationJs.StandardAutoClosingPairConditional)({
                open: b[0],
                close: b[1]
            }));
        else this._autoClosingPairs = [];
        if (config.__electricCharacterSupport && config.__electricCharacterSupport.docComment) {
            const docComment = config.__electricCharacterSupport.docComment;
            // IDocComment is legacy, only partially supported
            this._autoClosingPairs.push(new (0, _languageConfigurationJs.StandardAutoClosingPairConditional)({
                open: docComment.open,
                close: docComment.close || ""
            }));
        }
        this._autoCloseBeforeForQuotes = typeof config.autoCloseBefore === "string" ? config.autoCloseBefore : CharacterPairSupport.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_QUOTES;
        this._autoCloseBeforeForBrackets = typeof config.autoCloseBefore === "string" ? config.autoCloseBefore : CharacterPairSupport.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_BRACKETS;
        this._surroundingPairs = config.surroundingPairs || this._autoClosingPairs;
    }
    getAutoClosingPairs() {
        return this._autoClosingPairs;
    }
    getAutoCloseBeforeSet(forQuotes) {
        return forQuotes ? this._autoCloseBeforeForQuotes : this._autoCloseBeforeForBrackets;
    }
    getSurroundingPairs() {
        return this._surroundingPairs;
    }
}

},{"../languageConfiguration.js":"1ojaS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iqpkc":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BracketElectricCharacterSupport", ()=>BracketElectricCharacterSupport);
var _arraysJs = require("../../../../base/common/arrays.js");
var _supportsJs = require("../supports.js");
var _richEditBracketsJs = require("./richEditBrackets.js");
class BracketElectricCharacterSupport {
    constructor(richEditBrackets){
        this._richEditBrackets = richEditBrackets;
    }
    getElectricCharacters() {
        const result = [];
        if (this._richEditBrackets) {
            for (const bracket of this._richEditBrackets.brackets)for (const close of bracket.close){
                const lastChar = close.charAt(close.length - 1);
                result.push(lastChar);
            }
        }
        return (0, _arraysJs.distinct)(result);
    }
    onElectricCharacter(character, context, column) {
        if (!this._richEditBrackets || this._richEditBrackets.brackets.length === 0) return null;
        const tokenIndex = context.findTokenIndexAtOffset(column - 1);
        if ((0, _supportsJs.ignoreBracketsInToken)(context.getStandardTokenType(tokenIndex))) return null;
        const reversedBracketRegex = this._richEditBrackets.reversedRegex;
        const text = context.getLineContent().substring(0, column - 1) + character;
        const r = (0, _richEditBracketsJs.BracketsUtils).findPrevBracketInRange(reversedBracketRegex, 1, text, 0, text.length);
        if (!r) return null;
        const bracketText = text.substring(r.startColumn - 1, r.endColumn - 1).toLowerCase();
        const isOpen = this._richEditBrackets.textIsOpenBracket[bracketText];
        if (isOpen) return null;
        const textBeforeBracket = context.getActualLineContentBefore(r.startColumn - 1);
        if (!/^\s*$/.test(textBeforeBracket)) // There is other text on the line before the bracket
        return null;
        return {
            matchOpenBracket: bracketText
        };
    }
}

},{"../../../../base/common/arrays.js":"DECei","../supports.js":"aA5lJ","./richEditBrackets.js":"hHyd8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aA5lJ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScopedLineTokens", ()=>createScopedLineTokens);
parcelHelpers.export(exports, "ScopedLineTokens", ()=>ScopedLineTokens);
parcelHelpers.export(exports, "ignoreBracketsInToken", ()=>ignoreBracketsInToken);
function createScopedLineTokens(context, offset) {
    const tokenCount = context.getCount();
    const tokenIndex = context.findTokenIndexAtOffset(offset);
    const desiredLanguageId = context.getLanguageId(tokenIndex);
    let lastTokenIndex = tokenIndex;
    while(lastTokenIndex + 1 < tokenCount && context.getLanguageId(lastTokenIndex + 1) === desiredLanguageId)lastTokenIndex++;
    let firstTokenIndex = tokenIndex;
    while(firstTokenIndex > 0 && context.getLanguageId(firstTokenIndex - 1) === desiredLanguageId)firstTokenIndex--;
    return new ScopedLineTokens(context, desiredLanguageId, firstTokenIndex, lastTokenIndex + 1, context.getStartOffset(firstTokenIndex), context.getEndOffset(lastTokenIndex));
}
class ScopedLineTokens {
    constructor(actual, languageId, firstTokenIndex, lastTokenIndex, firstCharOffset, lastCharOffset){
        this._scopedLineTokensBrand = undefined;
        this._actual = actual;
        this.languageId = languageId;
        this._firstTokenIndex = firstTokenIndex;
        this._lastTokenIndex = lastTokenIndex;
        this.firstCharOffset = firstCharOffset;
        this._lastCharOffset = lastCharOffset;
        this.languageIdCodec = actual.languageIdCodec;
    }
    getLineContent() {
        const actualLineContent = this._actual.getLineContent();
        return actualLineContent.substring(this.firstCharOffset, this._lastCharOffset);
    }
    getLineLength() {
        return this._lastCharOffset - this.firstCharOffset;
    }
    getActualLineContentBefore(offset) {
        const actualLineContent = this._actual.getLineContent();
        return actualLineContent.substring(0, this.firstCharOffset + offset);
    }
    getTokenCount() {
        return this._lastTokenIndex - this._firstTokenIndex;
    }
    findTokenIndexAtOffset(offset) {
        return this._actual.findTokenIndexAtOffset(offset + this.firstCharOffset) - this._firstTokenIndex;
    }
    getStandardTokenType(tokenIndex) {
        return this._actual.getStandardTokenType(tokenIndex + this._firstTokenIndex);
    }
    toIViewLineTokens() {
        return this._actual.sliceAndInflate(this.firstCharOffset, this._lastCharOffset, 0);
    }
}
function ignoreBracketsInToken(standardTokenType) {
    return (standardTokenType & 3 /* IgnoreBracketsInTokens.value */ ) !== 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hHyd8":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a grouping of colliding bracket pairs.
 *
 * Most of the times this contains a single bracket pair,
 * but sometimes this contains multiple bracket pairs in cases
 * where the same string appears as a closing bracket for multiple
 * bracket pairs, or the same string appears an opening bracket for
 * multiple bracket pairs.
 *
 * e.g. of a group containing a single pair:
 *   open: ['{'], close: ['}']
 *
 * e.g. of a group containing multiple pairs:
 *   open: ['if', 'for'], close: ['end', 'end']
 */ parcelHelpers.export(exports, "RichEditBracket", ()=>RichEditBracket);
parcelHelpers.export(exports, "RichEditBrackets", ()=>RichEditBrackets);
parcelHelpers.export(exports, "createBracketOrRegExp", ()=>createBracketOrRegExp);
parcelHelpers.export(exports, "BracketsUtils", ()=>BracketsUtils);
var _stringsJs = require("../../../../base/common/strings.js");
var _stringBuilderJs = require("../../core/stringBuilder.js");
var _rangeJs = require("../../core/range.js");
class RichEditBracket {
    constructor(languageId, index, open, close, forwardRegex, reversedRegex){
        this._richEditBracketBrand = undefined;
        this.languageId = languageId;
        this.index = index;
        this.open = open;
        this.close = close;
        this.forwardRegex = forwardRegex;
        this.reversedRegex = reversedRegex;
        this._openSet = RichEditBracket._toSet(this.open);
        this._closeSet = RichEditBracket._toSet(this.close);
    }
    /**
     * Check if the provided `text` is an open bracket in this group.
     */ isOpen(text) {
        return this._openSet.has(text);
    }
    /**
     * Check if the provided `text` is a close bracket in this group.
     */ isClose(text) {
        return this._closeSet.has(text);
    }
    static _toSet(arr) {
        const result = new Set();
        for (const element of arr)result.add(element);
        return result;
    }
}
/**
 * Groups together brackets that have equal open or close sequences.
 *
 * For example, if the following brackets are defined:
 *   ['IF','END']
 *   ['for','end']
 *   ['{','}']
 *
 * Then the grouped brackets would be:
 *   { open: ['if', 'for'], close: ['end', 'end'] }
 *   { open: ['{'], close: ['}'] }
 *
 */ function groupFuzzyBrackets(brackets) {
    const N = brackets.length;
    brackets = brackets.map((b)=>[
            b[0].toLowerCase(),
            b[1].toLowerCase()
        ]);
    const group = [];
    for(let i = 0; i < N; i++)group[i] = i;
    const areOverlapping = (a, b)=>{
        const [aOpen, aClose] = a;
        const [bOpen, bClose] = b;
        return aOpen === bOpen || aOpen === bClose || aClose === bOpen || aClose === bClose;
    };
    const mergeGroups = (g1, g2)=>{
        const newG = Math.min(g1, g2);
        const oldG = Math.max(g1, g2);
        for(let i = 0; i < N; i++)if (group[i] === oldG) group[i] = newG;
    };
    // group together brackets that have the same open or the same close sequence
    for(let i = 0; i < N; i++){
        const a = brackets[i];
        for(let j = i + 1; j < N; j++){
            const b = brackets[j];
            if (areOverlapping(a, b)) mergeGroups(group[i], group[j]);
        }
    }
    const result = [];
    for(let g = 0; g < N; g++){
        const currentOpen = [];
        const currentClose = [];
        for(let i = 0; i < N; i++)if (group[i] === g) {
            const [open, close] = brackets[i];
            currentOpen.push(open);
            currentClose.push(close);
        }
        if (currentOpen.length > 0) result.push({
            open: currentOpen,
            close: currentClose
        });
    }
    return result;
}
class RichEditBrackets {
    constructor(languageId, _brackets){
        this._richEditBracketsBrand = undefined;
        const brackets = groupFuzzyBrackets(_brackets);
        this.brackets = brackets.map((b, index)=>{
            return new RichEditBracket(languageId, index, b.open, b.close, getRegexForBracketPair(b.open, b.close, brackets, index), getReversedRegexForBracketPair(b.open, b.close, brackets, index));
        });
        this.forwardRegex = getRegexForBrackets(this.brackets);
        this.reversedRegex = getReversedRegexForBrackets(this.brackets);
        this.textIsBracket = {};
        this.textIsOpenBracket = {};
        this.maxBracketLength = 0;
        for (const bracket of this.brackets){
            for (const open of bracket.open){
                this.textIsBracket[open] = bracket;
                this.textIsOpenBracket[open] = true;
                this.maxBracketLength = Math.max(this.maxBracketLength, open.length);
            }
            for (const close of bracket.close){
                this.textIsBracket[close] = bracket;
                this.textIsOpenBracket[close] = false;
                this.maxBracketLength = Math.max(this.maxBracketLength, close.length);
            }
        }
    }
}
function collectSuperstrings(str, brackets, currentIndex, dest) {
    for(let i = 0, len = brackets.length; i < len; i++){
        if (i === currentIndex) continue;
        const bracket = brackets[i];
        for (const open of bracket.open)if (open.indexOf(str) >= 0) dest.push(open);
        for (const close of bracket.close)if (close.indexOf(str) >= 0) dest.push(close);
    }
}
function lengthcmp(a, b) {
    return a.length - b.length;
}
function unique(arr) {
    if (arr.length <= 1) return arr;
    const result = [];
    const seen = new Set();
    for (const element of arr){
        if (seen.has(element)) continue;
        result.push(element);
        seen.add(element);
    }
    return result;
}
/**
 * Create a regular expression that can be used to search forward in a piece of text
 * for a group of bracket pairs. But this regex must be built in a way in which
 * it is aware of the other bracket pairs defined for the language.
 *
 * For example, if a language contains the following bracket pairs:
 *   ['begin', 'end']
 *   ['if', 'end if']
 * The two bracket pairs do not collide because no open or close brackets are equal.
 * So the function getRegexForBracketPair is called twice, once with
 * the ['begin'], ['end'] group consisting of one bracket pair, and once with
 * the ['if'], ['end if'] group consiting of the other bracket pair.
 *
 * But there could be a situation where an occurrence of 'end if' is mistaken
 * for an occurrence of 'end'.
 *
 * Therefore, for the bracket pair ['begin', 'end'], the regex will also
 * target 'end if'. The regex will be something like:
 *   /(\bend if\b)|(\bend\b)|(\bif\b)/
 *
 * The regex also searches for "superstrings" (other brackets that might be mistaken with the current bracket).
 *
 */ function getRegexForBracketPair(open, close, brackets, currentIndex) {
    // search in all brackets for other brackets that are a superstring of these brackets
    let pieces = [];
    pieces = pieces.concat(open);
    pieces = pieces.concat(close);
    for(let i = 0, len = pieces.length; i < len; i++)collectSuperstrings(pieces[i], brackets, currentIndex, pieces);
    pieces = unique(pieces);
    pieces.sort(lengthcmp);
    pieces.reverse();
    return createBracketOrRegExp(pieces);
}
/**
 * Matching a regular expression in JS can only be done "forwards". So JS offers natively only
 * methods to find the first match of a regex in a string. But sometimes, it is useful to
 * find the last match of a regex in a string. For such a situation, a nice solution is to
 * simply reverse the string and then search for a reversed regex.
 *
 * This function also has the fine details of `getRegexForBracketPair`. For the same example
 * given above, the regex produced here would look like:
 *   /(\bfi dne\b)|(\bdne\b)|(\bfi\b)/
 */ function getReversedRegexForBracketPair(open, close, brackets, currentIndex) {
    // search in all brackets for other brackets that are a superstring of these brackets
    let pieces = [];
    pieces = pieces.concat(open);
    pieces = pieces.concat(close);
    for(let i = 0, len = pieces.length; i < len; i++)collectSuperstrings(pieces[i], brackets, currentIndex, pieces);
    pieces = unique(pieces);
    pieces.sort(lengthcmp);
    pieces.reverse();
    return createBracketOrRegExp(pieces.map(toReversedString));
}
/**
 * Creates a regular expression that targets all bracket pairs.
 *
 * e.g. for the bracket pairs:
 *  ['{','}']
 *  ['begin,'end']
 *  ['for','end']
 * the regex would look like:
 *  /(\{)|(\})|(\bbegin\b)|(\bend\b)|(\bfor\b)/
 */ function getRegexForBrackets(brackets) {
    let pieces = [];
    for (const bracket of brackets){
        for (const open of bracket.open)pieces.push(open);
        for (const close of bracket.close)pieces.push(close);
    }
    pieces = unique(pieces);
    return createBracketOrRegExp(pieces);
}
/**
 * Matching a regular expression in JS can only be done "forwards". So JS offers natively only
 * methods to find the first match of a regex in a string. But sometimes, it is useful to
 * find the last match of a regex in a string. For such a situation, a nice solution is to
 * simply reverse the string and then search for a reversed regex.
 *
 * e.g. for the bracket pairs:
 *  ['{','}']
 *  ['begin,'end']
 *  ['for','end']
 * the regex would look like:
 *  /(\{)|(\})|(\bnigeb\b)|(\bdne\b)|(\brof\b)/
 */ function getReversedRegexForBrackets(brackets) {
    let pieces = [];
    for (const bracket of brackets){
        for (const open of bracket.open)pieces.push(open);
        for (const close of bracket.close)pieces.push(close);
    }
    pieces = unique(pieces);
    return createBracketOrRegExp(pieces.map(toReversedString));
}
function prepareBracketForRegExp(str) {
    // This bracket pair uses letters like e.g. "begin" - "end"
    const insertWordBoundaries = /^[\w ]+$/.test(str);
    str = _stringsJs.escapeRegExpCharacters(str);
    return insertWordBoundaries ? `\\b${str}\\b` : str;
}
function createBracketOrRegExp(pieces, options) {
    const regexStr = `(${pieces.map(prepareBracketForRegExp).join(")|(")})`;
    return _stringsJs.createRegExp(regexStr, true, options);
}
const toReversedString = function() {
    function reverse(str) {
        // create a Uint16Array and then use a TextDecoder to create a string
        const arr = new Uint16Array(str.length);
        let offset = 0;
        for(let i = str.length - 1; i >= 0; i--)arr[offset++] = str.charCodeAt(i);
        return _stringBuilderJs.getPlatformTextDecoder().decode(arr);
    }
    let lastInput = null;
    let lastOutput = null;
    return function toReversedString(str) {
        if (lastInput !== str) {
            lastInput = str;
            lastOutput = reverse(lastInput);
        }
        return lastOutput;
    };
}();
class BracketsUtils {
    static _findPrevBracketInText(reversedBracketRegex, lineNumber, reversedText, offset) {
        const m = reversedText.match(reversedBracketRegex);
        if (!m) return null;
        const matchOffset = reversedText.length - (m.index || 0);
        const matchLength = m[0].length;
        const absoluteMatchOffset = offset + matchOffset;
        return new (0, _rangeJs.Range)(lineNumber, absoluteMatchOffset - matchLength + 1, lineNumber, absoluteMatchOffset + 1);
    }
    static findPrevBracketInRange(reversedBracketRegex, lineNumber, lineText, startOffset, endOffset) {
        // Because JS does not support backwards regex search, we search forwards in a reversed string with a reversed regex ;)
        const reversedLineText = toReversedString(lineText);
        const reversedSubstr = reversedLineText.substring(lineText.length - endOffset, lineText.length - startOffset);
        return this._findPrevBracketInText(reversedBracketRegex, lineNumber, reversedSubstr, startOffset);
    }
    static findNextBracketInText(bracketRegex, lineNumber, text, offset) {
        const m = text.match(bracketRegex);
        if (!m) return null;
        const matchOffset = m.index || 0;
        const matchLength = m[0].length;
        if (matchLength === 0) return null;
        const absoluteMatchOffset = offset + matchOffset;
        return new (0, _rangeJs.Range)(lineNumber, absoluteMatchOffset + 1, lineNumber, absoluteMatchOffset + 1 + matchLength);
    }
    static findNextBracketInRange(bracketRegex, lineNumber, lineText, startOffset, endOffset) {
        const substr = lineText.substring(startOffset, endOffset);
        return this.findNextBracketInText(bracketRegex, lineNumber, substr, startOffset);
    }
}

},{"../../../../base/common/strings.js":"aA9I1","../../core/stringBuilder.js":"hHgWQ","../../core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hHgWQ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPlatformTextDecoder", ()=>getPlatformTextDecoder);
parcelHelpers.export(exports, "decodeUTF16LE", ()=>decodeUTF16LE);
parcelHelpers.export(exports, "StringBuilder", ()=>StringBuilder);
var _stringsJs = require("../../../base/common/strings.js");
var _platformJs = require("../../../base/common/platform.js");
var _bufferJs = require("../../../base/common/buffer.js");
let _utf16LE_TextDecoder;
function getUTF16LE_TextDecoder() {
    if (!_utf16LE_TextDecoder) _utf16LE_TextDecoder = new TextDecoder("UTF-16LE");
    return _utf16LE_TextDecoder;
}
let _utf16BE_TextDecoder;
function getUTF16BE_TextDecoder() {
    if (!_utf16BE_TextDecoder) _utf16BE_TextDecoder = new TextDecoder("UTF-16BE");
    return _utf16BE_TextDecoder;
}
let _platformTextDecoder;
function getPlatformTextDecoder() {
    if (!_platformTextDecoder) _platformTextDecoder = _platformJs.isLittleEndian() ? getUTF16LE_TextDecoder() : getUTF16BE_TextDecoder();
    return _platformTextDecoder;
}
function decodeUTF16LE(source, offset, len) {
    const view = new Uint16Array(source.buffer, offset, len);
    if (len > 0 && (view[0] === 0xFEFF || view[0] === 0xFFFE)) // UTF16 sometimes starts with a BOM https://de.wikipedia.org/wiki/Byte_Order_Mark
    // It looks like TextDecoder.decode will eat up a leading BOM (0xFEFF or 0xFFFE)
    // We don't want that behavior because we know the string is UTF16LE and the BOM should be maintained
    // So we use the manual decoder
    return compatDecodeUTF16LE(source, offset, len);
    return getUTF16LE_TextDecoder().decode(view);
}
function compatDecodeUTF16LE(source, offset, len) {
    const result = [];
    let resultLen = 0;
    for(let i = 0; i < len; i++){
        const charCode = _bufferJs.readUInt16LE(source, offset);
        offset += 2;
        result[resultLen++] = String.fromCharCode(charCode);
    }
    return result.join("");
}
class StringBuilder {
    constructor(capacity){
        this._capacity = capacity | 0;
        this._buffer = new Uint16Array(this._capacity);
        this._completedStrings = null;
        this._bufferLength = 0;
    }
    reset() {
        this._completedStrings = null;
        this._bufferLength = 0;
    }
    build() {
        if (this._completedStrings !== null) {
            this._flushBuffer();
            return this._completedStrings.join("");
        }
        return this._buildBuffer();
    }
    _buildBuffer() {
        if (this._bufferLength === 0) return "";
        const view = new Uint16Array(this._buffer.buffer, 0, this._bufferLength);
        return getPlatformTextDecoder().decode(view);
    }
    _flushBuffer() {
        const bufferString = this._buildBuffer();
        this._bufferLength = 0;
        if (this._completedStrings === null) this._completedStrings = [
            bufferString
        ];
        else this._completedStrings[this._completedStrings.length] = bufferString;
    }
    /**
     * Append a char code (<2^16)
     */ appendCharCode(charCode) {
        const remainingSpace = this._capacity - this._bufferLength;
        if (remainingSpace <= 1) {
            if (remainingSpace === 0 || _stringsJs.isHighSurrogate(charCode)) this._flushBuffer();
        }
        this._buffer[this._bufferLength++] = charCode;
    }
    /**
     * Append an ASCII char code (<2^8)
     */ appendASCIICharCode(charCode) {
        if (this._bufferLength === this._capacity) // buffer is full
        this._flushBuffer();
        this._buffer[this._bufferLength++] = charCode;
    }
    appendString(str) {
        const strLen = str.length;
        if (this._bufferLength + strLen >= this._capacity) {
            // This string does not fit in the remaining buffer space
            this._flushBuffer();
            this._completedStrings[this._completedStrings.length] = str;
            return;
        }
        for(let i = 0; i < strLen; i++)this._buffer[this._bufferLength++] = str.charCodeAt(i);
    }
}

},{"../../../base/common/strings.js":"aA9I1","../../../base/common/platform.js":"7maJO","../../../base/common/buffer.js":"cRDFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cRDFR":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VSBuffer", ()=>VSBuffer);
parcelHelpers.export(exports, "readUInt16LE", ()=>readUInt16LE);
parcelHelpers.export(exports, "writeUInt16LE", ()=>writeUInt16LE);
parcelHelpers.export(exports, "readUInt32BE", ()=>readUInt32BE);
parcelHelpers.export(exports, "writeUInt32BE", ()=>writeUInt32BE);
parcelHelpers.export(exports, "readUInt8", ()=>readUInt8);
parcelHelpers.export(exports, "writeUInt8", ()=>writeUInt8);
var _lazyJs = require("./lazy.js");
var Buffer = require("59a1dbefac989342").Buffer;
const hasBuffer = typeof Buffer !== "undefined";
const indexOfTable = new (0, _lazyJs.Lazy)(()=>new Uint8Array(256));
let textDecoder;
class VSBuffer {
    /**
     * When running in a nodejs context, if `actual` is not a nodejs Buffer, the backing store for
     * the returned `VSBuffer` instance might use a nodejs Buffer allocated from node's Buffer pool,
     * which is not transferrable.
     */ static wrap(actual) {
        if (hasBuffer && !Buffer.isBuffer(actual)) // https://nodejs.org/dist/latest-v10.x/docs/api/buffer.html#buffer_class_method_buffer_from_arraybuffer_byteoffset_length
        // Create a zero-copy Buffer wrapper around the ArrayBuffer pointed to by the Uint8Array
        actual = Buffer.from(actual.buffer, actual.byteOffset, actual.byteLength);
        return new VSBuffer(actual);
    }
    constructor(buffer){
        this.buffer = buffer;
        this.byteLength = this.buffer.byteLength;
    }
    toString() {
        if (hasBuffer) return this.buffer.toString();
        else {
            if (!textDecoder) textDecoder = new TextDecoder();
            return textDecoder.decode(this.buffer);
        }
    }
}
function readUInt16LE(source, offset) {
    return source[offset + 0] << 0 >>> 0 | source[offset + 1] << 8 >>> 0;
}
function writeUInt16LE(destination, value, offset) {
    destination[offset + 0] = value & 255;
    value = value >>> 8;
    destination[offset + 1] = value & 255;
}
function readUInt32BE(source, offset) {
    return source[offset] * 2 ** 24 + source[offset + 1] * 2 ** 16 + source[offset + 2] * 256 + source[offset + 3];
}
function writeUInt32BE(destination, value, offset) {
    destination[offset + 3] = value;
    value = value >>> 8;
    destination[offset + 2] = value;
    value = value >>> 8;
    destination[offset + 1] = value;
    value = value >>> 8;
    destination[offset] = value;
}
function readUInt8(source, offset) {
    return source[offset];
}
function writeUInt8(destination, value, offset) {
    destination[offset] = value;
}

},{"59a1dbefac989342":"13Pcp","./lazy.js":"6e57N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9SUpA":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IndentRulesSupport", ()=>IndentRulesSupport);
function resetGlobalRegex(reg) {
    if (reg.global) reg.lastIndex = 0;
    return true;
}
class IndentRulesSupport {
    constructor(indentationRules){
        this._indentationRules = indentationRules;
    }
    shouldIncrease(text) {
        if (this._indentationRules) {
            if (this._indentationRules.increaseIndentPattern && resetGlobalRegex(this._indentationRules.increaseIndentPattern) && this._indentationRules.increaseIndentPattern.test(text)) return true;
        // if (this._indentationRules.indentNextLinePattern && this._indentationRules.indentNextLinePattern.test(text)) {
        // 	return true;
        // }
        }
        return false;
    }
    shouldDecrease(text) {
        if (this._indentationRules && this._indentationRules.decreaseIndentPattern && resetGlobalRegex(this._indentationRules.decreaseIndentPattern) && this._indentationRules.decreaseIndentPattern.test(text)) return true;
        return false;
    }
    shouldIndentNextLine(text) {
        if (this._indentationRules && this._indentationRules.indentNextLinePattern && resetGlobalRegex(this._indentationRules.indentNextLinePattern) && this._indentationRules.indentNextLinePattern.test(text)) return true;
        return false;
    }
    shouldIgnore(text) {
        // the text matches `unIndentedLinePattern`
        if (this._indentationRules && this._indentationRules.unIndentedLinePattern && resetGlobalRegex(this._indentationRules.unIndentedLinePattern) && this._indentationRules.unIndentedLinePattern.test(text)) return true;
        return false;
    }
    getIndentMetadata(text) {
        let ret = 0;
        if (this.shouldIncrease(text)) ret += 1 /* IndentConsts.INCREASE_MASK */ ;
        if (this.shouldDecrease(text)) ret += 2 /* IndentConsts.DECREASE_MASK */ ;
        if (this.shouldIndentNextLine(text)) ret += 4 /* IndentConsts.INDENT_NEXTLINE_MASK */ ;
        if (this.shouldIgnore(text)) ret += 8 /* IndentConsts.UNINDENT_MASK */ ;
        return ret;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1alJG":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnEnterSupport", ()=>OnEnterSupport);
var _errorsJs = require("../../../../base/common/errors.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _languageConfigurationJs = require("../languageConfiguration.js");
class OnEnterSupport {
    constructor(opts){
        opts = opts || {};
        opts.brackets = opts.brackets || [
            [
                "(",
                ")"
            ],
            [
                "{",
                "}"
            ],
            [
                "[",
                "]"
            ]
        ];
        this._brackets = [];
        opts.brackets.forEach((bracket)=>{
            const openRegExp = OnEnterSupport._createOpenBracketRegExp(bracket[0]);
            const closeRegExp = OnEnterSupport._createCloseBracketRegExp(bracket[1]);
            if (openRegExp && closeRegExp) this._brackets.push({
                open: bracket[0],
                openRegExp: openRegExp,
                close: bracket[1],
                closeRegExp: closeRegExp
            });
        });
        this._regExpRules = opts.onEnterRules || [];
    }
    onEnter(autoIndent, previousLineText, beforeEnterText, afterEnterText) {
        // (1): `regExpRules`
        if (autoIndent >= 3 /* EditorAutoIndentStrategy.Advanced */ ) for(let i = 0, len = this._regExpRules.length; i < len; i++){
            const rule = this._regExpRules[i];
            const regResult = [
                {
                    reg: rule.beforeText,
                    text: beforeEnterText
                },
                {
                    reg: rule.afterText,
                    text: afterEnterText
                },
                {
                    reg: rule.previousLineText,
                    text: previousLineText
                }
            ].every((obj)=>{
                if (!obj.reg) return true;
                obj.reg.lastIndex = 0; // To disable the effect of the "g" flag.
                return obj.reg.test(obj.text);
            });
            if (regResult) return rule.action;
        }
        // (2): Special indent-outdent
        if (autoIndent >= 2 /* EditorAutoIndentStrategy.Brackets */ ) {
            if (beforeEnterText.length > 0 && afterEnterText.length > 0) for(let i = 0, len = this._brackets.length; i < len; i++){
                const bracket = this._brackets[i];
                if (bracket.openRegExp.test(beforeEnterText) && bracket.closeRegExp.test(afterEnterText)) return {
                    indentAction: (0, _languageConfigurationJs.IndentAction).IndentOutdent
                };
            }
        }
        // (4): Open bracket based logic
        if (autoIndent >= 2 /* EditorAutoIndentStrategy.Brackets */ ) {
            if (beforeEnterText.length > 0) for(let i = 0, len = this._brackets.length; i < len; i++){
                const bracket = this._brackets[i];
                if (bracket.openRegExp.test(beforeEnterText)) return {
                    indentAction: (0, _languageConfigurationJs.IndentAction).Indent
                };
            }
        }
        return null;
    }
    static _createOpenBracketRegExp(bracket) {
        let str = _stringsJs.escapeRegExpCharacters(bracket);
        if (!/\B/.test(str.charAt(0))) str = "\\b" + str;
        str += "\\s*$";
        return OnEnterSupport._safeRegExp(str);
    }
    static _createCloseBracketRegExp(bracket) {
        let str = _stringsJs.escapeRegExpCharacters(bracket);
        if (!/\B/.test(str.charAt(str.length - 1))) str = str + "\\b";
        str = "^\\s*" + str;
        return OnEnterSupport._safeRegExp(str);
    }
    static _safeRegExp(def) {
        try {
            return new RegExp(def);
        } catch (err) {
            (0, _errorsJs.onUnexpectedError)(err);
            return null;
        }
    }
}

},{"../../../../base/common/errors.js":"divX8","../../../../base/common/strings.js":"aA9I1","../languageConfiguration.js":"1ojaS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dXkjq":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IConfigurationService", ()=>IConfigurationService);
parcelHelpers.export(exports, "toValuesTree", ()=>toValuesTree);
parcelHelpers.export(exports, "addToValueTree", ()=>addToValueTree);
parcelHelpers.export(exports, "removeFromValueTree", ()=>removeFromValueTree);
/**
 * A helper function to get the configuration value with a specific settings path (e.g. config.some.setting)
 */ parcelHelpers.export(exports, "getConfigurationValue", ()=>getConfigurationValue);
parcelHelpers.export(exports, "getLanguageTagSettingPlainKey", ()=>getLanguageTagSettingPlainKey);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IConfigurationService = (0, _instantiationJs.createDecorator)("configurationService");
function toValuesTree(properties, conflictReporter) {
    const root = Object.create(null);
    for(const key in properties)addToValueTree(root, key, properties[key], conflictReporter);
    return root;
}
function addToValueTree(settingsTreeRoot, key, value, conflictReporter) {
    const segments = key.split(".");
    const last = segments.pop();
    let curr = settingsTreeRoot;
    for(let i = 0; i < segments.length; i++){
        const s = segments[i];
        let obj = curr[s];
        switch(typeof obj){
            case "undefined":
                obj = curr[s] = Object.create(null);
                break;
            case "object":
                if (obj === null) {
                    conflictReporter(`Ignoring ${key} as ${segments.slice(0, i + 1).join(".")} is null`);
                    return;
                }
                break;
            default:
                conflictReporter(`Ignoring ${key} as ${segments.slice(0, i + 1).join(".")} is ${JSON.stringify(obj)}`);
                return;
        }
        curr = obj;
    }
    if (typeof curr === "object" && curr !== null) try {
        curr[last] = value; // workaround https://github.com/microsoft/vscode/issues/13606
    } catch (e) {
        conflictReporter(`Ignoring ${key} as ${segments.join(".")} is ${JSON.stringify(curr)}`);
    }
    else conflictReporter(`Ignoring ${key} as ${segments.join(".")} is ${JSON.stringify(curr)}`);
}
function removeFromValueTree(valueTree, key) {
    const segments = key.split(".");
    doRemoveFromValueTree(valueTree, segments);
}
function doRemoveFromValueTree(valueTree, segments) {
    const first = segments.shift();
    if (segments.length === 0) {
        // Reached last segment
        delete valueTree[first];
        return;
    }
    if (Object.keys(valueTree).indexOf(first) !== -1) {
        const value = valueTree[first];
        if (typeof value === "object" && !Array.isArray(value)) {
            doRemoveFromValueTree(value, segments);
            if (Object.keys(value).length === 0) delete valueTree[first];
        }
    }
}
function getConfigurationValue(config, settingPath, defaultValue) {
    function accessSetting(config, path) {
        let current = config;
        for (const component of path){
            if (typeof current !== "object" || current === null) return undefined;
            current = current[component];
        }
        return current;
    }
    const path = settingPath.split(".");
    const result = accessSetting(config, path);
    return typeof result === "undefined" ? defaultValue : result;
}
function getLanguageTagSettingPlainKey(settingKey) {
    return settingKey.replace(/[\[\]]/g, "");
}

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ka2JQ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ILanguageService", ()=>ILanguageService);
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
const ILanguageService = (0, _instantiationJs.createDecorator)("languageService");

},{"../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6WJLq":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerSingleton", ()=>registerSingleton);
parcelHelpers.export(exports, "getSingletonServiceDescriptors", ()=>getSingletonServiceDescriptors);
var _descriptorsJs = require("./descriptors.js");
const _registry = [];
function registerSingleton(id, ctorOrDescriptor, supportsDelayedInstantiation) {
    if (!(ctorOrDescriptor instanceof (0, _descriptorsJs.SyncDescriptor))) ctorOrDescriptor = new (0, _descriptorsJs.SyncDescriptor)(ctorOrDescriptor, [], Boolean(supportsDelayedInstantiation));
    _registry.push([
        id,
        ctorOrDescriptor
    ]);
}
function getSingletonServiceDescriptors() {
    return _registry;
}

},{"./descriptors.js":"doIK7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"doIK7":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncDescriptor", ()=>SyncDescriptor);
class SyncDescriptor {
    constructor(ctor, staticArguments = [], supportsDelayedInstantiation = false){
        this.ctor = ctor;
        this.staticArguments = staticArguments;
        this.supportsDelayedInstantiation = supportsDelayedInstantiation;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gqkb7":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Extensions", ()=>Extensions);
parcelHelpers.export(exports, "EditorModesRegistry", ()=>EditorModesRegistry);
parcelHelpers.export(exports, "ModesRegistry", ()=>ModesRegistry);
parcelHelpers.export(exports, "PLAINTEXT_LANGUAGE_ID", ()=>PLAINTEXT_LANGUAGE_ID);
parcelHelpers.export(exports, "PLAINTEXT_EXTENSION", ()=>PLAINTEXT_EXTENSION);
var _nlsJs = require("../../../nls.js");
var _eventJs = require("../../../base/common/event.js");
var _platformJs = require("../../../platform/registry/common/platform.js");
var _mimeJs = require("../../../base/common/mime.js");
var _configurationRegistryJs = require("../../../platform/configuration/common/configurationRegistry.js");
const Extensions = {
    ModesRegistry: "editor.modesRegistry"
};
class EditorModesRegistry {
    constructor(){
        this._onDidChangeLanguages = new (0, _eventJs.Emitter)();
        this.onDidChangeLanguages = this._onDidChangeLanguages.event;
        this._languages = [];
    }
    registerLanguage(def) {
        this._languages.push(def);
        this._onDidChangeLanguages.fire(undefined);
        return {
            dispose: ()=>{
                for(let i = 0, len = this._languages.length; i < len; i++)if (this._languages[i] === def) {
                    this._languages.splice(i, 1);
                    return;
                }
            }
        };
    }
    getLanguages() {
        return this._languages;
    }
}
const ModesRegistry = new EditorModesRegistry();
(0, _platformJs.Registry).add(Extensions.ModesRegistry, ModesRegistry);
const PLAINTEXT_LANGUAGE_ID = "plaintext";
const PLAINTEXT_EXTENSION = ".txt";
ModesRegistry.registerLanguage({
    id: PLAINTEXT_LANGUAGE_ID,
    extensions: [
        PLAINTEXT_EXTENSION
    ],
    aliases: [
        _nlsJs.localize("plainText.alias", "Plain Text"),
        "text"
    ],
    mimetypes: [
        (0, _mimeJs.Mimes).text
    ]
});
(0, _platformJs.Registry).as((0, _configurationRegistryJs.Extensions).Configuration).registerDefaultConfigurations([
    {
        overrides: {
            "[plaintext]": {
                "editor.unicodeHighlight.ambiguousCharacters": false,
                "editor.unicodeHighlight.invisibleCharacters": false
            }
        }
    }
]);

},{"../../../nls.js":"l617d","../../../base/common/event.js":"4Zi8b","../../../platform/registry/common/platform.js":"dzx11","../../../base/common/mime.js":"9CBNk","../../../platform/configuration/common/configurationRegistry.js":"6y4yB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9CBNk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mimes", ()=>Mimes);
const Mimes = Object.freeze({
    text: "text/plain",
    binary: "application/octet-stream",
    unknown: "application/unknown",
    markdown: "text/markdown",
    latex: "text/latex",
    uriList: "text/uri-list"
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6y4yB":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Extensions", ()=>Extensions);
parcelHelpers.export(exports, "allSettings", ()=>allSettings);
parcelHelpers.export(exports, "applicationSettings", ()=>applicationSettings);
parcelHelpers.export(exports, "machineSettings", ()=>machineSettings);
parcelHelpers.export(exports, "machineOverridableSettings", ()=>machineOverridableSettings);
parcelHelpers.export(exports, "windowSettings", ()=>windowSettings);
parcelHelpers.export(exports, "resourceSettings", ()=>resourceSettings);
parcelHelpers.export(exports, "resourceLanguageSettingsSchemaId", ()=>resourceLanguageSettingsSchemaId);
parcelHelpers.export(exports, "OVERRIDE_PROPERTY_PATTERN", ()=>OVERRIDE_PROPERTY_PATTERN);
parcelHelpers.export(exports, "OVERRIDE_PROPERTY_REGEX", ()=>OVERRIDE_PROPERTY_REGEX);
parcelHelpers.export(exports, "overrideIdentifiersFromKey", ()=>overrideIdentifiersFromKey);
parcelHelpers.export(exports, "getDefaultValue", ()=>getDefaultValue);
parcelHelpers.export(exports, "validateProperty", ()=>validateProperty);
var _arraysJs = require("../../../base/common/arrays.js");
var _eventJs = require("../../../base/common/event.js");
var _typesJs = require("../../../base/common/types.js");
var _nlsJs = require("../../../nls.js");
var _configurationJs = require("./configuration.js");
var _jsonContributionRegistryJs = require("../../jsonschemas/common/jsonContributionRegistry.js");
var _platformJs = require("../../registry/common/platform.js");
const Extensions = {
    Configuration: "base.contributions.configuration"
};
const allSettings = {
    properties: {},
    patternProperties: {}
};
const applicationSettings = {
    properties: {},
    patternProperties: {}
};
const machineSettings = {
    properties: {},
    patternProperties: {}
};
const machineOverridableSettings = {
    properties: {},
    patternProperties: {}
};
const windowSettings = {
    properties: {},
    patternProperties: {}
};
const resourceSettings = {
    properties: {},
    patternProperties: {}
};
const resourceLanguageSettingsSchemaId = "vscode://schemas/settings/resourceLanguage";
const contributionRegistry = (0, _platformJs.Registry).as((0, _jsonContributionRegistryJs.Extensions).JSONContribution);
class ConfigurationRegistry {
    constructor(){
        this.registeredConfigurationDefaults = [];
        this.overrideIdentifiers = new Set();
        this._onDidSchemaChange = new (0, _eventJs.Emitter)();
        this._onDidUpdateConfiguration = new (0, _eventJs.Emitter)();
        this.configurationDefaultsOverrides = new Map();
        this.defaultLanguageConfigurationOverridesNode = {
            id: "defaultOverrides",
            title: _nlsJs.localize("defaultLanguageConfigurationOverrides.title", "Default Language Configuration Overrides"),
            properties: {}
        };
        this.configurationContributors = [
            this.defaultLanguageConfigurationOverridesNode
        ];
        this.resourceLanguageSettingsSchema = {
            properties: {},
            patternProperties: {},
            additionalProperties: true,
            allowTrailingCommas: true,
            allowComments: true
        };
        this.configurationProperties = {};
        this.policyConfigurations = new Map();
        this.excludedConfigurationProperties = {};
        contributionRegistry.registerSchema(resourceLanguageSettingsSchemaId, this.resourceLanguageSettingsSchema);
        this.registerOverridePropertyPatternKey();
    }
    registerConfiguration(configuration, validate = true) {
        this.registerConfigurations([
            configuration
        ], validate);
    }
    registerConfigurations(configurations, validate = true) {
        const properties = new Set();
        this.doRegisterConfigurations(configurations, validate, properties);
        contributionRegistry.registerSchema(resourceLanguageSettingsSchemaId, this.resourceLanguageSettingsSchema);
        this._onDidSchemaChange.fire();
        this._onDidUpdateConfiguration.fire({
            properties
        });
    }
    registerDefaultConfigurations(configurationDefaults) {
        const properties = new Set();
        this.doRegisterDefaultConfigurations(configurationDefaults, properties);
        this._onDidSchemaChange.fire();
        this._onDidUpdateConfiguration.fire({
            properties,
            defaultsOverrides: true
        });
    }
    doRegisterDefaultConfigurations(configurationDefaults, bucket) {
        this.registeredConfigurationDefaults.push(...configurationDefaults);
        const overrideIdentifiers = [];
        for (const { overrides, source } of configurationDefaults)for(const key in overrides){
            bucket.add(key);
            const configurationDefaultOverridesForKey = this.configurationDefaultsOverrides.get(key) ?? this.configurationDefaultsOverrides.set(key, {
                configurationDefaultOverrides: []
            }).get(key);
            const value = overrides[key];
            configurationDefaultOverridesForKey.configurationDefaultOverrides.push({
                value,
                source
            });
            // Configuration defaults for Override Identifiers
            if (OVERRIDE_PROPERTY_REGEX.test(key)) {
                const newDefaultOverride = this.mergeDefaultConfigurationsForOverrideIdentifier(key, value, source, configurationDefaultOverridesForKey.configurationDefaultOverrideValue);
                if (!newDefaultOverride) continue;
                configurationDefaultOverridesForKey.configurationDefaultOverrideValue = newDefaultOverride;
                this.updateDefaultOverrideProperty(key, newDefaultOverride, source);
                overrideIdentifiers.push(...overrideIdentifiersFromKey(key));
            } else {
                const newDefaultOverride = this.mergeDefaultConfigurationsForConfigurationProperty(key, value, source, configurationDefaultOverridesForKey.configurationDefaultOverrideValue);
                if (!newDefaultOverride) continue;
                configurationDefaultOverridesForKey.configurationDefaultOverrideValue = newDefaultOverride;
                const property = this.configurationProperties[key];
                if (property) {
                    this.updatePropertyDefaultValue(key, property);
                    this.updateSchema(key, property);
                }
            }
        }
        this.doRegisterOverrideIdentifiers(overrideIdentifiers);
    }
    updateDefaultOverrideProperty(key, newDefaultOverride, source) {
        const property = {
            type: "object",
            default: newDefaultOverride.value,
            description: _nlsJs.localize("defaultLanguageConfiguration.description", "Configure settings to be overridden for the {0} language.", (0, _configurationJs.getLanguageTagSettingPlainKey)(key)),
            $ref: resourceLanguageSettingsSchemaId,
            defaultDefaultValue: newDefaultOverride.value,
            source,
            defaultValueSource: source
        };
        this.configurationProperties[key] = property;
        this.defaultLanguageConfigurationOverridesNode.properties[key] = property;
    }
    mergeDefaultConfigurationsForOverrideIdentifier(overrideIdentifier, configurationValueObject, valueSource, existingDefaultOverride) {
        const defaultValue = existingDefaultOverride?.value || {};
        const source = existingDefaultOverride?.source ?? new Map();
        // This should not happen
        if (!(source instanceof Map)) {
            console.error("objectConfigurationSources is not a Map");
            return undefined;
        }
        for (const propertyKey of Object.keys(configurationValueObject)){
            const propertyDefaultValue = configurationValueObject[propertyKey];
            const isObjectSetting = _typesJs.isObject(propertyDefaultValue) && (_typesJs.isUndefined(defaultValue[propertyKey]) || _typesJs.isObject(defaultValue[propertyKey]));
            // If the default value is an object, merge the objects and store the source of each keys
            if (isObjectSetting) {
                defaultValue[propertyKey] = {
                    ...defaultValue[propertyKey] ?? {},
                    ...propertyDefaultValue
                };
                // Track the source of each value in the object
                if (valueSource) for(const objectKey in propertyDefaultValue)source.set(`${propertyKey}.${objectKey}`, valueSource);
            } else {
                defaultValue[propertyKey] = propertyDefaultValue;
                if (valueSource) source.set(propertyKey, valueSource);
                else source.delete(propertyKey);
            }
        }
        return {
            value: defaultValue,
            source
        };
    }
    mergeDefaultConfigurationsForConfigurationProperty(propertyKey, value, valuesSource, existingDefaultOverride) {
        const property = this.configurationProperties[propertyKey];
        const existingDefaultValue = existingDefaultOverride?.value ?? property?.defaultDefaultValue;
        let source = valuesSource;
        const isObjectSetting = _typesJs.isObject(value) && (property !== undefined && property.type === "object" || property === undefined && (_typesJs.isUndefined(existingDefaultValue) || _typesJs.isObject(existingDefaultValue)));
        // If the default value is an object, merge the objects and store the source of each keys
        if (isObjectSetting) {
            source = existingDefaultOverride?.source ?? new Map();
            // This should not happen
            if (!(source instanceof Map)) {
                console.error("defaultValueSource is not a Map");
                return undefined;
            }
            for(const objectKey in value)if (valuesSource) source.set(`${propertyKey}.${objectKey}`, valuesSource);
            value = {
                ..._typesJs.isObject(existingDefaultValue) ? existingDefaultValue : {},
                ...value
            };
        }
        return {
            value,
            source
        };
    }
    registerOverrideIdentifiers(overrideIdentifiers) {
        this.doRegisterOverrideIdentifiers(overrideIdentifiers);
        this._onDidSchemaChange.fire();
    }
    doRegisterOverrideIdentifiers(overrideIdentifiers) {
        for (const overrideIdentifier of overrideIdentifiers)this.overrideIdentifiers.add(overrideIdentifier);
        this.updateOverridePropertyPatternKey();
    }
    doRegisterConfigurations(configurations, validate, bucket) {
        configurations.forEach((configuration)=>{
            this.validateAndRegisterProperties(configuration, validate, configuration.extensionInfo, configuration.restrictedProperties, undefined, bucket);
            this.configurationContributors.push(configuration);
            this.registerJSONConfiguration(configuration);
        });
    }
    validateAndRegisterProperties(configuration, validate = true, extensionInfo, restrictedProperties, scope = 3 /* ConfigurationScope.WINDOW */ , bucket) {
        scope = _typesJs.isUndefinedOrNull(configuration.scope) ? scope : configuration.scope;
        const properties = configuration.properties;
        if (properties) for(const key in properties){
            const property = properties[key];
            if (validate && validateProperty(key, property)) {
                delete properties[key];
                continue;
            }
            property.source = extensionInfo;
            // update default value
            property.defaultDefaultValue = properties[key].default;
            this.updatePropertyDefaultValue(key, property);
            // update scope
            if (OVERRIDE_PROPERTY_REGEX.test(key)) property.scope = undefined; // No scope for overridable properties `[${identifier}]`
            else {
                property.scope = _typesJs.isUndefinedOrNull(property.scope) ? scope : property.scope;
                property.restricted = _typesJs.isUndefinedOrNull(property.restricted) ? !!restrictedProperties?.includes(key) : property.restricted;
            }
            // Add to properties maps
            // Property is included by default if 'included' is unspecified
            if (properties[key].hasOwnProperty("included") && !properties[key].included) {
                this.excludedConfigurationProperties[key] = properties[key];
                delete properties[key];
                continue;
            } else {
                this.configurationProperties[key] = properties[key];
                if (properties[key].policy?.name) this.policyConfigurations.set(properties[key].policy.name, key);
            }
            if (!properties[key].deprecationMessage && properties[key].markdownDeprecationMessage) // If not set, default deprecationMessage to the markdown source
            properties[key].deprecationMessage = properties[key].markdownDeprecationMessage;
            bucket.add(key);
        }
        const subNodes = configuration.allOf;
        if (subNodes) for (const node of subNodes)this.validateAndRegisterProperties(node, validate, extensionInfo, restrictedProperties, scope, bucket);
    }
    getConfigurationProperties() {
        return this.configurationProperties;
    }
    getPolicyConfigurations() {
        return this.policyConfigurations;
    }
    registerJSONConfiguration(configuration) {
        const register = (configuration)=>{
            const properties = configuration.properties;
            if (properties) for(const key in properties)this.updateSchema(key, properties[key]);
            const subNodes = configuration.allOf;
            subNodes?.forEach(register);
        };
        register(configuration);
    }
    updateSchema(key, property) {
        allSettings.properties[key] = property;
        switch(property.scope){
            case 1 /* ConfigurationScope.APPLICATION */ :
                applicationSettings.properties[key] = property;
                break;
            case 2 /* ConfigurationScope.MACHINE */ :
                machineSettings.properties[key] = property;
                break;
            case 6 /* ConfigurationScope.MACHINE_OVERRIDABLE */ :
                machineOverridableSettings.properties[key] = property;
                break;
            case 3 /* ConfigurationScope.WINDOW */ :
                windowSettings.properties[key] = property;
                break;
            case 4 /* ConfigurationScope.RESOURCE */ :
                resourceSettings.properties[key] = property;
                break;
            case 5 /* ConfigurationScope.LANGUAGE_OVERRIDABLE */ :
                resourceSettings.properties[key] = property;
                this.resourceLanguageSettingsSchema.properties[key] = property;
                break;
        }
    }
    updateOverridePropertyPatternKey() {
        for (const overrideIdentifier of this.overrideIdentifiers.values()){
            const overrideIdentifierProperty = `[${overrideIdentifier}]`;
            const resourceLanguagePropertiesSchema = {
                type: "object",
                description: _nlsJs.localize("overrideSettings.defaultDescription", "Configure editor settings to be overridden for a language."),
                errorMessage: _nlsJs.localize("overrideSettings.errorMessage", "This setting does not support per-language configuration."),
                $ref: resourceLanguageSettingsSchemaId
            };
            this.updatePropertyDefaultValue(overrideIdentifierProperty, resourceLanguagePropertiesSchema);
            allSettings.properties[overrideIdentifierProperty] = resourceLanguagePropertiesSchema;
            applicationSettings.properties[overrideIdentifierProperty] = resourceLanguagePropertiesSchema;
            machineSettings.properties[overrideIdentifierProperty] = resourceLanguagePropertiesSchema;
            machineOverridableSettings.properties[overrideIdentifierProperty] = resourceLanguagePropertiesSchema;
            windowSettings.properties[overrideIdentifierProperty] = resourceLanguagePropertiesSchema;
            resourceSettings.properties[overrideIdentifierProperty] = resourceLanguagePropertiesSchema;
        }
    }
    registerOverridePropertyPatternKey() {
        const resourceLanguagePropertiesSchema = {
            type: "object",
            description: _nlsJs.localize("overrideSettings.defaultDescription", "Configure editor settings to be overridden for a language."),
            errorMessage: _nlsJs.localize("overrideSettings.errorMessage", "This setting does not support per-language configuration."),
            $ref: resourceLanguageSettingsSchemaId
        };
        allSettings.patternProperties[OVERRIDE_PROPERTY_PATTERN] = resourceLanguagePropertiesSchema;
        applicationSettings.patternProperties[OVERRIDE_PROPERTY_PATTERN] = resourceLanguagePropertiesSchema;
        machineSettings.patternProperties[OVERRIDE_PROPERTY_PATTERN] = resourceLanguagePropertiesSchema;
        machineOverridableSettings.patternProperties[OVERRIDE_PROPERTY_PATTERN] = resourceLanguagePropertiesSchema;
        windowSettings.patternProperties[OVERRIDE_PROPERTY_PATTERN] = resourceLanguagePropertiesSchema;
        resourceSettings.patternProperties[OVERRIDE_PROPERTY_PATTERN] = resourceLanguagePropertiesSchema;
        this._onDidSchemaChange.fire();
    }
    updatePropertyDefaultValue(key, property) {
        const configurationdefaultOverride = this.configurationDefaultsOverrides.get(key)?.configurationDefaultOverrideValue;
        let defaultValue = undefined;
        let defaultSource = undefined;
        if (configurationdefaultOverride && (!property.disallowConfigurationDefault || !configurationdefaultOverride.source // Prevent overriding the default value if the property is disallowed to be overridden by configuration defaults from extensions
        )) {
            defaultValue = configurationdefaultOverride.value;
            defaultSource = configurationdefaultOverride.source;
        }
        if (_typesJs.isUndefined(defaultValue)) {
            defaultValue = property.defaultDefaultValue;
            defaultSource = undefined;
        }
        if (_typesJs.isUndefined(defaultValue)) defaultValue = getDefaultValue(property.type);
        property.default = defaultValue;
        property.defaultValueSource = defaultSource;
    }
}
const OVERRIDE_IDENTIFIER_PATTERN = `\\[([^\\]]+)\\]`;
const OVERRIDE_IDENTIFIER_REGEX = new RegExp(OVERRIDE_IDENTIFIER_PATTERN, "g");
const OVERRIDE_PROPERTY_PATTERN = `^(${OVERRIDE_IDENTIFIER_PATTERN})+$`;
const OVERRIDE_PROPERTY_REGEX = new RegExp(OVERRIDE_PROPERTY_PATTERN);
function overrideIdentifiersFromKey(key) {
    const identifiers = [];
    if (OVERRIDE_PROPERTY_REGEX.test(key)) {
        let matches = OVERRIDE_IDENTIFIER_REGEX.exec(key);
        while(matches?.length){
            const identifier = matches[1].trim();
            if (identifier) identifiers.push(identifier);
            matches = OVERRIDE_IDENTIFIER_REGEX.exec(key);
        }
    }
    return (0, _arraysJs.distinct)(identifiers);
}
function getDefaultValue(type) {
    const t = Array.isArray(type) ? type[0] : type;
    switch(t){
        case "boolean":
            return false;
        case "integer":
        case "number":
            return 0;
        case "string":
            return "";
        case "array":
            return [];
        case "object":
            return {};
        default:
            return null;
    }
}
const configurationRegistry = new ConfigurationRegistry();
(0, _platformJs.Registry).add(Extensions.Configuration, configurationRegistry);
function validateProperty(property, schema) {
    if (!property.trim()) return _nlsJs.localize("config.property.empty", "Cannot register an empty property");
    if (OVERRIDE_PROPERTY_REGEX.test(property)) return _nlsJs.localize("config.property.languageDefault", "Cannot register '{0}'. This matches property pattern '\\\\[.*\\\\]$' for describing language specific editor settings. Use 'configurationDefaults' contribution.", property);
    if (configurationRegistry.getConfigurationProperties()[property] !== undefined) return _nlsJs.localize("config.property.duplicate", "Cannot register '{0}'. This property is already registered.", property);
    if (schema.policy?.name && configurationRegistry.getPolicyConfigurations().get(schema.policy?.name) !== undefined) return _nlsJs.localize("config.policy.duplicate", "Cannot register '{0}'. The associated policy {1} is already registered with {2}.", property, schema.policy?.name, configurationRegistry.getPolicyConfigurations().get(schema.policy?.name));
    return null;
}

},{"../../../base/common/arrays.js":"DECei","../../../base/common/event.js":"4Zi8b","../../../base/common/types.js":"fb5yx","../../../nls.js":"l617d","./configuration.js":"dXkjq","../../jsonschemas/common/jsonContributionRegistry.js":"6LKe5","../../registry/common/platform.js":"dzx11","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6LKe5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Extensions", ()=>Extensions);
var _eventJs = require("../../../base/common/event.js");
var _platformJs = require("../../registry/common/platform.js");
const Extensions = {
    JSONContribution: "base.contributions.json"
};
function normalizeId(id) {
    if (id.length > 0 && id.charAt(id.length - 1) === "#") return id.substring(0, id.length - 1);
    return id;
}
class JSONContributionRegistry {
    constructor(){
        this._onDidChangeSchema = new (0, _eventJs.Emitter)();
        this.schemasById = {};
    }
    registerSchema(uri, unresolvedSchemaContent) {
        this.schemasById[normalizeId(uri)] = unresolvedSchemaContent;
        this._onDidChangeSchema.fire(uri);
    }
    notifySchemaChanged(uri) {
        this._onDidChangeSchema.fire(uri);
    }
}
const jsonContributionRegistry = new JSONContributionRegistry();
_platformJs.Registry.add(Extensions.JSONContribution, jsonContributionRegistry);

},{"../../../base/common/event.js":"4Zi8b","../../registry/common/platform.js":"dzx11","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"evcBn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Captures all bracket related configurations for a single language.
 * Immutable.
*/ parcelHelpers.export(exports, "LanguageBracketsConfiguration", ()=>LanguageBracketsConfiguration);
parcelHelpers.export(exports, "BracketKindBase", ()=>BracketKindBase);
parcelHelpers.export(exports, "OpeningBracketKind", ()=>OpeningBracketKind);
parcelHelpers.export(exports, "ClosingBracketKind", ()=>ClosingBracketKind);
var _cacheJs = require("../../../../base/common/cache.js");
var _richEditBracketsJs = require("./richEditBrackets.js");
class LanguageBracketsConfiguration {
    constructor(languageId, config){
        this.languageId = languageId;
        const bracketPairs = config.brackets ? filterValidBrackets(config.brackets) : [];
        const openingBracketInfos = new (0, _cacheJs.CachedFunction)((bracket)=>{
            const closing = new Set();
            return {
                info: new OpeningBracketKind(this, bracket, closing),
                closing
            };
        });
        const closingBracketInfos = new (0, _cacheJs.CachedFunction)((bracket)=>{
            const opening = new Set();
            const openingColorized = new Set();
            return {
                info: new ClosingBracketKind(this, bracket, opening, openingColorized),
                opening,
                openingColorized
            };
        });
        for (const [open, close] of bracketPairs){
            const opening = openingBracketInfos.get(open);
            const closing = closingBracketInfos.get(close);
            opening.closing.add(closing.info);
            closing.opening.add(opening.info);
        }
        // Treat colorized brackets as brackets, and mark them as colorized.
        const colorizedBracketPairs = config.colorizedBracketPairs ? filterValidBrackets(config.colorizedBracketPairs) : bracketPairs.filter((p)=>!(p[0] === "<" && p[1] === ">"));
        for (const [open, close] of colorizedBracketPairs){
            const opening = openingBracketInfos.get(open);
            const closing = closingBracketInfos.get(close);
            opening.closing.add(closing.info);
            closing.openingColorized.add(opening.info);
            closing.opening.add(opening.info);
        }
        this._openingBrackets = new Map([
            ...openingBracketInfos.cachedValues
        ].map(([k, v])=>[
                k,
                v.info
            ]));
        this._closingBrackets = new Map([
            ...closingBracketInfos.cachedValues
        ].map(([k, v])=>[
                k,
                v.info
            ]));
    }
    /**
     * No two brackets have the same bracket text.
    */ get openingBrackets() {
        return [
            ...this._openingBrackets.values()
        ];
    }
    /**
     * No two brackets have the same bracket text.
    */ get closingBrackets() {
        return [
            ...this._closingBrackets.values()
        ];
    }
    getOpeningBracketInfo(bracketText) {
        return this._openingBrackets.get(bracketText);
    }
    getClosingBracketInfo(bracketText) {
        return this._closingBrackets.get(bracketText);
    }
    getBracketInfo(bracketText) {
        return this.getOpeningBracketInfo(bracketText) || this.getClosingBracketInfo(bracketText);
    }
    getBracketRegExp(options) {
        const brackets = Array.from([
            ...this._openingBrackets.keys(),
            ...this._closingBrackets.keys()
        ]);
        return (0, _richEditBracketsJs.createBracketOrRegExp)(brackets, options);
    }
}
function filterValidBrackets(bracketPairs) {
    return bracketPairs.filter(([open, close])=>open !== "" && close !== "");
}
class BracketKindBase {
    constructor(config, bracketText){
        this.config = config;
        this.bracketText = bracketText;
    }
    get languageId() {
        return this.config.languageId;
    }
}
class OpeningBracketKind extends BracketKindBase {
    constructor(config, bracketText, openedBrackets){
        super(config, bracketText);
        this.openedBrackets = openedBrackets;
        this.isOpeningBracket = true;
    }
}
class ClosingBracketKind extends BracketKindBase {
    constructor(config, bracketText, /**
     * Non empty array of all opening brackets this bracket closes.
    */ openingBrackets, openingColorizedBrackets){
        super(config, bracketText);
        this.openingBrackets = openingBrackets;
        this.openingColorizedBrackets = openingColorizedBrackets;
        this.isOpeningBracket = false;
    }
    /**
     * Checks if this bracket closes the given other bracket.
     * If the bracket infos come from different configurations, this method will return false.
    */ closes(other) {
        if (other["config"] !== this.config) return false;
        return this.openingBrackets.has(other);
    }
    closesColorized(other) {
        if (other["config"] !== this.config) return false;
        return this.openingColorizedBrackets.has(other);
    }
    getOpeningBrackets() {
        return [
            ...this.openingBrackets
        ];
    }
}

},{"../../../../base/common/cache.js":"e83Ii","./richEditBrackets.js":"hHyd8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iRWuk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "BaseEditorSimpleWorker", ()=>BaseEditorSimpleWorker);
/**
 * @internal
 */ parcelHelpers.export(exports, "EditorSimpleWorker", ()=>EditorSimpleWorker);
/**
 * Defines the worker entry point. Must be exported and named `create`.
 * @skipMangle
 * @internal
 */ parcelHelpers.export(exports, "create", ()=>create);
var _diffJs = require("../../../base/common/diff/diff.js");
var _rangeJs = require("../core/range.js");
var _linkComputerJs = require("../languages/linkComputer.js");
var _inplaceReplaceSupportJs = require("../languages/supports/inplaceReplaceSupport.js");
var _editorBaseApiJs = require("./editorBaseApi.js");
var _editorWorkerHostJs = require("./editorWorkerHost.js");
var _stopwatchJs = require("../../../base/common/stopwatch.js");
var _unicodeTextModelHighlighterJs = require("./unicodeTextModelHighlighter.js");
var _linesDiffComputersJs = require("../diff/linesDiffComputers.js");
var _objectsJs = require("../../../base/common/objects.js");
var _networkJs = require("../../../base/common/network.js");
var _defaultDocumentColorsComputerJs = require("../languages/defaultDocumentColorsComputer.js");
var _findSectionHeadersJs = require("./findSectionHeaders.js");
var _textModelSyncImplJs = require("./textModelSync/textModelSync.impl.js");
// ESM-comment-begin
// const isESM = false;
// ESM-comment-end
// ESM-uncomment-begin
const isESM = true;
class BaseEditorSimpleWorker {
    constructor(){
        this._workerTextModelSyncServer = new (0, _textModelSyncImplJs.WorkerTextModelSyncServer)();
    }
    dispose() {}
    _getModel(uri) {
        return this._workerTextModelSyncServer.getModel(uri);
    }
    _getModels() {
        return this._workerTextModelSyncServer.getModels();
    }
    $acceptNewModel(data) {
        this._workerTextModelSyncServer.$acceptNewModel(data);
    }
    $acceptModelChanged(uri, e) {
        this._workerTextModelSyncServer.$acceptModelChanged(uri, e);
    }
    $acceptRemovedModel(uri) {
        this._workerTextModelSyncServer.$acceptRemovedModel(uri);
    }
    async $computeUnicodeHighlights(url, options, range) {
        const model = this._getModel(url);
        if (!model) return {
            ranges: [],
            hasMore: false,
            ambiguousCharacterCount: 0,
            invisibleCharacterCount: 0,
            nonBasicAsciiCharacterCount: 0
        };
        return (0, _unicodeTextModelHighlighterJs.UnicodeTextModelHighlighter).computeUnicodeHighlights(model, options, range);
    }
    async $findSectionHeaders(url, options) {
        const model = this._getModel(url);
        if (!model) return [];
        return (0, _findSectionHeadersJs.findSectionHeaders)(model, options);
    }
    // ---- BEGIN diff --------------------------------------------------------------------------
    async $computeDiff(originalUrl, modifiedUrl, options, algorithm) {
        const original = this._getModel(originalUrl);
        const modified = this._getModel(modifiedUrl);
        if (!original || !modified) return null;
        const result = EditorSimpleWorker.computeDiff(original, modified, options, algorithm);
        return result;
    }
    static computeDiff(originalTextModel, modifiedTextModel, options, algorithm) {
        const diffAlgorithm = algorithm === "advanced" ? (0, _linesDiffComputersJs.linesDiffComputers).getDefault() : (0, _linesDiffComputersJs.linesDiffComputers).getLegacy();
        const originalLines = originalTextModel.getLinesContent();
        const modifiedLines = modifiedTextModel.getLinesContent();
        const result = diffAlgorithm.computeDiff(originalLines, modifiedLines, options);
        const identical = result.changes.length > 0 ? false : this._modelsAreIdentical(originalTextModel, modifiedTextModel);
        function getLineChanges(changes) {
            return changes.map((m)=>[
                    m.original.startLineNumber,
                    m.original.endLineNumberExclusive,
                    m.modified.startLineNumber,
                    m.modified.endLineNumberExclusive,
                    m.innerChanges?.map((m)=>[
                            m.originalRange.startLineNumber,
                            m.originalRange.startColumn,
                            m.originalRange.endLineNumber,
                            m.originalRange.endColumn,
                            m.modifiedRange.startLineNumber,
                            m.modifiedRange.startColumn,
                            m.modifiedRange.endLineNumber,
                            m.modifiedRange.endColumn
                        ])
                ]);
        }
        return {
            identical,
            quitEarly: result.hitTimeout,
            changes: getLineChanges(result.changes),
            moves: result.moves.map((m)=>[
                    m.lineRangeMapping.original.startLineNumber,
                    m.lineRangeMapping.original.endLineNumberExclusive,
                    m.lineRangeMapping.modified.startLineNumber,
                    m.lineRangeMapping.modified.endLineNumberExclusive,
                    getLineChanges(m.changes)
                ])
        };
    }
    static _modelsAreIdentical(original, modified) {
        const originalLineCount = original.getLineCount();
        const modifiedLineCount = modified.getLineCount();
        if (originalLineCount !== modifiedLineCount) return false;
        for(let line = 1; line <= originalLineCount; line++){
            const originalLine = original.getLineContent(line);
            const modifiedLine = modified.getLineContent(line);
            if (originalLine !== modifiedLine) return false;
        }
        return true;
    }
    // ---- END diff --------------------------------------------------------------------------
    // ---- BEGIN minimal edits ---------------------------------------------------------------
    static{
        this._diffLimit = 100000;
    }
    async $computeMoreMinimalEdits(modelUrl, edits, pretty) {
        const model = this._getModel(modelUrl);
        if (!model) return edits;
        const result = [];
        let lastEol = undefined;
        edits = edits.slice(0).sort((a, b)=>{
            if (a.range && b.range) return (0, _rangeJs.Range).compareRangesUsingStarts(a.range, b.range);
            // eol only changes should go to the end
            const aRng = a.range ? 0 : 1;
            const bRng = b.range ? 0 : 1;
            return aRng - bRng;
        });
        // merge adjacent edits
        let writeIndex = 0;
        for(let readIndex = 1; readIndex < edits.length; readIndex++)if ((0, _rangeJs.Range).getEndPosition(edits[writeIndex].range).equals((0, _rangeJs.Range).getStartPosition(edits[readIndex].range))) {
            edits[writeIndex].range = (0, _rangeJs.Range).fromPositions((0, _rangeJs.Range).getStartPosition(edits[writeIndex].range), (0, _rangeJs.Range).getEndPosition(edits[readIndex].range));
            edits[writeIndex].text += edits[readIndex].text;
        } else {
            writeIndex++;
            edits[writeIndex] = edits[readIndex];
        }
        edits.length = writeIndex + 1;
        for (let { range, text, eol } of edits){
            if (typeof eol === "number") lastEol = eol;
            if ((0, _rangeJs.Range).isEmpty(range) && !text) continue;
            const original = model.getValueInRange(range);
            text = text.replace(/\r\n|\n|\r/g, model.eol);
            if (original === text) continue;
            // make sure diff won't take too long
            if (Math.max(text.length, original.length) > EditorSimpleWorker._diffLimit) {
                result.push({
                    range,
                    text
                });
                continue;
            }
            // compute diff between original and edit.text
            const changes = (0, _diffJs.stringDiff)(original, text, pretty);
            const editOffset = model.offsetAt((0, _rangeJs.Range).lift(range).getStartPosition());
            for (const change of changes){
                const start = model.positionAt(editOffset + change.originalStart);
                const end = model.positionAt(editOffset + change.originalStart + change.originalLength);
                const newEdit = {
                    text: text.substr(change.modifiedStart, change.modifiedLength),
                    range: {
                        startLineNumber: start.lineNumber,
                        startColumn: start.column,
                        endLineNumber: end.lineNumber,
                        endColumn: end.column
                    }
                };
                if (model.getValueInRange(newEdit.range) !== newEdit.text) result.push(newEdit);
            }
        }
        if (typeof lastEol === "number") result.push({
            eol: lastEol,
            text: "",
            range: {
                startLineNumber: 0,
                startColumn: 0,
                endLineNumber: 0,
                endColumn: 0
            }
        });
        return result;
    }
    // ---- END minimal edits ---------------------------------------------------------------
    async $computeLinks(modelUrl) {
        const model = this._getModel(modelUrl);
        if (!model) return null;
        return (0, _linkComputerJs.computeLinks)(model);
    }
    // --- BEGIN default document colors -----------------------------------------------------------
    async $computeDefaultDocumentColors(modelUrl) {
        const model = this._getModel(modelUrl);
        if (!model) return null;
        return (0, _defaultDocumentColorsComputerJs.computeDefaultDocumentColors)(model);
    }
    // ---- BEGIN suggest --------------------------------------------------------------------------
    static{
        this._suggestionsLimit = 10000;
    }
    async $textualSuggest(modelUrls, leadingWord, wordDef, wordDefFlags) {
        const sw = new (0, _stopwatchJs.StopWatch)();
        const wordDefRegExp = new RegExp(wordDef, wordDefFlags);
        const seen = new Set();
        outer: for (const url of modelUrls){
            const model = this._getModel(url);
            if (!model) continue;
            for (const word of model.words(wordDefRegExp)){
                if (word === leadingWord || !isNaN(Number(word))) continue;
                seen.add(word);
                if (seen.size > EditorSimpleWorker._suggestionsLimit) break outer;
            }
        }
        return {
            words: Array.from(seen),
            duration: sw.elapsed()
        };
    }
    // ---- END suggest --------------------------------------------------------------------------
    //#region -- word ranges --
    async $computeWordRanges(modelUrl, range, wordDef, wordDefFlags) {
        const model = this._getModel(modelUrl);
        if (!model) return Object.create(null);
        const wordDefRegExp = new RegExp(wordDef, wordDefFlags);
        const result = Object.create(null);
        for(let line = range.startLineNumber; line < range.endLineNumber; line++){
            const words = model.getLineWords(line, wordDefRegExp);
            for (const word of words){
                if (!isNaN(Number(word.word))) continue;
                let array = result[word.word];
                if (!array) {
                    array = [];
                    result[word.word] = array;
                }
                array.push({
                    startLineNumber: line,
                    startColumn: word.startColumn,
                    endLineNumber: line,
                    endColumn: word.endColumn
                });
            }
        }
        return result;
    }
    //#endregion
    async $navigateValueSet(modelUrl, range, up, wordDef, wordDefFlags) {
        const model = this._getModel(modelUrl);
        if (!model) return null;
        const wordDefRegExp = new RegExp(wordDef, wordDefFlags);
        if (range.startColumn === range.endColumn) range = {
            startLineNumber: range.startLineNumber,
            startColumn: range.startColumn,
            endLineNumber: range.endLineNumber,
            endColumn: range.endColumn + 1
        };
        const selectionText = model.getValueInRange(range);
        const wordRange = model.getWordAtPosition({
            lineNumber: range.startLineNumber,
            column: range.startColumn
        }, wordDefRegExp);
        if (!wordRange) return null;
        const word = model.getValueInRange(wordRange);
        const result = (0, _inplaceReplaceSupportJs.BasicInplaceReplace).INSTANCE.navigateValueSet(range, selectionText, wordRange, word, up);
        return result;
    }
}
class EditorSimpleWorker extends BaseEditorSimpleWorker {
    constructor(_host, _foreignModuleFactory){
        super();
        this._host = _host;
        this._foreignModuleFactory = _foreignModuleFactory;
        this._foreignModule = null;
    }
    async $ping() {
        return "pong";
    }
    // ---- BEGIN foreign module support --------------------------------------------------------------------------
    $loadForeignModule(moduleId, createData, foreignHostMethods) {
        const proxyMethodRequest = (method, args)=>{
            return this._host.$fhr(method, args);
        };
        const foreignHost = (0, _objectsJs.createProxyObject)(foreignHostMethods, proxyMethodRequest);
        const ctx = {
            host: foreignHost,
            getMirrorModels: ()=>{
                return this._getModels();
            }
        };
        if (this._foreignModuleFactory) {
            this._foreignModule = this._foreignModuleFactory(ctx, createData);
            // static foreing module
            return Promise.resolve((0, _objectsJs.getAllMethodNames)(this._foreignModule));
        }
        return new Promise((resolve, reject)=>{
            const onModuleCallback = (foreignModule)=>{
                this._foreignModule = foreignModule.create(ctx, createData);
                resolve((0, _objectsJs.getAllMethodNames)(this._foreignModule));
            };
            if (!isESM) require([
                `${moduleId}`
            ], onModuleCallback, reject);
            else {
                const url = (0, _networkJs.FileAccess).asBrowserUri(`${moduleId}.js`).toString(true);
                require(`${url}`).then(onModuleCallback).catch(reject);
            }
        });
    }
    // foreign method request
    $fmr(method, args) {
        if (!this._foreignModule || typeof this._foreignModule[method] !== "function") return Promise.reject(new Error("Missing requestHandler or method: " + method));
        try {
            return Promise.resolve(this._foreignModule[method].apply(this._foreignModule, args));
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
function create(workerServer) {
    return new EditorSimpleWorker((0, _editorWorkerHostJs.EditorWorkerHost).getChannel(workerServer), null);
}
if (typeof importScripts === "function") // Running in a web worker
globalThis.monaco = (0, _editorBaseApiJs.createMonacoBaseAPI)();

},{"../../../base/common/diff/diff.js":"8KX5t","../core/range.js":"jmUPh","../languages/linkComputer.js":"aD62c","../languages/supports/inplaceReplaceSupport.js":"lHctP","./editorBaseApi.js":"jf9LT","./editorWorkerHost.js":"dbMbx","../../../base/common/stopwatch.js":"77PF9","./unicodeTextModelHighlighter.js":"av1me","../diff/linesDiffComputers.js":"fz5Gs","../../../base/common/objects.js":"j84mT","../../../base/common/network.js":"2c1AD","../languages/defaultDocumentColorsComputer.js":"j46B3","./findSectionHeaders.js":"cpN9z","./textModelSync/textModelSync.impl.js":"d5ZUa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8KX5t":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringDiffSequence", ()=>StringDiffSequence);
parcelHelpers.export(exports, "stringDiff", ()=>stringDiff);
/**
 * An implementation of the difference algorithm described in
 * "An O(ND) Difference Algorithm and its variations" by Eugene W. Myers
 */ parcelHelpers.export(exports, "LcsDiff", ()=>LcsDiff);
var _diffChangeJs = require("./diffChange.js");
var _hashJs = require("../hash.js");
class StringDiffSequence {
    constructor(source){
        this.source = source;
    }
    getElements() {
        const source = this.source;
        const characters = new Int32Array(source.length);
        for(let i = 0, len = source.length; i < len; i++)characters[i] = source.charCodeAt(i);
        return characters;
    }
}
function stringDiff(original, modified, pretty) {
    return new LcsDiff(new StringDiffSequence(original), new StringDiffSequence(modified)).ComputeDiff(pretty).changes;
}
//
// The code below has been ported from a C# implementation in VS
//
class Debug {
    static Assert(condition, message) {
        if (!condition) throw new Error(message);
    }
}
class MyArray {
    /**
     * Copies a range of elements from an Array starting at the specified source index and pastes
     * them to another Array starting at the specified destination index. The length and the indexes
     * are specified as 64-bit integers.
     * sourceArray:
     *		The Array that contains the data to copy.
     * sourceIndex:
     *		A 64-bit integer that represents the index in the sourceArray at which copying begins.
     * destinationArray:
     *		The Array that receives the data.
     * destinationIndex:
     *		A 64-bit integer that represents the index in the destinationArray at which storing begins.
     * length:
     *		A 64-bit integer that represents the number of elements to copy.
     */ static Copy(sourceArray, sourceIndex, destinationArray, destinationIndex, length) {
        for(let i = 0; i < length; i++)destinationArray[destinationIndex + i] = sourceArray[sourceIndex + i];
    }
    static Copy2(sourceArray, sourceIndex, destinationArray, destinationIndex, length) {
        for(let i = 0; i < length; i++)destinationArray[destinationIndex + i] = sourceArray[sourceIndex + i];
    }
}
/**
 * A utility class which helps to create the set of DiffChanges from
 * a difference operation. This class accepts original DiffElements and
 * modified DiffElements that are involved in a particular change. The
 * MarkNextChange() method can be called to mark the separation between
 * distinct changes. At the end, the Changes property can be called to retrieve
 * the constructed changes.
 */ class DiffChangeHelper {
    /**
     * Constructs a new DiffChangeHelper for the given DiffSequences.
     */ constructor(){
        this.m_changes = [];
        this.m_originalStart = 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ;
        this.m_modifiedStart = 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ;
        this.m_originalCount = 0;
        this.m_modifiedCount = 0;
    }
    /**
     * Marks the beginning of the next change in the set of differences.
     */ MarkNextChange() {
        // Only add to the list if there is something to add
        if (this.m_originalCount > 0 || this.m_modifiedCount > 0) // Add the new change to our list
        this.m_changes.push(new (0, _diffChangeJs.DiffChange)(this.m_originalStart, this.m_originalCount, this.m_modifiedStart, this.m_modifiedCount));
        // Reset for the next change
        this.m_originalCount = 0;
        this.m_modifiedCount = 0;
        this.m_originalStart = 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ;
        this.m_modifiedStart = 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ;
    }
    /**
     * Adds the original element at the given position to the elements
     * affected by the current change. The modified index gives context
     * to the change position with respect to the original sequence.
     * @param originalIndex The index of the original element to add.
     * @param modifiedIndex The index of the modified element that provides corresponding position in the modified sequence.
     */ AddOriginalElement(originalIndex, modifiedIndex) {
        // The 'true' start index is the smallest of the ones we've seen
        this.m_originalStart = Math.min(this.m_originalStart, originalIndex);
        this.m_modifiedStart = Math.min(this.m_modifiedStart, modifiedIndex);
        this.m_originalCount++;
    }
    /**
     * Adds the modified element at the given position to the elements
     * affected by the current change. The original index gives context
     * to the change position with respect to the modified sequence.
     * @param originalIndex The index of the original element that provides corresponding position in the original sequence.
     * @param modifiedIndex The index of the modified element to add.
     */ AddModifiedElement(originalIndex, modifiedIndex) {
        // The 'true' start index is the smallest of the ones we've seen
        this.m_originalStart = Math.min(this.m_originalStart, originalIndex);
        this.m_modifiedStart = Math.min(this.m_modifiedStart, modifiedIndex);
        this.m_modifiedCount++;
    }
    /**
     * Retrieves all of the changes marked by the class.
     */ getChanges() {
        if (this.m_originalCount > 0 || this.m_modifiedCount > 0) // Finish up on whatever is left
        this.MarkNextChange();
        return this.m_changes;
    }
    /**
     * Retrieves all of the changes marked by the class in the reverse order
     */ getReverseChanges() {
        if (this.m_originalCount > 0 || this.m_modifiedCount > 0) // Finish up on whatever is left
        this.MarkNextChange();
        this.m_changes.reverse();
        return this.m_changes;
    }
}
class LcsDiff {
    /**
     * Constructs the DiffFinder
     */ constructor(originalSequence, modifiedSequence, continueProcessingPredicate = null){
        this.ContinueProcessingPredicate = continueProcessingPredicate;
        this._originalSequence = originalSequence;
        this._modifiedSequence = modifiedSequence;
        const [originalStringElements, originalElementsOrHash, originalHasStrings] = LcsDiff._getElements(originalSequence);
        const [modifiedStringElements, modifiedElementsOrHash, modifiedHasStrings] = LcsDiff._getElements(modifiedSequence);
        this._hasStrings = originalHasStrings && modifiedHasStrings;
        this._originalStringElements = originalStringElements;
        this._originalElementsOrHash = originalElementsOrHash;
        this._modifiedStringElements = modifiedStringElements;
        this._modifiedElementsOrHash = modifiedElementsOrHash;
        this.m_forwardHistory = [];
        this.m_reverseHistory = [];
    }
    static _isStringArray(arr) {
        return arr.length > 0 && typeof arr[0] === "string";
    }
    static _getElements(sequence) {
        const elements = sequence.getElements();
        if (LcsDiff._isStringArray(elements)) {
            const hashes = new Int32Array(elements.length);
            for(let i = 0, len = elements.length; i < len; i++)hashes[i] = (0, _hashJs.stringHash)(elements[i], 0);
            return [
                elements,
                hashes,
                true
            ];
        }
        if (elements instanceof Int32Array) return [
            [],
            elements,
            false
        ];
        return [
            [],
            new Int32Array(elements),
            false
        ];
    }
    ElementsAreEqual(originalIndex, newIndex) {
        if (this._originalElementsOrHash[originalIndex] !== this._modifiedElementsOrHash[newIndex]) return false;
        return this._hasStrings ? this._originalStringElements[originalIndex] === this._modifiedStringElements[newIndex] : true;
    }
    ElementsAreStrictEqual(originalIndex, newIndex) {
        if (!this.ElementsAreEqual(originalIndex, newIndex)) return false;
        const originalElement = LcsDiff._getStrictElement(this._originalSequence, originalIndex);
        const modifiedElement = LcsDiff._getStrictElement(this._modifiedSequence, newIndex);
        return originalElement === modifiedElement;
    }
    static _getStrictElement(sequence, index) {
        if (typeof sequence.getStrictElement === "function") return sequence.getStrictElement(index);
        return null;
    }
    OriginalElementsAreEqual(index1, index2) {
        if (this._originalElementsOrHash[index1] !== this._originalElementsOrHash[index2]) return false;
        return this._hasStrings ? this._originalStringElements[index1] === this._originalStringElements[index2] : true;
    }
    ModifiedElementsAreEqual(index1, index2) {
        if (this._modifiedElementsOrHash[index1] !== this._modifiedElementsOrHash[index2]) return false;
        return this._hasStrings ? this._modifiedStringElements[index1] === this._modifiedStringElements[index2] : true;
    }
    ComputeDiff(pretty) {
        return this._ComputeDiff(0, this._originalElementsOrHash.length - 1, 0, this._modifiedElementsOrHash.length - 1, pretty);
    }
    /**
     * Computes the differences between the original and modified input
     * sequences on the bounded range.
     * @returns An array of the differences between the two input sequences.
     */ _ComputeDiff(originalStart, originalEnd, modifiedStart, modifiedEnd, pretty) {
        const quitEarlyArr = [
            false
        ];
        let changes = this.ComputeDiffRecursive(originalStart, originalEnd, modifiedStart, modifiedEnd, quitEarlyArr);
        if (pretty) // We have to clean up the computed diff to be more intuitive
        // but it turns out this cannot be done correctly until the entire set
        // of diffs have been computed
        changes = this.PrettifyChanges(changes);
        return {
            quitEarly: quitEarlyArr[0],
            changes: changes
        };
    }
    /**
     * Private helper method which computes the differences on the bounded range
     * recursively.
     * @returns An array of the differences between the two input sequences.
     */ ComputeDiffRecursive(originalStart, originalEnd, modifiedStart, modifiedEnd, quitEarlyArr) {
        quitEarlyArr[0] = false;
        // Find the start of the differences
        while(originalStart <= originalEnd && modifiedStart <= modifiedEnd && this.ElementsAreEqual(originalStart, modifiedStart)){
            originalStart++;
            modifiedStart++;
        }
        // Find the end of the differences
        while(originalEnd >= originalStart && modifiedEnd >= modifiedStart && this.ElementsAreEqual(originalEnd, modifiedEnd)){
            originalEnd--;
            modifiedEnd--;
        }
        // In the special case where we either have all insertions or all deletions or the sequences are identical
        if (originalStart > originalEnd || modifiedStart > modifiedEnd) {
            let changes;
            if (modifiedStart <= modifiedEnd) {
                Debug.Assert(originalStart === originalEnd + 1, "originalStart should only be one more than originalEnd");
                // All insertions
                changes = [
                    new (0, _diffChangeJs.DiffChange)(originalStart, 0, modifiedStart, modifiedEnd - modifiedStart + 1)
                ];
            } else if (originalStart <= originalEnd) {
                Debug.Assert(modifiedStart === modifiedEnd + 1, "modifiedStart should only be one more than modifiedEnd");
                // All deletions
                changes = [
                    new (0, _diffChangeJs.DiffChange)(originalStart, originalEnd - originalStart + 1, modifiedStart, 0)
                ];
            } else {
                Debug.Assert(originalStart === originalEnd + 1, "originalStart should only be one more than originalEnd");
                Debug.Assert(modifiedStart === modifiedEnd + 1, "modifiedStart should only be one more than modifiedEnd");
                // Identical sequences - No differences
                changes = [];
            }
            return changes;
        }
        // This problem can be solved using the Divide-And-Conquer technique.
        const midOriginalArr = [
            0
        ];
        const midModifiedArr = [
            0
        ];
        const result = this.ComputeRecursionPoint(originalStart, originalEnd, modifiedStart, modifiedEnd, midOriginalArr, midModifiedArr, quitEarlyArr);
        const midOriginal = midOriginalArr[0];
        const midModified = midModifiedArr[0];
        if (result !== null) // Result is not-null when there was enough memory to compute the changes while
        // searching for the recursion point
        return result;
        else if (!quitEarlyArr[0]) {
            // We can break the problem down recursively by finding the changes in the
            // First Half:   (originalStart, modifiedStart) to (midOriginal, midModified)
            // Second Half:  (midOriginal + 1, minModified + 1) to (originalEnd, modifiedEnd)
            // NOTE: ComputeDiff() is inclusive, therefore the second range starts on the next point
            const leftChanges = this.ComputeDiffRecursive(originalStart, midOriginal, modifiedStart, midModified, quitEarlyArr);
            let rightChanges = [];
            if (!quitEarlyArr[0]) rightChanges = this.ComputeDiffRecursive(midOriginal + 1, originalEnd, midModified + 1, modifiedEnd, quitEarlyArr);
            else // We didn't have time to finish the first half, so we don't have time to compute this half.
            // Consider the entire rest of the sequence different.
            rightChanges = [
                new (0, _diffChangeJs.DiffChange)(midOriginal + 1, originalEnd - (midOriginal + 1) + 1, midModified + 1, modifiedEnd - (midModified + 1) + 1)
            ];
            return this.ConcatenateChanges(leftChanges, rightChanges);
        }
        // If we hit here, we quit early, and so can't return anything meaningful
        return [
            new (0, _diffChangeJs.DiffChange)(originalStart, originalEnd - originalStart + 1, modifiedStart, modifiedEnd - modifiedStart + 1)
        ];
    }
    WALKTRACE(diagonalForwardBase, diagonalForwardStart, diagonalForwardEnd, diagonalForwardOffset, diagonalReverseBase, diagonalReverseStart, diagonalReverseEnd, diagonalReverseOffset, forwardPoints, reversePoints, originalIndex, originalEnd, midOriginalArr, modifiedIndex, modifiedEnd, midModifiedArr, deltaIsEven, quitEarlyArr) {
        let forwardChanges = null;
        let reverseChanges = null;
        // First, walk backward through the forward diagonals history
        let changeHelper = new DiffChangeHelper();
        let diagonalMin = diagonalForwardStart;
        let diagonalMax = diagonalForwardEnd;
        let diagonalRelative = midOriginalArr[0] - midModifiedArr[0] - diagonalForwardOffset;
        let lastOriginalIndex = -1073741824 /* Constants.MIN_SAFE_SMALL_INTEGER */ ;
        let historyIndex = this.m_forwardHistory.length - 1;
        do {
            // Get the diagonal index from the relative diagonal number
            const diagonal = diagonalRelative + diagonalForwardBase;
            // Figure out where we came from
            if (diagonal === diagonalMin || diagonal < diagonalMax && forwardPoints[diagonal - 1] < forwardPoints[diagonal + 1]) {
                // Vertical line (the element is an insert)
                originalIndex = forwardPoints[diagonal + 1];
                modifiedIndex = originalIndex - diagonalRelative - diagonalForwardOffset;
                if (originalIndex < lastOriginalIndex) changeHelper.MarkNextChange();
                lastOriginalIndex = originalIndex;
                changeHelper.AddModifiedElement(originalIndex + 1, modifiedIndex);
                diagonalRelative = diagonal + 1 - diagonalForwardBase; //Setup for the next iteration
            } else {
                // Horizontal line (the element is a deletion)
                originalIndex = forwardPoints[diagonal - 1] + 1;
                modifiedIndex = originalIndex - diagonalRelative - diagonalForwardOffset;
                if (originalIndex < lastOriginalIndex) changeHelper.MarkNextChange();
                lastOriginalIndex = originalIndex - 1;
                changeHelper.AddOriginalElement(originalIndex, modifiedIndex + 1);
                diagonalRelative = diagonal - 1 - diagonalForwardBase; //Setup for the next iteration
            }
            if (historyIndex >= 0) {
                forwardPoints = this.m_forwardHistory[historyIndex];
                diagonalForwardBase = forwardPoints[0]; //We stored this in the first spot
                diagonalMin = 1;
                diagonalMax = forwardPoints.length - 1;
            }
        }while (--historyIndex >= -1);
        // Ironically, we get the forward changes as the reverse of the
        // order we added them since we technically added them backwards
        forwardChanges = changeHelper.getReverseChanges();
        if (quitEarlyArr[0]) {
            // TODO: Calculate a partial from the reverse diagonals.
            //       For now, just assume everything after the midOriginal/midModified point is a diff
            let originalStartPoint = midOriginalArr[0] + 1;
            let modifiedStartPoint = midModifiedArr[0] + 1;
            if (forwardChanges !== null && forwardChanges.length > 0) {
                const lastForwardChange = forwardChanges[forwardChanges.length - 1];
                originalStartPoint = Math.max(originalStartPoint, lastForwardChange.getOriginalEnd());
                modifiedStartPoint = Math.max(modifiedStartPoint, lastForwardChange.getModifiedEnd());
            }
            reverseChanges = [
                new (0, _diffChangeJs.DiffChange)(originalStartPoint, originalEnd - originalStartPoint + 1, modifiedStartPoint, modifiedEnd - modifiedStartPoint + 1)
            ];
        } else {
            // Now walk backward through the reverse diagonals history
            changeHelper = new DiffChangeHelper();
            diagonalMin = diagonalReverseStart;
            diagonalMax = diagonalReverseEnd;
            diagonalRelative = midOriginalArr[0] - midModifiedArr[0] - diagonalReverseOffset;
            lastOriginalIndex = 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ;
            historyIndex = deltaIsEven ? this.m_reverseHistory.length - 1 : this.m_reverseHistory.length - 2;
            do {
                // Get the diagonal index from the relative diagonal number
                const diagonal = diagonalRelative + diagonalReverseBase;
                // Figure out where we came from
                if (diagonal === diagonalMin || diagonal < diagonalMax && reversePoints[diagonal - 1] >= reversePoints[diagonal + 1]) {
                    // Horizontal line (the element is a deletion))
                    originalIndex = reversePoints[diagonal + 1] - 1;
                    modifiedIndex = originalIndex - diagonalRelative - diagonalReverseOffset;
                    if (originalIndex > lastOriginalIndex) changeHelper.MarkNextChange();
                    lastOriginalIndex = originalIndex + 1;
                    changeHelper.AddOriginalElement(originalIndex + 1, modifiedIndex + 1);
                    diagonalRelative = diagonal + 1 - diagonalReverseBase; //Setup for the next iteration
                } else {
                    // Vertical line (the element is an insertion)
                    originalIndex = reversePoints[diagonal - 1];
                    modifiedIndex = originalIndex - diagonalRelative - diagonalReverseOffset;
                    if (originalIndex > lastOriginalIndex) changeHelper.MarkNextChange();
                    lastOriginalIndex = originalIndex;
                    changeHelper.AddModifiedElement(originalIndex + 1, modifiedIndex + 1);
                    diagonalRelative = diagonal - 1 - diagonalReverseBase; //Setup for the next iteration
                }
                if (historyIndex >= 0) {
                    reversePoints = this.m_reverseHistory[historyIndex];
                    diagonalReverseBase = reversePoints[0]; //We stored this in the first spot
                    diagonalMin = 1;
                    diagonalMax = reversePoints.length - 1;
                }
            }while (--historyIndex >= -1);
            // There are cases where the reverse history will find diffs that
            // are correct, but not intuitive, so we need shift them.
            reverseChanges = changeHelper.getChanges();
        }
        return this.ConcatenateChanges(forwardChanges, reverseChanges);
    }
    /**
     * Given the range to compute the diff on, this method finds the point:
     * (midOriginal, midModified)
     * that exists in the middle of the LCS of the two sequences and
     * is the point at which the LCS problem may be broken down recursively.
     * This method will try to keep the LCS trace in memory. If the LCS recursion
     * point is calculated and the full trace is available in memory, then this method
     * will return the change list.
     * @param originalStart The start bound of the original sequence range
     * @param originalEnd The end bound of the original sequence range
     * @param modifiedStart The start bound of the modified sequence range
     * @param modifiedEnd The end bound of the modified sequence range
     * @param midOriginal The middle point of the original sequence range
     * @param midModified The middle point of the modified sequence range
     * @returns The diff changes, if available, otherwise null
     */ ComputeRecursionPoint(originalStart, originalEnd, modifiedStart, modifiedEnd, midOriginalArr, midModifiedArr, quitEarlyArr) {
        let originalIndex = 0, modifiedIndex = 0;
        let diagonalForwardStart = 0, diagonalForwardEnd = 0;
        let diagonalReverseStart = 0, diagonalReverseEnd = 0;
        // To traverse the edit graph and produce the proper LCS, our actual
        // start position is just outside the given boundary
        originalStart--;
        modifiedStart--;
        // We set these up to make the compiler happy, but they will
        // be replaced before we return with the actual recursion point
        midOriginalArr[0] = 0;
        midModifiedArr[0] = 0;
        // Clear out the history
        this.m_forwardHistory = [];
        this.m_reverseHistory = [];
        // Each cell in the two arrays corresponds to a diagonal in the edit graph.
        // The integer value in the cell represents the originalIndex of the furthest
        // reaching point found so far that ends in that diagonal.
        // The modifiedIndex can be computed mathematically from the originalIndex and the diagonal number.
        const maxDifferences = originalEnd - originalStart + (modifiedEnd - modifiedStart);
        const numDiagonals = maxDifferences + 1;
        const forwardPoints = new Int32Array(numDiagonals);
        const reversePoints = new Int32Array(numDiagonals);
        // diagonalForwardBase: Index into forwardPoints of the diagonal which passes through (originalStart, modifiedStart)
        // diagonalReverseBase: Index into reversePoints of the diagonal which passes through (originalEnd, modifiedEnd)
        const diagonalForwardBase = modifiedEnd - modifiedStart;
        const diagonalReverseBase = originalEnd - originalStart;
        // diagonalForwardOffset: Geometric offset which allows modifiedIndex to be computed from originalIndex and the
        //    diagonal number (relative to diagonalForwardBase)
        // diagonalReverseOffset: Geometric offset which allows modifiedIndex to be computed from originalIndex and the
        //    diagonal number (relative to diagonalReverseBase)
        const diagonalForwardOffset = originalStart - modifiedStart;
        const diagonalReverseOffset = originalEnd - modifiedEnd;
        // delta: The difference between the end diagonal and the start diagonal. This is used to relate diagonal numbers
        //   relative to the start diagonal with diagonal numbers relative to the end diagonal.
        // The Even/Oddn-ness of this delta is important for determining when we should check for overlap
        const delta = diagonalReverseBase - diagonalForwardBase;
        const deltaIsEven = delta % 2 === 0;
        // Here we set up the start and end points as the furthest points found so far
        // in both the forward and reverse directions, respectively
        forwardPoints[diagonalForwardBase] = originalStart;
        reversePoints[diagonalReverseBase] = originalEnd;
        // Remember if we quit early, and thus need to do a best-effort result instead of a real result.
        quitEarlyArr[0] = false;
        // A couple of points:
        // --With this method, we iterate on the number of differences between the two sequences.
        //   The more differences there actually are, the longer this will take.
        // --Also, as the number of differences increases, we have to search on diagonals further
        //   away from the reference diagonal (which is diagonalForwardBase for forward, diagonalReverseBase for reverse).
        // --We extend on even diagonals (relative to the reference diagonal) only when numDifferences
        //   is even and odd diagonals only when numDifferences is odd.
        for(let numDifferences = 1; numDifferences <= maxDifferences / 2 + 1; numDifferences++){
            let furthestOriginalIndex = 0;
            let furthestModifiedIndex = 0;
            // Run the algorithm in the forward direction
            diagonalForwardStart = this.ClipDiagonalBound(diagonalForwardBase - numDifferences, numDifferences, diagonalForwardBase, numDiagonals);
            diagonalForwardEnd = this.ClipDiagonalBound(diagonalForwardBase + numDifferences, numDifferences, diagonalForwardBase, numDiagonals);
            for(let diagonal = diagonalForwardStart; diagonal <= diagonalForwardEnd; diagonal += 2){
                // STEP 1: We extend the furthest reaching point in the present diagonal
                // by looking at the diagonals above and below and picking the one whose point
                // is further away from the start point (originalStart, modifiedStart)
                if (diagonal === diagonalForwardStart || diagonal < diagonalForwardEnd && forwardPoints[diagonal - 1] < forwardPoints[diagonal + 1]) originalIndex = forwardPoints[diagonal + 1];
                else originalIndex = forwardPoints[diagonal - 1] + 1;
                modifiedIndex = originalIndex - (diagonal - diagonalForwardBase) - diagonalForwardOffset;
                // Save the current originalIndex so we can test for false overlap in step 3
                const tempOriginalIndex = originalIndex;
                // STEP 2: We can continue to extend the furthest reaching point in the present diagonal
                // so long as the elements are equal.
                while(originalIndex < originalEnd && modifiedIndex < modifiedEnd && this.ElementsAreEqual(originalIndex + 1, modifiedIndex + 1)){
                    originalIndex++;
                    modifiedIndex++;
                }
                forwardPoints[diagonal] = originalIndex;
                if (originalIndex + modifiedIndex > furthestOriginalIndex + furthestModifiedIndex) {
                    furthestOriginalIndex = originalIndex;
                    furthestModifiedIndex = modifiedIndex;
                }
                // STEP 3: If delta is odd (overlap first happens on forward when delta is odd)
                // and diagonal is in the range of reverse diagonals computed for numDifferences-1
                // (the previous iteration; we haven't computed reverse diagonals for numDifferences yet)
                // then check for overlap.
                if (!deltaIsEven && Math.abs(diagonal - diagonalReverseBase) <= numDifferences - 1) {
                    if (originalIndex >= reversePoints[diagonal]) {
                        midOriginalArr[0] = originalIndex;
                        midModifiedArr[0] = modifiedIndex;
                        if (tempOriginalIndex <= reversePoints[diagonal] && true && numDifferences <= 1448) // BINGO! We overlapped, and we have the full trace in memory!
                        return this.WALKTRACE(diagonalForwardBase, diagonalForwardStart, diagonalForwardEnd, diagonalForwardOffset, diagonalReverseBase, diagonalReverseStart, diagonalReverseEnd, diagonalReverseOffset, forwardPoints, reversePoints, originalIndex, originalEnd, midOriginalArr, modifiedIndex, modifiedEnd, midModifiedArr, deltaIsEven, quitEarlyArr);
                        else // Either false overlap, or we didn't have enough memory for the full trace
                        // Just return the recursion point
                        return null;
                    }
                }
            }
            // Check to see if we should be quitting early, before moving on to the next iteration.
            const matchLengthOfLongest = (furthestOriginalIndex - originalStart + (furthestModifiedIndex - modifiedStart) - numDifferences) / 2;
            if (this.ContinueProcessingPredicate !== null && !this.ContinueProcessingPredicate(furthestOriginalIndex, matchLengthOfLongest)) {
                // We can't finish, so skip ahead to generating a result from what we have.
                quitEarlyArr[0] = true;
                // Use the furthest distance we got in the forward direction.
                midOriginalArr[0] = furthestOriginalIndex;
                midModifiedArr[0] = furthestModifiedIndex;
                if (matchLengthOfLongest > 0 && true && numDifferences <= 1448) // Enough of the history is in memory to walk it backwards
                return this.WALKTRACE(diagonalForwardBase, diagonalForwardStart, diagonalForwardEnd, diagonalForwardOffset, diagonalReverseBase, diagonalReverseStart, diagonalReverseEnd, diagonalReverseOffset, forwardPoints, reversePoints, originalIndex, originalEnd, midOriginalArr, modifiedIndex, modifiedEnd, midModifiedArr, deltaIsEven, quitEarlyArr);
                else {
                    // We didn't actually remember enough of the history.
                    //Since we are quitting the diff early, we need to shift back the originalStart and modified start
                    //back into the boundary limits since we decremented their value above beyond the boundary limit.
                    originalStart++;
                    modifiedStart++;
                    return [
                        new (0, _diffChangeJs.DiffChange)(originalStart, originalEnd - originalStart + 1, modifiedStart, modifiedEnd - modifiedStart + 1)
                    ];
                }
            }
            // Run the algorithm in the reverse direction
            diagonalReverseStart = this.ClipDiagonalBound(diagonalReverseBase - numDifferences, numDifferences, diagonalReverseBase, numDiagonals);
            diagonalReverseEnd = this.ClipDiagonalBound(diagonalReverseBase + numDifferences, numDifferences, diagonalReverseBase, numDiagonals);
            for(let diagonal = diagonalReverseStart; diagonal <= diagonalReverseEnd; diagonal += 2){
                // STEP 1: We extend the furthest reaching point in the present diagonal
                // by looking at the diagonals above and below and picking the one whose point
                // is further away from the start point (originalEnd, modifiedEnd)
                if (diagonal === diagonalReverseStart || diagonal < diagonalReverseEnd && reversePoints[diagonal - 1] >= reversePoints[diagonal + 1]) originalIndex = reversePoints[diagonal + 1] - 1;
                else originalIndex = reversePoints[diagonal - 1];
                modifiedIndex = originalIndex - (diagonal - diagonalReverseBase) - diagonalReverseOffset;
                // Save the current originalIndex so we can test for false overlap
                const tempOriginalIndex = originalIndex;
                // STEP 2: We can continue to extend the furthest reaching point in the present diagonal
                // as long as the elements are equal.
                while(originalIndex > originalStart && modifiedIndex > modifiedStart && this.ElementsAreEqual(originalIndex, modifiedIndex)){
                    originalIndex--;
                    modifiedIndex--;
                }
                reversePoints[diagonal] = originalIndex;
                // STEP 4: If delta is even (overlap first happens on reverse when delta is even)
                // and diagonal is in the range of forward diagonals computed for numDifferences
                // then check for overlap.
                if (deltaIsEven && Math.abs(diagonal - diagonalForwardBase) <= numDifferences) {
                    if (originalIndex <= forwardPoints[diagonal]) {
                        midOriginalArr[0] = originalIndex;
                        midModifiedArr[0] = modifiedIndex;
                        if (tempOriginalIndex >= forwardPoints[diagonal] && true && numDifferences <= 1448) // BINGO! We overlapped, and we have the full trace in memory!
                        return this.WALKTRACE(diagonalForwardBase, diagonalForwardStart, diagonalForwardEnd, diagonalForwardOffset, diagonalReverseBase, diagonalReverseStart, diagonalReverseEnd, diagonalReverseOffset, forwardPoints, reversePoints, originalIndex, originalEnd, midOriginalArr, modifiedIndex, modifiedEnd, midModifiedArr, deltaIsEven, quitEarlyArr);
                        else // Either false overlap, or we didn't have enough memory for the full trace
                        // Just return the recursion point
                        return null;
                    }
                }
            }
            // Save current vectors to history before the next iteration
            if (numDifferences <= 1447 /* LocalConstants.MaxDifferencesHistory */ ) {
                // We are allocating space for one extra int, which we fill with
                // the index of the diagonal base index
                let temp = new Int32Array(diagonalForwardEnd - diagonalForwardStart + 2);
                temp[0] = diagonalForwardBase - diagonalForwardStart + 1;
                MyArray.Copy2(forwardPoints, diagonalForwardStart, temp, 1, diagonalForwardEnd - diagonalForwardStart + 1);
                this.m_forwardHistory.push(temp);
                temp = new Int32Array(diagonalReverseEnd - diagonalReverseStart + 2);
                temp[0] = diagonalReverseBase - diagonalReverseStart + 1;
                MyArray.Copy2(reversePoints, diagonalReverseStart, temp, 1, diagonalReverseEnd - diagonalReverseStart + 1);
                this.m_reverseHistory.push(temp);
            }
        }
        // If we got here, then we have the full trace in history. We just have to convert it to a change list
        // NOTE: This part is a bit messy
        return this.WALKTRACE(diagonalForwardBase, diagonalForwardStart, diagonalForwardEnd, diagonalForwardOffset, diagonalReverseBase, diagonalReverseStart, diagonalReverseEnd, diagonalReverseOffset, forwardPoints, reversePoints, originalIndex, originalEnd, midOriginalArr, modifiedIndex, modifiedEnd, midModifiedArr, deltaIsEven, quitEarlyArr);
    }
    /**
     * Shifts the given changes to provide a more intuitive diff.
     * While the first element in a diff matches the first element after the diff,
     * we shift the diff down.
     *
     * @param changes The list of changes to shift
     * @returns The shifted changes
     */ PrettifyChanges(changes) {
        // Shift all the changes down first
        for(let i = 0; i < changes.length; i++){
            const change = changes[i];
            const originalStop = i < changes.length - 1 ? changes[i + 1].originalStart : this._originalElementsOrHash.length;
            const modifiedStop = i < changes.length - 1 ? changes[i + 1].modifiedStart : this._modifiedElementsOrHash.length;
            const checkOriginal = change.originalLength > 0;
            const checkModified = change.modifiedLength > 0;
            while(change.originalStart + change.originalLength < originalStop && change.modifiedStart + change.modifiedLength < modifiedStop && (!checkOriginal || this.OriginalElementsAreEqual(change.originalStart, change.originalStart + change.originalLength)) && (!checkModified || this.ModifiedElementsAreEqual(change.modifiedStart, change.modifiedStart + change.modifiedLength))){
                const startStrictEqual = this.ElementsAreStrictEqual(change.originalStart, change.modifiedStart);
                const endStrictEqual = this.ElementsAreStrictEqual(change.originalStart + change.originalLength, change.modifiedStart + change.modifiedLength);
                if (endStrictEqual && !startStrictEqual) break;
                change.originalStart++;
                change.modifiedStart++;
            }
            const mergedChangeArr = [
                null
            ];
            if (i < changes.length - 1 && this.ChangesOverlap(changes[i], changes[i + 1], mergedChangeArr)) {
                changes[i] = mergedChangeArr[0];
                changes.splice(i + 1, 1);
                i--;
                continue;
            }
        }
        // Shift changes back up until we hit empty or whitespace-only lines
        for(let i = changes.length - 1; i >= 0; i--){
            const change = changes[i];
            let originalStop = 0;
            let modifiedStop = 0;
            if (i > 0) {
                const prevChange = changes[i - 1];
                originalStop = prevChange.originalStart + prevChange.originalLength;
                modifiedStop = prevChange.modifiedStart + prevChange.modifiedLength;
            }
            const checkOriginal = change.originalLength > 0;
            const checkModified = change.modifiedLength > 0;
            let bestDelta = 0;
            let bestScore = this._boundaryScore(change.originalStart, change.originalLength, change.modifiedStart, change.modifiedLength);
            for(let delta = 1;; delta++){
                const originalStart = change.originalStart - delta;
                const modifiedStart = change.modifiedStart - delta;
                if (originalStart < originalStop || modifiedStart < modifiedStop) break;
                if (checkOriginal && !this.OriginalElementsAreEqual(originalStart, originalStart + change.originalLength)) break;
                if (checkModified && !this.ModifiedElementsAreEqual(modifiedStart, modifiedStart + change.modifiedLength)) break;
                const touchingPreviousChange = originalStart === originalStop && modifiedStart === modifiedStop;
                const score = (touchingPreviousChange ? 5 : 0) + this._boundaryScore(originalStart, change.originalLength, modifiedStart, change.modifiedLength);
                if (score > bestScore) {
                    bestScore = score;
                    bestDelta = delta;
                }
            }
            change.originalStart -= bestDelta;
            change.modifiedStart -= bestDelta;
            const mergedChangeArr = [
                null
            ];
            if (i > 0 && this.ChangesOverlap(changes[i - 1], changes[i], mergedChangeArr)) {
                changes[i - 1] = mergedChangeArr[0];
                changes.splice(i, 1);
                i++;
                continue;
            }
        }
        // There could be multiple longest common substrings.
        // Give preference to the ones containing longer lines
        if (this._hasStrings) for(let i = 1, len = changes.length; i < len; i++){
            const aChange = changes[i - 1];
            const bChange = changes[i];
            const matchedLength = bChange.originalStart - aChange.originalStart - aChange.originalLength;
            const aOriginalStart = aChange.originalStart;
            const bOriginalEnd = bChange.originalStart + bChange.originalLength;
            const abOriginalLength = bOriginalEnd - aOriginalStart;
            const aModifiedStart = aChange.modifiedStart;
            const bModifiedEnd = bChange.modifiedStart + bChange.modifiedLength;
            const abModifiedLength = bModifiedEnd - aModifiedStart;
            // Avoid wasting a lot of time with these searches
            if (matchedLength < 5 && abOriginalLength < 20 && abModifiedLength < 20) {
                const t = this._findBetterContiguousSequence(aOriginalStart, abOriginalLength, aModifiedStart, abModifiedLength, matchedLength);
                if (t) {
                    const [originalMatchStart, modifiedMatchStart] = t;
                    if (originalMatchStart !== aChange.originalStart + aChange.originalLength || modifiedMatchStart !== aChange.modifiedStart + aChange.modifiedLength) {
                        // switch to another sequence that has a better score
                        aChange.originalLength = originalMatchStart - aChange.originalStart;
                        aChange.modifiedLength = modifiedMatchStart - aChange.modifiedStart;
                        bChange.originalStart = originalMatchStart + matchedLength;
                        bChange.modifiedStart = modifiedMatchStart + matchedLength;
                        bChange.originalLength = bOriginalEnd - bChange.originalStart;
                        bChange.modifiedLength = bModifiedEnd - bChange.modifiedStart;
                    }
                }
            }
        }
        return changes;
    }
    _findBetterContiguousSequence(originalStart, originalLength, modifiedStart, modifiedLength, desiredLength) {
        if (originalLength < desiredLength || modifiedLength < desiredLength) return null;
        const originalMax = originalStart + originalLength - desiredLength + 1;
        const modifiedMax = modifiedStart + modifiedLength - desiredLength + 1;
        let bestScore = 0;
        let bestOriginalStart = 0;
        let bestModifiedStart = 0;
        for(let i = originalStart; i < originalMax; i++)for(let j = modifiedStart; j < modifiedMax; j++){
            const score = this._contiguousSequenceScore(i, j, desiredLength);
            if (score > 0 && score > bestScore) {
                bestScore = score;
                bestOriginalStart = i;
                bestModifiedStart = j;
            }
        }
        if (bestScore > 0) return [
            bestOriginalStart,
            bestModifiedStart
        ];
        return null;
    }
    _contiguousSequenceScore(originalStart, modifiedStart, length) {
        let score = 0;
        for(let l = 0; l < length; l++){
            if (!this.ElementsAreEqual(originalStart + l, modifiedStart + l)) return 0;
            score += this._originalStringElements[originalStart + l].length;
        }
        return score;
    }
    _OriginalIsBoundary(index) {
        if (index <= 0 || index >= this._originalElementsOrHash.length - 1) return true;
        return this._hasStrings && /^\s*$/.test(this._originalStringElements[index]);
    }
    _OriginalRegionIsBoundary(originalStart, originalLength) {
        if (this._OriginalIsBoundary(originalStart) || this._OriginalIsBoundary(originalStart - 1)) return true;
        if (originalLength > 0) {
            const originalEnd = originalStart + originalLength;
            if (this._OriginalIsBoundary(originalEnd - 1) || this._OriginalIsBoundary(originalEnd)) return true;
        }
        return false;
    }
    _ModifiedIsBoundary(index) {
        if (index <= 0 || index >= this._modifiedElementsOrHash.length - 1) return true;
        return this._hasStrings && /^\s*$/.test(this._modifiedStringElements[index]);
    }
    _ModifiedRegionIsBoundary(modifiedStart, modifiedLength) {
        if (this._ModifiedIsBoundary(modifiedStart) || this._ModifiedIsBoundary(modifiedStart - 1)) return true;
        if (modifiedLength > 0) {
            const modifiedEnd = modifiedStart + modifiedLength;
            if (this._ModifiedIsBoundary(modifiedEnd - 1) || this._ModifiedIsBoundary(modifiedEnd)) return true;
        }
        return false;
    }
    _boundaryScore(originalStart, originalLength, modifiedStart, modifiedLength) {
        const originalScore = this._OriginalRegionIsBoundary(originalStart, originalLength) ? 1 : 0;
        const modifiedScore = this._ModifiedRegionIsBoundary(modifiedStart, modifiedLength) ? 1 : 0;
        return originalScore + modifiedScore;
    }
    /**
     * Concatenates the two input DiffChange lists and returns the resulting
     * list.
     * @param The left changes
     * @param The right changes
     * @returns The concatenated list
     */ ConcatenateChanges(left, right) {
        const mergedChangeArr = [];
        if (left.length === 0 || right.length === 0) return right.length > 0 ? right : left;
        else if (this.ChangesOverlap(left[left.length - 1], right[0], mergedChangeArr)) {
            // Since we break the problem down recursively, it is possible that we
            // might recurse in the middle of a change thereby splitting it into
            // two changes. Here in the combining stage, we detect and fuse those
            // changes back together
            const result = new Array(left.length + right.length - 1);
            MyArray.Copy(left, 0, result, 0, left.length - 1);
            result[left.length - 1] = mergedChangeArr[0];
            MyArray.Copy(right, 1, result, left.length, right.length - 1);
            return result;
        } else {
            const result = new Array(left.length + right.length);
            MyArray.Copy(left, 0, result, 0, left.length);
            MyArray.Copy(right, 0, result, left.length, right.length);
            return result;
        }
    }
    /**
     * Returns true if the two changes overlap and can be merged into a single
     * change
     * @param left The left change
     * @param right The right change
     * @param mergedChange The merged change if the two overlap, null otherwise
     * @returns True if the two changes overlap
     */ ChangesOverlap(left, right, mergedChangeArr) {
        Debug.Assert(left.originalStart <= right.originalStart, "Left change is not less than or equal to right change");
        Debug.Assert(left.modifiedStart <= right.modifiedStart, "Left change is not less than or equal to right change");
        if (left.originalStart + left.originalLength >= right.originalStart || left.modifiedStart + left.modifiedLength >= right.modifiedStart) {
            const originalStart = left.originalStart;
            let originalLength = left.originalLength;
            const modifiedStart = left.modifiedStart;
            let modifiedLength = left.modifiedLength;
            if (left.originalStart + left.originalLength >= right.originalStart) originalLength = right.originalStart + right.originalLength - left.originalStart;
            if (left.modifiedStart + left.modifiedLength >= right.modifiedStart) modifiedLength = right.modifiedStart + right.modifiedLength - left.modifiedStart;
            mergedChangeArr[0] = new (0, _diffChangeJs.DiffChange)(originalStart, originalLength, modifiedStart, modifiedLength);
            return true;
        } else {
            mergedChangeArr[0] = null;
            return false;
        }
    }
    /**
     * Helper method used to clip a diagonal index to the range of valid
     * diagonals. This also decides whether or not the diagonal index,
     * if it exceeds the boundary, should be clipped to the boundary or clipped
     * one inside the boundary depending on the Even/Odd status of the boundary
     * and numDifferences.
     * @param diagonal The index of the diagonal to clip.
     * @param numDifferences The current number of differences being iterated upon.
     * @param diagonalBaseIndex The base reference diagonal.
     * @param numDiagonals The total number of diagonals.
     * @returns The clipped diagonal index.
     */ ClipDiagonalBound(diagonal, numDifferences, diagonalBaseIndex, numDiagonals) {
        if (diagonal >= 0 && diagonal < numDiagonals) // Nothing to clip, its in range
        return diagonal;
        // diagonalsBelow: The number of diagonals below the reference diagonal
        // diagonalsAbove: The number of diagonals above the reference diagonal
        const diagonalsBelow = diagonalBaseIndex;
        const diagonalsAbove = numDiagonals - diagonalBaseIndex - 1;
        const diffEven = numDifferences % 2 === 0;
        if (diagonal < 0) {
            const lowerBoundEven = diagonalsBelow % 2 === 0;
            return diffEven === lowerBoundEven ? 0 : 1;
        } else {
            const upperBoundEven = diagonalsAbove % 2 === 0;
            return diffEven === upperBoundEven ? numDiagonals - 1 : numDiagonals - 2;
        }
    }
}

},{"./diffChange.js":"2v4wN","../hash.js":"hXc0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2v4wN":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 * Represents information about a specific difference between two sequences.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiffChange", ()=>DiffChange);
class DiffChange {
    /**
     * Constructs a new DiffChange with the given sequence information
     * and content.
     */ constructor(originalStart, originalLength, modifiedStart, modifiedLength){
        //Debug.Assert(originalLength > 0 || modifiedLength > 0, "originalLength and modifiedLength cannot both be <= 0");
        this.originalStart = originalStart;
        this.originalLength = originalLength;
        this.modifiedStart = modifiedStart;
        this.modifiedLength = modifiedLength;
    }
    /**
     * The end point (exclusive) of the change in the original sequence.
     */ getOriginalEnd() {
        return this.originalStart + this.originalLength;
    }
    /**
     * The end point (exclusive) of the change in the modified sequence.
     */ getModifiedEnd() {
        return this.modifiedStart + this.modifiedLength;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aD62c":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StateMachine", ()=>StateMachine);
parcelHelpers.export(exports, "LinkComputer", ()=>LinkComputer);
/**
 * Returns an array of all links contains in the provided
 * document. *Note* that this operation is computational
 * expensive and should not run in the UI thread.
 */ parcelHelpers.export(exports, "computeLinks", ()=>computeLinks);
var _characterClassifierJs = require("../core/characterClassifier.js");
class Uint8Matrix {
    constructor(rows, cols, defaultValue){
        const data = new Uint8Array(rows * cols);
        for(let i = 0, len = rows * cols; i < len; i++)data[i] = defaultValue;
        this._data = data;
        this.rows = rows;
        this.cols = cols;
    }
    get(row, col) {
        return this._data[row * this.cols + col];
    }
    set(row, col, value) {
        this._data[row * this.cols + col] = value;
    }
}
class StateMachine {
    constructor(edges){
        let maxCharCode = 0;
        let maxState = 0 /* State.Invalid */ ;
        for(let i = 0, len = edges.length; i < len; i++){
            const [from, chCode, to] = edges[i];
            if (chCode > maxCharCode) maxCharCode = chCode;
            if (from > maxState) maxState = from;
            if (to > maxState) maxState = to;
        }
        maxCharCode++;
        maxState++;
        const states = new Uint8Matrix(maxState, maxCharCode, 0 /* State.Invalid */ );
        for(let i = 0, len = edges.length; i < len; i++){
            const [from, chCode, to] = edges[i];
            states.set(from, chCode, to);
        }
        this._states = states;
        this._maxCharCode = maxCharCode;
    }
    nextState(currentState, chCode) {
        if (chCode < 0 || chCode >= this._maxCharCode) return 0 /* State.Invalid */ ;
        return this._states.get(currentState, chCode);
    }
}
// State machine for http:// or https:// or file://
let _stateMachine = null;
function getStateMachine() {
    if (_stateMachine === null) _stateMachine = new StateMachine([
        [
            1 /* State.Start */ ,
            104 /* CharCode.h */ ,
            2 /* State.H */ 
        ],
        [
            1 /* State.Start */ ,
            72 /* CharCode.H */ ,
            2 /* State.H */ 
        ],
        [
            1 /* State.Start */ ,
            102 /* CharCode.f */ ,
            6 /* State.F */ 
        ],
        [
            1 /* State.Start */ ,
            70 /* CharCode.F */ ,
            6 /* State.F */ 
        ],
        [
            2 /* State.H */ ,
            116 /* CharCode.t */ ,
            3 /* State.HT */ 
        ],
        [
            2 /* State.H */ ,
            84 /* CharCode.T */ ,
            3 /* State.HT */ 
        ],
        [
            3 /* State.HT */ ,
            116 /* CharCode.t */ ,
            4 /* State.HTT */ 
        ],
        [
            3 /* State.HT */ ,
            84 /* CharCode.T */ ,
            4 /* State.HTT */ 
        ],
        [
            4 /* State.HTT */ ,
            112 /* CharCode.p */ ,
            5 /* State.HTTP */ 
        ],
        [
            4 /* State.HTT */ ,
            80 /* CharCode.P */ ,
            5 /* State.HTTP */ 
        ],
        [
            5 /* State.HTTP */ ,
            115 /* CharCode.s */ ,
            9 /* State.BeforeColon */ 
        ],
        [
            5 /* State.HTTP */ ,
            83 /* CharCode.S */ ,
            9 /* State.BeforeColon */ 
        ],
        [
            5 /* State.HTTP */ ,
            58 /* CharCode.Colon */ ,
            10 /* State.AfterColon */ 
        ],
        [
            6 /* State.F */ ,
            105 /* CharCode.i */ ,
            7 /* State.FI */ 
        ],
        [
            6 /* State.F */ ,
            73 /* CharCode.I */ ,
            7 /* State.FI */ 
        ],
        [
            7 /* State.FI */ ,
            108 /* CharCode.l */ ,
            8 /* State.FIL */ 
        ],
        [
            7 /* State.FI */ ,
            76 /* CharCode.L */ ,
            8 /* State.FIL */ 
        ],
        [
            8 /* State.FIL */ ,
            101 /* CharCode.e */ ,
            9 /* State.BeforeColon */ 
        ],
        [
            8 /* State.FIL */ ,
            69 /* CharCode.E */ ,
            9 /* State.BeforeColon */ 
        ],
        [
            9 /* State.BeforeColon */ ,
            58 /* CharCode.Colon */ ,
            10 /* State.AfterColon */ 
        ],
        [
            10 /* State.AfterColon */ ,
            47 /* CharCode.Slash */ ,
            11 /* State.AlmostThere */ 
        ],
        [
            11 /* State.AlmostThere */ ,
            47 /* CharCode.Slash */ ,
            12 /* State.End */ 
        ]
    ]);
    return _stateMachine;
}
let _classifier = null;
function getClassifier() {
    if (_classifier === null) {
        _classifier = new (0, _characterClassifierJs.CharacterClassifier)(0 /* CharacterClass.None */ );
        // allow-any-unicode-next-line
        const FORCE_TERMINATION_CHARACTERS = " 	<>'\"\u3001\u3002\uFF61\uFF64\uFF0C\uFF0E\uFF1A\uFF1B\u2018\u3008\u300C\u300E\u3014\uFF08\uFF3B\uFF5B\uFF62\uFF63\uFF5D\uFF3D\uFF09\u3015\u300F\u300D\u3009\u2019\uFF40\uFF5E\u2026";
        for(let i = 0; i < FORCE_TERMINATION_CHARACTERS.length; i++)_classifier.set(FORCE_TERMINATION_CHARACTERS.charCodeAt(i), 1 /* CharacterClass.ForceTermination */ );
        const CANNOT_END_WITH_CHARACTERS = ".,;:";
        for(let i = 0; i < CANNOT_END_WITH_CHARACTERS.length; i++)_classifier.set(CANNOT_END_WITH_CHARACTERS.charCodeAt(i), 2 /* CharacterClass.CannotEndIn */ );
    }
    return _classifier;
}
class LinkComputer {
    static _createLink(classifier, line, lineNumber, linkBeginIndex, linkEndIndex) {
        // Do not allow to end link in certain characters...
        let lastIncludedCharIndex = linkEndIndex - 1;
        do {
            const chCode = line.charCodeAt(lastIncludedCharIndex);
            const chClass = classifier.get(chCode);
            if (chClass !== 2 /* CharacterClass.CannotEndIn */ ) break;
            lastIncludedCharIndex--;
        }while (lastIncludedCharIndex > linkBeginIndex);
        // Handle links enclosed in parens, square brackets and curlys.
        if (linkBeginIndex > 0) {
            const charCodeBeforeLink = line.charCodeAt(linkBeginIndex - 1);
            const lastCharCodeInLink = line.charCodeAt(lastIncludedCharIndex);
            if (charCodeBeforeLink === 40 /* CharCode.OpenParen */  && lastCharCodeInLink === 41 /* CharCode.CloseParen */  || charCodeBeforeLink === 91 /* CharCode.OpenSquareBracket */  && lastCharCodeInLink === 93 /* CharCode.CloseSquareBracket */  || charCodeBeforeLink === 123 /* CharCode.OpenCurlyBrace */  && lastCharCodeInLink === 125 /* CharCode.CloseCurlyBrace */ ) // Do not end in ) if ( is before the link start
            // Do not end in ] if [ is before the link start
            // Do not end in } if { is before the link start
            lastIncludedCharIndex--;
        }
        return {
            range: {
                startLineNumber: lineNumber,
                startColumn: linkBeginIndex + 1,
                endLineNumber: lineNumber,
                endColumn: lastIncludedCharIndex + 2
            },
            url: line.substring(linkBeginIndex, lastIncludedCharIndex + 1)
        };
    }
    static computeLinks(model, stateMachine = getStateMachine()) {
        const classifier = getClassifier();
        const result = [];
        for(let i = 1, lineCount = model.getLineCount(); i <= lineCount; i++){
            const line = model.getLineContent(i);
            const len = line.length;
            let j = 0;
            let linkBeginIndex = 0;
            let linkBeginChCode = 0;
            let state = 1 /* State.Start */ ;
            let hasOpenParens = false;
            let hasOpenSquareBracket = false;
            let inSquareBrackets = false;
            let hasOpenCurlyBracket = false;
            while(j < len){
                let resetStateMachine = false;
                const chCode = line.charCodeAt(j);
                if (state === 13 /* State.Accept */ ) {
                    let chClass;
                    switch(chCode){
                        case 40 /* CharCode.OpenParen */ :
                            hasOpenParens = true;
                            chClass = 0 /* CharacterClass.None */ ;
                            break;
                        case 41 /* CharCode.CloseParen */ :
                            chClass = hasOpenParens ? 0 /* CharacterClass.None */  : 1 /* CharacterClass.ForceTermination */ ;
                            break;
                        case 91 /* CharCode.OpenSquareBracket */ :
                            inSquareBrackets = true;
                            hasOpenSquareBracket = true;
                            chClass = 0 /* CharacterClass.None */ ;
                            break;
                        case 93 /* CharCode.CloseSquareBracket */ :
                            inSquareBrackets = false;
                            chClass = hasOpenSquareBracket ? 0 /* CharacterClass.None */  : 1 /* CharacterClass.ForceTermination */ ;
                            break;
                        case 123 /* CharCode.OpenCurlyBrace */ :
                            hasOpenCurlyBracket = true;
                            chClass = 0 /* CharacterClass.None */ ;
                            break;
                        case 125 /* CharCode.CloseCurlyBrace */ :
                            chClass = hasOpenCurlyBracket ? 0 /* CharacterClass.None */  : 1 /* CharacterClass.ForceTermination */ ;
                            break;
                        // The following three rules make it that ' or " or ` are allowed inside links
                        // only if the link is wrapped by some other quote character
                        case 39 /* CharCode.SingleQuote */ :
                        case 34 /* CharCode.DoubleQuote */ :
                        case 96 /* CharCode.BackTick */ :
                            if (linkBeginChCode === chCode) chClass = 1 /* CharacterClass.ForceTermination */ ;
                            else if (linkBeginChCode === 39 /* CharCode.SingleQuote */  || linkBeginChCode === 34 /* CharCode.DoubleQuote */  || linkBeginChCode === 96 /* CharCode.BackTick */ ) chClass = 0 /* CharacterClass.None */ ;
                            else chClass = 1 /* CharacterClass.ForceTermination */ ;
                            break;
                        case 42 /* CharCode.Asterisk */ :
                            // `*` terminates a link if the link began with `*`
                            chClass = linkBeginChCode === 42 /* CharCode.Asterisk */  ? 1 /* CharacterClass.ForceTermination */  : 0 /* CharacterClass.None */ ;
                            break;
                        case 124 /* CharCode.Pipe */ :
                            // `|` terminates a link if the link began with `|`
                            chClass = linkBeginChCode === 124 /* CharCode.Pipe */  ? 1 /* CharacterClass.ForceTermination */  : 0 /* CharacterClass.None */ ;
                            break;
                        case 32 /* CharCode.Space */ :
                            // ` ` allow space in between [ and ]
                            chClass = inSquareBrackets ? 0 /* CharacterClass.None */  : 1 /* CharacterClass.ForceTermination */ ;
                            break;
                        default:
                            chClass = classifier.get(chCode);
                    }
                    // Check if character terminates link
                    if (chClass === 1 /* CharacterClass.ForceTermination */ ) {
                        result.push(LinkComputer._createLink(classifier, line, i, linkBeginIndex, j));
                        resetStateMachine = true;
                    }
                } else if (state === 12 /* State.End */ ) {
                    let chClass;
                    if (chCode === 91 /* CharCode.OpenSquareBracket */ ) {
                        // Allow for the authority part to contain ipv6 addresses which contain [ and ]
                        hasOpenSquareBracket = true;
                        chClass = 0 /* CharacterClass.None */ ;
                    } else chClass = classifier.get(chCode);
                    // Check if character terminates link
                    if (chClass === 1 /* CharacterClass.ForceTermination */ ) resetStateMachine = true;
                    else state = 13 /* State.Accept */ ;
                } else {
                    state = stateMachine.nextState(state, chCode);
                    if (state === 0 /* State.Invalid */ ) resetStateMachine = true;
                }
                if (resetStateMachine) {
                    state = 1 /* State.Start */ ;
                    hasOpenParens = false;
                    hasOpenSquareBracket = false;
                    hasOpenCurlyBracket = false;
                    // Record where the link started
                    linkBeginIndex = j + 1;
                    linkBeginChCode = chCode;
                }
                j++;
            }
            if (state === 13 /* State.Accept */ ) result.push(LinkComputer._createLink(classifier, line, i, linkBeginIndex, len));
        }
        return result;
    }
}
function computeLinks(model) {
    if (!model || typeof model.getLineCount !== "function" || typeof model.getLineContent !== "function") // Unknown caller!
    return [];
    return LinkComputer.computeLinks(model);
}

},{"../core/characterClassifier.js":"hl8tq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hl8tq":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A fast character classifier that uses a compact array for ASCII values.
 */ parcelHelpers.export(exports, "CharacterClassifier", ()=>CharacterClassifier);
parcelHelpers.export(exports, "CharacterSet", ()=>CharacterSet);
var _uintJs = require("../../../base/common/uint.js");
class CharacterClassifier {
    constructor(_defaultValue){
        const defaultValue = (0, _uintJs.toUint8)(_defaultValue);
        this._defaultValue = defaultValue;
        this._asciiMap = CharacterClassifier._createAsciiMap(defaultValue);
        this._map = new Map();
    }
    static _createAsciiMap(defaultValue) {
        const asciiMap = new Uint8Array(256);
        asciiMap.fill(defaultValue);
        return asciiMap;
    }
    set(charCode, _value) {
        const value = (0, _uintJs.toUint8)(_value);
        if (charCode >= 0 && charCode < 256) this._asciiMap[charCode] = value;
        else this._map.set(charCode, value);
    }
    get(charCode) {
        if (charCode >= 0 && charCode < 256) return this._asciiMap[charCode];
        else return this._map.get(charCode) || this._defaultValue;
    }
    clear() {
        this._asciiMap.fill(this._defaultValue);
        this._map.clear();
    }
}
class CharacterSet {
    constructor(){
        this._actual = new CharacterClassifier(0 /* Boolean.False */ );
    }
    add(charCode) {
        this._actual.set(charCode, 1 /* Boolean.True */ );
    }
    has(charCode) {
        return this._actual.get(charCode) === 1 /* Boolean.True */ ;
    }
    clear() {
        return this._actual.clear();
    }
}

},{"../../../base/common/uint.js":"7fnps","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7fnps":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toUint8", ()=>toUint8);
parcelHelpers.export(exports, "toUint32", ()=>toUint32);
function toUint8(v) {
    if (v < 0) return 0;
    if (v > 255 /* Constants.MAX_UINT_8 */ ) return 255 /* Constants.MAX_UINT_8 */ ;
    return v | 0;
}
function toUint32(v) {
    if (v < 0) return 0;
    if (v > 4294967295 /* Constants.MAX_UINT_32 */ ) return 4294967295 /* Constants.MAX_UINT_32 */ ;
    return v | 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lHctP":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BasicInplaceReplace", ()=>BasicInplaceReplace);
class BasicInplaceReplace {
    constructor(){
        this._defaultValueSet = [
            [
                "true",
                "false"
            ],
            [
                "True",
                "False"
            ],
            [
                "Private",
                "Public",
                "Friend",
                "ReadOnly",
                "Partial",
                "Protected",
                "WriteOnly"
            ],
            [
                "public",
                "protected",
                "private"
            ]
        ];
    }
    static{
        this.INSTANCE = new BasicInplaceReplace();
    }
    navigateValueSet(range1, text1, range2, text2, up) {
        if (range1 && text1) {
            const result = this.doNavigateValueSet(text1, up);
            if (result) return {
                range: range1,
                value: result
            };
        }
        if (range2 && text2) {
            const result = this.doNavigateValueSet(text2, up);
            if (result) return {
                range: range2,
                value: result
            };
        }
        return null;
    }
    doNavigateValueSet(text, up) {
        const numberResult = this.numberReplace(text, up);
        if (numberResult !== null) return numberResult;
        return this.textReplace(text, up);
    }
    numberReplace(value, up) {
        const precision = Math.pow(10, value.length - (value.lastIndexOf(".") + 1));
        let n1 = Number(value);
        const n2 = parseFloat(value);
        if (!isNaN(n1) && !isNaN(n2) && n1 === n2) {
            if (n1 === 0 && !up) return null; // don't do negative
            else {
                n1 = Math.floor(n1 * precision);
                n1 += up ? precision : -precision;
                return String(n1 / precision);
            }
        }
        return null;
    }
    textReplace(value, up) {
        return this.valueSetsReplace(this._defaultValueSet, value, up);
    }
    valueSetsReplace(valueSets, value, up) {
        let result = null;
        for(let i = 0, len = valueSets.length; result === null && i < len; i++)result = this.valueSetReplace(valueSets[i], value, up);
        return result;
    }
    valueSetReplace(valueSet, value, up) {
        let idx = valueSet.indexOf(value);
        if (idx >= 0) {
            idx += up ? 1 : -1;
            if (idx < 0) idx = valueSet.length - 1;
            else idx %= valueSet.length;
            return valueSet[idx];
        }
        return null;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dbMbx":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorWorkerHost", ()=>EditorWorkerHost);
class EditorWorkerHost {
    static{
        this.CHANNEL_NAME = "editorWorkerHost";
    }
    static getChannel(workerServer) {
        return workerServer.getChannel(EditorWorkerHost.CHANNEL_NAME);
    }
    static setChannel(workerClient, obj) {
        workerClient.setChannel(EditorWorkerHost.CHANNEL_NAME, obj);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"av1me":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnicodeTextModelHighlighter", ()=>UnicodeTextModelHighlighter);
var _rangeJs = require("../core/range.js");
var _textModelSearchJs = require("../model/textModelSearch.js");
var _stringsJs = require("../../../base/common/strings.js");
var _assertJs = require("../../../base/common/assert.js");
var _wordHelperJs = require("../core/wordHelper.js");
class UnicodeTextModelHighlighter {
    static computeUnicodeHighlights(model, options, range) {
        const startLine = range ? range.startLineNumber : 1;
        const endLine = range ? range.endLineNumber : model.getLineCount();
        const codePointHighlighter = new CodePointHighlighter(options);
        const candidates = codePointHighlighter.getCandidateCodePoints();
        let regex;
        if (candidates === "allNonBasicAscii") regex = new RegExp("[^\\t\\n\\r\\x20-\\x7E]", "g");
        else regex = new RegExp(`${buildRegExpCharClassExpr(Array.from(candidates))}`, "g");
        const searcher = new (0, _textModelSearchJs.Searcher)(null, regex);
        const ranges = [];
        let hasMore = false;
        let m;
        let ambiguousCharacterCount = 0;
        let invisibleCharacterCount = 0;
        let nonBasicAsciiCharacterCount = 0;
        forLoop: for(let lineNumber = startLine, lineCount = endLine; lineNumber <= lineCount; lineNumber++){
            const lineContent = model.getLineContent(lineNumber);
            const lineLength = lineContent.length;
            // Reset regex to search from the beginning
            searcher.reset(0);
            do {
                m = searcher.next(lineContent);
                if (m) {
                    let startIndex = m.index;
                    let endIndex = m.index + m[0].length;
                    // Extend range to entire code point
                    if (startIndex > 0) {
                        const charCodeBefore = lineContent.charCodeAt(startIndex - 1);
                        if (_stringsJs.isHighSurrogate(charCodeBefore)) startIndex--;
                    }
                    if (endIndex + 1 < lineLength) {
                        const charCodeBefore = lineContent.charCodeAt(endIndex - 1);
                        if (_stringsJs.isHighSurrogate(charCodeBefore)) endIndex++;
                    }
                    const str = lineContent.substring(startIndex, endIndex);
                    let word = (0, _wordHelperJs.getWordAtText)(startIndex + 1, (0, _wordHelperJs.DEFAULT_WORD_REGEXP), lineContent, 0);
                    if (word && word.endColumn <= startIndex + 1) // The word does not include the problematic character, ignore the word
                    word = null;
                    const highlightReason = codePointHighlighter.shouldHighlightNonBasicASCII(str, word ? word.word : null);
                    if (highlightReason !== 0 /* SimpleHighlightReason.None */ ) {
                        if (highlightReason === 3 /* SimpleHighlightReason.Ambiguous */ ) ambiguousCharacterCount++;
                        else if (highlightReason === 2 /* SimpleHighlightReason.Invisible */ ) invisibleCharacterCount++;
                        else if (highlightReason === 1 /* SimpleHighlightReason.NonBasicASCII */ ) nonBasicAsciiCharacterCount++;
                        else (0, _assertJs.assertNever)(highlightReason);
                        const MAX_RESULT_LENGTH = 1000;
                        if (ranges.length >= MAX_RESULT_LENGTH) {
                            hasMore = true;
                            break forLoop;
                        }
                        ranges.push(new (0, _rangeJs.Range)(lineNumber, startIndex + 1, lineNumber, endIndex + 1));
                    }
                }
            }while (m);
        }
        return {
            ranges,
            hasMore,
            ambiguousCharacterCount,
            invisibleCharacterCount,
            nonBasicAsciiCharacterCount
        };
    }
    static computeUnicodeHighlightReason(char, options) {
        const codePointHighlighter = new CodePointHighlighter(options);
        const reason = codePointHighlighter.shouldHighlightNonBasicASCII(char, null);
        switch(reason){
            case 0 /* SimpleHighlightReason.None */ :
                return null;
            case 2 /* SimpleHighlightReason.Invisible */ :
                return {
                    kind: 1 /* UnicodeHighlighterReasonKind.Invisible */ 
                };
            case 3 /* SimpleHighlightReason.Ambiguous */ :
                {
                    const codePoint = char.codePointAt(0);
                    const primaryConfusable = codePointHighlighter.ambiguousCharacters.getPrimaryConfusable(codePoint);
                    const notAmbiguousInLocales = _stringsJs.AmbiguousCharacters.getLocales().filter((l)=>!_stringsJs.AmbiguousCharacters.getInstance(new Set([
                            ...options.allowedLocales,
                            l
                        ])).isAmbiguous(codePoint));
                    return {
                        kind: 0 /* UnicodeHighlighterReasonKind.Ambiguous */ ,
                        confusableWith: String.fromCodePoint(primaryConfusable),
                        notAmbiguousInLocales
                    };
                }
            case 1 /* SimpleHighlightReason.NonBasicASCII */ :
                return {
                    kind: 2 /* UnicodeHighlighterReasonKind.NonBasicAscii */ 
                };
        }
    }
}
function buildRegExpCharClassExpr(codePoints, flags) {
    const src = `[${_stringsJs.escapeRegExpCharacters(codePoints.map((i)=>String.fromCodePoint(i)).join(""))}]`;
    return src;
}
class CodePointHighlighter {
    constructor(options){
        this.options = options;
        this.allowedCodePoints = new Set(options.allowedCodePoints);
        this.ambiguousCharacters = _stringsJs.AmbiguousCharacters.getInstance(new Set(options.allowedLocales));
    }
    getCandidateCodePoints() {
        if (this.options.nonBasicASCII) return "allNonBasicAscii";
        const set = new Set();
        if (this.options.invisibleCharacters) {
            for (const cp of _stringsJs.InvisibleCharacters.codePoints)if (!isAllowedInvisibleCharacter(String.fromCodePoint(cp))) set.add(cp);
        }
        if (this.options.ambiguousCharacters) for (const cp of this.ambiguousCharacters.getConfusableCodePoints())set.add(cp);
        for (const cp of this.allowedCodePoints)set.delete(cp);
        return set;
    }
    shouldHighlightNonBasicASCII(character, wordContext) {
        const codePoint = character.codePointAt(0);
        if (this.allowedCodePoints.has(codePoint)) return 0 /* SimpleHighlightReason.None */ ;
        if (this.options.nonBasicASCII) return 1 /* SimpleHighlightReason.NonBasicASCII */ ;
        let hasBasicASCIICharacters = false;
        let hasNonConfusableNonBasicAsciiCharacter = false;
        if (wordContext) for (const char of wordContext){
            const codePoint = char.codePointAt(0);
            const isBasicASCII = _stringsJs.isBasicASCII(char);
            hasBasicASCIICharacters = hasBasicASCIICharacters || isBasicASCII;
            if (!isBasicASCII && !this.ambiguousCharacters.isAmbiguous(codePoint) && !_stringsJs.InvisibleCharacters.isInvisibleCharacter(codePoint)) hasNonConfusableNonBasicAsciiCharacter = true;
        }
        if (/* Don't allow mixing weird looking characters with ASCII */ !hasBasicASCIICharacters && /* Is there an obviously weird looking character? */ hasNonConfusableNonBasicAsciiCharacter) return 0 /* SimpleHighlightReason.None */ ;
        if (this.options.invisibleCharacters) {
            // TODO check for emojis
            if (!isAllowedInvisibleCharacter(character) && _stringsJs.InvisibleCharacters.isInvisibleCharacter(codePoint)) return 2 /* SimpleHighlightReason.Invisible */ ;
        }
        if (this.options.ambiguousCharacters) {
            if (this.ambiguousCharacters.isAmbiguous(codePoint)) return 3 /* SimpleHighlightReason.Ambiguous */ ;
        }
        return 0 /* SimpleHighlightReason.None */ ;
    }
}
function isAllowedInvisibleCharacter(character) {
    return character === " " || character === "\n" || character === "	";
}

},{"../core/range.js":"jmUPh","../model/textModelSearch.js":"N1WkK","../../../base/common/strings.js":"aA9I1","../../../base/common/assert.js":"1nPIE","../core/wordHelper.js":"9FjxX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"N1WkK":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchParams", ()=>SearchParams);
parcelHelpers.export(exports, "isMultilineRegexSource", ()=>isMultilineRegexSource);
parcelHelpers.export(exports, "createFindMatch", ()=>createFindMatch);
parcelHelpers.export(exports, "TextModelSearch", ()=>TextModelSearch);
parcelHelpers.export(exports, "isValidMatch", ()=>isValidMatch);
parcelHelpers.export(exports, "Searcher", ()=>Searcher);
var _stringsJs = require("../../../base/common/strings.js");
var _wordCharacterClassifierJs = require("../core/wordCharacterClassifier.js");
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
var _modelJs = require("../model.js");
const LIMIT_FIND_COUNT = 999;
class SearchParams {
    constructor(searchString, isRegex, matchCase, wordSeparators){
        this.searchString = searchString;
        this.isRegex = isRegex;
        this.matchCase = matchCase;
        this.wordSeparators = wordSeparators;
    }
    parseSearchRequest() {
        if (this.searchString === "") return null;
        // Try to create a RegExp out of the params
        let multiline;
        if (this.isRegex) multiline = isMultilineRegexSource(this.searchString);
        else multiline = this.searchString.indexOf("\n") >= 0;
        let regex = null;
        try {
            regex = _stringsJs.createRegExp(this.searchString, this.isRegex, {
                matchCase: this.matchCase,
                wholeWord: false,
                multiline: multiline,
                global: true,
                unicode: true
            });
        } catch (err) {
            return null;
        }
        if (!regex) return null;
        let canUseSimpleSearch = !this.isRegex && !multiline;
        if (canUseSimpleSearch && this.searchString.toLowerCase() !== this.searchString.toUpperCase()) // casing might make a difference
        canUseSimpleSearch = this.matchCase;
        return new (0, _modelJs.SearchData)(regex, this.wordSeparators ? (0, _wordCharacterClassifierJs.getMapForWordSeparators)(this.wordSeparators, []) : null, canUseSimpleSearch ? this.searchString : null);
    }
}
function isMultilineRegexSource(searchString) {
    if (!searchString || searchString.length === 0) return false;
    for(let i = 0, len = searchString.length; i < len; i++){
        const chCode = searchString.charCodeAt(i);
        if (chCode === 10 /* CharCode.LineFeed */ ) return true;
        if (chCode === 92 /* CharCode.Backslash */ ) {
            // move to next char
            i++;
            if (i >= len) break;
            const nextChCode = searchString.charCodeAt(i);
            if (nextChCode === 110 /* CharCode.n */  || nextChCode === 114 /* CharCode.r */  || nextChCode === 87 /* CharCode.W */ ) return true;
        }
    }
    return false;
}
function createFindMatch(range, rawMatches, captureMatches) {
    if (!captureMatches) return new (0, _modelJs.FindMatch)(range, null);
    const matches = [];
    for(let i = 0, len = rawMatches.length; i < len; i++)matches[i] = rawMatches[i];
    return new (0, _modelJs.FindMatch)(range, matches);
}
class LineFeedCounter {
    constructor(text){
        const lineFeedsOffsets = [];
        let lineFeedsOffsetsLen = 0;
        for(let i = 0, textLen = text.length; i < textLen; i++)if (text.charCodeAt(i) === 10 /* CharCode.LineFeed */ ) lineFeedsOffsets[lineFeedsOffsetsLen++] = i;
        this._lineFeedsOffsets = lineFeedsOffsets;
    }
    findLineFeedCountBeforeOffset(offset) {
        const lineFeedsOffsets = this._lineFeedsOffsets;
        let min = 0;
        let max = lineFeedsOffsets.length - 1;
        if (max === -1) // no line feeds
        return 0;
        if (offset <= lineFeedsOffsets[0]) // before first line feed
        return 0;
        while(min < max){
            const mid = min + ((max - min) / 2 >> 0);
            if (lineFeedsOffsets[mid] >= offset) max = mid - 1;
            else if (lineFeedsOffsets[mid + 1] >= offset) {
                // bingo!
                min = mid;
                max = mid;
            } else min = mid + 1;
        }
        return min + 1;
    }
}
class TextModelSearch {
    static findMatches(model, searchParams, searchRange, captureMatches, limitResultCount) {
        const searchData = searchParams.parseSearchRequest();
        if (!searchData) return [];
        if (searchData.regex.multiline) return this._doFindMatchesMultiline(model, searchRange, new Searcher(searchData.wordSeparators, searchData.regex), captureMatches, limitResultCount);
        return this._doFindMatchesLineByLine(model, searchRange, searchData, captureMatches, limitResultCount);
    }
    /**
     * Multiline search always executes on the lines concatenated with \n.
     * We must therefore compensate for the count of \n in case the model is CRLF
     */ static _getMultilineMatchRange(model, deltaOffset, text, lfCounter, matchIndex, match0) {
        let startOffset;
        let lineFeedCountBeforeMatch = 0;
        if (lfCounter) {
            lineFeedCountBeforeMatch = lfCounter.findLineFeedCountBeforeOffset(matchIndex);
            startOffset = deltaOffset + matchIndex + lineFeedCountBeforeMatch /* add as many \r as there were \n */ ;
        } else startOffset = deltaOffset + matchIndex;
        let endOffset;
        if (lfCounter) {
            const lineFeedCountBeforeEndOfMatch = lfCounter.findLineFeedCountBeforeOffset(matchIndex + match0.length);
            const lineFeedCountInMatch = lineFeedCountBeforeEndOfMatch - lineFeedCountBeforeMatch;
            endOffset = startOffset + match0.length + lineFeedCountInMatch /* add as many \r as there were \n */ ;
        } else endOffset = startOffset + match0.length;
        const startPosition = model.getPositionAt(startOffset);
        const endPosition = model.getPositionAt(endOffset);
        return new (0, _rangeJs.Range)(startPosition.lineNumber, startPosition.column, endPosition.lineNumber, endPosition.column);
    }
    static _doFindMatchesMultiline(model, searchRange, searcher, captureMatches, limitResultCount) {
        const deltaOffset = model.getOffsetAt(searchRange.getStartPosition());
        // We always execute multiline search over the lines joined with \n
        // This makes it that \n will match the EOL for both CRLF and LF models
        // We compensate for offset errors in `_getMultilineMatchRange`
        const text = model.getValueInRange(searchRange, 1 /* EndOfLinePreference.LF */ );
        const lfCounter = model.getEOL() === "\r\n" ? new LineFeedCounter(text) : null;
        const result = [];
        let counter = 0;
        let m;
        searcher.reset(0);
        while(m = searcher.next(text)){
            result[counter++] = createFindMatch(this._getMultilineMatchRange(model, deltaOffset, text, lfCounter, m.index, m[0]), m, captureMatches);
            if (counter >= limitResultCount) return result;
        }
        return result;
    }
    static _doFindMatchesLineByLine(model, searchRange, searchData, captureMatches, limitResultCount) {
        const result = [];
        let resultLen = 0;
        // Early case for a search range that starts & stops on the same line number
        if (searchRange.startLineNumber === searchRange.endLineNumber) {
            const text = model.getLineContent(searchRange.startLineNumber).substring(searchRange.startColumn - 1, searchRange.endColumn - 1);
            resultLen = this._findMatchesInLine(searchData, text, searchRange.startLineNumber, searchRange.startColumn - 1, resultLen, result, captureMatches, limitResultCount);
            return result;
        }
        // Collect results from first line
        const text = model.getLineContent(searchRange.startLineNumber).substring(searchRange.startColumn - 1);
        resultLen = this._findMatchesInLine(searchData, text, searchRange.startLineNumber, searchRange.startColumn - 1, resultLen, result, captureMatches, limitResultCount);
        // Collect results from middle lines
        for(let lineNumber = searchRange.startLineNumber + 1; lineNumber < searchRange.endLineNumber && resultLen < limitResultCount; lineNumber++)resultLen = this._findMatchesInLine(searchData, model.getLineContent(lineNumber), lineNumber, 0, resultLen, result, captureMatches, limitResultCount);
        // Collect results from last line
        if (resultLen < limitResultCount) {
            const text = model.getLineContent(searchRange.endLineNumber).substring(0, searchRange.endColumn - 1);
            resultLen = this._findMatchesInLine(searchData, text, searchRange.endLineNumber, 0, resultLen, result, captureMatches, limitResultCount);
        }
        return result;
    }
    static _findMatchesInLine(searchData, text, lineNumber, deltaOffset, resultLen, result, captureMatches, limitResultCount) {
        const wordSeparators = searchData.wordSeparators;
        if (!captureMatches && searchData.simpleSearch) {
            const searchString = searchData.simpleSearch;
            const searchStringLen = searchString.length;
            const textLength = text.length;
            let lastMatchIndex = -searchStringLen;
            while((lastMatchIndex = text.indexOf(searchString, lastMatchIndex + searchStringLen)) !== -1)if (!wordSeparators || isValidMatch(wordSeparators, text, textLength, lastMatchIndex, searchStringLen)) {
                result[resultLen++] = new (0, _modelJs.FindMatch)(new (0, _rangeJs.Range)(lineNumber, lastMatchIndex + 1 + deltaOffset, lineNumber, lastMatchIndex + 1 + searchStringLen + deltaOffset), null);
                if (resultLen >= limitResultCount) return resultLen;
            }
            return resultLen;
        }
        const searcher = new Searcher(searchData.wordSeparators, searchData.regex);
        let m;
        // Reset regex to search from the beginning
        searcher.reset(0);
        do {
            m = searcher.next(text);
            if (m) {
                result[resultLen++] = createFindMatch(new (0, _rangeJs.Range)(lineNumber, m.index + 1 + deltaOffset, lineNumber, m.index + 1 + m[0].length + deltaOffset), m, captureMatches);
                if (resultLen >= limitResultCount) return resultLen;
            }
        }while (m);
        return resultLen;
    }
    static findNextMatch(model, searchParams, searchStart, captureMatches) {
        const searchData = searchParams.parseSearchRequest();
        if (!searchData) return null;
        const searcher = new Searcher(searchData.wordSeparators, searchData.regex);
        if (searchData.regex.multiline) return this._doFindNextMatchMultiline(model, searchStart, searcher, captureMatches);
        return this._doFindNextMatchLineByLine(model, searchStart, searcher, captureMatches);
    }
    static _doFindNextMatchMultiline(model, searchStart, searcher, captureMatches) {
        const searchTextStart = new (0, _positionJs.Position)(searchStart.lineNumber, 1);
        const deltaOffset = model.getOffsetAt(searchTextStart);
        const lineCount = model.getLineCount();
        // We always execute multiline search over the lines joined with \n
        // This makes it that \n will match the EOL for both CRLF and LF models
        // We compensate for offset errors in `_getMultilineMatchRange`
        const text = model.getValueInRange(new (0, _rangeJs.Range)(searchTextStart.lineNumber, searchTextStart.column, lineCount, model.getLineMaxColumn(lineCount)), 1 /* EndOfLinePreference.LF */ );
        const lfCounter = model.getEOL() === "\r\n" ? new LineFeedCounter(text) : null;
        searcher.reset(searchStart.column - 1);
        const m = searcher.next(text);
        if (m) return createFindMatch(this._getMultilineMatchRange(model, deltaOffset, text, lfCounter, m.index, m[0]), m, captureMatches);
        if (searchStart.lineNumber !== 1 || searchStart.column !== 1) // Try again from the top
        return this._doFindNextMatchMultiline(model, new (0, _positionJs.Position)(1, 1), searcher, captureMatches);
        return null;
    }
    static _doFindNextMatchLineByLine(model, searchStart, searcher, captureMatches) {
        const lineCount = model.getLineCount();
        const startLineNumber = searchStart.lineNumber;
        // Look in first line
        const text = model.getLineContent(startLineNumber);
        const r = this._findFirstMatchInLine(searcher, text, startLineNumber, searchStart.column, captureMatches);
        if (r) return r;
        for(let i = 1; i <= lineCount; i++){
            const lineIndex = (startLineNumber + i - 1) % lineCount;
            const text = model.getLineContent(lineIndex + 1);
            const r = this._findFirstMatchInLine(searcher, text, lineIndex + 1, 1, captureMatches);
            if (r) return r;
        }
        return null;
    }
    static _findFirstMatchInLine(searcher, text, lineNumber, fromColumn, captureMatches) {
        // Set regex to search from column
        searcher.reset(fromColumn - 1);
        const m = searcher.next(text);
        if (m) return createFindMatch(new (0, _rangeJs.Range)(lineNumber, m.index + 1, lineNumber, m.index + 1 + m[0].length), m, captureMatches);
        return null;
    }
    static findPreviousMatch(model, searchParams, searchStart, captureMatches) {
        const searchData = searchParams.parseSearchRequest();
        if (!searchData) return null;
        const searcher = new Searcher(searchData.wordSeparators, searchData.regex);
        if (searchData.regex.multiline) return this._doFindPreviousMatchMultiline(model, searchStart, searcher, captureMatches);
        return this._doFindPreviousMatchLineByLine(model, searchStart, searcher, captureMatches);
    }
    static _doFindPreviousMatchMultiline(model, searchStart, searcher, captureMatches) {
        const matches = this._doFindMatchesMultiline(model, new (0, _rangeJs.Range)(1, 1, searchStart.lineNumber, searchStart.column), searcher, captureMatches, 10 * LIMIT_FIND_COUNT);
        if (matches.length > 0) return matches[matches.length - 1];
        const lineCount = model.getLineCount();
        if (searchStart.lineNumber !== lineCount || searchStart.column !== model.getLineMaxColumn(lineCount)) // Try again with all content
        return this._doFindPreviousMatchMultiline(model, new (0, _positionJs.Position)(lineCount, model.getLineMaxColumn(lineCount)), searcher, captureMatches);
        return null;
    }
    static _doFindPreviousMatchLineByLine(model, searchStart, searcher, captureMatches) {
        const lineCount = model.getLineCount();
        const startLineNumber = searchStart.lineNumber;
        // Look in first line
        const text = model.getLineContent(startLineNumber).substring(0, searchStart.column - 1);
        const r = this._findLastMatchInLine(searcher, text, startLineNumber, captureMatches);
        if (r) return r;
        for(let i = 1; i <= lineCount; i++){
            const lineIndex = (lineCount + startLineNumber - i - 1) % lineCount;
            const text = model.getLineContent(lineIndex + 1);
            const r = this._findLastMatchInLine(searcher, text, lineIndex + 1, captureMatches);
            if (r) return r;
        }
        return null;
    }
    static _findLastMatchInLine(searcher, text, lineNumber, captureMatches) {
        let bestResult = null;
        let m;
        searcher.reset(0);
        while(m = searcher.next(text))bestResult = createFindMatch(new (0, _rangeJs.Range)(lineNumber, m.index + 1, lineNumber, m.index + 1 + m[0].length), m, captureMatches);
        return bestResult;
    }
}
function leftIsWordBounday(wordSeparators, text, textLength, matchStartIndex, matchLength) {
    if (matchStartIndex === 0) // Match starts at start of string
    return true;
    const charBefore = text.charCodeAt(matchStartIndex - 1);
    if (wordSeparators.get(charBefore) !== 0 /* WordCharacterClass.Regular */ ) // The character before the match is a word separator
    return true;
    if (charBefore === 13 /* CharCode.CarriageReturn */  || charBefore === 10 /* CharCode.LineFeed */ ) // The character before the match is line break or carriage return.
    return true;
    if (matchLength > 0) {
        const firstCharInMatch = text.charCodeAt(matchStartIndex);
        if (wordSeparators.get(firstCharInMatch) !== 0 /* WordCharacterClass.Regular */ ) // The first character inside the match is a word separator
        return true;
    }
    return false;
}
function rightIsWordBounday(wordSeparators, text, textLength, matchStartIndex, matchLength) {
    if (matchStartIndex + matchLength === textLength) // Match ends at end of string
    return true;
    const charAfter = text.charCodeAt(matchStartIndex + matchLength);
    if (wordSeparators.get(charAfter) !== 0 /* WordCharacterClass.Regular */ ) // The character after the match is a word separator
    return true;
    if (charAfter === 13 /* CharCode.CarriageReturn */  || charAfter === 10 /* CharCode.LineFeed */ ) // The character after the match is line break or carriage return.
    return true;
    if (matchLength > 0) {
        const lastCharInMatch = text.charCodeAt(matchStartIndex + matchLength - 1);
        if (wordSeparators.get(lastCharInMatch) !== 0 /* WordCharacterClass.Regular */ ) // The last character in the match is a word separator
        return true;
    }
    return false;
}
function isValidMatch(wordSeparators, text, textLength, matchStartIndex, matchLength) {
    return leftIsWordBounday(wordSeparators, text, textLength, matchStartIndex, matchLength) && rightIsWordBounday(wordSeparators, text, textLength, matchStartIndex, matchLength);
}
class Searcher {
    constructor(wordSeparators, searchRegex){
        this._wordSeparators = wordSeparators;
        this._searchRegex = searchRegex;
        this._prevMatchStartIndex = -1;
        this._prevMatchLength = 0;
    }
    reset(lastIndex) {
        this._searchRegex.lastIndex = lastIndex;
        this._prevMatchStartIndex = -1;
        this._prevMatchLength = 0;
    }
    next(text) {
        const textLength = text.length;
        let m;
        do {
            if (this._prevMatchStartIndex + this._prevMatchLength === textLength) // Reached the end of the line
            return null;
            m = this._searchRegex.exec(text);
            if (!m) return null;
            const matchStartIndex = m.index;
            const matchLength = m[0].length;
            if (matchStartIndex === this._prevMatchStartIndex && matchLength === this._prevMatchLength) {
                if (matchLength === 0) {
                    // the search result is an empty string and won't advance `regex.lastIndex`, so `regex.exec` will stuck here
                    // we attempt to recover from that by advancing by two if surrogate pair found and by one otherwise
                    if (_stringsJs.getNextCodePoint(text, textLength, this._searchRegex.lastIndex) > 0xFFFF) this._searchRegex.lastIndex += 2;
                    else this._searchRegex.lastIndex += 1;
                    continue;
                }
                // Exit early if the regex matches the same range twice
                return null;
            }
            this._prevMatchStartIndex = matchStartIndex;
            this._prevMatchLength = matchLength;
            if (!this._wordSeparators || isValidMatch(this._wordSeparators, text, textLength, matchStartIndex, matchLength)) return m;
        }while (m);
        return null;
    }
}

},{"../../../base/common/strings.js":"aA9I1","../core/wordCharacterClassifier.js":"a4wPa","../core/position.js":"lvrPe","../core/range.js":"jmUPh","../model.js":"1CSIB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a4wPa":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WordCharacterClassifier", ()=>WordCharacterClassifier);
parcelHelpers.export(exports, "getMapForWordSeparators", ()=>getMapForWordSeparators);
var _mapJs = require("../../../base/common/map.js");
var _characterClassifierJs = require("./characterClassifier.js");
class WordCharacterClassifier extends (0, _characterClassifierJs.CharacterClassifier) {
    constructor(wordSeparators, intlSegmenterLocales){
        super(0 /* WordCharacterClass.Regular */ );
        this._segmenter = null;
        this._cachedLine = null;
        this._cachedSegments = [];
        this.intlSegmenterLocales = intlSegmenterLocales;
        if (this.intlSegmenterLocales.length > 0) this._segmenter = new Intl.Segmenter(this.intlSegmenterLocales, {
            granularity: "word"
        });
        else this._segmenter = null;
        for(let i = 0, len = wordSeparators.length; i < len; i++)this.set(wordSeparators.charCodeAt(i), 2 /* WordCharacterClass.WordSeparator */ );
        this.set(32 /* CharCode.Space */ , 1 /* WordCharacterClass.Whitespace */ );
        this.set(9 /* CharCode.Tab */ , 1 /* WordCharacterClass.Whitespace */ );
    }
    findPrevIntlWordBeforeOrAtOffset(line, offset) {
        let candidate = null;
        for (const segment of this._getIntlSegmenterWordsOnLine(line)){
            if (segment.index > offset) break;
            candidate = segment;
        }
        return candidate;
    }
    findNextIntlWordAtOrAfterOffset(lineContent, offset) {
        for (const segment of this._getIntlSegmenterWordsOnLine(lineContent)){
            if (segment.index < offset) continue;
            return segment;
        }
        return null;
    }
    _getIntlSegmenterWordsOnLine(line) {
        if (!this._segmenter) return [];
        // Check if the line has changed from the previous call
        if (this._cachedLine === line) return this._cachedSegments;
        // Update the cache with the new line
        this._cachedLine = line;
        this._cachedSegments = this._filterWordSegments(this._segmenter.segment(line));
        return this._cachedSegments;
    }
    _filterWordSegments(segments) {
        const result = [];
        for (const segment of segments)if (this._isWordLike(segment)) result.push(segment);
        return result;
    }
    _isWordLike(segment) {
        if (segment.isWordLike) return true;
        return false;
    }
}
const wordClassifierCache = new (0, _mapJs.LRUCache)(10);
function getMapForWordSeparators(wordSeparators, intlSegmenterLocales) {
    const key = `${wordSeparators}/${intlSegmenterLocales.join(",")}`;
    let result = wordClassifierCache.get(key);
    if (!result) {
        result = new WordCharacterClassifier(wordSeparators, intlSegmenterLocales);
        wordClassifierCache.set(key, result);
    }
    return result;
}

},{"../../../base/common/map.js":"leSjz","./characterClassifier.js":"hl8tq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"leSjz":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResourceMap", ()=>ResourceMap);
parcelHelpers.export(exports, "LinkedMap", ()=>LinkedMap);
parcelHelpers.export(exports, "LRUCache", ()=>LRUCache);
/**
 * A map that allows access both by keys and values.
 * **NOTE**: values need to be unique.
 */ parcelHelpers.export(exports, "BidirectionalMap", ()=>BidirectionalMap);
parcelHelpers.export(exports, "SetMap", ()=>SetMap);
var _a, _b;
class ResourceMapEntry {
    constructor(uri, value){
        this.uri = uri;
        this.value = value;
    }
}
function isEntries(arg) {
    return Array.isArray(arg);
}
class ResourceMap {
    static{
        this.defaultToKey = (resource)=>resource.toString();
    }
    constructor(arg, toKey){
        this[_a] = "ResourceMap";
        if (arg instanceof ResourceMap) {
            this.map = new Map(arg.map);
            this.toKey = toKey ?? ResourceMap.defaultToKey;
        } else if (isEntries(arg)) {
            this.map = new Map();
            this.toKey = toKey ?? ResourceMap.defaultToKey;
            for (const [resource, value] of arg)this.set(resource, value);
        } else {
            this.map = new Map();
            this.toKey = arg ?? ResourceMap.defaultToKey;
        }
    }
    set(resource, value) {
        this.map.set(this.toKey(resource), new ResourceMapEntry(resource, value));
        return this;
    }
    get(resource) {
        return this.map.get(this.toKey(resource))?.value;
    }
    has(resource) {
        return this.map.has(this.toKey(resource));
    }
    get size() {
        return this.map.size;
    }
    clear() {
        this.map.clear();
    }
    delete(resource) {
        return this.map.delete(this.toKey(resource));
    }
    forEach(clb, thisArg) {
        if (typeof thisArg !== "undefined") clb = clb.bind(thisArg);
        for (const [_, entry] of this.map)clb(entry.value, entry.uri, this);
    }
    *values() {
        for (const entry of this.map.values())yield entry.value;
    }
    *keys() {
        for (const entry of this.map.values())yield entry.uri;
    }
    *entries() {
        for (const entry of this.map.values())yield [
            entry.uri,
            entry.value
        ];
    }
    *[(_a = Symbol.toStringTag, Symbol.iterator)]() {
        for (const [, entry] of this.map)yield [
            entry.uri,
            entry.value
        ];
    }
}
class LinkedMap {
    constructor(){
        this[_b] = "LinkedMap";
        this._map = new Map();
        this._head = undefined;
        this._tail = undefined;
        this._size = 0;
        this._state = 0;
    }
    clear() {
        this._map.clear();
        this._head = undefined;
        this._tail = undefined;
        this._size = 0;
        this._state++;
    }
    isEmpty() {
        return !this._head && !this._tail;
    }
    get size() {
        return this._size;
    }
    get first() {
        return this._head?.value;
    }
    get last() {
        return this._tail?.value;
    }
    has(key) {
        return this._map.has(key);
    }
    get(key, touch = 0 /* Touch.None */ ) {
        const item = this._map.get(key);
        if (!item) return undefined;
        if (touch !== 0 /* Touch.None */ ) this.touch(item, touch);
        return item.value;
    }
    set(key, value, touch = 0 /* Touch.None */ ) {
        let item = this._map.get(key);
        if (item) {
            item.value = value;
            if (touch !== 0 /* Touch.None */ ) this.touch(item, touch);
        } else {
            item = {
                key,
                value,
                next: undefined,
                previous: undefined
            };
            switch(touch){
                case 0 /* Touch.None */ :
                    this.addItemLast(item);
                    break;
                case 1 /* Touch.AsOld */ :
                    this.addItemFirst(item);
                    break;
                case 2 /* Touch.AsNew */ :
                    this.addItemLast(item);
                    break;
                default:
                    this.addItemLast(item);
                    break;
            }
            this._map.set(key, item);
            this._size++;
        }
        return this;
    }
    delete(key) {
        return !!this.remove(key);
    }
    remove(key) {
        const item = this._map.get(key);
        if (!item) return undefined;
        this._map.delete(key);
        this.removeItem(item);
        this._size--;
        return item.value;
    }
    shift() {
        if (!this._head && !this._tail) return undefined;
        if (!this._head || !this._tail) throw new Error("Invalid list");
        const item = this._head;
        this._map.delete(item.key);
        this.removeItem(item);
        this._size--;
        return item.value;
    }
    forEach(callbackfn, thisArg) {
        const state = this._state;
        let current = this._head;
        while(current){
            if (thisArg) callbackfn.bind(thisArg)(current.value, current.key, this);
            else callbackfn(current.value, current.key, this);
            if (this._state !== state) throw new Error(`LinkedMap got modified during iteration.`);
            current = current.next;
        }
    }
    keys() {
        const map = this;
        const state = this._state;
        let current = this._head;
        const iterator = {
            [Symbol.iterator] () {
                return iterator;
            },
            next () {
                if (map._state !== state) throw new Error(`LinkedMap got modified during iteration.`);
                if (current) {
                    const result = {
                        value: current.key,
                        done: false
                    };
                    current = current.next;
                    return result;
                } else return {
                    value: undefined,
                    done: true
                };
            }
        };
        return iterator;
    }
    values() {
        const map = this;
        const state = this._state;
        let current = this._head;
        const iterator = {
            [Symbol.iterator] () {
                return iterator;
            },
            next () {
                if (map._state !== state) throw new Error(`LinkedMap got modified during iteration.`);
                if (current) {
                    const result = {
                        value: current.value,
                        done: false
                    };
                    current = current.next;
                    return result;
                } else return {
                    value: undefined,
                    done: true
                };
            }
        };
        return iterator;
    }
    entries() {
        const map = this;
        const state = this._state;
        let current = this._head;
        const iterator = {
            [Symbol.iterator] () {
                return iterator;
            },
            next () {
                if (map._state !== state) throw new Error(`LinkedMap got modified during iteration.`);
                if (current) {
                    const result = {
                        value: [
                            current.key,
                            current.value
                        ],
                        done: false
                    };
                    current = current.next;
                    return result;
                } else return {
                    value: undefined,
                    done: true
                };
            }
        };
        return iterator;
    }
    [(_b = Symbol.toStringTag, Symbol.iterator)]() {
        return this.entries();
    }
    trimOld(newSize) {
        if (newSize >= this.size) return;
        if (newSize === 0) {
            this.clear();
            return;
        }
        let current = this._head;
        let currentSize = this.size;
        while(current && currentSize > newSize){
            this._map.delete(current.key);
            current = current.next;
            currentSize--;
        }
        this._head = current;
        this._size = currentSize;
        if (current) current.previous = undefined;
        this._state++;
    }
    trimNew(newSize) {
        if (newSize >= this.size) return;
        if (newSize === 0) {
            this.clear();
            return;
        }
        let current = this._tail;
        let currentSize = this.size;
        while(current && currentSize > newSize){
            this._map.delete(current.key);
            current = current.previous;
            currentSize--;
        }
        this._tail = current;
        this._size = currentSize;
        if (current) current.next = undefined;
        this._state++;
    }
    addItemFirst(item) {
        // First time Insert
        if (!this._head && !this._tail) this._tail = item;
        else if (!this._head) throw new Error("Invalid list");
        else {
            item.next = this._head;
            this._head.previous = item;
        }
        this._head = item;
        this._state++;
    }
    addItemLast(item) {
        // First time Insert
        if (!this._head && !this._tail) this._head = item;
        else if (!this._tail) throw new Error("Invalid list");
        else {
            item.previous = this._tail;
            this._tail.next = item;
        }
        this._tail = item;
        this._state++;
    }
    removeItem(item) {
        if (item === this._head && item === this._tail) {
            this._head = undefined;
            this._tail = undefined;
        } else if (item === this._head) {
            // This can only happen if size === 1 which is handled
            // by the case above.
            if (!item.next) throw new Error("Invalid list");
            item.next.previous = undefined;
            this._head = item.next;
        } else if (item === this._tail) {
            // This can only happen if size === 1 which is handled
            // by the case above.
            if (!item.previous) throw new Error("Invalid list");
            item.previous.next = undefined;
            this._tail = item.previous;
        } else {
            const next = item.next;
            const previous = item.previous;
            if (!next || !previous) throw new Error("Invalid list");
            next.previous = previous;
            previous.next = next;
        }
        item.next = undefined;
        item.previous = undefined;
        this._state++;
    }
    touch(item, touch) {
        if (!this._head || !this._tail) throw new Error("Invalid list");
        if (touch !== 1 /* Touch.AsOld */  && touch !== 2 /* Touch.AsNew */ ) return;
        if (touch === 1 /* Touch.AsOld */ ) {
            if (item === this._head) return;
            const next = item.next;
            const previous = item.previous;
            // Unlink the item
            if (item === this._tail) {
                // previous must be defined since item was not head but is tail
                // So there are more than on item in the map
                previous.next = undefined;
                this._tail = previous;
            } else {
                // Both next and previous are not undefined since item was neither head nor tail.
                next.previous = previous;
                previous.next = next;
            }
            // Insert the node at head
            item.previous = undefined;
            item.next = this._head;
            this._head.previous = item;
            this._head = item;
            this._state++;
        } else if (touch === 2 /* Touch.AsNew */ ) {
            if (item === this._tail) return;
            const next = item.next;
            const previous = item.previous;
            // Unlink the item.
            if (item === this._head) {
                // next must be defined since item was not tail but is head
                // So there are more than on item in the map
                next.previous = undefined;
                this._head = next;
            } else {
                // Both next and previous are not undefined since item was neither head nor tail.
                next.previous = previous;
                previous.next = next;
            }
            item.next = undefined;
            item.previous = this._tail;
            this._tail.next = item;
            this._tail = item;
            this._state++;
        }
    }
    toJSON() {
        const data = [];
        this.forEach((value, key)=>{
            data.push([
                key,
                value
            ]);
        });
        return data;
    }
    fromJSON(data) {
        this.clear();
        for (const [key, value] of data)this.set(key, value);
    }
}
class Cache extends LinkedMap {
    constructor(limit, ratio = 1){
        super();
        this._limit = limit;
        this._ratio = Math.min(Math.max(0, ratio), 1);
    }
    get limit() {
        return this._limit;
    }
    set limit(limit) {
        this._limit = limit;
        this.checkTrim();
    }
    get(key, touch = 2 /* Touch.AsNew */ ) {
        return super.get(key, touch);
    }
    peek(key) {
        return super.get(key, 0 /* Touch.None */ );
    }
    set(key, value) {
        super.set(key, value, 2 /* Touch.AsNew */ );
        return this;
    }
    checkTrim() {
        if (this.size > this._limit) this.trim(Math.round(this._limit * this._ratio));
    }
}
class LRUCache extends Cache {
    constructor(limit, ratio = 1){
        super(limit, ratio);
    }
    trim(newSize) {
        this.trimOld(newSize);
    }
    set(key, value) {
        super.set(key, value);
        this.checkTrim();
        return this;
    }
}
class BidirectionalMap {
    constructor(entries){
        this._m1 = new Map();
        this._m2 = new Map();
        if (entries) for (const [key, value] of entries)this.set(key, value);
    }
    clear() {
        this._m1.clear();
        this._m2.clear();
    }
    set(key, value) {
        this._m1.set(key, value);
        this._m2.set(value, key);
    }
    get(key) {
        return this._m1.get(key);
    }
    getKey(value) {
        return this._m2.get(value);
    }
    delete(key) {
        const value = this._m1.get(key);
        if (value === undefined) return false;
        this._m1.delete(key);
        this._m2.delete(value);
        return true;
    }
    keys() {
        return this._m1.keys();
    }
    values() {
        return this._m1.values();
    }
}
class SetMap {
    constructor(){
        this.map = new Map();
    }
    add(key, value) {
        let values = this.map.get(key);
        if (!values) {
            values = new Set();
            this.map.set(key, values);
        }
        values.add(value);
    }
    delete(key, value) {
        const values = this.map.get(key);
        if (!values) return;
        values.delete(value);
        if (values.size === 0) this.map.delete(key);
    }
    forEach(key, fn) {
        const values = this.map.get(key);
        if (!values) return;
        values.forEach(fn);
    }
    get(key) {
        const values = this.map.get(key);
        if (!values) return new Set();
        return values;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1CSIB":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverviewRulerLane", ()=>OverviewRulerLane);
parcelHelpers.export(exports, "GlyphMarginLane", ()=>GlyphMarginLane);
parcelHelpers.export(exports, "InjectedTextCursorStops", ()=>InjectedTextCursorStops);
parcelHelpers.export(exports, "TextModelResolvedOptions", ()=>TextModelResolvedOptions);
parcelHelpers.export(exports, "FindMatch", ()=>FindMatch);
/**
 * @internal
 */ parcelHelpers.export(exports, "isITextSnapshot", ()=>isITextSnapshot);
/**
 * @internal
 */ parcelHelpers.export(exports, "ValidAnnotatedEditOperation", ()=>ValidAnnotatedEditOperation);
/**
 * @internal
 */ parcelHelpers.export(exports, "SearchData", ()=>SearchData);
/**
 * @internal
 */ parcelHelpers.export(exports, "ApplyEditsResult", ()=>ApplyEditsResult);
/**
 * @internal
 */ parcelHelpers.export(exports, "shouldSynchronizeModel", ()=>shouldSynchronizeModel);
var _objectsJs = require("../../base/common/objects.js");
var OverviewRulerLane;
(function(OverviewRulerLane) {
    OverviewRulerLane[OverviewRulerLane["Left"] = 1] = "Left";
    OverviewRulerLane[OverviewRulerLane["Center"] = 2] = "Center";
    OverviewRulerLane[OverviewRulerLane["Right"] = 4] = "Right";
    OverviewRulerLane[OverviewRulerLane["Full"] = 7] = "Full";
})(OverviewRulerLane || (OverviewRulerLane = {}));
var GlyphMarginLane;
(function(GlyphMarginLane) {
    GlyphMarginLane[GlyphMarginLane["Left"] = 1] = "Left";
    GlyphMarginLane[GlyphMarginLane["Center"] = 2] = "Center";
    GlyphMarginLane[GlyphMarginLane["Right"] = 3] = "Right";
})(GlyphMarginLane || (GlyphMarginLane = {}));
var InjectedTextCursorStops;
(function(InjectedTextCursorStops) {
    InjectedTextCursorStops[InjectedTextCursorStops["Both"] = 0] = "Both";
    InjectedTextCursorStops[InjectedTextCursorStops["Right"] = 1] = "Right";
    InjectedTextCursorStops[InjectedTextCursorStops["Left"] = 2] = "Left";
    InjectedTextCursorStops[InjectedTextCursorStops["None"] = 3] = "None";
})(InjectedTextCursorStops || (InjectedTextCursorStops = {}));
class TextModelResolvedOptions {
    get originalIndentSize() {
        return this._indentSizeIsTabSize ? "tabSize" : this.indentSize;
    }
    /**
     * @internal
     */ constructor(src){
        this._textModelResolvedOptionsBrand = undefined;
        this.tabSize = Math.max(1, src.tabSize | 0);
        if (src.indentSize === "tabSize") {
            this.indentSize = this.tabSize;
            this._indentSizeIsTabSize = true;
        } else {
            this.indentSize = Math.max(1, src.indentSize | 0);
            this._indentSizeIsTabSize = false;
        }
        this.insertSpaces = Boolean(src.insertSpaces);
        this.defaultEOL = src.defaultEOL | 0;
        this.trimAutoWhitespace = Boolean(src.trimAutoWhitespace);
        this.bracketPairColorizationOptions = src.bracketPairColorizationOptions;
    }
    /**
     * @internal
     */ equals(other) {
        return this.tabSize === other.tabSize && this._indentSizeIsTabSize === other._indentSizeIsTabSize && this.indentSize === other.indentSize && this.insertSpaces === other.insertSpaces && this.defaultEOL === other.defaultEOL && this.trimAutoWhitespace === other.trimAutoWhitespace && (0, _objectsJs.equals)(this.bracketPairColorizationOptions, other.bracketPairColorizationOptions);
    }
    /**
     * @internal
     */ createChangeEvent(newOpts) {
        return {
            tabSize: this.tabSize !== newOpts.tabSize,
            indentSize: this.indentSize !== newOpts.indentSize,
            insertSpaces: this.insertSpaces !== newOpts.insertSpaces,
            trimAutoWhitespace: this.trimAutoWhitespace !== newOpts.trimAutoWhitespace
        };
    }
}
class FindMatch {
    /**
     * @internal
     */ constructor(range, matches){
        this._findMatchBrand = undefined;
        this.range = range;
        this.matches = matches;
    }
}
function isITextSnapshot(obj) {
    return obj && typeof obj.read === "function";
}
class ValidAnnotatedEditOperation {
    constructor(identifier, range, text, forceMoveMarkers, isAutoWhitespaceEdit, _isTracked){
        this.identifier = identifier;
        this.range = range;
        this.text = text;
        this.forceMoveMarkers = forceMoveMarkers;
        this.isAutoWhitespaceEdit = isAutoWhitespaceEdit;
        this._isTracked = _isTracked;
    }
}
class SearchData {
    constructor(regex, wordSeparators, simpleSearch){
        this.regex = regex;
        this.wordSeparators = wordSeparators;
        this.simpleSearch = simpleSearch;
    }
}
class ApplyEditsResult {
    constructor(reverseEdits, changes, trimAutoWhitespaceLineNumbers){
        this.reverseEdits = reverseEdits;
        this.changes = changes;
        this.trimAutoWhitespaceLineNumbers = trimAutoWhitespaceLineNumbers;
    }
}
function shouldSynchronizeModel(model) {
    return !model.isTooLargeForSyncing() && !model.isForSimpleWidget;
}

},{"../../base/common/objects.js":"j84mT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fz5Gs":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linesDiffComputers", ()=>linesDiffComputers);
var _legacyLinesDiffComputerJs = require("./legacyLinesDiffComputer.js");
var _defaultLinesDiffComputerJs = require("./defaultLinesDiffComputer/defaultLinesDiffComputer.js");
const linesDiffComputers = {
    getLegacy: ()=>new (0, _legacyLinesDiffComputerJs.LegacyLinesDiffComputer)(),
    getDefault: ()=>new (0, _defaultLinesDiffComputerJs.DefaultLinesDiffComputer)()
};

},{"./legacyLinesDiffComputer.js":"5YCr0","./defaultLinesDiffComputer/defaultLinesDiffComputer.js":"8qVeZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5YCr0":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LegacyLinesDiffComputer", ()=>LegacyLinesDiffComputer);
parcelHelpers.export(exports, "DiffComputer", ()=>DiffComputer);
var _diffJs = require("../../../base/common/diff/diff.js");
var _linesDiffComputerJs = require("./linesDiffComputer.js");
var _rangeMappingJs = require("./rangeMapping.js");
var _stringsJs = require("../../../base/common/strings.js");
var _rangeJs = require("../core/range.js");
var _assertJs = require("../../../base/common/assert.js");
var _lineRangeJs = require("../core/lineRange.js");
const MINIMUM_MATCHING_CHARACTER_LENGTH = 3;
class LegacyLinesDiffComputer {
    computeDiff(originalLines, modifiedLines, options) {
        const diffComputer = new DiffComputer(originalLines, modifiedLines, {
            maxComputationTime: options.maxComputationTimeMs,
            shouldIgnoreTrimWhitespace: options.ignoreTrimWhitespace,
            shouldComputeCharChanges: true,
            shouldMakePrettyDiff: true,
            shouldPostProcessCharChanges: true
        });
        const result = diffComputer.computeDiff();
        const changes = [];
        let lastChange = null;
        for (const c of result.changes){
            let originalRange;
            if (c.originalEndLineNumber === 0) // Insertion
            originalRange = new (0, _lineRangeJs.LineRange)(c.originalStartLineNumber + 1, c.originalStartLineNumber + 1);
            else originalRange = new (0, _lineRangeJs.LineRange)(c.originalStartLineNumber, c.originalEndLineNumber + 1);
            let modifiedRange;
            if (c.modifiedEndLineNumber === 0) // Deletion
            modifiedRange = new (0, _lineRangeJs.LineRange)(c.modifiedStartLineNumber + 1, c.modifiedStartLineNumber + 1);
            else modifiedRange = new (0, _lineRangeJs.LineRange)(c.modifiedStartLineNumber, c.modifiedEndLineNumber + 1);
            let change = new (0, _rangeMappingJs.DetailedLineRangeMapping)(originalRange, modifiedRange, c.charChanges?.map((c)=>new (0, _rangeMappingJs.RangeMapping)(new (0, _rangeJs.Range)(c.originalStartLineNumber, c.originalStartColumn, c.originalEndLineNumber, c.originalEndColumn), new (0, _rangeJs.Range)(c.modifiedStartLineNumber, c.modifiedStartColumn, c.modifiedEndLineNumber, c.modifiedEndColumn))));
            if (lastChange) {
                if (lastChange.modified.endLineNumberExclusive === change.modified.startLineNumber || lastChange.original.endLineNumberExclusive === change.original.startLineNumber) {
                    // join touching diffs. Probably moving diffs up/down in the algorithm causes touching diffs.
                    change = new (0, _rangeMappingJs.DetailedLineRangeMapping)(lastChange.original.join(change.original), lastChange.modified.join(change.modified), lastChange.innerChanges && change.innerChanges ? lastChange.innerChanges.concat(change.innerChanges) : undefined);
                    changes.pop();
                }
            }
            changes.push(change);
            lastChange = change;
        }
        (0, _assertJs.assertFn)(()=>{
            return (0, _assertJs.checkAdjacentItems)(changes, (m1, m2)=>m2.original.startLineNumber - m1.original.endLineNumberExclusive === m2.modified.startLineNumber - m1.modified.endLineNumberExclusive && // There has to be an unchanged line in between (otherwise both diffs should have been joined)
                m1.original.endLineNumberExclusive < m2.original.startLineNumber && m1.modified.endLineNumberExclusive < m2.modified.startLineNumber);
        });
        return new (0, _linesDiffComputerJs.LinesDiff)(changes, [], result.quitEarly);
    }
}
function computeDiff(originalSequence, modifiedSequence, continueProcessingPredicate, pretty) {
    const diffAlgo = new (0, _diffJs.LcsDiff)(originalSequence, modifiedSequence, continueProcessingPredicate);
    return diffAlgo.ComputeDiff(pretty);
}
class LineSequence {
    constructor(lines){
        const startColumns = [];
        const endColumns = [];
        for(let i = 0, length = lines.length; i < length; i++){
            startColumns[i] = getFirstNonBlankColumn(lines[i], 1);
            endColumns[i] = getLastNonBlankColumn(lines[i], 1);
        }
        this.lines = lines;
        this._startColumns = startColumns;
        this._endColumns = endColumns;
    }
    getElements() {
        const elements = [];
        for(let i = 0, len = this.lines.length; i < len; i++)elements[i] = this.lines[i].substring(this._startColumns[i] - 1, this._endColumns[i] - 1);
        return elements;
    }
    getStrictElement(index) {
        return this.lines[index];
    }
    getStartLineNumber(i) {
        return i + 1;
    }
    getEndLineNumber(i) {
        return i + 1;
    }
    createCharSequence(shouldIgnoreTrimWhitespace, startIndex, endIndex) {
        const charCodes = [];
        const lineNumbers = [];
        const columns = [];
        let len = 0;
        for(let index = startIndex; index <= endIndex; index++){
            const lineContent = this.lines[index];
            const startColumn = shouldIgnoreTrimWhitespace ? this._startColumns[index] : 1;
            const endColumn = shouldIgnoreTrimWhitespace ? this._endColumns[index] : lineContent.length + 1;
            for(let col = startColumn; col < endColumn; col++){
                charCodes[len] = lineContent.charCodeAt(col - 1);
                lineNumbers[len] = index + 1;
                columns[len] = col;
                len++;
            }
            if (!shouldIgnoreTrimWhitespace && index < endIndex) {
                // Add \n if trim whitespace is not ignored
                charCodes[len] = 10 /* CharCode.LineFeed */ ;
                lineNumbers[len] = index + 1;
                columns[len] = lineContent.length + 1;
                len++;
            }
        }
        return new CharSequence(charCodes, lineNumbers, columns);
    }
}
class CharSequence {
    constructor(charCodes, lineNumbers, columns){
        this._charCodes = charCodes;
        this._lineNumbers = lineNumbers;
        this._columns = columns;
    }
    toString() {
        return "[" + this._charCodes.map((s, idx)=>(s === 10 /* CharCode.LineFeed */  ? "\\n" : String.fromCharCode(s)) + `-(${this._lineNumbers[idx]},${this._columns[idx]})`).join(", ") + "]";
    }
    _assertIndex(index, arr) {
        if (index < 0 || index >= arr.length) throw new Error(`Illegal index`);
    }
    getElements() {
        return this._charCodes;
    }
    getStartLineNumber(i) {
        if (i > 0 && i === this._lineNumbers.length) // the start line number of the element after the last element
        // is the end line number of the last element
        return this.getEndLineNumber(i - 1);
        this._assertIndex(i, this._lineNumbers);
        return this._lineNumbers[i];
    }
    getEndLineNumber(i) {
        if (i === -1) // the end line number of the element before the first element
        // is the start line number of the first element
        return this.getStartLineNumber(i + 1);
        this._assertIndex(i, this._lineNumbers);
        if (this._charCodes[i] === 10 /* CharCode.LineFeed */ ) return this._lineNumbers[i] + 1;
        return this._lineNumbers[i];
    }
    getStartColumn(i) {
        if (i > 0 && i === this._columns.length) // the start column of the element after the last element
        // is the end column of the last element
        return this.getEndColumn(i - 1);
        this._assertIndex(i, this._columns);
        return this._columns[i];
    }
    getEndColumn(i) {
        if (i === -1) // the end column of the element before the first element
        // is the start column of the first element
        return this.getStartColumn(i + 1);
        this._assertIndex(i, this._columns);
        if (this._charCodes[i] === 10 /* CharCode.LineFeed */ ) return 1;
        return this._columns[i] + 1;
    }
}
class CharChange {
    constructor(originalStartLineNumber, originalStartColumn, originalEndLineNumber, originalEndColumn, modifiedStartLineNumber, modifiedStartColumn, modifiedEndLineNumber, modifiedEndColumn){
        this.originalStartLineNumber = originalStartLineNumber;
        this.originalStartColumn = originalStartColumn;
        this.originalEndLineNumber = originalEndLineNumber;
        this.originalEndColumn = originalEndColumn;
        this.modifiedStartLineNumber = modifiedStartLineNumber;
        this.modifiedStartColumn = modifiedStartColumn;
        this.modifiedEndLineNumber = modifiedEndLineNumber;
        this.modifiedEndColumn = modifiedEndColumn;
    }
    static createFromDiffChange(diffChange, originalCharSequence, modifiedCharSequence) {
        const originalStartLineNumber = originalCharSequence.getStartLineNumber(diffChange.originalStart);
        const originalStartColumn = originalCharSequence.getStartColumn(diffChange.originalStart);
        const originalEndLineNumber = originalCharSequence.getEndLineNumber(diffChange.originalStart + diffChange.originalLength - 1);
        const originalEndColumn = originalCharSequence.getEndColumn(diffChange.originalStart + diffChange.originalLength - 1);
        const modifiedStartLineNumber = modifiedCharSequence.getStartLineNumber(diffChange.modifiedStart);
        const modifiedStartColumn = modifiedCharSequence.getStartColumn(diffChange.modifiedStart);
        const modifiedEndLineNumber = modifiedCharSequence.getEndLineNumber(diffChange.modifiedStart + diffChange.modifiedLength - 1);
        const modifiedEndColumn = modifiedCharSequence.getEndColumn(diffChange.modifiedStart + diffChange.modifiedLength - 1);
        return new CharChange(originalStartLineNumber, originalStartColumn, originalEndLineNumber, originalEndColumn, modifiedStartLineNumber, modifiedStartColumn, modifiedEndLineNumber, modifiedEndColumn);
    }
}
function postProcessCharChanges(rawChanges) {
    if (rawChanges.length <= 1) return rawChanges;
    const result = [
        rawChanges[0]
    ];
    let prevChange = result[0];
    for(let i = 1, len = rawChanges.length; i < len; i++){
        const currChange = rawChanges[i];
        const originalMatchingLength = currChange.originalStart - (prevChange.originalStart + prevChange.originalLength);
        const modifiedMatchingLength = currChange.modifiedStart - (prevChange.modifiedStart + prevChange.modifiedLength);
        // Both of the above should be equal, but the continueProcessingPredicate may prevent this from being true
        const matchingLength = Math.min(originalMatchingLength, modifiedMatchingLength);
        if (matchingLength < MINIMUM_MATCHING_CHARACTER_LENGTH) {
            // Merge the current change into the previous one
            prevChange.originalLength = currChange.originalStart + currChange.originalLength - prevChange.originalStart;
            prevChange.modifiedLength = currChange.modifiedStart + currChange.modifiedLength - prevChange.modifiedStart;
        } else {
            // Add the current change
            result.push(currChange);
            prevChange = currChange;
        }
    }
    return result;
}
class LineChange {
    constructor(originalStartLineNumber, originalEndLineNumber, modifiedStartLineNumber, modifiedEndLineNumber, charChanges){
        this.originalStartLineNumber = originalStartLineNumber;
        this.originalEndLineNumber = originalEndLineNumber;
        this.modifiedStartLineNumber = modifiedStartLineNumber;
        this.modifiedEndLineNumber = modifiedEndLineNumber;
        this.charChanges = charChanges;
    }
    static createFromDiffResult(shouldIgnoreTrimWhitespace, diffChange, originalLineSequence, modifiedLineSequence, continueCharDiff, shouldComputeCharChanges, shouldPostProcessCharChanges) {
        let originalStartLineNumber;
        let originalEndLineNumber;
        let modifiedStartLineNumber;
        let modifiedEndLineNumber;
        let charChanges = undefined;
        if (diffChange.originalLength === 0) {
            originalStartLineNumber = originalLineSequence.getStartLineNumber(diffChange.originalStart) - 1;
            originalEndLineNumber = 0;
        } else {
            originalStartLineNumber = originalLineSequence.getStartLineNumber(diffChange.originalStart);
            originalEndLineNumber = originalLineSequence.getEndLineNumber(diffChange.originalStart + diffChange.originalLength - 1);
        }
        if (diffChange.modifiedLength === 0) {
            modifiedStartLineNumber = modifiedLineSequence.getStartLineNumber(diffChange.modifiedStart) - 1;
            modifiedEndLineNumber = 0;
        } else {
            modifiedStartLineNumber = modifiedLineSequence.getStartLineNumber(diffChange.modifiedStart);
            modifiedEndLineNumber = modifiedLineSequence.getEndLineNumber(diffChange.modifiedStart + diffChange.modifiedLength - 1);
        }
        if (shouldComputeCharChanges && diffChange.originalLength > 0 && diffChange.originalLength < 20 && diffChange.modifiedLength > 0 && diffChange.modifiedLength < 20 && continueCharDiff()) {
            // Compute character changes for diff chunks of at most 20 lines...
            const originalCharSequence = originalLineSequence.createCharSequence(shouldIgnoreTrimWhitespace, diffChange.originalStart, diffChange.originalStart + diffChange.originalLength - 1);
            const modifiedCharSequence = modifiedLineSequence.createCharSequence(shouldIgnoreTrimWhitespace, diffChange.modifiedStart, diffChange.modifiedStart + diffChange.modifiedLength - 1);
            if (originalCharSequence.getElements().length > 0 && modifiedCharSequence.getElements().length > 0) {
                let rawChanges = computeDiff(originalCharSequence, modifiedCharSequence, continueCharDiff, true).changes;
                if (shouldPostProcessCharChanges) rawChanges = postProcessCharChanges(rawChanges);
                charChanges = [];
                for(let i = 0, length = rawChanges.length; i < length; i++)charChanges.push(CharChange.createFromDiffChange(rawChanges[i], originalCharSequence, modifiedCharSequence));
            }
        }
        return new LineChange(originalStartLineNumber, originalEndLineNumber, modifiedStartLineNumber, modifiedEndLineNumber, charChanges);
    }
}
class DiffComputer {
    constructor(originalLines, modifiedLines, opts){
        this.shouldComputeCharChanges = opts.shouldComputeCharChanges;
        this.shouldPostProcessCharChanges = opts.shouldPostProcessCharChanges;
        this.shouldIgnoreTrimWhitespace = opts.shouldIgnoreTrimWhitespace;
        this.shouldMakePrettyDiff = opts.shouldMakePrettyDiff;
        this.originalLines = originalLines;
        this.modifiedLines = modifiedLines;
        this.original = new LineSequence(originalLines);
        this.modified = new LineSequence(modifiedLines);
        this.continueLineDiff = createContinueProcessingPredicate(opts.maxComputationTime);
        this.continueCharDiff = createContinueProcessingPredicate(opts.maxComputationTime === 0 ? 0 : Math.min(opts.maxComputationTime, 5000)); // never run after 5s for character changes...
    }
    computeDiff() {
        if (this.original.lines.length === 1 && this.original.lines[0].length === 0) {
            // empty original => fast path
            if (this.modified.lines.length === 1 && this.modified.lines[0].length === 0) return {
                quitEarly: false,
                changes: []
            };
            return {
                quitEarly: false,
                changes: [
                    {
                        originalStartLineNumber: 1,
                        originalEndLineNumber: 1,
                        modifiedStartLineNumber: 1,
                        modifiedEndLineNumber: this.modified.lines.length,
                        charChanges: undefined
                    }
                ]
            };
        }
        if (this.modified.lines.length === 1 && this.modified.lines[0].length === 0) // empty modified => fast path
        return {
            quitEarly: false,
            changes: [
                {
                    originalStartLineNumber: 1,
                    originalEndLineNumber: this.original.lines.length,
                    modifiedStartLineNumber: 1,
                    modifiedEndLineNumber: 1,
                    charChanges: undefined
                }
            ]
        };
        const diffResult = computeDiff(this.original, this.modified, this.continueLineDiff, this.shouldMakePrettyDiff);
        const rawChanges = diffResult.changes;
        const quitEarly = diffResult.quitEarly;
        // The diff is always computed with ignoring trim whitespace
        // This ensures we get the prettiest diff
        if (this.shouldIgnoreTrimWhitespace) {
            const lineChanges = [];
            for(let i = 0, length = rawChanges.length; i < length; i++)lineChanges.push(LineChange.createFromDiffResult(this.shouldIgnoreTrimWhitespace, rawChanges[i], this.original, this.modified, this.continueCharDiff, this.shouldComputeCharChanges, this.shouldPostProcessCharChanges));
            return {
                quitEarly: quitEarly,
                changes: lineChanges
            };
        }
        // Need to post-process and introduce changes where the trim whitespace is different
        // Note that we are looping starting at -1 to also cover the lines before the first change
        const result = [];
        let originalLineIndex = 0;
        let modifiedLineIndex = 0;
        for(let i = -1 /* !!!! */ , len = rawChanges.length; i < len; i++){
            const nextChange = i + 1 < len ? rawChanges[i + 1] : null;
            const originalStop = nextChange ? nextChange.originalStart : this.originalLines.length;
            const modifiedStop = nextChange ? nextChange.modifiedStart : this.modifiedLines.length;
            while(originalLineIndex < originalStop && modifiedLineIndex < modifiedStop){
                const originalLine = this.originalLines[originalLineIndex];
                const modifiedLine = this.modifiedLines[modifiedLineIndex];
                if (originalLine !== modifiedLine) {
                    // These lines differ only in trim whitespace
                    // Check the leading whitespace
                    {
                        let originalStartColumn = getFirstNonBlankColumn(originalLine, 1);
                        let modifiedStartColumn = getFirstNonBlankColumn(modifiedLine, 1);
                        while(originalStartColumn > 1 && modifiedStartColumn > 1){
                            const originalChar = originalLine.charCodeAt(originalStartColumn - 2);
                            const modifiedChar = modifiedLine.charCodeAt(modifiedStartColumn - 2);
                            if (originalChar !== modifiedChar) break;
                            originalStartColumn--;
                            modifiedStartColumn--;
                        }
                        if (originalStartColumn > 1 || modifiedStartColumn > 1) this._pushTrimWhitespaceCharChange(result, originalLineIndex + 1, 1, originalStartColumn, modifiedLineIndex + 1, 1, modifiedStartColumn);
                    }
                    // Check the trailing whitespace
                    {
                        let originalEndColumn = getLastNonBlankColumn(originalLine, 1);
                        let modifiedEndColumn = getLastNonBlankColumn(modifiedLine, 1);
                        const originalMaxColumn = originalLine.length + 1;
                        const modifiedMaxColumn = modifiedLine.length + 1;
                        while(originalEndColumn < originalMaxColumn && modifiedEndColumn < modifiedMaxColumn){
                            const originalChar = originalLine.charCodeAt(originalEndColumn - 1);
                            const modifiedChar = originalLine.charCodeAt(modifiedEndColumn - 1);
                            if (originalChar !== modifiedChar) break;
                            originalEndColumn++;
                            modifiedEndColumn++;
                        }
                        if (originalEndColumn < originalMaxColumn || modifiedEndColumn < modifiedMaxColumn) this._pushTrimWhitespaceCharChange(result, originalLineIndex + 1, originalEndColumn, originalMaxColumn, modifiedLineIndex + 1, modifiedEndColumn, modifiedMaxColumn);
                    }
                }
                originalLineIndex++;
                modifiedLineIndex++;
            }
            if (nextChange) {
                // Emit the actual change
                result.push(LineChange.createFromDiffResult(this.shouldIgnoreTrimWhitespace, nextChange, this.original, this.modified, this.continueCharDiff, this.shouldComputeCharChanges, this.shouldPostProcessCharChanges));
                originalLineIndex += nextChange.originalLength;
                modifiedLineIndex += nextChange.modifiedLength;
            }
        }
        return {
            quitEarly: quitEarly,
            changes: result
        };
    }
    _pushTrimWhitespaceCharChange(result, originalLineNumber, originalStartColumn, originalEndColumn, modifiedLineNumber, modifiedStartColumn, modifiedEndColumn) {
        if (this._mergeTrimWhitespaceCharChange(result, originalLineNumber, originalStartColumn, originalEndColumn, modifiedLineNumber, modifiedStartColumn, modifiedEndColumn)) // Merged into previous
        return;
        let charChanges = undefined;
        if (this.shouldComputeCharChanges) charChanges = [
            new CharChange(originalLineNumber, originalStartColumn, originalLineNumber, originalEndColumn, modifiedLineNumber, modifiedStartColumn, modifiedLineNumber, modifiedEndColumn)
        ];
        result.push(new LineChange(originalLineNumber, originalLineNumber, modifiedLineNumber, modifiedLineNumber, charChanges));
    }
    _mergeTrimWhitespaceCharChange(result, originalLineNumber, originalStartColumn, originalEndColumn, modifiedLineNumber, modifiedStartColumn, modifiedEndColumn) {
        const len = result.length;
        if (len === 0) return false;
        const prevChange = result[len - 1];
        if (prevChange.originalEndLineNumber === 0 || prevChange.modifiedEndLineNumber === 0) // Don't merge with inserts/deletes
        return false;
        if (prevChange.originalEndLineNumber === originalLineNumber && prevChange.modifiedEndLineNumber === modifiedLineNumber) {
            if (this.shouldComputeCharChanges && prevChange.charChanges) prevChange.charChanges.push(new CharChange(originalLineNumber, originalStartColumn, originalLineNumber, originalEndColumn, modifiedLineNumber, modifiedStartColumn, modifiedLineNumber, modifiedEndColumn));
            return true;
        }
        if (prevChange.originalEndLineNumber + 1 === originalLineNumber && prevChange.modifiedEndLineNumber + 1 === modifiedLineNumber) {
            prevChange.originalEndLineNumber = originalLineNumber;
            prevChange.modifiedEndLineNumber = modifiedLineNumber;
            if (this.shouldComputeCharChanges && prevChange.charChanges) prevChange.charChanges.push(new CharChange(originalLineNumber, originalStartColumn, originalLineNumber, originalEndColumn, modifiedLineNumber, modifiedStartColumn, modifiedLineNumber, modifiedEndColumn));
            return true;
        }
        return false;
    }
}
function getFirstNonBlankColumn(txt, defaultValue) {
    const r = _stringsJs.firstNonWhitespaceIndex(txt);
    if (r === -1) return defaultValue;
    return r + 1;
}
function getLastNonBlankColumn(txt, defaultValue) {
    const r = _stringsJs.lastNonWhitespaceIndex(txt);
    if (r === -1) return defaultValue;
    return r + 2;
}
function createContinueProcessingPredicate(maximumRuntime) {
    if (maximumRuntime === 0) return ()=>true;
    const startTime = Date.now();
    return ()=>{
        return Date.now() - startTime < maximumRuntime;
    };
}

},{"../../../base/common/diff/diff.js":"8KX5t","./linesDiffComputer.js":"kUXV1","./rangeMapping.js":"7QuJJ","../../../base/common/strings.js":"aA9I1","../core/range.js":"jmUPh","../../../base/common/assert.js":"1nPIE","../core/lineRange.js":"cmnMs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kUXV1":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinesDiff", ()=>LinesDiff);
parcelHelpers.export(exports, "MovedText", ()=>MovedText);
class LinesDiff {
    constructor(changes, /**
     * Sorted by original line ranges.
     * The original line ranges and the modified line ranges must be disjoint (but can be touching).
     */ moves, /**
     * Indicates if the time out was reached.
     * In that case, the diffs might be an approximation and the user should be asked to rerun the diff with more time.
     */ hitTimeout){
        this.changes = changes;
        this.moves = moves;
        this.hitTimeout = hitTimeout;
    }
}
class MovedText {
    constructor(lineRangeMapping, changes){
        this.lineRangeMapping = lineRangeMapping;
        this.changes = changes;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7QuJJ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Maps a line range in the original text model to a line range in the modified text model.
 */ parcelHelpers.export(exports, "LineRangeMapping", ()=>LineRangeMapping);
/**
 * Maps a line range in the original text model to a line range in the modified text model.
 * Also contains inner range mappings.
 */ parcelHelpers.export(exports, "DetailedLineRangeMapping", ()=>DetailedLineRangeMapping);
/**
 * Maps a range in the original text model to a range in the modified text model.
 */ parcelHelpers.export(exports, "RangeMapping", ()=>RangeMapping);
var _errorsJs = require("../../../base/common/errors.js");
var _lineRangeJs = require("../core/lineRange.js");
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
var _textEditJs = require("../core/textEdit.js");
class LineRangeMapping {
    static inverse(mapping, originalLineCount, modifiedLineCount) {
        const result = [];
        let lastOriginalEndLineNumber = 1;
        let lastModifiedEndLineNumber = 1;
        for (const m of mapping){
            const r = new LineRangeMapping(new (0, _lineRangeJs.LineRange)(lastOriginalEndLineNumber, m.original.startLineNumber), new (0, _lineRangeJs.LineRange)(lastModifiedEndLineNumber, m.modified.startLineNumber));
            if (!r.modified.isEmpty) result.push(r);
            lastOriginalEndLineNumber = m.original.endLineNumberExclusive;
            lastModifiedEndLineNumber = m.modified.endLineNumberExclusive;
        }
        const r = new LineRangeMapping(new (0, _lineRangeJs.LineRange)(lastOriginalEndLineNumber, originalLineCount + 1), new (0, _lineRangeJs.LineRange)(lastModifiedEndLineNumber, modifiedLineCount + 1));
        if (!r.modified.isEmpty) result.push(r);
        return result;
    }
    static clip(mapping, originalRange, modifiedRange) {
        const result = [];
        for (const m of mapping){
            const original = m.original.intersect(originalRange);
            const modified = m.modified.intersect(modifiedRange);
            if (original && !original.isEmpty && modified && !modified.isEmpty) result.push(new LineRangeMapping(original, modified));
        }
        return result;
    }
    constructor(originalRange, modifiedRange){
        this.original = originalRange;
        this.modified = modifiedRange;
    }
    toString() {
        return `{${this.original.toString()}->${this.modified.toString()}}`;
    }
    flip() {
        return new LineRangeMapping(this.modified, this.original);
    }
    join(other) {
        return new LineRangeMapping(this.original.join(other.original), this.modified.join(other.modified));
    }
    /**
     * This method assumes that the LineRangeMapping describes a valid diff!
     * I.e. if one range is empty, the other range cannot be the entire document.
     * It avoids various problems when the line range points to non-existing line-numbers.
    */ toRangeMapping() {
        const origInclusiveRange = this.original.toInclusiveRange();
        const modInclusiveRange = this.modified.toInclusiveRange();
        if (origInclusiveRange && modInclusiveRange) return new RangeMapping(origInclusiveRange, modInclusiveRange);
        else if (this.original.startLineNumber === 1 || this.modified.startLineNumber === 1) {
            if (!(this.modified.startLineNumber === 1 && this.original.startLineNumber === 1)) // If one line range starts at 1, the other one must start at 1 as well.
            throw new (0, _errorsJs.BugIndicatingError)("not a valid diff");
            // Because one range is empty and both ranges start at line 1, none of the ranges can cover all lines.
            // Thus, `endLineNumberExclusive` is a valid line number.
            return new RangeMapping(new (0, _rangeJs.Range)(this.original.startLineNumber, 1, this.original.endLineNumberExclusive, 1), new (0, _rangeJs.Range)(this.modified.startLineNumber, 1, this.modified.endLineNumberExclusive, 1));
        } else // We can assume here that both startLineNumbers are greater than 1.
        return new RangeMapping(new (0, _rangeJs.Range)(this.original.startLineNumber - 1, Number.MAX_SAFE_INTEGER, this.original.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER), new (0, _rangeJs.Range)(this.modified.startLineNumber - 1, Number.MAX_SAFE_INTEGER, this.modified.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER));
    }
    /**
     * This method assumes that the LineRangeMapping describes a valid diff!
     * I.e. if one range is empty, the other range cannot be the entire document.
     * It avoids various problems when the line range points to non-existing line-numbers.
    */ toRangeMapping2(original, modified) {
        if (isValidLineNumber(this.original.endLineNumberExclusive, original) && isValidLineNumber(this.modified.endLineNumberExclusive, modified)) return new RangeMapping(new (0, _rangeJs.Range)(this.original.startLineNumber, 1, this.original.endLineNumberExclusive, 1), new (0, _rangeJs.Range)(this.modified.startLineNumber, 1, this.modified.endLineNumberExclusive, 1));
        if (!this.original.isEmpty && !this.modified.isEmpty) return new RangeMapping((0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(this.original.startLineNumber, 1), normalizePosition(new (0, _positionJs.Position)(this.original.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER), original)), (0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(this.modified.startLineNumber, 1), normalizePosition(new (0, _positionJs.Position)(this.modified.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER), modified)));
        if (this.original.startLineNumber > 1 && this.modified.startLineNumber > 1) return new RangeMapping((0, _rangeJs.Range).fromPositions(normalizePosition(new (0, _positionJs.Position)(this.original.startLineNumber - 1, Number.MAX_SAFE_INTEGER), original), normalizePosition(new (0, _positionJs.Position)(this.original.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER), original)), (0, _rangeJs.Range).fromPositions(normalizePosition(new (0, _positionJs.Position)(this.modified.startLineNumber - 1, Number.MAX_SAFE_INTEGER), modified), normalizePosition(new (0, _positionJs.Position)(this.modified.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER), modified)));
        // Situation now: one range is empty and one range touches the last line and one range starts at line 1.
        // I don't think this can happen.
        throw new (0, _errorsJs.BugIndicatingError)();
    }
}
function normalizePosition(position, content) {
    if (position.lineNumber < 1) return new (0, _positionJs.Position)(1, 1);
    if (position.lineNumber > content.length) return new (0, _positionJs.Position)(content.length, content[content.length - 1].length + 1);
    const line = content[position.lineNumber - 1];
    if (position.column > line.length + 1) return new (0, _positionJs.Position)(position.lineNumber, line.length + 1);
    return position;
}
function isValidLineNumber(lineNumber, lines) {
    return lineNumber >= 1 && lineNumber <= lines.length;
}
class DetailedLineRangeMapping extends LineRangeMapping {
    static fromRangeMappings(rangeMappings) {
        const originalRange = (0, _lineRangeJs.LineRange).join(rangeMappings.map((r)=>(0, _lineRangeJs.LineRange).fromRangeInclusive(r.originalRange)));
        const modifiedRange = (0, _lineRangeJs.LineRange).join(rangeMappings.map((r)=>(0, _lineRangeJs.LineRange).fromRangeInclusive(r.modifiedRange)));
        return new DetailedLineRangeMapping(originalRange, modifiedRange, rangeMappings);
    }
    constructor(originalRange, modifiedRange, innerChanges){
        super(originalRange, modifiedRange);
        this.innerChanges = innerChanges;
    }
    flip() {
        return new DetailedLineRangeMapping(this.modified, this.original, this.innerChanges?.map((c)=>c.flip()));
    }
    withInnerChangesFromLineRanges() {
        return new DetailedLineRangeMapping(this.original, this.modified, [
            this.toRangeMapping()
        ]);
    }
}
class RangeMapping {
    static assertSorted(rangeMappings) {
        for(let i = 1; i < rangeMappings.length; i++){
            const previous = rangeMappings[i - 1];
            const current = rangeMappings[i];
            if (!(previous.originalRange.getEndPosition().isBeforeOrEqual(current.originalRange.getStartPosition()) && previous.modifiedRange.getEndPosition().isBeforeOrEqual(current.modifiedRange.getStartPosition()))) throw new (0, _errorsJs.BugIndicatingError)("Range mappings must be sorted");
        }
    }
    constructor(originalRange, modifiedRange){
        this.originalRange = originalRange;
        this.modifiedRange = modifiedRange;
    }
    toString() {
        return `{${this.originalRange.toString()}->${this.modifiedRange.toString()}}`;
    }
    flip() {
        return new RangeMapping(this.modifiedRange, this.originalRange);
    }
    /**
     * Creates a single text edit that describes the change from the original to the modified text.
    */ toTextEdit(modified) {
        const newText = modified.getValueOfRange(this.modifiedRange);
        return new (0, _textEditJs.SingleTextEdit)(this.originalRange, newText);
    }
}

},{"../../../base/common/errors.js":"divX8","../core/lineRange.js":"cmnMs","../core/position.js":"lvrPe","../core/range.js":"jmUPh","../core/textEdit.js":"hdqra","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cmnMs":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A range of lines (1-based).
 */ parcelHelpers.export(exports, "LineRange", ()=>LineRange);
parcelHelpers.export(exports, "LineRangeSet", ()=>LineRangeSet);
var _errorsJs = require("../../../base/common/errors.js");
var _offsetRangeJs = require("./offsetRange.js");
var _rangeJs = require("./range.js");
var _arraysFindJs = require("../../../base/common/arraysFind.js");
class LineRange {
    static fromRangeInclusive(range) {
        return new LineRange(range.startLineNumber, range.endLineNumber + 1);
    }
    /**
     * @param lineRanges An array of sorted line ranges.
     */ static joinMany(lineRanges) {
        if (lineRanges.length === 0) return [];
        let result = new LineRangeSet(lineRanges[0].slice());
        for(let i = 1; i < lineRanges.length; i++)result = result.getUnion(new LineRangeSet(lineRanges[i].slice()));
        return result.ranges;
    }
    static join(lineRanges) {
        if (lineRanges.length === 0) throw new (0, _errorsJs.BugIndicatingError)("lineRanges cannot be empty");
        let startLineNumber = lineRanges[0].startLineNumber;
        let endLineNumberExclusive = lineRanges[0].endLineNumberExclusive;
        for(let i = 1; i < lineRanges.length; i++){
            startLineNumber = Math.min(startLineNumber, lineRanges[i].startLineNumber);
            endLineNumberExclusive = Math.max(endLineNumberExclusive, lineRanges[i].endLineNumberExclusive);
        }
        return new LineRange(startLineNumber, endLineNumberExclusive);
    }
    static ofLength(startLineNumber, length) {
        return new LineRange(startLineNumber, startLineNumber + length);
    }
    /**
     * @internal
     */ static deserialize(lineRange) {
        return new LineRange(lineRange[0], lineRange[1]);
    }
    constructor(startLineNumber, endLineNumberExclusive){
        if (startLineNumber > endLineNumberExclusive) throw new (0, _errorsJs.BugIndicatingError)(`startLineNumber ${startLineNumber} cannot be after endLineNumberExclusive ${endLineNumberExclusive}`);
        this.startLineNumber = startLineNumber;
        this.endLineNumberExclusive = endLineNumberExclusive;
    }
    /**
     * Indicates if this line range contains the given line number.
     */ contains(lineNumber) {
        return this.startLineNumber <= lineNumber && lineNumber < this.endLineNumberExclusive;
    }
    /**
     * Indicates if this line range is empty.
     */ get isEmpty() {
        return this.startLineNumber === this.endLineNumberExclusive;
    }
    /**
     * Moves this line range by the given offset of line numbers.
     */ delta(offset) {
        return new LineRange(this.startLineNumber + offset, this.endLineNumberExclusive + offset);
    }
    deltaLength(offset) {
        return new LineRange(this.startLineNumber, this.endLineNumberExclusive + offset);
    }
    /**
     * The number of lines this line range spans.
     */ get length() {
        return this.endLineNumberExclusive - this.startLineNumber;
    }
    /**
     * Creates a line range that combines this and the given line range.
     */ join(other) {
        return new LineRange(Math.min(this.startLineNumber, other.startLineNumber), Math.max(this.endLineNumberExclusive, other.endLineNumberExclusive));
    }
    toString() {
        return `[${this.startLineNumber},${this.endLineNumberExclusive})`;
    }
    /**
     * The resulting range is empty if the ranges do not intersect, but touch.
     * If the ranges don't even touch, the result is undefined.
     */ intersect(other) {
        const startLineNumber = Math.max(this.startLineNumber, other.startLineNumber);
        const endLineNumberExclusive = Math.min(this.endLineNumberExclusive, other.endLineNumberExclusive);
        if (startLineNumber <= endLineNumberExclusive) return new LineRange(startLineNumber, endLineNumberExclusive);
        return undefined;
    }
    intersectsStrict(other) {
        return this.startLineNumber < other.endLineNumberExclusive && other.startLineNumber < this.endLineNumberExclusive;
    }
    overlapOrTouch(other) {
        return this.startLineNumber <= other.endLineNumberExclusive && other.startLineNumber <= this.endLineNumberExclusive;
    }
    equals(b) {
        return this.startLineNumber === b.startLineNumber && this.endLineNumberExclusive === b.endLineNumberExclusive;
    }
    toInclusiveRange() {
        if (this.isEmpty) return null;
        return new (0, _rangeJs.Range)(this.startLineNumber, 1, this.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER);
    }
    /**
     * @deprecated Using this function is discouraged because it might lead to bugs: The end position is not guaranteed to be a valid position!
    */ toExclusiveRange() {
        return new (0, _rangeJs.Range)(this.startLineNumber, 1, this.endLineNumberExclusive, 1);
    }
    mapToLineArray(f) {
        const result = [];
        for(let lineNumber = this.startLineNumber; lineNumber < this.endLineNumberExclusive; lineNumber++)result.push(f(lineNumber));
        return result;
    }
    forEach(f) {
        for(let lineNumber = this.startLineNumber; lineNumber < this.endLineNumberExclusive; lineNumber++)f(lineNumber);
    }
    /**
     * @internal
     */ serialize() {
        return [
            this.startLineNumber,
            this.endLineNumberExclusive
        ];
    }
    includes(lineNumber) {
        return this.startLineNumber <= lineNumber && lineNumber < this.endLineNumberExclusive;
    }
    /**
     * Converts this 1-based line range to a 0-based offset range (subtracts 1!).
     * @internal
     */ toOffsetRange() {
        return new (0, _offsetRangeJs.OffsetRange)(this.startLineNumber - 1, this.endLineNumberExclusive - 1);
    }
}
class LineRangeSet {
    constructor(/**
     * Sorted by start line number.
     * No two line ranges are touching or intersecting.
     */ _normalizedRanges = []){
        this._normalizedRanges = _normalizedRanges;
    }
    get ranges() {
        return this._normalizedRanges;
    }
    addRange(range) {
        if (range.length === 0) return;
        // Idea: Find joinRange such that:
        // replaceRange = _normalizedRanges.replaceRange(joinRange, range.joinAll(joinRange.map(idx => this._normalizedRanges[idx])))
        // idx of first element that touches range or that is after range
        const joinRangeStartIdx = (0, _arraysFindJs.findFirstIdxMonotonousOrArrLen)(this._normalizedRanges, (r)=>r.endLineNumberExclusive >= range.startLineNumber);
        // idx of element after { last element that touches range or that is before range }
        const joinRangeEndIdxExclusive = (0, _arraysFindJs.findLastIdxMonotonous)(this._normalizedRanges, (r)=>r.startLineNumber <= range.endLineNumberExclusive) + 1;
        if (joinRangeStartIdx === joinRangeEndIdxExclusive) // If there is no element that touches range, then joinRangeStartIdx === joinRangeEndIdxExclusive and that value is the index of the element after range
        this._normalizedRanges.splice(joinRangeStartIdx, 0, range);
        else if (joinRangeStartIdx === joinRangeEndIdxExclusive - 1) {
            // Else, there is an element that touches range and in this case it is both the first and last element. Thus we can replace it
            const joinRange = this._normalizedRanges[joinRangeStartIdx];
            this._normalizedRanges[joinRangeStartIdx] = joinRange.join(range);
        } else {
            // First and last element are different - we need to replace the entire range
            const joinRange = this._normalizedRanges[joinRangeStartIdx].join(this._normalizedRanges[joinRangeEndIdxExclusive - 1]).join(range);
            this._normalizedRanges.splice(joinRangeStartIdx, joinRangeEndIdxExclusive - joinRangeStartIdx, joinRange);
        }
    }
    contains(lineNumber) {
        const rangeThatStartsBeforeEnd = (0, _arraysFindJs.findLastMonotonous)(this._normalizedRanges, (r)=>r.startLineNumber <= lineNumber);
        return !!rangeThatStartsBeforeEnd && rangeThatStartsBeforeEnd.endLineNumberExclusive > lineNumber;
    }
    intersects(range) {
        const rangeThatStartsBeforeEnd = (0, _arraysFindJs.findLastMonotonous)(this._normalizedRanges, (r)=>r.startLineNumber < range.endLineNumberExclusive);
        return !!rangeThatStartsBeforeEnd && rangeThatStartsBeforeEnd.endLineNumberExclusive > range.startLineNumber;
    }
    getUnion(other) {
        if (this._normalizedRanges.length === 0) return other;
        if (other._normalizedRanges.length === 0) return this;
        const result = [];
        let i1 = 0;
        let i2 = 0;
        let current = null;
        while(i1 < this._normalizedRanges.length || i2 < other._normalizedRanges.length){
            let next = null;
            if (i1 < this._normalizedRanges.length && i2 < other._normalizedRanges.length) {
                const lineRange1 = this._normalizedRanges[i1];
                const lineRange2 = other._normalizedRanges[i2];
                if (lineRange1.startLineNumber < lineRange2.startLineNumber) {
                    next = lineRange1;
                    i1++;
                } else {
                    next = lineRange2;
                    i2++;
                }
            } else if (i1 < this._normalizedRanges.length) {
                next = this._normalizedRanges[i1];
                i1++;
            } else {
                next = other._normalizedRanges[i2];
                i2++;
            }
            if (current === null) current = next;
            else if (current.endLineNumberExclusive >= next.startLineNumber) // merge
            current = new LineRange(current.startLineNumber, Math.max(current.endLineNumberExclusive, next.endLineNumberExclusive));
            else {
                // push
                result.push(current);
                current = next;
            }
        }
        if (current !== null) result.push(current);
        return new LineRangeSet(result);
    }
    /**
     * Subtracts all ranges in this set from `range` and returns the result.
     */ subtractFrom(range) {
        // idx of first element that touches range or that is after range
        const joinRangeStartIdx = (0, _arraysFindJs.findFirstIdxMonotonousOrArrLen)(this._normalizedRanges, (r)=>r.endLineNumberExclusive >= range.startLineNumber);
        // idx of element after { last element that touches range or that is before range }
        const joinRangeEndIdxExclusive = (0, _arraysFindJs.findLastIdxMonotonous)(this._normalizedRanges, (r)=>r.startLineNumber <= range.endLineNumberExclusive) + 1;
        if (joinRangeStartIdx === joinRangeEndIdxExclusive) return new LineRangeSet([
            range
        ]);
        const result = [];
        let startLineNumber = range.startLineNumber;
        for(let i = joinRangeStartIdx; i < joinRangeEndIdxExclusive; i++){
            const r = this._normalizedRanges[i];
            if (r.startLineNumber > startLineNumber) result.push(new LineRange(startLineNumber, r.startLineNumber));
            startLineNumber = r.endLineNumberExclusive;
        }
        if (startLineNumber < range.endLineNumberExclusive) result.push(new LineRange(startLineNumber, range.endLineNumberExclusive));
        return new LineRangeSet(result);
    }
    toString() {
        return this._normalizedRanges.map((r)=>r.toString()).join(", ");
    }
    getIntersection(other) {
        const result = [];
        let i1 = 0;
        let i2 = 0;
        while(i1 < this._normalizedRanges.length && i2 < other._normalizedRanges.length){
            const r1 = this._normalizedRanges[i1];
            const r2 = other._normalizedRanges[i2];
            const i = r1.intersect(r2);
            if (i && !i.isEmpty) result.push(i);
            if (r1.endLineNumberExclusive < r2.endLineNumberExclusive) i1++;
            else i2++;
        }
        return new LineRangeSet(result);
    }
    getWithDelta(value) {
        return new LineRangeSet(this._normalizedRanges.map((r)=>r.delta(value)));
    }
}

},{"../../../base/common/errors.js":"divX8","./offsetRange.js":"ifHXk","./range.js":"jmUPh","../../../base/common/arraysFind.js":"gWrU0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ifHXk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A range of offsets (0-based).
*/ parcelHelpers.export(exports, "OffsetRange", ()=>OffsetRange);
parcelHelpers.export(exports, "OffsetRangeSet", ()=>OffsetRangeSet);
var _errorsJs = require("../../../base/common/errors.js");
class OffsetRange {
    static addRange(range, sortedRanges) {
        let i = 0;
        while(i < sortedRanges.length && sortedRanges[i].endExclusive < range.start)i++;
        let j = i;
        while(j < sortedRanges.length && sortedRanges[j].start <= range.endExclusive)j++;
        if (i === j) sortedRanges.splice(i, 0, range);
        else {
            const start = Math.min(range.start, sortedRanges[i].start);
            const end = Math.max(range.endExclusive, sortedRanges[j - 1].endExclusive);
            sortedRanges.splice(i, j - i, new OffsetRange(start, end));
        }
    }
    static tryCreate(start, endExclusive) {
        if (start > endExclusive) return undefined;
        return new OffsetRange(start, endExclusive);
    }
    static ofLength(length) {
        return new OffsetRange(0, length);
    }
    static ofStartAndLength(start, length) {
        return new OffsetRange(start, start + length);
    }
    constructor(start, endExclusive){
        this.start = start;
        this.endExclusive = endExclusive;
        if (start > endExclusive) throw new (0, _errorsJs.BugIndicatingError)(`Invalid range: ${this.toString()}`);
    }
    get isEmpty() {
        return this.start === this.endExclusive;
    }
    delta(offset) {
        return new OffsetRange(this.start + offset, this.endExclusive + offset);
    }
    deltaStart(offset) {
        return new OffsetRange(this.start + offset, this.endExclusive);
    }
    deltaEnd(offset) {
        return new OffsetRange(this.start, this.endExclusive + offset);
    }
    get length() {
        return this.endExclusive - this.start;
    }
    toString() {
        return `[${this.start}, ${this.endExclusive})`;
    }
    contains(offset) {
        return this.start <= offset && offset < this.endExclusive;
    }
    /**
     * for all numbers n: range1.contains(n) or range2.contains(n) => range1.join(range2).contains(n)
     * The joined range is the smallest range that contains both ranges.
     */ join(other) {
        return new OffsetRange(Math.min(this.start, other.start), Math.max(this.endExclusive, other.endExclusive));
    }
    /**
     * for all numbers n: range1.contains(n) and range2.contains(n) <=> range1.intersect(range2).contains(n)
     *
     * The resulting range is empty if the ranges do not intersect, but touch.
     * If the ranges don't even touch, the result is undefined.
     */ intersect(other) {
        const start = Math.max(this.start, other.start);
        const end = Math.min(this.endExclusive, other.endExclusive);
        if (start <= end) return new OffsetRange(start, end);
        return undefined;
    }
    intersects(other) {
        const start = Math.max(this.start, other.start);
        const end = Math.min(this.endExclusive, other.endExclusive);
        return start < end;
    }
    isBefore(other) {
        return this.endExclusive <= other.start;
    }
    isAfter(other) {
        return this.start >= other.endExclusive;
    }
    slice(arr) {
        return arr.slice(this.start, this.endExclusive);
    }
    substring(str) {
        return str.substring(this.start, this.endExclusive);
    }
    /**
     * Returns the given value if it is contained in this instance, otherwise the closest value that is contained.
     * The range must not be empty.
     */ clip(value) {
        if (this.isEmpty) throw new (0, _errorsJs.BugIndicatingError)(`Invalid clipping range: ${this.toString()}`);
        return Math.max(this.start, Math.min(this.endExclusive - 1, value));
    }
    /**
     * Returns `r := value + k * length` such that `r` is contained in this range.
     * The range must not be empty.
     *
     * E.g. `[5, 10).clipCyclic(10) === 5`, `[5, 10).clipCyclic(11) === 6` and `[5, 10).clipCyclic(4) === 9`.
     */ clipCyclic(value) {
        if (this.isEmpty) throw new (0, _errorsJs.BugIndicatingError)(`Invalid clipping range: ${this.toString()}`);
        if (value < this.start) return this.endExclusive - (this.start - value) % this.length;
        if (value >= this.endExclusive) return this.start + (value - this.start) % this.length;
        return value;
    }
    forEach(f) {
        for(let i = this.start; i < this.endExclusive; i++)f(i);
    }
}
class OffsetRangeSet {
    constructor(){
        this._sortedRanges = [];
    }
    addRange(range) {
        let i = 0;
        while(i < this._sortedRanges.length && this._sortedRanges[i].endExclusive < range.start)i++;
        let j = i;
        while(j < this._sortedRanges.length && this._sortedRanges[j].start <= range.endExclusive)j++;
        if (i === j) this._sortedRanges.splice(i, 0, range);
        else {
            const start = Math.min(range.start, this._sortedRanges[i].start);
            const end = Math.max(range.endExclusive, this._sortedRanges[j - 1].endExclusive);
            this._sortedRanges.splice(i, j - i, new OffsetRange(start, end));
        }
    }
    toString() {
        return this._sortedRanges.map((r)=>r.toString()).join(", ");
    }
    /**
     * Returns of there is a value that is contained in this instance and the given range.
     */ intersectsStrict(other) {
        // TODO use binary search
        let i = 0;
        while(i < this._sortedRanges.length && this._sortedRanges[i].endExclusive <= other.start)i++;
        return i < this._sortedRanges.length && this._sortedRanges[i].start < other.endExclusive;
    }
    intersectWithRange(other) {
        // TODO use binary search + slice
        const result = new OffsetRangeSet();
        for (const range of this._sortedRanges){
            const intersection = range.intersect(other);
            if (intersection) result.addRange(intersection);
        }
        return result;
    }
    intersectWithRangeLength(other) {
        return this.intersectWithRange(other).length;
    }
    get length() {
        return this._sortedRanges.reduce((prev, cur)=>prev + cur.length, 0);
    }
}

},{"../../../base/common/errors.js":"divX8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gWrU0":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findLast", ()=>findLast);
parcelHelpers.export(exports, "findLastIdx", ()=>findLastIdx);
/**
 * Finds the last item where predicate is true using binary search.
 * `predicate` must be monotonous, i.e. `arr.map(predicate)` must be like `[true, ..., true, false, ..., false]`!
 *
 * @returns `undefined` if no item matches, otherwise the last item that matches the predicate.
 */ parcelHelpers.export(exports, "findLastMonotonous", ()=>findLastMonotonous);
/**
 * Finds the last item where predicate is true using binary search.
 * `predicate` must be monotonous, i.e. `arr.map(predicate)` must be like `[true, ..., true, false, ..., false]`!
 *
 * @returns `startIdx - 1` if predicate is false for all items, otherwise the index of the last item that matches the predicate.
 */ parcelHelpers.export(exports, "findLastIdxMonotonous", ()=>findLastIdxMonotonous);
/**
 * Finds the first item where predicate is true using binary search.
 * `predicate` must be monotonous, i.e. `arr.map(predicate)` must be like `[false, ..., false, true, ..., true]`!
 *
 * @returns `undefined` if no item matches, otherwise the first item that matches the predicate.
 */ parcelHelpers.export(exports, "findFirstMonotonous", ()=>findFirstMonotonous);
/**
 * Finds the first item where predicate is true using binary search.
 * `predicate` must be monotonous, i.e. `arr.map(predicate)` must be like `[false, ..., false, true, ..., true]`!
 *
 * @returns `endIdxEx` if predicate is false for all items, otherwise the index of the first item that matches the predicate.
 */ parcelHelpers.export(exports, "findFirstIdxMonotonousOrArrLen", ()=>findFirstIdxMonotonousOrArrLen);
/**
 * Use this when
 * * You have a sorted array
 * * You query this array with a monotonous predicate to find the last item that has a certain property.
 * * You query this array multiple times with monotonous predicates that get weaker and weaker.
 */ parcelHelpers.export(exports, "MonotonousArray", ()=>MonotonousArray);
/**
 * Returns the first item that is equal to or greater than every other item.
*/ parcelHelpers.export(exports, "findFirstMax", ()=>findFirstMax);
/**
 * Returns the last item that is equal to or greater than every other item.
*/ parcelHelpers.export(exports, "findLastMax", ()=>findLastMax);
/**
 * Returns the first item that is equal to or less than every other item.
*/ parcelHelpers.export(exports, "findFirstMin", ()=>findFirstMin);
parcelHelpers.export(exports, "findMaxIdx", ()=>findMaxIdx);
/**
 * Returns the first mapped value of the array which is not undefined.
 */ parcelHelpers.export(exports, "mapFindFirst", ()=>mapFindFirst);
function findLast(array, predicate) {
    const idx = findLastIdx(array, predicate);
    if (idx === -1) return undefined;
    return array[idx];
}
function findLastIdx(array, predicate, fromIndex = array.length - 1) {
    for(let i = fromIndex; i >= 0; i--){
        const element = array[i];
        if (predicate(element)) return i;
    }
    return -1;
}
function findLastMonotonous(array, predicate) {
    const idx = findLastIdxMonotonous(array, predicate);
    return idx === -1 ? undefined : array[idx];
}
function findLastIdxMonotonous(array, predicate, startIdx = 0, endIdxEx = array.length) {
    let i = startIdx;
    let j = endIdxEx;
    while(i < j){
        const k = Math.floor((i + j) / 2);
        if (predicate(array[k])) i = k + 1;
        else j = k;
    }
    return i - 1;
}
function findFirstMonotonous(array, predicate) {
    const idx = findFirstIdxMonotonousOrArrLen(array, predicate);
    return idx === array.length ? undefined : array[idx];
}
function findFirstIdxMonotonousOrArrLen(array, predicate, startIdx = 0, endIdxEx = array.length) {
    let i = startIdx;
    let j = endIdxEx;
    while(i < j){
        const k = Math.floor((i + j) / 2);
        if (predicate(array[k])) j = k;
        else i = k + 1;
    }
    return i;
}
class MonotonousArray {
    static{
        this.assertInvariants = false;
    }
    constructor(_array){
        this._array = _array;
        this._findLastMonotonousLastIdx = 0;
    }
    /**
     * The predicate must be monotonous, i.e. `arr.map(predicate)` must be like `[true, ..., true, false, ..., false]`!
     * For subsequent calls, current predicate must be weaker than (or equal to) the previous predicate, i.e. more entries must be `true`.
     */ findLastMonotonous(predicate) {
        if (MonotonousArray.assertInvariants) {
            if (this._prevFindLastPredicate) for (const item of this._array){
                if (this._prevFindLastPredicate(item) && !predicate(item)) throw new Error("MonotonousArray: current predicate must be weaker than (or equal to) the previous predicate.");
            }
            this._prevFindLastPredicate = predicate;
        }
        const idx = findLastIdxMonotonous(this._array, predicate, this._findLastMonotonousLastIdx);
        this._findLastMonotonousLastIdx = idx + 1;
        return idx === -1 ? undefined : this._array[idx];
    }
}
function findFirstMax(array, comparator) {
    if (array.length === 0) return undefined;
    let max = array[0];
    for(let i = 1; i < array.length; i++){
        const item = array[i];
        if (comparator(item, max) > 0) max = item;
    }
    return max;
}
function findLastMax(array, comparator) {
    if (array.length === 0) return undefined;
    let max = array[0];
    for(let i = 1; i < array.length; i++){
        const item = array[i];
        if (comparator(item, max) >= 0) max = item;
    }
    return max;
}
function findFirstMin(array, comparator) {
    return findFirstMax(array, (a, b)=>-comparator(a, b));
}
function findMaxIdx(array, comparator) {
    if (array.length === 0) return -1;
    let maxIdx = 0;
    for(let i = 1; i < array.length; i++){
        const item = array[i];
        if (comparator(item, array[maxIdx]) > 0) maxIdx = i;
    }
    return maxIdx;
}
function mapFindFirst(items, mapFn) {
    for (const value of items){
        const mapped = mapFn(value);
        if (mapped !== undefined) return mapped;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hdqra":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextEdit", ()=>TextEdit);
parcelHelpers.export(exports, "SingleTextEdit", ()=>SingleTextEdit);
parcelHelpers.export(exports, "AbstractText", ()=>AbstractText);
parcelHelpers.export(exports, "StringText", ()=>StringText);
var _assertJs = require("../../../base/common/assert.js");
var _errorsJs = require("../../../base/common/errors.js");
var _positionJs = require("./position.js");
var _positionToOffsetJs = require("./positionToOffset.js");
var _rangeJs = require("./range.js");
var _textLengthJs = require("./textLength.js");
class TextEdit {
    constructor(edits){
        this.edits = edits;
        (0, _assertJs.assertFn)(()=>(0, _assertJs.checkAdjacentItems)(edits, (a, b)=>a.range.getEndPosition().isBeforeOrEqual(b.range.getStartPosition())));
    }
    apply(text) {
        let result = "";
        let lastEditEnd = new (0, _positionJs.Position)(1, 1);
        for (const edit of this.edits){
            const editRange = edit.range;
            const editStart = editRange.getStartPosition();
            const editEnd = editRange.getEndPosition();
            const r = rangeFromPositions(lastEditEnd, editStart);
            if (!r.isEmpty()) result += text.getValueOfRange(r);
            result += edit.text;
            lastEditEnd = editEnd;
        }
        const r = rangeFromPositions(lastEditEnd, text.endPositionExclusive);
        if (!r.isEmpty()) result += text.getValueOfRange(r);
        return result;
    }
    applyToString(str) {
        const strText = new StringText(str);
        return this.apply(strText);
    }
    getNewRanges() {
        const newRanges = [];
        let previousEditEndLineNumber = 0;
        let lineOffset = 0;
        let columnOffset = 0;
        for (const edit of this.edits){
            const textLength = (0, _textLengthJs.TextLength).ofText(edit.text);
            const newRangeStart = (0, _positionJs.Position).lift({
                lineNumber: edit.range.startLineNumber + lineOffset,
                column: edit.range.startColumn + (edit.range.startLineNumber === previousEditEndLineNumber ? columnOffset : 0)
            });
            const newRange = textLength.createRange(newRangeStart);
            newRanges.push(newRange);
            lineOffset = newRange.endLineNumber - edit.range.endLineNumber;
            columnOffset = newRange.endColumn - edit.range.endColumn;
            previousEditEndLineNumber = edit.range.endLineNumber;
        }
        return newRanges;
    }
}
class SingleTextEdit {
    constructor(range, text){
        this.range = range;
        this.text = text;
    }
    toSingleEditOperation() {
        return {
            range: this.range,
            text: this.text
        };
    }
}
function rangeFromPositions(start, end) {
    if (start.lineNumber === end.lineNumber && start.column === Number.MAX_SAFE_INTEGER) return (0, _rangeJs.Range).fromPositions(end, end);
    else if (!start.isBeforeOrEqual(end)) throw new (0, _errorsJs.BugIndicatingError)("start must be before end");
    return new (0, _rangeJs.Range)(start.lineNumber, start.column, end.lineNumber, end.column);
}
class AbstractText {
    get endPositionExclusive() {
        return this.length.addToPosition(new (0, _positionJs.Position)(1, 1));
    }
}
class StringText extends AbstractText {
    constructor(value){
        super();
        this.value = value;
        this._t = new (0, _positionToOffsetJs.PositionOffsetTransformer)(this.value);
    }
    getValueOfRange(range) {
        return this._t.getOffsetRange(range).substring(this.value);
    }
    get length() {
        return this._t.textLength;
    }
}

},{"../../../base/common/assert.js":"1nPIE","../../../base/common/errors.js":"divX8","./position.js":"lvrPe","./positionToOffset.js":"3zHvX","./range.js":"jmUPh","./textLength.js":"Lk80L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3zHvX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PositionOffsetTransformer", ()=>PositionOffsetTransformer);
var _offsetRangeJs = require("./offsetRange.js");
var _textLengthJs = require("./textLength.js");
class PositionOffsetTransformer {
    constructor(text){
        this.text = text;
        this.lineStartOffsetByLineIdx = [];
        this.lineStartOffsetByLineIdx.push(0);
        for(let i = 0; i < text.length; i++)if (text.charAt(i) === "\n") this.lineStartOffsetByLineIdx.push(i + 1);
    }
    getOffset(position) {
        return this.lineStartOffsetByLineIdx[position.lineNumber - 1] + position.column - 1;
    }
    getOffsetRange(range) {
        return new (0, _offsetRangeJs.OffsetRange)(this.getOffset(range.getStartPosition()), this.getOffset(range.getEndPosition()));
    }
    get textLength() {
        const lineIdx = this.lineStartOffsetByLineIdx.length - 1;
        return new (0, _textLengthJs.TextLength)(lineIdx, this.text.length - this.lineStartOffsetByLineIdx[lineIdx]);
    }
}

},{"./offsetRange.js":"ifHXk","./textLength.js":"Lk80L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Lk80L":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a non-negative length of text in terms of line and column count.
*/ parcelHelpers.export(exports, "TextLength", ()=>TextLength);
var _positionJs = require("./position.js");
var _rangeJs = require("./range.js");
class TextLength {
    static{
        this.zero = new TextLength(0, 0);
    }
    static betweenPositions(position1, position2) {
        if (position1.lineNumber === position2.lineNumber) return new TextLength(0, position2.column - position1.column);
        else return new TextLength(position2.lineNumber - position1.lineNumber, position2.column - 1);
    }
    static ofRange(range) {
        return TextLength.betweenPositions(range.getStartPosition(), range.getEndPosition());
    }
    static ofText(text) {
        let line = 0;
        let column = 0;
        for (const c of text)if (c === "\n") {
            line++;
            column = 0;
        } else column++;
        return new TextLength(line, column);
    }
    constructor(lineCount, columnCount){
        this.lineCount = lineCount;
        this.columnCount = columnCount;
    }
    isGreaterThanOrEqualTo(other) {
        if (this.lineCount !== other.lineCount) return this.lineCount > other.lineCount;
        return this.columnCount >= other.columnCount;
    }
    createRange(startPosition) {
        if (this.lineCount === 0) return new (0, _rangeJs.Range)(startPosition.lineNumber, startPosition.column, startPosition.lineNumber, startPosition.column + this.columnCount);
        else return new (0, _rangeJs.Range)(startPosition.lineNumber, startPosition.column, startPosition.lineNumber + this.lineCount, this.columnCount + 1);
    }
    addToPosition(position) {
        if (this.lineCount === 0) return new (0, _positionJs.Position)(position.lineNumber, position.column + this.columnCount);
        else return new (0, _positionJs.Position)(position.lineNumber + this.lineCount, this.columnCount + 1);
    }
    toString() {
        return `${this.lineCount},${this.columnCount}`;
    }
}

},{"./position.js":"lvrPe","./range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8qVeZ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultLinesDiffComputer", ()=>DefaultLinesDiffComputer);
parcelHelpers.export(exports, "lineRangeMappingFromRangeMappings", ()=>lineRangeMappingFromRangeMappings);
parcelHelpers.export(exports, "getLineRangeMapping", ()=>getLineRangeMapping);
var _arraysJs = require("../../../../base/common/arrays.js");
var _assertJs = require("../../../../base/common/assert.js");
var _lineRangeJs = require("../../core/lineRange.js");
var _offsetRangeJs = require("../../core/offsetRange.js");
var _rangeJs = require("../../core/range.js");
var _diffAlgorithmJs = require("./algorithms/diffAlgorithm.js");
var _dynamicProgrammingDiffingJs = require("./algorithms/dynamicProgrammingDiffing.js");
var _myersDiffAlgorithmJs = require("./algorithms/myersDiffAlgorithm.js");
var _computeMovedLinesJs = require("./computeMovedLines.js");
var _heuristicSequenceOptimizationsJs = require("./heuristicSequenceOptimizations.js");
var _lineSequenceJs = require("./lineSequence.js");
var _linesSliceCharSequenceJs = require("./linesSliceCharSequence.js");
var _linesDiffComputerJs = require("../linesDiffComputer.js");
var _rangeMappingJs = require("../rangeMapping.js");
class DefaultLinesDiffComputer {
    constructor(){
        this.dynamicProgrammingDiffing = new (0, _dynamicProgrammingDiffingJs.DynamicProgrammingDiffing)();
        this.myersDiffingAlgorithm = new (0, _myersDiffAlgorithmJs.MyersDiffAlgorithm)();
    }
    computeDiff(originalLines, modifiedLines, options) {
        if (originalLines.length <= 1 && (0, _arraysJs.equals)(originalLines, modifiedLines, (a, b)=>a === b)) return new (0, _linesDiffComputerJs.LinesDiff)([], [], false);
        if (originalLines.length === 1 && originalLines[0].length === 0 || modifiedLines.length === 1 && modifiedLines[0].length === 0) return new (0, _linesDiffComputerJs.LinesDiff)([
            new (0, _rangeMappingJs.DetailedLineRangeMapping)(new (0, _lineRangeJs.LineRange)(1, originalLines.length + 1), new (0, _lineRangeJs.LineRange)(1, modifiedLines.length + 1), [
                new (0, _rangeMappingJs.RangeMapping)(new (0, _rangeJs.Range)(1, 1, originalLines.length, originalLines[originalLines.length - 1].length + 1), new (0, _rangeJs.Range)(1, 1, modifiedLines.length, modifiedLines[modifiedLines.length - 1].length + 1))
            ])
        ], [], false);
        const timeout = options.maxComputationTimeMs === 0 ? (0, _diffAlgorithmJs.InfiniteTimeout).instance : new (0, _diffAlgorithmJs.DateTimeout)(options.maxComputationTimeMs);
        const considerWhitespaceChanges = !options.ignoreTrimWhitespace;
        const perfectHashes = new Map();
        function getOrCreateHash(text) {
            let hash = perfectHashes.get(text);
            if (hash === undefined) {
                hash = perfectHashes.size;
                perfectHashes.set(text, hash);
            }
            return hash;
        }
        const originalLinesHashes = originalLines.map((l)=>getOrCreateHash(l.trim()));
        const modifiedLinesHashes = modifiedLines.map((l)=>getOrCreateHash(l.trim()));
        const sequence1 = new (0, _lineSequenceJs.LineSequence)(originalLinesHashes, originalLines);
        const sequence2 = new (0, _lineSequenceJs.LineSequence)(modifiedLinesHashes, modifiedLines);
        const lineAlignmentResult = (()=>{
            if (sequence1.length + sequence2.length < 1700) // Use the improved algorithm for small files
            return this.dynamicProgrammingDiffing.compute(sequence1, sequence2, timeout, (offset1, offset2)=>originalLines[offset1] === modifiedLines[offset2] ? modifiedLines[offset2].length === 0 ? 0.1 : 1 + Math.log(1 + modifiedLines[offset2].length) : 0.99);
            return this.myersDiffingAlgorithm.compute(sequence1, sequence2, timeout);
        })();
        let lineAlignments = lineAlignmentResult.diffs;
        let hitTimeout = lineAlignmentResult.hitTimeout;
        lineAlignments = (0, _heuristicSequenceOptimizationsJs.optimizeSequenceDiffs)(sequence1, sequence2, lineAlignments);
        lineAlignments = (0, _heuristicSequenceOptimizationsJs.removeVeryShortMatchingLinesBetweenDiffs)(sequence1, sequence2, lineAlignments);
        const alignments = [];
        const scanForWhitespaceChanges = (equalLinesCount)=>{
            if (!considerWhitespaceChanges) return;
            for(let i = 0; i < equalLinesCount; i++){
                const seq1Offset = seq1LastStart + i;
                const seq2Offset = seq2LastStart + i;
                if (originalLines[seq1Offset] !== modifiedLines[seq2Offset]) {
                    // This is because of whitespace changes, diff these lines
                    const characterDiffs = this.refineDiff(originalLines, modifiedLines, new (0, _diffAlgorithmJs.SequenceDiff)(new (0, _offsetRangeJs.OffsetRange)(seq1Offset, seq1Offset + 1), new (0, _offsetRangeJs.OffsetRange)(seq2Offset, seq2Offset + 1)), timeout, considerWhitespaceChanges);
                    for (const a of characterDiffs.mappings)alignments.push(a);
                    if (characterDiffs.hitTimeout) hitTimeout = true;
                }
            }
        };
        let seq1LastStart = 0;
        let seq2LastStart = 0;
        for (const diff of lineAlignments){
            (0, _assertJs.assertFn)(()=>diff.seq1Range.start - seq1LastStart === diff.seq2Range.start - seq2LastStart);
            const equalLinesCount = diff.seq1Range.start - seq1LastStart;
            scanForWhitespaceChanges(equalLinesCount);
            seq1LastStart = diff.seq1Range.endExclusive;
            seq2LastStart = diff.seq2Range.endExclusive;
            const characterDiffs = this.refineDiff(originalLines, modifiedLines, diff, timeout, considerWhitespaceChanges);
            if (characterDiffs.hitTimeout) hitTimeout = true;
            for (const a of characterDiffs.mappings)alignments.push(a);
        }
        scanForWhitespaceChanges(originalLines.length - seq1LastStart);
        const changes = lineRangeMappingFromRangeMappings(alignments, originalLines, modifiedLines);
        let moves = [];
        if (options.computeMoves) moves = this.computeMoves(changes, originalLines, modifiedLines, originalLinesHashes, modifiedLinesHashes, timeout, considerWhitespaceChanges);
        // Make sure all ranges are valid
        (0, _assertJs.assertFn)(()=>{
            function validatePosition(pos, lines) {
                if (pos.lineNumber < 1 || pos.lineNumber > lines.length) return false;
                const line = lines[pos.lineNumber - 1];
                if (pos.column < 1 || pos.column > line.length + 1) return false;
                return true;
            }
            function validateRange(range, lines) {
                if (range.startLineNumber < 1 || range.startLineNumber > lines.length + 1) return false;
                if (range.endLineNumberExclusive < 1 || range.endLineNumberExclusive > lines.length + 1) return false;
                return true;
            }
            for (const c of changes){
                if (!c.innerChanges) return false;
                for (const ic of c.innerChanges){
                    const valid = validatePosition(ic.modifiedRange.getStartPosition(), modifiedLines) && validatePosition(ic.modifiedRange.getEndPosition(), modifiedLines) && validatePosition(ic.originalRange.getStartPosition(), originalLines) && validatePosition(ic.originalRange.getEndPosition(), originalLines);
                    if (!valid) return false;
                }
                if (!validateRange(c.modified, modifiedLines) || !validateRange(c.original, originalLines)) return false;
            }
            return true;
        });
        return new (0, _linesDiffComputerJs.LinesDiff)(changes, moves, hitTimeout);
    }
    computeMoves(changes, originalLines, modifiedLines, hashedOriginalLines, hashedModifiedLines, timeout, considerWhitespaceChanges) {
        const moves = (0, _computeMovedLinesJs.computeMovedLines)(changes, originalLines, modifiedLines, hashedOriginalLines, hashedModifiedLines, timeout);
        const movesWithDiffs = moves.map((m)=>{
            const moveChanges = this.refineDiff(originalLines, modifiedLines, new (0, _diffAlgorithmJs.SequenceDiff)(m.original.toOffsetRange(), m.modified.toOffsetRange()), timeout, considerWhitespaceChanges);
            const mappings = lineRangeMappingFromRangeMappings(moveChanges.mappings, originalLines, modifiedLines, true);
            return new (0, _linesDiffComputerJs.MovedText)(m, mappings);
        });
        return movesWithDiffs;
    }
    refineDiff(originalLines, modifiedLines, diff, timeout, considerWhitespaceChanges) {
        const lineRangeMapping = toLineRangeMapping(diff);
        const rangeMapping = lineRangeMapping.toRangeMapping2(originalLines, modifiedLines);
        const slice1 = new (0, _linesSliceCharSequenceJs.LinesSliceCharSequence)(originalLines, rangeMapping.originalRange, considerWhitespaceChanges);
        const slice2 = new (0, _linesSliceCharSequenceJs.LinesSliceCharSequence)(modifiedLines, rangeMapping.modifiedRange, considerWhitespaceChanges);
        const diffResult = slice1.length + slice2.length < 500 ? this.dynamicProgrammingDiffing.compute(slice1, slice2, timeout) : this.myersDiffingAlgorithm.compute(slice1, slice2, timeout);
        const check = false;
        let diffs = diffResult.diffs;
        if (check) (0, _diffAlgorithmJs.SequenceDiff).assertSorted(diffs);
        diffs = (0, _heuristicSequenceOptimizationsJs.optimizeSequenceDiffs)(slice1, slice2, diffs);
        if (check) (0, _diffAlgorithmJs.SequenceDiff).assertSorted(diffs);
        diffs = (0, _heuristicSequenceOptimizationsJs.extendDiffsToEntireWordIfAppropriate)(slice1, slice2, diffs);
        if (check) (0, _diffAlgorithmJs.SequenceDiff).assertSorted(diffs);
        diffs = (0, _heuristicSequenceOptimizationsJs.removeShortMatches)(slice1, slice2, diffs);
        if (check) (0, _diffAlgorithmJs.SequenceDiff).assertSorted(diffs);
        diffs = (0, _heuristicSequenceOptimizationsJs.removeVeryShortMatchingTextBetweenLongDiffs)(slice1, slice2, diffs);
        if (check) (0, _diffAlgorithmJs.SequenceDiff).assertSorted(diffs);
        const result = diffs.map((d)=>new (0, _rangeMappingJs.RangeMapping)(slice1.translateRange(d.seq1Range), slice2.translateRange(d.seq2Range)));
        if (check) (0, _rangeMappingJs.RangeMapping).assertSorted(result);
        // Assert: result applied on original should be the same as diff applied to original
        return {
            mappings: result,
            hitTimeout: diffResult.hitTimeout
        };
    }
}
function lineRangeMappingFromRangeMappings(alignments, originalLines, modifiedLines, dontAssertStartLine = false) {
    const changes = [];
    for (const g of (0, _arraysJs.groupAdjacentBy)(alignments.map((a)=>getLineRangeMapping(a, originalLines, modifiedLines)), (a1, a2)=>a1.original.overlapOrTouch(a2.original) || a1.modified.overlapOrTouch(a2.modified))){
        const first = g[0];
        const last = g[g.length - 1];
        changes.push(new (0, _rangeMappingJs.DetailedLineRangeMapping)(first.original.join(last.original), first.modified.join(last.modified), g.map((a)=>a.innerChanges[0])));
    }
    (0, _assertJs.assertFn)(()=>{
        if (!dontAssertStartLine && changes.length > 0) {
            if (changes[0].modified.startLineNumber !== changes[0].original.startLineNumber) return false;
            if (modifiedLines.length - changes[changes.length - 1].modified.endLineNumberExclusive !== originalLines.length - changes[changes.length - 1].original.endLineNumberExclusive) return false;
        }
        return (0, _assertJs.checkAdjacentItems)(changes, (m1, m2)=>m2.original.startLineNumber - m1.original.endLineNumberExclusive === m2.modified.startLineNumber - m1.modified.endLineNumberExclusive && // There has to be an unchanged line in between (otherwise both diffs should have been joined)
            m1.original.endLineNumberExclusive < m2.original.startLineNumber && m1.modified.endLineNumberExclusive < m2.modified.startLineNumber);
    });
    return changes;
}
function getLineRangeMapping(rangeMapping, originalLines, modifiedLines) {
    let lineStartDelta = 0;
    let lineEndDelta = 0;
    // rangeMapping describes the edit that replaces `rangeMapping.originalRange` with `newText := getText(modifiedLines, rangeMapping.modifiedRange)`.
    // original: ]xxx \n <- this line is not modified
    // modified: ]xx  \n
    if (rangeMapping.modifiedRange.endColumn === 1 && rangeMapping.originalRange.endColumn === 1 && rangeMapping.originalRange.startLineNumber + lineStartDelta <= rangeMapping.originalRange.endLineNumber && rangeMapping.modifiedRange.startLineNumber + lineStartDelta <= rangeMapping.modifiedRange.endLineNumber) // We can only do this if the range is not empty yet
    lineEndDelta = -1;
    // original: xxx[ \n <- this line is not modified
    // modified: xxx[ \n
    if (rangeMapping.modifiedRange.startColumn - 1 >= modifiedLines[rangeMapping.modifiedRange.startLineNumber - 1].length && rangeMapping.originalRange.startColumn - 1 >= originalLines[rangeMapping.originalRange.startLineNumber - 1].length && rangeMapping.originalRange.startLineNumber <= rangeMapping.originalRange.endLineNumber + lineEndDelta && rangeMapping.modifiedRange.startLineNumber <= rangeMapping.modifiedRange.endLineNumber + lineEndDelta) // We can only do this if the range is not empty yet
    lineStartDelta = 1;
    const originalLineRange = new (0, _lineRangeJs.LineRange)(rangeMapping.originalRange.startLineNumber + lineStartDelta, rangeMapping.originalRange.endLineNumber + 1 + lineEndDelta);
    const modifiedLineRange = new (0, _lineRangeJs.LineRange)(rangeMapping.modifiedRange.startLineNumber + lineStartDelta, rangeMapping.modifiedRange.endLineNumber + 1 + lineEndDelta);
    return new (0, _rangeMappingJs.DetailedLineRangeMapping)(originalLineRange, modifiedLineRange, [
        rangeMapping
    ]);
}
function toLineRangeMapping(sequenceDiff) {
    return new (0, _rangeMappingJs.LineRangeMapping)(new (0, _lineRangeJs.LineRange)(sequenceDiff.seq1Range.start + 1, sequenceDiff.seq1Range.endExclusive + 1), new (0, _lineRangeJs.LineRange)(sequenceDiff.seq2Range.start + 1, sequenceDiff.seq2Range.endExclusive + 1));
}

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/assert.js":"1nPIE","../../core/lineRange.js":"cmnMs","../../core/offsetRange.js":"ifHXk","../../core/range.js":"jmUPh","./algorithms/diffAlgorithm.js":"dKr4S","./algorithms/dynamicProgrammingDiffing.js":"aisSa","./algorithms/myersDiffAlgorithm.js":"cArRr","./computeMovedLines.js":"11f6B","./heuristicSequenceOptimizations.js":"eLKvQ","./lineSequence.js":"abvKv","./linesSliceCharSequence.js":"3k42X","../linesDiffComputer.js":"kUXV1","../rangeMapping.js":"7QuJJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dKr4S":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiffAlgorithmResult", ()=>DiffAlgorithmResult);
parcelHelpers.export(exports, "SequenceDiff", ()=>SequenceDiff);
parcelHelpers.export(exports, "OffsetPair", ()=>OffsetPair);
parcelHelpers.export(exports, "InfiniteTimeout", ()=>InfiniteTimeout);
parcelHelpers.export(exports, "DateTimeout", ()=>DateTimeout);
var _arraysJs = require("../../../../../base/common/arrays.js");
var _errorsJs = require("../../../../../base/common/errors.js");
var _offsetRangeJs = require("../../../core/offsetRange.js");
class DiffAlgorithmResult {
    static trivial(seq1, seq2) {
        return new DiffAlgorithmResult([
            new SequenceDiff((0, _offsetRangeJs.OffsetRange).ofLength(seq1.length), (0, _offsetRangeJs.OffsetRange).ofLength(seq2.length))
        ], false);
    }
    static trivialTimedOut(seq1, seq2) {
        return new DiffAlgorithmResult([
            new SequenceDiff((0, _offsetRangeJs.OffsetRange).ofLength(seq1.length), (0, _offsetRangeJs.OffsetRange).ofLength(seq2.length))
        ], true);
    }
    constructor(diffs, /**
     * Indicates if the time out was reached.
     * In that case, the diffs might be an approximation and the user should be asked to rerun the diff with more time.
     */ hitTimeout){
        this.diffs = diffs;
        this.hitTimeout = hitTimeout;
    }
}
class SequenceDiff {
    static invert(sequenceDiffs, doc1Length) {
        const result = [];
        (0, _arraysJs.forEachAdjacent)(sequenceDiffs, (a, b)=>{
            result.push(SequenceDiff.fromOffsetPairs(a ? a.getEndExclusives() : OffsetPair.zero, b ? b.getStarts() : new OffsetPair(doc1Length, (a ? a.seq2Range.endExclusive - a.seq1Range.endExclusive : 0) + doc1Length)));
        });
        return result;
    }
    static fromOffsetPairs(start, endExclusive) {
        return new SequenceDiff(new (0, _offsetRangeJs.OffsetRange)(start.offset1, endExclusive.offset1), new (0, _offsetRangeJs.OffsetRange)(start.offset2, endExclusive.offset2));
    }
    static assertSorted(sequenceDiffs) {
        let last = undefined;
        for (const cur of sequenceDiffs){
            if (last) {
                if (!(last.seq1Range.endExclusive <= cur.seq1Range.start && last.seq2Range.endExclusive <= cur.seq2Range.start)) throw new (0, _errorsJs.BugIndicatingError)("Sequence diffs must be sorted");
            }
            last = cur;
        }
    }
    constructor(seq1Range, seq2Range){
        this.seq1Range = seq1Range;
        this.seq2Range = seq2Range;
    }
    swap() {
        return new SequenceDiff(this.seq2Range, this.seq1Range);
    }
    toString() {
        return `${this.seq1Range} <-> ${this.seq2Range}`;
    }
    join(other) {
        return new SequenceDiff(this.seq1Range.join(other.seq1Range), this.seq2Range.join(other.seq2Range));
    }
    delta(offset) {
        if (offset === 0) return this;
        return new SequenceDiff(this.seq1Range.delta(offset), this.seq2Range.delta(offset));
    }
    deltaStart(offset) {
        if (offset === 0) return this;
        return new SequenceDiff(this.seq1Range.deltaStart(offset), this.seq2Range.deltaStart(offset));
    }
    deltaEnd(offset) {
        if (offset === 0) return this;
        return new SequenceDiff(this.seq1Range.deltaEnd(offset), this.seq2Range.deltaEnd(offset));
    }
    intersect(other) {
        const i1 = this.seq1Range.intersect(other.seq1Range);
        const i2 = this.seq2Range.intersect(other.seq2Range);
        if (!i1 || !i2) return undefined;
        return new SequenceDiff(i1, i2);
    }
    getStarts() {
        return new OffsetPair(this.seq1Range.start, this.seq2Range.start);
    }
    getEndExclusives() {
        return new OffsetPair(this.seq1Range.endExclusive, this.seq2Range.endExclusive);
    }
}
class OffsetPair {
    static{
        this.zero = new OffsetPair(0, 0);
    }
    static{
        this.max = new OffsetPair(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
    }
    constructor(offset1, offset2){
        this.offset1 = offset1;
        this.offset2 = offset2;
    }
    toString() {
        return `${this.offset1} <-> ${this.offset2}`;
    }
    delta(offset) {
        if (offset === 0) return this;
        return new OffsetPair(this.offset1 + offset, this.offset2 + offset);
    }
    equals(other) {
        return this.offset1 === other.offset1 && this.offset2 === other.offset2;
    }
}
class InfiniteTimeout {
    static{
        this.instance = new InfiniteTimeout();
    }
    isValid() {
        return true;
    }
}
class DateTimeout {
    constructor(timeout){
        this.timeout = timeout;
        this.startTime = Date.now();
        this.valid = true;
        if (timeout <= 0) throw new (0, _errorsJs.BugIndicatingError)("timeout must be positive");
    }
    // Recommendation: Set a log-point `{this.disable()}` in the body
    isValid() {
        const valid = Date.now() - this.startTime < this.timeout;
        if (!valid && this.valid) {
            this.valid = false; // timeout reached
            // eslint-disable-next-line no-debugger
            debugger; // WARNING: Most likely debugging caused the timeout. Call `this.disable()` to continue without timing out.
        }
        return this.valid;
    }
}

},{"../../../../../base/common/arrays.js":"DECei","../../../../../base/common/errors.js":"divX8","../../../core/offsetRange.js":"ifHXk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aisSa":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A O(MN) diffing algorithm that supports a score function.
 * The algorithm can be improved by processing the 2d array diagonally.
*/ parcelHelpers.export(exports, "DynamicProgrammingDiffing", ()=>DynamicProgrammingDiffing);
var _offsetRangeJs = require("../../../core/offsetRange.js");
var _diffAlgorithmJs = require("./diffAlgorithm.js");
var _utilsJs = require("../utils.js");
class DynamicProgrammingDiffing {
    compute(sequence1, sequence2, timeout = (0, _diffAlgorithmJs.InfiniteTimeout).instance, equalityScore) {
        if (sequence1.length === 0 || sequence2.length === 0) return (0, _diffAlgorithmJs.DiffAlgorithmResult).trivial(sequence1, sequence2);
        /**
         * lcsLengths.get(i, j): Length of the longest common subsequence of sequence1.substring(0, i + 1) and sequence2.substring(0, j + 1).
         */ const lcsLengths = new (0, _utilsJs.Array2D)(sequence1.length, sequence2.length);
        const directions = new (0, _utilsJs.Array2D)(sequence1.length, sequence2.length);
        const lengths = new (0, _utilsJs.Array2D)(sequence1.length, sequence2.length);
        // ==== Initializing lcsLengths ====
        for(let s1 = 0; s1 < sequence1.length; s1++)for(let s2 = 0; s2 < sequence2.length; s2++){
            if (!timeout.isValid()) return (0, _diffAlgorithmJs.DiffAlgorithmResult).trivialTimedOut(sequence1, sequence2);
            const horizontalLen = s1 === 0 ? 0 : lcsLengths.get(s1 - 1, s2);
            const verticalLen = s2 === 0 ? 0 : lcsLengths.get(s1, s2 - 1);
            let extendedSeqScore;
            if (sequence1.getElement(s1) === sequence2.getElement(s2)) {
                if (s1 === 0 || s2 === 0) extendedSeqScore = 0;
                else extendedSeqScore = lcsLengths.get(s1 - 1, s2 - 1);
                if (s1 > 0 && s2 > 0 && directions.get(s1 - 1, s2 - 1) === 3) // Prefer consecutive diagonals
                extendedSeqScore += lengths.get(s1 - 1, s2 - 1);
                extendedSeqScore += equalityScore ? equalityScore(s1, s2) : 1;
            } else extendedSeqScore = -1;
            const newValue = Math.max(horizontalLen, verticalLen, extendedSeqScore);
            if (newValue === extendedSeqScore) {
                // Prefer diagonals
                const prevLen = s1 > 0 && s2 > 0 ? lengths.get(s1 - 1, s2 - 1) : 0;
                lengths.set(s1, s2, prevLen + 1);
                directions.set(s1, s2, 3);
            } else if (newValue === horizontalLen) {
                lengths.set(s1, s2, 0);
                directions.set(s1, s2, 1);
            } else if (newValue === verticalLen) {
                lengths.set(s1, s2, 0);
                directions.set(s1, s2, 2);
            }
            lcsLengths.set(s1, s2, newValue);
        }
        // ==== Backtracking ====
        const result = [];
        let lastAligningPosS1 = sequence1.length;
        let lastAligningPosS2 = sequence2.length;
        function reportDecreasingAligningPositions(s1, s2) {
            if (s1 + 1 !== lastAligningPosS1 || s2 + 1 !== lastAligningPosS2) result.push(new (0, _diffAlgorithmJs.SequenceDiff)(new (0, _offsetRangeJs.OffsetRange)(s1 + 1, lastAligningPosS1), new (0, _offsetRangeJs.OffsetRange)(s2 + 1, lastAligningPosS2)));
            lastAligningPosS1 = s1;
            lastAligningPosS2 = s2;
        }
        let s1 = sequence1.length - 1;
        let s2 = sequence2.length - 1;
        while(s1 >= 0 && s2 >= 0){
            if (directions.get(s1, s2) === 3) {
                reportDecreasingAligningPositions(s1, s2);
                s1--;
                s2--;
            } else if (directions.get(s1, s2) === 1) s1--;
            else s2--;
        }
        reportDecreasingAligningPositions(-1, -1);
        result.reverse();
        return new (0, _diffAlgorithmJs.DiffAlgorithmResult)(result, false);
    }
}

},{"../../../core/offsetRange.js":"ifHXk","./diffAlgorithm.js":"dKr4S","../utils.js":"buhKg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"buhKg":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Array2D", ()=>Array2D);
parcelHelpers.export(exports, "isSpace", ()=>isSpace);
parcelHelpers.export(exports, "LineRangeFragment", ()=>LineRangeFragment);
class Array2D {
    constructor(width, height){
        this.width = width;
        this.height = height;
        this.array = [];
        this.array = new Array(width * height);
    }
    get(x, y) {
        return this.array[x + y * this.width];
    }
    set(x, y, value) {
        this.array[x + y * this.width] = value;
    }
}
function isSpace(charCode) {
    return charCode === 32 /* CharCode.Space */  || charCode === 9 /* CharCode.Tab */ ;
}
class LineRangeFragment {
    static{
        this.chrKeys = new Map();
    }
    static getKey(chr) {
        let key = this.chrKeys.get(chr);
        if (key === undefined) {
            key = this.chrKeys.size;
            this.chrKeys.set(chr, key);
        }
        return key;
    }
    constructor(range, lines, source){
        this.range = range;
        this.lines = lines;
        this.source = source;
        this.histogram = [];
        let counter = 0;
        for(let i = range.startLineNumber - 1; i < range.endLineNumberExclusive - 1; i++){
            const line = lines[i];
            for(let j = 0; j < line.length; j++){
                counter++;
                const chr = line[j];
                const key = LineRangeFragment.getKey(chr);
                this.histogram[key] = (this.histogram[key] || 0) + 1;
            }
            counter++;
            const key = LineRangeFragment.getKey("\n");
            this.histogram[key] = (this.histogram[key] || 0) + 1;
        }
        this.totalCount = counter;
    }
    computeSimilarity(other) {
        let sumDifferences = 0;
        const maxLength = Math.max(this.histogram.length, other.histogram.length);
        for(let i = 0; i < maxLength; i++)sumDifferences += Math.abs((this.histogram[i] ?? 0) - (other.histogram[i] ?? 0));
        return 1 - sumDifferences / (this.totalCount + other.totalCount);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cArRr":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An O(ND) diff algorithm that has a quadratic space worst-case complexity.
*/ parcelHelpers.export(exports, "MyersDiffAlgorithm", ()=>MyersDiffAlgorithm);
var _offsetRangeJs = require("../../../core/offsetRange.js");
var _diffAlgorithmJs = require("./diffAlgorithm.js");
class MyersDiffAlgorithm {
    compute(seq1, seq2, timeout = (0, _diffAlgorithmJs.InfiniteTimeout).instance) {
        // These are common special cases.
        // The early return improves performance dramatically.
        if (seq1.length === 0 || seq2.length === 0) return (0, _diffAlgorithmJs.DiffAlgorithmResult).trivial(seq1, seq2);
        const seqX = seq1; // Text on the x axis
        const seqY = seq2; // Text on the y axis
        function getXAfterSnake(x, y) {
            while(x < seqX.length && y < seqY.length && seqX.getElement(x) === seqY.getElement(y)){
                x++;
                y++;
            }
            return x;
        }
        let d = 0;
        // V[k]: X value of longest d-line that ends in diagonal k.
        // d-line: path from (0,0) to (x,y) that uses exactly d non-diagonals.
        // diagonal k: Set of points (x,y) with x-y = k.
        // k=1 -> (1,0),(2,1)
        const V = new FastInt32Array();
        V.set(0, getXAfterSnake(0, 0));
        const paths = new FastArrayNegativeIndices();
        paths.set(0, V.get(0) === 0 ? null : new SnakePath(null, 0, 0, V.get(0)));
        let k = 0;
        loop: while(true){
            d++;
            if (!timeout.isValid()) return (0, _diffAlgorithmJs.DiffAlgorithmResult).trivialTimedOut(seqX, seqY);
            // The paper has `for (k = -d; k <= d; k += 2)`, but we can ignore diagonals that cannot influence the result.
            const lowerBound = -Math.min(d, seqY.length + d % 2);
            const upperBound = Math.min(d, seqX.length + d % 2);
            for(k = lowerBound; k <= upperBound; k += 2){
                let step = 0;
                // We can use the X values of (d-1)-lines to compute X value of the longest d-lines.
                const maxXofDLineTop = k === upperBound ? -1 : V.get(k + 1); // We take a vertical non-diagonal (add a symbol in seqX)
                const maxXofDLineLeft = k === lowerBound ? -1 : V.get(k - 1) + 1; // We take a horizontal non-diagonal (+1 x) (delete a symbol in seqX)
                step++;
                const x = Math.min(Math.max(maxXofDLineTop, maxXofDLineLeft), seqX.length);
                const y = x - k;
                step++;
                if (x > seqX.length || y > seqY.length) continue;
                const newMaxX = getXAfterSnake(x, y);
                V.set(k, newMaxX);
                const lastPath = x === maxXofDLineTop ? paths.get(k + 1) : paths.get(k - 1);
                paths.set(k, newMaxX !== x ? new SnakePath(lastPath, x, y, newMaxX - x) : lastPath);
                if (V.get(k) === seqX.length && V.get(k) - k === seqY.length) break loop;
            }
        }
        let path = paths.get(k);
        const result = [];
        let lastAligningPosS1 = seqX.length;
        let lastAligningPosS2 = seqY.length;
        while(true){
            const endX = path ? path.x + path.length : 0;
            const endY = path ? path.y + path.length : 0;
            if (endX !== lastAligningPosS1 || endY !== lastAligningPosS2) result.push(new (0, _diffAlgorithmJs.SequenceDiff)(new (0, _offsetRangeJs.OffsetRange)(endX, lastAligningPosS1), new (0, _offsetRangeJs.OffsetRange)(endY, lastAligningPosS2)));
            if (!path) break;
            lastAligningPosS1 = path.x;
            lastAligningPosS2 = path.y;
            path = path.prev;
        }
        result.reverse();
        return new (0, _diffAlgorithmJs.DiffAlgorithmResult)(result, false);
    }
}
class SnakePath {
    constructor(prev, x, y, length){
        this.prev = prev;
        this.x = x;
        this.y = y;
        this.length = length;
    }
}
/**
 * An array that supports fast negative indices.
*/ class FastInt32Array {
    constructor(){
        this.positiveArr = new Int32Array(10);
        this.negativeArr = new Int32Array(10);
    }
    get(idx) {
        if (idx < 0) {
            idx = -idx - 1;
            return this.negativeArr[idx];
        } else return this.positiveArr[idx];
    }
    set(idx, value) {
        if (idx < 0) {
            idx = -idx - 1;
            if (idx >= this.negativeArr.length) {
                const arr = this.negativeArr;
                this.negativeArr = new Int32Array(arr.length * 2);
                this.negativeArr.set(arr);
            }
            this.negativeArr[idx] = value;
        } else {
            if (idx >= this.positiveArr.length) {
                const arr = this.positiveArr;
                this.positiveArr = new Int32Array(arr.length * 2);
                this.positiveArr.set(arr);
            }
            this.positiveArr[idx] = value;
        }
    }
}
/**
 * An array that supports fast negative indices.
*/ class FastArrayNegativeIndices {
    constructor(){
        this.positiveArr = [];
        this.negativeArr = [];
    }
    get(idx) {
        if (idx < 0) {
            idx = -idx - 1;
            return this.negativeArr[idx];
        } else return this.positiveArr[idx];
    }
    set(idx, value) {
        if (idx < 0) {
            idx = -idx - 1;
            this.negativeArr[idx] = value;
        } else this.positiveArr[idx] = value;
    }
}

},{"../../../core/offsetRange.js":"ifHXk","./diffAlgorithm.js":"dKr4S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"11f6B":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "computeMovedLines", ()=>computeMovedLines);
var _diffAlgorithmJs = require("./algorithms/diffAlgorithm.js");
var _rangeMappingJs = require("../rangeMapping.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _arraysFindJs = require("../../../../base/common/arraysFind.js");
var _mapJs = require("../../../../base/common/map.js");
var _lineRangeJs = require("../../core/lineRange.js");
var _linesSliceCharSequenceJs = require("./linesSliceCharSequence.js");
var _utilsJs = require("./utils.js");
var _myersDiffAlgorithmJs = require("./algorithms/myersDiffAlgorithm.js");
var _rangeJs = require("../../core/range.js");
function computeMovedLines(changes, originalLines, modifiedLines, hashedOriginalLines, hashedModifiedLines, timeout) {
    let { moves, excludedChanges } = computeMovesFromSimpleDeletionsToSimpleInsertions(changes, originalLines, modifiedLines, timeout);
    if (!timeout.isValid()) return [];
    const filteredChanges = changes.filter((c)=>!excludedChanges.has(c));
    const unchangedMoves = computeUnchangedMoves(filteredChanges, hashedOriginalLines, hashedModifiedLines, originalLines, modifiedLines, timeout);
    (0, _arraysJs.pushMany)(moves, unchangedMoves);
    moves = joinCloseConsecutiveMoves(moves);
    // Ignore too short moves
    moves = moves.filter((current)=>{
        const lines = current.original.toOffsetRange().slice(originalLines).map((l)=>l.trim());
        const originalText = lines.join("\n");
        return originalText.length >= 15 && countWhere(lines, (l)=>l.length >= 2) >= 2;
    });
    moves = removeMovesInSameDiff(changes, moves);
    return moves;
}
function countWhere(arr, predicate) {
    let count = 0;
    for (const t of arr)if (predicate(t)) count++;
    return count;
}
function computeMovesFromSimpleDeletionsToSimpleInsertions(changes, originalLines, modifiedLines, timeout) {
    const moves = [];
    const deletions = changes.filter((c)=>c.modified.isEmpty && c.original.length >= 3).map((d)=>new (0, _utilsJs.LineRangeFragment)(d.original, originalLines, d));
    const insertions = new Set(changes.filter((c)=>c.original.isEmpty && c.modified.length >= 3).map((d)=>new (0, _utilsJs.LineRangeFragment)(d.modified, modifiedLines, d)));
    const excludedChanges = new Set();
    for (const deletion of deletions){
        let highestSimilarity = -1;
        let best;
        for (const insertion of insertions){
            const similarity = deletion.computeSimilarity(insertion);
            if (similarity > highestSimilarity) {
                highestSimilarity = similarity;
                best = insertion;
            }
        }
        if (highestSimilarity > 0.90 && best) {
            insertions.delete(best);
            moves.push(new (0, _rangeMappingJs.LineRangeMapping)(deletion.range, best.range));
            excludedChanges.add(deletion.source);
            excludedChanges.add(best.source);
        }
        if (!timeout.isValid()) return {
            moves,
            excludedChanges
        };
    }
    return {
        moves,
        excludedChanges
    };
}
function computeUnchangedMoves(changes, hashedOriginalLines, hashedModifiedLines, originalLines, modifiedLines, timeout) {
    const moves = [];
    const original3LineHashes = new (0, _mapJs.SetMap)();
    for (const change of changes)for(let i = change.original.startLineNumber; i < change.original.endLineNumberExclusive - 2; i++){
        const key = `${hashedOriginalLines[i - 1]}:${hashedOriginalLines[i + 1 - 1]}:${hashedOriginalLines[i + 2 - 1]}`;
        original3LineHashes.add(key, {
            range: new (0, _lineRangeJs.LineRange)(i, i + 3)
        });
    }
    const possibleMappings = [];
    changes.sort((0, _arraysJs.compareBy)((c)=>c.modified.startLineNumber, (0, _arraysJs.numberComparator)));
    for (const change of changes){
        let lastMappings = [];
        for(let i = change.modified.startLineNumber; i < change.modified.endLineNumberExclusive - 2; i++){
            const key = `${hashedModifiedLines[i - 1]}:${hashedModifiedLines[i + 1 - 1]}:${hashedModifiedLines[i + 2 - 1]}`;
            const currentModifiedRange = new (0, _lineRangeJs.LineRange)(i, i + 3);
            const nextMappings = [];
            original3LineHashes.forEach(key, ({ range })=>{
                for (const lastMapping of lastMappings)// does this match extend some last match?
                if (lastMapping.originalLineRange.endLineNumberExclusive + 1 === range.endLineNumberExclusive && lastMapping.modifiedLineRange.endLineNumberExclusive + 1 === currentModifiedRange.endLineNumberExclusive) {
                    lastMapping.originalLineRange = new (0, _lineRangeJs.LineRange)(lastMapping.originalLineRange.startLineNumber, range.endLineNumberExclusive);
                    lastMapping.modifiedLineRange = new (0, _lineRangeJs.LineRange)(lastMapping.modifiedLineRange.startLineNumber, currentModifiedRange.endLineNumberExclusive);
                    nextMappings.push(lastMapping);
                    return;
                }
                const mapping = {
                    modifiedLineRange: currentModifiedRange,
                    originalLineRange: range
                };
                possibleMappings.push(mapping);
                nextMappings.push(mapping);
            });
            lastMappings = nextMappings;
        }
        if (!timeout.isValid()) return [];
    }
    possibleMappings.sort((0, _arraysJs.reverseOrder)((0, _arraysJs.compareBy)((m)=>m.modifiedLineRange.length, (0, _arraysJs.numberComparator))));
    const modifiedSet = new (0, _lineRangeJs.LineRangeSet)();
    const originalSet = new (0, _lineRangeJs.LineRangeSet)();
    for (const mapping of possibleMappings){
        const diffOrigToMod = mapping.modifiedLineRange.startLineNumber - mapping.originalLineRange.startLineNumber;
        const modifiedSections = modifiedSet.subtractFrom(mapping.modifiedLineRange);
        const originalTranslatedSections = originalSet.subtractFrom(mapping.originalLineRange).getWithDelta(diffOrigToMod);
        const modifiedIntersectedSections = modifiedSections.getIntersection(originalTranslatedSections);
        for (const s of modifiedIntersectedSections.ranges){
            if (s.length < 3) continue;
            const modifiedLineRange = s;
            const originalLineRange = s.delta(-diffOrigToMod);
            moves.push(new (0, _rangeMappingJs.LineRangeMapping)(originalLineRange, modifiedLineRange));
            modifiedSet.addRange(modifiedLineRange);
            originalSet.addRange(originalLineRange);
        }
    }
    moves.sort((0, _arraysJs.compareBy)((m)=>m.original.startLineNumber, (0, _arraysJs.numberComparator)));
    const monotonousChanges = new (0, _arraysFindJs.MonotonousArray)(changes);
    for(let i = 0; i < moves.length; i++){
        const move = moves[i];
        const firstTouchingChangeOrig = monotonousChanges.findLastMonotonous((c)=>c.original.startLineNumber <= move.original.startLineNumber);
        const firstTouchingChangeMod = (0, _arraysFindJs.findLastMonotonous)(changes, (c)=>c.modified.startLineNumber <= move.modified.startLineNumber);
        const linesAbove = Math.max(move.original.startLineNumber - firstTouchingChangeOrig.original.startLineNumber, move.modified.startLineNumber - firstTouchingChangeMod.modified.startLineNumber);
        const lastTouchingChangeOrig = monotonousChanges.findLastMonotonous((c)=>c.original.startLineNumber < move.original.endLineNumberExclusive);
        const lastTouchingChangeMod = (0, _arraysFindJs.findLastMonotonous)(changes, (c)=>c.modified.startLineNumber < move.modified.endLineNumberExclusive);
        const linesBelow = Math.max(lastTouchingChangeOrig.original.endLineNumberExclusive - move.original.endLineNumberExclusive, lastTouchingChangeMod.modified.endLineNumberExclusive - move.modified.endLineNumberExclusive);
        let extendToTop;
        for(extendToTop = 0; extendToTop < linesAbove; extendToTop++){
            const origLine = move.original.startLineNumber - extendToTop - 1;
            const modLine = move.modified.startLineNumber - extendToTop - 1;
            if (origLine > originalLines.length || modLine > modifiedLines.length) break;
            if (modifiedSet.contains(modLine) || originalSet.contains(origLine)) break;
            if (!areLinesSimilar(originalLines[origLine - 1], modifiedLines[modLine - 1], timeout)) break;
        }
        if (extendToTop > 0) {
            originalSet.addRange(new (0, _lineRangeJs.LineRange)(move.original.startLineNumber - extendToTop, move.original.startLineNumber));
            modifiedSet.addRange(new (0, _lineRangeJs.LineRange)(move.modified.startLineNumber - extendToTop, move.modified.startLineNumber));
        }
        let extendToBottom;
        for(extendToBottom = 0; extendToBottom < linesBelow; extendToBottom++){
            const origLine = move.original.endLineNumberExclusive + extendToBottom;
            const modLine = move.modified.endLineNumberExclusive + extendToBottom;
            if (origLine > originalLines.length || modLine > modifiedLines.length) break;
            if (modifiedSet.contains(modLine) || originalSet.contains(origLine)) break;
            if (!areLinesSimilar(originalLines[origLine - 1], modifiedLines[modLine - 1], timeout)) break;
        }
        if (extendToBottom > 0) {
            originalSet.addRange(new (0, _lineRangeJs.LineRange)(move.original.endLineNumberExclusive, move.original.endLineNumberExclusive + extendToBottom));
            modifiedSet.addRange(new (0, _lineRangeJs.LineRange)(move.modified.endLineNumberExclusive, move.modified.endLineNumberExclusive + extendToBottom));
        }
        if (extendToTop > 0 || extendToBottom > 0) moves[i] = new (0, _rangeMappingJs.LineRangeMapping)(new (0, _lineRangeJs.LineRange)(move.original.startLineNumber - extendToTop, move.original.endLineNumberExclusive + extendToBottom), new (0, _lineRangeJs.LineRange)(move.modified.startLineNumber - extendToTop, move.modified.endLineNumberExclusive + extendToBottom));
    }
    return moves;
}
function areLinesSimilar(line1, line2, timeout) {
    if (line1.trim() === line2.trim()) return true;
    if (line1.length > 300 && line2.length > 300) return false;
    const myersDiffingAlgorithm = new (0, _myersDiffAlgorithmJs.MyersDiffAlgorithm)();
    const result = myersDiffingAlgorithm.compute(new (0, _linesSliceCharSequenceJs.LinesSliceCharSequence)([
        line1
    ], new (0, _rangeJs.Range)(1, 1, 1, line1.length), false), new (0, _linesSliceCharSequenceJs.LinesSliceCharSequence)([
        line2
    ], new (0, _rangeJs.Range)(1, 1, 1, line2.length), false), timeout);
    let commonNonSpaceCharCount = 0;
    const inverted = (0, _diffAlgorithmJs.SequenceDiff).invert(result.diffs, line1.length);
    for (const seq of inverted)seq.seq1Range.forEach((idx)=>{
        if (!(0, _utilsJs.isSpace)(line1.charCodeAt(idx))) commonNonSpaceCharCount++;
    });
    function countNonWsChars(str) {
        let count = 0;
        for(let i = 0; i < line1.length; i++)if (!(0, _utilsJs.isSpace)(str.charCodeAt(i))) count++;
        return count;
    }
    const longerLineLength = countNonWsChars(line1.length > line2.length ? line1 : line2);
    const r = commonNonSpaceCharCount / longerLineLength > 0.6 && longerLineLength > 10;
    return r;
}
function joinCloseConsecutiveMoves(moves) {
    if (moves.length === 0) return moves;
    moves.sort((0, _arraysJs.compareBy)((m)=>m.original.startLineNumber, (0, _arraysJs.numberComparator)));
    const result = [
        moves[0]
    ];
    for(let i = 1; i < moves.length; i++){
        const last = result[result.length - 1];
        const current = moves[i];
        const originalDist = current.original.startLineNumber - last.original.endLineNumberExclusive;
        const modifiedDist = current.modified.startLineNumber - last.modified.endLineNumberExclusive;
        const currentMoveAfterLast = originalDist >= 0 && modifiedDist >= 0;
        if (currentMoveAfterLast && originalDist + modifiedDist <= 2) {
            result[result.length - 1] = last.join(current);
            continue;
        }
        result.push(current);
    }
    return result;
}
function removeMovesInSameDiff(changes, moves) {
    const changesMonotonous = new (0, _arraysFindJs.MonotonousArray)(changes);
    moves = moves.filter((m)=>{
        const diffBeforeEndOfMoveOriginal = changesMonotonous.findLastMonotonous((c)=>c.original.startLineNumber < m.original.endLineNumberExclusive) || new (0, _rangeMappingJs.LineRangeMapping)(new (0, _lineRangeJs.LineRange)(1, 1), new (0, _lineRangeJs.LineRange)(1, 1));
        const diffBeforeEndOfMoveModified = (0, _arraysFindJs.findLastMonotonous)(changes, (c)=>c.modified.startLineNumber < m.modified.endLineNumberExclusive);
        const differentDiffs = diffBeforeEndOfMoveOriginal !== diffBeforeEndOfMoveModified;
        return differentDiffs;
    });
    return moves;
}

},{"./algorithms/diffAlgorithm.js":"dKr4S","../rangeMapping.js":"7QuJJ","../../../../base/common/arrays.js":"DECei","../../../../base/common/arraysFind.js":"gWrU0","../../../../base/common/map.js":"leSjz","../../core/lineRange.js":"cmnMs","./linesSliceCharSequence.js":"3k42X","./utils.js":"buhKg","./algorithms/myersDiffAlgorithm.js":"cArRr","../../core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3k42X":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinesSliceCharSequence", ()=>LinesSliceCharSequence);
var _arraysFindJs = require("../../../../base/common/arraysFind.js");
var _offsetRangeJs = require("../../core/offsetRange.js");
var _positionJs = require("../../core/position.js");
var _rangeJs = require("../../core/range.js");
var _utilsJs = require("./utils.js");
class LinesSliceCharSequence {
    constructor(lines, range, considerWhitespaceChanges){
        this.lines = lines;
        this.range = range;
        this.considerWhitespaceChanges = considerWhitespaceChanges;
        this.elements = [];
        this.firstElementOffsetByLineIdx = [];
        this.lineStartOffsets = [];
        this.trimmedWsLengthsByLineIdx = [];
        this.firstElementOffsetByLineIdx.push(0);
        for(let lineNumber = this.range.startLineNumber; lineNumber <= this.range.endLineNumber; lineNumber++){
            let line = lines[lineNumber - 1];
            let lineStartOffset = 0;
            if (lineNumber === this.range.startLineNumber && this.range.startColumn > 1) {
                lineStartOffset = this.range.startColumn - 1;
                line = line.substring(lineStartOffset);
            }
            this.lineStartOffsets.push(lineStartOffset);
            let trimmedWsLength = 0;
            if (!considerWhitespaceChanges) {
                const trimmedStartLine = line.trimStart();
                trimmedWsLength = line.length - trimmedStartLine.length;
                line = trimmedStartLine.trimEnd();
            }
            this.trimmedWsLengthsByLineIdx.push(trimmedWsLength);
            const lineLength = lineNumber === this.range.endLineNumber ? Math.min(this.range.endColumn - 1 - lineStartOffset - trimmedWsLength, line.length) : line.length;
            for(let i = 0; i < lineLength; i++)this.elements.push(line.charCodeAt(i));
            if (lineNumber < this.range.endLineNumber) {
                this.elements.push("\n".charCodeAt(0));
                this.firstElementOffsetByLineIdx.push(this.elements.length);
            }
        }
    }
    toString() {
        return `Slice: "${this.text}"`;
    }
    get text() {
        return this.getText(new (0, _offsetRangeJs.OffsetRange)(0, this.length));
    }
    getText(range) {
        return this.elements.slice(range.start, range.endExclusive).map((e)=>String.fromCharCode(e)).join("");
    }
    getElement(offset) {
        return this.elements[offset];
    }
    get length() {
        return this.elements.length;
    }
    getBoundaryScore(length) {
        //   a   b   c   ,           d   e   f
        // 11  0   0   12  15  6   13  0   0   11
        const prevCategory = getCategory(length > 0 ? this.elements[length - 1] : -1);
        const nextCategory = getCategory(length < this.elements.length ? this.elements[length] : -1);
        if (prevCategory === 7 /* CharBoundaryCategory.LineBreakCR */  && nextCategory === 8 /* CharBoundaryCategory.LineBreakLF */ ) // don't break between \r and \n
        return 0;
        if (prevCategory === 8 /* CharBoundaryCategory.LineBreakLF */ ) // prefer the linebreak before the change
        return 150;
        let score = 0;
        if (prevCategory !== nextCategory) {
            score += 10;
            if (prevCategory === 0 /* CharBoundaryCategory.WordLower */  && nextCategory === 1 /* CharBoundaryCategory.WordUpper */ ) score += 1;
        }
        score += getCategoryBoundaryScore(prevCategory);
        score += getCategoryBoundaryScore(nextCategory);
        return score;
    }
    translateOffset(offset, preference = "right") {
        // find smallest i, so that lineBreakOffsets[i] <= offset using binary search
        const i = (0, _arraysFindJs.findLastIdxMonotonous)(this.firstElementOffsetByLineIdx, (value)=>value <= offset);
        const lineOffset = offset - this.firstElementOffsetByLineIdx[i];
        return new (0, _positionJs.Position)(this.range.startLineNumber + i, 1 + this.lineStartOffsets[i] + lineOffset + (lineOffset === 0 && preference === "left" ? 0 : this.trimmedWsLengthsByLineIdx[i]));
    }
    translateRange(range) {
        const pos1 = this.translateOffset(range.start, "right");
        const pos2 = this.translateOffset(range.endExclusive, "left");
        if (pos2.isBefore(pos1)) return (0, _rangeJs.Range).fromPositions(pos2, pos2);
        return (0, _rangeJs.Range).fromPositions(pos1, pos2);
    }
    /**
     * Finds the word that contains the character at the given offset
     */ findWordContaining(offset) {
        if (offset < 0 || offset >= this.elements.length) return undefined;
        if (!isWordChar(this.elements[offset])) return undefined;
        // find start
        let start = offset;
        while(start > 0 && isWordChar(this.elements[start - 1]))start--;
        // find end
        let end = offset;
        while(end < this.elements.length && isWordChar(this.elements[end]))end++;
        return new (0, _offsetRangeJs.OffsetRange)(start, end);
    }
    countLinesIn(range) {
        return this.translateOffset(range.endExclusive).lineNumber - this.translateOffset(range.start).lineNumber;
    }
    isStronglyEqual(offset1, offset2) {
        return this.elements[offset1] === this.elements[offset2];
    }
    extendToFullLines(range) {
        const start = (0, _arraysFindJs.findLastMonotonous)(this.firstElementOffsetByLineIdx, (x)=>x <= range.start) ?? 0;
        const end = (0, _arraysFindJs.findFirstMonotonous)(this.firstElementOffsetByLineIdx, (x)=>range.endExclusive <= x) ?? this.elements.length;
        return new (0, _offsetRangeJs.OffsetRange)(start, end);
    }
}
function isWordChar(charCode) {
    return charCode >= 97 /* CharCode.a */  && charCode <= 122 /* CharCode.z */  || charCode >= 65 /* CharCode.A */  && charCode <= 90 /* CharCode.Z */  || charCode >= 48 /* CharCode.Digit0 */  && charCode <= 57 /* CharCode.Digit9 */ ;
}
const score = {
    [0 /* CharBoundaryCategory.WordLower */ ]: 0,
    [1 /* CharBoundaryCategory.WordUpper */ ]: 0,
    [2 /* CharBoundaryCategory.WordNumber */ ]: 0,
    [3 /* CharBoundaryCategory.End */ ]: 10,
    [4 /* CharBoundaryCategory.Other */ ]: 2,
    [5 /* CharBoundaryCategory.Separator */ ]: 30,
    [6 /* CharBoundaryCategory.Space */ ]: 3,
    [7 /* CharBoundaryCategory.LineBreakCR */ ]: 10,
    [8 /* CharBoundaryCategory.LineBreakLF */ ]: 10
};
function getCategoryBoundaryScore(category) {
    return score[category];
}
function getCategory(charCode) {
    if (charCode === 10 /* CharCode.LineFeed */ ) return 8 /* CharBoundaryCategory.LineBreakLF */ ;
    else if (charCode === 13 /* CharCode.CarriageReturn */ ) return 7 /* CharBoundaryCategory.LineBreakCR */ ;
    else if ((0, _utilsJs.isSpace)(charCode)) return 6 /* CharBoundaryCategory.Space */ ;
    else if (charCode >= 97 /* CharCode.a */  && charCode <= 122 /* CharCode.z */ ) return 0 /* CharBoundaryCategory.WordLower */ ;
    else if (charCode >= 65 /* CharCode.A */  && charCode <= 90 /* CharCode.Z */ ) return 1 /* CharBoundaryCategory.WordUpper */ ;
    else if (charCode >= 48 /* CharCode.Digit0 */  && charCode <= 57 /* CharCode.Digit9 */ ) return 2 /* CharBoundaryCategory.WordNumber */ ;
    else if (charCode === -1) return 3 /* CharBoundaryCategory.End */ ;
    else if (charCode === 44 /* CharCode.Comma */  || charCode === 59 /* CharCode.Semicolon */ ) return 5 /* CharBoundaryCategory.Separator */ ;
    else return 4 /* CharBoundaryCategory.Other */ ;
}

},{"../../../../base/common/arraysFind.js":"gWrU0","../../core/offsetRange.js":"ifHXk","../../core/position.js":"lvrPe","../../core/range.js":"jmUPh","./utils.js":"buhKg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eLKvQ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optimizeSequenceDiffs", ()=>optimizeSequenceDiffs);
parcelHelpers.export(exports, "removeShortMatches", ()=>removeShortMatches);
parcelHelpers.export(exports, "extendDiffsToEntireWordIfAppropriate", ()=>extendDiffsToEntireWordIfAppropriate);
parcelHelpers.export(exports, "removeVeryShortMatchingLinesBetweenDiffs", ()=>removeVeryShortMatchingLinesBetweenDiffs);
parcelHelpers.export(exports, "removeVeryShortMatchingTextBetweenLongDiffs", ()=>removeVeryShortMatchingTextBetweenLongDiffs);
var _arraysJs = require("../../../../base/common/arrays.js");
var _offsetRangeJs = require("../../core/offsetRange.js");
var _diffAlgorithmJs = require("./algorithms/diffAlgorithm.js");
function optimizeSequenceDiffs(sequence1, sequence2, sequenceDiffs) {
    let result = sequenceDiffs;
    result = joinSequenceDiffsByShifting(sequence1, sequence2, result);
    // Sometimes, calling this function twice improves the result.
    // Uncomment the second invocation and run the tests to see the difference.
    result = joinSequenceDiffsByShifting(sequence1, sequence2, result);
    result = shiftSequenceDiffs(sequence1, sequence2, result);
    return result;
}
/**
 * This function fixes issues like this:
 * ```
 * import { Baz, Bar } from "foo";
 * ```
 * <->
 * ```
 * import { Baz, Bar, Foo } from "foo";
 * ```
 * Computed diff: [ {Add "," after Bar}, {Add "Foo " after space} }
 * Improved diff: [{Add ", Foo" after Bar}]
 */ function joinSequenceDiffsByShifting(sequence1, sequence2, sequenceDiffs) {
    if (sequenceDiffs.length === 0) return sequenceDiffs;
    const result = [];
    result.push(sequenceDiffs[0]);
    // First move them all to the left as much as possible and join them if possible
    for(let i = 1; i < sequenceDiffs.length; i++){
        const prevResult = result[result.length - 1];
        let cur = sequenceDiffs[i];
        if (cur.seq1Range.isEmpty || cur.seq2Range.isEmpty) {
            const length = cur.seq1Range.start - prevResult.seq1Range.endExclusive;
            let d;
            for(d = 1; d <= length; d++){
                if (sequence1.getElement(cur.seq1Range.start - d) !== sequence1.getElement(cur.seq1Range.endExclusive - d) || sequence2.getElement(cur.seq2Range.start - d) !== sequence2.getElement(cur.seq2Range.endExclusive - d)) break;
            }
            d--;
            if (d === length) {
                // Merge previous and current diff
                result[result.length - 1] = new (0, _diffAlgorithmJs.SequenceDiff)(new (0, _offsetRangeJs.OffsetRange)(prevResult.seq1Range.start, cur.seq1Range.endExclusive - length), new (0, _offsetRangeJs.OffsetRange)(prevResult.seq2Range.start, cur.seq2Range.endExclusive - length));
                continue;
            }
            cur = cur.delta(-d);
        }
        result.push(cur);
    }
    const result2 = [];
    // Then move them all to the right and join them again if possible
    for(let i = 0; i < result.length - 1; i++){
        const nextResult = result[i + 1];
        let cur = result[i];
        if (cur.seq1Range.isEmpty || cur.seq2Range.isEmpty) {
            const length = nextResult.seq1Range.start - cur.seq1Range.endExclusive;
            let d;
            for(d = 0; d < length; d++){
                if (!sequence1.isStronglyEqual(cur.seq1Range.start + d, cur.seq1Range.endExclusive + d) || !sequence2.isStronglyEqual(cur.seq2Range.start + d, cur.seq2Range.endExclusive + d)) break;
            }
            if (d === length) {
                // Merge previous and current diff, write to result!
                result[i + 1] = new (0, _diffAlgorithmJs.SequenceDiff)(new (0, _offsetRangeJs.OffsetRange)(cur.seq1Range.start + length, nextResult.seq1Range.endExclusive), new (0, _offsetRangeJs.OffsetRange)(cur.seq2Range.start + length, nextResult.seq2Range.endExclusive));
                continue;
            }
            if (d > 0) cur = cur.delta(d);
        }
        result2.push(cur);
    }
    if (result.length > 0) result2.push(result[result.length - 1]);
    return result2;
}
// align character level diffs at whitespace characters
// import { IBar } from "foo";
// import { I[Arr, I]Bar } from "foo";
// ->
// import { [IArr, ]IBar } from "foo";
// import { ITransaction, observableValue, transaction } from 'vs/base/common/observable';
// import { ITransaction, observable[FromEvent, observable]Value, transaction } from 'vs/base/common/observable';
// ->
// import { ITransaction, [observableFromEvent, ]observableValue, transaction } from 'vs/base/common/observable';
// collectBrackets(level + 1, levelPerBracketType);
// collectBrackets(level + 1, levelPerBracket[ + 1, levelPerBracket]Type);
// ->
// collectBrackets(level + 1, [levelPerBracket + 1, ]levelPerBracketType);
function shiftSequenceDiffs(sequence1, sequence2, sequenceDiffs) {
    if (!sequence1.getBoundaryScore || !sequence2.getBoundaryScore) return sequenceDiffs;
    for(let i = 0; i < sequenceDiffs.length; i++){
        const prevDiff = i > 0 ? sequenceDiffs[i - 1] : undefined;
        const diff = sequenceDiffs[i];
        const nextDiff = i + 1 < sequenceDiffs.length ? sequenceDiffs[i + 1] : undefined;
        const seq1ValidRange = new (0, _offsetRangeJs.OffsetRange)(prevDiff ? prevDiff.seq1Range.endExclusive + 1 : 0, nextDiff ? nextDiff.seq1Range.start - 1 : sequence1.length);
        const seq2ValidRange = new (0, _offsetRangeJs.OffsetRange)(prevDiff ? prevDiff.seq2Range.endExclusive + 1 : 0, nextDiff ? nextDiff.seq2Range.start - 1 : sequence2.length);
        if (diff.seq1Range.isEmpty) sequenceDiffs[i] = shiftDiffToBetterPosition(diff, sequence1, sequence2, seq1ValidRange, seq2ValidRange);
        else if (diff.seq2Range.isEmpty) sequenceDiffs[i] = shiftDiffToBetterPosition(diff.swap(), sequence2, sequence1, seq2ValidRange, seq1ValidRange).swap();
    }
    return sequenceDiffs;
}
function shiftDiffToBetterPosition(diff, sequence1, sequence2, seq1ValidRange, seq2ValidRange) {
    const maxShiftLimit = 100; // To prevent performance issues
    // don't touch previous or next!
    let deltaBefore = 1;
    while(diff.seq1Range.start - deltaBefore >= seq1ValidRange.start && diff.seq2Range.start - deltaBefore >= seq2ValidRange.start && sequence2.isStronglyEqual(diff.seq2Range.start - deltaBefore, diff.seq2Range.endExclusive - deltaBefore) && deltaBefore < maxShiftLimit)deltaBefore++;
    deltaBefore--;
    let deltaAfter = 0;
    while(diff.seq1Range.start + deltaAfter < seq1ValidRange.endExclusive && diff.seq2Range.endExclusive + deltaAfter < seq2ValidRange.endExclusive && sequence2.isStronglyEqual(diff.seq2Range.start + deltaAfter, diff.seq2Range.endExclusive + deltaAfter) && deltaAfter < maxShiftLimit)deltaAfter++;
    if (deltaBefore === 0 && deltaAfter === 0) return diff;
    // Visualize `[sequence1.text, diff.seq1Range.start + deltaAfter]`
    // and `[sequence2.text, diff.seq2Range.start + deltaAfter, diff.seq2Range.endExclusive + deltaAfter]`
    let bestDelta = 0;
    let bestScore = -1;
    // find best scored delta
    for(let delta = -deltaBefore; delta <= deltaAfter; delta++){
        const seq2OffsetStart = diff.seq2Range.start + delta;
        const seq2OffsetEndExclusive = diff.seq2Range.endExclusive + delta;
        const seq1Offset = diff.seq1Range.start + delta;
        const score = sequence1.getBoundaryScore(seq1Offset) + sequence2.getBoundaryScore(seq2OffsetStart) + sequence2.getBoundaryScore(seq2OffsetEndExclusive);
        if (score > bestScore) {
            bestScore = score;
            bestDelta = delta;
        }
    }
    return diff.delta(bestDelta);
}
function removeShortMatches(sequence1, sequence2, sequenceDiffs) {
    const result = [];
    for (const s of sequenceDiffs){
        const last = result[result.length - 1];
        if (!last) {
            result.push(s);
            continue;
        }
        if (s.seq1Range.start - last.seq1Range.endExclusive <= 2 || s.seq2Range.start - last.seq2Range.endExclusive <= 2) result[result.length - 1] = new (0, _diffAlgorithmJs.SequenceDiff)(last.seq1Range.join(s.seq1Range), last.seq2Range.join(s.seq2Range));
        else result.push(s);
    }
    return result;
}
function extendDiffsToEntireWordIfAppropriate(sequence1, sequence2, sequenceDiffs) {
    const equalMappings = (0, _diffAlgorithmJs.SequenceDiff).invert(sequenceDiffs, sequence1.length);
    const additional = [];
    let lastPoint = new (0, _diffAlgorithmJs.OffsetPair)(0, 0);
    function scanWord(pair, equalMapping) {
        if (pair.offset1 < lastPoint.offset1 || pair.offset2 < lastPoint.offset2) return;
        const w1 = sequence1.findWordContaining(pair.offset1);
        const w2 = sequence2.findWordContaining(pair.offset2);
        if (!w1 || !w2) return;
        let w = new (0, _diffAlgorithmJs.SequenceDiff)(w1, w2);
        const equalPart = w.intersect(equalMapping);
        let equalChars1 = equalPart.seq1Range.length;
        let equalChars2 = equalPart.seq2Range.length;
        // The words do not touch previous equals mappings, as we would have processed them already.
        // But they might touch the next ones.
        while(equalMappings.length > 0){
            const next = equalMappings[0];
            const intersects = next.seq1Range.intersects(w.seq1Range) || next.seq2Range.intersects(w.seq2Range);
            if (!intersects) break;
            const v1 = sequence1.findWordContaining(next.seq1Range.start);
            const v2 = sequence2.findWordContaining(next.seq2Range.start);
            // Because there is an intersection, we know that the words are not empty.
            const v = new (0, _diffAlgorithmJs.SequenceDiff)(v1, v2);
            const equalPart = v.intersect(next);
            equalChars1 += equalPart.seq1Range.length;
            equalChars2 += equalPart.seq2Range.length;
            w = w.join(v);
            if (w.seq1Range.endExclusive >= next.seq1Range.endExclusive) // The word extends beyond the next equal mapping.
            equalMappings.shift();
            else break;
        }
        if (equalChars1 + equalChars2 < (w.seq1Range.length + w.seq2Range.length) * 2 / 3) additional.push(w);
        lastPoint = w.getEndExclusives();
    }
    while(equalMappings.length > 0){
        const next = equalMappings.shift();
        if (next.seq1Range.isEmpty) continue;
        scanWord(next.getStarts(), next);
        // The equal parts are not empty, so -1 gives us a character that is equal in both parts.
        scanWord(next.getEndExclusives().delta(-1), next);
    }
    const merged = mergeSequenceDiffs(sequenceDiffs, additional);
    return merged;
}
function mergeSequenceDiffs(sequenceDiffs1, sequenceDiffs2) {
    const result = [];
    while(sequenceDiffs1.length > 0 || sequenceDiffs2.length > 0){
        const sd1 = sequenceDiffs1[0];
        const sd2 = sequenceDiffs2[0];
        let next;
        if (sd1 && (!sd2 || sd1.seq1Range.start < sd2.seq1Range.start)) next = sequenceDiffs1.shift();
        else next = sequenceDiffs2.shift();
        if (result.length > 0 && result[result.length - 1].seq1Range.endExclusive >= next.seq1Range.start) result[result.length - 1] = result[result.length - 1].join(next);
        else result.push(next);
    }
    return result;
}
function removeVeryShortMatchingLinesBetweenDiffs(sequence1, _sequence2, sequenceDiffs) {
    let diffs = sequenceDiffs;
    if (diffs.length === 0) return diffs;
    let counter = 0;
    let shouldRepeat;
    do {
        shouldRepeat = false;
        const result = [
            diffs[0]
        ];
        for(let i = 1; i < diffs.length; i++){
            const cur = diffs[i];
            const lastResult = result[result.length - 1];
            function shouldJoinDiffs(before, after) {
                const unchangedRange = new (0, _offsetRangeJs.OffsetRange)(lastResult.seq1Range.endExclusive, cur.seq1Range.start);
                const unchangedText = sequence1.getText(unchangedRange);
                const unchangedTextWithoutWs = unchangedText.replace(/\s/g, "");
                if (unchangedTextWithoutWs.length <= 4 && (before.seq1Range.length + before.seq2Range.length > 5 || after.seq1Range.length + after.seq2Range.length > 5)) return true;
                return false;
            }
            const shouldJoin = shouldJoinDiffs(lastResult, cur);
            if (shouldJoin) {
                shouldRepeat = true;
                result[result.length - 1] = result[result.length - 1].join(cur);
            } else result.push(cur);
        }
        diffs = result;
    }while (counter++ < 10 && shouldRepeat);
    return diffs;
}
function removeVeryShortMatchingTextBetweenLongDiffs(sequence1, sequence2, sequenceDiffs) {
    let diffs = sequenceDiffs;
    if (diffs.length === 0) return diffs;
    let counter = 0;
    let shouldRepeat;
    do {
        shouldRepeat = false;
        const result = [
            diffs[0]
        ];
        for(let i = 1; i < diffs.length; i++){
            const cur = diffs[i];
            const lastResult = result[result.length - 1];
            function shouldJoinDiffs(before, after) {
                const unchangedRange = new (0, _offsetRangeJs.OffsetRange)(lastResult.seq1Range.endExclusive, cur.seq1Range.start);
                const unchangedLineCount = sequence1.countLinesIn(unchangedRange);
                if (unchangedLineCount > 5 || unchangedRange.length > 500) return false;
                const unchangedText = sequence1.getText(unchangedRange).trim();
                if (unchangedText.length > 20 || unchangedText.split(/\r\n|\r|\n/).length > 1) return false;
                const beforeLineCount1 = sequence1.countLinesIn(before.seq1Range);
                const beforeSeq1Length = before.seq1Range.length;
                const beforeLineCount2 = sequence2.countLinesIn(before.seq2Range);
                const beforeSeq2Length = before.seq2Range.length;
                const afterLineCount1 = sequence1.countLinesIn(after.seq1Range);
                const afterSeq1Length = after.seq1Range.length;
                const afterLineCount2 = sequence2.countLinesIn(after.seq2Range);
                const afterSeq2Length = after.seq2Range.length;
                // TODO: Maybe a neural net can be used to derive the result from these numbers
                const max = 130;
                function cap(v) {
                    return Math.min(v, max);
                }
                if (Math.pow(Math.pow(cap(beforeLineCount1 * 40 + beforeSeq1Length), 1.5) + Math.pow(cap(beforeLineCount2 * 40 + beforeSeq2Length), 1.5), 1.5) + Math.pow(Math.pow(cap(afterLineCount1 * 40 + afterSeq1Length), 1.5) + Math.pow(cap(afterLineCount2 * 40 + afterSeq2Length), 1.5), 1.5) > (max ** 1.5) ** 1.5 * 1.3) return true;
                return false;
            }
            const shouldJoin = shouldJoinDiffs(lastResult, cur);
            if (shouldJoin) {
                shouldRepeat = true;
                result[result.length - 1] = result[result.length - 1].join(cur);
            } else result.push(cur);
        }
        diffs = result;
    }while (counter++ < 10 && shouldRepeat);
    const newDiffs = [];
    // Remove short suffixes/prefixes
    (0, _arraysJs.forEachWithNeighbors)(diffs, (prev, cur, next)=>{
        let newDiff = cur;
        function shouldMarkAsChanged(text) {
            return text.length > 0 && text.trim().length <= 3 && cur.seq1Range.length + cur.seq2Range.length > 100;
        }
        const fullRange1 = sequence1.extendToFullLines(cur.seq1Range);
        const prefix = sequence1.getText(new (0, _offsetRangeJs.OffsetRange)(fullRange1.start, cur.seq1Range.start));
        if (shouldMarkAsChanged(prefix)) newDiff = newDiff.deltaStart(-prefix.length);
        const suffix = sequence1.getText(new (0, _offsetRangeJs.OffsetRange)(cur.seq1Range.endExclusive, fullRange1.endExclusive));
        if (shouldMarkAsChanged(suffix)) newDiff = newDiff.deltaEnd(suffix.length);
        const availableSpace = (0, _diffAlgorithmJs.SequenceDiff).fromOffsetPairs(prev ? prev.getEndExclusives() : (0, _diffAlgorithmJs.OffsetPair).zero, next ? next.getStarts() : (0, _diffAlgorithmJs.OffsetPair).max);
        const result = newDiff.intersect(availableSpace);
        if (newDiffs.length > 0 && result.getStarts().equals(newDiffs[newDiffs.length - 1].getEndExclusives())) newDiffs[newDiffs.length - 1] = newDiffs[newDiffs.length - 1].join(result);
        else newDiffs.push(result);
    });
    return newDiffs;
}

},{"../../../../base/common/arrays.js":"DECei","../../core/offsetRange.js":"ifHXk","./algorithms/diffAlgorithm.js":"dKr4S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"abvKv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineSequence", ()=>LineSequence);
class LineSequence {
    constructor(trimmedHash, lines){
        this.trimmedHash = trimmedHash;
        this.lines = lines;
    }
    getElement(offset) {
        return this.trimmedHash[offset];
    }
    get length() {
        return this.trimmedHash.length;
    }
    getBoundaryScore(length) {
        const indentationBefore = length === 0 ? 0 : getIndentation(this.lines[length - 1]);
        const indentationAfter = length === this.lines.length ? 0 : getIndentation(this.lines[length]);
        return 1000 - (indentationBefore + indentationAfter);
    }
    getText(range) {
        return this.lines.slice(range.start, range.endExclusive).join("\n");
    }
    isStronglyEqual(offset1, offset2) {
        return this.lines[offset1] === this.lines[offset2];
    }
}
function getIndentation(str) {
    let i = 0;
    while(i < str.length && (str.charCodeAt(i) === 32 /* CharCode.Space */  || str.charCodeAt(i) === 9 /* CharCode.Tab */ ))i++;
    return i;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j46B3":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns an array of all default document colors in the provided document
 */ parcelHelpers.export(exports, "computeDefaultDocumentColors", ()=>computeDefaultDocumentColors);
var _colorJs = require("../../../base/common/color.js");
function _parseCaptureGroups(captureGroups) {
    const values = [];
    for (const captureGroup of captureGroups){
        const parsedNumber = Number(captureGroup);
        if (parsedNumber || parsedNumber === 0 && captureGroup.replace(/\s/g, "") !== "") values.push(parsedNumber);
    }
    return values;
}
function _toIColor(r, g, b, a) {
    return {
        red: r / 255,
        blue: b / 255,
        green: g / 255,
        alpha: a
    };
}
function _findRange(model, match) {
    const index = match.index;
    const length = match[0].length;
    if (!index) return;
    const startPosition = model.positionAt(index);
    const range = {
        startLineNumber: startPosition.lineNumber,
        startColumn: startPosition.column,
        endLineNumber: startPosition.lineNumber,
        endColumn: startPosition.column + length
    };
    return range;
}
function _findHexColorInformation(range, hexValue) {
    if (!range) return;
    const parsedHexColor = (0, _colorJs.Color).Format.CSS.parseHex(hexValue);
    if (!parsedHexColor) return;
    return {
        range: range,
        color: _toIColor(parsedHexColor.rgba.r, parsedHexColor.rgba.g, parsedHexColor.rgba.b, parsedHexColor.rgba.a)
    };
}
function _findRGBColorInformation(range, matches, isAlpha) {
    if (!range || matches.length !== 1) return;
    const match = matches[0];
    const captureGroups = match.values();
    const parsedRegex = _parseCaptureGroups(captureGroups);
    return {
        range: range,
        color: _toIColor(parsedRegex[0], parsedRegex[1], parsedRegex[2], isAlpha ? parsedRegex[3] : 1)
    };
}
function _findHSLColorInformation(range, matches, isAlpha) {
    if (!range || matches.length !== 1) return;
    const match = matches[0];
    const captureGroups = match.values();
    const parsedRegex = _parseCaptureGroups(captureGroups);
    const colorEquivalent = new (0, _colorJs.Color)(new (0, _colorJs.HSLA)(parsedRegex[0], parsedRegex[1] / 100, parsedRegex[2] / 100, isAlpha ? parsedRegex[3] : 1));
    return {
        range: range,
        color: _toIColor(colorEquivalent.rgba.r, colorEquivalent.rgba.g, colorEquivalent.rgba.b, colorEquivalent.rgba.a)
    };
}
function _findMatches(model, regex) {
    if (typeof model === "string") return [
        ...model.matchAll(regex)
    ];
    else return model.findMatches(regex);
}
function computeColors(model) {
    const result = [];
    // Early validation for RGB and HSL
    const initialValidationRegex = /\b(rgb|rgba|hsl|hsla)(\([0-9\s,.\%]*\))|(#)([A-Fa-f0-9]{3})\b|(#)([A-Fa-f0-9]{4})\b|(#)([A-Fa-f0-9]{6})\b|(#)([A-Fa-f0-9]{8})\b/gm;
    const initialValidationMatches = _findMatches(model, initialValidationRegex);
    // Potential colors have been found, validate the parameters
    if (initialValidationMatches.length > 0) for (const initialMatch of initialValidationMatches){
        const initialCaptureGroups = initialMatch.filter((captureGroup)=>captureGroup !== undefined);
        const colorScheme = initialCaptureGroups[1];
        const colorParameters = initialCaptureGroups[2];
        if (!colorParameters) continue;
        let colorInformation;
        if (colorScheme === "rgb") {
            const regexParameters = /^\(\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*\)$/gm;
            colorInformation = _findRGBColorInformation(_findRange(model, initialMatch), _findMatches(colorParameters, regexParameters), false);
        } else if (colorScheme === "rgba") {
            const regexParameters = /^\(\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(0[.][0-9]+|[.][0-9]+|[01][.]|[01])\s*\)$/gm;
            colorInformation = _findRGBColorInformation(_findRange(model, initialMatch), _findMatches(colorParameters, regexParameters), true);
        } else if (colorScheme === "hsl") {
            const regexParameters = /^\(\s*(36[0]|3[0-5][0-9]|[12][0-9][0-9]|[1-9]?[0-9])\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*\)$/gm;
            colorInformation = _findHSLColorInformation(_findRange(model, initialMatch), _findMatches(colorParameters, regexParameters), false);
        } else if (colorScheme === "hsla") {
            const regexParameters = /^\(\s*(36[0]|3[0-5][0-9]|[12][0-9][0-9]|[1-9]?[0-9])\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(0[.][0-9]+|[.][0-9]+|[01][.]|[01])\s*\)$/gm;
            colorInformation = _findHSLColorInformation(_findRange(model, initialMatch), _findMatches(colorParameters, regexParameters), true);
        } else if (colorScheme === "#") colorInformation = _findHexColorInformation(_findRange(model, initialMatch), colorScheme + colorParameters);
        if (colorInformation) result.push(colorInformation);
    }
    return result;
}
function computeDefaultDocumentColors(model) {
    if (!model || typeof model.getValue !== "function" || typeof model.positionAt !== "function") // Unknown caller!
    return [];
    return computeColors(model);
}

},{"../../../base/common/color.js":"at4gb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"at4gb":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RGBA", ()=>RGBA);
parcelHelpers.export(exports, "HSLA", ()=>HSLA);
parcelHelpers.export(exports, "HSVA", ()=>HSVA);
parcelHelpers.export(exports, "Color", ()=>Color);
function roundFloat(number, decimalPoints) {
    const decimal = Math.pow(10, decimalPoints);
    return Math.round(number * decimal) / decimal;
}
class RGBA {
    constructor(r, g, b, a = 1){
        this._rgbaBrand = undefined;
        this.r = Math.min(255, Math.max(0, r)) | 0;
        this.g = Math.min(255, Math.max(0, g)) | 0;
        this.b = Math.min(255, Math.max(0, b)) | 0;
        this.a = roundFloat(Math.max(Math.min(1, a), 0), 3);
    }
    static equals(a, b) {
        return a.r === b.r && a.g === b.g && a.b === b.b && a.a === b.a;
    }
}
class HSLA {
    constructor(h, s, l, a){
        this._hslaBrand = undefined;
        this.h = Math.max(Math.min(360, h), 0) | 0;
        this.s = roundFloat(Math.max(Math.min(1, s), 0), 3);
        this.l = roundFloat(Math.max(Math.min(1, l), 0), 3);
        this.a = roundFloat(Math.max(Math.min(1, a), 0), 3);
    }
    static equals(a, b) {
        return a.h === b.h && a.s === b.s && a.l === b.l && a.a === b.a;
    }
    /**
     * Converts an RGB color value to HSL. Conversion formula
     * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
     * Assumes r, g, and b are contained in the set [0, 255] and
     * returns h in the set [0, 360], s, and l in the set [0, 1].
     */ static fromRGBA(rgba) {
        const r = rgba.r / 255;
        const g = rgba.g / 255;
        const b = rgba.b / 255;
        const a = rgba.a;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let h = 0;
        let s = 0;
        const l = (min + max) / 2;
        const chroma = max - min;
        if (chroma > 0) {
            s = Math.min(l <= 0.5 ? chroma / (2 * l) : chroma / (2 - 2 * l), 1);
            switch(max){
                case r:
                    h = (g - b) / chroma + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / chroma + 2;
                    break;
                case b:
                    h = (r - g) / chroma + 4;
                    break;
            }
            h *= 60;
            h = Math.round(h);
        }
        return new HSLA(h, s, l, a);
    }
    static _hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    /**
     * Converts an HSL color value to RGB. Conversion formula
     * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
     * Assumes h in the set [0, 360] s, and l are contained in the set [0, 1] and
     * returns r, g, and b in the set [0, 255].
     */ static toRGBA(hsla) {
        const h = hsla.h / 360;
        const { s, l, a } = hsla;
        let r, g, b;
        if (s === 0) r = g = b = l; // achromatic
        else {
            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;
            r = HSLA._hue2rgb(p, q, h + 1 / 3);
            g = HSLA._hue2rgb(p, q, h);
            b = HSLA._hue2rgb(p, q, h - 1 / 3);
        }
        return new RGBA(Math.round(r * 255), Math.round(g * 255), Math.round(b * 255), a);
    }
}
class HSVA {
    constructor(h, s, v, a){
        this._hsvaBrand = undefined;
        this.h = Math.max(Math.min(360, h), 0) | 0;
        this.s = roundFloat(Math.max(Math.min(1, s), 0), 3);
        this.v = roundFloat(Math.max(Math.min(1, v), 0), 3);
        this.a = roundFloat(Math.max(Math.min(1, a), 0), 3);
    }
    static equals(a, b) {
        return a.h === b.h && a.s === b.s && a.v === b.v && a.a === b.a;
    }
    // from http://www.rapidtables.com/convert/color/rgb-to-hsv.htm
    static fromRGBA(rgba) {
        const r = rgba.r / 255;
        const g = rgba.g / 255;
        const b = rgba.b / 255;
        const cmax = Math.max(r, g, b);
        const cmin = Math.min(r, g, b);
        const delta = cmax - cmin;
        const s = cmax === 0 ? 0 : delta / cmax;
        let m;
        if (delta === 0) m = 0;
        else if (cmax === r) m = ((g - b) / delta % 6 + 6) % 6;
        else if (cmax === g) m = (b - r) / delta + 2;
        else m = (r - g) / delta + 4;
        return new HSVA(Math.round(m * 60), s, cmax, rgba.a);
    }
    // from http://www.rapidtables.com/convert/color/hsv-to-rgb.htm
    static toRGBA(hsva) {
        const { h, s, v, a } = hsva;
        const c = v * s;
        const x = c * (1 - Math.abs(h / 60 % 2 - 1));
        const m = v - c;
        let [r, g, b] = [
            0,
            0,
            0
        ];
        if (h < 60) {
            r = c;
            g = x;
        } else if (h < 120) {
            r = x;
            g = c;
        } else if (h < 180) {
            g = c;
            b = x;
        } else if (h < 240) {
            g = x;
            b = c;
        } else if (h < 300) {
            r = x;
            b = c;
        } else if (h <= 360) {
            r = c;
            b = x;
        }
        r = Math.round((r + m) * 255);
        g = Math.round((g + m) * 255);
        b = Math.round((b + m) * 255);
        return new RGBA(r, g, b, a);
    }
}
class Color {
    static fromHex(hex) {
        return Color.Format.CSS.parseHex(hex) || Color.red;
    }
    static equals(a, b) {
        if (!a && !b) return true;
        if (!a || !b) return false;
        return a.equals(b);
    }
    get hsla() {
        if (this._hsla) return this._hsla;
        else return HSLA.fromRGBA(this.rgba);
    }
    get hsva() {
        if (this._hsva) return this._hsva;
        return HSVA.fromRGBA(this.rgba);
    }
    constructor(arg){
        if (!arg) throw new Error("Color needs a value");
        else if (arg instanceof RGBA) this.rgba = arg;
        else if (arg instanceof HSLA) {
            this._hsla = arg;
            this.rgba = HSLA.toRGBA(arg);
        } else if (arg instanceof HSVA) {
            this._hsva = arg;
            this.rgba = HSVA.toRGBA(arg);
        } else throw new Error("Invalid color ctor argument");
    }
    equals(other) {
        return !!other && RGBA.equals(this.rgba, other.rgba) && HSLA.equals(this.hsla, other.hsla) && HSVA.equals(this.hsva, other.hsva);
    }
    /**
     * http://www.w3.org/TR/WCAG20/#relativeluminancedef
     * Returns the number in the set [0, 1]. O => Darkest Black. 1 => Lightest white.
     */ getRelativeLuminance() {
        const R = Color._relativeLuminanceForComponent(this.rgba.r);
        const G = Color._relativeLuminanceForComponent(this.rgba.g);
        const B = Color._relativeLuminanceForComponent(this.rgba.b);
        const luminance = 0.2126 * R + 0.7152 * G + 0.0722 * B;
        return roundFloat(luminance, 4);
    }
    static _relativeLuminanceForComponent(color) {
        const c = color / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    }
    /**
     *	http://24ways.org/2010/calculating-color-contrast
     *  Return 'true' if lighter color otherwise 'false'
     */ isLighter() {
        const yiq = (this.rgba.r * 299 + this.rgba.g * 587 + this.rgba.b * 114) / 1000;
        return yiq >= 128;
    }
    isLighterThan(another) {
        const lum1 = this.getRelativeLuminance();
        const lum2 = another.getRelativeLuminance();
        return lum1 > lum2;
    }
    isDarkerThan(another) {
        const lum1 = this.getRelativeLuminance();
        const lum2 = another.getRelativeLuminance();
        return lum1 < lum2;
    }
    lighten(factor) {
        return new Color(new HSLA(this.hsla.h, this.hsla.s, this.hsla.l + this.hsla.l * factor, this.hsla.a));
    }
    darken(factor) {
        return new Color(new HSLA(this.hsla.h, this.hsla.s, this.hsla.l - this.hsla.l * factor, this.hsla.a));
    }
    transparent(factor) {
        const { r, g, b, a } = this.rgba;
        return new Color(new RGBA(r, g, b, a * factor));
    }
    isTransparent() {
        return this.rgba.a === 0;
    }
    isOpaque() {
        return this.rgba.a === 1;
    }
    opposite() {
        return new Color(new RGBA(255 - this.rgba.r, 255 - this.rgba.g, 255 - this.rgba.b, this.rgba.a));
    }
    makeOpaque(opaqueBackground) {
        if (this.isOpaque() || opaqueBackground.rgba.a !== 1) // only allow to blend onto a non-opaque color onto a opaque color
        return this;
        const { r, g, b, a } = this.rgba;
        // https://stackoverflow.com/questions/12228548/finding-equivalent-color-with-opacity
        return new Color(new RGBA(opaqueBackground.rgba.r - a * (opaqueBackground.rgba.r - r), opaqueBackground.rgba.g - a * (opaqueBackground.rgba.g - g), opaqueBackground.rgba.b - a * (opaqueBackground.rgba.b - b), 1));
    }
    toString() {
        if (!this._toString) this._toString = Color.Format.CSS.format(this);
        return this._toString;
    }
    static getLighterColor(of, relative, factor) {
        if (of.isLighterThan(relative)) return of;
        factor = factor ? factor : 0.5;
        const lum1 = of.getRelativeLuminance();
        const lum2 = relative.getRelativeLuminance();
        factor = factor * (lum2 - lum1) / lum2;
        return of.lighten(factor);
    }
    static getDarkerColor(of, relative, factor) {
        if (of.isDarkerThan(relative)) return of;
        factor = factor ? factor : 0.5;
        const lum1 = of.getRelativeLuminance();
        const lum2 = relative.getRelativeLuminance();
        factor = factor * (lum1 - lum2) / lum1;
        return of.darken(factor);
    }
    static{
        this.white = new Color(new RGBA(255, 255, 255, 1));
    }
    static{
        this.black = new Color(new RGBA(0, 0, 0, 1));
    }
    static{
        this.red = new Color(new RGBA(255, 0, 0, 1));
    }
    static{
        this.blue = new Color(new RGBA(0, 0, 255, 1));
    }
    static{
        this.green = new Color(new RGBA(0, 255, 0, 1));
    }
    static{
        this.cyan = new Color(new RGBA(0, 255, 255, 1));
    }
    static{
        this.lightgrey = new Color(new RGBA(211, 211, 211, 1));
    }
    static{
        this.transparent = new Color(new RGBA(0, 0, 0, 0));
    }
}
(function(Color) {
    let Format;
    (function(Format) {
        let CSS;
        (function(CSS) {
            function formatRGB(color) {
                if (color.rgba.a === 1) return `rgb(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b})`;
                return Color.Format.CSS.formatRGBA(color);
            }
            CSS.formatRGB = formatRGB;
            function formatRGBA(color) {
                return `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${+color.rgba.a.toFixed(2)})`;
            }
            CSS.formatRGBA = formatRGBA;
            function formatHSL(color) {
                if (color.hsla.a === 1) return `hsl(${color.hsla.h}, ${(color.hsla.s * 100).toFixed(2)}%, ${(color.hsla.l * 100).toFixed(2)}%)`;
                return Color.Format.CSS.formatHSLA(color);
            }
            CSS.formatHSL = formatHSL;
            function formatHSLA(color) {
                return `hsla(${color.hsla.h}, ${(color.hsla.s * 100).toFixed(2)}%, ${(color.hsla.l * 100).toFixed(2)}%, ${color.hsla.a.toFixed(2)})`;
            }
            CSS.formatHSLA = formatHSLA;
            function _toTwoDigitHex(n) {
                const r = n.toString(16);
                return r.length !== 2 ? "0" + r : r;
            }
            /**
             * Formats the color as #RRGGBB
             */ function formatHex(color) {
                return `#${_toTwoDigitHex(color.rgba.r)}${_toTwoDigitHex(color.rgba.g)}${_toTwoDigitHex(color.rgba.b)}`;
            }
            CSS.formatHex = formatHex;
            /**
             * Formats the color as #RRGGBBAA
             * If 'compact' is set, colors without transparancy will be printed as #RRGGBB
             */ function formatHexA(color, compact = false) {
                if (compact && color.rgba.a === 1) return Color.Format.CSS.formatHex(color);
                return `#${_toTwoDigitHex(color.rgba.r)}${_toTwoDigitHex(color.rgba.g)}${_toTwoDigitHex(color.rgba.b)}${_toTwoDigitHex(Math.round(color.rgba.a * 255))}`;
            }
            CSS.formatHexA = formatHexA;
            /**
             * The default format will use HEX if opaque and RGBA otherwise.
             */ function format(color) {
                if (color.isOpaque()) return Color.Format.CSS.formatHex(color);
                return Color.Format.CSS.formatRGBA(color);
            }
            CSS.format = format;
            /**
             * Converts an Hex color value to a Color.
             * returns r, g, and b are contained in the set [0, 255]
             * @param hex string (#RGB, #RGBA, #RRGGBB or #RRGGBBAA).
             */ function parseHex(hex) {
                const length = hex.length;
                if (length === 0) // Invalid color
                return null;
                if (hex.charCodeAt(0) !== 35 /* CharCode.Hash */ ) // Does not begin with a #
                return null;
                if (length === 7) {
                    // #RRGGBB format
                    const r = 16 * _parseHexDigit(hex.charCodeAt(1)) + _parseHexDigit(hex.charCodeAt(2));
                    const g = 16 * _parseHexDigit(hex.charCodeAt(3)) + _parseHexDigit(hex.charCodeAt(4));
                    const b = 16 * _parseHexDigit(hex.charCodeAt(5)) + _parseHexDigit(hex.charCodeAt(6));
                    return new Color(new RGBA(r, g, b, 1));
                }
                if (length === 9) {
                    // #RRGGBBAA format
                    const r = 16 * _parseHexDigit(hex.charCodeAt(1)) + _parseHexDigit(hex.charCodeAt(2));
                    const g = 16 * _parseHexDigit(hex.charCodeAt(3)) + _parseHexDigit(hex.charCodeAt(4));
                    const b = 16 * _parseHexDigit(hex.charCodeAt(5)) + _parseHexDigit(hex.charCodeAt(6));
                    const a = 16 * _parseHexDigit(hex.charCodeAt(7)) + _parseHexDigit(hex.charCodeAt(8));
                    return new Color(new RGBA(r, g, b, a / 255));
                }
                if (length === 4) {
                    // #RGB format
                    const r = _parseHexDigit(hex.charCodeAt(1));
                    const g = _parseHexDigit(hex.charCodeAt(2));
                    const b = _parseHexDigit(hex.charCodeAt(3));
                    return new Color(new RGBA(16 * r + r, 16 * g + g, 16 * b + b));
                }
                if (length === 5) {
                    // #RGBA format
                    const r = _parseHexDigit(hex.charCodeAt(1));
                    const g = _parseHexDigit(hex.charCodeAt(2));
                    const b = _parseHexDigit(hex.charCodeAt(3));
                    const a = _parseHexDigit(hex.charCodeAt(4));
                    return new Color(new RGBA(16 * r + r, 16 * g + g, 16 * b + b, (16 * a + a) / 255));
                }
                // Invalid color
                return null;
            }
            CSS.parseHex = parseHex;
            function _parseHexDigit(charCode) {
                switch(charCode){
                    case 48 /* CharCode.Digit0 */ :
                        return 0;
                    case 49 /* CharCode.Digit1 */ :
                        return 1;
                    case 50 /* CharCode.Digit2 */ :
                        return 2;
                    case 51 /* CharCode.Digit3 */ :
                        return 3;
                    case 52 /* CharCode.Digit4 */ :
                        return 4;
                    case 53 /* CharCode.Digit5 */ :
                        return 5;
                    case 54 /* CharCode.Digit6 */ :
                        return 6;
                    case 55 /* CharCode.Digit7 */ :
                        return 7;
                    case 56 /* CharCode.Digit8 */ :
                        return 8;
                    case 57 /* CharCode.Digit9 */ :
                        return 9;
                    case 97 /* CharCode.a */ :
                        return 10;
                    case 65 /* CharCode.A */ :
                        return 10;
                    case 98 /* CharCode.b */ :
                        return 11;
                    case 66 /* CharCode.B */ :
                        return 11;
                    case 99 /* CharCode.c */ :
                        return 12;
                    case 67 /* CharCode.C */ :
                        return 12;
                    case 100 /* CharCode.d */ :
                        return 13;
                    case 68 /* CharCode.D */ :
                        return 13;
                    case 101 /* CharCode.e */ :
                        return 14;
                    case 69 /* CharCode.E */ :
                        return 14;
                    case 102 /* CharCode.f */ :
                        return 15;
                    case 70 /* CharCode.F */ :
                        return 15;
                }
                return 0;
            }
        })(CSS = Format.CSS || (Format.CSS = {}));
    })(Format = Color.Format || (Color.Format = {}));
})(Color || (Color = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cpN9z":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Find section headers in the model.
 *
 * @param model the text model to search in
 * @param options options to search with
 * @returns an array of section headers
 */ parcelHelpers.export(exports, "findSectionHeaders", ()=>findSectionHeaders);
const markRegex = new RegExp("\\bMARK:\\s*(.*)$", "d");
const trimDashesRegex = /^-+|-+$/g;
function findSectionHeaders(model, options) {
    let headers = [];
    if (options.findRegionSectionHeaders && options.foldingRules?.markers) {
        const regionHeaders = collectRegionHeaders(model, options);
        headers = headers.concat(regionHeaders);
    }
    if (options.findMarkSectionHeaders) {
        const markHeaders = collectMarkHeaders(model);
        headers = headers.concat(markHeaders);
    }
    return headers;
}
function collectRegionHeaders(model, options) {
    const regionHeaders = [];
    const endLineNumber = model.getLineCount();
    for(let lineNumber = 1; lineNumber <= endLineNumber; lineNumber++){
        const lineContent = model.getLineContent(lineNumber);
        const match = lineContent.match(options.foldingRules.markers.start);
        if (match) {
            const range = {
                startLineNumber: lineNumber,
                startColumn: match[0].length + 1,
                endLineNumber: lineNumber,
                endColumn: lineContent.length + 1
            };
            if (range.endColumn > range.startColumn) {
                const sectionHeader = {
                    range,
                    ...getHeaderText(lineContent.substring(match[0].length)),
                    shouldBeInComments: false
                };
                if (sectionHeader.text || sectionHeader.hasSeparatorLine) regionHeaders.push(sectionHeader);
            }
        }
    }
    return regionHeaders;
}
function collectMarkHeaders(model) {
    const markHeaders = [];
    const endLineNumber = model.getLineCount();
    for(let lineNumber = 1; lineNumber <= endLineNumber; lineNumber++){
        const lineContent = model.getLineContent(lineNumber);
        addMarkHeaderIfFound(lineContent, lineNumber, markHeaders);
    }
    return markHeaders;
}
function addMarkHeaderIfFound(lineContent, lineNumber, sectionHeaders) {
    markRegex.lastIndex = 0;
    const match = markRegex.exec(lineContent);
    if (match) {
        const column = match.indices[1][0] + 1;
        const endColumn = match.indices[1][1] + 1;
        const range = {
            startLineNumber: lineNumber,
            startColumn: column,
            endLineNumber: lineNumber,
            endColumn: endColumn
        };
        if (range.endColumn > range.startColumn) {
            const sectionHeader = {
                range,
                ...getHeaderText(match[1]),
                shouldBeInComments: true
            };
            if (sectionHeader.text || sectionHeader.hasSeparatorLine) sectionHeaders.push(sectionHeader);
        }
    }
}
function getHeaderText(text) {
    text = text.trim();
    const hasSeparatorLine = text.startsWith("-");
    text = text.replace(trimDashesRegex, "");
    return {
        text,
        hasSeparatorLine
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d5ZUa":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STOP_SYNC_MODEL_DELTA_TIME_MS", ()=>STOP_SYNC_MODEL_DELTA_TIME_MS);
parcelHelpers.export(exports, "WorkerTextModelSyncClient", ()=>WorkerTextModelSyncClient);
parcelHelpers.export(exports, "WorkerTextModelSyncServer", ()=>WorkerTextModelSyncServer);
parcelHelpers.export(exports, "MirrorModel", ()=>MirrorModel);
var _asyncJs = require("../../../../base/common/async.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _uriJs = require("../../../../base/common/uri.js");
var _positionJs = require("../../core/position.js");
var _rangeJs = require("../../core/range.js");
var _wordHelperJs = require("../../core/wordHelper.js");
var _mirrorTextModelJs = require("../../model/mirrorTextModel.js");
const STOP_SYNC_MODEL_DELTA_TIME_MS = 60000;
class WorkerTextModelSyncClient extends (0, _lifecycleJs.Disposable) {
    constructor(proxy, modelService, keepIdleModels = false){
        super();
        this._syncedModels = Object.create(null);
        this._syncedModelsLastUsedTime = Object.create(null);
        this._proxy = proxy;
        this._modelService = modelService;
        if (!keepIdleModels) {
            const timer = new (0, _asyncJs.IntervalTimer)();
            timer.cancelAndSet(()=>this._checkStopModelSync(), Math.round(STOP_SYNC_MODEL_DELTA_TIME_MS / 2));
            this._register(timer);
        }
    }
    dispose() {
        for(const modelUrl in this._syncedModels)(0, _lifecycleJs.dispose)(this._syncedModels[modelUrl]);
        this._syncedModels = Object.create(null);
        this._syncedModelsLastUsedTime = Object.create(null);
        super.dispose();
    }
    ensureSyncedResources(resources, forceLargeModels = false) {
        for (const resource of resources){
            const resourceStr = resource.toString();
            if (!this._syncedModels[resourceStr]) this._beginModelSync(resource, forceLargeModels);
            if (this._syncedModels[resourceStr]) this._syncedModelsLastUsedTime[resourceStr] = new Date().getTime();
        }
    }
    _checkStopModelSync() {
        const currentTime = new Date().getTime();
        const toRemove = [];
        for(const modelUrl in this._syncedModelsLastUsedTime){
            const elapsedTime = currentTime - this._syncedModelsLastUsedTime[modelUrl];
            if (elapsedTime > STOP_SYNC_MODEL_DELTA_TIME_MS) toRemove.push(modelUrl);
        }
        for (const e of toRemove)this._stopModelSync(e);
    }
    _beginModelSync(resource, forceLargeModels) {
        const model = this._modelService.getModel(resource);
        if (!model) return;
        if (!forceLargeModels && model.isTooLargeForSyncing()) return;
        const modelUrl = resource.toString();
        this._proxy.$acceptNewModel({
            url: model.uri.toString(),
            lines: model.getLinesContent(),
            EOL: model.getEOL(),
            versionId: model.getVersionId()
        });
        const toDispose = new (0, _lifecycleJs.DisposableStore)();
        toDispose.add(model.onDidChangeContent((e)=>{
            this._proxy.$acceptModelChanged(modelUrl.toString(), e);
        }));
        toDispose.add(model.onWillDispose(()=>{
            this._stopModelSync(modelUrl);
        }));
        toDispose.add((0, _lifecycleJs.toDisposable)(()=>{
            this._proxy.$acceptRemovedModel(modelUrl);
        }));
        this._syncedModels[modelUrl] = toDispose;
    }
    _stopModelSync(modelUrl) {
        const toDispose = this._syncedModels[modelUrl];
        delete this._syncedModels[modelUrl];
        delete this._syncedModelsLastUsedTime[modelUrl];
        (0, _lifecycleJs.dispose)(toDispose);
    }
}
class WorkerTextModelSyncServer {
    constructor(){
        this._models = Object.create(null);
    }
    getModel(uri) {
        return this._models[uri];
    }
    getModels() {
        const all = [];
        Object.keys(this._models).forEach((key)=>all.push(this._models[key]));
        return all;
    }
    $acceptNewModel(data) {
        this._models[data.url] = new MirrorModel((0, _uriJs.URI).parse(data.url), data.lines, data.EOL, data.versionId);
    }
    $acceptModelChanged(uri, e) {
        if (!this._models[uri]) return;
        const model = this._models[uri];
        model.onEvents(e);
    }
    $acceptRemovedModel(uri) {
        if (!this._models[uri]) return;
        delete this._models[uri];
    }
}
class MirrorModel extends (0, _mirrorTextModelJs.MirrorTextModel) {
    get uri() {
        return this._uri;
    }
    get eol() {
        return this._eol;
    }
    getValue() {
        return this.getText();
    }
    findMatches(regex) {
        const matches = [];
        for(let i = 0; i < this._lines.length; i++){
            const line = this._lines[i];
            const offsetToAdd = this.offsetAt(new (0, _positionJs.Position)(i + 1, 1));
            const iteratorOverMatches = line.matchAll(regex);
            for (const match of iteratorOverMatches){
                if (match.index || match.index === 0) match.index = match.index + offsetToAdd;
                matches.push(match);
            }
        }
        return matches;
    }
    getLinesContent() {
        return this._lines.slice(0);
    }
    getLineCount() {
        return this._lines.length;
    }
    getLineContent(lineNumber) {
        return this._lines[lineNumber - 1];
    }
    getWordAtPosition(position, wordDefinition) {
        const wordAtText = (0, _wordHelperJs.getWordAtText)(position.column, (0, _wordHelperJs.ensureValidWordDefinition)(wordDefinition), this._lines[position.lineNumber - 1], 0);
        if (wordAtText) return new (0, _rangeJs.Range)(position.lineNumber, wordAtText.startColumn, position.lineNumber, wordAtText.endColumn);
        return null;
    }
    words(wordDefinition) {
        const lines = this._lines;
        const wordenize = this._wordenize.bind(this);
        let lineNumber = 0;
        let lineText = "";
        let wordRangesIdx = 0;
        let wordRanges = [];
        return {
            *[Symbol.iterator] () {
                while(true)if (wordRangesIdx < wordRanges.length) {
                    const value = lineText.substring(wordRanges[wordRangesIdx].start, wordRanges[wordRangesIdx].end);
                    wordRangesIdx += 1;
                    yield value;
                } else {
                    if (lineNumber < lines.length) {
                        lineText = lines[lineNumber];
                        wordRanges = wordenize(lineText, wordDefinition);
                        wordRangesIdx = 0;
                        lineNumber += 1;
                    } else break;
                }
            }
        };
    }
    getLineWords(lineNumber, wordDefinition) {
        const content = this._lines[lineNumber - 1];
        const ranges = this._wordenize(content, wordDefinition);
        const words = [];
        for (const range of ranges)words.push({
            word: content.substring(range.start, range.end),
            startColumn: range.start + 1,
            endColumn: range.end + 1
        });
        return words;
    }
    _wordenize(content, wordDefinition) {
        const result = [];
        let match;
        wordDefinition.lastIndex = 0; // reset lastIndex just to be sure
        while(match = wordDefinition.exec(content)){
            if (match[0].length === 0) break;
            result.push({
                start: match.index,
                end: match.index + match[0].length
            });
        }
        return result;
    }
    getValueInRange(range) {
        range = this._validateRange(range);
        if (range.startLineNumber === range.endLineNumber) return this._lines[range.startLineNumber - 1].substring(range.startColumn - 1, range.endColumn - 1);
        const lineEnding = this._eol;
        const startLineIndex = range.startLineNumber - 1;
        const endLineIndex = range.endLineNumber - 1;
        const resultLines = [];
        resultLines.push(this._lines[startLineIndex].substring(range.startColumn - 1));
        for(let i = startLineIndex + 1; i < endLineIndex; i++)resultLines.push(this._lines[i]);
        resultLines.push(this._lines[endLineIndex].substring(0, range.endColumn - 1));
        return resultLines.join(lineEnding);
    }
    offsetAt(position) {
        position = this._validatePosition(position);
        this._ensureLineStarts();
        return this._lineStarts.getPrefixSum(position.lineNumber - 2) + (position.column - 1);
    }
    positionAt(offset) {
        offset = Math.floor(offset);
        offset = Math.max(0, offset);
        this._ensureLineStarts();
        const out = this._lineStarts.getIndexOf(offset);
        const lineLength = this._lines[out.index].length;
        // Ensure we return a valid position
        return {
            lineNumber: 1 + out.index,
            column: 1 + Math.min(out.remainder, lineLength)
        };
    }
    _validateRange(range) {
        const start = this._validatePosition({
            lineNumber: range.startLineNumber,
            column: range.startColumn
        });
        const end = this._validatePosition({
            lineNumber: range.endLineNumber,
            column: range.endColumn
        });
        if (start.lineNumber !== range.startLineNumber || start.column !== range.startColumn || end.lineNumber !== range.endLineNumber || end.column !== range.endColumn) return {
            startLineNumber: start.lineNumber,
            startColumn: start.column,
            endLineNumber: end.lineNumber,
            endColumn: end.column
        };
        return range;
    }
    _validatePosition(position) {
        if (!(0, _positionJs.Position).isIPosition(position)) throw new Error("bad position");
        let { lineNumber, column } = position;
        let hasChanged = false;
        if (lineNumber < 1) {
            lineNumber = 1;
            column = 1;
            hasChanged = true;
        } else if (lineNumber > this._lines.length) {
            lineNumber = this._lines.length;
            column = this._lines[lineNumber - 1].length + 1;
            hasChanged = true;
        } else {
            const maxCharacter = this._lines[lineNumber - 1].length + 1;
            if (column < 1) {
                column = 1;
                hasChanged = true;
            } else if (column > maxCharacter) {
                column = maxCharacter;
                hasChanged = true;
            }
        }
        if (!hasChanged) return position;
        else return {
            lineNumber,
            column
        };
    }
}

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/uri.js":"7qGS3","../../core/position.js":"lvrPe","../../core/range.js":"jmUPh","../../core/wordHelper.js":"9FjxX","../../model/mirrorTextModel.js":"hCU5W","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hCU5W":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MirrorTextModel", ()=>MirrorTextModel);
var _stringsJs = require("../../../base/common/strings.js");
var _positionJs = require("../core/position.js");
var _prefixSumComputerJs = require("./prefixSumComputer.js");
class MirrorTextModel {
    constructor(uri, lines, eol, versionId){
        this._uri = uri;
        this._lines = lines;
        this._eol = eol;
        this._versionId = versionId;
        this._lineStarts = null;
        this._cachedTextValue = null;
    }
    dispose() {
        this._lines.length = 0;
    }
    get version() {
        return this._versionId;
    }
    getText() {
        if (this._cachedTextValue === null) this._cachedTextValue = this._lines.join(this._eol);
        return this._cachedTextValue;
    }
    onEvents(e) {
        if (e.eol && e.eol !== this._eol) {
            this._eol = e.eol;
            this._lineStarts = null;
        }
        // Update my lines
        const changes = e.changes;
        for (const change of changes){
            this._acceptDeleteRange(change.range);
            this._acceptInsertText(new (0, _positionJs.Position)(change.range.startLineNumber, change.range.startColumn), change.text);
        }
        this._versionId = e.versionId;
        this._cachedTextValue = null;
    }
    _ensureLineStarts() {
        if (!this._lineStarts) {
            const eolLength = this._eol.length;
            const linesLength = this._lines.length;
            const lineStartValues = new Uint32Array(linesLength);
            for(let i = 0; i < linesLength; i++)lineStartValues[i] = this._lines[i].length + eolLength;
            this._lineStarts = new (0, _prefixSumComputerJs.PrefixSumComputer)(lineStartValues);
        }
    }
    /**
     * All changes to a line's text go through this method
     */ _setLineText(lineIndex, newValue) {
        this._lines[lineIndex] = newValue;
        if (this._lineStarts) // update prefix sum
        this._lineStarts.setValue(lineIndex, this._lines[lineIndex].length + this._eol.length);
    }
    _acceptDeleteRange(range) {
        if (range.startLineNumber === range.endLineNumber) {
            if (range.startColumn === range.endColumn) // Nothing to delete
            return;
            // Delete text on the affected line
            this._setLineText(range.startLineNumber - 1, this._lines[range.startLineNumber - 1].substring(0, range.startColumn - 1) + this._lines[range.startLineNumber - 1].substring(range.endColumn - 1));
            return;
        }
        // Take remaining text on last line and append it to remaining text on first line
        this._setLineText(range.startLineNumber - 1, this._lines[range.startLineNumber - 1].substring(0, range.startColumn - 1) + this._lines[range.endLineNumber - 1].substring(range.endColumn - 1));
        // Delete middle lines
        this._lines.splice(range.startLineNumber, range.endLineNumber - range.startLineNumber);
        if (this._lineStarts) // update prefix sum
        this._lineStarts.removeValues(range.startLineNumber, range.endLineNumber - range.startLineNumber);
    }
    _acceptInsertText(position, insertText) {
        if (insertText.length === 0) // Nothing to insert
        return;
        const insertLines = (0, _stringsJs.splitLines)(insertText);
        if (insertLines.length === 1) {
            // Inserting text on one line
            this._setLineText(position.lineNumber - 1, this._lines[position.lineNumber - 1].substring(0, position.column - 1) + insertLines[0] + this._lines[position.lineNumber - 1].substring(position.column - 1));
            return;
        }
        // Append overflowing text from first line to the end of text to insert
        insertLines[insertLines.length - 1] += this._lines[position.lineNumber - 1].substring(position.column - 1);
        // Delete overflowing text from first line and insert text on first line
        this._setLineText(position.lineNumber - 1, this._lines[position.lineNumber - 1].substring(0, position.column - 1) + insertLines[0]);
        // Insert new lines & store lengths
        const newLengths = new Uint32Array(insertLines.length - 1);
        for(let i = 1; i < insertLines.length; i++){
            this._lines.splice(position.lineNumber + i - 1, 0, insertLines[i]);
            newLengths[i - 1] = insertLines[i].length + this._eol.length;
        }
        if (this._lineStarts) // update prefix sum
        this._lineStarts.insertValues(position.lineNumber, newLengths);
    }
}

},{"../../../base/common/strings.js":"aA9I1","../core/position.js":"lvrPe","./prefixSumComputer.js":"1Xo23","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Xo23":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PrefixSumComputer", ()=>PrefixSumComputer);
/**
 * {@link getIndexOf} has an amortized runtime complexity of O(1).
 *
 * ({@link PrefixSumComputer.getIndexOf} is just  O(log n))
*/ parcelHelpers.export(exports, "ConstantTimePrefixSumComputer", ()=>ConstantTimePrefixSumComputer);
parcelHelpers.export(exports, "PrefixSumIndexOfResult", ()=>PrefixSumIndexOfResult);
var _arraysJs = require("../../../base/common/arrays.js");
var _uintJs = require("../../../base/common/uint.js");
class PrefixSumComputer {
    constructor(values){
        this.values = values;
        this.prefixSum = new Uint32Array(values.length);
        this.prefixSumValidIndex = new Int32Array(1);
        this.prefixSumValidIndex[0] = -1;
    }
    insertValues(insertIndex, insertValues) {
        insertIndex = (0, _uintJs.toUint32)(insertIndex);
        const oldValues = this.values;
        const oldPrefixSum = this.prefixSum;
        const insertValuesLen = insertValues.length;
        if (insertValuesLen === 0) return false;
        this.values = new Uint32Array(oldValues.length + insertValuesLen);
        this.values.set(oldValues.subarray(0, insertIndex), 0);
        this.values.set(oldValues.subarray(insertIndex), insertIndex + insertValuesLen);
        this.values.set(insertValues, insertIndex);
        if (insertIndex - 1 < this.prefixSumValidIndex[0]) this.prefixSumValidIndex[0] = insertIndex - 1;
        this.prefixSum = new Uint32Array(this.values.length);
        if (this.prefixSumValidIndex[0] >= 0) this.prefixSum.set(oldPrefixSum.subarray(0, this.prefixSumValidIndex[0] + 1));
        return true;
    }
    setValue(index, value) {
        index = (0, _uintJs.toUint32)(index);
        value = (0, _uintJs.toUint32)(value);
        if (this.values[index] === value) return false;
        this.values[index] = value;
        if (index - 1 < this.prefixSumValidIndex[0]) this.prefixSumValidIndex[0] = index - 1;
        return true;
    }
    removeValues(startIndex, count) {
        startIndex = (0, _uintJs.toUint32)(startIndex);
        count = (0, _uintJs.toUint32)(count);
        const oldValues = this.values;
        const oldPrefixSum = this.prefixSum;
        if (startIndex >= oldValues.length) return false;
        const maxCount = oldValues.length - startIndex;
        if (count >= maxCount) count = maxCount;
        if (count === 0) return false;
        this.values = new Uint32Array(oldValues.length - count);
        this.values.set(oldValues.subarray(0, startIndex), 0);
        this.values.set(oldValues.subarray(startIndex + count), startIndex);
        this.prefixSum = new Uint32Array(this.values.length);
        if (startIndex - 1 < this.prefixSumValidIndex[0]) this.prefixSumValidIndex[0] = startIndex - 1;
        if (this.prefixSumValidIndex[0] >= 0) this.prefixSum.set(oldPrefixSum.subarray(0, this.prefixSumValidIndex[0] + 1));
        return true;
    }
    getTotalSum() {
        if (this.values.length === 0) return 0;
        return this._getPrefixSum(this.values.length - 1);
    }
    /**
     * Returns the sum of the first `index + 1` many items.
     * @returns `SUM(0 <= j <= index, values[j])`.
     */ getPrefixSum(index) {
        if (index < 0) return 0;
        index = (0, _uintJs.toUint32)(index);
        return this._getPrefixSum(index);
    }
    _getPrefixSum(index) {
        if (index <= this.prefixSumValidIndex[0]) return this.prefixSum[index];
        let startIndex = this.prefixSumValidIndex[0] + 1;
        if (startIndex === 0) {
            this.prefixSum[0] = this.values[0];
            startIndex++;
        }
        if (index >= this.values.length) index = this.values.length - 1;
        for(let i = startIndex; i <= index; i++)this.prefixSum[i] = this.prefixSum[i - 1] + this.values[i];
        this.prefixSumValidIndex[0] = Math.max(this.prefixSumValidIndex[0], index);
        return this.prefixSum[index];
    }
    getIndexOf(sum) {
        sum = Math.floor(sum);
        // Compute all sums (to get a fully valid prefixSum)
        this.getTotalSum();
        let low = 0;
        let high = this.values.length - 1;
        let mid = 0;
        let midStop = 0;
        let midStart = 0;
        while(low <= high){
            mid = low + (high - low) / 2 | 0;
            midStop = this.prefixSum[mid];
            midStart = midStop - this.values[mid];
            if (sum < midStart) high = mid - 1;
            else if (sum >= midStop) low = mid + 1;
            else break;
        }
        return new PrefixSumIndexOfResult(mid, sum - midStart);
    }
}
class ConstantTimePrefixSumComputer {
    constructor(values){
        this._values = values;
        this._isValid = false;
        this._validEndIndex = -1;
        this._prefixSum = [];
        this._indexBySum = [];
    }
    /**
     * @returns SUM(0 <= j < values.length, values[j])
     */ getTotalSum() {
        this._ensureValid();
        return this._indexBySum.length;
    }
    /**
     * Returns the sum of the first `count` many items.
     * @returns `SUM(0 <= j < count, values[j])`.
     */ getPrefixSum(count) {
        this._ensureValid();
        if (count === 0) return 0;
        return this._prefixSum[count - 1];
    }
    /**
     * @returns `result`, such that `getPrefixSum(result.index) + result.remainder = sum`
     */ getIndexOf(sum) {
        this._ensureValid();
        const idx = this._indexBySum[sum];
        const viewLinesAbove = idx > 0 ? this._prefixSum[idx - 1] : 0;
        return new PrefixSumIndexOfResult(idx, sum - viewLinesAbove);
    }
    removeValues(start, deleteCount) {
        this._values.splice(start, deleteCount);
        this._invalidate(start);
    }
    insertValues(insertIndex, insertArr) {
        this._values = (0, _arraysJs.arrayInsert)(this._values, insertIndex, insertArr);
        this._invalidate(insertIndex);
    }
    _invalidate(index) {
        this._isValid = false;
        this._validEndIndex = Math.min(this._validEndIndex, index - 1);
    }
    _ensureValid() {
        if (this._isValid) return;
        for(let i = this._validEndIndex + 1, len = this._values.length; i < len; i++){
            const value = this._values[i];
            const sumAbove = i > 0 ? this._prefixSum[i - 1] : 0;
            this._prefixSum[i] = sumAbove + value;
            for(let j = 0; j < value; j++)this._indexBySum[sumAbove + j] = i;
        }
        // trim things
        this._prefixSum.length = this._values.length;
        this._indexBySum.length = this._prefixSum[this._prefixSum.length - 1];
        // mark as valid
        this._isValid = true;
        this._validEndIndex = this._values.length - 1;
    }
    setValue(index, value) {
        if (this._values[index] === value) // no change
        return;
        this._values[index] = value;
        this._invalidate(index);
    }
}
class PrefixSumIndexOfResult {
    constructor(index, remainder){
        this.index = index;
        this.remainder = remainder;
        this._prefixSumIndexOfResultBrand = undefined;
        this.index = index;
        this.remainder = remainder;
    }
}

},{"../../../base/common/arrays.js":"DECei","../../../base/common/uint.js":"7fnps","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4yrEB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ITextResourceConfigurationService", ()=>ITextResourceConfigurationService);
parcelHelpers.export(exports, "ITextResourcePropertiesService", ()=>ITextResourcePropertiesService);
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
const ITextResourceConfigurationService = (0, _instantiationJs.createDecorator)("textResourceConfigurationService");
const ITextResourcePropertiesService = (0, _instantiationJs.createDecorator)("textResourcePropertiesService");

},{"../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2IAko":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ILanguageFeaturesService", ()=>ILanguageFeaturesService);
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
const ILanguageFeaturesService = (0, _instantiationJs.createDecorator)("ILanguageFeaturesService");

},{"../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3py7i":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandaloneNotificationService", ()=>StandaloneNotificationService);
parcelHelpers.export(exports, "StandaloneCommandService", ()=>StandaloneCommandService);
parcelHelpers.export(exports, "StandaloneKeybindingService", ()=>StandaloneKeybindingService);
parcelHelpers.export(exports, "StandaloneConfigurationService", ()=>StandaloneConfigurationService);
parcelHelpers.export(exports, "updateConfigurationService", ()=>updateConfigurationService);
parcelHelpers.export(exports, "standaloneEditorWorkerDescriptor", ()=>standaloneEditorWorkerDescriptor);
parcelHelpers.export(exports, "StandaloneServices", ()=>StandaloneServices);
var _standaloneCodeEditorServiceJs = require("./standaloneCodeEditorService.js");
var _standaloneLayoutServiceJs = require("./standaloneLayoutService.js");
var _undoRedoServiceJs = require("../../../platform/undoRedo/common/undoRedoService.js");
var _languageFeatureDebounceJs = require("../../common/services/languageFeatureDebounce.js");
var _semanticTokensStylingServiceJs = require("../../common/services/semanticTokensStylingService.js");
var _languageFeaturesServiceJs = require("../../common/services/languageFeaturesService.js");
var _hoverServiceJs = require("../../browser/services/hoverService/hoverService.js");
var _stringsJs = require("../../../base/common/strings.js");
var _domJs = require("../../../base/browser/dom.js");
var _keyboardEventJs = require("../../../base/browser/keyboardEvent.js");
var _eventJs = require("../../../base/common/event.js");
var _keybindingsJs = require("../../../base/common/keybindings.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _platformJs = require("../../../base/common/platform.js");
var _severityJs = require("../../../base/common/severity.js");
var _severityJsDefault = parcelHelpers.interopDefault(_severityJs);
var _uriJs = require("../../../base/common/uri.js");
var _bulkEditServiceJs = require("../../browser/services/bulkEditService.js");
var _editorConfigurationSchemaJs = require("../../common/config/editorConfigurationSchema.js");
var _editOperationJs = require("../../common/core/editOperation.js");
var _positionJs = require("../../common/core/position.js");
var _rangeJs = require("../../common/core/range.js");
var _modelJs = require("../../common/services/model.js");
var _resolverServiceJs = require("../../common/services/resolverService.js");
var _textResourceConfigurationJs = require("../../common/services/textResourceConfiguration.js");
var _commandsJs = require("../../../platform/commands/common/commands.js");
var _configurationJs = require("../../../platform/configuration/common/configuration.js");
var _configurationModelsJs = require("../../../platform/configuration/common/configurationModels.js");
var _contextkeyJs = require("../../../platform/contextkey/common/contextkey.js");
var _dialogsJs = require("../../../platform/dialogs/common/dialogs.js");
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
var _abstractKeybindingServiceJs = require("../../../platform/keybinding/common/abstractKeybindingService.js");
var _keybindingJs = require("../../../platform/keybinding/common/keybinding.js");
var _keybindingResolverJs = require("../../../platform/keybinding/common/keybindingResolver.js");
var _keybindingsRegistryJs = require("../../../platform/keybinding/common/keybindingsRegistry.js");
var _resolvedKeybindingItemJs = require("../../../platform/keybinding/common/resolvedKeybindingItem.js");
var _usLayoutResolvedKeybindingJs = require("../../../platform/keybinding/common/usLayoutResolvedKeybinding.js");
var _labelJs = require("../../../platform/label/common/label.js");
var _notificationJs = require("../../../platform/notification/common/notification.js");
var _progressJs = require("../../../platform/progress/common/progress.js");
var _telemetryJs = require("../../../platform/telemetry/common/telemetry.js");
var _workspaceJs = require("../../../platform/workspace/common/workspace.js");
var _layoutServiceJs = require("../../../platform/layout/browser/layoutService.js");
var _standaloneStringsJs = require("../../common/standaloneStrings.js");
var _resourcesJs = require("../../../base/common/resources.js");
var _codeEditorServiceJs = require("../../browser/services/codeEditorService.js");
var _logJs = require("../../../platform/log/common/log.js");
var _workspaceTrustJs = require("../../../platform/workspace/common/workspaceTrust.js");
var _contextViewJs = require("../../../platform/contextview/browser/contextView.js");
var _contextViewServiceJs = require("../../../platform/contextview/browser/contextViewService.js");
var _languageServiceJs = require("../../common/services/languageService.js");
var _contextMenuServiceJs = require("../../../platform/contextview/browser/contextMenuService.js");
var _extensionsJs = require("../../../platform/instantiation/common/extensions.js");
var _openerServiceJs = require("../../browser/services/openerService.js");
var _editorWorkerJs = require("../../common/services/editorWorker.js");
var _editorWorkerServiceJs = require("../../browser/services/editorWorkerService.js");
var _languageJs = require("../../common/languages/language.js");
var _markerDecorationsServiceJs = require("../../common/services/markerDecorationsService.js");
var _markerDecorationsJs = require("../../common/services/markerDecorations.js");
var _modelServiceJs = require("../../common/services/modelService.js");
var _standaloneQuickInputServiceJs = require("./quickInput/standaloneQuickInputService.js");
var _standaloneThemeServiceJs = require("./standaloneThemeService.js");
var _standaloneThemeJs = require("../common/standaloneTheme.js");
var _accessibilityServiceJs = require("../../../platform/accessibility/browser/accessibilityService.js");
var _accessibilityJs = require("../../../platform/accessibility/common/accessibility.js");
var _actionsJs = require("../../../platform/actions/common/actions.js");
var _menuServiceJs = require("../../../platform/actions/common/menuService.js");
var _clipboardServiceJs = require("../../../platform/clipboard/browser/clipboardService.js");
var _clipboardServiceJs1 = require("../../../platform/clipboard/common/clipboardService.js");
var _contextKeyServiceJs = require("../../../platform/contextkey/browser/contextKeyService.js");
var _descriptorsJs = require("../../../platform/instantiation/common/descriptors.js");
var _instantiationServiceJs = require("../../../platform/instantiation/common/instantiationService.js");
var _serviceCollectionJs = require("../../../platform/instantiation/common/serviceCollection.js");
var _listServiceJs = require("../../../platform/list/browser/listService.js");
var _markersJs = require("../../../platform/markers/common/markers.js");
var _markerServiceJs = require("../../../platform/markers/common/markerService.js");
var _openerJs = require("../../../platform/opener/common/opener.js");
var _quickInputJs = require("../../../platform/quickinput/common/quickInput.js");
var _storageJs = require("../../../platform/storage/common/storage.js");
var _configurationsJs = require("../../../platform/configuration/common/configurations.js");
var _accessibilitySignalServiceJs = require("../../../platform/accessibilitySignal/browser/accessibilitySignalService.js");
var _languageFeaturesJs = require("../../common/services/languageFeatures.js");
var _languageConfigurationRegistryJs = require("../../common/languages/languageConfigurationRegistry.js");
var _logServiceJs = require("../../../platform/log/common/logService.js");
var _editorFeaturesJs = require("../../common/editorFeatures.js");
var _errorsJs = require("../../../base/common/errors.js");
var _environmentJs = require("../../../platform/environment/common/environment.js");
var _windowJs = require("../../../base/browser/window.js");
var _mapJs = require("../../../base/common/map.js");
var _treeSitterParserServiceJs = require("../../common/services/treeSitterParserService.js");
var _standaloneTreeSitterServiceJs = require("./standaloneTreeSitterService.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class SimpleModel {
    constructor(model){
        this.disposed = false;
        this.model = model;
        this._onWillDispose = new (0, _eventJs.Emitter)();
    }
    get textEditorModel() {
        return this.model;
    }
    dispose() {
        this.disposed = true;
        this._onWillDispose.fire();
    }
}
let StandaloneTextModelService = class StandaloneTextModelService {
    constructor(modelService){
        this.modelService = modelService;
    }
    createModelReference(resource) {
        const model = this.modelService.getModel(resource);
        if (!model) return Promise.reject(new Error(`Model not found`));
        return Promise.resolve(new (0, _lifecycleJs.ImmortalReference)(new SimpleModel(model)));
    }
};
StandaloneTextModelService = __decorate([
    __param(0, (0, _modelJs.IModelService))
], StandaloneTextModelService);
class StandaloneEditorProgressService {
    static{
        this.NULL_PROGRESS_RUNNER = {
            done: ()=>{},
            total: ()=>{},
            worked: ()=>{}
        };
    }
    show() {
        return StandaloneEditorProgressService.NULL_PROGRESS_RUNNER;
    }
    async showWhile(promise, delay) {
        await promise;
    }
}
class StandaloneProgressService {
    withProgress(_options, task, onDidCancel) {
        return task({
            report: ()=>{}
        });
    }
}
class StandaloneEnvironmentService {
    constructor(){
        this.isExtensionDevelopment = false;
        this.isBuilt = false;
    }
}
class StandaloneDialogService {
    async confirm(confirmation) {
        const confirmed = this.doConfirm(confirmation.message, confirmation.detail);
        return {
            confirmed,
            checkboxChecked: false // unsupported
        };
    }
    doConfirm(message, detail) {
        let messageText = message;
        if (detail) messageText = messageText + "\n\n" + detail;
        return (0, _windowJs.mainWindow).confirm(messageText);
    }
    async prompt(prompt) {
        let result = undefined;
        const confirmed = this.doConfirm(prompt.message, prompt.detail);
        if (confirmed) {
            const promptButtons = [
                ...prompt.buttons ?? []
            ];
            if (prompt.cancelButton && typeof prompt.cancelButton !== "string" && typeof prompt.cancelButton !== "boolean") promptButtons.push(prompt.cancelButton);
            result = await promptButtons[0]?.run({
                checkboxChecked: false
            });
        }
        return {
            result
        };
    }
    async error(message, detail) {
        await this.prompt({
            type: (0, _severityJsDefault.default).Error,
            message,
            detail
        });
    }
}
class StandaloneNotificationService {
    static{
        this.NO_OP = new (0, _notificationJs.NoOpNotification)();
    }
    info(message) {
        return this.notify({
            severity: (0, _severityJsDefault.default).Info,
            message
        });
    }
    warn(message) {
        return this.notify({
            severity: (0, _severityJsDefault.default).Warning,
            message
        });
    }
    error(error) {
        return this.notify({
            severity: (0, _severityJsDefault.default).Error,
            message: error
        });
    }
    notify(notification) {
        switch(notification.severity){
            case (0, _severityJsDefault.default).Error:
                console.error(notification.message);
                break;
            case (0, _severityJsDefault.default).Warning:
                console.warn(notification.message);
                break;
            default:
                console.log(notification.message);
                break;
        }
        return StandaloneNotificationService.NO_OP;
    }
    prompt(severity, message, choices, options) {
        return StandaloneNotificationService.NO_OP;
    }
    status(message, options) {
        return (0, _lifecycleJs.Disposable).None;
    }
}
let StandaloneCommandService = class StandaloneCommandService {
    constructor(instantiationService){
        this._onWillExecuteCommand = new (0, _eventJs.Emitter)();
        this._onDidExecuteCommand = new (0, _eventJs.Emitter)();
        this.onDidExecuteCommand = this._onDidExecuteCommand.event;
        this._instantiationService = instantiationService;
    }
    executeCommand(id, ...args) {
        const command = (0, _commandsJs.CommandsRegistry).getCommand(id);
        if (!command) return Promise.reject(new Error(`command '${id}' not found`));
        try {
            this._onWillExecuteCommand.fire({
                commandId: id,
                args
            });
            const result = this._instantiationService.invokeFunction.apply(this._instantiationService, [
                command.handler,
                ...args
            ]);
            this._onDidExecuteCommand.fire({
                commandId: id,
                args
            });
            return Promise.resolve(result);
        } catch (err) {
            return Promise.reject(err);
        }
    }
};
StandaloneCommandService = __decorate([
    __param(0, (0, _instantiationJs.IInstantiationService))
], StandaloneCommandService);
let StandaloneKeybindingService = class StandaloneKeybindingService extends (0, _abstractKeybindingServiceJs.AbstractKeybindingService) {
    constructor(contextKeyService, commandService, telemetryService, notificationService, logService, codeEditorService){
        super(contextKeyService, commandService, telemetryService, notificationService, logService);
        this._cachedResolver = null;
        this._dynamicKeybindings = [];
        this._domNodeListeners = [];
        const addContainer = (domNode)=>{
            const disposables = new (0, _lifecycleJs.DisposableStore)();
            // for standard keybindings
            disposables.add(_domJs.addDisposableListener(domNode, _domJs.EventType.KEY_DOWN, (e)=>{
                const keyEvent = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
                const shouldPreventDefault = this._dispatch(keyEvent, keyEvent.target);
                if (shouldPreventDefault) {
                    keyEvent.preventDefault();
                    keyEvent.stopPropagation();
                }
            }));
            // for single modifier chord keybindings (e.g. shift shift)
            disposables.add(_domJs.addDisposableListener(domNode, _domJs.EventType.KEY_UP, (e)=>{
                const keyEvent = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
                const shouldPreventDefault = this._singleModifierDispatch(keyEvent, keyEvent.target);
                if (shouldPreventDefault) keyEvent.preventDefault();
            }));
            this._domNodeListeners.push(new DomNodeListeners(domNode, disposables));
        };
        const removeContainer = (domNode)=>{
            for(let i = 0; i < this._domNodeListeners.length; i++){
                const domNodeListeners = this._domNodeListeners[i];
                if (domNodeListeners.domNode === domNode) {
                    this._domNodeListeners.splice(i, 1);
                    domNodeListeners.dispose();
                }
            }
        };
        const addCodeEditor = (codeEditor)=>{
            if (codeEditor.getOption(61 /* EditorOption.inDiffEditor */ )) return;
            addContainer(codeEditor.getContainerDomNode());
        };
        const removeCodeEditor = (codeEditor)=>{
            if (codeEditor.getOption(61 /* EditorOption.inDiffEditor */ )) return;
            removeContainer(codeEditor.getContainerDomNode());
        };
        this._register(codeEditorService.onCodeEditorAdd(addCodeEditor));
        this._register(codeEditorService.onCodeEditorRemove(removeCodeEditor));
        codeEditorService.listCodeEditors().forEach(addCodeEditor);
        const addDiffEditor = (diffEditor)=>{
            addContainer(diffEditor.getContainerDomNode());
        };
        const removeDiffEditor = (diffEditor)=>{
            removeContainer(diffEditor.getContainerDomNode());
        };
        this._register(codeEditorService.onDiffEditorAdd(addDiffEditor));
        this._register(codeEditorService.onDiffEditorRemove(removeDiffEditor));
        codeEditorService.listDiffEditors().forEach(addDiffEditor);
    }
    addDynamicKeybinding(command, keybinding, handler, when) {
        return (0, _lifecycleJs.combinedDisposable)((0, _commandsJs.CommandsRegistry).registerCommand(command, handler), this.addDynamicKeybindings([
            {
                keybinding,
                command,
                when
            }
        ]));
    }
    addDynamicKeybindings(rules) {
        const entries = rules.map((rule)=>{
            const keybinding = (0, _keybindingsJs.decodeKeybinding)(rule.keybinding, (0, _platformJs.OS));
            return {
                keybinding,
                command: rule.command ?? null,
                commandArgs: rule.commandArgs,
                when: rule.when,
                weight1: 1000,
                weight2: 0,
                extensionId: null,
                isBuiltinExtension: false
            };
        });
        this._dynamicKeybindings = this._dynamicKeybindings.concat(entries);
        this.updateResolver();
        return (0, _lifecycleJs.toDisposable)(()=>{
            // Search the first entry and remove them all since they will be contiguous
            for(let i = 0; i < this._dynamicKeybindings.length; i++)if (this._dynamicKeybindings[i] === entries[0]) {
                this._dynamicKeybindings.splice(i, entries.length);
                this.updateResolver();
                return;
            }
        });
    }
    updateResolver() {
        this._cachedResolver = null;
        this._onDidUpdateKeybindings.fire();
    }
    _getResolver() {
        if (!this._cachedResolver) {
            const defaults = this._toNormalizedKeybindingItems((0, _keybindingsRegistryJs.KeybindingsRegistry).getDefaultKeybindings(), true);
            const overrides = this._toNormalizedKeybindingItems(this._dynamicKeybindings, false);
            this._cachedResolver = new (0, _keybindingResolverJs.KeybindingResolver)(defaults, overrides, (str)=>this._log(str));
        }
        return this._cachedResolver;
    }
    _documentHasFocus() {
        return (0, _windowJs.mainWindow).document.hasFocus();
    }
    _toNormalizedKeybindingItems(items, isDefault) {
        const result = [];
        let resultLen = 0;
        for (const item of items){
            const when = item.when || undefined;
            const keybinding = item.keybinding;
            if (!keybinding) // This might be a removal keybinding item in user settings => accept it
            result[resultLen++] = new (0, _resolvedKeybindingItemJs.ResolvedKeybindingItem)(undefined, item.command, item.commandArgs, when, isDefault, null, false);
            else {
                const resolvedKeybindings = (0, _usLayoutResolvedKeybindingJs.USLayoutResolvedKeybinding).resolveKeybinding(keybinding, (0, _platformJs.OS));
                for (const resolvedKeybinding of resolvedKeybindings)result[resultLen++] = new (0, _resolvedKeybindingItemJs.ResolvedKeybindingItem)(resolvedKeybinding, item.command, item.commandArgs, when, isDefault, null, false);
            }
        }
        return result;
    }
    resolveKeyboardEvent(keyboardEvent) {
        const chord = new (0, _keybindingsJs.KeyCodeChord)(keyboardEvent.ctrlKey, keyboardEvent.shiftKey, keyboardEvent.altKey, keyboardEvent.metaKey, keyboardEvent.keyCode);
        return new (0, _usLayoutResolvedKeybindingJs.USLayoutResolvedKeybinding)([
            chord
        ], (0, _platformJs.OS));
    }
};
StandaloneKeybindingService = __decorate([
    __param(0, (0, _contextkeyJs.IContextKeyService)),
    __param(1, (0, _commandsJs.ICommandService)),
    __param(2, (0, _telemetryJs.ITelemetryService)),
    __param(3, (0, _notificationJs.INotificationService)),
    __param(4, (0, _logJs.ILogService)),
    __param(5, (0, _codeEditorServiceJs.ICodeEditorService))
], StandaloneKeybindingService);
class DomNodeListeners extends (0, _lifecycleJs.Disposable) {
    constructor(domNode, disposables){
        super();
        this.domNode = domNode;
        this._register(disposables);
    }
}
function isConfigurationOverrides(thing) {
    return thing && typeof thing === "object" && (!thing.overrideIdentifier || typeof thing.overrideIdentifier === "string") && (!thing.resource || thing.resource instanceof (0, _uriJs.URI));
}
let StandaloneConfigurationService = class StandaloneConfigurationService {
    constructor(logService){
        this.logService = logService;
        this._onDidChangeConfiguration = new (0, _eventJs.Emitter)();
        this.onDidChangeConfiguration = this._onDidChangeConfiguration.event;
        const defaultConfiguration = new (0, _configurationsJs.DefaultConfiguration)(logService);
        this._configuration = new (0, _configurationModelsJs.Configuration)(defaultConfiguration.reload(), (0, _configurationModelsJs.ConfigurationModel).createEmptyModel(logService), (0, _configurationModelsJs.ConfigurationModel).createEmptyModel(logService), (0, _configurationModelsJs.ConfigurationModel).createEmptyModel(logService), (0, _configurationModelsJs.ConfigurationModel).createEmptyModel(logService), (0, _configurationModelsJs.ConfigurationModel).createEmptyModel(logService), new (0, _mapJs.ResourceMap)(), (0, _configurationModelsJs.ConfigurationModel).createEmptyModel(logService), new (0, _mapJs.ResourceMap)(), logService);
        defaultConfiguration.dispose();
    }
    getValue(arg1, arg2) {
        const section = typeof arg1 === "string" ? arg1 : undefined;
        const overrides = isConfigurationOverrides(arg1) ? arg1 : isConfigurationOverrides(arg2) ? arg2 : {};
        return this._configuration.getValue(section, overrides, undefined);
    }
    updateValues(values) {
        const previous = {
            data: this._configuration.toData()
        };
        const changedKeys = [];
        for (const entry of values){
            const [key, value] = entry;
            if (this.getValue(key) === value) continue;
            this._configuration.updateValue(key, value);
            changedKeys.push(key);
        }
        if (changedKeys.length > 0) {
            const configurationChangeEvent = new (0, _configurationModelsJs.ConfigurationChangeEvent)({
                keys: changedKeys,
                overrides: []
            }, previous, this._configuration, undefined, this.logService);
            configurationChangeEvent.source = 8 /* ConfigurationTarget.MEMORY */ ;
            this._onDidChangeConfiguration.fire(configurationChangeEvent);
        }
        return Promise.resolve();
    }
    updateValue(key, value, arg3, arg4) {
        return this.updateValues([
            [
                key,
                value
            ]
        ]);
    }
    inspect(key, options = {}) {
        return this._configuration.inspect(key, options, undefined);
    }
};
StandaloneConfigurationService = __decorate([
    __param(0, (0, _logJs.ILogService))
], StandaloneConfigurationService);
let StandaloneResourceConfigurationService = class StandaloneResourceConfigurationService {
    constructor(configurationService, modelService, languageService){
        this.configurationService = configurationService;
        this.modelService = modelService;
        this.languageService = languageService;
        this._onDidChangeConfiguration = new (0, _eventJs.Emitter)();
        this.configurationService.onDidChangeConfiguration((e)=>{
            this._onDidChangeConfiguration.fire({
                affectedKeys: e.affectedKeys,
                affectsConfiguration: (resource, configuration)=>e.affectsConfiguration(configuration)
            });
        });
    }
    getValue(resource, arg2, arg3) {
        const position = (0, _positionJs.Position).isIPosition(arg2) ? arg2 : null;
        const section = position ? typeof arg3 === "string" ? arg3 : undefined : typeof arg2 === "string" ? arg2 : undefined;
        const language = resource ? this.getLanguage(resource, position) : undefined;
        if (typeof section === "undefined") return this.configurationService.getValue({
            resource,
            overrideIdentifier: language
        });
        return this.configurationService.getValue(section, {
            resource,
            overrideIdentifier: language
        });
    }
    getLanguage(resource, position) {
        const model = this.modelService.getModel(resource);
        if (model) return position ? model.getLanguageIdAtPosition(position.lineNumber, position.column) : model.getLanguageId();
        return this.languageService.guessLanguageIdByFilepathOrFirstLine(resource);
    }
};
StandaloneResourceConfigurationService = __decorate([
    __param(0, (0, _configurationJs.IConfigurationService)),
    __param(1, (0, _modelJs.IModelService)),
    __param(2, (0, _languageJs.ILanguageService))
], StandaloneResourceConfigurationService);
let StandaloneResourcePropertiesService = class StandaloneResourcePropertiesService {
    constructor(configurationService){
        this.configurationService = configurationService;
    }
    getEOL(resource, language) {
        const eol = this.configurationService.getValue("files.eol", {
            overrideIdentifier: language,
            resource
        });
        if (eol && typeof eol === "string" && eol !== "auto") return eol;
        return (0, _platformJs.isLinux) || (0, _platformJs.isMacintosh) ? "\n" : "\r\n";
    }
};
StandaloneResourcePropertiesService = __decorate([
    __param(0, (0, _configurationJs.IConfigurationService))
], StandaloneResourcePropertiesService);
class StandaloneTelemetryService {
    publicLog2() {}
}
class StandaloneWorkspaceContextService {
    static{
        this.SCHEME = "inmemory";
    }
    constructor(){
        const resource = (0, _uriJs.URI).from({
            scheme: StandaloneWorkspaceContextService.SCHEME,
            authority: "model",
            path: "/"
        });
        this.workspace = {
            id: (0, _workspaceJs.STANDALONE_EDITOR_WORKSPACE_ID),
            folders: [
                new (0, _workspaceJs.WorkspaceFolder)({
                    uri: resource,
                    name: "",
                    index: 0
                })
            ]
        };
    }
    getWorkspace() {
        return this.workspace;
    }
    getWorkspaceFolder(resource) {
        return resource && resource.scheme === StandaloneWorkspaceContextService.SCHEME ? this.workspace.folders[0] : null;
    }
}
function updateConfigurationService(configurationService, source, isDiffEditor) {
    if (!source) return;
    if (!(configurationService instanceof StandaloneConfigurationService)) return;
    const toUpdate = [];
    Object.keys(source).forEach((key)=>{
        if ((0, _editorConfigurationSchemaJs.isEditorConfigurationKey)(key)) toUpdate.push([
            `editor.${key}`,
            source[key]
        ]);
        if (isDiffEditor && (0, _editorConfigurationSchemaJs.isDiffEditorConfigurationKey)(key)) toUpdate.push([
            `diffEditor.${key}`,
            source[key]
        ]);
    });
    if (toUpdate.length > 0) configurationService.updateValues(toUpdate);
}
let StandaloneBulkEditService = class StandaloneBulkEditService {
    constructor(_modelService){
        this._modelService = _modelService;
    //
    }
    hasPreviewHandler() {
        return false;
    }
    async apply(editsIn, _options) {
        const edits = Array.isArray(editsIn) ? editsIn : (0, _bulkEditServiceJs.ResourceEdit).convert(editsIn);
        const textEdits = new Map();
        for (const edit of edits){
            if (!(edit instanceof (0, _bulkEditServiceJs.ResourceTextEdit))) throw new Error("bad edit - only text edits are supported");
            const model = this._modelService.getModel(edit.resource);
            if (!model) throw new Error("bad edit - model not found");
            if (typeof edit.versionId === "number" && model.getVersionId() !== edit.versionId) throw new Error("bad state - model changed in the meantime");
            let array = textEdits.get(model);
            if (!array) {
                array = [];
                textEdits.set(model, array);
            }
            array.push((0, _editOperationJs.EditOperation).replaceMove((0, _rangeJs.Range).lift(edit.textEdit.range), edit.textEdit.text));
        }
        let totalEdits = 0;
        let totalFiles = 0;
        for (const [model, edits] of textEdits){
            model.pushStackElement();
            model.pushEditOperations([], edits, ()=>[]);
            model.pushStackElement();
            totalFiles += 1;
            totalEdits += edits.length;
        }
        return {
            ariaSummary: _stringsJs.format((0, _standaloneStringsJs.StandaloneServicesNLS).bulkEditServiceSummary, totalEdits, totalFiles),
            isApplied: totalEdits > 0
        };
    }
};
StandaloneBulkEditService = __decorate([
    __param(0, (0, _modelJs.IModelService))
], StandaloneBulkEditService);
class StandaloneUriLabelService {
    getUriLabel(resource, options) {
        if (resource.scheme === "file") return resource.fsPath;
        return resource.path;
    }
    getUriBasenameLabel(resource) {
        return (0, _resourcesJs.basename)(resource);
    }
}
let StandaloneContextViewService = class StandaloneContextViewService extends (0, _contextViewServiceJs.ContextViewService) {
    constructor(layoutService, _codeEditorService){
        super(layoutService);
        this._codeEditorService = _codeEditorService;
    }
    showContextView(delegate, container, shadowRoot) {
        if (!container) {
            const codeEditor = this._codeEditorService.getFocusedCodeEditor() || this._codeEditorService.getActiveCodeEditor();
            if (codeEditor) container = codeEditor.getContainerDomNode();
        }
        return super.showContextView(delegate, container, shadowRoot);
    }
};
StandaloneContextViewService = __decorate([
    __param(0, (0, _layoutServiceJs.ILayoutService)),
    __param(1, (0, _codeEditorServiceJs.ICodeEditorService))
], StandaloneContextViewService);
class StandaloneWorkspaceTrustManagementService {
    constructor(){
        this._neverEmitter = new (0, _eventJs.Emitter)();
        this.onDidChangeTrust = this._neverEmitter.event;
    }
    isWorkspaceTrusted() {
        return true;
    }
}
class StandaloneLanguageService extends (0, _languageServiceJs.LanguageService) {
    constructor(){
        super();
    }
}
class StandaloneLogService extends (0, _logServiceJs.LogService) {
    constructor(){
        super(new (0, _logJs.ConsoleLogger)());
    }
}
let StandaloneContextMenuService = class StandaloneContextMenuService extends (0, _contextMenuServiceJs.ContextMenuService) {
    constructor(telemetryService, notificationService, contextViewService, keybindingService, menuService, contextKeyService){
        super(telemetryService, notificationService, contextViewService, keybindingService, menuService, contextKeyService);
        this.configure({
            blockMouse: false
        }); // we do not want that in the standalone editor
    }
};
StandaloneContextMenuService = __decorate([
    __param(0, (0, _telemetryJs.ITelemetryService)),
    __param(1, (0, _notificationJs.INotificationService)),
    __param(2, (0, _contextViewJs.IContextViewService)),
    __param(3, (0, _keybindingJs.IKeybindingService)),
    __param(4, (0, _actionsJs.IMenuService)),
    __param(5, (0, _contextkeyJs.IContextKeyService))
], StandaloneContextMenuService);
const standaloneEditorWorkerDescriptor = {
    amdModuleId: "vs/editor/common/services/editorSimpleWorker",
    esmModuleLocation: undefined,
    label: "editorWorkerService"
};
let StandaloneEditorWorkerService = class StandaloneEditorWorkerService extends (0, _editorWorkerServiceJs.EditorWorkerService) {
    constructor(modelService, configurationService, logService, languageConfigurationService, languageFeaturesService){
        super(standaloneEditorWorkerDescriptor, modelService, configurationService, logService, languageConfigurationService, languageFeaturesService);
    }
};
StandaloneEditorWorkerService = __decorate([
    __param(0, (0, _modelJs.IModelService)),
    __param(1, (0, _textResourceConfigurationJs.ITextResourceConfigurationService)),
    __param(2, (0, _logJs.ILogService)),
    __param(3, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService)),
    __param(4, (0, _languageFeaturesJs.ILanguageFeaturesService))
], StandaloneEditorWorkerService);
class StandaloneAccessbilitySignalService {
    async playSignal(cue, options) {}
}
(0, _extensionsJs.registerSingleton)((0, _logJs.ILogService), StandaloneLogService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _configurationJs.IConfigurationService), StandaloneConfigurationService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _textResourceConfigurationJs.ITextResourceConfigurationService), StandaloneResourceConfigurationService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _textResourceConfigurationJs.ITextResourcePropertiesService), StandaloneResourcePropertiesService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _workspaceJs.IWorkspaceContextService), StandaloneWorkspaceContextService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _labelJs.ILabelService), StandaloneUriLabelService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _telemetryJs.ITelemetryService), StandaloneTelemetryService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _dialogsJs.IDialogService), StandaloneDialogService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _environmentJs.IEnvironmentService), StandaloneEnvironmentService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _notificationJs.INotificationService), StandaloneNotificationService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _markersJs.IMarkerService), (0, _markerServiceJs.MarkerService), 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _languageJs.ILanguageService), StandaloneLanguageService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _standaloneThemeJs.IStandaloneThemeService), (0, _standaloneThemeServiceJs.StandaloneThemeService), 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _modelJs.IModelService), (0, _modelServiceJs.ModelService), 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _markerDecorationsJs.IMarkerDecorationsService), (0, _markerDecorationsServiceJs.MarkerDecorationsService), 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _contextkeyJs.IContextKeyService), (0, _contextKeyServiceJs.ContextKeyService), 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _progressJs.IProgressService), StandaloneProgressService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _progressJs.IEditorProgressService), StandaloneEditorProgressService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _storageJs.IStorageService), (0, _storageJs.InMemoryStorageService), 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _editorWorkerJs.IEditorWorkerService), StandaloneEditorWorkerService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _bulkEditServiceJs.IBulkEditService), StandaloneBulkEditService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _workspaceTrustJs.IWorkspaceTrustManagementService), StandaloneWorkspaceTrustManagementService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _resolverServiceJs.ITextModelService), StandaloneTextModelService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _accessibilityJs.IAccessibilityService), (0, _accessibilityServiceJs.AccessibilityService), 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _listServiceJs.IListService), (0, _listServiceJs.ListService), 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _commandsJs.ICommandService), StandaloneCommandService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _keybindingJs.IKeybindingService), StandaloneKeybindingService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _quickInputJs.IQuickInputService), (0, _standaloneQuickInputServiceJs.StandaloneQuickInputService), 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _contextViewJs.IContextViewService), StandaloneContextViewService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _openerJs.IOpenerService), (0, _openerServiceJs.OpenerService), 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _clipboardServiceJs1.IClipboardService), (0, _clipboardServiceJs.BrowserClipboardService), 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _contextViewJs.IContextMenuService), StandaloneContextMenuService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _actionsJs.IMenuService), (0, _menuServiceJs.MenuService), 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _accessibilitySignalServiceJs.IAccessibilitySignalService), StandaloneAccessbilitySignalService, 0 /* InstantiationType.Eager */ );
(0, _extensionsJs.registerSingleton)((0, _treeSitterParserServiceJs.ITreeSitterParserService), (0, _standaloneTreeSitterServiceJs.StandaloneTreeSitterParserService), 0 /* InstantiationType.Eager */ );
var StandaloneServices;
(function(StandaloneServices) {
    const serviceCollection = new (0, _serviceCollectionJs.ServiceCollection)();
    for (const [id, descriptor] of (0, _extensionsJs.getSingletonServiceDescriptors)())serviceCollection.set(id, descriptor);
    const instantiationService = new (0, _instantiationServiceJs.InstantiationService)(serviceCollection, true);
    serviceCollection.set((0, _instantiationJs.IInstantiationService), instantiationService);
    function get(serviceId) {
        if (!initialized) initialize({});
        const r = serviceCollection.get(serviceId);
        if (!r) throw new Error("Missing service " + serviceId);
        if (r instanceof (0, _descriptorsJs.SyncDescriptor)) return instantiationService.invokeFunction((accessor)=>accessor.get(serviceId));
        else return r;
    }
    StandaloneServices.get = get;
    let initialized = false;
    const onDidInitialize = new (0, _eventJs.Emitter)();
    function initialize(overrides) {
        if (initialized) return instantiationService;
        initialized = true;
        // Add singletons that were registered after this module loaded
        for (const [id, descriptor] of (0, _extensionsJs.getSingletonServiceDescriptors)())if (!serviceCollection.get(id)) serviceCollection.set(id, descriptor);
        // Initialize the service collection with the overrides, but only if the
        // service was not instantiated in the meantime.
        for(const serviceId in overrides)if (overrides.hasOwnProperty(serviceId)) {
            const serviceIdentifier = (0, _instantiationJs.createDecorator)(serviceId);
            const r = serviceCollection.get(serviceIdentifier);
            if (r instanceof (0, _descriptorsJs.SyncDescriptor)) serviceCollection.set(serviceIdentifier, overrides[serviceId]);
        }
        // Instantiate all editor features
        const editorFeatures = (0, _editorFeaturesJs.getEditorFeatures)();
        for (const feature of editorFeatures)try {
            instantiationService.createInstance(feature);
        } catch (err) {
            (0, _errorsJs.onUnexpectedError)(err);
        }
        onDidInitialize.fire();
        return instantiationService;
    }
    StandaloneServices.initialize = initialize;
    /**
     * Executes callback once services are initialized.
     */ function withServices(callback) {
        if (initialized) return callback();
        const disposable = new (0, _lifecycleJs.DisposableStore)();
        const listener = disposable.add(onDidInitialize.event(()=>{
            listener.dispose();
            disposable.add(callback());
        }));
        return disposable;
    }
    StandaloneServices.withServices = withServices;
})(StandaloneServices || (StandaloneServices = {}));

},{"./standaloneCodeEditorService.js":"kIky6","./standaloneLayoutService.js":"c5sFD","../../../platform/undoRedo/common/undoRedoService.js":"fdrLg","../../common/services/languageFeatureDebounce.js":"YGXXG","../../common/services/semanticTokensStylingService.js":"3RsCI","../../common/services/languageFeaturesService.js":"3X4wH","../../browser/services/hoverService/hoverService.js":"2lZxe","../../../base/common/strings.js":"aA9I1","../../../base/browser/dom.js":"bnqsM","../../../base/browser/keyboardEvent.js":"bxU9U","../../../base/common/event.js":"4Zi8b","../../../base/common/keybindings.js":"cQ6F5","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/platform.js":"7maJO","../../../base/common/severity.js":"faBYp","../../../base/common/uri.js":"7qGS3","../../browser/services/bulkEditService.js":"fLMRG","../../common/config/editorConfigurationSchema.js":"18Zc9","../../common/core/editOperation.js":"6r2FZ","../../common/core/position.js":"lvrPe","../../common/core/range.js":"jmUPh","../../common/services/model.js":"aciVm","../../common/services/resolverService.js":"ezAtF","../../common/services/textResourceConfiguration.js":"4yrEB","../../../platform/commands/common/commands.js":"ho6ic","../../../platform/configuration/common/configuration.js":"dXkjq","../../../platform/configuration/common/configurationModels.js":"1tQGv","../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../platform/dialogs/common/dialogs.js":"3ZDTa","../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../platform/keybinding/common/abstractKeybindingService.js":"ejxw7","../../../platform/keybinding/common/keybinding.js":"25pLT","../../../platform/keybinding/common/keybindingResolver.js":"hQoQq","../../../platform/keybinding/common/keybindingsRegistry.js":"h9qfk","../../../platform/keybinding/common/resolvedKeybindingItem.js":"ijJXz","../../../platform/keybinding/common/usLayoutResolvedKeybinding.js":"hUnGv","../../../platform/label/common/label.js":"esEqR","../../../platform/notification/common/notification.js":"igv0W","../../../platform/progress/common/progress.js":"f49eD","../../../platform/telemetry/common/telemetry.js":"7vW8j","../../../platform/workspace/common/workspace.js":"707vH","../../../platform/layout/browser/layoutService.js":"fPPgf","../../common/standaloneStrings.js":"D35dK","../../../base/common/resources.js":"700EV","../../browser/services/codeEditorService.js":"bOWtl","../../../platform/log/common/log.js":"ieJUF","../../../platform/workspace/common/workspaceTrust.js":"4R356","../../../platform/contextview/browser/contextView.js":"2QlUR","../../../platform/contextview/browser/contextViewService.js":"3MZFS","../../common/services/languageService.js":"8NPGN","../../../platform/contextview/browser/contextMenuService.js":"4Y5Vr","../../../platform/instantiation/common/extensions.js":"6WJLq","../../browser/services/openerService.js":"hdbML","../../common/services/editorWorker.js":"aaYJd","../../browser/services/editorWorkerService.js":"Dlnvt","../../common/languages/language.js":"ka2JQ","../../common/services/markerDecorationsService.js":"A8sE6","../../common/services/markerDecorations.js":"jDz73","../../common/services/modelService.js":"grnor","./quickInput/standaloneQuickInputService.js":"lLEaZ","./standaloneThemeService.js":"kMN9g","../common/standaloneTheme.js":"exW2E","../../../platform/accessibility/browser/accessibilityService.js":"3km7z","../../../platform/accessibility/common/accessibility.js":"9Svqy","../../../platform/actions/common/actions.js":"kyMtp","../../../platform/actions/common/menuService.js":"6ihaN","../../../platform/clipboard/browser/clipboardService.js":"iyql7","../../../platform/clipboard/common/clipboardService.js":"4IsFp","../../../platform/contextkey/browser/contextKeyService.js":"fCMgV","../../../platform/instantiation/common/descriptors.js":"doIK7","../../../platform/instantiation/common/instantiationService.js":"6g3vM","../../../platform/instantiation/common/serviceCollection.js":"5sFx9","../../../platform/list/browser/listService.js":"cyGMs","../../../platform/markers/common/markers.js":"aaeXc","../../../platform/markers/common/markerService.js":"ftx9i","../../../platform/opener/common/opener.js":"d3tj1","../../../platform/quickinput/common/quickInput.js":"a56M6","../../../platform/storage/common/storage.js":"6AhR2","../../../platform/configuration/common/configurations.js":"ldIh3","../../../platform/accessibilitySignal/browser/accessibilitySignalService.js":"hpeDM","../../common/services/languageFeatures.js":"2IAko","../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../platform/log/common/logService.js":"866WY","../../common/editorFeatures.js":"8AkS3","../../../base/common/errors.js":"divX8","../../../platform/environment/common/environment.js":"6y5Oq","../../../base/browser/window.js":"aJBhQ","../../../base/common/map.js":"leSjz","../../common/services/treeSitterParserService.js":"bi0Mc","./standaloneTreeSitterService.js":"1isRs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kIky6":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandaloneCodeEditorService", ()=>StandaloneCodeEditorService);
var _domJs = require("../../../base/browser/dom.js");
var _networkJs = require("../../../base/common/network.js");
var _abstractCodeEditorServiceJs = require("../../browser/services/abstractCodeEditorService.js");
var _codeEditorServiceJs = require("../../browser/services/codeEditorService.js");
var _contextkeyJs = require("../../../platform/contextkey/common/contextkey.js");
var _extensionsJs = require("../../../platform/instantiation/common/extensions.js");
var _themeServiceJs = require("../../../platform/theme/common/themeService.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let StandaloneCodeEditorService = class StandaloneCodeEditorService extends (0, _abstractCodeEditorServiceJs.AbstractCodeEditorService) {
    constructor(contextKeyService, themeService){
        super(themeService);
        this._register(this.onCodeEditorAdd(()=>this._checkContextKey()));
        this._register(this.onCodeEditorRemove(()=>this._checkContextKey()));
        this._editorIsOpen = contextKeyService.createKey("editorIsOpen", false);
        this._activeCodeEditor = null;
        this._register(this.registerCodeEditorOpenHandler(async (input, source, sideBySide)=>{
            if (!source) return null;
            return this.doOpenEditor(source, input);
        }));
    }
    _checkContextKey() {
        let hasCodeEditor = false;
        for (const editor of this.listCodeEditors())if (!editor.isSimpleWidget) {
            hasCodeEditor = true;
            break;
        }
        this._editorIsOpen.set(hasCodeEditor);
    }
    setActiveCodeEditor(activeCodeEditor) {
        this._activeCodeEditor = activeCodeEditor;
    }
    getActiveCodeEditor() {
        return this._activeCodeEditor;
    }
    doOpenEditor(editor, input) {
        const model = this.findModel(editor, input.resource);
        if (!model) {
            if (input.resource) {
                const schema = input.resource.scheme;
                if (schema === (0, _networkJs.Schemas).http || schema === (0, _networkJs.Schemas).https) {
                    // This is a fully qualified http or https URL
                    (0, _domJs.windowOpenNoOpener)(input.resource.toString());
                    return editor;
                }
            }
            return null;
        }
        const selection = input.options ? input.options.selection : null;
        if (selection) {
            if (typeof selection.endLineNumber === "number" && typeof selection.endColumn === "number") {
                editor.setSelection(selection);
                editor.revealRangeInCenter(selection, 1 /* ScrollType.Immediate */ );
            } else {
                const pos = {
                    lineNumber: selection.startLineNumber,
                    column: selection.startColumn
                };
                editor.setPosition(pos);
                editor.revealPositionInCenter(pos, 1 /* ScrollType.Immediate */ );
            }
        }
        return editor;
    }
    findModel(editor, resource) {
        const model = editor.getModel();
        if (model && model.uri.toString() !== resource.toString()) return null;
        return model;
    }
};
StandaloneCodeEditorService = __decorate([
    __param(0, (0, _contextkeyJs.IContextKeyService)),
    __param(1, (0, _themeServiceJs.IThemeService))
], StandaloneCodeEditorService);
(0, _extensionsJs.registerSingleton)((0, _codeEditorServiceJs.ICodeEditorService), StandaloneCodeEditorService, 0 /* InstantiationType.Eager */ );

},{"../../../base/browser/dom.js":"bnqsM","../../../base/common/network.js":"2c1AD","../../browser/services/abstractCodeEditorService.js":"7Aqhs","../../browser/services/codeEditorService.js":"bOWtl","../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../platform/instantiation/common/extensions.js":"6WJLq","../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Aqhs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractCodeEditorService", ()=>AbstractCodeEditorService);
parcelHelpers.export(exports, "GlobalStyleSheet", ()=>GlobalStyleSheet);
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _linkedListJs = require("../../../base/common/linkedList.js");
var _themeServiceJs = require("../../../platform/theme/common/themeService.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let AbstractCodeEditorService = class AbstractCodeEditorService extends (0, _lifecycleJs.Disposable) {
    constructor(_themeService){
        super();
        this._themeService = _themeService;
        this._onWillCreateCodeEditor = this._register(new (0, _eventJs.Emitter)());
        this._onCodeEditorAdd = this._register(new (0, _eventJs.Emitter)());
        this.onCodeEditorAdd = this._onCodeEditorAdd.event;
        this._onCodeEditorRemove = this._register(new (0, _eventJs.Emitter)());
        this.onCodeEditorRemove = this._onCodeEditorRemove.event;
        this._onWillCreateDiffEditor = this._register(new (0, _eventJs.Emitter)());
        this._onDiffEditorAdd = this._register(new (0, _eventJs.Emitter)());
        this.onDiffEditorAdd = this._onDiffEditorAdd.event;
        this._onDiffEditorRemove = this._register(new (0, _eventJs.Emitter)());
        this.onDiffEditorRemove = this._onDiffEditorRemove.event;
        this._decorationOptionProviders = new Map();
        this._codeEditorOpenHandlers = new (0, _linkedListJs.LinkedList)();
        this._modelProperties = new Map();
        this._codeEditors = Object.create(null);
        this._diffEditors = Object.create(null);
        this._globalStyleSheet = null;
    }
    willCreateCodeEditor() {
        this._onWillCreateCodeEditor.fire();
    }
    addCodeEditor(editor) {
        this._codeEditors[editor.getId()] = editor;
        this._onCodeEditorAdd.fire(editor);
    }
    removeCodeEditor(editor) {
        if (delete this._codeEditors[editor.getId()]) this._onCodeEditorRemove.fire(editor);
    }
    listCodeEditors() {
        return Object.keys(this._codeEditors).map((id)=>this._codeEditors[id]);
    }
    willCreateDiffEditor() {
        this._onWillCreateDiffEditor.fire();
    }
    addDiffEditor(editor) {
        this._diffEditors[editor.getId()] = editor;
        this._onDiffEditorAdd.fire(editor);
    }
    listDiffEditors() {
        return Object.keys(this._diffEditors).map((id)=>this._diffEditors[id]);
    }
    getFocusedCodeEditor() {
        let editorWithWidgetFocus = null;
        const editors = this.listCodeEditors();
        for (const editor of editors){
            if (editor.hasTextFocus()) // bingo!
            return editor;
            if (editor.hasWidgetFocus()) editorWithWidgetFocus = editor;
        }
        return editorWithWidgetFocus;
    }
    removeDecorationType(key) {
        const provider = this._decorationOptionProviders.get(key);
        if (provider) {
            provider.refCount--;
            if (provider.refCount <= 0) {
                this._decorationOptionProviders.delete(key);
                provider.dispose();
                this.listCodeEditors().forEach((ed)=>ed.removeDecorationsByType(key));
            }
        }
    }
    setModelProperty(resource, key, value) {
        const key1 = resource.toString();
        let dest;
        if (this._modelProperties.has(key1)) dest = this._modelProperties.get(key1);
        else {
            dest = new Map();
            this._modelProperties.set(key1, dest);
        }
        dest.set(key, value);
    }
    getModelProperty(resource, key) {
        const key1 = resource.toString();
        if (this._modelProperties.has(key1)) {
            const innerMap = this._modelProperties.get(key1);
            return innerMap.get(key);
        }
        return undefined;
    }
    async openCodeEditor(input, source, sideBySide) {
        for (const handler of this._codeEditorOpenHandlers){
            const candidate = await handler(input, source, sideBySide);
            if (candidate !== null) return candidate;
        }
        return null;
    }
    registerCodeEditorOpenHandler(handler) {
        const rm = this._codeEditorOpenHandlers.unshift(handler);
        return (0, _lifecycleJs.toDisposable)(rm);
    }
};
AbstractCodeEditorService = __decorate([
    __param(0, (0, _themeServiceJs.IThemeService))
], AbstractCodeEditorService);
class GlobalStyleSheet {
    constructor(styleSheet){
        this._styleSheet = styleSheet;
    }
}

},{"../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/linkedList.js":"kv7Rg","../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jMkIC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IThemeService", ()=>IThemeService);
parcelHelpers.export(exports, "themeColorFromId", ()=>themeColorFromId);
parcelHelpers.export(exports, "getThemeTypeSelector", ()=>getThemeTypeSelector);
parcelHelpers.export(exports, "Extensions", ()=>Extensions);
parcelHelpers.export(exports, "registerThemingParticipant", ()=>registerThemingParticipant);
/**
 * Utility base class for all themable components.
 */ parcelHelpers.export(exports, "Themable", ()=>Themable);
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var _platformJs = require("../../registry/common/platform.js");
var _themeJs = require("./theme.js");
const IThemeService = (0, _instantiationJs.createDecorator)("themeService");
function themeColorFromId(id) {
    return {
        id
    };
}
function getThemeTypeSelector(type) {
    switch(type){
        case (0, _themeJs.ColorScheme).DARK:
            return "vs-dark";
        case (0, _themeJs.ColorScheme).HIGH_CONTRAST_DARK:
            return "hc-black";
        case (0, _themeJs.ColorScheme).HIGH_CONTRAST_LIGHT:
            return "hc-light";
        default:
            return "vs";
    }
}
const Extensions = {
    ThemingContribution: "base.contributions.theming"
};
class ThemingRegistry {
    constructor(){
        this.themingParticipants = [];
        this.themingParticipants = [];
        this.onThemingParticipantAddedEmitter = new (0, _eventJs.Emitter)();
    }
    onColorThemeChange(participant) {
        this.themingParticipants.push(participant);
        this.onThemingParticipantAddedEmitter.fire(participant);
        return (0, _lifecycleJs.toDisposable)(()=>{
            const idx = this.themingParticipants.indexOf(participant);
            this.themingParticipants.splice(idx, 1);
        });
    }
    getThemingParticipants() {
        return this.themingParticipants;
    }
}
const themingRegistry = new ThemingRegistry();
_platformJs.Registry.add(Extensions.ThemingContribution, themingRegistry);
function registerThemingParticipant(participant) {
    return themingRegistry.onColorThemeChange(participant);
}
class Themable extends (0, _lifecycleJs.Disposable) {
    constructor(themeService){
        super();
        this.themeService = themeService;
        this.theme = themeService.getColorTheme();
        // Hook up to theme changes
        this._register(this.themeService.onDidColorThemeChange((theme)=>this.onThemeChange(theme)));
    }
    onThemeChange(theme) {
        this.theme = theme;
        this.updateStyles();
    }
    updateStyles() {
    // Subclasses to override
    }
}

},{"../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../instantiation/common/instantiation.js":"fjwWx","../../registry/common/platform.js":"dzx11","./theme.js":"gh7Zf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gh7Zf":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 * Color scheme used by the OS and by color themes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorScheme", ()=>ColorScheme);
parcelHelpers.export(exports, "isHighContrast", ()=>isHighContrast);
parcelHelpers.export(exports, "isDark", ()=>isDark);
var ColorScheme;
(function(ColorScheme) {
    ColorScheme["DARK"] = "dark";
    ColorScheme["LIGHT"] = "light";
    ColorScheme["HIGH_CONTRAST_DARK"] = "hcDark";
    ColorScheme["HIGH_CONTRAST_LIGHT"] = "hcLight";
})(ColorScheme || (ColorScheme = {}));
function isHighContrast(scheme) {
    return scheme === ColorScheme.HIGH_CONTRAST_DARK || scheme === ColorScheme.HIGH_CONTRAST_LIGHT;
}
function isDark(scheme) {
    return scheme === ColorScheme.DARK || scheme === ColorScheme.HIGH_CONTRAST_DARK;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c5sFD":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorScopedLayoutService", ()=>EditorScopedLayoutService);
var _domJs = require("../../../base/browser/dom.js");
var _windowJs = require("../../../base/browser/window.js");
var _arraysJs = require("../../../base/common/arrays.js");
var _eventJs = require("../../../base/common/event.js");
var _codeEditorServiceJs = require("../../browser/services/codeEditorService.js");
var _extensionsJs = require("../../../platform/instantiation/common/extensions.js");
var _layoutServiceJs = require("../../../platform/layout/browser/layoutService.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let StandaloneLayoutService = class StandaloneLayoutService {
    get mainContainer() {
        return (0, _arraysJs.firstOrDefault)(this._codeEditorService.listCodeEditors())?.getContainerDomNode() ?? (0, _windowJs.mainWindow).document.body;
    }
    get activeContainer() {
        const activeCodeEditor = this._codeEditorService.getFocusedCodeEditor() ?? this._codeEditorService.getActiveCodeEditor();
        return activeCodeEditor?.getContainerDomNode() ?? this.mainContainer;
    }
    get mainContainerDimension() {
        return _domJs.getClientArea(this.mainContainer);
    }
    get activeContainerDimension() {
        return _domJs.getClientArea(this.activeContainer);
    }
    get containers() {
        return (0, _arraysJs.coalesce)(this._codeEditorService.listCodeEditors().map((codeEditor)=>codeEditor.getContainerDomNode()));
    }
    getContainer() {
        return this.activeContainer;
    }
    whenContainerStylesLoaded() {
        return undefined;
    }
    focus() {
        this._codeEditorService.getFocusedCodeEditor()?.focus();
    }
    constructor(_codeEditorService){
        this._codeEditorService = _codeEditorService;
        this.onDidLayoutMainContainer = (0, _eventJs.Event).None;
        this.onDidLayoutActiveContainer = (0, _eventJs.Event).None;
        this.onDidLayoutContainer = (0, _eventJs.Event).None;
        this.onDidChangeActiveContainer = (0, _eventJs.Event).None;
        this.onDidAddContainer = (0, _eventJs.Event).None;
        this.mainContainerOffset = {
            top: 0,
            quickPickTop: 0
        };
        this.activeContainerOffset = {
            top: 0,
            quickPickTop: 0
        };
    }
};
StandaloneLayoutService = __decorate([
    __param(0, (0, _codeEditorServiceJs.ICodeEditorService))
], StandaloneLayoutService);
let EditorScopedLayoutService = class EditorScopedLayoutService extends StandaloneLayoutService {
    get mainContainer() {
        return this._container;
    }
    constructor(_container, codeEditorService){
        super(codeEditorService);
        this._container = _container;
    }
};
EditorScopedLayoutService = __decorate([
    __param(1, (0, _codeEditorServiceJs.ICodeEditorService))
], EditorScopedLayoutService);
(0, _extensionsJs.registerSingleton)((0, _layoutServiceJs.ILayoutService), StandaloneLayoutService, 1 /* InstantiationType.Delayed */ );

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/window.js":"aJBhQ","../../../base/common/arrays.js":"DECei","../../../base/common/event.js":"4Zi8b","../../browser/services/codeEditorService.js":"bOWtl","../../../platform/instantiation/common/extensions.js":"6WJLq","../../../platform/layout/browser/layoutService.js":"fPPgf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fPPgf":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ILayoutService", ()=>ILayoutService);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const ILayoutService = (0, _instantiationJs.createDecorator)("layoutService");

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fdrLg":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UndoRedoService", ()=>UndoRedoService);
var _errorsJs = require("../../../base/common/errors.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _networkJs = require("../../../base/common/network.js");
var _severityJs = require("../../../base/common/severity.js");
var _severityJsDefault = parcelHelpers.interopDefault(_severityJs);
var _nlsJs = require("../../../nls.js");
var _dialogsJs = require("../../dialogs/common/dialogs.js");
var _extensionsJs = require("../../instantiation/common/extensions.js");
var _notificationJs = require("../../notification/common/notification.js");
var _undoRedoJs = require("./undoRedo.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const DEBUG = false;
function getResourceLabel(resource) {
    return resource.scheme === (0, _networkJs.Schemas).file ? resource.fsPath : resource.path;
}
let stackElementCounter = 0;
class ResourceStackElement {
    constructor(actual, resourceLabel, strResource, groupId, groupOrder, sourceId, sourceOrder){
        this.id = ++stackElementCounter;
        this.type = 0 /* UndoRedoElementType.Resource */ ;
        this.actual = actual;
        this.label = actual.label;
        this.confirmBeforeUndo = actual.confirmBeforeUndo || false;
        this.resourceLabel = resourceLabel;
        this.strResource = strResource;
        this.resourceLabels = [
            this.resourceLabel
        ];
        this.strResources = [
            this.strResource
        ];
        this.groupId = groupId;
        this.groupOrder = groupOrder;
        this.sourceId = sourceId;
        this.sourceOrder = sourceOrder;
        this.isValid = true;
    }
    setValid(isValid) {
        this.isValid = isValid;
    }
    toString() {
        return `[id:${this.id}] [group:${this.groupId}] [${this.isValid ? "  VALID" : "INVALID"}] ${this.actual.constructor.name} - ${this.actual}`;
    }
}
class ResourceReasonPair {
    constructor(resourceLabel, reason){
        this.resourceLabel = resourceLabel;
        this.reason = reason;
    }
}
class RemovedResources {
    constructor(){
        this.elements = new Map();
    }
    createMessage() {
        const externalRemoval = [];
        const noParallelUniverses = [];
        for (const [, element] of this.elements){
            const dest = element.reason === 0 /* RemovedResourceReason.ExternalRemoval */  ? externalRemoval : noParallelUniverses;
            dest.push(element.resourceLabel);
        }
        const messages = [];
        if (externalRemoval.length > 0) messages.push(_nlsJs.localize({
            key: "externalRemoval",
            comment: [
                "{0} is a list of filenames"
            ]
        }, "The following files have been closed and modified on disk: {0}.", externalRemoval.join(", ")));
        if (noParallelUniverses.length > 0) messages.push(_nlsJs.localize({
            key: "noParallelUniverses",
            comment: [
                "{0} is a list of filenames"
            ]
        }, "The following files have been modified in an incompatible way: {0}.", noParallelUniverses.join(", ")));
        return messages.join("\n");
    }
    get size() {
        return this.elements.size;
    }
    has(strResource) {
        return this.elements.has(strResource);
    }
    set(strResource, value) {
        this.elements.set(strResource, value);
    }
    delete(strResource) {
        return this.elements.delete(strResource);
    }
}
class WorkspaceStackElement {
    constructor(actual, resourceLabels, strResources, groupId, groupOrder, sourceId, sourceOrder){
        this.id = ++stackElementCounter;
        this.type = 1 /* UndoRedoElementType.Workspace */ ;
        this.actual = actual;
        this.label = actual.label;
        this.confirmBeforeUndo = actual.confirmBeforeUndo || false;
        this.resourceLabels = resourceLabels;
        this.strResources = strResources;
        this.groupId = groupId;
        this.groupOrder = groupOrder;
        this.sourceId = sourceId;
        this.sourceOrder = sourceOrder;
        this.removedResources = null;
        this.invalidatedResources = null;
    }
    canSplit() {
        return typeof this.actual.split === "function";
    }
    removeResource(resourceLabel, strResource, reason) {
        if (!this.removedResources) this.removedResources = new RemovedResources();
        if (!this.removedResources.has(strResource)) this.removedResources.set(strResource, new ResourceReasonPair(resourceLabel, reason));
    }
    setValid(resourceLabel, strResource, isValid) {
        if (isValid) {
            if (this.invalidatedResources) {
                this.invalidatedResources.delete(strResource);
                if (this.invalidatedResources.size === 0) this.invalidatedResources = null;
            }
        } else {
            if (!this.invalidatedResources) this.invalidatedResources = new RemovedResources();
            if (!this.invalidatedResources.has(strResource)) this.invalidatedResources.set(strResource, new ResourceReasonPair(resourceLabel, 0 /* RemovedResourceReason.ExternalRemoval */ ));
        }
    }
    toString() {
        return `[id:${this.id}] [group:${this.groupId}] [${this.invalidatedResources ? "INVALID" : "  VALID"}] ${this.actual.constructor.name} - ${this.actual}`;
    }
}
class ResourceEditStack {
    constructor(resourceLabel, strResource){
        this.resourceLabel = resourceLabel;
        this.strResource = strResource;
        this._past = [];
        this._future = [];
        this.locked = false;
        this.versionId = 1;
    }
    dispose() {
        for (const element of this._past)if (element.type === 1 /* UndoRedoElementType.Workspace */ ) element.removeResource(this.resourceLabel, this.strResource, 0 /* RemovedResourceReason.ExternalRemoval */ );
        for (const element of this._future)if (element.type === 1 /* UndoRedoElementType.Workspace */ ) element.removeResource(this.resourceLabel, this.strResource, 0 /* RemovedResourceReason.ExternalRemoval */ );
        this.versionId++;
    }
    toString() {
        const result = [];
        result.push(`* ${this.strResource}:`);
        for(let i = 0; i < this._past.length; i++)result.push(`   * [UNDO] ${this._past[i]}`);
        for(let i = this._future.length - 1; i >= 0; i--)result.push(`   * [REDO] ${this._future[i]}`);
        return result.join("\n");
    }
    flushAllElements() {
        this._past = [];
        this._future = [];
        this.versionId++;
    }
    _setElementValidFlag(element, isValid) {
        if (element.type === 1 /* UndoRedoElementType.Workspace */ ) element.setValid(this.resourceLabel, this.strResource, isValid);
        else element.setValid(isValid);
    }
    setElementsValidFlag(isValid, filter) {
        for (const element of this._past)if (filter(element.actual)) this._setElementValidFlag(element, isValid);
        for (const element of this._future)if (filter(element.actual)) this._setElementValidFlag(element, isValid);
    }
    pushElement(element) {
        // remove the future
        for (const futureElement of this._future)if (futureElement.type === 1 /* UndoRedoElementType.Workspace */ ) futureElement.removeResource(this.resourceLabel, this.strResource, 1 /* RemovedResourceReason.NoParallelUniverses */ );
        this._future = [];
        this._past.push(element);
        this.versionId++;
    }
    createSnapshot(resource) {
        const elements = [];
        for(let i = 0, len = this._past.length; i < len; i++)elements.push(this._past[i].id);
        for(let i = this._future.length - 1; i >= 0; i--)elements.push(this._future[i].id);
        return new (0, _undoRedoJs.ResourceEditStackSnapshot)(resource, elements);
    }
    restoreSnapshot(snapshot) {
        const snapshotLength = snapshot.elements.length;
        let isOK = true;
        let snapshotIndex = 0;
        let removePastAfter = -1;
        for(let i = 0, len = this._past.length; i < len; i++, snapshotIndex++){
            const element = this._past[i];
            if (isOK && (snapshotIndex >= snapshotLength || element.id !== snapshot.elements[snapshotIndex])) {
                isOK = false;
                removePastAfter = 0;
            }
            if (!isOK && element.type === 1 /* UndoRedoElementType.Workspace */ ) element.removeResource(this.resourceLabel, this.strResource, 0 /* RemovedResourceReason.ExternalRemoval */ );
        }
        let removeFutureBefore = -1;
        for(let i = this._future.length - 1; i >= 0; i--, snapshotIndex++){
            const element = this._future[i];
            if (isOK && (snapshotIndex >= snapshotLength || element.id !== snapshot.elements[snapshotIndex])) {
                isOK = false;
                removeFutureBefore = i;
            }
            if (!isOK && element.type === 1 /* UndoRedoElementType.Workspace */ ) element.removeResource(this.resourceLabel, this.strResource, 0 /* RemovedResourceReason.ExternalRemoval */ );
        }
        if (removePastAfter !== -1) this._past = this._past.slice(0, removePastAfter);
        if (removeFutureBefore !== -1) this._future = this._future.slice(removeFutureBefore + 1);
        this.versionId++;
    }
    getElements() {
        const past = [];
        const future = [];
        for (const element of this._past)past.push(element.actual);
        for (const element of this._future)future.push(element.actual);
        return {
            past,
            future
        };
    }
    getClosestPastElement() {
        if (this._past.length === 0) return null;
        return this._past[this._past.length - 1];
    }
    getSecondClosestPastElement() {
        if (this._past.length < 2) return null;
        return this._past[this._past.length - 2];
    }
    getClosestFutureElement() {
        if (this._future.length === 0) return null;
        return this._future[this._future.length - 1];
    }
    hasPastElements() {
        return this._past.length > 0;
    }
    hasFutureElements() {
        return this._future.length > 0;
    }
    splitPastWorkspaceElement(toRemove, individualMap) {
        for(let j = this._past.length - 1; j >= 0; j--)if (this._past[j] === toRemove) {
            if (individualMap.has(this.strResource)) // gets replaced
            this._past[j] = individualMap.get(this.strResource);
            else // gets deleted
            this._past.splice(j, 1);
            break;
        }
        this.versionId++;
    }
    splitFutureWorkspaceElement(toRemove, individualMap) {
        for(let j = this._future.length - 1; j >= 0; j--)if (this._future[j] === toRemove) {
            if (individualMap.has(this.strResource)) // gets replaced
            this._future[j] = individualMap.get(this.strResource);
            else // gets deleted
            this._future.splice(j, 1);
            break;
        }
        this.versionId++;
    }
    moveBackward(element) {
        this._past.pop();
        this._future.push(element);
        this.versionId++;
    }
    moveForward(element) {
        this._future.pop();
        this._past.push(element);
        this.versionId++;
    }
}
class EditStackSnapshot {
    constructor(editStacks){
        this.editStacks = editStacks;
        this._versionIds = [];
        for(let i = 0, len = this.editStacks.length; i < len; i++)this._versionIds[i] = this.editStacks[i].versionId;
    }
    isValid() {
        for(let i = 0, len = this.editStacks.length; i < len; i++){
            if (this._versionIds[i] !== this.editStacks[i].versionId) return false;
        }
        return true;
    }
}
const missingEditStack = new ResourceEditStack("", "");
missingEditStack.locked = true;
let UndoRedoService = class UndoRedoService {
    constructor(_dialogService, _notificationService){
        this._dialogService = _dialogService;
        this._notificationService = _notificationService;
        this._editStacks = new Map();
        this._uriComparisonKeyComputers = [];
    }
    getUriComparisonKey(resource) {
        for (const uriComparisonKeyComputer of this._uriComparisonKeyComputers){
            if (uriComparisonKeyComputer[0] === resource.scheme) return uriComparisonKeyComputer[1].getComparisonKey(resource);
        }
        return resource.toString();
    }
    _print(label) {
        console.log(`------------------------------------`);
        console.log(`AFTER ${label}: `);
        const str = [];
        for (const element of this._editStacks)str.push(element[1].toString());
        console.log(str.join("\n"));
    }
    pushElement(element, group = (0, _undoRedoJs.UndoRedoGroup).None, source = (0, _undoRedoJs.UndoRedoSource).None) {
        if (element.type === 0 /* UndoRedoElementType.Resource */ ) {
            const resourceLabel = getResourceLabel(element.resource);
            const strResource = this.getUriComparisonKey(element.resource);
            this._pushElement(new ResourceStackElement(element, resourceLabel, strResource, group.id, group.nextOrder(), source.id, source.nextOrder()));
        } else {
            const seen = new Set();
            const resourceLabels = [];
            const strResources = [];
            for (const resource of element.resources){
                const resourceLabel = getResourceLabel(resource);
                const strResource = this.getUriComparisonKey(resource);
                if (seen.has(strResource)) continue;
                seen.add(strResource);
                resourceLabels.push(resourceLabel);
                strResources.push(strResource);
            }
            if (resourceLabels.length === 1) this._pushElement(new ResourceStackElement(element, resourceLabels[0], strResources[0], group.id, group.nextOrder(), source.id, source.nextOrder()));
            else this._pushElement(new WorkspaceStackElement(element, resourceLabels, strResources, group.id, group.nextOrder(), source.id, source.nextOrder()));
        }
        if (DEBUG) this._print("pushElement");
    }
    _pushElement(element) {
        for(let i = 0, len = element.strResources.length; i < len; i++){
            const resourceLabel = element.resourceLabels[i];
            const strResource = element.strResources[i];
            let editStack;
            if (this._editStacks.has(strResource)) editStack = this._editStacks.get(strResource);
            else {
                editStack = new ResourceEditStack(resourceLabel, strResource);
                this._editStacks.set(strResource, editStack);
            }
            editStack.pushElement(element);
        }
    }
    getLastElement(resource) {
        const strResource = this.getUriComparisonKey(resource);
        if (this._editStacks.has(strResource)) {
            const editStack = this._editStacks.get(strResource);
            if (editStack.hasFutureElements()) return null;
            const closestPastElement = editStack.getClosestPastElement();
            return closestPastElement ? closestPastElement.actual : null;
        }
        return null;
    }
    _splitPastWorkspaceElement(toRemove, ignoreResources) {
        const individualArr = toRemove.actual.split();
        const individualMap = new Map();
        for (const _element of individualArr){
            const resourceLabel = getResourceLabel(_element.resource);
            const strResource = this.getUriComparisonKey(_element.resource);
            const element = new ResourceStackElement(_element, resourceLabel, strResource, 0, 0, 0, 0);
            individualMap.set(element.strResource, element);
        }
        for (const strResource of toRemove.strResources){
            if (ignoreResources && ignoreResources.has(strResource)) continue;
            const editStack = this._editStacks.get(strResource);
            editStack.splitPastWorkspaceElement(toRemove, individualMap);
        }
    }
    _splitFutureWorkspaceElement(toRemove, ignoreResources) {
        const individualArr = toRemove.actual.split();
        const individualMap = new Map();
        for (const _element of individualArr){
            const resourceLabel = getResourceLabel(_element.resource);
            const strResource = this.getUriComparisonKey(_element.resource);
            const element = new ResourceStackElement(_element, resourceLabel, strResource, 0, 0, 0, 0);
            individualMap.set(element.strResource, element);
        }
        for (const strResource of toRemove.strResources){
            if (ignoreResources && ignoreResources.has(strResource)) continue;
            const editStack = this._editStacks.get(strResource);
            editStack.splitFutureWorkspaceElement(toRemove, individualMap);
        }
    }
    removeElements(resource) {
        const strResource = typeof resource === "string" ? resource : this.getUriComparisonKey(resource);
        if (this._editStacks.has(strResource)) {
            const editStack = this._editStacks.get(strResource);
            editStack.dispose();
            this._editStacks.delete(strResource);
        }
        if (DEBUG) this._print("removeElements");
    }
    setElementsValidFlag(resource, isValid, filter) {
        const strResource = this.getUriComparisonKey(resource);
        if (this._editStacks.has(strResource)) {
            const editStack = this._editStacks.get(strResource);
            editStack.setElementsValidFlag(isValid, filter);
        }
        if (DEBUG) this._print("setElementsValidFlag");
    }
    createSnapshot(resource) {
        const strResource = this.getUriComparisonKey(resource);
        if (this._editStacks.has(strResource)) {
            const editStack = this._editStacks.get(strResource);
            return editStack.createSnapshot(resource);
        }
        return new (0, _undoRedoJs.ResourceEditStackSnapshot)(resource, []);
    }
    restoreSnapshot(snapshot) {
        const strResource = this.getUriComparisonKey(snapshot.resource);
        if (this._editStacks.has(strResource)) {
            const editStack = this._editStacks.get(strResource);
            editStack.restoreSnapshot(snapshot);
            if (!editStack.hasPastElements() && !editStack.hasFutureElements()) {
                // the edit stack is now empty, just remove it entirely
                editStack.dispose();
                this._editStacks.delete(strResource);
            }
        }
        if (DEBUG) this._print("restoreSnapshot");
    }
    getElements(resource) {
        const strResource = this.getUriComparisonKey(resource);
        if (this._editStacks.has(strResource)) {
            const editStack = this._editStacks.get(strResource);
            return editStack.getElements();
        }
        return {
            past: [],
            future: []
        };
    }
    _findClosestUndoElementWithSource(sourceId) {
        if (!sourceId) return [
            null,
            null
        ];
        // find an element with the sourceId and with the highest sourceOrder ready to be undone
        let matchedElement = null;
        let matchedStrResource = null;
        for (const [strResource, editStack] of this._editStacks){
            const candidate = editStack.getClosestPastElement();
            if (!candidate) continue;
            if (candidate.sourceId === sourceId) {
                if (!matchedElement || candidate.sourceOrder > matchedElement.sourceOrder) {
                    matchedElement = candidate;
                    matchedStrResource = strResource;
                }
            }
        }
        return [
            matchedElement,
            matchedStrResource
        ];
    }
    canUndo(resourceOrSource) {
        if (resourceOrSource instanceof (0, _undoRedoJs.UndoRedoSource)) {
            const [, matchedStrResource] = this._findClosestUndoElementWithSource(resourceOrSource.id);
            return matchedStrResource ? true : false;
        }
        const strResource = this.getUriComparisonKey(resourceOrSource);
        if (this._editStacks.has(strResource)) {
            const editStack = this._editStacks.get(strResource);
            return editStack.hasPastElements();
        }
        return false;
    }
    _onError(err, element) {
        (0, _errorsJs.onUnexpectedError)(err);
        // An error occurred while undoing or redoing => drop the undo/redo stack for all affected resources
        for (const strResource of element.strResources)this.removeElements(strResource);
        this._notificationService.error(err);
    }
    _acquireLocks(editStackSnapshot) {
        // first, check if all locks can be acquired
        for (const editStack of editStackSnapshot.editStacks){
            if (editStack.locked) throw new Error("Cannot acquire edit stack lock");
        }
        // can acquire all locks
        for (const editStack of editStackSnapshot.editStacks)editStack.locked = true;
        return ()=>{
            // release all locks
            for (const editStack of editStackSnapshot.editStacks)editStack.locked = false;
        };
    }
    _safeInvokeWithLocks(element, invoke, editStackSnapshot, cleanup, continuation) {
        const releaseLocks = this._acquireLocks(editStackSnapshot);
        let result;
        try {
            result = invoke();
        } catch (err) {
            releaseLocks();
            cleanup.dispose();
            return this._onError(err, element);
        }
        if (result) // result is Promise<void>
        return result.then(()=>{
            releaseLocks();
            cleanup.dispose();
            return continuation();
        }, (err)=>{
            releaseLocks();
            cleanup.dispose();
            return this._onError(err, element);
        });
        else {
            // result is void
            releaseLocks();
            cleanup.dispose();
            return continuation();
        }
    }
    async _invokeWorkspacePrepare(element) {
        if (typeof element.actual.prepareUndoRedo === "undefined") return (0, _lifecycleJs.Disposable).None;
        const result = element.actual.prepareUndoRedo();
        if (typeof result === "undefined") return (0, _lifecycleJs.Disposable).None;
        return result;
    }
    _invokeResourcePrepare(element, callback) {
        if (element.actual.type !== 1 /* UndoRedoElementType.Workspace */  || typeof element.actual.prepareUndoRedo === "undefined") // no preparation needed
        return callback((0, _lifecycleJs.Disposable).None);
        const r = element.actual.prepareUndoRedo();
        if (!r) // nothing to clean up
        return callback((0, _lifecycleJs.Disposable).None);
        if ((0, _lifecycleJs.isDisposable)(r)) return callback(r);
        return r.then((disposable)=>{
            return callback(disposable);
        });
    }
    _getAffectedEditStacks(element) {
        const affectedEditStacks = [];
        for (const strResource of element.strResources)affectedEditStacks.push(this._editStacks.get(strResource) || missingEditStack);
        return new EditStackSnapshot(affectedEditStacks);
    }
    _tryToSplitAndUndo(strResource, element, ignoreResources, message) {
        if (element.canSplit()) {
            this._splitPastWorkspaceElement(element, ignoreResources);
            this._notificationService.warn(message);
            return new WorkspaceVerificationError(this._undo(strResource, 0, true));
        } else {
            // Cannot safely split this workspace element => flush all undo/redo stacks
            for (const strResource of element.strResources)this.removeElements(strResource);
            this._notificationService.warn(message);
            return new WorkspaceVerificationError();
        }
    }
    _checkWorkspaceUndo(strResource, element, editStackSnapshot, checkInvalidatedResources) {
        if (element.removedResources) return this._tryToSplitAndUndo(strResource, element, element.removedResources, _nlsJs.localize({
            key: "cannotWorkspaceUndo",
            comment: [
                "{0} is a label for an operation. {1} is another message."
            ]
        }, "Could not undo '{0}' across all files. {1}", element.label, element.removedResources.createMessage()));
        if (checkInvalidatedResources && element.invalidatedResources) return this._tryToSplitAndUndo(strResource, element, element.invalidatedResources, _nlsJs.localize({
            key: "cannotWorkspaceUndo",
            comment: [
                "{0} is a label for an operation. {1} is another message."
            ]
        }, "Could not undo '{0}' across all files. {1}", element.label, element.invalidatedResources.createMessage()));
        // this must be the last past element in all the impacted resources!
        const cannotUndoDueToResources = [];
        for (const editStack of editStackSnapshot.editStacks)if (editStack.getClosestPastElement() !== element) cannotUndoDueToResources.push(editStack.resourceLabel);
        if (cannotUndoDueToResources.length > 0) return this._tryToSplitAndUndo(strResource, element, null, _nlsJs.localize({
            key: "cannotWorkspaceUndoDueToChanges",
            comment: [
                "{0} is a label for an operation. {1} is a list of filenames."
            ]
        }, "Could not undo '{0}' across all files because changes were made to {1}", element.label, cannotUndoDueToResources.join(", ")));
        const cannotLockDueToResources = [];
        for (const editStack of editStackSnapshot.editStacks)if (editStack.locked) cannotLockDueToResources.push(editStack.resourceLabel);
        if (cannotLockDueToResources.length > 0) return this._tryToSplitAndUndo(strResource, element, null, _nlsJs.localize({
            key: "cannotWorkspaceUndoDueToInProgressUndoRedo",
            comment: [
                "{0} is a label for an operation. {1} is a list of filenames."
            ]
        }, "Could not undo '{0}' across all files because there is already an undo or redo operation running on {1}", element.label, cannotLockDueToResources.join(", ")));
        // check if new stack elements were added in the meantime...
        if (!editStackSnapshot.isValid()) return this._tryToSplitAndUndo(strResource, element, null, _nlsJs.localize({
            key: "cannotWorkspaceUndoDueToInMeantimeUndoRedo",
            comment: [
                "{0} is a label for an operation. {1} is a list of filenames."
            ]
        }, "Could not undo '{0}' across all files because an undo or redo operation occurred in the meantime", element.label));
        return null;
    }
    _workspaceUndo(strResource, element, undoConfirmed) {
        const affectedEditStacks = this._getAffectedEditStacks(element);
        const verificationError = this._checkWorkspaceUndo(strResource, element, affectedEditStacks, /*invalidated resources will be checked after the prepare call*/ false);
        if (verificationError) return verificationError.returnValue;
        return this._confirmAndExecuteWorkspaceUndo(strResource, element, affectedEditStacks, undoConfirmed);
    }
    _isPartOfUndoGroup(element) {
        if (!element.groupId) return false;
        // check that there is at least another element with the same groupId ready to be undone
        for (const [, editStack] of this._editStacks){
            const pastElement = editStack.getClosestPastElement();
            if (!pastElement) continue;
            if (pastElement === element) {
                const secondPastElement = editStack.getSecondClosestPastElement();
                if (secondPastElement && secondPastElement.groupId === element.groupId) // there is another element with the same group id in the same stack!
                return true;
            }
            if (pastElement.groupId === element.groupId) // there is another element with the same group id in another stack!
            return true;
        }
        return false;
    }
    async _confirmAndExecuteWorkspaceUndo(strResource, element, editStackSnapshot, undoConfirmed) {
        if (element.canSplit() && !this._isPartOfUndoGroup(element)) {
            // this element can be split
            let UndoChoice;
            (function(UndoChoice) {
                UndoChoice[UndoChoice["All"] = 0] = "All";
                UndoChoice[UndoChoice["This"] = 1] = "This";
                UndoChoice[UndoChoice["Cancel"] = 2] = "Cancel";
            })(UndoChoice || (UndoChoice = {}));
            const { result } = await this._dialogService.prompt({
                type: (0, _severityJsDefault.default).Info,
                message: _nlsJs.localize("confirmWorkspace", "Would you like to undo '{0}' across all files?", element.label),
                buttons: [
                    {
                        label: _nlsJs.localize({
                            key: "ok",
                            comment: [
                                "{0} denotes a number that is > 1, && denotes a mnemonic"
                            ]
                        }, "&&Undo in {0} Files", editStackSnapshot.editStacks.length),
                        run: ()=>UndoChoice.All
                    },
                    {
                        label: _nlsJs.localize({
                            key: "nok",
                            comment: [
                                "&& denotes a mnemonic"
                            ]
                        }, "Undo this &&File"),
                        run: ()=>UndoChoice.This
                    }
                ],
                cancelButton: {
                    run: ()=>UndoChoice.Cancel
                }
            });
            if (result === UndoChoice.Cancel) // choice: cancel
            return;
            if (result === UndoChoice.This) {
                // choice: undo this file
                this._splitPastWorkspaceElement(element, null);
                return this._undo(strResource, 0, true);
            }
            // choice: undo in all files
            // At this point, it is possible that the element has been made invalid in the meantime (due to the confirmation await)
            const verificationError1 = this._checkWorkspaceUndo(strResource, element, editStackSnapshot, /*invalidated resources will be checked after the prepare call*/ false);
            if (verificationError1) return verificationError1.returnValue;
            undoConfirmed = true;
        }
        // prepare
        let cleanup;
        try {
            cleanup = await this._invokeWorkspacePrepare(element);
        } catch (err) {
            return this._onError(err, element);
        }
        // At this point, it is possible that the element has been made invalid in the meantime (due to the prepare await)
        const verificationError2 = this._checkWorkspaceUndo(strResource, element, editStackSnapshot, /*now also check that there are no more invalidated resources*/ true);
        if (verificationError2) {
            cleanup.dispose();
            return verificationError2.returnValue;
        }
        for (const editStack of editStackSnapshot.editStacks)editStack.moveBackward(element);
        return this._safeInvokeWithLocks(element, ()=>element.actual.undo(), editStackSnapshot, cleanup, ()=>this._continueUndoInGroup(element.groupId, undoConfirmed));
    }
    _resourceUndo(editStack, element, undoConfirmed) {
        if (!element.isValid) {
            // invalid element => immediately flush edit stack!
            editStack.flushAllElements();
            return;
        }
        if (editStack.locked) {
            const message = _nlsJs.localize({
                key: "cannotResourceUndoDueToInProgressUndoRedo",
                comment: [
                    "{0} is a label for an operation."
                ]
            }, "Could not undo '{0}' because there is already an undo or redo operation running.", element.label);
            this._notificationService.warn(message);
            return;
        }
        return this._invokeResourcePrepare(element, (cleanup)=>{
            editStack.moveBackward(element);
            return this._safeInvokeWithLocks(element, ()=>element.actual.undo(), new EditStackSnapshot([
                editStack
            ]), cleanup, ()=>this._continueUndoInGroup(element.groupId, undoConfirmed));
        });
    }
    _findClosestUndoElementInGroup(groupId) {
        if (!groupId) return [
            null,
            null
        ];
        // find another element with the same groupId and with the highest groupOrder ready to be undone
        let matchedElement = null;
        let matchedStrResource = null;
        for (const [strResource, editStack] of this._editStacks){
            const candidate = editStack.getClosestPastElement();
            if (!candidate) continue;
            if (candidate.groupId === groupId) {
                if (!matchedElement || candidate.groupOrder > matchedElement.groupOrder) {
                    matchedElement = candidate;
                    matchedStrResource = strResource;
                }
            }
        }
        return [
            matchedElement,
            matchedStrResource
        ];
    }
    _continueUndoInGroup(groupId, undoConfirmed) {
        if (!groupId) return;
        const [, matchedStrResource] = this._findClosestUndoElementInGroup(groupId);
        if (matchedStrResource) return this._undo(matchedStrResource, 0, undoConfirmed);
    }
    undo(resourceOrSource) {
        if (resourceOrSource instanceof (0, _undoRedoJs.UndoRedoSource)) {
            const [, matchedStrResource] = this._findClosestUndoElementWithSource(resourceOrSource.id);
            return matchedStrResource ? this._undo(matchedStrResource, resourceOrSource.id, false) : undefined;
        }
        if (typeof resourceOrSource === "string") return this._undo(resourceOrSource, 0, false);
        return this._undo(this.getUriComparisonKey(resourceOrSource), 0, false);
    }
    _undo(strResource, sourceId = 0, undoConfirmed) {
        if (!this._editStacks.has(strResource)) return;
        const editStack = this._editStacks.get(strResource);
        const element = editStack.getClosestPastElement();
        if (!element) return;
        if (element.groupId) {
            // this element is a part of a group, we need to make sure undoing in a group is in order
            const [matchedElement, matchedStrResource] = this._findClosestUndoElementInGroup(element.groupId);
            if (element !== matchedElement && matchedStrResource) // there is an element in the same group that should be undone before this one
            return this._undo(matchedStrResource, sourceId, undoConfirmed);
        }
        const shouldPromptForConfirmation = element.sourceId !== sourceId || element.confirmBeforeUndo;
        if (shouldPromptForConfirmation && !undoConfirmed) // Hit a different source or the element asks for prompt before undo, prompt for confirmation
        return this._confirmAndContinueUndo(strResource, sourceId, element);
        try {
            if (element.type === 1 /* UndoRedoElementType.Workspace */ ) return this._workspaceUndo(strResource, element, undoConfirmed);
            else return this._resourceUndo(editStack, element, undoConfirmed);
        } finally{
            if (DEBUG) this._print("undo");
        }
    }
    async _confirmAndContinueUndo(strResource, sourceId, element) {
        const result = await this._dialogService.confirm({
            message: _nlsJs.localize("confirmDifferentSource", "Would you like to undo '{0}'?", element.label),
            primaryButton: _nlsJs.localize({
                key: "confirmDifferentSource.yes",
                comment: [
                    "&& denotes a mnemonic"
                ]
            }, "&&Yes"),
            cancelButton: _nlsJs.localize("confirmDifferentSource.no", "No")
        });
        if (!result.confirmed) return;
        return this._undo(strResource, sourceId, true);
    }
    _findClosestRedoElementWithSource(sourceId) {
        if (!sourceId) return [
            null,
            null
        ];
        // find an element with sourceId and with the lowest sourceOrder ready to be redone
        let matchedElement = null;
        let matchedStrResource = null;
        for (const [strResource, editStack] of this._editStacks){
            const candidate = editStack.getClosestFutureElement();
            if (!candidate) continue;
            if (candidate.sourceId === sourceId) {
                if (!matchedElement || candidate.sourceOrder < matchedElement.sourceOrder) {
                    matchedElement = candidate;
                    matchedStrResource = strResource;
                }
            }
        }
        return [
            matchedElement,
            matchedStrResource
        ];
    }
    canRedo(resourceOrSource) {
        if (resourceOrSource instanceof (0, _undoRedoJs.UndoRedoSource)) {
            const [, matchedStrResource] = this._findClosestRedoElementWithSource(resourceOrSource.id);
            return matchedStrResource ? true : false;
        }
        const strResource = this.getUriComparisonKey(resourceOrSource);
        if (this._editStacks.has(strResource)) {
            const editStack = this._editStacks.get(strResource);
            return editStack.hasFutureElements();
        }
        return false;
    }
    _tryToSplitAndRedo(strResource, element, ignoreResources, message) {
        if (element.canSplit()) {
            this._splitFutureWorkspaceElement(element, ignoreResources);
            this._notificationService.warn(message);
            return new WorkspaceVerificationError(this._redo(strResource));
        } else {
            // Cannot safely split this workspace element => flush all undo/redo stacks
            for (const strResource of element.strResources)this.removeElements(strResource);
            this._notificationService.warn(message);
            return new WorkspaceVerificationError();
        }
    }
    _checkWorkspaceRedo(strResource, element, editStackSnapshot, checkInvalidatedResources) {
        if (element.removedResources) return this._tryToSplitAndRedo(strResource, element, element.removedResources, _nlsJs.localize({
            key: "cannotWorkspaceRedo",
            comment: [
                "{0} is a label for an operation. {1} is another message."
            ]
        }, "Could not redo '{0}' across all files. {1}", element.label, element.removedResources.createMessage()));
        if (checkInvalidatedResources && element.invalidatedResources) return this._tryToSplitAndRedo(strResource, element, element.invalidatedResources, _nlsJs.localize({
            key: "cannotWorkspaceRedo",
            comment: [
                "{0} is a label for an operation. {1} is another message."
            ]
        }, "Could not redo '{0}' across all files. {1}", element.label, element.invalidatedResources.createMessage()));
        // this must be the last future element in all the impacted resources!
        const cannotRedoDueToResources = [];
        for (const editStack of editStackSnapshot.editStacks)if (editStack.getClosestFutureElement() !== element) cannotRedoDueToResources.push(editStack.resourceLabel);
        if (cannotRedoDueToResources.length > 0) return this._tryToSplitAndRedo(strResource, element, null, _nlsJs.localize({
            key: "cannotWorkspaceRedoDueToChanges",
            comment: [
                "{0} is a label for an operation. {1} is a list of filenames."
            ]
        }, "Could not redo '{0}' across all files because changes were made to {1}", element.label, cannotRedoDueToResources.join(", ")));
        const cannotLockDueToResources = [];
        for (const editStack of editStackSnapshot.editStacks)if (editStack.locked) cannotLockDueToResources.push(editStack.resourceLabel);
        if (cannotLockDueToResources.length > 0) return this._tryToSplitAndRedo(strResource, element, null, _nlsJs.localize({
            key: "cannotWorkspaceRedoDueToInProgressUndoRedo",
            comment: [
                "{0} is a label for an operation. {1} is a list of filenames."
            ]
        }, "Could not redo '{0}' across all files because there is already an undo or redo operation running on {1}", element.label, cannotLockDueToResources.join(", ")));
        // check if new stack elements were added in the meantime...
        if (!editStackSnapshot.isValid()) return this._tryToSplitAndRedo(strResource, element, null, _nlsJs.localize({
            key: "cannotWorkspaceRedoDueToInMeantimeUndoRedo",
            comment: [
                "{0} is a label for an operation. {1} is a list of filenames."
            ]
        }, "Could not redo '{0}' across all files because an undo or redo operation occurred in the meantime", element.label));
        return null;
    }
    _workspaceRedo(strResource, element) {
        const affectedEditStacks = this._getAffectedEditStacks(element);
        const verificationError = this._checkWorkspaceRedo(strResource, element, affectedEditStacks, /*invalidated resources will be checked after the prepare call*/ false);
        if (verificationError) return verificationError.returnValue;
        return this._executeWorkspaceRedo(strResource, element, affectedEditStacks);
    }
    async _executeWorkspaceRedo(strResource, element, editStackSnapshot) {
        // prepare
        let cleanup;
        try {
            cleanup = await this._invokeWorkspacePrepare(element);
        } catch (err) {
            return this._onError(err, element);
        }
        // At this point, it is possible that the element has been made invalid in the meantime (due to the prepare await)
        const verificationError = this._checkWorkspaceRedo(strResource, element, editStackSnapshot, /*now also check that there are no more invalidated resources*/ true);
        if (verificationError) {
            cleanup.dispose();
            return verificationError.returnValue;
        }
        for (const editStack of editStackSnapshot.editStacks)editStack.moveForward(element);
        return this._safeInvokeWithLocks(element, ()=>element.actual.redo(), editStackSnapshot, cleanup, ()=>this._continueRedoInGroup(element.groupId));
    }
    _resourceRedo(editStack, element) {
        if (!element.isValid) {
            // invalid element => immediately flush edit stack!
            editStack.flushAllElements();
            return;
        }
        if (editStack.locked) {
            const message = _nlsJs.localize({
                key: "cannotResourceRedoDueToInProgressUndoRedo",
                comment: [
                    "{0} is a label for an operation."
                ]
            }, "Could not redo '{0}' because there is already an undo or redo operation running.", element.label);
            this._notificationService.warn(message);
            return;
        }
        return this._invokeResourcePrepare(element, (cleanup)=>{
            editStack.moveForward(element);
            return this._safeInvokeWithLocks(element, ()=>element.actual.redo(), new EditStackSnapshot([
                editStack
            ]), cleanup, ()=>this._continueRedoInGroup(element.groupId));
        });
    }
    _findClosestRedoElementInGroup(groupId) {
        if (!groupId) return [
            null,
            null
        ];
        // find another element with the same groupId and with the lowest groupOrder ready to be redone
        let matchedElement = null;
        let matchedStrResource = null;
        for (const [strResource, editStack] of this._editStacks){
            const candidate = editStack.getClosestFutureElement();
            if (!candidate) continue;
            if (candidate.groupId === groupId) {
                if (!matchedElement || candidate.groupOrder < matchedElement.groupOrder) {
                    matchedElement = candidate;
                    matchedStrResource = strResource;
                }
            }
        }
        return [
            matchedElement,
            matchedStrResource
        ];
    }
    _continueRedoInGroup(groupId) {
        if (!groupId) return;
        const [, matchedStrResource] = this._findClosestRedoElementInGroup(groupId);
        if (matchedStrResource) return this._redo(matchedStrResource);
    }
    redo(resourceOrSource) {
        if (resourceOrSource instanceof (0, _undoRedoJs.UndoRedoSource)) {
            const [, matchedStrResource] = this._findClosestRedoElementWithSource(resourceOrSource.id);
            return matchedStrResource ? this._redo(matchedStrResource) : undefined;
        }
        if (typeof resourceOrSource === "string") return this._redo(resourceOrSource);
        return this._redo(this.getUriComparisonKey(resourceOrSource));
    }
    _redo(strResource) {
        if (!this._editStacks.has(strResource)) return;
        const editStack = this._editStacks.get(strResource);
        const element = editStack.getClosestFutureElement();
        if (!element) return;
        if (element.groupId) {
            // this element is a part of a group, we need to make sure redoing in a group is in order
            const [matchedElement, matchedStrResource] = this._findClosestRedoElementInGroup(element.groupId);
            if (element !== matchedElement && matchedStrResource) // there is an element in the same group that should be redone before this one
            return this._redo(matchedStrResource);
        }
        try {
            if (element.type === 1 /* UndoRedoElementType.Workspace */ ) return this._workspaceRedo(strResource, element);
            else return this._resourceRedo(editStack, element);
        } finally{
            if (DEBUG) this._print("redo");
        }
    }
};
UndoRedoService = __decorate([
    __param(0, (0, _dialogsJs.IDialogService)),
    __param(1, (0, _notificationJs.INotificationService))
], UndoRedoService);
class WorkspaceVerificationError {
    constructor(returnValue){
        this.returnValue = returnValue;
    }
}
(0, _extensionsJs.registerSingleton)((0, _undoRedoJs.IUndoRedoService), UndoRedoService, 1 /* InstantiationType.Delayed */ );

},{"../../../base/common/errors.js":"divX8","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/network.js":"2c1AD","../../../base/common/severity.js":"faBYp","../../../nls.js":"l617d","../../dialogs/common/dialogs.js":"3ZDTa","../../instantiation/common/extensions.js":"6WJLq","../../notification/common/notification.js":"igv0W","./undoRedo.js":"cXL0O","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"faBYp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stringsJs = require("./strings.js");
var Severity;
(function(Severity) {
    Severity[Severity["Ignore"] = 0] = "Ignore";
    Severity[Severity["Info"] = 1] = "Info";
    Severity[Severity["Warning"] = 2] = "Warning";
    Severity[Severity["Error"] = 3] = "Error";
})(Severity || (Severity = {}));
(function(Severity) {
    const _error = "error";
    const _warning = "warning";
    const _warn = "warn";
    const _info = "info";
    const _ignore = "ignore";
    /**
     * Parses 'error', 'warning', 'warn', 'info' in call casings
     * and falls back to ignore.
     */ function fromValue(value) {
        if (!value) return Severity.Ignore;
        if (_stringsJs.equalsIgnoreCase(_error, value)) return Severity.Error;
        if (_stringsJs.equalsIgnoreCase(_warning, value) || _stringsJs.equalsIgnoreCase(_warn, value)) return Severity.Warning;
        if (_stringsJs.equalsIgnoreCase(_info, value)) return Severity.Info;
        return Severity.Ignore;
    }
    Severity.fromValue = fromValue;
    function toString(severity) {
        switch(severity){
            case Severity.Error:
                return _error;
            case Severity.Warning:
                return _warning;
            case Severity.Info:
                return _info;
            default:
                return _ignore;
        }
    }
    Severity.toString = toString;
})(Severity || (Severity = {}));
exports.default = Severity;

},{"./strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ZDTa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IDialogService", ()=>IDialogService);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IDialogService = (0, _instantiationJs.createDecorator)("dialogService");

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"igv0W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Severity", ()=>Severity);
parcelHelpers.export(exports, "INotificationService", ()=>INotificationService);
parcelHelpers.export(exports, "NoOpNotification", ()=>NoOpNotification);
var _severityJs = require("../../../base/common/severity.js");
var _severityJsDefault = parcelHelpers.interopDefault(_severityJs);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var Severity = (0, _severityJsDefault.default);
const INotificationService = (0, _instantiationJs.createDecorator)("notificationService");
class NoOpNotification {
}

},{"../../../base/common/severity.js":"faBYp","../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cXL0O":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IUndoRedoService", ()=>IUndoRedoService);
parcelHelpers.export(exports, "ResourceEditStackSnapshot", ()=>ResourceEditStackSnapshot);
parcelHelpers.export(exports, "UndoRedoGroup", ()=>UndoRedoGroup);
parcelHelpers.export(exports, "UndoRedoSource", ()=>UndoRedoSource);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IUndoRedoService = (0, _instantiationJs.createDecorator)("undoRedoService");
class ResourceEditStackSnapshot {
    constructor(resource, elements){
        this.resource = resource;
        this.elements = elements;
    }
}
class UndoRedoGroup {
    static{
        this._ID = 0;
    }
    constructor(){
        this.id = UndoRedoGroup._ID++;
        this.order = 1;
    }
    nextOrder() {
        if (this.id === 0) return 0;
        return this.order++;
    }
    static{
        this.None = new UndoRedoGroup();
    }
}
class UndoRedoSource {
    static{
        this._ID = 0;
    }
    constructor(){
        this.id = UndoRedoSource._ID++;
        this.order = 1;
    }
    nextOrder() {
        if (this.id === 0) return 0;
        return this.order++;
    }
    static{
        this.None = new UndoRedoSource();
    }
}

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"YGXXG":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ILanguageFeatureDebounceService", ()=>ILanguageFeatureDebounceService);
parcelHelpers.export(exports, "LanguageFeatureDebounceService", ()=>LanguageFeatureDebounceService);
var _hashJs = require("../../../base/common/hash.js");
var _mapJs = require("../../../base/common/map.js");
var _numbersJs = require("../../../base/common/numbers.js");
var _environmentJs = require("../../../platform/environment/common/environment.js");
var _extensionsJs = require("../../../platform/instantiation/common/extensions.js");
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
var _logJs = require("../../../platform/log/common/log.js");
var _networkJs = require("../../../base/common/network.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const ILanguageFeatureDebounceService = (0, _instantiationJs.createDecorator)("ILanguageFeatureDebounceService");
var IdentityHash;
(function(IdentityHash) {
    const _hashes = new WeakMap();
    let pool = 0;
    function of(obj) {
        let value = _hashes.get(obj);
        if (value === undefined) {
            value = ++pool;
            _hashes.set(obj, value);
        }
        return value;
    }
    IdentityHash.of = of;
})(IdentityHash || (IdentityHash = {}));
class NullDebounceInformation {
    constructor(_default){
        this._default = _default;
    }
    get(_model) {
        return this._default;
    }
    update(_model, _value) {
        return this._default;
    }
    default() {
        return this._default;
    }
}
class FeatureDebounceInformation {
    constructor(_logService, _name, _registry, _default, _min, _max){
        this._logService = _logService;
        this._name = _name;
        this._registry = _registry;
        this._default = _default;
        this._min = _min;
        this._max = _max;
        this._cache = new (0, _mapJs.LRUCache)(50, 0.7);
    }
    _key(model) {
        return model.id + this._registry.all(model).reduce((hashVal, obj)=>(0, _hashJs.doHash)(IdentityHash.of(obj), hashVal), 0);
    }
    get(model) {
        const key = this._key(model);
        const avg = this._cache.get(key);
        return avg ? (0, _numbersJs.clamp)(avg.value, this._min, this._max) : this.default();
    }
    update(model, value) {
        const key = this._key(model);
        let avg = this._cache.get(key);
        if (!avg) {
            avg = new (0, _numbersJs.SlidingWindowAverage)(6);
            this._cache.set(key, avg);
        }
        const newValue = (0, _numbersJs.clamp)(avg.update(value), this._min, this._max);
        if (!(0, _networkJs.matchesScheme)(model.uri, "output")) this._logService.trace(`[DEBOUNCE: ${this._name}] for ${model.uri.toString()} is ${newValue}ms`);
        return newValue;
    }
    _overall() {
        const result = new (0, _numbersJs.MovingAverage)();
        for (const [, avg] of this._cache)result.update(avg.value);
        return result.value;
    }
    default() {
        const value = this._overall() | 0 || this._default;
        return (0, _numbersJs.clamp)(value, this._min, this._max);
    }
}
let LanguageFeatureDebounceService = class LanguageFeatureDebounceService {
    constructor(_logService, envService){
        this._logService = _logService;
        this._data = new Map();
        this._isDev = envService.isExtensionDevelopment || !envService.isBuilt;
    }
    for(feature, name, config) {
        const min = config?.min ?? 50;
        const max = config?.max ?? min ** 2;
        const extra = config?.key ?? undefined;
        const key = `${IdentityHash.of(feature)},${min}${extra ? "," + extra : ""}`;
        let info = this._data.get(key);
        if (!info) {
            if (this._isDev) {
                this._logService.debug(`[DEBOUNCE: ${name}] is disabled in developed mode`);
                info = new NullDebounceInformation(min * 1.5);
            } else info = new FeatureDebounceInformation(this._logService, name, feature, this._overallAverage() | 0 || min * 1.5, min, max);
            this._data.set(key, info);
        }
        return info;
    }
    _overallAverage() {
        // Average of all language features. Not a great value but an approximation
        const result = new (0, _numbersJs.MovingAverage)();
        for (const info of this._data.values())result.update(info.default());
        return result.value;
    }
};
LanguageFeatureDebounceService = __decorate([
    __param(0, (0, _logJs.ILogService)),
    __param(1, (0, _environmentJs.IEnvironmentService))
], LanguageFeatureDebounceService);
(0, _extensionsJs.registerSingleton)(ILanguageFeatureDebounceService, LanguageFeatureDebounceService, 1 /* InstantiationType.Delayed */ );

},{"../../../base/common/hash.js":"hXc0q","../../../base/common/map.js":"leSjz","../../../base/common/numbers.js":"diWMG","../../../platform/environment/common/environment.js":"6y5Oq","../../../platform/instantiation/common/extensions.js":"6WJLq","../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../platform/log/common/log.js":"ieJUF","../../../base/common/network.js":"2c1AD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"diWMG":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "MovingAverage", ()=>MovingAverage);
parcelHelpers.export(exports, "SlidingWindowAverage", ()=>SlidingWindowAverage);
function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
class MovingAverage {
    constructor(){
        this._n = 1;
        this._val = 0;
    }
    update(value) {
        this._val = this._val + (value - this._val) / this._n;
        this._n += 1;
        return this._val;
    }
    get value() {
        return this._val;
    }
}
class SlidingWindowAverage {
    constructor(size){
        this._n = 0;
        this._val = 0;
        this._values = [];
        this._index = 0;
        this._sum = 0;
        this._values = new Array(size);
        this._values.fill(0, 0, size);
    }
    update(value) {
        const oldValue = this._values[this._index];
        this._values[this._index] = value;
        this._index = (this._index + 1) % this._values.length;
        this._sum -= oldValue;
        this._sum += value;
        if (this._n < this._values.length) this._n += 1;
        this._val = this._sum / this._n;
        return this._val;
    }
    get value() {
        return this._val;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6y5Oq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IEnvironmentService", ()=>IEnvironmentService);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IEnvironmentService = (0, _instantiationJs.createDecorator)("environmentService");

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3RsCI":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SemanticTokensStylingService", ()=>SemanticTokensStylingService);
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _languageJs = require("../languages/language.js");
var _themeServiceJs = require("../../../platform/theme/common/themeService.js");
var _logJs = require("../../../platform/log/common/log.js");
var _semanticTokensProviderStylingJs = require("./semanticTokensProviderStyling.js");
var _semanticTokensStylingJs = require("./semanticTokensStyling.js");
var _extensionsJs = require("../../../platform/instantiation/common/extensions.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let SemanticTokensStylingService = class SemanticTokensStylingService extends (0, _lifecycleJs.Disposable) {
    constructor(_themeService, _logService, _languageService){
        super();
        this._themeService = _themeService;
        this._logService = _logService;
        this._languageService = _languageService;
        this._caches = new WeakMap();
        this._register(this._themeService.onDidColorThemeChange(()=>{
            this._caches = new WeakMap();
        }));
    }
    getStyling(provider) {
        if (!this._caches.has(provider)) this._caches.set(provider, new (0, _semanticTokensProviderStylingJs.SemanticTokensProviderStyling)(provider.getLegend(), this._themeService, this._languageService, this._logService));
        return this._caches.get(provider);
    }
};
SemanticTokensStylingService = __decorate([
    __param(0, (0, _themeServiceJs.IThemeService)),
    __param(1, (0, _logJs.ILogService)),
    __param(2, (0, _languageJs.ILanguageService))
], SemanticTokensStylingService);
(0, _extensionsJs.registerSingleton)((0, _semanticTokensStylingJs.ISemanticTokensStylingService), SemanticTokensStylingService, 1 /* InstantiationType.Delayed */ );

},{"../../../base/common/lifecycle.js":"9kg8d","../languages/language.js":"ka2JQ","../../../platform/theme/common/themeService.js":"jMkIC","../../../platform/log/common/log.js":"ieJUF","./semanticTokensProviderStyling.js":"3j70w","./semanticTokensStyling.js":"gV4Rk","../../../platform/instantiation/common/extensions.js":"6WJLq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3j70w":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SemanticTokensProviderStyling", ()=>SemanticTokensProviderStyling);
parcelHelpers.export(exports, "toMultilineTokens2", ()=>toMultilineTokens2);
var _encodedTokenAttributesJs = require("../encodedTokenAttributes.js");
var _themeServiceJs = require("../../../platform/theme/common/themeService.js");
var _logJs = require("../../../platform/log/common/log.js");
var _sparseMultilineTokensJs = require("../tokens/sparseMultilineTokens.js");
var _languageJs = require("../languages/language.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const ENABLE_TRACE = false;
let SemanticTokensProviderStyling = class SemanticTokensProviderStyling {
    constructor(_legend, _themeService, _languageService, _logService){
        this._legend = _legend;
        this._themeService = _themeService;
        this._languageService = _languageService;
        this._logService = _logService;
        this._hasWarnedOverlappingTokens = false;
        this._hasWarnedInvalidLengthTokens = false;
        this._hasWarnedInvalidEditStart = false;
        this._hashTable = new HashTable();
    }
    getMetadata(tokenTypeIndex, tokenModifierSet, languageId) {
        const encodedLanguageId = this._languageService.languageIdCodec.encodeLanguageId(languageId);
        const entry = this._hashTable.get(tokenTypeIndex, tokenModifierSet, encodedLanguageId);
        let metadata;
        if (entry) {
            metadata = entry.metadata;
            if (ENABLE_TRACE && this._logService.getLevel() === (0, _logJs.LogLevel).Trace) this._logService.trace(`SemanticTokensProviderStyling [CACHED] ${tokenTypeIndex} / ${tokenModifierSet}: foreground ${(0, _encodedTokenAttributesJs.TokenMetadata).getForeground(metadata)}, fontStyle ${(0, _encodedTokenAttributesJs.TokenMetadata).getFontStyle(metadata).toString(2)}`);
        } else {
            let tokenType = this._legend.tokenTypes[tokenTypeIndex];
            const tokenModifiers = [];
            if (tokenType) {
                let modifierSet = tokenModifierSet;
                for(let modifierIndex = 0; modifierSet > 0 && modifierIndex < this._legend.tokenModifiers.length; modifierIndex++){
                    if (modifierSet & 1) tokenModifiers.push(this._legend.tokenModifiers[modifierIndex]);
                    modifierSet = modifierSet >> 1;
                }
                if (ENABLE_TRACE && modifierSet > 0 && this._logService.getLevel() === (0, _logJs.LogLevel).Trace) {
                    this._logService.trace(`SemanticTokensProviderStyling: unknown token modifier index: ${tokenModifierSet.toString(2)} for legend: ${JSON.stringify(this._legend.tokenModifiers)}`);
                    tokenModifiers.push("not-in-legend");
                }
                const tokenStyle = this._themeService.getColorTheme().getTokenStyleMetadata(tokenType, tokenModifiers, languageId);
                if (typeof tokenStyle === "undefined") metadata = 2147483647 /* SemanticTokensProviderStylingConstants.NO_STYLING */ ;
                else {
                    metadata = 0;
                    if (typeof tokenStyle.italic !== "undefined") {
                        const italicBit = (tokenStyle.italic ? 1 /* FontStyle.Italic */  : 0) << 11 /* MetadataConsts.FONT_STYLE_OFFSET */ ;
                        metadata |= italicBit | 1 /* MetadataConsts.SEMANTIC_USE_ITALIC */ ;
                    }
                    if (typeof tokenStyle.bold !== "undefined") {
                        const boldBit = (tokenStyle.bold ? 2 /* FontStyle.Bold */  : 0) << 11 /* MetadataConsts.FONT_STYLE_OFFSET */ ;
                        metadata |= boldBit | 2 /* MetadataConsts.SEMANTIC_USE_BOLD */ ;
                    }
                    if (typeof tokenStyle.underline !== "undefined") {
                        const underlineBit = (tokenStyle.underline ? 4 /* FontStyle.Underline */  : 0) << 11 /* MetadataConsts.FONT_STYLE_OFFSET */ ;
                        metadata |= underlineBit | 4 /* MetadataConsts.SEMANTIC_USE_UNDERLINE */ ;
                    }
                    if (typeof tokenStyle.strikethrough !== "undefined") {
                        const strikethroughBit = (tokenStyle.strikethrough ? 8 /* FontStyle.Strikethrough */  : 0) << 11 /* MetadataConsts.FONT_STYLE_OFFSET */ ;
                        metadata |= strikethroughBit | 8 /* MetadataConsts.SEMANTIC_USE_STRIKETHROUGH */ ;
                    }
                    if (tokenStyle.foreground) {
                        const foregroundBits = tokenStyle.foreground << 15 /* MetadataConsts.FOREGROUND_OFFSET */ ;
                        metadata |= foregroundBits | 16 /* MetadataConsts.SEMANTIC_USE_FOREGROUND */ ;
                    }
                    if (metadata === 0) // Nothing!
                    metadata = 2147483647 /* SemanticTokensProviderStylingConstants.NO_STYLING */ ;
                }
            } else {
                if (ENABLE_TRACE && this._logService.getLevel() === (0, _logJs.LogLevel).Trace) this._logService.trace(`SemanticTokensProviderStyling: unknown token type index: ${tokenTypeIndex} for legend: ${JSON.stringify(this._legend.tokenTypes)}`);
                metadata = 2147483647 /* SemanticTokensProviderStylingConstants.NO_STYLING */ ;
                tokenType = "not-in-legend";
            }
            this._hashTable.add(tokenTypeIndex, tokenModifierSet, encodedLanguageId, metadata);
            if (ENABLE_TRACE && this._logService.getLevel() === (0, _logJs.LogLevel).Trace) this._logService.trace(`SemanticTokensProviderStyling ${tokenTypeIndex} (${tokenType}) / ${tokenModifierSet} (${tokenModifiers.join(" ")}): foreground ${(0, _encodedTokenAttributesJs.TokenMetadata).getForeground(metadata)}, fontStyle ${(0, _encodedTokenAttributesJs.TokenMetadata).getFontStyle(metadata).toString(2)}`);
        }
        return metadata;
    }
    warnOverlappingSemanticTokens(lineNumber, startColumn) {
        if (!this._hasWarnedOverlappingTokens) {
            this._hasWarnedOverlappingTokens = true;
            this._logService.warn(`Overlapping semantic tokens detected at lineNumber ${lineNumber}, column ${startColumn}`);
        }
    }
    warnInvalidLengthSemanticTokens(lineNumber, startColumn) {
        if (!this._hasWarnedInvalidLengthTokens) {
            this._hasWarnedInvalidLengthTokens = true;
            this._logService.warn(`Semantic token with invalid length detected at lineNumber ${lineNumber}, column ${startColumn}`);
        }
    }
    warnInvalidEditStart(previousResultId, resultId, editIndex, editStart, maxExpectedStart) {
        if (!this._hasWarnedInvalidEditStart) {
            this._hasWarnedInvalidEditStart = true;
            this._logService.warn(`Invalid semantic tokens edit detected (previousResultId: ${previousResultId}, resultId: ${resultId}) at edit #${editIndex}: The provided start offset ${editStart} is outside the previous data (length ${maxExpectedStart}).`);
        }
    }
};
SemanticTokensProviderStyling = __decorate([
    __param(1, (0, _themeServiceJs.IThemeService)),
    __param(2, (0, _languageJs.ILanguageService)),
    __param(3, (0, _logJs.ILogService))
], SemanticTokensProviderStyling);
function toMultilineTokens2(tokens, styling, languageId) {
    const srcData = tokens.data;
    const tokenCount = tokens.data.length / 5 | 0;
    const tokensPerArea = Math.max(Math.ceil(tokenCount / 1024 /* SemanticColoringConstants.DesiredMaxAreas */ ), 400 /* SemanticColoringConstants.DesiredTokensPerArea */ );
    const result = [];
    let tokenIndex = 0;
    let lastLineNumber = 1;
    let lastStartCharacter = 0;
    while(tokenIndex < tokenCount){
        const tokenStartIndex = tokenIndex;
        let tokenEndIndex = Math.min(tokenStartIndex + tokensPerArea, tokenCount);
        // Keep tokens on the same line in the same area...
        if (tokenEndIndex < tokenCount) {
            let smallTokenEndIndex = tokenEndIndex;
            while(smallTokenEndIndex - 1 > tokenStartIndex && srcData[5 * smallTokenEndIndex] === 0)smallTokenEndIndex--;
            if (smallTokenEndIndex - 1 === tokenStartIndex) {
                // there are so many tokens on this line that our area would be empty, we must now go right
                let bigTokenEndIndex = tokenEndIndex;
                while(bigTokenEndIndex + 1 < tokenCount && srcData[5 * bigTokenEndIndex] === 0)bigTokenEndIndex++;
                tokenEndIndex = bigTokenEndIndex;
            } else tokenEndIndex = smallTokenEndIndex;
        }
        let destData = new Uint32Array((tokenEndIndex - tokenStartIndex) * 4);
        let destOffset = 0;
        let areaLine = 0;
        let prevLineNumber = 0;
        let prevEndCharacter = 0;
        while(tokenIndex < tokenEndIndex){
            const srcOffset = 5 * tokenIndex;
            const deltaLine = srcData[srcOffset];
            const deltaCharacter = srcData[srcOffset + 1];
            // Casting both `lineNumber`, `startCharacter` and `endCharacter` here to uint32 using `|0`
            // to validate below with the actual values that will be inserted in the Uint32Array result
            const lineNumber = lastLineNumber + deltaLine | 0;
            const startCharacter = deltaLine === 0 ? lastStartCharacter + deltaCharacter | 0 : deltaCharacter;
            const length = srcData[srcOffset + 2];
            const endCharacter = startCharacter + length | 0;
            const tokenTypeIndex = srcData[srcOffset + 3];
            const tokenModifierSet = srcData[srcOffset + 4];
            if (endCharacter <= startCharacter) // this token is invalid (most likely a negative length casted to uint32)
            styling.warnInvalidLengthSemanticTokens(lineNumber, startCharacter + 1);
            else if (prevLineNumber === lineNumber && prevEndCharacter > startCharacter) // this token overlaps with the previous token
            styling.warnOverlappingSemanticTokens(lineNumber, startCharacter + 1);
            else {
                const metadata = styling.getMetadata(tokenTypeIndex, tokenModifierSet, languageId);
                if (metadata !== 2147483647 /* SemanticTokensProviderStylingConstants.NO_STYLING */ ) {
                    if (areaLine === 0) areaLine = lineNumber;
                    destData[destOffset] = lineNumber - areaLine;
                    destData[destOffset + 1] = startCharacter;
                    destData[destOffset + 2] = endCharacter;
                    destData[destOffset + 3] = metadata;
                    destOffset += 4;
                    prevLineNumber = lineNumber;
                    prevEndCharacter = endCharacter;
                }
            }
            lastLineNumber = lineNumber;
            lastStartCharacter = startCharacter;
            tokenIndex++;
        }
        if (destOffset !== destData.length) destData = destData.subarray(0, destOffset);
        const tokens = (0, _sparseMultilineTokensJs.SparseMultilineTokens).create(areaLine, destData);
        result.push(tokens);
    }
    return result;
}
class HashTableEntry {
    constructor(tokenTypeIndex, tokenModifierSet, languageId, metadata){
        this.tokenTypeIndex = tokenTypeIndex;
        this.tokenModifierSet = tokenModifierSet;
        this.languageId = languageId;
        this.metadata = metadata;
        this.next = null;
    }
}
class HashTable {
    static{
        this._SIZES = [
            3,
            7,
            13,
            31,
            61,
            127,
            251,
            509,
            1021,
            2039,
            4093,
            8191,
            16381,
            32749,
            65521,
            131071,
            262139,
            524287,
            1048573,
            2097143
        ];
    }
    constructor(){
        this._elementsCount = 0;
        this._currentLengthIndex = 0;
        this._currentLength = HashTable._SIZES[this._currentLengthIndex];
        this._growCount = Math.round(this._currentLengthIndex + 1 < HashTable._SIZES.length ? 2 / 3 * this._currentLength : 0);
        this._elements = [];
        HashTable._nullOutEntries(this._elements, this._currentLength);
    }
    static _nullOutEntries(entries, length) {
        for(let i = 0; i < length; i++)entries[i] = null;
    }
    _hash2(n1, n2) {
        return (n1 << 5) - n1 + n2 | 0; // n1 * 31 + n2, keep as int32
    }
    _hashFunc(tokenTypeIndex, tokenModifierSet, languageId) {
        return this._hash2(this._hash2(tokenTypeIndex, tokenModifierSet), languageId) % this._currentLength;
    }
    get(tokenTypeIndex, tokenModifierSet, languageId) {
        const hash = this._hashFunc(tokenTypeIndex, tokenModifierSet, languageId);
        let p = this._elements[hash];
        while(p){
            if (p.tokenTypeIndex === tokenTypeIndex && p.tokenModifierSet === tokenModifierSet && p.languageId === languageId) return p;
            p = p.next;
        }
        return null;
    }
    add(tokenTypeIndex, tokenModifierSet, languageId, metadata) {
        this._elementsCount++;
        if (this._growCount !== 0 && this._elementsCount >= this._growCount) {
            // expand!
            const oldElements = this._elements;
            this._currentLengthIndex++;
            this._currentLength = HashTable._SIZES[this._currentLengthIndex];
            this._growCount = Math.round(this._currentLengthIndex + 1 < HashTable._SIZES.length ? 2 / 3 * this._currentLength : 0);
            this._elements = [];
            HashTable._nullOutEntries(this._elements, this._currentLength);
            for (const first of oldElements){
                let p = first;
                while(p){
                    const oldNext = p.next;
                    p.next = null;
                    this._add(p);
                    p = oldNext;
                }
            }
        }
        this._add(new HashTableEntry(tokenTypeIndex, tokenModifierSet, languageId, metadata));
    }
    _add(element) {
        const hash = this._hashFunc(element.tokenTypeIndex, element.tokenModifierSet, element.languageId);
        element.next = this._elements[hash];
        this._elements[hash] = element;
    }
}

},{"../encodedTokenAttributes.js":"eH8EQ","../../../platform/theme/common/themeService.js":"jMkIC","../../../platform/log/common/log.js":"ieJUF","../tokens/sparseMultilineTokens.js":"3ZGnb","../languages/language.js":"ka2JQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eH8EQ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenMetadata", ()=>TokenMetadata);
class TokenMetadata {
    static getLanguageId(metadata) {
        return (metadata & 255 /* MetadataConsts.LANGUAGEID_MASK */ ) >>> 0 /* MetadataConsts.LANGUAGEID_OFFSET */ ;
    }
    static getTokenType(metadata) {
        return (metadata & 768 /* MetadataConsts.TOKEN_TYPE_MASK */ ) >>> 8 /* MetadataConsts.TOKEN_TYPE_OFFSET */ ;
    }
    static containsBalancedBrackets(metadata) {
        return (metadata & 1024 /* MetadataConsts.BALANCED_BRACKETS_MASK */ ) !== 0;
    }
    static getFontStyle(metadata) {
        return (metadata & 30720 /* MetadataConsts.FONT_STYLE_MASK */ ) >>> 11 /* MetadataConsts.FONT_STYLE_OFFSET */ ;
    }
    static getForeground(metadata) {
        return (metadata & 16744448 /* MetadataConsts.FOREGROUND_MASK */ ) >>> 15 /* MetadataConsts.FOREGROUND_OFFSET */ ;
    }
    static getBackground(metadata) {
        return (metadata & 4278190080 /* MetadataConsts.BACKGROUND_MASK */ ) >>> 24 /* MetadataConsts.BACKGROUND_OFFSET */ ;
    }
    static getClassNameFromMetadata(metadata) {
        const foreground = this.getForeground(metadata);
        let className = "mtk" + foreground;
        const fontStyle = this.getFontStyle(metadata);
        if (fontStyle & 1 /* FontStyle.Italic */ ) className += " mtki";
        if (fontStyle & 2 /* FontStyle.Bold */ ) className += " mtkb";
        if (fontStyle & 4 /* FontStyle.Underline */ ) className += " mtku";
        if (fontStyle & 8 /* FontStyle.Strikethrough */ ) className += " mtks";
        return className;
    }
    static getInlineStyleFromMetadata(metadata, colorMap) {
        const foreground = this.getForeground(metadata);
        const fontStyle = this.getFontStyle(metadata);
        let result = `color: ${colorMap[foreground]};`;
        if (fontStyle & 1 /* FontStyle.Italic */ ) result += "font-style: italic;";
        if (fontStyle & 2 /* FontStyle.Bold */ ) result += "font-weight: bold;";
        let textDecoration = "";
        if (fontStyle & 4 /* FontStyle.Underline */ ) textDecoration += " underline";
        if (fontStyle & 8 /* FontStyle.Strikethrough */ ) textDecoration += " line-through";
        if (textDecoration) result += `text-decoration:${textDecoration};`;
        return result;
    }
    static getPresentationFromMetadata(metadata) {
        const foreground = this.getForeground(metadata);
        const fontStyle = this.getFontStyle(metadata);
        return {
            foreground: foreground,
            italic: Boolean(fontStyle & 1 /* FontStyle.Italic */ ),
            bold: Boolean(fontStyle & 2 /* FontStyle.Bold */ ),
            underline: Boolean(fontStyle & 4 /* FontStyle.Underline */ ),
            strikethrough: Boolean(fontStyle & 8 /* FontStyle.Strikethrough */ )
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ZGnb":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents sparse tokens over a contiguous range of lines.
 */ parcelHelpers.export(exports, "SparseMultilineTokens", ()=>SparseMultilineTokens);
parcelHelpers.export(exports, "SparseLineTokens", ()=>SparseLineTokens);
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
var _eolCounterJs = require("../core/eolCounter.js");
class SparseMultilineTokens {
    static create(startLineNumber, tokens) {
        return new SparseMultilineTokens(startLineNumber, new SparseMultilineTokensStorage(tokens));
    }
    /**
     * (Inclusive) start line number for these tokens.
     */ get startLineNumber() {
        return this._startLineNumber;
    }
    /**
     * (Inclusive) end line number for these tokens.
     */ get endLineNumber() {
        return this._endLineNumber;
    }
    constructor(startLineNumber, tokens){
        this._startLineNumber = startLineNumber;
        this._tokens = tokens;
        this._endLineNumber = this._startLineNumber + this._tokens.getMaxDeltaLine();
    }
    toString() {
        return this._tokens.toString(this._startLineNumber);
    }
    _updateEndLineNumber() {
        this._endLineNumber = this._startLineNumber + this._tokens.getMaxDeltaLine();
    }
    isEmpty() {
        return this._tokens.isEmpty();
    }
    getLineTokens(lineNumber) {
        if (this._startLineNumber <= lineNumber && lineNumber <= this._endLineNumber) return this._tokens.getLineTokens(lineNumber - this._startLineNumber);
        return null;
    }
    getRange() {
        const deltaRange = this._tokens.getRange();
        if (!deltaRange) return deltaRange;
        return new (0, _rangeJs.Range)(this._startLineNumber + deltaRange.startLineNumber, deltaRange.startColumn, this._startLineNumber + deltaRange.endLineNumber, deltaRange.endColumn);
    }
    removeTokens(range) {
        const startLineIndex = range.startLineNumber - this._startLineNumber;
        const endLineIndex = range.endLineNumber - this._startLineNumber;
        this._startLineNumber += this._tokens.removeTokens(startLineIndex, range.startColumn - 1, endLineIndex, range.endColumn - 1);
        this._updateEndLineNumber();
    }
    split(range) {
        // split tokens to two:
        // a) all the tokens before `range`
        // b) all the tokens after `range`
        const startLineIndex = range.startLineNumber - this._startLineNumber;
        const endLineIndex = range.endLineNumber - this._startLineNumber;
        const [a, b, bDeltaLine] = this._tokens.split(startLineIndex, range.startColumn - 1, endLineIndex, range.endColumn - 1);
        return [
            new SparseMultilineTokens(this._startLineNumber, a),
            new SparseMultilineTokens(this._startLineNumber + bDeltaLine, b)
        ];
    }
    applyEdit(range, text) {
        const [eolCount, firstLineLength, lastLineLength] = (0, _eolCounterJs.countEOL)(text);
        this.acceptEdit(range, eolCount, firstLineLength, lastLineLength, text.length > 0 ? text.charCodeAt(0) : 0 /* CharCode.Null */ );
    }
    acceptEdit(range, eolCount, firstLineLength, lastLineLength, firstCharCode) {
        this._acceptDeleteRange(range);
        this._acceptInsertText(new (0, _positionJs.Position)(range.startLineNumber, range.startColumn), eolCount, firstLineLength, lastLineLength, firstCharCode);
        this._updateEndLineNumber();
    }
    _acceptDeleteRange(range) {
        if (range.startLineNumber === range.endLineNumber && range.startColumn === range.endColumn) // Nothing to delete
        return;
        const firstLineIndex = range.startLineNumber - this._startLineNumber;
        const lastLineIndex = range.endLineNumber - this._startLineNumber;
        if (lastLineIndex < 0) {
            // this deletion occurs entirely before this block, so we only need to adjust line numbers
            const deletedLinesCount = lastLineIndex - firstLineIndex;
            this._startLineNumber -= deletedLinesCount;
            return;
        }
        const tokenMaxDeltaLine = this._tokens.getMaxDeltaLine();
        if (firstLineIndex >= tokenMaxDeltaLine + 1) // this deletion occurs entirely after this block, so there is nothing to do
        return;
        if (firstLineIndex < 0 && lastLineIndex >= tokenMaxDeltaLine + 1) {
            // this deletion completely encompasses this block
            this._startLineNumber = 0;
            this._tokens.clear();
            return;
        }
        if (firstLineIndex < 0) {
            const deletedBefore = -firstLineIndex;
            this._startLineNumber -= deletedBefore;
            this._tokens.acceptDeleteRange(range.startColumn - 1, 0, 0, lastLineIndex, range.endColumn - 1);
        } else this._tokens.acceptDeleteRange(0, firstLineIndex, range.startColumn - 1, lastLineIndex, range.endColumn - 1);
    }
    _acceptInsertText(position, eolCount, firstLineLength, lastLineLength, firstCharCode) {
        if (eolCount === 0 && firstLineLength === 0) // Nothing to insert
        return;
        const lineIndex = position.lineNumber - this._startLineNumber;
        if (lineIndex < 0) {
            // this insertion occurs before this block, so we only need to adjust line numbers
            this._startLineNumber += eolCount;
            return;
        }
        const tokenMaxDeltaLine = this._tokens.getMaxDeltaLine();
        if (lineIndex >= tokenMaxDeltaLine + 1) // this insertion occurs after this block, so there is nothing to do
        return;
        this._tokens.acceptInsertText(lineIndex, position.column - 1, eolCount, firstLineLength, lastLineLength, firstCharCode);
    }
}
class SparseMultilineTokensStorage {
    constructor(tokens){
        this._tokens = tokens;
        this._tokenCount = tokens.length / 4;
    }
    toString(startLineNumber) {
        const pieces = [];
        for(let i = 0; i < this._tokenCount; i++)pieces.push(`(${this._getDeltaLine(i) + startLineNumber},${this._getStartCharacter(i)}-${this._getEndCharacter(i)})`);
        return `[${pieces.join(",")}]`;
    }
    getMaxDeltaLine() {
        const tokenCount = this._getTokenCount();
        if (tokenCount === 0) return -1;
        return this._getDeltaLine(tokenCount - 1);
    }
    getRange() {
        const tokenCount = this._getTokenCount();
        if (tokenCount === 0) return null;
        const startChar = this._getStartCharacter(0);
        const maxDeltaLine = this._getDeltaLine(tokenCount - 1);
        const endChar = this._getEndCharacter(tokenCount - 1);
        return new (0, _rangeJs.Range)(0, startChar + 1, maxDeltaLine, endChar + 1);
    }
    _getTokenCount() {
        return this._tokenCount;
    }
    _getDeltaLine(tokenIndex) {
        return this._tokens[4 * tokenIndex];
    }
    _getStartCharacter(tokenIndex) {
        return this._tokens[4 * tokenIndex + 1];
    }
    _getEndCharacter(tokenIndex) {
        return this._tokens[4 * tokenIndex + 2];
    }
    isEmpty() {
        return this._getTokenCount() === 0;
    }
    getLineTokens(deltaLine) {
        let low = 0;
        let high = this._getTokenCount() - 1;
        while(low < high){
            const mid = low + Math.floor((high - low) / 2);
            const midDeltaLine = this._getDeltaLine(mid);
            if (midDeltaLine < deltaLine) low = mid + 1;
            else if (midDeltaLine > deltaLine) high = mid - 1;
            else {
                let min = mid;
                while(min > low && this._getDeltaLine(min - 1) === deltaLine)min--;
                let max = mid;
                while(max < high && this._getDeltaLine(max + 1) === deltaLine)max++;
                return new SparseLineTokens(this._tokens.subarray(4 * min, 4 * max + 4));
            }
        }
        if (this._getDeltaLine(low) === deltaLine) return new SparseLineTokens(this._tokens.subarray(4 * low, 4 * low + 4));
        return null;
    }
    clear() {
        this._tokenCount = 0;
    }
    removeTokens(startDeltaLine, startChar, endDeltaLine, endChar) {
        const tokens = this._tokens;
        const tokenCount = this._tokenCount;
        let newTokenCount = 0;
        let hasDeletedTokens = false;
        let firstDeltaLine = 0;
        for(let i = 0; i < tokenCount; i++){
            const srcOffset = 4 * i;
            const tokenDeltaLine = tokens[srcOffset];
            const tokenStartCharacter = tokens[srcOffset + 1];
            const tokenEndCharacter = tokens[srcOffset + 2];
            const tokenMetadata = tokens[srcOffset + 3];
            if ((tokenDeltaLine > startDeltaLine || tokenDeltaLine === startDeltaLine && tokenEndCharacter >= startChar) && (tokenDeltaLine < endDeltaLine || tokenDeltaLine === endDeltaLine && tokenStartCharacter <= endChar)) hasDeletedTokens = true;
            else {
                if (newTokenCount === 0) firstDeltaLine = tokenDeltaLine;
                if (hasDeletedTokens) {
                    // must move the token to the left
                    const destOffset = 4 * newTokenCount;
                    tokens[destOffset] = tokenDeltaLine - firstDeltaLine;
                    tokens[destOffset + 1] = tokenStartCharacter;
                    tokens[destOffset + 2] = tokenEndCharacter;
                    tokens[destOffset + 3] = tokenMetadata;
                }
                newTokenCount++;
            }
        }
        this._tokenCount = newTokenCount;
        return firstDeltaLine;
    }
    split(startDeltaLine, startChar, endDeltaLine, endChar) {
        const tokens = this._tokens;
        const tokenCount = this._tokenCount;
        const aTokens = [];
        const bTokens = [];
        let destTokens = aTokens;
        let destOffset = 0;
        let destFirstDeltaLine = 0;
        for(let i = 0; i < tokenCount; i++){
            const srcOffset = 4 * i;
            const tokenDeltaLine = tokens[srcOffset];
            const tokenStartCharacter = tokens[srcOffset + 1];
            const tokenEndCharacter = tokens[srcOffset + 2];
            const tokenMetadata = tokens[srcOffset + 3];
            if (tokenDeltaLine > startDeltaLine || tokenDeltaLine === startDeltaLine && tokenEndCharacter >= startChar) {
                if (tokenDeltaLine < endDeltaLine || tokenDeltaLine === endDeltaLine && tokenStartCharacter <= endChar) continue;
                else // this token is after the range
                if (destTokens !== bTokens) {
                    // this token is the first token after the range
                    destTokens = bTokens;
                    destOffset = 0;
                    destFirstDeltaLine = tokenDeltaLine;
                }
            }
            destTokens[destOffset++] = tokenDeltaLine - destFirstDeltaLine;
            destTokens[destOffset++] = tokenStartCharacter;
            destTokens[destOffset++] = tokenEndCharacter;
            destTokens[destOffset++] = tokenMetadata;
        }
        return [
            new SparseMultilineTokensStorage(new Uint32Array(aTokens)),
            new SparseMultilineTokensStorage(new Uint32Array(bTokens)),
            destFirstDeltaLine
        ];
    }
    acceptDeleteRange(horizontalShiftForFirstLineTokens, startDeltaLine, startCharacter, endDeltaLine, endCharacter) {
        // This is a bit complex, here are the cases I used to think about this:
        //
        // 1. The token starts before the deletion range
        // 1a. The token is completely before the deletion range
        //               -----------
        //                          xxxxxxxxxxx
        // 1b. The token starts before, the deletion range ends after the token
        //               -----------
        //                      xxxxxxxxxxx
        // 1c. The token starts before, the deletion range ends precisely with the token
        //               ---------------
        //                      xxxxxxxx
        // 1d. The token starts before, the deletion range is inside the token
        //               ---------------
        //                    xxxxx
        //
        // 2. The token starts at the same position with the deletion range
        // 2a. The token starts at the same position, and ends inside the deletion range
        //               -------
        //               xxxxxxxxxxx
        // 2b. The token starts at the same position, and ends at the same position as the deletion range
        //               ----------
        //               xxxxxxxxxx
        // 2c. The token starts at the same position, and ends after the deletion range
        //               -------------
        //               xxxxxxx
        //
        // 3. The token starts inside the deletion range
        // 3a. The token is inside the deletion range
        //                -------
        //             xxxxxxxxxxxxx
        // 3b. The token starts inside the deletion range, and ends at the same position as the deletion range
        //                ----------
        //             xxxxxxxxxxxxx
        // 3c. The token starts inside the deletion range, and ends after the deletion range
        //                ------------
        //             xxxxxxxxxxx
        //
        // 4. The token starts after the deletion range
        //                  -----------
        //          xxxxxxxx
        //
        const tokens = this._tokens;
        const tokenCount = this._tokenCount;
        const deletedLineCount = endDeltaLine - startDeltaLine;
        let newTokenCount = 0;
        let hasDeletedTokens = false;
        for(let i = 0; i < tokenCount; i++){
            const srcOffset = 4 * i;
            let tokenDeltaLine = tokens[srcOffset];
            let tokenStartCharacter = tokens[srcOffset + 1];
            let tokenEndCharacter = tokens[srcOffset + 2];
            const tokenMetadata = tokens[srcOffset + 3];
            if (tokenDeltaLine < startDeltaLine || tokenDeltaLine === startDeltaLine && tokenEndCharacter <= startCharacter) {
                // 1a. The token is completely before the deletion range
                // => nothing to do
                newTokenCount++;
                continue;
            } else if (tokenDeltaLine === startDeltaLine && tokenStartCharacter < startCharacter) {
                // 1b, 1c, 1d
                // => the token survives, but it needs to shrink
                if (tokenDeltaLine === endDeltaLine && tokenEndCharacter > endCharacter) // 1d. The token starts before, the deletion range is inside the token
                // => the token shrinks by the deletion character count
                tokenEndCharacter -= endCharacter - startCharacter;
                else // 1b. The token starts before, the deletion range ends after the token
                // 1c. The token starts before, the deletion range ends precisely with the token
                // => the token shrinks its ending to the deletion start
                tokenEndCharacter = startCharacter;
            } else if (tokenDeltaLine === startDeltaLine && tokenStartCharacter === startCharacter) {
                // 2a, 2b, 2c
                if (tokenDeltaLine === endDeltaLine && tokenEndCharacter > endCharacter) // 2c. The token starts at the same position, and ends after the deletion range
                // => the token shrinks by the deletion character count
                tokenEndCharacter -= endCharacter - startCharacter;
                else {
                    // 2a. The token starts at the same position, and ends inside the deletion range
                    // 2b. The token starts at the same position, and ends at the same position as the deletion range
                    // => the token is deleted
                    hasDeletedTokens = true;
                    continue;
                }
            } else if (tokenDeltaLine < endDeltaLine || tokenDeltaLine === endDeltaLine && tokenStartCharacter < endCharacter) {
                // 3a, 3b, 3c
                if (tokenDeltaLine === endDeltaLine && tokenEndCharacter > endCharacter) {
                    // 3c. The token starts inside the deletion range, and ends after the deletion range
                    // => the token moves to continue right after the deletion
                    tokenDeltaLine = startDeltaLine;
                    tokenStartCharacter = startCharacter;
                    tokenEndCharacter = tokenStartCharacter + (tokenEndCharacter - endCharacter);
                } else {
                    // 3a. The token is inside the deletion range
                    // 3b. The token starts inside the deletion range, and ends at the same position as the deletion range
                    // => the token is deleted
                    hasDeletedTokens = true;
                    continue;
                }
            } else if (tokenDeltaLine > endDeltaLine) {
                // 4. (partial) The token starts after the deletion range, on a line below...
                if (deletedLineCount === 0 && !hasDeletedTokens) {
                    // early stop, there is no need to walk all the tokens and do nothing...
                    newTokenCount = tokenCount;
                    break;
                }
                tokenDeltaLine -= deletedLineCount;
            } else if (tokenDeltaLine === endDeltaLine && tokenStartCharacter >= endCharacter) {
                // 4. (continued) The token starts after the deletion range, on the last line where a deletion occurs
                if (horizontalShiftForFirstLineTokens && tokenDeltaLine === 0) {
                    tokenStartCharacter += horizontalShiftForFirstLineTokens;
                    tokenEndCharacter += horizontalShiftForFirstLineTokens;
                }
                tokenDeltaLine -= deletedLineCount;
                tokenStartCharacter -= endCharacter - startCharacter;
                tokenEndCharacter -= endCharacter - startCharacter;
            } else throw new Error(`Not possible!`);
            const destOffset = 4 * newTokenCount;
            tokens[destOffset] = tokenDeltaLine;
            tokens[destOffset + 1] = tokenStartCharacter;
            tokens[destOffset + 2] = tokenEndCharacter;
            tokens[destOffset + 3] = tokenMetadata;
            newTokenCount++;
        }
        this._tokenCount = newTokenCount;
    }
    acceptInsertText(deltaLine, character, eolCount, firstLineLength, lastLineLength, firstCharCode) {
        // Here are the cases I used to think about this:
        //
        // 1. The token is completely before the insertion point
        //            -----------   |
        // 2. The token ends precisely at the insertion point
        //            -----------|
        // 3. The token contains the insertion point
        //            -----|------
        // 4. The token starts precisely at the insertion point
        //            |-----------
        // 5. The token is completely after the insertion point
        //            |   -----------
        //
        const isInsertingPreciselyOneWordCharacter = eolCount === 0 && firstLineLength === 1 && (firstCharCode >= 48 /* CharCode.Digit0 */  && firstCharCode <= 57 /* CharCode.Digit9 */  || firstCharCode >= 65 /* CharCode.A */  && firstCharCode <= 90 /* CharCode.Z */  || firstCharCode >= 97 /* CharCode.a */  && firstCharCode <= 122 /* CharCode.z */ );
        const tokens = this._tokens;
        const tokenCount = this._tokenCount;
        for(let i = 0; i < tokenCount; i++){
            const offset = 4 * i;
            let tokenDeltaLine = tokens[offset];
            let tokenStartCharacter = tokens[offset + 1];
            let tokenEndCharacter = tokens[offset + 2];
            if (tokenDeltaLine < deltaLine || tokenDeltaLine === deltaLine && tokenEndCharacter < character) continue;
            else if (tokenDeltaLine === deltaLine && tokenEndCharacter === character) {
                // 2. The token ends precisely at the insertion point
                // => expand the end character only if inserting precisely one character that is a word character
                if (isInsertingPreciselyOneWordCharacter) tokenEndCharacter += 1;
                else continue;
            } else if (tokenDeltaLine === deltaLine && tokenStartCharacter < character && character < tokenEndCharacter) {
                // 3. The token contains the insertion point
                if (eolCount === 0) // => just expand the end character
                tokenEndCharacter += firstLineLength;
                else // => cut off the token
                tokenEndCharacter = character;
            } else {
                // 4. or 5.
                if (tokenDeltaLine === deltaLine && tokenStartCharacter === character) {
                    // 4. The token starts precisely at the insertion point
                    // => grow the token (by keeping its start constant) only if inserting precisely one character that is a word character
                    // => otherwise behave as in case 5.
                    if (isInsertingPreciselyOneWordCharacter) continue;
                }
                // => the token must move and keep its size constant
                if (tokenDeltaLine === deltaLine) {
                    tokenDeltaLine += eolCount;
                    // this token is on the line where the insertion is taking place
                    if (eolCount === 0) {
                        tokenStartCharacter += firstLineLength;
                        tokenEndCharacter += firstLineLength;
                    } else {
                        const tokenLength = tokenEndCharacter - tokenStartCharacter;
                        tokenStartCharacter = lastLineLength + (tokenStartCharacter - character);
                        tokenEndCharacter = tokenStartCharacter + tokenLength;
                    }
                } else tokenDeltaLine += eolCount;
            }
            tokens[offset] = tokenDeltaLine;
            tokens[offset + 1] = tokenStartCharacter;
            tokens[offset + 2] = tokenEndCharacter;
        }
    }
}
class SparseLineTokens {
    constructor(tokens){
        this._tokens = tokens;
    }
    getCount() {
        return this._tokens.length / 4;
    }
    getStartCharacter(tokenIndex) {
        return this._tokens[4 * tokenIndex + 1];
    }
    getEndCharacter(tokenIndex) {
        return this._tokens[4 * tokenIndex + 2];
    }
    getMetadata(tokenIndex) {
        return this._tokens[4 * tokenIndex + 3];
    }
}

},{"../core/position.js":"lvrPe","../core/range.js":"jmUPh","../core/eolCounter.js":"4i42Y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4i42Y":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "countEOL", ()=>countEOL);
function countEOL(text) {
    let eolCount = 0;
    let firstLineLength = 0;
    let lastLineStart = 0;
    let eol = 0 /* StringEOL.Unknown */ ;
    for(let i = 0, len = text.length; i < len; i++){
        const chr = text.charCodeAt(i);
        if (chr === 13 /* CharCode.CarriageReturn */ ) {
            if (eolCount === 0) firstLineLength = i;
            eolCount++;
            if (i + 1 < len && text.charCodeAt(i + 1) === 10 /* CharCode.LineFeed */ ) {
                // \r\n... case
                eol |= 2 /* StringEOL.CRLF */ ;
                i++; // skip \n
            } else // \r... case
            eol |= 3 /* StringEOL.Invalid */ ;
            lastLineStart = i + 1;
        } else if (chr === 10 /* CharCode.LineFeed */ ) {
            // \n... case
            eol |= 1 /* StringEOL.LF */ ;
            if (eolCount === 0) firstLineLength = i;
            eolCount++;
            lastLineStart = i + 1;
        }
    }
    if (eolCount === 0) firstLineLength = text.length;
    return [
        eolCount,
        firstLineLength,
        text.length - lastLineStart,
        eol
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gV4Rk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISemanticTokensStylingService", ()=>ISemanticTokensStylingService);
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
const ISemanticTokensStylingService = (0, _instantiationJs.createDecorator)("semanticTokensStylingService");

},{"../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3X4wH":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LanguageFeaturesService", ()=>LanguageFeaturesService);
var _languageFeatureRegistryJs = require("../languageFeatureRegistry.js");
var _languageFeaturesJs = require("./languageFeatures.js");
var _extensionsJs = require("../../../platform/instantiation/common/extensions.js");
class LanguageFeaturesService {
    constructor(){
        this.referenceProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.renameProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.newSymbolNamesProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.codeActionProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.definitionProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.typeDefinitionProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.declarationProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.implementationProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.documentSymbolProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.inlayHintsProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.colorProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.codeLensProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.documentFormattingEditProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.documentRangeFormattingEditProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.onTypeFormattingEditProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.signatureHelpProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.hoverProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.documentHighlightProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.multiDocumentHighlightProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.selectionRangeProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.foldingRangeProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.linkProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.inlineCompletionsProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.inlineEditProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.completionProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.linkedEditingRangeProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.documentRangeSemanticTokensProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.documentSemanticTokensProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.documentDropEditProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
        this.documentPasteEditProvider = new (0, _languageFeatureRegistryJs.LanguageFeatureRegistry)(this._score.bind(this));
    }
    _score(uri) {
        return this._notebookTypeResolver?.(uri);
    }
}
(0, _extensionsJs.registerSingleton)((0, _languageFeaturesJs.ILanguageFeaturesService), LanguageFeaturesService, 1 /* InstantiationType.Delayed */ );

},{"../languageFeatureRegistry.js":"QGng4","./languageFeatures.js":"2IAko","../../../platform/instantiation/common/extensions.js":"6WJLq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"QGng4":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LanguageFeatureRegistry", ()=>LanguageFeatureRegistry);
var _eventJs = require("../../base/common/event.js");
var _lifecycleJs = require("../../base/common/lifecycle.js");
var _modelJs = require("./model.js");
var _languageSelectorJs = require("./languageSelector.js");
function isExclusive(selector) {
    if (typeof selector === "string") return false;
    else if (Array.isArray(selector)) return selector.every(isExclusive);
    else return !!selector.exclusive; // TODO: microsoft/TypeScript#42768
}
class MatchCandidate {
    constructor(uri, languageId, notebookUri, notebookType, recursive){
        this.uri = uri;
        this.languageId = languageId;
        this.notebookUri = notebookUri;
        this.notebookType = notebookType;
        this.recursive = recursive;
    }
    equals(other) {
        return this.notebookType === other.notebookType && this.languageId === other.languageId && this.uri.toString() === other.uri.toString() && this.notebookUri?.toString() === other.notebookUri?.toString() && this.recursive === other.recursive;
    }
}
class LanguageFeatureRegistry {
    constructor(_notebookInfoResolver){
        this._notebookInfoResolver = _notebookInfoResolver;
        this._clock = 0;
        this._entries = [];
        this._onDidChange = new (0, _eventJs.Emitter)();
        this.onDidChange = this._onDidChange.event;
    }
    register(selector, provider) {
        let entry = {
            selector,
            provider,
            _score: -1,
            _time: this._clock++
        };
        this._entries.push(entry);
        this._lastCandidate = undefined;
        this._onDidChange.fire(this._entries.length);
        return (0, _lifecycleJs.toDisposable)(()=>{
            if (entry) {
                const idx = this._entries.indexOf(entry);
                if (idx >= 0) {
                    this._entries.splice(idx, 1);
                    this._lastCandidate = undefined;
                    this._onDidChange.fire(this._entries.length);
                    entry = undefined;
                }
            }
        });
    }
    has(model) {
        return this.all(model).length > 0;
    }
    all(model) {
        if (!model) return [];
        this._updateScores(model, false);
        const result = [];
        // from registry
        for (const entry of this._entries)if (entry._score > 0) result.push(entry.provider);
        return result;
    }
    ordered(model, recursive = false) {
        const result = [];
        this._orderedForEach(model, recursive, (entry)=>result.push(entry.provider));
        return result;
    }
    orderedGroups(model) {
        const result = [];
        let lastBucket;
        let lastBucketScore;
        this._orderedForEach(model, false, (entry)=>{
            if (lastBucket && lastBucketScore === entry._score) lastBucket.push(entry.provider);
            else {
                lastBucketScore = entry._score;
                lastBucket = [
                    entry.provider
                ];
                result.push(lastBucket);
            }
        });
        return result;
    }
    _orderedForEach(model, recursive, callback) {
        this._updateScores(model, recursive);
        for (const entry of this._entries)if (entry._score > 0) callback(entry);
    }
    _updateScores(model, recursive) {
        const notebookInfo = this._notebookInfoResolver?.(model.uri);
        // use the uri (scheme, pattern) of the notebook info iff we have one
        // otherwise it's the model's/document's uri
        const candidate = notebookInfo ? new MatchCandidate(model.uri, model.getLanguageId(), notebookInfo.uri, notebookInfo.type, recursive) : new MatchCandidate(model.uri, model.getLanguageId(), undefined, undefined, recursive);
        if (this._lastCandidate?.equals(candidate)) // nothing has changed
        return;
        this._lastCandidate = candidate;
        for (const entry of this._entries){
            entry._score = (0, _languageSelectorJs.score)(entry.selector, candidate.uri, candidate.languageId, (0, _modelJs.shouldSynchronizeModel)(model), candidate.notebookUri, candidate.notebookType);
            if (isExclusive(entry.selector) && entry._score > 0) {
                if (recursive) entry._score = 0;
                else {
                    // support for one exclusive selector that overwrites
                    // any other selector
                    for (const entry of this._entries)entry._score = 0;
                    entry._score = 1000;
                    break;
                }
            }
        }
        // needs sorting
        this._entries.sort(LanguageFeatureRegistry._compareByScoreAndTime);
    }
    static _compareByScoreAndTime(a, b) {
        if (a._score < b._score) return 1;
        else if (a._score > b._score) return -1;
        // De-prioritize built-in providers
        if (isBuiltinSelector(a.selector) && !isBuiltinSelector(b.selector)) return 1;
        else if (!isBuiltinSelector(a.selector) && isBuiltinSelector(b.selector)) return -1;
        if (a._time < b._time) return 1;
        else if (a._time > b._time) return -1;
        else return 0;
    }
}
function isBuiltinSelector(selector) {
    if (typeof selector === "string") return false;
    if (Array.isArray(selector)) return selector.some(isBuiltinSelector);
    return Boolean(selector.isBuiltin);
}

},{"../../base/common/event.js":"4Zi8b","../../base/common/lifecycle.js":"9kg8d","./model.js":"1CSIB","./languageSelector.js":"hho5L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hho5L":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "score", ()=>score);
var _globJs = require("../../base/common/glob.js");
var _pathJs = require("../../base/common/path.js");
function score(selector, candidateUri, candidateLanguage, candidateIsSynchronized, candidateNotebookUri, candidateNotebookType) {
    if (Array.isArray(selector)) {
        // array -> take max individual value
        let ret = 0;
        for (const filter of selector){
            const value = score(filter, candidateUri, candidateLanguage, candidateIsSynchronized, candidateNotebookUri, candidateNotebookType);
            if (value === 10) return value; // already at the highest
            if (value > ret) ret = value;
        }
        return ret;
    } else if (typeof selector === "string") {
        if (!candidateIsSynchronized) return 0;
        // short-hand notion, desugars to
        // 'fooLang' -> { language: 'fooLang'}
        // '*' -> { language: '*' }
        if (selector === "*") return 5;
        else if (selector === candidateLanguage) return 10;
        else return 0;
    } else if (selector) {
        // filter -> select accordingly, use defaults for scheme
        const { language, pattern, scheme, hasAccessToAllModels, notebookType } = selector; // TODO: microsoft/TypeScript#42768
        if (!candidateIsSynchronized && !hasAccessToAllModels) return 0;
        // selector targets a notebook -> use the notebook uri instead
        // of the "normal" document uri.
        if (notebookType && candidateNotebookUri) candidateUri = candidateNotebookUri;
        let ret = 0;
        if (scheme) {
            if (scheme === candidateUri.scheme) ret = 10;
            else if (scheme === "*") ret = 5;
            else return 0;
        }
        if (language) {
            if (language === candidateLanguage) ret = 10;
            else if (language === "*") ret = Math.max(ret, 5);
            else return 0;
        }
        if (notebookType) {
            if (notebookType === candidateNotebookType) ret = 10;
            else if (notebookType === "*" && candidateNotebookType !== undefined) ret = Math.max(ret, 5);
            else return 0;
        }
        if (pattern) {
            let normalizedPattern;
            if (typeof pattern === "string") normalizedPattern = pattern;
            else // Since this pattern has a `base` property, we need
            // to normalize this path first before passing it on
            // because we will compare it against `Uri.fsPath`
            // which uses platform specific separators.
            // Refs: https://github.com/microsoft/vscode/issues/99938
            normalizedPattern = {
                ...pattern,
                base: (0, _pathJs.normalize)(pattern.base)
            };
            if (normalizedPattern === candidateUri.fsPath || (0, _globJs.match)(normalizedPattern, candidateUri.fsPath)) ret = 10;
            else return 0;
        }
        return ret;
    } else return 0;
}

},{"../../base/common/glob.js":"gaB3X","../../base/common/path.js":"vyRKJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaB3X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBSTAR", ()=>GLOBSTAR);
parcelHelpers.export(exports, "GLOB_SPLIT", ()=>GLOB_SPLIT);
parcelHelpers.export(exports, "splitGlobAware", ()=>splitGlobAware);
parcelHelpers.export(exports, "match", ()=>match);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "isRelativePattern", ()=>isRelativePattern);
var _asyncJs = require("./async.js");
var _extpathJs = require("./extpath.js");
var _mapJs = require("./map.js");
var _pathJs = require("./path.js");
var _platformJs = require("./platform.js");
var _stringsJs = require("./strings.js");
const GLOBSTAR = "**";
const GLOB_SPLIT = "/";
const PATH_REGEX = "[/\\\\]"; // any slash or backslash
const NO_PATH_REGEX = "[^/\\\\]"; // any non-slash and non-backslash
const ALL_FORWARD_SLASHES = /\//g;
function starsToRegExp(starCount, isLastPattern) {
    switch(starCount){
        case 0:
            return "";
        case 1:
            return `${NO_PATH_REGEX}*?`; // 1 star matches any number of characters except path separator (/ and \) - non greedy (?)
        default:
            // Matches:  (Path Sep OR Path Val followed by Path Sep) 0-many times except when it's the last pattern
            //           in which case also matches (Path Sep followed by Path Val)
            // Group is non capturing because we don't need to capture at all (?:...)
            // Overall we use non-greedy matching because it could be that we match too much
            return `(?:${PATH_REGEX}|${NO_PATH_REGEX}+${PATH_REGEX}${isLastPattern ? `|${PATH_REGEX}${NO_PATH_REGEX}+` : ""})*?`;
    }
}
function splitGlobAware(pattern, splitChar) {
    if (!pattern) return [];
    const segments = [];
    let inBraces = false;
    let inBrackets = false;
    let curVal = "";
    for (const char of pattern){
        switch(char){
            case splitChar:
                if (!inBraces && !inBrackets) {
                    segments.push(curVal);
                    curVal = "";
                    continue;
                }
                break;
            case "{":
                inBraces = true;
                break;
            case "}":
                inBraces = false;
                break;
            case "[":
                inBrackets = true;
                break;
            case "]":
                inBrackets = false;
                break;
        }
        curVal += char;
    }
    // Tail
    if (curVal) segments.push(curVal);
    return segments;
}
function parseRegExp(pattern) {
    if (!pattern) return "";
    let regEx = "";
    // Split up into segments for each slash found
    const segments = splitGlobAware(pattern, GLOB_SPLIT);
    // Special case where we only have globstars
    if (segments.every((segment)=>segment === GLOBSTAR)) regEx = ".*";
    else {
        let previousSegmentWasGlobStar = false;
        segments.forEach((segment, index)=>{
            // Treat globstar specially
            if (segment === GLOBSTAR) {
                // if we have more than one globstar after another, just ignore it
                if (previousSegmentWasGlobStar) return;
                regEx += starsToRegExp(2, index === segments.length - 1);
            } else {
                // States
                let inBraces = false;
                let braceVal = "";
                let inBrackets = false;
                let bracketVal = "";
                for (const char of segment){
                    // Support brace expansion
                    if (char !== "}" && inBraces) {
                        braceVal += char;
                        continue;
                    }
                    // Support brackets
                    if (inBrackets && (char !== "]" || !bracketVal)) {
                        let res;
                        // range operator
                        if (char === "-") res = char;
                        else if ((char === "^" || char === "!") && !bracketVal) res = "^";
                        else if (char === GLOB_SPLIT) res = "";
                        else res = (0, _stringsJs.escapeRegExpCharacters)(char);
                        bracketVal += res;
                        continue;
                    }
                    switch(char){
                        case "{":
                            inBraces = true;
                            continue;
                        case "[":
                            inBrackets = true;
                            continue;
                        case "}":
                            {
                                const choices = splitGlobAware(braceVal, ",");
                                // Converts {foo,bar} => [foo|bar]
                                const braceRegExp = `(?:${choices.map((choice)=>parseRegExp(choice)).join("|")})`;
                                regEx += braceRegExp;
                                inBraces = false;
                                braceVal = "";
                                break;
                            }
                        case "]":
                            regEx += "[" + bracketVal + "]";
                            inBrackets = false;
                            bracketVal = "";
                            break;
                        case "?":
                            regEx += NO_PATH_REGEX; // 1 ? matches any single character except path separator (/ and \)
                            continue;
                        case "*":
                            regEx += starsToRegExp(1);
                            continue;
                        default:
                            regEx += (0, _stringsJs.escapeRegExpCharacters)(char);
                    }
                }
                // Tail: Add the slash we had split on if there is more to
                // come and the remaining pattern is not a globstar
                // For example if pattern: some/**/*.js we want the "/" after
                // some to be included in the RegEx to prevent a folder called
                // "something" to match as well.
                if (index < segments.length - 1 && // more segments to come after this
                (segments[index + 1] !== GLOBSTAR || // next segment is not **, or...
                index + 2 < segments.length // ...next segment is ** but there is more segments after that
                )) regEx += PATH_REGEX;
            }
            // update globstar state
            previousSegmentWasGlobStar = segment === GLOBSTAR;
        });
    }
    return regEx;
}
// regexes to check for trivial glob patterns that just check for String#endsWith
const T1 = /^\*\*\/\*\.[\w\.-]+$/; // **/*.something
const T2 = /^\*\*\/([\w\.-]+)\/?$/; // **/something
const T3 = /^{\*\*\/\*?[\w\.-]+\/?(,\*\*\/\*?[\w\.-]+\/?)*}$/; // {**/*.something,**/*.else} or {**/package.json,**/project.json}
const T3_2 = /^{\*\*\/\*?[\w\.-]+(\/(\*\*)?)?(,\*\*\/\*?[\w\.-]+(\/(\*\*)?)?)*}$/; // Like T3, with optional trailing /**
const T4 = /^\*\*((\/[\w\.-]+)+)\/?$/; // **/something/else
const T5 = /^([\w\.-]+(\/[\w\.-]+)*)\/?$/; // something/else
const CACHE = new (0, _mapJs.LRUCache)(10000); // bounded to 10000 elements
const FALSE = function() {
    return false;
};
const NULL = function() {
    return null;
};
function parsePattern(arg1, options) {
    if (!arg1) return NULL;
    // Handle relative patterns
    let pattern;
    if (typeof arg1 !== "string") pattern = arg1.pattern;
    else pattern = arg1;
    // Whitespace trimming
    pattern = pattern.trim();
    // Check cache
    const patternKey = `${pattern}_${!!options.trimForExclusions}`;
    let parsedPattern = CACHE.get(patternKey);
    if (parsedPattern) return wrapRelativePattern(parsedPattern, arg1);
    // Check for Trivials
    let match;
    if (T1.test(pattern)) parsedPattern = trivia1(pattern.substr(4), pattern); // common pattern: **/*.txt just need endsWith check
    else if (match = T2.exec(trimForExclusions(pattern, options))) parsedPattern = trivia2(match[1], pattern);
    else if ((options.trimForExclusions ? T3_2 : T3).test(pattern)) parsedPattern = trivia3(pattern, options);
    else if (match = T4.exec(trimForExclusions(pattern, options))) parsedPattern = trivia4and5(match[1].substr(1), pattern, true);
    else if (match = T5.exec(trimForExclusions(pattern, options))) parsedPattern = trivia4and5(match[1], pattern, false);
    else parsedPattern = toRegExp(pattern);
    // Cache
    CACHE.set(patternKey, parsedPattern);
    return wrapRelativePattern(parsedPattern, arg1);
}
function wrapRelativePattern(parsedPattern, arg2) {
    if (typeof arg2 === "string") return parsedPattern;
    const wrappedPattern = function(path, basename) {
        if (!(0, _extpathJs.isEqualOrParent)(path, arg2.base, !(0, _platformJs.isLinux))) // skip glob matching if `base` is not a parent of `path`
        return null;
        // Given we have checked `base` being a parent of `path`,
        // we can now remove the `base` portion of the `path`
        // and only match on the remaining path components
        // For that we try to extract the portion of the `path`
        // that comes after the `base` portion. We have to account
        // for the fact that `base` might end in a path separator
        // (https://github.com/microsoft/vscode/issues/162498)
        return parsedPattern((0, _stringsJs.ltrim)(path.substr(arg2.base.length), (0, _pathJs.sep)), basename);
    };
    // Make sure to preserve associated metadata
    wrappedPattern.allBasenames = parsedPattern.allBasenames;
    wrappedPattern.allPaths = parsedPattern.allPaths;
    wrappedPattern.basenames = parsedPattern.basenames;
    wrappedPattern.patterns = parsedPattern.patterns;
    return wrappedPattern;
}
function trimForExclusions(pattern, options) {
    return options.trimForExclusions && pattern.endsWith("/**") ? pattern.substr(0, pattern.length - 2) : pattern; // dropping **, tailing / is dropped later
}
// common pattern: **/*.txt just need endsWith check
function trivia1(base, pattern) {
    return function(path, basename) {
        return typeof path === "string" && path.endsWith(base) ? pattern : null;
    };
}
// common pattern: **/some.txt just need basename check
function trivia2(base, pattern) {
    const slashBase = `/${base}`;
    const backslashBase = `\\${base}`;
    const parsedPattern = function(path, basename) {
        if (typeof path !== "string") return null;
        if (basename) return basename === base ? pattern : null;
        return path === base || path.endsWith(slashBase) || path.endsWith(backslashBase) ? pattern : null;
    };
    const basenames = [
        base
    ];
    parsedPattern.basenames = basenames;
    parsedPattern.patterns = [
        pattern
    ];
    parsedPattern.allBasenames = basenames;
    return parsedPattern;
}
// repetition of common patterns (see above) {**/*.txt,**/*.png}
function trivia3(pattern, options) {
    const parsedPatterns = aggregateBasenameMatches(pattern.slice(1, -1).split(",").map((pattern)=>parsePattern(pattern, options)).filter((pattern)=>pattern !== NULL), pattern);
    const patternsLength = parsedPatterns.length;
    if (!patternsLength) return NULL;
    if (patternsLength === 1) return parsedPatterns[0];
    const parsedPattern = function(path, basename) {
        for(let i = 0, n = parsedPatterns.length; i < n; i++){
            if (parsedPatterns[i](path, basename)) return pattern;
        }
        return null;
    };
    const withBasenames = parsedPatterns.find((pattern)=>!!pattern.allBasenames);
    if (withBasenames) parsedPattern.allBasenames = withBasenames.allBasenames;
    const allPaths = parsedPatterns.reduce((all, current)=>current.allPaths ? all.concat(current.allPaths) : all, []);
    if (allPaths.length) parsedPattern.allPaths = allPaths;
    return parsedPattern;
}
// common patterns: **/something/else just need endsWith check, something/else just needs and equals check
function trivia4and5(targetPath, pattern, matchPathEnds) {
    const usingPosixSep = (0, _pathJs.sep) === (0, _pathJs.posix).sep;
    const nativePath = usingPosixSep ? targetPath : targetPath.replace(ALL_FORWARD_SLASHES, (0, _pathJs.sep));
    const nativePathEnd = (0, _pathJs.sep) + nativePath;
    const targetPathEnd = (0, _pathJs.posix).sep + targetPath;
    let parsedPattern;
    if (matchPathEnds) parsedPattern = function(path, basename) {
        return typeof path === "string" && (path === nativePath || path.endsWith(nativePathEnd) || !usingPosixSep && (path === targetPath || path.endsWith(targetPathEnd))) ? pattern : null;
    };
    else parsedPattern = function(path, basename) {
        return typeof path === "string" && (path === nativePath || !usingPosixSep && path === targetPath) ? pattern : null;
    };
    parsedPattern.allPaths = [
        (matchPathEnds ? "*/" : "./") + targetPath
    ];
    return parsedPattern;
}
function toRegExp(pattern) {
    try {
        const regExp = new RegExp(`^${parseRegExp(pattern)}$`);
        return function(path) {
            regExp.lastIndex = 0; // reset RegExp to its initial state to reuse it!
            return typeof path === "string" && regExp.test(path) ? pattern : null;
        };
    } catch (error) {
        return NULL;
    }
}
function match(arg1, path, hasSibling) {
    if (!arg1 || typeof path !== "string") return false;
    return parse(arg1)(path, undefined, hasSibling);
}
function parse(arg1, options = {}) {
    if (!arg1) return FALSE;
    // Glob with String
    if (typeof arg1 === "string" || isRelativePattern(arg1)) {
        const parsedPattern = parsePattern(arg1, options);
        if (parsedPattern === NULL) return FALSE;
        const resultPattern = function(path, basename) {
            return !!parsedPattern(path, basename);
        };
        if (parsedPattern.allBasenames) resultPattern.allBasenames = parsedPattern.allBasenames;
        if (parsedPattern.allPaths) resultPattern.allPaths = parsedPattern.allPaths;
        return resultPattern;
    }
    // Glob with Expression
    return parsedExpression(arg1, options);
}
function isRelativePattern(obj) {
    const rp = obj;
    if (!rp) return false;
    return typeof rp.base === "string" && typeof rp.pattern === "string";
}
function parsedExpression(expression, options) {
    const parsedPatterns = aggregateBasenameMatches(Object.getOwnPropertyNames(expression).map((pattern)=>parseExpressionPattern(pattern, expression[pattern], options)).filter((pattern)=>pattern !== NULL));
    const patternsLength = parsedPatterns.length;
    if (!patternsLength) return NULL;
    if (!parsedPatterns.some((parsedPattern)=>!!parsedPattern.requiresSiblings)) {
        if (patternsLength === 1) return parsedPatterns[0];
        const resultExpression = function(path, basename) {
            let resultPromises = undefined;
            for(let i = 0, n = parsedPatterns.length; i < n; i++){
                const result = parsedPatterns[i](path, basename);
                if (typeof result === "string") return result; // immediately return as soon as the first expression matches
                // If the result is a promise, we have to keep it for
                // later processing and await the result properly.
                if ((0, _asyncJs.isThenable)(result)) {
                    if (!resultPromises) resultPromises = [];
                    resultPromises.push(result);
                }
            }
            // With result promises, we have to loop over each and
            // await the result before we can return any result.
            if (resultPromises) return (async ()=>{
                for (const resultPromise of resultPromises){
                    const result = await resultPromise;
                    if (typeof result === "string") return result;
                }
                return null;
            })();
            return null;
        };
        const withBasenames = parsedPatterns.find((pattern)=>!!pattern.allBasenames);
        if (withBasenames) resultExpression.allBasenames = withBasenames.allBasenames;
        const allPaths = parsedPatterns.reduce((all, current)=>current.allPaths ? all.concat(current.allPaths) : all, []);
        if (allPaths.length) resultExpression.allPaths = allPaths;
        return resultExpression;
    }
    const resultExpression = function(path, base, hasSibling) {
        let name = undefined;
        let resultPromises = undefined;
        for(let i = 0, n = parsedPatterns.length; i < n; i++){
            // Pattern matches path
            const parsedPattern = parsedPatterns[i];
            if (parsedPattern.requiresSiblings && hasSibling) {
                if (!base) base = (0, _pathJs.basename)(path);
                if (!name) name = base.substr(0, base.length - (0, _pathJs.extname)(path).length);
            }
            const result = parsedPattern(path, base, name, hasSibling);
            if (typeof result === "string") return result; // immediately return as soon as the first expression matches
            // If the result is a promise, we have to keep it for
            // later processing and await the result properly.
            if ((0, _asyncJs.isThenable)(result)) {
                if (!resultPromises) resultPromises = [];
                resultPromises.push(result);
            }
        }
        // With result promises, we have to loop over each and
        // await the result before we can return any result.
        if (resultPromises) return (async ()=>{
            for (const resultPromise of resultPromises){
                const result = await resultPromise;
                if (typeof result === "string") return result;
            }
            return null;
        })();
        return null;
    };
    const withBasenames = parsedPatterns.find((pattern)=>!!pattern.allBasenames);
    if (withBasenames) resultExpression.allBasenames = withBasenames.allBasenames;
    const allPaths = parsedPatterns.reduce((all, current)=>current.allPaths ? all.concat(current.allPaths) : all, []);
    if (allPaths.length) resultExpression.allPaths = allPaths;
    return resultExpression;
}
function parseExpressionPattern(pattern, value, options) {
    if (value === false) return NULL; // pattern is disabled
    const parsedPattern = parsePattern(pattern, options);
    if (parsedPattern === NULL) return NULL;
    // Expression Pattern is <boolean>
    if (typeof value === "boolean") return parsedPattern;
    // Expression Pattern is <SiblingClause>
    if (value) {
        const when = value.when;
        if (typeof when === "string") {
            const result = (path, basename, name, hasSibling)=>{
                if (!hasSibling || !parsedPattern(path, basename)) return null;
                const clausePattern = when.replace("$(basename)", ()=>name);
                const matched = hasSibling(clausePattern);
                return (0, _asyncJs.isThenable)(matched) ? matched.then((match)=>match ? pattern : null) : matched ? pattern : null;
            };
            result.requiresSiblings = true;
            return result;
        }
    }
    // Expression is anything
    return parsedPattern;
}
function aggregateBasenameMatches(parsedPatterns, result) {
    const basenamePatterns = parsedPatterns.filter((parsedPattern)=>!!parsedPattern.basenames);
    if (basenamePatterns.length < 2) return parsedPatterns;
    const basenames = basenamePatterns.reduce((all, current)=>{
        const basenames = current.basenames;
        return basenames ? all.concat(basenames) : all;
    }, []);
    let patterns;
    if (result) {
        patterns = [];
        for(let i = 0, n = basenames.length; i < n; i++)patterns.push(result);
    } else patterns = basenamePatterns.reduce((all, current)=>{
        const patterns = current.patterns;
        return patterns ? all.concat(patterns) : all;
    }, []);
    const aggregate = function(path, basename) {
        if (typeof path !== "string") return null;
        if (!basename) {
            let i;
            for(i = path.length; i > 0; i--){
                const ch = path.charCodeAt(i - 1);
                if (ch === 47 /* CharCode.Slash */  || ch === 92 /* CharCode.Backslash */ ) break;
            }
            basename = path.substr(i);
        }
        const index = basenames.indexOf(basename);
        return index !== -1 ? patterns[index] : null;
    };
    aggregate.basenames = basenames;
    aggregate.patterns = patterns;
    aggregate.allBasenames = basenames;
    const aggregatedPatterns = parsedPatterns.filter((parsedPattern)=>!parsedPattern.basenames);
    aggregatedPatterns.push(aggregate);
    return aggregatedPatterns;
}

},{"./async.js":"4GJc4","./extpath.js":"7a3D5","./map.js":"leSjz","./path.js":"vyRKJ","./platform.js":"7maJO","./strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7a3D5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPathSeparator", ()=>isPathSeparator);
/**
 * Takes a Windows OS path and changes backward slashes to forward slashes.
 * This should only be done for OS paths from Windows (or user provided paths potentially from Windows).
 * Using it on a Linux or MaxOS path might change it.
 */ parcelHelpers.export(exports, "toSlashes", ()=>toSlashes);
/**
 * Takes a Windows OS path (using backward or forward slashes) and turns it into a posix path:
 * - turns backward slashes into forward slashes
 * - makes it absolute if it starts with a drive letter
 * This should only be done for OS paths from Windows (or user provided paths potentially from Windows).
 * Using it on a Linux or MaxOS path might change it.
 */ parcelHelpers.export(exports, "toPosixPath", ()=>toPosixPath);
/**
 * Computes the _root_ this path, like `getRoot('c:\files') === c:\`,
 * `getRoot('files:///files/path') === files:///`,
 * or `getRoot('\\server\shares\path') === \\server\shares\`
 */ parcelHelpers.export(exports, "getRoot", ()=>getRoot);
/**
 * @deprecated please use `IUriIdentityService.extUri.isEqualOrParent` instead. If
 * you are in a context without services, consider to pass down the `extUri` from the
 * outside, or use `extUriBiasedIgnorePathCase` if you know what you are doing.
 */ parcelHelpers.export(exports, "isEqualOrParent", ()=>isEqualOrParent);
parcelHelpers.export(exports, "isWindowsDriveLetter", ()=>isWindowsDriveLetter);
parcelHelpers.export(exports, "hasDriveLetter", ()=>hasDriveLetter);
var _pathJs = require("./path.js");
var _platformJs = require("./platform.js");
var _stringsJs = require("./strings.js");
function isPathSeparator(code) {
    return code === 47 /* CharCode.Slash */  || code === 92 /* CharCode.Backslash */ ;
}
function toSlashes(osPath) {
    return osPath.replace(/[\\/]/g, (0, _pathJs.posix).sep);
}
function toPosixPath(osPath) {
    if (osPath.indexOf("/") === -1) osPath = toSlashes(osPath);
    if (/^[a-zA-Z]:(\/|$)/.test(osPath)) osPath = "/" + osPath;
    return osPath;
}
function getRoot(path, sep = (0, _pathJs.posix).sep) {
    if (!path) return "";
    const len = path.length;
    const firstLetter = path.charCodeAt(0);
    if (isPathSeparator(firstLetter)) {
        if (isPathSeparator(path.charCodeAt(1))) // UNC candidate \\localhost\shares\ddd
        //               ^^^^^^^^^^^^^^^^^^^
        {
            if (!isPathSeparator(path.charCodeAt(2))) {
                let pos = 3;
                const start = pos;
                for(; pos < len; pos++){
                    if (isPathSeparator(path.charCodeAt(pos))) break;
                }
                if (start !== pos && !isPathSeparator(path.charCodeAt(pos + 1))) {
                    pos += 1;
                    for(; pos < len; pos++){
                        if (isPathSeparator(path.charCodeAt(pos))) return path.slice(0, pos + 1) // consume this separator
                        .replace(/[\\/]/g, sep);
                    }
                }
            }
        }
        // /user/far
        // ^
        return sep;
    } else if (isWindowsDriveLetter(firstLetter)) // check for windows drive letter c:\ or c:
    {
        if (path.charCodeAt(1) === 58 /* CharCode.Colon */ ) {
            if (isPathSeparator(path.charCodeAt(2))) // C:\fff
            // ^^^
            return path.slice(0, 2) + sep;
            else // C:
            // ^^
            return path.slice(0, 2);
        }
    }
    // check for URI
    // scheme://authority/path
    // ^^^^^^^^^^^^^^^^^^^
    let pos = path.indexOf("://");
    if (pos !== -1) {
        pos += 3; // 3 -> "://".length
        for(; pos < len; pos++){
            if (isPathSeparator(path.charCodeAt(pos))) return path.slice(0, pos + 1); // consume this separator
        }
    }
    return "";
}
function isEqualOrParent(base, parentCandidate, ignoreCase, separator = (0, _pathJs.sep)) {
    if (base === parentCandidate) return true;
    if (!base || !parentCandidate) return false;
    if (parentCandidate.length > base.length) return false;
    if (ignoreCase) {
        const beginsWith = (0, _stringsJs.startsWithIgnoreCase)(base, parentCandidate);
        if (!beginsWith) return false;
        if (parentCandidate.length === base.length) return true; // same path, different casing
        let sepOffset = parentCandidate.length;
        if (parentCandidate.charAt(parentCandidate.length - 1) === separator) sepOffset--; // adjust the expected sep offset in case our candidate already ends in separator character
        return base.charAt(sepOffset) === separator;
    }
    if (parentCandidate.charAt(parentCandidate.length - 1) !== separator) parentCandidate += separator;
    return base.indexOf(parentCandidate) === 0;
}
function isWindowsDriveLetter(char0) {
    return char0 >= 65 /* CharCode.A */  && char0 <= 90 /* CharCode.Z */  || char0 >= 97 /* CharCode.a */  && char0 <= 122 /* CharCode.z */ ;
}
function hasDriveLetter(path, isWindowsOS = (0, _platformJs.isWindows)) {
    if (isWindowsOS) return isWindowsDriveLetter(path.charCodeAt(0)) && path.charCodeAt(1) === 58 /* CharCode.Colon */ ;
    return false;
}

},{"./path.js":"vyRKJ","./platform.js":"7maJO","./strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2lZxe":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverService", ()=>HoverService);
var _extensionsJs = require("../../../../platform/instantiation/common/extensions.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _hoverJs = require("../../../../platform/hover/browser/hover.js");
var _contextViewJs = require("../../../../platform/contextview/browser/contextView.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _hoverWidgetJs = require("./hoverWidget.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _domJs = require("../../../../base/browser/dom.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _keyboardEventJs = require("../../../../base/browser/keyboardEvent.js");
var _accessibilityJs = require("../../../../platform/accessibility/common/accessibility.js");
var _layoutServiceJs = require("../../../../platform/layout/browser/layoutService.js");
var _windowJs = require("../../../../base/browser/window.js");
var _contextViewServiceJs = require("../../../../platform/contextview/browser/contextViewService.js");
var _updatableHoverWidgetJs = require("./updatableHoverWidget.js");
var _asyncJs = require("../../../../base/common/async.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let HoverService = class HoverService extends (0, _lifecycleJs.Disposable) {
    constructor(_instantiationService, contextMenuService, _keybindingService, _layoutService, _accessibilityService){
        super();
        this._instantiationService = _instantiationService;
        this._keybindingService = _keybindingService;
        this._layoutService = _layoutService;
        this._accessibilityService = _accessibilityService;
        this._managedHovers = new Map();
        contextMenuService.onDidShowContextMenu(()=>this.hideHover());
        this._contextViewHandler = this._register(new (0, _contextViewServiceJs.ContextViewHandler)(this._layoutService));
    }
    showHover(options, focus, skipLastFocusedUpdate) {
        if (getHoverOptionsIdentity(this._currentHoverOptions) === getHoverOptionsIdentity(options)) return undefined;
        if (this._currentHover && this._currentHoverOptions?.persistence?.sticky) return undefined;
        this._currentHoverOptions = options;
        this._lastHoverOptions = options;
        const trapFocus = options.trapFocus || this._accessibilityService.isScreenReaderOptimized();
        const activeElement = (0, _domJs.getActiveElement)();
        // HACK, remove this check when #189076 is fixed
        if (!skipLastFocusedUpdate) {
            if (trapFocus && activeElement) {
                if (!activeElement.classList.contains("monaco-hover")) this._lastFocusedElementBeforeOpen = activeElement;
            } else this._lastFocusedElementBeforeOpen = undefined;
        }
        const hoverDisposables = new (0, _lifecycleJs.DisposableStore)();
        const hover = this._instantiationService.createInstance((0, _hoverWidgetJs.HoverWidget), options);
        if (options.persistence?.sticky) hover.isLocked = true;
        hover.onDispose(()=>{
            const hoverWasFocused = this._currentHover?.domNode && (0, _domJs.isAncestorOfActiveElement)(this._currentHover.domNode);
            if (hoverWasFocused) // Required to handle cases such as closing the hover with the escape key
            this._lastFocusedElementBeforeOpen?.focus();
            // Only clear the current options if it's the current hover, the current options help
            // reduce flickering when the same hover is shown multiple times
            if (this._currentHoverOptions === options) this._currentHoverOptions = undefined;
            hoverDisposables.dispose();
        }, undefined, hoverDisposables);
        // Set the container explicitly to enable aux window support
        if (!options.container) {
            const targetElement = (0, _domJs.isHTMLElement)(options.target) ? options.target : options.target.targetElements[0];
            options.container = this._layoutService.getContainer((0, _domJs.getWindow)(targetElement));
        }
        this._contextViewHandler.showContextView(new HoverContextViewDelegate(hover, focus), options.container);
        hover.onRequestLayout(()=>this._contextViewHandler.layout(), undefined, hoverDisposables);
        if (options.persistence?.sticky) hoverDisposables.add((0, _domJs.addDisposableListener)((0, _domJs.getWindow)(options.container).document, (0, _domJs.EventType).MOUSE_DOWN, (e)=>{
            if (!(0, _domJs.isAncestor)(e.target, hover.domNode)) this.doHideHover();
        }));
        else {
            if ("targetElements" in options.target) for (const element of options.target.targetElements)hoverDisposables.add((0, _domJs.addDisposableListener)(element, (0, _domJs.EventType).CLICK, ()=>this.hideHover()));
            else hoverDisposables.add((0, _domJs.addDisposableListener)(options.target, (0, _domJs.EventType).CLICK, ()=>this.hideHover()));
            const focusedElement = (0, _domJs.getActiveElement)();
            if (focusedElement) {
                const focusedElementDocument = (0, _domJs.getWindow)(focusedElement).document;
                hoverDisposables.add((0, _domJs.addDisposableListener)(focusedElement, (0, _domJs.EventType).KEY_DOWN, (e)=>this._keyDown(e, hover, !!options.persistence?.hideOnKeyDown)));
                hoverDisposables.add((0, _domJs.addDisposableListener)(focusedElementDocument, (0, _domJs.EventType).KEY_DOWN, (e)=>this._keyDown(e, hover, !!options.persistence?.hideOnKeyDown)));
                hoverDisposables.add((0, _domJs.addDisposableListener)(focusedElement, (0, _domJs.EventType).KEY_UP, (e)=>this._keyUp(e, hover)));
                hoverDisposables.add((0, _domJs.addDisposableListener)(focusedElementDocument, (0, _domJs.EventType).KEY_UP, (e)=>this._keyUp(e, hover)));
            }
        }
        if ("IntersectionObserver" in (0, _windowJs.mainWindow)) {
            const observer = new IntersectionObserver((e)=>this._intersectionChange(e, hover), {
                threshold: 0
            });
            const firstTargetElement = "targetElements" in options.target ? options.target.targetElements[0] : options.target;
            observer.observe(firstTargetElement);
            hoverDisposables.add((0, _lifecycleJs.toDisposable)(()=>observer.disconnect()));
        }
        this._currentHover = hover;
        return hover;
    }
    hideHover() {
        if (this._currentHover?.isLocked || !this._currentHoverOptions) return;
        this.doHideHover();
    }
    doHideHover() {
        this._currentHover = undefined;
        this._currentHoverOptions = undefined;
        this._contextViewHandler.hideContextView();
    }
    _intersectionChange(entries, hover) {
        const entry = entries[entries.length - 1];
        if (!entry.isIntersecting) hover.dispose();
    }
    showAndFocusLastHover() {
        if (!this._lastHoverOptions) return;
        this.showHover(this._lastHoverOptions, true, true);
    }
    _keyDown(e, hover, hideOnKeyDown) {
        if (e.key === "Alt") {
            hover.isLocked = true;
            return;
        }
        const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
        const keybinding = this._keybindingService.resolveKeyboardEvent(event);
        if (keybinding.getSingleModifierDispatchChords().some((value)=>!!value) || this._keybindingService.softDispatch(event, event.target).kind !== 0 /* ResultKind.NoMatchingKb */ ) return;
        if (hideOnKeyDown && (!this._currentHoverOptions?.trapFocus || e.key !== "Tab")) {
            this.hideHover();
            this._lastFocusedElementBeforeOpen?.focus();
        }
    }
    _keyUp(e, hover) {
        if (e.key === "Alt") {
            hover.isLocked = false;
            // Hide if alt is released while the mouse is not over hover/target
            if (!hover.isMouseIn) {
                this.hideHover();
                this._lastFocusedElementBeforeOpen?.focus();
            }
        }
    }
    // TODO: Investigate performance of this function. There seems to be a lot of content created
    //       and thrown away on start up
    setupManagedHover(hoverDelegate, targetElement, content, options) {
        targetElement.setAttribute("custom-hover", "true");
        if (targetElement.title !== "") {
            console.warn("HTML element already has a title attribute, which will conflict with the custom hover. Please remove the title attribute.");
            console.trace("Stack trace:", targetElement.title);
            targetElement.title = "";
        }
        let hoverPreparation;
        let hoverWidget;
        const hideHover = (disposeWidget, disposePreparation)=>{
            const hadHover = hoverWidget !== undefined;
            if (disposeWidget) {
                hoverWidget?.dispose();
                hoverWidget = undefined;
            }
            if (disposePreparation) {
                hoverPreparation?.dispose();
                hoverPreparation = undefined;
            }
            if (hadHover) {
                hoverDelegate.onDidHideHover?.();
                hoverWidget = undefined;
            }
        };
        const triggerShowHover = (delay, focus, target, trapFocus)=>{
            return new (0, _asyncJs.TimeoutTimer)(async ()=>{
                if (!hoverWidget || hoverWidget.isDisposed) {
                    hoverWidget = new (0, _updatableHoverWidgetJs.ManagedHoverWidget)(hoverDelegate, target || targetElement, delay > 0);
                    await hoverWidget.update(typeof content === "function" ? content() : content, focus, {
                        ...options,
                        trapFocus
                    });
                }
            }, delay);
        };
        let isMouseDown = false;
        const mouseDownEmitter = (0, _domJs.addDisposableListener)(targetElement, (0, _domJs.EventType).MOUSE_DOWN, ()=>{
            isMouseDown = true;
            hideHover(true, true);
        }, true);
        const mouseUpEmitter = (0, _domJs.addDisposableListener)(targetElement, (0, _domJs.EventType).MOUSE_UP, ()=>{
            isMouseDown = false;
        }, true);
        const mouseLeaveEmitter = (0, _domJs.addDisposableListener)(targetElement, (0, _domJs.EventType).MOUSE_LEAVE, (e)=>{
            isMouseDown = false;
            hideHover(false, e.fromElement === targetElement);
        }, true);
        const onMouseOver = (e)=>{
            if (hoverPreparation) return;
            const toDispose = new (0, _lifecycleJs.DisposableStore)();
            const target = {
                targetElements: [
                    targetElement
                ],
                dispose: ()=>{}
            };
            if (hoverDelegate.placement === undefined || hoverDelegate.placement === "mouse") {
                // track the mouse position
                const onMouseMove = (e)=>{
                    target.x = e.x + 10;
                    if ((0, _domJs.isHTMLElement)(e.target) && getHoverTargetElement(e.target, targetElement) !== targetElement) hideHover(true, true);
                };
                toDispose.add((0, _domJs.addDisposableListener)(targetElement, (0, _domJs.EventType).MOUSE_MOVE, onMouseMove, true));
            }
            hoverPreparation = toDispose;
            if ((0, _domJs.isHTMLElement)(e.target) && getHoverTargetElement(e.target, targetElement) !== targetElement) return; // Do not show hover when the mouse is over another hover target
            toDispose.add(triggerShowHover(hoverDelegate.delay, false, target));
        };
        const mouseOverDomEmitter = (0, _domJs.addDisposableListener)(targetElement, (0, _domJs.EventType).MOUSE_OVER, onMouseOver, true);
        const onFocus = ()=>{
            if (isMouseDown || hoverPreparation) return;
            const target = {
                targetElements: [
                    targetElement
                ],
                dispose: ()=>{}
            };
            const toDispose = new (0, _lifecycleJs.DisposableStore)();
            const onBlur = ()=>hideHover(true, true);
            toDispose.add((0, _domJs.addDisposableListener)(targetElement, (0, _domJs.EventType).BLUR, onBlur, true));
            toDispose.add(triggerShowHover(hoverDelegate.delay, false, target));
            hoverPreparation = toDispose;
        };
        // Do not show hover when focusing an input or textarea
        let focusDomEmitter;
        const tagName = targetElement.tagName.toLowerCase();
        if (tagName !== "input" && tagName !== "textarea") focusDomEmitter = (0, _domJs.addDisposableListener)(targetElement, (0, _domJs.EventType).FOCUS, onFocus, true);
        const hover = {
            show: (focus)=>{
                hideHover(false, true); // terminate a ongoing mouse over preparation
                triggerShowHover(0, focus, undefined, focus); // show hover immediately
            },
            hide: ()=>{
                hideHover(true, true);
            },
            update: async (newContent, hoverOptions)=>{
                content = newContent;
                await hoverWidget?.update(content, undefined, hoverOptions);
            },
            dispose: ()=>{
                this._managedHovers.delete(targetElement);
                mouseOverDomEmitter.dispose();
                mouseLeaveEmitter.dispose();
                mouseDownEmitter.dispose();
                mouseUpEmitter.dispose();
                focusDomEmitter?.dispose();
                hideHover(true, true);
            }
        };
        this._managedHovers.set(targetElement, hover);
        return hover;
    }
    showManagedHover(target) {
        const hover = this._managedHovers.get(target);
        if (hover) hover.show(true);
    }
    dispose() {
        this._managedHovers.forEach((hover)=>hover.dispose());
        super.dispose();
    }
};
HoverService = __decorate([
    __param(0, (0, _instantiationJs.IInstantiationService)),
    __param(1, (0, _contextViewJs.IContextMenuService)),
    __param(2, (0, _keybindingJs.IKeybindingService)),
    __param(3, (0, _layoutServiceJs.ILayoutService)),
    __param(4, (0, _accessibilityJs.IAccessibilityService))
], HoverService);
function getHoverOptionsIdentity(options) {
    if (options === undefined) return undefined;
    return options?.id ?? options;
}
class HoverContextViewDelegate {
    get anchorPosition() {
        return this._hover.anchor;
    }
    constructor(_hover, _focus = false){
        this._hover = _hover;
        this._focus = _focus;
        // Render over all other context views
        this.layer = 1;
    }
    render(container) {
        this._hover.render(container);
        if (this._focus) this._hover.focus();
        return this._hover;
    }
    getAnchor() {
        return {
            x: this._hover.x,
            y: this._hover.y
        };
    }
    layout() {
        this._hover.layout();
    }
}
function getHoverTargetElement(element, stopElement) {
    stopElement = stopElement ?? (0, _domJs.getWindow)(element).document.body;
    while(!element.hasAttribute("custom-hover") && element !== stopElement)element = element.parentElement;
    return element;
}
(0, _extensionsJs.registerSingleton)((0, _hoverJs.IHoverService), HoverService, 1 /* InstantiationType.Delayed */ );
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const hoverBorder = theme.getColor((0, _colorRegistryJs.editorHoverBorder));
    if (hoverBorder) {
        collector.addRule(`.monaco-workbench .workbench-hover .hover-row:not(:first-child):not(:empty) { border-top: 1px solid ${hoverBorder.transparent(0.5)}; }`);
        collector.addRule(`.monaco-workbench .workbench-hover hr { border-top: 1px solid ${hoverBorder.transparent(0.5)}; }`);
    }
});

},{"../../../../platform/instantiation/common/extensions.js":"6WJLq","../../../../platform/theme/common/themeService.js":"jMkIC","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/hover/browser/hover.js":"3QGXp","../../../../platform/contextview/browser/contextView.js":"2QlUR","../../../../platform/instantiation/common/instantiation.js":"fjwWx","./hoverWidget.js":"8US5g","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/browser/dom.js":"bnqsM","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../base/browser/keyboardEvent.js":"bxU9U","../../../../platform/accessibility/common/accessibility.js":"9Svqy","../../../../platform/layout/browser/layoutService.js":"fPPgf","../../../../base/browser/window.js":"aJBhQ","../../../../platform/contextview/browser/contextViewService.js":"3MZFS","./updatableHoverWidget.js":"dUjQm","../../../../base/common/async.js":"4GJc4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ik5kv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorUtilsJs = require("./colorUtils.js");
parcelHelpers.exportAll(_colorUtilsJs, exports);
// Make sure all color files are exported
var _baseColorsJs = require("./colors/baseColors.js");
parcelHelpers.exportAll(_baseColorsJs, exports);
var _chartsColorsJs = require("./colors/chartsColors.js");
parcelHelpers.exportAll(_chartsColorsJs, exports);
var _editorColorsJs = require("./colors/editorColors.js");
parcelHelpers.exportAll(_editorColorsJs, exports);
var _inputColorsJs = require("./colors/inputColors.js");
parcelHelpers.exportAll(_inputColorsJs, exports);
var _listColorsJs = require("./colors/listColors.js");
parcelHelpers.exportAll(_listColorsJs, exports);
var _menuColorsJs = require("./colors/menuColors.js");
parcelHelpers.exportAll(_menuColorsJs, exports);
var _minimapColorsJs = require("./colors/minimapColors.js");
parcelHelpers.exportAll(_minimapColorsJs, exports);
var _miscColorsJs = require("./colors/miscColors.js");
parcelHelpers.exportAll(_miscColorsJs, exports);
var _quickpickColorsJs = require("./colors/quickpickColors.js");
parcelHelpers.exportAll(_quickpickColorsJs, exports);
var _searchColorsJs = require("./colors/searchColors.js");
parcelHelpers.exportAll(_searchColorsJs, exports);

},{"./colorUtils.js":"7VkBg","./colors/baseColors.js":"8iG5A","./colors/chartsColors.js":"d26TP","./colors/editorColors.js":"c46FO","./colors/inputColors.js":"9pTqI","./colors/listColors.js":"58Zzh","./colors/menuColors.js":"8mqTF","./colors/minimapColors.js":"kCB7P","./colors/miscColors.js":"9tRkH","./colors/quickpickColors.js":"9j1zL","./colors/searchColors.js":"23gml","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7VkBg":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the css variable name for the given color identifier. Dots (`.`) are replaced with hyphens (`-`) and
 * everything is prefixed with `--vscode-`.
 *
 * @sample `editorSuggestWidget.background` is `--vscode-editorSuggestWidget-background`.
 */ parcelHelpers.export(exports, "asCssVariableName", ()=>asCssVariableName);
parcelHelpers.export(exports, "asCssVariable", ()=>asCssVariable);
parcelHelpers.export(exports, "asCssVariableWithDefault", ()=>asCssVariableWithDefault);
parcelHelpers.export(exports, "isColorDefaults", ()=>isColorDefaults);
parcelHelpers.export(exports, "Extensions", ()=>Extensions);
parcelHelpers.export(exports, "DEFAULT_COLOR_CONFIG_VALUE", ()=>DEFAULT_COLOR_CONFIG_VALUE);
parcelHelpers.export(exports, "registerColor", ()=>registerColor);
// ----- color functions
parcelHelpers.export(exports, "executeTransform", ()=>executeTransform);
parcelHelpers.export(exports, "darken", ()=>darken);
parcelHelpers.export(exports, "lighten", ()=>lighten);
parcelHelpers.export(exports, "transparent", ()=>transparent);
parcelHelpers.export(exports, "oneOf", ()=>oneOf);
parcelHelpers.export(exports, "ifDefinedThenElse", ()=>ifDefinedThenElse);
parcelHelpers.export(exports, "lessProminent", ()=>lessProminent);
// ----- implementation
/**
 * @param colorValue Resolve a color value in the context of a theme
 */ parcelHelpers.export(exports, "resolveColorValue", ()=>resolveColorValue);
parcelHelpers.export(exports, "workbenchColorsSchemaId", ()=>workbenchColorsSchemaId);
var _assertJs = require("../../../base/common/assert.js");
var _asyncJs = require("../../../base/common/async.js");
var _colorJs = require("../../../base/common/color.js");
var _eventJs = require("../../../base/common/event.js");
var _jsonContributionRegistryJs = require("../../jsonschemas/common/jsonContributionRegistry.js");
var _platformJs = require("../../registry/common/platform.js");
var _nlsJs = require("../../../nls.js");
function asCssVariableName(colorIdent) {
    return `--vscode-${colorIdent.replace(/\./g, "-")}`;
}
function asCssVariable(color) {
    return `var(${asCssVariableName(color)})`;
}
function asCssVariableWithDefault(color, defaultCssValue) {
    return `var(${asCssVariableName(color)}, ${defaultCssValue})`;
}
function isColorDefaults(value) {
    return value !== null && typeof value === "object" && "light" in value && "dark" in value;
}
const Extensions = {
    ColorContribution: "base.contributions.colors"
};
const DEFAULT_COLOR_CONFIG_VALUE = "default";
class ColorRegistry {
    constructor(){
        this._onDidChangeSchema = new (0, _eventJs.Emitter)();
        this.onDidChangeSchema = this._onDidChangeSchema.event;
        this.colorSchema = {
            type: "object",
            properties: {}
        };
        this.colorReferenceSchema = {
            type: "string",
            enum: [],
            enumDescriptions: []
        };
        this.colorsById = {};
    }
    registerColor(id, defaults, description, needsTransparency = false, deprecationMessage) {
        const colorContribution = {
            id,
            description,
            defaults,
            needsTransparency,
            deprecationMessage
        };
        this.colorsById[id] = colorContribution;
        const propertySchema = {
            type: "string",
            format: "color-hex",
            defaultSnippets: [
                {
                    body: "${1:#ff0000}"
                }
            ]
        };
        if (deprecationMessage) propertySchema.deprecationMessage = deprecationMessage;
        if (needsTransparency) {
            propertySchema.pattern = "^#(?:(?<rgba>[0-9a-fA-f]{3}[0-9a-eA-E])|(?:[0-9a-fA-F]{6}(?:(?![fF]{2})(?:[0-9a-fA-F]{2}))))?$";
            propertySchema.patternErrorMessage = _nlsJs.localize("transparecyRequired", "This color must be transparent or it will obscure content");
        }
        this.colorSchema.properties[id] = {
            description,
            oneOf: [
                propertySchema,
                {
                    type: "string",
                    const: DEFAULT_COLOR_CONFIG_VALUE,
                    description: _nlsJs.localize("useDefault", "Use the default color.")
                }
            ]
        };
        this.colorReferenceSchema.enum.push(id);
        this.colorReferenceSchema.enumDescriptions.push(description);
        this._onDidChangeSchema.fire();
        return id;
    }
    getColors() {
        return Object.keys(this.colorsById).map((id)=>this.colorsById[id]);
    }
    resolveDefaultColor(id, theme) {
        const colorDesc = this.colorsById[id];
        if (colorDesc?.defaults) {
            const colorValue = isColorDefaults(colorDesc.defaults) ? colorDesc.defaults[theme.type] : colorDesc.defaults;
            return resolveColorValue(colorValue, theme);
        }
        return undefined;
    }
    getColorSchema() {
        return this.colorSchema;
    }
    toString() {
        const sorter = (a, b)=>{
            const cat1 = a.indexOf(".") === -1 ? 0 : 1;
            const cat2 = b.indexOf(".") === -1 ? 0 : 1;
            if (cat1 !== cat2) return cat1 - cat2;
            return a.localeCompare(b);
        };
        return Object.keys(this.colorsById).sort(sorter).map((k)=>`- \`${k}\`: ${this.colorsById[k].description}`).join("\n");
    }
}
const colorRegistry = new ColorRegistry();
_platformJs.Registry.add(Extensions.ColorContribution, colorRegistry);
function registerColor(id, defaults, description, needsTransparency, deprecationMessage) {
    return colorRegistry.registerColor(id, defaults, description, needsTransparency, deprecationMessage);
}
function executeTransform(transform, theme) {
    switch(transform.op){
        case 0 /* ColorTransformType.Darken */ :
            return resolveColorValue(transform.value, theme)?.darken(transform.factor);
        case 1 /* ColorTransformType.Lighten */ :
            return resolveColorValue(transform.value, theme)?.lighten(transform.factor);
        case 2 /* ColorTransformType.Transparent */ :
            return resolveColorValue(transform.value, theme)?.transparent(transform.factor);
        case 3 /* ColorTransformType.Opaque */ :
            {
                const backgroundColor = resolveColorValue(transform.background, theme);
                if (!backgroundColor) return resolveColorValue(transform.value, theme);
                return resolveColorValue(transform.value, theme)?.makeOpaque(backgroundColor);
            }
        case 4 /* ColorTransformType.OneOf */ :
            for (const candidate of transform.values){
                const color = resolveColorValue(candidate, theme);
                if (color) return color;
            }
            return undefined;
        case 6 /* ColorTransformType.IfDefinedThenElse */ :
            return resolveColorValue(theme.defines(transform.if) ? transform.then : transform.else, theme);
        case 5 /* ColorTransformType.LessProminent */ :
            {
                const from = resolveColorValue(transform.value, theme);
                if (!from) return undefined;
                const backgroundColor = resolveColorValue(transform.background, theme);
                if (!backgroundColor) return from.transparent(transform.factor * transform.transparency);
                return from.isDarkerThan(backgroundColor) ? (0, _colorJs.Color).getLighterColor(from, backgroundColor, transform.factor).transparent(transform.transparency) : (0, _colorJs.Color).getDarkerColor(from, backgroundColor, transform.factor).transparent(transform.transparency);
            }
        default:
            throw (0, _assertJs.assertNever)(transform);
    }
}
function darken(colorValue, factor) {
    return {
        op: 0 /* ColorTransformType.Darken */ ,
        value: colorValue,
        factor
    };
}
function lighten(colorValue, factor) {
    return {
        op: 1 /* ColorTransformType.Lighten */ ,
        value: colorValue,
        factor
    };
}
function transparent(colorValue, factor) {
    return {
        op: 2 /* ColorTransformType.Transparent */ ,
        value: colorValue,
        factor
    };
}
function oneOf(...colorValues) {
    return {
        op: 4 /* ColorTransformType.OneOf */ ,
        values: colorValues
    };
}
function ifDefinedThenElse(ifArg, thenArg, elseArg) {
    return {
        op: 6 /* ColorTransformType.IfDefinedThenElse */ ,
        if: ifArg,
        then: thenArg,
        else: elseArg
    };
}
function lessProminent(colorValue, backgroundColorValue, factor, transparency) {
    return {
        op: 5 /* ColorTransformType.LessProminent */ ,
        value: colorValue,
        background: backgroundColorValue,
        factor,
        transparency
    };
}
function resolveColorValue(colorValue, theme) {
    if (colorValue === null) return undefined;
    else if (typeof colorValue === "string") {
        if (colorValue[0] === "#") return (0, _colorJs.Color).fromHex(colorValue);
        return theme.getColor(colorValue);
    } else if (colorValue instanceof (0, _colorJs.Color)) return colorValue;
    else if (typeof colorValue === "object") return executeTransform(colorValue, theme);
    return undefined;
}
const workbenchColorsSchemaId = "vscode://schemas/workbench-colors";
const schemaRegistry = _platformJs.Registry.as((0, _jsonContributionRegistryJs.Extensions).JSONContribution);
schemaRegistry.registerSchema(workbenchColorsSchemaId, colorRegistry.getColorSchema());
const delayer = new (0, _asyncJs.RunOnceScheduler)(()=>schemaRegistry.notifySchemaChanged(workbenchColorsSchemaId), 200);
colorRegistry.onDidChangeSchema(()=>{
    if (!delayer.isScheduled()) delayer.schedule();
}); // setTimeout(_ => console.log(colorRegistry.toString()), 5000);

},{"../../../base/common/assert.js":"1nPIE","../../../base/common/async.js":"4GJc4","../../../base/common/color.js":"at4gb","../../../base/common/event.js":"4Zi8b","../../jsonschemas/common/jsonContributionRegistry.js":"6LKe5","../../registry/common/platform.js":"dzx11","../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8iG5A":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "foreground", ()=>foreground);
parcelHelpers.export(exports, "disabledForeground", ()=>disabledForeground);
parcelHelpers.export(exports, "errorForeground", ()=>errorForeground);
parcelHelpers.export(exports, "descriptionForeground", ()=>descriptionForeground);
parcelHelpers.export(exports, "iconForeground", ()=>iconForeground);
parcelHelpers.export(exports, "focusBorder", ()=>focusBorder);
parcelHelpers.export(exports, "contrastBorder", ()=>contrastBorder);
parcelHelpers.export(exports, "activeContrastBorder", ()=>activeContrastBorder);
parcelHelpers.export(exports, "selectionBackground", ()=>selectionBackground);
parcelHelpers.export(exports, "textLinkForeground", ()=>textLinkForeground);
parcelHelpers.export(exports, "textLinkActiveForeground", ()=>textLinkActiveForeground);
parcelHelpers.export(exports, "textSeparatorForeground", ()=>textSeparatorForeground);
parcelHelpers.export(exports, "textPreformatForeground", ()=>textPreformatForeground);
parcelHelpers.export(exports, "textPreformatBackground", ()=>textPreformatBackground);
parcelHelpers.export(exports, "textBlockQuoteBackground", ()=>textBlockQuoteBackground);
parcelHelpers.export(exports, "textBlockQuoteBorder", ()=>textBlockQuoteBorder);
parcelHelpers.export(exports, "textCodeBlockBackground", ()=>textCodeBlockBackground);
var _nlsJs = require("../../../../nls.js");
// Import the effects we need
var _colorJs = require("../../../../base/common/color.js");
var _colorUtilsJs = require("../colorUtils.js");
const foreground = (0, _colorUtilsJs.registerColor)("foreground", {
    dark: "#CCCCCC",
    light: "#616161",
    hcDark: "#FFFFFF",
    hcLight: "#292929"
}, _nlsJs.localize("foreground", "Overall foreground color. This color is only used if not overridden by a component."));
const disabledForeground = (0, _colorUtilsJs.registerColor)("disabledForeground", {
    dark: "#CCCCCC80",
    light: "#61616180",
    hcDark: "#A5A5A5",
    hcLight: "#7F7F7F"
}, _nlsJs.localize("disabledForeground", "Overall foreground for disabled elements. This color is only used if not overridden by a component."));
const errorForeground = (0, _colorUtilsJs.registerColor)("errorForeground", {
    dark: "#F48771",
    light: "#A1260D",
    hcDark: "#F48771",
    hcLight: "#B5200D"
}, _nlsJs.localize("errorForeground", "Overall foreground color for error messages. This color is only used if not overridden by a component."));
const descriptionForeground = (0, _colorUtilsJs.registerColor)("descriptionForeground", {
    light: "#717171",
    dark: (0, _colorUtilsJs.transparent)(foreground, 0.7),
    hcDark: (0, _colorUtilsJs.transparent)(foreground, 0.7),
    hcLight: (0, _colorUtilsJs.transparent)(foreground, 0.7)
}, _nlsJs.localize("descriptionForeground", "Foreground color for description text providing additional information, for example for a label."));
const iconForeground = (0, _colorUtilsJs.registerColor)("icon.foreground", {
    dark: "#C5C5C5",
    light: "#424242",
    hcDark: "#FFFFFF",
    hcLight: "#292929"
}, _nlsJs.localize("iconForeground", "The default color for icons in the workbench."));
const focusBorder = (0, _colorUtilsJs.registerColor)("focusBorder", {
    dark: "#007FD4",
    light: "#0090F1",
    hcDark: "#F38518",
    hcLight: "#006BBD"
}, _nlsJs.localize("focusBorder", "Overall border color for focused elements. This color is only used if not overridden by a component."));
const contrastBorder = (0, _colorUtilsJs.registerColor)("contrastBorder", {
    light: null,
    dark: null,
    hcDark: "#6FC3DF",
    hcLight: "#0F4A85"
}, _nlsJs.localize("contrastBorder", "An extra border around elements to separate them from others for greater contrast."));
const activeContrastBorder = (0, _colorUtilsJs.registerColor)("contrastActiveBorder", {
    light: null,
    dark: null,
    hcDark: focusBorder,
    hcLight: focusBorder
}, _nlsJs.localize("activeContrastBorder", "An extra border around active elements to separate them from others for greater contrast."));
const selectionBackground = (0, _colorUtilsJs.registerColor)("selection.background", null, _nlsJs.localize("selectionBackground", "The background color of text selections in the workbench (e.g. for input fields or text areas). Note that this does not apply to selections within the editor."));
const textLinkForeground = (0, _colorUtilsJs.registerColor)("textLink.foreground", {
    light: "#006AB1",
    dark: "#3794FF",
    hcDark: "#21A6FF",
    hcLight: "#0F4A85"
}, _nlsJs.localize("textLinkForeground", "Foreground color for links in text."));
const textLinkActiveForeground = (0, _colorUtilsJs.registerColor)("textLink.activeForeground", {
    light: "#006AB1",
    dark: "#3794FF",
    hcDark: "#21A6FF",
    hcLight: "#0F4A85"
}, _nlsJs.localize("textLinkActiveForeground", "Foreground color for links in text when clicked on and on mouse hover."));
const textSeparatorForeground = (0, _colorUtilsJs.registerColor)("textSeparator.foreground", {
    light: "#0000002e",
    dark: "#ffffff2e",
    hcDark: (0, _colorJs.Color).black,
    hcLight: "#292929"
}, _nlsJs.localize("textSeparatorForeground", "Color for text separators."));
const textPreformatForeground = (0, _colorUtilsJs.registerColor)("textPreformat.foreground", {
    light: "#A31515",
    dark: "#D7BA7D",
    hcDark: "#000000",
    hcLight: "#FFFFFF"
}, _nlsJs.localize("textPreformatForeground", "Foreground color for preformatted text segments."));
const textPreformatBackground = (0, _colorUtilsJs.registerColor)("textPreformat.background", {
    light: "#0000001A",
    dark: "#FFFFFF1A",
    hcDark: "#FFFFFF",
    hcLight: "#09345f"
}, _nlsJs.localize("textPreformatBackground", "Background color for preformatted text segments."));
const textBlockQuoteBackground = (0, _colorUtilsJs.registerColor)("textBlockQuote.background", {
    light: "#f2f2f2",
    dark: "#222222",
    hcDark: null,
    hcLight: "#F2F2F2"
}, _nlsJs.localize("textBlockQuoteBackground", "Background color for block quotes in text."));
const textBlockQuoteBorder = (0, _colorUtilsJs.registerColor)("textBlockQuote.border", {
    light: "#007acc80",
    dark: "#007acc80",
    hcDark: (0, _colorJs.Color).white,
    hcLight: "#292929"
}, _nlsJs.localize("textBlockQuoteBorder", "Border color for block quotes in text."));
const textCodeBlockBackground = (0, _colorUtilsJs.registerColor)("textCodeBlock.background", {
    light: "#dcdcdc66",
    dark: "#0a0a0a66",
    hcDark: (0, _colorJs.Color).black,
    hcLight: "#F2F2F2"
}, _nlsJs.localize("textCodeBlockBackground", "Background color for code blocks in text."));

},{"../../../../nls.js":"l617d","../../../../base/common/color.js":"at4gb","../colorUtils.js":"7VkBg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d26TP":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chartsForeground", ()=>chartsForeground);
parcelHelpers.export(exports, "chartsLines", ()=>chartsLines);
parcelHelpers.export(exports, "chartsRed", ()=>chartsRed);
parcelHelpers.export(exports, "chartsBlue", ()=>chartsBlue);
parcelHelpers.export(exports, "chartsYellow", ()=>chartsYellow);
parcelHelpers.export(exports, "chartsOrange", ()=>chartsOrange);
parcelHelpers.export(exports, "chartsGreen", ()=>chartsGreen);
parcelHelpers.export(exports, "chartsPurple", ()=>chartsPurple);
var _nlsJs = require("../../../../nls.js");
var _colorUtilsJs = require("../colorUtils.js");
var _baseColorsJs = require("./baseColors.js");
var _editorColorsJs = require("./editorColors.js");
var _minimapColorsJs = require("./minimapColors.js");
const chartsForeground = (0, _colorUtilsJs.registerColor)("charts.foreground", (0, _baseColorsJs.foreground), _nlsJs.localize("chartsForeground", "The foreground color used in charts."));
const chartsLines = (0, _colorUtilsJs.registerColor)("charts.lines", (0, _colorUtilsJs.transparent)((0, _baseColorsJs.foreground), .5), _nlsJs.localize("chartsLines", "The color used for horizontal lines in charts."));
const chartsRed = (0, _colorUtilsJs.registerColor)("charts.red", (0, _editorColorsJs.editorErrorForeground), _nlsJs.localize("chartsRed", "The red color used in chart visualizations."));
const chartsBlue = (0, _colorUtilsJs.registerColor)("charts.blue", (0, _editorColorsJs.editorInfoForeground), _nlsJs.localize("chartsBlue", "The blue color used in chart visualizations."));
const chartsYellow = (0, _colorUtilsJs.registerColor)("charts.yellow", (0, _editorColorsJs.editorWarningForeground), _nlsJs.localize("chartsYellow", "The yellow color used in chart visualizations."));
const chartsOrange = (0, _colorUtilsJs.registerColor)("charts.orange", (0, _minimapColorsJs.minimapFindMatch), _nlsJs.localize("chartsOrange", "The orange color used in chart visualizations."));
const chartsGreen = (0, _colorUtilsJs.registerColor)("charts.green", {
    dark: "#89D185",
    light: "#388A34",
    hcDark: "#89D185",
    hcLight: "#374e06"
}, _nlsJs.localize("chartsGreen", "The green color used in chart visualizations."));
const chartsPurple = (0, _colorUtilsJs.registerColor)("charts.purple", {
    dark: "#B180D7",
    light: "#652D90",
    hcDark: "#B180D7",
    hcLight: "#652D90"
}, _nlsJs.localize("chartsPurple", "The purple color used in chart visualizations."));

},{"../../../../nls.js":"l617d","../colorUtils.js":"7VkBg","./baseColors.js":"8iG5A","./editorColors.js":"c46FO","./minimapColors.js":"kCB7P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c46FO":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "editorBackground", ()=>editorBackground);
parcelHelpers.export(exports, "editorForeground", ()=>editorForeground);
parcelHelpers.export(exports, "editorStickyScrollBackground", ()=>editorStickyScrollBackground);
parcelHelpers.export(exports, "editorStickyScrollHoverBackground", ()=>editorStickyScrollHoverBackground);
parcelHelpers.export(exports, "editorStickyScrollBorder", ()=>editorStickyScrollBorder);
parcelHelpers.export(exports, "editorStickyScrollShadow", ()=>editorStickyScrollShadow);
parcelHelpers.export(exports, "editorWidgetBackground", ()=>editorWidgetBackground);
parcelHelpers.export(exports, "editorWidgetForeground", ()=>editorWidgetForeground);
parcelHelpers.export(exports, "editorWidgetBorder", ()=>editorWidgetBorder);
parcelHelpers.export(exports, "editorWidgetResizeBorder", ()=>editorWidgetResizeBorder);
parcelHelpers.export(exports, "editorErrorBackground", ()=>editorErrorBackground);
parcelHelpers.export(exports, "editorErrorForeground", ()=>editorErrorForeground);
parcelHelpers.export(exports, "editorErrorBorder", ()=>editorErrorBorder);
parcelHelpers.export(exports, "editorWarningBackground", ()=>editorWarningBackground);
parcelHelpers.export(exports, "editorWarningForeground", ()=>editorWarningForeground);
parcelHelpers.export(exports, "editorWarningBorder", ()=>editorWarningBorder);
parcelHelpers.export(exports, "editorInfoBackground", ()=>editorInfoBackground);
parcelHelpers.export(exports, "editorInfoForeground", ()=>editorInfoForeground);
parcelHelpers.export(exports, "editorInfoBorder", ()=>editorInfoBorder);
parcelHelpers.export(exports, "editorHintForeground", ()=>editorHintForeground);
parcelHelpers.export(exports, "editorHintBorder", ()=>editorHintBorder);
parcelHelpers.export(exports, "editorActiveLinkForeground", ()=>editorActiveLinkForeground);
parcelHelpers.export(exports, "editorSelectionBackground", ()=>editorSelectionBackground);
parcelHelpers.export(exports, "editorSelectionForeground", ()=>editorSelectionForeground);
parcelHelpers.export(exports, "editorInactiveSelection", ()=>editorInactiveSelection);
parcelHelpers.export(exports, "editorSelectionHighlight", ()=>editorSelectionHighlight);
parcelHelpers.export(exports, "editorSelectionHighlightBorder", ()=>editorSelectionHighlightBorder);
parcelHelpers.export(exports, "editorFindMatch", ()=>editorFindMatch);
parcelHelpers.export(exports, "editorFindMatchForeground", ()=>editorFindMatchForeground);
parcelHelpers.export(exports, "editorFindMatchHighlight", ()=>editorFindMatchHighlight);
parcelHelpers.export(exports, "editorFindMatchHighlightForeground", ()=>editorFindMatchHighlightForeground);
parcelHelpers.export(exports, "editorFindRangeHighlight", ()=>editorFindRangeHighlight);
parcelHelpers.export(exports, "editorFindMatchBorder", ()=>editorFindMatchBorder);
parcelHelpers.export(exports, "editorFindMatchHighlightBorder", ()=>editorFindMatchHighlightBorder);
parcelHelpers.export(exports, "editorFindRangeHighlightBorder", ()=>editorFindRangeHighlightBorder);
parcelHelpers.export(exports, "editorHoverHighlight", ()=>editorHoverHighlight);
parcelHelpers.export(exports, "editorHoverBackground", ()=>editorHoverBackground);
parcelHelpers.export(exports, "editorHoverForeground", ()=>editorHoverForeground);
parcelHelpers.export(exports, "editorHoverBorder", ()=>editorHoverBorder);
parcelHelpers.export(exports, "editorHoverStatusBarBackground", ()=>editorHoverStatusBarBackground);
parcelHelpers.export(exports, "editorInlayHintForeground", ()=>editorInlayHintForeground);
parcelHelpers.export(exports, "editorInlayHintBackground", ()=>editorInlayHintBackground);
parcelHelpers.export(exports, "editorInlayHintTypeForeground", ()=>editorInlayHintTypeForeground);
parcelHelpers.export(exports, "editorInlayHintTypeBackground", ()=>editorInlayHintTypeBackground);
parcelHelpers.export(exports, "editorInlayHintParameterForeground", ()=>editorInlayHintParameterForeground);
parcelHelpers.export(exports, "editorInlayHintParameterBackground", ()=>editorInlayHintParameterBackground);
parcelHelpers.export(exports, "editorLightBulbForeground", ()=>editorLightBulbForeground);
parcelHelpers.export(exports, "editorLightBulbAutoFixForeground", ()=>editorLightBulbAutoFixForeground);
parcelHelpers.export(exports, "editorLightBulbAiForeground", ()=>editorLightBulbAiForeground);
parcelHelpers.export(exports, "snippetTabstopHighlightBackground", ()=>snippetTabstopHighlightBackground);
parcelHelpers.export(exports, "snippetTabstopHighlightBorder", ()=>snippetTabstopHighlightBorder);
parcelHelpers.export(exports, "snippetFinalTabstopHighlightBackground", ()=>snippetFinalTabstopHighlightBackground);
parcelHelpers.export(exports, "snippetFinalTabstopHighlightBorder", ()=>snippetFinalTabstopHighlightBorder);
parcelHelpers.export(exports, "defaultInsertColor", ()=>defaultInsertColor);
parcelHelpers.export(exports, "defaultRemoveColor", ()=>defaultRemoveColor);
parcelHelpers.export(exports, "diffInserted", ()=>diffInserted);
parcelHelpers.export(exports, "diffRemoved", ()=>diffRemoved);
parcelHelpers.export(exports, "diffInsertedLine", ()=>diffInsertedLine);
parcelHelpers.export(exports, "diffRemovedLine", ()=>diffRemovedLine);
parcelHelpers.export(exports, "diffInsertedLineGutter", ()=>diffInsertedLineGutter);
parcelHelpers.export(exports, "diffRemovedLineGutter", ()=>diffRemovedLineGutter);
parcelHelpers.export(exports, "diffOverviewRulerInserted", ()=>diffOverviewRulerInserted);
parcelHelpers.export(exports, "diffOverviewRulerRemoved", ()=>diffOverviewRulerRemoved);
parcelHelpers.export(exports, "diffInsertedOutline", ()=>diffInsertedOutline);
parcelHelpers.export(exports, "diffRemovedOutline", ()=>diffRemovedOutline);
parcelHelpers.export(exports, "diffBorder", ()=>diffBorder);
parcelHelpers.export(exports, "diffDiagonalFill", ()=>diffDiagonalFill);
parcelHelpers.export(exports, "diffUnchangedRegionBackground", ()=>diffUnchangedRegionBackground);
parcelHelpers.export(exports, "diffUnchangedRegionForeground", ()=>diffUnchangedRegionForeground);
parcelHelpers.export(exports, "diffUnchangedTextBackground", ()=>diffUnchangedTextBackground);
parcelHelpers.export(exports, "widgetShadow", ()=>widgetShadow);
parcelHelpers.export(exports, "widgetBorder", ()=>widgetBorder);
parcelHelpers.export(exports, "toolbarHoverBackground", ()=>toolbarHoverBackground);
parcelHelpers.export(exports, "toolbarHoverOutline", ()=>toolbarHoverOutline);
parcelHelpers.export(exports, "toolbarActiveBackground", ()=>toolbarActiveBackground);
parcelHelpers.export(exports, "breadcrumbsForeground", ()=>breadcrumbsForeground);
parcelHelpers.export(exports, "breadcrumbsBackground", ()=>breadcrumbsBackground);
parcelHelpers.export(exports, "breadcrumbsFocusForeground", ()=>breadcrumbsFocusForeground);
parcelHelpers.export(exports, "breadcrumbsActiveSelectionForeground", ()=>breadcrumbsActiveSelectionForeground);
parcelHelpers.export(exports, "breadcrumbsPickerBackground", ()=>breadcrumbsPickerBackground);
parcelHelpers.export(exports, "mergeCurrentHeaderBackground", ()=>mergeCurrentHeaderBackground);
parcelHelpers.export(exports, "mergeCurrentContentBackground", ()=>mergeCurrentContentBackground);
parcelHelpers.export(exports, "mergeIncomingHeaderBackground", ()=>mergeIncomingHeaderBackground);
parcelHelpers.export(exports, "mergeIncomingContentBackground", ()=>mergeIncomingContentBackground);
parcelHelpers.export(exports, "mergeCommonHeaderBackground", ()=>mergeCommonHeaderBackground);
parcelHelpers.export(exports, "mergeCommonContentBackground", ()=>mergeCommonContentBackground);
parcelHelpers.export(exports, "mergeBorder", ()=>mergeBorder);
parcelHelpers.export(exports, "overviewRulerCurrentContentForeground", ()=>overviewRulerCurrentContentForeground);
parcelHelpers.export(exports, "overviewRulerIncomingContentForeground", ()=>overviewRulerIncomingContentForeground);
parcelHelpers.export(exports, "overviewRulerCommonContentForeground", ()=>overviewRulerCommonContentForeground);
parcelHelpers.export(exports, "overviewRulerFindMatchForeground", ()=>overviewRulerFindMatchForeground);
parcelHelpers.export(exports, "overviewRulerSelectionHighlightForeground", ()=>overviewRulerSelectionHighlightForeground);
parcelHelpers.export(exports, "problemsErrorIconForeground", ()=>problemsErrorIconForeground);
parcelHelpers.export(exports, "problemsWarningIconForeground", ()=>problemsWarningIconForeground);
parcelHelpers.export(exports, "problemsInfoIconForeground", ()=>problemsInfoIconForeground);
var _nlsJs = require("../../../../nls.js");
// Import the effects we need
var _colorJs = require("../../../../base/common/color.js");
var _colorUtilsJs = require("../colorUtils.js");
// Import the colors we need
var _baseColorsJs = require("./baseColors.js");
var _miscColorsJs = require("./miscColors.js");
const editorBackground = (0, _colorUtilsJs.registerColor)("editor.background", {
    light: "#ffffff",
    dark: "#1E1E1E",
    hcDark: (0, _colorJs.Color).black,
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("editorBackground", "Editor background color."));
const editorForeground = (0, _colorUtilsJs.registerColor)("editor.foreground", {
    light: "#333333",
    dark: "#BBBBBB",
    hcDark: (0, _colorJs.Color).white,
    hcLight: (0, _baseColorsJs.foreground)
}, _nlsJs.localize("editorForeground", "Editor default foreground color."));
const editorStickyScrollBackground = (0, _colorUtilsJs.registerColor)("editorStickyScroll.background", editorBackground, _nlsJs.localize("editorStickyScrollBackground", "Background color of sticky scroll in the editor"));
const editorStickyScrollHoverBackground = (0, _colorUtilsJs.registerColor)("editorStickyScrollHover.background", {
    dark: "#2A2D2E",
    light: "#F0F0F0",
    hcDark: null,
    hcLight: (0, _colorJs.Color).fromHex("#0F4A85").transparent(0.1)
}, _nlsJs.localize("editorStickyScrollHoverBackground", "Background color of sticky scroll on hover in the editor"));
const editorStickyScrollBorder = (0, _colorUtilsJs.registerColor)("editorStickyScroll.border", {
    dark: null,
    light: null,
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("editorStickyScrollBorder", "Border color of sticky scroll in the editor"));
const editorStickyScrollShadow = (0, _colorUtilsJs.registerColor)("editorStickyScroll.shadow", (0, _miscColorsJs.scrollbarShadow), _nlsJs.localize("editorStickyScrollShadow", " Shadow color of sticky scroll in the editor"));
const editorWidgetBackground = (0, _colorUtilsJs.registerColor)("editorWidget.background", {
    dark: "#252526",
    light: "#F3F3F3",
    hcDark: "#0C141F",
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("editorWidgetBackground", "Background color of editor widgets, such as find/replace."));
const editorWidgetForeground = (0, _colorUtilsJs.registerColor)("editorWidget.foreground", (0, _baseColorsJs.foreground), _nlsJs.localize("editorWidgetForeground", "Foreground color of editor widgets, such as find/replace."));
const editorWidgetBorder = (0, _colorUtilsJs.registerColor)("editorWidget.border", {
    dark: "#454545",
    light: "#C8C8C8",
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("editorWidgetBorder", "Border color of editor widgets. The color is only used if the widget chooses to have a border and if the color is not overridden by a widget."));
const editorWidgetResizeBorder = (0, _colorUtilsJs.registerColor)("editorWidget.resizeBorder", null, _nlsJs.localize("editorWidgetResizeBorder", "Border color of the resize bar of editor widgets. The color is only used if the widget chooses to have a resize border and if the color is not overridden by a widget."));
const editorErrorBackground = (0, _colorUtilsJs.registerColor)("editorError.background", null, _nlsJs.localize("editorError.background", "Background color of error text in the editor. The color must not be opaque so as not to hide underlying decorations."), true);
const editorErrorForeground = (0, _colorUtilsJs.registerColor)("editorError.foreground", {
    dark: "#F14C4C",
    light: "#E51400",
    hcDark: "#F48771",
    hcLight: "#B5200D"
}, _nlsJs.localize("editorError.foreground", "Foreground color of error squigglies in the editor."));
const editorErrorBorder = (0, _colorUtilsJs.registerColor)("editorError.border", {
    dark: null,
    light: null,
    hcDark: (0, _colorJs.Color).fromHex("#E47777").transparent(0.8),
    hcLight: "#B5200D"
}, _nlsJs.localize("errorBorder", "If set, color of double underlines for errors in the editor."));
const editorWarningBackground = (0, _colorUtilsJs.registerColor)("editorWarning.background", null, _nlsJs.localize("editorWarning.background", "Background color of warning text in the editor. The color must not be opaque so as not to hide underlying decorations."), true);
const editorWarningForeground = (0, _colorUtilsJs.registerColor)("editorWarning.foreground", {
    dark: "#CCA700",
    light: "#BF8803",
    hcDark: "#FFD370",
    hcLight: "#895503"
}, _nlsJs.localize("editorWarning.foreground", "Foreground color of warning squigglies in the editor."));
const editorWarningBorder = (0, _colorUtilsJs.registerColor)("editorWarning.border", {
    dark: null,
    light: null,
    hcDark: (0, _colorJs.Color).fromHex("#FFCC00").transparent(0.8),
    hcLight: (0, _colorJs.Color).fromHex("#FFCC00").transparent(0.8)
}, _nlsJs.localize("warningBorder", "If set, color of double underlines for warnings in the editor."));
const editorInfoBackground = (0, _colorUtilsJs.registerColor)("editorInfo.background", null, _nlsJs.localize("editorInfo.background", "Background color of info text in the editor. The color must not be opaque so as not to hide underlying decorations."), true);
const editorInfoForeground = (0, _colorUtilsJs.registerColor)("editorInfo.foreground", {
    dark: "#3794FF",
    light: "#1a85ff",
    hcDark: "#3794FF",
    hcLight: "#1a85ff"
}, _nlsJs.localize("editorInfo.foreground", "Foreground color of info squigglies in the editor."));
const editorInfoBorder = (0, _colorUtilsJs.registerColor)("editorInfo.border", {
    dark: null,
    light: null,
    hcDark: (0, _colorJs.Color).fromHex("#3794FF").transparent(0.8),
    hcLight: "#292929"
}, _nlsJs.localize("infoBorder", "If set, color of double underlines for infos in the editor."));
const editorHintForeground = (0, _colorUtilsJs.registerColor)("editorHint.foreground", {
    dark: (0, _colorJs.Color).fromHex("#eeeeee").transparent(0.7),
    light: "#6c6c6c",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("editorHint.foreground", "Foreground color of hint squigglies in the editor."));
const editorHintBorder = (0, _colorUtilsJs.registerColor)("editorHint.border", {
    dark: null,
    light: null,
    hcDark: (0, _colorJs.Color).fromHex("#eeeeee").transparent(0.8),
    hcLight: "#292929"
}, _nlsJs.localize("hintBorder", "If set, color of double underlines for hints in the editor."));
const editorActiveLinkForeground = (0, _colorUtilsJs.registerColor)("editorLink.activeForeground", {
    dark: "#4E94CE",
    light: (0, _colorJs.Color).blue,
    hcDark: (0, _colorJs.Color).cyan,
    hcLight: "#292929"
}, _nlsJs.localize("activeLinkForeground", "Color of active links."));
const editorSelectionBackground = (0, _colorUtilsJs.registerColor)("editor.selectionBackground", {
    light: "#ADD6FF",
    dark: "#264F78",
    hcDark: "#f3f518",
    hcLight: "#0F4A85"
}, _nlsJs.localize("editorSelectionBackground", "Color of the editor selection."));
const editorSelectionForeground = (0, _colorUtilsJs.registerColor)("editor.selectionForeground", {
    light: null,
    dark: null,
    hcDark: "#000000",
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("editorSelectionForeground", "Color of the selected text for high contrast."));
const editorInactiveSelection = (0, _colorUtilsJs.registerColor)("editor.inactiveSelectionBackground", {
    light: (0, _colorUtilsJs.transparent)(editorSelectionBackground, 0.5),
    dark: (0, _colorUtilsJs.transparent)(editorSelectionBackground, 0.5),
    hcDark: (0, _colorUtilsJs.transparent)(editorSelectionBackground, 0.7),
    hcLight: (0, _colorUtilsJs.transparent)(editorSelectionBackground, 0.5)
}, _nlsJs.localize("editorInactiveSelection", "Color of the selection in an inactive editor. The color must not be opaque so as not to hide underlying decorations."), true);
const editorSelectionHighlight = (0, _colorUtilsJs.registerColor)("editor.selectionHighlightBackground", {
    light: (0, _colorUtilsJs.lessProminent)(editorSelectionBackground, editorBackground, 0.3, 0.6),
    dark: (0, _colorUtilsJs.lessProminent)(editorSelectionBackground, editorBackground, 0.3, 0.6),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("editorSelectionHighlight", "Color for regions with the same content as the selection. The color must not be opaque so as not to hide underlying decorations."), true);
const editorSelectionHighlightBorder = (0, _colorUtilsJs.registerColor)("editor.selectionHighlightBorder", {
    light: null,
    dark: null,
    hcDark: (0, _baseColorsJs.activeContrastBorder),
    hcLight: (0, _baseColorsJs.activeContrastBorder)
}, _nlsJs.localize("editorSelectionHighlightBorder", "Border color for regions with the same content as the selection."));
const editorFindMatch = (0, _colorUtilsJs.registerColor)("editor.findMatchBackground", {
    light: "#A8AC94",
    dark: "#515C6A",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("editorFindMatch", "Color of the current search match."));
const editorFindMatchForeground = (0, _colorUtilsJs.registerColor)("editor.findMatchForeground", null, _nlsJs.localize("editorFindMatchForeground", "Text color of the current search match."));
const editorFindMatchHighlight = (0, _colorUtilsJs.registerColor)("editor.findMatchHighlightBackground", {
    light: "#EA5C0055",
    dark: "#EA5C0055",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("findMatchHighlight", "Color of the other search matches. The color must not be opaque so as not to hide underlying decorations."), true);
const editorFindMatchHighlightForeground = (0, _colorUtilsJs.registerColor)("editor.findMatchHighlightForeground", null, _nlsJs.localize("findMatchHighlightForeground", "Foreground color of the other search matches."), true);
const editorFindRangeHighlight = (0, _colorUtilsJs.registerColor)("editor.findRangeHighlightBackground", {
    dark: "#3a3d4166",
    light: "#b4b4b44d",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("findRangeHighlight", "Color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations."), true);
const editorFindMatchBorder = (0, _colorUtilsJs.registerColor)("editor.findMatchBorder", {
    light: null,
    dark: null,
    hcDark: (0, _baseColorsJs.activeContrastBorder),
    hcLight: (0, _baseColorsJs.activeContrastBorder)
}, _nlsJs.localize("editorFindMatchBorder", "Border color of the current search match."));
const editorFindMatchHighlightBorder = (0, _colorUtilsJs.registerColor)("editor.findMatchHighlightBorder", {
    light: null,
    dark: null,
    hcDark: (0, _baseColorsJs.activeContrastBorder),
    hcLight: (0, _baseColorsJs.activeContrastBorder)
}, _nlsJs.localize("findMatchHighlightBorder", "Border color of the other search matches."));
const editorFindRangeHighlightBorder = (0, _colorUtilsJs.registerColor)("editor.findRangeHighlightBorder", {
    dark: null,
    light: null,
    hcDark: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.activeContrastBorder), 0.4),
    hcLight: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.activeContrastBorder), 0.4)
}, _nlsJs.localize("findRangeHighlightBorder", "Border color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations."), true);
const editorHoverHighlight = (0, _colorUtilsJs.registerColor)("editor.hoverHighlightBackground", {
    light: "#ADD6FF26",
    dark: "#264f7840",
    hcDark: "#ADD6FF26",
    hcLight: null
}, _nlsJs.localize("hoverHighlight", "Highlight below the word for which a hover is shown. The color must not be opaque so as not to hide underlying decorations."), true);
const editorHoverBackground = (0, _colorUtilsJs.registerColor)("editorHoverWidget.background", editorWidgetBackground, _nlsJs.localize("hoverBackground", "Background color of the editor hover."));
const editorHoverForeground = (0, _colorUtilsJs.registerColor)("editorHoverWidget.foreground", editorWidgetForeground, _nlsJs.localize("hoverForeground", "Foreground color of the editor hover."));
const editorHoverBorder = (0, _colorUtilsJs.registerColor)("editorHoverWidget.border", editorWidgetBorder, _nlsJs.localize("hoverBorder", "Border color of the editor hover."));
const editorHoverStatusBarBackground = (0, _colorUtilsJs.registerColor)("editorHoverWidget.statusBarBackground", {
    dark: (0, _colorUtilsJs.lighten)(editorHoverBackground, 0.2),
    light: (0, _colorUtilsJs.darken)(editorHoverBackground, 0.05),
    hcDark: editorWidgetBackground,
    hcLight: editorWidgetBackground
}, _nlsJs.localize("statusBarBackground", "Background color of the editor hover status bar."));
const editorInlayHintForeground = (0, _colorUtilsJs.registerColor)("editorInlayHint.foreground", {
    dark: "#969696",
    light: "#969696",
    hcDark: (0, _colorJs.Color).white,
    hcLight: (0, _colorJs.Color).black
}, _nlsJs.localize("editorInlayHintForeground", "Foreground color of inline hints"));
const editorInlayHintBackground = (0, _colorUtilsJs.registerColor)("editorInlayHint.background", {
    dark: (0, _colorUtilsJs.transparent)((0, _miscColorsJs.badgeBackground), .10),
    light: (0, _colorUtilsJs.transparent)((0, _miscColorsJs.badgeBackground), .10),
    hcDark: (0, _colorUtilsJs.transparent)((0, _colorJs.Color).white, .10),
    hcLight: (0, _colorUtilsJs.transparent)((0, _miscColorsJs.badgeBackground), .10)
}, _nlsJs.localize("editorInlayHintBackground", "Background color of inline hints"));
const editorInlayHintTypeForeground = (0, _colorUtilsJs.registerColor)("editorInlayHint.typeForeground", editorInlayHintForeground, _nlsJs.localize("editorInlayHintForegroundTypes", "Foreground color of inline hints for types"));
const editorInlayHintTypeBackground = (0, _colorUtilsJs.registerColor)("editorInlayHint.typeBackground", editorInlayHintBackground, _nlsJs.localize("editorInlayHintBackgroundTypes", "Background color of inline hints for types"));
const editorInlayHintParameterForeground = (0, _colorUtilsJs.registerColor)("editorInlayHint.parameterForeground", editorInlayHintForeground, _nlsJs.localize("editorInlayHintForegroundParameter", "Foreground color of inline hints for parameters"));
const editorInlayHintParameterBackground = (0, _colorUtilsJs.registerColor)("editorInlayHint.parameterBackground", editorInlayHintBackground, _nlsJs.localize("editorInlayHintBackgroundParameter", "Background color of inline hints for parameters"));
const editorLightBulbForeground = (0, _colorUtilsJs.registerColor)("editorLightBulb.foreground", {
    dark: "#FFCC00",
    light: "#DDB100",
    hcDark: "#FFCC00",
    hcLight: "#007ACC"
}, _nlsJs.localize("editorLightBulbForeground", "The color used for the lightbulb actions icon."));
const editorLightBulbAutoFixForeground = (0, _colorUtilsJs.registerColor)("editorLightBulbAutoFix.foreground", {
    dark: "#75BEFF",
    light: "#007ACC",
    hcDark: "#75BEFF",
    hcLight: "#007ACC"
}, _nlsJs.localize("editorLightBulbAutoFixForeground", "The color used for the lightbulb auto fix actions icon."));
const editorLightBulbAiForeground = (0, _colorUtilsJs.registerColor)("editorLightBulbAi.foreground", editorLightBulbForeground, _nlsJs.localize("editorLightBulbAiForeground", "The color used for the lightbulb AI icon."));
const snippetTabstopHighlightBackground = (0, _colorUtilsJs.registerColor)("editor.snippetTabstopHighlightBackground", {
    dark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(124, 124, 124, 0.3)),
    light: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(10, 50, 100, 0.2)),
    hcDark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(124, 124, 124, 0.3)),
    hcLight: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(10, 50, 100, 0.2))
}, _nlsJs.localize("snippetTabstopHighlightBackground", "Highlight background color of a snippet tabstop."));
const snippetTabstopHighlightBorder = (0, _colorUtilsJs.registerColor)("editor.snippetTabstopHighlightBorder", null, _nlsJs.localize("snippetTabstopHighlightBorder", "Highlight border color of a snippet tabstop."));
const snippetFinalTabstopHighlightBackground = (0, _colorUtilsJs.registerColor)("editor.snippetFinalTabstopHighlightBackground", null, _nlsJs.localize("snippetFinalTabstopHighlightBackground", "Highlight background color of the final tabstop of a snippet."));
const snippetFinalTabstopHighlightBorder = (0, _colorUtilsJs.registerColor)("editor.snippetFinalTabstopHighlightBorder", {
    dark: "#525252",
    light: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(10, 50, 100, 0.5)),
    hcDark: "#525252",
    hcLight: "#292929"
}, _nlsJs.localize("snippetFinalTabstopHighlightBorder", "Highlight border color of the final tabstop of a snippet."));
const defaultInsertColor = new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(155, 185, 85, .2));
const defaultRemoveColor = new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(255, 0, 0, .2));
const diffInserted = (0, _colorUtilsJs.registerColor)("diffEditor.insertedTextBackground", {
    dark: "#9ccc2c33",
    light: "#9ccc2c40",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("diffEditorInserted", "Background color for text that got inserted. The color must not be opaque so as not to hide underlying decorations."), true);
const diffRemoved = (0, _colorUtilsJs.registerColor)("diffEditor.removedTextBackground", {
    dark: "#ff000033",
    light: "#ff000033",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("diffEditorRemoved", "Background color for text that got removed. The color must not be opaque so as not to hide underlying decorations."), true);
const diffInsertedLine = (0, _colorUtilsJs.registerColor)("diffEditor.insertedLineBackground", {
    dark: defaultInsertColor,
    light: defaultInsertColor,
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("diffEditorInsertedLines", "Background color for lines that got inserted. The color must not be opaque so as not to hide underlying decorations."), true);
const diffRemovedLine = (0, _colorUtilsJs.registerColor)("diffEditor.removedLineBackground", {
    dark: defaultRemoveColor,
    light: defaultRemoveColor,
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("diffEditorRemovedLines", "Background color for lines that got removed. The color must not be opaque so as not to hide underlying decorations."), true);
const diffInsertedLineGutter = (0, _colorUtilsJs.registerColor)("diffEditorGutter.insertedLineBackground", null, _nlsJs.localize("diffEditorInsertedLineGutter", "Background color for the margin where lines got inserted."));
const diffRemovedLineGutter = (0, _colorUtilsJs.registerColor)("diffEditorGutter.removedLineBackground", null, _nlsJs.localize("diffEditorRemovedLineGutter", "Background color for the margin where lines got removed."));
const diffOverviewRulerInserted = (0, _colorUtilsJs.registerColor)("diffEditorOverview.insertedForeground", null, _nlsJs.localize("diffEditorOverviewInserted", "Diff overview ruler foreground for inserted content."));
const diffOverviewRulerRemoved = (0, _colorUtilsJs.registerColor)("diffEditorOverview.removedForeground", null, _nlsJs.localize("diffEditorOverviewRemoved", "Diff overview ruler foreground for removed content."));
const diffInsertedOutline = (0, _colorUtilsJs.registerColor)("diffEditor.insertedTextBorder", {
    dark: null,
    light: null,
    hcDark: "#33ff2eff",
    hcLight: "#374E06"
}, _nlsJs.localize("diffEditorInsertedOutline", "Outline color for the text that got inserted."));
const diffRemovedOutline = (0, _colorUtilsJs.registerColor)("diffEditor.removedTextBorder", {
    dark: null,
    light: null,
    hcDark: "#FF008F",
    hcLight: "#AD0707"
}, _nlsJs.localize("diffEditorRemovedOutline", "Outline color for text that got removed."));
const diffBorder = (0, _colorUtilsJs.registerColor)("diffEditor.border", {
    dark: null,
    light: null,
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("diffEditorBorder", "Border color between the two text editors."));
const diffDiagonalFill = (0, _colorUtilsJs.registerColor)("diffEditor.diagonalFill", {
    dark: "#cccccc33",
    light: "#22222233",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("diffDiagonalFill", "Color of the diff editor's diagonal fill. The diagonal fill is used in side-by-side diff views."));
const diffUnchangedRegionBackground = (0, _colorUtilsJs.registerColor)("diffEditor.unchangedRegionBackground", "sideBar.background", _nlsJs.localize("diffEditor.unchangedRegionBackground", "The background color of unchanged blocks in the diff editor."));
const diffUnchangedRegionForeground = (0, _colorUtilsJs.registerColor)("diffEditor.unchangedRegionForeground", "foreground", _nlsJs.localize("diffEditor.unchangedRegionForeground", "The foreground color of unchanged blocks in the diff editor."));
const diffUnchangedTextBackground = (0, _colorUtilsJs.registerColor)("diffEditor.unchangedCodeBackground", {
    dark: "#74747429",
    light: "#b8b8b829",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("diffEditor.unchangedCodeBackground", "The background color of unchanged code in the diff editor."));
const widgetShadow = (0, _colorUtilsJs.registerColor)("widget.shadow", {
    dark: (0, _colorUtilsJs.transparent)((0, _colorJs.Color).black, .36),
    light: (0, _colorUtilsJs.transparent)((0, _colorJs.Color).black, .16),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("widgetShadow", "Shadow color of widgets such as find/replace inside the editor."));
const widgetBorder = (0, _colorUtilsJs.registerColor)("widget.border", {
    dark: null,
    light: null,
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("widgetBorder", "Border color of widgets such as find/replace inside the editor."));
const toolbarHoverBackground = (0, _colorUtilsJs.registerColor)("toolbar.hoverBackground", {
    dark: "#5a5d5e50",
    light: "#b8b8b850",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("toolbarHoverBackground", "Toolbar background when hovering over actions using the mouse"));
const toolbarHoverOutline = (0, _colorUtilsJs.registerColor)("toolbar.hoverOutline", {
    dark: null,
    light: null,
    hcDark: (0, _baseColorsJs.activeContrastBorder),
    hcLight: (0, _baseColorsJs.activeContrastBorder)
}, _nlsJs.localize("toolbarHoverOutline", "Toolbar outline when hovering over actions using the mouse"));
const toolbarActiveBackground = (0, _colorUtilsJs.registerColor)("toolbar.activeBackground", {
    dark: (0, _colorUtilsJs.lighten)(toolbarHoverBackground, 0.1),
    light: (0, _colorUtilsJs.darken)(toolbarHoverBackground, 0.1),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("toolbarActiveBackground", "Toolbar background when holding the mouse over actions"));
const breadcrumbsForeground = (0, _colorUtilsJs.registerColor)("breadcrumb.foreground", (0, _colorUtilsJs.transparent)((0, _baseColorsJs.foreground), 0.8), _nlsJs.localize("breadcrumbsFocusForeground", "Color of focused breadcrumb items."));
const breadcrumbsBackground = (0, _colorUtilsJs.registerColor)("breadcrumb.background", editorBackground, _nlsJs.localize("breadcrumbsBackground", "Background color of breadcrumb items."));
const breadcrumbsFocusForeground = (0, _colorUtilsJs.registerColor)("breadcrumb.focusForeground", {
    light: (0, _colorUtilsJs.darken)((0, _baseColorsJs.foreground), 0.2),
    dark: (0, _colorUtilsJs.lighten)((0, _baseColorsJs.foreground), 0.1),
    hcDark: (0, _colorUtilsJs.lighten)((0, _baseColorsJs.foreground), 0.1),
    hcLight: (0, _colorUtilsJs.lighten)((0, _baseColorsJs.foreground), 0.1)
}, _nlsJs.localize("breadcrumbsFocusForeground", "Color of focused breadcrumb items."));
const breadcrumbsActiveSelectionForeground = (0, _colorUtilsJs.registerColor)("breadcrumb.activeSelectionForeground", {
    light: (0, _colorUtilsJs.darken)((0, _baseColorsJs.foreground), 0.2),
    dark: (0, _colorUtilsJs.lighten)((0, _baseColorsJs.foreground), 0.1),
    hcDark: (0, _colorUtilsJs.lighten)((0, _baseColorsJs.foreground), 0.1),
    hcLight: (0, _colorUtilsJs.lighten)((0, _baseColorsJs.foreground), 0.1)
}, _nlsJs.localize("breadcrumbsSelectedForeground", "Color of selected breadcrumb items."));
const breadcrumbsPickerBackground = (0, _colorUtilsJs.registerColor)("breadcrumbPicker.background", editorWidgetBackground, _nlsJs.localize("breadcrumbsSelectedBackground", "Background color of breadcrumb item picker."));
// ----- merge
const headerTransparency = 0.5;
const currentBaseColor = (0, _colorJs.Color).fromHex("#40C8AE").transparent(headerTransparency);
const incomingBaseColor = (0, _colorJs.Color).fromHex("#40A6FF").transparent(headerTransparency);
const commonBaseColor = (0, _colorJs.Color).fromHex("#606060").transparent(0.4);
const contentTransparency = 0.4;
const rulerTransparency = 1;
const mergeCurrentHeaderBackground = (0, _colorUtilsJs.registerColor)("merge.currentHeaderBackground", {
    dark: currentBaseColor,
    light: currentBaseColor,
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("mergeCurrentHeaderBackground", "Current header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), true);
const mergeCurrentContentBackground = (0, _colorUtilsJs.registerColor)("merge.currentContentBackground", (0, _colorUtilsJs.transparent)(mergeCurrentHeaderBackground, contentTransparency), _nlsJs.localize("mergeCurrentContentBackground", "Current content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), true);
const mergeIncomingHeaderBackground = (0, _colorUtilsJs.registerColor)("merge.incomingHeaderBackground", {
    dark: incomingBaseColor,
    light: incomingBaseColor,
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("mergeIncomingHeaderBackground", "Incoming header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), true);
const mergeIncomingContentBackground = (0, _colorUtilsJs.registerColor)("merge.incomingContentBackground", (0, _colorUtilsJs.transparent)(mergeIncomingHeaderBackground, contentTransparency), _nlsJs.localize("mergeIncomingContentBackground", "Incoming content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), true);
const mergeCommonHeaderBackground = (0, _colorUtilsJs.registerColor)("merge.commonHeaderBackground", {
    dark: commonBaseColor,
    light: commonBaseColor,
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("mergeCommonHeaderBackground", "Common ancestor header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), true);
const mergeCommonContentBackground = (0, _colorUtilsJs.registerColor)("merge.commonContentBackground", (0, _colorUtilsJs.transparent)(mergeCommonHeaderBackground, contentTransparency), _nlsJs.localize("mergeCommonContentBackground", "Common ancestor content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), true);
const mergeBorder = (0, _colorUtilsJs.registerColor)("merge.border", {
    dark: null,
    light: null,
    hcDark: "#C3DF6F",
    hcLight: "#007ACC"
}, _nlsJs.localize("mergeBorder", "Border color on headers and the splitter in inline merge-conflicts."));
const overviewRulerCurrentContentForeground = (0, _colorUtilsJs.registerColor)("editorOverviewRuler.currentContentForeground", {
    dark: (0, _colorUtilsJs.transparent)(mergeCurrentHeaderBackground, rulerTransparency),
    light: (0, _colorUtilsJs.transparent)(mergeCurrentHeaderBackground, rulerTransparency),
    hcDark: mergeBorder,
    hcLight: mergeBorder
}, _nlsJs.localize("overviewRulerCurrentContentForeground", "Current overview ruler foreground for inline merge-conflicts."));
const overviewRulerIncomingContentForeground = (0, _colorUtilsJs.registerColor)("editorOverviewRuler.incomingContentForeground", {
    dark: (0, _colorUtilsJs.transparent)(mergeIncomingHeaderBackground, rulerTransparency),
    light: (0, _colorUtilsJs.transparent)(mergeIncomingHeaderBackground, rulerTransparency),
    hcDark: mergeBorder,
    hcLight: mergeBorder
}, _nlsJs.localize("overviewRulerIncomingContentForeground", "Incoming overview ruler foreground for inline merge-conflicts."));
const overviewRulerCommonContentForeground = (0, _colorUtilsJs.registerColor)("editorOverviewRuler.commonContentForeground", {
    dark: (0, _colorUtilsJs.transparent)(mergeCommonHeaderBackground, rulerTransparency),
    light: (0, _colorUtilsJs.transparent)(mergeCommonHeaderBackground, rulerTransparency),
    hcDark: mergeBorder,
    hcLight: mergeBorder
}, _nlsJs.localize("overviewRulerCommonContentForeground", "Common ancestor overview ruler foreground for inline merge-conflicts."));
const overviewRulerFindMatchForeground = (0, _colorUtilsJs.registerColor)("editorOverviewRuler.findMatchForeground", {
    dark: "#d186167e",
    light: "#d186167e",
    hcDark: "#AB5A00",
    hcLight: "#AB5A00"
}, _nlsJs.localize("overviewRulerFindMatchForeground", "Overview ruler marker color for find matches. The color must not be opaque so as not to hide underlying decorations."), true);
const overviewRulerSelectionHighlightForeground = (0, _colorUtilsJs.registerColor)("editorOverviewRuler.selectionHighlightForeground", "#A0A0A0CC", _nlsJs.localize("overviewRulerSelectionHighlightForeground", "Overview ruler marker color for selection highlights. The color must not be opaque so as not to hide underlying decorations."), true);
const problemsErrorIconForeground = (0, _colorUtilsJs.registerColor)("problemsErrorIcon.foreground", editorErrorForeground, _nlsJs.localize("problemsErrorIconForeground", "The color used for the problems error icon."));
const problemsWarningIconForeground = (0, _colorUtilsJs.registerColor)("problemsWarningIcon.foreground", editorWarningForeground, _nlsJs.localize("problemsWarningIconForeground", "The color used for the problems warning icon."));
const problemsInfoIconForeground = (0, _colorUtilsJs.registerColor)("problemsInfoIcon.foreground", editorInfoForeground, _nlsJs.localize("problemsInfoIconForeground", "The color used for the problems info icon."));

},{"../../../../nls.js":"l617d","../../../../base/common/color.js":"at4gb","../colorUtils.js":"7VkBg","./baseColors.js":"8iG5A","./miscColors.js":"9tRkH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9tRkH":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sashHoverBorder", ()=>sashHoverBorder);
parcelHelpers.export(exports, "badgeBackground", ()=>badgeBackground);
parcelHelpers.export(exports, "badgeForeground", ()=>badgeForeground);
parcelHelpers.export(exports, "scrollbarShadow", ()=>scrollbarShadow);
parcelHelpers.export(exports, "scrollbarSliderBackground", ()=>scrollbarSliderBackground);
parcelHelpers.export(exports, "scrollbarSliderHoverBackground", ()=>scrollbarSliderHoverBackground);
parcelHelpers.export(exports, "scrollbarSliderActiveBackground", ()=>scrollbarSliderActiveBackground);
parcelHelpers.export(exports, "progressBarBackground", ()=>progressBarBackground);
var _nlsJs = require("../../../../nls.js");
// Import the effects we need
var _colorJs = require("../../../../base/common/color.js");
var _colorUtilsJs = require("../colorUtils.js");
// Import the colors we need
var _baseColorsJs = require("./baseColors.js");
const sashHoverBorder = (0, _colorUtilsJs.registerColor)("sash.hoverBorder", (0, _baseColorsJs.focusBorder), _nlsJs.localize("sashActiveBorder", "Border color of active sashes."));
const badgeBackground = (0, _colorUtilsJs.registerColor)("badge.background", {
    dark: "#4D4D4D",
    light: "#C4C4C4",
    hcDark: (0, _colorJs.Color).black,
    hcLight: "#0F4A85"
}, _nlsJs.localize("badgeBackground", "Badge background color. Badges are small information labels, e.g. for search results count."));
const badgeForeground = (0, _colorUtilsJs.registerColor)("badge.foreground", {
    dark: (0, _colorJs.Color).white,
    light: "#333",
    hcDark: (0, _colorJs.Color).white,
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("badgeForeground", "Badge foreground color. Badges are small information labels, e.g. for search results count."));
const scrollbarShadow = (0, _colorUtilsJs.registerColor)("scrollbar.shadow", {
    dark: "#000000",
    light: "#DDDDDD",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("scrollbarShadow", "Scrollbar shadow to indicate that the view is scrolled."));
const scrollbarSliderBackground = (0, _colorUtilsJs.registerColor)("scrollbarSlider.background", {
    dark: (0, _colorJs.Color).fromHex("#797979").transparent(0.4),
    light: (0, _colorJs.Color).fromHex("#646464").transparent(0.4),
    hcDark: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.contrastBorder), 0.6),
    hcLight: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.contrastBorder), 0.4)
}, _nlsJs.localize("scrollbarSliderBackground", "Scrollbar slider background color."));
const scrollbarSliderHoverBackground = (0, _colorUtilsJs.registerColor)("scrollbarSlider.hoverBackground", {
    dark: (0, _colorJs.Color).fromHex("#646464").transparent(0.7),
    light: (0, _colorJs.Color).fromHex("#646464").transparent(0.7),
    hcDark: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.contrastBorder), 0.8),
    hcLight: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.contrastBorder), 0.8)
}, _nlsJs.localize("scrollbarSliderHoverBackground", "Scrollbar slider background color when hovering."));
const scrollbarSliderActiveBackground = (0, _colorUtilsJs.registerColor)("scrollbarSlider.activeBackground", {
    dark: (0, _colorJs.Color).fromHex("#BFBFBF").transparent(0.4),
    light: (0, _colorJs.Color).fromHex("#000000").transparent(0.6),
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("scrollbarSliderActiveBackground", "Scrollbar slider background color when clicked on."));
const progressBarBackground = (0, _colorUtilsJs.registerColor)("progressBar.background", {
    dark: (0, _colorJs.Color).fromHex("#0E70C0"),
    light: (0, _colorJs.Color).fromHex("#0E70C0"),
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("progressBarBackground", "Background color of the progress bar that can show for long running operations."));

},{"../../../../nls.js":"l617d","../../../../base/common/color.js":"at4gb","../colorUtils.js":"7VkBg","./baseColors.js":"8iG5A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kCB7P":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "minimapFindMatch", ()=>minimapFindMatch);
parcelHelpers.export(exports, "minimapSelectionOccurrenceHighlight", ()=>minimapSelectionOccurrenceHighlight);
parcelHelpers.export(exports, "minimapSelection", ()=>minimapSelection);
parcelHelpers.export(exports, "minimapInfo", ()=>minimapInfo);
parcelHelpers.export(exports, "minimapWarning", ()=>minimapWarning);
parcelHelpers.export(exports, "minimapError", ()=>minimapError);
parcelHelpers.export(exports, "minimapBackground", ()=>minimapBackground);
parcelHelpers.export(exports, "minimapForegroundOpacity", ()=>minimapForegroundOpacity);
parcelHelpers.export(exports, "minimapSliderBackground", ()=>minimapSliderBackground);
parcelHelpers.export(exports, "minimapSliderHoverBackground", ()=>minimapSliderHoverBackground);
parcelHelpers.export(exports, "minimapSliderActiveBackground", ()=>minimapSliderActiveBackground);
var _nlsJs = require("../../../../nls.js");
// Import the effects we need
var _colorJs = require("../../../../base/common/color.js");
var _colorUtilsJs = require("../colorUtils.js");
// Import the colors we need
var _editorColorsJs = require("./editorColors.js");
var _miscColorsJs = require("./miscColors.js");
const minimapFindMatch = (0, _colorUtilsJs.registerColor)("minimap.findMatchHighlight", {
    light: "#d18616",
    dark: "#d18616",
    hcDark: "#AB5A00",
    hcLight: "#0F4A85"
}, _nlsJs.localize("minimapFindMatchHighlight", "Minimap marker color for find matches."), true);
const minimapSelectionOccurrenceHighlight = (0, _colorUtilsJs.registerColor)("minimap.selectionOccurrenceHighlight", {
    light: "#c9c9c9",
    dark: "#676767",
    hcDark: "#ffffff",
    hcLight: "#0F4A85"
}, _nlsJs.localize("minimapSelectionOccurrenceHighlight", "Minimap marker color for repeating editor selections."), true);
const minimapSelection = (0, _colorUtilsJs.registerColor)("minimap.selectionHighlight", {
    light: "#ADD6FF",
    dark: "#264F78",
    hcDark: "#ffffff",
    hcLight: "#0F4A85"
}, _nlsJs.localize("minimapSelectionHighlight", "Minimap marker color for the editor selection."), true);
const minimapInfo = (0, _colorUtilsJs.registerColor)("minimap.infoHighlight", {
    dark: (0, _editorColorsJs.editorInfoForeground),
    light: (0, _editorColorsJs.editorInfoForeground),
    hcDark: (0, _editorColorsJs.editorInfoBorder),
    hcLight: (0, _editorColorsJs.editorInfoBorder)
}, _nlsJs.localize("minimapInfo", "Minimap marker color for infos."));
const minimapWarning = (0, _colorUtilsJs.registerColor)("minimap.warningHighlight", {
    dark: (0, _editorColorsJs.editorWarningForeground),
    light: (0, _editorColorsJs.editorWarningForeground),
    hcDark: (0, _editorColorsJs.editorWarningBorder),
    hcLight: (0, _editorColorsJs.editorWarningBorder)
}, _nlsJs.localize("overviewRuleWarning", "Minimap marker color for warnings."));
const minimapError = (0, _colorUtilsJs.registerColor)("minimap.errorHighlight", {
    dark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(255, 18, 18, 0.7)),
    light: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(255, 18, 18, 0.7)),
    hcDark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(255, 50, 50, 1)),
    hcLight: "#B5200D"
}, _nlsJs.localize("minimapError", "Minimap marker color for errors."));
const minimapBackground = (0, _colorUtilsJs.registerColor)("minimap.background", null, _nlsJs.localize("minimapBackground", "Minimap background color."));
const minimapForegroundOpacity = (0, _colorUtilsJs.registerColor)("minimap.foregroundOpacity", (0, _colorJs.Color).fromHex("#000f"), _nlsJs.localize("minimapForegroundOpacity", 'Opacity of foreground elements rendered in the minimap. For example, "#000000c0" will render the elements with 75% opacity.'));
const minimapSliderBackground = (0, _colorUtilsJs.registerColor)("minimapSlider.background", (0, _colorUtilsJs.transparent)((0, _miscColorsJs.scrollbarSliderBackground), 0.5), _nlsJs.localize("minimapSliderBackground", "Minimap slider background color."));
const minimapSliderHoverBackground = (0, _colorUtilsJs.registerColor)("minimapSlider.hoverBackground", (0, _colorUtilsJs.transparent)((0, _miscColorsJs.scrollbarSliderHoverBackground), 0.5), _nlsJs.localize("minimapSliderHoverBackground", "Minimap slider background color when hovering."));
const minimapSliderActiveBackground = (0, _colorUtilsJs.registerColor)("minimapSlider.activeBackground", (0, _colorUtilsJs.transparent)((0, _miscColorsJs.scrollbarSliderActiveBackground), 0.5), _nlsJs.localize("minimapSliderActiveBackground", "Minimap slider background color when clicked on."));

},{"../../../../nls.js":"l617d","../../../../base/common/color.js":"at4gb","../colorUtils.js":"7VkBg","./editorColors.js":"c46FO","./miscColors.js":"9tRkH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9pTqI":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inputBackground", ()=>inputBackground);
parcelHelpers.export(exports, "inputForeground", ()=>inputForeground);
parcelHelpers.export(exports, "inputBorder", ()=>inputBorder);
parcelHelpers.export(exports, "inputActiveOptionBorder", ()=>inputActiveOptionBorder);
parcelHelpers.export(exports, "inputActiveOptionHoverBackground", ()=>inputActiveOptionHoverBackground);
parcelHelpers.export(exports, "inputActiveOptionBackground", ()=>inputActiveOptionBackground);
parcelHelpers.export(exports, "inputActiveOptionForeground", ()=>inputActiveOptionForeground);
parcelHelpers.export(exports, "inputPlaceholderForeground", ()=>inputPlaceholderForeground);
parcelHelpers.export(exports, "inputValidationInfoBackground", ()=>inputValidationInfoBackground);
parcelHelpers.export(exports, "inputValidationInfoForeground", ()=>inputValidationInfoForeground);
parcelHelpers.export(exports, "inputValidationInfoBorder", ()=>inputValidationInfoBorder);
parcelHelpers.export(exports, "inputValidationWarningBackground", ()=>inputValidationWarningBackground);
parcelHelpers.export(exports, "inputValidationWarningForeground", ()=>inputValidationWarningForeground);
parcelHelpers.export(exports, "inputValidationWarningBorder", ()=>inputValidationWarningBorder);
parcelHelpers.export(exports, "inputValidationErrorBackground", ()=>inputValidationErrorBackground);
parcelHelpers.export(exports, "inputValidationErrorForeground", ()=>inputValidationErrorForeground);
parcelHelpers.export(exports, "inputValidationErrorBorder", ()=>inputValidationErrorBorder);
parcelHelpers.export(exports, "selectBackground", ()=>selectBackground);
parcelHelpers.export(exports, "selectListBackground", ()=>selectListBackground);
parcelHelpers.export(exports, "selectForeground", ()=>selectForeground);
parcelHelpers.export(exports, "selectBorder", ()=>selectBorder);
parcelHelpers.export(exports, "buttonForeground", ()=>buttonForeground);
parcelHelpers.export(exports, "buttonSeparator", ()=>buttonSeparator);
parcelHelpers.export(exports, "buttonBackground", ()=>buttonBackground);
parcelHelpers.export(exports, "buttonHoverBackground", ()=>buttonHoverBackground);
parcelHelpers.export(exports, "buttonBorder", ()=>buttonBorder);
parcelHelpers.export(exports, "buttonSecondaryForeground", ()=>buttonSecondaryForeground);
parcelHelpers.export(exports, "buttonSecondaryBackground", ()=>buttonSecondaryBackground);
parcelHelpers.export(exports, "buttonSecondaryHoverBackground", ()=>buttonSecondaryHoverBackground);
parcelHelpers.export(exports, "radioActiveForeground", ()=>radioActiveForeground);
parcelHelpers.export(exports, "radioActiveBackground", ()=>radioActiveBackground);
parcelHelpers.export(exports, "radioActiveBorder", ()=>radioActiveBorder);
parcelHelpers.export(exports, "radioInactiveForeground", ()=>radioInactiveForeground);
parcelHelpers.export(exports, "radioInactiveBackground", ()=>radioInactiveBackground);
parcelHelpers.export(exports, "radioInactiveBorder", ()=>radioInactiveBorder);
parcelHelpers.export(exports, "radioInactiveHoverBackground", ()=>radioInactiveHoverBackground);
parcelHelpers.export(exports, "checkboxBackground", ()=>checkboxBackground);
parcelHelpers.export(exports, "checkboxSelectBackground", ()=>checkboxSelectBackground);
parcelHelpers.export(exports, "checkboxForeground", ()=>checkboxForeground);
parcelHelpers.export(exports, "checkboxBorder", ()=>checkboxBorder);
parcelHelpers.export(exports, "checkboxSelectBorder", ()=>checkboxSelectBorder);
parcelHelpers.export(exports, "keybindingLabelBackground", ()=>keybindingLabelBackground);
parcelHelpers.export(exports, "keybindingLabelForeground", ()=>keybindingLabelForeground);
parcelHelpers.export(exports, "keybindingLabelBorder", ()=>keybindingLabelBorder);
parcelHelpers.export(exports, "keybindingLabelBottomBorder", ()=>keybindingLabelBottomBorder);
var _nlsJs = require("../../../../nls.js");
// Import the effects we need
var _colorJs = require("../../../../base/common/color.js");
var _colorUtilsJs = require("../colorUtils.js");
// Import the colors we need
var _baseColorsJs = require("./baseColors.js");
var _editorColorsJs = require("./editorColors.js");
const inputBackground = (0, _colorUtilsJs.registerColor)("input.background", {
    dark: "#3C3C3C",
    light: (0, _colorJs.Color).white,
    hcDark: (0, _colorJs.Color).black,
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("inputBoxBackground", "Input box background."));
const inputForeground = (0, _colorUtilsJs.registerColor)("input.foreground", (0, _baseColorsJs.foreground), _nlsJs.localize("inputBoxForeground", "Input box foreground."));
const inputBorder = (0, _colorUtilsJs.registerColor)("input.border", {
    dark: null,
    light: null,
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("inputBoxBorder", "Input box border."));
const inputActiveOptionBorder = (0, _colorUtilsJs.registerColor)("inputOption.activeBorder", {
    dark: "#007ACC",
    light: "#007ACC",
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("inputBoxActiveOptionBorder", "Border color of activated options in input fields."));
const inputActiveOptionHoverBackground = (0, _colorUtilsJs.registerColor)("inputOption.hoverBackground", {
    dark: "#5a5d5e80",
    light: "#b8b8b850",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("inputOption.hoverBackground", "Background color of activated options in input fields."));
const inputActiveOptionBackground = (0, _colorUtilsJs.registerColor)("inputOption.activeBackground", {
    dark: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.focusBorder), 0.4),
    light: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.focusBorder), 0.2),
    hcDark: (0, _colorJs.Color).transparent,
    hcLight: (0, _colorJs.Color).transparent
}, _nlsJs.localize("inputOption.activeBackground", "Background hover color of options in input fields."));
const inputActiveOptionForeground = (0, _colorUtilsJs.registerColor)("inputOption.activeForeground", {
    dark: (0, _colorJs.Color).white,
    light: (0, _colorJs.Color).black,
    hcDark: (0, _baseColorsJs.foreground),
    hcLight: (0, _baseColorsJs.foreground)
}, _nlsJs.localize("inputOption.activeForeground", "Foreground color of activated options in input fields."));
const inputPlaceholderForeground = (0, _colorUtilsJs.registerColor)("input.placeholderForeground", {
    light: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.foreground), 0.5),
    dark: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.foreground), 0.5),
    hcDark: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.foreground), 0.7),
    hcLight: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.foreground), 0.7)
}, _nlsJs.localize("inputPlaceholderForeground", "Input box foreground color for placeholder text."));
const inputValidationInfoBackground = (0, _colorUtilsJs.registerColor)("inputValidation.infoBackground", {
    dark: "#063B49",
    light: "#D6ECF2",
    hcDark: (0, _colorJs.Color).black,
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("inputValidationInfoBackground", "Input validation background color for information severity."));
const inputValidationInfoForeground = (0, _colorUtilsJs.registerColor)("inputValidation.infoForeground", {
    dark: null,
    light: null,
    hcDark: null,
    hcLight: (0, _baseColorsJs.foreground)
}, _nlsJs.localize("inputValidationInfoForeground", "Input validation foreground color for information severity."));
const inputValidationInfoBorder = (0, _colorUtilsJs.registerColor)("inputValidation.infoBorder", {
    dark: "#007acc",
    light: "#007acc",
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("inputValidationInfoBorder", "Input validation border color for information severity."));
const inputValidationWarningBackground = (0, _colorUtilsJs.registerColor)("inputValidation.warningBackground", {
    dark: "#352A05",
    light: "#F6F5D2",
    hcDark: (0, _colorJs.Color).black,
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("inputValidationWarningBackground", "Input validation background color for warning severity."));
const inputValidationWarningForeground = (0, _colorUtilsJs.registerColor)("inputValidation.warningForeground", {
    dark: null,
    light: null,
    hcDark: null,
    hcLight: (0, _baseColorsJs.foreground)
}, _nlsJs.localize("inputValidationWarningForeground", "Input validation foreground color for warning severity."));
const inputValidationWarningBorder = (0, _colorUtilsJs.registerColor)("inputValidation.warningBorder", {
    dark: "#B89500",
    light: "#B89500",
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("inputValidationWarningBorder", "Input validation border color for warning severity."));
const inputValidationErrorBackground = (0, _colorUtilsJs.registerColor)("inputValidation.errorBackground", {
    dark: "#5A1D1D",
    light: "#F2DEDE",
    hcDark: (0, _colorJs.Color).black,
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("inputValidationErrorBackground", "Input validation background color for error severity."));
const inputValidationErrorForeground = (0, _colorUtilsJs.registerColor)("inputValidation.errorForeground", {
    dark: null,
    light: null,
    hcDark: null,
    hcLight: (0, _baseColorsJs.foreground)
}, _nlsJs.localize("inputValidationErrorForeground", "Input validation foreground color for error severity."));
const inputValidationErrorBorder = (0, _colorUtilsJs.registerColor)("inputValidation.errorBorder", {
    dark: "#BE1100",
    light: "#BE1100",
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("inputValidationErrorBorder", "Input validation border color for error severity."));
const selectBackground = (0, _colorUtilsJs.registerColor)("dropdown.background", {
    dark: "#3C3C3C",
    light: (0, _colorJs.Color).white,
    hcDark: (0, _colorJs.Color).black,
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("dropdownBackground", "Dropdown background."));
const selectListBackground = (0, _colorUtilsJs.registerColor)("dropdown.listBackground", {
    dark: null,
    light: null,
    hcDark: (0, _colorJs.Color).black,
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("dropdownListBackground", "Dropdown list background."));
const selectForeground = (0, _colorUtilsJs.registerColor)("dropdown.foreground", {
    dark: "#F0F0F0",
    light: (0, _baseColorsJs.foreground),
    hcDark: (0, _colorJs.Color).white,
    hcLight: (0, _baseColorsJs.foreground)
}, _nlsJs.localize("dropdownForeground", "Dropdown foreground."));
const selectBorder = (0, _colorUtilsJs.registerColor)("dropdown.border", {
    dark: selectBackground,
    light: "#CECECE",
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("dropdownBorder", "Dropdown border."));
const buttonForeground = (0, _colorUtilsJs.registerColor)("button.foreground", (0, _colorJs.Color).white, _nlsJs.localize("buttonForeground", "Button foreground color."));
const buttonSeparator = (0, _colorUtilsJs.registerColor)("button.separator", (0, _colorUtilsJs.transparent)(buttonForeground, .4), _nlsJs.localize("buttonSeparator", "Button separator color."));
const buttonBackground = (0, _colorUtilsJs.registerColor)("button.background", {
    dark: "#0E639C",
    light: "#007ACC",
    hcDark: null,
    hcLight: "#0F4A85"
}, _nlsJs.localize("buttonBackground", "Button background color."));
const buttonHoverBackground = (0, _colorUtilsJs.registerColor)("button.hoverBackground", {
    dark: (0, _colorUtilsJs.lighten)(buttonBackground, 0.2),
    light: (0, _colorUtilsJs.darken)(buttonBackground, 0.2),
    hcDark: buttonBackground,
    hcLight: buttonBackground
}, _nlsJs.localize("buttonHoverBackground", "Button background color when hovering."));
const buttonBorder = (0, _colorUtilsJs.registerColor)("button.border", (0, _baseColorsJs.contrastBorder), _nlsJs.localize("buttonBorder", "Button border color."));
const buttonSecondaryForeground = (0, _colorUtilsJs.registerColor)("button.secondaryForeground", {
    dark: (0, _colorJs.Color).white,
    light: (0, _colorJs.Color).white,
    hcDark: (0, _colorJs.Color).white,
    hcLight: (0, _baseColorsJs.foreground)
}, _nlsJs.localize("buttonSecondaryForeground", "Secondary button foreground color."));
const buttonSecondaryBackground = (0, _colorUtilsJs.registerColor)("button.secondaryBackground", {
    dark: "#3A3D41",
    light: "#5F6A79",
    hcDark: null,
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("buttonSecondaryBackground", "Secondary button background color."));
const buttonSecondaryHoverBackground = (0, _colorUtilsJs.registerColor)("button.secondaryHoverBackground", {
    dark: (0, _colorUtilsJs.lighten)(buttonSecondaryBackground, 0.2),
    light: (0, _colorUtilsJs.darken)(buttonSecondaryBackground, 0.2),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("buttonSecondaryHoverBackground", "Secondary button background color when hovering."));
const radioActiveForeground = (0, _colorUtilsJs.registerColor)("radio.activeForeground", inputActiveOptionForeground, _nlsJs.localize("radioActiveForeground", "Foreground color of active radio option."));
const radioActiveBackground = (0, _colorUtilsJs.registerColor)("radio.activeBackground", inputActiveOptionBackground, _nlsJs.localize("radioBackground", "Background color of active radio option."));
const radioActiveBorder = (0, _colorUtilsJs.registerColor)("radio.activeBorder", inputActiveOptionBorder, _nlsJs.localize("radioActiveBorder", "Border color of the active radio option."));
const radioInactiveForeground = (0, _colorUtilsJs.registerColor)("radio.inactiveForeground", null, _nlsJs.localize("radioInactiveForeground", "Foreground color of inactive radio option."));
const radioInactiveBackground = (0, _colorUtilsJs.registerColor)("radio.inactiveBackground", null, _nlsJs.localize("radioInactiveBackground", "Background color of inactive radio option."));
const radioInactiveBorder = (0, _colorUtilsJs.registerColor)("radio.inactiveBorder", {
    light: (0, _colorUtilsJs.transparent)(radioActiveForeground, .2),
    dark: (0, _colorUtilsJs.transparent)(radioActiveForeground, .2),
    hcDark: (0, _colorUtilsJs.transparent)(radioActiveForeground, .4),
    hcLight: (0, _colorUtilsJs.transparent)(radioActiveForeground, .2)
}, _nlsJs.localize("radioInactiveBorder", "Border color of the inactive radio option."));
const radioInactiveHoverBackground = (0, _colorUtilsJs.registerColor)("radio.inactiveHoverBackground", inputActiveOptionHoverBackground, _nlsJs.localize("radioHoverBackground", "Background color of inactive active radio option when hovering."));
const checkboxBackground = (0, _colorUtilsJs.registerColor)("checkbox.background", selectBackground, _nlsJs.localize("checkbox.background", "Background color of checkbox widget."));
const checkboxSelectBackground = (0, _colorUtilsJs.registerColor)("checkbox.selectBackground", (0, _editorColorsJs.editorWidgetBackground), _nlsJs.localize("checkbox.select.background", "Background color of checkbox widget when the element it's in is selected."));
const checkboxForeground = (0, _colorUtilsJs.registerColor)("checkbox.foreground", selectForeground, _nlsJs.localize("checkbox.foreground", "Foreground color of checkbox widget."));
const checkboxBorder = (0, _colorUtilsJs.registerColor)("checkbox.border", selectBorder, _nlsJs.localize("checkbox.border", "Border color of checkbox widget."));
const checkboxSelectBorder = (0, _colorUtilsJs.registerColor)("checkbox.selectBorder", (0, _baseColorsJs.iconForeground), _nlsJs.localize("checkbox.select.border", "Border color of checkbox widget when the element it's in is selected."));
const keybindingLabelBackground = (0, _colorUtilsJs.registerColor)("keybindingLabel.background", {
    dark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(128, 128, 128, 0.17)),
    light: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(221, 221, 221, 0.4)),
    hcDark: (0, _colorJs.Color).transparent,
    hcLight: (0, _colorJs.Color).transparent
}, _nlsJs.localize("keybindingLabelBackground", "Keybinding label background color. The keybinding label is used to represent a keyboard shortcut."));
const keybindingLabelForeground = (0, _colorUtilsJs.registerColor)("keybindingLabel.foreground", {
    dark: (0, _colorJs.Color).fromHex("#CCCCCC"),
    light: (0, _colorJs.Color).fromHex("#555555"),
    hcDark: (0, _colorJs.Color).white,
    hcLight: (0, _baseColorsJs.foreground)
}, _nlsJs.localize("keybindingLabelForeground", "Keybinding label foreground color. The keybinding label is used to represent a keyboard shortcut."));
const keybindingLabelBorder = (0, _colorUtilsJs.registerColor)("keybindingLabel.border", {
    dark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(51, 51, 51, 0.6)),
    light: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(204, 204, 204, 0.4)),
    hcDark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(111, 195, 223)),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("keybindingLabelBorder", "Keybinding label border color. The keybinding label is used to represent a keyboard shortcut."));
const keybindingLabelBottomBorder = (0, _colorUtilsJs.registerColor)("keybindingLabel.bottomBorder", {
    dark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(68, 68, 68, 0.6)),
    light: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(187, 187, 187, 0.4)),
    hcDark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(111, 195, 223)),
    hcLight: (0, _baseColorsJs.foreground)
}, _nlsJs.localize("keybindingLabelBottomBorder", "Keybinding label border bottom color. The keybinding label is used to represent a keyboard shortcut."));

},{"../../../../nls.js":"l617d","../../../../base/common/color.js":"at4gb","../colorUtils.js":"7VkBg","./baseColors.js":"8iG5A","./editorColors.js":"c46FO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"58Zzh":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listFocusBackground", ()=>listFocusBackground);
parcelHelpers.export(exports, "listFocusForeground", ()=>listFocusForeground);
parcelHelpers.export(exports, "listFocusOutline", ()=>listFocusOutline);
parcelHelpers.export(exports, "listFocusAndSelectionOutline", ()=>listFocusAndSelectionOutline);
parcelHelpers.export(exports, "listActiveSelectionBackground", ()=>listActiveSelectionBackground);
parcelHelpers.export(exports, "listActiveSelectionForeground", ()=>listActiveSelectionForeground);
parcelHelpers.export(exports, "listActiveSelectionIconForeground", ()=>listActiveSelectionIconForeground);
parcelHelpers.export(exports, "listInactiveSelectionBackground", ()=>listInactiveSelectionBackground);
parcelHelpers.export(exports, "listInactiveSelectionForeground", ()=>listInactiveSelectionForeground);
parcelHelpers.export(exports, "listInactiveSelectionIconForeground", ()=>listInactiveSelectionIconForeground);
parcelHelpers.export(exports, "listInactiveFocusBackground", ()=>listInactiveFocusBackground);
parcelHelpers.export(exports, "listInactiveFocusOutline", ()=>listInactiveFocusOutline);
parcelHelpers.export(exports, "listHoverBackground", ()=>listHoverBackground);
parcelHelpers.export(exports, "listHoverForeground", ()=>listHoverForeground);
parcelHelpers.export(exports, "listDropOverBackground", ()=>listDropOverBackground);
parcelHelpers.export(exports, "listDropBetweenBackground", ()=>listDropBetweenBackground);
parcelHelpers.export(exports, "listHighlightForeground", ()=>listHighlightForeground);
parcelHelpers.export(exports, "listFocusHighlightForeground", ()=>listFocusHighlightForeground);
parcelHelpers.export(exports, "listInvalidItemForeground", ()=>listInvalidItemForeground);
parcelHelpers.export(exports, "listErrorForeground", ()=>listErrorForeground);
parcelHelpers.export(exports, "listWarningForeground", ()=>listWarningForeground);
parcelHelpers.export(exports, "listFilterWidgetBackground", ()=>listFilterWidgetBackground);
parcelHelpers.export(exports, "listFilterWidgetOutline", ()=>listFilterWidgetOutline);
parcelHelpers.export(exports, "listFilterWidgetNoMatchesOutline", ()=>listFilterWidgetNoMatchesOutline);
parcelHelpers.export(exports, "listFilterWidgetShadow", ()=>listFilterWidgetShadow);
parcelHelpers.export(exports, "listFilterMatchHighlight", ()=>listFilterMatchHighlight);
parcelHelpers.export(exports, "listFilterMatchHighlightBorder", ()=>listFilterMatchHighlightBorder);
parcelHelpers.export(exports, "listDeemphasizedForeground", ()=>listDeemphasizedForeground);
parcelHelpers.export(exports, "treeIndentGuidesStroke", ()=>treeIndentGuidesStroke);
parcelHelpers.export(exports, "treeInactiveIndentGuidesStroke", ()=>treeInactiveIndentGuidesStroke);
parcelHelpers.export(exports, "tableColumnsBorder", ()=>tableColumnsBorder);
parcelHelpers.export(exports, "tableOddRowsBackgroundColor", ()=>tableOddRowsBackgroundColor);
parcelHelpers.export(exports, "editorActionListBackground", ()=>editorActionListBackground);
parcelHelpers.export(exports, "editorActionListForeground", ()=>editorActionListForeground);
parcelHelpers.export(exports, "editorActionListFocusForeground", ()=>editorActionListFocusForeground);
parcelHelpers.export(exports, "editorActionListFocusBackground", ()=>editorActionListFocusBackground);
var _nlsJs = require("../../../../nls.js");
// Import the effects we need
var _colorJs = require("../../../../base/common/color.js");
var _colorUtilsJs = require("../colorUtils.js");
// Import the colors we need
var _baseColorsJs = require("./baseColors.js");
var _editorColorsJs = require("./editorColors.js");
const listFocusBackground = (0, _colorUtilsJs.registerColor)("list.focusBackground", null, _nlsJs.localize("listFocusBackground", "List/Tree background color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
const listFocusForeground = (0, _colorUtilsJs.registerColor)("list.focusForeground", null, _nlsJs.localize("listFocusForeground", "List/Tree foreground color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
const listFocusOutline = (0, _colorUtilsJs.registerColor)("list.focusOutline", {
    dark: (0, _baseColorsJs.focusBorder),
    light: (0, _baseColorsJs.focusBorder),
    hcDark: (0, _baseColorsJs.activeContrastBorder),
    hcLight: (0, _baseColorsJs.activeContrastBorder)
}, _nlsJs.localize("listFocusOutline", "List/Tree outline color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
const listFocusAndSelectionOutline = (0, _colorUtilsJs.registerColor)("list.focusAndSelectionOutline", null, _nlsJs.localize("listFocusAndSelectionOutline", "List/Tree outline color for the focused item when the list/tree is active and selected. An active list/tree has keyboard focus, an inactive does not."));
const listActiveSelectionBackground = (0, _colorUtilsJs.registerColor)("list.activeSelectionBackground", {
    dark: "#04395E",
    light: "#0060C0",
    hcDark: null,
    hcLight: (0, _colorJs.Color).fromHex("#0F4A85").transparent(0.1)
}, _nlsJs.localize("listActiveSelectionBackground", "List/Tree background color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
const listActiveSelectionForeground = (0, _colorUtilsJs.registerColor)("list.activeSelectionForeground", {
    dark: (0, _colorJs.Color).white,
    light: (0, _colorJs.Color).white,
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("listActiveSelectionForeground", "List/Tree foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
const listActiveSelectionIconForeground = (0, _colorUtilsJs.registerColor)("list.activeSelectionIconForeground", null, _nlsJs.localize("listActiveSelectionIconForeground", "List/Tree icon foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
const listInactiveSelectionBackground = (0, _colorUtilsJs.registerColor)("list.inactiveSelectionBackground", {
    dark: "#37373D",
    light: "#E4E6F1",
    hcDark: null,
    hcLight: (0, _colorJs.Color).fromHex("#0F4A85").transparent(0.1)
}, _nlsJs.localize("listInactiveSelectionBackground", "List/Tree background color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
const listInactiveSelectionForeground = (0, _colorUtilsJs.registerColor)("list.inactiveSelectionForeground", null, _nlsJs.localize("listInactiveSelectionForeground", "List/Tree foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
const listInactiveSelectionIconForeground = (0, _colorUtilsJs.registerColor)("list.inactiveSelectionIconForeground", null, _nlsJs.localize("listInactiveSelectionIconForeground", "List/Tree icon foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
const listInactiveFocusBackground = (0, _colorUtilsJs.registerColor)("list.inactiveFocusBackground", null, _nlsJs.localize("listInactiveFocusBackground", "List/Tree background color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
const listInactiveFocusOutline = (0, _colorUtilsJs.registerColor)("list.inactiveFocusOutline", null, _nlsJs.localize("listInactiveFocusOutline", "List/Tree outline color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
const listHoverBackground = (0, _colorUtilsJs.registerColor)("list.hoverBackground", {
    dark: "#2A2D2E",
    light: "#F0F0F0",
    hcDark: (0, _colorJs.Color).white.transparent(0.1),
    hcLight: (0, _colorJs.Color).fromHex("#0F4A85").transparent(0.1)
}, _nlsJs.localize("listHoverBackground", "List/Tree background when hovering over items using the mouse."));
const listHoverForeground = (0, _colorUtilsJs.registerColor)("list.hoverForeground", null, _nlsJs.localize("listHoverForeground", "List/Tree foreground when hovering over items using the mouse."));
const listDropOverBackground = (0, _colorUtilsJs.registerColor)("list.dropBackground", {
    dark: "#062F4A",
    light: "#D6EBFF",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("listDropBackground", "List/Tree drag and drop background when moving items over other items when using the mouse."));
const listDropBetweenBackground = (0, _colorUtilsJs.registerColor)("list.dropBetweenBackground", {
    dark: (0, _baseColorsJs.iconForeground),
    light: (0, _baseColorsJs.iconForeground),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("listDropBetweenBackground", "List/Tree drag and drop border color when moving items between items when using the mouse."));
const listHighlightForeground = (0, _colorUtilsJs.registerColor)("list.highlightForeground", {
    dark: "#2AAAFF",
    light: "#0066BF",
    hcDark: (0, _baseColorsJs.focusBorder),
    hcLight: (0, _baseColorsJs.focusBorder)
}, _nlsJs.localize("highlight", "List/Tree foreground color of the match highlights when searching inside the list/tree."));
const listFocusHighlightForeground = (0, _colorUtilsJs.registerColor)("list.focusHighlightForeground", {
    dark: listHighlightForeground,
    light: (0, _colorUtilsJs.ifDefinedThenElse)(listActiveSelectionBackground, listHighlightForeground, "#BBE7FF"),
    hcDark: listHighlightForeground,
    hcLight: listHighlightForeground
}, _nlsJs.localize("listFocusHighlightForeground", "List/Tree foreground color of the match highlights on actively focused items when searching inside the list/tree."));
const listInvalidItemForeground = (0, _colorUtilsJs.registerColor)("list.invalidItemForeground", {
    dark: "#B89500",
    light: "#B89500",
    hcDark: "#B89500",
    hcLight: "#B5200D"
}, _nlsJs.localize("invalidItemForeground", "List/Tree foreground color for invalid items, for example an unresolved root in explorer."));
const listErrorForeground = (0, _colorUtilsJs.registerColor)("list.errorForeground", {
    dark: "#F88070",
    light: "#B01011",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("listErrorForeground", "Foreground color of list items containing errors."));
const listWarningForeground = (0, _colorUtilsJs.registerColor)("list.warningForeground", {
    dark: "#CCA700",
    light: "#855F00",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("listWarningForeground", "Foreground color of list items containing warnings."));
const listFilterWidgetBackground = (0, _colorUtilsJs.registerColor)("listFilterWidget.background", {
    light: (0, _colorUtilsJs.darken)((0, _editorColorsJs.editorWidgetBackground), 0),
    dark: (0, _colorUtilsJs.lighten)((0, _editorColorsJs.editorWidgetBackground), 0),
    hcDark: (0, _editorColorsJs.editorWidgetBackground),
    hcLight: (0, _editorColorsJs.editorWidgetBackground)
}, _nlsJs.localize("listFilterWidgetBackground", "Background color of the type filter widget in lists and trees."));
const listFilterWidgetOutline = (0, _colorUtilsJs.registerColor)("listFilterWidget.outline", {
    dark: (0, _colorJs.Color).transparent,
    light: (0, _colorJs.Color).transparent,
    hcDark: "#f38518",
    hcLight: "#007ACC"
}, _nlsJs.localize("listFilterWidgetOutline", "Outline color of the type filter widget in lists and trees."));
const listFilterWidgetNoMatchesOutline = (0, _colorUtilsJs.registerColor)("listFilterWidget.noMatchesOutline", {
    dark: "#BE1100",
    light: "#BE1100",
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("listFilterWidgetNoMatchesOutline", "Outline color of the type filter widget in lists and trees, when there are no matches."));
const listFilterWidgetShadow = (0, _colorUtilsJs.registerColor)("listFilterWidget.shadow", (0, _editorColorsJs.widgetShadow), _nlsJs.localize("listFilterWidgetShadow", "Shadow color of the type filter widget in lists and trees."));
const listFilterMatchHighlight = (0, _colorUtilsJs.registerColor)("list.filterMatchBackground", {
    dark: (0, _editorColorsJs.editorFindMatchHighlight),
    light: (0, _editorColorsJs.editorFindMatchHighlight),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("listFilterMatchHighlight", "Background color of the filtered match."));
const listFilterMatchHighlightBorder = (0, _colorUtilsJs.registerColor)("list.filterMatchBorder", {
    dark: (0, _editorColorsJs.editorFindMatchHighlightBorder),
    light: (0, _editorColorsJs.editorFindMatchHighlightBorder),
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.activeContrastBorder)
}, _nlsJs.localize("listFilterMatchHighlightBorder", "Border color of the filtered match."));
const listDeemphasizedForeground = (0, _colorUtilsJs.registerColor)("list.deemphasizedForeground", {
    dark: "#8C8C8C",
    light: "#8E8E90",
    hcDark: "#A7A8A9",
    hcLight: "#666666"
}, _nlsJs.localize("listDeemphasizedForeground", "List/Tree foreground color for items that are deemphasized."));
const treeIndentGuidesStroke = (0, _colorUtilsJs.registerColor)("tree.indentGuidesStroke", {
    dark: "#585858",
    light: "#a9a9a9",
    hcDark: "#a9a9a9",
    hcLight: "#a5a5a5"
}, _nlsJs.localize("treeIndentGuidesStroke", "Tree stroke color for the indentation guides."));
const treeInactiveIndentGuidesStroke = (0, _colorUtilsJs.registerColor)("tree.inactiveIndentGuidesStroke", (0, _colorUtilsJs.transparent)(treeIndentGuidesStroke, 0.4), _nlsJs.localize("treeInactiveIndentGuidesStroke", "Tree stroke color for the indentation guides that are not active."));
const tableColumnsBorder = (0, _colorUtilsJs.registerColor)("tree.tableColumnsBorder", {
    dark: "#CCCCCC20",
    light: "#61616120",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("tableColumnsBorder", "Table border color between columns."));
const tableOddRowsBackgroundColor = (0, _colorUtilsJs.registerColor)("tree.tableOddRowsBackground", {
    dark: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.foreground), 0.04),
    light: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.foreground), 0.04),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("tableOddRowsBackgroundColor", "Background color for odd table rows."));
const editorActionListBackground = (0, _colorUtilsJs.registerColor)("editorActionList.background", (0, _editorColorsJs.editorWidgetBackground), _nlsJs.localize("editorActionListBackground", "Action List background color."));
const editorActionListForeground = (0, _colorUtilsJs.registerColor)("editorActionList.foreground", (0, _editorColorsJs.editorWidgetForeground), _nlsJs.localize("editorActionListForeground", "Action List foreground color."));
const editorActionListFocusForeground = (0, _colorUtilsJs.registerColor)("editorActionList.focusForeground", listActiveSelectionForeground, _nlsJs.localize("editorActionListFocusForeground", "Action List foreground color for the focused item."));
const editorActionListFocusBackground = (0, _colorUtilsJs.registerColor)("editorActionList.focusBackground", listActiveSelectionBackground, _nlsJs.localize("editorActionListFocusBackground", "Action List background color for the focused item."));

},{"../../../../nls.js":"l617d","../../../../base/common/color.js":"at4gb","../colorUtils.js":"7VkBg","./baseColors.js":"8iG5A","./editorColors.js":"c46FO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8mqTF":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "menuBorder", ()=>menuBorder);
parcelHelpers.export(exports, "menuForeground", ()=>menuForeground);
parcelHelpers.export(exports, "menuBackground", ()=>menuBackground);
parcelHelpers.export(exports, "menuSelectionForeground", ()=>menuSelectionForeground);
parcelHelpers.export(exports, "menuSelectionBackground", ()=>menuSelectionBackground);
parcelHelpers.export(exports, "menuSelectionBorder", ()=>menuSelectionBorder);
parcelHelpers.export(exports, "menuSeparatorBackground", ()=>menuSeparatorBackground);
var _nlsJs = require("../../../../nls.js");
// Import the effects we need
var _colorUtilsJs = require("../colorUtils.js");
// Import the colors we need
var _baseColorsJs = require("./baseColors.js");
var _inputColorsJs = require("./inputColors.js");
var _listColorsJs = require("./listColors.js");
const menuBorder = (0, _colorUtilsJs.registerColor)("menu.border", {
    dark: null,
    light: null,
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("menuBorder", "Border color of menus."));
const menuForeground = (0, _colorUtilsJs.registerColor)("menu.foreground", (0, _inputColorsJs.selectForeground), _nlsJs.localize("menuForeground", "Foreground color of menu items."));
const menuBackground = (0, _colorUtilsJs.registerColor)("menu.background", (0, _inputColorsJs.selectBackground), _nlsJs.localize("menuBackground", "Background color of menu items."));
const menuSelectionForeground = (0, _colorUtilsJs.registerColor)("menu.selectionForeground", (0, _listColorsJs.listActiveSelectionForeground), _nlsJs.localize("menuSelectionForeground", "Foreground color of the selected menu item in menus."));
const menuSelectionBackground = (0, _colorUtilsJs.registerColor)("menu.selectionBackground", (0, _listColorsJs.listActiveSelectionBackground), _nlsJs.localize("menuSelectionBackground", "Background color of the selected menu item in menus."));
const menuSelectionBorder = (0, _colorUtilsJs.registerColor)("menu.selectionBorder", {
    dark: null,
    light: null,
    hcDark: (0, _baseColorsJs.activeContrastBorder),
    hcLight: (0, _baseColorsJs.activeContrastBorder)
}, _nlsJs.localize("menuSelectionBorder", "Border color of the selected menu item in menus."));
const menuSeparatorBackground = (0, _colorUtilsJs.registerColor)("menu.separatorBackground", {
    dark: "#606060",
    light: "#D4D4D4",
    hcDark: (0, _baseColorsJs.contrastBorder),
    hcLight: (0, _baseColorsJs.contrastBorder)
}, _nlsJs.localize("menuSeparatorBackground", "Color of a separator menu item in menus."));

},{"../../../../nls.js":"l617d","../colorUtils.js":"7VkBg","./baseColors.js":"8iG5A","./inputColors.js":"9pTqI","./listColors.js":"58Zzh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9j1zL":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quickInputBackground", ()=>quickInputBackground);
parcelHelpers.export(exports, "quickInputForeground", ()=>quickInputForeground);
parcelHelpers.export(exports, "quickInputTitleBackground", ()=>quickInputTitleBackground);
parcelHelpers.export(exports, "pickerGroupForeground", ()=>pickerGroupForeground);
parcelHelpers.export(exports, "pickerGroupBorder", ()=>pickerGroupBorder);
parcelHelpers.export(exports, "_deprecatedQuickInputListFocusBackground", ()=>_deprecatedQuickInputListFocusBackground);
parcelHelpers.export(exports, "quickInputListFocusForeground", ()=>quickInputListFocusForeground);
parcelHelpers.export(exports, "quickInputListFocusIconForeground", ()=>quickInputListFocusIconForeground);
parcelHelpers.export(exports, "quickInputListFocusBackground", ()=>quickInputListFocusBackground);
var _nlsJs = require("../../../../nls.js");
// Import the effects we need
var _colorJs = require("../../../../base/common/color.js");
var _colorUtilsJs = require("../colorUtils.js");
// Import the colors we need
var _editorColorsJs = require("./editorColors.js");
var _listColorsJs = require("./listColors.js");
const quickInputBackground = (0, _colorUtilsJs.registerColor)("quickInput.background", (0, _editorColorsJs.editorWidgetBackground), _nlsJs.localize("pickerBackground", "Quick picker background color. The quick picker widget is the container for pickers like the command palette."));
const quickInputForeground = (0, _colorUtilsJs.registerColor)("quickInput.foreground", (0, _editorColorsJs.editorWidgetForeground), _nlsJs.localize("pickerForeground", "Quick picker foreground color. The quick picker widget is the container for pickers like the command palette."));
const quickInputTitleBackground = (0, _colorUtilsJs.registerColor)("quickInputTitle.background", {
    dark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(255, 255, 255, 0.105)),
    light: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(0, 0, 0, 0.06)),
    hcDark: "#000000",
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("pickerTitleBackground", "Quick picker title background color. The quick picker widget is the container for pickers like the command palette."));
const pickerGroupForeground = (0, _colorUtilsJs.registerColor)("pickerGroup.foreground", {
    dark: "#3794FF",
    light: "#0066BF",
    hcDark: (0, _colorJs.Color).white,
    hcLight: "#0F4A85"
}, _nlsJs.localize("pickerGroupForeground", "Quick picker color for grouping labels."));
const pickerGroupBorder = (0, _colorUtilsJs.registerColor)("pickerGroup.border", {
    dark: "#3F3F46",
    light: "#CCCEDB",
    hcDark: (0, _colorJs.Color).white,
    hcLight: "#0F4A85"
}, _nlsJs.localize("pickerGroupBorder", "Quick picker color for grouping borders."));
const _deprecatedQuickInputListFocusBackground = (0, _colorUtilsJs.registerColor)("quickInput.list.focusBackground", null, "", undefined, _nlsJs.localize("quickInput.list.focusBackground deprecation", "Please use quickInputList.focusBackground instead"));
const quickInputListFocusForeground = (0, _colorUtilsJs.registerColor)("quickInputList.focusForeground", (0, _listColorsJs.listActiveSelectionForeground), _nlsJs.localize("quickInput.listFocusForeground", "Quick picker foreground color for the focused item."));
const quickInputListFocusIconForeground = (0, _colorUtilsJs.registerColor)("quickInputList.focusIconForeground", (0, _listColorsJs.listActiveSelectionIconForeground), _nlsJs.localize("quickInput.listFocusIconForeground", "Quick picker icon foreground color for the focused item."));
const quickInputListFocusBackground = (0, _colorUtilsJs.registerColor)("quickInputList.focusBackground", {
    dark: (0, _colorUtilsJs.oneOf)(_deprecatedQuickInputListFocusBackground, (0, _listColorsJs.listActiveSelectionBackground)),
    light: (0, _colorUtilsJs.oneOf)(_deprecatedQuickInputListFocusBackground, (0, _listColorsJs.listActiveSelectionBackground)),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("quickInput.listFocusBackground", "Quick picker background color for the focused item."));

},{"../../../../nls.js":"l617d","../../../../base/common/color.js":"at4gb","../colorUtils.js":"7VkBg","./editorColors.js":"c46FO","./listColors.js":"58Zzh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"23gml":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "searchResultsInfoForeground", ()=>searchResultsInfoForeground);
parcelHelpers.export(exports, "searchEditorFindMatch", ()=>searchEditorFindMatch);
parcelHelpers.export(exports, "searchEditorFindMatchBorder", ()=>searchEditorFindMatchBorder);
var _nlsJs = require("../../../../nls.js");
// Import the effects we need
var _colorUtilsJs = require("../colorUtils.js");
// Import the colors we need
var _baseColorsJs = require("./baseColors.js");
var _editorColorsJs = require("./editorColors.js");
const searchResultsInfoForeground = (0, _colorUtilsJs.registerColor)("search.resultsInfoForeground", {
    light: (0, _baseColorsJs.foreground),
    dark: (0, _colorUtilsJs.transparent)((0, _baseColorsJs.foreground), 0.65),
    hcDark: (0, _baseColorsJs.foreground),
    hcLight: (0, _baseColorsJs.foreground)
}, _nlsJs.localize("search.resultsInfoForeground", "Color of the text in the search viewlet's completion message."));
const searchEditorFindMatch = (0, _colorUtilsJs.registerColor)("searchEditor.findMatchBackground", {
    light: (0, _colorUtilsJs.transparent)((0, _editorColorsJs.editorFindMatchHighlight), 0.66),
    dark: (0, _colorUtilsJs.transparent)((0, _editorColorsJs.editorFindMatchHighlight), 0.66),
    hcDark: (0, _editorColorsJs.editorFindMatchHighlight),
    hcLight: (0, _editorColorsJs.editorFindMatchHighlight)
}, _nlsJs.localize("searchEditor.queryMatch", "Color of the Search Editor query matches."));
const searchEditorFindMatchBorder = (0, _colorUtilsJs.registerColor)("searchEditor.findMatchBorder", {
    light: (0, _colorUtilsJs.transparent)((0, _editorColorsJs.editorFindMatchHighlightBorder), 0.66),
    dark: (0, _colorUtilsJs.transparent)((0, _editorColorsJs.editorFindMatchHighlightBorder), 0.66),
    hcDark: (0, _editorColorsJs.editorFindMatchHighlightBorder),
    hcLight: (0, _editorColorsJs.editorFindMatchHighlightBorder)
}, _nlsJs.localize("searchEditor.editorFindMatchBorder", "Border color of the Search Editor query matches."));

},{"../../../../nls.js":"l617d","../colorUtils.js":"7VkBg","./baseColors.js":"8iG5A","./editorColors.js":"c46FO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3QGXp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IHoverService", ()=>IHoverService);
parcelHelpers.export(exports, "WorkbenchHoverDelegate", ()=>WorkbenchHoverDelegate);
parcelHelpers.export(exports, "nativeHoverDelegate", ()=>nativeHoverDelegate);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _configurationJs = require("../../configuration/common/configuration.js");
var _domJs = require("../../../base/browser/dom.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const IHoverService = (0, _instantiationJs.createDecorator)("hoverService");
let WorkbenchHoverDelegate = class WorkbenchHoverDelegate extends (0, _lifecycleJs.Disposable) {
    get delay() {
        if (this.isInstantlyHovering()) return 0; // show instantly when a hover was recently shown
        return this._delay;
    }
    constructor(placement, instantHover, overrideOptions = {}, configurationService, hoverService){
        super();
        this.placement = placement;
        this.instantHover = instantHover;
        this.overrideOptions = overrideOptions;
        this.configurationService = configurationService;
        this.hoverService = hoverService;
        this.lastHoverHideTime = 0;
        this.timeLimit = 200;
        this.hoverDisposables = this._register(new (0, _lifecycleJs.DisposableStore)());
        this._delay = this.configurationService.getValue("workbench.hover.delay");
        this._register(this.configurationService.onDidChangeConfiguration((e)=>{
            if (e.affectsConfiguration("workbench.hover.delay")) this._delay = this.configurationService.getValue("workbench.hover.delay");
        }));
    }
    showHover(options, focus) {
        const overrideOptions = typeof this.overrideOptions === "function" ? this.overrideOptions(options, focus) : this.overrideOptions;
        // close hover on escape
        this.hoverDisposables.clear();
        const targets = (0, _domJs.isHTMLElement)(options.target) ? [
            options.target
        ] : options.target.targetElements;
        for (const target of targets)this.hoverDisposables.add((0, _domJs.addStandardDisposableListener)(target, "keydown", (e)=>{
            if (e.equals(9 /* KeyCode.Escape */ )) this.hoverService.hideHover();
        }));
        const id = (0, _domJs.isHTMLElement)(options.content) ? undefined : options.content.toString();
        return this.hoverService.showHover({
            ...options,
            ...overrideOptions,
            persistence: {
                hideOnKeyDown: true,
                ...overrideOptions.persistence
            },
            id,
            appearance: {
                ...options.appearance,
                compact: true,
                skipFadeInAnimation: this.isInstantlyHovering(),
                ...overrideOptions.appearance
            }
        }, focus);
    }
    isInstantlyHovering() {
        return this.instantHover && Date.now() - this.lastHoverHideTime < this.timeLimit;
    }
    onDidHideHover() {
        this.hoverDisposables.clear();
        if (this.instantHover) this.lastHoverHideTime = Date.now();
    }
};
WorkbenchHoverDelegate = __decorate([
    __param(3, (0, _configurationJs.IConfigurationService)),
    __param(4, IHoverService)
], WorkbenchHoverDelegate);
const nativeHoverDelegate = {
    showHover: function() {
        throw new Error("Native hover function not implemented.");
    },
    delay: 0,
    showNativeHover: true
};

},{"../../instantiation/common/instantiation.js":"fjwWx","../../../base/common/lifecycle.js":"9kg8d","../../configuration/common/configuration.js":"dXkjq","../../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2QlUR":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IContextViewService", ()=>IContextViewService);
parcelHelpers.export(exports, "IContextMenuService", ()=>IContextMenuService);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IContextViewService = (0, _instantiationJs.createDecorator)("contextViewService");
const IContextMenuService = (0, _instantiationJs.createDecorator)("contextMenuService");

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8US5g":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverWidget", ()=>HoverWidget);
var _hoverCss = require("./hover.css");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _eventJs = require("../../../../base/common/event.js");
var _domJs = require("../../../../base/browser/dom.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
var _hoverWidgetJs = require("../../../../base/browser/ui/hover/hoverWidget.js");
var _widgetJs = require("../../../../base/browser/ui/widget.js");
var _openerJs = require("../../../../platform/opener/common/opener.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _markdownRendererJs = require("../../widget/markdownRenderer/browser/markdownRenderer.js");
var _htmlContentJs = require("../../../../base/common/htmlContent.js");
var _nlsJs = require("../../../../nls.js");
var _platformJs = require("../../../../base/common/platform.js");
var _accessibilityJs = require("../../../../platform/accessibility/common/accessibility.js");
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const $ = _domJs.$;
let HoverWidget = class HoverWidget extends (0, _widgetJs.Widget) {
    get _targetWindow() {
        return _domJs.getWindow(this._target.targetElements[0]);
    }
    get _targetDocumentElement() {
        return _domJs.getWindow(this._target.targetElements[0]).document.documentElement;
    }
    get isDisposed() {
        return this._isDisposed;
    }
    get isMouseIn() {
        return this._lockMouseTracker.isMouseIn;
    }
    get domNode() {
        return this._hover.containerDomNode;
    }
    get onDispose() {
        return this._onDispose.event;
    }
    get onRequestLayout() {
        return this._onRequestLayout.event;
    }
    get anchor() {
        return this._hoverPosition === 2 /* HoverPosition.BELOW */  ? 0 /* AnchorPosition.BELOW */  : 1 /* AnchorPosition.ABOVE */ ;
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
    /**
     * Whether the hover is "locked" by holding the alt/option key. When locked, the hover will not
     * hide and can be hovered regardless of whether the `hideOnHover` hover option is set.
     */ get isLocked() {
        return this._isLocked;
    }
    set isLocked(value) {
        if (this._isLocked === value) return;
        this._isLocked = value;
        this._hoverContainer.classList.toggle("locked", this._isLocked);
    }
    constructor(options, _keybindingService, _configurationService, _openerService, _instantiationService, _accessibilityService){
        super();
        this._keybindingService = _keybindingService;
        this._configurationService = _configurationService;
        this._openerService = _openerService;
        this._instantiationService = _instantiationService;
        this._accessibilityService = _accessibilityService;
        this._messageListeners = new (0, _lifecycleJs.DisposableStore)();
        this._isDisposed = false;
        this._forcePosition = false;
        this._x = 0;
        this._y = 0;
        this._isLocked = false;
        this._enableFocusTraps = false;
        this._addedFocusTrap = false;
        this._onDispose = this._register(new (0, _eventJs.Emitter)());
        this._onRequestLayout = this._register(new (0, _eventJs.Emitter)());
        this._linkHandler = options.linkHandler || ((url)=>{
            return (0, _markdownRendererJs.openLinkFromMarkdown)(this._openerService, url, (0, _htmlContentJs.isMarkdownString)(options.content) ? options.content.isTrusted : undefined);
        });
        this._target = "targetElements" in options.target ? options.target : new ElementHoverTarget(options.target);
        this._hoverPointer = options.appearance?.showPointer ? $("div.workbench-hover-pointer") : undefined;
        this._hover = this._register(new (0, _hoverWidgetJs.HoverWidget)());
        this._hover.containerDomNode.classList.add("workbench-hover", "fadeIn");
        if (options.appearance?.compact) this._hover.containerDomNode.classList.add("workbench-hover", "compact");
        if (options.appearance?.skipFadeInAnimation) this._hover.containerDomNode.classList.add("skip-fade-in");
        if (options.additionalClasses) this._hover.containerDomNode.classList.add(...options.additionalClasses);
        if (options.position?.forcePosition) this._forcePosition = true;
        if (options.trapFocus) this._enableFocusTraps = true;
        this._hoverPosition = options.position?.hoverPosition ?? 3 /* HoverPosition.ABOVE */ ;
        // Don't allow mousedown out of the widget, otherwise preventDefault will call and text will
        // not be selected.
        this.onmousedown(this._hover.containerDomNode, (e)=>e.stopPropagation());
        // Hide hover on escape
        this.onkeydown(this._hover.containerDomNode, (e)=>{
            if (e.equals(9 /* KeyCode.Escape */ )) this.dispose();
        });
        // Hide when the window loses focus
        this._register(_domJs.addDisposableListener(this._targetWindow, "blur", ()=>this.dispose()));
        const rowElement = $("div.hover-row.markdown-hover");
        const contentsElement = $("div.hover-contents");
        if (typeof options.content === "string") {
            contentsElement.textContent = options.content;
            contentsElement.style.whiteSpace = "pre-wrap";
        } else if (_domJs.isHTMLElement(options.content)) {
            contentsElement.appendChild(options.content);
            contentsElement.classList.add("html-hover-contents");
        } else {
            const markdown = options.content;
            const mdRenderer = this._instantiationService.createInstance((0, _markdownRendererJs.MarkdownRenderer), {
                codeBlockFontFamily: this._configurationService.getValue("editor").fontFamily || (0, _editorOptionsJs.EDITOR_FONT_DEFAULTS).fontFamily
            });
            const { element } = mdRenderer.render(markdown, {
                actionHandler: {
                    callback: (content)=>this._linkHandler(content),
                    disposables: this._messageListeners
                },
                asyncRenderCallback: ()=>{
                    contentsElement.classList.add("code-hover-contents");
                    this.layout();
                    // This changes the dimensions of the hover so trigger a layout
                    this._onRequestLayout.fire();
                }
            });
            contentsElement.appendChild(element);
        }
        rowElement.appendChild(contentsElement);
        this._hover.contentsDomNode.appendChild(rowElement);
        if (options.actions && options.actions.length > 0) {
            const statusBarElement = $("div.hover-row.status-bar");
            const actionsElement = $("div.actions");
            options.actions.forEach((action)=>{
                const keybinding = this._keybindingService.lookupKeybinding(action.commandId);
                const keybindingLabel = keybinding ? keybinding.getLabel() : null;
                (0, _hoverWidgetJs.HoverAction).render(actionsElement, {
                    label: action.label,
                    commandId: action.commandId,
                    run: (e)=>{
                        action.run(e);
                        this.dispose();
                    },
                    iconClass: action.iconClass
                }, keybindingLabel);
            });
            statusBarElement.appendChild(actionsElement);
            this._hover.containerDomNode.appendChild(statusBarElement);
        }
        this._hoverContainer = $("div.workbench-hover-container");
        if (this._hoverPointer) this._hoverContainer.appendChild(this._hoverPointer);
        this._hoverContainer.appendChild(this._hover.containerDomNode);
        // Determine whether to hide on hover
        let hideOnHover;
        if (options.actions && options.actions.length > 0) // If there are actions, require hover so they can be accessed
        hideOnHover = false;
        else if (options.persistence?.hideOnHover === undefined) // When unset, will default to true when it's a string or when it's markdown that
        // appears to have a link using a naive check for '](' and '</a>'
        hideOnHover = typeof options.content === "string" || (0, _htmlContentJs.isMarkdownString)(options.content) && !options.content.value.includes("](") && !options.content.value.includes("</a>");
        else // It's set explicitly
        hideOnHover = options.persistence.hideOnHover;
        // Show the hover hint if needed
        if (options.appearance?.showHoverHint) {
            const statusBarElement = $("div.hover-row.status-bar");
            const infoElement = $("div.info");
            infoElement.textContent = (0, _nlsJs.localize)("hoverhint", "Hold {0} key to mouse over", (0, _platformJs.isMacintosh) ? "Option" : "Alt");
            statusBarElement.appendChild(infoElement);
            this._hover.containerDomNode.appendChild(statusBarElement);
        }
        const mouseTrackerTargets = [
            ...this._target.targetElements
        ];
        if (!hideOnHover) mouseTrackerTargets.push(this._hoverContainer);
        const mouseTracker = this._register(new CompositeMouseTracker(mouseTrackerTargets));
        this._register(mouseTracker.onMouseOut(()=>{
            if (!this._isLocked) this.dispose();
        }));
        // Setup another mouse tracker when hideOnHover is set in order to track the hover as well
        // when it is locked. This ensures the hover will hide on mouseout after alt has been
        // released to unlock the element.
        if (hideOnHover) {
            const mouseTracker2Targets = [
                ...this._target.targetElements,
                this._hoverContainer
            ];
            this._lockMouseTracker = this._register(new CompositeMouseTracker(mouseTracker2Targets));
            this._register(this._lockMouseTracker.onMouseOut(()=>{
                if (!this._isLocked) this.dispose();
            }));
        } else this._lockMouseTracker = mouseTracker;
    }
    addFocusTrap() {
        if (!this._enableFocusTraps || this._addedFocusTrap) return;
        this._addedFocusTrap = true;
        // Add a hover tab loop if the hover has at least one element with a valid tabIndex
        const firstContainerFocusElement = this._hover.containerDomNode;
        const lastContainerFocusElement = this.findLastFocusableChild(this._hover.containerDomNode);
        if (lastContainerFocusElement) {
            const beforeContainerFocusElement = _domJs.prepend(this._hoverContainer, $("div"));
            const afterContainerFocusElement = _domJs.append(this._hoverContainer, $("div"));
            beforeContainerFocusElement.tabIndex = 0;
            afterContainerFocusElement.tabIndex = 0;
            this._register(_domJs.addDisposableListener(afterContainerFocusElement, "focus", (e)=>{
                firstContainerFocusElement.focus();
                e.preventDefault();
            }));
            this._register(_domJs.addDisposableListener(beforeContainerFocusElement, "focus", (e)=>{
                lastContainerFocusElement.focus();
                e.preventDefault();
            }));
        }
    }
    findLastFocusableChild(root) {
        if (root.hasChildNodes()) for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes.item(root.childNodes.length - i - 1);
            if (node.nodeType === node.ELEMENT_NODE) {
                const parsedNode = node;
                if (typeof parsedNode.tabIndex === "number" && parsedNode.tabIndex >= 0) return parsedNode;
            }
            const recursivelyFoundElement = this.findLastFocusableChild(node);
            if (recursivelyFoundElement) return recursivelyFoundElement;
        }
        return undefined;
    }
    render(container) {
        container.appendChild(this._hoverContainer);
        const hoverFocused = this._hoverContainer.contains(this._hoverContainer.ownerDocument.activeElement);
        const accessibleViewHint = hoverFocused && (0, _hoverWidgetJs.getHoverAccessibleViewHint)(this._configurationService.getValue("accessibility.verbosity.hover") === true && this._accessibilityService.isScreenReaderOptimized(), this._keybindingService.lookupKeybinding("editor.action.accessibleView")?.getAriaLabel());
        if (accessibleViewHint) (0, _ariaJs.status)(accessibleViewHint);
        this.layout();
        this.addFocusTrap();
    }
    layout() {
        this._hover.containerDomNode.classList.remove("right-aligned");
        this._hover.contentsDomNode.style.maxHeight = "";
        const getZoomAccountedBoundingClientRect = (e)=>{
            const zoom = _domJs.getDomNodeZoomLevel(e);
            const boundingRect = e.getBoundingClientRect();
            return {
                top: boundingRect.top * zoom,
                bottom: boundingRect.bottom * zoom,
                right: boundingRect.right * zoom,
                left: boundingRect.left * zoom
            };
        };
        const targetBounds = this._target.targetElements.map((e)=>getZoomAccountedBoundingClientRect(e));
        const { top, right, bottom, left } = targetBounds[0];
        const width = right - left;
        const height = bottom - top;
        const targetRect = {
            top,
            right,
            bottom,
            left,
            width,
            height,
            center: {
                x: left + width / 2,
                y: top + height / 2
            }
        };
        // These calls adjust the position depending on spacing.
        this.adjustHorizontalHoverPosition(targetRect);
        this.adjustVerticalHoverPosition(targetRect);
        // This call limits the maximum height of the hover.
        this.adjustHoverMaxHeight(targetRect);
        // Offset the hover position if there is a pointer so it aligns with the target element
        this._hoverContainer.style.padding = "";
        this._hoverContainer.style.margin = "";
        if (this._hoverPointer) {
            switch(this._hoverPosition){
                case 1 /* HoverPosition.RIGHT */ :
                    targetRect.left += 3 /* Constants.PointerSize */ ;
                    targetRect.right += 3 /* Constants.PointerSize */ ;
                    this._hoverContainer.style.paddingLeft = `${3 /* Constants.PointerSize */ }px`;
                    this._hoverContainer.style.marginLeft = `${-3 /* Constants.PointerSize */ }px`;
                    break;
                case 0 /* HoverPosition.LEFT */ :
                    targetRect.left -= 3 /* Constants.PointerSize */ ;
                    targetRect.right -= 3 /* Constants.PointerSize */ ;
                    this._hoverContainer.style.paddingRight = `${3 /* Constants.PointerSize */ }px`;
                    this._hoverContainer.style.marginRight = `${-3 /* Constants.PointerSize */ }px`;
                    break;
                case 2 /* HoverPosition.BELOW */ :
                    targetRect.top += 3 /* Constants.PointerSize */ ;
                    targetRect.bottom += 3 /* Constants.PointerSize */ ;
                    this._hoverContainer.style.paddingTop = `${3 /* Constants.PointerSize */ }px`;
                    this._hoverContainer.style.marginTop = `${-3 /* Constants.PointerSize */ }px`;
                    break;
                case 3 /* HoverPosition.ABOVE */ :
                    targetRect.top -= 3 /* Constants.PointerSize */ ;
                    targetRect.bottom -= 3 /* Constants.PointerSize */ ;
                    this._hoverContainer.style.paddingBottom = `${3 /* Constants.PointerSize */ }px`;
                    this._hoverContainer.style.marginBottom = `${-3 /* Constants.PointerSize */ }px`;
                    break;
            }
            targetRect.center.x = targetRect.left + width / 2;
            targetRect.center.y = targetRect.top + height / 2;
        }
        this.computeXCordinate(targetRect);
        this.computeYCordinate(targetRect);
        if (this._hoverPointer) {
            // reset
            this._hoverPointer.classList.remove("top");
            this._hoverPointer.classList.remove("left");
            this._hoverPointer.classList.remove("right");
            this._hoverPointer.classList.remove("bottom");
            this.setHoverPointerPosition(targetRect);
        }
        this._hover.onContentsChanged();
    }
    computeXCordinate(target) {
        const hoverWidth = this._hover.containerDomNode.clientWidth + 2 /* Constants.HoverBorderWidth */ ;
        if (this._target.x !== undefined) this._x = this._target.x;
        else if (this._hoverPosition === 1 /* HoverPosition.RIGHT */ ) this._x = target.right;
        else if (this._hoverPosition === 0 /* HoverPosition.LEFT */ ) this._x = target.left - hoverWidth;
        else {
            if (this._hoverPointer) this._x = target.center.x - this._hover.containerDomNode.clientWidth / 2;
            else this._x = target.left;
            // Hover is going beyond window towards right end
            if (this._x + hoverWidth >= this._targetDocumentElement.clientWidth) {
                this._hover.containerDomNode.classList.add("right-aligned");
                this._x = Math.max(this._targetDocumentElement.clientWidth - hoverWidth - 2 /* Constants.HoverWindowEdgeMargin */ , this._targetDocumentElement.clientLeft);
            }
        }
        // Hover is going beyond window towards left end
        if (this._x < this._targetDocumentElement.clientLeft) this._x = target.left + 2 /* Constants.HoverWindowEdgeMargin */ ;
    }
    computeYCordinate(target) {
        if (this._target.y !== undefined) this._y = this._target.y;
        else if (this._hoverPosition === 3 /* HoverPosition.ABOVE */ ) this._y = target.top;
        else if (this._hoverPosition === 2 /* HoverPosition.BELOW */ ) this._y = target.bottom - 2;
        else if (this._hoverPointer) this._y = target.center.y + this._hover.containerDomNode.clientHeight / 2;
        else this._y = target.bottom;
        // Hover on bottom is going beyond window
        if (this._y > this._targetWindow.innerHeight) this._y = target.bottom;
    }
    adjustHorizontalHoverPosition(target) {
        // Do not adjust horizontal hover position if x cordiante is provided
        if (this._target.x !== undefined) return;
        const hoverPointerOffset = this._hoverPointer ? 3 /* Constants.PointerSize */  : 0;
        // When force position is enabled, restrict max width
        if (this._forcePosition) {
            const padding = hoverPointerOffset + 2 /* Constants.HoverBorderWidth */ ;
            if (this._hoverPosition === 1 /* HoverPosition.RIGHT */ ) this._hover.containerDomNode.style.maxWidth = `${this._targetDocumentElement.clientWidth - target.right - padding}px`;
            else if (this._hoverPosition === 0 /* HoverPosition.LEFT */ ) this._hover.containerDomNode.style.maxWidth = `${target.left - padding}px`;
            return;
        }
        // Position hover on right to target
        if (this._hoverPosition === 1 /* HoverPosition.RIGHT */ ) {
            const roomOnRight = this._targetDocumentElement.clientWidth - target.right;
            // Hover on the right is going beyond window.
            if (roomOnRight < this._hover.containerDomNode.clientWidth + hoverPointerOffset) {
                const roomOnLeft = target.left;
                // There's enough room on the left, flip the hover position
                if (roomOnLeft >= this._hover.containerDomNode.clientWidth + hoverPointerOffset) this._hoverPosition = 0 /* HoverPosition.LEFT */ ;
                else this._hoverPosition = 2 /* HoverPosition.BELOW */ ;
            }
        } else if (this._hoverPosition === 0 /* HoverPosition.LEFT */ ) {
            const roomOnLeft = target.left;
            // Hover on the left is going beyond window.
            if (roomOnLeft < this._hover.containerDomNode.clientWidth + hoverPointerOffset) {
                const roomOnRight = this._targetDocumentElement.clientWidth - target.right;
                // There's enough room on the right, flip the hover position
                if (roomOnRight >= this._hover.containerDomNode.clientWidth + hoverPointerOffset) this._hoverPosition = 1 /* HoverPosition.RIGHT */ ;
                else this._hoverPosition = 2 /* HoverPosition.BELOW */ ;
            }
            // Hover on the left is going beyond window.
            if (target.left - this._hover.containerDomNode.clientWidth - hoverPointerOffset <= this._targetDocumentElement.clientLeft) this._hoverPosition = 1 /* HoverPosition.RIGHT */ ;
        }
    }
    adjustVerticalHoverPosition(target) {
        // Do not adjust vertical hover position if the y coordinate is provided
        // or the position is forced
        if (this._target.y !== undefined || this._forcePosition) return;
        const hoverPointerOffset = this._hoverPointer ? 3 /* Constants.PointerSize */  : 0;
        // Position hover on top of the target
        if (this._hoverPosition === 3 /* HoverPosition.ABOVE */ ) // Hover on top is going beyond window
        {
            if (target.top - this._hover.containerDomNode.clientHeight - hoverPointerOffset < 0) this._hoverPosition = 2 /* HoverPosition.BELOW */ ;
        } else if (this._hoverPosition === 2 /* HoverPosition.BELOW */ ) // Hover on bottom is going beyond window
        {
            if (target.bottom + this._hover.containerDomNode.clientHeight + hoverPointerOffset > this._targetWindow.innerHeight) this._hoverPosition = 3 /* HoverPosition.ABOVE */ ;
        }
    }
    adjustHoverMaxHeight(target) {
        let maxHeight = this._targetWindow.innerHeight / 2;
        // When force position is enabled, restrict max height
        if (this._forcePosition) {
            const padding = (this._hoverPointer ? 3 /* Constants.PointerSize */  : 0) + 2 /* Constants.HoverBorderWidth */ ;
            if (this._hoverPosition === 3 /* HoverPosition.ABOVE */ ) maxHeight = Math.min(maxHeight, target.top - padding);
            else if (this._hoverPosition === 2 /* HoverPosition.BELOW */ ) maxHeight = Math.min(maxHeight, this._targetWindow.innerHeight - target.bottom - padding);
        }
        this._hover.containerDomNode.style.maxHeight = `${maxHeight}px`;
        if (this._hover.contentsDomNode.clientHeight < this._hover.contentsDomNode.scrollHeight) {
            // Add padding for a vertical scrollbar
            const extraRightPadding = `${this._hover.scrollbar.options.verticalScrollbarSize}px`;
            if (this._hover.contentsDomNode.style.paddingRight !== extraRightPadding) this._hover.contentsDomNode.style.paddingRight = extraRightPadding;
        }
    }
    setHoverPointerPosition(target) {
        if (!this._hoverPointer) return;
        switch(this._hoverPosition){
            case 0 /* HoverPosition.LEFT */ :
            case 1 /* HoverPosition.RIGHT */ :
                {
                    this._hoverPointer.classList.add(this._hoverPosition === 0 /* HoverPosition.LEFT */  ? "right" : "left");
                    const hoverHeight = this._hover.containerDomNode.clientHeight;
                    // If hover is taller than target, then show the pointer at the center of target
                    if (hoverHeight > target.height) this._hoverPointer.style.top = `${target.center.y - (this._y - hoverHeight) - 3 /* Constants.PointerSize */ }px`;
                    else this._hoverPointer.style.top = `${Math.round(hoverHeight / 2) - 3 /* Constants.PointerSize */ }px`;
                    break;
                }
            case 3 /* HoverPosition.ABOVE */ :
            case 2 /* HoverPosition.BELOW */ :
                {
                    this._hoverPointer.classList.add(this._hoverPosition === 3 /* HoverPosition.ABOVE */  ? "bottom" : "top");
                    const hoverWidth = this._hover.containerDomNode.clientWidth;
                    // Position pointer at the center of the hover
                    let pointerLeftPosition = Math.round(hoverWidth / 2) - 3 /* Constants.PointerSize */ ;
                    // If pointer goes beyond target then position it at the center of the target
                    const pointerX = this._x + pointerLeftPosition;
                    if (pointerX < target.left || pointerX > target.right) pointerLeftPosition = target.center.x - this._x - 3 /* Constants.PointerSize */ ;
                    this._hoverPointer.style.left = `${pointerLeftPosition}px`;
                    break;
                }
        }
    }
    focus() {
        this._hover.containerDomNode.focus();
    }
    dispose() {
        if (!this._isDisposed) {
            this._onDispose.fire();
            this._hoverContainer.remove();
            this._messageListeners.dispose();
            this._target.dispose();
            super.dispose();
        }
        this._isDisposed = true;
    }
};
HoverWidget = __decorate([
    __param(1, (0, _keybindingJs.IKeybindingService)),
    __param(2, (0, _configurationJs.IConfigurationService)),
    __param(3, (0, _openerJs.IOpenerService)),
    __param(4, (0, _instantiationJs.IInstantiationService)),
    __param(5, (0, _accessibilityJs.IAccessibilityService))
], HoverWidget);
class CompositeMouseTracker extends (0, _widgetJs.Widget) {
    get onMouseOut() {
        return this._onMouseOut.event;
    }
    get isMouseIn() {
        return this._isMouseIn;
    }
    constructor(_elements){
        super();
        this._elements = _elements;
        this._isMouseIn = true;
        this._onMouseOut = this._register(new (0, _eventJs.Emitter)());
        this._elements.forEach((n)=>this.onmouseover(n, ()=>this._onTargetMouseOver(n)));
        this._elements.forEach((n)=>this.onmouseleave(n, ()=>this._onTargetMouseLeave(n)));
    }
    _onTargetMouseOver(target) {
        this._isMouseIn = true;
        this._clearEvaluateMouseStateTimeout(target);
    }
    _onTargetMouseLeave(target) {
        this._isMouseIn = false;
        this._evaluateMouseState(target);
    }
    _evaluateMouseState(target) {
        this._clearEvaluateMouseStateTimeout(target);
        // Evaluate whether the mouse is still outside asynchronously such that other mouse targets
        // have the opportunity to first their mouse in event.
        this._mouseTimeout = _domJs.getWindow(target).setTimeout(()=>this._fireIfMouseOutside(), 0);
    }
    _clearEvaluateMouseStateTimeout(target) {
        if (this._mouseTimeout) {
            _domJs.getWindow(target).clearTimeout(this._mouseTimeout);
            this._mouseTimeout = undefined;
        }
    }
    _fireIfMouseOutside() {
        if (!this._isMouseIn) this._onMouseOut.fire();
    }
}
class ElementHoverTarget {
    constructor(_element){
        this._element = _element;
        this.targetElements = [
            this._element
        ];
    }
    dispose() {}
}

},{"./hover.css":"groWp","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/event.js":"4Zi8b","../../../../base/browser/dom.js":"bnqsM","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../common/config/editorOptions.js":"3Xi00","../../../../base/browser/ui/hover/hoverWidget.js":"5eWDy","../../../../base/browser/ui/widget.js":"kM4DP","../../../../platform/opener/common/opener.js":"d3tj1","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../widget/markdownRenderer/browser/markdownRenderer.js":"34xfZ","../../../../base/common/htmlContent.js":"3Hxzm","../../../../nls.js":"l617d","../../../../base/common/platform.js":"7maJO","../../../../platform/accessibility/common/accessibility.js":"9Svqy","../../../../base/browser/ui/aria/aria.js":"asrsh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"groWp":[function() {},{}],"25pLT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IKeybindingService", ()=>IKeybindingService);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IKeybindingService = (0, _instantiationJs.createDecorator)("keybindingService");

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5eWDy":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverWidget", ()=>HoverWidget);
parcelHelpers.export(exports, "HoverAction", ()=>HoverAction);
parcelHelpers.export(exports, "getHoverAccessibleViewHint", ()=>getHoverAccessibleViewHint);
parcelHelpers.export(exports, "ClickAction", ()=>ClickAction);
parcelHelpers.export(exports, "KeyDownAction", ()=>KeyDownAction);
var _domJs = require("../../dom.js");
var _keyboardEventJs = require("../../keyboardEvent.js");
var _scrollableElementJs = require("../scrollbar/scrollableElement.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _hoverWidgetCss = require("./hoverWidget.css");
var _nlsJs = require("../../../../nls.js");
const $ = _domJs.$;
class HoverWidget extends (0, _lifecycleJs.Disposable) {
    constructor(){
        super();
        this.containerDomNode = document.createElement("div");
        this.containerDomNode.className = "monaco-hover";
        this.containerDomNode.tabIndex = 0;
        this.containerDomNode.setAttribute("role", "tooltip");
        this.contentsDomNode = document.createElement("div");
        this.contentsDomNode.className = "monaco-hover-content";
        this.scrollbar = this._register(new (0, _scrollableElementJs.DomScrollableElement)(this.contentsDomNode, {
            consumeMouseWheelIfScrollbarIsNeeded: true
        }));
        this.containerDomNode.appendChild(this.scrollbar.getDomNode());
    }
    onContentsChanged() {
        this.scrollbar.scanDomNode();
    }
}
class HoverAction extends (0, _lifecycleJs.Disposable) {
    static render(parent, actionOptions, keybindingLabel) {
        return new HoverAction(parent, actionOptions, keybindingLabel);
    }
    constructor(parent, actionOptions, keybindingLabel){
        super();
        this.actionLabel = actionOptions.label;
        this.actionKeybindingLabel = keybindingLabel;
        this.actionContainer = _domJs.append(parent, $("div.action-container"));
        this.actionContainer.setAttribute("tabindex", "0");
        this.action = _domJs.append(this.actionContainer, $("a.action"));
        this.action.setAttribute("role", "button");
        if (actionOptions.iconClass) _domJs.append(this.action, $(`span.icon.${actionOptions.iconClass}`));
        const label = _domJs.append(this.action, $("span"));
        label.textContent = keybindingLabel ? `${actionOptions.label} (${keybindingLabel})` : actionOptions.label;
        this._store.add(new ClickAction(this.actionContainer, actionOptions.run));
        this._store.add(new KeyDownAction(this.actionContainer, actionOptions.run, [
            3 /* KeyCode.Enter */ ,
            10 /* KeyCode.Space */ 
        ]));
        this.setEnabled(true);
    }
    setEnabled(enabled) {
        if (enabled) {
            this.actionContainer.classList.remove("disabled");
            this.actionContainer.removeAttribute("aria-disabled");
        } else {
            this.actionContainer.classList.add("disabled");
            this.actionContainer.setAttribute("aria-disabled", "true");
        }
    }
}
function getHoverAccessibleViewHint(shouldHaveHint, keybinding) {
    return shouldHaveHint && keybinding ? (0, _nlsJs.localize)("acessibleViewHint", "Inspect this in the accessible view with {0}.", keybinding) : shouldHaveHint ? (0, _nlsJs.localize)("acessibleViewHintNoKbOpen", "Inspect this in the accessible view via the command Open Accessible View which is currently not triggerable via keybinding.") : "";
}
class ClickAction extends (0, _lifecycleJs.Disposable) {
    constructor(container, run){
        super();
        this._register(_domJs.addDisposableListener(container, _domJs.EventType.CLICK, (e)=>{
            e.stopPropagation();
            e.preventDefault();
            run(container);
        }));
    }
}
class KeyDownAction extends (0, _lifecycleJs.Disposable) {
    constructor(container, run, keyCodes){
        super();
        this._register(_domJs.addDisposableListener(container, _domJs.EventType.KEY_DOWN, (e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            if (keyCodes.some((keyCode)=>event.equals(keyCode))) {
                e.stopPropagation();
                e.preventDefault();
                run(container);
            }
        }));
    }
}

},{"../../dom.js":"bnqsM","../../keyboardEvent.js":"bxU9U","../scrollbar/scrollableElement.js":"h1C5l","../../../common/lifecycle.js":"9kg8d","./hoverWidget.css":"jYBFi","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h1C5l":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MouseWheelClassifier", ()=>MouseWheelClassifier);
parcelHelpers.export(exports, "AbstractScrollableElement", ()=>AbstractScrollableElement);
parcelHelpers.export(exports, "ScrollableElement", ()=>ScrollableElement);
parcelHelpers.export(exports, "SmoothScrollableElement", ()=>SmoothScrollableElement);
parcelHelpers.export(exports, "DomScrollableElement", ()=>DomScrollableElement);
var _browserJs = require("../../browser.js");
var _domJs = require("../../dom.js");
var _fastDomNodeJs = require("../../fastDomNode.js");
var _mouseEventJs = require("../../mouseEvent.js");
var _horizontalScrollbarJs = require("./horizontalScrollbar.js");
var _verticalScrollbarJs = require("./verticalScrollbar.js");
var _widgetJs = require("../widget.js");
var _asyncJs = require("../../../common/async.js");
var _eventJs = require("../../../common/event.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _platformJs = require("../../../common/platform.js");
var _scrollableJs = require("../../../common/scrollable.js");
var _scrollbarsCss = require("./media/scrollbars.css");
const HIDE_TIMEOUT = 500;
const SCROLL_WHEEL_SENSITIVITY = 50;
const SCROLL_WHEEL_SMOOTH_SCROLL_ENABLED = true;
class MouseWheelClassifierItem {
    constructor(timestamp, deltaX, deltaY){
        this.timestamp = timestamp;
        this.deltaX = deltaX;
        this.deltaY = deltaY;
        this.score = 0;
    }
}
class MouseWheelClassifier {
    static{
        this.INSTANCE = new MouseWheelClassifier();
    }
    constructor(){
        this._capacity = 5;
        this._memory = [];
        this._front = -1;
        this._rear = -1;
    }
    isPhysicalMouseWheel() {
        if (this._front === -1 && this._rear === -1) // no elements
        return false;
        // 0.5 * last + 0.25 * 2nd last + 0.125 * 3rd last + ...
        let remainingInfluence = 1;
        let score = 0;
        let iteration = 1;
        let index = this._rear;
        do {
            const influence = index === this._front ? remainingInfluence : Math.pow(2, -iteration);
            remainingInfluence -= influence;
            score += this._memory[index].score * influence;
            if (index === this._front) break;
            index = (this._capacity + index - 1) % this._capacity;
            iteration++;
        }while (true);
        return score <= 0.5;
    }
    acceptStandardWheelEvent(e) {
        if (0, _browserJs.isChrome) {
            const targetWindow = _domJs.getWindow(e.browserEvent);
            const pageZoomFactor = (0, _browserJs.getZoomFactor)(targetWindow);
            // On Chrome, the incoming delta events are multiplied with the OS zoom factor.
            // The OS zoom factor can be reverse engineered by using the device pixel ratio and the configured zoom factor into account.
            this.accept(Date.now(), e.deltaX * pageZoomFactor, e.deltaY * pageZoomFactor);
        } else this.accept(Date.now(), e.deltaX, e.deltaY);
    }
    accept(timestamp, deltaX, deltaY) {
        let previousItem = null;
        const item = new MouseWheelClassifierItem(timestamp, deltaX, deltaY);
        if (this._front === -1 && this._rear === -1) {
            this._memory[0] = item;
            this._front = 0;
            this._rear = 0;
        } else {
            previousItem = this._memory[this._rear];
            this._rear = (this._rear + 1) % this._capacity;
            if (this._rear === this._front) // Drop oldest
            this._front = (this._front + 1) % this._capacity;
            this._memory[this._rear] = item;
        }
        item.score = this._computeScore(item, previousItem);
    }
    /**
     * A score between 0 and 1 for `item`.
     *  - a score towards 0 indicates that the source appears to be a physical mouse wheel
     *  - a score towards 1 indicates that the source appears to be a touchpad or magic mouse, etc.
     */ _computeScore(item, previousItem) {
        if (Math.abs(item.deltaX) > 0 && Math.abs(item.deltaY) > 0) // both axes exercised => definitely not a physical mouse wheel
        return 1;
        let score = 0.5;
        if (!this._isAlmostInt(item.deltaX) || !this._isAlmostInt(item.deltaY)) // non-integer deltas => indicator that this is not a physical mouse wheel
        score += 0.25;
        // Non-accelerating scroll => indicator that this is a physical mouse wheel
        // These can be identified by seeing whether they are the module of one another.
        if (previousItem) {
            const absDeltaX = Math.abs(item.deltaX);
            const absDeltaY = Math.abs(item.deltaY);
            const absPreviousDeltaX = Math.abs(previousItem.deltaX);
            const absPreviousDeltaY = Math.abs(previousItem.deltaY);
            // Min 1 to avoid division by zero, module 1 will still be 0.
            const minDeltaX = Math.max(Math.min(absDeltaX, absPreviousDeltaX), 1);
            const minDeltaY = Math.max(Math.min(absDeltaY, absPreviousDeltaY), 1);
            const maxDeltaX = Math.max(absDeltaX, absPreviousDeltaX);
            const maxDeltaY = Math.max(absDeltaY, absPreviousDeltaY);
            const isSameModulo = maxDeltaX % minDeltaX === 0 && maxDeltaY % minDeltaY === 0;
            if (isSameModulo) score -= 0.5;
        }
        return Math.min(Math.max(score, 0), 1);
    }
    _isAlmostInt(value) {
        const delta = Math.abs(Math.round(value) - value);
        return delta < 0.01;
    }
}
class AbstractScrollableElement extends (0, _widgetJs.Widget) {
    get options() {
        return this._options;
    }
    constructor(element, options, scrollable){
        super();
        this._onScroll = this._register(new (0, _eventJs.Emitter)());
        this.onScroll = this._onScroll.event;
        this._onWillScroll = this._register(new (0, _eventJs.Emitter)());
        element.style.overflow = "hidden";
        this._options = resolveOptions(options);
        this._scrollable = scrollable;
        this._register(this._scrollable.onScroll((e)=>{
            this._onWillScroll.fire(e);
            this._onDidScroll(e);
            this._onScroll.fire(e);
        }));
        const scrollbarHost = {
            onMouseWheel: (mouseWheelEvent)=>this._onMouseWheel(mouseWheelEvent),
            onDragStart: ()=>this._onDragStart(),
            onDragEnd: ()=>this._onDragEnd()
        };
        this._verticalScrollbar = this._register(new (0, _verticalScrollbarJs.VerticalScrollbar)(this._scrollable, this._options, scrollbarHost));
        this._horizontalScrollbar = this._register(new (0, _horizontalScrollbarJs.HorizontalScrollbar)(this._scrollable, this._options, scrollbarHost));
        this._domNode = document.createElement("div");
        this._domNode.className = "monaco-scrollable-element " + this._options.className;
        this._domNode.setAttribute("role", "presentation");
        this._domNode.style.position = "relative";
        this._domNode.style.overflow = "hidden";
        this._domNode.appendChild(element);
        this._domNode.appendChild(this._horizontalScrollbar.domNode.domNode);
        this._domNode.appendChild(this._verticalScrollbar.domNode.domNode);
        if (this._options.useShadows) {
            this._leftShadowDomNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
            this._leftShadowDomNode.setClassName("shadow");
            this._domNode.appendChild(this._leftShadowDomNode.domNode);
            this._topShadowDomNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
            this._topShadowDomNode.setClassName("shadow");
            this._domNode.appendChild(this._topShadowDomNode.domNode);
            this._topLeftShadowDomNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
            this._topLeftShadowDomNode.setClassName("shadow");
            this._domNode.appendChild(this._topLeftShadowDomNode.domNode);
        } else {
            this._leftShadowDomNode = null;
            this._topShadowDomNode = null;
            this._topLeftShadowDomNode = null;
        }
        this._listenOnDomNode = this._options.listenOnDomNode || this._domNode;
        this._mouseWheelToDispose = [];
        this._setListeningToMouseWheel(this._options.handleMouseWheel);
        this.onmouseover(this._listenOnDomNode, (e)=>this._onMouseOver(e));
        this.onmouseleave(this._listenOnDomNode, (e)=>this._onMouseLeave(e));
        this._hideTimeout = this._register(new (0, _asyncJs.TimeoutTimer)());
        this._isDragging = false;
        this._mouseIsOver = false;
        this._shouldRender = true;
        this._revealOnScroll = true;
    }
    dispose() {
        this._mouseWheelToDispose = (0, _lifecycleJs.dispose)(this._mouseWheelToDispose);
        super.dispose();
    }
    /**
     * Get the generated 'scrollable' dom node
     */ getDomNode() {
        return this._domNode;
    }
    getOverviewRulerLayoutInfo() {
        return {
            parent: this._domNode,
            insertBefore: this._verticalScrollbar.domNode.domNode
        };
    }
    /**
     * Delegate a pointer down event to the vertical scrollbar.
     * This is to help with clicking somewhere else and having the scrollbar react.
     */ delegateVerticalScrollbarPointerDown(browserEvent) {
        this._verticalScrollbar.delegatePointerDown(browserEvent);
    }
    getScrollDimensions() {
        return this._scrollable.getScrollDimensions();
    }
    setScrollDimensions(dimensions) {
        this._scrollable.setScrollDimensions(dimensions, false);
    }
    /**
     * Update the class name of the scrollable element.
     */ updateClassName(newClassName) {
        this._options.className = newClassName;
        // Defaults are different on Macs
        if (_platformJs.isMacintosh) this._options.className += " mac";
        this._domNode.className = "monaco-scrollable-element " + this._options.className;
    }
    /**
     * Update configuration options for the scrollbar.
     */ updateOptions(newOptions) {
        if (typeof newOptions.handleMouseWheel !== "undefined") {
            this._options.handleMouseWheel = newOptions.handleMouseWheel;
            this._setListeningToMouseWheel(this._options.handleMouseWheel);
        }
        if (typeof newOptions.mouseWheelScrollSensitivity !== "undefined") this._options.mouseWheelScrollSensitivity = newOptions.mouseWheelScrollSensitivity;
        if (typeof newOptions.fastScrollSensitivity !== "undefined") this._options.fastScrollSensitivity = newOptions.fastScrollSensitivity;
        if (typeof newOptions.scrollPredominantAxis !== "undefined") this._options.scrollPredominantAxis = newOptions.scrollPredominantAxis;
        if (typeof newOptions.horizontal !== "undefined") this._options.horizontal = newOptions.horizontal;
        if (typeof newOptions.vertical !== "undefined") this._options.vertical = newOptions.vertical;
        if (typeof newOptions.horizontalScrollbarSize !== "undefined") this._options.horizontalScrollbarSize = newOptions.horizontalScrollbarSize;
        if (typeof newOptions.verticalScrollbarSize !== "undefined") this._options.verticalScrollbarSize = newOptions.verticalScrollbarSize;
        if (typeof newOptions.scrollByPage !== "undefined") this._options.scrollByPage = newOptions.scrollByPage;
        this._horizontalScrollbar.updateOptions(this._options);
        this._verticalScrollbar.updateOptions(this._options);
        if (!this._options.lazyRender) this._render();
    }
    delegateScrollFromMouseWheelEvent(browserEvent) {
        this._onMouseWheel(new (0, _mouseEventJs.StandardWheelEvent)(browserEvent));
    }
    // -------------------- mouse wheel scrolling --------------------
    _setListeningToMouseWheel(shouldListen) {
        const isListening = this._mouseWheelToDispose.length > 0;
        if (isListening === shouldListen) // No change
        return;
        // Stop listening (if necessary)
        this._mouseWheelToDispose = (0, _lifecycleJs.dispose)(this._mouseWheelToDispose);
        // Start listening (if necessary)
        if (shouldListen) {
            const onMouseWheel = (browserEvent)=>{
                this._onMouseWheel(new (0, _mouseEventJs.StandardWheelEvent)(browserEvent));
            };
            this._mouseWheelToDispose.push(_domJs.addDisposableListener(this._listenOnDomNode, _domJs.EventType.MOUSE_WHEEL, onMouseWheel, {
                passive: false
            }));
        }
    }
    _onMouseWheel(e) {
        if (e.browserEvent?.defaultPrevented) return;
        const classifier = MouseWheelClassifier.INSTANCE;
        if (SCROLL_WHEEL_SMOOTH_SCROLL_ENABLED) classifier.acceptStandardWheelEvent(e);
        // useful for creating unit tests:
        // console.log(`${Date.now()}, ${e.deltaY}, ${e.deltaX}`);
        let didScroll = false;
        if (e.deltaY || e.deltaX) {
            let deltaY = e.deltaY * this._options.mouseWheelScrollSensitivity;
            let deltaX = e.deltaX * this._options.mouseWheelScrollSensitivity;
            if (this._options.scrollPredominantAxis) {
                if (this._options.scrollYToX && deltaX + deltaY === 0) // when configured to map Y to X and we both see
                // no dominant axis and X and Y are competing with
                // identical values into opposite directions, we
                // ignore the delta as we cannot make a decision then
                deltaX = deltaY = 0;
                else if (Math.abs(deltaY) >= Math.abs(deltaX)) deltaX = 0;
                else deltaY = 0;
            }
            if (this._options.flipAxes) [deltaY, deltaX] = [
                deltaX,
                deltaY
            ];
            // Convert vertical scrolling to horizontal if shift is held, this
            // is handled at a higher level on Mac
            const shiftConvert = !_platformJs.isMacintosh && e.browserEvent && e.browserEvent.shiftKey;
            if ((this._options.scrollYToX || shiftConvert) && !deltaX) {
                deltaX = deltaY;
                deltaY = 0;
            }
            if (e.browserEvent && e.browserEvent.altKey) {
                // fastScrolling
                deltaX = deltaX * this._options.fastScrollSensitivity;
                deltaY = deltaY * this._options.fastScrollSensitivity;
            }
            const futureScrollPosition = this._scrollable.getFutureScrollPosition();
            let desiredScrollPosition = {};
            if (deltaY) {
                const deltaScrollTop = SCROLL_WHEEL_SENSITIVITY * deltaY;
                // Here we convert values such as -0.3 to -1 or 0.3 to 1, otherwise low speed scrolling will never scroll
                const desiredScrollTop = futureScrollPosition.scrollTop - (deltaScrollTop < 0 ? Math.floor(deltaScrollTop) : Math.ceil(deltaScrollTop));
                this._verticalScrollbar.writeScrollPosition(desiredScrollPosition, desiredScrollTop);
            }
            if (deltaX) {
                const deltaScrollLeft = SCROLL_WHEEL_SENSITIVITY * deltaX;
                // Here we convert values such as -0.3 to -1 or 0.3 to 1, otherwise low speed scrolling will never scroll
                const desiredScrollLeft = futureScrollPosition.scrollLeft - (deltaScrollLeft < 0 ? Math.floor(deltaScrollLeft) : Math.ceil(deltaScrollLeft));
                this._horizontalScrollbar.writeScrollPosition(desiredScrollPosition, desiredScrollLeft);
            }
            // Check that we are scrolling towards a location which is valid
            desiredScrollPosition = this._scrollable.validateScrollPosition(desiredScrollPosition);
            if (futureScrollPosition.scrollLeft !== desiredScrollPosition.scrollLeft || futureScrollPosition.scrollTop !== desiredScrollPosition.scrollTop) {
                const canPerformSmoothScroll = SCROLL_WHEEL_SMOOTH_SCROLL_ENABLED && this._options.mouseWheelSmoothScroll && classifier.isPhysicalMouseWheel();
                if (canPerformSmoothScroll) this._scrollable.setScrollPositionSmooth(desiredScrollPosition);
                else this._scrollable.setScrollPositionNow(desiredScrollPosition);
                didScroll = true;
            }
        }
        let consumeMouseWheel = didScroll;
        if (!consumeMouseWheel && this._options.alwaysConsumeMouseWheel) consumeMouseWheel = true;
        if (!consumeMouseWheel && this._options.consumeMouseWheelIfScrollbarIsNeeded && (this._verticalScrollbar.isNeeded() || this._horizontalScrollbar.isNeeded())) consumeMouseWheel = true;
        if (consumeMouseWheel) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    _onDidScroll(e) {
        this._shouldRender = this._horizontalScrollbar.onDidScroll(e) || this._shouldRender;
        this._shouldRender = this._verticalScrollbar.onDidScroll(e) || this._shouldRender;
        if (this._options.useShadows) this._shouldRender = true;
        if (this._revealOnScroll) this._reveal();
        if (!this._options.lazyRender) this._render();
    }
    /**
     * Render / mutate the DOM now.
     * Should be used together with the ctor option `lazyRender`.
     */ renderNow() {
        if (!this._options.lazyRender) throw new Error("Please use `lazyRender` together with `renderNow`!");
        this._render();
    }
    _render() {
        if (!this._shouldRender) return;
        this._shouldRender = false;
        this._horizontalScrollbar.render();
        this._verticalScrollbar.render();
        if (this._options.useShadows) {
            const scrollState = this._scrollable.getCurrentScrollPosition();
            const enableTop = scrollState.scrollTop > 0;
            const enableLeft = scrollState.scrollLeft > 0;
            const leftClassName = enableLeft ? " left" : "";
            const topClassName = enableTop ? " top" : "";
            const topLeftClassName = enableLeft || enableTop ? " top-left-corner" : "";
            this._leftShadowDomNode.setClassName(`shadow${leftClassName}`);
            this._topShadowDomNode.setClassName(`shadow${topClassName}`);
            this._topLeftShadowDomNode.setClassName(`shadow${topLeftClassName}${topClassName}${leftClassName}`);
        }
    }
    // -------------------- fade in / fade out --------------------
    _onDragStart() {
        this._isDragging = true;
        this._reveal();
    }
    _onDragEnd() {
        this._isDragging = false;
        this._hide();
    }
    _onMouseLeave(e) {
        this._mouseIsOver = false;
        this._hide();
    }
    _onMouseOver(e) {
        this._mouseIsOver = true;
        this._reveal();
    }
    _reveal() {
        this._verticalScrollbar.beginReveal();
        this._horizontalScrollbar.beginReveal();
        this._scheduleHide();
    }
    _hide() {
        if (!this._mouseIsOver && !this._isDragging) {
            this._verticalScrollbar.beginHide();
            this._horizontalScrollbar.beginHide();
        }
    }
    _scheduleHide() {
        if (!this._mouseIsOver && !this._isDragging) this._hideTimeout.cancelAndSet(()=>this._hide(), HIDE_TIMEOUT);
    }
}
class ScrollableElement extends AbstractScrollableElement {
    constructor(element, options){
        options = options || {};
        options.mouseWheelSmoothScroll = false;
        const scrollable = new (0, _scrollableJs.Scrollable)({
            forceIntegerValues: true,
            smoothScrollDuration: 0,
            scheduleAtNextAnimationFrame: (callback)=>_domJs.scheduleAtNextAnimationFrame(_domJs.getWindow(element), callback)
        });
        super(element, options, scrollable);
        this._register(scrollable);
    }
    setScrollPosition(update) {
        this._scrollable.setScrollPositionNow(update);
    }
}
class SmoothScrollableElement extends AbstractScrollableElement {
    constructor(element, options, scrollable){
        super(element, options, scrollable);
    }
    setScrollPosition(update) {
        if (update.reuseAnimation) this._scrollable.setScrollPositionSmooth(update, update.reuseAnimation);
        else this._scrollable.setScrollPositionNow(update);
    }
    getScrollPosition() {
        return this._scrollable.getCurrentScrollPosition();
    }
}
class DomScrollableElement extends AbstractScrollableElement {
    constructor(element, options){
        options = options || {};
        options.mouseWheelSmoothScroll = false;
        const scrollable = new (0, _scrollableJs.Scrollable)({
            forceIntegerValues: false,
            smoothScrollDuration: 0,
            scheduleAtNextAnimationFrame: (callback)=>_domJs.scheduleAtNextAnimationFrame(_domJs.getWindow(element), callback)
        });
        super(element, options, scrollable);
        this._register(scrollable);
        this._element = element;
        this._register(this.onScroll((e)=>{
            if (e.scrollTopChanged) this._element.scrollTop = e.scrollTop;
            if (e.scrollLeftChanged) this._element.scrollLeft = e.scrollLeft;
        }));
        this.scanDomNode();
    }
    setScrollPosition(update) {
        this._scrollable.setScrollPositionNow(update);
    }
    getScrollPosition() {
        return this._scrollable.getCurrentScrollPosition();
    }
    scanDomNode() {
        // width, scrollLeft, scrollWidth, height, scrollTop, scrollHeight
        this.setScrollDimensions({
            width: this._element.clientWidth,
            scrollWidth: this._element.scrollWidth,
            height: this._element.clientHeight,
            scrollHeight: this._element.scrollHeight
        });
        this.setScrollPosition({
            scrollLeft: this._element.scrollLeft,
            scrollTop: this._element.scrollTop
        });
    }
}
function resolveOptions(opts) {
    const result = {
        lazyRender: typeof opts.lazyRender !== "undefined" ? opts.lazyRender : false,
        className: typeof opts.className !== "undefined" ? opts.className : "",
        useShadows: typeof opts.useShadows !== "undefined" ? opts.useShadows : true,
        handleMouseWheel: typeof opts.handleMouseWheel !== "undefined" ? opts.handleMouseWheel : true,
        flipAxes: typeof opts.flipAxes !== "undefined" ? opts.flipAxes : false,
        consumeMouseWheelIfScrollbarIsNeeded: typeof opts.consumeMouseWheelIfScrollbarIsNeeded !== "undefined" ? opts.consumeMouseWheelIfScrollbarIsNeeded : false,
        alwaysConsumeMouseWheel: typeof opts.alwaysConsumeMouseWheel !== "undefined" ? opts.alwaysConsumeMouseWheel : false,
        scrollYToX: typeof opts.scrollYToX !== "undefined" ? opts.scrollYToX : false,
        mouseWheelScrollSensitivity: typeof opts.mouseWheelScrollSensitivity !== "undefined" ? opts.mouseWheelScrollSensitivity : 1,
        fastScrollSensitivity: typeof opts.fastScrollSensitivity !== "undefined" ? opts.fastScrollSensitivity : 5,
        scrollPredominantAxis: typeof opts.scrollPredominantAxis !== "undefined" ? opts.scrollPredominantAxis : true,
        mouseWheelSmoothScroll: typeof opts.mouseWheelSmoothScroll !== "undefined" ? opts.mouseWheelSmoothScroll : true,
        arrowSize: typeof opts.arrowSize !== "undefined" ? opts.arrowSize : 11,
        listenOnDomNode: typeof opts.listenOnDomNode !== "undefined" ? opts.listenOnDomNode : null,
        horizontal: typeof opts.horizontal !== "undefined" ? opts.horizontal : 1 /* ScrollbarVisibility.Auto */ ,
        horizontalScrollbarSize: typeof opts.horizontalScrollbarSize !== "undefined" ? opts.horizontalScrollbarSize : 10,
        horizontalSliderSize: typeof opts.horizontalSliderSize !== "undefined" ? opts.horizontalSliderSize : 0,
        horizontalHasArrows: typeof opts.horizontalHasArrows !== "undefined" ? opts.horizontalHasArrows : false,
        vertical: typeof opts.vertical !== "undefined" ? opts.vertical : 1 /* ScrollbarVisibility.Auto */ ,
        verticalScrollbarSize: typeof opts.verticalScrollbarSize !== "undefined" ? opts.verticalScrollbarSize : 10,
        verticalHasArrows: typeof opts.verticalHasArrows !== "undefined" ? opts.verticalHasArrows : false,
        verticalSliderSize: typeof opts.verticalSliderSize !== "undefined" ? opts.verticalSliderSize : 0,
        scrollByPage: typeof opts.scrollByPage !== "undefined" ? opts.scrollByPage : false
    };
    result.horizontalSliderSize = typeof opts.horizontalSliderSize !== "undefined" ? opts.horizontalSliderSize : result.horizontalScrollbarSize;
    result.verticalSliderSize = typeof opts.verticalSliderSize !== "undefined" ? opts.verticalSliderSize : result.verticalScrollbarSize;
    // Defaults are different on Macs
    if (_platformJs.isMacintosh) result.className += " mac";
    return result;
}

},{"../../browser.js":"4Zquf","../../dom.js":"bnqsM","../../fastDomNode.js":"2SADf","../../mouseEvent.js":"4jTdu","./horizontalScrollbar.js":"h0Hb6","./verticalScrollbar.js":"dG7eC","../widget.js":"kM4DP","../../../common/async.js":"4GJc4","../../../common/event.js":"4Zi8b","../../../common/lifecycle.js":"9kg8d","../../../common/platform.js":"7maJO","../../../common/scrollable.js":"8otcz","./media/scrollbars.css":"cZWi5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h0Hb6":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorizontalScrollbar", ()=>HorizontalScrollbar);
var _mouseEventJs = require("../../mouseEvent.js");
var _abstractScrollbarJs = require("./abstractScrollbar.js");
var _scrollbarArrowJs = require("./scrollbarArrow.js");
var _scrollbarStateJs = require("./scrollbarState.js");
var _codiconsJs = require("../../../common/codicons.js");
class HorizontalScrollbar extends (0, _abstractScrollbarJs.AbstractScrollbar) {
    constructor(scrollable, options, host){
        const scrollDimensions = scrollable.getScrollDimensions();
        const scrollPosition = scrollable.getCurrentScrollPosition();
        super({
            lazyRender: options.lazyRender,
            host: host,
            scrollbarState: new (0, _scrollbarStateJs.ScrollbarState)(options.horizontalHasArrows ? options.arrowSize : 0, options.horizontal === 2 /* ScrollbarVisibility.Hidden */  ? 0 : options.horizontalScrollbarSize, options.vertical === 2 /* ScrollbarVisibility.Hidden */  ? 0 : options.verticalScrollbarSize, scrollDimensions.width, scrollDimensions.scrollWidth, scrollPosition.scrollLeft),
            visibility: options.horizontal,
            extraScrollbarClassName: "horizontal",
            scrollable: scrollable,
            scrollByPage: options.scrollByPage
        });
        if (options.horizontalHasArrows) {
            const arrowDelta = (options.arrowSize - (0, _scrollbarArrowJs.ARROW_IMG_SIZE)) / 2;
            const scrollbarDelta = (options.horizontalScrollbarSize - (0, _scrollbarArrowJs.ARROW_IMG_SIZE)) / 2;
            this._createArrow({
                className: "scra",
                icon: (0, _codiconsJs.Codicon).scrollbarButtonLeft,
                top: scrollbarDelta,
                left: arrowDelta,
                bottom: undefined,
                right: undefined,
                bgWidth: options.arrowSize,
                bgHeight: options.horizontalScrollbarSize,
                onActivate: ()=>this._host.onMouseWheel(new (0, _mouseEventJs.StandardWheelEvent)(null, 1, 0))
            });
            this._createArrow({
                className: "scra",
                icon: (0, _codiconsJs.Codicon).scrollbarButtonRight,
                top: scrollbarDelta,
                left: undefined,
                bottom: undefined,
                right: arrowDelta,
                bgWidth: options.arrowSize,
                bgHeight: options.horizontalScrollbarSize,
                onActivate: ()=>this._host.onMouseWheel(new (0, _mouseEventJs.StandardWheelEvent)(null, -1, 0))
            });
        }
        this._createSlider(Math.floor((options.horizontalScrollbarSize - options.horizontalSliderSize) / 2), 0, undefined, options.horizontalSliderSize);
    }
    _updateSlider(sliderSize, sliderPosition) {
        this.slider.setWidth(sliderSize);
        this.slider.setLeft(sliderPosition);
    }
    _renderDomNode(largeSize, smallSize) {
        this.domNode.setWidth(largeSize);
        this.domNode.setHeight(smallSize);
        this.domNode.setLeft(0);
        this.domNode.setBottom(0);
    }
    onDidScroll(e) {
        this._shouldRender = this._onElementScrollSize(e.scrollWidth) || this._shouldRender;
        this._shouldRender = this._onElementScrollPosition(e.scrollLeft) || this._shouldRender;
        this._shouldRender = this._onElementSize(e.width) || this._shouldRender;
        return this._shouldRender;
    }
    _pointerDownRelativePosition(offsetX, offsetY) {
        return offsetX;
    }
    _sliderPointerPosition(e) {
        return e.pageX;
    }
    _sliderOrthogonalPointerPosition(e) {
        return e.pageY;
    }
    _updateScrollbarSize(size) {
        this.slider.setHeight(size);
    }
    writeScrollPosition(target, scrollPosition) {
        target.scrollLeft = scrollPosition;
    }
    updateOptions(options) {
        this.updateScrollbarSize(options.horizontal === 2 /* ScrollbarVisibility.Hidden */  ? 0 : options.horizontalScrollbarSize);
        this._scrollbarState.setOppositeScrollbarSize(options.vertical === 2 /* ScrollbarVisibility.Hidden */  ? 0 : options.verticalScrollbarSize);
        this._visibilityController.setVisibility(options.horizontal);
        this._scrollByPage = options.scrollByPage;
    }
}

},{"../../mouseEvent.js":"4jTdu","./abstractScrollbar.js":"h5g7M","./scrollbarArrow.js":"DCLDB","./scrollbarState.js":"7f0ty","../../../common/codicons.js":"hWYNf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h5g7M":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractScrollbar", ()=>AbstractScrollbar);
var _domJs = require("../../dom.js");
var _fastDomNodeJs = require("../../fastDomNode.js");
var _globalPointerMoveMonitorJs = require("../../globalPointerMoveMonitor.js");
var _scrollbarArrowJs = require("./scrollbarArrow.js");
var _scrollbarVisibilityControllerJs = require("./scrollbarVisibilityController.js");
var _widgetJs = require("../widget.js");
var _platformJs = require("../../../common/platform.js");
/**
 * The orthogonal distance to the slider at which dragging "resets". This implements "snapping"
 */ const POINTER_DRAG_RESET_DISTANCE = 140;
class AbstractScrollbar extends (0, _widgetJs.Widget) {
    constructor(opts){
        super();
        this._lazyRender = opts.lazyRender;
        this._host = opts.host;
        this._scrollable = opts.scrollable;
        this._scrollByPage = opts.scrollByPage;
        this._scrollbarState = opts.scrollbarState;
        this._visibilityController = this._register(new (0, _scrollbarVisibilityControllerJs.ScrollbarVisibilityController)(opts.visibility, "visible scrollbar " + opts.extraScrollbarClassName, "invisible scrollbar " + opts.extraScrollbarClassName));
        this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded());
        this._pointerMoveMonitor = this._register(new (0, _globalPointerMoveMonitorJs.GlobalPointerMoveMonitor)());
        this._shouldRender = true;
        this.domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this.domNode.setAttribute("role", "presentation");
        this.domNode.setAttribute("aria-hidden", "true");
        this._visibilityController.setDomNode(this.domNode);
        this.domNode.setPosition("absolute");
        this._register(_domJs.addDisposableListener(this.domNode.domNode, _domJs.EventType.POINTER_DOWN, (e)=>this._domNodePointerDown(e)));
    }
    // ----------------- creation
    /**
     * Creates the dom node for an arrow & adds it to the container
     */ _createArrow(opts) {
        const arrow = this._register(new (0, _scrollbarArrowJs.ScrollbarArrow)(opts));
        this.domNode.domNode.appendChild(arrow.bgDomNode);
        this.domNode.domNode.appendChild(arrow.domNode);
    }
    /**
     * Creates the slider dom node, adds it to the container & hooks up the events
     */ _createSlider(top, left, width, height) {
        this.slider = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this.slider.setClassName("slider");
        this.slider.setPosition("absolute");
        this.slider.setTop(top);
        this.slider.setLeft(left);
        if (typeof width === "number") this.slider.setWidth(width);
        if (typeof height === "number") this.slider.setHeight(height);
        this.slider.setLayerHinting(true);
        this.slider.setContain("strict");
        this.domNode.domNode.appendChild(this.slider.domNode);
        this._register(_domJs.addDisposableListener(this.slider.domNode, _domJs.EventType.POINTER_DOWN, (e)=>{
            if (e.button === 0) {
                e.preventDefault();
                this._sliderPointerDown(e);
            }
        }));
        this.onclick(this.slider.domNode, (e)=>{
            if (e.leftButton) e.stopPropagation();
        });
    }
    // ----------------- Update state
    _onElementSize(visibleSize) {
        if (this._scrollbarState.setVisibleSize(visibleSize)) {
            this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded());
            this._shouldRender = true;
            if (!this._lazyRender) this.render();
        }
        return this._shouldRender;
    }
    _onElementScrollSize(elementScrollSize) {
        if (this._scrollbarState.setScrollSize(elementScrollSize)) {
            this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded());
            this._shouldRender = true;
            if (!this._lazyRender) this.render();
        }
        return this._shouldRender;
    }
    _onElementScrollPosition(elementScrollPosition) {
        if (this._scrollbarState.setScrollPosition(elementScrollPosition)) {
            this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded());
            this._shouldRender = true;
            if (!this._lazyRender) this.render();
        }
        return this._shouldRender;
    }
    // ----------------- rendering
    beginReveal() {
        this._visibilityController.setShouldBeVisible(true);
    }
    beginHide() {
        this._visibilityController.setShouldBeVisible(false);
    }
    render() {
        if (!this._shouldRender) return;
        this._shouldRender = false;
        this._renderDomNode(this._scrollbarState.getRectangleLargeSize(), this._scrollbarState.getRectangleSmallSize());
        this._updateSlider(this._scrollbarState.getSliderSize(), this._scrollbarState.getArrowSize() + this._scrollbarState.getSliderPosition());
    }
    // ----------------- DOM events
    _domNodePointerDown(e) {
        if (e.target !== this.domNode.domNode) return;
        this._onPointerDown(e);
    }
    delegatePointerDown(e) {
        const domTop = this.domNode.domNode.getClientRects()[0].top;
        const sliderStart = domTop + this._scrollbarState.getSliderPosition();
        const sliderStop = domTop + this._scrollbarState.getSliderPosition() + this._scrollbarState.getSliderSize();
        const pointerPos = this._sliderPointerPosition(e);
        if (sliderStart <= pointerPos && pointerPos <= sliderStop) // Act as if it was a pointer down on the slider
        {
            if (e.button === 0) {
                e.preventDefault();
                this._sliderPointerDown(e);
            }
        } else // Act as if it was a pointer down on the scrollbar
        this._onPointerDown(e);
    }
    _onPointerDown(e) {
        let offsetX;
        let offsetY;
        if (e.target === this.domNode.domNode && typeof e.offsetX === "number" && typeof e.offsetY === "number") {
            offsetX = e.offsetX;
            offsetY = e.offsetY;
        } else {
            const domNodePosition = _domJs.getDomNodePagePosition(this.domNode.domNode);
            offsetX = e.pageX - domNodePosition.left;
            offsetY = e.pageY - domNodePosition.top;
        }
        const offset = this._pointerDownRelativePosition(offsetX, offsetY);
        this._setDesiredScrollPositionNow(this._scrollByPage ? this._scrollbarState.getDesiredScrollPositionFromOffsetPaged(offset) : this._scrollbarState.getDesiredScrollPositionFromOffset(offset));
        if (e.button === 0) {
            // left button
            e.preventDefault();
            this._sliderPointerDown(e);
        }
    }
    _sliderPointerDown(e) {
        if (!e.target || !(e.target instanceof Element)) return;
        const initialPointerPosition = this._sliderPointerPosition(e);
        const initialPointerOrthogonalPosition = this._sliderOrthogonalPointerPosition(e);
        const initialScrollbarState = this._scrollbarState.clone();
        this.slider.toggleClassName("active", true);
        this._pointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (pointerMoveData)=>{
            const pointerOrthogonalPosition = this._sliderOrthogonalPointerPosition(pointerMoveData);
            const pointerOrthogonalDelta = Math.abs(pointerOrthogonalPosition - initialPointerOrthogonalPosition);
            if (_platformJs.isWindows && pointerOrthogonalDelta > POINTER_DRAG_RESET_DISTANCE) {
                // The pointer has wondered away from the scrollbar => reset dragging
                this._setDesiredScrollPositionNow(initialScrollbarState.getScrollPosition());
                return;
            }
            const pointerPosition = this._sliderPointerPosition(pointerMoveData);
            const pointerDelta = pointerPosition - initialPointerPosition;
            this._setDesiredScrollPositionNow(initialScrollbarState.getDesiredScrollPositionFromDelta(pointerDelta));
        }, ()=>{
            this.slider.toggleClassName("active", false);
            this._host.onDragEnd();
        });
        this._host.onDragStart();
    }
    _setDesiredScrollPositionNow(_desiredScrollPosition) {
        const desiredScrollPosition = {};
        this.writeScrollPosition(desiredScrollPosition, _desiredScrollPosition);
        this._scrollable.setScrollPositionNow(desiredScrollPosition);
    }
    updateScrollbarSize(scrollbarSize) {
        this._updateScrollbarSize(scrollbarSize);
        this._scrollbarState.setScrollbarSize(scrollbarSize);
        this._shouldRender = true;
        if (!this._lazyRender) this.render();
    }
    isNeeded() {
        return this._scrollbarState.isNeeded();
    }
}

},{"../../dom.js":"bnqsM","../../fastDomNode.js":"2SADf","../../globalPointerMoveMonitor.js":"iDfLk","./scrollbarArrow.js":"DCLDB","./scrollbarVisibilityController.js":"7Oncc","../widget.js":"kM4DP","../../../common/platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iDfLk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalPointerMoveMonitor", ()=>GlobalPointerMoveMonitor);
var _domJs = require("./dom.js");
var _lifecycleJs = require("../common/lifecycle.js");
class GlobalPointerMoveMonitor {
    constructor(){
        this._hooks = new (0, _lifecycleJs.DisposableStore)();
        this._pointerMoveCallback = null;
        this._onStopCallback = null;
    }
    dispose() {
        this.stopMonitoring(false);
        this._hooks.dispose();
    }
    stopMonitoring(invokeStopCallback, browserEvent) {
        if (!this.isMonitoring()) // Not monitoring
        return;
        // Unhook
        this._hooks.clear();
        this._pointerMoveCallback = null;
        const onStopCallback = this._onStopCallback;
        this._onStopCallback = null;
        if (invokeStopCallback && onStopCallback) onStopCallback(browserEvent);
    }
    isMonitoring() {
        return !!this._pointerMoveCallback;
    }
    startMonitoring(initialElement, pointerId, initialButtons, pointerMoveCallback, onStopCallback) {
        if (this.isMonitoring()) this.stopMonitoring(false);
        this._pointerMoveCallback = pointerMoveCallback;
        this._onStopCallback = onStopCallback;
        let eventSource = initialElement;
        try {
            initialElement.setPointerCapture(pointerId);
            this._hooks.add((0, _lifecycleJs.toDisposable)(()=>{
                try {
                    initialElement.releasePointerCapture(pointerId);
                } catch (err) {
                // See https://github.com/microsoft/vscode/issues/161731
                //
                // `releasePointerCapture` sometimes fails when being invoked with the exception:
                //     DOMException: Failed to execute 'releasePointerCapture' on 'Element':
                //     No active pointer with the given id is found.
                //
                // There's no need to do anything in case of failure
                }
            }));
        } catch (err) {
            // See https://github.com/microsoft/vscode/issues/144584
            // See https://github.com/microsoft/vscode/issues/146947
            // `setPointerCapture` sometimes fails when being invoked
            // from a `mousedown` listener on macOS and Windows
            // and it always fails on Linux with the exception:
            //     DOMException: Failed to execute 'setPointerCapture' on 'Element':
            //     No active pointer with the given id is found.
            // In case of failure, we bind the listeners on the window
            eventSource = _domJs.getWindow(initialElement);
        }
        this._hooks.add(_domJs.addDisposableListener(eventSource, _domJs.EventType.POINTER_MOVE, (e)=>{
            if (e.buttons !== initialButtons) {
                // Buttons state has changed in the meantime
                this.stopMonitoring(true);
                return;
            }
            e.preventDefault();
            this._pointerMoveCallback(e);
        }));
        this._hooks.add(_domJs.addDisposableListener(eventSource, _domJs.EventType.POINTER_UP, (e)=>this.stopMonitoring(true)));
    }
}

},{"./dom.js":"bnqsM","../common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"DCLDB":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ARROW_IMG_SIZE", ()=>ARROW_IMG_SIZE);
parcelHelpers.export(exports, "ScrollbarArrow", ()=>ScrollbarArrow);
var _globalPointerMoveMonitorJs = require("../../globalPointerMoveMonitor.js");
var _widgetJs = require("../widget.js");
var _asyncJs = require("../../../common/async.js");
var _themablesJs = require("../../../common/themables.js");
var _domJs = require("../../dom.js");
const ARROW_IMG_SIZE = 11;
class ScrollbarArrow extends (0, _widgetJs.Widget) {
    constructor(opts){
        super();
        this._onActivate = opts.onActivate;
        this.bgDomNode = document.createElement("div");
        this.bgDomNode.className = "arrow-background";
        this.bgDomNode.style.position = "absolute";
        this.bgDomNode.style.width = opts.bgWidth + "px";
        this.bgDomNode.style.height = opts.bgHeight + "px";
        if (typeof opts.top !== "undefined") this.bgDomNode.style.top = "0px";
        if (typeof opts.left !== "undefined") this.bgDomNode.style.left = "0px";
        if (typeof opts.bottom !== "undefined") this.bgDomNode.style.bottom = "0px";
        if (typeof opts.right !== "undefined") this.bgDomNode.style.right = "0px";
        this.domNode = document.createElement("div");
        this.domNode.className = opts.className;
        this.domNode.classList.add(...(0, _themablesJs.ThemeIcon).asClassNameArray(opts.icon));
        this.domNode.style.position = "absolute";
        this.domNode.style.width = ARROW_IMG_SIZE + "px";
        this.domNode.style.height = ARROW_IMG_SIZE + "px";
        if (typeof opts.top !== "undefined") this.domNode.style.top = opts.top + "px";
        if (typeof opts.left !== "undefined") this.domNode.style.left = opts.left + "px";
        if (typeof opts.bottom !== "undefined") this.domNode.style.bottom = opts.bottom + "px";
        if (typeof opts.right !== "undefined") this.domNode.style.right = opts.right + "px";
        this._pointerMoveMonitor = this._register(new (0, _globalPointerMoveMonitorJs.GlobalPointerMoveMonitor)());
        this._register(_domJs.addStandardDisposableListener(this.bgDomNode, _domJs.EventType.POINTER_DOWN, (e)=>this._arrowPointerDown(e)));
        this._register(_domJs.addStandardDisposableListener(this.domNode, _domJs.EventType.POINTER_DOWN, (e)=>this._arrowPointerDown(e)));
        this._pointerdownRepeatTimer = this._register(new _domJs.WindowIntervalTimer());
        this._pointerdownScheduleRepeatTimer = this._register(new (0, _asyncJs.TimeoutTimer)());
    }
    _arrowPointerDown(e) {
        if (!e.target || !(e.target instanceof Element)) return;
        const scheduleRepeater = ()=>{
            this._pointerdownRepeatTimer.cancelAndSet(()=>this._onActivate(), 1000 / 24, _domJs.getWindow(e));
        };
        this._onActivate();
        this._pointerdownRepeatTimer.cancel();
        this._pointerdownScheduleRepeatTimer.cancelAndSet(scheduleRepeater, 200);
        this._pointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (pointerMoveData)=>{}, ()=>{
            this._pointerdownRepeatTimer.cancel();
            this._pointerdownScheduleRepeatTimer.cancel();
        });
        e.preventDefault();
    }
}

},{"../../globalPointerMoveMonitor.js":"iDfLk","../widget.js":"kM4DP","../../../common/async.js":"4GJc4","../../../common/themables.js":"hgyHi","../../dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kM4DP":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Widget", ()=>Widget);
var _domJs = require("../dom.js");
var _keyboardEventJs = require("../keyboardEvent.js");
var _mouseEventJs = require("../mouseEvent.js");
var _touchJs = require("../touch.js");
var _lifecycleJs = require("../../common/lifecycle.js");
class Widget extends (0, _lifecycleJs.Disposable) {
    onclick(domNode, listener) {
        this._register(_domJs.addDisposableListener(domNode, _domJs.EventType.CLICK, (e)=>listener(new (0, _mouseEventJs.StandardMouseEvent)(_domJs.getWindow(domNode), e))));
    }
    onmousedown(domNode, listener) {
        this._register(_domJs.addDisposableListener(domNode, _domJs.EventType.MOUSE_DOWN, (e)=>listener(new (0, _mouseEventJs.StandardMouseEvent)(_domJs.getWindow(domNode), e))));
    }
    onmouseover(domNode, listener) {
        this._register(_domJs.addDisposableListener(domNode, _domJs.EventType.MOUSE_OVER, (e)=>listener(new (0, _mouseEventJs.StandardMouseEvent)(_domJs.getWindow(domNode), e))));
    }
    onmouseleave(domNode, listener) {
        this._register(_domJs.addDisposableListener(domNode, _domJs.EventType.MOUSE_LEAVE, (e)=>listener(new (0, _mouseEventJs.StandardMouseEvent)(_domJs.getWindow(domNode), e))));
    }
    onkeydown(domNode, listener) {
        this._register(_domJs.addDisposableListener(domNode, _domJs.EventType.KEY_DOWN, (e)=>listener(new (0, _keyboardEventJs.StandardKeyboardEvent)(e))));
    }
    onkeyup(domNode, listener) {
        this._register(_domJs.addDisposableListener(domNode, _domJs.EventType.KEY_UP, (e)=>listener(new (0, _keyboardEventJs.StandardKeyboardEvent)(e))));
    }
    oninput(domNode, listener) {
        this._register(_domJs.addDisposableListener(domNode, _domJs.EventType.INPUT, listener));
    }
    onblur(domNode, listener) {
        this._register(_domJs.addDisposableListener(domNode, _domJs.EventType.BLUR, listener));
    }
    onfocus(domNode, listener) {
        this._register(_domJs.addDisposableListener(domNode, _domJs.EventType.FOCUS, listener));
    }
    ignoreGesture(domNode) {
        return (0, _touchJs.Gesture).ignoreTarget(domNode);
    }
}

},{"../dom.js":"bnqsM","../keyboardEvent.js":"bxU9U","../mouseEvent.js":"4jTdu","../touch.js":"6iGQn","../../common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6iGQn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventType", ()=>EventType);
parcelHelpers.export(exports, "Gesture", ()=>Gesture);
var _domJs = require("./dom.js");
var _windowJs = require("./window.js");
var _arraysJs = require("../common/arrays.js");
var _decoratorsJs = require("../common/decorators.js");
var _eventJs = require("../common/event.js");
var _lifecycleJs = require("../common/lifecycle.js");
var _linkedListJs = require("../common/linkedList.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var EventType;
(function(EventType) {
    EventType.Tap = "-monaco-gesturetap";
    EventType.Change = "-monaco-gesturechange";
    EventType.Start = "-monaco-gesturestart";
    EventType.End = "-monaco-gesturesend";
    EventType.Contextmenu = "-monaco-gesturecontextmenu";
})(EventType || (EventType = {}));
class Gesture extends (0, _lifecycleJs.Disposable) {
    static{
        this.SCROLL_FRICTION = -0.005;
    }
    static{
        this.HOLD_DELAY = 700;
    }
    static{
        this.CLEAR_TAP_COUNT_TIME = 400;
    }
    constructor(){
        super();
        this.dispatched = false;
        this.targets = new (0, _linkedListJs.LinkedList)();
        this.ignoreTargets = new (0, _linkedListJs.LinkedList)();
        this.activeTouches = {};
        this.handle = null;
        this._lastSetTapCountTime = 0;
        this._register((0, _eventJs.Event).runAndSubscribe(_domJs.onDidRegisterWindow, ({ window, disposables })=>{
            disposables.add(_domJs.addDisposableListener(window.document, "touchstart", (e)=>this.onTouchStart(e), {
                passive: false
            }));
            disposables.add(_domJs.addDisposableListener(window.document, "touchend", (e)=>this.onTouchEnd(window, e)));
            disposables.add(_domJs.addDisposableListener(window.document, "touchmove", (e)=>this.onTouchMove(e), {
                passive: false
            }));
        }, {
            window: (0, _windowJs.mainWindow),
            disposables: this._store
        }));
    }
    static addTarget(element) {
        if (!Gesture.isTouchDevice()) return (0, _lifecycleJs.Disposable).None;
        if (!Gesture.INSTANCE) Gesture.INSTANCE = (0, _lifecycleJs.markAsSingleton)(new Gesture());
        const remove = Gesture.INSTANCE.targets.push(element);
        return (0, _lifecycleJs.toDisposable)(remove);
    }
    static ignoreTarget(element) {
        if (!Gesture.isTouchDevice()) return (0, _lifecycleJs.Disposable).None;
        if (!Gesture.INSTANCE) Gesture.INSTANCE = (0, _lifecycleJs.markAsSingleton)(new Gesture());
        const remove = Gesture.INSTANCE.ignoreTargets.push(element);
        return (0, _lifecycleJs.toDisposable)(remove);
    }
    static isTouchDevice() {
        // `'ontouchstart' in window` always evaluates to true with typescript's modern typings. This causes `window` to be
        // `never` later in `window.navigator`. That's why we need the explicit `window as Window` cast
        return "ontouchstart" in (0, _windowJs.mainWindow) || navigator.maxTouchPoints > 0;
    }
    dispose() {
        if (this.handle) {
            this.handle.dispose();
            this.handle = null;
        }
        super.dispose();
    }
    onTouchStart(e) {
        const timestamp = Date.now(); // use Date.now() because on FF e.timeStamp is not epoch based.
        if (this.handle) {
            this.handle.dispose();
            this.handle = null;
        }
        for(let i = 0, len = e.targetTouches.length; i < len; i++){
            const touch = e.targetTouches.item(i);
            this.activeTouches[touch.identifier] = {
                id: touch.identifier,
                initialTarget: touch.target,
                initialTimeStamp: timestamp,
                initialPageX: touch.pageX,
                initialPageY: touch.pageY,
                rollingTimestamps: [
                    timestamp
                ],
                rollingPageX: [
                    touch.pageX
                ],
                rollingPageY: [
                    touch.pageY
                ]
            };
            const evt = this.newGestureEvent(EventType.Start, touch.target);
            evt.pageX = touch.pageX;
            evt.pageY = touch.pageY;
            this.dispatchEvent(evt);
        }
        if (this.dispatched) {
            e.preventDefault();
            e.stopPropagation();
            this.dispatched = false;
        }
    }
    onTouchEnd(targetWindow, e) {
        const timestamp = Date.now(); // use Date.now() because on FF e.timeStamp is not epoch based.
        const activeTouchCount = Object.keys(this.activeTouches).length;
        for(let i = 0, len = e.changedTouches.length; i < len; i++){
            const touch = e.changedTouches.item(i);
            if (!this.activeTouches.hasOwnProperty(String(touch.identifier))) {
                console.warn("move of an UNKNOWN touch", touch);
                continue;
            }
            const data = this.activeTouches[touch.identifier], holdTime = Date.now() - data.initialTimeStamp;
            if (holdTime < Gesture.HOLD_DELAY && Math.abs(data.initialPageX - _arraysJs.tail(data.rollingPageX)) < 30 && Math.abs(data.initialPageY - _arraysJs.tail(data.rollingPageY)) < 30) {
                const evt = this.newGestureEvent(EventType.Tap, data.initialTarget);
                evt.pageX = _arraysJs.tail(data.rollingPageX);
                evt.pageY = _arraysJs.tail(data.rollingPageY);
                this.dispatchEvent(evt);
            } else if (holdTime >= Gesture.HOLD_DELAY && Math.abs(data.initialPageX - _arraysJs.tail(data.rollingPageX)) < 30 && Math.abs(data.initialPageY - _arraysJs.tail(data.rollingPageY)) < 30) {
                const evt = this.newGestureEvent(EventType.Contextmenu, data.initialTarget);
                evt.pageX = _arraysJs.tail(data.rollingPageX);
                evt.pageY = _arraysJs.tail(data.rollingPageY);
                this.dispatchEvent(evt);
            } else if (activeTouchCount === 1) {
                const finalX = _arraysJs.tail(data.rollingPageX);
                const finalY = _arraysJs.tail(data.rollingPageY);
                const deltaT = _arraysJs.tail(data.rollingTimestamps) - data.rollingTimestamps[0];
                const deltaX = finalX - data.rollingPageX[0];
                const deltaY = finalY - data.rollingPageY[0];
                // We need to get all the dispatch targets on the start of the inertia event
                const dispatchTo = [
                    ...this.targets
                ].filter((t)=>data.initialTarget instanceof Node && t.contains(data.initialTarget));
                this.inertia(targetWindow, dispatchTo, timestamp, Math.abs(deltaX) / deltaT, deltaX > 0 ? 1 : -1, finalX, Math.abs(deltaY) / deltaT, deltaY > 0 ? 1 : -1, finalY // y now
                );
            }
            this.dispatchEvent(this.newGestureEvent(EventType.End, data.initialTarget));
            // forget about this touch
            delete this.activeTouches[touch.identifier];
        }
        if (this.dispatched) {
            e.preventDefault();
            e.stopPropagation();
            this.dispatched = false;
        }
    }
    newGestureEvent(type, initialTarget) {
        const event = document.createEvent("CustomEvent");
        event.initEvent(type, false, true);
        event.initialTarget = initialTarget;
        event.tapCount = 0;
        return event;
    }
    dispatchEvent(event) {
        if (event.type === EventType.Tap) {
            const currentTime = new Date().getTime();
            let setTapCount = 0;
            if (currentTime - this._lastSetTapCountTime > Gesture.CLEAR_TAP_COUNT_TIME) setTapCount = 1;
            else setTapCount = 2;
            this._lastSetTapCountTime = currentTime;
            event.tapCount = setTapCount;
        } else if (event.type === EventType.Change || event.type === EventType.Contextmenu) // tap is canceled by scrolling or context menu
        this._lastSetTapCountTime = 0;
        if (event.initialTarget instanceof Node) {
            for (const ignoreTarget of this.ignoreTargets){
                if (ignoreTarget.contains(event.initialTarget)) return;
            }
            const targets = [];
            for (const target of this.targets)if (target.contains(event.initialTarget)) {
                let depth = 0;
                let now = event.initialTarget;
                while(now && now !== target){
                    depth++;
                    now = now.parentElement;
                }
                targets.push([
                    depth,
                    target
                ]);
            }
            targets.sort((a, b)=>a[0] - b[0]);
            for (const [_, target] of targets){
                target.dispatchEvent(event);
                this.dispatched = true;
            }
        }
    }
    inertia(targetWindow, dispatchTo, t1, vX, dirX, x, vY, dirY, y) {
        this.handle = _domJs.scheduleAtNextAnimationFrame(targetWindow, ()=>{
            const now = Date.now();
            // velocity: old speed + accel_over_time
            const deltaT = now - t1;
            let delta_pos_x = 0, delta_pos_y = 0;
            let stopped = true;
            vX += Gesture.SCROLL_FRICTION * deltaT;
            vY += Gesture.SCROLL_FRICTION * deltaT;
            if (vX > 0) {
                stopped = false;
                delta_pos_x = dirX * vX * deltaT;
            }
            if (vY > 0) {
                stopped = false;
                delta_pos_y = dirY * vY * deltaT;
            }
            // dispatch translation event
            const evt = this.newGestureEvent(EventType.Change);
            evt.translationX = delta_pos_x;
            evt.translationY = delta_pos_y;
            dispatchTo.forEach((d)=>d.dispatchEvent(evt));
            if (!stopped) this.inertia(targetWindow, dispatchTo, now, vX, dirX, x + delta_pos_x, vY, dirY, y + delta_pos_y);
        });
    }
    onTouchMove(e) {
        const timestamp = Date.now(); // use Date.now() because on FF e.timeStamp is not epoch based.
        for(let i = 0, len = e.changedTouches.length; i < len; i++){
            const touch = e.changedTouches.item(i);
            if (!this.activeTouches.hasOwnProperty(String(touch.identifier))) {
                console.warn("end of an UNKNOWN touch", touch);
                continue;
            }
            const data = this.activeTouches[touch.identifier];
            const evt = this.newGestureEvent(EventType.Change, data.initialTarget);
            evt.translationX = touch.pageX - _arraysJs.tail(data.rollingPageX);
            evt.translationY = touch.pageY - _arraysJs.tail(data.rollingPageY);
            evt.pageX = touch.pageX;
            evt.pageY = touch.pageY;
            this.dispatchEvent(evt);
            // only keep a few data points, to average the final speed
            if (data.rollingPageX.length > 3) {
                data.rollingPageX.shift();
                data.rollingPageY.shift();
                data.rollingTimestamps.shift();
            }
            data.rollingPageX.push(touch.pageX);
            data.rollingPageY.push(touch.pageY);
            data.rollingTimestamps.push(timestamp);
        }
        if (this.dispatched) {
            e.preventDefault();
            e.stopPropagation();
            this.dispatched = false;
        }
    }
}
__decorate([
    (0, _decoratorsJs.memoize)
], Gesture, "isTouchDevice", null);

},{"./dom.js":"bnqsM","./window.js":"aJBhQ","../common/arrays.js":"DECei","../common/decorators.js":"hZnBn","../common/event.js":"4Zi8b","../common/lifecycle.js":"9kg8d","../common/linkedList.js":"kv7Rg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hZnBn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", ()=>memoize);
function memoize(_target, key, descriptor) {
    let fnKey = null;
    let fn = null;
    if (typeof descriptor.value === "function") {
        fnKey = "value";
        fn = descriptor.value;
        if (fn.length !== 0) console.warn("Memoize should only be used in functions with zero parameters");
    } else if (typeof descriptor.get === "function") {
        fnKey = "get";
        fn = descriptor.get;
    }
    if (!fn) throw new Error("not supported");
    const memoizeKey = `$memoize$${key}`;
    descriptor[fnKey] = function(...args) {
        if (!this.hasOwnProperty(memoizeKey)) Object.defineProperty(this, memoizeKey, {
            configurable: false,
            enumerable: false,
            writable: false,
            value: fn.apply(this, args)
        });
        return this[memoizeKey];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Oncc":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollbarVisibilityController", ()=>ScrollbarVisibilityController);
var _asyncJs = require("../../../common/async.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
class ScrollbarVisibilityController extends (0, _lifecycleJs.Disposable) {
    constructor(visibility, visibleClassName, invisibleClassName){
        super();
        this._visibility = visibility;
        this._visibleClassName = visibleClassName;
        this._invisibleClassName = invisibleClassName;
        this._domNode = null;
        this._isVisible = false;
        this._isNeeded = false;
        this._rawShouldBeVisible = false;
        this._shouldBeVisible = false;
        this._revealTimer = this._register(new (0, _asyncJs.TimeoutTimer)());
    }
    setVisibility(visibility) {
        if (this._visibility !== visibility) {
            this._visibility = visibility;
            this._updateShouldBeVisible();
        }
    }
    // ----------------- Hide / Reveal
    setShouldBeVisible(rawShouldBeVisible) {
        this._rawShouldBeVisible = rawShouldBeVisible;
        this._updateShouldBeVisible();
    }
    _applyVisibilitySetting() {
        if (this._visibility === 2 /* ScrollbarVisibility.Hidden */ ) return false;
        if (this._visibility === 3 /* ScrollbarVisibility.Visible */ ) return true;
        return this._rawShouldBeVisible;
    }
    _updateShouldBeVisible() {
        const shouldBeVisible = this._applyVisibilitySetting();
        if (this._shouldBeVisible !== shouldBeVisible) {
            this._shouldBeVisible = shouldBeVisible;
            this.ensureVisibility();
        }
    }
    setIsNeeded(isNeeded) {
        if (this._isNeeded !== isNeeded) {
            this._isNeeded = isNeeded;
            this.ensureVisibility();
        }
    }
    setDomNode(domNode) {
        this._domNode = domNode;
        this._domNode.setClassName(this._invisibleClassName);
        // Now that the flags & the dom node are in a consistent state, ensure the Hidden/Visible configuration
        this.setShouldBeVisible(false);
    }
    ensureVisibility() {
        if (!this._isNeeded) {
            // Nothing to be rendered
            this._hide(false);
            return;
        }
        if (this._shouldBeVisible) this._reveal();
        else this._hide(true);
    }
    _reveal() {
        if (this._isVisible) return;
        this._isVisible = true;
        // The CSS animation doesn't play otherwise
        this._revealTimer.setIfNotSet(()=>{
            this._domNode?.setClassName(this._visibleClassName);
        }, 0);
    }
    _hide(withFadeAway) {
        this._revealTimer.cancel();
        if (!this._isVisible) return;
        this._isVisible = false;
        this._domNode?.setClassName(this._invisibleClassName + (withFadeAway ? " fade" : ""));
    }
}

},{"../../../common/async.js":"4GJc4","../../../common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7f0ty":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 * The minimal size of the slider (such that it can still be clickable) -- it is artificially enlarged.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollbarState", ()=>ScrollbarState);
const MINIMUM_SLIDER_SIZE = 20;
class ScrollbarState {
    constructor(arrowSize, scrollbarSize, oppositeScrollbarSize, visibleSize, scrollSize, scrollPosition){
        this._scrollbarSize = Math.round(scrollbarSize);
        this._oppositeScrollbarSize = Math.round(oppositeScrollbarSize);
        this._arrowSize = Math.round(arrowSize);
        this._visibleSize = visibleSize;
        this._scrollSize = scrollSize;
        this._scrollPosition = scrollPosition;
        this._computedAvailableSize = 0;
        this._computedIsNeeded = false;
        this._computedSliderSize = 0;
        this._computedSliderRatio = 0;
        this._computedSliderPosition = 0;
        this._refreshComputedValues();
    }
    clone() {
        return new ScrollbarState(this._arrowSize, this._scrollbarSize, this._oppositeScrollbarSize, this._visibleSize, this._scrollSize, this._scrollPosition);
    }
    setVisibleSize(visibleSize) {
        const iVisibleSize = Math.round(visibleSize);
        if (this._visibleSize !== iVisibleSize) {
            this._visibleSize = iVisibleSize;
            this._refreshComputedValues();
            return true;
        }
        return false;
    }
    setScrollSize(scrollSize) {
        const iScrollSize = Math.round(scrollSize);
        if (this._scrollSize !== iScrollSize) {
            this._scrollSize = iScrollSize;
            this._refreshComputedValues();
            return true;
        }
        return false;
    }
    setScrollPosition(scrollPosition) {
        const iScrollPosition = Math.round(scrollPosition);
        if (this._scrollPosition !== iScrollPosition) {
            this._scrollPosition = iScrollPosition;
            this._refreshComputedValues();
            return true;
        }
        return false;
    }
    setScrollbarSize(scrollbarSize) {
        this._scrollbarSize = Math.round(scrollbarSize);
    }
    setOppositeScrollbarSize(oppositeScrollbarSize) {
        this._oppositeScrollbarSize = Math.round(oppositeScrollbarSize);
    }
    static _computeValues(oppositeScrollbarSize, arrowSize, visibleSize, scrollSize, scrollPosition) {
        const computedAvailableSize = Math.max(0, visibleSize - oppositeScrollbarSize);
        const computedRepresentableSize = Math.max(0, computedAvailableSize - 2 * arrowSize);
        const computedIsNeeded = scrollSize > 0 && scrollSize > visibleSize;
        if (!computedIsNeeded) // There is no need for a slider
        return {
            computedAvailableSize: Math.round(computedAvailableSize),
            computedIsNeeded: computedIsNeeded,
            computedSliderSize: Math.round(computedRepresentableSize),
            computedSliderRatio: 0,
            computedSliderPosition: 0
        };
        // We must artificially increase the size of the slider if needed, since the slider would be too small to grab with the mouse otherwise
        const computedSliderSize = Math.round(Math.max(MINIMUM_SLIDER_SIZE, Math.floor(visibleSize * computedRepresentableSize / scrollSize)));
        // The slider can move from 0 to `computedRepresentableSize` - `computedSliderSize`
        // in the same way `scrollPosition` can move from 0 to `scrollSize` - `visibleSize`.
        const computedSliderRatio = (computedRepresentableSize - computedSliderSize) / (scrollSize - visibleSize);
        const computedSliderPosition = scrollPosition * computedSliderRatio;
        return {
            computedAvailableSize: Math.round(computedAvailableSize),
            computedIsNeeded: computedIsNeeded,
            computedSliderSize: Math.round(computedSliderSize),
            computedSliderRatio: computedSliderRatio,
            computedSliderPosition: Math.round(computedSliderPosition)
        };
    }
    _refreshComputedValues() {
        const r = ScrollbarState._computeValues(this._oppositeScrollbarSize, this._arrowSize, this._visibleSize, this._scrollSize, this._scrollPosition);
        this._computedAvailableSize = r.computedAvailableSize;
        this._computedIsNeeded = r.computedIsNeeded;
        this._computedSliderSize = r.computedSliderSize;
        this._computedSliderRatio = r.computedSliderRatio;
        this._computedSliderPosition = r.computedSliderPosition;
    }
    getArrowSize() {
        return this._arrowSize;
    }
    getScrollPosition() {
        return this._scrollPosition;
    }
    getRectangleLargeSize() {
        return this._computedAvailableSize;
    }
    getRectangleSmallSize() {
        return this._scrollbarSize;
    }
    isNeeded() {
        return this._computedIsNeeded;
    }
    getSliderSize() {
        return this._computedSliderSize;
    }
    getSliderPosition() {
        return this._computedSliderPosition;
    }
    /**
     * Compute a desired `scrollPosition` such that `offset` ends up in the center of the slider.
     * `offset` is based on the same coordinate system as the `sliderPosition`.
     */ getDesiredScrollPositionFromOffset(offset) {
        if (!this._computedIsNeeded) // no need for a slider
        return 0;
        const desiredSliderPosition = offset - this._arrowSize - this._computedSliderSize / 2;
        return Math.round(desiredSliderPosition / this._computedSliderRatio);
    }
    /**
     * Compute a desired `scrollPosition` from if offset is before or after the slider position.
     * If offset is before slider, treat as a page up (or left).  If after, page down (or right).
     * `offset` and `_computedSliderPosition` are based on the same coordinate system.
     * `_visibleSize` corresponds to a "page" of lines in the returned coordinate system.
     */ getDesiredScrollPositionFromOffsetPaged(offset) {
        if (!this._computedIsNeeded) // no need for a slider
        return 0;
        const correctedOffset = offset - this._arrowSize; // compensate if has arrows
        let desiredScrollPosition = this._scrollPosition;
        if (correctedOffset < this._computedSliderPosition) desiredScrollPosition -= this._visibleSize; // page up/left
        else desiredScrollPosition += this._visibleSize; // page down/right
        return desiredScrollPosition;
    }
    /**
     * Compute a desired `scrollPosition` such that the slider moves by `delta`.
     */ getDesiredScrollPositionFromDelta(delta) {
        if (!this._computedIsNeeded) // no need for a slider
        return 0;
        const desiredSliderPosition = this._computedSliderPosition + delta;
        return Math.round(desiredSliderPosition / this._computedSliderRatio);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dG7eC":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerticalScrollbar", ()=>VerticalScrollbar);
var _mouseEventJs = require("../../mouseEvent.js");
var _abstractScrollbarJs = require("./abstractScrollbar.js");
var _scrollbarArrowJs = require("./scrollbarArrow.js");
var _scrollbarStateJs = require("./scrollbarState.js");
var _codiconsJs = require("../../../common/codicons.js");
class VerticalScrollbar extends (0, _abstractScrollbarJs.AbstractScrollbar) {
    constructor(scrollable, options, host){
        const scrollDimensions = scrollable.getScrollDimensions();
        const scrollPosition = scrollable.getCurrentScrollPosition();
        super({
            lazyRender: options.lazyRender,
            host: host,
            scrollbarState: new (0, _scrollbarStateJs.ScrollbarState)(options.verticalHasArrows ? options.arrowSize : 0, options.vertical === 2 /* ScrollbarVisibility.Hidden */  ? 0 : options.verticalScrollbarSize, // give priority to vertical scroll bar over horizontal and let it scroll all the way to the bottom
            0, scrollDimensions.height, scrollDimensions.scrollHeight, scrollPosition.scrollTop),
            visibility: options.vertical,
            extraScrollbarClassName: "vertical",
            scrollable: scrollable,
            scrollByPage: options.scrollByPage
        });
        if (options.verticalHasArrows) {
            const arrowDelta = (options.arrowSize - (0, _scrollbarArrowJs.ARROW_IMG_SIZE)) / 2;
            const scrollbarDelta = (options.verticalScrollbarSize - (0, _scrollbarArrowJs.ARROW_IMG_SIZE)) / 2;
            this._createArrow({
                className: "scra",
                icon: (0, _codiconsJs.Codicon).scrollbarButtonUp,
                top: arrowDelta,
                left: scrollbarDelta,
                bottom: undefined,
                right: undefined,
                bgWidth: options.verticalScrollbarSize,
                bgHeight: options.arrowSize,
                onActivate: ()=>this._host.onMouseWheel(new (0, _mouseEventJs.StandardWheelEvent)(null, 0, 1))
            });
            this._createArrow({
                className: "scra",
                icon: (0, _codiconsJs.Codicon).scrollbarButtonDown,
                top: undefined,
                left: scrollbarDelta,
                bottom: arrowDelta,
                right: undefined,
                bgWidth: options.verticalScrollbarSize,
                bgHeight: options.arrowSize,
                onActivate: ()=>this._host.onMouseWheel(new (0, _mouseEventJs.StandardWheelEvent)(null, 0, -1))
            });
        }
        this._createSlider(0, Math.floor((options.verticalScrollbarSize - options.verticalSliderSize) / 2), options.verticalSliderSize, undefined);
    }
    _updateSlider(sliderSize, sliderPosition) {
        this.slider.setHeight(sliderSize);
        this.slider.setTop(sliderPosition);
    }
    _renderDomNode(largeSize, smallSize) {
        this.domNode.setWidth(smallSize);
        this.domNode.setHeight(largeSize);
        this.domNode.setRight(0);
        this.domNode.setTop(0);
    }
    onDidScroll(e) {
        this._shouldRender = this._onElementScrollSize(e.scrollHeight) || this._shouldRender;
        this._shouldRender = this._onElementScrollPosition(e.scrollTop) || this._shouldRender;
        this._shouldRender = this._onElementSize(e.height) || this._shouldRender;
        return this._shouldRender;
    }
    _pointerDownRelativePosition(offsetX, offsetY) {
        return offsetY;
    }
    _sliderPointerPosition(e) {
        return e.pageY;
    }
    _sliderOrthogonalPointerPosition(e) {
        return e.pageX;
    }
    _updateScrollbarSize(size) {
        this.slider.setWidth(size);
    }
    writeScrollPosition(target, scrollPosition) {
        target.scrollTop = scrollPosition;
    }
    updateOptions(options) {
        this.updateScrollbarSize(options.vertical === 2 /* ScrollbarVisibility.Hidden */  ? 0 : options.verticalScrollbarSize);
        // give priority to vertical scroll bar over horizontal and let it scroll all the way to the bottom
        this._scrollbarState.setOppositeScrollbarSize(0);
        this._visibilityController.setVisibility(options.vertical);
        this._scrollByPage = options.scrollByPage;
    }
}

},{"../../mouseEvent.js":"4jTdu","./abstractScrollbar.js":"h5g7M","./scrollbarArrow.js":"DCLDB","./scrollbarState.js":"7f0ty","../../../common/codicons.js":"hWYNf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8otcz":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollState", ()=>ScrollState);
parcelHelpers.export(exports, "Scrollable", ()=>Scrollable);
parcelHelpers.export(exports, "SmoothScrollingUpdate", ()=>SmoothScrollingUpdate);
parcelHelpers.export(exports, "SmoothScrollingOperation", ()=>SmoothScrollingOperation);
var _eventJs = require("./event.js");
var _lifecycleJs = require("./lifecycle.js");
class ScrollState {
    constructor(_forceIntegerValues, width, scrollWidth, scrollLeft, height, scrollHeight, scrollTop){
        this._forceIntegerValues = _forceIntegerValues;
        this._scrollStateBrand = undefined;
        if (this._forceIntegerValues) {
            width = width | 0;
            scrollWidth = scrollWidth | 0;
            scrollLeft = scrollLeft | 0;
            height = height | 0;
            scrollHeight = scrollHeight | 0;
            scrollTop = scrollTop | 0;
        }
        this.rawScrollLeft = scrollLeft; // before validation
        this.rawScrollTop = scrollTop; // before validation
        if (width < 0) width = 0;
        if (scrollLeft + width > scrollWidth) scrollLeft = scrollWidth - width;
        if (scrollLeft < 0) scrollLeft = 0;
        if (height < 0) height = 0;
        if (scrollTop + height > scrollHeight) scrollTop = scrollHeight - height;
        if (scrollTop < 0) scrollTop = 0;
        this.width = width;
        this.scrollWidth = scrollWidth;
        this.scrollLeft = scrollLeft;
        this.height = height;
        this.scrollHeight = scrollHeight;
        this.scrollTop = scrollTop;
    }
    equals(other) {
        return this.rawScrollLeft === other.rawScrollLeft && this.rawScrollTop === other.rawScrollTop && this.width === other.width && this.scrollWidth === other.scrollWidth && this.scrollLeft === other.scrollLeft && this.height === other.height && this.scrollHeight === other.scrollHeight && this.scrollTop === other.scrollTop;
    }
    withScrollDimensions(update, useRawScrollPositions) {
        return new ScrollState(this._forceIntegerValues, typeof update.width !== "undefined" ? update.width : this.width, typeof update.scrollWidth !== "undefined" ? update.scrollWidth : this.scrollWidth, useRawScrollPositions ? this.rawScrollLeft : this.scrollLeft, typeof update.height !== "undefined" ? update.height : this.height, typeof update.scrollHeight !== "undefined" ? update.scrollHeight : this.scrollHeight, useRawScrollPositions ? this.rawScrollTop : this.scrollTop);
    }
    withScrollPosition(update) {
        return new ScrollState(this._forceIntegerValues, this.width, this.scrollWidth, typeof update.scrollLeft !== "undefined" ? update.scrollLeft : this.rawScrollLeft, this.height, this.scrollHeight, typeof update.scrollTop !== "undefined" ? update.scrollTop : this.rawScrollTop);
    }
    createScrollEvent(previous, inSmoothScrolling) {
        const widthChanged = this.width !== previous.width;
        const scrollWidthChanged = this.scrollWidth !== previous.scrollWidth;
        const scrollLeftChanged = this.scrollLeft !== previous.scrollLeft;
        const heightChanged = this.height !== previous.height;
        const scrollHeightChanged = this.scrollHeight !== previous.scrollHeight;
        const scrollTopChanged = this.scrollTop !== previous.scrollTop;
        return {
            inSmoothScrolling: inSmoothScrolling,
            oldWidth: previous.width,
            oldScrollWidth: previous.scrollWidth,
            oldScrollLeft: previous.scrollLeft,
            width: this.width,
            scrollWidth: this.scrollWidth,
            scrollLeft: this.scrollLeft,
            oldHeight: previous.height,
            oldScrollHeight: previous.scrollHeight,
            oldScrollTop: previous.scrollTop,
            height: this.height,
            scrollHeight: this.scrollHeight,
            scrollTop: this.scrollTop,
            widthChanged: widthChanged,
            scrollWidthChanged: scrollWidthChanged,
            scrollLeftChanged: scrollLeftChanged,
            heightChanged: heightChanged,
            scrollHeightChanged: scrollHeightChanged,
            scrollTopChanged: scrollTopChanged
        };
    }
}
class Scrollable extends (0, _lifecycleJs.Disposable) {
    constructor(options){
        super();
        this._scrollableBrand = undefined;
        this._onScroll = this._register(new (0, _eventJs.Emitter)());
        this.onScroll = this._onScroll.event;
        this._smoothScrollDuration = options.smoothScrollDuration;
        this._scheduleAtNextAnimationFrame = options.scheduleAtNextAnimationFrame;
        this._state = new ScrollState(options.forceIntegerValues, 0, 0, 0, 0, 0, 0);
        this._smoothScrolling = null;
    }
    dispose() {
        if (this._smoothScrolling) {
            this._smoothScrolling.dispose();
            this._smoothScrolling = null;
        }
        super.dispose();
    }
    setSmoothScrollDuration(smoothScrollDuration) {
        this._smoothScrollDuration = smoothScrollDuration;
    }
    validateScrollPosition(scrollPosition) {
        return this._state.withScrollPosition(scrollPosition);
    }
    getScrollDimensions() {
        return this._state;
    }
    setScrollDimensions(dimensions, useRawScrollPositions) {
        const newState = this._state.withScrollDimensions(dimensions, useRawScrollPositions);
        this._setState(newState, Boolean(this._smoothScrolling));
        // Validate outstanding animated scroll position target
        this._smoothScrolling?.acceptScrollDimensions(this._state);
    }
    /**
     * Returns the final scroll position that the instance will have once the smooth scroll animation concludes.
     * If no scroll animation is occurring, it will return the current scroll position instead.
     */ getFutureScrollPosition() {
        if (this._smoothScrolling) return this._smoothScrolling.to;
        return this._state;
    }
    /**
     * Returns the current scroll position.
     * Note: This result might be an intermediate scroll position, as there might be an ongoing smooth scroll animation.
     */ getCurrentScrollPosition() {
        return this._state;
    }
    setScrollPositionNow(update) {
        // no smooth scrolling requested
        const newState = this._state.withScrollPosition(update);
        // Terminate any outstanding smooth scrolling
        if (this._smoothScrolling) {
            this._smoothScrolling.dispose();
            this._smoothScrolling = null;
        }
        this._setState(newState, false);
    }
    setScrollPositionSmooth(update, reuseAnimation) {
        if (this._smoothScrollDuration === 0) // Smooth scrolling not supported.
        return this.setScrollPositionNow(update);
        if (this._smoothScrolling) {
            // Combine our pending scrollLeft/scrollTop with incoming scrollLeft/scrollTop
            update = {
                scrollLeft: typeof update.scrollLeft === "undefined" ? this._smoothScrolling.to.scrollLeft : update.scrollLeft,
                scrollTop: typeof update.scrollTop === "undefined" ? this._smoothScrolling.to.scrollTop : update.scrollTop
            };
            // Validate `update`
            const validTarget = this._state.withScrollPosition(update);
            if (this._smoothScrolling.to.scrollLeft === validTarget.scrollLeft && this._smoothScrolling.to.scrollTop === validTarget.scrollTop) // No need to interrupt or extend the current animation since we're going to the same place
            return;
            let newSmoothScrolling;
            if (reuseAnimation) newSmoothScrolling = new SmoothScrollingOperation(this._smoothScrolling.from, validTarget, this._smoothScrolling.startTime, this._smoothScrolling.duration);
            else newSmoothScrolling = this._smoothScrolling.combine(this._state, validTarget, this._smoothScrollDuration);
            this._smoothScrolling.dispose();
            this._smoothScrolling = newSmoothScrolling;
        } else {
            // Validate `update`
            const validTarget = this._state.withScrollPosition(update);
            this._smoothScrolling = SmoothScrollingOperation.start(this._state, validTarget, this._smoothScrollDuration);
        }
        // Begin smooth scrolling animation
        this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(()=>{
            if (!this._smoothScrolling) return;
            this._smoothScrolling.animationFrameDisposable = null;
            this._performSmoothScrolling();
        });
    }
    hasPendingScrollAnimation() {
        return Boolean(this._smoothScrolling);
    }
    _performSmoothScrolling() {
        if (!this._smoothScrolling) return;
        const update = this._smoothScrolling.tick();
        const newState = this._state.withScrollPosition(update);
        this._setState(newState, true);
        if (!this._smoothScrolling) // Looks like someone canceled the smooth scrolling
        // from the scroll event handler
        return;
        if (update.isDone) {
            this._smoothScrolling.dispose();
            this._smoothScrolling = null;
            return;
        }
        // Continue smooth scrolling animation
        this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(()=>{
            if (!this._smoothScrolling) return;
            this._smoothScrolling.animationFrameDisposable = null;
            this._performSmoothScrolling();
        });
    }
    _setState(newState, inSmoothScrolling) {
        const oldState = this._state;
        if (oldState.equals(newState)) // no change
        return;
        this._state = newState;
        this._onScroll.fire(this._state.createScrollEvent(oldState, inSmoothScrolling));
    }
}
class SmoothScrollingUpdate {
    constructor(scrollLeft, scrollTop, isDone){
        this.scrollLeft = scrollLeft;
        this.scrollTop = scrollTop;
        this.isDone = isDone;
    }
}
function createEaseOutCubic(from, to) {
    const delta = to - from;
    return function(completion) {
        return from + delta * easeOutCubic(completion);
    };
}
function createComposed(a, b, cut) {
    return function(completion) {
        if (completion < cut) return a(completion / cut);
        return b((completion - cut) / (1 - cut));
    };
}
class SmoothScrollingOperation {
    constructor(from, to, startTime, duration){
        this.from = from;
        this.to = to;
        this.duration = duration;
        this.startTime = startTime;
        this.animationFrameDisposable = null;
        this._initAnimations();
    }
    _initAnimations() {
        this.scrollLeft = this._initAnimation(this.from.scrollLeft, this.to.scrollLeft, this.to.width);
        this.scrollTop = this._initAnimation(this.from.scrollTop, this.to.scrollTop, this.to.height);
    }
    _initAnimation(from, to, viewportSize) {
        const delta = Math.abs(from - to);
        if (delta > 2.5 * viewportSize) {
            let stop1, stop2;
            if (from < to) {
                // scroll to 75% of the viewportSize
                stop1 = from + 0.75 * viewportSize;
                stop2 = to - 0.75 * viewportSize;
            } else {
                stop1 = from - 0.75 * viewportSize;
                stop2 = to + 0.75 * viewportSize;
            }
            return createComposed(createEaseOutCubic(from, stop1), createEaseOutCubic(stop2, to), 0.33);
        }
        return createEaseOutCubic(from, to);
    }
    dispose() {
        if (this.animationFrameDisposable !== null) {
            this.animationFrameDisposable.dispose();
            this.animationFrameDisposable = null;
        }
    }
    acceptScrollDimensions(state) {
        this.to = state.withScrollPosition(this.to);
        this._initAnimations();
    }
    tick() {
        return this._tick(Date.now());
    }
    _tick(now) {
        const completion = (now - this.startTime) / this.duration;
        if (completion < 1) {
            const newScrollLeft = this.scrollLeft(completion);
            const newScrollTop = this.scrollTop(completion);
            return new SmoothScrollingUpdate(newScrollLeft, newScrollTop, false);
        }
        return new SmoothScrollingUpdate(this.to.scrollLeft, this.to.scrollTop, true);
    }
    combine(from, to, duration) {
        return SmoothScrollingOperation.start(from, to, duration);
    }
    static start(from, to, duration) {
        // +10 / -10 : pretend the animation already started for a quicker response to a scroll request
        duration = duration + 10;
        const startTime = Date.now() - 10;
        return new SmoothScrollingOperation(from, to, startTime, duration);
    }
}
function easeInCubic(t) {
    return Math.pow(t, 3);
}
function easeOutCubic(t) {
    return 1 - easeInCubic(1 - t);
}

},{"./event.js":"4Zi8b","./lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cZWi5":[function() {},{}],"jYBFi":[function() {},{}],"d3tj1":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IOpenerService", ()=>IOpenerService);
/**
 * file:///some/file.js#73
 * file:///some/file.js#L73
 * file:///some/file.js#73,84
 * file:///some/file.js#L73,84
 * file:///some/file.js#73-83
 * file:///some/file.js#L73-L83
 * file:///some/file.js#73,84-83,52
 * file:///some/file.js#L73,84-L83,52
 */ parcelHelpers.export(exports, "extractSelection", ()=>extractSelection);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IOpenerService = (0, _instantiationJs.createDecorator)("openerService");
function extractSelection(uri) {
    let selection = undefined;
    const match = /^L?(\d+)(?:,(\d+))?(-L?(\d+)(?:,(\d+))?)?/.exec(uri.fragment);
    if (match) {
        selection = {
            startLineNumber: parseInt(match[1]),
            startColumn: match[2] ? parseInt(match[2]) : 1,
            endLineNumber: match[4] ? parseInt(match[4]) : undefined,
            endColumn: match[4] ? match[5] ? parseInt(match[5]) : 1 : undefined
        };
        uri = uri.with({
            fragment: ""
        });
    }
    return {
        selection,
        uri
    };
}

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"34xfZ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkdownRenderer", ()=>MarkdownRenderer);
parcelHelpers.export(exports, "openLinkFromMarkdown", ()=>openLinkFromMarkdown);
var _markdownRendererJs = require("../../../../../base/browser/markdownRenderer.js");
var _trustedTypesJs = require("../../../../../base/browser/trustedTypes.js");
var _errorsJs = require("../../../../../base/common/errors.js");
var _eventJs = require("../../../../../base/common/event.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _renderedMarkdownCss = require("./renderedMarkdown.css");
var _domFontInfoJs = require("../../../config/domFontInfo.js");
var _languageJs = require("../../../../common/languages/language.js");
var _modesRegistryJs = require("../../../../common/languages/modesRegistry.js");
var _textToHtmlTokenizerJs = require("../../../../common/languages/textToHtmlTokenizer.js");
var _openerJs = require("../../../../../platform/opener/common/opener.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var MarkdownRenderer_1;
/**
 * Markdown renderer that can render codeblocks with the editor mechanics. This
 * renderer should always be preferred.
 */ let MarkdownRenderer = class MarkdownRenderer {
    static{
        MarkdownRenderer_1 = this;
    }
    static{
        this._ttpTokenizer = (0, _trustedTypesJs.createTrustedTypesPolicy)("tokenizeToString", {
            createHTML (html) {
                return html;
            }
        });
    }
    constructor(_options, _languageService, _openerService){
        this._options = _options;
        this._languageService = _languageService;
        this._openerService = _openerService;
        this._onDidRenderAsync = new (0, _eventJs.Emitter)();
        this.onDidRenderAsync = this._onDidRenderAsync.event;
    }
    dispose() {
        this._onDidRenderAsync.dispose();
    }
    render(markdown, options, markedOptions) {
        if (!markdown) {
            const element = document.createElement("span");
            return {
                element,
                dispose: ()=>{}
            };
        }
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        const rendered = disposables.add((0, _markdownRendererJs.renderMarkdown)(markdown, {
            ...this._getRenderOptions(markdown, disposables),
            ...options
        }, markedOptions));
        rendered.element.classList.add("rendered-markdown");
        return {
            element: rendered.element,
            dispose: ()=>disposables.dispose()
        };
    }
    _getRenderOptions(markdown, disposables) {
        return {
            codeBlockRenderer: async (languageAlias, value)=>{
                // In markdown,
                // it is possible that we stumble upon language aliases (e.g.js instead of javascript)
                // it is possible no alias is given in which case we fall back to the current editor lang
                let languageId;
                if (languageAlias) languageId = this._languageService.getLanguageIdByLanguageName(languageAlias);
                else if (this._options.editor) languageId = this._options.editor.getModel()?.getLanguageId();
                if (!languageId) languageId = (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID);
                const html = await (0, _textToHtmlTokenizerJs.tokenizeToString)(this._languageService, value, languageId);
                const element = document.createElement("span");
                element.innerHTML = MarkdownRenderer_1._ttpTokenizer?.createHTML(html) ?? html;
                // use "good" font
                if (this._options.editor) {
                    const fontInfo = this._options.editor.getOption(50 /* EditorOption.fontInfo */ );
                    (0, _domFontInfoJs.applyFontInfo)(element, fontInfo);
                } else if (this._options.codeBlockFontFamily) element.style.fontFamily = this._options.codeBlockFontFamily;
                if (this._options.codeBlockFontSize !== undefined) element.style.fontSize = this._options.codeBlockFontSize;
                return element;
            },
            asyncRenderCallback: ()=>this._onDidRenderAsync.fire(),
            actionHandler: {
                callback: (link)=>openLinkFromMarkdown(this._openerService, link, markdown.isTrusted),
                disposables: disposables
            }
        };
    }
};
MarkdownRenderer = MarkdownRenderer_1 = __decorate([
    __param(1, (0, _languageJs.ILanguageService)),
    __param(2, (0, _openerJs.IOpenerService))
], MarkdownRenderer);
async function openLinkFromMarkdown(openerService, link, isTrusted) {
    try {
        return await openerService.open(link, {
            fromUserGesture: true,
            allowContributedOpeners: true,
            allowCommands: toAllowCommandsOption(isTrusted)
        });
    } catch (e) {
        (0, _errorsJs.onUnexpectedError)(e);
        return false;
    }
}
function toAllowCommandsOption(isTrusted) {
    if (isTrusted === true) return true; // Allow all commands
    if (isTrusted && Array.isArray(isTrusted.enabledCommands)) return isTrusted.enabledCommands; // Allow subset of commands
    return false; // Block commands
}

},{"../../../../../base/browser/markdownRenderer.js":"3fw7s","../../../../../base/browser/trustedTypes.js":"bgQyv","../../../../../base/common/errors.js":"divX8","../../../../../base/common/event.js":"4Zi8b","../../../../../base/common/lifecycle.js":"9kg8d","./renderedMarkdown.css":"ROAwM","../../../config/domFontInfo.js":"fQezv","../../../../common/languages/language.js":"ka2JQ","../../../../common/languages/modesRegistry.js":"gqkb7","../../../../common/languages/textToHtmlTokenizer.js":"je4FM","../../../../../platform/opener/common/opener.js":"d3tj1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3fw7s":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Low-level way create a html element from a markdown string.
 *
 * **Note** that for most cases you should be using [`MarkdownRenderer`](./src/vs/editor/contrib/markdownRenderer/browser/markdownRenderer.ts)
 * which comes with support for pretty code block rendering and which uses the default way of handling links.
 */ parcelHelpers.export(exports, "renderMarkdown", ()=>renderMarkdown);
parcelHelpers.export(exports, "allowedMarkdownAttr", ()=>allowedMarkdownAttr);
/**
 * Strips all markdown from `string`, if it's an IMarkdownString. For example
 * `# Header` would be output as `Header`. If it's not, the string is returned.
 */ parcelHelpers.export(exports, "renderStringAsPlaintext", ()=>renderStringAsPlaintext);
/**
 * Strips all markdown from `markdown`. For example `# Header` would be output as `Header`.
 * provide @param withCodeBlocks to retain code blocks
 */ parcelHelpers.export(exports, "renderMarkdownAsPlaintext", ()=>renderMarkdownAsPlaintext);
parcelHelpers.export(exports, "fillInIncompleteTokens", ()=>fillInIncompleteTokens);
var _domJs = require("./dom.js");
var _dompurifyJs = require("./dompurify/dompurify.js");
var _eventJs = require("./event.js");
var _formattedTextRendererJs = require("./formattedTextRenderer.js");
var _keyboardEventJs = require("./keyboardEvent.js");
var _mouseEventJs = require("./mouseEvent.js");
var _iconLabelsJs = require("./ui/iconLabel/iconLabels.js");
var _errorsJs = require("../common/errors.js");
var _eventJs1 = require("../common/event.js");
var _htmlContentJs = require("../common/htmlContent.js");
var _iconLabelsJs1 = require("../common/iconLabels.js");
var _idGeneratorJs = require("../common/idGenerator.js");
var _lazyJs = require("../common/lazy.js");
var _lifecycleJs = require("../common/lifecycle.js");
var _markedJs = require("../common/marked/marked.js");
var _marshallingJs = require("../common/marshalling.js");
var _networkJs = require("../common/network.js");
var _objectsJs = require("../common/objects.js");
var _resourcesJs = require("../common/resources.js");
var _stringsJs = require("../common/strings.js");
var _uriJs = require("../common/uri.js");
const defaultMarkedRenderers = Object.freeze({
    image: ({ href, title, text })=>{
        let dimensions = [];
        let attributes = [];
        if (href) {
            ({ href, dimensions } = (0, _htmlContentJs.parseHrefAndDimensions)(href));
            attributes.push(`src="${(0, _htmlContentJs.escapeDoubleQuotes)(href)}"`);
        }
        if (text) attributes.push(`alt="${(0, _htmlContentJs.escapeDoubleQuotes)(text)}"`);
        if (title) attributes.push(`title="${(0, _htmlContentJs.escapeDoubleQuotes)(title)}"`);
        if (dimensions.length) attributes = attributes.concat(dimensions);
        return "<img " + attributes.join(" ") + ">";
    },
    paragraph ({ tokens }) {
        return `<p>${this.parser.parseInline(tokens)}</p>`;
    },
    link ({ href, title, tokens }) {
        let text = this.parser.parseInline(tokens);
        if (typeof href !== "string") return "";
        // Remove markdown escapes. Workaround for https://github.com/chjj/marked/issues/829
        if (href === text) text = (0, _htmlContentJs.removeMarkdownEscapes)(text);
        title = typeof title === "string" ? (0, _htmlContentJs.escapeDoubleQuotes)((0, _htmlContentJs.removeMarkdownEscapes)(title)) : "";
        href = (0, _htmlContentJs.removeMarkdownEscapes)(href);
        // HTML Encode href
        href = href.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        return `<a href="${href}" title="${title || href}" draggable="false">${text}</a>`;
    }
});
function renderMarkdown(markdown, options = {}, markedOptions = {}) {
    const disposables = new (0, _lifecycleJs.DisposableStore)();
    let isDisposed = false;
    const element = (0, _formattedTextRendererJs.createElement)(options);
    const _uriMassage = function(part) {
        let data;
        try {
            data = (0, _marshallingJs.parse)(decodeURIComponent(part));
        } catch (e) {
        // ignore
        }
        if (!data) return part;
        data = (0, _objectsJs.cloneAndChange)(data, (value)=>{
            if (markdown.uris && markdown.uris[value]) return (0, _uriJs.URI).revive(markdown.uris[value]);
            else return undefined;
        });
        return encodeURIComponent(JSON.stringify(data));
    };
    const _href = function(href, isDomUri) {
        const data = markdown.uris && markdown.uris[href];
        let uri = (0, _uriJs.URI).revive(data);
        if (isDomUri) {
            if (href.startsWith((0, _networkJs.Schemas).data + ":")) return href;
            if (!uri) uri = (0, _uriJs.URI).parse(href);
            // this URI will end up as "src"-attribute of a dom node
            // and because of that special rewriting needs to be done
            // so that the URI uses a protocol that's understood by
            // browsers (like http or https)
            return (0, _networkJs.FileAccess).uriToBrowserUri(uri).toString(true);
        }
        if (!uri) return href;
        if ((0, _uriJs.URI).parse(href).toString() === uri.toString()) return href; // no transformation performed
        if (uri.query) uri = uri.with({
            query: _uriMassage(uri.query)
        });
        return uri.toString();
    };
    const renderer = new _markedJs.Renderer();
    renderer.image = defaultMarkedRenderers.image;
    renderer.link = defaultMarkedRenderers.link;
    renderer.paragraph = defaultMarkedRenderers.paragraph;
    // Will collect [id, renderedElement] tuples
    const codeBlocks = [];
    const syncCodeBlocks = [];
    if (options.codeBlockRendererSync) renderer.code = ({ text, lang })=>{
        const id = (0, _idGeneratorJs.defaultGenerator).nextId();
        const value = options.codeBlockRendererSync(postProcessCodeBlockLanguageId(lang), text);
        syncCodeBlocks.push([
            id,
            value
        ]);
        return `<div class="code" data-code="${id}">${(0, _stringsJs.escape)(text)}</div>`;
    };
    else if (options.codeBlockRenderer) renderer.code = ({ text, lang })=>{
        const id = (0, _idGeneratorJs.defaultGenerator).nextId();
        const value = options.codeBlockRenderer(postProcessCodeBlockLanguageId(lang), text);
        codeBlocks.push(value.then((element)=>[
                id,
                element
            ]));
        return `<div class="code" data-code="${id}">${(0, _stringsJs.escape)(text)}</div>`;
    };
    if (options.actionHandler) {
        const _activateLink = function(event) {
            let target = event.target;
            if (target.tagName !== "A") {
                target = target.parentElement;
                if (!target || target.tagName !== "A") return;
            }
            try {
                let href = target.dataset["href"];
                if (href) {
                    if (markdown.baseUri) href = resolveWithBaseUri((0, _uriJs.URI).from(markdown.baseUri), href);
                    options.actionHandler.callback(href, event);
                }
            } catch (err) {
                (0, _errorsJs.onUnexpectedError)(err);
            } finally{
                event.preventDefault();
            }
        };
        const onClick = options.actionHandler.disposables.add(new (0, _eventJs.DomEmitter)(element, "click"));
        const onAuxClick = options.actionHandler.disposables.add(new (0, _eventJs.DomEmitter)(element, "auxclick"));
        options.actionHandler.disposables.add((0, _eventJs1.Event).any(onClick.event, onAuxClick.event)((e)=>{
            const mouseEvent = new (0, _mouseEventJs.StandardMouseEvent)(_domJs.getWindow(element), e);
            if (!mouseEvent.leftButton && !mouseEvent.middleButton) return;
            _activateLink(mouseEvent);
        }));
        options.actionHandler.disposables.add(_domJs.addDisposableListener(element, "keydown", (e)=>{
            const keyboardEvent = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            if (!keyboardEvent.equals(10 /* KeyCode.Space */ ) && !keyboardEvent.equals(3 /* KeyCode.Enter */ )) return;
            _activateLink(keyboardEvent);
        }));
    }
    if (!markdown.supportHtml) // Note: we always pass the output through dompurify after this so that we don't rely on
    // marked for real sanitization.
    renderer.html = ({ text })=>{
        if (options.sanitizerOptions?.replaceWithPlaintext) return (0, _stringsJs.escape)(text);
        const match = markdown.isTrusted ? text.match(/^(<span[^>]+>)|(<\/\s*span>)$/) : undefined;
        return match ? text : "";
    };
    markedOptions.renderer = renderer;
    // values that are too long will freeze the UI
    let value = markdown.value ?? "";
    if (value.length > 100000) value = `${value.substr(0, 100000)}\u{2026}`;
    // escape theme icons
    if (markdown.supportThemeIcons) value = (0, _iconLabelsJs1.markdownEscapeEscapedIcons)(value);
    let renderedMarkdown;
    if (options.fillInIncompleteTokens) {
        // The defaults are applied by parse but not lexer()/parser(), and they need to be present
        const opts = {
            ..._markedJs.defaults,
            ...markedOptions
        };
        const tokens = _markedJs.lexer(value, opts);
        const newTokens = fillInIncompleteTokens(tokens);
        renderedMarkdown = _markedJs.parser(newTokens, opts);
    } else renderedMarkdown = _markedJs.parse(value, {
        ...markedOptions,
        async: false
    });
    // Rewrite theme icons
    if (markdown.supportThemeIcons) {
        const elements = (0, _iconLabelsJs.renderLabelWithIcons)(renderedMarkdown);
        renderedMarkdown = elements.map((e)=>typeof e === "string" ? e : e.outerHTML).join("");
    }
    const htmlParser = new DOMParser();
    const markdownHtmlDoc = htmlParser.parseFromString(sanitizeRenderedMarkdown({
        isTrusted: markdown.isTrusted,
        ...options.sanitizerOptions
    }, renderedMarkdown), "text/html");
    markdownHtmlDoc.body.querySelectorAll("img, audio, video, source").forEach((img)=>{
        const src = img.getAttribute("src"); // Get the raw 'src' attribute value as text, not the resolved 'src'
        if (src) {
            let href = src;
            try {
                if (markdown.baseUri) href = resolveWithBaseUri((0, _uriJs.URI).from(markdown.baseUri), href);
            } catch (err) {}
            img.setAttribute("src", _href(href, true));
            if (options.remoteImageIsAllowed) {
                const uri = (0, _uriJs.URI).parse(href);
                if (uri.scheme !== (0, _networkJs.Schemas).file && uri.scheme !== (0, _networkJs.Schemas).data && !options.remoteImageIsAllowed(uri)) img.replaceWith(_domJs.$("", undefined, img.outerHTML));
            }
        }
    });
    markdownHtmlDoc.body.querySelectorAll("a").forEach((a)=>{
        const href = a.getAttribute("href"); // Get the raw 'href' attribute value as text, not the resolved 'href'
        a.setAttribute("href", ""); // Clear out href. We use the `data-href` for handling clicks instead
        if (!href || /^data:|javascript:/i.test(href) || /^command:/i.test(href) && !markdown.isTrusted || /^command:(\/\/\/)?_workbench\.downloadResource/i.test(href)) // drop the link
        a.replaceWith(...a.childNodes);
        else {
            let resolvedHref = _href(href, false);
            if (markdown.baseUri) resolvedHref = resolveWithBaseUri((0, _uriJs.URI).from(markdown.baseUri), href);
            a.dataset.href = resolvedHref;
        }
    });
    element.innerHTML = sanitizeRenderedMarkdown({
        isTrusted: markdown.isTrusted,
        ...options.sanitizerOptions
    }, markdownHtmlDoc.body.innerHTML);
    if (codeBlocks.length > 0) Promise.all(codeBlocks).then((tuples)=>{
        if (isDisposed) return;
        const renderedElements = new Map(tuples);
        const placeholderElements = element.querySelectorAll(`div[data-code]`);
        for (const placeholderElement of placeholderElements){
            const renderedElement = renderedElements.get(placeholderElement.dataset["code"] ?? "");
            if (renderedElement) _domJs.reset(placeholderElement, renderedElement);
        }
        options.asyncRenderCallback?.();
    });
    else if (syncCodeBlocks.length > 0) {
        const renderedElements = new Map(syncCodeBlocks);
        const placeholderElements = element.querySelectorAll(`div[data-code]`);
        for (const placeholderElement of placeholderElements){
            const renderedElement = renderedElements.get(placeholderElement.dataset["code"] ?? "");
            if (renderedElement) _domJs.reset(placeholderElement, renderedElement);
        }
    }
    // signal size changes for image tags
    if (options.asyncRenderCallback) for (const img of element.getElementsByTagName("img")){
        const listener = disposables.add(_domJs.addDisposableListener(img, "load", ()=>{
            listener.dispose();
            options.asyncRenderCallback();
        }));
    }
    return {
        element,
        dispose: ()=>{
            isDisposed = true;
            disposables.dispose();
        }
    };
}
function postProcessCodeBlockLanguageId(lang) {
    if (!lang) return "";
    const parts = lang.split(/[\s+|:|,|\{|\?]/, 1);
    if (parts.length) return parts[0];
    return lang;
}
function resolveWithBaseUri(baseUri, href) {
    const hasScheme = /^\w[\w\d+.-]*:/.test(href);
    if (hasScheme) return href;
    if (baseUri.path.endsWith("/")) return (0, _resourcesJs.resolvePath)(baseUri, href).toString();
    else return (0, _resourcesJs.resolvePath)((0, _resourcesJs.dirname)(baseUri), href).toString();
}
const selfClosingTags = [
    "area",
    "base",
    "br",
    "col",
    "command",
    "embed",
    "hr",
    "img",
    "input",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
];
function sanitizeRenderedMarkdown(options, renderedMarkdown) {
    const { config, allowedSchemes } = getSanitizerOptions(options);
    const store = new (0, _lifecycleJs.DisposableStore)();
    store.add(addDompurifyHook("uponSanitizeAttribute", (element, e)=>{
        if (e.attrName === "style" || e.attrName === "class") {
            if (element.tagName === "SPAN") {
                if (e.attrName === "style") {
                    e.keepAttr = /^(color\:(#[0-9a-fA-F]+|var\(--vscode(-[a-zA-Z]+)+\));)?(background-color\:(#[0-9a-fA-F]+|var\(--vscode(-[a-zA-Z]+)+\));)?(border-radius:[0-9]+px;)?$/.test(e.attrValue);
                    return;
                } else if (e.attrName === "class") {
                    e.keepAttr = /^codicon codicon-[a-z\-]+( codicon-modifier-[a-z\-]+)?$/.test(e.attrValue);
                    return;
                }
            }
            e.keepAttr = false;
            return;
        } else if (element.tagName === "INPUT" && element.attributes.getNamedItem("type")?.value === "checkbox") {
            if (e.attrName === "type" && e.attrValue === "checkbox" || e.attrName === "disabled" || e.attrName === "checked") {
                e.keepAttr = true;
                return;
            }
            e.keepAttr = false;
        }
    }));
    store.add(addDompurifyHook("uponSanitizeElement", (element, e)=>{
        if (e.tagName === "input") {
            if (element.attributes.getNamedItem("type")?.value === "checkbox") element.setAttribute("disabled", "");
            else if (!options.replaceWithPlaintext) element.remove();
        }
        if (options.replaceWithPlaintext && !e.allowedTags[e.tagName] && e.tagName !== "body") {
            if (element.parentElement) {
                let startTagText;
                let endTagText;
                if (e.tagName === "#comment") startTagText = `<!--${element.textContent}-->`;
                else {
                    const isSelfClosing = selfClosingTags.includes(e.tagName);
                    const attrString = element.attributes.length ? " " + Array.from(element.attributes).map((attr)=>`${attr.name}="${attr.value}"`).join(" ") : "";
                    startTagText = `<${e.tagName}${attrString}>`;
                    if (!isSelfClosing) endTagText = `</${e.tagName}>`;
                }
                const fragment = document.createDocumentFragment();
                const textNode = element.parentElement.ownerDocument.createTextNode(startTagText);
                fragment.appendChild(textNode);
                const endTagTextNode = endTagText ? element.parentElement.ownerDocument.createTextNode(endTagText) : undefined;
                while(element.firstChild)fragment.appendChild(element.firstChild);
                if (endTagTextNode) fragment.appendChild(endTagTextNode);
                element.parentElement.replaceChild(fragment, element);
            }
        }
    }));
    store.add(_domJs.hookDomPurifyHrefAndSrcSanitizer(allowedSchemes));
    try {
        return _dompurifyJs.sanitize(renderedMarkdown, {
            ...config,
            RETURN_TRUSTED_TYPE: true
        });
    } finally{
        store.dispose();
    }
}
const allowedMarkdownAttr = [
    "align",
    "autoplay",
    "alt",
    "checked",
    "class",
    "colspan",
    "controls",
    "data-code",
    "data-href",
    "disabled",
    "draggable",
    "height",
    "href",
    "loop",
    "muted",
    "playsinline",
    "poster",
    "rowspan",
    "src",
    "style",
    "target",
    "title",
    "type",
    "width",
    "start"
];
function getSanitizerOptions(options) {
    const allowedSchemes = [
        (0, _networkJs.Schemas).http,
        (0, _networkJs.Schemas).https,
        (0, _networkJs.Schemas).mailto,
        (0, _networkJs.Schemas).data,
        (0, _networkJs.Schemas).file,
        (0, _networkJs.Schemas).vscodeFileResource,
        (0, _networkJs.Schemas).vscodeRemote,
        (0, _networkJs.Schemas).vscodeRemoteResource
    ];
    if (options.isTrusted) allowedSchemes.push((0, _networkJs.Schemas).command);
    return {
        config: {
            // allowedTags should included everything that markdown renders to.
            // Since we have our own sanitize function for marked, it's possible we missed some tag so let dompurify make sure.
            // HTML tags that can result from markdown are from reading https://spec.commonmark.org/0.29/
            // HTML table tags that can result from markdown are from https://github.github.com/gfm/#tables-extension-
            ALLOWED_TAGS: options.allowedTags ?? [
                ..._domJs.basicMarkupHtmlTags
            ],
            ALLOWED_ATTR: allowedMarkdownAttr,
            ALLOW_UNKNOWN_PROTOCOLS: true
        },
        allowedSchemes
    };
}
function renderStringAsPlaintext(string) {
    return typeof string === "string" ? string : renderMarkdownAsPlaintext(string);
}
function renderMarkdownAsPlaintext(markdown, withCodeBlocks) {
    // values that are too long will freeze the UI
    let value = markdown.value ?? "";
    if (value.length > 100000) value = `${value.substr(0, 100000)}\u{2026}`;
    const html = _markedJs.parse(value, {
        async: false,
        renderer: withCodeBlocks ? plainTextWithCodeBlocksRenderer.value : plainTextRenderer.value
    }).replace(/&(#\d+|[a-zA-Z]+);/g, (m)=>unescapeInfo.get(m) ?? m);
    return sanitizeRenderedMarkdown({
        isTrusted: false
    }, html).toString();
}
const unescapeInfo = new Map([
    [
        "&quot;",
        '"'
    ],
    [
        "&nbsp;",
        " "
    ],
    [
        "&amp;",
        "&"
    ],
    [
        "&#39;",
        "'"
    ],
    [
        "&lt;",
        "<"
    ],
    [
        "&gt;",
        ">"
    ]
]);
function createRenderer() {
    const renderer = new _markedJs.Renderer();
    renderer.code = ({ text })=>{
        return text;
    };
    renderer.blockquote = ({ text })=>{
        return text + "\n";
    };
    renderer.html = (_)=>{
        return "";
    };
    renderer.heading = function({ tokens }) {
        return this.parser.parseInline(tokens) + "\n";
    };
    renderer.hr = ()=>{
        return "";
    };
    renderer.list = function({ items }) {
        return items.map((x)=>this.listitem(x)).join("\n") + "\n";
    };
    renderer.listitem = ({ text })=>{
        return text + "\n";
    };
    renderer.paragraph = function({ tokens }) {
        return this.parser.parseInline(tokens) + "\n";
    };
    renderer.table = function({ header, rows }) {
        return header.map((cell)=>this.tablecell(cell)).join(" ") + "\n" + rows.map((cells)=>cells.map((cell)=>this.tablecell(cell)).join(" ")).join("\n") + "\n";
    };
    renderer.tablerow = ({ text })=>{
        return text;
    };
    renderer.tablecell = function({ tokens }) {
        return this.parser.parseInline(tokens);
    };
    renderer.strong = ({ text })=>{
        return text;
    };
    renderer.em = ({ text })=>{
        return text;
    };
    renderer.codespan = ({ text })=>{
        return text;
    };
    renderer.br = (_)=>{
        return "\n";
    };
    renderer.del = ({ text })=>{
        return text;
    };
    renderer.image = (_)=>{
        return "";
    };
    renderer.text = ({ text })=>{
        return text;
    };
    renderer.link = ({ text })=>{
        return text;
    };
    return renderer;
}
const plainTextRenderer = new (0, _lazyJs.Lazy)((withCodeBlocks)=>createRenderer());
const plainTextWithCodeBlocksRenderer = new (0, _lazyJs.Lazy)(()=>{
    const renderer = createRenderer();
    renderer.code = ({ text })=>{
        return `\n\`\`\`\n${text}\n\`\`\`\n`;
    };
    return renderer;
});
function mergeRawTokenText(tokens) {
    let mergedTokenText = "";
    tokens.forEach((token)=>{
        mergedTokenText += token.raw;
    });
    return mergedTokenText;
}
function completeSingleLinePattern(token) {
    if (!token.tokens) return undefined;
    for(let i = token.tokens.length - 1; i >= 0; i--){
        const subtoken = token.tokens[i];
        if (subtoken.type === "text") {
            const lines = subtoken.raw.split("\n");
            const lastLine = lines[lines.length - 1];
            if (lastLine.includes("`")) return completeCodespan(token);
            else if (lastLine.includes("**")) return completeDoublestar(token);
            else if (lastLine.match(/\*\w/)) return completeStar(token);
            else if (lastLine.match(/(^|\s)__\w/)) return completeDoubleUnderscore(token);
            else if (lastLine.match(/(^|\s)_\w/)) return completeUnderscore(token);
            else if (// Text with start of link target
            hasLinkTextAndStartOfLinkTarget(lastLine) || // This token doesn't have the link text, eg if it contains other markdown constructs that are in other subtokens.
            // But some preceding token does have an unbalanced [ at least
            hasStartOfLinkTargetAndNoLinkText(lastLine) && token.tokens.slice(0, i).some((t)=>t.type === "text" && t.raw.match(/\[[^\]]*$/))) {
                const nextTwoSubTokens = token.tokens.slice(i + 1);
                // A markdown link can look like
                // [link text](https://microsoft.com "more text")
                // Where "more text" is a title for the link or an argument to a vscode command link
                if (// If the link was parsed as a link, then look for a link token and a text token with a quote
                nextTwoSubTokens[0]?.type === "link" && nextTwoSubTokens[1]?.type === "text" && nextTwoSubTokens[1].raw.match(/^ *"[^"]*$/) || // And if the link was not parsed as a link (eg command link), just look for a single quote in this token
                lastLine.match(/^[^"]* +"[^"]*$/)) return completeLinkTargetArg(token);
                return completeLinkTarget(token);
            } else if (lastLine.match(/(^|\s)\[\w*/)) return completeLinkText(token);
        }
    }
    return undefined;
}
function hasLinkTextAndStartOfLinkTarget(str) {
    return !!str.match(/(^|\s)\[.*\]\(\w*/);
}
function hasStartOfLinkTargetAndNoLinkText(str) {
    return !!str.match(/^[^\[]*\]\([^\)]*$/);
}
function completeListItemPattern(list) {
    // Patch up this one list item
    const lastListItem = list.items[list.items.length - 1];
    const lastListSubToken = lastListItem.tokens ? lastListItem.tokens[lastListItem.tokens.length - 1] : undefined;
    /*
    Example list token structures:

    list
        list_item
            text
                text
                codespan
                link
        list_item
            text
            code // Complete indented codeblock
        list_item
            text
            space
            text
                text // Incomplete indented codeblock
        list_item
            text
            list // Nested list
                list_item
                    text
                        text

    Contrast with paragraph:
    paragraph
        text
        codespan
    */ let newToken;
    if (lastListSubToken?.type === "text" && !("inRawBlock" in lastListItem)) newToken = completeSingleLinePattern(lastListSubToken);
    if (!newToken || newToken.type !== "paragraph") // Nothing to fix, or not a pattern we were expecting
    return;
    const previousListItemsText = mergeRawTokenText(list.items.slice(0, -1));
    // Grabbing the `- ` or `1. ` or `* ` off the list item because I can't find a better way to do this
    const lastListItemLead = lastListItem.raw.match(/^(\s*(-|\d+\.|\*) +)/)?.[0];
    if (!lastListItemLead) // Is badly formatted
    return;
    const newListItemText = lastListItemLead + mergeRawTokenText(lastListItem.tokens.slice(0, -1)) + newToken.raw;
    const newList = _markedJs.lexer(previousListItemsText + newListItemText)[0];
    if (newList.type !== "list") // Something went wrong
    return;
    return newList;
}
const maxIncompleteTokensFixRounds = 3;
function fillInIncompleteTokens(tokens) {
    for(let i = 0; i < maxIncompleteTokensFixRounds; i++){
        const newTokens = fillInIncompleteTokensOnce(tokens);
        if (newTokens) tokens = newTokens;
        else break;
    }
    return tokens;
}
function fillInIncompleteTokensOnce(tokens) {
    let i;
    let newTokens;
    for(i = 0; i < tokens.length; i++){
        const token = tokens[i];
        if (token.type === "paragraph" && token.raw.match(/(\n|^)\|/)) {
            newTokens = completeTable(tokens.slice(i));
            break;
        }
        if (i === tokens.length - 1 && token.type === "list") {
            const newListToken = completeListItemPattern(token);
            if (newListToken) {
                newTokens = [
                    newListToken
                ];
                break;
            }
        }
        if (i === tokens.length - 1 && token.type === "paragraph") {
            // Only operates on a single token, because any newline that follows this should break these patterns
            const newToken = completeSingleLinePattern(token);
            if (newToken) {
                newTokens = [
                    newToken
                ];
                break;
            }
        }
    }
    if (newTokens) {
        const newTokensList = [
            ...tokens.slice(0, i),
            ...newTokens
        ];
        newTokensList.links = tokens.links;
        return newTokensList;
    }
    return null;
}
function completeCodespan(token) {
    return completeWithString(token, "`");
}
function completeStar(tokens) {
    return completeWithString(tokens, "*");
}
function completeUnderscore(tokens) {
    return completeWithString(tokens, "_");
}
function completeLinkTarget(tokens) {
    return completeWithString(tokens, ")");
}
function completeLinkTargetArg(tokens) {
    return completeWithString(tokens, '")');
}
function completeLinkText(tokens) {
    return completeWithString(tokens, "](https://microsoft.com)");
}
function completeDoublestar(tokens) {
    return completeWithString(tokens, "**");
}
function completeDoubleUnderscore(tokens) {
    return completeWithString(tokens, "__");
}
function completeWithString(tokens, closingString) {
    const mergedRawText = mergeRawTokenText(Array.isArray(tokens) ? tokens : [
        tokens
    ]);
    // If it was completed correctly, this should be a single token.
    // Expecting either a Paragraph or a List
    return _markedJs.lexer(mergedRawText + closingString)[0];
}
function completeTable(tokens) {
    const mergedRawText = mergeRawTokenText(tokens);
    const lines = mergedRawText.split("\n");
    let numCols; // The number of line1 col headers
    let hasSeparatorRow = false;
    for(let i = 0; i < lines.length; i++){
        const line = lines[i].trim();
        if (typeof numCols === "undefined" && line.match(/^\s*\|/)) {
            const line1Matches = line.match(/(\|[^\|]+)(?=\||$)/g);
            if (line1Matches) numCols = line1Matches.length;
        } else if (typeof numCols === "number") {
            if (line.match(/^\s*\|/)) {
                if (i !== lines.length - 1) // We got the line1 header row, and the line2 separator row, but there are more lines, and it wasn't parsed as a table!
                // That's strange and means that the table is probably malformed in the source, so I won't try to patch it up.
                return undefined;
                // Got a line2 separator row- partial or complete, doesn't matter, we'll replace it with a correct one
                hasSeparatorRow = true;
            } else // The line after the header row isn't a valid separator row, so the table is malformed, don't fix it up
            return undefined;
        }
    }
    if (typeof numCols === "number" && numCols > 0) {
        const prefixText = hasSeparatorRow ? lines.slice(0, -1).join("\n") : mergedRawText;
        const line1EndsInPipe = !!prefixText.match(/\|\s*$/);
        const newRawText = prefixText + (line1EndsInPipe ? "" : "|") + `\n|${" --- |".repeat(numCols)}`;
        return _markedJs.lexer(newRawText);
    }
    return undefined;
}
function addDompurifyHook(hook, cb) {
    _dompurifyJs.addHook(hook, cb);
    return (0, _lifecycleJs.toDisposable)(()=>_dompurifyJs.removeHook(hook));
}

},{"./dom.js":"bnqsM","./dompurify/dompurify.js":"8OdMj","./event.js":"PHN3G","./formattedTextRenderer.js":"jCbdG","./keyboardEvent.js":"bxU9U","./mouseEvent.js":"4jTdu","./ui/iconLabel/iconLabels.js":"lXqhk","../common/errors.js":"divX8","../common/event.js":"4Zi8b","../common/htmlContent.js":"3Hxzm","../common/iconLabels.js":"3vhIZ","../common/idGenerator.js":"jlFbp","../common/lazy.js":"6e57N","../common/lifecycle.js":"9kg8d","../common/marked/marked.js":"4P351","../common/marshalling.js":"e1DQr","../common/network.js":"2c1AD","../common/objects.js":"j84mT","../common/resources.js":"700EV","../common/strings.js":"aA9I1","../common/uri.js":"7qGS3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"PHN3G":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DomEmitter", ()=>DomEmitter);
var _eventJs = require("../common/event.js");
class DomEmitter {
    get event() {
        return this.emitter.event;
    }
    constructor(element, type, useCapture){
        const fn = (e)=>this.emitter.fire(e);
        this.emitter = new (0, _eventJs.Emitter)({
            onWillAddFirstListener: ()=>element.addEventListener(type, fn, useCapture),
            onDidRemoveLastListener: ()=>element.removeEventListener(type, fn, useCapture)
        });
    }
    dispose() {
        this.emitter.dispose();
    }
}

},{"../common/event.js":"4Zi8b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jCbdG":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderText", ()=>renderText);
parcelHelpers.export(exports, "renderFormattedText", ()=>renderFormattedText);
parcelHelpers.export(exports, "createElement", ()=>createElement);
var _domJs = require("./dom.js");
function renderText(text, options = {}) {
    const element = createElement(options);
    element.textContent = text;
    return element;
}
function renderFormattedText(formattedText, options = {}) {
    const element = createElement(options);
    _renderFormattedText(element, parseFormattedText(formattedText, !!options.renderCodeSegments), options.actionHandler, options.renderCodeSegments);
    return element;
}
function createElement(options) {
    const tagName = options.inline ? "span" : "div";
    const element = document.createElement(tagName);
    if (options.className) element.className = options.className;
    return element;
}
class StringStream {
    constructor(source){
        this.source = source;
        this.index = 0;
    }
    eos() {
        return this.index >= this.source.length;
    }
    next() {
        const next = this.peek();
        this.advance();
        return next;
    }
    peek() {
        return this.source[this.index];
    }
    advance() {
        this.index++;
    }
}
function _renderFormattedText(element, treeNode, actionHandler, renderCodeSegments) {
    let child;
    if (treeNode.type === 2 /* FormatType.Text */ ) child = document.createTextNode(treeNode.content || "");
    else if (treeNode.type === 3 /* FormatType.Bold */ ) child = document.createElement("b");
    else if (treeNode.type === 4 /* FormatType.Italics */ ) child = document.createElement("i");
    else if (treeNode.type === 7 /* FormatType.Code */  && renderCodeSegments) child = document.createElement("code");
    else if (treeNode.type === 5 /* FormatType.Action */  && actionHandler) {
        const a = document.createElement("a");
        actionHandler.disposables.add(_domJs.addStandardDisposableListener(a, "click", (event)=>{
            actionHandler.callback(String(treeNode.index), event);
        }));
        child = a;
    } else if (treeNode.type === 8 /* FormatType.NewLine */ ) child = document.createElement("br");
    else if (treeNode.type === 1 /* FormatType.Root */ ) child = element;
    if (child && element !== child) element.appendChild(child);
    if (child && Array.isArray(treeNode.children)) treeNode.children.forEach((nodeChild)=>{
        _renderFormattedText(child, nodeChild, actionHandler, renderCodeSegments);
    });
}
function parseFormattedText(content, parseCodeSegments) {
    const root = {
        type: 1 /* FormatType.Root */ ,
        children: []
    };
    let actionViewItemIndex = 0;
    let current = root;
    const stack = [];
    const stream = new StringStream(content);
    while(!stream.eos()){
        let next = stream.next();
        const isEscapedFormatType = next === "\\" && formatTagType(stream.peek(), parseCodeSegments) !== 0 /* FormatType.Invalid */ ;
        if (isEscapedFormatType) next = stream.next(); // unread the backslash if it escapes a format tag type
        if (!isEscapedFormatType && isFormatTag(next, parseCodeSegments) && next === stream.peek()) {
            stream.advance();
            if (current.type === 2 /* FormatType.Text */ ) current = stack.pop();
            const type = formatTagType(next, parseCodeSegments);
            if (current.type === type || current.type === 5 /* FormatType.Action */  && type === 6 /* FormatType.ActionClose */ ) current = stack.pop();
            else {
                const newCurrent = {
                    type: type,
                    children: []
                };
                if (type === 5 /* FormatType.Action */ ) {
                    newCurrent.index = actionViewItemIndex;
                    actionViewItemIndex++;
                }
                current.children.push(newCurrent);
                stack.push(current);
                current = newCurrent;
            }
        } else if (next === "\n") {
            if (current.type === 2 /* FormatType.Text */ ) current = stack.pop();
            current.children.push({
                type: 8 /* FormatType.NewLine */ 
            });
        } else if (current.type !== 2 /* FormatType.Text */ ) {
            const textCurrent = {
                type: 2 /* FormatType.Text */ ,
                content: next
            };
            current.children.push(textCurrent);
            stack.push(current);
            current = textCurrent;
        } else current.content += next;
    }
    if (current.type === 2 /* FormatType.Text */ ) current = stack.pop();
    stack.length;
    return root;
}
function isFormatTag(char, supportCodeSegments) {
    return formatTagType(char, supportCodeSegments) !== 0 /* FormatType.Invalid */ ;
}
function formatTagType(char, supportCodeSegments) {
    switch(char){
        case "*":
            return 3 /* FormatType.Bold */ ;
        case "_":
            return 4 /* FormatType.Italics */ ;
        case "[":
            return 5 /* FormatType.Action */ ;
        case "]":
            return 6 /* FormatType.ActionClose */ ;
        case "`":
            return supportCodeSegments ? 7 /* FormatType.Code */  : 0 /* FormatType.Invalid */ ;
        default:
            return 0 /* FormatType.Invalid */ ;
    }
}

},{"./dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lXqhk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderLabelWithIcons", ()=>renderLabelWithIcons);
parcelHelpers.export(exports, "renderIcon", ()=>renderIcon);
var _domJs = require("../../dom.js");
var _themablesJs = require("../../../common/themables.js");
const labelWithIconsRegex = new RegExp(`(\\\\)?\\$\\((${(0, _themablesJs.ThemeIcon).iconNameExpression}(?:${(0, _themablesJs.ThemeIcon).iconModifierExpression})?)\\)`, "g");
function renderLabelWithIcons(text) {
    const elements = new Array();
    let match;
    let textStart = 0, textStop = 0;
    while((match = labelWithIconsRegex.exec(text)) !== null){
        textStop = match.index || 0;
        if (textStart < textStop) elements.push(text.substring(textStart, textStop));
        textStart = (match.index || 0) + match[0].length;
        const [, escaped, codicon] = match;
        elements.push(escaped ? `$(${codicon})` : renderIcon({
            id: codicon
        }));
    }
    if (textStart < text.length) elements.push(text.substring(textStart));
    return elements;
}
function renderIcon(icon) {
    const node = _domJs.$(`span`);
    node.classList.add(...(0, _themablesJs.ThemeIcon).asClassNameArray(icon));
    return node;
}

},{"../../dom.js":"bnqsM","../../../common/themables.js":"hgyHi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Hxzm":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkdownString", ()=>MarkdownString);
parcelHelpers.export(exports, "isEmptyMarkdownString", ()=>isEmptyMarkdownString);
parcelHelpers.export(exports, "isMarkdownString", ()=>isMarkdownString);
parcelHelpers.export(exports, "markdownStringEqual", ()=>markdownStringEqual);
parcelHelpers.export(exports, "escapeMarkdownSyntaxTokens", ()=>escapeMarkdownSyntaxTokens);
/**
 * @see https://github.com/microsoft/vscode/issues/193746
 */ parcelHelpers.export(exports, "appendEscapedMarkdownCodeBlockFence", ()=>appendEscapedMarkdownCodeBlockFence);
parcelHelpers.export(exports, "escapeDoubleQuotes", ()=>escapeDoubleQuotes);
parcelHelpers.export(exports, "removeMarkdownEscapes", ()=>removeMarkdownEscapes);
parcelHelpers.export(exports, "parseHrefAndDimensions", ()=>parseHrefAndDimensions);
var _errorsJs = require("./errors.js");
var _iconLabelsJs = require("./iconLabels.js");
var _resourcesJs = require("./resources.js");
var _stringsJs = require("./strings.js");
var _uriJs = require("./uri.js");
class MarkdownString {
    constructor(value = "", isTrustedOrOptions = false){
        this.value = value;
        if (typeof this.value !== "string") throw (0, _errorsJs.illegalArgument)("value");
        if (typeof isTrustedOrOptions === "boolean") {
            this.isTrusted = isTrustedOrOptions;
            this.supportThemeIcons = false;
            this.supportHtml = false;
        } else {
            this.isTrusted = isTrustedOrOptions.isTrusted ?? undefined;
            this.supportThemeIcons = isTrustedOrOptions.supportThemeIcons ?? false;
            this.supportHtml = isTrustedOrOptions.supportHtml ?? false;
        }
    }
    appendText(value, newlineStyle = 0 /* MarkdownStringTextNewlineStyle.Paragraph */ ) {
        this.value += escapeMarkdownSyntaxTokens(this.supportThemeIcons ? (0, _iconLabelsJs.escapeIcons)(value) : value) // CodeQL [SM02383] The Markdown is fully sanitized after being rendered.
        .replace(/([ \t]+)/g, (_match, g1)=>"&nbsp;".repeat(g1.length)) // CodeQL [SM02383] The Markdown is fully sanitized after being rendered.
        .replace(/\>/gm, "\\>") // CodeQL [SM02383] The Markdown is fully sanitized after being rendered.
        .replace(/\n/g, newlineStyle === 1 /* MarkdownStringTextNewlineStyle.Break */  ? "\\\n" : "\n\n"); // CodeQL [SM02383] The Markdown is fully sanitized after being rendered.
        return this;
    }
    appendMarkdown(value) {
        this.value += value;
        return this;
    }
    appendCodeblock(langId, code) {
        this.value += `\n${appendEscapedMarkdownCodeBlockFence(code, langId)}\n`;
        return this;
    }
    appendLink(target, label, title) {
        this.value += "[";
        this.value += this._escape(label, "]");
        this.value += "](";
        this.value += this._escape(String(target), ")");
        if (title) this.value += ` "${this._escape(this._escape(title, '"'), ")")}"`;
        this.value += ")";
        return this;
    }
    _escape(value, ch) {
        const r = new RegExp((0, _stringsJs.escapeRegExpCharacters)(ch), "g");
        return value.replace(r, (match, offset)=>{
            if (value.charAt(offset - 1) !== "\\") return `\\${match}`;
            else return match;
        });
    }
}
function isEmptyMarkdownString(oneOrMany) {
    if (isMarkdownString(oneOrMany)) return !oneOrMany.value;
    else if (Array.isArray(oneOrMany)) return oneOrMany.every(isEmptyMarkdownString);
    else return true;
}
function isMarkdownString(thing) {
    if (thing instanceof MarkdownString) return true;
    else if (thing && typeof thing === "object") return typeof thing.value === "string" && (typeof thing.isTrusted === "boolean" || typeof thing.isTrusted === "object" || thing.isTrusted === undefined) && (typeof thing.supportThemeIcons === "boolean" || thing.supportThemeIcons === undefined);
    return false;
}
function markdownStringEqual(a, b) {
    if (a === b) return true;
    else if (!a || !b) return false;
    else return a.value === b.value && a.isTrusted === b.isTrusted && a.supportThemeIcons === b.supportThemeIcons && a.supportHtml === b.supportHtml && (a.baseUri === b.baseUri || !!a.baseUri && !!b.baseUri && (0, _resourcesJs.isEqual)((0, _uriJs.URI).from(a.baseUri), (0, _uriJs.URI).from(b.baseUri)));
}
function escapeMarkdownSyntaxTokens(text) {
    // escape markdown syntax tokens: http://daringfireball.net/projects/markdown/syntax#backslash
    return text.replace(/[\\`*_{}[\]()#+\-!~]/g, "\\$&"); // CodeQL [SM02383] Backslash is escaped in the character class
}
function appendEscapedMarkdownCodeBlockFence(code, langId) {
    const longestFenceLength = code.match(/^`+/gm)?.reduce((a, b)=>a.length > b.length ? a : b).length ?? 0;
    const desiredFenceLength = longestFenceLength >= 3 ? longestFenceLength + 1 : 3;
    // the markdown result
    return [
        `${"`".repeat(desiredFenceLength)}${langId}`,
        code,
        `${"`".repeat(desiredFenceLength)}`
    ].join("\n");
}
function escapeDoubleQuotes(input) {
    return input.replace(/"/g, "&quot;");
}
function removeMarkdownEscapes(text) {
    if (!text) return text;
    return text.replace(/\\([\\`*_{}[\]()#+\-.!~])/g, "$1");
}
function parseHrefAndDimensions(href) {
    const dimensions = [];
    const splitted = href.split("|").map((s)=>s.trim());
    href = splitted[0];
    const parameters = splitted[1];
    if (parameters) {
        const heightFromParams = /height=(\d+)/.exec(parameters);
        const widthFromParams = /width=(\d+)/.exec(parameters);
        const height = heightFromParams ? heightFromParams[1] : "";
        const width = widthFromParams ? widthFromParams[1] : "";
        const widthIsFinite = isFinite(parseInt(width));
        const heightIsFinite = isFinite(parseInt(height));
        if (widthIsFinite) dimensions.push(`width="${width}"`);
        if (heightIsFinite) dimensions.push(`height="${height}"`);
    }
    return {
        href,
        dimensions
    };
}

},{"./errors.js":"divX8","./iconLabels.js":"3vhIZ","./resources.js":"700EV","./strings.js":"aA9I1","./uri.js":"7qGS3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3vhIZ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeIcons", ()=>escapeIcons);
parcelHelpers.export(exports, "markdownEscapeEscapedIcons", ()=>markdownEscapeEscapedIcons);
/**
 * Takes a label with icons (`$(iconId)xyz`)  and strips the icons out (`xyz`)
 */ parcelHelpers.export(exports, "stripIcons", ()=>stripIcons);
/**
 * Takes a label with icons (`$(iconId)xyz`), removes the icon syntax adds whitespace so that screen readers can read the text better.
 */ parcelHelpers.export(exports, "getCodiconAriaLabel", ()=>getCodiconAriaLabel);
/**
 * Takes a label with icons (`abc $(iconId)xyz`) and returns the text (`abc xyz`) and the offsets of the icons (`[3]`)
 */ parcelHelpers.export(exports, "parseLabelWithIcons", ()=>parseLabelWithIcons);
parcelHelpers.export(exports, "matchesFuzzyIconAware", ()=>matchesFuzzyIconAware);
var _filtersJs = require("./filters.js");
var _stringsJs = require("./strings.js");
var _themablesJs = require("./themables.js");
const iconStartMarker = "$(";
const iconsRegex = new RegExp(`\\$\\(${(0, _themablesJs.ThemeIcon).iconNameExpression}(?:${(0, _themablesJs.ThemeIcon).iconModifierExpression})?\\)`, "g"); // no capturing groups
const escapeIconsRegex = new RegExp(`(\\\\)?${iconsRegex.source}`, "g");
function escapeIcons(text) {
    return text.replace(escapeIconsRegex, (match, escaped)=>escaped ? match : `\\${match}`);
}
const markdownEscapedIconsRegex = new RegExp(`\\\\${iconsRegex.source}`, "g");
function markdownEscapeEscapedIcons(text) {
    // Need to add an extra \ for escaping in markdown
    return text.replace(markdownEscapedIconsRegex, (match)=>`\\${match}`);
}
const stripIconsRegex = new RegExp(`(\\s)?(\\\\)?${iconsRegex.source}(\\s)?`, "g");
function stripIcons(text) {
    if (text.indexOf(iconStartMarker) === -1) return text;
    return text.replace(stripIconsRegex, (match, preWhitespace, escaped, postWhitespace)=>escaped ? match : preWhitespace || postWhitespace || "");
}
function getCodiconAriaLabel(text) {
    if (!text) return "";
    return text.replace(/\$\((.*?)\)/g, (_match, codiconName)=>` ${codiconName} `).trim();
}
const _parseIconsRegex = new RegExp(`\\$\\(${(0, _themablesJs.ThemeIcon).iconNameCharacter}+\\)`, "g");
function parseLabelWithIcons(input) {
    _parseIconsRegex.lastIndex = 0;
    let text = "";
    const iconOffsets = [];
    let iconsOffset = 0;
    while(true){
        const pos = _parseIconsRegex.lastIndex;
        const match = _parseIconsRegex.exec(input);
        const chars = input.substring(pos, match?.index);
        if (chars.length > 0) {
            text += chars;
            for(let i = 0; i < chars.length; i++)iconOffsets.push(iconsOffset);
        }
        if (!match) break;
        iconsOffset += match[0].length;
    }
    return {
        text,
        iconOffsets
    };
}
function matchesFuzzyIconAware(query, target, enableSeparateSubstringMatching = false) {
    const { text, iconOffsets } = target;
    // Return early if there are no icon markers in the word to match against
    if (!iconOffsets || iconOffsets.length === 0) return (0, _filtersJs.matchesFuzzy)(query, text, enableSeparateSubstringMatching);
    // Trim the word to match against because it could have leading
    // whitespace now if the word started with an icon
    const wordToMatchAgainstWithoutIconsTrimmed = (0, _stringsJs.ltrim)(text, " ");
    const leadingWhitespaceOffset = text.length - wordToMatchAgainstWithoutIconsTrimmed.length;
    // match on value without icon
    const matches = (0, _filtersJs.matchesFuzzy)(query, wordToMatchAgainstWithoutIconsTrimmed, enableSeparateSubstringMatching);
    // Map matches back to offsets with icon and trimming
    if (matches) for (const match of matches){
        const iconOffset = iconOffsets[match.start + leadingWhitespaceOffset] + leadingWhitespaceOffset /* overall leading whitespace offset */ ;
        match.start += iconOffset;
        match.end += iconOffset;
    }
    return matches;
}

},{"./filters.js":"40BGZ","./strings.js":"aA9I1","./themables.js":"hgyHi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"40BGZ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Combined filters
/**
 * @returns A filter which combines the provided set
 * of filters with an or. The *first* filters that
 * matches defined the return value of the returned
 * filter.
 */ parcelHelpers.export(exports, "or", ()=>or);
parcelHelpers.export(exports, "matchesStrictPrefix", ()=>matchesStrictPrefix);
parcelHelpers.export(exports, "matchesPrefix", ()=>matchesPrefix);
// Contiguous Substring
parcelHelpers.export(exports, "matchesContiguousSubString", ()=>matchesContiguousSubString);
// Substring
parcelHelpers.export(exports, "matchesSubString", ()=>matchesSubString);
parcelHelpers.export(exports, "isUpper", ()=>isUpper);
parcelHelpers.export(exports, "matchesCamelCase", ()=>matchesCamelCase);
// Matches beginning of words supporting non-ASCII languages
// If `contiguous` is true then matches word with beginnings of the words in the target. E.g. "pul" will match "Git: Pull"
// Otherwise also matches sub string of the word with beginnings of the words in the target. E.g. "gp" or "g p" will match "Git: Pull"
// Useful in cases where the target is words (e.g. command labels)
parcelHelpers.export(exports, "matchesWords", ()=>matchesWords);
parcelHelpers.export(exports, "matchesFuzzy", ()=>matchesFuzzy);
/**
 * Match pattern against word in a fuzzy way. As in IntelliSense and faster and more
 * powerful than `matchesFuzzy`
 */ parcelHelpers.export(exports, "matchesFuzzy2", ()=>matchesFuzzy2);
parcelHelpers.export(exports, "anyScore", ()=>anyScore);
//#region --- fuzzyScore ---
parcelHelpers.export(exports, "createMatches", ()=>createMatches);
parcelHelpers.export(exports, "isPatternInWord", ()=>isPatternInWord);
parcelHelpers.export(exports, "FuzzyScore", ()=>FuzzyScore);
parcelHelpers.export(exports, "FuzzyScoreOptions", ()=>FuzzyScoreOptions);
parcelHelpers.export(exports, "fuzzyScore", ()=>fuzzyScore);
//#endregion
//#region --- graceful ---
parcelHelpers.export(exports, "fuzzyScoreGracefulAggressive", ()=>fuzzyScoreGracefulAggressive);
var _mapJs = require("./map.js");
var _koreanJs = require("./naturalLanguage/korean.js");
var _stringsJs = require("./strings.js");
function or(...filter) {
    return function(word, wordToMatchAgainst) {
        for(let i = 0, len = filter.length; i < len; i++){
            const match = filter[i](word, wordToMatchAgainst);
            if (match) return match;
        }
        return null;
    };
}
const matchesStrictPrefix = _matchesPrefix.bind(undefined, false);
const matchesPrefix = _matchesPrefix.bind(undefined, true);
function _matchesPrefix(ignoreCase, word, wordToMatchAgainst) {
    if (!wordToMatchAgainst || wordToMatchAgainst.length < word.length) return null;
    let matches;
    if (ignoreCase) matches = _stringsJs.startsWithIgnoreCase(wordToMatchAgainst, word);
    else matches = wordToMatchAgainst.indexOf(word) === 0;
    if (!matches) return null;
    return word.length > 0 ? [
        {
            start: 0,
            end: word.length
        }
    ] : [];
}
function matchesContiguousSubString(word, wordToMatchAgainst) {
    const index = wordToMatchAgainst.toLowerCase().indexOf(word.toLowerCase());
    if (index === -1) return null;
    return [
        {
            start: index,
            end: index + word.length
        }
    ];
}
function matchesSubString(word, wordToMatchAgainst) {
    return _matchesSubString(word.toLowerCase(), wordToMatchAgainst.toLowerCase(), 0, 0);
}
function _matchesSubString(word, wordToMatchAgainst, i, j) {
    if (i === word.length) return [];
    else if (j === wordToMatchAgainst.length) return null;
    else {
        if (word[i] === wordToMatchAgainst[j]) {
            let result = null;
            if (result = _matchesSubString(word, wordToMatchAgainst, i + 1, j + 1)) return join({
                start: j,
                end: j + 1
            }, result);
            return null;
        }
        return _matchesSubString(word, wordToMatchAgainst, i, j + 1);
    }
}
// CamelCase
function isLower(code) {
    return 97 /* CharCode.a */  <= code && code <= 122 /* CharCode.z */ ;
}
function isUpper(code) {
    return 65 /* CharCode.A */  <= code && code <= 90 /* CharCode.Z */ ;
}
function isNumber(code) {
    return 48 /* CharCode.Digit0 */  <= code && code <= 57 /* CharCode.Digit9 */ ;
}
function isWhitespace(code) {
    return code === 32 /* CharCode.Space */  || code === 9 /* CharCode.Tab */  || code === 10 /* CharCode.LineFeed */  || code === 13 /* CharCode.CarriageReturn */ ;
}
const wordSeparators = new Set();
// These are chosen as natural word separators based on writen text.
// It is a subset of the word separators used by the monaco editor.
"()[]{}<>`'\"-/;:,.?!".split("").forEach((s)=>wordSeparators.add(s.charCodeAt(0)));
function isWordSeparator(code) {
    return isWhitespace(code) || wordSeparators.has(code);
}
function charactersMatch(codeA, codeB) {
    return codeA === codeB || isWordSeparator(codeA) && isWordSeparator(codeB);
}
const alternateCharsCache = new Map();
/**
 * Gets alternative codes to the character code passed in. This comes in the
 * form of an array of character codes, all of which must match _in order_ to
 * successfully match.
 *
 * @param code The character code to check.
 */ function getAlternateCodes(code) {
    if (alternateCharsCache.has(code)) return alternateCharsCache.get(code);
    // NOTE: This function is written in such a way that it can be extended in
    // the future, but right now the return type takes into account it's only
    // supported by a single "alt codes provider".
    // `ArrayLike<ArrayLike<number>>` is a more appropriate type if changed.
    let result;
    const codes = (0, _koreanJs.getKoreanAltChars)(code);
    if (codes) result = codes;
    alternateCharsCache.set(code, result);
    return result;
}
function isAlphanumeric(code) {
    return isLower(code) || isUpper(code) || isNumber(code);
}
function join(head, tail) {
    if (tail.length === 0) tail = [
        head
    ];
    else if (head.end === tail[0].start) tail[0].start = head.start;
    else tail.unshift(head);
    return tail;
}
function nextAnchor(camelCaseWord, start) {
    for(let i = start; i < camelCaseWord.length; i++){
        const c = camelCaseWord.charCodeAt(i);
        if (isUpper(c) || isNumber(c) || i > 0 && !isAlphanumeric(camelCaseWord.charCodeAt(i - 1))) return i;
    }
    return camelCaseWord.length;
}
function _matchesCamelCase(word, camelCaseWord, i, j) {
    if (i === word.length) return [];
    else if (j === camelCaseWord.length) return null;
    else if (word[i] !== camelCaseWord[j].toLowerCase()) return null;
    else {
        let result = null;
        let nextUpperIndex = j + 1;
        result = _matchesCamelCase(word, camelCaseWord, i + 1, j + 1);
        while(!result && (nextUpperIndex = nextAnchor(camelCaseWord, nextUpperIndex)) < camelCaseWord.length){
            result = _matchesCamelCase(word, camelCaseWord, i + 1, nextUpperIndex);
            nextUpperIndex++;
        }
        return result === null ? null : join({
            start: j,
            end: j + 1
        }, result);
    }
}
// Heuristic to avoid computing camel case matcher for words that don't
// look like camelCaseWords.
function analyzeCamelCaseWord(word) {
    let upper = 0, lower = 0, alpha = 0, numeric = 0, code = 0;
    for(let i = 0; i < word.length; i++){
        code = word.charCodeAt(i);
        if (isUpper(code)) upper++;
        if (isLower(code)) lower++;
        if (isAlphanumeric(code)) alpha++;
        if (isNumber(code)) numeric++;
    }
    const upperPercent = upper / word.length;
    const lowerPercent = lower / word.length;
    const alphaPercent = alpha / word.length;
    const numericPercent = numeric / word.length;
    return {
        upperPercent,
        lowerPercent,
        alphaPercent,
        numericPercent
    };
}
function isUpperCaseWord(analysis) {
    const { upperPercent, lowerPercent } = analysis;
    return lowerPercent === 0 && upperPercent > 0.6;
}
function isCamelCaseWord(analysis) {
    const { upperPercent, lowerPercent, alphaPercent, numericPercent } = analysis;
    return lowerPercent > 0.2 && upperPercent < 0.8 && alphaPercent > 0.6 && numericPercent < 0.2;
}
// Heuristic to avoid computing camel case matcher for words that don't
// look like camel case patterns.
function isCamelCasePattern(word) {
    let upper = 0, lower = 0, code = 0, whitespace = 0;
    for(let i = 0; i < word.length; i++){
        code = word.charCodeAt(i);
        if (isUpper(code)) upper++;
        if (isLower(code)) lower++;
        if (isWhitespace(code)) whitespace++;
    }
    if ((upper === 0 || lower === 0) && whitespace === 0) return word.length <= 30;
    else return upper <= 5;
}
function matchesCamelCase(word, camelCaseWord) {
    if (!camelCaseWord) return null;
    camelCaseWord = camelCaseWord.trim();
    if (camelCaseWord.length === 0) return null;
    if (!isCamelCasePattern(word)) return null;
    // TODO: Consider removing this check
    if (camelCaseWord.length > 60) camelCaseWord = camelCaseWord.substring(0, 60);
    const analysis = analyzeCamelCaseWord(camelCaseWord);
    if (!isCamelCaseWord(analysis)) {
        if (!isUpperCaseWord(analysis)) return null;
        camelCaseWord = camelCaseWord.toLowerCase();
    }
    let result = null;
    let i = 0;
    word = word.toLowerCase();
    while(i < camelCaseWord.length && (result = _matchesCamelCase(word, camelCaseWord, 0, i)) === null)i = nextAnchor(camelCaseWord, i + 1);
    return result;
}
function matchesWords(word, target, contiguous = false) {
    if (!target || target.length === 0) return null;
    let result = null;
    let targetIndex = 0;
    word = word.toLowerCase();
    target = target.toLowerCase();
    while(targetIndex < target.length){
        result = _matchesWords(word, target, 0, targetIndex, contiguous);
        if (result !== null) break;
        targetIndex = nextWord(target, targetIndex + 1);
    }
    return result;
}
function _matchesWords(word, target, wordIndex, targetIndex, contiguous) {
    let targetIndexOffset = 0;
    if (wordIndex === word.length) return [];
    else if (targetIndex === target.length) return null;
    else if (!charactersMatch(word.charCodeAt(wordIndex), target.charCodeAt(targetIndex))) {
        // Verify alternate characters before exiting
        const altChars = getAlternateCodes(word.charCodeAt(wordIndex));
        if (!altChars) return null;
        for(let k = 0; k < altChars.length; k++){
            if (!charactersMatch(altChars[k], target.charCodeAt(targetIndex + k))) return null;
        }
        targetIndexOffset += altChars.length - 1;
    }
    let result = null;
    let nextWordIndex = targetIndex + targetIndexOffset + 1;
    result = _matchesWords(word, target, wordIndex + 1, nextWordIndex, contiguous);
    if (!contiguous) while(!result && (nextWordIndex = nextWord(target, nextWordIndex)) < target.length){
        result = _matchesWords(word, target, wordIndex + 1, nextWordIndex, contiguous);
        nextWordIndex++;
    }
    if (!result) return null;
    // If the characters don't exactly match, then they must be word separators (see charactersMatch(...)).
    // We don't want to include this in the matches but we don't want to throw the target out all together so we return `result`.
    if (word.charCodeAt(wordIndex) !== target.charCodeAt(targetIndex)) {
        // Verify alternate characters before exiting
        const altChars = getAlternateCodes(word.charCodeAt(wordIndex));
        if (!altChars) return result;
        for(let k = 0; k < altChars.length; k++){
            if (altChars[k] !== target.charCodeAt(targetIndex + k)) return result;
        }
    }
    return join({
        start: targetIndex,
        end: targetIndex + targetIndexOffset + 1
    }, result);
}
function nextWord(word, start) {
    for(let i = start; i < word.length; i++){
        if (isWordSeparator(word.charCodeAt(i)) || i > 0 && isWordSeparator(word.charCodeAt(i - 1))) return i;
    }
    return word.length;
}
// Fuzzy
const fuzzyContiguousFilter = or(matchesPrefix, matchesCamelCase, matchesContiguousSubString);
const fuzzySeparateFilter = or(matchesPrefix, matchesCamelCase, matchesSubString);
const fuzzyRegExpCache = new (0, _mapJs.LRUCache)(10000); // bounded to 10000 elements
function matchesFuzzy(word, wordToMatchAgainst, enableSeparateSubstringMatching = false) {
    if (typeof word !== "string" || typeof wordToMatchAgainst !== "string") return null; // return early for invalid input
    // Form RegExp for wildcard matches
    let regexp = fuzzyRegExpCache.get(word);
    if (!regexp) {
        regexp = new RegExp(_stringsJs.convertSimple2RegExpPattern(word), "i");
        fuzzyRegExpCache.set(word, regexp);
    }
    // RegExp Filter
    const match = regexp.exec(wordToMatchAgainst);
    if (match) return [
        {
            start: match.index,
            end: match.index + match[0].length
        }
    ];
    // Default Filter
    return enableSeparateSubstringMatching ? fuzzySeparateFilter(word, wordToMatchAgainst) : fuzzyContiguousFilter(word, wordToMatchAgainst);
}
function matchesFuzzy2(pattern, word) {
    const score = fuzzyScore(pattern, pattern.toLowerCase(), 0, word, word.toLowerCase(), 0, {
        firstMatchCanBeWeak: true,
        boostFullMatch: true
    });
    return score ? createMatches(score) : null;
}
function anyScore(pattern, lowPattern, patternPos, word, lowWord, wordPos) {
    const max = Math.min(13, pattern.length);
    for(; patternPos < max; patternPos++){
        const result = fuzzyScore(pattern, lowPattern, patternPos, word, lowWord, wordPos, {
            firstMatchCanBeWeak: true,
            boostFullMatch: true
        });
        if (result) return result;
    }
    return [
        0,
        wordPos
    ];
}
function createMatches(score) {
    if (typeof score === "undefined") return [];
    const res = [];
    const wordPos = score[1];
    for(let i = score.length - 1; i > 1; i--){
        const pos = score[i] + wordPos;
        const last = res[res.length - 1];
        if (last && last.end === pos) last.end = pos + 1;
        else res.push({
            start: pos,
            end: pos + 1
        });
    }
    return res;
}
const _maxLen = 128;
function initTable() {
    const table = [];
    const row = [];
    for(let i = 0; i <= _maxLen; i++)row[i] = 0;
    for(let i = 0; i <= _maxLen; i++)table.push(row.slice(0));
    return table;
}
function initArr(maxLen) {
    const row = [];
    for(let i = 0; i <= maxLen; i++)row[i] = 0;
    return row;
}
const _minWordMatchPos = initArr(2 * _maxLen); // min word position for a certain pattern position
const _maxWordMatchPos = initArr(2 * _maxLen); // max word position for a certain pattern position
const _diag = initTable(); // the length of a contiguous diagonal match
const _table = initTable();
const _arrows = initTable();
const _debug = false;
function printTable(table, pattern, patternLen, word, wordLen) {
    function pad(s, n, pad = " ") {
        while(s.length < n)s = pad + s;
        return s;
    }
    let ret = ` |   |${word.split("").map((c)=>pad(c, 3)).join("|")}\n`;
    for(let i = 0; i <= patternLen; i++){
        if (i === 0) ret += " |";
        else ret += `${pattern[i - 1]}|`;
        ret += table[i].slice(0, wordLen + 1).map((n)=>pad(n.toString(), 3)).join("|") + "\n";
    }
    return ret;
}
function printTables(pattern, patternStart, word, wordStart) {
    pattern = pattern.substr(patternStart);
    word = word.substr(wordStart);
    console.log(printTable(_table, pattern, pattern.length, word, word.length));
    console.log(printTable(_arrows, pattern, pattern.length, word, word.length));
    console.log(printTable(_diag, pattern, pattern.length, word, word.length));
}
function isSeparatorAtPos(value, index) {
    if (index < 0 || index >= value.length) return false;
    const code = value.codePointAt(index);
    switch(code){
        case 95 /* CharCode.Underline */ :
        case 45 /* CharCode.Dash */ :
        case 46 /* CharCode.Period */ :
        case 32 /* CharCode.Space */ :
        case 47 /* CharCode.Slash */ :
        case 92 /* CharCode.Backslash */ :
        case 39 /* CharCode.SingleQuote */ :
        case 34 /* CharCode.DoubleQuote */ :
        case 58 /* CharCode.Colon */ :
        case 36 /* CharCode.DollarSign */ :
        case 60 /* CharCode.LessThan */ :
        case 62 /* CharCode.GreaterThan */ :
        case 40 /* CharCode.OpenParen */ :
        case 41 /* CharCode.CloseParen */ :
        case 91 /* CharCode.OpenSquareBracket */ :
        case 93 /* CharCode.CloseSquareBracket */ :
        case 123 /* CharCode.OpenCurlyBrace */ :
        case 125 /* CharCode.CloseCurlyBrace */ :
            return true;
        case undefined:
            return false;
        default:
            if (_stringsJs.isEmojiImprecise(code)) return true;
            return false;
    }
}
function isWhitespaceAtPos(value, index) {
    if (index < 0 || index >= value.length) return false;
    const code = value.charCodeAt(index);
    switch(code){
        case 32 /* CharCode.Space */ :
        case 9 /* CharCode.Tab */ :
            return true;
        default:
            return false;
    }
}
function isUpperCaseAtPos(pos, word, wordLow) {
    return word[pos] !== wordLow[pos];
}
function isPatternInWord(patternLow, patternPos, patternLen, wordLow, wordPos, wordLen, fillMinWordPosArr = false) {
    while(patternPos < patternLen && wordPos < wordLen){
        if (patternLow[patternPos] === wordLow[wordPos]) {
            if (fillMinWordPosArr) // Remember the min word position for each pattern position
            _minWordMatchPos[patternPos] = wordPos;
            patternPos += 1;
        }
        wordPos += 1;
    }
    return patternPos === patternLen; // pattern must be exhausted
}
var FuzzyScore;
(function(FuzzyScore) {
    /**
     * No matches and value `-100`
     */ FuzzyScore.Default = [
        -100,
        0
    ];
    function isDefault(score) {
        return !score || score.length === 2 && score[0] === -100 && score[1] === 0;
    }
    FuzzyScore.isDefault = isDefault;
})(FuzzyScore || (FuzzyScore = {}));
class FuzzyScoreOptions {
    static{
        this.default = {
            boostFullMatch: true,
            firstMatchCanBeWeak: false
        };
    }
    constructor(firstMatchCanBeWeak, boostFullMatch){
        this.firstMatchCanBeWeak = firstMatchCanBeWeak;
        this.boostFullMatch = boostFullMatch;
    }
}
function fuzzyScore(pattern, patternLow, patternStart, word, wordLow, wordStart, options = FuzzyScoreOptions.default) {
    const patternLen = pattern.length > _maxLen ? _maxLen : pattern.length;
    const wordLen = word.length > _maxLen ? _maxLen : word.length;
    if (patternStart >= patternLen || wordStart >= wordLen || patternLen - patternStart > wordLen - wordStart) return undefined;
    // Run a simple check if the characters of pattern occur
    // (in order) at all in word. If that isn't the case we
    // stop because no match will be possible
    if (!isPatternInWord(patternLow, patternStart, patternLen, wordLow, wordStart, wordLen, true)) return undefined;
    // Find the max matching word position for each pattern position
    // NOTE: the min matching word position was filled in above, in the `isPatternInWord` call
    _fillInMaxWordMatchPos(patternLen, wordLen, patternStart, wordStart, patternLow, wordLow);
    let row = 1;
    let column = 1;
    let patternPos = patternStart;
    let wordPos = wordStart;
    const hasStrongFirstMatch = [
        false
    ];
    // There will be a match, fill in tables
    for(row = 1, patternPos = patternStart; patternPos < patternLen; row++, patternPos++){
        // Reduce search space to possible matching word positions and to possible access from next row
        const minWordMatchPos = _minWordMatchPos[patternPos];
        const maxWordMatchPos = _maxWordMatchPos[patternPos];
        const nextMaxWordMatchPos = patternPos + 1 < patternLen ? _maxWordMatchPos[patternPos + 1] : wordLen;
        for(column = minWordMatchPos - wordStart + 1, wordPos = minWordMatchPos; wordPos < nextMaxWordMatchPos; column++, wordPos++){
            let score = Number.MIN_SAFE_INTEGER;
            let canComeDiag = false;
            if (wordPos <= maxWordMatchPos) score = _doScore(pattern, patternLow, patternPos, patternStart, word, wordLow, wordPos, wordLen, wordStart, _diag[row - 1][column - 1] === 0, hasStrongFirstMatch);
            let diagScore = 0;
            if (score !== Number.MAX_SAFE_INTEGER) {
                canComeDiag = true;
                diagScore = score + _table[row - 1][column - 1];
            }
            const canComeLeft = wordPos > minWordMatchPos;
            const leftScore = canComeLeft ? _table[row][column - 1] + (_diag[row][column - 1] > 0 ? -5 : 0) : 0; // penalty for a gap start
            const canComeLeftLeft = wordPos > minWordMatchPos + 1 && _diag[row][column - 1] > 0;
            const leftLeftScore = canComeLeftLeft ? _table[row][column - 2] + (_diag[row][column - 2] > 0 ? -5 : 0) : 0; // penalty for a gap start
            if (canComeLeftLeft && (!canComeLeft || leftLeftScore >= leftScore) && (!canComeDiag || leftLeftScore >= diagScore)) {
                // always prefer choosing left left to jump over a diagonal because that means a match is earlier in the word
                _table[row][column] = leftLeftScore;
                _arrows[row][column] = 3 /* Arrow.LeftLeft */ ;
                _diag[row][column] = 0;
            } else if (canComeLeft && (!canComeDiag || leftScore >= diagScore)) {
                // always prefer choosing left since that means a match is earlier in the word
                _table[row][column] = leftScore;
                _arrows[row][column] = 2 /* Arrow.Left */ ;
                _diag[row][column] = 0;
            } else if (canComeDiag) {
                _table[row][column] = diagScore;
                _arrows[row][column] = 1 /* Arrow.Diag */ ;
                _diag[row][column] = _diag[row - 1][column - 1] + 1;
            } else throw new Error(`not possible`);
        }
    }
    if (_debug) printTables(pattern, patternStart, word, wordStart);
    if (!hasStrongFirstMatch[0] && !options.firstMatchCanBeWeak) return undefined;
    row--;
    column--;
    const result = [
        _table[row][column],
        wordStart
    ];
    let backwardsDiagLength = 0;
    let maxMatchColumn = 0;
    while(row >= 1){
        // Find the column where we go diagonally up
        let diagColumn = column;
        do {
            const arrow = _arrows[row][diagColumn];
            if (arrow === 3 /* Arrow.LeftLeft */ ) diagColumn = diagColumn - 2;
            else if (arrow === 2 /* Arrow.Left */ ) diagColumn = diagColumn - 1;
            else break;
        }while (diagColumn >= 1);
        // Overturn the "forwards" decision if keeping the "backwards" diagonal would give a better match
        if (backwardsDiagLength > 1 // only if we would have a contiguous match of 3 characters
         && patternLow[patternStart + row - 1] === wordLow[wordStart + column - 1] // only if we can do a contiguous match diagonally
         && !isUpperCaseAtPos(diagColumn + wordStart - 1, word, wordLow) // only if the forwards chose diagonal is not an uppercase
         && backwardsDiagLength + 1 > _diag[row][diagColumn] // only if our contiguous match would be longer than the "forwards" contiguous match
        ) diagColumn = column;
        if (diagColumn === column) // this is a contiguous match
        backwardsDiagLength++;
        else backwardsDiagLength = 1;
        if (!maxMatchColumn) // remember the last matched column
        maxMatchColumn = diagColumn;
        row--;
        column = diagColumn - 1;
        result.push(column);
    }
    if (wordLen - wordStart === patternLen && options.boostFullMatch) // the word matches the pattern with all characters!
    // giving the score a total match boost (to come up ahead other words)
    result[0] += 2;
    // Add 1 penalty for each skipped character in the word
    const skippedCharsCount = maxMatchColumn - patternLen;
    result[0] -= skippedCharsCount;
    return result;
}
function _fillInMaxWordMatchPos(patternLen, wordLen, patternStart, wordStart, patternLow, wordLow) {
    let patternPos = patternLen - 1;
    let wordPos = wordLen - 1;
    while(patternPos >= patternStart && wordPos >= wordStart){
        if (patternLow[patternPos] === wordLow[wordPos]) {
            _maxWordMatchPos[patternPos] = wordPos;
            patternPos--;
        }
        wordPos--;
    }
}
function _doScore(pattern, patternLow, patternPos, patternStart, word, wordLow, wordPos, wordLen, wordStart, newMatchStart, outFirstMatchStrong) {
    if (patternLow[patternPos] !== wordLow[wordPos]) return Number.MIN_SAFE_INTEGER;
    let score = 1;
    let isGapLocation = false;
    if (wordPos === patternPos - patternStart) // common prefix: `foobar <-> foobaz`
    //                            ^^^^^
    score = pattern[patternPos] === word[wordPos] ? 7 : 5;
    else if (isUpperCaseAtPos(wordPos, word, wordLow) && (wordPos === 0 || !isUpperCaseAtPos(wordPos - 1, word, wordLow))) {
        // hitting upper-case: `foo <-> forOthers`
        //                              ^^ ^
        score = pattern[patternPos] === word[wordPos] ? 7 : 5;
        isGapLocation = true;
    } else if (isSeparatorAtPos(wordLow, wordPos) && (wordPos === 0 || !isSeparatorAtPos(wordLow, wordPos - 1))) // hitting a separator: `. <-> foo.bar`
    //                                ^
    score = 5;
    else if (isSeparatorAtPos(wordLow, wordPos - 1) || isWhitespaceAtPos(wordLow, wordPos - 1)) {
        // post separator: `foo <-> bar_foo`
        //                              ^^^
        score = 5;
        isGapLocation = true;
    }
    if (score > 1 && patternPos === patternStart) outFirstMatchStrong[0] = true;
    if (!isGapLocation) isGapLocation = isUpperCaseAtPos(wordPos, word, wordLow) || isSeparatorAtPos(wordLow, wordPos - 1) || isWhitespaceAtPos(wordLow, wordPos - 1);
    //
    if (patternPos === patternStart) {
        if (wordPos > wordStart) // the first pattern character would match a word character that is not at the word start
        // so introduce a penalty to account for the gap preceding this match
        score -= isGapLocation ? 3 : 5;
    } else if (newMatchStart) // this would be the beginning of a new match (i.e. there would be a gap before this location)
    score += isGapLocation ? 2 : 0;
    else // this is part of a contiguous match, so give it a slight bonus, but do so only if it would not be a preferred gap location
    score += isGapLocation ? 0 : 1;
    if (wordPos + 1 === wordLen) // we always penalize gaps, but this gives unfair advantages to a match that would match the last character in the word
    // so pretend there is a gap after the last character in the word to normalize things
    score -= isGapLocation ? 3 : 5;
    return score;
}
function fuzzyScoreGracefulAggressive(pattern, lowPattern, patternPos, word, lowWord, wordPos, options) {
    return fuzzyScoreWithPermutations(pattern, lowPattern, patternPos, word, lowWord, wordPos, true, options);
}
function fuzzyScoreWithPermutations(pattern, lowPattern, patternPos, word, lowWord, wordPos, aggressive, options) {
    let top = fuzzyScore(pattern, lowPattern, patternPos, word, lowWord, wordPos, options);
    if (top && !aggressive) // when using the original pattern yield a result we`
    // return it unless we are aggressive and try to find
    // a better alignment, e.g. `cno` -> `^co^ns^ole` or `^c^o^nsole`.
    return top;
    if (pattern.length >= 3) {
        // When the pattern is long enough then try a few (max 7)
        // permutations of the pattern to find a better match. The
        // permutations only swap neighbouring characters, e.g
        // `cnoso` becomes `conso`, `cnsoo`, `cnoos`.
        const tries = Math.min(7, pattern.length - 1);
        for(let movingPatternPos = patternPos + 1; movingPatternPos < tries; movingPatternPos++){
            const newPattern = nextTypoPermutation(pattern, movingPatternPos);
            if (newPattern) {
                const candidate = fuzzyScore(newPattern, newPattern.toLowerCase(), patternPos, word, lowWord, wordPos, options);
                if (candidate) {
                    candidate[0] -= 3; // permutation penalty
                    if (!top || candidate[0] > top[0]) top = candidate;
                }
            }
        }
    }
    return top;
}
function nextTypoPermutation(pattern, patternPos) {
    if (patternPos + 1 >= pattern.length) return undefined;
    const swap1 = pattern[patternPos];
    const swap2 = pattern[patternPos + 1];
    if (swap1 === swap2) return undefined;
    return pattern.slice(0, patternPos) + swap2 + swap1 + pattern.slice(patternPos + 2);
} //#endregion

},{"./map.js":"leSjz","./naturalLanguage/korean.js":"18eX3","./strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"18eX3":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ // allow-any-unicode-comment-file
/**
 * Gets alternative Korean characters for the character code. This will return the ascii
 * character code(s) that a Hangul character may have been input with using a qwerty layout.
 *
 * This only aims to cover modern (not archaic) Hangul syllables.
 *
 * @param code The character code to get alternate characters for
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getKoreanAltChars", ()=>getKoreanAltChars);
function getKoreanAltChars(code) {
    const result = disassembleKorean(code);
    if (result && result.length > 0) return new Uint32Array(result);
    return undefined;
}
let codeBufferLength = 0;
const codeBuffer = new Uint32Array(10);
function disassembleKorean(code) {
    codeBufferLength = 0;
    // Initial consonants (초성)
    getCodesFromArray(code, modernConsonants, 4352 /* HangulRangeStartCode.InitialConsonant */ );
    if (codeBufferLength > 0) return codeBuffer.subarray(0, codeBufferLength);
    // Vowels (중성)
    getCodesFromArray(code, modernVowels, 4449 /* HangulRangeStartCode.Vowel */ );
    if (codeBufferLength > 0) return codeBuffer.subarray(0, codeBufferLength);
    // Final consonants (종성)
    getCodesFromArray(code, modernFinalConsonants, 4520 /* HangulRangeStartCode.FinalConsonant */ );
    if (codeBufferLength > 0) return codeBuffer.subarray(0, codeBufferLength);
    // Hangul Compatibility Jamo
    getCodesFromArray(code, compatibilityJamo, 12593 /* HangulRangeStartCode.CompatibilityJamo */ );
    if (codeBufferLength) return codeBuffer.subarray(0, codeBufferLength);
    // Hangul Syllables
    if (code >= 0xAC00 && code <= 0xD7A3) {
        const hangulIndex = code - 0xAC00;
        const vowelAndFinalConsonantProduct = hangulIndex % 588;
        // 0-based starting at 0x1100
        const initialConsonantIndex = Math.floor(hangulIndex / 588);
        // 0-based starting at 0x1161
        const vowelIndex = Math.floor(vowelAndFinalConsonantProduct / 28);
        // 0-based starting at 0x11A8
        // Subtract 1 as the standard algorithm uses the 0 index to represent no
        // final consonant
        const finalConsonantIndex = vowelAndFinalConsonantProduct % 28 - 1;
        if (initialConsonantIndex < modernConsonants.length) getCodesFromArray(initialConsonantIndex, modernConsonants, 0);
        else if (4352 /* HangulRangeStartCode.InitialConsonant */  + initialConsonantIndex - 12593 /* HangulRangeStartCode.CompatibilityJamo */  < compatibilityJamo.length) getCodesFromArray(4352 /* HangulRangeStartCode.InitialConsonant */  + initialConsonantIndex, compatibilityJamo, 12593 /* HangulRangeStartCode.CompatibilityJamo */ );
        if (vowelIndex < modernVowels.length) getCodesFromArray(vowelIndex, modernVowels, 0);
        else if (4449 /* HangulRangeStartCode.Vowel */  + vowelIndex - 12593 /* HangulRangeStartCode.CompatibilityJamo */  < compatibilityJamo.length) getCodesFromArray(4449 /* HangulRangeStartCode.Vowel */  + vowelIndex - 12593 /* HangulRangeStartCode.CompatibilityJamo */ , compatibilityJamo, 12593 /* HangulRangeStartCode.CompatibilityJamo */ );
        if (finalConsonantIndex >= 0) {
            if (finalConsonantIndex < modernFinalConsonants.length) getCodesFromArray(finalConsonantIndex, modernFinalConsonants, 0);
            else if (4520 /* HangulRangeStartCode.FinalConsonant */  + finalConsonantIndex - 12593 /* HangulRangeStartCode.CompatibilityJamo */  < compatibilityJamo.length) getCodesFromArray(4520 /* HangulRangeStartCode.FinalConsonant */  + finalConsonantIndex - 12593 /* HangulRangeStartCode.CompatibilityJamo */ , compatibilityJamo, 12593 /* HangulRangeStartCode.CompatibilityJamo */ );
        }
        if (codeBufferLength > 0) return codeBuffer.subarray(0, codeBufferLength);
    }
    return undefined;
}
function getCodesFromArray(code, array, arrayStartIndex) {
    // Verify the code is within the array's range
    if (code >= arrayStartIndex && code < arrayStartIndex + array.length) addCodesToBuffer(array[code - arrayStartIndex]);
}
function addCodesToBuffer(codes) {
    // NUL is ignored, this is used for archaic characters to avoid using a Map
    // for the data
    if (codes === 0 /* AsciiCode.NUL */ ) return;
    // Number stored in format: OptionalThirdCode << 16 | OptionalSecondCode << 8 | Code
    codeBuffer[codeBufferLength++] = codes & 0xFF;
    if (codes >> 8) codeBuffer[codeBufferLength++] = codes >> 8 & 0xFF;
    if (codes >> 16) codeBuffer[codeBufferLength++] = codes >> 16 & 0xFF;
}
/**
 * Hangul Jamo - Modern consonants #1
 *
 * Range U+1100..U+1112
 *
 * |        | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | A | B | C | D | E | F |
 * |--------|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|
 * | U+110x | ᄀ | ᄁ | ᄂ | ᄃ | ᄄ | ᄅ | ᄆ | ᄇ | ᄈ | ᄉ | ᄊ | ᄋ | ᄌ | ᄍ | ᄎ | ᄏ |
 * | U+111x | ᄐ | ᄑ | ᄒ |
 */ const modernConsonants = new Uint8Array([
    114 /* AsciiCode.r */ ,
    82 /* AsciiCode.R */ ,
    115 /* AsciiCode.s */ ,
    101 /* AsciiCode.e */ ,
    69 /* AsciiCode.E */ ,
    102 /* AsciiCode.f */ ,
    97 /* AsciiCode.a */ ,
    113 /* AsciiCode.q */ ,
    81 /* AsciiCode.Q */ ,
    116 /* AsciiCode.t */ ,
    84 /* AsciiCode.T */ ,
    100 /* AsciiCode.d */ ,
    119 /* AsciiCode.w */ ,
    87 /* AsciiCode.W */ ,
    99 /* AsciiCode.c */ ,
    122 /* AsciiCode.z */ ,
    120 /* AsciiCode.x */ ,
    118 /* AsciiCode.v */ ,
    103 /* AsciiCode.g */ 
]);
/**
 * Hangul Jamo - Modern Vowels
 *
 * Range U+1161..U+1175
 *
 * |        | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | A | B | C | D | E | F |
 * |--------|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|
 * | U+116x |   | ᅡ | ᅢ | ᅣ | ᅤ | ᅥ | ᅦ | ᅧ | ᅨ | ᅩ | ᅪ | ᅫ | ᅬ | ᅭ | ᅮ | ᅯ |
 * | U+117x | ᅰ | ᅱ | ᅲ | ᅳ | ᅴ | ᅵ |
 */ const modernVowels = new Uint16Array([
    107 /* AsciiCode.k */ ,
    111 /* AsciiCode.o */ ,
    105 /* AsciiCode.i */ ,
    79 /* AsciiCode.O */ ,
    106 /* AsciiCode.j */ ,
    112 /* AsciiCode.p */ ,
    117 /* AsciiCode.u */ ,
    80 /* AsciiCode.P */ ,
    104 /* AsciiCode.h */ ,
    27496 /* AsciiCodeCombo.hk */ ,
    28520 /* AsciiCodeCombo.ho */ ,
    27752 /* AsciiCodeCombo.hl */ ,
    121 /* AsciiCode.y */ ,
    110 /* AsciiCode.n */ ,
    27246 /* AsciiCodeCombo.nj */ ,
    28782 /* AsciiCodeCombo.np */ ,
    27758 /* AsciiCodeCombo.nl */ ,
    98 /* AsciiCode.b */ ,
    109 /* AsciiCode.m */ ,
    27757 /* AsciiCodeCombo.ml */ ,
    108 /* AsciiCode.l */ 
]);
/**
 * Hangul Jamo - Modern Consonants #2
 *
 * Range U+11A8..U+11C2
 *
 * |        | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | A | B | C | D | E | F |
 * |--------|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|
 * | U+11Ax |   |   |   |   |   |   |   |   | ᆨ | ᆩ | ᆪ | ᆫ | ᆬ | ᆭ | ᆮ | ᆯ |
 * | U+11Bx | ᆰ | ᆱ | ᆲ | ᆳ | ᆴ | ᆵ | ᆶ | ᆷ | ᆸ | ᆹ | ᆺ | ᆻ | ᆼ | ᆽ | ᆾ | ᆿ |
 * | U+11Cx | ᇀ | ᇁ | ᇂ |
 */ const modernFinalConsonants = new Uint16Array([
    114 /* AsciiCode.r */ ,
    82 /* AsciiCode.R */ ,
    29810 /* AsciiCodeCombo.rt */ ,
    115 /* AsciiCode.s */ ,
    30579 /* AsciiCodeCombo.sw */ ,
    26483 /* AsciiCodeCombo.sg */ ,
    101 /* AsciiCode.e */ ,
    102 /* AsciiCode.f */ ,
    29286 /* AsciiCodeCombo.fr */ ,
    24934 /* AsciiCodeCombo.fa */ ,
    29030 /* AsciiCodeCombo.fq */ ,
    29798 /* AsciiCodeCombo.ft */ ,
    30822 /* AsciiCodeCombo.fx */ ,
    30310 /* AsciiCodeCombo.fv */ ,
    26470 /* AsciiCodeCombo.fg */ ,
    97 /* AsciiCode.a */ ,
    113 /* AsciiCode.q */ ,
    29809 /* AsciiCodeCombo.qt */ ,
    116 /* AsciiCode.t */ ,
    84 /* AsciiCode.T */ ,
    100 /* AsciiCode.d */ ,
    119 /* AsciiCode.w */ ,
    99 /* AsciiCode.c */ ,
    122 /* AsciiCode.z */ ,
    120 /* AsciiCode.x */ ,
    118 /* AsciiCode.v */ ,
    103 /* AsciiCode.g */ 
]);
/**
 * Hangul Compatibility Jamo
 *
 * Range U+3131..U+318F
 *
 * This includes range includes archaic jamo which we don't consider, these are
 * given the NUL character code in order to be ignored.
 *
 * |        | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | A | B | C | D | E | F |
 * |--------|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|
 * | U+313x |   | ㄱ | ㄲ | ㄳ | ㄴ | ㄵ | ㄶ | ㄷ | ㄸ | ㄹ | ㄺ | ㄻ | ㄼ | ㄽ | ㄾ | ㄿ |
 * | U+314x | ㅀ | ㅁ | ㅂ | ㅃ | ㅄ | ㅅ | ㅆ | ㅇ | ㅈ | ㅉ | ㅊ | ㅋ | ㅌ | ㅍ | ㅎ | ㅏ |
 * | U+315x | ㅐ | ㅑ | ㅒ | ㅓ | ㅔ | ㅕ | ㅖ | ㅗ | ㅘ | ㅙ | ㅚ | ㅛ | ㅜ | ㅝ | ㅞ | ㅟ |
 * | U+316x | ㅠ | ㅡ | ㅢ | ㅣ | HF | ㅥ | ㅦ | ㅧ | ㅨ | ㅩ | ㅪ | ㅫ | ㅬ | ㅭ | ㅮ | ㅯ |
 * | U+317x | ㅰ | ㅱ | ㅲ | ㅳ | ㅴ | ㅵ | ㅶ | ㅷ | ㅸ | ㅹ | ㅺ | ㅻ | ㅼ | ㅽ | ㅾ | ㅿ |
 * | U+318x | ㆀ | ㆁ | ㆂ | ㆃ | ㆄ | ㆅ | ㆆ | ㆇ | ㆈ | ㆉ | ㆊ | ㆋ | ㆌ | ㆍ | ㆎ |
 */ const compatibilityJamo = new Uint16Array([
    114 /* AsciiCode.r */ ,
    82 /* AsciiCode.R */ ,
    29810 /* AsciiCodeCombo.rt */ ,
    115 /* AsciiCode.s */ ,
    30579 /* AsciiCodeCombo.sw */ ,
    26483 /* AsciiCodeCombo.sg */ ,
    101 /* AsciiCode.e */ ,
    69 /* AsciiCode.E */ ,
    102 /* AsciiCode.f */ ,
    29286 /* AsciiCodeCombo.fr */ ,
    24934 /* AsciiCodeCombo.fa */ ,
    29030 /* AsciiCodeCombo.fq */ ,
    29798 /* AsciiCodeCombo.ft */ ,
    30822 /* AsciiCodeCombo.fx */ ,
    30310 /* AsciiCodeCombo.fv */ ,
    26470 /* AsciiCodeCombo.fg */ ,
    97 /* AsciiCode.a */ ,
    113 /* AsciiCode.q */ ,
    81 /* AsciiCode.Q */ ,
    29809 /* AsciiCodeCombo.qt */ ,
    116 /* AsciiCode.t */ ,
    84 /* AsciiCode.T */ ,
    100 /* AsciiCode.d */ ,
    119 /* AsciiCode.w */ ,
    87 /* AsciiCode.W */ ,
    99 /* AsciiCode.c */ ,
    122 /* AsciiCode.z */ ,
    120 /* AsciiCode.x */ ,
    118 /* AsciiCode.v */ ,
    103 /* AsciiCode.g */ ,
    107 /* AsciiCode.k */ ,
    111 /* AsciiCode.o */ ,
    105 /* AsciiCode.i */ ,
    79 /* AsciiCode.O */ ,
    106 /* AsciiCode.j */ ,
    112 /* AsciiCode.p */ ,
    117 /* AsciiCode.u */ ,
    80 /* AsciiCode.P */ ,
    104 /* AsciiCode.h */ ,
    27496 /* AsciiCodeCombo.hk */ ,
    28520 /* AsciiCodeCombo.ho */ ,
    27752 /* AsciiCodeCombo.hl */ ,
    121 /* AsciiCode.y */ ,
    110 /* AsciiCode.n */ ,
    27246 /* AsciiCodeCombo.nj */ ,
    28782 /* AsciiCodeCombo.np */ ,
    27758 /* AsciiCodeCombo.nl */ ,
    98 /* AsciiCode.b */ ,
    109 /* AsciiCode.m */ ,
    27757 /* AsciiCodeCombo.ml */ ,
    108 /* AsciiCode.l */ 
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"700EV":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "originalFSPath", ()=>originalFSPath);
parcelHelpers.export(exports, "ExtUri", ()=>ExtUri);
parcelHelpers.export(exports, "extUri", ()=>extUri);
parcelHelpers.export(exports, "extUriBiasedIgnorePathCase", ()=>extUriBiasedIgnorePathCase);
parcelHelpers.export(exports, "extUriIgnorePathCase", ()=>extUriIgnorePathCase);
parcelHelpers.export(exports, "isEqual", ()=>isEqual);
parcelHelpers.export(exports, "isEqualOrParent", ()=>isEqualOrParent);
parcelHelpers.export(exports, "getComparisonKey", ()=>getComparisonKey);
parcelHelpers.export(exports, "basenameOrAuthority", ()=>basenameOrAuthority);
parcelHelpers.export(exports, "basename", ()=>basename);
parcelHelpers.export(exports, "extname", ()=>extname);
parcelHelpers.export(exports, "dirname", ()=>dirname);
parcelHelpers.export(exports, "joinPath", ()=>joinPath);
parcelHelpers.export(exports, "normalizePath", ()=>normalizePath);
parcelHelpers.export(exports, "relativePath", ()=>relativePath);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "isAbsolutePath", ()=>isAbsolutePath);
parcelHelpers.export(exports, "isEqualAuthority", ()=>isEqualAuthority);
parcelHelpers.export(exports, "hasTrailingPathSeparator", ()=>hasTrailingPathSeparator);
parcelHelpers.export(exports, "removeTrailingPathSeparator", ()=>removeTrailingPathSeparator);
parcelHelpers.export(exports, "addTrailingPathSeparator", ()=>addTrailingPathSeparator);
parcelHelpers.export(exports, "DataUri", ()=>DataUri);
var _extpathJs = require("./extpath.js");
var _networkJs = require("./network.js");
var _pathJs = require("./path.js");
var _platformJs = require("./platform.js");
var _stringsJs = require("./strings.js");
var _uriJs = require("./uri.js");
function originalFSPath(uri) {
    return (0, _uriJs.uriToFsPath)(uri, true);
}
class ExtUri {
    constructor(_ignorePathCasing){
        this._ignorePathCasing = _ignorePathCasing;
    }
    compare(uri1, uri2, ignoreFragment = false) {
        if (uri1 === uri2) return 0;
        return (0, _stringsJs.compare)(this.getComparisonKey(uri1, ignoreFragment), this.getComparisonKey(uri2, ignoreFragment));
    }
    isEqual(uri1, uri2, ignoreFragment = false) {
        if (uri1 === uri2) return true;
        if (!uri1 || !uri2) return false;
        return this.getComparisonKey(uri1, ignoreFragment) === this.getComparisonKey(uri2, ignoreFragment);
    }
    getComparisonKey(uri, ignoreFragment = false) {
        return uri.with({
            path: this._ignorePathCasing(uri) ? uri.path.toLowerCase() : undefined,
            fragment: ignoreFragment ? null : undefined
        }).toString();
    }
    isEqualOrParent(base, parentCandidate, ignoreFragment = false) {
        if (base.scheme === parentCandidate.scheme) {
            if (base.scheme === (0, _networkJs.Schemas).file) return _extpathJs.isEqualOrParent(originalFSPath(base), originalFSPath(parentCandidate), this._ignorePathCasing(base)) && base.query === parentCandidate.query && (ignoreFragment || base.fragment === parentCandidate.fragment);
            if (isEqualAuthority(base.authority, parentCandidate.authority)) return _extpathJs.isEqualOrParent(base.path, parentCandidate.path, this._ignorePathCasing(base), "/") && base.query === parentCandidate.query && (ignoreFragment || base.fragment === parentCandidate.fragment);
        }
        return false;
    }
    // --- path math
    joinPath(resource, ...pathFragment) {
        return (0, _uriJs.URI).joinPath(resource, ...pathFragment);
    }
    basenameOrAuthority(resource) {
        return basename(resource) || resource.authority;
    }
    basename(resource) {
        return _pathJs.posix.basename(resource.path);
    }
    extname(resource) {
        return _pathJs.posix.extname(resource.path);
    }
    dirname(resource) {
        if (resource.path.length === 0) return resource;
        let dirname;
        if (resource.scheme === (0, _networkJs.Schemas).file) dirname = (0, _uriJs.URI).file(_pathJs.dirname(originalFSPath(resource))).path;
        else {
            dirname = _pathJs.posix.dirname(resource.path);
            if (resource.authority && dirname.length && dirname.charCodeAt(0) !== 47 /* CharCode.Slash */ ) {
                console.error(`dirname("${resource.toString})) resulted in a relative path`);
                dirname = "/"; // If a URI contains an authority component, then the path component must either be empty or begin with a CharCode.Slash ("/") character
            }
        }
        return resource.with({
            path: dirname
        });
    }
    normalizePath(resource) {
        if (!resource.path.length) return resource;
        let normalizedPath;
        if (resource.scheme === (0, _networkJs.Schemas).file) normalizedPath = (0, _uriJs.URI).file(_pathJs.normalize(originalFSPath(resource))).path;
        else normalizedPath = _pathJs.posix.normalize(resource.path);
        return resource.with({
            path: normalizedPath
        });
    }
    relativePath(from, to) {
        if (from.scheme !== to.scheme || !isEqualAuthority(from.authority, to.authority)) return undefined;
        if (from.scheme === (0, _networkJs.Schemas).file) {
            const relativePath = _pathJs.relative(originalFSPath(from), originalFSPath(to));
            return (0, _platformJs.isWindows) ? _extpathJs.toSlashes(relativePath) : relativePath;
        }
        let fromPath = from.path || "/";
        const toPath = to.path || "/";
        if (this._ignorePathCasing(from)) {
            // make casing of fromPath match toPath
            let i = 0;
            for(const len = Math.min(fromPath.length, toPath.length); i < len; i++)if (fromPath.charCodeAt(i) !== toPath.charCodeAt(i)) {
                if (fromPath.charAt(i).toLowerCase() !== toPath.charAt(i).toLowerCase()) break;
            }
            fromPath = toPath.substr(0, i) + fromPath.substr(i);
        }
        return _pathJs.posix.relative(fromPath, toPath);
    }
    resolvePath(base, path) {
        if (base.scheme === (0, _networkJs.Schemas).file) {
            const newURI = (0, _uriJs.URI).file(_pathJs.resolve(originalFSPath(base), path));
            return base.with({
                authority: newURI.authority,
                path: newURI.path
            });
        }
        path = _extpathJs.toPosixPath(path); // we allow path to be a windows path
        return base.with({
            path: _pathJs.posix.resolve(base.path, path)
        });
    }
    // --- misc
    isAbsolutePath(resource) {
        return !!resource.path && resource.path[0] === "/";
    }
    isEqualAuthority(a1, a2) {
        return a1 === a2 || a1 !== undefined && a2 !== undefined && (0, _stringsJs.equalsIgnoreCase)(a1, a2);
    }
    hasTrailingPathSeparator(resource, sep = _pathJs.sep) {
        if (resource.scheme === (0, _networkJs.Schemas).file) {
            const fsp = originalFSPath(resource);
            return fsp.length > _extpathJs.getRoot(fsp).length && fsp[fsp.length - 1] === sep;
        } else {
            const p = resource.path;
            return p.length > 1 && p.charCodeAt(p.length - 1) === 47 /* CharCode.Slash */  && !/^[a-zA-Z]:(\/$|\\$)/.test(resource.fsPath); // ignore the slash at offset 0
        }
    }
    removeTrailingPathSeparator(resource, sep = _pathJs.sep) {
        // Make sure that the path isn't a drive letter. A trailing separator there is not removable.
        if (hasTrailingPathSeparator(resource, sep)) return resource.with({
            path: resource.path.substr(0, resource.path.length - 1)
        });
        return resource;
    }
    addTrailingPathSeparator(resource, sep = _pathJs.sep) {
        let isRootSep = false;
        if (resource.scheme === (0, _networkJs.Schemas).file) {
            const fsp = originalFSPath(resource);
            isRootSep = fsp !== undefined && fsp.length === _extpathJs.getRoot(fsp).length && fsp[fsp.length - 1] === sep;
        } else {
            sep = "/";
            const p = resource.path;
            isRootSep = p.length === 1 && p.charCodeAt(p.length - 1) === 47 /* CharCode.Slash */ ;
        }
        if (!isRootSep && !hasTrailingPathSeparator(resource, sep)) return resource.with({
            path: resource.path + "/"
        });
        return resource;
    }
}
const extUri = new ExtUri(()=>false);
const extUriBiasedIgnorePathCase = new ExtUri((uri)=>{
    // A file scheme resource is in the same platform as code, so ignore case for non linux platforms
    // Resource can be from another platform. Lowering the case as an hack. Should come from File system provider
    return uri.scheme === (0, _networkJs.Schemas).file ? !(0, _platformJs.isLinux) : true;
});
const extUriIgnorePathCase = new ExtUri((_)=>true);
const isEqual = extUri.isEqual.bind(extUri);
const isEqualOrParent = extUri.isEqualOrParent.bind(extUri);
const getComparisonKey = extUri.getComparisonKey.bind(extUri);
const basenameOrAuthority = extUri.basenameOrAuthority.bind(extUri);
const basename = extUri.basename.bind(extUri);
const extname = extUri.extname.bind(extUri);
const dirname = extUri.dirname.bind(extUri);
const joinPath = extUri.joinPath.bind(extUri);
const normalizePath = extUri.normalizePath.bind(extUri);
const relativePath = extUri.relativePath.bind(extUri);
const resolvePath = extUri.resolvePath.bind(extUri);
const isAbsolutePath = extUri.isAbsolutePath.bind(extUri);
const isEqualAuthority = extUri.isEqualAuthority.bind(extUri);
const hasTrailingPathSeparator = extUri.hasTrailingPathSeparator.bind(extUri);
const removeTrailingPathSeparator = extUri.removeTrailingPathSeparator.bind(extUri);
const addTrailingPathSeparator = extUri.addTrailingPathSeparator.bind(extUri);
var DataUri;
(function(DataUri) {
    DataUri.META_DATA_LABEL = "label";
    DataUri.META_DATA_DESCRIPTION = "description";
    DataUri.META_DATA_SIZE = "size";
    DataUri.META_DATA_MIME = "mime";
    function parseMetaData(dataUri) {
        const metadata = new Map();
        // Given a URI of:  data:image/png;size:2313;label:SomeLabel;description:SomeDescription;base64,77+9UE5...
        // the metadata is: size:2313;label:SomeLabel;description:SomeDescription
        const meta = dataUri.path.substring(dataUri.path.indexOf(";") + 1, dataUri.path.lastIndexOf(";"));
        meta.split(";").forEach((property)=>{
            const [key, value] = property.split(":");
            if (key && value) metadata.set(key, value);
        });
        // Given a URI of:  data:image/png;size:2313;label:SomeLabel;description:SomeDescription;base64,77+9UE5...
        // the mime is: image/png
        const mime = dataUri.path.substring(0, dataUri.path.indexOf(";"));
        if (mime) metadata.set(DataUri.META_DATA_MIME, mime);
        return metadata;
    }
    DataUri.parseMetaData = parseMetaData;
})(DataUri || (DataUri = {}));

},{"./extpath.js":"7a3D5","./network.js":"2c1AD","./path.js":"vyRKJ","./platform.js":"7maJO","./strings.js":"aA9I1","./uri.js":"7qGS3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlFbp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdGenerator", ()=>IdGenerator);
parcelHelpers.export(exports, "defaultGenerator", ()=>defaultGenerator);
class IdGenerator {
    constructor(prefix){
        this._prefix = prefix;
        this._lastId = 0;
    }
    nextId() {
        return this._prefix + ++this._lastId;
    }
}
const defaultGenerator = new IdGenerator("id#");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4P351":[function(require,module,exports) {
/**
 * marked v14.0.0 - a markdown parser
 * Copyright (c) 2011-2024, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ // ESM-uncomment-begin
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hooks", ()=>Hooks);
parcelHelpers.export(exports, "Lexer", ()=>Lexer);
parcelHelpers.export(exports, "Marked", ()=>Marked);
parcelHelpers.export(exports, "Parser", ()=>Parser);
parcelHelpers.export(exports, "Renderer", ()=>Renderer);
parcelHelpers.export(exports, "TextRenderer", ()=>TextRenderer);
parcelHelpers.export(exports, "Tokenizer", ()=>Tokenizer);
parcelHelpers.export(exports, "defaults", ()=>defaults);
parcelHelpers.export(exports, "getDefaults", ()=>getDefaults);
parcelHelpers.export(exports, "lexer", ()=>lexer);
parcelHelpers.export(exports, "marked", ()=>marked);
parcelHelpers.export(exports, "options", ()=>options);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "parseInline", ()=>parseInline);
parcelHelpers.export(exports, "parser", ()=>parser);
parcelHelpers.export(exports, "setOptions", ()=>setOptions);
parcelHelpers.export(exports, "use", ()=>use);
parcelHelpers.export(exports, "walkTokens", ()=>walkTokens);
let __marked_exports = {};
(function() {
    function define(deps, factory) {
        factory(__marked_exports);
    }
    define.amd = true;
    // ESM-uncomment-end
    (function(global, factory) {
        typeof define === "function" && define.amd ? define([
            "exports"
        ], factory) : factory(exports);
    })(this, function(exports1) {
        "use strict";
        /**
	 * Gets the original marked default options.
	 */ function _getDefaults() {
            return {
                async: false,
                breaks: false,
                extensions: null,
                gfm: true,
                hooks: null,
                pedantic: false,
                renderer: null,
                silent: false,
                tokenizer: null,
                walkTokens: null
            };
        }
        exports1.defaults = _getDefaults();
        function changeDefaults(newDefaults) {
            exports1.defaults = newDefaults;
        }
        /**
	 * Helpers
	 */ const escapeTest = /[&<>"']/;
        const escapeReplace = new RegExp(escapeTest.source, "g");
        const escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
        const escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, "g");
        const escapeReplacements = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        };
        const getEscapeReplacement = (ch)=>escapeReplacements[ch];
        function escape$1(html, encode) {
            if (encode) {
                if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
            } else {
                if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
            }
            return html;
        }
        const caret = /(^|[^\[])\^/g;
        function edit(regex, opt) {
            let source = typeof regex === "string" ? regex : regex.source;
            opt = opt || "";
            const obj = {
                replace: (name, val)=>{
                    let valSource = typeof val === "string" ? val : val.source;
                    valSource = valSource.replace(caret, "$1");
                    source = source.replace(name, valSource);
                    return obj;
                },
                getRegex: ()=>{
                    return new RegExp(source, opt);
                }
            };
            return obj;
        }
        function cleanUrl(href) {
            try {
                href = encodeURI(href).replace(/%25/g, "%");
            } catch  {
                return null;
            }
            return href;
        }
        const noopTest = {
            exec: ()=>null
        };
        function splitCells(tableRow, count) {
            // ensure that every cell-delimiting pipe has a space
            // before it to distinguish it from an escaped pipe
            const row = tableRow.replace(/\|/g, (match, offset, str)=>{
                let escaped = false;
                let curr = offset;
                while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
                if (escaped) // odd number of slashes means | is escaped
                // so we leave it alone
                return "|";
                else // add space before unescaped |
                return " |";
            }), cells = row.split(/ \|/);
            let i = 0;
            // First/last cell in a row cannot be empty if it has no leading/trailing pipe
            if (!cells[0].trim()) cells.shift();
            if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
            if (count) {
                if (cells.length > count) cells.splice(count);
                else while(cells.length < count)cells.push("");
            }
            for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
            cells[i] = cells[i].trim().replace(/\\\|/g, "|");
            return cells;
        }
        /**
	 * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
	 * /c*$/ is vulnerable to REDOS.
	 *
	 * @param str
	 * @param c
	 * @param invert Remove suffix of non-c chars instead. Default falsey.
	 */ function rtrim(str, c, invert) {
            const l = str.length;
            if (l === 0) return "";
            // Length of suffix matching the invert condition.
            let suffLen = 0;
            // Step left until we fail to match the invert condition.
            while(suffLen < l){
                const currChar = str.charAt(l - suffLen - 1);
                if (currChar === c && !invert) suffLen++;
                else if (currChar !== c && invert) suffLen++;
                else break;
            }
            return str.slice(0, l - suffLen);
        }
        function findClosingBracket(str, b) {
            if (str.indexOf(b[1]) === -1) return -1;
            let level = 0;
            for(let i = 0; i < str.length; i++){
                if (str[i] === "\\") i++;
                else if (str[i] === b[0]) level++;
                else if (str[i] === b[1]) {
                    level--;
                    if (level < 0) return i;
                }
            }
            return -1;
        }
        function outputLink(cap, link, raw, lexer) {
            const href = link.href;
            const title = link.title ? escape$1(link.title) : null;
            const text = cap[1].replace(/\\([\[\]])/g, "$1");
            if (cap[0].charAt(0) !== "!") {
                lexer.state.inLink = true;
                const token = {
                    type: "link",
                    raw,
                    href,
                    title,
                    text,
                    tokens: lexer.inlineTokens(text)
                };
                lexer.state.inLink = false;
                return token;
            }
            return {
                type: "image",
                raw,
                href,
                title,
                text: escape$1(text)
            };
        }
        function indentCodeCompensation(raw, text) {
            const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
            if (matchIndentToCode === null) return text;
            const indentToCode = matchIndentToCode[1];
            return text.split("\n").map((node)=>{
                const matchIndentInNode = node.match(/^\s+/);
                if (matchIndentInNode === null) return node;
                const [indentInNode] = matchIndentInNode;
                if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
                return node;
            }).join("\n");
        }
        /**
	 * Tokenizer
	 */ class _Tokenizer {
            options;
            rules;
            lexer;
            constructor(options){
                this.options = options || exports1.defaults;
            }
            space(src) {
                const cap = this.rules.block.newline.exec(src);
                if (cap && cap[0].length > 0) return {
                    type: "space",
                    raw: cap[0]
                };
            }
            code(src) {
                const cap = this.rules.block.code.exec(src);
                if (cap) {
                    const text = cap[0].replace(/^ {1,4}/gm, "");
                    return {
                        type: "code",
                        raw: cap[0],
                        codeBlockStyle: "indented",
                        text: !this.options.pedantic ? rtrim(text, "\n") : text
                    };
                }
            }
            fences(src) {
                const cap = this.rules.block.fences.exec(src);
                if (cap) {
                    const raw = cap[0];
                    const text = indentCodeCompensation(raw, cap[3] || "");
                    return {
                        type: "code",
                        raw,
                        lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                        text
                    };
                }
            }
            heading(src) {
                const cap = this.rules.block.heading.exec(src);
                if (cap) {
                    let text = cap[2].trim();
                    // remove trailing #s
                    if (/#$/.test(text)) {
                        const trimmed = rtrim(text, "#");
                        if (this.options.pedantic) text = trimmed.trim();
                        else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                        text = trimmed.trim();
                    }
                    return {
                        type: "heading",
                        raw: cap[0],
                        depth: cap[1].length,
                        text,
                        tokens: this.lexer.inline(text)
                    };
                }
            }
            hr(src) {
                const cap = this.rules.block.hr.exec(src);
                if (cap) return {
                    type: "hr",
                    raw: rtrim(cap[0], "\n")
                };
            }
            blockquote(src) {
                const cap = this.rules.block.blockquote.exec(src);
                if (cap) {
                    let lines = rtrim(cap[0], "\n").split("\n");
                    let raw = "";
                    let text = "";
                    const tokens = [];
                    while(lines.length > 0){
                        let inBlockquote = false;
                        const currentLines = [];
                        let i;
                        for(i = 0; i < lines.length; i++){
                            // get lines up to a continuation
                            if (/^ {0,3}>/.test(lines[i])) {
                                currentLines.push(lines[i]);
                                inBlockquote = true;
                            } else if (!inBlockquote) currentLines.push(lines[i]);
                            else break;
                        }
                        lines = lines.slice(i);
                        const currentRaw = currentLines.join("\n");
                        const currentText = currentRaw// precede setext continuation with 4 spaces so it isn't a setext
                        .replace(/\n {0,3}((?:=+|-+) *)(?=\n|$)/g, "\n    $1").replace(/^ {0,3}>[ \t]?/gm, "");
                        raw = raw ? `${raw}\n${currentRaw}` : currentRaw;
                        text = text ? `${text}\n${currentText}` : currentText;
                        // parse blockquote lines as top level tokens
                        // merge paragraphs if this is a continuation
                        const top = this.lexer.state.top;
                        this.lexer.state.top = true;
                        this.lexer.blockTokens(currentText, tokens, true);
                        this.lexer.state.top = top;
                        // if there is no continuation then we are done
                        if (lines.length === 0) break;
                        const lastToken = tokens[tokens.length - 1];
                        if (lastToken?.type === "code") break;
                        else if (lastToken?.type === "blockquote") {
                            // include continuation in nested blockquote
                            const oldToken = lastToken;
                            const newText = oldToken.raw + "\n" + lines.join("\n");
                            const newToken = this.blockquote(newText);
                            tokens[tokens.length - 1] = newToken;
                            raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                            text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                            break;
                        } else if (lastToken?.type === "list") {
                            // include continuation in nested list
                            const oldToken = lastToken;
                            const newText = oldToken.raw + "\n" + lines.join("\n");
                            const newToken = this.list(newText);
                            tokens[tokens.length - 1] = newToken;
                            raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                            text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                            lines = newText.substring(tokens[tokens.length - 1].raw.length).split("\n");
                            continue;
                        }
                    }
                    return {
                        type: "blockquote",
                        raw,
                        tokens,
                        text
                    };
                }
            }
            list(src) {
                let cap = this.rules.block.list.exec(src);
                if (cap) {
                    let bull = cap[1].trim();
                    const isordered = bull.length > 1;
                    const list = {
                        type: "list",
                        raw: "",
                        ordered: isordered,
                        start: isordered ? +bull.slice(0, -1) : "",
                        loose: false,
                        items: []
                    };
                    bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
                    if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                    // Get next list item
                    const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);
                    let endsWithBlankLine = false;
                    // Check if current bullet point can start a new List Item
                    while(src){
                        let endEarly = false;
                        let raw = "";
                        let itemContents = "";
                        if (!(cap = itemRegex.exec(src))) break;
                        if (this.rules.block.hr.test(src)) break;
                        raw = cap[0];
                        src = src.substring(raw.length);
                        let line = cap[2].split("\n", 1)[0].replace(/^\t+/, (t)=>" ".repeat(3 * t.length));
                        let nextLine = src.split("\n", 1)[0];
                        let blankLine = !line.trim();
                        let indent = 0;
                        if (this.options.pedantic) {
                            indent = 2;
                            itemContents = line.trimStart();
                        } else if (blankLine) indent = cap[1].length + 1;
                        else {
                            indent = cap[2].search(/[^ ]/); // Find first non-space char
                            indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                            itemContents = line.slice(indent);
                            indent += cap[1].length;
                        }
                        if (blankLine && /^ *$/.test(nextLine)) {
                            raw += nextLine + "\n";
                            src = src.substring(nextLine.length + 1);
                            endEarly = true;
                        }
                        if (!endEarly) {
                            const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`);
                            const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
                            const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
                            const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
                            // Check if following lines should be included in List Item
                            while(src){
                                const rawLine = src.split("\n", 1)[0];
                                nextLine = rawLine;
                                // Re-align to follow commonmark nesting rules
                                if (this.options.pedantic) nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
                                // End list item if found code fences
                                if (fencesBeginRegex.test(nextLine)) break;
                                // End list item if found start of new heading
                                if (headingBeginRegex.test(nextLine)) break;
                                // End list item if found start of new bullet
                                if (nextBulletRegex.test(nextLine)) break;
                                // Horizontal rule found
                                if (hrRegex.test(src)) break;
                                if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) itemContents += "\n" + nextLine.slice(indent);
                                else {
                                    // not enough indentation
                                    if (blankLine) break;
                                    // paragraph continuation unless last line was a different block level element
                                    if (line.search(/[^ ]/) >= 4) break;
                                    if (fencesBeginRegex.test(line)) break;
                                    if (headingBeginRegex.test(line)) break;
                                    if (hrRegex.test(line)) break;
                                    itemContents += "\n" + nextLine;
                                }
                                if (!blankLine && !nextLine.trim()) blankLine = true;
                                raw += rawLine + "\n";
                                src = src.substring(rawLine.length + 1);
                                line = nextLine.slice(indent);
                            }
                        }
                        if (!list.loose) {
                            // If the previous item ended with a blank line, the list is loose
                            if (endsWithBlankLine) list.loose = true;
                            else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                        }
                        let istask = null;
                        let ischecked;
                        // Check for task list items
                        if (this.options.gfm) {
                            istask = /^\[[ xX]\] /.exec(itemContents);
                            if (istask) {
                                ischecked = istask[0] !== "[ ] ";
                                itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
                            }
                        }
                        list.items.push({
                            type: "list_item",
                            raw,
                            task: !!istask,
                            checked: ischecked,
                            loose: false,
                            text: itemContents,
                            tokens: []
                        });
                        list.raw += raw;
                    }
                    // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                    list.items[list.items.length - 1].raw = list.items[list.items.length - 1].raw.trimEnd();
                    list.items[list.items.length - 1].text = list.items[list.items.length - 1].text.trimEnd();
                    list.raw = list.raw.trimEnd();
                    // Item child tokens handled here at end because we needed to have the final item to trim it first
                    for(let i = 0; i < list.items.length; i++){
                        this.lexer.state.top = false;
                        list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                        if (!list.loose) {
                            // Check if list should be loose
                            const spacers = list.items[i].tokens.filter((t)=>t.type === "space");
                            const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>/\n.*\n/.test(t.raw));
                            list.loose = hasMultipleLineBreaks;
                        }
                    }
                    // Set all items to loose if list is loose
                    if (list.loose) for(let i = 0; i < list.items.length; i++)list.items[i].loose = true;
                    return list;
                }
            }
            html(src) {
                const cap = this.rules.block.html.exec(src);
                if (cap) {
                    const token = {
                        type: "html",
                        block: true,
                        raw: cap[0],
                        pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                        text: cap[0]
                    };
                    return token;
                }
            }
            def(src) {
                const cap = this.rules.block.def.exec(src);
                if (cap) {
                    const tag = cap[1].toLowerCase().replace(/\s+/g, " ");
                    const href = cap[2] ? cap[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
                    const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
                    return {
                        type: "def",
                        tag,
                        raw: cap[0],
                        href,
                        title
                    };
                }
            }
            table(src) {
                const cap = this.rules.block.table.exec(src);
                if (!cap) return;
                if (!/[:|]/.test(cap[2])) // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
                return;
                const headers = splitCells(cap[1]);
                const aligns = cap[2].replace(/^\||\| *$/g, "").split("|");
                const rows = cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, "").split("\n") : [];
                const item = {
                    type: "table",
                    raw: cap[0],
                    header: [],
                    align: [],
                    rows: []
                };
                if (headers.length !== aligns.length) // header and align columns must be equal, rows can be different.
                return;
                for (const align of aligns){
                    if (/^ *-+: *$/.test(align)) item.align.push("right");
                    else if (/^ *:-+: *$/.test(align)) item.align.push("center");
                    else if (/^ *:-+ *$/.test(align)) item.align.push("left");
                    else item.align.push(null);
                }
                for(let i = 0; i < headers.length; i++)item.header.push({
                    text: headers[i],
                    tokens: this.lexer.inline(headers[i]),
                    header: true,
                    align: item.align[i]
                });
                for (const row of rows)item.rows.push(splitCells(row, item.header.length).map((cell, i)=>{
                    return {
                        text: cell,
                        tokens: this.lexer.inline(cell),
                        header: false,
                        align: item.align[i]
                    };
                }));
                return item;
            }
            lheading(src) {
                const cap = this.rules.block.lheading.exec(src);
                if (cap) return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[2].charAt(0) === "=" ? 1 : 2,
                    text: cap[1],
                    tokens: this.lexer.inline(cap[1])
                };
            }
            paragraph(src) {
                const cap = this.rules.block.paragraph.exec(src);
                if (cap) {
                    const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                    return {
                        type: "paragraph",
                        raw: cap[0],
                        text,
                        tokens: this.lexer.inline(text)
                    };
                }
            }
            text(src) {
                const cap = this.rules.block.text.exec(src);
                if (cap) return {
                    type: "text",
                    raw: cap[0],
                    text: cap[0],
                    tokens: this.lexer.inline(cap[0])
                };
            }
            escape(src) {
                const cap = this.rules.inline.escape.exec(src);
                if (cap) return {
                    type: "escape",
                    raw: cap[0],
                    text: escape$1(cap[1])
                };
            }
            tag(src) {
                const cap = this.rules.inline.tag.exec(src);
                if (cap) {
                    if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
                    else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
                    if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
                    else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
                    return {
                        type: "html",
                        raw: cap[0],
                        inLink: this.lexer.state.inLink,
                        inRawBlock: this.lexer.state.inRawBlock,
                        block: false,
                        text: cap[0]
                    };
                }
            }
            link(src) {
                const cap = this.rules.inline.link.exec(src);
                if (cap) {
                    const trimmedUrl = cap[2].trim();
                    if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                        // commonmark requires matching angle brackets
                        if (!/>$/.test(trimmedUrl)) return;
                        // ending angle bracket cannot be escaped
                        const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                        if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                    } else {
                        // find closing parenthesis
                        const lastParenIndex = findClosingBracket(cap[2], "()");
                        if (lastParenIndex > -1) {
                            const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                            const linkLen = start + cap[1].length + lastParenIndex;
                            cap[2] = cap[2].substring(0, lastParenIndex);
                            cap[0] = cap[0].substring(0, linkLen).trim();
                            cap[3] = "";
                        }
                    }
                    let href = cap[2];
                    let title = "";
                    if (this.options.pedantic) {
                        // split pedantic href and title
                        const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                        if (link) {
                            href = link[1];
                            title = link[3];
                        }
                    } else title = cap[3] ? cap[3].slice(1, -1) : "";
                    href = href.trim();
                    if (/^</.test(href)) {
                        if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                        href = href.slice(1);
                        else href = href.slice(1, -1);
                    }
                    return outputLink(cap, {
                        href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                        title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
                    }, cap[0], this.lexer);
                }
            }
            reflink(src, links) {
                let cap;
                if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                    const linkString = (cap[2] || cap[1]).replace(/\s+/g, " ");
                    const link = links[linkString.toLowerCase()];
                    if (!link) {
                        const text = cap[0].charAt(0);
                        return {
                            type: "text",
                            raw: text,
                            text
                        };
                    }
                    return outputLink(cap, link, cap[0], this.lexer);
                }
            }
            emStrong(src, maskedSrc, prevChar = "") {
                let match = this.rules.inline.emStrongLDelim.exec(src);
                if (!match) return;
                // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
                if (match[3] && prevChar.match(/[\p{L}\p{N}]/u)) return;
                const nextChar = match[1] || match[2] || "";
                if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                    // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
                    const lLength = [
                        ...match[0]
                    ].length - 1;
                    let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                    const endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                    endReg.lastIndex = 0;
                    // Clip maskedSrc to same section of string as src (move to lexer?)
                    maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                    while((match = endReg.exec(maskedSrc)) != null){
                        rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                        if (!rDelim) continue; // skip single * in __abc*abc__
                        rLength = [
                            ...rDelim
                        ].length;
                        if (match[3] || match[4]) {
                            delimTotal += rLength;
                            continue;
                        } else if (match[5] || match[6]) {
                            if (lLength % 3 && !((lLength + rLength) % 3)) {
                                midDelimTotal += rLength;
                                continue; // CommonMark Emphasis Rules 9-10
                            }
                        }
                        delimTotal -= rLength;
                        if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                        // Remove extra characters. *a*** -> *a*
                        rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                        // char length can be >1 for unicode characters;
                        const lastCharLength = [
                            ...match[0]
                        ][0].length;
                        const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                        // Create `em` if smallest delimiter has odd char count. *a***
                        if (Math.min(lLength, rLength) % 2) {
                            const text = raw.slice(1, -1);
                            return {
                                type: "em",
                                raw,
                                text,
                                tokens: this.lexer.inlineTokens(text)
                            };
                        }
                        // Create 'strong' if smallest delimiter has even char count. **a***
                        const text = raw.slice(2, -2);
                        return {
                            type: "strong",
                            raw,
                            text,
                            tokens: this.lexer.inlineTokens(text)
                        };
                    }
                }
            }
            codespan(src) {
                const cap = this.rules.inline.code.exec(src);
                if (cap) {
                    let text = cap[2].replace(/\n/g, " ");
                    const hasNonSpaceChars = /[^ ]/.test(text);
                    const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                    if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                    text = escape$1(text, true);
                    return {
                        type: "codespan",
                        raw: cap[0],
                        text
                    };
                }
            }
            br(src) {
                const cap = this.rules.inline.br.exec(src);
                if (cap) return {
                    type: "br",
                    raw: cap[0]
                };
            }
            del(src) {
                const cap = this.rules.inline.del.exec(src);
                if (cap) return {
                    type: "del",
                    raw: cap[0],
                    text: cap[2],
                    tokens: this.lexer.inlineTokens(cap[2])
                };
            }
            autolink(src) {
                const cap = this.rules.inline.autolink.exec(src);
                if (cap) {
                    let text, href;
                    if (cap[2] === "@") {
                        text = escape$1(cap[1]);
                        href = "mailto:" + text;
                    } else {
                        text = escape$1(cap[1]);
                        href = text;
                    }
                    return {
                        type: "link",
                        raw: cap[0],
                        text,
                        href,
                        tokens: [
                            {
                                type: "text",
                                raw: text,
                                text
                            }
                        ]
                    };
                }
            }
            url(src) {
                let cap;
                if (cap = this.rules.inline.url.exec(src)) {
                    let text, href;
                    if (cap[2] === "@") {
                        text = escape$1(cap[0]);
                        href = "mailto:" + text;
                    } else {
                        // do extended autolink path validation
                        let prevCapZero;
                        do {
                            prevCapZero = cap[0];
                            cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? "";
                        }while (prevCapZero !== cap[0]);
                        text = escape$1(cap[0]);
                        if (cap[1] === "www.") href = "http://" + cap[0];
                        else href = cap[0];
                    }
                    return {
                        type: "link",
                        raw: cap[0],
                        text,
                        href,
                        tokens: [
                            {
                                type: "text",
                                raw: text,
                                text
                            }
                        ]
                    };
                }
            }
            inlineText(src) {
                const cap = this.rules.inline.text.exec(src);
                if (cap) {
                    let text;
                    if (this.lexer.state.inRawBlock) text = cap[0];
                    else text = escape$1(cap[0]);
                    return {
                        type: "text",
                        raw: cap[0],
                        text
                    };
                }
            }
        }
        /**
	 * Block-Level Grammar
	 */ const newline = /^(?: *(?:\n|$))+/;
        const blockCode = /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/;
        const fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
        const hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
        const heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
        const bullet = /(?:[*+-]|\d{1,9}[.)])/;
        const lheading = edit(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, bullet) // lists can interrupt
        .replace(/blockCode/g, / {4}/) // indented code blocks can interrupt
        .replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
        .replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
        .replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
        .replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
        .getRegex();
        const _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
        const blockText = /^[^\n]+/;
        const _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
        const def = edit(/^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/).replace("label", _blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
        const list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
        const _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
        const _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
        const html = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))", "i").replace("comment", _comment).replace("tag", _tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
        const paragraph = edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "") // setext headings don't interrupt commonmark paragraphs
        .replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
        .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // pars can be interrupted by type (6) html blocks
        .getRegex();
        const blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", paragraph).getRegex();
        /**
	 * Normal Block Grammar
	 */ const blockNormal = {
            blockquote,
            code: blockCode,
            def,
            fences,
            heading,
            hr,
            html,
            lheading,
            list,
            newline,
            paragraph,
            table: noopTest,
            text: blockText
        };
        /**
	 * GFM Block Grammar
	 */ const gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)") // Cells
        .replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
        .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // tables can be interrupted by type (6) html blocks
        .getRegex();
        const blockGfm = {
            ...blockNormal,
            table: gfmTable,
            paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "") // setext headings don't interrupt commonmark paragraphs
            .replace("table", gfmTable) // interrupt paragraphs with table
            .replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
            .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // pars can be interrupted by type (6) html blocks
            .getRegex()
        };
        /**
	 * Pedantic grammar (original John Gruber's loose markdown specification)
	 */ const blockPedantic = {
            ...blockNormal,
            html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
            def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
            heading: /^(#{1,6})(.*)(?:\n+|$)/,
            fences: noopTest,
            lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
            paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
        };
        /**
	 * Inline-Level Grammar
	 */ const escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
        const inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
        const br = /^( {2,}|\\)\n(?!\s*$)/;
        const inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
        // list of unicode punctuation marks, plus any missing characters from CommonMark spec
        const _punctuation = "\\p{P}\\p{S}";
        const punctuation = edit(/^((?![*_])[\spunctuation])/, "u").replace(/punctuation/g, _punctuation).getRegex();
        // sequences em should skip over [title](link), `code`, <html>
        const blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
        const emStrongLDelim = edit(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, "u").replace(/punct/g, _punctuation).getRegex();
        const emStrongRDelimAst = edit("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)[punct](\\*+)(?=[\\s]|$)|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])|[\\s](\\*+)(?!\\*)(?=[punct])|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])|[^punct\\s](\\*+)(?=[^punct\\s])", "gu") // (6) a***a can be either Left or Right Delimiter
        .replace(/punct/g, _punctuation).getRegex();
        // (6) Not allowed for _
        const emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\\s]|$)|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)|(?!_)[punct\\s](_+)(?=[^punct\\s])|[\\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])", "gu") // (5) #___# can be either Left or Right Delimiter
        .replace(/punct/g, _punctuation).getRegex();
        const anyPunctuation = edit(/\\([punct])/, "gu").replace(/punct/g, _punctuation).getRegex();
        const autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
        const _inlineComment = edit(_comment).replace("(?:-->|$)", "-->").getRegex();
        const tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>") // CDATA section
        .replace("comment", _inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
        const _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
        const link = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", _inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
        const reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", _inlineLabel).replace("ref", _blockLabel).getRegex();
        const nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", _blockLabel).getRegex();
        const reflinkSearch = edit("reflink|nolink(?!\\()", "g").replace("reflink", reflink).replace("nolink", nolink).getRegex();
        /**
	 * Normal Inline Grammar
	 */ const inlineNormal = {
            _backpedal: noopTest,
            anyPunctuation,
            autolink,
            blockSkip,
            br,
            code: inlineCode,
            del: noopTest,
            emStrongLDelim,
            emStrongRDelimAst,
            emStrongRDelimUnd,
            escape,
            link,
            nolink,
            punctuation,
            reflink,
            reflinkSearch,
            tag,
            text: inlineText,
            url: noopTest
        };
        /**
	 * Pedantic Inline Grammar
	 */ const inlinePedantic = {
            ...inlineNormal,
            link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", _inlineLabel).getRegex(),
            reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", _inlineLabel).getRegex()
        };
        /**
	 * GFM Inline Grammar
	 */ const inlineGfm = {
            ...inlineNormal,
            escape: edit(escape).replace("])", "~|])").getRegex(),
            url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
            _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
            del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
            text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
        };
        /**
	 * GFM + Line Breaks Inline Grammar
	 */ const inlineBreaks = {
            ...inlineGfm,
            br: edit(br).replace("{2,}", "*").getRegex(),
            text: edit(inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
        };
        /**
	 * exports
	 */ const block = {
            normal: blockNormal,
            gfm: blockGfm,
            pedantic: blockPedantic
        };
        const inline = {
            normal: inlineNormal,
            gfm: inlineGfm,
            breaks: inlineBreaks,
            pedantic: inlinePedantic
        };
        /**
	 * Block Lexer
	 */ class _Lexer {
            tokens;
            options;
            state;
            tokenizer;
            inlineQueue;
            constructor(options){
                // TokenList cannot be created in one go
                this.tokens = [];
                this.tokens.links = Object.create(null);
                this.options = options || exports1.defaults;
                this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
                this.tokenizer = this.options.tokenizer;
                this.tokenizer.options = this.options;
                this.tokenizer.lexer = this;
                this.inlineQueue = [];
                this.state = {
                    inLink: false,
                    inRawBlock: false,
                    top: true
                };
                const rules = {
                    block: block.normal,
                    inline: inline.normal
                };
                if (this.options.pedantic) {
                    rules.block = block.pedantic;
                    rules.inline = inline.pedantic;
                } else if (this.options.gfm) {
                    rules.block = block.gfm;
                    if (this.options.breaks) rules.inline = inline.breaks;
                    else rules.inline = inline.gfm;
                }
                this.tokenizer.rules = rules;
            }
            /**
		 * Expose Rules
		 */ static get rules() {
                return {
                    block,
                    inline
                };
            }
            /**
		 * Static Lex Method
		 */ static lex(src, options) {
                const lexer = new _Lexer(options);
                return lexer.lex(src);
            }
            /**
		 * Static Lex Inline Method
		 */ static lexInline(src, options) {
                const lexer = new _Lexer(options);
                return lexer.inlineTokens(src);
            }
            /**
		 * Preprocessing
		 */ lex(src) {
                src = src.replace(/\r\n|\r/g, "\n");
                this.blockTokens(src, this.tokens);
                for(let i = 0; i < this.inlineQueue.length; i++){
                    const next = this.inlineQueue[i];
                    this.inlineTokens(next.src, next.tokens);
                }
                this.inlineQueue = [];
                return this.tokens;
            }
            blockTokens(src, tokens = [], lastParagraphClipped = false) {
                if (this.options.pedantic) src = src.replace(/\t/g, "    ").replace(/^ +$/gm, "");
                else src = src.replace(/^( *)(\t+)/gm, (_, leading, tabs)=>{
                    return leading + "    ".repeat(tabs.length);
                });
                let token;
                let lastToken;
                let cutSrc;
                while(src){
                    if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((extTokenizer)=>{
                        if (token = extTokenizer.call({
                            lexer: this
                        }, src, tokens)) {
                            src = src.substring(token.raw.length);
                            tokens.push(token);
                            return true;
                        }
                        return false;
                    })) continue;
                    // newline
                    if (token = this.tokenizer.space(src)) {
                        src = src.substring(token.raw.length);
                        if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                        // so move it there so that we don't get unnecessary paragraph tags
                        tokens[tokens.length - 1].raw += "\n";
                        else tokens.push(token);
                        continue;
                    }
                    // code
                    if (token = this.tokenizer.code(src)) {
                        src = src.substring(token.raw.length);
                        lastToken = tokens[tokens.length - 1];
                        // An indented code block cannot interrupt a paragraph.
                        if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                            lastToken.raw += "\n" + token.raw;
                            lastToken.text += "\n" + token.text;
                            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                        } else tokens.push(token);
                        continue;
                    }
                    // fences
                    if (token = this.tokenizer.fences(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // heading
                    if (token = this.tokenizer.heading(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // hr
                    if (token = this.tokenizer.hr(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // blockquote
                    if (token = this.tokenizer.blockquote(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // list
                    if (token = this.tokenizer.list(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // html
                    if (token = this.tokenizer.html(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // def
                    if (token = this.tokenizer.def(src)) {
                        src = src.substring(token.raw.length);
                        lastToken = tokens[tokens.length - 1];
                        if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                            lastToken.raw += "\n" + token.raw;
                            lastToken.text += "\n" + token.raw;
                            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                        } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                            href: token.href,
                            title: token.title
                        };
                        continue;
                    }
                    // table (gfm)
                    if (token = this.tokenizer.table(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // lheading
                    if (token = this.tokenizer.lheading(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // top-level paragraph
                    // prevent paragraph consuming extensions by clipping 'src' to extension start
                    cutSrc = src;
                    if (this.options.extensions && this.options.extensions.startBlock) {
                        let startIndex = Infinity;
                        const tempSrc = src.slice(1);
                        let tempStart;
                        this.options.extensions.startBlock.forEach((getStartIndex)=>{
                            tempStart = getStartIndex.call({
                                lexer: this
                            }, tempSrc);
                            if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                        });
                        if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                    }
                    if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                        lastToken = tokens[tokens.length - 1];
                        if (lastParagraphClipped && lastToken?.type === "paragraph") {
                            lastToken.raw += "\n" + token.raw;
                            lastToken.text += "\n" + token.text;
                            this.inlineQueue.pop();
                            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                        } else tokens.push(token);
                        lastParagraphClipped = cutSrc.length !== src.length;
                        src = src.substring(token.raw.length);
                        continue;
                    }
                    // text
                    if (token = this.tokenizer.text(src)) {
                        src = src.substring(token.raw.length);
                        lastToken = tokens[tokens.length - 1];
                        if (lastToken && lastToken.type === "text") {
                            lastToken.raw += "\n" + token.raw;
                            lastToken.text += "\n" + token.text;
                            this.inlineQueue.pop();
                            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                        } else tokens.push(token);
                        continue;
                    }
                    if (src) {
                        const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                        if (this.options.silent) {
                            console.error(errMsg);
                            break;
                        } else throw new Error(errMsg);
                    }
                }
                this.state.top = true;
                return tokens;
            }
            inline(src, tokens = []) {
                this.inlineQueue.push({
                    src,
                    tokens
                });
                return tokens;
            }
            /**
		 * Lexing/Compiling
		 */ inlineTokens(src, tokens = []) {
                let token, lastToken, cutSrc;
                // String with links masked to avoid interference with em and strong
                let maskedSrc = src;
                let match;
                let keepPrevChar, prevChar;
                // Mask out reflinks
                if (this.tokens.links) {
                    const links = Object.keys(this.tokens.links);
                    if (links.length > 0) {
                        while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                    }
                }
                // Mask out other blocks
                while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
                // Mask out escaped characters
                while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
                while(src){
                    if (!keepPrevChar) prevChar = "";
                    keepPrevChar = false;
                    // extensions
                    if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((extTokenizer)=>{
                        if (token = extTokenizer.call({
                            lexer: this
                        }, src, tokens)) {
                            src = src.substring(token.raw.length);
                            tokens.push(token);
                            return true;
                        }
                        return false;
                    })) continue;
                    // escape
                    if (token = this.tokenizer.escape(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // tag
                    if (token = this.tokenizer.tag(src)) {
                        src = src.substring(token.raw.length);
                        lastToken = tokens[tokens.length - 1];
                        if (lastToken && token.type === "text" && lastToken.type === "text") {
                            lastToken.raw += token.raw;
                            lastToken.text += token.text;
                        } else tokens.push(token);
                        continue;
                    }
                    // link
                    if (token = this.tokenizer.link(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // reflink, nolink
                    if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                        src = src.substring(token.raw.length);
                        lastToken = tokens[tokens.length - 1];
                        if (lastToken && token.type === "text" && lastToken.type === "text") {
                            lastToken.raw += token.raw;
                            lastToken.text += token.text;
                        } else tokens.push(token);
                        continue;
                    }
                    // em & strong
                    if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // code
                    if (token = this.tokenizer.codespan(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // br
                    if (token = this.tokenizer.br(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // del (gfm)
                    if (token = this.tokenizer.del(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // autolink
                    if (token = this.tokenizer.autolink(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // url (gfm)
                    if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        continue;
                    }
                    // text
                    // prevent inlineText consuming extensions by clipping 'src' to extension start
                    cutSrc = src;
                    if (this.options.extensions && this.options.extensions.startInline) {
                        let startIndex = Infinity;
                        const tempSrc = src.slice(1);
                        let tempStart;
                        this.options.extensions.startInline.forEach((getStartIndex)=>{
                            tempStart = getStartIndex.call({
                                lexer: this
                            }, tempSrc);
                            if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                        });
                        if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                    }
                    if (token = this.tokenizer.inlineText(cutSrc)) {
                        src = src.substring(token.raw.length);
                        if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                        keepPrevChar = true;
                        lastToken = tokens[tokens.length - 1];
                        if (lastToken && lastToken.type === "text") {
                            lastToken.raw += token.raw;
                            lastToken.text += token.text;
                        } else tokens.push(token);
                        continue;
                    }
                    if (src) {
                        const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                        if (this.options.silent) {
                            console.error(errMsg);
                            break;
                        } else throw new Error(errMsg);
                    }
                }
                return tokens;
            }
        }
        /**
	 * Renderer
	 */ class _Renderer {
            options;
            parser;
            constructor(options){
                this.options = options || exports1.defaults;
            }
            space(token) {
                return "";
            }
            code({ text, lang, escaped }) {
                const langString = (lang || "").match(/^\S*/)?.[0];
                const code = text.replace(/\n$/, "") + "\n";
                if (!langString) return "<pre><code>" + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
                return '<pre><code class="language-' + escape$1(langString) + '">' + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
            }
            blockquote({ tokens }) {
                const body = this.parser.parse(tokens);
                return `<blockquote>\n${body}</blockquote>\n`;
            }
            html({ text }) {
                return text;
            }
            heading({ tokens, depth }) {
                return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>\n`;
            }
            hr(token) {
                return "<hr>\n";
            }
            list(token) {
                const ordered = token.ordered;
                const start = token.start;
                let body = "";
                for(let j = 0; j < token.items.length; j++){
                    const item = token.items[j];
                    body += this.listitem(item);
                }
                const type = ordered ? "ol" : "ul";
                const startAttr = ordered && start !== 1 ? ' start="' + start + '"' : "";
                return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
            }
            listitem(item) {
                let itemBody = "";
                if (item.task) {
                    const checkbox = this.checkbox({
                        checked: !!item.checked
                    });
                    if (item.loose) {
                        if (item.tokens.length > 0 && item.tokens[0].type === "paragraph") {
                            item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                            if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") item.tokens[0].tokens[0].text = checkbox + " " + item.tokens[0].tokens[0].text;
                        } else item.tokens.unshift({
                            type: "text",
                            raw: checkbox + " ",
                            text: checkbox + " "
                        });
                    } else itemBody += checkbox + " ";
                }
                itemBody += this.parser.parse(item.tokens, !!item.loose);
                return `<li>${itemBody}</li>\n`;
            }
            checkbox({ checked }) {
                return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
            }
            paragraph({ tokens }) {
                return `<p>${this.parser.parseInline(tokens)}</p>\n`;
            }
            table(token) {
                let header = "";
                // header
                let cell = "";
                for(let j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
                header += this.tablerow({
                    text: cell
                });
                let body = "";
                for(let j = 0; j < token.rows.length; j++){
                    const row = token.rows[j];
                    cell = "";
                    for(let k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
                    body += this.tablerow({
                        text: cell
                    });
                }
                if (body) body = `<tbody>${body}</tbody>`;
                return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
            }
            tablerow({ text }) {
                return `<tr>\n${text}</tr>\n`;
            }
            tablecell(token) {
                const content = this.parser.parseInline(token.tokens);
                const type = token.header ? "th" : "td";
                const tag = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
                return tag + content + `</${type}>\n`;
            }
            /**
		 * span level renderer
		 */ strong({ tokens }) {
                return `<strong>${this.parser.parseInline(tokens)}</strong>`;
            }
            em({ tokens }) {
                return `<em>${this.parser.parseInline(tokens)}</em>`;
            }
            codespan({ text }) {
                return `<code>${text}</code>`;
            }
            br(token) {
                return "<br>";
            }
            del({ tokens }) {
                return `<del>${this.parser.parseInline(tokens)}</del>`;
            }
            link({ href, title, tokens }) {
                const text = this.parser.parseInline(tokens);
                const cleanHref = cleanUrl(href);
                if (cleanHref === null) return text;
                href = cleanHref;
                let out = '<a href="' + href + '"';
                if (title) out += ' title="' + title + '"';
                out += ">" + text + "</a>";
                return out;
            }
            image({ href, title, text }) {
                const cleanHref = cleanUrl(href);
                if (cleanHref === null) return text;
                href = cleanHref;
                let out = `<img src="${href}" alt="${text}"`;
                if (title) out += ` title="${title}"`;
                out += ">";
                return out;
            }
            text(token) {
                return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : token.text;
            }
        }
        /**
	 * TextRenderer
	 * returns only the textual part of the token
	 */ class _TextRenderer {
            // no need for block level renderers
            strong({ text }) {
                return text;
            }
            em({ text }) {
                return text;
            }
            codespan({ text }) {
                return text;
            }
            del({ text }) {
                return text;
            }
            html({ text }) {
                return text;
            }
            text({ text }) {
                return text;
            }
            link({ text }) {
                return "" + text;
            }
            image({ text }) {
                return "" + text;
            }
            br() {
                return "";
            }
        }
        /**
	 * Parsing & Compiling
	 */ class _Parser {
            options;
            renderer;
            textRenderer;
            constructor(options){
                this.options = options || exports1.defaults;
                this.options.renderer = this.options.renderer || new _Renderer();
                this.renderer = this.options.renderer;
                this.renderer.options = this.options;
                this.renderer.parser = this;
                this.textRenderer = new _TextRenderer();
            }
            /**
		 * Static Parse Method
		 */ static parse(tokens, options) {
                const parser = new _Parser(options);
                return parser.parse(tokens);
            }
            /**
		 * Static Parse Inline Method
		 */ static parseInline(tokens, options) {
                const parser = new _Parser(options);
                return parser.parseInline(tokens);
            }
            /**
		 * Parse Loop
		 */ parse(tokens, top = true) {
                let out = "";
                for(let i = 0; i < tokens.length; i++){
                    const anyToken = tokens[i];
                    // Run any renderer extensions
                    if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[anyToken.type]) {
                        const genericToken = anyToken;
                        const ret = this.options.extensions.renderers[genericToken.type].call({
                            parser: this
                        }, genericToken);
                        if (ret !== false || ![
                            "space",
                            "hr",
                            "heading",
                            "code",
                            "table",
                            "blockquote",
                            "list",
                            "html",
                            "paragraph",
                            "text"
                        ].includes(genericToken.type)) {
                            out += ret || "";
                            continue;
                        }
                    }
                    const token = anyToken;
                    switch(token.type){
                        case "space":
                            out += this.renderer.space(token);
                            continue;
                        case "hr":
                            out += this.renderer.hr(token);
                            continue;
                        case "heading":
                            out += this.renderer.heading(token);
                            continue;
                        case "code":
                            out += this.renderer.code(token);
                            continue;
                        case "table":
                            out += this.renderer.table(token);
                            continue;
                        case "blockquote":
                            out += this.renderer.blockquote(token);
                            continue;
                        case "list":
                            out += this.renderer.list(token);
                            continue;
                        case "html":
                            out += this.renderer.html(token);
                            continue;
                        case "paragraph":
                            out += this.renderer.paragraph(token);
                            continue;
                        case "text":
                            {
                                let textToken = token;
                                let body = this.renderer.text(textToken);
                                while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                                    textToken = tokens[++i];
                                    body += "\n" + this.renderer.text(textToken);
                                }
                                if (top) out += this.renderer.paragraph({
                                    type: "paragraph",
                                    raw: body,
                                    text: body,
                                    tokens: [
                                        {
                                            type: "text",
                                            raw: body,
                                            text: body
                                        }
                                    ]
                                });
                                else out += body;
                                continue;
                            }
                        default:
                            {
                                const errMsg = 'Token with "' + token.type + '" type was not found.';
                                if (this.options.silent) {
                                    console.error(errMsg);
                                    return "";
                                } else throw new Error(errMsg);
                            }
                    }
                }
                return out;
            }
            /**
		 * Parse Inline Tokens
		 */ parseInline(tokens, renderer) {
                renderer = renderer || this.renderer;
                let out = "";
                for(let i = 0; i < tokens.length; i++){
                    const anyToken = tokens[i];
                    // Run any renderer extensions
                    if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[anyToken.type]) {
                        const ret = this.options.extensions.renderers[anyToken.type].call({
                            parser: this
                        }, anyToken);
                        if (ret !== false || ![
                            "escape",
                            "html",
                            "link",
                            "image",
                            "strong",
                            "em",
                            "codespan",
                            "br",
                            "del",
                            "text"
                        ].includes(anyToken.type)) {
                            out += ret || "";
                            continue;
                        }
                    }
                    const token = anyToken;
                    switch(token.type){
                        case "escape":
                            out += renderer.text(token);
                            break;
                        case "html":
                            out += renderer.html(token);
                            break;
                        case "link":
                            out += renderer.link(token);
                            break;
                        case "image":
                            out += renderer.image(token);
                            break;
                        case "strong":
                            out += renderer.strong(token);
                            break;
                        case "em":
                            out += renderer.em(token);
                            break;
                        case "codespan":
                            out += renderer.codespan(token);
                            break;
                        case "br":
                            out += renderer.br(token);
                            break;
                        case "del":
                            out += renderer.del(token);
                            break;
                        case "text":
                            out += renderer.text(token);
                            break;
                        default:
                            {
                                const errMsg = 'Token with "' + token.type + '" type was not found.';
                                if (this.options.silent) {
                                    console.error(errMsg);
                                    return "";
                                } else throw new Error(errMsg);
                            }
                    }
                }
                return out;
            }
        }
        class _Hooks {
            options;
            constructor(options){
                this.options = options || exports1.defaults;
            }
            static passThroughHooks = new Set([
                "preprocess",
                "postprocess",
                "processAllTokens"
            ]);
            /**
		 * Process markdown before marked
		 */ preprocess(markdown) {
                return markdown;
            }
            /**
		 * Process HTML after marked is finished
		 */ postprocess(html) {
                return html;
            }
            /**
		 * Process all tokens before walk tokens
		 */ processAllTokens(tokens) {
                return tokens;
            }
        }
        class Marked {
            defaults = _getDefaults();
            options = this.setOptions;
            parse = this.parseMarkdown(_Lexer.lex, _Parser.parse);
            parseInline = this.parseMarkdown(_Lexer.lexInline, _Parser.parseInline);
            Parser = _Parser;
            Renderer = _Renderer;
            TextRenderer = _TextRenderer;
            Lexer = _Lexer;
            Tokenizer = _Tokenizer;
            Hooks = _Hooks;
            constructor(...args){
                this.use(...args);
            }
            /**
		 * Run callback for every token
		 */ walkTokens(tokens, callback) {
                let values = [];
                for (const token of tokens){
                    values = values.concat(callback.call(this, token));
                    switch(token.type){
                        case "table":
                            {
                                const tableToken = token;
                                for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                                for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                                break;
                            }
                        case "list":
                            {
                                const listToken = token;
                                values = values.concat(this.walkTokens(listToken.items, callback));
                                break;
                            }
                        default:
                            {
                                const genericToken = token;
                                if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                                    const tokens = genericToken[childTokens].flat(Infinity);
                                    values = values.concat(this.walkTokens(tokens, callback));
                                });
                                else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                            }
                    }
                }
                return values;
            }
            use(...args) {
                const extensions = this.defaults.extensions || {
                    renderers: {},
                    childTokens: {}
                };
                args.forEach((pack)=>{
                    // copy options to new object
                    const opts = {
                        ...pack
                    };
                    // set async to true if it was set to true before
                    opts.async = this.defaults.async || opts.async || false;
                    // ==-- Parse "addon" extensions --== //
                    if (pack.extensions) {
                        pack.extensions.forEach((ext)=>{
                            if (!ext.name) throw new Error("extension name required");
                            if ("renderer" in ext) {
                                const prevRenderer = extensions.renderers[ext.name];
                                if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                                extensions.renderers[ext.name] = function(...args) {
                                    let ret = ext.renderer.apply(this, args);
                                    if (ret === false) ret = prevRenderer.apply(this, args);
                                    return ret;
                                };
                                else extensions.renderers[ext.name] = ext.renderer;
                            }
                            if ("tokenizer" in ext) {
                                if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                                const extLevel = extensions[ext.level];
                                if (extLevel) extLevel.unshift(ext.tokenizer);
                                else extensions[ext.level] = [
                                    ext.tokenizer
                                ];
                                if (ext.start) {
                                    if (ext.level === "block") {
                                        if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                        else extensions.startBlock = [
                                            ext.start
                                        ];
                                    } else if (ext.level === "inline") {
                                        if (extensions.startInline) extensions.startInline.push(ext.start);
                                        else extensions.startInline = [
                                            ext.start
                                        ];
                                    }
                                }
                            }
                            if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                        });
                        opts.extensions = extensions;
                    }
                    // ==-- Parse "overwrite" extensions --== //
                    if (pack.renderer) {
                        const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                        for(const prop in pack.renderer){
                            if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                            if ([
                                "options",
                                "parser"
                            ].includes(prop)) continue;
                            const rendererProp = prop;
                            const rendererFunc = pack.renderer[rendererProp];
                            const prevRenderer = renderer[rendererProp];
                            // Replace renderer with func to run extension, but fall back if false
                            renderer[rendererProp] = (...args)=>{
                                let ret = rendererFunc.apply(renderer, args);
                                if (ret === false) ret = prevRenderer.apply(renderer, args);
                                return ret || "";
                            };
                        }
                        opts.renderer = renderer;
                    }
                    if (pack.tokenizer) {
                        const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                        for(const prop in pack.tokenizer){
                            if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                            if ([
                                "options",
                                "rules",
                                "lexer"
                            ].includes(prop)) continue;
                            const tokenizerProp = prop;
                            const tokenizerFunc = pack.tokenizer[tokenizerProp];
                            const prevTokenizer = tokenizer[tokenizerProp];
                            // Replace tokenizer with func to run extension, but fall back if false
                            // @ts-expect-error cannot type tokenizer function dynamically
                            tokenizer[tokenizerProp] = (...args)=>{
                                let ret = tokenizerFunc.apply(tokenizer, args);
                                if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                                return ret;
                            };
                        }
                        opts.tokenizer = tokenizer;
                    }
                    // ==-- Parse Hooks extensions --== //
                    if (pack.hooks) {
                        const hooks = this.defaults.hooks || new _Hooks();
                        for(const prop in pack.hooks){
                            if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                            if (prop === "options") continue;
                            const hooksProp = prop;
                            const hooksFunc = pack.hooks[hooksProp];
                            const prevHook = hooks[hooksProp];
                            if (_Hooks.passThroughHooks.has(prop)) // @ts-expect-error cannot type hook function dynamically
                            hooks[hooksProp] = (arg)=>{
                                if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret)=>{
                                    return prevHook.call(hooks, ret);
                                });
                                const ret = hooksFunc.call(hooks, arg);
                                return prevHook.call(hooks, ret);
                            };
                            else // @ts-expect-error cannot type hook function dynamically
                            hooks[hooksProp] = (...args)=>{
                                let ret = hooksFunc.apply(hooks, args);
                                if (ret === false) ret = prevHook.apply(hooks, args);
                                return ret;
                            };
                        }
                        opts.hooks = hooks;
                    }
                    // ==-- Parse WalkTokens extensions --== //
                    if (pack.walkTokens) {
                        const walkTokens = this.defaults.walkTokens;
                        const packWalktokens = pack.walkTokens;
                        opts.walkTokens = function(token) {
                            let values = [];
                            values.push(packWalktokens.call(this, token));
                            if (walkTokens) values = values.concat(walkTokens.call(this, token));
                            return values;
                        };
                    }
                    this.defaults = {
                        ...this.defaults,
                        ...opts
                    };
                });
                return this;
            }
            setOptions(opt) {
                this.defaults = {
                    ...this.defaults,
                    ...opt
                };
                return this;
            }
            lexer(src, options) {
                return _Lexer.lex(src, options ?? this.defaults);
            }
            parser(tokens, options) {
                return _Parser.parse(tokens, options ?? this.defaults);
            }
            parseMarkdown(lexer, parser) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const parse = (src, options)=>{
                    const origOpt = {
                        ...options
                    };
                    const opt = {
                        ...this.defaults,
                        ...origOpt
                    };
                    const throwError = this.onError(!!opt.silent, !!opt.async);
                    // throw error if an extension set async to true but parse was called with async: false
                    if (this.defaults.async === true && origOpt.async === false) return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                    // throw error in case of non string input
                    if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
                    if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
                    if (opt.hooks) opt.hooks.options = opt;
                    if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src)=>lexer(src, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser(tokens, opt)).then((html)=>opt.hooks ? opt.hooks.postprocess(html) : html).catch(throwError);
                    try {
                        if (opt.hooks) src = opt.hooks.preprocess(src);
                        let tokens = lexer(src, opt);
                        if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                        if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                        let html = parser(tokens, opt);
                        if (opt.hooks) html = opt.hooks.postprocess(html);
                        return html;
                    } catch (e) {
                        return throwError(e);
                    }
                };
                return parse;
            }
            onError(silent, async) {
                return (e)=>{
                    e.message += "\nPlease report this to https://github.com/markedjs/marked.";
                    if (silent) {
                        const msg = "<p>An error occurred:</p><pre>" + escape$1(e.message + "", true) + "</pre>";
                        if (async) return Promise.resolve(msg);
                        return msg;
                    }
                    if (async) return Promise.reject(e);
                    throw e;
                };
            }
        }
        const markedInstance = new Marked();
        function marked(src, opt) {
            return markedInstance.parse(src, opt);
        }
        /**
	 * Sets the default options.
	 *
	 * @param options Hash of options
	 */ marked.options = marked.setOptions = function(options) {
            markedInstance.setOptions(options);
            marked.defaults = markedInstance.defaults;
            changeDefaults(marked.defaults);
            return marked;
        };
        /**
	 * Gets the original marked default options.
	 */ marked.getDefaults = _getDefaults;
        marked.defaults = exports1.defaults;
        /**
	 * Use Extension
	 */ marked.use = function(...args) {
            markedInstance.use(...args);
            marked.defaults = markedInstance.defaults;
            changeDefaults(marked.defaults);
            return marked;
        };
        /**
	 * Run callback for every token
	 */ marked.walkTokens = function(tokens, callback) {
            return markedInstance.walkTokens(tokens, callback);
        };
        /**
	 * Compiles markdown to HTML without enclosing `p` tag.
	 *
	 * @param src String of markdown source to be compiled
	 * @param options Hash of options
	 * @return String of compiled HTML
	 */ marked.parseInline = markedInstance.parseInline;
        /**
	 * Expose
	 */ marked.Parser = _Parser;
        marked.parser = _Parser.parse;
        marked.Renderer = _Renderer;
        marked.TextRenderer = _TextRenderer;
        marked.Lexer = _Lexer;
        marked.lexer = _Lexer.lex;
        marked.Tokenizer = _Tokenizer;
        marked.Hooks = _Hooks;
        marked.parse = marked;
        const options = marked.options;
        const setOptions = marked.setOptions;
        const use = marked.use;
        const walkTokens = marked.walkTokens;
        const parseInline = marked.parseInline;
        const parse = marked;
        const parser = _Parser.parse;
        const lexer = _Lexer.lex;
        exports1.Hooks = _Hooks;
        exports1.Lexer = _Lexer;
        exports1.Marked = Marked;
        exports1.Parser = _Parser;
        exports1.Renderer = _Renderer;
        exports1.TextRenderer = _TextRenderer;
        exports1.Tokenizer = _Tokenizer;
        exports1.getDefaults = _getDefaults;
        exports1.lexer = lexer;
        exports1.marked = marked;
        exports1.options = options;
        exports1.parse = parse;
        exports1.parseInline = parseInline;
        exports1.parser = parser;
        exports1.setOptions = setOptions;
        exports1.use = use;
        exports1.walkTokens = walkTokens;
    });
// ESM-uncomment-begin
})();
var Hooks = __marked_exports.Hooks || exports.Hooks;
var Lexer = __marked_exports.Lexer || exports.Lexer;
var Marked = __marked_exports.Marked || exports.Marked;
var Parser = __marked_exports.Parser || exports.Parser;
var Renderer = __marked_exports.Renderer || exports.Renderer;
var TextRenderer = __marked_exports.TextRenderer || exports.TextRenderer;
var Tokenizer = __marked_exports.Tokenizer || exports.Tokenizer;
var defaults = __marked_exports.defaults || exports.defaults;
var getDefaults = __marked_exports.getDefaults || exports.getDefaults;
var lexer = __marked_exports.lexer || exports.lexer;
var marked = __marked_exports.marked || exports.marked;
var options = __marked_exports.options || exports.options;
var parse = __marked_exports.parse || exports.parse;
var parseInline = __marked_exports.parseInline || exports.parseInline;
var parser = __marked_exports.parser || exports.parser;
var setOptions = __marked_exports.setOptions || exports.setOptions;
var use = __marked_exports.use || exports.use;
var walkTokens = __marked_exports.walkTokens || exports.walkTokens; // ESM-uncomment-end
 //# sourceMappingURL=marked.umd.js.map

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e1DQr":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stringify", ()=>stringify);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "revive", ()=>revive);
var _bufferJs = require("./buffer.js");
var _uriJs = require("./uri.js");
function stringify(obj) {
    return JSON.stringify(obj, replacer);
}
function parse(text) {
    let data = JSON.parse(text);
    data = revive(data);
    return data;
}
function replacer(key, value) {
    // URI is done via toJSON-member
    if (value instanceof RegExp) return {
        $mid: 2 /* MarshalledId.Regexp */ ,
        source: value.source,
        flags: value.flags
    };
    return value;
}
function revive(obj, depth = 0) {
    if (!obj || depth > 200) return obj;
    if (typeof obj === "object") {
        switch(obj.$mid){
            case 1 /* MarshalledId.Uri */ :
                return (0, _uriJs.URI).revive(obj);
            case 2 /* MarshalledId.Regexp */ :
                return new RegExp(obj.source, obj.flags);
            case 17 /* MarshalledId.Date */ :
                return new Date(obj.source);
        }
        if (obj instanceof (0, _bufferJs.VSBuffer) || obj instanceof Uint8Array) return obj;
        if (Array.isArray(obj)) for(let i = 0; i < obj.length; ++i)obj[i] = revive(obj[i], depth + 1);
        else {
            // walk object
            for(const key in obj)if (Object.hasOwnProperty.call(obj, key)) obj[key] = revive(obj[key], depth + 1);
        }
    }
    return obj;
}

},{"./buffer.js":"cRDFR","./uri.js":"7qGS3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ROAwM":[function() {},{}],"je4FM":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tokenizeToString", ()=>tokenizeToString);
parcelHelpers.export(exports, "tokenizeLineToHTML", ()=>tokenizeLineToHTML);
parcelHelpers.export(exports, "_tokenizeToString", ()=>_tokenizeToString);
var _stringsJs = require("../../../base/common/strings.js");
var _lineTokensJs = require("../tokens/lineTokens.js");
var _languagesJs = require("../languages.js");
var _nullTokenizeJs = require("./nullTokenize.js");
const fallback = {
    getInitialState: ()=>(0, _nullTokenizeJs.NullState),
    tokenizeEncoded: (buffer, hasEOL, state)=>(0, _nullTokenizeJs.nullTokenizeEncoded)(0 /* LanguageId.Null */ , state)
};
async function tokenizeToString(languageService, text, languageId) {
    if (!languageId) return _tokenizeToString(text, languageService.languageIdCodec, fallback);
    const tokenizationSupport = await (0, _languagesJs.TokenizationRegistry).getOrCreate(languageId);
    return _tokenizeToString(text, languageService.languageIdCodec, tokenizationSupport || fallback);
}
function tokenizeLineToHTML(text, viewLineTokens, colorMap, startOffset, endOffset, tabSize, useNbsp) {
    let result = `<div>`;
    let charIndex = startOffset;
    let tabsCharDelta = 0;
    let prevIsSpace = true;
    for(let tokenIndex = 0, tokenCount = viewLineTokens.getCount(); tokenIndex < tokenCount; tokenIndex++){
        const tokenEndIndex = viewLineTokens.getEndOffset(tokenIndex);
        if (tokenEndIndex <= startOffset) continue;
        let partContent = "";
        for(; charIndex < tokenEndIndex && charIndex < endOffset; charIndex++){
            const charCode = text.charCodeAt(charIndex);
            switch(charCode){
                case 9 /* CharCode.Tab */ :
                    {
                        let insertSpacesCount = tabSize - (charIndex + tabsCharDelta) % tabSize;
                        tabsCharDelta += insertSpacesCount - 1;
                        while(insertSpacesCount > 0){
                            if (useNbsp && prevIsSpace) {
                                partContent += "&#160;";
                                prevIsSpace = false;
                            } else {
                                partContent += " ";
                                prevIsSpace = true;
                            }
                            insertSpacesCount--;
                        }
                        break;
                    }
                case 60 /* CharCode.LessThan */ :
                    partContent += "&lt;";
                    prevIsSpace = false;
                    break;
                case 62 /* CharCode.GreaterThan */ :
                    partContent += "&gt;";
                    prevIsSpace = false;
                    break;
                case 38 /* CharCode.Ampersand */ :
                    partContent += "&amp;";
                    prevIsSpace = false;
                    break;
                case 0 /* CharCode.Null */ :
                    partContent += "&#00;";
                    prevIsSpace = false;
                    break;
                case 65279 /* CharCode.UTF8_BOM */ :
                case 8232 /* CharCode.LINE_SEPARATOR */ :
                case 8233 /* CharCode.PARAGRAPH_SEPARATOR */ :
                case 133 /* CharCode.NEXT_LINE */ :
                    partContent += "\uFFFD";
                    prevIsSpace = false;
                    break;
                case 13 /* CharCode.CarriageReturn */ :
                    // zero width space, because carriage return would introduce a line break
                    partContent += "&#8203";
                    prevIsSpace = false;
                    break;
                case 32 /* CharCode.Space */ :
                    if (useNbsp && prevIsSpace) {
                        partContent += "&#160;";
                        prevIsSpace = false;
                    } else {
                        partContent += " ";
                        prevIsSpace = true;
                    }
                    break;
                default:
                    partContent += String.fromCharCode(charCode);
                    prevIsSpace = false;
            }
        }
        result += `<span style="${viewLineTokens.getInlineStyle(tokenIndex, colorMap)}">${partContent}</span>`;
        if (tokenEndIndex > endOffset || charIndex >= endOffset) break;
    }
    result += `</div>`;
    return result;
}
function _tokenizeToString(text, languageIdCodec, tokenizationSupport) {
    let result = `<div class="monaco-tokenized-source">`;
    const lines = _stringsJs.splitLines(text);
    let currentState = tokenizationSupport.getInitialState();
    for(let i = 0, len = lines.length; i < len; i++){
        const line = lines[i];
        if (i > 0) result += `<br/>`;
        const tokenizationResult = tokenizationSupport.tokenizeEncoded(line, true, currentState);
        (0, _lineTokensJs.LineTokens).convertToEndOffset(tokenizationResult.tokens, line.length);
        const lineTokens = new (0, _lineTokensJs.LineTokens)(tokenizationResult.tokens, line, languageIdCodec);
        const viewLineTokens = lineTokens.inflate();
        let startOffset = 0;
        for(let j = 0, lenJ = viewLineTokens.getCount(); j < lenJ; j++){
            const type = viewLineTokens.getClassName(j);
            const endIndex = viewLineTokens.getEndOffset(j);
            result += `<span class="${type}">${_stringsJs.escape(line.substring(startOffset, endIndex))}</span>`;
            startOffset = endIndex;
        }
        currentState = tokenizationResult.endState;
    }
    result += `</div>`;
    return result;
}

},{"../../../base/common/strings.js":"aA9I1","../tokens/lineTokens.js":"6iUVx","../languages.js":"g5n96","./nullTokenize.js":"ekzGB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6iUVx":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineTokens", ()=>LineTokens);
parcelHelpers.export(exports, "getStandardTokenTypeAtPosition", ()=>getStandardTokenTypeAtPosition);
var _encodedTokenAttributesJs = require("../encodedTokenAttributes.js");
class LineTokens {
    static{
        this.defaultTokenMetadata = 33587200;
    }
    static createEmpty(lineContent, decoder) {
        const defaultMetadata = LineTokens.defaultTokenMetadata;
        const tokens = new Uint32Array(2);
        tokens[0] = lineContent.length;
        tokens[1] = defaultMetadata;
        return new LineTokens(tokens, lineContent, decoder);
    }
    static createFromTextAndMetadata(data, decoder) {
        let offset = 0;
        let fullText = "";
        const tokens = new Array();
        for (const { text, metadata } of data){
            tokens.push(offset + text.length, metadata);
            offset += text.length;
            fullText += text;
        }
        return new LineTokens(new Uint32Array(tokens), fullText, decoder);
    }
    constructor(tokens, text, decoder){
        this._lineTokensBrand = undefined;
        this._tokens = tokens;
        this._tokensCount = this._tokens.length >>> 1;
        this._text = text;
        this.languageIdCodec = decoder;
    }
    equals(other) {
        if (other instanceof LineTokens) return this.slicedEquals(other, 0, this._tokensCount);
        return false;
    }
    slicedEquals(other, sliceFromTokenIndex, sliceTokenCount) {
        if (this._text !== other._text) return false;
        if (this._tokensCount !== other._tokensCount) return false;
        const from = sliceFromTokenIndex << 1;
        const to = from + (sliceTokenCount << 1);
        for(let i = from; i < to; i++){
            if (this._tokens[i] !== other._tokens[i]) return false;
        }
        return true;
    }
    getLineContent() {
        return this._text;
    }
    getCount() {
        return this._tokensCount;
    }
    getStartOffset(tokenIndex) {
        if (tokenIndex > 0) return this._tokens[tokenIndex - 1 << 1];
        return 0;
    }
    getMetadata(tokenIndex) {
        const metadata = this._tokens[(tokenIndex << 1) + 1];
        return metadata;
    }
    getLanguageId(tokenIndex) {
        const metadata = this._tokens[(tokenIndex << 1) + 1];
        const languageId = (0, _encodedTokenAttributesJs.TokenMetadata).getLanguageId(metadata);
        return this.languageIdCodec.decodeLanguageId(languageId);
    }
    getStandardTokenType(tokenIndex) {
        const metadata = this._tokens[(tokenIndex << 1) + 1];
        return (0, _encodedTokenAttributesJs.TokenMetadata).getTokenType(metadata);
    }
    getForeground(tokenIndex) {
        const metadata = this._tokens[(tokenIndex << 1) + 1];
        return (0, _encodedTokenAttributesJs.TokenMetadata).getForeground(metadata);
    }
    getClassName(tokenIndex) {
        const metadata = this._tokens[(tokenIndex << 1) + 1];
        return (0, _encodedTokenAttributesJs.TokenMetadata).getClassNameFromMetadata(metadata);
    }
    getInlineStyle(tokenIndex, colorMap) {
        const metadata = this._tokens[(tokenIndex << 1) + 1];
        return (0, _encodedTokenAttributesJs.TokenMetadata).getInlineStyleFromMetadata(metadata, colorMap);
    }
    getPresentation(tokenIndex) {
        const metadata = this._tokens[(tokenIndex << 1) + 1];
        return (0, _encodedTokenAttributesJs.TokenMetadata).getPresentationFromMetadata(metadata);
    }
    getEndOffset(tokenIndex) {
        return this._tokens[tokenIndex << 1];
    }
    /**
     * Find the token containing offset `offset`.
     * @param offset The search offset
     * @return The index of the token containing the offset.
     */ findTokenIndexAtOffset(offset) {
        return LineTokens.findIndexInTokensArray(this._tokens, offset);
    }
    inflate() {
        return this;
    }
    sliceAndInflate(startOffset, endOffset, deltaOffset) {
        return new SliceLineTokens(this, startOffset, endOffset, deltaOffset);
    }
    static convertToEndOffset(tokens, lineTextLength) {
        const tokenCount = tokens.length >>> 1;
        const lastTokenIndex = tokenCount - 1;
        for(let tokenIndex = 0; tokenIndex < lastTokenIndex; tokenIndex++)tokens[tokenIndex << 1] = tokens[tokenIndex + 1 << 1];
        tokens[lastTokenIndex << 1] = lineTextLength;
    }
    static findIndexInTokensArray(tokens, desiredIndex) {
        if (tokens.length <= 2) return 0;
        let low = 0;
        let high = (tokens.length >>> 1) - 1;
        while(low < high){
            const mid = low + Math.floor((high - low) / 2);
            const endOffset = tokens[mid << 1];
            if (endOffset === desiredIndex) return mid + 1;
            else if (endOffset < desiredIndex) low = mid + 1;
            else if (endOffset > desiredIndex) high = mid;
        }
        return low;
    }
    /**
     * @pure
     * @param insertTokens Must be sorted by offset.
    */ withInserted(insertTokens) {
        if (insertTokens.length === 0) return this;
        let nextOriginalTokenIdx = 0;
        let nextInsertTokenIdx = 0;
        let text = "";
        const newTokens = new Array();
        let originalEndOffset = 0;
        while(true){
            const nextOriginalTokenEndOffset = nextOriginalTokenIdx < this._tokensCount ? this._tokens[nextOriginalTokenIdx << 1] : -1;
            const nextInsertToken = nextInsertTokenIdx < insertTokens.length ? insertTokens[nextInsertTokenIdx] : null;
            if (nextOriginalTokenEndOffset !== -1 && (nextInsertToken === null || nextOriginalTokenEndOffset <= nextInsertToken.offset)) {
                // original token ends before next insert token
                text += this._text.substring(originalEndOffset, nextOriginalTokenEndOffset);
                const metadata = this._tokens[(nextOriginalTokenIdx << 1) + 1];
                newTokens.push(text.length, metadata);
                nextOriginalTokenIdx++;
                originalEndOffset = nextOriginalTokenEndOffset;
            } else if (nextInsertToken) {
                if (nextInsertToken.offset > originalEndOffset) {
                    // insert token is in the middle of the next token.
                    text += this._text.substring(originalEndOffset, nextInsertToken.offset);
                    const metadata = this._tokens[(nextOriginalTokenIdx << 1) + 1];
                    newTokens.push(text.length, metadata);
                    originalEndOffset = nextInsertToken.offset;
                }
                text += nextInsertToken.text;
                newTokens.push(text.length, nextInsertToken.tokenMetadata);
                nextInsertTokenIdx++;
            } else break;
        }
        return new LineTokens(new Uint32Array(newTokens), text, this.languageIdCodec);
    }
    getTokenText(tokenIndex) {
        const startOffset = this.getStartOffset(tokenIndex);
        const endOffset = this.getEndOffset(tokenIndex);
        const text = this._text.substring(startOffset, endOffset);
        return text;
    }
    forEach(callback) {
        const tokenCount = this.getCount();
        for(let tokenIndex = 0; tokenIndex < tokenCount; tokenIndex++)callback(tokenIndex);
    }
}
class SliceLineTokens {
    constructor(source, startOffset, endOffset, deltaOffset){
        this._source = source;
        this._startOffset = startOffset;
        this._endOffset = endOffset;
        this._deltaOffset = deltaOffset;
        this._firstTokenIndex = source.findTokenIndexAtOffset(startOffset);
        this.languageIdCodec = source.languageIdCodec;
        this._tokensCount = 0;
        for(let i = this._firstTokenIndex, len = source.getCount(); i < len; i++){
            const tokenStartOffset = source.getStartOffset(i);
            if (tokenStartOffset >= endOffset) break;
            this._tokensCount++;
        }
    }
    getMetadata(tokenIndex) {
        return this._source.getMetadata(this._firstTokenIndex + tokenIndex);
    }
    getLanguageId(tokenIndex) {
        return this._source.getLanguageId(this._firstTokenIndex + tokenIndex);
    }
    getLineContent() {
        return this._source.getLineContent().substring(this._startOffset, this._endOffset);
    }
    equals(other) {
        if (other instanceof SliceLineTokens) return this._startOffset === other._startOffset && this._endOffset === other._endOffset && this._deltaOffset === other._deltaOffset && this._source.slicedEquals(other._source, this._firstTokenIndex, this._tokensCount);
        return false;
    }
    getCount() {
        return this._tokensCount;
    }
    getStandardTokenType(tokenIndex) {
        return this._source.getStandardTokenType(this._firstTokenIndex + tokenIndex);
    }
    getForeground(tokenIndex) {
        return this._source.getForeground(this._firstTokenIndex + tokenIndex);
    }
    getEndOffset(tokenIndex) {
        const tokenEndOffset = this._source.getEndOffset(this._firstTokenIndex + tokenIndex);
        return Math.min(this._endOffset, tokenEndOffset) - this._startOffset + this._deltaOffset;
    }
    getClassName(tokenIndex) {
        return this._source.getClassName(this._firstTokenIndex + tokenIndex);
    }
    getInlineStyle(tokenIndex, colorMap) {
        return this._source.getInlineStyle(this._firstTokenIndex + tokenIndex, colorMap);
    }
    getPresentation(tokenIndex) {
        return this._source.getPresentation(this._firstTokenIndex + tokenIndex);
    }
    findTokenIndexAtOffset(offset) {
        return this._source.findTokenIndexAtOffset(offset + this._startOffset - this._deltaOffset) - this._firstTokenIndex;
    }
    getTokenText(tokenIndex) {
        const adjustedTokenIndex = this._firstTokenIndex + tokenIndex;
        const tokenStartOffset = this._source.getStartOffset(adjustedTokenIndex);
        const tokenEndOffset = this._source.getEndOffset(adjustedTokenIndex);
        let text = this._source.getTokenText(adjustedTokenIndex);
        if (tokenStartOffset < this._startOffset) text = text.substring(this._startOffset - tokenStartOffset);
        if (tokenEndOffset > this._endOffset) text = text.substring(0, text.length - (tokenEndOffset - this._endOffset));
        return text;
    }
    forEach(callback) {
        for(let tokenIndex = 0; tokenIndex < this.getCount(); tokenIndex++)callback(tokenIndex);
    }
}
function getStandardTokenTypeAtPosition(model, position) {
    const lineNumber = position.lineNumber;
    if (!model.tokenization.isCheapToTokenize(lineNumber)) return undefined;
    model.tokenization.forceTokenization(lineNumber);
    const lineTokens = model.tokenization.getLineTokens(lineNumber);
    const tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
    const tokenType = lineTokens.getStandardTokenType(tokenIndex);
    return tokenType;
}

},{"../encodedTokenAttributes.js":"eH8EQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ekzGB":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NullState", ()=>NullState);
parcelHelpers.export(exports, "nullTokenize", ()=>nullTokenize);
parcelHelpers.export(exports, "nullTokenizeEncoded", ()=>nullTokenizeEncoded);
var _languagesJs = require("../languages.js");
const NullState = new class {
    clone() {
        return this;
    }
    equals(other) {
        return this === other;
    }
};
function nullTokenize(languageId, state) {
    return new (0, _languagesJs.TokenizationResult)([
        new (0, _languagesJs.Token)(0, "", languageId)
    ], state);
}
function nullTokenizeEncoded(languageId, state) {
    const tokens = new Uint32Array(2);
    tokens[0] = 0;
    tokens[1] = (languageId << 0 /* MetadataConsts.LANGUAGEID_OFFSET */  | 33587200) >>> 0;
    return new (0, _languagesJs.EncodedTokenizationResult)(tokens, state === null ? NullState : state);
}

},{"../languages.js":"g5n96","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Svqy":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IAccessibilityService", ()=>IAccessibilityService);
parcelHelpers.export(exports, "CONTEXT_ACCESSIBILITY_MODE_ENABLED", ()=>CONTEXT_ACCESSIBILITY_MODE_ENABLED);
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IAccessibilityService = (0, _instantiationJs.createDecorator)("accessibilityService");
const CONTEXT_ACCESSIBILITY_MODE_ENABLED = new (0, _contextkeyJs.RawContextKey)("accessibilityModeEnabled", false);

},{"../../contextkey/common/contextkey.js":"gXuBD","../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"asrsh":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setARIAContainer", ()=>setARIAContainer);
/**
 * Given the provided message, will make sure that it is read as alert to screen readers.
 */ parcelHelpers.export(exports, "alert", ()=>alert);
/**
 * Given the provided message, will make sure that it is read as status to screen readers.
 */ parcelHelpers.export(exports, "status", ()=>status);
var _domJs = require("../../dom.js");
var _ariaCss = require("./aria.css");
// Use a max length since we are inserting the whole msg in the DOM and that can cause browsers to freeze for long messages #94233
const MAX_MESSAGE_LENGTH = 20000;
let ariaContainer;
let alertContainer;
let alertContainer2;
let statusContainer;
let statusContainer2;
function setARIAContainer(parent) {
    ariaContainer = document.createElement("div");
    ariaContainer.className = "monaco-aria-container";
    const createAlertContainer = ()=>{
        const element = document.createElement("div");
        element.className = "monaco-alert";
        element.setAttribute("role", "alert");
        element.setAttribute("aria-atomic", "true");
        ariaContainer.appendChild(element);
        return element;
    };
    alertContainer = createAlertContainer();
    alertContainer2 = createAlertContainer();
    const createStatusContainer = ()=>{
        const element = document.createElement("div");
        element.className = "monaco-status";
        element.setAttribute("aria-live", "polite");
        element.setAttribute("aria-atomic", "true");
        ariaContainer.appendChild(element);
        return element;
    };
    statusContainer = createStatusContainer();
    statusContainer2 = createStatusContainer();
    parent.appendChild(ariaContainer);
}
function alert(msg) {
    if (!ariaContainer) return;
    // Use alternate containers such that duplicated messages get read out by screen readers #99466
    if (alertContainer.textContent !== msg) {
        _domJs.clearNode(alertContainer2);
        insertMessage(alertContainer, msg);
    } else {
        _domJs.clearNode(alertContainer);
        insertMessage(alertContainer2, msg);
    }
}
function status(msg) {
    if (!ariaContainer) return;
    if (statusContainer.textContent !== msg) {
        _domJs.clearNode(statusContainer2);
        insertMessage(statusContainer, msg);
    } else {
        _domJs.clearNode(statusContainer);
        insertMessage(statusContainer2, msg);
    }
}
function insertMessage(target, msg) {
    _domJs.clearNode(target);
    if (msg.length > MAX_MESSAGE_LENGTH) msg = msg.substr(0, MAX_MESSAGE_LENGTH);
    target.textContent = msg;
    // See https://www.paciellogroup.com/blog/2012/06/html5-accessibility-chops-aria-rolealert-browser-support/
    target.style.visibility = "hidden";
    target.style.visibility = "visible";
}

},{"../../dom.js":"bnqsM","./aria.css":"NmpuO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"NmpuO":[function() {},{}],"3MZFS":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextViewHandler", ()=>ContextViewHandler);
parcelHelpers.export(exports, "ContextViewService", ()=>ContextViewService);
var _contextviewJs = require("../../../base/browser/ui/contextview/contextview.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _layoutServiceJs = require("../../layout/browser/layoutService.js");
var _domJs = require("../../../base/browser/dom.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let ContextViewHandler = class ContextViewHandler extends (0, _lifecycleJs.Disposable) {
    constructor(layoutService){
        super();
        this.layoutService = layoutService;
        this.contextView = this._register(new (0, _contextviewJs.ContextView)(this.layoutService.mainContainer, 1 /* ContextViewDOMPosition.ABSOLUTE */ ));
        this.layout();
        this._register(layoutService.onDidLayoutContainer(()=>this.layout()));
    }
    // ContextView
    showContextView(delegate, container, shadowRoot) {
        let domPosition;
        if (container) {
            if (container === this.layoutService.getContainer((0, _domJs.getWindow)(container))) domPosition = 1 /* ContextViewDOMPosition.ABSOLUTE */ ;
            else if (shadowRoot) domPosition = 3 /* ContextViewDOMPosition.FIXED_SHADOW */ ;
            else domPosition = 2 /* ContextViewDOMPosition.FIXED */ ;
        } else domPosition = 1 /* ContextViewDOMPosition.ABSOLUTE */ ;
        this.contextView.setContainer(container ?? this.layoutService.activeContainer, domPosition);
        this.contextView.show(delegate);
        const openContextView = {
            close: ()=>{
                if (this.openContextView === openContextView) this.hideContextView();
            }
        };
        this.openContextView = openContextView;
        return openContextView;
    }
    layout() {
        this.contextView.layout();
    }
    hideContextView(data) {
        this.contextView.hide(data);
        this.openContextView = undefined;
    }
};
ContextViewHandler = __decorate([
    __param(0, (0, _layoutServiceJs.ILayoutService))
], ContextViewHandler);
class ContextViewService extends ContextViewHandler {
    getContextViewElement() {
        return this.contextView.getViewElement();
    }
}

},{"../../../base/browser/ui/contextview/contextview.js":"3CURE","../../../base/common/lifecycle.js":"9kg8d","../../layout/browser/layoutService.js":"fPPgf","../../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3CURE":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnchor", ()=>isAnchor);
parcelHelpers.export(exports, "LayoutAnchorMode", ()=>LayoutAnchorMode);
/**
 * Lays out a one dimensional view next to an anchor in a viewport.
 *
 * @returns The view offset within the viewport.
 */ parcelHelpers.export(exports, "layout", ()=>layout);
parcelHelpers.export(exports, "ContextView", ()=>ContextView);
var _canIUseJs = require("../../canIUse.js");
var _domJs = require("../../dom.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _platformJs = require("../../../common/platform.js");
var _rangeJs = require("../../../common/range.js");
var _contextviewCss = require("./contextview.css");
function isAnchor(obj) {
    const anchor = obj;
    return !!anchor && typeof anchor.x === "number" && typeof anchor.y === "number";
}
var LayoutAnchorMode;
(function(LayoutAnchorMode) {
    LayoutAnchorMode[LayoutAnchorMode["AVOID"] = 0] = "AVOID";
    LayoutAnchorMode[LayoutAnchorMode["ALIGN"] = 1] = "ALIGN";
})(LayoutAnchorMode || (LayoutAnchorMode = {}));
function layout(viewportSize, viewSize, anchor) {
    const layoutAfterAnchorBoundary = anchor.mode === LayoutAnchorMode.ALIGN ? anchor.offset : anchor.offset + anchor.size;
    const layoutBeforeAnchorBoundary = anchor.mode === LayoutAnchorMode.ALIGN ? anchor.offset + anchor.size : anchor.offset;
    if (anchor.position === 0 /* LayoutAnchorPosition.Before */ ) {
        if (viewSize <= viewportSize - layoutAfterAnchorBoundary) return layoutAfterAnchorBoundary; // happy case, lay it out after the anchor
        if (viewSize <= layoutBeforeAnchorBoundary) return layoutBeforeAnchorBoundary - viewSize; // ok case, lay it out before the anchor
        return Math.max(viewportSize - viewSize, 0); // sad case, lay it over the anchor
    } else {
        if (viewSize <= layoutBeforeAnchorBoundary) return layoutBeforeAnchorBoundary - viewSize; // happy case, lay it out before the anchor
        if (viewSize <= viewportSize - layoutAfterAnchorBoundary) return layoutAfterAnchorBoundary; // ok case, lay it out after the anchor
        return 0; // sad case, lay it over the anchor
    }
}
class ContextView extends (0, _lifecycleJs.Disposable) {
    static{
        this.BUBBLE_UP_EVENTS = [
            "click",
            "keydown",
            "focus",
            "blur"
        ];
    }
    static{
        this.BUBBLE_DOWN_EVENTS = [
            "click"
        ];
    }
    constructor(container, domPosition){
        super();
        this.container = null;
        this.useFixedPosition = false;
        this.useShadowDOM = false;
        this.delegate = null;
        this.toDisposeOnClean = (0, _lifecycleJs.Disposable).None;
        this.toDisposeOnSetContainer = (0, _lifecycleJs.Disposable).None;
        this.shadowRoot = null;
        this.shadowRootHostElement = null;
        this.view = _domJs.$(".context-view");
        _domJs.hide(this.view);
        this.setContainer(container, domPosition);
        this._register((0, _lifecycleJs.toDisposable)(()=>this.setContainer(null, 1 /* ContextViewDOMPosition.ABSOLUTE */ )));
    }
    setContainer(container, domPosition) {
        this.useFixedPosition = domPosition !== 1 /* ContextViewDOMPosition.ABSOLUTE */ ;
        const usedShadowDOM = this.useShadowDOM;
        this.useShadowDOM = domPosition === 3 /* ContextViewDOMPosition.FIXED_SHADOW */ ;
        if (container === this.container && usedShadowDOM === this.useShadowDOM) return; // container is the same and no shadow DOM usage has changed
        if (this.container) {
            this.toDisposeOnSetContainer.dispose();
            this.view.remove();
            if (this.shadowRoot) {
                this.shadowRoot = null;
                this.shadowRootHostElement?.remove();
                this.shadowRootHostElement = null;
            }
            this.container = null;
        }
        if (container) {
            this.container = container;
            if (this.useShadowDOM) {
                this.shadowRootHostElement = _domJs.$(".shadow-root-host");
                this.container.appendChild(this.shadowRootHostElement);
                this.shadowRoot = this.shadowRootHostElement.attachShadow({
                    mode: "open"
                });
                const style = document.createElement("style");
                style.textContent = SHADOW_ROOT_CSS;
                this.shadowRoot.appendChild(style);
                this.shadowRoot.appendChild(this.view);
                this.shadowRoot.appendChild(_domJs.$("slot"));
            } else this.container.appendChild(this.view);
            const toDisposeOnSetContainer = new (0, _lifecycleJs.DisposableStore)();
            ContextView.BUBBLE_UP_EVENTS.forEach((event)=>{
                toDisposeOnSetContainer.add(_domJs.addStandardDisposableListener(this.container, event, (e)=>{
                    this.onDOMEvent(e, false);
                }));
            });
            ContextView.BUBBLE_DOWN_EVENTS.forEach((event)=>{
                toDisposeOnSetContainer.add(_domJs.addStandardDisposableListener(this.container, event, (e)=>{
                    this.onDOMEvent(e, true);
                }, true));
            });
            this.toDisposeOnSetContainer = toDisposeOnSetContainer;
        }
    }
    show(delegate) {
        if (this.isVisible()) this.hide();
        // Show static box
        _domJs.clearNode(this.view);
        this.view.className = "context-view monaco-component";
        this.view.style.top = "0px";
        this.view.style.left = "0px";
        this.view.style.zIndex = `${2575 + (delegate.layer ?? 0)}`;
        this.view.style.position = this.useFixedPosition ? "fixed" : "absolute";
        _domJs.show(this.view);
        // Render content
        this.toDisposeOnClean = delegate.render(this.view) || (0, _lifecycleJs.Disposable).None;
        // Set active delegate
        this.delegate = delegate;
        // Layout
        this.doLayout();
        // Focus
        this.delegate.focus?.();
    }
    getViewElement() {
        return this.view;
    }
    layout() {
        if (!this.isVisible()) return;
        if (this.delegate.canRelayout === false && !(_platformJs.isIOS && (0, _canIUseJs.BrowserFeatures).pointerEvents)) {
            this.hide();
            return;
        }
        this.delegate?.layout?.();
        this.doLayout();
    }
    doLayout() {
        // Check that we still have a delegate - this.delegate.layout may have hidden
        if (!this.isVisible()) return;
        // Get anchor
        const anchor = this.delegate.getAnchor();
        // Compute around
        let around;
        // Get the element's position and size (to anchor the view)
        if (_domJs.isHTMLElement(anchor)) {
            const elementPosition = _domJs.getDomNodePagePosition(anchor);
            // In areas where zoom is applied to the element or its ancestors, we need to adjust the size of the element
            // e.g. The title bar has counter zoom behavior meaning it applies the inverse of zoom level.
            // Window Zoom Level: 1.5, Title Bar Zoom: 1/1.5, Size Multiplier: 1.5
            const zoom = _domJs.getDomNodeZoomLevel(anchor);
            around = {
                top: elementPosition.top * zoom,
                left: elementPosition.left * zoom,
                width: elementPosition.width * zoom,
                height: elementPosition.height * zoom
            };
        } else if (isAnchor(anchor)) around = {
            top: anchor.y,
            left: anchor.x,
            width: anchor.width || 1,
            height: anchor.height || 2
        };
        else around = {
            top: anchor.posy,
            left: anchor.posx,
            // We are about to position the context view where the mouse
            // cursor is. To prevent the view being exactly under the mouse
            // when showing and thus potentially triggering an action within,
            // we treat the mouse location like a small sized block element.
            width: 2,
            height: 2
        };
        const viewSizeWidth = _domJs.getTotalWidth(this.view);
        const viewSizeHeight = _domJs.getTotalHeight(this.view);
        const anchorPosition = this.delegate.anchorPosition || 0 /* AnchorPosition.BELOW */ ;
        const anchorAlignment = this.delegate.anchorAlignment || 0 /* AnchorAlignment.LEFT */ ;
        const anchorAxisAlignment = this.delegate.anchorAxisAlignment || 0 /* AnchorAxisAlignment.VERTICAL */ ;
        let top;
        let left;
        const activeWindow = _domJs.getActiveWindow();
        if (anchorAxisAlignment === 0 /* AnchorAxisAlignment.VERTICAL */ ) {
            const verticalAnchor = {
                offset: around.top - activeWindow.pageYOffset,
                size: around.height,
                position: anchorPosition === 0 /* AnchorPosition.BELOW */  ? 0 /* LayoutAnchorPosition.Before */  : 1 /* LayoutAnchorPosition.After */ 
            };
            const horizontalAnchor = {
                offset: around.left,
                size: around.width,
                position: anchorAlignment === 0 /* AnchorAlignment.LEFT */  ? 0 /* LayoutAnchorPosition.Before */  : 1 /* LayoutAnchorPosition.After */ ,
                mode: LayoutAnchorMode.ALIGN
            };
            top = layout(activeWindow.innerHeight, viewSizeHeight, verticalAnchor) + activeWindow.pageYOffset;
            // if view intersects vertically with anchor,  we must avoid the anchor
            if ((0, _rangeJs.Range).intersects({
                start: top,
                end: top + viewSizeHeight
            }, {
                start: verticalAnchor.offset,
                end: verticalAnchor.offset + verticalAnchor.size
            })) horizontalAnchor.mode = LayoutAnchorMode.AVOID;
            left = layout(activeWindow.innerWidth, viewSizeWidth, horizontalAnchor);
        } else {
            const horizontalAnchor = {
                offset: around.left,
                size: around.width,
                position: anchorAlignment === 0 /* AnchorAlignment.LEFT */  ? 0 /* LayoutAnchorPosition.Before */  : 1 /* LayoutAnchorPosition.After */ 
            };
            const verticalAnchor = {
                offset: around.top,
                size: around.height,
                position: anchorPosition === 0 /* AnchorPosition.BELOW */  ? 0 /* LayoutAnchorPosition.Before */  : 1 /* LayoutAnchorPosition.After */ ,
                mode: LayoutAnchorMode.ALIGN
            };
            left = layout(activeWindow.innerWidth, viewSizeWidth, horizontalAnchor);
            // if view intersects horizontally with anchor, we must avoid the anchor
            if ((0, _rangeJs.Range).intersects({
                start: left,
                end: left + viewSizeWidth
            }, {
                start: horizontalAnchor.offset,
                end: horizontalAnchor.offset + horizontalAnchor.size
            })) verticalAnchor.mode = LayoutAnchorMode.AVOID;
            top = layout(activeWindow.innerHeight, viewSizeHeight, verticalAnchor) + activeWindow.pageYOffset;
        }
        this.view.classList.remove("top", "bottom", "left", "right");
        this.view.classList.add(anchorPosition === 0 /* AnchorPosition.BELOW */  ? "bottom" : "top");
        this.view.classList.add(anchorAlignment === 0 /* AnchorAlignment.LEFT */  ? "left" : "right");
        this.view.classList.toggle("fixed", this.useFixedPosition);
        const containerPosition = _domJs.getDomNodePagePosition(this.container);
        this.view.style.top = `${top - (this.useFixedPosition ? _domJs.getDomNodePagePosition(this.view).top : containerPosition.top)}px`;
        this.view.style.left = `${left - (this.useFixedPosition ? _domJs.getDomNodePagePosition(this.view).left : containerPosition.left)}px`;
        this.view.style.width = "initial";
    }
    hide(data) {
        const delegate = this.delegate;
        this.delegate = null;
        if (delegate?.onHide) delegate.onHide(data);
        this.toDisposeOnClean.dispose();
        _domJs.hide(this.view);
    }
    isVisible() {
        return !!this.delegate;
    }
    onDOMEvent(e, onCapture) {
        if (this.delegate) {
            if (this.delegate.onDOMEvent) this.delegate.onDOMEvent(e, _domJs.getWindow(e).document.activeElement);
            else if (onCapture && !_domJs.isAncestor(e.target, this.container)) this.hide();
        }
    }
    dispose() {
        this.hide();
        super.dispose();
    }
}
const SHADOW_ROOT_CSS = /* css */ `
	:host {
		all: initial; /* 1st rule so subsequent properties are reset. */
	}

	.codicon[class*='codicon-'] {
		font: normal normal normal 16px/1 codicon;
		display: inline-block;
		text-decoration: none;
		text-rendering: auto;
		text-align: center;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}

	:host {
		font-family: -apple-system, BlinkMacSystemFont, "Segoe WPC", "Segoe UI", "HelveticaNeue-Light", system-ui, "Ubuntu", "Droid Sans", sans-serif;
	}

	:host-context(.mac) { font-family: -apple-system, BlinkMacSystemFont, sans-serif; }
	:host-context(.mac:lang(zh-Hans)) { font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", sans-serif; }
	:host-context(.mac:lang(zh-Hant)) { font-family: -apple-system, BlinkMacSystemFont, "PingFang TC", sans-serif; }
	:host-context(.mac:lang(ja)) { font-family: -apple-system, BlinkMacSystemFont, "Hiragino Kaku Gothic Pro", sans-serif; }
	:host-context(.mac:lang(ko)) { font-family: -apple-system, BlinkMacSystemFont, "Nanum Gothic", "Apple SD Gothic Neo", "AppleGothic", sans-serif; }

	:host-context(.windows) { font-family: "Segoe WPC", "Segoe UI", sans-serif; }
	:host-context(.windows:lang(zh-Hans)) { font-family: "Segoe WPC", "Segoe UI", "Microsoft YaHei", sans-serif; }
	:host-context(.windows:lang(zh-Hant)) { font-family: "Segoe WPC", "Segoe UI", "Microsoft Jhenghei", sans-serif; }
	:host-context(.windows:lang(ja)) { font-family: "Segoe WPC", "Segoe UI", "Yu Gothic UI", "Meiryo UI", sans-serif; }
	:host-context(.windows:lang(ko)) { font-family: "Segoe WPC", "Segoe UI", "Malgun Gothic", "Dotom", sans-serif; }

	:host-context(.linux) { font-family: system-ui, "Ubuntu", "Droid Sans", sans-serif; }
	:host-context(.linux:lang(zh-Hans)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans SC", "Source Han Sans CN", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(zh-Hant)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans TC", "Source Han Sans TW", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(ja)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans J", "Source Han Sans JP", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(ko)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans K", "Source Han Sans JR", "Source Han Sans", "UnDotum", "FBaekmuk Gulim", sans-serif; }
`;

},{"../../canIUse.js":"h5HmQ","../../dom.js":"bnqsM","../../../common/lifecycle.js":"9kg8d","../../../common/platform.js":"7maJO","../../../common/range.js":"1yq3Z","./contextview.css":"2q0fb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1yq3Z":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Range", ()=>Range);
var Range;
(function(Range) {
    /**
     * Returns the intersection between two ranges as a range itself.
     * Returns `{ start: 0, end: 0 }` if the intersection is empty.
     */ function intersect(one, other) {
        if (one.start >= other.end || other.start >= one.end) return {
            start: 0,
            end: 0
        };
        const start = Math.max(one.start, other.start);
        const end = Math.min(one.end, other.end);
        if (end - start <= 0) return {
            start: 0,
            end: 0
        };
        return {
            start,
            end
        };
    }
    Range.intersect = intersect;
    function isEmpty(range) {
        return range.end - range.start <= 0;
    }
    Range.isEmpty = isEmpty;
    function intersects(one, other) {
        return !isEmpty(intersect(one, other));
    }
    Range.intersects = intersects;
    function relativeComplement(one, other) {
        const result = [];
        const first = {
            start: one.start,
            end: Math.min(other.start, one.end)
        };
        const second = {
            start: Math.max(other.end, one.start),
            end: one.end
        };
        if (!isEmpty(first)) result.push(first);
        if (!isEmpty(second)) result.push(second);
        return result;
    }
    Range.relativeComplement = relativeComplement;
})(Range || (Range = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2q0fb":[function() {},{}],"dUjQm":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManagedHoverWidget", ()=>ManagedHoverWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _htmlContentJs = require("../../../../base/common/htmlContent.js");
var _typesJs = require("../../../../base/common/types.js");
var _nlsJs = require("../../../../nls.js");
class ManagedHoverWidget {
    constructor(hoverDelegate, target, fadeInAnimation){
        this.hoverDelegate = hoverDelegate;
        this.target = target;
        this.fadeInAnimation = fadeInAnimation;
    }
    async update(content, focus, options) {
        if (this._cancellationTokenSource) {
            // there's an computation ongoing, cancel it
            this._cancellationTokenSource.dispose(true);
            this._cancellationTokenSource = undefined;
        }
        if (this.isDisposed) return;
        let resolvedContent;
        if (content === undefined || (0, _typesJs.isString)(content) || (0, _domJs.isHTMLElement)(content)) resolvedContent = content;
        else if (!(0, _typesJs.isFunction)(content.markdown)) resolvedContent = content.markdown ?? content.markdownNotSupportedFallback;
        else {
            // compute the content, potentially long-running
            // show 'Loading' if no hover is up yet
            if (!this._hoverWidget) this.show((0, _nlsJs.localize)("iconLabel.loading", "Loading..."), focus, options);
            // compute the content
            this._cancellationTokenSource = new (0, _cancellationJs.CancellationTokenSource)();
            const token = this._cancellationTokenSource.token;
            resolvedContent = await content.markdown(token);
            if (resolvedContent === undefined) resolvedContent = content.markdownNotSupportedFallback;
            if (this.isDisposed || token.isCancellationRequested) // either the widget has been closed in the meantime
            // or there has been a new call to `update`
            return;
        }
        this.show(resolvedContent, focus, options);
    }
    show(content, focus, options) {
        const oldHoverWidget = this._hoverWidget;
        if (this.hasContent(content)) {
            const hoverOptions = {
                content,
                target: this.target,
                actions: options?.actions,
                linkHandler: options?.linkHandler,
                trapFocus: options?.trapFocus,
                appearance: {
                    showPointer: this.hoverDelegate.placement === "element",
                    skipFadeInAnimation: !this.fadeInAnimation || !!oldHoverWidget,
                    showHoverHint: options?.appearance?.showHoverHint
                },
                position: {
                    hoverPosition: 2 /* HoverPosition.BELOW */ 
                }
            };
            this._hoverWidget = this.hoverDelegate.showHover(hoverOptions, focus);
        }
        oldHoverWidget?.dispose();
    }
    hasContent(content) {
        if (!content) return false;
        if ((0, _htmlContentJs.isMarkdownString)(content)) return !!content.value;
        return true;
    }
    get isDisposed() {
        return this._hoverWidget?.isDisposed;
    }
    dispose() {
        this._hoverWidget?.dispose();
        this._cancellationTokenSource?.dispose(true);
        this._cancellationTokenSource = undefined;
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/htmlContent.js":"3Hxzm","../../../../base/common/types.js":"fb5yx","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fLMRG":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IBulkEditService", ()=>IBulkEditService);
parcelHelpers.export(exports, "ResourceEdit", ()=>ResourceEdit);
parcelHelpers.export(exports, "ResourceTextEdit", ()=>ResourceTextEdit);
parcelHelpers.export(exports, "ResourceFileEdit", ()=>ResourceFileEdit);
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
var _uriJs = require("../../../base/common/uri.js");
var _typesJs = require("../../../base/common/types.js");
const IBulkEditService = (0, _instantiationJs.createDecorator)("IWorkspaceEditService");
class ResourceEdit {
    constructor(metadata){
        this.metadata = metadata;
    }
    static convert(edit) {
        return edit.edits.map((edit)=>{
            if (ResourceTextEdit.is(edit)) return ResourceTextEdit.lift(edit);
            if (ResourceFileEdit.is(edit)) return ResourceFileEdit.lift(edit);
            throw new Error("Unsupported edit");
        });
    }
}
class ResourceTextEdit extends ResourceEdit {
    static is(candidate) {
        if (candidate instanceof ResourceTextEdit) return true;
        return (0, _typesJs.isObject)(candidate) && (0, _uriJs.URI).isUri(candidate.resource) && (0, _typesJs.isObject)(candidate.textEdit);
    }
    static lift(edit) {
        if (edit instanceof ResourceTextEdit) return edit;
        else return new ResourceTextEdit(edit.resource, edit.textEdit, edit.versionId, edit.metadata);
    }
    constructor(resource, textEdit, versionId, metadata){
        super(metadata);
        this.resource = resource;
        this.textEdit = textEdit;
        this.versionId = versionId;
    }
}
class ResourceFileEdit extends ResourceEdit {
    static is(candidate) {
        if (candidate instanceof ResourceFileEdit) return true;
        else return (0, _typesJs.isObject)(candidate) && (Boolean(candidate.newResource) || Boolean(candidate.oldResource));
    }
    static lift(edit) {
        if (edit instanceof ResourceFileEdit) return edit;
        else return new ResourceFileEdit(edit.oldResource, edit.newResource, edit.options, edit.metadata);
    }
    constructor(oldResource, newResource, options = {}, metadata){
        super(metadata);
        this.oldResource = oldResource;
        this.newResource = newResource;
        this.options = options;
    }
}

},{"../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../base/common/uri.js":"7qGS3","../../../base/common/types.js":"fb5yx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"18Zc9":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "editorConfigurationBaseNode", ()=>editorConfigurationBaseNode);
parcelHelpers.export(exports, "isEditorConfigurationKey", ()=>isEditorConfigurationKey);
parcelHelpers.export(exports, "isDiffEditorConfigurationKey", ()=>isDiffEditorConfigurationKey);
var _diffEditorJs = require("./diffEditor.js");
var _editorOptionsJs = require("./editorOptions.js");
var _textModelDefaultsJs = require("../core/textModelDefaults.js");
var _nlsJs = require("../../../nls.js");
var _configurationRegistryJs = require("../../../platform/configuration/common/configurationRegistry.js");
var _platformJs = require("../../../platform/registry/common/platform.js");
const editorConfigurationBaseNode = Object.freeze({
    id: "editor",
    order: 5,
    type: "object",
    title: _nlsJs.localize("editorConfigurationTitle", "Editor"),
    scope: 5 /* ConfigurationScope.LANGUAGE_OVERRIDABLE */ 
});
const editorConfiguration = {
    ...editorConfigurationBaseNode,
    properties: {
        "editor.tabSize": {
            type: "number",
            default: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).tabSize,
            minimum: 1,
            markdownDescription: _nlsJs.localize("tabSize", "The number of spaces a tab is equal to. This setting is overridden based on the file contents when {0} is on.", "`#editor.detectIndentation#`")
        },
        "editor.indentSize": {
            "anyOf": [
                {
                    type: "string",
                    enum: [
                        "tabSize"
                    ]
                },
                {
                    type: "number",
                    minimum: 1
                }
            ],
            default: "tabSize",
            markdownDescription: _nlsJs.localize("indentSize", 'The number of spaces used for indentation or `"tabSize"` to use the value from `#editor.tabSize#`. This setting is overridden based on the file contents when `#editor.detectIndentation#` is on.')
        },
        "editor.insertSpaces": {
            type: "boolean",
            default: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).insertSpaces,
            markdownDescription: _nlsJs.localize("insertSpaces", "Insert spaces when pressing `Tab`. This setting is overridden based on the file contents when {0} is on.", "`#editor.detectIndentation#`")
        },
        "editor.detectIndentation": {
            type: "boolean",
            default: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).detectIndentation,
            markdownDescription: _nlsJs.localize("detectIndentation", "Controls whether {0} and {1} will be automatically detected when a file is opened based on the file contents.", "`#editor.tabSize#`", "`#editor.insertSpaces#`")
        },
        "editor.trimAutoWhitespace": {
            type: "boolean",
            default: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).trimAutoWhitespace,
            description: _nlsJs.localize("trimAutoWhitespace", "Remove trailing auto inserted whitespace.")
        },
        "editor.largeFileOptimizations": {
            type: "boolean",
            default: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).largeFileOptimizations,
            description: _nlsJs.localize("largeFileOptimizations", "Special handling for large files to disable certain memory intensive features.")
        },
        "editor.wordBasedSuggestions": {
            enum: [
                "off",
                "currentDocument",
                "matchingDocuments",
                "allDocuments"
            ],
            default: "matchingDocuments",
            enumDescriptions: [
                _nlsJs.localize("wordBasedSuggestions.off", "Turn off Word Based Suggestions."),
                _nlsJs.localize("wordBasedSuggestions.currentDocument", "Only suggest words from the active document."),
                _nlsJs.localize("wordBasedSuggestions.matchingDocuments", "Suggest words from all open documents of the same language."),
                _nlsJs.localize("wordBasedSuggestions.allDocuments", "Suggest words from all open documents.")
            ],
            description: _nlsJs.localize("wordBasedSuggestions", "Controls whether completions should be computed based on words in the document and from which documents they are computed.")
        },
        "editor.semanticHighlighting.enabled": {
            enum: [
                true,
                false,
                "configuredByTheme"
            ],
            enumDescriptions: [
                _nlsJs.localize("semanticHighlighting.true", "Semantic highlighting enabled for all color themes."),
                _nlsJs.localize("semanticHighlighting.false", "Semantic highlighting disabled for all color themes."),
                _nlsJs.localize("semanticHighlighting.configuredByTheme", "Semantic highlighting is configured by the current color theme's `semanticHighlighting` setting.")
            ],
            default: "configuredByTheme",
            description: _nlsJs.localize("semanticHighlighting.enabled", "Controls whether the semanticHighlighting is shown for the languages that support it.")
        },
        "editor.stablePeek": {
            type: "boolean",
            default: false,
            markdownDescription: _nlsJs.localize("stablePeek", "Keep peek editors open even when double-clicking their content or when hitting `Escape`.")
        },
        "editor.maxTokenizationLineLength": {
            type: "integer",
            default: 20000,
            description: _nlsJs.localize("maxTokenizationLineLength", "Lines above this length will not be tokenized for performance reasons")
        },
        "editor.experimental.asyncTokenization": {
            type: "boolean",
            default: true,
            description: _nlsJs.localize("editor.experimental.asyncTokenization", "Controls whether the tokenization should happen asynchronously on a web worker."),
            tags: [
                "experimental"
            ]
        },
        "editor.experimental.asyncTokenizationLogging": {
            type: "boolean",
            default: false,
            description: _nlsJs.localize("editor.experimental.asyncTokenizationLogging", "Controls whether async tokenization should be logged. For debugging only.")
        },
        "editor.experimental.asyncTokenizationVerification": {
            type: "boolean",
            default: false,
            description: _nlsJs.localize("editor.experimental.asyncTokenizationVerification", "Controls whether async tokenization should be verified against legacy background tokenization. Might slow down tokenization. For debugging only."),
            tags: [
                "experimental"
            ]
        },
        "editor.experimental.treeSitterTelemetry": {
            type: "boolean",
            default: false,
            markdownDescription: _nlsJs.localize("editor.experimental.treeSitterTelemetry", "Controls whether tree sitter parsing should be turned on and telemetry collected. Setting `editor.experimental.preferTreeSitter` for specific languages will take precedence."),
            tags: [
                "experimental"
            ]
        },
        "editor.language.brackets": {
            type: [
                "array",
                "null"
            ],
            default: null,
            description: _nlsJs.localize("schema.brackets", "Defines the bracket symbols that increase or decrease the indentation."),
            items: {
                type: "array",
                items: [
                    {
                        type: "string",
                        description: _nlsJs.localize("schema.openBracket", "The opening bracket character or string sequence.")
                    },
                    {
                        type: "string",
                        description: _nlsJs.localize("schema.closeBracket", "The closing bracket character or string sequence.")
                    }
                ]
            }
        },
        "editor.language.colorizedBracketPairs": {
            type: [
                "array",
                "null"
            ],
            default: null,
            description: _nlsJs.localize("schema.colorizedBracketPairs", "Defines the bracket pairs that are colorized by their nesting level if bracket pair colorization is enabled."),
            items: {
                type: "array",
                items: [
                    {
                        type: "string",
                        description: _nlsJs.localize("schema.openBracket", "The opening bracket character or string sequence.")
                    },
                    {
                        type: "string",
                        description: _nlsJs.localize("schema.closeBracket", "The closing bracket character or string sequence.")
                    }
                ]
            }
        },
        "diffEditor.maxComputationTime": {
            type: "number",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).maxComputationTime,
            description: _nlsJs.localize("maxComputationTime", "Timeout in milliseconds after which diff computation is cancelled. Use 0 for no timeout.")
        },
        "diffEditor.maxFileSize": {
            type: "number",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).maxFileSize,
            description: _nlsJs.localize("maxFileSize", "Maximum file size in MB for which to compute diffs. Use 0 for no limit.")
        },
        "diffEditor.renderSideBySide": {
            type: "boolean",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).renderSideBySide,
            description: _nlsJs.localize("sideBySide", "Controls whether the diff editor shows the diff side by side or inline.")
        },
        "diffEditor.renderSideBySideInlineBreakpoint": {
            type: "number",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).renderSideBySideInlineBreakpoint,
            description: _nlsJs.localize("renderSideBySideInlineBreakpoint", "If the diff editor width is smaller than this value, the inline view is used.")
        },
        "diffEditor.useInlineViewWhenSpaceIsLimited": {
            type: "boolean",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).useInlineViewWhenSpaceIsLimited,
            description: _nlsJs.localize("useInlineViewWhenSpaceIsLimited", "If enabled and the editor width is too small, the inline view is used.")
        },
        "diffEditor.renderMarginRevertIcon": {
            type: "boolean",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).renderMarginRevertIcon,
            description: _nlsJs.localize("renderMarginRevertIcon", "When enabled, the diff editor shows arrows in its glyph margin to revert changes.")
        },
        "diffEditor.renderGutterMenu": {
            type: "boolean",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).renderGutterMenu,
            description: _nlsJs.localize("renderGutterMenu", "When enabled, the diff editor shows a special gutter for revert and stage actions.")
        },
        "diffEditor.ignoreTrimWhitespace": {
            type: "boolean",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).ignoreTrimWhitespace,
            description: _nlsJs.localize("ignoreTrimWhitespace", "When enabled, the diff editor ignores changes in leading or trailing whitespace.")
        },
        "diffEditor.renderIndicators": {
            type: "boolean",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).renderIndicators,
            description: _nlsJs.localize("renderIndicators", "Controls whether the diff editor shows +/- indicators for added/removed changes.")
        },
        "diffEditor.codeLens": {
            type: "boolean",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).diffCodeLens,
            description: _nlsJs.localize("codeLens", "Controls whether the editor shows CodeLens.")
        },
        "diffEditor.wordWrap": {
            type: "string",
            enum: [
                "off",
                "on",
                "inherit"
            ],
            default: (0, _diffEditorJs.diffEditorDefaultOptions).diffWordWrap,
            markdownEnumDescriptions: [
                _nlsJs.localize("wordWrap.off", "Lines will never wrap."),
                _nlsJs.localize("wordWrap.on", "Lines will wrap at the viewport width."),
                _nlsJs.localize("wordWrap.inherit", "Lines will wrap according to the {0} setting.", "`#editor.wordWrap#`")
            ]
        },
        "diffEditor.diffAlgorithm": {
            type: "string",
            enum: [
                "legacy",
                "advanced"
            ],
            default: (0, _diffEditorJs.diffEditorDefaultOptions).diffAlgorithm,
            markdownEnumDescriptions: [
                _nlsJs.localize("diffAlgorithm.legacy", "Uses the legacy diffing algorithm."),
                _nlsJs.localize("diffAlgorithm.advanced", "Uses the advanced diffing algorithm.")
            ],
            tags: [
                "experimental"
            ]
        },
        "diffEditor.hideUnchangedRegions.enabled": {
            type: "boolean",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).hideUnchangedRegions.enabled,
            markdownDescription: _nlsJs.localize("hideUnchangedRegions.enabled", "Controls whether the diff editor shows unchanged regions.")
        },
        "diffEditor.hideUnchangedRegions.revealLineCount": {
            type: "integer",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).hideUnchangedRegions.revealLineCount,
            markdownDescription: _nlsJs.localize("hideUnchangedRegions.revealLineCount", "Controls how many lines are used for unchanged regions."),
            minimum: 1
        },
        "diffEditor.hideUnchangedRegions.minimumLineCount": {
            type: "integer",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).hideUnchangedRegions.minimumLineCount,
            markdownDescription: _nlsJs.localize("hideUnchangedRegions.minimumLineCount", "Controls how many lines are used as a minimum for unchanged regions."),
            minimum: 1
        },
        "diffEditor.hideUnchangedRegions.contextLineCount": {
            type: "integer",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).hideUnchangedRegions.contextLineCount,
            markdownDescription: _nlsJs.localize("hideUnchangedRegions.contextLineCount", "Controls how many lines are used as context when comparing unchanged regions."),
            minimum: 1
        },
        "diffEditor.experimental.showMoves": {
            type: "boolean",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).experimental.showMoves,
            markdownDescription: _nlsJs.localize("showMoves", "Controls whether the diff editor should show detected code moves.")
        },
        "diffEditor.experimental.showEmptyDecorations": {
            type: "boolean",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).experimental.showEmptyDecorations,
            description: _nlsJs.localize("showEmptyDecorations", "Controls whether the diff editor shows empty decorations to see where characters got inserted or deleted.")
        },
        "diffEditor.experimental.useTrueInlineView": {
            type: "boolean",
            default: (0, _diffEditorJs.diffEditorDefaultOptions).experimental.useTrueInlineView,
            description: _nlsJs.localize("useTrueInlineView", "If enabled and the editor uses the inline view, word changes are rendered inline.")
        }
    }
};
function isConfigurationPropertySchema(x) {
    return typeof x.type !== "undefined" || typeof x.anyOf !== "undefined";
}
// Add properties from the Editor Option Registry
for (const editorOption of (0, _editorOptionsJs.editorOptionsRegistry)){
    const schema = editorOption.schema;
    if (typeof schema !== "undefined") {
        if (isConfigurationPropertySchema(schema)) // This is a single schema contribution
        editorConfiguration.properties[`editor.${editorOption.name}`] = schema;
        else {
            for(const key in schema)if (Object.hasOwnProperty.call(schema, key)) editorConfiguration.properties[key] = schema[key];
        }
    }
}
let cachedEditorConfigurationKeys = null;
function getEditorConfigurationKeys() {
    if (cachedEditorConfigurationKeys === null) {
        cachedEditorConfigurationKeys = Object.create(null);
        Object.keys(editorConfiguration.properties).forEach((prop)=>{
            cachedEditorConfigurationKeys[prop] = true;
        });
    }
    return cachedEditorConfigurationKeys;
}
function isEditorConfigurationKey(key) {
    const editorConfigurationKeys = getEditorConfigurationKeys();
    return editorConfigurationKeys[`editor.${key}`] || false;
}
function isDiffEditorConfigurationKey(key) {
    const editorConfigurationKeys = getEditorConfigurationKeys();
    return editorConfigurationKeys[`diffEditor.${key}`] || false;
}
const configurationRegistry = (0, _platformJs.Registry).as((0, _configurationRegistryJs.Extensions).Configuration);
configurationRegistry.registerConfiguration(editorConfiguration);

},{"./diffEditor.js":"FPe1s","./editorOptions.js":"3Xi00","../core/textModelDefaults.js":"esbOV","../../../nls.js":"l617d","../../../platform/configuration/common/configurationRegistry.js":"6y4yB","../../../platform/registry/common/platform.js":"dzx11","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"FPe1s":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "diffEditorDefaultOptions", ()=>diffEditorDefaultOptions);
const diffEditorDefaultOptions = {
    enableSplitViewResizing: true,
    splitViewDefaultRatio: 0.5,
    renderSideBySide: true,
    renderMarginRevertIcon: true,
    renderGutterMenu: true,
    maxComputationTime: 5000,
    maxFileSize: 50,
    ignoreTrimWhitespace: true,
    renderIndicators: true,
    originalEditable: false,
    diffCodeLens: false,
    renderOverviewRuler: true,
    diffWordWrap: "inherit",
    diffAlgorithm: "advanced",
    accessibilityVerbose: false,
    experimental: {
        showMoves: false,
        showEmptyDecorations: true,
        useTrueInlineView: false
    },
    hideUnchangedRegions: {
        enabled: false,
        contextLineCount: 3,
        minimumLineCount: 3,
        revealLineCount: 20
    },
    isInEmbeddedEditor: false,
    onlyShowAccessibleDiffViewer: false,
    renderSideBySideInlineBreakpoint: 900,
    useInlineViewWhenSpaceIsLimited: true,
    compactMode: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6r2FZ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditOperation", ()=>EditOperation);
var _rangeJs = require("./range.js");
class EditOperation {
    static insert(position, text) {
        return {
            range: new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column),
            text: text,
            forceMoveMarkers: true
        };
    }
    static delete(range) {
        return {
            range: range,
            text: null
        };
    }
    static replace(range, text) {
        return {
            range: range,
            text: text
        };
    }
    static replaceMove(range, text) {
        return {
            range: range,
            text: text,
            forceMoveMarkers: true
        };
    }
}

},{"./range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1tQGv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfigurationModel", ()=>ConfigurationModel);
parcelHelpers.export(exports, "ConfigurationModelParser", ()=>ConfigurationModelParser);
parcelHelpers.export(exports, "Configuration", ()=>Configuration);
parcelHelpers.export(exports, "ConfigurationChangeEvent", ()=>ConfigurationChangeEvent);
var _arraysJs = require("../../../base/common/arrays.js");
var _mapJs = require("../../../base/common/map.js");
var _objectsJs = require("../../../base/common/objects.js");
var _typesJs = require("../../../base/common/types.js");
var _uriJs = require("../../../base/common/uri.js");
var _configurationJs = require("./configuration.js");
var _configurationRegistryJs = require("./configurationRegistry.js");
var _platformJs = require("../../registry/common/platform.js");
function freeze(data) {
    return Object.isFrozen(data) ? data : _objectsJs.deepFreeze(data);
}
class ConfigurationModel {
    static createEmptyModel(logService) {
        return new ConfigurationModel({}, [], [], undefined, logService);
    }
    constructor(_contents, _keys, _overrides, raw, logService){
        this._contents = _contents;
        this._keys = _keys;
        this._overrides = _overrides;
        this.raw = raw;
        this.logService = logService;
        this.overrideConfigurations = new Map();
    }
    get rawConfiguration() {
        if (!this._rawConfiguration) {
            if (this.raw?.length) {
                const rawConfigurationModels = this.raw.map((raw)=>{
                    if (raw instanceof ConfigurationModel) return raw;
                    const parser = new ConfigurationModelParser("", this.logService);
                    parser.parseRaw(raw);
                    return parser.configurationModel;
                });
                this._rawConfiguration = rawConfigurationModels.reduce((previous, current)=>current === previous ? current : previous.merge(current), rawConfigurationModels[0]);
            } else // raw is same as current
            this._rawConfiguration = this;
        }
        return this._rawConfiguration;
    }
    get contents() {
        return this._contents;
    }
    get overrides() {
        return this._overrides;
    }
    get keys() {
        return this._keys;
    }
    isEmpty() {
        return this._keys.length === 0 && Object.keys(this._contents).length === 0 && this._overrides.length === 0;
    }
    getValue(section) {
        return section ? (0, _configurationJs.getConfigurationValue)(this.contents, section) : this.contents;
    }
    inspect(section, overrideIdentifier) {
        const that = this;
        return {
            get value () {
                return freeze(that.rawConfiguration.getValue(section));
            },
            get override () {
                return overrideIdentifier ? freeze(that.rawConfiguration.getOverrideValue(section, overrideIdentifier)) : undefined;
            },
            get merged () {
                return freeze(overrideIdentifier ? that.rawConfiguration.override(overrideIdentifier).getValue(section) : that.rawConfiguration.getValue(section));
            },
            get overrides () {
                const overrides = [];
                for (const { contents, identifiers, keys } of that.rawConfiguration.overrides){
                    const value = new ConfigurationModel(contents, keys, [], undefined, that.logService).getValue(section);
                    if (value !== undefined) overrides.push({
                        identifiers,
                        value
                    });
                }
                return overrides.length ? freeze(overrides) : undefined;
            }
        };
    }
    getOverrideValue(section, overrideIdentifier) {
        const overrideContents = this.getContentsForOverrideIdentifer(overrideIdentifier);
        return overrideContents ? section ? (0, _configurationJs.getConfigurationValue)(overrideContents, section) : overrideContents : undefined;
    }
    override(identifier) {
        let overrideConfigurationModel = this.overrideConfigurations.get(identifier);
        if (!overrideConfigurationModel) {
            overrideConfigurationModel = this.createOverrideConfigurationModel(identifier);
            this.overrideConfigurations.set(identifier, overrideConfigurationModel);
        }
        return overrideConfigurationModel;
    }
    merge(...others) {
        const contents = _objectsJs.deepClone(this.contents);
        const overrides = _objectsJs.deepClone(this.overrides);
        const keys = [
            ...this.keys
        ];
        const raws = this.raw?.length ? [
            ...this.raw
        ] : [
            this
        ];
        for (const other of others){
            raws.push(...other.raw?.length ? other.raw : [
                other
            ]);
            if (other.isEmpty()) continue;
            this.mergeContents(contents, other.contents);
            for (const otherOverride of other.overrides){
                const [override] = overrides.filter((o)=>_arraysJs.equals(o.identifiers, otherOverride.identifiers));
                if (override) {
                    this.mergeContents(override.contents, otherOverride.contents);
                    override.keys.push(...otherOverride.keys);
                    override.keys = _arraysJs.distinct(override.keys);
                } else overrides.push(_objectsJs.deepClone(otherOverride));
            }
            for (const key of other.keys)if (keys.indexOf(key) === -1) keys.push(key);
        }
        return new ConfigurationModel(contents, keys, overrides, raws.every((raw)=>raw instanceof ConfigurationModel) ? undefined : raws, this.logService);
    }
    createOverrideConfigurationModel(identifier) {
        const overrideContents = this.getContentsForOverrideIdentifer(identifier);
        if (!overrideContents || typeof overrideContents !== "object" || !Object.keys(overrideContents).length) // If there are no valid overrides, return self
        return this;
        const contents = {};
        for (const key of _arraysJs.distinct([
            ...Object.keys(this.contents),
            ...Object.keys(overrideContents)
        ])){
            let contentsForKey = this.contents[key];
            const overrideContentsForKey = overrideContents[key];
            // If there are override contents for the key, clone and merge otherwise use base contents
            if (overrideContentsForKey) {
                // Clone and merge only if base contents and override contents are of type object otherwise just override
                if (typeof contentsForKey === "object" && typeof overrideContentsForKey === "object") {
                    contentsForKey = _objectsJs.deepClone(contentsForKey);
                    this.mergeContents(contentsForKey, overrideContentsForKey);
                } else contentsForKey = overrideContentsForKey;
            }
            contents[key] = contentsForKey;
        }
        return new ConfigurationModel(contents, this.keys, this.overrides, undefined, this.logService);
    }
    mergeContents(source, target) {
        for (const key of Object.keys(target)){
            if (key in source) {
                if (_typesJs.isObject(source[key]) && _typesJs.isObject(target[key])) {
                    this.mergeContents(source[key], target[key]);
                    continue;
                }
            }
            source[key] = _objectsJs.deepClone(target[key]);
        }
    }
    getContentsForOverrideIdentifer(identifier) {
        let contentsForIdentifierOnly = null;
        let contents = null;
        const mergeContents = (contentsToMerge)=>{
            if (contentsToMerge) {
                if (contents) this.mergeContents(contents, contentsToMerge);
                else contents = _objectsJs.deepClone(contentsToMerge);
            }
        };
        for (const override of this.overrides){
            if (override.identifiers.length === 1 && override.identifiers[0] === identifier) contentsForIdentifierOnly = override.contents;
            else if (override.identifiers.includes(identifier)) mergeContents(override.contents);
        }
        // Merge contents of the identifier only at the end to take precedence.
        mergeContents(contentsForIdentifierOnly);
        return contents;
    }
    toJSON() {
        return {
            contents: this.contents,
            overrides: this.overrides,
            keys: this.keys
        };
    }
    setValue(key, value) {
        this.updateValue(key, value, false);
    }
    removeValue(key) {
        const index = this.keys.indexOf(key);
        if (index === -1) return;
        this.keys.splice(index, 1);
        (0, _configurationJs.removeFromValueTree)(this.contents, key);
        if ((0, _configurationRegistryJs.OVERRIDE_PROPERTY_REGEX).test(key)) this.overrides.splice(this.overrides.findIndex((o)=>_arraysJs.equals(o.identifiers, (0, _configurationRegistryJs.overrideIdentifiersFromKey)(key))), 1);
    }
    updateValue(key, value, add) {
        (0, _configurationJs.addToValueTree)(this.contents, key, value, (e)=>this.logService.error(e));
        add = add || this.keys.indexOf(key) === -1;
        if (add) this.keys.push(key);
        if ((0, _configurationRegistryJs.OVERRIDE_PROPERTY_REGEX).test(key)) {
            const identifiers = (0, _configurationRegistryJs.overrideIdentifiersFromKey)(key);
            const override = {
                identifiers,
                keys: Object.keys(this.contents[key]),
                contents: (0, _configurationJs.toValuesTree)(this.contents[key], (message)=>this.logService.error(message))
            };
            const index = this.overrides.findIndex((o)=>_arraysJs.equals(o.identifiers, identifiers));
            if (index !== -1) this.overrides[index] = override;
            else this.overrides.push(override);
        }
    }
}
class ConfigurationModelParser {
    constructor(_name, logService){
        this._name = _name;
        this.logService = logService;
        this._raw = null;
        this._configurationModel = null;
        this._restrictedConfigurations = [];
    }
    get configurationModel() {
        return this._configurationModel || ConfigurationModel.createEmptyModel(this.logService);
    }
    parseRaw(raw, options) {
        this._raw = raw;
        const { contents, keys, overrides, restricted, hasExcludedProperties } = this.doParseRaw(raw, options);
        this._configurationModel = new ConfigurationModel(contents, keys, overrides, hasExcludedProperties ? [
            raw
        ] : undefined /* raw has not changed */ , this.logService);
        this._restrictedConfigurations = restricted || [];
    }
    doParseRaw(raw, options) {
        const configurationProperties = (0, _platformJs.Registry).as((0, _configurationRegistryJs.Extensions).Configuration).getConfigurationProperties();
        const filtered = this.filter(raw, configurationProperties, true, options);
        raw = filtered.raw;
        const contents = (0, _configurationJs.toValuesTree)(raw, (message)=>this.logService.error(`Conflict in settings file ${this._name}: ${message}`));
        const keys = Object.keys(raw);
        const overrides = this.toOverrides(raw, (message)=>this.logService.error(`Conflict in settings file ${this._name}: ${message}`));
        return {
            contents,
            keys,
            overrides,
            restricted: filtered.restricted,
            hasExcludedProperties: filtered.hasExcludedProperties
        };
    }
    filter(properties, configurationProperties, filterOverriddenProperties, options) {
        let hasExcludedProperties = false;
        if (!options?.scopes && !options?.skipRestricted && !options?.exclude?.length) return {
            raw: properties,
            restricted: [],
            hasExcludedProperties
        };
        const raw = {};
        const restricted = [];
        for(const key in properties)if ((0, _configurationRegistryJs.OVERRIDE_PROPERTY_REGEX).test(key) && filterOverriddenProperties) {
            const result = this.filter(properties[key], configurationProperties, false, options);
            raw[key] = result.raw;
            hasExcludedProperties = hasExcludedProperties || result.hasExcludedProperties;
            restricted.push(...result.restricted);
        } else {
            const propertySchema = configurationProperties[key];
            const scope = propertySchema ? typeof propertySchema.scope !== "undefined" ? propertySchema.scope : 3 /* ConfigurationScope.WINDOW */  : undefined;
            if (propertySchema?.restricted) restricted.push(key);
            if (!options.exclude?.includes(key) && (options.include?.includes(key) || (scope === undefined || options.scopes === undefined || options.scopes.includes(scope)) && !(options.skipRestricted && propertySchema?.restricted))) raw[key] = properties[key];
            else hasExcludedProperties = true;
        }
        return {
            raw,
            restricted,
            hasExcludedProperties
        };
    }
    toOverrides(raw, conflictReporter) {
        const overrides = [];
        for (const key of Object.keys(raw))if ((0, _configurationRegistryJs.OVERRIDE_PROPERTY_REGEX).test(key)) {
            const overrideRaw = {};
            for(const keyInOverrideRaw in raw[key])overrideRaw[keyInOverrideRaw] = raw[key][keyInOverrideRaw];
            overrides.push({
                identifiers: (0, _configurationRegistryJs.overrideIdentifiersFromKey)(key),
                keys: Object.keys(overrideRaw),
                contents: (0, _configurationJs.toValuesTree)(overrideRaw, conflictReporter)
            });
        }
        return overrides;
    }
}
class ConfigurationInspectValue {
    constructor(key, overrides, _value, overrideIdentifiers, defaultConfiguration, policyConfiguration, applicationConfiguration, userConfiguration, localUserConfiguration, remoteUserConfiguration, workspaceConfiguration, folderConfigurationModel, memoryConfigurationModel){
        this.key = key;
        this.overrides = overrides;
        this._value = _value;
        this.overrideIdentifiers = overrideIdentifiers;
        this.defaultConfiguration = defaultConfiguration;
        this.policyConfiguration = policyConfiguration;
        this.applicationConfiguration = applicationConfiguration;
        this.userConfiguration = userConfiguration;
        this.localUserConfiguration = localUserConfiguration;
        this.remoteUserConfiguration = remoteUserConfiguration;
        this.workspaceConfiguration = workspaceConfiguration;
        this.folderConfigurationModel = folderConfigurationModel;
        this.memoryConfigurationModel = memoryConfigurationModel;
    }
    toInspectValue(inspectValue) {
        return inspectValue?.value !== undefined || inspectValue?.override !== undefined || inspectValue?.overrides !== undefined ? inspectValue : undefined;
    }
    get userInspectValue() {
        if (!this._userInspectValue) this._userInspectValue = this.userConfiguration.inspect(this.key, this.overrides.overrideIdentifier);
        return this._userInspectValue;
    }
    get user() {
        return this.toInspectValue(this.userInspectValue);
    }
}
class Configuration {
    constructor(_defaultConfiguration, _policyConfiguration, _applicationConfiguration, _localUserConfiguration, _remoteUserConfiguration, _workspaceConfiguration, _folderConfigurations, _memoryConfiguration, _memoryConfigurationByResource, logService){
        this._defaultConfiguration = _defaultConfiguration;
        this._policyConfiguration = _policyConfiguration;
        this._applicationConfiguration = _applicationConfiguration;
        this._localUserConfiguration = _localUserConfiguration;
        this._remoteUserConfiguration = _remoteUserConfiguration;
        this._workspaceConfiguration = _workspaceConfiguration;
        this._folderConfigurations = _folderConfigurations;
        this._memoryConfiguration = _memoryConfiguration;
        this._memoryConfigurationByResource = _memoryConfigurationByResource;
        this.logService = logService;
        this._workspaceConsolidatedConfiguration = null;
        this._foldersConsolidatedConfigurations = new (0, _mapJs.ResourceMap)();
        this._userConfiguration = null;
    }
    getValue(section, overrides, workspace) {
        const consolidateConfigurationModel = this.getConsolidatedConfigurationModel(section, overrides, workspace);
        return consolidateConfigurationModel.getValue(section);
    }
    updateValue(key, value, overrides = {}) {
        let memoryConfiguration;
        if (overrides.resource) {
            memoryConfiguration = this._memoryConfigurationByResource.get(overrides.resource);
            if (!memoryConfiguration) {
                memoryConfiguration = ConfigurationModel.createEmptyModel(this.logService);
                this._memoryConfigurationByResource.set(overrides.resource, memoryConfiguration);
            }
        } else memoryConfiguration = this._memoryConfiguration;
        if (value === undefined) memoryConfiguration.removeValue(key);
        else memoryConfiguration.setValue(key, value);
        if (!overrides.resource) this._workspaceConsolidatedConfiguration = null;
    }
    inspect(key, overrides, workspace) {
        const consolidateConfigurationModel = this.getConsolidatedConfigurationModel(key, overrides, workspace);
        const folderConfigurationModel = this.getFolderConfigurationModelForResource(overrides.resource, workspace);
        const memoryConfigurationModel = overrides.resource ? this._memoryConfigurationByResource.get(overrides.resource) || this._memoryConfiguration : this._memoryConfiguration;
        const overrideIdentifiers = new Set();
        for (const override of consolidateConfigurationModel.overrides){
            for (const overrideIdentifier of override.identifiers)if (consolidateConfigurationModel.getOverrideValue(key, overrideIdentifier) !== undefined) overrideIdentifiers.add(overrideIdentifier);
        }
        return new ConfigurationInspectValue(key, overrides, consolidateConfigurationModel.getValue(key), overrideIdentifiers.size ? [
            ...overrideIdentifiers
        ] : undefined, this._defaultConfiguration, this._policyConfiguration.isEmpty() ? undefined : this._policyConfiguration, this.applicationConfiguration.isEmpty() ? undefined : this.applicationConfiguration, this.userConfiguration, this.localUserConfiguration, this.remoteUserConfiguration, workspace ? this._workspaceConfiguration : undefined, folderConfigurationModel ? folderConfigurationModel : undefined, memoryConfigurationModel);
    }
    get applicationConfiguration() {
        return this._applicationConfiguration;
    }
    get userConfiguration() {
        if (!this._userConfiguration) this._userConfiguration = this._remoteUserConfiguration.isEmpty() ? this._localUserConfiguration : this._localUserConfiguration.merge(this._remoteUserConfiguration);
        return this._userConfiguration;
    }
    get localUserConfiguration() {
        return this._localUserConfiguration;
    }
    get remoteUserConfiguration() {
        return this._remoteUserConfiguration;
    }
    getConsolidatedConfigurationModel(section, overrides, workspace) {
        let configurationModel = this.getConsolidatedConfigurationModelForResource(overrides, workspace);
        if (overrides.overrideIdentifier) configurationModel = configurationModel.override(overrides.overrideIdentifier);
        if (!this._policyConfiguration.isEmpty() && this._policyConfiguration.getValue(section) !== undefined) configurationModel = configurationModel.merge(this._policyConfiguration);
        return configurationModel;
    }
    getConsolidatedConfigurationModelForResource({ resource }, workspace) {
        let consolidateConfiguration = this.getWorkspaceConsolidatedConfiguration();
        if (workspace && resource) {
            const root = workspace.getFolder(resource);
            if (root) consolidateConfiguration = this.getFolderConsolidatedConfiguration(root.uri) || consolidateConfiguration;
            const memoryConfigurationForResource = this._memoryConfigurationByResource.get(resource);
            if (memoryConfigurationForResource) consolidateConfiguration = consolidateConfiguration.merge(memoryConfigurationForResource);
        }
        return consolidateConfiguration;
    }
    getWorkspaceConsolidatedConfiguration() {
        if (!this._workspaceConsolidatedConfiguration) this._workspaceConsolidatedConfiguration = this._defaultConfiguration.merge(this.applicationConfiguration, this.userConfiguration, this._workspaceConfiguration, this._memoryConfiguration);
        return this._workspaceConsolidatedConfiguration;
    }
    getFolderConsolidatedConfiguration(folder) {
        let folderConsolidatedConfiguration = this._foldersConsolidatedConfigurations.get(folder);
        if (!folderConsolidatedConfiguration) {
            const workspaceConsolidateConfiguration = this.getWorkspaceConsolidatedConfiguration();
            const folderConfiguration = this._folderConfigurations.get(folder);
            if (folderConfiguration) {
                folderConsolidatedConfiguration = workspaceConsolidateConfiguration.merge(folderConfiguration);
                this._foldersConsolidatedConfigurations.set(folder, folderConsolidatedConfiguration);
            } else folderConsolidatedConfiguration = workspaceConsolidateConfiguration;
        }
        return folderConsolidatedConfiguration;
    }
    getFolderConfigurationModelForResource(resource, workspace) {
        if (workspace && resource) {
            const root = workspace.getFolder(resource);
            if (root) return this._folderConfigurations.get(root.uri);
        }
        return undefined;
    }
    toData() {
        return {
            defaults: {
                contents: this._defaultConfiguration.contents,
                overrides: this._defaultConfiguration.overrides,
                keys: this._defaultConfiguration.keys
            },
            policy: {
                contents: this._policyConfiguration.contents,
                overrides: this._policyConfiguration.overrides,
                keys: this._policyConfiguration.keys
            },
            application: {
                contents: this.applicationConfiguration.contents,
                overrides: this.applicationConfiguration.overrides,
                keys: this.applicationConfiguration.keys
            },
            user: {
                contents: this.userConfiguration.contents,
                overrides: this.userConfiguration.overrides,
                keys: this.userConfiguration.keys
            },
            workspace: {
                contents: this._workspaceConfiguration.contents,
                overrides: this._workspaceConfiguration.overrides,
                keys: this._workspaceConfiguration.keys
            },
            folders: [
                ...this._folderConfigurations.keys()
            ].reduce((result, folder)=>{
                const { contents, overrides, keys } = this._folderConfigurations.get(folder);
                result.push([
                    folder,
                    {
                        contents,
                        overrides,
                        keys
                    }
                ]);
                return result;
            }, [])
        };
    }
    static parse(data, logService) {
        const defaultConfiguration = this.parseConfigurationModel(data.defaults, logService);
        const policyConfiguration = this.parseConfigurationModel(data.policy, logService);
        const applicationConfiguration = this.parseConfigurationModel(data.application, logService);
        const userConfiguration = this.parseConfigurationModel(data.user, logService);
        const workspaceConfiguration = this.parseConfigurationModel(data.workspace, logService);
        const folders = data.folders.reduce((result, value)=>{
            result.set((0, _uriJs.URI).revive(value[0]), this.parseConfigurationModel(value[1], logService));
            return result;
        }, new (0, _mapJs.ResourceMap)());
        return new Configuration(defaultConfiguration, policyConfiguration, applicationConfiguration, userConfiguration, ConfigurationModel.createEmptyModel(logService), workspaceConfiguration, folders, ConfigurationModel.createEmptyModel(logService), new (0, _mapJs.ResourceMap)(), logService);
    }
    static parseConfigurationModel(model, logService) {
        return new ConfigurationModel(model.contents, model.keys, model.overrides, undefined, logService);
    }
}
class ConfigurationChangeEvent {
    constructor(change, previous, currentConfiguraiton, currentWorkspace, logService){
        this.change = change;
        this.previous = previous;
        this.currentConfiguraiton = currentConfiguraiton;
        this.currentWorkspace = currentWorkspace;
        this.logService = logService;
        this._marker = "\n";
        this._markerCode1 = this._marker.charCodeAt(0);
        this._markerCode2 = ".".charCodeAt(0);
        this.affectedKeys = new Set();
        this._previousConfiguration = undefined;
        for (const key of change.keys)this.affectedKeys.add(key);
        for (const [, keys] of change.overrides)for (const key of keys)this.affectedKeys.add(key);
        // Example: '\nfoo.bar\nabc.def\n'
        this._affectsConfigStr = this._marker;
        for (const key of this.affectedKeys)this._affectsConfigStr += key + this._marker;
    }
    get previousConfiguration() {
        if (!this._previousConfiguration && this.previous) this._previousConfiguration = Configuration.parse(this.previous.data, this.logService);
        return this._previousConfiguration;
    }
    affectsConfiguration(section, overrides) {
        // we have one large string with all keys that have changed. we pad (marker) the section
        // and check that either find it padded or before a segment character
        const needle = this._marker + section;
        const idx = this._affectsConfigStr.indexOf(needle);
        if (idx < 0) // NOT: (marker + section)
        return false;
        const pos = idx + needle.length;
        if (pos >= this._affectsConfigStr.length) return false;
        const code = this._affectsConfigStr.charCodeAt(pos);
        if (code !== this._markerCode1 && code !== this._markerCode2) // NOT: section + (marker | segment)
        return false;
        if (overrides) {
            const value1 = this.previousConfiguration ? this.previousConfiguration.getValue(section, overrides, this.previous?.workspace) : undefined;
            const value2 = this.currentConfiguraiton.getValue(section, overrides, this.currentWorkspace);
            return !_objectsJs.equals(value1, value2);
        }
        return true;
    }
}

},{"../../../base/common/arrays.js":"DECei","../../../base/common/map.js":"leSjz","../../../base/common/objects.js":"j84mT","../../../base/common/types.js":"fb5yx","../../../base/common/uri.js":"7qGS3","./configuration.js":"dXkjq","./configurationRegistry.js":"6y4yB","../../registry/common/platform.js":"dzx11","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ejxw7":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractKeybindingService", ()=>AbstractKeybindingService);
var _asyncJs = require("../../../base/common/async.js");
var _errorsJs = require("../../../base/common/errors.js");
var _eventJs = require("../../../base/common/event.js");
var _imeJs = require("../../../base/common/ime.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _nlsJs = require("../../../nls.js");
var _keybindingResolverJs = require("./keybindingResolver.js");
const HIGH_FREQ_COMMANDS = /^(cursor|delete|undo|redo|tab|editor\.action\.clipboard)/;
class AbstractKeybindingService extends (0, _lifecycleJs.Disposable) {
    get onDidUpdateKeybindings() {
        return this._onDidUpdateKeybindings ? this._onDidUpdateKeybindings.event : (0, _eventJs.Event).None; // Sinon stubbing walks properties on prototype
    }
    get inChordMode() {
        return this._currentChords.length > 0;
    }
    constructor(_contextKeyService, _commandService, _telemetryService, _notificationService, _logService){
        super();
        this._contextKeyService = _contextKeyService;
        this._commandService = _commandService;
        this._telemetryService = _telemetryService;
        this._notificationService = _notificationService;
        this._logService = _logService;
        this._onDidUpdateKeybindings = this._register(new (0, _eventJs.Emitter)());
        this._currentChords = [];
        this._currentChordChecker = new (0, _asyncJs.IntervalTimer)();
        this._currentChordStatusMessage = null;
        this._ignoreSingleModifiers = KeybindingModifierSet.EMPTY;
        this._currentSingleModifier = null;
        this._currentSingleModifierClearTimeout = new (0, _asyncJs.TimeoutTimer)();
        this._currentlyDispatchingCommandId = null;
        this._logging = false;
    }
    dispose() {
        super.dispose();
    }
    _log(str) {
        if (this._logging) this._logService.info(`[KeybindingService]: ${str}`);
    }
    getKeybindings() {
        return this._getResolver().getKeybindings();
    }
    lookupKeybinding(commandId, context) {
        const result = this._getResolver().lookupPrimaryKeybinding(commandId, context || this._contextKeyService);
        if (!result) return undefined;
        return result.resolvedKeybinding;
    }
    dispatchEvent(e, target) {
        return this._dispatch(e, target);
    }
    // TODO@ulugbekna: update namings to align with `_doDispatch`
    // TODO@ulugbekna: this fn doesn't seem to take into account single-modifier keybindings, eg `shift shift`
    softDispatch(e, target) {
        this._log(`/ Soft dispatching keyboard event`);
        const keybinding = this.resolveKeyboardEvent(e);
        if (keybinding.hasMultipleChords()) {
            console.warn("keyboard event should not be mapped to multiple chords");
            return 0, _keybindingResolverJs.NoMatchingKb;
        }
        const [firstChord] = keybinding.getDispatchChords();
        if (firstChord === null) {
            // cannot be dispatched, probably only modifier keys
            this._log(`\\ Keyboard event cannot be dispatched`);
            return 0, _keybindingResolverJs.NoMatchingKb;
        }
        const contextValue = this._contextKeyService.getContext(target);
        const currentChords = this._currentChords.map(({ keypress })=>keypress);
        return this._getResolver().resolve(contextValue, currentChords, firstChord);
    }
    _scheduleLeaveChordMode() {
        const chordLastInteractedTime = Date.now();
        this._currentChordChecker.cancelAndSet(()=>{
            if (!this._documentHasFocus()) {
                // Focus has been lost => leave chord mode
                this._leaveChordMode();
                return;
            }
            if (Date.now() - chordLastInteractedTime > 5000) // 5 seconds elapsed => leave chord mode
            this._leaveChordMode();
        }, 500);
    }
    _expectAnotherChord(firstChord, keypressLabel) {
        this._currentChords.push({
            keypress: firstChord,
            label: keypressLabel
        });
        switch(this._currentChords.length){
            case 0:
                throw (0, _errorsJs.illegalState)("impossible");
            case 1:
                // TODO@ulugbekna: revise this message and the one below (at least, fix terminology)
                this._currentChordStatusMessage = this._notificationService.status(_nlsJs.localize("first.chord", "({0}) was pressed. Waiting for second key of chord...", keypressLabel));
                break;
            default:
                {
                    const fullKeypressLabel = this._currentChords.map(({ label })=>label).join(", ");
                    this._currentChordStatusMessage = this._notificationService.status(_nlsJs.localize("next.chord", "({0}) was pressed. Waiting for next key of chord...", fullKeypressLabel));
                }
        }
        this._scheduleLeaveChordMode();
        if ((0, _imeJs.IME).enabled) (0, _imeJs.IME).disable();
    }
    _leaveChordMode() {
        if (this._currentChordStatusMessage) {
            this._currentChordStatusMessage.dispose();
            this._currentChordStatusMessage = null;
        }
        this._currentChordChecker.cancel();
        this._currentChords = [];
        (0, _imeJs.IME).enable();
    }
    _dispatch(e, target) {
        return this._doDispatch(this.resolveKeyboardEvent(e), target, /*isSingleModiferChord*/ false);
    }
    _singleModifierDispatch(e, target) {
        const keybinding = this.resolveKeyboardEvent(e);
        const [singleModifier] = keybinding.getSingleModifierDispatchChords();
        if (singleModifier) {
            if (this._ignoreSingleModifiers.has(singleModifier)) {
                this._log(`+ Ignoring single modifier ${singleModifier} due to it being pressed together with other keys.`);
                this._ignoreSingleModifiers = KeybindingModifierSet.EMPTY;
                this._currentSingleModifierClearTimeout.cancel();
                this._currentSingleModifier = null;
                return false;
            }
            this._ignoreSingleModifiers = KeybindingModifierSet.EMPTY;
            if (this._currentSingleModifier === null) {
                // we have a valid `singleModifier`, store it for the next keyup, but clear it in 300ms
                this._log(`+ Storing single modifier for possible chord ${singleModifier}.`);
                this._currentSingleModifier = singleModifier;
                this._currentSingleModifierClearTimeout.cancelAndSet(()=>{
                    this._log(`+ Clearing single modifier due to 300ms elapsed.`);
                    this._currentSingleModifier = null;
                }, 300);
                return false;
            }
            if (singleModifier === this._currentSingleModifier) {
                // bingo!
                this._log(`/ Dispatching single modifier chord ${singleModifier} ${singleModifier}`);
                this._currentSingleModifierClearTimeout.cancel();
                this._currentSingleModifier = null;
                return this._doDispatch(keybinding, target, /*isSingleModiferChord*/ true);
            }
            this._log(`+ Clearing single modifier due to modifier mismatch: ${this._currentSingleModifier} ${singleModifier}`);
            this._currentSingleModifierClearTimeout.cancel();
            this._currentSingleModifier = null;
            return false;
        }
        // When pressing a modifier and holding it pressed with any other modifier or key combination,
        // the pressed modifiers should no longer be considered for single modifier dispatch.
        const [firstChord] = keybinding.getChords();
        this._ignoreSingleModifiers = new KeybindingModifierSet(firstChord);
        if (this._currentSingleModifier !== null) this._log(`+ Clearing single modifier due to other key up.`);
        this._currentSingleModifierClearTimeout.cancel();
        this._currentSingleModifier = null;
        return false;
    }
    _doDispatch(userKeypress, target, isSingleModiferChord = false) {
        let shouldPreventDefault = false;
        if (userKeypress.hasMultipleChords()) {
            console.warn("Unexpected keyboard event mapped to multiple chords");
            return false;
        }
        let userPressedChord = null;
        let currentChords = null;
        if (isSingleModiferChord) {
            // The keybinding is the second keypress of a single modifier chord, e.g. "shift shift".
            // A single modifier can only occur when the same modifier is pressed in short sequence,
            // hence we disregard `_currentChord` and use the same modifier instead.
            const [dispatchKeyname] = userKeypress.getSingleModifierDispatchChords();
            userPressedChord = dispatchKeyname;
            currentChords = dispatchKeyname ? [
                dispatchKeyname
            ] : []; // TODO@ulugbekna: in the `else` case we assign an empty array - make sure `resolve` can handle an empty array well
        } else {
            [userPressedChord] = userKeypress.getDispatchChords();
            currentChords = this._currentChords.map(({ keypress })=>keypress);
        }
        if (userPressedChord === null) {
            this._log(`\\ Keyboard event cannot be dispatched in keydown phase.`);
            // cannot be dispatched, probably only modifier keys
            return shouldPreventDefault;
        }
        const contextValue = this._contextKeyService.getContext(target);
        const keypressLabel = userKeypress.getLabel();
        const resolveResult = this._getResolver().resolve(contextValue, currentChords, userPressedChord);
        switch(resolveResult.kind){
            case 0 /* ResultKind.NoMatchingKb */ :
                this._logService.trace("KeybindingService#dispatch", keypressLabel, `[ No matching keybinding ]`);
                if (this.inChordMode) {
                    const currentChordsLabel = this._currentChords.map(({ label })=>label).join(", ");
                    this._log(`+ Leaving multi-chord mode: Nothing bound to "${currentChordsLabel}, ${keypressLabel}".`);
                    this._notificationService.status(_nlsJs.localize("missing.chord", "The key combination ({0}, {1}) is not a command.", currentChordsLabel, keypressLabel), {
                        hideAfter: 10000 /* 10s */ 
                    });
                    this._leaveChordMode();
                    shouldPreventDefault = true;
                }
                return shouldPreventDefault;
            case 1 /* ResultKind.MoreChordsNeeded */ :
                this._logService.trace("KeybindingService#dispatch", keypressLabel, `[ Several keybindings match - more chords needed ]`);
                shouldPreventDefault = true;
                this._expectAnotherChord(userPressedChord, keypressLabel);
                this._log(this._currentChords.length === 1 ? `+ Entering multi-chord mode...` : `+ Continuing multi-chord mode...`);
                return shouldPreventDefault;
            case 2 /* ResultKind.KbFound */ :
                this._logService.trace("KeybindingService#dispatch", keypressLabel, `[ Will dispatch command ${resolveResult.commandId} ]`);
                if (resolveResult.commandId === null || resolveResult.commandId === "") {
                    if (this.inChordMode) {
                        const currentChordsLabel = this._currentChords.map(({ label })=>label).join(", ");
                        this._log(`+ Leaving chord mode: Nothing bound to "${currentChordsLabel}, ${keypressLabel}".`);
                        this._notificationService.status(_nlsJs.localize("missing.chord", "The key combination ({0}, {1}) is not a command.", currentChordsLabel, keypressLabel), {
                            hideAfter: 10000 /* 10s */ 
                        });
                        this._leaveChordMode();
                        shouldPreventDefault = true;
                    }
                } else {
                    if (this.inChordMode) this._leaveChordMode();
                    if (!resolveResult.isBubble) shouldPreventDefault = true;
                    this._log(`+ Invoking command ${resolveResult.commandId}.`);
                    this._currentlyDispatchingCommandId = resolveResult.commandId;
                    try {
                        if (typeof resolveResult.commandArgs === "undefined") this._commandService.executeCommand(resolveResult.commandId).then(undefined, (err)=>this._notificationService.warn(err));
                        else this._commandService.executeCommand(resolveResult.commandId, resolveResult.commandArgs).then(undefined, (err)=>this._notificationService.warn(err));
                    } finally{
                        this._currentlyDispatchingCommandId = null;
                    }
                    if (!HIGH_FREQ_COMMANDS.test(resolveResult.commandId)) this._telemetryService.publicLog2("workbenchActionExecuted", {
                        id: resolveResult.commandId,
                        from: "keybinding",
                        detail: userKeypress.getUserSettingsLabel() ?? undefined
                    });
                }
                return shouldPreventDefault;
        }
    }
    mightProducePrintableCharacter(event) {
        if (event.ctrlKey || event.metaKey) // ignore ctrl/cmd-combination but not shift/alt-combinatios
        return false;
        // weak check for certain ranges. this is properly implemented in a subclass
        // with access to the KeyboardMapperFactory.
        if (event.keyCode >= 31 /* KeyCode.KeyA */  && event.keyCode <= 56 /* KeyCode.KeyZ */  || event.keyCode >= 21 /* KeyCode.Digit0 */  && event.keyCode <= 30 /* KeyCode.Digit9 */ ) return true;
        return false;
    }
}
class KeybindingModifierSet {
    static{
        this.EMPTY = new KeybindingModifierSet(null);
    }
    constructor(source){
        this._ctrlKey = source ? source.ctrlKey : false;
        this._shiftKey = source ? source.shiftKey : false;
        this._altKey = source ? source.altKey : false;
        this._metaKey = source ? source.metaKey : false;
    }
    has(modifier) {
        switch(modifier){
            case "ctrl":
                return this._ctrlKey;
            case "shift":
                return this._shiftKey;
            case "alt":
                return this._altKey;
            case "meta":
                return this._metaKey;
        }
    }
}

},{"../../../base/common/async.js":"4GJc4","../../../base/common/errors.js":"divX8","../../../base/common/event.js":"4Zi8b","../../../base/common/ime.js":"iPFYF","../../../base/common/lifecycle.js":"9kg8d","../../../nls.js":"l617d","./keybindingResolver.js":"hQoQq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iPFYF":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IMEImpl", ()=>IMEImpl);
parcelHelpers.export(exports, "IME", ()=>IME);
var _eventJs = require("./event.js");
class IMEImpl {
    constructor(){
        this._onDidChange = new (0, _eventJs.Emitter)();
        this.onDidChange = this._onDidChange.event;
        this._enabled = true;
    }
    get enabled() {
        return this._enabled;
    }
    /**
     * Enable IME
     */ enable() {
        this._enabled = true;
        this._onDidChange.fire();
    }
    /**
     * Disable IME
     */ disable() {
        this._enabled = false;
        this._onDidChange.fire();
    }
}
const IME = new IMEImpl();

},{"./event.js":"4Zi8b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hQoQq":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoMatchingKb", ()=>NoMatchingKb);
//#endregion
/**
 * Stores mappings from keybindings to commands and from commands to keybindings.
 * Given a sequence of chords, `resolve`s which keybinding it matches
 */ parcelHelpers.export(exports, "KeybindingResolver", ()=>KeybindingResolver);
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
const NoMatchingKb = {
    kind: 0 /* ResultKind.NoMatchingKb */ 
};
const MoreChordsNeeded = {
    kind: 1 /* ResultKind.MoreChordsNeeded */ 
};
function KbFound(commandId, commandArgs, isBubble) {
    return {
        kind: 2 /* ResultKind.KbFound */ ,
        commandId,
        commandArgs,
        isBubble
    };
}
class KeybindingResolver {
    constructor(/** built-in and extension-provided keybindings */ defaultKeybindings, /** user's keybindings */ overrides, log){
        this._log = log;
        this._defaultKeybindings = defaultKeybindings;
        this._defaultBoundCommands = new Map();
        for (const defaultKeybinding of defaultKeybindings){
            const command = defaultKeybinding.command;
            if (command && command.charAt(0) !== "-") this._defaultBoundCommands.set(command, true);
        }
        this._map = new Map();
        this._lookupMap = new Map();
        this._keybindings = KeybindingResolver.handleRemovals([].concat(defaultKeybindings).concat(overrides));
        for(let i = 0, len = this._keybindings.length; i < len; i++){
            const k = this._keybindings[i];
            if (k.chords.length === 0) continue;
            // substitute with constants that are registered after startup - https://github.com/microsoft/vscode/issues/174218#issuecomment-1437972127
            const when = k.when?.substituteConstants();
            if (when && when.type === 0 /* ContextKeyExprType.False */ ) continue;
            this._addKeyPress(k.chords[0], k);
        }
    }
    static _isTargetedForRemoval(defaultKb, keypress, when) {
        if (keypress) for(let i = 0; i < keypress.length; i++){
            if (keypress[i] !== defaultKb.chords[i]) return false;
        }
        // `true` means always, as does `undefined`
        // so we will treat `true` === `undefined`
        if (when && when.type !== 1 /* ContextKeyExprType.True */ ) {
            if (!defaultKb.when) return false;
            if (!(0, _contextkeyJs.expressionsAreEqualWithConstantSubstitution)(when, defaultKb.when)) return false;
        }
        return true;
    }
    /**
     * Looks for rules containing "-commandId" and removes them.
     */ static handleRemovals(rules) {
        // Do a first pass and construct a hash-map for removals
        const removals = new Map();
        for(let i = 0, len = rules.length; i < len; i++){
            const rule = rules[i];
            if (rule.command && rule.command.charAt(0) === "-") {
                const command = rule.command.substring(1);
                if (!removals.has(command)) removals.set(command, [
                    rule
                ]);
                else removals.get(command).push(rule);
            }
        }
        if (removals.size === 0) // There are no removals
        return rules;
        // Do a second pass and keep only non-removed keybindings
        const result = [];
        for(let i = 0, len = rules.length; i < len; i++){
            const rule = rules[i];
            if (!rule.command || rule.command.length === 0) {
                result.push(rule);
                continue;
            }
            if (rule.command.charAt(0) === "-") continue;
            const commandRemovals = removals.get(rule.command);
            if (!commandRemovals || !rule.isDefault) {
                result.push(rule);
                continue;
            }
            let isRemoved = false;
            for (const commandRemoval of commandRemovals){
                const when = commandRemoval.when;
                if (this._isTargetedForRemoval(rule, commandRemoval.chords, when)) {
                    isRemoved = true;
                    break;
                }
            }
            if (!isRemoved) {
                result.push(rule);
                continue;
            }
        }
        return result;
    }
    _addKeyPress(keypress, item) {
        const conflicts = this._map.get(keypress);
        if (typeof conflicts === "undefined") {
            // There is no conflict so far
            this._map.set(keypress, [
                item
            ]);
            this._addToLookupMap(item);
            return;
        }
        for(let i = conflicts.length - 1; i >= 0; i--){
            const conflict = conflicts[i];
            if (conflict.command === item.command) continue;
            // Test if the shorter keybinding is a prefix of the longer one.
            // If the shorter keybinding is a prefix, it effectively will shadow the longer one and is considered a conflict.
            let isShorterKbPrefix = true;
            for(let i = 1; i < conflict.chords.length && i < item.chords.length; i++)if (conflict.chords[i] !== item.chords[i]) {
                // The ith step does not conflict
                isShorterKbPrefix = false;
                break;
            }
            if (!isShorterKbPrefix) continue;
            if (KeybindingResolver.whenIsEntirelyIncluded(conflict.when, item.when)) // `item` completely overwrites `conflict`
            // Remove conflict from the lookupMap
            this._removeFromLookupMap(conflict);
        }
        conflicts.push(item);
        this._addToLookupMap(item);
    }
    _addToLookupMap(item) {
        if (!item.command) return;
        let arr = this._lookupMap.get(item.command);
        if (typeof arr === "undefined") {
            arr = [
                item
            ];
            this._lookupMap.set(item.command, arr);
        } else arr.push(item);
    }
    _removeFromLookupMap(item) {
        if (!item.command) return;
        const arr = this._lookupMap.get(item.command);
        if (typeof arr === "undefined") return;
        for(let i = 0, len = arr.length; i < len; i++)if (arr[i] === item) {
            arr.splice(i, 1);
            return;
        }
    }
    /**
     * Returns true if it is provable `a` implies `b`.
     */ static whenIsEntirelyIncluded(a, b) {
        if (!b || b.type === 1 /* ContextKeyExprType.True */ ) return true;
        if (!a || a.type === 1 /* ContextKeyExprType.True */ ) return false;
        return (0, _contextkeyJs.implies)(a, b);
    }
    getKeybindings() {
        return this._keybindings;
    }
    lookupPrimaryKeybinding(commandId, context) {
        const items = this._lookupMap.get(commandId);
        if (typeof items === "undefined" || items.length === 0) return null;
        if (items.length === 1) return items[0];
        for(let i = items.length - 1; i >= 0; i--){
            const item = items[i];
            if (context.contextMatchesRules(item.when)) return item;
        }
        return items[items.length - 1];
    }
    /**
     * Looks up a keybinding trigged as a result of pressing a sequence of chords - `[...currentChords, keypress]`
     *
     * Example: resolving 3 chords pressed sequentially - `cmd+k cmd+p cmd+i`:
     * 	`currentChords = [ 'cmd+k' , 'cmd+p' ]` and `keypress = `cmd+i` - last pressed chord
     */ resolve(context, currentChords, keypress) {
        const pressedChords = [
            ...currentChords,
            keypress
        ];
        this._log(`| Resolving ${pressedChords}`);
        const kbCandidates = this._map.get(pressedChords[0]);
        if (kbCandidates === undefined) {
            // No bindings with such 0-th chord
            this._log(`\\ No keybinding entries.`);
            return NoMatchingKb;
        }
        let lookupMap = null;
        if (pressedChords.length < 2) lookupMap = kbCandidates;
        else {
            // Fetch all chord bindings for `currentChords`
            lookupMap = [];
            for(let i = 0, len = kbCandidates.length; i < len; i++){
                const candidate = kbCandidates[i];
                if (pressedChords.length > candidate.chords.length) continue;
                let prefixMatches = true;
                for(let i = 1; i < pressedChords.length; i++)if (candidate.chords[i] !== pressedChords[i]) {
                    prefixMatches = false;
                    break;
                }
                if (prefixMatches) lookupMap.push(candidate);
            }
        }
        // check there's a keybinding with a matching when clause
        const result = this._findCommand(context, lookupMap);
        if (!result) {
            this._log(`\\ From ${lookupMap.length} keybinding entries, no when clauses matched the context.`);
            return NoMatchingKb;
        }
        // check we got all chords necessary to be sure a particular keybinding needs to be invoked
        if (pressedChords.length < result.chords.length) {
            // The chord sequence is not complete
            this._log(`\\ From ${lookupMap.length} keybinding entries, awaiting ${result.chords.length - pressedChords.length} more chord(s), when: ${printWhenExplanation(result.when)}, source: ${printSourceExplanation(result)}.`);
            return MoreChordsNeeded;
        }
        this._log(`\\ From ${lookupMap.length} keybinding entries, matched ${result.command}, when: ${printWhenExplanation(result.when)}, source: ${printSourceExplanation(result)}.`);
        return KbFound(result.command, result.commandArgs, result.bubble);
    }
    _findCommand(context, matches) {
        for(let i = matches.length - 1; i >= 0; i--){
            const k = matches[i];
            if (!KeybindingResolver._contextMatchesRules(context, k.when)) continue;
            return k;
        }
        return null;
    }
    static _contextMatchesRules(context, rules) {
        if (!rules) return true;
        return rules.evaluate(context);
    }
}
function printWhenExplanation(when) {
    if (!when) return `no when condition`;
    return `${when.serialize()}`;
}
function printSourceExplanation(kb) {
    return kb.extensionId ? kb.isBuiltinExtension ? `built-in extension ${kb.extensionId}` : `user extension ${kb.extensionId}` : kb.isDefault ? `built-in` : `user`;
}

},{"../../contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ijJXz":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResolvedKeybindingItem", ()=>ResolvedKeybindingItem);
parcelHelpers.export(exports, "toEmptyArrayIfContainsNull", ()=>toEmptyArrayIfContainsNull);
class ResolvedKeybindingItem {
    constructor(resolvedKeybinding, command, commandArgs, when, isDefault, extensionId, isBuiltinExtension){
        this._resolvedKeybindingItemBrand = undefined;
        this.resolvedKeybinding = resolvedKeybinding;
        this.chords = resolvedKeybinding ? toEmptyArrayIfContainsNull(resolvedKeybinding.getDispatchChords()) : [];
        if (resolvedKeybinding && this.chords.length === 0) // handle possible single modifier chord keybindings
        this.chords = toEmptyArrayIfContainsNull(resolvedKeybinding.getSingleModifierDispatchChords());
        this.bubble = command ? command.charCodeAt(0) === 94 /* CharCode.Caret */  : false;
        this.command = this.bubble ? command.substr(1) : command;
        this.commandArgs = commandArgs;
        this.when = when;
        this.isDefault = isDefault;
        this.extensionId = extensionId;
        this.isBuiltinExtension = isBuiltinExtension;
    }
}
function toEmptyArrayIfContainsNull(arr) {
    const result = [];
    for(let i = 0, len = arr.length; i < len; i++){
        const element = arr[i];
        if (!element) return [];
        result.push(element);
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUnGv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Do not instantiate. Use KeybindingService to get a ResolvedKeybinding seeded with information about the current kb layout.
 */ parcelHelpers.export(exports, "USLayoutResolvedKeybinding", ()=>USLayoutResolvedKeybinding);
var _keyCodesJs = require("../../../base/common/keyCodes.js");
var _keybindingsJs = require("../../../base/common/keybindings.js");
var _baseResolvedKeybindingJs = require("./baseResolvedKeybinding.js");
var _resolvedKeybindingItemJs = require("./resolvedKeybindingItem.js");
class USLayoutResolvedKeybinding extends (0, _baseResolvedKeybindingJs.BaseResolvedKeybinding) {
    constructor(chords, os){
        super(os, chords);
    }
    _keyCodeToUILabel(keyCode) {
        if (this._os === 2 /* OperatingSystem.Macintosh */ ) switch(keyCode){
            case 15 /* KeyCode.LeftArrow */ :
                return "\u2190";
            case 16 /* KeyCode.UpArrow */ :
                return "\u2191";
            case 17 /* KeyCode.RightArrow */ :
                return "\u2192";
            case 18 /* KeyCode.DownArrow */ :
                return "\u2193";
        }
        return (0, _keyCodesJs.KeyCodeUtils).toString(keyCode);
    }
    _getLabel(chord) {
        if (chord.isDuplicateModifierCase()) return "";
        return this._keyCodeToUILabel(chord.keyCode);
    }
    _getAriaLabel(chord) {
        if (chord.isDuplicateModifierCase()) return "";
        return (0, _keyCodesJs.KeyCodeUtils).toString(chord.keyCode);
    }
    _getElectronAccelerator(chord) {
        return (0, _keyCodesJs.KeyCodeUtils).toElectronAccelerator(chord.keyCode);
    }
    _getUserSettingsLabel(chord) {
        if (chord.isDuplicateModifierCase()) return "";
        const result = (0, _keyCodesJs.KeyCodeUtils).toUserSettingsUS(chord.keyCode);
        return result ? result.toLowerCase() : result;
    }
    _getChordDispatch(chord) {
        return USLayoutResolvedKeybinding.getDispatchStr(chord);
    }
    static getDispatchStr(chord) {
        if (chord.isModifierKey()) return null;
        let result = "";
        if (chord.ctrlKey) result += "ctrl+";
        if (chord.shiftKey) result += "shift+";
        if (chord.altKey) result += "alt+";
        if (chord.metaKey) result += "meta+";
        result += (0, _keyCodesJs.KeyCodeUtils).toString(chord.keyCode);
        return result;
    }
    _getSingleModifierChordDispatch(keybinding) {
        if (keybinding.keyCode === 5 /* KeyCode.Ctrl */  && !keybinding.shiftKey && !keybinding.altKey && !keybinding.metaKey) return "ctrl";
        if (keybinding.keyCode === 4 /* KeyCode.Shift */  && !keybinding.ctrlKey && !keybinding.altKey && !keybinding.metaKey) return "shift";
        if (keybinding.keyCode === 6 /* KeyCode.Alt */  && !keybinding.ctrlKey && !keybinding.shiftKey && !keybinding.metaKey) return "alt";
        if (keybinding.keyCode === 57 /* KeyCode.Meta */  && !keybinding.ctrlKey && !keybinding.shiftKey && !keybinding.altKey) return "meta";
        return null;
    }
    /**
     * *NOTE*: Check return value for `KeyCode.Unknown`.
     */ static _scanCodeToKeyCode(scanCode) {
        const immutableKeyCode = (0, _keyCodesJs.IMMUTABLE_CODE_TO_KEY_CODE)[scanCode];
        if (immutableKeyCode !== -1 /* KeyCode.DependsOnKbLayout */ ) return immutableKeyCode;
        switch(scanCode){
            case 10 /* ScanCode.KeyA */ :
                return 31 /* KeyCode.KeyA */ ;
            case 11 /* ScanCode.KeyB */ :
                return 32 /* KeyCode.KeyB */ ;
            case 12 /* ScanCode.KeyC */ :
                return 33 /* KeyCode.KeyC */ ;
            case 13 /* ScanCode.KeyD */ :
                return 34 /* KeyCode.KeyD */ ;
            case 14 /* ScanCode.KeyE */ :
                return 35 /* KeyCode.KeyE */ ;
            case 15 /* ScanCode.KeyF */ :
                return 36 /* KeyCode.KeyF */ ;
            case 16 /* ScanCode.KeyG */ :
                return 37 /* KeyCode.KeyG */ ;
            case 17 /* ScanCode.KeyH */ :
                return 38 /* KeyCode.KeyH */ ;
            case 18 /* ScanCode.KeyI */ :
                return 39 /* KeyCode.KeyI */ ;
            case 19 /* ScanCode.KeyJ */ :
                return 40 /* KeyCode.KeyJ */ ;
            case 20 /* ScanCode.KeyK */ :
                return 41 /* KeyCode.KeyK */ ;
            case 21 /* ScanCode.KeyL */ :
                return 42 /* KeyCode.KeyL */ ;
            case 22 /* ScanCode.KeyM */ :
                return 43 /* KeyCode.KeyM */ ;
            case 23 /* ScanCode.KeyN */ :
                return 44 /* KeyCode.KeyN */ ;
            case 24 /* ScanCode.KeyO */ :
                return 45 /* KeyCode.KeyO */ ;
            case 25 /* ScanCode.KeyP */ :
                return 46 /* KeyCode.KeyP */ ;
            case 26 /* ScanCode.KeyQ */ :
                return 47 /* KeyCode.KeyQ */ ;
            case 27 /* ScanCode.KeyR */ :
                return 48 /* KeyCode.KeyR */ ;
            case 28 /* ScanCode.KeyS */ :
                return 49 /* KeyCode.KeyS */ ;
            case 29 /* ScanCode.KeyT */ :
                return 50 /* KeyCode.KeyT */ ;
            case 30 /* ScanCode.KeyU */ :
                return 51 /* KeyCode.KeyU */ ;
            case 31 /* ScanCode.KeyV */ :
                return 52 /* KeyCode.KeyV */ ;
            case 32 /* ScanCode.KeyW */ :
                return 53 /* KeyCode.KeyW */ ;
            case 33 /* ScanCode.KeyX */ :
                return 54 /* KeyCode.KeyX */ ;
            case 34 /* ScanCode.KeyY */ :
                return 55 /* KeyCode.KeyY */ ;
            case 35 /* ScanCode.KeyZ */ :
                return 56 /* KeyCode.KeyZ */ ;
            case 36 /* ScanCode.Digit1 */ :
                return 22 /* KeyCode.Digit1 */ ;
            case 37 /* ScanCode.Digit2 */ :
                return 23 /* KeyCode.Digit2 */ ;
            case 38 /* ScanCode.Digit3 */ :
                return 24 /* KeyCode.Digit3 */ ;
            case 39 /* ScanCode.Digit4 */ :
                return 25 /* KeyCode.Digit4 */ ;
            case 40 /* ScanCode.Digit5 */ :
                return 26 /* KeyCode.Digit5 */ ;
            case 41 /* ScanCode.Digit6 */ :
                return 27 /* KeyCode.Digit6 */ ;
            case 42 /* ScanCode.Digit7 */ :
                return 28 /* KeyCode.Digit7 */ ;
            case 43 /* ScanCode.Digit8 */ :
                return 29 /* KeyCode.Digit8 */ ;
            case 44 /* ScanCode.Digit9 */ :
                return 30 /* KeyCode.Digit9 */ ;
            case 45 /* ScanCode.Digit0 */ :
                return 21 /* KeyCode.Digit0 */ ;
            case 51 /* ScanCode.Minus */ :
                return 88 /* KeyCode.Minus */ ;
            case 52 /* ScanCode.Equal */ :
                return 86 /* KeyCode.Equal */ ;
            case 53 /* ScanCode.BracketLeft */ :
                return 92 /* KeyCode.BracketLeft */ ;
            case 54 /* ScanCode.BracketRight */ :
                return 94 /* KeyCode.BracketRight */ ;
            case 55 /* ScanCode.Backslash */ :
                return 93 /* KeyCode.Backslash */ ;
            case 56 /* ScanCode.IntlHash */ :
                return 0 /* KeyCode.Unknown */ ; // missing
            case 57 /* ScanCode.Semicolon */ :
                return 85 /* KeyCode.Semicolon */ ;
            case 58 /* ScanCode.Quote */ :
                return 95 /* KeyCode.Quote */ ;
            case 59 /* ScanCode.Backquote */ :
                return 91 /* KeyCode.Backquote */ ;
            case 60 /* ScanCode.Comma */ :
                return 87 /* KeyCode.Comma */ ;
            case 61 /* ScanCode.Period */ :
                return 89 /* KeyCode.Period */ ;
            case 62 /* ScanCode.Slash */ :
                return 90 /* KeyCode.Slash */ ;
            case 106 /* ScanCode.IntlBackslash */ :
                return 97 /* KeyCode.IntlBackslash */ ;
        }
        return 0 /* KeyCode.Unknown */ ;
    }
    static _toKeyCodeChord(chord) {
        if (!chord) return null;
        if (chord instanceof (0, _keybindingsJs.KeyCodeChord)) return chord;
        const keyCode = this._scanCodeToKeyCode(chord.scanCode);
        if (keyCode === 0 /* KeyCode.Unknown */ ) return null;
        return new (0, _keybindingsJs.KeyCodeChord)(chord.ctrlKey, chord.shiftKey, chord.altKey, chord.metaKey, keyCode);
    }
    static resolveKeybinding(keybinding, os) {
        const chords = (0, _resolvedKeybindingItemJs.toEmptyArrayIfContainsNull)(keybinding.chords.map((chord)=>this._toKeyCodeChord(chord)));
        if (chords.length > 0) return [
            new USLayoutResolvedKeybinding(chords, os)
        ];
        return [];
    }
}

},{"../../../base/common/keyCodes.js":"bHiG9","../../../base/common/keybindings.js":"cQ6F5","./baseResolvedKeybinding.js":"6Dw5E","./resolvedKeybindingItem.js":"ijJXz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Dw5E":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseResolvedKeybinding", ()=>BaseResolvedKeybinding);
var _errorsJs = require("../../../base/common/errors.js");
var _keybindingLabelsJs = require("../../../base/common/keybindingLabels.js");
var _keybindingsJs = require("../../../base/common/keybindings.js");
class BaseResolvedKeybinding extends (0, _keybindingsJs.ResolvedKeybinding) {
    constructor(os, chords){
        super();
        if (chords.length === 0) throw (0, _errorsJs.illegalArgument)(`chords`);
        this._os = os;
        this._chords = chords;
    }
    getLabel() {
        return (0, _keybindingLabelsJs.UILabelProvider).toLabel(this._os, this._chords, (keybinding)=>this._getLabel(keybinding));
    }
    getAriaLabel() {
        return (0, _keybindingLabelsJs.AriaLabelProvider).toLabel(this._os, this._chords, (keybinding)=>this._getAriaLabel(keybinding));
    }
    getElectronAccelerator() {
        if (this._chords.length > 1) // [Electron Accelerators] Electron cannot handle chords
        return null;
        if (this._chords[0].isDuplicateModifierCase()) // [Electron Accelerators] Electron cannot handle modifier only keybindings
        // e.g. "shift shift"
        return null;
        return (0, _keybindingLabelsJs.ElectronAcceleratorLabelProvider).toLabel(this._os, this._chords, (keybinding)=>this._getElectronAccelerator(keybinding));
    }
    getUserSettingsLabel() {
        return (0, _keybindingLabelsJs.UserSettingsLabelProvider).toLabel(this._os, this._chords, (keybinding)=>this._getUserSettingsLabel(keybinding));
    }
    hasMultipleChords() {
        return this._chords.length > 1;
    }
    getChords() {
        return this._chords.map((keybinding)=>this._getChord(keybinding));
    }
    _getChord(keybinding) {
        return new (0, _keybindingsJs.ResolvedChord)(keybinding.ctrlKey, keybinding.shiftKey, keybinding.altKey, keybinding.metaKey, this._getLabel(keybinding), this._getAriaLabel(keybinding));
    }
    getDispatchChords() {
        return this._chords.map((keybinding)=>this._getChordDispatch(keybinding));
    }
    getSingleModifierDispatchChords() {
        return this._chords.map((keybinding)=>this._getSingleModifierChordDispatch(keybinding));
    }
}

},{"../../../base/common/errors.js":"divX8","../../../base/common/keybindingLabels.js":"jUs6a","../../../base/common/keybindings.js":"cQ6F5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jUs6a":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModifierLabelProvider", ()=>ModifierLabelProvider);
parcelHelpers.export(exports, "UILabelProvider", ()=>UILabelProvider);
parcelHelpers.export(exports, "AriaLabelProvider", ()=>AriaLabelProvider);
parcelHelpers.export(exports, "ElectronAcceleratorLabelProvider", ()=>ElectronAcceleratorLabelProvider);
parcelHelpers.export(exports, "UserSettingsLabelProvider", ()=>UserSettingsLabelProvider);
var _nlsJs = require("../../nls.js");
class ModifierLabelProvider {
    constructor(mac, windows, linux = windows){
        this.modifierLabels = [
            null
        ]; // index 0 will never me accessed.
        this.modifierLabels[2 /* OperatingSystem.Macintosh */ ] = mac;
        this.modifierLabels[1 /* OperatingSystem.Windows */ ] = windows;
        this.modifierLabels[3 /* OperatingSystem.Linux */ ] = linux;
    }
    toLabel(OS, chords, keyLabelProvider) {
        if (chords.length === 0) return null;
        const result = [];
        for(let i = 0, len = chords.length; i < len; i++){
            const chord = chords[i];
            const keyLabel = keyLabelProvider(chord);
            if (keyLabel === null) // this keybinding cannot be expressed...
            return null;
            result[i] = _simpleAsString(chord, keyLabel, this.modifierLabels[OS]);
        }
        return result.join(" ");
    }
}
const UILabelProvider = new ModifierLabelProvider({
    ctrlKey: "\u2303",
    shiftKey: "\u21E7",
    altKey: "\u2325",
    metaKey: "\u2318",
    separator: ""
}, {
    ctrlKey: _nlsJs.localize({
        key: "ctrlKey",
        comment: [
            "This is the short form for the Control key on the keyboard"
        ]
    }, "Ctrl"),
    shiftKey: _nlsJs.localize({
        key: "shiftKey",
        comment: [
            "This is the short form for the Shift key on the keyboard"
        ]
    }, "Shift"),
    altKey: _nlsJs.localize({
        key: "altKey",
        comment: [
            "This is the short form for the Alt key on the keyboard"
        ]
    }, "Alt"),
    metaKey: _nlsJs.localize({
        key: "windowsKey",
        comment: [
            "This is the short form for the Windows key on the keyboard"
        ]
    }, "Windows"),
    separator: "+"
}, {
    ctrlKey: _nlsJs.localize({
        key: "ctrlKey",
        comment: [
            "This is the short form for the Control key on the keyboard"
        ]
    }, "Ctrl"),
    shiftKey: _nlsJs.localize({
        key: "shiftKey",
        comment: [
            "This is the short form for the Shift key on the keyboard"
        ]
    }, "Shift"),
    altKey: _nlsJs.localize({
        key: "altKey",
        comment: [
            "This is the short form for the Alt key on the keyboard"
        ]
    }, "Alt"),
    metaKey: _nlsJs.localize({
        key: "superKey",
        comment: [
            "This is the short form for the Super key on the keyboard"
        ]
    }, "Super"),
    separator: "+"
});
const AriaLabelProvider = new ModifierLabelProvider({
    ctrlKey: _nlsJs.localize({
        key: "ctrlKey.long",
        comment: [
            "This is the long form for the Control key on the keyboard"
        ]
    }, "Control"),
    shiftKey: _nlsJs.localize({
        key: "shiftKey.long",
        comment: [
            "This is the long form for the Shift key on the keyboard"
        ]
    }, "Shift"),
    altKey: _nlsJs.localize({
        key: "optKey.long",
        comment: [
            "This is the long form for the Alt/Option key on the keyboard"
        ]
    }, "Option"),
    metaKey: _nlsJs.localize({
        key: "cmdKey.long",
        comment: [
            "This is the long form for the Command key on the keyboard"
        ]
    }, "Command"),
    separator: "+"
}, {
    ctrlKey: _nlsJs.localize({
        key: "ctrlKey.long",
        comment: [
            "This is the long form for the Control key on the keyboard"
        ]
    }, "Control"),
    shiftKey: _nlsJs.localize({
        key: "shiftKey.long",
        comment: [
            "This is the long form for the Shift key on the keyboard"
        ]
    }, "Shift"),
    altKey: _nlsJs.localize({
        key: "altKey.long",
        comment: [
            "This is the long form for the Alt key on the keyboard"
        ]
    }, "Alt"),
    metaKey: _nlsJs.localize({
        key: "windowsKey.long",
        comment: [
            "This is the long form for the Windows key on the keyboard"
        ]
    }, "Windows"),
    separator: "+"
}, {
    ctrlKey: _nlsJs.localize({
        key: "ctrlKey.long",
        comment: [
            "This is the long form for the Control key on the keyboard"
        ]
    }, "Control"),
    shiftKey: _nlsJs.localize({
        key: "shiftKey.long",
        comment: [
            "This is the long form for the Shift key on the keyboard"
        ]
    }, "Shift"),
    altKey: _nlsJs.localize({
        key: "altKey.long",
        comment: [
            "This is the long form for the Alt key on the keyboard"
        ]
    }, "Alt"),
    metaKey: _nlsJs.localize({
        key: "superKey.long",
        comment: [
            "This is the long form for the Super key on the keyboard"
        ]
    }, "Super"),
    separator: "+"
});
const ElectronAcceleratorLabelProvider = new ModifierLabelProvider({
    ctrlKey: "Ctrl",
    shiftKey: "Shift",
    altKey: "Alt",
    metaKey: "Cmd",
    separator: "+"
}, {
    ctrlKey: "Ctrl",
    shiftKey: "Shift",
    altKey: "Alt",
    metaKey: "Super",
    separator: "+"
});
const UserSettingsLabelProvider = new ModifierLabelProvider({
    ctrlKey: "ctrl",
    shiftKey: "shift",
    altKey: "alt",
    metaKey: "cmd",
    separator: "+"
}, {
    ctrlKey: "ctrl",
    shiftKey: "shift",
    altKey: "alt",
    metaKey: "win",
    separator: "+"
}, {
    ctrlKey: "ctrl",
    shiftKey: "shift",
    altKey: "alt",
    metaKey: "meta",
    separator: "+"
});
function _simpleAsString(modifiers, key, labels) {
    if (key === null) return "";
    const result = [];
    // translate modifier keys: Ctrl-Shift-Alt-Meta
    if (modifiers.ctrlKey) result.push(labels.ctrlKey);
    if (modifiers.shiftKey) result.push(labels.shiftKey);
    if (modifiers.altKey) result.push(labels.altKey);
    if (modifiers.metaKey) result.push(labels.metaKey);
    // the actual key
    if (key !== "") result.push(key);
    return result.join(labels.separator);
}

},{"../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"esEqR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ILabelService", ()=>ILabelService);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const ILabelService = (0, _instantiationJs.createDecorator)("labelService");

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f49eD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IProgressService", ()=>IProgressService);
parcelHelpers.export(exports, "emptyProgressRunner", ()=>emptyProgressRunner);
parcelHelpers.export(exports, "Progress", ()=>Progress);
parcelHelpers.export(exports, "IEditorProgressService", ()=>IEditorProgressService);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IProgressService = (0, _instantiationJs.createDecorator)("progressService");
const emptyProgressRunner = Object.freeze({
    total () {},
    worked () {},
    done () {}
});
class Progress {
    static{
        this.None = Object.freeze({
            report () {}
        });
    }
    constructor(callback){
        this.callback = callback;
    }
    report(item) {
        this._value = item;
        this.callback(this._value);
    }
}
const IEditorProgressService = (0, _instantiationJs.createDecorator)("editorProgressService");

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"707vH":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IWorkspaceContextService", ()=>IWorkspaceContextService);
parcelHelpers.export(exports, "isSingleFolderWorkspaceIdentifier", ()=>isSingleFolderWorkspaceIdentifier);
parcelHelpers.export(exports, "isEmptyWorkspaceIdentifier", ()=>isEmptyWorkspaceIdentifier);
parcelHelpers.export(exports, "EXTENSION_DEVELOPMENT_EMPTY_WINDOW_WORKSPACE", ()=>EXTENSION_DEVELOPMENT_EMPTY_WINDOW_WORKSPACE);
parcelHelpers.export(exports, "UNKNOWN_EMPTY_WINDOW_WORKSPACE", ()=>UNKNOWN_EMPTY_WINDOW_WORKSPACE);
parcelHelpers.export(exports, "toWorkspaceIdentifier", ()=>toWorkspaceIdentifier);
parcelHelpers.export(exports, "isWorkspaceIdentifier", ()=>isWorkspaceIdentifier);
parcelHelpers.export(exports, "Workspace", ()=>Workspace);
parcelHelpers.export(exports, "WorkspaceFolder", ()=>WorkspaceFolder);
parcelHelpers.export(exports, "WORKSPACE_EXTENSION", ()=>WORKSPACE_EXTENSION);
parcelHelpers.export(exports, "WORKSPACE_FILTER", ()=>WORKSPACE_FILTER);
parcelHelpers.export(exports, "STANDALONE_EDITOR_WORKSPACE_ID", ()=>STANDALONE_EDITOR_WORKSPACE_ID);
parcelHelpers.export(exports, "isStandaloneEditorWorkspace", ()=>isStandaloneEditorWorkspace);
var _nlsJs = require("../../../nls.js");
var _pathJs = require("../../../base/common/path.js");
var _ternarySearchTreeJs = require("../../../base/common/ternarySearchTree.js");
var _uriJs = require("../../../base/common/uri.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IWorkspaceContextService = (0, _instantiationJs.createDecorator)("contextService");
function isSingleFolderWorkspaceIdentifier(obj) {
    const singleFolderIdentifier = obj;
    return typeof singleFolderIdentifier?.id === "string" && (0, _uriJs.URI).isUri(singleFolderIdentifier.uri);
}
function isEmptyWorkspaceIdentifier(obj) {
    const emptyWorkspaceIdentifier = obj;
    return typeof emptyWorkspaceIdentifier?.id === "string" && !isSingleFolderWorkspaceIdentifier(obj) && !isWorkspaceIdentifier(obj);
}
const EXTENSION_DEVELOPMENT_EMPTY_WINDOW_WORKSPACE = {
    id: "ext-dev"
};
const UNKNOWN_EMPTY_WINDOW_WORKSPACE = {
    id: "empty-window"
};
function toWorkspaceIdentifier(arg0, isExtensionDevelopment) {
    // Empty workspace
    if (typeof arg0 === "string" || typeof arg0 === "undefined") {
        // With a backupPath, the basename is the empty workspace identifier
        if (typeof arg0 === "string") return {
            id: (0, _pathJs.basename)(arg0)
        };
        // Extension development empty windows have backups disabled
        // so we return a constant workspace identifier for extension
        // authors to allow to restore their workspace state even then.
        if (isExtensionDevelopment) return EXTENSION_DEVELOPMENT_EMPTY_WINDOW_WORKSPACE;
        return UNKNOWN_EMPTY_WINDOW_WORKSPACE;
    }
    // Multi root
    const workspace = arg0;
    if (workspace.configuration) return {
        id: workspace.id,
        configPath: workspace.configuration
    };
    // Single folder
    if (workspace.folders.length === 1) return {
        id: workspace.id,
        uri: workspace.folders[0].uri
    };
    // Empty window
    return {
        id: workspace.id
    };
}
function isWorkspaceIdentifier(obj) {
    const workspaceIdentifier = obj;
    return typeof workspaceIdentifier?.id === "string" && (0, _uriJs.URI).isUri(workspaceIdentifier.configPath);
}
class Workspace {
    constructor(_id, folders, _transient, _configuration, _ignorePathCasing){
        this._id = _id;
        this._transient = _transient;
        this._configuration = _configuration;
        this._ignorePathCasing = _ignorePathCasing;
        this._foldersMap = (0, _ternarySearchTreeJs.TernarySearchTree).forUris(this._ignorePathCasing, ()=>true);
        this.folders = folders;
    }
    get folders() {
        return this._folders;
    }
    set folders(folders) {
        this._folders = folders;
        this.updateFoldersMap();
    }
    get id() {
        return this._id;
    }
    get transient() {
        return this._transient;
    }
    get configuration() {
        return this._configuration;
    }
    set configuration(configuration) {
        this._configuration = configuration;
    }
    getFolder(resource) {
        if (!resource) return null;
        return this._foldersMap.findSubstr(resource) || null;
    }
    updateFoldersMap() {
        this._foldersMap = (0, _ternarySearchTreeJs.TernarySearchTree).forUris(this._ignorePathCasing, ()=>true);
        for (const folder of this.folders)this._foldersMap.set(folder.uri, folder);
    }
    toJSON() {
        return {
            id: this.id,
            folders: this.folders,
            transient: this.transient,
            configuration: this.configuration
        };
    }
}
class WorkspaceFolder {
    constructor(data, /**
     * Provides access to the original metadata for this workspace
     * folder. This can be different from the metadata provided in
     * this class:
     * - raw paths can be relative
     * - raw paths are not normalized
     */ raw){
        this.raw = raw;
        this.uri = data.uri;
        this.index = data.index;
        this.name = data.name;
    }
    toJSON() {
        return {
            uri: this.uri,
            name: this.name,
            index: this.index
        };
    }
}
const WORKSPACE_EXTENSION = "code-workspace";
const WORKSPACE_FILTER = [
    {
        name: (0, _nlsJs.localize)("codeWorkspace", "Code Workspace"),
        extensions: [
            WORKSPACE_EXTENSION
        ]
    }
];
const STANDALONE_EDITOR_WORKSPACE_ID = "4064f6ec-cb38-4ad0-af64-ee6467e63c82";
function isStandaloneEditorWorkspace(workspace) {
    return workspace.id === STANDALONE_EDITOR_WORKSPACE_ID;
}

},{"../../../nls.js":"l617d","../../../base/common/path.js":"vyRKJ","../../../base/common/ternarySearchTree.js":"d54no","../../../base/common/uri.js":"7qGS3","../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d54no":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringIterator", ()=>StringIterator);
parcelHelpers.export(exports, "ConfigKeysIterator", ()=>ConfigKeysIterator);
parcelHelpers.export(exports, "PathIterator", ()=>PathIterator);
parcelHelpers.export(exports, "UriIterator", ()=>UriIterator);
parcelHelpers.export(exports, "TernarySearchTree", ()=>TernarySearchTree);
var _stringsJs = require("./strings.js");
class StringIterator {
    constructor(){
        this._value = "";
        this._pos = 0;
    }
    reset(key) {
        this._value = key;
        this._pos = 0;
        return this;
    }
    next() {
        this._pos += 1;
        return this;
    }
    hasNext() {
        return this._pos < this._value.length - 1;
    }
    cmp(a) {
        const aCode = a.charCodeAt(0);
        const thisCode = this._value.charCodeAt(this._pos);
        return aCode - thisCode;
    }
    value() {
        return this._value[this._pos];
    }
}
class ConfigKeysIterator {
    constructor(_caseSensitive = true){
        this._caseSensitive = _caseSensitive;
    }
    reset(key) {
        this._value = key;
        this._from = 0;
        this._to = 0;
        return this.next();
    }
    hasNext() {
        return this._to < this._value.length;
    }
    next() {
        // this._data = key.split(/[\\/]/).filter(s => !!s);
        this._from = this._to;
        let justSeps = true;
        for(; this._to < this._value.length; this._to++){
            const ch = this._value.charCodeAt(this._to);
            if (ch === 46 /* CharCode.Period */ ) {
                if (justSeps) this._from++;
                else break;
            } else justSeps = false;
        }
        return this;
    }
    cmp(a) {
        return this._caseSensitive ? (0, _stringsJs.compareSubstring)(a, this._value, 0, a.length, this._from, this._to) : (0, _stringsJs.compareSubstringIgnoreCase)(a, this._value, 0, a.length, this._from, this._to);
    }
    value() {
        return this._value.substring(this._from, this._to);
    }
}
class PathIterator {
    constructor(_splitOnBackslash = true, _caseSensitive = true){
        this._splitOnBackslash = _splitOnBackslash;
        this._caseSensitive = _caseSensitive;
    }
    reset(key) {
        this._from = 0;
        this._to = 0;
        this._value = key;
        this._valueLen = key.length;
        for(let pos = key.length - 1; pos >= 0; pos--, this._valueLen--){
            const ch = this._value.charCodeAt(pos);
            if (!(ch === 47 /* CharCode.Slash */  || this._splitOnBackslash && ch === 92 /* CharCode.Backslash */ )) break;
        }
        return this.next();
    }
    hasNext() {
        return this._to < this._valueLen;
    }
    next() {
        // this._data = key.split(/[\\/]/).filter(s => !!s);
        this._from = this._to;
        let justSeps = true;
        for(; this._to < this._valueLen; this._to++){
            const ch = this._value.charCodeAt(this._to);
            if (ch === 47 /* CharCode.Slash */  || this._splitOnBackslash && ch === 92 /* CharCode.Backslash */ ) {
                if (justSeps) this._from++;
                else break;
            } else justSeps = false;
        }
        return this;
    }
    cmp(a) {
        return this._caseSensitive ? (0, _stringsJs.compareSubstring)(a, this._value, 0, a.length, this._from, this._to) : (0, _stringsJs.compareSubstringIgnoreCase)(a, this._value, 0, a.length, this._from, this._to);
    }
    value() {
        return this._value.substring(this._from, this._to);
    }
}
class UriIterator {
    constructor(_ignorePathCasing, _ignoreQueryAndFragment){
        this._ignorePathCasing = _ignorePathCasing;
        this._ignoreQueryAndFragment = _ignoreQueryAndFragment;
        this._states = [];
        this._stateIdx = 0;
    }
    reset(key) {
        this._value = key;
        this._states = [];
        if (this._value.scheme) this._states.push(1 /* UriIteratorState.Scheme */ );
        if (this._value.authority) this._states.push(2 /* UriIteratorState.Authority */ );
        if (this._value.path) {
            this._pathIterator = new PathIterator(false, !this._ignorePathCasing(key));
            this._pathIterator.reset(key.path);
            if (this._pathIterator.value()) this._states.push(3 /* UriIteratorState.Path */ );
        }
        if (!this._ignoreQueryAndFragment(key)) {
            if (this._value.query) this._states.push(4 /* UriIteratorState.Query */ );
            if (this._value.fragment) this._states.push(5 /* UriIteratorState.Fragment */ );
        }
        this._stateIdx = 0;
        return this;
    }
    next() {
        if (this._states[this._stateIdx] === 3 /* UriIteratorState.Path */  && this._pathIterator.hasNext()) this._pathIterator.next();
        else this._stateIdx += 1;
        return this;
    }
    hasNext() {
        return this._states[this._stateIdx] === 3 /* UriIteratorState.Path */  && this._pathIterator.hasNext() || this._stateIdx < this._states.length - 1;
    }
    cmp(a) {
        if (this._states[this._stateIdx] === 1 /* UriIteratorState.Scheme */ ) return (0, _stringsJs.compareIgnoreCase)(a, this._value.scheme);
        else if (this._states[this._stateIdx] === 2 /* UriIteratorState.Authority */ ) return (0, _stringsJs.compareIgnoreCase)(a, this._value.authority);
        else if (this._states[this._stateIdx] === 3 /* UriIteratorState.Path */ ) return this._pathIterator.cmp(a);
        else if (this._states[this._stateIdx] === 4 /* UriIteratorState.Query */ ) return (0, _stringsJs.compare)(a, this._value.query);
        else if (this._states[this._stateIdx] === 5 /* UriIteratorState.Fragment */ ) return (0, _stringsJs.compare)(a, this._value.fragment);
        throw new Error();
    }
    value() {
        if (this._states[this._stateIdx] === 1 /* UriIteratorState.Scheme */ ) return this._value.scheme;
        else if (this._states[this._stateIdx] === 2 /* UriIteratorState.Authority */ ) return this._value.authority;
        else if (this._states[this._stateIdx] === 3 /* UriIteratorState.Path */ ) return this._pathIterator.value();
        else if (this._states[this._stateIdx] === 4 /* UriIteratorState.Query */ ) return this._value.query;
        else if (this._states[this._stateIdx] === 5 /* UriIteratorState.Fragment */ ) return this._value.fragment;
        throw new Error();
    }
}
class TernarySearchTreeNode {
    constructor(){
        this.height = 1;
    }
    rotateLeft() {
        const tmp = this.right;
        this.right = tmp.left;
        tmp.left = this;
        this.updateHeight();
        tmp.updateHeight();
        return tmp;
    }
    rotateRight() {
        const tmp = this.left;
        this.left = tmp.right;
        tmp.right = this;
        this.updateHeight();
        tmp.updateHeight();
        return tmp;
    }
    updateHeight() {
        this.height = 1 + Math.max(this.heightLeft, this.heightRight);
    }
    balanceFactor() {
        return this.heightRight - this.heightLeft;
    }
    get heightLeft() {
        return this.left?.height ?? 0;
    }
    get heightRight() {
        return this.right?.height ?? 0;
    }
}
class TernarySearchTree {
    static forUris(ignorePathCasing = ()=>false, ignoreQueryAndFragment = ()=>false) {
        return new TernarySearchTree(new UriIterator(ignorePathCasing, ignoreQueryAndFragment));
    }
    static forStrings() {
        return new TernarySearchTree(new StringIterator());
    }
    static forConfigKeys() {
        return new TernarySearchTree(new ConfigKeysIterator());
    }
    constructor(segments){
        this._iter = segments;
    }
    clear() {
        this._root = undefined;
    }
    set(key, element) {
        const iter = this._iter.reset(key);
        let node;
        if (!this._root) {
            this._root = new TernarySearchTreeNode();
            this._root.segment = iter.value();
        }
        const stack = [];
        // find insert_node
        node = this._root;
        while(true){
            const val = iter.cmp(node.segment);
            if (val > 0) {
                // left
                if (!node.left) {
                    node.left = new TernarySearchTreeNode();
                    node.left.segment = iter.value();
                }
                stack.push([
                    -1 /* Dir.Left */ ,
                    node
                ]);
                node = node.left;
            } else if (val < 0) {
                // right
                if (!node.right) {
                    node.right = new TernarySearchTreeNode();
                    node.right.segment = iter.value();
                }
                stack.push([
                    1 /* Dir.Right */ ,
                    node
                ]);
                node = node.right;
            } else if (iter.hasNext()) {
                // mid
                iter.next();
                if (!node.mid) {
                    node.mid = new TernarySearchTreeNode();
                    node.mid.segment = iter.value();
                }
                stack.push([
                    0 /* Dir.Mid */ ,
                    node
                ]);
                node = node.mid;
            } else break;
        }
        // set value
        const oldElement = node.value;
        node.value = element;
        node.key = key;
        // balance
        for(let i = stack.length - 1; i >= 0; i--){
            const node = stack[i][1];
            node.updateHeight();
            const bf = node.balanceFactor();
            if (bf < -1 || bf > 1) {
                // needs rotate
                const d1 = stack[i][0];
                const d2 = stack[i + 1][0];
                if (d1 === 1 /* Dir.Right */  && d2 === 1 /* Dir.Right */ ) //right, right -> rotate left
                stack[i][1] = node.rotateLeft();
                else if (d1 === -1 /* Dir.Left */  && d2 === -1 /* Dir.Left */ ) // left, left -> rotate right
                stack[i][1] = node.rotateRight();
                else if (d1 === 1 /* Dir.Right */  && d2 === -1 /* Dir.Left */ ) {
                    // right, left -> double rotate right, left
                    node.right = stack[i + 1][1] = stack[i + 1][1].rotateRight();
                    stack[i][1] = node.rotateLeft();
                } else if (d1 === -1 /* Dir.Left */  && d2 === 1 /* Dir.Right */ ) {
                    // left, right -> double rotate left, right
                    node.left = stack[i + 1][1] = stack[i + 1][1].rotateLeft();
                    stack[i][1] = node.rotateRight();
                } else throw new Error();
                // patch path to parent
                if (i > 0) switch(stack[i - 1][0]){
                    case -1 /* Dir.Left */ :
                        stack[i - 1][1].left = stack[i][1];
                        break;
                    case 1 /* Dir.Right */ :
                        stack[i - 1][1].right = stack[i][1];
                        break;
                    case 0 /* Dir.Mid */ :
                        stack[i - 1][1].mid = stack[i][1];
                        break;
                }
                else this._root = stack[0][1];
            }
        }
        return oldElement;
    }
    get(key) {
        return this._getNode(key)?.value;
    }
    _getNode(key) {
        const iter = this._iter.reset(key);
        let node = this._root;
        while(node){
            const val = iter.cmp(node.segment);
            if (val > 0) // left
            node = node.left;
            else if (val < 0) // right
            node = node.right;
            else if (iter.hasNext()) {
                // mid
                iter.next();
                node = node.mid;
            } else break;
        }
        return node;
    }
    has(key) {
        const node = this._getNode(key);
        return !(node?.value === undefined && node?.mid === undefined);
    }
    delete(key) {
        return this._delete(key, false);
    }
    deleteSuperstr(key) {
        return this._delete(key, true);
    }
    _delete(key, superStr) {
        const iter = this._iter.reset(key);
        const stack = [];
        let node = this._root;
        // find node
        while(node){
            const val = iter.cmp(node.segment);
            if (val > 0) {
                // left
                stack.push([
                    -1 /* Dir.Left */ ,
                    node
                ]);
                node = node.left;
            } else if (val < 0) {
                // right
                stack.push([
                    1 /* Dir.Right */ ,
                    node
                ]);
                node = node.right;
            } else if (iter.hasNext()) {
                // mid
                iter.next();
                stack.push([
                    0 /* Dir.Mid */ ,
                    node
                ]);
                node = node.mid;
            } else break;
        }
        if (!node) // node not found
        return;
        if (superStr) {
            // removing children, reset height
            node.left = undefined;
            node.mid = undefined;
            node.right = undefined;
            node.height = 1;
        } else {
            // removing element
            node.key = undefined;
            node.value = undefined;
        }
        // BST node removal
        if (!node.mid && !node.value) {
            if (node.left && node.right) {
                // full node
                // replace deleted-node with the min-node of the right branch.
                // If there is no true min-node leave things as they are
                const min = this._min(node.right);
                if (min.key) {
                    const { key, value, segment } = min;
                    this._delete(min.key, false);
                    node.key = key;
                    node.value = value;
                    node.segment = segment;
                }
            } else {
                // empty or half empty
                const newChild = node.left ?? node.right;
                if (stack.length > 0) {
                    const [dir, parent] = stack[stack.length - 1];
                    switch(dir){
                        case -1 /* Dir.Left */ :
                            parent.left = newChild;
                            break;
                        case 0 /* Dir.Mid */ :
                            parent.mid = newChild;
                            break;
                        case 1 /* Dir.Right */ :
                            parent.right = newChild;
                            break;
                    }
                } else this._root = newChild;
            }
        }
        // AVL balance
        for(let i = stack.length - 1; i >= 0; i--){
            const node = stack[i][1];
            node.updateHeight();
            const bf = node.balanceFactor();
            if (bf > 1) {
                // right heavy
                if (node.right.balanceFactor() >= 0) // right, right -> rotate left
                stack[i][1] = node.rotateLeft();
                else {
                    // right, left -> double rotate
                    node.right = node.right.rotateRight();
                    stack[i][1] = node.rotateLeft();
                }
            } else if (bf < -1) {
                // left heavy
                if (node.left.balanceFactor() <= 0) // left, left -> rotate right
                stack[i][1] = node.rotateRight();
                else {
                    // left, right -> double rotate
                    node.left = node.left.rotateLeft();
                    stack[i][1] = node.rotateRight();
                }
            }
            // patch path to parent
            if (i > 0) switch(stack[i - 1][0]){
                case -1 /* Dir.Left */ :
                    stack[i - 1][1].left = stack[i][1];
                    break;
                case 1 /* Dir.Right */ :
                    stack[i - 1][1].right = stack[i][1];
                    break;
                case 0 /* Dir.Mid */ :
                    stack[i - 1][1].mid = stack[i][1];
                    break;
            }
            else this._root = stack[0][1];
        }
    }
    _min(node) {
        while(node.left)node = node.left;
        return node;
    }
    findSubstr(key) {
        const iter = this._iter.reset(key);
        let node = this._root;
        let candidate = undefined;
        while(node){
            const val = iter.cmp(node.segment);
            if (val > 0) // left
            node = node.left;
            else if (val < 0) // right
            node = node.right;
            else if (iter.hasNext()) {
                // mid
                iter.next();
                candidate = node.value || candidate;
                node = node.mid;
            } else break;
        }
        return node && node.value || candidate;
    }
    findSuperstr(key) {
        return this._findSuperstrOrElement(key, false);
    }
    _findSuperstrOrElement(key, allowValue) {
        const iter = this._iter.reset(key);
        let node = this._root;
        while(node){
            const val = iter.cmp(node.segment);
            if (val > 0) // left
            node = node.left;
            else if (val < 0) // right
            node = node.right;
            else if (iter.hasNext()) {
                // mid
                iter.next();
                node = node.mid;
            } else {
                // collect
                if (!node.mid) {
                    if (allowValue) return node.value;
                    else return undefined;
                } else return this._entries(node.mid);
            }
        }
        return undefined;
    }
    forEach(callback) {
        for (const [key, value] of this)callback(value, key);
    }
    *[Symbol.iterator]() {
        yield* this._entries(this._root);
    }
    _entries(node) {
        const result = [];
        this._dfsEntries(node, result);
        return result[Symbol.iterator]();
    }
    _dfsEntries(node, bucket) {
        // DFS
        if (!node) return;
        if (node.left) this._dfsEntries(node.left, bucket);
        if (node.value) bucket.push([
            node.key,
            node.value
        ]);
        if (node.mid) this._dfsEntries(node.mid, bucket);
        if (node.right) this._dfsEntries(node.right, bucket);
    }
}

},{"./strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"D35dK":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InspectTokensNLS", ()=>InspectTokensNLS);
parcelHelpers.export(exports, "GoToLineNLS", ()=>GoToLineNLS);
parcelHelpers.export(exports, "QuickHelpNLS", ()=>QuickHelpNLS);
parcelHelpers.export(exports, "QuickCommandNLS", ()=>QuickCommandNLS);
parcelHelpers.export(exports, "QuickOutlineNLS", ()=>QuickOutlineNLS);
parcelHelpers.export(exports, "StandaloneCodeEditorNLS", ()=>StandaloneCodeEditorNLS);
parcelHelpers.export(exports, "ToggleHighContrastNLS", ()=>ToggleHighContrastNLS);
parcelHelpers.export(exports, "StandaloneServicesNLS", ()=>StandaloneServicesNLS);
var _nlsJs = require("../../nls.js");
var InspectTokensNLS;
(function(InspectTokensNLS) {
    InspectTokensNLS.inspectTokensAction = _nlsJs.localize("inspectTokens", "Developer: Inspect Tokens");
})(InspectTokensNLS || (InspectTokensNLS = {}));
var GoToLineNLS;
(function(GoToLineNLS) {
    GoToLineNLS.gotoLineActionLabel = _nlsJs.localize("gotoLineActionLabel", "Go to Line/Column...");
})(GoToLineNLS || (GoToLineNLS = {}));
var QuickHelpNLS;
(function(QuickHelpNLS) {
    QuickHelpNLS.helpQuickAccessActionLabel = _nlsJs.localize("helpQuickAccess", "Show all Quick Access Providers");
})(QuickHelpNLS || (QuickHelpNLS = {}));
var QuickCommandNLS;
(function(QuickCommandNLS) {
    QuickCommandNLS.quickCommandActionLabel = _nlsJs.localize("quickCommandActionLabel", "Command Palette");
    QuickCommandNLS.quickCommandHelp = _nlsJs.localize("quickCommandActionHelp", "Show And Run Commands");
})(QuickCommandNLS || (QuickCommandNLS = {}));
var QuickOutlineNLS;
(function(QuickOutlineNLS) {
    QuickOutlineNLS.quickOutlineActionLabel = _nlsJs.localize("quickOutlineActionLabel", "Go to Symbol...");
    QuickOutlineNLS.quickOutlineByCategoryActionLabel = _nlsJs.localize("quickOutlineByCategoryActionLabel", "Go to Symbol by Category...");
})(QuickOutlineNLS || (QuickOutlineNLS = {}));
var StandaloneCodeEditorNLS;
(function(StandaloneCodeEditorNLS) {
    StandaloneCodeEditorNLS.editorViewAccessibleLabel = _nlsJs.localize("editorViewAccessibleLabel", "Editor content");
})(StandaloneCodeEditorNLS || (StandaloneCodeEditorNLS = {}));
var ToggleHighContrastNLS;
(function(ToggleHighContrastNLS) {
    ToggleHighContrastNLS.toggleHighContrast = _nlsJs.localize("toggleHighContrast", "Toggle High Contrast Theme");
})(ToggleHighContrastNLS || (ToggleHighContrastNLS = {}));
var StandaloneServicesNLS;
(function(StandaloneServicesNLS) {
    StandaloneServicesNLS.bulkEditServiceSummary = _nlsJs.localize("bulkEditServiceSummary", "Made {0} edits in {1} files");
})(StandaloneServicesNLS || (StandaloneServicesNLS = {}));

},{"../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4R356":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IWorkspaceTrustManagementService", ()=>IWorkspaceTrustManagementService);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IWorkspaceTrustManagementService = (0, _instantiationJs.createDecorator)("workspaceTrustManagementService");

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8NPGN":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LanguageService", ()=>LanguageService);
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _languagesRegistryJs = require("./languagesRegistry.js");
var _arraysJs = require("../../../base/common/arrays.js");
var _languagesJs = require("../languages.js");
var _modesRegistryJs = require("../languages/modesRegistry.js");
var _observableJs = require("../../../base/common/observable.js");
class LanguageService extends (0, _lifecycleJs.Disposable) {
    static{
        this.instanceCount = 0;
    }
    constructor(warnOnOverwrite = false){
        super();
        this._onDidRequestBasicLanguageFeatures = this._register(new (0, _eventJs.Emitter)());
        this.onDidRequestBasicLanguageFeatures = this._onDidRequestBasicLanguageFeatures.event;
        this._onDidRequestRichLanguageFeatures = this._register(new (0, _eventJs.Emitter)());
        this.onDidRequestRichLanguageFeatures = this._onDidRequestRichLanguageFeatures.event;
        this._onDidChange = this._register(new (0, _eventJs.Emitter)({
            leakWarningThreshold: 200 /* https://github.com/microsoft/vscode/issues/119968 */ 
        }));
        this.onDidChange = this._onDidChange.event;
        this._requestedBasicLanguages = new Set();
        this._requestedRichLanguages = new Set();
        LanguageService.instanceCount++;
        this._registry = this._register(new (0, _languagesRegistryJs.LanguagesRegistry)(true, warnOnOverwrite));
        this.languageIdCodec = this._registry.languageIdCodec;
        this._register(this._registry.onDidChange(()=>this._onDidChange.fire()));
    }
    dispose() {
        LanguageService.instanceCount--;
        super.dispose();
    }
    isRegisteredLanguageId(languageId) {
        return this._registry.isRegisteredLanguageId(languageId);
    }
    getLanguageIdByLanguageName(languageName) {
        return this._registry.getLanguageIdByLanguageName(languageName);
    }
    getLanguageIdByMimeType(mimeType) {
        return this._registry.getLanguageIdByMimeType(mimeType);
    }
    guessLanguageIdByFilepathOrFirstLine(resource, firstLine) {
        const languageIds = this._registry.guessLanguageIdByFilepathOrFirstLine(resource, firstLine);
        return (0, _arraysJs.firstOrDefault)(languageIds, null);
    }
    createById(languageId) {
        return new LanguageSelection(this.onDidChange, ()=>{
            return this._createAndGetLanguageIdentifier(languageId);
        });
    }
    createByFilepathOrFirstLine(resource, firstLine) {
        return new LanguageSelection(this.onDidChange, ()=>{
            const languageId = this.guessLanguageIdByFilepathOrFirstLine(resource, firstLine);
            return this._createAndGetLanguageIdentifier(languageId);
        });
    }
    _createAndGetLanguageIdentifier(languageId) {
        if (!languageId || !this.isRegisteredLanguageId(languageId)) // Fall back to plain text if language is unknown
        languageId = (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID);
        return languageId;
    }
    requestBasicLanguageFeatures(languageId) {
        if (!this._requestedBasicLanguages.has(languageId)) {
            this._requestedBasicLanguages.add(languageId);
            this._onDidRequestBasicLanguageFeatures.fire(languageId);
        }
    }
    requestRichLanguageFeatures(languageId) {
        if (!this._requestedRichLanguages.has(languageId)) {
            this._requestedRichLanguages.add(languageId);
            // Ensure basic features are requested
            this.requestBasicLanguageFeatures(languageId);
            // Ensure tokenizers are created
            (0, _languagesJs.TokenizationRegistry).getOrCreate(languageId);
            this._onDidRequestRichLanguageFeatures.fire(languageId);
        }
    }
}
class LanguageSelection {
    constructor(onDidChangeLanguages, selector){
        this._value = (0, _observableJs.observableFromEvent)(this, onDidChangeLanguages, ()=>selector());
        this.onDidChange = (0, _eventJs.Event).fromObservable(this._value);
    }
    get languageId() {
        return this._value.get();
    }
}

},{"../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","./languagesRegistry.js":"fHyEp","../../../base/common/arrays.js":"DECei","../languages.js":"g5n96","../languages/modesRegistry.js":"gqkb7","../../../base/common/observable.js":"2xbG5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fHyEp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LanguageIdCodec", ()=>LanguageIdCodec);
parcelHelpers.export(exports, "LanguagesRegistry", ()=>LanguagesRegistry);
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _stringsJs = require("../../../base/common/strings.js");
var _languagesAssociationsJs = require("./languagesAssociations.js");
var _modesRegistryJs = require("../languages/modesRegistry.js");
var _configurationRegistryJs = require("../../../platform/configuration/common/configurationRegistry.js");
var _platformJs = require("../../../platform/registry/common/platform.js");
const hasOwnProperty = Object.prototype.hasOwnProperty;
const NULL_LANGUAGE_ID = "vs.editor.nullLanguage";
class LanguageIdCodec {
    constructor(){
        this._languageIdToLanguage = [];
        this._languageToLanguageId = new Map();
        this._register(NULL_LANGUAGE_ID, 0 /* LanguageId.Null */ );
        this._register((0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID), 1 /* LanguageId.PlainText */ );
        this._nextLanguageId = 2;
    }
    _register(language, languageId) {
        this._languageIdToLanguage[languageId] = language;
        this._languageToLanguageId.set(language, languageId);
    }
    register(language) {
        if (this._languageToLanguageId.has(language)) return;
        const languageId = this._nextLanguageId++;
        this._register(language, languageId);
    }
    encodeLanguageId(languageId) {
        return this._languageToLanguageId.get(languageId) || 0 /* LanguageId.Null */ ;
    }
    decodeLanguageId(languageId) {
        return this._languageIdToLanguage[languageId] || NULL_LANGUAGE_ID;
    }
}
class LanguagesRegistry extends (0, _lifecycleJs.Disposable) {
    static{
        this.instanceCount = 0;
    }
    constructor(useModesRegistry = true, warnOnOverwrite = false){
        super();
        this._onDidChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidChange = this._onDidChange.event;
        LanguagesRegistry.instanceCount++;
        this._warnOnOverwrite = warnOnOverwrite;
        this.languageIdCodec = new LanguageIdCodec();
        this._dynamicLanguages = [];
        this._languages = {};
        this._mimeTypesMap = {};
        this._nameMap = {};
        this._lowercaseNameMap = {};
        if (useModesRegistry) {
            this._initializeFromRegistry();
            this._register((0, _modesRegistryJs.ModesRegistry).onDidChangeLanguages((m)=>{
                this._initializeFromRegistry();
            }));
        }
    }
    dispose() {
        LanguagesRegistry.instanceCount--;
        super.dispose();
    }
    _initializeFromRegistry() {
        this._languages = {};
        this._mimeTypesMap = {};
        this._nameMap = {};
        this._lowercaseNameMap = {};
        (0, _languagesAssociationsJs.clearPlatformLanguageAssociations)();
        const desc = [].concat((0, _modesRegistryJs.ModesRegistry).getLanguages()).concat(this._dynamicLanguages);
        this._registerLanguages(desc);
    }
    _registerLanguages(desc) {
        for (const d of desc)this._registerLanguage(d);
        // Rebuild fast path maps
        this._mimeTypesMap = {};
        this._nameMap = {};
        this._lowercaseNameMap = {};
        Object.keys(this._languages).forEach((langId)=>{
            const language = this._languages[langId];
            if (language.name) this._nameMap[language.name] = language.identifier;
            language.aliases.forEach((alias)=>{
                this._lowercaseNameMap[alias.toLowerCase()] = language.identifier;
            });
            language.mimetypes.forEach((mimetype)=>{
                this._mimeTypesMap[mimetype] = language.identifier;
            });
        });
        (0, _platformJs.Registry).as((0, _configurationRegistryJs.Extensions).Configuration).registerOverrideIdentifiers(this.getRegisteredLanguageIds());
        this._onDidChange.fire();
    }
    _registerLanguage(lang) {
        const langId = lang.id;
        let resolvedLanguage;
        if (hasOwnProperty.call(this._languages, langId)) resolvedLanguage = this._languages[langId];
        else {
            this.languageIdCodec.register(langId);
            resolvedLanguage = {
                identifier: langId,
                name: null,
                mimetypes: [],
                aliases: [],
                extensions: [],
                filenames: [],
                configurationFiles: [],
                icons: []
            };
            this._languages[langId] = resolvedLanguage;
        }
        this._mergeLanguage(resolvedLanguage, lang);
    }
    _mergeLanguage(resolvedLanguage, lang) {
        const langId = lang.id;
        let primaryMime = null;
        if (Array.isArray(lang.mimetypes) && lang.mimetypes.length > 0) {
            resolvedLanguage.mimetypes.push(...lang.mimetypes);
            primaryMime = lang.mimetypes[0];
        }
        if (!primaryMime) {
            primaryMime = `text/x-${langId}`;
            resolvedLanguage.mimetypes.push(primaryMime);
        }
        if (Array.isArray(lang.extensions)) {
            if (lang.configuration) // insert first as this appears to be the 'primary' language definition
            resolvedLanguage.extensions = lang.extensions.concat(resolvedLanguage.extensions);
            else resolvedLanguage.extensions = resolvedLanguage.extensions.concat(lang.extensions);
            for (const extension of lang.extensions)(0, _languagesAssociationsJs.registerPlatformLanguageAssociation)({
                id: langId,
                mime: primaryMime,
                extension: extension
            }, this._warnOnOverwrite);
        }
        if (Array.isArray(lang.filenames)) for (const filename of lang.filenames){
            (0, _languagesAssociationsJs.registerPlatformLanguageAssociation)({
                id: langId,
                mime: primaryMime,
                filename: filename
            }, this._warnOnOverwrite);
            resolvedLanguage.filenames.push(filename);
        }
        if (Array.isArray(lang.filenamePatterns)) for (const filenamePattern of lang.filenamePatterns)(0, _languagesAssociationsJs.registerPlatformLanguageAssociation)({
            id: langId,
            mime: primaryMime,
            filepattern: filenamePattern
        }, this._warnOnOverwrite);
        if (typeof lang.firstLine === "string" && lang.firstLine.length > 0) {
            let firstLineRegexStr = lang.firstLine;
            if (firstLineRegexStr.charAt(0) !== "^") firstLineRegexStr = "^" + firstLineRegexStr;
            try {
                const firstLineRegex = new RegExp(firstLineRegexStr);
                if (!(0, _stringsJs.regExpLeadsToEndlessLoop)(firstLineRegex)) (0, _languagesAssociationsJs.registerPlatformLanguageAssociation)({
                    id: langId,
                    mime: primaryMime,
                    firstline: firstLineRegex
                }, this._warnOnOverwrite);
            } catch (err) {
                // Most likely, the regex was bad
                console.warn(`[${lang.id}]: Invalid regular expression \`${firstLineRegexStr}\`: `, err);
            }
        }
        resolvedLanguage.aliases.push(langId);
        let langAliases = null;
        if (typeof lang.aliases !== "undefined" && Array.isArray(lang.aliases)) {
            if (lang.aliases.length === 0) // signal that this language should not get a name
            langAliases = [
                null
            ];
            else langAliases = lang.aliases;
        }
        if (langAliases !== null) for (const langAlias of langAliases){
            if (!langAlias || langAlias.length === 0) continue;
            resolvedLanguage.aliases.push(langAlias);
        }
        const containsAliases = langAliases !== null && langAliases.length > 0;
        if (containsAliases && langAliases[0] === null) ;
        else {
            const bestName = (containsAliases ? langAliases[0] : null) || langId;
            if (containsAliases || !resolvedLanguage.name) resolvedLanguage.name = bestName;
        }
        if (lang.configuration) resolvedLanguage.configurationFiles.push(lang.configuration);
        if (lang.icon) resolvedLanguage.icons.push(lang.icon);
    }
    isRegisteredLanguageId(languageId) {
        if (!languageId) return false;
        return hasOwnProperty.call(this._languages, languageId);
    }
    getRegisteredLanguageIds() {
        return Object.keys(this._languages);
    }
    getLanguageIdByLanguageName(languageName) {
        const languageNameLower = languageName.toLowerCase();
        if (!hasOwnProperty.call(this._lowercaseNameMap, languageNameLower)) return null;
        return this._lowercaseNameMap[languageNameLower];
    }
    getLanguageIdByMimeType(mimeType) {
        if (!mimeType) return null;
        if (hasOwnProperty.call(this._mimeTypesMap, mimeType)) return this._mimeTypesMap[mimeType];
        return null;
    }
    guessLanguageIdByFilepathOrFirstLine(resource, firstLine) {
        if (!resource && !firstLine) return [];
        return (0, _languagesAssociationsJs.getLanguageIds)(resource, firstLine);
    }
}

},{"../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/strings.js":"aA9I1","./languagesAssociations.js":"17tE6","../languages/modesRegistry.js":"gqkb7","../../../platform/configuration/common/configurationRegistry.js":"6y4yB","../../../platform/registry/common/platform.js":"dzx11","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"17tE6":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Associate a language to the registry (platform).
 * * **NOTE**: This association will lose over associations registered using `registerConfiguredLanguageAssociation`.
 * * **NOTE**: Use `clearPlatformLanguageAssociations` to remove all associations registered using this function.
 */ parcelHelpers.export(exports, "registerPlatformLanguageAssociation", ()=>registerPlatformLanguageAssociation);
/**
 * Clear language associations from the registry (platform).
 */ parcelHelpers.export(exports, "clearPlatformLanguageAssociations", ()=>clearPlatformLanguageAssociations);
/**
 * @see `getMimeTypes`
 */ parcelHelpers.export(exports, "getLanguageIds", ()=>getLanguageIds);
var _globJs = require("../../../base/common/glob.js");
var _mimeJs = require("../../../base/common/mime.js");
var _networkJs = require("../../../base/common/network.js");
var _pathJs = require("../../../base/common/path.js");
var _resourcesJs = require("../../../base/common/resources.js");
var _stringsJs = require("../../../base/common/strings.js");
var _modesRegistryJs = require("../languages/modesRegistry.js");
let registeredAssociations = [];
let nonUserRegisteredAssociations = [];
let userRegisteredAssociations = [];
function registerPlatformLanguageAssociation(association, warnOnOverwrite = false) {
    _registerLanguageAssociation(association, false, warnOnOverwrite);
}
function _registerLanguageAssociation(association, userConfigured, warnOnOverwrite) {
    // Register
    const associationItem = toLanguageAssociationItem(association, userConfigured);
    registeredAssociations.push(associationItem);
    if (!associationItem.userConfigured) nonUserRegisteredAssociations.push(associationItem);
    else userRegisteredAssociations.push(associationItem);
    // Check for conflicts unless this is a user configured association
    if (warnOnOverwrite && !associationItem.userConfigured) registeredAssociations.forEach((a)=>{
        if (a.mime === associationItem.mime || a.userConfigured) return; // same mime or userConfigured is ok
        if (associationItem.extension && a.extension === associationItem.extension) console.warn(`Overwriting extension <<${associationItem.extension}>> to now point to mime <<${associationItem.mime}>>`);
        if (associationItem.filename && a.filename === associationItem.filename) console.warn(`Overwriting filename <<${associationItem.filename}>> to now point to mime <<${associationItem.mime}>>`);
        if (associationItem.filepattern && a.filepattern === associationItem.filepattern) console.warn(`Overwriting filepattern <<${associationItem.filepattern}>> to now point to mime <<${associationItem.mime}>>`);
        if (associationItem.firstline && a.firstline === associationItem.firstline) console.warn(`Overwriting firstline <<${associationItem.firstline}>> to now point to mime <<${associationItem.mime}>>`);
    });
}
function toLanguageAssociationItem(association, userConfigured) {
    return {
        id: association.id,
        mime: association.mime,
        filename: association.filename,
        extension: association.extension,
        filepattern: association.filepattern,
        firstline: association.firstline,
        userConfigured: userConfigured,
        filenameLowercase: association.filename ? association.filename.toLowerCase() : undefined,
        extensionLowercase: association.extension ? association.extension.toLowerCase() : undefined,
        filepatternLowercase: association.filepattern ? (0, _globJs.parse)(association.filepattern.toLowerCase()) : undefined,
        filepatternOnPath: association.filepattern ? association.filepattern.indexOf((0, _pathJs.posix).sep) >= 0 : false
    };
}
function clearPlatformLanguageAssociations() {
    registeredAssociations = registeredAssociations.filter((a)=>a.userConfigured);
    nonUserRegisteredAssociations = [];
}
function getLanguageIds(resource, firstLine) {
    return getAssociations(resource, firstLine).map((item)=>item.id);
}
function getAssociations(resource, firstLine) {
    let path;
    if (resource) switch(resource.scheme){
        case (0, _networkJs.Schemas).file:
            path = resource.fsPath;
            break;
        case (0, _networkJs.Schemas).data:
            {
                const metadata = (0, _resourcesJs.DataUri).parseMetaData(resource);
                path = metadata.get((0, _resourcesJs.DataUri).META_DATA_LABEL);
                break;
            }
        case (0, _networkJs.Schemas).vscodeNotebookCell:
            // File path not relevant for language detection of cell
            path = undefined;
            break;
        default:
            path = resource.path;
    }
    if (!path) return [
        {
            id: "unknown",
            mime: (0, _mimeJs.Mimes).unknown
        }
    ];
    path = path.toLowerCase();
    const filename = (0, _pathJs.basename)(path);
    // 1.) User configured mappings have highest priority
    const configuredLanguage = getAssociationByPath(path, filename, userRegisteredAssociations);
    if (configuredLanguage) return [
        configuredLanguage,
        {
            id: (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID),
            mime: (0, _mimeJs.Mimes).text
        }
    ];
    // 2.) Registered mappings have middle priority
    const registeredLanguage = getAssociationByPath(path, filename, nonUserRegisteredAssociations);
    if (registeredLanguage) return [
        registeredLanguage,
        {
            id: (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID),
            mime: (0, _mimeJs.Mimes).text
        }
    ];
    // 3.) Firstline has lowest priority
    if (firstLine) {
        const firstlineLanguage = getAssociationByFirstline(firstLine);
        if (firstlineLanguage) return [
            firstlineLanguage,
            {
                id: (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID),
                mime: (0, _mimeJs.Mimes).text
            }
        ];
    }
    return [
        {
            id: "unknown",
            mime: (0, _mimeJs.Mimes).unknown
        }
    ];
}
function getAssociationByPath(path, filename, associations) {
    let filenameMatch = undefined;
    let patternMatch = undefined;
    let extensionMatch = undefined;
    // We want to prioritize associations based on the order they are registered so that the last registered
    // association wins over all other. This is for https://github.com/microsoft/vscode/issues/20074
    for(let i = associations.length - 1; i >= 0; i--){
        const association = associations[i];
        // First exact name match
        if (filename === association.filenameLowercase) {
            filenameMatch = association;
            break; // take it!
        }
        // Longest pattern match
        if (association.filepattern) {
            if (!patternMatch || association.filepattern.length > patternMatch.filepattern.length) {
                const target = association.filepatternOnPath ? path : filename; // match on full path if pattern contains path separator
                if (association.filepatternLowercase?.(target)) patternMatch = association;
            }
        }
        // Longest extension match
        if (association.extension) {
            if (!extensionMatch || association.extension.length > extensionMatch.extension.length) {
                if (filename.endsWith(association.extensionLowercase)) extensionMatch = association;
            }
        }
    }
    // 1.) Exact name match has second highest priority
    if (filenameMatch) return filenameMatch;
    // 2.) Match on pattern
    if (patternMatch) return patternMatch;
    // 3.) Match on extension comes next
    if (extensionMatch) return extensionMatch;
    return undefined;
}
function getAssociationByFirstline(firstLine) {
    if ((0, _stringsJs.startsWithUTF8BOM)(firstLine)) firstLine = firstLine.substr(1);
    if (firstLine.length > 0) // We want to prioritize associations based on the order they are registered so that the last registered
    // association wins over all other. This is for https://github.com/microsoft/vscode/issues/20074
    for(let i = registeredAssociations.length - 1; i >= 0; i--){
        const association = registeredAssociations[i];
        if (!association.firstline) continue;
        const matches = firstLine.match(association.firstline);
        if (matches && matches.length > 0) return association;
    }
    return undefined;
}

},{"../../../base/common/glob.js":"gaB3X","../../../base/common/mime.js":"9CBNk","../../../base/common/network.js":"2c1AD","../../../base/common/path.js":"vyRKJ","../../../base/common/resources.js":"700EV","../../../base/common/strings.js":"aA9I1","../languages/modesRegistry.js":"gqkb7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2xbG5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observableValue", ()=>(0, _baseJs.observableValue));
parcelHelpers.export(exports, "disposableObservableValue", ()=>(0, _baseJs.disposableObservableValue));
parcelHelpers.export(exports, "transaction", ()=>(0, _baseJs.transaction));
parcelHelpers.export(exports, "subtransaction", ()=>(0, _baseJs.subtransaction));
parcelHelpers.export(exports, "derived", ()=>(0, _derivedJs.derived));
parcelHelpers.export(exports, "derivedOpts", ()=>(0, _derivedJs.derivedOpts));
parcelHelpers.export(exports, "derivedHandleChanges", ()=>(0, _derivedJs.derivedHandleChanges));
parcelHelpers.export(exports, "derivedWithStore", ()=>(0, _derivedJs.derivedWithStore));
parcelHelpers.export(exports, "autorun", ()=>(0, _autorunJs.autorun));
parcelHelpers.export(exports, "autorunHandleChanges", ()=>(0, _autorunJs.autorunHandleChanges));
parcelHelpers.export(exports, "autorunWithStore", ()=>(0, _autorunJs.autorunWithStore));
parcelHelpers.export(exports, "autorunOpts", ()=>(0, _autorunJs.autorunOpts));
parcelHelpers.export(exports, "autorunWithStoreHandleChanges", ()=>(0, _autorunJs.autorunWithStoreHandleChanges));
parcelHelpers.export(exports, "constObservable", ()=>(0, _utilsJs.constObservable));
parcelHelpers.export(exports, "derivedObservableWithCache", ()=>(0, _utilsJs.derivedObservableWithCache));
parcelHelpers.export(exports, "derivedObservableWithWritableCache", ()=>(0, _utilsJs.derivedObservableWithWritableCache));
parcelHelpers.export(exports, "keepObserved", ()=>(0, _utilsJs.keepObserved));
parcelHelpers.export(exports, "recomputeInitiallyAndOnChange", ()=>(0, _utilsJs.recomputeInitiallyAndOnChange));
parcelHelpers.export(exports, "observableFromEvent", ()=>(0, _utilsJs.observableFromEvent));
parcelHelpers.export(exports, "observableSignal", ()=>(0, _utilsJs.observableSignal));
parcelHelpers.export(exports, "observableSignalFromEvent", ()=>(0, _utilsJs.observableSignalFromEvent));
parcelHelpers.export(exports, "ObservablePromise", ()=>(0, _promiseJs.ObservablePromise));
parcelHelpers.export(exports, "PromiseResult", ()=>(0, _promiseJs.PromiseResult));
parcelHelpers.export(exports, "waitForState", ()=>(0, _promiseJs.waitForState));
parcelHelpers.export(exports, "observableValueOpts", ()=>(0, _apiJs.observableValueOpts));
var _baseJs = require("./observableInternal/base.js");
var _derivedJs = require("./observableInternal/derived.js");
var _autorunJs = require("./observableInternal/autorun.js");
var _utilsJs = require("./observableInternal/utils.js");
var _promiseJs = require("./observableInternal/promise.js");
var _apiJs = require("./observableInternal/api.js");
var _loggingJs = require("./observableInternal/logging.js");
// Remove "//" in the next line to enable logging
const enableLogging = false;
if (enableLogging) (0, _loggingJs.setLogger)(new (0, _loggingJs.ConsoleObservableLogger)());

},{"./observableInternal/base.js":"lYJZ2","./observableInternal/derived.js":"hZb5S","./observableInternal/autorun.js":"bvj7k","./observableInternal/utils.js":"4p38u","./observableInternal/promise.js":"dQv4n","./observableInternal/api.js":"bddbX","./observableInternal/logging.js":"eRYLp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lYJZ2":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_setRecomputeInitiallyAndOnChange", ()=>_setRecomputeInitiallyAndOnChange);
parcelHelpers.export(exports, "_setKeepObserved", ()=>_setKeepObserved);
/**
 * @internal
 * This is to allow splitting files.
*/ parcelHelpers.export(exports, "_setDerivedOpts", ()=>_setDerivedOpts);
parcelHelpers.export(exports, "ConvenientObservable", ()=>ConvenientObservable);
parcelHelpers.export(exports, "BaseObservable", ()=>BaseObservable);
/**
 * Starts a transaction in which many observables can be changed at once.
 * {@link fn} should start with a JS Doc using `@description` to give the transaction a debug name.
 * Reaction run on demand or when the transaction ends.
 */ parcelHelpers.export(exports, "transaction", ()=>transaction);
parcelHelpers.export(exports, "globalTransaction", ()=>globalTransaction);
parcelHelpers.export(exports, "asyncTransaction", ()=>asyncTransaction);
/**
 * Allows to chain transactions.
 */ parcelHelpers.export(exports, "subtransaction", ()=>subtransaction);
parcelHelpers.export(exports, "TransactionImpl", ()=>TransactionImpl);
parcelHelpers.export(exports, "observableValue", ()=>observableValue);
parcelHelpers.export(exports, "ObservableValue", ()=>ObservableValue);
/**
 * A disposable observable. When disposed, its value is also disposed.
 * When a new value is set, the previous value is disposed.
 */ parcelHelpers.export(exports, "disposableObservableValue", ()=>disposableObservableValue);
parcelHelpers.export(exports, "DisposableObservableValue", ()=>DisposableObservableValue);
var _equalsJs = require("../equals.js");
var _debugNameJs = require("./debugName.js");
var _loggingJs = require("./logging.js");
let _recomputeInitiallyAndOnChange;
function _setRecomputeInitiallyAndOnChange(recomputeInitiallyAndOnChange) {
    _recomputeInitiallyAndOnChange = recomputeInitiallyAndOnChange;
}
let _keepObserved;
function _setKeepObserved(keepObserved) {
    _keepObserved = keepObserved;
}
let _derived;
function _setDerivedOpts(derived) {
    _derived = derived;
}
class ConvenientObservable {
    get TChange() {
        return null;
    }
    reportChanges() {
        this.get();
    }
    /** @sealed */ read(reader) {
        if (reader) return reader.readObservable(this);
        else return this.get();
    }
    map(fnOrOwner, fnOrUndefined) {
        const owner = fnOrUndefined === undefined ? undefined : fnOrOwner;
        const fn = fnOrUndefined === undefined ? fnOrOwner : fnOrUndefined;
        return _derived({
            owner,
            debugName: ()=>{
                const name = (0, _debugNameJs.getFunctionName)(fn);
                if (name !== undefined) return name;
                // regexp to match `x => x.y` or `x => x?.y` where x and y can be arbitrary identifiers (uses backref):
                const regexp = /^\s*\(?\s*([a-zA-Z_$][a-zA-Z_$0-9]*)\s*\)?\s*=>\s*\1(?:\??)\.([a-zA-Z_$][a-zA-Z_$0-9]*)\s*$/;
                const match = regexp.exec(fn.toString());
                if (match) return `${this.debugName}.${match[2]}`;
                if (!owner) return `${this.debugName} (mapped)`;
                return undefined;
            },
            debugReferenceFn: fn
        }, (reader)=>fn(this.read(reader), reader));
    }
    /**
     * @sealed
     * Converts an observable of an observable value into a direct observable of the value.
    */ flatten() {
        return _derived({
            owner: undefined,
            debugName: ()=>`${this.debugName} (flattened)`
        }, (reader)=>this.read(reader).read(reader));
    }
    recomputeInitiallyAndOnChange(store, handleValue) {
        store.add(_recomputeInitiallyAndOnChange(this, handleValue));
        return this;
    }
    /**
     * Ensures that this observable is observed. This keeps the cache alive.
     * However, in case of deriveds, it does not force eager evaluation (only when the value is read/get).
     * Use `recomputeInitiallyAndOnChange` for eager evaluation.
     */ keepObserved(store) {
        store.add(_keepObserved(this));
        return this;
    }
}
class BaseObservable extends ConvenientObservable {
    constructor(){
        super(...arguments);
        this.observers = new Set();
    }
    addObserver(observer) {
        const len = this.observers.size;
        this.observers.add(observer);
        if (len === 0) this.onFirstObserverAdded();
    }
    removeObserver(observer) {
        const deleted = this.observers.delete(observer);
        if (deleted && this.observers.size === 0) this.onLastObserverRemoved();
    }
    onFirstObserverAdded() {}
    onLastObserverRemoved() {}
}
function transaction(fn, getDebugName) {
    const tx = new TransactionImpl(fn, getDebugName);
    try {
        fn(tx);
    } finally{
        tx.finish();
    }
}
let _globalTransaction = undefined;
function globalTransaction(fn) {
    if (_globalTransaction) fn(_globalTransaction);
    else {
        const tx = new TransactionImpl(fn, undefined);
        _globalTransaction = tx;
        try {
            fn(tx);
        } finally{
            tx.finish(); // During finish, more actions might be added to the transaction.
            // Which is why we only clear the global transaction after finish.
            _globalTransaction = undefined;
        }
    }
}
async function asyncTransaction(fn, getDebugName) {
    const tx = new TransactionImpl(fn, getDebugName);
    try {
        await fn(tx);
    } finally{
        tx.finish();
    }
}
function subtransaction(tx, fn, getDebugName) {
    if (!tx) transaction(fn, getDebugName);
    else fn(tx);
}
class TransactionImpl {
    constructor(_fn, _getDebugName){
        this._fn = _fn;
        this._getDebugName = _getDebugName;
        this.updatingObservers = [];
        (0, _loggingJs.getLogger)()?.handleBeginTransaction(this);
    }
    getDebugName() {
        if (this._getDebugName) return this._getDebugName();
        return (0, _debugNameJs.getFunctionName)(this._fn);
    }
    updateObserver(observer, observable) {
        // When this gets called while finish is active, they will still get considered
        this.updatingObservers.push({
            observer,
            observable
        });
        observer.beginUpdate(observable);
    }
    finish() {
        const updatingObservers = this.updatingObservers;
        for(let i = 0; i < updatingObservers.length; i++){
            const { observer, observable } = updatingObservers[i];
            observer.endUpdate(observable);
        }
        // Prevent anyone from updating observers from now on.
        this.updatingObservers = null;
        (0, _loggingJs.getLogger)()?.handleEndTransaction();
    }
}
function observableValue(nameOrOwner, initialValue) {
    let debugNameData;
    if (typeof nameOrOwner === "string") debugNameData = new (0, _debugNameJs.DebugNameData)(undefined, nameOrOwner, undefined);
    else debugNameData = new (0, _debugNameJs.DebugNameData)(nameOrOwner, undefined, undefined);
    return new ObservableValue(debugNameData, initialValue, (0, _equalsJs.strictEquals));
}
class ObservableValue extends BaseObservable {
    get debugName() {
        return this._debugNameData.getDebugName(this) ?? "ObservableValue";
    }
    constructor(_debugNameData, initialValue, _equalityComparator){
        super();
        this._debugNameData = _debugNameData;
        this._equalityComparator = _equalityComparator;
        this._value = initialValue;
    }
    get() {
        return this._value;
    }
    set(value, tx, change) {
        if (change === undefined && this._equalityComparator(this._value, value)) return;
        let _tx;
        if (!tx) tx = _tx = new TransactionImpl(()=>{}, ()=>`Setting ${this.debugName}`);
        try {
            const oldValue = this._value;
            this._setValue(value);
            (0, _loggingJs.getLogger)()?.handleObservableChanged(this, {
                oldValue,
                newValue: value,
                change,
                didChange: true,
                hadValue: true
            });
            for (const observer of this.observers){
                tx.updateObserver(observer, this);
                observer.handleChange(this, change);
            }
        } finally{
            if (_tx) _tx.finish();
        }
    }
    toString() {
        return `${this.debugName}: ${this._value}`;
    }
    _setValue(newValue) {
        this._value = newValue;
    }
}
function disposableObservableValue(nameOrOwner, initialValue) {
    let debugNameData;
    if (typeof nameOrOwner === "string") debugNameData = new (0, _debugNameJs.DebugNameData)(undefined, nameOrOwner, undefined);
    else debugNameData = new (0, _debugNameJs.DebugNameData)(nameOrOwner, undefined, undefined);
    return new DisposableObservableValue(debugNameData, initialValue, (0, _equalsJs.strictEquals));
}
class DisposableObservableValue extends ObservableValue {
    _setValue(newValue) {
        if (this._value === newValue) return;
        if (this._value) this._value.dispose();
        this._value = newValue;
    }
    dispose() {
        this._value?.dispose();
    }
}

},{"../equals.js":"8hes7","./debugName.js":"1zc3i","./logging.js":"eRYLp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8hes7":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "strictEquals", ()=>strictEquals);
/**
 * Checks if the items of two arrays are equal.
 * By default, strict equality is used to compare elements, but a custom equality comparer can be provided.
 */ parcelHelpers.export(exports, "itemsEquals", ()=>itemsEquals);
/**
 * Uses `item.equals(other)` to determine equality.
 */ parcelHelpers.export(exports, "itemEquals", ()=>itemEquals);
parcelHelpers.export(exports, "equalsIfDefined", ()=>equalsIfDefined);
/**
 * Drills into arrays (items ordered) and objects (keys unordered) and uses strict equality on everything else.
*/ parcelHelpers.export(exports, "structuralEquals", ()=>structuralEquals);
var _arraysJs = require("./arrays.js");
const strictEquals = (a, b)=>a === b;
function itemsEquals(itemEquals = strictEquals) {
    return (a, b)=>_arraysJs.equals(a, b, itemEquals);
}
function itemEquals() {
    return (a, b)=>a.equals(b);
}
function equalsIfDefined(equalsOrV1, v2, equals) {
    if (equals !== undefined) {
        const v1 = equalsOrV1;
        if (v1 === undefined || v1 === null || v2 === undefined || v2 === null) return v2 === v1;
        return equals(v1, v2);
    } else {
        const equals = equalsOrV1;
        return (v1, v2)=>{
            if (v1 === undefined || v1 === null || v2 === undefined || v2 === null) return v2 === v1;
            return equals(v1, v2);
        };
    }
}
function structuralEquals(a, b) {
    if (a === b) return true;
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!structuralEquals(a[i], b[i])) return false;
        }
        return true;
    }
    if (a && typeof a === "object" && b && typeof b === "object") {
        if (Object.getPrototypeOf(a) === Object.prototype && Object.getPrototypeOf(b) === Object.prototype) {
            const aObj = a;
            const bObj = b;
            const keysA = Object.keys(aObj);
            const keysB = Object.keys(bObj);
            const keysBSet = new Set(keysB);
            if (keysA.length !== keysB.length) return false;
            for (const key of keysA){
                if (!keysBSet.has(key)) return false;
                if (!structuralEquals(aObj[key], bObj[key])) return false;
            }
            return true;
        }
    }
    return false;
}
const objIds = new WeakMap();

},{"./arrays.js":"DECei","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1zc3i":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DebugNameData", ()=>DebugNameData);
parcelHelpers.export(exports, "getDebugName", ()=>getDebugName);
parcelHelpers.export(exports, "getFunctionName", ()=>getFunctionName);
class DebugNameData {
    constructor(owner, debugNameSource, referenceFn){
        this.owner = owner;
        this.debugNameSource = debugNameSource;
        this.referenceFn = referenceFn;
    }
    getDebugName(target) {
        return getDebugName(target, this);
    }
}
const countPerName = new Map();
const cachedDebugName = new WeakMap();
function getDebugName(target, data) {
    const cached = cachedDebugName.get(target);
    if (cached) return cached;
    const dbgName = computeDebugName(target, data);
    if (dbgName) {
        let count = countPerName.get(dbgName) ?? 0;
        count++;
        countPerName.set(dbgName, count);
        const result = count === 1 ? dbgName : `${dbgName}#${count}`;
        cachedDebugName.set(target, result);
        return result;
    }
    return undefined;
}
function computeDebugName(self, data) {
    const cached = cachedDebugName.get(self);
    if (cached) return cached;
    const ownerStr = data.owner ? formatOwner(data.owner) + `.` : "";
    let result;
    const debugNameSource = data.debugNameSource;
    if (debugNameSource !== undefined) {
        if (typeof debugNameSource === "function") {
            result = debugNameSource();
            if (result !== undefined) return ownerStr + result;
        } else return ownerStr + debugNameSource;
    }
    const referenceFn = data.referenceFn;
    if (referenceFn !== undefined) {
        result = getFunctionName(referenceFn);
        if (result !== undefined) return ownerStr + result;
    }
    if (data.owner !== undefined) {
        const key = findKey(data.owner, self);
        if (key !== undefined) return ownerStr + key;
    }
    return undefined;
}
function findKey(obj, value) {
    for(const key in obj){
        if (obj[key] === value) return key;
    }
    return undefined;
}
const countPerClassName = new Map();
const ownerId = new WeakMap();
function formatOwner(owner) {
    const id = ownerId.get(owner);
    if (id) return id;
    const className = getClassName(owner);
    let count = countPerClassName.get(className) ?? 0;
    count++;
    countPerClassName.set(className, count);
    const result = count === 1 ? className : `${className}#${count}`;
    ownerId.set(owner, result);
    return result;
}
function getClassName(obj) {
    const ctor = obj.constructor;
    if (ctor) return ctor.name;
    return "Object";
}
function getFunctionName(fn) {
    const fnSrc = fn.toString();
    // Pattern: /** @description ... */
    const regexp = /\/\*\*\s*@description\s*([^*]*)\*\//;
    const match = regexp.exec(fnSrc);
    const result = match ? match[1] : undefined;
    return result?.trim();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eRYLp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setLogger", ()=>setLogger);
parcelHelpers.export(exports, "getLogger", ()=>getLogger);
parcelHelpers.export(exports, "ConsoleObservableLogger", ()=>ConsoleObservableLogger);
let globalObservableLogger;
function setLogger(logger) {
    globalObservableLogger = logger;
}
function getLogger() {
    return globalObservableLogger;
}
class ConsoleObservableLogger {
    constructor(){
        this.indentation = 0;
        this.changedObservablesSets = new WeakMap();
    }
    textToConsoleArgs(text) {
        return consoleTextToArgs([
            normalText(repeat("|  ", this.indentation)),
            text
        ]);
    }
    formatInfo(info) {
        if (!info.hadValue) return [
            normalText(` `),
            styled(formatValue(info.newValue, 60), {
                color: "green"
            }),
            normalText(` (initial)`)
        ];
        return info.didChange ? [
            normalText(` `),
            styled(formatValue(info.oldValue, 70), {
                color: "red",
                strikeThrough: true
            }),
            normalText(` `),
            styled(formatValue(info.newValue, 60), {
                color: "green"
            })
        ] : [
            normalText(` (unchanged)`)
        ];
    }
    handleObservableChanged(observable, info) {
        console.log(...this.textToConsoleArgs([
            formatKind("observable value changed"),
            styled(observable.debugName, {
                color: "BlueViolet"
            }),
            ...this.formatInfo(info)
        ]));
    }
    formatChanges(changes) {
        if (changes.size === 0) return undefined;
        return styled(" (changed deps: " + [
            ...changes
        ].map((o)=>o.debugName).join(", ") + ")", {
            color: "gray"
        });
    }
    handleDerivedCreated(derived) {
        const existingHandleChange = derived.handleChange;
        this.changedObservablesSets.set(derived, new Set());
        derived.handleChange = (observable, change)=>{
            this.changedObservablesSets.get(derived).add(observable);
            return existingHandleChange.apply(derived, [
                observable,
                change
            ]);
        };
    }
    handleDerivedRecomputed(derived, info) {
        const changedObservables = this.changedObservablesSets.get(derived);
        console.log(...this.textToConsoleArgs([
            formatKind("derived recomputed"),
            styled(derived.debugName, {
                color: "BlueViolet"
            }),
            ...this.formatInfo(info),
            this.formatChanges(changedObservables),
            {
                data: [
                    {
                        fn: derived._debugNameData.referenceFn ?? derived._computeFn
                    }
                ]
            }
        ]));
        changedObservables.clear();
    }
    handleFromEventObservableTriggered(observable, info) {
        console.log(...this.textToConsoleArgs([
            formatKind("observable from event triggered"),
            styled(observable.debugName, {
                color: "BlueViolet"
            }),
            ...this.formatInfo(info),
            {
                data: [
                    {
                        fn: observable._getValue
                    }
                ]
            }
        ]));
    }
    handleAutorunCreated(autorun) {
        const existingHandleChange = autorun.handleChange;
        this.changedObservablesSets.set(autorun, new Set());
        autorun.handleChange = (observable, change)=>{
            this.changedObservablesSets.get(autorun).add(observable);
            return existingHandleChange.apply(autorun, [
                observable,
                change
            ]);
        };
    }
    handleAutorunTriggered(autorun) {
        const changedObservables = this.changedObservablesSets.get(autorun);
        console.log(...this.textToConsoleArgs([
            formatKind("autorun"),
            styled(autorun.debugName, {
                color: "BlueViolet"
            }),
            this.formatChanges(changedObservables),
            {
                data: [
                    {
                        fn: autorun._debugNameData.referenceFn ?? autorun._runFn
                    }
                ]
            }
        ]));
        changedObservables.clear();
        this.indentation++;
    }
    handleAutorunFinished(autorun) {
        this.indentation--;
    }
    handleBeginTransaction(transaction) {
        let transactionName = transaction.getDebugName();
        if (transactionName === undefined) transactionName = "";
        console.log(...this.textToConsoleArgs([
            formatKind("transaction"),
            styled(transactionName, {
                color: "BlueViolet"
            }),
            {
                data: [
                    {
                        fn: transaction._fn
                    }
                ]
            }
        ]));
        this.indentation++;
    }
    handleEndTransaction() {
        this.indentation--;
    }
}
function consoleTextToArgs(text) {
    const styles = new Array();
    const data = [];
    let firstArg = "";
    function process(t) {
        if ("length" in t) {
            for (const item of t)if (item) process(item);
        } else if ("text" in t) {
            firstArg += `%c${t.text}`;
            styles.push(t.style);
            if (t.data) data.push(...t.data);
        } else if ("data" in t) data.push(...t.data);
    }
    process(text);
    const result = [
        firstArg,
        ...styles
    ];
    result.push(...data);
    return result;
}
function normalText(text) {
    return styled(text, {
        color: "black"
    });
}
function formatKind(kind) {
    return styled(padStr(`${kind}: `, 10), {
        color: "black",
        bold: true
    });
}
function styled(text, options = {
    color: "black"
}) {
    function objToCss(styleObj) {
        return Object.entries(styleObj).reduce((styleString, [propName, propValue])=>{
            return `${styleString}${propName}:${propValue};`;
        }, "");
    }
    const style = {
        color: options.color
    };
    if (options.strikeThrough) style["text-decoration"] = "line-through";
    if (options.bold) style["font-weight"] = "bold";
    return {
        text,
        style: objToCss(style)
    };
}
function formatValue(value, availableLen) {
    switch(typeof value){
        case "number":
            return "" + value;
        case "string":
            if (value.length + 2 <= availableLen) return `"${value}"`;
            return `"${value.substr(0, availableLen - 7)}"+...`;
        case "boolean":
            return value ? "true" : "false";
        case "undefined":
            return "undefined";
        case "object":
            if (value === null) return "null";
            if (Array.isArray(value)) return formatArray(value, availableLen);
            return formatObject(value, availableLen);
        case "symbol":
            return value.toString();
        case "function":
            return `[[Function${value.name ? " " + value.name : ""}]]`;
        default:
            return "" + value;
    }
}
function formatArray(value, availableLen) {
    let result = "[ ";
    let first = true;
    for (const val of value){
        if (!first) result += ", ";
        if (result.length - 5 > availableLen) {
            result += "...";
            break;
        }
        first = false;
        result += `${formatValue(val, availableLen - result.length)}`;
    }
    result += " ]";
    return result;
}
function formatObject(value, availableLen) {
    let result = "{ ";
    let first = true;
    for (const [key, val] of Object.entries(value)){
        if (!first) result += ", ";
        if (result.length - 5 > availableLen) {
            result += "...";
            break;
        }
        first = false;
        result += `${key}: ${formatValue(val, availableLen - result.length)}`;
    }
    result += " }";
    return result;
}
function repeat(str, count) {
    let result = "";
    for(let i = 1; i <= count; i++)result += str;
    return result;
}
function padStr(str, length) {
    while(str.length < length)str += " ";
    return str;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hZb5S":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "derived", ()=>derived);
parcelHelpers.export(exports, "derivedWithSetter", ()=>derivedWithSetter);
parcelHelpers.export(exports, "derivedOpts", ()=>derivedOpts);
/**
 * Represents an observable that is derived from other observables.
 * The value is only recomputed when absolutely needed.
 *
 * {@link computeFn} should start with a JS Doc using `@description` to name the derived.
 *
 * Use `createEmptyChangeSummary` to create a "change summary" that can collect the changes.
 * Use `handleChange` to add a reported change to the change summary.
 * The compute function is given the last change summary.
 * The change summary is discarded after the compute function was called.
 *
 * @see derived
 */ parcelHelpers.export(exports, "derivedHandleChanges", ()=>derivedHandleChanges);
parcelHelpers.export(exports, "derivedWithStore", ()=>derivedWithStore);
parcelHelpers.export(exports, "derivedDisposable", ()=>derivedDisposable);
parcelHelpers.export(exports, "Derived", ()=>Derived);
parcelHelpers.export(exports, "DerivedWithSetter", ()=>DerivedWithSetter);
var _assertJs = require("../assert.js");
var _equalsJs = require("../equals.js");
var _lifecycleJs = require("../lifecycle.js");
var _baseJs = require("./base.js");
var _debugNameJs = require("./debugName.js");
var _loggingJs = require("./logging.js");
function derived(computeFnOrOwner, computeFn) {
    if (computeFn !== undefined) return new Derived(new (0, _debugNameJs.DebugNameData)(computeFnOrOwner, undefined, computeFn), computeFn, undefined, undefined, undefined, (0, _equalsJs.strictEquals));
    return new Derived(new (0, _debugNameJs.DebugNameData)(undefined, undefined, computeFnOrOwner), computeFnOrOwner, undefined, undefined, undefined, (0, _equalsJs.strictEquals));
}
function derivedWithSetter(owner, computeFn, setter) {
    return new DerivedWithSetter(new (0, _debugNameJs.DebugNameData)(owner, undefined, computeFn), computeFn, undefined, undefined, undefined, (0, _equalsJs.strictEquals), setter);
}
function derivedOpts(options, computeFn) {
    return new Derived(new (0, _debugNameJs.DebugNameData)(options.owner, options.debugName, options.debugReferenceFn), computeFn, undefined, undefined, options.onLastObserverRemoved, options.equalsFn ?? (0, _equalsJs.strictEquals));
}
(0, _baseJs._setDerivedOpts)(derivedOpts);
function derivedHandleChanges(options, computeFn) {
    return new Derived(new (0, _debugNameJs.DebugNameData)(options.owner, options.debugName, undefined), computeFn, options.createEmptyChangeSummary, options.handleChange, undefined, options.equalityComparer ?? (0, _equalsJs.strictEquals));
}
function derivedWithStore(computeFnOrOwner, computeFnOrUndefined) {
    let computeFn;
    let owner;
    if (computeFnOrUndefined === undefined) {
        computeFn = computeFnOrOwner;
        owner = undefined;
    } else {
        owner = computeFnOrOwner;
        computeFn = computeFnOrUndefined;
    }
    const store = new (0, _lifecycleJs.DisposableStore)();
    return new Derived(new (0, _debugNameJs.DebugNameData)(owner, undefined, computeFn), (r)=>{
        store.clear();
        return computeFn(r, store);
    }, undefined, undefined, ()=>store.dispose(), (0, _equalsJs.strictEquals));
}
function derivedDisposable(computeFnOrOwner, computeFnOrUndefined) {
    let computeFn;
    let owner;
    if (computeFnOrUndefined === undefined) {
        computeFn = computeFnOrOwner;
        owner = undefined;
    } else {
        owner = computeFnOrOwner;
        computeFn = computeFnOrUndefined;
    }
    let store = undefined;
    return new Derived(new (0, _debugNameJs.DebugNameData)(owner, undefined, computeFn), (r)=>{
        if (!store) store = new (0, _lifecycleJs.DisposableStore)();
        else store.clear();
        const result = computeFn(r);
        if (result) store.add(result);
        return result;
    }, undefined, undefined, ()=>{
        if (store) {
            store.dispose();
            store = undefined;
        }
    }, (0, _equalsJs.strictEquals));
}
class Derived extends (0, _baseJs.BaseObservable) {
    get debugName() {
        return this._debugNameData.getDebugName(this) ?? "(anonymous)";
    }
    constructor(_debugNameData, _computeFn, createChangeSummary, _handleChange, _handleLastObserverRemoved, _equalityComparator){
        super();
        this._debugNameData = _debugNameData;
        this._computeFn = _computeFn;
        this.createChangeSummary = createChangeSummary;
        this._handleChange = _handleChange;
        this._handleLastObserverRemoved = _handleLastObserverRemoved;
        this._equalityComparator = _equalityComparator;
        this.state = 0 /* DerivedState.initial */ ;
        this.value = undefined;
        this.updateCount = 0;
        this.dependencies = new Set();
        this.dependenciesToBeRemoved = new Set();
        this.changeSummary = undefined;
        this.changeSummary = this.createChangeSummary?.();
        (0, _loggingJs.getLogger)()?.handleDerivedCreated(this);
    }
    onLastObserverRemoved() {
        /**
         * We are not tracking changes anymore, thus we have to assume
         * that our cache is invalid.
         */ this.state = 0 /* DerivedState.initial */ ;
        this.value = undefined;
        for (const d of this.dependencies)d.removeObserver(this);
        this.dependencies.clear();
        this._handleLastObserverRemoved?.();
    }
    get() {
        if (this.observers.size === 0) {
            // Without observers, we don't know when to clean up stuff.
            // Thus, we don't cache anything to prevent memory leaks.
            const result = this._computeFn(this, this.createChangeSummary?.());
            // Clear new dependencies
            this.onLastObserverRemoved();
            return result;
        } else {
            do {
                // We might not get a notification for a dependency that changed while it is updating,
                // thus we also have to ask all our depedencies if they changed in this case.
                if (this.state === 1 /* DerivedState.dependenciesMightHaveChanged */ ) for (const d of this.dependencies){
                    /** might call {@link handleChange} indirectly, which could make us stale */ d.reportChanges();
                    if (this.state === 2 /* DerivedState.stale */ ) break;
                }
                // We called report changes of all dependencies.
                // If we are still not stale, we can assume to be up to date again.
                if (this.state === 1 /* DerivedState.dependenciesMightHaveChanged */ ) this.state = 3 /* DerivedState.upToDate */ ;
                this._recomputeIfNeeded();
            // In case recomputation changed one of our dependencies, we need to recompute again.
            }while (this.state !== 3 /* DerivedState.upToDate */ );
            return this.value;
        }
    }
    _recomputeIfNeeded() {
        if (this.state === 3 /* DerivedState.upToDate */ ) return;
        const emptySet = this.dependenciesToBeRemoved;
        this.dependenciesToBeRemoved = this.dependencies;
        this.dependencies = emptySet;
        const hadValue = this.state !== 0 /* DerivedState.initial */ ;
        const oldValue = this.value;
        this.state = 3 /* DerivedState.upToDate */ ;
        const changeSummary = this.changeSummary;
        this.changeSummary = this.createChangeSummary?.();
        try {
            /** might call {@link handleChange} indirectly, which could invalidate us */ this.value = this._computeFn(this, changeSummary);
        } finally{
            // We don't want our observed observables to think that they are (not even temporarily) not being observed.
            // Thus, we only unsubscribe from observables that are definitely not read anymore.
            for (const o of this.dependenciesToBeRemoved)o.removeObserver(this);
            this.dependenciesToBeRemoved.clear();
        }
        const didChange = hadValue && !this._equalityComparator(oldValue, this.value);
        (0, _loggingJs.getLogger)()?.handleDerivedRecomputed(this, {
            oldValue,
            newValue: this.value,
            change: undefined,
            didChange,
            hadValue
        });
        if (didChange) for (const r of this.observers)r.handleChange(this, undefined);
    }
    toString() {
        return `LazyDerived<${this.debugName}>`;
    }
    // IObserver Implementation
    beginUpdate(_observable) {
        this.updateCount++;
        const propagateBeginUpdate = this.updateCount === 1;
        if (this.state === 3 /* DerivedState.upToDate */ ) {
            this.state = 1 /* DerivedState.dependenciesMightHaveChanged */ ;
            // If we propagate begin update, that will already signal a possible change.
            if (!propagateBeginUpdate) for (const r of this.observers)r.handlePossibleChange(this);
        }
        if (propagateBeginUpdate) for (const r of this.observers)r.beginUpdate(this); // This signals a possible change
    }
    endUpdate(_observable) {
        this.updateCount--;
        if (this.updateCount === 0) {
            // End update could change the observer list.
            const observers = [
                ...this.observers
            ];
            for (const r of observers)r.endUpdate(this);
        }
        (0, _assertJs.assertFn)(()=>this.updateCount >= 0);
    }
    handlePossibleChange(observable) {
        // In all other states, observers already know that we might have changed.
        if (this.state === 3 /* DerivedState.upToDate */  && this.dependencies.has(observable) && !this.dependenciesToBeRemoved.has(observable)) {
            this.state = 1 /* DerivedState.dependenciesMightHaveChanged */ ;
            for (const r of this.observers)r.handlePossibleChange(this);
        }
    }
    handleChange(observable, change) {
        if (this.dependencies.has(observable) && !this.dependenciesToBeRemoved.has(observable)) {
            const shouldReact = this._handleChange ? this._handleChange({
                changedObservable: observable,
                change,
                didChange: (o)=>o === observable
            }, this.changeSummary) : true;
            const wasUpToDate = this.state === 3 /* DerivedState.upToDate */ ;
            if (shouldReact && (this.state === 1 /* DerivedState.dependenciesMightHaveChanged */  || wasUpToDate)) {
                this.state = 2 /* DerivedState.stale */ ;
                if (wasUpToDate) for (const r of this.observers)r.handlePossibleChange(this);
            }
        }
    }
    // IReader Implementation
    readObservable(observable) {
        // Subscribe before getting the value to enable caching
        observable.addObserver(this);
        /** This might call {@link handleChange} indirectly, which could invalidate us */ const value = observable.get();
        // Which is why we only add the observable to the dependencies now.
        this.dependencies.add(observable);
        this.dependenciesToBeRemoved.delete(observable);
        return value;
    }
    addObserver(observer) {
        const shouldCallBeginUpdate = !this.observers.has(observer) && this.updateCount > 0;
        super.addObserver(observer);
        if (shouldCallBeginUpdate) observer.beginUpdate(this);
    }
    removeObserver(observer) {
        const shouldCallEndUpdate = this.observers.has(observer) && this.updateCount > 0;
        super.removeObserver(observer);
        if (shouldCallEndUpdate) // Calling end update after removing the observer makes sure endUpdate cannot be called twice here.
        observer.endUpdate(this);
    }
}
class DerivedWithSetter extends Derived {
    constructor(debugNameData, computeFn, createChangeSummary, handleChange, handleLastObserverRemoved, equalityComparator, set){
        super(debugNameData, computeFn, createChangeSummary, handleChange, handleLastObserverRemoved, equalityComparator);
        this.set = set;
    }
}

},{"../assert.js":"1nPIE","../equals.js":"8hes7","../lifecycle.js":"9kg8d","./base.js":"lYJZ2","./debugName.js":"1zc3i","./logging.js":"eRYLp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bvj7k":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Runs immediately and whenever a transaction ends and an observed observable changed.
 * {@link fn} should start with a JS Doc using `@description` to name the autorun.
 */ parcelHelpers.export(exports, "autorun", ()=>autorun);
/**
 * Runs immediately and whenever a transaction ends and an observed observable changed.
 * {@link fn} should start with a JS Doc using `@description` to name the autorun.
 */ parcelHelpers.export(exports, "autorunOpts", ()=>autorunOpts);
/**
 * Runs immediately and whenever a transaction ends and an observed observable changed.
 * {@link fn} should start with a JS Doc using `@description` to name the autorun.
 *
 * Use `createEmptyChangeSummary` to create a "change summary" that can collect the changes.
 * Use `handleChange` to add a reported change to the change summary.
 * The run function is given the last change summary.
 * The change summary is discarded after the run function was called.
 *
 * @see autorun
 */ parcelHelpers.export(exports, "autorunHandleChanges", ()=>autorunHandleChanges);
/**
 * @see autorunHandleChanges (but with a disposable store that is cleared before the next run or on dispose)
 */ parcelHelpers.export(exports, "autorunWithStoreHandleChanges", ()=>autorunWithStoreHandleChanges);
/**
 * @see autorun (but with a disposable store that is cleared before the next run or on dispose)
 */ parcelHelpers.export(exports, "autorunWithStore", ()=>autorunWithStore);
parcelHelpers.export(exports, "AutorunObserver", ()=>AutorunObserver);
var _assertJs = require("../assert.js");
var _lifecycleJs = require("../lifecycle.js");
var _debugNameJs = require("./debugName.js");
var _loggingJs = require("./logging.js");
function autorun(fn) {
    return new AutorunObserver(new (0, _debugNameJs.DebugNameData)(undefined, undefined, fn), fn, undefined, undefined);
}
function autorunOpts(options, fn) {
    return new AutorunObserver(new (0, _debugNameJs.DebugNameData)(options.owner, options.debugName, options.debugReferenceFn ?? fn), fn, undefined, undefined);
}
function autorunHandleChanges(options, fn) {
    return new AutorunObserver(new (0, _debugNameJs.DebugNameData)(options.owner, options.debugName, options.debugReferenceFn ?? fn), fn, options.createEmptyChangeSummary, options.handleChange);
}
function autorunWithStoreHandleChanges(options, fn) {
    const store = new (0, _lifecycleJs.DisposableStore)();
    const disposable = autorunHandleChanges({
        owner: options.owner,
        debugName: options.debugName,
        debugReferenceFn: options.debugReferenceFn ?? fn,
        createEmptyChangeSummary: options.createEmptyChangeSummary,
        handleChange: options.handleChange
    }, (reader, changeSummary)=>{
        store.clear();
        fn(reader, changeSummary, store);
    });
    return (0, _lifecycleJs.toDisposable)(()=>{
        disposable.dispose();
        store.dispose();
    });
}
function autorunWithStore(fn) {
    const store = new (0, _lifecycleJs.DisposableStore)();
    const disposable = autorunOpts({
        owner: undefined,
        debugName: undefined,
        debugReferenceFn: fn
    }, (reader)=>{
        store.clear();
        fn(reader, store);
    });
    return (0, _lifecycleJs.toDisposable)(()=>{
        disposable.dispose();
        store.dispose();
    });
}
class AutorunObserver {
    get debugName() {
        return this._debugNameData.getDebugName(this) ?? "(anonymous)";
    }
    constructor(_debugNameData, _runFn, createChangeSummary, _handleChange){
        this._debugNameData = _debugNameData;
        this._runFn = _runFn;
        this.createChangeSummary = createChangeSummary;
        this._handleChange = _handleChange;
        this.state = 2 /* AutorunState.stale */ ;
        this.updateCount = 0;
        this.disposed = false;
        this.dependencies = new Set();
        this.dependenciesToBeRemoved = new Set();
        this.changeSummary = this.createChangeSummary?.();
        (0, _loggingJs.getLogger)()?.handleAutorunCreated(this);
        this._runIfNeeded();
        (0, _lifecycleJs.trackDisposable)(this);
    }
    dispose() {
        this.disposed = true;
        for (const o of this.dependencies)o.removeObserver(this);
        this.dependencies.clear();
        (0, _lifecycleJs.markAsDisposed)(this);
    }
    _runIfNeeded() {
        if (this.state === 3 /* AutorunState.upToDate */ ) return;
        const emptySet = this.dependenciesToBeRemoved;
        this.dependenciesToBeRemoved = this.dependencies;
        this.dependencies = emptySet;
        this.state = 3 /* AutorunState.upToDate */ ;
        const isDisposed = this.disposed;
        try {
            if (!isDisposed) {
                (0, _loggingJs.getLogger)()?.handleAutorunTriggered(this);
                const changeSummary = this.changeSummary;
                this.changeSummary = this.createChangeSummary?.();
                this._runFn(this, changeSummary);
            }
        } finally{
            if (!isDisposed) (0, _loggingJs.getLogger)()?.handleAutorunFinished(this);
            // We don't want our observed observables to think that they are (not even temporarily) not being observed.
            // Thus, we only unsubscribe from observables that are definitely not read anymore.
            for (const o of this.dependenciesToBeRemoved)o.removeObserver(this);
            this.dependenciesToBeRemoved.clear();
        }
    }
    toString() {
        return `Autorun<${this.debugName}>`;
    }
    // IObserver implementation
    beginUpdate() {
        if (this.state === 3 /* AutorunState.upToDate */ ) this.state = 1 /* AutorunState.dependenciesMightHaveChanged */ ;
        this.updateCount++;
    }
    endUpdate() {
        if (this.updateCount === 1) do {
            if (this.state === 1 /* AutorunState.dependenciesMightHaveChanged */ ) {
                this.state = 3 /* AutorunState.upToDate */ ;
                for (const d of this.dependencies){
                    d.reportChanges();
                    if (this.state === 2 /* AutorunState.stale */ ) break;
                }
            }
            this._runIfNeeded();
        }while (this.state !== 3 /* AutorunState.upToDate */ );
        this.updateCount--;
        (0, _assertJs.assertFn)(()=>this.updateCount >= 0);
    }
    handlePossibleChange(observable) {
        if (this.state === 3 /* AutorunState.upToDate */  && this.dependencies.has(observable) && !this.dependenciesToBeRemoved.has(observable)) this.state = 1 /* AutorunState.dependenciesMightHaveChanged */ ;
    }
    handleChange(observable, change) {
        if (this.dependencies.has(observable) && !this.dependenciesToBeRemoved.has(observable)) {
            const shouldReact = this._handleChange ? this._handleChange({
                changedObservable: observable,
                change,
                didChange: (o)=>o === observable
            }, this.changeSummary) : true;
            if (shouldReact) this.state = 2 /* AutorunState.stale */ ;
        }
    }
    // IReader implementation
    readObservable(observable) {
        // In case the run action disposes the autorun
        if (this.disposed) return observable.get();
        observable.addObserver(this);
        const value = observable.get();
        this.dependencies.add(observable);
        this.dependenciesToBeRemoved.delete(observable);
        return value;
    }
}
(function(autorun) {
    autorun.Observer = AutorunObserver;
})(autorun || (autorun = {}));

},{"../assert.js":"1nPIE","../lifecycle.js":"9kg8d","./debugName.js":"1zc3i","./logging.js":"eRYLp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4p38u":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents an efficient observable whose value never changes.
 */ parcelHelpers.export(exports, "constObservable", ()=>constObservable);
parcelHelpers.export(exports, "observableFromEvent", ()=>observableFromEvent);
parcelHelpers.export(exports, "observableFromEventOpts", ()=>observableFromEventOpts);
parcelHelpers.export(exports, "FromEventObservable", ()=>FromEventObservable);
parcelHelpers.export(exports, "observableSignalFromEvent", ()=>observableSignalFromEvent);
parcelHelpers.export(exports, "observableSignal", ()=>observableSignal);
/**
 * This makes sure the observable is being observed and keeps its cache alive.
 */ parcelHelpers.export(exports, "keepObserved", ()=>keepObserved);
/**
 * This converts the given observable into an autorun.
 */ parcelHelpers.export(exports, "recomputeInitiallyAndOnChange", ()=>recomputeInitiallyAndOnChange);
parcelHelpers.export(exports, "KeepAliveObserver", ()=>KeepAliveObserver);
parcelHelpers.export(exports, "derivedObservableWithCache", ()=>derivedObservableWithCache);
parcelHelpers.export(exports, "derivedObservableWithWritableCache", ()=>derivedObservableWithWritableCache);
/**
 * When the items array changes, referential equal items are not mapped again.
 */ parcelHelpers.export(exports, "mapObservableArrayCached", ()=>mapObservableArrayCached);
parcelHelpers.export(exports, "ValueWithChangeEventFromObservable", ()=>ValueWithChangeEventFromObservable);
parcelHelpers.export(exports, "observableFromValueWithChangeEvent", ()=>observableFromValueWithChangeEvent);
/**
 * Works like a derived.
 * However, if the value is not undefined, it is cached and will not be recomputed anymore.
 * In that case, the derived will unsubscribe from its dependencies.
*/ parcelHelpers.export(exports, "derivedConstOnceDefined", ()=>derivedConstOnceDefined);
var _eventJs = require("../event.js");
var _lifecycleJs = require("../lifecycle.js");
var _baseJs = require("./base.js");
var _debugNameJs = require("./debugName.js");
var _derivedJs = require("./derived.js");
var _loggingJs = require("./logging.js");
var _equalsJs = require("../equals.js");
function constObservable(value) {
    return new ConstObservable(value);
}
class ConstObservable extends (0, _baseJs.ConvenientObservable) {
    constructor(value){
        super();
        this.value = value;
    }
    get debugName() {
        return this.toString();
    }
    get() {
        return this.value;
    }
    addObserver(observer) {
    // NO OP
    }
    removeObserver(observer) {
    // NO OP
    }
    toString() {
        return `Const: ${this.value}`;
    }
}
function observableFromEvent(...args) {
    let owner;
    let event;
    let getValue;
    if (args.length === 3) [owner, event, getValue] = args;
    else [event, getValue] = args;
    return new FromEventObservable(new (0, _debugNameJs.DebugNameData)(owner, undefined, getValue), event, getValue, ()=>FromEventObservable.globalTransaction, (0, _equalsJs.strictEquals));
}
function observableFromEventOpts(options, event, getValue) {
    return new FromEventObservable(new (0, _debugNameJs.DebugNameData)(options.owner, options.debugName, options.debugReferenceFn ?? getValue), event, getValue, ()=>FromEventObservable.globalTransaction, options.equalsFn ?? (0, _equalsJs.strictEquals));
}
class FromEventObservable extends (0, _baseJs.BaseObservable) {
    constructor(_debugNameData, event, _getValue, _getTransaction, _equalityComparator){
        super();
        this._debugNameData = _debugNameData;
        this.event = event;
        this._getValue = _getValue;
        this._getTransaction = _getTransaction;
        this._equalityComparator = _equalityComparator;
        this.hasValue = false;
        this.handleEvent = (args)=>{
            const newValue = this._getValue(args);
            const oldValue = this.value;
            const didChange = !this.hasValue || !this._equalityComparator(oldValue, newValue);
            let didRunTransaction = false;
            if (didChange) {
                this.value = newValue;
                if (this.hasValue) {
                    didRunTransaction = true;
                    (0, _baseJs.subtransaction)(this._getTransaction(), (tx)=>{
                        (0, _loggingJs.getLogger)()?.handleFromEventObservableTriggered(this, {
                            oldValue,
                            newValue,
                            change: undefined,
                            didChange,
                            hadValue: this.hasValue
                        });
                        for (const o of this.observers){
                            tx.updateObserver(o, this);
                            o.handleChange(this, undefined);
                        }
                    }, ()=>{
                        const name = this.getDebugName();
                        return "Event fired" + (name ? `: ${name}` : "");
                    });
                }
                this.hasValue = true;
            }
            if (!didRunTransaction) (0, _loggingJs.getLogger)()?.handleFromEventObservableTriggered(this, {
                oldValue,
                newValue,
                change: undefined,
                didChange,
                hadValue: this.hasValue
            });
        };
    }
    getDebugName() {
        return this._debugNameData.getDebugName(this);
    }
    get debugName() {
        const name = this.getDebugName();
        return "From Event" + (name ? `: ${name}` : "");
    }
    onFirstObserverAdded() {
        this.subscription = this.event(this.handleEvent);
    }
    onLastObserverRemoved() {
        this.subscription.dispose();
        this.subscription = undefined;
        this.hasValue = false;
        this.value = undefined;
    }
    get() {
        if (this.subscription) {
            if (!this.hasValue) this.handleEvent(undefined);
            return this.value;
        } else {
            // no cache, as there are no subscribers to keep it updated
            const value = this._getValue(undefined);
            return value;
        }
    }
}
(function(observableFromEvent) {
    observableFromEvent.Observer = FromEventObservable;
    function batchEventsGlobally(tx, fn) {
        let didSet = false;
        if (FromEventObservable.globalTransaction === undefined) {
            FromEventObservable.globalTransaction = tx;
            didSet = true;
        }
        try {
            fn();
        } finally{
            if (didSet) FromEventObservable.globalTransaction = undefined;
        }
    }
    observableFromEvent.batchEventsGlobally = batchEventsGlobally;
})(observableFromEvent || (observableFromEvent = {}));
function observableSignalFromEvent(debugName, event) {
    return new FromEventObservableSignal(debugName, event);
}
class FromEventObservableSignal extends (0, _baseJs.BaseObservable) {
    constructor(debugName, event){
        super();
        this.debugName = debugName;
        this.event = event;
        this.handleEvent = ()=>{
            (0, _baseJs.transaction)((tx)=>{
                for (const o of this.observers){
                    tx.updateObserver(o, this);
                    o.handleChange(this, undefined);
                }
            }, ()=>this.debugName);
        };
    }
    onFirstObserverAdded() {
        this.subscription = this.event(this.handleEvent);
    }
    onLastObserverRemoved() {
        this.subscription.dispose();
        this.subscription = undefined;
    }
    get() {
    // NO OP
    }
}
function observableSignal(debugNameOrOwner) {
    if (typeof debugNameOrOwner === "string") return new ObservableSignal(debugNameOrOwner);
    else return new ObservableSignal(undefined, debugNameOrOwner);
}
class ObservableSignal extends (0, _baseJs.BaseObservable) {
    get debugName() {
        return new (0, _debugNameJs.DebugNameData)(this._owner, this._debugName, undefined).getDebugName(this) ?? "Observable Signal";
    }
    toString() {
        return this.debugName;
    }
    constructor(_debugName, _owner){
        super();
        this._debugName = _debugName;
        this._owner = _owner;
    }
    trigger(tx, change) {
        if (!tx) {
            (0, _baseJs.transaction)((tx)=>{
                this.trigger(tx, change);
            }, ()=>`Trigger signal ${this.debugName}`);
            return;
        }
        for (const o of this.observers){
            tx.updateObserver(o, this);
            o.handleChange(this, change);
        }
    }
    get() {
    // NO OP
    }
}
function keepObserved(observable) {
    const o = new KeepAliveObserver(false, undefined);
    observable.addObserver(o);
    return (0, _lifecycleJs.toDisposable)(()=>{
        observable.removeObserver(o);
    });
}
(0, _baseJs._setKeepObserved)(keepObserved);
function recomputeInitiallyAndOnChange(observable, handleValue) {
    const o = new KeepAliveObserver(true, handleValue);
    observable.addObserver(o);
    if (handleValue) handleValue(observable.get());
    else observable.reportChanges();
    return (0, _lifecycleJs.toDisposable)(()=>{
        observable.removeObserver(o);
    });
}
(0, _baseJs._setRecomputeInitiallyAndOnChange)(recomputeInitiallyAndOnChange);
class KeepAliveObserver {
    constructor(_forceRecompute, _handleValue){
        this._forceRecompute = _forceRecompute;
        this._handleValue = _handleValue;
        this._counter = 0;
    }
    beginUpdate(observable) {
        this._counter++;
    }
    endUpdate(observable) {
        this._counter--;
        if (this._counter === 0 && this._forceRecompute) {
            if (this._handleValue) this._handleValue(observable.get());
            else observable.reportChanges();
        }
    }
    handlePossibleChange(observable) {
    // NO OP
    }
    handleChange(observable, change) {
    // NO OP
    }
}
function derivedObservableWithCache(owner, computeFn) {
    let lastValue = undefined;
    const observable = (0, _derivedJs.derivedOpts)({
        owner,
        debugReferenceFn: computeFn
    }, (reader)=>{
        lastValue = computeFn(reader, lastValue);
        return lastValue;
    });
    return observable;
}
function derivedObservableWithWritableCache(owner, computeFn) {
    let lastValue = undefined;
    const onChange = observableSignal("derivedObservableWithWritableCache");
    const observable = (0, _derivedJs.derived)(owner, (reader)=>{
        onChange.read(reader);
        lastValue = computeFn(reader, lastValue);
        return lastValue;
    });
    return Object.assign(observable, {
        clearCache: (tx)=>{
            lastValue = undefined;
            onChange.trigger(tx);
        },
        setCache: (newValue, tx)=>{
            lastValue = newValue;
            onChange.trigger(tx);
        }
    });
}
function mapObservableArrayCached(owner, items, map, keySelector) {
    let m = new ArrayMap(map, keySelector);
    const self = (0, _derivedJs.derivedOpts)({
        debugReferenceFn: map,
        owner,
        onLastObserverRemoved: ()=>{
            m.dispose();
            m = new ArrayMap(map);
        }
    }, (reader)=>{
        m.setItems(items.read(reader));
        return m.getItems();
    });
    return self;
}
class ArrayMap {
    constructor(_map, _keySelector){
        this._map = _map;
        this._keySelector = _keySelector;
        this._cache = new Map();
        this._items = [];
    }
    dispose() {
        this._cache.forEach((entry)=>entry.store.dispose());
        this._cache.clear();
    }
    setItems(items) {
        const newItems = [];
        const itemsToRemove = new Set(this._cache.keys());
        for (const item of items){
            const key = this._keySelector ? this._keySelector(item) : item;
            let entry = this._cache.get(key);
            if (!entry) {
                const store = new (0, _lifecycleJs.DisposableStore)();
                const out = this._map(item, store);
                entry = {
                    out,
                    store
                };
                this._cache.set(key, entry);
            } else itemsToRemove.delete(key);
            newItems.push(entry.out);
        }
        for (const item of itemsToRemove){
            const entry = this._cache.get(item);
            entry.store.dispose();
            this._cache.delete(item);
        }
        this._items = newItems;
    }
    getItems() {
        return this._items;
    }
}
class ValueWithChangeEventFromObservable {
    constructor(observable){
        this.observable = observable;
    }
    get onDidChange() {
        return (0, _eventJs.Event).fromObservableLight(this.observable);
    }
    get value() {
        return this.observable.get();
    }
}
function observableFromValueWithChangeEvent(owner, value) {
    if (value instanceof ValueWithChangeEventFromObservable) return value.observable;
    return observableFromEvent(owner, value.onDidChange, ()=>value.value);
}
function derivedConstOnceDefined(owner, fn) {
    return derivedObservableWithCache(owner, (reader, lastValue)=>lastValue ?? fn(reader));
}

},{"../event.js":"4Zi8b","../lifecycle.js":"9kg8d","./base.js":"lYJZ2","./debugName.js":"1zc3i","./derived.js":"hZb5S","./logging.js":"eRYLp","../equals.js":"8hes7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dQv4n":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A promise whose state is observable.
 */ parcelHelpers.export(exports, "ObservablePromise", ()=>ObservablePromise);
parcelHelpers.export(exports, "PromiseResult", ()=>PromiseResult);
parcelHelpers.export(exports, "waitForState", ()=>waitForState);
var _autorunJs = require("./autorun.js");
var _baseJs = require("./base.js");
var _errorsJs = require("../errors.js");
class ObservablePromise {
    static fromFn(fn) {
        return new ObservablePromise(fn());
    }
    constructor(promise){
        this._value = (0, _baseJs.observableValue)(this, undefined);
        /**
         * The current state of the promise.
         * Is `undefined` if the promise didn't resolve yet.
         */ this.promiseResult = this._value;
        this.promise = promise.then((value)=>{
            (0, _baseJs.transaction)((tx)=>{
                /** @description onPromiseResolved */ this._value.set(new PromiseResult(value, undefined), tx);
            });
            return value;
        }, (error)=>{
            (0, _baseJs.transaction)((tx)=>{
                /** @description onPromiseRejected */ this._value.set(new PromiseResult(undefined, error), tx);
            });
            throw error;
        });
    }
}
class PromiseResult {
    constructor(/**
     * The value of the resolved promise.
     * Undefined if the promise rejected.
     */ data, /**
     * The error in case of a rejected promise.
     * Undefined if the promise resolved.
     */ error){
        this.data = data;
        this.error = error;
    }
}
function waitForState(observable, predicate, isError, cancellationToken) {
    if (!predicate) predicate = (state)=>state !== null && state !== undefined;
    return new Promise((resolve, reject)=>{
        let isImmediateRun = true;
        let shouldDispose = false;
        const stateObs = observable.map((state)=>{
            /** @description waitForState.state */ return {
                isFinished: predicate(state),
                error: isError ? isError(state) : false,
                state
            };
        });
        const d = (0, _autorunJs.autorun)((reader)=>{
            /** @description waitForState */ const { isFinished, error, state } = stateObs.read(reader);
            if (isFinished || error) {
                if (isImmediateRun) // The variable `d` is not initialized yet
                shouldDispose = true;
                else d.dispose();
                if (error) reject(error === true ? state : error);
                else resolve(state);
            }
        });
        if (cancellationToken) {
            const dc = cancellationToken.onCancellationRequested(()=>{
                d.dispose();
                dc.dispose();
                reject(new (0, _errorsJs.CancellationError)());
            });
            if (cancellationToken.isCancellationRequested) {
                d.dispose();
                dc.dispose();
                reject(new (0, _errorsJs.CancellationError)());
                return;
            }
        }
        isImmediateRun = false;
        if (shouldDispose) d.dispose();
    });
}

},{"./autorun.js":"bvj7k","./base.js":"lYJZ2","../errors.js":"divX8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bddbX":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observableValueOpts", ()=>observableValueOpts);
var _equalsJs = require("../equals.js");
var _baseJs = require("./base.js");
var _debugNameJs = require("./debugName.js");
var _lazyObservableValueJs = require("./lazyObservableValue.js");
function observableValueOpts(options, initialValue) {
    if (options.lazy) return new (0, _lazyObservableValueJs.LazyObservableValue)(new (0, _debugNameJs.DebugNameData)(options.owner, options.debugName, undefined), initialValue, options.equalsFn ?? (0, _equalsJs.strictEquals));
    return new (0, _baseJs.ObservableValue)(new (0, _debugNameJs.DebugNameData)(options.owner, options.debugName, undefined), initialValue, options.equalsFn ?? (0, _equalsJs.strictEquals));
}

},{"../equals.js":"8hes7","./base.js":"lYJZ2","./debugName.js":"1zc3i","./lazyObservableValue.js":"lRpKT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lRpKT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Holds off updating observers until the value is actually read.
*/ parcelHelpers.export(exports, "LazyObservableValue", ()=>LazyObservableValue);
var _baseJs = require("./base.js");
class LazyObservableValue extends (0, _baseJs.BaseObservable) {
    get debugName() {
        return this._debugNameData.getDebugName(this) ?? "LazyObservableValue";
    }
    constructor(_debugNameData, initialValue, _equalityComparator){
        super();
        this._debugNameData = _debugNameData;
        this._equalityComparator = _equalityComparator;
        this._isUpToDate = true;
        this._deltas = [];
        this._updateCounter = 0;
        this._value = initialValue;
    }
    get() {
        this._update();
        return this._value;
    }
    _update() {
        if (this._isUpToDate) return;
        this._isUpToDate = true;
        if (this._deltas.length > 0) {
            for (const observer of this.observers)for (const change of this._deltas)observer.handleChange(this, change);
            this._deltas.length = 0;
        } else for (const observer of this.observers)observer.handleChange(this, undefined);
    }
    _beginUpdate() {
        this._updateCounter++;
        if (this._updateCounter === 1) for (const observer of this.observers)observer.beginUpdate(this);
    }
    _endUpdate() {
        this._updateCounter--;
        if (this._updateCounter === 0) {
            this._update();
            // End update could change the observer list.
            const observers = [
                ...this.observers
            ];
            for (const r of observers)r.endUpdate(this);
        }
    }
    addObserver(observer) {
        const shouldCallBeginUpdate = !this.observers.has(observer) && this._updateCounter > 0;
        super.addObserver(observer);
        if (shouldCallBeginUpdate) observer.beginUpdate(this);
    }
    removeObserver(observer) {
        const shouldCallEndUpdate = this.observers.has(observer) && this._updateCounter > 0;
        super.removeObserver(observer);
        if (shouldCallEndUpdate) // Calling end update after removing the observer makes sure endUpdate cannot be called twice here.
        observer.endUpdate(this);
    }
    set(value, tx, change) {
        if (change === undefined && this._equalityComparator(this._value, value)) return;
        let _tx;
        if (!tx) tx = _tx = new (0, _baseJs.TransactionImpl)(()=>{}, ()=>`Setting ${this.debugName}`);
        try {
            this._isUpToDate = false;
            this._setValue(value);
            if (change !== undefined) this._deltas.push(change);
            tx.updateObserver({
                beginUpdate: ()=>this._beginUpdate(),
                endUpdate: ()=>this._endUpdate(),
                handleChange: (observable, change)=>{},
                handlePossibleChange: (observable)=>{}
            }, this);
            if (this._updateCounter > 1) // We already started begin/end update, so we need to manually call handlePossibleChange
            for (const observer of this.observers)observer.handlePossibleChange(this);
        } finally{
            if (_tx) _tx.finish();
        }
    }
    toString() {
        return `${this.debugName}: ${this._value}`;
    }
    _setValue(newValue) {
        this._value = newValue;
    }
}

},{"./base.js":"lYJZ2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Y5Vr":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextMenuService", ()=>ContextMenuService);
parcelHelpers.export(exports, "ContextMenuMenuDelegate", ()=>ContextMenuMenuDelegate);
var _domJs = require("../../../base/browser/dom.js");
var _actionsJs = require("../../../base/common/actions.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _menuEntryActionViewItemJs = require("../../actions/browser/menuEntryActionViewItem.js");
var _actionsJs1 = require("../../actions/common/actions.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _keybindingJs = require("../../keybinding/common/keybinding.js");
var _notificationJs = require("../../notification/common/notification.js");
var _telemetryJs = require("../../telemetry/common/telemetry.js");
var _contextMenuHandlerJs = require("./contextMenuHandler.js");
var _contextViewJs = require("./contextView.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let ContextMenuService = class ContextMenuService extends (0, _lifecycleJs.Disposable) {
    get contextMenuHandler() {
        if (!this._contextMenuHandler) this._contextMenuHandler = new (0, _contextMenuHandlerJs.ContextMenuHandler)(this.contextViewService, this.telemetryService, this.notificationService, this.keybindingService);
        return this._contextMenuHandler;
    }
    constructor(telemetryService, notificationService, contextViewService, keybindingService, menuService, contextKeyService){
        super();
        this.telemetryService = telemetryService;
        this.notificationService = notificationService;
        this.contextViewService = contextViewService;
        this.keybindingService = keybindingService;
        this.menuService = menuService;
        this.contextKeyService = contextKeyService;
        this._contextMenuHandler = undefined;
        this._onDidShowContextMenu = this._store.add(new (0, _eventJs.Emitter)());
        this.onDidShowContextMenu = this._onDidShowContextMenu.event;
        this._onDidHideContextMenu = this._store.add(new (0, _eventJs.Emitter)());
    }
    configure(options) {
        this.contextMenuHandler.configure(options);
    }
    // ContextMenu
    showContextMenu(delegate) {
        delegate = ContextMenuMenuDelegate.transform(delegate, this.menuService, this.contextKeyService);
        this.contextMenuHandler.showContextMenu({
            ...delegate,
            onHide: (didCancel)=>{
                delegate.onHide?.(didCancel);
                this._onDidHideContextMenu.fire();
            }
        });
        (0, _domJs.ModifierKeyEmitter).getInstance().resetKeyStatus();
        this._onDidShowContextMenu.fire();
    }
};
ContextMenuService = __decorate([
    __param(0, (0, _telemetryJs.ITelemetryService)),
    __param(1, (0, _notificationJs.INotificationService)),
    __param(2, (0, _contextViewJs.IContextViewService)),
    __param(3, (0, _keybindingJs.IKeybindingService)),
    __param(4, (0, _actionsJs1.IMenuService)),
    __param(5, (0, _contextkeyJs.IContextKeyService))
], ContextMenuService);
var ContextMenuMenuDelegate;
(function(ContextMenuMenuDelegate) {
    function is(thing) {
        return thing && thing.menuId instanceof (0, _actionsJs1.MenuId);
    }
    function transform(delegate, menuService, globalContextKeyService) {
        if (!is(delegate)) return delegate;
        const { menuId, menuActionOptions, contextKeyService } = delegate;
        return {
            ...delegate,
            getActions: ()=>{
                const target = [];
                if (menuId) {
                    const menu = menuService.getMenuActions(menuId, contextKeyService ?? globalContextKeyService, menuActionOptions);
                    (0, _menuEntryActionViewItemJs.createAndFillInContextMenuActions)(menu, target);
                }
                if (!delegate.getActions) return target;
                else return (0, _actionsJs.Separator).join(delegate.getActions(), target);
            }
        };
    }
    ContextMenuMenuDelegate.transform = transform;
})(ContextMenuMenuDelegate || (ContextMenuMenuDelegate = {}));

},{"../../../base/browser/dom.js":"bnqsM","../../../base/common/actions.js":"5GjLb","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../actions/browser/menuEntryActionViewItem.js":"evssn","../../actions/common/actions.js":"kyMtp","../../contextkey/common/contextkey.js":"gXuBD","../../keybinding/common/keybinding.js":"25pLT","../../notification/common/notification.js":"igv0W","../../telemetry/common/telemetry.js":"7vW8j","./contextMenuHandler.js":"hrTjq","./contextView.js":"2QlUR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"evssn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAndFillInContextMenuActions", ()=>createAndFillInContextMenuActions);
parcelHelpers.export(exports, "createAndFillInActionBarActions", ()=>createAndFillInActionBarActions);
parcelHelpers.export(exports, "MenuEntryActionViewItem", ()=>MenuEntryActionViewItem);
parcelHelpers.export(exports, "TextOnlyMenuEntryActionViewItem", ()=>TextOnlyMenuEntryActionViewItem);
parcelHelpers.export(exports, "SubmenuEntryActionViewItem", ()=>SubmenuEntryActionViewItem);
parcelHelpers.export(exports, "DropdownWithDefaultActionViewItem", ()=>DropdownWithDefaultActionViewItem);
/**
 * Creates action view items for menu actions or submenu actions.
 */ parcelHelpers.export(exports, "createActionViewItem", ()=>createActionViewItem);
var _domJs = require("../../../base/browser/dom.js");
var _keyboardEventJs = require("../../../base/browser/keyboardEvent.js");
var _actionViewItemsJs = require("../../../base/browser/ui/actionbar/actionViewItems.js");
var _dropdownActionViewItemJs = require("../../../base/browser/ui/dropdown/dropdownActionViewItem.js");
var _actionsJs = require("../../../base/common/actions.js");
var _keybindingLabelsJs = require("../../../base/common/keybindingLabels.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _platformJs = require("../../../base/common/platform.js");
var _menuEntryActionViewItemCss = require("./menuEntryActionViewItem.css");
var _nlsJs = require("../../../nls.js");
var _actionsJs1 = require("../common/actions.js");
var _actionJs = require("../../action/common/action.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _contextViewJs = require("../../contextview/browser/contextView.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var _keybindingJs = require("../../keybinding/common/keybinding.js");
var _notificationJs = require("../../notification/common/notification.js");
var _storageJs = require("../../storage/common/storage.js");
var _themeServiceJs = require("../../theme/common/themeService.js");
var _themablesJs = require("../../../base/common/themables.js");
var _themeJs = require("../../theme/common/theme.js");
var _typesJs = require("../../../base/common/types.js");
var _colorRegistryJs = require("../../theme/common/colorRegistry.js");
var _defaultStylesJs = require("../../theme/browser/defaultStyles.js");
var _accessibilityJs = require("../../accessibility/common/accessibility.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
function createAndFillInContextMenuActions(menu, optionsOrTarget, targetOrPrimaryGroup, primaryGroupOrUndefined) {
    let target;
    let primaryGroup;
    let groups;
    if (Array.isArray(menu)) {
        groups = menu;
        target = optionsOrTarget;
        primaryGroup = targetOrPrimaryGroup;
    } else {
        const options = optionsOrTarget;
        groups = menu.getActions(options);
        target = targetOrPrimaryGroup;
        primaryGroup = primaryGroupOrUndefined;
    }
    const modifierKeyEmitter = (0, _domJs.ModifierKeyEmitter).getInstance();
    const useAlternativeActions = modifierKeyEmitter.keyStatus.altKey || ((0, _platformJs.isWindows) || (0, _platformJs.isLinux)) && modifierKeyEmitter.keyStatus.shiftKey;
    fillInActions(groups, target, useAlternativeActions, primaryGroup ? (actionGroup)=>actionGroup === primaryGroup : (actionGroup)=>actionGroup === "navigation");
}
function createAndFillInActionBarActions(menu, optionsOrTarget, targetOrPrimaryGroup, primaryGroupOrShouldInlineSubmenu, shouldInlineSubmenuOrUseSeparatorsInPrimaryActions, useSeparatorsInPrimaryActionsOrUndefined) {
    let target;
    let primaryGroup;
    let shouldInlineSubmenu;
    let useSeparatorsInPrimaryActions;
    let groups;
    if (Array.isArray(menu)) {
        groups = menu;
        target = optionsOrTarget;
        primaryGroup = targetOrPrimaryGroup;
        shouldInlineSubmenu = primaryGroupOrShouldInlineSubmenu;
        useSeparatorsInPrimaryActions = shouldInlineSubmenuOrUseSeparatorsInPrimaryActions;
    } else {
        const options = optionsOrTarget;
        groups = menu.getActions(options);
        target = targetOrPrimaryGroup;
        primaryGroup = primaryGroupOrShouldInlineSubmenu;
        shouldInlineSubmenu = shouldInlineSubmenuOrUseSeparatorsInPrimaryActions;
        useSeparatorsInPrimaryActions = useSeparatorsInPrimaryActionsOrUndefined;
    }
    const isPrimaryAction = typeof primaryGroup === "string" ? (actionGroup)=>actionGroup === primaryGroup : primaryGroup;
    // Action bars handle alternative actions on their own so the alternative actions should be ignored
    fillInActions(groups, target, false, isPrimaryAction, shouldInlineSubmenu, useSeparatorsInPrimaryActions);
}
function fillInActions(groups, target, useAlternativeActions, isPrimaryAction = (actionGroup)=>actionGroup === "navigation", shouldInlineSubmenu = ()=>false, useSeparatorsInPrimaryActions = false) {
    let primaryBucket;
    let secondaryBucket;
    if (Array.isArray(target)) {
        primaryBucket = target;
        secondaryBucket = target;
    } else {
        primaryBucket = target.primary;
        secondaryBucket = target.secondary;
    }
    const submenuInfo = new Set();
    for (const [group, actions] of groups){
        let target;
        if (isPrimaryAction(group)) {
            target = primaryBucket;
            if (target.length > 0 && useSeparatorsInPrimaryActions) target.push(new (0, _actionsJs.Separator)());
        } else {
            target = secondaryBucket;
            if (target.length > 0) target.push(new (0, _actionsJs.Separator)());
        }
        for (let action of actions){
            if (useAlternativeActions) action = action instanceof (0, _actionsJs1.MenuItemAction) && action.alt ? action.alt : action;
            const newLen = target.push(action);
            // keep submenu info for later inlining
            if (action instanceof (0, _actionsJs.SubmenuAction)) submenuInfo.add({
                group,
                action,
                index: newLen - 1
            });
        }
    }
    // ask the outside if submenu should be inlined or not. only ask when
    // there would be enough space
    for (const { group, action, index } of submenuInfo){
        const target = isPrimaryAction(group) ? primaryBucket : secondaryBucket;
        // inlining submenus with length 0 or 1 is easy,
        // larger submenus need to be checked with the overall limit
        const submenuActions = action.actions;
        if (shouldInlineSubmenu(action, group, target.length)) target.splice(index, 1, ...submenuActions);
    }
}
let MenuEntryActionViewItem = class MenuEntryActionViewItem extends (0, _actionViewItemsJs.ActionViewItem) {
    constructor(action, _options, _keybindingService, _notificationService, _contextKeyService, _themeService, _contextMenuService, _accessibilityService){
        super(undefined, action, {
            icon: !!(action.class || action.item.icon),
            label: !action.class && !action.item.icon,
            draggable: _options?.draggable,
            keybinding: _options?.keybinding,
            hoverDelegate: _options?.hoverDelegate
        });
        this._options = _options;
        this._keybindingService = _keybindingService;
        this._notificationService = _notificationService;
        this._contextKeyService = _contextKeyService;
        this._themeService = _themeService;
        this._contextMenuService = _contextMenuService;
        this._accessibilityService = _accessibilityService;
        this._wantsAltCommand = false;
        this._itemClassDispose = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this._altKey = (0, _domJs.ModifierKeyEmitter).getInstance();
    }
    get _menuItemAction() {
        return this._action;
    }
    get _commandAction() {
        return this._wantsAltCommand && this._menuItemAction.alt || this._menuItemAction;
    }
    async onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        try {
            await this.actionRunner.run(this._commandAction, this._context);
        } catch (err) {
            this._notificationService.error(err);
        }
    }
    render(container) {
        super.render(container);
        container.classList.add("menu-entry");
        if (this.options.icon) this._updateItemClass(this._menuItemAction.item);
        if (this._menuItemAction.alt) {
            let isMouseOver = false;
            const updateAltState = ()=>{
                const wantsAltCommand = !!this._menuItemAction.alt?.enabled && (!this._accessibilityService.isMotionReduced() || isMouseOver) && (this._altKey.keyStatus.altKey || this._altKey.keyStatus.shiftKey && isMouseOver);
                if (wantsAltCommand !== this._wantsAltCommand) {
                    this._wantsAltCommand = wantsAltCommand;
                    this.updateLabel();
                    this.updateTooltip();
                    this.updateClass();
                }
            };
            this._register(this._altKey.event(updateAltState));
            this._register((0, _domJs.addDisposableListener)(container, "mouseleave", (_)=>{
                isMouseOver = false;
                updateAltState();
            }));
            this._register((0, _domJs.addDisposableListener)(container, "mouseenter", (_)=>{
                isMouseOver = true;
                updateAltState();
            }));
            updateAltState();
        }
    }
    updateLabel() {
        if (this.options.label && this.label) this.label.textContent = this._commandAction.label;
    }
    getTooltip() {
        const keybinding = this._keybindingService.lookupKeybinding(this._commandAction.id, this._contextKeyService);
        const keybindingLabel = keybinding && keybinding.getLabel();
        const tooltip = this._commandAction.tooltip || this._commandAction.label;
        let title = keybindingLabel ? (0, _nlsJs.localize)("titleAndKb", "{0} ({1})", tooltip, keybindingLabel) : tooltip;
        if (!this._wantsAltCommand && this._menuItemAction.alt?.enabled) {
            const altTooltip = this._menuItemAction.alt.tooltip || this._menuItemAction.alt.label;
            const altKeybinding = this._keybindingService.lookupKeybinding(this._menuItemAction.alt.id, this._contextKeyService);
            const altKeybindingLabel = altKeybinding && altKeybinding.getLabel();
            const altTitleSection = altKeybindingLabel ? (0, _nlsJs.localize)("titleAndKb", "{0} ({1})", altTooltip, altKeybindingLabel) : altTooltip;
            title = (0, _nlsJs.localize)("titleAndKbAndAlt", "{0}\n[{1}] {2}", title, (0, _keybindingLabelsJs.UILabelProvider).modifierLabels[0, _platformJs.OS].altKey, altTitleSection);
        }
        return title;
    }
    updateClass() {
        if (this.options.icon) {
            if (this._commandAction !== this._menuItemAction) {
                if (this._menuItemAction.alt) this._updateItemClass(this._menuItemAction.alt.item);
            } else this._updateItemClass(this._menuItemAction.item);
        }
    }
    _updateItemClass(item) {
        this._itemClassDispose.value = undefined;
        const { element, label } = this;
        if (!element || !label) return;
        const icon = this._commandAction.checked && (0, _actionJs.isICommandActionToggleInfo)(item.toggled) && item.toggled.icon ? item.toggled.icon : item.icon;
        if (!icon) return;
        if ((0, _themablesJs.ThemeIcon).isThemeIcon(icon)) {
            // theme icons
            const iconClasses = (0, _themablesJs.ThemeIcon).asClassNameArray(icon);
            label.classList.add(...iconClasses);
            this._itemClassDispose.value = (0, _lifecycleJs.toDisposable)(()=>{
                label.classList.remove(...iconClasses);
            });
        } else {
            // icon path/url
            label.style.backgroundImage = (0, _themeJs.isDark)(this._themeService.getColorTheme().type) ? (0, _domJs.asCSSUrl)(icon.dark) : (0, _domJs.asCSSUrl)(icon.light);
            label.classList.add("icon");
            this._itemClassDispose.value = (0, _lifecycleJs.combinedDisposable)((0, _lifecycleJs.toDisposable)(()=>{
                label.style.backgroundImage = "";
                label.classList.remove("icon");
            }), this._themeService.onDidColorThemeChange(()=>{
                // refresh when the theme changes in case we go between dark <-> light
                this.updateClass();
            }));
        }
    }
};
MenuEntryActionViewItem = __decorate([
    __param(2, (0, _keybindingJs.IKeybindingService)),
    __param(3, (0, _notificationJs.INotificationService)),
    __param(4, (0, _contextkeyJs.IContextKeyService)),
    __param(5, (0, _themeServiceJs.IThemeService)),
    __param(6, (0, _contextViewJs.IContextMenuService)),
    __param(7, (0, _accessibilityJs.IAccessibilityService))
], MenuEntryActionViewItem);
class TextOnlyMenuEntryActionViewItem extends MenuEntryActionViewItem {
    render(container) {
        this.options.label = true;
        this.options.icon = false;
        super.render(container);
        container.classList.add("text-only");
        container.classList.toggle("use-comma", this._options?.useComma ?? false);
    }
    updateLabel() {
        const kb = this._keybindingService.lookupKeybinding(this._action.id, this._contextKeyService);
        if (!kb) return super.updateLabel();
        if (this.label) {
            const kb2 = TextOnlyMenuEntryActionViewItem._symbolPrintEnter(kb);
            if (this._options?.conversational) this.label.textContent = (0, _nlsJs.localize)({
                key: "content2",
                comment: [
                    'A label with keybindg like "ESC to dismiss"'
                ]
            }, "{1} to {0}", this._action.label, kb2);
            else this.label.textContent = (0, _nlsJs.localize)({
                key: "content",
                comment: [
                    "A label",
                    "A keybinding"
                ]
            }, "{0} ({1})", this._action.label, kb2);
        }
    }
    static _symbolPrintEnter(kb) {
        return kb.getLabel()?.replace(/\benter\b/gi, "\u23CE").replace(/\bEscape\b/gi, "Esc");
    }
}
let SubmenuEntryActionViewItem = class SubmenuEntryActionViewItem extends (0, _dropdownActionViewItemJs.DropdownMenuActionViewItem) {
    constructor(action, options, _keybindingService, _contextMenuService, _themeService){
        const dropdownOptions = {
            ...options,
            menuAsChild: options?.menuAsChild ?? false,
            classNames: options?.classNames ?? ((0, _themablesJs.ThemeIcon).isThemeIcon(action.item.icon) ? (0, _themablesJs.ThemeIcon).asClassName(action.item.icon) : undefined),
            keybindingProvider: options?.keybindingProvider ?? ((action)=>_keybindingService.lookupKeybinding(action.id))
        };
        super(action, {
            getActions: ()=>action.actions
        }, _contextMenuService, dropdownOptions);
        this._keybindingService = _keybindingService;
        this._contextMenuService = _contextMenuService;
        this._themeService = _themeService;
    }
    render(container) {
        super.render(container);
        (0, _typesJs.assertType)(this.element);
        container.classList.add("menu-entry");
        const action = this._action;
        const { icon } = action.item;
        if (icon && !(0, _themablesJs.ThemeIcon).isThemeIcon(icon)) {
            this.element.classList.add("icon");
            const setBackgroundImage = ()=>{
                if (this.element) this.element.style.backgroundImage = (0, _themeJs.isDark)(this._themeService.getColorTheme().type) ? (0, _domJs.asCSSUrl)(icon.dark) : (0, _domJs.asCSSUrl)(icon.light);
            };
            setBackgroundImage();
            this._register(this._themeService.onDidColorThemeChange(()=>{
                // refresh when the theme changes in case we go between dark <-> light
                setBackgroundImage();
            }));
        }
    }
};
SubmenuEntryActionViewItem = __decorate([
    __param(2, (0, _keybindingJs.IKeybindingService)),
    __param(3, (0, _contextViewJs.IContextMenuService)),
    __param(4, (0, _themeServiceJs.IThemeService))
], SubmenuEntryActionViewItem);
let DropdownWithDefaultActionViewItem = class DropdownWithDefaultActionViewItem extends (0, _actionViewItemsJs.BaseActionViewItem) {
    constructor(submenuAction, options, _keybindingService, _notificationService, _contextMenuService, _menuService, _instaService, _storageService){
        super(null, submenuAction);
        this._keybindingService = _keybindingService;
        this._notificationService = _notificationService;
        this._contextMenuService = _contextMenuService;
        this._menuService = _menuService;
        this._instaService = _instaService;
        this._storageService = _storageService;
        this._container = null;
        this._options = options;
        this._storageKey = `${submenuAction.item.submenu.id}_lastActionId`;
        // determine default action
        let defaultAction;
        const defaultActionId = options?.persistLastActionId ? _storageService.get(this._storageKey, 1 /* StorageScope.WORKSPACE */ ) : undefined;
        if (defaultActionId) defaultAction = submenuAction.actions.find((a)=>defaultActionId === a.id);
        if (!defaultAction) defaultAction = submenuAction.actions[0];
        this._defaultAction = this._instaService.createInstance(MenuEntryActionViewItem, defaultAction, {
            keybinding: this._getDefaultActionKeybindingLabel(defaultAction)
        });
        const dropdownOptions = {
            keybindingProvider: (action)=>this._keybindingService.lookupKeybinding(action.id),
            ...options,
            menuAsChild: options?.menuAsChild ?? true,
            classNames: options?.classNames ?? [
                "codicon",
                "codicon-chevron-down"
            ],
            actionRunner: options?.actionRunner ?? new (0, _actionsJs.ActionRunner)()
        };
        this._dropdown = new (0, _dropdownActionViewItemJs.DropdownMenuActionViewItem)(submenuAction, submenuAction.actions, this._contextMenuService, dropdownOptions);
        this._register(this._dropdown.actionRunner.onDidRun((e)=>{
            if (e.action instanceof (0, _actionsJs1.MenuItemAction)) this.update(e.action);
        }));
    }
    update(lastAction) {
        if (this._options?.persistLastActionId) this._storageService.store(this._storageKey, lastAction.id, 1 /* StorageScope.WORKSPACE */ , 1 /* StorageTarget.MACHINE */ );
        this._defaultAction.dispose();
        this._defaultAction = this._instaService.createInstance(MenuEntryActionViewItem, lastAction, {
            keybinding: this._getDefaultActionKeybindingLabel(lastAction)
        });
        this._defaultAction.actionRunner = new class extends (0, _actionsJs.ActionRunner) {
            async runAction(action, context) {
                await action.run(undefined);
            }
        }();
        if (this._container) this._defaultAction.render((0, _domJs.prepend)(this._container, (0, _domJs.$)(".action-container")));
    }
    _getDefaultActionKeybindingLabel(defaultAction) {
        let defaultActionKeybinding;
        if (this._options?.renderKeybindingWithDefaultActionLabel) {
            const kb = this._keybindingService.lookupKeybinding(defaultAction.id);
            if (kb) defaultActionKeybinding = `(${kb.getLabel()})`;
        }
        return defaultActionKeybinding;
    }
    setActionContext(newContext) {
        super.setActionContext(newContext);
        this._defaultAction.setActionContext(newContext);
        this._dropdown.setActionContext(newContext);
    }
    render(container) {
        this._container = container;
        super.render(this._container);
        this._container.classList.add("monaco-dropdown-with-default");
        const primaryContainer = (0, _domJs.$)(".action-container");
        this._defaultAction.render((0, _domJs.append)(this._container, primaryContainer));
        this._register((0, _domJs.addDisposableListener)(primaryContainer, (0, _domJs.EventType).KEY_DOWN, (e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            if (event.equals(17 /* KeyCode.RightArrow */ )) {
                this._defaultAction.element.tabIndex = -1;
                this._dropdown.focus();
                event.stopPropagation();
            }
        }));
        const dropdownContainer = (0, _domJs.$)(".dropdown-action-container");
        this._dropdown.render((0, _domJs.append)(this._container, dropdownContainer));
        this._register((0, _domJs.addDisposableListener)(dropdownContainer, (0, _domJs.EventType).KEY_DOWN, (e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            if (event.equals(15 /* KeyCode.LeftArrow */ )) {
                this._defaultAction.element.tabIndex = 0;
                this._dropdown.setFocusable(false);
                this._defaultAction.element?.focus();
                event.stopPropagation();
            }
        }));
    }
    focus(fromRight) {
        if (fromRight) this._dropdown.focus();
        else {
            this._defaultAction.element.tabIndex = 0;
            this._defaultAction.element.focus();
        }
    }
    blur() {
        this._defaultAction.element.tabIndex = -1;
        this._dropdown.blur();
        this._container.blur();
    }
    setFocusable(focusable) {
        if (focusable) this._defaultAction.element.tabIndex = 0;
        else {
            this._defaultAction.element.tabIndex = -1;
            this._dropdown.setFocusable(false);
        }
    }
    dispose() {
        this._defaultAction.dispose();
        this._dropdown.dispose();
        super.dispose();
    }
};
DropdownWithDefaultActionViewItem = __decorate([
    __param(2, (0, _keybindingJs.IKeybindingService)),
    __param(3, (0, _notificationJs.INotificationService)),
    __param(4, (0, _contextViewJs.IContextMenuService)),
    __param(5, (0, _actionsJs1.IMenuService)),
    __param(6, (0, _instantiationJs.IInstantiationService)),
    __param(7, (0, _storageJs.IStorageService))
], DropdownWithDefaultActionViewItem);
let SubmenuEntrySelectActionViewItem = class SubmenuEntrySelectActionViewItem extends (0, _actionViewItemsJs.SelectActionViewItem) {
    constructor(action, contextViewService){
        super(null, action, action.actions.map((a)=>({
                text: a.id === (0, _actionsJs.Separator).ID ? "\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500" : a.label,
                isDisabled: !a.enabled
            })), 0, contextViewService, (0, _defaultStylesJs.defaultSelectBoxStyles), {
            ariaLabel: action.tooltip,
            optionsAsChildren: true
        });
        this.select(Math.max(0, action.actions.findIndex((a)=>a.checked)));
    }
    render(container) {
        super.render(container);
        container.style.borderColor = (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.selectBorder));
    }
    runAction(option, index) {
        const action = this.action.actions[index];
        if (action) this.actionRunner.run(action);
    }
};
SubmenuEntrySelectActionViewItem = __decorate([
    __param(1, (0, _contextViewJs.IContextViewService))
], SubmenuEntrySelectActionViewItem);
function createActionViewItem(instaService, action, options) {
    if (action instanceof (0, _actionsJs1.MenuItemAction)) return instaService.createInstance(MenuEntryActionViewItem, action, options);
    else if (action instanceof (0, _actionsJs1.SubmenuItemAction)) {
        if (action.item.isSelection) return instaService.createInstance(SubmenuEntrySelectActionViewItem, action);
        else {
            if (action.item.rememberDefaultAction) return instaService.createInstance(DropdownWithDefaultActionViewItem, action, {
                ...options,
                persistLastActionId: true
            });
            else return instaService.createInstance(SubmenuEntryActionViewItem, action, options);
        }
    } else return undefined;
}

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/keyboardEvent.js":"bxU9U","../../../base/browser/ui/actionbar/actionViewItems.js":"6Yy9b","../../../base/browser/ui/dropdown/dropdownActionViewItem.js":"k8InY","../../../base/common/actions.js":"5GjLb","../../../base/common/keybindingLabels.js":"jUs6a","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/platform.js":"7maJO","./menuEntryActionViewItem.css":"jpJ86","../../../nls.js":"l617d","../common/actions.js":"kyMtp","../../action/common/action.js":"kzlRi","../../contextkey/common/contextkey.js":"gXuBD","../../contextview/browser/contextView.js":"2QlUR","../../instantiation/common/instantiation.js":"fjwWx","../../keybinding/common/keybinding.js":"25pLT","../../notification/common/notification.js":"igv0W","../../storage/common/storage.js":"6AhR2","../../theme/common/themeService.js":"jMkIC","../../../base/common/themables.js":"hgyHi","../../theme/common/theme.js":"gh7Zf","../../../base/common/types.js":"fb5yx","../../theme/common/colorRegistry.js":"ik5kv","../../theme/browser/defaultStyles.js":"4exuA","../../accessibility/common/accessibility.js":"9Svqy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Yy9b":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseActionViewItem", ()=>BaseActionViewItem);
parcelHelpers.export(exports, "ActionViewItem", ()=>ActionViewItem);
parcelHelpers.export(exports, "SelectActionViewItem", ()=>SelectActionViewItem);
var _browserJs = require("../../browser.js");
var _dndJs = require("../../dnd.js");
var _domJs = require("../../dom.js");
var _touchJs = require("../../touch.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _selectBoxJs = require("../selectBox/selectBox.js");
var _actionsJs = require("../../../common/actions.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _platformJs = require("../../../common/platform.js");
var _typesJs = require("../../../common/types.js");
var _actionbarCss = require("./actionbar.css");
var _nlsJs = require("../../../../nls.js");
var _hoverDelegate2Js = require("../hover/hoverDelegate2.js");
class BaseActionViewItem extends (0, _lifecycleJs.Disposable) {
    get action() {
        return this._action;
    }
    constructor(context, action, options = {}){
        super();
        this.options = options;
        this._context = context || this;
        this._action = action;
        if (action instanceof (0, _actionsJs.Action)) this._register(action.onDidChange((event)=>{
            if (!this.element) // we have not been rendered yet, so there
            // is no point in updating the UI
            return;
            this.handleActionChangeEvent(event);
        }));
    }
    handleActionChangeEvent(event) {
        if (event.enabled !== undefined) this.updateEnabled();
        if (event.checked !== undefined) this.updateChecked();
        if (event.class !== undefined) this.updateClass();
        if (event.label !== undefined) {
            this.updateLabel();
            this.updateTooltip();
        }
        if (event.tooltip !== undefined) this.updateTooltip();
    }
    get actionRunner() {
        if (!this._actionRunner) this._actionRunner = this._register(new (0, _actionsJs.ActionRunner)());
        return this._actionRunner;
    }
    set actionRunner(actionRunner) {
        this._actionRunner = actionRunner;
    }
    isEnabled() {
        return this._action.enabled;
    }
    setActionContext(newContext) {
        this._context = newContext;
    }
    render(container) {
        const element = this.element = container;
        this._register((0, _touchJs.Gesture).addTarget(container));
        const enableDragging = this.options && this.options.draggable;
        if (enableDragging) {
            container.draggable = true;
            if (0, _browserJs.isFirefox) // Firefox: requires to set a text data transfer to get going
            this._register((0, _domJs.addDisposableListener)(container, (0, _domJs.EventType).DRAG_START, (e)=>e.dataTransfer?.setData((0, _dndJs.DataTransfers).TEXT, this._action.label)));
        }
        this._register((0, _domJs.addDisposableListener)(element, (0, _touchJs.EventType).Tap, (e)=>this.onClick(e, true))); // Preserve focus on tap #125470
        this._register((0, _domJs.addDisposableListener)(element, (0, _domJs.EventType).MOUSE_DOWN, (e)=>{
            if (!enableDragging) (0, _domJs.EventHelper).stop(e, true); // do not run when dragging is on because that would disable it
            if (this._action.enabled && e.button === 0) element.classList.add("active");
        }));
        if (_platformJs.isMacintosh) // macOS: allow to trigger the button when holding Ctrl+key and pressing the
        // main mouse button. This is for scenarios where e.g. some interaction forces
        // the Ctrl+key to be pressed and hold but the user still wants to interact
        // with the actions (for example quick access in quick navigation mode).
        this._register((0, _domJs.addDisposableListener)(element, (0, _domJs.EventType).CONTEXT_MENU, (e)=>{
            if (e.button === 0 && e.ctrlKey === true) this.onClick(e);
        }));
        this._register((0, _domJs.addDisposableListener)(element, (0, _domJs.EventType).CLICK, (e)=>{
            (0, _domJs.EventHelper).stop(e, true);
            // menus do not use the click event
            if (!(this.options && this.options.isMenu)) this.onClick(e);
        }));
        this._register((0, _domJs.addDisposableListener)(element, (0, _domJs.EventType).DBLCLICK, (e)=>{
            (0, _domJs.EventHelper).stop(e, true);
        }));
        [
            (0, _domJs.EventType).MOUSE_UP,
            (0, _domJs.EventType).MOUSE_OUT
        ].forEach((event)=>{
            this._register((0, _domJs.addDisposableListener)(element, event, (e)=>{
                (0, _domJs.EventHelper).stop(e);
                element.classList.remove("active");
            }));
        });
    }
    onClick(event, preserveFocus = false) {
        (0, _domJs.EventHelper).stop(event, true);
        const context = _typesJs.isUndefinedOrNull(this._context) ? this.options?.useEventAsContext ? event : {
            preserveFocus
        } : this._context;
        this.actionRunner.run(this._action, context);
    }
    // Only set the tabIndex on the element once it is about to get focused
    // That way this element wont be a tab stop when it is not needed #106441
    focus() {
        if (this.element) {
            this.element.tabIndex = 0;
            this.element.focus();
            this.element.classList.add("focused");
        }
    }
    blur() {
        if (this.element) {
            this.element.blur();
            this.element.tabIndex = -1;
            this.element.classList.remove("focused");
        }
    }
    setFocusable(focusable) {
        if (this.element) this.element.tabIndex = focusable ? 0 : -1;
    }
    get trapsArrowNavigation() {
        return false;
    }
    updateEnabled() {
    // implement in subclass
    }
    updateLabel() {
    // implement in subclass
    }
    getClass() {
        return this.action.class;
    }
    getTooltip() {
        return this.action.tooltip;
    }
    updateTooltip() {
        if (!this.element) return;
        const title = this.getTooltip() ?? "";
        this.updateAriaLabel();
        if (this.options.hoverDelegate?.showNativeHover) /* While custom hover is not inside custom hover */ this.element.title = title;
        else {
            if (!this.customHover && title !== "") {
                const hoverDelegate = this.options.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("element");
                this.customHover = this._store.add((0, _hoverDelegate2Js.getBaseLayerHoverDelegate)().setupManagedHover(hoverDelegate, this.element, title));
            } else if (this.customHover) this.customHover.update(title);
        }
    }
    updateAriaLabel() {
        if (this.element) {
            const title = this.getTooltip() ?? "";
            this.element.setAttribute("aria-label", title);
        }
    }
    updateClass() {
    // implement in subclass
    }
    updateChecked() {
    // implement in subclass
    }
    dispose() {
        if (this.element) {
            this.element.remove();
            this.element = undefined;
        }
        this._context = undefined;
        super.dispose();
    }
}
class ActionViewItem extends BaseActionViewItem {
    constructor(context, action, options){
        super(context, action, options);
        this.options = options;
        this.options.icon = options.icon !== undefined ? options.icon : false;
        this.options.label = options.label !== undefined ? options.label : true;
        this.cssClass = "";
    }
    render(container) {
        super.render(container);
        _typesJs.assertType(this.element);
        const label = document.createElement("a");
        label.classList.add("action-label");
        label.setAttribute("role", this.getDefaultAriaRole());
        this.label = label;
        this.element.appendChild(label);
        if (this.options.label && this.options.keybinding) {
            const kbLabel = document.createElement("span");
            kbLabel.classList.add("keybinding");
            kbLabel.textContent = this.options.keybinding;
            this.element.appendChild(kbLabel);
        }
        this.updateClass();
        this.updateLabel();
        this.updateTooltip();
        this.updateEnabled();
        this.updateChecked();
    }
    getDefaultAriaRole() {
        if (this._action.id === (0, _actionsJs.Separator).ID) return "presentation"; // A separator is a presentation item
        else {
            if (this.options.isMenu) return "menuitem";
            else if (this.options.isTabList) return "tab";
            else return "button";
        }
    }
    // Only set the tabIndex on the element once it is about to get focused
    // That way this element wont be a tab stop when it is not needed #106441
    focus() {
        if (this.label) {
            this.label.tabIndex = 0;
            this.label.focus();
        }
    }
    blur() {
        if (this.label) this.label.tabIndex = -1;
    }
    setFocusable(focusable) {
        if (this.label) this.label.tabIndex = focusable ? 0 : -1;
    }
    updateLabel() {
        if (this.options.label && this.label) this.label.textContent = this.action.label;
    }
    getTooltip() {
        let title = null;
        if (this.action.tooltip) title = this.action.tooltip;
        else if (!this.options.label && this.action.label && this.options.icon) {
            title = this.action.label;
            if (this.options.keybinding) title = _nlsJs.localize({
                key: "titleLabel",
                comment: [
                    "action title",
                    "action keybinding"
                ]
            }, "{0} ({1})", title, this.options.keybinding);
        }
        return title ?? undefined;
    }
    updateClass() {
        if (this.cssClass && this.label) this.label.classList.remove(...this.cssClass.split(" "));
        if (this.options.icon) {
            this.cssClass = this.getClass();
            if (this.label) {
                this.label.classList.add("codicon");
                if (this.cssClass) this.label.classList.add(...this.cssClass.split(" "));
            }
            this.updateEnabled();
        } else this.label?.classList.remove("codicon");
    }
    updateEnabled() {
        if (this.action.enabled) {
            if (this.label) {
                this.label.removeAttribute("aria-disabled");
                this.label.classList.remove("disabled");
            }
            this.element?.classList.remove("disabled");
        } else {
            if (this.label) {
                this.label.setAttribute("aria-disabled", "true");
                this.label.classList.add("disabled");
            }
            this.element?.classList.add("disabled");
        }
    }
    updateAriaLabel() {
        if (this.label) {
            const title = this.getTooltip() ?? "";
            this.label.setAttribute("aria-label", title);
        }
    }
    updateChecked() {
        if (this.label) {
            if (this.action.checked !== undefined) {
                this.label.classList.toggle("checked", this.action.checked);
                if (this.options.isTabList) this.label.setAttribute("aria-selected", this.action.checked ? "true" : "false");
                else {
                    this.label.setAttribute("aria-checked", this.action.checked ? "true" : "false");
                    this.label.setAttribute("role", "checkbox");
                }
            } else {
                this.label.classList.remove("checked");
                this.label.removeAttribute(this.options.isTabList ? "aria-selected" : "aria-checked");
                this.label.setAttribute("role", this.getDefaultAriaRole());
            }
        }
    }
}
class SelectActionViewItem extends BaseActionViewItem {
    constructor(ctx, action, options, selected, contextViewProvider, styles, selectBoxOptions){
        super(ctx, action);
        this.selectBox = new (0, _selectBoxJs.SelectBox)(options, selected, contextViewProvider, styles, selectBoxOptions);
        this.selectBox.setFocusable(false);
        this._register(this.selectBox);
        this.registerListeners();
    }
    select(index) {
        this.selectBox.select(index);
    }
    registerListeners() {
        this._register(this.selectBox.onDidSelect((e)=>this.runAction(e.selected, e.index)));
    }
    runAction(option, index) {
        this.actionRunner.run(this._action, this.getActionContext(option, index));
    }
    getActionContext(option, index) {
        return option;
    }
    setFocusable(focusable) {
        this.selectBox.setFocusable(focusable);
    }
    focus() {
        this.selectBox?.focus();
    }
    blur() {
        this.selectBox?.blur();
    }
    render(container) {
        this.selectBox.render(container);
    }
}

},{"../../browser.js":"4Zquf","../../dnd.js":"io6s1","../../dom.js":"bnqsM","../../touch.js":"6iGQn","../hover/hoverDelegateFactory.js":"kll4h","../selectBox/selectBox.js":"kFfjU","../../../common/actions.js":"5GjLb","../../../common/lifecycle.js":"9kg8d","../../../common/platform.js":"7maJO","../../../common/types.js":"fb5yx","./actionbar.css":"gFocE","../../../../nls.js":"l617d","../hover/hoverDelegate2.js":"5jqL3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"io6s1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataTransfers", ()=>DataTransfers);
var _mimeJs = require("../common/mime.js");
const DataTransfers = {
    /**
     * Application specific resource transfer type
     */ RESOURCES: "ResourceURLs",
    /**
     * Browser specific transfer type to download
     */ DOWNLOAD_URL: "DownloadURL",
    /**
     * Browser specific transfer type for files
     */ FILES: "Files",
    /**
     * Typically transfer type for copy/paste transfers.
     */ TEXT: (0, _mimeJs.Mimes).text,
    /**
     * Internal type used to pass around text/uri-list data.
     *
     * This is needed to work around https://bugs.chromium.org/p/chromium/issues/detail?id=239745.
     */ INTERNAL_URI_LIST: "application/vnd.code.uri-list"
};

},{"../common/mime.js":"9CBNk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kll4h":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// TODO: Remove when getDefaultHoverDelegate is no longer used
parcelHelpers.export(exports, "setHoverDelegateFactory", ()=>setHoverDelegateFactory);
// TODO: Refine type for use in new IHoverService interface
parcelHelpers.export(exports, "getDefaultHoverDelegate", ()=>getDefaultHoverDelegate);
// TODO: Create equivalent in IHoverService
parcelHelpers.export(exports, "createInstantHoverDelegate", ()=>createInstantHoverDelegate);
var _lazyJs = require("../../../common/lazy.js");
const nullHoverDelegateFactory = ()=>({
        get delay () {
            return -1;
        },
        dispose: ()=>{},
        showHover: ()=>{
            return undefined;
        }
    });
let hoverDelegateFactory = nullHoverDelegateFactory;
const defaultHoverDelegateMouse = new (0, _lazyJs.Lazy)(()=>hoverDelegateFactory("mouse", false));
const defaultHoverDelegateElement = new (0, _lazyJs.Lazy)(()=>hoverDelegateFactory("element", false));
function setHoverDelegateFactory(hoverDelegateProvider) {
    hoverDelegateFactory = hoverDelegateProvider;
}
function getDefaultHoverDelegate(placement) {
    if (placement === "element") return defaultHoverDelegateElement.value;
    return defaultHoverDelegateMouse.value;
}
function createInstantHoverDelegate() {
    // Creates a hover delegate with instant hover enabled.
    // This hover belongs to the consumer and requires the them to dispose it.
    // Instant hover only makes sense for 'element' placement.
    return hoverDelegateFactory("element", true);
}

},{"../../../common/lazy.js":"6e57N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kFfjU":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectBox", ()=>SelectBox);
var _selectBoxCustomJs = require("./selectBoxCustom.js");
var _selectBoxNativeJs = require("./selectBoxNative.js");
var _widgetJs = require("../widget.js");
var _platformJs = require("../../../common/platform.js");
var _selectBoxCss = require("./selectBox.css");
class SelectBox extends (0, _widgetJs.Widget) {
    constructor(options, selected, contextViewProvider, styles, selectBoxOptions){
        super();
        // Default to native SelectBox for OSX unless overridden
        if ((0, _platformJs.isMacintosh) && !selectBoxOptions?.useCustomDrawn) this.selectBoxDelegate = new (0, _selectBoxNativeJs.SelectBoxNative)(options, selected, styles, selectBoxOptions);
        else this.selectBoxDelegate = new (0, _selectBoxCustomJs.SelectBoxList)(options, selected, contextViewProvider, styles, selectBoxOptions);
        this._register(this.selectBoxDelegate);
    }
    // Public SelectBox Methods - routed through delegate interface
    get onDidSelect() {
        return this.selectBoxDelegate.onDidSelect;
    }
    setOptions(options, selected) {
        this.selectBoxDelegate.setOptions(options, selected);
    }
    select(index) {
        this.selectBoxDelegate.select(index);
    }
    focus() {
        this.selectBoxDelegate.focus();
    }
    blur() {
        this.selectBoxDelegate.blur();
    }
    setFocusable(focusable) {
        this.selectBoxDelegate.setFocusable(focusable);
    }
    render(container) {
        this.selectBoxDelegate.render(container);
    }
}

},{"./selectBoxCustom.js":"eATuP","./selectBoxNative.js":"h7BCW","../widget.js":"kM4DP","../../../common/platform.js":"7maJO","./selectBox.css":"koHgG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eATuP":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectBoxList", ()=>SelectBoxList);
var _domJs = require("../../dom.js");
var _eventJs = require("../../event.js");
var _keyboardEventJs = require("../../keyboardEvent.js");
var _markdownRendererJs = require("../../markdownRenderer.js");
var _hoverDelegate2Js = require("../hover/hoverDelegate2.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _listWidgetJs = require("../list/listWidget.js");
var _arraysJs = require("../../../common/arrays.js");
var _eventJs1 = require("../../../common/event.js");
var _keyCodesJs = require("../../../common/keyCodes.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _platformJs = require("../../../common/platform.js");
var _selectBoxCustomCss = require("./selectBoxCustom.css");
var _nlsJs = require("../../../../nls.js");
const $ = _domJs.$;
const SELECT_OPTION_ENTRY_TEMPLATE_ID = "selectOption.entry.template";
class SelectListRenderer {
    get templateId() {
        return SELECT_OPTION_ENTRY_TEMPLATE_ID;
    }
    renderTemplate(container) {
        const data = Object.create(null);
        data.root = container;
        data.text = _domJs.append(container, $(".option-text"));
        data.detail = _domJs.append(container, $(".option-detail"));
        data.decoratorRight = _domJs.append(container, $(".option-decorator-right"));
        return data;
    }
    renderElement(element, index, templateData) {
        const data = templateData;
        const text = element.text;
        const detail = element.detail;
        const decoratorRight = element.decoratorRight;
        const isDisabled = element.isDisabled;
        data.text.textContent = text;
        data.detail.textContent = !!detail ? detail : "";
        data.decoratorRight.innerText = !!decoratorRight ? decoratorRight : "";
        // pseudo-select disabled option
        if (isDisabled) data.root.classList.add("option-disabled");
        else // Make sure we do class removal from prior template rendering
        data.root.classList.remove("option-disabled");
    }
    disposeTemplate(_templateData) {
    // noop
    }
}
class SelectBoxList extends (0, _lifecycleJs.Disposable) {
    static{
        this.DEFAULT_DROPDOWN_MINIMUM_BOTTOM_MARGIN = 32;
    }
    static{
        this.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN = 2;
    }
    static{
        this.DEFAULT_MINIMUM_VISIBLE_OPTIONS = 3;
    }
    constructor(options, selected, contextViewProvider, styles, selectBoxOptions){
        super();
        this.options = [];
        this._currentSelection = 0;
        this._hasDetails = false;
        this._skipLayout = false;
        this._sticky = false; // for dev purposes only
        this._isVisible = false;
        this.styles = styles;
        this.selectBoxOptions = selectBoxOptions || Object.create(null);
        if (typeof this.selectBoxOptions.minBottomMargin !== "number") this.selectBoxOptions.minBottomMargin = SelectBoxList.DEFAULT_DROPDOWN_MINIMUM_BOTTOM_MARGIN;
        else if (this.selectBoxOptions.minBottomMargin < 0) this.selectBoxOptions.minBottomMargin = 0;
        this.selectElement = document.createElement("select");
        // Use custom CSS vars for padding calculation
        this.selectElement.className = "monaco-select-box monaco-select-box-dropdown-padding";
        if (typeof this.selectBoxOptions.ariaLabel === "string") this.selectElement.setAttribute("aria-label", this.selectBoxOptions.ariaLabel);
        if (typeof this.selectBoxOptions.ariaDescription === "string") this.selectElement.setAttribute("aria-description", this.selectBoxOptions.ariaDescription);
        this._onDidSelect = new (0, _eventJs1.Emitter)();
        this._register(this._onDidSelect);
        this.registerListeners();
        this.constructSelectDropDown(contextViewProvider);
        this.selected = selected || 0;
        if (options) this.setOptions(options, selected);
        this.initStyleSheet();
    }
    setTitle(title) {
        if (!this._hover && title) this._hover = this._register((0, _hoverDelegate2Js.getBaseLayerHoverDelegate)().setupManagedHover((0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("mouse"), this.selectElement, title));
        else if (this._hover) this._hover.update(title);
    }
    // IDelegate - List renderer
    getHeight() {
        return 22;
    }
    getTemplateId() {
        return SELECT_OPTION_ENTRY_TEMPLATE_ID;
    }
    constructSelectDropDown(contextViewProvider) {
        // SetUp ContextView container to hold select Dropdown
        this.contextViewProvider = contextViewProvider;
        this.selectDropDownContainer = _domJs.$(".monaco-select-box-dropdown-container");
        // Use custom CSS vars for padding calculation (shared with parent select)
        this.selectDropDownContainer.classList.add("monaco-select-box-dropdown-padding");
        // Setup container for select option details
        this.selectionDetailsPane = _domJs.append(this.selectDropDownContainer, $(".select-box-details-pane"));
        // Create span flex box item/div we can measure and control
        const widthControlOuterDiv = _domJs.append(this.selectDropDownContainer, $(".select-box-dropdown-container-width-control"));
        const widthControlInnerDiv = _domJs.append(widthControlOuterDiv, $(".width-control-div"));
        this.widthControlElement = document.createElement("span");
        this.widthControlElement.className = "option-text-width-control";
        _domJs.append(widthControlInnerDiv, this.widthControlElement);
        // Always default to below position
        this._dropDownPosition = 0 /* AnchorPosition.BELOW */ ;
        // Inline stylesheet for themes
        this.styleElement = _domJs.createStyleSheet(this.selectDropDownContainer);
        // Prevent dragging of dropdown #114329
        this.selectDropDownContainer.setAttribute("draggable", "true");
        this._register(_domJs.addDisposableListener(this.selectDropDownContainer, _domJs.EventType.DRAG_START, (e)=>{
            _domJs.EventHelper.stop(e, true);
        }));
    }
    registerListeners() {
        // Parent native select keyboard listeners
        this._register(_domJs.addStandardDisposableListener(this.selectElement, "change", (e)=>{
            this.selected = e.target.selectedIndex;
            this._onDidSelect.fire({
                index: e.target.selectedIndex,
                selected: e.target.value
            });
            if (!!this.options[this.selected] && !!this.options[this.selected].text) this.setTitle(this.options[this.selected].text);
        }));
        // Have to implement both keyboard and mouse controllers to handle disabled options
        // Intercept mouse events to override normal select actions on parents
        this._register(_domJs.addDisposableListener(this.selectElement, _domJs.EventType.CLICK, (e)=>{
            _domJs.EventHelper.stop(e);
            if (this._isVisible) this.hideSelectDropDown(true);
            else this.showSelectDropDown();
        }));
        this._register(_domJs.addDisposableListener(this.selectElement, _domJs.EventType.MOUSE_DOWN, (e)=>{
            _domJs.EventHelper.stop(e);
        }));
        // Intercept touch events
        // The following implementation is slightly different from the mouse event handlers above.
        // Use the following helper variable, otherwise the list flickers.
        let listIsVisibleOnTouchStart;
        this._register(_domJs.addDisposableListener(this.selectElement, "touchstart", (e)=>{
            listIsVisibleOnTouchStart = this._isVisible;
        }));
        this._register(_domJs.addDisposableListener(this.selectElement, "touchend", (e)=>{
            _domJs.EventHelper.stop(e);
            if (listIsVisibleOnTouchStart) this.hideSelectDropDown(true);
            else this.showSelectDropDown();
        }));
        // Intercept keyboard handling
        this._register(_domJs.addDisposableListener(this.selectElement, _domJs.EventType.KEY_DOWN, (e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            let showDropDown = false;
            // Create and drop down select list on keyboard select
            if (0, _platformJs.isMacintosh) {
                if (event.keyCode === 18 /* KeyCode.DownArrow */  || event.keyCode === 16 /* KeyCode.UpArrow */  || event.keyCode === 10 /* KeyCode.Space */  || event.keyCode === 3 /* KeyCode.Enter */ ) showDropDown = true;
            } else if (event.keyCode === 18 /* KeyCode.DownArrow */  && event.altKey || event.keyCode === 16 /* KeyCode.UpArrow */  && event.altKey || event.keyCode === 10 /* KeyCode.Space */  || event.keyCode === 3 /* KeyCode.Enter */ ) showDropDown = true;
            if (showDropDown) {
                this.showSelectDropDown();
                _domJs.EventHelper.stop(e, true);
            }
        }));
    }
    get onDidSelect() {
        return this._onDidSelect.event;
    }
    setOptions(options, selected) {
        if (!_arraysJs.equals(this.options, options)) {
            this.options = options;
            this.selectElement.options.length = 0;
            this._hasDetails = false;
            this._cachedMaxDetailsHeight = undefined;
            this.options.forEach((option, index)=>{
                this.selectElement.add(this.createOption(option.text, index, option.isDisabled));
                if (typeof option.description === "string") this._hasDetails = true;
            });
        }
        if (selected !== undefined) {
            this.select(selected);
            // Set current = selected since this is not necessarily a user exit
            this._currentSelection = this.selected;
        }
    }
    setOptionsList() {
        // Mirror options in drop-down
        // Populate select list for non-native select mode
        this.selectList?.splice(0, this.selectList.length, this.options);
    }
    select(index) {
        if (index >= 0 && index < this.options.length) this.selected = index;
        else if (index > this.options.length - 1) // Adjust index to end of list
        // This could make client out of sync with the select
        this.select(this.options.length - 1);
        else if (this.selected < 0) this.selected = 0;
        this.selectElement.selectedIndex = this.selected;
        if (!!this.options[this.selected] && !!this.options[this.selected].text) this.setTitle(this.options[this.selected].text);
    }
    focus() {
        if (this.selectElement) {
            this.selectElement.tabIndex = 0;
            this.selectElement.focus();
        }
    }
    blur() {
        if (this.selectElement) {
            this.selectElement.tabIndex = -1;
            this.selectElement.blur();
        }
    }
    setFocusable(focusable) {
        this.selectElement.tabIndex = focusable ? 0 : -1;
    }
    render(container) {
        this.container = container;
        container.classList.add("select-container");
        container.appendChild(this.selectElement);
        this.styleSelectElement();
    }
    initStyleSheet() {
        const content = [];
        // Style non-native select mode
        if (this.styles.listFocusBackground) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { background-color: ${this.styles.listFocusBackground} !important; }`);
        if (this.styles.listFocusForeground) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { color: ${this.styles.listFocusForeground} !important; }`);
        if (this.styles.decoratorRightForeground) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.focused) .option-decorator-right { color: ${this.styles.decoratorRightForeground}; }`);
        if (this.styles.selectBackground && this.styles.selectBorder && this.styles.selectBorder !== this.styles.selectBackground) {
            content.push(`.monaco-select-box-dropdown-container { border: 1px solid ${this.styles.selectBorder} } `);
            content.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-top { border-top: 1px solid ${this.styles.selectBorder} } `);
            content.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-bottom { border-bottom: 1px solid ${this.styles.selectBorder} } `);
        } else if (this.styles.selectListBorder) {
            content.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-top { border-top: 1px solid ${this.styles.selectListBorder} } `);
            content.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-bottom { border-bottom: 1px solid ${this.styles.selectListBorder} } `);
        }
        // Hover foreground - ignore for disabled options
        if (this.styles.listHoverForeground) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { color: ${this.styles.listHoverForeground} !important; }`);
        // Hover background - ignore for disabled options
        if (this.styles.listHoverBackground) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { background-color: ${this.styles.listHoverBackground} !important; }`);
        // Match quick input outline styles - ignore for disabled options
        if (this.styles.listFocusOutline) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { outline: 1.6px dotted ${this.styles.listFocusOutline} !important; outline-offset: -1.6px !important; }`);
        if (this.styles.listHoverOutline) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { outline: 1.6px dashed ${this.styles.listHoverOutline} !important; outline-offset: -1.6px !important; }`);
        // Clear list styles on focus and on hover for disabled options
        content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.option-disabled.focused { background-color: transparent !important; color: inherit !important; outline: none !important; }`);
        content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.option-disabled:hover { background-color: transparent !important; color: inherit !important; outline: none !important; }`);
        this.styleElement.textContent = content.join("\n");
    }
    styleSelectElement() {
        const background = this.styles.selectBackground ?? "";
        const foreground = this.styles.selectForeground ?? "";
        const border = this.styles.selectBorder ?? "";
        this.selectElement.style.backgroundColor = background;
        this.selectElement.style.color = foreground;
        this.selectElement.style.borderColor = border;
    }
    styleList() {
        const background = this.styles.selectBackground ?? "";
        const listBackground = _domJs.asCssValueWithDefault(this.styles.selectListBackground, background);
        this.selectDropDownListContainer.style.backgroundColor = listBackground;
        this.selectionDetailsPane.style.backgroundColor = listBackground;
        const optionsBorder = this.styles.focusBorder ?? "";
        this.selectDropDownContainer.style.outlineColor = optionsBorder;
        this.selectDropDownContainer.style.outlineOffset = "-1px";
        this.selectList.style(this.styles);
    }
    createOption(value, index, disabled) {
        const option = document.createElement("option");
        option.value = value;
        option.text = value;
        option.disabled = !!disabled;
        return option;
    }
    // ContextView dropdown methods
    showSelectDropDown() {
        this.selectionDetailsPane.innerText = "";
        if (!this.contextViewProvider || this._isVisible) return;
        // Lazily create and populate list only at open, moved from constructor
        this.createSelectList(this.selectDropDownContainer);
        this.setOptionsList();
        // This allows us to flip the position based on measurement
        // Set drop-down position above/below from required height and margins
        // If pre-layout cannot fit at least one option do not show drop-down
        this.contextViewProvider.showContextView({
            getAnchor: ()=>this.selectElement,
            render: (container)=>this.renderSelectDropDown(container, true),
            layout: ()=>{
                this.layoutSelectDropDown();
            },
            onHide: ()=>{
                this.selectDropDownContainer.classList.remove("visible");
                this.selectElement.classList.remove("synthetic-focus");
            },
            anchorPosition: this._dropDownPosition
        }, this.selectBoxOptions.optionsAsChildren ? this.container : undefined);
        // Hide so we can relay out
        this._isVisible = true;
        this.hideSelectDropDown(false);
        this.contextViewProvider.showContextView({
            getAnchor: ()=>this.selectElement,
            render: (container)=>this.renderSelectDropDown(container),
            layout: ()=>this.layoutSelectDropDown(),
            onHide: ()=>{
                this.selectDropDownContainer.classList.remove("visible");
                this.selectElement.classList.remove("synthetic-focus");
            },
            anchorPosition: this._dropDownPosition
        }, this.selectBoxOptions.optionsAsChildren ? this.container : undefined);
        // Track initial selection the case user escape, blur
        this._currentSelection = this.selected;
        this._isVisible = true;
        this.selectElement.setAttribute("aria-expanded", "true");
    }
    hideSelectDropDown(focusSelect) {
        if (!this.contextViewProvider || !this._isVisible) return;
        this._isVisible = false;
        this.selectElement.setAttribute("aria-expanded", "false");
        if (focusSelect) this.selectElement.focus();
        this.contextViewProvider.hideContextView();
    }
    renderSelectDropDown(container, preLayoutPosition) {
        container.appendChild(this.selectDropDownContainer);
        // Pre-Layout allows us to change position
        this.layoutSelectDropDown(preLayoutPosition);
        return {
            dispose: ()=>{
                // contextView will dispose itself if moving from one View to another
                this.selectDropDownContainer.remove(); // remove to take out the CSS rules we add
            }
        };
    }
    // Iterate over detailed descriptions, find max height
    measureMaxDetailsHeight() {
        let maxDetailsPaneHeight = 0;
        this.options.forEach((_option, index)=>{
            this.updateDetail(index);
            if (this.selectionDetailsPane.offsetHeight > maxDetailsPaneHeight) maxDetailsPaneHeight = this.selectionDetailsPane.offsetHeight;
        });
        return maxDetailsPaneHeight;
    }
    layoutSelectDropDown(preLayoutPosition) {
        // Avoid recursion from layout called in onListFocus
        if (this._skipLayout) return false;
        // Layout ContextView drop down select list and container
        // Have to manage our vertical overflow, sizing, position below or above
        // Position has to be determined and set prior to contextView instantiation
        if (this.selectList) {
            // Make visible to enable measurements
            this.selectDropDownContainer.classList.add("visible");
            const window = _domJs.getWindow(this.selectElement);
            const selectPosition = _domJs.getDomNodePagePosition(this.selectElement);
            const styles = _domJs.getWindow(this.selectElement).getComputedStyle(this.selectElement);
            const verticalPadding = parseFloat(styles.getPropertyValue("--dropdown-padding-top")) + parseFloat(styles.getPropertyValue("--dropdown-padding-bottom"));
            const maxSelectDropDownHeightBelow = window.innerHeight - selectPosition.top - selectPosition.height - (this.selectBoxOptions.minBottomMargin || 0);
            const maxSelectDropDownHeightAbove = selectPosition.top - SelectBoxList.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN;
            // Determine optimal width - min(longest option), opt(parent select, excluding margins), max(ContextView controlled)
            const selectWidth = this.selectElement.offsetWidth;
            const selectMinWidth = this.setWidthControlElement(this.widthControlElement);
            const selectOptimalWidth = Math.max(selectMinWidth, Math.round(selectWidth)).toString() + "px";
            this.selectDropDownContainer.style.width = selectOptimalWidth;
            // Get initial list height and determine space above and below
            this.selectList.getHTMLElement().style.height = "";
            this.selectList.layout();
            let listHeight = this.selectList.contentHeight;
            if (this._hasDetails && this._cachedMaxDetailsHeight === undefined) this._cachedMaxDetailsHeight = this.measureMaxDetailsHeight();
            const maxDetailsPaneHeight = this._hasDetails ? this._cachedMaxDetailsHeight : 0;
            const minRequiredDropDownHeight = listHeight + verticalPadding + maxDetailsPaneHeight;
            const maxVisibleOptionsBelow = Math.floor((maxSelectDropDownHeightBelow - verticalPadding - maxDetailsPaneHeight) / this.getHeight());
            const maxVisibleOptionsAbove = Math.floor((maxSelectDropDownHeightAbove - verticalPadding - maxDetailsPaneHeight) / this.getHeight());
            // If we are only doing pre-layout check/adjust position only
            // Calculate vertical space available, flip up if insufficient
            // Use reflected padding on parent select, ContextView style
            // properties not available before DOM attachment
            if (preLayoutPosition) {
                // Check if select moved out of viewport , do not open
                // If at least one option cannot be shown, don't open the drop-down or hide/remove if open
                if (selectPosition.top + selectPosition.height > window.innerHeight - 22 || selectPosition.top < SelectBoxList.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN || maxVisibleOptionsBelow < 1 && maxVisibleOptionsAbove < 1) // Indicate we cannot open
                return false;
                // Determine if we have to flip up
                // Always show complete list items - never more than Max available vertical height
                if (maxVisibleOptionsBelow < SelectBoxList.DEFAULT_MINIMUM_VISIBLE_OPTIONS && maxVisibleOptionsAbove > maxVisibleOptionsBelow && this.options.length > maxVisibleOptionsBelow) {
                    this._dropDownPosition = 1 /* AnchorPosition.ABOVE */ ;
                    this.selectDropDownListContainer.remove();
                    this.selectionDetailsPane.remove();
                    this.selectDropDownContainer.appendChild(this.selectionDetailsPane);
                    this.selectDropDownContainer.appendChild(this.selectDropDownListContainer);
                    this.selectionDetailsPane.classList.remove("border-top");
                    this.selectionDetailsPane.classList.add("border-bottom");
                } else {
                    this._dropDownPosition = 0 /* AnchorPosition.BELOW */ ;
                    this.selectDropDownListContainer.remove();
                    this.selectionDetailsPane.remove();
                    this.selectDropDownContainer.appendChild(this.selectDropDownListContainer);
                    this.selectDropDownContainer.appendChild(this.selectionDetailsPane);
                    this.selectionDetailsPane.classList.remove("border-bottom");
                    this.selectionDetailsPane.classList.add("border-top");
                }
                // Do full layout on showSelectDropDown only
                return true;
            }
            // Check if select out of viewport or cutting into status bar
            if (selectPosition.top + selectPosition.height > window.innerHeight - 22 || selectPosition.top < SelectBoxList.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN || this._dropDownPosition === 0 /* AnchorPosition.BELOW */  && maxVisibleOptionsBelow < 1 || this._dropDownPosition === 1 /* AnchorPosition.ABOVE */  && maxVisibleOptionsAbove < 1) {
                // Cannot properly layout, close and hide
                this.hideSelectDropDown(true);
                return false;
            }
            // SetUp list dimensions and layout - account for container padding
            // Use position to check above or below available space
            if (this._dropDownPosition === 0 /* AnchorPosition.BELOW */ ) {
                if (this._isVisible && maxVisibleOptionsBelow + maxVisibleOptionsAbove < 1) {
                    // If drop-down is visible, must be doing a DOM re-layout, hide since we don't fit
                    // Hide drop-down, hide contextview, focus on parent select
                    this.hideSelectDropDown(true);
                    return false;
                }
                // Adjust list height to max from select bottom to margin (default/minBottomMargin)
                if (minRequiredDropDownHeight > maxSelectDropDownHeightBelow) listHeight = maxVisibleOptionsBelow * this.getHeight();
            } else if (minRequiredDropDownHeight > maxSelectDropDownHeightAbove) listHeight = maxVisibleOptionsAbove * this.getHeight();
            // Set adjusted list height and relayout
            this.selectList.layout(listHeight);
            this.selectList.domFocus();
            // Finally set focus on selected item
            if (this.selectList.length > 0) {
                this.selectList.setFocus([
                    this.selected || 0
                ]);
                this.selectList.reveal(this.selectList.getFocus()[0] || 0);
            }
            if (this._hasDetails) {
                // Leave the selectDropDownContainer to size itself according to children (list + details) - #57447
                this.selectList.getHTMLElement().style.height = listHeight + verticalPadding + "px";
                this.selectDropDownContainer.style.height = "";
            } else this.selectDropDownContainer.style.height = listHeight + verticalPadding + "px";
            this.updateDetail(this.selected);
            this.selectDropDownContainer.style.width = selectOptimalWidth;
            // Maintain focus outline on parent select as well as list container - tabindex for focus
            this.selectDropDownListContainer.setAttribute("tabindex", "0");
            this.selectElement.classList.add("synthetic-focus");
            this.selectDropDownContainer.classList.add("synthetic-focus");
            return true;
        } else return false;
    }
    setWidthControlElement(container) {
        let elementWidth = 0;
        if (container) {
            let longest = 0;
            let longestLength = 0;
            this.options.forEach((option, index)=>{
                const detailLength = !!option.detail ? option.detail.length : 0;
                const rightDecoratorLength = !!option.decoratorRight ? option.decoratorRight.length : 0;
                const len = option.text.length + detailLength + rightDecoratorLength;
                if (len > longestLength) {
                    longest = index;
                    longestLength = len;
                }
            });
            container.textContent = this.options[longest].text + (!!this.options[longest].decoratorRight ? this.options[longest].decoratorRight + " " : "");
            elementWidth = _domJs.getTotalWidth(container);
        }
        return elementWidth;
    }
    createSelectList(parent) {
        // If we have already constructive list on open, skip
        if (this.selectList) return;
        // SetUp container for list
        this.selectDropDownListContainer = _domJs.append(parent, $(".select-box-dropdown-list-container"));
        this.listRenderer = new SelectListRenderer();
        this.selectList = this._register(new (0, _listWidgetJs.List)("SelectBoxCustom", this.selectDropDownListContainer, this, [
            this.listRenderer
        ], {
            useShadows: false,
            verticalScrollMode: 3 /* ScrollbarVisibility.Visible */ ,
            keyboardSupport: false,
            mouseSupport: false,
            accessibilityProvider: {
                getAriaLabel: (element)=>{
                    let label = element.text;
                    if (element.detail) label += `. ${element.detail}`;
                    if (element.decoratorRight) label += `. ${element.decoratorRight}`;
                    if (element.description) label += `. ${element.description}`;
                    return label;
                },
                getWidgetAriaLabel: ()=>(0, _nlsJs.localize)({
                        key: "selectBox",
                        comment: [
                            "Behave like native select dropdown element."
                        ]
                    }, "Select Box"),
                getRole: ()=>(0, _platformJs.isMacintosh) ? "" : "option",
                getWidgetRole: ()=>"listbox"
            }
        }));
        if (this.selectBoxOptions.ariaLabel) this.selectList.ariaLabel = this.selectBoxOptions.ariaLabel;
        // SetUp list keyboard controller - control navigation, disabled items, focus
        const onKeyDown = this._register(new (0, _eventJs.DomEmitter)(this.selectDropDownListContainer, "keydown"));
        const onSelectDropDownKeyDown = (0, _eventJs1.Event).chain(onKeyDown.event, ($)=>$.filter(()=>this.selectList.length > 0).map((e)=>new (0, _keyboardEventJs.StandardKeyboardEvent)(e)));
        this._register((0, _eventJs1.Event).chain(onSelectDropDownKeyDown, ($)=>$.filter((e)=>e.keyCode === 3 /* KeyCode.Enter */ ))(this.onEnter, this));
        this._register((0, _eventJs1.Event).chain(onSelectDropDownKeyDown, ($)=>$.filter((e)=>e.keyCode === 2 /* KeyCode.Tab */ ))(this.onEnter, this)); // Tab should behave the same as enter, #79339
        this._register((0, _eventJs1.Event).chain(onSelectDropDownKeyDown, ($)=>$.filter((e)=>e.keyCode === 9 /* KeyCode.Escape */ ))(this.onEscape, this));
        this._register((0, _eventJs1.Event).chain(onSelectDropDownKeyDown, ($)=>$.filter((e)=>e.keyCode === 16 /* KeyCode.UpArrow */ ))(this.onUpArrow, this));
        this._register((0, _eventJs1.Event).chain(onSelectDropDownKeyDown, ($)=>$.filter((e)=>e.keyCode === 18 /* KeyCode.DownArrow */ ))(this.onDownArrow, this));
        this._register((0, _eventJs1.Event).chain(onSelectDropDownKeyDown, ($)=>$.filter((e)=>e.keyCode === 12 /* KeyCode.PageDown */ ))(this.onPageDown, this));
        this._register((0, _eventJs1.Event).chain(onSelectDropDownKeyDown, ($)=>$.filter((e)=>e.keyCode === 11 /* KeyCode.PageUp */ ))(this.onPageUp, this));
        this._register((0, _eventJs1.Event).chain(onSelectDropDownKeyDown, ($)=>$.filter((e)=>e.keyCode === 14 /* KeyCode.Home */ ))(this.onHome, this));
        this._register((0, _eventJs1.Event).chain(onSelectDropDownKeyDown, ($)=>$.filter((e)=>e.keyCode === 13 /* KeyCode.End */ ))(this.onEnd, this));
        this._register((0, _eventJs1.Event).chain(onSelectDropDownKeyDown, ($)=>$.filter((e)=>e.keyCode >= 21 /* KeyCode.Digit0 */  && e.keyCode <= 56 /* KeyCode.KeyZ */  || e.keyCode >= 85 /* KeyCode.Semicolon */  && e.keyCode <= 113 /* KeyCode.NumpadDivide */ ))(this.onCharacter, this));
        // SetUp list mouse controller - control navigation, disabled items, focus
        this._register(_domJs.addDisposableListener(this.selectList.getHTMLElement(), _domJs.EventType.POINTER_UP, (e)=>this.onPointerUp(e)));
        this._register(this.selectList.onMouseOver((e)=>typeof e.index !== "undefined" && this.selectList.setFocus([
                e.index
            ])));
        this._register(this.selectList.onDidChangeFocus((e)=>this.onListFocus(e)));
        this._register(_domJs.addDisposableListener(this.selectDropDownContainer, _domJs.EventType.FOCUS_OUT, (e)=>{
            if (!this._isVisible || _domJs.isAncestor(e.relatedTarget, this.selectDropDownContainer)) return;
            this.onListBlur();
        }));
        this.selectList.getHTMLElement().setAttribute("aria-label", this.selectBoxOptions.ariaLabel || "");
        this.selectList.getHTMLElement().setAttribute("aria-expanded", "true");
        this.styleList();
    }
    // List methods
    // List mouse controller - active exit, select option, fire onDidSelect if change, return focus to parent select
    // Also takes in touchend events
    onPointerUp(e) {
        if (!this.selectList.length) return;
        _domJs.EventHelper.stop(e);
        const target = e.target;
        if (!target) return;
        // Check our mouse event is on an option (not scrollbar)
        if (target.classList.contains("slider")) return;
        const listRowElement = target.closest(".monaco-list-row");
        if (!listRowElement) return;
        const index = Number(listRowElement.getAttribute("data-index"));
        const disabled = listRowElement.classList.contains("option-disabled");
        // Ignore mouse selection of disabled options
        if (index >= 0 && index < this.options.length && !disabled) {
            this.selected = index;
            this.select(this.selected);
            this.selectList.setFocus([
                this.selected
            ]);
            this.selectList.reveal(this.selectList.getFocus()[0]);
            // Only fire if selection change
            if (this.selected !== this._currentSelection) {
                // Set current = selected
                this._currentSelection = this.selected;
                this._onDidSelect.fire({
                    index: this.selectElement.selectedIndex,
                    selected: this.options[this.selected].text
                });
                if (!!this.options[this.selected] && !!this.options[this.selected].text) this.setTitle(this.options[this.selected].text);
            }
            this.hideSelectDropDown(true);
        }
    }
    // List Exit - passive - implicit no selection change, hide drop-down
    onListBlur() {
        if (this._sticky) return;
        if (this.selected !== this._currentSelection) // Reset selected to current if no change
        this.select(this._currentSelection);
        this.hideSelectDropDown(false);
    }
    renderDescriptionMarkdown(text, actionHandler) {
        const cleanRenderedMarkdown = (element)=>{
            for(let i = 0; i < element.childNodes.length; i++){
                const child = element.childNodes.item(i);
                const tagName = child.tagName && child.tagName.toLowerCase();
                if (tagName === "img") child.remove();
                else cleanRenderedMarkdown(child);
            }
        };
        const rendered = (0, _markdownRendererJs.renderMarkdown)({
            value: text,
            supportThemeIcons: true
        }, {
            actionHandler
        });
        rendered.element.classList.add("select-box-description-markdown");
        cleanRenderedMarkdown(rendered.element);
        return rendered.element;
    }
    // List Focus Change - passive - update details pane with newly focused element's data
    onListFocus(e) {
        // Skip during initial layout
        if (!this._isVisible || !this._hasDetails) return;
        this.updateDetail(e.indexes[0]);
    }
    updateDetail(selectedIndex) {
        this.selectionDetailsPane.innerText = "";
        const option = this.options[selectedIndex];
        const description = option?.description ?? "";
        const descriptionIsMarkdown = option?.descriptionIsMarkdown ?? false;
        if (description) {
            if (descriptionIsMarkdown) {
                const actionHandler = option.descriptionMarkdownActionHandler;
                this.selectionDetailsPane.appendChild(this.renderDescriptionMarkdown(description, actionHandler));
            } else this.selectionDetailsPane.innerText = description;
            this.selectionDetailsPane.style.display = "block";
        } else this.selectionDetailsPane.style.display = "none";
        // Avoid recursion
        this._skipLayout = true;
        this.contextViewProvider.layout();
        this._skipLayout = false;
    }
    // List keyboard controller
    // List exit - active - hide ContextView dropdown, reset selection, return focus to parent select
    onEscape(e) {
        _domJs.EventHelper.stop(e);
        // Reset selection to value when opened
        this.select(this._currentSelection);
        this.hideSelectDropDown(true);
    }
    // List exit - active - hide ContextView dropdown, return focus to parent select, fire onDidSelect if change
    onEnter(e) {
        _domJs.EventHelper.stop(e);
        // Only fire if selection change
        if (this.selected !== this._currentSelection) {
            this._currentSelection = this.selected;
            this._onDidSelect.fire({
                index: this.selectElement.selectedIndex,
                selected: this.options[this.selected].text
            });
            if (!!this.options[this.selected] && !!this.options[this.selected].text) this.setTitle(this.options[this.selected].text);
        }
        this.hideSelectDropDown(true);
    }
    // List navigation - have to handle a disabled option (jump over)
    onDownArrow(e) {
        if (this.selected < this.options.length - 1) {
            _domJs.EventHelper.stop(e, true);
            // Skip disabled options
            const nextOptionDisabled = this.options[this.selected + 1].isDisabled;
            if (nextOptionDisabled && this.options.length > this.selected + 2) this.selected += 2;
            else if (nextOptionDisabled) return;
            else this.selected++;
            // Set focus/selection - only fire event when closing drop-down or on blur
            this.select(this.selected);
            this.selectList.setFocus([
                this.selected
            ]);
            this.selectList.reveal(this.selectList.getFocus()[0]);
        }
    }
    onUpArrow(e) {
        if (this.selected > 0) {
            _domJs.EventHelper.stop(e, true);
            // Skip disabled options
            const previousOptionDisabled = this.options[this.selected - 1].isDisabled;
            if (previousOptionDisabled && this.selected > 1) this.selected -= 2;
            else this.selected--;
            // Set focus/selection - only fire event when closing drop-down or on blur
            this.select(this.selected);
            this.selectList.setFocus([
                this.selected
            ]);
            this.selectList.reveal(this.selectList.getFocus()[0]);
        }
    }
    onPageUp(e) {
        _domJs.EventHelper.stop(e);
        this.selectList.focusPreviousPage();
        // Allow scrolling to settle
        setTimeout(()=>{
            this.selected = this.selectList.getFocus()[0];
            // Shift selection down if we land on a disabled option
            if (this.options[this.selected].isDisabled && this.selected < this.options.length - 1) {
                this.selected++;
                this.selectList.setFocus([
                    this.selected
                ]);
            }
            this.selectList.reveal(this.selected);
            this.select(this.selected);
        }, 1);
    }
    onPageDown(e) {
        _domJs.EventHelper.stop(e);
        this.selectList.focusNextPage();
        // Allow scrolling to settle
        setTimeout(()=>{
            this.selected = this.selectList.getFocus()[0];
            // Shift selection up if we land on a disabled option
            if (this.options[this.selected].isDisabled && this.selected > 0) {
                this.selected--;
                this.selectList.setFocus([
                    this.selected
                ]);
            }
            this.selectList.reveal(this.selected);
            this.select(this.selected);
        }, 1);
    }
    onHome(e) {
        _domJs.EventHelper.stop(e);
        if (this.options.length < 2) return;
        this.selected = 0;
        if (this.options[this.selected].isDisabled && this.selected > 1) this.selected++;
        this.selectList.setFocus([
            this.selected
        ]);
        this.selectList.reveal(this.selected);
        this.select(this.selected);
    }
    onEnd(e) {
        _domJs.EventHelper.stop(e);
        if (this.options.length < 2) return;
        this.selected = this.options.length - 1;
        if (this.options[this.selected].isDisabled && this.selected > 1) this.selected--;
        this.selectList.setFocus([
            this.selected
        ]);
        this.selectList.reveal(this.selected);
        this.select(this.selected);
    }
    // Mimic option first character navigation of native select
    onCharacter(e) {
        const ch = (0, _keyCodesJs.KeyCodeUtils).toString(e.keyCode);
        let optionIndex = -1;
        for(let i = 0; i < this.options.length - 1; i++){
            optionIndex = (i + this.selected + 1) % this.options.length;
            if (this.options[optionIndex].text.charAt(0).toUpperCase() === ch && !this.options[optionIndex].isDisabled) {
                this.select(optionIndex);
                this.selectList.setFocus([
                    optionIndex
                ]);
                this.selectList.reveal(this.selectList.getFocus()[0]);
                _domJs.EventHelper.stop(e);
                break;
            }
        }
    }
    dispose() {
        this.hideSelectDropDown(false);
        super.dispose();
    }
}

},{"../../dom.js":"bnqsM","../../event.js":"PHN3G","../../keyboardEvent.js":"bxU9U","../../markdownRenderer.js":"3fw7s","../hover/hoverDelegate2.js":"5jqL3","../hover/hoverDelegateFactory.js":"kll4h","../list/listWidget.js":"f6tmg","../../../common/arrays.js":"DECei","../../../common/event.js":"4Zi8b","../../../common/keyCodes.js":"bHiG9","../../../common/lifecycle.js":"9kg8d","../../../common/platform.js":"7maJO","./selectBoxCustom.css":"10G0b","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5jqL3":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sets the hover delegate for use **only in the `base/` layer**.
 */ parcelHelpers.export(exports, "setBaseLayerHoverDelegate", ()=>setBaseLayerHoverDelegate);
/**
 * Gets the hover delegate for use **only in the `base/` layer**.
 *
 * Since the hover service depends on various platform services, this delegate essentially bypasses
 * the standard dependency injection mechanism by injecting a global hover service at start up. The
 * only reason this should be used is if `IHoverService` is not available.
 */ parcelHelpers.export(exports, "getBaseLayerHoverDelegate", ()=>getBaseLayerHoverDelegate);
let baseHoverDelegate = {
    showHover: ()=>undefined,
    hideHover: ()=>undefined,
    showAndFocusLastHover: ()=>undefined,
    setupManagedHover: ()=>null,
    showManagedHover: ()=>undefined
};
function setBaseLayerHoverDelegate(hoverDelegate) {
    baseHoverDelegate = hoverDelegate;
}
function getBaseLayerHoverDelegate() {
    return baseHoverDelegate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f6tmg":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInputElement", ()=>isInputElement);
parcelHelpers.export(exports, "isMonacoEditor", ()=>isMonacoEditor);
parcelHelpers.export(exports, "isMonacoCustomToggle", ()=>isMonacoCustomToggle);
parcelHelpers.export(exports, "isActionItem", ()=>isActionItem);
parcelHelpers.export(exports, "isStickyScrollElement", ()=>isStickyScrollElement);
parcelHelpers.export(exports, "isStickyScrollContainer", ()=>isStickyScrollContainer);
parcelHelpers.export(exports, "isButton", ()=>isButton);
parcelHelpers.export(exports, "TypeNavigationMode", ()=>TypeNavigationMode);
parcelHelpers.export(exports, "DefaultKeyboardNavigationDelegate", ()=>DefaultKeyboardNavigationDelegate);
parcelHelpers.export(exports, "isSelectionSingleChangeEvent", ()=>isSelectionSingleChangeEvent);
parcelHelpers.export(exports, "isSelectionRangeChangeEvent", ()=>isSelectionRangeChangeEvent);
parcelHelpers.export(exports, "MouseController", ()=>MouseController);
parcelHelpers.export(exports, "DefaultStyleController", ()=>DefaultStyleController);
parcelHelpers.export(exports, "unthemedListStyles", ()=>unthemedListStyles);
/**
 * The {@link List} is a virtual scrolling widget, built on top of the {@link ListView}
 * widget.
 *
 * Features:
 * - Customizable keyboard and mouse support
 * - Element traits: focus, selection, achor
 * - Accessibility support
 * - Touch support
 * - Performant template-based rendering
 * - Horizontal scrolling
 * - Variable element height support
 * - Dynamic element height support
 * - Drag-and-drop support
 */ parcelHelpers.export(exports, "List", ()=>List);
var _domJs = require("../../dom.js");
var _eventJs = require("../../event.js");
var _keyboardEventJs = require("../../keyboardEvent.js");
var _touchJs = require("../../touch.js");
var _ariaJs = require("../aria/aria.js");
var _spliceJs = require("./splice.js");
var _arraysJs = require("../../../common/arrays.js");
var _asyncJs = require("../../../common/async.js");
var _colorJs = require("../../../common/color.js");
var _decoratorsJs = require("../../../common/decorators.js");
var _eventJs1 = require("../../../common/event.js");
var _filtersJs = require("../../../common/filters.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _numbersJs = require("../../../common/numbers.js");
var _platformJs = require("../../../common/platform.js");
var _typesJs = require("../../../common/types.js");
var _listCss = require("./list.css");
var _listJs = require("./list.js");
var _listViewJs = require("./listView.js");
var _mouseEventJs = require("../../mouseEvent.js");
var _observableJs = require("../../../common/observable.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class TraitRenderer {
    constructor(trait){
        this.trait = trait;
        this.renderedElements = [];
    }
    get templateId() {
        return `template:${this.trait.name}`;
    }
    renderTemplate(container) {
        return container;
    }
    renderElement(element, index, templateData) {
        const renderedElementIndex = this.renderedElements.findIndex((el)=>el.templateData === templateData);
        if (renderedElementIndex >= 0) {
            const rendered = this.renderedElements[renderedElementIndex];
            this.trait.unrender(templateData);
            rendered.index = index;
        } else {
            const rendered = {
                index,
                templateData
            };
            this.renderedElements.push(rendered);
        }
        this.trait.renderIndex(index, templateData);
    }
    splice(start, deleteCount, insertCount) {
        const rendered = [];
        for (const renderedElement of this.renderedElements){
            if (renderedElement.index < start) rendered.push(renderedElement);
            else if (renderedElement.index >= start + deleteCount) rendered.push({
                index: renderedElement.index + insertCount - deleteCount,
                templateData: renderedElement.templateData
            });
        }
        this.renderedElements = rendered;
    }
    renderIndexes(indexes) {
        for (const { index, templateData } of this.renderedElements)if (indexes.indexOf(index) > -1) this.trait.renderIndex(index, templateData);
    }
    disposeTemplate(templateData) {
        const index = this.renderedElements.findIndex((el)=>el.templateData === templateData);
        if (index < 0) return;
        this.renderedElements.splice(index, 1);
    }
}
class Trait {
    get name() {
        return this._trait;
    }
    get renderer() {
        return new TraitRenderer(this);
    }
    constructor(_trait){
        this._trait = _trait;
        this.indexes = [];
        this.sortedIndexes = [];
        this._onChange = new (0, _eventJs1.Emitter)();
        this.onChange = this._onChange.event;
    }
    splice(start, deleteCount, elements) {
        const diff = elements.length - deleteCount;
        const end = start + deleteCount;
        const sortedIndexes = [];
        let i = 0;
        while(i < this.sortedIndexes.length && this.sortedIndexes[i] < start)sortedIndexes.push(this.sortedIndexes[i++]);
        for(let j = 0; j < elements.length; j++)if (elements[j]) sortedIndexes.push(j + start);
        while(i < this.sortedIndexes.length && this.sortedIndexes[i] >= end)sortedIndexes.push(this.sortedIndexes[i++] + diff);
        this.renderer.splice(start, deleteCount, elements.length);
        this._set(sortedIndexes, sortedIndexes);
    }
    renderIndex(index, container) {
        container.classList.toggle(this._trait, this.contains(index));
    }
    unrender(container) {
        container.classList.remove(this._trait);
    }
    /**
     * Sets the indexes which should have this trait.
     *
     * @param indexes Indexes which should have this trait.
     * @return The old indexes which had this trait.
     */ set(indexes, browserEvent) {
        return this._set(indexes, [
            ...indexes
        ].sort(numericSort), browserEvent);
    }
    _set(indexes, sortedIndexes, browserEvent) {
        const result = this.indexes;
        const sortedResult = this.sortedIndexes;
        this.indexes = indexes;
        this.sortedIndexes = sortedIndexes;
        const toRender = disjunction(sortedResult, indexes);
        this.renderer.renderIndexes(toRender);
        this._onChange.fire({
            indexes,
            browserEvent
        });
        return result;
    }
    get() {
        return this.indexes;
    }
    contains(index) {
        return (0, _arraysJs.binarySearch)(this.sortedIndexes, index, numericSort) >= 0;
    }
    dispose() {
        (0, _lifecycleJs.dispose)(this._onChange);
    }
}
__decorate([
    (0, _decoratorsJs.memoize)
], Trait.prototype, "renderer", null);
class SelectionTrait extends Trait {
    constructor(setAriaSelected){
        super("selected");
        this.setAriaSelected = setAriaSelected;
    }
    renderIndex(index, container) {
        super.renderIndex(index, container);
        if (this.setAriaSelected) {
            if (this.contains(index)) container.setAttribute("aria-selected", "true");
            else container.setAttribute("aria-selected", "false");
        }
    }
}
/**
 * The TraitSpliceable is used as a util class to be able
 * to preserve traits across splice calls, given an identity
 * provider.
 */ class TraitSpliceable {
    constructor(trait, view, identityProvider){
        this.trait = trait;
        this.view = view;
        this.identityProvider = identityProvider;
    }
    splice(start, deleteCount, elements) {
        if (!this.identityProvider) return this.trait.splice(start, deleteCount, new Array(elements.length).fill(false));
        const pastElementsWithTrait = this.trait.get().map((i)=>this.identityProvider.getId(this.view.element(i)).toString());
        if (pastElementsWithTrait.length === 0) return this.trait.splice(start, deleteCount, new Array(elements.length).fill(false));
        const pastElementsWithTraitSet = new Set(pastElementsWithTrait);
        const elementsWithTrait = elements.map((e)=>pastElementsWithTraitSet.has(this.identityProvider.getId(e).toString()));
        this.trait.splice(start, deleteCount, elementsWithTrait);
    }
}
function isInputElement(e) {
    return e.tagName === "INPUT" || e.tagName === "TEXTAREA";
}
function isListElementDescendantOfClass(e, className) {
    if (e.classList.contains(className)) return true;
    if (e.classList.contains("monaco-list")) return false;
    if (!e.parentElement) return false;
    return isListElementDescendantOfClass(e.parentElement, className);
}
function isMonacoEditor(e) {
    return isListElementDescendantOfClass(e, "monaco-editor");
}
function isMonacoCustomToggle(e) {
    return isListElementDescendantOfClass(e, "monaco-custom-toggle");
}
function isActionItem(e) {
    return isListElementDescendantOfClass(e, "action-item");
}
function isStickyScrollElement(e) {
    return isListElementDescendantOfClass(e, "monaco-tree-sticky-row");
}
function isStickyScrollContainer(e) {
    return e.classList.contains("monaco-tree-sticky-container");
}
function isButton(e) {
    if (e.tagName === "A" && e.classList.contains("monaco-button") || e.tagName === "DIV" && e.classList.contains("monaco-button-dropdown")) return true;
    if (e.classList.contains("monaco-list")) return false;
    if (!e.parentElement) return false;
    return isButton(e.parentElement);
}
class KeyboardController {
    get onKeyDown() {
        return (0, _eventJs1.Event).chain(this.disposables.add(new (0, _eventJs.DomEmitter)(this.view.domNode, "keydown")).event, ($)=>$.filter((e)=>!isInputElement(e.target)).map((e)=>new (0, _keyboardEventJs.StandardKeyboardEvent)(e)));
    }
    constructor(list, view, options){
        this.list = list;
        this.view = view;
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this.multipleSelectionDisposables = new (0, _lifecycleJs.DisposableStore)();
        this.multipleSelectionSupport = options.multipleSelectionSupport;
        this.disposables.add(this.onKeyDown((e)=>{
            switch(e.keyCode){
                case 3 /* KeyCode.Enter */ :
                    return this.onEnter(e);
                case 16 /* KeyCode.UpArrow */ :
                    return this.onUpArrow(e);
                case 18 /* KeyCode.DownArrow */ :
                    return this.onDownArrow(e);
                case 11 /* KeyCode.PageUp */ :
                    return this.onPageUpArrow(e);
                case 12 /* KeyCode.PageDown */ :
                    return this.onPageDownArrow(e);
                case 9 /* KeyCode.Escape */ :
                    return this.onEscape(e);
                case 31 /* KeyCode.KeyA */ :
                    if (this.multipleSelectionSupport && (_platformJs.isMacintosh ? e.metaKey : e.ctrlKey)) this.onCtrlA(e);
            }
        }));
    }
    updateOptions(optionsUpdate) {
        if (optionsUpdate.multipleSelectionSupport !== undefined) this.multipleSelectionSupport = optionsUpdate.multipleSelectionSupport;
    }
    onEnter(e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.setSelection(this.list.getFocus(), e.browserEvent);
    }
    onUpArrow(e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.focusPrevious(1, false, e.browserEvent);
        const el = this.list.getFocus()[0];
        this.list.setAnchor(el);
        this.list.reveal(el);
        this.view.domNode.focus();
    }
    onDownArrow(e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.focusNext(1, false, e.browserEvent);
        const el = this.list.getFocus()[0];
        this.list.setAnchor(el);
        this.list.reveal(el);
        this.view.domNode.focus();
    }
    onPageUpArrow(e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.focusPreviousPage(e.browserEvent);
        const el = this.list.getFocus()[0];
        this.list.setAnchor(el);
        this.list.reveal(el);
        this.view.domNode.focus();
    }
    onPageDownArrow(e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.focusNextPage(e.browserEvent);
        const el = this.list.getFocus()[0];
        this.list.setAnchor(el);
        this.list.reveal(el);
        this.view.domNode.focus();
    }
    onCtrlA(e) {
        e.preventDefault();
        e.stopPropagation();
        this.list.setSelection((0, _arraysJs.range)(this.list.length), e.browserEvent);
        this.list.setAnchor(undefined);
        this.view.domNode.focus();
    }
    onEscape(e) {
        if (this.list.getSelection().length) {
            e.preventDefault();
            e.stopPropagation();
            this.list.setSelection([], e.browserEvent);
            this.list.setAnchor(undefined);
            this.view.domNode.focus();
        }
    }
    dispose() {
        this.disposables.dispose();
        this.multipleSelectionDisposables.dispose();
    }
}
__decorate([
    (0, _decoratorsJs.memoize)
], KeyboardController.prototype, "onKeyDown", null);
var TypeNavigationMode;
(function(TypeNavigationMode) {
    TypeNavigationMode[TypeNavigationMode["Automatic"] = 0] = "Automatic";
    TypeNavigationMode[TypeNavigationMode["Trigger"] = 1] = "Trigger";
})(TypeNavigationMode || (TypeNavigationMode = {}));
var TypeNavigationControllerState;
(function(TypeNavigationControllerState) {
    TypeNavigationControllerState[TypeNavigationControllerState["Idle"] = 0] = "Idle";
    TypeNavigationControllerState[TypeNavigationControllerState["Typing"] = 1] = "Typing";
})(TypeNavigationControllerState || (TypeNavigationControllerState = {}));
const DefaultKeyboardNavigationDelegate = new class {
    mightProducePrintableCharacter(event) {
        if (event.ctrlKey || event.metaKey || event.altKey) return false;
        return event.keyCode >= 31 /* KeyCode.KeyA */  && event.keyCode <= 56 /* KeyCode.KeyZ */  || event.keyCode >= 21 /* KeyCode.Digit0 */  && event.keyCode <= 30 /* KeyCode.Digit9 */  || event.keyCode >= 98 /* KeyCode.Numpad0 */  && event.keyCode <= 107 /* KeyCode.Numpad9 */  || event.keyCode >= 85 /* KeyCode.Semicolon */  && event.keyCode <= 95 /* KeyCode.Quote */ ;
    }
};
class TypeNavigationController {
    constructor(list, view, keyboardNavigationLabelProvider, keyboardNavigationEventFilter, delegate){
        this.list = list;
        this.view = view;
        this.keyboardNavigationLabelProvider = keyboardNavigationLabelProvider;
        this.keyboardNavigationEventFilter = keyboardNavigationEventFilter;
        this.delegate = delegate;
        this.enabled = false;
        this.state = TypeNavigationControllerState.Idle;
        this.mode = TypeNavigationMode.Automatic;
        this.triggered = false;
        this.previouslyFocused = -1;
        this.enabledDisposables = new (0, _lifecycleJs.DisposableStore)();
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this.updateOptions(list.options);
    }
    updateOptions(options) {
        if (options.typeNavigationEnabled ?? true) this.enable();
        else this.disable();
        this.mode = options.typeNavigationMode ?? TypeNavigationMode.Automatic;
    }
    enable() {
        if (this.enabled) return;
        let typing = false;
        const onChar = (0, _eventJs1.Event).chain(this.enabledDisposables.add(new (0, _eventJs.DomEmitter)(this.view.domNode, "keydown")).event, ($)=>$.filter((e)=>!isInputElement(e.target)).filter(()=>this.mode === TypeNavigationMode.Automatic || this.triggered).map((event)=>new (0, _keyboardEventJs.StandardKeyboardEvent)(event)).filter((e)=>typing || this.keyboardNavigationEventFilter(e)).filter((e)=>this.delegate.mightProducePrintableCharacter(e)).forEach((e)=>(0, _domJs.EventHelper).stop(e, true)).map((event)=>event.browserEvent.key));
        const onClear = (0, _eventJs1.Event).debounce(onChar, ()=>null, 800, undefined, undefined, undefined, this.enabledDisposables);
        const onInput = (0, _eventJs1.Event).reduce((0, _eventJs1.Event).any(onChar, onClear), (r, i)=>i === null ? null : (r || "") + i, undefined, this.enabledDisposables);
        onInput(this.onInput, this, this.enabledDisposables);
        onClear(this.onClear, this, this.enabledDisposables);
        onChar(()=>typing = true, undefined, this.enabledDisposables);
        onClear(()=>typing = false, undefined, this.enabledDisposables);
        this.enabled = true;
        this.triggered = false;
    }
    disable() {
        if (!this.enabled) return;
        this.enabledDisposables.clear();
        this.enabled = false;
        this.triggered = false;
    }
    onClear() {
        const focus = this.list.getFocus();
        if (focus.length > 0 && focus[0] === this.previouslyFocused) {
            // List: re-announce element on typing end since typed keys will interrupt aria label of focused element
            // Do not announce if there was a focus change at the end to prevent duplication https://github.com/microsoft/vscode/issues/95961
            const ariaLabel = this.list.options.accessibilityProvider?.getAriaLabel(this.list.element(focus[0]));
            if (typeof ariaLabel === "string") (0, _ariaJs.alert)(ariaLabel);
            else if (ariaLabel) (0, _ariaJs.alert)(ariaLabel.get());
        }
        this.previouslyFocused = -1;
    }
    onInput(word) {
        if (!word) {
            this.state = TypeNavigationControllerState.Idle;
            this.triggered = false;
            return;
        }
        const focus = this.list.getFocus();
        const start = focus.length > 0 ? focus[0] : 0;
        const delta = this.state === TypeNavigationControllerState.Idle ? 1 : 0;
        this.state = TypeNavigationControllerState.Typing;
        for(let i = 0; i < this.list.length; i++){
            const index = (start + i + delta) % this.list.length;
            const label = this.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(this.view.element(index));
            const labelStr = label && label.toString();
            if (this.list.options.typeNavigationEnabled) {
                if (typeof labelStr !== "undefined") {
                    // If prefix is found, focus and return early
                    if ((0, _filtersJs.matchesPrefix)(word, labelStr)) {
                        this.previouslyFocused = start;
                        this.list.setFocus([
                            index
                        ]);
                        this.list.reveal(index);
                        return;
                    }
                    const fuzzy = (0, _filtersJs.matchesFuzzy2)(word, labelStr);
                    if (fuzzy) {
                        const fuzzyScore = fuzzy[0].end - fuzzy[0].start;
                        // ensures that when fuzzy matching, doesn't clash with prefix matching (1 input vs 1+ should be prefix and fuzzy respecitvely). Also makes sure that exact matches are prioritized.
                        if (fuzzyScore > 1 && fuzzy.length === 1) {
                            this.previouslyFocused = start;
                            this.list.setFocus([
                                index
                            ]);
                            this.list.reveal(index);
                            return;
                        }
                    }
                }
            } else if (typeof labelStr === "undefined" || (0, _filtersJs.matchesPrefix)(word, labelStr)) {
                this.previouslyFocused = start;
                this.list.setFocus([
                    index
                ]);
                this.list.reveal(index);
                return;
            }
        }
    }
    dispose() {
        this.disable();
        this.enabledDisposables.dispose();
        this.disposables.dispose();
    }
}
class DOMFocusController {
    constructor(list, view){
        this.list = list;
        this.view = view;
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        const onKeyDown = (0, _eventJs1.Event).chain(this.disposables.add(new (0, _eventJs.DomEmitter)(view.domNode, "keydown")).event, ($)=>$.filter((e)=>!isInputElement(e.target)).map((e)=>new (0, _keyboardEventJs.StandardKeyboardEvent)(e)));
        const onTab = (0, _eventJs1.Event).chain(onKeyDown, ($)=>$.filter((e)=>e.keyCode === 2 /* KeyCode.Tab */  && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey));
        onTab(this.onTab, this, this.disposables);
    }
    onTab(e) {
        if (e.target !== this.view.domNode) return;
        const focus = this.list.getFocus();
        if (focus.length === 0) return;
        const focusedDomElement = this.view.domElement(focus[0]);
        if (!focusedDomElement) return;
        const tabIndexElement = focusedDomElement.querySelector("[tabIndex]");
        if (!tabIndexElement || !(0, _domJs.isHTMLElement)(tabIndexElement) || tabIndexElement.tabIndex === -1) return;
        const style = (0, _domJs.getWindow)(tabIndexElement).getComputedStyle(tabIndexElement);
        if (style.visibility === "hidden" || style.display === "none") return;
        e.preventDefault();
        e.stopPropagation();
        tabIndexElement.focus();
    }
    dispose() {
        this.disposables.dispose();
    }
}
function isSelectionSingleChangeEvent(event) {
    return _platformJs.isMacintosh ? event.browserEvent.metaKey : event.browserEvent.ctrlKey;
}
function isSelectionRangeChangeEvent(event) {
    return event.browserEvent.shiftKey;
}
function isMouseRightClick(event) {
    return (0, _domJs.isMouseEvent)(event) && event.button === 2;
}
const DefaultMultipleSelectionController = {
    isSelectionSingleChangeEvent,
    isSelectionRangeChangeEvent
};
class MouseController {
    constructor(list){
        this.list = list;
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this._onPointer = new (0, _eventJs1.Emitter)();
        this.onPointer = this._onPointer.event;
        if (list.options.multipleSelectionSupport !== false) this.multipleSelectionController = this.list.options.multipleSelectionController || DefaultMultipleSelectionController;
        this.mouseSupport = typeof list.options.mouseSupport === "undefined" || !!list.options.mouseSupport;
        if (this.mouseSupport) {
            list.onMouseDown(this.onMouseDown, this, this.disposables);
            list.onContextMenu(this.onContextMenu, this, this.disposables);
            list.onMouseDblClick(this.onDoubleClick, this, this.disposables);
            list.onTouchStart(this.onMouseDown, this, this.disposables);
            this.disposables.add((0, _touchJs.Gesture).addTarget(list.getHTMLElement()));
        }
        (0, _eventJs1.Event).any(list.onMouseClick, list.onMouseMiddleClick, list.onTap)(this.onViewPointer, this, this.disposables);
    }
    updateOptions(optionsUpdate) {
        if (optionsUpdate.multipleSelectionSupport !== undefined) {
            this.multipleSelectionController = undefined;
            if (optionsUpdate.multipleSelectionSupport) this.multipleSelectionController = this.list.options.multipleSelectionController || DefaultMultipleSelectionController;
        }
    }
    isSelectionSingleChangeEvent(event) {
        if (!this.multipleSelectionController) return false;
        return this.multipleSelectionController.isSelectionSingleChangeEvent(event);
    }
    isSelectionRangeChangeEvent(event) {
        if (!this.multipleSelectionController) return false;
        return this.multipleSelectionController.isSelectionRangeChangeEvent(event);
    }
    isSelectionChangeEvent(event) {
        return this.isSelectionSingleChangeEvent(event) || this.isSelectionRangeChangeEvent(event);
    }
    onMouseDown(e) {
        if (isMonacoEditor(e.browserEvent.target)) return;
        if ((0, _domJs.getActiveElement)() !== e.browserEvent.target) this.list.domFocus();
    }
    onContextMenu(e) {
        if (isInputElement(e.browserEvent.target) || isMonacoEditor(e.browserEvent.target)) return;
        const focus = typeof e.index === "undefined" ? [] : [
            e.index
        ];
        this.list.setFocus(focus, e.browserEvent);
    }
    onViewPointer(e) {
        if (!this.mouseSupport) return;
        if (isInputElement(e.browserEvent.target) || isMonacoEditor(e.browserEvent.target)) return;
        if (e.browserEvent.isHandledByList) return;
        e.browserEvent.isHandledByList = true;
        const focus = e.index;
        if (typeof focus === "undefined") {
            this.list.setFocus([], e.browserEvent);
            this.list.setSelection([], e.browserEvent);
            this.list.setAnchor(undefined);
            return;
        }
        if (this.isSelectionChangeEvent(e)) return this.changeSelection(e);
        this.list.setFocus([
            focus
        ], e.browserEvent);
        this.list.setAnchor(focus);
        if (!isMouseRightClick(e.browserEvent)) this.list.setSelection([
            focus
        ], e.browserEvent);
        this._onPointer.fire(e);
    }
    onDoubleClick(e) {
        if (isInputElement(e.browserEvent.target) || isMonacoEditor(e.browserEvent.target)) return;
        if (this.isSelectionChangeEvent(e)) return;
        if (e.browserEvent.isHandledByList) return;
        e.browserEvent.isHandledByList = true;
        const focus = this.list.getFocus();
        this.list.setSelection(focus, e.browserEvent);
    }
    changeSelection(e) {
        const focus = e.index;
        let anchor = this.list.getAnchor();
        if (this.isSelectionRangeChangeEvent(e)) {
            if (typeof anchor === "undefined") {
                const currentFocus = this.list.getFocus()[0];
                anchor = currentFocus ?? focus;
                this.list.setAnchor(anchor);
            }
            const min = Math.min(anchor, focus);
            const max = Math.max(anchor, focus);
            const rangeSelection = (0, _arraysJs.range)(min, max + 1);
            const selection = this.list.getSelection();
            const contiguousRange = getContiguousRangeContaining(disjunction(selection, [
                anchor
            ]), anchor);
            if (contiguousRange.length === 0) return;
            const newSelection = disjunction(rangeSelection, relativeComplement(selection, contiguousRange));
            this.list.setSelection(newSelection, e.browserEvent);
            this.list.setFocus([
                focus
            ], e.browserEvent);
        } else if (this.isSelectionSingleChangeEvent(e)) {
            const selection = this.list.getSelection();
            const newSelection = selection.filter((i)=>i !== focus);
            this.list.setFocus([
                focus
            ]);
            this.list.setAnchor(focus);
            if (selection.length === newSelection.length) this.list.setSelection([
                ...newSelection,
                focus
            ], e.browserEvent);
            else this.list.setSelection(newSelection, e.browserEvent);
        }
    }
    dispose() {
        this.disposables.dispose();
    }
}
class DefaultStyleController {
    constructor(styleElement, selectorSuffix){
        this.styleElement = styleElement;
        this.selectorSuffix = selectorSuffix;
    }
    style(styles) {
        const suffix = this.selectorSuffix && `.${this.selectorSuffix}`;
        const content = [];
        if (styles.listBackground) content.push(`.monaco-list${suffix} .monaco-list-rows { background: ${styles.listBackground}; }`);
        if (styles.listFocusBackground) {
            content.push(`.monaco-list${suffix}:focus .monaco-list-row.focused { background-color: ${styles.listFocusBackground}; }`);
            content.push(`.monaco-list${suffix}:focus .monaco-list-row.focused:hover { background-color: ${styles.listFocusBackground}; }`); // overwrite :hover style in this case!
        }
        if (styles.listFocusForeground) content.push(`.monaco-list${suffix}:focus .monaco-list-row.focused { color: ${styles.listFocusForeground}; }`);
        if (styles.listActiveSelectionBackground) {
            content.push(`.monaco-list${suffix}:focus .monaco-list-row.selected { background-color: ${styles.listActiveSelectionBackground}; }`);
            content.push(`.monaco-list${suffix}:focus .monaco-list-row.selected:hover { background-color: ${styles.listActiveSelectionBackground}; }`); // overwrite :hover style in this case!
        }
        if (styles.listActiveSelectionForeground) content.push(`.monaco-list${suffix}:focus .monaco-list-row.selected { color: ${styles.listActiveSelectionForeground}; }`);
        if (styles.listActiveSelectionIconForeground) content.push(`.monaco-list${suffix}:focus .monaco-list-row.selected .codicon { color: ${styles.listActiveSelectionIconForeground}; }`);
        if (styles.listFocusAndSelectionBackground) content.push(`
				.monaco-drag-image,
				.monaco-list${suffix}:focus .monaco-list-row.selected.focused { background-color: ${styles.listFocusAndSelectionBackground}; }
			`);
        if (styles.listFocusAndSelectionForeground) content.push(`
				.monaco-drag-image,
				.monaco-list${suffix}:focus .monaco-list-row.selected.focused { color: ${styles.listFocusAndSelectionForeground}; }
			`);
        if (styles.listInactiveFocusForeground) {
            content.push(`.monaco-list${suffix} .monaco-list-row.focused { color:  ${styles.listInactiveFocusForeground}; }`);
            content.push(`.monaco-list${suffix} .monaco-list-row.focused:hover { color:  ${styles.listInactiveFocusForeground}; }`); // overwrite :hover style in this case!
        }
        if (styles.listInactiveSelectionIconForeground) content.push(`.monaco-list${suffix} .monaco-list-row.focused .codicon { color:  ${styles.listInactiveSelectionIconForeground}; }`);
        if (styles.listInactiveFocusBackground) {
            content.push(`.monaco-list${suffix} .monaco-list-row.focused { background-color:  ${styles.listInactiveFocusBackground}; }`);
            content.push(`.monaco-list${suffix} .monaco-list-row.focused:hover { background-color:  ${styles.listInactiveFocusBackground}; }`); // overwrite :hover style in this case!
        }
        if (styles.listInactiveSelectionBackground) {
            content.push(`.monaco-list${suffix} .monaco-list-row.selected { background-color:  ${styles.listInactiveSelectionBackground}; }`);
            content.push(`.monaco-list${suffix} .monaco-list-row.selected:hover { background-color:  ${styles.listInactiveSelectionBackground}; }`); // overwrite :hover style in this case!
        }
        if (styles.listInactiveSelectionForeground) content.push(`.monaco-list${suffix} .monaco-list-row.selected { color: ${styles.listInactiveSelectionForeground}; }`);
        if (styles.listHoverBackground) content.push(`.monaco-list${suffix}:not(.drop-target):not(.dragging) .monaco-list-row:hover:not(.selected):not(.focused) { background-color: ${styles.listHoverBackground}; }`);
        if (styles.listHoverForeground) content.push(`.monaco-list${suffix}:not(.drop-target):not(.dragging) .monaco-list-row:hover:not(.selected):not(.focused) { color:  ${styles.listHoverForeground}; }`);
        /**
         * Outlines
         */ const focusAndSelectionOutline = (0, _domJs.asCssValueWithDefault)(styles.listFocusAndSelectionOutline, (0, _domJs.asCssValueWithDefault)(styles.listSelectionOutline, styles.listFocusOutline ?? ""));
        if (focusAndSelectionOutline) content.push(`.monaco-list${suffix}:focus .monaco-list-row.focused.selected { outline: 1px solid ${focusAndSelectionOutline}; outline-offset: -1px;}`);
        if (styles.listFocusOutline) content.push(`
				.monaco-drag-image,
				.monaco-list${suffix}:focus .monaco-list-row.focused { outline: 1px solid ${styles.listFocusOutline}; outline-offset: -1px; }
				.monaco-workbench.context-menu-visible .monaco-list${suffix}.last-focused .monaco-list-row.focused { outline: 1px solid ${styles.listFocusOutline}; outline-offset: -1px; }
			`);
        const inactiveFocusAndSelectionOutline = (0, _domJs.asCssValueWithDefault)(styles.listSelectionOutline, styles.listInactiveFocusOutline ?? "");
        if (inactiveFocusAndSelectionOutline) content.push(`.monaco-list${suffix} .monaco-list-row.focused.selected { outline: 1px dotted ${inactiveFocusAndSelectionOutline}; outline-offset: -1px; }`);
        if (styles.listSelectionOutline) content.push(`.monaco-list${suffix} .monaco-list-row.selected { outline: 1px dotted ${styles.listSelectionOutline}; outline-offset: -1px; }`);
        if (styles.listInactiveFocusOutline) content.push(`.monaco-list${suffix} .monaco-list-row.focused { outline: 1px dotted ${styles.listInactiveFocusOutline}; outline-offset: -1px; }`);
        if (styles.listHoverOutline) content.push(`.monaco-list${suffix} .monaco-list-row:hover { outline: 1px dashed ${styles.listHoverOutline}; outline-offset: -1px; }`);
        if (styles.listDropOverBackground) content.push(`
				.monaco-list${suffix}.drop-target,
				.monaco-list${suffix} .monaco-list-rows.drop-target,
				.monaco-list${suffix} .monaco-list-row.drop-target { background-color: ${styles.listDropOverBackground} !important; color: inherit !important; }
			`);
        if (styles.listDropBetweenBackground) {
            content.push(`
			.monaco-list${suffix} .monaco-list-rows.drop-target-before .monaco-list-row:first-child::before,
			.monaco-list${suffix} .monaco-list-row.drop-target-before::before {
				content: ""; position: absolute; top: 0px; left: 0px; width: 100%; height: 1px;
				background-color: ${styles.listDropBetweenBackground};
			}`);
            content.push(`
			.monaco-list${suffix} .monaco-list-rows.drop-target-after .monaco-list-row:last-child::after,
			.monaco-list${suffix} .monaco-list-row.drop-target-after::after {
				content: ""; position: absolute; bottom: 0px; left: 0px; width: 100%; height: 1px;
				background-color: ${styles.listDropBetweenBackground};
			}`);
        }
        if (styles.tableColumnsBorder) content.push(`
				.monaco-table > .monaco-split-view2,
				.monaco-table > .monaco-split-view2 .monaco-sash.vertical::before,
				.monaco-workbench:not(.reduce-motion) .monaco-table:hover > .monaco-split-view2,
				.monaco-workbench:not(.reduce-motion) .monaco-table:hover > .monaco-split-view2 .monaco-sash.vertical::before {
					border-color: ${styles.tableColumnsBorder};
				}

				.monaco-workbench:not(.reduce-motion) .monaco-table > .monaco-split-view2,
				.monaco-workbench:not(.reduce-motion) .monaco-table > .monaco-split-view2 .monaco-sash.vertical::before {
					border-color: transparent;
				}
			`);
        if (styles.tableOddRowsBackgroundColor) content.push(`
				.monaco-table .monaco-list-row[data-parity=odd]:not(.focused):not(.selected):not(:hover) .monaco-table-tr,
				.monaco-table .monaco-list:not(:focus) .monaco-list-row[data-parity=odd].focused:not(.selected):not(:hover) .monaco-table-tr,
				.monaco-table .monaco-list:not(.focused) .monaco-list-row[data-parity=odd].focused:not(.selected):not(:hover) .monaco-table-tr {
					background-color: ${styles.tableOddRowsBackgroundColor};
				}
			`);
        this.styleElement.textContent = content.join("\n");
    }
}
const unthemedListStyles = {
    listFocusBackground: "#7FB0D0",
    listActiveSelectionBackground: "#0E639C",
    listActiveSelectionForeground: "#FFFFFF",
    listActiveSelectionIconForeground: "#FFFFFF",
    listFocusAndSelectionOutline: "#90C2F9",
    listFocusAndSelectionBackground: "#094771",
    listFocusAndSelectionForeground: "#FFFFFF",
    listInactiveSelectionBackground: "#3F3F46",
    listInactiveSelectionIconForeground: "#FFFFFF",
    listHoverBackground: "#2A2D2E",
    listDropOverBackground: "#383B3D",
    listDropBetweenBackground: "#EEEEEE",
    treeIndentGuidesStroke: "#a9a9a9",
    treeInactiveIndentGuidesStroke: (0, _colorJs.Color).fromHex("#a9a9a9").transparent(0.4).toString(),
    tableColumnsBorder: (0, _colorJs.Color).fromHex("#cccccc").transparent(0.2).toString(),
    tableOddRowsBackgroundColor: (0, _colorJs.Color).fromHex("#cccccc").transparent(0.04).toString(),
    listBackground: undefined,
    listFocusForeground: undefined,
    listInactiveSelectionForeground: undefined,
    listInactiveFocusForeground: undefined,
    listInactiveFocusBackground: undefined,
    listHoverForeground: undefined,
    listFocusOutline: undefined,
    listInactiveFocusOutline: undefined,
    listSelectionOutline: undefined,
    listHoverOutline: undefined,
    treeStickyScrollBackground: undefined,
    treeStickyScrollBorder: undefined,
    treeStickyScrollShadow: undefined
};
const DefaultOptions = {
    keyboardSupport: true,
    mouseSupport: true,
    multipleSelectionSupport: true,
    dnd: {
        getDragURI () {
            return null;
        },
        onDragStart () {},
        onDragOver () {
            return false;
        },
        drop () {},
        dispose () {}
    }
};
// TODO@Joao: move these utils into a SortedArray class
function getContiguousRangeContaining(range, value) {
    const index = range.indexOf(value);
    if (index === -1) return [];
    const result = [];
    let i = index - 1;
    while(i >= 0 && range[i] === value - (index - i))result.push(range[i--]);
    result.reverse();
    i = index;
    while(i < range.length && range[i] === value + (i - index))result.push(range[i++]);
    return result;
}
/**
 * Given two sorted collections of numbers, returns the intersection
 * between them (OR).
 */ function disjunction(one, other) {
    const result = [];
    let i = 0, j = 0;
    while(i < one.length || j < other.length){
        if (i >= one.length) result.push(other[j++]);
        else if (j >= other.length) result.push(one[i++]);
        else if (one[i] === other[j]) {
            result.push(one[i]);
            i++;
            j++;
            continue;
        } else if (one[i] < other[j]) result.push(one[i++]);
        else result.push(other[j++]);
    }
    return result;
}
/**
 * Given two sorted collections of numbers, returns the relative
 * complement between them (XOR).
 */ function relativeComplement(one, other) {
    const result = [];
    let i = 0, j = 0;
    while(i < one.length || j < other.length){
        if (i >= one.length) result.push(other[j++]);
        else if (j >= other.length) result.push(one[i++]);
        else if (one[i] === other[j]) {
            i++;
            j++;
            continue;
        } else if (one[i] < other[j]) result.push(one[i++]);
        else j++;
    }
    return result;
}
const numericSort = (a, b)=>a - b;
class PipelineRenderer {
    constructor(_templateId, renderers){
        this._templateId = _templateId;
        this.renderers = renderers;
    }
    get templateId() {
        return this._templateId;
    }
    renderTemplate(container) {
        return this.renderers.map((r)=>r.renderTemplate(container));
    }
    renderElement(element, index, templateData, height) {
        let i = 0;
        for (const renderer of this.renderers)renderer.renderElement(element, index, templateData[i++], height);
    }
    disposeElement(element, index, templateData, height) {
        let i = 0;
        for (const renderer of this.renderers){
            renderer.disposeElement?.(element, index, templateData[i], height);
            i += 1;
        }
    }
    disposeTemplate(templateData) {
        let i = 0;
        for (const renderer of this.renderers)renderer.disposeTemplate(templateData[i++]);
    }
}
class AccessibiltyRenderer {
    constructor(accessibilityProvider){
        this.accessibilityProvider = accessibilityProvider;
        this.templateId = "a18n";
    }
    renderTemplate(container) {
        return {
            container,
            disposables: new (0, _lifecycleJs.DisposableStore)()
        };
    }
    renderElement(element, index, data) {
        const ariaLabel = this.accessibilityProvider.getAriaLabel(element);
        const observable = ariaLabel && typeof ariaLabel !== "string" ? ariaLabel : (0, _observableJs.constObservable)(ariaLabel);
        data.disposables.add((0, _observableJs.autorun)((reader)=>{
            this.setAriaLabel(reader.readObservable(observable), data.container);
        }));
        const ariaLevel = this.accessibilityProvider.getAriaLevel && this.accessibilityProvider.getAriaLevel(element);
        if (typeof ariaLevel === "number") data.container.setAttribute("aria-level", `${ariaLevel}`);
        else data.container.removeAttribute("aria-level");
    }
    setAriaLabel(ariaLabel, element) {
        if (ariaLabel) element.setAttribute("aria-label", ariaLabel);
        else element.removeAttribute("aria-label");
    }
    disposeElement(element, index, templateData, height) {
        templateData.disposables.clear();
    }
    disposeTemplate(templateData) {
        templateData.disposables.dispose();
    }
}
class ListViewDragAndDrop {
    constructor(list, dnd){
        this.list = list;
        this.dnd = dnd;
    }
    getDragElements(element) {
        const selection = this.list.getSelectedElements();
        const elements = selection.indexOf(element) > -1 ? selection : [
            element
        ];
        return elements;
    }
    getDragURI(element) {
        return this.dnd.getDragURI(element);
    }
    getDragLabel(elements, originalEvent) {
        if (this.dnd.getDragLabel) return this.dnd.getDragLabel(elements, originalEvent);
        return undefined;
    }
    onDragStart(data, originalEvent) {
        this.dnd.onDragStart?.(data, originalEvent);
    }
    onDragOver(data, targetElement, targetIndex, targetSector, originalEvent) {
        return this.dnd.onDragOver(data, targetElement, targetIndex, targetSector, originalEvent);
    }
    onDragLeave(data, targetElement, targetIndex, originalEvent) {
        this.dnd.onDragLeave?.(data, targetElement, targetIndex, originalEvent);
    }
    onDragEnd(originalEvent) {
        this.dnd.onDragEnd?.(originalEvent);
    }
    drop(data, targetElement, targetIndex, targetSector, originalEvent) {
        this.dnd.drop(data, targetElement, targetIndex, targetSector, originalEvent);
    }
    dispose() {
        this.dnd.dispose();
    }
}
class List {
    get onDidChangeFocus() {
        return (0, _eventJs1.Event).map(this.eventBufferer.wrapEvent(this.focus.onChange), (e)=>this.toListEvent(e), this.disposables);
    }
    get onDidChangeSelection() {
        return (0, _eventJs1.Event).map(this.eventBufferer.wrapEvent(this.selection.onChange), (e)=>this.toListEvent(e), this.disposables);
    }
    get domId() {
        return this.view.domId;
    }
    get onDidScroll() {
        return this.view.onDidScroll;
    }
    get onMouseClick() {
        return this.view.onMouseClick;
    }
    get onMouseDblClick() {
        return this.view.onMouseDblClick;
    }
    get onMouseMiddleClick() {
        return this.view.onMouseMiddleClick;
    }
    get onPointer() {
        return this.mouseController.onPointer;
    }
    get onMouseDown() {
        return this.view.onMouseDown;
    }
    get onMouseOver() {
        return this.view.onMouseOver;
    }
    get onMouseOut() {
        return this.view.onMouseOut;
    }
    get onTouchStart() {
        return this.view.onTouchStart;
    }
    get onTap() {
        return this.view.onTap;
    }
    /**
     * Possible context menu trigger events:
     * - ContextMenu key
     * - Shift F10
     * - Ctrl Option Shift M (macOS with VoiceOver)
     * - Mouse right click
     */ get onContextMenu() {
        let didJustPressContextMenuKey = false;
        const fromKeyDown = (0, _eventJs1.Event).chain(this.disposables.add(new (0, _eventJs.DomEmitter)(this.view.domNode, "keydown")).event, ($)=>$.map((e)=>new (0, _keyboardEventJs.StandardKeyboardEvent)(e)).filter((e)=>didJustPressContextMenuKey = e.keyCode === 58 /* KeyCode.ContextMenu */  || e.shiftKey && e.keyCode === 68 /* KeyCode.F10 */ ).map((e)=>(0, _domJs.EventHelper).stop(e, true)).filter(()=>false));
        const fromKeyUp = (0, _eventJs1.Event).chain(this.disposables.add(new (0, _eventJs.DomEmitter)(this.view.domNode, "keyup")).event, ($)=>$.forEach(()=>didJustPressContextMenuKey = false).map((e)=>new (0, _keyboardEventJs.StandardKeyboardEvent)(e)).filter((e)=>e.keyCode === 58 /* KeyCode.ContextMenu */  || e.shiftKey && e.keyCode === 68 /* KeyCode.F10 */ ).map((e)=>(0, _domJs.EventHelper).stop(e, true)).map(({ browserEvent })=>{
                const focus = this.getFocus();
                const index = focus.length ? focus[0] : undefined;
                const element = typeof index !== "undefined" ? this.view.element(index) : undefined;
                const anchor = typeof index !== "undefined" ? this.view.domElement(index) : this.view.domNode;
                return {
                    index,
                    element,
                    anchor,
                    browserEvent
                };
            }));
        const fromMouse = (0, _eventJs1.Event).chain(this.view.onContextMenu, ($)=>$.filter((_)=>!didJustPressContextMenuKey).map(({ element, index, browserEvent })=>({
                    element,
                    index,
                    anchor: new (0, _mouseEventJs.StandardMouseEvent)((0, _domJs.getWindow)(this.view.domNode), browserEvent),
                    browserEvent
                })));
        return (0, _eventJs1.Event).any(fromKeyDown, fromKeyUp, fromMouse);
    }
    get onKeyDown() {
        return this.disposables.add(new (0, _eventJs.DomEmitter)(this.view.domNode, "keydown")).event;
    }
    get onDidFocus() {
        return (0, _eventJs1.Event).signal(this.disposables.add(new (0, _eventJs.DomEmitter)(this.view.domNode, "focus", true)).event);
    }
    get onDidBlur() {
        return (0, _eventJs1.Event).signal(this.disposables.add(new (0, _eventJs.DomEmitter)(this.view.domNode, "blur", true)).event);
    }
    constructor(user, container, virtualDelegate, renderers, _options = DefaultOptions){
        this.user = user;
        this._options = _options;
        this.focus = new Trait("focused");
        this.anchor = new Trait("anchor");
        this.eventBufferer = new (0, _eventJs1.EventBufferer)();
        this._ariaLabel = "";
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this._onDidDispose = new (0, _eventJs1.Emitter)();
        this.onDidDispose = this._onDidDispose.event;
        const role = this._options.accessibilityProvider && this._options.accessibilityProvider.getWidgetRole ? this._options.accessibilityProvider?.getWidgetRole() : "list";
        this.selection = new SelectionTrait(role !== "listbox");
        const baseRenderers = [
            this.focus.renderer,
            this.selection.renderer
        ];
        this.accessibilityProvider = _options.accessibilityProvider;
        if (this.accessibilityProvider) {
            baseRenderers.push(new AccessibiltyRenderer(this.accessibilityProvider));
            this.accessibilityProvider.onDidChangeActiveDescendant?.(this.onDidChangeActiveDescendant, this, this.disposables);
        }
        renderers = renderers.map((r)=>new PipelineRenderer(r.templateId, [
                ...baseRenderers,
                r
            ]));
        const viewOptions = {
            ..._options,
            dnd: _options.dnd && new ListViewDragAndDrop(this, _options.dnd)
        };
        this.view = this.createListView(container, virtualDelegate, renderers, viewOptions);
        this.view.domNode.setAttribute("role", role);
        if (_options.styleController) this.styleController = _options.styleController(this.view.domId);
        else {
            const styleElement = (0, _domJs.createStyleSheet)(this.view.domNode);
            this.styleController = new DefaultStyleController(styleElement, this.view.domId);
        }
        this.spliceable = new (0, _spliceJs.CombinedSpliceable)([
            new TraitSpliceable(this.focus, this.view, _options.identityProvider),
            new TraitSpliceable(this.selection, this.view, _options.identityProvider),
            new TraitSpliceable(this.anchor, this.view, _options.identityProvider),
            this.view
        ]);
        this.disposables.add(this.focus);
        this.disposables.add(this.selection);
        this.disposables.add(this.anchor);
        this.disposables.add(this.view);
        this.disposables.add(this._onDidDispose);
        this.disposables.add(new DOMFocusController(this, this.view));
        if (typeof _options.keyboardSupport !== "boolean" || _options.keyboardSupport) {
            this.keyboardController = new KeyboardController(this, this.view, _options);
            this.disposables.add(this.keyboardController);
        }
        if (_options.keyboardNavigationLabelProvider) {
            const delegate = _options.keyboardNavigationDelegate || DefaultKeyboardNavigationDelegate;
            this.typeNavigationController = new TypeNavigationController(this, this.view, _options.keyboardNavigationLabelProvider, _options.keyboardNavigationEventFilter ?? (()=>true), delegate);
            this.disposables.add(this.typeNavigationController);
        }
        this.mouseController = this.createMouseController(_options);
        this.disposables.add(this.mouseController);
        this.onDidChangeFocus(this._onFocusChange, this, this.disposables);
        this.onDidChangeSelection(this._onSelectionChange, this, this.disposables);
        if (this.accessibilityProvider) this.ariaLabel = this.accessibilityProvider.getWidgetAriaLabel();
        if (this._options.multipleSelectionSupport !== false) this.view.domNode.setAttribute("aria-multiselectable", "true");
    }
    createListView(container, virtualDelegate, renderers, viewOptions) {
        return new (0, _listViewJs.ListView)(container, virtualDelegate, renderers, viewOptions);
    }
    createMouseController(options) {
        return new MouseController(this);
    }
    updateOptions(optionsUpdate = {}) {
        this._options = {
            ...this._options,
            ...optionsUpdate
        };
        this.typeNavigationController?.updateOptions(this._options);
        if (this._options.multipleSelectionController !== undefined) {
            if (this._options.multipleSelectionSupport) this.view.domNode.setAttribute("aria-multiselectable", "true");
            else this.view.domNode.removeAttribute("aria-multiselectable");
        }
        this.mouseController.updateOptions(optionsUpdate);
        this.keyboardController?.updateOptions(optionsUpdate);
        this.view.updateOptions(optionsUpdate);
    }
    get options() {
        return this._options;
    }
    splice(start, deleteCount, elements = []) {
        if (start < 0 || start > this.view.length) throw new (0, _listJs.ListError)(this.user, `Invalid start index: ${start}`);
        if (deleteCount < 0) throw new (0, _listJs.ListError)(this.user, `Invalid delete count: ${deleteCount}`);
        if (deleteCount === 0 && elements.length === 0) return;
        this.eventBufferer.bufferEvents(()=>this.spliceable.splice(start, deleteCount, elements));
    }
    rerender() {
        this.view.rerender();
    }
    element(index) {
        return this.view.element(index);
    }
    indexOf(element) {
        return this.view.indexOf(element);
    }
    indexAt(position) {
        return this.view.indexAt(position);
    }
    get length() {
        return this.view.length;
    }
    get contentHeight() {
        return this.view.contentHeight;
    }
    get onDidChangeContentHeight() {
        return this.view.onDidChangeContentHeight;
    }
    get scrollTop() {
        return this.view.getScrollTop();
    }
    set scrollTop(scrollTop) {
        this.view.setScrollTop(scrollTop);
    }
    get scrollHeight() {
        return this.view.scrollHeight;
    }
    get renderHeight() {
        return this.view.renderHeight;
    }
    get firstVisibleIndex() {
        return this.view.firstVisibleIndex;
    }
    get ariaLabel() {
        return this._ariaLabel;
    }
    set ariaLabel(value) {
        this._ariaLabel = value;
        this.view.domNode.setAttribute("aria-label", value);
    }
    domFocus() {
        this.view.domNode.focus({
            preventScroll: true
        });
    }
    layout(height, width) {
        this.view.layout(height, width);
    }
    setSelection(indexes, browserEvent) {
        for (const index of indexes){
            if (index < 0 || index >= this.length) throw new (0, _listJs.ListError)(this.user, `Invalid index ${index}`);
        }
        this.selection.set(indexes, browserEvent);
    }
    getSelection() {
        return this.selection.get();
    }
    getSelectedElements() {
        return this.getSelection().map((i)=>this.view.element(i));
    }
    setAnchor(index) {
        if (typeof index === "undefined") {
            this.anchor.set([]);
            return;
        }
        if (index < 0 || index >= this.length) throw new (0, _listJs.ListError)(this.user, `Invalid index ${index}`);
        this.anchor.set([
            index
        ]);
    }
    getAnchor() {
        return (0, _arraysJs.firstOrDefault)(this.anchor.get(), undefined);
    }
    getAnchorElement() {
        const anchor = this.getAnchor();
        return typeof anchor === "undefined" ? undefined : this.element(anchor);
    }
    setFocus(indexes, browserEvent) {
        for (const index of indexes){
            if (index < 0 || index >= this.length) throw new (0, _listJs.ListError)(this.user, `Invalid index ${index}`);
        }
        this.focus.set(indexes, browserEvent);
    }
    focusNext(n = 1, loop = false, browserEvent, filter) {
        if (this.length === 0) return;
        const focus = this.focus.get();
        const index = this.findNextIndex(focus.length > 0 ? focus[0] + n : 0, loop, filter);
        if (index > -1) this.setFocus([
            index
        ], browserEvent);
    }
    focusPrevious(n = 1, loop = false, browserEvent, filter) {
        if (this.length === 0) return;
        const focus = this.focus.get();
        const index = this.findPreviousIndex(focus.length > 0 ? focus[0] - n : 0, loop, filter);
        if (index > -1) this.setFocus([
            index
        ], browserEvent);
    }
    async focusNextPage(browserEvent, filter) {
        let lastPageIndex = this.view.indexAt(this.view.getScrollTop() + this.view.renderHeight);
        lastPageIndex = lastPageIndex === 0 ? 0 : lastPageIndex - 1;
        const currentlyFocusedElementIndex = this.getFocus()[0];
        if (currentlyFocusedElementIndex !== lastPageIndex && (currentlyFocusedElementIndex === undefined || lastPageIndex > currentlyFocusedElementIndex)) {
            const lastGoodPageIndex = this.findPreviousIndex(lastPageIndex, false, filter);
            if (lastGoodPageIndex > -1 && currentlyFocusedElementIndex !== lastGoodPageIndex) this.setFocus([
                lastGoodPageIndex
            ], browserEvent);
            else this.setFocus([
                lastPageIndex
            ], browserEvent);
        } else {
            const previousScrollTop = this.view.getScrollTop();
            let nextpageScrollTop = previousScrollTop + this.view.renderHeight;
            if (lastPageIndex > currentlyFocusedElementIndex) // scroll last page element to the top only if the last page element is below the focused element
            nextpageScrollTop -= this.view.elementHeight(lastPageIndex);
            this.view.setScrollTop(nextpageScrollTop);
            if (this.view.getScrollTop() !== previousScrollTop) {
                this.setFocus([]);
                // Let the scroll event listener run
                await (0, _asyncJs.timeout)(0);
                await this.focusNextPage(browserEvent, filter);
            }
        }
    }
    async focusPreviousPage(browserEvent, filter, getPaddingTop = ()=>0) {
        let firstPageIndex;
        const paddingTop = getPaddingTop();
        const scrollTop = this.view.getScrollTop() + paddingTop;
        if (scrollTop === 0) firstPageIndex = this.view.indexAt(scrollTop);
        else firstPageIndex = this.view.indexAfter(scrollTop - 1);
        const currentlyFocusedElementIndex = this.getFocus()[0];
        if (currentlyFocusedElementIndex !== firstPageIndex && (currentlyFocusedElementIndex === undefined || currentlyFocusedElementIndex >= firstPageIndex)) {
            const firstGoodPageIndex = this.findNextIndex(firstPageIndex, false, filter);
            if (firstGoodPageIndex > -1 && currentlyFocusedElementIndex !== firstGoodPageIndex) this.setFocus([
                firstGoodPageIndex
            ], browserEvent);
            else this.setFocus([
                firstPageIndex
            ], browserEvent);
        } else {
            const previousScrollTop = scrollTop;
            this.view.setScrollTop(scrollTop - this.view.renderHeight - paddingTop);
            if (this.view.getScrollTop() + getPaddingTop() !== previousScrollTop) {
                this.setFocus([]);
                // Let the scroll event listener run
                await (0, _asyncJs.timeout)(0);
                await this.focusPreviousPage(browserEvent, filter, getPaddingTop);
            }
        }
    }
    focusLast(browserEvent, filter) {
        if (this.length === 0) return;
        const index = this.findPreviousIndex(this.length - 1, false, filter);
        if (index > -1) this.setFocus([
            index
        ], browserEvent);
    }
    focusFirst(browserEvent, filter) {
        this.focusNth(0, browserEvent, filter);
    }
    focusNth(n, browserEvent, filter) {
        if (this.length === 0) return;
        const index = this.findNextIndex(n, false, filter);
        if (index > -1) this.setFocus([
            index
        ], browserEvent);
    }
    findNextIndex(index, loop = false, filter) {
        for(let i = 0; i < this.length; i++){
            if (index >= this.length && !loop) return -1;
            index = index % this.length;
            if (!filter || filter(this.element(index))) return index;
            index++;
        }
        return -1;
    }
    findPreviousIndex(index, loop = false, filter) {
        for(let i = 0; i < this.length; i++){
            if (index < 0 && !loop) return -1;
            index = (this.length + index % this.length) % this.length;
            if (!filter || filter(this.element(index))) return index;
            index--;
        }
        return -1;
    }
    getFocus() {
        return this.focus.get();
    }
    getFocusedElements() {
        return this.getFocus().map((i)=>this.view.element(i));
    }
    reveal(index, relativeTop, paddingTop = 0) {
        if (index < 0 || index >= this.length) throw new (0, _listJs.ListError)(this.user, `Invalid index ${index}`);
        const scrollTop = this.view.getScrollTop();
        const elementTop = this.view.elementTop(index);
        const elementHeight = this.view.elementHeight(index);
        if ((0, _typesJs.isNumber)(relativeTop)) {
            // y = mx + b
            const m = elementHeight - this.view.renderHeight + paddingTop;
            this.view.setScrollTop(m * (0, _numbersJs.clamp)(relativeTop, 0, 1) + elementTop - paddingTop);
        } else {
            const viewItemBottom = elementTop + elementHeight;
            const scrollBottom = scrollTop + this.view.renderHeight;
            if (elementTop < scrollTop + paddingTop && viewItemBottom >= scrollBottom) ;
            else if (elementTop < scrollTop + paddingTop || viewItemBottom >= scrollBottom && elementHeight >= this.view.renderHeight) this.view.setScrollTop(elementTop - paddingTop);
            else if (viewItemBottom >= scrollBottom) this.view.setScrollTop(viewItemBottom - this.view.renderHeight);
        }
    }
    /**
     * Returns the relative position of an element rendered in the list.
     * Returns `null` if the element isn't *entirely* in the visible viewport.
     */ getRelativeTop(index, paddingTop = 0) {
        if (index < 0 || index >= this.length) throw new (0, _listJs.ListError)(this.user, `Invalid index ${index}`);
        const scrollTop = this.view.getScrollTop();
        const elementTop = this.view.elementTop(index);
        const elementHeight = this.view.elementHeight(index);
        if (elementTop < scrollTop + paddingTop || elementTop + elementHeight > scrollTop + this.view.renderHeight) return null;
        // y = mx + b
        const m = elementHeight - this.view.renderHeight + paddingTop;
        return Math.abs((scrollTop + paddingTop - elementTop) / m);
    }
    getHTMLElement() {
        return this.view.domNode;
    }
    getScrollableElement() {
        return this.view.scrollableElementDomNode;
    }
    getElementID(index) {
        return this.view.getElementDomId(index);
    }
    getElementTop(index) {
        return this.view.elementTop(index);
    }
    style(styles) {
        this.styleController.style(styles);
    }
    toListEvent({ indexes, browserEvent }) {
        return {
            indexes,
            elements: indexes.map((i)=>this.view.element(i)),
            browserEvent
        };
    }
    _onFocusChange() {
        const focus = this.focus.get();
        this.view.domNode.classList.toggle("element-focused", focus.length > 0);
        this.onDidChangeActiveDescendant();
    }
    onDidChangeActiveDescendant() {
        const focus = this.focus.get();
        if (focus.length > 0) {
            let id;
            if (this.accessibilityProvider?.getActiveDescendantId) id = this.accessibilityProvider.getActiveDescendantId(this.view.element(focus[0]));
            this.view.domNode.setAttribute("aria-activedescendant", id || this.view.getElementDomId(focus[0]));
        } else this.view.domNode.removeAttribute("aria-activedescendant");
    }
    _onSelectionChange() {
        const selection = this.selection.get();
        this.view.domNode.classList.toggle("selection-none", selection.length === 0);
        this.view.domNode.classList.toggle("selection-single", selection.length === 1);
        this.view.domNode.classList.toggle("selection-multiple", selection.length > 1);
    }
    dispose() {
        this._onDidDispose.fire();
        this.disposables.dispose();
        this._onDidDispose.dispose();
    }
}
__decorate([
    (0, _decoratorsJs.memoize)
], List.prototype, "onDidChangeFocus", null);
__decorate([
    (0, _decoratorsJs.memoize)
], List.prototype, "onDidChangeSelection", null);
__decorate([
    (0, _decoratorsJs.memoize)
], List.prototype, "onContextMenu", null);
__decorate([
    (0, _decoratorsJs.memoize)
], List.prototype, "onKeyDown", null);
__decorate([
    (0, _decoratorsJs.memoize)
], List.prototype, "onDidFocus", null);
__decorate([
    (0, _decoratorsJs.memoize)
], List.prototype, "onDidBlur", null);

},{"../../dom.js":"bnqsM","../../event.js":"PHN3G","../../keyboardEvent.js":"bxU9U","../../touch.js":"6iGQn","../aria/aria.js":"asrsh","./splice.js":"6XTbA","../../../common/arrays.js":"DECei","../../../common/async.js":"4GJc4","../../../common/color.js":"at4gb","../../../common/decorators.js":"hZnBn","../../../common/event.js":"4Zi8b","../../../common/filters.js":"40BGZ","../../../common/lifecycle.js":"9kg8d","../../../common/numbers.js":"diWMG","../../../common/platform.js":"7maJO","../../../common/types.js":"fb5yx","./list.css":"5wcA5","./list.js":"4POjt","./listView.js":"36g6B","../../mouseEvent.js":"4jTdu","../../../common/observable.js":"2xbG5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6XTbA":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CombinedSpliceable", ()=>CombinedSpliceable);
class CombinedSpliceable {
    constructor(spliceables){
        this.spliceables = spliceables;
    }
    splice(start, deleteCount, elements) {
        this.spliceables.forEach((s)=>s.splice(start, deleteCount, elements));
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5wcA5":[function() {},{}],"4POjt":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListError", ()=>ListError);
class ListError extends Error {
    constructor(user, message){
        super(`ListError [${user}] ${message}`);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"36g6B":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ElementsDragAndDropData", ()=>ElementsDragAndDropData);
parcelHelpers.export(exports, "ExternalElementsDragAndDropData", ()=>ExternalElementsDragAndDropData);
parcelHelpers.export(exports, "NativeDragAndDropData", ()=>NativeDragAndDropData);
/**
 * The {@link ListView} is a virtual scrolling engine.
 *
 * Given that it only renders elements within its viewport, it can hold large
 * collections of elements and stay very performant. The performance bottleneck
 * usually lies within the user's rendering code for each element.
 *
 * @remarks It is a low-level widget, not meant to be used directly. Refer to the
 * List widget instead.
 */ parcelHelpers.export(exports, "ListView", ()=>ListView);
var _dndJs = require("../../dnd.js");
var _domJs = require("../../dom.js");
var _eventJs = require("../../event.js");
var _touchJs = require("../../touch.js");
var _scrollableElementJs = require("../scrollbar/scrollableElement.js");
var _arraysJs = require("../../../common/arrays.js");
var _asyncJs = require("../../../common/async.js");
var _decoratorsJs = require("../../../common/decorators.js");
var _eventJs1 = require("../../../common/event.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _rangeJs = require("../../../common/range.js");
var _scrollableJs = require("../../../common/scrollable.js");
var _rangeMapJs = require("./rangeMap.js");
var _rowCacheJs = require("./rowCache.js");
var _errorsJs = require("../../../common/errors.js");
var _numbersJs = require("../../../common/numbers.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const StaticDND = {
    CurrentDragAndDropData: undefined
};
const DefaultOptions = {
    useShadows: true,
    verticalScrollMode: 1 /* ScrollbarVisibility.Auto */ ,
    setRowLineHeight: true,
    setRowHeight: true,
    supportDynamicHeights: false,
    dnd: {
        getDragElements (e) {
            return [
                e
            ];
        },
        getDragURI () {
            return null;
        },
        onDragStart () {},
        onDragOver () {
            return false;
        },
        drop () {},
        dispose () {}
    },
    horizontalScrolling: false,
    transformOptimization: true,
    alwaysConsumeMouseWheel: true
};
class ElementsDragAndDropData {
    constructor(elements){
        this.elements = elements;
    }
    update() {}
    getData() {
        return this.elements;
    }
}
class ExternalElementsDragAndDropData {
    constructor(elements){
        this.elements = elements;
    }
    update() {}
    getData() {
        return this.elements;
    }
}
class NativeDragAndDropData {
    constructor(){
        this.types = [];
        this.files = [];
    }
    update(dataTransfer) {
        if (dataTransfer.types) this.types.splice(0, this.types.length, ...dataTransfer.types);
        if (dataTransfer.files) {
            this.files.splice(0, this.files.length);
            for(let i = 0; i < dataTransfer.files.length; i++){
                const file = dataTransfer.files.item(i);
                if (file && (file.size || file.type)) this.files.push(file);
            }
        }
    }
    getData() {
        return {
            types: this.types,
            files: this.files
        };
    }
}
function equalsDragFeedback(f1, f2) {
    if (Array.isArray(f1) && Array.isArray(f2)) return (0, _arraysJs.equals)(f1, f2);
    return f1 === f2;
}
class ListViewAccessibilityProvider {
    constructor(accessibilityProvider){
        if (accessibilityProvider?.getSetSize) this.getSetSize = accessibilityProvider.getSetSize.bind(accessibilityProvider);
        else this.getSetSize = (e, i, l)=>l;
        if (accessibilityProvider?.getPosInSet) this.getPosInSet = accessibilityProvider.getPosInSet.bind(accessibilityProvider);
        else this.getPosInSet = (e, i)=>i + 1;
        if (accessibilityProvider?.getRole) this.getRole = accessibilityProvider.getRole.bind(accessibilityProvider);
        else this.getRole = (_)=>"listitem";
        if (accessibilityProvider?.isChecked) this.isChecked = accessibilityProvider.isChecked.bind(accessibilityProvider);
        else this.isChecked = (_)=>undefined;
    }
}
class ListView {
    static{
        this.InstanceCount = 0;
    }
    get contentHeight() {
        return this.rangeMap.size;
    }
    get onDidScroll() {
        return this.scrollableElement.onScroll;
    }
    get scrollableElementDomNode() {
        return this.scrollableElement.getDomNode();
    }
    get horizontalScrolling() {
        return this._horizontalScrolling;
    }
    set horizontalScrolling(value) {
        if (value === this._horizontalScrolling) return;
        if (value && this.supportDynamicHeights) throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
        this._horizontalScrolling = value;
        this.domNode.classList.toggle("horizontal-scrolling", this._horizontalScrolling);
        if (this._horizontalScrolling) {
            for (const item of this.items)this.measureItemWidth(item);
            this.updateScrollWidth();
            this.scrollableElement.setScrollDimensions({
                width: (0, _domJs.getContentWidth)(this.domNode)
            });
            this.rowsContainer.style.width = `${Math.max(this.scrollWidth || 0, this.renderWidth)}px`;
        } else {
            this.scrollableElementWidthDelayer.cancel();
            this.scrollableElement.setScrollDimensions({
                width: this.renderWidth,
                scrollWidth: this.renderWidth
            });
            this.rowsContainer.style.width = "";
        }
    }
    constructor(container, virtualDelegate, renderers, options = DefaultOptions){
        this.virtualDelegate = virtualDelegate;
        this.domId = `list_id_${++ListView.InstanceCount}`;
        this.renderers = new Map();
        this.renderWidth = 0;
        this._scrollHeight = 0;
        this.scrollableElementUpdateDisposable = null;
        this.scrollableElementWidthDelayer = new (0, _asyncJs.Delayer)(50);
        this.splicing = false;
        this.dragOverAnimationStopDisposable = (0, _lifecycleJs.Disposable).None;
        this.dragOverMouseY = 0;
        this.canDrop = false;
        this.currentDragFeedbackDisposable = (0, _lifecycleJs.Disposable).None;
        this.onDragLeaveTimeout = (0, _lifecycleJs.Disposable).None;
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this._onDidChangeContentHeight = new (0, _eventJs1.Emitter)();
        this._onDidChangeContentWidth = new (0, _eventJs1.Emitter)();
        this.onDidChangeContentHeight = (0, _eventJs1.Event).latch(this._onDidChangeContentHeight.event, undefined, this.disposables);
        this._horizontalScrolling = false;
        if (options.horizontalScrolling && options.supportDynamicHeights) throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
        this.items = [];
        this.itemId = 0;
        this.rangeMap = this.createRangeMap(options.paddingTop ?? 0);
        for (const renderer of renderers)this.renderers.set(renderer.templateId, renderer);
        this.cache = this.disposables.add(new (0, _rowCacheJs.RowCache)(this.renderers));
        this.lastRenderTop = 0;
        this.lastRenderHeight = 0;
        this.domNode = document.createElement("div");
        this.domNode.className = "monaco-list";
        this.domNode.classList.add(this.domId);
        this.domNode.tabIndex = 0;
        this.domNode.classList.toggle("mouse-support", typeof options.mouseSupport === "boolean" ? options.mouseSupport : true);
        this._horizontalScrolling = options.horizontalScrolling ?? DefaultOptions.horizontalScrolling;
        this.domNode.classList.toggle("horizontal-scrolling", this._horizontalScrolling);
        this.paddingBottom = typeof options.paddingBottom === "undefined" ? 0 : options.paddingBottom;
        this.accessibilityProvider = new ListViewAccessibilityProvider(options.accessibilityProvider);
        this.rowsContainer = document.createElement("div");
        this.rowsContainer.className = "monaco-list-rows";
        const transformOptimization = options.transformOptimization ?? DefaultOptions.transformOptimization;
        if (transformOptimization) {
            this.rowsContainer.style.transform = "translate3d(0px, 0px, 0px)";
            this.rowsContainer.style.overflow = "hidden";
            this.rowsContainer.style.contain = "strict";
        }
        this.disposables.add((0, _touchJs.Gesture).addTarget(this.rowsContainer));
        this.scrollable = this.disposables.add(new (0, _scrollableJs.Scrollable)({
            forceIntegerValues: true,
            smoothScrollDuration: options.smoothScrolling ?? false ? 125 : 0,
            scheduleAtNextAnimationFrame: (cb)=>(0, _domJs.scheduleAtNextAnimationFrame)((0, _domJs.getWindow)(this.domNode), cb)
        }));
        this.scrollableElement = this.disposables.add(new (0, _scrollableElementJs.SmoothScrollableElement)(this.rowsContainer, {
            alwaysConsumeMouseWheel: options.alwaysConsumeMouseWheel ?? DefaultOptions.alwaysConsumeMouseWheel,
            horizontal: 1 /* ScrollbarVisibility.Auto */ ,
            vertical: options.verticalScrollMode ?? DefaultOptions.verticalScrollMode,
            useShadows: options.useShadows ?? DefaultOptions.useShadows,
            mouseWheelScrollSensitivity: options.mouseWheelScrollSensitivity,
            fastScrollSensitivity: options.fastScrollSensitivity,
            scrollByPage: options.scrollByPage
        }, this.scrollable));
        this.domNode.appendChild(this.scrollableElement.getDomNode());
        container.appendChild(this.domNode);
        this.scrollableElement.onScroll(this.onScroll, this, this.disposables);
        this.disposables.add((0, _domJs.addDisposableListener)(this.rowsContainer, (0, _touchJs.EventType).Change, (e)=>this.onTouchChange(e)));
        // Prevent the monaco-scrollable-element from scrolling
        // https://github.com/microsoft/vscode/issues/44181
        this.disposables.add((0, _domJs.addDisposableListener)(this.scrollableElement.getDomNode(), "scroll", (e)=>e.target.scrollTop = 0));
        this.disposables.add((0, _domJs.addDisposableListener)(this.domNode, "dragover", (e)=>this.onDragOver(this.toDragEvent(e))));
        this.disposables.add((0, _domJs.addDisposableListener)(this.domNode, "drop", (e)=>this.onDrop(this.toDragEvent(e))));
        this.disposables.add((0, _domJs.addDisposableListener)(this.domNode, "dragleave", (e)=>this.onDragLeave(this.toDragEvent(e))));
        this.disposables.add((0, _domJs.addDisposableListener)(this.domNode, "dragend", (e)=>this.onDragEnd(e)));
        this.setRowLineHeight = options.setRowLineHeight ?? DefaultOptions.setRowLineHeight;
        this.setRowHeight = options.setRowHeight ?? DefaultOptions.setRowHeight;
        this.supportDynamicHeights = options.supportDynamicHeights ?? DefaultOptions.supportDynamicHeights;
        this.dnd = options.dnd ?? this.disposables.add(DefaultOptions.dnd);
        this.layout(options.initialSize?.height, options.initialSize?.width);
    }
    updateOptions(options) {
        if (options.paddingBottom !== undefined) {
            this.paddingBottom = options.paddingBottom;
            this.scrollableElement.setScrollDimensions({
                scrollHeight: this.scrollHeight
            });
        }
        if (options.smoothScrolling !== undefined) this.scrollable.setSmoothScrollDuration(options.smoothScrolling ? 125 : 0);
        if (options.horizontalScrolling !== undefined) this.horizontalScrolling = options.horizontalScrolling;
        let scrollableOptions;
        if (options.scrollByPage !== undefined) scrollableOptions = {
            ...scrollableOptions ?? {},
            scrollByPage: options.scrollByPage
        };
        if (options.mouseWheelScrollSensitivity !== undefined) scrollableOptions = {
            ...scrollableOptions ?? {},
            mouseWheelScrollSensitivity: options.mouseWheelScrollSensitivity
        };
        if (options.fastScrollSensitivity !== undefined) scrollableOptions = {
            ...scrollableOptions ?? {},
            fastScrollSensitivity: options.fastScrollSensitivity
        };
        if (scrollableOptions) this.scrollableElement.updateOptions(scrollableOptions);
        if (options.paddingTop !== undefined && options.paddingTop !== this.rangeMap.paddingTop) {
            // trigger a rerender
            const lastRenderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
            const offset = options.paddingTop - this.rangeMap.paddingTop;
            this.rangeMap.paddingTop = options.paddingTop;
            this.render(lastRenderRange, Math.max(0, this.lastRenderTop + offset), this.lastRenderHeight, undefined, undefined, true);
            this.setScrollTop(this.lastRenderTop);
            this.eventuallyUpdateScrollDimensions();
            if (this.supportDynamicHeights) this._rerender(this.lastRenderTop, this.lastRenderHeight);
        }
    }
    createRangeMap(paddingTop) {
        return new (0, _rangeMapJs.RangeMap)(paddingTop);
    }
    splice(start, deleteCount, elements = []) {
        if (this.splicing) throw new Error("Can't run recursive splices.");
        this.splicing = true;
        try {
            return this._splice(start, deleteCount, elements);
        } finally{
            this.splicing = false;
            this._onDidChangeContentHeight.fire(this.contentHeight);
        }
    }
    _splice(start, deleteCount, elements = []) {
        const previousRenderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
        const deleteRange = {
            start,
            end: start + deleteCount
        };
        const removeRange = (0, _rangeJs.Range).intersect(previousRenderRange, deleteRange);
        // try to reuse rows, avoid removing them from DOM
        const rowsToDispose = new Map();
        for(let i = removeRange.end - 1; i >= removeRange.start; i--){
            const item = this.items[i];
            item.dragStartDisposable.dispose();
            item.checkedDisposable.dispose();
            if (item.row) {
                let rows = rowsToDispose.get(item.templateId);
                if (!rows) {
                    rows = [];
                    rowsToDispose.set(item.templateId, rows);
                }
                const renderer = this.renderers.get(item.templateId);
                if (renderer && renderer.disposeElement) renderer.disposeElement(item.element, i, item.row.templateData, item.size);
                rows.unshift(item.row);
            }
            item.row = null;
            item.stale = true;
        }
        const previousRestRange = {
            start: start + deleteCount,
            end: this.items.length
        };
        const previousRenderedRestRange = (0, _rangeJs.Range).intersect(previousRestRange, previousRenderRange);
        const previousUnrenderedRestRanges = (0, _rangeJs.Range).relativeComplement(previousRestRange, previousRenderRange);
        const inserted = elements.map((element)=>({
                id: String(this.itemId++),
                element,
                templateId: this.virtualDelegate.getTemplateId(element),
                size: this.virtualDelegate.getHeight(element),
                width: undefined,
                hasDynamicHeight: !!this.virtualDelegate.hasDynamicHeight && this.virtualDelegate.hasDynamicHeight(element),
                lastDynamicHeightWidth: undefined,
                row: null,
                uri: undefined,
                dropTarget: false,
                dragStartDisposable: (0, _lifecycleJs.Disposable).None,
                checkedDisposable: (0, _lifecycleJs.Disposable).None,
                stale: false
            }));
        let deleted;
        // TODO@joao: improve this optimization to catch even more cases
        if (start === 0 && deleteCount >= this.items.length) {
            this.rangeMap = this.createRangeMap(this.rangeMap.paddingTop);
            this.rangeMap.splice(0, 0, inserted);
            deleted = this.items;
            this.items = inserted;
        } else {
            this.rangeMap.splice(start, deleteCount, inserted);
            deleted = this.items.splice(start, deleteCount, ...inserted);
        }
        const delta = elements.length - deleteCount;
        const renderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
        const renderedRestRange = (0, _rangeMapJs.shift)(previousRenderedRestRange, delta);
        const updateRange = (0, _rangeJs.Range).intersect(renderRange, renderedRestRange);
        for(let i = updateRange.start; i < updateRange.end; i++)this.updateItemInDOM(this.items[i], i);
        const removeRanges = (0, _rangeJs.Range).relativeComplement(renderedRestRange, renderRange);
        for (const range of removeRanges)for(let i = range.start; i < range.end; i++)this.removeItemFromDOM(i);
        const unrenderedRestRanges = previousUnrenderedRestRanges.map((r)=>(0, _rangeMapJs.shift)(r, delta));
        const elementsRange = {
            start,
            end: start + elements.length
        };
        const insertRanges = [
            elementsRange,
            ...unrenderedRestRanges
        ].map((r)=>(0, _rangeJs.Range).intersect(renderRange, r)).reverse();
        for (const range of insertRanges)for(let i = range.end - 1; i >= range.start; i--){
            const item = this.items[i];
            const rows = rowsToDispose.get(item.templateId);
            const row = rows?.pop();
            this.insertItemInDOM(i, row);
        }
        for (const rows of rowsToDispose.values())for (const row of rows)this.cache.release(row);
        this.eventuallyUpdateScrollDimensions();
        if (this.supportDynamicHeights) this._rerender(this.scrollTop, this.renderHeight);
        return deleted.map((i)=>i.element);
    }
    eventuallyUpdateScrollDimensions() {
        this._scrollHeight = this.contentHeight;
        this.rowsContainer.style.height = `${this._scrollHeight}px`;
        if (!this.scrollableElementUpdateDisposable) this.scrollableElementUpdateDisposable = (0, _domJs.scheduleAtNextAnimationFrame)((0, _domJs.getWindow)(this.domNode), ()=>{
            this.scrollableElement.setScrollDimensions({
                scrollHeight: this.scrollHeight
            });
            this.updateScrollWidth();
            this.scrollableElementUpdateDisposable = null;
        });
    }
    eventuallyUpdateScrollWidth() {
        if (!this.horizontalScrolling) {
            this.scrollableElementWidthDelayer.cancel();
            return;
        }
        this.scrollableElementWidthDelayer.trigger(()=>this.updateScrollWidth());
    }
    updateScrollWidth() {
        if (!this.horizontalScrolling) return;
        let scrollWidth = 0;
        for (const item of this.items)if (typeof item.width !== "undefined") scrollWidth = Math.max(scrollWidth, item.width);
        this.scrollWidth = scrollWidth;
        this.scrollableElement.setScrollDimensions({
            scrollWidth: scrollWidth === 0 ? 0 : scrollWidth + 10
        });
        this._onDidChangeContentWidth.fire(this.scrollWidth);
    }
    rerender() {
        if (!this.supportDynamicHeights) return;
        for (const item of this.items)item.lastDynamicHeightWidth = undefined;
        this._rerender(this.lastRenderTop, this.lastRenderHeight);
    }
    get length() {
        return this.items.length;
    }
    get renderHeight() {
        const scrollDimensions = this.scrollableElement.getScrollDimensions();
        return scrollDimensions.height;
    }
    get firstVisibleIndex() {
        const range = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
        return range.start;
    }
    element(index) {
        return this.items[index].element;
    }
    indexOf(element) {
        return this.items.findIndex((item)=>item.element === element);
    }
    domElement(index) {
        const row = this.items[index].row;
        return row && row.domNode;
    }
    elementHeight(index) {
        return this.items[index].size;
    }
    elementTop(index) {
        return this.rangeMap.positionAt(index);
    }
    indexAt(position) {
        return this.rangeMap.indexAt(position);
    }
    indexAfter(position) {
        return this.rangeMap.indexAfter(position);
    }
    layout(height, width) {
        const scrollDimensions = {
            height: typeof height === "number" ? height : (0, _domJs.getContentHeight)(this.domNode)
        };
        if (this.scrollableElementUpdateDisposable) {
            this.scrollableElementUpdateDisposable.dispose();
            this.scrollableElementUpdateDisposable = null;
            scrollDimensions.scrollHeight = this.scrollHeight;
        }
        this.scrollableElement.setScrollDimensions(scrollDimensions);
        if (typeof width !== "undefined") {
            this.renderWidth = width;
            if (this.supportDynamicHeights) this._rerender(this.scrollTop, this.renderHeight);
        }
        if (this.horizontalScrolling) this.scrollableElement.setScrollDimensions({
            width: typeof width === "number" ? width : (0, _domJs.getContentWidth)(this.domNode)
        });
    }
    // Render
    render(previousRenderRange, renderTop, renderHeight, renderLeft, scrollWidth, updateItemsInDOM = false) {
        const renderRange = this.getRenderRange(renderTop, renderHeight);
        const rangesToInsert = (0, _rangeJs.Range).relativeComplement(renderRange, previousRenderRange).reverse();
        const rangesToRemove = (0, _rangeJs.Range).relativeComplement(previousRenderRange, renderRange);
        if (updateItemsInDOM) {
            const rangesToUpdate = (0, _rangeJs.Range).intersect(previousRenderRange, renderRange);
            for(let i = rangesToUpdate.start; i < rangesToUpdate.end; i++)this.updateItemInDOM(this.items[i], i);
        }
        this.cache.transact(()=>{
            for (const range of rangesToRemove)for(let i = range.start; i < range.end; i++)this.removeItemFromDOM(i);
            for (const range of rangesToInsert)for(let i = range.end - 1; i >= range.start; i--)this.insertItemInDOM(i);
        });
        if (renderLeft !== undefined) this.rowsContainer.style.left = `-${renderLeft}px`;
        this.rowsContainer.style.top = `-${renderTop}px`;
        if (this.horizontalScrolling && scrollWidth !== undefined) this.rowsContainer.style.width = `${Math.max(scrollWidth, this.renderWidth)}px`;
        this.lastRenderTop = renderTop;
        this.lastRenderHeight = renderHeight;
    }
    // DOM operations
    insertItemInDOM(index, row) {
        const item = this.items[index];
        if (!item.row) {
            if (row) {
                item.row = row;
                item.stale = true;
            } else {
                const result = this.cache.alloc(item.templateId);
                item.row = result.row;
                item.stale ||= result.isReusingConnectedDomNode;
            }
        }
        const role = this.accessibilityProvider.getRole(item.element) || "listitem";
        item.row.domNode.setAttribute("role", role);
        const checked = this.accessibilityProvider.isChecked(item.element);
        if (typeof checked === "boolean") item.row.domNode.setAttribute("aria-checked", String(!!checked));
        else if (checked) {
            const update = (checked)=>item.row.domNode.setAttribute("aria-checked", String(!!checked));
            update(checked.value);
            item.checkedDisposable = checked.onDidChange(()=>update(checked.value));
        }
        if (item.stale || !item.row.domNode.parentElement) {
            const referenceNode = this.items.at(index + 1)?.row?.domNode ?? null;
            if (item.row.domNode.parentElement !== this.rowsContainer || item.row.domNode.nextElementSibling !== referenceNode) this.rowsContainer.insertBefore(item.row.domNode, referenceNode);
            item.stale = false;
        }
        this.updateItemInDOM(item, index);
        const renderer = this.renderers.get(item.templateId);
        if (!renderer) throw new Error(`No renderer found for template id ${item.templateId}`);
        renderer?.renderElement(item.element, index, item.row.templateData, item.size);
        const uri = this.dnd.getDragURI(item.element);
        item.dragStartDisposable.dispose();
        item.row.domNode.draggable = !!uri;
        if (uri) item.dragStartDisposable = (0, _domJs.addDisposableListener)(item.row.domNode, "dragstart", (event)=>this.onDragStart(item.element, uri, event));
        if (this.horizontalScrolling) {
            this.measureItemWidth(item);
            this.eventuallyUpdateScrollWidth();
        }
    }
    measureItemWidth(item) {
        if (!item.row || !item.row.domNode) return;
        item.row.domNode.style.width = "fit-content";
        item.width = (0, _domJs.getContentWidth)(item.row.domNode);
        const style = (0, _domJs.getWindow)(item.row.domNode).getComputedStyle(item.row.domNode);
        if (style.paddingLeft) item.width += parseFloat(style.paddingLeft);
        if (style.paddingRight) item.width += parseFloat(style.paddingRight);
        item.row.domNode.style.width = "";
    }
    updateItemInDOM(item, index) {
        item.row.domNode.style.top = `${this.elementTop(index)}px`;
        if (this.setRowHeight) item.row.domNode.style.height = `${item.size}px`;
        if (this.setRowLineHeight) item.row.domNode.style.lineHeight = `${item.size}px`;
        item.row.domNode.setAttribute("data-index", `${index}`);
        item.row.domNode.setAttribute("data-last-element", index === this.length - 1 ? "true" : "false");
        item.row.domNode.setAttribute("data-parity", index % 2 === 0 ? "even" : "odd");
        item.row.domNode.setAttribute("aria-setsize", String(this.accessibilityProvider.getSetSize(item.element, index, this.length)));
        item.row.domNode.setAttribute("aria-posinset", String(this.accessibilityProvider.getPosInSet(item.element, index)));
        item.row.domNode.setAttribute("id", this.getElementDomId(index));
        item.row.domNode.classList.toggle("drop-target", item.dropTarget);
    }
    removeItemFromDOM(index) {
        const item = this.items[index];
        item.dragStartDisposable.dispose();
        item.checkedDisposable.dispose();
        if (item.row) {
            const renderer = this.renderers.get(item.templateId);
            if (renderer && renderer.disposeElement) renderer.disposeElement(item.element, index, item.row.templateData, item.size);
            this.cache.release(item.row);
            item.row = null;
        }
        if (this.horizontalScrolling) this.eventuallyUpdateScrollWidth();
    }
    getScrollTop() {
        const scrollPosition = this.scrollableElement.getScrollPosition();
        return scrollPosition.scrollTop;
    }
    setScrollTop(scrollTop, reuseAnimation) {
        if (this.scrollableElementUpdateDisposable) {
            this.scrollableElementUpdateDisposable.dispose();
            this.scrollableElementUpdateDisposable = null;
            this.scrollableElement.setScrollDimensions({
                scrollHeight: this.scrollHeight
            });
        }
        this.scrollableElement.setScrollPosition({
            scrollTop,
            reuseAnimation
        });
    }
    get scrollTop() {
        return this.getScrollTop();
    }
    set scrollTop(scrollTop) {
        this.setScrollTop(scrollTop);
    }
    get scrollHeight() {
        return this._scrollHeight + (this.horizontalScrolling ? 10 : 0) + this.paddingBottom;
    }
    // Events
    get onMouseClick() {
        return (0, _eventJs1.Event).map(this.disposables.add(new (0, _eventJs.DomEmitter)(this.domNode, "click")).event, (e)=>this.toMouseEvent(e), this.disposables);
    }
    get onMouseDblClick() {
        return (0, _eventJs1.Event).map(this.disposables.add(new (0, _eventJs.DomEmitter)(this.domNode, "dblclick")).event, (e)=>this.toMouseEvent(e), this.disposables);
    }
    get onMouseMiddleClick() {
        return (0, _eventJs1.Event).filter((0, _eventJs1.Event).map(this.disposables.add(new (0, _eventJs.DomEmitter)(this.domNode, "auxclick")).event, (e)=>this.toMouseEvent(e), this.disposables), (e)=>e.browserEvent.button === 1, this.disposables);
    }
    get onMouseDown() {
        return (0, _eventJs1.Event).map(this.disposables.add(new (0, _eventJs.DomEmitter)(this.domNode, "mousedown")).event, (e)=>this.toMouseEvent(e), this.disposables);
    }
    get onMouseOver() {
        return (0, _eventJs1.Event).map(this.disposables.add(new (0, _eventJs.DomEmitter)(this.domNode, "mouseover")).event, (e)=>this.toMouseEvent(e), this.disposables);
    }
    get onMouseOut() {
        return (0, _eventJs1.Event).map(this.disposables.add(new (0, _eventJs.DomEmitter)(this.domNode, "mouseout")).event, (e)=>this.toMouseEvent(e), this.disposables);
    }
    get onContextMenu() {
        return (0, _eventJs1.Event).any((0, _eventJs1.Event).map(this.disposables.add(new (0, _eventJs.DomEmitter)(this.domNode, "contextmenu")).event, (e)=>this.toMouseEvent(e), this.disposables), (0, _eventJs1.Event).map(this.disposables.add(new (0, _eventJs.DomEmitter)(this.domNode, (0, _touchJs.EventType).Contextmenu)).event, (e)=>this.toGestureEvent(e), this.disposables));
    }
    get onTouchStart() {
        return (0, _eventJs1.Event).map(this.disposables.add(new (0, _eventJs.DomEmitter)(this.domNode, "touchstart")).event, (e)=>this.toTouchEvent(e), this.disposables);
    }
    get onTap() {
        return (0, _eventJs1.Event).map(this.disposables.add(new (0, _eventJs.DomEmitter)(this.rowsContainer, (0, _touchJs.EventType).Tap)).event, (e)=>this.toGestureEvent(e), this.disposables);
    }
    toMouseEvent(browserEvent) {
        const index = this.getItemIndexFromEventTarget(browserEvent.target || null);
        const item = typeof index === "undefined" ? undefined : this.items[index];
        const element = item && item.element;
        return {
            browserEvent,
            index,
            element
        };
    }
    toTouchEvent(browserEvent) {
        const index = this.getItemIndexFromEventTarget(browserEvent.target || null);
        const item = typeof index === "undefined" ? undefined : this.items[index];
        const element = item && item.element;
        return {
            browserEvent,
            index,
            element
        };
    }
    toGestureEvent(browserEvent) {
        const index = this.getItemIndexFromEventTarget(browserEvent.initialTarget || null);
        const item = typeof index === "undefined" ? undefined : this.items[index];
        const element = item && item.element;
        return {
            browserEvent,
            index,
            element
        };
    }
    toDragEvent(browserEvent) {
        const index = this.getItemIndexFromEventTarget(browserEvent.target || null);
        const item = typeof index === "undefined" ? undefined : this.items[index];
        const element = item && item.element;
        const sector = this.getTargetSector(browserEvent, index);
        return {
            browserEvent,
            index,
            element,
            sector
        };
    }
    onScroll(e) {
        try {
            const previousRenderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
            this.render(previousRenderRange, e.scrollTop, e.height, e.scrollLeft, e.scrollWidth);
            if (this.supportDynamicHeights) this._rerender(e.scrollTop, e.height, e.inSmoothScrolling);
        } catch (err) {
            console.error("Got bad scroll event:", e);
            throw err;
        }
    }
    onTouchChange(event) {
        event.preventDefault();
        event.stopPropagation();
        this.scrollTop -= event.translationY;
    }
    // DND
    onDragStart(element, uri, event) {
        if (!event.dataTransfer) return;
        const elements = this.dnd.getDragElements(element);
        event.dataTransfer.effectAllowed = "copyMove";
        event.dataTransfer.setData((0, _dndJs.DataTransfers).TEXT, uri);
        if (event.dataTransfer.setDragImage) {
            let label;
            if (this.dnd.getDragLabel) label = this.dnd.getDragLabel(elements, event);
            if (typeof label === "undefined") label = String(elements.length);
            const dragImage = (0, _domJs.$)(".monaco-drag-image");
            dragImage.textContent = label;
            const getDragImageContainer = (e)=>{
                while(e && !e.classList.contains("monaco-workbench"))e = e.parentElement;
                return e || this.domNode.ownerDocument;
            };
            const container = getDragImageContainer(this.domNode);
            container.appendChild(dragImage);
            event.dataTransfer.setDragImage(dragImage, -10, -10);
            setTimeout(()=>dragImage.remove(), 0);
        }
        this.domNode.classList.add("dragging");
        this.currentDragData = new ElementsDragAndDropData(elements);
        StaticDND.CurrentDragAndDropData = new ExternalElementsDragAndDropData(elements);
        this.dnd.onDragStart?.(this.currentDragData, event);
    }
    onDragOver(event) {
        event.browserEvent.preventDefault(); // needed so that the drop event fires (https://stackoverflow.com/questions/21339924/drop-event-not-firing-in-chrome)
        this.onDragLeaveTimeout.dispose();
        if (StaticDND.CurrentDragAndDropData && StaticDND.CurrentDragAndDropData.getData() === "vscode-ui") return false;
        this.setupDragAndDropScrollTopAnimation(event.browserEvent);
        if (!event.browserEvent.dataTransfer) return false;
        // Drag over from outside
        if (!this.currentDragData) {
            if (StaticDND.CurrentDragAndDropData) // Drag over from another list
            this.currentDragData = StaticDND.CurrentDragAndDropData;
            else {
                // Drag over from the desktop
                if (!event.browserEvent.dataTransfer.types) return false;
                this.currentDragData = new NativeDragAndDropData();
            }
        }
        const result = this.dnd.onDragOver(this.currentDragData, event.element, event.index, event.sector, event.browserEvent);
        this.canDrop = typeof result === "boolean" ? result : result.accept;
        if (!this.canDrop) {
            this.currentDragFeedback = undefined;
            this.currentDragFeedbackDisposable.dispose();
            return false;
        }
        event.browserEvent.dataTransfer.dropEffect = typeof result !== "boolean" && result.effect?.type === 0 /* ListDragOverEffectType.Copy */  ? "copy" : "move";
        let feedback;
        if (typeof result !== "boolean" && result.feedback) feedback = result.feedback;
        else if (typeof event.index === "undefined") feedback = [
            -1
        ];
        else feedback = [
            event.index
        ];
        // sanitize feedback list
        feedback = (0, _arraysJs.distinct)(feedback).filter((i)=>i >= -1 && i < this.length).sort((a, b)=>a - b);
        feedback = feedback[0] === -1 ? [
            -1
        ] : feedback;
        let dragOverEffectPosition = typeof result !== "boolean" && result.effect && result.effect.position ? result.effect.position : "drop-target" /* ListDragOverEffectPosition.Over */ ;
        if (equalsDragFeedback(this.currentDragFeedback, feedback) && this.currentDragFeedbackPosition === dragOverEffectPosition) return true;
        this.currentDragFeedback = feedback;
        this.currentDragFeedbackPosition = dragOverEffectPosition;
        this.currentDragFeedbackDisposable.dispose();
        if (feedback[0] === -1) {
            this.domNode.classList.add(dragOverEffectPosition);
            this.rowsContainer.classList.add(dragOverEffectPosition);
            this.currentDragFeedbackDisposable = (0, _lifecycleJs.toDisposable)(()=>{
                this.domNode.classList.remove(dragOverEffectPosition);
                this.rowsContainer.classList.remove(dragOverEffectPosition);
            });
        } else {
            if (feedback.length > 1 && dragOverEffectPosition !== "drop-target" /* ListDragOverEffectPosition.Over */ ) throw new Error("Can't use multiple feedbacks with position different than 'over'");
            // Make sure there is no flicker when moving between two items
            // Always use the before feedback if possible
            if (dragOverEffectPosition === "drop-target-after" /* ListDragOverEffectPosition.After */ ) {
                if (feedback[0] < this.length - 1) {
                    feedback[0] += 1;
                    dragOverEffectPosition = "drop-target-before" /* ListDragOverEffectPosition.Before */ ;
                }
            }
            for (const index of feedback){
                const item = this.items[index];
                item.dropTarget = true;
                item.row?.domNode.classList.add(dragOverEffectPosition);
            }
            this.currentDragFeedbackDisposable = (0, _lifecycleJs.toDisposable)(()=>{
                for (const index of feedback){
                    const item = this.items[index];
                    item.dropTarget = false;
                    item.row?.domNode.classList.remove(dragOverEffectPosition);
                }
            });
        }
        return true;
    }
    onDragLeave(event) {
        this.onDragLeaveTimeout.dispose();
        this.onDragLeaveTimeout = (0, _asyncJs.disposableTimeout)(()=>this.clearDragOverFeedback(), 100, this.disposables);
        if (this.currentDragData) this.dnd.onDragLeave?.(this.currentDragData, event.element, event.index, event.browserEvent);
    }
    onDrop(event) {
        if (!this.canDrop) return;
        const dragData = this.currentDragData;
        this.teardownDragAndDropScrollTopAnimation();
        this.clearDragOverFeedback();
        this.domNode.classList.remove("dragging");
        this.currentDragData = undefined;
        StaticDND.CurrentDragAndDropData = undefined;
        if (!dragData || !event.browserEvent.dataTransfer) return;
        event.browserEvent.preventDefault();
        dragData.update(event.browserEvent.dataTransfer);
        this.dnd.drop(dragData, event.element, event.index, event.sector, event.browserEvent);
    }
    onDragEnd(event) {
        this.canDrop = false;
        this.teardownDragAndDropScrollTopAnimation();
        this.clearDragOverFeedback();
        this.domNode.classList.remove("dragging");
        this.currentDragData = undefined;
        StaticDND.CurrentDragAndDropData = undefined;
        this.dnd.onDragEnd?.(event);
    }
    clearDragOverFeedback() {
        this.currentDragFeedback = undefined;
        this.currentDragFeedbackPosition = undefined;
        this.currentDragFeedbackDisposable.dispose();
        this.currentDragFeedbackDisposable = (0, _lifecycleJs.Disposable).None;
    }
    // DND scroll top animation
    setupDragAndDropScrollTopAnimation(event) {
        if (!this.dragOverAnimationDisposable) {
            const viewTop = (0, _domJs.getTopLeftOffset)(this.domNode).top;
            this.dragOverAnimationDisposable = (0, _domJs.animate)((0, _domJs.getWindow)(this.domNode), this.animateDragAndDropScrollTop.bind(this, viewTop));
        }
        this.dragOverAnimationStopDisposable.dispose();
        this.dragOverAnimationStopDisposable = (0, _asyncJs.disposableTimeout)(()=>{
            if (this.dragOverAnimationDisposable) {
                this.dragOverAnimationDisposable.dispose();
                this.dragOverAnimationDisposable = undefined;
            }
        }, 1000, this.disposables);
        this.dragOverMouseY = event.pageY;
    }
    animateDragAndDropScrollTop(viewTop) {
        if (this.dragOverMouseY === undefined) return;
        const diff = this.dragOverMouseY - viewTop;
        const upperLimit = this.renderHeight - 35;
        if (diff < 35) this.scrollTop += Math.max(-14, Math.floor(0.3 * (diff - 35)));
        else if (diff > upperLimit) this.scrollTop += Math.min(14, Math.floor(0.3 * (diff - upperLimit)));
    }
    teardownDragAndDropScrollTopAnimation() {
        this.dragOverAnimationStopDisposable.dispose();
        if (this.dragOverAnimationDisposable) {
            this.dragOverAnimationDisposable.dispose();
            this.dragOverAnimationDisposable = undefined;
        }
    }
    // Util
    getTargetSector(browserEvent, targetIndex) {
        if (targetIndex === undefined) return undefined;
        const relativePosition = browserEvent.offsetY / this.items[targetIndex].size;
        const sector = Math.floor(relativePosition / 0.25);
        return (0, _numbersJs.clamp)(sector, 0, 3);
    }
    getItemIndexFromEventTarget(target) {
        const scrollableElement = this.scrollableElement.getDomNode();
        let element = target;
        while(((0, _domJs.isHTMLElement)(element) || (0, _domJs.isSVGElement)(element)) && element !== this.rowsContainer && scrollableElement.contains(element)){
            const rawIndex = element.getAttribute("data-index");
            if (rawIndex) {
                const index = Number(rawIndex);
                if (!isNaN(index)) return index;
            }
            element = element.parentElement;
        }
        return undefined;
    }
    getRenderRange(renderTop, renderHeight) {
        return {
            start: this.rangeMap.indexAt(renderTop),
            end: this.rangeMap.indexAfter(renderTop + renderHeight - 1)
        };
    }
    /**
     * Given a stable rendered state, checks every rendered element whether it needs
     * to be probed for dynamic height. Adjusts scroll height and top if necessary.
     */ _rerender(renderTop, renderHeight, inSmoothScrolling) {
        const previousRenderRange = this.getRenderRange(renderTop, renderHeight);
        // Let's remember the second element's position, this helps in scrolling up
        // and preserving a linear upwards scroll movement
        let anchorElementIndex;
        let anchorElementTopDelta;
        if (renderTop === this.elementTop(previousRenderRange.start)) {
            anchorElementIndex = previousRenderRange.start;
            anchorElementTopDelta = 0;
        } else if (previousRenderRange.end - previousRenderRange.start > 1) {
            anchorElementIndex = previousRenderRange.start + 1;
            anchorElementTopDelta = this.elementTop(anchorElementIndex) - renderTop;
        }
        let heightDiff = 0;
        while(true){
            const renderRange = this.getRenderRange(renderTop, renderHeight);
            let didChange = false;
            for(let i = renderRange.start; i < renderRange.end; i++){
                const diff = this.probeDynamicHeight(i);
                if (diff !== 0) this.rangeMap.splice(i, 1, [
                    this.items[i]
                ]);
                heightDiff += diff;
                didChange = didChange || diff !== 0;
            }
            if (!didChange) {
                if (heightDiff !== 0) this.eventuallyUpdateScrollDimensions();
                const unrenderRanges = (0, _rangeJs.Range).relativeComplement(previousRenderRange, renderRange);
                for (const range of unrenderRanges){
                    for(let i = range.start; i < range.end; i++)if (this.items[i].row) this.removeItemFromDOM(i);
                }
                const renderRanges = (0, _rangeJs.Range).relativeComplement(renderRange, previousRenderRange).reverse();
                for (const range of renderRanges)for(let i = range.end - 1; i >= range.start; i--)this.insertItemInDOM(i);
                for(let i = renderRange.start; i < renderRange.end; i++)if (this.items[i].row) this.updateItemInDOM(this.items[i], i);
                if (typeof anchorElementIndex === "number") {
                    // To compute a destination scroll top, we need to take into account the current smooth scrolling
                    // animation, and then reuse it with a new target (to avoid prolonging the scroll)
                    // See https://github.com/microsoft/vscode/issues/104144
                    // See https://github.com/microsoft/vscode/pull/104284
                    // See https://github.com/microsoft/vscode/issues/107704
                    const deltaScrollTop = this.scrollable.getFutureScrollPosition().scrollTop - renderTop;
                    const newScrollTop = this.elementTop(anchorElementIndex) - anchorElementTopDelta + deltaScrollTop;
                    this.setScrollTop(newScrollTop, inSmoothScrolling);
                }
                this._onDidChangeContentHeight.fire(this.contentHeight);
                return;
            }
        }
    }
    probeDynamicHeight(index) {
        const item = this.items[index];
        if (!!this.virtualDelegate.getDynamicHeight) {
            const newSize = this.virtualDelegate.getDynamicHeight(item.element);
            if (newSize !== null) {
                const size = item.size;
                item.size = newSize;
                item.lastDynamicHeightWidth = this.renderWidth;
                return newSize - size;
            }
        }
        if (!item.hasDynamicHeight || item.lastDynamicHeightWidth === this.renderWidth) return 0;
        if (!!this.virtualDelegate.hasDynamicHeight && !this.virtualDelegate.hasDynamicHeight(item.element)) return 0;
        const size = item.size;
        if (item.row) {
            item.row.domNode.style.height = "";
            item.size = item.row.domNode.offsetHeight;
            if (item.size === 0 && !(0, _domJs.isAncestor)(item.row.domNode, (0, _domJs.getWindow)(item.row.domNode).document.body)) console.warn("Measuring item node that is not in DOM! Add ListView to the DOM before measuring row height!", new Error().stack);
            item.lastDynamicHeightWidth = this.renderWidth;
            return item.size - size;
        }
        const { row } = this.cache.alloc(item.templateId);
        row.domNode.style.height = "";
        this.rowsContainer.appendChild(row.domNode);
        const renderer = this.renderers.get(item.templateId);
        if (!renderer) throw new (0, _errorsJs.BugIndicatingError)("Missing renderer for templateId: " + item.templateId);
        renderer.renderElement(item.element, index, row.templateData, undefined);
        item.size = row.domNode.offsetHeight;
        renderer.disposeElement?.(item.element, index, row.templateData, undefined);
        this.virtualDelegate.setDynamicHeight?.(item.element, item.size);
        item.lastDynamicHeightWidth = this.renderWidth;
        row.domNode.remove();
        this.cache.release(row);
        return item.size - size;
    }
    getElementDomId(index) {
        return `${this.domId}_${index}`;
    }
    // Dispose
    dispose() {
        for (const item of this.items){
            item.dragStartDisposable.dispose();
            item.checkedDisposable.dispose();
            if (item.row) {
                const renderer = this.renderers.get(item.row.templateId);
                if (renderer) {
                    renderer.disposeElement?.(item.element, -1, item.row.templateData, undefined);
                    renderer.disposeTemplate(item.row.templateData);
                }
            }
        }
        this.items = [];
        this.domNode?.remove();
        this.dragOverAnimationDisposable?.dispose();
        this.disposables.dispose();
    }
}
__decorate([
    (0, _decoratorsJs.memoize)
], ListView.prototype, "onMouseClick", null);
__decorate([
    (0, _decoratorsJs.memoize)
], ListView.prototype, "onMouseDblClick", null);
__decorate([
    (0, _decoratorsJs.memoize)
], ListView.prototype, "onMouseMiddleClick", null);
__decorate([
    (0, _decoratorsJs.memoize)
], ListView.prototype, "onMouseDown", null);
__decorate([
    (0, _decoratorsJs.memoize)
], ListView.prototype, "onMouseOver", null);
__decorate([
    (0, _decoratorsJs.memoize)
], ListView.prototype, "onMouseOut", null);
__decorate([
    (0, _decoratorsJs.memoize)
], ListView.prototype, "onContextMenu", null);
__decorate([
    (0, _decoratorsJs.memoize)
], ListView.prototype, "onTouchStart", null);
__decorate([
    (0, _decoratorsJs.memoize)
], ListView.prototype, "onTap", null);

},{"../../dnd.js":"io6s1","../../dom.js":"bnqsM","../../event.js":"PHN3G","../../touch.js":"6iGQn","../scrollbar/scrollableElement.js":"h1C5l","../../../common/arrays.js":"DECei","../../../common/async.js":"4GJc4","../../../common/decorators.js":"hZnBn","../../../common/event.js":"4Zi8b","../../../common/lifecycle.js":"9kg8d","../../../common/range.js":"1yq3Z","../../../common/scrollable.js":"8otcz","./rangeMap.js":"2ajX5","./rowCache.js":"kW5sE","../../../common/errors.js":"divX8","../../../common/numbers.js":"diWMG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ajX5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the intersection between a ranged group and a range.
 * Returns `[]` if the intersection is empty.
 */ parcelHelpers.export(exports, "groupIntersect", ()=>groupIntersect);
/**
 * Shifts a range by that `much`.
 */ parcelHelpers.export(exports, "shift", ()=>shift);
/**
 * Consolidates a collection of ranged groups.
 *
 * Consolidation is the process of merging consecutive ranged groups
 * that share the same `size`.
 */ parcelHelpers.export(exports, "consolidate", ()=>consolidate);
parcelHelpers.export(exports, "RangeMap", ()=>RangeMap);
var _rangeJs = require("../../../common/range.js");
function groupIntersect(range, groups) {
    const result = [];
    for (const r of groups){
        if (range.start >= r.range.end) continue;
        if (range.end < r.range.start) break;
        const intersection = (0, _rangeJs.Range).intersect(range, r.range);
        if ((0, _rangeJs.Range).isEmpty(intersection)) continue;
        result.push({
            range: intersection,
            size: r.size
        });
    }
    return result;
}
function shift({ start, end }, much) {
    return {
        start: start + much,
        end: end + much
    };
}
function consolidate(groups) {
    const result = [];
    let previousGroup = null;
    for (const group of groups){
        const start = group.range.start;
        const end = group.range.end;
        const size = group.size;
        if (previousGroup && size === previousGroup.size) {
            previousGroup.range.end = end;
            continue;
        }
        previousGroup = {
            range: {
                start,
                end
            },
            size
        };
        result.push(previousGroup);
    }
    return result;
}
/**
 * Concatenates several collections of ranged groups into a single
 * collection.
 */ function concat(...groups) {
    return consolidate(groups.reduce((r, g)=>r.concat(g), []));
}
class RangeMap {
    get paddingTop() {
        return this._paddingTop;
    }
    set paddingTop(paddingTop) {
        this._size = this._size + paddingTop - this._paddingTop;
        this._paddingTop = paddingTop;
    }
    constructor(topPadding){
        this.groups = [];
        this._size = 0;
        this._paddingTop = 0;
        this._paddingTop = topPadding ?? 0;
        this._size = this._paddingTop;
    }
    splice(index, deleteCount, items = []) {
        const diff = items.length - deleteCount;
        const before = groupIntersect({
            start: 0,
            end: index
        }, this.groups);
        const after = groupIntersect({
            start: index + deleteCount,
            end: Number.POSITIVE_INFINITY
        }, this.groups).map((g)=>({
                range: shift(g.range, diff),
                size: g.size
            }));
        const middle = items.map((item, i)=>({
                range: {
                    start: index + i,
                    end: index + i + 1
                },
                size: item.size
            }));
        this.groups = concat(before, middle, after);
        this._size = this._paddingTop + this.groups.reduce((t, g)=>t + g.size * (g.range.end - g.range.start), 0);
    }
    /**
     * Returns the number of items in the range map.
     */ get count() {
        const len = this.groups.length;
        if (!len) return 0;
        return this.groups[len - 1].range.end;
    }
    /**
     * Returns the sum of the sizes of all items in the range map.
     */ get size() {
        return this._size;
    }
    /**
     * Returns the index of the item at the given position.
     */ indexAt(position) {
        if (position < 0) return -1;
        if (position < this._paddingTop) return 0;
        let index = 0;
        let size = this._paddingTop;
        for (const group of this.groups){
            const count = group.range.end - group.range.start;
            const newSize = size + count * group.size;
            if (position < newSize) return index + Math.floor((position - size) / group.size);
            index += count;
            size = newSize;
        }
        return index;
    }
    /**
     * Returns the index of the item right after the item at the
     * index of the given position.
     */ indexAfter(position) {
        return Math.min(this.indexAt(position) + 1, this.count);
    }
    /**
     * Returns the start position of the item at the given index.
     */ positionAt(index) {
        if (index < 0) return -1;
        let position = 0;
        let count = 0;
        for (const group of this.groups){
            const groupCount = group.range.end - group.range.start;
            const newCount = count + groupCount;
            if (index < newCount) return this._paddingTop + position + (index - count) * group.size;
            position += groupCount * group.size;
            count = newCount;
        }
        return -1;
    }
}

},{"../../../common/range.js":"1yq3Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kW5sE":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RowCache", ()=>RowCache);
var _domJs = require("../../dom.js");
class RowCache {
    constructor(renderers){
        this.renderers = renderers;
        this.cache = new Map();
        this.transactionNodesPendingRemoval = new Set();
        this.inTransaction = false;
    }
    /**
     * Returns a row either by creating a new one or reusing
     * a previously released row which shares the same templateId.
     *
     * @returns A row and `isReusingConnectedDomNode` if the row's node is already in the dom in a stale position.
     */ alloc(templateId) {
        let result = this.getTemplateCache(templateId).pop();
        let isStale = false;
        if (result) {
            isStale = this.transactionNodesPendingRemoval.has(result.domNode);
            if (isStale) this.transactionNodesPendingRemoval.delete(result.domNode);
        } else {
            const domNode = (0, _domJs.$)(".monaco-list-row");
            const renderer = this.getRenderer(templateId);
            const templateData = renderer.renderTemplate(domNode);
            result = {
                domNode,
                templateId,
                templateData
            };
        }
        return {
            row: result,
            isReusingConnectedDomNode: isStale
        };
    }
    /**
     * Releases the row for eventual reuse.
     */ release(row) {
        if (!row) return;
        this.releaseRow(row);
    }
    /**
     * Begin a set of changes that use the cache. This lets us skip work when a row is removed and then inserted again.
     */ transact(makeChanges) {
        if (this.inTransaction) throw new Error("Already in transaction");
        this.inTransaction = true;
        try {
            makeChanges();
        } finally{
            for (const domNode of this.transactionNodesPendingRemoval)this.doRemoveNode(domNode);
            this.transactionNodesPendingRemoval.clear();
            this.inTransaction = false;
        }
    }
    releaseRow(row) {
        const { domNode, templateId } = row;
        if (domNode) {
            if (this.inTransaction) this.transactionNodesPendingRemoval.add(domNode);
            else this.doRemoveNode(domNode);
        }
        const cache = this.getTemplateCache(templateId);
        cache.push(row);
    }
    doRemoveNode(domNode) {
        domNode.classList.remove("scrolling");
        domNode.remove();
    }
    getTemplateCache(templateId) {
        let result = this.cache.get(templateId);
        if (!result) {
            result = [];
            this.cache.set(templateId, result);
        }
        return result;
    }
    dispose() {
        this.cache.forEach((cachedRows, templateId)=>{
            for (const cachedRow of cachedRows){
                const renderer = this.getRenderer(templateId);
                renderer.disposeTemplate(cachedRow.templateData);
                cachedRow.templateData = null;
            }
        });
        this.cache.clear();
        this.transactionNodesPendingRemoval.clear();
    }
    getRenderer(templateId) {
        const renderer = this.renderers.get(templateId);
        if (!renderer) throw new Error(`No renderer found for ${templateId}`);
        return renderer;
    }
}

},{"../../dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"10G0b":[function() {},{}],"h7BCW":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectBoxNative", ()=>SelectBoxNative);
var _domJs = require("../../dom.js");
var _touchJs = require("../../touch.js");
var _arraysJs = require("../../../common/arrays.js");
var _eventJs = require("../../../common/event.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _platformJs = require("../../../common/platform.js");
class SelectBoxNative extends (0, _lifecycleJs.Disposable) {
    constructor(options, selected, styles, selectBoxOptions){
        super();
        this.selected = 0;
        this.selectBoxOptions = selectBoxOptions || Object.create(null);
        this.options = [];
        this.selectElement = document.createElement("select");
        this.selectElement.className = "monaco-select-box";
        if (typeof this.selectBoxOptions.ariaLabel === "string") this.selectElement.setAttribute("aria-label", this.selectBoxOptions.ariaLabel);
        if (typeof this.selectBoxOptions.ariaDescription === "string") this.selectElement.setAttribute("aria-description", this.selectBoxOptions.ariaDescription);
        this._onDidSelect = this._register(new (0, _eventJs.Emitter)());
        this.styles = styles;
        this.registerListeners();
        this.setOptions(options, selected);
    }
    registerListeners() {
        this._register((0, _touchJs.Gesture).addTarget(this.selectElement));
        [
            (0, _touchJs.EventType).Tap
        ].forEach((eventType)=>{
            this._register(_domJs.addDisposableListener(this.selectElement, eventType, (e)=>{
                this.selectElement.focus();
            }));
        });
        this._register(_domJs.addStandardDisposableListener(this.selectElement, "click", (e)=>{
            _domJs.EventHelper.stop(e, true);
        }));
        this._register(_domJs.addStandardDisposableListener(this.selectElement, "change", (e)=>{
            this.selectElement.title = e.target.value;
            this._onDidSelect.fire({
                index: e.target.selectedIndex,
                selected: e.target.value
            });
        }));
        this._register(_domJs.addStandardDisposableListener(this.selectElement, "keydown", (e)=>{
            let showSelect = false;
            if (0, _platformJs.isMacintosh) {
                if (e.keyCode === 18 /* KeyCode.DownArrow */  || e.keyCode === 16 /* KeyCode.UpArrow */  || e.keyCode === 10 /* KeyCode.Space */ ) showSelect = true;
            } else if (e.keyCode === 18 /* KeyCode.DownArrow */  && e.altKey || e.keyCode === 10 /* KeyCode.Space */  || e.keyCode === 3 /* KeyCode.Enter */ ) showSelect = true;
            if (showSelect) // Space, Enter, is used to expand select box, do not propagate it (prevent action bar action run)
            e.stopPropagation();
        }));
    }
    get onDidSelect() {
        return this._onDidSelect.event;
    }
    setOptions(options, selected) {
        if (!this.options || !_arraysJs.equals(this.options, options)) {
            this.options = options;
            this.selectElement.options.length = 0;
            this.options.forEach((option, index)=>{
                this.selectElement.add(this.createOption(option.text, index, option.isDisabled));
            });
        }
        if (selected !== undefined) this.select(selected);
    }
    select(index) {
        if (this.options.length === 0) this.selected = 0;
        else if (index >= 0 && index < this.options.length) this.selected = index;
        else if (index > this.options.length - 1) // Adjust index to end of list
        // This could make client out of sync with the select
        this.select(this.options.length - 1);
        else if (this.selected < 0) this.selected = 0;
        this.selectElement.selectedIndex = this.selected;
        if (this.selected < this.options.length && typeof this.options[this.selected].text === "string") this.selectElement.title = this.options[this.selected].text;
        else this.selectElement.title = "";
    }
    focus() {
        if (this.selectElement) {
            this.selectElement.tabIndex = 0;
            this.selectElement.focus();
        }
    }
    blur() {
        if (this.selectElement) {
            this.selectElement.tabIndex = -1;
            this.selectElement.blur();
        }
    }
    setFocusable(focusable) {
        this.selectElement.tabIndex = focusable ? 0 : -1;
    }
    render(container) {
        container.classList.add("select-container");
        container.appendChild(this.selectElement);
        this.setOptions(this.options, this.selected);
        this.applyStyles();
    }
    applyStyles() {
        // Style native select
        if (this.selectElement) {
            this.selectElement.style.backgroundColor = this.styles.selectBackground ?? "";
            this.selectElement.style.color = this.styles.selectForeground ?? "";
            this.selectElement.style.borderColor = this.styles.selectBorder ?? "";
        }
    }
    createOption(value, index, disabled) {
        const option = document.createElement("option");
        option.value = value;
        option.text = value;
        option.disabled = !!disabled;
        return option;
    }
}

},{"../../dom.js":"bnqsM","../../touch.js":"6iGQn","../../../common/arrays.js":"DECei","../../../common/event.js":"4Zi8b","../../../common/lifecycle.js":"9kg8d","../../../common/platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"koHgG":[function() {},{}],"gFocE":[function() {},{}],"k8InY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropdownMenuActionViewItem", ()=>DropdownMenuActionViewItem);
var _domJs = require("../../dom.js");
var _actionViewItemsJs = require("../actionbar/actionViewItems.js");
var _dropdownJs = require("./dropdown.js");
var _eventJs = require("../../../common/event.js");
var _dropdownCss = require("./dropdown.css");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _hoverDelegate2Js = require("../hover/hoverDelegate2.js");
class DropdownMenuActionViewItem extends (0, _actionViewItemsJs.BaseActionViewItem) {
    constructor(action, menuActionsOrProvider, contextMenuProvider, options = Object.create(null)){
        super(null, action, options);
        this.actionItem = null;
        this._onDidChangeVisibility = this._register(new (0, _eventJs.Emitter)());
        this.onDidChangeVisibility = this._onDidChangeVisibility.event;
        this.menuActionsOrProvider = menuActionsOrProvider;
        this.contextMenuProvider = contextMenuProvider;
        this.options = options;
        if (this.options.actionRunner) this.actionRunner = this.options.actionRunner;
    }
    render(container) {
        this.actionItem = container;
        const labelRenderer = (el)=>{
            this.element = (0, _domJs.append)(el, (0, _domJs.$)("a.action-label"));
            let classNames = [];
            if (typeof this.options.classNames === "string") classNames = this.options.classNames.split(/\s+/g).filter((s)=>!!s);
            else if (this.options.classNames) classNames = this.options.classNames;
            // todo@aeschli: remove codicon, should come through `this.options.classNames`
            if (!classNames.find((c)=>c === "icon")) classNames.push("codicon");
            this.element.classList.add(...classNames);
            this.element.setAttribute("role", "button");
            this.element.setAttribute("aria-haspopup", "true");
            this.element.setAttribute("aria-expanded", "false");
            if (this._action.label) this._register((0, _hoverDelegate2Js.getBaseLayerHoverDelegate)().setupManagedHover(this.options.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("mouse"), this.element, this._action.label));
            this.element.ariaLabel = this._action.label || "";
            return null;
        };
        const isActionsArray = Array.isArray(this.menuActionsOrProvider);
        const options = {
            contextMenuProvider: this.contextMenuProvider,
            labelRenderer: labelRenderer,
            menuAsChild: this.options.menuAsChild,
            actions: isActionsArray ? this.menuActionsOrProvider : undefined,
            actionProvider: isActionsArray ? undefined : this.menuActionsOrProvider,
            skipTelemetry: this.options.skipTelemetry
        };
        this.dropdownMenu = this._register(new (0, _dropdownJs.DropdownMenu)(container, options));
        this._register(this.dropdownMenu.onDidChangeVisibility((visible)=>{
            this.element?.setAttribute("aria-expanded", `${visible}`);
            this._onDidChangeVisibility.fire(visible);
        }));
        this.dropdownMenu.menuOptions = {
            actionViewItemProvider: this.options.actionViewItemProvider,
            actionRunner: this.actionRunner,
            getKeyBinding: this.options.keybindingProvider,
            context: this._context
        };
        if (this.options.anchorAlignmentProvider) {
            const that = this;
            this.dropdownMenu.menuOptions = {
                ...this.dropdownMenu.menuOptions,
                get anchorAlignment () {
                    return that.options.anchorAlignmentProvider();
                }
            };
        }
        this.updateTooltip();
        this.updateEnabled();
    }
    getTooltip() {
        let title = null;
        if (this.action.tooltip) title = this.action.tooltip;
        else if (this.action.label) title = this.action.label;
        return title ?? undefined;
    }
    setActionContext(newContext) {
        super.setActionContext(newContext);
        if (this.dropdownMenu) {
            if (this.dropdownMenu.menuOptions) this.dropdownMenu.menuOptions.context = newContext;
            else this.dropdownMenu.menuOptions = {
                context: newContext
            };
        }
    }
    show() {
        this.dropdownMenu?.show();
    }
    updateEnabled() {
        const disabled = !this.action.enabled;
        this.actionItem?.classList.toggle("disabled", disabled);
        this.element?.classList.toggle("disabled", disabled);
    }
}

},{"../../dom.js":"bnqsM","../actionbar/actionViewItems.js":"6Yy9b","./dropdown.js":"3tUhs","../../../common/event.js":"4Zi8b","./dropdown.css":"4CXRg","../hover/hoverDelegateFactory.js":"kll4h","../hover/hoverDelegate2.js":"5jqL3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3tUhs":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropdownMenu", ()=>DropdownMenu);
var _domJs = require("../../dom.js");
var _keyboardEventJs = require("../../keyboardEvent.js");
var _touchJs = require("../../touch.js");
var _actionsJs = require("../../../common/actions.js");
var _eventJs = require("../../../common/event.js");
var _dropdownCss = require("./dropdown.css");
class BaseDropdown extends (0, _actionsJs.ActionRunner) {
    constructor(container, options){
        super();
        this._onDidChangeVisibility = this._register(new (0, _eventJs.Emitter)());
        this.onDidChangeVisibility = this._onDidChangeVisibility.event;
        this._element = (0, _domJs.append)(container, (0, _domJs.$)(".monaco-dropdown"));
        this._label = (0, _domJs.append)(this._element, (0, _domJs.$)(".dropdown-label"));
        let labelRenderer = options.labelRenderer;
        if (!labelRenderer) labelRenderer = (container)=>{
            container.textContent = options.label || "";
            return null;
        };
        for (const event of [
            (0, _domJs.EventType).CLICK,
            (0, _domJs.EventType).MOUSE_DOWN,
            (0, _touchJs.EventType).Tap
        ])this._register((0, _domJs.addDisposableListener)(this.element, event, (e)=>(0, _domJs.EventHelper).stop(e, true))); // prevent default click behaviour to trigger
        for (const event of [
            (0, _domJs.EventType).MOUSE_DOWN,
            (0, _touchJs.EventType).Tap
        ])this._register((0, _domJs.addDisposableListener)(this._label, event, (e)=>{
            if ((0, _domJs.isMouseEvent)(e) && (e.detail > 1 || e.button !== 0)) // prevent right click trigger to allow separate context menu (https://github.com/microsoft/vscode/issues/151064)
            // prevent multiple clicks to open multiple context menus (https://github.com/microsoft/vscode/issues/41363)
            return;
            if (this.visible) this.hide();
            else this.show();
        }));
        this._register((0, _domJs.addDisposableListener)(this._label, (0, _domJs.EventType).KEY_UP, (e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            if (event.equals(3 /* KeyCode.Enter */ ) || event.equals(10 /* KeyCode.Space */ )) {
                (0, _domJs.EventHelper).stop(e, true); // https://github.com/microsoft/vscode/issues/57997
                if (this.visible) this.hide();
                else this.show();
            }
        }));
        const cleanupFn = labelRenderer(this._label);
        if (cleanupFn) this._register(cleanupFn);
        this._register((0, _touchJs.Gesture).addTarget(this._label));
    }
    get element() {
        return this._element;
    }
    show() {
        if (!this.visible) {
            this.visible = true;
            this._onDidChangeVisibility.fire(true);
        }
    }
    hide() {
        if (this.visible) {
            this.visible = false;
            this._onDidChangeVisibility.fire(false);
        }
    }
    dispose() {
        super.dispose();
        this.hide();
        if (this.boxContainer) {
            this.boxContainer.remove();
            this.boxContainer = undefined;
        }
        if (this.contents) {
            this.contents.remove();
            this.contents = undefined;
        }
        if (this._label) {
            this._label.remove();
            this._label = undefined;
        }
    }
}
class DropdownMenu extends BaseDropdown {
    constructor(container, _options){
        super(container, _options);
        this._options = _options;
        this._actions = [];
        this.actions = _options.actions || [];
    }
    set menuOptions(options) {
        this._menuOptions = options;
    }
    get menuOptions() {
        return this._menuOptions;
    }
    get actions() {
        if (this._options.actionProvider) return this._options.actionProvider.getActions();
        return this._actions;
    }
    set actions(actions) {
        this._actions = actions;
    }
    show() {
        super.show();
        this.element.classList.add("active");
        this._options.contextMenuProvider.showContextMenu({
            getAnchor: ()=>this.element,
            getActions: ()=>this.actions,
            getActionsContext: ()=>this.menuOptions ? this.menuOptions.context : null,
            getActionViewItem: (action, options)=>this.menuOptions && this.menuOptions.actionViewItemProvider ? this.menuOptions.actionViewItemProvider(action, options) : undefined,
            getKeyBinding: (action)=>this.menuOptions && this.menuOptions.getKeyBinding ? this.menuOptions.getKeyBinding(action) : undefined,
            getMenuClassName: ()=>this._options.menuClassName || "",
            onHide: ()=>this.onHide(),
            actionRunner: this.menuOptions ? this.menuOptions.actionRunner : undefined,
            anchorAlignment: this.menuOptions ? this.menuOptions.anchorAlignment : 0 /* AnchorAlignment.LEFT */ ,
            domForShadowRoot: this._options.menuAsChild ? this.element : undefined,
            skipTelemetry: this._options.skipTelemetry
        });
    }
    hide() {
        super.hide();
    }
    onHide() {
        this.hide();
        this.element.classList.remove("active");
    }
}

},{"../../dom.js":"bnqsM","../../keyboardEvent.js":"bxU9U","../../touch.js":"6iGQn","../../../common/actions.js":"5GjLb","../../../common/event.js":"4Zi8b","./dropdown.css":"4CXRg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4CXRg":[function() {},{}],"4CXRg":[function() {},{}],"jpJ86":[function() {},{}],"kzlRi":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isLocalizedString", ()=>isLocalizedString);
parcelHelpers.export(exports, "isICommandActionToggleInfo", ()=>isICommandActionToggleInfo);
function isLocalizedString(thing) {
    return thing && typeof thing === "object" && typeof thing.original === "string" && typeof thing.value === "string";
}
function isICommandActionToggleInfo(thing) {
    return thing ? thing.condition !== undefined : false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6AhR2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TARGET_KEY", ()=>TARGET_KEY);
parcelHelpers.export(exports, "IStorageService", ()=>IStorageService);
parcelHelpers.export(exports, "WillSaveStateReason", ()=>WillSaveStateReason);
parcelHelpers.export(exports, "loadKeyTargets", ()=>loadKeyTargets);
parcelHelpers.export(exports, "AbstractStorageService", ()=>AbstractStorageService);
parcelHelpers.export(exports, "InMemoryStorageService", ()=>InMemoryStorageService);
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _typesJs = require("../../../base/common/types.js");
var _storageJs = require("../../../base/parts/storage/common/storage.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const TARGET_KEY = "__$__targetStorageMarker";
const IStorageService = (0, _instantiationJs.createDecorator)("storageService");
var WillSaveStateReason;
(function(WillSaveStateReason) {
    /**
     * No specific reason to save state.
     */ WillSaveStateReason[WillSaveStateReason["NONE"] = 0] = "NONE";
    /**
     * A hint that the workbench is about to shutdown.
     */ WillSaveStateReason[WillSaveStateReason["SHUTDOWN"] = 1] = "SHUTDOWN";
})(WillSaveStateReason || (WillSaveStateReason = {}));
function loadKeyTargets(storage) {
    const keysRaw = storage.get(TARGET_KEY);
    if (keysRaw) try {
        return JSON.parse(keysRaw);
    } catch (error) {
    // Fail gracefully
    }
    return Object.create(null);
}
class AbstractStorageService extends (0, _lifecycleJs.Disposable) {
    static{
        this.DEFAULT_FLUSH_INTERVAL = 60000;
    }
    constructor(options = {
        flushInterval: AbstractStorageService.DEFAULT_FLUSH_INTERVAL
    }){
        super();
        this.options = options;
        this._onDidChangeValue = this._register(new (0, _eventJs.PauseableEmitter)());
        this._onDidChangeTarget = this._register(new (0, _eventJs.PauseableEmitter)());
        this._onWillSaveState = this._register(new (0, _eventJs.Emitter)());
        this.onWillSaveState = this._onWillSaveState.event;
        this._workspaceKeyTargets = undefined;
        this._profileKeyTargets = undefined;
        this._applicationKeyTargets = undefined;
    }
    onDidChangeValue(scope, key, disposable) {
        return (0, _eventJs.Event).filter(this._onDidChangeValue.event, (e)=>e.scope === scope && (key === undefined || e.key === key), disposable);
    }
    emitDidChangeValue(scope, event) {
        const { key, external } = event;
        // Specially handle `TARGET_KEY`
        if (key === TARGET_KEY) {
            // Clear our cached version which is now out of date
            switch(scope){
                case -1 /* StorageScope.APPLICATION */ :
                    this._applicationKeyTargets = undefined;
                    break;
                case 0 /* StorageScope.PROFILE */ :
                    this._profileKeyTargets = undefined;
                    break;
                case 1 /* StorageScope.WORKSPACE */ :
                    this._workspaceKeyTargets = undefined;
                    break;
            }
            // Emit as `didChangeTarget` event
            this._onDidChangeTarget.fire({
                scope
            });
        } else this._onDidChangeValue.fire({
            scope,
            key,
            target: this.getKeyTargets(scope)[key],
            external
        });
    }
    get(key, scope, fallbackValue) {
        return this.getStorage(scope)?.get(key, fallbackValue);
    }
    getBoolean(key, scope, fallbackValue) {
        return this.getStorage(scope)?.getBoolean(key, fallbackValue);
    }
    getNumber(key, scope, fallbackValue) {
        return this.getStorage(scope)?.getNumber(key, fallbackValue);
    }
    store(key, value, scope, target, external = false) {
        // We remove the key for undefined/null values
        if ((0, _typesJs.isUndefinedOrNull)(value)) {
            this.remove(key, scope, external);
            return;
        }
        // Update our datastructures but send events only after
        this.withPausedEmitters(()=>{
            // Update key-target map
            this.updateKeyTarget(key, scope, target);
            // Store actual value
            this.getStorage(scope)?.set(key, value, external);
        });
    }
    remove(key, scope, external = false) {
        // Update our datastructures but send events only after
        this.withPausedEmitters(()=>{
            // Update key-target map
            this.updateKeyTarget(key, scope, undefined);
            // Remove actual key
            this.getStorage(scope)?.delete(key, external);
        });
    }
    withPausedEmitters(fn) {
        // Pause emitters
        this._onDidChangeValue.pause();
        this._onDidChangeTarget.pause();
        try {
            fn();
        } finally{
            // Resume emitters
            this._onDidChangeValue.resume();
            this._onDidChangeTarget.resume();
        }
    }
    updateKeyTarget(key, scope, target, external = false) {
        // Add
        const keyTargets = this.getKeyTargets(scope);
        if (typeof target === "number") {
            if (keyTargets[key] !== target) {
                keyTargets[key] = target;
                this.getStorage(scope)?.set(TARGET_KEY, JSON.stringify(keyTargets), external);
            }
        } else if (typeof keyTargets[key] === "number") {
            delete keyTargets[key];
            this.getStorage(scope)?.set(TARGET_KEY, JSON.stringify(keyTargets), external);
        }
    }
    get workspaceKeyTargets() {
        if (!this._workspaceKeyTargets) this._workspaceKeyTargets = this.loadKeyTargets(1 /* StorageScope.WORKSPACE */ );
        return this._workspaceKeyTargets;
    }
    get profileKeyTargets() {
        if (!this._profileKeyTargets) this._profileKeyTargets = this.loadKeyTargets(0 /* StorageScope.PROFILE */ );
        return this._profileKeyTargets;
    }
    get applicationKeyTargets() {
        if (!this._applicationKeyTargets) this._applicationKeyTargets = this.loadKeyTargets(-1 /* StorageScope.APPLICATION */ );
        return this._applicationKeyTargets;
    }
    getKeyTargets(scope) {
        switch(scope){
            case -1 /* StorageScope.APPLICATION */ :
                return this.applicationKeyTargets;
            case 0 /* StorageScope.PROFILE */ :
                return this.profileKeyTargets;
            default:
                return this.workspaceKeyTargets;
        }
    }
    loadKeyTargets(scope) {
        const storage = this.getStorage(scope);
        return storage ? loadKeyTargets(storage) : Object.create(null);
    }
}
class InMemoryStorageService extends AbstractStorageService {
    constructor(){
        super();
        this.applicationStorage = this._register(new (0, _storageJs.Storage)(new (0, _storageJs.InMemoryStorageDatabase)(), {
            hint: (0, _storageJs.StorageHint).STORAGE_IN_MEMORY
        }));
        this.profileStorage = this._register(new (0, _storageJs.Storage)(new (0, _storageJs.InMemoryStorageDatabase)(), {
            hint: (0, _storageJs.StorageHint).STORAGE_IN_MEMORY
        }));
        this.workspaceStorage = this._register(new (0, _storageJs.Storage)(new (0, _storageJs.InMemoryStorageDatabase)(), {
            hint: (0, _storageJs.StorageHint).STORAGE_IN_MEMORY
        }));
        this._register(this.workspaceStorage.onDidChangeStorage((e)=>this.emitDidChangeValue(1 /* StorageScope.WORKSPACE */ , e)));
        this._register(this.profileStorage.onDidChangeStorage((e)=>this.emitDidChangeValue(0 /* StorageScope.PROFILE */ , e)));
        this._register(this.applicationStorage.onDidChangeStorage((e)=>this.emitDidChangeValue(-1 /* StorageScope.APPLICATION */ , e)));
    }
    getStorage(scope) {
        switch(scope){
            case -1 /* StorageScope.APPLICATION */ :
                return this.applicationStorage;
            case 0 /* StorageScope.PROFILE */ :
                return this.profileStorage;
            default:
                return this.workspaceStorage;
        }
    }
}

},{"../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/types.js":"fb5yx","../../../base/parts/storage/common/storage.js":"g6Lt1","../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g6Lt1":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageHint", ()=>StorageHint);
parcelHelpers.export(exports, "StorageState", ()=>StorageState);
parcelHelpers.export(exports, "Storage", ()=>Storage);
parcelHelpers.export(exports, "InMemoryStorageDatabase", ()=>InMemoryStorageDatabase);
var _asyncJs = require("../../../common/async.js");
var _eventJs = require("../../../common/event.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _marshallingJs = require("../../../common/marshalling.js");
var _typesJs = require("../../../common/types.js");
var StorageHint;
(function(StorageHint) {
    // A hint to the storage that the storage
    // does not exist on disk yet. This allows
    // the storage library to improve startup
    // time by not checking the storage for data.
    StorageHint[StorageHint["STORAGE_DOES_NOT_EXIST"] = 0] = "STORAGE_DOES_NOT_EXIST";
    // A hint to the storage that the storage
    // is backed by an in-memory storage.
    StorageHint[StorageHint["STORAGE_IN_MEMORY"] = 1] = "STORAGE_IN_MEMORY";
})(StorageHint || (StorageHint = {}));
var StorageState;
(function(StorageState) {
    StorageState[StorageState["None"] = 0] = "None";
    StorageState[StorageState["Initialized"] = 1] = "Initialized";
    StorageState[StorageState["Closed"] = 2] = "Closed";
})(StorageState || (StorageState = {}));
class Storage extends (0, _lifecycleJs.Disposable) {
    static{
        this.DEFAULT_FLUSH_DELAY = 100;
    }
    constructor(database, options = Object.create(null)){
        super();
        this.database = database;
        this.options = options;
        this._onDidChangeStorage = this._register(new (0, _eventJs.PauseableEmitter)());
        this.onDidChangeStorage = this._onDidChangeStorage.event;
        this.state = StorageState.None;
        this.cache = new Map();
        this.flushDelayer = this._register(new (0, _asyncJs.ThrottledDelayer)(Storage.DEFAULT_FLUSH_DELAY));
        this.pendingDeletes = new Set();
        this.pendingInserts = new Map();
        this.whenFlushedCallbacks = [];
        this.registerListeners();
    }
    registerListeners() {
        this._register(this.database.onDidChangeItemsExternal((e)=>this.onDidChangeItemsExternal(e)));
    }
    onDidChangeItemsExternal(e) {
        this._onDidChangeStorage.pause();
        try {
            // items that change external require us to update our
            // caches with the values. we just accept the value and
            // emit an event if there is a change.
            e.changed?.forEach((value, key)=>this.acceptExternal(key, value));
            e.deleted?.forEach((key)=>this.acceptExternal(key, undefined));
        } finally{
            this._onDidChangeStorage.resume();
        }
    }
    acceptExternal(key, value) {
        if (this.state === StorageState.Closed) return; // Return early if we are already closed
        let changed = false;
        // Item got removed, check for deletion
        if ((0, _typesJs.isUndefinedOrNull)(value)) changed = this.cache.delete(key);
        else {
            const currentValue = this.cache.get(key);
            if (currentValue !== value) {
                this.cache.set(key, value);
                changed = true;
            }
        }
        // Signal to outside listeners
        if (changed) this._onDidChangeStorage.fire({
            key,
            external: true
        });
    }
    get(key, fallbackValue) {
        const value = this.cache.get(key);
        if ((0, _typesJs.isUndefinedOrNull)(value)) return fallbackValue;
        return value;
    }
    getBoolean(key, fallbackValue) {
        const value = this.get(key);
        if ((0, _typesJs.isUndefinedOrNull)(value)) return fallbackValue;
        return value === "true";
    }
    getNumber(key, fallbackValue) {
        const value = this.get(key);
        if ((0, _typesJs.isUndefinedOrNull)(value)) return fallbackValue;
        return parseInt(value, 10);
    }
    async set(key, value, external = false) {
        if (this.state === StorageState.Closed) return; // Return early if we are already closed
        // We remove the key for undefined/null values
        if ((0, _typesJs.isUndefinedOrNull)(value)) return this.delete(key, external);
        // Otherwise, convert to String and store
        const valueStr = (0, _typesJs.isObject)(value) || Array.isArray(value) ? (0, _marshallingJs.stringify)(value) : String(value);
        // Return early if value already set
        const currentValue = this.cache.get(key);
        if (currentValue === valueStr) return;
        // Update in cache and pending
        this.cache.set(key, valueStr);
        this.pendingInserts.set(key, valueStr);
        this.pendingDeletes.delete(key);
        // Event
        this._onDidChangeStorage.fire({
            key,
            external
        });
        // Accumulate work by scheduling after timeout
        return this.doFlush();
    }
    async delete(key, external = false) {
        if (this.state === StorageState.Closed) return; // Return early if we are already closed
        // Remove from cache and add to pending
        const wasDeleted = this.cache.delete(key);
        if (!wasDeleted) return; // Return early if value already deleted
        if (!this.pendingDeletes.has(key)) this.pendingDeletes.add(key);
        this.pendingInserts.delete(key);
        // Event
        this._onDidChangeStorage.fire({
            key,
            external
        });
        // Accumulate work by scheduling after timeout
        return this.doFlush();
    }
    get hasPending() {
        return this.pendingInserts.size > 0 || this.pendingDeletes.size > 0;
    }
    async flushPending() {
        if (!this.hasPending) return; // return early if nothing to do
        // Get pending data
        const updateRequest = {
            insert: this.pendingInserts,
            delete: this.pendingDeletes
        };
        // Reset pending data for next run
        this.pendingDeletes = new Set();
        this.pendingInserts = new Map();
        // Update in storage and release any
        // waiters we have once done
        return this.database.updateItems(updateRequest).finally(()=>{
            if (!this.hasPending) while(this.whenFlushedCallbacks.length)this.whenFlushedCallbacks.pop()?.();
        });
    }
    async doFlush(delay) {
        if (this.options.hint === StorageHint.STORAGE_IN_MEMORY) return this.flushPending(); // return early if in-memory
        return this.flushDelayer.trigger(()=>this.flushPending(), delay);
    }
}
class InMemoryStorageDatabase {
    constructor(){
        this.onDidChangeItemsExternal = (0, _eventJs.Event).None;
        this.items = new Map();
    }
    async updateItems(request) {
        request.insert?.forEach((value, key)=>this.items.set(key, value));
        request.delete?.forEach((key)=>this.items.delete(key));
    }
}

},{"../../../common/async.js":"4GJc4","../../../common/event.js":"4Zi8b","../../../common/lifecycle.js":"9kg8d","../../../common/marshalling.js":"e1DQr","../../../common/types.js":"fb5yx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4exuA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultKeybindingLabelStyles", ()=>defaultKeybindingLabelStyles);
parcelHelpers.export(exports, "defaultButtonStyles", ()=>defaultButtonStyles);
parcelHelpers.export(exports, "defaultProgressBarStyles", ()=>defaultProgressBarStyles);
parcelHelpers.export(exports, "defaultToggleStyles", ()=>defaultToggleStyles);
parcelHelpers.export(exports, "defaultRadioStyles", ()=>defaultRadioStyles);
parcelHelpers.export(exports, "defaultCheckboxStyles", ()=>defaultCheckboxStyles);
parcelHelpers.export(exports, "defaultDialogStyles", ()=>defaultDialogStyles);
parcelHelpers.export(exports, "defaultInputBoxStyles", ()=>defaultInputBoxStyles);
parcelHelpers.export(exports, "defaultFindWidgetStyles", ()=>defaultFindWidgetStyles);
parcelHelpers.export(exports, "defaultCountBadgeStyles", ()=>defaultCountBadgeStyles);
parcelHelpers.export(exports, "defaultBreadcrumbsWidgetStyles", ()=>defaultBreadcrumbsWidgetStyles);
parcelHelpers.export(exports, "defaultListStyles", ()=>defaultListStyles);
parcelHelpers.export(exports, "getListStyles", ()=>getListStyles);
parcelHelpers.export(exports, "defaultSelectBoxStyles", ()=>defaultSelectBoxStyles);
parcelHelpers.export(exports, "defaultMenuStyles", ()=>defaultMenuStyles);
var _colorRegistryJs = require("../common/colorRegistry.js");
var _colorJs = require("../../../base/common/color.js");
function overrideStyles(override, styles) {
    const result = {
        ...styles
    };
    for(const key in override){
        const val = override[key];
        result[key] = val !== undefined ? (0, _colorRegistryJs.asCssVariable)(val) : undefined;
    }
    return result;
}
const defaultKeybindingLabelStyles = {
    keybindingLabelBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.keybindingLabelBackground)),
    keybindingLabelForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.keybindingLabelForeground)),
    keybindingLabelBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.keybindingLabelBorder)),
    keybindingLabelBottomBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.keybindingLabelBottomBorder)),
    keybindingLabelShadow: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.widgetShadow))
};
const defaultButtonStyles = {
    buttonForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.buttonForeground)),
    buttonSeparator: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.buttonSeparator)),
    buttonBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.buttonBackground)),
    buttonHoverBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.buttonHoverBackground)),
    buttonSecondaryForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.buttonSecondaryForeground)),
    buttonSecondaryBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.buttonSecondaryBackground)),
    buttonSecondaryHoverBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.buttonSecondaryHoverBackground)),
    buttonBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.buttonBorder))
};
const defaultProgressBarStyles = {
    progressBarBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.progressBarBackground))
};
const defaultToggleStyles = {
    inputActiveOptionBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputActiveOptionBorder)),
    inputActiveOptionForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputActiveOptionForeground)),
    inputActiveOptionBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputActiveOptionBackground))
};
const defaultRadioStyles = {
    activeForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.radioActiveForeground)),
    activeBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.radioActiveBackground)),
    activeBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.radioActiveBorder)),
    inactiveForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.radioInactiveForeground)),
    inactiveBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.radioInactiveBackground)),
    inactiveBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.radioInactiveBorder)),
    inactiveHoverBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.radioInactiveHoverBackground))
};
const defaultCheckboxStyles = {
    checkboxBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.checkboxBackground)),
    checkboxBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.checkboxBorder)),
    checkboxForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.checkboxForeground))
};
const defaultDialogStyles = {
    dialogBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.editorWidgetBackground)),
    dialogForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.editorWidgetForeground)),
    dialogShadow: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.widgetShadow)),
    dialogBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.contrastBorder)),
    errorIconForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.problemsErrorIconForeground)),
    warningIconForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.problemsWarningIconForeground)),
    infoIconForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.problemsInfoIconForeground)),
    textLinkForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.textLinkForeground))
};
const defaultInputBoxStyles = {
    inputBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputBackground)),
    inputForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputForeground)),
    inputBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputBorder)),
    inputValidationInfoBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputValidationInfoBorder)),
    inputValidationInfoBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputValidationInfoBackground)),
    inputValidationInfoForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputValidationInfoForeground)),
    inputValidationWarningBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputValidationWarningBorder)),
    inputValidationWarningBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputValidationWarningBackground)),
    inputValidationWarningForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputValidationWarningForeground)),
    inputValidationErrorBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputValidationErrorBorder)),
    inputValidationErrorBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputValidationErrorBackground)),
    inputValidationErrorForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputValidationErrorForeground))
};
const defaultFindWidgetStyles = {
    listFilterWidgetBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listFilterWidgetBackground)),
    listFilterWidgetOutline: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listFilterWidgetOutline)),
    listFilterWidgetNoMatchesOutline: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listFilterWidgetNoMatchesOutline)),
    listFilterWidgetShadow: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listFilterWidgetShadow)),
    inputBoxStyles: defaultInputBoxStyles,
    toggleStyles: defaultToggleStyles
};
const defaultCountBadgeStyles = {
    badgeBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.badgeBackground)),
    badgeForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.badgeForeground)),
    badgeBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.contrastBorder))
};
const defaultBreadcrumbsWidgetStyles = {
    breadcrumbsBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.breadcrumbsBackground)),
    breadcrumbsForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.breadcrumbsForeground)),
    breadcrumbsHoverForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.breadcrumbsFocusForeground)),
    breadcrumbsFocusForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.breadcrumbsFocusForeground)),
    breadcrumbsFocusAndSelectionForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.breadcrumbsActiveSelectionForeground))
};
const defaultListStyles = {
    listBackground: undefined,
    listInactiveFocusForeground: undefined,
    listFocusBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listFocusBackground)),
    listFocusForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listFocusForeground)),
    listFocusOutline: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listFocusOutline)),
    listActiveSelectionBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listActiveSelectionBackground)),
    listActiveSelectionForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listActiveSelectionForeground)),
    listActiveSelectionIconForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listActiveSelectionIconForeground)),
    listFocusAndSelectionOutline: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listFocusAndSelectionOutline)),
    listFocusAndSelectionBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listActiveSelectionBackground)),
    listFocusAndSelectionForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listActiveSelectionForeground)),
    listInactiveSelectionBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listInactiveSelectionBackground)),
    listInactiveSelectionIconForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listInactiveSelectionIconForeground)),
    listInactiveSelectionForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listInactiveSelectionForeground)),
    listInactiveFocusBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listInactiveFocusBackground)),
    listInactiveFocusOutline: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listInactiveFocusOutline)),
    listHoverBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listHoverBackground)),
    listHoverForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listHoverForeground)),
    listDropOverBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listDropOverBackground)),
    listDropBetweenBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listDropBetweenBackground)),
    listSelectionOutline: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.activeContrastBorder)),
    listHoverOutline: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.activeContrastBorder)),
    treeIndentGuidesStroke: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.treeIndentGuidesStroke)),
    treeInactiveIndentGuidesStroke: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.treeInactiveIndentGuidesStroke)),
    treeStickyScrollBackground: undefined,
    treeStickyScrollBorder: undefined,
    treeStickyScrollShadow: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.scrollbarShadow)),
    tableColumnsBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.tableColumnsBorder)),
    tableOddRowsBackgroundColor: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.tableOddRowsBackgroundColor))
};
function getListStyles(override) {
    return overrideStyles(override, defaultListStyles);
}
const defaultSelectBoxStyles = {
    selectBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.selectBackground)),
    selectListBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.selectListBackground)),
    selectForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.selectForeground)),
    decoratorRightForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.pickerGroupForeground)),
    selectBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.selectBorder)),
    focusBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.focusBorder)),
    listFocusBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.quickInputListFocusBackground)),
    listInactiveSelectionIconForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.quickInputListFocusIconForeground)),
    listFocusForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.quickInputListFocusForeground)),
    listFocusOutline: (0, _colorRegistryJs.asCssVariableWithDefault)((0, _colorRegistryJs.activeContrastBorder), (0, _colorJs.Color).transparent.toString()),
    listHoverBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listHoverBackground)),
    listHoverForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.listHoverForeground)),
    listHoverOutline: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.activeContrastBorder)),
    selectListBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.editorWidgetBorder)),
    listBackground: undefined,
    listActiveSelectionBackground: undefined,
    listActiveSelectionForeground: undefined,
    listActiveSelectionIconForeground: undefined,
    listFocusAndSelectionBackground: undefined,
    listDropOverBackground: undefined,
    listDropBetweenBackground: undefined,
    listInactiveSelectionBackground: undefined,
    listInactiveSelectionForeground: undefined,
    listInactiveFocusBackground: undefined,
    listInactiveFocusOutline: undefined,
    listSelectionOutline: undefined,
    listFocusAndSelectionForeground: undefined,
    listFocusAndSelectionOutline: undefined,
    listInactiveFocusForeground: undefined,
    tableColumnsBorder: undefined,
    tableOddRowsBackgroundColor: undefined,
    treeIndentGuidesStroke: undefined,
    treeInactiveIndentGuidesStroke: undefined,
    treeStickyScrollBackground: undefined,
    treeStickyScrollBorder: undefined,
    treeStickyScrollShadow: undefined
};
const defaultMenuStyles = {
    shadowColor: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.widgetShadow)),
    borderColor: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.menuBorder)),
    foregroundColor: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.menuForeground)),
    backgroundColor: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.menuBackground)),
    selectionForegroundColor: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.menuSelectionForeground)),
    selectionBackgroundColor: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.menuSelectionBackground)),
    selectionBorderColor: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.menuSelectionBorder)),
    separatorColor: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.menuSeparatorBackground)),
    scrollbarShadow: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.scrollbarShadow)),
    scrollbarSliderBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.scrollbarSliderBackground)),
    scrollbarSliderHoverBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.scrollbarSliderHoverBackground)),
    scrollbarSliderActiveBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.scrollbarSliderActiveBackground))
};

},{"../common/colorRegistry.js":"ik5kv","../../../base/common/color.js":"at4gb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hrTjq":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextMenuHandler", ()=>ContextMenuHandler);
var _domJs = require("../../../base/browser/dom.js");
var _mouseEventJs = require("../../../base/browser/mouseEvent.js");
var _menuJs = require("../../../base/browser/ui/menu/menu.js");
var _actionsJs = require("../../../base/common/actions.js");
var _errorsJs = require("../../../base/common/errors.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _defaultStylesJs = require("../../theme/browser/defaultStyles.js");
class ContextMenuHandler {
    constructor(contextViewService, telemetryService, notificationService, keybindingService){
        this.contextViewService = contextViewService;
        this.telemetryService = telemetryService;
        this.notificationService = notificationService;
        this.keybindingService = keybindingService;
        this.focusToReturn = null;
        this.lastContainer = null;
        this.block = null;
        this.blockDisposable = null;
        this.options = {
            blockMouse: true
        };
    }
    configure(options) {
        this.options = options;
    }
    showContextMenu(delegate) {
        const actions = delegate.getActions();
        if (!actions.length) return; // Don't render an empty context menu
        this.focusToReturn = (0, _domJs.getActiveElement)();
        let menu;
        const shadowRootElement = (0, _domJs.isHTMLElement)(delegate.domForShadowRoot) ? delegate.domForShadowRoot : undefined;
        this.contextViewService.showContextView({
            getAnchor: ()=>delegate.getAnchor(),
            canRelayout: false,
            anchorAlignment: delegate.anchorAlignment,
            anchorAxisAlignment: delegate.anchorAxisAlignment,
            render: (container)=>{
                this.lastContainer = container;
                const className = delegate.getMenuClassName ? delegate.getMenuClassName() : "";
                if (className) container.className += " " + className;
                // Render invisible div to block mouse interaction in the rest of the UI
                if (this.options.blockMouse) {
                    this.block = container.appendChild((0, _domJs.$)(".context-view-block"));
                    this.block.style.position = "fixed";
                    this.block.style.cursor = "initial";
                    this.block.style.left = "0";
                    this.block.style.top = "0";
                    this.block.style.width = "100%";
                    this.block.style.height = "100%";
                    this.block.style.zIndex = "-1";
                    this.blockDisposable?.dispose();
                    this.blockDisposable = (0, _domJs.addDisposableListener)(this.block, (0, _domJs.EventType).MOUSE_DOWN, (e)=>e.stopPropagation());
                }
                const menuDisposables = new (0, _lifecycleJs.DisposableStore)();
                const actionRunner = delegate.actionRunner || new (0, _actionsJs.ActionRunner)();
                actionRunner.onWillRun((evt)=>this.onActionRun(evt, !delegate.skipTelemetry), this, menuDisposables);
                actionRunner.onDidRun(this.onDidActionRun, this, menuDisposables);
                menu = new (0, _menuJs.Menu)(container, actions, {
                    actionViewItemProvider: delegate.getActionViewItem,
                    context: delegate.getActionsContext ? delegate.getActionsContext() : null,
                    actionRunner,
                    getKeyBinding: delegate.getKeyBinding ? delegate.getKeyBinding : (action)=>this.keybindingService.lookupKeybinding(action.id)
                }, (0, _defaultStylesJs.defaultMenuStyles));
                menu.onDidCancel(()=>this.contextViewService.hideContextView(true), null, menuDisposables);
                menu.onDidBlur(()=>this.contextViewService.hideContextView(true), null, menuDisposables);
                const targetWindow = (0, _domJs.getWindow)(container);
                menuDisposables.add((0, _domJs.addDisposableListener)(targetWindow, (0, _domJs.EventType).BLUR, ()=>this.contextViewService.hideContextView(true)));
                menuDisposables.add((0, _domJs.addDisposableListener)(targetWindow, (0, _domJs.EventType).MOUSE_DOWN, (e)=>{
                    if (e.defaultPrevented) return;
                    const event = new (0, _mouseEventJs.StandardMouseEvent)(targetWindow, e);
                    let element = event.target;
                    // Don't do anything as we are likely creating a context menu
                    if (event.rightButton) return;
                    while(element){
                        if (element === container) return;
                        element = element.parentElement;
                    }
                    this.contextViewService.hideContextView(true);
                }));
                return (0, _lifecycleJs.combinedDisposable)(menuDisposables, menu);
            },
            focus: ()=>{
                menu?.focus(!!delegate.autoSelectFirstItem);
            },
            onHide: (didCancel)=>{
                delegate.onHide?.(!!didCancel);
                if (this.block) {
                    this.block.remove();
                    this.block = null;
                }
                this.blockDisposable?.dispose();
                this.blockDisposable = null;
                if (!!this.lastContainer && ((0, _domJs.getActiveElement)() === this.lastContainer || (0, _domJs.isAncestor)((0, _domJs.getActiveElement)(), this.lastContainer))) this.focusToReturn?.focus();
                this.lastContainer = null;
            }
        }, shadowRootElement, !!shadowRootElement);
    }
    onActionRun(e, logTelemetry) {
        if (logTelemetry) this.telemetryService.publicLog2("workbenchActionExecuted", {
            id: e.action.id,
            from: "contextMenu"
        });
        this.contextViewService.hideContextView(false);
    }
    onDidActionRun(e) {
        if (e.error && !(0, _errorsJs.isCancellationError)(e.error)) this.notificationService.error(e.error);
    }
}

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/mouseEvent.js":"4jTdu","../../../base/browser/ui/menu/menu.js":"j5zNx","../../../base/common/actions.js":"5GjLb","../../../base/common/errors.js":"divX8","../../../base/common/lifecycle.js":"9kg8d","../../theme/browser/defaultStyles.js":"4exuA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j5zNx":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MENU_MNEMONIC_REGEX", ()=>MENU_MNEMONIC_REGEX);
parcelHelpers.export(exports, "MENU_ESCAPED_MNEMONIC_REGEX", ()=>MENU_ESCAPED_MNEMONIC_REGEX);
parcelHelpers.export(exports, "HorizontalDirection", ()=>HorizontalDirection);
parcelHelpers.export(exports, "VerticalDirection", ()=>VerticalDirection);
parcelHelpers.export(exports, "Menu", ()=>Menu);
parcelHelpers.export(exports, "cleanMnemonic", ()=>cleanMnemonic);
parcelHelpers.export(exports, "formatRule", ()=>formatRule);
var _browserJs = require("../../browser.js");
var _touchJs = require("../../touch.js");
var _domJs = require("../../dom.js");
var _keyboardEventJs = require("../../keyboardEvent.js");
var _mouseEventJs = require("../../mouseEvent.js");
var _actionbarJs = require("../actionbar/actionbar.js");
var _actionViewItemsJs = require("../actionbar/actionViewItems.js");
var _contextviewJs = require("../contextview/contextview.js");
var _scrollableElementJs = require("../scrollbar/scrollableElement.js");
var _actionsJs = require("../../../common/actions.js");
var _asyncJs = require("../../../common/async.js");
var _codiconsJs = require("../../../common/codicons.js");
var _codiconsUtilJs = require("../../../common/codiconsUtil.js");
var _themablesJs = require("../../../common/themables.js");
var _iconLabelsJs = require("../../../common/iconLabels.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _platformJs = require("../../../common/platform.js");
var _stringsJs = require("../../../common/strings.js");
const MENU_MNEMONIC_REGEX = /\(&([^\s&])\)|(^|[^&])&([^\s&])/;
const MENU_ESCAPED_MNEMONIC_REGEX = /(&amp;)?(&amp;)([^\s&])/g;
var HorizontalDirection;
(function(HorizontalDirection) {
    HorizontalDirection[HorizontalDirection["Right"] = 0] = "Right";
    HorizontalDirection[HorizontalDirection["Left"] = 1] = "Left";
})(HorizontalDirection || (HorizontalDirection = {}));
var VerticalDirection;
(function(VerticalDirection) {
    VerticalDirection[VerticalDirection["Above"] = 0] = "Above";
    VerticalDirection[VerticalDirection["Below"] = 1] = "Below";
})(VerticalDirection || (VerticalDirection = {}));
class Menu extends (0, _actionbarJs.ActionBar) {
    constructor(container, actions, options, menuStyles){
        container.classList.add("monaco-menu-container");
        container.setAttribute("role", "presentation");
        const menuElement = document.createElement("div");
        menuElement.classList.add("monaco-menu");
        menuElement.setAttribute("role", "presentation");
        super(menuElement, {
            orientation: 1 /* ActionsOrientation.VERTICAL */ ,
            actionViewItemProvider: (action)=>this.doGetActionViewItem(action, options, parentData),
            context: options.context,
            actionRunner: options.actionRunner,
            ariaLabel: options.ariaLabel,
            ariaRole: "menu",
            focusOnlyEnabledItems: true,
            triggerKeys: {
                keys: [
                    3 /* KeyCode.Enter */ ,
                    ...(0, _platformJs.isMacintosh) || (0, _platformJs.isLinux) ? [
                        10 /* KeyCode.Space */ 
                    ] : []
                ],
                keyDown: true
            }
        });
        this.menuStyles = menuStyles;
        this.menuElement = menuElement;
        this.actionsList.tabIndex = 0;
        this.initializeOrUpdateStyleSheet(container, menuStyles);
        this._register((0, _touchJs.Gesture).addTarget(menuElement));
        this._register((0, _domJs.addDisposableListener)(menuElement, (0, _domJs.EventType).KEY_DOWN, (e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            // Stop tab navigation of menus
            if (event.equals(2 /* KeyCode.Tab */ )) e.preventDefault();
        }));
        if (options.enableMnemonics) this._register((0, _domJs.addDisposableListener)(menuElement, (0, _domJs.EventType).KEY_DOWN, (e)=>{
            const key = e.key.toLocaleLowerCase();
            if (this.mnemonics.has(key)) {
                (0, _domJs.EventHelper).stop(e, true);
                const actions = this.mnemonics.get(key);
                if (actions.length === 1) {
                    if (actions[0] instanceof SubmenuMenuActionViewItem && actions[0].container) this.focusItemByElement(actions[0].container);
                    actions[0].onClick(e);
                }
                if (actions.length > 1) {
                    const action = actions.shift();
                    if (action && action.container) {
                        this.focusItemByElement(action.container);
                        actions.push(action);
                    }
                    this.mnemonics.set(key, actions);
                }
            }
        }));
        if (0, _platformJs.isLinux) this._register((0, _domJs.addDisposableListener)(menuElement, (0, _domJs.EventType).KEY_DOWN, (e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            if (event.equals(14 /* KeyCode.Home */ ) || event.equals(11 /* KeyCode.PageUp */ )) {
                this.focusedItem = this.viewItems.length - 1;
                this.focusNext();
                (0, _domJs.EventHelper).stop(e, true);
            } else if (event.equals(13 /* KeyCode.End */ ) || event.equals(12 /* KeyCode.PageDown */ )) {
                this.focusedItem = 0;
                this.focusPrevious();
                (0, _domJs.EventHelper).stop(e, true);
            }
        }));
        this._register((0, _domJs.addDisposableListener)(this.domNode, (0, _domJs.EventType).MOUSE_OUT, (e)=>{
            const relatedTarget = e.relatedTarget;
            if (!(0, _domJs.isAncestor)(relatedTarget, this.domNode)) {
                this.focusedItem = undefined;
                this.updateFocus();
                e.stopPropagation();
            }
        }));
        this._register((0, _domJs.addDisposableListener)(this.actionsList, (0, _domJs.EventType).MOUSE_OVER, (e)=>{
            let target = e.target;
            if (!target || !(0, _domJs.isAncestor)(target, this.actionsList) || target === this.actionsList) return;
            while(target.parentElement !== this.actionsList && target.parentElement !== null)target = target.parentElement;
            if (target.classList.contains("action-item")) {
                const lastFocusedItem = this.focusedItem;
                this.setFocusedItem(target);
                if (lastFocusedItem !== this.focusedItem) this.updateFocus();
            }
        }));
        // Support touch on actions list to focus items (needed for submenus)
        this._register((0, _touchJs.Gesture).addTarget(this.actionsList));
        this._register((0, _domJs.addDisposableListener)(this.actionsList, (0, _touchJs.EventType).Tap, (e)=>{
            let target = e.initialTarget;
            if (!target || !(0, _domJs.isAncestor)(target, this.actionsList) || target === this.actionsList) return;
            while(target.parentElement !== this.actionsList && target.parentElement !== null)target = target.parentElement;
            if (target.classList.contains("action-item")) {
                const lastFocusedItem = this.focusedItem;
                this.setFocusedItem(target);
                if (lastFocusedItem !== this.focusedItem) this.updateFocus();
            }
        }));
        const parentData = {
            parent: this
        };
        this.mnemonics = new Map();
        // Scroll Logic
        this.scrollableElement = this._register(new (0, _scrollableElementJs.DomScrollableElement)(menuElement, {
            alwaysConsumeMouseWheel: true,
            horizontal: 2 /* ScrollbarVisibility.Hidden */ ,
            vertical: 3 /* ScrollbarVisibility.Visible */ ,
            verticalScrollbarSize: 7,
            handleMouseWheel: true,
            useShadows: true
        }));
        const scrollElement = this.scrollableElement.getDomNode();
        scrollElement.style.position = "";
        this.styleScrollElement(scrollElement, menuStyles);
        // Support scroll on menu drag
        this._register((0, _domJs.addDisposableListener)(menuElement, (0, _touchJs.EventType).Change, (e)=>{
            (0, _domJs.EventHelper).stop(e, true);
            const scrollTop = this.scrollableElement.getScrollPosition().scrollTop;
            this.scrollableElement.setScrollPosition({
                scrollTop: scrollTop - e.translationY
            });
        }));
        this._register((0, _domJs.addDisposableListener)(scrollElement, (0, _domJs.EventType).MOUSE_UP, (e)=>{
            // Absorb clicks in menu dead space https://github.com/microsoft/vscode/issues/63575
            // We do this on the scroll element so the scroll bar doesn't dismiss the menu either
            e.preventDefault();
        }));
        const window = (0, _domJs.getWindow)(container);
        menuElement.style.maxHeight = `${Math.max(10, window.innerHeight - container.getBoundingClientRect().top - 35)}px`;
        actions = actions.filter((a, idx)=>{
            if (options.submenuIds?.has(a.id)) {
                console.warn(`Found submenu cycle: ${a.id}`);
                return false;
            }
            // Filter out consecutive or useless separators
            if (a instanceof (0, _actionsJs.Separator)) {
                if (idx === actions.length - 1 || idx === 0) return false;
                const prevAction = actions[idx - 1];
                if (prevAction instanceof (0, _actionsJs.Separator)) return false;
            }
            return true;
        });
        this.push(actions, {
            icon: true,
            label: true,
            isMenu: true
        });
        container.appendChild(this.scrollableElement.getDomNode());
        this.scrollableElement.scanDomNode();
        this.viewItems.filter((item)=>!(item instanceof MenuSeparatorActionViewItem)).forEach((item, index, array)=>{
            item.updatePositionInSet(index + 1, array.length);
        });
    }
    initializeOrUpdateStyleSheet(container, style) {
        if (!this.styleSheet) {
            if ((0, _domJs.isInShadowDOM)(container)) this.styleSheet = (0, _domJs.createStyleSheet)(container);
            else {
                if (!Menu.globalStyleSheet) Menu.globalStyleSheet = (0, _domJs.createStyleSheet)();
                this.styleSheet = Menu.globalStyleSheet;
            }
        }
        this.styleSheet.textContent = getMenuWidgetCSS(style, (0, _domJs.isInShadowDOM)(container));
    }
    styleScrollElement(scrollElement, style) {
        const fgColor = style.foregroundColor ?? "";
        const bgColor = style.backgroundColor ?? "";
        const border = style.borderColor ? `1px solid ${style.borderColor}` : "";
        const borderRadius = "5px";
        const shadow = style.shadowColor ? `0 2px 8px ${style.shadowColor}` : "";
        scrollElement.style.outline = border;
        scrollElement.style.borderRadius = borderRadius;
        scrollElement.style.color = fgColor;
        scrollElement.style.backgroundColor = bgColor;
        scrollElement.style.boxShadow = shadow;
    }
    getContainer() {
        return this.scrollableElement.getDomNode();
    }
    get onScroll() {
        return this.scrollableElement.onScroll;
    }
    focusItemByElement(element) {
        const lastFocusedItem = this.focusedItem;
        this.setFocusedItem(element);
        if (lastFocusedItem !== this.focusedItem) this.updateFocus();
    }
    setFocusedItem(element) {
        for(let i = 0; i < this.actionsList.children.length; i++){
            const elem = this.actionsList.children[i];
            if (element === elem) {
                this.focusedItem = i;
                break;
            }
        }
    }
    updateFocus(fromRight) {
        super.updateFocus(fromRight, true, true);
        if (typeof this.focusedItem !== "undefined") // Workaround for #80047 caused by an issue in chromium
        // https://bugs.chromium.org/p/chromium/issues/detail?id=414283
        // When that's fixed, just call this.scrollableElement.scanDomNode()
        this.scrollableElement.setScrollPosition({
            scrollTop: Math.round(this.menuElement.scrollTop)
        });
    }
    doGetActionViewItem(action, options, parentData) {
        if (action instanceof (0, _actionsJs.Separator)) return new MenuSeparatorActionViewItem(options.context, action, {
            icon: true
        }, this.menuStyles);
        else if (action instanceof (0, _actionsJs.SubmenuAction)) {
            const menuActionViewItem = new SubmenuMenuActionViewItem(action, action.actions, parentData, {
                ...options,
                submenuIds: new Set([
                    ...options.submenuIds || [],
                    action.id
                ])
            }, this.menuStyles);
            if (options.enableMnemonics) {
                const mnemonic = menuActionViewItem.getMnemonic();
                if (mnemonic && menuActionViewItem.isEnabled()) {
                    let actionViewItems = [];
                    if (this.mnemonics.has(mnemonic)) actionViewItems = this.mnemonics.get(mnemonic);
                    actionViewItems.push(menuActionViewItem);
                    this.mnemonics.set(mnemonic, actionViewItems);
                }
            }
            return menuActionViewItem;
        } else {
            const menuItemOptions = {
                enableMnemonics: options.enableMnemonics,
                useEventAsContext: options.useEventAsContext
            };
            if (options.getKeyBinding) {
                const keybinding = options.getKeyBinding(action);
                if (keybinding) {
                    const keybindingLabel = keybinding.getLabel();
                    if (keybindingLabel) menuItemOptions.keybinding = keybindingLabel;
                }
            }
            const menuActionViewItem = new BaseMenuActionViewItem(options.context, action, menuItemOptions, this.menuStyles);
            if (options.enableMnemonics) {
                const mnemonic = menuActionViewItem.getMnemonic();
                if (mnemonic && menuActionViewItem.isEnabled()) {
                    let actionViewItems = [];
                    if (this.mnemonics.has(mnemonic)) actionViewItems = this.mnemonics.get(mnemonic);
                    actionViewItems.push(menuActionViewItem);
                    this.mnemonics.set(mnemonic, actionViewItems);
                }
            }
            return menuActionViewItem;
        }
    }
}
class BaseMenuActionViewItem extends (0, _actionViewItemsJs.BaseActionViewItem) {
    constructor(ctx, action, options, menuStyle){
        options.isMenu = true;
        super(action, action, options);
        this.menuStyle = menuStyle;
        this.options = options;
        this.options.icon = options.icon !== undefined ? options.icon : false;
        this.options.label = options.label !== undefined ? options.label : true;
        this.cssClass = "";
        // Set mnemonic
        if (this.options.label && options.enableMnemonics) {
            const label = this.action.label;
            if (label) {
                const matches = MENU_MNEMONIC_REGEX.exec(label);
                if (matches) this.mnemonic = (!!matches[1] ? matches[1] : matches[3]).toLocaleLowerCase();
            }
        }
        // Add mouse up listener later to avoid accidental clicks
        this.runOnceToEnableMouseUp = new (0, _asyncJs.RunOnceScheduler)(()=>{
            if (!this.element) return;
            this._register((0, _domJs.addDisposableListener)(this.element, (0, _domJs.EventType).MOUSE_UP, (e)=>{
                // removed default prevention as it conflicts
                // with BaseActionViewItem #101537
                // add back if issues arise and link new issue
                (0, _domJs.EventHelper).stop(e, true);
                // See https://developer.mozilla.org/en-US/Add-ons/WebExtensions/Interact_with_the_clipboard
                // > Writing to the clipboard
                // > You can use the "cut" and "copy" commands without any special
                // permission if you are using them in a short-lived event handler
                // for a user action (for example, a click handler).
                // => to get the Copy and Paste context menu actions working on Firefox,
                // there should be no timeout here
                if (0, _browserJs.isFirefox) {
                    const mouseEvent = new (0, _mouseEventJs.StandardMouseEvent)((0, _domJs.getWindow)(this.element), e);
                    // Allowing right click to trigger the event causes the issue described below,
                    // but since the solution below does not work in FF, we must disable right click
                    if (mouseEvent.rightButton) return;
                    this.onClick(e);
                } else setTimeout(()=>{
                    this.onClick(e);
                }, 0);
            }));
            this._register((0, _domJs.addDisposableListener)(this.element, (0, _domJs.EventType).CONTEXT_MENU, (e)=>{
                (0, _domJs.EventHelper).stop(e, true);
            }));
        }, 100);
        this._register(this.runOnceToEnableMouseUp);
    }
    render(container) {
        super.render(container);
        if (!this.element) return;
        this.container = container;
        this.item = (0, _domJs.append)(this.element, (0, _domJs.$)("a.action-menu-item"));
        if (this._action.id === (0, _actionsJs.Separator).ID) // A separator is a presentation item
        this.item.setAttribute("role", "presentation");
        else {
            this.item.setAttribute("role", "menuitem");
            if (this.mnemonic) this.item.setAttribute("aria-keyshortcuts", `${this.mnemonic}`);
        }
        this.check = (0, _domJs.append)(this.item, (0, _domJs.$)("span.menu-item-check" + (0, _themablesJs.ThemeIcon).asCSSSelector((0, _codiconsJs.Codicon).menuSelection)));
        this.check.setAttribute("role", "none");
        this.label = (0, _domJs.append)(this.item, (0, _domJs.$)("span.action-label"));
        if (this.options.label && this.options.keybinding) (0, _domJs.append)(this.item, (0, _domJs.$)("span.keybinding")).textContent = this.options.keybinding;
        // Adds mouse up listener to actually run the action
        this.runOnceToEnableMouseUp.schedule();
        this.updateClass();
        this.updateLabel();
        this.updateTooltip();
        this.updateEnabled();
        this.updateChecked();
        this.applyStyle();
    }
    blur() {
        super.blur();
        this.applyStyle();
    }
    focus() {
        super.focus();
        this.item?.focus();
        this.applyStyle();
    }
    updatePositionInSet(pos, setSize) {
        if (this.item) {
            this.item.setAttribute("aria-posinset", `${pos}`);
            this.item.setAttribute("aria-setsize", `${setSize}`);
        }
    }
    updateLabel() {
        if (!this.label) return;
        if (this.options.label) {
            (0, _domJs.clearNode)(this.label);
            let label = (0, _iconLabelsJs.stripIcons)(this.action.label);
            if (label) {
                const cleanLabel = cleanMnemonic(label);
                if (!this.options.enableMnemonics) label = cleanLabel;
                this.label.setAttribute("aria-label", cleanLabel.replace(/&&/g, "&"));
                const matches = MENU_MNEMONIC_REGEX.exec(label);
                if (matches) {
                    label = _stringsJs.escape(label);
                    // This is global, reset it
                    MENU_ESCAPED_MNEMONIC_REGEX.lastIndex = 0;
                    let escMatch = MENU_ESCAPED_MNEMONIC_REGEX.exec(label);
                    // We can't use negative lookbehind so if we match our negative and skip
                    while(escMatch && escMatch[1])escMatch = MENU_ESCAPED_MNEMONIC_REGEX.exec(label);
                    const replaceDoubleEscapes = (str)=>str.replace(/&amp;&amp;/g, "&amp;");
                    if (escMatch) this.label.append(_stringsJs.ltrim(replaceDoubleEscapes(label.substr(0, escMatch.index)), " "), (0, _domJs.$)("u", {
                        "aria-hidden": "true"
                    }, escMatch[3]), _stringsJs.rtrim(replaceDoubleEscapes(label.substr(escMatch.index + escMatch[0].length)), " "));
                    else this.label.innerText = replaceDoubleEscapes(label).trim();
                    this.item?.setAttribute("aria-keyshortcuts", (!!matches[1] ? matches[1] : matches[3]).toLocaleLowerCase());
                } else this.label.innerText = label.replace(/&&/g, "&").trim();
            }
        }
    }
    updateTooltip() {
    // menus should function like native menus and they do not have tooltips
    }
    updateClass() {
        if (this.cssClass && this.item) this.item.classList.remove(...this.cssClass.split(" "));
        if (this.options.icon && this.label) {
            this.cssClass = this.action.class || "";
            this.label.classList.add("icon");
            if (this.cssClass) this.label.classList.add(...this.cssClass.split(" "));
            this.updateEnabled();
        } else if (this.label) this.label.classList.remove("icon");
    }
    updateEnabled() {
        if (this.action.enabled) {
            if (this.element) {
                this.element.classList.remove("disabled");
                this.element.removeAttribute("aria-disabled");
            }
            if (this.item) {
                this.item.classList.remove("disabled");
                this.item.removeAttribute("aria-disabled");
                this.item.tabIndex = 0;
            }
        } else {
            if (this.element) {
                this.element.classList.add("disabled");
                this.element.setAttribute("aria-disabled", "true");
            }
            if (this.item) {
                this.item.classList.add("disabled");
                this.item.setAttribute("aria-disabled", "true");
            }
        }
    }
    updateChecked() {
        if (!this.item) return;
        const checked = this.action.checked;
        this.item.classList.toggle("checked", !!checked);
        if (checked !== undefined) {
            this.item.setAttribute("role", "menuitemcheckbox");
            this.item.setAttribute("aria-checked", checked ? "true" : "false");
        } else {
            this.item.setAttribute("role", "menuitem");
            this.item.setAttribute("aria-checked", "");
        }
    }
    getMnemonic() {
        return this.mnemonic;
    }
    applyStyle() {
        const isSelected = this.element && this.element.classList.contains("focused");
        const fgColor = isSelected && this.menuStyle.selectionForegroundColor ? this.menuStyle.selectionForegroundColor : this.menuStyle.foregroundColor;
        const bgColor = isSelected && this.menuStyle.selectionBackgroundColor ? this.menuStyle.selectionBackgroundColor : undefined;
        const outline = isSelected && this.menuStyle.selectionBorderColor ? `1px solid ${this.menuStyle.selectionBorderColor}` : "";
        const outlineOffset = isSelected && this.menuStyle.selectionBorderColor ? `-1px` : "";
        if (this.item) {
            this.item.style.color = fgColor ?? "";
            this.item.style.backgroundColor = bgColor ?? "";
            this.item.style.outline = outline;
            this.item.style.outlineOffset = outlineOffset;
        }
        if (this.check) this.check.style.color = fgColor ?? "";
    }
}
class SubmenuMenuActionViewItem extends BaseMenuActionViewItem {
    constructor(action, submenuActions, parentData, submenuOptions, menuStyles){
        super(action, action, submenuOptions, menuStyles);
        this.submenuActions = submenuActions;
        this.parentData = parentData;
        this.submenuOptions = submenuOptions;
        this.mysubmenu = null;
        this.submenuDisposables = this._register(new (0, _lifecycleJs.DisposableStore)());
        this.mouseOver = false;
        this.expandDirection = submenuOptions && submenuOptions.expandDirection !== undefined ? submenuOptions.expandDirection : {
            horizontal: HorizontalDirection.Right,
            vertical: VerticalDirection.Below
        };
        this.showScheduler = new (0, _asyncJs.RunOnceScheduler)(()=>{
            if (this.mouseOver) {
                this.cleanupExistingSubmenu(false);
                this.createSubmenu(false);
            }
        }, 250);
        this.hideScheduler = new (0, _asyncJs.RunOnceScheduler)(()=>{
            if (this.element && !(0, _domJs.isAncestor)((0, _domJs.getActiveElement)(), this.element) && this.parentData.submenu === this.mysubmenu) {
                this.parentData.parent.focus(false);
                this.cleanupExistingSubmenu(true);
            }
        }, 750);
    }
    render(container) {
        super.render(container);
        if (!this.element) return;
        if (this.item) {
            this.item.classList.add("monaco-submenu-item");
            this.item.tabIndex = 0;
            this.item.setAttribute("aria-haspopup", "true");
            this.updateAriaExpanded("false");
            this.submenuIndicator = (0, _domJs.append)(this.item, (0, _domJs.$)("span.submenu-indicator" + (0, _themablesJs.ThemeIcon).asCSSSelector((0, _codiconsJs.Codicon).menuSubmenu)));
            this.submenuIndicator.setAttribute("aria-hidden", "true");
        }
        this._register((0, _domJs.addDisposableListener)(this.element, (0, _domJs.EventType).KEY_UP, (e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            if (event.equals(17 /* KeyCode.RightArrow */ ) || event.equals(3 /* KeyCode.Enter */ )) {
                (0, _domJs.EventHelper).stop(e, true);
                this.createSubmenu(true);
            }
        }));
        this._register((0, _domJs.addDisposableListener)(this.element, (0, _domJs.EventType).KEY_DOWN, (e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            if ((0, _domJs.getActiveElement)() === this.item) {
                if (event.equals(17 /* KeyCode.RightArrow */ ) || event.equals(3 /* KeyCode.Enter */ )) (0, _domJs.EventHelper).stop(e, true);
            }
        }));
        this._register((0, _domJs.addDisposableListener)(this.element, (0, _domJs.EventType).MOUSE_OVER, (e)=>{
            if (!this.mouseOver) {
                this.mouseOver = true;
                this.showScheduler.schedule();
            }
        }));
        this._register((0, _domJs.addDisposableListener)(this.element, (0, _domJs.EventType).MOUSE_LEAVE, (e)=>{
            this.mouseOver = false;
        }));
        this._register((0, _domJs.addDisposableListener)(this.element, (0, _domJs.EventType).FOCUS_OUT, (e)=>{
            if (this.element && !(0, _domJs.isAncestor)((0, _domJs.getActiveElement)(), this.element)) this.hideScheduler.schedule();
        }));
        this._register(this.parentData.parent.onScroll(()=>{
            if (this.parentData.submenu === this.mysubmenu) {
                this.parentData.parent.focus(false);
                this.cleanupExistingSubmenu(true);
            }
        }));
    }
    updateEnabled() {
    // override on submenu entry
    // native menus do not observe enablement on sumbenus
    // we mimic that behavior
    }
    onClick(e) {
        // stop clicking from trying to run an action
        (0, _domJs.EventHelper).stop(e, true);
        this.cleanupExistingSubmenu(false);
        this.createSubmenu(true);
    }
    cleanupExistingSubmenu(force) {
        if (this.parentData.submenu && (force || this.parentData.submenu !== this.mysubmenu)) {
            // disposal may throw if the submenu has already been removed
            try {
                this.parentData.submenu.dispose();
            } catch  {}
            this.parentData.submenu = undefined;
            this.updateAriaExpanded("false");
            if (this.submenuContainer) {
                this.submenuDisposables.clear();
                this.submenuContainer = undefined;
            }
        }
    }
    calculateSubmenuMenuLayout(windowDimensions, submenu, entry, expandDirection) {
        const ret = {
            top: 0,
            left: 0
        };
        // Start with horizontal
        ret.left = (0, _contextviewJs.layout)(windowDimensions.width, submenu.width, {
            position: expandDirection.horizontal === HorizontalDirection.Right ? 0 /* LayoutAnchorPosition.Before */  : 1 /* LayoutAnchorPosition.After */ ,
            offset: entry.left,
            size: entry.width
        });
        // We don't have enough room to layout the menu fully, so we are overlapping the menu
        if (ret.left >= entry.left && ret.left < entry.left + entry.width) {
            if (entry.left + 10 + submenu.width <= windowDimensions.width) ret.left = entry.left + 10;
            entry.top += 10;
            entry.height = 0;
        }
        // Now that we have a horizontal position, try layout vertically
        ret.top = (0, _contextviewJs.layout)(windowDimensions.height, submenu.height, {
            position: 0 /* LayoutAnchorPosition.Before */ ,
            offset: entry.top,
            size: 0
        });
        // We didn't have enough room below, but we did above, so we shift down to align the menu
        if (ret.top + submenu.height === entry.top && ret.top + entry.height + submenu.height <= windowDimensions.height) ret.top += entry.height;
        return ret;
    }
    createSubmenu(selectFirstItem = true) {
        if (!this.element) return;
        if (!this.parentData.submenu) {
            this.updateAriaExpanded("true");
            this.submenuContainer = (0, _domJs.append)(this.element, (0, _domJs.$)("div.monaco-submenu"));
            this.submenuContainer.classList.add("menubar-menu-items-holder", "context-view");
            // Set the top value of the menu container before construction
            // This allows the menu constructor to calculate the proper max height
            const computedStyles = (0, _domJs.getWindow)(this.parentData.parent.domNode).getComputedStyle(this.parentData.parent.domNode);
            const paddingTop = parseFloat(computedStyles.paddingTop || "0") || 0;
            // this.submenuContainer.style.top = `${this.element.offsetTop - this.parentData.parent.scrollOffset - paddingTop}px`;
            this.submenuContainer.style.zIndex = "1";
            this.submenuContainer.style.position = "fixed";
            this.submenuContainer.style.top = "0";
            this.submenuContainer.style.left = "0";
            this.parentData.submenu = new Menu(this.submenuContainer, this.submenuActions.length ? this.submenuActions : [
                new (0, _actionsJs.EmptySubmenuAction)()
            ], this.submenuOptions, this.menuStyle);
            // layout submenu
            const entryBox = this.element.getBoundingClientRect();
            const entryBoxUpdated = {
                top: entryBox.top - paddingTop,
                left: entryBox.left,
                height: entryBox.height + 2 * paddingTop,
                width: entryBox.width
            };
            const viewBox = this.submenuContainer.getBoundingClientRect();
            const window = (0, _domJs.getWindow)(this.element);
            const { top, left } = this.calculateSubmenuMenuLayout(new (0, _domJs.Dimension)(window.innerWidth, window.innerHeight), (0, _domJs.Dimension).lift(viewBox), entryBoxUpdated, this.expandDirection);
            // subtract offsets caused by transform parent
            this.submenuContainer.style.left = `${left - viewBox.left}px`;
            this.submenuContainer.style.top = `${top - viewBox.top}px`;
            this.submenuDisposables.add((0, _domJs.addDisposableListener)(this.submenuContainer, (0, _domJs.EventType).KEY_UP, (e)=>{
                const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
                if (event.equals(15 /* KeyCode.LeftArrow */ )) {
                    (0, _domJs.EventHelper).stop(e, true);
                    this.parentData.parent.focus();
                    this.cleanupExistingSubmenu(true);
                }
            }));
            this.submenuDisposables.add((0, _domJs.addDisposableListener)(this.submenuContainer, (0, _domJs.EventType).KEY_DOWN, (e)=>{
                const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
                if (event.equals(15 /* KeyCode.LeftArrow */ )) (0, _domJs.EventHelper).stop(e, true);
            }));
            this.submenuDisposables.add(this.parentData.submenu.onDidCancel(()=>{
                this.parentData.parent.focus();
                this.cleanupExistingSubmenu(true);
            }));
            this.parentData.submenu.focus(selectFirstItem);
            this.mysubmenu = this.parentData.submenu;
        } else this.parentData.submenu.focus(false);
    }
    updateAriaExpanded(value) {
        if (this.item) this.item?.setAttribute("aria-expanded", value);
    }
    applyStyle() {
        super.applyStyle();
        const isSelected = this.element && this.element.classList.contains("focused");
        const fgColor = isSelected && this.menuStyle.selectionForegroundColor ? this.menuStyle.selectionForegroundColor : this.menuStyle.foregroundColor;
        if (this.submenuIndicator) this.submenuIndicator.style.color = fgColor ?? "";
    }
    dispose() {
        super.dispose();
        this.hideScheduler.dispose();
        if (this.mysubmenu) {
            this.mysubmenu.dispose();
            this.mysubmenu = null;
        }
        if (this.submenuContainer) this.submenuContainer = undefined;
    }
}
class MenuSeparatorActionViewItem extends (0, _actionViewItemsJs.ActionViewItem) {
    constructor(context, action, options, menuStyles){
        super(context, action, options);
        this.menuStyles = menuStyles;
    }
    render(container) {
        super.render(container);
        if (this.label) this.label.style.borderBottomColor = this.menuStyles.separatorColor ? `${this.menuStyles.separatorColor}` : "";
    }
}
function cleanMnemonic(label) {
    const regex = MENU_MNEMONIC_REGEX;
    const matches = regex.exec(label);
    if (!matches) return label;
    const mnemonicInText = !matches[1];
    return label.replace(regex, mnemonicInText ? "$2$3" : "").trim();
}
function formatRule(c) {
    const fontCharacter = (0, _codiconsUtilJs.getCodiconFontCharacters)()[c.id];
    return `.codicon-${c.id}:before { content: '\\${fontCharacter.toString(16)}'; }`;
}
function getMenuWidgetCSS(style, isForShadowDom) {
    let result = /* css */ `
.monaco-menu {
	font-size: 13px;
	border-radius: 5px;
	min-width: 160px;
}

${formatRule((0, _codiconsJs.Codicon).menuSelection)}
${formatRule((0, _codiconsJs.Codicon).menuSubmenu)}

.monaco-menu .monaco-action-bar {
	text-align: right;
	overflow: hidden;
	white-space: nowrap;
}

.monaco-menu .monaco-action-bar .actions-container {
	display: flex;
	margin: 0 auto;
	padding: 0;
	width: 100%;
	justify-content: flex-end;
}

.monaco-menu .monaco-action-bar.vertical .actions-container {
	display: inline-block;
}

.monaco-menu .monaco-action-bar.reverse .actions-container {
	flex-direction: row-reverse;
}

.monaco-menu .monaco-action-bar .action-item {
	cursor: pointer;
	display: inline-block;
	transition: transform 50ms ease;
	position: relative;  /* DO NOT REMOVE - this is the key to preventing the ghosting icon bug in Chrome 42 */
}

.monaco-menu .monaco-action-bar .action-item.disabled {
	cursor: default;
}

.monaco-menu .monaco-action-bar .action-item .icon,
.monaco-menu .monaco-action-bar .action-item .codicon {
	display: inline-block;
}

.monaco-menu .monaco-action-bar .action-item .codicon {
	display: flex;
	align-items: center;
}

.monaco-menu .monaco-action-bar .action-label {
	font-size: 11px;
	margin-right: 4px;
}

.monaco-menu .monaco-action-bar .action-item.disabled .action-label,
.monaco-menu .monaco-action-bar .action-item.disabled .action-label:hover {
	color: var(--vscode-disabledForeground);
}

/* Vertical actions */

.monaco-menu .monaco-action-bar.vertical {
	text-align: left;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	display: block;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	display: block;
	border-bottom: 1px solid var(--vscode-menu-separatorBackground);
	padding-top: 1px;
	padding: 30px;
}

.monaco-menu .secondary-actions .monaco-action-bar .action-label {
	margin-left: 6px;
}

/* Action Items */
.monaco-menu .monaco-action-bar .action-item.select-container {
	overflow: hidden; /* somehow the dropdown overflows its container, we prevent it here to not push */
	flex: 1;
	max-width: 170px;
	min-width: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 10px;
}

.monaco-menu .monaco-action-bar.vertical {
	margin-left: 0;
	overflow: visible;
}

.monaco-menu .monaco-action-bar.vertical .actions-container {
	display: block;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	padding: 0;
	transform: none;
	display: flex;
}

.monaco-menu .monaco-action-bar.vertical .action-item.active {
	transform: none;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item {
	flex: 1 1 auto;
	display: flex;
	height: 2em;
	align-items: center;
	position: relative;
	margin: 0 4px;
	border-radius: 4px;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item:hover .keybinding,
.monaco-menu .monaco-action-bar.vertical .action-menu-item:focus .keybinding {
	opacity: unset;
}

.monaco-menu .monaco-action-bar.vertical .action-label {
	flex: 1 1 auto;
	text-decoration: none;
	padding: 0 1em;
	background: none;
	font-size: 12px;
	line-height: 1;
}

.monaco-menu .monaco-action-bar.vertical .keybinding,
.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	display: inline-block;
	flex: 2 1 auto;
	padding: 0 1em;
	text-align: right;
	font-size: 12px;
	line-height: 1;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator.codicon {
	font-size: 16px !important;
	display: flex;
	align-items: center;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator.codicon::before {
	margin-left: auto;
	margin-right: -20px;
}

.monaco-menu .monaco-action-bar.vertical .action-item.disabled .keybinding,
.monaco-menu .monaco-action-bar.vertical .action-item.disabled .submenu-indicator {
	opacity: 0.4;
}

.monaco-menu .monaco-action-bar.vertical .action-label:not(.separator) {
	display: inline-block;
	box-sizing: border-box;
	margin: 0;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	position: static;
	overflow: visible;
}

.monaco-menu .monaco-action-bar.vertical .action-item .monaco-submenu {
	position: absolute;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	width: 100%;
	height: 0px !important;
	opacity: 1;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator.text {
	padding: 0.7em 1em 0.1em 1em;
	font-weight: bold;
	opacity: 1;
}

.monaco-menu .monaco-action-bar.vertical .action-label:hover {
	color: inherit;
}

.monaco-menu .monaco-action-bar.vertical .menu-item-check {
	position: absolute;
	visibility: hidden;
	width: 1em;
	height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item.checked .menu-item-check {
	visibility: visible;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* Context Menu */

.context-view.monaco-menu-container {
	outline: 0;
	border: none;
	animation: fadeIn 0.083s linear;
	-webkit-app-region: no-drag;
}

.context-view.monaco-menu-container :focus,
.context-view.monaco-menu-container .monaco-action-bar.vertical:focus,
.context-view.monaco-menu-container .monaco-action-bar.vertical :focus {
	outline: 0;
}

.hc-black .context-view.monaco-menu-container,
.hc-light .context-view.monaco-menu-container,
:host-context(.hc-black) .context-view.monaco-menu-container,
:host-context(.hc-light) .context-view.monaco-menu-container {
	box-shadow: none;
}

.hc-black .monaco-menu .monaco-action-bar.vertical .action-item.focused,
.hc-light .monaco-menu .monaco-action-bar.vertical .action-item.focused,
:host-context(.hc-black) .monaco-menu .monaco-action-bar.vertical .action-item.focused,
:host-context(.hc-light) .monaco-menu .monaco-action-bar.vertical .action-item.focused {
	background: none;
}

/* Vertical Action Bar Styles */

.monaco-menu .monaco-action-bar.vertical {
	padding: 4px 0;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item {
	height: 2em;
}

.monaco-menu .monaco-action-bar.vertical .action-label:not(.separator),
.monaco-menu .monaco-action-bar.vertical .keybinding {
	font-size: inherit;
	padding: 0 2em;
	max-height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .menu-item-check {
	font-size: inherit;
	width: 2em;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	font-size: inherit;
	margin: 5px 0 !important;
	padding: 0;
	border-radius: 0;
}

.linux .monaco-menu .monaco-action-bar.vertical .action-label.separator,
:host-context(.linux) .monaco-menu .monaco-action-bar.vertical .action-label.separator {
	margin-left: 0;
	margin-right: 0;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	font-size: 60%;
	padding: 0 1.8em;
}

.linux .monaco-menu .monaco-action-bar.vertical .submenu-indicator,
:host-context(.linux) .monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	height: 100%;
	mask-size: 10px 10px;
	-webkit-mask-size: 10px 10px;
}

.monaco-menu .action-item {
	cursor: default;
}`;
    if (isForShadowDom) {
        // Only define scrollbar styles when used inside shadow dom,
        // otherwise leave their styling to the global workbench styling.
        result += `
			/* Arrows */
			.monaco-scrollable-element > .scrollbar > .scra {
				cursor: pointer;
				font-size: 11px !important;
			}

			.monaco-scrollable-element > .visible {
				opacity: 1;

				/* Background rule added for IE9 - to allow clicks on dom node */
				background:rgba(0,0,0,0);

				transition: opacity 100ms linear;
			}
			.monaco-scrollable-element > .invisible {
				opacity: 0;
				pointer-events: none;
			}
			.monaco-scrollable-element > .invisible.fade {
				transition: opacity 800ms linear;
			}

			/* Scrollable Content Inset Shadow */
			.monaco-scrollable-element > .shadow {
				position: absolute;
				display: none;
			}
			.monaco-scrollable-element > .shadow.top {
				display: block;
				top: 0;
				left: 3px;
				height: 3px;
				width: 100%;
			}
			.monaco-scrollable-element > .shadow.left {
				display: block;
				top: 3px;
				left: 0;
				height: 100%;
				width: 3px;
			}
			.monaco-scrollable-element > .shadow.top-left-corner {
				display: block;
				top: 0;
				left: 0;
				height: 3px;
				width: 3px;
			}
		`;
        // Scrollbars
        const scrollbarShadowColor = style.scrollbarShadow;
        if (scrollbarShadowColor) result += `
				.monaco-scrollable-element > .shadow.top {
					box-shadow: ${scrollbarShadowColor} 0 6px 6px -6px inset;
				}

				.monaco-scrollable-element > .shadow.left {
					box-shadow: ${scrollbarShadowColor} 6px 0 6px -6px inset;
				}

				.monaco-scrollable-element > .shadow.top.left {
					box-shadow: ${scrollbarShadowColor} 6px 6px 6px -6px inset;
				}
			`;
        const scrollbarSliderBackgroundColor = style.scrollbarSliderBackground;
        if (scrollbarSliderBackgroundColor) result += `
				.monaco-scrollable-element > .scrollbar > .slider {
					background: ${scrollbarSliderBackgroundColor};
				}
			`;
        const scrollbarSliderHoverBackgroundColor = style.scrollbarSliderHoverBackground;
        if (scrollbarSliderHoverBackgroundColor) result += `
				.monaco-scrollable-element > .scrollbar > .slider:hover {
					background: ${scrollbarSliderHoverBackgroundColor};
				}
			`;
        const scrollbarSliderActiveBackgroundColor = style.scrollbarSliderActiveBackground;
        if (scrollbarSliderActiveBackgroundColor) result += `
				.monaco-scrollable-element > .scrollbar > .slider.active {
					background: ${scrollbarSliderActiveBackgroundColor};
				}
			`;
    }
    return result;
}

},{"../../browser.js":"4Zquf","../../touch.js":"6iGQn","../../dom.js":"bnqsM","../../keyboardEvent.js":"bxU9U","../../mouseEvent.js":"4jTdu","../actionbar/actionbar.js":"5Xmba","../actionbar/actionViewItems.js":"6Yy9b","../contextview/contextview.js":"3CURE","../scrollbar/scrollableElement.js":"h1C5l","../../../common/actions.js":"5GjLb","../../../common/async.js":"4GJc4","../../../common/codicons.js":"hWYNf","../../../common/codiconsUtil.js":"6g8vy","../../../common/themables.js":"hgyHi","../../../common/iconLabels.js":"3vhIZ","../../../common/lifecycle.js":"9kg8d","../../../common/platform.js":"7maJO","../../../common/strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Xmba":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBar", ()=>ActionBar);
var _domJs = require("../../dom.js");
var _keyboardEventJs = require("../../keyboardEvent.js");
var _actionViewItemsJs = require("./actionViewItems.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _actionsJs = require("../../../common/actions.js");
var _eventJs = require("../../../common/event.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _typesJs = require("../../../common/types.js");
var _actionbarCss = require("./actionbar.css");
class ActionBar extends (0, _lifecycleJs.Disposable) {
    constructor(container, options = {}){
        super();
        this._actionRunnerDisposables = this._register(new (0, _lifecycleJs.DisposableStore)());
        this.viewItemDisposables = this._register(new (0, _lifecycleJs.DisposableMap)());
        // Trigger Key Tracking
        this.triggerKeyDown = false;
        this.focusable = true;
        this._onDidBlur = this._register(new (0, _eventJs.Emitter)());
        this.onDidBlur = this._onDidBlur.event;
        this._onDidCancel = this._register(new (0, _eventJs.Emitter)({
            onWillAddFirstListener: ()=>this.cancelHasListener = true
        }));
        this.onDidCancel = this._onDidCancel.event;
        this.cancelHasListener = false;
        this._onDidRun = this._register(new (0, _eventJs.Emitter)());
        this.onDidRun = this._onDidRun.event;
        this._onWillRun = this._register(new (0, _eventJs.Emitter)());
        this.onWillRun = this._onWillRun.event;
        this.options = options;
        this._context = options.context ?? null;
        this._orientation = this.options.orientation ?? 0 /* ActionsOrientation.HORIZONTAL */ ;
        this._triggerKeys = {
            keyDown: this.options.triggerKeys?.keyDown ?? false,
            keys: this.options.triggerKeys?.keys ?? [
                3 /* KeyCode.Enter */ ,
                10 /* KeyCode.Space */ 
            ]
        };
        this._hoverDelegate = options.hoverDelegate ?? this._register((0, _hoverDelegateFactoryJs.createInstantHoverDelegate)());
        if (this.options.actionRunner) this._actionRunner = this.options.actionRunner;
        else {
            this._actionRunner = new (0, _actionsJs.ActionRunner)();
            this._actionRunnerDisposables.add(this._actionRunner);
        }
        this._actionRunnerDisposables.add(this._actionRunner.onDidRun((e)=>this._onDidRun.fire(e)));
        this._actionRunnerDisposables.add(this._actionRunner.onWillRun((e)=>this._onWillRun.fire(e)));
        this.viewItems = [];
        this.focusedItem = undefined;
        this.domNode = document.createElement("div");
        this.domNode.className = "monaco-action-bar";
        let previousKeys;
        let nextKeys;
        switch(this._orientation){
            case 0 /* ActionsOrientation.HORIZONTAL */ :
                previousKeys = [
                    15 /* KeyCode.LeftArrow */ 
                ];
                nextKeys = [
                    17 /* KeyCode.RightArrow */ 
                ];
                break;
            case 1 /* ActionsOrientation.VERTICAL */ :
                previousKeys = [
                    16 /* KeyCode.UpArrow */ 
                ];
                nextKeys = [
                    18 /* KeyCode.DownArrow */ 
                ];
                this.domNode.className += " vertical";
                break;
        }
        this._register(_domJs.addDisposableListener(this.domNode, _domJs.EventType.KEY_DOWN, (e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            let eventHandled = true;
            const focusedItem = typeof this.focusedItem === "number" ? this.viewItems[this.focusedItem] : undefined;
            if (previousKeys && (event.equals(previousKeys[0]) || event.equals(previousKeys[1]))) eventHandled = this.focusPrevious();
            else if (nextKeys && (event.equals(nextKeys[0]) || event.equals(nextKeys[1]))) eventHandled = this.focusNext();
            else if (event.equals(9 /* KeyCode.Escape */ ) && this.cancelHasListener) this._onDidCancel.fire();
            else if (event.equals(14 /* KeyCode.Home */ )) eventHandled = this.focusFirst();
            else if (event.equals(13 /* KeyCode.End */ )) eventHandled = this.focusLast();
            else if (event.equals(2 /* KeyCode.Tab */ ) && focusedItem instanceof (0, _actionViewItemsJs.BaseActionViewItem) && focusedItem.trapsArrowNavigation) // Tab, so forcibly focus next #219199
            eventHandled = this.focusNext(undefined, true);
            else if (this.isTriggerKeyEvent(event)) {
                // Staying out of the else branch even if not triggered
                if (this._triggerKeys.keyDown) this.doTrigger(event);
                else this.triggerKeyDown = true;
            } else eventHandled = false;
            if (eventHandled) {
                event.preventDefault();
                event.stopPropagation();
            }
        }));
        this._register(_domJs.addDisposableListener(this.domNode, _domJs.EventType.KEY_UP, (e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            // Run action on Enter/Space
            if (this.isTriggerKeyEvent(event)) {
                if (!this._triggerKeys.keyDown && this.triggerKeyDown) {
                    this.triggerKeyDown = false;
                    this.doTrigger(event);
                }
                event.preventDefault();
                event.stopPropagation();
            } else if (event.equals(2 /* KeyCode.Tab */ ) || event.equals(1026 /* KeyCode.Tab */ ) || event.equals(16 /* KeyCode.UpArrow */ ) || event.equals(18 /* KeyCode.DownArrow */ ) || event.equals(15 /* KeyCode.LeftArrow */ ) || event.equals(17 /* KeyCode.RightArrow */ )) this.updateFocusedItem();
        }));
        this.focusTracker = this._register(_domJs.trackFocus(this.domNode));
        this._register(this.focusTracker.onDidBlur(()=>{
            if (_domJs.getActiveElement() === this.domNode || !_domJs.isAncestor(_domJs.getActiveElement(), this.domNode)) {
                this._onDidBlur.fire();
                this.previouslyFocusedItem = this.focusedItem;
                this.focusedItem = undefined;
                this.triggerKeyDown = false;
            }
        }));
        this._register(this.focusTracker.onDidFocus(()=>this.updateFocusedItem()));
        this.actionsList = document.createElement("ul");
        this.actionsList.className = "actions-container";
        if (this.options.highlightToggledItems) this.actionsList.classList.add("highlight-toggled");
        this.actionsList.setAttribute("role", this.options.ariaRole || "toolbar");
        if (this.options.ariaLabel) this.actionsList.setAttribute("aria-label", this.options.ariaLabel);
        this.domNode.appendChild(this.actionsList);
        container.appendChild(this.domNode);
    }
    refreshRole() {
        if (this.length() >= 1) this.actionsList.setAttribute("role", this.options.ariaRole || "toolbar");
        else this.actionsList.setAttribute("role", "presentation");
    }
    // Some action bars should not be focusable at times
    // When an action bar is not focusable make sure to make all the elements inside it not focusable
    // When an action bar is focusable again, make sure the first item can be focused
    setFocusable(focusable) {
        this.focusable = focusable;
        if (this.focusable) {
            const firstEnabled = this.viewItems.find((vi)=>vi instanceof (0, _actionViewItemsJs.BaseActionViewItem) && vi.isEnabled());
            if (firstEnabled instanceof (0, _actionViewItemsJs.BaseActionViewItem)) firstEnabled.setFocusable(true);
        } else this.viewItems.forEach((vi)=>{
            if (vi instanceof (0, _actionViewItemsJs.BaseActionViewItem)) vi.setFocusable(false);
        });
    }
    isTriggerKeyEvent(event) {
        let ret = false;
        this._triggerKeys.keys.forEach((keyCode)=>{
            ret = ret || event.equals(keyCode);
        });
        return ret;
    }
    updateFocusedItem() {
        for(let i = 0; i < this.actionsList.children.length; i++){
            const elem = this.actionsList.children[i];
            if (_domJs.isAncestor(_domJs.getActiveElement(), elem)) {
                this.focusedItem = i;
                this.viewItems[this.focusedItem]?.showHover?.();
                break;
            }
        }
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
        this.viewItems.forEach((i)=>i.setActionContext(context));
    }
    get actionRunner() {
        return this._actionRunner;
    }
    set actionRunner(actionRunner) {
        this._actionRunner = actionRunner;
        // when setting a new `IActionRunner` make sure to dispose old listeners and
        // start to forward events from the new listener
        this._actionRunnerDisposables.clear();
        this._actionRunnerDisposables.add(this._actionRunner.onDidRun((e)=>this._onDidRun.fire(e)));
        this._actionRunnerDisposables.add(this._actionRunner.onWillRun((e)=>this._onWillRun.fire(e)));
        this.viewItems.forEach((item)=>item.actionRunner = actionRunner);
    }
    getContainer() {
        return this.domNode;
    }
    getAction(indexOrElement) {
        // by index
        if (typeof indexOrElement === "number") return this.viewItems[indexOrElement]?.action;
        // by element
        if (_domJs.isHTMLElement(indexOrElement)) {
            while(indexOrElement.parentElement !== this.actionsList){
                if (!indexOrElement.parentElement) return undefined;
                indexOrElement = indexOrElement.parentElement;
            }
            for(let i = 0; i < this.actionsList.childNodes.length; i++){
                if (this.actionsList.childNodes[i] === indexOrElement) return this.viewItems[i].action;
            }
        }
        return undefined;
    }
    push(arg, options = {}) {
        const actions = Array.isArray(arg) ? arg : [
            arg
        ];
        let index = _typesJs.isNumber(options.index) ? options.index : null;
        actions.forEach((action)=>{
            const actionViewItemElement = document.createElement("li");
            actionViewItemElement.className = "action-item";
            actionViewItemElement.setAttribute("role", "presentation");
            let item;
            const viewItemOptions = {
                hoverDelegate: this._hoverDelegate,
                ...options,
                isTabList: this.options.ariaRole === "tablist"
            };
            if (this.options.actionViewItemProvider) item = this.options.actionViewItemProvider(action, viewItemOptions);
            if (!item) item = new (0, _actionViewItemsJs.ActionViewItem)(this.context, action, viewItemOptions);
            // Prevent native context menu on actions
            if (!this.options.allowContextMenu) this.viewItemDisposables.set(item, _domJs.addDisposableListener(actionViewItemElement, _domJs.EventType.CONTEXT_MENU, (e)=>{
                _domJs.EventHelper.stop(e, true);
            }));
            item.actionRunner = this._actionRunner;
            item.setActionContext(this.context);
            item.render(actionViewItemElement);
            if (this.focusable && item instanceof (0, _actionViewItemsJs.BaseActionViewItem) && this.viewItems.length === 0) // We need to allow for the first enabled item to be focused on using tab navigation #106441
            item.setFocusable(true);
            if (index === null || index < 0 || index >= this.actionsList.children.length) {
                this.actionsList.appendChild(actionViewItemElement);
                this.viewItems.push(item);
            } else {
                this.actionsList.insertBefore(actionViewItemElement, this.actionsList.children[index]);
                this.viewItems.splice(index, 0, item);
                index++;
            }
        });
        if (typeof this.focusedItem === "number") // After a clear actions might be re-added to simply toggle some actions. We should preserve focus #97128
        this.focus(this.focusedItem);
        this.refreshRole();
    }
    clear() {
        if (this.isEmpty()) return;
        this.viewItems = (0, _lifecycleJs.dispose)(this.viewItems);
        this.viewItemDisposables.clearAndDisposeAll();
        _domJs.clearNode(this.actionsList);
        this.refreshRole();
    }
    length() {
        return this.viewItems.length;
    }
    isEmpty() {
        return this.viewItems.length === 0;
    }
    focus(arg) {
        let selectFirst = false;
        let index = undefined;
        if (arg === undefined) selectFirst = true;
        else if (typeof arg === "number") index = arg;
        else if (typeof arg === "boolean") selectFirst = arg;
        if (selectFirst && typeof this.focusedItem === "undefined") {
            const firstEnabled = this.viewItems.findIndex((item)=>item.isEnabled());
            // Focus the first enabled item
            this.focusedItem = firstEnabled === -1 ? undefined : firstEnabled;
            this.updateFocus(undefined, undefined, true);
        } else {
            if (index !== undefined) this.focusedItem = index;
            this.updateFocus(undefined, undefined, true);
        }
    }
    focusFirst() {
        this.focusedItem = this.length() - 1;
        return this.focusNext(true);
    }
    focusLast() {
        this.focusedItem = 0;
        return this.focusPrevious(true);
    }
    focusNext(forceLoop, forceFocus) {
        if (typeof this.focusedItem === "undefined") this.focusedItem = this.viewItems.length - 1;
        else if (this.viewItems.length <= 1) return false;
        const startIndex = this.focusedItem;
        let item;
        do {
            if (!forceLoop && this.options.preventLoopNavigation && this.focusedItem + 1 >= this.viewItems.length) {
                this.focusedItem = startIndex;
                return false;
            }
            this.focusedItem = (this.focusedItem + 1) % this.viewItems.length;
            item = this.viewItems[this.focusedItem];
        }while (this.focusedItem !== startIndex && (this.options.focusOnlyEnabledItems && !item.isEnabled() || item.action.id === (0, _actionsJs.Separator).ID));
        this.updateFocus(undefined, undefined, forceFocus);
        return true;
    }
    focusPrevious(forceLoop) {
        if (typeof this.focusedItem === "undefined") this.focusedItem = 0;
        else if (this.viewItems.length <= 1) return false;
        const startIndex = this.focusedItem;
        let item;
        do {
            this.focusedItem = this.focusedItem - 1;
            if (this.focusedItem < 0) {
                if (!forceLoop && this.options.preventLoopNavigation) {
                    this.focusedItem = startIndex;
                    return false;
                }
                this.focusedItem = this.viewItems.length - 1;
            }
            item = this.viewItems[this.focusedItem];
        }while (this.focusedItem !== startIndex && (this.options.focusOnlyEnabledItems && !item.isEnabled() || item.action.id === (0, _actionsJs.Separator).ID));
        this.updateFocus(true);
        return true;
    }
    updateFocus(fromRight, preventScroll, forceFocus = false) {
        if (typeof this.focusedItem === "undefined") this.actionsList.focus({
            preventScroll
        });
        if (this.previouslyFocusedItem !== undefined && this.previouslyFocusedItem !== this.focusedItem) this.viewItems[this.previouslyFocusedItem]?.blur();
        const actionViewItem = this.focusedItem !== undefined ? this.viewItems[this.focusedItem] : undefined;
        if (actionViewItem) {
            let focusItem = true;
            if (!_typesJs.isFunction(actionViewItem.focus)) focusItem = false;
            if (this.options.focusOnlyEnabledItems && _typesJs.isFunction(actionViewItem.isEnabled) && !actionViewItem.isEnabled()) focusItem = false;
            if (actionViewItem.action.id === (0, _actionsJs.Separator).ID) focusItem = false;
            if (!focusItem) {
                this.actionsList.focus({
                    preventScroll
                });
                this.previouslyFocusedItem = undefined;
            } else if (forceFocus || this.previouslyFocusedItem !== this.focusedItem) {
                actionViewItem.focus(fromRight);
                this.previouslyFocusedItem = this.focusedItem;
            }
            if (focusItem) actionViewItem.showHover?.();
        }
    }
    doTrigger(event) {
        if (typeof this.focusedItem === "undefined") return; //nothing to focus
        // trigger action
        const actionViewItem = this.viewItems[this.focusedItem];
        if (actionViewItem instanceof (0, _actionViewItemsJs.BaseActionViewItem)) {
            const context = actionViewItem._context === null || actionViewItem._context === undefined ? event : actionViewItem._context;
            this.run(actionViewItem._action, context);
        }
    }
    async run(action, context) {
        await this._actionRunner.run(action, context);
    }
    dispose() {
        this._context = undefined;
        this.viewItems = (0, _lifecycleJs.dispose)(this.viewItems);
        this.getContainer().remove();
        super.dispose();
    }
}

},{"../../dom.js":"bnqsM","../../keyboardEvent.js":"bxU9U","./actionViewItems.js":"6Yy9b","../hover/hoverDelegateFactory.js":"kll4h","../../../common/actions.js":"5GjLb","../../../common/event.js":"4Zi8b","../../../common/lifecycle.js":"9kg8d","../../../common/types.js":"fb5yx","./actionbar.css":"gFocE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gFocE":[function() {},{}],"hdbML":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenerService", ()=>OpenerService);
var _domJs = require("../../../base/browser/dom.js");
var _windowJs = require("../../../base/browser/window.js");
var _cancellationJs = require("../../../base/common/cancellation.js");
var _linkedListJs = require("../../../base/common/linkedList.js");
var _mapJs = require("../../../base/common/map.js");
var _marshallingJs = require("../../../base/common/marshalling.js");
var _networkJs = require("../../../base/common/network.js");
var _resourcesJs = require("../../../base/common/resources.js");
var _uriJs = require("../../../base/common/uri.js");
var _codeEditorServiceJs = require("./codeEditorService.js");
var _commandsJs = require("../../../platform/commands/common/commands.js");
var _editorJs = require("../../../platform/editor/common/editor.js");
var _openerJs = require("../../../platform/opener/common/opener.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let CommandOpener = class CommandOpener {
    constructor(_commandService){
        this._commandService = _commandService;
    }
    async open(target, options) {
        if (!(0, _networkJs.matchesScheme)(target, (0, _networkJs.Schemas).command)) return false;
        if (!options?.allowCommands) // silently ignore commands when command-links are disabled, also
        // suppress other openers by returning TRUE
        return true;
        if (typeof target === "string") target = (0, _uriJs.URI).parse(target);
        if (Array.isArray(options.allowCommands)) {
            // Only allow specific commands
            if (!options.allowCommands.includes(target.path)) // Suppress other openers by returning TRUE
            return true;
        }
        // execute as command
        let args = [];
        try {
            args = (0, _marshallingJs.parse)(decodeURIComponent(target.query));
        } catch  {
            // ignore and retry
            try {
                args = (0, _marshallingJs.parse)(target.query);
            } catch  {
            // ignore error
            }
        }
        if (!Array.isArray(args)) args = [
            args
        ];
        await this._commandService.executeCommand(target.path, ...args);
        return true;
    }
};
CommandOpener = __decorate([
    __param(0, (0, _commandsJs.ICommandService))
], CommandOpener);
let EditorOpener = class EditorOpener {
    constructor(_editorService){
        this._editorService = _editorService;
    }
    async open(target, options) {
        if (typeof target === "string") target = (0, _uriJs.URI).parse(target);
        const { selection, uri } = (0, _openerJs.extractSelection)(target);
        target = uri;
        if (target.scheme === (0, _networkJs.Schemas).file) target = (0, _resourcesJs.normalizePath)(target); // workaround for non-normalized paths (https://github.com/microsoft/vscode/issues/12954)
        await this._editorService.openCodeEditor({
            resource: target,
            options: {
                selection,
                source: options?.fromUserGesture ? (0, _editorJs.EditorOpenSource).USER : (0, _editorJs.EditorOpenSource).API,
                ...options?.editorOptions
            }
        }, this._editorService.getFocusedCodeEditor(), options?.openToSide);
        return true;
    }
};
EditorOpener = __decorate([
    __param(0, (0, _codeEditorServiceJs.ICodeEditorService))
], EditorOpener);
let OpenerService = class OpenerService {
    constructor(editorService, commandService){
        this._openers = new (0, _linkedListJs.LinkedList)();
        this._validators = new (0, _linkedListJs.LinkedList)();
        this._resolvers = new (0, _linkedListJs.LinkedList)();
        this._resolvedUriTargets = new (0, _mapJs.ResourceMap)((uri)=>uri.with({
                path: null,
                fragment: null,
                query: null
            }).toString());
        this._externalOpeners = new (0, _linkedListJs.LinkedList)();
        // Default external opener is going through window.open()
        this._defaultExternalOpener = {
            openExternal: async (href)=>{
                // ensure to open HTTP/HTTPS links into new windows
                // to not trigger a navigation. Any other link is
                // safe to be set as HREF to prevent a blank window
                // from opening.
                if ((0, _networkJs.matchesSomeScheme)(href, (0, _networkJs.Schemas).http, (0, _networkJs.Schemas).https)) _domJs.windowOpenNoOpener(href);
                else (0, _windowJs.mainWindow).location.href = href;
                return true;
            }
        };
        // Default opener: any external, maito, http(s), command, and catch-all-editors
        this._openers.push({
            open: async (target, options)=>{
                if (options?.openExternal || (0, _networkJs.matchesSomeScheme)(target, (0, _networkJs.Schemas).mailto, (0, _networkJs.Schemas).http, (0, _networkJs.Schemas).https, (0, _networkJs.Schemas).vsls)) {
                    // open externally
                    await this._doOpenExternal(target, options);
                    return true;
                }
                return false;
            }
        });
        this._openers.push(new CommandOpener(commandService));
        this._openers.push(new EditorOpener(editorService));
    }
    registerOpener(opener) {
        const remove = this._openers.unshift(opener);
        return {
            dispose: remove
        };
    }
    async open(target, options) {
        // check with contributed validators
        const targetURI = typeof target === "string" ? (0, _uriJs.URI).parse(target) : target;
        // validate against the original URI that this URI resolves to, if one exists
        const validationTarget = this._resolvedUriTargets.get(targetURI) ?? target;
        for (const validator of this._validators){
            if (!await validator.shouldOpen(validationTarget, options)) return false;
        }
        // check with contributed openers
        for (const opener of this._openers){
            const handled = await opener.open(target, options);
            if (handled) return true;
        }
        return false;
    }
    async resolveExternalUri(resource, options) {
        for (const resolver of this._resolvers)try {
            const result = await resolver.resolveExternalUri(resource, options);
            if (result) {
                if (!this._resolvedUriTargets.has(result.resolved)) this._resolvedUriTargets.set(result.resolved, resource);
                return result;
            }
        } catch  {
        // noop
        }
        throw new Error("Could not resolve external URI: " + resource.toString());
    }
    async _doOpenExternal(resource, options) {
        //todo@jrieken IExternalUriResolver should support `uri: URI | string`
        const uri = typeof resource === "string" ? (0, _uriJs.URI).parse(resource) : resource;
        let externalUri;
        try {
            externalUri = (await this.resolveExternalUri(uri, options)).resolved;
        } catch  {
            externalUri = uri;
        }
        let href;
        if (typeof resource === "string" && uri.toString() === externalUri.toString()) // open the url-string AS IS
        href = resource;
        else // open URI using the toString(noEncode)+encodeURI-trick
        href = encodeURI(externalUri.toString(true));
        if (options?.allowContributedOpeners) {
            const preferredOpenerId = typeof options?.allowContributedOpeners === "string" ? options?.allowContributedOpeners : undefined;
            for (const opener of this._externalOpeners){
                const didOpen = await opener.openExternal(href, {
                    sourceUri: uri,
                    preferredOpenerId
                }, (0, _cancellationJs.CancellationToken).None);
                if (didOpen) return true;
            }
        }
        return this._defaultExternalOpener.openExternal(href, {
            sourceUri: uri
        }, (0, _cancellationJs.CancellationToken).None);
    }
    dispose() {
        this._validators.clear();
    }
};
OpenerService = __decorate([
    __param(0, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(1, (0, _commandsJs.ICommandService))
], OpenerService);

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/window.js":"aJBhQ","../../../base/common/cancellation.js":"hoVxw","../../../base/common/linkedList.js":"kv7Rg","../../../base/common/map.js":"leSjz","../../../base/common/marshalling.js":"e1DQr","../../../base/common/network.js":"2c1AD","../../../base/common/resources.js":"700EV","../../../base/common/uri.js":"7qGS3","./codeEditorService.js":"bOWtl","../../../platform/commands/common/commands.js":"ho6ic","../../../platform/editor/common/editor.js":"890mu","../../../platform/opener/common/opener.js":"d3tj1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"890mu":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorOpenSource", ()=>EditorOpenSource);
var EditorOpenSource;
(function(EditorOpenSource) {
    /**
     * Default: the editor is opening via a programmatic call
     * to the editor service API.
     */ EditorOpenSource[EditorOpenSource["API"] = 0] = "API";
    /**
     * Indicates that a user action triggered the opening, e.g.
     * via mouse or keyboard use.
     */ EditorOpenSource[EditorOpenSource["USER"] = 1] = "USER";
})(EditorOpenSource || (EditorOpenSource = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aaYJd":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IEditorWorkerService", ()=>IEditorWorkerService);
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
const IEditorWorkerService = (0, _instantiationJs.createDecorator)("editorWorkerService");

},{"../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"A8sE6":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkerDecorationsService", ()=>MarkerDecorationsService);
var _markersJs = require("../../../platform/markers/common/markers.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _modelJs = require("../model.js");
var _themeServiceJs = require("../../../platform/theme/common/themeService.js");
var _editorColorRegistryJs = require("../core/editorColorRegistry.js");
var _modelJs1 = require("./model.js");
var _rangeJs = require("../core/range.js");
var _networkJs = require("../../../base/common/network.js");
var _eventJs = require("../../../base/common/event.js");
var _colorRegistryJs = require("../../../platform/theme/common/colorRegistry.js");
var _mapJs = require("../../../base/common/map.js");
var _collectionsJs = require("../../../base/common/collections.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let MarkerDecorationsService = class MarkerDecorationsService extends (0, _lifecycleJs.Disposable) {
    constructor(modelService, _markerService){
        super();
        this._markerService = _markerService;
        this._onDidChangeMarker = this._register(new (0, _eventJs.Emitter)());
        this._markerDecorations = new (0, _mapJs.ResourceMap)();
        modelService.getModels().forEach((model)=>this._onModelAdded(model));
        this._register(modelService.onModelAdded(this._onModelAdded, this));
        this._register(modelService.onModelRemoved(this._onModelRemoved, this));
        this._register(this._markerService.onMarkerChanged(this._handleMarkerChange, this));
    }
    dispose() {
        super.dispose();
        this._markerDecorations.forEach((value)=>value.dispose());
        this._markerDecorations.clear();
    }
    getMarker(uri, decoration) {
        const markerDecorations = this._markerDecorations.get(uri);
        return markerDecorations ? markerDecorations.getMarker(decoration) || null : null;
    }
    _handleMarkerChange(changedResources) {
        changedResources.forEach((resource)=>{
            const markerDecorations = this._markerDecorations.get(resource);
            if (markerDecorations) this._updateDecorations(markerDecorations);
        });
    }
    _onModelAdded(model) {
        const markerDecorations = new MarkerDecorations(model);
        this._markerDecorations.set(model.uri, markerDecorations);
        this._updateDecorations(markerDecorations);
    }
    _onModelRemoved(model) {
        const markerDecorations = this._markerDecorations.get(model.uri);
        if (markerDecorations) {
            markerDecorations.dispose();
            this._markerDecorations.delete(model.uri);
        }
        // clean up markers for internal, transient models
        if (model.uri.scheme === (0, _networkJs.Schemas).inMemory || model.uri.scheme === (0, _networkJs.Schemas).internal || model.uri.scheme === (0, _networkJs.Schemas).vscode) this._markerService?.read({
            resource: model.uri
        }).map((marker)=>marker.owner).forEach((owner)=>this._markerService.remove(owner, [
                model.uri
            ]));
    }
    _updateDecorations(markerDecorations) {
        // Limit to the first 500 errors/warnings
        const markers = this._markerService.read({
            resource: markerDecorations.model.uri,
            take: 500
        });
        if (markerDecorations.update(markers)) this._onDidChangeMarker.fire(markerDecorations.model);
    }
};
MarkerDecorationsService = __decorate([
    __param(0, (0, _modelJs1.IModelService)),
    __param(1, (0, _markersJs.IMarkerService))
], MarkerDecorationsService);
class MarkerDecorations extends (0, _lifecycleJs.Disposable) {
    constructor(model){
        super();
        this.model = model;
        this._map = new (0, _mapJs.BidirectionalMap)();
        this._register((0, _lifecycleJs.toDisposable)(()=>{
            this.model.deltaDecorations([
                ...this._map.values()
            ], []);
            this._map.clear();
        }));
    }
    update(markers) {
        // We use the fact that marker instances are not recreated when different owners
        // update. So we can compare references to find out what changed since the last update.
        const { added, removed } = (0, _collectionsJs.diffSets)(new Set(this._map.keys()), new Set(markers));
        if (added.length === 0 && removed.length === 0) return false;
        const oldIds = removed.map((marker)=>this._map.get(marker));
        const newDecorations = added.map((marker)=>{
            return {
                range: this._createDecorationRange(this.model, marker),
                options: this._createDecorationOption(marker)
            };
        });
        const ids = this.model.deltaDecorations(oldIds, newDecorations);
        for (const removedMarker of removed)this._map.delete(removedMarker);
        for(let index = 0; index < ids.length; index++)this._map.set(added[index], ids[index]);
        return true;
    }
    getMarker(decoration) {
        return this._map.getKey(decoration.id);
    }
    _createDecorationRange(model, rawMarker) {
        let ret = (0, _rangeJs.Range).lift(rawMarker);
        if (rawMarker.severity === (0, _markersJs.MarkerSeverity).Hint && !this._hasMarkerTag(rawMarker, 1 /* MarkerTag.Unnecessary */ ) && !this._hasMarkerTag(rawMarker, 2 /* MarkerTag.Deprecated */ )) // * never render hints on multiple lines
        // * make enough space for three dots
        ret = ret.setEndPosition(ret.startLineNumber, ret.startColumn + 2);
        ret = model.validateRange(ret);
        if (ret.isEmpty()) {
            const maxColumn = model.getLineLastNonWhitespaceColumn(ret.startLineNumber) || model.getLineMaxColumn(ret.startLineNumber);
            if (maxColumn === 1 || ret.endColumn >= maxColumn) // empty line or behind eol
            // keep the range as is, it will be rendered 1ch wide
            return ret;
            const word = model.getWordAtPosition(ret.getStartPosition());
            if (word) ret = new (0, _rangeJs.Range)(ret.startLineNumber, word.startColumn, ret.endLineNumber, word.endColumn);
        } else if (rawMarker.endColumn === Number.MAX_VALUE && rawMarker.startColumn === 1 && ret.startLineNumber === ret.endLineNumber) {
            const minColumn = model.getLineFirstNonWhitespaceColumn(rawMarker.startLineNumber);
            if (minColumn < ret.endColumn) {
                ret = new (0, _rangeJs.Range)(ret.startLineNumber, minColumn, ret.endLineNumber, ret.endColumn);
                rawMarker.startColumn = minColumn;
            }
        }
        return ret;
    }
    _createDecorationOption(marker) {
        let className;
        let color = undefined;
        let zIndex;
        let inlineClassName = undefined;
        let minimap;
        switch(marker.severity){
            case (0, _markersJs.MarkerSeverity).Hint:
                if (this._hasMarkerTag(marker, 2 /* MarkerTag.Deprecated */ )) className = undefined;
                else if (this._hasMarkerTag(marker, 1 /* MarkerTag.Unnecessary */ )) className = "squiggly-unnecessary" /* ClassName.EditorUnnecessaryDecoration */ ;
                else className = "squiggly-hint" /* ClassName.EditorHintDecoration */ ;
                zIndex = 0;
                break;
            case (0, _markersJs.MarkerSeverity).Info:
                className = "squiggly-info" /* ClassName.EditorInfoDecoration */ ;
                color = (0, _themeServiceJs.themeColorFromId)((0, _editorColorRegistryJs.overviewRulerInfo));
                zIndex = 10;
                minimap = {
                    color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.minimapInfo)),
                    position: 1 /* MinimapPosition.Inline */ 
                };
                break;
            case (0, _markersJs.MarkerSeverity).Warning:
                className = "squiggly-warning" /* ClassName.EditorWarningDecoration */ ;
                color = (0, _themeServiceJs.themeColorFromId)((0, _editorColorRegistryJs.overviewRulerWarning));
                zIndex = 20;
                minimap = {
                    color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.minimapWarning)),
                    position: 1 /* MinimapPosition.Inline */ 
                };
                break;
            case (0, _markersJs.MarkerSeverity).Error:
            default:
                className = "squiggly-error" /* ClassName.EditorErrorDecoration */ ;
                color = (0, _themeServiceJs.themeColorFromId)((0, _editorColorRegistryJs.overviewRulerError));
                zIndex = 30;
                minimap = {
                    color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.minimapError)),
                    position: 1 /* MinimapPosition.Inline */ 
                };
                break;
        }
        if (marker.tags) {
            if (marker.tags.indexOf(1 /* MarkerTag.Unnecessary */ ) !== -1) inlineClassName = "squiggly-inline-unnecessary" /* ClassName.EditorUnnecessaryInlineDecoration */ ;
            if (marker.tags.indexOf(2 /* MarkerTag.Deprecated */ ) !== -1) inlineClassName = "squiggly-inline-deprecated" /* ClassName.EditorDeprecatedInlineDecoration */ ;
        }
        return {
            description: "marker-decoration",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
            className,
            showIfCollapsed: true,
            overviewRuler: {
                color,
                position: (0, _modelJs.OverviewRulerLane).Right
            },
            minimap,
            zIndex,
            inlineClassName
        };
    }
    _hasMarkerTag(marker, tag) {
        if (marker.tags) return marker.tags.indexOf(tag) >= 0;
        return false;
    }
}

},{"../../../platform/markers/common/markers.js":"aaeXc","../../../base/common/lifecycle.js":"9kg8d","../model.js":"1CSIB","../../../platform/theme/common/themeService.js":"jMkIC","../core/editorColorRegistry.js":"5XqtL","./model.js":"aciVm","../core/range.js":"jmUPh","../../../base/common/network.js":"2c1AD","../../../base/common/event.js":"4Zi8b","../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../base/common/map.js":"leSjz","../../../base/common/collections.js":"6NI7k","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aaeXc":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkerSeverity", ()=>MarkerSeverity);
parcelHelpers.export(exports, "IMarkerData", ()=>IMarkerData);
parcelHelpers.export(exports, "IMarkerService", ()=>IMarkerService);
var _severityJs = require("../../../base/common/severity.js");
var _severityJsDefault = parcelHelpers.interopDefault(_severityJs);
var _nlsJs = require("../../../nls.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var MarkerSeverity;
(function(MarkerSeverity) {
    MarkerSeverity[MarkerSeverity["Hint"] = 1] = "Hint";
    MarkerSeverity[MarkerSeverity["Info"] = 2] = "Info";
    MarkerSeverity[MarkerSeverity["Warning"] = 4] = "Warning";
    MarkerSeverity[MarkerSeverity["Error"] = 8] = "Error";
})(MarkerSeverity || (MarkerSeverity = {}));
(function(MarkerSeverity) {
    function compare(a, b) {
        return b - a;
    }
    MarkerSeverity.compare = compare;
    const _displayStrings = Object.create(null);
    _displayStrings[MarkerSeverity.Error] = (0, _nlsJs.localize)("sev.error", "Error");
    _displayStrings[MarkerSeverity.Warning] = (0, _nlsJs.localize)("sev.warning", "Warning");
    _displayStrings[MarkerSeverity.Info] = (0, _nlsJs.localize)("sev.info", "Info");
    function toString(a) {
        return _displayStrings[a] || "";
    }
    MarkerSeverity.toString = toString;
    function fromSeverity(severity) {
        switch(severity){
            case (0, _severityJsDefault.default).Error:
                return MarkerSeverity.Error;
            case (0, _severityJsDefault.default).Warning:
                return MarkerSeverity.Warning;
            case (0, _severityJsDefault.default).Info:
                return MarkerSeverity.Info;
            case (0, _severityJsDefault.default).Ignore:
                return MarkerSeverity.Hint;
        }
    }
    MarkerSeverity.fromSeverity = fromSeverity;
    function toSeverity(severity) {
        switch(severity){
            case MarkerSeverity.Error:
                return (0, _severityJsDefault.default).Error;
            case MarkerSeverity.Warning:
                return (0, _severityJsDefault.default).Warning;
            case MarkerSeverity.Info:
                return (0, _severityJsDefault.default).Info;
            case MarkerSeverity.Hint:
                return (0, _severityJsDefault.default).Ignore;
        }
    }
    MarkerSeverity.toSeverity = toSeverity;
})(MarkerSeverity || (MarkerSeverity = {}));
var IMarkerData;
(function(IMarkerData) {
    const emptyString = "";
    function makeKey(markerData) {
        return makeKeyOptionalMessage(markerData, true);
    }
    IMarkerData.makeKey = makeKey;
    function makeKeyOptionalMessage(markerData, useMessage) {
        const result = [
            emptyString
        ];
        if (markerData.source) result.push(markerData.source.replace("\xa6", "\\\xa6"));
        else result.push(emptyString);
        if (markerData.code) {
            if (typeof markerData.code === "string") result.push(markerData.code.replace("\xa6", "\\\xa6"));
            else result.push(markerData.code.value.replace("\xa6", "\\\xa6"));
        } else result.push(emptyString);
        if (markerData.severity !== undefined && markerData.severity !== null) result.push(MarkerSeverity.toString(markerData.severity));
        else result.push(emptyString);
        // Modifed to not include the message as part of the marker key to work around
        // https://github.com/microsoft/vscode/issues/77475
        if (markerData.message && useMessage) result.push(markerData.message.replace("\xa6", "\\\xa6"));
        else result.push(emptyString);
        if (markerData.startLineNumber !== undefined && markerData.startLineNumber !== null) result.push(markerData.startLineNumber.toString());
        else result.push(emptyString);
        if (markerData.startColumn !== undefined && markerData.startColumn !== null) result.push(markerData.startColumn.toString());
        else result.push(emptyString);
        if (markerData.endLineNumber !== undefined && markerData.endLineNumber !== null) result.push(markerData.endLineNumber.toString());
        else result.push(emptyString);
        if (markerData.endColumn !== undefined && markerData.endColumn !== null) result.push(markerData.endColumn.toString());
        else result.push(emptyString);
        result.push(emptyString);
        return result.join("\xa6");
    }
    IMarkerData.makeKeyOptionalMessage = makeKeyOptionalMessage;
})(IMarkerData || (IMarkerData = {}));
const IMarkerService = (0, _instantiationJs.createDecorator)("markerService");

},{"../../../base/common/severity.js":"faBYp","../../../nls.js":"l617d","../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5XqtL":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "editorLineHighlight", ()=>editorLineHighlight);
parcelHelpers.export(exports, "editorLineHighlightBorder", ()=>editorLineHighlightBorder);
parcelHelpers.export(exports, "editorRangeHighlight", ()=>editorRangeHighlight);
parcelHelpers.export(exports, "editorRangeHighlightBorder", ()=>editorRangeHighlightBorder);
parcelHelpers.export(exports, "editorSymbolHighlight", ()=>editorSymbolHighlight);
parcelHelpers.export(exports, "editorSymbolHighlightBorder", ()=>editorSymbolHighlightBorder);
parcelHelpers.export(exports, "editorCursorForeground", ()=>editorCursorForeground);
parcelHelpers.export(exports, "editorCursorBackground", ()=>editorCursorBackground);
parcelHelpers.export(exports, "editorMultiCursorPrimaryForeground", ()=>editorMultiCursorPrimaryForeground);
parcelHelpers.export(exports, "editorMultiCursorPrimaryBackground", ()=>editorMultiCursorPrimaryBackground);
parcelHelpers.export(exports, "editorMultiCursorSecondaryForeground", ()=>editorMultiCursorSecondaryForeground);
parcelHelpers.export(exports, "editorMultiCursorSecondaryBackground", ()=>editorMultiCursorSecondaryBackground);
parcelHelpers.export(exports, "editorWhitespaces", ()=>editorWhitespaces);
parcelHelpers.export(exports, "editorLineNumbers", ()=>editorLineNumbers);
parcelHelpers.export(exports, "deprecatedEditorIndentGuides", ()=>deprecatedEditorIndentGuides);
parcelHelpers.export(exports, "deprecatedEditorActiveIndentGuides", ()=>deprecatedEditorActiveIndentGuides);
parcelHelpers.export(exports, "editorIndentGuide1", ()=>editorIndentGuide1);
parcelHelpers.export(exports, "editorIndentGuide2", ()=>editorIndentGuide2);
parcelHelpers.export(exports, "editorIndentGuide3", ()=>editorIndentGuide3);
parcelHelpers.export(exports, "editorIndentGuide4", ()=>editorIndentGuide4);
parcelHelpers.export(exports, "editorIndentGuide5", ()=>editorIndentGuide5);
parcelHelpers.export(exports, "editorIndentGuide6", ()=>editorIndentGuide6);
parcelHelpers.export(exports, "editorActiveIndentGuide1", ()=>editorActiveIndentGuide1);
parcelHelpers.export(exports, "editorActiveIndentGuide2", ()=>editorActiveIndentGuide2);
parcelHelpers.export(exports, "editorActiveIndentGuide3", ()=>editorActiveIndentGuide3);
parcelHelpers.export(exports, "editorActiveIndentGuide4", ()=>editorActiveIndentGuide4);
parcelHelpers.export(exports, "editorActiveIndentGuide5", ()=>editorActiveIndentGuide5);
parcelHelpers.export(exports, "editorActiveIndentGuide6", ()=>editorActiveIndentGuide6);
parcelHelpers.export(exports, "editorActiveLineNumber", ()=>editorActiveLineNumber);
parcelHelpers.export(exports, "editorDimmedLineNumber", ()=>editorDimmedLineNumber);
parcelHelpers.export(exports, "editorRuler", ()=>editorRuler);
parcelHelpers.export(exports, "editorCodeLensForeground", ()=>editorCodeLensForeground);
parcelHelpers.export(exports, "editorBracketMatchBackground", ()=>editorBracketMatchBackground);
parcelHelpers.export(exports, "editorBracketMatchBorder", ()=>editorBracketMatchBorder);
parcelHelpers.export(exports, "editorOverviewRulerBorder", ()=>editorOverviewRulerBorder);
parcelHelpers.export(exports, "editorOverviewRulerBackground", ()=>editorOverviewRulerBackground);
parcelHelpers.export(exports, "editorGutter", ()=>editorGutter);
parcelHelpers.export(exports, "editorUnnecessaryCodeBorder", ()=>editorUnnecessaryCodeBorder);
parcelHelpers.export(exports, "editorUnnecessaryCodeOpacity", ()=>editorUnnecessaryCodeOpacity);
parcelHelpers.export(exports, "ghostTextBorder", ()=>ghostTextBorder);
parcelHelpers.export(exports, "ghostTextForeground", ()=>ghostTextForeground);
parcelHelpers.export(exports, "ghostTextBackground", ()=>ghostTextBackground);
parcelHelpers.export(exports, "overviewRulerRangeHighlight", ()=>overviewRulerRangeHighlight);
parcelHelpers.export(exports, "overviewRulerError", ()=>overviewRulerError);
parcelHelpers.export(exports, "overviewRulerWarning", ()=>overviewRulerWarning);
parcelHelpers.export(exports, "overviewRulerInfo", ()=>overviewRulerInfo);
parcelHelpers.export(exports, "editorBracketHighlightingForeground1", ()=>editorBracketHighlightingForeground1);
parcelHelpers.export(exports, "editorBracketHighlightingForeground2", ()=>editorBracketHighlightingForeground2);
parcelHelpers.export(exports, "editorBracketHighlightingForeground3", ()=>editorBracketHighlightingForeground3);
parcelHelpers.export(exports, "editorBracketHighlightingForeground4", ()=>editorBracketHighlightingForeground4);
parcelHelpers.export(exports, "editorBracketHighlightingForeground5", ()=>editorBracketHighlightingForeground5);
parcelHelpers.export(exports, "editorBracketHighlightingForeground6", ()=>editorBracketHighlightingForeground6);
parcelHelpers.export(exports, "editorBracketHighlightingUnexpectedBracketForeground", ()=>editorBracketHighlightingUnexpectedBracketForeground);
parcelHelpers.export(exports, "editorBracketPairGuideBackground1", ()=>editorBracketPairGuideBackground1);
parcelHelpers.export(exports, "editorBracketPairGuideBackground2", ()=>editorBracketPairGuideBackground2);
parcelHelpers.export(exports, "editorBracketPairGuideBackground3", ()=>editorBracketPairGuideBackground3);
parcelHelpers.export(exports, "editorBracketPairGuideBackground4", ()=>editorBracketPairGuideBackground4);
parcelHelpers.export(exports, "editorBracketPairGuideBackground5", ()=>editorBracketPairGuideBackground5);
parcelHelpers.export(exports, "editorBracketPairGuideBackground6", ()=>editorBracketPairGuideBackground6);
parcelHelpers.export(exports, "editorBracketPairGuideActiveBackground1", ()=>editorBracketPairGuideActiveBackground1);
parcelHelpers.export(exports, "editorBracketPairGuideActiveBackground2", ()=>editorBracketPairGuideActiveBackground2);
parcelHelpers.export(exports, "editorBracketPairGuideActiveBackground3", ()=>editorBracketPairGuideActiveBackground3);
parcelHelpers.export(exports, "editorBracketPairGuideActiveBackground4", ()=>editorBracketPairGuideActiveBackground4);
parcelHelpers.export(exports, "editorBracketPairGuideActiveBackground5", ()=>editorBracketPairGuideActiveBackground5);
parcelHelpers.export(exports, "editorBracketPairGuideActiveBackground6", ()=>editorBracketPairGuideActiveBackground6);
parcelHelpers.export(exports, "editorUnicodeHighlightBorder", ()=>editorUnicodeHighlightBorder);
parcelHelpers.export(exports, "editorUnicodeHighlightBackground", ()=>editorUnicodeHighlightBackground);
var _nlsJs = require("../../../nls.js");
var _colorJs = require("../../../base/common/color.js");
var _colorRegistryJs = require("../../../platform/theme/common/colorRegistry.js");
var _themeServiceJs = require("../../../platform/theme/common/themeService.js");
const editorLineHighlight = (0, _colorRegistryJs.registerColor)("editor.lineHighlightBackground", null, _nlsJs.localize("lineHighlight", "Background color for the highlight of line at the cursor position."));
const editorLineHighlightBorder = (0, _colorRegistryJs.registerColor)("editor.lineHighlightBorder", {
    dark: "#282828",
    light: "#eeeeee",
    hcDark: "#f38518",
    hcLight: (0, _colorRegistryJs.contrastBorder)
}, _nlsJs.localize("lineHighlightBorderBox", "Background color for the border around the line at the cursor position."));
const editorRangeHighlight = (0, _colorRegistryJs.registerColor)("editor.rangeHighlightBackground", {
    dark: "#ffffff0b",
    light: "#fdff0033",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("rangeHighlight", "Background color of highlighted ranges, like by quick open and find features. The color must not be opaque so as not to hide underlying decorations."), true);
const editorRangeHighlightBorder = (0, _colorRegistryJs.registerColor)("editor.rangeHighlightBorder", {
    dark: null,
    light: null,
    hcDark: (0, _colorRegistryJs.activeContrastBorder),
    hcLight: (0, _colorRegistryJs.activeContrastBorder)
}, _nlsJs.localize("rangeHighlightBorder", "Background color of the border around highlighted ranges."));
const editorSymbolHighlight = (0, _colorRegistryJs.registerColor)("editor.symbolHighlightBackground", {
    dark: (0, _colorRegistryJs.editorFindMatchHighlight),
    light: (0, _colorRegistryJs.editorFindMatchHighlight),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("symbolHighlight", "Background color of highlighted symbol, like for go to definition or go next/previous symbol. The color must not be opaque so as not to hide underlying decorations."), true);
const editorSymbolHighlightBorder = (0, _colorRegistryJs.registerColor)("editor.symbolHighlightBorder", {
    dark: null,
    light: null,
    hcDark: (0, _colorRegistryJs.activeContrastBorder),
    hcLight: (0, _colorRegistryJs.activeContrastBorder)
}, _nlsJs.localize("symbolHighlightBorder", "Background color of the border around highlighted symbols."));
const editorCursorForeground = (0, _colorRegistryJs.registerColor)("editorCursor.foreground", {
    dark: "#AEAFAD",
    light: (0, _colorJs.Color).black,
    hcDark: (0, _colorJs.Color).white,
    hcLight: "#0F4A85"
}, _nlsJs.localize("caret", "Color of the editor cursor."));
const editorCursorBackground = (0, _colorRegistryJs.registerColor)("editorCursor.background", null, _nlsJs.localize("editorCursorBackground", "The background color of the editor cursor. Allows customizing the color of a character overlapped by a block cursor."));
const editorMultiCursorPrimaryForeground = (0, _colorRegistryJs.registerColor)("editorMultiCursor.primary.foreground", editorCursorForeground, _nlsJs.localize("editorMultiCursorPrimaryForeground", "Color of the primary editor cursor when multiple cursors are present."));
const editorMultiCursorPrimaryBackground = (0, _colorRegistryJs.registerColor)("editorMultiCursor.primary.background", editorCursorBackground, _nlsJs.localize("editorMultiCursorPrimaryBackground", "The background color of the primary editor cursor when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor."));
const editorMultiCursorSecondaryForeground = (0, _colorRegistryJs.registerColor)("editorMultiCursor.secondary.foreground", editorCursorForeground, _nlsJs.localize("editorMultiCursorSecondaryForeground", "Color of secondary editor cursors when multiple cursors are present."));
const editorMultiCursorSecondaryBackground = (0, _colorRegistryJs.registerColor)("editorMultiCursor.secondary.background", editorCursorBackground, _nlsJs.localize("editorMultiCursorSecondaryBackground", "The background color of secondary editor cursors when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor."));
const editorWhitespaces = (0, _colorRegistryJs.registerColor)("editorWhitespace.foreground", {
    dark: "#e3e4e229",
    light: "#33333333",
    hcDark: "#e3e4e229",
    hcLight: "#CCCCCC"
}, _nlsJs.localize("editorWhitespaces", "Color of whitespace characters in the editor."));
const editorLineNumbers = (0, _colorRegistryJs.registerColor)("editorLineNumber.foreground", {
    dark: "#858585",
    light: "#237893",
    hcDark: (0, _colorJs.Color).white,
    hcLight: "#292929"
}, _nlsJs.localize("editorLineNumbers", "Color of editor line numbers."));
const deprecatedEditorIndentGuides = (0, _colorRegistryJs.registerColor)("editorIndentGuide.background", editorWhitespaces, _nlsJs.localize("editorIndentGuides", "Color of the editor indentation guides."), false, _nlsJs.localize("deprecatedEditorIndentGuides", "'editorIndentGuide.background' is deprecated. Use 'editorIndentGuide.background1' instead."));
const deprecatedEditorActiveIndentGuides = (0, _colorRegistryJs.registerColor)("editorIndentGuide.activeBackground", editorWhitespaces, _nlsJs.localize("editorActiveIndentGuide", "Color of the active editor indentation guides."), false, _nlsJs.localize("deprecatedEditorActiveIndentGuide", "'editorIndentGuide.activeBackground' is deprecated. Use 'editorIndentGuide.activeBackground1' instead."));
const editorIndentGuide1 = (0, _colorRegistryJs.registerColor)("editorIndentGuide.background1", deprecatedEditorIndentGuides, _nlsJs.localize("editorIndentGuides1", "Color of the editor indentation guides (1)."));
const editorIndentGuide2 = (0, _colorRegistryJs.registerColor)("editorIndentGuide.background2", "#00000000", _nlsJs.localize("editorIndentGuides2", "Color of the editor indentation guides (2)."));
const editorIndentGuide3 = (0, _colorRegistryJs.registerColor)("editorIndentGuide.background3", "#00000000", _nlsJs.localize("editorIndentGuides3", "Color of the editor indentation guides (3)."));
const editorIndentGuide4 = (0, _colorRegistryJs.registerColor)("editorIndentGuide.background4", "#00000000", _nlsJs.localize("editorIndentGuides4", "Color of the editor indentation guides (4)."));
const editorIndentGuide5 = (0, _colorRegistryJs.registerColor)("editorIndentGuide.background5", "#00000000", _nlsJs.localize("editorIndentGuides5", "Color of the editor indentation guides (5)."));
const editorIndentGuide6 = (0, _colorRegistryJs.registerColor)("editorIndentGuide.background6", "#00000000", _nlsJs.localize("editorIndentGuides6", "Color of the editor indentation guides (6)."));
const editorActiveIndentGuide1 = (0, _colorRegistryJs.registerColor)("editorIndentGuide.activeBackground1", deprecatedEditorActiveIndentGuides, _nlsJs.localize("editorActiveIndentGuide1", "Color of the active editor indentation guides (1)."));
const editorActiveIndentGuide2 = (0, _colorRegistryJs.registerColor)("editorIndentGuide.activeBackground2", "#00000000", _nlsJs.localize("editorActiveIndentGuide2", "Color of the active editor indentation guides (2)."));
const editorActiveIndentGuide3 = (0, _colorRegistryJs.registerColor)("editorIndentGuide.activeBackground3", "#00000000", _nlsJs.localize("editorActiveIndentGuide3", "Color of the active editor indentation guides (3)."));
const editorActiveIndentGuide4 = (0, _colorRegistryJs.registerColor)("editorIndentGuide.activeBackground4", "#00000000", _nlsJs.localize("editorActiveIndentGuide4", "Color of the active editor indentation guides (4)."));
const editorActiveIndentGuide5 = (0, _colorRegistryJs.registerColor)("editorIndentGuide.activeBackground5", "#00000000", _nlsJs.localize("editorActiveIndentGuide5", "Color of the active editor indentation guides (5)."));
const editorActiveIndentGuide6 = (0, _colorRegistryJs.registerColor)("editorIndentGuide.activeBackground6", "#00000000", _nlsJs.localize("editorActiveIndentGuide6", "Color of the active editor indentation guides (6)."));
const deprecatedEditorActiveLineNumber = (0, _colorRegistryJs.registerColor)("editorActiveLineNumber.foreground", {
    dark: "#c6c6c6",
    light: "#0B216F",
    hcDark: (0, _colorRegistryJs.activeContrastBorder),
    hcLight: (0, _colorRegistryJs.activeContrastBorder)
}, _nlsJs.localize("editorActiveLineNumber", "Color of editor active line number"), false, _nlsJs.localize("deprecatedEditorActiveLineNumber", "Id is deprecated. Use 'editorLineNumber.activeForeground' instead."));
const editorActiveLineNumber = (0, _colorRegistryJs.registerColor)("editorLineNumber.activeForeground", deprecatedEditorActiveLineNumber, _nlsJs.localize("editorActiveLineNumber", "Color of editor active line number"));
const editorDimmedLineNumber = (0, _colorRegistryJs.registerColor)("editorLineNumber.dimmedForeground", null, _nlsJs.localize("editorDimmedLineNumber", "Color of the final editor line when editor.renderFinalNewline is set to dimmed."));
const editorRuler = (0, _colorRegistryJs.registerColor)("editorRuler.foreground", {
    dark: "#5A5A5A",
    light: (0, _colorJs.Color).lightgrey,
    hcDark: (0, _colorJs.Color).white,
    hcLight: "#292929"
}, _nlsJs.localize("editorRuler", "Color of the editor rulers."));
const editorCodeLensForeground = (0, _colorRegistryJs.registerColor)("editorCodeLens.foreground", {
    dark: "#999999",
    light: "#919191",
    hcDark: "#999999",
    hcLight: "#292929"
}, _nlsJs.localize("editorCodeLensForeground", "Foreground color of editor CodeLens"));
const editorBracketMatchBackground = (0, _colorRegistryJs.registerColor)("editorBracketMatch.background", {
    dark: "#0064001a",
    light: "#0064001a",
    hcDark: "#0064001a",
    hcLight: "#0000"
}, _nlsJs.localize("editorBracketMatchBackground", "Background color behind matching brackets"));
const editorBracketMatchBorder = (0, _colorRegistryJs.registerColor)("editorBracketMatch.border", {
    dark: "#888",
    light: "#B9B9B9",
    hcDark: (0, _colorRegistryJs.contrastBorder),
    hcLight: (0, _colorRegistryJs.contrastBorder)
}, _nlsJs.localize("editorBracketMatchBorder", "Color for matching brackets boxes"));
const editorOverviewRulerBorder = (0, _colorRegistryJs.registerColor)("editorOverviewRuler.border", {
    dark: "#7f7f7f4d",
    light: "#7f7f7f4d",
    hcDark: "#7f7f7f4d",
    hcLight: "#666666"
}, _nlsJs.localize("editorOverviewRulerBorder", "Color of the overview ruler border."));
const editorOverviewRulerBackground = (0, _colorRegistryJs.registerColor)("editorOverviewRuler.background", null, _nlsJs.localize("editorOverviewRulerBackground", "Background color of the editor overview ruler."));
const editorGutter = (0, _colorRegistryJs.registerColor)("editorGutter.background", (0, _colorRegistryJs.editorBackground), _nlsJs.localize("editorGutter", "Background color of the editor gutter. The gutter contains the glyph margins and the line numbers."));
const editorUnnecessaryCodeBorder = (0, _colorRegistryJs.registerColor)("editorUnnecessaryCode.border", {
    dark: null,
    light: null,
    hcDark: (0, _colorJs.Color).fromHex("#fff").transparent(0.8),
    hcLight: (0, _colorRegistryJs.contrastBorder)
}, _nlsJs.localize("unnecessaryCodeBorder", "Border color of unnecessary (unused) source code in the editor."));
const editorUnnecessaryCodeOpacity = (0, _colorRegistryJs.registerColor)("editorUnnecessaryCode.opacity", {
    dark: (0, _colorJs.Color).fromHex("#000a"),
    light: (0, _colorJs.Color).fromHex("#0007"),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("unnecessaryCodeOpacity", "Opacity of unnecessary (unused) source code in the editor. For example, \"#000000c0\" will render the code with 75% opacity. For high contrast themes, use the  'editorUnnecessaryCode.border' theme color to underline unnecessary code instead of fading it out."));
const ghostTextBorder = (0, _colorRegistryJs.registerColor)("editorGhostText.border", {
    dark: null,
    light: null,
    hcDark: (0, _colorJs.Color).fromHex("#fff").transparent(0.8),
    hcLight: (0, _colorJs.Color).fromHex("#292929").transparent(0.8)
}, _nlsJs.localize("editorGhostTextBorder", "Border color of ghost text in the editor."));
const ghostTextForeground = (0, _colorRegistryJs.registerColor)("editorGhostText.foreground", {
    dark: (0, _colorJs.Color).fromHex("#ffffff56"),
    light: (0, _colorJs.Color).fromHex("#0007"),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("editorGhostTextForeground", "Foreground color of the ghost text in the editor."));
const ghostTextBackground = (0, _colorRegistryJs.registerColor)("editorGhostText.background", null, _nlsJs.localize("editorGhostTextBackground", "Background color of the ghost text in the editor."));
const rulerRangeDefault = new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(0, 122, 204, 0.6));
const overviewRulerRangeHighlight = (0, _colorRegistryJs.registerColor)("editorOverviewRuler.rangeHighlightForeground", rulerRangeDefault, _nlsJs.localize("overviewRulerRangeHighlight", "Overview ruler marker color for range highlights. The color must not be opaque so as not to hide underlying decorations."), true);
const overviewRulerError = (0, _colorRegistryJs.registerColor)("editorOverviewRuler.errorForeground", {
    dark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(255, 18, 18, 0.7)),
    light: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(255, 18, 18, 0.7)),
    hcDark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(255, 50, 50, 1)),
    hcLight: "#B5200D"
}, _nlsJs.localize("overviewRuleError", "Overview ruler marker color for errors."));
const overviewRulerWarning = (0, _colorRegistryJs.registerColor)("editorOverviewRuler.warningForeground", {
    dark: (0, _colorRegistryJs.editorWarningForeground),
    light: (0, _colorRegistryJs.editorWarningForeground),
    hcDark: (0, _colorRegistryJs.editorWarningBorder),
    hcLight: (0, _colorRegistryJs.editorWarningBorder)
}, _nlsJs.localize("overviewRuleWarning", "Overview ruler marker color for warnings."));
const overviewRulerInfo = (0, _colorRegistryJs.registerColor)("editorOverviewRuler.infoForeground", {
    dark: (0, _colorRegistryJs.editorInfoForeground),
    light: (0, _colorRegistryJs.editorInfoForeground),
    hcDark: (0, _colorRegistryJs.editorInfoBorder),
    hcLight: (0, _colorRegistryJs.editorInfoBorder)
}, _nlsJs.localize("overviewRuleInfo", "Overview ruler marker color for infos."));
const editorBracketHighlightingForeground1 = (0, _colorRegistryJs.registerColor)("editorBracketHighlight.foreground1", {
    dark: "#FFD700",
    light: "#0431FAFF",
    hcDark: "#FFD700",
    hcLight: "#0431FAFF"
}, _nlsJs.localize("editorBracketHighlightForeground1", "Foreground color of brackets (1). Requires enabling bracket pair colorization."));
const editorBracketHighlightingForeground2 = (0, _colorRegistryJs.registerColor)("editorBracketHighlight.foreground2", {
    dark: "#DA70D6",
    light: "#319331FF",
    hcDark: "#DA70D6",
    hcLight: "#319331FF"
}, _nlsJs.localize("editorBracketHighlightForeground2", "Foreground color of brackets (2). Requires enabling bracket pair colorization."));
const editorBracketHighlightingForeground3 = (0, _colorRegistryJs.registerColor)("editorBracketHighlight.foreground3", {
    dark: "#179FFF",
    light: "#7B3814FF",
    hcDark: "#87CEFA",
    hcLight: "#7B3814FF"
}, _nlsJs.localize("editorBracketHighlightForeground3", "Foreground color of brackets (3). Requires enabling bracket pair colorization."));
const editorBracketHighlightingForeground4 = (0, _colorRegistryJs.registerColor)("editorBracketHighlight.foreground4", "#00000000", _nlsJs.localize("editorBracketHighlightForeground4", "Foreground color of brackets (4). Requires enabling bracket pair colorization."));
const editorBracketHighlightingForeground5 = (0, _colorRegistryJs.registerColor)("editorBracketHighlight.foreground5", "#00000000", _nlsJs.localize("editorBracketHighlightForeground5", "Foreground color of brackets (5). Requires enabling bracket pair colorization."));
const editorBracketHighlightingForeground6 = (0, _colorRegistryJs.registerColor)("editorBracketHighlight.foreground6", "#00000000", _nlsJs.localize("editorBracketHighlightForeground6", "Foreground color of brackets (6). Requires enabling bracket pair colorization."));
const editorBracketHighlightingUnexpectedBracketForeground = (0, _colorRegistryJs.registerColor)("editorBracketHighlight.unexpectedBracket.foreground", {
    dark: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(255, 18, 18, 0.8)),
    light: new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(255, 18, 18, 0.8)),
    hcDark: "new Color(new RGBA(255, 50, 50, 1))",
    hcLight: "#B5200D"
}, _nlsJs.localize("editorBracketHighlightUnexpectedBracketForeground", "Foreground color of unexpected brackets."));
const editorBracketPairGuideBackground1 = (0, _colorRegistryJs.registerColor)("editorBracketPairGuide.background1", "#00000000", _nlsJs.localize("editorBracketPairGuide.background1", "Background color of inactive bracket pair guides (1). Requires enabling bracket pair guides."));
const editorBracketPairGuideBackground2 = (0, _colorRegistryJs.registerColor)("editorBracketPairGuide.background2", "#00000000", _nlsJs.localize("editorBracketPairGuide.background2", "Background color of inactive bracket pair guides (2). Requires enabling bracket pair guides."));
const editorBracketPairGuideBackground3 = (0, _colorRegistryJs.registerColor)("editorBracketPairGuide.background3", "#00000000", _nlsJs.localize("editorBracketPairGuide.background3", "Background color of inactive bracket pair guides (3). Requires enabling bracket pair guides."));
const editorBracketPairGuideBackground4 = (0, _colorRegistryJs.registerColor)("editorBracketPairGuide.background4", "#00000000", _nlsJs.localize("editorBracketPairGuide.background4", "Background color of inactive bracket pair guides (4). Requires enabling bracket pair guides."));
const editorBracketPairGuideBackground5 = (0, _colorRegistryJs.registerColor)("editorBracketPairGuide.background5", "#00000000", _nlsJs.localize("editorBracketPairGuide.background5", "Background color of inactive bracket pair guides (5). Requires enabling bracket pair guides."));
const editorBracketPairGuideBackground6 = (0, _colorRegistryJs.registerColor)("editorBracketPairGuide.background6", "#00000000", _nlsJs.localize("editorBracketPairGuide.background6", "Background color of inactive bracket pair guides (6). Requires enabling bracket pair guides."));
const editorBracketPairGuideActiveBackground1 = (0, _colorRegistryJs.registerColor)("editorBracketPairGuide.activeBackground1", "#00000000", _nlsJs.localize("editorBracketPairGuide.activeBackground1", "Background color of active bracket pair guides (1). Requires enabling bracket pair guides."));
const editorBracketPairGuideActiveBackground2 = (0, _colorRegistryJs.registerColor)("editorBracketPairGuide.activeBackground2", "#00000000", _nlsJs.localize("editorBracketPairGuide.activeBackground2", "Background color of active bracket pair guides (2). Requires enabling bracket pair guides."));
const editorBracketPairGuideActiveBackground3 = (0, _colorRegistryJs.registerColor)("editorBracketPairGuide.activeBackground3", "#00000000", _nlsJs.localize("editorBracketPairGuide.activeBackground3", "Background color of active bracket pair guides (3). Requires enabling bracket pair guides."));
const editorBracketPairGuideActiveBackground4 = (0, _colorRegistryJs.registerColor)("editorBracketPairGuide.activeBackground4", "#00000000", _nlsJs.localize("editorBracketPairGuide.activeBackground4", "Background color of active bracket pair guides (4). Requires enabling bracket pair guides."));
const editorBracketPairGuideActiveBackground5 = (0, _colorRegistryJs.registerColor)("editorBracketPairGuide.activeBackground5", "#00000000", _nlsJs.localize("editorBracketPairGuide.activeBackground5", "Background color of active bracket pair guides (5). Requires enabling bracket pair guides."));
const editorBracketPairGuideActiveBackground6 = (0, _colorRegistryJs.registerColor)("editorBracketPairGuide.activeBackground6", "#00000000", _nlsJs.localize("editorBracketPairGuide.activeBackground6", "Background color of active bracket pair guides (6). Requires enabling bracket pair guides."));
const editorUnicodeHighlightBorder = (0, _colorRegistryJs.registerColor)("editorUnicodeHighlight.border", (0, _colorRegistryJs.editorWarningForeground), _nlsJs.localize("editorUnicodeHighlight.border", "Border color used to highlight unicode characters."));
const editorUnicodeHighlightBackground = (0, _colorRegistryJs.registerColor)("editorUnicodeHighlight.background", (0, _colorRegistryJs.editorWarningBackground), _nlsJs.localize("editorUnicodeHighlight.background", "Background color used to highlight unicode characters."));
// contains all color rules that used to defined in editor/browser/widget/editor.css
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const background = theme.getColor((0, _colorRegistryJs.editorBackground));
    const lineHighlight = theme.getColor(editorLineHighlight);
    const imeBackground = lineHighlight && !lineHighlight.isTransparent() ? lineHighlight : background;
    if (imeBackground) collector.addRule(`.monaco-editor .inputarea.ime-input { background-color: ${imeBackground}; }`);
});

},{"../../../nls.js":"l617d","../../../base/common/color.js":"at4gb","../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6NI7k":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "diffSets", ()=>diffSets);
/**
 * Computes the intersection of two sets.
 *
 * @param setA - The first set.
 * @param setB - The second iterable.
 * @returns A new set containing the elements that are in both `setA` and `setB`.
 */ parcelHelpers.export(exports, "intersection", ()=>intersection);
function diffSets(before, after) {
    const removed = [];
    const added = [];
    for (const element of before)if (!after.has(element)) removed.push(element);
    for (const element of after)if (!before.has(element)) added.push(element);
    return {
        removed,
        added
    };
}
function intersection(setA, setB) {
    const result = new Set();
    for (const elem of setB)if (setA.has(elem)) result.add(elem);
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jDz73":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IMarkerDecorationsService", ()=>IMarkerDecorationsService);
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
const IMarkerDecorationsService = (0, _instantiationJs.createDecorator)("markerDecorationsService");

},{"../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"grnor":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelService", ()=>ModelService);
parcelHelpers.export(exports, "DefaultModelSHA1Computer", ()=>DefaultModelSHA1Computer);
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _platformJs = require("../../../base/common/platform.js");
var _textModelJs = require("../model/textModel.js");
var _textModelDefaultsJs = require("../core/textModelDefaults.js");
var _modesRegistryJs = require("../languages/modesRegistry.js");
var _textResourceConfigurationJs = require("./textResourceConfiguration.js");
var _configurationJs = require("../../../platform/configuration/common/configuration.js");
var _undoRedoJs = require("../../../platform/undoRedo/common/undoRedo.js");
var _hashJs = require("../../../base/common/hash.js");
var _editStackJs = require("../model/editStack.js");
var _networkJs = require("../../../base/common/network.js");
var _objectsJs = require("../../../base/common/objects.js");
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var ModelService_1;
function MODEL_ID(resource) {
    return resource.toString();
}
class ModelData {
    constructor(model, onWillDispose, onDidChangeLanguage){
        this.model = model;
        this._modelEventListeners = new (0, _lifecycleJs.DisposableStore)();
        this.model = model;
        this._modelEventListeners.add(model.onWillDispose(()=>onWillDispose(model)));
        this._modelEventListeners.add(model.onDidChangeLanguage((e)=>onDidChangeLanguage(model, e)));
    }
    dispose() {
        this._modelEventListeners.dispose();
    }
}
const DEFAULT_EOL = _platformJs.isLinux || _platformJs.isMacintosh ? 1 /* DefaultEndOfLine.LF */  : 2 /* DefaultEndOfLine.CRLF */ ;
class DisposedModelInfo {
    constructor(uri, initialUndoRedoSnapshot, time, sharesUndoRedoStack, heapSize, sha1, versionId, alternativeVersionId){
        this.uri = uri;
        this.initialUndoRedoSnapshot = initialUndoRedoSnapshot;
        this.time = time;
        this.sharesUndoRedoStack = sharesUndoRedoStack;
        this.heapSize = heapSize;
        this.sha1 = sha1;
        this.versionId = versionId;
        this.alternativeVersionId = alternativeVersionId;
    }
}
let ModelService = class ModelService extends (0, _lifecycleJs.Disposable) {
    static{
        ModelService_1 = this;
    }
    static{
        this.MAX_MEMORY_FOR_CLOSED_FILES_UNDO_STACK = 20971520;
    }
    constructor(_configurationService, _resourcePropertiesService, _undoRedoService, _instantiationService){
        super();
        this._configurationService = _configurationService;
        this._resourcePropertiesService = _resourcePropertiesService;
        this._undoRedoService = _undoRedoService;
        this._instantiationService = _instantiationService;
        this._onModelAdded = this._register(new (0, _eventJs.Emitter)());
        this.onModelAdded = this._onModelAdded.event;
        this._onModelRemoved = this._register(new (0, _eventJs.Emitter)());
        this.onModelRemoved = this._onModelRemoved.event;
        this._onModelModeChanged = this._register(new (0, _eventJs.Emitter)());
        this.onModelLanguageChanged = this._onModelModeChanged.event;
        this._modelCreationOptionsByLanguageAndResource = Object.create(null);
        this._models = {};
        this._disposedModels = new Map();
        this._disposedModelsHeapSize = 0;
        this._register(this._configurationService.onDidChangeConfiguration((e)=>this._updateModelOptions(e)));
        this._updateModelOptions(undefined);
    }
    static _readModelOptions(config, isForSimpleWidget) {
        let tabSize = (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).tabSize;
        if (config.editor && typeof config.editor.tabSize !== "undefined") {
            const parsedTabSize = parseInt(config.editor.tabSize, 10);
            if (!isNaN(parsedTabSize)) tabSize = parsedTabSize;
            if (tabSize < 1) tabSize = 1;
        }
        let indentSize = "tabSize";
        if (config.editor && typeof config.editor.indentSize !== "undefined" && config.editor.indentSize !== "tabSize") {
            const parsedIndentSize = parseInt(config.editor.indentSize, 10);
            if (!isNaN(parsedIndentSize)) indentSize = Math.max(parsedIndentSize, 1);
        }
        let insertSpaces = (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).insertSpaces;
        if (config.editor && typeof config.editor.insertSpaces !== "undefined") insertSpaces = config.editor.insertSpaces === "false" ? false : Boolean(config.editor.insertSpaces);
        let newDefaultEOL = DEFAULT_EOL;
        const eol = config.eol;
        if (eol === "\r\n") newDefaultEOL = 2 /* DefaultEndOfLine.CRLF */ ;
        else if (eol === "\n") newDefaultEOL = 1 /* DefaultEndOfLine.LF */ ;
        let trimAutoWhitespace = (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).trimAutoWhitespace;
        if (config.editor && typeof config.editor.trimAutoWhitespace !== "undefined") trimAutoWhitespace = config.editor.trimAutoWhitespace === "false" ? false : Boolean(config.editor.trimAutoWhitespace);
        let detectIndentation = (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).detectIndentation;
        if (config.editor && typeof config.editor.detectIndentation !== "undefined") detectIndentation = config.editor.detectIndentation === "false" ? false : Boolean(config.editor.detectIndentation);
        let largeFileOptimizations = (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).largeFileOptimizations;
        if (config.editor && typeof config.editor.largeFileOptimizations !== "undefined") largeFileOptimizations = config.editor.largeFileOptimizations === "false" ? false : Boolean(config.editor.largeFileOptimizations);
        let bracketPairColorizationOptions = (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).bracketPairColorizationOptions;
        if (config.editor?.bracketPairColorization && typeof config.editor.bracketPairColorization === "object") bracketPairColorizationOptions = {
            enabled: !!config.editor.bracketPairColorization.enabled,
            independentColorPoolPerBracketType: !!config.editor.bracketPairColorization.independentColorPoolPerBracketType
        };
        return {
            isForSimpleWidget: isForSimpleWidget,
            tabSize: tabSize,
            indentSize: indentSize,
            insertSpaces: insertSpaces,
            detectIndentation: detectIndentation,
            defaultEOL: newDefaultEOL,
            trimAutoWhitespace: trimAutoWhitespace,
            largeFileOptimizations: largeFileOptimizations,
            bracketPairColorizationOptions
        };
    }
    _getEOL(resource, language) {
        if (resource) return this._resourcePropertiesService.getEOL(resource, language);
        const eol = this._configurationService.getValue("files.eol", {
            overrideIdentifier: language
        });
        if (eol && typeof eol === "string" && eol !== "auto") return eol;
        return _platformJs.OS === 3 /* platform.OperatingSystem.Linux */  || _platformJs.OS === 2 /* platform.OperatingSystem.Macintosh */  ? "\n" : "\r\n";
    }
    _shouldRestoreUndoStack() {
        const result = this._configurationService.getValue("files.restoreUndoStack");
        if (typeof result === "boolean") return result;
        return true;
    }
    getCreationOptions(languageIdOrSelection, resource, isForSimpleWidget) {
        const language = typeof languageIdOrSelection === "string" ? languageIdOrSelection : languageIdOrSelection.languageId;
        let creationOptions = this._modelCreationOptionsByLanguageAndResource[language + resource];
        if (!creationOptions) {
            const editor = this._configurationService.getValue("editor", {
                overrideIdentifier: language,
                resource
            });
            const eol = this._getEOL(resource, language);
            creationOptions = ModelService_1._readModelOptions({
                editor,
                eol
            }, isForSimpleWidget);
            this._modelCreationOptionsByLanguageAndResource[language + resource] = creationOptions;
        }
        return creationOptions;
    }
    _updateModelOptions(e) {
        const oldOptionsByLanguageAndResource = this._modelCreationOptionsByLanguageAndResource;
        this._modelCreationOptionsByLanguageAndResource = Object.create(null);
        // Update options on all models
        const keys = Object.keys(this._models);
        for(let i = 0, len = keys.length; i < len; i++){
            const modelId = keys[i];
            const modelData = this._models[modelId];
            const language = modelData.model.getLanguageId();
            const uri = modelData.model.uri;
            if (e && !e.affectsConfiguration("editor", {
                overrideIdentifier: language,
                resource: uri
            }) && !e.affectsConfiguration("files.eol", {
                overrideIdentifier: language,
                resource: uri
            })) continue; // perf: skip if this model is not affected by configuration change
            const oldOptions = oldOptionsByLanguageAndResource[language + uri];
            const newOptions = this.getCreationOptions(language, uri, modelData.model.isForSimpleWidget);
            ModelService_1._setModelOptionsForModel(modelData.model, newOptions, oldOptions);
        }
    }
    static _setModelOptionsForModel(model, newOptions, currentOptions) {
        if (currentOptions && currentOptions.defaultEOL !== newOptions.defaultEOL && model.getLineCount() === 1) model.setEOL(newOptions.defaultEOL === 1 /* DefaultEndOfLine.LF */  ? 0 /* EndOfLineSequence.LF */  : 1 /* EndOfLineSequence.CRLF */ );
        if (currentOptions && currentOptions.detectIndentation === newOptions.detectIndentation && currentOptions.insertSpaces === newOptions.insertSpaces && currentOptions.tabSize === newOptions.tabSize && currentOptions.indentSize === newOptions.indentSize && currentOptions.trimAutoWhitespace === newOptions.trimAutoWhitespace && (0, _objectsJs.equals)(currentOptions.bracketPairColorizationOptions, newOptions.bracketPairColorizationOptions)) // Same indent opts, no need to touch the model
        return;
        if (newOptions.detectIndentation) {
            model.detectIndentation(newOptions.insertSpaces, newOptions.tabSize);
            model.updateOptions({
                trimAutoWhitespace: newOptions.trimAutoWhitespace,
                bracketColorizationOptions: newOptions.bracketPairColorizationOptions
            });
        } else model.updateOptions({
            insertSpaces: newOptions.insertSpaces,
            tabSize: newOptions.tabSize,
            indentSize: newOptions.indentSize,
            trimAutoWhitespace: newOptions.trimAutoWhitespace,
            bracketColorizationOptions: newOptions.bracketPairColorizationOptions
        });
    }
    // --- begin IModelService
    _insertDisposedModel(disposedModelData) {
        this._disposedModels.set(MODEL_ID(disposedModelData.uri), disposedModelData);
        this._disposedModelsHeapSize += disposedModelData.heapSize;
    }
    _removeDisposedModel(resource) {
        const disposedModelData = this._disposedModels.get(MODEL_ID(resource));
        if (disposedModelData) this._disposedModelsHeapSize -= disposedModelData.heapSize;
        this._disposedModels.delete(MODEL_ID(resource));
        return disposedModelData;
    }
    _ensureDisposedModelsHeapSize(maxModelsHeapSize) {
        if (this._disposedModelsHeapSize > maxModelsHeapSize) {
            // we must remove some old undo stack elements to free up some memory
            const disposedModels = [];
            this._disposedModels.forEach((entry)=>{
                if (!entry.sharesUndoRedoStack) disposedModels.push(entry);
            });
            disposedModels.sort((a, b)=>a.time - b.time);
            while(disposedModels.length > 0 && this._disposedModelsHeapSize > maxModelsHeapSize){
                const disposedModel = disposedModels.shift();
                this._removeDisposedModel(disposedModel.uri);
                if (disposedModel.initialUndoRedoSnapshot !== null) this._undoRedoService.restoreSnapshot(disposedModel.initialUndoRedoSnapshot);
            }
        }
    }
    _createModelData(value, languageIdOrSelection, resource, isForSimpleWidget) {
        // create & save the model
        const options = this.getCreationOptions(languageIdOrSelection, resource, isForSimpleWidget);
        const model = this._instantiationService.createInstance((0, _textModelJs.TextModel), value, languageIdOrSelection, options, resource);
        if (resource && this._disposedModels.has(MODEL_ID(resource))) {
            const disposedModelData = this._removeDisposedModel(resource);
            const elements = this._undoRedoService.getElements(resource);
            const sha1Computer = this._getSHA1Computer();
            const sha1IsEqual = sha1Computer.canComputeSHA1(model) ? sha1Computer.computeSHA1(model) === disposedModelData.sha1 : false;
            if (sha1IsEqual || disposedModelData.sharesUndoRedoStack) {
                for (const element of elements.past)if ((0, _editStackJs.isEditStackElement)(element) && element.matchesResource(resource)) element.setModel(model);
                for (const element of elements.future)if ((0, _editStackJs.isEditStackElement)(element) && element.matchesResource(resource)) element.setModel(model);
                this._undoRedoService.setElementsValidFlag(resource, true, (element)=>(0, _editStackJs.isEditStackElement)(element) && element.matchesResource(resource));
                if (sha1IsEqual) {
                    model._overwriteVersionId(disposedModelData.versionId);
                    model._overwriteAlternativeVersionId(disposedModelData.alternativeVersionId);
                    model._overwriteInitialUndoRedoSnapshot(disposedModelData.initialUndoRedoSnapshot);
                }
            } else if (disposedModelData.initialUndoRedoSnapshot !== null) this._undoRedoService.restoreSnapshot(disposedModelData.initialUndoRedoSnapshot);
        }
        const modelId = MODEL_ID(model.uri);
        if (this._models[modelId]) // There already exists a model with this id => this is a programmer error
        throw new Error("ModelService: Cannot add model because it already exists!");
        const modelData = new ModelData(model, (model)=>this._onWillDispose(model), (model, e)=>this._onDidChangeLanguage(model, e));
        this._models[modelId] = modelData;
        return modelData;
    }
    createModel(value, languageSelection, resource, isForSimpleWidget = false) {
        let modelData;
        if (languageSelection) modelData = this._createModelData(value, languageSelection, resource, isForSimpleWidget);
        else modelData = this._createModelData(value, (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID), resource, isForSimpleWidget);
        this._onModelAdded.fire(modelData.model);
        return modelData.model;
    }
    getModels() {
        const ret = [];
        const keys = Object.keys(this._models);
        for(let i = 0, len = keys.length; i < len; i++){
            const modelId = keys[i];
            ret.push(this._models[modelId].model);
        }
        return ret;
    }
    getModel(resource) {
        const modelId = MODEL_ID(resource);
        const modelData = this._models[modelId];
        if (!modelData) return null;
        return modelData.model;
    }
    // --- end IModelService
    _schemaShouldMaintainUndoRedoElements(resource) {
        return resource.scheme === (0, _networkJs.Schemas).file || resource.scheme === (0, _networkJs.Schemas).vscodeRemote || resource.scheme === (0, _networkJs.Schemas).vscodeUserData || resource.scheme === (0, _networkJs.Schemas).vscodeNotebookCell || resource.scheme === "fake-fs" // for tests
        ;
    }
    _onWillDispose(model) {
        const modelId = MODEL_ID(model.uri);
        const modelData = this._models[modelId];
        const sharesUndoRedoStack = this._undoRedoService.getUriComparisonKey(model.uri) !== model.uri.toString();
        let maintainUndoRedoStack = false;
        let heapSize = 0;
        if (sharesUndoRedoStack || this._shouldRestoreUndoStack() && this._schemaShouldMaintainUndoRedoElements(model.uri)) {
            const elements = this._undoRedoService.getElements(model.uri);
            if (elements.past.length > 0 || elements.future.length > 0) {
                for (const element of elements.past)if ((0, _editStackJs.isEditStackElement)(element) && element.matchesResource(model.uri)) {
                    maintainUndoRedoStack = true;
                    heapSize += element.heapSize(model.uri);
                    element.setModel(model.uri); // remove reference from text buffer instance
                }
                for (const element of elements.future)if ((0, _editStackJs.isEditStackElement)(element) && element.matchesResource(model.uri)) {
                    maintainUndoRedoStack = true;
                    heapSize += element.heapSize(model.uri);
                    element.setModel(model.uri); // remove reference from text buffer instance
                }
            }
        }
        const maxMemory = ModelService_1.MAX_MEMORY_FOR_CLOSED_FILES_UNDO_STACK;
        const sha1Computer = this._getSHA1Computer();
        if (!maintainUndoRedoStack) {
            if (!sharesUndoRedoStack) {
                const initialUndoRedoSnapshot = modelData.model.getInitialUndoRedoSnapshot();
                if (initialUndoRedoSnapshot !== null) this._undoRedoService.restoreSnapshot(initialUndoRedoSnapshot);
            }
        } else if (!sharesUndoRedoStack && (heapSize > maxMemory || !sha1Computer.canComputeSHA1(model))) {
            // the undo stack for this file would never fit in the configured memory or the file is very large, so don't bother with it.
            const initialUndoRedoSnapshot = modelData.model.getInitialUndoRedoSnapshot();
            if (initialUndoRedoSnapshot !== null) this._undoRedoService.restoreSnapshot(initialUndoRedoSnapshot);
        } else {
            this._ensureDisposedModelsHeapSize(maxMemory - heapSize);
            // We only invalidate the elements, but they remain in the undo-redo service.
            this._undoRedoService.setElementsValidFlag(model.uri, false, (element)=>(0, _editStackJs.isEditStackElement)(element) && element.matchesResource(model.uri));
            this._insertDisposedModel(new DisposedModelInfo(model.uri, modelData.model.getInitialUndoRedoSnapshot(), Date.now(), sharesUndoRedoStack, heapSize, sha1Computer.computeSHA1(model), model.getVersionId(), model.getAlternativeVersionId()));
        }
        delete this._models[modelId];
        modelData.dispose();
        // clean up cache
        delete this._modelCreationOptionsByLanguageAndResource[model.getLanguageId() + model.uri];
        this._onModelRemoved.fire(model);
    }
    _onDidChangeLanguage(model, e) {
        const oldLanguageId = e.oldLanguage;
        const newLanguageId = model.getLanguageId();
        const oldOptions = this.getCreationOptions(oldLanguageId, model.uri, model.isForSimpleWidget);
        const newOptions = this.getCreationOptions(newLanguageId, model.uri, model.isForSimpleWidget);
        ModelService_1._setModelOptionsForModel(model, newOptions, oldOptions);
        this._onModelModeChanged.fire({
            model,
            oldLanguageId: oldLanguageId
        });
    }
    _getSHA1Computer() {
        return new DefaultModelSHA1Computer();
    }
};
ModelService = ModelService_1 = __decorate([
    __param(0, (0, _configurationJs.IConfigurationService)),
    __param(1, (0, _textResourceConfigurationJs.ITextResourcePropertiesService)),
    __param(2, (0, _undoRedoJs.IUndoRedoService)),
    __param(3, (0, _instantiationJs.IInstantiationService))
], ModelService);
class DefaultModelSHA1Computer {
    static{
        this.MAX_MODEL_SIZE = 10485760;
    }
    canComputeSHA1(model) {
        return model.getValueLength() <= DefaultModelSHA1Computer.MAX_MODEL_SIZE;
    }
    computeSHA1(model) {
        // compute the sha1
        const shaComputer = new (0, _hashJs.StringSHA1)();
        const snapshot = model.createSnapshot();
        let text;
        while(text = snapshot.read())shaComputer.update(text);
        return shaComputer.digest();
    }
}

},{"../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/platform.js":"7maJO","../model/textModel.js":"9beDe","../core/textModelDefaults.js":"esbOV","../languages/modesRegistry.js":"gqkb7","./textResourceConfiguration.js":"4yrEB","../../../platform/configuration/common/configuration.js":"dXkjq","../../../platform/undoRedo/common/undoRedo.js":"cXL0O","../../../base/common/hash.js":"hXc0q","../model/editStack.js":"iS9MJ","../../../base/common/network.js":"2c1AD","../../../base/common/objects.js":"j84mT","../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9beDe":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createTextBufferFactory", ()=>createTextBufferFactory);
parcelHelpers.export(exports, "createTextBufferFactoryFromSnapshot", ()=>createTextBufferFactoryFromSnapshot);
parcelHelpers.export(exports, "createTextBuffer", ()=>createTextBuffer);
parcelHelpers.export(exports, "TextModel", ()=>TextModel);
parcelHelpers.export(exports, "indentOfLine", ()=>indentOfLine);
parcelHelpers.export(exports, "ModelDecorationOverviewRulerOptions", ()=>ModelDecorationOverviewRulerOptions);
parcelHelpers.export(exports, "ModelDecorationGlyphMarginOptions", ()=>ModelDecorationGlyphMarginOptions);
parcelHelpers.export(exports, "ModelDecorationMinimapOptions", ()=>ModelDecorationMinimapOptions);
parcelHelpers.export(exports, "ModelDecorationInjectedTextOptions", ()=>ModelDecorationInjectedTextOptions);
parcelHelpers.export(exports, "ModelDecorationOptions", ()=>ModelDecorationOptions);
var _arraysJs = require("../../../base/common/arrays.js");
var _colorJs = require("../../../base/common/color.js");
var _errorsJs = require("../../../base/common/errors.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _stringsJs = require("../../../base/common/strings.js");
var _uriJs = require("../../../base/common/uri.js");
var _eolCounterJs = require("../core/eolCounter.js");
var _indentationJs = require("../core/indentation.js");
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
var _selectionJs = require("../core/selection.js");
var _textModelDefaultsJs = require("../core/textModelDefaults.js");
var _languageJs = require("../languages/language.js");
var _languageConfigurationRegistryJs = require("../languages/languageConfigurationRegistry.js");
var _modelJs = require("../model.js");
var _bracketPairsImplJs = require("./bracketPairsTextModelPart/bracketPairsImpl.js");
var _colorizedBracketPairsDecorationProviderJs = require("./bracketPairsTextModelPart/colorizedBracketPairsDecorationProvider.js");
var _editStackJs = require("./editStack.js");
var _guidesTextModelPartJs = require("./guidesTextModelPart.js");
var _indentationGuesserJs = require("./indentationGuesser.js");
var _intervalTreeJs = require("./intervalTree.js");
var _pieceTreeTextBufferJs = require("./pieceTreeTextBuffer/pieceTreeTextBuffer.js");
var _pieceTreeTextBufferBuilderJs = require("./pieceTreeTextBuffer/pieceTreeTextBufferBuilder.js");
var _textModelSearchJs = require("./textModelSearch.js");
var _tokenizationTextModelPartJs = require("./tokenizationTextModelPart.js");
var _tokensJs = require("./tokens.js");
var _textModelEventsJs = require("../textModelEvents.js");
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
var _undoRedoJs = require("../../../platform/undoRedo/common/undoRedo.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var TextModel_1;
function createTextBufferFactory(text) {
    const builder = new (0, _pieceTreeTextBufferBuilderJs.PieceTreeTextBufferBuilder)();
    builder.acceptChunk(text);
    return builder.finish();
}
function createTextBufferFactoryFromSnapshot(snapshot) {
    const builder = new (0, _pieceTreeTextBufferBuilderJs.PieceTreeTextBufferBuilder)();
    let chunk;
    while(typeof (chunk = snapshot.read()) === "string")builder.acceptChunk(chunk);
    return builder.finish();
}
function createTextBuffer(value, defaultEOL) {
    let factory;
    if (typeof value === "string") factory = createTextBufferFactory(value);
    else if (_modelJs.isITextSnapshot(value)) factory = createTextBufferFactoryFromSnapshot(value);
    else factory = value;
    return factory.create(defaultEOL);
}
let MODEL_ID = 0;
const LIMIT_FIND_COUNT = 999;
const LONG_LINE_BOUNDARY = 10000;
class TextModelSnapshot {
    constructor(source){
        this._source = source;
        this._eos = false;
    }
    read() {
        if (this._eos) return null;
        const result = [];
        let resultCnt = 0;
        let resultLength = 0;
        do {
            const tmp = this._source.read();
            if (tmp === null) {
                // end-of-stream
                this._eos = true;
                if (resultCnt === 0) return null;
                else return result.join("");
            }
            if (tmp.length > 0) {
                result[resultCnt++] = tmp;
                resultLength += tmp.length;
            }
            if (resultLength >= 65536) return result.join("");
        }while (true);
    }
}
const invalidFunc = ()=>{
    throw new Error(`Invalid change accessor`);
};
let TextModel = class TextModel extends (0, _lifecycleJs.Disposable) {
    static{
        TextModel_1 = this;
    }
    static{
        this._MODEL_SYNC_LIMIT = 52428800;
    }
    static{
        this.LARGE_FILE_SIZE_THRESHOLD = 20971520;
    }
    static{
        this.LARGE_FILE_LINE_COUNT_THRESHOLD = 300000;
    }
    static{
        this.LARGE_FILE_HEAP_OPERATION_THRESHOLD = 268435456;
    }
    static{
        this.DEFAULT_CREATION_OPTIONS = {
            isForSimpleWidget: false,
            tabSize: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).tabSize,
            indentSize: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).indentSize,
            insertSpaces: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).insertSpaces,
            detectIndentation: false,
            defaultEOL: 1 /* model.DefaultEndOfLine.LF */ ,
            trimAutoWhitespace: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).trimAutoWhitespace,
            largeFileOptimizations: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).largeFileOptimizations,
            bracketPairColorizationOptions: (0, _textModelDefaultsJs.EDITOR_MODEL_DEFAULTS).bracketPairColorizationOptions
        };
    }
    static resolveOptions(textBuffer, options) {
        if (options.detectIndentation) {
            const guessedIndentation = (0, _indentationGuesserJs.guessIndentation)(textBuffer, options.tabSize, options.insertSpaces);
            return new _modelJs.TextModelResolvedOptions({
                tabSize: guessedIndentation.tabSize,
                indentSize: "tabSize",
                insertSpaces: guessedIndentation.insertSpaces,
                trimAutoWhitespace: options.trimAutoWhitespace,
                defaultEOL: options.defaultEOL,
                bracketPairColorizationOptions: options.bracketPairColorizationOptions
            });
        }
        return new _modelJs.TextModelResolvedOptions(options);
    }
    get onDidChangeLanguage() {
        return this._tokenizationTextModelPart.onDidChangeLanguage;
    }
    get onDidChangeLanguageConfiguration() {
        return this._tokenizationTextModelPart.onDidChangeLanguageConfiguration;
    }
    get onDidChangeTokens() {
        return this._tokenizationTextModelPart.onDidChangeTokens;
    }
    onDidChangeContent(listener) {
        return this._eventEmitter.slowEvent((e)=>listener(e.contentChangedEvent));
    }
    onDidChangeContentOrInjectedText(listener) {
        return (0, _lifecycleJs.combinedDisposable)(this._eventEmitter.fastEvent((e)=>listener(e)), this._onDidChangeInjectedText.event((e)=>listener(e)));
    }
    _isDisposing() {
        return this.__isDisposing;
    }
    get tokenization() {
        return this._tokenizationTextModelPart;
    }
    get bracketPairs() {
        return this._bracketPairs;
    }
    get guides() {
        return this._guidesTextModelPart;
    }
    constructor(source, languageIdOrSelection, creationOptions, associatedResource = null, _undoRedoService, _languageService, _languageConfigurationService, instantiationService){
        super();
        this._undoRedoService = _undoRedoService;
        this._languageService = _languageService;
        this._languageConfigurationService = _languageConfigurationService;
        this.instantiationService = instantiationService;
        //#region Events
        this._onWillDispose = this._register(new (0, _eventJs.Emitter)());
        this.onWillDispose = this._onWillDispose.event;
        this._onDidChangeDecorations = this._register(new DidChangeDecorationsEmitter((affectedInjectedTextLines)=>this.handleBeforeFireDecorationsChangedEvent(affectedInjectedTextLines)));
        this.onDidChangeDecorations = this._onDidChangeDecorations.event;
        this._onDidChangeOptions = this._register(new (0, _eventJs.Emitter)());
        this.onDidChangeOptions = this._onDidChangeOptions.event;
        this._onDidChangeAttached = this._register(new (0, _eventJs.Emitter)());
        this.onDidChangeAttached = this._onDidChangeAttached.event;
        this._onDidChangeInjectedText = this._register(new (0, _eventJs.Emitter)());
        this._eventEmitter = this._register(new DidChangeContentEmitter());
        this._languageSelectionListener = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this._deltaDecorationCallCnt = 0;
        this._attachedViews = new (0, _tokensJs.AttachedViews)();
        // Generate a new unique model id
        MODEL_ID++;
        this.id = "$model" + MODEL_ID;
        this.isForSimpleWidget = creationOptions.isForSimpleWidget;
        if (typeof associatedResource === "undefined" || associatedResource === null) this._associatedResource = (0, _uriJs.URI).parse("inmemory://model/" + MODEL_ID);
        else this._associatedResource = associatedResource;
        this._attachedEditorCount = 0;
        const { textBuffer, disposable } = createTextBuffer(source, creationOptions.defaultEOL);
        this._buffer = textBuffer;
        this._bufferDisposable = disposable;
        this._options = TextModel_1.resolveOptions(this._buffer, creationOptions);
        const languageId = typeof languageIdOrSelection === "string" ? languageIdOrSelection : languageIdOrSelection.languageId;
        if (typeof languageIdOrSelection !== "string") this._languageSelectionListener.value = languageIdOrSelection.onDidChange(()=>this._setLanguage(languageIdOrSelection.languageId));
        this._bracketPairs = this._register(new (0, _bracketPairsImplJs.BracketPairsTextModelPart)(this, this._languageConfigurationService));
        this._guidesTextModelPart = this._register(new (0, _guidesTextModelPartJs.GuidesTextModelPart)(this, this._languageConfigurationService));
        this._decorationProvider = this._register(new (0, _colorizedBracketPairsDecorationProviderJs.ColorizedBracketPairsDecorationProvider)(this));
        this._tokenizationTextModelPart = this.instantiationService.createInstance((0, _tokenizationTextModelPartJs.TokenizationTextModelPart), this, this._bracketPairs, languageId, this._attachedViews);
        const bufferLineCount = this._buffer.getLineCount();
        const bufferTextLength = this._buffer.getValueLengthInRange(new (0, _rangeJs.Range)(1, 1, bufferLineCount, this._buffer.getLineLength(bufferLineCount) + 1), 0 /* model.EndOfLinePreference.TextDefined */ );
        // !!! Make a decision in the ctor and permanently respect this decision !!!
        // If a model is too large at construction time, it will never get tokenized,
        // under no circumstances.
        if (creationOptions.largeFileOptimizations) {
            this._isTooLargeForTokenization = bufferTextLength > TextModel_1.LARGE_FILE_SIZE_THRESHOLD || bufferLineCount > TextModel_1.LARGE_FILE_LINE_COUNT_THRESHOLD;
            this._isTooLargeForHeapOperation = bufferTextLength > TextModel_1.LARGE_FILE_HEAP_OPERATION_THRESHOLD;
        } else {
            this._isTooLargeForTokenization = false;
            this._isTooLargeForHeapOperation = false;
        }
        this._isTooLargeForSyncing = bufferTextLength > TextModel_1._MODEL_SYNC_LIMIT;
        this._versionId = 1;
        this._alternativeVersionId = 1;
        this._initialUndoRedoSnapshot = null;
        this._isDisposed = false;
        this.__isDisposing = false;
        this._instanceId = _stringsJs.singleLetterHash(MODEL_ID);
        this._lastDecorationId = 0;
        this._decorations = Object.create(null);
        this._decorationsTree = new DecorationsTrees();
        this._commandManager = new (0, _editStackJs.EditStack)(this, this._undoRedoService);
        this._isUndoing = false;
        this._isRedoing = false;
        this._trimAutoWhitespaceLines = null;
        this._register(this._decorationProvider.onDidChange(()=>{
            this._onDidChangeDecorations.beginDeferredEmit();
            this._onDidChangeDecorations.fire();
            this._onDidChangeDecorations.endDeferredEmit();
        }));
        this._languageService.requestRichLanguageFeatures(languageId);
        this._register(this._languageConfigurationService.onDidChange((e)=>{
            this._bracketPairs.handleLanguageConfigurationServiceChange(e);
            this._tokenizationTextModelPart.handleLanguageConfigurationServiceChange(e);
        }));
    }
    dispose() {
        this.__isDisposing = true;
        this._onWillDispose.fire();
        this._tokenizationTextModelPart.dispose();
        this._isDisposed = true;
        super.dispose();
        this._bufferDisposable.dispose();
        this.__isDisposing = false;
        // Manually release reference to previous text buffer to avoid large leaks
        // in case someone leaks a TextModel reference
        const emptyDisposedTextBuffer = new (0, _pieceTreeTextBufferJs.PieceTreeTextBuffer)([], "", "\n", false, false, true, true);
        emptyDisposedTextBuffer.dispose();
        this._buffer = emptyDisposedTextBuffer;
        this._bufferDisposable = (0, _lifecycleJs.Disposable).None;
    }
    _assertNotDisposed() {
        if (this._isDisposed) throw new (0, _errorsJs.BugIndicatingError)("Model is disposed!");
    }
    _emitContentChangedEvent(rawChange, change) {
        if (this.__isDisposing) // Do not confuse listeners by emitting any event after disposing
        return;
        this._tokenizationTextModelPart.handleDidChangeContent(change);
        this._bracketPairs.handleDidChangeContent(change);
        this._eventEmitter.fire(new (0, _textModelEventsJs.InternalModelContentChangeEvent)(rawChange, change));
    }
    setValue(value) {
        this._assertNotDisposed();
        if (value === null || value === undefined) throw (0, _errorsJs.illegalArgument)();
        const { textBuffer, disposable } = createTextBuffer(value, this._options.defaultEOL);
        this._setValueFromTextBuffer(textBuffer, disposable);
    }
    _createContentChanged2(range, rangeOffset, rangeLength, text, isUndoing, isRedoing, isFlush, isEolChange) {
        return {
            changes: [
                {
                    range: range,
                    rangeOffset: rangeOffset,
                    rangeLength: rangeLength,
                    text: text
                }
            ],
            eol: this._buffer.getEOL(),
            isEolChange: isEolChange,
            versionId: this.getVersionId(),
            isUndoing: isUndoing,
            isRedoing: isRedoing,
            isFlush: isFlush
        };
    }
    _setValueFromTextBuffer(textBuffer, textBufferDisposable) {
        this._assertNotDisposed();
        const oldFullModelRange = this.getFullModelRange();
        const oldModelValueLength = this.getValueLengthInRange(oldFullModelRange);
        const endLineNumber = this.getLineCount();
        const endColumn = this.getLineMaxColumn(endLineNumber);
        this._buffer = textBuffer;
        this._bufferDisposable.dispose();
        this._bufferDisposable = textBufferDisposable;
        this._increaseVersionId();
        // Destroy all my decorations
        this._decorations = Object.create(null);
        this._decorationsTree = new DecorationsTrees();
        // Destroy my edit history and settings
        this._commandManager.clear();
        this._trimAutoWhitespaceLines = null;
        this._emitContentChangedEvent(new (0, _textModelEventsJs.ModelRawContentChangedEvent)([
            new (0, _textModelEventsJs.ModelRawFlush)()
        ], this._versionId, false, false), this._createContentChanged2(new (0, _rangeJs.Range)(1, 1, endLineNumber, endColumn), 0, oldModelValueLength, this.getValue(), false, false, true, false));
    }
    setEOL(eol) {
        this._assertNotDisposed();
        const newEOL = eol === 1 /* model.EndOfLineSequence.CRLF */  ? "\r\n" : "\n";
        if (this._buffer.getEOL() === newEOL) // Nothing to do
        return;
        const oldFullModelRange = this.getFullModelRange();
        const oldModelValueLength = this.getValueLengthInRange(oldFullModelRange);
        const endLineNumber = this.getLineCount();
        const endColumn = this.getLineMaxColumn(endLineNumber);
        this._onBeforeEOLChange();
        this._buffer.setEOL(newEOL);
        this._increaseVersionId();
        this._onAfterEOLChange();
        this._emitContentChangedEvent(new (0, _textModelEventsJs.ModelRawContentChangedEvent)([
            new (0, _textModelEventsJs.ModelRawEOLChanged)()
        ], this._versionId, false, false), this._createContentChanged2(new (0, _rangeJs.Range)(1, 1, endLineNumber, endColumn), 0, oldModelValueLength, this.getValue(), false, false, false, true));
    }
    _onBeforeEOLChange() {
        // Ensure all decorations get their `range` set.
        this._decorationsTree.ensureAllNodesHaveRanges(this);
    }
    _onAfterEOLChange() {
        // Transform back `range` to offsets
        const versionId = this.getVersionId();
        const allDecorations = this._decorationsTree.collectNodesPostOrder();
        for(let i = 0, len = allDecorations.length; i < len; i++){
            const node = allDecorations[i];
            const range = node.range; // the range is defined due to `_onBeforeEOLChange`
            const delta = node.cachedAbsoluteStart - node.start;
            const startOffset = this._buffer.getOffsetAt(range.startLineNumber, range.startColumn);
            const endOffset = this._buffer.getOffsetAt(range.endLineNumber, range.endColumn);
            node.cachedAbsoluteStart = startOffset;
            node.cachedAbsoluteEnd = endOffset;
            node.cachedVersionId = versionId;
            node.start = startOffset - delta;
            node.end = endOffset - delta;
            (0, _intervalTreeJs.recomputeMaxEnd)(node);
        }
    }
    onBeforeAttached() {
        this._attachedEditorCount++;
        if (this._attachedEditorCount === 1) {
            this._tokenizationTextModelPart.handleDidChangeAttached();
            this._onDidChangeAttached.fire(undefined);
        }
        return this._attachedViews.attachView();
    }
    onBeforeDetached(view) {
        this._attachedEditorCount--;
        if (this._attachedEditorCount === 0) {
            this._tokenizationTextModelPart.handleDidChangeAttached();
            this._onDidChangeAttached.fire(undefined);
        }
        this._attachedViews.detachView(view);
    }
    isAttachedToEditor() {
        return this._attachedEditorCount > 0;
    }
    getAttachedEditorCount() {
        return this._attachedEditorCount;
    }
    isTooLargeForSyncing() {
        return this._isTooLargeForSyncing;
    }
    isTooLargeForTokenization() {
        return this._isTooLargeForTokenization;
    }
    isTooLargeForHeapOperation() {
        return this._isTooLargeForHeapOperation;
    }
    isDisposed() {
        return this._isDisposed;
    }
    isDominatedByLongLines() {
        this._assertNotDisposed();
        if (this.isTooLargeForTokenization()) // Cannot word wrap huge files anyways, so it doesn't really matter
        return false;
        let smallLineCharCount = 0;
        let longLineCharCount = 0;
        const lineCount = this._buffer.getLineCount();
        for(let lineNumber = 1; lineNumber <= lineCount; lineNumber++){
            const lineLength = this._buffer.getLineLength(lineNumber);
            if (lineLength >= LONG_LINE_BOUNDARY) longLineCharCount += lineLength;
            else smallLineCharCount += lineLength;
        }
        return longLineCharCount > smallLineCharCount;
    }
    get uri() {
        return this._associatedResource;
    }
    //#region Options
    getOptions() {
        this._assertNotDisposed();
        return this._options;
    }
    getFormattingOptions() {
        return {
            tabSize: this._options.indentSize,
            insertSpaces: this._options.insertSpaces
        };
    }
    updateOptions(_newOpts) {
        this._assertNotDisposed();
        const tabSize = typeof _newOpts.tabSize !== "undefined" ? _newOpts.tabSize : this._options.tabSize;
        const indentSize = typeof _newOpts.indentSize !== "undefined" ? _newOpts.indentSize : this._options.originalIndentSize;
        const insertSpaces = typeof _newOpts.insertSpaces !== "undefined" ? _newOpts.insertSpaces : this._options.insertSpaces;
        const trimAutoWhitespace = typeof _newOpts.trimAutoWhitespace !== "undefined" ? _newOpts.trimAutoWhitespace : this._options.trimAutoWhitespace;
        const bracketPairColorizationOptions = typeof _newOpts.bracketColorizationOptions !== "undefined" ? _newOpts.bracketColorizationOptions : this._options.bracketPairColorizationOptions;
        const newOpts = new _modelJs.TextModelResolvedOptions({
            tabSize: tabSize,
            indentSize: indentSize,
            insertSpaces: insertSpaces,
            defaultEOL: this._options.defaultEOL,
            trimAutoWhitespace: trimAutoWhitespace,
            bracketPairColorizationOptions
        });
        if (this._options.equals(newOpts)) return;
        const e = this._options.createChangeEvent(newOpts);
        this._options = newOpts;
        this._bracketPairs.handleDidChangeOptions(e);
        this._decorationProvider.handleDidChangeOptions(e);
        this._onDidChangeOptions.fire(e);
    }
    detectIndentation(defaultInsertSpaces, defaultTabSize) {
        this._assertNotDisposed();
        const guessedIndentation = (0, _indentationGuesserJs.guessIndentation)(this._buffer, defaultTabSize, defaultInsertSpaces);
        this.updateOptions({
            insertSpaces: guessedIndentation.insertSpaces,
            tabSize: guessedIndentation.tabSize,
            indentSize: guessedIndentation.tabSize
        });
    }
    normalizeIndentation(str) {
        this._assertNotDisposed();
        return (0, _indentationJs.normalizeIndentation)(str, this._options.indentSize, this._options.insertSpaces);
    }
    //#endregion
    //#region Reading
    getVersionId() {
        this._assertNotDisposed();
        return this._versionId;
    }
    mightContainRTL() {
        return this._buffer.mightContainRTL();
    }
    mightContainUnusualLineTerminators() {
        return this._buffer.mightContainUnusualLineTerminators();
    }
    removeUnusualLineTerminators(selections = null) {
        const matches = this.findMatches(_stringsJs.UNUSUAL_LINE_TERMINATORS.source, false, true, false, null, false, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ );
        this._buffer.resetMightContainUnusualLineTerminators();
        this.pushEditOperations(selections, matches.map((m)=>({
                range: m.range,
                text: null
            })), ()=>null);
    }
    mightContainNonBasicASCII() {
        return this._buffer.mightContainNonBasicASCII();
    }
    getAlternativeVersionId() {
        this._assertNotDisposed();
        return this._alternativeVersionId;
    }
    getInitialUndoRedoSnapshot() {
        this._assertNotDisposed();
        return this._initialUndoRedoSnapshot;
    }
    getOffsetAt(rawPosition) {
        this._assertNotDisposed();
        const position = this._validatePosition(rawPosition.lineNumber, rawPosition.column, 0 /* StringOffsetValidationType.Relaxed */ );
        return this._buffer.getOffsetAt(position.lineNumber, position.column);
    }
    getPositionAt(rawOffset) {
        this._assertNotDisposed();
        const offset = Math.min(this._buffer.getLength(), Math.max(0, rawOffset));
        return this._buffer.getPositionAt(offset);
    }
    _increaseVersionId() {
        this._versionId = this._versionId + 1;
        this._alternativeVersionId = this._versionId;
    }
    _overwriteVersionId(versionId) {
        this._versionId = versionId;
    }
    _overwriteAlternativeVersionId(newAlternativeVersionId) {
        this._alternativeVersionId = newAlternativeVersionId;
    }
    _overwriteInitialUndoRedoSnapshot(newInitialUndoRedoSnapshot) {
        this._initialUndoRedoSnapshot = newInitialUndoRedoSnapshot;
    }
    getValue(eol, preserveBOM = false) {
        this._assertNotDisposed();
        if (this.isTooLargeForHeapOperation()) throw new (0, _errorsJs.BugIndicatingError)("Operation would exceed heap memory limits");
        const fullModelRange = this.getFullModelRange();
        const fullModelValue = this.getValueInRange(fullModelRange, eol);
        if (preserveBOM) return this._buffer.getBOM() + fullModelValue;
        return fullModelValue;
    }
    createSnapshot(preserveBOM = false) {
        return new TextModelSnapshot(this._buffer.createSnapshot(preserveBOM));
    }
    getValueLength(eol, preserveBOM = false) {
        this._assertNotDisposed();
        const fullModelRange = this.getFullModelRange();
        const fullModelValue = this.getValueLengthInRange(fullModelRange, eol);
        if (preserveBOM) return this._buffer.getBOM().length + fullModelValue;
        return fullModelValue;
    }
    getValueInRange(rawRange, eol = 0 /* model.EndOfLinePreference.TextDefined */ ) {
        this._assertNotDisposed();
        return this._buffer.getValueInRange(this.validateRange(rawRange), eol);
    }
    getValueLengthInRange(rawRange, eol = 0 /* model.EndOfLinePreference.TextDefined */ ) {
        this._assertNotDisposed();
        return this._buffer.getValueLengthInRange(this.validateRange(rawRange), eol);
    }
    getCharacterCountInRange(rawRange, eol = 0 /* model.EndOfLinePreference.TextDefined */ ) {
        this._assertNotDisposed();
        return this._buffer.getCharacterCountInRange(this.validateRange(rawRange), eol);
    }
    getLineCount() {
        this._assertNotDisposed();
        return this._buffer.getLineCount();
    }
    getLineContent(lineNumber) {
        this._assertNotDisposed();
        if (lineNumber < 1 || lineNumber > this.getLineCount()) throw new (0, _errorsJs.BugIndicatingError)("Illegal value for lineNumber");
        return this._buffer.getLineContent(lineNumber);
    }
    getLineLength(lineNumber) {
        this._assertNotDisposed();
        if (lineNumber < 1 || lineNumber > this.getLineCount()) throw new (0, _errorsJs.BugIndicatingError)("Illegal value for lineNumber");
        return this._buffer.getLineLength(lineNumber);
    }
    getLinesContent() {
        this._assertNotDisposed();
        if (this.isTooLargeForHeapOperation()) throw new (0, _errorsJs.BugIndicatingError)("Operation would exceed heap memory limits");
        return this._buffer.getLinesContent();
    }
    getEOL() {
        this._assertNotDisposed();
        return this._buffer.getEOL();
    }
    getEndOfLineSequence() {
        this._assertNotDisposed();
        return this._buffer.getEOL() === "\n" ? 0 /* model.EndOfLineSequence.LF */  : 1 /* model.EndOfLineSequence.CRLF */ ;
    }
    getLineMinColumn(lineNumber) {
        this._assertNotDisposed();
        return 1;
    }
    getLineMaxColumn(lineNumber) {
        this._assertNotDisposed();
        if (lineNumber < 1 || lineNumber > this.getLineCount()) throw new (0, _errorsJs.BugIndicatingError)("Illegal value for lineNumber");
        return this._buffer.getLineLength(lineNumber) + 1;
    }
    getLineFirstNonWhitespaceColumn(lineNumber) {
        this._assertNotDisposed();
        if (lineNumber < 1 || lineNumber > this.getLineCount()) throw new (0, _errorsJs.BugIndicatingError)("Illegal value for lineNumber");
        return this._buffer.getLineFirstNonWhitespaceColumn(lineNumber);
    }
    getLineLastNonWhitespaceColumn(lineNumber) {
        this._assertNotDisposed();
        if (lineNumber < 1 || lineNumber > this.getLineCount()) throw new (0, _errorsJs.BugIndicatingError)("Illegal value for lineNumber");
        return this._buffer.getLineLastNonWhitespaceColumn(lineNumber);
    }
    /**
     * Validates `range` is within buffer bounds, but allows it to sit in between surrogate pairs, etc.
     * Will try to not allocate if possible.
     */ _validateRangeRelaxedNoAllocations(range) {
        const linesCount = this._buffer.getLineCount();
        const initialStartLineNumber = range.startLineNumber;
        const initialStartColumn = range.startColumn;
        let startLineNumber = Math.floor(typeof initialStartLineNumber === "number" && !isNaN(initialStartLineNumber) ? initialStartLineNumber : 1);
        let startColumn = Math.floor(typeof initialStartColumn === "number" && !isNaN(initialStartColumn) ? initialStartColumn : 1);
        if (startLineNumber < 1) {
            startLineNumber = 1;
            startColumn = 1;
        } else if (startLineNumber > linesCount) {
            startLineNumber = linesCount;
            startColumn = this.getLineMaxColumn(startLineNumber);
        } else if (startColumn <= 1) startColumn = 1;
        else {
            const maxColumn = this.getLineMaxColumn(startLineNumber);
            if (startColumn >= maxColumn) startColumn = maxColumn;
        }
        const initialEndLineNumber = range.endLineNumber;
        const initialEndColumn = range.endColumn;
        let endLineNumber = Math.floor(typeof initialEndLineNumber === "number" && !isNaN(initialEndLineNumber) ? initialEndLineNumber : 1);
        let endColumn = Math.floor(typeof initialEndColumn === "number" && !isNaN(initialEndColumn) ? initialEndColumn : 1);
        if (endLineNumber < 1) {
            endLineNumber = 1;
            endColumn = 1;
        } else if (endLineNumber > linesCount) {
            endLineNumber = linesCount;
            endColumn = this.getLineMaxColumn(endLineNumber);
        } else if (endColumn <= 1) endColumn = 1;
        else {
            const maxColumn = this.getLineMaxColumn(endLineNumber);
            if (endColumn >= maxColumn) endColumn = maxColumn;
        }
        if (initialStartLineNumber === startLineNumber && initialStartColumn === startColumn && initialEndLineNumber === endLineNumber && initialEndColumn === endColumn && range instanceof (0, _rangeJs.Range) && !(range instanceof (0, _selectionJs.Selection))) return range;
        return new (0, _rangeJs.Range)(startLineNumber, startColumn, endLineNumber, endColumn);
    }
    _isValidPosition(lineNumber, column, validationType) {
        if (typeof lineNumber !== "number" || typeof column !== "number") return false;
        if (isNaN(lineNumber) || isNaN(column)) return false;
        if (lineNumber < 1 || column < 1) return false;
        if ((lineNumber | 0) !== lineNumber || (column | 0) !== column) return false;
        const lineCount = this._buffer.getLineCount();
        if (lineNumber > lineCount) return false;
        if (column === 1) return true;
        const maxColumn = this.getLineMaxColumn(lineNumber);
        if (column > maxColumn) return false;
        if (validationType === 1 /* StringOffsetValidationType.SurrogatePairs */ ) {
            // !!At this point, column > 1
            const charCodeBefore = this._buffer.getLineCharCode(lineNumber, column - 2);
            if (_stringsJs.isHighSurrogate(charCodeBefore)) return false;
        }
        return true;
    }
    _validatePosition(_lineNumber, _column, validationType) {
        const lineNumber = Math.floor(typeof _lineNumber === "number" && !isNaN(_lineNumber) ? _lineNumber : 1);
        const column = Math.floor(typeof _column === "number" && !isNaN(_column) ? _column : 1);
        const lineCount = this._buffer.getLineCount();
        if (lineNumber < 1) return new (0, _positionJs.Position)(1, 1);
        if (lineNumber > lineCount) return new (0, _positionJs.Position)(lineCount, this.getLineMaxColumn(lineCount));
        if (column <= 1) return new (0, _positionJs.Position)(lineNumber, 1);
        const maxColumn = this.getLineMaxColumn(lineNumber);
        if (column >= maxColumn) return new (0, _positionJs.Position)(lineNumber, maxColumn);
        if (validationType === 1 /* StringOffsetValidationType.SurrogatePairs */ ) {
            // If the position would end up in the middle of a high-low surrogate pair,
            // we move it to before the pair
            // !!At this point, column > 1
            const charCodeBefore = this._buffer.getLineCharCode(lineNumber, column - 2);
            if (_stringsJs.isHighSurrogate(charCodeBefore)) return new (0, _positionJs.Position)(lineNumber, column - 1);
        }
        return new (0, _positionJs.Position)(lineNumber, column);
    }
    validatePosition(position) {
        const validationType = 1 /* StringOffsetValidationType.SurrogatePairs */ ;
        this._assertNotDisposed();
        // Avoid object allocation and cover most likely case
        if (position instanceof (0, _positionJs.Position)) {
            if (this._isValidPosition(position.lineNumber, position.column, validationType)) return position;
        }
        return this._validatePosition(position.lineNumber, position.column, validationType);
    }
    _isValidRange(range, validationType) {
        const startLineNumber = range.startLineNumber;
        const startColumn = range.startColumn;
        const endLineNumber = range.endLineNumber;
        const endColumn = range.endColumn;
        if (!this._isValidPosition(startLineNumber, startColumn, 0 /* StringOffsetValidationType.Relaxed */ )) return false;
        if (!this._isValidPosition(endLineNumber, endColumn, 0 /* StringOffsetValidationType.Relaxed */ )) return false;
        if (validationType === 1 /* StringOffsetValidationType.SurrogatePairs */ ) {
            const charCodeBeforeStart = startColumn > 1 ? this._buffer.getLineCharCode(startLineNumber, startColumn - 2) : 0;
            const charCodeBeforeEnd = endColumn > 1 && endColumn <= this._buffer.getLineLength(endLineNumber) ? this._buffer.getLineCharCode(endLineNumber, endColumn - 2) : 0;
            const startInsideSurrogatePair = _stringsJs.isHighSurrogate(charCodeBeforeStart);
            const endInsideSurrogatePair = _stringsJs.isHighSurrogate(charCodeBeforeEnd);
            if (!startInsideSurrogatePair && !endInsideSurrogatePair) return true;
            return false;
        }
        return true;
    }
    validateRange(_range) {
        const validationType = 1 /* StringOffsetValidationType.SurrogatePairs */ ;
        this._assertNotDisposed();
        // Avoid object allocation and cover most likely case
        if (_range instanceof (0, _rangeJs.Range) && !(_range instanceof (0, _selectionJs.Selection))) {
            if (this._isValidRange(_range, validationType)) return _range;
        }
        const start = this._validatePosition(_range.startLineNumber, _range.startColumn, 0 /* StringOffsetValidationType.Relaxed */ );
        const end = this._validatePosition(_range.endLineNumber, _range.endColumn, 0 /* StringOffsetValidationType.Relaxed */ );
        const startLineNumber = start.lineNumber;
        const startColumn = start.column;
        const endLineNumber = end.lineNumber;
        const endColumn = end.column;
        if (validationType === 1 /* StringOffsetValidationType.SurrogatePairs */ ) {
            const charCodeBeforeStart = startColumn > 1 ? this._buffer.getLineCharCode(startLineNumber, startColumn - 2) : 0;
            const charCodeBeforeEnd = endColumn > 1 && endColumn <= this._buffer.getLineLength(endLineNumber) ? this._buffer.getLineCharCode(endLineNumber, endColumn - 2) : 0;
            const startInsideSurrogatePair = _stringsJs.isHighSurrogate(charCodeBeforeStart);
            const endInsideSurrogatePair = _stringsJs.isHighSurrogate(charCodeBeforeEnd);
            if (!startInsideSurrogatePair && !endInsideSurrogatePair) return new (0, _rangeJs.Range)(startLineNumber, startColumn, endLineNumber, endColumn);
            if (startLineNumber === endLineNumber && startColumn === endColumn) // do not expand a collapsed range, simply move it to a valid location
            return new (0, _rangeJs.Range)(startLineNumber, startColumn - 1, endLineNumber, endColumn - 1);
            if (startInsideSurrogatePair && endInsideSurrogatePair) // expand range at both ends
            return new (0, _rangeJs.Range)(startLineNumber, startColumn - 1, endLineNumber, endColumn + 1);
            if (startInsideSurrogatePair) // only expand range at the start
            return new (0, _rangeJs.Range)(startLineNumber, startColumn - 1, endLineNumber, endColumn);
            // only expand range at the end
            return new (0, _rangeJs.Range)(startLineNumber, startColumn, endLineNumber, endColumn + 1);
        }
        return new (0, _rangeJs.Range)(startLineNumber, startColumn, endLineNumber, endColumn);
    }
    modifyPosition(rawPosition, offset) {
        this._assertNotDisposed();
        const candidate = this.getOffsetAt(rawPosition) + offset;
        return this.getPositionAt(Math.min(this._buffer.getLength(), Math.max(0, candidate)));
    }
    getFullModelRange() {
        this._assertNotDisposed();
        const lineCount = this.getLineCount();
        return new (0, _rangeJs.Range)(1, 1, lineCount, this.getLineMaxColumn(lineCount));
    }
    findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount) {
        return this._buffer.findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount);
    }
    findMatches(searchString, rawSearchScope, isRegex, matchCase, wordSeparators, captureMatches, limitResultCount = LIMIT_FIND_COUNT) {
        this._assertNotDisposed();
        let searchRanges = null;
        if (rawSearchScope !== null) {
            if (!Array.isArray(rawSearchScope)) rawSearchScope = [
                rawSearchScope
            ];
            if (rawSearchScope.every((searchScope)=>(0, _rangeJs.Range).isIRange(searchScope))) searchRanges = rawSearchScope.map((searchScope)=>this.validateRange(searchScope));
        }
        if (searchRanges === null) searchRanges = [
            this.getFullModelRange()
        ];
        searchRanges = searchRanges.sort((d1, d2)=>d1.startLineNumber - d2.startLineNumber || d1.startColumn - d2.startColumn);
        const uniqueSearchRanges = [];
        uniqueSearchRanges.push(searchRanges.reduce((prev, curr)=>{
            if ((0, _rangeJs.Range).areIntersecting(prev, curr)) return prev.plusRange(curr);
            uniqueSearchRanges.push(prev);
            return curr;
        }));
        let matchMapper;
        if (!isRegex && searchString.indexOf("\n") < 0) {
            // not regex, not multi line
            const searchParams = new (0, _textModelSearchJs.SearchParams)(searchString, isRegex, matchCase, wordSeparators);
            const searchData = searchParams.parseSearchRequest();
            if (!searchData) return [];
            matchMapper = (searchRange)=>this.findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount);
        } else matchMapper = (searchRange)=>(0, _textModelSearchJs.TextModelSearch).findMatches(this, new (0, _textModelSearchJs.SearchParams)(searchString, isRegex, matchCase, wordSeparators), searchRange, captureMatches, limitResultCount);
        return uniqueSearchRanges.map(matchMapper).reduce((arr, matches)=>arr.concat(matches), []);
    }
    findNextMatch(searchString, rawSearchStart, isRegex, matchCase, wordSeparators, captureMatches) {
        this._assertNotDisposed();
        const searchStart = this.validatePosition(rawSearchStart);
        if (!isRegex && searchString.indexOf("\n") < 0) {
            const searchParams = new (0, _textModelSearchJs.SearchParams)(searchString, isRegex, matchCase, wordSeparators);
            const searchData = searchParams.parseSearchRequest();
            if (!searchData) return null;
            const lineCount = this.getLineCount();
            let searchRange = new (0, _rangeJs.Range)(searchStart.lineNumber, searchStart.column, lineCount, this.getLineMaxColumn(lineCount));
            let ret = this.findMatchesLineByLine(searchRange, searchData, captureMatches, 1);
            (0, _textModelSearchJs.TextModelSearch).findNextMatch(this, new (0, _textModelSearchJs.SearchParams)(searchString, isRegex, matchCase, wordSeparators), searchStart, captureMatches);
            if (ret.length > 0) return ret[0];
            searchRange = new (0, _rangeJs.Range)(1, 1, searchStart.lineNumber, this.getLineMaxColumn(searchStart.lineNumber));
            ret = this.findMatchesLineByLine(searchRange, searchData, captureMatches, 1);
            if (ret.length > 0) return ret[0];
            return null;
        }
        return (0, _textModelSearchJs.TextModelSearch).findNextMatch(this, new (0, _textModelSearchJs.SearchParams)(searchString, isRegex, matchCase, wordSeparators), searchStart, captureMatches);
    }
    findPreviousMatch(searchString, rawSearchStart, isRegex, matchCase, wordSeparators, captureMatches) {
        this._assertNotDisposed();
        const searchStart = this.validatePosition(rawSearchStart);
        return (0, _textModelSearchJs.TextModelSearch).findPreviousMatch(this, new (0, _textModelSearchJs.SearchParams)(searchString, isRegex, matchCase, wordSeparators), searchStart, captureMatches);
    }
    //#endregion
    //#region Editing
    pushStackElement() {
        this._commandManager.pushStackElement();
    }
    popStackElement() {
        this._commandManager.popStackElement();
    }
    pushEOL(eol) {
        const currentEOL = this.getEOL() === "\n" ? 0 /* model.EndOfLineSequence.LF */  : 1 /* model.EndOfLineSequence.CRLF */ ;
        if (currentEOL === eol) return;
        try {
            this._onDidChangeDecorations.beginDeferredEmit();
            this._eventEmitter.beginDeferredEmit();
            if (this._initialUndoRedoSnapshot === null) this._initialUndoRedoSnapshot = this._undoRedoService.createSnapshot(this.uri);
            this._commandManager.pushEOL(eol);
        } finally{
            this._eventEmitter.endDeferredEmit();
            this._onDidChangeDecorations.endDeferredEmit();
        }
    }
    _validateEditOperation(rawOperation) {
        if (rawOperation instanceof _modelJs.ValidAnnotatedEditOperation) return rawOperation;
        return new _modelJs.ValidAnnotatedEditOperation(rawOperation.identifier || null, this.validateRange(rawOperation.range), rawOperation.text, rawOperation.forceMoveMarkers || false, rawOperation.isAutoWhitespaceEdit || false, rawOperation._isTracked || false);
    }
    _validateEditOperations(rawOperations) {
        const result = [];
        for(let i = 0, len = rawOperations.length; i < len; i++)result[i] = this._validateEditOperation(rawOperations[i]);
        return result;
    }
    pushEditOperations(beforeCursorState, editOperations, cursorStateComputer, group) {
        try {
            this._onDidChangeDecorations.beginDeferredEmit();
            this._eventEmitter.beginDeferredEmit();
            return this._pushEditOperations(beforeCursorState, this._validateEditOperations(editOperations), cursorStateComputer, group);
        } finally{
            this._eventEmitter.endDeferredEmit();
            this._onDidChangeDecorations.endDeferredEmit();
        }
    }
    _pushEditOperations(beforeCursorState, editOperations, cursorStateComputer, group) {
        if (this._options.trimAutoWhitespace && this._trimAutoWhitespaceLines) {
            // Go through each saved line number and insert a trim whitespace edit
            // if it is safe to do so (no conflicts with other edits).
            const incomingEdits = editOperations.map((op)=>{
                return {
                    range: this.validateRange(op.range),
                    text: op.text
                };
            });
            // Sometimes, auto-formatters change ranges automatically which can cause undesired auto whitespace trimming near the cursor
            // We'll use the following heuristic: if the edits occur near the cursor, then it's ok to trim auto whitespace
            let editsAreNearCursors = true;
            if (beforeCursorState) for(let i = 0, len = beforeCursorState.length; i < len; i++){
                const sel = beforeCursorState[i];
                let foundEditNearSel = false;
                for(let j = 0, lenJ = incomingEdits.length; j < lenJ; j++){
                    const editRange = incomingEdits[j].range;
                    const selIsAbove = editRange.startLineNumber > sel.endLineNumber;
                    const selIsBelow = sel.startLineNumber > editRange.endLineNumber;
                    if (!selIsAbove && !selIsBelow) {
                        foundEditNearSel = true;
                        break;
                    }
                }
                if (!foundEditNearSel) {
                    editsAreNearCursors = false;
                    break;
                }
            }
            if (editsAreNearCursors) for(let i = 0, len = this._trimAutoWhitespaceLines.length; i < len; i++){
                const trimLineNumber = this._trimAutoWhitespaceLines[i];
                const maxLineColumn = this.getLineMaxColumn(trimLineNumber);
                let allowTrimLine = true;
                for(let j = 0, lenJ = incomingEdits.length; j < lenJ; j++){
                    const editRange = incomingEdits[j].range;
                    const editText = incomingEdits[j].text;
                    if (trimLineNumber < editRange.startLineNumber || trimLineNumber > editRange.endLineNumber) continue;
                    // At this point:
                    //   editRange.startLineNumber <= trimLine <= editRange.endLineNumber
                    if (trimLineNumber === editRange.startLineNumber && editRange.startColumn === maxLineColumn && editRange.isEmpty() && editText && editText.length > 0 && editText.charAt(0) === "\n") continue;
                    if (trimLineNumber === editRange.startLineNumber && editRange.startColumn === 1 && editRange.isEmpty() && editText && editText.length > 0 && editText.charAt(editText.length - 1) === "\n") continue;
                    // Looks like we can't trim this line as it would interfere with an incoming edit
                    allowTrimLine = false;
                    break;
                }
                if (allowTrimLine) {
                    const trimRange = new (0, _rangeJs.Range)(trimLineNumber, 1, trimLineNumber, maxLineColumn);
                    editOperations.push(new _modelJs.ValidAnnotatedEditOperation(null, trimRange, null, false, false, false));
                }
            }
            this._trimAutoWhitespaceLines = null;
        }
        if (this._initialUndoRedoSnapshot === null) this._initialUndoRedoSnapshot = this._undoRedoService.createSnapshot(this.uri);
        return this._commandManager.pushEditOperation(beforeCursorState, editOperations, cursorStateComputer, group);
    }
    _applyUndo(changes, eol, resultingAlternativeVersionId, resultingSelection) {
        const edits = changes.map((change)=>{
            const rangeStart = this.getPositionAt(change.newPosition);
            const rangeEnd = this.getPositionAt(change.newEnd);
            return {
                range: new (0, _rangeJs.Range)(rangeStart.lineNumber, rangeStart.column, rangeEnd.lineNumber, rangeEnd.column),
                text: change.oldText
            };
        });
        this._applyUndoRedoEdits(edits, eol, true, false, resultingAlternativeVersionId, resultingSelection);
    }
    _applyRedo(changes, eol, resultingAlternativeVersionId, resultingSelection) {
        const edits = changes.map((change)=>{
            const rangeStart = this.getPositionAt(change.oldPosition);
            const rangeEnd = this.getPositionAt(change.oldEnd);
            return {
                range: new (0, _rangeJs.Range)(rangeStart.lineNumber, rangeStart.column, rangeEnd.lineNumber, rangeEnd.column),
                text: change.newText
            };
        });
        this._applyUndoRedoEdits(edits, eol, false, true, resultingAlternativeVersionId, resultingSelection);
    }
    _applyUndoRedoEdits(edits, eol, isUndoing, isRedoing, resultingAlternativeVersionId, resultingSelection) {
        try {
            this._onDidChangeDecorations.beginDeferredEmit();
            this._eventEmitter.beginDeferredEmit();
            this._isUndoing = isUndoing;
            this._isRedoing = isRedoing;
            this.applyEdits(edits, false);
            this.setEOL(eol);
            this._overwriteAlternativeVersionId(resultingAlternativeVersionId);
        } finally{
            this._isUndoing = false;
            this._isRedoing = false;
            this._eventEmitter.endDeferredEmit(resultingSelection);
            this._onDidChangeDecorations.endDeferredEmit();
        }
    }
    applyEdits(rawOperations, computeUndoEdits = false) {
        try {
            this._onDidChangeDecorations.beginDeferredEmit();
            this._eventEmitter.beginDeferredEmit();
            const operations = this._validateEditOperations(rawOperations);
            return this._doApplyEdits(operations, computeUndoEdits);
        } finally{
            this._eventEmitter.endDeferredEmit();
            this._onDidChangeDecorations.endDeferredEmit();
        }
    }
    _doApplyEdits(rawOperations, computeUndoEdits) {
        const oldLineCount = this._buffer.getLineCount();
        const result = this._buffer.applyEdits(rawOperations, this._options.trimAutoWhitespace, computeUndoEdits);
        const newLineCount = this._buffer.getLineCount();
        const contentChanges = result.changes;
        this._trimAutoWhitespaceLines = result.trimAutoWhitespaceLineNumbers;
        if (contentChanges.length !== 0) {
            // We do a first pass to update decorations
            // because we want to read decorations in the second pass
            // where we will emit content change events
            // and we want to read the final decorations
            for(let i = 0, len = contentChanges.length; i < len; i++){
                const change = contentChanges[i];
                this._decorationsTree.acceptReplace(change.rangeOffset, change.rangeLength, change.text.length, change.forceMoveMarkers);
            }
            const rawContentChanges = [];
            this._increaseVersionId();
            let lineCount = oldLineCount;
            for(let i = 0, len = contentChanges.length; i < len; i++){
                const change = contentChanges[i];
                const [eolCount] = (0, _eolCounterJs.countEOL)(change.text);
                this._onDidChangeDecorations.fire();
                const startLineNumber = change.range.startLineNumber;
                const endLineNumber = change.range.endLineNumber;
                const deletingLinesCnt = endLineNumber - startLineNumber;
                const insertingLinesCnt = eolCount;
                const editingLinesCnt = Math.min(deletingLinesCnt, insertingLinesCnt);
                const changeLineCountDelta = insertingLinesCnt - deletingLinesCnt;
                const currentEditStartLineNumber = newLineCount - lineCount - changeLineCountDelta + startLineNumber;
                const firstEditLineNumber = currentEditStartLineNumber;
                const lastInsertedLineNumber = currentEditStartLineNumber + insertingLinesCnt;
                const decorationsWithInjectedTextInEditedRange = this._decorationsTree.getInjectedTextInInterval(this, this.getOffsetAt(new (0, _positionJs.Position)(firstEditLineNumber, 1)), this.getOffsetAt(new (0, _positionJs.Position)(lastInsertedLineNumber, this.getLineMaxColumn(lastInsertedLineNumber))), 0);
                const injectedTextInEditedRange = (0, _textModelEventsJs.LineInjectedText).fromDecorations(decorationsWithInjectedTextInEditedRange);
                const injectedTextInEditedRangeQueue = new (0, _arraysJs.ArrayQueue)(injectedTextInEditedRange);
                for(let j = editingLinesCnt; j >= 0; j--){
                    const editLineNumber = startLineNumber + j;
                    const currentEditLineNumber = currentEditStartLineNumber + j;
                    injectedTextInEditedRangeQueue.takeFromEndWhile((r)=>r.lineNumber > currentEditLineNumber);
                    const decorationsInCurrentLine = injectedTextInEditedRangeQueue.takeFromEndWhile((r)=>r.lineNumber === currentEditLineNumber);
                    rawContentChanges.push(new (0, _textModelEventsJs.ModelRawLineChanged)(editLineNumber, this.getLineContent(currentEditLineNumber), decorationsInCurrentLine));
                }
                if (editingLinesCnt < deletingLinesCnt) {
                    // Must delete some lines
                    const spliceStartLineNumber = startLineNumber + editingLinesCnt;
                    rawContentChanges.push(new (0, _textModelEventsJs.ModelRawLinesDeleted)(spliceStartLineNumber + 1, endLineNumber));
                }
                if (editingLinesCnt < insertingLinesCnt) {
                    const injectedTextInEditedRangeQueue = new (0, _arraysJs.ArrayQueue)(injectedTextInEditedRange);
                    // Must insert some lines
                    const spliceLineNumber = startLineNumber + editingLinesCnt;
                    const cnt = insertingLinesCnt - editingLinesCnt;
                    const fromLineNumber = newLineCount - lineCount - cnt + spliceLineNumber + 1;
                    const injectedTexts = [];
                    const newLines = [];
                    for(let i = 0; i < cnt; i++){
                        const lineNumber = fromLineNumber + i;
                        newLines[i] = this.getLineContent(lineNumber);
                        injectedTextInEditedRangeQueue.takeWhile((r)=>r.lineNumber < lineNumber);
                        injectedTexts[i] = injectedTextInEditedRangeQueue.takeWhile((r)=>r.lineNumber === lineNumber);
                    }
                    rawContentChanges.push(new (0, _textModelEventsJs.ModelRawLinesInserted)(spliceLineNumber + 1, startLineNumber + insertingLinesCnt, newLines, injectedTexts));
                }
                lineCount += changeLineCountDelta;
            }
            this._emitContentChangedEvent(new (0, _textModelEventsJs.ModelRawContentChangedEvent)(rawContentChanges, this.getVersionId(), this._isUndoing, this._isRedoing), {
                changes: contentChanges,
                eol: this._buffer.getEOL(),
                isEolChange: false,
                versionId: this.getVersionId(),
                isUndoing: this._isUndoing,
                isRedoing: this._isRedoing,
                isFlush: false
            });
        }
        return result.reverseEdits === null ? undefined : result.reverseEdits;
    }
    undo() {
        return this._undoRedoService.undo(this.uri);
    }
    canUndo() {
        return this._undoRedoService.canUndo(this.uri);
    }
    redo() {
        return this._undoRedoService.redo(this.uri);
    }
    canRedo() {
        return this._undoRedoService.canRedo(this.uri);
    }
    //#endregion
    //#region Decorations
    handleBeforeFireDecorationsChangedEvent(affectedInjectedTextLines) {
        // This is called before the decoration changed event is fired.
        if (affectedInjectedTextLines === null || affectedInjectedTextLines.size === 0) return;
        const affectedLines = Array.from(affectedInjectedTextLines);
        const lineChangeEvents = affectedLines.map((lineNumber)=>new (0, _textModelEventsJs.ModelRawLineChanged)(lineNumber, this.getLineContent(lineNumber), this._getInjectedTextInLine(lineNumber)));
        this._onDidChangeInjectedText.fire(new (0, _textModelEventsJs.ModelInjectedTextChangedEvent)(lineChangeEvents));
    }
    changeDecorations(callback, ownerId = 0) {
        this._assertNotDisposed();
        try {
            this._onDidChangeDecorations.beginDeferredEmit();
            return this._changeDecorations(ownerId, callback);
        } finally{
            this._onDidChangeDecorations.endDeferredEmit();
        }
    }
    _changeDecorations(ownerId, callback) {
        const changeAccessor = {
            addDecoration: (range, options)=>{
                return this._deltaDecorationsImpl(ownerId, [], [
                    {
                        range: range,
                        options: options
                    }
                ])[0];
            },
            changeDecoration: (id, newRange)=>{
                this._changeDecorationImpl(id, newRange);
            },
            changeDecorationOptions: (id, options)=>{
                this._changeDecorationOptionsImpl(id, _normalizeOptions(options));
            },
            removeDecoration: (id)=>{
                this._deltaDecorationsImpl(ownerId, [
                    id
                ], []);
            },
            deltaDecorations: (oldDecorations, newDecorations)=>{
                if (oldDecorations.length === 0 && newDecorations.length === 0) // nothing to do
                return [];
                return this._deltaDecorationsImpl(ownerId, oldDecorations, newDecorations);
            }
        };
        let result = null;
        try {
            result = callback(changeAccessor);
        } catch (e) {
            (0, _errorsJs.onUnexpectedError)(e);
        }
        // Invalidate change accessor
        changeAccessor.addDecoration = invalidFunc;
        changeAccessor.changeDecoration = invalidFunc;
        changeAccessor.changeDecorationOptions = invalidFunc;
        changeAccessor.removeDecoration = invalidFunc;
        changeAccessor.deltaDecorations = invalidFunc;
        return result;
    }
    deltaDecorations(oldDecorations, newDecorations, ownerId = 0) {
        this._assertNotDisposed();
        if (!oldDecorations) oldDecorations = [];
        if (oldDecorations.length === 0 && newDecorations.length === 0) // nothing to do
        return [];
        try {
            this._deltaDecorationCallCnt++;
            if (this._deltaDecorationCallCnt > 1) {
                console.warn(`Invoking deltaDecorations recursively could lead to leaking decorations.`);
                (0, _errorsJs.onUnexpectedError)(new Error(`Invoking deltaDecorations recursively could lead to leaking decorations.`));
            }
            this._onDidChangeDecorations.beginDeferredEmit();
            return this._deltaDecorationsImpl(ownerId, oldDecorations, newDecorations);
        } finally{
            this._onDidChangeDecorations.endDeferredEmit();
            this._deltaDecorationCallCnt--;
        }
    }
    _getTrackedRange(id) {
        return this.getDecorationRange(id);
    }
    _setTrackedRange(id, newRange, newStickiness) {
        const node = id ? this._decorations[id] : null;
        if (!node) {
            if (!newRange) // node doesn't exist, the request is to delete => nothing to do
            return null;
            // node doesn't exist, the request is to set => add the tracked range
            return this._deltaDecorationsImpl(0, [], [
                {
                    range: newRange,
                    options: TRACKED_RANGE_OPTIONS[newStickiness]
                }
            ], true)[0];
        }
        if (!newRange) {
            // node exists, the request is to delete => delete node
            this._decorationsTree.delete(node);
            delete this._decorations[node.id];
            return null;
        }
        // node exists, the request is to set => change the tracked range and its options
        const range = this._validateRangeRelaxedNoAllocations(newRange);
        const startOffset = this._buffer.getOffsetAt(range.startLineNumber, range.startColumn);
        const endOffset = this._buffer.getOffsetAt(range.endLineNumber, range.endColumn);
        this._decorationsTree.delete(node);
        node.reset(this.getVersionId(), startOffset, endOffset, range);
        node.setOptions(TRACKED_RANGE_OPTIONS[newStickiness]);
        this._decorationsTree.insert(node);
        return node.id;
    }
    removeAllDecorationsWithOwnerId(ownerId) {
        if (this._isDisposed) return;
        const nodes = this._decorationsTree.collectNodesFromOwner(ownerId);
        for(let i = 0, len = nodes.length; i < len; i++){
            const node = nodes[i];
            this._decorationsTree.delete(node);
            delete this._decorations[node.id];
        }
    }
    getDecorationOptions(decorationId) {
        const node = this._decorations[decorationId];
        if (!node) return null;
        return node.options;
    }
    getDecorationRange(decorationId) {
        const node = this._decorations[decorationId];
        if (!node) return null;
        return this._decorationsTree.getNodeRange(this, node);
    }
    getLineDecorations(lineNumber, ownerId = 0, filterOutValidation = false) {
        if (lineNumber < 1 || lineNumber > this.getLineCount()) return [];
        return this.getLinesDecorations(lineNumber, lineNumber, ownerId, filterOutValidation);
    }
    getLinesDecorations(_startLineNumber, _endLineNumber, ownerId = 0, filterOutValidation = false, onlyMarginDecorations = false) {
        const lineCount = this.getLineCount();
        const startLineNumber = Math.min(lineCount, Math.max(1, _startLineNumber));
        const endLineNumber = Math.min(lineCount, Math.max(1, _endLineNumber));
        const endColumn = this.getLineMaxColumn(endLineNumber);
        const range = new (0, _rangeJs.Range)(startLineNumber, 1, endLineNumber, endColumn);
        const decorations = this._getDecorationsInRange(range, ownerId, filterOutValidation, onlyMarginDecorations);
        (0, _arraysJs.pushMany)(decorations, this._decorationProvider.getDecorationsInRange(range, ownerId, filterOutValidation));
        return decorations;
    }
    getDecorationsInRange(range, ownerId = 0, filterOutValidation = false, onlyMinimapDecorations = false, onlyMarginDecorations = false) {
        const validatedRange = this.validateRange(range);
        const decorations = this._getDecorationsInRange(validatedRange, ownerId, filterOutValidation, onlyMarginDecorations);
        (0, _arraysJs.pushMany)(decorations, this._decorationProvider.getDecorationsInRange(validatedRange, ownerId, filterOutValidation, onlyMinimapDecorations));
        return decorations;
    }
    getOverviewRulerDecorations(ownerId = 0, filterOutValidation = false) {
        return this._decorationsTree.getAll(this, ownerId, filterOutValidation, true, false);
    }
    getInjectedTextDecorations(ownerId = 0) {
        return this._decorationsTree.getAllInjectedText(this, ownerId);
    }
    _getInjectedTextInLine(lineNumber) {
        const startOffset = this._buffer.getOffsetAt(lineNumber, 1);
        const endOffset = startOffset + this._buffer.getLineLength(lineNumber);
        const result = this._decorationsTree.getInjectedTextInInterval(this, startOffset, endOffset, 0);
        return (0, _textModelEventsJs.LineInjectedText).fromDecorations(result).filter((t)=>t.lineNumber === lineNumber);
    }
    getAllDecorations(ownerId = 0, filterOutValidation = false) {
        let result = this._decorationsTree.getAll(this, ownerId, filterOutValidation, false, false);
        result = result.concat(this._decorationProvider.getAllDecorations(ownerId, filterOutValidation));
        return result;
    }
    getAllMarginDecorations(ownerId = 0) {
        return this._decorationsTree.getAll(this, ownerId, false, false, true);
    }
    _getDecorationsInRange(filterRange, filterOwnerId, filterOutValidation, onlyMarginDecorations) {
        const startOffset = this._buffer.getOffsetAt(filterRange.startLineNumber, filterRange.startColumn);
        const endOffset = this._buffer.getOffsetAt(filterRange.endLineNumber, filterRange.endColumn);
        return this._decorationsTree.getAllInInterval(this, startOffset, endOffset, filterOwnerId, filterOutValidation, onlyMarginDecorations);
    }
    getRangeAt(start, end) {
        return this._buffer.getRangeAt(start, end - start);
    }
    _changeDecorationImpl(decorationId, _range) {
        const node = this._decorations[decorationId];
        if (!node) return;
        if (node.options.after) {
            const oldRange = this.getDecorationRange(decorationId);
            this._onDidChangeDecorations.recordLineAffectedByInjectedText(oldRange.endLineNumber);
        }
        if (node.options.before) {
            const oldRange = this.getDecorationRange(decorationId);
            this._onDidChangeDecorations.recordLineAffectedByInjectedText(oldRange.startLineNumber);
        }
        const range = this._validateRangeRelaxedNoAllocations(_range);
        const startOffset = this._buffer.getOffsetAt(range.startLineNumber, range.startColumn);
        const endOffset = this._buffer.getOffsetAt(range.endLineNumber, range.endColumn);
        this._decorationsTree.delete(node);
        node.reset(this.getVersionId(), startOffset, endOffset, range);
        this._decorationsTree.insert(node);
        this._onDidChangeDecorations.checkAffectedAndFire(node.options);
        if (node.options.after) this._onDidChangeDecorations.recordLineAffectedByInjectedText(range.endLineNumber);
        if (node.options.before) this._onDidChangeDecorations.recordLineAffectedByInjectedText(range.startLineNumber);
    }
    _changeDecorationOptionsImpl(decorationId, options) {
        const node = this._decorations[decorationId];
        if (!node) return;
        const nodeWasInOverviewRuler = node.options.overviewRuler && node.options.overviewRuler.color ? true : false;
        const nodeIsInOverviewRuler = options.overviewRuler && options.overviewRuler.color ? true : false;
        this._onDidChangeDecorations.checkAffectedAndFire(node.options);
        this._onDidChangeDecorations.checkAffectedAndFire(options);
        if (node.options.after || options.after) {
            const nodeRange = this._decorationsTree.getNodeRange(this, node);
            this._onDidChangeDecorations.recordLineAffectedByInjectedText(nodeRange.endLineNumber);
        }
        if (node.options.before || options.before) {
            const nodeRange = this._decorationsTree.getNodeRange(this, node);
            this._onDidChangeDecorations.recordLineAffectedByInjectedText(nodeRange.startLineNumber);
        }
        const movedInOverviewRuler = nodeWasInOverviewRuler !== nodeIsInOverviewRuler;
        const changedWhetherInjectedText = isOptionsInjectedText(options) !== isNodeInjectedText(node);
        if (movedInOverviewRuler || changedWhetherInjectedText) {
            this._decorationsTree.delete(node);
            node.setOptions(options);
            this._decorationsTree.insert(node);
        } else node.setOptions(options);
    }
    _deltaDecorationsImpl(ownerId, oldDecorationsIds, newDecorations, suppressEvents = false) {
        const versionId = this.getVersionId();
        const oldDecorationsLen = oldDecorationsIds.length;
        let oldDecorationIndex = 0;
        const newDecorationsLen = newDecorations.length;
        let newDecorationIndex = 0;
        this._onDidChangeDecorations.beginDeferredEmit();
        try {
            const result = new Array(newDecorationsLen);
            while(oldDecorationIndex < oldDecorationsLen || newDecorationIndex < newDecorationsLen){
                let node = null;
                if (oldDecorationIndex < oldDecorationsLen) {
                    // (1) get ourselves an old node
                    do node = this._decorations[oldDecorationsIds[oldDecorationIndex++]];
                    while (!node && oldDecorationIndex < oldDecorationsLen);
                    // (2) remove the node from the tree (if it exists)
                    if (node) {
                        if (node.options.after) {
                            const nodeRange = this._decorationsTree.getNodeRange(this, node);
                            this._onDidChangeDecorations.recordLineAffectedByInjectedText(nodeRange.endLineNumber);
                        }
                        if (node.options.before) {
                            const nodeRange = this._decorationsTree.getNodeRange(this, node);
                            this._onDidChangeDecorations.recordLineAffectedByInjectedText(nodeRange.startLineNumber);
                        }
                        this._decorationsTree.delete(node);
                        if (!suppressEvents) this._onDidChangeDecorations.checkAffectedAndFire(node.options);
                    }
                }
                if (newDecorationIndex < newDecorationsLen) {
                    // (3) create a new node if necessary
                    if (!node) {
                        const internalDecorationId = ++this._lastDecorationId;
                        const decorationId = `${this._instanceId};${internalDecorationId}`;
                        node = new (0, _intervalTreeJs.IntervalNode)(decorationId, 0, 0);
                        this._decorations[decorationId] = node;
                    }
                    // (4) initialize node
                    const newDecoration = newDecorations[newDecorationIndex];
                    const range = this._validateRangeRelaxedNoAllocations(newDecoration.range);
                    const options = _normalizeOptions(newDecoration.options);
                    const startOffset = this._buffer.getOffsetAt(range.startLineNumber, range.startColumn);
                    const endOffset = this._buffer.getOffsetAt(range.endLineNumber, range.endColumn);
                    node.ownerId = ownerId;
                    node.reset(versionId, startOffset, endOffset, range);
                    node.setOptions(options);
                    if (node.options.after) this._onDidChangeDecorations.recordLineAffectedByInjectedText(range.endLineNumber);
                    if (node.options.before) this._onDidChangeDecorations.recordLineAffectedByInjectedText(range.startLineNumber);
                    if (!suppressEvents) this._onDidChangeDecorations.checkAffectedAndFire(options);
                    this._decorationsTree.insert(node);
                    result[newDecorationIndex] = node.id;
                    newDecorationIndex++;
                } else if (node) delete this._decorations[node.id];
            }
            return result;
        } finally{
            this._onDidChangeDecorations.endDeferredEmit();
        }
    }
    //#endregion
    //#region Tokenization
    // TODO move them to the tokenization part.
    getLanguageId() {
        return this.tokenization.getLanguageId();
    }
    setLanguage(languageIdOrSelection, source) {
        if (typeof languageIdOrSelection === "string") {
            this._languageSelectionListener.clear();
            this._setLanguage(languageIdOrSelection, source);
        } else {
            this._languageSelectionListener.value = languageIdOrSelection.onDidChange(()=>this._setLanguage(languageIdOrSelection.languageId, source));
            this._setLanguage(languageIdOrSelection.languageId, source);
        }
    }
    _setLanguage(languageId, source) {
        this.tokenization.setLanguageId(languageId, source);
        this._languageService.requestRichLanguageFeatures(languageId);
    }
    getLanguageIdAtPosition(lineNumber, column) {
        return this.tokenization.getLanguageIdAtPosition(lineNumber, column);
    }
    getWordAtPosition(position) {
        return this._tokenizationTextModelPart.getWordAtPosition(position);
    }
    getWordUntilPosition(position) {
        return this._tokenizationTextModelPart.getWordUntilPosition(position);
    }
    //#endregion
    normalizePosition(position, affinity) {
        return position;
    }
    /**
     * Gets the column at which indentation stops at a given line.
     * @internal
    */ getLineIndentColumn(lineNumber) {
        // Columns start with 1.
        return indentOfLine(this.getLineContent(lineNumber)) + 1;
    }
};
TextModel = TextModel_1 = __decorate([
    __param(4, (0, _undoRedoJs.IUndoRedoService)),
    __param(5, (0, _languageJs.ILanguageService)),
    __param(6, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService)),
    __param(7, (0, _instantiationJs.IInstantiationService))
], TextModel);
function indentOfLine(line) {
    let indent = 0;
    for (const c of line){
        if (c === " " || c === "	") indent++;
        else break;
    }
    return indent;
}
//#region Decorations
function isNodeInOverviewRuler(node) {
    return node.options.overviewRuler && node.options.overviewRuler.color ? true : false;
}
function isOptionsInjectedText(options) {
    return !!options.after || !!options.before;
}
function isNodeInjectedText(node) {
    return !!node.options.after || !!node.options.before;
}
class DecorationsTrees {
    constructor(){
        this._decorationsTree0 = new (0, _intervalTreeJs.IntervalTree)();
        this._decorationsTree1 = new (0, _intervalTreeJs.IntervalTree)();
        this._injectedTextDecorationsTree = new (0, _intervalTreeJs.IntervalTree)();
    }
    ensureAllNodesHaveRanges(host) {
        this.getAll(host, 0, false, false, false);
    }
    _ensureNodesHaveRanges(host, nodes) {
        for (const node of nodes)if (node.range === null) node.range = host.getRangeAt(node.cachedAbsoluteStart, node.cachedAbsoluteEnd);
        return nodes;
    }
    getAllInInterval(host, start, end, filterOwnerId, filterOutValidation, onlyMarginDecorations) {
        const versionId = host.getVersionId();
        const result = this._intervalSearch(start, end, filterOwnerId, filterOutValidation, versionId, onlyMarginDecorations);
        return this._ensureNodesHaveRanges(host, result);
    }
    _intervalSearch(start, end, filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations) {
        const r0 = this._decorationsTree0.intervalSearch(start, end, filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations);
        const r1 = this._decorationsTree1.intervalSearch(start, end, filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations);
        const r2 = this._injectedTextDecorationsTree.intervalSearch(start, end, filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations);
        return r0.concat(r1).concat(r2);
    }
    getInjectedTextInInterval(host, start, end, filterOwnerId) {
        const versionId = host.getVersionId();
        const result = this._injectedTextDecorationsTree.intervalSearch(start, end, filterOwnerId, false, versionId, false);
        return this._ensureNodesHaveRanges(host, result).filter((i)=>i.options.showIfCollapsed || !i.range.isEmpty());
    }
    getAllInjectedText(host, filterOwnerId) {
        const versionId = host.getVersionId();
        const result = this._injectedTextDecorationsTree.search(filterOwnerId, false, versionId, false);
        return this._ensureNodesHaveRanges(host, result).filter((i)=>i.options.showIfCollapsed || !i.range.isEmpty());
    }
    getAll(host, filterOwnerId, filterOutValidation, overviewRulerOnly, onlyMarginDecorations) {
        const versionId = host.getVersionId();
        const result = this._search(filterOwnerId, filterOutValidation, overviewRulerOnly, versionId, onlyMarginDecorations);
        return this._ensureNodesHaveRanges(host, result);
    }
    _search(filterOwnerId, filterOutValidation, overviewRulerOnly, cachedVersionId, onlyMarginDecorations) {
        if (overviewRulerOnly) return this._decorationsTree1.search(filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations);
        else {
            const r0 = this._decorationsTree0.search(filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations);
            const r1 = this._decorationsTree1.search(filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations);
            const r2 = this._injectedTextDecorationsTree.search(filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations);
            return r0.concat(r1).concat(r2);
        }
    }
    collectNodesFromOwner(ownerId) {
        const r0 = this._decorationsTree0.collectNodesFromOwner(ownerId);
        const r1 = this._decorationsTree1.collectNodesFromOwner(ownerId);
        const r2 = this._injectedTextDecorationsTree.collectNodesFromOwner(ownerId);
        return r0.concat(r1).concat(r2);
    }
    collectNodesPostOrder() {
        const r0 = this._decorationsTree0.collectNodesPostOrder();
        const r1 = this._decorationsTree1.collectNodesPostOrder();
        const r2 = this._injectedTextDecorationsTree.collectNodesPostOrder();
        return r0.concat(r1).concat(r2);
    }
    insert(node) {
        if (isNodeInjectedText(node)) this._injectedTextDecorationsTree.insert(node);
        else if (isNodeInOverviewRuler(node)) this._decorationsTree1.insert(node);
        else this._decorationsTree0.insert(node);
    }
    delete(node) {
        if (isNodeInjectedText(node)) this._injectedTextDecorationsTree.delete(node);
        else if (isNodeInOverviewRuler(node)) this._decorationsTree1.delete(node);
        else this._decorationsTree0.delete(node);
    }
    getNodeRange(host, node) {
        const versionId = host.getVersionId();
        if (node.cachedVersionId !== versionId) this._resolveNode(node, versionId);
        if (node.range === null) node.range = host.getRangeAt(node.cachedAbsoluteStart, node.cachedAbsoluteEnd);
        return node.range;
    }
    _resolveNode(node, cachedVersionId) {
        if (isNodeInjectedText(node)) this._injectedTextDecorationsTree.resolveNode(node, cachedVersionId);
        else if (isNodeInOverviewRuler(node)) this._decorationsTree1.resolveNode(node, cachedVersionId);
        else this._decorationsTree0.resolveNode(node, cachedVersionId);
    }
    acceptReplace(offset, length, textLength, forceMoveMarkers) {
        this._decorationsTree0.acceptReplace(offset, length, textLength, forceMoveMarkers);
        this._decorationsTree1.acceptReplace(offset, length, textLength, forceMoveMarkers);
        this._injectedTextDecorationsTree.acceptReplace(offset, length, textLength, forceMoveMarkers);
    }
}
function cleanClassName(className) {
    return className.replace(/[^a-z0-9\-_]/gi, " ");
}
class DecorationOptions {
    constructor(options){
        this.color = options.color || "";
        this.darkColor = options.darkColor || "";
    }
}
class ModelDecorationOverviewRulerOptions extends DecorationOptions {
    constructor(options){
        super(options);
        this._resolvedColor = null;
        this.position = typeof options.position === "number" ? options.position : _modelJs.OverviewRulerLane.Center;
    }
    getColor(theme) {
        if (!this._resolvedColor) {
            if (theme.type !== "light" && this.darkColor) this._resolvedColor = this._resolveColor(this.darkColor, theme);
            else this._resolvedColor = this._resolveColor(this.color, theme);
        }
        return this._resolvedColor;
    }
    invalidateCachedColor() {
        this._resolvedColor = null;
    }
    _resolveColor(color, theme) {
        if (typeof color === "string") return color;
        const c = color ? theme.getColor(color.id) : null;
        if (!c) return "";
        return c.toString();
    }
}
class ModelDecorationGlyphMarginOptions {
    constructor(options){
        this.position = options?.position ?? _modelJs.GlyphMarginLane.Center;
        this.persistLane = options?.persistLane;
    }
}
class ModelDecorationMinimapOptions extends DecorationOptions {
    constructor(options){
        super(options);
        this.position = options.position;
        this.sectionHeaderStyle = options.sectionHeaderStyle ?? null;
        this.sectionHeaderText = options.sectionHeaderText ?? null;
    }
    getColor(theme) {
        if (!this._resolvedColor) {
            if (theme.type !== "light" && this.darkColor) this._resolvedColor = this._resolveColor(this.darkColor, theme);
            else this._resolvedColor = this._resolveColor(this.color, theme);
        }
        return this._resolvedColor;
    }
    invalidateCachedColor() {
        this._resolvedColor = undefined;
    }
    _resolveColor(color, theme) {
        if (typeof color === "string") return (0, _colorJs.Color).fromHex(color);
        return theme.getColor(color.id);
    }
}
class ModelDecorationInjectedTextOptions {
    static from(options) {
        if (options instanceof ModelDecorationInjectedTextOptions) return options;
        return new ModelDecorationInjectedTextOptions(options);
    }
    constructor(options){
        this.content = options.content || "";
        this.inlineClassName = options.inlineClassName || null;
        this.inlineClassNameAffectsLetterSpacing = options.inlineClassNameAffectsLetterSpacing || false;
        this.attachedData = options.attachedData || null;
        this.cursorStops = options.cursorStops || null;
    }
}
class ModelDecorationOptions {
    static register(options) {
        return new ModelDecorationOptions(options);
    }
    static createDynamic(options) {
        return new ModelDecorationOptions(options);
    }
    constructor(options){
        this.description = options.description;
        this.blockClassName = options.blockClassName ? cleanClassName(options.blockClassName) : null;
        this.blockDoesNotCollapse = options.blockDoesNotCollapse ?? null;
        this.blockIsAfterEnd = options.blockIsAfterEnd ?? null;
        this.blockPadding = options.blockPadding ?? null;
        this.stickiness = options.stickiness || 0 /* model.TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ;
        this.zIndex = options.zIndex || 0;
        this.className = options.className ? cleanClassName(options.className) : null;
        this.shouldFillLineOnLineBreak = options.shouldFillLineOnLineBreak ?? null;
        this.hoverMessage = options.hoverMessage || null;
        this.glyphMarginHoverMessage = options.glyphMarginHoverMessage || null;
        this.lineNumberHoverMessage = options.lineNumberHoverMessage || null;
        this.isWholeLine = options.isWholeLine || false;
        this.showIfCollapsed = options.showIfCollapsed || false;
        this.collapseOnReplaceEdit = options.collapseOnReplaceEdit || false;
        this.overviewRuler = options.overviewRuler ? new ModelDecorationOverviewRulerOptions(options.overviewRuler) : null;
        this.minimap = options.minimap ? new ModelDecorationMinimapOptions(options.minimap) : null;
        this.glyphMargin = options.glyphMarginClassName ? new ModelDecorationGlyphMarginOptions(options.glyphMargin) : null;
        this.glyphMarginClassName = options.glyphMarginClassName ? cleanClassName(options.glyphMarginClassName) : null;
        this.linesDecorationsClassName = options.linesDecorationsClassName ? cleanClassName(options.linesDecorationsClassName) : null;
        this.lineNumberClassName = options.lineNumberClassName ? cleanClassName(options.lineNumberClassName) : null;
        this.linesDecorationsTooltip = options.linesDecorationsTooltip ? _stringsJs.htmlAttributeEncodeValue(options.linesDecorationsTooltip) : null;
        this.firstLineDecorationClassName = options.firstLineDecorationClassName ? cleanClassName(options.firstLineDecorationClassName) : null;
        this.marginClassName = options.marginClassName ? cleanClassName(options.marginClassName) : null;
        this.inlineClassName = options.inlineClassName ? cleanClassName(options.inlineClassName) : null;
        this.inlineClassNameAffectsLetterSpacing = options.inlineClassNameAffectsLetterSpacing || false;
        this.beforeContentClassName = options.beforeContentClassName ? cleanClassName(options.beforeContentClassName) : null;
        this.afterContentClassName = options.afterContentClassName ? cleanClassName(options.afterContentClassName) : null;
        this.after = options.after ? ModelDecorationInjectedTextOptions.from(options.after) : null;
        this.before = options.before ? ModelDecorationInjectedTextOptions.from(options.before) : null;
        this.hideInCommentTokens = options.hideInCommentTokens ?? false;
        this.hideInStringTokens = options.hideInStringTokens ?? false;
    }
}
ModelDecorationOptions.EMPTY = ModelDecorationOptions.register({
    description: "empty"
});
/**
 * The order carefully matches the values of the enum.
 */ const TRACKED_RANGE_OPTIONS = [
    ModelDecorationOptions.register({
        description: "tracked-range-always-grows-when-typing-at-edges",
        stickiness: 0 /* model.TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ 
    }),
    ModelDecorationOptions.register({
        description: "tracked-range-never-grows-when-typing-at-edges",
        stickiness: 1 /* model.TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ 
    }),
    ModelDecorationOptions.register({
        description: "tracked-range-grows-only-when-typing-before",
        stickiness: 2 /* model.TrackedRangeStickiness.GrowsOnlyWhenTypingBefore */ 
    }),
    ModelDecorationOptions.register({
        description: "tracked-range-grows-only-when-typing-after",
        stickiness: 3 /* model.TrackedRangeStickiness.GrowsOnlyWhenTypingAfter */ 
    })
];
function _normalizeOptions(options) {
    if (options instanceof ModelDecorationOptions) return options;
    return ModelDecorationOptions.createDynamic(options);
}
class DidChangeDecorationsEmitter extends (0, _lifecycleJs.Disposable) {
    constructor(handleBeforeFire){
        super();
        this.handleBeforeFire = handleBeforeFire;
        this._actual = this._register(new (0, _eventJs.Emitter)());
        this.event = this._actual.event;
        this._affectedInjectedTextLines = null;
        this._deferredCnt = 0;
        this._shouldFireDeferred = false;
        this._affectsMinimap = false;
        this._affectsOverviewRuler = false;
        this._affectsGlyphMargin = false;
        this._affectsLineNumber = false;
    }
    beginDeferredEmit() {
        this._deferredCnt++;
    }
    endDeferredEmit() {
        this._deferredCnt--;
        if (this._deferredCnt === 0) {
            if (this._shouldFireDeferred) this.doFire();
            this._affectedInjectedTextLines?.clear();
            this._affectedInjectedTextLines = null;
        }
    }
    recordLineAffectedByInjectedText(lineNumber) {
        if (!this._affectedInjectedTextLines) this._affectedInjectedTextLines = new Set();
        this._affectedInjectedTextLines.add(lineNumber);
    }
    checkAffectedAndFire(options) {
        this._affectsMinimap ||= !!options.minimap?.position;
        this._affectsOverviewRuler ||= !!options.overviewRuler?.color;
        this._affectsGlyphMargin ||= !!options.glyphMarginClassName;
        this._affectsLineNumber ||= !!options.lineNumberClassName;
        this.tryFire();
    }
    fire() {
        this._affectsMinimap = true;
        this._affectsOverviewRuler = true;
        this._affectsGlyphMargin = true;
        this.tryFire();
    }
    tryFire() {
        if (this._deferredCnt === 0) this.doFire();
        else this._shouldFireDeferred = true;
    }
    doFire() {
        this.handleBeforeFire(this._affectedInjectedTextLines);
        const event = {
            affectsMinimap: this._affectsMinimap,
            affectsOverviewRuler: this._affectsOverviewRuler,
            affectsGlyphMargin: this._affectsGlyphMargin,
            affectsLineNumber: this._affectsLineNumber
        };
        this._shouldFireDeferred = false;
        this._affectsMinimap = false;
        this._affectsOverviewRuler = false;
        this._affectsGlyphMargin = false;
        this._actual.fire(event);
    }
}
//#endregion
class DidChangeContentEmitter extends (0, _lifecycleJs.Disposable) {
    constructor(){
        super();
        /**
         * Both `fastEvent` and `slowEvent` work the same way and contain the same events, but first we invoke `fastEvent` and then `slowEvent`.
         */ this._fastEmitter = this._register(new (0, _eventJs.Emitter)());
        this.fastEvent = this._fastEmitter.event;
        this._slowEmitter = this._register(new (0, _eventJs.Emitter)());
        this.slowEvent = this._slowEmitter.event;
        this._deferredCnt = 0;
        this._deferredEvent = null;
    }
    beginDeferredEmit() {
        this._deferredCnt++;
    }
    endDeferredEmit(resultingSelection = null) {
        this._deferredCnt--;
        if (this._deferredCnt === 0) {
            if (this._deferredEvent !== null) {
                this._deferredEvent.rawContentChangedEvent.resultingSelection = resultingSelection;
                const e = this._deferredEvent;
                this._deferredEvent = null;
                this._fastEmitter.fire(e);
                this._slowEmitter.fire(e);
            }
        }
    }
    fire(e) {
        if (this._deferredCnt > 0) {
            if (this._deferredEvent) this._deferredEvent = this._deferredEvent.merge(e);
            else this._deferredEvent = e;
            return;
        }
        this._fastEmitter.fire(e);
        this._slowEmitter.fire(e);
    }
}

},{"../../../base/common/arrays.js":"DECei","../../../base/common/color.js":"at4gb","../../../base/common/errors.js":"divX8","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/strings.js":"aA9I1","../../../base/common/uri.js":"7qGS3","../core/eolCounter.js":"4i42Y","../core/indentation.js":"7FtDC","../core/position.js":"lvrPe","../core/range.js":"jmUPh","../core/selection.js":"kcwzU","../core/textModelDefaults.js":"esbOV","../languages/language.js":"ka2JQ","../languages/languageConfigurationRegistry.js":"2Lk9v","../model.js":"1CSIB","./bracketPairsTextModelPart/bracketPairsImpl.js":"j3xXT","./bracketPairsTextModelPart/colorizedBracketPairsDecorationProvider.js":"hZpLU","./editStack.js":"iS9MJ","./guidesTextModelPart.js":"k7k2K","./indentationGuesser.js":"1Fgj5","./intervalTree.js":"bGmRA","./pieceTreeTextBuffer/pieceTreeTextBuffer.js":"fhukT","./pieceTreeTextBuffer/pieceTreeTextBufferBuilder.js":"2qgIn","./textModelSearch.js":"N1WkK","./tokenizationTextModelPart.js":"j42xY","./tokens.js":"gi3Tb","../textModelEvents.js":"90evO","../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../platform/undoRedo/common/undoRedo.js":"cXL0O","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7FtDC":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeIndentation", ()=>normalizeIndentation);
var _stringsJs = require("../../../base/common/strings.js");
var _cursorColumnsJs = require("./cursorColumns.js");
function _normalizeIndentationFromWhitespace(str, indentSize, insertSpaces) {
    let spacesCnt = 0;
    for(let i = 0; i < str.length; i++)if (str.charAt(i) === "	") spacesCnt = (0, _cursorColumnsJs.CursorColumns).nextIndentTabStop(spacesCnt, indentSize);
    else spacesCnt++;
    let result = "";
    if (!insertSpaces) {
        const tabsCnt = Math.floor(spacesCnt / indentSize);
        spacesCnt = spacesCnt % indentSize;
        for(let i = 0; i < tabsCnt; i++)result += "	";
    }
    for(let i = 0; i < spacesCnt; i++)result += " ";
    return result;
}
function normalizeIndentation(str, indentSize, insertSpaces) {
    let firstNonWhitespaceIndex = _stringsJs.firstNonWhitespaceIndex(str);
    if (firstNonWhitespaceIndex === -1) firstNonWhitespaceIndex = str.length;
    return _normalizeIndentationFromWhitespace(str.substring(0, firstNonWhitespaceIndex), indentSize, insertSpaces) + str.substring(firstNonWhitespaceIndex);
}

},{"../../../base/common/strings.js":"aA9I1","./cursorColumns.js":"idX7D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"idX7D":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A column in a position is the gap between two adjacent characters. The methods here
 * work with a concept called "visible column". A visible column is a very rough approximation
 * of the horizontal screen position of a column. For example, using a tab size of 4:
 * ```txt
 * |<TAB>|<TAB>|T|ext
 * |     |     | \---- column = 4, visible column = 9
 * |     |     \------ column = 3, visible column = 8
 * |     \------------ column = 2, visible column = 4
 * \------------------ column = 1, visible column = 0
 * ```
 *
 * **NOTE**: Visual columns do not work well for RTL text or variable-width fonts or characters.
 *
 * **NOTE**: These methods work and make sense both on the model and on the view model.
 */ parcelHelpers.export(exports, "CursorColumns", ()=>CursorColumns);
var _stringsJs = require("../../../base/common/strings.js");
class CursorColumns {
    static _nextVisibleColumn(codePoint, visibleColumn, tabSize) {
        if (codePoint === 9 /* CharCode.Tab */ ) return CursorColumns.nextRenderTabStop(visibleColumn, tabSize);
        if (_stringsJs.isFullWidthCharacter(codePoint) || _stringsJs.isEmojiImprecise(codePoint)) return visibleColumn + 2;
        return visibleColumn + 1;
    }
    /**
     * Returns a visible column from a column.
     * @see {@link CursorColumns}
     */ static visibleColumnFromColumn(lineContent, column, tabSize) {
        const textLen = Math.min(column - 1, lineContent.length);
        const text = lineContent.substring(0, textLen);
        const iterator = new _stringsJs.GraphemeIterator(text);
        let result = 0;
        while(!iterator.eol()){
            const codePoint = _stringsJs.getNextCodePoint(text, textLen, iterator.offset);
            iterator.nextGraphemeLength();
            result = this._nextVisibleColumn(codePoint, result, tabSize);
        }
        return result;
    }
    /**
     * Returns a column from a visible column.
     * @see {@link CursorColumns}
     */ static columnFromVisibleColumn(lineContent, visibleColumn, tabSize) {
        if (visibleColumn <= 0) return 1;
        const lineContentLength = lineContent.length;
        const iterator = new _stringsJs.GraphemeIterator(lineContent);
        let beforeVisibleColumn = 0;
        let beforeColumn = 1;
        while(!iterator.eol()){
            const codePoint = _stringsJs.getNextCodePoint(lineContent, lineContentLength, iterator.offset);
            iterator.nextGraphemeLength();
            const afterVisibleColumn = this._nextVisibleColumn(codePoint, beforeVisibleColumn, tabSize);
            const afterColumn = iterator.offset + 1;
            if (afterVisibleColumn >= visibleColumn) {
                const beforeDelta = visibleColumn - beforeVisibleColumn;
                const afterDelta = afterVisibleColumn - visibleColumn;
                if (afterDelta < beforeDelta) return afterColumn;
                else return beforeColumn;
            }
            beforeVisibleColumn = afterVisibleColumn;
            beforeColumn = afterColumn;
        }
        // walked the entire string
        return lineContentLength + 1;
    }
    /**
     * ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
     * @see {@link CursorColumns}
     */ static nextRenderTabStop(visibleColumn, tabSize) {
        return visibleColumn + tabSize - visibleColumn % tabSize;
    }
    /**
     * ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
     * @see {@link CursorColumns}
     */ static nextIndentTabStop(visibleColumn, indentSize) {
        return visibleColumn + indentSize - visibleColumn % indentSize;
    }
    /**
     * ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
     * @see {@link CursorColumns}
     */ static prevRenderTabStop(column, tabSize) {
        return Math.max(0, column - 1 - (column - 1) % tabSize);
    }
    /**
     * ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
     * @see {@link CursorColumns}
     */ static prevIndentTabStop(column, indentSize) {
        return Math.max(0, column - 1 - (column - 1) % indentSize);
    }
}

},{"../../../base/common/strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j3xXT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BracketPairsTextModelPart", ()=>BracketPairsTextModelPart);
var _arraysJs = require("../../../../base/common/arrays.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _rangeJs = require("../../core/range.js");
var _supportsJs = require("../../languages/supports.js");
var _richEditBracketsJs = require("../../languages/supports/richEditBrackets.js");
var _bracketPairsTreeJs = require("./bracketPairsTree/bracketPairsTree.js");
class BracketPairsTextModelPart extends (0, _lifecycleJs.Disposable) {
    get canBuildAST() {
        const maxSupportedDocumentLength = /* max lines */ 5000000;
        return this.textModel.getValueLength() <= maxSupportedDocumentLength;
    }
    constructor(textModel, languageConfigurationService){
        super();
        this.textModel = textModel;
        this.languageConfigurationService = languageConfigurationService;
        this.bracketPairsTree = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this.onDidChangeEmitter = new (0, _eventJs.Emitter)();
        this.onDidChange = this.onDidChangeEmitter.event;
        this.bracketsRequested = false;
    }
    //#region TextModel events
    handleLanguageConfigurationServiceChange(e) {
        if (!e.languageId || this.bracketPairsTree.value?.object.didLanguageChange(e.languageId)) {
            this.bracketPairsTree.clear();
            this.updateBracketPairsTree();
        }
    }
    handleDidChangeOptions(e) {
        this.bracketPairsTree.clear();
        this.updateBracketPairsTree();
    }
    handleDidChangeLanguage(e) {
        this.bracketPairsTree.clear();
        this.updateBracketPairsTree();
    }
    handleDidChangeContent(change) {
        this.bracketPairsTree.value?.object.handleContentChanged(change);
    }
    handleDidChangeBackgroundTokenizationState() {
        this.bracketPairsTree.value?.object.handleDidChangeBackgroundTokenizationState();
    }
    handleDidChangeTokens(e) {
        this.bracketPairsTree.value?.object.handleDidChangeTokens(e);
    }
    //#endregion
    updateBracketPairsTree() {
        if (this.bracketsRequested && this.canBuildAST) {
            if (!this.bracketPairsTree.value) {
                const store = new (0, _lifecycleJs.DisposableStore)();
                this.bracketPairsTree.value = createDisposableRef(store.add(new (0, _bracketPairsTreeJs.BracketPairsTree)(this.textModel, (languageId)=>{
                    return this.languageConfigurationService.getLanguageConfiguration(languageId);
                })), store);
                store.add(this.bracketPairsTree.value.object.onDidChange((e)=>this.onDidChangeEmitter.fire(e)));
                this.onDidChangeEmitter.fire();
            }
        } else if (this.bracketPairsTree.value) {
            this.bracketPairsTree.clear();
            // Important: Don't call fire if there was no change!
            this.onDidChangeEmitter.fire();
        }
    }
    /**
     * Returns all bracket pairs that intersect the given range.
     * The result is sorted by the start position.
    */ getBracketPairsInRange(range) {
        this.bracketsRequested = true;
        this.updateBracketPairsTree();
        return this.bracketPairsTree.value?.object.getBracketPairsInRange(range, false) || (0, _arraysJs.CallbackIterable).empty;
    }
    getBracketPairsInRangeWithMinIndentation(range) {
        this.bracketsRequested = true;
        this.updateBracketPairsTree();
        return this.bracketPairsTree.value?.object.getBracketPairsInRange(range, true) || (0, _arraysJs.CallbackIterable).empty;
    }
    getBracketsInRange(range, onlyColorizedBrackets = false) {
        this.bracketsRequested = true;
        this.updateBracketPairsTree();
        return this.bracketPairsTree.value?.object.getBracketsInRange(range, onlyColorizedBrackets) || (0, _arraysJs.CallbackIterable).empty;
    }
    findMatchingBracketUp(_bracket, _position, maxDuration) {
        const position = this.textModel.validatePosition(_position);
        const languageId = this.textModel.getLanguageIdAtPosition(position.lineNumber, position.column);
        if (this.canBuildAST) {
            const closingBracketInfo = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew.getClosingBracketInfo(_bracket);
            if (!closingBracketInfo) return null;
            const bracketPair = this.getBracketPairsInRange((0, _rangeJs.Range).fromPositions(_position, _position)).findLast((b)=>closingBracketInfo.closes(b.openingBracketInfo));
            if (bracketPair) return bracketPair.openingBracketRange;
            return null;
        } else {
            // Fallback to old bracket matching code:
            const bracket = _bracket.toLowerCase();
            const bracketsSupport = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
            if (!bracketsSupport) return null;
            const data = bracketsSupport.textIsBracket[bracket];
            if (!data) return null;
            return stripBracketSearchCanceled(this._findMatchingBracketUp(data, position, createTimeBasedContinueBracketSearchPredicate(maxDuration)));
        }
    }
    matchBracket(position, maxDuration) {
        if (this.canBuildAST) {
            const bracketPair = this.getBracketPairsInRange((0, _rangeJs.Range).fromPositions(position, position)).filter((item)=>item.closingBracketRange !== undefined && (item.openingBracketRange.containsPosition(position) || item.closingBracketRange.containsPosition(position))).findLastMaxBy((0, _arraysJs.compareBy)((item)=>item.openingBracketRange.containsPosition(position) ? item.openingBracketRange : item.closingBracketRange, (0, _rangeJs.Range).compareRangesUsingStarts));
            if (bracketPair) return [
                bracketPair.openingBracketRange,
                bracketPair.closingBracketRange
            ];
            return null;
        } else {
            // Fallback to old bracket matching code:
            const continueSearchPredicate = createTimeBasedContinueBracketSearchPredicate(maxDuration);
            return this._matchBracket(this.textModel.validatePosition(position), continueSearchPredicate);
        }
    }
    _establishBracketSearchOffsets(position, lineTokens, modeBrackets, tokenIndex) {
        const tokenCount = lineTokens.getCount();
        const currentLanguageId = lineTokens.getLanguageId(tokenIndex);
        // limit search to not go before `maxBracketLength`
        let searchStartOffset = Math.max(0, position.column - 1 - modeBrackets.maxBracketLength);
        for(let i = tokenIndex - 1; i >= 0; i--){
            const tokenEndOffset = lineTokens.getEndOffset(i);
            if (tokenEndOffset <= searchStartOffset) break;
            if ((0, _supportsJs.ignoreBracketsInToken)(lineTokens.getStandardTokenType(i)) || lineTokens.getLanguageId(i) !== currentLanguageId) {
                searchStartOffset = tokenEndOffset;
                break;
            }
        }
        // limit search to not go after `maxBracketLength`
        let searchEndOffset = Math.min(lineTokens.getLineContent().length, position.column - 1 + modeBrackets.maxBracketLength);
        for(let i = tokenIndex + 1; i < tokenCount; i++){
            const tokenStartOffset = lineTokens.getStartOffset(i);
            if (tokenStartOffset >= searchEndOffset) break;
            if ((0, _supportsJs.ignoreBracketsInToken)(lineTokens.getStandardTokenType(i)) || lineTokens.getLanguageId(i) !== currentLanguageId) {
                searchEndOffset = tokenStartOffset;
                break;
            }
        }
        return {
            searchStartOffset,
            searchEndOffset
        };
    }
    _matchBracket(position, continueSearchPredicate) {
        const lineNumber = position.lineNumber;
        const lineTokens = this.textModel.tokenization.getLineTokens(lineNumber);
        const lineText = this.textModel.getLineContent(lineNumber);
        const tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
        if (tokenIndex < 0) return null;
        const currentModeBrackets = this.languageConfigurationService.getLanguageConfiguration(lineTokens.getLanguageId(tokenIndex)).brackets;
        // check that the token is not to be ignored
        if (currentModeBrackets && !(0, _supportsJs.ignoreBracketsInToken)(lineTokens.getStandardTokenType(tokenIndex))) {
            let { searchStartOffset, searchEndOffset } = this._establishBracketSearchOffsets(position, lineTokens, currentModeBrackets, tokenIndex);
            // it might be the case that [currentTokenStart -> currentTokenEnd] contains multiple brackets
            // `bestResult` will contain the most right-side result
            let bestResult = null;
            while(true){
                const foundBracket = (0, _richEditBracketsJs.BracketsUtils).findNextBracketInRange(currentModeBrackets.forwardRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                if (!foundBracket) break;
                // check that we didn't hit a bracket too far away from position
                if (foundBracket.startColumn <= position.column && position.column <= foundBracket.endColumn) {
                    const foundBracketText = lineText.substring(foundBracket.startColumn - 1, foundBracket.endColumn - 1).toLowerCase();
                    const r = this._matchFoundBracket(foundBracket, currentModeBrackets.textIsBracket[foundBracketText], currentModeBrackets.textIsOpenBracket[foundBracketText], continueSearchPredicate);
                    if (r) {
                        if (r instanceof BracketSearchCanceled) return null;
                        bestResult = r;
                    }
                }
                searchStartOffset = foundBracket.endColumn - 1;
            }
            if (bestResult) return bestResult;
        }
        // If position is in between two tokens, try also looking in the previous token
        if (tokenIndex > 0 && lineTokens.getStartOffset(tokenIndex) === position.column - 1) {
            const prevTokenIndex = tokenIndex - 1;
            const prevModeBrackets = this.languageConfigurationService.getLanguageConfiguration(lineTokens.getLanguageId(prevTokenIndex)).brackets;
            // check that previous token is not to be ignored
            if (prevModeBrackets && !(0, _supportsJs.ignoreBracketsInToken)(lineTokens.getStandardTokenType(prevTokenIndex))) {
                const { searchStartOffset, searchEndOffset } = this._establishBracketSearchOffsets(position, lineTokens, prevModeBrackets, prevTokenIndex);
                const foundBracket = (0, _richEditBracketsJs.BracketsUtils).findPrevBracketInRange(prevModeBrackets.reversedRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                // check that we didn't hit a bracket too far away from position
                if (foundBracket && foundBracket.startColumn <= position.column && position.column <= foundBracket.endColumn) {
                    const foundBracketText = lineText.substring(foundBracket.startColumn - 1, foundBracket.endColumn - 1).toLowerCase();
                    const r = this._matchFoundBracket(foundBracket, prevModeBrackets.textIsBracket[foundBracketText], prevModeBrackets.textIsOpenBracket[foundBracketText], continueSearchPredicate);
                    if (r) {
                        if (r instanceof BracketSearchCanceled) return null;
                        return r;
                    }
                }
            }
        }
        return null;
    }
    _matchFoundBracket(foundBracket, data, isOpen, continueSearchPredicate) {
        if (!data) return null;
        const matched = isOpen ? this._findMatchingBracketDown(data, foundBracket.getEndPosition(), continueSearchPredicate) : this._findMatchingBracketUp(data, foundBracket.getStartPosition(), continueSearchPredicate);
        if (!matched) return null;
        if (matched instanceof BracketSearchCanceled) return matched;
        return [
            foundBracket,
            matched
        ];
    }
    _findMatchingBracketUp(bracket, position, continueSearchPredicate) {
        // console.log('_findMatchingBracketUp: ', 'bracket: ', JSON.stringify(bracket), 'startPosition: ', String(position));
        const languageId = bracket.languageId;
        const reversedBracketRegex = bracket.reversedRegex;
        let count = -1;
        let totalCallCount = 0;
        const searchPrevMatchingBracketInRange = (lineNumber, lineText, searchStartOffset, searchEndOffset)=>{
            while(true){
                if (continueSearchPredicate && ++totalCallCount % 100 === 0 && !continueSearchPredicate()) return BracketSearchCanceled.INSTANCE;
                const r = (0, _richEditBracketsJs.BracketsUtils).findPrevBracketInRange(reversedBracketRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                if (!r) break;
                const hitText = lineText.substring(r.startColumn - 1, r.endColumn - 1).toLowerCase();
                if (bracket.isOpen(hitText)) count++;
                else if (bracket.isClose(hitText)) count--;
                if (count === 0) return r;
                searchEndOffset = r.startColumn - 1;
            }
            return null;
        };
        for(let lineNumber = position.lineNumber; lineNumber >= 1; lineNumber--){
            const lineTokens = this.textModel.tokenization.getLineTokens(lineNumber);
            const tokenCount = lineTokens.getCount();
            const lineText = this.textModel.getLineContent(lineNumber);
            let tokenIndex = tokenCount - 1;
            let searchStartOffset = lineText.length;
            let searchEndOffset = lineText.length;
            if (lineNumber === position.lineNumber) {
                tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
                searchStartOffset = position.column - 1;
                searchEndOffset = position.column - 1;
            }
            let prevSearchInToken = true;
            for(; tokenIndex >= 0; tokenIndex--){
                const searchInToken = lineTokens.getLanguageId(tokenIndex) === languageId && !(0, _supportsJs.ignoreBracketsInToken)(lineTokens.getStandardTokenType(tokenIndex));
                if (searchInToken) {
                    // this token should be searched
                    if (prevSearchInToken) // the previous token should be searched, simply extend searchStartOffset
                    searchStartOffset = lineTokens.getStartOffset(tokenIndex);
                    else {
                        // the previous token should not be searched
                        searchStartOffset = lineTokens.getStartOffset(tokenIndex);
                        searchEndOffset = lineTokens.getEndOffset(tokenIndex);
                    }
                } else // this token should not be searched
                if (prevSearchInToken && searchStartOffset !== searchEndOffset) {
                    const r = searchPrevMatchingBracketInRange(lineNumber, lineText, searchStartOffset, searchEndOffset);
                    if (r) return r;
                }
                prevSearchInToken = searchInToken;
            }
            if (prevSearchInToken && searchStartOffset !== searchEndOffset) {
                const r = searchPrevMatchingBracketInRange(lineNumber, lineText, searchStartOffset, searchEndOffset);
                if (r) return r;
            }
        }
        return null;
    }
    _findMatchingBracketDown(bracket, position, continueSearchPredicate) {
        // console.log('_findMatchingBracketDown: ', 'bracket: ', JSON.stringify(bracket), 'startPosition: ', String(position));
        const languageId = bracket.languageId;
        const bracketRegex = bracket.forwardRegex;
        let count = 1;
        let totalCallCount = 0;
        const searchNextMatchingBracketInRange = (lineNumber, lineText, searchStartOffset, searchEndOffset)=>{
            while(true){
                if (continueSearchPredicate && ++totalCallCount % 100 === 0 && !continueSearchPredicate()) return BracketSearchCanceled.INSTANCE;
                const r = (0, _richEditBracketsJs.BracketsUtils).findNextBracketInRange(bracketRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                if (!r) break;
                const hitText = lineText.substring(r.startColumn - 1, r.endColumn - 1).toLowerCase();
                if (bracket.isOpen(hitText)) count++;
                else if (bracket.isClose(hitText)) count--;
                if (count === 0) return r;
                searchStartOffset = r.endColumn - 1;
            }
            return null;
        };
        const lineCount = this.textModel.getLineCount();
        for(let lineNumber = position.lineNumber; lineNumber <= lineCount; lineNumber++){
            const lineTokens = this.textModel.tokenization.getLineTokens(lineNumber);
            const tokenCount = lineTokens.getCount();
            const lineText = this.textModel.getLineContent(lineNumber);
            let tokenIndex = 0;
            let searchStartOffset = 0;
            let searchEndOffset = 0;
            if (lineNumber === position.lineNumber) {
                tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
                searchStartOffset = position.column - 1;
                searchEndOffset = position.column - 1;
            }
            let prevSearchInToken = true;
            for(; tokenIndex < tokenCount; tokenIndex++){
                const searchInToken = lineTokens.getLanguageId(tokenIndex) === languageId && !(0, _supportsJs.ignoreBracketsInToken)(lineTokens.getStandardTokenType(tokenIndex));
                if (searchInToken) {
                    // this token should be searched
                    if (prevSearchInToken) // the previous token should be searched, simply extend searchEndOffset
                    searchEndOffset = lineTokens.getEndOffset(tokenIndex);
                    else {
                        // the previous token should not be searched
                        searchStartOffset = lineTokens.getStartOffset(tokenIndex);
                        searchEndOffset = lineTokens.getEndOffset(tokenIndex);
                    }
                } else // this token should not be searched
                if (prevSearchInToken && searchStartOffset !== searchEndOffset) {
                    const r = searchNextMatchingBracketInRange(lineNumber, lineText, searchStartOffset, searchEndOffset);
                    if (r) return r;
                }
                prevSearchInToken = searchInToken;
            }
            if (prevSearchInToken && searchStartOffset !== searchEndOffset) {
                const r = searchNextMatchingBracketInRange(lineNumber, lineText, searchStartOffset, searchEndOffset);
                if (r) return r;
            }
        }
        return null;
    }
    findPrevBracket(_position) {
        const position = this.textModel.validatePosition(_position);
        if (this.canBuildAST) {
            this.bracketsRequested = true;
            this.updateBracketPairsTree();
            return this.bracketPairsTree.value?.object.getFirstBracketBefore(position) || null;
        }
        let languageId = null;
        let modeBrackets = null;
        let bracketConfig = null;
        for(let lineNumber = position.lineNumber; lineNumber >= 1; lineNumber--){
            const lineTokens = this.textModel.tokenization.getLineTokens(lineNumber);
            const tokenCount = lineTokens.getCount();
            const lineText = this.textModel.getLineContent(lineNumber);
            let tokenIndex = tokenCount - 1;
            let searchStartOffset = lineText.length;
            let searchEndOffset = lineText.length;
            if (lineNumber === position.lineNumber) {
                tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
                searchStartOffset = position.column - 1;
                searchEndOffset = position.column - 1;
                const tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
                if (languageId !== tokenLanguageId) {
                    languageId = tokenLanguageId;
                    modeBrackets = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
                    bracketConfig = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew;
                }
            }
            let prevSearchInToken = true;
            for(; tokenIndex >= 0; tokenIndex--){
                const tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
                if (languageId !== tokenLanguageId) {
                    // language id change!
                    if (modeBrackets && bracketConfig && prevSearchInToken && searchStartOffset !== searchEndOffset) {
                        const r = (0, _richEditBracketsJs.BracketsUtils).findPrevBracketInRange(modeBrackets.reversedRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                        if (r) return this._toFoundBracket(bracketConfig, r);
                        prevSearchInToken = false;
                    }
                    languageId = tokenLanguageId;
                    modeBrackets = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
                    bracketConfig = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew;
                }
                const searchInToken = !!modeBrackets && !(0, _supportsJs.ignoreBracketsInToken)(lineTokens.getStandardTokenType(tokenIndex));
                if (searchInToken) {
                    // this token should be searched
                    if (prevSearchInToken) // the previous token should be searched, simply extend searchStartOffset
                    searchStartOffset = lineTokens.getStartOffset(tokenIndex);
                    else {
                        // the previous token should not be searched
                        searchStartOffset = lineTokens.getStartOffset(tokenIndex);
                        searchEndOffset = lineTokens.getEndOffset(tokenIndex);
                    }
                } else // this token should not be searched
                if (bracketConfig && modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
                    const r = (0, _richEditBracketsJs.BracketsUtils).findPrevBracketInRange(modeBrackets.reversedRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                    if (r) return this._toFoundBracket(bracketConfig, r);
                }
                prevSearchInToken = searchInToken;
            }
            if (bracketConfig && modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
                const r = (0, _richEditBracketsJs.BracketsUtils).findPrevBracketInRange(modeBrackets.reversedRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                if (r) return this._toFoundBracket(bracketConfig, r);
            }
        }
        return null;
    }
    findNextBracket(_position) {
        const position = this.textModel.validatePosition(_position);
        if (this.canBuildAST) {
            this.bracketsRequested = true;
            this.updateBracketPairsTree();
            return this.bracketPairsTree.value?.object.getFirstBracketAfter(position) || null;
        }
        const lineCount = this.textModel.getLineCount();
        let languageId = null;
        let modeBrackets = null;
        let bracketConfig = null;
        for(let lineNumber = position.lineNumber; lineNumber <= lineCount; lineNumber++){
            const lineTokens = this.textModel.tokenization.getLineTokens(lineNumber);
            const tokenCount = lineTokens.getCount();
            const lineText = this.textModel.getLineContent(lineNumber);
            let tokenIndex = 0;
            let searchStartOffset = 0;
            let searchEndOffset = 0;
            if (lineNumber === position.lineNumber) {
                tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
                searchStartOffset = position.column - 1;
                searchEndOffset = position.column - 1;
                const tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
                if (languageId !== tokenLanguageId) {
                    languageId = tokenLanguageId;
                    modeBrackets = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
                    bracketConfig = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew;
                }
            }
            let prevSearchInToken = true;
            for(; tokenIndex < tokenCount; tokenIndex++){
                const tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
                if (languageId !== tokenLanguageId) {
                    // language id change!
                    if (bracketConfig && modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
                        const r = (0, _richEditBracketsJs.BracketsUtils).findNextBracketInRange(modeBrackets.forwardRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                        if (r) return this._toFoundBracket(bracketConfig, r);
                        prevSearchInToken = false;
                    }
                    languageId = tokenLanguageId;
                    modeBrackets = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
                    bracketConfig = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew;
                }
                const searchInToken = !!modeBrackets && !(0, _supportsJs.ignoreBracketsInToken)(lineTokens.getStandardTokenType(tokenIndex));
                if (searchInToken) {
                    // this token should be searched
                    if (prevSearchInToken) // the previous token should be searched, simply extend searchEndOffset
                    searchEndOffset = lineTokens.getEndOffset(tokenIndex);
                    else {
                        // the previous token should not be searched
                        searchStartOffset = lineTokens.getStartOffset(tokenIndex);
                        searchEndOffset = lineTokens.getEndOffset(tokenIndex);
                    }
                } else // this token should not be searched
                if (bracketConfig && modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
                    const r = (0, _richEditBracketsJs.BracketsUtils).findNextBracketInRange(modeBrackets.forwardRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                    if (r) return this._toFoundBracket(bracketConfig, r);
                }
                prevSearchInToken = searchInToken;
            }
            if (bracketConfig && modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
                const r = (0, _richEditBracketsJs.BracketsUtils).findNextBracketInRange(modeBrackets.forwardRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                if (r) return this._toFoundBracket(bracketConfig, r);
            }
        }
        return null;
    }
    findEnclosingBrackets(_position, maxDuration) {
        const position = this.textModel.validatePosition(_position);
        if (this.canBuildAST) {
            const range = (0, _rangeJs.Range).fromPositions(position);
            const bracketPair = this.getBracketPairsInRange((0, _rangeJs.Range).fromPositions(position, position)).findLast((item)=>item.closingBracketRange !== undefined && item.range.strictContainsRange(range));
            if (bracketPair) return [
                bracketPair.openingBracketRange,
                bracketPair.closingBracketRange
            ];
            return null;
        }
        const continueSearchPredicate = createTimeBasedContinueBracketSearchPredicate(maxDuration);
        const lineCount = this.textModel.getLineCount();
        const savedCounts = new Map();
        let counts = [];
        const resetCounts = (languageId, modeBrackets)=>{
            if (!savedCounts.has(languageId)) {
                const tmp = [];
                for(let i = 0, len = modeBrackets ? modeBrackets.brackets.length : 0; i < len; i++)tmp[i] = 0;
                savedCounts.set(languageId, tmp);
            }
            counts = savedCounts.get(languageId);
        };
        let totalCallCount = 0;
        const searchInRange = (modeBrackets, lineNumber, lineText, searchStartOffset, searchEndOffset)=>{
            while(true){
                if (continueSearchPredicate && ++totalCallCount % 100 === 0 && !continueSearchPredicate()) return BracketSearchCanceled.INSTANCE;
                const r = (0, _richEditBracketsJs.BracketsUtils).findNextBracketInRange(modeBrackets.forwardRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
                if (!r) break;
                const hitText = lineText.substring(r.startColumn - 1, r.endColumn - 1).toLowerCase();
                const bracket = modeBrackets.textIsBracket[hitText];
                if (bracket) {
                    if (bracket.isOpen(hitText)) counts[bracket.index]++;
                    else if (bracket.isClose(hitText)) counts[bracket.index]--;
                    if (counts[bracket.index] === -1) return this._matchFoundBracket(r, bracket, false, continueSearchPredicate);
                }
                searchStartOffset = r.endColumn - 1;
            }
            return null;
        };
        let languageId = null;
        let modeBrackets = null;
        for(let lineNumber = position.lineNumber; lineNumber <= lineCount; lineNumber++){
            const lineTokens = this.textModel.tokenization.getLineTokens(lineNumber);
            const tokenCount = lineTokens.getCount();
            const lineText = this.textModel.getLineContent(lineNumber);
            let tokenIndex = 0;
            let searchStartOffset = 0;
            let searchEndOffset = 0;
            if (lineNumber === position.lineNumber) {
                tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
                searchStartOffset = position.column - 1;
                searchEndOffset = position.column - 1;
                const tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
                if (languageId !== tokenLanguageId) {
                    languageId = tokenLanguageId;
                    modeBrackets = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
                    resetCounts(languageId, modeBrackets);
                }
            }
            let prevSearchInToken = true;
            for(; tokenIndex < tokenCount; tokenIndex++){
                const tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
                if (languageId !== tokenLanguageId) {
                    // language id change!
                    if (modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
                        const r = searchInRange(modeBrackets, lineNumber, lineText, searchStartOffset, searchEndOffset);
                        if (r) return stripBracketSearchCanceled(r);
                        prevSearchInToken = false;
                    }
                    languageId = tokenLanguageId;
                    modeBrackets = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
                    resetCounts(languageId, modeBrackets);
                }
                const searchInToken = !!modeBrackets && !(0, _supportsJs.ignoreBracketsInToken)(lineTokens.getStandardTokenType(tokenIndex));
                if (searchInToken) {
                    // this token should be searched
                    if (prevSearchInToken) // the previous token should be searched, simply extend searchEndOffset
                    searchEndOffset = lineTokens.getEndOffset(tokenIndex);
                    else {
                        // the previous token should not be searched
                        searchStartOffset = lineTokens.getStartOffset(tokenIndex);
                        searchEndOffset = lineTokens.getEndOffset(tokenIndex);
                    }
                } else // this token should not be searched
                if (modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
                    const r = searchInRange(modeBrackets, lineNumber, lineText, searchStartOffset, searchEndOffset);
                    if (r) return stripBracketSearchCanceled(r);
                }
                prevSearchInToken = searchInToken;
            }
            if (modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
                const r = searchInRange(modeBrackets, lineNumber, lineText, searchStartOffset, searchEndOffset);
                if (r) return stripBracketSearchCanceled(r);
            }
        }
        return null;
    }
    _toFoundBracket(bracketConfig, r) {
        if (!r) return null;
        let text = this.textModel.getValueInRange(r);
        text = text.toLowerCase();
        const bracketInfo = bracketConfig.getBracketInfo(text);
        if (!bracketInfo) return null;
        return {
            range: r,
            bracketInfo
        };
    }
}
function createDisposableRef(object, disposable) {
    return {
        object,
        dispose: ()=>disposable?.dispose()
    };
}
function createTimeBasedContinueBracketSearchPredicate(maxDuration) {
    if (typeof maxDuration === "undefined") return ()=>true;
    else {
        const startTime = Date.now();
        return ()=>{
            return Date.now() - startTime <= maxDuration;
        };
    }
}
class BracketSearchCanceled {
    static{
        this.INSTANCE = new BracketSearchCanceled();
    }
    constructor(){
        this._searchCanceledBrand = undefined;
    }
}
function stripBracketSearchCanceled(result) {
    if (result instanceof BracketSearchCanceled) return null;
    return result;
}

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../core/range.js":"jmUPh","../../languages/supports.js":"aA5lJ","../../languages/supports/richEditBrackets.js":"hHyd8","./bracketPairsTree/bracketPairsTree.js":"d670t","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d670t":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BracketPairsTree", ()=>BracketPairsTree);
var _eventJs = require("../../../../../base/common/event.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _textModelBracketPairsJs = require("../../../textModelBracketPairs.js");
var _beforeEditPositionMapperJs = require("./beforeEditPositionMapper.js");
var _bracketsJs = require("./brackets.js");
var _lengthJs = require("./length.js");
var _parserJs = require("./parser.js");
var _smallImmutableSetJs = require("./smallImmutableSet.js");
var _tokenizerJs = require("./tokenizer.js");
var _arraysJs = require("../../../../../base/common/arrays.js");
var _combineTextEditInfosJs = require("./combineTextEditInfos.js");
class BracketPairsTree extends (0, _lifecycleJs.Disposable) {
    didLanguageChange(languageId) {
        return this.brackets.didLanguageChange(languageId);
    }
    constructor(textModel, getLanguageConfiguration){
        super();
        this.textModel = textModel;
        this.getLanguageConfiguration = getLanguageConfiguration;
        this.didChangeEmitter = new (0, _eventJs.Emitter)();
        this.denseKeyProvider = new (0, _smallImmutableSetJs.DenseKeyProvider)();
        this.brackets = new (0, _bracketsJs.LanguageAgnosticBracketTokens)(this.denseKeyProvider, this.getLanguageConfiguration);
        this.onDidChange = this.didChangeEmitter.event;
        this.queuedTextEditsForInitialAstWithoutTokens = [];
        this.queuedTextEdits = [];
        if (!textModel.tokenization.hasTokens) {
            const brackets = this.brackets.getSingleLanguageBracketTokens(this.textModel.getLanguageId());
            const tokenizer = new (0, _tokenizerJs.FastTokenizer)(this.textModel.getValue(), brackets);
            this.initialAstWithoutTokens = (0, _parserJs.parseDocument)(tokenizer, [], undefined, true);
            this.astWithTokens = this.initialAstWithoutTokens;
        } else if (textModel.tokenization.backgroundTokenizationState === 2 /* BackgroundTokenizationState.Completed */ ) {
            // Skip the initial ast, as there is no flickering.
            // Directly create the tree with token information.
            this.initialAstWithoutTokens = undefined;
            this.astWithTokens = this.parseDocumentFromTextBuffer([], undefined, false);
        } else {
            // We missed some token changes already, so we cannot use the fast tokenizer + delta increments
            this.initialAstWithoutTokens = this.parseDocumentFromTextBuffer([], undefined, true);
            this.astWithTokens = this.initialAstWithoutTokens;
        }
    }
    //#region TextModel events
    handleDidChangeBackgroundTokenizationState() {
        if (this.textModel.tokenization.backgroundTokenizationState === 2 /* BackgroundTokenizationState.Completed */ ) {
            const wasUndefined = this.initialAstWithoutTokens === undefined;
            // Clear the initial tree as we can use the tree with token information now.
            this.initialAstWithoutTokens = undefined;
            if (!wasUndefined) this.didChangeEmitter.fire();
        }
    }
    handleDidChangeTokens({ ranges }) {
        const edits = ranges.map((r)=>new (0, _beforeEditPositionMapperJs.TextEditInfo)((0, _lengthJs.toLength)(r.fromLineNumber - 1, 0), (0, _lengthJs.toLength)(r.toLineNumber, 0), (0, _lengthJs.toLength)(r.toLineNumber - r.fromLineNumber + 1, 0)));
        this.handleEdits(edits, true);
        if (!this.initialAstWithoutTokens) this.didChangeEmitter.fire();
    }
    handleContentChanged(change) {
        const edits = (0, _beforeEditPositionMapperJs.TextEditInfo).fromModelContentChanges(change.changes);
        this.handleEdits(edits, false);
    }
    handleEdits(edits, tokenChange) {
        // Lazily queue the edits and only apply them when the tree is accessed.
        const result = (0, _combineTextEditInfosJs.combineTextEditInfos)(this.queuedTextEdits, edits);
        this.queuedTextEdits = result;
        if (this.initialAstWithoutTokens && !tokenChange) this.queuedTextEditsForInitialAstWithoutTokens = (0, _combineTextEditInfosJs.combineTextEditInfos)(this.queuedTextEditsForInitialAstWithoutTokens, edits);
    }
    //#endregion
    flushQueue() {
        if (this.queuedTextEdits.length > 0) {
            this.astWithTokens = this.parseDocumentFromTextBuffer(this.queuedTextEdits, this.astWithTokens, false);
            this.queuedTextEdits = [];
        }
        if (this.queuedTextEditsForInitialAstWithoutTokens.length > 0) {
            if (this.initialAstWithoutTokens) this.initialAstWithoutTokens = this.parseDocumentFromTextBuffer(this.queuedTextEditsForInitialAstWithoutTokens, this.initialAstWithoutTokens, false);
            this.queuedTextEditsForInitialAstWithoutTokens = [];
        }
    }
    /**
     * @pure (only if isPure = true)
    */ parseDocumentFromTextBuffer(edits, previousAst, immutable) {
        // Is much faster if `isPure = false`.
        const isPure = false;
        const previousAstClone = isPure ? previousAst?.deepClone() : previousAst;
        const tokenizer = new (0, _tokenizerJs.TextBufferTokenizer)(this.textModel, this.brackets);
        const result = (0, _parserJs.parseDocument)(tokenizer, edits, previousAstClone, immutable);
        return result;
    }
    getBracketsInRange(range, onlyColorizedBrackets) {
        this.flushQueue();
        const startOffset = (0, _lengthJs.toLength)(range.startLineNumber - 1, range.startColumn - 1);
        const endOffset = (0, _lengthJs.toLength)(range.endLineNumber - 1, range.endColumn - 1);
        return new (0, _arraysJs.CallbackIterable)((cb)=>{
            const node = this.initialAstWithoutTokens || this.astWithTokens;
            collectBrackets(node, (0, _lengthJs.lengthZero), node.length, startOffset, endOffset, cb, 0, 0, new Map(), onlyColorizedBrackets);
        });
    }
    getBracketPairsInRange(range, includeMinIndentation) {
        this.flushQueue();
        const startLength = (0, _lengthJs.positionToLength)(range.getStartPosition());
        const endLength = (0, _lengthJs.positionToLength)(range.getEndPosition());
        return new (0, _arraysJs.CallbackIterable)((cb)=>{
            const node = this.initialAstWithoutTokens || this.astWithTokens;
            const context = new CollectBracketPairsContext(cb, includeMinIndentation, this.textModel);
            collectBracketPairs(node, (0, _lengthJs.lengthZero), node.length, startLength, endLength, context, 0, new Map());
        });
    }
    getFirstBracketAfter(position) {
        this.flushQueue();
        const node = this.initialAstWithoutTokens || this.astWithTokens;
        return getFirstBracketAfter(node, (0, _lengthJs.lengthZero), node.length, (0, _lengthJs.positionToLength)(position));
    }
    getFirstBracketBefore(position) {
        this.flushQueue();
        const node = this.initialAstWithoutTokens || this.astWithTokens;
        return getFirstBracketBefore(node, (0, _lengthJs.lengthZero), node.length, (0, _lengthJs.positionToLength)(position));
    }
}
function getFirstBracketBefore(node, nodeOffsetStart, nodeOffsetEnd, position) {
    if (node.kind === 4 /* AstNodeKind.List */  || node.kind === 2 /* AstNodeKind.Pair */ ) {
        const lengths = [];
        for (const child of node.children){
            nodeOffsetEnd = (0, _lengthJs.lengthAdd)(nodeOffsetStart, child.length);
            lengths.push({
                nodeOffsetStart,
                nodeOffsetEnd
            });
            nodeOffsetStart = nodeOffsetEnd;
        }
        for(let i = lengths.length - 1; i >= 0; i--){
            const { nodeOffsetStart, nodeOffsetEnd } = lengths[i];
            if ((0, _lengthJs.lengthLessThan)(nodeOffsetStart, position)) {
                const result = getFirstBracketBefore(node.children[i], nodeOffsetStart, nodeOffsetEnd, position);
                if (result) return result;
            }
        }
        return null;
    } else if (node.kind === 3 /* AstNodeKind.UnexpectedClosingBracket */ ) return null;
    else if (node.kind === 1 /* AstNodeKind.Bracket */ ) {
        const range = (0, _lengthJs.lengthsToRange)(nodeOffsetStart, nodeOffsetEnd);
        return {
            bracketInfo: node.bracketInfo,
            range
        };
    }
    return null;
}
function getFirstBracketAfter(node, nodeOffsetStart, nodeOffsetEnd, position) {
    if (node.kind === 4 /* AstNodeKind.List */  || node.kind === 2 /* AstNodeKind.Pair */ ) {
        for (const child of node.children){
            nodeOffsetEnd = (0, _lengthJs.lengthAdd)(nodeOffsetStart, child.length);
            if ((0, _lengthJs.lengthLessThan)(position, nodeOffsetEnd)) {
                const result = getFirstBracketAfter(child, nodeOffsetStart, nodeOffsetEnd, position);
                if (result) return result;
            }
            nodeOffsetStart = nodeOffsetEnd;
        }
        return null;
    } else if (node.kind === 3 /* AstNodeKind.UnexpectedClosingBracket */ ) return null;
    else if (node.kind === 1 /* AstNodeKind.Bracket */ ) {
        const range = (0, _lengthJs.lengthsToRange)(nodeOffsetStart, nodeOffsetEnd);
        return {
            bracketInfo: node.bracketInfo,
            range
        };
    }
    return null;
}
function collectBrackets(node, nodeOffsetStart, nodeOffsetEnd, startOffset, endOffset, push, level, nestingLevelOfEqualBracketType, levelPerBracketType, onlyColorizedBrackets, parentPairIsIncomplete = false) {
    if (level > 200) return true;
    whileLoop: while(true)switch(node.kind){
        case 4 /* AstNodeKind.List */ :
            {
                const childCount = node.childrenLength;
                for(let i = 0; i < childCount; i++){
                    const child = node.getChild(i);
                    if (!child) continue;
                    nodeOffsetEnd = (0, _lengthJs.lengthAdd)(nodeOffsetStart, child.length);
                    if ((0, _lengthJs.lengthLessThanEqual)(nodeOffsetStart, endOffset) && (0, _lengthJs.lengthGreaterThanEqual)(nodeOffsetEnd, startOffset)) {
                        const childEndsAfterEnd = (0, _lengthJs.lengthGreaterThanEqual)(nodeOffsetEnd, endOffset);
                        if (childEndsAfterEnd) {
                            // No child after this child in the requested window, don't recurse
                            node = child;
                            continue whileLoop;
                        }
                        const shouldContinue = collectBrackets(child, nodeOffsetStart, nodeOffsetEnd, startOffset, endOffset, push, level, 0, levelPerBracketType, onlyColorizedBrackets);
                        if (!shouldContinue) return false;
                    }
                    nodeOffsetStart = nodeOffsetEnd;
                }
                return true;
            }
        case 2 /* AstNodeKind.Pair */ :
            {
                const colorize = !onlyColorizedBrackets || !node.closingBracket || node.closingBracket.bracketInfo.closesColorized(node.openingBracket.bracketInfo);
                let levelPerBracket = 0;
                if (levelPerBracketType) {
                    let existing = levelPerBracketType.get(node.openingBracket.text);
                    if (existing === undefined) existing = 0;
                    levelPerBracket = existing;
                    if (colorize) {
                        existing++;
                        levelPerBracketType.set(node.openingBracket.text, existing);
                    }
                }
                const childCount = node.childrenLength;
                for(let i = 0; i < childCount; i++){
                    const child = node.getChild(i);
                    if (!child) continue;
                    nodeOffsetEnd = (0, _lengthJs.lengthAdd)(nodeOffsetStart, child.length);
                    if ((0, _lengthJs.lengthLessThanEqual)(nodeOffsetStart, endOffset) && (0, _lengthJs.lengthGreaterThanEqual)(nodeOffsetEnd, startOffset)) {
                        const childEndsAfterEnd = (0, _lengthJs.lengthGreaterThanEqual)(nodeOffsetEnd, endOffset);
                        if (childEndsAfterEnd && child.kind !== 1 /* AstNodeKind.Bracket */ ) {
                            // No child after this child in the requested window, don't recurse
                            // Don't do this for brackets because of unclosed/unopened brackets
                            node = child;
                            if (colorize) {
                                level++;
                                nestingLevelOfEqualBracketType = levelPerBracket + 1;
                            } else nestingLevelOfEqualBracketType = levelPerBracket;
                            continue whileLoop;
                        }
                        if (colorize || child.kind !== 1 /* AstNodeKind.Bracket */  || !node.closingBracket) {
                            const shouldContinue = collectBrackets(child, nodeOffsetStart, nodeOffsetEnd, startOffset, endOffset, push, colorize ? level + 1 : level, colorize ? levelPerBracket + 1 : levelPerBracket, levelPerBracketType, onlyColorizedBrackets, !node.closingBracket);
                            if (!shouldContinue) return false;
                        }
                    }
                    nodeOffsetStart = nodeOffsetEnd;
                }
                levelPerBracketType?.set(node.openingBracket.text, levelPerBracket);
                return true;
            }
        case 3 /* AstNodeKind.UnexpectedClosingBracket */ :
            {
                const range = (0, _lengthJs.lengthsToRange)(nodeOffsetStart, nodeOffsetEnd);
                return push(new (0, _textModelBracketPairsJs.BracketInfo)(range, level - 1, 0, true));
            }
        case 1 /* AstNodeKind.Bracket */ :
            {
                const range = (0, _lengthJs.lengthsToRange)(nodeOffsetStart, nodeOffsetEnd);
                return push(new (0, _textModelBracketPairsJs.BracketInfo)(range, level - 1, nestingLevelOfEqualBracketType - 1, parentPairIsIncomplete));
            }
        case 0 /* AstNodeKind.Text */ :
            return true;
    }
}
class CollectBracketPairsContext {
    constructor(push, includeMinIndentation, textModel){
        this.push = push;
        this.includeMinIndentation = includeMinIndentation;
        this.textModel = textModel;
    }
}
function collectBracketPairs(node, nodeOffsetStart, nodeOffsetEnd, startOffset, endOffset, context, level, levelPerBracketType) {
    if (level > 200) return true;
    let shouldContinue = true;
    if (node.kind === 2 /* AstNodeKind.Pair */ ) {
        let levelPerBracket = 0;
        if (levelPerBracketType) {
            let existing = levelPerBracketType.get(node.openingBracket.text);
            if (existing === undefined) existing = 0;
            levelPerBracket = existing;
            existing++;
            levelPerBracketType.set(node.openingBracket.text, existing);
        }
        const openingBracketEnd = (0, _lengthJs.lengthAdd)(nodeOffsetStart, node.openingBracket.length);
        let minIndentation = -1;
        if (context.includeMinIndentation) minIndentation = node.computeMinIndentation(nodeOffsetStart, context.textModel);
        shouldContinue = context.push(new (0, _textModelBracketPairsJs.BracketPairWithMinIndentationInfo)((0, _lengthJs.lengthsToRange)(nodeOffsetStart, nodeOffsetEnd), (0, _lengthJs.lengthsToRange)(nodeOffsetStart, openingBracketEnd), node.closingBracket ? (0, _lengthJs.lengthsToRange)((0, _lengthJs.lengthAdd)(openingBracketEnd, node.child?.length || (0, _lengthJs.lengthZero)), nodeOffsetEnd) : undefined, level, levelPerBracket, node, minIndentation));
        nodeOffsetStart = openingBracketEnd;
        if (shouldContinue && node.child) {
            const child = node.child;
            nodeOffsetEnd = (0, _lengthJs.lengthAdd)(nodeOffsetStart, child.length);
            if ((0, _lengthJs.lengthLessThanEqual)(nodeOffsetStart, endOffset) && (0, _lengthJs.lengthGreaterThanEqual)(nodeOffsetEnd, startOffset)) {
                shouldContinue = collectBracketPairs(child, nodeOffsetStart, nodeOffsetEnd, startOffset, endOffset, context, level + 1, levelPerBracketType);
                if (!shouldContinue) return false;
            }
        }
        levelPerBracketType?.set(node.openingBracket.text, levelPerBracket);
    } else {
        let curOffset = nodeOffsetStart;
        for (const child of node.children){
            const childOffset = curOffset;
            curOffset = (0, _lengthJs.lengthAdd)(curOffset, child.length);
            if ((0, _lengthJs.lengthLessThanEqual)(childOffset, endOffset) && (0, _lengthJs.lengthLessThanEqual)(startOffset, curOffset)) {
                shouldContinue = collectBracketPairs(child, childOffset, curOffset, startOffset, endOffset, context, level, levelPerBracketType);
                if (!shouldContinue) return false;
            }
        }
    }
    return shouldContinue;
}

},{"../../../../../base/common/event.js":"4Zi8b","../../../../../base/common/lifecycle.js":"9kg8d","../../../textModelBracketPairs.js":"1RfwE","./beforeEditPositionMapper.js":"kLXi3","./brackets.js":"i2EWB","./length.js":"lbA4G","./parser.js":"dwAx5","./smallImmutableSet.js":"4iPAQ","./tokenizer.js":"e4jw0","../../../../../base/common/arrays.js":"DECei","./combineTextEditInfos.js":"6PVkC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1RfwE":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BracketInfo", ()=>BracketInfo);
parcelHelpers.export(exports, "BracketPairInfo", ()=>BracketPairInfo);
parcelHelpers.export(exports, "BracketPairWithMinIndentationInfo", ()=>BracketPairWithMinIndentationInfo);
class BracketInfo {
    constructor(range, /** 0-based level */ nestingLevel, nestingLevelOfEqualBracketType, isInvalid){
        this.range = range;
        this.nestingLevel = nestingLevel;
        this.nestingLevelOfEqualBracketType = nestingLevelOfEqualBracketType;
        this.isInvalid = isInvalid;
    }
}
class BracketPairInfo {
    constructor(range, openingBracketRange, closingBracketRange, /** 0-based */ nestingLevel, nestingLevelOfEqualBracketType, bracketPairNode){
        this.range = range;
        this.openingBracketRange = openingBracketRange;
        this.closingBracketRange = closingBracketRange;
        this.nestingLevel = nestingLevel;
        this.nestingLevelOfEqualBracketType = nestingLevelOfEqualBracketType;
        this.bracketPairNode = bracketPairNode;
    }
    get openingBracketInfo() {
        return this.bracketPairNode.openingBracket.bracketInfo;
    }
}
class BracketPairWithMinIndentationInfo extends BracketPairInfo {
    constructor(range, openingBracketRange, closingBracketRange, /**
     * 0-based
    */ nestingLevel, nestingLevelOfEqualBracketType, bracketPairNode, /**
     * -1 if not requested, otherwise the size of the minimum indentation in the bracket pair in terms of visible columns.
    */ minVisibleColumnIndentation){
        super(range, openingBracketRange, closingBracketRange, nestingLevel, nestingLevelOfEqualBracketType, bracketPairNode);
        this.minVisibleColumnIndentation = minVisibleColumnIndentation;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kLXi3":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextEditInfo", ()=>TextEditInfo);
parcelHelpers.export(exports, "BeforeEditPositionMapper", ()=>BeforeEditPositionMapper);
var _rangeJs = require("../../../core/range.js");
var _lengthJs = require("./length.js");
class TextEditInfo {
    static fromModelContentChanges(changes) {
        // Must be sorted in ascending order
        const edits = changes.map((c)=>{
            const range = (0, _rangeJs.Range).lift(c.range);
            return new TextEditInfo((0, _lengthJs.positionToLength)(range.getStartPosition()), (0, _lengthJs.positionToLength)(range.getEndPosition()), (0, _lengthJs.lengthOfString)(c.text));
        }).reverse();
        return edits;
    }
    constructor(startOffset, endOffset, newLength){
        this.startOffset = startOffset;
        this.endOffset = endOffset;
        this.newLength = newLength;
    }
    toString() {
        return `[${(0, _lengthJs.lengthToObj)(this.startOffset)}...${(0, _lengthJs.lengthToObj)(this.endOffset)}) -> ${(0, _lengthJs.lengthToObj)(this.newLength)}`;
    }
}
class BeforeEditPositionMapper {
    /**
     * @param edits Must be sorted by offset in ascending order.
    */ constructor(edits){
        this.nextEditIdx = 0;
        this.deltaOldToNewLineCount = 0;
        this.deltaOldToNewColumnCount = 0;
        this.deltaLineIdxInOld = -1;
        this.edits = edits.map((edit)=>TextEditInfoCache.from(edit));
    }
    /**
     * @param offset Must be equal to or greater than the last offset this method has been called with.
    */ getOffsetBeforeChange(offset) {
        this.adjustNextEdit(offset);
        return this.translateCurToOld(offset);
    }
    /**
     * @param offset Must be equal to or greater than the last offset this method has been called with.
     * Returns null if there is no edit anymore.
    */ getDistanceToNextChange(offset) {
        this.adjustNextEdit(offset);
        const nextEdit = this.edits[this.nextEditIdx];
        const nextChangeOffset = nextEdit ? this.translateOldToCur(nextEdit.offsetObj) : null;
        if (nextChangeOffset === null) return null;
        return (0, _lengthJs.lengthDiffNonNegative)(offset, nextChangeOffset);
    }
    translateOldToCur(oldOffsetObj) {
        if (oldOffsetObj.lineCount === this.deltaLineIdxInOld) return (0, _lengthJs.toLength)(oldOffsetObj.lineCount + this.deltaOldToNewLineCount, oldOffsetObj.columnCount + this.deltaOldToNewColumnCount);
        else return (0, _lengthJs.toLength)(oldOffsetObj.lineCount + this.deltaOldToNewLineCount, oldOffsetObj.columnCount);
    }
    translateCurToOld(newOffset) {
        const offsetObj = (0, _lengthJs.lengthToObj)(newOffset);
        if (offsetObj.lineCount - this.deltaOldToNewLineCount === this.deltaLineIdxInOld) return (0, _lengthJs.toLength)(offsetObj.lineCount - this.deltaOldToNewLineCount, offsetObj.columnCount - this.deltaOldToNewColumnCount);
        else return (0, _lengthJs.toLength)(offsetObj.lineCount - this.deltaOldToNewLineCount, offsetObj.columnCount);
    }
    adjustNextEdit(offset) {
        while(this.nextEditIdx < this.edits.length){
            const nextEdit = this.edits[this.nextEditIdx];
            // After applying the edit, what is its end offset (considering all previous edits)?
            const nextEditEndOffsetInCur = this.translateOldToCur(nextEdit.endOffsetAfterObj);
            if ((0, _lengthJs.lengthLessThanEqual)(nextEditEndOffsetInCur, offset)) {
                // We are after the edit, skip it
                this.nextEditIdx++;
                const nextEditEndOffsetInCurObj = (0, _lengthJs.lengthToObj)(nextEditEndOffsetInCur);
                // Before applying the edit, what is its end offset (considering all previous edits)?
                const nextEditEndOffsetBeforeInCurObj = (0, _lengthJs.lengthToObj)(this.translateOldToCur(nextEdit.endOffsetBeforeObj));
                const lineDelta = nextEditEndOffsetInCurObj.lineCount - nextEditEndOffsetBeforeInCurObj.lineCount;
                this.deltaOldToNewLineCount += lineDelta;
                const previousColumnDelta = this.deltaLineIdxInOld === nextEdit.endOffsetBeforeObj.lineCount ? this.deltaOldToNewColumnCount : 0;
                const columnDelta = nextEditEndOffsetInCurObj.columnCount - nextEditEndOffsetBeforeInCurObj.columnCount;
                this.deltaOldToNewColumnCount = previousColumnDelta + columnDelta;
                this.deltaLineIdxInOld = nextEdit.endOffsetBeforeObj.lineCount;
            } else break;
        }
    }
}
class TextEditInfoCache {
    static from(edit) {
        return new TextEditInfoCache(edit.startOffset, edit.endOffset, edit.newLength);
    }
    constructor(startOffset, endOffset, textLength){
        this.endOffsetBeforeObj = (0, _lengthJs.lengthToObj)(endOffset);
        this.endOffsetAfterObj = (0, _lengthJs.lengthToObj)((0, _lengthJs.lengthAdd)(startOffset, textLength));
        this.offsetObj = (0, _lengthJs.lengthToObj)(startOffset);
    }
}

},{"../../../core/range.js":"jmUPh","./length.js":"lbA4G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lbA4G":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The end must be greater than or equal to the start.
*/ parcelHelpers.export(exports, "lengthDiff", ()=>lengthDiff);
parcelHelpers.export(exports, "lengthZero", ()=>lengthZero);
parcelHelpers.export(exports, "lengthIsZero", ()=>lengthIsZero);
/*/
const factor = 1000000;
// */ parcelHelpers.export(exports, "toLength", ()=>toLength);
parcelHelpers.export(exports, "lengthToObj", ()=>lengthToObj);
parcelHelpers.export(exports, "lengthGetLineCount", ()=>lengthGetLineCount);
/**
 * Returns the amount of columns of the given length, assuming that it does not span any line.
*/ parcelHelpers.export(exports, "lengthGetColumnCountIfZeroLineCount", ()=>lengthGetColumnCountIfZeroLineCount);
parcelHelpers.export(exports, "lengthAdd", ()=>lengthAdd);
parcelHelpers.export(exports, "sumLengths", ()=>sumLengths);
parcelHelpers.export(exports, "lengthEquals", ()=>lengthEquals);
/**
 * Returns a non negative length `result` such that `lengthAdd(length1, result) = length2`, or zero if such length does not exist.
 */ parcelHelpers.export(exports, "lengthDiffNonNegative", ()=>lengthDiffNonNegative);
parcelHelpers.export(exports, "lengthLessThan", ()=>lengthLessThan);
parcelHelpers.export(exports, "lengthLessThanEqual", ()=>lengthLessThanEqual);
parcelHelpers.export(exports, "lengthGreaterThanEqual", ()=>lengthGreaterThanEqual);
parcelHelpers.export(exports, "positionToLength", ()=>positionToLength);
parcelHelpers.export(exports, "lengthsToRange", ()=>lengthsToRange);
parcelHelpers.export(exports, "lengthOfString", ()=>lengthOfString);
var _stringsJs = require("../../../../../base/common/strings.js");
var _rangeJs = require("../../../core/range.js");
var _textLengthJs = require("../../../core/textLength.js");
function lengthDiff(startLineCount, startColumnCount, endLineCount, endColumnCount) {
    return startLineCount !== endLineCount ? toLength(endLineCount - startLineCount, endColumnCount) : toLength(0, endColumnCount - startColumnCount);
}
const lengthZero = 0;
function lengthIsZero(length) {
    return length === 0;
}
/*
 * We have 52 bits available in a JS number.
 * We use the upper 26 bits to store the line and the lower 26 bits to store the column.
 */ ///*
const factor = 2 ** 26;
function toLength(lineCount, columnCount) {
    // llllllllllllllllllllllllllcccccccccccccccccccccccccc (52 bits)
    //       line count (26 bits)    column count (26 bits)
    // If there is no overflow (all values/sums below 2^26 = 67108864),
    // we have `toLength(lns1, cols1) + toLength(lns2, cols2) = toLength(lns1 + lns2, cols1 + cols2)`.
    return lineCount * factor + columnCount;
}
function lengthToObj(length) {
    const l = length;
    const lineCount = Math.floor(l / factor);
    const columnCount = l - lineCount * factor;
    return new (0, _textLengthJs.TextLength)(lineCount, columnCount);
}
function lengthGetLineCount(length) {
    return Math.floor(length / factor);
}
function lengthGetColumnCountIfZeroLineCount(length) {
    return length;
}
function lengthAdd(l1, l2) {
    let r = l1 + l2;
    if (l2 >= factor) r = r - l1 % factor;
    return r;
}
function sumLengths(items, lengthFn) {
    return items.reduce((a, b)=>lengthAdd(a, lengthFn(b)), lengthZero);
}
function lengthEquals(length1, length2) {
    return length1 === length2;
}
function lengthDiffNonNegative(length1, length2) {
    const l1 = length1;
    const l2 = length2;
    const diff = l2 - l1;
    if (diff <= 0) // line-count of length1 is higher than line-count of length2
    // or they are equal and column-count of length1 is higher than column-count of length2
    return lengthZero;
    const lineCount1 = Math.floor(l1 / factor);
    const lineCount2 = Math.floor(l2 / factor);
    const colCount2 = l2 - lineCount2 * factor;
    if (lineCount1 === lineCount2) {
        const colCount1 = l1 - lineCount1 * factor;
        return toLength(0, colCount2 - colCount1);
    } else return toLength(lineCount2 - lineCount1, colCount2);
}
function lengthLessThan(length1, length2) {
    // First, compare line counts, then column counts.
    return length1 < length2;
}
function lengthLessThanEqual(length1, length2) {
    return length1 <= length2;
}
function lengthGreaterThanEqual(length1, length2) {
    return length1 >= length2;
}
function positionToLength(position) {
    return toLength(position.lineNumber - 1, position.column - 1);
}
function lengthsToRange(lengthStart, lengthEnd) {
    const l = lengthStart;
    const lineCount = Math.floor(l / factor);
    const colCount = l - lineCount * factor;
    const l2 = lengthEnd;
    const lineCount2 = Math.floor(l2 / factor);
    const colCount2 = l2 - lineCount2 * factor;
    return new (0, _rangeJs.Range)(lineCount + 1, colCount + 1, lineCount2 + 1, colCount2 + 1);
}
function lengthOfString(str) {
    const lines = (0, _stringsJs.splitLines)(str);
    return toLength(lines.length - 1, lines[lines.length - 1].length);
}

},{"../../../../../base/common/strings.js":"aA9I1","../../../core/range.js":"jmUPh","../../../core/textLength.js":"Lk80L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i2EWB":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BracketTokens", ()=>BracketTokens);
parcelHelpers.export(exports, "LanguageAgnosticBracketTokens", ()=>LanguageAgnosticBracketTokens);
var _stringsJs = require("../../../../../base/common/strings.js");
var _astJs = require("./ast.js");
var _lengthJs = require("./length.js");
var _smallImmutableSetJs = require("./smallImmutableSet.js");
var _tokenizerJs = require("./tokenizer.js");
class BracketTokens {
    static createFromLanguage(configuration, denseKeyProvider) {
        function getId(bracketInfo) {
            return denseKeyProvider.getKey(`${bracketInfo.languageId}:::${bracketInfo.bracketText}`);
        }
        const map = new Map();
        for (const openingBracket of configuration.bracketsNew.openingBrackets){
            const length = (0, _lengthJs.toLength)(0, openingBracket.bracketText.length);
            const openingTextId = getId(openingBracket);
            const bracketIds = (0, _smallImmutableSetJs.SmallImmutableSet).getEmpty().add(openingTextId, (0, _smallImmutableSetJs.identityKeyProvider));
            map.set(openingBracket.bracketText, new (0, _tokenizerJs.Token)(length, 1 /* TokenKind.OpeningBracket */ , openingTextId, bracketIds, (0, _astJs.BracketAstNode).create(length, openingBracket, bracketIds)));
        }
        for (const closingBracket of configuration.bracketsNew.closingBrackets){
            const length = (0, _lengthJs.toLength)(0, closingBracket.bracketText.length);
            let bracketIds = (0, _smallImmutableSetJs.SmallImmutableSet).getEmpty();
            const closingBrackets = closingBracket.getOpeningBrackets();
            for (const bracket of closingBrackets)bracketIds = bracketIds.add(getId(bracket), (0, _smallImmutableSetJs.identityKeyProvider));
            map.set(closingBracket.bracketText, new (0, _tokenizerJs.Token)(length, 2 /* TokenKind.ClosingBracket */ , getId(closingBrackets[0]), bracketIds, (0, _astJs.BracketAstNode).create(length, closingBracket, bracketIds)));
        }
        return new BracketTokens(map);
    }
    constructor(map){
        this.map = map;
        this.hasRegExp = false;
        this._regExpGlobal = null;
    }
    getRegExpStr() {
        if (this.isEmpty) return null;
        else {
            const keys = [
                ...this.map.keys()
            ];
            keys.sort();
            keys.reverse();
            return keys.map((k)=>prepareBracketForRegExp(k)).join("|");
        }
    }
    /**
     * Returns null if there is no such regexp (because there are no brackets).
    */ get regExpGlobal() {
        if (!this.hasRegExp) {
            const regExpStr = this.getRegExpStr();
            this._regExpGlobal = regExpStr ? new RegExp(regExpStr, "gi") : null;
            this.hasRegExp = true;
        }
        return this._regExpGlobal;
    }
    getToken(value) {
        return this.map.get(value.toLowerCase());
    }
    findClosingTokenText(openingBracketIds) {
        for (const [closingText, info] of this.map){
            if (info.kind === 2 /* TokenKind.ClosingBracket */  && info.bracketIds.intersects(openingBracketIds)) return closingText;
        }
        return undefined;
    }
    get isEmpty() {
        return this.map.size === 0;
    }
}
function prepareBracketForRegExp(str) {
    let escaped = (0, _stringsJs.escapeRegExpCharacters)(str);
    // These bracket pair delimiters start or end with letters
    // see https://github.com/microsoft/vscode/issues/132162 https://github.com/microsoft/vscode/issues/150440
    if (/^[\w ]+/.test(str)) escaped = `\\b${escaped}`;
    if (/[\w ]+$/.test(str)) escaped = `${escaped}\\b`;
    return escaped;
}
class LanguageAgnosticBracketTokens {
    constructor(denseKeyProvider, getLanguageConfiguration){
        this.denseKeyProvider = denseKeyProvider;
        this.getLanguageConfiguration = getLanguageConfiguration;
        this.languageIdToBracketTokens = new Map();
    }
    didLanguageChange(languageId) {
        // Report a change whenever the language configuration updates.
        return this.languageIdToBracketTokens.has(languageId);
    }
    getSingleLanguageBracketTokens(languageId) {
        let singleLanguageBracketTokens = this.languageIdToBracketTokens.get(languageId);
        if (!singleLanguageBracketTokens) {
            singleLanguageBracketTokens = BracketTokens.createFromLanguage(this.getLanguageConfiguration(languageId), this.denseKeyProvider);
            this.languageIdToBracketTokens.set(languageId, singleLanguageBracketTokens);
        }
        return singleLanguageBracketTokens;
    }
}

},{"../../../../../base/common/strings.js":"aA9I1","./ast.js":"lc7sD","./length.js":"lbA4G","./smallImmutableSet.js":"4iPAQ","./tokenizer.js":"e4jw0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lc7sD":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a bracket pair including its child (e.g. `{ ... }`).
 * Might be unclosed.
 * Immutable, if all children are immutable.
*/ parcelHelpers.export(exports, "PairAstNode", ()=>PairAstNode);
parcelHelpers.export(exports, "ListAstNode", ()=>ListAstNode);
parcelHelpers.export(exports, "TextAstNode", ()=>TextAstNode);
parcelHelpers.export(exports, "BracketAstNode", ()=>BracketAstNode);
parcelHelpers.export(exports, "InvalidBracketAstNode", ()=>InvalidBracketAstNode);
var _errorsJs = require("../../../../../base/common/errors.js");
var _cursorColumnsJs = require("../../../core/cursorColumns.js");
var _lengthJs = require("./length.js");
var _smallImmutableSetJs = require("./smallImmutableSet.js");
/**
 * The base implementation for all AST nodes.
*/ class BaseAstNode {
    /**
     * The length of the entire node, which should equal the sum of lengths of all children.
    */ get length() {
        return this._length;
    }
    constructor(length){
        this._length = length;
    }
}
class PairAstNode extends BaseAstNode {
    static create(openingBracket, child, closingBracket) {
        let length = openingBracket.length;
        if (child) length = (0, _lengthJs.lengthAdd)(length, child.length);
        if (closingBracket) length = (0, _lengthJs.lengthAdd)(length, closingBracket.length);
        return new PairAstNode(length, openingBracket, child, closingBracket, child ? child.missingOpeningBracketIds : (0, _smallImmutableSetJs.SmallImmutableSet).getEmpty());
    }
    get kind() {
        return 2 /* AstNodeKind.Pair */ ;
    }
    get listHeight() {
        return 0;
    }
    get childrenLength() {
        return 3;
    }
    getChild(idx) {
        switch(idx){
            case 0:
                return this.openingBracket;
            case 1:
                return this.child;
            case 2:
                return this.closingBracket;
        }
        throw new Error("Invalid child index");
    }
    /**
     * Avoid using this property, it allocates an array!
    */ get children() {
        const result = [];
        result.push(this.openingBracket);
        if (this.child) result.push(this.child);
        if (this.closingBracket) result.push(this.closingBracket);
        return result;
    }
    constructor(length, openingBracket, child, closingBracket, missingOpeningBracketIds){
        super(length);
        this.openingBracket = openingBracket;
        this.child = child;
        this.closingBracket = closingBracket;
        this.missingOpeningBracketIds = missingOpeningBracketIds;
    }
    canBeReused(openBracketIds) {
        if (this.closingBracket === null) // Unclosed pair ast nodes only
        // end at the end of the document
        // or when a parent node is closed.
        // This could be improved:
        // Only return false if some next token is neither "undefined" nor a bracket that closes a parent.
        return false;
        if (openBracketIds.intersects(this.missingOpeningBracketIds)) return false;
        return true;
    }
    deepClone() {
        return new PairAstNode(this.length, this.openingBracket.deepClone(), this.child && this.child.deepClone(), this.closingBracket && this.closingBracket.deepClone(), this.missingOpeningBracketIds);
    }
    computeMinIndentation(offset, textModel) {
        return this.child ? this.child.computeMinIndentation((0, _lengthJs.lengthAdd)(offset, this.openingBracket.length), textModel) : Number.MAX_SAFE_INTEGER;
    }
}
class ListAstNode extends BaseAstNode {
    /**
     * This method uses more memory-efficient list nodes that can only store 2 or 3 children.
    */ static create23(item1, item2, item3, immutable = false) {
        let length = item1.length;
        let missingBracketIds = item1.missingOpeningBracketIds;
        if (item1.listHeight !== item2.listHeight) throw new Error("Invalid list heights");
        length = (0, _lengthJs.lengthAdd)(length, item2.length);
        missingBracketIds = missingBracketIds.merge(item2.missingOpeningBracketIds);
        if (item3) {
            if (item1.listHeight !== item3.listHeight) throw new Error("Invalid list heights");
            length = (0, _lengthJs.lengthAdd)(length, item3.length);
            missingBracketIds = missingBracketIds.merge(item3.missingOpeningBracketIds);
        }
        return immutable ? new Immutable23ListAstNode(length, item1.listHeight + 1, item1, item2, item3, missingBracketIds) : new TwoThreeListAstNode(length, item1.listHeight + 1, item1, item2, item3, missingBracketIds);
    }
    static getEmpty() {
        return new ImmutableArrayListAstNode((0, _lengthJs.lengthZero), 0, [], (0, _smallImmutableSetJs.SmallImmutableSet).getEmpty());
    }
    get kind() {
        return 4 /* AstNodeKind.List */ ;
    }
    get missingOpeningBracketIds() {
        return this._missingOpeningBracketIds;
    }
    /**
     * Use ListAstNode.create.
    */ constructor(length, listHeight, _missingOpeningBracketIds){
        super(length);
        this.listHeight = listHeight;
        this._missingOpeningBracketIds = _missingOpeningBracketIds;
        this.cachedMinIndentation = -1;
    }
    throwIfImmutable() {
    // NOOP
    }
    makeLastElementMutable() {
        this.throwIfImmutable();
        const childCount = this.childrenLength;
        if (childCount === 0) return undefined;
        const lastChild = this.getChild(childCount - 1);
        const mutable = lastChild.kind === 4 /* AstNodeKind.List */  ? lastChild.toMutable() : lastChild;
        if (lastChild !== mutable) this.setChild(childCount - 1, mutable);
        return mutable;
    }
    makeFirstElementMutable() {
        this.throwIfImmutable();
        const childCount = this.childrenLength;
        if (childCount === 0) return undefined;
        const firstChild = this.getChild(0);
        const mutable = firstChild.kind === 4 /* AstNodeKind.List */  ? firstChild.toMutable() : firstChild;
        if (firstChild !== mutable) this.setChild(0, mutable);
        return mutable;
    }
    canBeReused(openBracketIds) {
        if (openBracketIds.intersects(this.missingOpeningBracketIds)) return false;
        if (this.childrenLength === 0) // Don't reuse empty lists.
        return false;
        let lastChild = this;
        while(lastChild.kind === 4 /* AstNodeKind.List */ ){
            const lastLength = lastChild.childrenLength;
            if (lastLength === 0) // Empty lists should never be contained in other lists.
            throw new (0, _errorsJs.BugIndicatingError)();
            lastChild = lastChild.getChild(lastLength - 1);
        }
        return lastChild.canBeReused(openBracketIds);
    }
    handleChildrenChanged() {
        this.throwIfImmutable();
        const count = this.childrenLength;
        let length = this.getChild(0).length;
        let unopenedBrackets = this.getChild(0).missingOpeningBracketIds;
        for(let i = 1; i < count; i++){
            const child = this.getChild(i);
            length = (0, _lengthJs.lengthAdd)(length, child.length);
            unopenedBrackets = unopenedBrackets.merge(child.missingOpeningBracketIds);
        }
        this._length = length;
        this._missingOpeningBracketIds = unopenedBrackets;
        this.cachedMinIndentation = -1;
    }
    computeMinIndentation(offset, textModel) {
        if (this.cachedMinIndentation !== -1) return this.cachedMinIndentation;
        let minIndentation = Number.MAX_SAFE_INTEGER;
        let childOffset = offset;
        for(let i = 0; i < this.childrenLength; i++){
            const child = this.getChild(i);
            if (child) {
                minIndentation = Math.min(minIndentation, child.computeMinIndentation(childOffset, textModel));
                childOffset = (0, _lengthJs.lengthAdd)(childOffset, child.length);
            }
        }
        this.cachedMinIndentation = minIndentation;
        return minIndentation;
    }
}
class TwoThreeListAstNode extends ListAstNode {
    get childrenLength() {
        return this._item3 !== null ? 3 : 2;
    }
    getChild(idx) {
        switch(idx){
            case 0:
                return this._item1;
            case 1:
                return this._item2;
            case 2:
                return this._item3;
        }
        throw new Error("Invalid child index");
    }
    setChild(idx, node) {
        switch(idx){
            case 0:
                this._item1 = node;
                return;
            case 1:
                this._item2 = node;
                return;
            case 2:
                this._item3 = node;
                return;
        }
        throw new Error("Invalid child index");
    }
    get children() {
        return this._item3 ? [
            this._item1,
            this._item2,
            this._item3
        ] : [
            this._item1,
            this._item2
        ];
    }
    get item1() {
        return this._item1;
    }
    get item2() {
        return this._item2;
    }
    get item3() {
        return this._item3;
    }
    constructor(length, listHeight, _item1, _item2, _item3, missingOpeningBracketIds){
        super(length, listHeight, missingOpeningBracketIds);
        this._item1 = _item1;
        this._item2 = _item2;
        this._item3 = _item3;
    }
    deepClone() {
        return new TwoThreeListAstNode(this.length, this.listHeight, this._item1.deepClone(), this._item2.deepClone(), this._item3 ? this._item3.deepClone() : null, this.missingOpeningBracketIds);
    }
    appendChildOfSameHeight(node) {
        if (this._item3) throw new Error("Cannot append to a full (2,3) tree node");
        this.throwIfImmutable();
        this._item3 = node;
        this.handleChildrenChanged();
    }
    unappendChild() {
        if (!this._item3) throw new Error("Cannot remove from a non-full (2,3) tree node");
        this.throwIfImmutable();
        const result = this._item3;
        this._item3 = null;
        this.handleChildrenChanged();
        return result;
    }
    prependChildOfSameHeight(node) {
        if (this._item3) throw new Error("Cannot prepend to a full (2,3) tree node");
        this.throwIfImmutable();
        this._item3 = this._item2;
        this._item2 = this._item1;
        this._item1 = node;
        this.handleChildrenChanged();
    }
    unprependChild() {
        if (!this._item3) throw new Error("Cannot remove from a non-full (2,3) tree node");
        this.throwIfImmutable();
        const result = this._item1;
        this._item1 = this._item2;
        this._item2 = this._item3;
        this._item3 = null;
        this.handleChildrenChanged();
        return result;
    }
    toMutable() {
        return this;
    }
}
/**
 * Immutable, if all children are immutable.
*/ class Immutable23ListAstNode extends TwoThreeListAstNode {
    toMutable() {
        return new TwoThreeListAstNode(this.length, this.listHeight, this.item1, this.item2, this.item3, this.missingOpeningBracketIds);
    }
    throwIfImmutable() {
        throw new Error("this instance is immutable");
    }
}
/**
 * For debugging.
*/ class ArrayListAstNode extends ListAstNode {
    get childrenLength() {
        return this._children.length;
    }
    getChild(idx) {
        return this._children[idx];
    }
    setChild(idx, child) {
        this._children[idx] = child;
    }
    get children() {
        return this._children;
    }
    constructor(length, listHeight, _children, missingOpeningBracketIds){
        super(length, listHeight, missingOpeningBracketIds);
        this._children = _children;
    }
    deepClone() {
        const children = new Array(this._children.length);
        for(let i = 0; i < this._children.length; i++)children[i] = this._children[i].deepClone();
        return new ArrayListAstNode(this.length, this.listHeight, children, this.missingOpeningBracketIds);
    }
    appendChildOfSameHeight(node) {
        this.throwIfImmutable();
        this._children.push(node);
        this.handleChildrenChanged();
    }
    unappendChild() {
        this.throwIfImmutable();
        const item = this._children.pop();
        this.handleChildrenChanged();
        return item;
    }
    prependChildOfSameHeight(node) {
        this.throwIfImmutable();
        this._children.unshift(node);
        this.handleChildrenChanged();
    }
    unprependChild() {
        this.throwIfImmutable();
        const item = this._children.shift();
        this.handleChildrenChanged();
        return item;
    }
    toMutable() {
        return this;
    }
}
/**
 * Immutable, if all children are immutable.
*/ class ImmutableArrayListAstNode extends ArrayListAstNode {
    toMutable() {
        return new ArrayListAstNode(this.length, this.listHeight, [
            ...this.children
        ], this.missingOpeningBracketIds);
    }
    throwIfImmutable() {
        throw new Error("this instance is immutable");
    }
}
const emptyArray = [];
class ImmutableLeafAstNode extends BaseAstNode {
    get listHeight() {
        return 0;
    }
    get childrenLength() {
        return 0;
    }
    getChild(idx) {
        return null;
    }
    get children() {
        return emptyArray;
    }
    deepClone() {
        return this;
    }
}
class TextAstNode extends ImmutableLeafAstNode {
    get kind() {
        return 0 /* AstNodeKind.Text */ ;
    }
    get missingOpeningBracketIds() {
        return (0, _smallImmutableSetJs.SmallImmutableSet).getEmpty();
    }
    canBeReused(_openedBracketIds) {
        return true;
    }
    computeMinIndentation(offset, textModel) {
        const start = (0, _lengthJs.lengthToObj)(offset);
        // Text ast nodes don't have partial indentation (ensured by the tokenizer).
        // Thus, if this text node does not start at column 0, the first line cannot have any indentation at all.
        const startLineNumber = (start.columnCount === 0 ? start.lineCount : start.lineCount + 1) + 1;
        const endLineNumber = (0, _lengthJs.lengthGetLineCount)((0, _lengthJs.lengthAdd)(offset, this.length)) + 1;
        let result = Number.MAX_SAFE_INTEGER;
        for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++){
            const firstNonWsColumn = textModel.getLineFirstNonWhitespaceColumn(lineNumber);
            const lineContent = textModel.getLineContent(lineNumber);
            if (firstNonWsColumn === 0) continue;
            const visibleColumn = (0, _cursorColumnsJs.CursorColumns).visibleColumnFromColumn(lineContent, firstNonWsColumn, textModel.getOptions().tabSize);
            result = Math.min(result, visibleColumn);
        }
        return result;
    }
}
class BracketAstNode extends ImmutableLeafAstNode {
    static create(length, bracketInfo, bracketIds) {
        const node = new BracketAstNode(length, bracketInfo, bracketIds);
        return node;
    }
    get kind() {
        return 1 /* AstNodeKind.Bracket */ ;
    }
    get missingOpeningBracketIds() {
        return (0, _smallImmutableSetJs.SmallImmutableSet).getEmpty();
    }
    constructor(length, bracketInfo, /**
     * In case of a opening bracket, this is the id of the opening bracket.
     * In case of a closing bracket, this contains the ids of all opening brackets it can close.
    */ bracketIds){
        super(length);
        this.bracketInfo = bracketInfo;
        this.bracketIds = bracketIds;
    }
    get text() {
        return this.bracketInfo.bracketText;
    }
    get languageId() {
        return this.bracketInfo.languageId;
    }
    canBeReused(_openedBracketIds) {
        // These nodes could be reused,
        // but not in a general way.
        // Their parent may be reused.
        return false;
    }
    computeMinIndentation(offset, textModel) {
        return Number.MAX_SAFE_INTEGER;
    }
}
class InvalidBracketAstNode extends ImmutableLeafAstNode {
    get kind() {
        return 3 /* AstNodeKind.UnexpectedClosingBracket */ ;
    }
    constructor(closingBrackets, length){
        super(length);
        this.missingOpeningBracketIds = closingBrackets;
    }
    canBeReused(openedBracketIds) {
        return !openedBracketIds.intersects(this.missingOpeningBracketIds);
    }
    computeMinIndentation(offset, textModel) {
        return Number.MAX_SAFE_INTEGER;
    }
}

},{"../../../../../base/common/errors.js":"divX8","../../../core/cursorColumns.js":"idX7D","./length.js":"lbA4G","./smallImmutableSet.js":"4iPAQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iPAQ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents an immutable set that works best for a small number of elements (less than 32).
 * It uses bits to encode element membership efficiently.
*/ parcelHelpers.export(exports, "SmallImmutableSet", ()=>SmallImmutableSet);
parcelHelpers.export(exports, "identityKeyProvider", ()=>identityKeyProvider);
/**
 * Assigns values a unique incrementing key.
*/ parcelHelpers.export(exports, "DenseKeyProvider", ()=>DenseKeyProvider);
const emptyArr = [];
class SmallImmutableSet {
    static{
        this.cache = new Array(129);
    }
    static create(items, additionalItems) {
        if (items <= 128 && additionalItems.length === 0) {
            // We create a cache of 128=2^7 elements to cover all sets with up to 7 (dense) elements.
            let cached = SmallImmutableSet.cache[items];
            if (!cached) {
                cached = new SmallImmutableSet(items, additionalItems);
                SmallImmutableSet.cache[items] = cached;
            }
            return cached;
        }
        return new SmallImmutableSet(items, additionalItems);
    }
    static{
        this.empty = SmallImmutableSet.create(0, emptyArr);
    }
    static getEmpty() {
        return this.empty;
    }
    constructor(items, additionalItems){
        this.items = items;
        this.additionalItems = additionalItems;
    }
    add(value, keyProvider) {
        const key = keyProvider.getKey(value);
        let idx = key >> 5; // divided by 32
        if (idx === 0) {
            // fast path
            const newItem = 1 << key | this.items;
            if (newItem === this.items) return this;
            return SmallImmutableSet.create(newItem, this.additionalItems);
        }
        idx--;
        const newItems = this.additionalItems.slice(0);
        while(newItems.length < idx)newItems.push(0);
        newItems[idx] |= 1 << (key & 31);
        return SmallImmutableSet.create(this.items, newItems);
    }
    merge(other) {
        const merged = this.items | other.items;
        if (this.additionalItems === emptyArr && other.additionalItems === emptyArr) {
            // fast path
            if (merged === this.items) return this;
            if (merged === other.items) return other;
            return SmallImmutableSet.create(merged, emptyArr);
        }
        // This can be optimized, but it's not a common case
        const newItems = [];
        for(let i = 0; i < Math.max(this.additionalItems.length, other.additionalItems.length); i++){
            const item1 = this.additionalItems[i] || 0;
            const item2 = other.additionalItems[i] || 0;
            newItems.push(item1 | item2);
        }
        return SmallImmutableSet.create(merged, newItems);
    }
    intersects(other) {
        if ((this.items & other.items) !== 0) return true;
        for(let i = 0; i < Math.min(this.additionalItems.length, other.additionalItems.length); i++){
            if ((this.additionalItems[i] & other.additionalItems[i]) !== 0) return true;
        }
        return false;
    }
}
const identityKeyProvider = {
    getKey (value) {
        return value;
    }
};
class DenseKeyProvider {
    constructor(){
        this.items = new Map();
    }
    getKey(value) {
        let existing = this.items.get(value);
        if (existing === undefined) {
            existing = this.items.size;
            this.items.set(value, existing);
        }
        return existing;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e4jw0":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Token", ()=>Token);
parcelHelpers.export(exports, "TextBufferTokenizer", ()=>TextBufferTokenizer);
parcelHelpers.export(exports, "FastTokenizer", ()=>FastTokenizer);
var _errorsJs = require("../../../../../base/common/errors.js");
var _encodedTokenAttributesJs = require("../../../encodedTokenAttributes.js");
var _astJs = require("./ast.js");
var _lengthJs = require("./length.js");
var _smallImmutableSetJs = require("./smallImmutableSet.js");
class Token {
    constructor(length, kind, /**
     * If this token is an opening bracket, this is the id of the opening bracket.
     * If this token is a closing bracket, this is the id of the first opening bracket that is closed by this bracket.
     * Otherwise, it is -1.
     */ bracketId, /**
     * If this token is an opening bracket, this just contains `bracketId`.
     * If this token is a closing bracket, this lists all opening bracket ids, that it closes.
     * Otherwise, it is empty.
     */ bracketIds, astNode){
        this.length = length;
        this.kind = kind;
        this.bracketId = bracketId;
        this.bracketIds = bracketIds;
        this.astNode = astNode;
    }
}
class TextBufferTokenizer {
    constructor(textModel, bracketTokens){
        this.textModel = textModel;
        this.bracketTokens = bracketTokens;
        this.reader = new NonPeekableTextBufferTokenizer(this.textModel, this.bracketTokens);
        this._offset = (0, _lengthJs.lengthZero);
        this.didPeek = false;
        this.peeked = null;
        this.textBufferLineCount = textModel.getLineCount();
        this.textBufferLastLineLength = textModel.getLineLength(this.textBufferLineCount);
    }
    get offset() {
        return this._offset;
    }
    get length() {
        return (0, _lengthJs.toLength)(this.textBufferLineCount - 1, this.textBufferLastLineLength);
    }
    skip(length) {
        this.didPeek = false;
        this._offset = (0, _lengthJs.lengthAdd)(this._offset, length);
        const obj = (0, _lengthJs.lengthToObj)(this._offset);
        this.reader.setPosition(obj.lineCount, obj.columnCount);
    }
    read() {
        let token;
        if (this.peeked) {
            this.didPeek = false;
            token = this.peeked;
        } else token = this.reader.read();
        if (token) this._offset = (0, _lengthJs.lengthAdd)(this._offset, token.length);
        return token;
    }
    peek() {
        if (!this.didPeek) {
            this.peeked = this.reader.read();
            this.didPeek = true;
        }
        return this.peeked;
    }
}
/**
 * Does not support peek.
*/ class NonPeekableTextBufferTokenizer {
    constructor(textModel, bracketTokens){
        this.textModel = textModel;
        this.bracketTokens = bracketTokens;
        this.lineIdx = 0;
        this.line = null;
        this.lineCharOffset = 0;
        this.lineTokens = null;
        this.lineTokenOffset = 0;
        /** Must be a zero line token. The end of the document cannot be peeked. */ this.peekedToken = null;
        this.textBufferLineCount = textModel.getLineCount();
        this.textBufferLastLineLength = textModel.getLineLength(this.textBufferLineCount);
    }
    setPosition(lineIdx, column) {
        // We must not jump into a token!
        if (lineIdx === this.lineIdx) {
            this.lineCharOffset = column;
            if (this.line !== null) this.lineTokenOffset = this.lineCharOffset === 0 ? 0 : this.lineTokens.findTokenIndexAtOffset(this.lineCharOffset);
        } else {
            this.lineIdx = lineIdx;
            this.lineCharOffset = column;
            this.line = null;
        }
        this.peekedToken = null;
    }
    read() {
        if (this.peekedToken) {
            const token = this.peekedToken;
            this.peekedToken = null;
            this.lineCharOffset += (0, _lengthJs.lengthGetColumnCountIfZeroLineCount)(token.length);
            return token;
        }
        if (this.lineIdx > this.textBufferLineCount - 1 || this.lineIdx === this.textBufferLineCount - 1 && this.lineCharOffset >= this.textBufferLastLineLength) // We are after the end
        return null;
        if (this.line === null) {
            this.lineTokens = this.textModel.tokenization.getLineTokens(this.lineIdx + 1);
            this.line = this.lineTokens.getLineContent();
            this.lineTokenOffset = this.lineCharOffset === 0 ? 0 : this.lineTokens.findTokenIndexAtOffset(this.lineCharOffset);
        }
        const startLineIdx = this.lineIdx;
        const startLineCharOffset = this.lineCharOffset;
        // limits the length of text tokens.
        // If text tokens get too long, incremental updates will be slow
        let lengthHeuristic = 0;
        while(true){
            const lineTokens = this.lineTokens;
            const tokenCount = lineTokens.getCount();
            let peekedBracketToken = null;
            if (this.lineTokenOffset < tokenCount) {
                const tokenMetadata = lineTokens.getMetadata(this.lineTokenOffset);
                while(this.lineTokenOffset + 1 < tokenCount && tokenMetadata === lineTokens.getMetadata(this.lineTokenOffset + 1))// Skip tokens that are identical.
                // Sometimes, (bracket) identifiers are split up into multiple tokens.
                this.lineTokenOffset++;
                const isOther = (0, _encodedTokenAttributesJs.TokenMetadata).getTokenType(tokenMetadata) === 0 /* StandardTokenType.Other */ ;
                const containsBracketType = (0, _encodedTokenAttributesJs.TokenMetadata).containsBalancedBrackets(tokenMetadata);
                const endOffset = lineTokens.getEndOffset(this.lineTokenOffset);
                // Is there a bracket token next? Only consume text.
                if (containsBracketType && isOther && this.lineCharOffset < endOffset) {
                    const languageId = lineTokens.getLanguageId(this.lineTokenOffset);
                    const text = this.line.substring(this.lineCharOffset, endOffset);
                    const brackets = this.bracketTokens.getSingleLanguageBracketTokens(languageId);
                    const regexp = brackets.regExpGlobal;
                    if (regexp) {
                        regexp.lastIndex = 0;
                        const match = regexp.exec(text);
                        if (match) {
                            peekedBracketToken = brackets.getToken(match[0]);
                            if (peekedBracketToken) // Consume leading text of the token
                            this.lineCharOffset += match.index;
                        }
                    }
                }
                lengthHeuristic += endOffset - this.lineCharOffset;
                if (peekedBracketToken) {
                    // Don't skip the entire token, as a single token could contain multiple brackets.
                    if (startLineIdx !== this.lineIdx || startLineCharOffset !== this.lineCharOffset) {
                        // There is text before the bracket
                        this.peekedToken = peekedBracketToken;
                        break;
                    } else {
                        // Consume the peeked token
                        this.lineCharOffset += (0, _lengthJs.lengthGetColumnCountIfZeroLineCount)(peekedBracketToken.length);
                        return peekedBracketToken;
                    }
                } else {
                    // Skip the entire token, as the token contains no brackets at all.
                    this.lineTokenOffset++;
                    this.lineCharOffset = endOffset;
                }
            } else {
                if (this.lineIdx === this.textBufferLineCount - 1) break;
                this.lineIdx++;
                this.lineTokens = this.textModel.tokenization.getLineTokens(this.lineIdx + 1);
                this.lineTokenOffset = 0;
                this.line = this.lineTokens.getLineContent();
                this.lineCharOffset = 0;
                lengthHeuristic += 33; // max 1000/33 = 30 lines
                // This limits the amount of work to recompute min-indentation
                if (lengthHeuristic > 1000) break;
            }
            if (lengthHeuristic > 1500) break;
        }
        // If a token contains some proper indentation, it also contains \n{INDENTATION+}(?!{INDENTATION}),
        // unless the line is too long.
        // Thus, the min indentation of the document is the minimum min indentation of every text node.
        const length = (0, _lengthJs.lengthDiff)(startLineIdx, startLineCharOffset, this.lineIdx, this.lineCharOffset);
        return new Token(length, 0 /* TokenKind.Text */ , -1, (0, _smallImmutableSetJs.SmallImmutableSet).getEmpty(), new (0, _astJs.TextAstNode)(length));
    }
}
class FastTokenizer {
    constructor(text, brackets){
        this.text = text;
        this._offset = (0, _lengthJs.lengthZero);
        this.idx = 0;
        const regExpStr = brackets.getRegExpStr();
        const regexp = regExpStr ? new RegExp(regExpStr + "|\n", "gi") : null;
        const tokens = [];
        let match;
        let curLineCount = 0;
        let lastLineBreakOffset = 0;
        let lastTokenEndOffset = 0;
        let lastTokenEndLine = 0;
        const smallTextTokens0Line = [];
        for(let i = 0; i < 60; i++)smallTextTokens0Line.push(new Token((0, _lengthJs.toLength)(0, i), 0 /* TokenKind.Text */ , -1, (0, _smallImmutableSetJs.SmallImmutableSet).getEmpty(), new (0, _astJs.TextAstNode)((0, _lengthJs.toLength)(0, i))));
        const smallTextTokens1Line = [];
        for(let i = 0; i < 60; i++)smallTextTokens1Line.push(new Token((0, _lengthJs.toLength)(1, i), 0 /* TokenKind.Text */ , -1, (0, _smallImmutableSetJs.SmallImmutableSet).getEmpty(), new (0, _astJs.TextAstNode)((0, _lengthJs.toLength)(1, i))));
        if (regexp) {
            regexp.lastIndex = 0;
            // If a token contains indentation, it also contains \n{INDENTATION+}(?!{INDENTATION})
            while((match = regexp.exec(text)) !== null){
                const curOffset = match.index;
                const value = match[0];
                if (value === "\n") {
                    curLineCount++;
                    lastLineBreakOffset = curOffset + 1;
                } else {
                    if (lastTokenEndOffset !== curOffset) {
                        let token;
                        if (lastTokenEndLine === curLineCount) {
                            const colCount = curOffset - lastTokenEndOffset;
                            if (colCount < smallTextTokens0Line.length) token = smallTextTokens0Line[colCount];
                            else {
                                const length = (0, _lengthJs.toLength)(0, colCount);
                                token = new Token(length, 0 /* TokenKind.Text */ , -1, (0, _smallImmutableSetJs.SmallImmutableSet).getEmpty(), new (0, _astJs.TextAstNode)(length));
                            }
                        } else {
                            const lineCount = curLineCount - lastTokenEndLine;
                            const colCount = curOffset - lastLineBreakOffset;
                            if (lineCount === 1 && colCount < smallTextTokens1Line.length) token = smallTextTokens1Line[colCount];
                            else {
                                const length = (0, _lengthJs.toLength)(lineCount, colCount);
                                token = new Token(length, 0 /* TokenKind.Text */ , -1, (0, _smallImmutableSetJs.SmallImmutableSet).getEmpty(), new (0, _astJs.TextAstNode)(length));
                            }
                        }
                        tokens.push(token);
                    }
                    // value is matched by regexp, so the token must exist
                    tokens.push(brackets.getToken(value));
                    lastTokenEndOffset = curOffset + value.length;
                    lastTokenEndLine = curLineCount;
                }
            }
        }
        const offset = text.length;
        if (lastTokenEndOffset !== offset) {
            const length = lastTokenEndLine === curLineCount ? (0, _lengthJs.toLength)(0, offset - lastTokenEndOffset) : (0, _lengthJs.toLength)(curLineCount - lastTokenEndLine, offset - lastLineBreakOffset);
            tokens.push(new Token(length, 0 /* TokenKind.Text */ , -1, (0, _smallImmutableSetJs.SmallImmutableSet).getEmpty(), new (0, _astJs.TextAstNode)(length)));
        }
        this.length = (0, _lengthJs.toLength)(curLineCount, offset - lastLineBreakOffset);
        this.tokens = tokens;
    }
    get offset() {
        return this._offset;
    }
    read() {
        return this.tokens[this.idx++] || null;
    }
    peek() {
        return this.tokens[this.idx] || null;
    }
    skip(length) {
        throw new (0, _errorsJs.NotSupportedError)();
    }
}

},{"../../../../../base/common/errors.js":"divX8","../../../encodedTokenAttributes.js":"eH8EQ","./ast.js":"lc7sD","./length.js":"lbA4G","./smallImmutableSet.js":"4iPAQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dwAx5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Non incrementally built ASTs are immutable.
*/ parcelHelpers.export(exports, "parseDocument", ()=>parseDocument);
var _astJs = require("./ast.js");
var _beforeEditPositionMapperJs = require("./beforeEditPositionMapper.js");
var _smallImmutableSetJs = require("./smallImmutableSet.js");
var _lengthJs = require("./length.js");
var _concat23TreesJs = require("./concat23Trees.js");
var _nodeReaderJs = require("./nodeReader.js");
function parseDocument(tokenizer, edits, oldNode, createImmutableLists) {
    const parser = new Parser(tokenizer, edits, oldNode, createImmutableLists);
    return parser.parseDocument();
}
/**
 * Non incrementally built ASTs are immutable.
*/ class Parser {
    constructor(tokenizer, edits, oldNode, createImmutableLists){
        this.tokenizer = tokenizer;
        this.createImmutableLists = createImmutableLists;
        this._itemsConstructed = 0;
        this._itemsFromCache = 0;
        if (oldNode && createImmutableLists) throw new Error("Not supported");
        this.oldNodeReader = oldNode ? new (0, _nodeReaderJs.NodeReader)(oldNode) : undefined;
        this.positionMapper = new (0, _beforeEditPositionMapperJs.BeforeEditPositionMapper)(edits);
    }
    parseDocument() {
        this._itemsConstructed = 0;
        this._itemsFromCache = 0;
        let result = this.parseList((0, _smallImmutableSetJs.SmallImmutableSet).getEmpty(), 0);
        if (!result) result = (0, _astJs.ListAstNode).getEmpty();
        return result;
    }
    parseList(openedBracketIds, level) {
        const items = [];
        while(true){
            let child = this.tryReadChildFromCache(openedBracketIds);
            if (!child) {
                const token = this.tokenizer.peek();
                if (!token || token.kind === 2 /* TokenKind.ClosingBracket */  && token.bracketIds.intersects(openedBracketIds)) break;
                child = this.parseChild(openedBracketIds, level + 1);
            }
            if (child.kind === 4 /* AstNodeKind.List */  && child.childrenLength === 0) continue;
            items.push(child);
        }
        // When there is no oldNodeReader, all items are created from scratch and must have the same height.
        const result = this.oldNodeReader ? (0, _concat23TreesJs.concat23Trees)(items) : (0, _concat23TreesJs.concat23TreesOfSameHeight)(items, this.createImmutableLists);
        return result;
    }
    tryReadChildFromCache(openedBracketIds) {
        if (this.oldNodeReader) {
            const maxCacheableLength = this.positionMapper.getDistanceToNextChange(this.tokenizer.offset);
            if (maxCacheableLength === null || !(0, _lengthJs.lengthIsZero)(maxCacheableLength)) {
                const cachedNode = this.oldNodeReader.readLongestNodeAt(this.positionMapper.getOffsetBeforeChange(this.tokenizer.offset), (curNode)=>{
                    // The edit could extend the ending token, thus we cannot re-use nodes that touch the edit.
                    // If there is no edit anymore, we can re-use the node in any case.
                    if (maxCacheableLength !== null && !(0, _lengthJs.lengthLessThan)(curNode.length, maxCacheableLength)) // Either the node contains edited text or touches edited text.
                    // In the latter case, brackets might have been extended (`end` -> `ending`), so even touching nodes cannot be reused.
                    return false;
                    const canBeReused = curNode.canBeReused(openedBracketIds);
                    return canBeReused;
                });
                if (cachedNode) {
                    this._itemsFromCache++;
                    this.tokenizer.skip(cachedNode.length);
                    return cachedNode;
                }
            }
        }
        return undefined;
    }
    parseChild(openedBracketIds, level) {
        this._itemsConstructed++;
        const token = this.tokenizer.read();
        switch(token.kind){
            case 2 /* TokenKind.ClosingBracket */ :
                return new (0, _astJs.InvalidBracketAstNode)(token.bracketIds, token.length);
            case 0 /* TokenKind.Text */ :
                return token.astNode;
            case 1 /* TokenKind.OpeningBracket */ :
                {
                    if (level > 300) // To prevent stack overflows
                    return new (0, _astJs.TextAstNode)(token.length);
                    const set = openedBracketIds.merge(token.bracketIds);
                    const child = this.parseList(set, level + 1);
                    const nextToken = this.tokenizer.peek();
                    if (nextToken && nextToken.kind === 2 /* TokenKind.ClosingBracket */  && (nextToken.bracketId === token.bracketId || nextToken.bracketIds.intersects(token.bracketIds))) {
                        this.tokenizer.read();
                        return (0, _astJs.PairAstNode).create(token.astNode, child, nextToken.astNode);
                    } else return (0, _astJs.PairAstNode).create(token.astNode, child, null);
                }
            default:
                throw new Error("unexpected");
        }
    }
}

},{"./ast.js":"lc7sD","./beforeEditPositionMapper.js":"kLXi3","./smallImmutableSet.js":"4iPAQ","./length.js":"lbA4G","./concat23Trees.js":"e7ywu","./nodeReader.js":"kDGRw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e7ywu":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Concatenates a list of (2,3) AstNode's into a single (2,3) AstNode.
 * This mutates the items of the input array!
 * If all items have the same height, this method has runtime O(items.length).
 * Otherwise, it has runtime O(items.length * max(log(items.length), items.max(i => i.height))).
*/ parcelHelpers.export(exports, "concat23Trees", ()=>concat23Trees);
parcelHelpers.export(exports, "concat23TreesOfSameHeight", ()=>concat23TreesOfSameHeight);
var _astJs = require("./ast.js");
function concat23Trees(items) {
    if (items.length === 0) return null;
    if (items.length === 1) return items[0];
    let i = 0;
    /**
     * Reads nodes of same height and concatenates them to a single node.
    */ function readNode() {
        if (i >= items.length) return null;
        const start = i;
        const height = items[start].listHeight;
        i++;
        while(i < items.length && items[i].listHeight === height)i++;
        if (i - start >= 2) return concat23TreesOfSameHeight(start === 0 && i === items.length ? items : items.slice(start, i), false);
        else return items[start];
    }
    // The items might not have the same height.
    // We merge all items by using a binary concat operator.
    let first = readNode(); // There must be a first item
    let second = readNode();
    if (!second) return first;
    for(let item = readNode(); item; item = readNode())// Prefer concatenating smaller trees, as the runtime of concat depends on the tree height.
    if (heightDiff(first, second) <= heightDiff(second, item)) {
        first = concat(first, second);
        second = item;
    } else second = concat(second, item);
    const result = concat(first, second);
    return result;
}
function concat23TreesOfSameHeight(items, createImmutableLists = false) {
    if (items.length === 0) return null;
    if (items.length === 1) return items[0];
    let length = items.length;
    // All trees have same height, just create parent nodes.
    while(length > 3){
        const newLength = length >> 1;
        for(let i = 0; i < newLength; i++){
            const j = i << 1;
            items[i] = (0, _astJs.ListAstNode).create23(items[j], items[j + 1], j + 3 === length ? items[j + 2] : null, createImmutableLists);
        }
        length = newLength;
    }
    return (0, _astJs.ListAstNode).create23(items[0], items[1], length >= 3 ? items[2] : null, createImmutableLists);
}
function heightDiff(node1, node2) {
    return Math.abs(node1.listHeight - node2.listHeight);
}
function concat(node1, node2) {
    if (node1.listHeight === node2.listHeight) return (0, _astJs.ListAstNode).create23(node1, node2, null, false);
    else if (node1.listHeight > node2.listHeight) // node1 is the tree we want to insert into
    return append(node1, node2);
    else return prepend(node2, node1);
}
/**
 * Appends the given node to the end of this (2,3) tree.
 * Returns the new root.
*/ function append(list, nodeToAppend) {
    list = list.toMutable();
    let curNode = list;
    const parents = [];
    let nodeToAppendOfCorrectHeight;
    while(true){
        // assert nodeToInsert.listHeight <= curNode.listHeight
        if (nodeToAppend.listHeight === curNode.listHeight) {
            nodeToAppendOfCorrectHeight = nodeToAppend;
            break;
        }
        // assert 0 <= nodeToInsert.listHeight < curNode.listHeight
        if (curNode.kind !== 4 /* AstNodeKind.List */ ) throw new Error("unexpected");
        parents.push(curNode);
        // assert 2 <= curNode.childrenLength <= 3
        curNode = curNode.makeLastElementMutable();
    }
    // assert nodeToAppendOfCorrectHeight!.listHeight === curNode.listHeight
    for(let i = parents.length - 1; i >= 0; i--){
        const parent = parents[i];
        if (nodeToAppendOfCorrectHeight) {
            // Can we take the element?
            if (parent.childrenLength >= 3) // assert parent.childrenLength === 3 && parent.listHeight === nodeToAppendOfCorrectHeight.listHeight + 1
            // we need to split to maintain (2,3)-tree property.
            // Send the third element + the new element to the parent.
            nodeToAppendOfCorrectHeight = (0, _astJs.ListAstNode).create23(parent.unappendChild(), nodeToAppendOfCorrectHeight, null, false);
            else {
                parent.appendChildOfSameHeight(nodeToAppendOfCorrectHeight);
                nodeToAppendOfCorrectHeight = undefined;
            }
        } else parent.handleChildrenChanged();
    }
    if (nodeToAppendOfCorrectHeight) return (0, _astJs.ListAstNode).create23(list, nodeToAppendOfCorrectHeight, null, false);
    else return list;
}
/**
 * Prepends the given node to the end of this (2,3) tree.
 * Returns the new root.
*/ function prepend(list, nodeToAppend) {
    list = list.toMutable();
    let curNode = list;
    const parents = [];
    // assert nodeToInsert.listHeight <= curNode.listHeight
    while(nodeToAppend.listHeight !== curNode.listHeight){
        // assert 0 <= nodeToInsert.listHeight < curNode.listHeight
        if (curNode.kind !== 4 /* AstNodeKind.List */ ) throw new Error("unexpected");
        parents.push(curNode);
        // assert 2 <= curNode.childrenFast.length <= 3
        curNode = curNode.makeFirstElementMutable();
    }
    let nodeToPrependOfCorrectHeight = nodeToAppend;
    // assert nodeToAppendOfCorrectHeight!.listHeight === curNode.listHeight
    for(let i = parents.length - 1; i >= 0; i--){
        const parent = parents[i];
        if (nodeToPrependOfCorrectHeight) {
            // Can we take the element?
            if (parent.childrenLength >= 3) // assert parent.childrenLength === 3 && parent.listHeight === nodeToAppendOfCorrectHeight.listHeight + 1
            // we need to split to maintain (2,3)-tree property.
            // Send the third element + the new element to the parent.
            nodeToPrependOfCorrectHeight = (0, _astJs.ListAstNode).create23(nodeToPrependOfCorrectHeight, parent.unprependChild(), null, false);
            else {
                parent.prependChildOfSameHeight(nodeToPrependOfCorrectHeight);
                nodeToPrependOfCorrectHeight = undefined;
            }
        } else parent.handleChildrenChanged();
    }
    if (nodeToPrependOfCorrectHeight) return (0, _astJs.ListAstNode).create23(nodeToPrependOfCorrectHeight, list, null, false);
    else return list;
}

},{"./ast.js":"lc7sD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kDGRw":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Allows to efficiently find a longest child at a given offset in a fixed node.
 * The requested offsets must increase monotonously.
*/ parcelHelpers.export(exports, "NodeReader", ()=>NodeReader);
var _lengthJs = require("./length.js");
class NodeReader {
    constructor(node){
        this.lastOffset = (0, _lengthJs.lengthZero);
        this.nextNodes = [
            node
        ];
        this.offsets = [
            (0, _lengthJs.lengthZero)
        ];
        this.idxs = [];
    }
    /**
     * Returns the longest node at `offset` that satisfies the predicate.
     * @param offset must be greater than or equal to the last offset this method has been called with!
    */ readLongestNodeAt(offset, predicate) {
        if ((0, _lengthJs.lengthLessThan)(offset, this.lastOffset)) throw new Error("Invalid offset");
        this.lastOffset = offset;
        // Find the longest node of all those that are closest to the current offset.
        while(true){
            const curNode = lastOrUndefined(this.nextNodes);
            if (!curNode) return undefined;
            const curNodeOffset = lastOrUndefined(this.offsets);
            if ((0, _lengthJs.lengthLessThan)(offset, curNodeOffset)) // The next best node is not here yet.
            // The reader must advance before a cached node is hit.
            return undefined;
            if ((0, _lengthJs.lengthLessThan)(curNodeOffset, offset)) {
                // The reader is ahead of the current node.
                if ((0, _lengthJs.lengthAdd)(curNodeOffset, curNode.length) <= offset) // The reader is after the end of the current node.
                this.nextNodeAfterCurrent();
                else {
                    // The reader is somewhere in the current node.
                    const nextChildIdx = getNextChildIdx(curNode);
                    if (nextChildIdx !== -1) {
                        // Go to the first child and repeat.
                        this.nextNodes.push(curNode.getChild(nextChildIdx));
                        this.offsets.push(curNodeOffset);
                        this.idxs.push(nextChildIdx);
                    } else // We don't have children
                    this.nextNodeAfterCurrent();
                }
            } else // readerOffsetBeforeChange === curNodeOffset
            if (predicate(curNode)) {
                this.nextNodeAfterCurrent();
                return curNode;
            } else {
                const nextChildIdx = getNextChildIdx(curNode);
                // look for shorter node
                if (nextChildIdx === -1) {
                    // There is no shorter node.
                    this.nextNodeAfterCurrent();
                    return undefined;
                } else {
                    // Descend into first child & repeat.
                    this.nextNodes.push(curNode.getChild(nextChildIdx));
                    this.offsets.push(curNodeOffset);
                    this.idxs.push(nextChildIdx);
                }
            }
        }
    }
    // Navigates to the longest node that continues after the current node.
    nextNodeAfterCurrent() {
        while(true){
            const currentOffset = lastOrUndefined(this.offsets);
            const currentNode = lastOrUndefined(this.nextNodes);
            this.nextNodes.pop();
            this.offsets.pop();
            if (this.idxs.length === 0) break;
            // Parent is not undefined, because idxs is not empty
            const parent = lastOrUndefined(this.nextNodes);
            const nextChildIdx = getNextChildIdx(parent, this.idxs[this.idxs.length - 1]);
            if (nextChildIdx !== -1) {
                this.nextNodes.push(parent.getChild(nextChildIdx));
                this.offsets.push((0, _lengthJs.lengthAdd)(currentOffset, currentNode.length));
                this.idxs[this.idxs.length - 1] = nextChildIdx;
                break;
            } else this.idxs.pop();
        // We fully consumed the parent.
        // Current node is now parent, so call nextNodeAfterCurrent again
        }
    }
}
function getNextChildIdx(node, curIdx = -1) {
    while(true){
        curIdx++;
        if (curIdx >= node.childrenLength) return -1;
        if (node.getChild(curIdx)) return curIdx;
    }
}
function lastOrUndefined(arr) {
    return arr.length > 0 ? arr[arr.length - 1] : undefined;
}

},{"./length.js":"lbA4G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6PVkC":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineTextEditInfos", ()=>combineTextEditInfos);
var _arraysJs = require("../../../../../base/common/arrays.js");
var _beforeEditPositionMapperJs = require("./beforeEditPositionMapper.js");
var _lengthJs = require("./length.js");
function combineTextEditInfos(textEditInfoFirst, textEditInfoSecond) {
    if (textEditInfoFirst.length === 0) return textEditInfoSecond;
    if (textEditInfoSecond.length === 0) return textEditInfoFirst;
    // s0: State before any edits
    const s0ToS1Map = new (0, _arraysJs.ArrayQueue)(toLengthMapping(textEditInfoFirst));
    // s1: State after first edit, but before second edit
    const s1ToS2Map = toLengthMapping(textEditInfoSecond);
    s1ToS2Map.push({
        modified: false,
        lengthBefore: undefined,
        lengthAfter: undefined
    }); // Copy everything from old to new
    // s2: State after both edits
    let curItem = s0ToS1Map.dequeue();
    /**
     * @param s1Length Use undefined for length "infinity"
     */ function nextS0ToS1MapWithS1LengthOf(s1Length) {
        if (s1Length === undefined) {
            const arr = s0ToS1Map.takeWhile((v)=>true) || [];
            if (curItem) arr.unshift(curItem);
            return arr;
        }
        const result = [];
        while(curItem && !(0, _lengthJs.lengthIsZero)(s1Length)){
            const [item, remainingItem] = curItem.splitAt(s1Length);
            result.push(item);
            s1Length = (0, _lengthJs.lengthDiffNonNegative)(item.lengthAfter, s1Length);
            curItem = remainingItem ?? s0ToS1Map.dequeue();
        }
        if (!(0, _lengthJs.lengthIsZero)(s1Length)) result.push(new LengthMapping(false, s1Length, s1Length));
        return result;
    }
    const result = [];
    function pushEdit(startOffset, endOffset, newLength) {
        if (result.length > 0 && (0, _lengthJs.lengthEquals)(result[result.length - 1].endOffset, startOffset)) {
            const lastResult = result[result.length - 1];
            result[result.length - 1] = new (0, _beforeEditPositionMapperJs.TextEditInfo)(lastResult.startOffset, endOffset, (0, _lengthJs.lengthAdd)(lastResult.newLength, newLength));
        } else result.push({
            startOffset,
            endOffset,
            newLength
        });
    }
    let s0offset = (0, _lengthJs.lengthZero);
    for (const s1ToS2 of s1ToS2Map){
        const s0ToS1Map = nextS0ToS1MapWithS1LengthOf(s1ToS2.lengthBefore);
        if (s1ToS2.modified) {
            const s0Length = (0, _lengthJs.sumLengths)(s0ToS1Map, (s)=>s.lengthBefore);
            const s0EndOffset = (0, _lengthJs.lengthAdd)(s0offset, s0Length);
            pushEdit(s0offset, s0EndOffset, s1ToS2.lengthAfter);
            s0offset = s0EndOffset;
        } else for (const s1 of s0ToS1Map){
            const s0startOffset = s0offset;
            s0offset = (0, _lengthJs.lengthAdd)(s0offset, s1.lengthBefore);
            if (s1.modified) pushEdit(s0startOffset, s0offset, s1.lengthAfter);
        }
    }
    return result;
}
class LengthMapping {
    constructor(/**
     * If false, length before and length after equal.
     */ modified, lengthBefore, lengthAfter){
        this.modified = modified;
        this.lengthBefore = lengthBefore;
        this.lengthAfter = lengthAfter;
    }
    splitAt(lengthAfter) {
        const remainingLengthAfter = (0, _lengthJs.lengthDiffNonNegative)(lengthAfter, this.lengthAfter);
        if ((0, _lengthJs.lengthEquals)(remainingLengthAfter, (0, _lengthJs.lengthZero))) return [
            this,
            undefined
        ];
        else if (this.modified) return [
            new LengthMapping(this.modified, this.lengthBefore, lengthAfter),
            new LengthMapping(this.modified, (0, _lengthJs.lengthZero), remainingLengthAfter)
        ];
        else return [
            new LengthMapping(this.modified, lengthAfter, lengthAfter),
            new LengthMapping(this.modified, remainingLengthAfter, remainingLengthAfter)
        ];
    }
    toString() {
        return `${this.modified ? "M" : "U"}:${(0, _lengthJs.lengthToObj)(this.lengthBefore)} -> ${(0, _lengthJs.lengthToObj)(this.lengthAfter)}`;
    }
}
function toLengthMapping(textEditInfos) {
    const result = [];
    let lastOffset = (0, _lengthJs.lengthZero);
    for (const textEditInfo of textEditInfos){
        const spaceLength = (0, _lengthJs.lengthDiffNonNegative)(lastOffset, textEditInfo.startOffset);
        if (!(0, _lengthJs.lengthIsZero)(spaceLength)) result.push(new LengthMapping(false, spaceLength, spaceLength));
        const lengthBefore = (0, _lengthJs.lengthDiffNonNegative)(textEditInfo.startOffset, textEditInfo.endOffset);
        result.push(new LengthMapping(true, lengthBefore, textEditInfo.newLength));
        lastOffset = textEditInfo.endOffset;
    }
    return result;
}

},{"../../../../../base/common/arrays.js":"DECei","./beforeEditPositionMapper.js":"kLXi3","./length.js":"lbA4G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hZpLU":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorizedBracketPairsDecorationProvider", ()=>ColorizedBracketPairsDecorationProvider);
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _rangeJs = require("../../core/range.js");
var _editorColorRegistryJs = require("../../core/editorColorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
class ColorizedBracketPairsDecorationProvider extends (0, _lifecycleJs.Disposable) {
    constructor(textModel){
        super();
        this.textModel = textModel;
        this.colorProvider = new ColorProvider();
        this.onDidChangeEmitter = new (0, _eventJs.Emitter)();
        this.onDidChange = this.onDidChangeEmitter.event;
        this.colorizationOptions = textModel.getOptions().bracketPairColorizationOptions;
        this._register(textModel.bracketPairs.onDidChange((e)=>{
            this.onDidChangeEmitter.fire();
        }));
    }
    //#region TextModel events
    handleDidChangeOptions(e) {
        this.colorizationOptions = this.textModel.getOptions().bracketPairColorizationOptions;
    }
    //#endregion
    getDecorationsInRange(range, ownerId, filterOutValidation, onlyMinimapDecorations) {
        if (onlyMinimapDecorations) // Bracket pair colorization decorations are not rendered in the minimap
        return [];
        if (ownerId === undefined) return [];
        if (!this.colorizationOptions.enabled) return [];
        const result = this.textModel.bracketPairs.getBracketsInRange(range, true).map((bracket)=>({
                id: `bracket${bracket.range.toString()}-${bracket.nestingLevel}`,
                options: {
                    description: "BracketPairColorization",
                    inlineClassName: this.colorProvider.getInlineClassName(bracket, this.colorizationOptions.independentColorPoolPerBracketType)
                },
                ownerId: 0,
                range: bracket.range
            })).toArray();
        return result;
    }
    getAllDecorations(ownerId, filterOutValidation) {
        if (ownerId === undefined) return [];
        if (!this.colorizationOptions.enabled) return [];
        return this.getDecorationsInRange(new (0, _rangeJs.Range)(1, 1, this.textModel.getLineCount(), 1), ownerId, filterOutValidation);
    }
}
class ColorProvider {
    constructor(){
        this.unexpectedClosingBracketClassName = "unexpected-closing-bracket";
    }
    getInlineClassName(bracket, independentColorPoolPerBracketType) {
        if (bracket.isInvalid) return this.unexpectedClosingBracketClassName;
        return this.getInlineClassNameOfLevel(independentColorPoolPerBracketType ? bracket.nestingLevelOfEqualBracketType : bracket.nestingLevel);
    }
    getInlineClassNameOfLevel(level) {
        // To support a dynamic amount of colors up to 6 colors,
        // we use a number that is a lcm of all numbers from 1 to 6.
        return `bracket-highlighting-${level % 30}`;
    }
}
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const colors = [
        (0, _editorColorRegistryJs.editorBracketHighlightingForeground1),
        (0, _editorColorRegistryJs.editorBracketHighlightingForeground2),
        (0, _editorColorRegistryJs.editorBracketHighlightingForeground3),
        (0, _editorColorRegistryJs.editorBracketHighlightingForeground4),
        (0, _editorColorRegistryJs.editorBracketHighlightingForeground5),
        (0, _editorColorRegistryJs.editorBracketHighlightingForeground6)
    ];
    const colorProvider = new ColorProvider();
    collector.addRule(`.monaco-editor .${colorProvider.unexpectedClosingBracketClassName} { color: ${theme.getColor((0, _editorColorRegistryJs.editorBracketHighlightingUnexpectedBracketForeground))}; }`);
    const colorValues = colors.map((c)=>theme.getColor(c)).filter((c)=>!!c).filter((c)=>!c.isTransparent());
    for(let level = 0; level < 30; level++){
        const color = colorValues[level % colorValues.length];
        collector.addRule(`.monaco-editor .${colorProvider.getInlineClassNameOfLevel(level)} { color: ${color}; }`);
    }
});

},{"../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../core/range.js":"jmUPh","../../core/editorColorRegistry.js":"5XqtL","../../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iS9MJ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SingleModelEditStackData", ()=>SingleModelEditStackData);
parcelHelpers.export(exports, "SingleModelEditStackElement", ()=>SingleModelEditStackElement);
parcelHelpers.export(exports, "MultiModelEditStackElement", ()=>MultiModelEditStackElement);
parcelHelpers.export(exports, "isEditStackElement", ()=>isEditStackElement);
parcelHelpers.export(exports, "EditStack", ()=>EditStack);
var _nlsJs = require("../../../nls.js");
var _errorsJs = require("../../../base/common/errors.js");
var _selectionJs = require("../core/selection.js");
var _uriJs = require("../../../base/common/uri.js");
var _textChangeJs = require("../core/textChange.js");
var _bufferJs = require("../../../base/common/buffer.js");
var _resourcesJs = require("../../../base/common/resources.js");
function uriGetComparisonKey(resource) {
    return resource.toString();
}
class SingleModelEditStackData {
    static create(model, beforeCursorState) {
        const alternativeVersionId = model.getAlternativeVersionId();
        const eol = getModelEOL(model);
        return new SingleModelEditStackData(alternativeVersionId, alternativeVersionId, eol, eol, beforeCursorState, beforeCursorState, []);
    }
    constructor(beforeVersionId, afterVersionId, beforeEOL, afterEOL, beforeCursorState, afterCursorState, changes){
        this.beforeVersionId = beforeVersionId;
        this.afterVersionId = afterVersionId;
        this.beforeEOL = beforeEOL;
        this.afterEOL = afterEOL;
        this.beforeCursorState = beforeCursorState;
        this.afterCursorState = afterCursorState;
        this.changes = changes;
    }
    append(model, textChanges, afterEOL, afterVersionId, afterCursorState) {
        if (textChanges.length > 0) this.changes = (0, _textChangeJs.compressConsecutiveTextChanges)(this.changes, textChanges);
        this.afterEOL = afterEOL;
        this.afterVersionId = afterVersionId;
        this.afterCursorState = afterCursorState;
    }
    static _writeSelectionsSize(selections) {
        return 4 + 16 * (selections ? selections.length : 0);
    }
    static _writeSelections(b, selections, offset) {
        _bufferJs.writeUInt32BE(b, selections ? selections.length : 0, offset);
        offset += 4;
        if (selections) for (const selection of selections){
            _bufferJs.writeUInt32BE(b, selection.selectionStartLineNumber, offset);
            offset += 4;
            _bufferJs.writeUInt32BE(b, selection.selectionStartColumn, offset);
            offset += 4;
            _bufferJs.writeUInt32BE(b, selection.positionLineNumber, offset);
            offset += 4;
            _bufferJs.writeUInt32BE(b, selection.positionColumn, offset);
            offset += 4;
        }
        return offset;
    }
    static _readSelections(b, offset, dest) {
        const count = _bufferJs.readUInt32BE(b, offset);
        offset += 4;
        for(let i = 0; i < count; i++){
            const selectionStartLineNumber = _bufferJs.readUInt32BE(b, offset);
            offset += 4;
            const selectionStartColumn = _bufferJs.readUInt32BE(b, offset);
            offset += 4;
            const positionLineNumber = _bufferJs.readUInt32BE(b, offset);
            offset += 4;
            const positionColumn = _bufferJs.readUInt32BE(b, offset);
            offset += 4;
            dest.push(new (0, _selectionJs.Selection)(selectionStartLineNumber, selectionStartColumn, positionLineNumber, positionColumn));
        }
        return offset;
    }
    serialize() {
        let necessarySize = 10 // afterEOL
         + SingleModelEditStackData._writeSelectionsSize(this.beforeCursorState) + SingleModelEditStackData._writeSelectionsSize(this.afterCursorState) + 4 // change count
        ;
        for (const change of this.changes)necessarySize += change.writeSize();
        const b = new Uint8Array(necessarySize);
        let offset = 0;
        _bufferJs.writeUInt32BE(b, this.beforeVersionId, offset);
        offset += 4;
        _bufferJs.writeUInt32BE(b, this.afterVersionId, offset);
        offset += 4;
        _bufferJs.writeUInt8(b, this.beforeEOL, offset);
        offset += 1;
        _bufferJs.writeUInt8(b, this.afterEOL, offset);
        offset += 1;
        offset = SingleModelEditStackData._writeSelections(b, this.beforeCursorState, offset);
        offset = SingleModelEditStackData._writeSelections(b, this.afterCursorState, offset);
        _bufferJs.writeUInt32BE(b, this.changes.length, offset);
        offset += 4;
        for (const change of this.changes)offset = change.write(b, offset);
        return b.buffer;
    }
    static deserialize(source) {
        const b = new Uint8Array(source);
        let offset = 0;
        const beforeVersionId = _bufferJs.readUInt32BE(b, offset);
        offset += 4;
        const afterVersionId = _bufferJs.readUInt32BE(b, offset);
        offset += 4;
        const beforeEOL = _bufferJs.readUInt8(b, offset);
        offset += 1;
        const afterEOL = _bufferJs.readUInt8(b, offset);
        offset += 1;
        const beforeCursorState = [];
        offset = SingleModelEditStackData._readSelections(b, offset, beforeCursorState);
        const afterCursorState = [];
        offset = SingleModelEditStackData._readSelections(b, offset, afterCursorState);
        const changeCount = _bufferJs.readUInt32BE(b, offset);
        offset += 4;
        const changes = [];
        for(let i = 0; i < changeCount; i++)offset = (0, _textChangeJs.TextChange).read(b, offset, changes);
        return new SingleModelEditStackData(beforeVersionId, afterVersionId, beforeEOL, afterEOL, beforeCursorState, afterCursorState, changes);
    }
}
class SingleModelEditStackElement {
    get type() {
        return 0 /* UndoRedoElementType.Resource */ ;
    }
    get resource() {
        if ((0, _uriJs.URI).isUri(this.model)) return this.model;
        return this.model.uri;
    }
    constructor(label, code, model, beforeCursorState){
        this.label = label;
        this.code = code;
        this.model = model;
        this._data = SingleModelEditStackData.create(model, beforeCursorState);
    }
    toString() {
        const data = this._data instanceof SingleModelEditStackData ? this._data : SingleModelEditStackData.deserialize(this._data);
        return data.changes.map((change)=>change.toString()).join(", ");
    }
    matchesResource(resource) {
        const uri = (0, _uriJs.URI).isUri(this.model) ? this.model : this.model.uri;
        return uri.toString() === resource.toString();
    }
    setModel(model) {
        this.model = model;
    }
    canAppend(model) {
        return this.model === model && this._data instanceof SingleModelEditStackData;
    }
    append(model, textChanges, afterEOL, afterVersionId, afterCursorState) {
        if (this._data instanceof SingleModelEditStackData) this._data.append(model, textChanges, afterEOL, afterVersionId, afterCursorState);
    }
    close() {
        if (this._data instanceof SingleModelEditStackData) this._data = this._data.serialize();
    }
    open() {
        if (!(this._data instanceof SingleModelEditStackData)) this._data = SingleModelEditStackData.deserialize(this._data);
    }
    undo() {
        if ((0, _uriJs.URI).isUri(this.model)) // don't have a model
        throw new Error(`Invalid SingleModelEditStackElement`);
        if (this._data instanceof SingleModelEditStackData) this._data = this._data.serialize();
        const data = SingleModelEditStackData.deserialize(this._data);
        this.model._applyUndo(data.changes, data.beforeEOL, data.beforeVersionId, data.beforeCursorState);
    }
    redo() {
        if ((0, _uriJs.URI).isUri(this.model)) // don't have a model
        throw new Error(`Invalid SingleModelEditStackElement`);
        if (this._data instanceof SingleModelEditStackData) this._data = this._data.serialize();
        const data = SingleModelEditStackData.deserialize(this._data);
        this.model._applyRedo(data.changes, data.afterEOL, data.afterVersionId, data.afterCursorState);
    }
    heapSize() {
        if (this._data instanceof SingleModelEditStackData) this._data = this._data.serialize();
        return this._data.byteLength + 168 /*heap overhead*/ ;
    }
}
class MultiModelEditStackElement {
    get resources() {
        return this._editStackElementsArr.map((editStackElement)=>editStackElement.resource);
    }
    constructor(label, code, editStackElements){
        this.label = label;
        this.code = code;
        this.type = 1 /* UndoRedoElementType.Workspace */ ;
        this._isOpen = true;
        this._editStackElementsArr = editStackElements.slice(0);
        this._editStackElementsMap = new Map();
        for (const editStackElement of this._editStackElementsArr){
            const key = uriGetComparisonKey(editStackElement.resource);
            this._editStackElementsMap.set(key, editStackElement);
        }
        this._delegate = null;
    }
    prepareUndoRedo() {
        if (this._delegate) return this._delegate.prepareUndoRedo(this);
    }
    matchesResource(resource) {
        const key = uriGetComparisonKey(resource);
        return this._editStackElementsMap.has(key);
    }
    setModel(model) {
        const key = uriGetComparisonKey((0, _uriJs.URI).isUri(model) ? model : model.uri);
        if (this._editStackElementsMap.has(key)) this._editStackElementsMap.get(key).setModel(model);
    }
    canAppend(model) {
        if (!this._isOpen) return false;
        const key = uriGetComparisonKey(model.uri);
        if (this._editStackElementsMap.has(key)) {
            const editStackElement = this._editStackElementsMap.get(key);
            return editStackElement.canAppend(model);
        }
        return false;
    }
    append(model, textChanges, afterEOL, afterVersionId, afterCursorState) {
        const key = uriGetComparisonKey(model.uri);
        const editStackElement = this._editStackElementsMap.get(key);
        editStackElement.append(model, textChanges, afterEOL, afterVersionId, afterCursorState);
    }
    close() {
        this._isOpen = false;
    }
    open() {
    // cannot reopen
    }
    undo() {
        this._isOpen = false;
        for (const editStackElement of this._editStackElementsArr)editStackElement.undo();
    }
    redo() {
        for (const editStackElement of this._editStackElementsArr)editStackElement.redo();
    }
    heapSize(resource) {
        const key = uriGetComparisonKey(resource);
        if (this._editStackElementsMap.has(key)) {
            const editStackElement = this._editStackElementsMap.get(key);
            return editStackElement.heapSize();
        }
        return 0;
    }
    split() {
        return this._editStackElementsArr;
    }
    toString() {
        const result = [];
        for (const editStackElement of this._editStackElementsArr)result.push(`${(0, _resourcesJs.basename)(editStackElement.resource)}: ${editStackElement}`);
        return `{${result.join(", ")}}`;
    }
}
function getModelEOL(model) {
    const eol = model.getEOL();
    if (eol === "\n") return 0 /* EndOfLineSequence.LF */ ;
    else return 1 /* EndOfLineSequence.CRLF */ ;
}
function isEditStackElement(element) {
    if (!element) return false;
    return element instanceof SingleModelEditStackElement || element instanceof MultiModelEditStackElement;
}
class EditStack {
    constructor(model, undoRedoService){
        this._model = model;
        this._undoRedoService = undoRedoService;
    }
    pushStackElement() {
        const lastElement = this._undoRedoService.getLastElement(this._model.uri);
        if (isEditStackElement(lastElement)) lastElement.close();
    }
    popStackElement() {
        const lastElement = this._undoRedoService.getLastElement(this._model.uri);
        if (isEditStackElement(lastElement)) lastElement.open();
    }
    clear() {
        this._undoRedoService.removeElements(this._model.uri);
    }
    _getOrCreateEditStackElement(beforeCursorState, group) {
        const lastElement = this._undoRedoService.getLastElement(this._model.uri);
        if (isEditStackElement(lastElement) && lastElement.canAppend(this._model)) return lastElement;
        const newElement = new SingleModelEditStackElement(_nlsJs.localize("edit", "Typing"), "undoredo.textBufferEdit", this._model, beforeCursorState);
        this._undoRedoService.pushElement(newElement, group);
        return newElement;
    }
    pushEOL(eol) {
        const editStackElement = this._getOrCreateEditStackElement(null, undefined);
        this._model.setEOL(eol);
        editStackElement.append(this._model, [], getModelEOL(this._model), this._model.getAlternativeVersionId(), null);
    }
    pushEditOperation(beforeCursorState, editOperations, cursorStateComputer, group) {
        const editStackElement = this._getOrCreateEditStackElement(beforeCursorState, group);
        const inverseEditOperations = this._model.applyEdits(editOperations, true);
        const afterCursorState = EditStack._computeCursorState(cursorStateComputer, inverseEditOperations);
        const textChanges = inverseEditOperations.map((op, index)=>({
                index: index,
                textChange: op.textChange
            }));
        textChanges.sort((a, b)=>{
            if (a.textChange.oldPosition === b.textChange.oldPosition) return a.index - b.index;
            return a.textChange.oldPosition - b.textChange.oldPosition;
        });
        editStackElement.append(this._model, textChanges.map((op)=>op.textChange), getModelEOL(this._model), this._model.getAlternativeVersionId(), afterCursorState);
        return afterCursorState;
    }
    static _computeCursorState(cursorStateComputer, inverseEditOperations) {
        try {
            return cursorStateComputer ? cursorStateComputer(inverseEditOperations) : null;
        } catch (e) {
            (0, _errorsJs.onUnexpectedError)(e);
            return null;
        }
    }
}

},{"../../../nls.js":"l617d","../../../base/common/errors.js":"divX8","../core/selection.js":"kcwzU","../../../base/common/uri.js":"7qGS3","../core/textChange.js":"iZMJm","../../../base/common/buffer.js":"cRDFR","../../../base/common/resources.js":"700EV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iZMJm":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextChange", ()=>TextChange);
parcelHelpers.export(exports, "compressConsecutiveTextChanges", ()=>compressConsecutiveTextChanges);
var _bufferJs = require("../../../base/common/buffer.js");
var _stringBuilderJs = require("./stringBuilder.js");
function escapeNewLine(str) {
    return str.replace(/\n/g, "\\n").replace(/\r/g, "\\r");
}
class TextChange {
    get oldLength() {
        return this.oldText.length;
    }
    get oldEnd() {
        return this.oldPosition + this.oldText.length;
    }
    get newLength() {
        return this.newText.length;
    }
    get newEnd() {
        return this.newPosition + this.newText.length;
    }
    constructor(oldPosition, oldText, newPosition, newText){
        this.oldPosition = oldPosition;
        this.oldText = oldText;
        this.newPosition = newPosition;
        this.newText = newText;
    }
    toString() {
        if (this.oldText.length === 0) return `(insert@${this.oldPosition} "${escapeNewLine(this.newText)}")`;
        if (this.newText.length === 0) return `(delete@${this.oldPosition} "${escapeNewLine(this.oldText)}")`;
        return `(replace@${this.oldPosition} "${escapeNewLine(this.oldText)}" with "${escapeNewLine(this.newText)}")`;
    }
    static _writeStringSize(str) {
        return 4 + 2 * str.length;
    }
    static _writeString(b, str, offset) {
        const len = str.length;
        _bufferJs.writeUInt32BE(b, len, offset);
        offset += 4;
        for(let i = 0; i < len; i++){
            _bufferJs.writeUInt16LE(b, str.charCodeAt(i), offset);
            offset += 2;
        }
        return offset;
    }
    static _readString(b, offset) {
        const len = _bufferJs.readUInt32BE(b, offset);
        offset += 4;
        return (0, _stringBuilderJs.decodeUTF16LE)(b, offset, len);
    }
    writeSize() {
        return 8 // newPosition
         + TextChange._writeStringSize(this.oldText) + TextChange._writeStringSize(this.newText);
    }
    write(b, offset) {
        _bufferJs.writeUInt32BE(b, this.oldPosition, offset);
        offset += 4;
        _bufferJs.writeUInt32BE(b, this.newPosition, offset);
        offset += 4;
        offset = TextChange._writeString(b, this.oldText, offset);
        offset = TextChange._writeString(b, this.newText, offset);
        return offset;
    }
    static read(b, offset, dest) {
        const oldPosition = _bufferJs.readUInt32BE(b, offset);
        offset += 4;
        const newPosition = _bufferJs.readUInt32BE(b, offset);
        offset += 4;
        const oldText = TextChange._readString(b, offset);
        offset += TextChange._writeStringSize(oldText);
        const newText = TextChange._readString(b, offset);
        offset += TextChange._writeStringSize(newText);
        dest.push(new TextChange(oldPosition, oldText, newPosition, newText));
        return offset;
    }
}
function compressConsecutiveTextChanges(prevEdits, currEdits) {
    if (prevEdits === null || prevEdits.length === 0) return currEdits;
    const compressor = new TextChangeCompressor(prevEdits, currEdits);
    return compressor.compress();
}
class TextChangeCompressor {
    constructor(prevEdits, currEdits){
        this._prevEdits = prevEdits;
        this._currEdits = currEdits;
        this._result = [];
        this._resultLen = 0;
        this._prevLen = this._prevEdits.length;
        this._prevDeltaOffset = 0;
        this._currLen = this._currEdits.length;
        this._currDeltaOffset = 0;
    }
    compress() {
        let prevIndex = 0;
        let currIndex = 0;
        let prevEdit = this._getPrev(prevIndex);
        let currEdit = this._getCurr(currIndex);
        while(prevIndex < this._prevLen || currIndex < this._currLen){
            if (prevEdit === null) {
                this._acceptCurr(currEdit);
                currEdit = this._getCurr(++currIndex);
                continue;
            }
            if (currEdit === null) {
                this._acceptPrev(prevEdit);
                prevEdit = this._getPrev(++prevIndex);
                continue;
            }
            if (currEdit.oldEnd <= prevEdit.newPosition) {
                this._acceptCurr(currEdit);
                currEdit = this._getCurr(++currIndex);
                continue;
            }
            if (prevEdit.newEnd <= currEdit.oldPosition) {
                this._acceptPrev(prevEdit);
                prevEdit = this._getPrev(++prevIndex);
                continue;
            }
            if (currEdit.oldPosition < prevEdit.newPosition) {
                const [e1, e2] = TextChangeCompressor._splitCurr(currEdit, prevEdit.newPosition - currEdit.oldPosition);
                this._acceptCurr(e1);
                currEdit = e2;
                continue;
            }
            if (prevEdit.newPosition < currEdit.oldPosition) {
                const [e1, e2] = TextChangeCompressor._splitPrev(prevEdit, currEdit.oldPosition - prevEdit.newPosition);
                this._acceptPrev(e1);
                prevEdit = e2;
                continue;
            }
            // At this point, currEdit.oldPosition === prevEdit.newPosition
            let mergePrev;
            let mergeCurr;
            if (currEdit.oldEnd === prevEdit.newEnd) {
                mergePrev = prevEdit;
                mergeCurr = currEdit;
                prevEdit = this._getPrev(++prevIndex);
                currEdit = this._getCurr(++currIndex);
            } else if (currEdit.oldEnd < prevEdit.newEnd) {
                const [e1, e2] = TextChangeCompressor._splitPrev(prevEdit, currEdit.oldLength);
                mergePrev = e1;
                mergeCurr = currEdit;
                prevEdit = e2;
                currEdit = this._getCurr(++currIndex);
            } else {
                const [e1, e2] = TextChangeCompressor._splitCurr(currEdit, prevEdit.newLength);
                mergePrev = prevEdit;
                mergeCurr = e1;
                prevEdit = this._getPrev(++prevIndex);
                currEdit = e2;
            }
            this._result[this._resultLen++] = new TextChange(mergePrev.oldPosition, mergePrev.oldText, mergeCurr.newPosition, mergeCurr.newText);
            this._prevDeltaOffset += mergePrev.newLength - mergePrev.oldLength;
            this._currDeltaOffset += mergeCurr.newLength - mergeCurr.oldLength;
        }
        const merged = TextChangeCompressor._merge(this._result);
        const cleaned = TextChangeCompressor._removeNoOps(merged);
        return cleaned;
    }
    _acceptCurr(currEdit) {
        this._result[this._resultLen++] = TextChangeCompressor._rebaseCurr(this._prevDeltaOffset, currEdit);
        this._currDeltaOffset += currEdit.newLength - currEdit.oldLength;
    }
    _getCurr(currIndex) {
        return currIndex < this._currLen ? this._currEdits[currIndex] : null;
    }
    _acceptPrev(prevEdit) {
        this._result[this._resultLen++] = TextChangeCompressor._rebasePrev(this._currDeltaOffset, prevEdit);
        this._prevDeltaOffset += prevEdit.newLength - prevEdit.oldLength;
    }
    _getPrev(prevIndex) {
        return prevIndex < this._prevLen ? this._prevEdits[prevIndex] : null;
    }
    static _rebaseCurr(prevDeltaOffset, currEdit) {
        return new TextChange(currEdit.oldPosition - prevDeltaOffset, currEdit.oldText, currEdit.newPosition, currEdit.newText);
    }
    static _rebasePrev(currDeltaOffset, prevEdit) {
        return new TextChange(prevEdit.oldPosition, prevEdit.oldText, prevEdit.newPosition + currDeltaOffset, prevEdit.newText);
    }
    static _splitPrev(edit, offset) {
        const preText = edit.newText.substr(0, offset);
        const postText = edit.newText.substr(offset);
        return [
            new TextChange(edit.oldPosition, edit.oldText, edit.newPosition, preText),
            new TextChange(edit.oldEnd, "", edit.newPosition + offset, postText)
        ];
    }
    static _splitCurr(edit, offset) {
        const preText = edit.oldText.substr(0, offset);
        const postText = edit.oldText.substr(offset);
        return [
            new TextChange(edit.oldPosition, preText, edit.newPosition, edit.newText),
            new TextChange(edit.oldPosition + offset, postText, edit.newEnd, "")
        ];
    }
    static _merge(edits) {
        if (edits.length === 0) return edits;
        const result = [];
        let resultLen = 0;
        let prev = edits[0];
        for(let i = 1; i < edits.length; i++){
            const curr = edits[i];
            if (prev.oldEnd === curr.oldPosition) // Merge into `prev`
            prev = new TextChange(prev.oldPosition, prev.oldText + curr.oldText, prev.newPosition, prev.newText + curr.newText);
            else {
                result[resultLen++] = prev;
                prev = curr;
            }
        }
        result[resultLen++] = prev;
        return result;
    }
    static _removeNoOps(edits) {
        if (edits.length === 0) return edits;
        const result = [];
        let resultLen = 0;
        for(let i = 0; i < edits.length; i++){
            const edit = edits[i];
            if (edit.oldText === edit.newText) continue;
            result[resultLen++] = edit;
        }
        return result;
    }
}

},{"../../../base/common/buffer.js":"cRDFR","./stringBuilder.js":"hHgWQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k7k2K":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuidesTextModelPart", ()=>GuidesTextModelPart);
parcelHelpers.export(exports, "BracketPairGuidesClassNames", ()=>BracketPairGuidesClassNames);
var _arraysFindJs = require("../../../base/common/arraysFind.js");
var _stringsJs = require("../../../base/common/strings.js");
var _cursorColumnsJs = require("../core/cursorColumns.js");
var _rangeJs = require("../core/range.js");
var _textModelPartJs = require("./textModelPart.js");
var _utilsJs = require("./utils.js");
var _textModelGuidesJs = require("../textModelGuides.js");
var _errorsJs = require("../../../base/common/errors.js");
class GuidesTextModelPart extends (0, _textModelPartJs.TextModelPart) {
    constructor(textModel, languageConfigurationService){
        super();
        this.textModel = textModel;
        this.languageConfigurationService = languageConfigurationService;
    }
    getLanguageConfiguration(languageId) {
        return this.languageConfigurationService.getLanguageConfiguration(languageId);
    }
    _computeIndentLevel(lineIndex) {
        return (0, _utilsJs.computeIndentLevel)(this.textModel.getLineContent(lineIndex + 1), this.textModel.getOptions().tabSize);
    }
    getActiveIndentGuide(lineNumber, minLineNumber, maxLineNumber) {
        this.assertNotDisposed();
        const lineCount = this.textModel.getLineCount();
        if (lineNumber < 1 || lineNumber > lineCount) throw new (0, _errorsJs.BugIndicatingError)("Illegal value for lineNumber");
        const foldingRules = this.getLanguageConfiguration(this.textModel.getLanguageId()).foldingRules;
        const offSide = Boolean(foldingRules && foldingRules.offSide);
        let up_aboveContentLineIndex = -2; /* -2 is a marker for not having computed it */ 
        let up_aboveContentLineIndent = -1;
        let up_belowContentLineIndex = -2; /* -2 is a marker for not having computed it */ 
        let up_belowContentLineIndent = -1;
        const up_resolveIndents = (lineNumber)=>{
            if (up_aboveContentLineIndex !== -1 && (up_aboveContentLineIndex === -2 || up_aboveContentLineIndex > lineNumber - 1)) {
                up_aboveContentLineIndex = -1;
                up_aboveContentLineIndent = -1;
                // must find previous line with content
                for(let lineIndex = lineNumber - 2; lineIndex >= 0; lineIndex--){
                    const indent = this._computeIndentLevel(lineIndex);
                    if (indent >= 0) {
                        up_aboveContentLineIndex = lineIndex;
                        up_aboveContentLineIndent = indent;
                        break;
                    }
                }
            }
            if (up_belowContentLineIndex === -2) {
                up_belowContentLineIndex = -1;
                up_belowContentLineIndent = -1;
                // must find next line with content
                for(let lineIndex = lineNumber; lineIndex < lineCount; lineIndex++){
                    const indent = this._computeIndentLevel(lineIndex);
                    if (indent >= 0) {
                        up_belowContentLineIndex = lineIndex;
                        up_belowContentLineIndent = indent;
                        break;
                    }
                }
            }
        };
        let down_aboveContentLineIndex = -2; /* -2 is a marker for not having computed it */ 
        let down_aboveContentLineIndent = -1;
        let down_belowContentLineIndex = -2; /* -2 is a marker for not having computed it */ 
        let down_belowContentLineIndent = -1;
        const down_resolveIndents = (lineNumber)=>{
            if (down_aboveContentLineIndex === -2) {
                down_aboveContentLineIndex = -1;
                down_aboveContentLineIndent = -1;
                // must find previous line with content
                for(let lineIndex = lineNumber - 2; lineIndex >= 0; lineIndex--){
                    const indent = this._computeIndentLevel(lineIndex);
                    if (indent >= 0) {
                        down_aboveContentLineIndex = lineIndex;
                        down_aboveContentLineIndent = indent;
                        break;
                    }
                }
            }
            if (down_belowContentLineIndex !== -1 && (down_belowContentLineIndex === -2 || down_belowContentLineIndex < lineNumber - 1)) {
                down_belowContentLineIndex = -1;
                down_belowContentLineIndent = -1;
                // must find next line with content
                for(let lineIndex = lineNumber; lineIndex < lineCount; lineIndex++){
                    const indent = this._computeIndentLevel(lineIndex);
                    if (indent >= 0) {
                        down_belowContentLineIndex = lineIndex;
                        down_belowContentLineIndent = indent;
                        break;
                    }
                }
            }
        };
        let startLineNumber = 0;
        let goUp = true;
        let endLineNumber = 0;
        let goDown = true;
        let indent = 0;
        let initialIndent = 0;
        for(let distance = 0; goUp || goDown; distance++){
            const upLineNumber = lineNumber - distance;
            const downLineNumber = lineNumber + distance;
            if (distance > 1 && (upLineNumber < 1 || upLineNumber < minLineNumber)) goUp = false;
            if (distance > 1 && (downLineNumber > lineCount || downLineNumber > maxLineNumber)) goDown = false;
            if (distance > 50000) {
                // stop processing
                goUp = false;
                goDown = false;
            }
            let upLineIndentLevel = -1;
            if (goUp && upLineNumber >= 1) {
                // compute indent level going up
                const currentIndent = this._computeIndentLevel(upLineNumber - 1);
                if (currentIndent >= 0) {
                    // This line has content (besides whitespace)
                    // Use the line's indent
                    up_belowContentLineIndex = upLineNumber - 1;
                    up_belowContentLineIndent = currentIndent;
                    upLineIndentLevel = Math.ceil(currentIndent / this.textModel.getOptions().indentSize);
                } else {
                    up_resolveIndents(upLineNumber);
                    upLineIndentLevel = this._getIndentLevelForWhitespaceLine(offSide, up_aboveContentLineIndent, up_belowContentLineIndent);
                }
            }
            let downLineIndentLevel = -1;
            if (goDown && downLineNumber <= lineCount) {
                // compute indent level going down
                const currentIndent = this._computeIndentLevel(downLineNumber - 1);
                if (currentIndent >= 0) {
                    // This line has content (besides whitespace)
                    // Use the line's indent
                    down_aboveContentLineIndex = downLineNumber - 1;
                    down_aboveContentLineIndent = currentIndent;
                    downLineIndentLevel = Math.ceil(currentIndent / this.textModel.getOptions().indentSize);
                } else {
                    down_resolveIndents(downLineNumber);
                    downLineIndentLevel = this._getIndentLevelForWhitespaceLine(offSide, down_aboveContentLineIndent, down_belowContentLineIndent);
                }
            }
            if (distance === 0) {
                initialIndent = upLineIndentLevel;
                continue;
            }
            if (distance === 1) {
                if (downLineNumber <= lineCount && downLineIndentLevel >= 0 && initialIndent + 1 === downLineIndentLevel) {
                    // This is the beginning of a scope, we have special handling here, since we want the
                    // child scope indent to be active, not the parent scope
                    goUp = false;
                    startLineNumber = downLineNumber;
                    endLineNumber = downLineNumber;
                    indent = downLineIndentLevel;
                    continue;
                }
                if (upLineNumber >= 1 && upLineIndentLevel >= 0 && upLineIndentLevel - 1 === initialIndent) {
                    // This is the end of a scope, just like above
                    goDown = false;
                    startLineNumber = upLineNumber;
                    endLineNumber = upLineNumber;
                    indent = upLineIndentLevel;
                    continue;
                }
                startLineNumber = lineNumber;
                endLineNumber = lineNumber;
                indent = initialIndent;
                if (indent === 0) // No need to continue
                return {
                    startLineNumber,
                    endLineNumber,
                    indent
                };
            }
            if (goUp) {
                if (upLineIndentLevel >= indent) startLineNumber = upLineNumber;
                else goUp = false;
            }
            if (goDown) {
                if (downLineIndentLevel >= indent) endLineNumber = downLineNumber;
                else goDown = false;
            }
        }
        return {
            startLineNumber,
            endLineNumber,
            indent
        };
    }
    getLinesBracketGuides(startLineNumber, endLineNumber, activePosition, options) {
        const result = [];
        for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++)result.push([]);
        // If requested, this could be made configurable.
        const includeSingleLinePairs = true;
        const bracketPairs = this.textModel.bracketPairs.getBracketPairsInRangeWithMinIndentation(new (0, _rangeJs.Range)(startLineNumber, 1, endLineNumber, this.textModel.getLineMaxColumn(endLineNumber))).toArray();
        let activeBracketPairRange = undefined;
        if (activePosition && bracketPairs.length > 0) {
            const bracketsContainingActivePosition = (startLineNumber <= activePosition.lineNumber && activePosition.lineNumber <= endLineNumber ? bracketPairs : this.textModel.bracketPairs.getBracketPairsInRange((0, _rangeJs.Range).fromPositions(activePosition)).toArray()).filter((bp)=>(0, _rangeJs.Range).strictContainsPosition(bp.range, activePosition));
            activeBracketPairRange = (0, _arraysFindJs.findLast)(bracketsContainingActivePosition, (i)=>includeSingleLinePairs || i.range.startLineNumber !== i.range.endLineNumber)?.range;
        }
        const independentColorPoolPerBracketType = this.textModel.getOptions().bracketPairColorizationOptions.independentColorPoolPerBracketType;
        const colorProvider = new BracketPairGuidesClassNames();
        for (const pair of bracketPairs){
            /*


                    {
                    |
                    }

                    {
                    |
                    ----}

                ____{
                |test
                ----}

                renderHorizontalEndLineAtTheBottom:
                    {
                    |
                    |x}
                    --
                renderHorizontalEndLineAtTheBottom:
                ____{
                |test
                | x }
                ----
            */ if (!pair.closingBracketRange) continue;
            const isActive = activeBracketPairRange && pair.range.equalsRange(activeBracketPairRange);
            if (!isActive && !options.includeInactive) continue;
            const className = colorProvider.getInlineClassName(pair.nestingLevel, pair.nestingLevelOfEqualBracketType, independentColorPoolPerBracketType) + (options.highlightActive && isActive ? " " + colorProvider.activeClassName : "");
            const start = pair.openingBracketRange.getStartPosition();
            const end = pair.closingBracketRange.getStartPosition();
            const horizontalGuides = options.horizontalGuides === (0, _textModelGuidesJs.HorizontalGuidesState).Enabled || options.horizontalGuides === (0, _textModelGuidesJs.HorizontalGuidesState).EnabledForActive && isActive;
            if (pair.range.startLineNumber === pair.range.endLineNumber) {
                if (includeSingleLinePairs && horizontalGuides) result[pair.range.startLineNumber - startLineNumber].push(new (0, _textModelGuidesJs.IndentGuide)(-1, pair.openingBracketRange.getEndPosition().column, className, new (0, _textModelGuidesJs.IndentGuideHorizontalLine)(false, end.column), -1, -1));
                continue;
            }
            const endVisibleColumn = this.getVisibleColumnFromPosition(end);
            const startVisibleColumn = this.getVisibleColumnFromPosition(pair.openingBracketRange.getStartPosition());
            const guideVisibleColumn = Math.min(startVisibleColumn, endVisibleColumn, pair.minVisibleColumnIndentation + 1);
            let renderHorizontalEndLineAtTheBottom = false;
            const firstNonWsIndex = _stringsJs.firstNonWhitespaceIndex(this.textModel.getLineContent(pair.closingBracketRange.startLineNumber));
            const hasTextBeforeClosingBracket = firstNonWsIndex < pair.closingBracketRange.startColumn - 1;
            if (hasTextBeforeClosingBracket) renderHorizontalEndLineAtTheBottom = true;
            const visibleGuideStartLineNumber = Math.max(start.lineNumber, startLineNumber);
            const visibleGuideEndLineNumber = Math.min(end.lineNumber, endLineNumber);
            const offset = renderHorizontalEndLineAtTheBottom ? 1 : 0;
            for(let l = visibleGuideStartLineNumber; l < visibleGuideEndLineNumber + offset; l++)result[l - startLineNumber].push(new (0, _textModelGuidesJs.IndentGuide)(guideVisibleColumn, -1, className, null, l === start.lineNumber ? start.column : -1, l === end.lineNumber ? end.column : -1));
            if (horizontalGuides) {
                if (start.lineNumber >= startLineNumber && startVisibleColumn > guideVisibleColumn) result[start.lineNumber - startLineNumber].push(new (0, _textModelGuidesJs.IndentGuide)(guideVisibleColumn, -1, className, new (0, _textModelGuidesJs.IndentGuideHorizontalLine)(false, start.column), -1, -1));
                if (end.lineNumber <= endLineNumber && endVisibleColumn > guideVisibleColumn) result[end.lineNumber - startLineNumber].push(new (0, _textModelGuidesJs.IndentGuide)(guideVisibleColumn, -1, className, new (0, _textModelGuidesJs.IndentGuideHorizontalLine)(!renderHorizontalEndLineAtTheBottom, end.column), -1, -1));
            }
        }
        for (const guides of result)guides.sort((a, b)=>a.visibleColumn - b.visibleColumn);
        return result;
    }
    getVisibleColumnFromPosition(position) {
        return (0, _cursorColumnsJs.CursorColumns).visibleColumnFromColumn(this.textModel.getLineContent(position.lineNumber), position.column, this.textModel.getOptions().tabSize) + 1;
    }
    getLinesIndentGuides(startLineNumber, endLineNumber) {
        this.assertNotDisposed();
        const lineCount = this.textModel.getLineCount();
        if (startLineNumber < 1 || startLineNumber > lineCount) throw new Error("Illegal value for startLineNumber");
        if (endLineNumber < 1 || endLineNumber > lineCount) throw new Error("Illegal value for endLineNumber");
        const options = this.textModel.getOptions();
        const foldingRules = this.getLanguageConfiguration(this.textModel.getLanguageId()).foldingRules;
        const offSide = Boolean(foldingRules && foldingRules.offSide);
        const result = new Array(endLineNumber - startLineNumber + 1);
        let aboveContentLineIndex = -2; /* -2 is a marker for not having computed it */ 
        let aboveContentLineIndent = -1;
        let belowContentLineIndex = -2; /* -2 is a marker for not having computed it */ 
        let belowContentLineIndent = -1;
        for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++){
            const resultIndex = lineNumber - startLineNumber;
            const currentIndent = this._computeIndentLevel(lineNumber - 1);
            if (currentIndent >= 0) {
                // This line has content (besides whitespace)
                // Use the line's indent
                aboveContentLineIndex = lineNumber - 1;
                aboveContentLineIndent = currentIndent;
                result[resultIndex] = Math.ceil(currentIndent / options.indentSize);
                continue;
            }
            if (aboveContentLineIndex === -2) {
                aboveContentLineIndex = -1;
                aboveContentLineIndent = -1;
                // must find previous line with content
                for(let lineIndex = lineNumber - 2; lineIndex >= 0; lineIndex--){
                    const indent = this._computeIndentLevel(lineIndex);
                    if (indent >= 0) {
                        aboveContentLineIndex = lineIndex;
                        aboveContentLineIndent = indent;
                        break;
                    }
                }
            }
            if (belowContentLineIndex !== -1 && (belowContentLineIndex === -2 || belowContentLineIndex < lineNumber - 1)) {
                belowContentLineIndex = -1;
                belowContentLineIndent = -1;
                // must find next line with content
                for(let lineIndex = lineNumber; lineIndex < lineCount; lineIndex++){
                    const indent = this._computeIndentLevel(lineIndex);
                    if (indent >= 0) {
                        belowContentLineIndex = lineIndex;
                        belowContentLineIndent = indent;
                        break;
                    }
                }
            }
            result[resultIndex] = this._getIndentLevelForWhitespaceLine(offSide, aboveContentLineIndent, belowContentLineIndent);
        }
        return result;
    }
    _getIndentLevelForWhitespaceLine(offSide, aboveContentLineIndent, belowContentLineIndent) {
        const options = this.textModel.getOptions();
        if (aboveContentLineIndent === -1 || belowContentLineIndent === -1) // At the top or bottom of the file
        return 0;
        else if (aboveContentLineIndent < belowContentLineIndent) // we are inside the region above
        return 1 + Math.floor(aboveContentLineIndent / options.indentSize);
        else if (aboveContentLineIndent === belowContentLineIndent) // we are in between two regions
        return Math.ceil(belowContentLineIndent / options.indentSize);
        else {
            if (offSide) // same level as region below
            return Math.ceil(belowContentLineIndent / options.indentSize);
            else // we are inside the region that ends below
            return 1 + Math.floor(belowContentLineIndent / options.indentSize);
        }
    }
}
class BracketPairGuidesClassNames {
    constructor(){
        this.activeClassName = "indent-active";
    }
    getInlineClassName(nestingLevel, nestingLevelOfEqualBracketType, independentColorPoolPerBracketType) {
        return this.getInlineClassNameOfLevel(independentColorPoolPerBracketType ? nestingLevelOfEqualBracketType : nestingLevel);
    }
    getInlineClassNameOfLevel(level) {
        // To support a dynamic amount of colors up to 6 colors,
        // we use a number that is a lcm of all numbers from 1 to 6.
        return `bracket-indent-guide lvl-${level % 30}`;
    }
}

},{"../../../base/common/arraysFind.js":"gWrU0","../../../base/common/strings.js":"aA9I1","../core/cursorColumns.js":"idX7D","../core/range.js":"jmUPh","./textModelPart.js":"aVeVR","./utils.js":"gEgu8","../textModelGuides.js":"fnW8P","../../../base/common/errors.js":"divX8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aVeVR":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextModelPart", ()=>TextModelPart);
var _lifecycleJs = require("../../../base/common/lifecycle.js");
class TextModelPart extends (0, _lifecycleJs.Disposable) {
    constructor(){
        super(...arguments);
        this._isDisposed = false;
    }
    dispose() {
        super.dispose();
        this._isDisposed = true;
    }
    assertNotDisposed() {
        if (this._isDisposed) throw new Error("TextModelPart is disposed!");
    }
}

},{"../../../base/common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gEgu8":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 * Returns:
 *  - -1 => the line consists of whitespace
 *  - otherwise => the indent level is returned value
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "computeIndentLevel", ()=>computeIndentLevel);
function computeIndentLevel(line, tabSize) {
    let indent = 0;
    let i = 0;
    const len = line.length;
    while(i < len){
        const chCode = line.charCodeAt(i);
        if (chCode === 32 /* CharCode.Space */ ) indent++;
        else if (chCode === 9 /* CharCode.Tab */ ) indent = indent - indent % tabSize + tabSize;
        else break;
        i++;
    }
    if (i === len) return -1; // line only consists of whitespace
    return indent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fnW8P":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorizontalGuidesState", ()=>HorizontalGuidesState);
parcelHelpers.export(exports, "IndentGuide", ()=>IndentGuide);
parcelHelpers.export(exports, "IndentGuideHorizontalLine", ()=>IndentGuideHorizontalLine);
var HorizontalGuidesState;
(function(HorizontalGuidesState) {
    HorizontalGuidesState[HorizontalGuidesState["Disabled"] = 0] = "Disabled";
    HorizontalGuidesState[HorizontalGuidesState["EnabledForActive"] = 1] = "EnabledForActive";
    HorizontalGuidesState[HorizontalGuidesState["Enabled"] = 2] = "Enabled";
})(HorizontalGuidesState || (HorizontalGuidesState = {}));
class IndentGuide {
    constructor(visibleColumn, column, className, /**
     * If set, this indent guide is a horizontal guide (no vertical part).
     * It starts at visibleColumn and continues until endColumn.
    */ horizontalLine, /**
     * If set (!= -1), only show this guide for wrapped lines that don't contain this model column, but are after it.
    */ forWrappedLinesAfterColumn, forWrappedLinesBeforeOrAtColumn){
        this.visibleColumn = visibleColumn;
        this.column = column;
        this.className = className;
        this.horizontalLine = horizontalLine;
        this.forWrappedLinesAfterColumn = forWrappedLinesAfterColumn;
        this.forWrappedLinesBeforeOrAtColumn = forWrappedLinesBeforeOrAtColumn;
        if (visibleColumn !== -1 === (column !== -1)) throw new Error();
    }
}
class IndentGuideHorizontalLine {
    constructor(top, endColumn){
        this.top = top;
        this.endColumn = endColumn;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Fgj5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "guessIndentation", ()=>guessIndentation);
class SpacesDiffResult {
    constructor(){
        this.spacesDiff = 0;
        this.looksLikeAlignment = false;
    }
}
/**
 * Compute the diff in spaces between two line's indentation.
 */ function spacesDiff(a, aLength, b, bLength, result) {
    result.spacesDiff = 0;
    result.looksLikeAlignment = false;
    // This can go both ways (e.g.):
    //  - a: "\t"
    //  - b: "\t    "
    //  => This should count 1 tab and 4 spaces
    let i;
    for(i = 0; i < aLength && i < bLength; i++){
        const aCharCode = a.charCodeAt(i);
        const bCharCode = b.charCodeAt(i);
        if (aCharCode !== bCharCode) break;
    }
    let aSpacesCnt = 0, aTabsCount = 0;
    for(let j = i; j < aLength; j++){
        const aCharCode = a.charCodeAt(j);
        if (aCharCode === 32 /* CharCode.Space */ ) aSpacesCnt++;
        else aTabsCount++;
    }
    let bSpacesCnt = 0, bTabsCount = 0;
    for(let j = i; j < bLength; j++){
        const bCharCode = b.charCodeAt(j);
        if (bCharCode === 32 /* CharCode.Space */ ) bSpacesCnt++;
        else bTabsCount++;
    }
    if (aSpacesCnt > 0 && aTabsCount > 0) return;
    if (bSpacesCnt > 0 && bTabsCount > 0) return;
    const tabsDiff = Math.abs(aTabsCount - bTabsCount);
    const spacesDiff = Math.abs(aSpacesCnt - bSpacesCnt);
    if (tabsDiff === 0) {
        // check if the indentation difference might be caused by alignment reasons
        // sometime folks like to align their code, but this should not be used as a hint
        result.spacesDiff = spacesDiff;
        if (spacesDiff > 0 && 0 <= bSpacesCnt - 1 && bSpacesCnt - 1 < a.length && bSpacesCnt < b.length) {
            if (b.charCodeAt(bSpacesCnt) !== 32 /* CharCode.Space */  && a.charCodeAt(bSpacesCnt - 1) === 32 /* CharCode.Space */ ) {
                if (a.charCodeAt(a.length - 1) === 44 /* CharCode.Comma */ ) // This looks like an alignment desire: e.g.
                // const a = b + c,
                //       d = b - c;
                result.looksLikeAlignment = true;
            }
        }
        return;
    }
    if (spacesDiff % tabsDiff === 0) {
        result.spacesDiff = spacesDiff / tabsDiff;
        return;
    }
}
function guessIndentation(source, defaultTabSize, defaultInsertSpaces) {
    // Look at most at the first 10k lines
    const linesCount = Math.min(source.getLineCount(), 10000);
    let linesIndentedWithTabsCount = 0; // number of lines that contain at least one tab in indentation
    let linesIndentedWithSpacesCount = 0; // number of lines that contain only spaces in indentation
    let previousLineText = ""; // content of latest line that contained non-whitespace chars
    let previousLineIndentation = 0; // index at which latest line contained the first non-whitespace char
    const ALLOWED_TAB_SIZE_GUESSES = [
        2,
        4,
        6,
        8,
        3,
        5,
        7
    ]; // prefer even guesses for `tabSize`, limit to [2, 8].
    const MAX_ALLOWED_TAB_SIZE_GUESS = 8; // max(ALLOWED_TAB_SIZE_GUESSES) = 8
    const spacesDiffCount = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]; // `tabSize` scores
    const tmp = new SpacesDiffResult();
    for(let lineNumber = 1; lineNumber <= linesCount; lineNumber++){
        const currentLineLength = source.getLineLength(lineNumber);
        const currentLineText = source.getLineContent(lineNumber);
        // if the text buffer is chunk based, so long lines are cons-string, v8 will flattern the string when we check charCode.
        // checking charCode on chunks directly is cheaper.
        const useCurrentLineText = currentLineLength <= 65536;
        let currentLineHasContent = false; // does `currentLineText` contain non-whitespace chars
        let currentLineIndentation = 0; // index at which `currentLineText` contains the first non-whitespace char
        let currentLineSpacesCount = 0; // count of spaces found in `currentLineText` indentation
        let currentLineTabsCount = 0; // count of tabs found in `currentLineText` indentation
        for(let j = 0, lenJ = currentLineLength; j < lenJ; j++){
            const charCode = useCurrentLineText ? currentLineText.charCodeAt(j) : source.getLineCharCode(lineNumber, j);
            if (charCode === 9 /* CharCode.Tab */ ) currentLineTabsCount++;
            else if (charCode === 32 /* CharCode.Space */ ) currentLineSpacesCount++;
            else {
                // Hit non whitespace character on this line
                currentLineHasContent = true;
                currentLineIndentation = j;
                break;
            }
        }
        // Ignore empty or only whitespace lines
        if (!currentLineHasContent) continue;
        if (currentLineTabsCount > 0) linesIndentedWithTabsCount++;
        else if (currentLineSpacesCount > 1) linesIndentedWithSpacesCount++;
        spacesDiff(previousLineText, previousLineIndentation, currentLineText, currentLineIndentation, tmp);
        if (tmp.looksLikeAlignment) {
            // if defaultInsertSpaces === true && the spaces count == tabSize, we may want to count it as valid indentation
            //
            // - item1
            //   - item2
            //
            // otherwise skip this line entirely
            //
            // const a = 1,
            //       b = 2;
            if (!(defaultInsertSpaces && defaultTabSize === tmp.spacesDiff)) continue;
        }
        const currentSpacesDiff = tmp.spacesDiff;
        if (currentSpacesDiff <= MAX_ALLOWED_TAB_SIZE_GUESS) spacesDiffCount[currentSpacesDiff]++;
        previousLineText = currentLineText;
        previousLineIndentation = currentLineIndentation;
    }
    let insertSpaces = defaultInsertSpaces;
    if (linesIndentedWithTabsCount !== linesIndentedWithSpacesCount) insertSpaces = linesIndentedWithTabsCount < linesIndentedWithSpacesCount;
    let tabSize = defaultTabSize;
    // Guess tabSize only if inserting spaces...
    if (insertSpaces) {
        let tabSizeScore = insertSpaces ? 0 : 0.1 * linesCount;
        // console.log("score threshold: " + tabSizeScore);
        ALLOWED_TAB_SIZE_GUESSES.forEach((possibleTabSize)=>{
            const possibleTabSizeScore = spacesDiffCount[possibleTabSize];
            if (possibleTabSizeScore > tabSizeScore) {
                tabSizeScore = possibleTabSizeScore;
                tabSize = possibleTabSize;
            }
        });
        // Let a tabSize of 2 win even if it is not the maximum
        // (only in case 4 was guessed)
        if (tabSize === 4 && spacesDiffCount[4] > 0 && spacesDiffCount[2] > 0 && spacesDiffCount[2] >= spacesDiffCount[4] / 2) tabSize = 2;
    }
    // console.log('--------------------------');
    // console.log('linesIndentedWithTabsCount: ' + linesIndentedWithTabsCount + ', linesIndentedWithSpacesCount: ' + linesIndentedWithSpacesCount);
    // console.log('spacesDiffCount: ' + spacesDiffCount);
    // console.log('tabSize: ' + tabSize + ', tabSizeScore: ' + tabSizeScore);
    return {
        insertSpaces: insertSpaces,
        tabSize: tabSize
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bGmRA":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNodeColor", ()=>getNodeColor);
parcelHelpers.export(exports, "IntervalNode", ()=>IntervalNode);
parcelHelpers.export(exports, "SENTINEL", ()=>SENTINEL);
parcelHelpers.export(exports, "IntervalTree", ()=>IntervalTree);
/**
 * This is a lot more complicated than strictly necessary to maintain the same behaviour
 * as when decorations were implemented using two markers.
 */ parcelHelpers.export(exports, "nodeAcceptEdit", ()=>nodeAcceptEdit);
parcelHelpers.export(exports, "recomputeMaxEnd", ()=>recomputeMaxEnd);
//#endregion
//#region utils
parcelHelpers.export(exports, "intervalCompare", ()=>intervalCompare) //#endregion
;
function getNodeColor(node) {
    return (node.metadata & 1 /* Constants.ColorMask */ ) >>> 0 /* Constants.ColorOffset */ ;
}
function setNodeColor(node, color) {
    node.metadata = node.metadata & 254 /* Constants.ColorMaskInverse */  | color << 0 /* Constants.ColorOffset */ ;
}
function getNodeIsVisited(node) {
    return (node.metadata & 2 /* Constants.IsVisitedMask */ ) >>> 1 /* Constants.IsVisitedOffset */  === 1;
}
function setNodeIsVisited(node, value) {
    node.metadata = node.metadata & 253 /* Constants.IsVisitedMaskInverse */  | (value ? 1 : 0) << 1 /* Constants.IsVisitedOffset */ ;
}
function getNodeIsForValidation(node) {
    return (node.metadata & 4 /* Constants.IsForValidationMask */ ) >>> 2 /* Constants.IsForValidationOffset */  === 1;
}
function setNodeIsForValidation(node, value) {
    node.metadata = node.metadata & 251 /* Constants.IsForValidationMaskInverse */  | (value ? 1 : 0) << 2 /* Constants.IsForValidationOffset */ ;
}
function getNodeIsInGlyphMargin(node) {
    return (node.metadata & 64 /* Constants.IsMarginMask */ ) >>> 6 /* Constants.IsMarginOffset */  === 1;
}
function setNodeIsInGlyphMargin(node, value) {
    node.metadata = node.metadata & 191 /* Constants.IsMarginMaskInverse */  | (value ? 1 : 0) << 6 /* Constants.IsMarginOffset */ ;
}
function getNodeStickiness(node) {
    return (node.metadata & 24 /* Constants.StickinessMask */ ) >>> 3 /* Constants.StickinessOffset */ ;
}
function _setNodeStickiness(node, stickiness) {
    node.metadata = node.metadata & 231 /* Constants.StickinessMaskInverse */  | stickiness << 3 /* Constants.StickinessOffset */ ;
}
function getCollapseOnReplaceEdit(node) {
    return (node.metadata & 32 /* Constants.CollapseOnReplaceEditMask */ ) >>> 5 /* Constants.CollapseOnReplaceEditOffset */  === 1;
}
function setCollapseOnReplaceEdit(node, value) {
    node.metadata = node.metadata & 223 /* Constants.CollapseOnReplaceEditMaskInverse */  | (value ? 1 : 0) << 5 /* Constants.CollapseOnReplaceEditOffset */ ;
}
class IntervalNode {
    constructor(id, start, end){
        this.metadata = 0;
        this.parent = this;
        this.left = this;
        this.right = this;
        setNodeColor(this, 1 /* NodeColor.Red */ );
        this.start = start;
        this.end = end;
        // FORCE_OVERFLOWING_TEST: this.delta = start;
        this.delta = 0;
        this.maxEnd = end;
        this.id = id;
        this.ownerId = 0;
        this.options = null;
        setNodeIsForValidation(this, false);
        setNodeIsInGlyphMargin(this, false);
        _setNodeStickiness(this, 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ );
        setCollapseOnReplaceEdit(this, false);
        this.cachedVersionId = 0;
        this.cachedAbsoluteStart = start;
        this.cachedAbsoluteEnd = end;
        this.range = null;
        setNodeIsVisited(this, false);
    }
    reset(versionId, start, end, range) {
        this.start = start;
        this.end = end;
        this.maxEnd = end;
        this.cachedVersionId = versionId;
        this.cachedAbsoluteStart = start;
        this.cachedAbsoluteEnd = end;
        this.range = range;
    }
    setOptions(options) {
        this.options = options;
        const className = this.options.className;
        setNodeIsForValidation(this, className === "squiggly-error" /* ClassName.EditorErrorDecoration */  || className === "squiggly-warning" /* ClassName.EditorWarningDecoration */  || className === "squiggly-info" /* ClassName.EditorInfoDecoration */ );
        setNodeIsInGlyphMargin(this, this.options.glyphMarginClassName !== null);
        _setNodeStickiness(this, this.options.stickiness);
        setCollapseOnReplaceEdit(this, this.options.collapseOnReplaceEdit);
    }
    setCachedOffsets(absoluteStart, absoluteEnd, cachedVersionId) {
        if (this.cachedVersionId !== cachedVersionId) this.range = null;
        this.cachedVersionId = cachedVersionId;
        this.cachedAbsoluteStart = absoluteStart;
        this.cachedAbsoluteEnd = absoluteEnd;
    }
    detach() {
        this.parent = null;
        this.left = null;
        this.right = null;
    }
}
const SENTINEL = new IntervalNode(null, 0, 0);
SENTINEL.parent = SENTINEL;
SENTINEL.left = SENTINEL;
SENTINEL.right = SENTINEL;
setNodeColor(SENTINEL, 0 /* NodeColor.Black */ );
class IntervalTree {
    constructor(){
        this.root = SENTINEL;
        this.requestNormalizeDelta = false;
    }
    intervalSearch(start, end, filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations) {
        if (this.root === SENTINEL) return [];
        return intervalSearch(this, start, end, filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations);
    }
    search(filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations) {
        if (this.root === SENTINEL) return [];
        return search(this, filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations);
    }
    /**
     * Will not set `cachedAbsoluteStart` nor `cachedAbsoluteEnd` on the returned nodes!
     */ collectNodesFromOwner(ownerId) {
        return collectNodesFromOwner(this, ownerId);
    }
    /**
     * Will not set `cachedAbsoluteStart` nor `cachedAbsoluteEnd` on the returned nodes!
     */ collectNodesPostOrder() {
        return collectNodesPostOrder(this);
    }
    insert(node) {
        rbTreeInsert(this, node);
        this._normalizeDeltaIfNecessary();
    }
    delete(node) {
        rbTreeDelete(this, node);
        this._normalizeDeltaIfNecessary();
    }
    resolveNode(node, cachedVersionId) {
        const initialNode = node;
        let delta = 0;
        while(node !== this.root){
            if (node === node.parent.right) delta += node.parent.delta;
            node = node.parent;
        }
        const nodeStart = initialNode.start + delta;
        const nodeEnd = initialNode.end + delta;
        initialNode.setCachedOffsets(nodeStart, nodeEnd, cachedVersionId);
    }
    acceptReplace(offset, length, textLength, forceMoveMarkers) {
        // Our strategy is to remove all directly impacted nodes, and then add them back to the tree.
        // (1) collect all nodes that are intersecting this edit as nodes of interest
        const nodesOfInterest = searchForEditing(this, offset, offset + length);
        // (2) remove all nodes that are intersecting this edit
        for(let i = 0, len = nodesOfInterest.length; i < len; i++){
            const node = nodesOfInterest[i];
            rbTreeDelete(this, node);
        }
        this._normalizeDeltaIfNecessary();
        // (3) edit all tree nodes except the nodes of interest
        noOverlapReplace(this, offset, offset + length, textLength);
        this._normalizeDeltaIfNecessary();
        // (4) edit the nodes of interest and insert them back in the tree
        for(let i = 0, len = nodesOfInterest.length; i < len; i++){
            const node = nodesOfInterest[i];
            node.start = node.cachedAbsoluteStart;
            node.end = node.cachedAbsoluteEnd;
            nodeAcceptEdit(node, offset, offset + length, textLength, forceMoveMarkers);
            node.maxEnd = node.end;
            rbTreeInsert(this, node);
        }
        this._normalizeDeltaIfNecessary();
    }
    _normalizeDeltaIfNecessary() {
        if (!this.requestNormalizeDelta) return;
        this.requestNormalizeDelta = false;
        normalizeDelta(this);
    }
}
//#region Delta Normalization
function normalizeDelta(T) {
    let node = T.root;
    let delta = 0;
    while(node !== SENTINEL){
        if (node.left !== SENTINEL && !getNodeIsVisited(node.left)) {
            // go left
            node = node.left;
            continue;
        }
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            delta += node.delta;
            node = node.right;
            continue;
        }
        // handle current node
        node.start = delta + node.start;
        node.end = delta + node.end;
        node.delta = 0;
        recomputeMaxEnd(node);
        setNodeIsVisited(node, true);
        // going up from this node
        setNodeIsVisited(node.left, false);
        setNodeIsVisited(node.right, false);
        if (node === node.parent.right) delta -= node.parent.delta;
        node = node.parent;
    }
    setNodeIsVisited(T.root, false);
}
function adjustMarkerBeforeColumn(markerOffset, markerStickToPreviousCharacter, checkOffset, moveSemantics) {
    if (markerOffset < checkOffset) return true;
    if (markerOffset > checkOffset) return false;
    if (moveSemantics === 1 /* MarkerMoveSemantics.ForceMove */ ) return false;
    if (moveSemantics === 2 /* MarkerMoveSemantics.ForceStay */ ) return true;
    return markerStickToPreviousCharacter;
}
function nodeAcceptEdit(node, start, end, textLength, forceMoveMarkers) {
    const nodeStickiness = getNodeStickiness(node);
    const startStickToPreviousCharacter = nodeStickiness === 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */  || nodeStickiness === 2 /* TrackedRangeStickiness.GrowsOnlyWhenTypingBefore */ ;
    const endStickToPreviousCharacter = nodeStickiness === 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */  || nodeStickiness === 2 /* TrackedRangeStickiness.GrowsOnlyWhenTypingBefore */ ;
    const deletingCnt = end - start;
    const insertingCnt = textLength;
    const commonLength = Math.min(deletingCnt, insertingCnt);
    const nodeStart = node.start;
    let startDone = false;
    const nodeEnd = node.end;
    let endDone = false;
    if (start <= nodeStart && nodeEnd <= end && getCollapseOnReplaceEdit(node)) {
        // This edit encompasses the entire decoration range
        // and the decoration has asked to become collapsed
        node.start = start;
        startDone = true;
        node.end = start;
        endDone = true;
    }
    {
        const moveSemantics = forceMoveMarkers ? 1 /* MarkerMoveSemantics.ForceMove */  : deletingCnt > 0 ? 2 /* MarkerMoveSemantics.ForceStay */  : 0 /* MarkerMoveSemantics.MarkerDefined */ ;
        if (!startDone && adjustMarkerBeforeColumn(nodeStart, startStickToPreviousCharacter, start, moveSemantics)) startDone = true;
        if (!endDone && adjustMarkerBeforeColumn(nodeEnd, endStickToPreviousCharacter, start, moveSemantics)) endDone = true;
    }
    if (commonLength > 0 && !forceMoveMarkers) {
        const moveSemantics = deletingCnt > insertingCnt ? 2 /* MarkerMoveSemantics.ForceStay */  : 0 /* MarkerMoveSemantics.MarkerDefined */ ;
        if (!startDone && adjustMarkerBeforeColumn(nodeStart, startStickToPreviousCharacter, start + commonLength, moveSemantics)) startDone = true;
        if (!endDone && adjustMarkerBeforeColumn(nodeEnd, endStickToPreviousCharacter, start + commonLength, moveSemantics)) endDone = true;
    }
    {
        const moveSemantics = forceMoveMarkers ? 1 /* MarkerMoveSemantics.ForceMove */  : 0 /* MarkerMoveSemantics.MarkerDefined */ ;
        if (!startDone && adjustMarkerBeforeColumn(nodeStart, startStickToPreviousCharacter, end, moveSemantics)) {
            node.start = start + insertingCnt;
            startDone = true;
        }
        if (!endDone && adjustMarkerBeforeColumn(nodeEnd, endStickToPreviousCharacter, end, moveSemantics)) {
            node.end = start + insertingCnt;
            endDone = true;
        }
    }
    // Finish
    const deltaColumn = insertingCnt - deletingCnt;
    if (!startDone) node.start = Math.max(0, nodeStart + deltaColumn);
    if (!endDone) node.end = Math.max(0, nodeEnd + deltaColumn);
    if (node.start > node.end) node.end = node.start;
}
function searchForEditing(T, start, end) {
    // https://en.wikipedia.org/wiki/Interval_tree#Augmented_tree
    // Now, it is known that two intervals A and B overlap only when both
    // A.low <= B.high and A.high >= B.low. When searching the trees for
    // nodes overlapping with a given interval, you can immediately skip:
    //  a) all nodes to the right of nodes whose low value is past the end of the given interval.
    //  b) all nodes that have their maximum 'high' value below the start of the given interval.
    let node = T.root;
    let delta = 0;
    let nodeMaxEnd = 0;
    let nodeStart = 0;
    let nodeEnd = 0;
    const result = [];
    let resultLen = 0;
    while(node !== SENTINEL){
        if (getNodeIsVisited(node)) {
            // going up from this node
            setNodeIsVisited(node.left, false);
            setNodeIsVisited(node.right, false);
            if (node === node.parent.right) delta -= node.parent.delta;
            node = node.parent;
            continue;
        }
        if (!getNodeIsVisited(node.left)) {
            // first time seeing this node
            nodeMaxEnd = delta + node.maxEnd;
            if (nodeMaxEnd < start) {
                // cover case b) from above
                // there is no need to search this node or its children
                setNodeIsVisited(node, true);
                continue;
            }
            if (node.left !== SENTINEL) {
                // go left
                node = node.left;
                continue;
            }
        }
        // handle current node
        nodeStart = delta + node.start;
        if (nodeStart > end) {
            // cover case a) from above
            // there is no need to search this node or its right subtree
            setNodeIsVisited(node, true);
            continue;
        }
        nodeEnd = delta + node.end;
        if (nodeEnd >= start) {
            node.setCachedOffsets(nodeStart, nodeEnd, 0);
            result[resultLen++] = node;
        }
        setNodeIsVisited(node, true);
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            delta += node.delta;
            node = node.right;
            continue;
        }
    }
    setNodeIsVisited(T.root, false);
    return result;
}
function noOverlapReplace(T, start, end, textLength) {
    // https://en.wikipedia.org/wiki/Interval_tree#Augmented_tree
    // Now, it is known that two intervals A and B overlap only when both
    // A.low <= B.high and A.high >= B.low. When searching the trees for
    // nodes overlapping with a given interval, you can immediately skip:
    //  a) all nodes to the right of nodes whose low value is past the end of the given interval.
    //  b) all nodes that have their maximum 'high' value below the start of the given interval.
    let node = T.root;
    let delta = 0;
    let nodeMaxEnd = 0;
    let nodeStart = 0;
    const editDelta = textLength - (end - start);
    while(node !== SENTINEL){
        if (getNodeIsVisited(node)) {
            // going up from this node
            setNodeIsVisited(node.left, false);
            setNodeIsVisited(node.right, false);
            if (node === node.parent.right) delta -= node.parent.delta;
            recomputeMaxEnd(node);
            node = node.parent;
            continue;
        }
        if (!getNodeIsVisited(node.left)) {
            // first time seeing this node
            nodeMaxEnd = delta + node.maxEnd;
            if (nodeMaxEnd < start) {
                // cover case b) from above
                // there is no need to search this node or its children
                setNodeIsVisited(node, true);
                continue;
            }
            if (node.left !== SENTINEL) {
                // go left
                node = node.left;
                continue;
            }
        }
        // handle current node
        nodeStart = delta + node.start;
        if (nodeStart > end) {
            node.start += editDelta;
            node.end += editDelta;
            node.delta += editDelta;
            if (node.delta < -1073741824 /* Constants.MIN_SAFE_DELTA */  || node.delta > 1073741824 /* Constants.MAX_SAFE_DELTA */ ) T.requestNormalizeDelta = true;
            // cover case a) from above
            // there is no need to search this node or its right subtree
            setNodeIsVisited(node, true);
            continue;
        }
        setNodeIsVisited(node, true);
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            delta += node.delta;
            node = node.right;
            continue;
        }
    }
    setNodeIsVisited(T.root, false);
}
//#endregion
//#region Searching
function collectNodesFromOwner(T, ownerId) {
    let node = T.root;
    const result = [];
    let resultLen = 0;
    while(node !== SENTINEL){
        if (getNodeIsVisited(node)) {
            // going up from this node
            setNodeIsVisited(node.left, false);
            setNodeIsVisited(node.right, false);
            node = node.parent;
            continue;
        }
        if (node.left !== SENTINEL && !getNodeIsVisited(node.left)) {
            // go left
            node = node.left;
            continue;
        }
        // handle current node
        if (node.ownerId === ownerId) result[resultLen++] = node;
        setNodeIsVisited(node, true);
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            node = node.right;
            continue;
        }
    }
    setNodeIsVisited(T.root, false);
    return result;
}
function collectNodesPostOrder(T) {
    let node = T.root;
    const result = [];
    let resultLen = 0;
    while(node !== SENTINEL){
        if (getNodeIsVisited(node)) {
            // going up from this node
            setNodeIsVisited(node.left, false);
            setNodeIsVisited(node.right, false);
            node = node.parent;
            continue;
        }
        if (node.left !== SENTINEL && !getNodeIsVisited(node.left)) {
            // go left
            node = node.left;
            continue;
        }
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            node = node.right;
            continue;
        }
        // handle current node
        result[resultLen++] = node;
        setNodeIsVisited(node, true);
    }
    setNodeIsVisited(T.root, false);
    return result;
}
function search(T, filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations) {
    let node = T.root;
    let delta = 0;
    let nodeStart = 0;
    let nodeEnd = 0;
    const result = [];
    let resultLen = 0;
    while(node !== SENTINEL){
        if (getNodeIsVisited(node)) {
            // going up from this node
            setNodeIsVisited(node.left, false);
            setNodeIsVisited(node.right, false);
            if (node === node.parent.right) delta -= node.parent.delta;
            node = node.parent;
            continue;
        }
        if (node.left !== SENTINEL && !getNodeIsVisited(node.left)) {
            // go left
            node = node.left;
            continue;
        }
        // handle current node
        nodeStart = delta + node.start;
        nodeEnd = delta + node.end;
        node.setCachedOffsets(nodeStart, nodeEnd, cachedVersionId);
        let include = true;
        if (filterOwnerId && node.ownerId && node.ownerId !== filterOwnerId) include = false;
        if (filterOutValidation && getNodeIsForValidation(node)) include = false;
        if (onlyMarginDecorations && !getNodeIsInGlyphMargin(node)) include = false;
        if (include) result[resultLen++] = node;
        setNodeIsVisited(node, true);
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            delta += node.delta;
            node = node.right;
            continue;
        }
    }
    setNodeIsVisited(T.root, false);
    return result;
}
function intervalSearch(T, intervalStart, intervalEnd, filterOwnerId, filterOutValidation, cachedVersionId, onlyMarginDecorations) {
    // https://en.wikipedia.org/wiki/Interval_tree#Augmented_tree
    // Now, it is known that two intervals A and B overlap only when both
    // A.low <= B.high and A.high >= B.low. When searching the trees for
    // nodes overlapping with a given interval, you can immediately skip:
    //  a) all nodes to the right of nodes whose low value is past the end of the given interval.
    //  b) all nodes that have their maximum 'high' value below the start of the given interval.
    let node = T.root;
    let delta = 0;
    let nodeMaxEnd = 0;
    let nodeStart = 0;
    let nodeEnd = 0;
    const result = [];
    let resultLen = 0;
    while(node !== SENTINEL){
        if (getNodeIsVisited(node)) {
            // going up from this node
            setNodeIsVisited(node.left, false);
            setNodeIsVisited(node.right, false);
            if (node === node.parent.right) delta -= node.parent.delta;
            node = node.parent;
            continue;
        }
        if (!getNodeIsVisited(node.left)) {
            // first time seeing this node
            nodeMaxEnd = delta + node.maxEnd;
            if (nodeMaxEnd < intervalStart) {
                // cover case b) from above
                // there is no need to search this node or its children
                setNodeIsVisited(node, true);
                continue;
            }
            if (node.left !== SENTINEL) {
                // go left
                node = node.left;
                continue;
            }
        }
        // handle current node
        nodeStart = delta + node.start;
        if (nodeStart > intervalEnd) {
            // cover case a) from above
            // there is no need to search this node or its right subtree
            setNodeIsVisited(node, true);
            continue;
        }
        nodeEnd = delta + node.end;
        if (nodeEnd >= intervalStart) {
            // There is overlap
            node.setCachedOffsets(nodeStart, nodeEnd, cachedVersionId);
            let include = true;
            if (filterOwnerId && node.ownerId && node.ownerId !== filterOwnerId) include = false;
            if (filterOutValidation && getNodeIsForValidation(node)) include = false;
            if (onlyMarginDecorations && !getNodeIsInGlyphMargin(node)) include = false;
            if (include) result[resultLen++] = node;
        }
        setNodeIsVisited(node, true);
        if (node.right !== SENTINEL && !getNodeIsVisited(node.right)) {
            // go right
            delta += node.delta;
            node = node.right;
            continue;
        }
    }
    setNodeIsVisited(T.root, false);
    return result;
}
//#endregion
//#region Insertion
function rbTreeInsert(T, newNode) {
    if (T.root === SENTINEL) {
        newNode.parent = SENTINEL;
        newNode.left = SENTINEL;
        newNode.right = SENTINEL;
        setNodeColor(newNode, 0 /* NodeColor.Black */ );
        T.root = newNode;
        return T.root;
    }
    treeInsert(T, newNode);
    recomputeMaxEndWalkToRoot(newNode.parent);
    // repair tree
    let x = newNode;
    while(x !== T.root && getNodeColor(x.parent) === 1 /* NodeColor.Red */ )if (x.parent === x.parent.parent.left) {
        const y = x.parent.parent.right;
        if (getNodeColor(y) === 1 /* NodeColor.Red */ ) {
            setNodeColor(x.parent, 0 /* NodeColor.Black */ );
            setNodeColor(y, 0 /* NodeColor.Black */ );
            setNodeColor(x.parent.parent, 1 /* NodeColor.Red */ );
            x = x.parent.parent;
        } else {
            if (x === x.parent.right) {
                x = x.parent;
                leftRotate(T, x);
            }
            setNodeColor(x.parent, 0 /* NodeColor.Black */ );
            setNodeColor(x.parent.parent, 1 /* NodeColor.Red */ );
            rightRotate(T, x.parent.parent);
        }
    } else {
        const y = x.parent.parent.left;
        if (getNodeColor(y) === 1 /* NodeColor.Red */ ) {
            setNodeColor(x.parent, 0 /* NodeColor.Black */ );
            setNodeColor(y, 0 /* NodeColor.Black */ );
            setNodeColor(x.parent.parent, 1 /* NodeColor.Red */ );
            x = x.parent.parent;
        } else {
            if (x === x.parent.left) {
                x = x.parent;
                rightRotate(T, x);
            }
            setNodeColor(x.parent, 0 /* NodeColor.Black */ );
            setNodeColor(x.parent.parent, 1 /* NodeColor.Red */ );
            leftRotate(T, x.parent.parent);
        }
    }
    setNodeColor(T.root, 0 /* NodeColor.Black */ );
    return newNode;
}
function treeInsert(T, z) {
    let delta = 0;
    let x = T.root;
    const zAbsoluteStart = z.start;
    const zAbsoluteEnd = z.end;
    while(true){
        const cmp = intervalCompare(zAbsoluteStart, zAbsoluteEnd, x.start + delta, x.end + delta);
        if (cmp < 0) {
            // this node should be inserted to the left
            // => it is not affected by the node's delta
            if (x.left === SENTINEL) {
                z.start -= delta;
                z.end -= delta;
                z.maxEnd -= delta;
                x.left = z;
                break;
            } else x = x.left;
        } else // this node should be inserted to the right
        // => it is not affected by the node's delta
        if (x.right === SENTINEL) {
            z.start -= delta + x.delta;
            z.end -= delta + x.delta;
            z.maxEnd -= delta + x.delta;
            x.right = z;
            break;
        } else {
            delta += x.delta;
            x = x.right;
        }
    }
    z.parent = x;
    z.left = SENTINEL;
    z.right = SENTINEL;
    setNodeColor(z, 1 /* NodeColor.Red */ );
}
//#endregion
//#region Deletion
function rbTreeDelete(T, z) {
    let x;
    let y;
    // RB-DELETE except we don't swap z and y in case c)
    // i.e. we always delete what's pointed at by z.
    if (z.left === SENTINEL) {
        x = z.right;
        y = z;
        // x's delta is no longer influenced by z's delta
        x.delta += z.delta;
        if (x.delta < -1073741824 /* Constants.MIN_SAFE_DELTA */  || x.delta > 1073741824 /* Constants.MAX_SAFE_DELTA */ ) T.requestNormalizeDelta = true;
        x.start += z.delta;
        x.end += z.delta;
    } else if (z.right === SENTINEL) {
        x = z.left;
        y = z;
    } else {
        y = leftest(z.right);
        x = y.right;
        // y's delta is no longer influenced by z's delta,
        // but we don't want to walk the entire right-hand-side subtree of x.
        // we therefore maintain z's delta in y, and adjust only x
        x.start += y.delta;
        x.end += y.delta;
        x.delta += y.delta;
        if (x.delta < -1073741824 /* Constants.MIN_SAFE_DELTA */  || x.delta > 1073741824 /* Constants.MAX_SAFE_DELTA */ ) T.requestNormalizeDelta = true;
        y.start += z.delta;
        y.end += z.delta;
        y.delta = z.delta;
        if (y.delta < -1073741824 /* Constants.MIN_SAFE_DELTA */  || y.delta > 1073741824 /* Constants.MAX_SAFE_DELTA */ ) T.requestNormalizeDelta = true;
    }
    if (y === T.root) {
        T.root = x;
        setNodeColor(x, 0 /* NodeColor.Black */ );
        z.detach();
        resetSentinel();
        recomputeMaxEnd(x);
        T.root.parent = SENTINEL;
        return;
    }
    const yWasRed = getNodeColor(y) === 1 /* NodeColor.Red */ ;
    if (y === y.parent.left) y.parent.left = x;
    else y.parent.right = x;
    if (y === z) x.parent = y.parent;
    else {
        if (y.parent === z) x.parent = y;
        else x.parent = y.parent;
        y.left = z.left;
        y.right = z.right;
        y.parent = z.parent;
        setNodeColor(y, getNodeColor(z));
        if (z === T.root) T.root = y;
        else if (z === z.parent.left) z.parent.left = y;
        else z.parent.right = y;
        if (y.left !== SENTINEL) y.left.parent = y;
        if (y.right !== SENTINEL) y.right.parent = y;
    }
    z.detach();
    if (yWasRed) {
        recomputeMaxEndWalkToRoot(x.parent);
        if (y !== z) {
            recomputeMaxEndWalkToRoot(y);
            recomputeMaxEndWalkToRoot(y.parent);
        }
        resetSentinel();
        return;
    }
    recomputeMaxEndWalkToRoot(x);
    recomputeMaxEndWalkToRoot(x.parent);
    if (y !== z) {
        recomputeMaxEndWalkToRoot(y);
        recomputeMaxEndWalkToRoot(y.parent);
    }
    // RB-DELETE-FIXUP
    let w;
    while(x !== T.root && getNodeColor(x) === 0 /* NodeColor.Black */ )if (x === x.parent.left) {
        w = x.parent.right;
        if (getNodeColor(w) === 1 /* NodeColor.Red */ ) {
            setNodeColor(w, 0 /* NodeColor.Black */ );
            setNodeColor(x.parent, 1 /* NodeColor.Red */ );
            leftRotate(T, x.parent);
            w = x.parent.right;
        }
        if (getNodeColor(w.left) === 0 /* NodeColor.Black */  && getNodeColor(w.right) === 0 /* NodeColor.Black */ ) {
            setNodeColor(w, 1 /* NodeColor.Red */ );
            x = x.parent;
        } else {
            if (getNodeColor(w.right) === 0 /* NodeColor.Black */ ) {
                setNodeColor(w.left, 0 /* NodeColor.Black */ );
                setNodeColor(w, 1 /* NodeColor.Red */ );
                rightRotate(T, w);
                w = x.parent.right;
            }
            setNodeColor(w, getNodeColor(x.parent));
            setNodeColor(x.parent, 0 /* NodeColor.Black */ );
            setNodeColor(w.right, 0 /* NodeColor.Black */ );
            leftRotate(T, x.parent);
            x = T.root;
        }
    } else {
        w = x.parent.left;
        if (getNodeColor(w) === 1 /* NodeColor.Red */ ) {
            setNodeColor(w, 0 /* NodeColor.Black */ );
            setNodeColor(x.parent, 1 /* NodeColor.Red */ );
            rightRotate(T, x.parent);
            w = x.parent.left;
        }
        if (getNodeColor(w.left) === 0 /* NodeColor.Black */  && getNodeColor(w.right) === 0 /* NodeColor.Black */ ) {
            setNodeColor(w, 1 /* NodeColor.Red */ );
            x = x.parent;
        } else {
            if (getNodeColor(w.left) === 0 /* NodeColor.Black */ ) {
                setNodeColor(w.right, 0 /* NodeColor.Black */ );
                setNodeColor(w, 1 /* NodeColor.Red */ );
                leftRotate(T, w);
                w = x.parent.left;
            }
            setNodeColor(w, getNodeColor(x.parent));
            setNodeColor(x.parent, 0 /* NodeColor.Black */ );
            setNodeColor(w.left, 0 /* NodeColor.Black */ );
            rightRotate(T, x.parent);
            x = T.root;
        }
    }
    setNodeColor(x, 0 /* NodeColor.Black */ );
    resetSentinel();
}
function leftest(node) {
    while(node.left !== SENTINEL)node = node.left;
    return node;
}
function resetSentinel() {
    SENTINEL.parent = SENTINEL;
    SENTINEL.delta = 0; // optional
    SENTINEL.start = 0; // optional
    SENTINEL.end = 0; // optional
}
//#endregion
//#region Rotations
function leftRotate(T, x) {
    const y = x.right; // set y.
    y.delta += x.delta; // y's delta is no longer influenced by x's delta
    if (y.delta < -1073741824 /* Constants.MIN_SAFE_DELTA */  || y.delta > 1073741824 /* Constants.MAX_SAFE_DELTA */ ) T.requestNormalizeDelta = true;
    y.start += x.delta;
    y.end += x.delta;
    x.right = y.left; // turn y's left subtree into x's right subtree.
    if (y.left !== SENTINEL) y.left.parent = x;
    y.parent = x.parent; // link x's parent to y.
    if (x.parent === SENTINEL) T.root = y;
    else if (x === x.parent.left) x.parent.left = y;
    else x.parent.right = y;
    y.left = x; // put x on y's left.
    x.parent = y;
    recomputeMaxEnd(x);
    recomputeMaxEnd(y);
}
function rightRotate(T, y) {
    const x = y.left;
    y.delta -= x.delta;
    if (y.delta < -1073741824 /* Constants.MIN_SAFE_DELTA */  || y.delta > 1073741824 /* Constants.MAX_SAFE_DELTA */ ) T.requestNormalizeDelta = true;
    y.start -= x.delta;
    y.end -= x.delta;
    y.left = x.right;
    if (x.right !== SENTINEL) x.right.parent = y;
    x.parent = y.parent;
    if (y.parent === SENTINEL) T.root = x;
    else if (y === y.parent.right) y.parent.right = x;
    else y.parent.left = x;
    x.right = y;
    y.parent = x;
    recomputeMaxEnd(y);
    recomputeMaxEnd(x);
}
//#endregion
//#region max end computation
function computeMaxEnd(node) {
    let maxEnd = node.end;
    if (node.left !== SENTINEL) {
        const leftMaxEnd = node.left.maxEnd;
        if (leftMaxEnd > maxEnd) maxEnd = leftMaxEnd;
    }
    if (node.right !== SENTINEL) {
        const rightMaxEnd = node.right.maxEnd + node.delta;
        if (rightMaxEnd > maxEnd) maxEnd = rightMaxEnd;
    }
    return maxEnd;
}
function recomputeMaxEnd(node) {
    node.maxEnd = computeMaxEnd(node);
}
function recomputeMaxEndWalkToRoot(node) {
    while(node !== SENTINEL){
        const maxEnd = computeMaxEnd(node);
        if (node.maxEnd === maxEnd) // no need to go further
        return;
        node.maxEnd = maxEnd;
        node = node.parent;
    }
}
function intervalCompare(aStart, aEnd, bStart, bEnd) {
    if (aStart === bStart) return aEnd - bEnd;
    return aStart - bStart;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fhukT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PieceTreeTextBuffer", ()=>PieceTreeTextBuffer);
var _eventJs = require("../../../../base/common/event.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _rangeJs = require("../../core/range.js");
var _modelJs = require("../../model.js");
var _pieceTreeBaseJs = require("./pieceTreeBase.js");
var _eolCounterJs = require("../../core/eolCounter.js");
var _textChangeJs = require("../../core/textChange.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
class PieceTreeTextBuffer extends (0, _lifecycleJs.Disposable) {
    constructor(chunks, BOM, eol, containsRTL, containsUnusualLineTerminators, isBasicASCII, eolNormalized){
        super();
        this._onDidChangeContent = this._register(new (0, _eventJs.Emitter)());
        this._BOM = BOM;
        this._mightContainNonBasicASCII = !isBasicASCII;
        this._mightContainRTL = containsRTL;
        this._mightContainUnusualLineTerminators = containsUnusualLineTerminators;
        this._pieceTree = new (0, _pieceTreeBaseJs.PieceTreeBase)(chunks, eol, eolNormalized);
    }
    mightContainRTL() {
        return this._mightContainRTL;
    }
    mightContainUnusualLineTerminators() {
        return this._mightContainUnusualLineTerminators;
    }
    resetMightContainUnusualLineTerminators() {
        this._mightContainUnusualLineTerminators = false;
    }
    mightContainNonBasicASCII() {
        return this._mightContainNonBasicASCII;
    }
    getBOM() {
        return this._BOM;
    }
    getEOL() {
        return this._pieceTree.getEOL();
    }
    createSnapshot(preserveBOM) {
        return this._pieceTree.createSnapshot(preserveBOM ? this._BOM : "");
    }
    getOffsetAt(lineNumber, column) {
        return this._pieceTree.getOffsetAt(lineNumber, column);
    }
    getPositionAt(offset) {
        return this._pieceTree.getPositionAt(offset);
    }
    getRangeAt(start, length) {
        const end = start + length;
        const startPosition = this.getPositionAt(start);
        const endPosition = this.getPositionAt(end);
        return new (0, _rangeJs.Range)(startPosition.lineNumber, startPosition.column, endPosition.lineNumber, endPosition.column);
    }
    getValueInRange(range, eol = 0 /* EndOfLinePreference.TextDefined */ ) {
        if (range.isEmpty()) return "";
        const lineEnding = this._getEndOfLine(eol);
        return this._pieceTree.getValueInRange(range, lineEnding);
    }
    getValueLengthInRange(range, eol = 0 /* EndOfLinePreference.TextDefined */ ) {
        if (range.isEmpty()) return 0;
        if (range.startLineNumber === range.endLineNumber) return range.endColumn - range.startColumn;
        const startOffset = this.getOffsetAt(range.startLineNumber, range.startColumn);
        const endOffset = this.getOffsetAt(range.endLineNumber, range.endColumn);
        // offsets use the text EOL, so we need to compensate for length differences
        // if the requested EOL doesn't match the text EOL
        let eolOffsetCompensation = 0;
        const desiredEOL = this._getEndOfLine(eol);
        const actualEOL = this.getEOL();
        if (desiredEOL.length !== actualEOL.length) {
            const delta = desiredEOL.length - actualEOL.length;
            const eolCount = range.endLineNumber - range.startLineNumber;
            eolOffsetCompensation = delta * eolCount;
        }
        return endOffset - startOffset + eolOffsetCompensation;
    }
    getCharacterCountInRange(range, eol = 0 /* EndOfLinePreference.TextDefined */ ) {
        if (this._mightContainNonBasicASCII) {
            // we must count by iterating
            let result = 0;
            const fromLineNumber = range.startLineNumber;
            const toLineNumber = range.endLineNumber;
            for(let lineNumber = fromLineNumber; lineNumber <= toLineNumber; lineNumber++){
                const lineContent = this.getLineContent(lineNumber);
                const fromOffset = lineNumber === fromLineNumber ? range.startColumn - 1 : 0;
                const toOffset = lineNumber === toLineNumber ? range.endColumn - 1 : lineContent.length;
                for(let offset = fromOffset; offset < toOffset; offset++)if (_stringsJs.isHighSurrogate(lineContent.charCodeAt(offset))) {
                    result = result + 1;
                    offset = offset + 1;
                } else result = result + 1;
            }
            result += this._getEndOfLine(eol).length * (toLineNumber - fromLineNumber);
            return result;
        }
        return this.getValueLengthInRange(range, eol);
    }
    getLength() {
        return this._pieceTree.getLength();
    }
    getLineCount() {
        return this._pieceTree.getLineCount();
    }
    getLinesContent() {
        return this._pieceTree.getLinesContent();
    }
    getLineContent(lineNumber) {
        return this._pieceTree.getLineContent(lineNumber);
    }
    getLineCharCode(lineNumber, index) {
        return this._pieceTree.getLineCharCode(lineNumber, index);
    }
    getLineLength(lineNumber) {
        return this._pieceTree.getLineLength(lineNumber);
    }
    getLineFirstNonWhitespaceColumn(lineNumber) {
        const result = _stringsJs.firstNonWhitespaceIndex(this.getLineContent(lineNumber));
        if (result === -1) return 0;
        return result + 1;
    }
    getLineLastNonWhitespaceColumn(lineNumber) {
        const result = _stringsJs.lastNonWhitespaceIndex(this.getLineContent(lineNumber));
        if (result === -1) return 0;
        return result + 2;
    }
    _getEndOfLine(eol) {
        switch(eol){
            case 1 /* EndOfLinePreference.LF */ :
                return "\n";
            case 2 /* EndOfLinePreference.CRLF */ :
                return "\r\n";
            case 0 /* EndOfLinePreference.TextDefined */ :
                return this.getEOL();
            default:
                throw new Error("Unknown EOL preference");
        }
    }
    setEOL(newEOL) {
        this._pieceTree.setEOL(newEOL);
    }
    applyEdits(rawOperations, recordTrimAutoWhitespace, computeUndoEdits) {
        let mightContainRTL = this._mightContainRTL;
        let mightContainUnusualLineTerminators = this._mightContainUnusualLineTerminators;
        let mightContainNonBasicASCII = this._mightContainNonBasicASCII;
        let canReduceOperations = true;
        let operations = [];
        for(let i = 0; i < rawOperations.length; i++){
            const op = rawOperations[i];
            if (canReduceOperations && op._isTracked) canReduceOperations = false;
            const validatedRange = op.range;
            if (op.text) {
                let textMightContainNonBasicASCII = true;
                if (!mightContainNonBasicASCII) {
                    textMightContainNonBasicASCII = !_stringsJs.isBasicASCII(op.text);
                    mightContainNonBasicASCII = textMightContainNonBasicASCII;
                }
                if (!mightContainRTL && textMightContainNonBasicASCII) // check if the new inserted text contains RTL
                mightContainRTL = _stringsJs.containsRTL(op.text);
                if (!mightContainUnusualLineTerminators && textMightContainNonBasicASCII) // check if the new inserted text contains unusual line terminators
                mightContainUnusualLineTerminators = _stringsJs.containsUnusualLineTerminators(op.text);
            }
            let validText = "";
            let eolCount = 0;
            let firstLineLength = 0;
            let lastLineLength = 0;
            if (op.text) {
                let strEOL;
                [eolCount, firstLineLength, lastLineLength, strEOL] = (0, _eolCounterJs.countEOL)(op.text);
                const bufferEOL = this.getEOL();
                const expectedStrEOL = bufferEOL === "\r\n" ? 2 /* StringEOL.CRLF */  : 1 /* StringEOL.LF */ ;
                if (strEOL === 0 /* StringEOL.Unknown */  || strEOL === expectedStrEOL) validText = op.text;
                else validText = op.text.replace(/\r\n|\r|\n/g, bufferEOL);
            }
            operations[i] = {
                sortIndex: i,
                identifier: op.identifier || null,
                range: validatedRange,
                rangeOffset: this.getOffsetAt(validatedRange.startLineNumber, validatedRange.startColumn),
                rangeLength: this.getValueLengthInRange(validatedRange),
                text: validText,
                eolCount: eolCount,
                firstLineLength: firstLineLength,
                lastLineLength: lastLineLength,
                forceMoveMarkers: Boolean(op.forceMoveMarkers),
                isAutoWhitespaceEdit: op.isAutoWhitespaceEdit || false
            };
        }
        // Sort operations ascending
        operations.sort(PieceTreeTextBuffer._sortOpsAscending);
        let hasTouchingRanges = false;
        for(let i = 0, count = operations.length - 1; i < count; i++){
            const rangeEnd = operations[i].range.getEndPosition();
            const nextRangeStart = operations[i + 1].range.getStartPosition();
            if (nextRangeStart.isBeforeOrEqual(rangeEnd)) {
                if (nextRangeStart.isBefore(rangeEnd)) // overlapping ranges
                throw new Error("Overlapping ranges are not allowed!");
                hasTouchingRanges = true;
            }
        }
        if (canReduceOperations) operations = this._reduceOperations(operations);
        // Delta encode operations
        const reverseRanges = computeUndoEdits || recordTrimAutoWhitespace ? PieceTreeTextBuffer._getInverseEditRanges(operations) : [];
        const newTrimAutoWhitespaceCandidates = [];
        if (recordTrimAutoWhitespace) for(let i = 0; i < operations.length; i++){
            const op = operations[i];
            const reverseRange = reverseRanges[i];
            if (op.isAutoWhitespaceEdit && op.range.isEmpty()) // Record already the future line numbers that might be auto whitespace removal candidates on next edit
            for(let lineNumber = reverseRange.startLineNumber; lineNumber <= reverseRange.endLineNumber; lineNumber++){
                let currentLineContent = "";
                if (lineNumber === reverseRange.startLineNumber) {
                    currentLineContent = this.getLineContent(op.range.startLineNumber);
                    if (_stringsJs.firstNonWhitespaceIndex(currentLineContent) !== -1) continue;
                }
                newTrimAutoWhitespaceCandidates.push({
                    lineNumber: lineNumber,
                    oldContent: currentLineContent
                });
            }
        }
        let reverseOperations = null;
        if (computeUndoEdits) {
            let reverseRangeDeltaOffset = 0;
            reverseOperations = [];
            for(let i = 0; i < operations.length; i++){
                const op = operations[i];
                const reverseRange = reverseRanges[i];
                const bufferText = this.getValueInRange(op.range);
                const reverseRangeOffset = op.rangeOffset + reverseRangeDeltaOffset;
                reverseRangeDeltaOffset += op.text.length - bufferText.length;
                reverseOperations[i] = {
                    sortIndex: op.sortIndex,
                    identifier: op.identifier,
                    range: reverseRange,
                    text: bufferText,
                    textChange: new (0, _textChangeJs.TextChange)(op.rangeOffset, bufferText, reverseRangeOffset, op.text)
                };
            }
            // Can only sort reverse operations when the order is not significant
            if (!hasTouchingRanges) reverseOperations.sort((a, b)=>a.sortIndex - b.sortIndex);
        }
        this._mightContainRTL = mightContainRTL;
        this._mightContainUnusualLineTerminators = mightContainUnusualLineTerminators;
        this._mightContainNonBasicASCII = mightContainNonBasicASCII;
        const contentChanges = this._doApplyEdits(operations);
        let trimAutoWhitespaceLineNumbers = null;
        if (recordTrimAutoWhitespace && newTrimAutoWhitespaceCandidates.length > 0) {
            // sort line numbers auto whitespace removal candidates for next edit descending
            newTrimAutoWhitespaceCandidates.sort((a, b)=>b.lineNumber - a.lineNumber);
            trimAutoWhitespaceLineNumbers = [];
            for(let i = 0, len = newTrimAutoWhitespaceCandidates.length; i < len; i++){
                const lineNumber = newTrimAutoWhitespaceCandidates[i].lineNumber;
                if (i > 0 && newTrimAutoWhitespaceCandidates[i - 1].lineNumber === lineNumber) continue;
                const prevContent = newTrimAutoWhitespaceCandidates[i].oldContent;
                const lineContent = this.getLineContent(lineNumber);
                if (lineContent.length === 0 || lineContent === prevContent || _stringsJs.firstNonWhitespaceIndex(lineContent) !== -1) continue;
                trimAutoWhitespaceLineNumbers.push(lineNumber);
            }
        }
        this._onDidChangeContent.fire();
        return new (0, _modelJs.ApplyEditsResult)(reverseOperations, contentChanges, trimAutoWhitespaceLineNumbers);
    }
    /**
     * Transform operations such that they represent the same logic edit,
     * but that they also do not cause OOM crashes.
     */ _reduceOperations(operations) {
        if (operations.length < 1000) // We know from empirical testing that a thousand edits work fine regardless of their shape.
        return operations;
        // At one point, due to how events are emitted and how each operation is handled,
        // some operations can trigger a high amount of temporary string allocations,
        // that will immediately get edited again.
        // e.g. a formatter inserting ridiculous ammounts of \n on a model with a single line
        // Therefore, the strategy is to collapse all the operations into a huge single edit operation
        return [
            this._toSingleEditOperation(operations)
        ];
    }
    _toSingleEditOperation(operations) {
        let forceMoveMarkers = false;
        const firstEditRange = operations[0].range;
        const lastEditRange = operations[operations.length - 1].range;
        const entireEditRange = new (0, _rangeJs.Range)(firstEditRange.startLineNumber, firstEditRange.startColumn, lastEditRange.endLineNumber, lastEditRange.endColumn);
        let lastEndLineNumber = firstEditRange.startLineNumber;
        let lastEndColumn = firstEditRange.startColumn;
        const result = [];
        for(let i = 0, len = operations.length; i < len; i++){
            const operation = operations[i];
            const range = operation.range;
            forceMoveMarkers = forceMoveMarkers || operation.forceMoveMarkers;
            // (1) -- Push old text
            result.push(this.getValueInRange(new (0, _rangeJs.Range)(lastEndLineNumber, lastEndColumn, range.startLineNumber, range.startColumn)));
            // (2) -- Push new text
            if (operation.text.length > 0) result.push(operation.text);
            lastEndLineNumber = range.endLineNumber;
            lastEndColumn = range.endColumn;
        }
        const text = result.join("");
        const [eolCount, firstLineLength, lastLineLength] = (0, _eolCounterJs.countEOL)(text);
        return {
            sortIndex: 0,
            identifier: operations[0].identifier,
            range: entireEditRange,
            rangeOffset: this.getOffsetAt(entireEditRange.startLineNumber, entireEditRange.startColumn),
            rangeLength: this.getValueLengthInRange(entireEditRange, 0 /* EndOfLinePreference.TextDefined */ ),
            text: text,
            eolCount: eolCount,
            firstLineLength: firstLineLength,
            lastLineLength: lastLineLength,
            forceMoveMarkers: forceMoveMarkers,
            isAutoWhitespaceEdit: false
        };
    }
    _doApplyEdits(operations) {
        operations.sort(PieceTreeTextBuffer._sortOpsDescending);
        const contentChanges = [];
        // operations are from bottom to top
        for(let i = 0; i < operations.length; i++){
            const op = operations[i];
            const startLineNumber = op.range.startLineNumber;
            const startColumn = op.range.startColumn;
            const endLineNumber = op.range.endLineNumber;
            const endColumn = op.range.endColumn;
            if (startLineNumber === endLineNumber && startColumn === endColumn && op.text.length === 0) continue;
            if (op.text) {
                // replacement
                this._pieceTree.delete(op.rangeOffset, op.rangeLength);
                this._pieceTree.insert(op.rangeOffset, op.text, true);
            } else // deletion
            this._pieceTree.delete(op.rangeOffset, op.rangeLength);
            const contentChangeRange = new (0, _rangeJs.Range)(startLineNumber, startColumn, endLineNumber, endColumn);
            contentChanges.push({
                range: contentChangeRange,
                rangeLength: op.rangeLength,
                text: op.text,
                rangeOffset: op.rangeOffset,
                forceMoveMarkers: op.forceMoveMarkers
            });
        }
        return contentChanges;
    }
    findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount) {
        return this._pieceTree.findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount);
    }
    /**
     * Assumes `operations` are validated and sorted ascending
     */ static _getInverseEditRanges(operations) {
        const result = [];
        let prevOpEndLineNumber = 0;
        let prevOpEndColumn = 0;
        let prevOp = null;
        for(let i = 0, len = operations.length; i < len; i++){
            const op = operations[i];
            let startLineNumber;
            let startColumn;
            if (prevOp) {
                if (prevOp.range.endLineNumber === op.range.startLineNumber) {
                    startLineNumber = prevOpEndLineNumber;
                    startColumn = prevOpEndColumn + (op.range.startColumn - prevOp.range.endColumn);
                } else {
                    startLineNumber = prevOpEndLineNumber + (op.range.startLineNumber - prevOp.range.endLineNumber);
                    startColumn = op.range.startColumn;
                }
            } else {
                startLineNumber = op.range.startLineNumber;
                startColumn = op.range.startColumn;
            }
            let resultRange;
            if (op.text.length > 0) {
                // the operation inserts something
                const lineCount = op.eolCount + 1;
                if (lineCount === 1) // single line insert
                resultRange = new (0, _rangeJs.Range)(startLineNumber, startColumn, startLineNumber, startColumn + op.firstLineLength);
                else // multi line insert
                resultRange = new (0, _rangeJs.Range)(startLineNumber, startColumn, startLineNumber + lineCount - 1, op.lastLineLength + 1);
            } else // There is nothing to insert
            resultRange = new (0, _rangeJs.Range)(startLineNumber, startColumn, startLineNumber, startColumn);
            prevOpEndLineNumber = resultRange.endLineNumber;
            prevOpEndColumn = resultRange.endColumn;
            result.push(resultRange);
            prevOp = op;
        }
        return result;
    }
    static _sortOpsAscending(a, b) {
        const r = (0, _rangeJs.Range).compareRangesUsingEnds(a.range, b.range);
        if (r === 0) return a.sortIndex - b.sortIndex;
        return r;
    }
    static _sortOpsDescending(a, b) {
        const r = (0, _rangeJs.Range).compareRangesUsingEnds(a.range, b.range);
        if (r === 0) return b.sortIndex - a.sortIndex;
        return -r;
    }
}

},{"../../../../base/common/event.js":"4Zi8b","../../../../base/common/strings.js":"aA9I1","../../core/range.js":"jmUPh","../../model.js":"1CSIB","./pieceTreeBase.js":"e8MbF","../../core/eolCounter.js":"4i42Y","../../core/textChange.js":"iZMJm","../../../../base/common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e8MbF":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLineStartsFast", ()=>createLineStartsFast);
parcelHelpers.export(exports, "createLineStarts", ()=>createLineStarts);
parcelHelpers.export(exports, "Piece", ()=>Piece);
parcelHelpers.export(exports, "StringBuffer", ()=>StringBuffer);
parcelHelpers.export(exports, "PieceTreeBase", ()=>PieceTreeBase);
var _positionJs = require("../../core/position.js");
var _rangeJs = require("../../core/range.js");
var _modelJs = require("../../model.js");
var _rbTreeBaseJs = require("./rbTreeBase.js");
var _textModelSearchJs = require("../textModelSearch.js");
// const lfRegex = new RegExp(/\r\n|\r|\n/g);
const AverageBufferSize = 65535;
function createUintArray(arr) {
    let r;
    if (arr[arr.length - 1] < 65536) r = new Uint16Array(arr.length);
    else r = new Uint32Array(arr.length);
    r.set(arr, 0);
    return r;
}
class LineStarts {
    constructor(lineStarts, cr, lf, crlf, isBasicASCII){
        this.lineStarts = lineStarts;
        this.cr = cr;
        this.lf = lf;
        this.crlf = crlf;
        this.isBasicASCII = isBasicASCII;
    }
}
function createLineStartsFast(str, readonly = true) {
    const r = [
        0
    ];
    let rLength = 1;
    for(let i = 0, len = str.length; i < len; i++){
        const chr = str.charCodeAt(i);
        if (chr === 13 /* CharCode.CarriageReturn */ ) {
            if (i + 1 < len && str.charCodeAt(i + 1) === 10 /* CharCode.LineFeed */ ) {
                // \r\n... case
                r[rLength++] = i + 2;
                i++; // skip \n
            } else // \r... case
            r[rLength++] = i + 1;
        } else if (chr === 10 /* CharCode.LineFeed */ ) r[rLength++] = i + 1;
    }
    if (readonly) return createUintArray(r);
    else return r;
}
function createLineStarts(r, str) {
    r.length = 0;
    r[0] = 0;
    let rLength = 1;
    let cr = 0, lf = 0, crlf = 0;
    let isBasicASCII = true;
    for(let i = 0, len = str.length; i < len; i++){
        const chr = str.charCodeAt(i);
        if (chr === 13 /* CharCode.CarriageReturn */ ) {
            if (i + 1 < len && str.charCodeAt(i + 1) === 10 /* CharCode.LineFeed */ ) {
                // \r\n... case
                crlf++;
                r[rLength++] = i + 2;
                i++; // skip \n
            } else {
                cr++;
                // \r... case
                r[rLength++] = i + 1;
            }
        } else if (chr === 10 /* CharCode.LineFeed */ ) {
            lf++;
            r[rLength++] = i + 1;
        } else {
            if (isBasicASCII) {
                if (chr !== 9 /* CharCode.Tab */  && (chr < 32 || chr > 126)) isBasicASCII = false;
            }
        }
    }
    const result = new LineStarts(createUintArray(r), cr, lf, crlf, isBasicASCII);
    r.length = 0;
    return result;
}
class Piece {
    constructor(bufferIndex, start, end, lineFeedCnt, length){
        this.bufferIndex = bufferIndex;
        this.start = start;
        this.end = end;
        this.lineFeedCnt = lineFeedCnt;
        this.length = length;
    }
}
class StringBuffer {
    constructor(buffer, lineStarts){
        this.buffer = buffer;
        this.lineStarts = lineStarts;
    }
}
/**
 * Readonly snapshot for piece tree.
 * In a real multiple thread environment, to make snapshot reading always work correctly, we need to
 * 1. Make TreeNode.piece immutable, then reading and writing can run in parallel.
 * 2. TreeNode/Buffers normalization should not happen during snapshot reading.
 */ class PieceTreeSnapshot {
    constructor(tree, BOM){
        this._pieces = [];
        this._tree = tree;
        this._BOM = BOM;
        this._index = 0;
        if (tree.root !== (0, _rbTreeBaseJs.SENTINEL)) tree.iterate(tree.root, (node)=>{
            if (node !== (0, _rbTreeBaseJs.SENTINEL)) this._pieces.push(node.piece);
            return true;
        });
    }
    read() {
        if (this._pieces.length === 0) {
            if (this._index === 0) {
                this._index++;
                return this._BOM;
            } else return null;
        }
        if (this._index > this._pieces.length - 1) return null;
        if (this._index === 0) return this._BOM + this._tree.getPieceContent(this._pieces[this._index++]);
        return this._tree.getPieceContent(this._pieces[this._index++]);
    }
}
class PieceTreeSearchCache {
    constructor(limit){
        this._limit = limit;
        this._cache = [];
    }
    get(offset) {
        for(let i = this._cache.length - 1; i >= 0; i--){
            const nodePos = this._cache[i];
            if (nodePos.nodeStartOffset <= offset && nodePos.nodeStartOffset + nodePos.node.piece.length >= offset) return nodePos;
        }
        return null;
    }
    get2(lineNumber) {
        for(let i = this._cache.length - 1; i >= 0; i--){
            const nodePos = this._cache[i];
            if (nodePos.nodeStartLineNumber && nodePos.nodeStartLineNumber < lineNumber && nodePos.nodeStartLineNumber + nodePos.node.piece.lineFeedCnt >= lineNumber) return nodePos;
        }
        return null;
    }
    set(nodePosition) {
        if (this._cache.length >= this._limit) this._cache.shift();
        this._cache.push(nodePosition);
    }
    validate(offset) {
        let hasInvalidVal = false;
        const tmp = this._cache;
        for(let i = 0; i < tmp.length; i++){
            const nodePos = tmp[i];
            if (nodePos.node.parent === null || nodePos.nodeStartOffset >= offset) {
                tmp[i] = null;
                hasInvalidVal = true;
                continue;
            }
        }
        if (hasInvalidVal) {
            const newArr = [];
            for (const entry of tmp)if (entry !== null) newArr.push(entry);
            this._cache = newArr;
        }
    }
}
class PieceTreeBase {
    constructor(chunks, eol, eolNormalized){
        this.create(chunks, eol, eolNormalized);
    }
    create(chunks, eol, eolNormalized) {
        this._buffers = [
            new StringBuffer("", [
                0
            ])
        ];
        this._lastChangeBufferPos = {
            line: 0,
            column: 0
        };
        this.root = (0, _rbTreeBaseJs.SENTINEL);
        this._lineCnt = 1;
        this._length = 0;
        this._EOL = eol;
        this._EOLLength = eol.length;
        this._EOLNormalized = eolNormalized;
        let lastNode = null;
        for(let i = 0, len = chunks.length; i < len; i++)if (chunks[i].buffer.length > 0) {
            if (!chunks[i].lineStarts) chunks[i].lineStarts = createLineStartsFast(chunks[i].buffer);
            const piece = new Piece(i + 1, {
                line: 0,
                column: 0
            }, {
                line: chunks[i].lineStarts.length - 1,
                column: chunks[i].buffer.length - chunks[i].lineStarts[chunks[i].lineStarts.length - 1]
            }, chunks[i].lineStarts.length - 1, chunks[i].buffer.length);
            this._buffers.push(chunks[i]);
            lastNode = this.rbInsertRight(lastNode, piece);
        }
        this._searchCache = new PieceTreeSearchCache(1);
        this._lastVisitedLine = {
            lineNumber: 0,
            value: ""
        };
        this.computeBufferMetadata();
    }
    normalizeEOL(eol) {
        const averageBufferSize = AverageBufferSize;
        const min = averageBufferSize - Math.floor(averageBufferSize / 3);
        const max = min * 2;
        let tempChunk = "";
        let tempChunkLen = 0;
        const chunks = [];
        this.iterate(this.root, (node)=>{
            const str = this.getNodeContent(node);
            const len = str.length;
            if (tempChunkLen <= min || tempChunkLen + len < max) {
                tempChunk += str;
                tempChunkLen += len;
                return true;
            }
            // flush anyways
            const text = tempChunk.replace(/\r\n|\r|\n/g, eol);
            chunks.push(new StringBuffer(text, createLineStartsFast(text)));
            tempChunk = str;
            tempChunkLen = len;
            return true;
        });
        if (tempChunkLen > 0) {
            const text = tempChunk.replace(/\r\n|\r|\n/g, eol);
            chunks.push(new StringBuffer(text, createLineStartsFast(text)));
        }
        this.create(chunks, eol, true);
    }
    // #region Buffer API
    getEOL() {
        return this._EOL;
    }
    setEOL(newEOL) {
        this._EOL = newEOL;
        this._EOLLength = this._EOL.length;
        this.normalizeEOL(newEOL);
    }
    createSnapshot(BOM) {
        return new PieceTreeSnapshot(this, BOM);
    }
    getOffsetAt(lineNumber, column) {
        let leftLen = 0; // inorder
        let x = this.root;
        while(x !== (0, _rbTreeBaseJs.SENTINEL)){
            if (x.left !== (0, _rbTreeBaseJs.SENTINEL) && x.lf_left + 1 >= lineNumber) x = x.left;
            else if (x.lf_left + x.piece.lineFeedCnt + 1 >= lineNumber) {
                leftLen += x.size_left;
                // lineNumber >= 2
                const accumualtedValInCurrentIndex = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
                return leftLen += accumualtedValInCurrentIndex + column - 1;
            } else {
                lineNumber -= x.lf_left + x.piece.lineFeedCnt;
                leftLen += x.size_left + x.piece.length;
                x = x.right;
            }
        }
        return leftLen;
    }
    getPositionAt(offset) {
        offset = Math.floor(offset);
        offset = Math.max(0, offset);
        let x = this.root;
        let lfCnt = 0;
        const originalOffset = offset;
        while(x !== (0, _rbTreeBaseJs.SENTINEL)){
            if (x.size_left !== 0 && x.size_left >= offset) x = x.left;
            else if (x.size_left + x.piece.length >= offset) {
                const out = this.getIndexOf(x, offset - x.size_left);
                lfCnt += x.lf_left + out.index;
                if (out.index === 0) {
                    const lineStartOffset = this.getOffsetAt(lfCnt + 1, 1);
                    const column = originalOffset - lineStartOffset;
                    return new (0, _positionJs.Position)(lfCnt + 1, column + 1);
                }
                return new (0, _positionJs.Position)(lfCnt + 1, out.remainder + 1);
            } else {
                offset -= x.size_left + x.piece.length;
                lfCnt += x.lf_left + x.piece.lineFeedCnt;
                if (x.right === (0, _rbTreeBaseJs.SENTINEL)) {
                    // last node
                    const lineStartOffset = this.getOffsetAt(lfCnt + 1, 1);
                    const column = originalOffset - offset - lineStartOffset;
                    return new (0, _positionJs.Position)(lfCnt + 1, column + 1);
                } else x = x.right;
            }
        }
        return new (0, _positionJs.Position)(1, 1);
    }
    getValueInRange(range, eol) {
        if (range.startLineNumber === range.endLineNumber && range.startColumn === range.endColumn) return "";
        const startPosition = this.nodeAt2(range.startLineNumber, range.startColumn);
        const endPosition = this.nodeAt2(range.endLineNumber, range.endColumn);
        const value = this.getValueInRange2(startPosition, endPosition);
        if (eol) {
            if (eol !== this._EOL || !this._EOLNormalized) return value.replace(/\r\n|\r|\n/g, eol);
            if (eol === this.getEOL() && this._EOLNormalized) {
                eol;
                return value;
            }
            return value.replace(/\r\n|\r|\n/g, eol);
        }
        return value;
    }
    getValueInRange2(startPosition, endPosition) {
        if (startPosition.node === endPosition.node) {
            const node = startPosition.node;
            const buffer = this._buffers[node.piece.bufferIndex].buffer;
            const startOffset = this.offsetInBuffer(node.piece.bufferIndex, node.piece.start);
            return buffer.substring(startOffset + startPosition.remainder, startOffset + endPosition.remainder);
        }
        let x = startPosition.node;
        const buffer = this._buffers[x.piece.bufferIndex].buffer;
        const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
        let ret = buffer.substring(startOffset + startPosition.remainder, startOffset + x.piece.length);
        x = x.next();
        while(x !== (0, _rbTreeBaseJs.SENTINEL)){
            const buffer = this._buffers[x.piece.bufferIndex].buffer;
            const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
            if (x === endPosition.node) {
                ret += buffer.substring(startOffset, startOffset + endPosition.remainder);
                break;
            } else ret += buffer.substr(startOffset, x.piece.length);
            x = x.next();
        }
        return ret;
    }
    getLinesContent() {
        const lines = [];
        let linesLength = 0;
        let currentLine = "";
        let danglingCR = false;
        this.iterate(this.root, (node)=>{
            if (node === (0, _rbTreeBaseJs.SENTINEL)) return true;
            const piece = node.piece;
            let pieceLength = piece.length;
            if (pieceLength === 0) return true;
            const buffer = this._buffers[piece.bufferIndex].buffer;
            const lineStarts = this._buffers[piece.bufferIndex].lineStarts;
            const pieceStartLine = piece.start.line;
            const pieceEndLine = piece.end.line;
            let pieceStartOffset = lineStarts[pieceStartLine] + piece.start.column;
            if (danglingCR) {
                if (buffer.charCodeAt(pieceStartOffset) === 10 /* CharCode.LineFeed */ ) {
                    // pretend the \n was in the previous piece..
                    pieceStartOffset++;
                    pieceLength--;
                }
                lines[linesLength++] = currentLine;
                currentLine = "";
                danglingCR = false;
                if (pieceLength === 0) return true;
            }
            if (pieceStartLine === pieceEndLine) {
                // this piece has no new lines
                if (!this._EOLNormalized && buffer.charCodeAt(pieceStartOffset + pieceLength - 1) === 13 /* CharCode.CarriageReturn */ ) {
                    danglingCR = true;
                    currentLine += buffer.substr(pieceStartOffset, pieceLength - 1);
                } else currentLine += buffer.substr(pieceStartOffset, pieceLength);
                return true;
            }
            // add the text before the first line start in this piece
            currentLine += this._EOLNormalized ? buffer.substring(pieceStartOffset, Math.max(pieceStartOffset, lineStarts[pieceStartLine + 1] - this._EOLLength)) : buffer.substring(pieceStartOffset, lineStarts[pieceStartLine + 1]).replace(/(\r\n|\r|\n)$/, "");
            lines[linesLength++] = currentLine;
            for(let line = pieceStartLine + 1; line < pieceEndLine; line++){
                currentLine = this._EOLNormalized ? buffer.substring(lineStarts[line], lineStarts[line + 1] - this._EOLLength) : buffer.substring(lineStarts[line], lineStarts[line + 1]).replace(/(\r\n|\r|\n)$/, "");
                lines[linesLength++] = currentLine;
            }
            if (!this._EOLNormalized && buffer.charCodeAt(lineStarts[pieceEndLine] + piece.end.column - 1) === 13 /* CharCode.CarriageReturn */ ) {
                danglingCR = true;
                if (piece.end.column === 0) // The last line ended with a \r, let's undo the push, it will be pushed by next iteration
                linesLength--;
                else currentLine = buffer.substr(lineStarts[pieceEndLine], piece.end.column - 1);
            } else currentLine = buffer.substr(lineStarts[pieceEndLine], piece.end.column);
            return true;
        });
        if (danglingCR) {
            lines[linesLength++] = currentLine;
            currentLine = "";
        }
        lines[linesLength++] = currentLine;
        return lines;
    }
    getLength() {
        return this._length;
    }
    getLineCount() {
        return this._lineCnt;
    }
    getLineContent(lineNumber) {
        if (this._lastVisitedLine.lineNumber === lineNumber) return this._lastVisitedLine.value;
        this._lastVisitedLine.lineNumber = lineNumber;
        if (lineNumber === this._lineCnt) this._lastVisitedLine.value = this.getLineRawContent(lineNumber);
        else if (this._EOLNormalized) this._lastVisitedLine.value = this.getLineRawContent(lineNumber, this._EOLLength);
        else this._lastVisitedLine.value = this.getLineRawContent(lineNumber).replace(/(\r\n|\r|\n)$/, "");
        return this._lastVisitedLine.value;
    }
    _getCharCode(nodePos) {
        if (nodePos.remainder === nodePos.node.piece.length) {
            // the char we want to fetch is at the head of next node.
            const matchingNode = nodePos.node.next();
            if (!matchingNode) return 0;
            const buffer = this._buffers[matchingNode.piece.bufferIndex];
            const startOffset = this.offsetInBuffer(matchingNode.piece.bufferIndex, matchingNode.piece.start);
            return buffer.buffer.charCodeAt(startOffset);
        } else {
            const buffer = this._buffers[nodePos.node.piece.bufferIndex];
            const startOffset = this.offsetInBuffer(nodePos.node.piece.bufferIndex, nodePos.node.piece.start);
            const targetOffset = startOffset + nodePos.remainder;
            return buffer.buffer.charCodeAt(targetOffset);
        }
    }
    getLineCharCode(lineNumber, index) {
        const nodePos = this.nodeAt2(lineNumber, index + 1);
        return this._getCharCode(nodePos);
    }
    getLineLength(lineNumber) {
        if (lineNumber === this.getLineCount()) {
            const startOffset = this.getOffsetAt(lineNumber, 1);
            return this.getLength() - startOffset;
        }
        return this.getOffsetAt(lineNumber + 1, 1) - this.getOffsetAt(lineNumber, 1) - this._EOLLength;
    }
    findMatchesInNode(node, searcher, startLineNumber, startColumn, startCursor, endCursor, searchData, captureMatches, limitResultCount, resultLen, result) {
        const buffer = this._buffers[node.piece.bufferIndex];
        const startOffsetInBuffer = this.offsetInBuffer(node.piece.bufferIndex, node.piece.start);
        const start = this.offsetInBuffer(node.piece.bufferIndex, startCursor);
        const end = this.offsetInBuffer(node.piece.bufferIndex, endCursor);
        let m;
        // Reset regex to search from the beginning
        const ret = {
            line: 0,
            column: 0
        };
        let searchText;
        let offsetInBuffer;
        if (searcher._wordSeparators) {
            searchText = buffer.buffer.substring(start, end);
            offsetInBuffer = (offset)=>offset + start;
            searcher.reset(0);
        } else {
            searchText = buffer.buffer;
            offsetInBuffer = (offset)=>offset;
            searcher.reset(start);
        }
        do {
            m = searcher.next(searchText);
            if (m) {
                if (offsetInBuffer(m.index) >= end) return resultLen;
                this.positionInBuffer(node, offsetInBuffer(m.index) - startOffsetInBuffer, ret);
                const lineFeedCnt = this.getLineFeedCnt(node.piece.bufferIndex, startCursor, ret);
                const retStartColumn = ret.line === startCursor.line ? ret.column - startCursor.column + startColumn : ret.column + 1;
                const retEndColumn = retStartColumn + m[0].length;
                result[resultLen++] = (0, _textModelSearchJs.createFindMatch)(new (0, _rangeJs.Range)(startLineNumber + lineFeedCnt, retStartColumn, startLineNumber + lineFeedCnt, retEndColumn), m, captureMatches);
                if (offsetInBuffer(m.index) + m[0].length >= end) return resultLen;
                if (resultLen >= limitResultCount) return resultLen;
            }
        }while (m);
        return resultLen;
    }
    findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount) {
        const result = [];
        let resultLen = 0;
        const searcher = new (0, _textModelSearchJs.Searcher)(searchData.wordSeparators, searchData.regex);
        let startPosition = this.nodeAt2(searchRange.startLineNumber, searchRange.startColumn);
        if (startPosition === null) return [];
        const endPosition = this.nodeAt2(searchRange.endLineNumber, searchRange.endColumn);
        if (endPosition === null) return [];
        let start = this.positionInBuffer(startPosition.node, startPosition.remainder);
        const end = this.positionInBuffer(endPosition.node, endPosition.remainder);
        if (startPosition.node === endPosition.node) {
            this.findMatchesInNode(startPosition.node, searcher, searchRange.startLineNumber, searchRange.startColumn, start, end, searchData, captureMatches, limitResultCount, resultLen, result);
            return result;
        }
        let startLineNumber = searchRange.startLineNumber;
        let currentNode = startPosition.node;
        while(currentNode !== endPosition.node){
            const lineBreakCnt = this.getLineFeedCnt(currentNode.piece.bufferIndex, start, currentNode.piece.end);
            if (lineBreakCnt >= 1) {
                // last line break position
                const lineStarts = this._buffers[currentNode.piece.bufferIndex].lineStarts;
                const startOffsetInBuffer = this.offsetInBuffer(currentNode.piece.bufferIndex, currentNode.piece.start);
                const nextLineStartOffset = lineStarts[start.line + lineBreakCnt];
                const startColumn = startLineNumber === searchRange.startLineNumber ? searchRange.startColumn : 1;
                resultLen = this.findMatchesInNode(currentNode, searcher, startLineNumber, startColumn, start, this.positionInBuffer(currentNode, nextLineStartOffset - startOffsetInBuffer), searchData, captureMatches, limitResultCount, resultLen, result);
                if (resultLen >= limitResultCount) return result;
                startLineNumber += lineBreakCnt;
            }
            const startColumn = startLineNumber === searchRange.startLineNumber ? searchRange.startColumn - 1 : 0;
            // search for the remaining content
            if (startLineNumber === searchRange.endLineNumber) {
                const text = this.getLineContent(startLineNumber).substring(startColumn, searchRange.endColumn - 1);
                resultLen = this._findMatchesInLine(searchData, searcher, text, searchRange.endLineNumber, startColumn, resultLen, result, captureMatches, limitResultCount);
                return result;
            }
            resultLen = this._findMatchesInLine(searchData, searcher, this.getLineContent(startLineNumber).substr(startColumn), startLineNumber, startColumn, resultLen, result, captureMatches, limitResultCount);
            if (resultLen >= limitResultCount) return result;
            startLineNumber++;
            startPosition = this.nodeAt2(startLineNumber, 1);
            currentNode = startPosition.node;
            start = this.positionInBuffer(startPosition.node, startPosition.remainder);
        }
        if (startLineNumber === searchRange.endLineNumber) {
            const startColumn = startLineNumber === searchRange.startLineNumber ? searchRange.startColumn - 1 : 0;
            const text = this.getLineContent(startLineNumber).substring(startColumn, searchRange.endColumn - 1);
            resultLen = this._findMatchesInLine(searchData, searcher, text, searchRange.endLineNumber, startColumn, resultLen, result, captureMatches, limitResultCount);
            return result;
        }
        const startColumn = startLineNumber === searchRange.startLineNumber ? searchRange.startColumn : 1;
        resultLen = this.findMatchesInNode(endPosition.node, searcher, startLineNumber, startColumn, start, end, searchData, captureMatches, limitResultCount, resultLen, result);
        return result;
    }
    _findMatchesInLine(searchData, searcher, text, lineNumber, deltaOffset, resultLen, result, captureMatches, limitResultCount) {
        const wordSeparators = searchData.wordSeparators;
        if (!captureMatches && searchData.simpleSearch) {
            const searchString = searchData.simpleSearch;
            const searchStringLen = searchString.length;
            const textLength = text.length;
            let lastMatchIndex = -searchStringLen;
            while((lastMatchIndex = text.indexOf(searchString, lastMatchIndex + searchStringLen)) !== -1)if (!wordSeparators || (0, _textModelSearchJs.isValidMatch)(wordSeparators, text, textLength, lastMatchIndex, searchStringLen)) {
                result[resultLen++] = new (0, _modelJs.FindMatch)(new (0, _rangeJs.Range)(lineNumber, lastMatchIndex + 1 + deltaOffset, lineNumber, lastMatchIndex + 1 + searchStringLen + deltaOffset), null);
                if (resultLen >= limitResultCount) return resultLen;
            }
            return resultLen;
        }
        let m;
        // Reset regex to search from the beginning
        searcher.reset(0);
        do {
            m = searcher.next(text);
            if (m) {
                result[resultLen++] = (0, _textModelSearchJs.createFindMatch)(new (0, _rangeJs.Range)(lineNumber, m.index + 1 + deltaOffset, lineNumber, m.index + 1 + m[0].length + deltaOffset), m, captureMatches);
                if (resultLen >= limitResultCount) return resultLen;
            }
        }while (m);
        return resultLen;
    }
    // #endregion
    // #region Piece Table
    insert(offset, value, eolNormalized = false) {
        this._EOLNormalized = this._EOLNormalized && eolNormalized;
        this._lastVisitedLine.lineNumber = 0;
        this._lastVisitedLine.value = "";
        if (this.root !== (0, _rbTreeBaseJs.SENTINEL)) {
            const { node, remainder, nodeStartOffset } = this.nodeAt(offset);
            const piece = node.piece;
            const bufferIndex = piece.bufferIndex;
            const insertPosInBuffer = this.positionInBuffer(node, remainder);
            if (node.piece.bufferIndex === 0 && piece.end.line === this._lastChangeBufferPos.line && piece.end.column === this._lastChangeBufferPos.column && nodeStartOffset + piece.length === offset && value.length < AverageBufferSize) {
                // changed buffer
                this.appendToNode(node, value);
                this.computeBufferMetadata();
                return;
            }
            if (nodeStartOffset === offset) {
                this.insertContentToNodeLeft(value, node);
                this._searchCache.validate(offset);
            } else if (nodeStartOffset + node.piece.length > offset) {
                // we are inserting into the middle of a node.
                const nodesToDel = [];
                let newRightPiece = new Piece(piece.bufferIndex, insertPosInBuffer, piece.end, this.getLineFeedCnt(piece.bufferIndex, insertPosInBuffer, piece.end), this.offsetInBuffer(bufferIndex, piece.end) - this.offsetInBuffer(bufferIndex, insertPosInBuffer));
                if (this.shouldCheckCRLF() && this.endWithCR(value)) {
                    const headOfRight = this.nodeCharCodeAt(node, remainder);
                    if (headOfRight === 10 /** \n */ ) {
                        const newStart = {
                            line: newRightPiece.start.line + 1,
                            column: 0
                        };
                        newRightPiece = new Piece(newRightPiece.bufferIndex, newStart, newRightPiece.end, this.getLineFeedCnt(newRightPiece.bufferIndex, newStart, newRightPiece.end), newRightPiece.length - 1);
                        value += "\n";
                    }
                }
                // reuse node for content before insertion point.
                if (this.shouldCheckCRLF() && this.startWithLF(value)) {
                    const tailOfLeft = this.nodeCharCodeAt(node, remainder - 1);
                    if (tailOfLeft === 13 /** \r */ ) {
                        const previousPos = this.positionInBuffer(node, remainder - 1);
                        this.deleteNodeTail(node, previousPos);
                        value = "\r" + value;
                        if (node.piece.length === 0) nodesToDel.push(node);
                    } else this.deleteNodeTail(node, insertPosInBuffer);
                } else this.deleteNodeTail(node, insertPosInBuffer);
                const newPieces = this.createNewPieces(value);
                if (newRightPiece.length > 0) this.rbInsertRight(node, newRightPiece);
                let tmpNode = node;
                for(let k = 0; k < newPieces.length; k++)tmpNode = this.rbInsertRight(tmpNode, newPieces[k]);
                this.deleteNodes(nodesToDel);
            } else this.insertContentToNodeRight(value, node);
        } else {
            // insert new node
            const pieces = this.createNewPieces(value);
            let node = this.rbInsertLeft(null, pieces[0]);
            for(let k = 1; k < pieces.length; k++)node = this.rbInsertRight(node, pieces[k]);
        }
        // todo, this is too brutal. Total line feed count should be updated the same way as lf_left.
        this.computeBufferMetadata();
    }
    delete(offset, cnt) {
        this._lastVisitedLine.lineNumber = 0;
        this._lastVisitedLine.value = "";
        if (cnt <= 0 || this.root === (0, _rbTreeBaseJs.SENTINEL)) return;
        const startPosition = this.nodeAt(offset);
        const endPosition = this.nodeAt(offset + cnt);
        const startNode = startPosition.node;
        const endNode = endPosition.node;
        if (startNode === endNode) {
            const startSplitPosInBuffer = this.positionInBuffer(startNode, startPosition.remainder);
            const endSplitPosInBuffer = this.positionInBuffer(startNode, endPosition.remainder);
            if (startPosition.nodeStartOffset === offset) {
                if (cnt === startNode.piece.length) {
                    const next = startNode.next();
                    (0, _rbTreeBaseJs.rbDelete)(this, startNode);
                    this.validateCRLFWithPrevNode(next);
                    this.computeBufferMetadata();
                    return;
                }
                this.deleteNodeHead(startNode, endSplitPosInBuffer);
                this._searchCache.validate(offset);
                this.validateCRLFWithPrevNode(startNode);
                this.computeBufferMetadata();
                return;
            }
            if (startPosition.nodeStartOffset + startNode.piece.length === offset + cnt) {
                this.deleteNodeTail(startNode, startSplitPosInBuffer);
                this.validateCRLFWithNextNode(startNode);
                this.computeBufferMetadata();
                return;
            }
            // delete content in the middle, this node will be splitted to nodes
            this.shrinkNode(startNode, startSplitPosInBuffer, endSplitPosInBuffer);
            this.computeBufferMetadata();
            return;
        }
        const nodesToDel = [];
        const startSplitPosInBuffer = this.positionInBuffer(startNode, startPosition.remainder);
        this.deleteNodeTail(startNode, startSplitPosInBuffer);
        this._searchCache.validate(offset);
        if (startNode.piece.length === 0) nodesToDel.push(startNode);
        // update last touched node
        const endSplitPosInBuffer = this.positionInBuffer(endNode, endPosition.remainder);
        this.deleteNodeHead(endNode, endSplitPosInBuffer);
        if (endNode.piece.length === 0) nodesToDel.push(endNode);
        // delete nodes in between
        const secondNode = startNode.next();
        for(let node = secondNode; node !== (0, _rbTreeBaseJs.SENTINEL) && node !== endNode; node = node.next())nodesToDel.push(node);
        const prev = startNode.piece.length === 0 ? startNode.prev() : startNode;
        this.deleteNodes(nodesToDel);
        this.validateCRLFWithNextNode(prev);
        this.computeBufferMetadata();
    }
    insertContentToNodeLeft(value, node) {
        // we are inserting content to the beginning of node
        const nodesToDel = [];
        if (this.shouldCheckCRLF() && this.endWithCR(value) && this.startWithLF(node)) {
            // move `\n` to new node.
            const piece = node.piece;
            const newStart = {
                line: piece.start.line + 1,
                column: 0
            };
            const nPiece = new Piece(piece.bufferIndex, newStart, piece.end, this.getLineFeedCnt(piece.bufferIndex, newStart, piece.end), piece.length - 1);
            node.piece = nPiece;
            value += "\n";
            (0, _rbTreeBaseJs.updateTreeMetadata)(this, node, -1, -1);
            if (node.piece.length === 0) nodesToDel.push(node);
        }
        const newPieces = this.createNewPieces(value);
        let newNode = this.rbInsertLeft(node, newPieces[newPieces.length - 1]);
        for(let k = newPieces.length - 2; k >= 0; k--)newNode = this.rbInsertLeft(newNode, newPieces[k]);
        this.validateCRLFWithPrevNode(newNode);
        this.deleteNodes(nodesToDel);
    }
    insertContentToNodeRight(value, node) {
        // we are inserting to the right of this node.
        if (this.adjustCarriageReturnFromNext(value, node)) // move \n to the new node.
        value += "\n";
        const newPieces = this.createNewPieces(value);
        const newNode = this.rbInsertRight(node, newPieces[0]);
        let tmpNode = newNode;
        for(let k = 1; k < newPieces.length; k++)tmpNode = this.rbInsertRight(tmpNode, newPieces[k]);
        this.validateCRLFWithPrevNode(newNode);
    }
    positionInBuffer(node, remainder, ret) {
        const piece = node.piece;
        const bufferIndex = node.piece.bufferIndex;
        const lineStarts = this._buffers[bufferIndex].lineStarts;
        const startOffset = lineStarts[piece.start.line] + piece.start.column;
        const offset = startOffset + remainder;
        // binary search offset between startOffset and endOffset
        let low = piece.start.line;
        let high = piece.end.line;
        let mid = 0;
        let midStop = 0;
        let midStart = 0;
        while(low <= high){
            mid = low + (high - low) / 2 | 0;
            midStart = lineStarts[mid];
            if (mid === high) break;
            midStop = lineStarts[mid + 1];
            if (offset < midStart) high = mid - 1;
            else if (offset >= midStop) low = mid + 1;
            else break;
        }
        if (ret) {
            ret.line = mid;
            ret.column = offset - midStart;
            return null;
        }
        return {
            line: mid,
            column: offset - midStart
        };
    }
    getLineFeedCnt(bufferIndex, start, end) {
        // we don't need to worry about start: abc\r|\n, or abc|\r, or abc|\n, or abc|\r\n doesn't change the fact that, there is one line break after start.
        // now let's take care of end: abc\r|\n, if end is in between \r and \n, we need to add line feed count by 1
        if (end.column === 0) return end.line - start.line;
        const lineStarts = this._buffers[bufferIndex].lineStarts;
        if (end.line === lineStarts.length - 1) return end.line - start.line;
        const nextLineStartOffset = lineStarts[end.line + 1];
        const endOffset = lineStarts[end.line] + end.column;
        if (nextLineStartOffset > endOffset + 1) return end.line - start.line;
        // endOffset + 1 === nextLineStartOffset
        // character at endOffset is \n, so we check the character before first
        // if character at endOffset is \r, end.column is 0 and we can't get here.
        const previousCharOffset = endOffset - 1; // end.column > 0 so it's okay.
        const buffer = this._buffers[bufferIndex].buffer;
        if (buffer.charCodeAt(previousCharOffset) === 13) return end.line - start.line + 1;
        else return end.line - start.line;
    }
    offsetInBuffer(bufferIndex, cursor) {
        const lineStarts = this._buffers[bufferIndex].lineStarts;
        return lineStarts[cursor.line] + cursor.column;
    }
    deleteNodes(nodes) {
        for(let i = 0; i < nodes.length; i++)(0, _rbTreeBaseJs.rbDelete)(this, nodes[i]);
    }
    createNewPieces(text) {
        if (text.length > AverageBufferSize) {
            // the content is large, operations like substring, charCode becomes slow
            // so here we split it into smaller chunks, just like what we did for CR/LF normalization
            const newPieces = [];
            while(text.length > AverageBufferSize){
                const lastChar = text.charCodeAt(AverageBufferSize - 1);
                let splitText;
                if (lastChar === 13 /* CharCode.CarriageReturn */  || lastChar >= 0xD800 && lastChar <= 0xDBFF) {
                    // last character is \r or a high surrogate => keep it back
                    splitText = text.substring(0, AverageBufferSize - 1);
                    text = text.substring(AverageBufferSize - 1);
                } else {
                    splitText = text.substring(0, AverageBufferSize);
                    text = text.substring(AverageBufferSize);
                }
                const lineStarts = createLineStartsFast(splitText);
                newPieces.push(new Piece(this._buffers.length, /* buffer index */ {
                    line: 0,
                    column: 0
                }, {
                    line: lineStarts.length - 1,
                    column: splitText.length - lineStarts[lineStarts.length - 1]
                }, lineStarts.length - 1, splitText.length));
                this._buffers.push(new StringBuffer(splitText, lineStarts));
            }
            const lineStarts = createLineStartsFast(text);
            newPieces.push(new Piece(this._buffers.length, /* buffer index */ {
                line: 0,
                column: 0
            }, {
                line: lineStarts.length - 1,
                column: text.length - lineStarts[lineStarts.length - 1]
            }, lineStarts.length - 1, text.length));
            this._buffers.push(new StringBuffer(text, lineStarts));
            return newPieces;
        }
        let startOffset = this._buffers[0].buffer.length;
        const lineStarts = createLineStartsFast(text, false);
        let start = this._lastChangeBufferPos;
        if (this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 1] === startOffset && startOffset !== 0 && this.startWithLF(text) && this.endWithCR(this._buffers[0].buffer) // todo, we can check this._lastChangeBufferPos's column as it's the last one
        ) {
            this._lastChangeBufferPos = {
                line: this._lastChangeBufferPos.line,
                column: this._lastChangeBufferPos.column + 1
            };
            start = this._lastChangeBufferPos;
            for(let i = 0; i < lineStarts.length; i++)lineStarts[i] += startOffset + 1;
            this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(lineStarts.slice(1));
            this._buffers[0].buffer += "_" + text;
            startOffset += 1;
        } else {
            if (startOffset !== 0) for(let i = 0; i < lineStarts.length; i++)lineStarts[i] += startOffset;
            this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(lineStarts.slice(1));
            this._buffers[0].buffer += text;
        }
        const endOffset = this._buffers[0].buffer.length;
        const endIndex = this._buffers[0].lineStarts.length - 1;
        const endColumn = endOffset - this._buffers[0].lineStarts[endIndex];
        const endPos = {
            line: endIndex,
            column: endColumn
        };
        const newPiece = new Piece(0, /** todo@peng */ start, endPos, this.getLineFeedCnt(0, start, endPos), endOffset - startOffset);
        this._lastChangeBufferPos = endPos;
        return [
            newPiece
        ];
    }
    getLineRawContent(lineNumber, endOffset = 0) {
        let x = this.root;
        let ret = "";
        const cache = this._searchCache.get2(lineNumber);
        if (cache) {
            x = cache.node;
            const prevAccumulatedValue = this.getAccumulatedValue(x, lineNumber - cache.nodeStartLineNumber - 1);
            const buffer = this._buffers[x.piece.bufferIndex].buffer;
            const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
            if (cache.nodeStartLineNumber + x.piece.lineFeedCnt === lineNumber) ret = buffer.substring(startOffset + prevAccumulatedValue, startOffset + x.piece.length);
            else {
                const accumulatedValue = this.getAccumulatedValue(x, lineNumber - cache.nodeStartLineNumber);
                return buffer.substring(startOffset + prevAccumulatedValue, startOffset + accumulatedValue - endOffset);
            }
        } else {
            let nodeStartOffset = 0;
            const originalLineNumber = lineNumber;
            while(x !== (0, _rbTreeBaseJs.SENTINEL)){
                if (x.left !== (0, _rbTreeBaseJs.SENTINEL) && x.lf_left >= lineNumber - 1) x = x.left;
                else if (x.lf_left + x.piece.lineFeedCnt > lineNumber - 1) {
                    const prevAccumulatedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
                    const accumulatedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 1);
                    const buffer = this._buffers[x.piece.bufferIndex].buffer;
                    const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
                    nodeStartOffset += x.size_left;
                    this._searchCache.set({
                        node: x,
                        nodeStartOffset,
                        nodeStartLineNumber: originalLineNumber - (lineNumber - 1 - x.lf_left)
                    });
                    return buffer.substring(startOffset + prevAccumulatedValue, startOffset + accumulatedValue - endOffset);
                } else if (x.lf_left + x.piece.lineFeedCnt === lineNumber - 1) {
                    const prevAccumulatedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
                    const buffer = this._buffers[x.piece.bufferIndex].buffer;
                    const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
                    ret = buffer.substring(startOffset + prevAccumulatedValue, startOffset + x.piece.length);
                    break;
                } else {
                    lineNumber -= x.lf_left + x.piece.lineFeedCnt;
                    nodeStartOffset += x.size_left + x.piece.length;
                    x = x.right;
                }
            }
        }
        // search in order, to find the node contains end column
        x = x.next();
        while(x !== (0, _rbTreeBaseJs.SENTINEL)){
            const buffer = this._buffers[x.piece.bufferIndex].buffer;
            if (x.piece.lineFeedCnt > 0) {
                const accumulatedValue = this.getAccumulatedValue(x, 0);
                const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
                ret += buffer.substring(startOffset, startOffset + accumulatedValue - endOffset);
                return ret;
            } else {
                const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
                ret += buffer.substr(startOffset, x.piece.length);
            }
            x = x.next();
        }
        return ret;
    }
    computeBufferMetadata() {
        let x = this.root;
        let lfCnt = 1;
        let len = 0;
        while(x !== (0, _rbTreeBaseJs.SENTINEL)){
            lfCnt += x.lf_left + x.piece.lineFeedCnt;
            len += x.size_left + x.piece.length;
            x = x.right;
        }
        this._lineCnt = lfCnt;
        this._length = len;
        this._searchCache.validate(this._length);
    }
    // #region node operations
    getIndexOf(node, accumulatedValue) {
        const piece = node.piece;
        const pos = this.positionInBuffer(node, accumulatedValue);
        const lineCnt = pos.line - piece.start.line;
        if (this.offsetInBuffer(piece.bufferIndex, piece.end) - this.offsetInBuffer(piece.bufferIndex, piece.start) === accumulatedValue) {
            // we are checking the end of this node, so a CRLF check is necessary.
            const realLineCnt = this.getLineFeedCnt(node.piece.bufferIndex, piece.start, pos);
            if (realLineCnt !== lineCnt) // aha yes, CRLF
            return {
                index: realLineCnt,
                remainder: 0
            };
        }
        return {
            index: lineCnt,
            remainder: pos.column
        };
    }
    getAccumulatedValue(node, index) {
        if (index < 0) return 0;
        const piece = node.piece;
        const lineStarts = this._buffers[piece.bufferIndex].lineStarts;
        const expectedLineStartIndex = piece.start.line + index + 1;
        if (expectedLineStartIndex > piece.end.line) return lineStarts[piece.end.line] + piece.end.column - lineStarts[piece.start.line] - piece.start.column;
        else return lineStarts[expectedLineStartIndex] - lineStarts[piece.start.line] - piece.start.column;
    }
    deleteNodeTail(node, pos) {
        const piece = node.piece;
        const originalLFCnt = piece.lineFeedCnt;
        const originalEndOffset = this.offsetInBuffer(piece.bufferIndex, piece.end);
        const newEnd = pos;
        const newEndOffset = this.offsetInBuffer(piece.bufferIndex, newEnd);
        const newLineFeedCnt = this.getLineFeedCnt(piece.bufferIndex, piece.start, newEnd);
        const lf_delta = newLineFeedCnt - originalLFCnt;
        const size_delta = newEndOffset - originalEndOffset;
        const newLength = piece.length + size_delta;
        node.piece = new Piece(piece.bufferIndex, piece.start, newEnd, newLineFeedCnt, newLength);
        (0, _rbTreeBaseJs.updateTreeMetadata)(this, node, size_delta, lf_delta);
    }
    deleteNodeHead(node, pos) {
        const piece = node.piece;
        const originalLFCnt = piece.lineFeedCnt;
        const originalStartOffset = this.offsetInBuffer(piece.bufferIndex, piece.start);
        const newStart = pos;
        const newLineFeedCnt = this.getLineFeedCnt(piece.bufferIndex, newStart, piece.end);
        const newStartOffset = this.offsetInBuffer(piece.bufferIndex, newStart);
        const lf_delta = newLineFeedCnt - originalLFCnt;
        const size_delta = originalStartOffset - newStartOffset;
        const newLength = piece.length + size_delta;
        node.piece = new Piece(piece.bufferIndex, newStart, piece.end, newLineFeedCnt, newLength);
        (0, _rbTreeBaseJs.updateTreeMetadata)(this, node, size_delta, lf_delta);
    }
    shrinkNode(node, start, end) {
        const piece = node.piece;
        const originalStartPos = piece.start;
        const originalEndPos = piece.end;
        // old piece, originalStartPos, start
        const oldLength = piece.length;
        const oldLFCnt = piece.lineFeedCnt;
        const newEnd = start;
        const newLineFeedCnt = this.getLineFeedCnt(piece.bufferIndex, piece.start, newEnd);
        const newLength = this.offsetInBuffer(piece.bufferIndex, start) - this.offsetInBuffer(piece.bufferIndex, originalStartPos);
        node.piece = new Piece(piece.bufferIndex, piece.start, newEnd, newLineFeedCnt, newLength);
        (0, _rbTreeBaseJs.updateTreeMetadata)(this, node, newLength - oldLength, newLineFeedCnt - oldLFCnt);
        // new right piece, end, originalEndPos
        const newPiece = new Piece(piece.bufferIndex, end, originalEndPos, this.getLineFeedCnt(piece.bufferIndex, end, originalEndPos), this.offsetInBuffer(piece.bufferIndex, originalEndPos) - this.offsetInBuffer(piece.bufferIndex, end));
        const newNode = this.rbInsertRight(node, newPiece);
        this.validateCRLFWithPrevNode(newNode);
    }
    appendToNode(node, value) {
        if (this.adjustCarriageReturnFromNext(value, node)) value += "\n";
        const hitCRLF = this.shouldCheckCRLF() && this.startWithLF(value) && this.endWithCR(node);
        const startOffset = this._buffers[0].buffer.length;
        this._buffers[0].buffer += value;
        const lineStarts = createLineStartsFast(value, false);
        for(let i = 0; i < lineStarts.length; i++)lineStarts[i] += startOffset;
        if (hitCRLF) {
            const prevStartOffset = this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 2];
            this._buffers[0].lineStarts.pop();
            // _lastChangeBufferPos is already wrong
            this._lastChangeBufferPos = {
                line: this._lastChangeBufferPos.line - 1,
                column: startOffset - prevStartOffset
            };
        }
        this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(lineStarts.slice(1));
        const endIndex = this._buffers[0].lineStarts.length - 1;
        const endColumn = this._buffers[0].buffer.length - this._buffers[0].lineStarts[endIndex];
        const newEnd = {
            line: endIndex,
            column: endColumn
        };
        const newLength = node.piece.length + value.length;
        const oldLineFeedCnt = node.piece.lineFeedCnt;
        const newLineFeedCnt = this.getLineFeedCnt(0, node.piece.start, newEnd);
        const lf_delta = newLineFeedCnt - oldLineFeedCnt;
        node.piece = new Piece(node.piece.bufferIndex, node.piece.start, newEnd, newLineFeedCnt, newLength);
        this._lastChangeBufferPos = newEnd;
        (0, _rbTreeBaseJs.updateTreeMetadata)(this, node, value.length, lf_delta);
    }
    nodeAt(offset) {
        let x = this.root;
        const cache = this._searchCache.get(offset);
        if (cache) return {
            node: cache.node,
            nodeStartOffset: cache.nodeStartOffset,
            remainder: offset - cache.nodeStartOffset
        };
        let nodeStartOffset = 0;
        while(x !== (0, _rbTreeBaseJs.SENTINEL)){
            if (x.size_left > offset) x = x.left;
            else if (x.size_left + x.piece.length >= offset) {
                nodeStartOffset += x.size_left;
                const ret = {
                    node: x,
                    remainder: offset - x.size_left,
                    nodeStartOffset
                };
                this._searchCache.set(ret);
                return ret;
            } else {
                offset -= x.size_left + x.piece.length;
                nodeStartOffset += x.size_left + x.piece.length;
                x = x.right;
            }
        }
        return null;
    }
    nodeAt2(lineNumber, column) {
        let x = this.root;
        let nodeStartOffset = 0;
        while(x !== (0, _rbTreeBaseJs.SENTINEL)){
            if (x.left !== (0, _rbTreeBaseJs.SENTINEL) && x.lf_left >= lineNumber - 1) x = x.left;
            else if (x.lf_left + x.piece.lineFeedCnt > lineNumber - 1) {
                const prevAccumualtedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
                const accumulatedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 1);
                nodeStartOffset += x.size_left;
                return {
                    node: x,
                    remainder: Math.min(prevAccumualtedValue + column - 1, accumulatedValue),
                    nodeStartOffset
                };
            } else if (x.lf_left + x.piece.lineFeedCnt === lineNumber - 1) {
                const prevAccumualtedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
                if (prevAccumualtedValue + column - 1 <= x.piece.length) return {
                    node: x,
                    remainder: prevAccumualtedValue + column - 1,
                    nodeStartOffset
                };
                else {
                    column -= x.piece.length - prevAccumualtedValue;
                    break;
                }
            } else {
                lineNumber -= x.lf_left + x.piece.lineFeedCnt;
                nodeStartOffset += x.size_left + x.piece.length;
                x = x.right;
            }
        }
        // search in order, to find the node contains position.column
        x = x.next();
        while(x !== (0, _rbTreeBaseJs.SENTINEL)){
            if (x.piece.lineFeedCnt > 0) {
                const accumulatedValue = this.getAccumulatedValue(x, 0);
                const nodeStartOffset = this.offsetOfNode(x);
                return {
                    node: x,
                    remainder: Math.min(column - 1, accumulatedValue),
                    nodeStartOffset
                };
            } else if (x.piece.length >= column - 1) {
                const nodeStartOffset = this.offsetOfNode(x);
                return {
                    node: x,
                    remainder: column - 1,
                    nodeStartOffset
                };
            } else column -= x.piece.length;
            x = x.next();
        }
        return null;
    }
    nodeCharCodeAt(node, offset) {
        if (node.piece.lineFeedCnt < 1) return -1;
        const buffer = this._buffers[node.piece.bufferIndex];
        const newOffset = this.offsetInBuffer(node.piece.bufferIndex, node.piece.start) + offset;
        return buffer.buffer.charCodeAt(newOffset);
    }
    offsetOfNode(node) {
        if (!node) return 0;
        let pos = node.size_left;
        while(node !== this.root){
            if (node.parent.right === node) pos += node.parent.size_left + node.parent.piece.length;
            node = node.parent;
        }
        return pos;
    }
    // #endregion
    // #region CRLF
    shouldCheckCRLF() {
        return !(this._EOLNormalized && this._EOL === "\n");
    }
    startWithLF(val) {
        if (typeof val === "string") return val.charCodeAt(0) === 10;
        if (val === (0, _rbTreeBaseJs.SENTINEL) || val.piece.lineFeedCnt === 0) return false;
        const piece = val.piece;
        const lineStarts = this._buffers[piece.bufferIndex].lineStarts;
        const line = piece.start.line;
        const startOffset = lineStarts[line] + piece.start.column;
        if (line === lineStarts.length - 1) // last line, so there is no line feed at the end of this line
        return false;
        const nextLineOffset = lineStarts[line + 1];
        if (nextLineOffset > startOffset + 1) return false;
        return this._buffers[piece.bufferIndex].buffer.charCodeAt(startOffset) === 10;
    }
    endWithCR(val) {
        if (typeof val === "string") return val.charCodeAt(val.length - 1) === 13;
        if (val === (0, _rbTreeBaseJs.SENTINEL) || val.piece.lineFeedCnt === 0) return false;
        return this.nodeCharCodeAt(val, val.piece.length - 1) === 13;
    }
    validateCRLFWithPrevNode(nextNode) {
        if (this.shouldCheckCRLF() && this.startWithLF(nextNode)) {
            const node = nextNode.prev();
            if (this.endWithCR(node)) this.fixCRLF(node, nextNode);
        }
    }
    validateCRLFWithNextNode(node) {
        if (this.shouldCheckCRLF() && this.endWithCR(node)) {
            const nextNode = node.next();
            if (this.startWithLF(nextNode)) this.fixCRLF(node, nextNode);
        }
    }
    fixCRLF(prev, next) {
        const nodesToDel = [];
        // update node
        const lineStarts = this._buffers[prev.piece.bufferIndex].lineStarts;
        let newEnd;
        if (prev.piece.end.column === 0) // it means, last line ends with \r, not \r\n
        newEnd = {
            line: prev.piece.end.line - 1,
            column: lineStarts[prev.piece.end.line] - lineStarts[prev.piece.end.line - 1] - 1
        };
        else // \r\n
        newEnd = {
            line: prev.piece.end.line,
            column: prev.piece.end.column - 1
        };
        const prevNewLength = prev.piece.length - 1;
        const prevNewLFCnt = prev.piece.lineFeedCnt - 1;
        prev.piece = new Piece(prev.piece.bufferIndex, prev.piece.start, newEnd, prevNewLFCnt, prevNewLength);
        (0, _rbTreeBaseJs.updateTreeMetadata)(this, prev, -1, -1);
        if (prev.piece.length === 0) nodesToDel.push(prev);
        // update nextNode
        const newStart = {
            line: next.piece.start.line + 1,
            column: 0
        };
        const newLength = next.piece.length - 1;
        const newLineFeedCnt = this.getLineFeedCnt(next.piece.bufferIndex, newStart, next.piece.end);
        next.piece = new Piece(next.piece.bufferIndex, newStart, next.piece.end, newLineFeedCnt, newLength);
        (0, _rbTreeBaseJs.updateTreeMetadata)(this, next, -1, -1);
        if (next.piece.length === 0) nodesToDel.push(next);
        // create new piece which contains \r\n
        const pieces = this.createNewPieces("\r\n");
        this.rbInsertRight(prev, pieces[0]);
        // delete empty nodes
        for(let i = 0; i < nodesToDel.length; i++)(0, _rbTreeBaseJs.rbDelete)(this, nodesToDel[i]);
    }
    adjustCarriageReturnFromNext(value, node) {
        if (this.shouldCheckCRLF() && this.endWithCR(value)) {
            const nextNode = node.next();
            if (this.startWithLF(nextNode)) {
                // move `\n` forward
                value += "\n";
                if (nextNode.piece.length === 1) (0, _rbTreeBaseJs.rbDelete)(this, nextNode);
                else {
                    const piece = nextNode.piece;
                    const newStart = {
                        line: piece.start.line + 1,
                        column: 0
                    };
                    const newLength = piece.length - 1;
                    const newLineFeedCnt = this.getLineFeedCnt(piece.bufferIndex, newStart, piece.end);
                    nextNode.piece = new Piece(piece.bufferIndex, newStart, piece.end, newLineFeedCnt, newLength);
                    (0, _rbTreeBaseJs.updateTreeMetadata)(this, nextNode, -1, -1);
                }
                return true;
            }
        }
        return false;
    }
    // #endregion
    // #endregion
    // #region Tree operations
    iterate(node, callback) {
        if (node === (0, _rbTreeBaseJs.SENTINEL)) return callback((0, _rbTreeBaseJs.SENTINEL));
        const leftRet = this.iterate(node.left, callback);
        if (!leftRet) return leftRet;
        return callback(node) && this.iterate(node.right, callback);
    }
    getNodeContent(node) {
        if (node === (0, _rbTreeBaseJs.SENTINEL)) return "";
        const buffer = this._buffers[node.piece.bufferIndex];
        const piece = node.piece;
        const startOffset = this.offsetInBuffer(piece.bufferIndex, piece.start);
        const endOffset = this.offsetInBuffer(piece.bufferIndex, piece.end);
        const currentContent = buffer.buffer.substring(startOffset, endOffset);
        return currentContent;
    }
    getPieceContent(piece) {
        const buffer = this._buffers[piece.bufferIndex];
        const startOffset = this.offsetInBuffer(piece.bufferIndex, piece.start);
        const endOffset = this.offsetInBuffer(piece.bufferIndex, piece.end);
        const currentContent = buffer.buffer.substring(startOffset, endOffset);
        return currentContent;
    }
    /**
     *      node              node
     *     /  \              /  \
     *    a   b    <----   a    b
     *                         /
     *                        z
     */ rbInsertRight(node, p) {
        const z = new (0, _rbTreeBaseJs.TreeNode)(p, 1 /* NodeColor.Red */ );
        z.left = (0, _rbTreeBaseJs.SENTINEL);
        z.right = (0, _rbTreeBaseJs.SENTINEL);
        z.parent = (0, _rbTreeBaseJs.SENTINEL);
        z.size_left = 0;
        z.lf_left = 0;
        const x = this.root;
        if (x === (0, _rbTreeBaseJs.SENTINEL)) {
            this.root = z;
            z.color = 0 /* NodeColor.Black */ ;
        } else if (node.right === (0, _rbTreeBaseJs.SENTINEL)) {
            node.right = z;
            z.parent = node;
        } else {
            const nextNode = (0, _rbTreeBaseJs.leftest)(node.right);
            nextNode.left = z;
            z.parent = nextNode;
        }
        (0, _rbTreeBaseJs.fixInsert)(this, z);
        return z;
    }
    /**
     *      node              node
     *     /  \              /  \
     *    a   b     ---->   a    b
     *                       \
     *                        z
     */ rbInsertLeft(node, p) {
        const z = new (0, _rbTreeBaseJs.TreeNode)(p, 1 /* NodeColor.Red */ );
        z.left = (0, _rbTreeBaseJs.SENTINEL);
        z.right = (0, _rbTreeBaseJs.SENTINEL);
        z.parent = (0, _rbTreeBaseJs.SENTINEL);
        z.size_left = 0;
        z.lf_left = 0;
        if (this.root === (0, _rbTreeBaseJs.SENTINEL)) {
            this.root = z;
            z.color = 0 /* NodeColor.Black */ ;
        } else if (node.left === (0, _rbTreeBaseJs.SENTINEL)) {
            node.left = z;
            z.parent = node;
        } else {
            const prevNode = (0, _rbTreeBaseJs.righttest)(node.left); // a
            prevNode.right = z;
            z.parent = prevNode;
        }
        (0, _rbTreeBaseJs.fixInsert)(this, z);
        return z;
    }
}

},{"../../core/position.js":"lvrPe","../../core/range.js":"jmUPh","../../model.js":"1CSIB","./rbTreeBase.js":"cYiLt","../textModelSearch.js":"N1WkK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cYiLt":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TreeNode", ()=>TreeNode);
parcelHelpers.export(exports, "SENTINEL", ()=>SENTINEL);
parcelHelpers.export(exports, "leftest", ()=>leftest);
parcelHelpers.export(exports, "righttest", ()=>righttest);
parcelHelpers.export(exports, "leftRotate", ()=>leftRotate);
parcelHelpers.export(exports, "rightRotate", ()=>rightRotate);
parcelHelpers.export(exports, "rbDelete", ()=>rbDelete);
parcelHelpers.export(exports, "fixInsert", ()=>fixInsert);
parcelHelpers.export(exports, "updateTreeMetadata", ()=>updateTreeMetadata);
parcelHelpers.export(exports, "recomputeTreeMetadata", ()=>recomputeTreeMetadata);
class TreeNode {
    constructor(piece, color){
        this.piece = piece;
        this.color = color;
        this.size_left = 0;
        this.lf_left = 0;
        this.parent = this;
        this.left = this;
        this.right = this;
    }
    next() {
        if (this.right !== SENTINEL) return leftest(this.right);
        let node = this;
        while(node.parent !== SENTINEL){
            if (node.parent.left === node) break;
            node = node.parent;
        }
        if (node.parent === SENTINEL) return SENTINEL;
        else return node.parent;
    }
    prev() {
        if (this.left !== SENTINEL) return righttest(this.left);
        let node = this;
        while(node.parent !== SENTINEL){
            if (node.parent.right === node) break;
            node = node.parent;
        }
        if (node.parent === SENTINEL) return SENTINEL;
        else return node.parent;
    }
    detach() {
        this.parent = null;
        this.left = null;
        this.right = null;
    }
}
const SENTINEL = new TreeNode(null, 0 /* NodeColor.Black */ );
SENTINEL.parent = SENTINEL;
SENTINEL.left = SENTINEL;
SENTINEL.right = SENTINEL;
SENTINEL.color = 0 /* NodeColor.Black */ ;
function leftest(node) {
    while(node.left !== SENTINEL)node = node.left;
    return node;
}
function righttest(node) {
    while(node.right !== SENTINEL)node = node.right;
    return node;
}
function calculateSize(node) {
    if (node === SENTINEL) return 0;
    return node.size_left + node.piece.length + calculateSize(node.right);
}
function calculateLF(node) {
    if (node === SENTINEL) return 0;
    return node.lf_left + node.piece.lineFeedCnt + calculateLF(node.right);
}
function resetSentinel() {
    SENTINEL.parent = SENTINEL;
}
function leftRotate(tree, x) {
    const y = x.right;
    // fix size_left
    y.size_left += x.size_left + (x.piece ? x.piece.length : 0);
    y.lf_left += x.lf_left + (x.piece ? x.piece.lineFeedCnt : 0);
    x.right = y.left;
    if (y.left !== SENTINEL) y.left.parent = x;
    y.parent = x.parent;
    if (x.parent === SENTINEL) tree.root = y;
    else if (x.parent.left === x) x.parent.left = y;
    else x.parent.right = y;
    y.left = x;
    x.parent = y;
}
function rightRotate(tree, y) {
    const x = y.left;
    y.left = x.right;
    if (x.right !== SENTINEL) x.right.parent = y;
    x.parent = y.parent;
    // fix size_left
    y.size_left -= x.size_left + (x.piece ? x.piece.length : 0);
    y.lf_left -= x.lf_left + (x.piece ? x.piece.lineFeedCnt : 0);
    if (y.parent === SENTINEL) tree.root = x;
    else if (y === y.parent.right) y.parent.right = x;
    else y.parent.left = x;
    x.right = y;
    y.parent = x;
}
function rbDelete(tree, z) {
    let x;
    let y;
    if (z.left === SENTINEL) {
        y = z;
        x = y.right;
    } else if (z.right === SENTINEL) {
        y = z;
        x = y.left;
    } else {
        y = leftest(z.right);
        x = y.right;
    }
    if (y === tree.root) {
        tree.root = x;
        // if x is null, we are removing the only node
        x.color = 0 /* NodeColor.Black */ ;
        z.detach();
        resetSentinel();
        tree.root.parent = SENTINEL;
        return;
    }
    const yWasRed = y.color === 1 /* NodeColor.Red */ ;
    if (y === y.parent.left) y.parent.left = x;
    else y.parent.right = x;
    if (y === z) {
        x.parent = y.parent;
        recomputeTreeMetadata(tree, x);
    } else {
        if (y.parent === z) x.parent = y;
        else x.parent = y.parent;
        // as we make changes to x's hierarchy, update size_left of subtree first
        recomputeTreeMetadata(tree, x);
        y.left = z.left;
        y.right = z.right;
        y.parent = z.parent;
        y.color = z.color;
        if (z === tree.root) tree.root = y;
        else if (z === z.parent.left) z.parent.left = y;
        else z.parent.right = y;
        if (y.left !== SENTINEL) y.left.parent = y;
        if (y.right !== SENTINEL) y.right.parent = y;
        // update metadata
        // we replace z with y, so in this sub tree, the length change is z.item.length
        y.size_left = z.size_left;
        y.lf_left = z.lf_left;
        recomputeTreeMetadata(tree, y);
    }
    z.detach();
    if (x.parent.left === x) {
        const newSizeLeft = calculateSize(x);
        const newLFLeft = calculateLF(x);
        if (newSizeLeft !== x.parent.size_left || newLFLeft !== x.parent.lf_left) {
            const delta = newSizeLeft - x.parent.size_left;
            const lf_delta = newLFLeft - x.parent.lf_left;
            x.parent.size_left = newSizeLeft;
            x.parent.lf_left = newLFLeft;
            updateTreeMetadata(tree, x.parent, delta, lf_delta);
        }
    }
    recomputeTreeMetadata(tree, x.parent);
    if (yWasRed) {
        resetSentinel();
        return;
    }
    // RB-DELETE-FIXUP
    let w;
    while(x !== tree.root && x.color === 0 /* NodeColor.Black */ )if (x === x.parent.left) {
        w = x.parent.right;
        if (w.color === 1 /* NodeColor.Red */ ) {
            w.color = 0 /* NodeColor.Black */ ;
            x.parent.color = 1 /* NodeColor.Red */ ;
            leftRotate(tree, x.parent);
            w = x.parent.right;
        }
        if (w.left.color === 0 /* NodeColor.Black */  && w.right.color === 0 /* NodeColor.Black */ ) {
            w.color = 1 /* NodeColor.Red */ ;
            x = x.parent;
        } else {
            if (w.right.color === 0 /* NodeColor.Black */ ) {
                w.left.color = 0 /* NodeColor.Black */ ;
                w.color = 1 /* NodeColor.Red */ ;
                rightRotate(tree, w);
                w = x.parent.right;
            }
            w.color = x.parent.color;
            x.parent.color = 0 /* NodeColor.Black */ ;
            w.right.color = 0 /* NodeColor.Black */ ;
            leftRotate(tree, x.parent);
            x = tree.root;
        }
    } else {
        w = x.parent.left;
        if (w.color === 1 /* NodeColor.Red */ ) {
            w.color = 0 /* NodeColor.Black */ ;
            x.parent.color = 1 /* NodeColor.Red */ ;
            rightRotate(tree, x.parent);
            w = x.parent.left;
        }
        if (w.left.color === 0 /* NodeColor.Black */  && w.right.color === 0 /* NodeColor.Black */ ) {
            w.color = 1 /* NodeColor.Red */ ;
            x = x.parent;
        } else {
            if (w.left.color === 0 /* NodeColor.Black */ ) {
                w.right.color = 0 /* NodeColor.Black */ ;
                w.color = 1 /* NodeColor.Red */ ;
                leftRotate(tree, w);
                w = x.parent.left;
            }
            w.color = x.parent.color;
            x.parent.color = 0 /* NodeColor.Black */ ;
            w.left.color = 0 /* NodeColor.Black */ ;
            rightRotate(tree, x.parent);
            x = tree.root;
        }
    }
    x.color = 0 /* NodeColor.Black */ ;
    resetSentinel();
}
function fixInsert(tree, x) {
    recomputeTreeMetadata(tree, x);
    while(x !== tree.root && x.parent.color === 1 /* NodeColor.Red */ )if (x.parent === x.parent.parent.left) {
        const y = x.parent.parent.right;
        if (y.color === 1 /* NodeColor.Red */ ) {
            x.parent.color = 0 /* NodeColor.Black */ ;
            y.color = 0 /* NodeColor.Black */ ;
            x.parent.parent.color = 1 /* NodeColor.Red */ ;
            x = x.parent.parent;
        } else {
            if (x === x.parent.right) {
                x = x.parent;
                leftRotate(tree, x);
            }
            x.parent.color = 0 /* NodeColor.Black */ ;
            x.parent.parent.color = 1 /* NodeColor.Red */ ;
            rightRotate(tree, x.parent.parent);
        }
    } else {
        const y = x.parent.parent.left;
        if (y.color === 1 /* NodeColor.Red */ ) {
            x.parent.color = 0 /* NodeColor.Black */ ;
            y.color = 0 /* NodeColor.Black */ ;
            x.parent.parent.color = 1 /* NodeColor.Red */ ;
            x = x.parent.parent;
        } else {
            if (x === x.parent.left) {
                x = x.parent;
                rightRotate(tree, x);
            }
            x.parent.color = 0 /* NodeColor.Black */ ;
            x.parent.parent.color = 1 /* NodeColor.Red */ ;
            leftRotate(tree, x.parent.parent);
        }
    }
    tree.root.color = 0 /* NodeColor.Black */ ;
}
function updateTreeMetadata(tree, x, delta, lineFeedCntDelta) {
    // node length change or line feed count change
    while(x !== tree.root && x !== SENTINEL){
        if (x.parent.left === x) {
            x.parent.size_left += delta;
            x.parent.lf_left += lineFeedCntDelta;
        }
        x = x.parent;
    }
}
function recomputeTreeMetadata(tree, x) {
    let delta = 0;
    let lf_delta = 0;
    if (x === tree.root) return;
    // go upwards till the node whose left subtree is changed.
    while(x !== tree.root && x === x.parent.right)x = x.parent;
    if (x === tree.root) // well, it means we add a node to the end (inorder)
    return;
    // x is the node whose right subtree is changed.
    x = x.parent;
    delta = calculateSize(x.left) - x.size_left;
    lf_delta = calculateLF(x.left) - x.lf_left;
    x.size_left += delta;
    x.lf_left += lf_delta;
    // go upwards till root. O(logN)
    while(x !== tree.root && (delta !== 0 || lf_delta !== 0)){
        if (x.parent.left === x) {
            x.parent.size_left += delta;
            x.parent.lf_left += lf_delta;
        }
        x = x.parent;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2qgIn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PieceTreeTextBufferBuilder", ()=>PieceTreeTextBufferBuilder);
var _stringsJs = require("../../../../base/common/strings.js");
var _pieceTreeBaseJs = require("./pieceTreeBase.js");
var _pieceTreeTextBufferJs = require("./pieceTreeTextBuffer.js");
class PieceTreeTextBufferFactory {
    constructor(_chunks, _bom, _cr, _lf, _crlf, _containsRTL, _containsUnusualLineTerminators, _isBasicASCII, _normalizeEOL){
        this._chunks = _chunks;
        this._bom = _bom;
        this._cr = _cr;
        this._lf = _lf;
        this._crlf = _crlf;
        this._containsRTL = _containsRTL;
        this._containsUnusualLineTerminators = _containsUnusualLineTerminators;
        this._isBasicASCII = _isBasicASCII;
        this._normalizeEOL = _normalizeEOL;
    }
    _getEOL(defaultEOL) {
        const totalEOLCount = this._cr + this._lf + this._crlf;
        const totalCRCount = this._cr + this._crlf;
        if (totalEOLCount === 0) // This is an empty file or a file with precisely one line
        return defaultEOL === 1 /* DefaultEndOfLine.LF */  ? "\n" : "\r\n";
        if (totalCRCount > totalEOLCount / 2) // More than half of the file contains \r\n ending lines
        return "\r\n";
        // At least one line more ends in \n
        return "\n";
    }
    create(defaultEOL) {
        const eol = this._getEOL(defaultEOL);
        const chunks = this._chunks;
        if (this._normalizeEOL && (eol === "\r\n" && (this._cr > 0 || this._lf > 0) || eol === "\n" && (this._cr > 0 || this._crlf > 0))) // Normalize pieces
        for(let i = 0, len = chunks.length; i < len; i++){
            const str = chunks[i].buffer.replace(/\r\n|\r|\n/g, eol);
            const newLineStart = (0, _pieceTreeBaseJs.createLineStartsFast)(str);
            chunks[i] = new (0, _pieceTreeBaseJs.StringBuffer)(str, newLineStart);
        }
        const textBuffer = new (0, _pieceTreeTextBufferJs.PieceTreeTextBuffer)(chunks, this._bom, eol, this._containsRTL, this._containsUnusualLineTerminators, this._isBasicASCII, this._normalizeEOL);
        return {
            textBuffer: textBuffer,
            disposable: textBuffer
        };
    }
}
class PieceTreeTextBufferBuilder {
    constructor(){
        this.chunks = [];
        this.BOM = "";
        this._hasPreviousChar = false;
        this._previousChar = 0;
        this._tmpLineStarts = [];
        this.cr = 0;
        this.lf = 0;
        this.crlf = 0;
        this.containsRTL = false;
        this.containsUnusualLineTerminators = false;
        this.isBasicASCII = true;
    }
    acceptChunk(chunk) {
        if (chunk.length === 0) return;
        if (this.chunks.length === 0) {
            if (_stringsJs.startsWithUTF8BOM(chunk)) {
                this.BOM = _stringsJs.UTF8_BOM_CHARACTER;
                chunk = chunk.substr(1);
            }
        }
        const lastChar = chunk.charCodeAt(chunk.length - 1);
        if (lastChar === 13 /* CharCode.CarriageReturn */  || lastChar >= 0xD800 && lastChar <= 0xDBFF) {
            // last character is \r or a high surrogate => keep it back
            this._acceptChunk1(chunk.substr(0, chunk.length - 1), false);
            this._hasPreviousChar = true;
            this._previousChar = lastChar;
        } else {
            this._acceptChunk1(chunk, false);
            this._hasPreviousChar = false;
            this._previousChar = lastChar;
        }
    }
    _acceptChunk1(chunk, allowEmptyStrings) {
        if (!allowEmptyStrings && chunk.length === 0) // Nothing to do
        return;
        if (this._hasPreviousChar) this._acceptChunk2(String.fromCharCode(this._previousChar) + chunk);
        else this._acceptChunk2(chunk);
    }
    _acceptChunk2(chunk) {
        const lineStarts = (0, _pieceTreeBaseJs.createLineStarts)(this._tmpLineStarts, chunk);
        this.chunks.push(new (0, _pieceTreeBaseJs.StringBuffer)(chunk, lineStarts.lineStarts));
        this.cr += lineStarts.cr;
        this.lf += lineStarts.lf;
        this.crlf += lineStarts.crlf;
        if (!lineStarts.isBasicASCII) {
            // this chunk contains non basic ASCII characters
            this.isBasicASCII = false;
            if (!this.containsRTL) this.containsRTL = _stringsJs.containsRTL(chunk);
            if (!this.containsUnusualLineTerminators) this.containsUnusualLineTerminators = _stringsJs.containsUnusualLineTerminators(chunk);
        }
    }
    finish(normalizeEOL = true) {
        this._finish();
        return new PieceTreeTextBufferFactory(this.chunks, this.BOM, this.cr, this.lf, this.crlf, this.containsRTL, this.containsUnusualLineTerminators, this.isBasicASCII, normalizeEOL);
    }
    _finish() {
        if (this.chunks.length === 0) this._acceptChunk1("", true);
        if (this._hasPreviousChar) {
            this._hasPreviousChar = false;
            // recreate last chunk
            const lastChunk = this.chunks[this.chunks.length - 1];
            lastChunk.buffer += String.fromCharCode(this._previousChar);
            const newLineStarts = (0, _pieceTreeBaseJs.createLineStartsFast)(lastChunk.buffer);
            lastChunk.lineStarts = newLineStarts;
            if (this._previousChar === 13 /* CharCode.CarriageReturn */ ) this.cr++;
        }
    }
}

},{"../../../../base/common/strings.js":"aA9I1","./pieceTreeBase.js":"e8MbF","./pieceTreeTextBuffer.js":"fhukT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j42xY":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenizationTextModelPart", ()=>TokenizationTextModelPart);
var _errorsJs = require("../../../base/common/errors.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _eolCounterJs = require("../core/eolCounter.js");
var _lineRangeJs = require("../core/lineRange.js");
var _positionJs = require("../core/position.js");
var _wordHelperJs = require("../core/wordHelper.js");
var _languagesJs = require("../languages.js");
var _languageJs = require("../languages/language.js");
var _languageConfigurationRegistryJs = require("../languages/languageConfigurationRegistry.js");
var _textModelPartJs = require("./textModelPart.js");
var _textModelTokensJs = require("./textModelTokens.js");
var _tokensJs = require("./tokens.js");
var _treeSitterTokensJs = require("./treeSitterTokens.js");
var _treeSitterParserServiceJs = require("../services/treeSitterParserService.js");
var _contiguousMultilineTokensBuilderJs = require("../tokens/contiguousMultilineTokensBuilder.js");
var _contiguousTokensStoreJs = require("../tokens/contiguousTokensStore.js");
var _sparseTokensStoreJs = require("../tokens/sparseTokensStore.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var TokenizationTextModelPart_1;
let TokenizationTextModelPart = TokenizationTextModelPart_1 = class TokenizationTextModelPart extends (0, _textModelPartJs.TextModelPart) {
    constructor(_textModel, _bracketPairsTextModelPart, _languageId, _attachedViews, _languageService, _languageConfigurationService, _treeSitterService){
        super();
        this._textModel = _textModel;
        this._bracketPairsTextModelPart = _bracketPairsTextModelPart;
        this._languageId = _languageId;
        this._attachedViews = _attachedViews;
        this._languageService = _languageService;
        this._languageConfigurationService = _languageConfigurationService;
        this._treeSitterService = _treeSitterService;
        this._semanticTokens = new (0, _sparseTokensStoreJs.SparseTokensStore)(this._languageService.languageIdCodec);
        this._onDidChangeLanguage = this._register(new (0, _eventJs.Emitter)());
        this.onDidChangeLanguage = this._onDidChangeLanguage.event;
        this._onDidChangeLanguageConfiguration = this._register(new (0, _eventJs.Emitter)());
        this.onDidChangeLanguageConfiguration = this._onDidChangeLanguageConfiguration.event;
        this._onDidChangeTokens = this._register(new (0, _eventJs.Emitter)());
        this.onDidChangeTokens = this._onDidChangeTokens.event;
        this._tokensDisposables = this._register(new (0, _lifecycleJs.DisposableStore)());
        this._register(this._languageConfigurationService.onDidChange((e)=>{
            if (e.affects(this._languageId)) this._onDidChangeLanguageConfiguration.fire({});
        }));
        // We just look at registry changes to determine whether to use tree sitter.
        // This means that removing a language from the setting will not cause a switch to textmate and will require a reload.
        // Adding a language to the setting will not need a reload, however.
        this._register((0, _eventJs.Event).filter((0, _languagesJs.TreeSitterTokenizationRegistry).onDidChange, (e)=>e.changedLanguages.includes(this._languageId))(()=>{
            this.createPreferredTokenProvider();
        }));
        this.createPreferredTokenProvider();
    }
    createGrammarTokens() {
        return this._register(new GrammarTokens(this._languageService.languageIdCodec, this._textModel, ()=>this._languageId, this._attachedViews));
    }
    createTreeSitterTokens() {
        return this._register(new (0, _treeSitterTokensJs.TreeSitterTokens)(this._treeSitterService, this._languageService.languageIdCodec, this._textModel, ()=>this._languageId));
    }
    createTokens(useTreeSitter) {
        const needsReset = this._tokens !== undefined;
        this._tokens?.dispose();
        this._tokens = useTreeSitter ? this.createTreeSitterTokens() : this.createGrammarTokens();
        this._tokensDisposables.clear();
        this._tokensDisposables.add(this._tokens.onDidChangeTokens((e)=>{
            this._emitModelTokensChangedEvent(e);
        }));
        this._tokensDisposables.add(this._tokens.onDidChangeBackgroundTokenizationState((e)=>{
            this._bracketPairsTextModelPart.handleDidChangeBackgroundTokenizationState();
        }));
        if (needsReset) // We need to reset the tokenization, as the new token provider otherwise won't have a chance to provide tokens until some action happens in the editor.
        this._tokens.resetTokenization();
    }
    createPreferredTokenProvider() {
        if ((0, _languagesJs.TreeSitterTokenizationRegistry).get(this._languageId)) {
            if (!(this._tokens instanceof (0, _treeSitterTokensJs.TreeSitterTokens))) this.createTokens(true);
        } else if (!(this._tokens instanceof GrammarTokens)) this.createTokens(false);
    }
    handleLanguageConfigurationServiceChange(e) {
        if (e.affects(this._languageId)) this._onDidChangeLanguageConfiguration.fire({});
    }
    handleDidChangeContent(e) {
        if (e.isFlush) this._semanticTokens.flush();
        else if (!e.isEolChange) for (const c of e.changes){
            const [eolCount, firstLineLength, lastLineLength] = (0, _eolCounterJs.countEOL)(c.text);
            this._semanticTokens.acceptEdit(c.range, eolCount, firstLineLength, lastLineLength, c.text.length > 0 ? c.text.charCodeAt(0) : 0 /* CharCode.Null */ );
        }
        this._tokens.handleDidChangeContent(e);
    }
    handleDidChangeAttached() {
        this._tokens.handleDidChangeAttached();
    }
    /**
     * Includes grammar and semantic tokens.
     */ getLineTokens(lineNumber) {
        this.validateLineNumber(lineNumber);
        const syntacticTokens = this._tokens.getLineTokens(lineNumber);
        return this._semanticTokens.addSparseTokens(lineNumber, syntacticTokens);
    }
    _emitModelTokensChangedEvent(e) {
        if (!this._textModel._isDisposing()) {
            this._bracketPairsTextModelPart.handleDidChangeTokens(e);
            this._onDidChangeTokens.fire(e);
        }
    }
    // #region Grammar Tokens
    validateLineNumber(lineNumber) {
        if (lineNumber < 1 || lineNumber > this._textModel.getLineCount()) throw new (0, _errorsJs.BugIndicatingError)("Illegal value for lineNumber");
    }
    get hasTokens() {
        return this._tokens.hasTokens;
    }
    resetTokenization() {
        this._tokens.resetTokenization();
    }
    get backgroundTokenizationState() {
        return this._tokens.backgroundTokenizationState;
    }
    forceTokenization(lineNumber) {
        this.validateLineNumber(lineNumber);
        this._tokens.forceTokenization(lineNumber);
    }
    hasAccurateTokensForLine(lineNumber) {
        this.validateLineNumber(lineNumber);
        return this._tokens.hasAccurateTokensForLine(lineNumber);
    }
    isCheapToTokenize(lineNumber) {
        this.validateLineNumber(lineNumber);
        return this._tokens.isCheapToTokenize(lineNumber);
    }
    tokenizeIfCheap(lineNumber) {
        this.validateLineNumber(lineNumber);
        this._tokens.tokenizeIfCheap(lineNumber);
    }
    getTokenTypeIfInsertingCharacter(lineNumber, column, character) {
        return this._tokens.getTokenTypeIfInsertingCharacter(lineNumber, column, character);
    }
    tokenizeLineWithEdit(position, length, newText) {
        return this._tokens.tokenizeLineWithEdit(position, length, newText);
    }
    // #endregion
    // #region Semantic Tokens
    setSemanticTokens(tokens, isComplete) {
        this._semanticTokens.set(tokens, isComplete);
        this._emitModelTokensChangedEvent({
            semanticTokensApplied: tokens !== null,
            ranges: [
                {
                    fromLineNumber: 1,
                    toLineNumber: this._textModel.getLineCount()
                }
            ]
        });
    }
    hasCompleteSemanticTokens() {
        return this._semanticTokens.isComplete();
    }
    hasSomeSemanticTokens() {
        return !this._semanticTokens.isEmpty();
    }
    setPartialSemanticTokens(range, tokens) {
        if (this.hasCompleteSemanticTokens()) return;
        const changedRange = this._textModel.validateRange(this._semanticTokens.setPartial(range, tokens));
        this._emitModelTokensChangedEvent({
            semanticTokensApplied: true,
            ranges: [
                {
                    fromLineNumber: changedRange.startLineNumber,
                    toLineNumber: changedRange.endLineNumber
                }
            ]
        });
    }
    // #endregion
    // #region Utility Methods
    getWordAtPosition(_position) {
        this.assertNotDisposed();
        const position = this._textModel.validatePosition(_position);
        const lineContent = this._textModel.getLineContent(position.lineNumber);
        const lineTokens = this.getLineTokens(position.lineNumber);
        const tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
        // (1). First try checking right biased word
        const [rbStartOffset, rbEndOffset] = TokenizationTextModelPart_1._findLanguageBoundaries(lineTokens, tokenIndex);
        const rightBiasedWord = (0, _wordHelperJs.getWordAtText)(position.column, this.getLanguageConfiguration(lineTokens.getLanguageId(tokenIndex)).getWordDefinition(), lineContent.substring(rbStartOffset, rbEndOffset), rbStartOffset);
        // Make sure the result touches the original passed in position
        if (rightBiasedWord && rightBiasedWord.startColumn <= _position.column && _position.column <= rightBiasedWord.endColumn) return rightBiasedWord;
        // (2). Else, if we were at a language boundary, check the left biased word
        if (tokenIndex > 0 && rbStartOffset === position.column - 1) {
            // edge case, where `position` sits between two tokens belonging to two different languages
            const [lbStartOffset, lbEndOffset] = TokenizationTextModelPart_1._findLanguageBoundaries(lineTokens, tokenIndex - 1);
            const leftBiasedWord = (0, _wordHelperJs.getWordAtText)(position.column, this.getLanguageConfiguration(lineTokens.getLanguageId(tokenIndex - 1)).getWordDefinition(), lineContent.substring(lbStartOffset, lbEndOffset), lbStartOffset);
            // Make sure the result touches the original passed in position
            if (leftBiasedWord && leftBiasedWord.startColumn <= _position.column && _position.column <= leftBiasedWord.endColumn) return leftBiasedWord;
        }
        return null;
    }
    getLanguageConfiguration(languageId) {
        return this._languageConfigurationService.getLanguageConfiguration(languageId);
    }
    static _findLanguageBoundaries(lineTokens, tokenIndex) {
        const languageId = lineTokens.getLanguageId(tokenIndex);
        // go left until a different language is hit
        let startOffset = 0;
        for(let i = tokenIndex; i >= 0 && lineTokens.getLanguageId(i) === languageId; i--)startOffset = lineTokens.getStartOffset(i);
        // go right until a different language is hit
        let endOffset = lineTokens.getLineContent().length;
        for(let i = tokenIndex, tokenCount = lineTokens.getCount(); i < tokenCount && lineTokens.getLanguageId(i) === languageId; i++)endOffset = lineTokens.getEndOffset(i);
        return [
            startOffset,
            endOffset
        ];
    }
    getWordUntilPosition(position) {
        const wordAtPosition = this.getWordAtPosition(position);
        if (!wordAtPosition) return {
            word: "",
            startColumn: position.column,
            endColumn: position.column
        };
        return {
            word: wordAtPosition.word.substr(0, position.column - wordAtPosition.startColumn),
            startColumn: wordAtPosition.startColumn,
            endColumn: position.column
        };
    }
    // #endregion
    // #region Language Id handling
    getLanguageId() {
        return this._languageId;
    }
    getLanguageIdAtPosition(lineNumber, column) {
        const position = this._textModel.validatePosition(new (0, _positionJs.Position)(lineNumber, column));
        const lineTokens = this.getLineTokens(position.lineNumber);
        return lineTokens.getLanguageId(lineTokens.findTokenIndexAtOffset(position.column - 1));
    }
    setLanguageId(languageId, source = "api") {
        if (this._languageId === languageId) // There's nothing to do
        return;
        const e = {
            oldLanguage: this._languageId,
            newLanguage: languageId,
            source
        };
        this._languageId = languageId;
        this._bracketPairsTextModelPart.handleDidChangeLanguage(e);
        this._tokens.resetTokenization();
        this.createPreferredTokenProvider();
        this._onDidChangeLanguage.fire(e);
        this._onDidChangeLanguageConfiguration.fire({});
    }
};
TokenizationTextModelPart = TokenizationTextModelPart_1 = __decorate([
    __param(4, (0, _languageJs.ILanguageService)),
    __param(5, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService)),
    __param(6, (0, _treeSitterParserServiceJs.ITreeSitterParserService))
], TokenizationTextModelPart);
class GrammarTokens extends (0, _tokensJs.AbstractTokens) {
    constructor(languageIdCodec, textModel, getLanguageId, attachedViews){
        super(languageIdCodec, textModel, getLanguageId);
        this._tokenizer = null;
        this._defaultBackgroundTokenizer = null;
        this._backgroundTokenizer = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this._tokens = new (0, _contiguousTokensStoreJs.ContiguousTokensStore)(this._languageIdCodec);
        this._debugBackgroundTokenizer = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this._attachedViewStates = this._register(new (0, _lifecycleJs.DisposableMap)());
        this._register((0, _languagesJs.TokenizationRegistry).onDidChange((e)=>{
            const languageId = this.getLanguageId();
            if (e.changedLanguages.indexOf(languageId) === -1) return;
            this.resetTokenization();
        }));
        this.resetTokenization();
        this._register(attachedViews.onDidChangeVisibleRanges(({ view, state })=>{
            if (state) {
                let existing = this._attachedViewStates.get(view);
                if (!existing) {
                    existing = new (0, _tokensJs.AttachedViewHandler)(()=>this.refreshRanges(existing.lineRanges));
                    this._attachedViewStates.set(view, existing);
                }
                existing.handleStateChange(state);
            } else this._attachedViewStates.deleteAndDispose(view);
        }));
    }
    resetTokenization(fireTokenChangeEvent = true) {
        this._tokens.flush();
        this._debugBackgroundTokens?.flush();
        if (this._debugBackgroundStates) this._debugBackgroundStates = new (0, _textModelTokensJs.TrackingTokenizationStateStore)(this._textModel.getLineCount());
        if (fireTokenChangeEvent) this._onDidChangeTokens.fire({
            semanticTokensApplied: false,
            ranges: [
                {
                    fromLineNumber: 1,
                    toLineNumber: this._textModel.getLineCount()
                }
            ]
        });
        const initializeTokenization = ()=>{
            if (this._textModel.isTooLargeForTokenization()) return [
                null,
                null
            ];
            const tokenizationSupport = (0, _languagesJs.TokenizationRegistry).get(this.getLanguageId());
            if (!tokenizationSupport) return [
                null,
                null
            ];
            let initialState;
            try {
                initialState = tokenizationSupport.getInitialState();
            } catch (e) {
                (0, _errorsJs.onUnexpectedError)(e);
                return [
                    null,
                    null
                ];
            }
            return [
                tokenizationSupport,
                initialState
            ];
        };
        const [tokenizationSupport, initialState] = initializeTokenization();
        if (tokenizationSupport && initialState) this._tokenizer = new (0, _textModelTokensJs.TokenizerWithStateStoreAndTextModel)(this._textModel.getLineCount(), tokenizationSupport, this._textModel, this._languageIdCodec);
        else this._tokenizer = null;
        this._backgroundTokenizer.clear();
        this._defaultBackgroundTokenizer = null;
        if (this._tokenizer) {
            const b = {
                setTokens: (tokens)=>{
                    this.setTokens(tokens);
                },
                backgroundTokenizationFinished: ()=>{
                    if (this._backgroundTokenizationState === 2 /* BackgroundTokenizationState.Completed */ ) // We already did a full tokenization and don't go back to progressing.
                    return;
                    const newState = 2 /* BackgroundTokenizationState.Completed */ ;
                    this._backgroundTokenizationState = newState;
                    this._onDidChangeBackgroundTokenizationState.fire();
                },
                setEndState: (lineNumber, state)=>{
                    if (!this._tokenizer) return;
                    const firstInvalidEndStateLineNumber = this._tokenizer.store.getFirstInvalidEndStateLineNumber();
                    // Don't accept states for definitely valid states, the renderer is ahead of the worker!
                    if (firstInvalidEndStateLineNumber !== null && lineNumber >= firstInvalidEndStateLineNumber) this._tokenizer?.store.setEndState(lineNumber, state);
                }
            };
            if (tokenizationSupport && tokenizationSupport.createBackgroundTokenizer && !tokenizationSupport.backgroundTokenizerShouldOnlyVerifyTokens) this._backgroundTokenizer.value = tokenizationSupport.createBackgroundTokenizer(this._textModel, b);
            if (!this._backgroundTokenizer.value && !this._textModel.isTooLargeForTokenization()) {
                this._backgroundTokenizer.value = this._defaultBackgroundTokenizer = new (0, _textModelTokensJs.DefaultBackgroundTokenizer)(this._tokenizer, b);
                this._defaultBackgroundTokenizer.handleChanges();
            }
            if (tokenizationSupport?.backgroundTokenizerShouldOnlyVerifyTokens && tokenizationSupport.createBackgroundTokenizer) {
                this._debugBackgroundTokens = new (0, _contiguousTokensStoreJs.ContiguousTokensStore)(this._languageIdCodec);
                this._debugBackgroundStates = new (0, _textModelTokensJs.TrackingTokenizationStateStore)(this._textModel.getLineCount());
                this._debugBackgroundTokenizer.clear();
                this._debugBackgroundTokenizer.value = tokenizationSupport.createBackgroundTokenizer(this._textModel, {
                    setTokens: (tokens)=>{
                        this._debugBackgroundTokens?.setMultilineTokens(tokens, this._textModel);
                    },
                    backgroundTokenizationFinished () {
                    // NO OP
                    },
                    setEndState: (lineNumber, state)=>{
                        this._debugBackgroundStates?.setEndState(lineNumber, state);
                    }
                });
            } else {
                this._debugBackgroundTokens = undefined;
                this._debugBackgroundStates = undefined;
                this._debugBackgroundTokenizer.value = undefined;
            }
        }
        this.refreshAllVisibleLineTokens();
    }
    handleDidChangeAttached() {
        this._defaultBackgroundTokenizer?.handleChanges();
    }
    handleDidChangeContent(e) {
        if (e.isFlush) // Don't fire the event, as the view might not have got the text change event yet
        this.resetTokenization(false);
        else if (!e.isEolChange) {
            for (const c of e.changes){
                const [eolCount, firstLineLength] = (0, _eolCounterJs.countEOL)(c.text);
                this._tokens.acceptEdit(c.range, eolCount, firstLineLength);
                this._debugBackgroundTokens?.acceptEdit(c.range, eolCount, firstLineLength);
            }
            this._debugBackgroundStates?.acceptChanges(e.changes);
            if (this._tokenizer) this._tokenizer.store.acceptChanges(e.changes);
            this._defaultBackgroundTokenizer?.handleChanges();
        }
    }
    setTokens(tokens) {
        const { changes } = this._tokens.setMultilineTokens(tokens, this._textModel);
        if (changes.length > 0) this._onDidChangeTokens.fire({
            semanticTokensApplied: false,
            ranges: changes
        });
        return {
            changes: changes
        };
    }
    refreshAllVisibleLineTokens() {
        const ranges = (0, _lineRangeJs.LineRange).joinMany([
            ...this._attachedViewStates
        ].map(([_, s])=>s.lineRanges));
        this.refreshRanges(ranges);
    }
    refreshRanges(ranges) {
        for (const range of ranges)this.refreshRange(range.startLineNumber, range.endLineNumberExclusive - 1);
    }
    refreshRange(startLineNumber, endLineNumber) {
        if (!this._tokenizer) return;
        startLineNumber = Math.max(1, Math.min(this._textModel.getLineCount(), startLineNumber));
        endLineNumber = Math.min(this._textModel.getLineCount(), endLineNumber);
        const builder = new (0, _contiguousMultilineTokensBuilderJs.ContiguousMultilineTokensBuilder)();
        const { heuristicTokens } = this._tokenizer.tokenizeHeuristically(builder, startLineNumber, endLineNumber);
        const changedTokens = this.setTokens(builder.finalize());
        if (heuristicTokens) // We overrode tokens with heuristically computed ones.
        // Because old states might get reused (thus stopping invalidation),
        // we have to explicitly request the tokens for the changed ranges again.
        for (const c of changedTokens.changes)this._backgroundTokenizer.value?.requestTokens(c.fromLineNumber, c.toLineNumber + 1);
        this._defaultBackgroundTokenizer?.checkFinished();
    }
    forceTokenization(lineNumber) {
        const builder = new (0, _contiguousMultilineTokensBuilderJs.ContiguousMultilineTokensBuilder)();
        this._tokenizer?.updateTokensUntilLine(builder, lineNumber);
        this.setTokens(builder.finalize());
        this._defaultBackgroundTokenizer?.checkFinished();
    }
    hasAccurateTokensForLine(lineNumber) {
        if (!this._tokenizer) return true;
        return this._tokenizer.hasAccurateTokensForLine(lineNumber);
    }
    isCheapToTokenize(lineNumber) {
        if (!this._tokenizer) return true;
        return this._tokenizer.isCheapToTokenize(lineNumber);
    }
    getLineTokens(lineNumber) {
        const lineText = this._textModel.getLineContent(lineNumber);
        const result = this._tokens.getTokens(this._textModel.getLanguageId(), lineNumber - 1, lineText);
        if (this._debugBackgroundTokens && this._debugBackgroundStates && this._tokenizer) {
            if (this._debugBackgroundStates.getFirstInvalidEndStateLineNumberOrMax() > lineNumber && this._tokenizer.store.getFirstInvalidEndStateLineNumberOrMax() > lineNumber) {
                const backgroundResult = this._debugBackgroundTokens.getTokens(this._textModel.getLanguageId(), lineNumber - 1, lineText);
                if (!result.equals(backgroundResult) && this._debugBackgroundTokenizer.value?.reportMismatchingTokens) this._debugBackgroundTokenizer.value.reportMismatchingTokens(lineNumber);
            }
        }
        return result;
    }
    getTokenTypeIfInsertingCharacter(lineNumber, column, character) {
        if (!this._tokenizer) return 0 /* StandardTokenType.Other */ ;
        const position = this._textModel.validatePosition(new (0, _positionJs.Position)(lineNumber, column));
        this.forceTokenization(position.lineNumber);
        return this._tokenizer.getTokenTypeIfInsertingCharacter(position, character);
    }
    tokenizeLineWithEdit(position, length, newText) {
        if (!this._tokenizer) return null;
        const validatedPosition = this._textModel.validatePosition(position);
        this.forceTokenization(validatedPosition.lineNumber);
        return this._tokenizer.tokenizeLineWithEdit(validatedPosition, length, newText);
    }
    get hasTokens() {
        return this._tokens.hasTokens;
    }
}

},{"../../../base/common/errors.js":"divX8","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../core/eolCounter.js":"4i42Y","../core/lineRange.js":"cmnMs","../core/position.js":"lvrPe","../core/wordHelper.js":"9FjxX","../languages.js":"g5n96","../languages/language.js":"ka2JQ","../languages/languageConfigurationRegistry.js":"2Lk9v","./textModelPart.js":"aVeVR","./textModelTokens.js":"511en","./tokens.js":"gi3Tb","./treeSitterTokens.js":"bP62x","../services/treeSitterParserService.js":"bi0Mc","../tokens/contiguousMultilineTokensBuilder.js":"4SfGD","../tokens/contiguousTokensStore.js":"wxC8l","../tokens/sparseTokensStore.js":"2XNAL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"511en":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenizerWithStateStore", ()=>TokenizerWithStateStore);
parcelHelpers.export(exports, "TokenizerWithStateStoreAndTextModel", ()=>TokenizerWithStateStoreAndTextModel);
/**
 * **Invariant:**
 * If the text model is retokenized from line 1 to {@link getFirstInvalidEndStateLineNumber}() - 1,
 * then the recomputed end state for line l will be equal to {@link getEndState}(l).
 */ parcelHelpers.export(exports, "TrackingTokenizationStateStore", ()=>TrackingTokenizationStateStore);
parcelHelpers.export(exports, "TokenizationStateStore", ()=>TokenizationStateStore);
parcelHelpers.export(exports, "RangePriorityQueueImpl", ()=>RangePriorityQueueImpl);
parcelHelpers.export(exports, "DefaultBackgroundTokenizer", ()=>DefaultBackgroundTokenizer);
var _asyncJs = require("../../../base/common/async.js");
var _errorsJs = require("../../../base/common/errors.js");
var _platformJs = require("../../../base/common/platform.js");
var _stopwatchJs = require("../../../base/common/stopwatch.js");
var _eolCounterJs = require("../core/eolCounter.js");
var _lineRangeJs = require("../core/lineRange.js");
var _offsetRangeJs = require("../core/offsetRange.js");
var _nullTokenizeJs = require("../languages/nullTokenize.js");
var _fixedArrayJs = require("./fixedArray.js");
var _contiguousMultilineTokensBuilderJs = require("../tokens/contiguousMultilineTokensBuilder.js");
var _lineTokensJs = require("../tokens/lineTokens.js");
class TokenizerWithStateStore {
    constructor(lineCount, tokenizationSupport){
        this.tokenizationSupport = tokenizationSupport;
        this.initialState = this.tokenizationSupport.getInitialState();
        this.store = new TrackingTokenizationStateStore(lineCount);
    }
    getStartState(lineNumber) {
        return this.store.getStartState(lineNumber, this.initialState);
    }
    getFirstInvalidLine() {
        return this.store.getFirstInvalidLine(this.initialState);
    }
}
class TokenizerWithStateStoreAndTextModel extends TokenizerWithStateStore {
    constructor(lineCount, tokenizationSupport, _textModel, _languageIdCodec){
        super(lineCount, tokenizationSupport);
        this._textModel = _textModel;
        this._languageIdCodec = _languageIdCodec;
    }
    updateTokensUntilLine(builder, lineNumber) {
        const languageId = this._textModel.getLanguageId();
        while(true){
            const lineToTokenize = this.getFirstInvalidLine();
            if (!lineToTokenize || lineToTokenize.lineNumber > lineNumber) break;
            const text = this._textModel.getLineContent(lineToTokenize.lineNumber);
            const r = safeTokenize(this._languageIdCodec, languageId, this.tokenizationSupport, text, true, lineToTokenize.startState);
            builder.add(lineToTokenize.lineNumber, r.tokens);
            this.store.setEndState(lineToTokenize.lineNumber, r.endState);
        }
    }
    /** assumes state is up to date */ getTokenTypeIfInsertingCharacter(position, character) {
        // TODO@hediet: use tokenizeLineWithEdit
        const lineStartState = this.getStartState(position.lineNumber);
        if (!lineStartState) return 0 /* StandardTokenType.Other */ ;
        const languageId = this._textModel.getLanguageId();
        const lineContent = this._textModel.getLineContent(position.lineNumber);
        // Create the text as if `character` was inserted
        const text = lineContent.substring(0, position.column - 1) + character + lineContent.substring(position.column - 1);
        const r = safeTokenize(this._languageIdCodec, languageId, this.tokenizationSupport, text, true, lineStartState);
        const lineTokens = new (0, _lineTokensJs.LineTokens)(r.tokens, text, this._languageIdCodec);
        if (lineTokens.getCount() === 0) return 0 /* StandardTokenType.Other */ ;
        const tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
        return lineTokens.getStandardTokenType(tokenIndex);
    }
    /** assumes state is up to date */ tokenizeLineWithEdit(position, length, newText) {
        const lineNumber = position.lineNumber;
        const column = position.column;
        const lineStartState = this.getStartState(lineNumber);
        if (!lineStartState) return null;
        const curLineContent = this._textModel.getLineContent(lineNumber);
        const newLineContent = curLineContent.substring(0, column - 1) + newText + curLineContent.substring(column - 1 + length);
        const languageId = this._textModel.getLanguageIdAtPosition(lineNumber, 0);
        const result = safeTokenize(this._languageIdCodec, languageId, this.tokenizationSupport, newLineContent, true, lineStartState);
        const lineTokens = new (0, _lineTokensJs.LineTokens)(result.tokens, newLineContent, this._languageIdCodec);
        return lineTokens;
    }
    hasAccurateTokensForLine(lineNumber) {
        const firstInvalidLineNumber = this.store.getFirstInvalidEndStateLineNumberOrMax();
        return lineNumber < firstInvalidLineNumber;
    }
    isCheapToTokenize(lineNumber) {
        const firstInvalidLineNumber = this.store.getFirstInvalidEndStateLineNumberOrMax();
        if (lineNumber < firstInvalidLineNumber) return true;
        if (lineNumber === firstInvalidLineNumber && this._textModel.getLineLength(lineNumber) < 2048 /* Constants.CHEAP_TOKENIZATION_LENGTH_LIMIT */ ) return true;
        return false;
    }
    /**
     * The result is not cached.
     */ tokenizeHeuristically(builder, startLineNumber, endLineNumber) {
        if (endLineNumber <= this.store.getFirstInvalidEndStateLineNumberOrMax()) // nothing to do
        return {
            heuristicTokens: false
        };
        if (startLineNumber <= this.store.getFirstInvalidEndStateLineNumberOrMax()) {
            // tokenization has reached the viewport start...
            this.updateTokensUntilLine(builder, endLineNumber);
            return {
                heuristicTokens: false
            };
        }
        let state = this.guessStartState(startLineNumber);
        const languageId = this._textModel.getLanguageId();
        for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++){
            const text = this._textModel.getLineContent(lineNumber);
            const r = safeTokenize(this._languageIdCodec, languageId, this.tokenizationSupport, text, true, state);
            builder.add(lineNumber, r.tokens);
            state = r.endState;
        }
        return {
            heuristicTokens: true
        };
    }
    guessStartState(lineNumber) {
        let nonWhitespaceColumn = this._textModel.getLineFirstNonWhitespaceColumn(lineNumber);
        const likelyRelevantLines = [];
        let initialState = null;
        for(let i = lineNumber - 1; nonWhitespaceColumn > 1 && i >= 1; i--){
            const newNonWhitespaceIndex = this._textModel.getLineFirstNonWhitespaceColumn(i);
            // Ignore lines full of whitespace
            if (newNonWhitespaceIndex === 0) continue;
            if (newNonWhitespaceIndex < nonWhitespaceColumn) {
                likelyRelevantLines.push(this._textModel.getLineContent(i));
                nonWhitespaceColumn = newNonWhitespaceIndex;
                initialState = this.getStartState(i);
                if (initialState) break;
            }
        }
        if (!initialState) initialState = this.tokenizationSupport.getInitialState();
        likelyRelevantLines.reverse();
        const languageId = this._textModel.getLanguageId();
        let state = initialState;
        for (const line of likelyRelevantLines){
            const r = safeTokenize(this._languageIdCodec, languageId, this.tokenizationSupport, line, false, state);
            state = r.endState;
        }
        return state;
    }
}
class TrackingTokenizationStateStore {
    constructor(lineCount){
        this.lineCount = lineCount;
        this._tokenizationStateStore = new TokenizationStateStore();
        this._invalidEndStatesLineNumbers = new RangePriorityQueueImpl();
        this._invalidEndStatesLineNumbers.addRange(new (0, _offsetRangeJs.OffsetRange)(1, lineCount + 1));
    }
    getEndState(lineNumber) {
        return this._tokenizationStateStore.getEndState(lineNumber);
    }
    /**
     * @returns if the end state has changed.
     */ setEndState(lineNumber, state) {
        if (!state) throw new (0, _errorsJs.BugIndicatingError)("Cannot set null/undefined state");
        this._invalidEndStatesLineNumbers.delete(lineNumber);
        const r = this._tokenizationStateStore.setEndState(lineNumber, state);
        if (r && lineNumber < this.lineCount) // because the state changed, we cannot trust the next state anymore and have to invalidate it.
        this._invalidEndStatesLineNumbers.addRange(new (0, _offsetRangeJs.OffsetRange)(lineNumber + 1, lineNumber + 2));
        return r;
    }
    acceptChange(range, newLineCount) {
        this.lineCount += newLineCount - range.length;
        this._tokenizationStateStore.acceptChange(range, newLineCount);
        this._invalidEndStatesLineNumbers.addRangeAndResize(new (0, _offsetRangeJs.OffsetRange)(range.startLineNumber, range.endLineNumberExclusive), newLineCount);
    }
    acceptChanges(changes) {
        for (const c of changes){
            const [eolCount] = (0, _eolCounterJs.countEOL)(c.text);
            this.acceptChange(new (0, _lineRangeJs.LineRange)(c.range.startLineNumber, c.range.endLineNumber + 1), eolCount + 1);
        }
    }
    invalidateEndStateRange(range) {
        this._invalidEndStatesLineNumbers.addRange(new (0, _offsetRangeJs.OffsetRange)(range.startLineNumber, range.endLineNumberExclusive));
    }
    getFirstInvalidEndStateLineNumber() {
        return this._invalidEndStatesLineNumbers.min;
    }
    getFirstInvalidEndStateLineNumberOrMax() {
        return this.getFirstInvalidEndStateLineNumber() || Number.MAX_SAFE_INTEGER;
    }
    allStatesValid() {
        return this._invalidEndStatesLineNumbers.min === null;
    }
    getStartState(lineNumber, initialState) {
        if (lineNumber === 1) return initialState;
        return this.getEndState(lineNumber - 1);
    }
    getFirstInvalidLine(initialState) {
        const lineNumber = this.getFirstInvalidEndStateLineNumber();
        if (lineNumber === null) return null;
        const startState = this.getStartState(lineNumber, initialState);
        if (!startState) throw new (0, _errorsJs.BugIndicatingError)("Start state must be defined");
        return {
            lineNumber,
            startState
        };
    }
}
class TokenizationStateStore {
    constructor(){
        this._lineEndStates = new (0, _fixedArrayJs.FixedArray)(null);
    }
    getEndState(lineNumber) {
        return this._lineEndStates.get(lineNumber);
    }
    setEndState(lineNumber, state) {
        const oldState = this._lineEndStates.get(lineNumber);
        if (oldState && oldState.equals(state)) return false;
        this._lineEndStates.set(lineNumber, state);
        return true;
    }
    acceptChange(range, newLineCount) {
        let length = range.length;
        if (newLineCount > 0 && length > 0) {
            // Keep the last state, even though it is unrelated.
            // But if the new state happens to agree with this last state, then we know we can stop tokenizing.
            length--;
            newLineCount--;
        }
        this._lineEndStates.replace(range.startLineNumber, length, newLineCount);
    }
}
class RangePriorityQueueImpl {
    constructor(){
        this._ranges = [];
    }
    get min() {
        if (this._ranges.length === 0) return null;
        return this._ranges[0].start;
    }
    delete(value) {
        const idx = this._ranges.findIndex((r)=>r.contains(value));
        if (idx !== -1) {
            const range = this._ranges[idx];
            if (range.start === value) {
                if (range.endExclusive === value + 1) this._ranges.splice(idx, 1);
                else this._ranges[idx] = new (0, _offsetRangeJs.OffsetRange)(value + 1, range.endExclusive);
            } else if (range.endExclusive === value + 1) this._ranges[idx] = new (0, _offsetRangeJs.OffsetRange)(range.start, value);
            else this._ranges.splice(idx, 1, new (0, _offsetRangeJs.OffsetRange)(range.start, value), new (0, _offsetRangeJs.OffsetRange)(value + 1, range.endExclusive));
        }
    }
    addRange(range) {
        (0, _offsetRangeJs.OffsetRange).addRange(range, this._ranges);
    }
    addRangeAndResize(range, newLength) {
        let idxFirstMightBeIntersecting = 0;
        while(!(idxFirstMightBeIntersecting >= this._ranges.length || range.start <= this._ranges[idxFirstMightBeIntersecting].endExclusive))idxFirstMightBeIntersecting++;
        let idxFirstIsAfter = idxFirstMightBeIntersecting;
        while(!(idxFirstIsAfter >= this._ranges.length || range.endExclusive < this._ranges[idxFirstIsAfter].start))idxFirstIsAfter++;
        const delta = newLength - range.length;
        for(let i = idxFirstIsAfter; i < this._ranges.length; i++)this._ranges[i] = this._ranges[i].delta(delta);
        if (idxFirstMightBeIntersecting === idxFirstIsAfter) {
            const newRange = new (0, _offsetRangeJs.OffsetRange)(range.start, range.start + newLength);
            if (!newRange.isEmpty) this._ranges.splice(idxFirstMightBeIntersecting, 0, newRange);
        } else {
            const start = Math.min(range.start, this._ranges[idxFirstMightBeIntersecting].start);
            const endEx = Math.max(range.endExclusive, this._ranges[idxFirstIsAfter - 1].endExclusive);
            const newRange = new (0, _offsetRangeJs.OffsetRange)(start, endEx + delta);
            if (!newRange.isEmpty) this._ranges.splice(idxFirstMightBeIntersecting, idxFirstIsAfter - idxFirstMightBeIntersecting, newRange);
            else this._ranges.splice(idxFirstMightBeIntersecting, idxFirstIsAfter - idxFirstMightBeIntersecting);
        }
    }
    toString() {
        return this._ranges.map((r)=>r.toString()).join(" + ");
    }
}
function safeTokenize(languageIdCodec, languageId, tokenizationSupport, text, hasEOL, state) {
    let r = null;
    if (tokenizationSupport) try {
        r = tokenizationSupport.tokenizeEncoded(text, hasEOL, state.clone());
    } catch (e) {
        (0, _errorsJs.onUnexpectedError)(e);
    }
    if (!r) r = (0, _nullTokenizeJs.nullTokenizeEncoded)(languageIdCodec.encodeLanguageId(languageId), state);
    (0, _lineTokensJs.LineTokens).convertToEndOffset(r.tokens, text.length);
    return r;
}
class DefaultBackgroundTokenizer {
    constructor(_tokenizerWithStateStore, _backgroundTokenStore){
        this._tokenizerWithStateStore = _tokenizerWithStateStore;
        this._backgroundTokenStore = _backgroundTokenStore;
        this._isDisposed = false;
        this._isScheduled = false;
    }
    dispose() {
        this._isDisposed = true;
    }
    handleChanges() {
        this._beginBackgroundTokenization();
    }
    _beginBackgroundTokenization() {
        if (this._isScheduled || !this._tokenizerWithStateStore._textModel.isAttachedToEditor() || !this._hasLinesToTokenize()) return;
        this._isScheduled = true;
        (0, _asyncJs.runWhenGlobalIdle)((deadline)=>{
            this._isScheduled = false;
            this._backgroundTokenizeWithDeadline(deadline);
        });
    }
    /**
     * Tokenize until the deadline occurs, but try to yield every 1-2ms.
     */ _backgroundTokenizeWithDeadline(deadline) {
        // Read the time remaining from the `deadline` immediately because it is unclear
        // if the `deadline` object will be valid after execution leaves this function.
        const endTime = Date.now() + deadline.timeRemaining();
        const execute = ()=>{
            if (this._isDisposed || !this._tokenizerWithStateStore._textModel.isAttachedToEditor() || !this._hasLinesToTokenize()) // disposed in the meantime or detached or finished
            return;
            this._backgroundTokenizeForAtLeast1ms();
            if (Date.now() < endTime) // There is still time before reaching the deadline, so yield to the browser and then
            // continue execution
            (0, _platformJs.setTimeout0)(execute);
            else // The deadline has been reached, so schedule a new idle callback if necessary
            this._beginBackgroundTokenization();
        };
        execute();
    }
    /**
     * Tokenize for at least 1ms.
     */ _backgroundTokenizeForAtLeast1ms() {
        const lineCount = this._tokenizerWithStateStore._textModel.getLineCount();
        const builder = new (0, _contiguousMultilineTokensBuilderJs.ContiguousMultilineTokensBuilder)();
        const sw = (0, _stopwatchJs.StopWatch).create(false);
        do {
            if (sw.elapsed() > 1) break;
            const tokenizedLineNumber = this._tokenizeOneInvalidLine(builder);
            if (tokenizedLineNumber >= lineCount) break;
        }while (this._hasLinesToTokenize());
        this._backgroundTokenStore.setTokens(builder.finalize());
        this.checkFinished();
    }
    _hasLinesToTokenize() {
        if (!this._tokenizerWithStateStore) return false;
        return !this._tokenizerWithStateStore.store.allStatesValid();
    }
    _tokenizeOneInvalidLine(builder) {
        const firstInvalidLine = this._tokenizerWithStateStore?.getFirstInvalidLine();
        if (!firstInvalidLine) return this._tokenizerWithStateStore._textModel.getLineCount() + 1;
        this._tokenizerWithStateStore.updateTokensUntilLine(builder, firstInvalidLine.lineNumber);
        return firstInvalidLine.lineNumber;
    }
    checkFinished() {
        if (this._isDisposed) return;
        if (this._tokenizerWithStateStore.store.allStatesValid()) this._backgroundTokenStore.backgroundTokenizationFinished();
    }
    requestTokens(startLineNumber, endLineNumberExclusive) {
        this._tokenizerWithStateStore.store.invalidateEndStateRange(new (0, _lineRangeJs.LineRange)(startLineNumber, endLineNumberExclusive));
    }
}

},{"../../../base/common/async.js":"4GJc4","../../../base/common/errors.js":"divX8","../../../base/common/platform.js":"7maJO","../../../base/common/stopwatch.js":"77PF9","../core/eolCounter.js":"4i42Y","../core/lineRange.js":"cmnMs","../core/offsetRange.js":"ifHXk","../languages/nullTokenize.js":"ekzGB","./fixedArray.js":"cluTr","../tokens/contiguousMultilineTokensBuilder.js":"4SfGD","../tokens/lineTokens.js":"6iUVx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cluTr":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An array that avoids being sparse by always
 * filling up unused indices with a default value.
 */ parcelHelpers.export(exports, "FixedArray", ()=>FixedArray);
var _arraysJs = require("../../../base/common/arrays.js");
class FixedArray {
    constructor(_default){
        this._default = _default;
        this._store = [];
    }
    get(index) {
        if (index < this._store.length) return this._store[index];
        return this._default;
    }
    set(index, value) {
        while(index >= this._store.length)this._store[this._store.length] = this._default;
        this._store[index] = value;
    }
    replace(index, oldLength, newLength) {
        if (index >= this._store.length) return;
        if (oldLength === 0) {
            this.insert(index, newLength);
            return;
        } else if (newLength === 0) {
            this.delete(index, oldLength);
            return;
        }
        const before = this._store.slice(0, index);
        const after = this._store.slice(index + oldLength);
        const insertArr = arrayFill(newLength, this._default);
        this._store = before.concat(insertArr, after);
    }
    delete(deleteIndex, deleteCount) {
        if (deleteCount === 0 || deleteIndex >= this._store.length) return;
        this._store.splice(deleteIndex, deleteCount);
    }
    insert(insertIndex, insertCount) {
        if (insertCount === 0 || insertIndex >= this._store.length) return;
        const arr = [];
        for(let i = 0; i < insertCount; i++)arr[i] = this._default;
        this._store = (0, _arraysJs.arrayInsert)(this._store, insertIndex, arr);
    }
}
function arrayFill(length, value) {
    const arr = [];
    for(let i = 0; i < length; i++)arr[i] = value;
    return arr;
}

},{"../../../base/common/arrays.js":"DECei","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4SfGD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContiguousMultilineTokensBuilder", ()=>ContiguousMultilineTokensBuilder);
var _contiguousMultilineTokensJs = require("./contiguousMultilineTokens.js");
class ContiguousMultilineTokensBuilder {
    constructor(){
        this._tokens = [];
    }
    add(lineNumber, lineTokens) {
        if (this._tokens.length > 0) {
            const last = this._tokens[this._tokens.length - 1];
            if (last.endLineNumber + 1 === lineNumber) {
                // append
                last.appendLineTokens(lineTokens);
                return;
            }
        }
        this._tokens.push(new (0, _contiguousMultilineTokensJs.ContiguousMultilineTokens)(lineNumber, [
            lineTokens
        ]));
    }
    finalize() {
        return this._tokens;
    }
}

},{"./contiguousMultilineTokens.js":"aBZFV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aBZFV":[function(require,module,exports) {
/**
 * Represents contiguous tokens over a contiguous range of lines.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContiguousMultilineTokens", ()=>ContiguousMultilineTokens);
class ContiguousMultilineTokens {
    /**
     * (Inclusive) start line number for these tokens.
     */ get startLineNumber() {
        return this._startLineNumber;
    }
    /**
     * (Inclusive) end line number for these tokens.
     */ get endLineNumber() {
        return this._startLineNumber + this._tokens.length - 1;
    }
    constructor(startLineNumber, tokens){
        this._startLineNumber = startLineNumber;
        this._tokens = tokens;
    }
    /**
     * @see {@link _tokens}
     */ getLineTokens(lineNumber) {
        return this._tokens[lineNumber - this._startLineNumber];
    }
    appendLineTokens(lineTokens) {
        this._tokens.push(lineTokens);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gi3Tb":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "AttachedViews", ()=>AttachedViews);
parcelHelpers.export(exports, "AttachedViewHandler", ()=>AttachedViewHandler);
parcelHelpers.export(exports, "AbstractTokens", ()=>AbstractTokens);
var _arraysJs = require("../../../base/common/arrays.js");
var _asyncJs = require("../../../base/common/async.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _lineRangeJs = require("../core/lineRange.js");
class AttachedViews {
    constructor(){
        this._onDidChangeVisibleRanges = new (0, _eventJs.Emitter)();
        this.onDidChangeVisibleRanges = this._onDidChangeVisibleRanges.event;
        this._views = new Set();
    }
    attachView() {
        const view = new AttachedViewImpl((state)=>{
            this._onDidChangeVisibleRanges.fire({
                view,
                state
            });
        });
        this._views.add(view);
        return view;
    }
    detachView(view) {
        this._views.delete(view);
        this._onDidChangeVisibleRanges.fire({
            view,
            state: undefined
        });
    }
}
class AttachedViewImpl {
    constructor(handleStateChange){
        this.handleStateChange = handleStateChange;
    }
    setVisibleLines(visibleLines, stabilized) {
        const visibleLineRanges = visibleLines.map((line)=>new (0, _lineRangeJs.LineRange)(line.startLineNumber, line.endLineNumber + 1));
        this.handleStateChange({
            visibleLineRanges,
            stabilized
        });
    }
}
class AttachedViewHandler extends (0, _lifecycleJs.Disposable) {
    get lineRanges() {
        return this._lineRanges;
    }
    constructor(_refreshTokens){
        super();
        this._refreshTokens = _refreshTokens;
        this.runner = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this.update(), 50));
        this._computedLineRanges = [];
        this._lineRanges = [];
    }
    update() {
        if ((0, _arraysJs.equals)(this._computedLineRanges, this._lineRanges, (a, b)=>a.equals(b))) return;
        this._computedLineRanges = this._lineRanges;
        this._refreshTokens();
    }
    handleStateChange(state) {
        this._lineRanges = state.visibleLineRanges;
        if (state.stabilized) {
            this.runner.cancel();
            this.update();
        } else this.runner.schedule();
    }
}
class AbstractTokens extends (0, _lifecycleJs.Disposable) {
    get backgroundTokenizationState() {
        return this._backgroundTokenizationState;
    }
    constructor(_languageIdCodec, _textModel, getLanguageId){
        super();
        this._languageIdCodec = _languageIdCodec;
        this._textModel = _textModel;
        this.getLanguageId = getLanguageId;
        this._backgroundTokenizationState = 1 /* BackgroundTokenizationState.InProgress */ ;
        this._onDidChangeBackgroundTokenizationState = this._register(new (0, _eventJs.Emitter)());
        /** @internal, should not be exposed by the text model! */ this.onDidChangeBackgroundTokenizationState = this._onDidChangeBackgroundTokenizationState.event;
        this._onDidChangeTokens = this._register(new (0, _eventJs.Emitter)());
        /** @internal, should not be exposed by the text model! */ this.onDidChangeTokens = this._onDidChangeTokens.event;
    }
    tokenizeIfCheap(lineNumber) {
        if (this.isCheapToTokenize(lineNumber)) this.forceTokenization(lineNumber);
    }
}

},{"../../../base/common/arrays.js":"DECei","../../../base/common/async.js":"4GJc4","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../core/lineRange.js":"cmnMs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bP62x":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TreeSitterTokens", ()=>TreeSitterTokens);
var _languagesJs = require("../languages.js");
var _lineTokensJs = require("../tokens/lineTokens.js");
var _tokensJs = require("./tokens.js");
class TreeSitterTokens extends (0, _tokensJs.AbstractTokens) {
    constructor(_treeSitterService, languageIdCodec, textModel, languageId){
        super(languageIdCodec, textModel, languageId);
        this._treeSitterService = _treeSitterService;
        this._tokenizationSupport = null;
        this._initialize();
    }
    _initialize() {
        const newLanguage = this.getLanguageId();
        if (!this._tokenizationSupport || this._lastLanguageId !== newLanguage) {
            this._lastLanguageId = newLanguage;
            this._tokenizationSupport = (0, _languagesJs.TreeSitterTokenizationRegistry).get(newLanguage);
        }
    }
    getLineTokens(lineNumber) {
        const content = this._textModel.getLineContent(lineNumber);
        if (this._tokenizationSupport) {
            const rawTokens = this._tokenizationSupport.tokenizeEncoded(lineNumber, this._textModel);
            if (rawTokens) return new (0, _lineTokensJs.LineTokens)(rawTokens, content, this._languageIdCodec);
        }
        return (0, _lineTokensJs.LineTokens).createEmpty(content, this._languageIdCodec);
    }
    resetTokenization(fireTokenChangeEvent = true) {
        if (fireTokenChangeEvent) this._onDidChangeTokens.fire({
            semanticTokensApplied: false,
            ranges: [
                {
                    fromLineNumber: 1,
                    toLineNumber: this._textModel.getLineCount()
                }
            ]
        });
        this._initialize();
    }
    handleDidChangeAttached() {
    // TODO @alexr00 implement for background tokenization
    }
    handleDidChangeContent(e) {
        if (e.isFlush) // Don't fire the event, as the view might not have got the text change event yet
        this.resetTokenization(false);
    }
    forceTokenization(lineNumber) {
    // TODO @alexr00 implement
    }
    hasAccurateTokensForLine(lineNumber) {
        // TODO @alexr00 update for background tokenization
        return true;
    }
    isCheapToTokenize(lineNumber) {
        // TODO @alexr00 update for background tokenization
        return true;
    }
    getTokenTypeIfInsertingCharacter(lineNumber, column, character) {
        // TODO @alexr00 implement once we have custom parsing and don't just feed in the whole text model value
        return 0 /* StandardTokenType.Other */ ;
    }
    tokenizeLineWithEdit(position, length, newText) {
        // TODO @alexr00 understand what this is for and implement
        return null;
    }
    get hasTokens() {
        // TODO @alexr00 once we have a token store, implement properly
        const hasTree = this._treeSitterService.getParseResult(this._textModel) !== undefined;
        return hasTree;
    }
}

},{"../languages.js":"g5n96","../tokens/lineTokens.js":"6iUVx","./tokens.js":"gi3Tb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bi0Mc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ITreeSitterParserService", ()=>ITreeSitterParserService);
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
const ITreeSitterParserService = (0, _instantiationJs.createDecorator)("treeSitterParserService");

},{"../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"wxC8l":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents contiguous tokens in a text model.
 */ parcelHelpers.export(exports, "ContiguousTokensStore", ()=>ContiguousTokensStore);
var _arraysJs = require("../../../base/common/arrays.js");
var _positionJs = require("../core/position.js");
var _contiguousTokensEditingJs = require("./contiguousTokensEditing.js");
var _lineTokensJs = require("./lineTokens.js");
var _encodedTokenAttributesJs = require("../encodedTokenAttributes.js");
class ContiguousTokensStore {
    constructor(languageIdCodec){
        this._lineTokens = [];
        this._len = 0;
        this._languageIdCodec = languageIdCodec;
    }
    flush() {
        this._lineTokens = [];
        this._len = 0;
    }
    get hasTokens() {
        return this._lineTokens.length > 0;
    }
    getTokens(topLevelLanguageId, lineIndex, lineText) {
        let rawLineTokens = null;
        if (lineIndex < this._len) rawLineTokens = this._lineTokens[lineIndex];
        if (rawLineTokens !== null && rawLineTokens !== (0, _contiguousTokensEditingJs.EMPTY_LINE_TOKENS)) return new (0, _lineTokensJs.LineTokens)((0, _contiguousTokensEditingJs.toUint32Array)(rawLineTokens), lineText, this._languageIdCodec);
        const lineTokens = new Uint32Array(2);
        lineTokens[0] = lineText.length;
        lineTokens[1] = getDefaultMetadata(this._languageIdCodec.encodeLanguageId(topLevelLanguageId));
        return new (0, _lineTokensJs.LineTokens)(lineTokens, lineText, this._languageIdCodec);
    }
    static _massageTokens(topLevelLanguageId, lineTextLength, _tokens) {
        const tokens = _tokens ? (0, _contiguousTokensEditingJs.toUint32Array)(_tokens) : null;
        if (lineTextLength === 0) {
            let hasDifferentLanguageId = false;
            if (tokens && tokens.length > 1) hasDifferentLanguageId = (0, _encodedTokenAttributesJs.TokenMetadata).getLanguageId(tokens[1]) !== topLevelLanguageId;
            if (!hasDifferentLanguageId) return 0, _contiguousTokensEditingJs.EMPTY_LINE_TOKENS;
        }
        if (!tokens || tokens.length === 0) {
            const tokens = new Uint32Array(2);
            tokens[0] = lineTextLength;
            tokens[1] = getDefaultMetadata(topLevelLanguageId);
            return tokens.buffer;
        }
        // Ensure the last token covers the end of the text
        tokens[tokens.length - 2] = lineTextLength;
        if (tokens.byteOffset === 0 && tokens.byteLength === tokens.buffer.byteLength) // Store directly the ArrayBuffer pointer to save an object
        return tokens.buffer;
        return tokens;
    }
    _ensureLine(lineIndex) {
        while(lineIndex >= this._len){
            this._lineTokens[this._len] = null;
            this._len++;
        }
    }
    _deleteLines(start, deleteCount) {
        if (deleteCount === 0) return;
        if (start + deleteCount > this._len) deleteCount = this._len - start;
        this._lineTokens.splice(start, deleteCount);
        this._len -= deleteCount;
    }
    _insertLines(insertIndex, insertCount) {
        if (insertCount === 0) return;
        const lineTokens = [];
        for(let i = 0; i < insertCount; i++)lineTokens[i] = null;
        this._lineTokens = _arraysJs.arrayInsert(this._lineTokens, insertIndex, lineTokens);
        this._len += insertCount;
    }
    setTokens(topLevelLanguageId, lineIndex, lineTextLength, _tokens, checkEquality) {
        const tokens = ContiguousTokensStore._massageTokens(this._languageIdCodec.encodeLanguageId(topLevelLanguageId), lineTextLength, _tokens);
        this._ensureLine(lineIndex);
        const oldTokens = this._lineTokens[lineIndex];
        this._lineTokens[lineIndex] = tokens;
        if (checkEquality) return !ContiguousTokensStore._equals(oldTokens, tokens);
        return false;
    }
    static _equals(_a, _b) {
        if (!_a || !_b) return !_a && !_b;
        const a = (0, _contiguousTokensEditingJs.toUint32Array)(_a);
        const b = (0, _contiguousTokensEditingJs.toUint32Array)(_b);
        if (a.length !== b.length) return false;
        for(let i = 0, len = a.length; i < len; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    //#region Editing
    acceptEdit(range, eolCount, firstLineLength) {
        this._acceptDeleteRange(range);
        this._acceptInsertText(new (0, _positionJs.Position)(range.startLineNumber, range.startColumn), eolCount, firstLineLength);
    }
    _acceptDeleteRange(range) {
        const firstLineIndex = range.startLineNumber - 1;
        if (firstLineIndex >= this._len) return;
        if (range.startLineNumber === range.endLineNumber) {
            if (range.startColumn === range.endColumn) // Nothing to delete
            return;
            this._lineTokens[firstLineIndex] = (0, _contiguousTokensEditingJs.ContiguousTokensEditing).delete(this._lineTokens[firstLineIndex], range.startColumn - 1, range.endColumn - 1);
            return;
        }
        this._lineTokens[firstLineIndex] = (0, _contiguousTokensEditingJs.ContiguousTokensEditing).deleteEnding(this._lineTokens[firstLineIndex], range.startColumn - 1);
        const lastLineIndex = range.endLineNumber - 1;
        let lastLineTokens = null;
        if (lastLineIndex < this._len) lastLineTokens = (0, _contiguousTokensEditingJs.ContiguousTokensEditing).deleteBeginning(this._lineTokens[lastLineIndex], range.endColumn - 1);
        // Take remaining text on last line and append it to remaining text on first line
        this._lineTokens[firstLineIndex] = (0, _contiguousTokensEditingJs.ContiguousTokensEditing).append(this._lineTokens[firstLineIndex], lastLineTokens);
        // Delete middle lines
        this._deleteLines(range.startLineNumber, range.endLineNumber - range.startLineNumber);
    }
    _acceptInsertText(position, eolCount, firstLineLength) {
        if (eolCount === 0 && firstLineLength === 0) // Nothing to insert
        return;
        const lineIndex = position.lineNumber - 1;
        if (lineIndex >= this._len) return;
        if (eolCount === 0) {
            // Inserting text on one line
            this._lineTokens[lineIndex] = (0, _contiguousTokensEditingJs.ContiguousTokensEditing).insert(this._lineTokens[lineIndex], position.column - 1, firstLineLength);
            return;
        }
        this._lineTokens[lineIndex] = (0, _contiguousTokensEditingJs.ContiguousTokensEditing).deleteEnding(this._lineTokens[lineIndex], position.column - 1);
        this._lineTokens[lineIndex] = (0, _contiguousTokensEditingJs.ContiguousTokensEditing).insert(this._lineTokens[lineIndex], position.column - 1, firstLineLength);
        this._insertLines(position.lineNumber, eolCount);
    }
    //#endregion
    setMultilineTokens(tokens, textModel) {
        if (tokens.length === 0) return {
            changes: []
        };
        const ranges = [];
        for(let i = 0, len = tokens.length; i < len; i++){
            const element = tokens[i];
            let minChangedLineNumber = 0;
            let maxChangedLineNumber = 0;
            let hasChange = false;
            for(let lineNumber = element.startLineNumber; lineNumber <= element.endLineNumber; lineNumber++)if (hasChange) {
                this.setTokens(textModel.getLanguageId(), lineNumber - 1, textModel.getLineLength(lineNumber), element.getLineTokens(lineNumber), false);
                maxChangedLineNumber = lineNumber;
            } else {
                const lineHasChange = this.setTokens(textModel.getLanguageId(), lineNumber - 1, textModel.getLineLength(lineNumber), element.getLineTokens(lineNumber), true);
                if (lineHasChange) {
                    hasChange = true;
                    minChangedLineNumber = lineNumber;
                    maxChangedLineNumber = lineNumber;
                }
            }
            if (hasChange) ranges.push({
                fromLineNumber: minChangedLineNumber,
                toLineNumber: maxChangedLineNumber
            });
        }
        return {
            changes: ranges
        };
    }
}
function getDefaultMetadata(topLevelLanguageId) {
    return (topLevelLanguageId << 0 /* MetadataConsts.LANGUAGEID_OFFSET */  | 33588224) >>> 0;
}

},{"../../../base/common/arrays.js":"DECei","../core/position.js":"lvrPe","./contiguousTokensEditing.js":"kuUmR","./lineTokens.js":"6iUVx","../encodedTokenAttributes.js":"eH8EQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kuUmR":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_LINE_TOKENS", ()=>EMPTY_LINE_TOKENS);
parcelHelpers.export(exports, "ContiguousTokensEditing", ()=>ContiguousTokensEditing);
parcelHelpers.export(exports, "toUint32Array", ()=>toUint32Array);
var _lineTokensJs = require("./lineTokens.js");
const EMPTY_LINE_TOKENS = new Uint32Array(0).buffer;
class ContiguousTokensEditing {
    static deleteBeginning(lineTokens, toChIndex) {
        if (lineTokens === null || lineTokens === EMPTY_LINE_TOKENS) return lineTokens;
        return ContiguousTokensEditing.delete(lineTokens, 0, toChIndex);
    }
    static deleteEnding(lineTokens, fromChIndex) {
        if (lineTokens === null || lineTokens === EMPTY_LINE_TOKENS) return lineTokens;
        const tokens = toUint32Array(lineTokens);
        const lineTextLength = tokens[tokens.length - 2];
        return ContiguousTokensEditing.delete(lineTokens, fromChIndex, lineTextLength);
    }
    static delete(lineTokens, fromChIndex, toChIndex) {
        if (lineTokens === null || lineTokens === EMPTY_LINE_TOKENS || fromChIndex === toChIndex) return lineTokens;
        const tokens = toUint32Array(lineTokens);
        const tokensCount = tokens.length >>> 1;
        // special case: deleting everything
        if (fromChIndex === 0 && tokens[tokens.length - 2] === toChIndex) return EMPTY_LINE_TOKENS;
        const fromTokenIndex = (0, _lineTokensJs.LineTokens).findIndexInTokensArray(tokens, fromChIndex);
        const fromTokenStartOffset = fromTokenIndex > 0 ? tokens[fromTokenIndex - 1 << 1] : 0;
        const fromTokenEndOffset = tokens[fromTokenIndex << 1];
        if (toChIndex < fromTokenEndOffset) {
            // the delete range is inside a single token
            const delta = toChIndex - fromChIndex;
            for(let i = fromTokenIndex; i < tokensCount; i++)tokens[i << 1] -= delta;
            return lineTokens;
        }
        let dest;
        let lastEnd;
        if (fromTokenStartOffset !== fromChIndex) {
            tokens[fromTokenIndex << 1] = fromChIndex;
            dest = fromTokenIndex + 1 << 1;
            lastEnd = fromChIndex;
        } else {
            dest = fromTokenIndex << 1;
            lastEnd = fromTokenStartOffset;
        }
        const delta = toChIndex - fromChIndex;
        for(let tokenIndex = fromTokenIndex + 1; tokenIndex < tokensCount; tokenIndex++){
            const tokenEndOffset = tokens[tokenIndex << 1] - delta;
            if (tokenEndOffset > lastEnd) {
                tokens[dest++] = tokenEndOffset;
                tokens[dest++] = tokens[(tokenIndex << 1) + 1];
                lastEnd = tokenEndOffset;
            }
        }
        if (dest === tokens.length) // nothing to trim
        return lineTokens;
        const tmp = new Uint32Array(dest);
        tmp.set(tokens.subarray(0, dest), 0);
        return tmp.buffer;
    }
    static append(lineTokens, _otherTokens) {
        if (_otherTokens === EMPTY_LINE_TOKENS) return lineTokens;
        if (lineTokens === EMPTY_LINE_TOKENS) return _otherTokens;
        if (lineTokens === null) return lineTokens;
        if (_otherTokens === null) // cannot determine combined line length...
        return null;
        const myTokens = toUint32Array(lineTokens);
        const otherTokens = toUint32Array(_otherTokens);
        const otherTokensCount = otherTokens.length >>> 1;
        const result = new Uint32Array(myTokens.length + otherTokens.length);
        result.set(myTokens, 0);
        let dest = myTokens.length;
        const delta = myTokens[myTokens.length - 2];
        for(let i = 0; i < otherTokensCount; i++){
            result[dest++] = otherTokens[i << 1] + delta;
            result[dest++] = otherTokens[(i << 1) + 1];
        }
        return result.buffer;
    }
    static insert(lineTokens, chIndex, textLength) {
        if (lineTokens === null || lineTokens === EMPTY_LINE_TOKENS) // nothing to do
        return lineTokens;
        const tokens = toUint32Array(lineTokens);
        const tokensCount = tokens.length >>> 1;
        let fromTokenIndex = (0, _lineTokensJs.LineTokens).findIndexInTokensArray(tokens, chIndex);
        if (fromTokenIndex > 0) {
            const fromTokenStartOffset = tokens[fromTokenIndex - 1 << 1];
            if (fromTokenStartOffset === chIndex) fromTokenIndex--;
        }
        for(let tokenIndex = fromTokenIndex; tokenIndex < tokensCount; tokenIndex++)tokens[tokenIndex << 1] += textLength;
        return lineTokens;
    }
}
function toUint32Array(arr) {
    if (arr instanceof Uint32Array) return arr;
    else return new Uint32Array(arr);
}

},{"./lineTokens.js":"6iUVx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2XNAL":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents sparse tokens in a text model.
 */ parcelHelpers.export(exports, "SparseTokensStore", ()=>SparseTokensStore);
var _arraysJs = require("../../../base/common/arrays.js");
var _lineTokensJs = require("./lineTokens.js");
class SparseTokensStore {
    constructor(languageIdCodec){
        this._pieces = [];
        this._isComplete = false;
        this._languageIdCodec = languageIdCodec;
    }
    flush() {
        this._pieces = [];
        this._isComplete = false;
    }
    isEmpty() {
        return this._pieces.length === 0;
    }
    set(pieces, isComplete) {
        this._pieces = pieces || [];
        this._isComplete = isComplete;
    }
    setPartial(_range, pieces) {
        // console.log(`setPartial ${_range} ${pieces.map(p => p.toString()).join(', ')}`);
        let range = _range;
        if (pieces.length > 0) {
            const _firstRange = pieces[0].getRange();
            const _lastRange = pieces[pieces.length - 1].getRange();
            if (!_firstRange || !_lastRange) return _range;
            range = _range.plusRange(_firstRange).plusRange(_lastRange);
        }
        let insertPosition = null;
        for(let i = 0, len = this._pieces.length; i < len; i++){
            const piece = this._pieces[i];
            if (piece.endLineNumber < range.startLineNumber) continue;
            if (piece.startLineNumber > range.endLineNumber) {
                // this piece is after the range, so mark the spot before this piece
                // as a good insertion position and stop looping
                insertPosition = insertPosition || {
                    index: i
                };
                break;
            }
            // this piece might intersect with the range
            piece.removeTokens(range);
            if (piece.isEmpty()) {
                // remove the piece if it became empty
                this._pieces.splice(i, 1);
                i--;
                len--;
                continue;
            }
            if (piece.endLineNumber < range.startLineNumber) continue;
            if (piece.startLineNumber > range.endLineNumber) {
                // after removal, this piece is after the range
                insertPosition = insertPosition || {
                    index: i
                };
                continue;
            }
            // after removal, this piece contains the range
            const [a, b] = piece.split(range);
            if (a.isEmpty()) {
                // this piece is actually after the range
                insertPosition = insertPosition || {
                    index: i
                };
                continue;
            }
            if (b.isEmpty()) continue;
            this._pieces.splice(i, 1, a, b);
            i++;
            len++;
            insertPosition = insertPosition || {
                index: i
            };
        }
        insertPosition = insertPosition || {
            index: this._pieces.length
        };
        if (pieces.length > 0) this._pieces = _arraysJs.arrayInsert(this._pieces, insertPosition.index, pieces);
        // console.log(`I HAVE ${this._pieces.length} pieces`);
        // console.log(`${this._pieces.map(p => p.toString()).join('\n')}`);
        return range;
    }
    isComplete() {
        return this._isComplete;
    }
    addSparseTokens(lineNumber, aTokens) {
        if (aTokens.getLineContent().length === 0) // Don't do anything for empty lines
        return aTokens;
        const pieces = this._pieces;
        if (pieces.length === 0) return aTokens;
        const pieceIndex = SparseTokensStore._findFirstPieceWithLine(pieces, lineNumber);
        const bTokens = pieces[pieceIndex].getLineTokens(lineNumber);
        if (!bTokens) return aTokens;
        const aLen = aTokens.getCount();
        const bLen = bTokens.getCount();
        let aIndex = 0;
        const result = [];
        let resultLen = 0;
        let lastEndOffset = 0;
        const emitToken = (endOffset, metadata)=>{
            if (endOffset === lastEndOffset) return;
            lastEndOffset = endOffset;
            result[resultLen++] = endOffset;
            result[resultLen++] = metadata;
        };
        for(let bIndex = 0; bIndex < bLen; bIndex++){
            const bStartCharacter = bTokens.getStartCharacter(bIndex);
            const bEndCharacter = bTokens.getEndCharacter(bIndex);
            const bMetadata = bTokens.getMetadata(bIndex);
            const bMask = ((bMetadata & 1 /* MetadataConsts.SEMANTIC_USE_ITALIC */  ? 2048 /* MetadataConsts.ITALIC_MASK */  : 0) | (bMetadata & 2 /* MetadataConsts.SEMANTIC_USE_BOLD */  ? 4096 /* MetadataConsts.BOLD_MASK */  : 0) | (bMetadata & 4 /* MetadataConsts.SEMANTIC_USE_UNDERLINE */  ? 8192 /* MetadataConsts.UNDERLINE_MASK */  : 0) | (bMetadata & 8 /* MetadataConsts.SEMANTIC_USE_STRIKETHROUGH */  ? 16384 /* MetadataConsts.STRIKETHROUGH_MASK */  : 0) | (bMetadata & 16 /* MetadataConsts.SEMANTIC_USE_FOREGROUND */  ? 16744448 /* MetadataConsts.FOREGROUND_MASK */  : 0) | (bMetadata & 32 /* MetadataConsts.SEMANTIC_USE_BACKGROUND */  ? 4278190080 /* MetadataConsts.BACKGROUND_MASK */  : 0)) >>> 0;
            const aMask = ~bMask >>> 0;
            // push any token from `a` that is before `b`
            while(aIndex < aLen && aTokens.getEndOffset(aIndex) <= bStartCharacter){
                emitToken(aTokens.getEndOffset(aIndex), aTokens.getMetadata(aIndex));
                aIndex++;
            }
            // push the token from `a` if it intersects the token from `b`
            if (aIndex < aLen && aTokens.getStartOffset(aIndex) < bStartCharacter) emitToken(bStartCharacter, aTokens.getMetadata(aIndex));
            // skip any tokens from `a` that are contained inside `b`
            while(aIndex < aLen && aTokens.getEndOffset(aIndex) < bEndCharacter){
                emitToken(aTokens.getEndOffset(aIndex), aTokens.getMetadata(aIndex) & aMask | bMetadata & bMask);
                aIndex++;
            }
            if (aIndex < aLen) {
                emitToken(bEndCharacter, aTokens.getMetadata(aIndex) & aMask | bMetadata & bMask);
                if (aTokens.getEndOffset(aIndex) === bEndCharacter) // `a` ends exactly at the same spot as `b`!
                aIndex++;
            } else {
                const aMergeIndex = Math.min(Math.max(0, aIndex - 1), aLen - 1);
                // push the token from `b`
                emitToken(bEndCharacter, aTokens.getMetadata(aMergeIndex) & aMask | bMetadata & bMask);
            }
        }
        // push the remaining tokens from `a`
        while(aIndex < aLen){
            emitToken(aTokens.getEndOffset(aIndex), aTokens.getMetadata(aIndex));
            aIndex++;
        }
        return new (0, _lineTokensJs.LineTokens)(new Uint32Array(result), aTokens.getLineContent(), this._languageIdCodec);
    }
    static _findFirstPieceWithLine(pieces, lineNumber) {
        let low = 0;
        let high = pieces.length - 1;
        while(low < high){
            let mid = low + Math.floor((high - low) / 2);
            if (pieces[mid].endLineNumber < lineNumber) low = mid + 1;
            else if (pieces[mid].startLineNumber > lineNumber) high = mid - 1;
            else {
                while(mid > low && pieces[mid - 1].startLineNumber <= lineNumber && lineNumber <= pieces[mid - 1].endLineNumber)mid--;
                return mid;
            }
        }
        return low;
    }
    acceptEdit(range, eolCount, firstLineLength, lastLineLength, firstCharCode) {
        for (const piece of this._pieces)piece.acceptEdit(range, eolCount, firstLineLength, lastLineLength, firstCharCode);
    }
}

},{"../../../base/common/arrays.js":"DECei","./lineTokens.js":"6iUVx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"90evO":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 * An event describing that a model has been reset to a new value.
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelRawFlush", ()=>ModelRawFlush);
/**
 * Represents text injected on a line
 * @internal
 */ parcelHelpers.export(exports, "LineInjectedText", ()=>LineInjectedText);
/**
 * An event describing that a line has changed in a model.
 * @internal
 */ parcelHelpers.export(exports, "ModelRawLineChanged", ()=>ModelRawLineChanged);
/**
 * An event describing that line(s) have been deleted in a model.
 * @internal
 */ parcelHelpers.export(exports, "ModelRawLinesDeleted", ()=>ModelRawLinesDeleted);
/**
 * An event describing that line(s) have been inserted in a model.
 * @internal
 */ parcelHelpers.export(exports, "ModelRawLinesInserted", ()=>ModelRawLinesInserted);
/**
 * An event describing that a model has had its EOL changed.
 * @internal
 */ parcelHelpers.export(exports, "ModelRawEOLChanged", ()=>ModelRawEOLChanged);
/**
 * An event describing a change in the text of a model.
 * @internal
 */ parcelHelpers.export(exports, "ModelRawContentChangedEvent", ()=>ModelRawContentChangedEvent);
/**
 * An event describing a change in injected text.
 * @internal
 */ parcelHelpers.export(exports, "ModelInjectedTextChangedEvent", ()=>ModelInjectedTextChangedEvent);
/**
 * @internal
 */ parcelHelpers.export(exports, "InternalModelContentChangeEvent", ()=>InternalModelContentChangeEvent);
class ModelRawFlush {
    constructor(){
        this.changeType = 1 /* RawContentChangedType.Flush */ ;
    }
}
class LineInjectedText {
    static applyInjectedText(lineText, injectedTexts) {
        if (!injectedTexts || injectedTexts.length === 0) return lineText;
        let result = "";
        let lastOriginalOffset = 0;
        for (const injectedText of injectedTexts){
            result += lineText.substring(lastOriginalOffset, injectedText.column - 1);
            lastOriginalOffset = injectedText.column - 1;
            result += injectedText.options.content;
        }
        result += lineText.substring(lastOriginalOffset);
        return result;
    }
    static fromDecorations(decorations) {
        const result = [];
        for (const decoration of decorations){
            if (decoration.options.before && decoration.options.before.content.length > 0) result.push(new LineInjectedText(decoration.ownerId, decoration.range.startLineNumber, decoration.range.startColumn, decoration.options.before, 0));
            if (decoration.options.after && decoration.options.after.content.length > 0) result.push(new LineInjectedText(decoration.ownerId, decoration.range.endLineNumber, decoration.range.endColumn, decoration.options.after, 1));
        }
        result.sort((a, b)=>{
            if (a.lineNumber === b.lineNumber) {
                if (a.column === b.column) return a.order - b.order;
                return a.column - b.column;
            }
            return a.lineNumber - b.lineNumber;
        });
        return result;
    }
    constructor(ownerId, lineNumber, column, options, order){
        this.ownerId = ownerId;
        this.lineNumber = lineNumber;
        this.column = column;
        this.options = options;
        this.order = order;
    }
}
class ModelRawLineChanged {
    constructor(lineNumber, detail, injectedText){
        this.changeType = 2 /* RawContentChangedType.LineChanged */ ;
        this.lineNumber = lineNumber;
        this.detail = detail;
        this.injectedText = injectedText;
    }
}
class ModelRawLinesDeleted {
    constructor(fromLineNumber, toLineNumber){
        this.changeType = 3 /* RawContentChangedType.LinesDeleted */ ;
        this.fromLineNumber = fromLineNumber;
        this.toLineNumber = toLineNumber;
    }
}
class ModelRawLinesInserted {
    constructor(fromLineNumber, toLineNumber, detail, injectedTexts){
        this.changeType = 4 /* RawContentChangedType.LinesInserted */ ;
        this.injectedTexts = injectedTexts;
        this.fromLineNumber = fromLineNumber;
        this.toLineNumber = toLineNumber;
        this.detail = detail;
    }
}
class ModelRawEOLChanged {
    constructor(){
        this.changeType = 5 /* RawContentChangedType.EOLChanged */ ;
    }
}
class ModelRawContentChangedEvent {
    constructor(changes, versionId, isUndoing, isRedoing){
        this.changes = changes;
        this.versionId = versionId;
        this.isUndoing = isUndoing;
        this.isRedoing = isRedoing;
        this.resultingSelection = null;
    }
    containsEvent(type) {
        for(let i = 0, len = this.changes.length; i < len; i++){
            const change = this.changes[i];
            if (change.changeType === type) return true;
        }
        return false;
    }
    static merge(a, b) {
        const changes = [].concat(a.changes).concat(b.changes);
        const versionId = b.versionId;
        const isUndoing = a.isUndoing || b.isUndoing;
        const isRedoing = a.isRedoing || b.isRedoing;
        return new ModelRawContentChangedEvent(changes, versionId, isUndoing, isRedoing);
    }
}
class ModelInjectedTextChangedEvent {
    constructor(changes){
        this.changes = changes;
    }
}
class InternalModelContentChangeEvent {
    constructor(rawContentChangedEvent, contentChangedEvent){
        this.rawContentChangedEvent = rawContentChangedEvent;
        this.contentChangedEvent = contentChangedEvent;
    }
    merge(other) {
        const rawContentChangedEvent = ModelRawContentChangedEvent.merge(this.rawContentChangedEvent, other.rawContentChangedEvent);
        const contentChangedEvent = InternalModelContentChangeEvent._mergeChangeEvents(this.contentChangedEvent, other.contentChangedEvent);
        return new InternalModelContentChangeEvent(rawContentChangedEvent, contentChangedEvent);
    }
    static _mergeChangeEvents(a, b) {
        const changes = [].concat(a.changes).concat(b.changes);
        const eol = b.eol;
        const versionId = b.versionId;
        const isUndoing = a.isUndoing || b.isUndoing;
        const isRedoing = a.isRedoing || b.isRedoing;
        const isFlush = a.isFlush || b.isFlush;
        const isEolChange = a.isEolChange && b.isEolChange; // both must be true to not confuse listeners who skip such edits
        return {
            changes: changes,
            eol: eol,
            isEolChange: isEolChange,
            versionId: versionId,
            isUndoing: isUndoing,
            isRedoing: isRedoing,
            isFlush: isFlush
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lLEaZ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandaloneQuickInputService", ()=>StandaloneQuickInputService);
parcelHelpers.export(exports, "QuickInputEditorContribution", ()=>QuickInputEditorContribution);
parcelHelpers.export(exports, "QuickInputEditorWidget", ()=>QuickInputEditorWidget);
var _standaloneQuickInputCss = require("./standaloneQuickInput.css");
var _eventJs = require("../../../../base/common/event.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _standaloneLayoutServiceJs = require("../standaloneLayoutService.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _quickInputServiceJs = require("../../../../platform/quickinput/browser/quickInputService.js");
var _functionalJs = require("../../../../base/common/functional.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let EditorScopedQuickInputService = class EditorScopedQuickInputService extends (0, _quickInputServiceJs.QuickInputService) {
    constructor(editor, instantiationService, contextKeyService, themeService, codeEditorService, configurationService){
        super(instantiationService, contextKeyService, themeService, new (0, _standaloneLayoutServiceJs.EditorScopedLayoutService)(editor.getContainerDomNode(), codeEditorService), configurationService);
        this.host = undefined;
        // Use the passed in code editor as host for the quick input widget
        const contribution = QuickInputEditorContribution.get(editor);
        if (contribution) {
            const widget = contribution.widget;
            this.host = {
                _serviceBrand: undefined,
                get mainContainer () {
                    return widget.getDomNode();
                },
                getContainer () {
                    return widget.getDomNode();
                },
                whenContainerStylesLoaded () {
                    return undefined;
                },
                get containers () {
                    return [
                        widget.getDomNode()
                    ];
                },
                get activeContainer () {
                    return widget.getDomNode();
                },
                get mainContainerDimension () {
                    return editor.getLayoutInfo();
                },
                get activeContainerDimension () {
                    return editor.getLayoutInfo();
                },
                get onDidLayoutMainContainer () {
                    return editor.onDidLayoutChange;
                },
                get onDidLayoutActiveContainer () {
                    return editor.onDidLayoutChange;
                },
                get onDidLayoutContainer () {
                    return (0, _eventJs.Event).map(editor.onDidLayoutChange, (dimension)=>({
                            container: widget.getDomNode(),
                            dimension
                        }));
                },
                get onDidChangeActiveContainer () {
                    return (0, _eventJs.Event).None;
                },
                get onDidAddContainer () {
                    return (0, _eventJs.Event).None;
                },
                get mainContainerOffset () {
                    return {
                        top: 0,
                        quickPickTop: 0
                    };
                },
                get activeContainerOffset () {
                    return {
                        top: 0,
                        quickPickTop: 0
                    };
                },
                focus: ()=>editor.focus()
            };
        } else this.host = undefined;
    }
    createController() {
        return super.createController(this.host);
    }
};
EditorScopedQuickInputService = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService)),
    __param(2, (0, _contextkeyJs.IContextKeyService)),
    __param(3, (0, _themeServiceJs.IThemeService)),
    __param(4, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(5, (0, _configurationJs.IConfigurationService))
], EditorScopedQuickInputService);
let StandaloneQuickInputService = class StandaloneQuickInputService {
    get activeService() {
        const editor = this.codeEditorService.getFocusedCodeEditor();
        if (!editor) throw new Error("Quick input service needs a focused editor to work.");
        // Find the quick input implementation for the focused
        // editor or create it lazily if not yet created
        let quickInputService = this.mapEditorToService.get(editor);
        if (!quickInputService) {
            const newQuickInputService = quickInputService = this.instantiationService.createInstance(EditorScopedQuickInputService, editor);
            this.mapEditorToService.set(editor, quickInputService);
            (0, _functionalJs.createSingleCallFunction)(editor.onDidDispose)(()=>{
                newQuickInputService.dispose();
                this.mapEditorToService.delete(editor);
            });
        }
        return quickInputService;
    }
    get currentQuickInput() {
        return this.activeService.currentQuickInput;
    }
    get quickAccess() {
        return this.activeService.quickAccess;
    }
    constructor(instantiationService, codeEditorService){
        this.instantiationService = instantiationService;
        this.codeEditorService = codeEditorService;
        this.mapEditorToService = new Map();
    }
    pick(picks, options, token = (0, _cancellationJs.CancellationToken).None) {
        return this.activeService /* TS fail */ .pick(picks, options, token);
    }
    createQuickPick(options = {
        useSeparators: false
    }) {
        return this.activeService.createQuickPick(options);
    }
    createInputBox() {
        return this.activeService.createInputBox();
    }
};
StandaloneQuickInputService = __decorate([
    __param(0, (0, _instantiationJs.IInstantiationService)),
    __param(1, (0, _codeEditorServiceJs.ICodeEditorService))
], StandaloneQuickInputService);
class QuickInputEditorContribution {
    static{
        this.ID = "editor.controller.quickInput";
    }
    static get(editor) {
        return editor.getContribution(QuickInputEditorContribution.ID);
    }
    constructor(editor){
        this.editor = editor;
        this.widget = new QuickInputEditorWidget(this.editor);
    }
    dispose() {
        this.widget.dispose();
    }
}
class QuickInputEditorWidget {
    static{
        this.ID = "editor.contrib.quickInputWidget";
    }
    constructor(codeEditor){
        this.codeEditor = codeEditor;
        this.domNode = document.createElement("div");
        this.codeEditor.addOverlayWidget(this);
    }
    getId() {
        return QuickInputEditorWidget.ID;
    }
    getDomNode() {
        return this.domNode;
    }
    getPosition() {
        return {
            preference: 2 /* OverlayWidgetPositionPreference.TOP_CENTER */ 
        };
    }
    dispose() {
        this.codeEditor.removeOverlayWidget(this);
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(QuickInputEditorContribution.ID, QuickInputEditorContribution, 4 /* EditorContributionInstantiation.Lazy */ );

},{"./standaloneQuickInput.css":"jChlq","../../../../base/common/event.js":"4Zi8b","../../../browser/editorExtensions.js":"kC3w6","../../../../platform/theme/common/themeService.js":"jMkIC","../../../../base/common/cancellation.js":"hoVxw","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../standaloneLayoutService.js":"c5sFD","../../../browser/services/codeEditorService.js":"bOWtl","../../../../platform/quickinput/browser/quickInputService.js":"9vJR9","../../../../base/common/functional.js":"75R2i","../../../../platform/configuration/common/configuration.js":"dXkjq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jChlq":[function() {},{}],"9vJR9":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuickInputService", ()=>QuickInputService);
var _cancellationJs = require("../../../base/common/cancellation.js");
var _eventJs = require("../../../base/common/event.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var _layoutServiceJs = require("../../layout/browser/layoutService.js");
var _openerJs = require("../../opener/common/opener.js");
var _quickAccessJs = require("./quickAccess.js");
var _defaultStylesJs = require("../../theme/browser/defaultStyles.js");
var _colorRegistryJs = require("../../theme/common/colorRegistry.js");
var _themeServiceJs = require("../../theme/common/themeService.js");
var _quickInputJs = require("./quickInput.js");
var _quickInputControllerJs = require("./quickInputController.js");
var _configurationJs = require("../../configuration/common/configuration.js");
var _domJs = require("../../../base/browser/dom.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let QuickInputService = class QuickInputService extends (0, _themeServiceJs.Themable) {
    get controller() {
        if (!this._controller) this._controller = this._register(this.createController());
        return this._controller;
    }
    get hasController() {
        return !!this._controller;
    }
    get currentQuickInput() {
        return this.controller.currentQuickInput;
    }
    get quickAccess() {
        if (!this._quickAccess) this._quickAccess = this._register(this.instantiationService.createInstance((0, _quickAccessJs.QuickAccessController)));
        return this._quickAccess;
    }
    constructor(instantiationService, contextKeyService, themeService, layoutService, configurationService){
        super(themeService);
        this.instantiationService = instantiationService;
        this.contextKeyService = contextKeyService;
        this.layoutService = layoutService;
        this.configurationService = configurationService;
        this._onShow = this._register(new (0, _eventJs.Emitter)());
        this._onHide = this._register(new (0, _eventJs.Emitter)());
        this.contexts = new Map();
    }
    createController(host = this.layoutService, options) {
        const defaultOptions = {
            idPrefix: "quickInput_",
            container: host.activeContainer,
            ignoreFocusOut: ()=>false,
            backKeybindingLabel: ()=>undefined,
            setContextKey: (id)=>this.setContextKey(id),
            linkOpenerDelegate: (content)=>{
                // HACK: https://github.com/microsoft/vscode/issues/173691
                this.instantiationService.invokeFunction((accessor)=>{
                    const openerService = accessor.get((0, _openerJs.IOpenerService));
                    openerService.open(content, {
                        allowCommands: true,
                        fromUserGesture: true
                    });
                });
            },
            returnFocus: ()=>host.focus(),
            styles: this.computeStyles(),
            hoverDelegate: this._register(this.instantiationService.createInstance((0, _quickInputJs.QuickInputHoverDelegate)))
        };
        const controller = this._register(this.instantiationService.createInstance((0, _quickInputControllerJs.QuickInputController), {
            ...defaultOptions,
            ...options
        }));
        controller.layout(host.activeContainerDimension, host.activeContainerOffset.quickPickTop);
        // Layout changes
        this._register(host.onDidLayoutActiveContainer((dimension)=>{
            if ((0, _domJs.getWindow)(host.activeContainer) === (0, _domJs.getWindow)(controller.container)) controller.layout(dimension, host.activeContainerOffset.quickPickTop);
        }));
        this._register(host.onDidChangeActiveContainer(()=>{
            if (controller.isVisible()) return;
            controller.layout(host.activeContainerDimension, host.activeContainerOffset.quickPickTop);
        }));
        // Context keys
        this._register(controller.onShow(()=>{
            this.resetContextKeys();
            this._onShow.fire();
        }));
        this._register(controller.onHide(()=>{
            this.resetContextKeys();
            this._onHide.fire();
        }));
        return controller;
    }
    setContextKey(id) {
        let key;
        if (id) {
            key = this.contexts.get(id);
            if (!key) {
                key = new (0, _contextkeyJs.RawContextKey)(id, false).bindTo(this.contextKeyService);
                this.contexts.set(id, key);
            }
        }
        if (key && key.get()) return; // already active context
        this.resetContextKeys();
        key?.set(true);
    }
    resetContextKeys() {
        this.contexts.forEach((context)=>{
            if (context.get()) context.reset();
        });
    }
    pick(picks, options, token = (0, _cancellationJs.CancellationToken).None) {
        return this.controller.pick(picks, options, token);
    }
    createQuickPick(options = {
        useSeparators: false
    }) {
        return this.controller.createQuickPick(options);
    }
    createInputBox() {
        return this.controller.createInputBox();
    }
    updateStyles() {
        if (this.hasController) this.controller.applyStyles(this.computeStyles());
    }
    computeStyles() {
        return {
            widget: {
                quickInputBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.quickInputBackground)),
                quickInputForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.quickInputForeground)),
                quickInputTitleBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.quickInputTitleBackground)),
                widgetBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.widgetBorder)),
                widgetShadow: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.widgetShadow))
            },
            inputBox: (0, _defaultStylesJs.defaultInputBoxStyles),
            toggle: (0, _defaultStylesJs.defaultToggleStyles),
            countBadge: (0, _defaultStylesJs.defaultCountBadgeStyles),
            button: (0, _defaultStylesJs.defaultButtonStyles),
            progressBar: (0, _defaultStylesJs.defaultProgressBarStyles),
            keybindingLabel: (0, _defaultStylesJs.defaultKeybindingLabelStyles),
            list: (0, _defaultStylesJs.getListStyles)({
                listBackground: (0, _colorRegistryJs.quickInputBackground),
                listFocusBackground: (0, _colorRegistryJs.quickInputListFocusBackground),
                listFocusForeground: (0, _colorRegistryJs.quickInputListFocusForeground),
                // Look like focused when inactive.
                listInactiveFocusForeground: (0, _colorRegistryJs.quickInputListFocusForeground),
                listInactiveSelectionIconForeground: (0, _colorRegistryJs.quickInputListFocusIconForeground),
                listInactiveFocusBackground: (0, _colorRegistryJs.quickInputListFocusBackground),
                listFocusOutline: (0, _colorRegistryJs.activeContrastBorder),
                listInactiveFocusOutline: (0, _colorRegistryJs.activeContrastBorder)
            }),
            pickerGroup: {
                pickerGroupBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.pickerGroupBorder)),
                pickerGroupForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.pickerGroupForeground))
            }
        };
    }
};
QuickInputService = __decorate([
    __param(0, (0, _instantiationJs.IInstantiationService)),
    __param(1, (0, _contextkeyJs.IContextKeyService)),
    __param(2, (0, _themeServiceJs.IThemeService)),
    __param(3, (0, _layoutServiceJs.ILayoutService)),
    __param(4, (0, _configurationJs.IConfigurationService))
], QuickInputService);

},{"../../../base/common/cancellation.js":"hoVxw","../../../base/common/event.js":"4Zi8b","../../contextkey/common/contextkey.js":"gXuBD","../../instantiation/common/instantiation.js":"fjwWx","../../layout/browser/layoutService.js":"fPPgf","../../opener/common/opener.js":"d3tj1","./quickAccess.js":"ebrgf","../../theme/browser/defaultStyles.js":"4exuA","../../theme/common/colorRegistry.js":"ik5kv","../../theme/common/themeService.js":"jMkIC","./quickInput.js":"bmHRs","./quickInputController.js":"44PZ8","../../configuration/common/configuration.js":"dXkjq","../../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ebrgf":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuickAccessController", ()=>QuickAccessController);
var _asyncJs = require("../../../base/common/async.js");
var _cancellationJs = require("../../../base/common/cancellation.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var _quickAccessJs = require("../common/quickAccess.js");
var _quickInputJs = require("../common/quickInput.js");
var _platformJs = require("../../registry/common/platform.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let QuickAccessController = class QuickAccessController extends (0, _lifecycleJs.Disposable) {
    constructor(quickInputService, instantiationService){
        super();
        this.quickInputService = quickInputService;
        this.instantiationService = instantiationService;
        this.registry = (0, _platformJs.Registry).as((0, _quickAccessJs.Extensions).Quickaccess);
        this.mapProviderToDescriptor = new Map();
        this.lastAcceptedPickerValues = new Map();
        this.visibleQuickAccess = undefined;
    }
    show(value = "", options) {
        this.doShowOrPick(value, false, options);
    }
    doShowOrPick(value, pick, options) {
        // Find provider for the value to show
        const [provider, descriptor] = this.getOrInstantiateProvider(value, options?.enabledProviderPrefixes);
        // Return early if quick access is already showing on that same prefix
        const visibleQuickAccess = this.visibleQuickAccess;
        const visibleDescriptor = visibleQuickAccess?.descriptor;
        if (visibleQuickAccess && descriptor && visibleDescriptor === descriptor) {
            // Apply value only if it is more specific than the prefix
            // from the provider and we are not instructed to preserve
            if (value !== descriptor.prefix && !options?.preserveValue) visibleQuickAccess.picker.value = value;
            // Always adjust selection
            this.adjustValueSelection(visibleQuickAccess.picker, descriptor, options);
            return;
        }
        // Rewrite the filter value based on certain rules unless disabled
        if (descriptor && !options?.preserveValue) {
            let newValue = undefined;
            // If we have a visible provider with a value, take it's filter value but
            // rewrite to new provider prefix in case they differ
            if (visibleQuickAccess && visibleDescriptor && visibleDescriptor !== descriptor) {
                const newValueCandidateWithoutPrefix = visibleQuickAccess.value.substr(visibleDescriptor.prefix.length);
                if (newValueCandidateWithoutPrefix) newValue = `${descriptor.prefix}${newValueCandidateWithoutPrefix}`;
            }
            // Otherwise, take a default value as instructed
            if (!newValue) {
                const defaultFilterValue = provider?.defaultFilterValue;
                if (defaultFilterValue === (0, _quickAccessJs.DefaultQuickAccessFilterValue).LAST) newValue = this.lastAcceptedPickerValues.get(descriptor);
                else if (typeof defaultFilterValue === "string") newValue = `${descriptor.prefix}${defaultFilterValue}`;
            }
            if (typeof newValue === "string") value = newValue;
        }
        // Store the existing selection if there was one.
        const visibleSelection = visibleQuickAccess?.picker?.valueSelection;
        const visibleValue = visibleQuickAccess?.picker?.value;
        // Create a picker for the provider to use with the initial value
        // and adjust the filtering to exclude the prefix from filtering
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        const picker = disposables.add(this.quickInputService.createQuickPick({
            useSeparators: true
        }));
        picker.value = value;
        this.adjustValueSelection(picker, descriptor, options);
        picker.placeholder = options?.placeholder ?? descriptor?.placeholder;
        picker.quickNavigate = options?.quickNavigateConfiguration;
        picker.hideInput = !!picker.quickNavigate && !visibleQuickAccess; // only hide input if there was no picker opened already
        if (typeof options?.itemActivation === "number" || options?.quickNavigateConfiguration) picker.itemActivation = options?.itemActivation ?? (0, _quickInputJs.ItemActivation).SECOND /* quick nav is always second */ ;
        picker.contextKey = descriptor?.contextKey;
        picker.filterValue = (value)=>value.substring(descriptor ? descriptor.prefix.length : 0);
        // Pick mode: setup a promise that can be resolved
        // with the selected items and prevent execution
        let pickPromise = undefined;
        if (pick) {
            pickPromise = new (0, _asyncJs.DeferredPromise)();
            disposables.add((0, _eventJs.Event).once(picker.onWillAccept)((e)=>{
                e.veto();
                picker.hide();
            }));
        }
        // Register listeners
        disposables.add(this.registerPickerListeners(picker, provider, descriptor, value, options));
        // Ask provider to fill the picker as needed if we have one
        // and pass over a cancellation token that will indicate when
        // the picker is hiding without a pick being made.
        const cts = disposables.add(new (0, _cancellationJs.CancellationTokenSource)());
        if (provider) disposables.add(provider.provide(picker, cts.token, options?.providerOptions));
        // Finally, trigger disposal and cancellation when the picker
        // hides depending on items selected or not.
        (0, _eventJs.Event).once(picker.onDidHide)(()=>{
            if (picker.selectedItems.length === 0) cts.cancel();
            // Start to dispose once picker hides
            disposables.dispose();
            // Resolve pick promise with selected items
            pickPromise?.complete(picker.selectedItems.slice(0));
        });
        // Finally, show the picker. This is important because a provider
        // may not call this and then our disposables would leak that rely
        // on the onDidHide event.
        picker.show();
        // If the previous picker had a selection and the value is unchanged, we should set that in the new picker.
        if (visibleSelection && visibleValue === value) picker.valueSelection = visibleSelection;
        // Pick mode: return with promise
        if (pick) return pickPromise?.p;
    }
    adjustValueSelection(picker, descriptor, options) {
        let valueSelection;
        // Preserve: just always put the cursor at the end
        if (options?.preserveValue) valueSelection = [
            picker.value.length,
            picker.value.length
        ];
        else valueSelection = [
            descriptor?.prefix.length ?? 0,
            picker.value.length
        ];
        picker.valueSelection = valueSelection;
    }
    registerPickerListeners(picker, provider, descriptor, value, options) {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        // Remember as last visible picker and clean up once picker get's disposed
        const visibleQuickAccess = this.visibleQuickAccess = {
            picker,
            descriptor,
            value
        };
        disposables.add((0, _lifecycleJs.toDisposable)(()=>{
            if (visibleQuickAccess === this.visibleQuickAccess) this.visibleQuickAccess = undefined;
        }));
        // Whenever the value changes, check if the provider has
        // changed and if so - re-create the picker from the beginning
        disposables.add(picker.onDidChangeValue((value)=>{
            const [providerForValue] = this.getOrInstantiateProvider(value, options?.enabledProviderPrefixes);
            if (providerForValue !== provider) this.show(value, {
                enabledProviderPrefixes: options?.enabledProviderPrefixes,
                // do not rewrite value from user typing!
                preserveValue: true,
                // persist the value of the providerOptions from the original showing
                providerOptions: options?.providerOptions
            });
            else visibleQuickAccess.value = value; // remember the value in our visible one
        }));
        // Remember picker input for future use when accepting
        if (descriptor) disposables.add(picker.onDidAccept(()=>{
            this.lastAcceptedPickerValues.set(descriptor, picker.value);
        }));
        return disposables;
    }
    getOrInstantiateProvider(value, enabledProviderPrefixes) {
        const providerDescriptor = this.registry.getQuickAccessProvider(value);
        if (!providerDescriptor || enabledProviderPrefixes && !enabledProviderPrefixes?.includes(providerDescriptor.prefix)) return [
            undefined,
            undefined
        ];
        let provider = this.mapProviderToDescriptor.get(providerDescriptor);
        if (!provider) {
            provider = this.instantiationService.createInstance(providerDescriptor.ctor);
            this.mapProviderToDescriptor.set(providerDescriptor, provider);
        }
        return [
            provider,
            providerDescriptor
        ];
    }
};
QuickAccessController = __decorate([
    __param(0, (0, _quickInputJs.IQuickInputService)),
    __param(1, (0, _instantiationJs.IInstantiationService))
], QuickAccessController);

},{"../../../base/common/async.js":"4GJc4","../../../base/common/cancellation.js":"hoVxw","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../instantiation/common/instantiation.js":"fjwWx","../common/quickAccess.js":"k9EM7","../common/quickInput.js":"a56M6","../../registry/common/platform.js":"dzx11","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k9EM7":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultQuickAccessFilterValue", ()=>DefaultQuickAccessFilterValue);
parcelHelpers.export(exports, "Extensions", ()=>Extensions);
parcelHelpers.export(exports, "QuickAccessRegistry", ()=>QuickAccessRegistry);
var _arraysJs = require("../../../base/common/arrays.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _platformJs = require("../../registry/common/platform.js");
var DefaultQuickAccessFilterValue;
(function(DefaultQuickAccessFilterValue) {
    /**
     * Keep the value as it is given to quick access.
     */ DefaultQuickAccessFilterValue[DefaultQuickAccessFilterValue["PRESERVE"] = 0] = "PRESERVE";
    /**
     * Use the value that was used last time something was accepted from the picker.
     */ DefaultQuickAccessFilterValue[DefaultQuickAccessFilterValue["LAST"] = 1] = "LAST";
})(DefaultQuickAccessFilterValue || (DefaultQuickAccessFilterValue = {}));
const Extensions = {
    Quickaccess: "workbench.contributions.quickaccess"
};
class QuickAccessRegistry {
    constructor(){
        this.providers = [];
        this.defaultProvider = undefined;
    }
    registerQuickAccessProvider(provider) {
        // Extract the default provider when no prefix is present
        if (provider.prefix.length === 0) this.defaultProvider = provider;
        else this.providers.push(provider);
        // sort the providers by decreasing prefix length, such that longer
        // prefixes take priority: 'ext' vs 'ext install' - the latter should win
        this.providers.sort((providerA, providerB)=>providerB.prefix.length - providerA.prefix.length);
        return (0, _lifecycleJs.toDisposable)(()=>{
            this.providers.splice(this.providers.indexOf(provider), 1);
            if (this.defaultProvider === provider) this.defaultProvider = undefined;
        });
    }
    getQuickAccessProviders() {
        return (0, _arraysJs.coalesce)([
            this.defaultProvider,
            ...this.providers
        ]);
    }
    getQuickAccessProvider(prefix) {
        const result = prefix ? this.providers.find((provider)=>prefix.startsWith(provider.prefix)) || undefined : undefined;
        return result || this.defaultProvider;
    }
}
(0, _platformJs.Registry).add(Extensions.Quickaccess, new QuickAccessRegistry());

},{"../../../base/common/arrays.js":"DECei","../../../base/common/lifecycle.js":"9kg8d","../../registry/common/platform.js":"dzx11","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a56M6":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NO_KEY_MODS", ()=>NO_KEY_MODS);
parcelHelpers.export(exports, "QuickInputHideReason", ()=>QuickInputHideReason);
parcelHelpers.export(exports, "ItemActivation", ()=>ItemActivation);
parcelHelpers.export(exports, "QuickPickFocus", ()=>QuickPickFocus);
parcelHelpers.export(exports, "QuickInputButtonLocation", ()=>QuickInputButtonLocation);
parcelHelpers.export(exports, "QuickPickItemScorerAccessor", ()=>QuickPickItemScorerAccessor);
parcelHelpers.export(exports, "quickPickItemScorerAccessor", ()=>quickPickItemScorerAccessor);
parcelHelpers.export(exports, "IQuickInputService", ()=>IQuickInputService);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const NO_KEY_MODS = {
    ctrlCmd: false,
    alt: false
};
var QuickInputHideReason;
(function(QuickInputHideReason) {
    /**
     * Focus moved away from the quick input.
     */ QuickInputHideReason[QuickInputHideReason["Blur"] = 1] = "Blur";
    /**
     * An explicit user gesture, e.g. pressing Escape key.
     */ QuickInputHideReason[QuickInputHideReason["Gesture"] = 2] = "Gesture";
    /**
     * Anything else.
     */ QuickInputHideReason[QuickInputHideReason["Other"] = 3] = "Other";
})(QuickInputHideReason || (QuickInputHideReason = {}));
var ItemActivation;
(function(ItemActivation) {
    /**
     * No item will be active.
     */ ItemActivation[ItemActivation["NONE"] = 0] = "NONE";
    /**
     * First item will be active.
     */ ItemActivation[ItemActivation["FIRST"] = 1] = "FIRST";
    /**
     * Second item will be active.
     */ ItemActivation[ItemActivation["SECOND"] = 2] = "SECOND";
    /**
     * Last item will be active.
     */ ItemActivation[ItemActivation["LAST"] = 3] = "LAST";
})(ItemActivation || (ItemActivation = {}));
var QuickPickFocus;
(function(QuickPickFocus) {
    /**
     * Focus the first item in the list.
     */ QuickPickFocus[QuickPickFocus["First"] = 1] = "First";
    /**
     * Focus the second item in the list.
     */ QuickPickFocus[QuickPickFocus["Second"] = 2] = "Second";
    /**
     * Focus the last item in the list.
     */ QuickPickFocus[QuickPickFocus["Last"] = 3] = "Last";
    /**
     * Focus the next item in the list.
     */ QuickPickFocus[QuickPickFocus["Next"] = 4] = "Next";
    /**
     * Focus the previous item in the list.
     */ QuickPickFocus[QuickPickFocus["Previous"] = 5] = "Previous";
    /**
     * Focus the next page in the list.
     */ QuickPickFocus[QuickPickFocus["NextPage"] = 6] = "NextPage";
    /**
     * Focus the previous page in the list.
     */ QuickPickFocus[QuickPickFocus["PreviousPage"] = 7] = "PreviousPage";
    /**
     * Focus the first item under the next separator.
     */ QuickPickFocus[QuickPickFocus["NextSeparator"] = 8] = "NextSeparator";
    /**
     * Focus the first item under the current separator.
     */ QuickPickFocus[QuickPickFocus["PreviousSeparator"] = 9] = "PreviousSeparator";
})(QuickPickFocus || (QuickPickFocus = {}));
var QuickInputButtonLocation;
(function(QuickInputButtonLocation) {
    /**
     * In the title bar.
     */ QuickInputButtonLocation[QuickInputButtonLocation["Title"] = 1] = "Title";
    /**
     * To the right of the input box.
     */ QuickInputButtonLocation[QuickInputButtonLocation["Inline"] = 2] = "Inline";
})(QuickInputButtonLocation || (QuickInputButtonLocation = {}));
class QuickPickItemScorerAccessor {
    constructor(options){
        this.options = options;
    }
}
const quickPickItemScorerAccessor = new QuickPickItemScorerAccessor();
const IQuickInputService = (0, _instantiationJs.createDecorator)("quickInputService");

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bmHRs":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inQuickInputContextKeyValue", ()=>inQuickInputContextKeyValue);
parcelHelpers.export(exports, "InQuickInputContextKey", ()=>InQuickInputContextKey);
parcelHelpers.export(exports, "inQuickInputContext", ()=>inQuickInputContext);
parcelHelpers.export(exports, "quickInputTypeContextKeyValue", ()=>quickInputTypeContextKeyValue);
parcelHelpers.export(exports, "QuickInputTypeContextKey", ()=>QuickInputTypeContextKey);
parcelHelpers.export(exports, "endOfQuickInputBoxContextKeyValue", ()=>endOfQuickInputBoxContextKeyValue);
parcelHelpers.export(exports, "EndOfQuickInputBoxContextKey", ()=>EndOfQuickInputBoxContextKey);
parcelHelpers.export(exports, "endOfQuickInputBoxContext", ()=>endOfQuickInputBoxContext);
parcelHelpers.export(exports, "backButton", ()=>backButton);
parcelHelpers.export(exports, "QuickPick", ()=>QuickPick);
parcelHelpers.export(exports, "InputBox", ()=>InputBox);
parcelHelpers.export(exports, "QuickInputHoverDelegate", ()=>QuickInputHoverDelegate);
var _domJs = require("../../../base/browser/dom.js");
var _keyboardEventJs = require("../../../base/browser/keyboardEvent.js");
var _toggleJs = require("../../../base/browser/ui/toggle/toggle.js");
var _arraysJs = require("../../../base/common/arrays.js");
var _asyncJs = require("../../../base/common/async.js");
var _codiconsJs = require("../../../base/common/codicons.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _platformJs = require("../../../base/common/platform.js");
var _severityJs = require("../../../base/common/severity.js");
var _severityJsDefault = parcelHelpers.interopDefault(_severityJs);
var _themablesJs = require("../../../base/common/themables.js");
var _quickInputCss = require("./media/quickInput.css");
var _nlsJs = require("../../../nls.js");
var _quickInputJs = require("../common/quickInput.js");
var _quickInputUtilsJs = require("./quickInputUtils.js");
var _configurationJs = require("../../configuration/common/configuration.js");
var _hoverJs = require("../../hover/browser/hover.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const inQuickInputContextKeyValue = "inQuickInput";
const InQuickInputContextKey = new (0, _contextkeyJs.RawContextKey)(inQuickInputContextKeyValue, false, (0, _nlsJs.localize)("inQuickInput", "Whether keyboard focus is inside the quick input control"));
const inQuickInputContext = (0, _contextkeyJs.ContextKeyExpr).has(inQuickInputContextKeyValue);
const quickInputTypeContextKeyValue = "quickInputType";
const QuickInputTypeContextKey = new (0, _contextkeyJs.RawContextKey)(quickInputTypeContextKeyValue, undefined, (0, _nlsJs.localize)("quickInputType", "The type of the currently visible quick input"));
const endOfQuickInputBoxContextKeyValue = "cursorAtEndOfQuickInputBox";
const EndOfQuickInputBoxContextKey = new (0, _contextkeyJs.RawContextKey)(endOfQuickInputBoxContextKeyValue, false, (0, _nlsJs.localize)("cursorAtEndOfQuickInputBox", "Whether the cursor in the quick input is at the end of the input box"));
const endOfQuickInputBoxContext = (0, _contextkeyJs.ContextKeyExpr).has(endOfQuickInputBoxContextKeyValue);
const backButton = {
    iconClass: (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).quickInputBack),
    tooltip: (0, _nlsJs.localize)("quickInput.back", "Back"),
    handle: -1 // TODO
};
class QuickInput extends (0, _lifecycleJs.Disposable) {
    static{
        this.noPromptMessage = (0, _nlsJs.localize)("inputModeEntry", "Press 'Enter' to confirm your input or 'Escape' to cancel");
    }
    constructor(ui){
        super();
        this.ui = ui;
        this._widgetUpdated = false;
        this.visible = false;
        this._enabled = true;
        this._busy = false;
        this._ignoreFocusOut = false;
        this._leftButtons = [];
        this._rightButtons = [];
        this._inlineButtons = [];
        this.buttonsUpdated = false;
        this._toggles = [];
        this.togglesUpdated = false;
        this.noValidationMessage = QuickInput.noPromptMessage;
        this._severity = (0, _severityJsDefault.default).Ignore;
        this.onDidTriggerButtonEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onDidHideEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onWillHideEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onDisposeEmitter = this._register(new (0, _eventJs.Emitter)());
        this.visibleDisposables = this._register(new (0, _lifecycleJs.DisposableStore)());
        this.onDidHide = this.onDidHideEmitter.event;
    }
    get title() {
        return this._title;
    }
    set title(title) {
        this._title = title;
        this.update();
    }
    get description() {
        return this._description;
    }
    set description(description) {
        this._description = description;
        this.update();
    }
    get step() {
        return this._steps;
    }
    set step(step) {
        this._steps = step;
        this.update();
    }
    get totalSteps() {
        return this._totalSteps;
    }
    set totalSteps(totalSteps) {
        this._totalSteps = totalSteps;
        this.update();
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(enabled) {
        this._enabled = enabled;
        this.update();
    }
    get contextKey() {
        return this._contextKey;
    }
    set contextKey(contextKey) {
        this._contextKey = contextKey;
        this.update();
    }
    get busy() {
        return this._busy;
    }
    set busy(busy) {
        this._busy = busy;
        this.update();
    }
    get ignoreFocusOut() {
        return this._ignoreFocusOut;
    }
    set ignoreFocusOut(ignoreFocusOut) {
        const shouldUpdate = this._ignoreFocusOut !== ignoreFocusOut && !(0, _platformJs.isIOS);
        this._ignoreFocusOut = ignoreFocusOut && !(0, _platformJs.isIOS);
        if (shouldUpdate) this.update();
    }
    get titleButtons() {
        return this._leftButtons.length ? [
            ...this._leftButtons,
            this._rightButtons
        ] : this._rightButtons;
    }
    get buttons() {
        return [
            ...this._leftButtons,
            ...this._rightButtons,
            ...this._inlineButtons
        ];
    }
    set buttons(buttons) {
        this._leftButtons = buttons.filter((b)=>b === backButton);
        this._rightButtons = buttons.filter((b)=>b !== backButton && b.location !== (0, _quickInputJs.QuickInputButtonLocation).Inline);
        this._inlineButtons = buttons.filter((b)=>b.location === (0, _quickInputJs.QuickInputButtonLocation).Inline);
        this.buttonsUpdated = true;
        this.update();
    }
    get toggles() {
        return this._toggles;
    }
    set toggles(toggles) {
        this._toggles = toggles ?? [];
        this.togglesUpdated = true;
        this.update();
    }
    get validationMessage() {
        return this._validationMessage;
    }
    set validationMessage(validationMessage) {
        this._validationMessage = validationMessage;
        this.update();
    }
    get severity() {
        return this._severity;
    }
    set severity(severity) {
        this._severity = severity;
        this.update();
    }
    show() {
        if (this.visible) return;
        this.visibleDisposables.add(this.ui.onDidTriggerButton((button)=>{
            if (this.buttons.indexOf(button) !== -1) this.onDidTriggerButtonEmitter.fire(button);
        }));
        this.ui.show(this);
        // update properties in the controller that get reset in the ui.show() call
        this.visible = true;
        // This ensures the message/prompt gets rendered
        this._lastValidationMessage = undefined;
        // This ensures the input box has the right severity applied
        this._lastSeverity = undefined;
        if (this.buttons.length) // if there are buttons, the ui.show() clears them out of the UI so we should
        // rerender them.
        this.buttonsUpdated = true;
        if (this.toggles.length) // if there are toggles, the ui.show() clears them out of the UI so we should
        // rerender them.
        this.togglesUpdated = true;
        this.update();
    }
    hide() {
        if (!this.visible) return;
        this.ui.hide();
    }
    didHide(reason = (0, _quickInputJs.QuickInputHideReason).Other) {
        this.visible = false;
        this.visibleDisposables.clear();
        this.onDidHideEmitter.fire({
            reason
        });
    }
    willHide(reason = (0, _quickInputJs.QuickInputHideReason).Other) {
        this.onWillHideEmitter.fire({
            reason
        });
    }
    update() {
        if (!this.visible) return;
        const title = this.getTitle();
        if (title && this.ui.title.textContent !== title) this.ui.title.textContent = title;
        else if (!title && this.ui.title.innerHTML !== "&nbsp;") this.ui.title.innerText = "\xa0";
        const description = this.getDescription();
        if (this.ui.description1.textContent !== description) this.ui.description1.textContent = description;
        if (this.ui.description2.textContent !== description) this.ui.description2.textContent = description;
        if (this._widgetUpdated) {
            this._widgetUpdated = false;
            if (this._widget) _domJs.reset(this.ui.widget, this._widget);
            else _domJs.reset(this.ui.widget);
        }
        if (this.busy && !this.busyDelay) {
            this.busyDelay = new (0, _asyncJs.TimeoutTimer)();
            this.busyDelay.setIfNotSet(()=>{
                if (this.visible) this.ui.progressBar.infinite();
            }, 800);
        }
        if (!this.busy && this.busyDelay) {
            this.ui.progressBar.stop();
            this.busyDelay.cancel();
            this.busyDelay = undefined;
        }
        if (this.buttonsUpdated) {
            this.buttonsUpdated = false;
            this.ui.leftActionBar.clear();
            const leftButtons = this._leftButtons.map((button, index)=>(0, _quickInputUtilsJs.quickInputButtonToAction)(button, `id-${index}`, async ()=>this.onDidTriggerButtonEmitter.fire(button)));
            this.ui.leftActionBar.push(leftButtons, {
                icon: true,
                label: false
            });
            this.ui.rightActionBar.clear();
            const rightButtons = this._rightButtons.map((button, index)=>(0, _quickInputUtilsJs.quickInputButtonToAction)(button, `id-${index}`, async ()=>this.onDidTriggerButtonEmitter.fire(button)));
            this.ui.rightActionBar.push(rightButtons, {
                icon: true,
                label: false
            });
            this.ui.inlineActionBar.clear();
            const inlineButtons = this._inlineButtons.map((button, index)=>(0, _quickInputUtilsJs.quickInputButtonToAction)(button, `id-${index}`, async ()=>this.onDidTriggerButtonEmitter.fire(button)));
            this.ui.inlineActionBar.push(inlineButtons, {
                icon: true,
                label: false
            });
        }
        if (this.togglesUpdated) {
            this.togglesUpdated = false;
            // HACK: Filter out toggles here that are not concrete Toggle objects. This is to workaround
            // a layering issue as quick input's interface is in common but Toggle is in browser and
            // it requires a HTMLElement on its interface
            const concreteToggles = this.toggles?.filter((opts)=>opts instanceof (0, _toggleJs.Toggle)) ?? [];
            this.ui.inputBox.toggles = concreteToggles;
        }
        this.ui.ignoreFocusOut = this.ignoreFocusOut;
        this.ui.setEnabled(this.enabled);
        this.ui.setContextKey(this.contextKey);
        const validationMessage = this.validationMessage || this.noValidationMessage;
        if (this._lastValidationMessage !== validationMessage) {
            this._lastValidationMessage = validationMessage;
            _domJs.reset(this.ui.message);
            (0, _quickInputUtilsJs.renderQuickInputDescription)(validationMessage, this.ui.message, {
                callback: (content)=>{
                    this.ui.linkOpenerDelegate(content);
                },
                disposables: this.visibleDisposables
            });
        }
        if (this._lastSeverity !== this.severity) {
            this._lastSeverity = this.severity;
            this.showMessageDecoration(this.severity);
        }
    }
    getTitle() {
        if (this.title && this.step) return `${this.title} (${this.getSteps()})`;
        if (this.title) return this.title;
        if (this.step) return this.getSteps();
        return "";
    }
    getDescription() {
        return this.description || "";
    }
    getSteps() {
        if (this.step && this.totalSteps) return (0, _nlsJs.localize)("quickInput.steps", "{0}/{1}", this.step, this.totalSteps);
        if (this.step) return String(this.step);
        return "";
    }
    showMessageDecoration(severity) {
        this.ui.inputBox.showDecoration(severity);
        if (severity !== (0, _severityJsDefault.default).Ignore) {
            const styles = this.ui.inputBox.stylesForType(severity);
            this.ui.message.style.color = styles.foreground ? `${styles.foreground}` : "";
            this.ui.message.style.backgroundColor = styles.background ? `${styles.background}` : "";
            this.ui.message.style.border = styles.border ? `1px solid ${styles.border}` : "";
            this.ui.message.style.marginBottom = "-2px";
        } else {
            this.ui.message.style.color = "";
            this.ui.message.style.backgroundColor = "";
            this.ui.message.style.border = "";
            this.ui.message.style.marginBottom = "";
        }
    }
    dispose() {
        this.hide();
        this.onDisposeEmitter.fire();
        super.dispose();
    }
}
class QuickPick extends QuickInput {
    constructor(){
        super(...arguments);
        this._value = "";
        this.onDidChangeValueEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onWillAcceptEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onDidAcceptEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onDidCustomEmitter = this._register(new (0, _eventJs.Emitter)());
        this._items = [];
        this.itemsUpdated = false;
        this._canSelectMany = false;
        this._canAcceptInBackground = false;
        this._matchOnDescription = false;
        this._matchOnDetail = false;
        this._matchOnLabel = true;
        this._matchOnLabelMode = "fuzzy";
        this._sortByLabel = true;
        this._keepScrollPosition = false;
        this._itemActivation = (0, _quickInputJs.ItemActivation).FIRST;
        this._activeItems = [];
        this.activeItemsUpdated = false;
        this.activeItemsToConfirm = [];
        this.onDidChangeActiveEmitter = this._register(new (0, _eventJs.Emitter)());
        this._selectedItems = [];
        this.selectedItemsUpdated = false;
        this.selectedItemsToConfirm = [];
        this.onDidChangeSelectionEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onDidTriggerItemButtonEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onDidTriggerSeparatorButtonEmitter = this._register(new (0, _eventJs.Emitter)());
        this.valueSelectionUpdated = true;
        this._ok = "default";
        this._customButton = false;
        this._focusEventBufferer = new (0, _eventJs.EventBufferer)();
        this.type = "quickPick" /* QuickInputType.QuickPick */ ;
        this.filterValue = (value)=>value;
        this.onDidChangeValue = this.onDidChangeValueEmitter.event;
        this.onWillAccept = this.onWillAcceptEmitter.event;
        this.onDidAccept = this.onDidAcceptEmitter.event;
        this.onDidChangeActive = this.onDidChangeActiveEmitter.event;
        this.onDidChangeSelection = this.onDidChangeSelectionEmitter.event;
        this.onDidTriggerItemButton = this.onDidTriggerItemButtonEmitter.event;
        this.onDidTriggerSeparatorButton = this.onDidTriggerSeparatorButtonEmitter.event;
    }
    static{
        this.DEFAULT_ARIA_LABEL = (0, _nlsJs.localize)("quickInputBox.ariaLabel", "Type to narrow down results.");
    }
    get quickNavigate() {
        return this._quickNavigate;
    }
    set quickNavigate(quickNavigate) {
        this._quickNavigate = quickNavigate;
        this.update();
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this.doSetValue(value);
    }
    doSetValue(value, skipUpdate) {
        if (this._value !== value) {
            this._value = value;
            if (!skipUpdate) this.update();
            if (this.visible) {
                const didFilter = this.ui.list.filter(this.filterValue(this._value));
                if (didFilter) this.trySelectFirst();
            }
            this.onDidChangeValueEmitter.fire(this._value);
        }
    }
    set ariaLabel(ariaLabel) {
        this._ariaLabel = ariaLabel;
        this.update();
    }
    get ariaLabel() {
        return this._ariaLabel;
    }
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(placeholder) {
        this._placeholder = placeholder;
        this.update();
    }
    get items() {
        return this._items;
    }
    get scrollTop() {
        return this.ui.list.scrollTop;
    }
    set scrollTop(scrollTop) {
        this.ui.list.scrollTop = scrollTop;
    }
    set items(items) {
        this._items = items;
        this.itemsUpdated = true;
        this.update();
    }
    get canSelectMany() {
        return this._canSelectMany;
    }
    set canSelectMany(canSelectMany) {
        this._canSelectMany = canSelectMany;
        this.update();
    }
    get canAcceptInBackground() {
        return this._canAcceptInBackground;
    }
    set canAcceptInBackground(canAcceptInBackground) {
        this._canAcceptInBackground = canAcceptInBackground;
    }
    get matchOnDescription() {
        return this._matchOnDescription;
    }
    set matchOnDescription(matchOnDescription) {
        this._matchOnDescription = matchOnDescription;
        this.update();
    }
    get matchOnDetail() {
        return this._matchOnDetail;
    }
    set matchOnDetail(matchOnDetail) {
        this._matchOnDetail = matchOnDetail;
        this.update();
    }
    get matchOnLabel() {
        return this._matchOnLabel;
    }
    set matchOnLabel(matchOnLabel) {
        this._matchOnLabel = matchOnLabel;
        this.update();
    }
    get matchOnLabelMode() {
        return this._matchOnLabelMode;
    }
    set matchOnLabelMode(matchOnLabelMode) {
        this._matchOnLabelMode = matchOnLabelMode;
        this.update();
    }
    get sortByLabel() {
        return this._sortByLabel;
    }
    set sortByLabel(sortByLabel) {
        this._sortByLabel = sortByLabel;
        this.update();
    }
    get keepScrollPosition() {
        return this._keepScrollPosition;
    }
    set keepScrollPosition(keepScrollPosition) {
        this._keepScrollPosition = keepScrollPosition;
    }
    get itemActivation() {
        return this._itemActivation;
    }
    set itemActivation(itemActivation) {
        this._itemActivation = itemActivation;
    }
    get activeItems() {
        return this._activeItems;
    }
    set activeItems(activeItems) {
        this._activeItems = activeItems;
        this.activeItemsUpdated = true;
        this.update();
    }
    get selectedItems() {
        return this._selectedItems;
    }
    set selectedItems(selectedItems) {
        this._selectedItems = selectedItems;
        this.selectedItemsUpdated = true;
        this.update();
    }
    get keyMods() {
        if (this._quickNavigate) // Disable keyMods when quick navigate is enabled
        // because in this model the interaction is purely
        // keyboard driven and Ctrl/Alt are typically
        // pressed and hold during this interaction.
        return 0, _quickInputJs.NO_KEY_MODS;
        return this.ui.keyMods;
    }
    get valueSelection() {
        const selection = this.ui.inputBox.getSelection();
        if (!selection) return undefined;
        return [
            selection.start,
            selection.end
        ];
    }
    set valueSelection(valueSelection) {
        this._valueSelection = valueSelection;
        this.valueSelectionUpdated = true;
        this.update();
    }
    get customButton() {
        return this._customButton;
    }
    set customButton(showCustomButton) {
        this._customButton = showCustomButton;
        this.update();
    }
    get customLabel() {
        return this._customButtonLabel;
    }
    set customLabel(label) {
        this._customButtonLabel = label;
        this.update();
    }
    get customHover() {
        return this._customButtonHover;
    }
    set customHover(hover) {
        this._customButtonHover = hover;
        this.update();
    }
    get ok() {
        return this._ok;
    }
    set ok(showOkButton) {
        this._ok = showOkButton;
        this.update();
    }
    get hideInput() {
        return !!this._hideInput;
    }
    set hideInput(hideInput) {
        this._hideInput = hideInput;
        this.update();
    }
    trySelectFirst() {
        if (!this.canSelectMany) this.ui.list.focus((0, _quickInputJs.QuickPickFocus).First);
    }
    show() {
        if (!this.visible) {
            this.visibleDisposables.add(this.ui.inputBox.onDidChange((value)=>{
                this.doSetValue(value, true);
            }));
            this.visibleDisposables.add(this.ui.onDidAccept(()=>{
                if (this.canSelectMany) // if there are no checked elements, it means that an onDidChangeSelection never fired to overwrite
                // `_selectedItems`. In that case, we should emit one with an empty array to ensure that
                // `.selectedItems` is up to date.
                {
                    if (!this.ui.list.getCheckedElements().length) {
                        this._selectedItems = [];
                        this.onDidChangeSelectionEmitter.fire(this.selectedItems);
                    }
                } else if (this.activeItems[0]) {
                    // For single-select, we set `selectedItems` to the item that was accepted.
                    this._selectedItems = [
                        this.activeItems[0]
                    ];
                    this.onDidChangeSelectionEmitter.fire(this.selectedItems);
                }
                this.handleAccept(false);
            }));
            this.visibleDisposables.add(this.ui.onDidCustom(()=>{
                this.onDidCustomEmitter.fire();
            }));
            this.visibleDisposables.add(this._focusEventBufferer.wrapEvent(this.ui.list.onDidChangeFocus, // Only fire the last event
            (_, e)=>e)((focusedItems)=>{
                if (this.activeItemsUpdated) return; // Expect another event.
                if (this.activeItemsToConfirm !== this._activeItems && (0, _arraysJs.equals)(focusedItems, this._activeItems, (a, b)=>a === b)) return;
                this._activeItems = focusedItems;
                this.onDidChangeActiveEmitter.fire(focusedItems);
            }));
            this.visibleDisposables.add(this.ui.list.onDidChangeSelection(({ items: selectedItems, event })=>{
                if (this.canSelectMany) {
                    if (selectedItems.length) this.ui.list.setSelectedElements([]);
                    return;
                }
                if (this.selectedItemsToConfirm !== this._selectedItems && (0, _arraysJs.equals)(selectedItems, this._selectedItems, (a, b)=>a === b)) return;
                this._selectedItems = selectedItems;
                this.onDidChangeSelectionEmitter.fire(selectedItems);
                if (selectedItems.length) this.handleAccept(_domJs.isMouseEvent(event) && event.button === 1 /* mouse middle click */ );
            }));
            this.visibleDisposables.add(this.ui.list.onChangedCheckedElements((checkedItems)=>{
                if (!this.canSelectMany || !this.visible) return;
                if (this.selectedItemsToConfirm !== this._selectedItems && (0, _arraysJs.equals)(checkedItems, this._selectedItems, (a, b)=>a === b)) return;
                this._selectedItems = checkedItems;
                this.onDidChangeSelectionEmitter.fire(checkedItems);
            }));
            this.visibleDisposables.add(this.ui.list.onButtonTriggered((event)=>this.onDidTriggerItemButtonEmitter.fire(event)));
            this.visibleDisposables.add(this.ui.list.onSeparatorButtonTriggered((event)=>this.onDidTriggerSeparatorButtonEmitter.fire(event)));
            this.visibleDisposables.add(this.registerQuickNavigation());
            this.valueSelectionUpdated = true;
        }
        super.show(); // TODO: Why have show() bubble up while update() trickles down?
    }
    handleAccept(inBackground) {
        // Figure out veto via `onWillAccept` event
        let veto = false;
        this.onWillAcceptEmitter.fire({
            veto: ()=>veto = true
        });
        // Continue with `onDidAccept` if no veto
        if (!veto) this.onDidAcceptEmitter.fire({
            inBackground
        });
    }
    registerQuickNavigation() {
        return _domJs.addDisposableListener(this.ui.container, _domJs.EventType.KEY_UP, (e)=>{
            if (this.canSelectMany || !this._quickNavigate) return;
            const keyboardEvent = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            const keyCode = keyboardEvent.keyCode;
            // Select element when keys are pressed that signal it
            const quickNavKeys = this._quickNavigate.keybindings;
            const wasTriggerKeyPressed = quickNavKeys.some((k)=>{
                const chords = k.getChords();
                if (chords.length > 1) return false;
                if (chords[0].shiftKey && keyCode === 4 /* KeyCode.Shift */ ) {
                    if (keyboardEvent.ctrlKey || keyboardEvent.altKey || keyboardEvent.metaKey) return false; // this is an optimistic check for the shift key being used to navigate back in quick input
                    return true;
                }
                if (chords[0].altKey && keyCode === 6 /* KeyCode.Alt */ ) return true;
                if (chords[0].ctrlKey && keyCode === 5 /* KeyCode.Ctrl */ ) return true;
                if (chords[0].metaKey && keyCode === 57 /* KeyCode.Meta */ ) return true;
                return false;
            });
            if (wasTriggerKeyPressed) {
                if (this.activeItems[0]) {
                    this._selectedItems = [
                        this.activeItems[0]
                    ];
                    this.onDidChangeSelectionEmitter.fire(this.selectedItems);
                    this.handleAccept(false);
                }
                // Unset quick navigate after press. It is only valid once
                // and should not result in any behaviour change afterwards
                // if the picker remains open because there was no active item
                this._quickNavigate = undefined;
            }
        });
    }
    update() {
        if (!this.visible) return;
        // store the scrollTop before it is reset
        const scrollTopBefore = this.keepScrollPosition ? this.scrollTop : 0;
        const hasDescription = !!this.description;
        const visibilities = {
            title: !!this.title || !!this.step || !!this.titleButtons.length,
            description: hasDescription,
            checkAll: this.canSelectMany && !this._hideCheckAll,
            checkBox: this.canSelectMany,
            inputBox: !this._hideInput,
            progressBar: !this._hideInput || hasDescription,
            visibleCount: true,
            count: this.canSelectMany && !this._hideCountBadge,
            ok: this.ok === "default" ? this.canSelectMany : this.ok,
            list: true,
            message: !!this.validationMessage,
            customButton: this.customButton
        };
        this.ui.setVisibilities(visibilities);
        super.update();
        if (this.ui.inputBox.value !== this.value) this.ui.inputBox.value = this.value;
        if (this.valueSelectionUpdated) {
            this.valueSelectionUpdated = false;
            this.ui.inputBox.select(this._valueSelection && {
                start: this._valueSelection[0],
                end: this._valueSelection[1]
            });
        }
        if (this.ui.inputBox.placeholder !== (this.placeholder || "")) this.ui.inputBox.placeholder = this.placeholder || "";
        let ariaLabel = this.ariaLabel;
        // Only set aria label to the input box placeholder if we actually have an input box.
        if (!ariaLabel && visibilities.inputBox) {
            ariaLabel = this.placeholder || QuickPick.DEFAULT_ARIA_LABEL;
            // If we have a title, include it in the aria label.
            if (this.title) ariaLabel += ` - ${this.title}`;
        }
        if (this.ui.list.ariaLabel !== ariaLabel) this.ui.list.ariaLabel = ariaLabel ?? null;
        this.ui.list.matchOnDescription = this.matchOnDescription;
        this.ui.list.matchOnDetail = this.matchOnDetail;
        this.ui.list.matchOnLabel = this.matchOnLabel;
        this.ui.list.matchOnLabelMode = this.matchOnLabelMode;
        this.ui.list.sortByLabel = this.sortByLabel;
        if (this.itemsUpdated) {
            this.itemsUpdated = false;
            this._focusEventBufferer.bufferEvents(()=>{
                this.ui.list.setElements(this.items);
                // We want focus to exist in the list if there are items so that space can be used to toggle
                this.ui.list.shouldLoop = !this.canSelectMany;
                this.ui.list.filter(this.filterValue(this.ui.inputBox.value));
                switch(this._itemActivation){
                    case (0, _quickInputJs.ItemActivation).NONE:
                        this._itemActivation = (0, _quickInputJs.ItemActivation).FIRST; // only valid once, then unset
                        break;
                    case (0, _quickInputJs.ItemActivation).SECOND:
                        this.ui.list.focus((0, _quickInputJs.QuickPickFocus).Second);
                        this._itemActivation = (0, _quickInputJs.ItemActivation).FIRST; // only valid once, then unset
                        break;
                    case (0, _quickInputJs.ItemActivation).LAST:
                        this.ui.list.focus((0, _quickInputJs.QuickPickFocus).Last);
                        this._itemActivation = (0, _quickInputJs.ItemActivation).FIRST; // only valid once, then unset
                        break;
                    default:
                        this.trySelectFirst();
                        break;
                }
            });
        }
        if (this.ui.container.classList.contains("show-checkboxes") !== !!this.canSelectMany) {
            if (this.canSelectMany) this.ui.list.clearFocus();
            else this.trySelectFirst();
        }
        if (this.activeItemsUpdated) {
            this.activeItemsUpdated = false;
            this.activeItemsToConfirm = this._activeItems;
            this.ui.list.setFocusedElements(this.activeItems);
            if (this.activeItemsToConfirm === this._activeItems) this.activeItemsToConfirm = null;
        }
        if (this.selectedItemsUpdated) {
            this.selectedItemsUpdated = false;
            this.selectedItemsToConfirm = this._selectedItems;
            if (this.canSelectMany) this.ui.list.setCheckedElements(this.selectedItems);
            else this.ui.list.setSelectedElements(this.selectedItems);
            if (this.selectedItemsToConfirm === this._selectedItems) this.selectedItemsToConfirm = null;
        }
        this.ui.customButton.label = this.customLabel || "";
        this.ui.customButton.element.title = this.customHover || "";
        if (!visibilities.inputBox) {
            // we need to move focus into the tree to detect keybindings
            // properly when the input box is not visible (quick nav)
            this.ui.list.domFocus();
            // Focus the first element in the list if multiselect is enabled
            if (this.canSelectMany) this.ui.list.focus((0, _quickInputJs.QuickPickFocus).First);
        }
        // Set the scroll position to what it was before updating the items
        if (this.keepScrollPosition) this.scrollTop = scrollTopBefore;
    }
    focus(focus) {
        this.ui.list.focus(focus);
        // To allow things like space to check/uncheck items
        if (this.canSelectMany) this.ui.list.domFocus();
    }
    accept(inBackground) {
        if (inBackground && !this._canAcceptInBackground) return; // needs to be enabled
        if (this.activeItems[0]) {
            this._selectedItems = [
                this.activeItems[0]
            ];
            this.onDidChangeSelectionEmitter.fire(this.selectedItems);
            this.handleAccept(inBackground ?? false);
        }
    }
}
class InputBox extends QuickInput {
    constructor(){
        super(...arguments);
        this._value = "";
        this.valueSelectionUpdated = true;
        this._password = false;
        this.onDidValueChangeEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onDidAcceptEmitter = this._register(new (0, _eventJs.Emitter)());
        this.type = "inputBox" /* QuickInputType.InputBox */ ;
        this.onDidChangeValue = this.onDidValueChangeEmitter.event;
        this.onDidAccept = this.onDidAcceptEmitter.event;
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value || "";
        this.update();
    }
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(placeholder) {
        this._placeholder = placeholder;
        this.update();
    }
    get password() {
        return this._password;
    }
    set password(password) {
        this._password = password;
        this.update();
    }
    show() {
        if (!this.visible) {
            this.visibleDisposables.add(this.ui.inputBox.onDidChange((value)=>{
                if (value === this.value) return;
                this._value = value;
                this.onDidValueChangeEmitter.fire(value);
            }));
            this.visibleDisposables.add(this.ui.onDidAccept(()=>this.onDidAcceptEmitter.fire()));
            this.valueSelectionUpdated = true;
        }
        super.show();
    }
    update() {
        if (!this.visible) return;
        this.ui.container.classList.remove("hidden-input");
        const visibilities = {
            title: !!this.title || !!this.step || !!this.titleButtons.length,
            description: !!this.description || !!this.step,
            inputBox: true,
            message: true,
            progressBar: true
        };
        this.ui.setVisibilities(visibilities);
        super.update();
        if (this.ui.inputBox.value !== this.value) this.ui.inputBox.value = this.value;
        if (this.valueSelectionUpdated) {
            this.valueSelectionUpdated = false;
            this.ui.inputBox.select(this._valueSelection && {
                start: this._valueSelection[0],
                end: this._valueSelection[1]
            });
        }
        if (this.ui.inputBox.placeholder !== (this.placeholder || "")) this.ui.inputBox.placeholder = this.placeholder || "";
        if (this.ui.inputBox.password !== this.password) this.ui.inputBox.password = this.password;
    }
}
let QuickInputHoverDelegate = class QuickInputHoverDelegate extends (0, _hoverJs.WorkbenchHoverDelegate) {
    constructor(configurationService, hoverService){
        super("element", false, (options)=>this.getOverrideOptions(options), configurationService, hoverService);
    }
    getOverrideOptions(options) {
        // Only show the hover hint if the content is of a decent size
        const showHoverHint = (_domJs.isHTMLElement(options.content) ? options.content.textContent ?? "" : typeof options.content === "string" ? options.content : options.content.value).includes("\n");
        return {
            persistence: {
                hideOnKeyDown: false
            },
            appearance: {
                showHoverHint,
                skipFadeInAnimation: true
            }
        };
    }
};
QuickInputHoverDelegate = __decorate([
    __param(0, (0, _configurationJs.IConfigurationService)),
    __param(1, (0, _hoverJs.IHoverService))
], QuickInputHoverDelegate);

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/keyboardEvent.js":"bxU9U","../../../base/browser/ui/toggle/toggle.js":"3QqQn","../../../base/common/arrays.js":"DECei","../../../base/common/async.js":"4GJc4","../../../base/common/codicons.js":"hWYNf","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/platform.js":"7maJO","../../../base/common/severity.js":"faBYp","../../../base/common/themables.js":"hgyHi","./media/quickInput.css":"kd5QF","../../../nls.js":"l617d","../common/quickInput.js":"a56M6","./quickInputUtils.js":"dJuPL","../../configuration/common/configuration.js":"dXkjq","../../hover/browser/hover.js":"3QGXp","../../contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3QqQn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unthemedToggleStyles", ()=>unthemedToggleStyles);
parcelHelpers.export(exports, "Toggle", ()=>Toggle);
var _widgetJs = require("../widget.js");
var _themablesJs = require("../../../common/themables.js");
var _eventJs = require("../../../common/event.js");
var _toggleCss = require("./toggle.css");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _hoverDelegate2Js = require("../hover/hoverDelegate2.js");
const unthemedToggleStyles = {
    inputActiveOptionBorder: "#007ACC00",
    inputActiveOptionForeground: "#FFFFFF",
    inputActiveOptionBackground: "#0E639C50"
};
class Toggle extends (0, _widgetJs.Widget) {
    constructor(opts){
        super();
        this._onChange = this._register(new (0, _eventJs.Emitter)());
        this.onChange = this._onChange.event;
        this._onKeyDown = this._register(new (0, _eventJs.Emitter)());
        this.onKeyDown = this._onKeyDown.event;
        this._opts = opts;
        this._checked = this._opts.isChecked;
        const classes = [
            "monaco-custom-toggle"
        ];
        if (this._opts.icon) {
            this._icon = this._opts.icon;
            classes.push(...(0, _themablesJs.ThemeIcon).asClassNameArray(this._icon));
        }
        if (this._opts.actionClassName) classes.push(...this._opts.actionClassName.split(" "));
        if (this._checked) classes.push("checked");
        this.domNode = document.createElement("div");
        this._hover = this._register((0, _hoverDelegate2Js.getBaseLayerHoverDelegate)().setupManagedHover(opts.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("mouse"), this.domNode, this._opts.title));
        this.domNode.classList.add(...classes);
        if (!this._opts.notFocusable) this.domNode.tabIndex = 0;
        this.domNode.setAttribute("role", "checkbox");
        this.domNode.setAttribute("aria-checked", String(this._checked));
        this.domNode.setAttribute("aria-label", this._opts.title);
        this.applyStyles();
        this.onclick(this.domNode, (ev)=>{
            if (this.enabled) {
                this.checked = !this._checked;
                this._onChange.fire(false);
                ev.preventDefault();
            }
        });
        this._register(this.ignoreGesture(this.domNode));
        this.onkeydown(this.domNode, (keyboardEvent)=>{
            if (keyboardEvent.keyCode === 10 /* KeyCode.Space */  || keyboardEvent.keyCode === 3 /* KeyCode.Enter */ ) {
                this.checked = !this._checked;
                this._onChange.fire(true);
                keyboardEvent.preventDefault();
                keyboardEvent.stopPropagation();
                return;
            }
            this._onKeyDown.fire(keyboardEvent);
        });
    }
    get enabled() {
        return this.domNode.getAttribute("aria-disabled") !== "true";
    }
    focus() {
        this.domNode.focus();
    }
    get checked() {
        return this._checked;
    }
    set checked(newIsChecked) {
        this._checked = newIsChecked;
        this.domNode.setAttribute("aria-checked", String(this._checked));
        this.domNode.classList.toggle("checked", this._checked);
        this.applyStyles();
    }
    width() {
        return 22 /* icon width */ ;
    }
    applyStyles() {
        if (this.domNode) {
            this.domNode.style.borderColor = this._checked && this._opts.inputActiveOptionBorder || "";
            this.domNode.style.color = this._checked && this._opts.inputActiveOptionForeground || "inherit";
            this.domNode.style.backgroundColor = this._checked && this._opts.inputActiveOptionBackground || "";
        }
    }
    enable() {
        this.domNode.setAttribute("aria-disabled", String(false));
    }
    disable() {
        this.domNode.setAttribute("aria-disabled", String(true));
    }
}

},{"../widget.js":"kM4DP","../../../common/themables.js":"hgyHi","../../../common/event.js":"4Zi8b","./toggle.css":"9ShxW","../hover/hoverDelegateFactory.js":"kll4h","../hover/hoverDelegate2.js":"5jqL3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ShxW":[function() {},{}],"kd5QF":[function() {},{}],"dJuPL":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quickInputButtonToAction", ()=>quickInputButtonToAction);
parcelHelpers.export(exports, "renderQuickInputDescription", ()=>renderQuickInputDescription);
var _domJs = require("../../../base/browser/dom.js");
var _eventJs = require("../../../base/browser/event.js");
var _eventJs1 = require("../../../base/common/event.js");
var _keyboardEventJs = require("../../../base/browser/keyboardEvent.js");
var _touchJs = require("../../../base/browser/touch.js");
var _iconLabelsJs = require("../../../base/browser/ui/iconLabel/iconLabels.js");
var _idGeneratorJs = require("../../../base/common/idGenerator.js");
var _linkedTextJs = require("../../../base/common/linkedText.js");
var _quickInputCss = require("./media/quickInput.css");
var _nlsJs = require("../../../nls.js");
const iconPathToClass = {};
const iconClassGenerator = new (0, _idGeneratorJs.IdGenerator)("quick-input-button-icon-");
function getIconClass(iconPath) {
    if (!iconPath) return undefined;
    let iconClass;
    const key = iconPath.dark.toString();
    if (iconPathToClass[key]) iconClass = iconPathToClass[key];
    else {
        iconClass = iconClassGenerator.nextId();
        _domJs.createCSSRule(`.${iconClass}, .hc-light .${iconClass}`, `background-image: ${_domJs.asCSSUrl(iconPath.light || iconPath.dark)}`);
        _domJs.createCSSRule(`.vs-dark .${iconClass}, .hc-black .${iconClass}`, `background-image: ${_domJs.asCSSUrl(iconPath.dark)}`);
        iconPathToClass[key] = iconClass;
    }
    return iconClass;
}
function quickInputButtonToAction(button, id, run) {
    let cssClasses = button.iconClass || getIconClass(button.iconPath);
    if (button.alwaysVisible) cssClasses = cssClasses ? `${cssClasses} always-visible` : "always-visible";
    return {
        id,
        label: "",
        tooltip: button.tooltip || "",
        class: cssClasses,
        enabled: true,
        run
    };
}
function renderQuickInputDescription(description, container, actionHandler) {
    _domJs.reset(container);
    const parsed = (0, _linkedTextJs.parseLinkedText)(description);
    let tabIndex = 0;
    for (const node of parsed.nodes)if (typeof node === "string") container.append(...(0, _iconLabelsJs.renderLabelWithIcons)(node));
    else {
        let title = node.title;
        if (!title && node.href.startsWith("command:")) title = (0, _nlsJs.localize)("executeCommand", "Click to execute command '{0}'", node.href.substring(8));
        else if (!title) title = node.href;
        const anchor = _domJs.$("a", {
            href: node.href,
            title,
            tabIndex: tabIndex++
        }, node.label);
        anchor.style.textDecoration = "underline";
        const handleOpen = (e)=>{
            if (_domJs.isEventLike(e)) _domJs.EventHelper.stop(e, true);
            actionHandler.callback(node.href);
        };
        const onClick = actionHandler.disposables.add(new (0, _eventJs.DomEmitter)(anchor, _domJs.EventType.CLICK)).event;
        const onKeydown = actionHandler.disposables.add(new (0, _eventJs.DomEmitter)(anchor, _domJs.EventType.KEY_DOWN)).event;
        const onSpaceOrEnter = (0, _eventJs1.Event).chain(onKeydown, ($)=>$.filter((e)=>{
                const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
                return event.equals(10 /* KeyCode.Space */ ) || event.equals(3 /* KeyCode.Enter */ );
            }));
        actionHandler.disposables.add((0, _touchJs.Gesture).addTarget(anchor));
        const onTap = actionHandler.disposables.add(new (0, _eventJs.DomEmitter)(anchor, (0, _touchJs.EventType).Tap)).event;
        (0, _eventJs1.Event).any(onClick, onTap, onSpaceOrEnter)(handleOpen, null, actionHandler.disposables);
        container.appendChild(anchor);
    }
}

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/event.js":"PHN3G","../../../base/common/event.js":"4Zi8b","../../../base/browser/keyboardEvent.js":"bxU9U","../../../base/browser/touch.js":"6iGQn","../../../base/browser/ui/iconLabel/iconLabels.js":"lXqhk","../../../base/common/idGenerator.js":"jlFbp","../../../base/common/linkedText.js":"bMmTk","./media/quickInput.css":"kd5QF","../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bMmTk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkedText", ()=>LinkedText);
parcelHelpers.export(exports, "parseLinkedText", ()=>parseLinkedText);
var _decoratorsJs = require("./decorators.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class LinkedText {
    constructor(nodes){
        this.nodes = nodes;
    }
    toString() {
        return this.nodes.map((node)=>typeof node === "string" ? node : node.label).join("");
    }
}
__decorate([
    (0, _decoratorsJs.memoize)
], LinkedText.prototype, "toString", null);
const LINK_REGEX = /\[([^\]]+)\]\(((?:https?:\/\/|command:|file:)[^\)\s]+)(?: (["'])(.+?)(\3))?\)/gi;
function parseLinkedText(text) {
    const result = [];
    let index = 0;
    let match;
    while(match = LINK_REGEX.exec(text)){
        if (match.index - index > 0) result.push(text.substring(index, match.index));
        const [, label, href, , title] = match;
        if (title) result.push({
            label,
            href,
            title
        });
        else result.push({
            label,
            href
        });
        index = match.index + match[0].length;
    }
    if (index < text.length) result.push(text.substring(index));
    return new LinkedText(result);
}

},{"./decorators.js":"hZnBn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kd5QF":[function() {},{}],"44PZ8":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuickInputController", ()=>QuickInputController);
var _domJs = require("../../../base/browser/dom.js");
var _actionbarJs = require("../../../base/browser/ui/actionbar/actionbar.js");
var _buttonJs = require("../../../base/browser/ui/button/button.js");
var _countBadgeJs = require("../../../base/browser/ui/countBadge/countBadge.js");
var _progressbarJs = require("../../../base/browser/ui/progressbar/progressbar.js");
var _cancellationJs = require("../../../base/common/cancellation.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _severityJs = require("../../../base/common/severity.js");
var _severityJsDefault = parcelHelpers.interopDefault(_severityJs);
var _nlsJs = require("../../../nls.js");
var _quickInputJs = require("../common/quickInput.js");
var _quickInputBoxJs = require("./quickInputBox.js");
var _quickInputJs1 = require("./quickInput.js");
var _layoutServiceJs = require("../../layout/browser/layoutService.js");
var _windowJs = require("../../../base/browser/window.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var _quickInputTreeJs = require("./quickInputTree.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _quickInputActionsJs = require("./quickInputActions.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var QuickInputController_1;
const $ = _domJs.$;
let QuickInputController = class QuickInputController extends (0, _lifecycleJs.Disposable) {
    static{
        QuickInputController_1 = this;
    }
    static{
        this.MAX_WIDTH = 600;
    }
    get currentQuickInput() {
        return this.controller ?? undefined;
    }
    get container() {
        return this._container;
    }
    constructor(options, layoutService, instantiationService, contextKeyService){
        super();
        this.options = options;
        this.layoutService = layoutService;
        this.instantiationService = instantiationService;
        this.contextKeyService = contextKeyService;
        this.enabled = true;
        this.onDidAcceptEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onDidCustomEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onDidTriggerButtonEmitter = this._register(new (0, _eventJs.Emitter)());
        this.keyMods = {
            ctrlCmd: false,
            alt: false
        };
        this.controller = null;
        this.onShowEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onShow = this.onShowEmitter.event;
        this.onHideEmitter = this._register(new (0, _eventJs.Emitter)());
        this.onHide = this.onHideEmitter.event;
        this.inQuickInputContext = (0, _quickInputJs1.InQuickInputContextKey).bindTo(this.contextKeyService);
        this.quickInputTypeContext = (0, _quickInputJs1.QuickInputTypeContextKey).bindTo(this.contextKeyService);
        this.endOfQuickInputBoxContext = (0, _quickInputJs1.EndOfQuickInputBoxContextKey).bindTo(this.contextKeyService);
        this.idPrefix = options.idPrefix;
        this._container = options.container;
        this.styles = options.styles;
        this._register((0, _eventJs.Event).runAndSubscribe(_domJs.onDidRegisterWindow, ({ window, disposables })=>this.registerKeyModsListeners(window, disposables), {
            window: (0, _windowJs.mainWindow),
            disposables: this._store
        }));
        this._register(_domJs.onWillUnregisterWindow((window)=>{
            if (this.ui && _domJs.getWindow(this.ui.container) === window) {
                // The window this quick input is contained in is about to
                // close, so we have to make sure to reparent it back to an
                // existing parent to not loose functionality.
                // (https://github.com/microsoft/vscode/issues/195870)
                this.reparentUI(this.layoutService.mainContainer);
                this.layout(this.layoutService.mainContainerDimension, this.layoutService.mainContainerOffset.quickPickTop);
            }
        }));
    }
    registerKeyModsListeners(window, disposables) {
        const listener = (e)=>{
            this.keyMods.ctrlCmd = e.ctrlKey || e.metaKey;
            this.keyMods.alt = e.altKey;
        };
        for (const event of [
            _domJs.EventType.KEY_DOWN,
            _domJs.EventType.KEY_UP,
            _domJs.EventType.MOUSE_DOWN
        ])disposables.add(_domJs.addDisposableListener(window, event, listener, true));
    }
    getUI(showInActiveContainer) {
        if (this.ui) {
            // In order to support aux windows, re-parent the controller
            // if the original event is from a different document
            if (showInActiveContainer) {
                if (_domJs.getWindow(this._container) !== _domJs.getWindow(this.layoutService.activeContainer)) {
                    this.reparentUI(this.layoutService.activeContainer);
                    this.layout(this.layoutService.activeContainerDimension, this.layoutService.activeContainerOffset.quickPickTop);
                }
            }
            return this.ui;
        }
        const container = _domJs.append(this._container, $(".quick-input-widget.show-file-icons"));
        container.tabIndex = -1;
        container.style.display = "none";
        const styleSheet = _domJs.createStyleSheet(container);
        const titleBar = _domJs.append(container, $(".quick-input-titlebar"));
        const leftActionBar = this._register(new (0, _actionbarJs.ActionBar)(titleBar, {
            hoverDelegate: this.options.hoverDelegate
        }));
        leftActionBar.domNode.classList.add("quick-input-left-action-bar");
        const title = _domJs.append(titleBar, $(".quick-input-title"));
        const rightActionBar = this._register(new (0, _actionbarJs.ActionBar)(titleBar, {
            hoverDelegate: this.options.hoverDelegate
        }));
        rightActionBar.domNode.classList.add("quick-input-right-action-bar");
        const headerContainer = _domJs.append(container, $(".quick-input-header"));
        const checkAll = _domJs.append(headerContainer, $("input.quick-input-check-all"));
        checkAll.type = "checkbox";
        checkAll.setAttribute("aria-label", (0, _nlsJs.localize)("quickInput.checkAll", "Toggle all checkboxes"));
        this._register(_domJs.addStandardDisposableListener(checkAll, _domJs.EventType.CHANGE, (e)=>{
            const checked = checkAll.checked;
            list.setAllVisibleChecked(checked);
        }));
        this._register(_domJs.addDisposableListener(checkAll, _domJs.EventType.CLICK, (e)=>{
            if (e.x || e.y) inputBox.setFocus();
        }));
        const description2 = _domJs.append(headerContainer, $(".quick-input-description"));
        const inputContainer = _domJs.append(headerContainer, $(".quick-input-and-message"));
        const filterContainer = _domJs.append(inputContainer, $(".quick-input-filter"));
        const inputBox = this._register(new (0, _quickInputBoxJs.QuickInputBox)(filterContainer, this.styles.inputBox, this.styles.toggle));
        inputBox.setAttribute("aria-describedby", `${this.idPrefix}message`);
        const visibleCountContainer = _domJs.append(filterContainer, $(".quick-input-visible-count"));
        visibleCountContainer.setAttribute("aria-live", "polite");
        visibleCountContainer.setAttribute("aria-atomic", "true");
        const visibleCount = new (0, _countBadgeJs.CountBadge)(visibleCountContainer, {
            countFormat: (0, _nlsJs.localize)({
                key: "quickInput.visibleCount",
                comment: [
                    "This tells the user how many items are shown in a list of items to select from. The items can be anything. Currently not visible, but read by screen readers."
                ]
            }, "{0} Results")
        }, this.styles.countBadge);
        const countContainer = _domJs.append(filterContainer, $(".quick-input-count"));
        countContainer.setAttribute("aria-live", "polite");
        const count = new (0, _countBadgeJs.CountBadge)(countContainer, {
            countFormat: (0, _nlsJs.localize)({
                key: "quickInput.countSelected",
                comment: [
                    "This tells the user how many items are selected in a list of items to select from. The items can be anything."
                ]
            }, "{0} Selected")
        }, this.styles.countBadge);
        const inlineActionBar = this._register(new (0, _actionbarJs.ActionBar)(headerContainer, {
            hoverDelegate: this.options.hoverDelegate
        }));
        inlineActionBar.domNode.classList.add("quick-input-inline-action-bar");
        const okContainer = _domJs.append(headerContainer, $(".quick-input-action"));
        const ok = this._register(new (0, _buttonJs.Button)(okContainer, this.styles.button));
        ok.label = (0, _nlsJs.localize)("ok", "OK");
        this._register(ok.onDidClick((e)=>{
            this.onDidAcceptEmitter.fire();
        }));
        const customButtonContainer = _domJs.append(headerContainer, $(".quick-input-action"));
        const customButton = this._register(new (0, _buttonJs.Button)(customButtonContainer, {
            ...this.styles.button,
            supportIcons: true
        }));
        customButton.label = (0, _nlsJs.localize)("custom", "Custom");
        this._register(customButton.onDidClick((e)=>{
            this.onDidCustomEmitter.fire();
        }));
        const message = _domJs.append(inputContainer, $(`#${this.idPrefix}message.quick-input-message`));
        const progressBar = this._register(new (0, _progressbarJs.ProgressBar)(container, this.styles.progressBar));
        progressBar.getContainer().classList.add("quick-input-progress");
        const widget = _domJs.append(container, $(".quick-input-html-widget"));
        widget.tabIndex = -1;
        const description1 = _domJs.append(container, $(".quick-input-description"));
        const listId = this.idPrefix + "list";
        const list = this._register(this.instantiationService.createInstance((0, _quickInputTreeJs.QuickInputTree), container, this.options.hoverDelegate, this.options.linkOpenerDelegate, listId));
        inputBox.setAttribute("aria-controls", listId);
        this._register(list.onDidChangeFocus(()=>{
            inputBox.setAttribute("aria-activedescendant", list.getActiveDescendant() ?? "");
        }));
        this._register(list.onChangedAllVisibleChecked((checked)=>{
            checkAll.checked = checked;
        }));
        this._register(list.onChangedVisibleCount((c)=>{
            visibleCount.setCount(c);
        }));
        this._register(list.onChangedCheckedCount((c)=>{
            count.setCount(c);
        }));
        this._register(list.onLeave(()=>{
            // Defer to avoid the input field reacting to the triggering key.
            // TODO@TylerLeonhardt https://github.com/microsoft/vscode/issues/203675
            setTimeout(()=>{
                if (!this.controller) return;
                inputBox.setFocus();
                if (this.controller instanceof (0, _quickInputJs1.QuickPick) && this.controller.canSelectMany) list.clearFocus();
            }, 0);
        }));
        const focusTracker = _domJs.trackFocus(container);
        this._register(focusTracker);
        this._register(_domJs.addDisposableListener(container, _domJs.EventType.FOCUS, (e)=>{
            const ui = this.getUI();
            if (_domJs.isAncestor(e.relatedTarget, ui.inputContainer)) {
                const value = ui.inputBox.isSelectionAtEnd();
                if (this.endOfQuickInputBoxContext.get() !== value) this.endOfQuickInputBoxContext.set(value);
            }
            // Ignore focus events within container
            if (_domJs.isAncestor(e.relatedTarget, ui.container)) return;
            this.inQuickInputContext.set(true);
            this.previousFocusElement = _domJs.isHTMLElement(e.relatedTarget) ? e.relatedTarget : undefined;
        }, true));
        this._register(focusTracker.onDidBlur(()=>{
            if (!this.getUI().ignoreFocusOut && !this.options.ignoreFocusOut()) this.hide((0, _quickInputJs.QuickInputHideReason).Blur);
            this.inQuickInputContext.set(false);
            this.endOfQuickInputBoxContext.set(false);
            this.previousFocusElement = undefined;
        }));
        this._register(inputBox.onKeyDown((_)=>{
            const value = this.getUI().inputBox.isSelectionAtEnd();
            if (this.endOfQuickInputBoxContext.get() !== value) this.endOfQuickInputBoxContext.set(value);
        }));
        this._register(_domJs.addDisposableListener(container, _domJs.EventType.FOCUS, (e)=>{
            inputBox.setFocus();
        }));
        // TODO: Turn into commands instead of handling KEY_DOWN
        // Keybindings for the quickinput widget as a whole
        this._register(_domJs.addStandardDisposableListener(container, _domJs.EventType.KEY_DOWN, (event)=>{
            if (_domJs.isAncestor(event.target, widget)) return; // Ignore event if target is inside widget to allow the widget to handle the event.
            switch(event.keyCode){
                case 3 /* KeyCode.Enter */ :
                    _domJs.EventHelper.stop(event, true);
                    if (this.enabled) this.onDidAcceptEmitter.fire();
                    break;
                case 9 /* KeyCode.Escape */ :
                    _domJs.EventHelper.stop(event, true);
                    this.hide((0, _quickInputJs.QuickInputHideReason).Gesture);
                    break;
                case 2 /* KeyCode.Tab */ :
                    if (!event.altKey && !event.ctrlKey && !event.metaKey) {
                        // detect only visible actions
                        const selectors = [
                            ".quick-input-list .monaco-action-bar .always-visible",
                            ".quick-input-list-entry:hover .monaco-action-bar",
                            ".monaco-list-row.focused .monaco-action-bar"
                        ];
                        if (container.classList.contains("show-checkboxes")) selectors.push("input");
                        else selectors.push("input[type=text]");
                        if (this.getUI().list.displayed) selectors.push(".monaco-list");
                        // focus links if there are any
                        if (this.getUI().message) selectors.push(".quick-input-message a");
                        if (this.getUI().widget) {
                            if (_domJs.isAncestor(event.target, this.getUI().widget)) break;
                            selectors.push(".quick-input-html-widget");
                        }
                        const stops = container.querySelectorAll(selectors.join(", "));
                        if (event.shiftKey && event.target === stops[0]) {
                            // Clear the focus from the list in order to allow
                            // screen readers to read operations in the input box.
                            _domJs.EventHelper.stop(event, true);
                            list.clearFocus();
                        } else if (!event.shiftKey && _domJs.isAncestor(event.target, stops[stops.length - 1])) {
                            _domJs.EventHelper.stop(event, true);
                            stops[0].focus();
                        }
                    }
                    break;
                case 10 /* KeyCode.Space */ :
                    if (event.ctrlKey) {
                        _domJs.EventHelper.stop(event, true);
                        this.getUI().list.toggleHover();
                    }
                    break;
            }
        }));
        this.ui = {
            container,
            styleSheet,
            leftActionBar,
            titleBar,
            title,
            description1,
            description2,
            widget,
            rightActionBar,
            inlineActionBar,
            checkAll,
            inputContainer,
            filterContainer,
            inputBox,
            visibleCountContainer,
            visibleCount,
            countContainer,
            count,
            okContainer,
            ok,
            message,
            customButtonContainer,
            customButton,
            list,
            progressBar,
            onDidAccept: this.onDidAcceptEmitter.event,
            onDidCustom: this.onDidCustomEmitter.event,
            onDidTriggerButton: this.onDidTriggerButtonEmitter.event,
            ignoreFocusOut: false,
            keyMods: this.keyMods,
            show: (controller)=>this.show(controller),
            hide: ()=>this.hide(),
            setVisibilities: (visibilities)=>this.setVisibilities(visibilities),
            setEnabled: (enabled)=>this.setEnabled(enabled),
            setContextKey: (contextKey)=>this.options.setContextKey(contextKey),
            linkOpenerDelegate: (content)=>this.options.linkOpenerDelegate(content)
        };
        this.updateStyles();
        return this.ui;
    }
    reparentUI(container) {
        if (this.ui) {
            this._container = container;
            _domJs.append(this._container, this.ui.container);
        }
    }
    pick(picks, options = {}, token = (0, _cancellationJs.CancellationToken).None) {
        return new Promise((doResolve, reject)=>{
            let resolve = (result)=>{
                resolve = doResolve;
                options.onKeyMods?.(input.keyMods);
                doResolve(result);
            };
            if (token.isCancellationRequested) {
                resolve(undefined);
                return;
            }
            const input = this.createQuickPick({
                useSeparators: true
            });
            let activeItem;
            const disposables = [
                input,
                input.onDidAccept(()=>{
                    if (input.canSelectMany) {
                        resolve(input.selectedItems.slice());
                        input.hide();
                    } else {
                        const result = input.activeItems[0];
                        if (result) {
                            resolve(result);
                            input.hide();
                        }
                    }
                }),
                input.onDidChangeActive((items)=>{
                    const focused = items[0];
                    if (focused && options.onDidFocus) options.onDidFocus(focused);
                }),
                input.onDidChangeSelection((items)=>{
                    if (!input.canSelectMany) {
                        const result = items[0];
                        if (result) {
                            resolve(result);
                            input.hide();
                        }
                    }
                }),
                input.onDidTriggerItemButton((event)=>options.onDidTriggerItemButton && options.onDidTriggerItemButton({
                        ...event,
                        removeItem: ()=>{
                            const index = input.items.indexOf(event.item);
                            if (index !== -1) {
                                const items = input.items.slice();
                                const removed = items.splice(index, 1);
                                const activeItems = input.activeItems.filter((activeItem)=>activeItem !== removed[0]);
                                const keepScrollPositionBefore = input.keepScrollPosition;
                                input.keepScrollPosition = true;
                                input.items = items;
                                if (activeItems) input.activeItems = activeItems;
                                input.keepScrollPosition = keepScrollPositionBefore;
                            }
                        }
                    })),
                input.onDidTriggerSeparatorButton((event)=>options.onDidTriggerSeparatorButton?.(event)),
                input.onDidChangeValue((value)=>{
                    if (activeItem && !value && (input.activeItems.length !== 1 || input.activeItems[0] !== activeItem)) input.activeItems = [
                        activeItem
                    ];
                }),
                token.onCancellationRequested(()=>{
                    input.hide();
                }),
                input.onDidHide(()=>{
                    (0, _lifecycleJs.dispose)(disposables);
                    resolve(undefined);
                })
            ];
            input.title = options.title;
            if (options.value) input.value = options.value;
            input.canSelectMany = !!options.canPickMany;
            input.placeholder = options.placeHolder;
            input.ignoreFocusOut = !!options.ignoreFocusLost;
            input.matchOnDescription = !!options.matchOnDescription;
            input.matchOnDetail = !!options.matchOnDetail;
            input.matchOnLabel = options.matchOnLabel === undefined || options.matchOnLabel; // default to true
            input.quickNavigate = options.quickNavigate;
            input.hideInput = !!options.hideInput;
            input.contextKey = options.contextKey;
            input.busy = true;
            Promise.all([
                picks,
                options.activeItem
            ]).then(([items, _activeItem])=>{
                activeItem = _activeItem;
                input.busy = false;
                input.items = items;
                if (input.canSelectMany) input.selectedItems = items.filter((item)=>item.type !== "separator" && item.picked);
                if (activeItem) input.activeItems = [
                    activeItem
                ];
            });
            input.show();
            Promise.resolve(picks).then(undefined, (err)=>{
                reject(err);
                input.hide();
            });
        });
    }
    createQuickPick(options = {
        useSeparators: false
    }) {
        const ui = this.getUI(true);
        return new (0, _quickInputJs1.QuickPick)(ui);
    }
    createInputBox() {
        const ui = this.getUI(true);
        return new (0, _quickInputJs1.InputBox)(ui);
    }
    show(controller) {
        const ui = this.getUI(true);
        this.onShowEmitter.fire();
        const oldController = this.controller;
        this.controller = controller;
        oldController?.didHide();
        this.setEnabled(true);
        ui.leftActionBar.clear();
        ui.title.textContent = "";
        ui.description1.textContent = "";
        ui.description2.textContent = "";
        _domJs.reset(ui.widget);
        ui.rightActionBar.clear();
        ui.inlineActionBar.clear();
        ui.checkAll.checked = false;
        // ui.inputBox.value = ''; Avoid triggering an event.
        ui.inputBox.placeholder = "";
        ui.inputBox.password = false;
        ui.inputBox.showDecoration((0, _severityJsDefault.default).Ignore);
        ui.visibleCount.setCount(0);
        ui.count.setCount(0);
        _domJs.reset(ui.message);
        ui.progressBar.stop();
        ui.list.setElements([]);
        ui.list.matchOnDescription = false;
        ui.list.matchOnDetail = false;
        ui.list.matchOnLabel = true;
        ui.list.sortByLabel = true;
        ui.ignoreFocusOut = false;
        ui.inputBox.toggles = undefined;
        const backKeybindingLabel = this.options.backKeybindingLabel();
        (0, _quickInputJs1.backButton).tooltip = backKeybindingLabel ? (0, _nlsJs.localize)("quickInput.backWithKeybinding", "Back ({0})", backKeybindingLabel) : (0, _nlsJs.localize)("quickInput.back", "Back");
        ui.container.style.display = "";
        this.updateLayout();
        ui.inputBox.setFocus();
        this.quickInputTypeContext.set(controller.type);
    }
    isVisible() {
        return !!this.ui && this.ui.container.style.display !== "none";
    }
    setVisibilities(visibilities) {
        const ui = this.getUI();
        ui.title.style.display = visibilities.title ? "" : "none";
        ui.description1.style.display = visibilities.description && (visibilities.inputBox || visibilities.checkAll) ? "" : "none";
        ui.description2.style.display = visibilities.description && !(visibilities.inputBox || visibilities.checkAll) ? "" : "none";
        ui.checkAll.style.display = visibilities.checkAll ? "" : "none";
        ui.inputContainer.style.display = visibilities.inputBox ? "" : "none";
        ui.filterContainer.style.display = visibilities.inputBox ? "" : "none";
        ui.visibleCountContainer.style.display = visibilities.visibleCount ? "" : "none";
        ui.countContainer.style.display = visibilities.count ? "" : "none";
        ui.okContainer.style.display = visibilities.ok ? "" : "none";
        ui.customButtonContainer.style.display = visibilities.customButton ? "" : "none";
        ui.message.style.display = visibilities.message ? "" : "none";
        ui.progressBar.getContainer().style.display = visibilities.progressBar ? "" : "none";
        ui.list.displayed = !!visibilities.list;
        ui.container.classList.toggle("show-checkboxes", !!visibilities.checkBox);
        ui.container.classList.toggle("hidden-input", !visibilities.inputBox && !visibilities.description);
        this.updateLayout(); // TODO
    }
    setEnabled(enabled) {
        if (enabled !== this.enabled) {
            this.enabled = enabled;
            for (const item of this.getUI().leftActionBar.viewItems)item.action.enabled = enabled;
            for (const item of this.getUI().rightActionBar.viewItems)item.action.enabled = enabled;
            this.getUI().checkAll.disabled = !enabled;
            this.getUI().inputBox.enabled = enabled;
            this.getUI().ok.enabled = enabled;
            this.getUI().list.enabled = enabled;
        }
    }
    hide(reason) {
        const controller = this.controller;
        if (!controller) return;
        controller.willHide(reason);
        const container = this.ui?.container;
        const focusChanged = container && !_domJs.isAncestorOfActiveElement(container);
        this.controller = null;
        this.onHideEmitter.fire();
        if (container) container.style.display = "none";
        if (!focusChanged) {
            let currentElement = this.previousFocusElement;
            while(currentElement && !currentElement.offsetParent)currentElement = currentElement.parentElement ?? undefined;
            if (currentElement?.offsetParent) {
                currentElement.focus();
                this.previousFocusElement = undefined;
            } else this.options.returnFocus();
        }
        controller.didHide(reason);
    }
    layout(dimension, titleBarOffset) {
        this.dimension = dimension;
        this.titleBarOffset = titleBarOffset;
        this.updateLayout();
    }
    updateLayout() {
        if (this.ui && this.isVisible()) {
            this.ui.container.style.top = `${this.titleBarOffset}px`;
            const style = this.ui.container.style;
            const width = Math.min(this.dimension.width * 0.62 /* golden cut */ , QuickInputController_1.MAX_WIDTH);
            style.width = width + "px";
            style.marginLeft = "-" + width / 2 + "px";
            this.ui.inputBox.layout();
            this.ui.list.layout(this.dimension && this.dimension.height * 0.4);
        }
    }
    applyStyles(styles) {
        this.styles = styles;
        this.updateStyles();
    }
    updateStyles() {
        if (this.ui) {
            const { quickInputTitleBackground, quickInputBackground, quickInputForeground, widgetBorder, widgetShadow } = this.styles.widget;
            this.ui.titleBar.style.backgroundColor = quickInputTitleBackground ?? "";
            this.ui.container.style.backgroundColor = quickInputBackground ?? "";
            this.ui.container.style.color = quickInputForeground ?? "";
            this.ui.container.style.border = widgetBorder ? `1px solid ${widgetBorder}` : "";
            this.ui.container.style.boxShadow = widgetShadow ? `0 0 8px 2px ${widgetShadow}` : "";
            this.ui.list.style(this.styles.list);
            const content = [];
            if (this.styles.pickerGroup.pickerGroupBorder) content.push(`.quick-input-list .quick-input-list-entry { border-top-color:  ${this.styles.pickerGroup.pickerGroupBorder}; }`);
            if (this.styles.pickerGroup.pickerGroupForeground) content.push(`.quick-input-list .quick-input-list-separator { color:  ${this.styles.pickerGroup.pickerGroupForeground}; }`);
            if (this.styles.pickerGroup.pickerGroupForeground) content.push(`.quick-input-list .quick-input-list-separator-as-item { color: var(--vscode-descriptionForeground); }`);
            if (this.styles.keybindingLabel.keybindingLabelBackground || this.styles.keybindingLabel.keybindingLabelBorder || this.styles.keybindingLabel.keybindingLabelBottomBorder || this.styles.keybindingLabel.keybindingLabelShadow || this.styles.keybindingLabel.keybindingLabelForeground) {
                content.push(".quick-input-list .monaco-keybinding > .monaco-keybinding-key {");
                if (this.styles.keybindingLabel.keybindingLabelBackground) content.push(`background-color: ${this.styles.keybindingLabel.keybindingLabelBackground};`);
                if (this.styles.keybindingLabel.keybindingLabelBorder) // Order matters here. `border-color` must come before `border-bottom-color`.
                content.push(`border-color: ${this.styles.keybindingLabel.keybindingLabelBorder};`);
                if (this.styles.keybindingLabel.keybindingLabelBottomBorder) content.push(`border-bottom-color: ${this.styles.keybindingLabel.keybindingLabelBottomBorder};`);
                if (this.styles.keybindingLabel.keybindingLabelShadow) content.push(`box-shadow: inset 0 -1px 0 ${this.styles.keybindingLabel.keybindingLabelShadow};`);
                if (this.styles.keybindingLabel.keybindingLabelForeground) content.push(`color: ${this.styles.keybindingLabel.keybindingLabelForeground};`);
                content.push("}");
            }
            const newStyles = content.join("\n");
            if (newStyles !== this.ui.styleSheet.textContent) this.ui.styleSheet.textContent = newStyles;
        }
    }
};
QuickInputController = QuickInputController_1 = __decorate([
    __param(1, (0, _layoutServiceJs.ILayoutService)),
    __param(2, (0, _instantiationJs.IInstantiationService)),
    __param(3, (0, _contextkeyJs.IContextKeyService))
], QuickInputController);

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/ui/actionbar/actionbar.js":"5Xmba","../../../base/browser/ui/button/button.js":"fmbgq","../../../base/browser/ui/countBadge/countBadge.js":"2Bgie","../../../base/browser/ui/progressbar/progressbar.js":"7SHL2","../../../base/common/cancellation.js":"hoVxw","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/severity.js":"faBYp","../../../nls.js":"l617d","../common/quickInput.js":"a56M6","./quickInputBox.js":"aBU5R","./quickInput.js":"bmHRs","../../layout/browser/layoutService.js":"fPPgf","../../../base/browser/window.js":"aJBhQ","../../instantiation/common/instantiation.js":"fjwWx","./quickInputTree.js":"0qxvt","../../contextkey/common/contextkey.js":"gXuBD","./quickInputActions.js":"gGKuo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fmbgq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unthemedButtonStyles", ()=>unthemedButtonStyles);
parcelHelpers.export(exports, "Button", ()=>Button);
var _domJs = require("../../dom.js");
var _dompurifyJs = require("../../dompurify/dompurify.js");
var _keyboardEventJs = require("../../keyboardEvent.js");
var _markdownRendererJs = require("../../markdownRenderer.js");
var _touchJs = require("../../touch.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _iconLabelsJs = require("../iconLabel/iconLabels.js");
var _colorJs = require("../../../common/color.js");
var _eventJs = require("../../../common/event.js");
var _htmlContentJs = require("../../../common/htmlContent.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _themablesJs = require("../../../common/themables.js");
var _buttonCss = require("./button.css");
var _hoverDelegate2Js = require("../hover/hoverDelegate2.js");
const unthemedButtonStyles = {
    buttonBackground: "#0E639C",
    buttonHoverBackground: "#006BB3",
    buttonSeparator: (0, _colorJs.Color).white.toString(),
    buttonForeground: (0, _colorJs.Color).white.toString(),
    buttonBorder: undefined,
    buttonSecondaryBackground: undefined,
    buttonSecondaryForeground: undefined,
    buttonSecondaryHoverBackground: undefined
};
class Button extends (0, _lifecycleJs.Disposable) {
    get onDidClick() {
        return this._onDidClick.event;
    }
    constructor(container, options){
        super();
        this._label = "";
        this._onDidClick = this._register(new (0, _eventJs.Emitter)());
        this._onDidEscape = this._register(new (0, _eventJs.Emitter)());
        this.options = options;
        this._element = document.createElement("a");
        this._element.classList.add("monaco-button");
        this._element.tabIndex = 0;
        this._element.setAttribute("role", "button");
        this._element.classList.toggle("secondary", !!options.secondary);
        const background = options.secondary ? options.buttonSecondaryBackground : options.buttonBackground;
        const foreground = options.secondary ? options.buttonSecondaryForeground : options.buttonForeground;
        this._element.style.color = foreground || "";
        this._element.style.backgroundColor = background || "";
        if (options.supportShortLabel) {
            this._labelShortElement = document.createElement("div");
            this._labelShortElement.classList.add("monaco-button-label-short");
            this._element.appendChild(this._labelShortElement);
            this._labelElement = document.createElement("div");
            this._labelElement.classList.add("monaco-button-label");
            this._element.appendChild(this._labelElement);
            this._element.classList.add("monaco-text-button-with-short-label");
        }
        if (typeof options.title === "string") this.setTitle(options.title);
        if (typeof options.ariaLabel === "string") this._element.setAttribute("aria-label", options.ariaLabel);
        container.appendChild(this._element);
        this._register((0, _touchJs.Gesture).addTarget(this._element));
        [
            (0, _domJs.EventType).CLICK,
            (0, _touchJs.EventType).Tap
        ].forEach((eventType)=>{
            this._register((0, _domJs.addDisposableListener)(this._element, eventType, (e)=>{
                if (!this.enabled) {
                    (0, _domJs.EventHelper).stop(e);
                    return;
                }
                this._onDidClick.fire(e);
            }));
        });
        this._register((0, _domJs.addDisposableListener)(this._element, (0, _domJs.EventType).KEY_DOWN, (e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            let eventHandled = false;
            if (this.enabled && (event.equals(3 /* KeyCode.Enter */ ) || event.equals(10 /* KeyCode.Space */ ))) {
                this._onDidClick.fire(e);
                eventHandled = true;
            } else if (event.equals(9 /* KeyCode.Escape */ )) {
                this._onDidEscape.fire(e);
                this._element.blur();
                eventHandled = true;
            }
            if (eventHandled) (0, _domJs.EventHelper).stop(event, true);
        }));
        this._register((0, _domJs.addDisposableListener)(this._element, (0, _domJs.EventType).MOUSE_OVER, (e)=>{
            if (!this._element.classList.contains("disabled")) this.updateBackground(true);
        }));
        this._register((0, _domJs.addDisposableListener)(this._element, (0, _domJs.EventType).MOUSE_OUT, (e)=>{
            this.updateBackground(false); // restore standard styles
        }));
        // Also set hover background when button is focused for feedback
        this.focusTracker = this._register((0, _domJs.trackFocus)(this._element));
        this._register(this.focusTracker.onDidFocus(()=>{
            if (this.enabled) this.updateBackground(true);
        }));
        this._register(this.focusTracker.onDidBlur(()=>{
            if (this.enabled) this.updateBackground(false);
        }));
    }
    dispose() {
        super.dispose();
        this._element.remove();
    }
    getContentElements(content) {
        const elements = [];
        for (let segment of (0, _iconLabelsJs.renderLabelWithIcons)(content))if (typeof segment === "string") {
            segment = segment.trim();
            // Ignore empty segment
            if (segment === "") continue;
            // Convert string segments to <span> nodes
            const node = document.createElement("span");
            node.textContent = segment;
            elements.push(node);
        } else elements.push(segment);
        return elements;
    }
    updateBackground(hover) {
        let background;
        if (this.options.secondary) background = hover ? this.options.buttonSecondaryHoverBackground : this.options.buttonSecondaryBackground;
        else background = hover ? this.options.buttonHoverBackground : this.options.buttonBackground;
        if (background) this._element.style.backgroundColor = background;
    }
    get element() {
        return this._element;
    }
    set label(value) {
        if (this._label === value) return;
        if ((0, _htmlContentJs.isMarkdownString)(this._label) && (0, _htmlContentJs.isMarkdownString)(value) && (0, _htmlContentJs.markdownStringEqual)(this._label, value)) return;
        this._element.classList.add("monaco-text-button");
        const labelElement = this.options.supportShortLabel ? this._labelElement : this._element;
        if ((0, _htmlContentJs.isMarkdownString)(value)) {
            const rendered = (0, _markdownRendererJs.renderMarkdown)(value, {
                inline: true
            });
            rendered.dispose();
            // Don't include outer `<p>`
            const root = rendered.element.querySelector("p")?.innerHTML;
            if (root) {
                // Only allow a very limited set of inline html tags
                const sanitized = (0, _dompurifyJs.sanitize)(root, {
                    ADD_TAGS: [
                        "b",
                        "i",
                        "u",
                        "code",
                        "span"
                    ],
                    ALLOWED_ATTR: [
                        "class"
                    ],
                    RETURN_TRUSTED_TYPE: true
                });
                labelElement.innerHTML = sanitized;
            } else (0, _domJs.reset)(labelElement);
        } else if (this.options.supportIcons) (0, _domJs.reset)(labelElement, ...this.getContentElements(value));
        else labelElement.textContent = value;
        let title = "";
        if (typeof this.options.title === "string") title = this.options.title;
        else if (this.options.title) title = (0, _markdownRendererJs.renderStringAsPlaintext)(value);
        this.setTitle(title);
        if (typeof this.options.ariaLabel === "string") this._element.setAttribute("aria-label", this.options.ariaLabel);
        else if (this.options.ariaLabel) this._element.setAttribute("aria-label", title);
        this._label = value;
    }
    get label() {
        return this._label;
    }
    set icon(icon) {
        this._element.classList.add(...(0, _themablesJs.ThemeIcon).asClassNameArray(icon));
    }
    set enabled(value) {
        if (value) {
            this._element.classList.remove("disabled");
            this._element.setAttribute("aria-disabled", String(false));
            this._element.tabIndex = 0;
        } else {
            this._element.classList.add("disabled");
            this._element.setAttribute("aria-disabled", String(true));
        }
    }
    get enabled() {
        return !this._element.classList.contains("disabled");
    }
    setTitle(title) {
        if (!this._hover && title !== "") this._hover = this._register((0, _hoverDelegate2Js.getBaseLayerHoverDelegate)().setupManagedHover(this.options.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("mouse"), this._element, title));
        else if (this._hover) this._hover.update(title);
    }
}

},{"../../dom.js":"bnqsM","../../dompurify/dompurify.js":"8OdMj","../../keyboardEvent.js":"bxU9U","../../markdownRenderer.js":"3fw7s","../../touch.js":"6iGQn","../hover/hoverDelegateFactory.js":"kll4h","../iconLabel/iconLabels.js":"lXqhk","../../../common/color.js":"at4gb","../../../common/event.js":"4Zi8b","../../../common/htmlContent.js":"3Hxzm","../../../common/lifecycle.js":"9kg8d","../../../common/themables.js":"hgyHi","./button.css":"gHbCw","../hover/hoverDelegate2.js":"5jqL3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gHbCw":[function() {},{}],"2Bgie":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CountBadge", ()=>CountBadge);
var _domJs = require("../../dom.js");
var _stringsJs = require("../../../common/strings.js");
var _countBadgeCss = require("./countBadge.css");
class CountBadge {
    constructor(container, options, styles){
        this.options = options;
        this.styles = styles;
        this.count = 0;
        this.element = (0, _domJs.append)(container, (0, _domJs.$)(".monaco-count-badge"));
        this.countFormat = this.options.countFormat || "{0}";
        this.titleFormat = this.options.titleFormat || "";
        this.setCount(this.options.count || 0);
    }
    setCount(count) {
        this.count = count;
        this.render();
    }
    setTitleFormat(titleFormat) {
        this.titleFormat = titleFormat;
        this.render();
    }
    render() {
        this.element.textContent = (0, _stringsJs.format)(this.countFormat, this.count);
        this.element.title = (0, _stringsJs.format)(this.titleFormat, this.count);
        this.element.style.backgroundColor = this.styles.badgeBackground ?? "";
        this.element.style.color = this.styles.badgeForeground ?? "";
        if (this.styles.badgeBorder) this.element.style.border = `1px solid ${this.styles.badgeBorder}`;
    }
}

},{"../../dom.js":"bnqsM","../../../common/strings.js":"aA9I1","./countBadge.css":"bfHdS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bfHdS":[function() {},{}],"7SHL2":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A progress bar with support for infinite or discrete progress.
 */ parcelHelpers.export(exports, "ProgressBar", ()=>ProgressBar);
var _domJs = require("../../dom.js");
var _asyncJs = require("../../../common/async.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _progressbarCss = require("./progressbar.css");
const CSS_DONE = "done";
const CSS_ACTIVE = "active";
const CSS_INFINITE = "infinite";
const CSS_INFINITE_LONG_RUNNING = "infinite-long-running";
const CSS_DISCRETE = "discrete";
class ProgressBar extends (0, _lifecycleJs.Disposable) {
    /**
     * After a certain time of showing the progress bar, switch
     * to long-running mode and throttle animations to reduce
     * the pressure on the GPU process.
     *
     * https://github.com/microsoft/vscode/issues/97900
     * https://github.com/microsoft/vscode/issues/138396
     */ static{
        this.LONG_RUNNING_INFINITE_THRESHOLD = 10000;
    }
    constructor(container, options){
        super();
        this.progressSignal = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this.workedVal = 0;
        this.showDelayedScheduler = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>(0, _domJs.show)(this.element), 0));
        this.longRunningScheduler = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this.infiniteLongRunning(), ProgressBar.LONG_RUNNING_INFINITE_THRESHOLD));
        this.create(container, options);
    }
    create(container, options) {
        this.element = document.createElement("div");
        this.element.classList.add("monaco-progress-container");
        this.element.setAttribute("role", "progressbar");
        this.element.setAttribute("aria-valuemin", "0");
        container.appendChild(this.element);
        this.bit = document.createElement("div");
        this.bit.classList.add("progress-bit");
        this.bit.style.backgroundColor = options?.progressBarBackground || "#0E70C0";
        this.element.appendChild(this.bit);
    }
    off() {
        this.bit.style.width = "inherit";
        this.bit.style.opacity = "1";
        this.element.classList.remove(CSS_ACTIVE, CSS_INFINITE, CSS_INFINITE_LONG_RUNNING, CSS_DISCRETE);
        this.workedVal = 0;
        this.totalWork = undefined;
        this.longRunningScheduler.cancel();
        this.progressSignal.clear();
    }
    /**
     * Stops the progressbar from showing any progress instantly without fading out.
     */ stop() {
        return this.doDone(false);
    }
    doDone(delayed) {
        this.element.classList.add(CSS_DONE);
        // discrete: let it grow to 100% width and hide afterwards
        if (!this.element.classList.contains(CSS_INFINITE)) {
            this.bit.style.width = "inherit";
            if (delayed) setTimeout(()=>this.off(), 200);
            else this.off();
        } else {
            this.bit.style.opacity = "0";
            if (delayed) setTimeout(()=>this.off(), 200);
            else this.off();
        }
        return this;
    }
    /**
     * Use this mode to indicate progress that has no total number of work units.
     */ infinite() {
        this.bit.style.width = "2%";
        this.bit.style.opacity = "1";
        this.element.classList.remove(CSS_DISCRETE, CSS_DONE, CSS_INFINITE_LONG_RUNNING);
        this.element.classList.add(CSS_ACTIVE, CSS_INFINITE);
        this.longRunningScheduler.schedule();
        return this;
    }
    infiniteLongRunning() {
        this.element.classList.add(CSS_INFINITE_LONG_RUNNING);
    }
    getContainer() {
        return this.element;
    }
}

},{"../../dom.js":"bnqsM","../../../common/async.js":"4GJc4","../../../common/lifecycle.js":"9kg8d","./progressbar.css":"lMMse","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lMMse":[function() {},{}],"aBU5R":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuickInputBox", ()=>QuickInputBox);
var _domJs = require("../../../base/browser/dom.js");
var _findInputJs = require("../../../base/browser/ui/findinput/findInput.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _severityJs = require("../../../base/common/severity.js");
var _severityJsDefault = parcelHelpers.interopDefault(_severityJs);
var _quickInputCss = require("./media/quickInput.css");
const $ = _domJs.$;
class QuickInputBox extends (0, _lifecycleJs.Disposable) {
    constructor(parent, inputBoxStyles, toggleStyles){
        super();
        this.parent = parent;
        this.onKeyDown = (handler)=>{
            return _domJs.addStandardDisposableListener(this.findInput.inputBox.inputElement, _domJs.EventType.KEY_DOWN, handler);
        };
        this.onDidChange = (handler)=>{
            return this.findInput.onDidChange(handler);
        };
        this.container = _domJs.append(this.parent, $(".quick-input-box"));
        this.findInput = this._register(new (0, _findInputJs.FindInput)(this.container, undefined, {
            label: "",
            inputBoxStyles,
            toggleStyles
        }));
        const input = this.findInput.inputBox.inputElement;
        input.role = "combobox";
        input.ariaHasPopup = "menu";
        input.ariaAutoComplete = "list";
        input.ariaExpanded = "true";
    }
    get value() {
        return this.findInput.getValue();
    }
    set value(value) {
        this.findInput.setValue(value);
    }
    select(range = null) {
        this.findInput.inputBox.select(range);
    }
    getSelection() {
        return this.findInput.inputBox.getSelection();
    }
    isSelectionAtEnd() {
        return this.findInput.inputBox.isSelectionAtEnd();
    }
    get placeholder() {
        return this.findInput.inputBox.inputElement.getAttribute("placeholder") || "";
    }
    set placeholder(placeholder) {
        this.findInput.inputBox.setPlaceHolder(placeholder);
    }
    get password() {
        return this.findInput.inputBox.inputElement.type === "password";
    }
    set password(password) {
        this.findInput.inputBox.inputElement.type = password ? "password" : "text";
    }
    set enabled(enabled) {
        // We can't disable the input box because it is still used for
        // navigating the list. Instead, we disable the list and the OK
        // so that nothing can be selected.
        // TODO: should this be what we do for all find inputs? Or maybe some _other_ API
        // on findInput to change it to readonly?
        this.findInput.inputBox.inputElement.toggleAttribute("readonly", !enabled);
    // TODO: styles of the quick pick need to be moved to the CSS instead of being in line
    // so things like this can be done in CSS
    // this.findInput.inputBox.inputElement.classList.toggle('disabled', !enabled);
    }
    set toggles(toggles) {
        this.findInput.setAdditionalToggles(toggles);
    }
    setAttribute(name, value) {
        this.findInput.inputBox.inputElement.setAttribute(name, value);
    }
    showDecoration(decoration) {
        if (decoration === (0, _severityJsDefault.default).Ignore) this.findInput.clearMessage();
        else this.findInput.showMessage({
            type: decoration === (0, _severityJsDefault.default).Info ? 1 /* MessageType.INFO */  : decoration === (0, _severityJsDefault.default).Warning ? 2 /* MessageType.WARNING */  : 3 /* MessageType.ERROR */ ,
            content: ""
        });
    }
    stylesForType(decoration) {
        return this.findInput.inputBox.stylesForType(decoration === (0, _severityJsDefault.default).Info ? 1 /* MessageType.INFO */  : decoration === (0, _severityJsDefault.default).Warning ? 2 /* MessageType.WARNING */  : 3 /* MessageType.ERROR */ );
    }
    setFocus() {
        this.findInput.focus();
    }
    layout() {
        this.findInput.inputBox.layout();
    }
}

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/ui/findinput/findInput.js":"dp0WT","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/severity.js":"faBYp","./media/quickInput.css":"kd5QF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dp0WT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FindInput", ()=>FindInput);
var _domJs = require("../../dom.js");
var _findInputTogglesJs = require("./findInputToggles.js");
var _inputBoxJs = require("../inputbox/inputBox.js");
var _widgetJs = require("../widget.js");
var _eventJs = require("../../../common/event.js");
var _findInputCss = require("./findInput.css");
var _nlsJs = require("../../../../nls.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
const NLS_DEFAULT_LABEL = _nlsJs.localize("defaultLabel", "input");
class FindInput extends (0, _widgetJs.Widget) {
    constructor(parent, contextViewProvider, options){
        super();
        this.fixFocusOnOptionClickEnabled = true;
        this.imeSessionInProgress = false;
        this.additionalTogglesDisposables = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this.additionalToggles = [];
        this._onDidOptionChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidOptionChange = this._onDidOptionChange.event;
        this._onKeyDown = this._register(new (0, _eventJs.Emitter)());
        this.onKeyDown = this._onKeyDown.event;
        this._onMouseDown = this._register(new (0, _eventJs.Emitter)());
        this.onMouseDown = this._onMouseDown.event;
        this._onInput = this._register(new (0, _eventJs.Emitter)());
        this._onKeyUp = this._register(new (0, _eventJs.Emitter)());
        this._onCaseSensitiveKeyDown = this._register(new (0, _eventJs.Emitter)());
        this.onCaseSensitiveKeyDown = this._onCaseSensitiveKeyDown.event;
        this._onRegexKeyDown = this._register(new (0, _eventJs.Emitter)());
        this.onRegexKeyDown = this._onRegexKeyDown.event;
        this._lastHighlightFindOptions = 0;
        this.placeholder = options.placeholder || "";
        this.validation = options.validation;
        this.label = options.label || NLS_DEFAULT_LABEL;
        this.showCommonFindToggles = !!options.showCommonFindToggles;
        const appendCaseSensitiveLabel = options.appendCaseSensitiveLabel || "";
        const appendWholeWordsLabel = options.appendWholeWordsLabel || "";
        const appendRegexLabel = options.appendRegexLabel || "";
        const history = options.history || [];
        const flexibleHeight = !!options.flexibleHeight;
        const flexibleWidth = !!options.flexibleWidth;
        const flexibleMaxHeight = options.flexibleMaxHeight;
        this.domNode = document.createElement("div");
        this.domNode.classList.add("monaco-findInput");
        this.inputBox = this._register(new (0, _inputBoxJs.HistoryInputBox)(this.domNode, contextViewProvider, {
            placeholder: this.placeholder || "",
            ariaLabel: this.label || "",
            validationOptions: {
                validation: this.validation
            },
            history,
            showHistoryHint: options.showHistoryHint,
            flexibleHeight,
            flexibleWidth,
            flexibleMaxHeight,
            inputBoxStyles: options.inputBoxStyles
        }));
        const hoverDelegate = this._register((0, _hoverDelegateFactoryJs.createInstantHoverDelegate)());
        if (this.showCommonFindToggles) {
            this.regex = this._register(new (0, _findInputTogglesJs.RegexToggle)({
                appendTitle: appendRegexLabel,
                isChecked: false,
                hoverDelegate,
                ...options.toggleStyles
            }));
            this._register(this.regex.onChange((viaKeyboard)=>{
                this._onDidOptionChange.fire(viaKeyboard);
                if (!viaKeyboard && this.fixFocusOnOptionClickEnabled) this.inputBox.focus();
                this.validate();
            }));
            this._register(this.regex.onKeyDown((e)=>{
                this._onRegexKeyDown.fire(e);
            }));
            this.wholeWords = this._register(new (0, _findInputTogglesJs.WholeWordsToggle)({
                appendTitle: appendWholeWordsLabel,
                isChecked: false,
                hoverDelegate,
                ...options.toggleStyles
            }));
            this._register(this.wholeWords.onChange((viaKeyboard)=>{
                this._onDidOptionChange.fire(viaKeyboard);
                if (!viaKeyboard && this.fixFocusOnOptionClickEnabled) this.inputBox.focus();
                this.validate();
            }));
            this.caseSensitive = this._register(new (0, _findInputTogglesJs.CaseSensitiveToggle)({
                appendTitle: appendCaseSensitiveLabel,
                isChecked: false,
                hoverDelegate,
                ...options.toggleStyles
            }));
            this._register(this.caseSensitive.onChange((viaKeyboard)=>{
                this._onDidOptionChange.fire(viaKeyboard);
                if (!viaKeyboard && this.fixFocusOnOptionClickEnabled) this.inputBox.focus();
                this.validate();
            }));
            this._register(this.caseSensitive.onKeyDown((e)=>{
                this._onCaseSensitiveKeyDown.fire(e);
            }));
            // Arrow-Key support to navigate between options
            const indexes = [
                this.caseSensitive.domNode,
                this.wholeWords.domNode,
                this.regex.domNode
            ];
            this.onkeydown(this.domNode, (event)=>{
                if (event.equals(15 /* KeyCode.LeftArrow */ ) || event.equals(17 /* KeyCode.RightArrow */ ) || event.equals(9 /* KeyCode.Escape */ )) {
                    const index = indexes.indexOf(this.domNode.ownerDocument.activeElement);
                    if (index >= 0) {
                        let newIndex = -1;
                        if (event.equals(17 /* KeyCode.RightArrow */ )) newIndex = (index + 1) % indexes.length;
                        else if (event.equals(15 /* KeyCode.LeftArrow */ )) {
                            if (index === 0) newIndex = indexes.length - 1;
                            else newIndex = index - 1;
                        }
                        if (event.equals(9 /* KeyCode.Escape */ )) {
                            indexes[index].blur();
                            this.inputBox.focus();
                        } else if (newIndex >= 0) indexes[newIndex].focus();
                        _domJs.EventHelper.stop(event, true);
                    }
                }
            });
        }
        this.controls = document.createElement("div");
        this.controls.className = "controls";
        this.controls.style.display = this.showCommonFindToggles ? "" : "none";
        if (this.caseSensitive) this.controls.append(this.caseSensitive.domNode);
        if (this.wholeWords) this.controls.appendChild(this.wholeWords.domNode);
        if (this.regex) this.controls.appendChild(this.regex.domNode);
        this.setAdditionalToggles(options?.additionalToggles);
        if (this.controls) this.domNode.appendChild(this.controls);
        parent?.appendChild(this.domNode);
        this._register(_domJs.addDisposableListener(this.inputBox.inputElement, "compositionstart", (e)=>{
            this.imeSessionInProgress = true;
        }));
        this._register(_domJs.addDisposableListener(this.inputBox.inputElement, "compositionend", (e)=>{
            this.imeSessionInProgress = false;
            this._onInput.fire();
        }));
        this.onkeydown(this.inputBox.inputElement, (e)=>this._onKeyDown.fire(e));
        this.onkeyup(this.inputBox.inputElement, (e)=>this._onKeyUp.fire(e));
        this.oninput(this.inputBox.inputElement, (e)=>this._onInput.fire());
        this.onmousedown(this.inputBox.inputElement, (e)=>this._onMouseDown.fire(e));
    }
    get onDidChange() {
        return this.inputBox.onDidChange;
    }
    layout(style) {
        this.inputBox.layout();
        this.updateInputBoxPadding(style.collapsedFindWidget);
    }
    enable() {
        this.domNode.classList.remove("disabled");
        this.inputBox.enable();
        this.regex?.enable();
        this.wholeWords?.enable();
        this.caseSensitive?.enable();
        for (const toggle of this.additionalToggles)toggle.enable();
    }
    disable() {
        this.domNode.classList.add("disabled");
        this.inputBox.disable();
        this.regex?.disable();
        this.wholeWords?.disable();
        this.caseSensitive?.disable();
        for (const toggle of this.additionalToggles)toggle.disable();
    }
    setFocusInputOnOptionClick(value) {
        this.fixFocusOnOptionClickEnabled = value;
    }
    setEnabled(enabled) {
        if (enabled) this.enable();
        else this.disable();
    }
    setAdditionalToggles(toggles) {
        for (const currentToggle of this.additionalToggles)currentToggle.domNode.remove();
        this.additionalToggles = [];
        this.additionalTogglesDisposables.value = new (0, _lifecycleJs.DisposableStore)();
        for (const toggle of toggles ?? []){
            this.additionalTogglesDisposables.value.add(toggle);
            this.controls.appendChild(toggle.domNode);
            this.additionalTogglesDisposables.value.add(toggle.onChange((viaKeyboard)=>{
                this._onDidOptionChange.fire(viaKeyboard);
                if (!viaKeyboard && this.fixFocusOnOptionClickEnabled) this.inputBox.focus();
            }));
            this.additionalToggles.push(toggle);
        }
        if (this.additionalToggles.length > 0) this.controls.style.display = "";
        this.updateInputBoxPadding();
    }
    updateInputBoxPadding(controlsHidden = false) {
        if (controlsHidden) this.inputBox.paddingRight = 0;
        else this.inputBox.paddingRight = (this.caseSensitive?.width() ?? 0) + (this.wholeWords?.width() ?? 0) + (this.regex?.width() ?? 0) + this.additionalToggles.reduce((r, t)=>r + t.width(), 0);
    }
    getValue() {
        return this.inputBox.value;
    }
    setValue(value) {
        if (this.inputBox.value !== value) this.inputBox.value = value;
    }
    select() {
        this.inputBox.select();
    }
    focus() {
        this.inputBox.focus();
    }
    getCaseSensitive() {
        return this.caseSensitive?.checked ?? false;
    }
    setCaseSensitive(value) {
        if (this.caseSensitive) this.caseSensitive.checked = value;
    }
    getWholeWords() {
        return this.wholeWords?.checked ?? false;
    }
    setWholeWords(value) {
        if (this.wholeWords) this.wholeWords.checked = value;
    }
    getRegex() {
        return this.regex?.checked ?? false;
    }
    setRegex(value) {
        if (this.regex) {
            this.regex.checked = value;
            this.validate();
        }
    }
    focusOnCaseSensitive() {
        this.caseSensitive?.focus();
    }
    highlightFindOptions() {
        this.domNode.classList.remove("highlight-" + this._lastHighlightFindOptions);
        this._lastHighlightFindOptions = 1 - this._lastHighlightFindOptions;
        this.domNode.classList.add("highlight-" + this._lastHighlightFindOptions);
    }
    validate() {
        this.inputBox.validate();
    }
    showMessage(message) {
        this.inputBox.showMessage(message);
    }
    clearMessage() {
        this.inputBox.hideMessage();
    }
}

},{"../../dom.js":"bnqsM","./findInputToggles.js":"h4mwj","../inputbox/inputBox.js":"aE5HZ","../widget.js":"kM4DP","../../../common/event.js":"4Zi8b","./findInput.css":"8KxY6","../../../../nls.js":"l617d","../../../common/lifecycle.js":"9kg8d","../hover/hoverDelegateFactory.js":"kll4h","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h4mwj":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CaseSensitiveToggle", ()=>CaseSensitiveToggle);
parcelHelpers.export(exports, "WholeWordsToggle", ()=>WholeWordsToggle);
parcelHelpers.export(exports, "RegexToggle", ()=>RegexToggle);
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _toggleJs = require("../toggle/toggle.js");
var _codiconsJs = require("../../../common/codicons.js");
var _nlsJs = require("../../../../nls.js");
const NLS_CASE_SENSITIVE_TOGGLE_LABEL = _nlsJs.localize("caseDescription", "Match Case");
const NLS_WHOLE_WORD_TOGGLE_LABEL = _nlsJs.localize("wordsDescription", "Match Whole Word");
const NLS_REGEX_TOGGLE_LABEL = _nlsJs.localize("regexDescription", "Use Regular Expression");
class CaseSensitiveToggle extends (0, _toggleJs.Toggle) {
    constructor(opts){
        super({
            icon: (0, _codiconsJs.Codicon).caseSensitive,
            title: NLS_CASE_SENSITIVE_TOGGLE_LABEL + opts.appendTitle,
            isChecked: opts.isChecked,
            hoverDelegate: opts.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("element"),
            inputActiveOptionBorder: opts.inputActiveOptionBorder,
            inputActiveOptionForeground: opts.inputActiveOptionForeground,
            inputActiveOptionBackground: opts.inputActiveOptionBackground
        });
    }
}
class WholeWordsToggle extends (0, _toggleJs.Toggle) {
    constructor(opts){
        super({
            icon: (0, _codiconsJs.Codicon).wholeWord,
            title: NLS_WHOLE_WORD_TOGGLE_LABEL + opts.appendTitle,
            isChecked: opts.isChecked,
            hoverDelegate: opts.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("element"),
            inputActiveOptionBorder: opts.inputActiveOptionBorder,
            inputActiveOptionForeground: opts.inputActiveOptionForeground,
            inputActiveOptionBackground: opts.inputActiveOptionBackground
        });
    }
}
class RegexToggle extends (0, _toggleJs.Toggle) {
    constructor(opts){
        super({
            icon: (0, _codiconsJs.Codicon).regex,
            title: NLS_REGEX_TOGGLE_LABEL + opts.appendTitle,
            isChecked: opts.isChecked,
            hoverDelegate: opts.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("element"),
            inputActiveOptionBorder: opts.inputActiveOptionBorder,
            inputActiveOptionForeground: opts.inputActiveOptionForeground,
            inputActiveOptionBackground: opts.inputActiveOptionBackground
        });
    }
}

},{"../hover/hoverDelegateFactory.js":"kll4h","../toggle/toggle.js":"3QqQn","../../../common/codicons.js":"hWYNf","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aE5HZ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unthemedInboxStyles", ()=>unthemedInboxStyles);
parcelHelpers.export(exports, "InputBox", ()=>InputBox);
parcelHelpers.export(exports, "HistoryInputBox", ()=>HistoryInputBox);
var _domJs = require("../../dom.js");
var _eventJs = require("../../event.js");
var _formattedTextRendererJs = require("../../formattedTextRenderer.js");
var _actionbarJs = require("../actionbar/actionbar.js");
var _ariaJs = require("../aria/aria.js");
var _hoverDelegate2Js = require("../hover/hoverDelegate2.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _scrollableElementJs = require("../scrollbar/scrollableElement.js");
var _widgetJs = require("../widget.js");
var _eventJs1 = require("../../../common/event.js");
var _historyJs = require("../../../common/history.js");
var _objectsJs = require("../../../common/objects.js");
var _inputBoxCss = require("./inputBox.css");
var _nlsJs = require("../../../../nls.js");
const $ = _domJs.$;
const unthemedInboxStyles = {
    inputBackground: "#3C3C3C",
    inputForeground: "#CCCCCC",
    inputValidationInfoBorder: "#55AAFF",
    inputValidationInfoBackground: "#063B49",
    inputValidationWarningBorder: "#B89500",
    inputValidationWarningBackground: "#352A05",
    inputValidationErrorBorder: "#BE1100",
    inputValidationErrorBackground: "#5A1D1D",
    inputBorder: undefined,
    inputValidationErrorForeground: undefined,
    inputValidationInfoForeground: undefined,
    inputValidationWarningForeground: undefined
};
class InputBox extends (0, _widgetJs.Widget) {
    constructor(container, contextViewProvider, options){
        super();
        this.state = "idle";
        this.maxHeight = Number.POSITIVE_INFINITY;
        this._onDidChange = this._register(new (0, _eventJs1.Emitter)());
        this.onDidChange = this._onDidChange.event;
        this._onDidHeightChange = this._register(new (0, _eventJs1.Emitter)());
        this.onDidHeightChange = this._onDidHeightChange.event;
        this.contextViewProvider = contextViewProvider;
        this.options = options;
        this.message = null;
        this.placeholder = this.options.placeholder || "";
        this.tooltip = this.options.tooltip ?? (this.placeholder || "");
        this.ariaLabel = this.options.ariaLabel || "";
        if (this.options.validationOptions) this.validation = this.options.validationOptions.validation;
        this.element = _domJs.append(container, $(".monaco-inputbox.idle"));
        const tagName = this.options.flexibleHeight ? "textarea" : "input";
        const wrapper = _domJs.append(this.element, $(".ibwrapper"));
        this.input = _domJs.append(wrapper, $(tagName + ".input.empty"));
        this.input.setAttribute("autocorrect", "off");
        this.input.setAttribute("autocapitalize", "off");
        this.input.setAttribute("spellcheck", "false");
        this.onfocus(this.input, ()=>this.element.classList.add("synthetic-focus"));
        this.onblur(this.input, ()=>this.element.classList.remove("synthetic-focus"));
        if (this.options.flexibleHeight) {
            this.maxHeight = typeof this.options.flexibleMaxHeight === "number" ? this.options.flexibleMaxHeight : Number.POSITIVE_INFINITY;
            this.mirror = _domJs.append(wrapper, $("div.mirror"));
            this.mirror.innerText = "\xa0";
            this.scrollableElement = new (0, _scrollableElementJs.ScrollableElement)(this.element, {
                vertical: 1 /* ScrollbarVisibility.Auto */ 
            });
            if (this.options.flexibleWidth) {
                this.input.setAttribute("wrap", "off");
                this.mirror.style.whiteSpace = "pre";
                this.mirror.style.wordWrap = "initial";
            }
            _domJs.append(container, this.scrollableElement.getDomNode());
            this._register(this.scrollableElement);
            // from ScrollableElement to DOM
            this._register(this.scrollableElement.onScroll((e)=>this.input.scrollTop = e.scrollTop));
            const onSelectionChange = this._register(new (0, _eventJs.DomEmitter)(container.ownerDocument, "selectionchange"));
            const onAnchoredSelectionChange = (0, _eventJs1.Event).filter(onSelectionChange.event, ()=>{
                const selection = container.ownerDocument.getSelection();
                return selection?.anchorNode === wrapper;
            });
            // from DOM to ScrollableElement
            this._register(onAnchoredSelectionChange(this.updateScrollDimensions, this));
            this._register(this.onDidHeightChange(this.updateScrollDimensions, this));
        } else {
            this.input.type = this.options.type || "text";
            this.input.setAttribute("wrap", "off");
        }
        if (this.ariaLabel) this.input.setAttribute("aria-label", this.ariaLabel);
        if (this.placeholder && !this.options.showPlaceholderOnFocus) this.setPlaceHolder(this.placeholder);
        if (this.tooltip) this.setTooltip(this.tooltip);
        this.oninput(this.input, ()=>this.onValueChange());
        this.onblur(this.input, ()=>this.onBlur());
        this.onfocus(this.input, ()=>this.onFocus());
        this._register(this.ignoreGesture(this.input));
        setTimeout(()=>this.updateMirror(), 0);
        // Support actions
        if (this.options.actions) {
            this.actionbar = this._register(new (0, _actionbarJs.ActionBar)(this.element));
            this.actionbar.push(this.options.actions, {
                icon: true,
                label: false
            });
        }
        this.applyStyles();
    }
    onBlur() {
        this._hideMessage();
        if (this.options.showPlaceholderOnFocus) this.input.setAttribute("placeholder", "");
    }
    onFocus() {
        this._showMessage();
        if (this.options.showPlaceholderOnFocus) this.input.setAttribute("placeholder", this.placeholder || "");
    }
    setPlaceHolder(placeHolder) {
        this.placeholder = placeHolder;
        this.input.setAttribute("placeholder", placeHolder);
    }
    setTooltip(tooltip) {
        this.tooltip = tooltip;
        if (!this.hover) this.hover = this._register((0, _hoverDelegate2Js.getBaseLayerHoverDelegate)().setupManagedHover((0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("mouse"), this.input, tooltip));
        else this.hover.update(tooltip);
    }
    get inputElement() {
        return this.input;
    }
    get value() {
        return this.input.value;
    }
    set value(newValue) {
        if (this.input.value !== newValue) {
            this.input.value = newValue;
            this.onValueChange();
        }
    }
    get height() {
        return typeof this.cachedHeight === "number" ? this.cachedHeight : _domJs.getTotalHeight(this.element);
    }
    focus() {
        this.input.focus();
    }
    blur() {
        this.input.blur();
    }
    hasFocus() {
        return _domJs.isActiveElement(this.input);
    }
    select(range = null) {
        this.input.select();
        if (range) {
            this.input.setSelectionRange(range.start, range.end);
            if (range.end === this.input.value.length) this.input.scrollLeft = this.input.scrollWidth;
        }
    }
    isSelectionAtEnd() {
        return this.input.selectionEnd === this.input.value.length && this.input.selectionStart === this.input.selectionEnd;
    }
    getSelection() {
        const selectionStart = this.input.selectionStart;
        if (selectionStart === null) return null;
        const selectionEnd = this.input.selectionEnd ?? selectionStart;
        return {
            start: selectionStart,
            end: selectionEnd
        };
    }
    enable() {
        this.input.removeAttribute("disabled");
    }
    disable() {
        this.blur();
        this.input.disabled = true;
        this._hideMessage();
    }
    set paddingRight(paddingRight) {
        // Set width to avoid hint text overlapping buttons
        this.input.style.width = `calc(100% - ${paddingRight}px)`;
        if (this.mirror) this.mirror.style.paddingRight = paddingRight + "px";
    }
    updateScrollDimensions() {
        if (typeof this.cachedContentHeight !== "number" || typeof this.cachedHeight !== "number" || !this.scrollableElement) return;
        const scrollHeight = this.cachedContentHeight;
        const height = this.cachedHeight;
        const scrollTop = this.input.scrollTop;
        this.scrollableElement.setScrollDimensions({
            scrollHeight,
            height
        });
        this.scrollableElement.setScrollPosition({
            scrollTop
        });
    }
    showMessage(message, force) {
        if (this.state === "open" && (0, _objectsJs.equals)(this.message, message)) // Already showing
        return;
        this.message = message;
        this.element.classList.remove("idle");
        this.element.classList.remove("info");
        this.element.classList.remove("warning");
        this.element.classList.remove("error");
        this.element.classList.add(this.classForType(message.type));
        const styles = this.stylesForType(this.message.type);
        this.element.style.border = `1px solid ${_domJs.asCssValueWithDefault(styles.border, "transparent")}`;
        if (this.message.content && (this.hasFocus() || force)) this._showMessage();
    }
    hideMessage() {
        this.message = null;
        this.element.classList.remove("info");
        this.element.classList.remove("warning");
        this.element.classList.remove("error");
        this.element.classList.add("idle");
        this._hideMessage();
        this.applyStyles();
    }
    validate() {
        let errorMsg = null;
        if (this.validation) {
            errorMsg = this.validation(this.value);
            if (errorMsg) {
                this.inputElement.setAttribute("aria-invalid", "true");
                this.showMessage(errorMsg);
            } else if (this.inputElement.hasAttribute("aria-invalid")) {
                this.inputElement.removeAttribute("aria-invalid");
                this.hideMessage();
            }
        }
        return errorMsg?.type;
    }
    stylesForType(type) {
        const styles = this.options.inputBoxStyles;
        switch(type){
            case 1 /* MessageType.INFO */ :
                return {
                    border: styles.inputValidationInfoBorder,
                    background: styles.inputValidationInfoBackground,
                    foreground: styles.inputValidationInfoForeground
                };
            case 2 /* MessageType.WARNING */ :
                return {
                    border: styles.inputValidationWarningBorder,
                    background: styles.inputValidationWarningBackground,
                    foreground: styles.inputValidationWarningForeground
                };
            default:
                return {
                    border: styles.inputValidationErrorBorder,
                    background: styles.inputValidationErrorBackground,
                    foreground: styles.inputValidationErrorForeground
                };
        }
    }
    classForType(type) {
        switch(type){
            case 1 /* MessageType.INFO */ :
                return "info";
            case 2 /* MessageType.WARNING */ :
                return "warning";
            default:
                return "error";
        }
    }
    _showMessage() {
        if (!this.contextViewProvider || !this.message) return;
        let div;
        const layout = ()=>div.style.width = _domJs.getTotalWidth(this.element) + "px";
        this.contextViewProvider.showContextView({
            getAnchor: ()=>this.element,
            anchorAlignment: 1 /* AnchorAlignment.RIGHT */ ,
            render: (container)=>{
                if (!this.message) return null;
                div = _domJs.append(container, $(".monaco-inputbox-container"));
                layout();
                const renderOptions = {
                    inline: true,
                    className: "monaco-inputbox-message"
                };
                const spanElement = this.message.formatContent ? (0, _formattedTextRendererJs.renderFormattedText)(this.message.content, renderOptions) : (0, _formattedTextRendererJs.renderText)(this.message.content, renderOptions);
                spanElement.classList.add(this.classForType(this.message.type));
                const styles = this.stylesForType(this.message.type);
                spanElement.style.backgroundColor = styles.background ?? "";
                spanElement.style.color = styles.foreground ?? "";
                spanElement.style.border = styles.border ? `1px solid ${styles.border}` : "";
                _domJs.append(div, spanElement);
                return null;
            },
            onHide: ()=>{
                this.state = "closed";
            },
            layout: layout
        });
        // ARIA Support
        let alertText;
        if (this.message.type === 3 /* MessageType.ERROR */ ) alertText = _nlsJs.localize("alertErrorMessage", "Error: {0}", this.message.content);
        else if (this.message.type === 2 /* MessageType.WARNING */ ) alertText = _nlsJs.localize("alertWarningMessage", "Warning: {0}", this.message.content);
        else alertText = _nlsJs.localize("alertInfoMessage", "Info: {0}", this.message.content);
        _ariaJs.alert(alertText);
        this.state = "open";
    }
    _hideMessage() {
        if (!this.contextViewProvider) return;
        if (this.state === "open") this.contextViewProvider.hideContextView();
        this.state = "idle";
    }
    onValueChange() {
        this._onDidChange.fire(this.value);
        this.validate();
        this.updateMirror();
        this.input.classList.toggle("empty", !this.value);
        if (this.state === "open" && this.contextViewProvider) this.contextViewProvider.layout();
    }
    updateMirror() {
        if (!this.mirror) return;
        const value = this.value;
        const lastCharCode = value.charCodeAt(value.length - 1);
        const suffix = lastCharCode === 10 ? " " : "";
        const mirrorTextContent = (value + suffix).replace(/\u000c/g, ""); // Don't measure with the form feed character, which messes up sizing
        if (mirrorTextContent) this.mirror.textContent = value + suffix;
        else this.mirror.innerText = "\xa0";
        this.layout();
    }
    applyStyles() {
        const styles = this.options.inputBoxStyles;
        const background = styles.inputBackground ?? "";
        const foreground = styles.inputForeground ?? "";
        const border = styles.inputBorder ?? "";
        this.element.style.backgroundColor = background;
        this.element.style.color = foreground;
        this.input.style.backgroundColor = "inherit";
        this.input.style.color = foreground;
        // there's always a border, even if the color is not set.
        this.element.style.border = `1px solid ${_domJs.asCssValueWithDefault(border, "transparent")}`;
    }
    layout() {
        if (!this.mirror) return;
        const previousHeight = this.cachedContentHeight;
        this.cachedContentHeight = _domJs.getTotalHeight(this.mirror);
        if (previousHeight !== this.cachedContentHeight) {
            this.cachedHeight = Math.min(this.cachedContentHeight, this.maxHeight);
            this.input.style.height = this.cachedHeight + "px";
            this._onDidHeightChange.fire(this.cachedContentHeight);
        }
    }
    insertAtCursor(text) {
        const inputElement = this.inputElement;
        const start = inputElement.selectionStart;
        const end = inputElement.selectionEnd;
        const content = inputElement.value;
        if (start !== null && end !== null) {
            this.value = content.substr(0, start) + text + content.substr(end);
            inputElement.setSelectionRange(start + 1, start + 1);
            this.layout();
        }
    }
    dispose() {
        this._hideMessage();
        this.message = null;
        this.actionbar?.dispose();
        super.dispose();
    }
}
class HistoryInputBox extends InputBox {
    constructor(container, contextViewProvider, options){
        const NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_NO_PARENS = _nlsJs.localize({
            key: "history.inputbox.hint.suffix.noparens",
            comment: [
                'Text is the suffix of an input field placeholder coming after the action the input field performs, this will be used when the input field ends in a closing parenthesis ")", for example "Filter (e.g. text, !exclude)". The character inserted into the final string is \u21C5 to represent the up and down arrow keys.'
            ]
        }, " or {0} for history", `\u21C5`);
        const NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_IN_PARENS = _nlsJs.localize({
            key: "history.inputbox.hint.suffix.inparens",
            comment: [
                'Text is the suffix of an input field placeholder coming after the action the input field performs, this will be used when the input field does NOT end in a closing parenthesis (eg. "Find"). The character inserted into the final string is \u21C5 to represent the up and down arrow keys.'
            ]
        }, " ({0} for history)", `\u21C5`);
        super(container, contextViewProvider, options);
        this._onDidFocus = this._register(new (0, _eventJs1.Emitter)());
        this.onDidFocus = this._onDidFocus.event;
        this._onDidBlur = this._register(new (0, _eventJs1.Emitter)());
        this.onDidBlur = this._onDidBlur.event;
        this.history = new (0, _historyJs.HistoryNavigator)(options.history, 100);
        // Function to append the history suffix to the placeholder if necessary
        const addSuffix = ()=>{
            if (options.showHistoryHint && options.showHistoryHint() && !this.placeholder.endsWith(NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_NO_PARENS) && !this.placeholder.endsWith(NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_IN_PARENS) && this.history.getHistory().length) {
                const suffix = this.placeholder.endsWith(")") ? NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_NO_PARENS : NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_IN_PARENS;
                const suffixedPlaceholder = this.placeholder + suffix;
                if (options.showPlaceholderOnFocus && !_domJs.isActiveElement(this.input)) this.placeholder = suffixedPlaceholder;
                else this.setPlaceHolder(suffixedPlaceholder);
            }
        };
        // Spot the change to the textarea class attribute which occurs when it changes between non-empty and empty,
        // and add the history suffix to the placeholder if not yet present
        this.observer = new MutationObserver((mutationList, observer)=>{
            mutationList.forEach((mutation)=>{
                if (!mutation.target.textContent) addSuffix();
            });
        });
        this.observer.observe(this.input, {
            attributeFilter: [
                "class"
            ]
        });
        this.onfocus(this.input, ()=>addSuffix());
        this.onblur(this.input, ()=>{
            const resetPlaceholder = (historyHint)=>{
                if (!this.placeholder.endsWith(historyHint)) return false;
                else {
                    const revertedPlaceholder = this.placeholder.slice(0, this.placeholder.length - historyHint.length);
                    if (options.showPlaceholderOnFocus) this.placeholder = revertedPlaceholder;
                    else this.setPlaceHolder(revertedPlaceholder);
                    return true;
                }
            };
            if (!resetPlaceholder(NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_IN_PARENS)) resetPlaceholder(NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_NO_PARENS);
        });
    }
    dispose() {
        super.dispose();
        if (this.observer) {
            this.observer.disconnect();
            this.observer = undefined;
        }
    }
    addToHistory(always) {
        if (this.value && (always || this.value !== this.getCurrentValue())) this.history.add(this.value);
    }
    isAtLastInHistory() {
        return this.history.isLast();
    }
    isNowhereInHistory() {
        return this.history.isNowhere();
    }
    showNextValue() {
        if (!this.history.has(this.value)) this.addToHistory();
        let next = this.getNextValue();
        if (next) next = next === this.value ? this.getNextValue() : next;
        this.value = next ?? "";
        _ariaJs.status(this.value ? this.value : _nlsJs.localize("clearedInput", "Cleared Input"));
    }
    showPreviousValue() {
        if (!this.history.has(this.value)) this.addToHistory();
        let previous = this.getPreviousValue();
        if (previous) previous = previous === this.value ? this.getPreviousValue() : previous;
        if (previous) {
            this.value = previous;
            _ariaJs.status(this.value);
        }
    }
    setPlaceHolder(placeHolder) {
        super.setPlaceHolder(placeHolder);
        this.setTooltip(placeHolder);
    }
    onBlur() {
        super.onBlur();
        this._onDidBlur.fire();
    }
    onFocus() {
        super.onFocus();
        this._onDidFocus.fire();
    }
    getCurrentValue() {
        let currentValue = this.history.current();
        if (!currentValue) {
            currentValue = this.history.last();
            this.history.next();
        }
        return currentValue;
    }
    getPreviousValue() {
        return this.history.previous() || this.history.first();
    }
    getNextValue() {
        return this.history.next();
    }
}

},{"../../dom.js":"bnqsM","../../event.js":"PHN3G","../../formattedTextRenderer.js":"jCbdG","../actionbar/actionbar.js":"5Xmba","../aria/aria.js":"asrsh","../hover/hoverDelegate2.js":"5jqL3","../hover/hoverDelegateFactory.js":"kll4h","../scrollbar/scrollableElement.js":"h1C5l","../widget.js":"kM4DP","../../../common/event.js":"4Zi8b","../../../common/history.js":"6U9AU","../../../common/objects.js":"j84mT","./inputBox.css":"8SHyF","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6U9AU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HistoryNavigator", ()=>HistoryNavigator);
var _navigatorJs = require("./navigator.js");
class HistoryNavigator {
    constructor(history = [], limit = 10){
        this._initialize(history);
        this._limit = limit;
        this._onChange();
    }
    getHistory() {
        return this._elements;
    }
    add(t) {
        this._history.delete(t);
        this._history.add(t);
        this._onChange();
    }
    next() {
        // This will navigate past the end of the last element, and in that case the input should be cleared
        return this._navigator.next();
    }
    previous() {
        if (this._currentPosition() !== 0) return this._navigator.previous();
        return null;
    }
    current() {
        return this._navigator.current();
    }
    first() {
        return this._navigator.first();
    }
    last() {
        return this._navigator.last();
    }
    isLast() {
        return this._currentPosition() >= this._elements.length - 1;
    }
    isNowhere() {
        return this._navigator.current() === null;
    }
    has(t) {
        return this._history.has(t);
    }
    _onChange() {
        this._reduceToLimit();
        const elements = this._elements;
        this._navigator = new (0, _navigatorJs.ArrayNavigator)(elements, 0, elements.length, elements.length);
    }
    _reduceToLimit() {
        const data = this._elements;
        if (data.length > this._limit) this._initialize(data.slice(data.length - this._limit));
    }
    _currentPosition() {
        const currentElement = this._navigator.current();
        if (!currentElement) return -1;
        return this._elements.indexOf(currentElement);
    }
    _initialize(history) {
        this._history = new Set();
        for (const entry of history)this._history.add(entry);
    }
    get _elements() {
        const elements = [];
        this._history.forEach((e)=>elements.push(e));
        return elements;
    }
}

},{"./navigator.js":"lKASw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lKASw":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrayNavigator", ()=>ArrayNavigator);
class ArrayNavigator {
    constructor(items, start = 0, end = items.length, index = start - 1){
        this.items = items;
        this.start = start;
        this.end = end;
        this.index = index;
    }
    current() {
        if (this.index === this.start - 1 || this.index === this.end) return null;
        return this.items[this.index];
    }
    next() {
        this.index = Math.min(this.index + 1, this.end);
        return this.current();
    }
    previous() {
        this.index = Math.max(this.index - 1, this.start - 1);
        return this.current();
    }
    first() {
        this.index = this.start;
        return this.current();
    }
    last() {
        this.index = this.end - 1;
        return this.current();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8SHyF":[function() {},{}],"8KxY6":[function() {},{}],"kd5QF":[function() {},{}],"0qxvt":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuickInputTree", ()=>QuickInputTree);
var _domJs = require("../../../base/browser/dom.js");
var _eventJs = require("../../../base/common/event.js");
var _nlsJs = require("../../../nls.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var _listServiceJs = require("../../list/browser/listService.js");
var _themeServiceJs = require("../../theme/common/themeService.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _quickInputJs = require("../common/quickInput.js");
var _keyboardEventJs = require("../../../base/browser/keyboardEvent.js");
var _platformJs = require("../../../base/common/platform.js");
var _decoratorsJs = require("../../../base/common/decorators.js");
var _iconLabelJs = require("../../../base/browser/ui/iconLabel/iconLabel.js");
var _keybindingLabelJs = require("../../../base/browser/ui/keybindingLabel/keybindingLabel.js");
var _actionbarJs = require("../../../base/browser/ui/actionbar/actionbar.js");
var _themeJs = require("../../theme/common/theme.js");
var _uriJs = require("../../../base/common/uri.js");
var _quickInputUtilsJs = require("./quickInputUtils.js");
var _lazyJs = require("../../../base/common/lazy.js");
var _iconLabelsJs = require("../../../base/common/iconLabels.js");
var _comparersJs = require("../../../base/common/comparers.js");
var _stringsJs = require("../../../base/common/strings.js");
var _abstractTreeJs = require("../../../base/browser/ui/tree/abstractTree.js");
var _asyncJs = require("../../../base/common/async.js");
var _errorsJs = require("../../../base/common/errors.js");
var _accessibilityJs = require("../../accessibility/common/accessibility.js");
var _observableJs = require("../../../base/common/observable.js");
var _arraysJs = require("../../../base/common/arrays.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var QuickPickItemElementRenderer_1;
const $ = _domJs.$;
class BaseQuickPickItemElement {
    constructor(index, hasCheckbox, mainItem){
        this.index = index;
        this.hasCheckbox = hasCheckbox;
        this._hidden = false;
        this._init = new (0, _lazyJs.Lazy)(()=>{
            const saneLabel = mainItem.label ?? "";
            const saneSortLabel = (0, _iconLabelsJs.parseLabelWithIcons)(saneLabel).text.trim();
            const saneAriaLabel = mainItem.ariaLabel || [
                saneLabel,
                this.saneDescription,
                this.saneDetail
            ].map((s)=>(0, _iconLabelsJs.getCodiconAriaLabel)(s)).filter((s)=>!!s).join(", ");
            return {
                saneLabel,
                saneSortLabel,
                saneAriaLabel
            };
        });
        this._saneDescription = mainItem.description;
        this._saneTooltip = mainItem.tooltip;
    }
    // #region Lazy Getters
    get saneLabel() {
        return this._init.value.saneLabel;
    }
    get saneSortLabel() {
        return this._init.value.saneSortLabel;
    }
    get saneAriaLabel() {
        return this._init.value.saneAriaLabel;
    }
    get element() {
        return this._element;
    }
    set element(value) {
        this._element = value;
    }
    get hidden() {
        return this._hidden;
    }
    set hidden(value) {
        this._hidden = value;
    }
    get saneDescription() {
        return this._saneDescription;
    }
    set saneDescription(value) {
        this._saneDescription = value;
    }
    get saneDetail() {
        return this._saneDetail;
    }
    set saneDetail(value) {
        this._saneDetail = value;
    }
    get saneTooltip() {
        return this._saneTooltip;
    }
    set saneTooltip(value) {
        this._saneTooltip = value;
    }
    get labelHighlights() {
        return this._labelHighlights;
    }
    set labelHighlights(value) {
        this._labelHighlights = value;
    }
    get descriptionHighlights() {
        return this._descriptionHighlights;
    }
    set descriptionHighlights(value) {
        this._descriptionHighlights = value;
    }
    get detailHighlights() {
        return this._detailHighlights;
    }
    set detailHighlights(value) {
        this._detailHighlights = value;
    }
}
class QuickPickItemElement extends BaseQuickPickItemElement {
    constructor(index, hasCheckbox, fireButtonTriggered, _onChecked, item, _separator){
        super(index, hasCheckbox, item);
        this.fireButtonTriggered = fireButtonTriggered;
        this._onChecked = _onChecked;
        this.item = item;
        this._separator = _separator;
        this._checked = false;
        this.onChecked = hasCheckbox ? (0, _eventJs.Event).map((0, _eventJs.Event).filter(this._onChecked.event, (e)=>e.element === this), (e)=>e.checked) : (0, _eventJs.Event).None;
        this._saneDetail = item.detail;
        this._labelHighlights = item.highlights?.label;
        this._descriptionHighlights = item.highlights?.description;
        this._detailHighlights = item.highlights?.detail;
    }
    get separator() {
        return this._separator;
    }
    set separator(value) {
        this._separator = value;
    }
    get checked() {
        return this._checked;
    }
    set checked(value) {
        if (value !== this._checked) {
            this._checked = value;
            this._onChecked.fire({
                element: this,
                checked: value
            });
        }
    }
    get checkboxDisabled() {
        return !!this.item.disabled;
    }
}
var QuickPickSeparatorFocusReason;
(function(QuickPickSeparatorFocusReason) {
    /**
     * No item is hovered or active
     */ QuickPickSeparatorFocusReason[QuickPickSeparatorFocusReason["NONE"] = 0] = "NONE";
    /**
     * Some item within this section is hovered
     */ QuickPickSeparatorFocusReason[QuickPickSeparatorFocusReason["MOUSE_HOVER"] = 1] = "MOUSE_HOVER";
    /**
     * Some item within this section is active
     */ QuickPickSeparatorFocusReason[QuickPickSeparatorFocusReason["ACTIVE_ITEM"] = 2] = "ACTIVE_ITEM";
})(QuickPickSeparatorFocusReason || (QuickPickSeparatorFocusReason = {}));
class QuickPickSeparatorElement extends BaseQuickPickItemElement {
    constructor(index, fireSeparatorButtonTriggered, separator){
        super(index, false, separator);
        this.fireSeparatorButtonTriggered = fireSeparatorButtonTriggered;
        this.separator = separator;
        this.children = new Array();
        /**
         * If this item is >0, it means that there is some item in the list that is either:
         * * hovered over
         * * active
         */ this.focusInsideSeparator = QuickPickSeparatorFocusReason.NONE;
    }
}
class QuickInputItemDelegate {
    getHeight(element) {
        if (element instanceof QuickPickSeparatorElement) return 30;
        return element.saneDetail ? 44 : 22;
    }
    getTemplateId(element) {
        if (element instanceof QuickPickItemElement) return QuickPickItemElementRenderer.ID;
        else return QuickPickSeparatorElementRenderer.ID;
    }
}
class QuickInputAccessibilityProvider {
    getWidgetAriaLabel() {
        return (0, _nlsJs.localize)("quickInput", "Quick Input");
    }
    getAriaLabel(element) {
        return element.separator?.label ? `${element.saneAriaLabel}, ${element.separator.label}` : element.saneAriaLabel;
    }
    getWidgetRole() {
        return "listbox";
    }
    getRole(element) {
        return element.hasCheckbox ? "checkbox" : "option";
    }
    isChecked(element) {
        if (!element.hasCheckbox || !(element instanceof QuickPickItemElement)) return undefined;
        return {
            get value () {
                return element.checked;
            },
            onDidChange: (e)=>element.onChecked(()=>e())
        };
    }
}
class BaseQuickInputListRenderer {
    constructor(hoverDelegate){
        this.hoverDelegate = hoverDelegate;
    }
    // TODO: only do the common stuff here and have a subclass handle their specific stuff
    renderTemplate(container) {
        const data = Object.create(null);
        data.toDisposeElement = new (0, _lifecycleJs.DisposableStore)();
        data.toDisposeTemplate = new (0, _lifecycleJs.DisposableStore)();
        data.entry = _domJs.append(container, $(".quick-input-list-entry"));
        // Checkbox
        const label = _domJs.append(data.entry, $("label.quick-input-list-label"));
        data.toDisposeTemplate.add(_domJs.addStandardDisposableListener(label, _domJs.EventType.CLICK, (e)=>{
            if (!data.checkbox.offsetParent) e.preventDefault(); // Prevent toggle of checkbox when it is immediately shown afterwards. #91740
        }));
        data.checkbox = _domJs.append(label, $("input.quick-input-list-checkbox"));
        data.checkbox.type = "checkbox";
        // Rows
        const rows = _domJs.append(label, $(".quick-input-list-rows"));
        const row1 = _domJs.append(rows, $(".quick-input-list-row"));
        const row2 = _domJs.append(rows, $(".quick-input-list-row"));
        // Label
        data.label = new (0, _iconLabelJs.IconLabel)(row1, {
            supportHighlights: true,
            supportDescriptionHighlights: true,
            supportIcons: true,
            hoverDelegate: this.hoverDelegate
        });
        data.toDisposeTemplate.add(data.label);
        data.icon = _domJs.prepend(data.label.element, $(".quick-input-list-icon"));
        // Keybinding
        const keybindingContainer = _domJs.append(row1, $(".quick-input-list-entry-keybinding"));
        data.keybinding = new (0, _keybindingLabelJs.KeybindingLabel)(keybindingContainer, (0, _platformJs.OS));
        data.toDisposeTemplate.add(data.keybinding);
        // Detail
        const detailContainer = _domJs.append(row2, $(".quick-input-list-label-meta"));
        data.detail = new (0, _iconLabelJs.IconLabel)(detailContainer, {
            supportHighlights: true,
            supportIcons: true,
            hoverDelegate: this.hoverDelegate
        });
        data.toDisposeTemplate.add(data.detail);
        // Separator
        data.separator = _domJs.append(data.entry, $(".quick-input-list-separator"));
        // Actions
        data.actionBar = new (0, _actionbarJs.ActionBar)(data.entry, this.hoverDelegate ? {
            hoverDelegate: this.hoverDelegate
        } : undefined);
        data.actionBar.domNode.classList.add("quick-input-list-entry-action-bar");
        data.toDisposeTemplate.add(data.actionBar);
        return data;
    }
    disposeTemplate(data) {
        data.toDisposeElement.dispose();
        data.toDisposeTemplate.dispose();
    }
    disposeElement(_element, _index, data) {
        data.toDisposeElement.clear();
        data.actionBar.clear();
    }
}
let QuickPickItemElementRenderer = class QuickPickItemElementRenderer extends BaseQuickInputListRenderer {
    static{
        QuickPickItemElementRenderer_1 = this;
    }
    static{
        this.ID = "quickpickitem";
    }
    constructor(hoverDelegate, themeService){
        super(hoverDelegate);
        this.themeService = themeService;
        // Follow what we do in the separator renderer
        this._itemsWithSeparatorsFrequency = new Map();
    }
    get templateId() {
        return QuickPickItemElementRenderer_1.ID;
    }
    renderTemplate(container) {
        const data = super.renderTemplate(container);
        data.toDisposeTemplate.add(_domJs.addStandardDisposableListener(data.checkbox, _domJs.EventType.CHANGE, (e)=>{
            data.element.checked = data.checkbox.checked;
        }));
        return data;
    }
    renderElement(node, index, data) {
        const element = node.element;
        data.element = element;
        element.element = data.entry ?? undefined;
        const mainItem = element.item;
        data.checkbox.checked = element.checked;
        data.toDisposeElement.add(element.onChecked((checked)=>data.checkbox.checked = checked));
        data.checkbox.disabled = element.checkboxDisabled;
        const { labelHighlights, descriptionHighlights, detailHighlights } = element;
        // Icon
        if (mainItem.iconPath) {
            const icon = (0, _themeJs.isDark)(this.themeService.getColorTheme().type) ? mainItem.iconPath.dark : mainItem.iconPath.light ?? mainItem.iconPath.dark;
            const iconUrl = (0, _uriJs.URI).revive(icon);
            data.icon.className = "quick-input-list-icon";
            data.icon.style.backgroundImage = _domJs.asCSSUrl(iconUrl);
        } else {
            data.icon.style.backgroundImage = "";
            data.icon.className = mainItem.iconClass ? `quick-input-list-icon ${mainItem.iconClass}` : "";
        }
        // Label
        let descriptionTitle;
        // if we have a tooltip, that will be the hover,
        // with the saneDescription as fallback if it
        // is defined
        if (!element.saneTooltip && element.saneDescription) descriptionTitle = {
            markdown: {
                value: element.saneDescription,
                supportThemeIcons: true
            },
            markdownNotSupportedFallback: element.saneDescription
        };
        const options = {
            matches: labelHighlights || [],
            // If we have a tooltip, we want that to be shown and not any other hover
            descriptionTitle,
            descriptionMatches: descriptionHighlights || [],
            labelEscapeNewLines: true
        };
        options.extraClasses = mainItem.iconClasses;
        options.italic = mainItem.italic;
        options.strikethrough = mainItem.strikethrough;
        data.entry.classList.remove("quick-input-list-separator-as-item");
        data.label.setLabel(element.saneLabel, element.saneDescription, options);
        // Keybinding
        data.keybinding.set(mainItem.keybinding);
        // Detail
        if (element.saneDetail) {
            let title;
            // If we have a tooltip, we want that to be shown and not any other hover
            if (!element.saneTooltip) title = {
                markdown: {
                    value: element.saneDetail,
                    supportThemeIcons: true
                },
                markdownNotSupportedFallback: element.saneDetail
            };
            data.detail.element.style.display = "";
            data.detail.setLabel(element.saneDetail, undefined, {
                matches: detailHighlights,
                title,
                labelEscapeNewLines: true
            });
        } else data.detail.element.style.display = "none";
        // Separator
        if (element.separator?.label) {
            data.separator.textContent = element.separator.label;
            data.separator.style.display = "";
            this.addItemWithSeparator(element);
        } else data.separator.style.display = "none";
        data.entry.classList.toggle("quick-input-list-separator-border", !!element.separator);
        // Actions
        const buttons = mainItem.buttons;
        if (buttons && buttons.length) {
            data.actionBar.push(buttons.map((button, index)=>(0, _quickInputUtilsJs.quickInputButtonToAction)(button, `id-${index}`, ()=>element.fireButtonTriggered({
                        button,
                        item: element.item
                    }))), {
                icon: true,
                label: false
            });
            data.entry.classList.add("has-actions");
        } else data.entry.classList.remove("has-actions");
    }
    disposeElement(element, _index, data) {
        this.removeItemWithSeparator(element.element);
        super.disposeElement(element, _index, data);
    }
    isItemWithSeparatorVisible(item) {
        return this._itemsWithSeparatorsFrequency.has(item);
    }
    addItemWithSeparator(item) {
        this._itemsWithSeparatorsFrequency.set(item, (this._itemsWithSeparatorsFrequency.get(item) || 0) + 1);
    }
    removeItemWithSeparator(item) {
        const frequency = this._itemsWithSeparatorsFrequency.get(item) || 0;
        if (frequency > 1) this._itemsWithSeparatorsFrequency.set(item, frequency - 1);
        else this._itemsWithSeparatorsFrequency.delete(item);
    }
};
QuickPickItemElementRenderer = QuickPickItemElementRenderer_1 = __decorate([
    __param(1, (0, _themeServiceJs.IThemeService))
], QuickPickItemElementRenderer);
class QuickPickSeparatorElementRenderer extends BaseQuickInputListRenderer {
    constructor(){
        super(...arguments);
        // This is a frequency map because sticky scroll re-uses the same renderer to render a second
        // instance of the same separator.
        this._visibleSeparatorsFrequency = new Map();
    }
    static{
        this.ID = "quickpickseparator";
    }
    get templateId() {
        return QuickPickSeparatorElementRenderer.ID;
    }
    get visibleSeparators() {
        return [
            ...this._visibleSeparatorsFrequency.keys()
        ];
    }
    isSeparatorVisible(separator) {
        return this._visibleSeparatorsFrequency.has(separator);
    }
    renderTemplate(container) {
        const data = super.renderTemplate(container);
        data.checkbox.style.display = "none";
        return data;
    }
    renderElement(node, index, data) {
        const element = node.element;
        data.element = element;
        element.element = data.entry ?? undefined;
        element.element.classList.toggle("focus-inside", !!element.focusInsideSeparator);
        const mainItem = element.separator;
        const { labelHighlights, descriptionHighlights, detailHighlights } = element;
        // Icon
        data.icon.style.backgroundImage = "";
        data.icon.className = "";
        // Label
        let descriptionTitle;
        // if we have a tooltip, that will be the hover,
        // with the saneDescription as fallback if it
        // is defined
        if (!element.saneTooltip && element.saneDescription) descriptionTitle = {
            markdown: {
                value: element.saneDescription,
                supportThemeIcons: true
            },
            markdownNotSupportedFallback: element.saneDescription
        };
        const options = {
            matches: labelHighlights || [],
            // If we have a tooltip, we want that to be shown and not any other hover
            descriptionTitle,
            descriptionMatches: descriptionHighlights || [],
            labelEscapeNewLines: true
        };
        data.entry.classList.add("quick-input-list-separator-as-item");
        data.label.setLabel(element.saneLabel, element.saneDescription, options);
        // Detail
        if (element.saneDetail) {
            let title;
            // If we have a tooltip, we want that to be shown and not any other hover
            if (!element.saneTooltip) title = {
                markdown: {
                    value: element.saneDetail,
                    supportThemeIcons: true
                },
                markdownNotSupportedFallback: element.saneDetail
            };
            data.detail.element.style.display = "";
            data.detail.setLabel(element.saneDetail, undefined, {
                matches: detailHighlights,
                title,
                labelEscapeNewLines: true
            });
        } else data.detail.element.style.display = "none";
        // Separator
        data.separator.style.display = "none";
        data.entry.classList.add("quick-input-list-separator-border");
        // Actions
        const buttons = mainItem.buttons;
        if (buttons && buttons.length) {
            data.actionBar.push(buttons.map((button, index)=>(0, _quickInputUtilsJs.quickInputButtonToAction)(button, `id-${index}`, ()=>element.fireSeparatorButtonTriggered({
                        button,
                        separator: element.separator
                    }))), {
                icon: true,
                label: false
            });
            data.entry.classList.add("has-actions");
        } else data.entry.classList.remove("has-actions");
        this.addSeparator(element);
    }
    disposeElement(element, _index, data) {
        this.removeSeparator(element.element);
        if (!this.isSeparatorVisible(element.element)) element.element.element?.classList.remove("focus-inside");
        super.disposeElement(element, _index, data);
    }
    addSeparator(separator) {
        this._visibleSeparatorsFrequency.set(separator, (this._visibleSeparatorsFrequency.get(separator) || 0) + 1);
    }
    removeSeparator(separator) {
        const frequency = this._visibleSeparatorsFrequency.get(separator) || 0;
        if (frequency > 1) this._visibleSeparatorsFrequency.set(separator, frequency - 1);
        else this._visibleSeparatorsFrequency.delete(separator);
    }
}
let QuickInputTree = class QuickInputTree extends (0, _lifecycleJs.Disposable) {
    constructor(parent, hoverDelegate, linkOpenerDelegate, id, instantiationService, accessibilityService){
        super();
        this.parent = parent;
        this.hoverDelegate = hoverDelegate;
        this.linkOpenerDelegate = linkOpenerDelegate;
        this.accessibilityService = accessibilityService;
        //#region QuickInputTree Events
        this._onKeyDown = new (0, _eventJs.Emitter)();
        this._onLeave = new (0, _eventJs.Emitter)();
        /**
         * Event that is fired when the tree would no longer have focus.
        */ this.onLeave = this._onLeave.event;
        this._visibleCountObservable = (0, _observableJs.observableValue)("VisibleCount", 0);
        this.onChangedVisibleCount = (0, _eventJs.Event).fromObservable(this._visibleCountObservable, this._store);
        this._allVisibleCheckedObservable = (0, _observableJs.observableValue)("AllVisibleChecked", false);
        this.onChangedAllVisibleChecked = (0, _eventJs.Event).fromObservable(this._allVisibleCheckedObservable, this._store);
        this._checkedCountObservable = (0, _observableJs.observableValue)("CheckedCount", 0);
        this.onChangedCheckedCount = (0, _eventJs.Event).fromObservable(this._checkedCountObservable, this._store);
        this._checkedElementsObservable = (0, _observableJs.observableValueOpts)({
            equalsFn: (0, _arraysJs.equals)
        }, new Array());
        this.onChangedCheckedElements = (0, _eventJs.Event).fromObservable(this._checkedElementsObservable, this._store);
        this._onButtonTriggered = new (0, _eventJs.Emitter)();
        this.onButtonTriggered = this._onButtonTriggered.event;
        this._onSeparatorButtonTriggered = new (0, _eventJs.Emitter)();
        this.onSeparatorButtonTriggered = this._onSeparatorButtonTriggered.event;
        this._elementChecked = new (0, _eventJs.Emitter)();
        this._elementCheckedEventBufferer = new (0, _eventJs.EventBufferer)();
        //#endregion
        this._hasCheckboxes = false;
        this._inputElements = new Array();
        this._elementTree = new Array();
        this._itemElements = new Array();
        // Elements that apply to the current set of elements
        this._elementDisposable = this._register(new (0, _lifecycleJs.DisposableStore)());
        this._matchOnDescription = false;
        this._matchOnDetail = false;
        this._matchOnLabel = true;
        this._matchOnLabelMode = "fuzzy";
        this._sortByLabel = true;
        this._shouldLoop = true;
        this._container = _domJs.append(this.parent, $(".quick-input-list"));
        this._separatorRenderer = new QuickPickSeparatorElementRenderer(hoverDelegate);
        this._itemRenderer = instantiationService.createInstance(QuickPickItemElementRenderer, hoverDelegate);
        this._tree = this._register(instantiationService.createInstance((0, _listServiceJs.WorkbenchObjectTree), "QuickInput", this._container, new QuickInputItemDelegate(), [
            this._itemRenderer,
            this._separatorRenderer
        ], {
            filter: {
                filter (element) {
                    return element.hidden ? 0 /* TreeVisibility.Hidden */  : element instanceof QuickPickSeparatorElement ? 2 /* TreeVisibility.Recurse */  : 1 /* TreeVisibility.Visible */ ;
                }
            },
            sorter: {
                compare: (element, otherElement)=>{
                    if (!this.sortByLabel || !this._lastQueryString) return 0;
                    const normalizedSearchValue = this._lastQueryString.toLowerCase();
                    return compareEntries(element, otherElement, normalizedSearchValue);
                }
            },
            accessibilityProvider: new QuickInputAccessibilityProvider(),
            setRowLineHeight: false,
            multipleSelectionSupport: false,
            hideTwistiesOfChildlessElements: true,
            renderIndentGuides: (0, _abstractTreeJs.RenderIndentGuides).None,
            findWidgetEnabled: false,
            indent: 0,
            horizontalScrolling: false,
            allowNonCollapsibleParents: true,
            alwaysConsumeMouseWheel: true
        }));
        this._tree.getHTMLElement().id = id;
        this._registerListeners();
    }
    //#region public getters/setters
    get onDidChangeFocus() {
        return (0, _eventJs.Event).map(this._tree.onDidChangeFocus, (e)=>e.elements.filter((e)=>e instanceof QuickPickItemElement).map((e)=>e.item), this._store);
    }
    get onDidChangeSelection() {
        return (0, _eventJs.Event).map(this._tree.onDidChangeSelection, (e)=>({
                items: e.elements.filter((e)=>e instanceof QuickPickItemElement).map((e)=>e.item),
                event: e.browserEvent
            }), this._store);
    }
    get displayed() {
        return this._container.style.display !== "none";
    }
    set displayed(value) {
        this._container.style.display = value ? "" : "none";
    }
    get scrollTop() {
        return this._tree.scrollTop;
    }
    set scrollTop(scrollTop) {
        this._tree.scrollTop = scrollTop;
    }
    get ariaLabel() {
        return this._tree.ariaLabel;
    }
    set ariaLabel(label) {
        this._tree.ariaLabel = label ?? "";
    }
    set enabled(value) {
        this._tree.getHTMLElement().style.pointerEvents = value ? "" : "none";
    }
    get matchOnDescription() {
        return this._matchOnDescription;
    }
    set matchOnDescription(value) {
        this._matchOnDescription = value;
    }
    get matchOnDetail() {
        return this._matchOnDetail;
    }
    set matchOnDetail(value) {
        this._matchOnDetail = value;
    }
    get matchOnLabel() {
        return this._matchOnLabel;
    }
    set matchOnLabel(value) {
        this._matchOnLabel = value;
    }
    get matchOnLabelMode() {
        return this._matchOnLabelMode;
    }
    set matchOnLabelMode(value) {
        this._matchOnLabelMode = value;
    }
    get sortByLabel() {
        return this._sortByLabel;
    }
    set sortByLabel(value) {
        this._sortByLabel = value;
    }
    get shouldLoop() {
        return this._shouldLoop;
    }
    set shouldLoop(value) {
        this._shouldLoop = value;
    }
    //#endregion
    //#region register listeners
    _registerListeners() {
        this._registerOnKeyDown();
        this._registerOnContainerClick();
        this._registerOnMouseMiddleClick();
        this._registerOnTreeModelChanged();
        this._registerOnElementChecked();
        this._registerOnContextMenu();
        this._registerHoverListeners();
        this._registerSelectionChangeListener();
        this._registerSeparatorActionShowingListeners();
    }
    _registerOnKeyDown() {
        // TODO: Should this be added at a higher level?
        this._register(this._tree.onKeyDown((e)=>{
            const event = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
            switch(event.keyCode){
                case 10 /* KeyCode.Space */ :
                    this.toggleCheckbox();
                    break;
            }
            this._onKeyDown.fire(event);
        }));
    }
    _registerOnContainerClick() {
        this._register(_domJs.addDisposableListener(this._container, _domJs.EventType.CLICK, (e)=>{
            if (e.x || e.y) this._onLeave.fire();
        }));
    }
    _registerOnMouseMiddleClick() {
        this._register(_domJs.addDisposableListener(this._container, _domJs.EventType.AUXCLICK, (e)=>{
            if (e.button === 1) this._onLeave.fire();
        }));
    }
    _registerOnTreeModelChanged() {
        this._register(this._tree.onDidChangeModel(()=>{
            const visibleCount = this._itemElements.filter((e)=>!e.hidden).length;
            this._visibleCountObservable.set(visibleCount, undefined);
            if (this._hasCheckboxes) this._updateCheckedObservables();
        }));
    }
    _registerOnElementChecked() {
        // Only fire the last event when buffered
        this._register(this._elementCheckedEventBufferer.wrapEvent(this._elementChecked.event, (_, e)=>e)((_)=>this._updateCheckedObservables()));
    }
    _registerOnContextMenu() {
        this._register(this._tree.onContextMenu((e)=>{
            if (e.element) {
                e.browserEvent.preventDefault();
                // we want to treat a context menu event as
                // a gesture to open the item at the index
                // since we do not have any context menu
                // this enables for example macOS to Ctrl-
                // click on an item to open it.
                this._tree.setSelection([
                    e.element
                ]);
            }
        }));
    }
    _registerHoverListeners() {
        const delayer = this._register(new (0, _asyncJs.ThrottledDelayer)(this.hoverDelegate.delay));
        this._register(this._tree.onMouseOver(async (e)=>{
            // If we hover over an anchor element, we don't want to show the hover because
            // the anchor may have a tooltip that we want to show instead.
            if (_domJs.isHTMLAnchorElement(e.browserEvent.target)) {
                delayer.cancel();
                return;
            }
            if (// anchors are an exception as called out above so we skip them here
            !_domJs.isHTMLAnchorElement(e.browserEvent.relatedTarget) && // check if the mouse is still over the same element
            _domJs.isAncestor(e.browserEvent.relatedTarget, e.element?.element)) return;
            try {
                await delayer.trigger(async ()=>{
                    if (e.element instanceof QuickPickItemElement) this.showHover(e.element);
                });
            } catch (e) {
                // Ignore cancellation errors due to mouse out
                if (!(0, _errorsJs.isCancellationError)(e)) throw e;
            }
        }));
        this._register(this._tree.onMouseOut((e)=>{
            // onMouseOut triggers every time a new element has been moused over
            // even if it's on the same list item. We only want one event, so we
            // check if the mouse is still over the same element.
            if (_domJs.isAncestor(e.browserEvent.relatedTarget, e.element?.element)) return;
            delayer.cancel();
        }));
    }
    /**
     * Register's focus change and mouse events so that we can track when items inside of a
     * separator's section are focused or hovered so that we can display the separator's actions
     */ _registerSeparatorActionShowingListeners() {
        this._register(this._tree.onDidChangeFocus((e)=>{
            const parent = e.elements[0] ? this._tree.getParentElement(e.elements[0]) : null;
            for (const separator of this._separatorRenderer.visibleSeparators){
                const value = separator === parent;
                // get bitness of ACTIVE_ITEM and check if it changed
                const currentActive = !!(separator.focusInsideSeparator & QuickPickSeparatorFocusReason.ACTIVE_ITEM);
                if (currentActive !== value) {
                    if (value) separator.focusInsideSeparator |= QuickPickSeparatorFocusReason.ACTIVE_ITEM;
                    else separator.focusInsideSeparator &= ~QuickPickSeparatorFocusReason.ACTIVE_ITEM;
                    this._tree.rerender(separator);
                }
            }
        }));
        this._register(this._tree.onMouseOver((e)=>{
            const parent = e.element ? this._tree.getParentElement(e.element) : null;
            for (const separator of this._separatorRenderer.visibleSeparators){
                if (separator !== parent) continue;
                const currentMouse = !!(separator.focusInsideSeparator & QuickPickSeparatorFocusReason.MOUSE_HOVER);
                if (!currentMouse) {
                    separator.focusInsideSeparator |= QuickPickSeparatorFocusReason.MOUSE_HOVER;
                    this._tree.rerender(separator);
                }
            }
        }));
        this._register(this._tree.onMouseOut((e)=>{
            const parent = e.element ? this._tree.getParentElement(e.element) : null;
            for (const separator of this._separatorRenderer.visibleSeparators){
                if (separator !== parent) continue;
                const currentMouse = !!(separator.focusInsideSeparator & QuickPickSeparatorFocusReason.MOUSE_HOVER);
                if (currentMouse) {
                    separator.focusInsideSeparator &= ~QuickPickSeparatorFocusReason.MOUSE_HOVER;
                    this._tree.rerender(separator);
                }
            }
        }));
    }
    _registerSelectionChangeListener() {
        // When the user selects a separator, the separator will move to the top and focus will be
        // set to the first element after the separator.
        this._register(this._tree.onDidChangeSelection((e)=>{
            const elementsWithoutSeparators = e.elements.filter((e)=>e instanceof QuickPickItemElement);
            if (elementsWithoutSeparators.length !== e.elements.length) {
                if (e.elements.length === 1 && e.elements[0] instanceof QuickPickSeparatorElement) {
                    this._tree.setFocus([
                        e.elements[0].children[0]
                    ]);
                    this._tree.reveal(e.elements[0], 0);
                }
                this._tree.setSelection(elementsWithoutSeparators);
            }
        }));
    }
    //#endregion
    //#region public methods
    setAllVisibleChecked(checked) {
        this._elementCheckedEventBufferer.bufferEvents(()=>{
            this._itemElements.forEach((element)=>{
                if (!element.hidden && !element.checkboxDisabled) // Would fire an event if we didn't beffer the events
                element.checked = checked;
            });
        });
    }
    setElements(inputElements) {
        this._elementDisposable.clear();
        this._lastQueryString = undefined;
        this._inputElements = inputElements;
        this._hasCheckboxes = this.parent.classList.contains("show-checkboxes");
        let currentSeparatorElement;
        this._itemElements = new Array();
        this._elementTree = inputElements.reduce((result, item, index)=>{
            let element;
            if (item.type === "separator") {
                if (!item.buttons) // This separator will be rendered as a part of the list item
                return result;
                currentSeparatorElement = new QuickPickSeparatorElement(index, (e)=>this._onSeparatorButtonTriggered.fire(e), item);
                element = currentSeparatorElement;
            } else {
                const previous = index > 0 ? inputElements[index - 1] : undefined;
                let separator;
                if (previous && previous.type === "separator" && !previous.buttons) {
                    // Found an inline separator so we clear out the current separator element
                    currentSeparatorElement = undefined;
                    separator = previous;
                }
                const qpi = new QuickPickItemElement(index, this._hasCheckboxes, (e)=>this._onButtonTriggered.fire(e), this._elementChecked, item, separator);
                this._itemElements.push(qpi);
                if (currentSeparatorElement) {
                    currentSeparatorElement.children.push(qpi);
                    return result;
                }
                element = qpi;
            }
            result.push(element);
            return result;
        }, new Array());
        this._setElementsToTree(this._elementTree);
        // Accessibility hack, unfortunately on next tick
        // https://github.com/microsoft/vscode/issues/211976
        if (this.accessibilityService.isScreenReaderOptimized()) setTimeout(()=>{
            const focusedElement = this._tree.getHTMLElement().querySelector(`.monaco-list-row.focused`);
            const parent = focusedElement?.parentNode;
            if (focusedElement && parent) {
                const nextSibling = focusedElement.nextSibling;
                focusedElement.remove();
                parent.insertBefore(focusedElement, nextSibling);
            }
        }, 0);
    }
    setFocusedElements(items) {
        const elements = items.map((item)=>this._itemElements.find((e)=>e.item === item)).filter((e)=>!!e).filter((e)=>!e.hidden);
        this._tree.setFocus(elements);
        if (items.length > 0) {
            const focused = this._tree.getFocus()[0];
            if (focused) this._tree.reveal(focused);
        }
    }
    getActiveDescendant() {
        return this._tree.getHTMLElement().getAttribute("aria-activedescendant");
    }
    setSelectedElements(items) {
        const elements = items.map((item)=>this._itemElements.find((e)=>e.item === item)).filter((e)=>!!e);
        this._tree.setSelection(elements);
    }
    getCheckedElements() {
        return this._itemElements.filter((e)=>e.checked).map((e)=>e.item);
    }
    setCheckedElements(items) {
        this._elementCheckedEventBufferer.bufferEvents(()=>{
            const checked = new Set();
            for (const item of items)checked.add(item);
            for (const element of this._itemElements)// Would fire an event if we didn't beffer the events
            element.checked = checked.has(element.item);
        });
    }
    focus(what) {
        if (!this._itemElements.length) return;
        if (what === (0, _quickInputJs.QuickPickFocus).Second && this._itemElements.length < 2) what = (0, _quickInputJs.QuickPickFocus).First;
        switch(what){
            case (0, _quickInputJs.QuickPickFocus).First:
                this._tree.scrollTop = 0;
                this._tree.focusFirst(undefined, (e)=>e.element instanceof QuickPickItemElement);
                break;
            case (0, _quickInputJs.QuickPickFocus).Second:
                {
                    this._tree.scrollTop = 0;
                    let isSecondItem = false;
                    this._tree.focusFirst(undefined, (e)=>{
                        if (!(e.element instanceof QuickPickItemElement)) return false;
                        if (isSecondItem) return true;
                        isSecondItem = !isSecondItem;
                        return false;
                    });
                    break;
                }
            case (0, _quickInputJs.QuickPickFocus).Last:
                this._tree.scrollTop = this._tree.scrollHeight;
                this._tree.focusLast(undefined, (e)=>e.element instanceof QuickPickItemElement);
                break;
            case (0, _quickInputJs.QuickPickFocus).Next:
                {
                    const prevFocus = this._tree.getFocus();
                    this._tree.focusNext(undefined, this._shouldLoop, undefined, (e)=>{
                        if (!(e.element instanceof QuickPickItemElement)) return false;
                        this._tree.reveal(e.element);
                        return true;
                    });
                    const currentFocus = this._tree.getFocus();
                    if (prevFocus.length && prevFocus[0] === currentFocus[0] && prevFocus[0] === this._itemElements[this._itemElements.length - 1]) this._onLeave.fire();
                    break;
                }
            case (0, _quickInputJs.QuickPickFocus).Previous:
                {
                    const prevFocus = this._tree.getFocus();
                    this._tree.focusPrevious(undefined, this._shouldLoop, undefined, (e)=>{
                        if (!(e.element instanceof QuickPickItemElement)) return false;
                        const parent = this._tree.getParentElement(e.element);
                        if (parent === null || parent.children[0] !== e.element) this._tree.reveal(e.element);
                        else // Only if we are the first child of a separator do we reveal the separator
                        this._tree.reveal(parent);
                        return true;
                    });
                    const currentFocus = this._tree.getFocus();
                    if (prevFocus.length && prevFocus[0] === currentFocus[0] && prevFocus[0] === this._itemElements[0]) this._onLeave.fire();
                    break;
                }
            case (0, _quickInputJs.QuickPickFocus).NextPage:
                this._tree.focusNextPage(undefined, (e)=>{
                    if (!(e.element instanceof QuickPickItemElement)) return false;
                    this._tree.reveal(e.element);
                    return true;
                });
                break;
            case (0, _quickInputJs.QuickPickFocus).PreviousPage:
                this._tree.focusPreviousPage(undefined, (e)=>{
                    if (!(e.element instanceof QuickPickItemElement)) return false;
                    const parent = this._tree.getParentElement(e.element);
                    if (parent === null || parent.children[0] !== e.element) this._tree.reveal(e.element);
                    else this._tree.reveal(parent);
                    return true;
                });
                break;
            case (0, _quickInputJs.QuickPickFocus).NextSeparator:
                {
                    let foundSeparatorAsItem = false;
                    const before = this._tree.getFocus()[0];
                    this._tree.focusNext(undefined, true, undefined, (e)=>{
                        if (foundSeparatorAsItem) // This should be the index right after the separator so it
                        // is the item we want to focus.
                        return true;
                        if (e.element instanceof QuickPickSeparatorElement) {
                            foundSeparatorAsItem = true;
                            // If the separator is visible, then we should just reveal its first child so it's not as jarring.
                            if (this._separatorRenderer.isSeparatorVisible(e.element)) this._tree.reveal(e.element.children[0]);
                            else // If the separator is not visible, then we should
                            // push it up to the top of the list.
                            this._tree.reveal(e.element, 0);
                        } else if (e.element instanceof QuickPickItemElement) {
                            if (e.element.separator) {
                                if (this._itemRenderer.isItemWithSeparatorVisible(e.element)) this._tree.reveal(e.element);
                                else this._tree.reveal(e.element, 0);
                                return true;
                            } else if (e.element === this._elementTree[0]) {
                                // We should stop at the first item in the list if it's a regular item.
                                this._tree.reveal(e.element, 0);
                                return true;
                            }
                        }
                        return false;
                    });
                    const after = this._tree.getFocus()[0];
                    if (before === after) {
                        // If we didn't move, then we should just move to the end
                        // of the list.
                        this._tree.scrollTop = this._tree.scrollHeight;
                        this._tree.focusLast(undefined, (e)=>e.element instanceof QuickPickItemElement);
                    }
                    break;
                }
            case (0, _quickInputJs.QuickPickFocus).PreviousSeparator:
                {
                    let focusElement;
                    // If we are already sitting on an inline separator, then we
                    // have already found the _current_ separator and need to
                    // move to the previous one.
                    let foundSeparator = !!this._tree.getFocus()[0]?.separator;
                    this._tree.focusPrevious(undefined, true, undefined, (e)=>{
                        if (e.element instanceof QuickPickSeparatorElement) {
                            if (foundSeparator) {
                                if (!focusElement) {
                                    if (this._separatorRenderer.isSeparatorVisible(e.element)) this._tree.reveal(e.element);
                                    else this._tree.reveal(e.element, 0);
                                    focusElement = e.element.children[0];
                                }
                            } else foundSeparator = true;
                        } else if (e.element instanceof QuickPickItemElement) {
                            if (!focusElement) {
                                if (e.element.separator) {
                                    if (this._itemRenderer.isItemWithSeparatorVisible(e.element)) this._tree.reveal(e.element);
                                    else this._tree.reveal(e.element, 0);
                                    focusElement = e.element;
                                } else if (e.element === this._elementTree[0]) {
                                    // We should stop at the first item in the list if it's a regular item.
                                    this._tree.reveal(e.element, 0);
                                    return true;
                                }
                            }
                        }
                        return false;
                    });
                    if (focusElement) this._tree.setFocus([
                        focusElement
                    ]);
                    break;
                }
        }
    }
    clearFocus() {
        this._tree.setFocus([]);
    }
    domFocus() {
        this._tree.domFocus();
    }
    layout(maxHeight) {
        this._tree.getHTMLElement().style.maxHeight = maxHeight ? `${// Make sure height aligns with list item heights
        Math.floor(maxHeight / 44) * 44 + 6}px` : "";
        this._tree.layout();
    }
    filter(query) {
        this._lastQueryString = query;
        if (!(this._sortByLabel || this._matchOnLabel || this._matchOnDescription || this._matchOnDetail)) {
            this._tree.layout();
            return false;
        }
        const queryWithWhitespace = query;
        query = query.trim();
        // Reset filtering
        if (!query || !(this.matchOnLabel || this.matchOnDescription || this.matchOnDetail)) this._itemElements.forEach((element)=>{
            element.labelHighlights = undefined;
            element.descriptionHighlights = undefined;
            element.detailHighlights = undefined;
            element.hidden = false;
            const previous = element.index && this._inputElements[element.index - 1];
            if (element.item) element.separator = previous && previous.type === "separator" && !previous.buttons ? previous : undefined;
        });
        else {
            let currentSeparator;
            this._itemElements.forEach((element)=>{
                let labelHighlights;
                if (this.matchOnLabelMode === "fuzzy") labelHighlights = this.matchOnLabel ? (0, _iconLabelsJs.matchesFuzzyIconAware)(query, (0, _iconLabelsJs.parseLabelWithIcons)(element.saneLabel)) ?? undefined : undefined;
                else labelHighlights = this.matchOnLabel ? matchesContiguousIconAware(queryWithWhitespace, (0, _iconLabelsJs.parseLabelWithIcons)(element.saneLabel)) ?? undefined : undefined;
                const descriptionHighlights = this.matchOnDescription ? (0, _iconLabelsJs.matchesFuzzyIconAware)(query, (0, _iconLabelsJs.parseLabelWithIcons)(element.saneDescription || "")) ?? undefined : undefined;
                const detailHighlights = this.matchOnDetail ? (0, _iconLabelsJs.matchesFuzzyIconAware)(query, (0, _iconLabelsJs.parseLabelWithIcons)(element.saneDetail || "")) ?? undefined : undefined;
                if (labelHighlights || descriptionHighlights || detailHighlights) {
                    element.labelHighlights = labelHighlights;
                    element.descriptionHighlights = descriptionHighlights;
                    element.detailHighlights = detailHighlights;
                    element.hidden = false;
                } else {
                    element.labelHighlights = undefined;
                    element.descriptionHighlights = undefined;
                    element.detailHighlights = undefined;
                    element.hidden = element.item ? !element.item.alwaysShow : true;
                }
                // Ensure separators are filtered out first before deciding if we need to bring them back
                if (element.item) element.separator = undefined;
                else if (element.separator) element.hidden = true;
                // we can show the separator unless the list gets sorted by match
                if (!this.sortByLabel) {
                    const previous = element.index && this._inputElements[element.index - 1] || undefined;
                    if (previous?.type === "separator" && !previous.buttons) currentSeparator = previous;
                    if (currentSeparator && !element.hidden) {
                        element.separator = currentSeparator;
                        currentSeparator = undefined;
                    }
                }
            });
        }
        this._setElementsToTree(this._sortByLabel && query ? this._itemElements : this._elementTree);
        this._tree.layout();
        return true;
    }
    toggleCheckbox() {
        this._elementCheckedEventBufferer.bufferEvents(()=>{
            const elements = this._tree.getFocus().filter((e)=>e instanceof QuickPickItemElement);
            const allChecked = this._allVisibleChecked(elements);
            for (const element of elements)if (!element.checkboxDisabled) // Would fire an event if we didn't have the flag set
            element.checked = !allChecked;
        });
    }
    style(styles) {
        this._tree.style(styles);
    }
    toggleHover() {
        const focused = this._tree.getFocus()[0];
        if (!focused?.saneTooltip || !(focused instanceof QuickPickItemElement)) return;
        // if there's a hover already, hide it (toggle off)
        if (this._lastHover && !this._lastHover.isDisposed) {
            this._lastHover.dispose();
            return;
        }
        // If there is no hover, show it (toggle on)
        this.showHover(focused);
        const store = new (0, _lifecycleJs.DisposableStore)();
        store.add(this._tree.onDidChangeFocus((e)=>{
            if (e.elements[0] instanceof QuickPickItemElement) this.showHover(e.elements[0]);
        }));
        if (this._lastHover) store.add(this._lastHover);
        this._elementDisposable.add(store);
    }
    //#endregion
    //#region private methods
    _setElementsToTree(elements) {
        const treeElements = new Array();
        for (const element of elements)if (element instanceof QuickPickSeparatorElement) treeElements.push({
            element,
            collapsible: false,
            collapsed: false,
            children: element.children.map((e)=>({
                    element: e,
                    collapsible: false,
                    collapsed: false
                }))
        });
        else treeElements.push({
            element,
            collapsible: false,
            collapsed: false
        });
        this._tree.setChildren(null, treeElements);
    }
    _allVisibleChecked(elements, whenNoneVisible = true) {
        for(let i = 0, n = elements.length; i < n; i++){
            const element = elements[i];
            if (!element.hidden) {
                if (!element.checked) return false;
                else whenNoneVisible = true;
            }
        }
        return whenNoneVisible;
    }
    _updateCheckedObservables() {
        (0, _observableJs.transaction)((tx)=>{
            this._allVisibleCheckedObservable.set(this._allVisibleChecked(this._itemElements, false), tx);
            const checkedCount = this._itemElements.filter((element)=>element.checked).length;
            this._checkedCountObservable.set(checkedCount, tx);
            this._checkedElementsObservable.set(this.getCheckedElements(), tx);
        });
    }
    /**
     * Disposes of the hover and shows a new one for the given index if it has a tooltip.
     * @param element The element to show the hover for
     */ showHover(element) {
        if (this._lastHover && !this._lastHover.isDisposed) {
            this.hoverDelegate.onDidHideHover?.();
            this._lastHover?.dispose();
        }
        if (!element.element || !element.saneTooltip) return;
        this._lastHover = this.hoverDelegate.showHover({
            content: element.saneTooltip,
            target: element.element,
            linkHandler: (url)=>{
                this.linkOpenerDelegate(url);
            },
            appearance: {
                showPointer: true
            },
            container: this._container,
            position: {
                hoverPosition: 1 /* HoverPosition.RIGHT */ 
            }
        }, false);
    }
};
__decorate([
    (0, _decoratorsJs.memoize)
], QuickInputTree.prototype, "onDidChangeFocus", null);
__decorate([
    (0, _decoratorsJs.memoize)
], QuickInputTree.prototype, "onDidChangeSelection", null);
QuickInputTree = __decorate([
    __param(4, (0, _instantiationJs.IInstantiationService)),
    __param(5, (0, _accessibilityJs.IAccessibilityService))
], QuickInputTree);
function matchesContiguousIconAware(query, target) {
    const { text, iconOffsets } = target;
    // Return early if there are no icon markers in the word to match against
    if (!iconOffsets || iconOffsets.length === 0) return matchesContiguous(query, text);
    // Trim the word to match against because it could have leading
    // whitespace now if the word started with an icon
    const wordToMatchAgainstWithoutIconsTrimmed = (0, _stringsJs.ltrim)(text, " ");
    const leadingWhitespaceOffset = text.length - wordToMatchAgainstWithoutIconsTrimmed.length;
    // match on value without icon
    const matches = matchesContiguous(query, wordToMatchAgainstWithoutIconsTrimmed);
    // Map matches back to offsets with icon and trimming
    if (matches) for (const match of matches){
        const iconOffset = iconOffsets[match.start + leadingWhitespaceOffset] + leadingWhitespaceOffset /* overall leading whitespace offset */ ;
        match.start += iconOffset;
        match.end += iconOffset;
    }
    return matches;
}
function matchesContiguous(word, wordToMatchAgainst) {
    const matchIndex = wordToMatchAgainst.toLowerCase().indexOf(word.toLowerCase());
    if (matchIndex !== -1) return [
        {
            start: matchIndex,
            end: matchIndex + word.length
        }
    ];
    return null;
}
function compareEntries(elementA, elementB, lookFor) {
    const labelHighlightsA = elementA.labelHighlights || [];
    const labelHighlightsB = elementB.labelHighlights || [];
    if (labelHighlightsA.length && !labelHighlightsB.length) return -1;
    if (!labelHighlightsA.length && labelHighlightsB.length) return 1;
    if (labelHighlightsA.length === 0 && labelHighlightsB.length === 0) return 0;
    return (0, _comparersJs.compareAnything)(elementA.saneSortLabel, elementB.saneSortLabel, lookFor);
}

},{"../../../base/browser/dom.js":"bnqsM","../../../base/common/event.js":"4Zi8b","../../../nls.js":"l617d","../../instantiation/common/instantiation.js":"fjwWx","../../list/browser/listService.js":"cyGMs","../../theme/common/themeService.js":"jMkIC","../../../base/common/lifecycle.js":"9kg8d","../common/quickInput.js":"a56M6","../../../base/browser/keyboardEvent.js":"bxU9U","../../../base/common/platform.js":"7maJO","../../../base/common/decorators.js":"hZnBn","../../../base/browser/ui/iconLabel/iconLabel.js":"jocWA","../../../base/browser/ui/keybindingLabel/keybindingLabel.js":"hpphu","../../../base/browser/ui/actionbar/actionbar.js":"5Xmba","../../theme/common/theme.js":"gh7Zf","../../../base/common/uri.js":"7qGS3","./quickInputUtils.js":"dJuPL","../../../base/common/lazy.js":"6e57N","../../../base/common/iconLabels.js":"3vhIZ","../../../base/common/comparers.js":"93ss4","../../../base/common/strings.js":"aA9I1","../../../base/browser/ui/tree/abstractTree.js":"2Z8Kh","../../../base/common/async.js":"4GJc4","../../../base/common/errors.js":"divX8","../../accessibility/common/accessibility.js":"9Svqy","../../../base/common/observable.js":"2xbG5","../../../base/common/arrays.js":"DECei","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cyGMs":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IListService", ()=>IListService);
parcelHelpers.export(exports, "ListService", ()=>ListService);
parcelHelpers.export(exports, "RawWorkbenchListScrollAtBoundaryContextKey", ()=>RawWorkbenchListScrollAtBoundaryContextKey);
parcelHelpers.export(exports, "WorkbenchListScrollAtTopContextKey", ()=>WorkbenchListScrollAtTopContextKey);
parcelHelpers.export(exports, "WorkbenchListScrollAtBottomContextKey", ()=>WorkbenchListScrollAtBottomContextKey);
parcelHelpers.export(exports, "RawWorkbenchListFocusContextKey", ()=>RawWorkbenchListFocusContextKey);
parcelHelpers.export(exports, "WorkbenchTreeStickyScrollFocused", ()=>WorkbenchTreeStickyScrollFocused);
parcelHelpers.export(exports, "WorkbenchListSupportsMultiSelectContextKey", ()=>WorkbenchListSupportsMultiSelectContextKey);
parcelHelpers.export(exports, "WorkbenchListFocusContextKey", ()=>WorkbenchListFocusContextKey);
parcelHelpers.export(exports, "WorkbenchListHasSelectionOrFocus", ()=>WorkbenchListHasSelectionOrFocus);
parcelHelpers.export(exports, "WorkbenchListDoubleSelection", ()=>WorkbenchListDoubleSelection);
parcelHelpers.export(exports, "WorkbenchListMultiSelection", ()=>WorkbenchListMultiSelection);
parcelHelpers.export(exports, "WorkbenchListSelectionNavigation", ()=>WorkbenchListSelectionNavigation);
parcelHelpers.export(exports, "WorkbenchListSupportsFind", ()=>WorkbenchListSupportsFind);
parcelHelpers.export(exports, "WorkbenchTreeElementCanCollapse", ()=>WorkbenchTreeElementCanCollapse);
parcelHelpers.export(exports, "WorkbenchTreeElementHasParent", ()=>WorkbenchTreeElementHasParent);
parcelHelpers.export(exports, "WorkbenchTreeElementCanExpand", ()=>WorkbenchTreeElementCanExpand);
parcelHelpers.export(exports, "WorkbenchTreeElementHasChild", ()=>WorkbenchTreeElementHasChild);
parcelHelpers.export(exports, "WorkbenchTreeFindOpen", ()=>WorkbenchTreeFindOpen);
parcelHelpers.export(exports, "WorkbenchList", ()=>WorkbenchList);
parcelHelpers.export(exports, "WorkbenchPagedList", ()=>WorkbenchPagedList);
parcelHelpers.export(exports, "WorkbenchTable", ()=>WorkbenchTable);
parcelHelpers.export(exports, "WorkbenchObjectTree", ()=>WorkbenchObjectTree);
parcelHelpers.export(exports, "WorkbenchCompressibleObjectTree", ()=>WorkbenchCompressibleObjectTree);
parcelHelpers.export(exports, "WorkbenchDataTree", ()=>WorkbenchDataTree);
parcelHelpers.export(exports, "WorkbenchAsyncDataTree", ()=>WorkbenchAsyncDataTree);
parcelHelpers.export(exports, "WorkbenchCompressibleAsyncDataTree", ()=>WorkbenchCompressibleAsyncDataTree);
var _domJs = require("../../../base/browser/dom.js");
var _listPagingJs = require("../../../base/browser/ui/list/listPaging.js");
var _listWidgetJs = require("../../../base/browser/ui/list/listWidget.js");
var _tableWidgetJs = require("../../../base/browser/ui/table/tableWidget.js");
var _abstractTreeJs = require("../../../base/browser/ui/tree/abstractTree.js");
var _asyncDataTreeJs = require("../../../base/browser/ui/tree/asyncDataTree.js");
var _dataTreeJs = require("../../../base/browser/ui/tree/dataTree.js");
var _objectTreeJs = require("../../../base/browser/ui/tree/objectTree.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _nlsJs = require("../../../nls.js");
var _configurationJs = require("../../configuration/common/configuration.js");
var _configurationRegistryJs = require("../../configuration/common/configurationRegistry.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _contextkeysJs = require("../../contextkey/common/contextkeys.js");
var _contextViewJs = require("../../contextview/browser/contextView.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var _keybindingJs = require("../../keybinding/common/keybinding.js");
var _platformJs = require("../../registry/common/platform.js");
var _defaultStylesJs = require("../../theme/browser/defaultStyles.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const IListService = (0, _instantiationJs.createDecorator)("listService");
class ListService {
    get lastFocusedList() {
        return this._lastFocusedWidget;
    }
    constructor(){
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this.lists = [];
        this._lastFocusedWidget = undefined;
        this._hasCreatedStyleController = false;
    }
    setLastFocusedList(widget) {
        if (widget === this._lastFocusedWidget) return;
        this._lastFocusedWidget?.getHTMLElement().classList.remove("last-focused");
        this._lastFocusedWidget = widget;
        this._lastFocusedWidget?.getHTMLElement().classList.add("last-focused");
    }
    register(widget, extraContextKeys) {
        if (!this._hasCreatedStyleController) {
            this._hasCreatedStyleController = true;
            // create a shared default tree style sheet for performance reasons
            const styleController = new (0, _listWidgetJs.DefaultStyleController)((0, _domJs.createStyleSheet)(), "");
            styleController.style((0, _defaultStylesJs.defaultListStyles));
        }
        if (this.lists.some((l)=>l.widget === widget)) throw new Error("Cannot register the same widget multiple times");
        // Keep in our lists list
        const registeredList = {
            widget,
            extraContextKeys
        };
        this.lists.push(registeredList);
        // Check for currently being focused
        if ((0, _domJs.isActiveElement)(widget.getHTMLElement())) this.setLastFocusedList(widget);
        return (0, _lifecycleJs.combinedDisposable)(widget.onDidFocus(()=>this.setLastFocusedList(widget)), (0, _lifecycleJs.toDisposable)(()=>this.lists.splice(this.lists.indexOf(registeredList), 1)), widget.onDidDispose(()=>{
            this.lists = this.lists.filter((l)=>l !== registeredList);
            if (this._lastFocusedWidget === widget) this.setLastFocusedList(undefined);
        }));
    }
    dispose() {
        this.disposables.dispose();
    }
}
const RawWorkbenchListScrollAtBoundaryContextKey = new (0, _contextkeyJs.RawContextKey)("listScrollAtBoundary", "none");
const WorkbenchListScrollAtTopContextKey = (0, _contextkeyJs.ContextKeyExpr).or(RawWorkbenchListScrollAtBoundaryContextKey.isEqualTo("top"), RawWorkbenchListScrollAtBoundaryContextKey.isEqualTo("both"));
const WorkbenchListScrollAtBottomContextKey = (0, _contextkeyJs.ContextKeyExpr).or(RawWorkbenchListScrollAtBoundaryContextKey.isEqualTo("bottom"), RawWorkbenchListScrollAtBoundaryContextKey.isEqualTo("both"));
const RawWorkbenchListFocusContextKey = new (0, _contextkeyJs.RawContextKey)("listFocus", true);
const WorkbenchTreeStickyScrollFocused = new (0, _contextkeyJs.RawContextKey)("treestickyScrollFocused", false);
const WorkbenchListSupportsMultiSelectContextKey = new (0, _contextkeyJs.RawContextKey)("listSupportsMultiselect", true);
const WorkbenchListFocusContextKey = (0, _contextkeyJs.ContextKeyExpr).and(RawWorkbenchListFocusContextKey, (0, _contextkeyJs.ContextKeyExpr).not((0, _contextkeysJs.InputFocusedContextKey)), WorkbenchTreeStickyScrollFocused.negate());
const WorkbenchListHasSelectionOrFocus = new (0, _contextkeyJs.RawContextKey)("listHasSelectionOrFocus", false);
const WorkbenchListDoubleSelection = new (0, _contextkeyJs.RawContextKey)("listDoubleSelection", false);
const WorkbenchListMultiSelection = new (0, _contextkeyJs.RawContextKey)("listMultiSelection", false);
const WorkbenchListSelectionNavigation = new (0, _contextkeyJs.RawContextKey)("listSelectionNavigation", false);
const WorkbenchListSupportsFind = new (0, _contextkeyJs.RawContextKey)("listSupportsFind", true);
const WorkbenchTreeElementCanCollapse = new (0, _contextkeyJs.RawContextKey)("treeElementCanCollapse", false);
const WorkbenchTreeElementHasParent = new (0, _contextkeyJs.RawContextKey)("treeElementHasParent", false);
const WorkbenchTreeElementCanExpand = new (0, _contextkeyJs.RawContextKey)("treeElementCanExpand", false);
const WorkbenchTreeElementHasChild = new (0, _contextkeyJs.RawContextKey)("treeElementHasChild", false);
const WorkbenchTreeFindOpen = new (0, _contextkeyJs.RawContextKey)("treeFindOpen", false);
const WorkbenchListTypeNavigationModeKey = "listTypeNavigationMode";
/**
 * @deprecated in favor of WorkbenchListTypeNavigationModeKey
 */ const WorkbenchListAutomaticKeyboardNavigationLegacyKey = "listAutomaticKeyboardNavigation";
function createScopedContextKeyService(contextKeyService, widget) {
    const result = contextKeyService.createScoped(widget.getHTMLElement());
    RawWorkbenchListFocusContextKey.bindTo(result);
    return result;
}
function createScrollObserver(contextKeyService, widget) {
    const listScrollAt = RawWorkbenchListScrollAtBoundaryContextKey.bindTo(contextKeyService);
    const update = ()=>{
        const atTop = widget.scrollTop === 0;
        // We need a threshold `1` since scrollHeight is rounded.
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#determine_if_an_element_has_been_totally_scrolled
        const atBottom = widget.scrollHeight - widget.renderHeight - widget.scrollTop < 1;
        if (atTop && atBottom) listScrollAt.set("both");
        else if (atTop) listScrollAt.set("top");
        else if (atBottom) listScrollAt.set("bottom");
        else listScrollAt.set("none");
    };
    update();
    return widget.onDidScroll(update);
}
const multiSelectModifierSettingKey = "workbench.list.multiSelectModifier";
const openModeSettingKey = "workbench.list.openMode";
const horizontalScrollingKey = "workbench.list.horizontalScrolling";
const defaultFindModeSettingKey = "workbench.list.defaultFindMode";
const typeNavigationModeSettingKey = "workbench.list.typeNavigationMode";
/** @deprecated in favor of `workbench.list.defaultFindMode` and `workbench.list.typeNavigationMode` */ const keyboardNavigationSettingKey = "workbench.list.keyboardNavigation";
const scrollByPageKey = "workbench.list.scrollByPage";
const defaultFindMatchTypeSettingKey = "workbench.list.defaultFindMatchType";
const treeIndentKey = "workbench.tree.indent";
const treeRenderIndentGuidesKey = "workbench.tree.renderIndentGuides";
const listSmoothScrolling = "workbench.list.smoothScrolling";
const mouseWheelScrollSensitivityKey = "workbench.list.mouseWheelScrollSensitivity";
const fastScrollSensitivityKey = "workbench.list.fastScrollSensitivity";
const treeExpandMode = "workbench.tree.expandMode";
const treeStickyScroll = "workbench.tree.enableStickyScroll";
const treeStickyScrollMaxElements = "workbench.tree.stickyScrollMaxItemCount";
function useAltAsMultipleSelectionModifier(configurationService) {
    return configurationService.getValue(multiSelectModifierSettingKey) === "alt";
}
class MultipleSelectionController extends (0, _lifecycleJs.Disposable) {
    constructor(configurationService){
        super();
        this.configurationService = configurationService;
        this.useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
        this.registerListeners();
    }
    registerListeners() {
        this._register(this.configurationService.onDidChangeConfiguration((e)=>{
            if (e.affectsConfiguration(multiSelectModifierSettingKey)) this.useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(this.configurationService);
        }));
    }
    isSelectionSingleChangeEvent(event) {
        if (this.useAltAsMultipleSelectionModifier) return event.browserEvent.altKey;
        return (0, _listWidgetJs.isSelectionSingleChangeEvent)(event);
    }
    isSelectionRangeChangeEvent(event) {
        return (0, _listWidgetJs.isSelectionRangeChangeEvent)(event);
    }
}
function toWorkbenchListOptions(accessor, options) {
    const configurationService = accessor.get((0, _configurationJs.IConfigurationService));
    const keybindingService = accessor.get((0, _keybindingJs.IKeybindingService));
    const disposables = new (0, _lifecycleJs.DisposableStore)();
    const result = {
        ...options,
        keyboardNavigationDelegate: {
            mightProducePrintableCharacter (e) {
                return keybindingService.mightProducePrintableCharacter(e);
            }
        },
        smoothScrolling: Boolean(configurationService.getValue(listSmoothScrolling)),
        mouseWheelScrollSensitivity: configurationService.getValue(mouseWheelScrollSensitivityKey),
        fastScrollSensitivity: configurationService.getValue(fastScrollSensitivityKey),
        multipleSelectionController: options.multipleSelectionController ?? disposables.add(new MultipleSelectionController(configurationService)),
        keyboardNavigationEventFilter: createKeyboardNavigationEventFilter(keybindingService),
        scrollByPage: Boolean(configurationService.getValue(scrollByPageKey))
    };
    return [
        result,
        disposables
    ];
}
let WorkbenchList = class WorkbenchList extends (0, _listWidgetJs.List) {
    constructor(user, container, delegate, renderers, options, contextKeyService, listService, configurationService, instantiationService){
        const horizontalScrolling = typeof options.horizontalScrolling !== "undefined" ? options.horizontalScrolling : Boolean(configurationService.getValue(horizontalScrollingKey));
        const [workbenchListOptions, workbenchListOptionsDisposable] = instantiationService.invokeFunction(toWorkbenchListOptions, options);
        super(user, container, delegate, renderers, {
            keyboardSupport: false,
            ...workbenchListOptions,
            horizontalScrolling
        });
        this.disposables.add(workbenchListOptionsDisposable);
        this.contextKeyService = createScopedContextKeyService(contextKeyService, this);
        this.disposables.add(createScrollObserver(this.contextKeyService, this));
        this.listSupportsMultiSelect = WorkbenchListSupportsMultiSelectContextKey.bindTo(this.contextKeyService);
        this.listSupportsMultiSelect.set(options.multipleSelectionSupport !== false);
        const listSelectionNavigation = WorkbenchListSelectionNavigation.bindTo(this.contextKeyService);
        listSelectionNavigation.set(Boolean(options.selectionNavigation));
        this.listHasSelectionOrFocus = WorkbenchListHasSelectionOrFocus.bindTo(this.contextKeyService);
        this.listDoubleSelection = WorkbenchListDoubleSelection.bindTo(this.contextKeyService);
        this.listMultiSelection = WorkbenchListMultiSelection.bindTo(this.contextKeyService);
        this.horizontalScrolling = options.horizontalScrolling;
        this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
        this.disposables.add(this.contextKeyService);
        this.disposables.add(listService.register(this));
        this.updateStyles(options.overrideStyles);
        this.disposables.add(this.onDidChangeSelection(()=>{
            const selection = this.getSelection();
            const focus = this.getFocus();
            this.contextKeyService.bufferChangeEvents(()=>{
                this.listHasSelectionOrFocus.set(selection.length > 0 || focus.length > 0);
                this.listMultiSelection.set(selection.length > 1);
                this.listDoubleSelection.set(selection.length === 2);
            });
        }));
        this.disposables.add(this.onDidChangeFocus(()=>{
            const selection = this.getSelection();
            const focus = this.getFocus();
            this.listHasSelectionOrFocus.set(selection.length > 0 || focus.length > 0);
        }));
        this.disposables.add(configurationService.onDidChangeConfiguration((e)=>{
            if (e.affectsConfiguration(multiSelectModifierSettingKey)) this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
            let options = {};
            if (e.affectsConfiguration(horizontalScrollingKey) && this.horizontalScrolling === undefined) {
                const horizontalScrolling = Boolean(configurationService.getValue(horizontalScrollingKey));
                options = {
                    ...options,
                    horizontalScrolling
                };
            }
            if (e.affectsConfiguration(scrollByPageKey)) {
                const scrollByPage = Boolean(configurationService.getValue(scrollByPageKey));
                options = {
                    ...options,
                    scrollByPage
                };
            }
            if (e.affectsConfiguration(listSmoothScrolling)) {
                const smoothScrolling = Boolean(configurationService.getValue(listSmoothScrolling));
                options = {
                    ...options,
                    smoothScrolling
                };
            }
            if (e.affectsConfiguration(mouseWheelScrollSensitivityKey)) {
                const mouseWheelScrollSensitivity = configurationService.getValue(mouseWheelScrollSensitivityKey);
                options = {
                    ...options,
                    mouseWheelScrollSensitivity
                };
            }
            if (e.affectsConfiguration(fastScrollSensitivityKey)) {
                const fastScrollSensitivity = configurationService.getValue(fastScrollSensitivityKey);
                options = {
                    ...options,
                    fastScrollSensitivity
                };
            }
            if (Object.keys(options).length > 0) this.updateOptions(options);
        }));
        this.navigator = new ListResourceNavigator(this, {
            configurationService,
            ...options
        });
        this.disposables.add(this.navigator);
    }
    updateOptions(options) {
        super.updateOptions(options);
        if (options.overrideStyles !== undefined) this.updateStyles(options.overrideStyles);
        if (options.multipleSelectionSupport !== undefined) this.listSupportsMultiSelect.set(!!options.multipleSelectionSupport);
    }
    updateStyles(styles) {
        this.style(styles ? (0, _defaultStylesJs.getListStyles)(styles) : (0, _defaultStylesJs.defaultListStyles));
    }
};
WorkbenchList = __decorate([
    __param(5, (0, _contextkeyJs.IContextKeyService)),
    __param(6, IListService),
    __param(7, (0, _configurationJs.IConfigurationService)),
    __param(8, (0, _instantiationJs.IInstantiationService))
], WorkbenchList);
let WorkbenchPagedList = class WorkbenchPagedList extends (0, _listPagingJs.PagedList) {
    constructor(user, container, delegate, renderers, options, contextKeyService, listService, configurationService, instantiationService){
        const horizontalScrolling = typeof options.horizontalScrolling !== "undefined" ? options.horizontalScrolling : Boolean(configurationService.getValue(horizontalScrollingKey));
        const [workbenchListOptions, workbenchListOptionsDisposable] = instantiationService.invokeFunction(toWorkbenchListOptions, options);
        super(user, container, delegate, renderers, {
            keyboardSupport: false,
            ...workbenchListOptions,
            horizontalScrolling
        });
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this.disposables.add(workbenchListOptionsDisposable);
        this.contextKeyService = createScopedContextKeyService(contextKeyService, this);
        this.disposables.add(createScrollObserver(this.contextKeyService, this.widget));
        this.horizontalScrolling = options.horizontalScrolling;
        this.listSupportsMultiSelect = WorkbenchListSupportsMultiSelectContextKey.bindTo(this.contextKeyService);
        this.listSupportsMultiSelect.set(options.multipleSelectionSupport !== false);
        const listSelectionNavigation = WorkbenchListSelectionNavigation.bindTo(this.contextKeyService);
        listSelectionNavigation.set(Boolean(options.selectionNavigation));
        this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
        this.disposables.add(this.contextKeyService);
        this.disposables.add(listService.register(this));
        this.updateStyles(options.overrideStyles);
        this.disposables.add(configurationService.onDidChangeConfiguration((e)=>{
            if (e.affectsConfiguration(multiSelectModifierSettingKey)) this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
            let options = {};
            if (e.affectsConfiguration(horizontalScrollingKey) && this.horizontalScrolling === undefined) {
                const horizontalScrolling = Boolean(configurationService.getValue(horizontalScrollingKey));
                options = {
                    ...options,
                    horizontalScrolling
                };
            }
            if (e.affectsConfiguration(scrollByPageKey)) {
                const scrollByPage = Boolean(configurationService.getValue(scrollByPageKey));
                options = {
                    ...options,
                    scrollByPage
                };
            }
            if (e.affectsConfiguration(listSmoothScrolling)) {
                const smoothScrolling = Boolean(configurationService.getValue(listSmoothScrolling));
                options = {
                    ...options,
                    smoothScrolling
                };
            }
            if (e.affectsConfiguration(mouseWheelScrollSensitivityKey)) {
                const mouseWheelScrollSensitivity = configurationService.getValue(mouseWheelScrollSensitivityKey);
                options = {
                    ...options,
                    mouseWheelScrollSensitivity
                };
            }
            if (e.affectsConfiguration(fastScrollSensitivityKey)) {
                const fastScrollSensitivity = configurationService.getValue(fastScrollSensitivityKey);
                options = {
                    ...options,
                    fastScrollSensitivity
                };
            }
            if (Object.keys(options).length > 0) this.updateOptions(options);
        }));
        this.navigator = new ListResourceNavigator(this, {
            configurationService,
            ...options
        });
        this.disposables.add(this.navigator);
    }
    updateOptions(options) {
        super.updateOptions(options);
        if (options.overrideStyles !== undefined) this.updateStyles(options.overrideStyles);
        if (options.multipleSelectionSupport !== undefined) this.listSupportsMultiSelect.set(!!options.multipleSelectionSupport);
    }
    updateStyles(styles) {
        this.style(styles ? (0, _defaultStylesJs.getListStyles)(styles) : (0, _defaultStylesJs.defaultListStyles));
    }
    dispose() {
        this.disposables.dispose();
        super.dispose();
    }
};
WorkbenchPagedList = __decorate([
    __param(5, (0, _contextkeyJs.IContextKeyService)),
    __param(6, IListService),
    __param(7, (0, _configurationJs.IConfigurationService)),
    __param(8, (0, _instantiationJs.IInstantiationService))
], WorkbenchPagedList);
let WorkbenchTable = class WorkbenchTable extends (0, _tableWidgetJs.Table) {
    constructor(user, container, delegate, columns, renderers, options, contextKeyService, listService, configurationService, instantiationService){
        const horizontalScrolling = typeof options.horizontalScrolling !== "undefined" ? options.horizontalScrolling : Boolean(configurationService.getValue(horizontalScrollingKey));
        const [workbenchListOptions, workbenchListOptionsDisposable] = instantiationService.invokeFunction(toWorkbenchListOptions, options);
        super(user, container, delegate, columns, renderers, {
            keyboardSupport: false,
            ...workbenchListOptions,
            horizontalScrolling
        });
        this.disposables.add(workbenchListOptionsDisposable);
        this.contextKeyService = createScopedContextKeyService(contextKeyService, this);
        this.disposables.add(createScrollObserver(this.contextKeyService, this));
        this.listSupportsMultiSelect = WorkbenchListSupportsMultiSelectContextKey.bindTo(this.contextKeyService);
        this.listSupportsMultiSelect.set(options.multipleSelectionSupport !== false);
        const listSelectionNavigation = WorkbenchListSelectionNavigation.bindTo(this.contextKeyService);
        listSelectionNavigation.set(Boolean(options.selectionNavigation));
        this.listHasSelectionOrFocus = WorkbenchListHasSelectionOrFocus.bindTo(this.contextKeyService);
        this.listDoubleSelection = WorkbenchListDoubleSelection.bindTo(this.contextKeyService);
        this.listMultiSelection = WorkbenchListMultiSelection.bindTo(this.contextKeyService);
        this.horizontalScrolling = options.horizontalScrolling;
        this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
        this.disposables.add(this.contextKeyService);
        this.disposables.add(listService.register(this));
        this.updateStyles(options.overrideStyles);
        this.disposables.add(this.onDidChangeSelection(()=>{
            const selection = this.getSelection();
            const focus = this.getFocus();
            this.contextKeyService.bufferChangeEvents(()=>{
                this.listHasSelectionOrFocus.set(selection.length > 0 || focus.length > 0);
                this.listMultiSelection.set(selection.length > 1);
                this.listDoubleSelection.set(selection.length === 2);
            });
        }));
        this.disposables.add(this.onDidChangeFocus(()=>{
            const selection = this.getSelection();
            const focus = this.getFocus();
            this.listHasSelectionOrFocus.set(selection.length > 0 || focus.length > 0);
        }));
        this.disposables.add(configurationService.onDidChangeConfiguration((e)=>{
            if (e.affectsConfiguration(multiSelectModifierSettingKey)) this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
            let options = {};
            if (e.affectsConfiguration(horizontalScrollingKey) && this.horizontalScrolling === undefined) {
                const horizontalScrolling = Boolean(configurationService.getValue(horizontalScrollingKey));
                options = {
                    ...options,
                    horizontalScrolling
                };
            }
            if (e.affectsConfiguration(scrollByPageKey)) {
                const scrollByPage = Boolean(configurationService.getValue(scrollByPageKey));
                options = {
                    ...options,
                    scrollByPage
                };
            }
            if (e.affectsConfiguration(listSmoothScrolling)) {
                const smoothScrolling = Boolean(configurationService.getValue(listSmoothScrolling));
                options = {
                    ...options,
                    smoothScrolling
                };
            }
            if (e.affectsConfiguration(mouseWheelScrollSensitivityKey)) {
                const mouseWheelScrollSensitivity = configurationService.getValue(mouseWheelScrollSensitivityKey);
                options = {
                    ...options,
                    mouseWheelScrollSensitivity
                };
            }
            if (e.affectsConfiguration(fastScrollSensitivityKey)) {
                const fastScrollSensitivity = configurationService.getValue(fastScrollSensitivityKey);
                options = {
                    ...options,
                    fastScrollSensitivity
                };
            }
            if (Object.keys(options).length > 0) this.updateOptions(options);
        }));
        this.navigator = new TableResourceNavigator(this, {
            configurationService,
            ...options
        });
        this.disposables.add(this.navigator);
    }
    updateOptions(options) {
        super.updateOptions(options);
        if (options.overrideStyles !== undefined) this.updateStyles(options.overrideStyles);
        if (options.multipleSelectionSupport !== undefined) this.listSupportsMultiSelect.set(!!options.multipleSelectionSupport);
    }
    updateStyles(styles) {
        this.style(styles ? (0, _defaultStylesJs.getListStyles)(styles) : (0, _defaultStylesJs.defaultListStyles));
    }
    dispose() {
        this.disposables.dispose();
        super.dispose();
    }
};
WorkbenchTable = __decorate([
    __param(6, (0, _contextkeyJs.IContextKeyService)),
    __param(7, IListService),
    __param(8, (0, _configurationJs.IConfigurationService)),
    __param(9, (0, _instantiationJs.IInstantiationService))
], WorkbenchTable);
class ResourceNavigator extends (0, _lifecycleJs.Disposable) {
    constructor(widget, options){
        super();
        this.widget = widget;
        this._onDidOpen = this._register(new (0, _eventJs.Emitter)());
        this.onDidOpen = this._onDidOpen.event;
        this._register((0, _eventJs.Event).filter(this.widget.onDidChangeSelection, (e)=>(0, _domJs.isKeyboardEvent)(e.browserEvent))((e)=>this.onSelectionFromKeyboard(e)));
        this._register(this.widget.onPointer((e)=>this.onPointer(e.element, e.browserEvent)));
        this._register(this.widget.onMouseDblClick((e)=>this.onMouseDblClick(e.element, e.browserEvent)));
        if (typeof options?.openOnSingleClick !== "boolean" && options?.configurationService) {
            this.openOnSingleClick = options?.configurationService.getValue(openModeSettingKey) !== "doubleClick";
            this._register(options?.configurationService.onDidChangeConfiguration((e)=>{
                if (e.affectsConfiguration(openModeSettingKey)) this.openOnSingleClick = options?.configurationService.getValue(openModeSettingKey) !== "doubleClick";
            }));
        } else this.openOnSingleClick = options?.openOnSingleClick ?? true;
    }
    onSelectionFromKeyboard(event) {
        if (event.elements.length !== 1) return;
        const selectionKeyboardEvent = event.browserEvent;
        const preserveFocus = typeof selectionKeyboardEvent.preserveFocus === "boolean" ? selectionKeyboardEvent.preserveFocus : true;
        const pinned = typeof selectionKeyboardEvent.pinned === "boolean" ? selectionKeyboardEvent.pinned : !preserveFocus;
        const sideBySide = false;
        this._open(this.getSelectedElement(), preserveFocus, pinned, sideBySide, event.browserEvent);
    }
    onPointer(element, browserEvent) {
        if (!this.openOnSingleClick) return;
        const isDoubleClick = browserEvent.detail === 2;
        if (isDoubleClick) return;
        const isMiddleClick = browserEvent.button === 1;
        const preserveFocus = true;
        const pinned = isMiddleClick;
        const sideBySide = browserEvent.ctrlKey || browserEvent.metaKey || browserEvent.altKey;
        this._open(element, preserveFocus, pinned, sideBySide, browserEvent);
    }
    onMouseDblClick(element, browserEvent) {
        if (!browserEvent) return;
        // copied from AbstractTree
        const target = browserEvent.target;
        const onTwistie = target.classList.contains("monaco-tl-twistie") || target.classList.contains("monaco-icon-label") && target.classList.contains("folder-icon") && browserEvent.offsetX < 16;
        if (onTwistie) return;
        const preserveFocus = false;
        const pinned = true;
        const sideBySide = browserEvent.ctrlKey || browserEvent.metaKey || browserEvent.altKey;
        this._open(element, preserveFocus, pinned, sideBySide, browserEvent);
    }
    _open(element, preserveFocus, pinned, sideBySide, browserEvent) {
        if (!element) return;
        this._onDidOpen.fire({
            editorOptions: {
                preserveFocus,
                pinned,
                revealIfVisible: true
            },
            sideBySide,
            element,
            browserEvent
        });
    }
}
class ListResourceNavigator extends ResourceNavigator {
    constructor(widget, options){
        super(widget, options);
        this.widget = widget;
    }
    getSelectedElement() {
        return this.widget.getSelectedElements()[0];
    }
}
class TableResourceNavigator extends ResourceNavigator {
    constructor(widget, options){
        super(widget, options);
    }
    getSelectedElement() {
        return this.widget.getSelectedElements()[0];
    }
}
class TreeResourceNavigator extends ResourceNavigator {
    constructor(widget, options){
        super(widget, options);
    }
    getSelectedElement() {
        return this.widget.getSelection()[0] ?? undefined;
    }
}
function createKeyboardNavigationEventFilter(keybindingService) {
    let inMultiChord = false;
    return (event)=>{
        if (event.toKeyCodeChord().isModifierKey()) return false;
        if (inMultiChord) {
            inMultiChord = false;
            return false;
        }
        const result = keybindingService.softDispatch(event, event.target);
        if (result.kind === 1 /* ResultKind.MoreChordsNeeded */ ) {
            inMultiChord = true;
            return false;
        }
        inMultiChord = false;
        return result.kind === 0 /* ResultKind.NoMatchingKb */ ;
    };
}
let WorkbenchObjectTree = class WorkbenchObjectTree extends (0, _objectTreeJs.ObjectTree) {
    constructor(user, container, delegate, renderers, options, instantiationService, contextKeyService, listService, configurationService){
        const { options: treeOptions, getTypeNavigationMode, disposable } = instantiationService.invokeFunction(workbenchTreeDataPreamble, options);
        super(user, container, delegate, renderers, treeOptions);
        this.disposables.add(disposable);
        this.internals = new WorkbenchTreeInternals(this, options, getTypeNavigationMode, options.overrideStyles, contextKeyService, listService, configurationService);
        this.disposables.add(this.internals);
    }
    updateOptions(options) {
        super.updateOptions(options);
        this.internals.updateOptions(options);
    }
};
WorkbenchObjectTree = __decorate([
    __param(5, (0, _instantiationJs.IInstantiationService)),
    __param(6, (0, _contextkeyJs.IContextKeyService)),
    __param(7, IListService),
    __param(8, (0, _configurationJs.IConfigurationService))
], WorkbenchObjectTree);
let WorkbenchCompressibleObjectTree = class WorkbenchCompressibleObjectTree extends (0, _objectTreeJs.CompressibleObjectTree) {
    constructor(user, container, delegate, renderers, options, instantiationService, contextKeyService, listService, configurationService){
        const { options: treeOptions, getTypeNavigationMode, disposable } = instantiationService.invokeFunction(workbenchTreeDataPreamble, options);
        super(user, container, delegate, renderers, treeOptions);
        this.disposables.add(disposable);
        this.internals = new WorkbenchTreeInternals(this, options, getTypeNavigationMode, options.overrideStyles, contextKeyService, listService, configurationService);
        this.disposables.add(this.internals);
    }
    updateOptions(options = {}) {
        super.updateOptions(options);
        if (options.overrideStyles) this.internals.updateStyleOverrides(options.overrideStyles);
        this.internals.updateOptions(options);
    }
};
WorkbenchCompressibleObjectTree = __decorate([
    __param(5, (0, _instantiationJs.IInstantiationService)),
    __param(6, (0, _contextkeyJs.IContextKeyService)),
    __param(7, IListService),
    __param(8, (0, _configurationJs.IConfigurationService))
], WorkbenchCompressibleObjectTree);
let WorkbenchDataTree = class WorkbenchDataTree extends (0, _dataTreeJs.DataTree) {
    constructor(user, container, delegate, renderers, dataSource, options, instantiationService, contextKeyService, listService, configurationService){
        const { options: treeOptions, getTypeNavigationMode, disposable } = instantiationService.invokeFunction(workbenchTreeDataPreamble, options);
        super(user, container, delegate, renderers, dataSource, treeOptions);
        this.disposables.add(disposable);
        this.internals = new WorkbenchTreeInternals(this, options, getTypeNavigationMode, options.overrideStyles, contextKeyService, listService, configurationService);
        this.disposables.add(this.internals);
    }
    updateOptions(options = {}) {
        super.updateOptions(options);
        if (options.overrideStyles !== undefined) this.internals.updateStyleOverrides(options.overrideStyles);
        this.internals.updateOptions(options);
    }
};
WorkbenchDataTree = __decorate([
    __param(6, (0, _instantiationJs.IInstantiationService)),
    __param(7, (0, _contextkeyJs.IContextKeyService)),
    __param(8, IListService),
    __param(9, (0, _configurationJs.IConfigurationService))
], WorkbenchDataTree);
let WorkbenchAsyncDataTree = class WorkbenchAsyncDataTree extends (0, _asyncDataTreeJs.AsyncDataTree) {
    get onDidOpen() {
        return this.internals.onDidOpen;
    }
    constructor(user, container, delegate, renderers, dataSource, options, instantiationService, contextKeyService, listService, configurationService){
        const { options: treeOptions, getTypeNavigationMode, disposable } = instantiationService.invokeFunction(workbenchTreeDataPreamble, options);
        super(user, container, delegate, renderers, dataSource, treeOptions);
        this.disposables.add(disposable);
        this.internals = new WorkbenchTreeInternals(this, options, getTypeNavigationMode, options.overrideStyles, contextKeyService, listService, configurationService);
        this.disposables.add(this.internals);
    }
    updateOptions(options = {}) {
        super.updateOptions(options);
        if (options.overrideStyles) this.internals.updateStyleOverrides(options.overrideStyles);
        this.internals.updateOptions(options);
    }
};
WorkbenchAsyncDataTree = __decorate([
    __param(6, (0, _instantiationJs.IInstantiationService)),
    __param(7, (0, _contextkeyJs.IContextKeyService)),
    __param(8, IListService),
    __param(9, (0, _configurationJs.IConfigurationService))
], WorkbenchAsyncDataTree);
let WorkbenchCompressibleAsyncDataTree = class WorkbenchCompressibleAsyncDataTree extends (0, _asyncDataTreeJs.CompressibleAsyncDataTree) {
    constructor(user, container, virtualDelegate, compressionDelegate, renderers, dataSource, options, instantiationService, contextKeyService, listService, configurationService){
        const { options: treeOptions, getTypeNavigationMode, disposable } = instantiationService.invokeFunction(workbenchTreeDataPreamble, options);
        super(user, container, virtualDelegate, compressionDelegate, renderers, dataSource, treeOptions);
        this.disposables.add(disposable);
        this.internals = new WorkbenchTreeInternals(this, options, getTypeNavigationMode, options.overrideStyles, contextKeyService, listService, configurationService);
        this.disposables.add(this.internals);
    }
    updateOptions(options) {
        super.updateOptions(options);
        this.internals.updateOptions(options);
    }
};
WorkbenchCompressibleAsyncDataTree = __decorate([
    __param(7, (0, _instantiationJs.IInstantiationService)),
    __param(8, (0, _contextkeyJs.IContextKeyService)),
    __param(9, IListService),
    __param(10, (0, _configurationJs.IConfigurationService))
], WorkbenchCompressibleAsyncDataTree);
function getDefaultTreeFindMode(configurationService) {
    const value = configurationService.getValue(defaultFindModeSettingKey);
    if (value === "highlight") return (0, _abstractTreeJs.TreeFindMode).Highlight;
    else if (value === "filter") return (0, _abstractTreeJs.TreeFindMode).Filter;
    const deprecatedValue = configurationService.getValue(keyboardNavigationSettingKey);
    if (deprecatedValue === "simple" || deprecatedValue === "highlight") return (0, _abstractTreeJs.TreeFindMode).Highlight;
    else if (deprecatedValue === "filter") return (0, _abstractTreeJs.TreeFindMode).Filter;
    return undefined;
}
function getDefaultTreeFindMatchType(configurationService) {
    const value = configurationService.getValue(defaultFindMatchTypeSettingKey);
    if (value === "fuzzy") return (0, _abstractTreeJs.TreeFindMatchType).Fuzzy;
    else if (value === "contiguous") return (0, _abstractTreeJs.TreeFindMatchType).Contiguous;
    return undefined;
}
function workbenchTreeDataPreamble(accessor, options) {
    const configurationService = accessor.get((0, _configurationJs.IConfigurationService));
    const contextViewService = accessor.get((0, _contextViewJs.IContextViewService));
    const contextKeyService = accessor.get((0, _contextkeyJs.IContextKeyService));
    const instantiationService = accessor.get((0, _instantiationJs.IInstantiationService));
    const getTypeNavigationMode = ()=>{
        // give priority to the context key value to specify a value
        const modeString = contextKeyService.getContextKeyValue(WorkbenchListTypeNavigationModeKey);
        if (modeString === "automatic") return (0, _listWidgetJs.TypeNavigationMode).Automatic;
        else if (modeString === "trigger") return (0, _listWidgetJs.TypeNavigationMode).Trigger;
        // also check the deprecated context key to set the mode to 'trigger'
        const modeBoolean = contextKeyService.getContextKeyValue(WorkbenchListAutomaticKeyboardNavigationLegacyKey);
        if (modeBoolean === false) return (0, _listWidgetJs.TypeNavigationMode).Trigger;
        // finally, check the setting
        const configString = configurationService.getValue(typeNavigationModeSettingKey);
        if (configString === "automatic") return (0, _listWidgetJs.TypeNavigationMode).Automatic;
        else if (configString === "trigger") return (0, _listWidgetJs.TypeNavigationMode).Trigger;
        return undefined;
    };
    const horizontalScrolling = options.horizontalScrolling !== undefined ? options.horizontalScrolling : Boolean(configurationService.getValue(horizontalScrollingKey));
    const [workbenchListOptions, disposable] = instantiationService.invokeFunction(toWorkbenchListOptions, options);
    const paddingBottom = options.paddingBottom;
    const renderIndentGuides = options.renderIndentGuides !== undefined ? options.renderIndentGuides : configurationService.getValue(treeRenderIndentGuidesKey);
    return {
        getTypeNavigationMode,
        disposable,
        options: {
            // ...options, // TODO@Joao why is this not splatted here?
            keyboardSupport: false,
            ...workbenchListOptions,
            indent: typeof configurationService.getValue(treeIndentKey) === "number" ? configurationService.getValue(treeIndentKey) : undefined,
            renderIndentGuides,
            smoothScrolling: Boolean(configurationService.getValue(listSmoothScrolling)),
            defaultFindMode: getDefaultTreeFindMode(configurationService),
            defaultFindMatchType: getDefaultTreeFindMatchType(configurationService),
            horizontalScrolling,
            scrollByPage: Boolean(configurationService.getValue(scrollByPageKey)),
            paddingBottom: paddingBottom,
            hideTwistiesOfChildlessElements: options.hideTwistiesOfChildlessElements,
            expandOnlyOnTwistieClick: options.expandOnlyOnTwistieClick ?? configurationService.getValue(treeExpandMode) === "doubleClick",
            contextViewProvider: contextViewService,
            findWidgetStyles: (0, _defaultStylesJs.defaultFindWidgetStyles),
            enableStickyScroll: Boolean(configurationService.getValue(treeStickyScroll)),
            stickyScrollMaxItemCount: Number(configurationService.getValue(treeStickyScrollMaxElements))
        }
    };
}
let WorkbenchTreeInternals = class WorkbenchTreeInternals {
    get onDidOpen() {
        return this.navigator.onDidOpen;
    }
    constructor(tree, options, getTypeNavigationMode, overrideStyles, contextKeyService, listService, configurationService){
        this.tree = tree;
        this.disposables = [];
        this.contextKeyService = createScopedContextKeyService(contextKeyService, tree);
        this.disposables.push(createScrollObserver(this.contextKeyService, tree));
        this.listSupportsMultiSelect = WorkbenchListSupportsMultiSelectContextKey.bindTo(this.contextKeyService);
        this.listSupportsMultiSelect.set(options.multipleSelectionSupport !== false);
        const listSelectionNavigation = WorkbenchListSelectionNavigation.bindTo(this.contextKeyService);
        listSelectionNavigation.set(Boolean(options.selectionNavigation));
        this.listSupportFindWidget = WorkbenchListSupportsFind.bindTo(this.contextKeyService);
        this.listSupportFindWidget.set(options.findWidgetEnabled ?? true);
        this.hasSelectionOrFocus = WorkbenchListHasSelectionOrFocus.bindTo(this.contextKeyService);
        this.hasDoubleSelection = WorkbenchListDoubleSelection.bindTo(this.contextKeyService);
        this.hasMultiSelection = WorkbenchListMultiSelection.bindTo(this.contextKeyService);
        this.treeElementCanCollapse = WorkbenchTreeElementCanCollapse.bindTo(this.contextKeyService);
        this.treeElementHasParent = WorkbenchTreeElementHasParent.bindTo(this.contextKeyService);
        this.treeElementCanExpand = WorkbenchTreeElementCanExpand.bindTo(this.contextKeyService);
        this.treeElementHasChild = WorkbenchTreeElementHasChild.bindTo(this.contextKeyService);
        this.treeFindOpen = WorkbenchTreeFindOpen.bindTo(this.contextKeyService);
        this.treeStickyScrollFocused = WorkbenchTreeStickyScrollFocused.bindTo(this.contextKeyService);
        this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
        this.updateStyleOverrides(overrideStyles);
        const updateCollapseContextKeys = ()=>{
            const focus = tree.getFocus()[0];
            if (!focus) return;
            const node = tree.getNode(focus);
            this.treeElementCanCollapse.set(node.collapsible && !node.collapsed);
            this.treeElementHasParent.set(!!tree.getParentElement(focus));
            this.treeElementCanExpand.set(node.collapsible && node.collapsed);
            this.treeElementHasChild.set(!!tree.getFirstElementChild(focus));
        };
        const interestingContextKeys = new Set();
        interestingContextKeys.add(WorkbenchListTypeNavigationModeKey);
        interestingContextKeys.add(WorkbenchListAutomaticKeyboardNavigationLegacyKey);
        this.disposables.push(this.contextKeyService, listService.register(tree), tree.onDidChangeSelection(()=>{
            const selection = tree.getSelection();
            const focus = tree.getFocus();
            this.contextKeyService.bufferChangeEvents(()=>{
                this.hasSelectionOrFocus.set(selection.length > 0 || focus.length > 0);
                this.hasMultiSelection.set(selection.length > 1);
                this.hasDoubleSelection.set(selection.length === 2);
            });
        }), tree.onDidChangeFocus(()=>{
            const selection = tree.getSelection();
            const focus = tree.getFocus();
            this.hasSelectionOrFocus.set(selection.length > 0 || focus.length > 0);
            updateCollapseContextKeys();
        }), tree.onDidChangeCollapseState(updateCollapseContextKeys), tree.onDidChangeModel(updateCollapseContextKeys), tree.onDidChangeFindOpenState((enabled)=>this.treeFindOpen.set(enabled)), tree.onDidChangeStickyScrollFocused((focused)=>this.treeStickyScrollFocused.set(focused)), configurationService.onDidChangeConfiguration((e)=>{
            let newOptions = {};
            if (e.affectsConfiguration(multiSelectModifierSettingKey)) this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
            if (e.affectsConfiguration(treeIndentKey)) {
                const indent = configurationService.getValue(treeIndentKey);
                newOptions = {
                    ...newOptions,
                    indent
                };
            }
            if (e.affectsConfiguration(treeRenderIndentGuidesKey) && options.renderIndentGuides === undefined) {
                const renderIndentGuides = configurationService.getValue(treeRenderIndentGuidesKey);
                newOptions = {
                    ...newOptions,
                    renderIndentGuides
                };
            }
            if (e.affectsConfiguration(listSmoothScrolling)) {
                const smoothScrolling = Boolean(configurationService.getValue(listSmoothScrolling));
                newOptions = {
                    ...newOptions,
                    smoothScrolling
                };
            }
            if (e.affectsConfiguration(defaultFindModeSettingKey) || e.affectsConfiguration(keyboardNavigationSettingKey)) {
                const defaultFindMode = getDefaultTreeFindMode(configurationService);
                newOptions = {
                    ...newOptions,
                    defaultFindMode
                };
            }
            if (e.affectsConfiguration(typeNavigationModeSettingKey) || e.affectsConfiguration(keyboardNavigationSettingKey)) {
                const typeNavigationMode = getTypeNavigationMode();
                newOptions = {
                    ...newOptions,
                    typeNavigationMode
                };
            }
            if (e.affectsConfiguration(defaultFindMatchTypeSettingKey)) {
                const defaultFindMatchType = getDefaultTreeFindMatchType(configurationService);
                newOptions = {
                    ...newOptions,
                    defaultFindMatchType
                };
            }
            if (e.affectsConfiguration(horizontalScrollingKey) && options.horizontalScrolling === undefined) {
                const horizontalScrolling = Boolean(configurationService.getValue(horizontalScrollingKey));
                newOptions = {
                    ...newOptions,
                    horizontalScrolling
                };
            }
            if (e.affectsConfiguration(scrollByPageKey)) {
                const scrollByPage = Boolean(configurationService.getValue(scrollByPageKey));
                newOptions = {
                    ...newOptions,
                    scrollByPage
                };
            }
            if (e.affectsConfiguration(treeExpandMode) && options.expandOnlyOnTwistieClick === undefined) newOptions = {
                ...newOptions,
                expandOnlyOnTwistieClick: configurationService.getValue(treeExpandMode) === "doubleClick"
            };
            if (e.affectsConfiguration(treeStickyScroll)) {
                const enableStickyScroll = configurationService.getValue(treeStickyScroll);
                newOptions = {
                    ...newOptions,
                    enableStickyScroll
                };
            }
            if (e.affectsConfiguration(treeStickyScrollMaxElements)) {
                const stickyScrollMaxItemCount = Math.max(1, configurationService.getValue(treeStickyScrollMaxElements));
                newOptions = {
                    ...newOptions,
                    stickyScrollMaxItemCount
                };
            }
            if (e.affectsConfiguration(mouseWheelScrollSensitivityKey)) {
                const mouseWheelScrollSensitivity = configurationService.getValue(mouseWheelScrollSensitivityKey);
                newOptions = {
                    ...newOptions,
                    mouseWheelScrollSensitivity
                };
            }
            if (e.affectsConfiguration(fastScrollSensitivityKey)) {
                const fastScrollSensitivity = configurationService.getValue(fastScrollSensitivityKey);
                newOptions = {
                    ...newOptions,
                    fastScrollSensitivity
                };
            }
            if (Object.keys(newOptions).length > 0) tree.updateOptions(newOptions);
        }), this.contextKeyService.onDidChangeContext((e)=>{
            if (e.affectsSome(interestingContextKeys)) tree.updateOptions({
                typeNavigationMode: getTypeNavigationMode()
            });
        }));
        this.navigator = new TreeResourceNavigator(tree, {
            configurationService,
            ...options
        });
        this.disposables.push(this.navigator);
    }
    updateOptions(options) {
        if (options.multipleSelectionSupport !== undefined) this.listSupportsMultiSelect.set(!!options.multipleSelectionSupport);
    }
    updateStyleOverrides(overrideStyles) {
        this.tree.style(overrideStyles ? (0, _defaultStylesJs.getListStyles)(overrideStyles) : (0, _defaultStylesJs.defaultListStyles));
    }
    dispose() {
        this.disposables = (0, _lifecycleJs.dispose)(this.disposables);
    }
};
WorkbenchTreeInternals = __decorate([
    __param(4, (0, _contextkeyJs.IContextKeyService)),
    __param(5, IListService),
    __param(6, (0, _configurationJs.IConfigurationService))
], WorkbenchTreeInternals);
const configurationRegistry = (0, _platformJs.Registry).as((0, _configurationRegistryJs.Extensions).Configuration);
configurationRegistry.registerConfiguration({
    id: "workbench",
    order: 7,
    title: (0, _nlsJs.localize)("workbenchConfigurationTitle", "Workbench"),
    type: "object",
    properties: {
        [multiSelectModifierSettingKey]: {
            type: "string",
            enum: [
                "ctrlCmd",
                "alt"
            ],
            markdownEnumDescriptions: [
                (0, _nlsJs.localize)("multiSelectModifier.ctrlCmd", "Maps to `Control` on Windows and Linux and to `Command` on macOS."),
                (0, _nlsJs.localize)("multiSelectModifier.alt", "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")
            ],
            default: "ctrlCmd",
            description: (0, _nlsJs.localize)({
                key: "multiSelectModifier",
                comment: [
                    "- `ctrlCmd` refers to a value the setting can take and should not be localized.",
                    "- `Control` and `Command` refer to the modifier keys Ctrl or Cmd on the keyboard and can be localized."
                ]
            }, "The modifier to be used to add an item in trees and lists to a multi-selection with the mouse (for example in the explorer, open editors and scm view). The 'Open to Side' mouse gestures - if supported - will adapt such that they do not conflict with the multiselect modifier.")
        },
        [openModeSettingKey]: {
            type: "string",
            enum: [
                "singleClick",
                "doubleClick"
            ],
            default: "singleClick",
            description: (0, _nlsJs.localize)({
                key: "openModeModifier",
                comment: [
                    "`singleClick` and `doubleClick` refers to a value the setting can take and should not be localized."
                ]
            }, "Controls how to open items in trees and lists using the mouse (if supported). Note that some trees and lists might choose to ignore this setting if it is not applicable.")
        },
        [horizontalScrollingKey]: {
            type: "boolean",
            default: false,
            description: (0, _nlsJs.localize)("horizontalScrolling setting", "Controls whether lists and trees support horizontal scrolling in the workbench. Warning: turning on this setting has a performance implication.")
        },
        [scrollByPageKey]: {
            type: "boolean",
            default: false,
            description: (0, _nlsJs.localize)("list.scrollByPage", "Controls whether clicks in the scrollbar scroll page by page.")
        },
        [treeIndentKey]: {
            type: "number",
            default: 8,
            minimum: 4,
            maximum: 40,
            description: (0, _nlsJs.localize)("tree indent setting", "Controls tree indentation in pixels.")
        },
        [treeRenderIndentGuidesKey]: {
            type: "string",
            enum: [
                "none",
                "onHover",
                "always"
            ],
            default: "onHover",
            description: (0, _nlsJs.localize)("render tree indent guides", "Controls whether the tree should render indent guides.")
        },
        [listSmoothScrolling]: {
            type: "boolean",
            default: false,
            description: (0, _nlsJs.localize)("list smoothScrolling setting", "Controls whether lists and trees have smooth scrolling.")
        },
        [mouseWheelScrollSensitivityKey]: {
            type: "number",
            default: 1,
            markdownDescription: (0, _nlsJs.localize)("Mouse Wheel Scroll Sensitivity", "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.")
        },
        [fastScrollSensitivityKey]: {
            type: "number",
            default: 5,
            markdownDescription: (0, _nlsJs.localize)("Fast Scroll Sensitivity", "Scrolling speed multiplier when pressing `Alt`.")
        },
        [defaultFindModeSettingKey]: {
            type: "string",
            enum: [
                "highlight",
                "filter"
            ],
            enumDescriptions: [
                (0, _nlsJs.localize)("defaultFindModeSettingKey.highlight", "Highlight elements when searching. Further up and down navigation will traverse only the highlighted elements."),
                (0, _nlsJs.localize)("defaultFindModeSettingKey.filter", "Filter elements when searching.")
            ],
            default: "highlight",
            description: (0, _nlsJs.localize)("defaultFindModeSettingKey", "Controls the default find mode for lists and trees in the workbench.")
        },
        [keyboardNavigationSettingKey]: {
            type: "string",
            enum: [
                "simple",
                "highlight",
                "filter"
            ],
            enumDescriptions: [
                (0, _nlsJs.localize)("keyboardNavigationSettingKey.simple", "Simple keyboard navigation focuses elements which match the keyboard input. Matching is done only on prefixes."),
                (0, _nlsJs.localize)("keyboardNavigationSettingKey.highlight", "Highlight keyboard navigation highlights elements which match the keyboard input. Further up and down navigation will traverse only the highlighted elements."),
                (0, _nlsJs.localize)("keyboardNavigationSettingKey.filter", "Filter keyboard navigation will filter out and hide all the elements which do not match the keyboard input.")
            ],
            default: "highlight",
            description: (0, _nlsJs.localize)("keyboardNavigationSettingKey", "Controls the keyboard navigation style for lists and trees in the workbench. Can be simple, highlight and filter."),
            deprecated: true,
            deprecationMessage: (0, _nlsJs.localize)("keyboardNavigationSettingKeyDeprecated", "Please use 'workbench.list.defaultFindMode' and	'workbench.list.typeNavigationMode' instead.")
        },
        [defaultFindMatchTypeSettingKey]: {
            type: "string",
            enum: [
                "fuzzy",
                "contiguous"
            ],
            enumDescriptions: [
                (0, _nlsJs.localize)("defaultFindMatchTypeSettingKey.fuzzy", "Use fuzzy matching when searching."),
                (0, _nlsJs.localize)("defaultFindMatchTypeSettingKey.contiguous", "Use contiguous matching when searching.")
            ],
            default: "fuzzy",
            description: (0, _nlsJs.localize)("defaultFindMatchTypeSettingKey", "Controls the type of matching used when searching lists and trees in the workbench.")
        },
        [treeExpandMode]: {
            type: "string",
            enum: [
                "singleClick",
                "doubleClick"
            ],
            default: "singleClick",
            description: (0, _nlsJs.localize)("expand mode", "Controls how tree folders are expanded when clicking the folder names. Note that some trees and lists might choose to ignore this setting if it is not applicable.")
        },
        [treeStickyScroll]: {
            type: "boolean",
            default: true,
            description: (0, _nlsJs.localize)("sticky scroll", "Controls whether sticky scrolling is enabled in trees.")
        },
        [treeStickyScrollMaxElements]: {
            type: "number",
            minimum: 1,
            default: 7,
            markdownDescription: (0, _nlsJs.localize)("sticky scroll maximum items", "Controls the number of sticky elements displayed in the tree when {0} is enabled.", "`#workbench.tree.enableStickyScroll#`")
        },
        [typeNavigationModeSettingKey]: {
            type: "string",
            enum: [
                "automatic",
                "trigger"
            ],
            default: "automatic",
            markdownDescription: (0, _nlsJs.localize)("typeNavigationMode2", "Controls how type navigation works in lists and trees in the workbench. When set to `trigger`, type navigation begins once the `list.triggerTypeNavigation` command is run.")
        }
    }
});

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/ui/list/listPaging.js":"j1W60","../../../base/browser/ui/list/listWidget.js":"f6tmg","../../../base/browser/ui/table/tableWidget.js":"cjcao","../../../base/browser/ui/tree/abstractTree.js":"2Z8Kh","../../../base/browser/ui/tree/asyncDataTree.js":"eY8mJ","../../../base/browser/ui/tree/dataTree.js":"cC1Yk","../../../base/browser/ui/tree/objectTree.js":"eYKNI","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../nls.js":"l617d","../../configuration/common/configuration.js":"dXkjq","../../configuration/common/configurationRegistry.js":"6y4yB","../../contextkey/common/contextkey.js":"gXuBD","../../contextkey/common/contextkeys.js":"jqcbi","../../contextview/browser/contextView.js":"2QlUR","../../instantiation/common/instantiation.js":"fjwWx","../../keybinding/common/keybinding.js":"25pLT","../../registry/common/platform.js":"dzx11","../../theme/browser/defaultStyles.js":"4exuA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j1W60":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PagedList", ()=>PagedList);
var _arraysJs = require("../../../common/arrays.js");
var _cancellationJs = require("../../../common/cancellation.js");
var _eventJs = require("../../../common/event.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _listCss = require("./list.css");
var _listWidgetJs = require("./listWidget.js");
class PagedRenderer {
    get templateId() {
        return this.renderer.templateId;
    }
    constructor(renderer, modelProvider){
        this.renderer = renderer;
        this.modelProvider = modelProvider;
    }
    renderTemplate(container) {
        const data = this.renderer.renderTemplate(container);
        return {
            data,
            disposable: (0, _lifecycleJs.Disposable).None
        };
    }
    renderElement(index, _, data, height) {
        data.disposable?.dispose();
        if (!data.data) return;
        const model = this.modelProvider();
        if (model.isResolved(index)) return this.renderer.renderElement(model.get(index), index, data.data, height);
        const cts = new (0, _cancellationJs.CancellationTokenSource)();
        const promise = model.resolve(index, cts.token);
        data.disposable = {
            dispose: ()=>cts.cancel()
        };
        this.renderer.renderPlaceholder(index, data.data);
        promise.then((entry)=>this.renderer.renderElement(entry, index, data.data, height));
    }
    disposeTemplate(data) {
        if (data.disposable) {
            data.disposable.dispose();
            data.disposable = undefined;
        }
        if (data.data) {
            this.renderer.disposeTemplate(data.data);
            data.data = undefined;
        }
    }
}
class PagedAccessibilityProvider {
    constructor(modelProvider, accessibilityProvider){
        this.modelProvider = modelProvider;
        this.accessibilityProvider = accessibilityProvider;
    }
    getWidgetAriaLabel() {
        return this.accessibilityProvider.getWidgetAriaLabel();
    }
    getAriaLabel(index) {
        const model = this.modelProvider();
        if (!model.isResolved(index)) return null;
        return this.accessibilityProvider.getAriaLabel(model.get(index));
    }
}
function fromPagedListOptions(modelProvider, options) {
    return {
        ...options,
        accessibilityProvider: options.accessibilityProvider && new PagedAccessibilityProvider(modelProvider, options.accessibilityProvider)
    };
}
class PagedList {
    constructor(user, container, virtualDelegate, renderers, options = {}){
        const modelProvider = ()=>this.model;
        const pagedRenderers = renderers.map((r)=>new PagedRenderer(r, modelProvider));
        this.list = new (0, _listWidgetJs.List)(user, container, virtualDelegate, pagedRenderers, fromPagedListOptions(modelProvider, options));
    }
    updateOptions(options) {
        this.list.updateOptions(options);
    }
    getHTMLElement() {
        return this.list.getHTMLElement();
    }
    get onDidFocus() {
        return this.list.onDidFocus;
    }
    get widget() {
        return this.list;
    }
    get onDidDispose() {
        return this.list.onDidDispose;
    }
    get onMouseDblClick() {
        return (0, _eventJs.Event).map(this.list.onMouseDblClick, ({ element, index, browserEvent })=>({
                element: element === undefined ? undefined : this._model.get(element),
                index,
                browserEvent
            }));
    }
    get onPointer() {
        return (0, _eventJs.Event).map(this.list.onPointer, ({ element, index, browserEvent })=>({
                element: element === undefined ? undefined : this._model.get(element),
                index,
                browserEvent
            }));
    }
    get onDidChangeSelection() {
        return (0, _eventJs.Event).map(this.list.onDidChangeSelection, ({ elements, indexes, browserEvent })=>({
                elements: elements.map((e)=>this._model.get(e)),
                indexes,
                browserEvent
            }));
    }
    get model() {
        return this._model;
    }
    set model(model) {
        this._model = model;
        this.list.splice(0, this.list.length, (0, _arraysJs.range)(model.length));
    }
    getFocus() {
        return this.list.getFocus();
    }
    getSelection() {
        return this.list.getSelection();
    }
    getSelectedElements() {
        return this.getSelection().map((i)=>this.model.get(i));
    }
    style(styles) {
        this.list.style(styles);
    }
    dispose() {
        this.list.dispose();
    }
}

},{"../../../common/arrays.js":"DECei","../../../common/cancellation.js":"hoVxw","../../../common/event.js":"4Zi8b","../../../common/lifecycle.js":"9kg8d","./list.css":"5wcA5","./listWidget.js":"f6tmg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5wcA5":[function() {},{}],"cjcao":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
var _domJs = require("../../dom.js");
var _hoverDelegate2Js = require("../hover/hoverDelegate2.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _listWidgetJs = require("../list/listWidget.js");
var _splitviewJs = require("../splitview/splitview.js");
var _eventJs = require("../../../common/event.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _tableCss = require("./table.css");
class TableListRenderer {
    static{
        this.TemplateId = "row";
    }
    constructor(columns, renderers, getColumnSize){
        this.columns = columns;
        this.getColumnSize = getColumnSize;
        this.templateId = TableListRenderer.TemplateId;
        this.renderedTemplates = new Set();
        const rendererMap = new Map(renderers.map((r)=>[
                r.templateId,
                r
            ]));
        this.renderers = [];
        for (const column of columns){
            const renderer = rendererMap.get(column.templateId);
            if (!renderer) throw new Error(`Table cell renderer for template id ${column.templateId} not found.`);
            this.renderers.push(renderer);
        }
    }
    renderTemplate(container) {
        const rowContainer = (0, _domJs.append)(container, (0, _domJs.$)(".monaco-table-tr"));
        const cellContainers = [];
        const cellTemplateData = [];
        for(let i = 0; i < this.columns.length; i++){
            const renderer = this.renderers[i];
            const cellContainer = (0, _domJs.append)(rowContainer, (0, _domJs.$)(".monaco-table-td", {
                "data-col-index": i
            }));
            cellContainer.style.width = `${this.getColumnSize(i)}px`;
            cellContainers.push(cellContainer);
            cellTemplateData.push(renderer.renderTemplate(cellContainer));
        }
        const result = {
            container,
            cellContainers,
            cellTemplateData
        };
        this.renderedTemplates.add(result);
        return result;
    }
    renderElement(element, index, templateData, height) {
        for(let i = 0; i < this.columns.length; i++){
            const column = this.columns[i];
            const cell = column.project(element);
            const renderer = this.renderers[i];
            renderer.renderElement(cell, index, templateData.cellTemplateData[i], height);
        }
    }
    disposeElement(element, index, templateData, height) {
        for(let i = 0; i < this.columns.length; i++){
            const renderer = this.renderers[i];
            if (renderer.disposeElement) {
                const column = this.columns[i];
                const cell = column.project(element);
                renderer.disposeElement(cell, index, templateData.cellTemplateData[i], height);
            }
        }
    }
    disposeTemplate(templateData) {
        for(let i = 0; i < this.columns.length; i++){
            const renderer = this.renderers[i];
            renderer.disposeTemplate(templateData.cellTemplateData[i]);
        }
        (0, _domJs.clearNode)(templateData.container);
        this.renderedTemplates.delete(templateData);
    }
    layoutColumn(index, size) {
        for (const { cellContainers } of this.renderedTemplates)cellContainers[index].style.width = `${size}px`;
    }
}
function asListVirtualDelegate(delegate) {
    return {
        getHeight (row) {
            return delegate.getHeight(row);
        },
        getTemplateId () {
            return TableListRenderer.TemplateId;
        }
    };
}
class ColumnHeader extends (0, _lifecycleJs.Disposable) {
    get minimumSize() {
        return this.column.minimumWidth ?? 120;
    }
    get maximumSize() {
        return this.column.maximumWidth ?? Number.POSITIVE_INFINITY;
    }
    get onDidChange() {
        return this.column.onDidChangeWidthConstraints ?? (0, _eventJs.Event).None;
    }
    constructor(column, index){
        super();
        this.column = column;
        this.index = index;
        this._onDidLayout = new (0, _eventJs.Emitter)();
        this.onDidLayout = this._onDidLayout.event;
        this.element = (0, _domJs.$)(".monaco-table-th", {
            "data-col-index": index
        }, column.label);
        if (column.tooltip) this._register((0, _hoverDelegate2Js.getBaseLayerHoverDelegate)().setupManagedHover((0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("mouse"), this.element, column.tooltip));
    }
    layout(size) {
        this._onDidLayout.fire([
            this.index,
            size
        ]);
    }
}
class Table {
    static{
        this.InstanceCount = 0;
    }
    get onDidChangeFocus() {
        return this.list.onDidChangeFocus;
    }
    get onDidChangeSelection() {
        return this.list.onDidChangeSelection;
    }
    get onDidScroll() {
        return this.list.onDidScroll;
    }
    get onMouseDblClick() {
        return this.list.onMouseDblClick;
    }
    get onPointer() {
        return this.list.onPointer;
    }
    get onDidFocus() {
        return this.list.onDidFocus;
    }
    get scrollTop() {
        return this.list.scrollTop;
    }
    set scrollTop(scrollTop) {
        this.list.scrollTop = scrollTop;
    }
    get scrollHeight() {
        return this.list.scrollHeight;
    }
    get renderHeight() {
        return this.list.renderHeight;
    }
    get onDidDispose() {
        return this.list.onDidDispose;
    }
    constructor(user, container, virtualDelegate, columns, renderers, _options){
        this.virtualDelegate = virtualDelegate;
        this.columns = columns;
        this.domId = `table_id_${++Table.InstanceCount}`;
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this.cachedWidth = 0;
        this.cachedHeight = 0;
        this.domNode = (0, _domJs.append)(container, (0, _domJs.$)(`.monaco-table.${this.domId}`));
        const headers = columns.map((c, i)=>this.disposables.add(new ColumnHeader(c, i)));
        const descriptor = {
            size: headers.reduce((a, b)=>a + b.column.weight, 0),
            views: headers.map((view)=>({
                    size: view.column.weight,
                    view
                }))
        };
        this.splitview = this.disposables.add(new (0, _splitviewJs.SplitView)(this.domNode, {
            orientation: 1 /* Orientation.HORIZONTAL */ ,
            scrollbarVisibility: 2 /* ScrollbarVisibility.Hidden */ ,
            getSashOrthogonalSize: ()=>this.cachedHeight,
            descriptor
        }));
        this.splitview.el.style.height = `${virtualDelegate.headerRowHeight}px`;
        this.splitview.el.style.lineHeight = `${virtualDelegate.headerRowHeight}px`;
        const renderer = new TableListRenderer(columns, renderers, (i)=>this.splitview.getViewSize(i));
        this.list = this.disposables.add(new (0, _listWidgetJs.List)(user, this.domNode, asListVirtualDelegate(virtualDelegate), [
            renderer
        ], _options));
        (0, _eventJs.Event).any(...headers.map((h)=>h.onDidLayout))(([index, size])=>renderer.layoutColumn(index, size), null, this.disposables);
        this.splitview.onDidSashReset((index)=>{
            const totalWeight = columns.reduce((r, c)=>r + c.weight, 0);
            const size = columns[index].weight / totalWeight * this.cachedWidth;
            this.splitview.resizeView(index, size);
        }, null, this.disposables);
        this.styleElement = (0, _domJs.createStyleSheet)(this.domNode);
        this.style((0, _listWidgetJs.unthemedListStyles));
    }
    updateOptions(options) {
        this.list.updateOptions(options);
    }
    splice(start, deleteCount, elements = []) {
        this.list.splice(start, deleteCount, elements);
    }
    getHTMLElement() {
        return this.domNode;
    }
    style(styles) {
        const content = [];
        content.push(`.monaco-table.${this.domId} > .monaco-split-view2 .monaco-sash.vertical::before {
			top: ${this.virtualDelegate.headerRowHeight + 1}px;
			height: calc(100% - ${this.virtualDelegate.headerRowHeight}px);
		}`);
        this.styleElement.textContent = content.join("\n");
        this.list.style(styles);
    }
    getSelectedElements() {
        return this.list.getSelectedElements();
    }
    getSelection() {
        return this.list.getSelection();
    }
    getFocus() {
        return this.list.getFocus();
    }
    dispose() {
        this.disposables.dispose();
    }
}

},{"../../dom.js":"bnqsM","../hover/hoverDelegate2.js":"5jqL3","../hover/hoverDelegateFactory.js":"kll4h","../list/listWidget.js":"f6tmg","../splitview/splitview.js":"kIDcw","../../../common/event.js":"4Zi8b","../../../common/lifecycle.js":"9kg8d","./table.css":"k8a3I","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kIDcw":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sizing", ()=>Sizing);
/**
 * The {@link SplitView} is the UI component which implements a one dimensional
 * flex-like layout algorithm for a collection of {@link IView} instances, which
 * are essentially HTMLElement instances with the following size constraints:
 *
 * - {@link IView.minimumSize}
 * - {@link IView.maximumSize}
 * - {@link IView.priority}
 * - {@link IView.snap}
 *
 * In case the SplitView doesn't have enough size to fit all views, it will overflow
 * its content with a scrollbar.
 *
 * In between each pair of views there will be a {@link Sash} allowing the user
 * to resize the views, making sure the constraints are respected.
 *
 * An optional {@link TLayoutContext layout context type} may be used in order to
 * pass along layout contextual data from the {@link SplitView.layout} method down
 * to each view's {@link IView.layout} calls.
 *
 * Features:
 * - Flex-like layout algorithm
 * - Snap support
 * - Orthogonal sash support, for corner sashes
 * - View hide/show support
 * - View swap/move support
 * - Alt key modifier behavior, macOS style
 */ parcelHelpers.export(exports, "SplitView", ()=>SplitView);
var _domJs = require("../../dom.js");
var _eventJs = require("../../event.js");
var _sashJs = require("../sash/sash.js");
var _scrollableElementJs = require("../scrollbar/scrollableElement.js");
var _arraysJs = require("../../../common/arrays.js");
var _colorJs = require("../../../common/color.js");
var _eventJs1 = require("../../../common/event.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _numbersJs = require("../../../common/numbers.js");
var _scrollableJs = require("../../../common/scrollable.js");
var _typesJs = require("../../../common/types.js");
var _splitviewCss = require("./splitview.css");
const defaultStyles = {
    separatorBorder: (0, _colorJs.Color).transparent
};
class ViewItem {
    set size(size) {
        this._size = size;
    }
    get size() {
        return this._size;
    }
    get visible() {
        return typeof this._cachedVisibleSize === "undefined";
    }
    setVisible(visible, size) {
        if (visible === this.visible) return;
        if (visible) {
            this.size = (0, _numbersJs.clamp)(this._cachedVisibleSize, this.viewMinimumSize, this.viewMaximumSize);
            this._cachedVisibleSize = undefined;
        } else {
            this._cachedVisibleSize = typeof size === "number" ? size : this.size;
            this.size = 0;
        }
        this.container.classList.toggle("visible", visible);
        try {
            this.view.setVisible?.(visible);
        } catch (e) {
            console.error("Splitview: Failed to set visible view");
            console.error(e);
        }
    }
    get minimumSize() {
        return this.visible ? this.view.minimumSize : 0;
    }
    get viewMinimumSize() {
        return this.view.minimumSize;
    }
    get maximumSize() {
        return this.visible ? this.view.maximumSize : 0;
    }
    get viewMaximumSize() {
        return this.view.maximumSize;
    }
    get priority() {
        return this.view.priority;
    }
    get proportionalLayout() {
        return this.view.proportionalLayout ?? true;
    }
    get snap() {
        return !!this.view.snap;
    }
    set enabled(enabled) {
        this.container.style.pointerEvents = enabled ? "" : "none";
    }
    constructor(container, view, size, disposable){
        this.container = container;
        this.view = view;
        this.disposable = disposable;
        this._cachedVisibleSize = undefined;
        if (typeof size === "number") {
            this._size = size;
            this._cachedVisibleSize = undefined;
            container.classList.add("visible");
        } else {
            this._size = 0;
            this._cachedVisibleSize = size.cachedVisibleSize;
        }
    }
    layout(offset, layoutContext) {
        this.layoutContainer(offset);
        try {
            this.view.layout(this.size, offset, layoutContext);
        } catch (e) {
            console.error("Splitview: Failed to layout view");
            console.error(e);
        }
    }
    dispose() {
        this.disposable.dispose();
    }
}
class VerticalViewItem extends ViewItem {
    layoutContainer(offset) {
        this.container.style.top = `${offset}px`;
        this.container.style.height = `${this.size}px`;
    }
}
class HorizontalViewItem extends ViewItem {
    layoutContainer(offset) {
        this.container.style.left = `${offset}px`;
        this.container.style.width = `${this.size}px`;
    }
}
var State;
(function(State) {
    State[State["Idle"] = 0] = "Idle";
    State[State["Busy"] = 1] = "Busy";
})(State || (State = {}));
var Sizing;
(function(Sizing) {
    /**
     * When adding or removing views, distribute the delta space among
     * all other views.
     */ Sizing.Distribute = {
        type: "distribute"
    };
    /**
     * When adding or removing views, split the delta space with another
     * specific view, indexed by the provided `index`.
     */ function Split(index) {
        return {
            type: "split",
            index
        };
    }
    Sizing.Split = Split;
    /**
     * When adding a view, use DistributeSizing when all pre-existing views are
     * distributed evenly, otherwise use SplitSizing.
     */ function Auto(index) {
        return {
            type: "auto",
            index
        };
    }
    Sizing.Auto = Auto;
    /**
     * When adding or removing views, assume the view is invisible.
     */ function Invisible(cachedVisibleSize) {
        return {
            type: "invisible",
            cachedVisibleSize
        };
    }
    Sizing.Invisible = Invisible;
})(Sizing || (Sizing = {}));
class SplitView extends (0, _lifecycleJs.Disposable) {
    get orthogonalStartSash() {
        return this._orthogonalStartSash;
    }
    get orthogonalEndSash() {
        return this._orthogonalEndSash;
    }
    get startSnappingEnabled() {
        return this._startSnappingEnabled;
    }
    get endSnappingEnabled() {
        return this._endSnappingEnabled;
    }
    /**
     * A reference to a sash, perpendicular to all sashes in this {@link SplitView},
     * located at the left- or top-most side of the SplitView.
     * Corner sashes will be created automatically at the intersections.
     */ set orthogonalStartSash(sash) {
        for (const sashItem of this.sashItems)sashItem.sash.orthogonalStartSash = sash;
        this._orthogonalStartSash = sash;
    }
    /**
     * A reference to a sash, perpendicular to all sashes in this {@link SplitView},
     * located at the right- or bottom-most side of the SplitView.
     * Corner sashes will be created automatically at the intersections.
     */ set orthogonalEndSash(sash) {
        for (const sashItem of this.sashItems)sashItem.sash.orthogonalEndSash = sash;
        this._orthogonalEndSash = sash;
    }
    /**
     * Enable/disable snapping at the beginning of this {@link SplitView}.
     */ set startSnappingEnabled(startSnappingEnabled) {
        if (this._startSnappingEnabled === startSnappingEnabled) return;
        this._startSnappingEnabled = startSnappingEnabled;
        this.updateSashEnablement();
    }
    /**
     * Enable/disable snapping at the end of this {@link SplitView}.
     */ set endSnappingEnabled(endSnappingEnabled) {
        if (this._endSnappingEnabled === endSnappingEnabled) return;
        this._endSnappingEnabled = endSnappingEnabled;
        this.updateSashEnablement();
    }
    /**
     * Create a new {@link SplitView} instance.
     */ constructor(container, options = {}){
        super();
        this.size = 0;
        this._contentSize = 0;
        this.proportions = undefined;
        this.viewItems = [];
        this.sashItems = []; // used in tests
        this.state = State.Idle;
        this._onDidSashChange = this._register(new (0, _eventJs1.Emitter)());
        this._onDidSashReset = this._register(new (0, _eventJs1.Emitter)());
        this._startSnappingEnabled = true;
        this._endSnappingEnabled = true;
        /**
         * Fires whenever the user resizes a {@link Sash sash}.
         */ this.onDidSashChange = this._onDidSashChange.event;
        /**
         * Fires whenever the user double clicks a {@link Sash sash}.
         */ this.onDidSashReset = this._onDidSashReset.event;
        this.orientation = options.orientation ?? 0 /* Orientation.VERTICAL */ ;
        this.inverseAltBehavior = options.inverseAltBehavior ?? false;
        this.proportionalLayout = options.proportionalLayout ?? true;
        this.getSashOrthogonalSize = options.getSashOrthogonalSize;
        this.el = document.createElement("div");
        this.el.classList.add("monaco-split-view2");
        this.el.classList.add(this.orientation === 0 /* Orientation.VERTICAL */  ? "vertical" : "horizontal");
        container.appendChild(this.el);
        this.sashContainer = (0, _domJs.append)(this.el, (0, _domJs.$)(".sash-container"));
        this.viewContainer = (0, _domJs.$)(".split-view-container");
        this.scrollable = this._register(new (0, _scrollableJs.Scrollable)({
            forceIntegerValues: true,
            smoothScrollDuration: 125,
            scheduleAtNextAnimationFrame: (callback)=>(0, _domJs.scheduleAtNextAnimationFrame)((0, _domJs.getWindow)(this.el), callback)
        }));
        this.scrollableElement = this._register(new (0, _scrollableElementJs.SmoothScrollableElement)(this.viewContainer, {
            vertical: this.orientation === 0 /* Orientation.VERTICAL */  ? options.scrollbarVisibility ?? 1 /* ScrollbarVisibility.Auto */  : 2 /* ScrollbarVisibility.Hidden */ ,
            horizontal: this.orientation === 1 /* Orientation.HORIZONTAL */  ? options.scrollbarVisibility ?? 1 /* ScrollbarVisibility.Auto */  : 2 /* ScrollbarVisibility.Hidden */ 
        }, this.scrollable));
        // https://github.com/microsoft/vscode/issues/157737
        const onDidScrollViewContainer = this._register(new (0, _eventJs.DomEmitter)(this.viewContainer, "scroll")).event;
        this._register(onDidScrollViewContainer((_)=>{
            const position = this.scrollableElement.getScrollPosition();
            const scrollLeft = Math.abs(this.viewContainer.scrollLeft - position.scrollLeft) <= 1 ? undefined : this.viewContainer.scrollLeft;
            const scrollTop = Math.abs(this.viewContainer.scrollTop - position.scrollTop) <= 1 ? undefined : this.viewContainer.scrollTop;
            if (scrollLeft !== undefined || scrollTop !== undefined) this.scrollableElement.setScrollPosition({
                scrollLeft,
                scrollTop
            });
        }));
        this.onDidScroll = this.scrollableElement.onScroll;
        this._register(this.onDidScroll((e)=>{
            if (e.scrollTopChanged) this.viewContainer.scrollTop = e.scrollTop;
            if (e.scrollLeftChanged) this.viewContainer.scrollLeft = e.scrollLeft;
        }));
        (0, _domJs.append)(this.el, this.scrollableElement.getDomNode());
        this.style(options.styles || defaultStyles);
        // We have an existing set of view, add them now
        if (options.descriptor) {
            this.size = options.descriptor.size;
            options.descriptor.views.forEach((viewDescriptor, index)=>{
                const sizing = _typesJs.isUndefined(viewDescriptor.visible) || viewDescriptor.visible ? viewDescriptor.size : {
                    type: "invisible",
                    cachedVisibleSize: viewDescriptor.size
                };
                const view = viewDescriptor.view;
                this.doAddView(view, sizing, index, true);
            });
            // Initialize content size and proportions for first layout
            this._contentSize = this.viewItems.reduce((r, i)=>r + i.size, 0);
            this.saveProportions();
        }
    }
    style(styles) {
        if (styles.separatorBorder.isTransparent()) {
            this.el.classList.remove("separator-border");
            this.el.style.removeProperty("--separator-border");
        } else {
            this.el.classList.add("separator-border");
            this.el.style.setProperty("--separator-border", styles.separatorBorder.toString());
        }
    }
    /**
     * Add a {@link IView view} to this {@link SplitView}.
     *
     * @param view The view to add.
     * @param size Either a fixed size, or a dynamic {@link Sizing} strategy.
     * @param index The index to insert the view on.
     * @param skipLayout Whether layout should be skipped.
     */ addView(view, size, index = this.viewItems.length, skipLayout) {
        this.doAddView(view, size, index, skipLayout);
    }
    /**
     * Layout the {@link SplitView}.
     *
     * @param size The entire size of the {@link SplitView}.
     * @param layoutContext An optional layout context to pass along to {@link IView views}.
     */ layout(size, layoutContext) {
        const previousSize = Math.max(this.size, this._contentSize);
        this.size = size;
        this.layoutContext = layoutContext;
        if (!this.proportions) {
            const indexes = (0, _arraysJs.range)(this.viewItems.length);
            const lowPriorityIndexes = indexes.filter((i)=>this.viewItems[i].priority === 1 /* LayoutPriority.Low */ );
            const highPriorityIndexes = indexes.filter((i)=>this.viewItems[i].priority === 2 /* LayoutPriority.High */ );
            this.resize(this.viewItems.length - 1, size - previousSize, undefined, lowPriorityIndexes, highPriorityIndexes);
        } else {
            let total = 0;
            for(let i = 0; i < this.viewItems.length; i++){
                const item = this.viewItems[i];
                const proportion = this.proportions[i];
                if (typeof proportion === "number") total += proportion;
                else size -= item.size;
            }
            for(let i = 0; i < this.viewItems.length; i++){
                const item = this.viewItems[i];
                const proportion = this.proportions[i];
                if (typeof proportion === "number" && total > 0) item.size = (0, _numbersJs.clamp)(Math.round(proportion * size / total), item.minimumSize, item.maximumSize);
            }
        }
        this.distributeEmptySpace();
        this.layoutViews();
    }
    saveProportions() {
        if (this.proportionalLayout && this._contentSize > 0) this.proportions = this.viewItems.map((v)=>v.proportionalLayout && v.visible ? v.size / this._contentSize : undefined);
    }
    onSashStart({ sash, start, alt }) {
        for (const item of this.viewItems)item.enabled = false;
        const index = this.sashItems.findIndex((item)=>item.sash === sash);
        // This way, we can press Alt while we resize a sash, macOS style!
        const disposable = (0, _lifecycleJs.combinedDisposable)((0, _domJs.addDisposableListener)(this.el.ownerDocument.body, "keydown", (e)=>resetSashDragState(this.sashDragState.current, e.altKey)), (0, _domJs.addDisposableListener)(this.el.ownerDocument.body, "keyup", ()=>resetSashDragState(this.sashDragState.current, false)));
        const resetSashDragState = (start, alt)=>{
            const sizes = this.viewItems.map((i)=>i.size);
            let minDelta = Number.NEGATIVE_INFINITY;
            let maxDelta = Number.POSITIVE_INFINITY;
            if (this.inverseAltBehavior) alt = !alt;
            if (alt) {
                // When we're using the last sash with Alt, we're resizing
                // the view to the left/up, instead of right/down as usual
                // Thus, we must do the inverse of the usual
                const isLastSash = index === this.sashItems.length - 1;
                if (isLastSash) {
                    const viewItem = this.viewItems[index];
                    minDelta = (viewItem.minimumSize - viewItem.size) / 2;
                    maxDelta = (viewItem.maximumSize - viewItem.size) / 2;
                } else {
                    const viewItem = this.viewItems[index + 1];
                    minDelta = (viewItem.size - viewItem.maximumSize) / 2;
                    maxDelta = (viewItem.size - viewItem.minimumSize) / 2;
                }
            }
            let snapBefore;
            let snapAfter;
            if (!alt) {
                const upIndexes = (0, _arraysJs.range)(index, -1);
                const downIndexes = (0, _arraysJs.range)(index + 1, this.viewItems.length);
                const minDeltaUp = upIndexes.reduce((r, i)=>r + (this.viewItems[i].minimumSize - sizes[i]), 0);
                const maxDeltaUp = upIndexes.reduce((r, i)=>r + (this.viewItems[i].viewMaximumSize - sizes[i]), 0);
                const maxDeltaDown = downIndexes.length === 0 ? Number.POSITIVE_INFINITY : downIndexes.reduce((r, i)=>r + (sizes[i] - this.viewItems[i].minimumSize), 0);
                const minDeltaDown = downIndexes.length === 0 ? Number.NEGATIVE_INFINITY : downIndexes.reduce((r, i)=>r + (sizes[i] - this.viewItems[i].viewMaximumSize), 0);
                const minDelta = Math.max(minDeltaUp, minDeltaDown);
                const maxDelta = Math.min(maxDeltaDown, maxDeltaUp);
                const snapBeforeIndex = this.findFirstSnapIndex(upIndexes);
                const snapAfterIndex = this.findFirstSnapIndex(downIndexes);
                if (typeof snapBeforeIndex === "number") {
                    const viewItem = this.viewItems[snapBeforeIndex];
                    const halfSize = Math.floor(viewItem.viewMinimumSize / 2);
                    snapBefore = {
                        index: snapBeforeIndex,
                        limitDelta: viewItem.visible ? minDelta - halfSize : minDelta + halfSize,
                        size: viewItem.size
                    };
                }
                if (typeof snapAfterIndex === "number") {
                    const viewItem = this.viewItems[snapAfterIndex];
                    const halfSize = Math.floor(viewItem.viewMinimumSize / 2);
                    snapAfter = {
                        index: snapAfterIndex,
                        limitDelta: viewItem.visible ? maxDelta + halfSize : maxDelta - halfSize,
                        size: viewItem.size
                    };
                }
            }
            this.sashDragState = {
                start,
                current: start,
                index,
                sizes,
                minDelta,
                maxDelta,
                alt,
                snapBefore,
                snapAfter,
                disposable
            };
        };
        resetSashDragState(start, alt);
    }
    onSashChange({ current }) {
        const { index, start, sizes, alt, minDelta, maxDelta, snapBefore, snapAfter } = this.sashDragState;
        this.sashDragState.current = current;
        const delta = current - start;
        const newDelta = this.resize(index, delta, sizes, undefined, undefined, minDelta, maxDelta, snapBefore, snapAfter);
        if (alt) {
            const isLastSash = index === this.sashItems.length - 1;
            const newSizes = this.viewItems.map((i)=>i.size);
            const viewItemIndex = isLastSash ? index : index + 1;
            const viewItem = this.viewItems[viewItemIndex];
            const newMinDelta = viewItem.size - viewItem.maximumSize;
            const newMaxDelta = viewItem.size - viewItem.minimumSize;
            const resizeIndex = isLastSash ? index - 1 : index + 1;
            this.resize(resizeIndex, -newDelta, newSizes, undefined, undefined, newMinDelta, newMaxDelta);
        }
        this.distributeEmptySpace();
        this.layoutViews();
    }
    onSashEnd(index) {
        this._onDidSashChange.fire(index);
        this.sashDragState.disposable.dispose();
        this.saveProportions();
        for (const item of this.viewItems)item.enabled = true;
    }
    onViewChange(item, size) {
        const index = this.viewItems.indexOf(item);
        if (index < 0 || index >= this.viewItems.length) return;
        size = typeof size === "number" ? size : item.size;
        size = (0, _numbersJs.clamp)(size, item.minimumSize, item.maximumSize);
        if (this.inverseAltBehavior && index > 0) {
            // In this case, we want the view to grow or shrink both sides equally
            // so we just resize the "left" side by half and let `resize` do the clamping magic
            this.resize(index - 1, Math.floor((item.size - size) / 2));
            this.distributeEmptySpace();
            this.layoutViews();
        } else {
            item.size = size;
            this.relayout([
                index
            ], undefined);
        }
    }
    /**
     * Resize a {@link IView view} within the {@link SplitView}.
     *
     * @param index The {@link IView view} index.
     * @param size The {@link IView view} size.
     */ resizeView(index, size) {
        if (index < 0 || index >= this.viewItems.length) return;
        if (this.state !== State.Idle) throw new Error("Cant modify splitview");
        this.state = State.Busy;
        try {
            const indexes = (0, _arraysJs.range)(this.viewItems.length).filter((i)=>i !== index);
            const lowPriorityIndexes = [
                ...indexes.filter((i)=>this.viewItems[i].priority === 1 /* LayoutPriority.Low */ ),
                index
            ];
            const highPriorityIndexes = indexes.filter((i)=>this.viewItems[i].priority === 2 /* LayoutPriority.High */ );
            const item = this.viewItems[index];
            size = Math.round(size);
            size = (0, _numbersJs.clamp)(size, item.minimumSize, Math.min(item.maximumSize, this.size));
            item.size = size;
            this.relayout(lowPriorityIndexes, highPriorityIndexes);
        } finally{
            this.state = State.Idle;
        }
    }
    /**
     * Distribute the entire {@link SplitView} size among all {@link IView views}.
     */ distributeViewSizes() {
        const flexibleViewItems = [];
        let flexibleSize = 0;
        for (const item of this.viewItems)if (item.maximumSize - item.minimumSize > 0) {
            flexibleViewItems.push(item);
            flexibleSize += item.size;
        }
        const size = Math.floor(flexibleSize / flexibleViewItems.length);
        for (const item of flexibleViewItems)item.size = (0, _numbersJs.clamp)(size, item.minimumSize, item.maximumSize);
        const indexes = (0, _arraysJs.range)(this.viewItems.length);
        const lowPriorityIndexes = indexes.filter((i)=>this.viewItems[i].priority === 1 /* LayoutPriority.Low */ );
        const highPriorityIndexes = indexes.filter((i)=>this.viewItems[i].priority === 2 /* LayoutPriority.High */ );
        this.relayout(lowPriorityIndexes, highPriorityIndexes);
    }
    /**
     * Returns the size of a {@link IView view}.
     */ getViewSize(index) {
        if (index < 0 || index >= this.viewItems.length) return -1;
        return this.viewItems[index].size;
    }
    doAddView(view, size, index = this.viewItems.length, skipLayout) {
        if (this.state !== State.Idle) throw new Error("Cant modify splitview");
        this.state = State.Busy;
        try {
            // Add view
            const container = (0, _domJs.$)(".split-view-view");
            if (index === this.viewItems.length) this.viewContainer.appendChild(container);
            else this.viewContainer.insertBefore(container, this.viewContainer.children.item(index));
            const onChangeDisposable = view.onDidChange((size)=>this.onViewChange(item, size));
            const containerDisposable = (0, _lifecycleJs.toDisposable)(()=>container.remove());
            const disposable = (0, _lifecycleJs.combinedDisposable)(onChangeDisposable, containerDisposable);
            let viewSize;
            if (typeof size === "number") viewSize = size;
            else {
                if (size.type === "auto") {
                    if (this.areViewsDistributed()) size = {
                        type: "distribute"
                    };
                    else size = {
                        type: "split",
                        index: size.index
                    };
                }
                if (size.type === "split") viewSize = this.getViewSize(size.index) / 2;
                else if (size.type === "invisible") viewSize = {
                    cachedVisibleSize: size.cachedVisibleSize
                };
                else viewSize = view.minimumSize;
            }
            const item = this.orientation === 0 /* Orientation.VERTICAL */  ? new VerticalViewItem(container, view, viewSize, disposable) : new HorizontalViewItem(container, view, viewSize, disposable);
            this.viewItems.splice(index, 0, item);
            // Add sash
            if (this.viewItems.length > 1) {
                const opts = {
                    orthogonalStartSash: this.orthogonalStartSash,
                    orthogonalEndSash: this.orthogonalEndSash
                };
                const sash = this.orientation === 0 /* Orientation.VERTICAL */  ? new (0, _sashJs.Sash)(this.sashContainer, {
                    getHorizontalSashTop: (s)=>this.getSashPosition(s),
                    getHorizontalSashWidth: this.getSashOrthogonalSize
                }, {
                    ...opts,
                    orientation: 1 /* Orientation.HORIZONTAL */ 
                }) : new (0, _sashJs.Sash)(this.sashContainer, {
                    getVerticalSashLeft: (s)=>this.getSashPosition(s),
                    getVerticalSashHeight: this.getSashOrthogonalSize
                }, {
                    ...opts,
                    orientation: 0 /* Orientation.VERTICAL */ 
                });
                const sashEventMapper = this.orientation === 0 /* Orientation.VERTICAL */  ? (e)=>({
                        sash,
                        start: e.startY,
                        current: e.currentY,
                        alt: e.altKey
                    }) : (e)=>({
                        sash,
                        start: e.startX,
                        current: e.currentX,
                        alt: e.altKey
                    });
                const onStart = (0, _eventJs1.Event).map(sash.onDidStart, sashEventMapper);
                const onStartDisposable = onStart(this.onSashStart, this);
                const onChange = (0, _eventJs1.Event).map(sash.onDidChange, sashEventMapper);
                const onChangeDisposable = onChange(this.onSashChange, this);
                const onEnd = (0, _eventJs1.Event).map(sash.onDidEnd, ()=>this.sashItems.findIndex((item)=>item.sash === sash));
                const onEndDisposable = onEnd(this.onSashEnd, this);
                const onDidResetDisposable = sash.onDidReset(()=>{
                    const index = this.sashItems.findIndex((item)=>item.sash === sash);
                    const upIndexes = (0, _arraysJs.range)(index, -1);
                    const downIndexes = (0, _arraysJs.range)(index + 1, this.viewItems.length);
                    const snapBeforeIndex = this.findFirstSnapIndex(upIndexes);
                    const snapAfterIndex = this.findFirstSnapIndex(downIndexes);
                    if (typeof snapBeforeIndex === "number" && !this.viewItems[snapBeforeIndex].visible) return;
                    if (typeof snapAfterIndex === "number" && !this.viewItems[snapAfterIndex].visible) return;
                    this._onDidSashReset.fire(index);
                });
                const disposable = (0, _lifecycleJs.combinedDisposable)(onStartDisposable, onChangeDisposable, onEndDisposable, onDidResetDisposable, sash);
                const sashItem = {
                    sash,
                    disposable
                };
                this.sashItems.splice(index - 1, 0, sashItem);
            }
            container.appendChild(view.element);
            let highPriorityIndexes;
            if (typeof size !== "number" && size.type === "split") highPriorityIndexes = [
                size.index
            ];
            if (!skipLayout) this.relayout([
                index
            ], highPriorityIndexes);
            if (!skipLayout && typeof size !== "number" && size.type === "distribute") this.distributeViewSizes();
        } finally{
            this.state = State.Idle;
        }
    }
    relayout(lowPriorityIndexes, highPriorityIndexes) {
        const contentSize = this.viewItems.reduce((r, i)=>r + i.size, 0);
        this.resize(this.viewItems.length - 1, this.size - contentSize, undefined, lowPriorityIndexes, highPriorityIndexes);
        this.distributeEmptySpace();
        this.layoutViews();
        this.saveProportions();
    }
    resize(index, delta, sizes = this.viewItems.map((i)=>i.size), lowPriorityIndexes, highPriorityIndexes, overloadMinDelta = Number.NEGATIVE_INFINITY, overloadMaxDelta = Number.POSITIVE_INFINITY, snapBefore, snapAfter) {
        if (index < 0 || index >= this.viewItems.length) return 0;
        const upIndexes = (0, _arraysJs.range)(index, -1);
        const downIndexes = (0, _arraysJs.range)(index + 1, this.viewItems.length);
        if (highPriorityIndexes) for (const index of highPriorityIndexes){
            (0, _arraysJs.pushToStart)(upIndexes, index);
            (0, _arraysJs.pushToStart)(downIndexes, index);
        }
        if (lowPriorityIndexes) for (const index of lowPriorityIndexes){
            (0, _arraysJs.pushToEnd)(upIndexes, index);
            (0, _arraysJs.pushToEnd)(downIndexes, index);
        }
        const upItems = upIndexes.map((i)=>this.viewItems[i]);
        const upSizes = upIndexes.map((i)=>sizes[i]);
        const downItems = downIndexes.map((i)=>this.viewItems[i]);
        const downSizes = downIndexes.map((i)=>sizes[i]);
        const minDeltaUp = upIndexes.reduce((r, i)=>r + (this.viewItems[i].minimumSize - sizes[i]), 0);
        const maxDeltaUp = upIndexes.reduce((r, i)=>r + (this.viewItems[i].maximumSize - sizes[i]), 0);
        const maxDeltaDown = downIndexes.length === 0 ? Number.POSITIVE_INFINITY : downIndexes.reduce((r, i)=>r + (sizes[i] - this.viewItems[i].minimumSize), 0);
        const minDeltaDown = downIndexes.length === 0 ? Number.NEGATIVE_INFINITY : downIndexes.reduce((r, i)=>r + (sizes[i] - this.viewItems[i].maximumSize), 0);
        const minDelta = Math.max(minDeltaUp, minDeltaDown, overloadMinDelta);
        const maxDelta = Math.min(maxDeltaDown, maxDeltaUp, overloadMaxDelta);
        let snapped = false;
        if (snapBefore) {
            const snapView = this.viewItems[snapBefore.index];
            const visible = delta >= snapBefore.limitDelta;
            snapped = visible !== snapView.visible;
            snapView.setVisible(visible, snapBefore.size);
        }
        if (!snapped && snapAfter) {
            const snapView = this.viewItems[snapAfter.index];
            const visible = delta < snapAfter.limitDelta;
            snapped = visible !== snapView.visible;
            snapView.setVisible(visible, snapAfter.size);
        }
        if (snapped) return this.resize(index, delta, sizes, lowPriorityIndexes, highPriorityIndexes, overloadMinDelta, overloadMaxDelta);
        delta = (0, _numbersJs.clamp)(delta, minDelta, maxDelta);
        for(let i = 0, deltaUp = delta; i < upItems.length; i++){
            const item = upItems[i];
            const size = (0, _numbersJs.clamp)(upSizes[i] + deltaUp, item.minimumSize, item.maximumSize);
            const viewDelta = size - upSizes[i];
            deltaUp -= viewDelta;
            item.size = size;
        }
        for(let i = 0, deltaDown = delta; i < downItems.length; i++){
            const item = downItems[i];
            const size = (0, _numbersJs.clamp)(downSizes[i] - deltaDown, item.minimumSize, item.maximumSize);
            const viewDelta = size - downSizes[i];
            deltaDown += viewDelta;
            item.size = size;
        }
        return delta;
    }
    distributeEmptySpace(lowPriorityIndex) {
        const contentSize = this.viewItems.reduce((r, i)=>r + i.size, 0);
        let emptyDelta = this.size - contentSize;
        const indexes = (0, _arraysJs.range)(this.viewItems.length - 1, -1);
        const lowPriorityIndexes = indexes.filter((i)=>this.viewItems[i].priority === 1 /* LayoutPriority.Low */ );
        const highPriorityIndexes = indexes.filter((i)=>this.viewItems[i].priority === 2 /* LayoutPriority.High */ );
        for (const index of highPriorityIndexes)(0, _arraysJs.pushToStart)(indexes, index);
        for (const index of lowPriorityIndexes)(0, _arraysJs.pushToEnd)(indexes, index);
        if (typeof lowPriorityIndex === "number") (0, _arraysJs.pushToEnd)(indexes, lowPriorityIndex);
        for(let i = 0; emptyDelta !== 0 && i < indexes.length; i++){
            const item = this.viewItems[indexes[i]];
            const size = (0, _numbersJs.clamp)(item.size + emptyDelta, item.minimumSize, item.maximumSize);
            const viewDelta = size - item.size;
            emptyDelta -= viewDelta;
            item.size = size;
        }
    }
    layoutViews() {
        // Save new content size
        this._contentSize = this.viewItems.reduce((r, i)=>r + i.size, 0);
        // Layout views
        let offset = 0;
        for (const viewItem of this.viewItems){
            viewItem.layout(offset, this.layoutContext);
            offset += viewItem.size;
        }
        // Layout sashes
        this.sashItems.forEach((item)=>item.sash.layout());
        this.updateSashEnablement();
        this.updateScrollableElement();
    }
    updateScrollableElement() {
        if (this.orientation === 0 /* Orientation.VERTICAL */ ) this.scrollableElement.setScrollDimensions({
            height: this.size,
            scrollHeight: this._contentSize
        });
        else this.scrollableElement.setScrollDimensions({
            width: this.size,
            scrollWidth: this._contentSize
        });
    }
    updateSashEnablement() {
        let previous = false;
        const collapsesDown = this.viewItems.map((i)=>previous = i.size - i.minimumSize > 0 || previous);
        previous = false;
        const expandsDown = this.viewItems.map((i)=>previous = i.maximumSize - i.size > 0 || previous);
        const reverseViews = [
            ...this.viewItems
        ].reverse();
        previous = false;
        const collapsesUp = reverseViews.map((i)=>previous = i.size - i.minimumSize > 0 || previous).reverse();
        previous = false;
        const expandsUp = reverseViews.map((i)=>previous = i.maximumSize - i.size > 0 || previous).reverse();
        let position = 0;
        for(let index = 0; index < this.sashItems.length; index++){
            const { sash } = this.sashItems[index];
            const viewItem = this.viewItems[index];
            position += viewItem.size;
            const min = !(collapsesDown[index] && expandsUp[index + 1]);
            const max = !(expandsDown[index] && collapsesUp[index + 1]);
            if (min && max) {
                const upIndexes = (0, _arraysJs.range)(index, -1);
                const downIndexes = (0, _arraysJs.range)(index + 1, this.viewItems.length);
                const snapBeforeIndex = this.findFirstSnapIndex(upIndexes);
                const snapAfterIndex = this.findFirstSnapIndex(downIndexes);
                const snappedBefore = typeof snapBeforeIndex === "number" && !this.viewItems[snapBeforeIndex].visible;
                const snappedAfter = typeof snapAfterIndex === "number" && !this.viewItems[snapAfterIndex].visible;
                if (snappedBefore && collapsesUp[index] && (position > 0 || this.startSnappingEnabled)) sash.state = 1 /* SashState.AtMinimum */ ;
                else if (snappedAfter && collapsesDown[index] && (position < this._contentSize || this.endSnappingEnabled)) sash.state = 2 /* SashState.AtMaximum */ ;
                else sash.state = 0 /* SashState.Disabled */ ;
            } else if (min && !max) sash.state = 1 /* SashState.AtMinimum */ ;
            else if (!min && max) sash.state = 2 /* SashState.AtMaximum */ ;
            else sash.state = 3 /* SashState.Enabled */ ;
        }
    }
    getSashPosition(sash) {
        let position = 0;
        for(let i = 0; i < this.sashItems.length; i++){
            position += this.viewItems[i].size;
            if (this.sashItems[i].sash === sash) return position;
        }
        return 0;
    }
    findFirstSnapIndex(indexes) {
        // visible views first
        for (const index of indexes){
            const viewItem = this.viewItems[index];
            if (!viewItem.visible) continue;
            if (viewItem.snap) return index;
        }
        // then, hidden views
        for (const index of indexes){
            const viewItem = this.viewItems[index];
            if (viewItem.visible && viewItem.maximumSize - viewItem.minimumSize > 0) return undefined;
            if (!viewItem.visible && viewItem.snap) return index;
        }
        return undefined;
    }
    areViewsDistributed() {
        let min = undefined, max = undefined;
        for (const view of this.viewItems){
            min = min === undefined ? view.size : Math.min(min, view.size);
            max = max === undefined ? view.size : Math.max(max, view.size);
            if (max - min > 2) return false;
        }
        return true;
    }
    dispose() {
        this.sashDragState?.disposable.dispose();
        (0, _lifecycleJs.dispose)(this.viewItems);
        this.viewItems = [];
        this.sashItems.forEach((i)=>i.disposable.dispose());
        this.sashItems = [];
        super.dispose();
    }
}

},{"../../dom.js":"bnqsM","../../event.js":"PHN3G","../sash/sash.js":"2Pk4d","../scrollbar/scrollableElement.js":"h1C5l","../../../common/arrays.js":"DECei","../../../common/color.js":"at4gb","../../../common/event.js":"4Zi8b","../../../common/lifecycle.js":"9kg8d","../../../common/numbers.js":"diWMG","../../../common/scrollable.js":"8otcz","../../../common/types.js":"fb5yx","./splitview.css":"292RN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Pk4d":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrthogonalEdge", ()=>OrthogonalEdge);
/**
 * The {@link Sash} is the UI component which allows the user to resize other
 * components. It's usually an invisible horizontal or vertical line which, when
 * hovered, becomes highlighted and can be dragged along the perpendicular dimension
 * to its direction.
 *
 * Features:
 * - Touch event handling
 * - Corner sash support
 * - Hover with different mouse cursor support
 * - Configurable hover size
 * - Linked sash support, for 2x2 corner sashes
 */ parcelHelpers.export(exports, "Sash", ()=>Sash);
var _domJs = require("../../dom.js");
var _eventJs = require("../../event.js");
var _touchJs = require("../../touch.js");
var _asyncJs = require("../../../common/async.js");
var _decoratorsJs = require("../../../common/decorators.js");
var _eventJs1 = require("../../../common/event.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _platformJs = require("../../../common/platform.js");
var _sashCss = require("./sash.css");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Allow the sashes to be visible at runtime.
 * @remark Use for development purposes only.
 */ const DEBUG = false;
var OrthogonalEdge;
(function(OrthogonalEdge) {
    OrthogonalEdge["North"] = "north";
    OrthogonalEdge["South"] = "south";
    OrthogonalEdge["East"] = "east";
    OrthogonalEdge["West"] = "west";
})(OrthogonalEdge || (OrthogonalEdge = {}));
let globalSize = 4;
const onDidChangeGlobalSize = new (0, _eventJs1.Emitter)();
let globalHoverDelay = 300;
const onDidChangeHoverDelay = new (0, _eventJs1.Emitter)();
class MouseEventFactory {
    constructor(el){
        this.el = el;
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
    }
    get onPointerMove() {
        return this.disposables.add(new (0, _eventJs.DomEmitter)((0, _domJs.getWindow)(this.el), "mousemove")).event;
    }
    get onPointerUp() {
        return this.disposables.add(new (0, _eventJs.DomEmitter)((0, _domJs.getWindow)(this.el), "mouseup")).event;
    }
    dispose() {
        this.disposables.dispose();
    }
}
__decorate([
    (0, _decoratorsJs.memoize)
], MouseEventFactory.prototype, "onPointerMove", null);
__decorate([
    (0, _decoratorsJs.memoize)
], MouseEventFactory.prototype, "onPointerUp", null);
class GestureEventFactory {
    get onPointerMove() {
        return this.disposables.add(new (0, _eventJs.DomEmitter)(this.el, (0, _touchJs.EventType).Change)).event;
    }
    get onPointerUp() {
        return this.disposables.add(new (0, _eventJs.DomEmitter)(this.el, (0, _touchJs.EventType).End)).event;
    }
    constructor(el){
        this.el = el;
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
    }
    dispose() {
        this.disposables.dispose();
    }
}
__decorate([
    (0, _decoratorsJs.memoize)
], GestureEventFactory.prototype, "onPointerMove", null);
__decorate([
    (0, _decoratorsJs.memoize)
], GestureEventFactory.prototype, "onPointerUp", null);
class OrthogonalPointerEventFactory {
    get onPointerMove() {
        return this.factory.onPointerMove;
    }
    get onPointerUp() {
        return this.factory.onPointerUp;
    }
    constructor(factory){
        this.factory = factory;
    }
    dispose() {
    // noop
    }
}
__decorate([
    (0, _decoratorsJs.memoize)
], OrthogonalPointerEventFactory.prototype, "onPointerMove", null);
__decorate([
    (0, _decoratorsJs.memoize)
], OrthogonalPointerEventFactory.prototype, "onPointerUp", null);
const PointerEventsDisabledCssClass = "pointer-events-disabled";
class Sash extends (0, _lifecycleJs.Disposable) {
    get state() {
        return this._state;
    }
    get orthogonalStartSash() {
        return this._orthogonalStartSash;
    }
    get orthogonalEndSash() {
        return this._orthogonalEndSash;
    }
    /**
     * The state of a sash defines whether it can be interacted with by the user
     * as well as what mouse cursor to use, when hovered.
     */ set state(state) {
        if (this._state === state) return;
        this.el.classList.toggle("disabled", state === 0 /* SashState.Disabled */ );
        this.el.classList.toggle("minimum", state === 1 /* SashState.AtMinimum */ );
        this.el.classList.toggle("maximum", state === 2 /* SashState.AtMaximum */ );
        this._state = state;
        this.onDidEnablementChange.fire(state);
    }
    /**
     * A reference to another sash, perpendicular to this one, which
     * aligns at the start of this one. A corner sash will be created
     * automatically at that location.
     *
     * The start of a horizontal sash is its left-most position.
     * The start of a vertical sash is its top-most position.
     */ set orthogonalStartSash(sash) {
        if (this._orthogonalStartSash === sash) return;
        this.orthogonalStartDragHandleDisposables.clear();
        this.orthogonalStartSashDisposables.clear();
        if (sash) {
            const onChange = (state)=>{
                this.orthogonalStartDragHandleDisposables.clear();
                if (state !== 0 /* SashState.Disabled */ ) {
                    this._orthogonalStartDragHandle = (0, _domJs.append)(this.el, (0, _domJs.$)(".orthogonal-drag-handle.start"));
                    this.orthogonalStartDragHandleDisposables.add((0, _lifecycleJs.toDisposable)(()=>this._orthogonalStartDragHandle.remove()));
                    this.orthogonalStartDragHandleDisposables.add(new (0, _eventJs.DomEmitter)(this._orthogonalStartDragHandle, "mouseenter")).event(()=>Sash.onMouseEnter(sash), undefined, this.orthogonalStartDragHandleDisposables);
                    this.orthogonalStartDragHandleDisposables.add(new (0, _eventJs.DomEmitter)(this._orthogonalStartDragHandle, "mouseleave")).event(()=>Sash.onMouseLeave(sash), undefined, this.orthogonalStartDragHandleDisposables);
                }
            };
            this.orthogonalStartSashDisposables.add(sash.onDidEnablementChange.event(onChange, this));
            onChange(sash.state);
        }
        this._orthogonalStartSash = sash;
    }
    /**
     * A reference to another sash, perpendicular to this one, which
     * aligns at the end of this one. A corner sash will be created
     * automatically at that location.
     *
     * The end of a horizontal sash is its right-most position.
     * The end of a vertical sash is its bottom-most position.
     */ set orthogonalEndSash(sash) {
        if (this._orthogonalEndSash === sash) return;
        this.orthogonalEndDragHandleDisposables.clear();
        this.orthogonalEndSashDisposables.clear();
        if (sash) {
            const onChange = (state)=>{
                this.orthogonalEndDragHandleDisposables.clear();
                if (state !== 0 /* SashState.Disabled */ ) {
                    this._orthogonalEndDragHandle = (0, _domJs.append)(this.el, (0, _domJs.$)(".orthogonal-drag-handle.end"));
                    this.orthogonalEndDragHandleDisposables.add((0, _lifecycleJs.toDisposable)(()=>this._orthogonalEndDragHandle.remove()));
                    this.orthogonalEndDragHandleDisposables.add(new (0, _eventJs.DomEmitter)(this._orthogonalEndDragHandle, "mouseenter")).event(()=>Sash.onMouseEnter(sash), undefined, this.orthogonalEndDragHandleDisposables);
                    this.orthogonalEndDragHandleDisposables.add(new (0, _eventJs.DomEmitter)(this._orthogonalEndDragHandle, "mouseleave")).event(()=>Sash.onMouseLeave(sash), undefined, this.orthogonalEndDragHandleDisposables);
                }
            };
            this.orthogonalEndSashDisposables.add(sash.onDidEnablementChange.event(onChange, this));
            onChange(sash.state);
        }
        this._orthogonalEndSash = sash;
    }
    constructor(container, layoutProvider, options){
        super();
        this.hoverDelay = globalHoverDelay;
        this.hoverDelayer = this._register(new (0, _asyncJs.Delayer)(this.hoverDelay));
        this._state = 3 /* SashState.Enabled */ ;
        this.onDidEnablementChange = this._register(new (0, _eventJs1.Emitter)());
        this._onDidStart = this._register(new (0, _eventJs1.Emitter)());
        this._onDidChange = this._register(new (0, _eventJs1.Emitter)());
        this._onDidReset = this._register(new (0, _eventJs1.Emitter)());
        this._onDidEnd = this._register(new (0, _eventJs1.Emitter)());
        this.orthogonalStartSashDisposables = this._register(new (0, _lifecycleJs.DisposableStore)());
        this.orthogonalStartDragHandleDisposables = this._register(new (0, _lifecycleJs.DisposableStore)());
        this.orthogonalEndSashDisposables = this._register(new (0, _lifecycleJs.DisposableStore)());
        this.orthogonalEndDragHandleDisposables = this._register(new (0, _lifecycleJs.DisposableStore)());
        /**
         * An event which fires whenever the user starts dragging this sash.
         */ this.onDidStart = this._onDidStart.event;
        /**
         * An event which fires whenever the user moves the mouse while
         * dragging this sash.
         */ this.onDidChange = this._onDidChange.event;
        /**
         * An event which fires whenever the user double clicks this sash.
         */ this.onDidReset = this._onDidReset.event;
        /**
         * An event which fires whenever the user stops dragging this sash.
         */ this.onDidEnd = this._onDidEnd.event;
        /**
         * A linked sash will be forwarded the same user interactions and events
         * so it moves exactly the same way as this sash.
         *
         * Useful in 2x2 grids. Not meant for widespread usage.
         */ this.linkedSash = undefined;
        this.el = (0, _domJs.append)(container, (0, _domJs.$)(".monaco-sash"));
        if (options.orthogonalEdge) this.el.classList.add(`orthogonal-edge-${options.orthogonalEdge}`);
        if (0, _platformJs.isMacintosh) this.el.classList.add("mac");
        const onMouseDown = this._register(new (0, _eventJs.DomEmitter)(this.el, "mousedown")).event;
        this._register(onMouseDown((e)=>this.onPointerStart(e, new MouseEventFactory(container)), this));
        const onMouseDoubleClick = this._register(new (0, _eventJs.DomEmitter)(this.el, "dblclick")).event;
        this._register(onMouseDoubleClick(this.onPointerDoublePress, this));
        const onMouseEnter = this._register(new (0, _eventJs.DomEmitter)(this.el, "mouseenter")).event;
        this._register(onMouseEnter(()=>Sash.onMouseEnter(this)));
        const onMouseLeave = this._register(new (0, _eventJs.DomEmitter)(this.el, "mouseleave")).event;
        this._register(onMouseLeave(()=>Sash.onMouseLeave(this)));
        this._register((0, _touchJs.Gesture).addTarget(this.el));
        const onTouchStart = this._register(new (0, _eventJs.DomEmitter)(this.el, (0, _touchJs.EventType).Start)).event;
        this._register(onTouchStart((e)=>this.onPointerStart(e, new GestureEventFactory(this.el)), this));
        const onTap = this._register(new (0, _eventJs.DomEmitter)(this.el, (0, _touchJs.EventType).Tap)).event;
        let doubleTapTimeout = undefined;
        this._register(onTap((event)=>{
            if (doubleTapTimeout) {
                clearTimeout(doubleTapTimeout);
                doubleTapTimeout = undefined;
                this.onPointerDoublePress(event);
                return;
            }
            clearTimeout(doubleTapTimeout);
            doubleTapTimeout = setTimeout(()=>doubleTapTimeout = undefined, 250);
        }, this));
        if (typeof options.size === "number") {
            this.size = options.size;
            if (options.orientation === 0 /* Orientation.VERTICAL */ ) this.el.style.width = `${this.size}px`;
            else this.el.style.height = `${this.size}px`;
        } else {
            this.size = globalSize;
            this._register(onDidChangeGlobalSize.event((size)=>{
                this.size = size;
                this.layout();
            }));
        }
        this._register(onDidChangeHoverDelay.event((delay)=>this.hoverDelay = delay));
        this.layoutProvider = layoutProvider;
        this.orthogonalStartSash = options.orthogonalStartSash;
        this.orthogonalEndSash = options.orthogonalEndSash;
        this.orientation = options.orientation || 0 /* Orientation.VERTICAL */ ;
        if (this.orientation === 1 /* Orientation.HORIZONTAL */ ) {
            this.el.classList.add("horizontal");
            this.el.classList.remove("vertical");
        } else {
            this.el.classList.remove("horizontal");
            this.el.classList.add("vertical");
        }
        this.el.classList.toggle("debug", DEBUG);
        this.layout();
    }
    onPointerStart(event, pointerEventFactory) {
        (0, _domJs.EventHelper).stop(event);
        let isMultisashResize = false;
        if (!event.__orthogonalSashEvent) {
            const orthogonalSash = this.getOrthogonalSash(event);
            if (orthogonalSash) {
                isMultisashResize = true;
                event.__orthogonalSashEvent = true;
                orthogonalSash.onPointerStart(event, new OrthogonalPointerEventFactory(pointerEventFactory));
            }
        }
        if (this.linkedSash && !event.__linkedSashEvent) {
            event.__linkedSashEvent = true;
            this.linkedSash.onPointerStart(event, new OrthogonalPointerEventFactory(pointerEventFactory));
        }
        if (!this.state) return;
        const iframes = this.el.ownerDocument.getElementsByTagName("iframe");
        for (const iframe of iframes)iframe.classList.add(PointerEventsDisabledCssClass); // disable mouse events on iframes as long as we drag the sash
        const startX = event.pageX;
        const startY = event.pageY;
        const altKey = event.altKey;
        const startEvent = {
            startX,
            currentX: startX,
            startY,
            currentY: startY,
            altKey
        };
        this.el.classList.add("active");
        this._onDidStart.fire(startEvent);
        // fix https://github.com/microsoft/vscode/issues/21675
        const style = (0, _domJs.createStyleSheet)(this.el);
        const updateStyle = ()=>{
            let cursor = "";
            if (isMultisashResize) cursor = "all-scroll";
            else if (this.orientation === 1 /* Orientation.HORIZONTAL */ ) {
                if (this.state === 1 /* SashState.AtMinimum */ ) cursor = "s-resize";
                else if (this.state === 2 /* SashState.AtMaximum */ ) cursor = "n-resize";
                else cursor = (0, _platformJs.isMacintosh) ? "row-resize" : "ns-resize";
            } else {
                if (this.state === 1 /* SashState.AtMinimum */ ) cursor = "e-resize";
                else if (this.state === 2 /* SashState.AtMaximum */ ) cursor = "w-resize";
                else cursor = (0, _platformJs.isMacintosh) ? "col-resize" : "ew-resize";
            }
            style.textContent = `* { cursor: ${cursor} !important; }`;
        };
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        updateStyle();
        if (!isMultisashResize) this.onDidEnablementChange.event(updateStyle, null, disposables);
        const onPointerMove = (e)=>{
            (0, _domJs.EventHelper).stop(e, false);
            const event = {
                startX,
                currentX: e.pageX,
                startY,
                currentY: e.pageY,
                altKey
            };
            this._onDidChange.fire(event);
        };
        const onPointerUp = (e)=>{
            (0, _domJs.EventHelper).stop(e, false);
            style.remove();
            this.el.classList.remove("active");
            this._onDidEnd.fire();
            disposables.dispose();
            for (const iframe of iframes)iframe.classList.remove(PointerEventsDisabledCssClass);
        };
        pointerEventFactory.onPointerMove(onPointerMove, null, disposables);
        pointerEventFactory.onPointerUp(onPointerUp, null, disposables);
        disposables.add(pointerEventFactory);
    }
    onPointerDoublePress(e) {
        const orthogonalSash = this.getOrthogonalSash(e);
        if (orthogonalSash) orthogonalSash._onDidReset.fire();
        if (this.linkedSash) this.linkedSash._onDidReset.fire();
        this._onDidReset.fire();
    }
    static onMouseEnter(sash, fromLinkedSash = false) {
        if (sash.el.classList.contains("active")) {
            sash.hoverDelayer.cancel();
            sash.el.classList.add("hover");
        } else sash.hoverDelayer.trigger(()=>sash.el.classList.add("hover"), sash.hoverDelay).then(undefined, ()=>{});
        if (!fromLinkedSash && sash.linkedSash) Sash.onMouseEnter(sash.linkedSash, true);
    }
    static onMouseLeave(sash, fromLinkedSash = false) {
        sash.hoverDelayer.cancel();
        sash.el.classList.remove("hover");
        if (!fromLinkedSash && sash.linkedSash) Sash.onMouseLeave(sash.linkedSash, true);
    }
    /**
     * Forcefully stop any user interactions with this sash.
     * Useful when hiding a parent component, while the user is still
     * interacting with the sash.
     */ clearSashHoverState() {
        Sash.onMouseLeave(this);
    }
    /**
     * Layout the sash. The sash will size and position itself
     * based on its provided {@link ISashLayoutProvider layout provider}.
     */ layout() {
        if (this.orientation === 0 /* Orientation.VERTICAL */ ) {
            const verticalProvider = this.layoutProvider;
            this.el.style.left = verticalProvider.getVerticalSashLeft(this) - this.size / 2 + "px";
            if (verticalProvider.getVerticalSashTop) this.el.style.top = verticalProvider.getVerticalSashTop(this) + "px";
            if (verticalProvider.getVerticalSashHeight) this.el.style.height = verticalProvider.getVerticalSashHeight(this) + "px";
        } else {
            const horizontalProvider = this.layoutProvider;
            this.el.style.top = horizontalProvider.getHorizontalSashTop(this) - this.size / 2 + "px";
            if (horizontalProvider.getHorizontalSashLeft) this.el.style.left = horizontalProvider.getHorizontalSashLeft(this) + "px";
            if (horizontalProvider.getHorizontalSashWidth) this.el.style.width = horizontalProvider.getHorizontalSashWidth(this) + "px";
        }
    }
    getOrthogonalSash(e) {
        const target = e.initialTarget ?? e.target;
        if (!target || !(0, _domJs.isHTMLElement)(target)) return undefined;
        if (target.classList.contains("orthogonal-drag-handle")) return target.classList.contains("start") ? this.orthogonalStartSash : this.orthogonalEndSash;
        return undefined;
    }
    dispose() {
        super.dispose();
        this.el.remove();
    }
}

},{"../../dom.js":"bnqsM","../../event.js":"PHN3G","../../touch.js":"6iGQn","../../../common/async.js":"4GJc4","../../../common/decorators.js":"hZnBn","../../../common/event.js":"4Zi8b","../../../common/lifecycle.js":"9kg8d","../../../common/platform.js":"7maJO","./sash.css":"gdwaG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gdwaG":[function() {},{}],"292RN":[function() {},{}],"k8a3I":[function() {},{}],"2Z8Kh":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComposedTreeDelegate", ()=>ComposedTreeDelegate);
parcelHelpers.export(exports, "RenderIndentGuides", ()=>RenderIndentGuides);
parcelHelpers.export(exports, "TreeRenderer", ()=>TreeRenderer);
parcelHelpers.export(exports, "ModeToggle", ()=>ModeToggle);
parcelHelpers.export(exports, "FuzzyToggle", ()=>FuzzyToggle);
parcelHelpers.export(exports, "TreeFindMode", ()=>TreeFindMode);
parcelHelpers.export(exports, "TreeFindMatchType", ()=>TreeFindMatchType);
parcelHelpers.export(exports, "AbstractTree", ()=>AbstractTree);
var _domJs = require("../../dom.js");
var _eventJs = require("../../event.js");
var _keyboardEventJs = require("../../keyboardEvent.js");
var _actionbarJs = require("../actionbar/actionbar.js");
var _findInputJs = require("../findinput/findInput.js");
var _inputBoxJs = require("../inputbox/inputBox.js");
var _listViewJs = require("../list/listView.js");
var _listWidgetJs = require("../list/listWidget.js");
var _toggleJs = require("../toggle/toggle.js");
var _indexTreeModelJs = require("./indexTreeModel.js");
var _treeJs = require("./tree.js");
var _actionsJs = require("../../../common/actions.js");
var _arraysJs = require("../../../common/arrays.js");
var _asyncJs = require("../../../common/async.js");
var _codiconsJs = require("../../../common/codicons.js");
var _themablesJs = require("../../../common/themables.js");
var _mapJs = require("../../../common/map.js");
var _eventJs1 = require("../../../common/event.js");
var _filtersJs = require("../../../common/filters.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _numbersJs = require("../../../common/numbers.js");
var _typesJs = require("../../../common/types.js");
var _treeCss = require("./media/tree.css");
var _nlsJs = require("../../../../nls.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _observableJs = require("../../../common/observable.js");
var _ariaJs = require("../aria/aria.js");
class TreeElementsDragAndDropData extends (0, _listViewJs.ElementsDragAndDropData) {
    constructor(data){
        super(data.elements.map((node)=>node.element));
        this.data = data;
    }
}
function asTreeDragAndDropData(data) {
    if (data instanceof (0, _listViewJs.ElementsDragAndDropData)) return new TreeElementsDragAndDropData(data);
    return data;
}
class TreeNodeListDragAndDrop {
    constructor(modelProvider, dnd){
        this.modelProvider = modelProvider;
        this.dnd = dnd;
        this.autoExpandDisposable = (0, _lifecycleJs.Disposable).None;
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
    }
    getDragURI(node) {
        return this.dnd.getDragURI(node.element);
    }
    getDragLabel(nodes, originalEvent) {
        if (this.dnd.getDragLabel) return this.dnd.getDragLabel(nodes.map((node)=>node.element), originalEvent);
        return undefined;
    }
    onDragStart(data, originalEvent) {
        this.dnd.onDragStart?.(asTreeDragAndDropData(data), originalEvent);
    }
    onDragOver(data, targetNode, targetIndex, targetSector, originalEvent, raw = true) {
        const result = this.dnd.onDragOver(asTreeDragAndDropData(data), targetNode && targetNode.element, targetIndex, targetSector, originalEvent);
        const didChangeAutoExpandNode = this.autoExpandNode !== targetNode;
        if (didChangeAutoExpandNode) {
            this.autoExpandDisposable.dispose();
            this.autoExpandNode = targetNode;
        }
        if (typeof targetNode === "undefined") return result;
        if (didChangeAutoExpandNode && typeof result !== "boolean" && result.autoExpand) this.autoExpandDisposable = (0, _asyncJs.disposableTimeout)(()=>{
            const model = this.modelProvider();
            const ref = model.getNodeLocation(targetNode);
            if (model.isCollapsed(ref)) model.setCollapsed(ref, false);
            this.autoExpandNode = undefined;
        }, 500, this.disposables);
        if (typeof result === "boolean" || !result.accept || typeof result.bubble === "undefined" || result.feedback) {
            if (!raw) {
                const accept = typeof result === "boolean" ? result : result.accept;
                const effect = typeof result === "boolean" ? undefined : result.effect;
                return {
                    accept,
                    effect,
                    feedback: [
                        targetIndex
                    ]
                };
            }
            return result;
        }
        if (result.bubble === 1 /* TreeDragOverBubble.Up */ ) {
            const model = this.modelProvider();
            const ref = model.getNodeLocation(targetNode);
            const parentRef = model.getParentNodeLocation(ref);
            const parentNode = model.getNode(parentRef);
            const parentIndex = parentRef && model.getListIndex(parentRef);
            return this.onDragOver(data, parentNode, parentIndex, targetSector, originalEvent, false);
        }
        const model = this.modelProvider();
        const ref = model.getNodeLocation(targetNode);
        const start = model.getListIndex(ref);
        const length = model.getListRenderCount(ref);
        return {
            ...result,
            feedback: (0, _arraysJs.range)(start, start + length)
        };
    }
    drop(data, targetNode, targetIndex, targetSector, originalEvent) {
        this.autoExpandDisposable.dispose();
        this.autoExpandNode = undefined;
        this.dnd.drop(asTreeDragAndDropData(data), targetNode && targetNode.element, targetIndex, targetSector, originalEvent);
    }
    onDragEnd(originalEvent) {
        this.dnd.onDragEnd?.(originalEvent);
    }
    dispose() {
        this.disposables.dispose();
        this.dnd.dispose();
    }
}
function asListOptions(modelProvider, options) {
    return options && {
        ...options,
        identityProvider: options.identityProvider && {
            getId (el) {
                return options.identityProvider.getId(el.element);
            }
        },
        dnd: options.dnd && new TreeNodeListDragAndDrop(modelProvider, options.dnd),
        multipleSelectionController: options.multipleSelectionController && {
            isSelectionSingleChangeEvent (e) {
                return options.multipleSelectionController.isSelectionSingleChangeEvent({
                    ...e,
                    element: e.element
                });
            },
            isSelectionRangeChangeEvent (e) {
                return options.multipleSelectionController.isSelectionRangeChangeEvent({
                    ...e,
                    element: e.element
                });
            }
        },
        accessibilityProvider: options.accessibilityProvider && {
            ...options.accessibilityProvider,
            getSetSize (node) {
                const model = modelProvider();
                const ref = model.getNodeLocation(node);
                const parentRef = model.getParentNodeLocation(ref);
                const parentNode = model.getNode(parentRef);
                return parentNode.visibleChildrenCount;
            },
            getPosInSet (node) {
                return node.visibleChildIndex + 1;
            },
            isChecked: options.accessibilityProvider && options.accessibilityProvider.isChecked ? (node)=>{
                return options.accessibilityProvider.isChecked(node.element);
            } : undefined,
            getRole: options.accessibilityProvider && options.accessibilityProvider.getRole ? (node)=>{
                return options.accessibilityProvider.getRole(node.element);
            } : ()=>"treeitem",
            getAriaLabel (e) {
                return options.accessibilityProvider.getAriaLabel(e.element);
            },
            getWidgetAriaLabel () {
                return options.accessibilityProvider.getWidgetAriaLabel();
            },
            getWidgetRole: options.accessibilityProvider && options.accessibilityProvider.getWidgetRole ? ()=>options.accessibilityProvider.getWidgetRole() : ()=>"tree",
            getAriaLevel: options.accessibilityProvider && options.accessibilityProvider.getAriaLevel ? (node)=>options.accessibilityProvider.getAriaLevel(node.element) : (node)=>{
                return node.depth;
            },
            getActiveDescendantId: options.accessibilityProvider.getActiveDescendantId && ((node)=>{
                return options.accessibilityProvider.getActiveDescendantId(node.element);
            })
        },
        keyboardNavigationLabelProvider: options.keyboardNavigationLabelProvider && {
            ...options.keyboardNavigationLabelProvider,
            getKeyboardNavigationLabel (node) {
                return options.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(node.element);
            }
        }
    };
}
class ComposedTreeDelegate {
    constructor(delegate){
        this.delegate = delegate;
    }
    getHeight(element) {
        return this.delegate.getHeight(element.element);
    }
    getTemplateId(element) {
        return this.delegate.getTemplateId(element.element);
    }
    hasDynamicHeight(element) {
        return !!this.delegate.hasDynamicHeight && this.delegate.hasDynamicHeight(element.element);
    }
    setDynamicHeight(element, height) {
        this.delegate.setDynamicHeight?.(element.element, height);
    }
}
var RenderIndentGuides;
(function(RenderIndentGuides) {
    RenderIndentGuides["None"] = "none";
    RenderIndentGuides["OnHover"] = "onHover";
    RenderIndentGuides["Always"] = "always";
})(RenderIndentGuides || (RenderIndentGuides = {}));
class EventCollection {
    get elements() {
        return this._elements;
    }
    constructor(onDidChange, _elements = []){
        this._elements = _elements;
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this.onDidChange = (0, _eventJs1.Event).forEach(onDidChange, (elements)=>this._elements = elements, this.disposables);
    }
    dispose() {
        this.disposables.dispose();
    }
}
class TreeRenderer {
    static{
        this.DefaultIndent = 8;
    }
    constructor(renderer, modelProvider, onDidChangeCollapseState, activeNodes, renderedIndentGuides, options = {}){
        this.renderer = renderer;
        this.modelProvider = modelProvider;
        this.activeNodes = activeNodes;
        this.renderedIndentGuides = renderedIndentGuides;
        this.renderedElements = new Map();
        this.renderedNodes = new Map();
        this.indent = TreeRenderer.DefaultIndent;
        this.hideTwistiesOfChildlessElements = false;
        this.shouldRenderIndentGuides = false;
        this.activeIndentNodes = new Set();
        this.indentGuidesDisposable = (0, _lifecycleJs.Disposable).None;
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this.templateId = renderer.templateId;
        this.updateOptions(options);
        (0, _eventJs1.Event).map(onDidChangeCollapseState, (e)=>e.node)(this.onDidChangeNodeTwistieState, this, this.disposables);
        renderer.onDidChangeTwistieState?.(this.onDidChangeTwistieState, this, this.disposables);
    }
    updateOptions(options = {}) {
        if (typeof options.indent !== "undefined") {
            const indent = (0, _numbersJs.clamp)(options.indent, 0, 40);
            if (indent !== this.indent) {
                this.indent = indent;
                for (const [node, templateData] of this.renderedNodes)this.renderTreeElement(node, templateData);
            }
        }
        if (typeof options.renderIndentGuides !== "undefined") {
            const shouldRenderIndentGuides = options.renderIndentGuides !== RenderIndentGuides.None;
            if (shouldRenderIndentGuides !== this.shouldRenderIndentGuides) {
                this.shouldRenderIndentGuides = shouldRenderIndentGuides;
                for (const [node, templateData] of this.renderedNodes)this._renderIndentGuides(node, templateData);
                this.indentGuidesDisposable.dispose();
                if (shouldRenderIndentGuides) {
                    const disposables = new (0, _lifecycleJs.DisposableStore)();
                    this.activeNodes.onDidChange(this._onDidChangeActiveNodes, this, disposables);
                    this.indentGuidesDisposable = disposables;
                    this._onDidChangeActiveNodes(this.activeNodes.elements);
                }
            }
        }
        if (typeof options.hideTwistiesOfChildlessElements !== "undefined") this.hideTwistiesOfChildlessElements = options.hideTwistiesOfChildlessElements;
    }
    renderTemplate(container) {
        const el = (0, _domJs.append)(container, (0, _domJs.$)(".monaco-tl-row"));
        const indent = (0, _domJs.append)(el, (0, _domJs.$)(".monaco-tl-indent"));
        const twistie = (0, _domJs.append)(el, (0, _domJs.$)(".monaco-tl-twistie"));
        const contents = (0, _domJs.append)(el, (0, _domJs.$)(".monaco-tl-contents"));
        const templateData = this.renderer.renderTemplate(contents);
        return {
            container,
            indent,
            twistie,
            indentGuidesDisposable: (0, _lifecycleJs.Disposable).None,
            templateData
        };
    }
    renderElement(node, index, templateData, height) {
        this.renderedNodes.set(node, templateData);
        this.renderedElements.set(node.element, node);
        this.renderTreeElement(node, templateData);
        this.renderer.renderElement(node, index, templateData.templateData, height);
    }
    disposeElement(node, index, templateData, height) {
        templateData.indentGuidesDisposable.dispose();
        this.renderer.disposeElement?.(node, index, templateData.templateData, height);
        if (typeof height === "number") {
            this.renderedNodes.delete(node);
            this.renderedElements.delete(node.element);
        }
    }
    disposeTemplate(templateData) {
        this.renderer.disposeTemplate(templateData.templateData);
    }
    onDidChangeTwistieState(element) {
        const node = this.renderedElements.get(element);
        if (!node) return;
        this.onDidChangeNodeTwistieState(node);
    }
    onDidChangeNodeTwistieState(node) {
        const templateData = this.renderedNodes.get(node);
        if (!templateData) return;
        this._onDidChangeActiveNodes(this.activeNodes.elements);
        this.renderTreeElement(node, templateData);
    }
    renderTreeElement(node, templateData) {
        const indent = TreeRenderer.DefaultIndent + (node.depth - 1) * this.indent;
        templateData.twistie.style.paddingLeft = `${indent}px`;
        templateData.indent.style.width = `${indent + this.indent - 16}px`;
        if (node.collapsible) templateData.container.setAttribute("aria-expanded", String(!node.collapsed));
        else templateData.container.removeAttribute("aria-expanded");
        templateData.twistie.classList.remove(...(0, _themablesJs.ThemeIcon).asClassNameArray((0, _codiconsJs.Codicon).treeItemExpanded));
        let twistieRendered = false;
        if (this.renderer.renderTwistie) twistieRendered = this.renderer.renderTwistie(node.element, templateData.twistie);
        if (node.collapsible && (!this.hideTwistiesOfChildlessElements || node.visibleChildrenCount > 0)) {
            if (!twistieRendered) templateData.twistie.classList.add(...(0, _themablesJs.ThemeIcon).asClassNameArray((0, _codiconsJs.Codicon).treeItemExpanded));
            templateData.twistie.classList.add("collapsible");
            templateData.twistie.classList.toggle("collapsed", node.collapsed);
        } else templateData.twistie.classList.remove("collapsible", "collapsed");
        this._renderIndentGuides(node, templateData);
    }
    _renderIndentGuides(node, templateData) {
        (0, _domJs.clearNode)(templateData.indent);
        templateData.indentGuidesDisposable.dispose();
        if (!this.shouldRenderIndentGuides) return;
        const disposableStore = new (0, _lifecycleJs.DisposableStore)();
        const model = this.modelProvider();
        while(true){
            const ref = model.getNodeLocation(node);
            const parentRef = model.getParentNodeLocation(ref);
            if (!parentRef) break;
            const parent = model.getNode(parentRef);
            const guide = (0, _domJs.$)(".indent-guide", {
                style: `width: ${this.indent}px`
            });
            if (this.activeIndentNodes.has(parent)) guide.classList.add("active");
            if (templateData.indent.childElementCount === 0) templateData.indent.appendChild(guide);
            else templateData.indent.insertBefore(guide, templateData.indent.firstElementChild);
            this.renderedIndentGuides.add(parent, guide);
            disposableStore.add((0, _lifecycleJs.toDisposable)(()=>this.renderedIndentGuides.delete(parent, guide)));
            node = parent;
        }
        templateData.indentGuidesDisposable = disposableStore;
    }
    _onDidChangeActiveNodes(nodes) {
        if (!this.shouldRenderIndentGuides) return;
        const set = new Set();
        const model = this.modelProvider();
        nodes.forEach((node)=>{
            const ref = model.getNodeLocation(node);
            try {
                const parentRef = model.getParentNodeLocation(ref);
                if (node.collapsible && node.children.length > 0 && !node.collapsed) set.add(node);
                else if (parentRef) set.add(model.getNode(parentRef));
            } catch  {
            // noop
            }
        });
        this.activeIndentNodes.forEach((node)=>{
            if (!set.has(node)) this.renderedIndentGuides.forEach(node, (line)=>line.classList.remove("active"));
        });
        set.forEach((node)=>{
            if (!this.activeIndentNodes.has(node)) this.renderedIndentGuides.forEach(node, (line)=>line.classList.add("active"));
        });
        this.activeIndentNodes = set;
    }
    dispose() {
        this.renderedNodes.clear();
        this.renderedElements.clear();
        this.indentGuidesDisposable.dispose();
        (0, _lifecycleJs.dispose)(this.disposables);
    }
}
class FindFilter {
    get totalCount() {
        return this._totalCount;
    }
    get matchCount() {
        return this._matchCount;
    }
    constructor(tree, keyboardNavigationLabelProvider, _filter){
        this.tree = tree;
        this.keyboardNavigationLabelProvider = keyboardNavigationLabelProvider;
        this._filter = _filter;
        this._totalCount = 0;
        this._matchCount = 0;
        this._pattern = "";
        this._lowercasePattern = "";
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        tree.onWillRefilter(this.reset, this, this.disposables);
    }
    filter(element, parentVisibility) {
        let visibility = 1 /* TreeVisibility.Visible */ ;
        if (this._filter) {
            const result = this._filter.filter(element, parentVisibility);
            if (typeof result === "boolean") visibility = result ? 1 /* TreeVisibility.Visible */  : 0 /* TreeVisibility.Hidden */ ;
            else if ((0, _indexTreeModelJs.isFilterResult)(result)) visibility = (0, _indexTreeModelJs.getVisibleState)(result.visibility);
            else visibility = result;
            if (visibility === 0 /* TreeVisibility.Hidden */ ) return false;
        }
        this._totalCount++;
        if (!this._pattern) {
            this._matchCount++;
            return {
                data: (0, _filtersJs.FuzzyScore).Default,
                visibility
            };
        }
        const label = this.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(element);
        const labels = Array.isArray(label) ? label : [
            label
        ];
        for (const l of labels){
            const labelStr = l && l.toString();
            if (typeof labelStr === "undefined") return {
                data: (0, _filtersJs.FuzzyScore).Default,
                visibility
            };
            let score;
            if (this.tree.findMatchType === TreeFindMatchType.Contiguous) {
                const index = labelStr.toLowerCase().indexOf(this._lowercasePattern);
                if (index > -1) {
                    score = [
                        Number.MAX_SAFE_INTEGER,
                        0
                    ];
                    for(let i = this._lowercasePattern.length; i > 0; i--)score.push(index + i - 1);
                }
            } else score = (0, _filtersJs.fuzzyScore)(this._pattern, this._lowercasePattern, 0, labelStr, labelStr.toLowerCase(), 0, {
                firstMatchCanBeWeak: true,
                boostFullMatch: true
            });
            if (score) {
                this._matchCount++;
                return labels.length === 1 ? {
                    data: score,
                    visibility
                } : {
                    data: {
                        label: labelStr,
                        score: score
                    },
                    visibility
                };
            }
        }
        if (this.tree.findMode === TreeFindMode.Filter) {
            if (typeof this.tree.options.defaultFindVisibility === "number") return this.tree.options.defaultFindVisibility;
            else if (this.tree.options.defaultFindVisibility) return this.tree.options.defaultFindVisibility(element);
            else return 2 /* TreeVisibility.Recurse */ ;
        } else return {
            data: (0, _filtersJs.FuzzyScore).Default,
            visibility
        };
    }
    reset() {
        this._totalCount = 0;
        this._matchCount = 0;
    }
    dispose() {
        (0, _lifecycleJs.dispose)(this.disposables);
    }
}
class ModeToggle extends (0, _toggleJs.Toggle) {
    constructor(opts){
        super({
            icon: (0, _codiconsJs.Codicon).listFilter,
            title: (0, _nlsJs.localize)("filter", "Filter"),
            isChecked: opts.isChecked ?? false,
            hoverDelegate: opts.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("element"),
            inputActiveOptionBorder: opts.inputActiveOptionBorder,
            inputActiveOptionForeground: opts.inputActiveOptionForeground,
            inputActiveOptionBackground: opts.inputActiveOptionBackground
        });
    }
}
class FuzzyToggle extends (0, _toggleJs.Toggle) {
    constructor(opts){
        super({
            icon: (0, _codiconsJs.Codicon).searchFuzzy,
            title: (0, _nlsJs.localize)("fuzzySearch", "Fuzzy Match"),
            isChecked: opts.isChecked ?? false,
            hoverDelegate: opts.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("element"),
            inputActiveOptionBorder: opts.inputActiveOptionBorder,
            inputActiveOptionForeground: opts.inputActiveOptionForeground,
            inputActiveOptionBackground: opts.inputActiveOptionBackground
        });
    }
}
const unthemedFindWidgetStyles = {
    inputBoxStyles: (0, _inputBoxJs.unthemedInboxStyles),
    toggleStyles: (0, _toggleJs.unthemedToggleStyles),
    listFilterWidgetBackground: undefined,
    listFilterWidgetNoMatchesOutline: undefined,
    listFilterWidgetOutline: undefined,
    listFilterWidgetShadow: undefined
};
var TreeFindMode;
(function(TreeFindMode) {
    TreeFindMode[TreeFindMode["Highlight"] = 0] = "Highlight";
    TreeFindMode[TreeFindMode["Filter"] = 1] = "Filter";
})(TreeFindMode || (TreeFindMode = {}));
var TreeFindMatchType;
(function(TreeFindMatchType) {
    TreeFindMatchType[TreeFindMatchType["Fuzzy"] = 0] = "Fuzzy";
    TreeFindMatchType[TreeFindMatchType["Contiguous"] = 1] = "Contiguous";
})(TreeFindMatchType || (TreeFindMatchType = {}));
class FindWidget extends (0, _lifecycleJs.Disposable) {
    set mode(mode) {
        this.modeToggle.checked = mode === TreeFindMode.Filter;
        this.findInput.inputBox.setPlaceHolder(mode === TreeFindMode.Filter ? (0, _nlsJs.localize)("type to filter", "Type to filter") : (0, _nlsJs.localize)("type to search", "Type to search"));
    }
    set matchType(matchType) {
        this.matchTypeToggle.checked = matchType === TreeFindMatchType.Fuzzy;
    }
    constructor(container, tree, contextViewProvider, mode, matchType, options){
        super();
        this.tree = tree;
        this.elements = (0, _domJs.h)(".monaco-tree-type-filter", [
            (0, _domJs.h)(".monaco-tree-type-filter-grab.codicon.codicon-debug-gripper@grab", {
                tabIndex: 0
            }),
            (0, _domJs.h)(".monaco-tree-type-filter-input@findInput"),
            (0, _domJs.h)(".monaco-tree-type-filter-actionbar@actionbar")
        ]);
        this.width = 0;
        this.right = 0;
        this.top = 0;
        this._onDidDisable = new (0, _eventJs1.Emitter)();
        container.appendChild(this.elements.root);
        this._register((0, _lifecycleJs.toDisposable)(()=>this.elements.root.remove()));
        const styles = options?.styles ?? unthemedFindWidgetStyles;
        if (styles.listFilterWidgetBackground) this.elements.root.style.backgroundColor = styles.listFilterWidgetBackground;
        if (styles.listFilterWidgetShadow) this.elements.root.style.boxShadow = `0 0 8px 2px ${styles.listFilterWidgetShadow}`;
        const toggleHoverDelegate = this._register((0, _hoverDelegateFactoryJs.createInstantHoverDelegate)());
        this.modeToggle = this._register(new ModeToggle({
            ...styles.toggleStyles,
            isChecked: mode === TreeFindMode.Filter,
            hoverDelegate: toggleHoverDelegate
        }));
        this.matchTypeToggle = this._register(new FuzzyToggle({
            ...styles.toggleStyles,
            isChecked: matchType === TreeFindMatchType.Fuzzy,
            hoverDelegate: toggleHoverDelegate
        }));
        this.onDidChangeMode = (0, _eventJs1.Event).map(this.modeToggle.onChange, ()=>this.modeToggle.checked ? TreeFindMode.Filter : TreeFindMode.Highlight, this._store);
        this.onDidChangeMatchType = (0, _eventJs1.Event).map(this.matchTypeToggle.onChange, ()=>this.matchTypeToggle.checked ? TreeFindMatchType.Fuzzy : TreeFindMatchType.Contiguous, this._store);
        this.findInput = this._register(new (0, _findInputJs.FindInput)(this.elements.findInput, contextViewProvider, {
            label: (0, _nlsJs.localize)("type to search", "Type to search"),
            additionalToggles: [
                this.modeToggle,
                this.matchTypeToggle
            ],
            showCommonFindToggles: false,
            inputBoxStyles: styles.inputBoxStyles,
            toggleStyles: styles.toggleStyles,
            history: options?.history
        }));
        this.actionbar = this._register(new (0, _actionbarJs.ActionBar)(this.elements.actionbar));
        this.mode = mode;
        const emitter = this._register(new (0, _eventJs.DomEmitter)(this.findInput.inputBox.inputElement, "keydown"));
        const onKeyDown = (0, _eventJs1.Event).chain(emitter.event, ($)=>$.map((e)=>new (0, _keyboardEventJs.StandardKeyboardEvent)(e)));
        this._register(onKeyDown((e)=>{
            // Using equals() so we reserve modified keys for future use
            if (e.equals(3 /* KeyCode.Enter */ )) {
                // This is the only keyboard way to return to the tree from a history item that isn't the last one
                e.preventDefault();
                e.stopPropagation();
                this.findInput.inputBox.addToHistory();
                this.tree.domFocus();
                return;
            }
            if (e.equals(18 /* KeyCode.DownArrow */ )) {
                e.preventDefault();
                e.stopPropagation();
                if (this.findInput.inputBox.isAtLastInHistory() || this.findInput.inputBox.isNowhereInHistory()) {
                    // Retain original pre-history DownArrow behavior
                    this.findInput.inputBox.addToHistory();
                    this.tree.domFocus();
                } else // Downward through history
                this.findInput.inputBox.showNextValue();
                return;
            }
            if (e.equals(16 /* KeyCode.UpArrow */ )) {
                e.preventDefault();
                e.stopPropagation();
                // Upward through history
                this.findInput.inputBox.showPreviousValue();
                return;
            }
        }));
        const closeAction = this._register(new (0, _actionsJs.Action)("close", (0, _nlsJs.localize)("close", "Close"), "codicon codicon-close", true, ()=>this.dispose()));
        this.actionbar.push(closeAction, {
            icon: true,
            label: false
        });
        const onGrabMouseDown = this._register(new (0, _eventJs.DomEmitter)(this.elements.grab, "mousedown"));
        this._register(onGrabMouseDown.event((e)=>{
            const disposables = new (0, _lifecycleJs.DisposableStore)();
            const onWindowMouseMove = disposables.add(new (0, _eventJs.DomEmitter)((0, _domJs.getWindow)(e), "mousemove"));
            const onWindowMouseUp = disposables.add(new (0, _eventJs.DomEmitter)((0, _domJs.getWindow)(e), "mouseup"));
            const startRight = this.right;
            const startX = e.pageX;
            const startTop = this.top;
            const startY = e.pageY;
            this.elements.grab.classList.add("grabbing");
            const transition = this.elements.root.style.transition;
            this.elements.root.style.transition = "unset";
            const update = (e)=>{
                const deltaX = e.pageX - startX;
                this.right = startRight - deltaX;
                const deltaY = e.pageY - startY;
                this.top = startTop + deltaY;
                this.layout();
            };
            disposables.add(onWindowMouseMove.event(update));
            disposables.add(onWindowMouseUp.event((e)=>{
                update(e);
                this.elements.grab.classList.remove("grabbing");
                this.elements.root.style.transition = transition;
                disposables.dispose();
            }));
        }));
        const onGrabKeyDown = (0, _eventJs1.Event).chain(this._register(new (0, _eventJs.DomEmitter)(this.elements.grab, "keydown")).event, ($)=>$.map((e)=>new (0, _keyboardEventJs.StandardKeyboardEvent)(e)));
        this._register(onGrabKeyDown((e)=>{
            let right;
            let top;
            if (e.keyCode === 15 /* KeyCode.LeftArrow */ ) right = Number.POSITIVE_INFINITY;
            else if (e.keyCode === 17 /* KeyCode.RightArrow */ ) right = 0;
            else if (e.keyCode === 10 /* KeyCode.Space */ ) right = this.right === 0 ? Number.POSITIVE_INFINITY : 0;
            if (e.keyCode === 16 /* KeyCode.UpArrow */ ) top = 0;
            else if (e.keyCode === 18 /* KeyCode.DownArrow */ ) top = Number.POSITIVE_INFINITY;
            if (right !== undefined) {
                e.preventDefault();
                e.stopPropagation();
                this.right = right;
                this.layout();
            }
            if (top !== undefined) {
                e.preventDefault();
                e.stopPropagation();
                this.top = top;
                const transition = this.elements.root.style.transition;
                this.elements.root.style.transition = "unset";
                this.layout();
                setTimeout(()=>{
                    this.elements.root.style.transition = transition;
                }, 0);
            }
        }));
        this.onDidChangeValue = this.findInput.onDidChange;
    }
    layout(width = this.width) {
        this.width = width;
        this.right = (0, _numbersJs.clamp)(this.right, 0, Math.max(0, width - 212));
        this.elements.root.style.right = `${this.right}px`;
        this.top = (0, _numbersJs.clamp)(this.top, 0, 24);
        this.elements.root.style.top = `${this.top}px`;
    }
    showMessage(message) {
        this.findInput.showMessage(message);
    }
    clearMessage() {
        this.findInput.clearMessage();
    }
    async dispose() {
        this._onDidDisable.fire();
        this.elements.root.classList.add("disabled");
        await (0, _asyncJs.timeout)(300);
        super.dispose();
    }
}
class FindController {
    get pattern() {
        return this._pattern;
    }
    get mode() {
        return this._mode;
    }
    set mode(mode) {
        if (mode === this._mode) return;
        this._mode = mode;
        if (this.widget) this.widget.mode = this._mode;
        this.tree.refilter();
        this.render();
        this._onDidChangeMode.fire(mode);
    }
    get matchType() {
        return this._matchType;
    }
    set matchType(matchType) {
        if (matchType === this._matchType) return;
        this._matchType = matchType;
        if (this.widget) this.widget.matchType = this._matchType;
        this.tree.refilter();
        this.render();
        this._onDidChangeMatchType.fire(matchType);
    }
    constructor(tree, model, view, filter, contextViewProvider, options = {}){
        this.tree = tree;
        this.view = view;
        this.filter = filter;
        this.contextViewProvider = contextViewProvider;
        this.options = options;
        this._pattern = "";
        this.width = 0;
        this._onDidChangeMode = new (0, _eventJs1.Emitter)();
        this.onDidChangeMode = this._onDidChangeMode.event;
        this._onDidChangeMatchType = new (0, _eventJs1.Emitter)();
        this.onDidChangeMatchType = this._onDidChangeMatchType.event;
        this._onDidChangePattern = new (0, _eventJs1.Emitter)();
        this._onDidChangeOpenState = new (0, _eventJs1.Emitter)();
        this.onDidChangeOpenState = this._onDidChangeOpenState.event;
        this.enabledDisposables = new (0, _lifecycleJs.DisposableStore)();
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this._mode = tree.options.defaultFindMode ?? TreeFindMode.Highlight;
        this._matchType = tree.options.defaultFindMatchType ?? TreeFindMatchType.Fuzzy;
        model.onDidSplice(this.onDidSpliceModel, this, this.disposables);
    }
    updateOptions(optionsUpdate = {}) {
        if (optionsUpdate.defaultFindMode !== undefined) this.mode = optionsUpdate.defaultFindMode;
        if (optionsUpdate.defaultFindMatchType !== undefined) this.matchType = optionsUpdate.defaultFindMatchType;
    }
    onDidSpliceModel() {
        if (!this.widget || this.pattern.length === 0) return;
        this.tree.refilter();
        this.render();
    }
    render() {
        const noMatches = this.filter.totalCount > 0 && this.filter.matchCount === 0;
        if (this.pattern && noMatches) {
            (0, _ariaJs.alert)((0, _nlsJs.localize)("replFindNoResults", "No results"));
            if (this.tree.options.showNotFoundMessage ?? true) this.widget?.showMessage({
                type: 2 /* MessageType.WARNING */ ,
                content: (0, _nlsJs.localize)("not found", "No elements found.")
            });
            else this.widget?.showMessage({
                type: 2 /* MessageType.WARNING */ 
            });
        } else {
            this.widget?.clearMessage();
            if (this.pattern) (0, _ariaJs.alert)((0, _nlsJs.localize)("replFindResults", "{0} results", this.filter.matchCount));
        }
    }
    shouldAllowFocus(node) {
        if (!this.widget || !this.pattern) return true;
        if (this.filter.totalCount > 0 && this.filter.matchCount <= 1) return true;
        return !(0, _filtersJs.FuzzyScore).isDefault(node.filterData);
    }
    layout(width) {
        this.width = width;
        this.widget?.layout(width);
    }
    dispose() {
        this._history = undefined;
        this._onDidChangePattern.dispose();
        this.enabledDisposables.dispose();
        this.disposables.dispose();
    }
}
function stickyScrollNodeStateEquals(node1, node2) {
    return node1.position === node2.position && stickyScrollNodeEquals(node1, node2);
}
function stickyScrollNodeEquals(node1, node2) {
    return node1.node.element === node2.node.element && node1.startIndex === node2.startIndex && node1.height === node2.height && node1.endIndex === node2.endIndex;
}
class StickyScrollState {
    constructor(stickyNodes = []){
        this.stickyNodes = stickyNodes;
    }
    get count() {
        return this.stickyNodes.length;
    }
    equal(state) {
        return (0, _arraysJs.equals)(this.stickyNodes, state.stickyNodes, stickyScrollNodeStateEquals);
    }
    lastNodePartiallyVisible() {
        if (this.count === 0) return false;
        const lastStickyNode = this.stickyNodes[this.count - 1];
        if (this.count === 1) return lastStickyNode.position !== 0;
        const secondLastStickyNode = this.stickyNodes[this.count - 2];
        return secondLastStickyNode.position + secondLastStickyNode.height !== lastStickyNode.position;
    }
    animationStateChanged(previousState) {
        if (!(0, _arraysJs.equals)(this.stickyNodes, previousState.stickyNodes, stickyScrollNodeEquals)) return false;
        if (this.count === 0) return false;
        const lastStickyNode = this.stickyNodes[this.count - 1];
        const previousLastStickyNode = previousState.stickyNodes[previousState.count - 1];
        return lastStickyNode.position !== previousLastStickyNode.position;
    }
}
class DefaultStickyScrollDelegate {
    constrainStickyScrollNodes(stickyNodes, stickyScrollMaxItemCount, maxWidgetHeight) {
        for(let i = 0; i < stickyNodes.length; i++){
            const stickyNode = stickyNodes[i];
            const stickyNodeBottom = stickyNode.position + stickyNode.height;
            if (stickyNodeBottom > maxWidgetHeight || i >= stickyScrollMaxItemCount) return stickyNodes.slice(0, i);
        }
        return stickyNodes;
    }
}
class StickyScrollController extends (0, _lifecycleJs.Disposable) {
    constructor(tree, model, view, renderers, treeDelegate, options = {}){
        super();
        this.tree = tree;
        this.model = model;
        this.view = view;
        this.treeDelegate = treeDelegate;
        this.maxWidgetViewRatio = 0.4;
        const stickyScrollOptions = this.validateStickySettings(options);
        this.stickyScrollMaxItemCount = stickyScrollOptions.stickyScrollMaxItemCount;
        this.stickyScrollDelegate = options.stickyScrollDelegate ?? new DefaultStickyScrollDelegate();
        this._widget = this._register(new StickyScrollWidget(view.getScrollableElement(), view, tree, renderers, treeDelegate, options.accessibilityProvider));
        this.onDidChangeHasFocus = this._widget.onDidChangeHasFocus;
        this.onContextMenu = this._widget.onContextMenu;
        this._register(view.onDidScroll(()=>this.update()));
        this._register(view.onDidChangeContentHeight(()=>this.update()));
        this._register(tree.onDidChangeCollapseState(()=>this.update()));
        this.update();
    }
    get height() {
        return this._widget.height;
    }
    getNodeAtHeight(height) {
        let index;
        if (height === 0) index = this.view.firstVisibleIndex;
        else index = this.view.indexAt(height + this.view.scrollTop);
        if (index < 0 || index >= this.view.length) return undefined;
        return this.view.element(index);
    }
    update() {
        const firstVisibleNode = this.getNodeAtHeight(0);
        // Don't render anything if there are no elements
        if (!firstVisibleNode || this.tree.scrollTop === 0) {
            this._widget.setState(undefined);
            return;
        }
        const stickyState = this.findStickyState(firstVisibleNode);
        this._widget.setState(stickyState);
    }
    findStickyState(firstVisibleNode) {
        const stickyNodes = [];
        let firstVisibleNodeUnderWidget = firstVisibleNode;
        let stickyNodesHeight = 0;
        let nextStickyNode = this.getNextStickyNode(firstVisibleNodeUnderWidget, undefined, stickyNodesHeight);
        while(nextStickyNode){
            stickyNodes.push(nextStickyNode);
            stickyNodesHeight += nextStickyNode.height;
            if (stickyNodes.length <= this.stickyScrollMaxItemCount) {
                firstVisibleNodeUnderWidget = this.getNextVisibleNode(nextStickyNode);
                if (!firstVisibleNodeUnderWidget) break;
            }
            nextStickyNode = this.getNextStickyNode(firstVisibleNodeUnderWidget, nextStickyNode.node, stickyNodesHeight);
        }
        const contrainedStickyNodes = this.constrainStickyNodes(stickyNodes);
        return contrainedStickyNodes.length ? new StickyScrollState(contrainedStickyNodes) : undefined;
    }
    getNextVisibleNode(previousStickyNode) {
        return this.getNodeAtHeight(previousStickyNode.position + previousStickyNode.height);
    }
    getNextStickyNode(firstVisibleNodeUnderWidget, previousStickyNode, stickyNodesHeight) {
        const nextStickyNode = this.getAncestorUnderPrevious(firstVisibleNodeUnderWidget, previousStickyNode);
        if (!nextStickyNode) return undefined;
        if (nextStickyNode === firstVisibleNodeUnderWidget) {
            if (!this.nodeIsUncollapsedParent(firstVisibleNodeUnderWidget)) return undefined;
            if (this.nodeTopAlignsWithStickyNodesBottom(firstVisibleNodeUnderWidget, stickyNodesHeight)) return undefined;
        }
        return this.createStickyScrollNode(nextStickyNode, stickyNodesHeight);
    }
    nodeTopAlignsWithStickyNodesBottom(node, stickyNodesHeight) {
        const nodeIndex = this.getNodeIndex(node);
        const elementTop = this.view.getElementTop(nodeIndex);
        const stickyPosition = stickyNodesHeight;
        return this.view.scrollTop === elementTop - stickyPosition;
    }
    createStickyScrollNode(node, currentStickyNodesHeight) {
        const height = this.treeDelegate.getHeight(node);
        const { startIndex, endIndex } = this.getNodeRange(node);
        const position = this.calculateStickyNodePosition(endIndex, currentStickyNodesHeight, height);
        return {
            node,
            position,
            height,
            startIndex,
            endIndex
        };
    }
    getAncestorUnderPrevious(node, previousAncestor) {
        let currentAncestor = node;
        let parentOfcurrentAncestor = this.getParentNode(currentAncestor);
        while(parentOfcurrentAncestor){
            if (parentOfcurrentAncestor === previousAncestor) return currentAncestor;
            currentAncestor = parentOfcurrentAncestor;
            parentOfcurrentAncestor = this.getParentNode(currentAncestor);
        }
        if (previousAncestor === undefined) return currentAncestor;
        return undefined;
    }
    calculateStickyNodePosition(lastDescendantIndex, stickyRowPositionTop, stickyNodeHeight) {
        let lastChildRelativeTop = this.view.getRelativeTop(lastDescendantIndex);
        // If the last descendant is only partially visible at the top of the view, getRelativeTop() returns null
        // In that case, utilize the next node's relative top to calculate the sticky node's position
        if (lastChildRelativeTop === null && this.view.firstVisibleIndex === lastDescendantIndex && lastDescendantIndex + 1 < this.view.length) {
            const nodeHeight = this.treeDelegate.getHeight(this.view.element(lastDescendantIndex));
            const nextNodeRelativeTop = this.view.getRelativeTop(lastDescendantIndex + 1);
            lastChildRelativeTop = nextNodeRelativeTop ? nextNodeRelativeTop - nodeHeight / this.view.renderHeight : null;
        }
        if (lastChildRelativeTop === null) return stickyRowPositionTop;
        const lastChildNode = this.view.element(lastDescendantIndex);
        const lastChildHeight = this.treeDelegate.getHeight(lastChildNode);
        const topOfLastChild = lastChildRelativeTop * this.view.renderHeight;
        const bottomOfLastChild = topOfLastChild + lastChildHeight;
        if (stickyRowPositionTop + stickyNodeHeight > bottomOfLastChild && stickyRowPositionTop <= bottomOfLastChild) return bottomOfLastChild - stickyNodeHeight;
        return stickyRowPositionTop;
    }
    constrainStickyNodes(stickyNodes) {
        if (stickyNodes.length === 0) return [];
        // Check if sticky nodes need to be constrained
        const maximumStickyWidgetHeight = this.view.renderHeight * this.maxWidgetViewRatio;
        const lastStickyNode = stickyNodes[stickyNodes.length - 1];
        if (stickyNodes.length <= this.stickyScrollMaxItemCount && lastStickyNode.position + lastStickyNode.height <= maximumStickyWidgetHeight) return stickyNodes;
        // constrain sticky nodes
        const constrainedStickyNodes = this.stickyScrollDelegate.constrainStickyScrollNodes(stickyNodes, this.stickyScrollMaxItemCount, maximumStickyWidgetHeight);
        if (!constrainedStickyNodes.length) return [];
        // Validate constraints
        const lastConstrainedStickyNode = constrainedStickyNodes[constrainedStickyNodes.length - 1];
        if (constrainedStickyNodes.length > this.stickyScrollMaxItemCount || lastConstrainedStickyNode.position + lastConstrainedStickyNode.height > maximumStickyWidgetHeight) throw new Error("stickyScrollDelegate violates constraints");
        return constrainedStickyNodes;
    }
    getParentNode(node) {
        const nodeLocation = this.model.getNodeLocation(node);
        const parentLocation = this.model.getParentNodeLocation(nodeLocation);
        return parentLocation ? this.model.getNode(parentLocation) : undefined;
    }
    nodeIsUncollapsedParent(node) {
        const nodeLocation = this.model.getNodeLocation(node);
        return this.model.getListRenderCount(nodeLocation) > 1;
    }
    getNodeIndex(node) {
        const nodeLocation = this.model.getNodeLocation(node);
        const nodeIndex = this.model.getListIndex(nodeLocation);
        return nodeIndex;
    }
    getNodeRange(node) {
        const nodeLocation = this.model.getNodeLocation(node);
        const startIndex = this.model.getListIndex(nodeLocation);
        if (startIndex < 0) throw new Error("Node not found in tree");
        const renderCount = this.model.getListRenderCount(nodeLocation);
        const endIndex = startIndex + renderCount - 1;
        return {
            startIndex,
            endIndex
        };
    }
    nodePositionTopBelowWidget(node) {
        const ancestors = [];
        let currentAncestor = this.getParentNode(node);
        while(currentAncestor){
            ancestors.push(currentAncestor);
            currentAncestor = this.getParentNode(currentAncestor);
        }
        let widgetHeight = 0;
        for(let i = 0; i < ancestors.length && i < this.stickyScrollMaxItemCount; i++)widgetHeight += this.treeDelegate.getHeight(ancestors[i]);
        return widgetHeight;
    }
    domFocus() {
        this._widget.domFocus();
    }
    // Whether sticky scroll was the last focused part in the tree or not
    focusedLast() {
        return this._widget.focusedLast();
    }
    updateOptions(optionsUpdate = {}) {
        if (!optionsUpdate.stickyScrollMaxItemCount) return;
        const validatedOptions = this.validateStickySettings(optionsUpdate);
        if (this.stickyScrollMaxItemCount !== validatedOptions.stickyScrollMaxItemCount) {
            this.stickyScrollMaxItemCount = validatedOptions.stickyScrollMaxItemCount;
            this.update();
        }
    }
    validateStickySettings(options) {
        let stickyScrollMaxItemCount = 7;
        if (typeof options.stickyScrollMaxItemCount === "number") stickyScrollMaxItemCount = Math.max(options.stickyScrollMaxItemCount, 1);
        return {
            stickyScrollMaxItemCount
        };
    }
}
class StickyScrollWidget {
    constructor(container, view, tree, treeRenderers, treeDelegate, accessibilityProvider){
        this.view = view;
        this.tree = tree;
        this.treeRenderers = treeRenderers;
        this.treeDelegate = treeDelegate;
        this.accessibilityProvider = accessibilityProvider;
        this._previousElements = [];
        this._previousStateDisposables = new (0, _lifecycleJs.DisposableStore)();
        this._rootDomNode = (0, _domJs.$)(".monaco-tree-sticky-container.empty");
        container.appendChild(this._rootDomNode);
        const shadow = (0, _domJs.$)(".monaco-tree-sticky-container-shadow");
        this._rootDomNode.appendChild(shadow);
        this.stickyScrollFocus = new StickyScrollFocus(this._rootDomNode, view);
        this.onDidChangeHasFocus = this.stickyScrollFocus.onDidChangeHasFocus;
        this.onContextMenu = this.stickyScrollFocus.onContextMenu;
    }
    get height() {
        if (!this._previousState) return 0;
        const lastElement = this._previousState.stickyNodes[this._previousState.count - 1];
        return lastElement.position + lastElement.height;
    }
    setState(state) {
        const wasVisible = !!this._previousState && this._previousState.count > 0;
        const isVisible = !!state && state.count > 0;
        // If state has not changed, do nothing
        if (!wasVisible && !isVisible || wasVisible && isVisible && this._previousState.equal(state)) return;
        // Update visibility of the widget if changed
        if (wasVisible !== isVisible) this.setVisible(isVisible);
        if (!isVisible) {
            this._previousState = undefined;
            this._previousElements = [];
            this._previousStateDisposables.clear();
            return;
        }
        const lastStickyNode = state.stickyNodes[state.count - 1];
        // If the new state is only a change in the last node's position, update the position of the last element
        if (this._previousState && state.animationStateChanged(this._previousState)) this._previousElements[this._previousState.count - 1].style.top = `${lastStickyNode.position}px`;
        else {
            this._previousStateDisposables.clear();
            const elements = Array(state.count);
            for(let stickyIndex = state.count - 1; stickyIndex >= 0; stickyIndex--){
                const stickyNode = state.stickyNodes[stickyIndex];
                const { element, disposable } = this.createElement(stickyNode, stickyIndex, state.count);
                elements[stickyIndex] = element;
                this._rootDomNode.appendChild(element);
                this._previousStateDisposables.add(disposable);
            }
            this.stickyScrollFocus.updateElements(elements, state);
            this._previousElements = elements;
        }
        this._previousState = state;
        // Set the height of the widget to the bottom of the last sticky node
        this._rootDomNode.style.height = `${lastStickyNode.position + lastStickyNode.height}px`;
    }
    createElement(stickyNode, stickyIndex, stickyNodesTotal) {
        const nodeIndex = stickyNode.startIndex;
        // Sticky element container
        const stickyElement = document.createElement("div");
        stickyElement.style.top = `${stickyNode.position}px`;
        if (this.tree.options.setRowHeight !== false) stickyElement.style.height = `${stickyNode.height}px`;
        if (this.tree.options.setRowLineHeight !== false) stickyElement.style.lineHeight = `${stickyNode.height}px`;
        stickyElement.classList.add("monaco-tree-sticky-row");
        stickyElement.classList.add("monaco-list-row");
        stickyElement.setAttribute("data-index", `${nodeIndex}`);
        stickyElement.setAttribute("data-parity", nodeIndex % 2 === 0 ? "even" : "odd");
        stickyElement.setAttribute("id", this.view.getElementID(nodeIndex));
        const accessibilityDisposable = this.setAccessibilityAttributes(stickyElement, stickyNode.node.element, stickyIndex, stickyNodesTotal);
        // Get the renderer for the node
        const nodeTemplateId = this.treeDelegate.getTemplateId(stickyNode.node);
        const renderer = this.treeRenderers.find((renderer)=>renderer.templateId === nodeTemplateId);
        if (!renderer) throw new Error(`No renderer found for template id ${nodeTemplateId}`);
        // To make sure we do not influence the original node, we create a copy of the node
        // We need to check if it is already a unique instance of the node by the delegate
        let nodeCopy = stickyNode.node;
        if (nodeCopy === this.tree.getNode(this.tree.getNodeLocation(stickyNode.node))) nodeCopy = new Proxy(stickyNode.node, {});
        // Render the element
        const templateData = renderer.renderTemplate(stickyElement);
        renderer.renderElement(nodeCopy, stickyNode.startIndex, templateData, stickyNode.height);
        // Remove the element from the DOM when state is disposed
        const disposable = (0, _lifecycleJs.toDisposable)(()=>{
            accessibilityDisposable.dispose();
            renderer.disposeElement(nodeCopy, stickyNode.startIndex, templateData, stickyNode.height);
            renderer.disposeTemplate(templateData);
            stickyElement.remove();
        });
        return {
            element: stickyElement,
            disposable
        };
    }
    setAccessibilityAttributes(container, element, stickyIndex, stickyNodesTotal) {
        if (!this.accessibilityProvider) return (0, _lifecycleJs.Disposable).None;
        if (this.accessibilityProvider.getSetSize) container.setAttribute("aria-setsize", String(this.accessibilityProvider.getSetSize(element, stickyIndex, stickyNodesTotal)));
        if (this.accessibilityProvider.getPosInSet) container.setAttribute("aria-posinset", String(this.accessibilityProvider.getPosInSet(element, stickyIndex)));
        if (this.accessibilityProvider.getRole) container.setAttribute("role", this.accessibilityProvider.getRole(element) ?? "treeitem");
        const ariaLabel = this.accessibilityProvider.getAriaLabel(element);
        const observable = ariaLabel && typeof ariaLabel !== "string" ? ariaLabel : (0, _observableJs.constObservable)(ariaLabel);
        const result = (0, _observableJs.autorun)((reader)=>{
            const value = reader.readObservable(observable);
            if (value) container.setAttribute("aria-label", value);
            else container.removeAttribute("aria-label");
        });
        if (typeof ariaLabel === "string") ;
        else if (ariaLabel) container.setAttribute("aria-label", ariaLabel.get());
        const ariaLevel = this.accessibilityProvider.getAriaLevel && this.accessibilityProvider.getAriaLevel(element);
        if (typeof ariaLevel === "number") container.setAttribute("aria-level", `${ariaLevel}`);
        // Sticky Scroll elements can not be selected
        container.setAttribute("aria-selected", String(false));
        return result;
    }
    setVisible(visible) {
        this._rootDomNode.classList.toggle("empty", !visible);
        if (!visible) this.stickyScrollFocus.updateElements([], undefined);
    }
    domFocus() {
        this.stickyScrollFocus.domFocus();
    }
    focusedLast() {
        return this.stickyScrollFocus.focusedLast();
    }
    dispose() {
        this.stickyScrollFocus.dispose();
        this._previousStateDisposables.dispose();
        this._rootDomNode.remove();
    }
}
class StickyScrollFocus extends (0, _lifecycleJs.Disposable) {
    get domHasFocus() {
        return this._domHasFocus;
    }
    set domHasFocus(hasFocus) {
        if (hasFocus !== this._domHasFocus) {
            this._onDidChangeHasFocus.fire(hasFocus);
            this._domHasFocus = hasFocus;
        }
    }
    constructor(container, view){
        super();
        this.container = container;
        this.view = view;
        this.focusedIndex = -1;
        this.elements = [];
        this._onDidChangeHasFocus = new (0, _eventJs1.Emitter)();
        this.onDidChangeHasFocus = this._onDidChangeHasFocus.event;
        this._onContextMenu = new (0, _eventJs1.Emitter)();
        this.onContextMenu = this._onContextMenu.event;
        this._domHasFocus = false;
        this._register((0, _domJs.addDisposableListener)(this.container, "focus", ()=>this.onFocus()));
        this._register((0, _domJs.addDisposableListener)(this.container, "blur", ()=>this.onBlur()));
        this._register(this.view.onDidFocus(()=>this.toggleStickyScrollFocused(false)));
        this._register(this.view.onKeyDown((e)=>this.onKeyDown(e)));
        this._register(this.view.onMouseDown((e)=>this.onMouseDown(e)));
        this._register(this.view.onContextMenu((e)=>this.handleContextMenu(e)));
    }
    handleContextMenu(e) {
        const target = e.browserEvent.target;
        if (!(0, _listWidgetJs.isStickyScrollContainer)(target) && !(0, _listWidgetJs.isStickyScrollElement)(target)) {
            if (this.focusedLast()) this.view.domFocus();
            return;
        }
        // The list handles the context menu triggered by a mouse event
        // In that case only set the focus of the element clicked and leave the rest to the list to handle
        if (!(0, _domJs.isKeyboardEvent)(e.browserEvent)) {
            if (!this.state) throw new Error("Context menu should not be triggered when state is undefined");
            const stickyIndex = this.state.stickyNodes.findIndex((stickyNode)=>stickyNode.node.element === e.element?.element);
            if (stickyIndex === -1) throw new Error("Context menu should not be triggered when element is not in sticky scroll widget");
            this.container.focus();
            this.setFocus(stickyIndex);
            return;
        }
        if (!this.state || this.focusedIndex < 0) throw new Error("Context menu key should not be triggered when focus is not in sticky scroll widget");
        const stickyNode = this.state.stickyNodes[this.focusedIndex];
        const element = stickyNode.node.element;
        const anchor = this.elements[this.focusedIndex];
        this._onContextMenu.fire({
            element,
            anchor,
            browserEvent: e.browserEvent,
            isStickyScroll: true
        });
    }
    onKeyDown(e) {
        // Sticky Scroll Navigation
        if (this.domHasFocus && this.state) {
            // Move up
            if (e.key === "ArrowUp") {
                this.setFocusedElement(Math.max(0, this.focusedIndex - 1));
                e.preventDefault();
                e.stopPropagation();
            } else if (e.key === "ArrowDown" || e.key === "ArrowRight") {
                if (this.focusedIndex >= this.state.count - 1) {
                    const nodeIndexToFocus = this.state.stickyNodes[this.state.count - 1].startIndex + 1;
                    this.view.domFocus();
                    this.view.setFocus([
                        nodeIndexToFocus
                    ]);
                    this.scrollNodeUnderWidget(nodeIndexToFocus, this.state);
                } else this.setFocusedElement(this.focusedIndex + 1);
                e.preventDefault();
                e.stopPropagation();
            }
        }
    }
    onMouseDown(e) {
        const target = e.browserEvent.target;
        if (!(0, _listWidgetJs.isStickyScrollContainer)(target) && !(0, _listWidgetJs.isStickyScrollElement)(target)) return;
        e.browserEvent.preventDefault();
        e.browserEvent.stopPropagation();
    }
    updateElements(elements, state) {
        if (state && state.count === 0) throw new Error("Sticky scroll state must be undefined when there are no sticky nodes");
        if (state && state.count !== elements.length) throw new Error("Sticky scroll focus received illigel state");
        const previousIndex = this.focusedIndex;
        this.removeFocus();
        this.elements = elements;
        this.state = state;
        if (state) {
            const newFocusedIndex = (0, _numbersJs.clamp)(previousIndex, 0, state.count - 1);
            this.setFocus(newFocusedIndex);
        } else if (this.domHasFocus) this.view.domFocus();
        // must come last as it calls blur()
        this.container.tabIndex = state ? 0 : -1;
    }
    setFocusedElement(stickyIndex) {
        // doesn't imply that the widget has (or will have) focus
        const state = this.state;
        if (!state) throw new Error("Cannot set focus when state is undefined");
        this.setFocus(stickyIndex);
        if (stickyIndex < state.count - 1) return;
        // If the last sticky node is not fully visible, scroll it into view
        if (state.lastNodePartiallyVisible()) {
            const lastStickyNode = state.stickyNodes[stickyIndex];
            this.scrollNodeUnderWidget(lastStickyNode.endIndex + 1, state);
        }
    }
    scrollNodeUnderWidget(nodeIndex, state) {
        const lastStickyNode = state.stickyNodes[state.count - 1];
        const secondLastStickyNode = state.count > 1 ? state.stickyNodes[state.count - 2] : undefined;
        const elementScrollTop = this.view.getElementTop(nodeIndex);
        const elementTargetViewTop = secondLastStickyNode ? secondLastStickyNode.position + secondLastStickyNode.height + lastStickyNode.height : lastStickyNode.height;
        this.view.scrollTop = elementScrollTop - elementTargetViewTop;
    }
    domFocus() {
        if (!this.state) throw new Error("Cannot focus when state is undefined");
        this.container.focus();
    }
    focusedLast() {
        if (!this.state) return false;
        return this.view.getHTMLElement().classList.contains("sticky-scroll-focused");
    }
    removeFocus() {
        if (this.focusedIndex === -1) return;
        this.toggleElementFocus(this.elements[this.focusedIndex], false);
        this.focusedIndex = -1;
    }
    setFocus(newFocusIndex) {
        if (0 > newFocusIndex) throw new Error("addFocus() can not remove focus");
        if (!this.state && newFocusIndex >= 0) throw new Error("Cannot set focus index when state is undefined");
        if (this.state && newFocusIndex >= this.state.count) throw new Error("Cannot set focus index to an index that does not exist");
        const oldIndex = this.focusedIndex;
        if (oldIndex >= 0) this.toggleElementFocus(this.elements[oldIndex], false);
        if (newFocusIndex >= 0) this.toggleElementFocus(this.elements[newFocusIndex], true);
        this.focusedIndex = newFocusIndex;
    }
    toggleElementFocus(element, focused) {
        this.toggleElementActiveFocus(element, focused && this.domHasFocus);
        this.toggleElementPassiveFocus(element, focused);
    }
    toggleCurrentElementActiveFocus(focused) {
        if (this.focusedIndex === -1) return;
        this.toggleElementActiveFocus(this.elements[this.focusedIndex], focused);
    }
    toggleElementActiveFocus(element, focused) {
        // active focus is set when sticky scroll has focus
        element.classList.toggle("focused", focused);
    }
    toggleElementPassiveFocus(element, focused) {
        // passive focus allows to show focus when sticky scroll does not have focus
        // for example when the context menu has focus
        element.classList.toggle("passive-focused", focused);
    }
    toggleStickyScrollFocused(focused) {
        // Weather the last focus in the view was sticky scroll and not the list
        // Is only removed when the focus is back in the tree an no longer in sticky scroll
        this.view.getHTMLElement().classList.toggle("sticky-scroll-focused", focused);
    }
    onFocus() {
        if (!this.state || this.elements.length === 0) throw new Error("Cannot focus when state is undefined or elements are empty");
        this.domHasFocus = true;
        this.toggleStickyScrollFocused(true);
        this.toggleCurrentElementActiveFocus(true);
        if (this.focusedIndex === -1) this.setFocus(0);
    }
    onBlur() {
        this.domHasFocus = false;
        this.toggleCurrentElementActiveFocus(false);
    }
    dispose() {
        this.toggleStickyScrollFocused(false);
        this._onDidChangeHasFocus.fire(false);
        super.dispose();
    }
}
function asTreeMouseEvent(event) {
    let target = (0, _treeJs.TreeMouseEventTarget).Unknown;
    if ((0, _domJs.hasParentWithClass)(event.browserEvent.target, "monaco-tl-twistie", "monaco-tl-row")) target = (0, _treeJs.TreeMouseEventTarget).Twistie;
    else if ((0, _domJs.hasParentWithClass)(event.browserEvent.target, "monaco-tl-contents", "monaco-tl-row")) target = (0, _treeJs.TreeMouseEventTarget).Element;
    else if ((0, _domJs.hasParentWithClass)(event.browserEvent.target, "monaco-tree-type-filter", "monaco-list")) target = (0, _treeJs.TreeMouseEventTarget).Filter;
    return {
        browserEvent: event.browserEvent,
        element: event.element ? event.element.element : null,
        target
    };
}
function asTreeContextMenuEvent(event) {
    const isStickyScroll = (0, _listWidgetJs.isStickyScrollContainer)(event.browserEvent.target);
    return {
        element: event.element ? event.element.element : null,
        browserEvent: event.browserEvent,
        anchor: event.anchor,
        isStickyScroll
    };
}
function dfs(node, fn) {
    fn(node);
    node.children.forEach((child)=>dfs(child, fn));
}
/**
 * The trait concept needs to exist at the tree level, because collapsed
 * tree nodes will not be known by the list.
 */ class Trait {
    get nodeSet() {
        if (!this._nodeSet) this._nodeSet = this.createNodeSet();
        return this._nodeSet;
    }
    constructor(getFirstViewElementWithTrait, identityProvider){
        this.getFirstViewElementWithTrait = getFirstViewElementWithTrait;
        this.identityProvider = identityProvider;
        this.nodes = [];
        this._onDidChange = new (0, _eventJs1.Emitter)();
        this.onDidChange = this._onDidChange.event;
    }
    set(nodes, browserEvent) {
        if (!browserEvent?.__forceEvent && (0, _arraysJs.equals)(this.nodes, nodes)) return;
        this._set(nodes, false, browserEvent);
    }
    _set(nodes, silent, browserEvent) {
        this.nodes = [
            ...nodes
        ];
        this.elements = undefined;
        this._nodeSet = undefined;
        if (!silent) {
            const that = this;
            this._onDidChange.fire({
                get elements () {
                    return that.get();
                },
                browserEvent
            });
        }
    }
    get() {
        if (!this.elements) this.elements = this.nodes.map((node)=>node.element);
        return [
            ...this.elements
        ];
    }
    getNodes() {
        return this.nodes;
    }
    has(node) {
        return this.nodeSet.has(node);
    }
    onDidModelSplice({ insertedNodes, deletedNodes }) {
        if (!this.identityProvider) {
            const set = this.createNodeSet();
            const visit = (node)=>set.delete(node);
            deletedNodes.forEach((node)=>dfs(node, visit));
            this.set([
                ...set.values()
            ]);
            return;
        }
        const deletedNodesIdSet = new Set();
        const deletedNodesVisitor = (node)=>deletedNodesIdSet.add(this.identityProvider.getId(node.element).toString());
        deletedNodes.forEach((node)=>dfs(node, deletedNodesVisitor));
        const insertedNodesMap = new Map();
        const insertedNodesVisitor = (node)=>insertedNodesMap.set(this.identityProvider.getId(node.element).toString(), node);
        insertedNodes.forEach((node)=>dfs(node, insertedNodesVisitor));
        const nodes = [];
        for (const node of this.nodes){
            const id = this.identityProvider.getId(node.element).toString();
            const wasDeleted = deletedNodesIdSet.has(id);
            if (!wasDeleted) nodes.push(node);
            else {
                const insertedNode = insertedNodesMap.get(id);
                if (insertedNode && insertedNode.visible) nodes.push(insertedNode);
            }
        }
        if (this.nodes.length > 0 && nodes.length === 0) {
            const node = this.getFirstViewElementWithTrait();
            if (node) nodes.push(node);
        }
        this._set(nodes, true);
    }
    createNodeSet() {
        const set = new Set();
        for (const node of this.nodes)set.add(node);
        return set;
    }
}
class TreeNodeListMouseController extends (0, _listWidgetJs.MouseController) {
    constructor(list, tree, stickyScrollProvider){
        super(list);
        this.tree = tree;
        this.stickyScrollProvider = stickyScrollProvider;
    }
    onViewPointer(e) {
        if ((0, _listWidgetJs.isButton)(e.browserEvent.target) || (0, _listWidgetJs.isInputElement)(e.browserEvent.target) || (0, _listWidgetJs.isMonacoEditor)(e.browserEvent.target)) return;
        if (e.browserEvent.isHandledByList) return;
        const node = e.element;
        if (!node) return super.onViewPointer(e);
        if (this.isSelectionRangeChangeEvent(e) || this.isSelectionSingleChangeEvent(e)) return super.onViewPointer(e);
        const target = e.browserEvent.target;
        const onTwistie = target.classList.contains("monaco-tl-twistie") || target.classList.contains("monaco-icon-label") && target.classList.contains("folder-icon") && e.browserEvent.offsetX < 16;
        const isStickyElement = (0, _listWidgetJs.isStickyScrollElement)(e.browserEvent.target);
        let expandOnlyOnTwistieClick = false;
        if (isStickyElement) expandOnlyOnTwistieClick = true;
        else if (typeof this.tree.expandOnlyOnTwistieClick === "function") expandOnlyOnTwistieClick = this.tree.expandOnlyOnTwistieClick(node.element);
        else expandOnlyOnTwistieClick = !!this.tree.expandOnlyOnTwistieClick;
        if (!isStickyElement) {
            if (expandOnlyOnTwistieClick && !onTwistie && e.browserEvent.detail !== 2) return super.onViewPointer(e);
            if (!this.tree.expandOnDoubleClick && e.browserEvent.detail === 2) return super.onViewPointer(e);
        } else this.handleStickyScrollMouseEvent(e, node);
        if (node.collapsible && (!isStickyElement || onTwistie)) {
            const location = this.tree.getNodeLocation(node);
            const recursive = e.browserEvent.altKey;
            this.tree.setFocus([
                location
            ]);
            this.tree.toggleCollapsed(location, recursive);
            if (onTwistie) {
                // Do not set this before calling a handler on the super class, because it will reject it as handled
                e.browserEvent.isHandledByList = true;
                return;
            }
        }
        if (!isStickyElement) super.onViewPointer(e);
    }
    handleStickyScrollMouseEvent(e, node) {
        if ((0, _listWidgetJs.isMonacoCustomToggle)(e.browserEvent.target) || (0, _listWidgetJs.isActionItem)(e.browserEvent.target)) return;
        const stickyScrollController = this.stickyScrollProvider();
        if (!stickyScrollController) throw new Error("Sticky scroll controller not found");
        const nodeIndex = this.list.indexOf(node);
        const elementScrollTop = this.list.getElementTop(nodeIndex);
        const elementTargetViewTop = stickyScrollController.nodePositionTopBelowWidget(node);
        this.tree.scrollTop = elementScrollTop - elementTargetViewTop;
        this.list.domFocus();
        this.list.setFocus([
            nodeIndex
        ]);
        this.list.setSelection([
            nodeIndex
        ]);
    }
    onDoubleClick(e) {
        const onTwistie = e.browserEvent.target.classList.contains("monaco-tl-twistie");
        if (onTwistie || !this.tree.expandOnDoubleClick) return;
        if (e.browserEvent.isHandledByList) return;
        super.onDoubleClick(e);
    }
    // to make sure dom focus is not stolen (for example with context menu)
    onMouseDown(e) {
        const target = e.browserEvent.target;
        if (!(0, _listWidgetJs.isStickyScrollContainer)(target) && !(0, _listWidgetJs.isStickyScrollElement)(target)) {
            super.onMouseDown(e);
            return;
        }
    }
    onContextMenu(e) {
        const target = e.browserEvent.target;
        if (!(0, _listWidgetJs.isStickyScrollContainer)(target) && !(0, _listWidgetJs.isStickyScrollElement)(target)) {
            super.onContextMenu(e);
            return;
        }
    }
}
/**
 * We use this List subclass to restore selection and focus as nodes
 * get rendered in the list, possibly due to a node expand() call.
 */ class TreeNodeList extends (0, _listWidgetJs.List) {
    constructor(user, container, virtualDelegate, renderers, focusTrait, selectionTrait, anchorTrait, options){
        super(user, container, virtualDelegate, renderers, options);
        this.focusTrait = focusTrait;
        this.selectionTrait = selectionTrait;
        this.anchorTrait = anchorTrait;
    }
    createMouseController(options) {
        return new TreeNodeListMouseController(this, options.tree, options.stickyScrollProvider);
    }
    splice(start, deleteCount, elements = []) {
        super.splice(start, deleteCount, elements);
        if (elements.length === 0) return;
        const additionalFocus = [];
        const additionalSelection = [];
        let anchor;
        elements.forEach((node, index)=>{
            if (this.focusTrait.has(node)) additionalFocus.push(start + index);
            if (this.selectionTrait.has(node)) additionalSelection.push(start + index);
            if (this.anchorTrait.has(node)) anchor = start + index;
        });
        if (additionalFocus.length > 0) super.setFocus((0, _arraysJs.distinct)([
            ...super.getFocus(),
            ...additionalFocus
        ]));
        if (additionalSelection.length > 0) super.setSelection((0, _arraysJs.distinct)([
            ...super.getSelection(),
            ...additionalSelection
        ]));
        if (typeof anchor === "number") super.setAnchor(anchor);
    }
    setFocus(indexes, browserEvent, fromAPI = false) {
        super.setFocus(indexes, browserEvent);
        if (!fromAPI) this.focusTrait.set(indexes.map((i)=>this.element(i)), browserEvent);
    }
    setSelection(indexes, browserEvent, fromAPI = false) {
        super.setSelection(indexes, browserEvent);
        if (!fromAPI) this.selectionTrait.set(indexes.map((i)=>this.element(i)), browserEvent);
    }
    setAnchor(index, fromAPI = false) {
        super.setAnchor(index);
        if (!fromAPI) {
            if (typeof index === "undefined") this.anchorTrait.set([]);
            else this.anchorTrait.set([
                this.element(index)
            ]);
        }
    }
}
class AbstractTree {
    get onDidScroll() {
        return this.view.onDidScroll;
    }
    get onDidChangeFocus() {
        return this.eventBufferer.wrapEvent(this.focus.onDidChange);
    }
    get onDidChangeSelection() {
        return this.eventBufferer.wrapEvent(this.selection.onDidChange);
    }
    get onMouseDblClick() {
        return (0, _eventJs1.Event).filter((0, _eventJs1.Event).map(this.view.onMouseDblClick, asTreeMouseEvent), (e)=>e.target !== (0, _treeJs.TreeMouseEventTarget).Filter);
    }
    get onMouseOver() {
        return (0, _eventJs1.Event).map(this.view.onMouseOver, asTreeMouseEvent);
    }
    get onMouseOut() {
        return (0, _eventJs1.Event).map(this.view.onMouseOut, asTreeMouseEvent);
    }
    get onContextMenu() {
        return (0, _eventJs1.Event).any((0, _eventJs1.Event).filter((0, _eventJs1.Event).map(this.view.onContextMenu, asTreeContextMenuEvent), (e)=>!e.isStickyScroll), this.stickyScrollController?.onContextMenu ?? (0, _eventJs1.Event).None);
    }
    get onPointer() {
        return (0, _eventJs1.Event).map(this.view.onPointer, asTreeMouseEvent);
    }
    get onKeyDown() {
        return this.view.onKeyDown;
    }
    get onDidFocus() {
        return this.view.onDidFocus;
    }
    get onDidChangeModel() {
        return (0, _eventJs1.Event).signal(this.model.onDidSplice);
    }
    get onDidChangeCollapseState() {
        return this.model.onDidChangeCollapseState;
    }
    get findMode() {
        return this.findController?.mode ?? TreeFindMode.Highlight;
    }
    set findMode(findMode) {
        if (this.findController) this.findController.mode = findMode;
    }
    get findMatchType() {
        return this.findController?.matchType ?? TreeFindMatchType.Fuzzy;
    }
    set findMatchType(findFuzzy) {
        if (this.findController) this.findController.matchType = findFuzzy;
    }
    get expandOnDoubleClick() {
        return typeof this._options.expandOnDoubleClick === "undefined" ? true : this._options.expandOnDoubleClick;
    }
    get expandOnlyOnTwistieClick() {
        return typeof this._options.expandOnlyOnTwistieClick === "undefined" ? true : this._options.expandOnlyOnTwistieClick;
    }
    get onDidDispose() {
        return this.view.onDidDispose;
    }
    constructor(_user, container, delegate, renderers, _options = {}){
        this._user = _user;
        this._options = _options;
        this.eventBufferer = new (0, _eventJs1.EventBufferer)();
        this.onDidChangeFindOpenState = (0, _eventJs1.Event).None;
        this.onDidChangeStickyScrollFocused = (0, _eventJs1.Event).None;
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this._onWillRefilter = new (0, _eventJs1.Emitter)();
        this.onWillRefilter = this._onWillRefilter.event;
        this._onDidUpdateOptions = new (0, _eventJs1.Emitter)();
        this.treeDelegate = new ComposedTreeDelegate(delegate);
        const onDidChangeCollapseStateRelay = new (0, _eventJs1.Relay)();
        const onDidChangeActiveNodes = new (0, _eventJs1.Relay)();
        const activeNodes = this.disposables.add(new EventCollection(onDidChangeActiveNodes.event));
        const renderedIndentGuides = new (0, _mapJs.SetMap)();
        this.renderers = renderers.map((r)=>new TreeRenderer(r, ()=>this.model, onDidChangeCollapseStateRelay.event, activeNodes, renderedIndentGuides, _options));
        for (const r of this.renderers)this.disposables.add(r);
        let filter;
        if (_options.keyboardNavigationLabelProvider) {
            filter = new FindFilter(this, _options.keyboardNavigationLabelProvider, _options.filter);
            _options = {
                ..._options,
                filter: filter
            }; // TODO need typescript help here
            this.disposables.add(filter);
        }
        this.focus = new Trait(()=>this.view.getFocusedElements()[0], _options.identityProvider);
        this.selection = new Trait(()=>this.view.getSelectedElements()[0], _options.identityProvider);
        this.anchor = new Trait(()=>this.view.getAnchorElement(), _options.identityProvider);
        this.view = new TreeNodeList(_user, container, this.treeDelegate, this.renderers, this.focus, this.selection, this.anchor, {
            ...asListOptions(()=>this.model, _options),
            tree: this,
            stickyScrollProvider: ()=>this.stickyScrollController
        });
        this.model = this.createModel(_user, this.view, _options);
        onDidChangeCollapseStateRelay.input = this.model.onDidChangeCollapseState;
        const onDidModelSplice = (0, _eventJs1.Event).forEach(this.model.onDidSplice, (e)=>{
            this.eventBufferer.bufferEvents(()=>{
                this.focus.onDidModelSplice(e);
                this.selection.onDidModelSplice(e);
            });
        }, this.disposables);
        // Make sure the `forEach` always runs
        onDidModelSplice(()=>null, null, this.disposables);
        // Active nodes can change when the model changes or when focus or selection change.
        // We debounce it with 0 delay since these events may fire in the same stack and we only
        // want to run this once. It also doesn't matter if it runs on the next tick since it's only
        // a nice to have UI feature.
        const activeNodesEmitter = this.disposables.add(new (0, _eventJs1.Emitter)());
        const activeNodesDebounce = this.disposables.add(new (0, _asyncJs.Delayer)(0));
        this.disposables.add((0, _eventJs1.Event).any(onDidModelSplice, this.focus.onDidChange, this.selection.onDidChange)(()=>{
            activeNodesDebounce.trigger(()=>{
                const set = new Set();
                for (const node of this.focus.getNodes())set.add(node);
                for (const node of this.selection.getNodes())set.add(node);
                activeNodesEmitter.fire([
                    ...set.values()
                ]);
            });
        }));
        onDidChangeActiveNodes.input = activeNodesEmitter.event;
        if (_options.keyboardSupport !== false) {
            const onKeyDown = (0, _eventJs1.Event).chain(this.view.onKeyDown, ($)=>$.filter((e)=>!(0, _listWidgetJs.isInputElement)(e.target)).map((e)=>new (0, _keyboardEventJs.StandardKeyboardEvent)(e)));
            (0, _eventJs1.Event).chain(onKeyDown, ($)=>$.filter((e)=>e.keyCode === 15 /* KeyCode.LeftArrow */ ))(this.onLeftArrow, this, this.disposables);
            (0, _eventJs1.Event).chain(onKeyDown, ($)=>$.filter((e)=>e.keyCode === 17 /* KeyCode.RightArrow */ ))(this.onRightArrow, this, this.disposables);
            (0, _eventJs1.Event).chain(onKeyDown, ($)=>$.filter((e)=>e.keyCode === 10 /* KeyCode.Space */ ))(this.onSpace, this, this.disposables);
        }
        if ((_options.findWidgetEnabled ?? true) && _options.keyboardNavigationLabelProvider && _options.contextViewProvider) {
            const opts = this.options.findWidgetStyles ? {
                styles: this.options.findWidgetStyles
            } : undefined;
            this.findController = new FindController(this, this.model, this.view, filter, _options.contextViewProvider, opts);
            this.focusNavigationFilter = (node)=>this.findController.shouldAllowFocus(node);
            this.onDidChangeFindOpenState = this.findController.onDidChangeOpenState;
            this.disposables.add(this.findController);
            this.onDidChangeFindMode = this.findController.onDidChangeMode;
            this.onDidChangeFindMatchType = this.findController.onDidChangeMatchType;
        } else {
            this.onDidChangeFindMode = (0, _eventJs1.Event).None;
            this.onDidChangeFindMatchType = (0, _eventJs1.Event).None;
        }
        if (_options.enableStickyScroll) {
            this.stickyScrollController = new StickyScrollController(this, this.model, this.view, this.renderers, this.treeDelegate, _options);
            this.onDidChangeStickyScrollFocused = this.stickyScrollController.onDidChangeHasFocus;
        }
        this.styleElement = (0, _domJs.createStyleSheet)(this.view.getHTMLElement());
        this.getHTMLElement().classList.toggle("always", this._options.renderIndentGuides === RenderIndentGuides.Always);
    }
    updateOptions(optionsUpdate = {}) {
        this._options = {
            ...this._options,
            ...optionsUpdate
        };
        for (const renderer of this.renderers)renderer.updateOptions(optionsUpdate);
        this.view.updateOptions(this._options);
        this.findController?.updateOptions(optionsUpdate);
        this.updateStickyScroll(optionsUpdate);
        this._onDidUpdateOptions.fire(this._options);
        this.getHTMLElement().classList.toggle("always", this._options.renderIndentGuides === RenderIndentGuides.Always);
    }
    get options() {
        return this._options;
    }
    updateStickyScroll(optionsUpdate) {
        if (!this.stickyScrollController && this._options.enableStickyScroll) {
            this.stickyScrollController = new StickyScrollController(this, this.model, this.view, this.renderers, this.treeDelegate, this._options);
            this.onDidChangeStickyScrollFocused = this.stickyScrollController.onDidChangeHasFocus;
        } else if (this.stickyScrollController && !this._options.enableStickyScroll) {
            this.onDidChangeStickyScrollFocused = (0, _eventJs1.Event).None;
            this.stickyScrollController.dispose();
            this.stickyScrollController = undefined;
        }
        this.stickyScrollController?.updateOptions(optionsUpdate);
    }
    // Widget
    getHTMLElement() {
        return this.view.getHTMLElement();
    }
    get scrollTop() {
        return this.view.scrollTop;
    }
    set scrollTop(scrollTop) {
        this.view.scrollTop = scrollTop;
    }
    get scrollHeight() {
        return this.view.scrollHeight;
    }
    get renderHeight() {
        return this.view.renderHeight;
    }
    get ariaLabel() {
        return this.view.ariaLabel;
    }
    set ariaLabel(value) {
        this.view.ariaLabel = value;
    }
    domFocus() {
        if (this.stickyScrollController?.focusedLast()) this.stickyScrollController.domFocus();
        else this.view.domFocus();
    }
    layout(height, width) {
        this.view.layout(height, width);
        if ((0, _typesJs.isNumber)(width)) this.findController?.layout(width);
    }
    style(styles) {
        const suffix = `.${this.view.domId}`;
        const content = [];
        if (styles.treeIndentGuidesStroke) {
            content.push(`.monaco-list${suffix}:hover .monaco-tl-indent > .indent-guide, .monaco-list${suffix}.always .monaco-tl-indent > .indent-guide  { border-color: ${styles.treeInactiveIndentGuidesStroke}; }`);
            content.push(`.monaco-list${suffix} .monaco-tl-indent > .indent-guide.active { border-color: ${styles.treeIndentGuidesStroke}; }`);
        }
        // Sticky Scroll Background
        const stickyScrollBackground = styles.treeStickyScrollBackground ?? styles.listBackground;
        if (stickyScrollBackground) {
            content.push(`.monaco-list${suffix} .monaco-scrollable-element .monaco-tree-sticky-container { background-color: ${stickyScrollBackground}; }`);
            content.push(`.monaco-list${suffix} .monaco-scrollable-element .monaco-tree-sticky-container .monaco-tree-sticky-row { background-color: ${stickyScrollBackground}; }`);
        }
        // Sticky Scroll Border
        if (styles.treeStickyScrollBorder) content.push(`.monaco-list${suffix} .monaco-scrollable-element .monaco-tree-sticky-container { border-bottom: 1px solid ${styles.treeStickyScrollBorder}; }`);
        // Sticky Scroll Shadow
        if (styles.treeStickyScrollShadow) content.push(`.monaco-list${suffix} .monaco-scrollable-element .monaco-tree-sticky-container .monaco-tree-sticky-container-shadow { box-shadow: ${styles.treeStickyScrollShadow} 0 6px 6px -6px inset; height: 3px; }`);
        // Sticky Scroll Focus
        if (styles.listFocusForeground) {
            content.push(`.monaco-list${suffix}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused { color: ${styles.listFocusForeground}; }`);
            content.push(`.monaco-list${suffix}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused { color: inherit; }`);
        }
        // Sticky Scroll Focus Outlines
        const focusAndSelectionOutline = (0, _domJs.asCssValueWithDefault)(styles.listFocusAndSelectionOutline, (0, _domJs.asCssValueWithDefault)(styles.listSelectionOutline, styles.listFocusOutline ?? ""));
        if (focusAndSelectionOutline) {
            content.push(`.monaco-list${suffix}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused.selected { outline: 1px solid ${focusAndSelectionOutline}; outline-offset: -1px;}`);
            content.push(`.monaco-list${suffix}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused.selected { outline: inherit;}`);
        }
        if (styles.listFocusOutline) {
            content.push(`.monaco-list${suffix}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused { outline: 1px solid ${styles.listFocusOutline}; outline-offset: -1px; }`);
            content.push(`.monaco-list${suffix}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused { outline: inherit; }`);
            content.push(`.monaco-workbench.context-menu-visible .monaco-list${suffix}.last-focused.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.passive-focused { outline: 1px solid ${styles.listFocusOutline}; outline-offset: -1px; }`);
            content.push(`.monaco-workbench.context-menu-visible .monaco-list${suffix}.last-focused.sticky-scroll-focused .monaco-list-rows .monaco-list-row.focused { outline: inherit; }`);
            content.push(`.monaco-workbench.context-menu-visible .monaco-list${suffix}.last-focused:not(.sticky-scroll-focused) .monaco-tree-sticky-container .monaco-list-rows .monaco-list-row.focused { outline: inherit; }`);
        }
        this.styleElement.textContent = content.join("\n");
        this.view.style(styles);
    }
    // Tree navigation
    getParentElement(location) {
        const parentRef = this.model.getParentNodeLocation(location);
        const parentNode = this.model.getNode(parentRef);
        return parentNode.element;
    }
    getFirstElementChild(location) {
        return this.model.getFirstElementChild(location);
    }
    // Tree
    getNode(location) {
        return this.model.getNode(location);
    }
    getNodeLocation(node) {
        return this.model.getNodeLocation(node);
    }
    collapse(location, recursive = false) {
        return this.model.setCollapsed(location, true, recursive);
    }
    expand(location, recursive = false) {
        return this.model.setCollapsed(location, false, recursive);
    }
    toggleCollapsed(location, recursive = false) {
        return this.model.setCollapsed(location, undefined, recursive);
    }
    isCollapsible(location) {
        return this.model.isCollapsible(location);
    }
    setCollapsible(location, collapsible) {
        return this.model.setCollapsible(location, collapsible);
    }
    isCollapsed(location) {
        return this.model.isCollapsed(location);
    }
    refilter() {
        this._onWillRefilter.fire(undefined);
        this.model.refilter();
    }
    setSelection(elements, browserEvent) {
        this.eventBufferer.bufferEvents(()=>{
            const nodes = elements.map((e)=>this.model.getNode(e));
            this.selection.set(nodes, browserEvent);
            const indexes = elements.map((e)=>this.model.getListIndex(e)).filter((i)=>i > -1);
            this.view.setSelection(indexes, browserEvent, true);
        });
    }
    getSelection() {
        return this.selection.get();
    }
    setFocus(elements, browserEvent) {
        this.eventBufferer.bufferEvents(()=>{
            const nodes = elements.map((e)=>this.model.getNode(e));
            this.focus.set(nodes, browserEvent);
            const indexes = elements.map((e)=>this.model.getListIndex(e)).filter((i)=>i > -1);
            this.view.setFocus(indexes, browserEvent, true);
        });
    }
    focusNext(n = 1, loop = false, browserEvent, filter = (0, _domJs.isKeyboardEvent)(browserEvent) && browserEvent.altKey ? undefined : this.focusNavigationFilter) {
        this.view.focusNext(n, loop, browserEvent, filter);
    }
    focusPrevious(n = 1, loop = false, browserEvent, filter = (0, _domJs.isKeyboardEvent)(browserEvent) && browserEvent.altKey ? undefined : this.focusNavigationFilter) {
        this.view.focusPrevious(n, loop, browserEvent, filter);
    }
    focusNextPage(browserEvent, filter = (0, _domJs.isKeyboardEvent)(browserEvent) && browserEvent.altKey ? undefined : this.focusNavigationFilter) {
        return this.view.focusNextPage(browserEvent, filter);
    }
    focusPreviousPage(browserEvent, filter = (0, _domJs.isKeyboardEvent)(browserEvent) && browserEvent.altKey ? undefined : this.focusNavigationFilter) {
        return this.view.focusPreviousPage(browserEvent, filter, ()=>this.stickyScrollController?.height ?? 0);
    }
    focusLast(browserEvent, filter = (0, _domJs.isKeyboardEvent)(browserEvent) && browserEvent.altKey ? undefined : this.focusNavigationFilter) {
        this.view.focusLast(browserEvent, filter);
    }
    focusFirst(browserEvent, filter = (0, _domJs.isKeyboardEvent)(browserEvent) && browserEvent.altKey ? undefined : this.focusNavigationFilter) {
        this.view.focusFirst(browserEvent, filter);
    }
    getFocus() {
        return this.focus.get();
    }
    reveal(location, relativeTop) {
        this.model.expandTo(location);
        const index = this.model.getListIndex(location);
        if (index === -1) return;
        if (!this.stickyScrollController) this.view.reveal(index, relativeTop);
        else {
            const paddingTop = this.stickyScrollController.nodePositionTopBelowWidget(this.getNode(location));
            this.view.reveal(index, relativeTop, paddingTop);
        }
    }
    // List
    onLeftArrow(e) {
        e.preventDefault();
        e.stopPropagation();
        const nodes = this.view.getFocusedElements();
        if (nodes.length === 0) return;
        const node = nodes[0];
        const location = this.model.getNodeLocation(node);
        const didChange = this.model.setCollapsed(location, true);
        if (!didChange) {
            const parentLocation = this.model.getParentNodeLocation(location);
            if (!parentLocation) return;
            const parentListIndex = this.model.getListIndex(parentLocation);
            this.view.reveal(parentListIndex);
            this.view.setFocus([
                parentListIndex
            ]);
        }
    }
    onRightArrow(e) {
        e.preventDefault();
        e.stopPropagation();
        const nodes = this.view.getFocusedElements();
        if (nodes.length === 0) return;
        const node = nodes[0];
        const location = this.model.getNodeLocation(node);
        const didChange = this.model.setCollapsed(location, false);
        if (!didChange) {
            if (!node.children.some((child)=>child.visible)) return;
            const [focusedIndex] = this.view.getFocus();
            const firstChildIndex = focusedIndex + 1;
            this.view.reveal(firstChildIndex);
            this.view.setFocus([
                firstChildIndex
            ]);
        }
    }
    onSpace(e) {
        e.preventDefault();
        e.stopPropagation();
        const nodes = this.view.getFocusedElements();
        if (nodes.length === 0) return;
        const node = nodes[0];
        const location = this.model.getNodeLocation(node);
        const recursive = e.browserEvent.altKey;
        this.model.setCollapsed(location, undefined, recursive);
    }
    dispose() {
        (0, _lifecycleJs.dispose)(this.disposables);
        this.stickyScrollController?.dispose();
        this.view.dispose();
    }
}

},{"../../dom.js":"bnqsM","../../event.js":"PHN3G","../../keyboardEvent.js":"bxU9U","../actionbar/actionbar.js":"5Xmba","../findinput/findInput.js":"dp0WT","../inputbox/inputBox.js":"aE5HZ","../list/listView.js":"36g6B","../list/listWidget.js":"f6tmg","../toggle/toggle.js":"3QqQn","./indexTreeModel.js":"1um9V","./tree.js":"5dQKP","../../../common/actions.js":"5GjLb","../../../common/arrays.js":"DECei","../../../common/async.js":"4GJc4","../../../common/codicons.js":"hWYNf","../../../common/themables.js":"hgyHi","../../../common/map.js":"leSjz","../../../common/event.js":"4Zi8b","../../../common/filters.js":"40BGZ","../../../common/lifecycle.js":"9kg8d","../../../common/numbers.js":"diWMG","../../../common/types.js":"fb5yx","./media/tree.css":"j8oJs","../../../../nls.js":"l617d","../hover/hoverDelegateFactory.js":"kll4h","../../../common/observable.js":"2xbG5","../aria/aria.js":"asrsh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1um9V":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFilterResult", ()=>isFilterResult);
parcelHelpers.export(exports, "getVisibleState", ()=>getVisibleState);
parcelHelpers.export(exports, "IndexTreeModel", ()=>IndexTreeModel);
var _treeJs = require("./tree.js");
var _arraysJs = require("../../../common/arrays.js");
var _asyncJs = require("../../../common/async.js");
var _symbolsJs = require("../../../common/symbols.js");
var _diffJs = require("../../../common/diff/diff.js");
var _eventJs = require("../../../common/event.js");
var _iteratorJs = require("../../../common/iterator.js");
function isFilterResult(obj) {
    return typeof obj === "object" && "visibility" in obj && "data" in obj;
}
function getVisibleState(visibility) {
    switch(visibility){
        case true:
            return 1 /* TreeVisibility.Visible */ ;
        case false:
            return 0 /* TreeVisibility.Hidden */ ;
        default:
            return visibility;
    }
}
function isCollapsibleStateUpdate(update) {
    return typeof update.collapsible === "boolean";
}
class IndexTreeModel {
    constructor(user, list, rootElement, options = {}){
        this.user = user;
        this.list = list;
        this.rootRef = [];
        this.eventBufferer = new (0, _eventJs.EventBufferer)();
        this._onDidChangeCollapseState = new (0, _eventJs.Emitter)();
        this.onDidChangeCollapseState = this.eventBufferer.wrapEvent(this._onDidChangeCollapseState.event);
        this._onDidChangeRenderNodeCount = new (0, _eventJs.Emitter)();
        this.onDidChangeRenderNodeCount = this.eventBufferer.wrapEvent(this._onDidChangeRenderNodeCount.event);
        this._onDidSplice = new (0, _eventJs.Emitter)();
        this.onDidSplice = this._onDidSplice.event;
        this.refilterDelayer = new (0, _asyncJs.Delayer)((0, _symbolsJs.MicrotaskDelay));
        this.collapseByDefault = typeof options.collapseByDefault === "undefined" ? false : options.collapseByDefault;
        this.allowNonCollapsibleParents = options.allowNonCollapsibleParents ?? false;
        this.filter = options.filter;
        this.autoExpandSingleChildren = typeof options.autoExpandSingleChildren === "undefined" ? false : options.autoExpandSingleChildren;
        this.root = {
            parent: undefined,
            element: rootElement,
            children: [],
            depth: 0,
            visibleChildrenCount: 0,
            visibleChildIndex: -1,
            collapsible: false,
            collapsed: false,
            renderNodeCount: 0,
            visibility: 1 /* TreeVisibility.Visible */ ,
            visible: true,
            filterData: undefined
        };
    }
    splice(location, deleteCount, toInsert = (0, _iteratorJs.Iterable).empty(), options = {}) {
        if (location.length === 0) throw new (0, _treeJs.TreeError)(this.user, "Invalid tree location");
        if (options.diffIdentityProvider) this.spliceSmart(options.diffIdentityProvider, location, deleteCount, toInsert, options);
        else this.spliceSimple(location, deleteCount, toInsert, options);
    }
    spliceSmart(identity, location, deleteCount, toInsertIterable = (0, _iteratorJs.Iterable).empty(), options, recurseLevels = options.diffDepth ?? 0) {
        const { parentNode } = this.getParentNodeWithListIndex(location);
        if (!parentNode.lastDiffIds) return this.spliceSimple(location, deleteCount, toInsertIterable, options);
        const toInsert = [
            ...toInsertIterable
        ];
        const index = location[location.length - 1];
        const diff = new (0, _diffJs.LcsDiff)({
            getElements: ()=>parentNode.lastDiffIds
        }, {
            getElements: ()=>[
                    ...parentNode.children.slice(0, index),
                    ...toInsert,
                    ...parentNode.children.slice(index + deleteCount)
                ].map((e)=>identity.getId(e.element).toString())
        }).ComputeDiff(false);
        // if we were given a 'best effort' diff, use default behavior
        if (diff.quitEarly) {
            parentNode.lastDiffIds = undefined;
            return this.spliceSimple(location, deleteCount, toInsert, options);
        }
        const locationPrefix = location.slice(0, -1);
        const recurseSplice = (fromOriginal, fromModified, count)=>{
            if (recurseLevels > 0) for(let i = 0; i < count; i++){
                fromOriginal--;
                fromModified--;
                this.spliceSmart(identity, [
                    ...locationPrefix,
                    fromOriginal,
                    0
                ], Number.MAX_SAFE_INTEGER, toInsert[fromModified].children, options, recurseLevels - 1);
            }
        };
        let lastStartO = Math.min(parentNode.children.length, index + deleteCount);
        let lastStartM = toInsert.length;
        for (const change of diff.changes.sort((a, b)=>b.originalStart - a.originalStart)){
            recurseSplice(lastStartO, lastStartM, lastStartO - (change.originalStart + change.originalLength));
            lastStartO = change.originalStart;
            lastStartM = change.modifiedStart - index;
            this.spliceSimple([
                ...locationPrefix,
                lastStartO
            ], change.originalLength, (0, _iteratorJs.Iterable).slice(toInsert, lastStartM, lastStartM + change.modifiedLength), options);
        }
        // at this point, startO === startM === count since any remaining prefix should match
        recurseSplice(lastStartO, lastStartM, lastStartO);
    }
    spliceSimple(location, deleteCount, toInsert = (0, _iteratorJs.Iterable).empty(), { onDidCreateNode, onDidDeleteNode, diffIdentityProvider }) {
        const { parentNode, listIndex, revealed, visible } = this.getParentNodeWithListIndex(location);
        const treeListElementsToInsert = [];
        const nodesToInsertIterator = (0, _iteratorJs.Iterable).map(toInsert, (el)=>this.createTreeNode(el, parentNode, parentNode.visible ? 1 /* TreeVisibility.Visible */  : 0 /* TreeVisibility.Hidden */ , revealed, treeListElementsToInsert, onDidCreateNode));
        const lastIndex = location[location.length - 1];
        // figure out what's the visible child start index right before the
        // splice point
        let visibleChildStartIndex = 0;
        for(let i = lastIndex; i >= 0 && i < parentNode.children.length; i--){
            const child = parentNode.children[i];
            if (child.visible) {
                visibleChildStartIndex = child.visibleChildIndex;
                break;
            }
        }
        const nodesToInsert = [];
        let insertedVisibleChildrenCount = 0;
        let renderNodeCount = 0;
        for (const child of nodesToInsertIterator){
            nodesToInsert.push(child);
            renderNodeCount += child.renderNodeCount;
            if (child.visible) child.visibleChildIndex = visibleChildStartIndex + insertedVisibleChildrenCount++;
        }
        const deletedNodes = (0, _arraysJs.splice)(parentNode.children, lastIndex, deleteCount, nodesToInsert);
        if (!diffIdentityProvider) parentNode.lastDiffIds = undefined;
        else if (parentNode.lastDiffIds) (0, _arraysJs.splice)(parentNode.lastDiffIds, lastIndex, deleteCount, nodesToInsert.map((n)=>diffIdentityProvider.getId(n.element).toString()));
        else parentNode.lastDiffIds = parentNode.children.map((n)=>diffIdentityProvider.getId(n.element).toString());
        // figure out what is the count of deleted visible children
        let deletedVisibleChildrenCount = 0;
        for (const child of deletedNodes)if (child.visible) deletedVisibleChildrenCount++;
        // and adjust for all visible children after the splice point
        if (deletedVisibleChildrenCount !== 0) for(let i = lastIndex + nodesToInsert.length; i < parentNode.children.length; i++){
            const child = parentNode.children[i];
            if (child.visible) child.visibleChildIndex -= deletedVisibleChildrenCount;
        }
        // update parent's visible children count
        parentNode.visibleChildrenCount += insertedVisibleChildrenCount - deletedVisibleChildrenCount;
        if (revealed && visible) {
            const visibleDeleteCount = deletedNodes.reduce((r, node)=>r + (node.visible ? node.renderNodeCount : 0), 0);
            this._updateAncestorsRenderNodeCount(parentNode, renderNodeCount - visibleDeleteCount);
            this.list.splice(listIndex, visibleDeleteCount, treeListElementsToInsert);
        }
        if (deletedNodes.length > 0 && onDidDeleteNode) {
            const visit = (node)=>{
                onDidDeleteNode(node);
                node.children.forEach(visit);
            };
            deletedNodes.forEach(visit);
        }
        this._onDidSplice.fire({
            insertedNodes: nodesToInsert,
            deletedNodes
        });
        let node = parentNode;
        while(node){
            if (node.visibility === 2 /* TreeVisibility.Recurse */ ) {
                // delayed to avoid excessive refiltering, see #135941
                this.refilterDelayer.trigger(()=>this.refilter());
                break;
            }
            node = node.parent;
        }
    }
    rerender(location) {
        if (location.length === 0) throw new (0, _treeJs.TreeError)(this.user, "Invalid tree location");
        const { node, listIndex, revealed } = this.getTreeNodeWithListIndex(location);
        if (node.visible && revealed) this.list.splice(listIndex, 1, [
            node
        ]);
    }
    has(location) {
        return this.hasTreeNode(location);
    }
    getListIndex(location) {
        const { listIndex, visible, revealed } = this.getTreeNodeWithListIndex(location);
        return visible && revealed ? listIndex : -1;
    }
    getListRenderCount(location) {
        return this.getTreeNode(location).renderNodeCount;
    }
    isCollapsible(location) {
        return this.getTreeNode(location).collapsible;
    }
    setCollapsible(location, collapsible) {
        const node = this.getTreeNode(location);
        if (typeof collapsible === "undefined") collapsible = !node.collapsible;
        const update = {
            collapsible
        };
        return this.eventBufferer.bufferEvents(()=>this._setCollapseState(location, update));
    }
    isCollapsed(location) {
        return this.getTreeNode(location).collapsed;
    }
    setCollapsed(location, collapsed, recursive) {
        const node = this.getTreeNode(location);
        if (typeof collapsed === "undefined") collapsed = !node.collapsed;
        const update = {
            collapsed,
            recursive: recursive || false
        };
        return this.eventBufferer.bufferEvents(()=>this._setCollapseState(location, update));
    }
    _setCollapseState(location, update) {
        const { node, listIndex, revealed } = this.getTreeNodeWithListIndex(location);
        const result = this._setListNodeCollapseState(node, listIndex, revealed, update);
        if (node !== this.root && this.autoExpandSingleChildren && result && !isCollapsibleStateUpdate(update) && node.collapsible && !node.collapsed && !update.recursive) {
            let onlyVisibleChildIndex = -1;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                if (child.visible) {
                    if (onlyVisibleChildIndex > -1) {
                        onlyVisibleChildIndex = -1;
                        break;
                    } else onlyVisibleChildIndex = i;
                }
            }
            if (onlyVisibleChildIndex > -1) this._setCollapseState([
                ...location,
                onlyVisibleChildIndex
            ], update);
        }
        return result;
    }
    _setListNodeCollapseState(node, listIndex, revealed, update) {
        const result = this._setNodeCollapseState(node, update, false);
        if (!revealed || !node.visible || !result) return result;
        const previousRenderNodeCount = node.renderNodeCount;
        const toInsert = this.updateNodeAfterCollapseChange(node);
        const deleteCount = previousRenderNodeCount - (listIndex === -1 ? 0 : 1);
        this.list.splice(listIndex + 1, deleteCount, toInsert.slice(1));
        return result;
    }
    _setNodeCollapseState(node, update, deep) {
        let result;
        if (node === this.root) result = false;
        else {
            if (isCollapsibleStateUpdate(update)) {
                result = node.collapsible !== update.collapsible;
                node.collapsible = update.collapsible;
            } else if (!node.collapsible) result = false;
            else {
                result = node.collapsed !== update.collapsed;
                node.collapsed = update.collapsed;
            }
            if (result) this._onDidChangeCollapseState.fire({
                node,
                deep
            });
        }
        if (!isCollapsibleStateUpdate(update) && update.recursive) for (const child of node.children)result = this._setNodeCollapseState(child, update, true) || result;
        return result;
    }
    expandTo(location) {
        this.eventBufferer.bufferEvents(()=>{
            let node = this.getTreeNode(location);
            while(node.parent){
                node = node.parent;
                location = location.slice(0, location.length - 1);
                if (node.collapsed) this._setCollapseState(location, {
                    collapsed: false,
                    recursive: false
                });
            }
        });
    }
    refilter() {
        const previousRenderNodeCount = this.root.renderNodeCount;
        const toInsert = this.updateNodeAfterFilterChange(this.root);
        this.list.splice(0, previousRenderNodeCount, toInsert);
        this.refilterDelayer.cancel();
    }
    createTreeNode(treeElement, parent, parentVisibility, revealed, treeListElements, onDidCreateNode) {
        const node = {
            parent,
            element: treeElement.element,
            children: [],
            depth: parent.depth + 1,
            visibleChildrenCount: 0,
            visibleChildIndex: -1,
            collapsible: typeof treeElement.collapsible === "boolean" ? treeElement.collapsible : typeof treeElement.collapsed !== "undefined",
            collapsed: typeof treeElement.collapsed === "undefined" ? this.collapseByDefault : treeElement.collapsed,
            renderNodeCount: 1,
            visibility: 1 /* TreeVisibility.Visible */ ,
            visible: true,
            filterData: undefined
        };
        const visibility = this._filterNode(node, parentVisibility);
        node.visibility = visibility;
        if (revealed) treeListElements.push(node);
        const childElements = treeElement.children || (0, _iteratorJs.Iterable).empty();
        const childRevealed = revealed && visibility !== 0 /* TreeVisibility.Hidden */  && !node.collapsed;
        let visibleChildrenCount = 0;
        let renderNodeCount = 1;
        for (const el of childElements){
            const child = this.createTreeNode(el, node, visibility, childRevealed, treeListElements, onDidCreateNode);
            node.children.push(child);
            renderNodeCount += child.renderNodeCount;
            if (child.visible) child.visibleChildIndex = visibleChildrenCount++;
        }
        if (!this.allowNonCollapsibleParents) node.collapsible = node.collapsible || node.children.length > 0;
        node.visibleChildrenCount = visibleChildrenCount;
        node.visible = visibility === 2 /* TreeVisibility.Recurse */  ? visibleChildrenCount > 0 : visibility === 1 /* TreeVisibility.Visible */ ;
        if (!node.visible) {
            node.renderNodeCount = 0;
            if (revealed) treeListElements.pop();
        } else if (!node.collapsed) node.renderNodeCount = renderNodeCount;
        onDidCreateNode?.(node);
        return node;
    }
    updateNodeAfterCollapseChange(node) {
        const previousRenderNodeCount = node.renderNodeCount;
        const result = [];
        this._updateNodeAfterCollapseChange(node, result);
        this._updateAncestorsRenderNodeCount(node.parent, result.length - previousRenderNodeCount);
        return result;
    }
    _updateNodeAfterCollapseChange(node, result) {
        if (node.visible === false) return 0;
        result.push(node);
        node.renderNodeCount = 1;
        if (!node.collapsed) for (const child of node.children)node.renderNodeCount += this._updateNodeAfterCollapseChange(child, result);
        this._onDidChangeRenderNodeCount.fire(node);
        return node.renderNodeCount;
    }
    updateNodeAfterFilterChange(node) {
        const previousRenderNodeCount = node.renderNodeCount;
        const result = [];
        this._updateNodeAfterFilterChange(node, node.visible ? 1 /* TreeVisibility.Visible */  : 0 /* TreeVisibility.Hidden */ , result);
        this._updateAncestorsRenderNodeCount(node.parent, result.length - previousRenderNodeCount);
        return result;
    }
    _updateNodeAfterFilterChange(node, parentVisibility, result, revealed = true) {
        let visibility;
        if (node !== this.root) {
            visibility = this._filterNode(node, parentVisibility);
            if (visibility === 0 /* TreeVisibility.Hidden */ ) {
                node.visible = false;
                node.renderNodeCount = 0;
                return false;
            }
            if (revealed) result.push(node);
        }
        const resultStartLength = result.length;
        node.renderNodeCount = node === this.root ? 0 : 1;
        let hasVisibleDescendants = false;
        if (!node.collapsed || visibility !== 0 /* TreeVisibility.Hidden */ ) {
            let visibleChildIndex = 0;
            for (const child of node.children){
                hasVisibleDescendants = this._updateNodeAfterFilterChange(child, visibility, result, revealed && !node.collapsed) || hasVisibleDescendants;
                if (child.visible) child.visibleChildIndex = visibleChildIndex++;
            }
            node.visibleChildrenCount = visibleChildIndex;
        } else node.visibleChildrenCount = 0;
        if (node !== this.root) {
            node.visible = visibility === 2 /* TreeVisibility.Recurse */  ? hasVisibleDescendants : visibility === 1 /* TreeVisibility.Visible */ ;
            node.visibility = visibility;
        }
        if (!node.visible) {
            node.renderNodeCount = 0;
            if (revealed) result.pop();
        } else if (!node.collapsed) node.renderNodeCount += result.length - resultStartLength;
        this._onDidChangeRenderNodeCount.fire(node);
        return node.visible;
    }
    _updateAncestorsRenderNodeCount(node, diff) {
        if (diff === 0) return;
        while(node){
            node.renderNodeCount += diff;
            this._onDidChangeRenderNodeCount.fire(node);
            node = node.parent;
        }
    }
    _filterNode(node, parentVisibility) {
        const result = this.filter ? this.filter.filter(node.element, parentVisibility) : 1 /* TreeVisibility.Visible */ ;
        if (typeof result === "boolean") {
            node.filterData = undefined;
            return result ? 1 /* TreeVisibility.Visible */  : 0 /* TreeVisibility.Hidden */ ;
        } else if (isFilterResult(result)) {
            node.filterData = result.data;
            return getVisibleState(result.visibility);
        } else {
            node.filterData = undefined;
            return getVisibleState(result);
        }
    }
    // cheap
    hasTreeNode(location, node = this.root) {
        if (!location || location.length === 0) return true;
        const [index, ...rest] = location;
        if (index < 0 || index > node.children.length) return false;
        return this.hasTreeNode(rest, node.children[index]);
    }
    // cheap
    getTreeNode(location, node = this.root) {
        if (!location || location.length === 0) return node;
        const [index, ...rest] = location;
        if (index < 0 || index > node.children.length) throw new (0, _treeJs.TreeError)(this.user, "Invalid tree location");
        return this.getTreeNode(rest, node.children[index]);
    }
    // expensive
    getTreeNodeWithListIndex(location) {
        if (location.length === 0) return {
            node: this.root,
            listIndex: -1,
            revealed: true,
            visible: false
        };
        const { parentNode, listIndex, revealed, visible } = this.getParentNodeWithListIndex(location);
        const index = location[location.length - 1];
        if (index < 0 || index > parentNode.children.length) throw new (0, _treeJs.TreeError)(this.user, "Invalid tree location");
        const node = parentNode.children[index];
        return {
            node,
            listIndex,
            revealed,
            visible: visible && node.visible
        };
    }
    getParentNodeWithListIndex(location, node = this.root, listIndex = 0, revealed = true, visible = true) {
        const [index, ...rest] = location;
        if (index < 0 || index > node.children.length) throw new (0, _treeJs.TreeError)(this.user, "Invalid tree location");
        // TODO@joao perf!
        for(let i = 0; i < index; i++)listIndex += node.children[i].renderNodeCount;
        revealed = revealed && !node.collapsed;
        visible = visible && node.visible;
        if (rest.length === 0) return {
            parentNode: node,
            listIndex,
            revealed,
            visible
        };
        return this.getParentNodeWithListIndex(rest, node.children[index], listIndex + 1, revealed, visible);
    }
    getNode(location = []) {
        return this.getTreeNode(location);
    }
    // TODO@joao perf!
    getNodeLocation(node) {
        const location = [];
        let indexTreeNode = node; // typing woes
        while(indexTreeNode.parent){
            location.push(indexTreeNode.parent.children.indexOf(indexTreeNode));
            indexTreeNode = indexTreeNode.parent;
        }
        return location.reverse();
    }
    getParentNodeLocation(location) {
        if (location.length === 0) return undefined;
        else if (location.length === 1) return [];
        else return (0, _arraysJs.tail2)(location)[0];
    }
    getFirstElementChild(location) {
        const node = this.getTreeNode(location);
        if (node.children.length === 0) return undefined;
        return node.children[0].element;
    }
}

},{"./tree.js":"5dQKP","../../../common/arrays.js":"DECei","../../../common/async.js":"4GJc4","../../../common/symbols.js":"2bzCZ","../../../common/diff/diff.js":"8KX5t","../../../common/event.js":"4Zi8b","../../../common/iterator.js":"2FiS0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5dQKP":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectTreeElementCollapseState", ()=>ObjectTreeElementCollapseState);
parcelHelpers.export(exports, "TreeMouseEventTarget", ()=>TreeMouseEventTarget);
parcelHelpers.export(exports, "TreeError", ()=>TreeError);
parcelHelpers.export(exports, "WeakMapper", ()=>WeakMapper);
var ObjectTreeElementCollapseState;
(function(ObjectTreeElementCollapseState) {
    ObjectTreeElementCollapseState[ObjectTreeElementCollapseState["Expanded"] = 0] = "Expanded";
    ObjectTreeElementCollapseState[ObjectTreeElementCollapseState["Collapsed"] = 1] = "Collapsed";
    /**
     * If the element is already in the tree, preserve its current state. Else, expand it.
     */ ObjectTreeElementCollapseState[ObjectTreeElementCollapseState["PreserveOrExpanded"] = 2] = "PreserveOrExpanded";
    /**
     * If the element is already in the tree, preserve its current state. Else, collapse it.
     */ ObjectTreeElementCollapseState[ObjectTreeElementCollapseState["PreserveOrCollapsed"] = 3] = "PreserveOrCollapsed";
})(ObjectTreeElementCollapseState || (ObjectTreeElementCollapseState = {}));
var TreeMouseEventTarget;
(function(TreeMouseEventTarget) {
    TreeMouseEventTarget[TreeMouseEventTarget["Unknown"] = 0] = "Unknown";
    TreeMouseEventTarget[TreeMouseEventTarget["Twistie"] = 1] = "Twistie";
    TreeMouseEventTarget[TreeMouseEventTarget["Element"] = 2] = "Element";
    TreeMouseEventTarget[TreeMouseEventTarget["Filter"] = 3] = "Filter";
})(TreeMouseEventTarget || (TreeMouseEventTarget = {}));
class TreeError extends Error {
    constructor(user, message){
        super(`TreeError [${user}] ${message}`);
    }
}
class WeakMapper {
    constructor(fn){
        this.fn = fn;
        this._map = new WeakMap();
    }
    map(key) {
        let result = this._map.get(key);
        if (!result) {
            result = this.fn(key);
            this._map.set(key, result);
        }
        return result;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j8oJs":[function() {},{}],"eY8mJ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncDataTree", ()=>AsyncDataTree);
parcelHelpers.export(exports, "CompressibleAsyncDataTree", ()=>CompressibleAsyncDataTree);
var _listViewJs = require("../list/listView.js");
var _abstractTreeJs = require("./abstractTree.js");
var _indexTreeModelJs = require("./indexTreeModel.js");
var _objectTreeJs = require("./objectTree.js");
var _treeJs = require("./tree.js");
var _asyncJs = require("../../../common/async.js");
var _codiconsJs = require("../../../common/codicons.js");
var _themablesJs = require("../../../common/themables.js");
var _errorsJs = require("../../../common/errors.js");
var _eventJs = require("../../../common/event.js");
var _iteratorJs = require("../../../common/iterator.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _typesJs = require("../../../common/types.js");
function createAsyncDataTreeNode(props) {
    return {
        ...props,
        children: [],
        refreshPromise: undefined,
        stale: true,
        slow: false,
        forceExpanded: false
    };
}
function isAncestor(ancestor, descendant) {
    if (!descendant.parent) return false;
    else if (descendant.parent === ancestor) return true;
    else return isAncestor(ancestor, descendant.parent);
}
function intersects(node, other) {
    return node === other || isAncestor(node, other) || isAncestor(other, node);
}
class AsyncDataTreeNodeWrapper {
    get element() {
        return this.node.element.element;
    }
    get children() {
        return this.node.children.map((node)=>new AsyncDataTreeNodeWrapper(node));
    }
    get depth() {
        return this.node.depth;
    }
    get visibleChildrenCount() {
        return this.node.visibleChildrenCount;
    }
    get visibleChildIndex() {
        return this.node.visibleChildIndex;
    }
    get collapsible() {
        return this.node.collapsible;
    }
    get collapsed() {
        return this.node.collapsed;
    }
    get visible() {
        return this.node.visible;
    }
    get filterData() {
        return this.node.filterData;
    }
    constructor(node){
        this.node = node;
    }
}
class AsyncDataTreeRenderer {
    constructor(renderer, nodeMapper, onDidChangeTwistieState){
        this.renderer = renderer;
        this.nodeMapper = nodeMapper;
        this.onDidChangeTwistieState = onDidChangeTwistieState;
        this.renderedNodes = new Map();
        this.templateId = renderer.templateId;
    }
    renderTemplate(container) {
        const templateData = this.renderer.renderTemplate(container);
        return {
            templateData
        };
    }
    renderElement(node, index, templateData, height) {
        this.renderer.renderElement(this.nodeMapper.map(node), index, templateData.templateData, height);
    }
    renderTwistie(element, twistieElement) {
        if (element.slow) {
            twistieElement.classList.add(...(0, _themablesJs.ThemeIcon).asClassNameArray((0, _codiconsJs.Codicon).treeItemLoading));
            return true;
        } else {
            twistieElement.classList.remove(...(0, _themablesJs.ThemeIcon).asClassNameArray((0, _codiconsJs.Codicon).treeItemLoading));
            return false;
        }
    }
    disposeElement(node, index, templateData, height) {
        this.renderer.disposeElement?.(this.nodeMapper.map(node), index, templateData.templateData, height);
    }
    disposeTemplate(templateData) {
        this.renderer.disposeTemplate(templateData.templateData);
    }
    dispose() {
        this.renderedNodes.clear();
    }
}
function asTreeEvent(e) {
    return {
        browserEvent: e.browserEvent,
        elements: e.elements.map((e)=>e.element)
    };
}
function asTreeMouseEvent(e) {
    return {
        browserEvent: e.browserEvent,
        element: e.element && e.element.element,
        target: e.target
    };
}
class AsyncDataTreeElementsDragAndDropData extends (0, _listViewJs.ElementsDragAndDropData) {
    constructor(data){
        super(data.elements.map((node)=>node.element));
        this.data = data;
    }
}
function asAsyncDataTreeDragAndDropData(data) {
    if (data instanceof (0, _listViewJs.ElementsDragAndDropData)) return new AsyncDataTreeElementsDragAndDropData(data);
    return data;
}
class AsyncDataTreeNodeListDragAndDrop {
    constructor(dnd){
        this.dnd = dnd;
    }
    getDragURI(node) {
        return this.dnd.getDragURI(node.element);
    }
    getDragLabel(nodes, originalEvent) {
        if (this.dnd.getDragLabel) return this.dnd.getDragLabel(nodes.map((node)=>node.element), originalEvent);
        return undefined;
    }
    onDragStart(data, originalEvent) {
        this.dnd.onDragStart?.(asAsyncDataTreeDragAndDropData(data), originalEvent);
    }
    onDragOver(data, targetNode, targetIndex, targetSector, originalEvent, raw = true) {
        return this.dnd.onDragOver(asAsyncDataTreeDragAndDropData(data), targetNode && targetNode.element, targetIndex, targetSector, originalEvent);
    }
    drop(data, targetNode, targetIndex, targetSector, originalEvent) {
        this.dnd.drop(asAsyncDataTreeDragAndDropData(data), targetNode && targetNode.element, targetIndex, targetSector, originalEvent);
    }
    onDragEnd(originalEvent) {
        this.dnd.onDragEnd?.(originalEvent);
    }
    dispose() {
        this.dnd.dispose();
    }
}
function asObjectTreeOptions(options) {
    return options && {
        ...options,
        collapseByDefault: true,
        identityProvider: options.identityProvider && {
            getId (el) {
                return options.identityProvider.getId(el.element);
            }
        },
        dnd: options.dnd && new AsyncDataTreeNodeListDragAndDrop(options.dnd),
        multipleSelectionController: options.multipleSelectionController && {
            isSelectionSingleChangeEvent (e) {
                return options.multipleSelectionController.isSelectionSingleChangeEvent({
                    ...e,
                    element: e.element
                });
            },
            isSelectionRangeChangeEvent (e) {
                return options.multipleSelectionController.isSelectionRangeChangeEvent({
                    ...e,
                    element: e.element
                });
            }
        },
        accessibilityProvider: options.accessibilityProvider && {
            ...options.accessibilityProvider,
            getPosInSet: undefined,
            getSetSize: undefined,
            getRole: options.accessibilityProvider.getRole ? (el)=>{
                return options.accessibilityProvider.getRole(el.element);
            } : ()=>"treeitem",
            isChecked: options.accessibilityProvider.isChecked ? (e)=>{
                return !!options.accessibilityProvider?.isChecked(e.element);
            } : undefined,
            getAriaLabel (e) {
                return options.accessibilityProvider.getAriaLabel(e.element);
            },
            getWidgetAriaLabel () {
                return options.accessibilityProvider.getWidgetAriaLabel();
            },
            getWidgetRole: options.accessibilityProvider.getWidgetRole ? ()=>options.accessibilityProvider.getWidgetRole() : ()=>"tree",
            getAriaLevel: options.accessibilityProvider.getAriaLevel && ((node)=>{
                return options.accessibilityProvider.getAriaLevel(node.element);
            }),
            getActiveDescendantId: options.accessibilityProvider.getActiveDescendantId && ((node)=>{
                return options.accessibilityProvider.getActiveDescendantId(node.element);
            })
        },
        filter: options.filter && {
            filter (e, parentVisibility) {
                return options.filter.filter(e.element, parentVisibility);
            }
        },
        keyboardNavigationLabelProvider: options.keyboardNavigationLabelProvider && {
            ...options.keyboardNavigationLabelProvider,
            getKeyboardNavigationLabel (e) {
                return options.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e.element);
            }
        },
        sorter: undefined,
        expandOnlyOnTwistieClick: typeof options.expandOnlyOnTwistieClick === "undefined" ? undefined : typeof options.expandOnlyOnTwistieClick !== "function" ? options.expandOnlyOnTwistieClick : (e)=>options.expandOnlyOnTwistieClick(e.element),
        defaultFindVisibility: (e)=>{
            if (e.hasChildren && e.stale) return 1 /* TreeVisibility.Visible */ ;
            else if (typeof options.defaultFindVisibility === "number") return options.defaultFindVisibility;
            else if (typeof options.defaultFindVisibility === "undefined") return 2 /* TreeVisibility.Recurse */ ;
            else return options.defaultFindVisibility(e.element);
        }
    };
}
function dfs(node, fn) {
    fn(node);
    node.children.forEach((child)=>dfs(child, fn));
}
class AsyncDataTree {
    get onDidScroll() {
        return this.tree.onDidScroll;
    }
    get onDidChangeFocus() {
        return (0, _eventJs.Event).map(this.tree.onDidChangeFocus, asTreeEvent);
    }
    get onDidChangeSelection() {
        return (0, _eventJs.Event).map(this.tree.onDidChangeSelection, asTreeEvent);
    }
    get onMouseDblClick() {
        return (0, _eventJs.Event).map(this.tree.onMouseDblClick, asTreeMouseEvent);
    }
    get onPointer() {
        return (0, _eventJs.Event).map(this.tree.onPointer, asTreeMouseEvent);
    }
    get onDidFocus() {
        return this.tree.onDidFocus;
    }
    /**
     * To be used internally only!
     * @deprecated
     */ get onDidChangeModel() {
        return this.tree.onDidChangeModel;
    }
    get onDidChangeCollapseState() {
        return this.tree.onDidChangeCollapseState;
    }
    get onDidChangeFindOpenState() {
        return this.tree.onDidChangeFindOpenState;
    }
    get onDidChangeStickyScrollFocused() {
        return this.tree.onDidChangeStickyScrollFocused;
    }
    get onDidDispose() {
        return this.tree.onDidDispose;
    }
    constructor(user, container, delegate, renderers, dataSource, options = {}){
        this.user = user;
        this.dataSource = dataSource;
        this.nodes = new Map();
        this.subTreeRefreshPromises = new Map();
        this.refreshPromises = new Map();
        this._onDidRender = new (0, _eventJs.Emitter)();
        this._onDidChangeNodeSlowState = new (0, _eventJs.Emitter)();
        this.nodeMapper = new (0, _treeJs.WeakMapper)((node)=>new AsyncDataTreeNodeWrapper(node));
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        this.identityProvider = options.identityProvider;
        this.autoExpandSingleChildren = typeof options.autoExpandSingleChildren === "undefined" ? false : options.autoExpandSingleChildren;
        this.sorter = options.sorter;
        this.getDefaultCollapseState = (e)=>options.collapseByDefault ? options.collapseByDefault(e) ? (0, _treeJs.ObjectTreeElementCollapseState).PreserveOrCollapsed : (0, _treeJs.ObjectTreeElementCollapseState).PreserveOrExpanded : undefined;
        this.tree = this.createTree(user, container, delegate, renderers, options);
        this.onDidChangeFindMode = this.tree.onDidChangeFindMode;
        this.onDidChangeFindMatchType = this.tree.onDidChangeFindMatchType;
        this.root = createAsyncDataTreeNode({
            element: undefined,
            parent: null,
            hasChildren: true,
            defaultCollapseState: undefined
        });
        if (this.identityProvider) this.root = {
            ...this.root,
            id: null
        };
        this.nodes.set(null, this.root);
        this.tree.onDidChangeCollapseState(this._onDidChangeCollapseState, this, this.disposables);
    }
    createTree(user, container, delegate, renderers, options) {
        const objectTreeDelegate = new (0, _abstractTreeJs.ComposedTreeDelegate)(delegate);
        const objectTreeRenderers = renderers.map((r)=>new AsyncDataTreeRenderer(r, this.nodeMapper, this._onDidChangeNodeSlowState.event));
        const objectTreeOptions = asObjectTreeOptions(options) || {};
        return new (0, _objectTreeJs.ObjectTree)(user, container, objectTreeDelegate, objectTreeRenderers, objectTreeOptions);
    }
    updateOptions(options = {}) {
        this.tree.updateOptions(options);
    }
    // Widget
    getHTMLElement() {
        return this.tree.getHTMLElement();
    }
    get scrollTop() {
        return this.tree.scrollTop;
    }
    set scrollTop(scrollTop) {
        this.tree.scrollTop = scrollTop;
    }
    get scrollHeight() {
        return this.tree.scrollHeight;
    }
    get renderHeight() {
        return this.tree.renderHeight;
    }
    domFocus() {
        this.tree.domFocus();
    }
    layout(height, width) {
        this.tree.layout(height, width);
    }
    style(styles) {
        this.tree.style(styles);
    }
    // Model
    getInput() {
        return this.root.element;
    }
    async setInput(input, viewState) {
        this.refreshPromises.forEach((promise)=>promise.cancel());
        this.refreshPromises.clear();
        this.root.element = input;
        const viewStateContext = viewState && {
            viewState,
            focus: [],
            selection: []
        };
        await this._updateChildren(input, true, false, viewStateContext);
        if (viewStateContext) {
            this.tree.setFocus(viewStateContext.focus);
            this.tree.setSelection(viewStateContext.selection);
        }
        if (viewState && typeof viewState.scrollTop === "number") this.scrollTop = viewState.scrollTop;
    }
    async _updateChildren(element = this.root.element, recursive = true, rerender = false, viewStateContext, options) {
        if (typeof this.root.element === "undefined") throw new (0, _treeJs.TreeError)(this.user, "Tree input not set");
        if (this.root.refreshPromise) {
            await this.root.refreshPromise;
            await (0, _eventJs.Event).toPromise(this._onDidRender.event);
        }
        const node = this.getDataNode(element);
        await this.refreshAndRenderNode(node, recursive, viewStateContext, options);
        if (rerender) try {
            this.tree.rerender(node);
        } catch  {
        // missing nodes are fine, this could've resulted from
        // parallel refresh calls, removing `node` altogether
        }
    }
    // View
    rerender(element) {
        if (element === undefined || element === this.root.element) {
            this.tree.rerender();
            return;
        }
        const node = this.getDataNode(element);
        this.tree.rerender(node);
    }
    // Tree
    getNode(element = this.root.element) {
        const dataNode = this.getDataNode(element);
        const node = this.tree.getNode(dataNode === this.root ? null : dataNode);
        return this.nodeMapper.map(node);
    }
    collapse(element, recursive = false) {
        const node = this.getDataNode(element);
        return this.tree.collapse(node === this.root ? null : node, recursive);
    }
    async expand(element, recursive = false) {
        if (typeof this.root.element === "undefined") throw new (0, _treeJs.TreeError)(this.user, "Tree input not set");
        if (this.root.refreshPromise) {
            await this.root.refreshPromise;
            await (0, _eventJs.Event).toPromise(this._onDidRender.event);
        }
        const node = this.getDataNode(element);
        if (this.tree.hasElement(node) && !this.tree.isCollapsible(node)) return false;
        if (node.refreshPromise) {
            await this.root.refreshPromise;
            await (0, _eventJs.Event).toPromise(this._onDidRender.event);
        }
        if (node !== this.root && !node.refreshPromise && !this.tree.isCollapsed(node)) return false;
        const result = this.tree.expand(node === this.root ? null : node, recursive);
        if (node.refreshPromise) {
            await this.root.refreshPromise;
            await (0, _eventJs.Event).toPromise(this._onDidRender.event);
        }
        return result;
    }
    setSelection(elements, browserEvent) {
        const nodes = elements.map((e)=>this.getDataNode(e));
        this.tree.setSelection(nodes, browserEvent);
    }
    getSelection() {
        const nodes = this.tree.getSelection();
        return nodes.map((n)=>n.element);
    }
    setFocus(elements, browserEvent) {
        const nodes = elements.map((e)=>this.getDataNode(e));
        this.tree.setFocus(nodes, browserEvent);
    }
    getFocus() {
        const nodes = this.tree.getFocus();
        return nodes.map((n)=>n.element);
    }
    reveal(element, relativeTop) {
        this.tree.reveal(this.getDataNode(element), relativeTop);
    }
    // Tree navigation
    getParentElement(element) {
        const node = this.tree.getParentElement(this.getDataNode(element));
        return node && node.element;
    }
    getFirstElementChild(element = this.root.element) {
        const dataNode = this.getDataNode(element);
        const node = this.tree.getFirstElementChild(dataNode === this.root ? null : dataNode);
        return node && node.element;
    }
    // Implementation
    getDataNode(element) {
        const node = this.nodes.get(element === this.root.element ? null : element);
        if (!node) throw new (0, _treeJs.TreeError)(this.user, `Data tree node not found: ${element}`);
        return node;
    }
    async refreshAndRenderNode(node, recursive, viewStateContext, options) {
        await this.refreshNode(node, recursive, viewStateContext);
        if (this.disposables.isDisposed) return; // tree disposed during refresh (#199264)
        this.render(node, viewStateContext, options);
    }
    async refreshNode(node, recursive, viewStateContext) {
        let result;
        this.subTreeRefreshPromises.forEach((refreshPromise, refreshNode)=>{
            if (!result && intersects(refreshNode, node)) result = refreshPromise.then(()=>this.refreshNode(node, recursive, viewStateContext));
        });
        if (result) return result;
        if (node !== this.root) {
            const treeNode = this.tree.getNode(node);
            if (treeNode.collapsed) {
                node.hasChildren = !!this.dataSource.hasChildren(node.element);
                node.stale = true;
                this.setChildren(node, [], recursive, viewStateContext);
                return;
            }
        }
        return this.doRefreshSubTree(node, recursive, viewStateContext);
    }
    async doRefreshSubTree(node, recursive, viewStateContext) {
        let done;
        node.refreshPromise = new Promise((c)=>done = c);
        this.subTreeRefreshPromises.set(node, node.refreshPromise);
        node.refreshPromise.finally(()=>{
            node.refreshPromise = undefined;
            this.subTreeRefreshPromises.delete(node);
        });
        try {
            const childrenToRefresh = await this.doRefreshNode(node, recursive, viewStateContext);
            node.stale = false;
            await (0, _asyncJs.Promises).settled(childrenToRefresh.map((child)=>this.doRefreshSubTree(child, recursive, viewStateContext)));
        } finally{
            done();
        }
    }
    async doRefreshNode(node, recursive, viewStateContext) {
        node.hasChildren = !!this.dataSource.hasChildren(node.element);
        let childrenPromise;
        if (!node.hasChildren) childrenPromise = Promise.resolve((0, _iteratorJs.Iterable).empty());
        else {
            const children = this.doGetChildren(node);
            if ((0, _typesJs.isIterable)(children)) childrenPromise = Promise.resolve(children);
            else {
                const slowTimeout = (0, _asyncJs.timeout)(800);
                slowTimeout.then(()=>{
                    node.slow = true;
                    this._onDidChangeNodeSlowState.fire(node);
                }, (_)=>null);
                childrenPromise = children.finally(()=>slowTimeout.cancel());
            }
        }
        try {
            const children = await childrenPromise;
            return this.setChildren(node, children, recursive, viewStateContext);
        } catch (err) {
            if (node !== this.root && this.tree.hasElement(node)) this.tree.collapse(node);
            if ((0, _errorsJs.isCancellationError)(err)) return [];
            throw err;
        } finally{
            if (node.slow) {
                node.slow = false;
                this._onDidChangeNodeSlowState.fire(node);
            }
        }
    }
    doGetChildren(node) {
        let result = this.refreshPromises.get(node);
        if (result) return result;
        const children = this.dataSource.getChildren(node.element);
        if ((0, _typesJs.isIterable)(children)) return this.processChildren(children);
        else {
            result = (0, _asyncJs.createCancelablePromise)(async ()=>this.processChildren(await children));
            this.refreshPromises.set(node, result);
            return result.finally(()=>{
                this.refreshPromises.delete(node);
            });
        }
    }
    _onDidChangeCollapseState({ node, deep }) {
        if (node.element === null) return;
        if (!node.collapsed && node.element.stale) {
            if (deep) this.collapse(node.element.element);
            else this.refreshAndRenderNode(node.element, false).catch((0, _errorsJs.onUnexpectedError));
        }
    }
    setChildren(node, childrenElementsIterable, recursive, viewStateContext) {
        const childrenElements = [
            ...childrenElementsIterable
        ];
        // perf: if the node was and still is a leaf, avoid all this hassle
        if (node.children.length === 0 && childrenElements.length === 0) return [];
        const nodesToForget = new Map();
        const childrenTreeNodesById = new Map();
        for (const child of node.children){
            nodesToForget.set(child.element, child);
            if (this.identityProvider) childrenTreeNodesById.set(child.id, {
                node: child,
                collapsed: this.tree.hasElement(child) && this.tree.isCollapsed(child)
            });
        }
        const childrenToRefresh = [];
        const children = childrenElements.map((element)=>{
            const hasChildren = !!this.dataSource.hasChildren(element);
            if (!this.identityProvider) {
                const asyncDataTreeNode = createAsyncDataTreeNode({
                    element,
                    parent: node,
                    hasChildren,
                    defaultCollapseState: this.getDefaultCollapseState(element)
                });
                if (hasChildren && asyncDataTreeNode.defaultCollapseState === (0, _treeJs.ObjectTreeElementCollapseState).PreserveOrExpanded) childrenToRefresh.push(asyncDataTreeNode);
                return asyncDataTreeNode;
            }
            const id = this.identityProvider.getId(element).toString();
            const result = childrenTreeNodesById.get(id);
            if (result) {
                const asyncDataTreeNode = result.node;
                nodesToForget.delete(asyncDataTreeNode.element);
                this.nodes.delete(asyncDataTreeNode.element);
                this.nodes.set(element, asyncDataTreeNode);
                asyncDataTreeNode.element = element;
                asyncDataTreeNode.hasChildren = hasChildren;
                if (recursive) {
                    if (result.collapsed) {
                        asyncDataTreeNode.children.forEach((node)=>dfs(node, (node)=>this.nodes.delete(node.element)));
                        asyncDataTreeNode.children.splice(0, asyncDataTreeNode.children.length);
                        asyncDataTreeNode.stale = true;
                    } else childrenToRefresh.push(asyncDataTreeNode);
                } else if (hasChildren && !result.collapsed) childrenToRefresh.push(asyncDataTreeNode);
                return asyncDataTreeNode;
            }
            const childAsyncDataTreeNode = createAsyncDataTreeNode({
                element,
                parent: node,
                id,
                hasChildren,
                defaultCollapseState: this.getDefaultCollapseState(element)
            });
            if (viewStateContext && viewStateContext.viewState.focus && viewStateContext.viewState.focus.indexOf(id) > -1) viewStateContext.focus.push(childAsyncDataTreeNode);
            if (viewStateContext && viewStateContext.viewState.selection && viewStateContext.viewState.selection.indexOf(id) > -1) viewStateContext.selection.push(childAsyncDataTreeNode);
            if (viewStateContext && viewStateContext.viewState.expanded && viewStateContext.viewState.expanded.indexOf(id) > -1) childrenToRefresh.push(childAsyncDataTreeNode);
            else if (hasChildren && childAsyncDataTreeNode.defaultCollapseState === (0, _treeJs.ObjectTreeElementCollapseState).PreserveOrExpanded) childrenToRefresh.push(childAsyncDataTreeNode);
            return childAsyncDataTreeNode;
        });
        for (const node of nodesToForget.values())dfs(node, (node)=>this.nodes.delete(node.element));
        for (const child of children)this.nodes.set(child.element, child);
        node.children.splice(0, node.children.length, ...children);
        // TODO@joao this doesn't take filter into account
        if (node !== this.root && this.autoExpandSingleChildren && children.length === 1 && childrenToRefresh.length === 0) {
            children[0].forceExpanded = true;
            childrenToRefresh.push(children[0]);
        }
        return childrenToRefresh;
    }
    render(node, viewStateContext, options) {
        const children = node.children.map((node)=>this.asTreeElement(node, viewStateContext));
        const objectTreeOptions = options && {
            ...options,
            diffIdentityProvider: options.diffIdentityProvider && {
                getId (node) {
                    return options.diffIdentityProvider.getId(node.element);
                }
            }
        };
        this.tree.setChildren(node === this.root ? null : node, children, objectTreeOptions);
        if (node !== this.root) this.tree.setCollapsible(node, node.hasChildren);
        this._onDidRender.fire();
    }
    asTreeElement(node, viewStateContext) {
        if (node.stale) return {
            element: node,
            collapsible: node.hasChildren,
            collapsed: true
        };
        let collapsed;
        if (viewStateContext && viewStateContext.viewState.expanded && node.id && viewStateContext.viewState.expanded.indexOf(node.id) > -1) collapsed = false;
        else if (node.forceExpanded) {
            collapsed = false;
            node.forceExpanded = false;
        } else collapsed = node.defaultCollapseState;
        return {
            element: node,
            children: node.hasChildren ? (0, _iteratorJs.Iterable).map(node.children, (child)=>this.asTreeElement(child, viewStateContext)) : [],
            collapsible: node.hasChildren,
            collapsed
        };
    }
    processChildren(children) {
        if (this.sorter) children = [
            ...children
        ].sort(this.sorter.compare.bind(this.sorter));
        return children;
    }
    dispose() {
        this.disposables.dispose();
        this.tree.dispose();
    }
}
class CompressibleAsyncDataTreeNodeWrapper {
    get element() {
        return {
            elements: this.node.element.elements.map((e)=>e.element),
            incompressible: this.node.element.incompressible
        };
    }
    get children() {
        return this.node.children.map((node)=>new CompressibleAsyncDataTreeNodeWrapper(node));
    }
    get depth() {
        return this.node.depth;
    }
    get visibleChildrenCount() {
        return this.node.visibleChildrenCount;
    }
    get visibleChildIndex() {
        return this.node.visibleChildIndex;
    }
    get collapsible() {
        return this.node.collapsible;
    }
    get collapsed() {
        return this.node.collapsed;
    }
    get visible() {
        return this.node.visible;
    }
    get filterData() {
        return this.node.filterData;
    }
    constructor(node){
        this.node = node;
    }
}
class CompressibleAsyncDataTreeRenderer {
    constructor(renderer, nodeMapper, compressibleNodeMapperProvider, onDidChangeTwistieState){
        this.renderer = renderer;
        this.nodeMapper = nodeMapper;
        this.compressibleNodeMapperProvider = compressibleNodeMapperProvider;
        this.onDidChangeTwistieState = onDidChangeTwistieState;
        this.renderedNodes = new Map();
        this.disposables = [];
        this.templateId = renderer.templateId;
    }
    renderTemplate(container) {
        const templateData = this.renderer.renderTemplate(container);
        return {
            templateData
        };
    }
    renderElement(node, index, templateData, height) {
        this.renderer.renderElement(this.nodeMapper.map(node), index, templateData.templateData, height);
    }
    renderCompressedElements(node, index, templateData, height) {
        this.renderer.renderCompressedElements(this.compressibleNodeMapperProvider().map(node), index, templateData.templateData, height);
    }
    renderTwistie(element, twistieElement) {
        if (element.slow) {
            twistieElement.classList.add(...(0, _themablesJs.ThemeIcon).asClassNameArray((0, _codiconsJs.Codicon).treeItemLoading));
            return true;
        } else {
            twistieElement.classList.remove(...(0, _themablesJs.ThemeIcon).asClassNameArray((0, _codiconsJs.Codicon).treeItemLoading));
            return false;
        }
    }
    disposeElement(node, index, templateData, height) {
        this.renderer.disposeElement?.(this.nodeMapper.map(node), index, templateData.templateData, height);
    }
    disposeCompressedElements(node, index, templateData, height) {
        this.renderer.disposeCompressedElements?.(this.compressibleNodeMapperProvider().map(node), index, templateData.templateData, height);
    }
    disposeTemplate(templateData) {
        this.renderer.disposeTemplate(templateData.templateData);
    }
    dispose() {
        this.renderedNodes.clear();
        this.disposables = (0, _lifecycleJs.dispose)(this.disposables);
    }
}
function asCompressibleObjectTreeOptions(options) {
    const objectTreeOptions = options && asObjectTreeOptions(options);
    return objectTreeOptions && {
        ...objectTreeOptions,
        keyboardNavigationLabelProvider: objectTreeOptions.keyboardNavigationLabelProvider && {
            ...objectTreeOptions.keyboardNavigationLabelProvider,
            getCompressedNodeKeyboardNavigationLabel (els) {
                return options.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(els.map((e)=>e.element));
            }
        }
    };
}
class CompressibleAsyncDataTree extends AsyncDataTree {
    constructor(user, container, virtualDelegate, compressionDelegate, renderers, dataSource, options = {}){
        super(user, container, virtualDelegate, renderers, dataSource, options);
        this.compressionDelegate = compressionDelegate;
        this.compressibleNodeMapper = new (0, _treeJs.WeakMapper)((node)=>new CompressibleAsyncDataTreeNodeWrapper(node));
        this.filter = options.filter;
    }
    createTree(user, container, delegate, renderers, options) {
        const objectTreeDelegate = new (0, _abstractTreeJs.ComposedTreeDelegate)(delegate);
        const objectTreeRenderers = renderers.map((r)=>new CompressibleAsyncDataTreeRenderer(r, this.nodeMapper, ()=>this.compressibleNodeMapper, this._onDidChangeNodeSlowState.event));
        const objectTreeOptions = asCompressibleObjectTreeOptions(options) || {};
        return new (0, _objectTreeJs.CompressibleObjectTree)(user, container, objectTreeDelegate, objectTreeRenderers, objectTreeOptions);
    }
    asTreeElement(node, viewStateContext) {
        return {
            incompressible: this.compressionDelegate.isIncompressible(node.element),
            ...super.asTreeElement(node, viewStateContext)
        };
    }
    updateOptions(options = {}) {
        this.tree.updateOptions(options);
    }
    render(node, viewStateContext, options) {
        if (!this.identityProvider) return super.render(node, viewStateContext);
        // Preserve traits across compressions. Hacky but does the trick.
        // This is hard to fix properly since it requires rewriting the traits
        // across trees and lists. Let's just keep it this way for now.
        const getId = (element)=>this.identityProvider.getId(element).toString();
        const getUncompressedIds = (nodes)=>{
            const result = new Set();
            for (const node of nodes){
                const compressedNode = this.tree.getCompressedTreeNode(node === this.root ? null : node);
                if (!compressedNode.element) continue;
                for (const node of compressedNode.element.elements)result.add(getId(node.element));
            }
            return result;
        };
        const oldSelection = getUncompressedIds(this.tree.getSelection());
        const oldFocus = getUncompressedIds(this.tree.getFocus());
        super.render(node, viewStateContext, options);
        const selection = this.getSelection();
        let didChangeSelection = false;
        const focus = this.getFocus();
        let didChangeFocus = false;
        const visit = (node)=>{
            const compressedNode = node.element;
            if (compressedNode) for(let i = 0; i < compressedNode.elements.length; i++){
                const id = getId(compressedNode.elements[i].element);
                const element = compressedNode.elements[compressedNode.elements.length - 1].element;
                // github.com/microsoft/vscode/issues/85938
                if (oldSelection.has(id) && selection.indexOf(element) === -1) {
                    selection.push(element);
                    didChangeSelection = true;
                }
                if (oldFocus.has(id) && focus.indexOf(element) === -1) {
                    focus.push(element);
                    didChangeFocus = true;
                }
            }
            node.children.forEach(visit);
        };
        visit(this.tree.getCompressedTreeNode(node === this.root ? null : node));
        if (didChangeSelection) this.setSelection(selection);
        if (didChangeFocus) this.setFocus(focus);
    }
    // For compressed async data trees, `TreeVisibility.Recurse` doesn't currently work
    // and we have to filter everything beforehand
    // Related to #85193 and #85835
    processChildren(children) {
        if (this.filter) children = (0, _iteratorJs.Iterable).filter(children, (e)=>{
            const result = this.filter.filter(e, 1 /* TreeVisibility.Visible */ );
            const visibility = getVisibility(result);
            if (visibility === 2 /* TreeVisibility.Recurse */ ) throw new Error("Recursive tree visibility not supported in async data compressed trees");
            return visibility === 1 /* TreeVisibility.Visible */ ;
        });
        return super.processChildren(children);
    }
}
function getVisibility(filterResult) {
    if (typeof filterResult === "boolean") return filterResult ? 1 /* TreeVisibility.Visible */  : 0 /* TreeVisibility.Hidden */ ;
    else if ((0, _indexTreeModelJs.isFilterResult)(filterResult)) return (0, _indexTreeModelJs.getVisibleState)(filterResult.visibility);
    else return (0, _indexTreeModelJs.getVisibleState)(filterResult);
}

},{"../list/listView.js":"36g6B","./abstractTree.js":"2Z8Kh","./indexTreeModel.js":"1um9V","./objectTree.js":"eYKNI","./tree.js":"5dQKP","../../../common/async.js":"4GJc4","../../../common/codicons.js":"hWYNf","../../../common/themables.js":"hgyHi","../../../common/errors.js":"divX8","../../../common/event.js":"4Zi8b","../../../common/iterator.js":"2FiS0","../../../common/lifecycle.js":"9kg8d","../../../common/types.js":"fb5yx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eYKNI":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectTree", ()=>ObjectTree);
parcelHelpers.export(exports, "CompressibleObjectTree", ()=>CompressibleObjectTree);
var _abstractTreeJs = require("./abstractTree.js");
var _compressedObjectTreeModelJs = require("./compressedObjectTreeModel.js");
var _objectTreeModelJs = require("./objectTreeModel.js");
var _decoratorsJs = require("../../../common/decorators.js");
var _iteratorJs = require("../../../common/iterator.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class ObjectTree extends (0, _abstractTreeJs.AbstractTree) {
    get onDidChangeCollapseState() {
        return this.model.onDidChangeCollapseState;
    }
    constructor(user, container, delegate, renderers, options = {}){
        super(user, container, delegate, renderers, options);
        this.user = user;
    }
    setChildren(element, children = (0, _iteratorJs.Iterable).empty(), options) {
        this.model.setChildren(element, children, options);
    }
    rerender(element) {
        if (element === undefined) {
            this.view.rerender();
            return;
        }
        this.model.rerender(element);
    }
    hasElement(element) {
        return this.model.has(element);
    }
    createModel(user, view, options) {
        return new (0, _objectTreeModelJs.ObjectTreeModel)(user, view, options);
    }
}
class CompressibleRenderer {
    get compressedTreeNodeProvider() {
        return this._compressedTreeNodeProvider();
    }
    constructor(_compressedTreeNodeProvider, stickyScrollDelegate, renderer){
        this._compressedTreeNodeProvider = _compressedTreeNodeProvider;
        this.stickyScrollDelegate = stickyScrollDelegate;
        this.renderer = renderer;
        this.templateId = renderer.templateId;
        if (renderer.onDidChangeTwistieState) this.onDidChangeTwistieState = renderer.onDidChangeTwistieState;
    }
    renderTemplate(container) {
        const data = this.renderer.renderTemplate(container);
        return {
            compressedTreeNode: undefined,
            data
        };
    }
    renderElement(node, index, templateData, height) {
        let compressedTreeNode = this.stickyScrollDelegate.getCompressedNode(node);
        if (!compressedTreeNode) compressedTreeNode = this.compressedTreeNodeProvider.getCompressedTreeNode(node.element);
        if (compressedTreeNode.element.elements.length === 1) {
            templateData.compressedTreeNode = undefined;
            this.renderer.renderElement(node, index, templateData.data, height);
        } else {
            templateData.compressedTreeNode = compressedTreeNode;
            this.renderer.renderCompressedElements(compressedTreeNode, index, templateData.data, height);
        }
    }
    disposeElement(node, index, templateData, height) {
        if (templateData.compressedTreeNode) this.renderer.disposeCompressedElements?.(templateData.compressedTreeNode, index, templateData.data, height);
        else this.renderer.disposeElement?.(node, index, templateData.data, height);
    }
    disposeTemplate(templateData) {
        this.renderer.disposeTemplate(templateData.data);
    }
    renderTwistie(element, twistieElement) {
        if (this.renderer.renderTwistie) return this.renderer.renderTwistie(element, twistieElement);
        return false;
    }
}
__decorate([
    (0, _decoratorsJs.memoize)
], CompressibleRenderer.prototype, "compressedTreeNodeProvider", null);
class CompressibleStickyScrollDelegate {
    constructor(modelProvider){
        this.modelProvider = modelProvider;
        this.compressedStickyNodes = new Map();
    }
    getCompressedNode(node) {
        return this.compressedStickyNodes.get(node);
    }
    constrainStickyScrollNodes(stickyNodes, stickyScrollMaxItemCount, maxWidgetHeight) {
        this.compressedStickyNodes.clear();
        if (stickyNodes.length === 0) return [];
        for(let i = 0; i < stickyNodes.length; i++){
            const stickyNode = stickyNodes[i];
            const stickyNodeBottom = stickyNode.position + stickyNode.height;
            const followingReachesMaxHeight = i + 1 < stickyNodes.length && stickyNodeBottom + stickyNodes[i + 1].height > maxWidgetHeight;
            if (followingReachesMaxHeight || i >= stickyScrollMaxItemCount - 1 && stickyScrollMaxItemCount < stickyNodes.length) {
                const uncompressedStickyNodes = stickyNodes.slice(0, i);
                const overflowingStickyNodes = stickyNodes.slice(i);
                const compressedStickyNode = this.compressStickyNodes(overflowingStickyNodes);
                return [
                    ...uncompressedStickyNodes,
                    compressedStickyNode
                ];
            }
        }
        return stickyNodes;
    }
    compressStickyNodes(stickyNodes) {
        if (stickyNodes.length === 0) throw new Error("Can't compress empty sticky nodes");
        const compressionModel = this.modelProvider();
        if (!compressionModel.isCompressionEnabled()) return stickyNodes[0];
        // Collect all elements to be compressed
        const elements = [];
        for(let i = 0; i < stickyNodes.length; i++){
            const stickyNode = stickyNodes[i];
            const compressedNode = compressionModel.getCompressedTreeNode(stickyNode.node.element);
            if (compressedNode.element) {
                // if an element is incompressible, it can't be compressed with it's parent element
                if (i !== 0 && compressedNode.element.incompressible) break;
                elements.push(...compressedNode.element.elements);
            }
        }
        if (elements.length < 2) return stickyNodes[0];
        // Compress the elements
        const lastStickyNode = stickyNodes[stickyNodes.length - 1];
        const compressedElement = {
            elements,
            incompressible: false
        };
        const compressedNode = {
            ...lastStickyNode.node,
            children: [],
            element: compressedElement
        };
        const stickyTreeNode = new Proxy(stickyNodes[0].node, {});
        const compressedStickyNode = {
            node: stickyTreeNode,
            startIndex: stickyNodes[0].startIndex,
            endIndex: lastStickyNode.endIndex,
            position: stickyNodes[0].position,
            height: stickyNodes[0].height
        };
        this.compressedStickyNodes.set(stickyTreeNode, compressedNode);
        return compressedStickyNode;
    }
}
function asObjectTreeOptions(compressedTreeNodeProvider, options) {
    return options && {
        ...options,
        keyboardNavigationLabelProvider: options.keyboardNavigationLabelProvider && {
            getKeyboardNavigationLabel (e) {
                let compressedTreeNode;
                try {
                    compressedTreeNode = compressedTreeNodeProvider().getCompressedTreeNode(e);
                } catch  {
                    return options.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e);
                }
                if (compressedTreeNode.element.elements.length === 1) return options.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e);
                else return options.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(compressedTreeNode.element.elements);
            }
        }
    };
}
class CompressibleObjectTree extends ObjectTree {
    constructor(user, container, delegate, renderers, options = {}){
        const compressedTreeNodeProvider = ()=>this;
        const stickyScrollDelegate = new CompressibleStickyScrollDelegate(()=>this.model);
        const compressibleRenderers = renderers.map((r)=>new CompressibleRenderer(compressedTreeNodeProvider, stickyScrollDelegate, r));
        super(user, container, delegate, compressibleRenderers, {
            ...asObjectTreeOptions(compressedTreeNodeProvider, options),
            stickyScrollDelegate
        });
    }
    setChildren(element, children = (0, _iteratorJs.Iterable).empty(), options) {
        this.model.setChildren(element, children, options);
    }
    createModel(user, view, options) {
        return new (0, _compressedObjectTreeModelJs.CompressibleObjectTreeModel)(user, view, options);
    }
    updateOptions(optionsUpdate = {}) {
        super.updateOptions(optionsUpdate);
        if (typeof optionsUpdate.compressionEnabled !== "undefined") this.model.setCompressionEnabled(optionsUpdate.compressionEnabled);
    }
    getCompressedTreeNode(element = null) {
        return this.model.getCompressedTreeNode(element);
    }
}

},{"./abstractTree.js":"2Z8Kh","./compressedObjectTreeModel.js":"cJXFb","./objectTreeModel.js":"w1RXp","../../../common/decorators.js":"hZnBn","../../../common/iterator.js":"2FiS0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cJXFb":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Exported only for test reasons, do not use directly
parcelHelpers.export(exports, "compress", ()=>compress);
// Exported only for test reasons, do not use directly
parcelHelpers.export(exports, "decompress", ()=>decompress);
// Exported only for test reasons, do not use directly
parcelHelpers.export(exports, "CompressedObjectTreeModel", ()=>CompressedObjectTreeModel);
parcelHelpers.export(exports, "DefaultElementMapper", ()=>DefaultElementMapper);
parcelHelpers.export(exports, "CompressibleObjectTreeModel", ()=>CompressibleObjectTreeModel);
var _objectTreeModelJs = require("./objectTreeModel.js");
var _treeJs = require("./tree.js");
var _arraysJs = require("../../../common/arrays.js");
var _eventJs = require("../../../common/event.js");
var _iteratorJs = require("../../../common/iterator.js");
function noCompress(element) {
    const elements = [
        element.element
    ];
    const incompressible = element.incompressible || false;
    return {
        element: {
            elements,
            incompressible
        },
        children: (0, _iteratorJs.Iterable).map((0, _iteratorJs.Iterable).from(element.children), noCompress),
        collapsible: element.collapsible,
        collapsed: element.collapsed
    };
}
function compress(element) {
    const elements = [
        element.element
    ];
    const incompressible = element.incompressible || false;
    let childrenIterator;
    let children;
    while(true){
        [children, childrenIterator] = (0, _iteratorJs.Iterable).consume((0, _iteratorJs.Iterable).from(element.children), 2);
        if (children.length !== 1) break;
        if (children[0].incompressible) break;
        element = children[0];
        elements.push(element.element);
    }
    return {
        element: {
            elements,
            incompressible
        },
        children: (0, _iteratorJs.Iterable).map((0, _iteratorJs.Iterable).concat(children, childrenIterator), compress),
        collapsible: element.collapsible,
        collapsed: element.collapsed
    };
}
function _decompress(element, index = 0) {
    let children;
    if (index < element.element.elements.length - 1) children = [
        _decompress(element, index + 1)
    ];
    else children = (0, _iteratorJs.Iterable).map((0, _iteratorJs.Iterable).from(element.children), (el)=>_decompress(el, 0));
    if (index === 0 && element.element.incompressible) return {
        element: element.element.elements[index],
        children,
        incompressible: true,
        collapsible: element.collapsible,
        collapsed: element.collapsed
    };
    return {
        element: element.element.elements[index],
        children,
        collapsible: element.collapsible,
        collapsed: element.collapsed
    };
}
function decompress(element) {
    return _decompress(element, 0);
}
function splice(treeElement, element, children) {
    if (treeElement.element === element) return {
        ...treeElement,
        children
    };
    return {
        ...treeElement,
        children: (0, _iteratorJs.Iterable).map((0, _iteratorJs.Iterable).from(treeElement.children), (e)=>splice(e, element, children))
    };
}
const wrapIdentityProvider = (base)=>({
        getId (node) {
            return node.elements.map((e)=>base.getId(e).toString()).join("\0");
        }
    });
class CompressedObjectTreeModel {
    get onDidSplice() {
        return this.model.onDidSplice;
    }
    get onDidChangeCollapseState() {
        return this.model.onDidChangeCollapseState;
    }
    get onDidChangeRenderNodeCount() {
        return this.model.onDidChangeRenderNodeCount;
    }
    constructor(user, list, options = {}){
        this.user = user;
        this.rootRef = null;
        this.nodes = new Map();
        this.model = new (0, _objectTreeModelJs.ObjectTreeModel)(user, list, options);
        this.enabled = typeof options.compressionEnabled === "undefined" ? true : options.compressionEnabled;
        this.identityProvider = options.identityProvider;
    }
    setChildren(element, children = (0, _iteratorJs.Iterable).empty(), options) {
        // Diffs must be deep, since the compression can affect nested elements.
        // @see https://github.com/microsoft/vscode/pull/114237#issuecomment-759425034
        const diffIdentityProvider = options.diffIdentityProvider && wrapIdentityProvider(options.diffIdentityProvider);
        if (element === null) {
            const compressedChildren = (0, _iteratorJs.Iterable).map(children, this.enabled ? compress : noCompress);
            this._setChildren(null, compressedChildren, {
                diffIdentityProvider,
                diffDepth: Infinity
            });
            return;
        }
        const compressedNode = this.nodes.get(element);
        if (!compressedNode) throw new (0, _treeJs.TreeError)(this.user, "Unknown compressed tree node");
        const node = this.model.getNode(compressedNode);
        const compressedParentNode = this.model.getParentNodeLocation(compressedNode);
        const parent = this.model.getNode(compressedParentNode);
        const decompressedElement = decompress(node);
        const splicedElement = splice(decompressedElement, element, children);
        const recompressedElement = (this.enabled ? compress : noCompress)(splicedElement);
        // If the recompressed node is identical to the original, just set its children.
        // Saves work and churn diffing the parent element.
        const elementComparator = options.diffIdentityProvider ? (a, b)=>options.diffIdentityProvider.getId(a) === options.diffIdentityProvider.getId(b) : undefined;
        if ((0, _arraysJs.equals)(recompressedElement.element.elements, node.element.elements, elementComparator)) {
            this._setChildren(compressedNode, recompressedElement.children || (0, _iteratorJs.Iterable).empty(), {
                diffIdentityProvider,
                diffDepth: 1
            });
            return;
        }
        const parentChildren = parent.children.map((child)=>child === node ? recompressedElement : child);
        this._setChildren(parent.element, parentChildren, {
            diffIdentityProvider,
            diffDepth: node.depth - parent.depth
        });
    }
    isCompressionEnabled() {
        return this.enabled;
    }
    setCompressionEnabled(enabled) {
        if (enabled === this.enabled) return;
        this.enabled = enabled;
        const root = this.model.getNode();
        const rootChildren = root.children;
        const decompressedRootChildren = (0, _iteratorJs.Iterable).map(rootChildren, decompress);
        const recompressedRootChildren = (0, _iteratorJs.Iterable).map(decompressedRootChildren, enabled ? compress : noCompress);
        // it should be safe to always use deep diff mode here if an identity
        // provider is available, since we know the raw nodes are unchanged.
        this._setChildren(null, recompressedRootChildren, {
            diffIdentityProvider: this.identityProvider,
            diffDepth: Infinity
        });
    }
    _setChildren(node, children, options) {
        const insertedElements = new Set();
        const onDidCreateNode = (node)=>{
            for (const element of node.element.elements){
                insertedElements.add(element);
                this.nodes.set(element, node.element);
            }
        };
        const onDidDeleteNode = (node)=>{
            for (const element of node.element.elements)if (!insertedElements.has(element)) this.nodes.delete(element);
        };
        this.model.setChildren(node, children, {
            ...options,
            onDidCreateNode,
            onDidDeleteNode
        });
    }
    has(element) {
        return this.nodes.has(element);
    }
    getListIndex(location) {
        const node = this.getCompressedNode(location);
        return this.model.getListIndex(node);
    }
    getListRenderCount(location) {
        const node = this.getCompressedNode(location);
        return this.model.getListRenderCount(node);
    }
    getNode(location) {
        if (typeof location === "undefined") return this.model.getNode();
        const node = this.getCompressedNode(location);
        return this.model.getNode(node);
    }
    // TODO: review this
    getNodeLocation(node) {
        const compressedNode = this.model.getNodeLocation(node);
        if (compressedNode === null) return null;
        return compressedNode.elements[compressedNode.elements.length - 1];
    }
    // TODO: review this
    getParentNodeLocation(location) {
        const compressedNode = this.getCompressedNode(location);
        const parentNode = this.model.getParentNodeLocation(compressedNode);
        if (parentNode === null) return null;
        return parentNode.elements[parentNode.elements.length - 1];
    }
    getFirstElementChild(location) {
        const compressedNode = this.getCompressedNode(location);
        return this.model.getFirstElementChild(compressedNode);
    }
    isCollapsible(location) {
        const compressedNode = this.getCompressedNode(location);
        return this.model.isCollapsible(compressedNode);
    }
    setCollapsible(location, collapsible) {
        const compressedNode = this.getCompressedNode(location);
        return this.model.setCollapsible(compressedNode, collapsible);
    }
    isCollapsed(location) {
        const compressedNode = this.getCompressedNode(location);
        return this.model.isCollapsed(compressedNode);
    }
    setCollapsed(location, collapsed, recursive) {
        const compressedNode = this.getCompressedNode(location);
        return this.model.setCollapsed(compressedNode, collapsed, recursive);
    }
    expandTo(location) {
        const compressedNode = this.getCompressedNode(location);
        this.model.expandTo(compressedNode);
    }
    rerender(location) {
        const compressedNode = this.getCompressedNode(location);
        this.model.rerender(compressedNode);
    }
    refilter() {
        this.model.refilter();
    }
    getCompressedNode(element) {
        if (element === null) return null;
        const node = this.nodes.get(element);
        if (!node) throw new (0, _treeJs.TreeError)(this.user, `Tree element not found: ${element}`);
        return node;
    }
}
const DefaultElementMapper = (elements)=>elements[elements.length - 1];
class CompressedTreeNodeWrapper {
    get element() {
        return this.node.element === null ? null : this.unwrapper(this.node.element);
    }
    get children() {
        return this.node.children.map((node)=>new CompressedTreeNodeWrapper(this.unwrapper, node));
    }
    get depth() {
        return this.node.depth;
    }
    get visibleChildrenCount() {
        return this.node.visibleChildrenCount;
    }
    get visibleChildIndex() {
        return this.node.visibleChildIndex;
    }
    get collapsible() {
        return this.node.collapsible;
    }
    get collapsed() {
        return this.node.collapsed;
    }
    get visible() {
        return this.node.visible;
    }
    get filterData() {
        return this.node.filterData;
    }
    constructor(unwrapper, node){
        this.unwrapper = unwrapper;
        this.node = node;
    }
}
function mapList(nodeMapper, list) {
    return {
        splice (start, deleteCount, toInsert) {
            list.splice(start, deleteCount, toInsert.map((node)=>nodeMapper.map(node)));
        },
        updateElementHeight (index, height) {
            list.updateElementHeight(index, height);
        }
    };
}
function mapOptions(compressedNodeUnwrapper, options) {
    return {
        ...options,
        identityProvider: options.identityProvider && {
            getId (node) {
                return options.identityProvider.getId(compressedNodeUnwrapper(node));
            }
        },
        sorter: options.sorter && {
            compare (node, otherNode) {
                return options.sorter.compare(node.elements[0], otherNode.elements[0]);
            }
        },
        filter: options.filter && {
            filter (node, parentVisibility) {
                return options.filter.filter(compressedNodeUnwrapper(node), parentVisibility);
            }
        }
    };
}
class CompressibleObjectTreeModel {
    get onDidSplice() {
        return (0, _eventJs.Event).map(this.model.onDidSplice, ({ insertedNodes, deletedNodes })=>({
                insertedNodes: insertedNodes.map((node)=>this.nodeMapper.map(node)),
                deletedNodes: deletedNodes.map((node)=>this.nodeMapper.map(node))
            }));
    }
    get onDidChangeCollapseState() {
        return (0, _eventJs.Event).map(this.model.onDidChangeCollapseState, ({ node, deep })=>({
                node: this.nodeMapper.map(node),
                deep
            }));
    }
    get onDidChangeRenderNodeCount() {
        return (0, _eventJs.Event).map(this.model.onDidChangeRenderNodeCount, (node)=>this.nodeMapper.map(node));
    }
    constructor(user, list, options = {}){
        this.rootRef = null;
        this.elementMapper = options.elementMapper || DefaultElementMapper;
        const compressedNodeUnwrapper = (node)=>this.elementMapper(node.elements);
        this.nodeMapper = new (0, _treeJs.WeakMapper)((node)=>new CompressedTreeNodeWrapper(compressedNodeUnwrapper, node));
        this.model = new CompressedObjectTreeModel(user, mapList(this.nodeMapper, list), mapOptions(compressedNodeUnwrapper, options));
    }
    setChildren(element, children = (0, _iteratorJs.Iterable).empty(), options = {}) {
        this.model.setChildren(element, children, options);
    }
    isCompressionEnabled() {
        return this.model.isCompressionEnabled();
    }
    setCompressionEnabled(enabled) {
        this.model.setCompressionEnabled(enabled);
    }
    has(location) {
        return this.model.has(location);
    }
    getListIndex(location) {
        return this.model.getListIndex(location);
    }
    getListRenderCount(location) {
        return this.model.getListRenderCount(location);
    }
    getNode(location) {
        return this.nodeMapper.map(this.model.getNode(location));
    }
    getNodeLocation(node) {
        return node.element;
    }
    getParentNodeLocation(location) {
        return this.model.getParentNodeLocation(location);
    }
    getFirstElementChild(location) {
        const result = this.model.getFirstElementChild(location);
        if (result === null || typeof result === "undefined") return result;
        return this.elementMapper(result.elements);
    }
    isCollapsible(location) {
        return this.model.isCollapsible(location);
    }
    setCollapsible(location, collapsed) {
        return this.model.setCollapsible(location, collapsed);
    }
    isCollapsed(location) {
        return this.model.isCollapsed(location);
    }
    setCollapsed(location, collapsed, recursive) {
        return this.model.setCollapsed(location, collapsed, recursive);
    }
    expandTo(location) {
        return this.model.expandTo(location);
    }
    rerender(location) {
        return this.model.rerender(location);
    }
    refilter() {
        return this.model.refilter();
    }
    getCompressedTreeNode(location = null) {
        return this.model.getNode(location);
    }
}

},{"./objectTreeModel.js":"w1RXp","./tree.js":"5dQKP","../../../common/arrays.js":"DECei","../../../common/event.js":"4Zi8b","../../../common/iterator.js":"2FiS0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"w1RXp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectTreeModel", ()=>ObjectTreeModel);
var _indexTreeModelJs = require("./indexTreeModel.js");
var _treeJs = require("./tree.js");
var _iteratorJs = require("../../../common/iterator.js");
class ObjectTreeModel {
    constructor(user, list, options = {}){
        this.user = user;
        this.rootRef = null;
        this.nodes = new Map();
        this.nodesByIdentity = new Map();
        this.model = new (0, _indexTreeModelJs.IndexTreeModel)(user, list, null, options);
        this.onDidSplice = this.model.onDidSplice;
        this.onDidChangeCollapseState = this.model.onDidChangeCollapseState;
        this.onDidChangeRenderNodeCount = this.model.onDidChangeRenderNodeCount;
        if (options.sorter) this.sorter = {
            compare (a, b) {
                return options.sorter.compare(a.element, b.element);
            }
        };
        this.identityProvider = options.identityProvider;
    }
    setChildren(element, children = (0, _iteratorJs.Iterable).empty(), options = {}) {
        const location = this.getElementLocation(element);
        this._setChildren(location, this.preserveCollapseState(children), options);
    }
    _setChildren(location, children = (0, _iteratorJs.Iterable).empty(), options) {
        const insertedElements = new Set();
        const insertedElementIds = new Set();
        const onDidCreateNode = (node)=>{
            if (node.element === null) return;
            const tnode = node;
            insertedElements.add(tnode.element);
            this.nodes.set(tnode.element, tnode);
            if (this.identityProvider) {
                const id = this.identityProvider.getId(tnode.element).toString();
                insertedElementIds.add(id);
                this.nodesByIdentity.set(id, tnode);
            }
            options.onDidCreateNode?.(tnode);
        };
        const onDidDeleteNode = (node)=>{
            if (node.element === null) return;
            const tnode = node;
            if (!insertedElements.has(tnode.element)) this.nodes.delete(tnode.element);
            if (this.identityProvider) {
                const id = this.identityProvider.getId(tnode.element).toString();
                if (!insertedElementIds.has(id)) this.nodesByIdentity.delete(id);
            }
            options.onDidDeleteNode?.(tnode);
        };
        this.model.splice([
            ...location,
            0
        ], Number.MAX_VALUE, children, {
            ...options,
            onDidCreateNode,
            onDidDeleteNode
        });
    }
    preserveCollapseState(elements = (0, _iteratorJs.Iterable).empty()) {
        if (this.sorter) elements = [
            ...elements
        ].sort(this.sorter.compare.bind(this.sorter));
        return (0, _iteratorJs.Iterable).map(elements, (treeElement)=>{
            let node = this.nodes.get(treeElement.element);
            if (!node && this.identityProvider) {
                const id = this.identityProvider.getId(treeElement.element).toString();
                node = this.nodesByIdentity.get(id);
            }
            if (!node) {
                let collapsed;
                if (typeof treeElement.collapsed === "undefined") collapsed = undefined;
                else if (treeElement.collapsed === (0, _treeJs.ObjectTreeElementCollapseState).Collapsed || treeElement.collapsed === (0, _treeJs.ObjectTreeElementCollapseState).PreserveOrCollapsed) collapsed = true;
                else if (treeElement.collapsed === (0, _treeJs.ObjectTreeElementCollapseState).Expanded || treeElement.collapsed === (0, _treeJs.ObjectTreeElementCollapseState).PreserveOrExpanded) collapsed = false;
                else collapsed = Boolean(treeElement.collapsed);
                return {
                    ...treeElement,
                    children: this.preserveCollapseState(treeElement.children),
                    collapsed
                };
            }
            const collapsible = typeof treeElement.collapsible === "boolean" ? treeElement.collapsible : node.collapsible;
            let collapsed;
            if (typeof treeElement.collapsed === "undefined" || treeElement.collapsed === (0, _treeJs.ObjectTreeElementCollapseState).PreserveOrCollapsed || treeElement.collapsed === (0, _treeJs.ObjectTreeElementCollapseState).PreserveOrExpanded) collapsed = node.collapsed;
            else if (treeElement.collapsed === (0, _treeJs.ObjectTreeElementCollapseState).Collapsed) collapsed = true;
            else if (treeElement.collapsed === (0, _treeJs.ObjectTreeElementCollapseState).Expanded) collapsed = false;
            else collapsed = Boolean(treeElement.collapsed);
            return {
                ...treeElement,
                collapsible,
                collapsed,
                children: this.preserveCollapseState(treeElement.children)
            };
        });
    }
    rerender(element) {
        const location = this.getElementLocation(element);
        this.model.rerender(location);
    }
    getFirstElementChild(ref = null) {
        const location = this.getElementLocation(ref);
        return this.model.getFirstElementChild(location);
    }
    has(element) {
        return this.nodes.has(element);
    }
    getListIndex(element) {
        const location = this.getElementLocation(element);
        return this.model.getListIndex(location);
    }
    getListRenderCount(element) {
        const location = this.getElementLocation(element);
        return this.model.getListRenderCount(location);
    }
    isCollapsible(element) {
        const location = this.getElementLocation(element);
        return this.model.isCollapsible(location);
    }
    setCollapsible(element, collapsible) {
        const location = this.getElementLocation(element);
        return this.model.setCollapsible(location, collapsible);
    }
    isCollapsed(element) {
        const location = this.getElementLocation(element);
        return this.model.isCollapsed(location);
    }
    setCollapsed(element, collapsed, recursive) {
        const location = this.getElementLocation(element);
        return this.model.setCollapsed(location, collapsed, recursive);
    }
    expandTo(element) {
        const location = this.getElementLocation(element);
        this.model.expandTo(location);
    }
    refilter() {
        this.model.refilter();
    }
    getNode(element = null) {
        if (element === null) return this.model.getNode(this.model.rootRef);
        const node = this.nodes.get(element);
        if (!node) throw new (0, _treeJs.TreeError)(this.user, `Tree element not found: ${element}`);
        return node;
    }
    getNodeLocation(node) {
        return node.element;
    }
    getParentNodeLocation(element) {
        if (element === null) throw new (0, _treeJs.TreeError)(this.user, `Invalid getParentNodeLocation call`);
        const node = this.nodes.get(element);
        if (!node) throw new (0, _treeJs.TreeError)(this.user, `Tree element not found: ${element}`);
        const location = this.model.getNodeLocation(node);
        const parentLocation = this.model.getParentNodeLocation(location);
        const parent = this.model.getNode(parentLocation);
        return parent.element;
    }
    getElementLocation(element) {
        if (element === null) return [];
        const node = this.nodes.get(element);
        if (!node) throw new (0, _treeJs.TreeError)(this.user, `Tree element not found: ${element}`);
        return this.model.getNodeLocation(node);
    }
}

},{"./indexTreeModel.js":"1um9V","./tree.js":"5dQKP","../../../common/iterator.js":"2FiS0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cC1Yk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataTree", ()=>DataTree);
var _abstractTreeJs = require("./abstractTree.js");
var _objectTreeModelJs = require("./objectTreeModel.js");
class DataTree extends (0, _abstractTreeJs.AbstractTree) {
    constructor(user, container, delegate, renderers, dataSource, options = {}){
        super(user, container, delegate, renderers, options);
        this.user = user;
        this.dataSource = dataSource;
        this.identityProvider = options.identityProvider;
    }
    createModel(user, view, options) {
        return new (0, _objectTreeModelJs.ObjectTreeModel)(user, view, options);
    }
}

},{"./abstractTree.js":"2Z8Kh","./objectTreeModel.js":"w1RXp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jqcbi":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsMacContext", ()=>IsMacContext);
parcelHelpers.export(exports, "IsLinuxContext", ()=>IsLinuxContext);
parcelHelpers.export(exports, "IsWindowsContext", ()=>IsWindowsContext);
parcelHelpers.export(exports, "IsWebContext", ()=>IsWebContext);
parcelHelpers.export(exports, "IsMacNativeContext", ()=>IsMacNativeContext);
parcelHelpers.export(exports, "IsIOSContext", ()=>IsIOSContext);
parcelHelpers.export(exports, "IsMobileContext", ()=>IsMobileContext);
parcelHelpers.export(exports, "IsDevelopmentContext", ()=>IsDevelopmentContext);
parcelHelpers.export(exports, "ProductQualityContext", ()=>ProductQualityContext);
parcelHelpers.export(exports, "InputFocusedContextKey", ()=>InputFocusedContextKey);
parcelHelpers.export(exports, "InputFocusedContext", ()=>InputFocusedContext);
var _platformJs = require("../../../base/common/platform.js");
var _nlsJs = require("../../../nls.js");
var _contextkeyJs = require("./contextkey.js");
const IsMacContext = new (0, _contextkeyJs.RawContextKey)("isMac", (0, _platformJs.isMacintosh), (0, _nlsJs.localize)("isMac", "Whether the operating system is macOS"));
const IsLinuxContext = new (0, _contextkeyJs.RawContextKey)("isLinux", (0, _platformJs.isLinux), (0, _nlsJs.localize)("isLinux", "Whether the operating system is Linux"));
const IsWindowsContext = new (0, _contextkeyJs.RawContextKey)("isWindows", (0, _platformJs.isWindows), (0, _nlsJs.localize)("isWindows", "Whether the operating system is Windows"));
const IsWebContext = new (0, _contextkeyJs.RawContextKey)("isWeb", (0, _platformJs.isWeb), (0, _nlsJs.localize)("isWeb", "Whether the platform is a web browser"));
const IsMacNativeContext = new (0, _contextkeyJs.RawContextKey)("isMacNative", (0, _platformJs.isMacintosh) && !(0, _platformJs.isWeb), (0, _nlsJs.localize)("isMacNative", "Whether the operating system is macOS on a non-browser platform"));
const IsIOSContext = new (0, _contextkeyJs.RawContextKey)("isIOS", (0, _platformJs.isIOS), (0, _nlsJs.localize)("isIOS", "Whether the operating system is iOS"));
const IsMobileContext = new (0, _contextkeyJs.RawContextKey)("isMobile", (0, _platformJs.isMobile), (0, _nlsJs.localize)("isMobile", "Whether the platform is a mobile web browser"));
const IsDevelopmentContext = new (0, _contextkeyJs.RawContextKey)("isDevelopment", false, true);
const ProductQualityContext = new (0, _contextkeyJs.RawContextKey)("productQualityType", "", (0, _nlsJs.localize)("productQualityType", "Quality type of VS Code"));
const InputFocusedContextKey = "inputFocus";
const InputFocusedContext = new (0, _contextkeyJs.RawContextKey)(InputFocusedContextKey, false, (0, _nlsJs.localize)("inputFocus", "Whether keyboard focus is inside an input box"));

},{"../../../base/common/platform.js":"7maJO","../../../nls.js":"l617d","./contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jocWA":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconLabel", ()=>IconLabel);
var _iconlabelCss = require("./iconlabel.css");
var _domJs = require("../../dom.js");
var _highlightedLabelJs = require("../highlightedlabel/highlightedLabel.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _objectsJs = require("../../../common/objects.js");
var _rangeJs = require("../../../common/range.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _hoverDelegate2Js = require("../hover/hoverDelegate2.js");
var _typesJs = require("../../../common/types.js");
var _iconLabelsJs = require("../../../common/iconLabels.js");
class FastLabelNode {
    constructor(_element){
        this._element = _element;
    }
    get element() {
        return this._element;
    }
    set textContent(content) {
        if (this.disposed || content === this._textContent) return;
        this._textContent = content;
        this._element.textContent = content;
    }
    set classNames(classNames) {
        if (this.disposed || (0, _objectsJs.equals)(classNames, this._classNames)) return;
        this._classNames = classNames;
        this._element.classList.value = "";
        this._element.classList.add(...classNames);
    }
    set empty(empty) {
        if (this.disposed || empty === this._empty) return;
        this._empty = empty;
        this._element.style.marginLeft = empty ? "0" : "";
    }
    dispose() {
        this.disposed = true;
    }
}
class IconLabel extends (0, _lifecycleJs.Disposable) {
    constructor(container, options){
        super();
        this.customHovers = new Map();
        this.creationOptions = options;
        this.domNode = this._register(new FastLabelNode(_domJs.append(container, _domJs.$(".monaco-icon-label"))));
        this.labelContainer = _domJs.append(this.domNode.element, _domJs.$(".monaco-icon-label-container"));
        this.nameContainer = _domJs.append(this.labelContainer, _domJs.$("span.monaco-icon-name-container"));
        if (options?.supportHighlights || options?.supportIcons) this.nameNode = this._register(new LabelWithHighlights(this.nameContainer, !!options.supportIcons));
        else this.nameNode = new Label(this.nameContainer);
        this.hoverDelegate = options?.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("mouse");
    }
    get element() {
        return this.domNode.element;
    }
    setLabel(label, description, options) {
        const labelClasses = [
            "monaco-icon-label"
        ];
        const containerClasses = [
            "monaco-icon-label-container"
        ];
        let ariaLabel = "";
        if (options) {
            if (options.extraClasses) labelClasses.push(...options.extraClasses);
            if (options.italic) labelClasses.push("italic");
            if (options.strikethrough) labelClasses.push("strikethrough");
            if (options.disabledCommand) containerClasses.push("disabled");
            if (options.title) {
                if (typeof options.title === "string") ariaLabel += options.title;
                else ariaLabel += label;
            }
        }
        const existingIconNode = this.domNode.element.querySelector(".monaco-icon-label-iconpath");
        if (options?.iconPath) {
            let iconNode;
            if (!existingIconNode || !_domJs.isHTMLElement(existingIconNode)) {
                iconNode = _domJs.$(".monaco-icon-label-iconpath");
                this.domNode.element.prepend(iconNode);
            } else iconNode = existingIconNode;
            iconNode.style.backgroundImage = _domJs.asCSSUrl(options?.iconPath);
        } else if (existingIconNode) existingIconNode.remove();
        this.domNode.classNames = labelClasses;
        this.domNode.element.setAttribute("aria-label", ariaLabel);
        this.labelContainer.classList.value = "";
        this.labelContainer.classList.add(...containerClasses);
        this.setupHover(options?.descriptionTitle ? this.labelContainer : this.element, options?.title);
        this.nameNode.setLabel(label, options);
        if (description || this.descriptionNode) {
            const descriptionNode = this.getOrCreateDescriptionNode();
            if (descriptionNode instanceof (0, _highlightedLabelJs.HighlightedLabel)) {
                descriptionNode.set(description || "", options ? options.descriptionMatches : undefined, undefined, options?.labelEscapeNewLines);
                this.setupHover(descriptionNode.element, options?.descriptionTitle);
            } else {
                descriptionNode.textContent = description && options?.labelEscapeNewLines ? (0, _highlightedLabelJs.HighlightedLabel).escapeNewLines(description, []) : description || "";
                this.setupHover(descriptionNode.element, options?.descriptionTitle || "");
                descriptionNode.empty = !description;
            }
        }
        if (options?.suffix || this.suffixNode) {
            const suffixNode = this.getOrCreateSuffixNode();
            suffixNode.textContent = options?.suffix ?? "";
        }
    }
    setupHover(htmlElement, tooltip) {
        const previousCustomHover = this.customHovers.get(htmlElement);
        if (previousCustomHover) {
            previousCustomHover.dispose();
            this.customHovers.delete(htmlElement);
        }
        if (!tooltip) {
            htmlElement.removeAttribute("title");
            return;
        }
        if (this.hoverDelegate.showNativeHover) {
            function setupNativeHover(htmlElement, tooltip) {
                if ((0, _typesJs.isString)(tooltip)) // Icons don't render in the native hover so we strip them out
                htmlElement.title = (0, _iconLabelsJs.stripIcons)(tooltip);
                else if (tooltip?.markdownNotSupportedFallback) htmlElement.title = tooltip.markdownNotSupportedFallback;
                else htmlElement.removeAttribute("title");
            }
            setupNativeHover(htmlElement, tooltip);
        } else {
            const hoverDisposable = (0, _hoverDelegate2Js.getBaseLayerHoverDelegate)().setupManagedHover(this.hoverDelegate, htmlElement, tooltip);
            if (hoverDisposable) this.customHovers.set(htmlElement, hoverDisposable);
        }
    }
    dispose() {
        super.dispose();
        for (const disposable of this.customHovers.values())disposable.dispose();
        this.customHovers.clear();
    }
    getOrCreateSuffixNode() {
        if (!this.suffixNode) {
            const suffixContainer = this._register(new FastLabelNode(_domJs.after(this.nameContainer, _domJs.$("span.monaco-icon-suffix-container"))));
            this.suffixNode = this._register(new FastLabelNode(_domJs.append(suffixContainer.element, _domJs.$("span.label-suffix"))));
        }
        return this.suffixNode;
    }
    getOrCreateDescriptionNode() {
        if (!this.descriptionNode) {
            const descriptionContainer = this._register(new FastLabelNode(_domJs.append(this.labelContainer, _domJs.$("span.monaco-icon-description-container"))));
            if (this.creationOptions?.supportDescriptionHighlights) this.descriptionNode = this._register(new (0, _highlightedLabelJs.HighlightedLabel)(_domJs.append(descriptionContainer.element, _domJs.$("span.label-description")), {
                supportIcons: !!this.creationOptions.supportIcons
            }));
            else this.descriptionNode = this._register(new FastLabelNode(_domJs.append(descriptionContainer.element, _domJs.$("span.label-description"))));
        }
        return this.descriptionNode;
    }
}
class Label {
    constructor(container){
        this.container = container;
        this.label = undefined;
        this.singleLabel = undefined;
    }
    setLabel(label, options) {
        if (this.label === label && (0, _objectsJs.equals)(this.options, options)) return;
        this.label = label;
        this.options = options;
        if (typeof label === "string") {
            if (!this.singleLabel) {
                this.container.innerText = "";
                this.container.classList.remove("multiple");
                this.singleLabel = _domJs.append(this.container, _domJs.$("a.label-name", {
                    id: options?.domId
                }));
            }
            this.singleLabel.textContent = label;
        } else {
            this.container.innerText = "";
            this.container.classList.add("multiple");
            this.singleLabel = undefined;
            for(let i = 0; i < label.length; i++){
                const l = label[i];
                const id = options?.domId && `${options?.domId}_${i}`;
                _domJs.append(this.container, _domJs.$("a.label-name", {
                    id,
                    "data-icon-label-count": label.length,
                    "data-icon-label-index": i,
                    "role": "treeitem"
                }, l));
                if (i < label.length - 1) _domJs.append(this.container, _domJs.$("span.label-separator", undefined, options?.separator || "/"));
            }
        }
    }
}
function splitMatches(labels, separator, matches) {
    if (!matches) return undefined;
    let labelStart = 0;
    return labels.map((label)=>{
        const labelRange = {
            start: labelStart,
            end: labelStart + label.length
        };
        const result = matches.map((match)=>(0, _rangeJs.Range).intersect(labelRange, match)).filter((range)=>!(0, _rangeJs.Range).isEmpty(range)).map(({ start, end })=>({
                start: start - labelStart,
                end: end - labelStart
            }));
        labelStart = labelRange.end + separator.length;
        return result;
    });
}
class LabelWithHighlights extends (0, _lifecycleJs.Disposable) {
    constructor(container, supportIcons){
        super();
        this.container = container;
        this.supportIcons = supportIcons;
        this.label = undefined;
        this.singleLabel = undefined;
    }
    setLabel(label, options) {
        if (this.label === label && (0, _objectsJs.equals)(this.options, options)) return;
        this.label = label;
        this.options = options;
        if (typeof label === "string") {
            if (!this.singleLabel) {
                this.container.innerText = "";
                this.container.classList.remove("multiple");
                this.singleLabel = this._register(new (0, _highlightedLabelJs.HighlightedLabel)(_domJs.append(this.container, _domJs.$("a.label-name", {
                    id: options?.domId
                })), {
                    supportIcons: this.supportIcons
                }));
            }
            this.singleLabel.set(label, options?.matches, undefined, options?.labelEscapeNewLines);
        } else {
            this.container.innerText = "";
            this.container.classList.add("multiple");
            this.singleLabel = undefined;
            const separator = options?.separator || "/";
            const matches = splitMatches(label, separator, options?.matches);
            for(let i = 0; i < label.length; i++){
                const l = label[i];
                const m = matches ? matches[i] : undefined;
                const id = options?.domId && `${options?.domId}_${i}`;
                const name = _domJs.$("a.label-name", {
                    id,
                    "data-icon-label-count": label.length,
                    "data-icon-label-index": i,
                    "role": "treeitem"
                });
                const highlightedLabel = this._register(new (0, _highlightedLabelJs.HighlightedLabel)(_domJs.append(this.container, name), {
                    supportIcons: this.supportIcons
                }));
                highlightedLabel.set(l, m, undefined, options?.labelEscapeNewLines);
                if (i < label.length - 1) _domJs.append(name, _domJs.$("span.label-separator", undefined, separator));
            }
        }
    }
}

},{"./iconlabel.css":"aMaQW","../../dom.js":"bnqsM","../highlightedlabel/highlightedLabel.js":"dx5zl","../../../common/lifecycle.js":"9kg8d","../../../common/objects.js":"j84mT","../../../common/range.js":"1yq3Z","../hover/hoverDelegateFactory.js":"kll4h","../hover/hoverDelegate2.js":"5jqL3","../../../common/types.js":"fb5yx","../../../common/iconLabels.js":"3vhIZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aMaQW":[function() {},{}],"dx5zl":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A widget which can render a label with substring highlights, often
 * originating from a filter function like the fuzzy matcher.
 */ parcelHelpers.export(exports, "HighlightedLabel", ()=>HighlightedLabel);
var _domJs = require("../../dom.js");
var _hoverDelegate2Js = require("../hover/hoverDelegate2.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _iconLabelsJs = require("../iconLabel/iconLabels.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _objectsJs = require("../../../common/objects.js");
class HighlightedLabel extends (0, _lifecycleJs.Disposable) {
    /**
     * Create a new {@link HighlightedLabel}.
     *
     * @param container The parent container to append to.
     */ constructor(container, options){
        super();
        this.options = options;
        this.text = "";
        this.title = "";
        this.highlights = [];
        this.didEverRender = false;
        this.supportIcons = options?.supportIcons ?? false;
        this.domNode = _domJs.append(container, _domJs.$("span.monaco-highlighted-label"));
    }
    /**
     * The label's DOM node.
     */ get element() {
        return this.domNode;
    }
    /**
     * Set the label and highlights.
     *
     * @param text The label to display.
     * @param highlights The ranges to highlight.
     * @param title An optional title for the hover tooltip.
     * @param escapeNewLines Whether to escape new lines.
     * @returns
     */ set(text, highlights = [], title = "", escapeNewLines) {
        if (!text) text = "";
        if (escapeNewLines) // adjusts highlights inplace
        text = HighlightedLabel.escapeNewLines(text, highlights);
        if (this.didEverRender && this.text === text && this.title === title && _objectsJs.equals(this.highlights, highlights)) return;
        this.text = text;
        this.title = title;
        this.highlights = highlights;
        this.render();
    }
    render() {
        const children = [];
        let pos = 0;
        for (const highlight of this.highlights){
            if (highlight.end === highlight.start) continue;
            if (pos < highlight.start) {
                const substring = this.text.substring(pos, highlight.start);
                if (this.supportIcons) children.push(...(0, _iconLabelsJs.renderLabelWithIcons)(substring));
                else children.push(substring);
                pos = highlight.start;
            }
            const substring = this.text.substring(pos, highlight.end);
            const element = _domJs.$("span.highlight", undefined, ...this.supportIcons ? (0, _iconLabelsJs.renderLabelWithIcons)(substring) : [
                substring
            ]);
            if (highlight.extraClasses) element.classList.add(...highlight.extraClasses);
            children.push(element);
            pos = highlight.end;
        }
        if (pos < this.text.length) {
            const substring = this.text.substring(pos);
            if (this.supportIcons) children.push(...(0, _iconLabelsJs.renderLabelWithIcons)(substring));
            else children.push(substring);
        }
        _domJs.reset(this.domNode, ...children);
        if (this.options?.hoverDelegate?.showNativeHover) /* While custom hover is not inside custom hover */ this.domNode.title = this.title;
        else {
            if (!this.customHover && this.title !== "") {
                const hoverDelegate = this.options?.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("mouse");
                this.customHover = this._register((0, _hoverDelegate2Js.getBaseLayerHoverDelegate)().setupManagedHover(hoverDelegate, this.domNode, this.title));
            } else if (this.customHover) this.customHover.update(this.title);
        }
        this.didEverRender = true;
    }
    static escapeNewLines(text, highlights) {
        let total = 0;
        let extra = 0;
        return text.replace(/\r\n|\r|\n/g, (match, offset)=>{
            extra = match === "\r\n" ? -1 : 0;
            offset += total;
            for (const highlight of highlights){
                if (highlight.end <= offset) continue;
                if (highlight.start >= offset) highlight.start += extra;
                if (highlight.end >= offset) highlight.end += extra;
            }
            total += extra;
            return "\u23CE";
        });
    }
}

},{"../../dom.js":"bnqsM","../hover/hoverDelegate2.js":"5jqL3","../hover/hoverDelegateFactory.js":"kll4h","../iconLabel/iconLabels.js":"lXqhk","../../../common/lifecycle.js":"9kg8d","../../../common/objects.js":"j84mT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hpphu":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unthemedKeybindingLabelOptions", ()=>unthemedKeybindingLabelOptions);
parcelHelpers.export(exports, "KeybindingLabel", ()=>KeybindingLabel);
var _domJs = require("../../dom.js");
var _hoverDelegate2Js = require("../hover/hoverDelegate2.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
var _keybindingLabelsJs = require("../../../common/keybindingLabels.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _objectsJs = require("../../../common/objects.js");
var _keybindingLabelCss = require("./keybindingLabel.css");
var _nlsJs = require("../../../../nls.js");
const $ = _domJs.$;
const unthemedKeybindingLabelOptions = {
    keybindingLabelBackground: undefined,
    keybindingLabelForeground: undefined,
    keybindingLabelBorder: undefined,
    keybindingLabelBottomBorder: undefined,
    keybindingLabelShadow: undefined
};
class KeybindingLabel extends (0, _lifecycleJs.Disposable) {
    constructor(container, os, options){
        super();
        this.os = os;
        this.keyElements = new Set();
        this.options = options || Object.create(null);
        const labelForeground = this.options.keybindingLabelForeground;
        this.domNode = _domJs.append(container, $(".monaco-keybinding"));
        if (labelForeground) this.domNode.style.color = labelForeground;
        this.hover = this._register((0, _hoverDelegate2Js.getBaseLayerHoverDelegate)().setupManagedHover((0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("mouse"), this.domNode, ""));
        this.didEverRender = false;
        container.appendChild(this.domNode);
    }
    get element() {
        return this.domNode;
    }
    set(keybinding, matches) {
        if (this.didEverRender && this.keybinding === keybinding && KeybindingLabel.areSame(this.matches, matches)) return;
        this.keybinding = keybinding;
        this.matches = matches;
        this.render();
    }
    render() {
        this.clear();
        if (this.keybinding) {
            const chords = this.keybinding.getChords();
            if (chords[0]) this.renderChord(this.domNode, chords[0], this.matches ? this.matches.firstPart : null);
            for(let i = 1; i < chords.length; i++){
                _domJs.append(this.domNode, $("span.monaco-keybinding-key-chord-separator", undefined, " "));
                this.renderChord(this.domNode, chords[i], this.matches ? this.matches.chordPart : null);
            }
            const title = this.options.disableTitle ?? false ? undefined : this.keybinding.getAriaLabel() || undefined;
            this.hover.update(title);
            this.domNode.setAttribute("aria-label", title || "");
        } else if (this.options && this.options.renderUnboundKeybindings) this.renderUnbound(this.domNode);
        this.didEverRender = true;
    }
    clear() {
        _domJs.clearNode(this.domNode);
        this.keyElements.clear();
    }
    renderChord(parent, chord, match) {
        const modifierLabels = (0, _keybindingLabelsJs.UILabelProvider).modifierLabels[this.os];
        if (chord.ctrlKey) this.renderKey(parent, modifierLabels.ctrlKey, Boolean(match?.ctrlKey), modifierLabels.separator);
        if (chord.shiftKey) this.renderKey(parent, modifierLabels.shiftKey, Boolean(match?.shiftKey), modifierLabels.separator);
        if (chord.altKey) this.renderKey(parent, modifierLabels.altKey, Boolean(match?.altKey), modifierLabels.separator);
        if (chord.metaKey) this.renderKey(parent, modifierLabels.metaKey, Boolean(match?.metaKey), modifierLabels.separator);
        const keyLabel = chord.keyLabel;
        if (keyLabel) this.renderKey(parent, keyLabel, Boolean(match?.keyCode), "");
    }
    renderKey(parent, label, highlight, separator) {
        _domJs.append(parent, this.createKeyElement(label, highlight ? ".highlight" : ""));
        if (separator) _domJs.append(parent, $("span.monaco-keybinding-key-separator", undefined, separator));
    }
    renderUnbound(parent) {
        _domJs.append(parent, this.createKeyElement((0, _nlsJs.localize)("unbound", "Unbound")));
    }
    createKeyElement(label, extraClass = "") {
        const keyElement = $("span.monaco-keybinding-key" + extraClass, undefined, label);
        this.keyElements.add(keyElement);
        if (this.options.keybindingLabelBackground) keyElement.style.backgroundColor = this.options.keybindingLabelBackground;
        if (this.options.keybindingLabelBorder) keyElement.style.borderColor = this.options.keybindingLabelBorder;
        if (this.options.keybindingLabelBottomBorder) keyElement.style.borderBottomColor = this.options.keybindingLabelBottomBorder;
        if (this.options.keybindingLabelShadow) keyElement.style.boxShadow = `inset 0 -1px 0 ${this.options.keybindingLabelShadow}`;
        return keyElement;
    }
    static areSame(a, b) {
        if (a === b || !a && !b) return true;
        return !!a && !!b && (0, _objectsJs.equals)(a.firstPart, b.firstPart) && (0, _objectsJs.equals)(a.chordPart, b.chordPart);
    }
}

},{"../../dom.js":"bnqsM","../hover/hoverDelegate2.js":"5jqL3","../hover/hoverDelegateFactory.js":"kll4h","../../../common/keybindingLabels.js":"jUs6a","../../../common/lifecycle.js":"9kg8d","../../../common/objects.js":"j84mT","./keybindingLabel.css":"3797P","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3797P":[function() {},{}],"93ss4":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Compares filenames without distinguishing the name from the extension. Disambiguates by unicode comparison. */ parcelHelpers.export(exports, "compareFileNames", ()=>compareFileNames);
parcelHelpers.export(exports, "compareAnything", ()=>compareAnything);
parcelHelpers.export(exports, "compareByPrefix", ()=>compareByPrefix);
var _lazyJs = require("./lazy.js");
// When comparing large numbers of strings it's better for performance to create an
// Intl.Collator object and use the function provided by its compare property
// than it is to use String.prototype.localeCompare()
// A collator with numeric sorting enabled, and no sensitivity to case, accents or diacritics.
const intlFileNameCollatorBaseNumeric = new (0, _lazyJs.Lazy)(()=>{
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: "base"
    });
    return {
        collator,
        collatorIsNumeric: collator.resolvedOptions().numeric
    };
});
// A collator with numeric sorting enabled.
const intlFileNameCollatorNumeric = new (0, _lazyJs.Lazy)(()=>{
    const collator = new Intl.Collator(undefined, {
        numeric: true
    });
    return {
        collator
    };
});
// A collator with numeric sorting enabled, and sensitivity to accents and diacritics but not case.
const intlFileNameCollatorNumericCaseInsensitive = new (0, _lazyJs.Lazy)(()=>{
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: "accent"
    });
    return {
        collator
    };
});
function compareFileNames(one, other, caseSensitive = false) {
    const a = one || "";
    const b = other || "";
    const result = intlFileNameCollatorBaseNumeric.value.collator.compare(a, b);
    // Using the numeric option will make compare(`foo1`, `foo01`) === 0. Disambiguate.
    if (intlFileNameCollatorBaseNumeric.value.collatorIsNumeric && result === 0 && a !== b) return a < b ? -1 : 1;
    return result;
}
function compareAnything(one, other, lookFor) {
    const elementAName = one.toLowerCase();
    const elementBName = other.toLowerCase();
    // Sort prefix matches over non prefix matches
    const prefixCompare = compareByPrefix(one, other, lookFor);
    if (prefixCompare) return prefixCompare;
    // Sort suffix matches over non suffix matches
    const elementASuffixMatch = elementAName.endsWith(lookFor);
    const elementBSuffixMatch = elementBName.endsWith(lookFor);
    if (elementASuffixMatch !== elementBSuffixMatch) return elementASuffixMatch ? -1 : 1;
    // Understand file names
    const r = compareFileNames(elementAName, elementBName);
    if (r !== 0) return r;
    // Compare by name
    return elementAName.localeCompare(elementBName);
}
function compareByPrefix(one, other, lookFor) {
    const elementAName = one.toLowerCase();
    const elementBName = other.toLowerCase();
    // Sort prefix matches over non prefix matches
    const elementAPrefixMatch = elementAName.startsWith(lookFor);
    const elementBPrefixMatch = elementBName.startsWith(lookFor);
    if (elementAPrefixMatch !== elementBPrefixMatch) return elementAPrefixMatch ? -1 : 1;
    else if (elementAPrefixMatch && elementBPrefixMatch) {
        if (elementAName.length < elementBName.length) return -1;
        if (elementAName.length > elementBName.length) return 1;
    }
    return 0;
}

},{"./lazy.js":"6e57N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gGKuo":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _platformJs = require("../../../base/common/platform.js");
var _nlsJs = require("../../../nls.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _contextkeysJs = require("../../contextkey/common/contextkeys.js");
var _keybindingsRegistryJs = require("../../keybinding/common/keybindingsRegistry.js");
var _quickInputJs = require("./quickInput.js");
var _quickInputJs1 = require("../common/quickInput.js");
const defaultCommandAndKeybindingRule = {
    weight: 200 /* KeybindingWeight.WorkbenchContrib */ ,
    when: (0, _contextkeyJs.ContextKeyExpr).and((0, _contextkeyJs.ContextKeyExpr).equals((0, _quickInputJs.quickInputTypeContextKeyValue), "quickPick" /* QuickInputType.QuickPick */ ), (0, _quickInputJs.inQuickInputContext)),
    metadata: {
        description: (0, _nlsJs.localize)("quickPick", "Used while in the context of the quick pick. If you change one keybinding for this command, you should change all of the other keybindings (modifier variants) of this command as well.")
    }
};
function registerQuickPickCommandAndKeybindingRule(rule, options = {}) {
    (0, _keybindingsRegistryJs.KeybindingsRegistry).registerCommandAndKeybindingRule({
        ...defaultCommandAndKeybindingRule,
        ...rule,
        secondary: getSecondary(rule.primary, rule.secondary ?? [], options)
    });
}
const ctrlKeyMod = (0, _platformJs.isMacintosh) ? 256 /* KeyMod.WinCtrl */  : 2048 /* KeyMod.CtrlCmd */ ;
// This function will generate all the combinations of keybindings for the given primary keybinding
function getSecondary(primary, secondary, options = {}) {
    if (options.withAltMod) secondary.push(512 /* KeyMod.Alt */  + primary);
    if (options.withCtrlMod) {
        secondary.push(ctrlKeyMod + primary);
        if (options.withAltMod) secondary.push(512 /* KeyMod.Alt */  + ctrlKeyMod + primary);
    }
    if (options.withCmdMod && (0, _platformJs.isMacintosh)) {
        secondary.push(2048 /* KeyMod.CtrlCmd */  + primary);
        if (options.withCtrlMod) secondary.push(2304 /* KeyMod.WinCtrl */  + primary);
        if (options.withAltMod) {
            secondary.push(2560 /* KeyMod.Alt */  + primary);
            if (options.withCtrlMod) secondary.push(2816 /* KeyMod.WinCtrl */  + primary);
        }
    }
    return secondary;
}
//#region Navigation
function focusHandler(focus, focusOnQuickNatigate) {
    return (accessor)=>{
        // Assuming this is a quick pick due to above when clause
        const currentQuickPick = accessor.get((0, _quickInputJs1.IQuickInputService)).currentQuickInput;
        if (!currentQuickPick) return;
        if (focusOnQuickNatigate && currentQuickPick.quickNavigate) return currentQuickPick.focus(focusOnQuickNatigate);
        return currentQuickPick.focus(focus);
    };
}
registerQuickPickCommandAndKeybindingRule({
    id: "quickInput.pageNext",
    primary: 12 /* KeyCode.PageDown */ ,
    handler: focusHandler((0, _quickInputJs1.QuickPickFocus).NextPage)
}, {
    withAltMod: true,
    withCtrlMod: true,
    withCmdMod: true
});
registerQuickPickCommandAndKeybindingRule({
    id: "quickInput.pagePrevious",
    primary: 11 /* KeyCode.PageUp */ ,
    handler: focusHandler((0, _quickInputJs1.QuickPickFocus).PreviousPage)
}, {
    withAltMod: true,
    withCtrlMod: true,
    withCmdMod: true
});
registerQuickPickCommandAndKeybindingRule({
    id: "quickInput.first",
    primary: ctrlKeyMod + 14 /* KeyCode.Home */ ,
    handler: focusHandler((0, _quickInputJs1.QuickPickFocus).First)
}, {
    withAltMod: true,
    withCmdMod: true
});
registerQuickPickCommandAndKeybindingRule({
    id: "quickInput.last",
    primary: ctrlKeyMod + 13 /* KeyCode.End */ ,
    handler: focusHandler((0, _quickInputJs1.QuickPickFocus).Last)
}, {
    withAltMod: true,
    withCmdMod: true
});
registerQuickPickCommandAndKeybindingRule({
    id: "quickInput.next",
    primary: 18 /* KeyCode.DownArrow */ ,
    handler: focusHandler((0, _quickInputJs1.QuickPickFocus).Next)
}, {
    withCtrlMod: true
});
registerQuickPickCommandAndKeybindingRule({
    id: "quickInput.previous",
    primary: 16 /* KeyCode.UpArrow */ ,
    handler: focusHandler((0, _quickInputJs1.QuickPickFocus).Previous)
}, {
    withCtrlMod: true
});
// The next & previous separator commands are interesting because if we are in quick access mode, we are already holding a modifier key down.
// In this case, we want that modifier key+up/down to navigate to the next/previous item, not the next/previous separator.
// To handle this, we have a separate command for navigating to the next/previous separator when we are not in quick access mode.
// If, however, we are in quick access mode, and you hold down an additional modifier key, we will navigate to the next/previous separator.
const nextSeparatorFallbackDesc = (0, _nlsJs.localize)("quickInput.nextSeparatorWithQuickAccessFallback", "If we're in quick access mode, this will navigate to the next item. If we are not in quick access mode, this will navigate to the next separator.");
const prevSeparatorFallbackDesc = (0, _nlsJs.localize)("quickInput.previousSeparatorWithQuickAccessFallback", "If we're in quick access mode, this will navigate to the previous item. If we are not in quick access mode, this will navigate to the previous separator.");
if (0, _platformJs.isMacintosh) {
    registerQuickPickCommandAndKeybindingRule({
        id: "quickInput.nextSeparatorWithQuickAccessFallback",
        primary: 2066 /* KeyCode.DownArrow */ ,
        handler: focusHandler((0, _quickInputJs1.QuickPickFocus).NextSeparator, (0, _quickInputJs1.QuickPickFocus).Next),
        metadata: {
            description: nextSeparatorFallbackDesc
        }
    });
    registerQuickPickCommandAndKeybindingRule({
        id: "quickInput.nextSeparator",
        primary: 2578 /* KeyCode.DownArrow */ ,
        // Since macOS has the cmd key as the primary modifier, we need to add this additional
        // keybinding to capture cmd+ctrl+upArrow
        secondary: [
            2322 /* KeyCode.DownArrow */ 
        ],
        handler: focusHandler((0, _quickInputJs1.QuickPickFocus).NextSeparator)
    }, {
        withCtrlMod: true
    });
    registerQuickPickCommandAndKeybindingRule({
        id: "quickInput.previousSeparatorWithQuickAccessFallback",
        primary: 2064 /* KeyCode.UpArrow */ ,
        handler: focusHandler((0, _quickInputJs1.QuickPickFocus).PreviousSeparator, (0, _quickInputJs1.QuickPickFocus).Previous),
        metadata: {
            description: prevSeparatorFallbackDesc
        }
    });
    registerQuickPickCommandAndKeybindingRule({
        id: "quickInput.previousSeparator",
        primary: 2576 /* KeyCode.UpArrow */ ,
        // Since macOS has the cmd key as the primary modifier, we need to add this additional
        // keybinding to capture cmd+ctrl+upArrow
        secondary: [
            2320 /* KeyCode.UpArrow */ 
        ],
        handler: focusHandler((0, _quickInputJs1.QuickPickFocus).PreviousSeparator)
    }, {
        withCtrlMod: true
    });
} else {
    registerQuickPickCommandAndKeybindingRule({
        id: "quickInput.nextSeparatorWithQuickAccessFallback",
        primary: 530 /* KeyCode.DownArrow */ ,
        handler: focusHandler((0, _quickInputJs1.QuickPickFocus).NextSeparator, (0, _quickInputJs1.QuickPickFocus).Next),
        metadata: {
            description: nextSeparatorFallbackDesc
        }
    });
    registerQuickPickCommandAndKeybindingRule({
        id: "quickInput.nextSeparator",
        primary: 2578 /* KeyCode.DownArrow */ ,
        handler: focusHandler((0, _quickInputJs1.QuickPickFocus).NextSeparator)
    });
    registerQuickPickCommandAndKeybindingRule({
        id: "quickInput.previousSeparatorWithQuickAccessFallback",
        primary: 528 /* KeyCode.UpArrow */ ,
        handler: focusHandler((0, _quickInputJs1.QuickPickFocus).PreviousSeparator, (0, _quickInputJs1.QuickPickFocus).Previous),
        metadata: {
            description: prevSeparatorFallbackDesc
        }
    });
    registerQuickPickCommandAndKeybindingRule({
        id: "quickInput.previousSeparator",
        primary: 2576 /* KeyCode.UpArrow */ ,
        handler: focusHandler((0, _quickInputJs1.QuickPickFocus).PreviousSeparator)
    });
}
//#endregion
//#region Accept
registerQuickPickCommandAndKeybindingRule({
    id: "quickInput.acceptInBackground",
    // If we are in the quick pick but the input box is not focused or our cursor is at the end of the input box
    when: (0, _contextkeyJs.ContextKeyExpr).and(defaultCommandAndKeybindingRule.when, (0, _contextkeyJs.ContextKeyExpr).or((0, _contextkeysJs.InputFocusedContext).negate(), (0, _quickInputJs.endOfQuickInputBoxContext))),
    primary: 17 /* KeyCode.RightArrow */ ,
    // Need a little extra weight to ensure this keybinding is preferred over the default cmd+alt+right arrow keybinding
    // https://github.com/microsoft/vscode/blob/1451e4fbbbf074a4355cc537c35b547b80ce1c52/src/vs/workbench/browser/parts/editor/editorActions.ts#L1178-L1195
    weight: 250,
    handler: (accessor)=>{
        const currentQuickPick = accessor.get((0, _quickInputJs1.IQuickInputService)).currentQuickInput;
        currentQuickPick?.accept(true);
    }
}, {
    withAltMod: true,
    withCtrlMod: true,
    withCmdMod: true
});

},{"../../../base/common/platform.js":"7maJO","../../../nls.js":"l617d","../../contextkey/common/contextkey.js":"gXuBD","../../contextkey/common/contextkeys.js":"jqcbi","../../keybinding/common/keybindingsRegistry.js":"h9qfk","./quickInput.js":"bmHRs","../common/quickInput.js":"a56M6"}],"kMN9g":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VS_LIGHT_THEME_NAME", ()=>VS_LIGHT_THEME_NAME);
parcelHelpers.export(exports, "VS_DARK_THEME_NAME", ()=>VS_DARK_THEME_NAME);
parcelHelpers.export(exports, "HC_BLACK_THEME_NAME", ()=>HC_BLACK_THEME_NAME);
parcelHelpers.export(exports, "HC_LIGHT_THEME_NAME", ()=>HC_LIGHT_THEME_NAME);
parcelHelpers.export(exports, "StandaloneThemeService", ()=>StandaloneThemeService);
var _domJs = require("../../../base/browser/dom.js");
var _browserJs = require("../../../base/browser/browser.js");
var _colorJs = require("../../../base/common/color.js");
var _eventJs = require("../../../base/common/event.js");
var _languagesJs = require("../../common/languages.js");
var _encodedTokenAttributesJs = require("../../common/encodedTokenAttributes.js");
var _tokenizationJs = require("../../common/languages/supports/tokenization.js");
var _themesJs = require("../common/themes.js");
var _platformJs = require("../../../platform/registry/common/platform.js");
var _colorRegistryJs = require("../../../platform/theme/common/colorRegistry.js");
var _themeServiceJs = require("../../../platform/theme/common/themeService.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _themeJs = require("../../../platform/theme/common/theme.js");
var _iconsStyleSheetJs = require("../../../platform/theme/browser/iconsStyleSheet.js");
var _windowJs = require("../../../base/browser/window.js");
const VS_LIGHT_THEME_NAME = "vs";
const VS_DARK_THEME_NAME = "vs-dark";
const HC_BLACK_THEME_NAME = "hc-black";
const HC_LIGHT_THEME_NAME = "hc-light";
const colorRegistry = (0, _platformJs.Registry).as((0, _colorRegistryJs.Extensions).ColorContribution);
const themingRegistry = (0, _platformJs.Registry).as((0, _themeServiceJs.Extensions).ThemingContribution);
class StandaloneTheme {
    constructor(name, standaloneThemeData){
        this.semanticHighlighting = false;
        this.themeData = standaloneThemeData;
        const base = standaloneThemeData.base;
        if (name.length > 0) {
            if (isBuiltinTheme(name)) this.id = name;
            else this.id = base + " " + name;
            this.themeName = name;
        } else {
            this.id = base;
            this.themeName = base;
        }
        this.colors = null;
        this.defaultColors = Object.create(null);
        this._tokenTheme = null;
    }
    get base() {
        return this.themeData.base;
    }
    notifyBaseUpdated() {
        if (this.themeData.inherit) {
            this.colors = null;
            this._tokenTheme = null;
        }
    }
    getColors() {
        if (!this.colors) {
            const colors = new Map();
            for(const id in this.themeData.colors)colors.set(id, (0, _colorJs.Color).fromHex(this.themeData.colors[id]));
            if (this.themeData.inherit) {
                const baseData = getBuiltinRules(this.themeData.base);
                for(const id in baseData.colors)if (!colors.has(id)) colors.set(id, (0, _colorJs.Color).fromHex(baseData.colors[id]));
            }
            this.colors = colors;
        }
        return this.colors;
    }
    getColor(colorId, useDefault) {
        const color = this.getColors().get(colorId);
        if (color) return color;
        if (useDefault !== false) return this.getDefault(colorId);
        return undefined;
    }
    getDefault(colorId) {
        let color = this.defaultColors[colorId];
        if (color) return color;
        color = colorRegistry.resolveDefaultColor(colorId, this);
        this.defaultColors[colorId] = color;
        return color;
    }
    defines(colorId) {
        return this.getColors().has(colorId);
    }
    get type() {
        switch(this.base){
            case VS_LIGHT_THEME_NAME:
                return (0, _themeJs.ColorScheme).LIGHT;
            case HC_BLACK_THEME_NAME:
                return (0, _themeJs.ColorScheme).HIGH_CONTRAST_DARK;
            case HC_LIGHT_THEME_NAME:
                return (0, _themeJs.ColorScheme).HIGH_CONTRAST_LIGHT;
            default:
                return (0, _themeJs.ColorScheme).DARK;
        }
    }
    get tokenTheme() {
        if (!this._tokenTheme) {
            let rules = [];
            let encodedTokensColors = [];
            if (this.themeData.inherit) {
                const baseData = getBuiltinRules(this.themeData.base);
                rules = baseData.rules;
                if (baseData.encodedTokensColors) encodedTokensColors = baseData.encodedTokensColors;
            }
            // Pick up default colors from `editor.foreground` and `editor.background` if available
            const editorForeground = this.themeData.colors["editor.foreground"];
            const editorBackground = this.themeData.colors["editor.background"];
            if (editorForeground || editorBackground) {
                const rule = {
                    token: ""
                };
                if (editorForeground) rule.foreground = editorForeground;
                if (editorBackground) rule.background = editorBackground;
                rules.push(rule);
            }
            rules = rules.concat(this.themeData.rules);
            if (this.themeData.encodedTokensColors) encodedTokensColors = this.themeData.encodedTokensColors;
            this._tokenTheme = (0, _tokenizationJs.TokenTheme).createFromRawTokenTheme(rules, encodedTokensColors);
        }
        return this._tokenTheme;
    }
    getTokenStyleMetadata(type, modifiers, modelLanguage) {
        // use theme rules match
        const style = this.tokenTheme._match([
            type
        ].concat(modifiers).join("."));
        const metadata = style.metadata;
        const foreground = (0, _encodedTokenAttributesJs.TokenMetadata).getForeground(metadata);
        const fontStyle = (0, _encodedTokenAttributesJs.TokenMetadata).getFontStyle(metadata);
        return {
            foreground: foreground,
            italic: Boolean(fontStyle & 1 /* FontStyle.Italic */ ),
            bold: Boolean(fontStyle & 2 /* FontStyle.Bold */ ),
            underline: Boolean(fontStyle & 4 /* FontStyle.Underline */ ),
            strikethrough: Boolean(fontStyle & 8 /* FontStyle.Strikethrough */ )
        };
    }
}
function isBuiltinTheme(themeName) {
    return themeName === VS_LIGHT_THEME_NAME || themeName === VS_DARK_THEME_NAME || themeName === HC_BLACK_THEME_NAME || themeName === HC_LIGHT_THEME_NAME;
}
function getBuiltinRules(builtinTheme) {
    switch(builtinTheme){
        case VS_LIGHT_THEME_NAME:
            return 0, _themesJs.vs;
        case VS_DARK_THEME_NAME:
            return 0, _themesJs.vs_dark;
        case HC_BLACK_THEME_NAME:
            return 0, _themesJs.hc_black;
        case HC_LIGHT_THEME_NAME:
            return 0, _themesJs.hc_light;
    }
}
function newBuiltInTheme(builtinTheme) {
    const themeData = getBuiltinRules(builtinTheme);
    return new StandaloneTheme(builtinTheme, themeData);
}
class StandaloneThemeService extends (0, _lifecycleJs.Disposable) {
    constructor(){
        super();
        this._onColorThemeChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidColorThemeChange = this._onColorThemeChange.event;
        this._onProductIconThemeChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidProductIconThemeChange = this._onProductIconThemeChange.event;
        this._environment = Object.create(null);
        this._builtInProductIconTheme = new (0, _iconsStyleSheetJs.UnthemedProductIconTheme)();
        this._autoDetectHighContrast = true;
        this._knownThemes = new Map();
        this._knownThemes.set(VS_LIGHT_THEME_NAME, newBuiltInTheme(VS_LIGHT_THEME_NAME));
        this._knownThemes.set(VS_DARK_THEME_NAME, newBuiltInTheme(VS_DARK_THEME_NAME));
        this._knownThemes.set(HC_BLACK_THEME_NAME, newBuiltInTheme(HC_BLACK_THEME_NAME));
        this._knownThemes.set(HC_LIGHT_THEME_NAME, newBuiltInTheme(HC_LIGHT_THEME_NAME));
        const iconsStyleSheet = this._register((0, _iconsStyleSheetJs.getIconsStyleSheet)(this));
        this._codiconCSS = iconsStyleSheet.getCSS();
        this._themeCSS = "";
        this._allCSS = `${this._codiconCSS}\n${this._themeCSS}`;
        this._globalStyleElement = null;
        this._styleElements = [];
        this._colorMapOverride = null;
        this.setTheme(VS_LIGHT_THEME_NAME);
        this._onOSSchemeChanged();
        this._register(iconsStyleSheet.onDidChange(()=>{
            this._codiconCSS = iconsStyleSheet.getCSS();
            this._updateCSS();
        }));
        (0, _browserJs.addMatchMediaChangeListener)((0, _windowJs.mainWindow), "(forced-colors: active)", ()=>{
            this._onOSSchemeChanged();
        });
    }
    registerEditorContainer(domNode) {
        if (_domJs.isInShadowDOM(domNode)) return this._registerShadowDomContainer(domNode);
        return this._registerRegularEditorContainer();
    }
    _registerRegularEditorContainer() {
        if (!this._globalStyleElement) {
            this._globalStyleElement = _domJs.createStyleSheet(undefined, (style)=>{
                style.className = "monaco-colors";
                style.textContent = this._allCSS;
            });
            this._styleElements.push(this._globalStyleElement);
        }
        return (0, _lifecycleJs.Disposable).None;
    }
    _registerShadowDomContainer(domNode) {
        const styleElement = _domJs.createStyleSheet(domNode, (style)=>{
            style.className = "monaco-colors";
            style.textContent = this._allCSS;
        });
        this._styleElements.push(styleElement);
        return {
            dispose: ()=>{
                for(let i = 0; i < this._styleElements.length; i++)if (this._styleElements[i] === styleElement) {
                    this._styleElements.splice(i, 1);
                    return;
                }
            }
        };
    }
    defineTheme(themeName, themeData) {
        if (!/^[a-z0-9\-]+$/i.test(themeName)) throw new Error("Illegal theme name!");
        if (!isBuiltinTheme(themeData.base) && !isBuiltinTheme(themeName)) throw new Error("Illegal theme base!");
        // set or replace theme
        this._knownThemes.set(themeName, new StandaloneTheme(themeName, themeData));
        if (isBuiltinTheme(themeName)) this._knownThemes.forEach((theme)=>{
            if (theme.base === themeName) theme.notifyBaseUpdated();
        });
        if (this._theme.themeName === themeName) this.setTheme(themeName); // refresh theme
    }
    getColorTheme() {
        return this._theme;
    }
    setColorMapOverride(colorMapOverride) {
        this._colorMapOverride = colorMapOverride;
        this._updateThemeOrColorMap();
    }
    setTheme(themeName) {
        let theme;
        if (this._knownThemes.has(themeName)) theme = this._knownThemes.get(themeName);
        else theme = this._knownThemes.get(VS_LIGHT_THEME_NAME);
        this._updateActualTheme(theme);
    }
    _updateActualTheme(desiredTheme) {
        if (!desiredTheme || this._theme === desiredTheme) // Nothing to do
        return;
        this._theme = desiredTheme;
        this._updateThemeOrColorMap();
    }
    _onOSSchemeChanged() {
        if (this._autoDetectHighContrast) {
            const wantsHighContrast = (0, _windowJs.mainWindow).matchMedia(`(forced-colors: active)`).matches;
            if (wantsHighContrast !== (0, _themeJs.isHighContrast)(this._theme.type)) {
                // switch to high contrast or non-high contrast but stick to dark or light
                let newThemeName;
                if ((0, _themeJs.isDark)(this._theme.type)) newThemeName = wantsHighContrast ? HC_BLACK_THEME_NAME : VS_DARK_THEME_NAME;
                else newThemeName = wantsHighContrast ? HC_LIGHT_THEME_NAME : VS_LIGHT_THEME_NAME;
                this._updateActualTheme(this._knownThemes.get(newThemeName));
            }
        }
    }
    setAutoDetectHighContrast(autoDetectHighContrast) {
        this._autoDetectHighContrast = autoDetectHighContrast;
        this._onOSSchemeChanged();
    }
    _updateThemeOrColorMap() {
        const cssRules = [];
        const hasRule = {};
        const ruleCollector = {
            addRule: (rule)=>{
                if (!hasRule[rule]) {
                    cssRules.push(rule);
                    hasRule[rule] = true;
                }
            }
        };
        themingRegistry.getThemingParticipants().forEach((p)=>p(this._theme, ruleCollector, this._environment));
        const colorVariables = [];
        for (const item of colorRegistry.getColors()){
            const color = this._theme.getColor(item.id, true);
            if (color) colorVariables.push(`${(0, _colorRegistryJs.asCssVariableName)(item.id)}: ${color.toString()};`);
        }
        ruleCollector.addRule(`.monaco-editor, .monaco-diff-editor, .monaco-component { ${colorVariables.join("\n")} }`);
        const colorMap = this._colorMapOverride || this._theme.tokenTheme.getColorMap();
        ruleCollector.addRule((0, _tokenizationJs.generateTokensCSSForColorMap)(colorMap));
        this._themeCSS = cssRules.join("\n");
        this._updateCSS();
        (0, _languagesJs.TokenizationRegistry).setColorMap(colorMap);
        this._onColorThemeChange.fire(this._theme);
    }
    _updateCSS() {
        this._allCSS = `${this._codiconCSS}\n${this._themeCSS}`;
        this._styleElements.forEach((styleElement)=>styleElement.textContent = this._allCSS);
    }
    getFileIconTheme() {
        return {
            hasFileIcons: false,
            hasFolderIcons: false,
            hidesExplorerArrows: false
        };
    }
    getProductIconTheme() {
        return this._builtInProductIconTheme;
    }
}

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/browser.js":"4Zquf","../../../base/common/color.js":"at4gb","../../../base/common/event.js":"4Zi8b","../../common/languages.js":"g5n96","../../common/encodedTokenAttributes.js":"eH8EQ","../../common/languages/supports/tokenization.js":"f4h6N","../common/themes.js":"1r40h","../../../platform/registry/common/platform.js":"dzx11","../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../platform/theme/common/themeService.js":"jMkIC","../../../base/common/lifecycle.js":"9kg8d","../../../platform/theme/common/theme.js":"gh7Zf","../../../platform/theme/browser/iconsStyleSheet.js":"bexxn","../../../base/browser/window.js":"aJBhQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f4h6N":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParsedTokenThemeRule", ()=>ParsedTokenThemeRule);
/**
 * Parse a raw theme into rules.
 */ parcelHelpers.export(exports, "parseTokenTheme", ()=>parseTokenTheme);
parcelHelpers.export(exports, "ColorMap", ()=>ColorMap);
parcelHelpers.export(exports, "TokenTheme", ()=>TokenTheme);
parcelHelpers.export(exports, "toStandardTokenType", ()=>toStandardTokenType);
parcelHelpers.export(exports, "strcmp", ()=>strcmp);
parcelHelpers.export(exports, "ThemeTrieElementRule", ()=>ThemeTrieElementRule);
parcelHelpers.export(exports, "ThemeTrieElement", ()=>ThemeTrieElement);
parcelHelpers.export(exports, "generateTokensCSSForColorMap", ()=>generateTokensCSSForColorMap);
var _colorJs = require("../../../../base/common/color.js");
class ParsedTokenThemeRule {
    constructor(token, index, fontStyle, foreground, background){
        this._parsedThemeRuleBrand = undefined;
        this.token = token;
        this.index = index;
        this.fontStyle = fontStyle;
        this.foreground = foreground;
        this.background = background;
    }
}
function parseTokenTheme(source) {
    if (!source || !Array.isArray(source)) return [];
    const result = [];
    let resultLen = 0;
    for(let i = 0, len = source.length; i < len; i++){
        const entry = source[i];
        let fontStyle = -1 /* FontStyle.NotSet */ ;
        if (typeof entry.fontStyle === "string") {
            fontStyle = 0 /* FontStyle.None */ ;
            const segments = entry.fontStyle.split(" ");
            for(let j = 0, lenJ = segments.length; j < lenJ; j++){
                const segment = segments[j];
                switch(segment){
                    case "italic":
                        fontStyle = fontStyle | 1 /* FontStyle.Italic */ ;
                        break;
                    case "bold":
                        fontStyle = fontStyle | 2 /* FontStyle.Bold */ ;
                        break;
                    case "underline":
                        fontStyle = fontStyle | 4 /* FontStyle.Underline */ ;
                        break;
                    case "strikethrough":
                        fontStyle = fontStyle | 8 /* FontStyle.Strikethrough */ ;
                        break;
                }
            }
        }
        let foreground = null;
        if (typeof entry.foreground === "string") foreground = entry.foreground;
        let background = null;
        if (typeof entry.background === "string") background = entry.background;
        result[resultLen++] = new ParsedTokenThemeRule(entry.token || "", i, fontStyle, foreground, background);
    }
    return result;
}
/**
 * Resolve rules (i.e. inheritance).
 */ function resolveParsedTokenThemeRules(parsedThemeRules, customTokenColors) {
    // Sort rules lexicographically, and then by index if necessary
    parsedThemeRules.sort((a, b)=>{
        const r = strcmp(a.token, b.token);
        if (r !== 0) return r;
        return a.index - b.index;
    });
    // Determine defaults
    let defaultFontStyle = 0 /* FontStyle.None */ ;
    let defaultForeground = "000000";
    let defaultBackground = "ffffff";
    while(parsedThemeRules.length >= 1 && parsedThemeRules[0].token === ""){
        const incomingDefaults = parsedThemeRules.shift();
        if (incomingDefaults.fontStyle !== -1 /* FontStyle.NotSet */ ) defaultFontStyle = incomingDefaults.fontStyle;
        if (incomingDefaults.foreground !== null) defaultForeground = incomingDefaults.foreground;
        if (incomingDefaults.background !== null) defaultBackground = incomingDefaults.background;
    }
    const colorMap = new ColorMap();
    // start with token colors from custom token themes
    for (const color of customTokenColors)colorMap.getId(color);
    const foregroundColorId = colorMap.getId(defaultForeground);
    const backgroundColorId = colorMap.getId(defaultBackground);
    const defaults = new ThemeTrieElementRule(defaultFontStyle, foregroundColorId, backgroundColorId);
    const root = new ThemeTrieElement(defaults);
    for(let i = 0, len = parsedThemeRules.length; i < len; i++){
        const rule = parsedThemeRules[i];
        root.insert(rule.token, rule.fontStyle, colorMap.getId(rule.foreground), colorMap.getId(rule.background));
    }
    return new TokenTheme(colorMap, root);
}
const colorRegExp = /^#?([0-9A-Fa-f]{6})([0-9A-Fa-f]{2})?$/;
class ColorMap {
    constructor(){
        this._lastColorId = 0;
        this._id2color = [];
        this._color2id = new Map();
    }
    getId(color) {
        if (color === null) return 0;
        const match = color.match(colorRegExp);
        if (!match) throw new Error("Illegal value for token color: " + color);
        color = match[1].toUpperCase();
        let value = this._color2id.get(color);
        if (value) return value;
        value = ++this._lastColorId;
        this._color2id.set(color, value);
        this._id2color[value] = (0, _colorJs.Color).fromHex("#" + color);
        return value;
    }
    getColorMap() {
        return this._id2color.slice(0);
    }
}
class TokenTheme {
    static createFromRawTokenTheme(source, customTokenColors) {
        return this.createFromParsedTokenTheme(parseTokenTheme(source), customTokenColors);
    }
    static createFromParsedTokenTheme(source, customTokenColors) {
        return resolveParsedTokenThemeRules(source, customTokenColors);
    }
    constructor(colorMap, root){
        this._colorMap = colorMap;
        this._root = root;
        this._cache = new Map();
    }
    getColorMap() {
        return this._colorMap.getColorMap();
    }
    _match(token) {
        return this._root.match(token);
    }
    match(languageId, token) {
        // The cache contains the metadata without the language bits set.
        let result = this._cache.get(token);
        if (typeof result === "undefined") {
            const rule = this._match(token);
            const standardToken = toStandardTokenType(token);
            result = (rule.metadata | standardToken << 8 /* MetadataConsts.TOKEN_TYPE_OFFSET */ ) >>> 0;
            this._cache.set(token, result);
        }
        return (result | languageId << 0 /* MetadataConsts.LANGUAGEID_OFFSET */ ) >>> 0;
    }
}
const STANDARD_TOKEN_TYPE_REGEXP = /\b(comment|string|regex|regexp)\b/;
function toStandardTokenType(tokenType) {
    const m = tokenType.match(STANDARD_TOKEN_TYPE_REGEXP);
    if (!m) return 0 /* StandardTokenType.Other */ ;
    switch(m[1]){
        case "comment":
            return 1 /* StandardTokenType.Comment */ ;
        case "string":
            return 2 /* StandardTokenType.String */ ;
        case "regex":
            return 3 /* StandardTokenType.RegEx */ ;
        case "regexp":
            return 3 /* StandardTokenType.RegEx */ ;
    }
    throw new Error("Unexpected match for standard token type!");
}
function strcmp(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
class ThemeTrieElementRule {
    constructor(fontStyle, foreground, background){
        this._themeTrieElementRuleBrand = undefined;
        this._fontStyle = fontStyle;
        this._foreground = foreground;
        this._background = background;
        this.metadata = (this._fontStyle << 11 /* MetadataConsts.FONT_STYLE_OFFSET */  | this._foreground << 15 /* MetadataConsts.FOREGROUND_OFFSET */  | this._background << 24 /* MetadataConsts.BACKGROUND_OFFSET */ ) >>> 0;
    }
    clone() {
        return new ThemeTrieElementRule(this._fontStyle, this._foreground, this._background);
    }
    acceptOverwrite(fontStyle, foreground, background) {
        if (fontStyle !== -1 /* FontStyle.NotSet */ ) this._fontStyle = fontStyle;
        if (foreground !== 0 /* ColorId.None */ ) this._foreground = foreground;
        if (background !== 0 /* ColorId.None */ ) this._background = background;
        this.metadata = (this._fontStyle << 11 /* MetadataConsts.FONT_STYLE_OFFSET */  | this._foreground << 15 /* MetadataConsts.FOREGROUND_OFFSET */  | this._background << 24 /* MetadataConsts.BACKGROUND_OFFSET */ ) >>> 0;
    }
}
class ThemeTrieElement {
    constructor(mainRule){
        this._themeTrieElementBrand = undefined;
        this._mainRule = mainRule;
        this._children = new Map();
    }
    match(token) {
        if (token === "") return this._mainRule;
        const dotIndex = token.indexOf(".");
        let head;
        let tail;
        if (dotIndex === -1) {
            head = token;
            tail = "";
        } else {
            head = token.substring(0, dotIndex);
            tail = token.substring(dotIndex + 1);
        }
        const child = this._children.get(head);
        if (typeof child !== "undefined") return child.match(tail);
        return this._mainRule;
    }
    insert(token, fontStyle, foreground, background) {
        if (token === "") {
            // Merge into the main rule
            this._mainRule.acceptOverwrite(fontStyle, foreground, background);
            return;
        }
        const dotIndex = token.indexOf(".");
        let head;
        let tail;
        if (dotIndex === -1) {
            head = token;
            tail = "";
        } else {
            head = token.substring(0, dotIndex);
            tail = token.substring(dotIndex + 1);
        }
        let child = this._children.get(head);
        if (typeof child === "undefined") {
            child = new ThemeTrieElement(this._mainRule.clone());
            this._children.set(head, child);
        }
        child.insert(tail, fontStyle, foreground, background);
    }
}
function generateTokensCSSForColorMap(colorMap) {
    const rules = [];
    for(let i = 1, len = colorMap.length; i < len; i++){
        const color = colorMap[i];
        rules[i] = `.mtk${i} { color: ${color}; }`;
    }
    rules.push(".mtki { font-style: italic; }");
    rules.push(".mtkb { font-weight: bold; }");
    rules.push(".mtku { text-decoration: underline; text-underline-position: under; }");
    rules.push(".mtks { text-decoration: line-through; }");
    rules.push(".mtks.mtku { text-decoration: underline line-through; text-underline-position: under; }");
    return rules.join("\n");
}

},{"../../../../base/common/color.js":"at4gb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1r40h":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vs", ()=>vs);
parcelHelpers.export(exports, "vs_dark", ()=>vs_dark);
parcelHelpers.export(exports, "hc_black", ()=>hc_black);
parcelHelpers.export(exports, "hc_light", ()=>hc_light);
var _editorColorRegistryJs = require("../../common/core/editorColorRegistry.js");
var _colorRegistryJs = require("../../../platform/theme/common/colorRegistry.js");
const vs = {
    base: "vs",
    inherit: false,
    rules: [
        {
            token: "",
            foreground: "000000",
            background: "fffffe"
        },
        {
            token: "invalid",
            foreground: "cd3131"
        },
        {
            token: "emphasis",
            fontStyle: "italic"
        },
        {
            token: "strong",
            fontStyle: "bold"
        },
        {
            token: "variable",
            foreground: "001188"
        },
        {
            token: "variable.predefined",
            foreground: "4864AA"
        },
        {
            token: "constant",
            foreground: "dd0000"
        },
        {
            token: "comment",
            foreground: "008000"
        },
        {
            token: "number",
            foreground: "098658"
        },
        {
            token: "number.hex",
            foreground: "3030c0"
        },
        {
            token: "regexp",
            foreground: "800000"
        },
        {
            token: "annotation",
            foreground: "808080"
        },
        {
            token: "type",
            foreground: "008080"
        },
        {
            token: "delimiter",
            foreground: "000000"
        },
        {
            token: "delimiter.html",
            foreground: "383838"
        },
        {
            token: "delimiter.xml",
            foreground: "0000FF"
        },
        {
            token: "tag",
            foreground: "800000"
        },
        {
            token: "tag.id.pug",
            foreground: "4F76AC"
        },
        {
            token: "tag.class.pug",
            foreground: "4F76AC"
        },
        {
            token: "meta.scss",
            foreground: "800000"
        },
        {
            token: "metatag",
            foreground: "e00000"
        },
        {
            token: "metatag.content.html",
            foreground: "FF0000"
        },
        {
            token: "metatag.html",
            foreground: "808080"
        },
        {
            token: "metatag.xml",
            foreground: "808080"
        },
        {
            token: "metatag.php",
            fontStyle: "bold"
        },
        {
            token: "key",
            foreground: "863B00"
        },
        {
            token: "string.key.json",
            foreground: "A31515"
        },
        {
            token: "string.value.json",
            foreground: "0451A5"
        },
        {
            token: "attribute.name",
            foreground: "FF0000"
        },
        {
            token: "attribute.value",
            foreground: "0451A5"
        },
        {
            token: "attribute.value.number",
            foreground: "098658"
        },
        {
            token: "attribute.value.unit",
            foreground: "098658"
        },
        {
            token: "attribute.value.html",
            foreground: "0000FF"
        },
        {
            token: "attribute.value.xml",
            foreground: "0000FF"
        },
        {
            token: "string",
            foreground: "A31515"
        },
        {
            token: "string.html",
            foreground: "0000FF"
        },
        {
            token: "string.sql",
            foreground: "FF0000"
        },
        {
            token: "string.yaml",
            foreground: "0451A5"
        },
        {
            token: "keyword",
            foreground: "0000FF"
        },
        {
            token: "keyword.json",
            foreground: "0451A5"
        },
        {
            token: "keyword.flow",
            foreground: "AF00DB"
        },
        {
            token: "keyword.flow.scss",
            foreground: "0000FF"
        },
        {
            token: "operator.scss",
            foreground: "666666"
        },
        {
            token: "operator.sql",
            foreground: "778899"
        },
        {
            token: "operator.swift",
            foreground: "666666"
        },
        {
            token: "predefined.sql",
            foreground: "C700C7"
        }
    ],
    colors: {
        [(0, _colorRegistryJs.editorBackground)]: "#FFFFFE",
        [(0, _colorRegistryJs.editorForeground)]: "#000000",
        [(0, _colorRegistryJs.editorInactiveSelection)]: "#E5EBF1",
        [(0, _editorColorRegistryJs.editorIndentGuide1)]: "#D3D3D3",
        [(0, _editorColorRegistryJs.editorActiveIndentGuide1)]: "#939393",
        [(0, _colorRegistryJs.editorSelectionHighlight)]: "#ADD6FF4D"
    }
};
const vs_dark = {
    base: "vs-dark",
    inherit: false,
    rules: [
        {
            token: "",
            foreground: "D4D4D4",
            background: "1E1E1E"
        },
        {
            token: "invalid",
            foreground: "f44747"
        },
        {
            token: "emphasis",
            fontStyle: "italic"
        },
        {
            token: "strong",
            fontStyle: "bold"
        },
        {
            token: "variable",
            foreground: "74B0DF"
        },
        {
            token: "variable.predefined",
            foreground: "4864AA"
        },
        {
            token: "variable.parameter",
            foreground: "9CDCFE"
        },
        {
            token: "constant",
            foreground: "569CD6"
        },
        {
            token: "comment",
            foreground: "608B4E"
        },
        {
            token: "number",
            foreground: "B5CEA8"
        },
        {
            token: "number.hex",
            foreground: "5BB498"
        },
        {
            token: "regexp",
            foreground: "B46695"
        },
        {
            token: "annotation",
            foreground: "cc6666"
        },
        {
            token: "type",
            foreground: "3DC9B0"
        },
        {
            token: "delimiter",
            foreground: "DCDCDC"
        },
        {
            token: "delimiter.html",
            foreground: "808080"
        },
        {
            token: "delimiter.xml",
            foreground: "808080"
        },
        {
            token: "tag",
            foreground: "569CD6"
        },
        {
            token: "tag.id.pug",
            foreground: "4F76AC"
        },
        {
            token: "tag.class.pug",
            foreground: "4F76AC"
        },
        {
            token: "meta.scss",
            foreground: "A79873"
        },
        {
            token: "meta.tag",
            foreground: "CE9178"
        },
        {
            token: "metatag",
            foreground: "DD6A6F"
        },
        {
            token: "metatag.content.html",
            foreground: "9CDCFE"
        },
        {
            token: "metatag.html",
            foreground: "569CD6"
        },
        {
            token: "metatag.xml",
            foreground: "569CD6"
        },
        {
            token: "metatag.php",
            fontStyle: "bold"
        },
        {
            token: "key",
            foreground: "9CDCFE"
        },
        {
            token: "string.key.json",
            foreground: "9CDCFE"
        },
        {
            token: "string.value.json",
            foreground: "CE9178"
        },
        {
            token: "attribute.name",
            foreground: "9CDCFE"
        },
        {
            token: "attribute.value",
            foreground: "CE9178"
        },
        {
            token: "attribute.value.number.css",
            foreground: "B5CEA8"
        },
        {
            token: "attribute.value.unit.css",
            foreground: "B5CEA8"
        },
        {
            token: "attribute.value.hex.css",
            foreground: "D4D4D4"
        },
        {
            token: "string",
            foreground: "CE9178"
        },
        {
            token: "string.sql",
            foreground: "FF0000"
        },
        {
            token: "keyword",
            foreground: "569CD6"
        },
        {
            token: "keyword.flow",
            foreground: "C586C0"
        },
        {
            token: "keyword.json",
            foreground: "CE9178"
        },
        {
            token: "keyword.flow.scss",
            foreground: "569CD6"
        },
        {
            token: "operator.scss",
            foreground: "909090"
        },
        {
            token: "operator.sql",
            foreground: "778899"
        },
        {
            token: "operator.swift",
            foreground: "909090"
        },
        {
            token: "predefined.sql",
            foreground: "FF00FF"
        }
    ],
    colors: {
        [(0, _colorRegistryJs.editorBackground)]: "#1E1E1E",
        [(0, _colorRegistryJs.editorForeground)]: "#D4D4D4",
        [(0, _colorRegistryJs.editorInactiveSelection)]: "#3A3D41",
        [(0, _editorColorRegistryJs.editorIndentGuide1)]: "#404040",
        [(0, _editorColorRegistryJs.editorActiveIndentGuide1)]: "#707070",
        [(0, _colorRegistryJs.editorSelectionHighlight)]: "#ADD6FF26"
    }
};
const hc_black = {
    base: "hc-black",
    inherit: false,
    rules: [
        {
            token: "",
            foreground: "FFFFFF",
            background: "000000"
        },
        {
            token: "invalid",
            foreground: "f44747"
        },
        {
            token: "emphasis",
            fontStyle: "italic"
        },
        {
            token: "strong",
            fontStyle: "bold"
        },
        {
            token: "variable",
            foreground: "1AEBFF"
        },
        {
            token: "variable.parameter",
            foreground: "9CDCFE"
        },
        {
            token: "constant",
            foreground: "569CD6"
        },
        {
            token: "comment",
            foreground: "608B4E"
        },
        {
            token: "number",
            foreground: "FFFFFF"
        },
        {
            token: "regexp",
            foreground: "C0C0C0"
        },
        {
            token: "annotation",
            foreground: "569CD6"
        },
        {
            token: "type",
            foreground: "3DC9B0"
        },
        {
            token: "delimiter",
            foreground: "FFFF00"
        },
        {
            token: "delimiter.html",
            foreground: "FFFF00"
        },
        {
            token: "tag",
            foreground: "569CD6"
        },
        {
            token: "tag.id.pug",
            foreground: "4F76AC"
        },
        {
            token: "tag.class.pug",
            foreground: "4F76AC"
        },
        {
            token: "meta",
            foreground: "D4D4D4"
        },
        {
            token: "meta.tag",
            foreground: "CE9178"
        },
        {
            token: "metatag",
            foreground: "569CD6"
        },
        {
            token: "metatag.content.html",
            foreground: "1AEBFF"
        },
        {
            token: "metatag.html",
            foreground: "569CD6"
        },
        {
            token: "metatag.xml",
            foreground: "569CD6"
        },
        {
            token: "metatag.php",
            fontStyle: "bold"
        },
        {
            token: "key",
            foreground: "9CDCFE"
        },
        {
            token: "string.key",
            foreground: "9CDCFE"
        },
        {
            token: "string.value",
            foreground: "CE9178"
        },
        {
            token: "attribute.name",
            foreground: "569CD6"
        },
        {
            token: "attribute.value",
            foreground: "3FF23F"
        },
        {
            token: "string",
            foreground: "CE9178"
        },
        {
            token: "string.sql",
            foreground: "FF0000"
        },
        {
            token: "keyword",
            foreground: "569CD6"
        },
        {
            token: "keyword.flow",
            foreground: "C586C0"
        },
        {
            token: "operator.sql",
            foreground: "778899"
        },
        {
            token: "operator.swift",
            foreground: "909090"
        },
        {
            token: "predefined.sql",
            foreground: "FF00FF"
        }
    ],
    colors: {
        [(0, _colorRegistryJs.editorBackground)]: "#000000",
        [(0, _colorRegistryJs.editorForeground)]: "#FFFFFF",
        [(0, _editorColorRegistryJs.editorIndentGuide1)]: "#FFFFFF",
        [(0, _editorColorRegistryJs.editorActiveIndentGuide1)]: "#FFFFFF"
    }
};
const hc_light = {
    base: "hc-light",
    inherit: false,
    rules: [
        {
            token: "",
            foreground: "292929",
            background: "FFFFFF"
        },
        {
            token: "invalid",
            foreground: "B5200D"
        },
        {
            token: "emphasis",
            fontStyle: "italic"
        },
        {
            token: "strong",
            fontStyle: "bold"
        },
        {
            token: "variable",
            foreground: "264F70"
        },
        {
            token: "variable.predefined",
            foreground: "4864AA"
        },
        {
            token: "constant",
            foreground: "dd0000"
        },
        {
            token: "comment",
            foreground: "008000"
        },
        {
            token: "number",
            foreground: "098658"
        },
        {
            token: "number.hex",
            foreground: "3030c0"
        },
        {
            token: "regexp",
            foreground: "800000"
        },
        {
            token: "annotation",
            foreground: "808080"
        },
        {
            token: "type",
            foreground: "008080"
        },
        {
            token: "delimiter",
            foreground: "000000"
        },
        {
            token: "delimiter.html",
            foreground: "383838"
        },
        {
            token: "tag",
            foreground: "800000"
        },
        {
            token: "tag.id.pug",
            foreground: "4F76AC"
        },
        {
            token: "tag.class.pug",
            foreground: "4F76AC"
        },
        {
            token: "meta.scss",
            foreground: "800000"
        },
        {
            token: "metatag",
            foreground: "e00000"
        },
        {
            token: "metatag.content.html",
            foreground: "B5200D"
        },
        {
            token: "metatag.html",
            foreground: "808080"
        },
        {
            token: "metatag.xml",
            foreground: "808080"
        },
        {
            token: "metatag.php",
            fontStyle: "bold"
        },
        {
            token: "key",
            foreground: "863B00"
        },
        {
            token: "string.key.json",
            foreground: "A31515"
        },
        {
            token: "string.value.json",
            foreground: "0451A5"
        },
        {
            token: "attribute.name",
            foreground: "264F78"
        },
        {
            token: "attribute.value",
            foreground: "0451A5"
        },
        {
            token: "string",
            foreground: "A31515"
        },
        {
            token: "string.sql",
            foreground: "B5200D"
        },
        {
            token: "keyword",
            foreground: "0000FF"
        },
        {
            token: "keyword.flow",
            foreground: "AF00DB"
        },
        {
            token: "operator.sql",
            foreground: "778899"
        },
        {
            token: "operator.swift",
            foreground: "666666"
        },
        {
            token: "predefined.sql",
            foreground: "C700C7"
        }
    ],
    colors: {
        [(0, _colorRegistryJs.editorBackground)]: "#FFFFFF",
        [(0, _colorRegistryJs.editorForeground)]: "#292929",
        [(0, _editorColorRegistryJs.editorIndentGuide1)]: "#292929",
        [(0, _editorColorRegistryJs.editorActiveIndentGuide1)]: "#292929"
    }
}; /* -------------------------------- End hc-light theme -------------------------------- */ 

},{"../../common/core/editorColorRegistry.js":"5XqtL","../../../platform/theme/common/colorRegistry.js":"ik5kv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bexxn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIconsStyleSheet", ()=>getIconsStyleSheet);
parcelHelpers.export(exports, "UnthemedProductIconTheme", ()=>UnthemedProductIconTheme);
var _domJs = require("../../../base/browser/dom.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _themablesJs = require("../../../base/common/themables.js");
var _iconRegistryJs = require("../common/iconRegistry.js");
function getIconsStyleSheet(themeService) {
    const disposable = new (0, _lifecycleJs.DisposableStore)();
    const onDidChangeEmmiter = disposable.add(new (0, _eventJs.Emitter)());
    const iconRegistry = (0, _iconRegistryJs.getIconRegistry)();
    disposable.add(iconRegistry.onDidChange(()=>onDidChangeEmmiter.fire()));
    if (themeService) disposable.add(themeService.onDidProductIconThemeChange(()=>onDidChangeEmmiter.fire()));
    return {
        dispose: ()=>disposable.dispose(),
        onDidChange: onDidChangeEmmiter.event,
        getCSS () {
            const productIconTheme = themeService ? themeService.getProductIconTheme() : new UnthemedProductIconTheme();
            const usedFontIds = {};
            const rules = [];
            const rootAttribs = [];
            for (const contribution of iconRegistry.getIcons()){
                const definition = productIconTheme.getIcon(contribution);
                if (!definition) continue;
                const fontContribution = definition.font;
                const fontFamilyVar = `--vscode-icon-${contribution.id}-font-family`;
                const contentVar = `--vscode-icon-${contribution.id}-content`;
                if (fontContribution) {
                    usedFontIds[fontContribution.id] = fontContribution.definition;
                    rootAttribs.push(`${fontFamilyVar}: ${(0, _domJs.asCSSPropertyValue)(fontContribution.id)};`, `${contentVar}: '${definition.fontCharacter}';`);
                    rules.push(`.codicon-${contribution.id}:before { content: '${definition.fontCharacter}'; font-family: ${(0, _domJs.asCSSPropertyValue)(fontContribution.id)}; }`);
                } else {
                    rootAttribs.push(`${contentVar}: '${definition.fontCharacter}'; ${fontFamilyVar}: 'codicon';`);
                    rules.push(`.codicon-${contribution.id}:before { content: '${definition.fontCharacter}'; }`);
                }
            }
            for(const id in usedFontIds){
                const definition = usedFontIds[id];
                const fontWeight = definition.weight ? `font-weight: ${definition.weight};` : "";
                const fontStyle = definition.style ? `font-style: ${definition.style};` : "";
                const src = definition.src.map((l)=>`${(0, _domJs.asCSSUrl)(l.location)} format('${l.format}')`).join(", ");
                rules.push(`@font-face { src: ${src}; font-family: ${(0, _domJs.asCSSPropertyValue)(id)};${fontWeight}${fontStyle} font-display: block; }`);
            }
            rules.push(`:root { ${rootAttribs.join(" ")} }`);
            return rules.join("\n");
        }
    };
}
class UnthemedProductIconTheme {
    getIcon(contribution) {
        const iconRegistry = (0, _iconRegistryJs.getIconRegistry)();
        let definition = contribution.defaults;
        while((0, _themablesJs.ThemeIcon).isThemeIcon(definition)){
            const c = iconRegistry.getIcon(definition.id);
            if (!c) return undefined;
            definition = c.defaults;
        }
        return definition;
    }
}

},{"../../../base/browser/dom.js":"bnqsM","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/themables.js":"hgyHi","../common/iconRegistry.js":"bRNEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bRNEz":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Extensions", ()=>Extensions);
parcelHelpers.export(exports, "IconContribution", ()=>IconContribution);
parcelHelpers.export(exports, "IconFontDefinition", ()=>IconFontDefinition);
parcelHelpers.export(exports, "registerIcon", ()=>registerIcon);
parcelHelpers.export(exports, "getIconRegistry", ()=>getIconRegistry);
parcelHelpers.export(exports, "iconsSchemaId", ()=>iconsSchemaId);
parcelHelpers.export(exports, "widgetClose", ()=>widgetClose);
parcelHelpers.export(exports, "gotoPreviousLocation", ()=>gotoPreviousLocation);
parcelHelpers.export(exports, "gotoNextLocation", ()=>gotoNextLocation);
parcelHelpers.export(exports, "syncing", ()=>syncing);
parcelHelpers.export(exports, "spinningLoading", ()=>spinningLoading);
var _asyncJs = require("../../../base/common/async.js");
var _codiconsJs = require("../../../base/common/codicons.js");
var _codiconsUtilJs = require("../../../base/common/codiconsUtil.js");
var _themablesJs = require("../../../base/common/themables.js");
var _eventJs = require("../../../base/common/event.js");
var _typesJs = require("../../../base/common/types.js");
var _uriJs = require("../../../base/common/uri.js");
var _nlsJs = require("../../../nls.js");
var _jsonContributionRegistryJs = require("../../jsonschemas/common/jsonContributionRegistry.js");
var _platformJs = require("../../registry/common/platform.js");
const Extensions = {
    IconContribution: "base.contributions.icons"
};
var IconContribution;
(function(IconContribution) {
    function getDefinition(contribution, registry) {
        let definition = contribution.defaults;
        while((0, _themablesJs.ThemeIcon).isThemeIcon(definition)){
            const c = iconRegistry.getIcon(definition.id);
            if (!c) return undefined;
            definition = c.defaults;
        }
        return definition;
    }
    IconContribution.getDefinition = getDefinition;
})(IconContribution || (IconContribution = {}));
var IconFontDefinition;
(function(IconFontDefinition) {
    function toJSONObject(iconFont) {
        return {
            weight: iconFont.weight,
            style: iconFont.style,
            src: iconFont.src.map((s)=>({
                    format: s.format,
                    location: s.location.toString()
                }))
        };
    }
    IconFontDefinition.toJSONObject = toJSONObject;
    function fromJSONObject(json) {
        const stringOrUndef = (s)=>(0, _typesJs.isString)(s) ? s : undefined;
        if (json && Array.isArray(json.src) && json.src.every((s)=>(0, _typesJs.isString)(s.format) && (0, _typesJs.isString)(s.location))) return {
            weight: stringOrUndef(json.weight),
            style: stringOrUndef(json.style),
            src: json.src.map((s)=>({
                    format: s.format,
                    location: (0, _uriJs.URI).parse(s.location)
                }))
        };
        return undefined;
    }
    IconFontDefinition.fromJSONObject = fromJSONObject;
})(IconFontDefinition || (IconFontDefinition = {}));
class IconRegistry {
    constructor(){
        this._onDidChange = new (0, _eventJs.Emitter)();
        this.onDidChange = this._onDidChange.event;
        this.iconSchema = {
            definitions: {
                icons: {
                    type: "object",
                    properties: {
                        fontId: {
                            type: "string",
                            description: (0, _nlsJs.localize)("iconDefinition.fontId", "The id of the font to use. If not set, the font that is defined first is used.")
                        },
                        fontCharacter: {
                            type: "string",
                            description: (0, _nlsJs.localize)("iconDefinition.fontCharacter", "The font character associated with the icon definition.")
                        }
                    },
                    additionalProperties: false,
                    defaultSnippets: [
                        {
                            body: {
                                fontCharacter: "\\\\e030"
                            }
                        }
                    ]
                }
            },
            type: "object",
            properties: {}
        };
        this.iconReferenceSchema = {
            type: "string",
            pattern: `^${(0, _themablesJs.ThemeIcon).iconNameExpression}$`,
            enum: [],
            enumDescriptions: []
        };
        this.iconsById = {};
        this.iconFontsById = {};
    }
    registerIcon(id, defaults, description, deprecationMessage) {
        const existing = this.iconsById[id];
        if (existing) {
            if (description && !existing.description) {
                existing.description = description;
                this.iconSchema.properties[id].markdownDescription = `${description} $(${id})`;
                const enumIndex = this.iconReferenceSchema.enum.indexOf(id);
                if (enumIndex !== -1) this.iconReferenceSchema.enumDescriptions[enumIndex] = description;
                this._onDidChange.fire();
            }
            return existing;
        }
        const iconContribution = {
            id,
            description,
            defaults,
            deprecationMessage
        };
        this.iconsById[id] = iconContribution;
        const propertySchema = {
            $ref: "#/definitions/icons"
        };
        if (deprecationMessage) propertySchema.deprecationMessage = deprecationMessage;
        if (description) propertySchema.markdownDescription = `${description}: $(${id})`;
        this.iconSchema.properties[id] = propertySchema;
        this.iconReferenceSchema.enum.push(id);
        this.iconReferenceSchema.enumDescriptions.push(description || "");
        this._onDidChange.fire();
        return {
            id
        };
    }
    getIcons() {
        return Object.keys(this.iconsById).map((id)=>this.iconsById[id]);
    }
    getIcon(id) {
        return this.iconsById[id];
    }
    getIconSchema() {
        return this.iconSchema;
    }
    toString() {
        const sorter = (i1, i2)=>{
            return i1.id.localeCompare(i2.id);
        };
        const classNames = (i)=>{
            while((0, _themablesJs.ThemeIcon).isThemeIcon(i.defaults))i = this.iconsById[i.defaults.id];
            return `codicon codicon-${i ? i.id : ""}`;
        };
        const reference = [];
        reference.push(`| preview     | identifier                        | default codicon ID                | description`);
        reference.push(`| ----------- | --------------------------------- | --------------------------------- | --------------------------------- |`);
        const contributions = Object.keys(this.iconsById).map((key)=>this.iconsById[key]);
        for (const i of contributions.filter((i)=>!!i.description).sort(sorter))reference.push(`|<i class="${classNames(i)}"></i>|${i.id}|${(0, _themablesJs.ThemeIcon).isThemeIcon(i.defaults) ? i.defaults.id : i.id}|${i.description || ""}|`);
        reference.push(`| preview     | identifier                        `);
        reference.push(`| ----------- | --------------------------------- |`);
        for (const i of contributions.filter((i)=>!(0, _themablesJs.ThemeIcon).isThemeIcon(i.defaults)).sort(sorter))reference.push(`|<i class="${classNames(i)}"></i>|${i.id}|`);
        return reference.join("\n");
    }
}
const iconRegistry = new IconRegistry();
_platformJs.Registry.add(Extensions.IconContribution, iconRegistry);
function registerIcon(id, defaults, description, deprecationMessage) {
    return iconRegistry.registerIcon(id, defaults, description, deprecationMessage);
}
function getIconRegistry() {
    return iconRegistry;
}
function initialize() {
    const codiconFontCharacters = (0, _codiconsUtilJs.getCodiconFontCharacters)();
    for(const icon in codiconFontCharacters){
        const fontCharacter = "\\" + codiconFontCharacters[icon].toString(16);
        iconRegistry.registerIcon(icon, {
            fontCharacter
        });
    }
}
initialize();
const iconsSchemaId = "vscode://schemas/icons";
const schemaRegistry = _platformJs.Registry.as((0, _jsonContributionRegistryJs.Extensions).JSONContribution);
schemaRegistry.registerSchema(iconsSchemaId, iconRegistry.getIconSchema());
const delayer = new (0, _asyncJs.RunOnceScheduler)(()=>schemaRegistry.notifySchemaChanged(iconsSchemaId), 200);
iconRegistry.onDidChange(()=>{
    if (!delayer.isScheduled()) delayer.schedule();
});
const widgetClose = registerIcon("widget-close", (0, _codiconsJs.Codicon).close, (0, _nlsJs.localize)("widgetClose", "Icon for the close action in widgets."));
const gotoPreviousLocation = registerIcon("goto-previous-location", (0, _codiconsJs.Codicon).arrowUp, (0, _nlsJs.localize)("previousChangeIcon", "Icon for goto previous editor location."));
const gotoNextLocation = registerIcon("goto-next-location", (0, _codiconsJs.Codicon).arrowDown, (0, _nlsJs.localize)("nextChangeIcon", "Icon for goto next editor location."));
const syncing = (0, _themablesJs.ThemeIcon).modify((0, _codiconsJs.Codicon).sync, "spin");
const spinningLoading = (0, _themablesJs.ThemeIcon).modify((0, _codiconsJs.Codicon).loading, "spin");

},{"../../../base/common/async.js":"4GJc4","../../../base/common/codicons.js":"hWYNf","../../../base/common/codiconsUtil.js":"6g8vy","../../../base/common/themables.js":"hgyHi","../../../base/common/event.js":"4Zi8b","../../../base/common/types.js":"fb5yx","../../../base/common/uri.js":"7qGS3","../../../nls.js":"l617d","../../jsonschemas/common/jsonContributionRegistry.js":"6LKe5","../../registry/common/platform.js":"dzx11","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"exW2E":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IStandaloneThemeService", ()=>IStandaloneThemeService);
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
const IStandaloneThemeService = (0, _instantiationJs.createDecorator)("themeService");

},{"../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3km7z":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessibilityService", ()=>AccessibilityService);
var _domJs = require("../../../base/browser/dom.js");
var _windowJs = require("../../../base/browser/window.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _accessibilityJs = require("../common/accessibility.js");
var _configurationJs = require("../../configuration/common/configuration.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _layoutServiceJs = require("../../layout/browser/layoutService.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let AccessibilityService = class AccessibilityService extends (0, _lifecycleJs.Disposable) {
    constructor(_contextKeyService, _layoutService, _configurationService){
        super();
        this._contextKeyService = _contextKeyService;
        this._layoutService = _layoutService;
        this._configurationService = _configurationService;
        this._accessibilitySupport = 0 /* AccessibilitySupport.Unknown */ ;
        this._onDidChangeScreenReaderOptimized = new (0, _eventJs.Emitter)();
        this._onDidChangeReducedMotion = new (0, _eventJs.Emitter)();
        this._onDidChangeLinkUnderline = new (0, _eventJs.Emitter)();
        this._accessibilityModeEnabledContext = (0, _accessibilityJs.CONTEXT_ACCESSIBILITY_MODE_ENABLED).bindTo(this._contextKeyService);
        const updateContextKey = ()=>this._accessibilityModeEnabledContext.set(this.isScreenReaderOptimized());
        this._register(this._configurationService.onDidChangeConfiguration((e)=>{
            if (e.affectsConfiguration("editor.accessibilitySupport")) {
                updateContextKey();
                this._onDidChangeScreenReaderOptimized.fire();
            }
            if (e.affectsConfiguration("workbench.reduceMotion")) {
                this._configMotionReduced = this._configurationService.getValue("workbench.reduceMotion");
                this._onDidChangeReducedMotion.fire();
            }
        }));
        updateContextKey();
        this._register(this.onDidChangeScreenReaderOptimized(()=>updateContextKey()));
        const reduceMotionMatcher = (0, _windowJs.mainWindow).matchMedia(`(prefers-reduced-motion: reduce)`);
        this._systemMotionReduced = reduceMotionMatcher.matches;
        this._configMotionReduced = this._configurationService.getValue("workbench.reduceMotion");
        this._linkUnderlinesEnabled = this._configurationService.getValue("accessibility.underlineLinks");
        this.initReducedMotionListeners(reduceMotionMatcher);
        this.initLinkUnderlineListeners();
    }
    initReducedMotionListeners(reduceMotionMatcher) {
        this._register((0, _domJs.addDisposableListener)(reduceMotionMatcher, "change", ()=>{
            this._systemMotionReduced = reduceMotionMatcher.matches;
            if (this._configMotionReduced === "auto") this._onDidChangeReducedMotion.fire();
        }));
        const updateRootClasses = ()=>{
            const reduce = this.isMotionReduced();
            this._layoutService.mainContainer.classList.toggle("reduce-motion", reduce);
            this._layoutService.mainContainer.classList.toggle("enable-motion", !reduce);
        };
        updateRootClasses();
        this._register(this.onDidChangeReducedMotion(()=>updateRootClasses()));
    }
    initLinkUnderlineListeners() {
        this._register(this._configurationService.onDidChangeConfiguration((e)=>{
            if (e.affectsConfiguration("accessibility.underlineLinks")) {
                const linkUnderlinesEnabled = this._configurationService.getValue("accessibility.underlineLinks");
                this._linkUnderlinesEnabled = linkUnderlinesEnabled;
                this._onDidChangeLinkUnderline.fire();
            }
        }));
        const updateLinkUnderlineClasses = ()=>{
            const underlineLinks = this._linkUnderlinesEnabled;
            this._layoutService.mainContainer.classList.toggle("underline-links", underlineLinks);
        };
        updateLinkUnderlineClasses();
        this._register(this.onDidChangeLinkUnderlines(()=>updateLinkUnderlineClasses()));
    }
    onDidChangeLinkUnderlines(listener) {
        return this._onDidChangeLinkUnderline.event(listener);
    }
    get onDidChangeScreenReaderOptimized() {
        return this._onDidChangeScreenReaderOptimized.event;
    }
    isScreenReaderOptimized() {
        const config = this._configurationService.getValue("editor.accessibilitySupport");
        return config === "on" || config === "auto" && this._accessibilitySupport === 2 /* AccessibilitySupport.Enabled */ ;
    }
    get onDidChangeReducedMotion() {
        return this._onDidChangeReducedMotion.event;
    }
    isMotionReduced() {
        const config = this._configMotionReduced;
        return config === "on" || config === "auto" && this._systemMotionReduced;
    }
    getAccessibilitySupport() {
        return this._accessibilitySupport;
    }
};
AccessibilityService = __decorate([
    __param(0, (0, _contextkeyJs.IContextKeyService)),
    __param(1, (0, _layoutServiceJs.ILayoutService)),
    __param(2, (0, _configurationJs.IConfigurationService))
], AccessibilityService);

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/window.js":"aJBhQ","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../common/accessibility.js":"9Svqy","../../configuration/common/configuration.js":"dXkjq","../../contextkey/common/contextkey.js":"gXuBD","../../layout/browser/layoutService.js":"fPPgf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ihaN":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuService", ()=>MenuService);
parcelHelpers.export(exports, "createConfigureKeybindingAction", ()=>createConfigureKeybindingAction);
var _asyncJs = require("../../../base/common/async.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _actionsJs = require("./actions.js");
var _commandsJs = require("../../commands/common/commands.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _actionsJs1 = require("../../../base/common/actions.js");
var _storageJs = require("../../storage/common/storage.js");
var _arraysJs = require("../../../base/common/arrays.js");
var _nlsJs = require("../../../nls.js");
var _keybindingJs = require("../../keybinding/common/keybinding.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var PersistedMenuHideState_1, MenuInfo_1;
let MenuService = class MenuService {
    constructor(_commandService, _keybindingService, storageService){
        this._commandService = _commandService;
        this._keybindingService = _keybindingService;
        this._hiddenStates = new PersistedMenuHideState(storageService);
    }
    createMenu(id, contextKeyService, options) {
        return new MenuImpl(id, this._hiddenStates, {
            emitEventsForSubmenuChanges: false,
            eventDebounceDelay: 50,
            ...options
        }, this._commandService, this._keybindingService, contextKeyService);
    }
    getMenuActions(id, contextKeyService, options) {
        const menu = new MenuImpl(id, this._hiddenStates, {
            emitEventsForSubmenuChanges: false,
            eventDebounceDelay: 50,
            ...options
        }, this._commandService, this._keybindingService, contextKeyService);
        const actions = menu.getActions(options);
        menu.dispose();
        return actions;
    }
    resetHiddenStates(ids) {
        this._hiddenStates.reset(ids);
    }
};
MenuService = __decorate([
    __param(0, (0, _commandsJs.ICommandService)),
    __param(1, (0, _keybindingJs.IKeybindingService)),
    __param(2, (0, _storageJs.IStorageService))
], MenuService);
let PersistedMenuHideState = class PersistedMenuHideState {
    static{
        PersistedMenuHideState_1 = this;
    }
    static{
        this._key = "menu.hiddenCommands";
    }
    constructor(_storageService){
        this._storageService = _storageService;
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._onDidChange = new (0, _eventJs.Emitter)();
        this.onDidChange = this._onDidChange.event;
        this._ignoreChangeEvent = false;
        this._hiddenByDefaultCache = new Map();
        try {
            const raw = _storageService.get(PersistedMenuHideState_1._key, 0 /* StorageScope.PROFILE */ , "{}");
            this._data = JSON.parse(raw);
        } catch (err) {
            this._data = Object.create(null);
        }
        this._disposables.add(_storageService.onDidChangeValue(0 /* StorageScope.PROFILE */ , PersistedMenuHideState_1._key, this._disposables)(()=>{
            if (!this._ignoreChangeEvent) try {
                const raw = _storageService.get(PersistedMenuHideState_1._key, 0 /* StorageScope.PROFILE */ , "{}");
                this._data = JSON.parse(raw);
            } catch (err) {
                console.log("FAILED to read storage after UPDATE", err);
            }
            this._onDidChange.fire();
        }));
    }
    dispose() {
        this._onDidChange.dispose();
        this._disposables.dispose();
    }
    _isHiddenByDefault(menu, commandId) {
        return this._hiddenByDefaultCache.get(`${menu.id}/${commandId}`) ?? false;
    }
    setDefaultState(menu, commandId, hidden) {
        this._hiddenByDefaultCache.set(`${menu.id}/${commandId}`, hidden);
    }
    isHidden(menu, commandId) {
        const hiddenByDefault = this._isHiddenByDefault(menu, commandId);
        const state = this._data[menu.id]?.includes(commandId) ?? false;
        return hiddenByDefault ? !state : state;
    }
    updateHidden(menu, commandId, hidden) {
        const hiddenByDefault = this._isHiddenByDefault(menu, commandId);
        if (hiddenByDefault) hidden = !hidden;
        const entries = this._data[menu.id];
        if (!hidden) // remove and cleanup
        {
            if (entries) {
                const idx = entries.indexOf(commandId);
                if (idx >= 0) (0, _arraysJs.removeFastWithoutKeepingOrder)(entries, idx);
                if (entries.length === 0) delete this._data[menu.id];
            }
        } else // add unless already added
        if (!entries) this._data[menu.id] = [
            commandId
        ];
        else {
            const idx = entries.indexOf(commandId);
            if (idx < 0) entries.push(commandId);
        }
        this._persist();
    }
    reset(menus) {
        if (menus === undefined) {
            // reset all
            this._data = Object.create(null);
            this._persist();
        } else {
            // reset only for a specific menu
            for (const { id } of menus)if (this._data[id]) delete this._data[id];
            this._persist();
        }
    }
    _persist() {
        try {
            this._ignoreChangeEvent = true;
            const raw = JSON.stringify(this._data);
            this._storageService.store(PersistedMenuHideState_1._key, raw, 0 /* StorageScope.PROFILE */ , 0 /* StorageTarget.USER */ );
        } finally{
            this._ignoreChangeEvent = false;
        }
    }
};
PersistedMenuHideState = PersistedMenuHideState_1 = __decorate([
    __param(0, (0, _storageJs.IStorageService))
], PersistedMenuHideState);
class MenuInfoSnapshot {
    constructor(_id, _collectContextKeysForSubmenus){
        this._id = _id;
        this._collectContextKeysForSubmenus = _collectContextKeysForSubmenus;
        this._menuGroups = [];
        this._allMenuIds = new Set();
        this._structureContextKeys = new Set();
        this._preconditionContextKeys = new Set();
        this._toggledContextKeys = new Set();
        this.refresh();
    }
    get allMenuIds() {
        return this._allMenuIds;
    }
    get structureContextKeys() {
        return this._structureContextKeys;
    }
    get preconditionContextKeys() {
        return this._preconditionContextKeys;
    }
    get toggledContextKeys() {
        return this._toggledContextKeys;
    }
    refresh() {
        // reset
        this._menuGroups.length = 0;
        this._allMenuIds.clear();
        this._structureContextKeys.clear();
        this._preconditionContextKeys.clear();
        this._toggledContextKeys.clear();
        const menuItems = this._sort((0, _actionsJs.MenuRegistry).getMenuItems(this._id));
        let group;
        for (const item of menuItems){
            // group by groupId
            const groupName = item.group || "";
            if (!group || group[0] !== groupName) {
                group = [
                    groupName,
                    []
                ];
                this._menuGroups.push(group);
            }
            group[1].push(item);
            // keep keys and submenu ids for eventing
            this._collectContextKeysAndSubmenuIds(item);
        }
        this._allMenuIds.add(this._id);
    }
    _sort(menuItems) {
        // no sorting needed in snapshot
        return menuItems;
    }
    _collectContextKeysAndSubmenuIds(item) {
        MenuInfoSnapshot._fillInKbExprKeys(item.when, this._structureContextKeys);
        if ((0, _actionsJs.isIMenuItem)(item)) {
            // keep precondition keys for event if applicable
            if (item.command.precondition) MenuInfoSnapshot._fillInKbExprKeys(item.command.precondition, this._preconditionContextKeys);
            // keep toggled keys for event if applicable
            if (item.command.toggled) {
                const toggledExpression = item.command.toggled.condition || item.command.toggled;
                MenuInfoSnapshot._fillInKbExprKeys(toggledExpression, this._toggledContextKeys);
            }
        } else if (this._collectContextKeysForSubmenus) {
            // recursively collect context keys from submenus so that this
            // menu fires events when context key changes affect submenus
            (0, _actionsJs.MenuRegistry).getMenuItems(item.submenu).forEach(this._collectContextKeysAndSubmenuIds, this);
            this._allMenuIds.add(item.submenu);
        }
    }
    static _fillInKbExprKeys(exp, set) {
        if (exp) for (const key of exp.keys())set.add(key);
    }
}
let MenuInfo = MenuInfo_1 = class MenuInfo extends MenuInfoSnapshot {
    constructor(_id, _hiddenStates, _collectContextKeysForSubmenus, _commandService, _keybindingService, _contextKeyService){
        super(_id, _collectContextKeysForSubmenus);
        this._hiddenStates = _hiddenStates;
        this._commandService = _commandService;
        this._keybindingService = _keybindingService;
        this._contextKeyService = _contextKeyService;
        this.refresh();
    }
    createActionGroups(options) {
        const result = [];
        for (const group of this._menuGroups){
            const [id, items] = group;
            let activeActions;
            for (const item of items)if (this._contextKeyService.contextMatchesRules(item.when)) {
                const isMenuItem = (0, _actionsJs.isIMenuItem)(item);
                if (isMenuItem) this._hiddenStates.setDefaultState(this._id, item.command.id, !!item.isHiddenByDefault);
                const menuHide = createMenuHide(this._id, isMenuItem ? item.command : item, this._hiddenStates);
                if (isMenuItem) {
                    // MenuItemAction
                    const menuKeybinding = createConfigureKeybindingAction(this._commandService, this._keybindingService, item.command.id, item.when);
                    (activeActions ??= []).push(new (0, _actionsJs.MenuItemAction)(item.command, item.alt, options, menuHide, menuKeybinding, this._contextKeyService, this._commandService));
                } else {
                    // SubmenuItemAction
                    const groups = new MenuInfo_1(item.submenu, this._hiddenStates, this._collectContextKeysForSubmenus, this._commandService, this._keybindingService, this._contextKeyService).createActionGroups(options);
                    const submenuActions = (0, _actionsJs1.Separator).join(...groups.map((g)=>g[1]));
                    if (submenuActions.length > 0) (activeActions ??= []).push(new (0, _actionsJs.SubmenuItemAction)(item, menuHide, submenuActions));
                }
            }
            if (activeActions && activeActions.length > 0) result.push([
                id,
                activeActions
            ]);
        }
        return result;
    }
    _sort(menuItems) {
        return menuItems.sort(MenuInfo_1._compareMenuItems);
    }
    static _compareMenuItems(a, b) {
        const aGroup = a.group;
        const bGroup = b.group;
        if (aGroup !== bGroup) {
            // Falsy groups come last
            if (!aGroup) return 1;
            else if (!bGroup) return -1;
            // 'navigation' group comes first
            if (aGroup === "navigation") return -1;
            else if (bGroup === "navigation") return 1;
            // lexical sort for groups
            const value = aGroup.localeCompare(bGroup);
            if (value !== 0) return value;
        }
        // sort on priority - default is 0
        const aPrio = a.order || 0;
        const bPrio = b.order || 0;
        if (aPrio < bPrio) return -1;
        else if (aPrio > bPrio) return 1;
        // sort on titles
        return MenuInfo_1._compareTitles((0, _actionsJs.isIMenuItem)(a) ? a.command.title : a.title, (0, _actionsJs.isIMenuItem)(b) ? b.command.title : b.title);
    }
    static _compareTitles(a, b) {
        const aStr = typeof a === "string" ? a : a.original;
        const bStr = typeof b === "string" ? b : b.original;
        return aStr.localeCompare(bStr);
    }
};
MenuInfo = MenuInfo_1 = __decorate([
    __param(3, (0, _commandsJs.ICommandService)),
    __param(4, (0, _keybindingJs.IKeybindingService)),
    __param(5, (0, _contextkeyJs.IContextKeyService))
], MenuInfo);
let MenuImpl = class MenuImpl {
    constructor(id, hiddenStates, options, commandService, keybindingService, contextKeyService){
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._menuInfo = new MenuInfo(id, hiddenStates, options.emitEventsForSubmenuChanges, commandService, keybindingService, contextKeyService);
        // Rebuild this menu whenever the menu registry reports an event for this MenuId.
        // This usually happen while code and extensions are loaded and affects the over
        // structure of the menu
        const rebuildMenuSoon = new (0, _asyncJs.RunOnceScheduler)(()=>{
            this._menuInfo.refresh();
            this._onDidChange.fire({
                menu: this,
                isStructuralChange: true,
                isEnablementChange: true,
                isToggleChange: true
            });
        }, options.eventDebounceDelay);
        this._disposables.add(rebuildMenuSoon);
        this._disposables.add((0, _actionsJs.MenuRegistry).onDidChangeMenu((e)=>{
            for (const id of this._menuInfo.allMenuIds)if (e.has(id)) {
                rebuildMenuSoon.schedule();
                break;
            }
        }));
        // When context keys or storage state changes we need to check if the menu also has changed. However,
        // we only do that when someone listens on this menu because (1) these events are
        // firing often and (2) menu are often leaked
        const lazyListener = this._disposables.add(new (0, _lifecycleJs.DisposableStore)());
        const merge = (events)=>{
            let isStructuralChange = false;
            let isEnablementChange = false;
            let isToggleChange = false;
            for (const item of events){
                isStructuralChange = isStructuralChange || item.isStructuralChange;
                isEnablementChange = isEnablementChange || item.isEnablementChange;
                isToggleChange = isToggleChange || item.isToggleChange;
                if (isStructuralChange && isEnablementChange && isToggleChange) break;
            }
            return {
                menu: this,
                isStructuralChange,
                isEnablementChange,
                isToggleChange
            };
        };
        const startLazyListener = ()=>{
            lazyListener.add(contextKeyService.onDidChangeContext((e)=>{
                const isStructuralChange = e.affectsSome(this._menuInfo.structureContextKeys);
                const isEnablementChange = e.affectsSome(this._menuInfo.preconditionContextKeys);
                const isToggleChange = e.affectsSome(this._menuInfo.toggledContextKeys);
                if (isStructuralChange || isEnablementChange || isToggleChange) this._onDidChange.fire({
                    menu: this,
                    isStructuralChange,
                    isEnablementChange,
                    isToggleChange
                });
            }));
            lazyListener.add(hiddenStates.onDidChange((e)=>{
                this._onDidChange.fire({
                    menu: this,
                    isStructuralChange: true,
                    isEnablementChange: false,
                    isToggleChange: false
                });
            }));
        };
        this._onDidChange = new (0, _eventJs.DebounceEmitter)({
            // start/stop context key listener
            onWillAddFirstListener: startLazyListener,
            onDidRemoveLastListener: lazyListener.clear.bind(lazyListener),
            delay: options.eventDebounceDelay,
            merge
        });
        this.onDidChange = this._onDidChange.event;
    }
    getActions(options) {
        return this._menuInfo.createActionGroups(options);
    }
    dispose() {
        this._disposables.dispose();
        this._onDidChange.dispose();
    }
};
MenuImpl = __decorate([
    __param(3, (0, _commandsJs.ICommandService)),
    __param(4, (0, _keybindingJs.IKeybindingService)),
    __param(5, (0, _contextkeyJs.IContextKeyService))
], MenuImpl);
function createMenuHide(menu, command, states) {
    const id = (0, _actionsJs.isISubmenuItem)(command) ? command.submenu.id : command.id;
    const title = typeof command.title === "string" ? command.title : command.title.value;
    const hide = (0, _actionsJs1.toAction)({
        id: `hide/${menu.id}/${id}`,
        label: (0, _nlsJs.localize)("hide.label", "Hide '{0}'", title),
        run () {
            states.updateHidden(menu, id, true);
        }
    });
    const toggle = (0, _actionsJs1.toAction)({
        id: `toggle/${menu.id}/${id}`,
        label: title,
        get checked () {
            return !states.isHidden(menu, id);
        },
        run () {
            states.updateHidden(menu, id, !!this.checked);
        }
    });
    return {
        hide,
        toggle,
        get isHidden () {
            return !toggle.checked;
        }
    };
}
function createConfigureKeybindingAction(commandService, keybindingService, commandId, when, enabled = true) {
    return (0, _actionsJs1.toAction)({
        id: `configureKeybinding/${commandId}`,
        label: (0, _nlsJs.localize)("configure keybinding", "Configure Keybinding"),
        enabled,
        run () {
            // Only set the when clause when there is no keybinding
            // It is possible that the action and the keybinding have different when clauses
            const hasKeybinding = !!keybindingService.lookupKeybinding(commandId); // This may only be called inside the `run()` method as it can be expensive on startup. #210529
            const whenValue = !hasKeybinding && when ? when.serialize() : undefined;
            commandService.executeCommand("workbench.action.openGlobalKeybindings", `@command:${commandId}` + (whenValue ? ` +when:${whenValue}` : ""));
        }
    });
}

},{"../../../base/common/async.js":"4GJc4","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","./actions.js":"kyMtp","../../commands/common/commands.js":"ho6ic","../../contextkey/common/contextkey.js":"gXuBD","../../../base/common/actions.js":"5GjLb","../../storage/common/storage.js":"6AhR2","../../../base/common/arrays.js":"DECei","../../../nls.js":"l617d","../../keybinding/common/keybinding.js":"25pLT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iyql7":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserClipboardService", ()=>BrowserClipboardService);
var _browserJs = require("../../../base/browser/browser.js");
var _domJs = require("../../../base/browser/dom.js");
var _windowJs = require("../../../base/browser/window.js");
var _asyncJs = require("../../../base/common/async.js");
var _eventJs = require("../../../base/common/event.js");
var _hashJs = require("../../../base/common/hash.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _uriJs = require("../../../base/common/uri.js");
var _layoutServiceJs = require("../../layout/browser/layoutService.js");
var _logJs = require("../../log/common/log.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var BrowserClipboardService_1;
/**
 * Custom mime type used for storing a list of uris in the clipboard.
 *
 * Requires support for custom web clipboards https://github.com/w3c/clipboard-apis/pull/175
 */ const vscodeResourcesMime = "application/vnd.code.resources";
let BrowserClipboardService = class BrowserClipboardService extends (0, _lifecycleJs.Disposable) {
    static{
        BrowserClipboardService_1 = this;
    }
    constructor(layoutService, logService){
        super();
        this.layoutService = layoutService;
        this.logService = logService;
        this.mapTextToType = new Map(); // unsupported in web (only in-memory)
        this.findText = ""; // unsupported in web (only in-memory)
        this.resources = []; // unsupported in web (only in-memory)
        this.resourcesStateHash = undefined;
        if ((0, _browserJs.isSafari) || (0, _browserJs.isWebkitWebView)) this.installWebKitWriteTextWorkaround();
        // Keep track of copy operations to reset our set of
        // copied resources: since we keep resources in memory
        // and not in the clipboard, we have to invalidate
        // that state when the user copies other data.
        this._register((0, _eventJs.Event).runAndSubscribe((0, _domJs.onDidRegisterWindow), ({ window, disposables })=>{
            disposables.add((0, _domJs.addDisposableListener)(window.document, "copy", ()=>this.clearResourcesState()));
        }, {
            window: (0, _windowJs.mainWindow),
            disposables: this._store
        }));
    }
    // In Safari, it has the following note:
    //
    // "The request to write to the clipboard must be triggered during a user gesture.
    // A call to clipboard.write or clipboard.writeText outside the scope of a user
    // gesture(such as "click" or "touch" event handlers) will result in the immediate
    // rejection of the promise returned by the API call."
    // From: https://webkit.org/blog/10855/async-clipboard-api/
    //
    // Since extensions run in a web worker, and handle gestures in an asynchronous way,
    // they are not classified by Safari as "in response to a user gesture" and will reject.
    //
    // This function sets up some handlers to work around that behavior.
    installWebKitWriteTextWorkaround() {
        const handler = ()=>{
            const currentWritePromise = new (0, _asyncJs.DeferredPromise)();
            // Cancel the previous promise since we just created a new one in response to this new event
            if (this.webKitPendingClipboardWritePromise && !this.webKitPendingClipboardWritePromise.isSettled) this.webKitPendingClipboardWritePromise.cancel();
            this.webKitPendingClipboardWritePromise = currentWritePromise;
            // The ctor of ClipboardItem allows you to pass in a promise that will resolve to a string.
            // This allows us to pass in a Promise that will either be cancelled by another event or
            // resolved with the contents of the first call to this.writeText.
            // see https://developer.mozilla.org/en-US/docs/Web/API/ClipboardItem/ClipboardItem#parameters
            (0, _domJs.getActiveWindow)().navigator.clipboard.write([
                new ClipboardItem({
                    "text/plain": currentWritePromise.p
                })
            ]).catch(async (err)=>{
                if (!(err instanceof Error) || err.name !== "NotAllowedError" || !currentWritePromise.isRejected) this.logService.error(err);
            });
        };
        this._register((0, _eventJs.Event).runAndSubscribe(this.layoutService.onDidAddContainer, ({ container, disposables })=>{
            disposables.add((0, _domJs.addDisposableListener)(container, "click", handler));
            disposables.add((0, _domJs.addDisposableListener)(container, "keydown", handler));
        }, {
            container: this.layoutService.mainContainer,
            disposables: this._store
        }));
    }
    async writeText(text, type) {
        // Clear resources given we are writing text
        this.clearResourcesState();
        // With type: only in-memory is supported
        if (type) {
            this.mapTextToType.set(type, text);
            return;
        }
        if (this.webKitPendingClipboardWritePromise) // For Safari, we complete this Promise which allows the call to `navigator.clipboard.write()`
        // above to resolve and successfully copy to the clipboard. If we let this continue, Safari
        // would throw an error because this call stack doesn't appear to originate from a user gesture.
        return this.webKitPendingClipboardWritePromise.complete(text);
        // Guard access to navigator.clipboard with try/catch
        // as we have seen DOMExceptions in certain browsers
        // due to security policies.
        try {
            return await (0, _domJs.getActiveWindow)().navigator.clipboard.writeText(text);
        } catch (error) {
            console.error(error);
        }
        // Fallback to textarea and execCommand solution
        this.fallbackWriteText(text);
    }
    fallbackWriteText(text) {
        const activeDocument = (0, _domJs.getActiveDocument)();
        const activeElement = activeDocument.activeElement;
        const textArea = activeDocument.body.appendChild((0, _domJs.$)("textarea", {
            "aria-hidden": true
        }));
        textArea.style.height = "1px";
        textArea.style.width = "1px";
        textArea.style.position = "absolute";
        textArea.value = text;
        textArea.focus();
        textArea.select();
        activeDocument.execCommand("copy");
        if ((0, _domJs.isHTMLElement)(activeElement)) activeElement.focus();
        textArea.remove();
    }
    async readText(type) {
        // With type: only in-memory is supported
        if (type) return this.mapTextToType.get(type) || "";
        // Guard access to navigator.clipboard with try/catch
        // as we have seen DOMExceptions in certain browsers
        // due to security policies.
        try {
            return await (0, _domJs.getActiveWindow)().navigator.clipboard.readText();
        } catch (error) {
            console.error(error);
        }
        return "";
    }
    async readFindText() {
        return this.findText;
    }
    async writeFindText(text) {
        this.findText = text;
    }
    static{
        this.MAX_RESOURCE_STATE_SOURCE_LENGTH = 1000;
    }
    async readResources() {
        // Guard access to navigator.clipboard with try/catch
        // as we have seen DOMExceptions in certain browsers
        // due to security policies.
        try {
            const items = await (0, _domJs.getActiveWindow)().navigator.clipboard.read();
            for (const item of items)if (item.types.includes(`web ${vscodeResourcesMime}`)) {
                const blob = await item.getType(`web ${vscodeResourcesMime}`);
                const resources = JSON.parse(await blob.text()).map((x)=>(0, _uriJs.URI).from(x));
                return resources;
            }
        } catch (error) {
        // Noop
        }
        const resourcesStateHash = await this.computeResourcesStateHash();
        if (this.resourcesStateHash !== resourcesStateHash) this.clearResourcesState(); // state mismatch, resources no longer valid
        return this.resources;
    }
    async computeResourcesStateHash() {
        if (this.resources.length === 0) return undefined; // no resources, no hash needed
        // Resources clipboard is managed in-memory only and thus
        // fails to invalidate when clipboard data is changing.
        // As such, we compute the hash of the current clipboard
        // and use that to later validate the resources clipboard.
        const clipboardText = await this.readText();
        return (0, _hashJs.hash)(clipboardText.substring(0, BrowserClipboardService_1.MAX_RESOURCE_STATE_SOURCE_LENGTH));
    }
    clearInternalState() {
        this.clearResourcesState();
    }
    clearResourcesState() {
        this.resources = [];
        this.resourcesStateHash = undefined;
    }
};
BrowserClipboardService = BrowserClipboardService_1 = __decorate([
    __param(0, (0, _layoutServiceJs.ILayoutService)),
    __param(1, (0, _logJs.ILogService))
], BrowserClipboardService);

},{"../../../base/browser/browser.js":"4Zquf","../../../base/browser/dom.js":"bnqsM","../../../base/browser/window.js":"aJBhQ","../../../base/common/async.js":"4GJc4","../../../base/common/event.js":"4Zi8b","../../../base/common/hash.js":"hXc0q","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/uri.js":"7qGS3","../../layout/browser/layoutService.js":"fPPgf","../../log/common/log.js":"ieJUF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4IsFp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IClipboardService", ()=>IClipboardService);
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IClipboardService = (0, _instantiationJs.createDecorator)("clipboardService");

},{"../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fCMgV":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Context", ()=>Context);
parcelHelpers.export(exports, "AbstractContextKeyService", ()=>AbstractContextKeyService);
parcelHelpers.export(exports, "ContextKeyService", ()=>ContextKeyService);
parcelHelpers.export(exports, "setContext", ()=>setContext);
var _eventJs = require("../../../base/common/event.js");
var _iteratorJs = require("../../../base/common/iterator.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _objectsJs = require("../../../base/common/objects.js");
var _ternarySearchTreeJs = require("../../../base/common/ternarySearchTree.js");
var _uriJs = require("../../../base/common/uri.js");
var _nlsJs = require("../../../nls.js");
var _commandsJs = require("../../commands/common/commands.js");
var _configurationJs = require("../../configuration/common/configuration.js");
var _contextkeyJs = require("../common/contextkey.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const KEYBINDING_CONTEXT_ATTR = "data-keybinding-context";
class Context {
    constructor(id, parent){
        this._id = id;
        this._parent = parent;
        this._value = Object.create(null);
        this._value["_contextId"] = id;
    }
    get value() {
        return {
            ...this._value
        };
    }
    setValue(key, value) {
        // console.log('SET ' + key + ' = ' + value + ' ON ' + this._id);
        if (this._value[key] !== value) {
            this._value[key] = value;
            return true;
        }
        return false;
    }
    removeValue(key) {
        // console.log('REMOVE ' + key + ' FROM ' + this._id);
        if (key in this._value) {
            delete this._value[key];
            return true;
        }
        return false;
    }
    getValue(key) {
        const ret = this._value[key];
        if (typeof ret === "undefined" && this._parent) return this._parent.getValue(key);
        return ret;
    }
}
class NullContext extends Context {
    static{
        this.INSTANCE = new NullContext();
    }
    constructor(){
        super(-1, null);
    }
    setValue(key, value) {
        return false;
    }
    removeValue(key) {
        return false;
    }
    getValue(key) {
        return undefined;
    }
}
class ConfigAwareContextValuesContainer extends Context {
    static{
        this._keyPrefix = "config.";
    }
    constructor(id, _configurationService, emitter){
        super(id, null);
        this._configurationService = _configurationService;
        this._values = (0, _ternarySearchTreeJs.TernarySearchTree).forConfigKeys();
        this._listener = this._configurationService.onDidChangeConfiguration((event)=>{
            if (event.source === 7 /* ConfigurationTarget.DEFAULT */ ) {
                // new setting, reset everything
                const allKeys = Array.from(this._values, ([k])=>k);
                this._values.clear();
                emitter.fire(new ArrayContextKeyChangeEvent(allKeys));
            } else {
                const changedKeys = [];
                for (const configKey of event.affectedKeys){
                    const contextKey = `config.${configKey}`;
                    const cachedItems = this._values.findSuperstr(contextKey);
                    if (cachedItems !== undefined) {
                        changedKeys.push(...(0, _iteratorJs.Iterable).map(cachedItems, ([key])=>key));
                        this._values.deleteSuperstr(contextKey);
                    }
                    if (this._values.has(contextKey)) {
                        changedKeys.push(contextKey);
                        this._values.delete(contextKey);
                    }
                }
                emitter.fire(new ArrayContextKeyChangeEvent(changedKeys));
            }
        });
    }
    dispose() {
        this._listener.dispose();
    }
    getValue(key) {
        if (key.indexOf(ConfigAwareContextValuesContainer._keyPrefix) !== 0) return super.getValue(key);
        if (this._values.has(key)) return this._values.get(key);
        const configKey = key.substr(ConfigAwareContextValuesContainer._keyPrefix.length);
        const configValue = this._configurationService.getValue(configKey);
        let value = undefined;
        switch(typeof configValue){
            case "number":
            case "boolean":
            case "string":
                value = configValue;
                break;
            default:
                if (Array.isArray(configValue)) value = JSON.stringify(configValue);
                else value = configValue;
        }
        this._values.set(key, value);
        return value;
    }
    setValue(key, value) {
        return super.setValue(key, value);
    }
    removeValue(key) {
        return super.removeValue(key);
    }
}
class ContextKey {
    constructor(service, key, defaultValue){
        this._service = service;
        this._key = key;
        this._defaultValue = defaultValue;
        this.reset();
    }
    set(value) {
        this._service.setContext(this._key, value);
    }
    reset() {
        if (typeof this._defaultValue === "undefined") this._service.removeContext(this._key);
        else this._service.setContext(this._key, this._defaultValue);
    }
    get() {
        return this._service.getContextKeyValue(this._key);
    }
}
class SimpleContextKeyChangeEvent {
    constructor(key){
        this.key = key;
    }
    affectsSome(keys) {
        return keys.has(this.key);
    }
    allKeysContainedIn(keys) {
        return this.affectsSome(keys);
    }
}
class ArrayContextKeyChangeEvent {
    constructor(keys){
        this.keys = keys;
    }
    affectsSome(keys) {
        for (const key of this.keys){
            if (keys.has(key)) return true;
        }
        return false;
    }
    allKeysContainedIn(keys) {
        return this.keys.every((key)=>keys.has(key));
    }
}
class CompositeContextKeyChangeEvent {
    constructor(events){
        this.events = events;
    }
    affectsSome(keys) {
        for (const e of this.events){
            if (e.affectsSome(keys)) return true;
        }
        return false;
    }
    allKeysContainedIn(keys) {
        return this.events.every((evt)=>evt.allKeysContainedIn(keys));
    }
}
function allEventKeysInContext(event, context) {
    return event.allKeysContainedIn(new Set(Object.keys(context)));
}
class AbstractContextKeyService extends (0, _lifecycleJs.Disposable) {
    constructor(myContextId){
        super();
        this._onDidChangeContext = this._register(new (0, _eventJs.PauseableEmitter)({
            merge: (input)=>new CompositeContextKeyChangeEvent(input)
        }));
        this.onDidChangeContext = this._onDidChangeContext.event;
        this._isDisposed = false;
        this._myContextId = myContextId;
    }
    createKey(key, defaultValue) {
        if (this._isDisposed) throw new Error(`AbstractContextKeyService has been disposed`);
        return new ContextKey(this, key, defaultValue);
    }
    bufferChangeEvents(callback) {
        this._onDidChangeContext.pause();
        try {
            callback();
        } finally{
            this._onDidChangeContext.resume();
        }
    }
    createScoped(domNode) {
        if (this._isDisposed) throw new Error(`AbstractContextKeyService has been disposed`);
        return new ScopedContextKeyService(this, domNode);
    }
    contextMatchesRules(rules) {
        if (this._isDisposed) throw new Error(`AbstractContextKeyService has been disposed`);
        const context = this.getContextValuesContainer(this._myContextId);
        const result = rules ? rules.evaluate(context) : true;
        // console.group(rules.serialize() + ' -> ' + result);
        // rules.keys().forEach(key => { console.log(key, ctx[key]); });
        // console.groupEnd();
        return result;
    }
    getContextKeyValue(key) {
        if (this._isDisposed) return undefined;
        return this.getContextValuesContainer(this._myContextId).getValue(key);
    }
    setContext(key, value) {
        if (this._isDisposed) return;
        const myContext = this.getContextValuesContainer(this._myContextId);
        if (!myContext) return;
        if (myContext.setValue(key, value)) this._onDidChangeContext.fire(new SimpleContextKeyChangeEvent(key));
    }
    removeContext(key) {
        if (this._isDisposed) return;
        if (this.getContextValuesContainer(this._myContextId).removeValue(key)) this._onDidChangeContext.fire(new SimpleContextKeyChangeEvent(key));
    }
    getContext(target) {
        if (this._isDisposed) return NullContext.INSTANCE;
        return this.getContextValuesContainer(findContextAttr(target));
    }
    dispose() {
        super.dispose();
        this._isDisposed = true;
    }
}
let ContextKeyService = class ContextKeyService extends AbstractContextKeyService {
    constructor(configurationService){
        super(0);
        this._contexts = new Map();
        this._lastContextId = 0;
        const myContext = this._register(new ConfigAwareContextValuesContainer(this._myContextId, configurationService, this._onDidChangeContext));
        this._contexts.set(this._myContextId, myContext);
    // Uncomment this to see the contexts continuously logged
    // let lastLoggedValue: string | null = null;
    // setInterval(() => {
    // 	let values = Object.keys(this._contexts).map((key) => this._contexts[key]);
    // 	let logValue = values.map(v => JSON.stringify(v._value, null, '\t')).join('\n');
    // 	if (lastLoggedValue !== logValue) {
    // 		lastLoggedValue = logValue;
    // 		console.log(lastLoggedValue);
    // 	}
    // }, 2000);
    }
    getContextValuesContainer(contextId) {
        if (this._isDisposed) return NullContext.INSTANCE;
        return this._contexts.get(contextId) || NullContext.INSTANCE;
    }
    createChildContext(parentContextId = this._myContextId) {
        if (this._isDisposed) throw new Error(`ContextKeyService has been disposed`);
        const id = ++this._lastContextId;
        this._contexts.set(id, new Context(id, this.getContextValuesContainer(parentContextId)));
        return id;
    }
    disposeContext(contextId) {
        if (!this._isDisposed) this._contexts.delete(contextId);
    }
};
ContextKeyService = __decorate([
    __param(0, (0, _configurationJs.IConfigurationService))
], ContextKeyService);
class ScopedContextKeyService extends AbstractContextKeyService {
    constructor(parent, domNode){
        super(parent.createChildContext());
        this._parentChangeListener = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this._parent = parent;
        this._updateParentChangeListener();
        this._domNode = domNode;
        if (this._domNode.hasAttribute(KEYBINDING_CONTEXT_ATTR)) {
            let extraInfo = "";
            if (this._domNode.classList) extraInfo = Array.from(this._domNode.classList.values()).join(", ");
            console.error(`Element already has context attribute${extraInfo ? ": " + extraInfo : ""}`);
        }
        this._domNode.setAttribute(KEYBINDING_CONTEXT_ATTR, String(this._myContextId));
    }
    _updateParentChangeListener() {
        // Forward parent events to this listener. Parent will change.
        this._parentChangeListener.value = this._parent.onDidChangeContext((e)=>{
            const thisContainer = this._parent.getContextValuesContainer(this._myContextId);
            const thisContextValues = thisContainer.value;
            if (!allEventKeysInContext(e, thisContextValues)) this._onDidChangeContext.fire(e);
        });
    }
    dispose() {
        if (this._isDisposed) return;
        this._parent.disposeContext(this._myContextId);
        this._domNode.removeAttribute(KEYBINDING_CONTEXT_ATTR);
        super.dispose();
    }
    getContextValuesContainer(contextId) {
        if (this._isDisposed) return NullContext.INSTANCE;
        return this._parent.getContextValuesContainer(contextId);
    }
    createChildContext(parentContextId = this._myContextId) {
        if (this._isDisposed) throw new Error(`ScopedContextKeyService has been disposed`);
        return this._parent.createChildContext(parentContextId);
    }
    disposeContext(contextId) {
        if (this._isDisposed) return;
        this._parent.disposeContext(contextId);
    }
}
function findContextAttr(domNode) {
    while(domNode){
        if (domNode.hasAttribute(KEYBINDING_CONTEXT_ATTR)) {
            const attr = domNode.getAttribute(KEYBINDING_CONTEXT_ATTR);
            if (attr) return parseInt(attr, 10);
            return NaN;
        }
        domNode = domNode.parentElement;
    }
    return 0;
}
function setContext(accessor, contextKey, contextValue) {
    const contextKeyService = accessor.get((0, _contextkeyJs.IContextKeyService));
    contextKeyService.createKey(String(contextKey), stringifyURIs(contextValue));
}
function stringifyURIs(contextValue) {
    return (0, _objectsJs.cloneAndChange)(contextValue, (obj)=>{
        if (typeof obj === "object" && obj.$mid === 1 /* MarshalledId.Uri */ ) return (0, _uriJs.URI).revive(obj).toString();
        if (obj instanceof (0, _uriJs.URI)) return obj.toString();
        return undefined;
    });
}
(0, _commandsJs.CommandsRegistry).registerCommand("_setContext", setContext);
(0, _commandsJs.CommandsRegistry).registerCommand({
    id: "getContextKeyInfo",
    handler () {
        return [
            ...(0, _contextkeyJs.RawContextKey).all()
        ].sort((a, b)=>a.key.localeCompare(b.key));
    },
    metadata: {
        description: (0, _nlsJs.localize)("getContextKeyInfo", "A command that returns information about context keys"),
        args: []
    }
});
(0, _commandsJs.CommandsRegistry).registerCommand("_generateContextKeyInfo", function() {
    const result = [];
    const seen = new Set();
    for (const info of (0, _contextkeyJs.RawContextKey).all())if (!seen.has(info.key)) {
        seen.add(info.key);
        result.push(info);
    }
    result.sort((a, b)=>a.key.localeCompare(b.key));
    console.log(JSON.stringify(result, undefined, 2));
});

},{"../../../base/common/event.js":"4Zi8b","../../../base/common/iterator.js":"2FiS0","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/objects.js":"j84mT","../../../base/common/ternarySearchTree.js":"d54no","../../../base/common/uri.js":"7qGS3","../../../nls.js":"l617d","../../commands/common/commands.js":"ho6ic","../../configuration/common/configuration.js":"dXkjq","../common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6g3vM":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InstantiationService", ()=>InstantiationService);
parcelHelpers.export(exports, "Trace", ()=>Trace) //#endregion
;
var _asyncJs = require("../../../base/common/async.js");
var _errorsJs = require("../../../base/common/errors.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _descriptorsJs = require("./descriptors.js");
var _graphJs = require("./graph.js");
var _instantiationJs = require("./instantiation.js");
var _serviceCollectionJs = require("./serviceCollection.js");
var _linkedListJs = require("../../../base/common/linkedList.js");
// TRACING
const _enableAllTracing = false;
class CyclicDependencyError extends Error {
    constructor(graph){
        super("cyclic dependency between services");
        this.message = graph.findCycleSlow() ?? `UNABLE to detect cycle, dumping graph: \n${graph.toString()}`;
    }
}
class InstantiationService {
    constructor(_services = new (0, _serviceCollectionJs.ServiceCollection)(), _strict = false, _parent, _enableTracing = _enableAllTracing){
        this._services = _services;
        this._strict = _strict;
        this._parent = _parent;
        this._enableTracing = _enableTracing;
        this._isDisposed = false;
        this._servicesToMaybeDispose = new Set();
        this._children = new Set();
        this._activeInstantiations = new Set();
        this._services.set((0, _instantiationJs.IInstantiationService), this);
        this._globalGraph = _enableTracing ? _parent?._globalGraph ?? new (0, _graphJs.Graph)((e)=>e) : undefined;
    }
    dispose() {
        if (!this._isDisposed) {
            this._isDisposed = true;
            // dispose all child services
            (0, _lifecycleJs.dispose)(this._children);
            this._children.clear();
            // dispose all services created by this service
            for (const candidate of this._servicesToMaybeDispose)if ((0, _lifecycleJs.isDisposable)(candidate)) candidate.dispose();
            this._servicesToMaybeDispose.clear();
        }
    }
    _throwIfDisposed() {
        if (this._isDisposed) throw new Error("InstantiationService has been disposed");
    }
    createChild(services, store) {
        this._throwIfDisposed();
        const that = this;
        const result = new class extends InstantiationService {
            dispose() {
                that._children.delete(result);
                super.dispose();
            }
        }(services, this._strict, this, this._enableTracing);
        this._children.add(result);
        store?.add(result);
        return result;
    }
    invokeFunction(fn, ...args) {
        this._throwIfDisposed();
        const _trace = Trace.traceInvocation(this._enableTracing, fn);
        let _done = false;
        try {
            const accessor = {
                get: (id)=>{
                    if (_done) throw (0, _errorsJs.illegalState)("service accessor is only valid during the invocation of its target method");
                    const result = this._getOrCreateServiceInstance(id, _trace);
                    if (!result) throw new Error(`[invokeFunction] unknown service '${id}'`);
                    return result;
                }
            };
            return fn(accessor, ...args);
        } finally{
            _done = true;
            _trace.stop();
        }
    }
    createInstance(ctorOrDescriptor, ...rest) {
        this._throwIfDisposed();
        let _trace;
        let result;
        if (ctorOrDescriptor instanceof (0, _descriptorsJs.SyncDescriptor)) {
            _trace = Trace.traceCreation(this._enableTracing, ctorOrDescriptor.ctor);
            result = this._createInstance(ctorOrDescriptor.ctor, ctorOrDescriptor.staticArguments.concat(rest), _trace);
        } else {
            _trace = Trace.traceCreation(this._enableTracing, ctorOrDescriptor);
            result = this._createInstance(ctorOrDescriptor, rest, _trace);
        }
        _trace.stop();
        return result;
    }
    _createInstance(ctor, args = [], _trace) {
        // arguments defined by service decorators
        const serviceDependencies = (0, _instantiationJs._util).getServiceDependencies(ctor).sort((a, b)=>a.index - b.index);
        const serviceArgs = [];
        for (const dependency of serviceDependencies){
            const service = this._getOrCreateServiceInstance(dependency.id, _trace);
            if (!service) this._throwIfStrict(`[createInstance] ${ctor.name} depends on UNKNOWN service ${dependency.id}.`, false);
            serviceArgs.push(service);
        }
        const firstServiceArgPos = serviceDependencies.length > 0 ? serviceDependencies[0].index : args.length;
        // check for argument mismatches, adjust static args if needed
        if (args.length !== firstServiceArgPos) {
            console.trace(`[createInstance] First service dependency of ${ctor.name} at position ${firstServiceArgPos + 1} conflicts with ${args.length} static arguments`);
            const delta = firstServiceArgPos - args.length;
            if (delta > 0) args = args.concat(new Array(delta));
            else args = args.slice(0, firstServiceArgPos);
        }
        // now create the instance
        return Reflect.construct(ctor, args.concat(serviceArgs));
    }
    _setCreatedServiceInstance(id, instance) {
        if (this._services.get(id) instanceof (0, _descriptorsJs.SyncDescriptor)) this._services.set(id, instance);
        else if (this._parent) this._parent._setCreatedServiceInstance(id, instance);
        else throw new Error("illegalState - setting UNKNOWN service instance");
    }
    _getServiceInstanceOrDescriptor(id) {
        const instanceOrDesc = this._services.get(id);
        if (!instanceOrDesc && this._parent) return this._parent._getServiceInstanceOrDescriptor(id);
        else return instanceOrDesc;
    }
    _getOrCreateServiceInstance(id, _trace) {
        if (this._globalGraph && this._globalGraphImplicitDependency) this._globalGraph.insertEdge(this._globalGraphImplicitDependency, String(id));
        const thing = this._getServiceInstanceOrDescriptor(id);
        if (thing instanceof (0, _descriptorsJs.SyncDescriptor)) return this._safeCreateAndCacheServiceInstance(id, thing, _trace.branch(id, true));
        else {
            _trace.branch(id, false);
            return thing;
        }
    }
    _safeCreateAndCacheServiceInstance(id, desc, _trace) {
        if (this._activeInstantiations.has(id)) throw new Error(`illegal state - RECURSIVELY instantiating service '${id}'`);
        this._activeInstantiations.add(id);
        try {
            return this._createAndCacheServiceInstance(id, desc, _trace);
        } finally{
            this._activeInstantiations.delete(id);
        }
    }
    _createAndCacheServiceInstance(id, desc, _trace) {
        const graph = new (0, _graphJs.Graph)((data)=>data.id.toString());
        let cycleCount = 0;
        const stack = [
            {
                id,
                desc,
                _trace
            }
        ];
        const seen = new Set();
        while(stack.length){
            const item = stack.pop();
            if (seen.has(String(item.id))) continue;
            seen.add(String(item.id));
            graph.lookupOrInsertNode(item);
            // a weak but working heuristic for cycle checks
            if (cycleCount++ > 1000) throw new CyclicDependencyError(graph);
            // check all dependencies for existence and if they need to be created first
            for (const dependency of (0, _instantiationJs._util).getServiceDependencies(item.desc.ctor)){
                const instanceOrDesc = this._getServiceInstanceOrDescriptor(dependency.id);
                if (!instanceOrDesc) this._throwIfStrict(`[createInstance] ${id} depends on ${dependency.id} which is NOT registered.`, true);
                // take note of all service dependencies
                this._globalGraph?.insertEdge(String(item.id), String(dependency.id));
                if (instanceOrDesc instanceof (0, _descriptorsJs.SyncDescriptor)) {
                    const d = {
                        id: dependency.id,
                        desc: instanceOrDesc,
                        _trace: item._trace.branch(dependency.id, true)
                    };
                    graph.insertEdge(item, d);
                    stack.push(d);
                }
            }
        }
        while(true){
            const roots = graph.roots();
            // if there is no more roots but still
            // nodes in the graph we have a cycle
            if (roots.length === 0) {
                if (!graph.isEmpty()) throw new CyclicDependencyError(graph);
                break;
            }
            for (const { data } of roots){
                // Repeat the check for this still being a service sync descriptor. That's because
                // instantiating a dependency might have side-effect and recursively trigger instantiation
                // so that some dependencies are now fullfilled already.
                const instanceOrDesc = this._getServiceInstanceOrDescriptor(data.id);
                if (instanceOrDesc instanceof (0, _descriptorsJs.SyncDescriptor)) {
                    // create instance and overwrite the service collections
                    const instance = this._createServiceInstanceWithOwner(data.id, data.desc.ctor, data.desc.staticArguments, data.desc.supportsDelayedInstantiation, data._trace);
                    this._setCreatedServiceInstance(data.id, instance);
                }
                graph.removeNode(data);
            }
        }
        return this._getServiceInstanceOrDescriptor(id);
    }
    _createServiceInstanceWithOwner(id, ctor, args = [], supportsDelayedInstantiation, _trace) {
        if (this._services.get(id) instanceof (0, _descriptorsJs.SyncDescriptor)) return this._createServiceInstance(id, ctor, args, supportsDelayedInstantiation, _trace, this._servicesToMaybeDispose);
        else if (this._parent) return this._parent._createServiceInstanceWithOwner(id, ctor, args, supportsDelayedInstantiation, _trace);
        else throw new Error(`illegalState - creating UNKNOWN service instance ${ctor.name}`);
    }
    _createServiceInstance(id, ctor, args = [], supportsDelayedInstantiation, _trace, disposeBucket) {
        if (!supportsDelayedInstantiation) {
            // eager instantiation
            const result = this._createInstance(ctor, args, _trace);
            disposeBucket.add(result);
            return result;
        } else {
            const child = new InstantiationService(undefined, this._strict, this, this._enableTracing);
            child._globalGraphImplicitDependency = String(id);
            // Return a proxy object that's backed by an idle value. That
            // strategy is to instantiate services in our idle time or when actually
            // needed but not when injected into a consumer
            // return "empty events" when the service isn't instantiated yet
            const earlyListeners = new Map();
            const idle = new (0, _asyncJs.GlobalIdleValue)(()=>{
                const result = child._createInstance(ctor, args, _trace);
                // early listeners that we kept are now being subscribed to
                // the real service
                for (const [key, values] of earlyListeners){
                    const candidate = result[key];
                    if (typeof candidate === "function") for (const value of values)value.disposable = candidate.apply(result, value.listener);
                }
                earlyListeners.clear();
                disposeBucket.add(result);
                return result;
            });
            return new Proxy(Object.create(null), {
                get (target, key) {
                    if (!idle.isInitialized) // looks like an event
                    {
                        if (typeof key === "string" && (key.startsWith("onDid") || key.startsWith("onWill"))) {
                            let list = earlyListeners.get(key);
                            if (!list) {
                                list = new (0, _linkedListJs.LinkedList)();
                                earlyListeners.set(key, list);
                            }
                            const event = (callback, thisArg, disposables)=>{
                                if (idle.isInitialized) return idle.value[key](callback, thisArg, disposables);
                                else {
                                    const entry = {
                                        listener: [
                                            callback,
                                            thisArg,
                                            disposables
                                        ],
                                        disposable: undefined
                                    };
                                    const rm = list.push(entry);
                                    const result = (0, _lifecycleJs.toDisposable)(()=>{
                                        rm();
                                        entry.disposable?.dispose();
                                    });
                                    return result;
                                }
                            };
                            return event;
                        }
                    }
                    // value already exists
                    if (key in target) return target[key];
                    // create value
                    const obj = idle.value;
                    let prop = obj[key];
                    if (typeof prop !== "function") return prop;
                    prop = prop.bind(obj);
                    target[key] = prop;
                    return prop;
                },
                set (_target, p, value) {
                    idle.value[p] = value;
                    return true;
                },
                getPrototypeOf (_target) {
                    return ctor.prototype;
                }
            });
        }
    }
    _throwIfStrict(msg, printWarning) {
        if (printWarning) console.warn(msg);
        if (this._strict) throw new Error(msg);
    }
}
class Trace {
    static{
        this.all = new Set();
    }
    static{
        this._None = new class extends Trace {
            constructor(){
                super(0 /* TraceType.None */ , null);
            }
            stop() {}
            branch() {
                return this;
            }
        };
    }
    static traceInvocation(_enableTracing, ctor) {
        return !_enableTracing ? Trace._None : new Trace(2 /* TraceType.Invocation */ , ctor.name || new Error().stack.split("\n").slice(3, 4).join("\n"));
    }
    static traceCreation(_enableTracing, ctor) {
        return !_enableTracing ? Trace._None : new Trace(1 /* TraceType.Creation */ , ctor.name);
    }
    static{
        this._totals = 0;
    }
    constructor(type, name){
        this.type = type;
        this.name = name;
        this._start = Date.now();
        this._dep = [];
    }
    branch(id, first) {
        const child = new Trace(3 /* TraceType.Branch */ , id.toString());
        this._dep.push([
            id,
            first,
            child
        ]);
        return child;
    }
    stop() {
        const dur = Date.now() - this._start;
        Trace._totals += dur;
        let causedCreation = false;
        function printChild(n, trace) {
            const res = [];
            const prefix = new Array(n + 1).join("	");
            for (const [id, first, child] of trace._dep)if (first && child) {
                causedCreation = true;
                res.push(`${prefix}CREATES -> ${id}`);
                const nested = printChild(n + 1, child);
                if (nested) res.push(nested);
            } else res.push(`${prefix}uses -> ${id}`);
            return res.join("\n");
        }
        const lines = [
            `${this.type === 1 /* TraceType.Creation */  ? "CREATE" : "CALL"} ${this.name}`,
            `${printChild(1, this)}`,
            `DONE, took ${dur.toFixed(2)}ms (grand total ${Trace._totals.toFixed(2)}ms)`
        ];
        if (dur > 2 || causedCreation) Trace.all.add(lines.join("\n"));
    }
}

},{"../../../base/common/async.js":"4GJc4","../../../base/common/errors.js":"divX8","../../../base/common/lifecycle.js":"9kg8d","./descriptors.js":"doIK7","./graph.js":"7w6VI","./instantiation.js":"fjwWx","./serviceCollection.js":"5sFx9","../../../base/common/linkedList.js":"kv7Rg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7w6VI":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Node", ()=>Node);
parcelHelpers.export(exports, "Graph", ()=>Graph);
class Node {
    constructor(key, data){
        this.key = key;
        this.data = data;
        this.incoming = new Map();
        this.outgoing = new Map();
    }
}
class Graph {
    constructor(_hashFn){
        this._hashFn = _hashFn;
        this._nodes = new Map();
    // empty
    }
    roots() {
        const ret = [];
        for (const node of this._nodes.values())if (node.outgoing.size === 0) ret.push(node);
        return ret;
    }
    insertEdge(from, to) {
        const fromNode = this.lookupOrInsertNode(from);
        const toNode = this.lookupOrInsertNode(to);
        fromNode.outgoing.set(toNode.key, toNode);
        toNode.incoming.set(fromNode.key, fromNode);
    }
    removeNode(data) {
        const key = this._hashFn(data);
        this._nodes.delete(key);
        for (const node of this._nodes.values()){
            node.outgoing.delete(key);
            node.incoming.delete(key);
        }
    }
    lookupOrInsertNode(data) {
        const key = this._hashFn(data);
        let node = this._nodes.get(key);
        if (!node) {
            node = new Node(key, data);
            this._nodes.set(key, node);
        }
        return node;
    }
    isEmpty() {
        return this._nodes.size === 0;
    }
    toString() {
        const data = [];
        for (const [key, value] of this._nodes)data.push(`${key}\n\t(-> incoming)[${[
            ...value.incoming.keys()
        ].join(", ")}]\n\t(outgoing ->)[${[
            ...value.outgoing.keys()
        ].join(",")}]\n`);
        return data.join("\n");
    }
    /**
     * This is brute force and slow and **only** be used
     * to trouble shoot.
     */ findCycleSlow() {
        for (const [id, node] of this._nodes){
            const seen = new Set([
                id
            ]);
            const res = this._findCycle(node, seen);
            if (res) return res;
        }
        return undefined;
    }
    _findCycle(node, seen) {
        for (const [id, outgoing] of node.outgoing){
            if (seen.has(id)) return [
                ...seen,
                id
            ].join(" -> ");
            seen.add(id);
            const value = this._findCycle(outgoing, seen);
            if (value) return value;
            seen.delete(id);
        }
        return undefined;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5sFx9":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceCollection", ()=>ServiceCollection);
class ServiceCollection {
    constructor(...entries){
        this._entries = new Map();
        for (const [id, service] of entries)this.set(id, service);
    }
    set(id, instanceOrDescriptor) {
        const result = this._entries.get(id);
        this._entries.set(id, instanceOrDescriptor);
        return result;
    }
    get(id) {
        return this._entries.get(id);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ftx9i":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsupportedSchemas", ()=>unsupportedSchemas);
parcelHelpers.export(exports, "MarkerService", ()=>MarkerService);
var _arraysJs = require("../../../base/common/arrays.js");
var _eventJs = require("../../../base/common/event.js");
var _iteratorJs = require("../../../base/common/iterator.js");
var _mapJs = require("../../../base/common/map.js");
var _networkJs = require("../../../base/common/network.js");
var _uriJs = require("../../../base/common/uri.js");
var _markersJs = require("./markers.js");
const unsupportedSchemas = new Set([
    (0, _networkJs.Schemas).inMemory,
    (0, _networkJs.Schemas).vscodeSourceControl,
    (0, _networkJs.Schemas).walkThrough,
    (0, _networkJs.Schemas).walkThroughSnippet,
    (0, _networkJs.Schemas).vscodeChatCodeBlock
]);
class DoubleResourceMap {
    constructor(){
        this._byResource = new (0, _mapJs.ResourceMap)();
        this._byOwner = new Map();
    }
    set(resource, owner, value) {
        let ownerMap = this._byResource.get(resource);
        if (!ownerMap) {
            ownerMap = new Map();
            this._byResource.set(resource, ownerMap);
        }
        ownerMap.set(owner, value);
        let resourceMap = this._byOwner.get(owner);
        if (!resourceMap) {
            resourceMap = new (0, _mapJs.ResourceMap)();
            this._byOwner.set(owner, resourceMap);
        }
        resourceMap.set(resource, value);
    }
    get(resource, owner) {
        const ownerMap = this._byResource.get(resource);
        return ownerMap?.get(owner);
    }
    delete(resource, owner) {
        let removedA = false;
        let removedB = false;
        const ownerMap = this._byResource.get(resource);
        if (ownerMap) removedA = ownerMap.delete(owner);
        const resourceMap = this._byOwner.get(owner);
        if (resourceMap) removedB = resourceMap.delete(resource);
        if (removedA !== removedB) throw new Error("illegal state");
        return removedA && removedB;
    }
    values(key) {
        if (typeof key === "string") return this._byOwner.get(key)?.values() ?? (0, _iteratorJs.Iterable).empty();
        if ((0, _uriJs.URI).isUri(key)) return this._byResource.get(key)?.values() ?? (0, _iteratorJs.Iterable).empty();
        return (0, _iteratorJs.Iterable).map((0, _iteratorJs.Iterable).concat(...this._byOwner.values()), (map)=>map[1]);
    }
}
class MarkerStats {
    constructor(service){
        this.errors = 0;
        this.infos = 0;
        this.warnings = 0;
        this.unknowns = 0;
        this._data = new (0, _mapJs.ResourceMap)();
        this._service = service;
        this._subscription = service.onMarkerChanged(this._update, this);
    }
    dispose() {
        this._subscription.dispose();
    }
    _update(resources) {
        for (const resource of resources){
            const oldStats = this._data.get(resource);
            if (oldStats) this._substract(oldStats);
            const newStats = this._resourceStats(resource);
            this._add(newStats);
            this._data.set(resource, newStats);
        }
    }
    _resourceStats(resource) {
        const result = {
            errors: 0,
            warnings: 0,
            infos: 0,
            unknowns: 0
        };
        // TODO this is a hack
        if (unsupportedSchemas.has(resource.scheme)) return result;
        for (const { severity } of this._service.read({
            resource
        })){
            if (severity === (0, _markersJs.MarkerSeverity).Error) result.errors += 1;
            else if (severity === (0, _markersJs.MarkerSeverity).Warning) result.warnings += 1;
            else if (severity === (0, _markersJs.MarkerSeverity).Info) result.infos += 1;
            else result.unknowns += 1;
        }
        return result;
    }
    _substract(op) {
        this.errors -= op.errors;
        this.warnings -= op.warnings;
        this.infos -= op.infos;
        this.unknowns -= op.unknowns;
    }
    _add(op) {
        this.errors += op.errors;
        this.warnings += op.warnings;
        this.infos += op.infos;
        this.unknowns += op.unknowns;
    }
}
class MarkerService {
    constructor(){
        this._onMarkerChanged = new (0, _eventJs.DebounceEmitter)({
            delay: 0,
            merge: MarkerService._merge
        });
        this.onMarkerChanged = this._onMarkerChanged.event;
        this._data = new DoubleResourceMap();
        this._stats = new MarkerStats(this);
    }
    dispose() {
        this._stats.dispose();
        this._onMarkerChanged.dispose();
    }
    remove(owner, resources) {
        for (const resource of resources || [])this.changeOne(owner, resource, []);
    }
    changeOne(owner, resource, markerData) {
        if ((0, _arraysJs.isFalsyOrEmpty)(markerData)) {
            // remove marker for this (owner,resource)-tuple
            const removed = this._data.delete(resource, owner);
            if (removed) this._onMarkerChanged.fire([
                resource
            ]);
        } else {
            // insert marker for this (owner,resource)-tuple
            const markers = [];
            for (const data of markerData){
                const marker = MarkerService._toMarker(owner, resource, data);
                if (marker) markers.push(marker);
            }
            this._data.set(resource, owner, markers);
            this._onMarkerChanged.fire([
                resource
            ]);
        }
    }
    static _toMarker(owner, resource, data) {
        let { code, severity, message, source, startLineNumber, startColumn, endLineNumber, endColumn, relatedInformation, tags } = data;
        if (!message) return undefined;
        // santize data
        startLineNumber = startLineNumber > 0 ? startLineNumber : 1;
        startColumn = startColumn > 0 ? startColumn : 1;
        endLineNumber = endLineNumber >= startLineNumber ? endLineNumber : startLineNumber;
        endColumn = endColumn > 0 ? endColumn : startColumn;
        return {
            resource,
            owner,
            code,
            severity,
            message,
            source,
            startLineNumber,
            startColumn,
            endLineNumber,
            endColumn,
            relatedInformation,
            tags
        };
    }
    changeAll(owner, data) {
        const changes = [];
        // remove old marker
        const existing = this._data.values(owner);
        if (existing) for (const data of existing){
            const first = (0, _iteratorJs.Iterable).first(data);
            if (first) {
                changes.push(first.resource);
                this._data.delete(first.resource, owner);
            }
        }
        // add new markers
        if ((0, _arraysJs.isNonEmptyArray)(data)) {
            // group by resource
            const groups = new (0, _mapJs.ResourceMap)();
            for (const { resource, marker: markerData } of data){
                const marker = MarkerService._toMarker(owner, resource, markerData);
                if (!marker) continue;
                const array = groups.get(resource);
                if (!array) {
                    groups.set(resource, [
                        marker
                    ]);
                    changes.push(resource);
                } else array.push(marker);
            }
            // insert all
            for (const [resource, value] of groups)this._data.set(resource, owner, value);
        }
        if (changes.length > 0) this._onMarkerChanged.fire(changes);
    }
    read(filter = Object.create(null)) {
        let { owner, resource, severities, take } = filter;
        if (!take || take < 0) take = -1;
        if (owner && resource) {
            // exactly one owner AND resource
            const data = this._data.get(resource, owner);
            if (!data) return [];
            else {
                const result = [];
                for (const marker of data)if (MarkerService._accept(marker, severities)) {
                    const newLen = result.push(marker);
                    if (take > 0 && newLen === take) break;
                }
                return result;
            }
        } else if (!owner && !resource) {
            // all
            const result = [];
            for (const markers of this._data.values()){
                for (const data of markers)if (MarkerService._accept(data, severities)) {
                    const newLen = result.push(data);
                    if (take > 0 && newLen === take) return result;
                }
            }
            return result;
        } else {
            // of one resource OR owner
            const iterable = this._data.values(resource ?? owner);
            const result = [];
            for (const markers of iterable){
                for (const data of markers)if (MarkerService._accept(data, severities)) {
                    const newLen = result.push(data);
                    if (take > 0 && newLen === take) return result;
                }
            }
            return result;
        }
    }
    static _accept(marker, severities) {
        return severities === undefined || (severities & marker.severity) === marker.severity;
    }
    // --- event debounce logic
    static _merge(all) {
        const set = new (0, _mapJs.ResourceMap)();
        for (const array of all)for (const item of array)set.set(item, true);
        return Array.from(set.keys());
    }
}

},{"../../../base/common/arrays.js":"DECei","../../../base/common/event.js":"4Zi8b","../../../base/common/iterator.js":"2FiS0","../../../base/common/map.js":"leSjz","../../../base/common/network.js":"2c1AD","../../../base/common/uri.js":"7qGS3","./markers.js":"aaeXc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ldIh3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultConfiguration", ()=>DefaultConfiguration);
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _configurationModelsJs = require("./configurationModels.js");
var _configurationRegistryJs = require("./configurationRegistry.js");
var _platformJs = require("../../registry/common/platform.js");
class DefaultConfiguration extends (0, _lifecycleJs.Disposable) {
    get configurationModel() {
        return this._configurationModel;
    }
    constructor(logService){
        super();
        this.logService = logService;
        this._configurationModel = (0, _configurationModelsJs.ConfigurationModel).createEmptyModel(this.logService);
    }
    reload() {
        this.resetConfigurationModel();
        return this.configurationModel;
    }
    getConfigurationDefaultOverrides() {
        return {};
    }
    resetConfigurationModel() {
        this._configurationModel = (0, _configurationModelsJs.ConfigurationModel).createEmptyModel(this.logService);
        const properties = (0, _platformJs.Registry).as((0, _configurationRegistryJs.Extensions).Configuration).getConfigurationProperties();
        this.updateConfigurationModel(Object.keys(properties), properties);
    }
    updateConfigurationModel(properties, configurationProperties) {
        const configurationDefaultsOverrides = this.getConfigurationDefaultOverrides();
        for (const key of properties){
            const defaultOverrideValue = configurationDefaultsOverrides[key];
            const propertySchema = configurationProperties[key];
            if (defaultOverrideValue !== undefined) this._configurationModel.setValue(key, defaultOverrideValue);
            else if (propertySchema) this._configurationModel.setValue(key, propertySchema.default);
            else this._configurationModel.removeValue(key);
        }
    }
}

},{"../../../base/common/lifecycle.js":"9kg8d","./configurationModels.js":"1tQGv","./configurationRegistry.js":"6y4yB","../../registry/common/platform.js":"dzx11","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hpeDM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IAccessibilitySignalService", ()=>IAccessibilitySignalService);
parcelHelpers.export(exports, "AcknowledgeDocCommentsToken", ()=>AcknowledgeDocCommentsToken);
/**
 * Corresponds to the audio files in ./media.
*/ parcelHelpers.export(exports, "Sound", ()=>Sound);
parcelHelpers.export(exports, "SoundSource", ()=>SoundSource);
parcelHelpers.export(exports, "AccessibilitySignal", ()=>AccessibilitySignal);
var _nlsJs = require("../../../nls.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
const IAccessibilitySignalService = (0, _instantiationJs.createDecorator)("accessibilitySignalService");
const AcknowledgeDocCommentsToken = Symbol("AcknowledgeDocCommentsToken");
class Sound {
    static register(options) {
        const sound = new Sound(options.fileName);
        return sound;
    }
    static{
        this.error = Sound.register({
            fileName: "error.mp3"
        });
    }
    static{
        this.warning = Sound.register({
            fileName: "warning.mp3"
        });
    }
    static{
        this.success = Sound.register({
            fileName: "success.mp3"
        });
    }
    static{
        this.foldedArea = Sound.register({
            fileName: "foldedAreas.mp3"
        });
    }
    static{
        this.break = Sound.register({
            fileName: "break.mp3"
        });
    }
    static{
        this.quickFixes = Sound.register({
            fileName: "quickFixes.mp3"
        });
    }
    static{
        this.taskCompleted = Sound.register({
            fileName: "taskCompleted.mp3"
        });
    }
    static{
        this.taskFailed = Sound.register({
            fileName: "taskFailed.mp3"
        });
    }
    static{
        this.terminalBell = Sound.register({
            fileName: "terminalBell.mp3"
        });
    }
    static{
        this.diffLineInserted = Sound.register({
            fileName: "diffLineInserted.mp3"
        });
    }
    static{
        this.diffLineDeleted = Sound.register({
            fileName: "diffLineDeleted.mp3"
        });
    }
    static{
        this.diffLineModified = Sound.register({
            fileName: "diffLineModified.mp3"
        });
    }
    static{
        this.chatRequestSent = Sound.register({
            fileName: "chatRequestSent.mp3"
        });
    }
    static{
        this.chatResponseReceived1 = Sound.register({
            fileName: "chatResponseReceived1.mp3"
        });
    }
    static{
        this.chatResponseReceived2 = Sound.register({
            fileName: "chatResponseReceived2.mp3"
        });
    }
    static{
        this.chatResponseReceived3 = Sound.register({
            fileName: "chatResponseReceived3.mp3"
        });
    }
    static{
        this.chatResponseReceived4 = Sound.register({
            fileName: "chatResponseReceived4.mp3"
        });
    }
    static{
        this.clear = Sound.register({
            fileName: "clear.mp3"
        });
    }
    static{
        this.save = Sound.register({
            fileName: "save.mp3"
        });
    }
    static{
        this.format = Sound.register({
            fileName: "format.mp3"
        });
    }
    static{
        this.voiceRecordingStarted = Sound.register({
            fileName: "voiceRecordingStarted.mp3"
        });
    }
    static{
        this.voiceRecordingStopped = Sound.register({
            fileName: "voiceRecordingStopped.mp3"
        });
    }
    static{
        this.progress = Sound.register({
            fileName: "progress.mp3"
        });
    }
    constructor(fileName){
        this.fileName = fileName;
    }
}
class SoundSource {
    constructor(randomOneOf){
        this.randomOneOf = randomOneOf;
    }
}
class AccessibilitySignal {
    constructor(sound, name, legacySoundSettingsKey, settingsKey, legacyAnnouncementSettingsKey, announcementMessage){
        this.sound = sound;
        this.name = name;
        this.legacySoundSettingsKey = legacySoundSettingsKey;
        this.settingsKey = settingsKey;
        this.legacyAnnouncementSettingsKey = legacyAnnouncementSettingsKey;
        this.announcementMessage = announcementMessage;
    }
    static{
        this._signals = new Set();
    }
    static register(options) {
        const soundSource = new SoundSource("randomOneOf" in options.sound ? options.sound.randomOneOf : [
            options.sound
        ]);
        const signal = new AccessibilitySignal(soundSource, options.name, options.legacySoundSettingsKey, options.settingsKey, options.legacyAnnouncementSettingsKey, options.announcementMessage);
        AccessibilitySignal._signals.add(signal);
        return signal;
    }
    static{
        this.errorAtPosition = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.positionHasError.name", "Error at Position"),
            sound: Sound.error,
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.positionHasError", "Error"),
            settingsKey: "accessibility.signals.positionHasError",
            delaySettingsKey: "accessibility.signalOptions.delays.errorAtPosition"
        });
    }
    static{
        this.warningAtPosition = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.positionHasWarning.name", "Warning at Position"),
            sound: Sound.warning,
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.positionHasWarning", "Warning"),
            settingsKey: "accessibility.signals.positionHasWarning",
            delaySettingsKey: "accessibility.signalOptions.delays.warningAtPosition"
        });
    }
    static{
        this.errorOnLine = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.lineHasError.name", "Error on Line"),
            sound: Sound.error,
            legacySoundSettingsKey: "audioCues.lineHasError",
            legacyAnnouncementSettingsKey: "accessibility.alert.error",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.lineHasError", "Error on Line"),
            settingsKey: "accessibility.signals.lineHasError"
        });
    }
    static{
        this.warningOnLine = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.lineHasWarning.name", "Warning on Line"),
            sound: Sound.warning,
            legacySoundSettingsKey: "audioCues.lineHasWarning",
            legacyAnnouncementSettingsKey: "accessibility.alert.warning",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.lineHasWarning", "Warning on Line"),
            settingsKey: "accessibility.signals.lineHasWarning"
        });
    }
    static{
        this.foldedArea = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.lineHasFoldedArea.name", "Folded Area on Line"),
            sound: Sound.foldedArea,
            legacySoundSettingsKey: "audioCues.lineHasFoldedArea",
            legacyAnnouncementSettingsKey: "accessibility.alert.foldedArea",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.lineHasFoldedArea", "Folded"),
            settingsKey: "accessibility.signals.lineHasFoldedArea"
        });
    }
    static{
        this.break = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.lineHasBreakpoint.name", "Breakpoint on Line"),
            sound: Sound.break,
            legacySoundSettingsKey: "audioCues.lineHasBreakpoint",
            legacyAnnouncementSettingsKey: "accessibility.alert.breakpoint",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.lineHasBreakpoint", "Breakpoint"),
            settingsKey: "accessibility.signals.lineHasBreakpoint"
        });
    }
    static{
        this.inlineSuggestion = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.lineHasInlineSuggestion.name", "Inline Suggestion on Line"),
            sound: Sound.quickFixes,
            legacySoundSettingsKey: "audioCues.lineHasInlineSuggestion",
            settingsKey: "accessibility.signals.lineHasInlineSuggestion"
        });
    }
    static{
        this.terminalQuickFix = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.terminalQuickFix.name", "Terminal Quick Fix"),
            sound: Sound.quickFixes,
            legacySoundSettingsKey: "audioCues.terminalQuickFix",
            legacyAnnouncementSettingsKey: "accessibility.alert.terminalQuickFix",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.terminalQuickFix", "Quick Fix"),
            settingsKey: "accessibility.signals.terminalQuickFix"
        });
    }
    static{
        this.onDebugBreak = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.onDebugBreak.name", "Debugger Stopped on Breakpoint"),
            sound: Sound.break,
            legacySoundSettingsKey: "audioCues.onDebugBreak",
            legacyAnnouncementSettingsKey: "accessibility.alert.onDebugBreak",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.onDebugBreak", "Breakpoint"),
            settingsKey: "accessibility.signals.onDebugBreak"
        });
    }
    static{
        this.noInlayHints = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.noInlayHints", "No Inlay Hints on Line"),
            sound: Sound.error,
            legacySoundSettingsKey: "audioCues.noInlayHints",
            legacyAnnouncementSettingsKey: "accessibility.alert.noInlayHints",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.noInlayHints", "No Inlay Hints"),
            settingsKey: "accessibility.signals.noInlayHints"
        });
    }
    static{
        this.taskCompleted = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.taskCompleted", "Task Completed"),
            sound: Sound.taskCompleted,
            legacySoundSettingsKey: "audioCues.taskCompleted",
            legacyAnnouncementSettingsKey: "accessibility.alert.taskCompleted",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.taskCompleted", "Task Completed"),
            settingsKey: "accessibility.signals.taskCompleted"
        });
    }
    static{
        this.taskFailed = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.taskFailed", "Task Failed"),
            sound: Sound.taskFailed,
            legacySoundSettingsKey: "audioCues.taskFailed",
            legacyAnnouncementSettingsKey: "accessibility.alert.taskFailed",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.taskFailed", "Task Failed"),
            settingsKey: "accessibility.signals.taskFailed"
        });
    }
    static{
        this.terminalCommandFailed = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.terminalCommandFailed", "Terminal Command Failed"),
            sound: Sound.error,
            legacySoundSettingsKey: "audioCues.terminalCommandFailed",
            legacyAnnouncementSettingsKey: "accessibility.alert.terminalCommandFailed",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.terminalCommandFailed", "Command Failed"),
            settingsKey: "accessibility.signals.terminalCommandFailed"
        });
    }
    static{
        this.terminalCommandSucceeded = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.terminalCommandSucceeded", "Terminal Command Succeeded"),
            sound: Sound.success,
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.terminalCommandSucceeded", "Command Succeeded"),
            settingsKey: "accessibility.signals.terminalCommandSucceeded"
        });
    }
    static{
        this.terminalBell = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.terminalBell", "Terminal Bell"),
            sound: Sound.terminalBell,
            legacySoundSettingsKey: "audioCues.terminalBell",
            legacyAnnouncementSettingsKey: "accessibility.alert.terminalBell",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.terminalBell", "Terminal Bell"),
            settingsKey: "accessibility.signals.terminalBell"
        });
    }
    static{
        this.notebookCellCompleted = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.notebookCellCompleted", "Notebook Cell Completed"),
            sound: Sound.taskCompleted,
            legacySoundSettingsKey: "audioCues.notebookCellCompleted",
            legacyAnnouncementSettingsKey: "accessibility.alert.notebookCellCompleted",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.notebookCellCompleted", "Notebook Cell Completed"),
            settingsKey: "accessibility.signals.notebookCellCompleted"
        });
    }
    static{
        this.notebookCellFailed = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.notebookCellFailed", "Notebook Cell Failed"),
            sound: Sound.taskFailed,
            legacySoundSettingsKey: "audioCues.notebookCellFailed",
            legacyAnnouncementSettingsKey: "accessibility.alert.notebookCellFailed",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.notebookCellFailed", "Notebook Cell Failed"),
            settingsKey: "accessibility.signals.notebookCellFailed"
        });
    }
    static{
        this.diffLineInserted = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.diffLineInserted", "Diff Line Inserted"),
            sound: Sound.diffLineInserted,
            legacySoundSettingsKey: "audioCues.diffLineInserted",
            settingsKey: "accessibility.signals.diffLineInserted"
        });
    }
    static{
        this.diffLineDeleted = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.diffLineDeleted", "Diff Line Deleted"),
            sound: Sound.diffLineDeleted,
            legacySoundSettingsKey: "audioCues.diffLineDeleted",
            settingsKey: "accessibility.signals.diffLineDeleted"
        });
    }
    static{
        this.diffLineModified = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.diffLineModified", "Diff Line Modified"),
            sound: Sound.diffLineModified,
            legacySoundSettingsKey: "audioCues.diffLineModified",
            settingsKey: "accessibility.signals.diffLineModified"
        });
    }
    static{
        this.chatRequestSent = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.chatRequestSent", "Chat Request Sent"),
            sound: Sound.chatRequestSent,
            legacySoundSettingsKey: "audioCues.chatRequestSent",
            legacyAnnouncementSettingsKey: "accessibility.alert.chatRequestSent",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.chatRequestSent", "Chat Request Sent"),
            settingsKey: "accessibility.signals.chatRequestSent"
        });
    }
    static{
        this.chatResponseReceived = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.chatResponseReceived", "Chat Response Received"),
            legacySoundSettingsKey: "audioCues.chatResponseReceived",
            sound: {
                randomOneOf: [
                    Sound.chatResponseReceived1,
                    Sound.chatResponseReceived2,
                    Sound.chatResponseReceived3,
                    Sound.chatResponseReceived4
                ]
            },
            settingsKey: "accessibility.signals.chatResponseReceived"
        });
    }
    static{
        this.progress = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.progress", "Progress"),
            sound: Sound.progress,
            legacySoundSettingsKey: "audioCues.chatResponsePending",
            legacyAnnouncementSettingsKey: "accessibility.alert.progress",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.progress", "Progress"),
            settingsKey: "accessibility.signals.progress"
        });
    }
    static{
        this.clear = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.clear", "Clear"),
            sound: Sound.clear,
            legacySoundSettingsKey: "audioCues.clear",
            legacyAnnouncementSettingsKey: "accessibility.alert.clear",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.clear", "Clear"),
            settingsKey: "accessibility.signals.clear"
        });
    }
    static{
        this.save = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.save", "Save"),
            sound: Sound.save,
            legacySoundSettingsKey: "audioCues.save",
            legacyAnnouncementSettingsKey: "accessibility.alert.save",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.save", "Save"),
            settingsKey: "accessibility.signals.save"
        });
    }
    static{
        this.format = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.format", "Format"),
            sound: Sound.format,
            legacySoundSettingsKey: "audioCues.format",
            legacyAnnouncementSettingsKey: "accessibility.alert.format",
            announcementMessage: (0, _nlsJs.localize)("accessibility.signals.format", "Format"),
            settingsKey: "accessibility.signals.format"
        });
    }
    static{
        this.voiceRecordingStarted = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.voiceRecordingStarted", "Voice Recording Started"),
            sound: Sound.voiceRecordingStarted,
            legacySoundSettingsKey: "audioCues.voiceRecordingStarted",
            settingsKey: "accessibility.signals.voiceRecordingStarted"
        });
    }
    static{
        this.voiceRecordingStopped = AccessibilitySignal.register({
            name: (0, _nlsJs.localize)("accessibilitySignals.voiceRecordingStopped", "Voice Recording Stopped"),
            sound: Sound.voiceRecordingStopped,
            legacySoundSettingsKey: "audioCues.voiceRecordingStopped",
            settingsKey: "accessibility.signals.voiceRecordingStopped"
        });
    }
}

},{"../../../nls.js":"l617d","../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"866WY":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogService", ()=>LogService);
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _logJs = require("./log.js");
class LogService extends (0, _lifecycleJs.Disposable) {
    constructor(primaryLogger, otherLoggers = []){
        super();
        this.logger = new (0, _logJs.MultiplexLogger)([
            primaryLogger,
            ...otherLoggers
        ]);
        this._register(primaryLogger.onDidChangeLogLevel((level)=>this.setLevel(level)));
    }
    get onDidChangeLogLevel() {
        return this.logger.onDidChangeLogLevel;
    }
    setLevel(level) {
        this.logger.setLevel(level);
    }
    getLevel() {
        return this.logger.getLevel();
    }
    trace(message, ...args) {
        this.logger.trace(message, ...args);
    }
    debug(message, ...args) {
        this.logger.debug(message, ...args);
    }
    info(message, ...args) {
        this.logger.info(message, ...args);
    }
    warn(message, ...args) {
        this.logger.warn(message, ...args);
    }
    error(message, ...args) {
        this.logger.error(message, ...args);
    }
}

},{"../../../base/common/lifecycle.js":"9kg8d","./log.js":"ieJUF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8AkS3":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Registers an editor feature. Editor features will be instantiated only once, as soon as
 * the first code editor is instantiated.
 */ parcelHelpers.export(exports, "registerEditorFeature", ()=>registerEditorFeature);
parcelHelpers.export(exports, "getEditorFeatures", ()=>getEditorFeatures);
const editorFeatures = [];
function registerEditorFeature(ctor) {
    editorFeatures.push(ctor);
}
function getEditorFeatures() {
    return editorFeatures.slice(0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1isRs":[function(require,module,exports) {
/**
 * The monaco build doesn't like the dynamic import of tree sitter in the real service.
 * We use a dummy sertive here to make the build happy.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandaloneTreeSitterParserService", ()=>StandaloneTreeSitterParserService);
class StandaloneTreeSitterParserService {
    getParseResult(textModel) {
        return undefined;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"681Ll":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 * The type of the `IEditor`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorType", ()=>EditorType);
const EditorType = {
    ICodeEditor: "vs.editor.ICodeEditor",
    IDiffEditor: "vs.editor.IDiffEditor"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kb2bg":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Colorizer", ()=>Colorizer);
var _trustedTypesJs = require("../../../base/browser/trustedTypes.js");
var _stringsJs = require("../../../base/common/strings.js");
var _languagesJs = require("../../common/languages.js");
var _lineTokensJs = require("../../common/tokens/lineTokens.js");
var _viewLineRendererJs = require("../../common/viewLayout/viewLineRenderer.js");
var _viewModelJs = require("../../common/viewModel.js");
var _monarchLexerJs = require("../common/monarch/monarchLexer.js");
const ttPolicy = (0, _trustedTypesJs.createTrustedTypesPolicy)("standaloneColorizer", {
    createHTML: (value)=>value
});
class Colorizer {
    static colorizeElement(themeService, languageService, domNode, options) {
        options = options || {};
        const theme = options.theme || "vs";
        const mimeType = options.mimeType || domNode.getAttribute("lang") || domNode.getAttribute("data-lang");
        if (!mimeType) {
            console.error("Mode not detected");
            return Promise.resolve();
        }
        const languageId = languageService.getLanguageIdByMimeType(mimeType) || mimeType;
        themeService.setTheme(theme);
        const text = domNode.firstChild ? domNode.firstChild.nodeValue : "";
        domNode.className += " " + theme;
        const render = (str)=>{
            const trustedhtml = ttPolicy?.createHTML(str) ?? str;
            domNode.innerHTML = trustedhtml;
        };
        return this.colorize(languageService, text || "", languageId, options).then(render, (err)=>console.error(err));
    }
    static async colorize(languageService, text, languageId, options) {
        const languageIdCodec = languageService.languageIdCodec;
        let tabSize = 4;
        if (options && typeof options.tabSize === "number") tabSize = options.tabSize;
        if (_stringsJs.startsWithUTF8BOM(text)) text = text.substr(1);
        const lines = _stringsJs.splitLines(text);
        if (!languageService.isRegisteredLanguageId(languageId)) return _fakeColorize(lines, tabSize, languageIdCodec);
        const tokenizationSupport = await (0, _languagesJs.TokenizationRegistry).getOrCreate(languageId);
        if (tokenizationSupport) return _colorize(lines, tabSize, tokenizationSupport, languageIdCodec);
        return _fakeColorize(lines, tabSize, languageIdCodec);
    }
    static colorizeLine(line, mightContainNonBasicASCII, mightContainRTL, tokens, tabSize = 4) {
        const isBasicASCII = (0, _viewModelJs.ViewLineRenderingData).isBasicASCII(line, mightContainNonBasicASCII);
        const containsRTL = (0, _viewModelJs.ViewLineRenderingData).containsRTL(line, isBasicASCII, mightContainRTL);
        const renderResult = (0, _viewLineRendererJs.renderViewLine2)(new (0, _viewLineRendererJs.RenderLineInput)(false, true, line, false, isBasicASCII, containsRTL, 0, tokens, [], tabSize, 0, 0, 0, 0, -1, "none", false, false, null));
        return renderResult.html;
    }
    static colorizeModelLine(model, lineNumber, tabSize = 4) {
        const content = model.getLineContent(lineNumber);
        model.tokenization.forceTokenization(lineNumber);
        const tokens = model.tokenization.getLineTokens(lineNumber);
        const inflatedTokens = tokens.inflate();
        return this.colorizeLine(content, model.mightContainNonBasicASCII(), model.mightContainRTL(), inflatedTokens, tabSize);
    }
}
function _colorize(lines, tabSize, tokenizationSupport, languageIdCodec) {
    return new Promise((c, e)=>{
        const execute = ()=>{
            const result = _actualColorize(lines, tabSize, tokenizationSupport, languageIdCodec);
            if (tokenizationSupport instanceof (0, _monarchLexerJs.MonarchTokenizer)) {
                const status = tokenizationSupport.getLoadStatus();
                if (status.loaded === false) {
                    status.promise.then(execute, e);
                    return;
                }
            }
            c(result);
        };
        execute();
    });
}
function _fakeColorize(lines, tabSize, languageIdCodec) {
    let html = [];
    const defaultMetadata = 33587200;
    const tokens = new Uint32Array(2);
    tokens[0] = 0;
    tokens[1] = defaultMetadata;
    for(let i = 0, length = lines.length; i < length; i++){
        const line = lines[i];
        tokens[0] = line.length;
        const lineTokens = new (0, _lineTokensJs.LineTokens)(tokens, line, languageIdCodec);
        const isBasicASCII = (0, _viewModelJs.ViewLineRenderingData).isBasicASCII(line, /* check for basic ASCII */ true);
        const containsRTL = (0, _viewModelJs.ViewLineRenderingData).containsRTL(line, isBasicASCII, /* check for RTL */ true);
        const renderResult = (0, _viewLineRendererJs.renderViewLine2)(new (0, _viewLineRendererJs.RenderLineInput)(false, true, line, false, isBasicASCII, containsRTL, 0, lineTokens, [], tabSize, 0, 0, 0, 0, -1, "none", false, false, null));
        html = html.concat(renderResult.html);
        html.push("<br/>");
    }
    return html.join("");
}
function _actualColorize(lines, tabSize, tokenizationSupport, languageIdCodec) {
    let html = [];
    let state = tokenizationSupport.getInitialState();
    for(let i = 0, length = lines.length; i < length; i++){
        const line = lines[i];
        const tokenizeResult = tokenizationSupport.tokenizeEncoded(line, true, state);
        (0, _lineTokensJs.LineTokens).convertToEndOffset(tokenizeResult.tokens, line.length);
        const lineTokens = new (0, _lineTokensJs.LineTokens)(tokenizeResult.tokens, line, languageIdCodec);
        const isBasicASCII = (0, _viewModelJs.ViewLineRenderingData).isBasicASCII(line, /* check for basic ASCII */ true);
        const containsRTL = (0, _viewModelJs.ViewLineRenderingData).containsRTL(line, isBasicASCII, /* check for RTL */ true);
        const renderResult = (0, _viewLineRendererJs.renderViewLine2)(new (0, _viewLineRendererJs.RenderLineInput)(false, true, line, false, isBasicASCII, containsRTL, 0, lineTokens.inflate(), [], tabSize, 0, 0, 0, 0, -1, "none", false, false, null));
        html = html.concat(renderResult.html);
        html.push("<br/>");
        state = tokenizeResult.endState;
    }
    return html.join("");
}

},{"../../../base/browser/trustedTypes.js":"bgQyv","../../../base/common/strings.js":"aA9I1","../../common/languages.js":"g5n96","../../common/tokens/lineTokens.js":"6iUVx","../../common/viewLayout/viewLineRenderer.js":"1RGPz","../../common/viewModel.js":"5EHxj","../common/monarch/monarchLexer.js":"1mCsI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1RGPz":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineRange", ()=>LineRange);
parcelHelpers.export(exports, "RenderLineInput", ()=>RenderLineInput);
parcelHelpers.export(exports, "DomPosition", ()=>DomPosition);
/**
 * Provides a both direction mapping between a line's character and its rendered position.
 */ parcelHelpers.export(exports, "CharacterMapping", ()=>CharacterMapping);
parcelHelpers.export(exports, "RenderLineOutput", ()=>RenderLineOutput);
parcelHelpers.export(exports, "renderViewLine", ()=>renderViewLine);
parcelHelpers.export(exports, "RenderLineOutput2", ()=>RenderLineOutput2);
parcelHelpers.export(exports, "renderViewLine2", ()=>renderViewLine2);
var _nlsJs = require("../../../nls.js");
var _stringsJs = require("../../../base/common/strings.js");
var _stringBuilderJs = require("../core/stringBuilder.js");
var _lineDecorationsJs = require("./lineDecorations.js");
var _linePartJs = require("./linePart.js");
class LineRange {
    constructor(startIndex, endIndex){
        this.startOffset = startIndex;
        this.endOffset = endIndex;
    }
    equals(otherLineRange) {
        return this.startOffset === otherLineRange.startOffset && this.endOffset === otherLineRange.endOffset;
    }
}
class RenderLineInput {
    constructor(useMonospaceOptimizations, canUseHalfwidthRightwardsArrow, lineContent, continuesWithWrappedLine, isBasicASCII, containsRTL, fauxIndentLength, lineTokens, lineDecorations, tabSize, startVisibleColumn, spaceWidth, middotWidth, wsmiddotWidth, stopRenderingLineAfter, renderWhitespace, renderControlCharacters, fontLigatures, selectionsOnLine){
        this.useMonospaceOptimizations = useMonospaceOptimizations;
        this.canUseHalfwidthRightwardsArrow = canUseHalfwidthRightwardsArrow;
        this.lineContent = lineContent;
        this.continuesWithWrappedLine = continuesWithWrappedLine;
        this.isBasicASCII = isBasicASCII;
        this.containsRTL = containsRTL;
        this.fauxIndentLength = fauxIndentLength;
        this.lineTokens = lineTokens;
        this.lineDecorations = lineDecorations.sort((0, _lineDecorationsJs.LineDecoration).compare);
        this.tabSize = tabSize;
        this.startVisibleColumn = startVisibleColumn;
        this.spaceWidth = spaceWidth;
        this.stopRenderingLineAfter = stopRenderingLineAfter;
        this.renderWhitespace = renderWhitespace === "all" ? 4 /* RenderWhitespace.All */  : renderWhitespace === "boundary" ? 1 /* RenderWhitespace.Boundary */  : renderWhitespace === "selection" ? 2 /* RenderWhitespace.Selection */  : renderWhitespace === "trailing" ? 3 /* RenderWhitespace.Trailing */  : 0 /* RenderWhitespace.None */ ;
        this.renderControlCharacters = renderControlCharacters;
        this.fontLigatures = fontLigatures;
        this.selectionsOnLine = selectionsOnLine && selectionsOnLine.sort((a, b)=>a.startOffset < b.startOffset ? -1 : 1);
        const wsmiddotDiff = Math.abs(wsmiddotWidth - spaceWidth);
        const middotDiff = Math.abs(middotWidth - spaceWidth);
        if (wsmiddotDiff < middotDiff) {
            this.renderSpaceWidth = wsmiddotWidth;
            this.renderSpaceCharCode = 0x2E31; // U+2E31 - WORD SEPARATOR MIDDLE DOT
        } else {
            this.renderSpaceWidth = middotWidth;
            this.renderSpaceCharCode = 0xB7; // U+00B7 - MIDDLE DOT
        }
    }
    sameSelection(otherSelections) {
        if (this.selectionsOnLine === null) return otherSelections === null;
        if (otherSelections === null) return false;
        if (otherSelections.length !== this.selectionsOnLine.length) return false;
        for(let i = 0; i < this.selectionsOnLine.length; i++){
            if (!this.selectionsOnLine[i].equals(otherSelections[i])) return false;
        }
        return true;
    }
    equals(other) {
        return this.useMonospaceOptimizations === other.useMonospaceOptimizations && this.canUseHalfwidthRightwardsArrow === other.canUseHalfwidthRightwardsArrow && this.lineContent === other.lineContent && this.continuesWithWrappedLine === other.continuesWithWrappedLine && this.isBasicASCII === other.isBasicASCII && this.containsRTL === other.containsRTL && this.fauxIndentLength === other.fauxIndentLength && this.tabSize === other.tabSize && this.startVisibleColumn === other.startVisibleColumn && this.spaceWidth === other.spaceWidth && this.renderSpaceWidth === other.renderSpaceWidth && this.renderSpaceCharCode === other.renderSpaceCharCode && this.stopRenderingLineAfter === other.stopRenderingLineAfter && this.renderWhitespace === other.renderWhitespace && this.renderControlCharacters === other.renderControlCharacters && this.fontLigatures === other.fontLigatures && (0, _lineDecorationsJs.LineDecoration).equalsArr(this.lineDecorations, other.lineDecorations) && this.lineTokens.equals(other.lineTokens) && this.sameSelection(other.selectionsOnLine);
    }
}
class DomPosition {
    constructor(partIndex, charIndex){
        this.partIndex = partIndex;
        this.charIndex = charIndex;
    }
}
class CharacterMapping {
    static getPartIndex(partData) {
        return (partData & 4294901760 /* CharacterMappingConstants.PART_INDEX_MASK */ ) >>> 16 /* CharacterMappingConstants.PART_INDEX_OFFSET */ ;
    }
    static getCharIndex(partData) {
        return (partData & 65535 /* CharacterMappingConstants.CHAR_INDEX_MASK */ ) >>> 0 /* CharacterMappingConstants.CHAR_INDEX_OFFSET */ ;
    }
    constructor(length, partCount){
        this.length = length;
        this._data = new Uint32Array(this.length);
        this._horizontalOffset = new Uint32Array(this.length);
    }
    setColumnInfo(column, partIndex, charIndex, horizontalOffset) {
        const partData = (partIndex << 16 /* CharacterMappingConstants.PART_INDEX_OFFSET */  | charIndex << 0 /* CharacterMappingConstants.CHAR_INDEX_OFFSET */ ) >>> 0;
        this._data[column - 1] = partData;
        this._horizontalOffset[column - 1] = horizontalOffset;
    }
    getHorizontalOffset(column) {
        if (this._horizontalOffset.length === 0) // No characters on this line
        return 0;
        return this._horizontalOffset[column - 1];
    }
    charOffsetToPartData(charOffset) {
        if (this.length === 0) return 0;
        if (charOffset < 0) return this._data[0];
        if (charOffset >= this.length) return this._data[this.length - 1];
        return this._data[charOffset];
    }
    getDomPosition(column) {
        const partData = this.charOffsetToPartData(column - 1);
        const partIndex = CharacterMapping.getPartIndex(partData);
        const charIndex = CharacterMapping.getCharIndex(partData);
        return new DomPosition(partIndex, charIndex);
    }
    getColumn(domPosition, partLength) {
        const charOffset = this.partDataToCharOffset(domPosition.partIndex, partLength, domPosition.charIndex);
        return charOffset + 1;
    }
    partDataToCharOffset(partIndex, partLength, charIndex) {
        if (this.length === 0) return 0;
        const searchEntry = (partIndex << 16 /* CharacterMappingConstants.PART_INDEX_OFFSET */  | charIndex << 0 /* CharacterMappingConstants.CHAR_INDEX_OFFSET */ ) >>> 0;
        let min = 0;
        let max = this.length - 1;
        while(min + 1 < max){
            const mid = min + max >>> 1;
            const midEntry = this._data[mid];
            if (midEntry === searchEntry) return mid;
            else if (midEntry > searchEntry) max = mid;
            else min = mid;
        }
        if (min === max) return min;
        const minEntry = this._data[min];
        const maxEntry = this._data[max];
        if (minEntry === searchEntry) return min;
        if (maxEntry === searchEntry) return max;
        const minPartIndex = CharacterMapping.getPartIndex(minEntry);
        const minCharIndex = CharacterMapping.getCharIndex(minEntry);
        const maxPartIndex = CharacterMapping.getPartIndex(maxEntry);
        let maxCharIndex;
        if (minPartIndex !== maxPartIndex) // sitting between parts
        maxCharIndex = partLength;
        else maxCharIndex = CharacterMapping.getCharIndex(maxEntry);
        const minEntryDistance = charIndex - minCharIndex;
        const maxEntryDistance = maxCharIndex - charIndex;
        if (minEntryDistance <= maxEntryDistance) return min;
        return max;
    }
}
class RenderLineOutput {
    constructor(characterMapping, containsRTL, containsForeignElements){
        this._renderLineOutputBrand = undefined;
        this.characterMapping = characterMapping;
        this.containsRTL = containsRTL;
        this.containsForeignElements = containsForeignElements;
    }
}
function renderViewLine(input, sb) {
    if (input.lineContent.length === 0) {
        if (input.lineDecorations.length > 0) {
            // This line is empty, but it contains inline decorations
            sb.appendString(`<span>`);
            let beforeCount = 0;
            let afterCount = 0;
            let containsForeignElements = 0 /* ForeignElementType.None */ ;
            for (const lineDecoration of input.lineDecorations)if (lineDecoration.type === 1 /* InlineDecorationType.Before */  || lineDecoration.type === 2 /* InlineDecorationType.After */ ) {
                sb.appendString(`<span class="`);
                sb.appendString(lineDecoration.className);
                sb.appendString(`"></span>`);
                if (lineDecoration.type === 1 /* InlineDecorationType.Before */ ) {
                    containsForeignElements |= 1 /* ForeignElementType.Before */ ;
                    beforeCount++;
                }
                if (lineDecoration.type === 2 /* InlineDecorationType.After */ ) {
                    containsForeignElements |= 2 /* ForeignElementType.After */ ;
                    afterCount++;
                }
            }
            sb.appendString(`</span>`);
            const characterMapping = new CharacterMapping(1, beforeCount + afterCount);
            characterMapping.setColumnInfo(1, beforeCount, 0, 0);
            return new RenderLineOutput(characterMapping, false, containsForeignElements);
        }
        // completely empty line
        sb.appendString("<span><span></span></span>");
        return new RenderLineOutput(new CharacterMapping(0, 0), false, 0 /* ForeignElementType.None */ );
    }
    return _renderLine(resolveRenderLineInput(input), sb);
}
class RenderLineOutput2 {
    constructor(characterMapping, html, containsRTL, containsForeignElements){
        this.characterMapping = characterMapping;
        this.html = html;
        this.containsRTL = containsRTL;
        this.containsForeignElements = containsForeignElements;
    }
}
function renderViewLine2(input) {
    const sb = new (0, _stringBuilderJs.StringBuilder)(10000);
    const out = renderViewLine(input, sb);
    return new RenderLineOutput2(out.characterMapping, sb.build(), out.containsRTL, out.containsForeignElements);
}
class ResolvedRenderLineInput {
    constructor(fontIsMonospace, canUseHalfwidthRightwardsArrow, lineContent, len, isOverflowing, overflowingCharCount, parts, containsForeignElements, fauxIndentLength, tabSize, startVisibleColumn, containsRTL, spaceWidth, renderSpaceCharCode, renderWhitespace, renderControlCharacters){
        this.fontIsMonospace = fontIsMonospace;
        this.canUseHalfwidthRightwardsArrow = canUseHalfwidthRightwardsArrow;
        this.lineContent = lineContent;
        this.len = len;
        this.isOverflowing = isOverflowing;
        this.overflowingCharCount = overflowingCharCount;
        this.parts = parts;
        this.containsForeignElements = containsForeignElements;
        this.fauxIndentLength = fauxIndentLength;
        this.tabSize = tabSize;
        this.startVisibleColumn = startVisibleColumn;
        this.containsRTL = containsRTL;
        this.spaceWidth = spaceWidth;
        this.renderSpaceCharCode = renderSpaceCharCode;
        this.renderWhitespace = renderWhitespace;
        this.renderControlCharacters = renderControlCharacters;
    //
    }
}
function resolveRenderLineInput(input) {
    const lineContent = input.lineContent;
    let isOverflowing;
    let overflowingCharCount;
    let len;
    if (input.stopRenderingLineAfter !== -1 && input.stopRenderingLineAfter < lineContent.length) {
        isOverflowing = true;
        overflowingCharCount = lineContent.length - input.stopRenderingLineAfter;
        len = input.stopRenderingLineAfter;
    } else {
        isOverflowing = false;
        overflowingCharCount = 0;
        len = lineContent.length;
    }
    let tokens = transformAndRemoveOverflowing(lineContent, input.containsRTL, input.lineTokens, input.fauxIndentLength, len);
    if (input.renderControlCharacters && !input.isBasicASCII) // Calling `extractControlCharacters` before adding (possibly empty) line parts
    // for inline decorations. `extractControlCharacters` removes empty line parts.
    tokens = extractControlCharacters(lineContent, tokens);
    if (input.renderWhitespace === 4 /* RenderWhitespace.All */  || input.renderWhitespace === 1 /* RenderWhitespace.Boundary */  || input.renderWhitespace === 2 /* RenderWhitespace.Selection */  && !!input.selectionsOnLine || input.renderWhitespace === 3 /* RenderWhitespace.Trailing */  && !input.continuesWithWrappedLine) tokens = _applyRenderWhitespace(input, lineContent, len, tokens);
    let containsForeignElements = 0 /* ForeignElementType.None */ ;
    if (input.lineDecorations.length > 0) {
        for(let i = 0, len = input.lineDecorations.length; i < len; i++){
            const lineDecoration = input.lineDecorations[i];
            if (lineDecoration.type === 3 /* InlineDecorationType.RegularAffectingLetterSpacing */ ) // Pretend there are foreign elements... although not 100% accurate.
            containsForeignElements |= 1 /* ForeignElementType.Before */ ;
            else if (lineDecoration.type === 1 /* InlineDecorationType.Before */ ) containsForeignElements |= 1 /* ForeignElementType.Before */ ;
            else if (lineDecoration.type === 2 /* InlineDecorationType.After */ ) containsForeignElements |= 2 /* ForeignElementType.After */ ;
        }
        tokens = _applyInlineDecorations(lineContent, len, tokens, input.lineDecorations);
    }
    if (!input.containsRTL) // We can never split RTL text, as it ruins the rendering
    tokens = splitLargeTokens(lineContent, tokens, !input.isBasicASCII || input.fontLigatures);
    return new ResolvedRenderLineInput(input.useMonospaceOptimizations, input.canUseHalfwidthRightwardsArrow, lineContent, len, isOverflowing, overflowingCharCount, tokens, containsForeignElements, input.fauxIndentLength, input.tabSize, input.startVisibleColumn, input.containsRTL, input.spaceWidth, input.renderSpaceCharCode, input.renderWhitespace, input.renderControlCharacters);
}
/**
 * In the rendering phase, characters are always looped until token.endIndex.
 * Ensure that all tokens end before `len` and the last one ends precisely at `len`.
 */ function transformAndRemoveOverflowing(lineContent, lineContainsRTL, tokens, fauxIndentLength, len) {
    const result = [];
    let resultLen = 0;
    // The faux indent part of the line should have no token type
    if (fauxIndentLength > 0) result[resultLen++] = new (0, _linePartJs.LinePart)(fauxIndentLength, "", 0, false);
    let startOffset = fauxIndentLength;
    for(let tokenIndex = 0, tokensLen = tokens.getCount(); tokenIndex < tokensLen; tokenIndex++){
        const endIndex = tokens.getEndOffset(tokenIndex);
        if (endIndex <= fauxIndentLength) continue;
        const type = tokens.getClassName(tokenIndex);
        if (endIndex >= len) {
            const tokenContainsRTL = lineContainsRTL ? _stringsJs.containsRTL(lineContent.substring(startOffset, len)) : false;
            result[resultLen++] = new (0, _linePartJs.LinePart)(len, type, 0, tokenContainsRTL);
            break;
        }
        const tokenContainsRTL = lineContainsRTL ? _stringsJs.containsRTL(lineContent.substring(startOffset, endIndex)) : false;
        result[resultLen++] = new (0, _linePartJs.LinePart)(endIndex, type, 0, tokenContainsRTL);
        startOffset = endIndex;
    }
    return result;
}
/**
 * See https://github.com/microsoft/vscode/issues/6885.
 * It appears that having very large spans causes very slow reading of character positions.
 * So here we try to avoid that.
 */ function splitLargeTokens(lineContent, tokens, onlyAtSpaces) {
    let lastTokenEndIndex = 0;
    const result = [];
    let resultLen = 0;
    if (onlyAtSpaces) // Split only at spaces => we need to walk each character
    for(let i = 0, len = tokens.length; i < len; i++){
        const token = tokens[i];
        const tokenEndIndex = token.endIndex;
        if (lastTokenEndIndex + 50 /* Constants.LongToken */  < tokenEndIndex) {
            const tokenType = token.type;
            const tokenMetadata = token.metadata;
            const tokenContainsRTL = token.containsRTL;
            let lastSpaceOffset = -1;
            let currTokenStart = lastTokenEndIndex;
            for(let j = lastTokenEndIndex; j < tokenEndIndex; j++){
                if (lineContent.charCodeAt(j) === 32 /* CharCode.Space */ ) lastSpaceOffset = j;
                if (lastSpaceOffset !== -1 && j - currTokenStart >= 50 /* Constants.LongToken */ ) {
                    // Split at `lastSpaceOffset` + 1
                    result[resultLen++] = new (0, _linePartJs.LinePart)(lastSpaceOffset + 1, tokenType, tokenMetadata, tokenContainsRTL);
                    currTokenStart = lastSpaceOffset + 1;
                    lastSpaceOffset = -1;
                }
            }
            if (currTokenStart !== tokenEndIndex) result[resultLen++] = new (0, _linePartJs.LinePart)(tokenEndIndex, tokenType, tokenMetadata, tokenContainsRTL);
        } else result[resultLen++] = token;
        lastTokenEndIndex = tokenEndIndex;
    }
    else // Split anywhere => we don't need to walk each character
    for(let i = 0, len = tokens.length; i < len; i++){
        const token = tokens[i];
        const tokenEndIndex = token.endIndex;
        const diff = tokenEndIndex - lastTokenEndIndex;
        if (diff > 50 /* Constants.LongToken */ ) {
            const tokenType = token.type;
            const tokenMetadata = token.metadata;
            const tokenContainsRTL = token.containsRTL;
            const piecesCount = Math.ceil(diff / 50 /* Constants.LongToken */ );
            for(let j = 1; j < piecesCount; j++){
                const pieceEndIndex = lastTokenEndIndex + j * 50 /* Constants.LongToken */ ;
                result[resultLen++] = new (0, _linePartJs.LinePart)(pieceEndIndex, tokenType, tokenMetadata, tokenContainsRTL);
            }
            result[resultLen++] = new (0, _linePartJs.LinePart)(tokenEndIndex, tokenType, tokenMetadata, tokenContainsRTL);
        } else result[resultLen++] = token;
        lastTokenEndIndex = tokenEndIndex;
    }
    return result;
}
function isControlCharacter(charCode) {
    if (charCode < 32) return charCode !== 9 /* CharCode.Tab */ ;
    if (charCode === 127) // DEL
    return true;
    if (charCode >= 0x202A && charCode <= 0x202E || charCode >= 0x2066 && charCode <= 0x2069 || charCode >= 0x200E && charCode <= 0x200F || charCode === 0x061C) // Unicode Directional Formatting Characters
    // LRE	U+202A	LEFT-TO-RIGHT EMBEDDING
    // RLE	U+202B	RIGHT-TO-LEFT EMBEDDING
    // PDF	U+202C	POP DIRECTIONAL FORMATTING
    // LRO	U+202D	LEFT-TO-RIGHT OVERRIDE
    // RLO	U+202E	RIGHT-TO-LEFT OVERRIDE
    // LRI	U+2066	LEFT-TO-RIGHT ISOLATE
    // RLI	U+2067	RIGHT-TO-LEFT ISOLATE
    // FSI	U+2068	FIRST STRONG ISOLATE
    // PDI	U+2069	POP DIRECTIONAL ISOLATE
    // LRM	U+200E	LEFT-TO-RIGHT MARK
    // RLM	U+200F	RIGHT-TO-LEFT MARK
    // ALM	U+061C	ARABIC LETTER MARK
    return true;
    return false;
}
function extractControlCharacters(lineContent, tokens) {
    const result = [];
    let lastLinePart = new (0, _linePartJs.LinePart)(0, "", 0, false);
    let charOffset = 0;
    for (const token of tokens){
        const tokenEndIndex = token.endIndex;
        for(; charOffset < tokenEndIndex; charOffset++){
            const charCode = lineContent.charCodeAt(charOffset);
            if (isControlCharacter(charCode)) {
                if (charOffset > lastLinePart.endIndex) {
                    // emit previous part if it has text
                    lastLinePart = new (0, _linePartJs.LinePart)(charOffset, token.type, token.metadata, token.containsRTL);
                    result.push(lastLinePart);
                }
                lastLinePart = new (0, _linePartJs.LinePart)(charOffset + 1, "mtkcontrol", token.metadata, false);
                result.push(lastLinePart);
            }
        }
        if (charOffset > lastLinePart.endIndex) {
            // emit previous part if it has text
            lastLinePart = new (0, _linePartJs.LinePart)(tokenEndIndex, token.type, token.metadata, token.containsRTL);
            result.push(lastLinePart);
        }
    }
    return result;
}
/**
 * Whitespace is rendered by "replacing" tokens with a special-purpose `mtkw` type that is later recognized in the rendering phase.
 * Moreover, a token is created for every visual indent because on some fonts the glyphs used for rendering whitespace (&rarr; or &middot;) do not have the same width as &nbsp;.
 * The rendering phase will generate `style="width:..."` for these tokens.
 */ function _applyRenderWhitespace(input, lineContent, len, tokens) {
    const continuesWithWrappedLine = input.continuesWithWrappedLine;
    const fauxIndentLength = input.fauxIndentLength;
    const tabSize = input.tabSize;
    const startVisibleColumn = input.startVisibleColumn;
    const useMonospaceOptimizations = input.useMonospaceOptimizations;
    const selections = input.selectionsOnLine;
    const onlyBoundary = input.renderWhitespace === 1 /* RenderWhitespace.Boundary */ ;
    const onlyTrailing = input.renderWhitespace === 3 /* RenderWhitespace.Trailing */ ;
    const generateLinePartForEachWhitespace = input.renderSpaceWidth !== input.spaceWidth;
    const result = [];
    let resultLen = 0;
    let tokenIndex = 0;
    let tokenType = tokens[tokenIndex].type;
    let tokenContainsRTL = tokens[tokenIndex].containsRTL;
    let tokenEndIndex = tokens[tokenIndex].endIndex;
    const tokensLength = tokens.length;
    let lineIsEmptyOrWhitespace = false;
    let firstNonWhitespaceIndex = _stringsJs.firstNonWhitespaceIndex(lineContent);
    let lastNonWhitespaceIndex;
    if (firstNonWhitespaceIndex === -1) {
        lineIsEmptyOrWhitespace = true;
        firstNonWhitespaceIndex = len;
        lastNonWhitespaceIndex = len;
    } else lastNonWhitespaceIndex = _stringsJs.lastNonWhitespaceIndex(lineContent);
    let wasInWhitespace = false;
    let currentSelectionIndex = 0;
    let currentSelection = selections && selections[currentSelectionIndex];
    let tmpIndent = startVisibleColumn % tabSize;
    for(let charIndex = fauxIndentLength; charIndex < len; charIndex++){
        const chCode = lineContent.charCodeAt(charIndex);
        if (currentSelection && charIndex >= currentSelection.endOffset) {
            currentSelectionIndex++;
            currentSelection = selections && selections[currentSelectionIndex];
        }
        let isInWhitespace;
        if (charIndex < firstNonWhitespaceIndex || charIndex > lastNonWhitespaceIndex) // in leading or trailing whitespace
        isInWhitespace = true;
        else if (chCode === 9 /* CharCode.Tab */ ) // a tab character is rendered both in all and boundary cases
        isInWhitespace = true;
        else if (chCode === 32 /* CharCode.Space */ ) {
            // hit a space character
            if (onlyBoundary) {
                // rendering only boundary whitespace
                if (wasInWhitespace) isInWhitespace = true;
                else {
                    const nextChCode = charIndex + 1 < len ? lineContent.charCodeAt(charIndex + 1) : 0 /* CharCode.Null */ ;
                    isInWhitespace = nextChCode === 32 /* CharCode.Space */  || nextChCode === 9 /* CharCode.Tab */ ;
                }
            } else isInWhitespace = true;
        } else isInWhitespace = false;
        // If rendering whitespace on selection, check that the charIndex falls within a selection
        if (isInWhitespace && selections) isInWhitespace = !!currentSelection && currentSelection.startOffset <= charIndex && currentSelection.endOffset > charIndex;
        // If rendering only trailing whitespace, check that the charIndex points to trailing whitespace.
        if (isInWhitespace && onlyTrailing) isInWhitespace = lineIsEmptyOrWhitespace || charIndex > lastNonWhitespaceIndex;
        if (isInWhitespace && tokenContainsRTL) // If the token contains RTL text, breaking it up into multiple line parts
        // to render whitespace might affect the browser's bidi layout.
        //
        // We render whitespace in such tokens only if the whitespace
        // is the leading or the trailing whitespace of the line,
        // which doesn't affect the browser's bidi layout.
        {
            if (charIndex >= firstNonWhitespaceIndex && charIndex <= lastNonWhitespaceIndex) isInWhitespace = false;
        }
        if (wasInWhitespace) // was in whitespace token
        {
            if (!isInWhitespace || !useMonospaceOptimizations && tmpIndent >= tabSize) {
                // leaving whitespace token or entering a new indent
                if (generateLinePartForEachWhitespace) {
                    const lastEndIndex = resultLen > 0 ? result[resultLen - 1].endIndex : fauxIndentLength;
                    for(let i = lastEndIndex + 1; i <= charIndex; i++)result[resultLen++] = new (0, _linePartJs.LinePart)(i, "mtkw", 1 /* LinePartMetadata.IS_WHITESPACE */ , false);
                } else result[resultLen++] = new (0, _linePartJs.LinePart)(charIndex, "mtkw", 1 /* LinePartMetadata.IS_WHITESPACE */ , false);
                tmpIndent = tmpIndent % tabSize;
            }
        } else // was in regular token
        if (charIndex === tokenEndIndex || isInWhitespace && charIndex > fauxIndentLength) {
            result[resultLen++] = new (0, _linePartJs.LinePart)(charIndex, tokenType, 0, tokenContainsRTL);
            tmpIndent = tmpIndent % tabSize;
        }
        if (chCode === 9 /* CharCode.Tab */ ) tmpIndent = tabSize;
        else if (_stringsJs.isFullWidthCharacter(chCode)) tmpIndent += 2;
        else tmpIndent++;
        wasInWhitespace = isInWhitespace;
        while(charIndex === tokenEndIndex){
            tokenIndex++;
            if (tokenIndex < tokensLength) {
                tokenType = tokens[tokenIndex].type;
                tokenContainsRTL = tokens[tokenIndex].containsRTL;
                tokenEndIndex = tokens[tokenIndex].endIndex;
            } else break;
        }
    }
    let generateWhitespace = false;
    if (wasInWhitespace) {
        // was in whitespace token
        if (continuesWithWrappedLine && onlyBoundary) {
            const lastCharCode = len > 0 ? lineContent.charCodeAt(len - 1) : 0 /* CharCode.Null */ ;
            const prevCharCode = len > 1 ? lineContent.charCodeAt(len - 2) : 0 /* CharCode.Null */ ;
            const isSingleTrailingSpace = lastCharCode === 32 /* CharCode.Space */  && prevCharCode !== 32 /* CharCode.Space */  && prevCharCode !== 9 /* CharCode.Tab */ ;
            if (!isSingleTrailingSpace) generateWhitespace = true;
        } else generateWhitespace = true;
    }
    if (generateWhitespace) {
        if (generateLinePartForEachWhitespace) {
            const lastEndIndex = resultLen > 0 ? result[resultLen - 1].endIndex : fauxIndentLength;
            for(let i = lastEndIndex + 1; i <= len; i++)result[resultLen++] = new (0, _linePartJs.LinePart)(i, "mtkw", 1 /* LinePartMetadata.IS_WHITESPACE */ , false);
        } else result[resultLen++] = new (0, _linePartJs.LinePart)(len, "mtkw", 1 /* LinePartMetadata.IS_WHITESPACE */ , false);
    } else result[resultLen++] = new (0, _linePartJs.LinePart)(len, tokenType, 0, tokenContainsRTL);
    return result;
}
/**
 * Inline decorations are "merged" on top of tokens.
 * Special care must be taken when multiple inline decorations are at play and they overlap.
 */ function _applyInlineDecorations(lineContent, len, tokens, _lineDecorations) {
    _lineDecorations.sort((0, _lineDecorationsJs.LineDecoration).compare);
    const lineDecorations = (0, _lineDecorationsJs.LineDecorationsNormalizer).normalize(lineContent, _lineDecorations);
    const lineDecorationsLen = lineDecorations.length;
    let lineDecorationIndex = 0;
    const result = [];
    let resultLen = 0;
    let lastResultEndIndex = 0;
    for(let tokenIndex = 0, len = tokens.length; tokenIndex < len; tokenIndex++){
        const token = tokens[tokenIndex];
        const tokenEndIndex = token.endIndex;
        const tokenType = token.type;
        const tokenMetadata = token.metadata;
        const tokenContainsRTL = token.containsRTL;
        while(lineDecorationIndex < lineDecorationsLen && lineDecorations[lineDecorationIndex].startOffset < tokenEndIndex){
            const lineDecoration = lineDecorations[lineDecorationIndex];
            if (lineDecoration.startOffset > lastResultEndIndex) {
                lastResultEndIndex = lineDecoration.startOffset;
                result[resultLen++] = new (0, _linePartJs.LinePart)(lastResultEndIndex, tokenType, tokenMetadata, tokenContainsRTL);
            }
            if (lineDecoration.endOffset + 1 <= tokenEndIndex) {
                // This line decoration ends before this token ends
                lastResultEndIndex = lineDecoration.endOffset + 1;
                result[resultLen++] = new (0, _linePartJs.LinePart)(lastResultEndIndex, tokenType + " " + lineDecoration.className, tokenMetadata | lineDecoration.metadata, tokenContainsRTL);
                lineDecorationIndex++;
            } else {
                // This line decoration continues on to the next token
                lastResultEndIndex = tokenEndIndex;
                result[resultLen++] = new (0, _linePartJs.LinePart)(lastResultEndIndex, tokenType + " " + lineDecoration.className, tokenMetadata | lineDecoration.metadata, tokenContainsRTL);
                break;
            }
        }
        if (tokenEndIndex > lastResultEndIndex) {
            lastResultEndIndex = tokenEndIndex;
            result[resultLen++] = new (0, _linePartJs.LinePart)(lastResultEndIndex, tokenType, tokenMetadata, tokenContainsRTL);
        }
    }
    const lastTokenEndIndex = tokens[tokens.length - 1].endIndex;
    if (lineDecorationIndex < lineDecorationsLen && lineDecorations[lineDecorationIndex].startOffset === lastTokenEndIndex) while(lineDecorationIndex < lineDecorationsLen && lineDecorations[lineDecorationIndex].startOffset === lastTokenEndIndex){
        const lineDecoration = lineDecorations[lineDecorationIndex];
        result[resultLen++] = new (0, _linePartJs.LinePart)(lastResultEndIndex, lineDecoration.className, lineDecoration.metadata, false);
        lineDecorationIndex++;
    }
    return result;
}
/**
 * This function is on purpose not split up into multiple functions to allow runtime type inference (i.e. performance reasons).
 * Notice how all the needed data is fully resolved and passed in (i.e. no other calls).
 */ function _renderLine(input, sb) {
    const fontIsMonospace = input.fontIsMonospace;
    const canUseHalfwidthRightwardsArrow = input.canUseHalfwidthRightwardsArrow;
    const containsForeignElements = input.containsForeignElements;
    const lineContent = input.lineContent;
    const len = input.len;
    const isOverflowing = input.isOverflowing;
    const overflowingCharCount = input.overflowingCharCount;
    const parts = input.parts;
    const fauxIndentLength = input.fauxIndentLength;
    const tabSize = input.tabSize;
    const startVisibleColumn = input.startVisibleColumn;
    const containsRTL = input.containsRTL;
    const spaceWidth = input.spaceWidth;
    const renderSpaceCharCode = input.renderSpaceCharCode;
    const renderWhitespace = input.renderWhitespace;
    const renderControlCharacters = input.renderControlCharacters;
    const characterMapping = new CharacterMapping(len + 1, parts.length);
    let lastCharacterMappingDefined = false;
    let charIndex = 0;
    let visibleColumn = startVisibleColumn;
    let charOffsetInPart = 0; // the character offset in the current part
    let charHorizontalOffset = 0; // the character horizontal position in terms of chars relative to line start
    let partDisplacement = 0;
    if (containsRTL) sb.appendString('<span dir="ltr">');
    else sb.appendString("<span>");
    for(let partIndex = 0, tokensLen = parts.length; partIndex < tokensLen; partIndex++){
        const part = parts[partIndex];
        const partEndIndex = part.endIndex;
        const partType = part.type;
        const partContainsRTL = part.containsRTL;
        const partRendersWhitespace = renderWhitespace !== 0 /* RenderWhitespace.None */  && part.isWhitespace();
        const partRendersWhitespaceWithWidth = partRendersWhitespace && !fontIsMonospace && (partType === "mtkw" /*only whitespace*/  || !containsForeignElements);
        const partIsEmptyAndHasPseudoAfter = charIndex === partEndIndex && part.isPseudoAfter();
        charOffsetInPart = 0;
        sb.appendString("<span ");
        if (partContainsRTL) sb.appendString('style="unicode-bidi:isolate" ');
        sb.appendString('class="');
        sb.appendString(partRendersWhitespaceWithWidth ? "mtkz" : partType);
        sb.appendASCIICharCode(34 /* CharCode.DoubleQuote */ );
        if (partRendersWhitespace) {
            let partWidth = 0;
            {
                let _charIndex = charIndex;
                let _visibleColumn = visibleColumn;
                for(; _charIndex < partEndIndex; _charIndex++){
                    const charCode = lineContent.charCodeAt(_charIndex);
                    const charWidth = (charCode === 9 /* CharCode.Tab */  ? tabSize - _visibleColumn % tabSize : 1) | 0;
                    partWidth += charWidth;
                    if (_charIndex >= fauxIndentLength) _visibleColumn += charWidth;
                }
            }
            if (partRendersWhitespaceWithWidth) {
                sb.appendString(' style="width:');
                sb.appendString(String(spaceWidth * partWidth));
                sb.appendString('px"');
            }
            sb.appendASCIICharCode(62 /* CharCode.GreaterThan */ );
            for(; charIndex < partEndIndex; charIndex++){
                characterMapping.setColumnInfo(charIndex + 1, partIndex - partDisplacement, charOffsetInPart, charHorizontalOffset);
                partDisplacement = 0;
                const charCode = lineContent.charCodeAt(charIndex);
                let producedCharacters;
                let charWidth;
                if (charCode === 9 /* CharCode.Tab */ ) {
                    producedCharacters = tabSize - visibleColumn % tabSize | 0;
                    charWidth = producedCharacters;
                    if (!canUseHalfwidthRightwardsArrow || charWidth > 1) sb.appendCharCode(0x2192); // RIGHTWARDS ARROW
                    else sb.appendCharCode(0xFFEB); // HALFWIDTH RIGHTWARDS ARROW
                    for(let space = 2; space <= charWidth; space++)sb.appendCharCode(0xA0); // &nbsp;
                } else {
                    producedCharacters = 2;
                    charWidth = 1;
                    sb.appendCharCode(renderSpaceCharCode); // &middot; or word separator middle dot
                    sb.appendCharCode(0x200C); // ZERO WIDTH NON-JOINER
                }
                charOffsetInPart += producedCharacters;
                charHorizontalOffset += charWidth;
                if (charIndex >= fauxIndentLength) visibleColumn += charWidth;
            }
        } else {
            sb.appendASCIICharCode(62 /* CharCode.GreaterThan */ );
            for(; charIndex < partEndIndex; charIndex++){
                characterMapping.setColumnInfo(charIndex + 1, partIndex - partDisplacement, charOffsetInPart, charHorizontalOffset);
                partDisplacement = 0;
                const charCode = lineContent.charCodeAt(charIndex);
                let producedCharacters = 1;
                let charWidth = 1;
                switch(charCode){
                    case 9 /* CharCode.Tab */ :
                        producedCharacters = tabSize - visibleColumn % tabSize;
                        charWidth = producedCharacters;
                        for(let space = 1; space <= producedCharacters; space++)sb.appendCharCode(0xA0); // &nbsp;
                        break;
                    case 32 /* CharCode.Space */ :
                        sb.appendCharCode(0xA0); // &nbsp;
                        break;
                    case 60 /* CharCode.LessThan */ :
                        sb.appendString("&lt;");
                        break;
                    case 62 /* CharCode.GreaterThan */ :
                        sb.appendString("&gt;");
                        break;
                    case 38 /* CharCode.Ampersand */ :
                        sb.appendString("&amp;");
                        break;
                    case 0 /* CharCode.Null */ :
                        if (renderControlCharacters) // See https://unicode-table.com/en/blocks/control-pictures/
                        sb.appendCharCode(9216);
                        else sb.appendString("&#00;");
                        break;
                    case 65279 /* CharCode.UTF8_BOM */ :
                    case 8232 /* CharCode.LINE_SEPARATOR */ :
                    case 8233 /* CharCode.PARAGRAPH_SEPARATOR */ :
                    case 133 /* CharCode.NEXT_LINE */ :
                        sb.appendCharCode(0xFFFD);
                        break;
                    default:
                        if (_stringsJs.isFullWidthCharacter(charCode)) charWidth++;
                        // See https://unicode-table.com/en/blocks/control-pictures/
                        if (renderControlCharacters && charCode < 32) sb.appendCharCode(9216 + charCode);
                        else if (renderControlCharacters && charCode === 127) // DEL
                        sb.appendCharCode(9249);
                        else if (renderControlCharacters && isControlCharacter(charCode)) {
                            sb.appendString("[U+");
                            sb.appendString(to4CharHex(charCode));
                            sb.appendString("]");
                            producedCharacters = 8;
                            charWidth = producedCharacters;
                        } else sb.appendCharCode(charCode);
                }
                charOffsetInPart += producedCharacters;
                charHorizontalOffset += charWidth;
                if (charIndex >= fauxIndentLength) visibleColumn += charWidth;
            }
        }
        if (partIsEmptyAndHasPseudoAfter) partDisplacement++;
        else partDisplacement = 0;
        if (charIndex >= len && !lastCharacterMappingDefined && part.isPseudoAfter()) {
            lastCharacterMappingDefined = true;
            characterMapping.setColumnInfo(charIndex + 1, partIndex, charOffsetInPart, charHorizontalOffset);
        }
        sb.appendString("</span>");
    }
    if (!lastCharacterMappingDefined) // When getting client rects for the last character, we will position the
    // text range at the end of the span, insteaf of at the beginning of next span
    characterMapping.setColumnInfo(len + 1, parts.length - 1, charOffsetInPart, charHorizontalOffset);
    if (isOverflowing) {
        sb.appendString('<span class="mtkoverflow">');
        sb.appendString(_nlsJs.localize("showMore", "Show more ({0})", renderOverflowingCharCount(overflowingCharCount)));
        sb.appendString("</span>");
    }
    sb.appendString("</span>");
    return new RenderLineOutput(characterMapping, containsRTL, containsForeignElements);
}
function to4CharHex(n) {
    return n.toString(16).toUpperCase().padStart(4, "0");
}
function renderOverflowingCharCount(n) {
    if (n < 1024) return _nlsJs.localize("overflow.chars", "{0} chars", n);
    if (n < 1048576) return `${(n / 1024).toFixed(1)} KB`;
    return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

},{"../../../nls.js":"l617d","../../../base/common/strings.js":"aA9I1","../core/stringBuilder.js":"hHgWQ","./lineDecorations.js":"m2bJX","./linePart.js":"bMQ1E","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"m2bJX":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineDecoration", ()=>LineDecoration);
parcelHelpers.export(exports, "DecorationSegment", ()=>DecorationSegment);
parcelHelpers.export(exports, "LineDecorationsNormalizer", ()=>LineDecorationsNormalizer);
var _stringsJs = require("../../../base/common/strings.js");
class LineDecoration {
    constructor(startColumn, endColumn, className, type){
        this.startColumn = startColumn;
        this.endColumn = endColumn;
        this.className = className;
        this.type = type;
        this._lineDecorationBrand = undefined;
    }
    static _equals(a, b) {
        return a.startColumn === b.startColumn && a.endColumn === b.endColumn && a.className === b.className && a.type === b.type;
    }
    static equalsArr(a, b) {
        const aLen = a.length;
        const bLen = b.length;
        if (aLen !== bLen) return false;
        for(let i = 0; i < aLen; i++){
            if (!LineDecoration._equals(a[i], b[i])) return false;
        }
        return true;
    }
    static extractWrapped(arr, startOffset, endOffset) {
        if (arr.length === 0) return arr;
        const startColumn = startOffset + 1;
        const endColumn = endOffset + 1;
        const lineLength = endOffset - startOffset;
        const r = [];
        let rLength = 0;
        for (const dec of arr){
            if (dec.endColumn <= startColumn || dec.startColumn >= endColumn) continue;
            r[rLength++] = new LineDecoration(Math.max(1, dec.startColumn - startColumn + 1), Math.min(lineLength + 1, dec.endColumn - startColumn + 1), dec.className, dec.type);
        }
        return r;
    }
    static filter(lineDecorations, lineNumber, minLineColumn, maxLineColumn) {
        if (lineDecorations.length === 0) return [];
        const result = [];
        let resultLen = 0;
        for(let i = 0, len = lineDecorations.length; i < len; i++){
            const d = lineDecorations[i];
            const range = d.range;
            if (range.endLineNumber < lineNumber || range.startLineNumber > lineNumber) continue;
            if (range.isEmpty() && (d.type === 0 /* InlineDecorationType.Regular */  || d.type === 3 /* InlineDecorationType.RegularAffectingLetterSpacing */ )) continue;
            const startColumn = range.startLineNumber === lineNumber ? range.startColumn : minLineColumn;
            const endColumn = range.endLineNumber === lineNumber ? range.endColumn : maxLineColumn;
            result[resultLen++] = new LineDecoration(startColumn, endColumn, d.inlineClassName, d.type);
        }
        return result;
    }
    static _typeCompare(a, b) {
        const ORDER = [
            2,
            0,
            1,
            3
        ];
        return ORDER[a] - ORDER[b];
    }
    static compare(a, b) {
        if (a.startColumn !== b.startColumn) return a.startColumn - b.startColumn;
        if (a.endColumn !== b.endColumn) return a.endColumn - b.endColumn;
        const typeCmp = LineDecoration._typeCompare(a.type, b.type);
        if (typeCmp !== 0) return typeCmp;
        if (a.className !== b.className) return a.className < b.className ? -1 : 1;
        return 0;
    }
}
class DecorationSegment {
    constructor(startOffset, endOffset, className, metadata){
        this.startOffset = startOffset;
        this.endOffset = endOffset;
        this.className = className;
        this.metadata = metadata;
    }
}
class Stack {
    constructor(){
        this.stopOffsets = [];
        this.classNames = [];
        this.metadata = [];
        this.count = 0;
    }
    static _metadata(metadata) {
        let result = 0;
        for(let i = 0, len = metadata.length; i < len; i++)result |= metadata[i];
        return result;
    }
    consumeLowerThan(maxStopOffset, nextStartOffset, result) {
        while(this.count > 0 && this.stopOffsets[0] < maxStopOffset){
            let i = 0;
            // Take all equal stopping offsets
            while(i + 1 < this.count && this.stopOffsets[i] === this.stopOffsets[i + 1])i++;
            // Basically we are consuming the first i + 1 elements of the stack
            result.push(new DecorationSegment(nextStartOffset, this.stopOffsets[i], this.classNames.join(" "), Stack._metadata(this.metadata)));
            nextStartOffset = this.stopOffsets[i] + 1;
            // Consume them
            this.stopOffsets.splice(0, i + 1);
            this.classNames.splice(0, i + 1);
            this.metadata.splice(0, i + 1);
            this.count -= i + 1;
        }
        if (this.count > 0 && nextStartOffset < maxStopOffset) {
            result.push(new DecorationSegment(nextStartOffset, maxStopOffset - 1, this.classNames.join(" "), Stack._metadata(this.metadata)));
            nextStartOffset = maxStopOffset;
        }
        return nextStartOffset;
    }
    insert(stopOffset, className, metadata) {
        if (this.count === 0 || this.stopOffsets[this.count - 1] <= stopOffset) {
            // Insert at the end
            this.stopOffsets.push(stopOffset);
            this.classNames.push(className);
            this.metadata.push(metadata);
        } else {
            // Find the insertion position for `stopOffset`
            for(let i = 0; i < this.count; i++)if (this.stopOffsets[i] >= stopOffset) {
                this.stopOffsets.splice(i, 0, stopOffset);
                this.classNames.splice(i, 0, className);
                this.metadata.splice(i, 0, metadata);
                break;
            }
        }
        this.count++;
        return;
    }
}
class LineDecorationsNormalizer {
    /**
     * Normalize line decorations. Overlapping decorations will generate multiple segments
     */ static normalize(lineContent, lineDecorations) {
        if (lineDecorations.length === 0) return [];
        const result = [];
        const stack = new Stack();
        let nextStartOffset = 0;
        for(let i = 0, len = lineDecorations.length; i < len; i++){
            const d = lineDecorations[i];
            let startColumn = d.startColumn;
            let endColumn = d.endColumn;
            const className = d.className;
            const metadata = d.type === 1 /* InlineDecorationType.Before */  ? 2 /* LinePartMetadata.PSEUDO_BEFORE */  : d.type === 2 /* InlineDecorationType.After */  ? 4 /* LinePartMetadata.PSEUDO_AFTER */  : 0;
            // If the position would end up in the middle of a high-low surrogate pair, we move it to before the pair
            if (startColumn > 1) {
                const charCodeBefore = lineContent.charCodeAt(startColumn - 2);
                if (_stringsJs.isHighSurrogate(charCodeBefore)) startColumn--;
            }
            if (endColumn > 1) {
                const charCodeBefore = lineContent.charCodeAt(endColumn - 2);
                if (_stringsJs.isHighSurrogate(charCodeBefore)) endColumn--;
            }
            const currentStartOffset = startColumn - 1;
            const currentEndOffset = endColumn - 2;
            nextStartOffset = stack.consumeLowerThan(currentStartOffset, nextStartOffset, result);
            if (stack.count === 0) nextStartOffset = currentStartOffset;
            stack.insert(currentEndOffset, className, metadata);
        }
        stack.consumeLowerThan(1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ , nextStartOffset, result);
        return result;
    }
}

},{"../../../base/common/strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bMQ1E":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinePart", ()=>LinePart);
class LinePart {
    constructor(/**
     * last char index of this token (not inclusive).
     */ endIndex, type, metadata, containsRTL){
        this.endIndex = endIndex;
        this.type = type;
        this.metadata = metadata;
        this.containsRTL = containsRTL;
        this._linePartBrand = undefined;
    }
    isWhitespace() {
        return this.metadata & 1 /* LinePartMetadata.IS_WHITESPACE_MASK */  ? true : false;
    }
    isPseudoAfter() {
        return this.metadata & 4 /* LinePartMetadata.PSEUDO_AFTER_MASK */  ? true : false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5EHxj":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Viewport", ()=>Viewport);
parcelHelpers.export(exports, "MinimapLinesRenderingData", ()=>MinimapLinesRenderingData);
parcelHelpers.export(exports, "ViewLineData", ()=>ViewLineData);
parcelHelpers.export(exports, "ViewLineRenderingData", ()=>ViewLineRenderingData);
parcelHelpers.export(exports, "InlineDecoration", ()=>InlineDecoration);
parcelHelpers.export(exports, "SingleLineInlineDecoration", ()=>SingleLineInlineDecoration);
parcelHelpers.export(exports, "ViewModelDecoration", ()=>ViewModelDecoration);
parcelHelpers.export(exports, "OverviewRulerDecorationsGroup", ()=>OverviewRulerDecorationsGroup);
var _arraysJs = require("../../base/common/arrays.js");
var _stringsJs = require("../../base/common/strings.js");
var _rangeJs = require("./core/range.js");
class Viewport {
    constructor(top, left, width, height){
        this._viewportBrand = undefined;
        this.top = top | 0;
        this.left = left | 0;
        this.width = width | 0;
        this.height = height | 0;
    }
}
class MinimapLinesRenderingData {
    constructor(tabSize, data){
        this.tabSize = tabSize;
        this.data = data;
    }
}
class ViewLineData {
    constructor(content, continuesWithWrappedLine, minColumn, maxColumn, startVisibleColumn, tokens, inlineDecorations){
        this._viewLineDataBrand = undefined;
        this.content = content;
        this.continuesWithWrappedLine = continuesWithWrappedLine;
        this.minColumn = minColumn;
        this.maxColumn = maxColumn;
        this.startVisibleColumn = startVisibleColumn;
        this.tokens = tokens;
        this.inlineDecorations = inlineDecorations;
    }
}
class ViewLineRenderingData {
    constructor(minColumn, maxColumn, content, continuesWithWrappedLine, mightContainRTL, mightContainNonBasicASCII, tokens, inlineDecorations, tabSize, startVisibleColumn){
        this.minColumn = minColumn;
        this.maxColumn = maxColumn;
        this.content = content;
        this.continuesWithWrappedLine = continuesWithWrappedLine;
        this.isBasicASCII = ViewLineRenderingData.isBasicASCII(content, mightContainNonBasicASCII);
        this.containsRTL = ViewLineRenderingData.containsRTL(content, this.isBasicASCII, mightContainRTL);
        this.tokens = tokens;
        this.inlineDecorations = inlineDecorations;
        this.tabSize = tabSize;
        this.startVisibleColumn = startVisibleColumn;
    }
    static isBasicASCII(lineContent, mightContainNonBasicASCII) {
        if (mightContainNonBasicASCII) return _stringsJs.isBasicASCII(lineContent);
        return true;
    }
    static containsRTL(lineContent, isBasicASCII, mightContainRTL) {
        if (!isBasicASCII && mightContainRTL) return _stringsJs.containsRTL(lineContent);
        return false;
    }
}
class InlineDecoration {
    constructor(range, inlineClassName, type){
        this.range = range;
        this.inlineClassName = inlineClassName;
        this.type = type;
    }
}
class SingleLineInlineDecoration {
    constructor(startOffset, endOffset, inlineClassName, inlineClassNameAffectsLetterSpacing){
        this.startOffset = startOffset;
        this.endOffset = endOffset;
        this.inlineClassName = inlineClassName;
        this.inlineClassNameAffectsLetterSpacing = inlineClassNameAffectsLetterSpacing;
    }
    toInlineDecoration(lineNumber) {
        return new InlineDecoration(new (0, _rangeJs.Range)(lineNumber, this.startOffset + 1, lineNumber, this.endOffset + 1), this.inlineClassName, this.inlineClassNameAffectsLetterSpacing ? 3 /* InlineDecorationType.RegularAffectingLetterSpacing */  : 0 /* InlineDecorationType.Regular */ );
    }
}
class ViewModelDecoration {
    constructor(range, options){
        this._viewModelDecorationBrand = undefined;
        this.range = range;
        this.options = options;
    }
}
class OverviewRulerDecorationsGroup {
    constructor(color, zIndex, /**
     * Decorations are encoded in a number array using the following scheme:
     *  - 3*i = lane
     *  - 3*i+1 = startLineNumber
     *  - 3*i+2 = endLineNumber
     */ data){
        this.color = color;
        this.zIndex = zIndex;
        this.data = data;
    }
    static compareByRenderingProps(a, b) {
        if (a.zIndex === b.zIndex) {
            if (a.color < b.color) return -1;
            if (a.color > b.color) return 1;
            return 0;
        }
        return a.zIndex - b.zIndex;
    }
    static equals(a, b) {
        return a.color === b.color && a.zIndex === b.zIndex && _arraysJs.equals(a.data, b.data);
    }
    static equalsArr(a, b) {
        return _arraysJs.equals(a, b, OverviewRulerDecorationsGroup.equals);
    }
}

},{"../../base/common/arrays.js":"DECei","../../base/common/strings.js":"aA9I1","./core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1mCsI":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonarchTokenizer", ()=>MonarchTokenizer);
/**
 * Create a syntax highighter with a fully declarative JSON style lexer description
 * using regular expressions.
 */ var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _languagesJs = require("../../../common/languages.js");
var _nullTokenizeJs = require("../../../common/languages/nullTokenize.js");
var _monarchCommonJs = require("./monarchCommon.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var MonarchTokenizer_1;
const CACHE_STACK_DEPTH = 5;
/**
 * Reuse the same stack elements up to a certain depth.
 */ class MonarchStackElementFactory {
    static{
        this._INSTANCE = new MonarchStackElementFactory(CACHE_STACK_DEPTH);
    }
    static create(parent, state) {
        return this._INSTANCE.create(parent, state);
    }
    constructor(maxCacheDepth){
        this._maxCacheDepth = maxCacheDepth;
        this._entries = Object.create(null);
    }
    create(parent, state) {
        if (parent !== null && parent.depth >= this._maxCacheDepth) // no caching above a certain depth
        return new MonarchStackElement(parent, state);
        let stackElementId = MonarchStackElement.getStackElementId(parent);
        if (stackElementId.length > 0) stackElementId += "|";
        stackElementId += state;
        let result = this._entries[stackElementId];
        if (result) return result;
        result = new MonarchStackElement(parent, state);
        this._entries[stackElementId] = result;
        return result;
    }
}
class MonarchStackElement {
    constructor(parent, state){
        this.parent = parent;
        this.state = state;
        this.depth = (this.parent ? this.parent.depth : 0) + 1;
    }
    static getStackElementId(element) {
        let result = "";
        while(element !== null){
            if (result.length > 0) result += "|";
            result += element.state;
            element = element.parent;
        }
        return result;
    }
    static _equals(a, b) {
        while(a !== null && b !== null){
            if (a === b) return true;
            if (a.state !== b.state) return false;
            a = a.parent;
            b = b.parent;
        }
        if (a === null && b === null) return true;
        return false;
    }
    equals(other) {
        return MonarchStackElement._equals(this, other);
    }
    push(state) {
        return MonarchStackElementFactory.create(this, state);
    }
    pop() {
        return this.parent;
    }
    popall() {
        let result = this;
        while(result.parent)result = result.parent;
        return result;
    }
    switchTo(state) {
        return MonarchStackElementFactory.create(this.parent, state);
    }
}
class EmbeddedLanguageData {
    constructor(languageId, state){
        this.languageId = languageId;
        this.state = state;
    }
    equals(other) {
        return this.languageId === other.languageId && this.state.equals(other.state);
    }
    clone() {
        const stateClone = this.state.clone();
        // save an object
        if (stateClone === this.state) return this;
        return new EmbeddedLanguageData(this.languageId, this.state);
    }
}
/**
 * Reuse the same line states up to a certain depth.
 */ class MonarchLineStateFactory {
    static{
        this._INSTANCE = new MonarchLineStateFactory(CACHE_STACK_DEPTH);
    }
    static create(stack, embeddedLanguageData) {
        return this._INSTANCE.create(stack, embeddedLanguageData);
    }
    constructor(maxCacheDepth){
        this._maxCacheDepth = maxCacheDepth;
        this._entries = Object.create(null);
    }
    create(stack, embeddedLanguageData) {
        if (embeddedLanguageData !== null) // no caching when embedding
        return new MonarchLineState(stack, embeddedLanguageData);
        if (stack !== null && stack.depth >= this._maxCacheDepth) // no caching above a certain depth
        return new MonarchLineState(stack, embeddedLanguageData);
        const stackElementId = MonarchStackElement.getStackElementId(stack);
        let result = this._entries[stackElementId];
        if (result) return result;
        result = new MonarchLineState(stack, null);
        this._entries[stackElementId] = result;
        return result;
    }
}
class MonarchLineState {
    constructor(stack, embeddedLanguageData){
        this.stack = stack;
        this.embeddedLanguageData = embeddedLanguageData;
    }
    clone() {
        const embeddedlanguageDataClone = this.embeddedLanguageData ? this.embeddedLanguageData.clone() : null;
        // save an object
        if (embeddedlanguageDataClone === this.embeddedLanguageData) return this;
        return MonarchLineStateFactory.create(this.stack, this.embeddedLanguageData);
    }
    equals(other) {
        if (!(other instanceof MonarchLineState)) return false;
        if (!this.stack.equals(other.stack)) return false;
        if (this.embeddedLanguageData === null && other.embeddedLanguageData === null) return true;
        if (this.embeddedLanguageData === null || other.embeddedLanguageData === null) return false;
        return this.embeddedLanguageData.equals(other.embeddedLanguageData);
    }
}
class MonarchClassicTokensCollector {
    constructor(){
        this._tokens = [];
        this._languageId = null;
        this._lastTokenType = null;
        this._lastTokenLanguage = null;
    }
    enterLanguage(languageId) {
        this._languageId = languageId;
    }
    emit(startOffset, type) {
        if (this._lastTokenType === type && this._lastTokenLanguage === this._languageId) return;
        this._lastTokenType = type;
        this._lastTokenLanguage = this._languageId;
        this._tokens.push(new _languagesJs.Token(startOffset, type, this._languageId));
    }
    nestedLanguageTokenize(embeddedLanguageLine, hasEOL, embeddedLanguageData, offsetDelta) {
        const nestedLanguageId = embeddedLanguageData.languageId;
        const embeddedModeState = embeddedLanguageData.state;
        const nestedLanguageTokenizationSupport = _languagesJs.TokenizationRegistry.get(nestedLanguageId);
        if (!nestedLanguageTokenizationSupport) {
            this.enterLanguage(nestedLanguageId);
            this.emit(offsetDelta, "");
            return embeddedModeState;
        }
        const nestedResult = nestedLanguageTokenizationSupport.tokenize(embeddedLanguageLine, hasEOL, embeddedModeState);
        if (offsetDelta !== 0) for (const token of nestedResult.tokens)this._tokens.push(new _languagesJs.Token(token.offset + offsetDelta, token.type, token.language));
        else this._tokens = this._tokens.concat(nestedResult.tokens);
        this._lastTokenType = null;
        this._lastTokenLanguage = null;
        this._languageId = null;
        return nestedResult.endState;
    }
    finalize(endState) {
        return new _languagesJs.TokenizationResult(this._tokens, endState);
    }
}
class MonarchModernTokensCollector {
    constructor(languageService, theme){
        this._languageService = languageService;
        this._theme = theme;
        this._prependTokens = null;
        this._tokens = [];
        this._currentLanguageId = 0 /* LanguageId.Null */ ;
        this._lastTokenMetadata = 0;
    }
    enterLanguage(languageId) {
        this._currentLanguageId = this._languageService.languageIdCodec.encodeLanguageId(languageId);
    }
    emit(startOffset, type) {
        const metadata = this._theme.match(this._currentLanguageId, type) | 1024 /* MetadataConsts.BALANCED_BRACKETS_MASK */ ;
        if (this._lastTokenMetadata === metadata) return;
        this._lastTokenMetadata = metadata;
        this._tokens.push(startOffset);
        this._tokens.push(metadata);
    }
    static _merge(a, b, c) {
        const aLen = a !== null ? a.length : 0;
        const bLen = b.length;
        const cLen = c !== null ? c.length : 0;
        if (aLen === 0 && bLen === 0 && cLen === 0) return new Uint32Array(0);
        if (aLen === 0 && bLen === 0) return c;
        if (bLen === 0 && cLen === 0) return a;
        const result = new Uint32Array(aLen + bLen + cLen);
        if (a !== null) result.set(a);
        for(let i = 0; i < bLen; i++)result[aLen + i] = b[i];
        if (c !== null) result.set(c, aLen + bLen);
        return result;
    }
    nestedLanguageTokenize(embeddedLanguageLine, hasEOL, embeddedLanguageData, offsetDelta) {
        const nestedLanguageId = embeddedLanguageData.languageId;
        const embeddedModeState = embeddedLanguageData.state;
        const nestedLanguageTokenizationSupport = _languagesJs.TokenizationRegistry.get(nestedLanguageId);
        if (!nestedLanguageTokenizationSupport) {
            this.enterLanguage(nestedLanguageId);
            this.emit(offsetDelta, "");
            return embeddedModeState;
        }
        const nestedResult = nestedLanguageTokenizationSupport.tokenizeEncoded(embeddedLanguageLine, hasEOL, embeddedModeState);
        if (offsetDelta !== 0) for(let i = 0, len = nestedResult.tokens.length; i < len; i += 2)nestedResult.tokens[i] += offsetDelta;
        this._prependTokens = MonarchModernTokensCollector._merge(this._prependTokens, this._tokens, nestedResult.tokens);
        this._tokens = [];
        this._currentLanguageId = 0;
        this._lastTokenMetadata = 0;
        return nestedResult.endState;
    }
    finalize(endState) {
        return new _languagesJs.EncodedTokenizationResult(MonarchModernTokensCollector._merge(this._prependTokens, this._tokens, null), endState);
    }
}
let MonarchTokenizer = MonarchTokenizer_1 = class MonarchTokenizer extends (0, _lifecycleJs.Disposable) {
    constructor(languageService, standaloneThemeService, languageId, lexer, _configurationService){
        super();
        this._configurationService = _configurationService;
        this._languageService = languageService;
        this._standaloneThemeService = standaloneThemeService;
        this._languageId = languageId;
        this._lexer = lexer;
        this._embeddedLanguages = Object.create(null);
        this.embeddedLoaded = Promise.resolve(undefined);
        // Set up listening for embedded modes
        let emitting = false;
        this._register(_languagesJs.TokenizationRegistry.onDidChange((e)=>{
            if (emitting) return;
            let isOneOfMyEmbeddedModes = false;
            for(let i = 0, len = e.changedLanguages.length; i < len; i++){
                const language = e.changedLanguages[i];
                if (this._embeddedLanguages[language]) {
                    isOneOfMyEmbeddedModes = true;
                    break;
                }
            }
            if (isOneOfMyEmbeddedModes) {
                emitting = true;
                _languagesJs.TokenizationRegistry.handleChange([
                    this._languageId
                ]);
                emitting = false;
            }
        }));
        this._maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", {
            overrideIdentifier: this._languageId
        });
        this._register(this._configurationService.onDidChangeConfiguration((e)=>{
            if (e.affectsConfiguration("editor.maxTokenizationLineLength")) this._maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", {
                overrideIdentifier: this._languageId
            });
        }));
    }
    getLoadStatus() {
        const promises = [];
        for(const nestedLanguageId in this._embeddedLanguages){
            const tokenizationSupport = _languagesJs.TokenizationRegistry.get(nestedLanguageId);
            if (tokenizationSupport) {
                // The nested language is already loaded
                if (tokenizationSupport instanceof MonarchTokenizer_1) {
                    const nestedModeStatus = tokenizationSupport.getLoadStatus();
                    if (nestedModeStatus.loaded === false) promises.push(nestedModeStatus.promise);
                }
                continue;
            }
            if (!_languagesJs.TokenizationRegistry.isResolved(nestedLanguageId)) // The nested language is in the process of being loaded
            promises.push(_languagesJs.TokenizationRegistry.getOrCreate(nestedLanguageId));
        }
        if (promises.length === 0) return {
            loaded: true
        };
        return {
            loaded: false,
            promise: Promise.all(promises).then((_)=>undefined)
        };
    }
    getInitialState() {
        const rootState = MonarchStackElementFactory.create(null, this._lexer.start);
        return MonarchLineStateFactory.create(rootState, null);
    }
    tokenize(line, hasEOL, lineState) {
        if (line.length >= this._maxTokenizationLineLength) return (0, _nullTokenizeJs.nullTokenize)(this._languageId, lineState);
        const tokensCollector = new MonarchClassicTokensCollector();
        const endLineState = this._tokenize(line, hasEOL, lineState, tokensCollector);
        return tokensCollector.finalize(endLineState);
    }
    tokenizeEncoded(line, hasEOL, lineState) {
        if (line.length >= this._maxTokenizationLineLength) return (0, _nullTokenizeJs.nullTokenizeEncoded)(this._languageService.languageIdCodec.encodeLanguageId(this._languageId), lineState);
        const tokensCollector = new MonarchModernTokensCollector(this._languageService, this._standaloneThemeService.getColorTheme().tokenTheme);
        const endLineState = this._tokenize(line, hasEOL, lineState, tokensCollector);
        return tokensCollector.finalize(endLineState);
    }
    _tokenize(line, hasEOL, lineState, collector) {
        if (lineState.embeddedLanguageData) return this._nestedTokenize(line, hasEOL, lineState, 0, collector);
        else return this._myTokenize(line, hasEOL, lineState, 0, collector);
    }
    _findLeavingNestedLanguageOffset(line, state) {
        let rules = this._lexer.tokenizer[state.stack.state];
        if (!rules) {
            rules = _monarchCommonJs.findRules(this._lexer, state.stack.state); // do parent matching
            if (!rules) throw _monarchCommonJs.createError(this._lexer, "tokenizer state is not defined: " + state.stack.state);
        }
        let popOffset = -1;
        let hasEmbeddedPopRule = false;
        for (const rule of rules){
            if (!_monarchCommonJs.isIAction(rule.action) || rule.action.nextEmbedded !== "@pop") continue;
            hasEmbeddedPopRule = true;
            let regex = rule.resolveRegex(state.stack.state);
            const regexSource = regex.source;
            if (regexSource.substr(0, 4) === "^(?:" && regexSource.substr(regexSource.length - 1, 1) === ")") {
                const flags = (regex.ignoreCase ? "i" : "") + (regex.unicode ? "u" : "");
                regex = new RegExp(regexSource.substr(4, regexSource.length - 5), flags);
            }
            const result = line.search(regex);
            if (result === -1 || result !== 0 && rule.matchOnlyAtLineStart) continue;
            if (popOffset === -1 || result < popOffset) popOffset = result;
        }
        if (!hasEmbeddedPopRule) throw _monarchCommonJs.createError(this._lexer, 'no rule containing nextEmbedded: "@pop" in tokenizer embedded state: ' + state.stack.state);
        return popOffset;
    }
    _nestedTokenize(line, hasEOL, lineState, offsetDelta, tokensCollector) {
        const popOffset = this._findLeavingNestedLanguageOffset(line, lineState);
        if (popOffset === -1) {
            // tokenization will not leave nested language
            const nestedEndState = tokensCollector.nestedLanguageTokenize(line, hasEOL, lineState.embeddedLanguageData, offsetDelta);
            return MonarchLineStateFactory.create(lineState.stack, new EmbeddedLanguageData(lineState.embeddedLanguageData.languageId, nestedEndState));
        }
        const nestedLanguageLine = line.substring(0, popOffset);
        if (nestedLanguageLine.length > 0) // tokenize with the nested language
        tokensCollector.nestedLanguageTokenize(nestedLanguageLine, false, lineState.embeddedLanguageData, offsetDelta);
        const restOfTheLine = line.substring(popOffset);
        return this._myTokenize(restOfTheLine, hasEOL, lineState, offsetDelta + popOffset, tokensCollector);
    }
    _safeRuleName(rule) {
        if (rule) return rule.name;
        return "(unknown)";
    }
    _myTokenize(lineWithoutLF, hasEOL, lineState, offsetDelta, tokensCollector) {
        tokensCollector.enterLanguage(this._languageId);
        const lineWithoutLFLength = lineWithoutLF.length;
        const line = hasEOL && this._lexer.includeLF ? lineWithoutLF + "\n" : lineWithoutLF;
        const lineLength = line.length;
        let embeddedLanguageData = lineState.embeddedLanguageData;
        let stack = lineState.stack;
        let pos = 0;
        let groupMatching = null;
        // See https://github.com/microsoft/monaco-editor/issues/1235
        // Evaluate rules at least once for an empty line
        let forceEvaluation = true;
        while(forceEvaluation || pos < lineLength){
            const pos0 = pos;
            const stackLen0 = stack.depth;
            const groupLen0 = groupMatching ? groupMatching.groups.length : 0;
            const state = stack.state;
            let matches = null;
            let matched = null;
            let action = null;
            let rule = null;
            let enteringEmbeddedLanguage = null;
            // check if we need to process group matches first
            if (groupMatching) {
                matches = groupMatching.matches;
                const groupEntry = groupMatching.groups.shift();
                matched = groupEntry.matched;
                action = groupEntry.action;
                rule = groupMatching.rule;
                // cleanup if necessary
                if (groupMatching.groups.length === 0) groupMatching = null;
            } else {
                // otherwise we match on the token stream
                if (!forceEvaluation && pos >= lineLength) break;
                forceEvaluation = false;
                // get the rules for this state
                let rules = this._lexer.tokenizer[state];
                if (!rules) {
                    rules = _monarchCommonJs.findRules(this._lexer, state); // do parent matching
                    if (!rules) throw _monarchCommonJs.createError(this._lexer, "tokenizer state is not defined: " + state);
                }
                // try each rule until we match
                const restOfLine = line.substr(pos);
                for (const rule of rules)if (pos === 0 || !rule.matchOnlyAtLineStart) {
                    matches = restOfLine.match(rule.resolveRegex(state));
                    if (matches) {
                        matched = matches[0];
                        action = rule.action;
                        break;
                    }
                }
            }
            // We matched 'rule' with 'matches' and 'action'
            if (!matches) {
                matches = [
                    ""
                ];
                matched = "";
            }
            if (!action) {
                // bad: we didn't match anything, and there is no action to take
                // we need to advance the stream or we get progress trouble
                if (pos < lineLength) {
                    matches = [
                        line.charAt(pos)
                    ];
                    matched = matches[0];
                }
                action = this._lexer.defaultToken;
            }
            if (matched === null) break;
            // advance stream
            pos += matched.length;
            // maybe call action function (used for 'cases')
            while(_monarchCommonJs.isFuzzyAction(action) && _monarchCommonJs.isIAction(action) && action.test)action = action.test(matched, matches, state, pos === lineLength);
            let result = null;
            // set the result: either a string or an array of actions
            if (typeof action === "string" || Array.isArray(action)) result = action;
            else if (action.group) result = action.group;
            else if (action.token !== null && action.token !== undefined) {
                // do $n replacements?
                if (action.tokenSubst) result = _monarchCommonJs.substituteMatches(this._lexer, action.token, matched, matches, state);
                else result = action.token;
                // enter embedded language?
                if (action.nextEmbedded) {
                    if (action.nextEmbedded === "@pop") {
                        if (!embeddedLanguageData) throw _monarchCommonJs.createError(this._lexer, "cannot pop embedded language if not inside one");
                        embeddedLanguageData = null;
                    } else if (embeddedLanguageData) throw _monarchCommonJs.createError(this._lexer, "cannot enter embedded language from within an embedded language");
                    else enteringEmbeddedLanguage = _monarchCommonJs.substituteMatches(this._lexer, action.nextEmbedded, matched, matches, state);
                }
                // state transformations
                if (action.goBack) pos = Math.max(0, pos - action.goBack);
                if (action.switchTo && typeof action.switchTo === "string") {
                    let nextState = _monarchCommonJs.substituteMatches(this._lexer, action.switchTo, matched, matches, state); // switch state without a push...
                    if (nextState[0] === "@") nextState = nextState.substr(1); // peel off starting '@'
                    if (!_monarchCommonJs.findRules(this._lexer, nextState)) throw _monarchCommonJs.createError(this._lexer, "trying to switch to a state '" + nextState + "' that is undefined in rule: " + this._safeRuleName(rule));
                    else stack = stack.switchTo(nextState);
                } else if (action.transform && typeof action.transform === "function") throw _monarchCommonJs.createError(this._lexer, "action.transform not supported");
                else if (action.next) {
                    if (action.next === "@push") {
                        if (stack.depth >= this._lexer.maxStack) throw _monarchCommonJs.createError(this._lexer, "maximum tokenizer stack size reached: [" + stack.state + "," + stack.parent.state + ",...]");
                        else stack = stack.push(state);
                    } else if (action.next === "@pop") {
                        if (stack.depth <= 1) throw _monarchCommonJs.createError(this._lexer, "trying to pop an empty stack in rule: " + this._safeRuleName(rule));
                        else stack = stack.pop();
                    } else if (action.next === "@popall") stack = stack.popall();
                    else {
                        let nextState = _monarchCommonJs.substituteMatches(this._lexer, action.next, matched, matches, state);
                        if (nextState[0] === "@") nextState = nextState.substr(1); // peel off starting '@'
                        if (!_monarchCommonJs.findRules(this._lexer, nextState)) throw _monarchCommonJs.createError(this._lexer, "trying to set a next state '" + nextState + "' that is undefined in rule: " + this._safeRuleName(rule));
                        else stack = stack.push(nextState);
                    }
                }
                if (action.log && typeof action.log === "string") _monarchCommonJs.log(this._lexer, this._lexer.languageId + ": " + _monarchCommonJs.substituteMatches(this._lexer, action.log, matched, matches, state));
            }
            // check result
            if (result === null) throw _monarchCommonJs.createError(this._lexer, "lexer rule has no well-defined action in rule: " + this._safeRuleName(rule));
            const computeNewStateForEmbeddedLanguage = (enteringEmbeddedLanguage)=>{
                // support language names, mime types, and language ids
                const languageId = this._languageService.getLanguageIdByLanguageName(enteringEmbeddedLanguage) || this._languageService.getLanguageIdByMimeType(enteringEmbeddedLanguage) || enteringEmbeddedLanguage;
                const embeddedLanguageData = this._getNestedEmbeddedLanguageData(languageId);
                if (pos < lineLength) {
                    // there is content from the embedded language on this line
                    const restOfLine = lineWithoutLF.substr(pos);
                    return this._nestedTokenize(restOfLine, hasEOL, MonarchLineStateFactory.create(stack, embeddedLanguageData), offsetDelta + pos, tokensCollector);
                } else return MonarchLineStateFactory.create(stack, embeddedLanguageData);
            };
            // is the result a group match?
            if (Array.isArray(result)) {
                if (groupMatching && groupMatching.groups.length > 0) throw _monarchCommonJs.createError(this._lexer, "groups cannot be nested: " + this._safeRuleName(rule));
                if (matches.length !== result.length + 1) throw _monarchCommonJs.createError(this._lexer, "matched number of groups does not match the number of actions in rule: " + this._safeRuleName(rule));
                let totalLen = 0;
                for(let i = 1; i < matches.length; i++)totalLen += matches[i].length;
                if (totalLen !== matched.length) throw _monarchCommonJs.createError(this._lexer, "with groups, all characters should be matched in consecutive groups in rule: " + this._safeRuleName(rule));
                groupMatching = {
                    rule: rule,
                    matches: matches,
                    groups: []
                };
                for(let i = 0; i < result.length; i++)groupMatching.groups[i] = {
                    action: result[i],
                    matched: matches[i + 1]
                };
                pos -= matched.length;
                continue;
            } else {
                // regular result
                // check for '@rematch'
                if (result === "@rematch") {
                    pos -= matched.length;
                    matched = ""; // better set the next state too..
                    matches = null;
                    result = "";
                    // Even though `@rematch` was specified, if `nextEmbedded` also specified,
                    // a state transition should occur.
                    if (enteringEmbeddedLanguage !== null) return computeNewStateForEmbeddedLanguage(enteringEmbeddedLanguage);
                }
                // check progress
                if (matched.length === 0) {
                    if (lineLength === 0 || stackLen0 !== stack.depth || state !== stack.state || (!groupMatching ? 0 : groupMatching.groups.length) !== groupLen0) continue;
                    else throw _monarchCommonJs.createError(this._lexer, "no progress in tokenizer in rule: " + this._safeRuleName(rule));
                }
                // return the result (and check for brace matching)
                // todo: for efficiency we could pre-sanitize tokenPostfix and substitutions
                let tokenType = null;
                if (_monarchCommonJs.isString(result) && result.indexOf("@brackets") === 0) {
                    const rest = result.substr(9);
                    const bracket = findBracket(this._lexer, matched);
                    if (!bracket) throw _monarchCommonJs.createError(this._lexer, "@brackets token returned but no bracket defined as: " + matched);
                    tokenType = _monarchCommonJs.sanitize(bracket.token + rest);
                } else {
                    const token = result === "" ? "" : result + this._lexer.tokenPostfix;
                    tokenType = _monarchCommonJs.sanitize(token);
                }
                if (pos0 < lineWithoutLFLength) tokensCollector.emit(pos0 + offsetDelta, tokenType);
            }
            if (enteringEmbeddedLanguage !== null) return computeNewStateForEmbeddedLanguage(enteringEmbeddedLanguage);
        }
        return MonarchLineStateFactory.create(stack, embeddedLanguageData);
    }
    _getNestedEmbeddedLanguageData(languageId) {
        if (!this._languageService.isRegisteredLanguageId(languageId)) return new EmbeddedLanguageData(languageId, (0, _nullTokenizeJs.NullState));
        if (languageId !== this._languageId) {
            // Fire language loading event
            this._languageService.requestBasicLanguageFeatures(languageId);
            _languagesJs.TokenizationRegistry.getOrCreate(languageId);
            this._embeddedLanguages[languageId] = true;
        }
        const tokenizationSupport = _languagesJs.TokenizationRegistry.get(languageId);
        if (tokenizationSupport) return new EmbeddedLanguageData(languageId, tokenizationSupport.getInitialState());
        return new EmbeddedLanguageData(languageId, (0, _nullTokenizeJs.NullState));
    }
};
MonarchTokenizer = MonarchTokenizer_1 = __decorate([
    __param(4, (0, _configurationJs.IConfigurationService))
], MonarchTokenizer);
/**
 * Searches for a bracket in the 'brackets' attribute that matches the input.
 */ function findBracket(lexer, matched) {
    if (!matched) return null;
    matched = _monarchCommonJs.fixCase(lexer, matched);
    const brackets = lexer.brackets;
    for (const bracket of brackets){
        if (bracket.open === matched) return {
            token: bracket.token,
            bracketType: 1 /* monarchCommon.MonarchBracket.Open */ 
        };
        else if (bracket.close === matched) return {
            token: bracket.token,
            bracketType: -1 /* monarchCommon.MonarchBracket.Close */ 
        };
    }
    return null;
}

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../common/languages.js":"g5n96","../../../common/languages/nullTokenize.js":"ekzGB","./monarchCommon.js":"cx33T","../../../../platform/configuration/common/configuration.js":"dXkjq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cx33T":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFuzzyActionArr", ()=>isFuzzyActionArr);
parcelHelpers.export(exports, "isFuzzyAction", ()=>isFuzzyAction);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isIAction", ()=>isIAction);
// Small helper functions
/**
 * Is a string null, undefined, or empty?
 */ parcelHelpers.export(exports, "empty", ()=>empty);
/**
 * Puts a string to lower case if 'ignoreCase' is set.
 */ parcelHelpers.export(exports, "fixCase", ()=>fixCase);
/**
 * Ensures there are no bad characters in a CSS token class.
 */ parcelHelpers.export(exports, "sanitize", ()=>sanitize);
// Logging
/**
 * Logs a message.
 */ parcelHelpers.export(exports, "log", ()=>log);
// Throwing errors
parcelHelpers.export(exports, "createError", ()=>createError);
// Helper functions for rule finding and substitution
/**
 * substituteMatches is used on lexer strings and can substitutes predefined patterns:
 * 		$$  => $
 * 		$#  => id
 * 		$n  => matched entry n
 * 		@attr => contents of lexer[attr]
 *
 * See documentation for more info
 */ parcelHelpers.export(exports, "substituteMatches", ()=>substituteMatches);
/**
 * substituteMatchesRe is used on lexer regex rules and can substitutes predefined patterns:
 * 		$Sn => n'th part of state
 *
 */ parcelHelpers.export(exports, "substituteMatchesRe", ()=>substituteMatchesRe);
/**
 * Find the tokenizer rules for a specific state (i.e. next action)
 */ parcelHelpers.export(exports, "findRules", ()=>findRules);
/**
 * Is a certain state defined? In contrast to 'findRules' this works on a ILexerMin.
 * This is used during compilation where we may know the defined states
 * but not yet whether the corresponding rules are correct.
 */ parcelHelpers.export(exports, "stateExists", ()=>stateExists);
function isFuzzyActionArr(what) {
    return Array.isArray(what);
}
function isFuzzyAction(what) {
    return !isFuzzyActionArr(what);
}
function isString(what) {
    return typeof what === "string";
}
function isIAction(what) {
    return !isString(what);
}
function empty(s) {
    return s ? false : true;
}
function fixCase(lexer, str) {
    return lexer.ignoreCase && str ? str.toLowerCase() : str;
}
function sanitize(s) {
    return s.replace(/[&<>'"_]/g, "-"); // used on all output token CSS classes
}
function log(lexer, msg) {
    console.log(`${lexer.languageId}: ${msg}`);
}
function createError(lexer, msg) {
    return new Error(`${lexer.languageId}: ${msg}`);
}
function substituteMatches(lexer, str, id, matches, state) {
    const re = /\$((\$)|(#)|(\d\d?)|[sS](\d\d?)|@(\w+))/g;
    let stateMatches = null;
    return str.replace(re, function(full, sub, dollar, hash, n, s, attr, ofs, total) {
        if (!empty(dollar)) return "$"; // $$
        if (!empty(hash)) return fixCase(lexer, id); // default $#
        if (!empty(n) && n < matches.length) return fixCase(lexer, matches[n]); // $n
        if (!empty(attr) && lexer && typeof lexer[attr] === "string") return lexer[attr]; //@attribute
        if (stateMatches === null) {
            stateMatches = state.split(".");
            stateMatches.unshift(state);
        }
        if (!empty(s) && s < stateMatches.length) return fixCase(lexer, stateMatches[s]); //$Sn
        return "";
    });
}
function substituteMatchesRe(lexer, str, state) {
    const re = /\$[sS](\d\d?)/g;
    let stateMatches = null;
    return str.replace(re, function(full, s) {
        if (stateMatches === null) {
            stateMatches = state.split(".");
            stateMatches.unshift(state);
        }
        if (!empty(s) && s < stateMatches.length) return fixCase(lexer, stateMatches[s]); //$Sn
        return "";
    });
}
function findRules(lexer, inState) {
    let state = inState;
    while(state && state.length > 0){
        const rules = lexer.tokenizer[state];
        if (rules) return rules;
        const idx = state.lastIndexOf(".");
        if (idx < 0) state = null; // no further parent
        else state = state.substr(0, idx);
    }
    return null;
}
function stateExists(lexer, inState) {
    let state = inState;
    while(state && state.length > 0){
        const exist = lexer.stateNames[state];
        if (exist) return true;
        const idx = state.lastIndexOf(".");
        if (idx < 0) state = null; // no further parent
        else state = state.substr(0, idx);
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1KZsU":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandaloneCodeEditor", ()=>StandaloneCodeEditor);
parcelHelpers.export(exports, "StandaloneEditor", ()=>StandaloneEditor);
parcelHelpers.export(exports, "StandaloneDiffEditor2", ()=>StandaloneDiffEditor2);
/**
 * @internal
 */ parcelHelpers.export(exports, "createTextModel", ()=>createTextModel);
var _ariaJs = require("../../../base/browser/ui/aria/aria.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _codeEditorServiceJs = require("../../browser/services/codeEditorService.js");
var _codeEditorWidgetJs = require("../../browser/widget/codeEditor/codeEditorWidget.js");
var _editorActionJs = require("../../common/editorAction.js");
var _standaloneServicesJs = require("./standaloneServices.js");
var _standaloneThemeJs = require("../common/standaloneTheme.js");
var _actionsJs = require("../../../platform/actions/common/actions.js");
var _commandsJs = require("../../../platform/commands/common/commands.js");
var _configurationJs = require("../../../platform/configuration/common/configuration.js");
var _contextkeyJs = require("../../../platform/contextkey/common/contextkey.js");
var _contextViewJs = require("../../../platform/contextview/browser/contextView.js");
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
var _keybindingJs = require("../../../platform/keybinding/common/keybinding.js");
var _notificationJs = require("../../../platform/notification/common/notification.js");
var _themeServiceJs = require("../../../platform/theme/common/themeService.js");
var _accessibilityJs = require("../../../platform/accessibility/common/accessibility.js");
var _standaloneStringsJs = require("../../common/standaloneStrings.js");
var _clipboardServiceJs = require("../../../platform/clipboard/common/clipboardService.js");
var _progressJs = require("../../../platform/progress/common/progress.js");
var _modelJs = require("../../common/services/model.js");
var _languageJs = require("../../common/languages/language.js");
var _standaloneCodeEditorServiceJs = require("./standaloneCodeEditorService.js");
var _modesRegistryJs = require("../../common/languages/modesRegistry.js");
var _languageConfigurationRegistryJs = require("../../common/languages/languageConfigurationRegistry.js");
var _languageFeaturesJs = require("../../common/services/languageFeatures.js");
var _diffEditorWidgetJs = require("../../browser/widget/diffEditor/diffEditorWidget.js");
var _accessibilitySignalServiceJs = require("../../../platform/accessibilitySignal/browser/accessibilitySignalService.js");
var _windowJs = require("../../../base/browser/window.js");
var _hoverDelegateFactoryJs = require("../../../base/browser/ui/hover/hoverDelegateFactory.js");
var _hoverJs = require("../../../platform/hover/browser/hover.js");
var _hoverDelegate2Js = require("../../../base/browser/ui/hover/hoverDelegate2.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let LAST_GENERATED_COMMAND_ID = 0;
let ariaDomNodeCreated = false;
/**
 * Create ARIA dom node inside parent,
 * or only for the first editor instantiation inside document.body.
 * @param parent container element for ARIA dom node
 */ function createAriaDomNode(parent) {
    if (!parent) {
        if (ariaDomNodeCreated) return;
        ariaDomNodeCreated = true;
    }
    _ariaJs.setARIAContainer(parent || (0, _windowJs.mainWindow).document.body);
}
/**
 * A code editor to be used both by the standalone editor and the standalone diff editor.
 */ let StandaloneCodeEditor = class StandaloneCodeEditor extends (0, _codeEditorWidgetJs.CodeEditorWidget) {
    constructor(domElement, _options, instantiationService, codeEditorService, commandService, contextKeyService, hoverService, keybindingService, themeService, notificationService, accessibilityService, languageConfigurationService, languageFeaturesService){
        const options = {
            ..._options
        };
        options.ariaLabel = options.ariaLabel || (0, _standaloneStringsJs.StandaloneCodeEditorNLS).editorViewAccessibleLabel;
        super(domElement, options, {}, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService, accessibilityService, languageConfigurationService, languageFeaturesService);
        if (keybindingService instanceof (0, _standaloneServicesJs.StandaloneKeybindingService)) this._standaloneKeybindingService = keybindingService;
        else this._standaloneKeybindingService = null;
        createAriaDomNode(options.ariaContainerElement);
        (0, _hoverDelegateFactoryJs.setHoverDelegateFactory)((placement, enableInstantHover)=>instantiationService.createInstance((0, _hoverJs.WorkbenchHoverDelegate), placement, enableInstantHover, {}));
        (0, _hoverDelegate2Js.setBaseLayerHoverDelegate)(hoverService);
    }
    addCommand(keybinding, handler, context) {
        if (!this._standaloneKeybindingService) {
            console.warn("Cannot add command because the editor is configured with an unrecognized KeybindingService");
            return null;
        }
        const commandId = "DYNAMIC_" + ++LAST_GENERATED_COMMAND_ID;
        const whenExpression = (0, _contextkeyJs.ContextKeyExpr).deserialize(context);
        this._standaloneKeybindingService.addDynamicKeybinding(commandId, keybinding, handler, whenExpression);
        return commandId;
    }
    createContextKey(key, defaultValue) {
        return this._contextKeyService.createKey(key, defaultValue);
    }
    addAction(_descriptor) {
        if (typeof _descriptor.id !== "string" || typeof _descriptor.label !== "string" || typeof _descriptor.run !== "function") throw new Error("Invalid action descriptor, `id`, `label` and `run` are required properties!");
        if (!this._standaloneKeybindingService) {
            console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService");
            return (0, _lifecycleJs.Disposable).None;
        }
        // Read descriptor options
        const id = _descriptor.id;
        const label = _descriptor.label;
        const precondition = (0, _contextkeyJs.ContextKeyExpr).and((0, _contextkeyJs.ContextKeyExpr).equals("editorId", this.getId()), (0, _contextkeyJs.ContextKeyExpr).deserialize(_descriptor.precondition));
        const keybindings = _descriptor.keybindings;
        const keybindingsWhen = (0, _contextkeyJs.ContextKeyExpr).and(precondition, (0, _contextkeyJs.ContextKeyExpr).deserialize(_descriptor.keybindingContext));
        const contextMenuGroupId = _descriptor.contextMenuGroupId || null;
        const contextMenuOrder = _descriptor.contextMenuOrder || 0;
        const run = (_accessor, ...args)=>{
            return Promise.resolve(_descriptor.run(this, ...args));
        };
        const toDispose = new (0, _lifecycleJs.DisposableStore)();
        // Generate a unique id to allow the same descriptor.id across multiple editor instances
        const uniqueId = this.getId() + ":" + id;
        // Register the command
        toDispose.add((0, _commandsJs.CommandsRegistry).registerCommand(uniqueId, run));
        // Register the context menu item
        if (contextMenuGroupId) {
            const menuItem = {
                command: {
                    id: uniqueId,
                    title: label
                },
                when: precondition,
                group: contextMenuGroupId,
                order: contextMenuOrder
            };
            toDispose.add((0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).EditorContext, menuItem));
        }
        // Register the keybindings
        if (Array.isArray(keybindings)) for (const kb of keybindings)toDispose.add(this._standaloneKeybindingService.addDynamicKeybinding(uniqueId, kb, run, keybindingsWhen));
        // Finally, register an internal editor action
        const internalAction = new (0, _editorActionJs.InternalEditorAction)(uniqueId, label, label, undefined, precondition, (...args)=>Promise.resolve(_descriptor.run(this, ...args)), this._contextKeyService);
        // Store it under the original id, such that trigger with the original id will work
        this._actions.set(id, internalAction);
        toDispose.add((0, _lifecycleJs.toDisposable)(()=>{
            this._actions.delete(id);
        }));
        return toDispose;
    }
    _triggerCommand(handlerId, payload) {
        if (this._codeEditorService instanceof (0, _standaloneCodeEditorServiceJs.StandaloneCodeEditorService)) // Help commands find this editor as the active editor
        try {
            this._codeEditorService.setActiveCodeEditor(this);
            super._triggerCommand(handlerId, payload);
        } finally{
            this._codeEditorService.setActiveCodeEditor(null);
        }
        else super._triggerCommand(handlerId, payload);
    }
};
StandaloneCodeEditor = __decorate([
    __param(2, (0, _instantiationJs.IInstantiationService)),
    __param(3, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(4, (0, _commandsJs.ICommandService)),
    __param(5, (0, _contextkeyJs.IContextKeyService)),
    __param(6, (0, _hoverJs.IHoverService)),
    __param(7, (0, _keybindingJs.IKeybindingService)),
    __param(8, (0, _themeServiceJs.IThemeService)),
    __param(9, (0, _notificationJs.INotificationService)),
    __param(10, (0, _accessibilityJs.IAccessibilityService)),
    __param(11, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService)),
    __param(12, (0, _languageFeaturesJs.ILanguageFeaturesService))
], StandaloneCodeEditor);
let StandaloneEditor = class StandaloneEditor extends StandaloneCodeEditor {
    constructor(domElement, _options, instantiationService, codeEditorService, commandService, contextKeyService, hoverService, keybindingService, themeService, notificationService, configurationService, accessibilityService, modelService, languageService, languageConfigurationService, languageFeaturesService){
        const options = {
            ..._options
        };
        (0, _standaloneServicesJs.updateConfigurationService)(configurationService, options, false);
        const themeDomRegistration = themeService.registerEditorContainer(domElement);
        if (typeof options.theme === "string") themeService.setTheme(options.theme);
        if (typeof options.autoDetectHighContrast !== "undefined") themeService.setAutoDetectHighContrast(Boolean(options.autoDetectHighContrast));
        const _model = options.model;
        delete options.model;
        super(domElement, options, instantiationService, codeEditorService, commandService, contextKeyService, hoverService, keybindingService, themeService, notificationService, accessibilityService, languageConfigurationService, languageFeaturesService);
        this._configurationService = configurationService;
        this._standaloneThemeService = themeService;
        this._register(themeDomRegistration);
        let model;
        if (typeof _model === "undefined") {
            const languageId = languageService.getLanguageIdByMimeType(options.language) || options.language || (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID);
            model = createTextModel(modelService, languageService, options.value || "", languageId, undefined);
            this._ownsModel = true;
        } else {
            model = _model;
            this._ownsModel = false;
        }
        this._attachModel(model);
        if (model) {
            const e = {
                oldModelUrl: null,
                newModelUrl: model.uri
            };
            this._onDidChangeModel.fire(e);
        }
    }
    dispose() {
        super.dispose();
    }
    updateOptions(newOptions) {
        (0, _standaloneServicesJs.updateConfigurationService)(this._configurationService, newOptions, false);
        if (typeof newOptions.theme === "string") this._standaloneThemeService.setTheme(newOptions.theme);
        if (typeof newOptions.autoDetectHighContrast !== "undefined") this._standaloneThemeService.setAutoDetectHighContrast(Boolean(newOptions.autoDetectHighContrast));
        super.updateOptions(newOptions);
    }
    _postDetachModelCleanup(detachedModel) {
        super._postDetachModelCleanup(detachedModel);
        if (detachedModel && this._ownsModel) {
            detachedModel.dispose();
            this._ownsModel = false;
        }
    }
};
StandaloneEditor = __decorate([
    __param(2, (0, _instantiationJs.IInstantiationService)),
    __param(3, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(4, (0, _commandsJs.ICommandService)),
    __param(5, (0, _contextkeyJs.IContextKeyService)),
    __param(6, (0, _hoverJs.IHoverService)),
    __param(7, (0, _keybindingJs.IKeybindingService)),
    __param(8, (0, _standaloneThemeJs.IStandaloneThemeService)),
    __param(9, (0, _notificationJs.INotificationService)),
    __param(10, (0, _configurationJs.IConfigurationService)),
    __param(11, (0, _accessibilityJs.IAccessibilityService)),
    __param(12, (0, _modelJs.IModelService)),
    __param(13, (0, _languageJs.ILanguageService)),
    __param(14, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService)),
    __param(15, (0, _languageFeaturesJs.ILanguageFeaturesService))
], StandaloneEditor);
let StandaloneDiffEditor2 = class StandaloneDiffEditor2 extends (0, _diffEditorWidgetJs.DiffEditorWidget) {
    constructor(domElement, _options, instantiationService, contextKeyService, codeEditorService, themeService, notificationService, configurationService, contextMenuService, editorProgressService, clipboardService, accessibilitySignalService){
        const options = {
            ..._options
        };
        (0, _standaloneServicesJs.updateConfigurationService)(configurationService, options, true);
        const themeDomRegistration = themeService.registerEditorContainer(domElement);
        if (typeof options.theme === "string") themeService.setTheme(options.theme);
        if (typeof options.autoDetectHighContrast !== "undefined") themeService.setAutoDetectHighContrast(Boolean(options.autoDetectHighContrast));
        super(domElement, options, {}, contextKeyService, instantiationService, codeEditorService, accessibilitySignalService, editorProgressService);
        this._configurationService = configurationService;
        this._standaloneThemeService = themeService;
        this._register(themeDomRegistration);
    }
    dispose() {
        super.dispose();
    }
    updateOptions(newOptions) {
        (0, _standaloneServicesJs.updateConfigurationService)(this._configurationService, newOptions, true);
        if (typeof newOptions.theme === "string") this._standaloneThemeService.setTheme(newOptions.theme);
        if (typeof newOptions.autoDetectHighContrast !== "undefined") this._standaloneThemeService.setAutoDetectHighContrast(Boolean(newOptions.autoDetectHighContrast));
        super.updateOptions(newOptions);
    }
    _createInnerEditor(instantiationService, container, options) {
        return instantiationService.createInstance(StandaloneCodeEditor, container, options);
    }
    getOriginalEditor() {
        return super.getOriginalEditor();
    }
    getModifiedEditor() {
        return super.getModifiedEditor();
    }
    addCommand(keybinding, handler, context) {
        return this.getModifiedEditor().addCommand(keybinding, handler, context);
    }
    createContextKey(key, defaultValue) {
        return this.getModifiedEditor().createContextKey(key, defaultValue);
    }
    addAction(descriptor) {
        return this.getModifiedEditor().addAction(descriptor);
    }
};
StandaloneDiffEditor2 = __decorate([
    __param(2, (0, _instantiationJs.IInstantiationService)),
    __param(3, (0, _contextkeyJs.IContextKeyService)),
    __param(4, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(5, (0, _standaloneThemeJs.IStandaloneThemeService)),
    __param(6, (0, _notificationJs.INotificationService)),
    __param(7, (0, _configurationJs.IConfigurationService)),
    __param(8, (0, _contextViewJs.IContextMenuService)),
    __param(9, (0, _progressJs.IEditorProgressService)),
    __param(10, (0, _clipboardServiceJs.IClipboardService)),
    __param(11, (0, _accessibilitySignalServiceJs.IAccessibilitySignalService))
], StandaloneDiffEditor2);
function createTextModel(modelService, languageService, value, languageId, uri) {
    value = value || "";
    if (!languageId) {
        const firstLF = value.indexOf("\n");
        let firstLine = value;
        if (firstLF !== -1) firstLine = value.substring(0, firstLF);
        return doCreateModel(modelService, value, languageService.createByFilepathOrFirstLine(uri || null, firstLine), uri);
    }
    return doCreateModel(modelService, value, languageService.createById(languageId), uri);
}
/**
 * @internal
 */ function doCreateModel(modelService, value, languageSelection, uri) {
    return modelService.createModel(value, languageSelection, uri);
}

},{"../../../base/browser/ui/aria/aria.js":"asrsh","../../../base/common/lifecycle.js":"9kg8d","../../browser/services/codeEditorService.js":"bOWtl","../../browser/widget/codeEditor/codeEditorWidget.js":"kFkuL","../../common/editorAction.js":"l9eav","./standaloneServices.js":"3py7i","../common/standaloneTheme.js":"exW2E","../../../platform/actions/common/actions.js":"kyMtp","../../../platform/commands/common/commands.js":"ho6ic","../../../platform/configuration/common/configuration.js":"dXkjq","../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../platform/contextview/browser/contextView.js":"2QlUR","../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../platform/keybinding/common/keybinding.js":"25pLT","../../../platform/notification/common/notification.js":"igv0W","../../../platform/theme/common/themeService.js":"jMkIC","../../../platform/accessibility/common/accessibility.js":"9Svqy","../../common/standaloneStrings.js":"D35dK","../../../platform/clipboard/common/clipboardService.js":"4IsFp","../../../platform/progress/common/progress.js":"f49eD","../../common/services/model.js":"aciVm","../../common/languages/language.js":"ka2JQ","./standaloneCodeEditorService.js":"kIky6","../../common/languages/modesRegistry.js":"gqkb7","../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../common/services/languageFeatures.js":"2IAko","../../browser/widget/diffEditor/diffEditorWidget.js":"35Ond","../../../platform/accessibilitySignal/browser/accessibilitySignalService.js":"hpeDM","../../../base/browser/window.js":"aJBhQ","../../../base/browser/ui/hover/hoverDelegateFactory.js":"kll4h","../../../platform/hover/browser/hover.js":"3QGXp","../../../base/browser/ui/hover/hoverDelegate2.js":"5jqL3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kFkuL":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeEditorWidget", ()=>CodeEditorWidget);
parcelHelpers.export(exports, "BooleanEventEmitter", ()=>BooleanEventEmitter);
parcelHelpers.export(exports, "EditorModeContext", ()=>EditorModeContext);
var _markerDecorationsJs = require("../../services/markerDecorations.js");
var _domJs = require("../../../../base/browser/dom.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _networkJs = require("../../../../base/common/network.js");
var _editorCss = require("./editor.css");
var _domFontInfoJs = require("../../config/domFontInfo.js");
var _editorConfigurationJs = require("../../config/editorConfiguration.js");
var _tabFocusJs = require("../../config/tabFocus.js");
var _editorExtensionsJs = require("../../editorExtensions.js");
var _codeEditorServiceJs = require("../../services/codeEditorService.js");
var _viewJs = require("../../view.js");
var _domLineBreaksComputerJs = require("../../view/domLineBreaksComputer.js");
var _viewUserInputEventsJs = require("../../view/viewUserInputEvents.js");
var _codeEditorContributionsJs = require("./codeEditorContributions.js");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
var _cursorColumnsJs = require("../../../common/core/cursorColumns.js");
var _editorColorRegistryJs = require("../../../common/core/editorColorRegistry.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _cursorWordOperationsJs = require("../../../common/cursor/cursorWordOperations.js");
var _editorActionJs = require("../../../common/editorAction.js");
var _editorCommonJs = require("../../../common/editorCommon.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _monospaceLineBreaksComputerJs = require("../../../common/viewModel/monospaceLineBreaksComputer.js");
var _viewModelImplJs = require("../../../common/viewModel/viewModelImpl.js");
var _nlsJs = require("../../../../nls.js");
var _accessibilityJs = require("../../../../platform/accessibility/common/accessibility.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _serviceCollectionJs = require("../../../../platform/instantiation/common/serviceCollection.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var CodeEditorWidget_1;
let CodeEditorWidget = class CodeEditorWidget extends (0, _lifecycleJs.Disposable) {
    static{
        CodeEditorWidget_1 = this;
    }
    static{
        this.dropIntoEditorDecorationOptions = (0, _textModelJs.ModelDecorationOptions).register({
            description: "workbench-dnd-target",
            className: "dnd-target"
        });
    }
    //#endregion
    get isSimpleWidget() {
        return this._configuration.isSimpleWidget;
    }
    get contextMenuId() {
        return this._configuration.contextMenuId;
    }
    constructor(domElement, _options, codeEditorWidgetOptions, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService, accessibilityService, languageConfigurationService, languageFeaturesService){
        super();
        this.languageConfigurationService = languageConfigurationService;
        //#region Eventing
        this._deliveryQueue = (0, _eventJs.createEventDeliveryQueue)();
        this._contributions = this._register(new (0, _codeEditorContributionsJs.CodeEditorContributions)());
        this._onDidDispose = this._register(new (0, _eventJs.Emitter)());
        this.onDidDispose = this._onDidDispose.event;
        this._onDidChangeModelContent = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidChangeModelContent = this._onDidChangeModelContent.event;
        this._onDidChangeModelLanguage = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidChangeModelLanguage = this._onDidChangeModelLanguage.event;
        this._onDidChangeModelLanguageConfiguration = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidChangeModelLanguageConfiguration = this._onDidChangeModelLanguageConfiguration.event;
        this._onDidChangeModelOptions = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidChangeModelOptions = this._onDidChangeModelOptions.event;
        this._onDidChangeModelDecorations = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidChangeModelDecorations = this._onDidChangeModelDecorations.event;
        this._onDidChangeModelTokens = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidChangeModelTokens = this._onDidChangeModelTokens.event;
        this._onDidChangeConfiguration = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidChangeConfiguration = this._onDidChangeConfiguration.event;
        this._onWillChangeModel = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onWillChangeModel = this._onWillChangeModel.event;
        this._onDidChangeModel = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidChangeModel = this._onDidChangeModel.event;
        this._onDidChangeCursorPosition = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidChangeCursorPosition = this._onDidChangeCursorPosition.event;
        this._onDidChangeCursorSelection = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidChangeCursorSelection = this._onDidChangeCursorSelection.event;
        this._onDidAttemptReadOnlyEdit = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onDidAttemptReadOnlyEdit = this._onDidAttemptReadOnlyEdit.event;
        this._onDidLayoutChange = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidLayoutChange = this._onDidLayoutChange.event;
        this._editorTextFocus = this._register(new BooleanEventEmitter({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidFocusEditorText = this._editorTextFocus.onDidChangeToTrue;
        this.onDidBlurEditorText = this._editorTextFocus.onDidChangeToFalse;
        this._editorWidgetFocus = this._register(new BooleanEventEmitter({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidFocusEditorWidget = this._editorWidgetFocus.onDidChangeToTrue;
        this.onDidBlurEditorWidget = this._editorWidgetFocus.onDidChangeToFalse;
        this._onWillType = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onWillType = this._onWillType.event;
        this._onDidType = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onDidType = this._onDidType.event;
        this._onDidCompositionStart = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onDidCompositionStart = this._onDidCompositionStart.event;
        this._onDidCompositionEnd = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onDidCompositionEnd = this._onDidCompositionEnd.event;
        this._onDidPaste = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onDidPaste = this._onDidPaste.event;
        this._onMouseUp = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onMouseUp = this._onMouseUp.event;
        this._onMouseDown = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onMouseDown = this._onMouseDown.event;
        this._onMouseDrag = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onMouseDrag = this._onMouseDrag.event;
        this._onMouseDrop = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onMouseDrop = this._onMouseDrop.event;
        this._onMouseDropCanceled = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onMouseDropCanceled = this._onMouseDropCanceled.event;
        this._onDropIntoEditor = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onDropIntoEditor = this._onDropIntoEditor.event;
        this._onContextMenu = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onContextMenu = this._onContextMenu.event;
        this._onMouseMove = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onMouseMove = this._onMouseMove.event;
        this._onMouseLeave = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onMouseLeave = this._onMouseLeave.event;
        this._onMouseWheel = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onMouseWheel = this._onMouseWheel.event;
        this._onKeyUp = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onKeyUp = this._onKeyUp.event;
        this._onKeyDown = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
        this.onKeyDown = this._onKeyDown.event;
        this._onDidContentSizeChange = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidContentSizeChange = this._onDidContentSizeChange.event;
        this._onDidScrollChange = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidScrollChange = this._onDidScrollChange.event;
        this._onDidChangeViewZones = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidChangeViewZones = this._onDidChangeViewZones.event;
        this._onDidChangeHiddenAreas = this._register(new (0, _eventJs.Emitter)({
            deliveryQueue: this._deliveryQueue
        }));
        this.onDidChangeHiddenAreas = this._onDidChangeHiddenAreas.event;
        this._updateCounter = 0;
        this._onBeginUpdate = this._register(new (0, _eventJs.Emitter)());
        this.onBeginUpdate = this._onBeginUpdate.event;
        this._onEndUpdate = this._register(new (0, _eventJs.Emitter)());
        this.onEndUpdate = this._onEndUpdate.event;
        this._actions = new Map();
        this._bannerDomNode = null;
        this._dropIntoEditorDecorations = this.createDecorationsCollection();
        codeEditorService.willCreateCodeEditor();
        const options = {
            ..._options
        };
        this._domElement = domElement;
        this._overflowWidgetsDomNode = options.overflowWidgetsDomNode;
        delete options.overflowWidgetsDomNode;
        this._id = ++EDITOR_ID;
        this._decorationTypeKeysToIds = {};
        this._decorationTypeSubtypes = {};
        this._telemetryData = codeEditorWidgetOptions.telemetryData;
        this._configuration = this._register(this._createConfiguration(codeEditorWidgetOptions.isSimpleWidget || false, codeEditorWidgetOptions.contextMenuId ?? (codeEditorWidgetOptions.isSimpleWidget ? (0, _actionsJs.MenuId).SimpleEditorContext : (0, _actionsJs.MenuId).EditorContext), options, accessibilityService));
        this._register(this._configuration.onDidChange((e)=>{
            this._onDidChangeConfiguration.fire(e);
            const options = this._configuration.options;
            if (e.hasChanged(146 /* EditorOption.layoutInfo */ )) {
                const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
                this._onDidLayoutChange.fire(layoutInfo);
            }
        }));
        this._contextKeyService = this._register(contextKeyService.createScoped(this._domElement));
        this._notificationService = notificationService;
        this._codeEditorService = codeEditorService;
        this._commandService = commandService;
        this._themeService = themeService;
        this._register(new EditorContextKeysManager(this, this._contextKeyService));
        this._register(new EditorModeContext(this, this._contextKeyService, languageFeaturesService));
        this._instantiationService = this._register(instantiationService.createChild(new (0, _serviceCollectionJs.ServiceCollection)([
            (0, _contextkeyJs.IContextKeyService),
            this._contextKeyService
        ])));
        this._modelData = null;
        this._focusTracker = new CodeEditorWidgetFocusTracker(domElement, this._overflowWidgetsDomNode);
        this._register(this._focusTracker.onChange(()=>{
            this._editorWidgetFocus.setValue(this._focusTracker.hasFocus());
        }));
        this._contentWidgets = {};
        this._overlayWidgets = {};
        this._glyphMarginWidgets = {};
        let contributions;
        if (Array.isArray(codeEditorWidgetOptions.contributions)) contributions = codeEditorWidgetOptions.contributions;
        else contributions = (0, _editorExtensionsJs.EditorExtensionsRegistry).getEditorContributions();
        this._contributions.initialize(this, contributions, this._instantiationService);
        for (const action of (0, _editorExtensionsJs.EditorExtensionsRegistry).getEditorActions()){
            if (this._actions.has(action.id)) {
                (0, _errorsJs.onUnexpectedError)(new Error(`Cannot have two actions with the same id ${action.id}`));
                continue;
            }
            const internalAction = new (0, _editorActionJs.InternalEditorAction)(action.id, action.label, action.alias, action.metadata, action.precondition ?? undefined, (args)=>{
                return this._instantiationService.invokeFunction((accessor)=>{
                    return Promise.resolve(action.runEditorCommand(accessor, this, args));
                });
            }, this._contextKeyService);
            this._actions.set(internalAction.id, internalAction);
        }
        const isDropIntoEnabled = ()=>{
            return !this._configuration.options.get(92 /* EditorOption.readOnly */ ) && this._configuration.options.get(36 /* EditorOption.dropIntoEditor */ ).enabled;
        };
        this._register(new _domJs.DragAndDropObserver(this._domElement, {
            onDragOver: (e)=>{
                if (!isDropIntoEnabled()) return;
                const target = this.getTargetAtClientPoint(e.clientX, e.clientY);
                if (target?.position) this.showDropIndicatorAt(target.position);
            },
            onDrop: async (e)=>{
                if (!isDropIntoEnabled()) return;
                this.removeDropIndicator();
                if (!e.dataTransfer) return;
                const target = this.getTargetAtClientPoint(e.clientX, e.clientY);
                if (target?.position) this._onDropIntoEditor.fire({
                    position: target.position,
                    event: e
                });
            },
            onDragLeave: ()=>{
                this.removeDropIndicator();
            },
            onDragEnd: ()=>{
                this.removeDropIndicator();
            }
        }));
        this._codeEditorService.addCodeEditor(this);
    }
    writeScreenReaderContent(reason) {
        this._modelData?.view.writeScreenReaderContent(reason);
    }
    _createConfiguration(isSimpleWidget, contextMenuId, options, accessibilityService) {
        return new (0, _editorConfigurationJs.EditorConfiguration)(isSimpleWidget, contextMenuId, options, this._domElement, accessibilityService);
    }
    getId() {
        return this.getEditorType() + ":" + this._id;
    }
    getEditorType() {
        return _editorCommonJs.EditorType.ICodeEditor;
    }
    dispose() {
        this._codeEditorService.removeCodeEditor(this);
        this._focusTracker.dispose();
        this._actions.clear();
        this._contentWidgets = {};
        this._overlayWidgets = {};
        this._removeDecorationTypes();
        this._postDetachModelCleanup(this._detachModel());
        this._onDidDispose.fire();
        super.dispose();
    }
    invokeWithinContext(fn) {
        return this._instantiationService.invokeFunction(fn);
    }
    updateOptions(newOptions) {
        this._configuration.updateOptions(newOptions || {});
    }
    getOptions() {
        return this._configuration.options;
    }
    getOption(id) {
        return this._configuration.options.get(id);
    }
    getRawOptions() {
        return this._configuration.getRawOptions();
    }
    getOverflowWidgetsDomNode() {
        return this._overflowWidgetsDomNode;
    }
    getConfiguredWordAtPosition(position) {
        if (!this._modelData) return null;
        return (0, _cursorWordOperationsJs.WordOperations).getWordAtPosition(this._modelData.model, this._configuration.options.get(132 /* EditorOption.wordSeparators */ ), this._configuration.options.get(131 /* EditorOption.wordSegmenterLocales */ ), position);
    }
    getValue(options = null) {
        if (!this._modelData) return "";
        const preserveBOM = options && options.preserveBOM ? true : false;
        let eolPreference = 0 /* EndOfLinePreference.TextDefined */ ;
        if (options && options.lineEnding && options.lineEnding === "\n") eolPreference = 1 /* EndOfLinePreference.LF */ ;
        else if (options && options.lineEnding && options.lineEnding === "\r\n") eolPreference = 2 /* EndOfLinePreference.CRLF */ ;
        return this._modelData.model.getValue(eolPreference, preserveBOM);
    }
    setValue(newValue) {
        try {
            this._beginUpdate();
            if (!this._modelData) return;
            this._modelData.model.setValue(newValue);
        } finally{
            this._endUpdate();
        }
    }
    getModel() {
        if (!this._modelData) return null;
        return this._modelData.model;
    }
    setModel(_model = null) {
        try {
            this._beginUpdate();
            const model = _model;
            if (this._modelData === null && model === null) // Current model is the new model
            return;
            if (this._modelData && this._modelData.model === model) // Current model is the new model
            return;
            const e = {
                oldModelUrl: this._modelData?.model.uri || null,
                newModelUrl: model?.uri || null
            };
            this._onWillChangeModel.fire(e);
            const hasTextFocus = this.hasTextFocus();
            const detachedModel = this._detachModel();
            this._attachModel(model);
            if (hasTextFocus && this.hasModel()) this.focus();
            this._removeDecorationTypes();
            this._onDidChangeModel.fire(e);
            this._postDetachModelCleanup(detachedModel);
            this._contributionsDisposable = this._contributions.onAfterModelAttached();
        } finally{
            this._endUpdate();
        }
    }
    _removeDecorationTypes() {
        this._decorationTypeKeysToIds = {};
        if (this._decorationTypeSubtypes) {
            for(const decorationType in this._decorationTypeSubtypes){
                const subTypes = this._decorationTypeSubtypes[decorationType];
                for(const subType in subTypes)this._removeDecorationType(decorationType + "-" + subType);
            }
            this._decorationTypeSubtypes = {};
        }
    }
    getVisibleRanges() {
        if (!this._modelData) return [];
        return this._modelData.viewModel.getVisibleRanges();
    }
    getVisibleRangesPlusViewportAboveBelow() {
        if (!this._modelData) return [];
        return this._modelData.viewModel.getVisibleRangesPlusViewportAboveBelow();
    }
    getWhitespaces() {
        if (!this._modelData) return [];
        return this._modelData.viewModel.viewLayout.getWhitespaces();
    }
    static _getVerticalOffsetAfterPosition(modelData, modelLineNumber, modelColumn, includeViewZones) {
        const modelPosition = modelData.model.validatePosition({
            lineNumber: modelLineNumber,
            column: modelColumn
        });
        const viewPosition = modelData.viewModel.coordinatesConverter.convertModelPositionToViewPosition(modelPosition);
        return modelData.viewModel.viewLayout.getVerticalOffsetAfterLineNumber(viewPosition.lineNumber, includeViewZones);
    }
    getTopForLineNumber(lineNumber, includeViewZones = false) {
        if (!this._modelData) return -1;
        return CodeEditorWidget_1._getVerticalOffsetForPosition(this._modelData, lineNumber, 1, includeViewZones);
    }
    getTopForPosition(lineNumber, column) {
        if (!this._modelData) return -1;
        return CodeEditorWidget_1._getVerticalOffsetForPosition(this._modelData, lineNumber, column, false);
    }
    static _getVerticalOffsetForPosition(modelData, modelLineNumber, modelColumn, includeViewZones = false) {
        const modelPosition = modelData.model.validatePosition({
            lineNumber: modelLineNumber,
            column: modelColumn
        });
        const viewPosition = modelData.viewModel.coordinatesConverter.convertModelPositionToViewPosition(modelPosition);
        return modelData.viewModel.viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber, includeViewZones);
    }
    getBottomForLineNumber(lineNumber, includeViewZones = false) {
        if (!this._modelData) return -1;
        const maxCol = this._modelData.model.getLineMaxColumn(lineNumber);
        return CodeEditorWidget_1._getVerticalOffsetAfterPosition(this._modelData, lineNumber, maxCol, includeViewZones);
    }
    setHiddenAreas(ranges, source) {
        this._modelData?.viewModel.setHiddenAreas(ranges.map((r)=>(0, _rangeJs.Range).lift(r)), source);
    }
    getVisibleColumnFromPosition(rawPosition) {
        if (!this._modelData) return rawPosition.column;
        const position = this._modelData.model.validatePosition(rawPosition);
        const tabSize = this._modelData.model.getOptions().tabSize;
        return (0, _cursorColumnsJs.CursorColumns).visibleColumnFromColumn(this._modelData.model.getLineContent(position.lineNumber), position.column, tabSize) + 1;
    }
    getPosition() {
        if (!this._modelData) return null;
        return this._modelData.viewModel.getPosition();
    }
    setPosition(position, source = "api") {
        if (!this._modelData) return;
        if (!(0, _positionJs.Position).isIPosition(position)) throw new Error("Invalid arguments");
        this._modelData.viewModel.setSelections(source, [
            {
                selectionStartLineNumber: position.lineNumber,
                selectionStartColumn: position.column,
                positionLineNumber: position.lineNumber,
                positionColumn: position.column
            }
        ]);
    }
    _sendRevealRange(modelRange, verticalType, revealHorizontal, scrollType) {
        if (!this._modelData) return;
        if (!(0, _rangeJs.Range).isIRange(modelRange)) throw new Error("Invalid arguments");
        const validatedModelRange = this._modelData.model.validateRange(modelRange);
        const viewRange = this._modelData.viewModel.coordinatesConverter.convertModelRangeToViewRange(validatedModelRange);
        this._modelData.viewModel.revealRange("api", revealHorizontal, viewRange, verticalType, scrollType);
    }
    revealLine(lineNumber, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealLine(lineNumber, 0 /* VerticalRevealType.Simple */ , scrollType);
    }
    revealLineInCenter(lineNumber, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealLine(lineNumber, 1 /* VerticalRevealType.Center */ , scrollType);
    }
    revealLineInCenterIfOutsideViewport(lineNumber, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealLine(lineNumber, 2 /* VerticalRevealType.CenterIfOutsideViewport */ , scrollType);
    }
    revealLineNearTop(lineNumber, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealLine(lineNumber, 5 /* VerticalRevealType.NearTop */ , scrollType);
    }
    _revealLine(lineNumber, revealType, scrollType) {
        if (typeof lineNumber !== "number") throw new Error("Invalid arguments");
        this._sendRevealRange(new (0, _rangeJs.Range)(lineNumber, 1, lineNumber, 1), revealType, false, scrollType);
    }
    revealPosition(position, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealPosition(position, 0 /* VerticalRevealType.Simple */ , true, scrollType);
    }
    revealPositionInCenter(position, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealPosition(position, 1 /* VerticalRevealType.Center */ , true, scrollType);
    }
    revealPositionInCenterIfOutsideViewport(position, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealPosition(position, 2 /* VerticalRevealType.CenterIfOutsideViewport */ , true, scrollType);
    }
    revealPositionNearTop(position, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealPosition(position, 5 /* VerticalRevealType.NearTop */ , true, scrollType);
    }
    _revealPosition(position, verticalType, revealHorizontal, scrollType) {
        if (!(0, _positionJs.Position).isIPosition(position)) throw new Error("Invalid arguments");
        this._sendRevealRange(new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column), verticalType, revealHorizontal, scrollType);
    }
    getSelection() {
        if (!this._modelData) return null;
        return this._modelData.viewModel.getSelection();
    }
    getSelections() {
        if (!this._modelData) return null;
        return this._modelData.viewModel.getSelections();
    }
    setSelection(something, source = "api") {
        const isSelection = (0, _selectionJs.Selection).isISelection(something);
        const isRange = (0, _rangeJs.Range).isIRange(something);
        if (!isSelection && !isRange) throw new Error("Invalid arguments");
        if (isSelection) this._setSelectionImpl(something, source);
        else if (isRange) {
            // act as if it was an IRange
            const selection = {
                selectionStartLineNumber: something.startLineNumber,
                selectionStartColumn: something.startColumn,
                positionLineNumber: something.endLineNumber,
                positionColumn: something.endColumn
            };
            this._setSelectionImpl(selection, source);
        }
    }
    _setSelectionImpl(sel, source) {
        if (!this._modelData) return;
        const selection = new (0, _selectionJs.Selection)(sel.selectionStartLineNumber, sel.selectionStartColumn, sel.positionLineNumber, sel.positionColumn);
        this._modelData.viewModel.setSelections(source, [
            selection
        ]);
    }
    revealLines(startLineNumber, endLineNumber, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealLines(startLineNumber, endLineNumber, 0 /* VerticalRevealType.Simple */ , scrollType);
    }
    revealLinesInCenter(startLineNumber, endLineNumber, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealLines(startLineNumber, endLineNumber, 1 /* VerticalRevealType.Center */ , scrollType);
    }
    revealLinesInCenterIfOutsideViewport(startLineNumber, endLineNumber, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealLines(startLineNumber, endLineNumber, 2 /* VerticalRevealType.CenterIfOutsideViewport */ , scrollType);
    }
    revealLinesNearTop(startLineNumber, endLineNumber, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealLines(startLineNumber, endLineNumber, 5 /* VerticalRevealType.NearTop */ , scrollType);
    }
    _revealLines(startLineNumber, endLineNumber, verticalType, scrollType) {
        if (typeof startLineNumber !== "number" || typeof endLineNumber !== "number") throw new Error("Invalid arguments");
        this._sendRevealRange(new (0, _rangeJs.Range)(startLineNumber, 1, endLineNumber, 1), verticalType, false, scrollType);
    }
    revealRange(range, scrollType = 0 /* editorCommon.ScrollType.Smooth */ , revealVerticalInCenter = false, revealHorizontal = true) {
        this._revealRange(range, revealVerticalInCenter ? 1 /* VerticalRevealType.Center */  : 0 /* VerticalRevealType.Simple */ , revealHorizontal, scrollType);
    }
    revealRangeInCenter(range, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealRange(range, 1 /* VerticalRevealType.Center */ , true, scrollType);
    }
    revealRangeInCenterIfOutsideViewport(range, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealRange(range, 2 /* VerticalRevealType.CenterIfOutsideViewport */ , true, scrollType);
    }
    revealRangeNearTop(range, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealRange(range, 5 /* VerticalRevealType.NearTop */ , true, scrollType);
    }
    revealRangeNearTopIfOutsideViewport(range, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealRange(range, 6 /* VerticalRevealType.NearTopIfOutsideViewport */ , true, scrollType);
    }
    revealRangeAtTop(range, scrollType = 0 /* editorCommon.ScrollType.Smooth */ ) {
        this._revealRange(range, 3 /* VerticalRevealType.Top */ , true, scrollType);
    }
    _revealRange(range, verticalType, revealHorizontal, scrollType) {
        if (!(0, _rangeJs.Range).isIRange(range)) throw new Error("Invalid arguments");
        this._sendRevealRange((0, _rangeJs.Range).lift(range), verticalType, revealHorizontal, scrollType);
    }
    setSelections(ranges, source = "api", reason = 0 /* CursorChangeReason.NotSet */ ) {
        if (!this._modelData) return;
        if (!ranges || ranges.length === 0) throw new Error("Invalid arguments");
        for(let i = 0, len = ranges.length; i < len; i++){
            if (!(0, _selectionJs.Selection).isISelection(ranges[i])) throw new Error("Invalid arguments");
        }
        this._modelData.viewModel.setSelections(source, ranges, reason);
    }
    getContentWidth() {
        if (!this._modelData) return -1;
        return this._modelData.viewModel.viewLayout.getContentWidth();
    }
    getScrollWidth() {
        if (!this._modelData) return -1;
        return this._modelData.viewModel.viewLayout.getScrollWidth();
    }
    getScrollLeft() {
        if (!this._modelData) return -1;
        return this._modelData.viewModel.viewLayout.getCurrentScrollLeft();
    }
    getContentHeight() {
        if (!this._modelData) return -1;
        return this._modelData.viewModel.viewLayout.getContentHeight();
    }
    getScrollHeight() {
        if (!this._modelData) return -1;
        return this._modelData.viewModel.viewLayout.getScrollHeight();
    }
    getScrollTop() {
        if (!this._modelData) return -1;
        return this._modelData.viewModel.viewLayout.getCurrentScrollTop();
    }
    setScrollLeft(newScrollLeft, scrollType = 1 /* editorCommon.ScrollType.Immediate */ ) {
        if (!this._modelData) return;
        if (typeof newScrollLeft !== "number") throw new Error("Invalid arguments");
        this._modelData.viewModel.viewLayout.setScrollPosition({
            scrollLeft: newScrollLeft
        }, scrollType);
    }
    setScrollTop(newScrollTop, scrollType = 1 /* editorCommon.ScrollType.Immediate */ ) {
        if (!this._modelData) return;
        if (typeof newScrollTop !== "number") throw new Error("Invalid arguments");
        this._modelData.viewModel.viewLayout.setScrollPosition({
            scrollTop: newScrollTop
        }, scrollType);
    }
    setScrollPosition(position, scrollType = 1 /* editorCommon.ScrollType.Immediate */ ) {
        if (!this._modelData) return;
        this._modelData.viewModel.viewLayout.setScrollPosition(position, scrollType);
    }
    hasPendingScrollAnimation() {
        if (!this._modelData) return false;
        return this._modelData.viewModel.viewLayout.hasPendingScrollAnimation();
    }
    saveViewState() {
        if (!this._modelData) return null;
        const contributionsState = this._contributions.saveViewState();
        const cursorState = this._modelData.viewModel.saveCursorState();
        const viewState = this._modelData.viewModel.saveState();
        return {
            cursorState: cursorState,
            viewState: viewState,
            contributionsState: contributionsState
        };
    }
    restoreViewState(s) {
        if (!this._modelData || !this._modelData.hasRealView) return;
        const codeEditorState = s;
        if (codeEditorState && codeEditorState.cursorState && codeEditorState.viewState) {
            const cursorState = codeEditorState.cursorState;
            if (Array.isArray(cursorState)) {
                if (cursorState.length > 0) this._modelData.viewModel.restoreCursorState(cursorState);
            } else // Backwards compatibility
            this._modelData.viewModel.restoreCursorState([
                cursorState
            ]);
            this._contributions.restoreViewState(codeEditorState.contributionsState || {});
            const reducedState = this._modelData.viewModel.reduceRestoreState(codeEditorState.viewState);
            this._modelData.view.restoreState(reducedState);
        }
    }
    handleInitialized() {
        this._getViewModel()?.visibleLinesStabilized();
    }
    getContribution(id) {
        return this._contributions.get(id);
    }
    getActions() {
        return Array.from(this._actions.values());
    }
    getSupportedActions() {
        let result = this.getActions();
        result = result.filter((action)=>action.isSupported());
        return result;
    }
    getAction(id) {
        return this._actions.get(id) || null;
    }
    trigger(source, handlerId, payload) {
        payload = payload || {};
        try {
            this._beginUpdate();
            switch(handlerId){
                case "compositionStart" /* editorCommon.Handler.CompositionStart */ :
                    this._startComposition();
                    return;
                case "compositionEnd" /* editorCommon.Handler.CompositionEnd */ :
                    this._endComposition(source);
                    return;
                case "type" /* editorCommon.Handler.Type */ :
                    {
                        const args = payload;
                        this._type(source, args.text || "");
                        return;
                    }
                case "replacePreviousChar" /* editorCommon.Handler.ReplacePreviousChar */ :
                    {
                        const args = payload;
                        this._compositionType(source, args.text || "", args.replaceCharCnt || 0, 0, 0);
                        return;
                    }
                case "compositionType" /* editorCommon.Handler.CompositionType */ :
                    {
                        const args = payload;
                        this._compositionType(source, args.text || "", args.replacePrevCharCnt || 0, args.replaceNextCharCnt || 0, args.positionDelta || 0);
                        return;
                    }
                case "paste" /* editorCommon.Handler.Paste */ :
                    {
                        const args = payload;
                        this._paste(source, args.text || "", args.pasteOnNewLine || false, args.multicursorText || null, args.mode || null, args.clipboardEvent);
                        return;
                    }
                case "cut" /* editorCommon.Handler.Cut */ :
                    this._cut(source);
                    return;
            }
            const action = this.getAction(handlerId);
            if (action) {
                Promise.resolve(action.run(payload)).then(undefined, (0, _errorsJs.onUnexpectedError));
                return;
            }
            if (!this._modelData) return;
            if (this._triggerEditorCommand(source, handlerId, payload)) return;
            this._triggerCommand(handlerId, payload);
        } finally{
            this._endUpdate();
        }
    }
    _triggerCommand(handlerId, payload) {
        this._commandService.executeCommand(handlerId, payload);
    }
    _startComposition() {
        if (!this._modelData) return;
        this._modelData.viewModel.startComposition();
        this._onDidCompositionStart.fire();
    }
    _endComposition(source) {
        if (!this._modelData) return;
        this._modelData.viewModel.endComposition(source);
        this._onDidCompositionEnd.fire();
    }
    _type(source, text) {
        if (!this._modelData || text.length === 0) return;
        if (source === "keyboard") this._onWillType.fire(text);
        this._modelData.viewModel.type(text, source);
        if (source === "keyboard") this._onDidType.fire(text);
    }
    _compositionType(source, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta) {
        if (!this._modelData) return;
        this._modelData.viewModel.compositionType(text, replacePrevCharCnt, replaceNextCharCnt, positionDelta, source);
    }
    _paste(source, text, pasteOnNewLine, multicursorText, mode, clipboardEvent) {
        if (!this._modelData) return;
        const viewModel = this._modelData.viewModel;
        const startPosition = viewModel.getSelection().getStartPosition();
        viewModel.paste(text, pasteOnNewLine, multicursorText, source);
        const endPosition = viewModel.getSelection().getStartPosition();
        if (source === "keyboard") this._onDidPaste.fire({
            clipboardEvent,
            range: new (0, _rangeJs.Range)(startPosition.lineNumber, startPosition.column, endPosition.lineNumber, endPosition.column),
            languageId: mode
        });
    }
    _cut(source) {
        if (!this._modelData) return;
        this._modelData.viewModel.cut(source);
    }
    _triggerEditorCommand(source, handlerId, payload) {
        const command = (0, _editorExtensionsJs.EditorExtensionsRegistry).getEditorCommand(handlerId);
        if (command) {
            payload = payload || {};
            payload.source = source;
            this._instantiationService.invokeFunction((accessor)=>{
                Promise.resolve(command.runEditorCommand(accessor, this, payload)).then(undefined, (0, _errorsJs.onUnexpectedError));
            });
            return true;
        }
        return false;
    }
    _getViewModel() {
        if (!this._modelData) return null;
        return this._modelData.viewModel;
    }
    pushUndoStop() {
        if (!this._modelData) return false;
        if (this._configuration.options.get(92 /* EditorOption.readOnly */ )) // read only editor => sorry!
        return false;
        this._modelData.model.pushStackElement();
        return true;
    }
    popUndoStop() {
        if (!this._modelData) return false;
        if (this._configuration.options.get(92 /* EditorOption.readOnly */ )) // read only editor => sorry!
        return false;
        this._modelData.model.popStackElement();
        return true;
    }
    executeEdits(source, edits, endCursorState) {
        if (!this._modelData) return false;
        if (this._configuration.options.get(92 /* EditorOption.readOnly */ )) // read only editor => sorry!
        return false;
        let cursorStateComputer;
        if (!endCursorState) cursorStateComputer = ()=>null;
        else if (Array.isArray(endCursorState)) cursorStateComputer = ()=>endCursorState;
        else cursorStateComputer = endCursorState;
        this._modelData.viewModel.executeEdits(source, edits, cursorStateComputer);
        return true;
    }
    executeCommand(source, command) {
        if (!this._modelData) return;
        this._modelData.viewModel.executeCommand(command, source);
    }
    executeCommands(source, commands) {
        if (!this._modelData) return;
        this._modelData.viewModel.executeCommands(commands, source);
    }
    createDecorationsCollection(decorations) {
        return new EditorDecorationsCollection(this, decorations);
    }
    changeDecorations(callback) {
        if (!this._modelData) // callback will not be called
        return null;
        return this._modelData.model.changeDecorations(callback, this._id);
    }
    getLineDecorations(lineNumber) {
        if (!this._modelData) return null;
        return this._modelData.model.getLineDecorations(lineNumber, this._id, (0, _editorOptionsJs.filterValidationDecorations)(this._configuration.options));
    }
    getDecorationsInRange(range) {
        if (!this._modelData) return null;
        return this._modelData.model.getDecorationsInRange(range, this._id, (0, _editorOptionsJs.filterValidationDecorations)(this._configuration.options));
    }
    /**
     * @deprecated
     */ deltaDecorations(oldDecorations, newDecorations) {
        if (!this._modelData) return [];
        if (oldDecorations.length === 0 && newDecorations.length === 0) return oldDecorations;
        return this._modelData.model.deltaDecorations(oldDecorations, newDecorations, this._id);
    }
    removeDecorations(decorationIds) {
        if (!this._modelData || decorationIds.length === 0) return;
        this._modelData.model.changeDecorations((changeAccessor)=>{
            changeAccessor.deltaDecorations(decorationIds, []);
        });
    }
    removeDecorationsByType(decorationTypeKey) {
        // remove decorations for type and sub type
        const oldDecorationsIds = this._decorationTypeKeysToIds[decorationTypeKey];
        if (oldDecorationsIds) this.changeDecorations((accessor)=>accessor.deltaDecorations(oldDecorationsIds, []));
        if (this._decorationTypeKeysToIds.hasOwnProperty(decorationTypeKey)) delete this._decorationTypeKeysToIds[decorationTypeKey];
        if (this._decorationTypeSubtypes.hasOwnProperty(decorationTypeKey)) delete this._decorationTypeSubtypes[decorationTypeKey];
    }
    getLayoutInfo() {
        const options = this._configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        return layoutInfo;
    }
    createOverviewRuler(cssClassName) {
        if (!this._modelData || !this._modelData.hasRealView) return null;
        return this._modelData.view.createOverviewRuler(cssClassName);
    }
    getContainerDomNode() {
        return this._domElement;
    }
    getDomNode() {
        if (!this._modelData || !this._modelData.hasRealView) return null;
        return this._modelData.view.domNode.domNode;
    }
    delegateVerticalScrollbarPointerDown(browserEvent) {
        if (!this._modelData || !this._modelData.hasRealView) return;
        this._modelData.view.delegateVerticalScrollbarPointerDown(browserEvent);
    }
    delegateScrollFromMouseWheelEvent(browserEvent) {
        if (!this._modelData || !this._modelData.hasRealView) return;
        this._modelData.view.delegateScrollFromMouseWheelEvent(browserEvent);
    }
    layout(dimension, postponeRendering = false) {
        this._configuration.observeContainer(dimension);
        if (!postponeRendering) this.render();
    }
    focus() {
        if (!this._modelData || !this._modelData.hasRealView) return;
        this._modelData.view.focus();
    }
    hasTextFocus() {
        if (!this._modelData || !this._modelData.hasRealView) return false;
        return this._modelData.view.isFocused();
    }
    hasWidgetFocus() {
        return this._focusTracker && this._focusTracker.hasFocus();
    }
    addContentWidget(widget) {
        const widgetData = {
            widget: widget,
            position: widget.getPosition()
        };
        if (this._contentWidgets.hasOwnProperty(widget.getId())) console.warn("Overwriting a content widget with the same id:" + widget.getId());
        this._contentWidgets[widget.getId()] = widgetData;
        if (this._modelData && this._modelData.hasRealView) this._modelData.view.addContentWidget(widgetData);
    }
    layoutContentWidget(widget) {
        const widgetId = widget.getId();
        if (this._contentWidgets.hasOwnProperty(widgetId)) {
            const widgetData = this._contentWidgets[widgetId];
            widgetData.position = widget.getPosition();
            if (this._modelData && this._modelData.hasRealView) this._modelData.view.layoutContentWidget(widgetData);
        }
    }
    removeContentWidget(widget) {
        const widgetId = widget.getId();
        if (this._contentWidgets.hasOwnProperty(widgetId)) {
            const widgetData = this._contentWidgets[widgetId];
            delete this._contentWidgets[widgetId];
            if (this._modelData && this._modelData.hasRealView) this._modelData.view.removeContentWidget(widgetData);
        }
    }
    addOverlayWidget(widget) {
        const widgetData = {
            widget: widget,
            position: widget.getPosition()
        };
        if (this._overlayWidgets.hasOwnProperty(widget.getId())) console.warn("Overwriting an overlay widget with the same id.");
        this._overlayWidgets[widget.getId()] = widgetData;
        if (this._modelData && this._modelData.hasRealView) this._modelData.view.addOverlayWidget(widgetData);
    }
    layoutOverlayWidget(widget) {
        const widgetId = widget.getId();
        if (this._overlayWidgets.hasOwnProperty(widgetId)) {
            const widgetData = this._overlayWidgets[widgetId];
            widgetData.position = widget.getPosition();
            if (this._modelData && this._modelData.hasRealView) this._modelData.view.layoutOverlayWidget(widgetData);
        }
    }
    removeOverlayWidget(widget) {
        const widgetId = widget.getId();
        if (this._overlayWidgets.hasOwnProperty(widgetId)) {
            const widgetData = this._overlayWidgets[widgetId];
            delete this._overlayWidgets[widgetId];
            if (this._modelData && this._modelData.hasRealView) this._modelData.view.removeOverlayWidget(widgetData);
        }
    }
    addGlyphMarginWidget(widget) {
        const widgetData = {
            widget: widget,
            position: widget.getPosition()
        };
        if (this._glyphMarginWidgets.hasOwnProperty(widget.getId())) console.warn("Overwriting a glyph margin widget with the same id.");
        this._glyphMarginWidgets[widget.getId()] = widgetData;
        if (this._modelData && this._modelData.hasRealView) this._modelData.view.addGlyphMarginWidget(widgetData);
    }
    layoutGlyphMarginWidget(widget) {
        const widgetId = widget.getId();
        if (this._glyphMarginWidgets.hasOwnProperty(widgetId)) {
            const widgetData = this._glyphMarginWidgets[widgetId];
            widgetData.position = widget.getPosition();
            if (this._modelData && this._modelData.hasRealView) this._modelData.view.layoutGlyphMarginWidget(widgetData);
        }
    }
    removeGlyphMarginWidget(widget) {
        const widgetId = widget.getId();
        if (this._glyphMarginWidgets.hasOwnProperty(widgetId)) {
            const widgetData = this._glyphMarginWidgets[widgetId];
            delete this._glyphMarginWidgets[widgetId];
            if (this._modelData && this._modelData.hasRealView) this._modelData.view.removeGlyphMarginWidget(widgetData);
        }
    }
    changeViewZones(callback) {
        if (!this._modelData || !this._modelData.hasRealView) return;
        this._modelData.view.change(callback);
    }
    getTargetAtClientPoint(clientX, clientY) {
        if (!this._modelData || !this._modelData.hasRealView) return null;
        return this._modelData.view.getTargetAtClientPoint(clientX, clientY);
    }
    getScrolledVisiblePosition(rawPosition) {
        if (!this._modelData || !this._modelData.hasRealView) return null;
        const position = this._modelData.model.validatePosition(rawPosition);
        const options = this._configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        const top = CodeEditorWidget_1._getVerticalOffsetForPosition(this._modelData, position.lineNumber, position.column) - this.getScrollTop();
        const left = this._modelData.view.getOffsetForColumn(position.lineNumber, position.column) + layoutInfo.glyphMarginWidth + layoutInfo.lineNumbersWidth + layoutInfo.decorationsWidth - this.getScrollLeft();
        return {
            top: top,
            left: left,
            height: options.get(67 /* EditorOption.lineHeight */ )
        };
    }
    getOffsetForColumn(lineNumber, column) {
        if (!this._modelData || !this._modelData.hasRealView) return -1;
        return this._modelData.view.getOffsetForColumn(lineNumber, column);
    }
    render(forceRedraw = false) {
        if (!this._modelData || !this._modelData.hasRealView) return;
        this._modelData.viewModel.batchEvents(()=>{
            this._modelData.view.render(true, forceRedraw);
        });
    }
    setAriaOptions(options) {
        if (!this._modelData || !this._modelData.hasRealView) return;
        this._modelData.view.setAriaOptions(options);
    }
    applyFontInfo(target) {
        (0, _domFontInfoJs.applyFontInfo)(target, this._configuration.options.get(50 /* EditorOption.fontInfo */ ));
    }
    setBanner(domNode, domNodeHeight) {
        if (this._bannerDomNode && this._domElement.contains(this._bannerDomNode)) this._bannerDomNode.remove();
        this._bannerDomNode = domNode;
        this._configuration.setReservedHeight(domNode ? domNodeHeight : 0);
        if (this._bannerDomNode) this._domElement.prepend(this._bannerDomNode);
    }
    _attachModel(model) {
        if (!model) {
            this._modelData = null;
            return;
        }
        const listenersToRemove = [];
        this._domElement.setAttribute("data-mode-id", model.getLanguageId());
        this._configuration.setIsDominatedByLongLines(model.isDominatedByLongLines());
        this._configuration.setModelLineCount(model.getLineCount());
        const attachedView = model.onBeforeAttached();
        const viewModel = new (0, _viewModelImplJs.ViewModel)(this._id, this._configuration, model, (0, _domLineBreaksComputerJs.DOMLineBreaksComputerFactory).create(_domJs.getWindow(this._domElement)), (0, _monospaceLineBreaksComputerJs.MonospaceLineBreaksComputerFactory).create(this._configuration.options), (callback)=>_domJs.scheduleAtNextAnimationFrame(_domJs.getWindow(this._domElement), callback), this.languageConfigurationService, this._themeService, attachedView, {
            batchChanges: (cb)=>{
                try {
                    this._beginUpdate();
                    return cb();
                } finally{
                    this._endUpdate();
                }
            }
        });
        // Someone might destroy the model from under the editor, so prevent any exceptions by setting a null model
        listenersToRemove.push(model.onWillDispose(()=>this.setModel(null)));
        listenersToRemove.push(viewModel.onEvent((e)=>{
            switch(e.kind){
                case 0 /* OutgoingViewModelEventKind.ContentSizeChanged */ :
                    this._onDidContentSizeChange.fire(e);
                    break;
                case 1 /* OutgoingViewModelEventKind.FocusChanged */ :
                    this._editorTextFocus.setValue(e.hasFocus);
                    break;
                case 2 /* OutgoingViewModelEventKind.ScrollChanged */ :
                    this._onDidScrollChange.fire(e);
                    break;
                case 3 /* OutgoingViewModelEventKind.ViewZonesChanged */ :
                    this._onDidChangeViewZones.fire();
                    break;
                case 4 /* OutgoingViewModelEventKind.HiddenAreasChanged */ :
                    this._onDidChangeHiddenAreas.fire();
                    break;
                case 5 /* OutgoingViewModelEventKind.ReadOnlyEditAttempt */ :
                    this._onDidAttemptReadOnlyEdit.fire();
                    break;
                case 6 /* OutgoingViewModelEventKind.CursorStateChanged */ :
                    {
                        if (e.reachedMaxCursorCount) {
                            const multiCursorLimit = this.getOption(80 /* EditorOption.multiCursorLimit */ );
                            const message = _nlsJs.localize("cursors.maximum", "The number of cursors has been limited to {0}. Consider using [find and replace](https://code.visualstudio.com/docs/editor/codebasics#_find-and-replace) for larger changes or increase the editor multi cursor limit setting.", multiCursorLimit);
                            this._notificationService.prompt((0, _notificationJs.Severity).Warning, message, [
                                {
                                    label: "Find and Replace",
                                    run: ()=>{
                                        this._commandService.executeCommand("editor.action.startFindReplaceAction");
                                    }
                                },
                                {
                                    label: _nlsJs.localize("goToSetting", "Increase Multi Cursor Limit"),
                                    run: ()=>{
                                        this._commandService.executeCommand("workbench.action.openSettings2", {
                                            query: "editor.multiCursorLimit"
                                        });
                                    }
                                }
                            ]);
                        }
                        const positions = [];
                        for(let i = 0, len = e.selections.length; i < len; i++)positions[i] = e.selections[i].getPosition();
                        const e1 = {
                            position: positions[0],
                            secondaryPositions: positions.slice(1),
                            reason: e.reason,
                            source: e.source
                        };
                        this._onDidChangeCursorPosition.fire(e1);
                        const e2 = {
                            selection: e.selections[0],
                            secondarySelections: e.selections.slice(1),
                            modelVersionId: e.modelVersionId,
                            oldSelections: e.oldSelections,
                            oldModelVersionId: e.oldModelVersionId,
                            source: e.source,
                            reason: e.reason
                        };
                        this._onDidChangeCursorSelection.fire(e2);
                        break;
                    }
                case 7 /* OutgoingViewModelEventKind.ModelDecorationsChanged */ :
                    this._onDidChangeModelDecorations.fire(e.event);
                    break;
                case 8 /* OutgoingViewModelEventKind.ModelLanguageChanged */ :
                    this._domElement.setAttribute("data-mode-id", model.getLanguageId());
                    this._onDidChangeModelLanguage.fire(e.event);
                    break;
                case 9 /* OutgoingViewModelEventKind.ModelLanguageConfigurationChanged */ :
                    this._onDidChangeModelLanguageConfiguration.fire(e.event);
                    break;
                case 10 /* OutgoingViewModelEventKind.ModelContentChanged */ :
                    this._onDidChangeModelContent.fire(e.event);
                    break;
                case 11 /* OutgoingViewModelEventKind.ModelOptionsChanged */ :
                    this._onDidChangeModelOptions.fire(e.event);
                    break;
                case 12 /* OutgoingViewModelEventKind.ModelTokensChanged */ :
                    this._onDidChangeModelTokens.fire(e.event);
                    break;
            }
        }));
        const [view, hasRealView] = this._createView(viewModel);
        if (hasRealView) {
            this._domElement.appendChild(view.domNode.domNode);
            let keys = Object.keys(this._contentWidgets);
            for(let i = 0, len = keys.length; i < len; i++){
                const widgetId = keys[i];
                view.addContentWidget(this._contentWidgets[widgetId]);
            }
            keys = Object.keys(this._overlayWidgets);
            for(let i = 0, len = keys.length; i < len; i++){
                const widgetId = keys[i];
                view.addOverlayWidget(this._overlayWidgets[widgetId]);
            }
            keys = Object.keys(this._glyphMarginWidgets);
            for(let i = 0, len = keys.length; i < len; i++){
                const widgetId = keys[i];
                view.addGlyphMarginWidget(this._glyphMarginWidgets[widgetId]);
            }
            view.render(false, true);
            view.domNode.domNode.setAttribute("data-uri", model.uri.toString());
        }
        this._modelData = new ModelData(model, viewModel, view, hasRealView, listenersToRemove, attachedView);
    }
    _createView(viewModel) {
        let commandDelegate;
        if (this.isSimpleWidget) commandDelegate = {
            paste: (text, pasteOnNewLine, multicursorText, mode)=>{
                this._paste("keyboard", text, pasteOnNewLine, multicursorText, mode);
            },
            type: (text)=>{
                this._type("keyboard", text);
            },
            compositionType: (text, replacePrevCharCnt, replaceNextCharCnt, positionDelta)=>{
                this._compositionType("keyboard", text, replacePrevCharCnt, replaceNextCharCnt, positionDelta);
            },
            startComposition: ()=>{
                this._startComposition();
            },
            endComposition: ()=>{
                this._endComposition("keyboard");
            },
            cut: ()=>{
                this._cut("keyboard");
            }
        };
        else commandDelegate = {
            paste: (text, pasteOnNewLine, multicursorText, mode)=>{
                const payload = {
                    text,
                    pasteOnNewLine,
                    multicursorText,
                    mode
                };
                this._commandService.executeCommand("paste" /* editorCommon.Handler.Paste */ , payload);
            },
            type: (text)=>{
                const payload = {
                    text
                };
                this._commandService.executeCommand("type" /* editorCommon.Handler.Type */ , payload);
            },
            compositionType: (text, replacePrevCharCnt, replaceNextCharCnt, positionDelta)=>{
                // Try if possible to go through the existing `replacePreviousChar` command
                if (replaceNextCharCnt || positionDelta) {
                    // must be handled through the new command
                    const payload = {
                        text,
                        replacePrevCharCnt,
                        replaceNextCharCnt,
                        positionDelta
                    };
                    this._commandService.executeCommand("compositionType" /* editorCommon.Handler.CompositionType */ , payload);
                } else {
                    const payload = {
                        text,
                        replaceCharCnt: replacePrevCharCnt
                    };
                    this._commandService.executeCommand("replacePreviousChar" /* editorCommon.Handler.ReplacePreviousChar */ , payload);
                }
            },
            startComposition: ()=>{
                this._commandService.executeCommand("compositionStart" /* editorCommon.Handler.CompositionStart */ , {});
            },
            endComposition: ()=>{
                this._commandService.executeCommand("compositionEnd" /* editorCommon.Handler.CompositionEnd */ , {});
            },
            cut: ()=>{
                this._commandService.executeCommand("cut" /* editorCommon.Handler.Cut */ , {});
            }
        };
        const viewUserInputEvents = new (0, _viewUserInputEventsJs.ViewUserInputEvents)(viewModel.coordinatesConverter);
        viewUserInputEvents.onKeyDown = (e)=>this._onKeyDown.fire(e);
        viewUserInputEvents.onKeyUp = (e)=>this._onKeyUp.fire(e);
        viewUserInputEvents.onContextMenu = (e)=>this._onContextMenu.fire(e);
        viewUserInputEvents.onMouseMove = (e)=>this._onMouseMove.fire(e);
        viewUserInputEvents.onMouseLeave = (e)=>this._onMouseLeave.fire(e);
        viewUserInputEvents.onMouseDown = (e)=>this._onMouseDown.fire(e);
        viewUserInputEvents.onMouseUp = (e)=>this._onMouseUp.fire(e);
        viewUserInputEvents.onMouseDrag = (e)=>this._onMouseDrag.fire(e);
        viewUserInputEvents.onMouseDrop = (e)=>this._onMouseDrop.fire(e);
        viewUserInputEvents.onMouseDropCanceled = (e)=>this._onMouseDropCanceled.fire(e);
        viewUserInputEvents.onMouseWheel = (e)=>this._onMouseWheel.fire(e);
        const view = new (0, _viewJs.View)(commandDelegate, this._configuration, this._themeService.getColorTheme(), viewModel, viewUserInputEvents, this._overflowWidgetsDomNode, this._instantiationService);
        return [
            view,
            true
        ];
    }
    _postDetachModelCleanup(detachedModel) {
        detachedModel?.removeAllDecorationsWithOwnerId(this._id);
    }
    _detachModel() {
        this._contributionsDisposable?.dispose();
        this._contributionsDisposable = undefined;
        if (!this._modelData) return null;
        const model = this._modelData.model;
        const removeDomNode = this._modelData.hasRealView ? this._modelData.view.domNode.domNode : null;
        this._modelData.dispose();
        this._modelData = null;
        this._domElement.removeAttribute("data-mode-id");
        if (removeDomNode && this._domElement.contains(removeDomNode)) removeDomNode.remove();
        if (this._bannerDomNode && this._domElement.contains(this._bannerDomNode)) this._bannerDomNode.remove();
        return model;
    }
    _removeDecorationType(key) {
        this._codeEditorService.removeDecorationType(key);
    }
    hasModel() {
        return this._modelData !== null;
    }
    showDropIndicatorAt(position) {
        const newDecorations = [
            {
                range: new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column),
                options: CodeEditorWidget_1.dropIntoEditorDecorationOptions
            }
        ];
        this._dropIntoEditorDecorations.set(newDecorations);
        this.revealPosition(position, 1 /* editorCommon.ScrollType.Immediate */ );
    }
    removeDropIndicator() {
        this._dropIntoEditorDecorations.clear();
    }
    setContextValue(key, value) {
        this._contextKeyService.createKey(key, value);
    }
    _beginUpdate() {
        this._updateCounter++;
        if (this._updateCounter === 1) this._onBeginUpdate.fire();
    }
    _endUpdate() {
        this._updateCounter--;
        if (this._updateCounter === 0) this._onEndUpdate.fire();
    }
};
CodeEditorWidget = CodeEditorWidget_1 = __decorate([
    __param(3, (0, _instantiationJs.IInstantiationService)),
    __param(4, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(5, (0, _commandsJs.ICommandService)),
    __param(6, (0, _contextkeyJs.IContextKeyService)),
    __param(7, (0, _themeServiceJs.IThemeService)),
    __param(8, (0, _notificationJs.INotificationService)),
    __param(9, (0, _accessibilityJs.IAccessibilityService)),
    __param(10, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService)),
    __param(11, (0, _languageFeaturesJs.ILanguageFeaturesService))
], CodeEditorWidget);
let EDITOR_ID = 0;
class ModelData {
    constructor(model, viewModel, view, hasRealView, listenersToRemove, attachedView){
        this.model = model;
        this.viewModel = viewModel;
        this.view = view;
        this.hasRealView = hasRealView;
        this.listenersToRemove = listenersToRemove;
        this.attachedView = attachedView;
    }
    dispose() {
        (0, _lifecycleJs.dispose)(this.listenersToRemove);
        this.model.onBeforeDetached(this.attachedView);
        if (this.hasRealView) this.view.dispose();
        this.viewModel.dispose();
    }
}
class BooleanEventEmitter extends (0, _lifecycleJs.Disposable) {
    constructor(_emitterOptions){
        super();
        this._emitterOptions = _emitterOptions;
        this._onDidChangeToTrue = this._register(new (0, _eventJs.Emitter)(this._emitterOptions));
        this.onDidChangeToTrue = this._onDidChangeToTrue.event;
        this._onDidChangeToFalse = this._register(new (0, _eventJs.Emitter)(this._emitterOptions));
        this.onDidChangeToFalse = this._onDidChangeToFalse.event;
        this._value = 0 /* BooleanEventValue.NotSet */ ;
    }
    setValue(_value) {
        const value = _value ? 2 /* BooleanEventValue.True */  : 1 /* BooleanEventValue.False */ ;
        if (this._value === value) return;
        this._value = value;
        if (this._value === 2 /* BooleanEventValue.True */ ) this._onDidChangeToTrue.fire();
        else if (this._value === 1 /* BooleanEventValue.False */ ) this._onDidChangeToFalse.fire();
    }
}
/**
 * A regular event emitter that also makes sure contributions are instantiated if necessary
 */ class InteractionEmitter extends (0, _eventJs.Emitter) {
    constructor(_contributions, deliveryQueue){
        super({
            deliveryQueue
        });
        this._contributions = _contributions;
    }
    fire(event) {
        this._contributions.onBeforeInteractionEvent();
        super.fire(event);
    }
}
class EditorContextKeysManager extends (0, _lifecycleJs.Disposable) {
    constructor(editor, contextKeyService){
        super();
        this._editor = editor;
        contextKeyService.createKey("editorId", editor.getId());
        this._editorSimpleInput = (0, _editorContextKeysJs.EditorContextKeys).editorSimpleInput.bindTo(contextKeyService);
        this._editorFocus = (0, _editorContextKeysJs.EditorContextKeys).focus.bindTo(contextKeyService);
        this._textInputFocus = (0, _editorContextKeysJs.EditorContextKeys).textInputFocus.bindTo(contextKeyService);
        this._editorTextFocus = (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus.bindTo(contextKeyService);
        this._tabMovesFocus = (0, _editorContextKeysJs.EditorContextKeys).tabMovesFocus.bindTo(contextKeyService);
        this._editorReadonly = (0, _editorContextKeysJs.EditorContextKeys).readOnly.bindTo(contextKeyService);
        this._inDiffEditor = (0, _editorContextKeysJs.EditorContextKeys).inDiffEditor.bindTo(contextKeyService);
        this._editorColumnSelection = (0, _editorContextKeysJs.EditorContextKeys).columnSelection.bindTo(contextKeyService);
        this._hasMultipleSelections = (0, _editorContextKeysJs.EditorContextKeys).hasMultipleSelections.bindTo(contextKeyService);
        this._hasNonEmptySelection = (0, _editorContextKeysJs.EditorContextKeys).hasNonEmptySelection.bindTo(contextKeyService);
        this._canUndo = (0, _editorContextKeysJs.EditorContextKeys).canUndo.bindTo(contextKeyService);
        this._canRedo = (0, _editorContextKeysJs.EditorContextKeys).canRedo.bindTo(contextKeyService);
        this._register(this._editor.onDidChangeConfiguration(()=>this._updateFromConfig()));
        this._register(this._editor.onDidChangeCursorSelection(()=>this._updateFromSelection()));
        this._register(this._editor.onDidFocusEditorWidget(()=>this._updateFromFocus()));
        this._register(this._editor.onDidBlurEditorWidget(()=>this._updateFromFocus()));
        this._register(this._editor.onDidFocusEditorText(()=>this._updateFromFocus()));
        this._register(this._editor.onDidBlurEditorText(()=>this._updateFromFocus()));
        this._register(this._editor.onDidChangeModel(()=>this._updateFromModel()));
        this._register(this._editor.onDidChangeConfiguration(()=>this._updateFromModel()));
        this._register((0, _tabFocusJs.TabFocus).onDidChangeTabFocus((tabFocusMode)=>this._tabMovesFocus.set(tabFocusMode)));
        this._updateFromConfig();
        this._updateFromSelection();
        this._updateFromFocus();
        this._updateFromModel();
        this._editorSimpleInput.set(this._editor.isSimpleWidget);
    }
    _updateFromConfig() {
        const options = this._editor.getOptions();
        this._tabMovesFocus.set((0, _tabFocusJs.TabFocus).getTabFocusMode());
        this._editorReadonly.set(options.get(92 /* EditorOption.readOnly */ ));
        this._inDiffEditor.set(options.get(61 /* EditorOption.inDiffEditor */ ));
        this._editorColumnSelection.set(options.get(22 /* EditorOption.columnSelection */ ));
    }
    _updateFromSelection() {
        const selections = this._editor.getSelections();
        if (!selections) {
            this._hasMultipleSelections.reset();
            this._hasNonEmptySelection.reset();
        } else {
            this._hasMultipleSelections.set(selections.length > 1);
            this._hasNonEmptySelection.set(selections.some((s)=>!s.isEmpty()));
        }
    }
    _updateFromFocus() {
        this._editorFocus.set(this._editor.hasWidgetFocus() && !this._editor.isSimpleWidget);
        this._editorTextFocus.set(this._editor.hasTextFocus() && !this._editor.isSimpleWidget);
        this._textInputFocus.set(this._editor.hasTextFocus());
    }
    _updateFromModel() {
        const model = this._editor.getModel();
        this._canUndo.set(Boolean(model && model.canUndo()));
        this._canRedo.set(Boolean(model && model.canRedo()));
    }
}
class EditorModeContext extends (0, _lifecycleJs.Disposable) {
    constructor(_editor, _contextKeyService, _languageFeaturesService){
        super();
        this._editor = _editor;
        this._contextKeyService = _contextKeyService;
        this._languageFeaturesService = _languageFeaturesService;
        this._langId = (0, _editorContextKeysJs.EditorContextKeys).languageId.bindTo(_contextKeyService);
        this._hasCompletionItemProvider = (0, _editorContextKeysJs.EditorContextKeys).hasCompletionItemProvider.bindTo(_contextKeyService);
        this._hasCodeActionsProvider = (0, _editorContextKeysJs.EditorContextKeys).hasCodeActionsProvider.bindTo(_contextKeyService);
        this._hasCodeLensProvider = (0, _editorContextKeysJs.EditorContextKeys).hasCodeLensProvider.bindTo(_contextKeyService);
        this._hasDefinitionProvider = (0, _editorContextKeysJs.EditorContextKeys).hasDefinitionProvider.bindTo(_contextKeyService);
        this._hasDeclarationProvider = (0, _editorContextKeysJs.EditorContextKeys).hasDeclarationProvider.bindTo(_contextKeyService);
        this._hasImplementationProvider = (0, _editorContextKeysJs.EditorContextKeys).hasImplementationProvider.bindTo(_contextKeyService);
        this._hasTypeDefinitionProvider = (0, _editorContextKeysJs.EditorContextKeys).hasTypeDefinitionProvider.bindTo(_contextKeyService);
        this._hasHoverProvider = (0, _editorContextKeysJs.EditorContextKeys).hasHoverProvider.bindTo(_contextKeyService);
        this._hasDocumentHighlightProvider = (0, _editorContextKeysJs.EditorContextKeys).hasDocumentHighlightProvider.bindTo(_contextKeyService);
        this._hasDocumentSymbolProvider = (0, _editorContextKeysJs.EditorContextKeys).hasDocumentSymbolProvider.bindTo(_contextKeyService);
        this._hasReferenceProvider = (0, _editorContextKeysJs.EditorContextKeys).hasReferenceProvider.bindTo(_contextKeyService);
        this._hasRenameProvider = (0, _editorContextKeysJs.EditorContextKeys).hasRenameProvider.bindTo(_contextKeyService);
        this._hasSignatureHelpProvider = (0, _editorContextKeysJs.EditorContextKeys).hasSignatureHelpProvider.bindTo(_contextKeyService);
        this._hasInlayHintsProvider = (0, _editorContextKeysJs.EditorContextKeys).hasInlayHintsProvider.bindTo(_contextKeyService);
        this._hasDocumentFormattingProvider = (0, _editorContextKeysJs.EditorContextKeys).hasDocumentFormattingProvider.bindTo(_contextKeyService);
        this._hasDocumentSelectionFormattingProvider = (0, _editorContextKeysJs.EditorContextKeys).hasDocumentSelectionFormattingProvider.bindTo(_contextKeyService);
        this._hasMultipleDocumentFormattingProvider = (0, _editorContextKeysJs.EditorContextKeys).hasMultipleDocumentFormattingProvider.bindTo(_contextKeyService);
        this._hasMultipleDocumentSelectionFormattingProvider = (0, _editorContextKeysJs.EditorContextKeys).hasMultipleDocumentSelectionFormattingProvider.bindTo(_contextKeyService);
        this._isInEmbeddedEditor = (0, _editorContextKeysJs.EditorContextKeys).isInEmbeddedEditor.bindTo(_contextKeyService);
        const update = ()=>this._update();
        // update when model/mode changes
        this._register(_editor.onDidChangeModel(update));
        this._register(_editor.onDidChangeModelLanguage(update));
        // update when registries change
        this._register(_languageFeaturesService.completionProvider.onDidChange(update));
        this._register(_languageFeaturesService.codeActionProvider.onDidChange(update));
        this._register(_languageFeaturesService.codeLensProvider.onDidChange(update));
        this._register(_languageFeaturesService.definitionProvider.onDidChange(update));
        this._register(_languageFeaturesService.declarationProvider.onDidChange(update));
        this._register(_languageFeaturesService.implementationProvider.onDidChange(update));
        this._register(_languageFeaturesService.typeDefinitionProvider.onDidChange(update));
        this._register(_languageFeaturesService.hoverProvider.onDidChange(update));
        this._register(_languageFeaturesService.documentHighlightProvider.onDidChange(update));
        this._register(_languageFeaturesService.documentSymbolProvider.onDidChange(update));
        this._register(_languageFeaturesService.referenceProvider.onDidChange(update));
        this._register(_languageFeaturesService.renameProvider.onDidChange(update));
        this._register(_languageFeaturesService.documentFormattingEditProvider.onDidChange(update));
        this._register(_languageFeaturesService.documentRangeFormattingEditProvider.onDidChange(update));
        this._register(_languageFeaturesService.signatureHelpProvider.onDidChange(update));
        this._register(_languageFeaturesService.inlayHintsProvider.onDidChange(update));
        update();
    }
    dispose() {
        super.dispose();
    }
    reset() {
        this._contextKeyService.bufferChangeEvents(()=>{
            this._langId.reset();
            this._hasCompletionItemProvider.reset();
            this._hasCodeActionsProvider.reset();
            this._hasCodeLensProvider.reset();
            this._hasDefinitionProvider.reset();
            this._hasDeclarationProvider.reset();
            this._hasImplementationProvider.reset();
            this._hasTypeDefinitionProvider.reset();
            this._hasHoverProvider.reset();
            this._hasDocumentHighlightProvider.reset();
            this._hasDocumentSymbolProvider.reset();
            this._hasReferenceProvider.reset();
            this._hasRenameProvider.reset();
            this._hasDocumentFormattingProvider.reset();
            this._hasDocumentSelectionFormattingProvider.reset();
            this._hasSignatureHelpProvider.reset();
            this._isInEmbeddedEditor.reset();
        });
    }
    _update() {
        const model = this._editor.getModel();
        if (!model) {
            this.reset();
            return;
        }
        this._contextKeyService.bufferChangeEvents(()=>{
            this._langId.set(model.getLanguageId());
            this._hasCompletionItemProvider.set(this._languageFeaturesService.completionProvider.has(model));
            this._hasCodeActionsProvider.set(this._languageFeaturesService.codeActionProvider.has(model));
            this._hasCodeLensProvider.set(this._languageFeaturesService.codeLensProvider.has(model));
            this._hasDefinitionProvider.set(this._languageFeaturesService.definitionProvider.has(model));
            this._hasDeclarationProvider.set(this._languageFeaturesService.declarationProvider.has(model));
            this._hasImplementationProvider.set(this._languageFeaturesService.implementationProvider.has(model));
            this._hasTypeDefinitionProvider.set(this._languageFeaturesService.typeDefinitionProvider.has(model));
            this._hasHoverProvider.set(this._languageFeaturesService.hoverProvider.has(model));
            this._hasDocumentHighlightProvider.set(this._languageFeaturesService.documentHighlightProvider.has(model));
            this._hasDocumentSymbolProvider.set(this._languageFeaturesService.documentSymbolProvider.has(model));
            this._hasReferenceProvider.set(this._languageFeaturesService.referenceProvider.has(model));
            this._hasRenameProvider.set(this._languageFeaturesService.renameProvider.has(model));
            this._hasSignatureHelpProvider.set(this._languageFeaturesService.signatureHelpProvider.has(model));
            this._hasInlayHintsProvider.set(this._languageFeaturesService.inlayHintsProvider.has(model));
            this._hasDocumentFormattingProvider.set(this._languageFeaturesService.documentFormattingEditProvider.has(model) || this._languageFeaturesService.documentRangeFormattingEditProvider.has(model));
            this._hasDocumentSelectionFormattingProvider.set(this._languageFeaturesService.documentRangeFormattingEditProvider.has(model));
            this._hasMultipleDocumentFormattingProvider.set(this._languageFeaturesService.documentFormattingEditProvider.all(model).length + this._languageFeaturesService.documentRangeFormattingEditProvider.all(model).length > 1);
            this._hasMultipleDocumentSelectionFormattingProvider.set(this._languageFeaturesService.documentRangeFormattingEditProvider.all(model).length > 1);
            this._isInEmbeddedEditor.set(model.uri.scheme === (0, _networkJs.Schemas).walkThroughSnippet || model.uri.scheme === (0, _networkJs.Schemas).vscodeChatCodeBlock);
        });
    }
}
class CodeEditorWidgetFocusTracker extends (0, _lifecycleJs.Disposable) {
    constructor(domElement, overflowWidgetsDomNode){
        super();
        this._onChange = this._register(new (0, _eventJs.Emitter)());
        this.onChange = this._onChange.event;
        this._hadFocus = undefined;
        this._hasDomElementFocus = false;
        this._domFocusTracker = this._register(_domJs.trackFocus(domElement));
        this._overflowWidgetsDomNodeHasFocus = false;
        this._register(this._domFocusTracker.onDidFocus(()=>{
            this._hasDomElementFocus = true;
            this._update();
        }));
        this._register(this._domFocusTracker.onDidBlur(()=>{
            this._hasDomElementFocus = false;
            this._update();
        }));
        if (overflowWidgetsDomNode) {
            this._overflowWidgetsDomNode = this._register(_domJs.trackFocus(overflowWidgetsDomNode));
            this._register(this._overflowWidgetsDomNode.onDidFocus(()=>{
                this._overflowWidgetsDomNodeHasFocus = true;
                this._update();
            }));
            this._register(this._overflowWidgetsDomNode.onDidBlur(()=>{
                this._overflowWidgetsDomNodeHasFocus = false;
                this._update();
            }));
        }
    }
    _update() {
        const focused = this._hasDomElementFocus || this._overflowWidgetsDomNodeHasFocus;
        if (this._hadFocus !== focused) {
            this._hadFocus = focused;
            this._onChange.fire(undefined);
        }
    }
    hasFocus() {
        return this._hadFocus ?? false;
    }
}
class EditorDecorationsCollection {
    get length() {
        return this._decorationIds.length;
    }
    constructor(_editor, decorations){
        this._editor = _editor;
        this._decorationIds = [];
        this._isChangingDecorations = false;
        if (Array.isArray(decorations) && decorations.length > 0) this.set(decorations);
    }
    onDidChange(listener, thisArgs, disposables) {
        return this._editor.onDidChangeModelDecorations((e)=>{
            if (this._isChangingDecorations) return;
            listener.call(thisArgs, e);
        }, disposables);
    }
    getRange(index) {
        if (!this._editor.hasModel()) return null;
        if (index >= this._decorationIds.length) return null;
        return this._editor.getModel().getDecorationRange(this._decorationIds[index]);
    }
    getRanges() {
        if (!this._editor.hasModel()) return [];
        const model = this._editor.getModel();
        const result = [];
        for (const decorationId of this._decorationIds){
            const range = model.getDecorationRange(decorationId);
            if (range) result.push(range);
        }
        return result;
    }
    has(decoration) {
        return this._decorationIds.includes(decoration.id);
    }
    clear() {
        if (this._decorationIds.length === 0) // nothing to do
        return;
        this.set([]);
    }
    set(newDecorations) {
        try {
            this._isChangingDecorations = true;
            this._editor.changeDecorations((accessor)=>{
                this._decorationIds = accessor.deltaDecorations(this._decorationIds, newDecorations);
            });
        } finally{
            this._isChangingDecorations = false;
        }
        return this._decorationIds;
    }
    append(newDecorations) {
        let newDecorationIds = [];
        try {
            this._isChangingDecorations = true;
            this._editor.changeDecorations((accessor)=>{
                newDecorationIds = accessor.deltaDecorations([], newDecorations);
                this._decorationIds = this._decorationIds.concat(newDecorationIds);
            });
        } finally{
            this._isChangingDecorations = false;
        }
        return newDecorationIds;
    }
}
const squigglyStart = encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3' enable-background='new 0 0 6 3' height='3' width='6'><g fill='`);
const squigglyEnd = encodeURIComponent(`'><polygon points='5.5,0 2.5,3 1.1,3 4.1,0'/><polygon points='4,0 6,2 6,0.6 5.4,0'/><polygon points='0,2 1,3 2.4,3 0,0.6'/></g></svg>`);
function getSquigglySVGData(color) {
    return squigglyStart + encodeURIComponent(color.toString()) + squigglyEnd;
}
const dotdotdotStart = encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" height="3" width="12"><g fill="`);
const dotdotdotEnd = encodeURIComponent(`"><circle cx="1" cy="1" r="1"/><circle cx="5" cy="1" r="1"/><circle cx="9" cy="1" r="1"/></g></svg>`);
function getDotDotDotSVGData(color) {
    return dotdotdotStart + encodeURIComponent(color.toString()) + dotdotdotEnd;
}
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const errorForeground = theme.getColor((0, _colorRegistryJs.editorErrorForeground));
    if (errorForeground) collector.addRule(`.monaco-editor .${"squiggly-error" /* ClassName.EditorErrorDecoration */ } { background: url("data:image/svg+xml,${getSquigglySVGData(errorForeground)}") repeat-x bottom left; }`);
    const warningForeground = theme.getColor((0, _colorRegistryJs.editorWarningForeground));
    if (warningForeground) collector.addRule(`.monaco-editor .${"squiggly-warning" /* ClassName.EditorWarningDecoration */ } { background: url("data:image/svg+xml,${getSquigglySVGData(warningForeground)}") repeat-x bottom left; }`);
    const infoForeground = theme.getColor((0, _colorRegistryJs.editorInfoForeground));
    if (infoForeground) collector.addRule(`.monaco-editor .${"squiggly-info" /* ClassName.EditorInfoDecoration */ } { background: url("data:image/svg+xml,${getSquigglySVGData(infoForeground)}") repeat-x bottom left; }`);
    const hintForeground = theme.getColor((0, _colorRegistryJs.editorHintForeground));
    if (hintForeground) collector.addRule(`.monaco-editor .${"squiggly-hint" /* ClassName.EditorHintDecoration */ } { background: url("data:image/svg+xml,${getDotDotDotSVGData(hintForeground)}") no-repeat bottom left; }`);
    const unnecessaryForeground = theme.getColor((0, _editorColorRegistryJs.editorUnnecessaryCodeOpacity));
    if (unnecessaryForeground) collector.addRule(`.monaco-editor.showUnused .${"squiggly-inline-unnecessary" /* ClassName.EditorUnnecessaryInlineDecoration */ } { opacity: ${unnecessaryForeground.rgba.a}; }`);
});

},{"../../services/markerDecorations.js":"51Y4g","../../../../base/browser/dom.js":"bnqsM","../../../../base/common/errors.js":"divX8","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/network.js":"2c1AD","./editor.css":"gF7mW","../../config/domFontInfo.js":"fQezv","../../config/editorConfiguration.js":"cpnbk","../../config/tabFocus.js":"aWia7","../../editorExtensions.js":"kC3w6","../../services/codeEditorService.js":"bOWtl","../../view.js":"g6B7d","../../view/domLineBreaksComputer.js":"6iGoB","../../view/viewUserInputEvents.js":"hueuV","./codeEditorContributions.js":"9WYGR","../../../common/config/editorOptions.js":"3Xi00","../../../common/core/cursorColumns.js":"idX7D","../../../common/core/editorColorRegistry.js":"5XqtL","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/cursor/cursorWordOperations.js":"jmZq4","../../../common/editorAction.js":"l9eav","../../../common/editorCommon.js":"681Ll","../../../common/editorContextKeys.js":"5exv9","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../common/model/textModel.js":"9beDe","../../../common/services/languageFeatures.js":"2IAko","../../../common/viewModel/monospaceLineBreaksComputer.js":"emUHa","../../../common/viewModel/viewModelImpl.js":"k4sZN","../../../../nls.js":"l617d","../../../../platform/accessibility/common/accessibility.js":"9Svqy","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/instantiation/common/serviceCollection.js":"5sFx9","../../../../platform/notification/common/notification.js":"igv0W","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/themeService.js":"jMkIC","../../../../platform/actions/common/actions.js":"kyMtp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"51Y4g":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkerDecorationsContribution", ()=>MarkerDecorationsContribution);
var _markerDecorationsJs = require("../../common/services/markerDecorations.js");
var _editorExtensionsJs = require("../editorExtensions.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let MarkerDecorationsContribution = class MarkerDecorationsContribution {
    static{
        this.ID = "editor.contrib.markerDecorations";
    }
    constructor(_editor, _markerDecorationsService){
    // Doesn't do anything, just requires `IMarkerDecorationsService` to make sure it gets instantiated
    }
    dispose() {}
};
MarkerDecorationsContribution = __decorate([
    __param(1, (0, _markerDecorationsJs.IMarkerDecorationsService))
], MarkerDecorationsContribution);
(0, _editorExtensionsJs.registerEditorContribution)(MarkerDecorationsContribution.ID, MarkerDecorationsContribution, 0 /* EditorContributionInstantiation.Eager */ ); // eager because it instantiates IMarkerDecorationsService which is responsible for rendering squiggles

},{"../../common/services/markerDecorations.js":"jDz73","../editorExtensions.js":"kC3w6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gF7mW":[function() {},{}],"cpnbk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorConfiguration", ()=>EditorConfiguration);
parcelHelpers.export(exports, "ComputedEditorOptions", ()=>ComputedEditorOptions);
var _browserJs = require("../../../base/browser/browser.js");
var _arraysJs = require("../../../base/common/arrays.js");
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _objectsJs = require("../../../base/common/objects.js");
var _platformJs = require("../../../base/common/platform.js");
var _elementSizeObserverJs = require("./elementSizeObserver.js");
var _fontMeasurementsJs = require("./fontMeasurements.js");
var _migrateOptionsJs = require("./migrateOptions.js");
var _tabFocusJs = require("./tabFocus.js");
var _editorOptionsJs = require("../../common/config/editorOptions.js");
var _editorZoomJs = require("../../common/config/editorZoom.js");
var _fontInfoJs = require("../../common/config/fontInfo.js");
var _accessibilityJs = require("../../../platform/accessibility/common/accessibility.js");
var _domJs = require("../../../base/browser/dom.js");
var _pixelRatioJs = require("../../../base/browser/pixelRatio.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let EditorConfiguration = class EditorConfiguration extends (0, _lifecycleJs.Disposable) {
    constructor(isSimpleWidget, contextMenuId, options, container, _accessibilityService){
        super();
        this._accessibilityService = _accessibilityService;
        this._onDidChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidChange = this._onDidChange.event;
        this._onDidChangeFast = this._register(new (0, _eventJs.Emitter)());
        this.onDidChangeFast = this._onDidChangeFast.event;
        this._isDominatedByLongLines = false;
        this._viewLineCount = 1;
        this._lineNumbersDigitCount = 1;
        this._reservedHeight = 0;
        this._glyphMarginDecorationLaneCount = 1;
        this._computeOptionsMemory = new (0, _editorOptionsJs.ComputeOptionsMemory)();
        this.isSimpleWidget = isSimpleWidget;
        this.contextMenuId = contextMenuId;
        this._containerObserver = this._register(new (0, _elementSizeObserverJs.ElementSizeObserver)(container, options.dimension));
        this._targetWindowId = (0, _domJs.getWindow)(container).vscodeWindowId;
        this._rawOptions = deepCloneAndMigrateOptions(options);
        this._validatedOptions = EditorOptionsUtil.validateOptions(this._rawOptions);
        this.options = this._computeOptions();
        if (this.options.get(13 /* EditorOption.automaticLayout */ )) this._containerObserver.startObserving();
        this._register((0, _editorZoomJs.EditorZoom).onDidChangeZoomLevel(()=>this._recomputeOptions()));
        this._register((0, _tabFocusJs.TabFocus).onDidChangeTabFocus(()=>this._recomputeOptions()));
        this._register(this._containerObserver.onDidChange(()=>this._recomputeOptions()));
        this._register((0, _fontMeasurementsJs.FontMeasurements).onDidChange(()=>this._recomputeOptions()));
        this._register((0, _pixelRatioJs.PixelRatio).getInstance((0, _domJs.getWindow)(container)).onDidChange(()=>this._recomputeOptions()));
        this._register(this._accessibilityService.onDidChangeScreenReaderOptimized(()=>this._recomputeOptions()));
    }
    _recomputeOptions() {
        const newOptions = this._computeOptions();
        const changeEvent = EditorOptionsUtil.checkEquals(this.options, newOptions);
        if (changeEvent === null) // nothing changed!
        return;
        this.options = newOptions;
        this._onDidChangeFast.fire(changeEvent);
        this._onDidChange.fire(changeEvent);
    }
    _computeOptions() {
        const partialEnv = this._readEnvConfiguration();
        const bareFontInfo = (0, _fontInfoJs.BareFontInfo).createFromValidatedSettings(this._validatedOptions, partialEnv.pixelRatio, this.isSimpleWidget);
        const fontInfo = this._readFontInfo(bareFontInfo);
        const env = {
            memory: this._computeOptionsMemory,
            outerWidth: partialEnv.outerWidth,
            outerHeight: partialEnv.outerHeight - this._reservedHeight,
            fontInfo: fontInfo,
            extraEditorClassName: partialEnv.extraEditorClassName,
            isDominatedByLongLines: this._isDominatedByLongLines,
            viewLineCount: this._viewLineCount,
            lineNumbersDigitCount: this._lineNumbersDigitCount,
            emptySelectionClipboard: partialEnv.emptySelectionClipboard,
            pixelRatio: partialEnv.pixelRatio,
            tabFocusMode: (0, _tabFocusJs.TabFocus).getTabFocusMode(),
            accessibilitySupport: partialEnv.accessibilitySupport,
            glyphMarginDecorationLaneCount: this._glyphMarginDecorationLaneCount
        };
        return EditorOptionsUtil.computeOptions(this._validatedOptions, env);
    }
    _readEnvConfiguration() {
        return {
            extraEditorClassName: getExtraEditorClassName(),
            outerWidth: this._containerObserver.getWidth(),
            outerHeight: this._containerObserver.getHeight(),
            emptySelectionClipboard: _browserJs.isWebKit || _browserJs.isFirefox,
            pixelRatio: (0, _pixelRatioJs.PixelRatio).getInstance((0, _domJs.getWindowById)(this._targetWindowId, true).window).value,
            accessibilitySupport: this._accessibilityService.isScreenReaderOptimized() ? 2 /* AccessibilitySupport.Enabled */  : this._accessibilityService.getAccessibilitySupport()
        };
    }
    _readFontInfo(bareFontInfo) {
        return (0, _fontMeasurementsJs.FontMeasurements).readFontInfo((0, _domJs.getWindowById)(this._targetWindowId, true).window, bareFontInfo);
    }
    getRawOptions() {
        return this._rawOptions;
    }
    updateOptions(_newOptions) {
        const newOptions = deepCloneAndMigrateOptions(_newOptions);
        const didChange = EditorOptionsUtil.applyUpdate(this._rawOptions, newOptions);
        if (!didChange) return;
        this._validatedOptions = EditorOptionsUtil.validateOptions(this._rawOptions);
        this._recomputeOptions();
    }
    observeContainer(dimension) {
        this._containerObserver.observe(dimension);
    }
    setIsDominatedByLongLines(isDominatedByLongLines) {
        if (this._isDominatedByLongLines === isDominatedByLongLines) return;
        this._isDominatedByLongLines = isDominatedByLongLines;
        this._recomputeOptions();
    }
    setModelLineCount(modelLineCount) {
        const lineNumbersDigitCount = digitCount(modelLineCount);
        if (this._lineNumbersDigitCount === lineNumbersDigitCount) return;
        this._lineNumbersDigitCount = lineNumbersDigitCount;
        this._recomputeOptions();
    }
    setViewLineCount(viewLineCount) {
        if (this._viewLineCount === viewLineCount) return;
        this._viewLineCount = viewLineCount;
        this._recomputeOptions();
    }
    setReservedHeight(reservedHeight) {
        if (this._reservedHeight === reservedHeight) return;
        this._reservedHeight = reservedHeight;
        this._recomputeOptions();
    }
    setGlyphMarginDecorationLaneCount(decorationLaneCount) {
        if (this._glyphMarginDecorationLaneCount === decorationLaneCount) return;
        this._glyphMarginDecorationLaneCount = decorationLaneCount;
        this._recomputeOptions();
    }
};
EditorConfiguration = __decorate([
    __param(4, (0, _accessibilityJs.IAccessibilityService))
], EditorConfiguration);
function digitCount(n) {
    let r = 0;
    while(n){
        n = Math.floor(n / 10);
        r++;
    }
    return r ? r : 1;
}
function getExtraEditorClassName() {
    let extra = "";
    if (!_browserJs.isSafari && !_browserJs.isWebkitWebView) // Use user-select: none in all browsers except Safari and native macOS WebView
    extra += "no-user-select ";
    if (_browserJs.isSafari) {
        // See https://github.com/microsoft/vscode/issues/108822
        extra += "no-minimap-shadow ";
        extra += "enable-user-select ";
    }
    if (_platformJs.isMacintosh) extra += "mac ";
    return extra;
}
class ValidatedEditorOptions {
    constructor(){
        this._values = [];
    }
    _read(option) {
        return this._values[option];
    }
    get(id) {
        return this._values[id];
    }
    _write(option, value) {
        this._values[option] = value;
    }
}
class ComputedEditorOptions {
    constructor(){
        this._values = [];
    }
    _read(id) {
        if (id >= this._values.length) throw new Error("Cannot read uninitialized value");
        return this._values[id];
    }
    get(id) {
        return this._read(id);
    }
    _write(id, value) {
        this._values[id] = value;
    }
}
class EditorOptionsUtil {
    static validateOptions(options) {
        const result = new ValidatedEditorOptions();
        for (const editorOption of (0, _editorOptionsJs.editorOptionsRegistry)){
            const value = editorOption.name === "_never_" ? undefined : options[editorOption.name];
            result._write(editorOption.id, editorOption.validate(value));
        }
        return result;
    }
    static computeOptions(options, env) {
        const result = new ComputedEditorOptions();
        for (const editorOption of (0, _editorOptionsJs.editorOptionsRegistry))result._write(editorOption.id, editorOption.compute(env, result, options._read(editorOption.id)));
        return result;
    }
    static _deepEquals(a, b) {
        if (typeof a !== "object" || typeof b !== "object" || !a || !b) return a === b;
        if (Array.isArray(a) || Array.isArray(b)) return Array.isArray(a) && Array.isArray(b) ? _arraysJs.equals(a, b) : false;
        if (Object.keys(a).length !== Object.keys(b).length) return false;
        for(const key in a){
            if (!EditorOptionsUtil._deepEquals(a[key], b[key])) return false;
        }
        return true;
    }
    static checkEquals(a, b) {
        const result = [];
        let somethingChanged = false;
        for (const editorOption of (0, _editorOptionsJs.editorOptionsRegistry)){
            const changed = !EditorOptionsUtil._deepEquals(a._read(editorOption.id), b._read(editorOption.id));
            result[editorOption.id] = changed;
            if (changed) somethingChanged = true;
        }
        return somethingChanged ? new (0, _editorOptionsJs.ConfigurationChangedEvent)(result) : null;
    }
    /**
     * Returns true if something changed.
     * Modifies `options`.
    */ static applyUpdate(options, update) {
        let changed = false;
        for (const editorOption of (0, _editorOptionsJs.editorOptionsRegistry))if (update.hasOwnProperty(editorOption.name)) {
            const result = editorOption.applyUpdate(options[editorOption.name], update[editorOption.name]);
            options[editorOption.name] = result.newValue;
            changed = changed || result.didChange;
        }
        return changed;
    }
}
function deepCloneAndMigrateOptions(_options) {
    const options = _objectsJs.deepClone(_options);
    (0, _migrateOptionsJs.migrateOptions)(options);
    return options;
}

},{"../../../base/browser/browser.js":"4Zquf","../../../base/common/arrays.js":"DECei","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/objects.js":"j84mT","../../../base/common/platform.js":"7maJO","./elementSizeObserver.js":"kvp5N","./fontMeasurements.js":"3umX2","./migrateOptions.js":"cegio","./tabFocus.js":"aWia7","../../common/config/editorOptions.js":"3Xi00","../../common/config/editorZoom.js":"7PVxj","../../common/config/fontInfo.js":"68pxu","../../../platform/accessibility/common/accessibility.js":"9Svqy","../../../base/browser/dom.js":"bnqsM","../../../base/browser/pixelRatio.js":"2Kvgn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kvp5N":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ElementSizeObserver", ()=>ElementSizeObserver);
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _eventJs = require("../../../base/common/event.js");
var _domJs = require("../../../base/browser/dom.js");
class ElementSizeObserver extends (0, _lifecycleJs.Disposable) {
    constructor(referenceDomElement, dimension){
        super();
        this._onDidChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidChange = this._onDidChange.event;
        this._referenceDomElement = referenceDomElement;
        this._width = -1;
        this._height = -1;
        this._resizeObserver = null;
        this.measureReferenceDomElement(false, dimension);
    }
    dispose() {
        this.stopObserving();
        super.dispose();
    }
    getWidth() {
        return this._width;
    }
    getHeight() {
        return this._height;
    }
    startObserving() {
        if (!this._resizeObserver && this._referenceDomElement) {
            // We want to react to the resize observer only once per animation frame
            // The first time the resize observer fires, we will react to it immediately.
            // Otherwise we will postpone to the next animation frame.
            // We'll use `observeContentRect` to store the content rect we received.
            let observedDimenstion = null;
            const observeNow = ()=>{
                if (observedDimenstion) this.observe({
                    width: observedDimenstion.width,
                    height: observedDimenstion.height
                });
                else this.observe();
            };
            let shouldObserve = false;
            let alreadyObservedThisAnimationFrame = false;
            const update = ()=>{
                if (shouldObserve && !alreadyObservedThisAnimationFrame) try {
                    shouldObserve = false;
                    alreadyObservedThisAnimationFrame = true;
                    observeNow();
                } finally{
                    (0, _domJs.scheduleAtNextAnimationFrame)((0, _domJs.getWindow)(this._referenceDomElement), ()=>{
                        alreadyObservedThisAnimationFrame = false;
                        update();
                    });
                }
            };
            this._resizeObserver = new ResizeObserver((entries)=>{
                if (entries && entries[0] && entries[0].contentRect) observedDimenstion = {
                    width: entries[0].contentRect.width,
                    height: entries[0].contentRect.height
                };
                else observedDimenstion = null;
                shouldObserve = true;
                update();
            });
            this._resizeObserver.observe(this._referenceDomElement);
        }
    }
    stopObserving() {
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            this._resizeObserver = null;
        }
    }
    observe(dimension) {
        this.measureReferenceDomElement(true, dimension);
    }
    measureReferenceDomElement(emitEvent, dimension) {
        let observedWidth = 0;
        let observedHeight = 0;
        if (dimension) {
            observedWidth = dimension.width;
            observedHeight = dimension.height;
        } else if (this._referenceDomElement) {
            observedWidth = this._referenceDomElement.clientWidth;
            observedHeight = this._referenceDomElement.clientHeight;
        }
        observedWidth = Math.max(5, observedWidth);
        observedHeight = Math.max(5, observedHeight);
        if (this._width !== observedWidth || this._height !== observedHeight) {
            this._width = observedWidth;
            this._height = observedHeight;
            if (emitEvent) this._onDidChange.fire();
        }
    }
}

},{"../../../base/common/lifecycle.js":"9kg8d","../../../base/common/event.js":"4Zi8b","../../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cegio":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorSettingMigration", ()=>EditorSettingMigration);
/**
 * Compatibility with old options
 */ parcelHelpers.export(exports, "migrateOptions", ()=>migrateOptions);
class EditorSettingMigration {
    static{
        this.items = [];
    }
    constructor(key, migrate){
        this.key = key;
        this.migrate = migrate;
    }
    apply(options) {
        const value = EditorSettingMigration._read(options, this.key);
        const read = (key)=>EditorSettingMigration._read(options, key);
        const write = (key, value)=>EditorSettingMigration._write(options, key, value);
        this.migrate(value, read, write);
    }
    static _read(source, key) {
        if (typeof source === "undefined") return undefined;
        const firstDotIndex = key.indexOf(".");
        if (firstDotIndex >= 0) {
            const firstSegment = key.substring(0, firstDotIndex);
            return this._read(source[firstSegment], key.substring(firstDotIndex + 1));
        }
        return source[key];
    }
    static _write(target, key, value) {
        const firstDotIndex = key.indexOf(".");
        if (firstDotIndex >= 0) {
            const firstSegment = key.substring(0, firstDotIndex);
            target[firstSegment] = target[firstSegment] || {};
            this._write(target[firstSegment], key.substring(firstDotIndex + 1), value);
            return;
        }
        target[key] = value;
    }
}
function registerEditorSettingMigration(key, migrate) {
    EditorSettingMigration.items.push(new EditorSettingMigration(key, migrate));
}
function registerSimpleEditorSettingMigration(key, values) {
    registerEditorSettingMigration(key, (value, read, write)=>{
        if (typeof value !== "undefined") {
            for (const [oldValue, newValue] of values)if (value === oldValue) {
                write(key, newValue);
                return;
            }
        }
    });
}
function migrateOptions(options) {
    EditorSettingMigration.items.forEach((migration)=>migration.apply(options));
}
registerSimpleEditorSettingMigration("wordWrap", [
    [
        true,
        "on"
    ],
    [
        false,
        "off"
    ]
]);
registerSimpleEditorSettingMigration("lineNumbers", [
    [
        true,
        "on"
    ],
    [
        false,
        "off"
    ]
]);
registerSimpleEditorSettingMigration("cursorBlinking", [
    [
        "visible",
        "solid"
    ]
]);
registerSimpleEditorSettingMigration("renderWhitespace", [
    [
        true,
        "boundary"
    ],
    [
        false,
        "none"
    ]
]);
registerSimpleEditorSettingMigration("renderLineHighlight", [
    [
        true,
        "line"
    ],
    [
        false,
        "none"
    ]
]);
registerSimpleEditorSettingMigration("acceptSuggestionOnEnter", [
    [
        true,
        "on"
    ],
    [
        false,
        "off"
    ]
]);
registerSimpleEditorSettingMigration("tabCompletion", [
    [
        false,
        "off"
    ],
    [
        true,
        "onlySnippets"
    ]
]);
registerSimpleEditorSettingMigration("hover", [
    [
        true,
        {
            enabled: true
        }
    ],
    [
        false,
        {
            enabled: false
        }
    ]
]);
registerSimpleEditorSettingMigration("parameterHints", [
    [
        true,
        {
            enabled: true
        }
    ],
    [
        false,
        {
            enabled: false
        }
    ]
]);
registerSimpleEditorSettingMigration("autoIndent", [
    [
        false,
        "advanced"
    ],
    [
        true,
        "full"
    ]
]);
registerSimpleEditorSettingMigration("matchBrackets", [
    [
        true,
        "always"
    ],
    [
        false,
        "never"
    ]
]);
registerSimpleEditorSettingMigration("renderFinalNewline", [
    [
        true,
        "on"
    ],
    [
        false,
        "off"
    ]
]);
registerSimpleEditorSettingMigration("cursorSmoothCaretAnimation", [
    [
        true,
        "on"
    ],
    [
        false,
        "off"
    ]
]);
registerSimpleEditorSettingMigration("occurrencesHighlight", [
    [
        true,
        "singleFile"
    ],
    [
        false,
        "off"
    ]
]);
registerSimpleEditorSettingMigration("wordBasedSuggestions", [
    [
        true,
        "matchingDocuments"
    ],
    [
        false,
        "off"
    ]
]);
registerEditorSettingMigration("autoClosingBrackets", (value, read, write)=>{
    if (value === false) {
        write("autoClosingBrackets", "never");
        if (typeof read("autoClosingQuotes") === "undefined") write("autoClosingQuotes", "never");
        if (typeof read("autoSurround") === "undefined") write("autoSurround", "never");
    }
});
registerEditorSettingMigration("renderIndentGuides", (value, read, write)=>{
    if (typeof value !== "undefined") {
        write("renderIndentGuides", undefined);
        if (typeof read("guides.indentation") === "undefined") write("guides.indentation", !!value);
    }
});
registerEditorSettingMigration("highlightActiveIndentGuide", (value, read, write)=>{
    if (typeof value !== "undefined") {
        write("highlightActiveIndentGuide", undefined);
        if (typeof read("guides.highlightActiveIndentation") === "undefined") write("guides.highlightActiveIndentation", !!value);
    }
});
const suggestFilteredTypesMapping = {
    method: "showMethods",
    function: "showFunctions",
    constructor: "showConstructors",
    deprecated: "showDeprecated",
    field: "showFields",
    variable: "showVariables",
    class: "showClasses",
    struct: "showStructs",
    interface: "showInterfaces",
    module: "showModules",
    property: "showProperties",
    event: "showEvents",
    operator: "showOperators",
    unit: "showUnits",
    value: "showValues",
    constant: "showConstants",
    enum: "showEnums",
    enumMember: "showEnumMembers",
    keyword: "showKeywords",
    text: "showWords",
    color: "showColors",
    file: "showFiles",
    reference: "showReferences",
    folder: "showFolders",
    typeParameter: "showTypeParameters",
    snippet: "showSnippets"
};
registerEditorSettingMigration("suggest.filteredTypes", (value, read, write)=>{
    if (value && typeof value === "object") {
        for (const entry of Object.entries(suggestFilteredTypesMapping)){
            const v = value[entry[0]];
            if (v === false) {
                if (typeof read(`suggest.${entry[1]}`) === "undefined") write(`suggest.${entry[1]}`, false);
            }
        }
        write("suggest.filteredTypes", undefined);
    }
});
registerEditorSettingMigration("quickSuggestions", (input, read, write)=>{
    if (typeof input === "boolean") {
        const value = input ? "on" : "off";
        const newValue = {
            comments: value,
            strings: value,
            other: value
        };
        write("quickSuggestions", newValue);
    }
});
// Sticky Scroll
registerEditorSettingMigration("experimental.stickyScroll.enabled", (value, read, write)=>{
    if (typeof value === "boolean") {
        write("experimental.stickyScroll.enabled", undefined);
        if (typeof read("stickyScroll.enabled") === "undefined") write("stickyScroll.enabled", value);
    }
});
registerEditorSettingMigration("experimental.stickyScroll.maxLineCount", (value, read, write)=>{
    if (typeof value === "number") {
        write("experimental.stickyScroll.maxLineCount", undefined);
        if (typeof read("stickyScroll.maxLineCount") === "undefined") write("stickyScroll.maxLineCount", value);
    }
});
// Code Actions on Save
registerEditorSettingMigration("codeActionsOnSave", (value, read, write)=>{
    if (value && typeof value === "object") {
        let toBeModified = false;
        const newValue = {};
        for (const entry of Object.entries(value))if (typeof entry[1] === "boolean") {
            toBeModified = true;
            newValue[entry[0]] = entry[1] ? "explicit" : "never";
        } else newValue[entry[0]] = entry[1];
        if (toBeModified) write(`codeActionsOnSave`, newValue);
    }
});
// Migrate Quick Fix Settings
registerEditorSettingMigration("codeActionWidget.includeNearbyQuickfixes", (value, read, write)=>{
    if (typeof value === "boolean") {
        write("codeActionWidget.includeNearbyQuickfixes", undefined);
        if (typeof read("codeActionWidget.includeNearbyQuickFixes") === "undefined") write("codeActionWidget.includeNearbyQuickFixes", value);
    }
});
// Migrate the lightbulb settings
registerEditorSettingMigration("lightbulb.enabled", (value, read, write)=>{
    if (typeof value === "boolean") write("lightbulb.enabled", value ? undefined : "off");
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aWia7":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabFocus", ()=>TabFocus);
var _eventJs = require("../../../base/common/event.js");
class TabFocusImpl {
    constructor(){
        this._tabFocus = false;
        this._onDidChangeTabFocus = new (0, _eventJs.Emitter)();
        this.onDidChangeTabFocus = this._onDidChangeTabFocus.event;
    }
    getTabFocusMode() {
        return this._tabFocus;
    }
    setTabFocusMode(tabFocusMode) {
        this._tabFocus = tabFocusMode;
        this._onDidChangeTabFocus.fire(this._tabFocus);
    }
}
const TabFocus = new TabFocusImpl();

},{"../../../base/common/event.js":"4Zi8b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g6B7d":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "View", ()=>View);
var _domJs = require("../../base/browser/dom.js");
var _fastDomNodeJs = require("../../base/browser/fastDomNode.js");
var _performanceJs = require("../../base/browser/performance.js");
var _errorsJs = require("../../base/common/errors.js");
var _mouseTargetJs = require("./controller/mouseTarget.js");
var _pointerHandlerJs = require("./controller/pointerHandler.js");
var _textAreaHandlerJs = require("./controller/textAreaHandler.js");
var _renderingContextJs = require("./view/renderingContext.js");
var _viewControllerJs = require("./view/viewController.js");
var _viewOverlaysJs = require("./view/viewOverlays.js");
var _viewPartJs = require("./view/viewPart.js");
var _viewUserInputEventsJs = require("./view/viewUserInputEvents.js");
var _blockDecorationsJs = require("./viewParts/blockDecorations/blockDecorations.js");
var _contentWidgetsJs = require("./viewParts/contentWidgets/contentWidgets.js");
var _currentLineHighlightJs = require("./viewParts/currentLineHighlight/currentLineHighlight.js");
var _decorationsJs = require("./viewParts/decorations/decorations.js");
var _editorScrollbarJs = require("./viewParts/editorScrollbar/editorScrollbar.js");
var _glyphMarginJs = require("./viewParts/glyphMargin/glyphMargin.js");
var _indentGuidesJs = require("./viewParts/indentGuides/indentGuides.js");
var _lineNumbersJs = require("./viewParts/lineNumbers/lineNumbers.js");
var _viewLinesJs = require("./viewParts/lines/viewLines.js");
var _linesDecorationsJs = require("./viewParts/linesDecorations/linesDecorations.js");
var _marginJs = require("./viewParts/margin/margin.js");
var _marginDecorationsJs = require("./viewParts/marginDecorations/marginDecorations.js");
var _minimapJs = require("./viewParts/minimap/minimap.js");
var _overlayWidgetsJs = require("./viewParts/overlayWidgets/overlayWidgets.js");
var _decorationsOverviewRulerJs = require("./viewParts/overviewRuler/decorationsOverviewRuler.js");
var _overviewRulerJs = require("./viewParts/overviewRuler/overviewRuler.js");
var _rulersJs = require("./viewParts/rulers/rulers.js");
var _scrollDecorationJs = require("./viewParts/scrollDecoration/scrollDecoration.js");
var _selectionsJs = require("./viewParts/selections/selections.js");
var _viewCursorsJs = require("./viewParts/viewCursors/viewCursors.js");
var _viewZonesJs = require("./viewParts/viewZones/viewZones.js");
var _whitespaceJs = require("./viewParts/whitespace/whitespace.js");
var _positionJs = require("../common/core/position.js");
var _rangeJs = require("../common/core/range.js");
var _selectionJs = require("../common/core/selection.js");
var _modelJs = require("../common/model.js");
var _viewEventHandlerJs = require("../common/viewEventHandler.js");
var _viewLinesViewportDataJs = require("../common/viewLayout/viewLinesViewportData.js");
var _viewContextJs = require("../common/viewModel/viewContext.js");
var _instantiationJs = require("../../platform/instantiation/common/instantiation.js");
var _themeServiceJs = require("../../platform/theme/common/themeService.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let View = class View extends (0, _viewEventHandlerJs.ViewEventHandler) {
    constructor(commandDelegate, configuration, colorTheme, model, userInputEvents, overflowWidgetsDomNode, _instantiationService){
        super();
        this._instantiationService = _instantiationService;
        // Actual mutable state
        this._shouldRecomputeGlyphMarginLanes = false;
        this._selections = [
            new (0, _selectionJs.Selection)(1, 1, 1, 1)
        ];
        this._renderAnimationFrame = null;
        const viewController = new (0, _viewControllerJs.ViewController)(configuration, model, userInputEvents, commandDelegate);
        // The view context is passed on to most classes (basically to reduce param. counts in ctors)
        this._context = new (0, _viewContextJs.ViewContext)(configuration, colorTheme, model);
        // Ensure the view is the first event handler in order to update the layout
        this._context.addEventHandler(this);
        this._viewParts = [];
        // Keyboard handler
        this._textAreaHandler = this._instantiationService.createInstance((0, _textAreaHandlerJs.TextAreaHandler), this._context, viewController, this._createTextAreaHandlerHelper());
        this._viewParts.push(this._textAreaHandler);
        // These two dom nodes must be constructed up front, since references are needed in the layout provider (scrolling & co.)
        this._linesContent = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this._linesContent.setClassName("lines-content monaco-editor-background");
        this._linesContent.setPosition("absolute");
        this.domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this.domNode.setClassName(this._getEditorClassName());
        // Set role 'code' for better screen reader support https://github.com/microsoft/vscode/issues/93438
        this.domNode.setAttribute("role", "code");
        this._overflowGuardContainer = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        (0, _viewPartJs.PartFingerprints).write(this._overflowGuardContainer, 3 /* PartFingerprint.OverflowGuard */ );
        this._overflowGuardContainer.setClassName("overflow-guard");
        this._scrollbar = new (0, _editorScrollbarJs.EditorScrollbar)(this._context, this._linesContent, this.domNode, this._overflowGuardContainer);
        this._viewParts.push(this._scrollbar);
        // View Lines
        this._viewLines = new (0, _viewLinesJs.ViewLines)(this._context, this._linesContent);
        // View Zones
        this._viewZones = new (0, _viewZonesJs.ViewZones)(this._context);
        this._viewParts.push(this._viewZones);
        // Decorations overview ruler
        const decorationsOverviewRuler = new (0, _decorationsOverviewRulerJs.DecorationsOverviewRuler)(this._context);
        this._viewParts.push(decorationsOverviewRuler);
        const scrollDecoration = new (0, _scrollDecorationJs.ScrollDecorationViewPart)(this._context);
        this._viewParts.push(scrollDecoration);
        const contentViewOverlays = new (0, _viewOverlaysJs.ContentViewOverlays)(this._context);
        this._viewParts.push(contentViewOverlays);
        contentViewOverlays.addDynamicOverlay(new (0, _currentLineHighlightJs.CurrentLineHighlightOverlay)(this._context));
        contentViewOverlays.addDynamicOverlay(new (0, _selectionsJs.SelectionsOverlay)(this._context));
        contentViewOverlays.addDynamicOverlay(new (0, _indentGuidesJs.IndentGuidesOverlay)(this._context));
        contentViewOverlays.addDynamicOverlay(new (0, _decorationsJs.DecorationsOverlay)(this._context));
        contentViewOverlays.addDynamicOverlay(new (0, _whitespaceJs.WhitespaceOverlay)(this._context));
        const marginViewOverlays = new (0, _viewOverlaysJs.MarginViewOverlays)(this._context);
        this._viewParts.push(marginViewOverlays);
        marginViewOverlays.addDynamicOverlay(new (0, _currentLineHighlightJs.CurrentLineMarginHighlightOverlay)(this._context));
        marginViewOverlays.addDynamicOverlay(new (0, _marginDecorationsJs.MarginViewLineDecorationsOverlay)(this._context));
        marginViewOverlays.addDynamicOverlay(new (0, _linesDecorationsJs.LinesDecorationsOverlay)(this._context));
        marginViewOverlays.addDynamicOverlay(new (0, _lineNumbersJs.LineNumbersOverlay)(this._context));
        // Glyph margin widgets
        this._glyphMarginWidgets = new (0, _glyphMarginJs.GlyphMarginWidgets)(this._context);
        this._viewParts.push(this._glyphMarginWidgets);
        const margin = new (0, _marginJs.Margin)(this._context);
        margin.getDomNode().appendChild(this._viewZones.marginDomNode);
        margin.getDomNode().appendChild(marginViewOverlays.getDomNode());
        margin.getDomNode().appendChild(this._glyphMarginWidgets.domNode);
        this._viewParts.push(margin);
        // Content widgets
        this._contentWidgets = new (0, _contentWidgetsJs.ViewContentWidgets)(this._context, this.domNode);
        this._viewParts.push(this._contentWidgets);
        this._viewCursors = new (0, _viewCursorsJs.ViewCursors)(this._context);
        this._viewParts.push(this._viewCursors);
        // Overlay widgets
        this._overlayWidgets = new (0, _overlayWidgetsJs.ViewOverlayWidgets)(this._context, this.domNode);
        this._viewParts.push(this._overlayWidgets);
        const rulers = new (0, _rulersJs.Rulers)(this._context);
        this._viewParts.push(rulers);
        const blockOutline = new (0, _blockDecorationsJs.BlockDecorations)(this._context);
        this._viewParts.push(blockOutline);
        const minimap = new (0, _minimapJs.Minimap)(this._context);
        this._viewParts.push(minimap);
        // -------------- Wire dom nodes up
        if (decorationsOverviewRuler) {
            const overviewRulerData = this._scrollbar.getOverviewRulerLayoutInfo();
            overviewRulerData.parent.insertBefore(decorationsOverviewRuler.getDomNode(), overviewRulerData.insertBefore);
        }
        this._linesContent.appendChild(contentViewOverlays.getDomNode());
        this._linesContent.appendChild(rulers.domNode);
        this._linesContent.appendChild(this._viewZones.domNode);
        this._linesContent.appendChild(this._viewLines.getDomNode());
        this._linesContent.appendChild(this._contentWidgets.domNode);
        this._linesContent.appendChild(this._viewCursors.getDomNode());
        this._overflowGuardContainer.appendChild(margin.getDomNode());
        this._overflowGuardContainer.appendChild(this._scrollbar.getDomNode());
        this._overflowGuardContainer.appendChild(scrollDecoration.getDomNode());
        this._overflowGuardContainer.appendChild(this._textAreaHandler.textArea);
        this._overflowGuardContainer.appendChild(this._textAreaHandler.textAreaCover);
        this._overflowGuardContainer.appendChild(this._overlayWidgets.getDomNode());
        this._overflowGuardContainer.appendChild(minimap.getDomNode());
        this._overflowGuardContainer.appendChild(blockOutline.domNode);
        this.domNode.appendChild(this._overflowGuardContainer);
        if (overflowWidgetsDomNode) {
            overflowWidgetsDomNode.appendChild(this._contentWidgets.overflowingContentWidgetsDomNode.domNode);
            overflowWidgetsDomNode.appendChild(this._overlayWidgets.overflowingOverlayWidgetsDomNode.domNode);
        } else {
            this.domNode.appendChild(this._contentWidgets.overflowingContentWidgetsDomNode);
            this.domNode.appendChild(this._overlayWidgets.overflowingOverlayWidgetsDomNode);
        }
        this._applyLayout();
        // Pointer handler
        this._pointerHandler = this._register(new (0, _pointerHandlerJs.PointerHandler)(this._context, viewController, this._createPointerHandlerHelper()));
    }
    _computeGlyphMarginLanes() {
        const model = this._context.viewModel.model;
        const laneModel = this._context.viewModel.glyphLanes;
        let glyphs = [];
        let maxLineNumber = 0;
        // Add all margin decorations
        glyphs = glyphs.concat(model.getAllMarginDecorations().map((decoration)=>{
            const lane = decoration.options.glyphMargin?.position ?? (0, _modelJs.GlyphMarginLane).Center;
            maxLineNumber = Math.max(maxLineNumber, decoration.range.endLineNumber);
            return {
                range: decoration.range,
                lane,
                persist: decoration.options.glyphMargin?.persistLane
            };
        }));
        // Add all glyph margin widgets
        glyphs = glyphs.concat(this._glyphMarginWidgets.getWidgets().map((widget)=>{
            const range = model.validateRange(widget.preference.range);
            maxLineNumber = Math.max(maxLineNumber, range.endLineNumber);
            return {
                range,
                lane: widget.preference.lane
            };
        }));
        // Sorted by their start position
        glyphs.sort((a, b)=>(0, _rangeJs.Range).compareRangesUsingStarts(a.range, b.range));
        laneModel.reset(maxLineNumber);
        for (const glyph of glyphs)laneModel.push(glyph.lane, glyph.range, glyph.persist);
        return laneModel;
    }
    _createPointerHandlerHelper() {
        return {
            viewDomNode: this.domNode.domNode,
            linesContentDomNode: this._linesContent.domNode,
            viewLinesDomNode: this._viewLines.getDomNode().domNode,
            focusTextArea: ()=>{
                this.focus();
            },
            dispatchTextAreaEvent: (event)=>{
                this._textAreaHandler.textArea.domNode.dispatchEvent(event);
            },
            getLastRenderData: ()=>{
                const lastViewCursorsRenderData = this._viewCursors.getLastRenderData() || [];
                const lastTextareaPosition = this._textAreaHandler.getLastRenderData();
                return new (0, _mouseTargetJs.PointerHandlerLastRenderData)(lastViewCursorsRenderData, lastTextareaPosition);
            },
            renderNow: ()=>{
                this.render(true, false);
            },
            shouldSuppressMouseDownOnViewZone: (viewZoneId)=>{
                return this._viewZones.shouldSuppressMouseDownOnViewZone(viewZoneId);
            },
            shouldSuppressMouseDownOnWidget: (widgetId)=>{
                return this._contentWidgets.shouldSuppressMouseDownOnWidget(widgetId);
            },
            getPositionFromDOMInfo: (spanNode, offset)=>{
                this._flushAccumulatedAndRenderNow();
                return this._viewLines.getPositionFromDOMInfo(spanNode, offset);
            },
            visibleRangeForPosition: (lineNumber, column)=>{
                this._flushAccumulatedAndRenderNow();
                return this._viewLines.visibleRangeForPosition(new (0, _positionJs.Position)(lineNumber, column));
            },
            getLineWidth: (lineNumber)=>{
                this._flushAccumulatedAndRenderNow();
                return this._viewLines.getLineWidth(lineNumber);
            }
        };
    }
    _createTextAreaHandlerHelper() {
        return {
            visibleRangeForPosition: (position)=>{
                this._flushAccumulatedAndRenderNow();
                return this._viewLines.visibleRangeForPosition(position);
            }
        };
    }
    _applyLayout() {
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this.domNode.setWidth(layoutInfo.width);
        this.domNode.setHeight(layoutInfo.height);
        this._overflowGuardContainer.setWidth(layoutInfo.width);
        this._overflowGuardContainer.setHeight(layoutInfo.height);
        // https://stackoverflow.com/questions/38905916/content-in-google-chrome-larger-than-16777216-px-not-being-rendered
        this._linesContent.setWidth(16777216);
        this._linesContent.setHeight(16777216);
    }
    _getEditorClassName() {
        const focused = this._textAreaHandler.isFocused() ? " focused" : "";
        return this._context.configuration.options.get(143 /* EditorOption.editorClassName */ ) + " " + (0, _themeServiceJs.getThemeTypeSelector)(this._context.theme.type) + focused;
    }
    // --- begin event handlers
    handleEvents(events) {
        super.handleEvents(events);
        this._scheduleRender();
    }
    onConfigurationChanged(e) {
        this.domNode.setClassName(this._getEditorClassName());
        this._applyLayout();
        return false;
    }
    onCursorStateChanged(e) {
        this._selections = e.selections;
        return false;
    }
    onDecorationsChanged(e) {
        if (e.affectsGlyphMargin) this._shouldRecomputeGlyphMarginLanes = true;
        return false;
    }
    onFocusChanged(e) {
        this.domNode.setClassName(this._getEditorClassName());
        return false;
    }
    onThemeChanged(e) {
        this._context.theme.update(e.theme);
        this.domNode.setClassName(this._getEditorClassName());
        return false;
    }
    // --- end event handlers
    dispose() {
        if (this._renderAnimationFrame !== null) {
            this._renderAnimationFrame.dispose();
            this._renderAnimationFrame = null;
        }
        this._contentWidgets.overflowingContentWidgetsDomNode.domNode.remove();
        this._context.removeEventHandler(this);
        this._viewLines.dispose();
        // Destroy view parts
        for (const viewPart of this._viewParts)viewPart.dispose();
        super.dispose();
    }
    _scheduleRender() {
        if (this._store.isDisposed) throw new (0, _errorsJs.BugIndicatingError)();
        if (this._renderAnimationFrame === null) {
            const rendering = this._createCoordinatedRendering();
            this._renderAnimationFrame = EditorRenderingCoordinator.INSTANCE.scheduleCoordinatedRendering({
                window: _domJs.getWindow(this.domNode?.domNode),
                prepareRenderText: ()=>{
                    if (this._store.isDisposed) throw new (0, _errorsJs.BugIndicatingError)();
                    try {
                        return rendering.prepareRenderText();
                    } finally{
                        this._renderAnimationFrame = null;
                    }
                },
                renderText: ()=>{
                    if (this._store.isDisposed) throw new (0, _errorsJs.BugIndicatingError)();
                    return rendering.renderText();
                },
                prepareRender: (viewParts, ctx)=>{
                    if (this._store.isDisposed) throw new (0, _errorsJs.BugIndicatingError)();
                    return rendering.prepareRender(viewParts, ctx);
                },
                render: (viewParts, ctx)=>{
                    if (this._store.isDisposed) throw new (0, _errorsJs.BugIndicatingError)();
                    return rendering.render(viewParts, ctx);
                }
            });
        }
    }
    _flushAccumulatedAndRenderNow() {
        const rendering = this._createCoordinatedRendering();
        safeInvokeNoArg(()=>rendering.prepareRenderText());
        const data = safeInvokeNoArg(()=>rendering.renderText());
        if (data) {
            const [viewParts, ctx] = data;
            safeInvokeNoArg(()=>rendering.prepareRender(viewParts, ctx));
            safeInvokeNoArg(()=>rendering.render(viewParts, ctx));
        }
    }
    _getViewPartsToRender() {
        const result = [];
        let resultLen = 0;
        for (const viewPart of this._viewParts)if (viewPart.shouldRender()) result[resultLen++] = viewPart;
        return result;
    }
    _createCoordinatedRendering() {
        return {
            prepareRenderText: ()=>{
                if (this._shouldRecomputeGlyphMarginLanes) {
                    this._shouldRecomputeGlyphMarginLanes = false;
                    const model = this._computeGlyphMarginLanes();
                    this._context.configuration.setGlyphMarginDecorationLaneCount(model.requiredLanes);
                }
                (0, _performanceJs.inputLatency).onRenderStart();
            },
            renderText: ()=>{
                if (!this.domNode.domNode.isConnected) return null;
                let viewPartsToRender = this._getViewPartsToRender();
                if (!this._viewLines.shouldRender() && viewPartsToRender.length === 0) // Nothing to render
                return null;
                const partialViewportData = this._context.viewLayout.getLinesViewportData();
                this._context.viewModel.setViewport(partialViewportData.startLineNumber, partialViewportData.endLineNumber, partialViewportData.centeredLineNumber);
                const viewportData = new (0, _viewLinesViewportDataJs.ViewportData)(this._selections, partialViewportData, this._context.viewLayout.getWhitespaceViewportData(), this._context.viewModel);
                if (this._contentWidgets.shouldRender()) // Give the content widgets a chance to set their max width before a possible synchronous layout
                this._contentWidgets.onBeforeRender(viewportData);
                if (this._viewLines.shouldRender()) {
                    this._viewLines.renderText(viewportData);
                    this._viewLines.onDidRender();
                    // Rendering of viewLines might cause scroll events to occur, so collect view parts to render again
                    viewPartsToRender = this._getViewPartsToRender();
                }
                return [
                    viewPartsToRender,
                    new (0, _renderingContextJs.RenderingContext)(this._context.viewLayout, viewportData, this._viewLines)
                ];
            },
            prepareRender: (viewPartsToRender, ctx)=>{
                for (const viewPart of viewPartsToRender)viewPart.prepareRender(ctx);
            },
            render: (viewPartsToRender, ctx)=>{
                for (const viewPart of viewPartsToRender){
                    viewPart.render(ctx);
                    viewPart.onDidRender();
                }
            }
        };
    }
    // --- BEGIN CodeEditor helpers
    delegateVerticalScrollbarPointerDown(browserEvent) {
        this._scrollbar.delegateVerticalScrollbarPointerDown(browserEvent);
    }
    delegateScrollFromMouseWheelEvent(browserEvent) {
        this._scrollbar.delegateScrollFromMouseWheelEvent(browserEvent);
    }
    restoreState(scrollPosition) {
        this._context.viewModel.viewLayout.setScrollPosition({
            scrollTop: scrollPosition.scrollTop,
            scrollLeft: scrollPosition.scrollLeft
        }, 1 /* ScrollType.Immediate */ );
        this._context.viewModel.visibleLinesStabilized();
    }
    getOffsetForColumn(modelLineNumber, modelColumn) {
        const modelPosition = this._context.viewModel.model.validatePosition({
            lineNumber: modelLineNumber,
            column: modelColumn
        });
        const viewPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(modelPosition);
        this._flushAccumulatedAndRenderNow();
        const visibleRange = this._viewLines.visibleRangeForPosition(new (0, _positionJs.Position)(viewPosition.lineNumber, viewPosition.column));
        if (!visibleRange) return -1;
        return visibleRange.left;
    }
    getTargetAtClientPoint(clientX, clientY) {
        const mouseTarget = this._pointerHandler.getTargetAtClientPoint(clientX, clientY);
        if (!mouseTarget) return null;
        return (0, _viewUserInputEventsJs.ViewUserInputEvents).convertViewToModelMouseTarget(mouseTarget, this._context.viewModel.coordinatesConverter);
    }
    createOverviewRuler(cssClassName) {
        return new (0, _overviewRulerJs.OverviewRuler)(this._context, cssClassName);
    }
    change(callback) {
        this._viewZones.changeViewZones(callback);
        this._scheduleRender();
    }
    render(now, everything) {
        if (everything) {
            // Force everything to render...
            this._viewLines.forceShouldRender();
            for (const viewPart of this._viewParts)viewPart.forceShouldRender();
        }
        if (now) this._flushAccumulatedAndRenderNow();
        else this._scheduleRender();
    }
    writeScreenReaderContent(reason) {
        this._textAreaHandler.writeScreenReaderContent(reason);
    }
    focus() {
        this._textAreaHandler.focusTextArea();
    }
    isFocused() {
        return this._textAreaHandler.isFocused();
    }
    setAriaOptions(options) {
        this._textAreaHandler.setAriaOptions(options);
    }
    addContentWidget(widgetData) {
        this._contentWidgets.addWidget(widgetData.widget);
        this.layoutContentWidget(widgetData);
        this._scheduleRender();
    }
    layoutContentWidget(widgetData) {
        this._contentWidgets.setWidgetPosition(widgetData.widget, widgetData.position?.position ?? null, widgetData.position?.secondaryPosition ?? null, widgetData.position?.preference ?? null, widgetData.position?.positionAffinity ?? null);
        this._scheduleRender();
    }
    removeContentWidget(widgetData) {
        this._contentWidgets.removeWidget(widgetData.widget);
        this._scheduleRender();
    }
    addOverlayWidget(widgetData) {
        this._overlayWidgets.addWidget(widgetData.widget);
        this.layoutOverlayWidget(widgetData);
        this._scheduleRender();
    }
    layoutOverlayWidget(widgetData) {
        const shouldRender = this._overlayWidgets.setWidgetPosition(widgetData.widget, widgetData.position);
        if (shouldRender) this._scheduleRender();
    }
    removeOverlayWidget(widgetData) {
        this._overlayWidgets.removeWidget(widgetData.widget);
        this._scheduleRender();
    }
    addGlyphMarginWidget(widgetData) {
        this._glyphMarginWidgets.addWidget(widgetData.widget);
        this._shouldRecomputeGlyphMarginLanes = true;
        this._scheduleRender();
    }
    layoutGlyphMarginWidget(widgetData) {
        const newPreference = widgetData.position;
        const shouldRender = this._glyphMarginWidgets.setWidgetPosition(widgetData.widget, newPreference);
        if (shouldRender) {
            this._shouldRecomputeGlyphMarginLanes = true;
            this._scheduleRender();
        }
    }
    removeGlyphMarginWidget(widgetData) {
        this._glyphMarginWidgets.removeWidget(widgetData.widget);
        this._shouldRecomputeGlyphMarginLanes = true;
        this._scheduleRender();
    }
};
View = __decorate([
    __param(6, (0, _instantiationJs.IInstantiationService))
], View);
function safeInvokeNoArg(func) {
    try {
        return func();
    } catch (e) {
        (0, _errorsJs.onUnexpectedError)(e);
        return null;
    }
}
class EditorRenderingCoordinator {
    static{
        this.INSTANCE = new EditorRenderingCoordinator();
    }
    constructor(){
        this._coordinatedRenderings = [];
        this._animationFrameRunners = new Map();
    }
    scheduleCoordinatedRendering(rendering) {
        this._coordinatedRenderings.push(rendering);
        this._scheduleRender(rendering.window);
        return {
            dispose: ()=>{
                const renderingIndex = this._coordinatedRenderings.indexOf(rendering);
                if (renderingIndex === -1) return;
                this._coordinatedRenderings.splice(renderingIndex, 1);
                if (this._coordinatedRenderings.length === 0) {
                    // There are no more renderings to coordinate => cancel animation frames
                    for (const [_, disposable] of this._animationFrameRunners)disposable.dispose();
                    this._animationFrameRunners.clear();
                }
            }
        };
    }
    _scheduleRender(window) {
        if (!this._animationFrameRunners.has(window)) {
            const runner = ()=>{
                this._animationFrameRunners.delete(window);
                this._onRenderScheduled();
            };
            this._animationFrameRunners.set(window, _domJs.runAtThisOrScheduleAtNextAnimationFrame(window, runner, 100));
        }
    }
    _onRenderScheduled() {
        const coordinatedRenderings = this._coordinatedRenderings.slice(0);
        this._coordinatedRenderings = [];
        for (const rendering of coordinatedRenderings)safeInvokeNoArg(()=>rendering.prepareRenderText());
        const datas = [];
        for(let i = 0, len = coordinatedRenderings.length; i < len; i++){
            const rendering = coordinatedRenderings[i];
            datas[i] = safeInvokeNoArg(()=>rendering.renderText());
        }
        for(let i = 0, len = coordinatedRenderings.length; i < len; i++){
            const rendering = coordinatedRenderings[i];
            const data = datas[i];
            if (!data) continue;
            const [viewParts, ctx] = data;
            safeInvokeNoArg(()=>rendering.prepareRender(viewParts, ctx));
        }
        for(let i = 0, len = coordinatedRenderings.length; i < len; i++){
            const rendering = coordinatedRenderings[i];
            const data = datas[i];
            if (!data) continue;
            const [viewParts, ctx] = data;
            safeInvokeNoArg(()=>rendering.render(viewParts, ctx));
        }
    }
}

},{"../../base/browser/dom.js":"bnqsM","../../base/browser/fastDomNode.js":"2SADf","../../base/browser/performance.js":"9Gvzx","../../base/common/errors.js":"divX8","./controller/mouseTarget.js":"eaOsC","./controller/pointerHandler.js":"618Ru","./controller/textAreaHandler.js":"aM7Oo","./view/renderingContext.js":"bWoBX","./view/viewController.js":"zgM61","./view/viewOverlays.js":"fr4HK","./view/viewPart.js":"kTsLR","./view/viewUserInputEvents.js":"hueuV","./viewParts/blockDecorations/blockDecorations.js":"3uTRE","./viewParts/contentWidgets/contentWidgets.js":"40rVu","./viewParts/currentLineHighlight/currentLineHighlight.js":"272PD","./viewParts/decorations/decorations.js":"44Gng","./viewParts/editorScrollbar/editorScrollbar.js":"fBX2x","./viewParts/glyphMargin/glyphMargin.js":"gKiXe","./viewParts/indentGuides/indentGuides.js":"lNUuS","./viewParts/lineNumbers/lineNumbers.js":"7jBDo","./viewParts/lines/viewLines.js":"2Tih7","./viewParts/linesDecorations/linesDecorations.js":"88WDq","./viewParts/margin/margin.js":"6wqez","./viewParts/marginDecorations/marginDecorations.js":"2B9sH","./viewParts/minimap/minimap.js":"fhtW4","./viewParts/overlayWidgets/overlayWidgets.js":"kHnNk","./viewParts/overviewRuler/decorationsOverviewRuler.js":"iUvcT","./viewParts/overviewRuler/overviewRuler.js":"61Bf6","./viewParts/rulers/rulers.js":"3qAOT","./viewParts/scrollDecoration/scrollDecoration.js":"1WwMU","./viewParts/selections/selections.js":"ceEPx","./viewParts/viewCursors/viewCursors.js":"cYAdh","./viewParts/viewZones/viewZones.js":"iV3Rc","./viewParts/whitespace/whitespace.js":"6KlIs","../common/core/position.js":"lvrPe","../common/core/range.js":"jmUPh","../common/core/selection.js":"kcwzU","../common/model.js":"1CSIB","../common/viewEventHandler.js":"9pYyF","../common/viewLayout/viewLinesViewportData.js":"emhOT","../common/viewModel/viewContext.js":"gdMDu","../../platform/instantiation/common/instantiation.js":"fjwWx","../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Gvzx":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inputLatency", ()=>inputLatency);
var inputLatency;
(function(inputLatency) {
    const totalKeydownTime = {
        total: 0,
        min: Number.MAX_VALUE,
        max: 0
    };
    const totalInputTime = {
        ...totalKeydownTime
    };
    const totalRenderTime = {
        ...totalKeydownTime
    };
    const totalInputLatencyTime = {
        ...totalKeydownTime
    };
    let measurementsCount = 0;
    const state = {
        keydown: 0 /* EventPhase.Before */ ,
        input: 0 /* EventPhase.Before */ ,
        render: 0 /* EventPhase.Before */ 
    };
    /**
     * Record the start of the keydown event.
     */ function onKeyDown() {
        /** Direct Check C. See explanation in {@link recordIfFinished} */ recordIfFinished();
        performance.mark("inputlatency/start");
        performance.mark("keydown/start");
        state.keydown = 1 /* EventPhase.InProgress */ ;
        queueMicrotask(markKeyDownEnd);
    }
    inputLatency.onKeyDown = onKeyDown;
    /**
     * Mark the end of the keydown event.
     */ function markKeyDownEnd() {
        if (state.keydown === 1 /* EventPhase.InProgress */ ) {
            performance.mark("keydown/end");
            state.keydown = 2 /* EventPhase.Finished */ ;
        }
    }
    /**
     * Record the start of the beforeinput event.
     */ function onBeforeInput() {
        performance.mark("input/start");
        state.input = 1 /* EventPhase.InProgress */ ;
        /** Schedule Task A. See explanation in {@link recordIfFinished} */ scheduleRecordIfFinishedTask();
    }
    inputLatency.onBeforeInput = onBeforeInput;
    /**
     * Record the start of the input event.
     */ function onInput() {
        if (state.input === 0 /* EventPhase.Before */ ) // it looks like we didn't receive a `beforeinput`
        onBeforeInput();
        queueMicrotask(markInputEnd);
    }
    inputLatency.onInput = onInput;
    function markInputEnd() {
        if (state.input === 1 /* EventPhase.InProgress */ ) {
            performance.mark("input/end");
            state.input = 2 /* EventPhase.Finished */ ;
        }
    }
    /**
     * Record the start of the keyup event.
     */ function onKeyUp() {
        /** Direct Check D. See explanation in {@link recordIfFinished} */ recordIfFinished();
    }
    inputLatency.onKeyUp = onKeyUp;
    /**
     * Record the start of the selectionchange event.
     */ function onSelectionChange() {
        /** Direct Check E. See explanation in {@link recordIfFinished} */ recordIfFinished();
    }
    inputLatency.onSelectionChange = onSelectionChange;
    /**
     * Record the start of the animation frame performing the rendering.
     */ function onRenderStart() {
        // Render may be triggered during input, but we only measure the following animation frame
        if (state.keydown === 2 /* EventPhase.Finished */  && state.input === 2 /* EventPhase.Finished */  && state.render === 0 /* EventPhase.Before */ ) {
            // Only measure the first render after keyboard input
            performance.mark("render/start");
            state.render = 1 /* EventPhase.InProgress */ ;
            queueMicrotask(markRenderEnd);
            /** Schedule Task B. See explanation in {@link recordIfFinished} */ scheduleRecordIfFinishedTask();
        }
    }
    inputLatency.onRenderStart = onRenderStart;
    /**
     * Mark the end of the animation frame performing the rendering.
     */ function markRenderEnd() {
        if (state.render === 1 /* EventPhase.InProgress */ ) {
            performance.mark("render/end");
            state.render = 2 /* EventPhase.Finished */ ;
        }
    }
    function scheduleRecordIfFinishedTask() {
        // Here we can safely assume that the `setTimeout` will not be
        // artificially delayed by 4ms because we schedule it from
        // event handlers
        setTimeout(recordIfFinished);
    }
    /**
     * Record the input latency sample if input handling and rendering are finished.
     *
     * The challenge here is that we want to record the latency in such a way that it includes
     * also the layout and painting work the browser does during the animation frame task.
     *
     * Simply scheduling a new task (via `setTimeout`) from the animation frame task would
     * schedule the new task at the end of the task queue (after other code that uses `setTimeout`),
     * so we need to use multiple strategies to make sure our task runs before others:
     *
     * We schedule tasks (A and B):
     *    - we schedule a task A (via a `setTimeout` call) when the input starts in `markInputStart`.
     *      If the animation frame task is scheduled quickly by the browser, then task A has a very good
     *      chance of being the very first task after the animation frame and thus will record the input latency.
     *    - however, if the animation frame task is scheduled a bit later, then task A might execute
     *      before the animation frame task. We therefore schedule another task B from `markRenderStart`.
     *
     * We do direct checks in browser event handlers (C, D, E):
     *    - if the browser has multiple keydown events queued up, they will be scheduled before the `setTimeout` tasks,
     *      so we do a direct check in the keydown event handler (C).
     *    - depending on timing, sometimes the animation frame is scheduled even before the `keyup` event, so we
     *      do a direct check there too (E).
     *    - the browser oftentimes emits a `selectionchange` event after an `input`, so we do a direct check there (D).
     */ function recordIfFinished() {
        if (state.keydown === 2 /* EventPhase.Finished */  && state.input === 2 /* EventPhase.Finished */  && state.render === 2 /* EventPhase.Finished */ ) {
            performance.mark("inputlatency/end");
            performance.measure("keydown", "keydown/start", "keydown/end");
            performance.measure("input", "input/start", "input/end");
            performance.measure("render", "render/start", "render/end");
            performance.measure("inputlatency", "inputlatency/start", "inputlatency/end");
            addMeasure("keydown", totalKeydownTime);
            addMeasure("input", totalInputTime);
            addMeasure("render", totalRenderTime);
            addMeasure("inputlatency", totalInputLatencyTime);
            // console.info(
            // 	`input latency=${performance.getEntriesByName('inputlatency')[0].duration.toFixed(1)} [` +
            // 	`keydown=${performance.getEntriesByName('keydown')[0].duration.toFixed(1)}, ` +
            // 	`input=${performance.getEntriesByName('input')[0].duration.toFixed(1)}, ` +
            // 	`render=${performance.getEntriesByName('render')[0].duration.toFixed(1)}` +
            // 	`]`
            // );
            measurementsCount++;
            reset();
        }
    }
    function addMeasure(entryName, cumulativeMeasurement) {
        const duration = performance.getEntriesByName(entryName)[0].duration;
        cumulativeMeasurement.total += duration;
        cumulativeMeasurement.min = Math.min(cumulativeMeasurement.min, duration);
        cumulativeMeasurement.max = Math.max(cumulativeMeasurement.max, duration);
    }
    /**
     * Clear the current sample.
     */ function reset() {
        performance.clearMarks("keydown/start");
        performance.clearMarks("keydown/end");
        performance.clearMarks("input/start");
        performance.clearMarks("input/end");
        performance.clearMarks("render/start");
        performance.clearMarks("render/end");
        performance.clearMarks("inputlatency/start");
        performance.clearMarks("inputlatency/end");
        performance.clearMeasures("keydown");
        performance.clearMeasures("input");
        performance.clearMeasures("render");
        performance.clearMeasures("inputlatency");
        state.keydown = 0 /* EventPhase.Before */ ;
        state.input = 0 /* EventPhase.Before */ ;
        state.render = 0 /* EventPhase.Before */ ;
    }
    /**
     * Gets all input latency samples and clears the internal buffers to start recording a new set
     * of samples.
     */ function getAndClearMeasurements() {
        if (measurementsCount === 0) return undefined;
        // Assemble the result
        const result = {
            keydown: cumulativeToFinalMeasurement(totalKeydownTime),
            input: cumulativeToFinalMeasurement(totalInputTime),
            render: cumulativeToFinalMeasurement(totalRenderTime),
            total: cumulativeToFinalMeasurement(totalInputLatencyTime),
            sampleCount: measurementsCount
        };
        // Clear the cumulative measurements
        clearCumulativeMeasurement(totalKeydownTime);
        clearCumulativeMeasurement(totalInputTime);
        clearCumulativeMeasurement(totalRenderTime);
        clearCumulativeMeasurement(totalInputLatencyTime);
        measurementsCount = 0;
        return result;
    }
    inputLatency.getAndClearMeasurements = getAndClearMeasurements;
    function cumulativeToFinalMeasurement(cumulative) {
        return {
            average: cumulative.total / measurementsCount,
            max: cumulative.max,
            min: cumulative.min
        };
    }
    function clearCumulativeMeasurement(cumulative) {
        cumulative.total = 0;
        cumulative.min = Number.MAX_VALUE;
        cumulative.max = 0;
    }
})(inputLatency || (inputLatency = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eaOsC":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PointerHandlerLastRenderData", ()=>PointerHandlerLastRenderData);
parcelHelpers.export(exports, "MouseTarget", ()=>MouseTarget);
parcelHelpers.export(exports, "HitTestContext", ()=>HitTestContext);
parcelHelpers.export(exports, "MouseTargetFactory", ()=>MouseTargetFactory);
var _editorDomJs = require("../editorDom.js");
var _viewPartJs = require("../view/viewPart.js");
var _viewLineJs = require("../viewParts/lines/viewLine.js");
var _positionJs = require("../../common/core/position.js");
var _rangeJs = require("../../common/core/range.js");
var _cursorColumnsJs = require("../../common/core/cursorColumns.js");
var _domJs = require("../../../base/browser/dom.js");
var _cursorAtomicMoveOperationsJs = require("../../common/cursor/cursorAtomicMoveOperations.js");
var _lazyJs = require("../../../base/common/lazy.js");
class UnknownHitTestResult {
    constructor(hitTarget = null){
        this.hitTarget = hitTarget;
        this.type = 0 /* HitTestResultType.Unknown */ ;
    }
}
class ContentHitTestResult {
    get hitTarget() {
        return this.spanNode;
    }
    constructor(position, spanNode, injectedText){
        this.position = position;
        this.spanNode = spanNode;
        this.injectedText = injectedText;
        this.type = 1 /* HitTestResultType.Content */ ;
    }
}
var HitTestResult;
(function(HitTestResult) {
    function createFromDOMInfo(ctx, spanNode, offset) {
        const position = ctx.getPositionFromDOMInfo(spanNode, offset);
        if (position) return new ContentHitTestResult(position, spanNode, null);
        return new UnknownHitTestResult(spanNode);
    }
    HitTestResult.createFromDOMInfo = createFromDOMInfo;
})(HitTestResult || (HitTestResult = {}));
class PointerHandlerLastRenderData {
    constructor(lastViewCursorsRenderData, lastTextareaPosition){
        this.lastViewCursorsRenderData = lastViewCursorsRenderData;
        this.lastTextareaPosition = lastTextareaPosition;
    }
}
class MouseTarget {
    static _deduceRage(position, range = null) {
        if (!range && position) return new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column);
        return range ?? null;
    }
    static createUnknown(element, mouseColumn, position) {
        return {
            type: 0 /* MouseTargetType.UNKNOWN */ ,
            element,
            mouseColumn,
            position,
            range: this._deduceRage(position)
        };
    }
    static createTextarea(element, mouseColumn) {
        return {
            type: 1 /* MouseTargetType.TEXTAREA */ ,
            element,
            mouseColumn,
            position: null,
            range: null
        };
    }
    static createMargin(type, element, mouseColumn, position, range, detail) {
        return {
            type,
            element,
            mouseColumn,
            position,
            range,
            detail
        };
    }
    static createViewZone(type, element, mouseColumn, position, detail) {
        return {
            type,
            element,
            mouseColumn,
            position,
            range: this._deduceRage(position),
            detail
        };
    }
    static createContentText(element, mouseColumn, position, range, detail) {
        return {
            type: 6 /* MouseTargetType.CONTENT_TEXT */ ,
            element,
            mouseColumn,
            position,
            range: this._deduceRage(position, range),
            detail
        };
    }
    static createContentEmpty(element, mouseColumn, position, detail) {
        return {
            type: 7 /* MouseTargetType.CONTENT_EMPTY */ ,
            element,
            mouseColumn,
            position,
            range: this._deduceRage(position),
            detail
        };
    }
    static createContentWidget(element, mouseColumn, detail) {
        return {
            type: 9 /* MouseTargetType.CONTENT_WIDGET */ ,
            element,
            mouseColumn,
            position: null,
            range: null,
            detail
        };
    }
    static createScrollbar(element, mouseColumn, position) {
        return {
            type: 11 /* MouseTargetType.SCROLLBAR */ ,
            element,
            mouseColumn,
            position,
            range: this._deduceRage(position)
        };
    }
    static createOverlayWidget(element, mouseColumn, detail) {
        return {
            type: 12 /* MouseTargetType.OVERLAY_WIDGET */ ,
            element,
            mouseColumn,
            position: null,
            range: null,
            detail
        };
    }
    static createOutsideEditor(mouseColumn, position, outsidePosition, outsideDistance) {
        return {
            type: 13 /* MouseTargetType.OUTSIDE_EDITOR */ ,
            element: null,
            mouseColumn,
            position,
            range: this._deduceRage(position),
            outsidePosition,
            outsideDistance
        };
    }
    static _typeToString(type) {
        if (type === 1 /* MouseTargetType.TEXTAREA */ ) return "TEXTAREA";
        if (type === 2 /* MouseTargetType.GUTTER_GLYPH_MARGIN */ ) return "GUTTER_GLYPH_MARGIN";
        if (type === 3 /* MouseTargetType.GUTTER_LINE_NUMBERS */ ) return "GUTTER_LINE_NUMBERS";
        if (type === 4 /* MouseTargetType.GUTTER_LINE_DECORATIONS */ ) return "GUTTER_LINE_DECORATIONS";
        if (type === 5 /* MouseTargetType.GUTTER_VIEW_ZONE */ ) return "GUTTER_VIEW_ZONE";
        if (type === 6 /* MouseTargetType.CONTENT_TEXT */ ) return "CONTENT_TEXT";
        if (type === 7 /* MouseTargetType.CONTENT_EMPTY */ ) return "CONTENT_EMPTY";
        if (type === 8 /* MouseTargetType.CONTENT_VIEW_ZONE */ ) return "CONTENT_VIEW_ZONE";
        if (type === 9 /* MouseTargetType.CONTENT_WIDGET */ ) return "CONTENT_WIDGET";
        if (type === 10 /* MouseTargetType.OVERVIEW_RULER */ ) return "OVERVIEW_RULER";
        if (type === 11 /* MouseTargetType.SCROLLBAR */ ) return "SCROLLBAR";
        if (type === 12 /* MouseTargetType.OVERLAY_WIDGET */ ) return "OVERLAY_WIDGET";
        return "UNKNOWN";
    }
    static toString(target) {
        return this._typeToString(target.type) + ": " + target.position + " - " + target.range + " - " + JSON.stringify(target.detail);
    }
}
class ElementPath {
    static isTextArea(path) {
        return path.length === 2 && path[0] === 3 /* PartFingerprint.OverflowGuard */  && path[1] === 7 /* PartFingerprint.TextArea */ ;
    }
    static isChildOfViewLines(path) {
        return path.length >= 4 && path[0] === 3 /* PartFingerprint.OverflowGuard */  && path[3] === 8 /* PartFingerprint.ViewLines */ ;
    }
    static isStrictChildOfViewLines(path) {
        return path.length > 4 && path[0] === 3 /* PartFingerprint.OverflowGuard */  && path[3] === 8 /* PartFingerprint.ViewLines */ ;
    }
    static isChildOfScrollableElement(path) {
        return path.length >= 2 && path[0] === 3 /* PartFingerprint.OverflowGuard */  && path[1] === 6 /* PartFingerprint.ScrollableElement */ ;
    }
    static isChildOfMinimap(path) {
        return path.length >= 2 && path[0] === 3 /* PartFingerprint.OverflowGuard */  && path[1] === 9 /* PartFingerprint.Minimap */ ;
    }
    static isChildOfContentWidgets(path) {
        return path.length >= 4 && path[0] === 3 /* PartFingerprint.OverflowGuard */  && path[3] === 1 /* PartFingerprint.ContentWidgets */ ;
    }
    static isChildOfOverflowGuard(path) {
        return path.length >= 1 && path[0] === 3 /* PartFingerprint.OverflowGuard */ ;
    }
    static isChildOfOverflowingContentWidgets(path) {
        return path.length >= 1 && path[0] === 2 /* PartFingerprint.OverflowingContentWidgets */ ;
    }
    static isChildOfOverlayWidgets(path) {
        return path.length >= 2 && path[0] === 3 /* PartFingerprint.OverflowGuard */  && path[1] === 4 /* PartFingerprint.OverlayWidgets */ ;
    }
    static isChildOfOverflowingOverlayWidgets(path) {
        return path.length >= 1 && path[0] === 5 /* PartFingerprint.OverflowingOverlayWidgets */ ;
    }
}
class HitTestContext {
    constructor(context, viewHelper, lastRenderData){
        this.viewModel = context.viewModel;
        const options = context.configuration.options;
        this.layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this.viewDomNode = viewHelper.viewDomNode;
        this.lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this.stickyTabStops = options.get(117 /* EditorOption.stickyTabStops */ );
        this.typicalHalfwidthCharacterWidth = options.get(50 /* EditorOption.fontInfo */ ).typicalHalfwidthCharacterWidth;
        this.lastRenderData = lastRenderData;
        this._context = context;
        this._viewHelper = viewHelper;
    }
    getZoneAtCoord(mouseVerticalOffset) {
        return HitTestContext.getZoneAtCoord(this._context, mouseVerticalOffset);
    }
    static getZoneAtCoord(context, mouseVerticalOffset) {
        // The target is either a view zone or the empty space after the last view-line
        const viewZoneWhitespace = context.viewLayout.getWhitespaceAtVerticalOffset(mouseVerticalOffset);
        if (viewZoneWhitespace) {
            const viewZoneMiddle = viewZoneWhitespace.verticalOffset + viewZoneWhitespace.height / 2;
            const lineCount = context.viewModel.getLineCount();
            let positionBefore = null;
            let position;
            let positionAfter = null;
            if (viewZoneWhitespace.afterLineNumber !== lineCount) // There are more lines after this view zone
            positionAfter = new (0, _positionJs.Position)(viewZoneWhitespace.afterLineNumber + 1, 1);
            if (viewZoneWhitespace.afterLineNumber > 0) // There are more lines above this view zone
            positionBefore = new (0, _positionJs.Position)(viewZoneWhitespace.afterLineNumber, context.viewModel.getLineMaxColumn(viewZoneWhitespace.afterLineNumber));
            if (positionAfter === null) position = positionBefore;
            else if (positionBefore === null) position = positionAfter;
            else if (mouseVerticalOffset < viewZoneMiddle) position = positionBefore;
            else position = positionAfter;
            return {
                viewZoneId: viewZoneWhitespace.id,
                afterLineNumber: viewZoneWhitespace.afterLineNumber,
                positionBefore: positionBefore,
                positionAfter: positionAfter,
                position: position
            };
        }
        return null;
    }
    getFullLineRangeAtCoord(mouseVerticalOffset) {
        if (this._context.viewLayout.isAfterLines(mouseVerticalOffset)) {
            // Below the last line
            const lineNumber = this._context.viewModel.getLineCount();
            const maxLineColumn = this._context.viewModel.getLineMaxColumn(lineNumber);
            return {
                range: new (0, _rangeJs.Range)(lineNumber, maxLineColumn, lineNumber, maxLineColumn),
                isAfterLines: true
            };
        }
        const lineNumber = this._context.viewLayout.getLineNumberAtVerticalOffset(mouseVerticalOffset);
        const maxLineColumn = this._context.viewModel.getLineMaxColumn(lineNumber);
        return {
            range: new (0, _rangeJs.Range)(lineNumber, 1, lineNumber, maxLineColumn),
            isAfterLines: false
        };
    }
    getLineNumberAtVerticalOffset(mouseVerticalOffset) {
        return this._context.viewLayout.getLineNumberAtVerticalOffset(mouseVerticalOffset);
    }
    isAfterLines(mouseVerticalOffset) {
        return this._context.viewLayout.isAfterLines(mouseVerticalOffset);
    }
    isInTopPadding(mouseVerticalOffset) {
        return this._context.viewLayout.isInTopPadding(mouseVerticalOffset);
    }
    isInBottomPadding(mouseVerticalOffset) {
        return this._context.viewLayout.isInBottomPadding(mouseVerticalOffset);
    }
    getVerticalOffsetForLineNumber(lineNumber) {
        return this._context.viewLayout.getVerticalOffsetForLineNumber(lineNumber);
    }
    findAttribute(element, attr) {
        return HitTestContext._findAttribute(element, attr, this._viewHelper.viewDomNode);
    }
    static _findAttribute(element, attr, stopAt) {
        while(element && element !== element.ownerDocument.body){
            if (element.hasAttribute && element.hasAttribute(attr)) return element.getAttribute(attr);
            if (element === stopAt) return null;
            element = element.parentNode;
        }
        return null;
    }
    getLineWidth(lineNumber) {
        return this._viewHelper.getLineWidth(lineNumber);
    }
    visibleRangeForPosition(lineNumber, column) {
        return this._viewHelper.visibleRangeForPosition(lineNumber, column);
    }
    getPositionFromDOMInfo(spanNode, offset) {
        return this._viewHelper.getPositionFromDOMInfo(spanNode, offset);
    }
    getCurrentScrollTop() {
        return this._context.viewLayout.getCurrentScrollTop();
    }
    getCurrentScrollLeft() {
        return this._context.viewLayout.getCurrentScrollLeft();
    }
}
class BareHitTestRequest {
    constructor(ctx, editorPos, pos, relativePos){
        this.editorPos = editorPos;
        this.pos = pos;
        this.relativePos = relativePos;
        this.mouseVerticalOffset = Math.max(0, ctx.getCurrentScrollTop() + this.relativePos.y);
        this.mouseContentHorizontalOffset = ctx.getCurrentScrollLeft() + this.relativePos.x - ctx.layoutInfo.contentLeft;
        this.isInMarginArea = this.relativePos.x < ctx.layoutInfo.contentLeft && this.relativePos.x >= ctx.layoutInfo.glyphMarginLeft;
        this.isInContentArea = !this.isInMarginArea;
        this.mouseColumn = Math.max(0, MouseTargetFactory._getMouseColumn(this.mouseContentHorizontalOffset, ctx.typicalHalfwidthCharacterWidth));
    }
}
class HitTestRequest extends BareHitTestRequest {
    get target() {
        if (this._useHitTestTarget) return this.hitTestResult.value.hitTarget;
        return this._eventTarget;
    }
    get targetPath() {
        if (this._targetPathCacheElement !== this.target) {
            this._targetPathCacheElement = this.target;
            this._targetPathCacheValue = (0, _viewPartJs.PartFingerprints).collect(this.target, this._ctx.viewDomNode);
        }
        return this._targetPathCacheValue;
    }
    constructor(ctx, editorPos, pos, relativePos, eventTarget){
        super(ctx, editorPos, pos, relativePos);
        this.hitTestResult = new (0, _lazyJs.Lazy)(()=>MouseTargetFactory.doHitTest(this._ctx, this));
        this._targetPathCacheElement = null;
        this._targetPathCacheValue = new Uint8Array(0);
        this._ctx = ctx;
        this._eventTarget = eventTarget;
        // If no event target is passed in, we will use the hit test target
        const hasEventTarget = Boolean(this._eventTarget);
        this._useHitTestTarget = !hasEventTarget;
    }
    toString() {
        return `pos(${this.pos.x},${this.pos.y}), editorPos(${this.editorPos.x},${this.editorPos.y}), relativePos(${this.relativePos.x},${this.relativePos.y}), mouseVerticalOffset: ${this.mouseVerticalOffset}, mouseContentHorizontalOffset: ${this.mouseContentHorizontalOffset}\n\ttarget: ${this.target ? this.target.outerHTML : null}`;
    }
    get wouldBenefitFromHitTestTargetSwitch() {
        return !this._useHitTestTarget && this.hitTestResult.value.hitTarget !== null && this.target !== this.hitTestResult.value.hitTarget;
    }
    switchToHitTestTarget() {
        this._useHitTestTarget = true;
    }
    _getMouseColumn(position = null) {
        if (position && position.column < this._ctx.viewModel.getLineMaxColumn(position.lineNumber)) // Most likely, the line contains foreign decorations...
        return (0, _cursorColumnsJs.CursorColumns).visibleColumnFromColumn(this._ctx.viewModel.getLineContent(position.lineNumber), position.column, this._ctx.viewModel.model.getOptions().tabSize) + 1;
        return this.mouseColumn;
    }
    fulfillUnknown(position = null) {
        return MouseTarget.createUnknown(this.target, this._getMouseColumn(position), position);
    }
    fulfillTextarea() {
        return MouseTarget.createTextarea(this.target, this._getMouseColumn());
    }
    fulfillMargin(type, position, range, detail) {
        return MouseTarget.createMargin(type, this.target, this._getMouseColumn(position), position, range, detail);
    }
    fulfillViewZone(type, position, detail) {
        return MouseTarget.createViewZone(type, this.target, this._getMouseColumn(position), position, detail);
    }
    fulfillContentText(position, range, detail) {
        return MouseTarget.createContentText(this.target, this._getMouseColumn(position), position, range, detail);
    }
    fulfillContentEmpty(position, detail) {
        return MouseTarget.createContentEmpty(this.target, this._getMouseColumn(position), position, detail);
    }
    fulfillContentWidget(detail) {
        return MouseTarget.createContentWidget(this.target, this._getMouseColumn(), detail);
    }
    fulfillScrollbar(position) {
        return MouseTarget.createScrollbar(this.target, this._getMouseColumn(position), position);
    }
    fulfillOverlayWidget(detail) {
        return MouseTarget.createOverlayWidget(this.target, this._getMouseColumn(), detail);
    }
}
const EMPTY_CONTENT_AFTER_LINES = {
    isAfterLines: true
};
function createEmptyContentDataInLines(horizontalDistanceToText) {
    return {
        isAfterLines: false,
        horizontalDistanceToText: horizontalDistanceToText
    };
}
class MouseTargetFactory {
    constructor(context, viewHelper){
        this._context = context;
        this._viewHelper = viewHelper;
    }
    mouseTargetIsWidget(e) {
        const t = e.target;
        const path = (0, _viewPartJs.PartFingerprints).collect(t, this._viewHelper.viewDomNode);
        // Is it a content widget?
        if (ElementPath.isChildOfContentWidgets(path) || ElementPath.isChildOfOverflowingContentWidgets(path)) return true;
        // Is it an overlay widget?
        if (ElementPath.isChildOfOverlayWidgets(path) || ElementPath.isChildOfOverflowingOverlayWidgets(path)) return true;
        return false;
    }
    createMouseTarget(lastRenderData, editorPos, pos, relativePos, target) {
        const ctx = new HitTestContext(this._context, this._viewHelper, lastRenderData);
        const request = new HitTestRequest(ctx, editorPos, pos, relativePos, target);
        try {
            const r = MouseTargetFactory._createMouseTarget(ctx, request);
            if (r.type === 6 /* MouseTargetType.CONTENT_TEXT */ ) // Snap to the nearest soft tab boundary if atomic soft tabs are enabled.
            {
                if (ctx.stickyTabStops && r.position !== null) {
                    const position = MouseTargetFactory._snapToSoftTabBoundary(r.position, ctx.viewModel);
                    const range = (0, _rangeJs.Range).fromPositions(position, position).plusRange(r.range);
                    return request.fulfillContentText(position, range, r.detail);
                }
            }
            // console.log(MouseTarget.toString(r));
            return r;
        } catch (err) {
            // console.log(err);
            return request.fulfillUnknown();
        }
    }
    static _createMouseTarget(ctx, request) {
        // console.log(`${domHitTestExecuted ? '=>' : ''}CAME IN REQUEST: ${request}`);
        if (request.target === null) // No target
        return request.fulfillUnknown();
        // we know for a fact that request.target is not null
        const resolvedRequest = request;
        let result = null;
        if (!ElementPath.isChildOfOverflowGuard(request.targetPath) && !ElementPath.isChildOfOverflowingContentWidgets(request.targetPath) && !ElementPath.isChildOfOverflowingOverlayWidgets(request.targetPath)) // We only render dom nodes inside the overflow guard or in the overflowing content widgets
        result = result || request.fulfillUnknown();
        result = result || MouseTargetFactory._hitTestContentWidget(ctx, resolvedRequest);
        result = result || MouseTargetFactory._hitTestOverlayWidget(ctx, resolvedRequest);
        result = result || MouseTargetFactory._hitTestMinimap(ctx, resolvedRequest);
        result = result || MouseTargetFactory._hitTestScrollbarSlider(ctx, resolvedRequest);
        result = result || MouseTargetFactory._hitTestViewZone(ctx, resolvedRequest);
        result = result || MouseTargetFactory._hitTestMargin(ctx, resolvedRequest);
        result = result || MouseTargetFactory._hitTestViewCursor(ctx, resolvedRequest);
        result = result || MouseTargetFactory._hitTestTextArea(ctx, resolvedRequest);
        result = result || MouseTargetFactory._hitTestViewLines(ctx, resolvedRequest);
        result = result || MouseTargetFactory._hitTestScrollbar(ctx, resolvedRequest);
        return result || request.fulfillUnknown();
    }
    static _hitTestContentWidget(ctx, request) {
        // Is it a content widget?
        if (ElementPath.isChildOfContentWidgets(request.targetPath) || ElementPath.isChildOfOverflowingContentWidgets(request.targetPath)) {
            const widgetId = ctx.findAttribute(request.target, "widgetId");
            if (widgetId) return request.fulfillContentWidget(widgetId);
            else return request.fulfillUnknown();
        }
        return null;
    }
    static _hitTestOverlayWidget(ctx, request) {
        // Is it an overlay widget?
        if (ElementPath.isChildOfOverlayWidgets(request.targetPath) || ElementPath.isChildOfOverflowingOverlayWidgets(request.targetPath)) {
            const widgetId = ctx.findAttribute(request.target, "widgetId");
            if (widgetId) return request.fulfillOverlayWidget(widgetId);
            else return request.fulfillUnknown();
        }
        return null;
    }
    static _hitTestViewCursor(ctx, request) {
        if (request.target) {
            // Check if we've hit a painted cursor
            const lastViewCursorsRenderData = ctx.lastRenderData.lastViewCursorsRenderData;
            for (const d of lastViewCursorsRenderData){
                if (request.target === d.domNode) return request.fulfillContentText(d.position, null, {
                    mightBeForeignElement: false,
                    injectedText: null
                });
            }
        }
        if (request.isInContentArea) {
            // Edge has a bug when hit-testing the exact position of a cursor,
            // instead of returning the correct dom node, it returns the
            // first or last rendered view line dom node, therefore help it out
            // and first check if we are on top of a cursor
            const lastViewCursorsRenderData = ctx.lastRenderData.lastViewCursorsRenderData;
            const mouseContentHorizontalOffset = request.mouseContentHorizontalOffset;
            const mouseVerticalOffset = request.mouseVerticalOffset;
            for (const d of lastViewCursorsRenderData){
                if (mouseContentHorizontalOffset < d.contentLeft) continue;
                if (mouseContentHorizontalOffset > d.contentLeft + d.width) continue;
                const cursorVerticalOffset = ctx.getVerticalOffsetForLineNumber(d.position.lineNumber);
                if (cursorVerticalOffset <= mouseVerticalOffset && mouseVerticalOffset <= cursorVerticalOffset + d.height) return request.fulfillContentText(d.position, null, {
                    mightBeForeignElement: false,
                    injectedText: null
                });
            }
        }
        return null;
    }
    static _hitTestViewZone(ctx, request) {
        const viewZoneData = ctx.getZoneAtCoord(request.mouseVerticalOffset);
        if (viewZoneData) {
            const mouseTargetType = request.isInContentArea ? 8 /* MouseTargetType.CONTENT_VIEW_ZONE */  : 5 /* MouseTargetType.GUTTER_VIEW_ZONE */ ;
            return request.fulfillViewZone(mouseTargetType, viewZoneData.position, viewZoneData);
        }
        return null;
    }
    static _hitTestTextArea(ctx, request) {
        // Is it the textarea?
        if (ElementPath.isTextArea(request.targetPath)) {
            if (ctx.lastRenderData.lastTextareaPosition) return request.fulfillContentText(ctx.lastRenderData.lastTextareaPosition, null, {
                mightBeForeignElement: false,
                injectedText: null
            });
            return request.fulfillTextarea();
        }
        return null;
    }
    static _hitTestMargin(ctx, request) {
        if (request.isInMarginArea) {
            const res = ctx.getFullLineRangeAtCoord(request.mouseVerticalOffset);
            const pos = res.range.getStartPosition();
            let offset = Math.abs(request.relativePos.x);
            const detail = {
                isAfterLines: res.isAfterLines,
                glyphMarginLeft: ctx.layoutInfo.glyphMarginLeft,
                glyphMarginWidth: ctx.layoutInfo.glyphMarginWidth,
                lineNumbersWidth: ctx.layoutInfo.lineNumbersWidth,
                offsetX: offset
            };
            offset -= ctx.layoutInfo.glyphMarginLeft;
            if (offset <= ctx.layoutInfo.glyphMarginWidth) {
                // On the glyph margin
                const modelCoordinate = ctx.viewModel.coordinatesConverter.convertViewPositionToModelPosition(res.range.getStartPosition());
                const lanes = ctx.viewModel.glyphLanes.getLanesAtLine(modelCoordinate.lineNumber);
                detail.glyphMarginLane = lanes[Math.floor(offset / ctx.lineHeight)];
                return request.fulfillMargin(2 /* MouseTargetType.GUTTER_GLYPH_MARGIN */ , pos, res.range, detail);
            }
            offset -= ctx.layoutInfo.glyphMarginWidth;
            if (offset <= ctx.layoutInfo.lineNumbersWidth) // On the line numbers
            return request.fulfillMargin(3 /* MouseTargetType.GUTTER_LINE_NUMBERS */ , pos, res.range, detail);
            offset -= ctx.layoutInfo.lineNumbersWidth;
            // On the line decorations
            return request.fulfillMargin(4 /* MouseTargetType.GUTTER_LINE_DECORATIONS */ , pos, res.range, detail);
        }
        return null;
    }
    static _hitTestViewLines(ctx, request) {
        if (!ElementPath.isChildOfViewLines(request.targetPath)) return null;
        if (ctx.isInTopPadding(request.mouseVerticalOffset)) return request.fulfillContentEmpty(new (0, _positionJs.Position)(1, 1), EMPTY_CONTENT_AFTER_LINES);
        // Check if it is below any lines and any view zones
        if (ctx.isAfterLines(request.mouseVerticalOffset) || ctx.isInBottomPadding(request.mouseVerticalOffset)) {
            // This most likely indicates it happened after the last view-line
            const lineCount = ctx.viewModel.getLineCount();
            const maxLineColumn = ctx.viewModel.getLineMaxColumn(lineCount);
            return request.fulfillContentEmpty(new (0, _positionJs.Position)(lineCount, maxLineColumn), EMPTY_CONTENT_AFTER_LINES);
        }
        // Check if we are hitting a view-line (can happen in the case of inline decorations on empty lines)
        // See https://github.com/microsoft/vscode/issues/46942
        if (ElementPath.isStrictChildOfViewLines(request.targetPath)) {
            const lineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
            if (ctx.viewModel.getLineLength(lineNumber) === 0) {
                const lineWidth = ctx.getLineWidth(lineNumber);
                const detail = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
                return request.fulfillContentEmpty(new (0, _positionJs.Position)(lineNumber, 1), detail);
            }
            const lineWidth = ctx.getLineWidth(lineNumber);
            if (request.mouseContentHorizontalOffset >= lineWidth) {
                // TODO: This is wrong for RTL
                const detail = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
                const pos = new (0, _positionJs.Position)(lineNumber, ctx.viewModel.getLineMaxColumn(lineNumber));
                return request.fulfillContentEmpty(pos, detail);
            }
        }
        // Do the hit test (if not already done)
        const hitTestResult = request.hitTestResult.value;
        if (hitTestResult.type === 1 /* HitTestResultType.Content */ ) return MouseTargetFactory.createMouseTargetFromHitTestPosition(ctx, request, hitTestResult.spanNode, hitTestResult.position, hitTestResult.injectedText);
        // We didn't hit content...
        if (request.wouldBenefitFromHitTestTargetSwitch) {
            // We actually hit something different... Give it one last change by trying again with this new target
            request.switchToHitTestTarget();
            return this._createMouseTarget(ctx, request);
        }
        // We have tried everything...
        return request.fulfillUnknown();
    }
    static _hitTestMinimap(ctx, request) {
        if (ElementPath.isChildOfMinimap(request.targetPath)) {
            const possibleLineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
            const maxColumn = ctx.viewModel.getLineMaxColumn(possibleLineNumber);
            return request.fulfillScrollbar(new (0, _positionJs.Position)(possibleLineNumber, maxColumn));
        }
        return null;
    }
    static _hitTestScrollbarSlider(ctx, request) {
        if (ElementPath.isChildOfScrollableElement(request.targetPath)) {
            if (request.target && request.target.nodeType === 1) {
                const className = request.target.className;
                if (className && /\b(slider|scrollbar)\b/.test(className)) {
                    const possibleLineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
                    const maxColumn = ctx.viewModel.getLineMaxColumn(possibleLineNumber);
                    return request.fulfillScrollbar(new (0, _positionJs.Position)(possibleLineNumber, maxColumn));
                }
            }
        }
        return null;
    }
    static _hitTestScrollbar(ctx, request) {
        // Is it the overview ruler?
        // Is it a child of the scrollable element?
        if (ElementPath.isChildOfScrollableElement(request.targetPath)) {
            const possibleLineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
            const maxColumn = ctx.viewModel.getLineMaxColumn(possibleLineNumber);
            return request.fulfillScrollbar(new (0, _positionJs.Position)(possibleLineNumber, maxColumn));
        }
        return null;
    }
    getMouseColumn(relativePos) {
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        const mouseContentHorizontalOffset = this._context.viewLayout.getCurrentScrollLeft() + relativePos.x - layoutInfo.contentLeft;
        return MouseTargetFactory._getMouseColumn(mouseContentHorizontalOffset, options.get(50 /* EditorOption.fontInfo */ ).typicalHalfwidthCharacterWidth);
    }
    static _getMouseColumn(mouseContentHorizontalOffset, typicalHalfwidthCharacterWidth) {
        if (mouseContentHorizontalOffset < 0) return 1;
        const chars = Math.round(mouseContentHorizontalOffset / typicalHalfwidthCharacterWidth);
        return chars + 1;
    }
    static createMouseTargetFromHitTestPosition(ctx, request, spanNode, pos, injectedText) {
        const lineNumber = pos.lineNumber;
        const column = pos.column;
        const lineWidth = ctx.getLineWidth(lineNumber);
        if (request.mouseContentHorizontalOffset > lineWidth) {
            const detail = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
            return request.fulfillContentEmpty(pos, detail);
        }
        const visibleRange = ctx.visibleRangeForPosition(lineNumber, column);
        if (!visibleRange) return request.fulfillUnknown(pos);
        const columnHorizontalOffset = visibleRange.left;
        if (Math.abs(request.mouseContentHorizontalOffset - columnHorizontalOffset) < 1) return request.fulfillContentText(pos, null, {
            mightBeForeignElement: !!injectedText,
            injectedText
        });
        const points = [];
        points.push({
            offset: visibleRange.left,
            column: column
        });
        if (column > 1) {
            const visibleRange = ctx.visibleRangeForPosition(lineNumber, column - 1);
            if (visibleRange) points.push({
                offset: visibleRange.left,
                column: column - 1
            });
        }
        const lineMaxColumn = ctx.viewModel.getLineMaxColumn(lineNumber);
        if (column < lineMaxColumn) {
            const visibleRange = ctx.visibleRangeForPosition(lineNumber, column + 1);
            if (visibleRange) points.push({
                offset: visibleRange.left,
                column: column + 1
            });
        }
        points.sort((a, b)=>a.offset - b.offset);
        const mouseCoordinates = request.pos.toClientCoordinates(_domJs.getWindow(ctx.viewDomNode));
        const spanNodeClientRect = spanNode.getBoundingClientRect();
        const mouseIsOverSpanNode = spanNodeClientRect.left <= mouseCoordinates.clientX && mouseCoordinates.clientX <= spanNodeClientRect.right;
        let rng = null;
        for(let i = 1; i < points.length; i++){
            const prev = points[i - 1];
            const curr = points[i];
            if (prev.offset <= request.mouseContentHorizontalOffset && request.mouseContentHorizontalOffset <= curr.offset) {
                rng = new (0, _rangeJs.Range)(lineNumber, prev.column, lineNumber, curr.column);
                // See https://github.com/microsoft/vscode/issues/152819
                // Due to the use of zwj, the browser's hit test result is skewed towards the left
                // Here we try to correct that if the mouse horizontal offset is closer to the right than the left
                const prevDelta = Math.abs(prev.offset - request.mouseContentHorizontalOffset);
                const nextDelta = Math.abs(curr.offset - request.mouseContentHorizontalOffset);
                pos = prevDelta < nextDelta ? new (0, _positionJs.Position)(lineNumber, prev.column) : new (0, _positionJs.Position)(lineNumber, curr.column);
                break;
            }
        }
        return request.fulfillContentText(pos, rng, {
            mightBeForeignElement: !mouseIsOverSpanNode || !!injectedText,
            injectedText
        });
    }
    /**
     * Most probably WebKit browsers and Edge
     */ static _doHitTestWithCaretRangeFromPoint(ctx, request) {
        // In Chrome, especially on Linux it is possible to click between lines,
        // so try to adjust the `hity` below so that it lands in the center of a line
        const lineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
        const lineStartVerticalOffset = ctx.getVerticalOffsetForLineNumber(lineNumber);
        const lineEndVerticalOffset = lineStartVerticalOffset + ctx.lineHeight;
        const isBelowLastLine = lineNumber === ctx.viewModel.getLineCount() && request.mouseVerticalOffset > lineEndVerticalOffset;
        if (!isBelowLastLine) {
            const lineCenteredVerticalOffset = Math.floor((lineStartVerticalOffset + lineEndVerticalOffset) / 2);
            let adjustedPageY = request.pos.y + (lineCenteredVerticalOffset - request.mouseVerticalOffset);
            if (adjustedPageY <= request.editorPos.y) adjustedPageY = request.editorPos.y + 1;
            if (adjustedPageY >= request.editorPos.y + request.editorPos.height) adjustedPageY = request.editorPos.y + request.editorPos.height - 1;
            const adjustedPage = new (0, _editorDomJs.PageCoordinates)(request.pos.x, adjustedPageY);
            const r = this._actualDoHitTestWithCaretRangeFromPoint(ctx, adjustedPage.toClientCoordinates(_domJs.getWindow(ctx.viewDomNode)));
            if (r.type === 1 /* HitTestResultType.Content */ ) return r;
        }
        // Also try to hit test without the adjustment (for the edge cases that we are near the top or bottom)
        return this._actualDoHitTestWithCaretRangeFromPoint(ctx, request.pos.toClientCoordinates(_domJs.getWindow(ctx.viewDomNode)));
    }
    static _actualDoHitTestWithCaretRangeFromPoint(ctx, coords) {
        const shadowRoot = _domJs.getShadowRoot(ctx.viewDomNode);
        let range;
        if (shadowRoot) {
            if (typeof shadowRoot.caretRangeFromPoint === "undefined") range = shadowCaretRangeFromPoint(shadowRoot, coords.clientX, coords.clientY);
            else range = shadowRoot.caretRangeFromPoint(coords.clientX, coords.clientY);
        } else range = ctx.viewDomNode.ownerDocument.caretRangeFromPoint(coords.clientX, coords.clientY);
        if (!range || !range.startContainer) return new UnknownHitTestResult();
        // Chrome always hits a TEXT_NODE, while Edge sometimes hits a token span
        const startContainer = range.startContainer;
        if (startContainer.nodeType === startContainer.TEXT_NODE) {
            // startContainer is expected to be the token text
            const parent1 = startContainer.parentNode; // expected to be the token span
            const parent2 = parent1 ? parent1.parentNode : null; // expected to be the view line container span
            const parent3 = parent2 ? parent2.parentNode : null; // expected to be the view line div
            const parent3ClassName = parent3 && parent3.nodeType === parent3.ELEMENT_NODE ? parent3.className : null;
            if (parent3ClassName === (0, _viewLineJs.ViewLine).CLASS_NAME) return HitTestResult.createFromDOMInfo(ctx, parent1, range.startOffset);
            else return new UnknownHitTestResult(startContainer.parentNode);
        } else if (startContainer.nodeType === startContainer.ELEMENT_NODE) {
            // startContainer is expected to be the token span
            const parent1 = startContainer.parentNode; // expected to be the view line container span
            const parent2 = parent1 ? parent1.parentNode : null; // expected to be the view line div
            const parent2ClassName = parent2 && parent2.nodeType === parent2.ELEMENT_NODE ? parent2.className : null;
            if (parent2ClassName === (0, _viewLineJs.ViewLine).CLASS_NAME) return HitTestResult.createFromDOMInfo(ctx, startContainer, startContainer.textContent.length);
            else return new UnknownHitTestResult(startContainer);
        }
        return new UnknownHitTestResult();
    }
    /**
     * Most probably Gecko
     */ static _doHitTestWithCaretPositionFromPoint(ctx, coords) {
        const hitResult = ctx.viewDomNode.ownerDocument.caretPositionFromPoint(coords.clientX, coords.clientY);
        if (hitResult.offsetNode.nodeType === hitResult.offsetNode.TEXT_NODE) {
            // offsetNode is expected to be the token text
            const parent1 = hitResult.offsetNode.parentNode; // expected to be the token span
            const parent2 = parent1 ? parent1.parentNode : null; // expected to be the view line container span
            const parent3 = parent2 ? parent2.parentNode : null; // expected to be the view line div
            const parent3ClassName = parent3 && parent3.nodeType === parent3.ELEMENT_NODE ? parent3.className : null;
            if (parent3ClassName === (0, _viewLineJs.ViewLine).CLASS_NAME) return HitTestResult.createFromDOMInfo(ctx, hitResult.offsetNode.parentNode, hitResult.offset);
            else return new UnknownHitTestResult(hitResult.offsetNode.parentNode);
        }
        // For inline decorations, Gecko sometimes returns the `<span>` of the line and the offset is the `<span>` with the inline decoration
        // Some other times, it returns the `<span>` with the inline decoration
        if (hitResult.offsetNode.nodeType === hitResult.offsetNode.ELEMENT_NODE) {
            const parent1 = hitResult.offsetNode.parentNode;
            const parent1ClassName = parent1 && parent1.nodeType === parent1.ELEMENT_NODE ? parent1.className : null;
            const parent2 = parent1 ? parent1.parentNode : null;
            const parent2ClassName = parent2 && parent2.nodeType === parent2.ELEMENT_NODE ? parent2.className : null;
            if (parent1ClassName === (0, _viewLineJs.ViewLine).CLASS_NAME) {
                // it returned the `<span>` of the line and the offset is the `<span>` with the inline decoration
                const tokenSpan = hitResult.offsetNode.childNodes[Math.min(hitResult.offset, hitResult.offsetNode.childNodes.length - 1)];
                if (tokenSpan) return HitTestResult.createFromDOMInfo(ctx, tokenSpan, 0);
            } else if (parent2ClassName === (0, _viewLineJs.ViewLine).CLASS_NAME) // it returned the `<span>` with the inline decoration
            return HitTestResult.createFromDOMInfo(ctx, hitResult.offsetNode, 0);
        }
        return new UnknownHitTestResult(hitResult.offsetNode);
    }
    static _snapToSoftTabBoundary(position, viewModel) {
        const lineContent = viewModel.getLineContent(position.lineNumber);
        const { tabSize } = viewModel.model.getOptions();
        const newPosition = (0, _cursorAtomicMoveOperationsJs.AtomicTabMoveOperations).atomicPosition(lineContent, position.column - 1, tabSize, 2 /* Direction.Nearest */ );
        if (newPosition !== -1) return new (0, _positionJs.Position)(position.lineNumber, newPosition + 1);
        return position;
    }
    static doHitTest(ctx, request) {
        let result = new UnknownHitTestResult();
        if (typeof ctx.viewDomNode.ownerDocument.caretRangeFromPoint === "function") result = this._doHitTestWithCaretRangeFromPoint(ctx, request);
        else if (ctx.viewDomNode.ownerDocument.caretPositionFromPoint) result = this._doHitTestWithCaretPositionFromPoint(ctx, request.pos.toClientCoordinates(_domJs.getWindow(ctx.viewDomNode)));
        if (result.type === 1 /* HitTestResultType.Content */ ) {
            const injectedText = ctx.viewModel.getInjectedTextAt(result.position);
            const normalizedPosition = ctx.viewModel.normalizePosition(result.position, 2 /* PositionAffinity.None */ );
            if (injectedText || !normalizedPosition.equals(result.position)) result = new ContentHitTestResult(normalizedPosition, result.spanNode, injectedText);
        }
        return result;
    }
}
function shadowCaretRangeFromPoint(shadowRoot, x, y) {
    const range = document.createRange();
    // Get the element under the point
    let el = shadowRoot.elementFromPoint(x, y);
    if (el !== null) {
        // Get the last child of the element until its firstChild is a text node
        // This assumes that the pointer is on the right of the line, out of the tokens
        // and that we want to get the offset of the last token of the line
        while(el && el.firstChild && el.firstChild.nodeType !== el.firstChild.TEXT_NODE && el.lastChild && el.lastChild.firstChild)el = el.lastChild;
        // Grab its rect
        const rect = el.getBoundingClientRect();
        // And its font (the computed shorthand font property might be empty, see #3217)
        const elWindow = _domJs.getWindow(el);
        const fontStyle = elWindow.getComputedStyle(el, null).getPropertyValue("font-style");
        const fontVariant = elWindow.getComputedStyle(el, null).getPropertyValue("font-variant");
        const fontWeight = elWindow.getComputedStyle(el, null).getPropertyValue("font-weight");
        const fontSize = elWindow.getComputedStyle(el, null).getPropertyValue("font-size");
        const lineHeight = elWindow.getComputedStyle(el, null).getPropertyValue("line-height");
        const fontFamily = elWindow.getComputedStyle(el, null).getPropertyValue("font-family");
        const font = `${fontStyle} ${fontVariant} ${fontWeight} ${fontSize}/${lineHeight} ${fontFamily}`;
        // And also its txt content
        const text = el.innerText;
        // Position the pixel cursor at the left of the element
        let pixelCursor = rect.left;
        let offset = 0;
        let step;
        // If the point is on the right of the box put the cursor after the last character
        if (x > rect.left + rect.width) offset = text.length;
        else {
            const charWidthReader = CharWidthReader.getInstance();
            // Goes through all the characters of the innerText, and checks if the x of the point
            // belongs to the character.
            for(let i = 0; i < text.length + 1; i++){
                // The step is half the width of the character
                step = charWidthReader.getCharWidth(text.charAt(i), font) / 2;
                // Move to the center of the character
                pixelCursor += step;
                // If the x of the point is smaller that the position of the cursor, the point is over that character
                if (x < pixelCursor) {
                    offset = i;
                    break;
                }
                // Move between the current character and the next
                pixelCursor += step;
            }
        }
        // Creates a range with the text node of the element and set the offset found
        range.setStart(el.firstChild, offset);
        range.setEnd(el.firstChild, offset);
    }
    return range;
}
class CharWidthReader {
    static{
        this._INSTANCE = null;
    }
    static getInstance() {
        if (!CharWidthReader._INSTANCE) CharWidthReader._INSTANCE = new CharWidthReader();
        return CharWidthReader._INSTANCE;
    }
    constructor(){
        this._cache = {};
        this._canvas = document.createElement("canvas");
    }
    getCharWidth(char, font) {
        const cacheKey = char + font;
        if (this._cache[cacheKey]) return this._cache[cacheKey];
        const context = this._canvas.getContext("2d");
        context.font = font;
        const metrics = context.measureText(char);
        const width = metrics.width;
        this._cache[cacheKey] = width;
        return width;
    }
}

},{"../editorDom.js":"8EVOq","../view/viewPart.js":"kTsLR","../viewParts/lines/viewLine.js":"9rxuY","../../common/core/position.js":"lvrPe","../../common/core/range.js":"jmUPh","../../common/core/cursorColumns.js":"idX7D","../../../base/browser/dom.js":"bnqsM","../../common/cursor/cursorAtomicMoveOperations.js":"asPUi","../../../base/common/lazy.js":"6e57N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8EVOq":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Coordinates relative to the whole document (e.g. mouse event's pageX and pageY)
 */ parcelHelpers.export(exports, "PageCoordinates", ()=>PageCoordinates);
/**
 * Coordinates within the application's client area (i.e. origin is document's scroll position).
 *
 * For example, clicking in the top-left corner of the client area will
 * always result in a mouse event with a client.x value of 0, regardless
 * of whether the page is scrolled horizontally.
 */ parcelHelpers.export(exports, "ClientCoordinates", ()=>ClientCoordinates);
/**
 * The position of the editor in the page.
 */ parcelHelpers.export(exports, "EditorPagePosition", ()=>EditorPagePosition);
/**
 * Coordinates relative to the the (top;left) of the editor that can be used safely with other internal editor metrics.
 * **NOTE**: This position is obtained by taking page coordinates and transforming them relative to the
 * editor's (top;left) position in a way in which scale transformations are taken into account.
 * **NOTE**: These coordinates could be negative if the mouse position is outside the editor.
 */ parcelHelpers.export(exports, "CoordinatesRelativeToEditor", ()=>CoordinatesRelativeToEditor);
parcelHelpers.export(exports, "createEditorPagePosition", ()=>createEditorPagePosition);
parcelHelpers.export(exports, "createCoordinatesRelativeToEditor", ()=>createCoordinatesRelativeToEditor);
parcelHelpers.export(exports, "EditorMouseEvent", ()=>EditorMouseEvent);
parcelHelpers.export(exports, "EditorMouseEventFactory", ()=>EditorMouseEventFactory);
parcelHelpers.export(exports, "EditorPointerEventFactory", ()=>EditorPointerEventFactory);
parcelHelpers.export(exports, "GlobalEditorPointerMoveMonitor", ()=>GlobalEditorPointerMoveMonitor);
/**
 * A helper to create dynamic css rules, bound to a class name.
 * Rules are reused.
 * Reference counting and delayed garbage collection ensure that no rules leak.
*/ parcelHelpers.export(exports, "DynamicCssRules", ()=>DynamicCssRules);
var _domJs = require("../../base/browser/dom.js");
var _globalPointerMoveMonitorJs = require("../../base/browser/globalPointerMoveMonitor.js");
var _mouseEventJs = require("../../base/browser/mouseEvent.js");
var _asyncJs = require("../../base/common/async.js");
var _lifecycleJs = require("../../base/common/lifecycle.js");
var _colorRegistryJs = require("../../platform/theme/common/colorRegistry.js");
class PageCoordinates {
    constructor(x, y){
        this.x = x;
        this.y = y;
        this._pageCoordinatesBrand = undefined;
    }
    toClientCoordinates(targetWindow) {
        return new ClientCoordinates(this.x - targetWindow.scrollX, this.y - targetWindow.scrollY);
    }
}
class ClientCoordinates {
    constructor(clientX, clientY){
        this.clientX = clientX;
        this.clientY = clientY;
        this._clientCoordinatesBrand = undefined;
    }
    toPageCoordinates(targetWindow) {
        return new PageCoordinates(this.clientX + targetWindow.scrollX, this.clientY + targetWindow.scrollY);
    }
}
class EditorPagePosition {
    constructor(x, y, width, height){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this._editorPagePositionBrand = undefined;
    }
}
class CoordinatesRelativeToEditor {
    constructor(x, y){
        this.x = x;
        this.y = y;
        this._positionRelativeToEditorBrand = undefined;
    }
}
function createEditorPagePosition(editorViewDomNode) {
    const editorPos = _domJs.getDomNodePagePosition(editorViewDomNode);
    return new EditorPagePosition(editorPos.left, editorPos.top, editorPos.width, editorPos.height);
}
function createCoordinatesRelativeToEditor(editorViewDomNode, editorPagePosition, pos) {
    // The editor's page position is read from the DOM using getBoundingClientRect().
    //
    // getBoundingClientRect() returns the actual dimensions, while offsetWidth and offsetHeight
    // reflect the unscaled size. We can use this difference to detect a transform:scale()
    // and we will apply the transformation in inverse to get mouse coordinates that make sense inside the editor.
    //
    // This could be expanded to cover rotation as well maybe by walking the DOM up from `editorViewDomNode`
    // and computing the effective transformation matrix using getComputedStyle(element).transform.
    //
    const scaleX = editorPagePosition.width / editorViewDomNode.offsetWidth;
    const scaleY = editorPagePosition.height / editorViewDomNode.offsetHeight;
    // Adjust mouse offsets if editor appears to be scaled via transforms
    const relativeX = (pos.x - editorPagePosition.x) / scaleX;
    const relativeY = (pos.y - editorPagePosition.y) / scaleY;
    return new CoordinatesRelativeToEditor(relativeX, relativeY);
}
class EditorMouseEvent extends (0, _mouseEventJs.StandardMouseEvent) {
    constructor(e, isFromPointerCapture, editorViewDomNode){
        super(_domJs.getWindow(editorViewDomNode), e);
        this._editorMouseEventBrand = undefined;
        this.isFromPointerCapture = isFromPointerCapture;
        this.pos = new PageCoordinates(this.posx, this.posy);
        this.editorPos = createEditorPagePosition(editorViewDomNode);
        this.relativePos = createCoordinatesRelativeToEditor(editorViewDomNode, this.editorPos, this.pos);
    }
}
class EditorMouseEventFactory {
    constructor(editorViewDomNode){
        this._editorViewDomNode = editorViewDomNode;
    }
    _create(e) {
        return new EditorMouseEvent(e, false, this._editorViewDomNode);
    }
    onContextMenu(target, callback) {
        return _domJs.addDisposableListener(target, "contextmenu", (e)=>{
            callback(this._create(e));
        });
    }
    onMouseUp(target, callback) {
        return _domJs.addDisposableListener(target, "mouseup", (e)=>{
            callback(this._create(e));
        });
    }
    onMouseDown(target, callback) {
        return _domJs.addDisposableListener(target, _domJs.EventType.MOUSE_DOWN, (e)=>{
            callback(this._create(e));
        });
    }
    onPointerDown(target, callback) {
        return _domJs.addDisposableListener(target, _domJs.EventType.POINTER_DOWN, (e)=>{
            callback(this._create(e), e.pointerId);
        });
    }
    onMouseLeave(target, callback) {
        return _domJs.addDisposableListener(target, _domJs.EventType.MOUSE_LEAVE, (e)=>{
            callback(this._create(e));
        });
    }
    onMouseMove(target, callback) {
        return _domJs.addDisposableListener(target, "mousemove", (e)=>callback(this._create(e)));
    }
}
class EditorPointerEventFactory {
    constructor(editorViewDomNode){
        this._editorViewDomNode = editorViewDomNode;
    }
    _create(e) {
        return new EditorMouseEvent(e, false, this._editorViewDomNode);
    }
    onPointerUp(target, callback) {
        return _domJs.addDisposableListener(target, "pointerup", (e)=>{
            callback(this._create(e));
        });
    }
    onPointerDown(target, callback) {
        return _domJs.addDisposableListener(target, _domJs.EventType.POINTER_DOWN, (e)=>{
            callback(this._create(e), e.pointerId);
        });
    }
    onPointerLeave(target, callback) {
        return _domJs.addDisposableListener(target, _domJs.EventType.POINTER_LEAVE, (e)=>{
            callback(this._create(e));
        });
    }
    onPointerMove(target, callback) {
        return _domJs.addDisposableListener(target, "pointermove", (e)=>callback(this._create(e)));
    }
}
class GlobalEditorPointerMoveMonitor extends (0, _lifecycleJs.Disposable) {
    constructor(editorViewDomNode){
        super();
        this._editorViewDomNode = editorViewDomNode;
        this._globalPointerMoveMonitor = this._register(new (0, _globalPointerMoveMonitorJs.GlobalPointerMoveMonitor)());
        this._keydownListener = null;
    }
    startMonitoring(initialElement, pointerId, initialButtons, pointerMoveCallback, onStopCallback) {
        // Add a <<capture>> keydown event listener that will cancel the monitoring
        // if something other than a modifier key is pressed
        this._keydownListener = _domJs.addStandardDisposableListener(initialElement.ownerDocument, "keydown", (e)=>{
            const chord = e.toKeyCodeChord();
            if (chord.isModifierKey()) // Allow modifier keys
            return;
            this._globalPointerMoveMonitor.stopMonitoring(true, e.browserEvent);
        }, true);
        this._globalPointerMoveMonitor.startMonitoring(initialElement, pointerId, initialButtons, (e)=>{
            pointerMoveCallback(new EditorMouseEvent(e, true, this._editorViewDomNode));
        }, (e)=>{
            this._keydownListener.dispose();
            onStopCallback(e);
        });
    }
    stopMonitoring() {
        this._globalPointerMoveMonitor.stopMonitoring(true);
    }
}
class DynamicCssRules {
    static{
        this._idPool = 0;
    }
    constructor(_editor){
        this._editor = _editor;
        this._instanceId = ++DynamicCssRules._idPool;
        this._counter = 0;
        this._rules = new Map();
        // We delay garbage collection so that hanging rules can be reused.
        this._garbageCollectionScheduler = new (0, _asyncJs.RunOnceScheduler)(()=>this.garbageCollect(), 1000);
    }
    createClassNameRef(options) {
        const rule = this.getOrCreateRule(options);
        rule.increaseRefCount();
        return {
            className: rule.className,
            dispose: ()=>{
                rule.decreaseRefCount();
                this._garbageCollectionScheduler.schedule();
            }
        };
    }
    getOrCreateRule(properties) {
        const key = this.computeUniqueKey(properties);
        let existingRule = this._rules.get(key);
        if (!existingRule) {
            const counter = this._counter++;
            existingRule = new RefCountedCssRule(key, `dyn-rule-${this._instanceId}-${counter}`, _domJs.isInShadowDOM(this._editor.getContainerDomNode()) ? this._editor.getContainerDomNode() : undefined, properties);
            this._rules.set(key, existingRule);
        }
        return existingRule;
    }
    computeUniqueKey(properties) {
        return JSON.stringify(properties);
    }
    garbageCollect() {
        for (const rule of this._rules.values())if (!rule.hasReferences()) {
            this._rules.delete(rule.key);
            rule.dispose();
        }
    }
}
class RefCountedCssRule {
    constructor(key, className, _containerElement, properties){
        this.key = key;
        this.className = className;
        this.properties = properties;
        this._referenceCount = 0;
        this._styleElementDisposables = new (0, _lifecycleJs.DisposableStore)();
        this._styleElement = _domJs.createStyleSheet(_containerElement, undefined, this._styleElementDisposables);
        this._styleElement.textContent = this.getCssText(this.className, this.properties);
    }
    getCssText(className, properties) {
        let str = `.${className} {`;
        for(const prop in properties){
            const value = properties[prop];
            let cssValue;
            if (typeof value === "object") cssValue = (0, _colorRegistryJs.asCssVariable)(value.id);
            else cssValue = value;
            const cssPropName = camelToDashes(prop);
            str += `\n\t${cssPropName}: ${cssValue};`;
        }
        str += `\n}`;
        return str;
    }
    dispose() {
        this._styleElementDisposables.dispose();
        this._styleElement = undefined;
    }
    increaseRefCount() {
        this._referenceCount++;
    }
    decreaseRefCount() {
        this._referenceCount--;
    }
    hasReferences() {
        return this._referenceCount > 0;
    }
}
function camelToDashes(str) {
    return str.replace(/(^[A-Z])/, ([first])=>first.toLowerCase()).replace(/([A-Z])/g, ([letter])=>`-${letter.toLowerCase()}`);
}

},{"../../base/browser/dom.js":"bnqsM","../../base/browser/globalPointerMoveMonitor.js":"iDfLk","../../base/browser/mouseEvent.js":"4jTdu","../../base/common/async.js":"4GJc4","../../base/common/lifecycle.js":"9kg8d","../../platform/theme/common/colorRegistry.js":"ik5kv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kTsLR":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewPart", ()=>ViewPart);
parcelHelpers.export(exports, "PartFingerprints", ()=>PartFingerprints);
var _viewEventHandlerJs = require("../../common/viewEventHandler.js");
class ViewPart extends (0, _viewEventHandlerJs.ViewEventHandler) {
    constructor(context){
        super();
        this._context = context;
        this._context.addEventHandler(this);
    }
    dispose() {
        this._context.removeEventHandler(this);
        super.dispose();
    }
}
class PartFingerprints {
    static write(target, partId) {
        target.setAttribute("data-mprt", String(partId));
    }
    static read(target) {
        const r = target.getAttribute("data-mprt");
        if (r === null) return 0 /* PartFingerprint.None */ ;
        return parseInt(r, 10);
    }
    static collect(child, stopAt) {
        const result = [];
        let resultLen = 0;
        while(child && child !== child.ownerDocument.body){
            if (child === stopAt) break;
            if (child.nodeType === child.ELEMENT_NODE) result[resultLen++] = this.read(child);
            child = child.parentElement;
        }
        const r = new Uint8Array(resultLen);
        for(let i = 0; i < resultLen; i++)r[i] = result[resultLen - i - 1];
        return r;
    }
}

},{"../../common/viewEventHandler.js":"9pYyF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9pYyF":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewEventHandler", ()=>ViewEventHandler);
var _lifecycleJs = require("../../base/common/lifecycle.js");
class ViewEventHandler extends (0, _lifecycleJs.Disposable) {
    constructor(){
        super();
        this._shouldRender = true;
    }
    shouldRender() {
        return this._shouldRender;
    }
    forceShouldRender() {
        this._shouldRender = true;
    }
    setShouldRender() {
        this._shouldRender = true;
    }
    onDidRender() {
        this._shouldRender = false;
    }
    // --- begin event handlers
    onCompositionStart(e) {
        return false;
    }
    onCompositionEnd(e) {
        return false;
    }
    onConfigurationChanged(e) {
        return false;
    }
    onCursorStateChanged(e) {
        return false;
    }
    onDecorationsChanged(e) {
        return false;
    }
    onFlushed(e) {
        return false;
    }
    onFocusChanged(e) {
        return false;
    }
    onLanguageConfigurationChanged(e) {
        return false;
    }
    onLineMappingChanged(e) {
        return false;
    }
    onLinesChanged(e) {
        return false;
    }
    onLinesDeleted(e) {
        return false;
    }
    onLinesInserted(e) {
        return false;
    }
    onRevealRangeRequest(e) {
        return false;
    }
    onScrollChanged(e) {
        return false;
    }
    onThemeChanged(e) {
        return false;
    }
    onTokensChanged(e) {
        return false;
    }
    onTokensColorsChanged(e) {
        return false;
    }
    onZonesChanged(e) {
        return false;
    }
    // --- end event handlers
    handleEvents(events) {
        let shouldRender = false;
        for(let i = 0, len = events.length; i < len; i++){
            const e = events[i];
            switch(e.type){
                case 0 /* viewEvents.ViewEventType.ViewCompositionStart */ :
                    if (this.onCompositionStart(e)) shouldRender = true;
                    break;
                case 1 /* viewEvents.ViewEventType.ViewCompositionEnd */ :
                    if (this.onCompositionEnd(e)) shouldRender = true;
                    break;
                case 2 /* viewEvents.ViewEventType.ViewConfigurationChanged */ :
                    if (this.onConfigurationChanged(e)) shouldRender = true;
                    break;
                case 3 /* viewEvents.ViewEventType.ViewCursorStateChanged */ :
                    if (this.onCursorStateChanged(e)) shouldRender = true;
                    break;
                case 4 /* viewEvents.ViewEventType.ViewDecorationsChanged */ :
                    if (this.onDecorationsChanged(e)) shouldRender = true;
                    break;
                case 5 /* viewEvents.ViewEventType.ViewFlushed */ :
                    if (this.onFlushed(e)) shouldRender = true;
                    break;
                case 6 /* viewEvents.ViewEventType.ViewFocusChanged */ :
                    if (this.onFocusChanged(e)) shouldRender = true;
                    break;
                case 7 /* viewEvents.ViewEventType.ViewLanguageConfigurationChanged */ :
                    if (this.onLanguageConfigurationChanged(e)) shouldRender = true;
                    break;
                case 8 /* viewEvents.ViewEventType.ViewLineMappingChanged */ :
                    if (this.onLineMappingChanged(e)) shouldRender = true;
                    break;
                case 9 /* viewEvents.ViewEventType.ViewLinesChanged */ :
                    if (this.onLinesChanged(e)) shouldRender = true;
                    break;
                case 10 /* viewEvents.ViewEventType.ViewLinesDeleted */ :
                    if (this.onLinesDeleted(e)) shouldRender = true;
                    break;
                case 11 /* viewEvents.ViewEventType.ViewLinesInserted */ :
                    if (this.onLinesInserted(e)) shouldRender = true;
                    break;
                case 12 /* viewEvents.ViewEventType.ViewRevealRangeRequest */ :
                    if (this.onRevealRangeRequest(e)) shouldRender = true;
                    break;
                case 13 /* viewEvents.ViewEventType.ViewScrollChanged */ :
                    if (this.onScrollChanged(e)) shouldRender = true;
                    break;
                case 15 /* viewEvents.ViewEventType.ViewTokensChanged */ :
                    if (this.onTokensChanged(e)) shouldRender = true;
                    break;
                case 14 /* viewEvents.ViewEventType.ViewThemeChanged */ :
                    if (this.onThemeChanged(e)) shouldRender = true;
                    break;
                case 16 /* viewEvents.ViewEventType.ViewTokensColorsChanged */ :
                    if (this.onTokensColorsChanged(e)) shouldRender = true;
                    break;
                case 17 /* viewEvents.ViewEventType.ViewZonesChanged */ :
                    if (this.onZonesChanged(e)) shouldRender = true;
                    break;
                default:
                    console.info("View received unknown event: ");
                    console.info(e);
            }
        }
        if (shouldRender) this._shouldRender = true;
    }
}

},{"../../base/common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9rxuY":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewLineOptions", ()=>ViewLineOptions);
parcelHelpers.export(exports, "ViewLine", ()=>ViewLine);
parcelHelpers.export(exports, "getColumnOfNodeOffset", ()=>getColumnOfNodeOffset);
var _browserJs = require("../../../../base/browser/browser.js");
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _platformJs = require("../../../../base/common/platform.js");
var _rangeUtilJs = require("./rangeUtil.js");
var _renderingContextJs = require("../../view/renderingContext.js");
var _lineDecorationsJs = require("../../../common/viewLayout/lineDecorations.js");
var _viewLineRendererJs = require("../../../common/viewLayout/viewLineRenderer.js");
var _themeJs = require("../../../../platform/theme/common/theme.js");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
const canUseFastRenderedViewLine = function() {
    if (_platformJs.isNative) // In VSCode we know very well when the zoom level changes
    return true;
    if (_platformJs.isLinux || _browserJs.isFirefox || _browserJs.isSafari) // On Linux, it appears that zooming affects char widths (in pixels), which is unexpected.
    // --
    // Even though we read character widths correctly, having read them at a specific zoom level
    // does not mean they are the same at the current zoom level.
    // --
    // This could be improved if we ever figure out how to get an event when browsers zoom,
    // but until then we have to stick with reading client rects.
    // --
    // The same has been observed with Firefox on Windows7
    // --
    // The same has been oversved with Safari
    return false;
    return true;
}();
let monospaceAssumptionsAreValid = true;
class ViewLineOptions {
    constructor(config, themeType){
        this.themeType = themeType;
        const options = config.options;
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        const experimentalWhitespaceRendering = options.get(38 /* EditorOption.experimentalWhitespaceRendering */ );
        if (experimentalWhitespaceRendering === "off") this.renderWhitespace = options.get(100 /* EditorOption.renderWhitespace */ );
        else // whitespace is rendered in a different layer
        this.renderWhitespace = "none";
        this.renderControlCharacters = options.get(95 /* EditorOption.renderControlCharacters */ );
        this.spaceWidth = fontInfo.spaceWidth;
        this.middotWidth = fontInfo.middotWidth;
        this.wsmiddotWidth = fontInfo.wsmiddotWidth;
        this.useMonospaceOptimizations = fontInfo.isMonospace && !options.get(33 /* EditorOption.disableMonospaceOptimizations */ );
        this.canUseHalfwidthRightwardsArrow = fontInfo.canUseHalfwidthRightwardsArrow;
        this.lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this.stopRenderingLineAfter = options.get(118 /* EditorOption.stopRenderingLineAfter */ );
        this.fontLigatures = options.get(51 /* EditorOption.fontLigatures */ );
    }
    equals(other) {
        return this.themeType === other.themeType && this.renderWhitespace === other.renderWhitespace && this.renderControlCharacters === other.renderControlCharacters && this.spaceWidth === other.spaceWidth && this.middotWidth === other.middotWidth && this.wsmiddotWidth === other.wsmiddotWidth && this.useMonospaceOptimizations === other.useMonospaceOptimizations && this.canUseHalfwidthRightwardsArrow === other.canUseHalfwidthRightwardsArrow && this.lineHeight === other.lineHeight && this.stopRenderingLineAfter === other.stopRenderingLineAfter && this.fontLigatures === other.fontLigatures;
    }
}
class ViewLine {
    static{
        this.CLASS_NAME = "view-line";
    }
    constructor(options){
        this._options = options;
        this._isMaybeInvalid = true;
        this._renderedViewLine = null;
    }
    // --- begin IVisibleLineData
    getDomNode() {
        if (this._renderedViewLine && this._renderedViewLine.domNode) return this._renderedViewLine.domNode.domNode;
        return null;
    }
    setDomNode(domNode) {
        if (this._renderedViewLine) this._renderedViewLine.domNode = (0, _fastDomNodeJs.createFastDomNode)(domNode);
        else throw new Error("I have no rendered view line to set the dom node to...");
    }
    onContentChanged() {
        this._isMaybeInvalid = true;
    }
    onTokensChanged() {
        this._isMaybeInvalid = true;
    }
    onDecorationsChanged() {
        this._isMaybeInvalid = true;
    }
    onOptionsChanged(newOptions) {
        this._isMaybeInvalid = true;
        this._options = newOptions;
    }
    onSelectionChanged() {
        if ((0, _themeJs.isHighContrast)(this._options.themeType) || this._options.renderWhitespace === "selection") {
            this._isMaybeInvalid = true;
            return true;
        }
        return false;
    }
    renderLine(lineNumber, deltaTop, lineHeight, viewportData, sb) {
        if (this._isMaybeInvalid === false) // it appears that nothing relevant has changed
        return false;
        this._isMaybeInvalid = false;
        const lineData = viewportData.getViewLineRenderingData(lineNumber);
        const options = this._options;
        const actualInlineDecorations = (0, _lineDecorationsJs.LineDecoration).filter(lineData.inlineDecorations, lineNumber, lineData.minColumn, lineData.maxColumn);
        // Only send selection information when needed for rendering whitespace
        let selectionsOnLine = null;
        if ((0, _themeJs.isHighContrast)(options.themeType) || this._options.renderWhitespace === "selection") {
            const selections = viewportData.selections;
            for (const selection of selections){
                if (selection.endLineNumber < lineNumber || selection.startLineNumber > lineNumber) continue;
                const startColumn = selection.startLineNumber === lineNumber ? selection.startColumn : lineData.minColumn;
                const endColumn = selection.endLineNumber === lineNumber ? selection.endColumn : lineData.maxColumn;
                if (startColumn < endColumn) {
                    if ((0, _themeJs.isHighContrast)(options.themeType)) actualInlineDecorations.push(new (0, _lineDecorationsJs.LineDecoration)(startColumn, endColumn, "inline-selected-text", 0 /* InlineDecorationType.Regular */ ));
                    if (this._options.renderWhitespace === "selection") {
                        if (!selectionsOnLine) selectionsOnLine = [];
                        selectionsOnLine.push(new (0, _viewLineRendererJs.LineRange)(startColumn - 1, endColumn - 1));
                    }
                }
            }
        }
        const renderLineInput = new (0, _viewLineRendererJs.RenderLineInput)(options.useMonospaceOptimizations, options.canUseHalfwidthRightwardsArrow, lineData.content, lineData.continuesWithWrappedLine, lineData.isBasicASCII, lineData.containsRTL, lineData.minColumn - 1, lineData.tokens, actualInlineDecorations, lineData.tabSize, lineData.startVisibleColumn, options.spaceWidth, options.middotWidth, options.wsmiddotWidth, options.stopRenderingLineAfter, options.renderWhitespace, options.renderControlCharacters, options.fontLigatures !== (0, _editorOptionsJs.EditorFontLigatures).OFF, selectionsOnLine);
        if (this._renderedViewLine && this._renderedViewLine.input.equals(renderLineInput)) // no need to do anything, we have the same render input
        return false;
        sb.appendString('<div style="top:');
        sb.appendString(String(deltaTop));
        sb.appendString("px;height:");
        sb.appendString(String(lineHeight));
        sb.appendString('px;" class="');
        sb.appendString(ViewLine.CLASS_NAME);
        sb.appendString('">');
        const output = (0, _viewLineRendererJs.renderViewLine)(renderLineInput, sb);
        sb.appendString("</div>");
        let renderedViewLine = null;
        if (monospaceAssumptionsAreValid && canUseFastRenderedViewLine && lineData.isBasicASCII && options.useMonospaceOptimizations && output.containsForeignElements === 0 /* ForeignElementType.None */ ) renderedViewLine = new FastRenderedViewLine(this._renderedViewLine ? this._renderedViewLine.domNode : null, renderLineInput, output.characterMapping);
        if (!renderedViewLine) renderedViewLine = createRenderedLine(this._renderedViewLine ? this._renderedViewLine.domNode : null, renderLineInput, output.characterMapping, output.containsRTL, output.containsForeignElements);
        this._renderedViewLine = renderedViewLine;
        return true;
    }
    layoutLine(lineNumber, deltaTop, lineHeight) {
        if (this._renderedViewLine && this._renderedViewLine.domNode) {
            this._renderedViewLine.domNode.setTop(deltaTop);
            this._renderedViewLine.domNode.setHeight(lineHeight);
        }
    }
    // --- end IVisibleLineData
    getWidth(context) {
        if (!this._renderedViewLine) return 0;
        return this._renderedViewLine.getWidth(context);
    }
    getWidthIsFast() {
        if (!this._renderedViewLine) return true;
        return this._renderedViewLine.getWidthIsFast();
    }
    needsMonospaceFontCheck() {
        if (!this._renderedViewLine) return false;
        return this._renderedViewLine instanceof FastRenderedViewLine;
    }
    monospaceAssumptionsAreValid() {
        if (!this._renderedViewLine) return monospaceAssumptionsAreValid;
        if (this._renderedViewLine instanceof FastRenderedViewLine) return this._renderedViewLine.monospaceAssumptionsAreValid();
        return monospaceAssumptionsAreValid;
    }
    onMonospaceAssumptionsInvalidated() {
        if (this._renderedViewLine && this._renderedViewLine instanceof FastRenderedViewLine) this._renderedViewLine = this._renderedViewLine.toSlowRenderedLine();
    }
    getVisibleRangesForRange(lineNumber, startColumn, endColumn, context) {
        if (!this._renderedViewLine) return null;
        startColumn = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, startColumn));
        endColumn = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, endColumn));
        const stopRenderingLineAfter = this._renderedViewLine.input.stopRenderingLineAfter;
        if (stopRenderingLineAfter !== -1 && startColumn > stopRenderingLineAfter + 1 && endColumn > stopRenderingLineAfter + 1) // This range is obviously not visible
        return new (0, _renderingContextJs.VisibleRanges)(true, [
            new (0, _renderingContextJs.FloatHorizontalRange)(this.getWidth(context), 0)
        ]);
        if (stopRenderingLineAfter !== -1 && startColumn > stopRenderingLineAfter + 1) startColumn = stopRenderingLineAfter + 1;
        if (stopRenderingLineAfter !== -1 && endColumn > stopRenderingLineAfter + 1) endColumn = stopRenderingLineAfter + 1;
        const horizontalRanges = this._renderedViewLine.getVisibleRangesForRange(lineNumber, startColumn, endColumn, context);
        if (horizontalRanges && horizontalRanges.length > 0) return new (0, _renderingContextJs.VisibleRanges)(false, horizontalRanges);
        return null;
    }
    getColumnOfNodeOffset(spanNode, offset) {
        if (!this._renderedViewLine) return 1;
        return this._renderedViewLine.getColumnOfNodeOffset(spanNode, offset);
    }
}
/**
 * A rendered line which is guaranteed to contain only regular ASCII and is rendered with a monospace font.
 */ class FastRenderedViewLine {
    constructor(domNode, renderLineInput, characterMapping){
        this._cachedWidth = -1;
        this.domNode = domNode;
        this.input = renderLineInput;
        const keyColumnCount = Math.floor(renderLineInput.lineContent.length / 300 /* Constants.MaxMonospaceDistance */ );
        if (keyColumnCount > 0) {
            this._keyColumnPixelOffsetCache = new Float32Array(keyColumnCount);
            for(let i = 0; i < keyColumnCount; i++)this._keyColumnPixelOffsetCache[i] = -1;
        } else this._keyColumnPixelOffsetCache = null;
        this._characterMapping = characterMapping;
        this._charWidth = renderLineInput.spaceWidth;
    }
    getWidth(context) {
        if (!this.domNode || this.input.lineContent.length < 300 /* Constants.MaxMonospaceDistance */ ) {
            const horizontalOffset = this._characterMapping.getHorizontalOffset(this._characterMapping.length);
            return Math.round(this._charWidth * horizontalOffset);
        }
        if (this._cachedWidth === -1) {
            this._cachedWidth = this._getReadingTarget(this.domNode).offsetWidth;
            context?.markDidDomLayout();
        }
        return this._cachedWidth;
    }
    getWidthIsFast() {
        return this.input.lineContent.length < 300 /* Constants.MaxMonospaceDistance */  || this._cachedWidth !== -1;
    }
    monospaceAssumptionsAreValid() {
        if (!this.domNode) return monospaceAssumptionsAreValid;
        if (this.input.lineContent.length < 300 /* Constants.MaxMonospaceDistance */ ) {
            const expectedWidth = this.getWidth(null);
            const actualWidth = this.domNode.domNode.firstChild.offsetWidth;
            if (Math.abs(expectedWidth - actualWidth) >= 2) {
                // more than 2px off
                console.warn(`monospace assumptions have been violated, therefore disabling monospace optimizations!`);
                monospaceAssumptionsAreValid = false;
            }
        }
        return monospaceAssumptionsAreValid;
    }
    toSlowRenderedLine() {
        return createRenderedLine(this.domNode, this.input, this._characterMapping, false, 0 /* ForeignElementType.None */ );
    }
    getVisibleRangesForRange(lineNumber, startColumn, endColumn, context) {
        const startPosition = this._getColumnPixelOffset(lineNumber, startColumn, context);
        const endPosition = this._getColumnPixelOffset(lineNumber, endColumn, context);
        return [
            new (0, _renderingContextJs.FloatHorizontalRange)(startPosition, endPosition - startPosition)
        ];
    }
    _getColumnPixelOffset(lineNumber, column, context) {
        if (column <= 300 /* Constants.MaxMonospaceDistance */ ) {
            const horizontalOffset = this._characterMapping.getHorizontalOffset(column);
            return this._charWidth * horizontalOffset;
        }
        const keyColumnOrdinal = Math.floor((column - 1) / 300 /* Constants.MaxMonospaceDistance */ ) - 1;
        const keyColumn = (keyColumnOrdinal + 1) * 300 /* Constants.MaxMonospaceDistance */  + 1;
        let keyColumnPixelOffset = -1;
        if (this._keyColumnPixelOffsetCache) {
            keyColumnPixelOffset = this._keyColumnPixelOffsetCache[keyColumnOrdinal];
            if (keyColumnPixelOffset === -1) {
                keyColumnPixelOffset = this._actualReadPixelOffset(lineNumber, keyColumn, context);
                this._keyColumnPixelOffsetCache[keyColumnOrdinal] = keyColumnPixelOffset;
            }
        }
        if (keyColumnPixelOffset === -1) {
            // Could not read actual key column pixel offset
            const horizontalOffset = this._characterMapping.getHorizontalOffset(column);
            return this._charWidth * horizontalOffset;
        }
        const keyColumnHorizontalOffset = this._characterMapping.getHorizontalOffset(keyColumn);
        const horizontalOffset = this._characterMapping.getHorizontalOffset(column);
        return keyColumnPixelOffset + this._charWidth * (horizontalOffset - keyColumnHorizontalOffset);
    }
    _getReadingTarget(myDomNode) {
        return myDomNode.domNode.firstChild;
    }
    _actualReadPixelOffset(lineNumber, column, context) {
        if (!this.domNode) return -1;
        const domPosition = this._characterMapping.getDomPosition(column);
        const r = (0, _rangeUtilJs.RangeUtil).readHorizontalRanges(this._getReadingTarget(this.domNode), domPosition.partIndex, domPosition.charIndex, domPosition.partIndex, domPosition.charIndex, context);
        if (!r || r.length === 0) return -1;
        return r[0].left;
    }
    getColumnOfNodeOffset(spanNode, offset) {
        return getColumnOfNodeOffset(this._characterMapping, spanNode, offset);
    }
}
/**
 * Every time we render a line, we save what we have rendered in an instance of this class.
 */ class RenderedViewLine {
    constructor(domNode, renderLineInput, characterMapping, containsRTL, containsForeignElements){
        this.domNode = domNode;
        this.input = renderLineInput;
        this._characterMapping = characterMapping;
        this._isWhitespaceOnly = /^\s*$/.test(renderLineInput.lineContent);
        this._containsForeignElements = containsForeignElements;
        this._cachedWidth = -1;
        this._pixelOffsetCache = null;
        if (!containsRTL || this._characterMapping.length === 0 /* the line is empty */ ) {
            this._pixelOffsetCache = new Float32Array(Math.max(2, this._characterMapping.length + 1));
            for(let column = 0, len = this._characterMapping.length; column <= len; column++)this._pixelOffsetCache[column] = -1;
        }
    }
    // --- Reading from the DOM methods
    _getReadingTarget(myDomNode) {
        return myDomNode.domNode.firstChild;
    }
    /**
     * Width of the line in pixels
     */ getWidth(context) {
        if (!this.domNode) return 0;
        if (this._cachedWidth === -1) {
            this._cachedWidth = this._getReadingTarget(this.domNode).offsetWidth;
            context?.markDidDomLayout();
        }
        return this._cachedWidth;
    }
    getWidthIsFast() {
        if (this._cachedWidth === -1) return false;
        return true;
    }
    /**
     * Visible ranges for a model range
     */ getVisibleRangesForRange(lineNumber, startColumn, endColumn, context) {
        if (!this.domNode) return null;
        if (this._pixelOffsetCache !== null) {
            // the text is LTR
            const startOffset = this._readPixelOffset(this.domNode, lineNumber, startColumn, context);
            if (startOffset === -1) return null;
            const endOffset = this._readPixelOffset(this.domNode, lineNumber, endColumn, context);
            if (endOffset === -1) return null;
            return [
                new (0, _renderingContextJs.FloatHorizontalRange)(startOffset, endOffset - startOffset)
            ];
        }
        return this._readVisibleRangesForRange(this.domNode, lineNumber, startColumn, endColumn, context);
    }
    _readVisibleRangesForRange(domNode, lineNumber, startColumn, endColumn, context) {
        if (startColumn === endColumn) {
            const pixelOffset = this._readPixelOffset(domNode, lineNumber, startColumn, context);
            if (pixelOffset === -1) return null;
            else return [
                new (0, _renderingContextJs.FloatHorizontalRange)(pixelOffset, 0)
            ];
        } else return this._readRawVisibleRangesForRange(domNode, startColumn, endColumn, context);
    }
    _readPixelOffset(domNode, lineNumber, column, context) {
        if (this._characterMapping.length === 0) {
            // This line has no content
            if (this._containsForeignElements === 0 /* ForeignElementType.None */ ) // We can assume the line is really empty
            return 0;
            if (this._containsForeignElements === 2 /* ForeignElementType.After */ ) // We have foreign elements after the (empty) line
            return 0;
            if (this._containsForeignElements === 1 /* ForeignElementType.Before */ ) // We have foreign elements before the (empty) line
            return this.getWidth(context);
            // We have foreign elements before & after the (empty) line
            const readingTarget = this._getReadingTarget(domNode);
            if (readingTarget.firstChild) {
                context.markDidDomLayout();
                return readingTarget.firstChild.offsetWidth;
            } else return 0;
        }
        if (this._pixelOffsetCache !== null) {
            // the text is LTR
            const cachedPixelOffset = this._pixelOffsetCache[column];
            if (cachedPixelOffset !== -1) return cachedPixelOffset;
            const result = this._actualReadPixelOffset(domNode, lineNumber, column, context);
            this._pixelOffsetCache[column] = result;
            return result;
        }
        return this._actualReadPixelOffset(domNode, lineNumber, column, context);
    }
    _actualReadPixelOffset(domNode, lineNumber, column, context) {
        if (this._characterMapping.length === 0) {
            // This line has no content
            const r = (0, _rangeUtilJs.RangeUtil).readHorizontalRanges(this._getReadingTarget(domNode), 0, 0, 0, 0, context);
            if (!r || r.length === 0) return -1;
            return r[0].left;
        }
        if (column === this._characterMapping.length && this._isWhitespaceOnly && this._containsForeignElements === 0 /* ForeignElementType.None */ ) // This branch helps in the case of whitespace only lines which have a width set
        return this.getWidth(context);
        const domPosition = this._characterMapping.getDomPosition(column);
        const r = (0, _rangeUtilJs.RangeUtil).readHorizontalRanges(this._getReadingTarget(domNode), domPosition.partIndex, domPosition.charIndex, domPosition.partIndex, domPosition.charIndex, context);
        if (!r || r.length === 0) return -1;
        const result = r[0].left;
        if (this.input.isBasicASCII) {
            const horizontalOffset = this._characterMapping.getHorizontalOffset(column);
            const expectedResult = Math.round(this.input.spaceWidth * horizontalOffset);
            if (Math.abs(expectedResult - result) <= 1) return expectedResult;
        }
        return result;
    }
    _readRawVisibleRangesForRange(domNode, startColumn, endColumn, context) {
        if (startColumn === 1 && endColumn === this._characterMapping.length) // This branch helps IE with bidi text & gives a performance boost to other browsers when reading visible ranges for an entire line
        return [
            new (0, _renderingContextJs.FloatHorizontalRange)(0, this.getWidth(context))
        ];
        const startDomPosition = this._characterMapping.getDomPosition(startColumn);
        const endDomPosition = this._characterMapping.getDomPosition(endColumn);
        return (0, _rangeUtilJs.RangeUtil).readHorizontalRanges(this._getReadingTarget(domNode), startDomPosition.partIndex, startDomPosition.charIndex, endDomPosition.partIndex, endDomPosition.charIndex, context);
    }
    /**
     * Returns the column for the text found at a specific offset inside a rendered dom node
     */ getColumnOfNodeOffset(spanNode, offset) {
        return getColumnOfNodeOffset(this._characterMapping, spanNode, offset);
    }
}
class WebKitRenderedViewLine extends RenderedViewLine {
    _readVisibleRangesForRange(domNode, lineNumber, startColumn, endColumn, context) {
        const output = super._readVisibleRangesForRange(domNode, lineNumber, startColumn, endColumn, context);
        if (!output || output.length === 0 || startColumn === endColumn || startColumn === 1 && endColumn === this._characterMapping.length) return output;
        // WebKit is buggy and returns an expanded range (to contain words in some cases)
        // The last client rect is enlarged (I think)
        if (!this.input.containsRTL) {
            // This is an attempt to patch things up
            // Find position of last column
            const endPixelOffset = this._readPixelOffset(domNode, lineNumber, endColumn, context);
            if (endPixelOffset !== -1) {
                const lastRange = output[output.length - 1];
                if (lastRange.left < endPixelOffset) // Trim down the width of the last visible range to not go after the last column's position
                lastRange.width = endPixelOffset - lastRange.left;
            }
        }
        return output;
    }
}
const createRenderedLine = function() {
    if (_browserJs.isWebKit) return createWebKitRenderedLine;
    return createNormalRenderedLine;
}();
function createWebKitRenderedLine(domNode, renderLineInput, characterMapping, containsRTL, containsForeignElements) {
    return new WebKitRenderedViewLine(domNode, renderLineInput, characterMapping, containsRTL, containsForeignElements);
}
function createNormalRenderedLine(domNode, renderLineInput, characterMapping, containsRTL, containsForeignElements) {
    return new RenderedViewLine(domNode, renderLineInput, characterMapping, containsRTL, containsForeignElements);
}
function getColumnOfNodeOffset(characterMapping, spanNode, offset) {
    const spanNodeTextContentLength = spanNode.textContent.length;
    let spanIndex = -1;
    while(spanNode){
        spanNode = spanNode.previousSibling;
        spanIndex++;
    }
    return characterMapping.getColumn(new (0, _viewLineRendererJs.DomPosition)(spanIndex, offset), spanNodeTextContentLength);
}

},{"../../../../base/browser/browser.js":"4Zquf","../../../../base/browser/fastDomNode.js":"2SADf","../../../../base/common/platform.js":"7maJO","./rangeUtil.js":"jTQ6k","../../view/renderingContext.js":"bWoBX","../../../common/viewLayout/lineDecorations.js":"m2bJX","../../../common/viewLayout/viewLineRenderer.js":"1RGPz","../../../../platform/theme/common/theme.js":"gh7Zf","../../../common/config/editorOptions.js":"3Xi00","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jTQ6k":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeUtil", ()=>RangeUtil);
var _renderingContextJs = require("../../view/renderingContext.js");
class RangeUtil {
    static _createRange() {
        if (!this._handyReadyRange) this._handyReadyRange = document.createRange();
        return this._handyReadyRange;
    }
    static _detachRange(range, endNode) {
        // Move range out of the span node, IE doesn't like having many ranges in
        // the same spot and will act badly for lines containing dashes ('-')
        range.selectNodeContents(endNode);
    }
    static _readClientRects(startElement, startOffset, endElement, endOffset, endNode) {
        const range = this._createRange();
        try {
            range.setStart(startElement, startOffset);
            range.setEnd(endElement, endOffset);
            return range.getClientRects();
        } catch (e) {
            // This is life ...
            return null;
        } finally{
            this._detachRange(range, endNode);
        }
    }
    static _mergeAdjacentRanges(ranges) {
        if (ranges.length === 1) // There is nothing to merge
        return ranges;
        ranges.sort((0, _renderingContextJs.FloatHorizontalRange).compare);
        const result = [];
        let resultLen = 0;
        let prev = ranges[0];
        for(let i = 1, len = ranges.length; i < len; i++){
            const range = ranges[i];
            if (prev.left + prev.width + 0.9 /* account for browser's rounding errors*/  >= range.left) prev.width = Math.max(prev.width, range.left + range.width - prev.left);
            else {
                result[resultLen++] = prev;
                prev = range;
            }
        }
        result[resultLen++] = prev;
        return result;
    }
    static _createHorizontalRangesFromClientRects(clientRects, clientRectDeltaLeft, clientRectScale) {
        if (!clientRects || clientRects.length === 0) return null;
        // We go through FloatHorizontalRange because it has been observed in bi-di text
        // that the clientRects are not coming in sorted from the browser
        const result = [];
        for(let i = 0, len = clientRects.length; i < len; i++){
            const clientRect = clientRects[i];
            result[i] = new (0, _renderingContextJs.FloatHorizontalRange)(Math.max(0, (clientRect.left - clientRectDeltaLeft) / clientRectScale), clientRect.width / clientRectScale);
        }
        return this._mergeAdjacentRanges(result);
    }
    static readHorizontalRanges(domNode, startChildIndex, startOffset, endChildIndex, endOffset, context) {
        // Panic check
        const min = 0;
        const max = domNode.children.length - 1;
        if (min > max) return null;
        startChildIndex = Math.min(max, Math.max(min, startChildIndex));
        endChildIndex = Math.min(max, Math.max(min, endChildIndex));
        if (startChildIndex === endChildIndex && startOffset === endOffset && startOffset === 0 && !domNode.children[startChildIndex].firstChild) {
            // We must find the position at the beginning of a <span>
            // To cover cases of empty <span>s, avoid using a range and use the <span>'s bounding box
            const clientRects = domNode.children[startChildIndex].getClientRects();
            context.markDidDomLayout();
            return this._createHorizontalRangesFromClientRects(clientRects, context.clientRectDeltaLeft, context.clientRectScale);
        }
        // If crossing over to a span only to select offset 0, then use the previous span's maximum offset
        // Chrome is buggy and doesn't handle 0 offsets well sometimes.
        if (startChildIndex !== endChildIndex) {
            if (endChildIndex > 0 && endOffset === 0) {
                endChildIndex--;
                endOffset = 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ;
            }
        }
        let startElement = domNode.children[startChildIndex].firstChild;
        let endElement = domNode.children[endChildIndex].firstChild;
        if (!startElement || !endElement) {
            // When having an empty <span> (without any text content), try to move to the previous <span>
            if (!startElement && startOffset === 0 && startChildIndex > 0) {
                startElement = domNode.children[startChildIndex - 1].firstChild;
                startOffset = 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ;
            }
            if (!endElement && endOffset === 0 && endChildIndex > 0) {
                endElement = domNode.children[endChildIndex - 1].firstChild;
                endOffset = 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ;
            }
        }
        if (!startElement || !endElement) return null;
        startOffset = Math.min(startElement.textContent.length, Math.max(0, startOffset));
        endOffset = Math.min(endElement.textContent.length, Math.max(0, endOffset));
        const clientRects = this._readClientRects(startElement, startOffset, endElement, endOffset, context.endNode);
        context.markDidDomLayout();
        return this._createHorizontalRangesFromClientRects(clientRects, context.clientRectDeltaLeft, context.clientRectScale);
    }
}

},{"../../view/renderingContext.js":"bWoBX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bWoBX":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RestrictedRenderingContext", ()=>RestrictedRenderingContext);
parcelHelpers.export(exports, "RenderingContext", ()=>RenderingContext);
parcelHelpers.export(exports, "LineVisibleRanges", ()=>LineVisibleRanges);
parcelHelpers.export(exports, "HorizontalRange", ()=>HorizontalRange);
parcelHelpers.export(exports, "FloatHorizontalRange", ()=>FloatHorizontalRange);
parcelHelpers.export(exports, "HorizontalPosition", ()=>HorizontalPosition);
parcelHelpers.export(exports, "VisibleRanges", ()=>VisibleRanges);
class RestrictedRenderingContext {
    constructor(viewLayout, viewportData){
        this._restrictedRenderingContextBrand = undefined;
        this._viewLayout = viewLayout;
        this.viewportData = viewportData;
        this.scrollWidth = this._viewLayout.getScrollWidth();
        this.scrollHeight = this._viewLayout.getScrollHeight();
        this.visibleRange = this.viewportData.visibleRange;
        this.bigNumbersDelta = this.viewportData.bigNumbersDelta;
        const vInfo = this._viewLayout.getCurrentViewport();
        this.scrollTop = vInfo.top;
        this.scrollLeft = vInfo.left;
        this.viewportWidth = vInfo.width;
        this.viewportHeight = vInfo.height;
    }
    getScrolledTopFromAbsoluteTop(absoluteTop) {
        return absoluteTop - this.scrollTop;
    }
    getVerticalOffsetForLineNumber(lineNumber, includeViewZones) {
        return this._viewLayout.getVerticalOffsetForLineNumber(lineNumber, includeViewZones);
    }
    getVerticalOffsetAfterLineNumber(lineNumber, includeViewZones) {
        return this._viewLayout.getVerticalOffsetAfterLineNumber(lineNumber, includeViewZones);
    }
    getDecorationsInViewport() {
        return this.viewportData.getDecorationsInViewport();
    }
}
class RenderingContext extends RestrictedRenderingContext {
    constructor(viewLayout, viewportData, viewLines){
        super(viewLayout, viewportData);
        this._renderingContextBrand = undefined;
        this._viewLines = viewLines;
    }
    linesVisibleRangesForRange(range, includeNewLines) {
        return this._viewLines.linesVisibleRangesForRange(range, includeNewLines);
    }
    visibleRangeForPosition(position) {
        return this._viewLines.visibleRangeForPosition(position);
    }
}
class LineVisibleRanges {
    constructor(outsideRenderedLine, lineNumber, ranges, /**
     * Indicates if the requested range does not end in this line, but continues on the next line.
     */ continuesOnNextLine){
        this.outsideRenderedLine = outsideRenderedLine;
        this.lineNumber = lineNumber;
        this.ranges = ranges;
        this.continuesOnNextLine = continuesOnNextLine;
    }
}
class HorizontalRange {
    static from(ranges) {
        const result = new Array(ranges.length);
        for(let i = 0, len = ranges.length; i < len; i++){
            const range = ranges[i];
            result[i] = new HorizontalRange(range.left, range.width);
        }
        return result;
    }
    constructor(left, width){
        this._horizontalRangeBrand = undefined;
        this.left = Math.round(left);
        this.width = Math.round(width);
    }
    toString() {
        return `[${this.left},${this.width}]`;
    }
}
class FloatHorizontalRange {
    constructor(left, width){
        this._floatHorizontalRangeBrand = undefined;
        this.left = left;
        this.width = width;
    }
    toString() {
        return `[${this.left},${this.width}]`;
    }
    static compare(a, b) {
        return a.left - b.left;
    }
}
class HorizontalPosition {
    constructor(outsideRenderedLine, left){
        this.outsideRenderedLine = outsideRenderedLine;
        this.originalLeft = left;
        this.left = Math.round(this.originalLeft);
    }
}
class VisibleRanges {
    constructor(outsideRenderedLine, ranges){
        this.outsideRenderedLine = outsideRenderedLine;
        this.ranges = ranges;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"asPUi":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AtomicTabMoveOperations", ()=>AtomicTabMoveOperations);
var _cursorColumnsJs = require("../core/cursorColumns.js");
class AtomicTabMoveOperations {
    /**
     * Get the visible column at the position. If we get to a non-whitespace character first
     * or past the end of string then return -1.
     *
     * **Note** `position` and the return value are 0-based.
     */ static whitespaceVisibleColumn(lineContent, position, tabSize) {
        const lineLength = lineContent.length;
        let visibleColumn = 0;
        let prevTabStopPosition = -1;
        let prevTabStopVisibleColumn = -1;
        for(let i = 0; i < lineLength; i++){
            if (i === position) return [
                prevTabStopPosition,
                prevTabStopVisibleColumn,
                visibleColumn
            ];
            if (visibleColumn % tabSize === 0) {
                prevTabStopPosition = i;
                prevTabStopVisibleColumn = visibleColumn;
            }
            const chCode = lineContent.charCodeAt(i);
            switch(chCode){
                case 32 /* CharCode.Space */ :
                    visibleColumn += 1;
                    break;
                case 9 /* CharCode.Tab */ :
                    // Skip to the next multiple of tabSize.
                    visibleColumn = (0, _cursorColumnsJs.CursorColumns).nextRenderTabStop(visibleColumn, tabSize);
                    break;
                default:
                    return [
                        -1,
                        -1,
                        -1
                    ];
            }
        }
        if (position === lineLength) return [
            prevTabStopPosition,
            prevTabStopVisibleColumn,
            visibleColumn
        ];
        return [
            -1,
            -1,
            -1
        ];
    }
    /**
     * Return the position that should result from a move left, right or to the
     * nearest tab, if atomic tabs are enabled. Left and right are used for the
     * arrow key movements, nearest is used for mouse selection. It returns
     * -1 if atomic tabs are not relevant and you should fall back to normal
     * behaviour.
     *
     * **Note**: `position` and the return value are 0-based.
     */ static atomicPosition(lineContent, position, tabSize, direction) {
        const lineLength = lineContent.length;
        // Get the 0-based visible column corresponding to the position, or return
        // -1 if it is not in the initial whitespace.
        const [prevTabStopPosition, prevTabStopVisibleColumn, visibleColumn] = AtomicTabMoveOperations.whitespaceVisibleColumn(lineContent, position, tabSize);
        if (visibleColumn === -1) return -1;
        // Is the output left or right of the current position. The case for nearest
        // where it is the same as the current position is handled in the switch.
        let left;
        switch(direction){
            case 0 /* Direction.Left */ :
                left = true;
                break;
            case 1 /* Direction.Right */ :
                left = false;
                break;
            case 2 /* Direction.Nearest */ :
                // The code below assumes the output position is either left or right
                // of the input position. If it is the same, return immediately.
                if (visibleColumn % tabSize === 0) return position;
                // Go to the nearest indentation.
                left = visibleColumn % tabSize <= tabSize / 2;
                break;
        }
        // If going left, we can just use the info about the last tab stop position and
        // last tab stop visible column that we computed in the first walk over the whitespace.
        if (left) {
            if (prevTabStopPosition === -1) return -1;
            // If the direction is left, we need to keep scanning right to ensure
            // that targetVisibleColumn + tabSize is before non-whitespace.
            // This is so that when we press left at the end of a partial
            // indentation it only goes one character. For example '      foo' with
            // tabSize 4, should jump from position 6 to position 5, not 4.
            let currentVisibleColumn = prevTabStopVisibleColumn;
            for(let i = prevTabStopPosition; i < lineLength; ++i){
                if (currentVisibleColumn === prevTabStopVisibleColumn + tabSize) // It is a full indentation.
                return prevTabStopPosition;
                const chCode = lineContent.charCodeAt(i);
                switch(chCode){
                    case 32 /* CharCode.Space */ :
                        currentVisibleColumn += 1;
                        break;
                    case 9 /* CharCode.Tab */ :
                        currentVisibleColumn = (0, _cursorColumnsJs.CursorColumns).nextRenderTabStop(currentVisibleColumn, tabSize);
                        break;
                    default:
                        return -1;
                }
            }
            if (currentVisibleColumn === prevTabStopVisibleColumn + tabSize) return prevTabStopPosition;
            // It must have been a partial indentation.
            return -1;
        }
        // We are going right.
        const targetVisibleColumn = (0, _cursorColumnsJs.CursorColumns).nextRenderTabStop(visibleColumn, tabSize);
        // We can just continue from where whitespaceVisibleColumn got to.
        let currentVisibleColumn = visibleColumn;
        for(let i = position; i < lineLength; i++){
            if (currentVisibleColumn === targetVisibleColumn) return i;
            const chCode = lineContent.charCodeAt(i);
            switch(chCode){
                case 32 /* CharCode.Space */ :
                    currentVisibleColumn += 1;
                    break;
                case 9 /* CharCode.Tab */ :
                    currentVisibleColumn = (0, _cursorColumnsJs.CursorColumns).nextRenderTabStop(currentVisibleColumn, tabSize);
                    break;
                default:
                    return -1;
            }
        }
        // This condition handles when the target column is at the end of the line.
        if (currentVisibleColumn === targetVisibleColumn) return lineLength;
        return -1;
    }
}

},{"../core/cursorColumns.js":"idX7D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"618Ru":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Currently only tested on iOS 13/ iPadOS.
 */ parcelHelpers.export(exports, "PointerEventHandler", ()=>PointerEventHandler);
parcelHelpers.export(exports, "PointerHandler", ()=>PointerHandler);
var _canIUseJs = require("../../../base/browser/canIUse.js");
var _domJs = require("../../../base/browser/dom.js");
var _touchJs = require("../../../base/browser/touch.js");
var _windowJs = require("../../../base/browser/window.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _platformJs = require("../../../base/common/platform.js");
var _mouseHandlerJs = require("./mouseHandler.js");
var _textAreaInputJs = require("./textAreaInput.js");
var _editorDomJs = require("../editorDom.js");
class PointerEventHandler extends (0, _mouseHandlerJs.MouseHandler) {
    constructor(context, viewController, viewHelper){
        super(context, viewController, viewHelper);
        this._register((0, _touchJs.Gesture).addTarget(this.viewHelper.linesContentDomNode));
        this._register(_domJs.addDisposableListener(this.viewHelper.linesContentDomNode, (0, _touchJs.EventType).Tap, (e)=>this.onTap(e)));
        this._register(_domJs.addDisposableListener(this.viewHelper.linesContentDomNode, (0, _touchJs.EventType).Change, (e)=>this.onChange(e)));
        this._register(_domJs.addDisposableListener(this.viewHelper.linesContentDomNode, (0, _touchJs.EventType).Contextmenu, (e)=>this._onContextMenu(new (0, _editorDomJs.EditorMouseEvent)(e, false, this.viewHelper.viewDomNode), false)));
        this._lastPointerType = "mouse";
        this._register(_domJs.addDisposableListener(this.viewHelper.linesContentDomNode, "pointerdown", (e)=>{
            const pointerType = e.pointerType;
            if (pointerType === "mouse") {
                this._lastPointerType = "mouse";
                return;
            } else if (pointerType === "touch") this._lastPointerType = "touch";
            else this._lastPointerType = "pen";
        }));
        // PonterEvents
        const pointerEvents = new (0, _editorDomJs.EditorPointerEventFactory)(this.viewHelper.viewDomNode);
        this._register(pointerEvents.onPointerMove(this.viewHelper.viewDomNode, (e)=>this._onMouseMove(e)));
        this._register(pointerEvents.onPointerUp(this.viewHelper.viewDomNode, (e)=>this._onMouseUp(e)));
        this._register(pointerEvents.onPointerLeave(this.viewHelper.viewDomNode, (e)=>this._onMouseLeave(e)));
        this._register(pointerEvents.onPointerDown(this.viewHelper.viewDomNode, (e, pointerId)=>this._onMouseDown(e, pointerId)));
    }
    onTap(event) {
        if (!event.initialTarget || !this.viewHelper.linesContentDomNode.contains(event.initialTarget)) return;
        event.preventDefault();
        this.viewHelper.focusTextArea();
        this._dispatchGesture(event, /*inSelectionMode*/ false);
    }
    onChange(event) {
        if (this._lastPointerType === "touch") this._context.viewModel.viewLayout.deltaScrollNow(-event.translationX, -event.translationY);
        if (this._lastPointerType === "pen") this._dispatchGesture(event, /*inSelectionMode*/ true);
    }
    _dispatchGesture(event, inSelectionMode) {
        const target = this._createMouseTarget(new (0, _editorDomJs.EditorMouseEvent)(event, false, this.viewHelper.viewDomNode), false);
        if (target.position) this.viewController.dispatchMouse({
            position: target.position,
            mouseColumn: target.position.column,
            startedOnLineNumbers: false,
            revealType: 1 /* NavigationCommandRevealType.Minimal */ ,
            mouseDownCount: event.tapCount,
            inSelectionMode,
            altKey: false,
            ctrlKey: false,
            metaKey: false,
            shiftKey: false,
            leftButton: false,
            middleButton: false,
            onInjectedText: target.type === 6 /* MouseTargetType.CONTENT_TEXT */  && target.detail.injectedText !== null
        });
    }
    _onMouseDown(e, pointerId) {
        if (e.browserEvent.pointerType === "touch") return;
        super._onMouseDown(e, pointerId);
    }
}
class TouchHandler extends (0, _mouseHandlerJs.MouseHandler) {
    constructor(context, viewController, viewHelper){
        super(context, viewController, viewHelper);
        this._register((0, _touchJs.Gesture).addTarget(this.viewHelper.linesContentDomNode));
        this._register(_domJs.addDisposableListener(this.viewHelper.linesContentDomNode, (0, _touchJs.EventType).Tap, (e)=>this.onTap(e)));
        this._register(_domJs.addDisposableListener(this.viewHelper.linesContentDomNode, (0, _touchJs.EventType).Change, (e)=>this.onChange(e)));
        this._register(_domJs.addDisposableListener(this.viewHelper.linesContentDomNode, (0, _touchJs.EventType).Contextmenu, (e)=>this._onContextMenu(new (0, _editorDomJs.EditorMouseEvent)(e, false, this.viewHelper.viewDomNode), false)));
    }
    onTap(event) {
        event.preventDefault();
        this.viewHelper.focusTextArea();
        const target = this._createMouseTarget(new (0, _editorDomJs.EditorMouseEvent)(event, false, this.viewHelper.viewDomNode), false);
        if (target.position) {
            // Send the tap event also to the <textarea> (for input purposes)
            const event = document.createEvent("CustomEvent");
            event.initEvent((0, _textAreaInputJs.TextAreaSyntethicEvents).Tap, false, true);
            this.viewHelper.dispatchTextAreaEvent(event);
            this.viewController.moveTo(target.position, 1 /* NavigationCommandRevealType.Minimal */ );
        }
    }
    onChange(e) {
        this._context.viewModel.viewLayout.deltaScrollNow(-e.translationX, -e.translationY);
    }
}
class PointerHandler extends (0, _lifecycleJs.Disposable) {
    constructor(context, viewController, viewHelper){
        super();
        const isPhone = _platformJs.isIOS || _platformJs.isAndroid && _platformJs.isMobile;
        if (isPhone && (0, _canIUseJs.BrowserFeatures).pointerEvents) this.handler = this._register(new PointerEventHandler(context, viewController, viewHelper));
        else if ((0, _windowJs.mainWindow).TouchEvent) this.handler = this._register(new TouchHandler(context, viewController, viewHelper));
        else this.handler = this._register(new (0, _mouseHandlerJs.MouseHandler)(context, viewController, viewHelper));
    }
    getTargetAtClientPoint(clientX, clientY) {
        return this.handler.getTargetAtClientPoint(clientX, clientY);
    }
}

},{"../../../base/browser/canIUse.js":"h5HmQ","../../../base/browser/dom.js":"bnqsM","../../../base/browser/touch.js":"6iGQn","../../../base/browser/window.js":"aJBhQ","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/platform.js":"7maJO","./mouseHandler.js":"Q4kdN","./textAreaInput.js":"d7Bw3","../editorDom.js":"8EVOq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Q4kdN":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MouseHandler", ()=>MouseHandler);
var _domJs = require("../../../base/browser/dom.js");
var _mouseEventJs = require("../../../base/browser/mouseEvent.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _platformJs = require("../../../base/common/platform.js");
var _mouseTargetJs = require("./mouseTarget.js");
var _editorDomJs = require("../editorDom.js");
var _editorZoomJs = require("../../common/config/editorZoom.js");
var _positionJs = require("../../common/core/position.js");
var _selectionJs = require("../../common/core/selection.js");
var _viewEventHandlerJs = require("../../common/viewEventHandler.js");
var _scrollableElementJs = require("../../../base/browser/ui/scrollbar/scrollableElement.js");
class MouseHandler extends (0, _viewEventHandlerJs.ViewEventHandler) {
    constructor(context, viewController, viewHelper){
        super();
        this._mouseLeaveMonitor = null;
        this._context = context;
        this.viewController = viewController;
        this.viewHelper = viewHelper;
        this.mouseTargetFactory = new (0, _mouseTargetJs.MouseTargetFactory)(this._context, viewHelper);
        this._mouseDownOperation = this._register(new MouseDownOperation(this._context, this.viewController, this.viewHelper, this.mouseTargetFactory, (e, testEventTarget)=>this._createMouseTarget(e, testEventTarget), (e)=>this._getMouseColumn(e)));
        this.lastMouseLeaveTime = -1;
        this._height = this._context.configuration.options.get(146 /* EditorOption.layoutInfo */ ).height;
        const mouseEvents = new (0, _editorDomJs.EditorMouseEventFactory)(this.viewHelper.viewDomNode);
        this._register(mouseEvents.onContextMenu(this.viewHelper.viewDomNode, (e)=>this._onContextMenu(e, true)));
        this._register(mouseEvents.onMouseMove(this.viewHelper.viewDomNode, (e)=>{
            this._onMouseMove(e);
            // See https://github.com/microsoft/vscode/issues/138789
            // When moving the mouse really quickly, the browser sometimes forgets to
            // send us a `mouseleave` or `mouseout` event. We therefore install here
            // a global `mousemove` listener to manually recover if the mouse goes outside
            // the editor. As soon as the mouse leaves outside of the editor, we
            // remove this listener
            if (!this._mouseLeaveMonitor) this._mouseLeaveMonitor = _domJs.addDisposableListener(this.viewHelper.viewDomNode.ownerDocument, "mousemove", (e)=>{
                if (!this.viewHelper.viewDomNode.contains(e.target)) // went outside the editor!
                this._onMouseLeave(new (0, _editorDomJs.EditorMouseEvent)(e, false, this.viewHelper.viewDomNode));
            });
        }));
        this._register(mouseEvents.onMouseUp(this.viewHelper.viewDomNode, (e)=>this._onMouseUp(e)));
        this._register(mouseEvents.onMouseLeave(this.viewHelper.viewDomNode, (e)=>this._onMouseLeave(e)));
        // `pointerdown` events can't be used to determine if there's a double click, or triple click
        // because their `e.detail` is always 0.
        // We will therefore save the pointer id for the mouse and then reuse it in the `mousedown` event
        // for `element.setPointerCapture`.
        let capturePointerId = 0;
        this._register(mouseEvents.onPointerDown(this.viewHelper.viewDomNode, (e, pointerId)=>{
            capturePointerId = pointerId;
        }));
        // The `pointerup` listener registered by `GlobalEditorPointerMoveMonitor` does not get invoked 100% of the times.
        // I speculate that this is because the `pointerup` listener is only registered during the `mousedown` event, and perhaps
        // the `pointerup` event is already queued for dispatching, which makes it that the new listener doesn't get fired.
        // See https://github.com/microsoft/vscode/issues/146486 for repro steps.
        // To compensate for that, we simply register here a `pointerup` listener and just communicate it.
        this._register(_domJs.addDisposableListener(this.viewHelper.viewDomNode, _domJs.EventType.POINTER_UP, (e)=>{
            this._mouseDownOperation.onPointerUp();
        }));
        this._register(mouseEvents.onMouseDown(this.viewHelper.viewDomNode, (e)=>this._onMouseDown(e, capturePointerId)));
        this._setupMouseWheelZoomListener();
        this._context.addEventHandler(this);
    }
    _setupMouseWheelZoomListener() {
        const classifier = (0, _scrollableElementJs.MouseWheelClassifier).INSTANCE;
        let prevMouseWheelTime = 0;
        let gestureStartZoomLevel = (0, _editorZoomJs.EditorZoom).getZoomLevel();
        let gestureHasZoomModifiers = false;
        let gestureAccumulatedDelta = 0;
        const onMouseWheel = (browserEvent)=>{
            this.viewController.emitMouseWheel(browserEvent);
            if (!this._context.configuration.options.get(76 /* EditorOption.mouseWheelZoom */ )) return;
            const e = new (0, _mouseEventJs.StandardWheelEvent)(browserEvent);
            classifier.acceptStandardWheelEvent(e);
            if (classifier.isPhysicalMouseWheel()) {
                if (hasMouseWheelZoomModifiers(browserEvent)) {
                    const zoomLevel = (0, _editorZoomJs.EditorZoom).getZoomLevel();
                    const delta = e.deltaY > 0 ? 1 : -1;
                    (0, _editorZoomJs.EditorZoom).setZoomLevel(zoomLevel + delta);
                    e.preventDefault();
                    e.stopPropagation();
                }
            } else {
                // we consider mousewheel events that occur within 50ms of each other to be part of the same gesture
                // we don't want to consider mouse wheel events where ctrl/cmd is pressed during the inertia phase
                // we also want to accumulate deltaY values from the same gesture and use that to set the zoom level
                if (Date.now() - prevMouseWheelTime > 50) {
                    // reset if more than 50ms have passed
                    gestureStartZoomLevel = (0, _editorZoomJs.EditorZoom).getZoomLevel();
                    gestureHasZoomModifiers = hasMouseWheelZoomModifiers(browserEvent);
                    gestureAccumulatedDelta = 0;
                }
                prevMouseWheelTime = Date.now();
                gestureAccumulatedDelta += e.deltaY;
                if (gestureHasZoomModifiers) {
                    (0, _editorZoomJs.EditorZoom).setZoomLevel(gestureStartZoomLevel + gestureAccumulatedDelta / 5);
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        };
        this._register(_domJs.addDisposableListener(this.viewHelper.viewDomNode, _domJs.EventType.MOUSE_WHEEL, onMouseWheel, {
            capture: true,
            passive: false
        }));
        function hasMouseWheelZoomModifiers(browserEvent) {
            return _platformJs.isMacintosh ? (browserEvent.metaKey || browserEvent.ctrlKey) && !browserEvent.shiftKey && !browserEvent.altKey : browserEvent.ctrlKey && !browserEvent.metaKey && !browserEvent.shiftKey && !browserEvent.altKey;
        }
    }
    dispose() {
        this._context.removeEventHandler(this);
        if (this._mouseLeaveMonitor) {
            this._mouseLeaveMonitor.dispose();
            this._mouseLeaveMonitor = null;
        }
        super.dispose();
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        if (e.hasChanged(146 /* EditorOption.layoutInfo */ )) {
            // layout change
            const height = this._context.configuration.options.get(146 /* EditorOption.layoutInfo */ ).height;
            if (this._height !== height) {
                this._height = height;
                this._mouseDownOperation.onHeightChanged();
            }
        }
        return false;
    }
    onCursorStateChanged(e) {
        this._mouseDownOperation.onCursorStateChanged(e);
        return false;
    }
    onFocusChanged(e) {
        return false;
    }
    // --- end event handlers
    getTargetAtClientPoint(clientX, clientY) {
        const clientPos = new (0, _editorDomJs.ClientCoordinates)(clientX, clientY);
        const pos = clientPos.toPageCoordinates(_domJs.getWindow(this.viewHelper.viewDomNode));
        const editorPos = (0, _editorDomJs.createEditorPagePosition)(this.viewHelper.viewDomNode);
        if (pos.y < editorPos.y || pos.y > editorPos.y + editorPos.height || pos.x < editorPos.x || pos.x > editorPos.x + editorPos.width) return null;
        const relativePos = (0, _editorDomJs.createCoordinatesRelativeToEditor)(this.viewHelper.viewDomNode, editorPos, pos);
        return this.mouseTargetFactory.createMouseTarget(this.viewHelper.getLastRenderData(), editorPos, pos, relativePos, null);
    }
    _createMouseTarget(e, testEventTarget) {
        let target = e.target;
        if (!this.viewHelper.viewDomNode.contains(target)) {
            const shadowRoot = _domJs.getShadowRoot(this.viewHelper.viewDomNode);
            if (shadowRoot) target = shadowRoot.elementsFromPoint(e.posx, e.posy).find((el)=>this.viewHelper.viewDomNode.contains(el));
        }
        return this.mouseTargetFactory.createMouseTarget(this.viewHelper.getLastRenderData(), e.editorPos, e.pos, e.relativePos, testEventTarget ? target : null);
    }
    _getMouseColumn(e) {
        return this.mouseTargetFactory.getMouseColumn(e.relativePos);
    }
    _onContextMenu(e, testEventTarget) {
        this.viewController.emitContextMenu({
            event: e,
            target: this._createMouseTarget(e, testEventTarget)
        });
    }
    _onMouseMove(e) {
        const targetIsWidget = this.mouseTargetFactory.mouseTargetIsWidget(e);
        if (!targetIsWidget) e.preventDefault();
        if (this._mouseDownOperation.isActive()) // In selection/drag operation
        return;
        const actualMouseMoveTime = e.timestamp;
        if (actualMouseMoveTime < this.lastMouseLeaveTime) // Due to throttling, this event occurred before the mouse left the editor, therefore ignore it.
        return;
        this.viewController.emitMouseMove({
            event: e,
            target: this._createMouseTarget(e, true)
        });
    }
    _onMouseLeave(e) {
        if (this._mouseLeaveMonitor) {
            this._mouseLeaveMonitor.dispose();
            this._mouseLeaveMonitor = null;
        }
        this.lastMouseLeaveTime = new Date().getTime();
        this.viewController.emitMouseLeave({
            event: e,
            target: null
        });
    }
    _onMouseUp(e) {
        this.viewController.emitMouseUp({
            event: e,
            target: this._createMouseTarget(e, true)
        });
    }
    _onMouseDown(e, pointerId) {
        const t = this._createMouseTarget(e, true);
        const targetIsContent = t.type === 6 /* MouseTargetType.CONTENT_TEXT */  || t.type === 7 /* MouseTargetType.CONTENT_EMPTY */ ;
        const targetIsGutter = t.type === 2 /* MouseTargetType.GUTTER_GLYPH_MARGIN */  || t.type === 3 /* MouseTargetType.GUTTER_LINE_NUMBERS */  || t.type === 4 /* MouseTargetType.GUTTER_LINE_DECORATIONS */ ;
        const targetIsLineNumbers = t.type === 3 /* MouseTargetType.GUTTER_LINE_NUMBERS */ ;
        const selectOnLineNumbers = this._context.configuration.options.get(110 /* EditorOption.selectOnLineNumbers */ );
        const targetIsViewZone = t.type === 8 /* MouseTargetType.CONTENT_VIEW_ZONE */  || t.type === 5 /* MouseTargetType.GUTTER_VIEW_ZONE */ ;
        const targetIsWidget = t.type === 9 /* MouseTargetType.CONTENT_WIDGET */ ;
        let shouldHandle = e.leftButton || e.middleButton;
        if (_platformJs.isMacintosh && e.leftButton && e.ctrlKey) shouldHandle = false;
        const focus = ()=>{
            e.preventDefault();
            this.viewHelper.focusTextArea();
        };
        if (shouldHandle && (targetIsContent || targetIsLineNumbers && selectOnLineNumbers)) {
            focus();
            this._mouseDownOperation.start(t.type, e, pointerId);
        } else if (targetIsGutter) // Do not steal focus
        e.preventDefault();
        else if (targetIsViewZone) {
            const viewZoneData = t.detail;
            if (shouldHandle && this.viewHelper.shouldSuppressMouseDownOnViewZone(viewZoneData.viewZoneId)) {
                focus();
                this._mouseDownOperation.start(t.type, e, pointerId);
                e.preventDefault();
            }
        } else if (targetIsWidget && this.viewHelper.shouldSuppressMouseDownOnWidget(t.detail)) {
            focus();
            e.preventDefault();
        }
        this.viewController.emitMouseDown({
            event: e,
            target: t
        });
    }
}
class MouseDownOperation extends (0, _lifecycleJs.Disposable) {
    constructor(_context, _viewController, _viewHelper, _mouseTargetFactory, createMouseTarget, getMouseColumn){
        super();
        this._context = _context;
        this._viewController = _viewController;
        this._viewHelper = _viewHelper;
        this._mouseTargetFactory = _mouseTargetFactory;
        this._createMouseTarget = createMouseTarget;
        this._getMouseColumn = getMouseColumn;
        this._mouseMoveMonitor = this._register(new (0, _editorDomJs.GlobalEditorPointerMoveMonitor)(this._viewHelper.viewDomNode));
        this._topBottomDragScrolling = this._register(new TopBottomDragScrolling(this._context, this._viewHelper, this._mouseTargetFactory, (position, inSelectionMode, revealType)=>this._dispatchMouse(position, inSelectionMode, revealType)));
        this._mouseState = new MouseDownState();
        this._currentSelection = new (0, _selectionJs.Selection)(1, 1, 1, 1);
        this._isActive = false;
        this._lastMouseEvent = null;
    }
    dispose() {
        super.dispose();
    }
    isActive() {
        return this._isActive;
    }
    _onMouseDownThenMove(e) {
        this._lastMouseEvent = e;
        this._mouseState.setModifiers(e);
        const position = this._findMousePosition(e, false);
        if (!position) // Ignoring because position is unknown
        return;
        if (this._mouseState.isDragAndDrop) this._viewController.emitMouseDrag({
            event: e,
            target: position
        });
        else if (position.type === 13 /* MouseTargetType.OUTSIDE_EDITOR */  && (position.outsidePosition === "above" || position.outsidePosition === "below")) this._topBottomDragScrolling.start(position, e);
        else {
            this._topBottomDragScrolling.stop();
            this._dispatchMouse(position, true, 1 /* NavigationCommandRevealType.Minimal */ );
        }
    }
    start(targetType, e, pointerId) {
        this._lastMouseEvent = e;
        this._mouseState.setStartedOnLineNumbers(targetType === 3 /* MouseTargetType.GUTTER_LINE_NUMBERS */ );
        this._mouseState.setStartButtons(e);
        this._mouseState.setModifiers(e);
        const position = this._findMousePosition(e, true);
        if (!position || !position.position) // Ignoring because position is unknown
        return;
        this._mouseState.trySetCount(e.detail, position.position);
        // Overwrite the detail of the MouseEvent, as it will be sent out in an event and contributions might rely on it.
        e.detail = this._mouseState.count;
        const options = this._context.configuration.options;
        if (!options.get(92 /* EditorOption.readOnly */ ) && options.get(35 /* EditorOption.dragAndDrop */ ) && !options.get(22 /* EditorOption.columnSelection */ ) && !this._mouseState.altKey // we don't support multiple mouse
         && e.detail < 2 // only single click on a selection can work
         && !this._isActive // the mouse is not down yet
         && !this._currentSelection.isEmpty() // we don't drag single cursor
         && position.type === 6 /* MouseTargetType.CONTENT_TEXT */  // single click on text
         && position.position && this._currentSelection.containsPosition(position.position) // single click on a selection
        ) {
            this._mouseState.isDragAndDrop = true;
            this._isActive = true;
            this._mouseMoveMonitor.startMonitoring(this._viewHelper.viewLinesDomNode, pointerId, e.buttons, (e)=>this._onMouseDownThenMove(e), (browserEvent)=>{
                const position = this._findMousePosition(this._lastMouseEvent, false);
                if (_domJs.isKeyboardEvent(browserEvent)) // cancel
                this._viewController.emitMouseDropCanceled();
                else this._viewController.emitMouseDrop({
                    event: this._lastMouseEvent,
                    target: position ? this._createMouseTarget(this._lastMouseEvent, true) : null // Ignoring because position is unknown, e.g., Content View Zone
                });
                this._stop();
            });
            return;
        }
        this._mouseState.isDragAndDrop = false;
        this._dispatchMouse(position, e.shiftKey, 1 /* NavigationCommandRevealType.Minimal */ );
        if (!this._isActive) {
            this._isActive = true;
            this._mouseMoveMonitor.startMonitoring(this._viewHelper.viewLinesDomNode, pointerId, e.buttons, (e)=>this._onMouseDownThenMove(e), ()=>this._stop());
        }
    }
    _stop() {
        this._isActive = false;
        this._topBottomDragScrolling.stop();
    }
    onHeightChanged() {
        this._mouseMoveMonitor.stopMonitoring();
    }
    onPointerUp() {
        this._mouseMoveMonitor.stopMonitoring();
    }
    onCursorStateChanged(e) {
        this._currentSelection = e.selections[0];
    }
    _getPositionOutsideEditor(e) {
        const editorContent = e.editorPos;
        const model = this._context.viewModel;
        const viewLayout = this._context.viewLayout;
        const mouseColumn = this._getMouseColumn(e);
        if (e.posy < editorContent.y) {
            const outsideDistance = editorContent.y - e.posy;
            const verticalOffset = Math.max(viewLayout.getCurrentScrollTop() - outsideDistance, 0);
            const viewZoneData = (0, _mouseTargetJs.HitTestContext).getZoneAtCoord(this._context, verticalOffset);
            if (viewZoneData) {
                const newPosition = this._helpPositionJumpOverViewZone(viewZoneData);
                if (newPosition) return (0, _mouseTargetJs.MouseTarget).createOutsideEditor(mouseColumn, newPosition, "above", outsideDistance);
            }
            const aboveLineNumber = viewLayout.getLineNumberAtVerticalOffset(verticalOffset);
            return (0, _mouseTargetJs.MouseTarget).createOutsideEditor(mouseColumn, new (0, _positionJs.Position)(aboveLineNumber, 1), "above", outsideDistance);
        }
        if (e.posy > editorContent.y + editorContent.height) {
            const outsideDistance = e.posy - editorContent.y - editorContent.height;
            const verticalOffset = viewLayout.getCurrentScrollTop() + e.relativePos.y;
            const viewZoneData = (0, _mouseTargetJs.HitTestContext).getZoneAtCoord(this._context, verticalOffset);
            if (viewZoneData) {
                const newPosition = this._helpPositionJumpOverViewZone(viewZoneData);
                if (newPosition) return (0, _mouseTargetJs.MouseTarget).createOutsideEditor(mouseColumn, newPosition, "below", outsideDistance);
            }
            const belowLineNumber = viewLayout.getLineNumberAtVerticalOffset(verticalOffset);
            return (0, _mouseTargetJs.MouseTarget).createOutsideEditor(mouseColumn, new (0, _positionJs.Position)(belowLineNumber, model.getLineMaxColumn(belowLineNumber)), "below", outsideDistance);
        }
        const possibleLineNumber = viewLayout.getLineNumberAtVerticalOffset(viewLayout.getCurrentScrollTop() + e.relativePos.y);
        if (e.posx < editorContent.x) {
            const outsideDistance = editorContent.x - e.posx;
            return (0, _mouseTargetJs.MouseTarget).createOutsideEditor(mouseColumn, new (0, _positionJs.Position)(possibleLineNumber, 1), "left", outsideDistance);
        }
        if (e.posx > editorContent.x + editorContent.width) {
            const outsideDistance = e.posx - editorContent.x - editorContent.width;
            return (0, _mouseTargetJs.MouseTarget).createOutsideEditor(mouseColumn, new (0, _positionJs.Position)(possibleLineNumber, model.getLineMaxColumn(possibleLineNumber)), "right", outsideDistance);
        }
        return null;
    }
    _findMousePosition(e, testEventTarget) {
        const positionOutsideEditor = this._getPositionOutsideEditor(e);
        if (positionOutsideEditor) return positionOutsideEditor;
        const t = this._createMouseTarget(e, testEventTarget);
        const hintedPosition = t.position;
        if (!hintedPosition) return null;
        if (t.type === 8 /* MouseTargetType.CONTENT_VIEW_ZONE */  || t.type === 5 /* MouseTargetType.GUTTER_VIEW_ZONE */ ) {
            const newPosition = this._helpPositionJumpOverViewZone(t.detail);
            if (newPosition) return (0, _mouseTargetJs.MouseTarget).createViewZone(t.type, t.element, t.mouseColumn, newPosition, t.detail);
        }
        return t;
    }
    _helpPositionJumpOverViewZone(viewZoneData) {
        // Force position on view zones to go above or below depending on where selection started from
        const selectionStart = new (0, _positionJs.Position)(this._currentSelection.selectionStartLineNumber, this._currentSelection.selectionStartColumn);
        const positionBefore = viewZoneData.positionBefore;
        const positionAfter = viewZoneData.positionAfter;
        if (positionBefore && positionAfter) {
            if (positionBefore.isBefore(selectionStart)) return positionBefore;
            else return positionAfter;
        }
        return null;
    }
    _dispatchMouse(position, inSelectionMode, revealType) {
        if (!position.position) return;
        this._viewController.dispatchMouse({
            position: position.position,
            mouseColumn: position.mouseColumn,
            startedOnLineNumbers: this._mouseState.startedOnLineNumbers,
            revealType,
            inSelectionMode: inSelectionMode,
            mouseDownCount: this._mouseState.count,
            altKey: this._mouseState.altKey,
            ctrlKey: this._mouseState.ctrlKey,
            metaKey: this._mouseState.metaKey,
            shiftKey: this._mouseState.shiftKey,
            leftButton: this._mouseState.leftButton,
            middleButton: this._mouseState.middleButton,
            onInjectedText: position.type === 6 /* MouseTargetType.CONTENT_TEXT */  && position.detail.injectedText !== null
        });
    }
}
class TopBottomDragScrolling extends (0, _lifecycleJs.Disposable) {
    constructor(_context, _viewHelper, _mouseTargetFactory, _dispatchMouse){
        super();
        this._context = _context;
        this._viewHelper = _viewHelper;
        this._mouseTargetFactory = _mouseTargetFactory;
        this._dispatchMouse = _dispatchMouse;
        this._operation = null;
    }
    dispose() {
        super.dispose();
        this.stop();
    }
    start(position, mouseEvent) {
        if (this._operation) this._operation.setPosition(position, mouseEvent);
        else this._operation = new TopBottomDragScrollingOperation(this._context, this._viewHelper, this._mouseTargetFactory, this._dispatchMouse, position, mouseEvent);
    }
    stop() {
        if (this._operation) {
            this._operation.dispose();
            this._operation = null;
        }
    }
}
class TopBottomDragScrollingOperation extends (0, _lifecycleJs.Disposable) {
    constructor(_context, _viewHelper, _mouseTargetFactory, _dispatchMouse, position, mouseEvent){
        super();
        this._context = _context;
        this._viewHelper = _viewHelper;
        this._mouseTargetFactory = _mouseTargetFactory;
        this._dispatchMouse = _dispatchMouse;
        this._position = position;
        this._mouseEvent = mouseEvent;
        this._lastTime = Date.now();
        this._animationFrameDisposable = _domJs.scheduleAtNextAnimationFrame(_domJs.getWindow(mouseEvent.browserEvent), ()=>this._execute());
    }
    dispose() {
        this._animationFrameDisposable.dispose();
        super.dispose();
    }
    setPosition(position, mouseEvent) {
        this._position = position;
        this._mouseEvent = mouseEvent;
    }
    /**
     * update internal state and return elapsed ms since last time
     */ _tick() {
        const now = Date.now();
        const elapsed = now - this._lastTime;
        this._lastTime = now;
        return elapsed;
    }
    /**
     * get the number of lines per second to auto-scroll
     */ _getScrollSpeed() {
        const lineHeight = this._context.configuration.options.get(67 /* EditorOption.lineHeight */ );
        const viewportInLines = this._context.configuration.options.get(146 /* EditorOption.layoutInfo */ ).height / lineHeight;
        const outsideDistanceInLines = this._position.outsideDistance / lineHeight;
        if (outsideDistanceInLines <= 1.5) return Math.max(30, viewportInLines * (1 + outsideDistanceInLines));
        if (outsideDistanceInLines <= 3) return Math.max(60, viewportInLines * (2 + outsideDistanceInLines));
        return Math.max(200, viewportInLines * (7 + outsideDistanceInLines));
    }
    _execute() {
        const lineHeight = this._context.configuration.options.get(67 /* EditorOption.lineHeight */ );
        const scrollSpeedInLines = this._getScrollSpeed();
        const elapsed = this._tick();
        const scrollInPixels = scrollSpeedInLines * (elapsed / 1000) * lineHeight;
        const scrollValue = this._position.outsidePosition === "above" ? -scrollInPixels : scrollInPixels;
        this._context.viewModel.viewLayout.deltaScrollNow(0, scrollValue);
        this._viewHelper.renderNow();
        const viewportData = this._context.viewLayout.getLinesViewportData();
        const edgeLineNumber = this._position.outsidePosition === "above" ? viewportData.startLineNumber : viewportData.endLineNumber;
        // First, try to find a position that matches the horizontal position of the mouse
        let mouseTarget;
        {
            const editorPos = (0, _editorDomJs.createEditorPagePosition)(this._viewHelper.viewDomNode);
            const horizontalScrollbarHeight = this._context.configuration.options.get(146 /* EditorOption.layoutInfo */ ).horizontalScrollbarHeight;
            const pos = new (0, _editorDomJs.PageCoordinates)(this._mouseEvent.pos.x, editorPos.y + editorPos.height - horizontalScrollbarHeight - 0.1);
            const relativePos = (0, _editorDomJs.createCoordinatesRelativeToEditor)(this._viewHelper.viewDomNode, editorPos, pos);
            mouseTarget = this._mouseTargetFactory.createMouseTarget(this._viewHelper.getLastRenderData(), editorPos, pos, relativePos, null);
        }
        if (!mouseTarget.position || mouseTarget.position.lineNumber !== edgeLineNumber) {
            if (this._position.outsidePosition === "above") mouseTarget = (0, _mouseTargetJs.MouseTarget).createOutsideEditor(this._position.mouseColumn, new (0, _positionJs.Position)(edgeLineNumber, 1), "above", this._position.outsideDistance);
            else mouseTarget = (0, _mouseTargetJs.MouseTarget).createOutsideEditor(this._position.mouseColumn, new (0, _positionJs.Position)(edgeLineNumber, this._context.viewModel.getLineMaxColumn(edgeLineNumber)), "below", this._position.outsideDistance);
        }
        this._dispatchMouse(mouseTarget, true, 2 /* NavigationCommandRevealType.None */ );
        this._animationFrameDisposable = _domJs.scheduleAtNextAnimationFrame(_domJs.getWindow(mouseTarget.element), ()=>this._execute());
    }
}
class MouseDownState {
    static{
        this.CLEAR_MOUSE_DOWN_COUNT_TIME = 400;
    }
    get altKey() {
        return this._altKey;
    }
    get ctrlKey() {
        return this._ctrlKey;
    }
    get metaKey() {
        return this._metaKey;
    }
    get shiftKey() {
        return this._shiftKey;
    }
    get leftButton() {
        return this._leftButton;
    }
    get middleButton() {
        return this._middleButton;
    }
    get startedOnLineNumbers() {
        return this._startedOnLineNumbers;
    }
    constructor(){
        this._altKey = false;
        this._ctrlKey = false;
        this._metaKey = false;
        this._shiftKey = false;
        this._leftButton = false;
        this._middleButton = false;
        this._startedOnLineNumbers = false;
        this._lastMouseDownPosition = null;
        this._lastMouseDownPositionEqualCount = 0;
        this._lastMouseDownCount = 0;
        this._lastSetMouseDownCountTime = 0;
        this.isDragAndDrop = false;
    }
    get count() {
        return this._lastMouseDownCount;
    }
    setModifiers(source) {
        this._altKey = source.altKey;
        this._ctrlKey = source.ctrlKey;
        this._metaKey = source.metaKey;
        this._shiftKey = source.shiftKey;
    }
    setStartButtons(source) {
        this._leftButton = source.leftButton;
        this._middleButton = source.middleButton;
    }
    setStartedOnLineNumbers(startedOnLineNumbers) {
        this._startedOnLineNumbers = startedOnLineNumbers;
    }
    trySetCount(setMouseDownCount, newMouseDownPosition) {
        // a. Invalidate multiple clicking if too much time has passed (will be hit by IE because the detail field of mouse events contains garbage in IE10)
        const currentTime = new Date().getTime();
        if (currentTime - this._lastSetMouseDownCountTime > MouseDownState.CLEAR_MOUSE_DOWN_COUNT_TIME) setMouseDownCount = 1;
        this._lastSetMouseDownCountTime = currentTime;
        // b. Ensure that we don't jump from single click to triple click in one go (will be hit by IE because the detail field of mouse events contains garbage in IE10)
        if (setMouseDownCount > this._lastMouseDownCount + 1) setMouseDownCount = this._lastMouseDownCount + 1;
        // c. Invalidate multiple clicking if the logical position is different
        if (this._lastMouseDownPosition && this._lastMouseDownPosition.equals(newMouseDownPosition)) this._lastMouseDownPositionEqualCount++;
        else this._lastMouseDownPositionEqualCount = 1;
        this._lastMouseDownPosition = newMouseDownPosition;
        // Finally set the lastMouseDownCount
        this._lastMouseDownCount = Math.min(setMouseDownCount, this._lastMouseDownPositionEqualCount);
    }
}

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/mouseEvent.js":"4jTdu","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/platform.js":"7maJO","./mouseTarget.js":"eaOsC","../editorDom.js":"8EVOq","../../common/config/editorZoom.js":"7PVxj","../../common/core/position.js":"lvrPe","../../common/core/selection.js":"kcwzU","../../common/viewEventHandler.js":"9pYyF","../../../base/browser/ui/scrollbar/scrollableElement.js":"h1C5l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d7Bw3":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextAreaSyntethicEvents", ()=>TextAreaSyntethicEvents);
parcelHelpers.export(exports, "CopyOptions", ()=>CopyOptions);
/**
 * Every time we write to the clipboard, we record a bit of extra metadata here.
 * Every time we read from the cipboard, if the text matches our last written text,
 * we can fetch the previous metadata.
 */ parcelHelpers.export(exports, "InMemoryClipboardMetadataManager", ()=>InMemoryClipboardMetadataManager);
parcelHelpers.export(exports, "TextAreaInput", ()=>TextAreaInput);
parcelHelpers.export(exports, "ClipboardEventUtils", ()=>ClipboardEventUtils);
parcelHelpers.export(exports, "TextAreaWrapper", ()=>TextAreaWrapper);
var _browserJs = require("../../../base/browser/browser.js");
var _domJs = require("../../../base/browser/dom.js");
var _eventJs = require("../../../base/browser/event.js");
var _keyboardEventJs = require("../../../base/browser/keyboardEvent.js");
var _performanceJs = require("../../../base/browser/performance.js");
var _asyncJs = require("../../../base/common/async.js");
var _eventJs1 = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _mimeJs = require("../../../base/common/mime.js");
var _stringsJs = require("../../../base/common/strings.js");
var _textAreaStateJs = require("./textAreaState.js");
var _selectionJs = require("../../common/core/selection.js");
var _accessibilityJs = require("../../../platform/accessibility/common/accessibility.js");
var _logJs = require("../../../platform/log/common/log.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var TextAreaSyntethicEvents;
(function(TextAreaSyntethicEvents) {
    TextAreaSyntethicEvents.Tap = "-monaco-textarea-synthetic-tap";
})(TextAreaSyntethicEvents || (TextAreaSyntethicEvents = {}));
const CopyOptions = {
    forceCopyWithSyntaxHighlighting: false
};
class InMemoryClipboardMetadataManager {
    static{
        this.INSTANCE = new InMemoryClipboardMetadataManager();
    }
    constructor(){
        this._lastState = null;
    }
    set(lastCopiedValue, data) {
        this._lastState = {
            lastCopiedValue,
            data
        };
    }
    get(pastedText) {
        if (this._lastState && this._lastState.lastCopiedValue === pastedText) // match!
        return this._lastState.data;
        this._lastState = null;
        return null;
    }
}
class CompositionContext {
    constructor(){
        this._lastTypeTextLength = 0;
    }
    handleCompositionUpdate(text) {
        text = text || "";
        const typeInput = {
            text: text,
            replacePrevCharCnt: this._lastTypeTextLength,
            replaceNextCharCnt: 0,
            positionDelta: 0
        };
        this._lastTypeTextLength = text.length;
        return typeInput;
    }
}
/**
 * Writes screen reader content to the textarea and is able to analyze its input events to generate:
 *  - onCut
 *  - onPaste
 *  - onType
 *
 * Composition events are generated for presentation purposes (composition input is reflected in onType).
 */ let TextAreaInput = class TextAreaInput extends (0, _lifecycleJs.Disposable) {
    get textAreaState() {
        return this._textAreaState;
    }
    constructor(_host, _textArea, _OS, _browser, _accessibilityService, _logService){
        super();
        this._host = _host;
        this._textArea = _textArea;
        this._OS = _OS;
        this._browser = _browser;
        this._accessibilityService = _accessibilityService;
        this._logService = _logService;
        this._onFocus = this._register(new (0, _eventJs1.Emitter)());
        this.onFocus = this._onFocus.event;
        this._onBlur = this._register(new (0, _eventJs1.Emitter)());
        this.onBlur = this._onBlur.event;
        this._onKeyDown = this._register(new (0, _eventJs1.Emitter)());
        this.onKeyDown = this._onKeyDown.event;
        this._onKeyUp = this._register(new (0, _eventJs1.Emitter)());
        this.onKeyUp = this._onKeyUp.event;
        this._onCut = this._register(new (0, _eventJs1.Emitter)());
        this.onCut = this._onCut.event;
        this._onPaste = this._register(new (0, _eventJs1.Emitter)());
        this.onPaste = this._onPaste.event;
        this._onType = this._register(new (0, _eventJs1.Emitter)());
        this.onType = this._onType.event;
        this._onCompositionStart = this._register(new (0, _eventJs1.Emitter)());
        this.onCompositionStart = this._onCompositionStart.event;
        this._onCompositionUpdate = this._register(new (0, _eventJs1.Emitter)());
        this.onCompositionUpdate = this._onCompositionUpdate.event;
        this._onCompositionEnd = this._register(new (0, _eventJs1.Emitter)());
        this.onCompositionEnd = this._onCompositionEnd.event;
        this._onSelectionChangeRequest = this._register(new (0, _eventJs1.Emitter)());
        this.onSelectionChangeRequest = this._onSelectionChangeRequest.event;
        this._asyncFocusGainWriteScreenReaderContent = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this._asyncTriggerCut = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._onCut.fire(), 0));
        this._textAreaState = (0, _textAreaStateJs.TextAreaState).EMPTY;
        this._selectionChangeListener = null;
        if (this._accessibilityService.isScreenReaderOptimized()) this.writeNativeTextAreaContent("ctor");
        this._register((0, _eventJs1.Event).runAndSubscribe(this._accessibilityService.onDidChangeScreenReaderOptimized, ()=>{
            if (this._accessibilityService.isScreenReaderOptimized() && !this._asyncFocusGainWriteScreenReaderContent.value) this._asyncFocusGainWriteScreenReaderContent.value = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this.writeNativeTextAreaContent("asyncFocusGain"), 0));
            else this._asyncFocusGainWriteScreenReaderContent.clear();
        }));
        this._hasFocus = false;
        this._currentComposition = null;
        let lastKeyDown = null;
        this._register(this._textArea.onKeyDown((_e)=>{
            const e = new (0, _keyboardEventJs.StandardKeyboardEvent)(_e);
            if (e.keyCode === 114 /* KeyCode.KEY_IN_COMPOSITION */  || this._currentComposition && e.keyCode === 1 /* KeyCode.Backspace */ ) // Stop propagation for keyDown events if the IME is processing key input
            e.stopPropagation();
            if (e.equals(9 /* KeyCode.Escape */ )) // Prevent default always for `Esc`, otherwise it will generate a keypress
            // See https://msdn.microsoft.com/en-us/library/ie/ms536939(v=vs.85).aspx
            e.preventDefault();
            lastKeyDown = e;
            this._onKeyDown.fire(e);
        }));
        this._register(this._textArea.onKeyUp((_e)=>{
            const e = new (0, _keyboardEventJs.StandardKeyboardEvent)(_e);
            this._onKeyUp.fire(e);
        }));
        this._register(this._textArea.onCompositionStart((e)=>{
            if (0, _textAreaStateJs._debugComposition) console.log(`[compositionstart]`, e);
            const currentComposition = new CompositionContext();
            if (this._currentComposition) {
                // simply reset the composition context
                this._currentComposition = currentComposition;
                return;
            }
            this._currentComposition = currentComposition;
            if (this._OS === 2 /* OperatingSystem.Macintosh */  && lastKeyDown && lastKeyDown.equals(114 /* KeyCode.KEY_IN_COMPOSITION */ ) && this._textAreaState.selectionStart === this._textAreaState.selectionEnd && this._textAreaState.selectionStart > 0 && this._textAreaState.value.substr(this._textAreaState.selectionStart - 1, 1) === e.data && (lastKeyDown.code === "ArrowRight" || lastKeyDown.code === "ArrowLeft")) {
                // Handling long press case on Chromium/Safari macOS + arrow key => pretend the character was selected
                if (0, _textAreaStateJs._debugComposition) console.log(`[compositionstart] Handling long press case on macOS + arrow key`, e);
                // Pretend the previous character was composed (in order to get it removed by subsequent compositionupdate events)
                currentComposition.handleCompositionUpdate("x");
                this._onCompositionStart.fire({
                    data: e.data
                });
                return;
            }
            if (this._browser.isAndroid) {
                // when tapping on the editor, Android enters composition mode to edit the current word
                // so we cannot clear the textarea on Android and we must pretend the current word was selected
                this._onCompositionStart.fire({
                    data: e.data
                });
                return;
            }
            this._onCompositionStart.fire({
                data: e.data
            });
        }));
        this._register(this._textArea.onCompositionUpdate((e)=>{
            if (0, _textAreaStateJs._debugComposition) console.log(`[compositionupdate]`, e);
            const currentComposition = this._currentComposition;
            if (!currentComposition) // should not be possible to receive a 'compositionupdate' without a 'compositionstart'
            return;
            if (this._browser.isAndroid) {
                // On Android, the data sent with the composition update event is unusable.
                // For example, if the cursor is in the middle of a word like Mic|osoft
                // and Microsoft is chosen from the keyboard's suggestions, the e.data will contain "Microsoft".
                // This is not really usable because it doesn't tell us where the edit began and where it ended.
                const newState = (0, _textAreaStateJs.TextAreaState).readFromTextArea(this._textArea, this._textAreaState);
                const typeInput = (0, _textAreaStateJs.TextAreaState).deduceAndroidCompositionInput(this._textAreaState, newState);
                this._textAreaState = newState;
                this._onType.fire(typeInput);
                this._onCompositionUpdate.fire(e);
                return;
            }
            const typeInput = currentComposition.handleCompositionUpdate(e.data);
            this._textAreaState = (0, _textAreaStateJs.TextAreaState).readFromTextArea(this._textArea, this._textAreaState);
            this._onType.fire(typeInput);
            this._onCompositionUpdate.fire(e);
        }));
        this._register(this._textArea.onCompositionEnd((e)=>{
            if (0, _textAreaStateJs._debugComposition) console.log(`[compositionend]`, e);
            const currentComposition = this._currentComposition;
            if (!currentComposition) // https://github.com/microsoft/monaco-editor/issues/1663
            // On iOS 13.2, Chinese system IME randomly trigger an additional compositionend event with empty data
            return;
            this._currentComposition = null;
            if (this._browser.isAndroid) {
                // On Android, the data sent with the composition update event is unusable.
                // For example, if the cursor is in the middle of a word like Mic|osoft
                // and Microsoft is chosen from the keyboard's suggestions, the e.data will contain "Microsoft".
                // This is not really usable because it doesn't tell us where the edit began and where it ended.
                const newState = (0, _textAreaStateJs.TextAreaState).readFromTextArea(this._textArea, this._textAreaState);
                const typeInput = (0, _textAreaStateJs.TextAreaState).deduceAndroidCompositionInput(this._textAreaState, newState);
                this._textAreaState = newState;
                this._onType.fire(typeInput);
                this._onCompositionEnd.fire();
                return;
            }
            const typeInput = currentComposition.handleCompositionUpdate(e.data);
            this._textAreaState = (0, _textAreaStateJs.TextAreaState).readFromTextArea(this._textArea, this._textAreaState);
            this._onType.fire(typeInput);
            this._onCompositionEnd.fire();
        }));
        this._register(this._textArea.onInput((e)=>{
            if (0, _textAreaStateJs._debugComposition) console.log(`[input]`, e);
            // Pretend here we touched the text area, as the `input` event will most likely
            // result in a `selectionchange` event which we want to ignore
            this._textArea.setIgnoreSelectionChangeTime("received input event");
            if (this._currentComposition) return;
            const newState = (0, _textAreaStateJs.TextAreaState).readFromTextArea(this._textArea, this._textAreaState);
            const typeInput = (0, _textAreaStateJs.TextAreaState).deduceInput(this._textAreaState, newState, /*couldBeEmojiInput*/ this._OS === 2 /* OperatingSystem.Macintosh */ );
            if (typeInput.replacePrevCharCnt === 0 && typeInput.text.length === 1) {
                // one character was typed
                if (_stringsJs.isHighSurrogate(typeInput.text.charCodeAt(0)) || typeInput.text.charCodeAt(0) === 0x7f /* Delete */ ) // Ignore invalid input but keep it around for next time
                return;
            }
            this._textAreaState = newState;
            if (typeInput.text !== "" || typeInput.replacePrevCharCnt !== 0 || typeInput.replaceNextCharCnt !== 0 || typeInput.positionDelta !== 0) this._onType.fire(typeInput);
        }));
        // --- Clipboard operations
        this._register(this._textArea.onCut((e)=>{
            // Pretend here we touched the text area, as the `cut` event will most likely
            // result in a `selectionchange` event which we want to ignore
            this._textArea.setIgnoreSelectionChangeTime("received cut event");
            this._ensureClipboardGetsEditorSelection(e);
            this._asyncTriggerCut.schedule();
        }));
        this._register(this._textArea.onCopy((e)=>{
            this._ensureClipboardGetsEditorSelection(e);
        }));
        this._register(this._textArea.onPaste((e)=>{
            // Pretend here we touched the text area, as the `paste` event will most likely
            // result in a `selectionchange` event which we want to ignore
            this._textArea.setIgnoreSelectionChangeTime("received paste event");
            e.preventDefault();
            if (!e.clipboardData) return;
            let [text, metadata] = ClipboardEventUtils.getTextData(e.clipboardData);
            if (!text) return;
            // try the in-memory store
            metadata = metadata || InMemoryClipboardMetadataManager.INSTANCE.get(text);
            this._onPaste.fire({
                text: text,
                metadata: metadata
            });
        }));
        this._register(this._textArea.onFocus(()=>{
            const hadFocus = this._hasFocus;
            this._setHasFocus(true);
            if (this._accessibilityService.isScreenReaderOptimized() && this._browser.isSafari && !hadFocus && this._hasFocus) {
                // When "tabbing into" the textarea, immediately after dispatching the 'focus' event,
                // Safari will always move the selection at offset 0 in the textarea
                if (!this._asyncFocusGainWriteScreenReaderContent.value) this._asyncFocusGainWriteScreenReaderContent.value = new (0, _asyncJs.RunOnceScheduler)(()=>this.writeNativeTextAreaContent("asyncFocusGain"), 0);
                this._asyncFocusGainWriteScreenReaderContent.value.schedule();
            }
        }));
        this._register(this._textArea.onBlur(()=>{
            if (this._currentComposition) {
                // See https://github.com/microsoft/vscode/issues/112621
                // where compositionend is not triggered when the editor
                // is taken off-dom during a composition
                // Clear the flag to be able to write to the textarea
                this._currentComposition = null;
                // Clear the textarea to avoid an unwanted cursor type
                this.writeNativeTextAreaContent("blurWithoutCompositionEnd");
                // Fire artificial composition end
                this._onCompositionEnd.fire();
            }
            this._setHasFocus(false);
        }));
        this._register(this._textArea.onSyntheticTap(()=>{
            if (this._browser.isAndroid && this._currentComposition) {
                // on Android, tapping does not cancel the current composition, so the
                // textarea is stuck showing the old composition
                // Clear the flag to be able to write to the textarea
                this._currentComposition = null;
                // Clear the textarea to avoid an unwanted cursor type
                this.writeNativeTextAreaContent("tapWithoutCompositionEnd");
                // Fire artificial composition end
                this._onCompositionEnd.fire();
            }
        }));
    }
    _installSelectionChangeListener() {
        // See https://github.com/microsoft/vscode/issues/27216 and https://github.com/microsoft/vscode/issues/98256
        // When using a Braille display, it is possible for users to reposition the
        // system caret. This is reflected in Chrome as a `selectionchange` event.
        //
        // The `selectionchange` event appears to be emitted under numerous other circumstances,
        // so it is quite a challenge to distinguish a `selectionchange` coming in from a user
        // using a Braille display from all the other cases.
        //
        // The problems with the `selectionchange` event are:
        //  * the event is emitted when the textarea is focused programmatically -- textarea.focus()
        //  * the event is emitted when the selection is changed in the textarea programmatically -- textarea.setSelectionRange(...)
        //  * the event is emitted when the value of the textarea is changed programmatically -- textarea.value = '...'
        //  * the event is emitted when tabbing into the textarea
        //  * the event is emitted asynchronously (sometimes with a delay as high as a few tens of ms)
        //  * the event sometimes comes in bursts for a single logical textarea operation
        // `selectionchange` events often come multiple times for a single logical change
        // so throttle multiple `selectionchange` events that burst in a short period of time.
        let previousSelectionChangeEventTime = 0;
        return _domJs.addDisposableListener(this._textArea.ownerDocument, "selectionchange", (e)=>{
            (0, _performanceJs.inputLatency).onSelectionChange();
            if (!this._hasFocus) return;
            if (this._currentComposition) return;
            if (!this._browser.isChrome) // Support only for Chrome until testing happens on other browsers
            return;
            const now = Date.now();
            const delta1 = now - previousSelectionChangeEventTime;
            previousSelectionChangeEventTime = now;
            if (delta1 < 5) // received another `selectionchange` event within 5ms of the previous `selectionchange` event
            // => ignore it
            return;
            const delta2 = now - this._textArea.getIgnoreSelectionChangeTime();
            this._textArea.resetSelectionChangeTime();
            if (delta2 < 100) // received a `selectionchange` event within 100ms since we touched the textarea
            // => ignore it, since we caused it
            return;
            if (!this._textAreaState.selection) // Cannot correlate a position in the textarea with a position in the editor...
            return;
            const newValue = this._textArea.getValue();
            if (this._textAreaState.value !== newValue) // Cannot correlate a position in the textarea with a position in the editor...
            return;
            const newSelectionStart = this._textArea.getSelectionStart();
            const newSelectionEnd = this._textArea.getSelectionEnd();
            if (this._textAreaState.selectionStart === newSelectionStart && this._textAreaState.selectionEnd === newSelectionEnd) // Nothing to do...
            return;
            const _newSelectionStartPosition = this._textAreaState.deduceEditorPosition(newSelectionStart);
            const newSelectionStartPosition = this._host.deduceModelPosition(_newSelectionStartPosition[0], _newSelectionStartPosition[1], _newSelectionStartPosition[2]);
            const _newSelectionEndPosition = this._textAreaState.deduceEditorPosition(newSelectionEnd);
            const newSelectionEndPosition = this._host.deduceModelPosition(_newSelectionEndPosition[0], _newSelectionEndPosition[1], _newSelectionEndPosition[2]);
            const newSelection = new (0, _selectionJs.Selection)(newSelectionStartPosition.lineNumber, newSelectionStartPosition.column, newSelectionEndPosition.lineNumber, newSelectionEndPosition.column);
            this._onSelectionChangeRequest.fire(newSelection);
        });
    }
    dispose() {
        super.dispose();
        if (this._selectionChangeListener) {
            this._selectionChangeListener.dispose();
            this._selectionChangeListener = null;
        }
    }
    focusTextArea() {
        // Setting this._hasFocus and writing the screen reader content
        // will result in a focus() and setSelectionRange() in the textarea
        this._setHasFocus(true);
        // If the editor is off DOM, focus cannot be really set, so let's double check that we have managed to set the focus
        this.refreshFocusState();
    }
    isFocused() {
        return this._hasFocus;
    }
    refreshFocusState() {
        this._setHasFocus(this._textArea.hasFocus());
    }
    _setHasFocus(newHasFocus) {
        if (this._hasFocus === newHasFocus) // no change
        return;
        this._hasFocus = newHasFocus;
        if (this._selectionChangeListener) {
            this._selectionChangeListener.dispose();
            this._selectionChangeListener = null;
        }
        if (this._hasFocus) this._selectionChangeListener = this._installSelectionChangeListener();
        if (this._hasFocus) this.writeNativeTextAreaContent("focusgain");
        if (this._hasFocus) this._onFocus.fire();
        else this._onBlur.fire();
    }
    _setAndWriteTextAreaState(reason, textAreaState) {
        if (!this._hasFocus) textAreaState = textAreaState.collapseSelection();
        textAreaState.writeToTextArea(reason, this._textArea, this._hasFocus);
        this._textAreaState = textAreaState;
    }
    writeNativeTextAreaContent(reason) {
        if (!this._accessibilityService.isScreenReaderOptimized() && reason === "render" || this._currentComposition) // Do not write to the text on render unless a screen reader is being used #192278
        // Do not write to the text area when doing composition
        return;
        this._logService.trace(`writeTextAreaState(reason: ${reason})`);
        this._setAndWriteTextAreaState(reason, this._host.getScreenReaderContent());
    }
    _ensureClipboardGetsEditorSelection(e) {
        const dataToCopy = this._host.getDataToCopy();
        const storedMetadata = {
            version: 1,
            isFromEmptySelection: dataToCopy.isFromEmptySelection,
            multicursorText: dataToCopy.multicursorText,
            mode: dataToCopy.mode
        };
        InMemoryClipboardMetadataManager.INSTANCE.set(// When writing "LINE\r\n" to the clipboard and then pasting,
        // Firefox pastes "LINE\n", so let's work around this quirk
        this._browser.isFirefox ? dataToCopy.text.replace(/\r\n/g, "\n") : dataToCopy.text, storedMetadata);
        e.preventDefault();
        if (e.clipboardData) ClipboardEventUtils.setTextData(e.clipboardData, dataToCopy.text, dataToCopy.html, storedMetadata);
    }
};
TextAreaInput = __decorate([
    __param(4, (0, _accessibilityJs.IAccessibilityService)),
    __param(5, (0, _logJs.ILogService))
], TextAreaInput);
const ClipboardEventUtils = {
    getTextData (clipboardData) {
        const text = clipboardData.getData((0, _mimeJs.Mimes).text);
        let metadata = null;
        const rawmetadata = clipboardData.getData("vscode-editor-data");
        if (typeof rawmetadata === "string") try {
            metadata = JSON.parse(rawmetadata);
            if (metadata.version !== 1) metadata = null;
        } catch (err) {
        // no problem!
        }
        if (text.length === 0 && metadata === null && clipboardData.files.length > 0) {
            // no textual data pasted, generate text from file names
            const files = Array.prototype.slice.call(clipboardData.files, 0);
            return [
                files.map((file)=>file.name).join("\n"),
                null
            ];
        }
        return [
            text,
            metadata
        ];
    },
    setTextData (clipboardData, text, html, metadata) {
        clipboardData.setData((0, _mimeJs.Mimes).text, text);
        if (typeof html === "string") clipboardData.setData("text/html", html);
        clipboardData.setData("vscode-editor-data", JSON.stringify(metadata));
    }
};
class TextAreaWrapper extends (0, _lifecycleJs.Disposable) {
    get ownerDocument() {
        return this._actual.ownerDocument;
    }
    constructor(_actual){
        super();
        this._actual = _actual;
        this.onKeyDown = this._register(new (0, _eventJs.DomEmitter)(this._actual, "keydown")).event;
        this.onKeyUp = this._register(new (0, _eventJs.DomEmitter)(this._actual, "keyup")).event;
        this.onCompositionStart = this._register(new (0, _eventJs.DomEmitter)(this._actual, "compositionstart")).event;
        this.onCompositionUpdate = this._register(new (0, _eventJs.DomEmitter)(this._actual, "compositionupdate")).event;
        this.onCompositionEnd = this._register(new (0, _eventJs.DomEmitter)(this._actual, "compositionend")).event;
        this.onBeforeInput = this._register(new (0, _eventJs.DomEmitter)(this._actual, "beforeinput")).event;
        this.onInput = this._register(new (0, _eventJs.DomEmitter)(this._actual, "input")).event;
        this.onCut = this._register(new (0, _eventJs.DomEmitter)(this._actual, "cut")).event;
        this.onCopy = this._register(new (0, _eventJs.DomEmitter)(this._actual, "copy")).event;
        this.onPaste = this._register(new (0, _eventJs.DomEmitter)(this._actual, "paste")).event;
        this.onFocus = this._register(new (0, _eventJs.DomEmitter)(this._actual, "focus")).event;
        this.onBlur = this._register(new (0, _eventJs.DomEmitter)(this._actual, "blur")).event;
        this._onSyntheticTap = this._register(new (0, _eventJs1.Emitter)());
        this.onSyntheticTap = this._onSyntheticTap.event;
        this._ignoreSelectionChangeTime = 0;
        this._register(this.onKeyDown(()=>(0, _performanceJs.inputLatency).onKeyDown()));
        this._register(this.onBeforeInput(()=>(0, _performanceJs.inputLatency).onBeforeInput()));
        this._register(this.onInput(()=>(0, _performanceJs.inputLatency).onInput()));
        this._register(this.onKeyUp(()=>(0, _performanceJs.inputLatency).onKeyUp()));
        this._register(_domJs.addDisposableListener(this._actual, TextAreaSyntethicEvents.Tap, ()=>this._onSyntheticTap.fire()));
    }
    hasFocus() {
        const shadowRoot = _domJs.getShadowRoot(this._actual);
        if (shadowRoot) return shadowRoot.activeElement === this._actual;
        else if (this._actual.isConnected) return _domJs.getActiveElement() === this._actual;
        else return false;
    }
    setIgnoreSelectionChangeTime(reason) {
        this._ignoreSelectionChangeTime = Date.now();
    }
    getIgnoreSelectionChangeTime() {
        return this._ignoreSelectionChangeTime;
    }
    resetSelectionChangeTime() {
        this._ignoreSelectionChangeTime = 0;
    }
    getValue() {
        // console.log('current value: ' + this._textArea.value);
        return this._actual.value;
    }
    setValue(reason, value) {
        const textArea = this._actual;
        if (textArea.value === value) // No change
        return;
        // console.log('reason: ' + reason + ', current value: ' + textArea.value + ' => new value: ' + value);
        this.setIgnoreSelectionChangeTime("setValue");
        textArea.value = value;
    }
    getSelectionStart() {
        return this._actual.selectionDirection === "backward" ? this._actual.selectionEnd : this._actual.selectionStart;
    }
    getSelectionEnd() {
        return this._actual.selectionDirection === "backward" ? this._actual.selectionStart : this._actual.selectionEnd;
    }
    setSelectionRange(reason, selectionStart, selectionEnd) {
        const textArea = this._actual;
        let activeElement = null;
        const shadowRoot = _domJs.getShadowRoot(textArea);
        if (shadowRoot) activeElement = shadowRoot.activeElement;
        else activeElement = _domJs.getActiveElement();
        const activeWindow = _domJs.getWindow(activeElement);
        const currentIsFocused = activeElement === textArea;
        const currentSelectionStart = textArea.selectionStart;
        const currentSelectionEnd = textArea.selectionEnd;
        if (currentIsFocused && currentSelectionStart === selectionStart && currentSelectionEnd === selectionEnd) {
            // No change
            // Firefox iframe bug https://github.com/microsoft/monaco-editor/issues/643#issuecomment-367871377
            if (_browserJs.isFirefox && activeWindow.parent !== activeWindow) textArea.focus();
            return;
        }
        // console.log('reason: ' + reason + ', setSelectionRange: ' + selectionStart + ' -> ' + selectionEnd);
        if (currentIsFocused) {
            // No need to focus, only need to change the selection range
            this.setIgnoreSelectionChangeTime("setSelectionRange");
            textArea.setSelectionRange(selectionStart, selectionEnd);
            if (_browserJs.isFirefox && activeWindow.parent !== activeWindow) textArea.focus();
            return;
        }
        // If the focus is outside the textarea, browsers will try really hard to reveal the textarea.
        // Here, we try to undo the browser's desperate reveal.
        try {
            const scrollState = _domJs.saveParentsScrollTop(textArea);
            this.setIgnoreSelectionChangeTime("setSelectionRange");
            textArea.focus();
            textArea.setSelectionRange(selectionStart, selectionEnd);
            _domJs.restoreParentsScrollTop(textArea, scrollState);
        } catch (e) {
        // Sometimes IE throws when setting selection (e.g. textarea is off-DOM)
        }
    }
}

},{"../../../base/browser/browser.js":"4Zquf","../../../base/browser/dom.js":"bnqsM","../../../base/browser/event.js":"PHN3G","../../../base/browser/keyboardEvent.js":"bxU9U","../../../base/browser/performance.js":"9Gvzx","../../../base/common/async.js":"4GJc4","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/mime.js":"9CBNk","../../../base/common/strings.js":"aA9I1","./textAreaState.js":"ikXe1","../../common/core/selection.js":"kcwzU","../../../platform/accessibility/common/accessibility.js":"9Svqy","../../../platform/log/common/log.js":"ieJUF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ikXe1":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_debugComposition", ()=>_debugComposition);
parcelHelpers.export(exports, "TextAreaState", ()=>TextAreaState);
parcelHelpers.export(exports, "PagedScreenReaderStrategy", ()=>PagedScreenReaderStrategy);
var _stringsJs = require("../../../base/common/strings.js");
var _rangeJs = require("../../common/core/range.js");
const _debugComposition = false;
class TextAreaState {
    static{
        this.EMPTY = new TextAreaState("", 0, 0, null, undefined);
    }
    constructor(value, /** the offset where selection starts inside `value` */ selectionStart, /** the offset where selection ends inside `value` */ selectionEnd, /** the editor range in the view coordinate system that matches the selection inside `value` */ selection, /** the visible line count (wrapped, not necessarily matching \n characters) for the text in `value` before `selectionStart` */ newlineCountBeforeSelection){
        this.value = value;
        this.selectionStart = selectionStart;
        this.selectionEnd = selectionEnd;
        this.selection = selection;
        this.newlineCountBeforeSelection = newlineCountBeforeSelection;
    }
    toString() {
        return `[ <${this.value}>, selectionStart: ${this.selectionStart}, selectionEnd: ${this.selectionEnd}]`;
    }
    static readFromTextArea(textArea, previousState) {
        const value = textArea.getValue();
        const selectionStart = textArea.getSelectionStart();
        const selectionEnd = textArea.getSelectionEnd();
        let newlineCountBeforeSelection = undefined;
        if (previousState) {
            const valueBeforeSelectionStart = value.substring(0, selectionStart);
            const previousValueBeforeSelectionStart = previousState.value.substring(0, previousState.selectionStart);
            if (valueBeforeSelectionStart === previousValueBeforeSelectionStart) newlineCountBeforeSelection = previousState.newlineCountBeforeSelection;
        }
        return new TextAreaState(value, selectionStart, selectionEnd, null, newlineCountBeforeSelection);
    }
    collapseSelection() {
        if (this.selectionStart === this.value.length) return this;
        return new TextAreaState(this.value, this.value.length, this.value.length, null, undefined);
    }
    writeToTextArea(reason, textArea, select) {
        if (_debugComposition) console.log(`writeToTextArea ${reason}: ${this.toString()}`);
        textArea.setValue(reason, this.value);
        if (select) textArea.setSelectionRange(reason, this.selectionStart, this.selectionEnd);
    }
    deduceEditorPosition(offset) {
        if (offset <= this.selectionStart) {
            const str = this.value.substring(offset, this.selectionStart);
            return this._finishDeduceEditorPosition(this.selection?.getStartPosition() ?? null, str, -1);
        }
        if (offset >= this.selectionEnd) {
            const str = this.value.substring(this.selectionEnd, offset);
            return this._finishDeduceEditorPosition(this.selection?.getEndPosition() ?? null, str, 1);
        }
        const str1 = this.value.substring(this.selectionStart, offset);
        if (str1.indexOf(String.fromCharCode(8230)) === -1) return this._finishDeduceEditorPosition(this.selection?.getStartPosition() ?? null, str1, 1);
        const str2 = this.value.substring(offset, this.selectionEnd);
        return this._finishDeduceEditorPosition(this.selection?.getEndPosition() ?? null, str2, -1);
    }
    _finishDeduceEditorPosition(anchor, deltaText, signum) {
        let lineFeedCnt = 0;
        let lastLineFeedIndex = -1;
        while((lastLineFeedIndex = deltaText.indexOf("\n", lastLineFeedIndex + 1)) !== -1)lineFeedCnt++;
        return [
            anchor,
            signum * deltaText.length,
            lineFeedCnt
        ];
    }
    static deduceInput(previousState, currentState, couldBeEmojiInput) {
        if (!previousState) // This is the EMPTY state
        return {
            text: "",
            replacePrevCharCnt: 0,
            replaceNextCharCnt: 0,
            positionDelta: 0
        };
        if (_debugComposition) {
            console.log("------------------------deduceInput");
            console.log(`PREVIOUS STATE: ${previousState.toString()}`);
            console.log(`CURRENT STATE: ${currentState.toString()}`);
        }
        const prefixLength = Math.min(_stringsJs.commonPrefixLength(previousState.value, currentState.value), previousState.selectionStart, currentState.selectionStart);
        const suffixLength = Math.min(_stringsJs.commonSuffixLength(previousState.value, currentState.value), previousState.value.length - previousState.selectionEnd, currentState.value.length - currentState.selectionEnd);
        const previousValue = previousState.value.substring(prefixLength, previousState.value.length - suffixLength);
        const currentValue = currentState.value.substring(prefixLength, currentState.value.length - suffixLength);
        const previousSelectionStart = previousState.selectionStart - prefixLength;
        const previousSelectionEnd = previousState.selectionEnd - prefixLength;
        const currentSelectionStart = currentState.selectionStart - prefixLength;
        const currentSelectionEnd = currentState.selectionEnd - prefixLength;
        if (_debugComposition) {
            console.log(`AFTER DIFFING PREVIOUS STATE: <${previousValue}>, selectionStart: ${previousSelectionStart}, selectionEnd: ${previousSelectionEnd}`);
            console.log(`AFTER DIFFING CURRENT STATE: <${currentValue}>, selectionStart: ${currentSelectionStart}, selectionEnd: ${currentSelectionEnd}`);
        }
        if (currentSelectionStart === currentSelectionEnd) {
            // no current selection
            const replacePreviousCharacters = previousState.selectionStart - prefixLength;
            if (_debugComposition) console.log(`REMOVE PREVIOUS: ${replacePreviousCharacters} chars`);
            return {
                text: currentValue,
                replacePrevCharCnt: replacePreviousCharacters,
                replaceNextCharCnt: 0,
                positionDelta: 0
            };
        }
        // there is a current selection => composition case
        const replacePreviousCharacters = previousSelectionEnd - previousSelectionStart;
        return {
            text: currentValue,
            replacePrevCharCnt: replacePreviousCharacters,
            replaceNextCharCnt: 0,
            positionDelta: 0
        };
    }
    static deduceAndroidCompositionInput(previousState, currentState) {
        if (!previousState) // This is the EMPTY state
        return {
            text: "",
            replacePrevCharCnt: 0,
            replaceNextCharCnt: 0,
            positionDelta: 0
        };
        if (_debugComposition) {
            console.log("------------------------deduceAndroidCompositionInput");
            console.log(`PREVIOUS STATE: ${previousState.toString()}`);
            console.log(`CURRENT STATE: ${currentState.toString()}`);
        }
        if (previousState.value === currentState.value) return {
            text: "",
            replacePrevCharCnt: 0,
            replaceNextCharCnt: 0,
            positionDelta: currentState.selectionEnd - previousState.selectionEnd
        };
        const prefixLength = Math.min(_stringsJs.commonPrefixLength(previousState.value, currentState.value), previousState.selectionEnd);
        const suffixLength = Math.min(_stringsJs.commonSuffixLength(previousState.value, currentState.value), previousState.value.length - previousState.selectionEnd);
        const previousValue = previousState.value.substring(prefixLength, previousState.value.length - suffixLength);
        const currentValue = currentState.value.substring(prefixLength, currentState.value.length - suffixLength);
        const previousSelectionStart = previousState.selectionStart - prefixLength;
        const previousSelectionEnd = previousState.selectionEnd - prefixLength;
        const currentSelectionStart = currentState.selectionStart - prefixLength;
        const currentSelectionEnd = currentState.selectionEnd - prefixLength;
        if (_debugComposition) {
            console.log(`AFTER DIFFING PREVIOUS STATE: <${previousValue}>, selectionStart: ${previousSelectionStart}, selectionEnd: ${previousSelectionEnd}`);
            console.log(`AFTER DIFFING CURRENT STATE: <${currentValue}>, selectionStart: ${currentSelectionStart}, selectionEnd: ${currentSelectionEnd}`);
        }
        return {
            text: currentValue,
            replacePrevCharCnt: previousSelectionEnd,
            replaceNextCharCnt: previousValue.length - previousSelectionEnd,
            positionDelta: currentSelectionEnd - currentValue.length
        };
    }
}
class PagedScreenReaderStrategy {
    static _getPageOfLine(lineNumber, linesPerPage) {
        return Math.floor((lineNumber - 1) / linesPerPage);
    }
    static _getRangeForPage(page, linesPerPage) {
        const offset = page * linesPerPage;
        const startLineNumber = offset + 1;
        const endLineNumber = offset + linesPerPage;
        return new (0, _rangeJs.Range)(startLineNumber, 1, endLineNumber + 1, 1);
    }
    static fromEditorSelection(model, selection, linesPerPage, trimLongText) {
        // Chromium handles very poorly text even of a few thousand chars
        // Cut text to avoid stalling the entire UI
        const LIMIT_CHARS = 500;
        const selectionStartPage = PagedScreenReaderStrategy._getPageOfLine(selection.startLineNumber, linesPerPage);
        const selectionStartPageRange = PagedScreenReaderStrategy._getRangeForPage(selectionStartPage, linesPerPage);
        const selectionEndPage = PagedScreenReaderStrategy._getPageOfLine(selection.endLineNumber, linesPerPage);
        const selectionEndPageRange = PagedScreenReaderStrategy._getRangeForPage(selectionEndPage, linesPerPage);
        let pretextRange = selectionStartPageRange.intersectRanges(new (0, _rangeJs.Range)(1, 1, selection.startLineNumber, selection.startColumn));
        if (trimLongText && model.getValueLengthInRange(pretextRange, 1 /* EndOfLinePreference.LF */ ) > LIMIT_CHARS) {
            const pretextStart = model.modifyPosition(pretextRange.getEndPosition(), -LIMIT_CHARS);
            pretextRange = (0, _rangeJs.Range).fromPositions(pretextStart, pretextRange.getEndPosition());
        }
        const pretext = model.getValueInRange(pretextRange, 1 /* EndOfLinePreference.LF */ );
        const lastLine = model.getLineCount();
        const lastLineMaxColumn = model.getLineMaxColumn(lastLine);
        let posttextRange = selectionEndPageRange.intersectRanges(new (0, _rangeJs.Range)(selection.endLineNumber, selection.endColumn, lastLine, lastLineMaxColumn));
        if (trimLongText && model.getValueLengthInRange(posttextRange, 1 /* EndOfLinePreference.LF */ ) > LIMIT_CHARS) {
            const posttextEnd = model.modifyPosition(posttextRange.getStartPosition(), LIMIT_CHARS);
            posttextRange = (0, _rangeJs.Range).fromPositions(posttextRange.getStartPosition(), posttextEnd);
        }
        const posttext = model.getValueInRange(posttextRange, 1 /* EndOfLinePreference.LF */ );
        let text;
        if (selectionStartPage === selectionEndPage || selectionStartPage + 1 === selectionEndPage) // take full selection
        text = model.getValueInRange(selection, 1 /* EndOfLinePreference.LF */ );
        else {
            const selectionRange1 = selectionStartPageRange.intersectRanges(selection);
            const selectionRange2 = selectionEndPageRange.intersectRanges(selection);
            text = model.getValueInRange(selectionRange1, 1 /* EndOfLinePreference.LF */ ) + String.fromCharCode(8230) + model.getValueInRange(selectionRange2, 1 /* EndOfLinePreference.LF */ );
        }
        if (trimLongText && text.length > 2 * LIMIT_CHARS) text = text.substring(0, LIMIT_CHARS) + String.fromCharCode(8230) + text.substring(text.length - LIMIT_CHARS, text.length);
        return new TextAreaState(pretext + text + posttext, pretext.length, pretext.length + text.length, selection, pretextRange.endLineNumber - pretextRange.startLineNumber);
    }
}

},{"../../../base/common/strings.js":"aA9I1","../../common/core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aM7Oo":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextAreaHandler", ()=>TextAreaHandler);
var _textAreaHandlerCss = require("./textAreaHandler.css");
var _nlsJs = require("../../../nls.js");
var _browserJs = require("../../../base/browser/browser.js");
var _fastDomNodeJs = require("../../../base/browser/fastDomNode.js");
var _platformJs = require("../../../base/common/platform.js");
var _stringsJs = require("../../../base/common/strings.js");
var _domFontInfoJs = require("../config/domFontInfo.js");
var _textAreaInputJs = require("./textAreaInput.js");
var _textAreaStateJs = require("./textAreaState.js");
var _viewPartJs = require("../view/viewPart.js");
var _lineNumbersJs = require("../viewParts/lineNumbers/lineNumbers.js");
var _marginJs = require("../viewParts/margin/margin.js");
var _editorOptionsJs = require("../../common/config/editorOptions.js");
var _wordCharacterClassifierJs = require("../../common/core/wordCharacterClassifier.js");
var _positionJs = require("../../common/core/position.js");
var _rangeJs = require("../../common/core/range.js");
var _selectionJs = require("../../common/core/selection.js");
var _mouseCursorJs = require("../../../base/browser/ui/mouseCursor/mouseCursor.js");
var _languagesJs = require("../../common/languages.js");
var _colorJs = require("../../../base/common/color.js");
var _imeJs = require("../../../base/common/ime.js");
var _keybindingJs = require("../../../platform/keybinding/common/keybinding.js");
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class VisibleTextAreaData {
    constructor(_context, modelLineNumber, distanceToModelLineStart, widthOfHiddenLineTextBefore, distanceToModelLineEnd){
        this._context = _context;
        this.modelLineNumber = modelLineNumber;
        this.distanceToModelLineStart = distanceToModelLineStart;
        this.widthOfHiddenLineTextBefore = widthOfHiddenLineTextBefore;
        this.distanceToModelLineEnd = distanceToModelLineEnd;
        this._visibleTextAreaBrand = undefined;
        this.startPosition = null;
        this.endPosition = null;
        this.visibleTextareaStart = null;
        this.visibleTextareaEnd = null;
        /**
         * When doing composition, the currently composed text might be split up into
         * multiple tokens, then merged again into a single token, etc. Here we attempt
         * to keep the presentation of the <textarea> stable by using the previous used
         * style if multiple tokens come into play. This avoids flickering.
         */ this._previousPresentation = null;
    }
    prepareRender(visibleRangeProvider) {
        const startModelPosition = new (0, _positionJs.Position)(this.modelLineNumber, this.distanceToModelLineStart + 1);
        const endModelPosition = new (0, _positionJs.Position)(this.modelLineNumber, this._context.viewModel.model.getLineMaxColumn(this.modelLineNumber) - this.distanceToModelLineEnd);
        this.startPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(startModelPosition);
        this.endPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(endModelPosition);
        if (this.startPosition.lineNumber === this.endPosition.lineNumber) {
            this.visibleTextareaStart = visibleRangeProvider.visibleRangeForPosition(this.startPosition);
            this.visibleTextareaEnd = visibleRangeProvider.visibleRangeForPosition(this.endPosition);
        } else {
            // TODO: what if the view positions are not on the same line?
            this.visibleTextareaStart = null;
            this.visibleTextareaEnd = null;
        }
    }
    definePresentation(tokenPresentation) {
        if (!this._previousPresentation) {
            // To avoid flickering, once set, always reuse a presentation throughout the entire IME session
            if (tokenPresentation) this._previousPresentation = tokenPresentation;
            else this._previousPresentation = {
                foreground: 1 /* ColorId.DefaultForeground */ ,
                italic: false,
                bold: false,
                underline: false,
                strikethrough: false
            };
        }
        return this._previousPresentation;
    }
}
const canUseZeroSizeTextarea = _browserJs.isFirefox;
let TextAreaHandler = class TextAreaHandler extends (0, _viewPartJs.ViewPart) {
    constructor(context, viewController, visibleRangeProvider, _keybindingService, _instantiationService){
        super(context);
        this._keybindingService = _keybindingService;
        this._instantiationService = _instantiationService;
        this._primaryCursorPosition = new (0, _positionJs.Position)(1, 1);
        this._primaryCursorVisibleRange = null;
        this._viewController = viewController;
        this._visibleRangeProvider = visibleRangeProvider;
        this._scrollLeft = 0;
        this._scrollTop = 0;
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._setAccessibilityOptions(options);
        this._contentLeft = layoutInfo.contentLeft;
        this._contentWidth = layoutInfo.contentWidth;
        this._contentHeight = layoutInfo.height;
        this._fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this._emptySelectionClipboard = options.get(37 /* EditorOption.emptySelectionClipboard */ );
        this._copyWithSyntaxHighlighting = options.get(25 /* EditorOption.copyWithSyntaxHighlighting */ );
        this._visibleTextArea = null;
        this._selections = [
            new (0, _selectionJs.Selection)(1, 1, 1, 1)
        ];
        this._modelSelections = [
            new (0, _selectionJs.Selection)(1, 1, 1, 1)
        ];
        this._lastRenderPosition = null;
        // Text Area (The focus will always be in the textarea when the cursor is blinking)
        this.textArea = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("textarea"));
        (0, _viewPartJs.PartFingerprints).write(this.textArea, 7 /* PartFingerprint.TextArea */ );
        this.textArea.setClassName(`inputarea ${(0, _mouseCursorJs.MOUSE_CURSOR_TEXT_CSS_CLASS_NAME)}`);
        this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
        const { tabSize } = this._context.viewModel.model.getOptions();
        this.textArea.domNode.style.tabSize = `${tabSize * this._fontInfo.spaceWidth}px`;
        this.textArea.setAttribute("autocorrect", "off");
        this.textArea.setAttribute("autocapitalize", "off");
        this.textArea.setAttribute("autocomplete", "off");
        this.textArea.setAttribute("spellcheck", "false");
        this.textArea.setAttribute("aria-label", this._getAriaLabel(options));
        this.textArea.setAttribute("aria-required", options.get(5 /* EditorOption.ariaRequired */ ) ? "true" : "false");
        this.textArea.setAttribute("tabindex", String(options.get(125 /* EditorOption.tabIndex */ )));
        this.textArea.setAttribute("role", "textbox");
        this.textArea.setAttribute("aria-roledescription", _nlsJs.localize("editor", "editor"));
        this.textArea.setAttribute("aria-multiline", "true");
        this.textArea.setAttribute("aria-autocomplete", options.get(92 /* EditorOption.readOnly */ ) ? "none" : "both");
        this._ensureReadOnlyAttribute();
        this.textAreaCover = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this.textAreaCover.setPosition("absolute");
        const simpleModel = {
            getLineCount: ()=>{
                return this._context.viewModel.getLineCount();
            },
            getLineMaxColumn: (lineNumber)=>{
                return this._context.viewModel.getLineMaxColumn(lineNumber);
            },
            getValueInRange: (range, eol)=>{
                return this._context.viewModel.getValueInRange(range, eol);
            },
            getValueLengthInRange: (range, eol)=>{
                return this._context.viewModel.getValueLengthInRange(range, eol);
            },
            modifyPosition: (position, offset)=>{
                return this._context.viewModel.modifyPosition(position, offset);
            }
        };
        const textAreaInputHost = {
            getDataToCopy: ()=>{
                const rawTextToCopy = this._context.viewModel.getPlainTextToCopy(this._modelSelections, this._emptySelectionClipboard, _platformJs.isWindows);
                const newLineCharacter = this._context.viewModel.model.getEOL();
                const isFromEmptySelection = this._emptySelectionClipboard && this._modelSelections.length === 1 && this._modelSelections[0].isEmpty();
                const multicursorText = Array.isArray(rawTextToCopy) ? rawTextToCopy : null;
                const text = Array.isArray(rawTextToCopy) ? rawTextToCopy.join(newLineCharacter) : rawTextToCopy;
                let html = undefined;
                let mode = null;
                if ((0, _textAreaInputJs.CopyOptions).forceCopyWithSyntaxHighlighting || this._copyWithSyntaxHighlighting && text.length < 65536) {
                    const richText = this._context.viewModel.getRichTextToCopy(this._modelSelections, this._emptySelectionClipboard);
                    if (richText) {
                        html = richText.html;
                        mode = richText.mode;
                    }
                }
                return {
                    isFromEmptySelection,
                    multicursorText,
                    text,
                    html,
                    mode
                };
            },
            getScreenReaderContent: ()=>{
                if (this._accessibilitySupport === 1 /* AccessibilitySupport.Disabled */ ) {
                    // We know for a fact that a screen reader is not attached
                    // On OSX, we write the character before the cursor to allow for "long-press" composition
                    // Also on OSX, we write the word before the cursor to allow for the Accessibility Keyboard to give good hints
                    const selection = this._selections[0];
                    if (_platformJs.isMacintosh && selection.isEmpty()) {
                        const position = selection.getStartPosition();
                        let textBefore = this._getWordBeforePosition(position);
                        if (textBefore.length === 0) textBefore = this._getCharacterBeforePosition(position);
                        if (textBefore.length > 0) return new (0, _textAreaStateJs.TextAreaState)(textBefore, textBefore.length, textBefore.length, (0, _rangeJs.Range).fromPositions(position), 0);
                    }
                    // on macOS, write current selection into textarea will allow system text services pick selected text,
                    // but we still want to limit the amount of text given Chromium handles very poorly text even of a few
                    // thousand chars
                    // (https://github.com/microsoft/vscode/issues/27799)
                    const LIMIT_CHARS = 500;
                    if (_platformJs.isMacintosh && !selection.isEmpty() && simpleModel.getValueLengthInRange(selection, 0 /* EndOfLinePreference.TextDefined */ ) < LIMIT_CHARS) {
                        const text = simpleModel.getValueInRange(selection, 0 /* EndOfLinePreference.TextDefined */ );
                        return new (0, _textAreaStateJs.TextAreaState)(text, 0, text.length, selection, 0);
                    }
                    // on Safari, document.execCommand('cut') and document.execCommand('copy') will just not work
                    // if the textarea has no content selected. So if there is an editor selection, ensure something
                    // is selected in the textarea.
                    if (_browserJs.isSafari && !selection.isEmpty()) {
                        const placeholderText = "vscode-placeholder";
                        return new (0, _textAreaStateJs.TextAreaState)(placeholderText, 0, placeholderText.length, null, undefined);
                    }
                    return (0, _textAreaStateJs.TextAreaState).EMPTY;
                }
                if (_browserJs.isAndroid) {
                    // when tapping in the editor on a word, Android enters composition mode.
                    // in the `compositionstart` event we cannot clear the textarea, because
                    // it then forgets to ever send a `compositionend`.
                    // we therefore only write the current word in the textarea
                    const selection = this._selections[0];
                    if (selection.isEmpty()) {
                        const position = selection.getStartPosition();
                        const [wordAtPosition, positionOffsetInWord] = this._getAndroidWordAtPosition(position);
                        if (wordAtPosition.length > 0) return new (0, _textAreaStateJs.TextAreaState)(wordAtPosition, positionOffsetInWord, positionOffsetInWord, (0, _rangeJs.Range).fromPositions(position), 0);
                    }
                    return (0, _textAreaStateJs.TextAreaState).EMPTY;
                }
                return (0, _textAreaStateJs.PagedScreenReaderStrategy).fromEditorSelection(simpleModel, this._selections[0], this._accessibilityPageSize, this._accessibilitySupport === 0 /* AccessibilitySupport.Unknown */ );
            },
            deduceModelPosition: (viewAnchorPosition, deltaOffset, lineFeedCnt)=>{
                return this._context.viewModel.deduceModelPositionRelativeToViewPosition(viewAnchorPosition, deltaOffset, lineFeedCnt);
            }
        };
        const textAreaWrapper = this._register(new (0, _textAreaInputJs.TextAreaWrapper)(this.textArea.domNode));
        this._textAreaInput = this._register(this._instantiationService.createInstance((0, _textAreaInputJs.TextAreaInput), textAreaInputHost, textAreaWrapper, _platformJs.OS, {
            isAndroid: _browserJs.isAndroid,
            isChrome: _browserJs.isChrome,
            isFirefox: _browserJs.isFirefox,
            isSafari: _browserJs.isSafari
        }));
        this._register(this._textAreaInput.onKeyDown((e)=>{
            this._viewController.emitKeyDown(e);
        }));
        this._register(this._textAreaInput.onKeyUp((e)=>{
            this._viewController.emitKeyUp(e);
        }));
        this._register(this._textAreaInput.onPaste((e)=>{
            let pasteOnNewLine = false;
            let multicursorText = null;
            let mode = null;
            if (e.metadata) {
                pasteOnNewLine = this._emptySelectionClipboard && !!e.metadata.isFromEmptySelection;
                multicursorText = typeof e.metadata.multicursorText !== "undefined" ? e.metadata.multicursorText : null;
                mode = e.metadata.mode;
            }
            this._viewController.paste(e.text, pasteOnNewLine, multicursorText, mode);
        }));
        this._register(this._textAreaInput.onCut(()=>{
            this._viewController.cut();
        }));
        this._register(this._textAreaInput.onType((e)=>{
            if (e.replacePrevCharCnt || e.replaceNextCharCnt || e.positionDelta) {
                // must be handled through the new command
                if (0, _textAreaStateJs._debugComposition) console.log(` => compositionType: <<${e.text}>>, ${e.replacePrevCharCnt}, ${e.replaceNextCharCnt}, ${e.positionDelta}`);
                this._viewController.compositionType(e.text, e.replacePrevCharCnt, e.replaceNextCharCnt, e.positionDelta);
            } else {
                if (0, _textAreaStateJs._debugComposition) console.log(` => type: <<${e.text}>>`);
                this._viewController.type(e.text);
            }
        }));
        this._register(this._textAreaInput.onSelectionChangeRequest((modelSelection)=>{
            this._viewController.setSelection(modelSelection);
        }));
        this._register(this._textAreaInput.onCompositionStart((e)=>{
            // The textarea might contain some content when composition starts.
            //
            // When we make the textarea visible, it always has a height of 1 line,
            // so we don't need to worry too much about content on lines above or below
            // the selection.
            //
            // However, the text on the current line needs to be made visible because
            // some IME methods allow to move to other glyphs on the current line
            // (by pressing arrow keys).
            //
            // (1) The textarea might contain only some parts of the current line,
            // like the word before the selection. Also, the content inside the textarea
            // can grow or shrink as composition occurs. We therefore anchor the textarea
            // in terms of distance to a certain line start and line end.
            //
            // (2) Also, we should not make \t characters visible, because their rendering
            // inside the <textarea> will not align nicely with our rendering. We therefore
            // will hide (if necessary) some of the leading text on the current line.
            const ta = this.textArea.domNode;
            const modelSelection = this._modelSelections[0];
            const { distanceToModelLineStart, widthOfHiddenTextBefore } = (()=>{
                // Find the text that is on the current line before the selection
                const textBeforeSelection = ta.value.substring(0, Math.min(ta.selectionStart, ta.selectionEnd));
                const lineFeedOffset1 = textBeforeSelection.lastIndexOf("\n");
                const lineTextBeforeSelection = textBeforeSelection.substring(lineFeedOffset1 + 1);
                // We now search to see if we should hide some part of it (if it contains \t)
                const tabOffset1 = lineTextBeforeSelection.lastIndexOf("	");
                const desiredVisibleBeforeCharCount = lineTextBeforeSelection.length - tabOffset1 - 1;
                const startModelPosition = modelSelection.getStartPosition();
                const visibleBeforeCharCount = Math.min(startModelPosition.column - 1, desiredVisibleBeforeCharCount);
                const distanceToModelLineStart = startModelPosition.column - 1 - visibleBeforeCharCount;
                const hiddenLineTextBefore = lineTextBeforeSelection.substring(0, lineTextBeforeSelection.length - visibleBeforeCharCount);
                const { tabSize } = this._context.viewModel.model.getOptions();
                const widthOfHiddenTextBefore = measureText(this.textArea.domNode.ownerDocument, hiddenLineTextBefore, this._fontInfo, tabSize);
                return {
                    distanceToModelLineStart,
                    widthOfHiddenTextBefore
                };
            })();
            const { distanceToModelLineEnd } = (()=>{
                // Find the text that is on the current line after the selection
                const textAfterSelection = ta.value.substring(Math.max(ta.selectionStart, ta.selectionEnd));
                const lineFeedOffset2 = textAfterSelection.indexOf("\n");
                const lineTextAfterSelection = lineFeedOffset2 === -1 ? textAfterSelection : textAfterSelection.substring(0, lineFeedOffset2);
                const tabOffset2 = lineTextAfterSelection.indexOf("	");
                const desiredVisibleAfterCharCount = tabOffset2 === -1 ? lineTextAfterSelection.length : lineTextAfterSelection.length - tabOffset2 - 1;
                const endModelPosition = modelSelection.getEndPosition();
                const visibleAfterCharCount = Math.min(this._context.viewModel.model.getLineMaxColumn(endModelPosition.lineNumber) - endModelPosition.column, desiredVisibleAfterCharCount);
                const distanceToModelLineEnd = this._context.viewModel.model.getLineMaxColumn(endModelPosition.lineNumber) - endModelPosition.column - visibleAfterCharCount;
                return {
                    distanceToModelLineEnd
                };
            })();
            // Scroll to reveal the location in the editor where composition occurs
            this._context.viewModel.revealRange("keyboard", true, (0, _rangeJs.Range).fromPositions(this._selections[0].getStartPosition()), 0 /* viewEvents.VerticalRevealType.Simple */ , 1 /* ScrollType.Immediate */ );
            this._visibleTextArea = new VisibleTextAreaData(this._context, modelSelection.startLineNumber, distanceToModelLineStart, widthOfHiddenTextBefore, distanceToModelLineEnd);
            // We turn off wrapping if the <textarea> becomes visible for composition
            this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
            this._visibleTextArea.prepareRender(this._visibleRangeProvider);
            this._render();
            // Show the textarea
            this.textArea.setClassName(`inputarea ${(0, _mouseCursorJs.MOUSE_CURSOR_TEXT_CSS_CLASS_NAME)} ime-input`);
            this._viewController.compositionStart();
            this._context.viewModel.onCompositionStart();
        }));
        this._register(this._textAreaInput.onCompositionUpdate((e)=>{
            if (!this._visibleTextArea) return;
            this._visibleTextArea.prepareRender(this._visibleRangeProvider);
            this._render();
        }));
        this._register(this._textAreaInput.onCompositionEnd(()=>{
            this._visibleTextArea = null;
            // We turn on wrapping as necessary if the <textarea> hides after composition
            this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
            this._render();
            this.textArea.setClassName(`inputarea ${(0, _mouseCursorJs.MOUSE_CURSOR_TEXT_CSS_CLASS_NAME)}`);
            this._viewController.compositionEnd();
            this._context.viewModel.onCompositionEnd();
        }));
        this._register(this._textAreaInput.onFocus(()=>{
            this._context.viewModel.setHasFocus(true);
        }));
        this._register(this._textAreaInput.onBlur(()=>{
            this._context.viewModel.setHasFocus(false);
        }));
        this._register((0, _imeJs.IME).onDidChange(()=>{
            this._ensureReadOnlyAttribute();
        }));
    }
    writeScreenReaderContent(reason) {
        this._textAreaInput.writeNativeTextAreaContent(reason);
    }
    dispose() {
        super.dispose();
    }
    _getAndroidWordAtPosition(position) {
        const ANDROID_WORD_SEPARATORS = '`~!@#$%^&*()-=+[{]}\\|;:",.<>/?';
        const lineContent = this._context.viewModel.getLineContent(position.lineNumber);
        const wordSeparators = (0, _wordCharacterClassifierJs.getMapForWordSeparators)(ANDROID_WORD_SEPARATORS, []);
        let goingLeft = true;
        let startColumn = position.column;
        let goingRight = true;
        let endColumn = position.column;
        let distance = 0;
        while(distance < 50 && (goingLeft || goingRight)){
            if (goingLeft && startColumn <= 1) goingLeft = false;
            if (goingLeft) {
                const charCode = lineContent.charCodeAt(startColumn - 2);
                const charClass = wordSeparators.get(charCode);
                if (charClass !== 0 /* WordCharacterClass.Regular */ ) goingLeft = false;
                else startColumn--;
            }
            if (goingRight && endColumn > lineContent.length) goingRight = false;
            if (goingRight) {
                const charCode = lineContent.charCodeAt(endColumn - 1);
                const charClass = wordSeparators.get(charCode);
                if (charClass !== 0 /* WordCharacterClass.Regular */ ) goingRight = false;
                else endColumn++;
            }
            distance++;
        }
        return [
            lineContent.substring(startColumn - 1, endColumn - 1),
            position.column - startColumn
        ];
    }
    _getWordBeforePosition(position) {
        const lineContent = this._context.viewModel.getLineContent(position.lineNumber);
        const wordSeparators = (0, _wordCharacterClassifierJs.getMapForWordSeparators)(this._context.configuration.options.get(132 /* EditorOption.wordSeparators */ ), []);
        let column = position.column;
        let distance = 0;
        while(column > 1){
            const charCode = lineContent.charCodeAt(column - 2);
            const charClass = wordSeparators.get(charCode);
            if (charClass !== 0 /* WordCharacterClass.Regular */  || distance > 50) return lineContent.substring(column - 1, position.column - 1);
            distance++;
            column--;
        }
        return lineContent.substring(0, position.column - 1);
    }
    _getCharacterBeforePosition(position) {
        if (position.column > 1) {
            const lineContent = this._context.viewModel.getLineContent(position.lineNumber);
            const charBefore = lineContent.charAt(position.column - 2);
            if (!_stringsJs.isHighSurrogate(charBefore.charCodeAt(0))) return charBefore;
        }
        return "";
    }
    _getAriaLabel(options) {
        const accessibilitySupport = options.get(2 /* EditorOption.accessibilitySupport */ );
        if (accessibilitySupport === 1 /* AccessibilitySupport.Disabled */ ) {
            const toggleKeybindingLabel = this._keybindingService.lookupKeybinding("editor.action.toggleScreenReaderAccessibilityMode")?.getAriaLabel();
            const runCommandKeybindingLabel = this._keybindingService.lookupKeybinding("workbench.action.showCommands")?.getAriaLabel();
            const keybindingEditorKeybindingLabel = this._keybindingService.lookupKeybinding("workbench.action.openGlobalKeybindings")?.getAriaLabel();
            const editorNotAccessibleMessage = _nlsJs.localize("accessibilityModeOff", "The editor is not accessible at this time.");
            if (toggleKeybindingLabel) return _nlsJs.localize("accessibilityOffAriaLabel", "{0} To enable screen reader optimized mode, use {1}", editorNotAccessibleMessage, toggleKeybindingLabel);
            else if (runCommandKeybindingLabel) return _nlsJs.localize("accessibilityOffAriaLabelNoKb", "{0} To enable screen reader optimized mode, open the quick pick with {1} and run the command Toggle Screen Reader Accessibility Mode, which is currently not triggerable via keyboard.", editorNotAccessibleMessage, runCommandKeybindingLabel);
            else if (keybindingEditorKeybindingLabel) return _nlsJs.localize("accessibilityOffAriaLabelNoKbs", "{0} Please assign a keybinding for the command Toggle Screen Reader Accessibility Mode by accessing the keybindings editor with {1} and run it.", editorNotAccessibleMessage, keybindingEditorKeybindingLabel);
            else // SOS
            return editorNotAccessibleMessage;
        }
        return options.get(4 /* EditorOption.ariaLabel */ );
    }
    _setAccessibilityOptions(options) {
        this._accessibilitySupport = options.get(2 /* EditorOption.accessibilitySupport */ );
        const accessibilityPageSize = options.get(3 /* EditorOption.accessibilityPageSize */ );
        if (this._accessibilitySupport === 2 /* AccessibilitySupport.Enabled */  && accessibilityPageSize === (0, _editorOptionsJs.EditorOptions).accessibilityPageSize.defaultValue) // If a screen reader is attached and the default value is not set we should automatically increase the page size to 500 for a better experience
        this._accessibilityPageSize = 500;
        else this._accessibilityPageSize = accessibilityPageSize;
        // When wrapping is enabled and a screen reader might be attached,
        // we will size the textarea to match the width used for wrapping points computation (see `domLineBreaksComputer.ts`).
        // This is because screen readers will read the text in the textarea and we'd like that the
        // wrapping points in the textarea match the wrapping points in the editor.
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        const wrappingColumn = layoutInfo.wrappingColumn;
        if (wrappingColumn !== -1 && this._accessibilitySupport !== 1 /* AccessibilitySupport.Disabled */ ) {
            const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
            this._textAreaWrapping = true;
            this._textAreaWidth = Math.round(wrappingColumn * fontInfo.typicalHalfwidthCharacterWidth);
        } else {
            this._textAreaWrapping = false;
            this._textAreaWidth = canUseZeroSizeTextarea ? 0 : 1;
        }
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._setAccessibilityOptions(options);
        this._contentLeft = layoutInfo.contentLeft;
        this._contentWidth = layoutInfo.contentWidth;
        this._contentHeight = layoutInfo.height;
        this._fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this._emptySelectionClipboard = options.get(37 /* EditorOption.emptySelectionClipboard */ );
        this._copyWithSyntaxHighlighting = options.get(25 /* EditorOption.copyWithSyntaxHighlighting */ );
        this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
        const { tabSize } = this._context.viewModel.model.getOptions();
        this.textArea.domNode.style.tabSize = `${tabSize * this._fontInfo.spaceWidth}px`;
        this.textArea.setAttribute("aria-label", this._getAriaLabel(options));
        this.textArea.setAttribute("aria-required", options.get(5 /* EditorOption.ariaRequired */ ) ? "true" : "false");
        this.textArea.setAttribute("tabindex", String(options.get(125 /* EditorOption.tabIndex */ )));
        if (e.hasChanged(34 /* EditorOption.domReadOnly */ ) || e.hasChanged(92 /* EditorOption.readOnly */ )) this._ensureReadOnlyAttribute();
        if (e.hasChanged(2 /* EditorOption.accessibilitySupport */ )) this._textAreaInput.writeNativeTextAreaContent("strategy changed");
        return true;
    }
    onCursorStateChanged(e) {
        this._selections = e.selections.slice(0);
        this._modelSelections = e.modelSelections.slice(0);
        // We must update the <textarea> synchronously, otherwise long press IME on macos breaks.
        // See https://github.com/microsoft/vscode/issues/165821
        this._textAreaInput.writeNativeTextAreaContent("selection changed");
        return true;
    }
    onDecorationsChanged(e) {
        // true for inline decorations that can end up relayouting text
        return true;
    }
    onFlushed(e) {
        return true;
    }
    onLinesChanged(e) {
        return true;
    }
    onLinesDeleted(e) {
        return true;
    }
    onLinesInserted(e) {
        return true;
    }
    onScrollChanged(e) {
        this._scrollLeft = e.scrollLeft;
        this._scrollTop = e.scrollTop;
        return true;
    }
    onZonesChanged(e) {
        return true;
    }
    // --- end event handlers
    // --- begin view API
    isFocused() {
        return this._textAreaInput.isFocused();
    }
    focusTextArea() {
        this._textAreaInput.focusTextArea();
    }
    getLastRenderData() {
        return this._lastRenderPosition;
    }
    setAriaOptions(options) {
        if (options.activeDescendant) {
            this.textArea.setAttribute("aria-haspopup", "true");
            this.textArea.setAttribute("aria-autocomplete", "list");
            this.textArea.setAttribute("aria-activedescendant", options.activeDescendant);
        } else {
            this.textArea.setAttribute("aria-haspopup", "false");
            this.textArea.setAttribute("aria-autocomplete", "both");
            this.textArea.removeAttribute("aria-activedescendant");
        }
        if (options.role) this.textArea.setAttribute("role", options.role);
    }
    // --- end view API
    _ensureReadOnlyAttribute() {
        const options = this._context.configuration.options;
        // When someone requests to disable IME, we set the "readonly" attribute on the <textarea>.
        // This will prevent composition.
        const useReadOnly = !(0, _imeJs.IME).enabled || options.get(34 /* EditorOption.domReadOnly */ ) && options.get(92 /* EditorOption.readOnly */ );
        if (useReadOnly) this.textArea.setAttribute("readonly", "true");
        else this.textArea.removeAttribute("readonly");
    }
    prepareRender(ctx) {
        this._primaryCursorPosition = new (0, _positionJs.Position)(this._selections[0].positionLineNumber, this._selections[0].positionColumn);
        this._primaryCursorVisibleRange = ctx.visibleRangeForPosition(this._primaryCursorPosition);
        this._visibleTextArea?.prepareRender(ctx);
    }
    render(ctx) {
        this._textAreaInput.writeNativeTextAreaContent("render");
        this._render();
    }
    _render() {
        if (this._visibleTextArea) {
            // The text area is visible for composition reasons
            const visibleStart = this._visibleTextArea.visibleTextareaStart;
            const visibleEnd = this._visibleTextArea.visibleTextareaEnd;
            const startPosition = this._visibleTextArea.startPosition;
            const endPosition = this._visibleTextArea.endPosition;
            if (startPosition && endPosition && visibleStart && visibleEnd && visibleEnd.left >= this._scrollLeft && visibleStart.left <= this._scrollLeft + this._contentWidth) {
                const top = this._context.viewLayout.getVerticalOffsetForLineNumber(this._primaryCursorPosition.lineNumber) - this._scrollTop;
                const lineCount = this._newlinecount(this.textArea.domNode.value.substr(0, this.textArea.domNode.selectionStart));
                let scrollLeft = this._visibleTextArea.widthOfHiddenLineTextBefore;
                let left = this._contentLeft + visibleStart.left - this._scrollLeft;
                // See https://github.com/microsoft/vscode/issues/141725#issuecomment-1050670841
                // Here we are adding +1 to avoid flickering that might be caused by having a width that is too small.
                // This could be caused by rounding errors that might only show up with certain font families.
                // In other words, a pixel might be lost when doing something like
                //      `Math.round(end) - Math.round(start)`
                // vs
                //      `Math.round(end - start)`
                let width = visibleEnd.left - visibleStart.left + 1;
                if (left < this._contentLeft) {
                    // the textarea would be rendered on top of the margin,
                    // so reduce its width. We use the same technique as
                    // for hiding text before
                    const delta = this._contentLeft - left;
                    left += delta;
                    scrollLeft += delta;
                    width -= delta;
                }
                if (width > this._contentWidth) // the textarea would be wider than the content width,
                // so reduce its width.
                width = this._contentWidth;
                // Try to render the textarea with the color/font style to match the text under it
                const viewLineData = this._context.viewModel.getViewLineData(startPosition.lineNumber);
                const startTokenIndex = viewLineData.tokens.findTokenIndexAtOffset(startPosition.column - 1);
                const endTokenIndex = viewLineData.tokens.findTokenIndexAtOffset(endPosition.column - 1);
                const textareaSpansSingleToken = startTokenIndex === endTokenIndex;
                const presentation = this._visibleTextArea.definePresentation(textareaSpansSingleToken ? viewLineData.tokens.getPresentation(startTokenIndex) : null);
                this.textArea.domNode.scrollTop = lineCount * this._lineHeight;
                this.textArea.domNode.scrollLeft = scrollLeft;
                this._doRender({
                    lastRenderPosition: null,
                    top: top,
                    left: left,
                    width: width,
                    height: this._lineHeight,
                    useCover: false,
                    color: ((0, _languagesJs.TokenizationRegistry).getColorMap() || [])[presentation.foreground],
                    italic: presentation.italic,
                    bold: presentation.bold,
                    underline: presentation.underline,
                    strikethrough: presentation.strikethrough
                });
            }
            return;
        }
        if (!this._primaryCursorVisibleRange) {
            // The primary cursor is outside the viewport => place textarea to the top left
            this._renderAtTopLeft();
            return;
        }
        const left = this._contentLeft + this._primaryCursorVisibleRange.left - this._scrollLeft;
        if (left < this._contentLeft || left > this._contentLeft + this._contentWidth) {
            // cursor is outside the viewport
            this._renderAtTopLeft();
            return;
        }
        const top = this._context.viewLayout.getVerticalOffsetForLineNumber(this._selections[0].positionLineNumber) - this._scrollTop;
        if (top < 0 || top > this._contentHeight) {
            // cursor is outside the viewport
            this._renderAtTopLeft();
            return;
        }
        // The primary cursor is in the viewport (at least vertically) => place textarea on the cursor
        if (_platformJs.isMacintosh || this._accessibilitySupport === 2 /* AccessibilitySupport.Enabled */ ) {
            // For the popup emoji input, we will make the text area as high as the line height
            // We will also make the fontSize and lineHeight the correct dimensions to help with the placement of these pickers
            this._doRender({
                lastRenderPosition: this._primaryCursorPosition,
                top,
                left: this._textAreaWrapping ? this._contentLeft : left,
                width: this._textAreaWidth,
                height: this._lineHeight,
                useCover: false
            });
            // In case the textarea contains a word, we're going to try to align the textarea's cursor
            // with our cursor by scrolling the textarea as much as possible
            this.textArea.domNode.scrollLeft = this._primaryCursorVisibleRange.left;
            const lineCount = this._textAreaInput.textAreaState.newlineCountBeforeSelection ?? this._newlinecount(this.textArea.domNode.value.substr(0, this.textArea.domNode.selectionStart));
            this.textArea.domNode.scrollTop = lineCount * this._lineHeight;
            return;
        }
        this._doRender({
            lastRenderPosition: this._primaryCursorPosition,
            top: top,
            left: this._textAreaWrapping ? this._contentLeft : left,
            width: this._textAreaWidth,
            height: canUseZeroSizeTextarea ? 0 : 1,
            useCover: false
        });
    }
    _newlinecount(text) {
        let result = 0;
        let startIndex = -1;
        do {
            startIndex = text.indexOf("\n", startIndex + 1);
            if (startIndex === -1) break;
            result++;
        }while (true);
        return result;
    }
    _renderAtTopLeft() {
        // (in WebKit the textarea is 1px by 1px because it cannot handle input to a 0x0 textarea)
        // specifically, when doing Korean IME, setting the textarea to 0x0 breaks IME badly.
        this._doRender({
            lastRenderPosition: null,
            top: 0,
            left: 0,
            width: this._textAreaWidth,
            height: canUseZeroSizeTextarea ? 0 : 1,
            useCover: true
        });
    }
    _doRender(renderData) {
        this._lastRenderPosition = renderData.lastRenderPosition;
        const ta = this.textArea;
        const tac = this.textAreaCover;
        (0, _domFontInfoJs.applyFontInfo)(ta, this._fontInfo);
        ta.setTop(renderData.top);
        ta.setLeft(renderData.left);
        ta.setWidth(renderData.width);
        ta.setHeight(renderData.height);
        ta.setColor(renderData.color ? (0, _colorJs.Color).Format.CSS.formatHex(renderData.color) : "");
        ta.setFontStyle(renderData.italic ? "italic" : "");
        if (renderData.bold) // fontWeight is also set by `applyFontInfo`, so only overwrite it if necessary
        ta.setFontWeight("bold");
        ta.setTextDecoration(`${renderData.underline ? " underline" : ""}${renderData.strikethrough ? " line-through" : ""}`);
        tac.setTop(renderData.useCover ? renderData.top : 0);
        tac.setLeft(renderData.useCover ? renderData.left : 0);
        tac.setWidth(renderData.useCover ? renderData.width : 0);
        tac.setHeight(renderData.useCover ? renderData.height : 0);
        const options = this._context.configuration.options;
        if (options.get(57 /* EditorOption.glyphMargin */ )) tac.setClassName("monaco-editor-background textAreaCover " + (0, _marginJs.Margin).OUTER_CLASS_NAME);
        else if (options.get(68 /* EditorOption.lineNumbers */ ).renderType !== 0 /* RenderLineNumbersType.Off */ ) tac.setClassName("monaco-editor-background textAreaCover " + (0, _lineNumbersJs.LineNumbersOverlay).CLASS_NAME);
        else tac.setClassName("monaco-editor-background textAreaCover");
    }
};
TextAreaHandler = __decorate([
    __param(3, (0, _keybindingJs.IKeybindingService)),
    __param(4, (0, _instantiationJs.IInstantiationService))
], TextAreaHandler);
function measureText(targetDocument, text, fontInfo, tabSize) {
    if (text.length === 0) return 0;
    const container = targetDocument.createElement("div");
    container.style.position = "absolute";
    container.style.top = "-50000px";
    container.style.width = "50000px";
    const regularDomNode = targetDocument.createElement("span");
    (0, _domFontInfoJs.applyFontInfo)(regularDomNode, fontInfo);
    regularDomNode.style.whiteSpace = "pre"; // just like the textarea
    regularDomNode.style.tabSize = `${tabSize * fontInfo.spaceWidth}px`; // just like the textarea
    regularDomNode.append(text);
    container.appendChild(regularDomNode);
    targetDocument.body.appendChild(container);
    const res = regularDomNode.offsetWidth;
    container.remove();
    return res;
}

},{"./textAreaHandler.css":"h0duc","../../../nls.js":"l617d","../../../base/browser/browser.js":"4Zquf","../../../base/browser/fastDomNode.js":"2SADf","../../../base/common/platform.js":"7maJO","../../../base/common/strings.js":"aA9I1","../config/domFontInfo.js":"fQezv","./textAreaInput.js":"d7Bw3","./textAreaState.js":"ikXe1","../view/viewPart.js":"kTsLR","../viewParts/lineNumbers/lineNumbers.js":"7jBDo","../viewParts/margin/margin.js":"6wqez","../../common/config/editorOptions.js":"3Xi00","../../common/core/wordCharacterClassifier.js":"a4wPa","../../common/core/position.js":"lvrPe","../../common/core/range.js":"jmUPh","../../common/core/selection.js":"kcwzU","../../../base/browser/ui/mouseCursor/mouseCursor.js":"dizty","../../common/languages.js":"g5n96","../../../base/common/color.js":"at4gb","../../../base/common/ime.js":"iPFYF","../../../platform/keybinding/common/keybinding.js":"25pLT","../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h0duc":[function() {},{}],"7jBDo":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineNumbersOverlay", ()=>LineNumbersOverlay);
var _lineNumbersCss = require("./lineNumbers.css");
var _platformJs = require("../../../../base/common/platform.js");
var _dynamicViewOverlayJs = require("../../view/dynamicViewOverlay.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _editorColorRegistryJs = require("../../../common/core/editorColorRegistry.js");
class LineNumbersOverlay extends (0, _dynamicViewOverlayJs.DynamicViewOverlay) {
    static{
        this.CLASS_NAME = "line-numbers";
    }
    constructor(context){
        super();
        this._context = context;
        this._readConfig();
        this._lastCursorModelPosition = new (0, _positionJs.Position)(1, 1);
        this._renderResult = null;
        this._activeLineNumber = 1;
        this._context.addEventHandler(this);
    }
    _readConfig() {
        const options = this._context.configuration.options;
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        const lineNumbers = options.get(68 /* EditorOption.lineNumbers */ );
        this._renderLineNumbers = lineNumbers.renderType;
        this._renderCustomLineNumbers = lineNumbers.renderFn;
        this._renderFinalNewline = options.get(96 /* EditorOption.renderFinalNewline */ );
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._lineNumbersLeft = layoutInfo.lineNumbersLeft;
        this._lineNumbersWidth = layoutInfo.lineNumbersWidth;
    }
    dispose() {
        this._context.removeEventHandler(this);
        this._renderResult = null;
        super.dispose();
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        this._readConfig();
        return true;
    }
    onCursorStateChanged(e) {
        const primaryViewPosition = e.selections[0].getPosition();
        this._lastCursorModelPosition = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(primaryViewPosition);
        let shouldRender = false;
        if (this._activeLineNumber !== primaryViewPosition.lineNumber) {
            this._activeLineNumber = primaryViewPosition.lineNumber;
            shouldRender = true;
        }
        if (this._renderLineNumbers === 2 /* RenderLineNumbersType.Relative */  || this._renderLineNumbers === 3 /* RenderLineNumbersType.Interval */ ) shouldRender = true;
        return shouldRender;
    }
    onFlushed(e) {
        return true;
    }
    onLinesChanged(e) {
        return true;
    }
    onLinesDeleted(e) {
        return true;
    }
    onLinesInserted(e) {
        return true;
    }
    onScrollChanged(e) {
        return e.scrollTopChanged;
    }
    onZonesChanged(e) {
        return true;
    }
    onDecorationsChanged(e) {
        return e.affectsLineNumber;
    }
    // --- end event handlers
    _getLineRenderLineNumber(viewLineNumber) {
        const modelPosition = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new (0, _positionJs.Position)(viewLineNumber, 1));
        if (modelPosition.column !== 1) return "";
        const modelLineNumber = modelPosition.lineNumber;
        if (this._renderCustomLineNumbers) return this._renderCustomLineNumbers(modelLineNumber);
        if (this._renderLineNumbers === 2 /* RenderLineNumbersType.Relative */ ) {
            const diff = Math.abs(this._lastCursorModelPosition.lineNumber - modelLineNumber);
            if (diff === 0) return '<span class="relative-current-line-number">' + modelLineNumber + "</span>";
            return String(diff);
        }
        if (this._renderLineNumbers === 3 /* RenderLineNumbersType.Interval */ ) {
            if (this._lastCursorModelPosition.lineNumber === modelLineNumber) return String(modelLineNumber);
            if (modelLineNumber % 10 === 0) return String(modelLineNumber);
            const finalLineNumber = this._context.viewModel.getLineCount();
            if (modelLineNumber === finalLineNumber) return String(modelLineNumber);
            return "";
        }
        return String(modelLineNumber);
    }
    prepareRender(ctx) {
        if (this._renderLineNumbers === 0 /* RenderLineNumbersType.Off */ ) {
            this._renderResult = null;
            return;
        }
        const lineHeightClassName = _platformJs.isLinux ? this._lineHeight % 2 === 0 ? " lh-even" : " lh-odd" : "";
        const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        const lineNoDecorations = this._context.viewModel.getDecorationsInViewport(ctx.visibleRange).filter((d)=>!!d.options.lineNumberClassName);
        lineNoDecorations.sort((a, b)=>(0, _rangeJs.Range).compareRangesUsingEnds(a.range, b.range));
        let decorationStartIndex = 0;
        const lineCount = this._context.viewModel.getLineCount();
        const output = [];
        for(let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++){
            const lineIndex = lineNumber - visibleStartLineNumber;
            let renderLineNumber = this._getLineRenderLineNumber(lineNumber);
            let extraClassNames = "";
            // skip decorations whose end positions we've already passed
            while(decorationStartIndex < lineNoDecorations.length && lineNoDecorations[decorationStartIndex].range.endLineNumber < lineNumber)decorationStartIndex++;
            for(let i = decorationStartIndex; i < lineNoDecorations.length; i++){
                const { range, options } = lineNoDecorations[i];
                if (range.startLineNumber <= lineNumber) extraClassNames += " " + options.lineNumberClassName;
            }
            if (!renderLineNumber && !extraClassNames) {
                output[lineIndex] = "";
                continue;
            }
            if (lineNumber === lineCount && this._context.viewModel.getLineLength(lineNumber) === 0) {
                // this is the last line
                if (this._renderFinalNewline === "off") renderLineNumber = "";
                if (this._renderFinalNewline === "dimmed") extraClassNames += " dimmed-line-number";
            }
            if (lineNumber === this._activeLineNumber) extraClassNames += " active-line-number";
            output[lineIndex] = `<div class="${LineNumbersOverlay.CLASS_NAME}${lineHeightClassName}${extraClassNames}" style="left:${this._lineNumbersLeft}px;width:${this._lineNumbersWidth}px;">${renderLineNumber}</div>`;
        }
        this._renderResult = output;
    }
    render(startLineNumber, lineNumber) {
        if (!this._renderResult) return "";
        const lineIndex = lineNumber - startLineNumber;
        if (lineIndex < 0 || lineIndex >= this._renderResult.length) return "";
        return this._renderResult[lineIndex];
    }
}
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const editorLineNumbersColor = theme.getColor((0, _editorColorRegistryJs.editorLineNumbers));
    const editorDimmedLineNumberColor = theme.getColor((0, _editorColorRegistryJs.editorDimmedLineNumber));
    if (editorDimmedLineNumberColor) collector.addRule(`.monaco-editor .line-numbers.dimmed-line-number { color: ${editorDimmedLineNumberColor}; }`);
    else if (editorLineNumbersColor) collector.addRule(`.monaco-editor .line-numbers.dimmed-line-number { color: ${editorLineNumbersColor.transparent(0.4)}; }`);
});

},{"./lineNumbers.css":"8xaIP","../../../../base/common/platform.js":"7maJO","../../view/dynamicViewOverlay.js":"dULHQ","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../../platform/theme/common/themeService.js":"jMkIC","../../../common/core/editorColorRegistry.js":"5XqtL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8xaIP":[function() {},{}],"dULHQ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DynamicViewOverlay", ()=>DynamicViewOverlay);
var _viewEventHandlerJs = require("../../common/viewEventHandler.js");
class DynamicViewOverlay extends (0, _viewEventHandlerJs.ViewEventHandler) {
}

},{"../../common/viewEventHandler.js":"9pYyF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6wqez":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Margin", ()=>Margin);
var _marginCss = require("./margin.css");
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _viewPartJs = require("../../view/viewPart.js");
class Margin extends (0, _viewPartJs.ViewPart) {
    static{
        this.CLASS_NAME = "glyph-margin";
    }
    static{
        this.OUTER_CLASS_NAME = "margin";
    }
    constructor(context){
        super(context);
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._canUseLayerHinting = !options.get(32 /* EditorOption.disableLayerHinting */ );
        this._contentLeft = layoutInfo.contentLeft;
        this._glyphMarginLeft = layoutInfo.glyphMarginLeft;
        this._glyphMarginWidth = layoutInfo.glyphMarginWidth;
        this._domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this._domNode.setClassName(Margin.OUTER_CLASS_NAME);
        this._domNode.setPosition("absolute");
        this._domNode.setAttribute("role", "presentation");
        this._domNode.setAttribute("aria-hidden", "true");
        this._glyphMarginBackgroundDomNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this._glyphMarginBackgroundDomNode.setClassName(Margin.CLASS_NAME);
        this._domNode.appendChild(this._glyphMarginBackgroundDomNode);
    }
    dispose() {
        super.dispose();
    }
    getDomNode() {
        return this._domNode;
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._canUseLayerHinting = !options.get(32 /* EditorOption.disableLayerHinting */ );
        this._contentLeft = layoutInfo.contentLeft;
        this._glyphMarginLeft = layoutInfo.glyphMarginLeft;
        this._glyphMarginWidth = layoutInfo.glyphMarginWidth;
        return true;
    }
    onScrollChanged(e) {
        return super.onScrollChanged(e) || e.scrollTopChanged;
    }
    // --- end event handlers
    prepareRender(ctx) {
    // Nothing to read
    }
    render(ctx) {
        this._domNode.setLayerHinting(this._canUseLayerHinting);
        this._domNode.setContain("strict");
        const adjustedScrollTop = ctx.scrollTop - ctx.bigNumbersDelta;
        this._domNode.setTop(-adjustedScrollTop);
        const height = Math.min(ctx.scrollHeight, 1000000);
        this._domNode.setHeight(height);
        this._domNode.setWidth(this._contentLeft);
        this._glyphMarginBackgroundDomNode.setLeft(this._glyphMarginLeft);
        this._glyphMarginBackgroundDomNode.setWidth(this._glyphMarginWidth);
        this._glyphMarginBackgroundDomNode.setHeight(height);
    }
}

},{"./margin.css":"8Xy8D","../../../../base/browser/fastDomNode.js":"2SADf","../../view/viewPart.js":"kTsLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Xy8D":[function() {},{}],"dizty":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MOUSE_CURSOR_TEXT_CSS_CLASS_NAME", ()=>MOUSE_CURSOR_TEXT_CSS_CLASS_NAME);
var _mouseCursorCss = require("./mouseCursor.css");
const MOUSE_CURSOR_TEXT_CSS_CLASS_NAME = `monaco-mouse-cursor-text`;

},{"./mouseCursor.css":"7QWnP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7QWnP":[function() {},{}],"zgM61":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewController", ()=>ViewController);
var _coreCommandsJs = require("../coreCommands.js");
var _positionJs = require("../../common/core/position.js");
var _platformJs = require("../../../base/common/platform.js");
class ViewController {
    constructor(configuration, viewModel, userInputEvents, commandDelegate){
        this.configuration = configuration;
        this.viewModel = viewModel;
        this.userInputEvents = userInputEvents;
        this.commandDelegate = commandDelegate;
    }
    paste(text, pasteOnNewLine, multicursorText, mode) {
        this.commandDelegate.paste(text, pasteOnNewLine, multicursorText, mode);
    }
    type(text) {
        this.commandDelegate.type(text);
    }
    compositionType(text, replacePrevCharCnt, replaceNextCharCnt, positionDelta) {
        this.commandDelegate.compositionType(text, replacePrevCharCnt, replaceNextCharCnt, positionDelta);
    }
    compositionStart() {
        this.commandDelegate.startComposition();
    }
    compositionEnd() {
        this.commandDelegate.endComposition();
    }
    cut() {
        this.commandDelegate.cut();
    }
    setSelection(modelSelection) {
        (0, _coreCommandsJs.CoreNavigationCommands).SetSelection.runCoreEditorCommand(this.viewModel, {
            source: "keyboard",
            selection: modelSelection
        });
    }
    _validateViewColumn(viewPosition) {
        const minColumn = this.viewModel.getLineMinColumn(viewPosition.lineNumber);
        if (viewPosition.column < minColumn) return new (0, _positionJs.Position)(viewPosition.lineNumber, minColumn);
        return viewPosition;
    }
    _hasMulticursorModifier(data) {
        switch(this.configuration.options.get(78 /* EditorOption.multiCursorModifier */ )){
            case "altKey":
                return data.altKey;
            case "ctrlKey":
                return data.ctrlKey;
            case "metaKey":
                return data.metaKey;
            default:
                return false;
        }
    }
    _hasNonMulticursorModifier(data) {
        switch(this.configuration.options.get(78 /* EditorOption.multiCursorModifier */ )){
            case "altKey":
                return data.ctrlKey || data.metaKey;
            case "ctrlKey":
                return data.altKey || data.metaKey;
            case "metaKey":
                return data.ctrlKey || data.altKey;
            default:
                return false;
        }
    }
    dispatchMouse(data) {
        const options = this.configuration.options;
        const selectionClipboardIsOn = _platformJs.isLinux && options.get(108 /* EditorOption.selectionClipboard */ );
        const columnSelection = options.get(22 /* EditorOption.columnSelection */ );
        if (data.middleButton && !selectionClipboardIsOn) this._columnSelect(data.position, data.mouseColumn, data.inSelectionMode);
        else if (data.startedOnLineNumbers) {
            // If the dragging started on the gutter, then have operations work on the entire line
            if (this._hasMulticursorModifier(data)) {
                if (data.inSelectionMode) this._lastCursorLineSelect(data.position, data.revealType);
                else this._createCursor(data.position, true);
            } else if (data.inSelectionMode) this._lineSelectDrag(data.position, data.revealType);
            else this._lineSelect(data.position, data.revealType);
        } else if (data.mouseDownCount >= 4) this._selectAll();
        else if (data.mouseDownCount === 3) {
            if (this._hasMulticursorModifier(data)) {
                if (data.inSelectionMode) this._lastCursorLineSelectDrag(data.position, data.revealType);
                else this._lastCursorLineSelect(data.position, data.revealType);
            } else if (data.inSelectionMode) this._lineSelectDrag(data.position, data.revealType);
            else this._lineSelect(data.position, data.revealType);
        } else if (data.mouseDownCount === 2) {
            if (!data.onInjectedText) {
                if (this._hasMulticursorModifier(data)) this._lastCursorWordSelect(data.position, data.revealType);
                else if (data.inSelectionMode) this._wordSelectDrag(data.position, data.revealType);
                else this._wordSelect(data.position, data.revealType);
            }
        } else {
            if (this._hasMulticursorModifier(data)) {
                if (!this._hasNonMulticursorModifier(data)) {
                    if (data.shiftKey) this._columnSelect(data.position, data.mouseColumn, true);
                    else // Do multi-cursor operations only when purely alt is pressed
                    if (data.inSelectionMode) this._lastCursorMoveToSelect(data.position, data.revealType);
                    else this._createCursor(data.position, false);
                }
            } else if (data.inSelectionMode) {
                if (data.altKey) this._columnSelect(data.position, data.mouseColumn, true);
                else if (columnSelection) this._columnSelect(data.position, data.mouseColumn, true);
                else this._moveToSelect(data.position, data.revealType);
            } else this.moveTo(data.position, data.revealType);
        }
    }
    _usualArgs(viewPosition, revealType) {
        viewPosition = this._validateViewColumn(viewPosition);
        return {
            source: "mouse",
            position: this._convertViewToModelPosition(viewPosition),
            viewPosition,
            revealType
        };
    }
    moveTo(viewPosition, revealType) {
        (0, _coreCommandsJs.CoreNavigationCommands).MoveTo.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
    }
    _moveToSelect(viewPosition, revealType) {
        (0, _coreCommandsJs.CoreNavigationCommands).MoveToSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
    }
    _columnSelect(viewPosition, mouseColumn, doColumnSelect) {
        viewPosition = this._validateViewColumn(viewPosition);
        (0, _coreCommandsJs.CoreNavigationCommands).ColumnSelect.runCoreEditorCommand(this.viewModel, {
            source: "mouse",
            position: this._convertViewToModelPosition(viewPosition),
            viewPosition: viewPosition,
            mouseColumn: mouseColumn,
            doColumnSelect: doColumnSelect
        });
    }
    _createCursor(viewPosition, wholeLine) {
        viewPosition = this._validateViewColumn(viewPosition);
        (0, _coreCommandsJs.CoreNavigationCommands).CreateCursor.runCoreEditorCommand(this.viewModel, {
            source: "mouse",
            position: this._convertViewToModelPosition(viewPosition),
            viewPosition: viewPosition,
            wholeLine: wholeLine
        });
    }
    _lastCursorMoveToSelect(viewPosition, revealType) {
        (0, _coreCommandsJs.CoreNavigationCommands).LastCursorMoveToSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
    }
    _wordSelect(viewPosition, revealType) {
        (0, _coreCommandsJs.CoreNavigationCommands).WordSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
    }
    _wordSelectDrag(viewPosition, revealType) {
        (0, _coreCommandsJs.CoreNavigationCommands).WordSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
    }
    _lastCursorWordSelect(viewPosition, revealType) {
        (0, _coreCommandsJs.CoreNavigationCommands).LastCursorWordSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
    }
    _lineSelect(viewPosition, revealType) {
        (0, _coreCommandsJs.CoreNavigationCommands).LineSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
    }
    _lineSelectDrag(viewPosition, revealType) {
        (0, _coreCommandsJs.CoreNavigationCommands).LineSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
    }
    _lastCursorLineSelect(viewPosition, revealType) {
        (0, _coreCommandsJs.CoreNavigationCommands).LastCursorLineSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
    }
    _lastCursorLineSelectDrag(viewPosition, revealType) {
        (0, _coreCommandsJs.CoreNavigationCommands).LastCursorLineSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
    }
    _selectAll() {
        (0, _coreCommandsJs.CoreNavigationCommands).SelectAll.runCoreEditorCommand(this.viewModel, {
            source: "mouse"
        });
    }
    // ----------------------
    _convertViewToModelPosition(viewPosition) {
        return this.viewModel.coordinatesConverter.convertViewPositionToModelPosition(viewPosition);
    }
    emitKeyDown(e) {
        this.userInputEvents.emitKeyDown(e);
    }
    emitKeyUp(e) {
        this.userInputEvents.emitKeyUp(e);
    }
    emitContextMenu(e) {
        this.userInputEvents.emitContextMenu(e);
    }
    emitMouseMove(e) {
        this.userInputEvents.emitMouseMove(e);
    }
    emitMouseLeave(e) {
        this.userInputEvents.emitMouseLeave(e);
    }
    emitMouseUp(e) {
        this.userInputEvents.emitMouseUp(e);
    }
    emitMouseDown(e) {
        this.userInputEvents.emitMouseDown(e);
    }
    emitMouseDrag(e) {
        this.userInputEvents.emitMouseDrag(e);
    }
    emitMouseDrop(e) {
        this.userInputEvents.emitMouseDrop(e);
    }
    emitMouseDropCanceled() {
        this.userInputEvents.emitMouseDropCanceled();
    }
    emitMouseWheel(e) {
        this.userInputEvents.emitMouseWheel(e);
    }
}

},{"../coreCommands.js":"3GyQi","../../common/core/position.js":"lvrPe","../../../base/common/platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3GyQi":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoreEditorCommand", ()=>CoreEditorCommand);
parcelHelpers.export(exports, "EditorScroll_", ()=>EditorScroll_);
parcelHelpers.export(exports, "RevealLine_", ()=>RevealLine_);
parcelHelpers.export(exports, "CoreNavigationCommands", ()=>CoreNavigationCommands);
parcelHelpers.export(exports, "CoreEditingCommands", ()=>CoreEditingCommands);
var _nlsJs = require("../../nls.js");
var _browserJs = require("../../base/browser/browser.js");
var _typesJs = require("../../base/common/types.js");
var _ariaJs = require("../../base/browser/ui/aria/aria.js");
var _editorExtensionsJs = require("./editorExtensions.js");
var _codeEditorServiceJs = require("./services/codeEditorService.js");
var _cursorColumnSelectionJs = require("../common/cursor/cursorColumnSelection.js");
var _cursorCommonJs = require("../common/cursorCommon.js");
var _cursorDeleteOperationsJs = require("../common/cursor/cursorDeleteOperations.js");
var _cursorMoveCommandsJs = require("../common/cursor/cursorMoveCommands.js");
var _cursorTypeOperationsJs = require("../common/cursor/cursorTypeOperations.js");
var _positionJs = require("../common/core/position.js");
var _rangeJs = require("../common/core/range.js");
var _editorContextKeysJs = require("../common/editorContextKeys.js");
var _contextkeyJs = require("../../platform/contextkey/common/contextkey.js");
var _keybindingsRegistryJs = require("../../platform/keybinding/common/keybindingsRegistry.js");
var _domJs = require("../../base/browser/dom.js");
var _cursorTypeEditOperationsJs = require("../common/cursor/cursorTypeEditOperations.js");
const CORE_WEIGHT = 0 /* KeybindingWeight.EditorCore */ ;
class CoreEditorCommand extends (0, _editorExtensionsJs.EditorCommand) {
    runEditorCommand(accessor, editor, args) {
        const viewModel = editor._getViewModel();
        if (!viewModel) // the editor has no view => has no cursors
        return;
        this.runCoreEditorCommand(viewModel, args || {});
    }
}
var EditorScroll_;
(function(EditorScroll_) {
    const isEditorScrollArgs = function(arg) {
        if (!_typesJs.isObject(arg)) return false;
        const scrollArg = arg;
        if (!_typesJs.isString(scrollArg.to)) return false;
        if (!_typesJs.isUndefined(scrollArg.by) && !_typesJs.isString(scrollArg.by)) return false;
        if (!_typesJs.isUndefined(scrollArg.value) && !_typesJs.isNumber(scrollArg.value)) return false;
        if (!_typesJs.isUndefined(scrollArg.revealCursor) && !_typesJs.isBoolean(scrollArg.revealCursor)) return false;
        return true;
    };
    EditorScroll_.metadata = {
        description: "Scroll editor in the given direction",
        args: [
            {
                name: "Editor scroll argument object",
                description: `Property-value pairs that can be passed through this argument:
					* 'to': A mandatory direction value.
						\`\`\`
						'up', 'down'
						\`\`\`
					* 'by': Unit to move. Default is computed based on 'to' value.
						\`\`\`
						'line', 'wrappedLine', 'page', 'halfPage', 'editor'
						\`\`\`
					* 'value': Number of units to move. Default is '1'.
					* 'revealCursor': If 'true' reveals the cursor if it is outside view port.
				`,
                constraint: isEditorScrollArgs,
                schema: {
                    "type": "object",
                    "required": [
                        "to"
                    ],
                    "properties": {
                        "to": {
                            "type": "string",
                            "enum": [
                                "up",
                                "down"
                            ]
                        },
                        "by": {
                            "type": "string",
                            "enum": [
                                "line",
                                "wrappedLine",
                                "page",
                                "halfPage",
                                "editor"
                            ]
                        },
                        "value": {
                            "type": "number",
                            "default": 1
                        },
                        "revealCursor": {
                            "type": "boolean"
                        }
                    }
                }
            }
        ]
    };
    /**
     * Directions in the view for editor scroll command.
     */ EditorScroll_.RawDirection = {
        Up: "up",
        Right: "right",
        Down: "down",
        Left: "left"
    };
    /**
     * Units for editor scroll 'by' argument
     */ EditorScroll_.RawUnit = {
        Line: "line",
        WrappedLine: "wrappedLine",
        Page: "page",
        HalfPage: "halfPage",
        Editor: "editor",
        Column: "column"
    };
    function parse(args) {
        let direction;
        switch(args.to){
            case EditorScroll_.RawDirection.Up:
                direction = 1 /* Direction.Up */ ;
                break;
            case EditorScroll_.RawDirection.Right:
                direction = 2 /* Direction.Right */ ;
                break;
            case EditorScroll_.RawDirection.Down:
                direction = 3 /* Direction.Down */ ;
                break;
            case EditorScroll_.RawDirection.Left:
                direction = 4 /* Direction.Left */ ;
                break;
            default:
                // Illegal arguments
                return null;
        }
        let unit;
        switch(args.by){
            case EditorScroll_.RawUnit.Line:
                unit = 1 /* Unit.Line */ ;
                break;
            case EditorScroll_.RawUnit.WrappedLine:
                unit = 2 /* Unit.WrappedLine */ ;
                break;
            case EditorScroll_.RawUnit.Page:
                unit = 3 /* Unit.Page */ ;
                break;
            case EditorScroll_.RawUnit.HalfPage:
                unit = 4 /* Unit.HalfPage */ ;
                break;
            case EditorScroll_.RawUnit.Editor:
                unit = 5 /* Unit.Editor */ ;
                break;
            case EditorScroll_.RawUnit.Column:
                unit = 6 /* Unit.Column */ ;
                break;
            default:
                unit = 2 /* Unit.WrappedLine */ ;
        }
        const value = Math.floor(args.value || 1);
        const revealCursor = !!args.revealCursor;
        return {
            direction: direction,
            unit: unit,
            value: value,
            revealCursor: revealCursor,
            select: !!args.select
        };
    }
    EditorScroll_.parse = parse;
})(EditorScroll_ || (EditorScroll_ = {}));
var RevealLine_;
(function(RevealLine_) {
    const isRevealLineArgs = function(arg) {
        if (!_typesJs.isObject(arg)) return false;
        const reveaLineArg = arg;
        if (!_typesJs.isNumber(reveaLineArg.lineNumber) && !_typesJs.isString(reveaLineArg.lineNumber)) return false;
        if (!_typesJs.isUndefined(reveaLineArg.at) && !_typesJs.isString(reveaLineArg.at)) return false;
        return true;
    };
    RevealLine_.metadata = {
        description: "Reveal the given line at the given logical position",
        args: [
            {
                name: "Reveal line argument object",
                description: `Property-value pairs that can be passed through this argument:
					* 'lineNumber': A mandatory line number value.
					* 'at': Logical position at which line has to be revealed.
						\`\`\`
						'top', 'center', 'bottom'
						\`\`\`
				`,
                constraint: isRevealLineArgs,
                schema: {
                    "type": "object",
                    "required": [
                        "lineNumber"
                    ],
                    "properties": {
                        "lineNumber": {
                            "type": [
                                "number",
                                "string"
                            ]
                        },
                        "at": {
                            "type": "string",
                            "enum": [
                                "top",
                                "center",
                                "bottom"
                            ]
                        }
                    }
                }
            }
        ]
    };
    /**
     * Values for reveal line 'at' argument
     */ RevealLine_.RawAtArgument = {
        Top: "top",
        Center: "center",
        Bottom: "bottom"
    };
})(RevealLine_ || (RevealLine_ = {}));
class EditorOrNativeTextInputCommand {
    constructor(target){
        // 1. handle case when focus is in editor.
        target.addImplementation(10000, "code-editor", (accessor, args)=>{
            // Only if editor text focus (i.e. not if editor has widget focus).
            const focusedEditor = accessor.get((0, _codeEditorServiceJs.ICodeEditorService)).getFocusedCodeEditor();
            if (focusedEditor && focusedEditor.hasTextFocus()) return this._runEditorCommand(accessor, focusedEditor, args);
            return false;
        });
        // 2. handle case when focus is in some other `input` / `textarea`.
        target.addImplementation(1000, "generic-dom-input-textarea", (accessor, args)=>{
            // Only if focused on an element that allows for entering text
            const activeElement = (0, _domJs.getActiveElement)();
            if (activeElement && [
                "input",
                "textarea"
            ].indexOf(activeElement.tagName.toLowerCase()) >= 0) {
                this.runDOMCommand(activeElement);
                return true;
            }
            return false;
        });
        // 3. (default) handle case when focus is somewhere else.
        target.addImplementation(0, "generic-dom", (accessor, args)=>{
            // Redirecting to active editor
            const activeEditor = accessor.get((0, _codeEditorServiceJs.ICodeEditorService)).getActiveCodeEditor();
            if (activeEditor) {
                activeEditor.focus();
                return this._runEditorCommand(accessor, activeEditor, args);
            }
            return false;
        });
    }
    _runEditorCommand(accessor, editor, args) {
        const result = this.runEditorCommand(accessor, editor, args);
        if (result) return result;
        return true;
    }
}
var CoreNavigationCommands;
(function(CoreNavigationCommands) {
    class BaseMoveToCommand extends CoreEditorCommand {
        constructor(opts){
            super(opts);
            this._inSelectionMode = opts.inSelectionMode;
        }
        runCoreEditorCommand(viewModel, args) {
            if (!args.position) return;
            viewModel.model.pushStackElement();
            const cursorStateChanged = viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , [
                (0, _cursorMoveCommandsJs.CursorMoveCommands).moveTo(viewModel, viewModel.getPrimaryCursorState(), this._inSelectionMode, args.position, args.viewPosition)
            ]);
            if (cursorStateChanged && args.revealType !== 2 /* NavigationCommandRevealType.None */ ) viewModel.revealAllCursors(args.source, true, true);
        }
    }
    CoreNavigationCommands.MoveTo = (0, _editorExtensionsJs.registerEditorCommand)(new BaseMoveToCommand({
        id: "_moveTo",
        inSelectionMode: false,
        precondition: undefined
    }));
    CoreNavigationCommands.MoveToSelect = (0, _editorExtensionsJs.registerEditorCommand)(new BaseMoveToCommand({
        id: "_moveToSelect",
        inSelectionMode: true,
        precondition: undefined
    }));
    class ColumnSelectCommand extends CoreEditorCommand {
        runCoreEditorCommand(viewModel, args) {
            viewModel.model.pushStackElement();
            const result = this._getColumnSelectResult(viewModel, viewModel.getPrimaryCursorState(), viewModel.getCursorColumnSelectData(), args);
            if (result === null) // invalid arguments
            return;
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , result.viewStates.map((viewState)=>(0, _cursorCommonJs.CursorState).fromViewState(viewState)));
            viewModel.setCursorColumnSelectData({
                isReal: true,
                fromViewLineNumber: result.fromLineNumber,
                fromViewVisualColumn: result.fromVisualColumn,
                toViewLineNumber: result.toLineNumber,
                toViewVisualColumn: result.toVisualColumn
            });
            if (result.reversed) viewModel.revealTopMostCursor(args.source);
            else viewModel.revealBottomMostCursor(args.source);
        }
    }
    CoreNavigationCommands.ColumnSelect = (0, _editorExtensionsJs.registerEditorCommand)(new class extends ColumnSelectCommand {
        constructor(){
            super({
                id: "columnSelect",
                precondition: undefined
            });
        }
        _getColumnSelectResult(viewModel, primary, prevColumnSelectData, args) {
            if (typeof args.position === "undefined" || typeof args.viewPosition === "undefined" || typeof args.mouseColumn === "undefined") return null;
            // validate `args`
            const validatedPosition = viewModel.model.validatePosition(args.position);
            const validatedViewPosition = viewModel.coordinatesConverter.validateViewPosition(new (0, _positionJs.Position)(args.viewPosition.lineNumber, args.viewPosition.column), validatedPosition);
            const fromViewLineNumber = args.doColumnSelect ? prevColumnSelectData.fromViewLineNumber : validatedViewPosition.lineNumber;
            const fromViewVisualColumn = args.doColumnSelect ? prevColumnSelectData.fromViewVisualColumn : args.mouseColumn - 1;
            return (0, _cursorColumnSelectionJs.ColumnSelection).columnSelect(viewModel.cursorConfig, viewModel, fromViewLineNumber, fromViewVisualColumn, validatedViewPosition.lineNumber, args.mouseColumn - 1);
        }
    });
    CoreNavigationCommands.CursorColumnSelectLeft = (0, _editorExtensionsJs.registerEditorCommand)(new class extends ColumnSelectCommand {
        constructor(){
            super({
                id: "cursorColumnSelectLeft",
                precondition: undefined,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                    primary: 3599 /* KeyCode.LeftArrow */ ,
                    linux: {
                        primary: 0
                    }
                }
            });
        }
        _getColumnSelectResult(viewModel, primary, prevColumnSelectData, args) {
            return (0, _cursorColumnSelectionJs.ColumnSelection).columnSelectLeft(viewModel.cursorConfig, viewModel, prevColumnSelectData);
        }
    });
    CoreNavigationCommands.CursorColumnSelectRight = (0, _editorExtensionsJs.registerEditorCommand)(new class extends ColumnSelectCommand {
        constructor(){
            super({
                id: "cursorColumnSelectRight",
                precondition: undefined,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                    primary: 3601 /* KeyCode.RightArrow */ ,
                    linux: {
                        primary: 0
                    }
                }
            });
        }
        _getColumnSelectResult(viewModel, primary, prevColumnSelectData, args) {
            return (0, _cursorColumnSelectionJs.ColumnSelection).columnSelectRight(viewModel.cursorConfig, viewModel, prevColumnSelectData);
        }
    });
    class ColumnSelectUpCommand extends ColumnSelectCommand {
        constructor(opts){
            super(opts);
            this._isPaged = opts.isPaged;
        }
        _getColumnSelectResult(viewModel, primary, prevColumnSelectData, args) {
            return (0, _cursorColumnSelectionJs.ColumnSelection).columnSelectUp(viewModel.cursorConfig, viewModel, prevColumnSelectData, this._isPaged);
        }
    }
    CoreNavigationCommands.CursorColumnSelectUp = (0, _editorExtensionsJs.registerEditorCommand)(new ColumnSelectUpCommand({
        isPaged: false,
        id: "cursorColumnSelectUp",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 3600 /* KeyCode.UpArrow */ ,
            linux: {
                primary: 0
            }
        }
    }));
    CoreNavigationCommands.CursorColumnSelectPageUp = (0, _editorExtensionsJs.registerEditorCommand)(new ColumnSelectUpCommand({
        isPaged: true,
        id: "cursorColumnSelectPageUp",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 3595 /* KeyCode.PageUp */ ,
            linux: {
                primary: 0
            }
        }
    }));
    class ColumnSelectDownCommand extends ColumnSelectCommand {
        constructor(opts){
            super(opts);
            this._isPaged = opts.isPaged;
        }
        _getColumnSelectResult(viewModel, primary, prevColumnSelectData, args) {
            return (0, _cursorColumnSelectionJs.ColumnSelection).columnSelectDown(viewModel.cursorConfig, viewModel, prevColumnSelectData, this._isPaged);
        }
    }
    CoreNavigationCommands.CursorColumnSelectDown = (0, _editorExtensionsJs.registerEditorCommand)(new ColumnSelectDownCommand({
        isPaged: false,
        id: "cursorColumnSelectDown",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 3602 /* KeyCode.DownArrow */ ,
            linux: {
                primary: 0
            }
        }
    }));
    CoreNavigationCommands.CursorColumnSelectPageDown = (0, _editorExtensionsJs.registerEditorCommand)(new ColumnSelectDownCommand({
        isPaged: true,
        id: "cursorColumnSelectPageDown",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 3596 /* KeyCode.PageDown */ ,
            linux: {
                primary: 0
            }
        }
    }));
    class CursorMoveImpl extends CoreEditorCommand {
        constructor(){
            super({
                id: "cursorMove",
                precondition: undefined,
                metadata: (0, _cursorMoveCommandsJs.CursorMove).metadata
            });
        }
        runCoreEditorCommand(viewModel, args) {
            const parsed = (0, _cursorMoveCommandsJs.CursorMove).parse(args);
            if (!parsed) // illegal arguments
            return;
            this._runCursorMove(viewModel, args.source, parsed);
        }
        _runCursorMove(viewModel, source, args) {
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(source, 3 /* CursorChangeReason.Explicit */ , CursorMoveImpl._move(viewModel, viewModel.getCursorStates(), args));
            viewModel.revealAllCursors(source, true);
        }
        static _move(viewModel, cursors, args) {
            const inSelectionMode = args.select;
            const value = args.value;
            switch(args.direction){
                case 0 /* CursorMove_.Direction.Left */ :
                case 1 /* CursorMove_.Direction.Right */ :
                case 2 /* CursorMove_.Direction.Up */ :
                case 3 /* CursorMove_.Direction.Down */ :
                case 4 /* CursorMove_.Direction.PrevBlankLine */ :
                case 5 /* CursorMove_.Direction.NextBlankLine */ :
                case 6 /* CursorMove_.Direction.WrappedLineStart */ :
                case 7 /* CursorMove_.Direction.WrappedLineFirstNonWhitespaceCharacter */ :
                case 8 /* CursorMove_.Direction.WrappedLineColumnCenter */ :
                case 9 /* CursorMove_.Direction.WrappedLineEnd */ :
                case 10 /* CursorMove_.Direction.WrappedLineLastNonWhitespaceCharacter */ :
                    return (0, _cursorMoveCommandsJs.CursorMoveCommands).simpleMove(viewModel, cursors, args.direction, inSelectionMode, value, args.unit);
                case 11 /* CursorMove_.Direction.ViewPortTop */ :
                case 13 /* CursorMove_.Direction.ViewPortBottom */ :
                case 12 /* CursorMove_.Direction.ViewPortCenter */ :
                case 14 /* CursorMove_.Direction.ViewPortIfOutside */ :
                    return (0, _cursorMoveCommandsJs.CursorMoveCommands).viewportMove(viewModel, cursors, args.direction, inSelectionMode, value);
                default:
                    return null;
            }
        }
    }
    CoreNavigationCommands.CursorMoveImpl = CursorMoveImpl;
    CoreNavigationCommands.CursorMove = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveImpl());
    class CursorMoveBasedCommand extends CoreEditorCommand {
        constructor(opts){
            super(opts);
            this._staticArgs = opts.args;
        }
        runCoreEditorCommand(viewModel, dynamicArgs) {
            let args = this._staticArgs;
            if (this._staticArgs.value === -1 /* Constants.PAGE_SIZE_MARKER */ ) // -1 is a marker for page size
            args = {
                direction: this._staticArgs.direction,
                unit: this._staticArgs.unit,
                select: this._staticArgs.select,
                value: dynamicArgs.pageSize || viewModel.cursorConfig.pageSize
            };
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(dynamicArgs.source, 3 /* CursorChangeReason.Explicit */ , (0, _cursorMoveCommandsJs.CursorMoveCommands).simpleMove(viewModel, viewModel.getCursorStates(), args.direction, args.select, args.value, args.unit));
            viewModel.revealAllCursors(dynamicArgs.source, true);
        }
    }
    CoreNavigationCommands.CursorLeft = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveBasedCommand({
        args: {
            direction: 0 /* CursorMove_.Direction.Left */ ,
            unit: 0 /* CursorMove_.Unit.None */ ,
            select: false,
            value: 1
        },
        id: "cursorLeft",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 15 /* KeyCode.LeftArrow */ ,
            mac: {
                primary: 15 /* KeyCode.LeftArrow */ ,
                secondary: [
                    288 /* KeyCode.KeyB */ 
                ]
            }
        }
    }));
    CoreNavigationCommands.CursorLeftSelect = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveBasedCommand({
        args: {
            direction: 0 /* CursorMove_.Direction.Left */ ,
            unit: 0 /* CursorMove_.Unit.None */ ,
            select: true,
            value: 1
        },
        id: "cursorLeftSelect",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 1039 /* KeyCode.LeftArrow */ 
        }
    }));
    CoreNavigationCommands.CursorRight = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveBasedCommand({
        args: {
            direction: 1 /* CursorMove_.Direction.Right */ ,
            unit: 0 /* CursorMove_.Unit.None */ ,
            select: false,
            value: 1
        },
        id: "cursorRight",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 17 /* KeyCode.RightArrow */ ,
            mac: {
                primary: 17 /* KeyCode.RightArrow */ ,
                secondary: [
                    292 /* KeyCode.KeyF */ 
                ]
            }
        }
    }));
    CoreNavigationCommands.CursorRightSelect = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveBasedCommand({
        args: {
            direction: 1 /* CursorMove_.Direction.Right */ ,
            unit: 0 /* CursorMove_.Unit.None */ ,
            select: true,
            value: 1
        },
        id: "cursorRightSelect",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 1041 /* KeyCode.RightArrow */ 
        }
    }));
    CoreNavigationCommands.CursorUp = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveBasedCommand({
        args: {
            direction: 2 /* CursorMove_.Direction.Up */ ,
            unit: 2 /* CursorMove_.Unit.WrappedLine */ ,
            select: false,
            value: 1
        },
        id: "cursorUp",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 16 /* KeyCode.UpArrow */ ,
            mac: {
                primary: 16 /* KeyCode.UpArrow */ ,
                secondary: [
                    302 /* KeyCode.KeyP */ 
                ]
            }
        }
    }));
    CoreNavigationCommands.CursorUpSelect = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveBasedCommand({
        args: {
            direction: 2 /* CursorMove_.Direction.Up */ ,
            unit: 2 /* CursorMove_.Unit.WrappedLine */ ,
            select: true,
            value: 1
        },
        id: "cursorUpSelect",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 1040 /* KeyCode.UpArrow */ ,
            secondary: [
                3088 /* KeyCode.UpArrow */ 
            ],
            mac: {
                primary: 1040 /* KeyCode.UpArrow */ 
            },
            linux: {
                primary: 1040 /* KeyCode.UpArrow */ 
            }
        }
    }));
    CoreNavigationCommands.CursorPageUp = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveBasedCommand({
        args: {
            direction: 2 /* CursorMove_.Direction.Up */ ,
            unit: 2 /* CursorMove_.Unit.WrappedLine */ ,
            select: false,
            value: -1 /* Constants.PAGE_SIZE_MARKER */ 
        },
        id: "cursorPageUp",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 11 /* KeyCode.PageUp */ 
        }
    }));
    CoreNavigationCommands.CursorPageUpSelect = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveBasedCommand({
        args: {
            direction: 2 /* CursorMove_.Direction.Up */ ,
            unit: 2 /* CursorMove_.Unit.WrappedLine */ ,
            select: true,
            value: -1 /* Constants.PAGE_SIZE_MARKER */ 
        },
        id: "cursorPageUpSelect",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 1035 /* KeyCode.PageUp */ 
        }
    }));
    CoreNavigationCommands.CursorDown = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveBasedCommand({
        args: {
            direction: 3 /* CursorMove_.Direction.Down */ ,
            unit: 2 /* CursorMove_.Unit.WrappedLine */ ,
            select: false,
            value: 1
        },
        id: "cursorDown",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 18 /* KeyCode.DownArrow */ ,
            mac: {
                primary: 18 /* KeyCode.DownArrow */ ,
                secondary: [
                    300 /* KeyCode.KeyN */ 
                ]
            }
        }
    }));
    CoreNavigationCommands.CursorDownSelect = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveBasedCommand({
        args: {
            direction: 3 /* CursorMove_.Direction.Down */ ,
            unit: 2 /* CursorMove_.Unit.WrappedLine */ ,
            select: true,
            value: 1
        },
        id: "cursorDownSelect",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 1042 /* KeyCode.DownArrow */ ,
            secondary: [
                3090 /* KeyCode.DownArrow */ 
            ],
            mac: {
                primary: 1042 /* KeyCode.DownArrow */ 
            },
            linux: {
                primary: 1042 /* KeyCode.DownArrow */ 
            }
        }
    }));
    CoreNavigationCommands.CursorPageDown = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveBasedCommand({
        args: {
            direction: 3 /* CursorMove_.Direction.Down */ ,
            unit: 2 /* CursorMove_.Unit.WrappedLine */ ,
            select: false,
            value: -1 /* Constants.PAGE_SIZE_MARKER */ 
        },
        id: "cursorPageDown",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 12 /* KeyCode.PageDown */ 
        }
    }));
    CoreNavigationCommands.CursorPageDownSelect = (0, _editorExtensionsJs.registerEditorCommand)(new CursorMoveBasedCommand({
        args: {
            direction: 3 /* CursorMove_.Direction.Down */ ,
            unit: 2 /* CursorMove_.Unit.WrappedLine */ ,
            select: true,
            value: -1 /* Constants.PAGE_SIZE_MARKER */ 
        },
        id: "cursorPageDownSelect",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 1036 /* KeyCode.PageDown */ 
        }
    }));
    CoreNavigationCommands.CreateCursor = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "createCursor",
                precondition: undefined
            });
        }
        runCoreEditorCommand(viewModel, args) {
            if (!args.position) return;
            let newState;
            if (args.wholeLine) newState = (0, _cursorMoveCommandsJs.CursorMoveCommands).line(viewModel, viewModel.getPrimaryCursorState(), false, args.position, args.viewPosition);
            else newState = (0, _cursorMoveCommandsJs.CursorMoveCommands).moveTo(viewModel, viewModel.getPrimaryCursorState(), false, args.position, args.viewPosition);
            const states = viewModel.getCursorStates();
            // Check if we should remove a cursor (sort of like a toggle)
            if (states.length > 1) {
                const newModelPosition = newState.modelState ? newState.modelState.position : null;
                const newViewPosition = newState.viewState ? newState.viewState.position : null;
                for(let i = 0, len = states.length; i < len; i++){
                    const state = states[i];
                    if (newModelPosition && !state.modelState.selection.containsPosition(newModelPosition)) continue;
                    if (newViewPosition && !state.viewState.selection.containsPosition(newViewPosition)) continue;
                    // => Remove the cursor
                    states.splice(i, 1);
                    viewModel.model.pushStackElement();
                    viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , states);
                    return;
                }
            }
            // => Add the new cursor
            states.push(newState);
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , states);
        }
    });
    CoreNavigationCommands.LastCursorMoveToSelect = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "_lastCursorMoveToSelect",
                precondition: undefined
            });
        }
        runCoreEditorCommand(viewModel, args) {
            if (!args.position) return;
            const lastAddedCursorIndex = viewModel.getLastAddedCursorIndex();
            const states = viewModel.getCursorStates();
            const newStates = states.slice(0);
            newStates[lastAddedCursorIndex] = (0, _cursorMoveCommandsJs.CursorMoveCommands).moveTo(viewModel, states[lastAddedCursorIndex], true, args.position, args.viewPosition);
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , newStates);
        }
    });
    class HomeCommand extends CoreEditorCommand {
        constructor(opts){
            super(opts);
            this._inSelectionMode = opts.inSelectionMode;
        }
        runCoreEditorCommand(viewModel, args) {
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , (0, _cursorMoveCommandsJs.CursorMoveCommands).moveToBeginningOfLine(viewModel, viewModel.getCursorStates(), this._inSelectionMode));
            viewModel.revealAllCursors(args.source, true);
        }
    }
    CoreNavigationCommands.CursorHome = (0, _editorExtensionsJs.registerEditorCommand)(new HomeCommand({
        inSelectionMode: false,
        id: "cursorHome",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 14 /* KeyCode.Home */ ,
            mac: {
                primary: 14 /* KeyCode.Home */ ,
                secondary: [
                    2063 /* KeyCode.LeftArrow */ 
                ]
            }
        }
    }));
    CoreNavigationCommands.CursorHomeSelect = (0, _editorExtensionsJs.registerEditorCommand)(new HomeCommand({
        inSelectionMode: true,
        id: "cursorHomeSelect",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 1038 /* KeyCode.Home */ ,
            mac: {
                primary: 1038 /* KeyCode.Home */ ,
                secondary: [
                    3087 /* KeyCode.LeftArrow */ 
                ]
            }
        }
    }));
    class LineStartCommand extends CoreEditorCommand {
        constructor(opts){
            super(opts);
            this._inSelectionMode = opts.inSelectionMode;
        }
        runCoreEditorCommand(viewModel, args) {
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , this._exec(viewModel.getCursorStates()));
            viewModel.revealAllCursors(args.source, true);
        }
        _exec(cursors) {
            const result = [];
            for(let i = 0, len = cursors.length; i < len; i++){
                const cursor = cursors[i];
                const lineNumber = cursor.modelState.position.lineNumber;
                result[i] = (0, _cursorCommonJs.CursorState).fromModelState(cursor.modelState.move(this._inSelectionMode, lineNumber, 1, 0));
            }
            return result;
        }
    }
    CoreNavigationCommands.CursorLineStart = (0, _editorExtensionsJs.registerEditorCommand)(new LineStartCommand({
        inSelectionMode: false,
        id: "cursorLineStart",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 0,
            mac: {
                primary: 287 /* KeyCode.KeyA */ 
            }
        }
    }));
    CoreNavigationCommands.CursorLineStartSelect = (0, _editorExtensionsJs.registerEditorCommand)(new LineStartCommand({
        inSelectionMode: true,
        id: "cursorLineStartSelect",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 0,
            mac: {
                primary: 1311 /* KeyCode.KeyA */ 
            }
        }
    }));
    class EndCommand extends CoreEditorCommand {
        constructor(opts){
            super(opts);
            this._inSelectionMode = opts.inSelectionMode;
        }
        runCoreEditorCommand(viewModel, args) {
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , (0, _cursorMoveCommandsJs.CursorMoveCommands).moveToEndOfLine(viewModel, viewModel.getCursorStates(), this._inSelectionMode, args.sticky || false));
            viewModel.revealAllCursors(args.source, true);
        }
    }
    CoreNavigationCommands.CursorEnd = (0, _editorExtensionsJs.registerEditorCommand)(new EndCommand({
        inSelectionMode: false,
        id: "cursorEnd",
        precondition: undefined,
        kbOpts: {
            args: {
                sticky: false
            },
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 13 /* KeyCode.End */ ,
            mac: {
                primary: 13 /* KeyCode.End */ ,
                secondary: [
                    2065 /* KeyCode.RightArrow */ 
                ]
            }
        },
        metadata: {
            description: `Go to End`,
            args: [
                {
                    name: "args",
                    schema: {
                        type: "object",
                        properties: {
                            "sticky": {
                                description: _nlsJs.localize("stickydesc", "Stick to the end even when going to longer lines"),
                                type: "boolean",
                                default: false
                            }
                        }
                    }
                }
            ]
        }
    }));
    CoreNavigationCommands.CursorEndSelect = (0, _editorExtensionsJs.registerEditorCommand)(new EndCommand({
        inSelectionMode: true,
        id: "cursorEndSelect",
        precondition: undefined,
        kbOpts: {
            args: {
                sticky: false
            },
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 1037 /* KeyCode.End */ ,
            mac: {
                primary: 1037 /* KeyCode.End */ ,
                secondary: [
                    3089 /* KeyCode.RightArrow */ 
                ]
            }
        },
        metadata: {
            description: `Select to End`,
            args: [
                {
                    name: "args",
                    schema: {
                        type: "object",
                        properties: {
                            "sticky": {
                                description: _nlsJs.localize("stickydesc", "Stick to the end even when going to longer lines"),
                                type: "boolean",
                                default: false
                            }
                        }
                    }
                }
            ]
        }
    }));
    class LineEndCommand extends CoreEditorCommand {
        constructor(opts){
            super(opts);
            this._inSelectionMode = opts.inSelectionMode;
        }
        runCoreEditorCommand(viewModel, args) {
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , this._exec(viewModel, viewModel.getCursorStates()));
            viewModel.revealAllCursors(args.source, true);
        }
        _exec(viewModel, cursors) {
            const result = [];
            for(let i = 0, len = cursors.length; i < len; i++){
                const cursor = cursors[i];
                const lineNumber = cursor.modelState.position.lineNumber;
                const maxColumn = viewModel.model.getLineMaxColumn(lineNumber);
                result[i] = (0, _cursorCommonJs.CursorState).fromModelState(cursor.modelState.move(this._inSelectionMode, lineNumber, maxColumn, 0));
            }
            return result;
        }
    }
    CoreNavigationCommands.CursorLineEnd = (0, _editorExtensionsJs.registerEditorCommand)(new LineEndCommand({
        inSelectionMode: false,
        id: "cursorLineEnd",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 0,
            mac: {
                primary: 291 /* KeyCode.KeyE */ 
            }
        }
    }));
    CoreNavigationCommands.CursorLineEndSelect = (0, _editorExtensionsJs.registerEditorCommand)(new LineEndCommand({
        inSelectionMode: true,
        id: "cursorLineEndSelect",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 0,
            mac: {
                primary: 1315 /* KeyCode.KeyE */ 
            }
        }
    }));
    class TopCommand extends CoreEditorCommand {
        constructor(opts){
            super(opts);
            this._inSelectionMode = opts.inSelectionMode;
        }
        runCoreEditorCommand(viewModel, args) {
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , (0, _cursorMoveCommandsJs.CursorMoveCommands).moveToBeginningOfBuffer(viewModel, viewModel.getCursorStates(), this._inSelectionMode));
            viewModel.revealAllCursors(args.source, true);
        }
    }
    CoreNavigationCommands.CursorTop = (0, _editorExtensionsJs.registerEditorCommand)(new TopCommand({
        inSelectionMode: false,
        id: "cursorTop",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 2062 /* KeyCode.Home */ ,
            mac: {
                primary: 2064 /* KeyCode.UpArrow */ 
            }
        }
    }));
    CoreNavigationCommands.CursorTopSelect = (0, _editorExtensionsJs.registerEditorCommand)(new TopCommand({
        inSelectionMode: true,
        id: "cursorTopSelect",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 3086 /* KeyCode.Home */ ,
            mac: {
                primary: 3088 /* KeyCode.UpArrow */ 
            }
        }
    }));
    class BottomCommand extends CoreEditorCommand {
        constructor(opts){
            super(opts);
            this._inSelectionMode = opts.inSelectionMode;
        }
        runCoreEditorCommand(viewModel, args) {
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , (0, _cursorMoveCommandsJs.CursorMoveCommands).moveToEndOfBuffer(viewModel, viewModel.getCursorStates(), this._inSelectionMode));
            viewModel.revealAllCursors(args.source, true);
        }
    }
    CoreNavigationCommands.CursorBottom = (0, _editorExtensionsJs.registerEditorCommand)(new BottomCommand({
        inSelectionMode: false,
        id: "cursorBottom",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 2061 /* KeyCode.End */ ,
            mac: {
                primary: 2066 /* KeyCode.DownArrow */ 
            }
        }
    }));
    CoreNavigationCommands.CursorBottomSelect = (0, _editorExtensionsJs.registerEditorCommand)(new BottomCommand({
        inSelectionMode: true,
        id: "cursorBottomSelect",
        precondition: undefined,
        kbOpts: {
            weight: CORE_WEIGHT,
            kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
            primary: 3085 /* KeyCode.End */ ,
            mac: {
                primary: 3090 /* KeyCode.DownArrow */ 
            }
        }
    }));
    class EditorScrollImpl extends CoreEditorCommand {
        constructor(){
            super({
                id: "editorScroll",
                precondition: undefined,
                metadata: EditorScroll_.metadata
            });
        }
        determineScrollMethod(args) {
            const horizontalUnits = [
                6 /* EditorScroll_.Unit.Column */ 
            ];
            const verticalUnits = [
                1 /* EditorScroll_.Unit.Line */ ,
                2 /* EditorScroll_.Unit.WrappedLine */ ,
                3 /* EditorScroll_.Unit.Page */ ,
                4 /* EditorScroll_.Unit.HalfPage */ ,
                5 /* EditorScroll_.Unit.Editor */ ,
                6 /* EditorScroll_.Unit.Column */ 
            ];
            const horizontalDirections = [
                4 /* EditorScroll_.Direction.Left */ ,
                2 /* EditorScroll_.Direction.Right */ 
            ];
            const verticalDirections = [
                1 /* EditorScroll_.Direction.Up */ ,
                3 /* EditorScroll_.Direction.Down */ 
            ];
            if (horizontalUnits.includes(args.unit) && horizontalDirections.includes(args.direction)) return this._runHorizontalEditorScroll.bind(this);
            if (verticalUnits.includes(args.unit) && verticalDirections.includes(args.direction)) return this._runVerticalEditorScroll.bind(this);
            return null;
        }
        runCoreEditorCommand(viewModel, args) {
            const parsed = EditorScroll_.parse(args);
            if (!parsed) // illegal arguments
            return;
            const runEditorScroll = this.determineScrollMethod(parsed);
            if (!runEditorScroll) // Incompatible unit and direction
            return;
            runEditorScroll(viewModel, args.source, parsed);
        }
        _runVerticalEditorScroll(viewModel, source, args) {
            const desiredScrollTop = this._computeDesiredScrollTop(viewModel, args);
            if (args.revealCursor) {
                // must ensure cursor is in new visible range
                const desiredVisibleViewRange = viewModel.getCompletelyVisibleViewRangeAtScrollTop(desiredScrollTop);
                viewModel.setCursorStates(source, 3 /* CursorChangeReason.Explicit */ , [
                    (0, _cursorMoveCommandsJs.CursorMoveCommands).findPositionInViewportIfOutside(viewModel, viewModel.getPrimaryCursorState(), desiredVisibleViewRange, args.select)
                ]);
            }
            viewModel.viewLayout.setScrollPosition({
                scrollTop: desiredScrollTop
            }, 0 /* ScrollType.Smooth */ );
        }
        _computeDesiredScrollTop(viewModel, args) {
            if (args.unit === 1 /* EditorScroll_.Unit.Line */ ) {
                // scrolling by model lines
                const futureViewport = viewModel.viewLayout.getFutureViewport();
                const visibleViewRange = viewModel.getCompletelyVisibleViewRangeAtScrollTop(futureViewport.top);
                const visibleModelRange = viewModel.coordinatesConverter.convertViewRangeToModelRange(visibleViewRange);
                let desiredTopModelLineNumber;
                if (args.direction === 1 /* EditorScroll_.Direction.Up */ ) // must go x model lines up
                desiredTopModelLineNumber = Math.max(1, visibleModelRange.startLineNumber - args.value);
                else // must go x model lines down
                desiredTopModelLineNumber = Math.min(viewModel.model.getLineCount(), visibleModelRange.startLineNumber + args.value);
                const viewPosition = viewModel.coordinatesConverter.convertModelPositionToViewPosition(new (0, _positionJs.Position)(desiredTopModelLineNumber, 1));
                return viewModel.viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber);
            }
            if (args.unit === 5 /* EditorScroll_.Unit.Editor */ ) {
                let desiredTopModelLineNumber = 0;
                if (args.direction === 3 /* EditorScroll_.Direction.Down */ ) desiredTopModelLineNumber = viewModel.model.getLineCount() - viewModel.cursorConfig.pageSize;
                return viewModel.viewLayout.getVerticalOffsetForLineNumber(desiredTopModelLineNumber);
            }
            let noOfLines;
            if (args.unit === 3 /* EditorScroll_.Unit.Page */ ) noOfLines = viewModel.cursorConfig.pageSize * args.value;
            else if (args.unit === 4 /* EditorScroll_.Unit.HalfPage */ ) noOfLines = Math.round(viewModel.cursorConfig.pageSize / 2) * args.value;
            else noOfLines = args.value;
            const deltaLines = (args.direction === 1 /* EditorScroll_.Direction.Up */  ? -1 : 1) * noOfLines;
            return viewModel.viewLayout.getCurrentScrollTop() + deltaLines * viewModel.cursorConfig.lineHeight;
        }
        _runHorizontalEditorScroll(viewModel, source, args) {
            const desiredScrollLeft = this._computeDesiredScrollLeft(viewModel, args);
            viewModel.viewLayout.setScrollPosition({
                scrollLeft: desiredScrollLeft
            }, 0 /* ScrollType.Smooth */ );
        }
        _computeDesiredScrollLeft(viewModel, args) {
            const deltaColumns = (args.direction === 4 /* EditorScroll_.Direction.Left */  ? -1 : 1) * args.value;
            return viewModel.viewLayout.getCurrentScrollLeft() + deltaColumns * viewModel.cursorConfig.typicalHalfwidthCharacterWidth;
        }
    }
    CoreNavigationCommands.EditorScrollImpl = EditorScrollImpl;
    CoreNavigationCommands.EditorScroll = (0, _editorExtensionsJs.registerEditorCommand)(new EditorScrollImpl());
    CoreNavigationCommands.ScrollLineUp = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "scrollLineUp",
                precondition: undefined,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                    primary: 2064 /* KeyCode.UpArrow */ ,
                    mac: {
                        primary: 267 /* KeyCode.PageUp */ 
                    }
                }
            });
        }
        runCoreEditorCommand(viewModel, args) {
            CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
                to: EditorScroll_.RawDirection.Up,
                by: EditorScroll_.RawUnit.WrappedLine,
                value: 1,
                revealCursor: false,
                select: false,
                source: args.source
            });
        }
    });
    CoreNavigationCommands.ScrollPageUp = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "scrollPageUp",
                precondition: undefined,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                    primary: 2059 /* KeyCode.PageUp */ ,
                    win: {
                        primary: 523 /* KeyCode.PageUp */ 
                    },
                    linux: {
                        primary: 523 /* KeyCode.PageUp */ 
                    }
                }
            });
        }
        runCoreEditorCommand(viewModel, args) {
            CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
                to: EditorScroll_.RawDirection.Up,
                by: EditorScroll_.RawUnit.Page,
                value: 1,
                revealCursor: false,
                select: false,
                source: args.source
            });
        }
    });
    CoreNavigationCommands.ScrollEditorTop = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "scrollEditorTop",
                precondition: undefined,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus
                }
            });
        }
        runCoreEditorCommand(viewModel, args) {
            CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
                to: EditorScroll_.RawDirection.Up,
                by: EditorScroll_.RawUnit.Editor,
                value: 1,
                revealCursor: false,
                select: false,
                source: args.source
            });
        }
    });
    CoreNavigationCommands.ScrollLineDown = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "scrollLineDown",
                precondition: undefined,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                    primary: 2066 /* KeyCode.DownArrow */ ,
                    mac: {
                        primary: 268 /* KeyCode.PageDown */ 
                    }
                }
            });
        }
        runCoreEditorCommand(viewModel, args) {
            CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
                to: EditorScroll_.RawDirection.Down,
                by: EditorScroll_.RawUnit.WrappedLine,
                value: 1,
                revealCursor: false,
                select: false,
                source: args.source
            });
        }
    });
    CoreNavigationCommands.ScrollPageDown = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "scrollPageDown",
                precondition: undefined,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                    primary: 2060 /* KeyCode.PageDown */ ,
                    win: {
                        primary: 524 /* KeyCode.PageDown */ 
                    },
                    linux: {
                        primary: 524 /* KeyCode.PageDown */ 
                    }
                }
            });
        }
        runCoreEditorCommand(viewModel, args) {
            CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
                to: EditorScroll_.RawDirection.Down,
                by: EditorScroll_.RawUnit.Page,
                value: 1,
                revealCursor: false,
                select: false,
                source: args.source
            });
        }
    });
    CoreNavigationCommands.ScrollEditorBottom = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "scrollEditorBottom",
                precondition: undefined,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus
                }
            });
        }
        runCoreEditorCommand(viewModel, args) {
            CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
                to: EditorScroll_.RawDirection.Down,
                by: EditorScroll_.RawUnit.Editor,
                value: 1,
                revealCursor: false,
                select: false,
                source: args.source
            });
        }
    });
    CoreNavigationCommands.ScrollLeft = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "scrollLeft",
                precondition: undefined,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus
                }
            });
        }
        runCoreEditorCommand(viewModel, args) {
            CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
                to: EditorScroll_.RawDirection.Left,
                by: EditorScroll_.RawUnit.Column,
                value: 2,
                revealCursor: false,
                select: false,
                source: args.source
            });
        }
    });
    CoreNavigationCommands.ScrollRight = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "scrollRight",
                precondition: undefined,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus
                }
            });
        }
        runCoreEditorCommand(viewModel, args) {
            CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
                to: EditorScroll_.RawDirection.Right,
                by: EditorScroll_.RawUnit.Column,
                value: 2,
                revealCursor: false,
                select: false,
                source: args.source
            });
        }
    });
    class WordCommand extends CoreEditorCommand {
        constructor(opts){
            super(opts);
            this._inSelectionMode = opts.inSelectionMode;
        }
        runCoreEditorCommand(viewModel, args) {
            if (!args.position) return;
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , [
                (0, _cursorMoveCommandsJs.CursorMoveCommands).word(viewModel, viewModel.getPrimaryCursorState(), this._inSelectionMode, args.position)
            ]);
            if (args.revealType !== 2 /* NavigationCommandRevealType.None */ ) viewModel.revealAllCursors(args.source, true, true);
        }
    }
    CoreNavigationCommands.WordSelect = (0, _editorExtensionsJs.registerEditorCommand)(new WordCommand({
        inSelectionMode: false,
        id: "_wordSelect",
        precondition: undefined
    }));
    CoreNavigationCommands.WordSelectDrag = (0, _editorExtensionsJs.registerEditorCommand)(new WordCommand({
        inSelectionMode: true,
        id: "_wordSelectDrag",
        precondition: undefined
    }));
    CoreNavigationCommands.LastCursorWordSelect = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "lastCursorWordSelect",
                precondition: undefined
            });
        }
        runCoreEditorCommand(viewModel, args) {
            if (!args.position) return;
            const lastAddedCursorIndex = viewModel.getLastAddedCursorIndex();
            const states = viewModel.getCursorStates();
            const newStates = states.slice(0);
            const lastAddedState = states[lastAddedCursorIndex];
            newStates[lastAddedCursorIndex] = (0, _cursorMoveCommandsJs.CursorMoveCommands).word(viewModel, lastAddedState, lastAddedState.modelState.hasSelection(), args.position);
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , newStates);
        }
    });
    class LineCommand extends CoreEditorCommand {
        constructor(opts){
            super(opts);
            this._inSelectionMode = opts.inSelectionMode;
        }
        runCoreEditorCommand(viewModel, args) {
            if (!args.position) return;
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , [
                (0, _cursorMoveCommandsJs.CursorMoveCommands).line(viewModel, viewModel.getPrimaryCursorState(), this._inSelectionMode, args.position, args.viewPosition)
            ]);
            if (args.revealType !== 2 /* NavigationCommandRevealType.None */ ) viewModel.revealAllCursors(args.source, false, true);
        }
    }
    CoreNavigationCommands.LineSelect = (0, _editorExtensionsJs.registerEditorCommand)(new LineCommand({
        inSelectionMode: false,
        id: "_lineSelect",
        precondition: undefined
    }));
    CoreNavigationCommands.LineSelectDrag = (0, _editorExtensionsJs.registerEditorCommand)(new LineCommand({
        inSelectionMode: true,
        id: "_lineSelectDrag",
        precondition: undefined
    }));
    class LastCursorLineCommand extends CoreEditorCommand {
        constructor(opts){
            super(opts);
            this._inSelectionMode = opts.inSelectionMode;
        }
        runCoreEditorCommand(viewModel, args) {
            if (!args.position) return;
            const lastAddedCursorIndex = viewModel.getLastAddedCursorIndex();
            const states = viewModel.getCursorStates();
            const newStates = states.slice(0);
            newStates[lastAddedCursorIndex] = (0, _cursorMoveCommandsJs.CursorMoveCommands).line(viewModel, states[lastAddedCursorIndex], this._inSelectionMode, args.position, args.viewPosition);
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , newStates);
        }
    }
    CoreNavigationCommands.LastCursorLineSelect = (0, _editorExtensionsJs.registerEditorCommand)(new LastCursorLineCommand({
        inSelectionMode: false,
        id: "lastCursorLineSelect",
        precondition: undefined
    }));
    CoreNavigationCommands.LastCursorLineSelectDrag = (0, _editorExtensionsJs.registerEditorCommand)(new LastCursorLineCommand({
        inSelectionMode: true,
        id: "lastCursorLineSelectDrag",
        precondition: undefined
    }));
    CoreNavigationCommands.CancelSelection = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "cancelSelection",
                precondition: (0, _editorContextKeysJs.EditorContextKeys).hasNonEmptySelection,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                    primary: 9 /* KeyCode.Escape */ ,
                    secondary: [
                        1033 /* KeyCode.Escape */ 
                    ]
                }
            });
        }
        runCoreEditorCommand(viewModel, args) {
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , [
                (0, _cursorMoveCommandsJs.CursorMoveCommands).cancelSelection(viewModel, viewModel.getPrimaryCursorState())
            ]);
            viewModel.revealAllCursors(args.source, true);
        }
    });
    CoreNavigationCommands.RemoveSecondaryCursors = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "removeSecondaryCursors",
                precondition: (0, _editorContextKeysJs.EditorContextKeys).hasMultipleSelections,
                kbOpts: {
                    weight: CORE_WEIGHT + 1,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                    primary: 9 /* KeyCode.Escape */ ,
                    secondary: [
                        1033 /* KeyCode.Escape */ 
                    ]
                }
            });
        }
        runCoreEditorCommand(viewModel, args) {
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , [
                viewModel.getPrimaryCursorState()
            ]);
            viewModel.revealAllCursors(args.source, true);
            (0, _ariaJs.status)(_nlsJs.localize("removedCursor", "Removed secondary cursors"));
        }
    });
    CoreNavigationCommands.RevealLine = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "revealLine",
                precondition: undefined,
                metadata: RevealLine_.metadata
            });
        }
        runCoreEditorCommand(viewModel, args) {
            const revealLineArg = args;
            const lineNumberArg = revealLineArg.lineNumber || 0;
            let lineNumber = typeof lineNumberArg === "number" ? lineNumberArg + 1 : parseInt(lineNumberArg) + 1;
            if (lineNumber < 1) lineNumber = 1;
            const lineCount = viewModel.model.getLineCount();
            if (lineNumber > lineCount) lineNumber = lineCount;
            const range = new (0, _rangeJs.Range)(lineNumber, 1, lineNumber, viewModel.model.getLineMaxColumn(lineNumber));
            let revealAt = 0 /* VerticalRevealType.Simple */ ;
            if (revealLineArg.at) switch(revealLineArg.at){
                case RevealLine_.RawAtArgument.Top:
                    revealAt = 3 /* VerticalRevealType.Top */ ;
                    break;
                case RevealLine_.RawAtArgument.Center:
                    revealAt = 1 /* VerticalRevealType.Center */ ;
                    break;
                case RevealLine_.RawAtArgument.Bottom:
                    revealAt = 4 /* VerticalRevealType.Bottom */ ;
                    break;
                default:
                    break;
            }
            const viewRange = viewModel.coordinatesConverter.convertModelRangeToViewRange(range);
            viewModel.revealRange(args.source, false, viewRange, revealAt, 0 /* ScrollType.Smooth */ );
        }
    });
    CoreNavigationCommands.SelectAll = new class extends EditorOrNativeTextInputCommand {
        constructor(){
            super((0, _editorExtensionsJs.SelectAllCommand));
        }
        runDOMCommand(activeElement) {
            if (0, _browserJs.isFirefox) {
                activeElement.focus();
                activeElement.select();
            }
            activeElement.ownerDocument.execCommand("selectAll");
        }
        runEditorCommand(accessor, editor, args) {
            const viewModel = editor._getViewModel();
            if (!viewModel) // the editor has no view => has no cursors
            return;
            this.runCoreEditorCommand(viewModel, args);
        }
        runCoreEditorCommand(viewModel, args) {
            viewModel.model.pushStackElement();
            viewModel.setCursorStates("keyboard", 3 /* CursorChangeReason.Explicit */ , [
                (0, _cursorMoveCommandsJs.CursorMoveCommands).selectAll(viewModel, viewModel.getPrimaryCursorState())
            ]);
        }
    }();
    CoreNavigationCommands.SetSelection = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditorCommand {
        constructor(){
            super({
                id: "setSelection",
                precondition: undefined
            });
        }
        runCoreEditorCommand(viewModel, args) {
            if (!args.selection) return;
            viewModel.model.pushStackElement();
            viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , [
                (0, _cursorCommonJs.CursorState).fromModelSelection(args.selection)
            ]);
        }
    });
})(CoreNavigationCommands || (CoreNavigationCommands = {}));
const columnSelectionCondition = (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).textInputFocus, (0, _editorContextKeysJs.EditorContextKeys).columnSelection);
function registerColumnSelection(id, keybinding) {
    (0, _keybindingsRegistryJs.KeybindingsRegistry).registerKeybindingRule({
        id: id,
        primary: keybinding,
        when: columnSelectionCondition,
        weight: CORE_WEIGHT + 1
    });
}
registerColumnSelection(CoreNavigationCommands.CursorColumnSelectLeft.id, 1039 /* KeyCode.LeftArrow */ );
registerColumnSelection(CoreNavigationCommands.CursorColumnSelectRight.id, 1041 /* KeyCode.RightArrow */ );
registerColumnSelection(CoreNavigationCommands.CursorColumnSelectUp.id, 1040 /* KeyCode.UpArrow */ );
registerColumnSelection(CoreNavigationCommands.CursorColumnSelectPageUp.id, 1035 /* KeyCode.PageUp */ );
registerColumnSelection(CoreNavigationCommands.CursorColumnSelectDown.id, 1042 /* KeyCode.DownArrow */ );
registerColumnSelection(CoreNavigationCommands.CursorColumnSelectPageDown.id, 1036 /* KeyCode.PageDown */ );
function registerCommand(command) {
    command.register();
    return command;
}
var CoreEditingCommands;
(function(CoreEditingCommands) {
    class CoreEditingCommand extends (0, _editorExtensionsJs.EditorCommand) {
        runEditorCommand(accessor, editor, args) {
            const viewModel = editor._getViewModel();
            if (!viewModel) // the editor has no view => has no cursors
            return;
            this.runCoreEditingCommand(editor, viewModel, args || {});
        }
    }
    CoreEditingCommands.CoreEditingCommand = CoreEditingCommand;
    CoreEditingCommands.LineBreakInsert = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditingCommand {
        constructor(){
            super({
                id: "lineBreakInsert",
                precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                    primary: 0,
                    mac: {
                        primary: 301 /* KeyCode.KeyO */ 
                    }
                }
            });
        }
        runCoreEditingCommand(editor, viewModel, args) {
            editor.pushUndoStop();
            editor.executeCommands(this.id, (0, _cursorTypeEditOperationsJs.EnterOperation).lineBreakInsert(viewModel.cursorConfig, viewModel.model, viewModel.getCursorStates().map((s)=>s.modelState.selection)));
        }
    });
    CoreEditingCommands.Outdent = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditingCommand {
        constructor(){
            super({
                id: "outdent",
                precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).editorTextFocus, (0, _editorContextKeysJs.EditorContextKeys).tabDoesNotMoveFocus),
                    primary: 1026 /* KeyCode.Tab */ 
                }
            });
        }
        runCoreEditingCommand(editor, viewModel, args) {
            editor.pushUndoStop();
            editor.executeCommands(this.id, (0, _cursorTypeOperationsJs.TypeOperations).outdent(viewModel.cursorConfig, viewModel.model, viewModel.getCursorStates().map((s)=>s.modelState.selection)));
            editor.pushUndoStop();
        }
    });
    CoreEditingCommands.Tab = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditingCommand {
        constructor(){
            super({
                id: "tab",
                precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).editorTextFocus, (0, _editorContextKeysJs.EditorContextKeys).tabDoesNotMoveFocus),
                    primary: 2 /* KeyCode.Tab */ 
                }
            });
        }
        runCoreEditingCommand(editor, viewModel, args) {
            editor.pushUndoStop();
            editor.executeCommands(this.id, (0, _cursorTypeOperationsJs.TypeOperations).tab(viewModel.cursorConfig, viewModel.model, viewModel.getCursorStates().map((s)=>s.modelState.selection)));
            editor.pushUndoStop();
        }
    });
    CoreEditingCommands.DeleteLeft = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditingCommand {
        constructor(){
            super({
                id: "deleteLeft",
                precondition: undefined,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                    primary: 1 /* KeyCode.Backspace */ ,
                    secondary: [
                        1025 /* KeyCode.Backspace */ 
                    ],
                    mac: {
                        primary: 1 /* KeyCode.Backspace */ ,
                        secondary: [
                            1025 /* KeyCode.Backspace */ ,
                            294 /* KeyCode.KeyH */ ,
                            257 /* KeyCode.Backspace */ 
                        ]
                    }
                }
            });
        }
        runCoreEditingCommand(editor, viewModel, args) {
            const [shouldPushStackElementBefore, commands] = (0, _cursorDeleteOperationsJs.DeleteOperations).deleteLeft(viewModel.getPrevEditOperationType(), viewModel.cursorConfig, viewModel.model, viewModel.getCursorStates().map((s)=>s.modelState.selection), viewModel.getCursorAutoClosedCharacters());
            if (shouldPushStackElementBefore) editor.pushUndoStop();
            editor.executeCommands(this.id, commands);
            viewModel.setPrevEditOperationType(2 /* EditOperationType.DeletingLeft */ );
        }
    });
    CoreEditingCommands.DeleteRight = (0, _editorExtensionsJs.registerEditorCommand)(new class extends CoreEditingCommand {
        constructor(){
            super({
                id: "deleteRight",
                precondition: undefined,
                kbOpts: {
                    weight: CORE_WEIGHT,
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                    primary: 20 /* KeyCode.Delete */ ,
                    mac: {
                        primary: 20 /* KeyCode.Delete */ ,
                        secondary: [
                            290 /* KeyCode.KeyD */ ,
                            276 /* KeyCode.Delete */ 
                        ]
                    }
                }
            });
        }
        runCoreEditingCommand(editor, viewModel, args) {
            const [shouldPushStackElementBefore, commands] = (0, _cursorDeleteOperationsJs.DeleteOperations).deleteRight(viewModel.getPrevEditOperationType(), viewModel.cursorConfig, viewModel.model, viewModel.getCursorStates().map((s)=>s.modelState.selection));
            if (shouldPushStackElementBefore) editor.pushUndoStop();
            editor.executeCommands(this.id, commands);
            viewModel.setPrevEditOperationType(3 /* EditOperationType.DeletingRight */ );
        }
    });
    CoreEditingCommands.Undo = new class extends EditorOrNativeTextInputCommand {
        constructor(){
            super((0, _editorExtensionsJs.UndoCommand));
        }
        runDOMCommand(activeElement) {
            activeElement.ownerDocument.execCommand("undo");
        }
        runEditorCommand(accessor, editor, args) {
            if (!editor.hasModel() || editor.getOption(92 /* EditorOption.readOnly */ ) === true) return;
            return editor.getModel().undo();
        }
    }();
    CoreEditingCommands.Redo = new class extends EditorOrNativeTextInputCommand {
        constructor(){
            super((0, _editorExtensionsJs.RedoCommand));
        }
        runDOMCommand(activeElement) {
            activeElement.ownerDocument.execCommand("redo");
        }
        runEditorCommand(accessor, editor, args) {
            if (!editor.hasModel() || editor.getOption(92 /* EditorOption.readOnly */ ) === true) return;
            return editor.getModel().redo();
        }
    }();
})(CoreEditingCommands || (CoreEditingCommands = {}));
/**
 * A command that will invoke a command on the focused editor.
 */ class EditorHandlerCommand extends (0, _editorExtensionsJs.Command) {
    constructor(id, handlerId, metadata){
        super({
            id: id,
            precondition: undefined,
            metadata
        });
        this._handlerId = handlerId;
    }
    runCommand(accessor, args) {
        const editor = accessor.get((0, _codeEditorServiceJs.ICodeEditorService)).getFocusedCodeEditor();
        if (!editor) return;
        editor.trigger("keyboard", this._handlerId, args);
    }
}
function registerOverwritableCommand(handlerId, metadata) {
    registerCommand(new EditorHandlerCommand("default:" + handlerId, handlerId));
    registerCommand(new EditorHandlerCommand(handlerId, handlerId, metadata));
}
registerOverwritableCommand("type" /* Handler.Type */ , {
    description: `Type`,
    args: [
        {
            name: "args",
            schema: {
                "type": "object",
                "required": [
                    "text"
                ],
                "properties": {
                    "text": {
                        "type": "string"
                    }
                }
            }
        }
    ]
});
registerOverwritableCommand("replacePreviousChar" /* Handler.ReplacePreviousChar */ );
registerOverwritableCommand("compositionType" /* Handler.CompositionType */ );
registerOverwritableCommand("compositionStart" /* Handler.CompositionStart */ );
registerOverwritableCommand("compositionEnd" /* Handler.CompositionEnd */ );
registerOverwritableCommand("paste" /* Handler.Paste */ );
registerOverwritableCommand("cut" /* Handler.Cut */ );

},{"../../nls.js":"l617d","../../base/browser/browser.js":"4Zquf","../../base/common/types.js":"fb5yx","../../base/browser/ui/aria/aria.js":"asrsh","./editorExtensions.js":"kC3w6","./services/codeEditorService.js":"bOWtl","../common/cursor/cursorColumnSelection.js":"61O0f","../common/cursorCommon.js":"aKAuR","../common/cursor/cursorDeleteOperations.js":"kHqWV","../common/cursor/cursorMoveCommands.js":"sl4rn","../common/cursor/cursorTypeOperations.js":"8iSM3","../common/core/position.js":"lvrPe","../common/core/range.js":"jmUPh","../common/editorContextKeys.js":"5exv9","../../platform/contextkey/common/contextkey.js":"gXuBD","../../platform/keybinding/common/keybindingsRegistry.js":"h9qfk","../../base/browser/dom.js":"bnqsM","../common/cursor/cursorTypeEditOperations.js":"iMjJX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"61O0f":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColumnSelection", ()=>ColumnSelection);
var _cursorCommonJs = require("../cursorCommon.js");
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
class ColumnSelection {
    static columnSelect(config, model, fromLineNumber, fromVisibleColumn, toLineNumber, toVisibleColumn) {
        const lineCount = Math.abs(toLineNumber - fromLineNumber) + 1;
        const reversed = fromLineNumber > toLineNumber;
        const isRTL = fromVisibleColumn > toVisibleColumn;
        const isLTR = fromVisibleColumn < toVisibleColumn;
        const result = [];
        // console.log(`fromVisibleColumn: ${fromVisibleColumn}, toVisibleColumn: ${toVisibleColumn}`);
        for(let i = 0; i < lineCount; i++){
            const lineNumber = fromLineNumber + (reversed ? -i : i);
            const startColumn = config.columnFromVisibleColumn(model, lineNumber, fromVisibleColumn);
            const endColumn = config.columnFromVisibleColumn(model, lineNumber, toVisibleColumn);
            const visibleStartColumn = config.visibleColumnFromColumn(model, new (0, _positionJs.Position)(lineNumber, startColumn));
            const visibleEndColumn = config.visibleColumnFromColumn(model, new (0, _positionJs.Position)(lineNumber, endColumn));
            // console.log(`lineNumber: ${lineNumber}: visibleStartColumn: ${visibleStartColumn}, visibleEndColumn: ${visibleEndColumn}`);
            if (isLTR) {
                if (visibleStartColumn > toVisibleColumn) continue;
                if (visibleEndColumn < fromVisibleColumn) continue;
            }
            if (isRTL) {
                if (visibleEndColumn > fromVisibleColumn) continue;
                if (visibleStartColumn < toVisibleColumn) continue;
            }
            result.push(new (0, _cursorCommonJs.SingleCursorState)(new (0, _rangeJs.Range)(lineNumber, startColumn, lineNumber, startColumn), 0 /* SelectionStartKind.Simple */ , 0, new (0, _positionJs.Position)(lineNumber, endColumn), 0));
        }
        if (result.length === 0) // We are after all the lines, so add cursor at the end of each line
        for(let i = 0; i < lineCount; i++){
            const lineNumber = fromLineNumber + (reversed ? -i : i);
            const maxColumn = model.getLineMaxColumn(lineNumber);
            result.push(new (0, _cursorCommonJs.SingleCursorState)(new (0, _rangeJs.Range)(lineNumber, maxColumn, lineNumber, maxColumn), 0 /* SelectionStartKind.Simple */ , 0, new (0, _positionJs.Position)(lineNumber, maxColumn), 0));
        }
        return {
            viewStates: result,
            reversed: reversed,
            fromLineNumber: fromLineNumber,
            fromVisualColumn: fromVisibleColumn,
            toLineNumber: toLineNumber,
            toVisualColumn: toVisibleColumn
        };
    }
    static columnSelectLeft(config, model, prevColumnSelectData) {
        let toViewVisualColumn = prevColumnSelectData.toViewVisualColumn;
        if (toViewVisualColumn > 0) toViewVisualColumn--;
        return ColumnSelection.columnSelect(config, model, prevColumnSelectData.fromViewLineNumber, prevColumnSelectData.fromViewVisualColumn, prevColumnSelectData.toViewLineNumber, toViewVisualColumn);
    }
    static columnSelectRight(config, model, prevColumnSelectData) {
        let maxVisualViewColumn = 0;
        const minViewLineNumber = Math.min(prevColumnSelectData.fromViewLineNumber, prevColumnSelectData.toViewLineNumber);
        const maxViewLineNumber = Math.max(prevColumnSelectData.fromViewLineNumber, prevColumnSelectData.toViewLineNumber);
        for(let lineNumber = minViewLineNumber; lineNumber <= maxViewLineNumber; lineNumber++){
            const lineMaxViewColumn = model.getLineMaxColumn(lineNumber);
            const lineMaxVisualViewColumn = config.visibleColumnFromColumn(model, new (0, _positionJs.Position)(lineNumber, lineMaxViewColumn));
            maxVisualViewColumn = Math.max(maxVisualViewColumn, lineMaxVisualViewColumn);
        }
        let toViewVisualColumn = prevColumnSelectData.toViewVisualColumn;
        if (toViewVisualColumn < maxVisualViewColumn) toViewVisualColumn++;
        return this.columnSelect(config, model, prevColumnSelectData.fromViewLineNumber, prevColumnSelectData.fromViewVisualColumn, prevColumnSelectData.toViewLineNumber, toViewVisualColumn);
    }
    static columnSelectUp(config, model, prevColumnSelectData, isPaged) {
        const linesCount = isPaged ? config.pageSize : 1;
        const toViewLineNumber = Math.max(1, prevColumnSelectData.toViewLineNumber - linesCount);
        return this.columnSelect(config, model, prevColumnSelectData.fromViewLineNumber, prevColumnSelectData.fromViewVisualColumn, toViewLineNumber, prevColumnSelectData.toViewVisualColumn);
    }
    static columnSelectDown(config, model, prevColumnSelectData, isPaged) {
        const linesCount = isPaged ? config.pageSize : 1;
        const toViewLineNumber = Math.min(model.getLineCount(), prevColumnSelectData.toViewLineNumber + linesCount);
        return this.columnSelect(config, model, prevColumnSelectData.fromViewLineNumber, prevColumnSelectData.fromViewVisualColumn, toViewLineNumber, prevColumnSelectData.toViewVisualColumn);
    }
}

},{"../cursorCommon.js":"aKAuR","../core/position.js":"lvrPe","../core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aKAuR":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CursorConfiguration", ()=>CursorConfiguration);
parcelHelpers.export(exports, "CursorState", ()=>CursorState);
parcelHelpers.export(exports, "PartialModelCursorState", ()=>PartialModelCursorState);
parcelHelpers.export(exports, "PartialViewCursorState", ()=>PartialViewCursorState);
/**
 * Represents the cursor state on either the model or on the view model.
 */ parcelHelpers.export(exports, "SingleCursorState", ()=>SingleCursorState);
parcelHelpers.export(exports, "EditOperationResult", ()=>EditOperationResult);
parcelHelpers.export(exports, "isQuote", ()=>isQuote);
var _positionJs = require("./core/position.js");
var _rangeJs = require("./core/range.js");
var _selectionJs = require("./core/selection.js");
var _supportsJs = require("./languages/supports.js");
var _cursorColumnsJs = require("./core/cursorColumns.js");
var _indentationJs = require("./core/indentation.js");
const autoCloseAlways = ()=>true;
const autoCloseNever = ()=>false;
const autoCloseBeforeWhitespace = (chr)=>chr === " " || chr === "	";
class CursorConfiguration {
    static shouldRecreate(e) {
        return e.hasChanged(146 /* EditorOption.layoutInfo */ ) || e.hasChanged(132 /* EditorOption.wordSeparators */ ) || e.hasChanged(37 /* EditorOption.emptySelectionClipboard */ ) || e.hasChanged(77 /* EditorOption.multiCursorMergeOverlapping */ ) || e.hasChanged(79 /* EditorOption.multiCursorPaste */ ) || e.hasChanged(80 /* EditorOption.multiCursorLimit */ ) || e.hasChanged(6 /* EditorOption.autoClosingBrackets */ ) || e.hasChanged(7 /* EditorOption.autoClosingComments */ ) || e.hasChanged(11 /* EditorOption.autoClosingQuotes */ ) || e.hasChanged(9 /* EditorOption.autoClosingDelete */ ) || e.hasChanged(10 /* EditorOption.autoClosingOvertype */ ) || e.hasChanged(14 /* EditorOption.autoSurround */ ) || e.hasChanged(129 /* EditorOption.useTabStops */ ) || e.hasChanged(50 /* EditorOption.fontInfo */ ) || e.hasChanged(92 /* EditorOption.readOnly */ ) || e.hasChanged(131 /* EditorOption.wordSegmenterLocales */ );
    }
    constructor(languageId, modelOptions, configuration, languageConfigurationService){
        this.languageConfigurationService = languageConfigurationService;
        this._cursorMoveConfigurationBrand = undefined;
        this._languageId = languageId;
        const options = configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        this.readOnly = options.get(92 /* EditorOption.readOnly */ );
        this.tabSize = modelOptions.tabSize;
        this.indentSize = modelOptions.indentSize;
        this.insertSpaces = modelOptions.insertSpaces;
        this.stickyTabStops = options.get(117 /* EditorOption.stickyTabStops */ );
        this.lineHeight = fontInfo.lineHeight;
        this.typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
        this.pageSize = Math.max(1, Math.floor(layoutInfo.height / this.lineHeight) - 2);
        this.useTabStops = options.get(129 /* EditorOption.useTabStops */ );
        this.wordSeparators = options.get(132 /* EditorOption.wordSeparators */ );
        this.emptySelectionClipboard = options.get(37 /* EditorOption.emptySelectionClipboard */ );
        this.copyWithSyntaxHighlighting = options.get(25 /* EditorOption.copyWithSyntaxHighlighting */ );
        this.multiCursorMergeOverlapping = options.get(77 /* EditorOption.multiCursorMergeOverlapping */ );
        this.multiCursorPaste = options.get(79 /* EditorOption.multiCursorPaste */ );
        this.multiCursorLimit = options.get(80 /* EditorOption.multiCursorLimit */ );
        this.autoClosingBrackets = options.get(6 /* EditorOption.autoClosingBrackets */ );
        this.autoClosingComments = options.get(7 /* EditorOption.autoClosingComments */ );
        this.autoClosingQuotes = options.get(11 /* EditorOption.autoClosingQuotes */ );
        this.autoClosingDelete = options.get(9 /* EditorOption.autoClosingDelete */ );
        this.autoClosingOvertype = options.get(10 /* EditorOption.autoClosingOvertype */ );
        this.autoSurround = options.get(14 /* EditorOption.autoSurround */ );
        this.autoIndent = options.get(12 /* EditorOption.autoIndent */ );
        this.wordSegmenterLocales = options.get(131 /* EditorOption.wordSegmenterLocales */ );
        this.surroundingPairs = {};
        this._electricChars = null;
        this.shouldAutoCloseBefore = {
            quote: this._getShouldAutoClose(languageId, this.autoClosingQuotes, true),
            comment: this._getShouldAutoClose(languageId, this.autoClosingComments, false),
            bracket: this._getShouldAutoClose(languageId, this.autoClosingBrackets, false)
        };
        this.autoClosingPairs = this.languageConfigurationService.getLanguageConfiguration(languageId).getAutoClosingPairs();
        const surroundingPairs = this.languageConfigurationService.getLanguageConfiguration(languageId).getSurroundingPairs();
        if (surroundingPairs) for (const pair of surroundingPairs)this.surroundingPairs[pair.open] = pair.close;
        const commentsConfiguration = this.languageConfigurationService.getLanguageConfiguration(languageId).comments;
        this.blockCommentStartToken = commentsConfiguration?.blockCommentStartToken ?? null;
    }
    get electricChars() {
        if (!this._electricChars) {
            this._electricChars = {};
            const electricChars = this.languageConfigurationService.getLanguageConfiguration(this._languageId).electricCharacter?.getElectricCharacters();
            if (electricChars) for (const char of electricChars)this._electricChars[char] = true;
        }
        return this._electricChars;
    }
    /**
     * Should return opening bracket type to match indentation with
     */ onElectricCharacter(character, context, column) {
        const scopedLineTokens = (0, _supportsJs.createScopedLineTokens)(context, column - 1);
        const electricCharacterSupport = this.languageConfigurationService.getLanguageConfiguration(scopedLineTokens.languageId).electricCharacter;
        if (!electricCharacterSupport) return null;
        return electricCharacterSupport.onElectricCharacter(character, scopedLineTokens, column - scopedLineTokens.firstCharOffset);
    }
    normalizeIndentation(str) {
        return (0, _indentationJs.normalizeIndentation)(str, this.indentSize, this.insertSpaces);
    }
    _getShouldAutoClose(languageId, autoCloseConfig, forQuotes) {
        switch(autoCloseConfig){
            case "beforeWhitespace":
                return autoCloseBeforeWhitespace;
            case "languageDefined":
                return this._getLanguageDefinedShouldAutoClose(languageId, forQuotes);
            case "always":
                return autoCloseAlways;
            case "never":
                return autoCloseNever;
        }
    }
    _getLanguageDefinedShouldAutoClose(languageId, forQuotes) {
        const autoCloseBeforeSet = this.languageConfigurationService.getLanguageConfiguration(languageId).getAutoCloseBeforeSet(forQuotes);
        return (c)=>autoCloseBeforeSet.indexOf(c) !== -1;
    }
    /**
     * Returns a visible column from a column.
     * @see {@link CursorColumns}
     */ visibleColumnFromColumn(model, position) {
        return (0, _cursorColumnsJs.CursorColumns).visibleColumnFromColumn(model.getLineContent(position.lineNumber), position.column, this.tabSize);
    }
    /**
     * Returns a visible column from a column.
     * @see {@link CursorColumns}
     */ columnFromVisibleColumn(model, lineNumber, visibleColumn) {
        const result = (0, _cursorColumnsJs.CursorColumns).columnFromVisibleColumn(model.getLineContent(lineNumber), visibleColumn, this.tabSize);
        const minColumn = model.getLineMinColumn(lineNumber);
        if (result < minColumn) return minColumn;
        const maxColumn = model.getLineMaxColumn(lineNumber);
        if (result > maxColumn) return maxColumn;
        return result;
    }
}
class CursorState {
    static fromModelState(modelState) {
        return new PartialModelCursorState(modelState);
    }
    static fromViewState(viewState) {
        return new PartialViewCursorState(viewState);
    }
    static fromModelSelection(modelSelection) {
        const selection = (0, _selectionJs.Selection).liftSelection(modelSelection);
        const modelState = new SingleCursorState((0, _rangeJs.Range).fromPositions(selection.getSelectionStart()), 0 /* SelectionStartKind.Simple */ , 0, selection.getPosition(), 0);
        return CursorState.fromModelState(modelState);
    }
    static fromModelSelections(modelSelections) {
        const states = [];
        for(let i = 0, len = modelSelections.length; i < len; i++)states[i] = this.fromModelSelection(modelSelections[i]);
        return states;
    }
    constructor(modelState, viewState){
        this._cursorStateBrand = undefined;
        this.modelState = modelState;
        this.viewState = viewState;
    }
    equals(other) {
        return this.viewState.equals(other.viewState) && this.modelState.equals(other.modelState);
    }
}
class PartialModelCursorState {
    constructor(modelState){
        this.modelState = modelState;
        this.viewState = null;
    }
}
class PartialViewCursorState {
    constructor(viewState){
        this.modelState = null;
        this.viewState = viewState;
    }
}
class SingleCursorState {
    constructor(selectionStart, selectionStartKind, selectionStartLeftoverVisibleColumns, position, leftoverVisibleColumns){
        this.selectionStart = selectionStart;
        this.selectionStartKind = selectionStartKind;
        this.selectionStartLeftoverVisibleColumns = selectionStartLeftoverVisibleColumns;
        this.position = position;
        this.leftoverVisibleColumns = leftoverVisibleColumns;
        this._singleCursorStateBrand = undefined;
        this.selection = SingleCursorState._computeSelection(this.selectionStart, this.position);
    }
    equals(other) {
        return this.selectionStartLeftoverVisibleColumns === other.selectionStartLeftoverVisibleColumns && this.leftoverVisibleColumns === other.leftoverVisibleColumns && this.selectionStartKind === other.selectionStartKind && this.position.equals(other.position) && this.selectionStart.equalsRange(other.selectionStart);
    }
    hasSelection() {
        return !this.selection.isEmpty() || !this.selectionStart.isEmpty();
    }
    move(inSelectionMode, lineNumber, column, leftoverVisibleColumns) {
        if (inSelectionMode) // move just position
        return new SingleCursorState(this.selectionStart, this.selectionStartKind, this.selectionStartLeftoverVisibleColumns, new (0, _positionJs.Position)(lineNumber, column), leftoverVisibleColumns);
        else // move everything
        return new SingleCursorState(new (0, _rangeJs.Range)(lineNumber, column, lineNumber, column), 0 /* SelectionStartKind.Simple */ , leftoverVisibleColumns, new (0, _positionJs.Position)(lineNumber, column), leftoverVisibleColumns);
    }
    static _computeSelection(selectionStart, position) {
        if (selectionStart.isEmpty() || !position.isBeforeOrEqual(selectionStart.getStartPosition())) return (0, _selectionJs.Selection).fromPositions(selectionStart.getStartPosition(), position);
        else return (0, _selectionJs.Selection).fromPositions(selectionStart.getEndPosition(), position);
    }
}
class EditOperationResult {
    constructor(type, commands, opts){
        this._editOperationResultBrand = undefined;
        this.type = type;
        this.commands = commands;
        this.shouldPushStackElementBefore = opts.shouldPushStackElementBefore;
        this.shouldPushStackElementAfter = opts.shouldPushStackElementAfter;
    }
}
function isQuote(ch) {
    return ch === "'" || ch === '"' || ch === "`";
}

},{"./core/position.js":"lvrPe","./core/range.js":"jmUPh","./core/selection.js":"kcwzU","./languages/supports.js":"aA5lJ","./core/cursorColumns.js":"idX7D","./core/indentation.js":"7FtDC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kHqWV":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeleteOperations", ()=>DeleteOperations);
var _stringsJs = require("../../../base/common/strings.js");
var _replaceCommandJs = require("../commands/replaceCommand.js");
var _cursorCommonJs = require("../cursorCommon.js");
var _cursorColumnsJs = require("../core/cursorColumns.js");
var _cursorMoveOperationsJs = require("./cursorMoveOperations.js");
var _rangeJs = require("../core/range.js");
var _positionJs = require("../core/position.js");
class DeleteOperations {
    static deleteRight(prevEditOperationType, config, model, selections) {
        const commands = [];
        let shouldPushStackElementBefore = prevEditOperationType !== 3 /* EditOperationType.DeletingRight */ ;
        for(let i = 0, len = selections.length; i < len; i++){
            const selection = selections[i];
            let deleteSelection = selection;
            if (deleteSelection.isEmpty()) {
                const position = selection.getPosition();
                const rightOfPosition = (0, _cursorMoveOperationsJs.MoveOperations).right(config, model, position);
                deleteSelection = new (0, _rangeJs.Range)(rightOfPosition.lineNumber, rightOfPosition.column, position.lineNumber, position.column);
            }
            if (deleteSelection.isEmpty()) {
                // Probably at end of file => ignore
                commands[i] = null;
                continue;
            }
            if (deleteSelection.startLineNumber !== deleteSelection.endLineNumber) shouldPushStackElementBefore = true;
            commands[i] = new (0, _replaceCommandJs.ReplaceCommand)(deleteSelection, "");
        }
        return [
            shouldPushStackElementBefore,
            commands
        ];
    }
    static isAutoClosingPairDelete(autoClosingDelete, autoClosingBrackets, autoClosingQuotes, autoClosingPairsOpen, model, selections, autoClosedCharacters) {
        if (autoClosingBrackets === "never" && autoClosingQuotes === "never") return false;
        if (autoClosingDelete === "never") return false;
        for(let i = 0, len = selections.length; i < len; i++){
            const selection = selections[i];
            const position = selection.getPosition();
            if (!selection.isEmpty()) return false;
            const lineText = model.getLineContent(position.lineNumber);
            if (position.column < 2 || position.column >= lineText.length + 1) return false;
            const character = lineText.charAt(position.column - 2);
            const autoClosingPairCandidates = autoClosingPairsOpen.get(character);
            if (!autoClosingPairCandidates) return false;
            if ((0, _cursorCommonJs.isQuote)(character)) {
                if (autoClosingQuotes === "never") return false;
            } else {
                if (autoClosingBrackets === "never") return false;
            }
            const afterCharacter = lineText.charAt(position.column - 1);
            let foundAutoClosingPair = false;
            for (const autoClosingPairCandidate of autoClosingPairCandidates)if (autoClosingPairCandidate.open === character && autoClosingPairCandidate.close === afterCharacter) foundAutoClosingPair = true;
            if (!foundAutoClosingPair) return false;
            // Must delete the pair only if it was automatically inserted by the editor
            if (autoClosingDelete === "auto") {
                let found = false;
                for(let j = 0, lenJ = autoClosedCharacters.length; j < lenJ; j++){
                    const autoClosedCharacter = autoClosedCharacters[j];
                    if (position.lineNumber === autoClosedCharacter.startLineNumber && position.column === autoClosedCharacter.startColumn) {
                        found = true;
                        break;
                    }
                }
                if (!found) return false;
            }
        }
        return true;
    }
    static _runAutoClosingPairDelete(config, model, selections) {
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++){
            const position = selections[i].getPosition();
            const deleteSelection = new (0, _rangeJs.Range)(position.lineNumber, position.column - 1, position.lineNumber, position.column + 1);
            commands[i] = new (0, _replaceCommandJs.ReplaceCommand)(deleteSelection, "");
        }
        return [
            true,
            commands
        ];
    }
    static deleteLeft(prevEditOperationType, config, model, selections, autoClosedCharacters) {
        if (this.isAutoClosingPairDelete(config.autoClosingDelete, config.autoClosingBrackets, config.autoClosingQuotes, config.autoClosingPairs.autoClosingPairsOpenByEnd, model, selections, autoClosedCharacters)) return this._runAutoClosingPairDelete(config, model, selections);
        const commands = [];
        let shouldPushStackElementBefore = prevEditOperationType !== 2 /* EditOperationType.DeletingLeft */ ;
        for(let i = 0, len = selections.length; i < len; i++){
            const deleteRange = DeleteOperations.getDeleteRange(selections[i], model, config);
            // Ignore empty delete ranges, as they have no effect
            // They happen if the cursor is at the beginning of the file.
            if (deleteRange.isEmpty()) {
                commands[i] = null;
                continue;
            }
            if (deleteRange.startLineNumber !== deleteRange.endLineNumber) shouldPushStackElementBefore = true;
            commands[i] = new (0, _replaceCommandJs.ReplaceCommand)(deleteRange, "");
        }
        return [
            shouldPushStackElementBefore,
            commands
        ];
    }
    static getDeleteRange(selection, model, config) {
        if (!selection.isEmpty()) return selection;
        const position = selection.getPosition();
        // Unintend when using tab stops and cursor is within indentation
        if (config.useTabStops && position.column > 1) {
            const lineContent = model.getLineContent(position.lineNumber);
            const firstNonWhitespaceIndex = _stringsJs.firstNonWhitespaceIndex(lineContent);
            const lastIndentationColumn = firstNonWhitespaceIndex === -1 ? /* entire string is whitespace */ lineContent.length + 1 : firstNonWhitespaceIndex + 1;
            if (position.column <= lastIndentationColumn) {
                const fromVisibleColumn = config.visibleColumnFromColumn(model, position);
                const toVisibleColumn = (0, _cursorColumnsJs.CursorColumns).prevIndentTabStop(fromVisibleColumn, config.indentSize);
                const toColumn = config.columnFromVisibleColumn(model, position.lineNumber, toVisibleColumn);
                return new (0, _rangeJs.Range)(position.lineNumber, toColumn, position.lineNumber, position.column);
            }
        }
        return (0, _rangeJs.Range).fromPositions(DeleteOperations.getPositionAfterDeleteLeft(position, model), position);
    }
    static getPositionAfterDeleteLeft(position, model) {
        if (position.column > 1) {
            // Convert 1-based columns to 0-based offsets and back.
            const idx = _stringsJs.getLeftDeleteOffset(position.column - 1, model.getLineContent(position.lineNumber));
            return position.with(undefined, idx + 1);
        } else if (position.lineNumber > 1) {
            const newLine = position.lineNumber - 1;
            return new (0, _positionJs.Position)(newLine, model.getLineMaxColumn(newLine));
        } else return position;
    }
    static cut(config, model, selections) {
        const commands = [];
        let lastCutRange = null;
        selections.sort((a, b)=>(0, _positionJs.Position).compare(a.getStartPosition(), b.getEndPosition()));
        for(let i = 0, len = selections.length; i < len; i++){
            const selection = selections[i];
            if (selection.isEmpty()) {
                if (config.emptySelectionClipboard) {
                    // This is a full line cut
                    const position = selection.getPosition();
                    let startLineNumber, startColumn, endLineNumber, endColumn;
                    if (position.lineNumber < model.getLineCount()) {
                        // Cutting a line in the middle of the model
                        startLineNumber = position.lineNumber;
                        startColumn = 1;
                        endLineNumber = position.lineNumber + 1;
                        endColumn = 1;
                    } else if (position.lineNumber > 1 && lastCutRange?.endLineNumber !== position.lineNumber) {
                        // Cutting the last line & there are more than 1 lines in the model & a previous cut operation does not touch the current cut operation
                        startLineNumber = position.lineNumber - 1;
                        startColumn = model.getLineMaxColumn(position.lineNumber - 1);
                        endLineNumber = position.lineNumber;
                        endColumn = model.getLineMaxColumn(position.lineNumber);
                    } else {
                        // Cutting the single line that the model contains
                        startLineNumber = position.lineNumber;
                        startColumn = 1;
                        endLineNumber = position.lineNumber;
                        endColumn = model.getLineMaxColumn(position.lineNumber);
                    }
                    const deleteSelection = new (0, _rangeJs.Range)(startLineNumber, startColumn, endLineNumber, endColumn);
                    lastCutRange = deleteSelection;
                    if (!deleteSelection.isEmpty()) commands[i] = new (0, _replaceCommandJs.ReplaceCommand)(deleteSelection, "");
                    else commands[i] = null;
                } else // Cannot cut empty selection
                commands[i] = null;
            } else commands[i] = new (0, _replaceCommandJs.ReplaceCommand)(selection, "");
        }
        return new (0, _cursorCommonJs.EditOperationResult)(0 /* EditOperationType.Other */ , commands, {
            shouldPushStackElementBefore: true,
            shouldPushStackElementAfter: true
        });
    }
}

},{"../../../base/common/strings.js":"aA9I1","../commands/replaceCommand.js":"51hNH","../cursorCommon.js":"aKAuR","../core/cursorColumns.js":"idX7D","./cursorMoveOperations.js":"74ZGL","../core/range.js":"jmUPh","../core/position.js":"lvrPe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"51hNH":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplaceCommand", ()=>ReplaceCommand);
parcelHelpers.export(exports, "ReplaceCommandThatSelectsText", ()=>ReplaceCommandThatSelectsText);
parcelHelpers.export(exports, "ReplaceCommandWithoutChangingPosition", ()=>ReplaceCommandWithoutChangingPosition);
parcelHelpers.export(exports, "ReplaceCommandWithOffsetCursorState", ()=>ReplaceCommandWithOffsetCursorState);
parcelHelpers.export(exports, "ReplaceCommandThatPreservesSelection", ()=>ReplaceCommandThatPreservesSelection);
var _selectionJs = require("../core/selection.js");
class ReplaceCommand {
    constructor(range, text, insertsAutoWhitespace = false){
        this._range = range;
        this._text = text;
        this.insertsAutoWhitespace = insertsAutoWhitespace;
    }
    getEditOperations(model, builder) {
        builder.addTrackedEditOperation(this._range, this._text);
    }
    computeCursorState(model, helper) {
        const inverseEditOperations = helper.getInverseEditOperations();
        const srcRange = inverseEditOperations[0].range;
        return (0, _selectionJs.Selection).fromPositions(srcRange.getEndPosition());
    }
}
class ReplaceCommandThatSelectsText {
    constructor(range, text){
        this._range = range;
        this._text = text;
    }
    getEditOperations(model, builder) {
        builder.addTrackedEditOperation(this._range, this._text);
    }
    computeCursorState(model, helper) {
        const inverseEditOperations = helper.getInverseEditOperations();
        const srcRange = inverseEditOperations[0].range;
        return (0, _selectionJs.Selection).fromRange(srcRange, 0 /* SelectionDirection.LTR */ );
    }
}
class ReplaceCommandWithoutChangingPosition {
    constructor(range, text, insertsAutoWhitespace = false){
        this._range = range;
        this._text = text;
        this.insertsAutoWhitespace = insertsAutoWhitespace;
    }
    getEditOperations(model, builder) {
        builder.addTrackedEditOperation(this._range, this._text);
    }
    computeCursorState(model, helper) {
        const inverseEditOperations = helper.getInverseEditOperations();
        const srcRange = inverseEditOperations[0].range;
        return (0, _selectionJs.Selection).fromPositions(srcRange.getStartPosition());
    }
}
class ReplaceCommandWithOffsetCursorState {
    constructor(range, text, lineNumberDeltaOffset, columnDeltaOffset, insertsAutoWhitespace = false){
        this._range = range;
        this._text = text;
        this._columnDeltaOffset = columnDeltaOffset;
        this._lineNumberDeltaOffset = lineNumberDeltaOffset;
        this.insertsAutoWhitespace = insertsAutoWhitespace;
    }
    getEditOperations(model, builder) {
        builder.addTrackedEditOperation(this._range, this._text);
    }
    computeCursorState(model, helper) {
        const inverseEditOperations = helper.getInverseEditOperations();
        const srcRange = inverseEditOperations[0].range;
        return (0, _selectionJs.Selection).fromPositions(srcRange.getEndPosition().delta(this._lineNumberDeltaOffset, this._columnDeltaOffset));
    }
}
class ReplaceCommandThatPreservesSelection {
    constructor(editRange, text, initialSelection, forceMoveMarkers = false){
        this._range = editRange;
        this._text = text;
        this._initialSelection = initialSelection;
        this._forceMoveMarkers = forceMoveMarkers;
        this._selectionId = null;
    }
    getEditOperations(model, builder) {
        builder.addTrackedEditOperation(this._range, this._text, this._forceMoveMarkers);
        this._selectionId = builder.trackSelection(this._initialSelection);
    }
    computeCursorState(model, helper) {
        return helper.getTrackedSelection(this._selectionId);
    }
}

},{"../core/selection.js":"kcwzU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"74ZGL":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CursorPosition", ()=>CursorPosition);
parcelHelpers.export(exports, "MoveOperations", ()=>MoveOperations);
var _stringsJs = require("../../../base/common/strings.js");
var _cursorColumnsJs = require("../core/cursorColumns.js");
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
var _cursorAtomicMoveOperationsJs = require("./cursorAtomicMoveOperations.js");
var _cursorCommonJs = require("../cursorCommon.js");
class CursorPosition {
    constructor(lineNumber, column, leftoverVisibleColumns){
        this._cursorPositionBrand = undefined;
        this.lineNumber = lineNumber;
        this.column = column;
        this.leftoverVisibleColumns = leftoverVisibleColumns;
    }
}
class MoveOperations {
    static leftPosition(model, position) {
        if (position.column > model.getLineMinColumn(position.lineNumber)) return position.delta(undefined, -_stringsJs.prevCharLength(model.getLineContent(position.lineNumber), position.column - 1));
        else if (position.lineNumber > 1) {
            const newLineNumber = position.lineNumber - 1;
            return new (0, _positionJs.Position)(newLineNumber, model.getLineMaxColumn(newLineNumber));
        } else return position;
    }
    static leftPositionAtomicSoftTabs(model, position, tabSize) {
        if (position.column <= model.getLineIndentColumn(position.lineNumber)) {
            const minColumn = model.getLineMinColumn(position.lineNumber);
            const lineContent = model.getLineContent(position.lineNumber);
            const newPosition = (0, _cursorAtomicMoveOperationsJs.AtomicTabMoveOperations).atomicPosition(lineContent, position.column - 1, tabSize, 0 /* Direction.Left */ );
            if (newPosition !== -1 && newPosition + 1 >= minColumn) return new (0, _positionJs.Position)(position.lineNumber, newPosition + 1);
        }
        return this.leftPosition(model, position);
    }
    static left(config, model, position) {
        const pos = config.stickyTabStops ? MoveOperations.leftPositionAtomicSoftTabs(model, position, config.tabSize) : MoveOperations.leftPosition(model, position);
        return new CursorPosition(pos.lineNumber, pos.column, 0);
    }
    /**
     * @param noOfColumns Must be either `1`
     * or `Math.round(viewModel.getLineContent(viewLineNumber).length / 2)` (for half lines).
    */ static moveLeft(config, model, cursor, inSelectionMode, noOfColumns) {
        let lineNumber, column;
        if (cursor.hasSelection() && !inSelectionMode) {
            // If the user has a selection and does not want to extend it,
            // put the cursor at the beginning of the selection.
            lineNumber = cursor.selection.startLineNumber;
            column = cursor.selection.startColumn;
        } else {
            // This has no effect if noOfColumns === 1.
            // It is ok to do so in the half-line scenario.
            const pos = cursor.position.delta(undefined, -(noOfColumns - 1));
            // We clip the position before normalization, as normalization is not defined
            // for possibly negative columns.
            const normalizedPos = model.normalizePosition(MoveOperations.clipPositionColumn(pos, model), 0 /* PositionAffinity.Left */ );
            const p = MoveOperations.left(config, model, normalizedPos);
            lineNumber = p.lineNumber;
            column = p.column;
        }
        return cursor.move(inSelectionMode, lineNumber, column, 0);
    }
    /**
     * Adjusts the column so that it is within min/max of the line.
    */ static clipPositionColumn(position, model) {
        return new (0, _positionJs.Position)(position.lineNumber, MoveOperations.clipRange(position.column, model.getLineMinColumn(position.lineNumber), model.getLineMaxColumn(position.lineNumber)));
    }
    static clipRange(value, min, max) {
        if (value < min) return min;
        if (value > max) return max;
        return value;
    }
    static rightPosition(model, lineNumber, column) {
        if (column < model.getLineMaxColumn(lineNumber)) column = column + _stringsJs.nextCharLength(model.getLineContent(lineNumber), column - 1);
        else if (lineNumber < model.getLineCount()) {
            lineNumber = lineNumber + 1;
            column = model.getLineMinColumn(lineNumber);
        }
        return new (0, _positionJs.Position)(lineNumber, column);
    }
    static rightPositionAtomicSoftTabs(model, lineNumber, column, tabSize, indentSize) {
        if (column < model.getLineIndentColumn(lineNumber)) {
            const lineContent = model.getLineContent(lineNumber);
            const newPosition = (0, _cursorAtomicMoveOperationsJs.AtomicTabMoveOperations).atomicPosition(lineContent, column - 1, tabSize, 1 /* Direction.Right */ );
            if (newPosition !== -1) return new (0, _positionJs.Position)(lineNumber, newPosition + 1);
        }
        return this.rightPosition(model, lineNumber, column);
    }
    static right(config, model, position) {
        const pos = config.stickyTabStops ? MoveOperations.rightPositionAtomicSoftTabs(model, position.lineNumber, position.column, config.tabSize, config.indentSize) : MoveOperations.rightPosition(model, position.lineNumber, position.column);
        return new CursorPosition(pos.lineNumber, pos.column, 0);
    }
    static moveRight(config, model, cursor, inSelectionMode, noOfColumns) {
        let lineNumber, column;
        if (cursor.hasSelection() && !inSelectionMode) {
            // If we are in selection mode, move right without selection cancels selection and puts cursor at the end of the selection
            lineNumber = cursor.selection.endLineNumber;
            column = cursor.selection.endColumn;
        } else {
            const pos = cursor.position.delta(undefined, noOfColumns - 1);
            const normalizedPos = model.normalizePosition(MoveOperations.clipPositionColumn(pos, model), 1 /* PositionAffinity.Right */ );
            const r = MoveOperations.right(config, model, normalizedPos);
            lineNumber = r.lineNumber;
            column = r.column;
        }
        return cursor.move(inSelectionMode, lineNumber, column, 0);
    }
    static vertical(config, model, lineNumber, column, leftoverVisibleColumns, newLineNumber, allowMoveOnEdgeLine, normalizationAffinity) {
        const currentVisibleColumn = (0, _cursorColumnsJs.CursorColumns).visibleColumnFromColumn(model.getLineContent(lineNumber), column, config.tabSize) + leftoverVisibleColumns;
        const lineCount = model.getLineCount();
        const wasOnFirstPosition = lineNumber === 1 && column === 1;
        const wasOnLastPosition = lineNumber === lineCount && column === model.getLineMaxColumn(lineNumber);
        const wasAtEdgePosition = newLineNumber < lineNumber ? wasOnFirstPosition : wasOnLastPosition;
        lineNumber = newLineNumber;
        if (lineNumber < 1) {
            lineNumber = 1;
            if (allowMoveOnEdgeLine) column = model.getLineMinColumn(lineNumber);
            else column = Math.min(model.getLineMaxColumn(lineNumber), column);
        } else if (lineNumber > lineCount) {
            lineNumber = lineCount;
            if (allowMoveOnEdgeLine) column = model.getLineMaxColumn(lineNumber);
            else column = Math.min(model.getLineMaxColumn(lineNumber), column);
        } else column = config.columnFromVisibleColumn(model, lineNumber, currentVisibleColumn);
        if (wasAtEdgePosition) leftoverVisibleColumns = 0;
        else leftoverVisibleColumns = currentVisibleColumn - (0, _cursorColumnsJs.CursorColumns).visibleColumnFromColumn(model.getLineContent(lineNumber), column, config.tabSize);
        if (normalizationAffinity !== undefined) {
            const position = new (0, _positionJs.Position)(lineNumber, column);
            const newPosition = model.normalizePosition(position, normalizationAffinity);
            leftoverVisibleColumns = leftoverVisibleColumns + (column - newPosition.column);
            lineNumber = newPosition.lineNumber;
            column = newPosition.column;
        }
        return new CursorPosition(lineNumber, column, leftoverVisibleColumns);
    }
    static down(config, model, lineNumber, column, leftoverVisibleColumns, count, allowMoveOnLastLine) {
        return this.vertical(config, model, lineNumber, column, leftoverVisibleColumns, lineNumber + count, allowMoveOnLastLine, 4 /* PositionAffinity.RightOfInjectedText */ );
    }
    static moveDown(config, model, cursor, inSelectionMode, linesCount) {
        let lineNumber, column;
        if (cursor.hasSelection() && !inSelectionMode) {
            // If we are in selection mode, move down acts relative to the end of selection
            lineNumber = cursor.selection.endLineNumber;
            column = cursor.selection.endColumn;
        } else {
            lineNumber = cursor.position.lineNumber;
            column = cursor.position.column;
        }
        let i = 0;
        let r;
        do {
            r = MoveOperations.down(config, model, lineNumber + i, column, cursor.leftoverVisibleColumns, linesCount, true);
            const np = model.normalizePosition(new (0, _positionJs.Position)(r.lineNumber, r.column), 2 /* PositionAffinity.None */ );
            if (np.lineNumber > lineNumber) break;
        }while (i++ < 10 && lineNumber + i < model.getLineCount());
        return cursor.move(inSelectionMode, r.lineNumber, r.column, r.leftoverVisibleColumns);
    }
    static translateDown(config, model, cursor) {
        const selection = cursor.selection;
        const selectionStart = MoveOperations.down(config, model, selection.selectionStartLineNumber, selection.selectionStartColumn, cursor.selectionStartLeftoverVisibleColumns, 1, false);
        const position = MoveOperations.down(config, model, selection.positionLineNumber, selection.positionColumn, cursor.leftoverVisibleColumns, 1, false);
        return new (0, _cursorCommonJs.SingleCursorState)(new (0, _rangeJs.Range)(selectionStart.lineNumber, selectionStart.column, selectionStart.lineNumber, selectionStart.column), 0 /* SelectionStartKind.Simple */ , selectionStart.leftoverVisibleColumns, new (0, _positionJs.Position)(position.lineNumber, position.column), position.leftoverVisibleColumns);
    }
    static up(config, model, lineNumber, column, leftoverVisibleColumns, count, allowMoveOnFirstLine) {
        return this.vertical(config, model, lineNumber, column, leftoverVisibleColumns, lineNumber - count, allowMoveOnFirstLine, 3 /* PositionAffinity.LeftOfInjectedText */ );
    }
    static moveUp(config, model, cursor, inSelectionMode, linesCount) {
        let lineNumber, column;
        if (cursor.hasSelection() && !inSelectionMode) {
            // If we are in selection mode, move up acts relative to the beginning of selection
            lineNumber = cursor.selection.startLineNumber;
            column = cursor.selection.startColumn;
        } else {
            lineNumber = cursor.position.lineNumber;
            column = cursor.position.column;
        }
        const r = MoveOperations.up(config, model, lineNumber, column, cursor.leftoverVisibleColumns, linesCount, true);
        return cursor.move(inSelectionMode, r.lineNumber, r.column, r.leftoverVisibleColumns);
    }
    static translateUp(config, model, cursor) {
        const selection = cursor.selection;
        const selectionStart = MoveOperations.up(config, model, selection.selectionStartLineNumber, selection.selectionStartColumn, cursor.selectionStartLeftoverVisibleColumns, 1, false);
        const position = MoveOperations.up(config, model, selection.positionLineNumber, selection.positionColumn, cursor.leftoverVisibleColumns, 1, false);
        return new (0, _cursorCommonJs.SingleCursorState)(new (0, _rangeJs.Range)(selectionStart.lineNumber, selectionStart.column, selectionStart.lineNumber, selectionStart.column), 0 /* SelectionStartKind.Simple */ , selectionStart.leftoverVisibleColumns, new (0, _positionJs.Position)(position.lineNumber, position.column), position.leftoverVisibleColumns);
    }
    static _isBlankLine(model, lineNumber) {
        if (model.getLineFirstNonWhitespaceColumn(lineNumber) === 0) // empty or contains only whitespace
        return true;
        return false;
    }
    static moveToPrevBlankLine(config, model, cursor, inSelectionMode) {
        let lineNumber = cursor.position.lineNumber;
        // If our current line is blank, move to the previous non-blank line
        while(lineNumber > 1 && this._isBlankLine(model, lineNumber))lineNumber--;
        // Find the previous blank line
        while(lineNumber > 1 && !this._isBlankLine(model, lineNumber))lineNumber--;
        return cursor.move(inSelectionMode, lineNumber, model.getLineMinColumn(lineNumber), 0);
    }
    static moveToNextBlankLine(config, model, cursor, inSelectionMode) {
        const lineCount = model.getLineCount();
        let lineNumber = cursor.position.lineNumber;
        // If our current line is blank, move to the next non-blank line
        while(lineNumber < lineCount && this._isBlankLine(model, lineNumber))lineNumber++;
        // Find the next blank line
        while(lineNumber < lineCount && !this._isBlankLine(model, lineNumber))lineNumber++;
        return cursor.move(inSelectionMode, lineNumber, model.getLineMinColumn(lineNumber), 0);
    }
    static moveToBeginningOfLine(config, model, cursor, inSelectionMode) {
        const lineNumber = cursor.position.lineNumber;
        const minColumn = model.getLineMinColumn(lineNumber);
        const firstNonBlankColumn = model.getLineFirstNonWhitespaceColumn(lineNumber) || minColumn;
        let column;
        const relevantColumnNumber = cursor.position.column;
        if (relevantColumnNumber === firstNonBlankColumn) column = minColumn;
        else column = firstNonBlankColumn;
        return cursor.move(inSelectionMode, lineNumber, column, 0);
    }
    static moveToEndOfLine(config, model, cursor, inSelectionMode, sticky) {
        const lineNumber = cursor.position.lineNumber;
        const maxColumn = model.getLineMaxColumn(lineNumber);
        return cursor.move(inSelectionMode, lineNumber, maxColumn, sticky ? 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */  - maxColumn : 0);
    }
    static moveToBeginningOfBuffer(config, model, cursor, inSelectionMode) {
        return cursor.move(inSelectionMode, 1, 1, 0);
    }
    static moveToEndOfBuffer(config, model, cursor, inSelectionMode) {
        const lastLineNumber = model.getLineCount();
        const lastColumn = model.getLineMaxColumn(lastLineNumber);
        return cursor.move(inSelectionMode, lastLineNumber, lastColumn, 0);
    }
}

},{"../../../base/common/strings.js":"aA9I1","../core/cursorColumns.js":"idX7D","../core/position.js":"lvrPe","../core/range.js":"jmUPh","./cursorAtomicMoveOperations.js":"asPUi","../cursorCommon.js":"aKAuR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"sl4rn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CursorMoveCommands", ()=>CursorMoveCommands);
parcelHelpers.export(exports, "CursorMove", ()=>CursorMove);
var _typesJs = require("../../../base/common/types.js");
var _cursorCommonJs = require("../cursorCommon.js");
var _cursorMoveOperationsJs = require("./cursorMoveOperations.js");
var _cursorWordOperationsJs = require("./cursorWordOperations.js");
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
class CursorMoveCommands {
    static addCursorDown(viewModel, cursors, useLogicalLine) {
        const result = [];
        let resultLen = 0;
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            result[resultLen++] = new (0, _cursorCommonJs.CursorState)(cursor.modelState, cursor.viewState);
            if (useLogicalLine) result[resultLen++] = (0, _cursorCommonJs.CursorState).fromModelState((0, _cursorMoveOperationsJs.MoveOperations).translateDown(viewModel.cursorConfig, viewModel.model, cursor.modelState));
            else result[resultLen++] = (0, _cursorCommonJs.CursorState).fromViewState((0, _cursorMoveOperationsJs.MoveOperations).translateDown(viewModel.cursorConfig, viewModel, cursor.viewState));
        }
        return result;
    }
    static addCursorUp(viewModel, cursors, useLogicalLine) {
        const result = [];
        let resultLen = 0;
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            result[resultLen++] = new (0, _cursorCommonJs.CursorState)(cursor.modelState, cursor.viewState);
            if (useLogicalLine) result[resultLen++] = (0, _cursorCommonJs.CursorState).fromModelState((0, _cursorMoveOperationsJs.MoveOperations).translateUp(viewModel.cursorConfig, viewModel.model, cursor.modelState));
            else result[resultLen++] = (0, _cursorCommonJs.CursorState).fromViewState((0, _cursorMoveOperationsJs.MoveOperations).translateUp(viewModel.cursorConfig, viewModel, cursor.viewState));
        }
        return result;
    }
    static moveToBeginningOfLine(viewModel, cursors, inSelectionMode) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            result[i] = this._moveToLineStart(viewModel, cursor, inSelectionMode);
        }
        return result;
    }
    static _moveToLineStart(viewModel, cursor, inSelectionMode) {
        const currentViewStateColumn = cursor.viewState.position.column;
        const currentModelStateColumn = cursor.modelState.position.column;
        const isFirstLineOfWrappedLine = currentViewStateColumn === currentModelStateColumn;
        const currentViewStatelineNumber = cursor.viewState.position.lineNumber;
        const firstNonBlankColumn = viewModel.getLineFirstNonWhitespaceColumn(currentViewStatelineNumber);
        const isBeginningOfViewLine = currentViewStateColumn === firstNonBlankColumn;
        if (!isFirstLineOfWrappedLine && !isBeginningOfViewLine) return this._moveToLineStartByView(viewModel, cursor, inSelectionMode);
        else return this._moveToLineStartByModel(viewModel, cursor, inSelectionMode);
    }
    static _moveToLineStartByView(viewModel, cursor, inSelectionMode) {
        return (0, _cursorCommonJs.CursorState).fromViewState((0, _cursorMoveOperationsJs.MoveOperations).moveToBeginningOfLine(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode));
    }
    static _moveToLineStartByModel(viewModel, cursor, inSelectionMode) {
        return (0, _cursorCommonJs.CursorState).fromModelState((0, _cursorMoveOperationsJs.MoveOperations).moveToBeginningOfLine(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode));
    }
    static moveToEndOfLine(viewModel, cursors, inSelectionMode, sticky) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            result[i] = this._moveToLineEnd(viewModel, cursor, inSelectionMode, sticky);
        }
        return result;
    }
    static _moveToLineEnd(viewModel, cursor, inSelectionMode, sticky) {
        const viewStatePosition = cursor.viewState.position;
        const viewModelMaxColumn = viewModel.getLineMaxColumn(viewStatePosition.lineNumber);
        const isEndOfViewLine = viewStatePosition.column === viewModelMaxColumn;
        const modelStatePosition = cursor.modelState.position;
        const modelMaxColumn = viewModel.model.getLineMaxColumn(modelStatePosition.lineNumber);
        const isEndLineOfWrappedLine = viewModelMaxColumn - viewStatePosition.column === modelMaxColumn - modelStatePosition.column;
        if (isEndOfViewLine || isEndLineOfWrappedLine) return this._moveToLineEndByModel(viewModel, cursor, inSelectionMode, sticky);
        else return this._moveToLineEndByView(viewModel, cursor, inSelectionMode, sticky);
    }
    static _moveToLineEndByView(viewModel, cursor, inSelectionMode, sticky) {
        return (0, _cursorCommonJs.CursorState).fromViewState((0, _cursorMoveOperationsJs.MoveOperations).moveToEndOfLine(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, sticky));
    }
    static _moveToLineEndByModel(viewModel, cursor, inSelectionMode, sticky) {
        return (0, _cursorCommonJs.CursorState).fromModelState((0, _cursorMoveOperationsJs.MoveOperations).moveToEndOfLine(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode, sticky));
    }
    static expandLineSelection(viewModel, cursors) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            const startLineNumber = cursor.modelState.selection.startLineNumber;
            const lineCount = viewModel.model.getLineCount();
            let endLineNumber = cursor.modelState.selection.endLineNumber;
            let endColumn;
            if (endLineNumber === lineCount) endColumn = viewModel.model.getLineMaxColumn(lineCount);
            else {
                endLineNumber++;
                endColumn = 1;
            }
            result[i] = (0, _cursorCommonJs.CursorState).fromModelState(new (0, _cursorCommonJs.SingleCursorState)(new (0, _rangeJs.Range)(startLineNumber, 1, startLineNumber, 1), 0 /* SelectionStartKind.Simple */ , 0, new (0, _positionJs.Position)(endLineNumber, endColumn), 0));
        }
        return result;
    }
    static moveToBeginningOfBuffer(viewModel, cursors, inSelectionMode) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            result[i] = (0, _cursorCommonJs.CursorState).fromModelState((0, _cursorMoveOperationsJs.MoveOperations).moveToBeginningOfBuffer(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode));
        }
        return result;
    }
    static moveToEndOfBuffer(viewModel, cursors, inSelectionMode) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            result[i] = (0, _cursorCommonJs.CursorState).fromModelState((0, _cursorMoveOperationsJs.MoveOperations).moveToEndOfBuffer(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode));
        }
        return result;
    }
    static selectAll(viewModel, cursor) {
        const lineCount = viewModel.model.getLineCount();
        const maxColumn = viewModel.model.getLineMaxColumn(lineCount);
        return (0, _cursorCommonJs.CursorState).fromModelState(new (0, _cursorCommonJs.SingleCursorState)(new (0, _rangeJs.Range)(1, 1, 1, 1), 0 /* SelectionStartKind.Simple */ , 0, new (0, _positionJs.Position)(lineCount, maxColumn), 0));
    }
    static line(viewModel, cursor, inSelectionMode, _position, _viewPosition) {
        const position = viewModel.model.validatePosition(_position);
        const viewPosition = _viewPosition ? viewModel.coordinatesConverter.validateViewPosition(new (0, _positionJs.Position)(_viewPosition.lineNumber, _viewPosition.column), position) : viewModel.coordinatesConverter.convertModelPositionToViewPosition(position);
        if (!inSelectionMode) {
            // Entering line selection for the first time
            const lineCount = viewModel.model.getLineCount();
            let selectToLineNumber = position.lineNumber + 1;
            let selectToColumn = 1;
            if (selectToLineNumber > lineCount) {
                selectToLineNumber = lineCount;
                selectToColumn = viewModel.model.getLineMaxColumn(selectToLineNumber);
            }
            return (0, _cursorCommonJs.CursorState).fromModelState(new (0, _cursorCommonJs.SingleCursorState)(new (0, _rangeJs.Range)(position.lineNumber, 1, selectToLineNumber, selectToColumn), 2 /* SelectionStartKind.Line */ , 0, new (0, _positionJs.Position)(selectToLineNumber, selectToColumn), 0));
        }
        // Continuing line selection
        const enteringLineNumber = cursor.modelState.selectionStart.getStartPosition().lineNumber;
        if (position.lineNumber < enteringLineNumber) return (0, _cursorCommonJs.CursorState).fromViewState(cursor.viewState.move(true, viewPosition.lineNumber, 1, 0));
        else if (position.lineNumber > enteringLineNumber) {
            const lineCount = viewModel.getLineCount();
            let selectToViewLineNumber = viewPosition.lineNumber + 1;
            let selectToViewColumn = 1;
            if (selectToViewLineNumber > lineCount) {
                selectToViewLineNumber = lineCount;
                selectToViewColumn = viewModel.getLineMaxColumn(selectToViewLineNumber);
            }
            return (0, _cursorCommonJs.CursorState).fromViewState(cursor.viewState.move(true, selectToViewLineNumber, selectToViewColumn, 0));
        } else {
            const endPositionOfSelectionStart = cursor.modelState.selectionStart.getEndPosition();
            return (0, _cursorCommonJs.CursorState).fromModelState(cursor.modelState.move(true, endPositionOfSelectionStart.lineNumber, endPositionOfSelectionStart.column, 0));
        }
    }
    static word(viewModel, cursor, inSelectionMode, _position) {
        const position = viewModel.model.validatePosition(_position);
        return (0, _cursorCommonJs.CursorState).fromModelState((0, _cursorWordOperationsJs.WordOperations).word(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode, position));
    }
    static cancelSelection(viewModel, cursor) {
        if (!cursor.modelState.hasSelection()) return new (0, _cursorCommonJs.CursorState)(cursor.modelState, cursor.viewState);
        const lineNumber = cursor.viewState.position.lineNumber;
        const column = cursor.viewState.position.column;
        return (0, _cursorCommonJs.CursorState).fromViewState(new (0, _cursorCommonJs.SingleCursorState)(new (0, _rangeJs.Range)(lineNumber, column, lineNumber, column), 0 /* SelectionStartKind.Simple */ , 0, new (0, _positionJs.Position)(lineNumber, column), 0));
    }
    static moveTo(viewModel, cursor, inSelectionMode, _position, _viewPosition) {
        if (inSelectionMode) {
            if (cursor.modelState.selectionStartKind === 1 /* SelectionStartKind.Word */ ) return this.word(viewModel, cursor, inSelectionMode, _position);
            if (cursor.modelState.selectionStartKind === 2 /* SelectionStartKind.Line */ ) return this.line(viewModel, cursor, inSelectionMode, _position, _viewPosition);
        }
        const position = viewModel.model.validatePosition(_position);
        const viewPosition = _viewPosition ? viewModel.coordinatesConverter.validateViewPosition(new (0, _positionJs.Position)(_viewPosition.lineNumber, _viewPosition.column), position) : viewModel.coordinatesConverter.convertModelPositionToViewPosition(position);
        return (0, _cursorCommonJs.CursorState).fromViewState(cursor.viewState.move(inSelectionMode, viewPosition.lineNumber, viewPosition.column, 0));
    }
    static simpleMove(viewModel, cursors, direction, inSelectionMode, value, unit) {
        switch(direction){
            case 0 /* CursorMove.Direction.Left */ :
                if (unit === 4 /* CursorMove.Unit.HalfLine */ ) // Move left by half the current line length
                return this._moveHalfLineLeft(viewModel, cursors, inSelectionMode);
                else // Move left by `moveParams.value` columns
                return this._moveLeft(viewModel, cursors, inSelectionMode, value);
            case 1 /* CursorMove.Direction.Right */ :
                if (unit === 4 /* CursorMove.Unit.HalfLine */ ) // Move right by half the current line length
                return this._moveHalfLineRight(viewModel, cursors, inSelectionMode);
                else // Move right by `moveParams.value` columns
                return this._moveRight(viewModel, cursors, inSelectionMode, value);
            case 2 /* CursorMove.Direction.Up */ :
                if (unit === 2 /* CursorMove.Unit.WrappedLine */ ) // Move up by view lines
                return this._moveUpByViewLines(viewModel, cursors, inSelectionMode, value);
                else // Move up by model lines
                return this._moveUpByModelLines(viewModel, cursors, inSelectionMode, value);
            case 3 /* CursorMove.Direction.Down */ :
                if (unit === 2 /* CursorMove.Unit.WrappedLine */ ) // Move down by view lines
                return this._moveDownByViewLines(viewModel, cursors, inSelectionMode, value);
                else // Move down by model lines
                return this._moveDownByModelLines(viewModel, cursors, inSelectionMode, value);
            case 4 /* CursorMove.Direction.PrevBlankLine */ :
                if (unit === 2 /* CursorMove.Unit.WrappedLine */ ) return cursors.map((cursor)=>(0, _cursorCommonJs.CursorState).fromViewState((0, _cursorMoveOperationsJs.MoveOperations).moveToPrevBlankLine(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode)));
                else return cursors.map((cursor)=>(0, _cursorCommonJs.CursorState).fromModelState((0, _cursorMoveOperationsJs.MoveOperations).moveToPrevBlankLine(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode)));
            case 5 /* CursorMove.Direction.NextBlankLine */ :
                if (unit === 2 /* CursorMove.Unit.WrappedLine */ ) return cursors.map((cursor)=>(0, _cursorCommonJs.CursorState).fromViewState((0, _cursorMoveOperationsJs.MoveOperations).moveToNextBlankLine(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode)));
                else return cursors.map((cursor)=>(0, _cursorCommonJs.CursorState).fromModelState((0, _cursorMoveOperationsJs.MoveOperations).moveToNextBlankLine(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode)));
            case 6 /* CursorMove.Direction.WrappedLineStart */ :
                // Move to the beginning of the current view line
                return this._moveToViewMinColumn(viewModel, cursors, inSelectionMode);
            case 7 /* CursorMove.Direction.WrappedLineFirstNonWhitespaceCharacter */ :
                // Move to the first non-whitespace column of the current view line
                return this._moveToViewFirstNonWhitespaceColumn(viewModel, cursors, inSelectionMode);
            case 8 /* CursorMove.Direction.WrappedLineColumnCenter */ :
                // Move to the "center" of the current view line
                return this._moveToViewCenterColumn(viewModel, cursors, inSelectionMode);
            case 9 /* CursorMove.Direction.WrappedLineEnd */ :
                // Move to the end of the current view line
                return this._moveToViewMaxColumn(viewModel, cursors, inSelectionMode);
            case 10 /* CursorMove.Direction.WrappedLineLastNonWhitespaceCharacter */ :
                // Move to the last non-whitespace column of the current view line
                return this._moveToViewLastNonWhitespaceColumn(viewModel, cursors, inSelectionMode);
            default:
                return null;
        }
    }
    static viewportMove(viewModel, cursors, direction, inSelectionMode, value) {
        const visibleViewRange = viewModel.getCompletelyVisibleViewRange();
        const visibleModelRange = viewModel.coordinatesConverter.convertViewRangeToModelRange(visibleViewRange);
        switch(direction){
            case 11 /* CursorMove.Direction.ViewPortTop */ :
                {
                    // Move to the nth line start in the viewport (from the top)
                    const modelLineNumber = this._firstLineNumberInRange(viewModel.model, visibleModelRange, value);
                    const modelColumn = viewModel.model.getLineFirstNonWhitespaceColumn(modelLineNumber);
                    return [
                        this._moveToModelPosition(viewModel, cursors[0], inSelectionMode, modelLineNumber, modelColumn)
                    ];
                }
            case 13 /* CursorMove.Direction.ViewPortBottom */ :
                {
                    // Move to the nth line start in the viewport (from the bottom)
                    const modelLineNumber = this._lastLineNumberInRange(viewModel.model, visibleModelRange, value);
                    const modelColumn = viewModel.model.getLineFirstNonWhitespaceColumn(modelLineNumber);
                    return [
                        this._moveToModelPosition(viewModel, cursors[0], inSelectionMode, modelLineNumber, modelColumn)
                    ];
                }
            case 12 /* CursorMove.Direction.ViewPortCenter */ :
                {
                    // Move to the line start in the viewport center
                    const modelLineNumber = Math.round((visibleModelRange.startLineNumber + visibleModelRange.endLineNumber) / 2);
                    const modelColumn = viewModel.model.getLineFirstNonWhitespaceColumn(modelLineNumber);
                    return [
                        this._moveToModelPosition(viewModel, cursors[0], inSelectionMode, modelLineNumber, modelColumn)
                    ];
                }
            case 14 /* CursorMove.Direction.ViewPortIfOutside */ :
                {
                    // Move to a position inside the viewport
                    const result = [];
                    for(let i = 0, len = cursors.length; i < len; i++){
                        const cursor = cursors[i];
                        result[i] = this.findPositionInViewportIfOutside(viewModel, cursor, visibleViewRange, inSelectionMode);
                    }
                    return result;
                }
            default:
                return null;
        }
    }
    static findPositionInViewportIfOutside(viewModel, cursor, visibleViewRange, inSelectionMode) {
        const viewLineNumber = cursor.viewState.position.lineNumber;
        if (visibleViewRange.startLineNumber <= viewLineNumber && viewLineNumber <= visibleViewRange.endLineNumber - 1) // Nothing to do, cursor is in viewport
        return new (0, _cursorCommonJs.CursorState)(cursor.modelState, cursor.viewState);
        else {
            let newViewLineNumber;
            if (viewLineNumber > visibleViewRange.endLineNumber - 1) newViewLineNumber = visibleViewRange.endLineNumber - 1;
            else if (viewLineNumber < visibleViewRange.startLineNumber) newViewLineNumber = visibleViewRange.startLineNumber;
            else newViewLineNumber = viewLineNumber;
            const position = (0, _cursorMoveOperationsJs.MoveOperations).vertical(viewModel.cursorConfig, viewModel, viewLineNumber, cursor.viewState.position.column, cursor.viewState.leftoverVisibleColumns, newViewLineNumber, false);
            return (0, _cursorCommonJs.CursorState).fromViewState(cursor.viewState.move(inSelectionMode, position.lineNumber, position.column, position.leftoverVisibleColumns));
        }
    }
    /**
     * Find the nth line start included in the range (from the start).
     */ static _firstLineNumberInRange(model, range, count) {
        let startLineNumber = range.startLineNumber;
        if (range.startColumn !== model.getLineMinColumn(startLineNumber)) // Move on to the second line if the first line start is not included in the range
        startLineNumber++;
        return Math.min(range.endLineNumber, startLineNumber + count - 1);
    }
    /**
     * Find the nth line start included in the range (from the end).
     */ static _lastLineNumberInRange(model, range, count) {
        let startLineNumber = range.startLineNumber;
        if (range.startColumn !== model.getLineMinColumn(startLineNumber)) // Move on to the second line if the first line start is not included in the range
        startLineNumber++;
        return Math.max(startLineNumber, range.endLineNumber - count + 1);
    }
    static _moveLeft(viewModel, cursors, inSelectionMode, noOfColumns) {
        return cursors.map((cursor)=>(0, _cursorCommonJs.CursorState).fromViewState((0, _cursorMoveOperationsJs.MoveOperations).moveLeft(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, noOfColumns)));
    }
    static _moveHalfLineLeft(viewModel, cursors, inSelectionMode) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            const viewLineNumber = cursor.viewState.position.lineNumber;
            const halfLine = Math.round(viewModel.getLineLength(viewLineNumber) / 2);
            result[i] = (0, _cursorCommonJs.CursorState).fromViewState((0, _cursorMoveOperationsJs.MoveOperations).moveLeft(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, halfLine));
        }
        return result;
    }
    static _moveRight(viewModel, cursors, inSelectionMode, noOfColumns) {
        return cursors.map((cursor)=>(0, _cursorCommonJs.CursorState).fromViewState((0, _cursorMoveOperationsJs.MoveOperations).moveRight(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, noOfColumns)));
    }
    static _moveHalfLineRight(viewModel, cursors, inSelectionMode) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            const viewLineNumber = cursor.viewState.position.lineNumber;
            const halfLine = Math.round(viewModel.getLineLength(viewLineNumber) / 2);
            result[i] = (0, _cursorCommonJs.CursorState).fromViewState((0, _cursorMoveOperationsJs.MoveOperations).moveRight(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, halfLine));
        }
        return result;
    }
    static _moveDownByViewLines(viewModel, cursors, inSelectionMode, linesCount) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            result[i] = (0, _cursorCommonJs.CursorState).fromViewState((0, _cursorMoveOperationsJs.MoveOperations).moveDown(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, linesCount));
        }
        return result;
    }
    static _moveDownByModelLines(viewModel, cursors, inSelectionMode, linesCount) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            result[i] = (0, _cursorCommonJs.CursorState).fromModelState((0, _cursorMoveOperationsJs.MoveOperations).moveDown(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode, linesCount));
        }
        return result;
    }
    static _moveUpByViewLines(viewModel, cursors, inSelectionMode, linesCount) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            result[i] = (0, _cursorCommonJs.CursorState).fromViewState((0, _cursorMoveOperationsJs.MoveOperations).moveUp(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, linesCount));
        }
        return result;
    }
    static _moveUpByModelLines(viewModel, cursors, inSelectionMode, linesCount) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            result[i] = (0, _cursorCommonJs.CursorState).fromModelState((0, _cursorMoveOperationsJs.MoveOperations).moveUp(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode, linesCount));
        }
        return result;
    }
    static _moveToViewPosition(viewModel, cursor, inSelectionMode, toViewLineNumber, toViewColumn) {
        return (0, _cursorCommonJs.CursorState).fromViewState(cursor.viewState.move(inSelectionMode, toViewLineNumber, toViewColumn, 0));
    }
    static _moveToModelPosition(viewModel, cursor, inSelectionMode, toModelLineNumber, toModelColumn) {
        return (0, _cursorCommonJs.CursorState).fromModelState(cursor.modelState.move(inSelectionMode, toModelLineNumber, toModelColumn, 0));
    }
    static _moveToViewMinColumn(viewModel, cursors, inSelectionMode) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            const viewLineNumber = cursor.viewState.position.lineNumber;
            const viewColumn = viewModel.getLineMinColumn(viewLineNumber);
            result[i] = this._moveToViewPosition(viewModel, cursor, inSelectionMode, viewLineNumber, viewColumn);
        }
        return result;
    }
    static _moveToViewFirstNonWhitespaceColumn(viewModel, cursors, inSelectionMode) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            const viewLineNumber = cursor.viewState.position.lineNumber;
            const viewColumn = viewModel.getLineFirstNonWhitespaceColumn(viewLineNumber);
            result[i] = this._moveToViewPosition(viewModel, cursor, inSelectionMode, viewLineNumber, viewColumn);
        }
        return result;
    }
    static _moveToViewCenterColumn(viewModel, cursors, inSelectionMode) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            const viewLineNumber = cursor.viewState.position.lineNumber;
            const viewColumn = Math.round((viewModel.getLineMaxColumn(viewLineNumber) + viewModel.getLineMinColumn(viewLineNumber)) / 2);
            result[i] = this._moveToViewPosition(viewModel, cursor, inSelectionMode, viewLineNumber, viewColumn);
        }
        return result;
    }
    static _moveToViewMaxColumn(viewModel, cursors, inSelectionMode) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            const viewLineNumber = cursor.viewState.position.lineNumber;
            const viewColumn = viewModel.getLineMaxColumn(viewLineNumber);
            result[i] = this._moveToViewPosition(viewModel, cursor, inSelectionMode, viewLineNumber, viewColumn);
        }
        return result;
    }
    static _moveToViewLastNonWhitespaceColumn(viewModel, cursors, inSelectionMode) {
        const result = [];
        for(let i = 0, len = cursors.length; i < len; i++){
            const cursor = cursors[i];
            const viewLineNumber = cursor.viewState.position.lineNumber;
            const viewColumn = viewModel.getLineLastNonWhitespaceColumn(viewLineNumber);
            result[i] = this._moveToViewPosition(viewModel, cursor, inSelectionMode, viewLineNumber, viewColumn);
        }
        return result;
    }
}
var CursorMove;
(function(CursorMove) {
    const isCursorMoveArgs = function(arg) {
        if (!_typesJs.isObject(arg)) return false;
        const cursorMoveArg = arg;
        if (!_typesJs.isString(cursorMoveArg.to)) return false;
        if (!_typesJs.isUndefined(cursorMoveArg.select) && !_typesJs.isBoolean(cursorMoveArg.select)) return false;
        if (!_typesJs.isUndefined(cursorMoveArg.by) && !_typesJs.isString(cursorMoveArg.by)) return false;
        if (!_typesJs.isUndefined(cursorMoveArg.value) && !_typesJs.isNumber(cursorMoveArg.value)) return false;
        return true;
    };
    CursorMove.metadata = {
        description: "Move cursor to a logical position in the view",
        args: [
            {
                name: "Cursor move argument object",
                description: `Property-value pairs that can be passed through this argument:
					* 'to': A mandatory logical position value providing where to move the cursor.
						\`\`\`
						'left', 'right', 'up', 'down', 'prevBlankLine', 'nextBlankLine',
						'wrappedLineStart', 'wrappedLineEnd', 'wrappedLineColumnCenter'
						'wrappedLineFirstNonWhitespaceCharacter', 'wrappedLineLastNonWhitespaceCharacter'
						'viewPortTop', 'viewPortCenter', 'viewPortBottom', 'viewPortIfOutside'
						\`\`\`
					* 'by': Unit to move. Default is computed based on 'to' value.
						\`\`\`
						'line', 'wrappedLine', 'character', 'halfLine'
						\`\`\`
					* 'value': Number of units to move. Default is '1'.
					* 'select': If 'true' makes the selection. Default is 'false'.
				`,
                constraint: isCursorMoveArgs,
                schema: {
                    "type": "object",
                    "required": [
                        "to"
                    ],
                    "properties": {
                        "to": {
                            "type": "string",
                            "enum": [
                                "left",
                                "right",
                                "up",
                                "down",
                                "prevBlankLine",
                                "nextBlankLine",
                                "wrappedLineStart",
                                "wrappedLineEnd",
                                "wrappedLineColumnCenter",
                                "wrappedLineFirstNonWhitespaceCharacter",
                                "wrappedLineLastNonWhitespaceCharacter",
                                "viewPortTop",
                                "viewPortCenter",
                                "viewPortBottom",
                                "viewPortIfOutside"
                            ]
                        },
                        "by": {
                            "type": "string",
                            "enum": [
                                "line",
                                "wrappedLine",
                                "character",
                                "halfLine"
                            ]
                        },
                        "value": {
                            "type": "number",
                            "default": 1
                        },
                        "select": {
                            "type": "boolean",
                            "default": false
                        }
                    }
                }
            }
        ]
    };
    /**
     * Positions in the view for cursor move command.
     */ CursorMove.RawDirection = {
        Left: "left",
        Right: "right",
        Up: "up",
        Down: "down",
        PrevBlankLine: "prevBlankLine",
        NextBlankLine: "nextBlankLine",
        WrappedLineStart: "wrappedLineStart",
        WrappedLineFirstNonWhitespaceCharacter: "wrappedLineFirstNonWhitespaceCharacter",
        WrappedLineColumnCenter: "wrappedLineColumnCenter",
        WrappedLineEnd: "wrappedLineEnd",
        WrappedLineLastNonWhitespaceCharacter: "wrappedLineLastNonWhitespaceCharacter",
        ViewPortTop: "viewPortTop",
        ViewPortCenter: "viewPortCenter",
        ViewPortBottom: "viewPortBottom",
        ViewPortIfOutside: "viewPortIfOutside"
    };
    /**
     * Units for Cursor move 'by' argument
     */ CursorMove.RawUnit = {
        Line: "line",
        WrappedLine: "wrappedLine",
        Character: "character",
        HalfLine: "halfLine"
    };
    function parse(args) {
        if (!args.to) // illegal arguments
        return null;
        let direction;
        switch(args.to){
            case CursorMove.RawDirection.Left:
                direction = 0 /* Direction.Left */ ;
                break;
            case CursorMove.RawDirection.Right:
                direction = 1 /* Direction.Right */ ;
                break;
            case CursorMove.RawDirection.Up:
                direction = 2 /* Direction.Up */ ;
                break;
            case CursorMove.RawDirection.Down:
                direction = 3 /* Direction.Down */ ;
                break;
            case CursorMove.RawDirection.PrevBlankLine:
                direction = 4 /* Direction.PrevBlankLine */ ;
                break;
            case CursorMove.RawDirection.NextBlankLine:
                direction = 5 /* Direction.NextBlankLine */ ;
                break;
            case CursorMove.RawDirection.WrappedLineStart:
                direction = 6 /* Direction.WrappedLineStart */ ;
                break;
            case CursorMove.RawDirection.WrappedLineFirstNonWhitespaceCharacter:
                direction = 7 /* Direction.WrappedLineFirstNonWhitespaceCharacter */ ;
                break;
            case CursorMove.RawDirection.WrappedLineColumnCenter:
                direction = 8 /* Direction.WrappedLineColumnCenter */ ;
                break;
            case CursorMove.RawDirection.WrappedLineEnd:
                direction = 9 /* Direction.WrappedLineEnd */ ;
                break;
            case CursorMove.RawDirection.WrappedLineLastNonWhitespaceCharacter:
                direction = 10 /* Direction.WrappedLineLastNonWhitespaceCharacter */ ;
                break;
            case CursorMove.RawDirection.ViewPortTop:
                direction = 11 /* Direction.ViewPortTop */ ;
                break;
            case CursorMove.RawDirection.ViewPortBottom:
                direction = 13 /* Direction.ViewPortBottom */ ;
                break;
            case CursorMove.RawDirection.ViewPortCenter:
                direction = 12 /* Direction.ViewPortCenter */ ;
                break;
            case CursorMove.RawDirection.ViewPortIfOutside:
                direction = 14 /* Direction.ViewPortIfOutside */ ;
                break;
            default:
                // illegal arguments
                return null;
        }
        let unit = 0 /* Unit.None */ ;
        switch(args.by){
            case CursorMove.RawUnit.Line:
                unit = 1 /* Unit.Line */ ;
                break;
            case CursorMove.RawUnit.WrappedLine:
                unit = 2 /* Unit.WrappedLine */ ;
                break;
            case CursorMove.RawUnit.Character:
                unit = 3 /* Unit.Character */ ;
                break;
            case CursorMove.RawUnit.HalfLine:
                unit = 4 /* Unit.HalfLine */ ;
                break;
        }
        return {
            direction: direction,
            unit: unit,
            select: !!args.select,
            value: args.value || 1
        };
    }
    CursorMove.parse = parse;
})(CursorMove || (CursorMove = {}));

},{"../../../base/common/types.js":"fb5yx","../cursorCommon.js":"aKAuR","./cursorMoveOperations.js":"74ZGL","./cursorWordOperations.js":"jmZq4","../core/position.js":"lvrPe","../core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jmZq4":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WordOperations", ()=>WordOperations);
parcelHelpers.export(exports, "WordPartOperations", ()=>WordPartOperations);
var _stringsJs = require("../../../base/common/strings.js");
var _cursorCommonJs = require("../cursorCommon.js");
var _cursorDeleteOperationsJs = require("./cursorDeleteOperations.js");
var _wordCharacterClassifierJs = require("../core/wordCharacterClassifier.js");
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
class WordOperations {
    static _createWord(lineContent, wordType, nextCharClass, start, end) {
        // console.log('WORD ==> ' + start + ' => ' + end + ':::: <<<' + lineContent.substring(start, end) + '>>>');
        return {
            start: start,
            end: end,
            wordType: wordType,
            nextCharClass: nextCharClass
        };
    }
    static _createIntlWord(intlWord, nextCharClass) {
        // console.log('INTL WORD ==> ' + intlWord.index + ' => ' + intlWord.index + intlWord.segment.length + ':::: <<<' + intlWord.segment + '>>>');
        return {
            start: intlWord.index,
            end: intlWord.index + intlWord.segment.length,
            wordType: 1 /* WordType.Regular */ ,
            nextCharClass: nextCharClass
        };
    }
    static _findPreviousWordOnLine(wordSeparators, model, position) {
        const lineContent = model.getLineContent(position.lineNumber);
        return this._doFindPreviousWordOnLine(lineContent, wordSeparators, position);
    }
    static _doFindPreviousWordOnLine(lineContent, wordSeparators, position) {
        let wordType = 0 /* WordType.None */ ;
        const previousIntlWord = wordSeparators.findPrevIntlWordBeforeOrAtOffset(lineContent, position.column - 2);
        for(let chIndex = position.column - 2; chIndex >= 0; chIndex--){
            const chCode = lineContent.charCodeAt(chIndex);
            const chClass = wordSeparators.get(chCode);
            if (previousIntlWord && chIndex === previousIntlWord.index) return this._createIntlWord(previousIntlWord, chClass);
            if (chClass === 0 /* WordCharacterClass.Regular */ ) {
                if (wordType === 2 /* WordType.Separator */ ) return this._createWord(lineContent, wordType, chClass, chIndex + 1, this._findEndOfWord(lineContent, wordSeparators, wordType, chIndex + 1));
                wordType = 1 /* WordType.Regular */ ;
            } else if (chClass === 2 /* WordCharacterClass.WordSeparator */ ) {
                if (wordType === 1 /* WordType.Regular */ ) return this._createWord(lineContent, wordType, chClass, chIndex + 1, this._findEndOfWord(lineContent, wordSeparators, wordType, chIndex + 1));
                wordType = 2 /* WordType.Separator */ ;
            } else if (chClass === 1 /* WordCharacterClass.Whitespace */ ) {
                if (wordType !== 0 /* WordType.None */ ) return this._createWord(lineContent, wordType, chClass, chIndex + 1, this._findEndOfWord(lineContent, wordSeparators, wordType, chIndex + 1));
            }
        }
        if (wordType !== 0 /* WordType.None */ ) return this._createWord(lineContent, wordType, 1 /* WordCharacterClass.Whitespace */ , 0, this._findEndOfWord(lineContent, wordSeparators, wordType, 0));
        return null;
    }
    static _findEndOfWord(lineContent, wordSeparators, wordType, startIndex) {
        const nextIntlWord = wordSeparators.findNextIntlWordAtOrAfterOffset(lineContent, startIndex);
        const len = lineContent.length;
        for(let chIndex = startIndex; chIndex < len; chIndex++){
            const chCode = lineContent.charCodeAt(chIndex);
            const chClass = wordSeparators.get(chCode);
            if (nextIntlWord && chIndex === nextIntlWord.index + nextIntlWord.segment.length) return chIndex;
            if (chClass === 1 /* WordCharacterClass.Whitespace */ ) return chIndex;
            if (wordType === 1 /* WordType.Regular */  && chClass === 2 /* WordCharacterClass.WordSeparator */ ) return chIndex;
            if (wordType === 2 /* WordType.Separator */  && chClass === 0 /* WordCharacterClass.Regular */ ) return chIndex;
        }
        return len;
    }
    static _findNextWordOnLine(wordSeparators, model, position) {
        const lineContent = model.getLineContent(position.lineNumber);
        return this._doFindNextWordOnLine(lineContent, wordSeparators, position);
    }
    static _doFindNextWordOnLine(lineContent, wordSeparators, position) {
        let wordType = 0 /* WordType.None */ ;
        const len = lineContent.length;
        const nextIntlWord = wordSeparators.findNextIntlWordAtOrAfterOffset(lineContent, position.column - 1);
        for(let chIndex = position.column - 1; chIndex < len; chIndex++){
            const chCode = lineContent.charCodeAt(chIndex);
            const chClass = wordSeparators.get(chCode);
            if (nextIntlWord && chIndex === nextIntlWord.index) return this._createIntlWord(nextIntlWord, chClass);
            if (chClass === 0 /* WordCharacterClass.Regular */ ) {
                if (wordType === 2 /* WordType.Separator */ ) return this._createWord(lineContent, wordType, chClass, this._findStartOfWord(lineContent, wordSeparators, wordType, chIndex - 1), chIndex);
                wordType = 1 /* WordType.Regular */ ;
            } else if (chClass === 2 /* WordCharacterClass.WordSeparator */ ) {
                if (wordType === 1 /* WordType.Regular */ ) return this._createWord(lineContent, wordType, chClass, this._findStartOfWord(lineContent, wordSeparators, wordType, chIndex - 1), chIndex);
                wordType = 2 /* WordType.Separator */ ;
            } else if (chClass === 1 /* WordCharacterClass.Whitespace */ ) {
                if (wordType !== 0 /* WordType.None */ ) return this._createWord(lineContent, wordType, chClass, this._findStartOfWord(lineContent, wordSeparators, wordType, chIndex - 1), chIndex);
            }
        }
        if (wordType !== 0 /* WordType.None */ ) return this._createWord(lineContent, wordType, 1 /* WordCharacterClass.Whitespace */ , this._findStartOfWord(lineContent, wordSeparators, wordType, len - 1), len);
        return null;
    }
    static _findStartOfWord(lineContent, wordSeparators, wordType, startIndex) {
        const previousIntlWord = wordSeparators.findPrevIntlWordBeforeOrAtOffset(lineContent, startIndex);
        for(let chIndex = startIndex; chIndex >= 0; chIndex--){
            const chCode = lineContent.charCodeAt(chIndex);
            const chClass = wordSeparators.get(chCode);
            if (previousIntlWord && chIndex === previousIntlWord.index) return chIndex;
            if (chClass === 1 /* WordCharacterClass.Whitespace */ ) return chIndex + 1;
            if (wordType === 1 /* WordType.Regular */  && chClass === 2 /* WordCharacterClass.WordSeparator */ ) return chIndex + 1;
            if (wordType === 2 /* WordType.Separator */  && chClass === 0 /* WordCharacterClass.Regular */ ) return chIndex + 1;
        }
        return 0;
    }
    static moveWordLeft(wordSeparators, model, position, wordNavigationType, hasMulticursor) {
        let lineNumber = position.lineNumber;
        let column = position.column;
        if (column === 1) {
            if (lineNumber > 1) {
                lineNumber = lineNumber - 1;
                column = model.getLineMaxColumn(lineNumber);
            }
        }
        let prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new (0, _positionJs.Position)(lineNumber, column));
        if (wordNavigationType === 0 /* WordNavigationType.WordStart */ ) return new (0, _positionJs.Position)(lineNumber, prevWordOnLine ? prevWordOnLine.start + 1 : 1);
        if (wordNavigationType === 1 /* WordNavigationType.WordStartFast */ ) {
            if (!hasMulticursor // avoid having multiple cursors stop at different locations when doing word start
             && prevWordOnLine && prevWordOnLine.wordType === 2 /* WordType.Separator */  && prevWordOnLine.end - prevWordOnLine.start === 1 && prevWordOnLine.nextCharClass === 0 /* WordCharacterClass.Regular */ ) // Skip over a word made up of one single separator and followed by a regular character
            prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new (0, _positionJs.Position)(lineNumber, prevWordOnLine.start + 1));
            return new (0, _positionJs.Position)(lineNumber, prevWordOnLine ? prevWordOnLine.start + 1 : 1);
        }
        if (wordNavigationType === 3 /* WordNavigationType.WordAccessibility */ ) {
            while(prevWordOnLine && prevWordOnLine.wordType === 2 /* WordType.Separator */ )// Skip over words made up of only separators
            prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new (0, _positionJs.Position)(lineNumber, prevWordOnLine.start + 1));
            return new (0, _positionJs.Position)(lineNumber, prevWordOnLine ? prevWordOnLine.start + 1 : 1);
        }
        // We are stopping at the ending of words
        if (prevWordOnLine && column <= prevWordOnLine.end + 1) prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new (0, _positionJs.Position)(lineNumber, prevWordOnLine.start + 1));
        return new (0, _positionJs.Position)(lineNumber, prevWordOnLine ? prevWordOnLine.end + 1 : 1);
    }
    static _moveWordPartLeft(model, position) {
        const lineNumber = position.lineNumber;
        const maxColumn = model.getLineMaxColumn(lineNumber);
        if (position.column === 1) return lineNumber > 1 ? new (0, _positionJs.Position)(lineNumber - 1, model.getLineMaxColumn(lineNumber - 1)) : position;
        const lineContent = model.getLineContent(lineNumber);
        for(let column = position.column - 1; column > 1; column--){
            const left = lineContent.charCodeAt(column - 2);
            const right = lineContent.charCodeAt(column - 1);
            if (left === 95 /* CharCode.Underline */  && right !== 95 /* CharCode.Underline */ ) // snake_case_variables
            return new (0, _positionJs.Position)(lineNumber, column);
            if (left === 45 /* CharCode.Dash */  && right !== 45 /* CharCode.Dash */ ) // kebab-case-variables
            return new (0, _positionJs.Position)(lineNumber, column);
            if ((_stringsJs.isLowerAsciiLetter(left) || _stringsJs.isAsciiDigit(left)) && _stringsJs.isUpperAsciiLetter(right)) // camelCaseVariables
            return new (0, _positionJs.Position)(lineNumber, column);
            if (_stringsJs.isUpperAsciiLetter(left) && _stringsJs.isUpperAsciiLetter(right)) // thisIsACamelCaseWithOneLetterWords
            {
                if (column + 1 < maxColumn) {
                    const rightRight = lineContent.charCodeAt(column);
                    if (_stringsJs.isLowerAsciiLetter(rightRight) || _stringsJs.isAsciiDigit(rightRight)) return new (0, _positionJs.Position)(lineNumber, column);
                }
            }
        }
        return new (0, _positionJs.Position)(lineNumber, 1);
    }
    static moveWordRight(wordSeparators, model, position, wordNavigationType) {
        let lineNumber = position.lineNumber;
        let column = position.column;
        let movedDown = false;
        if (column === model.getLineMaxColumn(lineNumber)) {
            if (lineNumber < model.getLineCount()) {
                movedDown = true;
                lineNumber = lineNumber + 1;
                column = 1;
            }
        }
        let nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new (0, _positionJs.Position)(lineNumber, column));
        if (wordNavigationType === 2 /* WordNavigationType.WordEnd */ ) {
            if (nextWordOnLine && nextWordOnLine.wordType === 2 /* WordType.Separator */ ) {
                if (nextWordOnLine.end - nextWordOnLine.start === 1 && nextWordOnLine.nextCharClass === 0 /* WordCharacterClass.Regular */ ) // Skip over a word made up of one single separator and followed by a regular character
                nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new (0, _positionJs.Position)(lineNumber, nextWordOnLine.end + 1));
            }
            if (nextWordOnLine) column = nextWordOnLine.end + 1;
            else column = model.getLineMaxColumn(lineNumber);
        } else if (wordNavigationType === 3 /* WordNavigationType.WordAccessibility */ ) {
            if (movedDown) // If we move to the next line, pretend that the cursor is right before the first character.
            // This is needed when the first word starts right at the first character - and in order not to miss it,
            // we need to start before.
            column = 0;
            while(nextWordOnLine && (nextWordOnLine.wordType === 2 /* WordType.Separator */  || nextWordOnLine.start + 1 <= column))// Skip over a word made up of one single separator
            // Also skip over word if it begins before current cursor position to ascertain we're moving forward at least 1 character.
            nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new (0, _positionJs.Position)(lineNumber, nextWordOnLine.end + 1));
            if (nextWordOnLine) column = nextWordOnLine.start + 1;
            else column = model.getLineMaxColumn(lineNumber);
        } else {
            if (nextWordOnLine && !movedDown && column >= nextWordOnLine.start + 1) nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new (0, _positionJs.Position)(lineNumber, nextWordOnLine.end + 1));
            if (nextWordOnLine) column = nextWordOnLine.start + 1;
            else column = model.getLineMaxColumn(lineNumber);
        }
        return new (0, _positionJs.Position)(lineNumber, column);
    }
    static _moveWordPartRight(model, position) {
        const lineNumber = position.lineNumber;
        const maxColumn = model.getLineMaxColumn(lineNumber);
        if (position.column === maxColumn) return lineNumber < model.getLineCount() ? new (0, _positionJs.Position)(lineNumber + 1, 1) : position;
        const lineContent = model.getLineContent(lineNumber);
        for(let column = position.column + 1; column < maxColumn; column++){
            const left = lineContent.charCodeAt(column - 2);
            const right = lineContent.charCodeAt(column - 1);
            if (left !== 95 /* CharCode.Underline */  && right === 95 /* CharCode.Underline */ ) // snake_case_variables
            return new (0, _positionJs.Position)(lineNumber, column);
            if (left !== 45 /* CharCode.Dash */  && right === 45 /* CharCode.Dash */ ) // kebab-case-variables
            return new (0, _positionJs.Position)(lineNumber, column);
            if ((_stringsJs.isLowerAsciiLetter(left) || _stringsJs.isAsciiDigit(left)) && _stringsJs.isUpperAsciiLetter(right)) // camelCaseVariables
            return new (0, _positionJs.Position)(lineNumber, column);
            if (_stringsJs.isUpperAsciiLetter(left) && _stringsJs.isUpperAsciiLetter(right)) // thisIsACamelCaseWithOneLetterWords
            {
                if (column + 1 < maxColumn) {
                    const rightRight = lineContent.charCodeAt(column);
                    if (_stringsJs.isLowerAsciiLetter(rightRight) || _stringsJs.isAsciiDigit(rightRight)) return new (0, _positionJs.Position)(lineNumber, column);
                }
            }
        }
        return new (0, _positionJs.Position)(lineNumber, maxColumn);
    }
    static _deleteWordLeftWhitespace(model, position) {
        const lineContent = model.getLineContent(position.lineNumber);
        const startIndex = position.column - 2;
        const lastNonWhitespace = _stringsJs.lastNonWhitespaceIndex(lineContent, startIndex);
        if (lastNonWhitespace + 1 < startIndex) return new (0, _rangeJs.Range)(position.lineNumber, lastNonWhitespace + 2, position.lineNumber, position.column);
        return null;
    }
    static deleteWordLeft(ctx, wordNavigationType) {
        const wordSeparators = ctx.wordSeparators;
        const model = ctx.model;
        const selection = ctx.selection;
        const whitespaceHeuristics = ctx.whitespaceHeuristics;
        if (!selection.isEmpty()) return selection;
        if ((0, _cursorDeleteOperationsJs.DeleteOperations).isAutoClosingPairDelete(ctx.autoClosingDelete, ctx.autoClosingBrackets, ctx.autoClosingQuotes, ctx.autoClosingPairs.autoClosingPairsOpenByEnd, ctx.model, [
            ctx.selection
        ], ctx.autoClosedCharacters)) {
            const position = ctx.selection.getPosition();
            return new (0, _rangeJs.Range)(position.lineNumber, position.column - 1, position.lineNumber, position.column + 1);
        }
        const position = new (0, _positionJs.Position)(selection.positionLineNumber, selection.positionColumn);
        let lineNumber = position.lineNumber;
        let column = position.column;
        if (lineNumber === 1 && column === 1) // Ignore deleting at beginning of file
        return null;
        if (whitespaceHeuristics) {
            const r = this._deleteWordLeftWhitespace(model, position);
            if (r) return r;
        }
        let prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);
        if (wordNavigationType === 0 /* WordNavigationType.WordStart */ ) {
            if (prevWordOnLine) column = prevWordOnLine.start + 1;
            else if (column > 1) column = 1;
            else {
                lineNumber--;
                column = model.getLineMaxColumn(lineNumber);
            }
        } else {
            if (prevWordOnLine && column <= prevWordOnLine.end + 1) prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new (0, _positionJs.Position)(lineNumber, prevWordOnLine.start + 1));
            if (prevWordOnLine) column = prevWordOnLine.end + 1;
            else if (column > 1) column = 1;
            else {
                lineNumber--;
                column = model.getLineMaxColumn(lineNumber);
            }
        }
        return new (0, _rangeJs.Range)(lineNumber, column, position.lineNumber, position.column);
    }
    static deleteInsideWord(wordSeparators, model, selection) {
        if (!selection.isEmpty()) return selection;
        const position = new (0, _positionJs.Position)(selection.positionLineNumber, selection.positionColumn);
        const r = this._deleteInsideWordWhitespace(model, position);
        if (r) return r;
        return this._deleteInsideWordDetermineDeleteRange(wordSeparators, model, position);
    }
    static _charAtIsWhitespace(str, index) {
        const charCode = str.charCodeAt(index);
        return charCode === 32 /* CharCode.Space */  || charCode === 9 /* CharCode.Tab */ ;
    }
    static _deleteInsideWordWhitespace(model, position) {
        const lineContent = model.getLineContent(position.lineNumber);
        const lineContentLength = lineContent.length;
        if (lineContentLength === 0) // empty line
        return null;
        let leftIndex = Math.max(position.column - 2, 0);
        if (!this._charAtIsWhitespace(lineContent, leftIndex)) // touches a non-whitespace character to the left
        return null;
        let rightIndex = Math.min(position.column - 1, lineContentLength - 1);
        if (!this._charAtIsWhitespace(lineContent, rightIndex)) // touches a non-whitespace character to the right
        return null;
        // walk over whitespace to the left
        while(leftIndex > 0 && this._charAtIsWhitespace(lineContent, leftIndex - 1))leftIndex--;
        // walk over whitespace to the right
        while(rightIndex + 1 < lineContentLength && this._charAtIsWhitespace(lineContent, rightIndex + 1))rightIndex++;
        return new (0, _rangeJs.Range)(position.lineNumber, leftIndex + 1, position.lineNumber, rightIndex + 2);
    }
    static _deleteInsideWordDetermineDeleteRange(wordSeparators, model, position) {
        const lineContent = model.getLineContent(position.lineNumber);
        const lineLength = lineContent.length;
        if (lineLength === 0) {
            // empty line
            if (position.lineNumber > 1) return new (0, _rangeJs.Range)(position.lineNumber - 1, model.getLineMaxColumn(position.lineNumber - 1), position.lineNumber, 1);
            else {
                if (position.lineNumber < model.getLineCount()) return new (0, _rangeJs.Range)(position.lineNumber, 1, position.lineNumber + 1, 1);
                else // empty model
                return new (0, _rangeJs.Range)(position.lineNumber, 1, position.lineNumber, 1);
            }
        }
        const touchesWord = (word)=>{
            return word.start + 1 <= position.column && position.column <= word.end + 1;
        };
        const createRangeWithPosition = (startColumn, endColumn)=>{
            startColumn = Math.min(startColumn, position.column);
            endColumn = Math.max(endColumn, position.column);
            return new (0, _rangeJs.Range)(position.lineNumber, startColumn, position.lineNumber, endColumn);
        };
        const deleteWordAndAdjacentWhitespace = (word)=>{
            let startColumn = word.start + 1;
            let endColumn = word.end + 1;
            let expandedToTheRight = false;
            while(endColumn - 1 < lineLength && this._charAtIsWhitespace(lineContent, endColumn - 1)){
                expandedToTheRight = true;
                endColumn++;
            }
            if (!expandedToTheRight) while(startColumn > 1 && this._charAtIsWhitespace(lineContent, startColumn - 2))startColumn--;
            return createRangeWithPosition(startColumn, endColumn);
        };
        const prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);
        if (prevWordOnLine && touchesWord(prevWordOnLine)) return deleteWordAndAdjacentWhitespace(prevWordOnLine);
        const nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, position);
        if (nextWordOnLine && touchesWord(nextWordOnLine)) return deleteWordAndAdjacentWhitespace(nextWordOnLine);
        if (prevWordOnLine && nextWordOnLine) return createRangeWithPosition(prevWordOnLine.end + 1, nextWordOnLine.start + 1);
        if (prevWordOnLine) return createRangeWithPosition(prevWordOnLine.start + 1, prevWordOnLine.end + 1);
        if (nextWordOnLine) return createRangeWithPosition(nextWordOnLine.start + 1, nextWordOnLine.end + 1);
        return createRangeWithPosition(1, lineLength + 1);
    }
    static _deleteWordPartLeft(model, selection) {
        if (!selection.isEmpty()) return selection;
        const pos = selection.getPosition();
        const toPosition = WordOperations._moveWordPartLeft(model, pos);
        return new (0, _rangeJs.Range)(pos.lineNumber, pos.column, toPosition.lineNumber, toPosition.column);
    }
    static _findFirstNonWhitespaceChar(str, startIndex) {
        const len = str.length;
        for(let chIndex = startIndex; chIndex < len; chIndex++){
            const ch = str.charAt(chIndex);
            if (ch !== " " && ch !== "	") return chIndex;
        }
        return len;
    }
    static _deleteWordRightWhitespace(model, position) {
        const lineContent = model.getLineContent(position.lineNumber);
        const startIndex = position.column - 1;
        const firstNonWhitespace = this._findFirstNonWhitespaceChar(lineContent, startIndex);
        if (startIndex + 1 < firstNonWhitespace) // bingo
        return new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, firstNonWhitespace + 1);
        return null;
    }
    static deleteWordRight(ctx, wordNavigationType) {
        const wordSeparators = ctx.wordSeparators;
        const model = ctx.model;
        const selection = ctx.selection;
        const whitespaceHeuristics = ctx.whitespaceHeuristics;
        if (!selection.isEmpty()) return selection;
        const position = new (0, _positionJs.Position)(selection.positionLineNumber, selection.positionColumn);
        let lineNumber = position.lineNumber;
        let column = position.column;
        const lineCount = model.getLineCount();
        const maxColumn = model.getLineMaxColumn(lineNumber);
        if (lineNumber === lineCount && column === maxColumn) // Ignore deleting at end of file
        return null;
        if (whitespaceHeuristics) {
            const r = this._deleteWordRightWhitespace(model, position);
            if (r) return r;
        }
        let nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, position);
        if (wordNavigationType === 2 /* WordNavigationType.WordEnd */ ) {
            if (nextWordOnLine) column = nextWordOnLine.end + 1;
            else if (column < maxColumn || lineNumber === lineCount) column = maxColumn;
            else {
                lineNumber++;
                nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new (0, _positionJs.Position)(lineNumber, 1));
                if (nextWordOnLine) column = nextWordOnLine.start + 1;
                else column = model.getLineMaxColumn(lineNumber);
            }
        } else {
            if (nextWordOnLine && column >= nextWordOnLine.start + 1) nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new (0, _positionJs.Position)(lineNumber, nextWordOnLine.end + 1));
            if (nextWordOnLine) column = nextWordOnLine.start + 1;
            else if (column < maxColumn || lineNumber === lineCount) column = maxColumn;
            else {
                lineNumber++;
                nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new (0, _positionJs.Position)(lineNumber, 1));
                if (nextWordOnLine) column = nextWordOnLine.start + 1;
                else column = model.getLineMaxColumn(lineNumber);
            }
        }
        return new (0, _rangeJs.Range)(lineNumber, column, position.lineNumber, position.column);
    }
    static _deleteWordPartRight(model, selection) {
        if (!selection.isEmpty()) return selection;
        const pos = selection.getPosition();
        const toPosition = WordOperations._moveWordPartRight(model, pos);
        return new (0, _rangeJs.Range)(pos.lineNumber, pos.column, toPosition.lineNumber, toPosition.column);
    }
    static _createWordAtPosition(model, lineNumber, word) {
        const range = new (0, _rangeJs.Range)(lineNumber, word.start + 1, lineNumber, word.end + 1);
        return {
            word: model.getValueInRange(range),
            startColumn: range.startColumn,
            endColumn: range.endColumn
        };
    }
    static getWordAtPosition(model, _wordSeparators, _intlSegmenterLocales, position) {
        const wordSeparators = (0, _wordCharacterClassifierJs.getMapForWordSeparators)(_wordSeparators, _intlSegmenterLocales);
        const prevWord = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);
        if (prevWord && prevWord.wordType === 1 /* WordType.Regular */  && prevWord.start <= position.column - 1 && position.column - 1 <= prevWord.end) return WordOperations._createWordAtPosition(model, position.lineNumber, prevWord);
        const nextWord = WordOperations._findNextWordOnLine(wordSeparators, model, position);
        if (nextWord && nextWord.wordType === 1 /* WordType.Regular */  && nextWord.start <= position.column - 1 && position.column - 1 <= nextWord.end) return WordOperations._createWordAtPosition(model, position.lineNumber, nextWord);
        return null;
    }
    static word(config, model, cursor, inSelectionMode, position) {
        const wordSeparators = (0, _wordCharacterClassifierJs.getMapForWordSeparators)(config.wordSeparators, config.wordSegmenterLocales);
        const prevWord = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);
        const nextWord = WordOperations._findNextWordOnLine(wordSeparators, model, position);
        if (!inSelectionMode) {
            // Entering word selection for the first time
            let startColumn;
            let endColumn;
            if (prevWord && prevWord.wordType === 1 /* WordType.Regular */  && prevWord.start <= position.column - 1 && position.column - 1 <= prevWord.end) {
                // isTouchingPrevWord
                startColumn = prevWord.start + 1;
                endColumn = prevWord.end + 1;
            } else if (nextWord && nextWord.wordType === 1 /* WordType.Regular */  && nextWord.start <= position.column - 1 && position.column - 1 <= nextWord.end) {
                // isTouchingNextWord
                startColumn = nextWord.start + 1;
                endColumn = nextWord.end + 1;
            } else {
                if (prevWord) startColumn = prevWord.end + 1;
                else startColumn = 1;
                if (nextWord) endColumn = nextWord.start + 1;
                else endColumn = model.getLineMaxColumn(position.lineNumber);
            }
            return new (0, _cursorCommonJs.SingleCursorState)(new (0, _rangeJs.Range)(position.lineNumber, startColumn, position.lineNumber, endColumn), 1 /* SelectionStartKind.Word */ , 0, new (0, _positionJs.Position)(position.lineNumber, endColumn), 0);
        }
        let startColumn;
        let endColumn;
        if (prevWord && prevWord.wordType === 1 /* WordType.Regular */  && prevWord.start < position.column - 1 && position.column - 1 < prevWord.end) {
            // isInsidePrevWord
            startColumn = prevWord.start + 1;
            endColumn = prevWord.end + 1;
        } else if (nextWord && nextWord.wordType === 1 /* WordType.Regular */  && nextWord.start < position.column - 1 && position.column - 1 < nextWord.end) {
            // isInsideNextWord
            startColumn = nextWord.start + 1;
            endColumn = nextWord.end + 1;
        } else {
            startColumn = position.column;
            endColumn = position.column;
        }
        const lineNumber = position.lineNumber;
        let column;
        if (cursor.selectionStart.containsPosition(position)) column = cursor.selectionStart.endColumn;
        else if (position.isBeforeOrEqual(cursor.selectionStart.getStartPosition())) {
            column = startColumn;
            const possiblePosition = new (0, _positionJs.Position)(lineNumber, column);
            if (cursor.selectionStart.containsPosition(possiblePosition)) column = cursor.selectionStart.endColumn;
        } else {
            column = endColumn;
            const possiblePosition = new (0, _positionJs.Position)(lineNumber, column);
            if (cursor.selectionStart.containsPosition(possiblePosition)) column = cursor.selectionStart.startColumn;
        }
        return cursor.move(true, lineNumber, column, 0);
    }
}
class WordPartOperations extends WordOperations {
    static deleteWordPartLeft(ctx) {
        const candidates = enforceDefined([
            WordOperations.deleteWordLeft(ctx, 0 /* WordNavigationType.WordStart */ ),
            WordOperations.deleteWordLeft(ctx, 2 /* WordNavigationType.WordEnd */ ),
            WordOperations._deleteWordPartLeft(ctx.model, ctx.selection)
        ]);
        candidates.sort((0, _rangeJs.Range).compareRangesUsingEnds);
        return candidates[2];
    }
    static deleteWordPartRight(ctx) {
        const candidates = enforceDefined([
            WordOperations.deleteWordRight(ctx, 0 /* WordNavigationType.WordStart */ ),
            WordOperations.deleteWordRight(ctx, 2 /* WordNavigationType.WordEnd */ ),
            WordOperations._deleteWordPartRight(ctx.model, ctx.selection)
        ]);
        candidates.sort((0, _rangeJs.Range).compareRangesUsingStarts);
        return candidates[0];
    }
    static moveWordPartLeft(wordSeparators, model, position, hasMulticursor) {
        const candidates = enforceDefined([
            WordOperations.moveWordLeft(wordSeparators, model, position, 0 /* WordNavigationType.WordStart */ , hasMulticursor),
            WordOperations.moveWordLeft(wordSeparators, model, position, 2 /* WordNavigationType.WordEnd */ , hasMulticursor),
            WordOperations._moveWordPartLeft(model, position)
        ]);
        candidates.sort((0, _positionJs.Position).compare);
        return candidates[2];
    }
    static moveWordPartRight(wordSeparators, model, position) {
        const candidates = enforceDefined([
            WordOperations.moveWordRight(wordSeparators, model, position, 0 /* WordNavigationType.WordStart */ ),
            WordOperations.moveWordRight(wordSeparators, model, position, 2 /* WordNavigationType.WordEnd */ ),
            WordOperations._moveWordPartRight(model, position)
        ]);
        candidates.sort((0, _positionJs.Position).compare);
        return candidates[0];
    }
}
function enforceDefined(arr) {
    return arr.filter((el)=>Boolean(el));
}

},{"../../../base/common/strings.js":"aA9I1","../cursorCommon.js":"aKAuR","./cursorDeleteOperations.js":"kHqWV","../core/wordCharacterClassifier.js":"a4wPa","../core/position.js":"lvrPe","../core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8iSM3":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TypeOperations", ()=>TypeOperations);
parcelHelpers.export(exports, "CompositionOutcome", ()=>CompositionOutcome);
var _shiftCommandJs = require("../commands/shiftCommand.js");
var _surroundSelectionCommandJs = require("../commands/surroundSelectionCommand.js");
var _cursorCommonJs = require("../cursorCommon.js");
var _cursorTypeEditOperationsJs = require("./cursorTypeEditOperations.js");
class TypeOperations {
    static indent(config, model, selections) {
        if (model === null || selections === null) return [];
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++)commands[i] = new (0, _shiftCommandJs.ShiftCommand)(selections[i], {
            isUnshift: false,
            tabSize: config.tabSize,
            indentSize: config.indentSize,
            insertSpaces: config.insertSpaces,
            useTabStops: config.useTabStops,
            autoIndent: config.autoIndent
        }, config.languageConfigurationService);
        return commands;
    }
    static outdent(config, model, selections) {
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++)commands[i] = new (0, _shiftCommandJs.ShiftCommand)(selections[i], {
            isUnshift: true,
            tabSize: config.tabSize,
            indentSize: config.indentSize,
            insertSpaces: config.insertSpaces,
            useTabStops: config.useTabStops,
            autoIndent: config.autoIndent
        }, config.languageConfigurationService);
        return commands;
    }
    static paste(config, model, selections, text, pasteOnNewLine, multicursorText) {
        return (0, _cursorTypeEditOperationsJs.PasteOperation).getEdits(config, model, selections, text, pasteOnNewLine, multicursorText);
    }
    static tab(config, model, selections) {
        return (0, _cursorTypeEditOperationsJs.TabOperation).getCommands(config, model, selections);
    }
    static compositionType(prevEditOperationType, config, model, selections, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta) {
        return (0, _cursorTypeEditOperationsJs.CompositionOperation).getEdits(prevEditOperationType, config, model, selections, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta);
    }
    /**
     * This is very similar with typing, but the character is already in the text buffer!
     */ static compositionEndWithInterceptors(prevEditOperationType, config, model, compositions, selections, autoClosedCharacters) {
        if (!compositions) // could not deduce what the composition did
        return null;
        let insertedText = null;
        for (const composition of compositions){
            if (insertedText === null) insertedText = composition.insertedText;
            else if (insertedText !== composition.insertedText) // not all selections agree on what was typed
            return null;
        }
        if (!insertedText || insertedText.length !== 1) // we're only interested in the case where a single character was inserted
        return null;
        const ch = insertedText;
        let hasDeletion = false;
        for (const composition of compositions)if (composition.deletedText.length !== 0) {
            hasDeletion = true;
            break;
        }
        if (hasDeletion) {
            // Check if this could have been a surround selection
            if (!(0, _cursorTypeEditOperationsJs.shouldSurroundChar)(config, ch) || !config.surroundingPairs.hasOwnProperty(ch)) return null;
            const isTypingAQuoteCharacter = (0, _cursorCommonJs.isQuote)(ch);
            for (const composition of compositions){
                if (composition.deletedSelectionStart !== 0 || composition.deletedSelectionEnd !== composition.deletedText.length) // more text was deleted than was selected, so this could not have been a surround selection
                return null;
                if (/^[ \t]+$/.test(composition.deletedText)) // deleted text was only whitespace
                return null;
                if (isTypingAQuoteCharacter && (0, _cursorCommonJs.isQuote)(composition.deletedText)) // deleted text was a quote
                return null;
            }
            const positions = [];
            for (const selection of selections){
                if (!selection.isEmpty()) return null;
                positions.push(selection.getPosition());
            }
            if (positions.length !== compositions.length) return null;
            const commands = [];
            for(let i = 0, len = positions.length; i < len; i++)commands.push(new (0, _surroundSelectionCommandJs.CompositionSurroundSelectionCommand)(positions[i], compositions[i].deletedText, config.surroundingPairs[ch]));
            return new (0, _cursorCommonJs.EditOperationResult)(4 /* EditOperationType.TypingOther */ , commands, {
                shouldPushStackElementBefore: true,
                shouldPushStackElementAfter: false
            });
        }
        const autoClosingOvertypeEdits = (0, _cursorTypeEditOperationsJs.AutoClosingOvertypeWithInterceptorsOperation).getEdits(config, model, selections, autoClosedCharacters, ch);
        if (autoClosingOvertypeEdits !== undefined) return autoClosingOvertypeEdits;
        const autoClosingOpenCharEdits = (0, _cursorTypeEditOperationsJs.AutoClosingOpenCharTypeOperation).getEdits(config, model, selections, ch, true, false);
        if (autoClosingOpenCharEdits !== undefined) return autoClosingOpenCharEdits;
        return null;
    }
    static typeWithInterceptors(isDoingComposition, prevEditOperationType, config, model, selections, autoClosedCharacters, ch) {
        const enterEdits = (0, _cursorTypeEditOperationsJs.EnterOperation).getEdits(config, model, selections, ch, isDoingComposition);
        if (enterEdits !== undefined) return enterEdits;
        const autoIndentEdits = (0, _cursorTypeEditOperationsJs.AutoIndentOperation).getEdits(config, model, selections, ch, isDoingComposition);
        if (autoIndentEdits !== undefined) return autoIndentEdits;
        const autoClosingOverTypeEdits = (0, _cursorTypeEditOperationsJs.AutoClosingOvertypeOperation).getEdits(prevEditOperationType, config, model, selections, autoClosedCharacters, ch);
        if (autoClosingOverTypeEdits !== undefined) return autoClosingOverTypeEdits;
        const autoClosingOpenCharEdits = (0, _cursorTypeEditOperationsJs.AutoClosingOpenCharTypeOperation).getEdits(config, model, selections, ch, false, isDoingComposition);
        if (autoClosingOpenCharEdits !== undefined) return autoClosingOpenCharEdits;
        const surroundSelectionEdits = (0, _cursorTypeEditOperationsJs.SurroundSelectionOperation).getEdits(config, model, selections, ch, isDoingComposition);
        if (surroundSelectionEdits !== undefined) return surroundSelectionEdits;
        const interceptorElectricCharOperation = (0, _cursorTypeEditOperationsJs.InterceptorElectricCharOperation).getEdits(prevEditOperationType, config, model, selections, ch, isDoingComposition);
        if (interceptorElectricCharOperation !== undefined) return interceptorElectricCharOperation;
        return (0, _cursorTypeEditOperationsJs.SimpleCharacterTypeOperation).getEdits(prevEditOperationType, selections, ch);
    }
    static typeWithoutInterceptors(prevEditOperationType, config, model, selections, str) {
        return (0, _cursorTypeEditOperationsJs.TypeWithoutInterceptorsOperation).getEdits(prevEditOperationType, selections, str);
    }
}
class CompositionOutcome {
    constructor(deletedText, deletedSelectionStart, deletedSelectionEnd, insertedText, insertedSelectionStart, insertedSelectionEnd){
        this.deletedText = deletedText;
        this.deletedSelectionStart = deletedSelectionStart;
        this.deletedSelectionEnd = deletedSelectionEnd;
        this.insertedText = insertedText;
        this.insertedSelectionStart = insertedSelectionStart;
        this.insertedSelectionEnd = insertedSelectionEnd;
    }
}

},{"../commands/shiftCommand.js":"3JtMW","../commands/surroundSelectionCommand.js":"5684n","../cursorCommon.js":"aKAuR","./cursorTypeEditOperations.js":"iMjJX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3JtMW":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShiftCommand", ()=>ShiftCommand);
var _stringsJs = require("../../../base/common/strings.js");
var _cursorColumnsJs = require("../core/cursorColumns.js");
var _rangeJs = require("../core/range.js");
var _selectionJs = require("../core/selection.js");
var _enterActionJs = require("../languages/enterAction.js");
var _languageConfigurationRegistryJs = require("../languages/languageConfigurationRegistry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var ShiftCommand_1;
const repeatCache = Object.create(null);
function cachedStringRepeat(str, count) {
    if (count <= 0) return "";
    if (!repeatCache[str]) repeatCache[str] = [
        "",
        str
    ];
    const cache = repeatCache[str];
    for(let i = cache.length; i <= count; i++)cache[i] = cache[i - 1] + str;
    return cache[count];
}
let ShiftCommand = ShiftCommand_1 = class ShiftCommand {
    static unshiftIndent(line, column, tabSize, indentSize, insertSpaces) {
        // Determine the visible column where the content starts
        const contentStartVisibleColumn = (0, _cursorColumnsJs.CursorColumns).visibleColumnFromColumn(line, column, tabSize);
        if (insertSpaces) {
            const indent = cachedStringRepeat(" ", indentSize);
            const desiredTabStop = (0, _cursorColumnsJs.CursorColumns).prevIndentTabStop(contentStartVisibleColumn, indentSize);
            const indentCount = desiredTabStop / indentSize; // will be an integer
            return cachedStringRepeat(indent, indentCount);
        } else {
            const indent = "	";
            const desiredTabStop = (0, _cursorColumnsJs.CursorColumns).prevRenderTabStop(contentStartVisibleColumn, tabSize);
            const indentCount = desiredTabStop / tabSize; // will be an integer
            return cachedStringRepeat(indent, indentCount);
        }
    }
    static shiftIndent(line, column, tabSize, indentSize, insertSpaces) {
        // Determine the visible column where the content starts
        const contentStartVisibleColumn = (0, _cursorColumnsJs.CursorColumns).visibleColumnFromColumn(line, column, tabSize);
        if (insertSpaces) {
            const indent = cachedStringRepeat(" ", indentSize);
            const desiredTabStop = (0, _cursorColumnsJs.CursorColumns).nextIndentTabStop(contentStartVisibleColumn, indentSize);
            const indentCount = desiredTabStop / indentSize; // will be an integer
            return cachedStringRepeat(indent, indentCount);
        } else {
            const indent = "	";
            const desiredTabStop = (0, _cursorColumnsJs.CursorColumns).nextRenderTabStop(contentStartVisibleColumn, tabSize);
            const indentCount = desiredTabStop / tabSize; // will be an integer
            return cachedStringRepeat(indent, indentCount);
        }
    }
    constructor(range, opts, _languageConfigurationService){
        this._languageConfigurationService = _languageConfigurationService;
        this._opts = opts;
        this._selection = range;
        this._selectionId = null;
        this._useLastEditRangeForCursorEndPosition = false;
        this._selectionStartColumnStaysPut = false;
    }
    _addEditOperation(builder, range, text) {
        if (this._useLastEditRangeForCursorEndPosition) builder.addTrackedEditOperation(range, text);
        else builder.addEditOperation(range, text);
    }
    getEditOperations(model, builder) {
        const startLine = this._selection.startLineNumber;
        let endLine = this._selection.endLineNumber;
        if (this._selection.endColumn === 1 && startLine !== endLine) endLine = endLine - 1;
        const { tabSize, indentSize, insertSpaces } = this._opts;
        const shouldIndentEmptyLines = startLine === endLine;
        if (this._opts.useTabStops) {
            // if indenting or outdenting on a whitespace only line
            if (this._selection.isEmpty()) {
                if (/^\s*$/.test(model.getLineContent(startLine))) this._useLastEditRangeForCursorEndPosition = true;
            }
            // keep track of previous line's "miss-alignment"
            let previousLineExtraSpaces = 0, extraSpaces = 0;
            for(let lineNumber = startLine; lineNumber <= endLine; lineNumber++, previousLineExtraSpaces = extraSpaces){
                extraSpaces = 0;
                const lineText = model.getLineContent(lineNumber);
                let indentationEndIndex = _stringsJs.firstNonWhitespaceIndex(lineText);
                if (this._opts.isUnshift && (lineText.length === 0 || indentationEndIndex === 0)) continue;
                if (!shouldIndentEmptyLines && !this._opts.isUnshift && lineText.length === 0) continue;
                if (indentationEndIndex === -1) // the entire line is whitespace
                indentationEndIndex = lineText.length;
                if (lineNumber > 1) {
                    const contentStartVisibleColumn = (0, _cursorColumnsJs.CursorColumns).visibleColumnFromColumn(lineText, indentationEndIndex + 1, tabSize);
                    if (contentStartVisibleColumn % indentSize !== 0) // The current line is "miss-aligned", so let's see if this is expected...
                    // This can only happen when it has trailing commas in the indent
                    {
                        if (model.tokenization.isCheapToTokenize(lineNumber - 1)) {
                            const enterAction = (0, _enterActionJs.getEnterAction)(this._opts.autoIndent, model, new (0, _rangeJs.Range)(lineNumber - 1, model.getLineMaxColumn(lineNumber - 1), lineNumber - 1, model.getLineMaxColumn(lineNumber - 1)), this._languageConfigurationService);
                            if (enterAction) {
                                extraSpaces = previousLineExtraSpaces;
                                if (enterAction.appendText) for(let j = 0, lenJ = enterAction.appendText.length; j < lenJ && extraSpaces < indentSize; j++){
                                    if (enterAction.appendText.charCodeAt(j) === 32 /* CharCode.Space */ ) extraSpaces++;
                                    else break;
                                }
                                if (enterAction.removeText) extraSpaces = Math.max(0, extraSpaces - enterAction.removeText);
                                // Act as if `prefixSpaces` is not part of the indentation
                                for(let j = 0; j < extraSpaces; j++){
                                    if (indentationEndIndex === 0 || lineText.charCodeAt(indentationEndIndex - 1) !== 32 /* CharCode.Space */ ) break;
                                    indentationEndIndex--;
                                }
                            }
                        }
                    }
                }
                if (this._opts.isUnshift && indentationEndIndex === 0) continue;
                let desiredIndent;
                if (this._opts.isUnshift) desiredIndent = ShiftCommand_1.unshiftIndent(lineText, indentationEndIndex + 1, tabSize, indentSize, insertSpaces);
                else desiredIndent = ShiftCommand_1.shiftIndent(lineText, indentationEndIndex + 1, tabSize, indentSize, insertSpaces);
                this._addEditOperation(builder, new (0, _rangeJs.Range)(lineNumber, 1, lineNumber, indentationEndIndex + 1), desiredIndent);
                if (lineNumber === startLine && !this._selection.isEmpty()) // Force the startColumn to stay put because we're inserting after it
                this._selectionStartColumnStaysPut = this._selection.startColumn <= indentationEndIndex + 1;
            }
        } else {
            // if indenting or outdenting on a whitespace only line
            if (!this._opts.isUnshift && this._selection.isEmpty() && model.getLineLength(startLine) === 0) this._useLastEditRangeForCursorEndPosition = true;
            const oneIndent = insertSpaces ? cachedStringRepeat(" ", indentSize) : "	";
            for(let lineNumber = startLine; lineNumber <= endLine; lineNumber++){
                const lineText = model.getLineContent(lineNumber);
                let indentationEndIndex = _stringsJs.firstNonWhitespaceIndex(lineText);
                if (this._opts.isUnshift && (lineText.length === 0 || indentationEndIndex === 0)) continue;
                if (!shouldIndentEmptyLines && !this._opts.isUnshift && lineText.length === 0) continue;
                if (indentationEndIndex === -1) // the entire line is whitespace
                indentationEndIndex = lineText.length;
                if (this._opts.isUnshift && indentationEndIndex === 0) continue;
                if (this._opts.isUnshift) {
                    indentationEndIndex = Math.min(indentationEndIndex, indentSize);
                    for(let i = 0; i < indentationEndIndex; i++){
                        const chr = lineText.charCodeAt(i);
                        if (chr === 9 /* CharCode.Tab */ ) {
                            indentationEndIndex = i + 1;
                            break;
                        }
                    }
                    this._addEditOperation(builder, new (0, _rangeJs.Range)(lineNumber, 1, lineNumber, indentationEndIndex + 1), "");
                } else {
                    this._addEditOperation(builder, new (0, _rangeJs.Range)(lineNumber, 1, lineNumber, 1), oneIndent);
                    if (lineNumber === startLine && !this._selection.isEmpty()) // Force the startColumn to stay put because we're inserting after it
                    this._selectionStartColumnStaysPut = this._selection.startColumn === 1;
                }
            }
        }
        this._selectionId = builder.trackSelection(this._selection);
    }
    computeCursorState(model, helper) {
        if (this._useLastEditRangeForCursorEndPosition) {
            const lastOp = helper.getInverseEditOperations()[0];
            return new (0, _selectionJs.Selection)(lastOp.range.endLineNumber, lastOp.range.endColumn, lastOp.range.endLineNumber, lastOp.range.endColumn);
        }
        const result = helper.getTrackedSelection(this._selectionId);
        if (this._selectionStartColumnStaysPut) {
            // The selection start should not move
            const initialStartColumn = this._selection.startColumn;
            const resultStartColumn = result.startColumn;
            if (resultStartColumn <= initialStartColumn) return result;
            if (result.getDirection() === 0 /* SelectionDirection.LTR */ ) return new (0, _selectionJs.Selection)(result.startLineNumber, initialStartColumn, result.endLineNumber, result.endColumn);
            return new (0, _selectionJs.Selection)(result.endLineNumber, result.endColumn, result.startLineNumber, initialStartColumn);
        }
        return result;
    }
};
ShiftCommand = ShiftCommand_1 = __decorate([
    __param(2, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService))
], ShiftCommand);

},{"../../../base/common/strings.js":"aA9I1","../core/cursorColumns.js":"idX7D","../core/range.js":"jmUPh","../core/selection.js":"kcwzU","../languages/enterAction.js":"0RBgX","../languages/languageConfigurationRegistry.js":"2Lk9v","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0RBgX":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEnterAction", ()=>getEnterAction);
var _languageConfigurationJs = require("./languageConfiguration.js");
var _languageConfigurationRegistryJs = require("./languageConfigurationRegistry.js");
var _indentationLineProcessorJs = require("./supports/indentationLineProcessor.js");
function getEnterAction(autoIndent, model, range, languageConfigurationService) {
    model.tokenization.forceTokenization(range.startLineNumber);
    const languageId = model.getLanguageIdAtPosition(range.startLineNumber, range.startColumn);
    const richEditSupport = languageConfigurationService.getLanguageConfiguration(languageId);
    if (!richEditSupport) return null;
    const indentationContextProcessor = new (0, _indentationLineProcessorJs.IndentationContextProcessor)(model, languageConfigurationService);
    const processedContextTokens = indentationContextProcessor.getProcessedTokenContextAroundRange(range);
    const previousLineText = processedContextTokens.previousLineProcessedTokens.getLineContent();
    const beforeEnterText = processedContextTokens.beforeRangeProcessedTokens.getLineContent();
    const afterEnterText = processedContextTokens.afterRangeProcessedTokens.getLineContent();
    const enterResult = richEditSupport.onEnter(autoIndent, previousLineText, beforeEnterText, afterEnterText);
    if (!enterResult) return null;
    const indentAction = enterResult.indentAction;
    let appendText = enterResult.appendText;
    const removeText = enterResult.removeText || 0;
    // Here we add `\t` to appendText first because enterAction is leveraging appendText and removeText to change indentation.
    if (!appendText) {
        if (indentAction === (0, _languageConfigurationJs.IndentAction).Indent || indentAction === (0, _languageConfigurationJs.IndentAction).IndentOutdent) appendText = "	";
        else appendText = "";
    } else if (indentAction === (0, _languageConfigurationJs.IndentAction).Indent) appendText = "	" + appendText;
    let indentation = (0, _languageConfigurationRegistryJs.getIndentationAtPosition)(model, range.startLineNumber, range.startColumn);
    if (removeText) indentation = indentation.substring(0, indentation.length - removeText);
    return {
        indentAction: indentAction,
        appendText: appendText,
        removeText: removeText,
        indentation: indentation
    };
}

},{"./languageConfiguration.js":"1ojaS","./languageConfigurationRegistry.js":"2Lk9v","./supports/indentationLineProcessor.js":"44GwO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"44GwO":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This class is a wrapper class around {@link IndentRulesSupport}.
 * It processes the lines by removing the language configuration brackets from the regex, string and comment tokens.
 * It then calls into the {@link IndentRulesSupport} to validate the indentation conditions.
 */ parcelHelpers.export(exports, "ProcessedIndentRulesSupport", ()=>ProcessedIndentRulesSupport);
/**
 * This class fetches the processed text around a range which can be used for indentation evaluation.
 * It returns:
 * - The processed text before the given range and on the same start line
 * - The processed text after the given range and on the same end line
 * - The processed text on the previous line
 */ parcelHelpers.export(exports, "IndentationContextProcessor", ()=>IndentationContextProcessor);
parcelHelpers.export(exports, "isLanguageDifferentFromLineStart", ()=>isLanguageDifferentFromLineStart);
var _stringsJs = require("../../../../base/common/strings.js");
var _supportsJs = require("../supports.js");
var _lineTokensJs = require("../../tokens/lineTokens.js");
class ProcessedIndentRulesSupport {
    constructor(model, indentRulesSupport, languageConfigurationService){
        this._indentRulesSupport = indentRulesSupport;
        this._indentationLineProcessor = new IndentationLineProcessor(model, languageConfigurationService);
    }
    /**
     * Apply the new indentation and return whether the indentation level should be increased after the given line number
     */ shouldIncrease(lineNumber, newIndentation) {
        const processedLine = this._indentationLineProcessor.getProcessedLine(lineNumber, newIndentation);
        return this._indentRulesSupport.shouldIncrease(processedLine);
    }
    /**
     * Apply the new indentation and return whether the indentation level should be decreased after the given line number
     */ shouldDecrease(lineNumber, newIndentation) {
        const processedLine = this._indentationLineProcessor.getProcessedLine(lineNumber, newIndentation);
        return this._indentRulesSupport.shouldDecrease(processedLine);
    }
    /**
     * Apply the new indentation and return whether the indentation level should remain unchanged at the given line number
     */ shouldIgnore(lineNumber, newIndentation) {
        const processedLine = this._indentationLineProcessor.getProcessedLine(lineNumber, newIndentation);
        return this._indentRulesSupport.shouldIgnore(processedLine);
    }
    /**
     * Apply the new indentation and return whether the indentation level should increase on the line after the given line number
     */ shouldIndentNextLine(lineNumber, newIndentation) {
        const processedLine = this._indentationLineProcessor.getProcessedLine(lineNumber, newIndentation);
        return this._indentRulesSupport.shouldIndentNextLine(processedLine);
    }
}
class IndentationContextProcessor {
    constructor(model, languageConfigurationService){
        this.model = model;
        this.indentationLineProcessor = new IndentationLineProcessor(model, languageConfigurationService);
    }
    /**
     * Returns the processed text, stripped from the language configuration brackets within the string, comment and regex tokens, around the given range
     */ getProcessedTokenContextAroundRange(range) {
        const beforeRangeProcessedTokens = this._getProcessedTokensBeforeRange(range);
        const afterRangeProcessedTokens = this._getProcessedTokensAfterRange(range);
        const previousLineProcessedTokens = this._getProcessedPreviousLineTokens(range);
        return {
            beforeRangeProcessedTokens,
            afterRangeProcessedTokens,
            previousLineProcessedTokens
        };
    }
    _getProcessedTokensBeforeRange(range) {
        this.model.tokenization.forceTokenization(range.startLineNumber);
        const lineTokens = this.model.tokenization.getLineTokens(range.startLineNumber);
        const scopedLineTokens = (0, _supportsJs.createScopedLineTokens)(lineTokens, range.startColumn - 1);
        let slicedTokens;
        if (isLanguageDifferentFromLineStart(this.model, range.getStartPosition())) {
            const columnIndexWithinScope = range.startColumn - 1 - scopedLineTokens.firstCharOffset;
            const firstCharacterOffset = scopedLineTokens.firstCharOffset;
            const lastCharacterOffset = firstCharacterOffset + columnIndexWithinScope;
            slicedTokens = lineTokens.sliceAndInflate(firstCharacterOffset, lastCharacterOffset, 0);
        } else {
            const columnWithinLine = range.startColumn - 1;
            slicedTokens = lineTokens.sliceAndInflate(0, columnWithinLine, 0);
        }
        const processedTokens = this.indentationLineProcessor.getProcessedTokens(slicedTokens);
        return processedTokens;
    }
    _getProcessedTokensAfterRange(range) {
        const position = range.isEmpty() ? range.getStartPosition() : range.getEndPosition();
        this.model.tokenization.forceTokenization(position.lineNumber);
        const lineTokens = this.model.tokenization.getLineTokens(position.lineNumber);
        const scopedLineTokens = (0, _supportsJs.createScopedLineTokens)(lineTokens, position.column - 1);
        const columnIndexWithinScope = position.column - 1 - scopedLineTokens.firstCharOffset;
        const firstCharacterOffset = scopedLineTokens.firstCharOffset + columnIndexWithinScope;
        const lastCharacterOffset = scopedLineTokens.firstCharOffset + scopedLineTokens.getLineLength();
        const slicedTokens = lineTokens.sliceAndInflate(firstCharacterOffset, lastCharacterOffset, 0);
        const processedTokens = this.indentationLineProcessor.getProcessedTokens(slicedTokens);
        return processedTokens;
    }
    _getProcessedPreviousLineTokens(range) {
        const getScopedLineTokensAtEndColumnOfLine = (lineNumber)=>{
            this.model.tokenization.forceTokenization(lineNumber);
            const lineTokens = this.model.tokenization.getLineTokens(lineNumber);
            const endColumnOfLine = this.model.getLineMaxColumn(lineNumber) - 1;
            const scopedLineTokensAtEndColumn = (0, _supportsJs.createScopedLineTokens)(lineTokens, endColumnOfLine);
            return scopedLineTokensAtEndColumn;
        };
        this.model.tokenization.forceTokenization(range.startLineNumber);
        const lineTokens = this.model.tokenization.getLineTokens(range.startLineNumber);
        const scopedLineTokens = (0, _supportsJs.createScopedLineTokens)(lineTokens, range.startColumn - 1);
        const emptyTokens = (0, _lineTokensJs.LineTokens).createEmpty("", scopedLineTokens.languageIdCodec);
        const previousLineNumber = range.startLineNumber - 1;
        const isFirstLine = previousLineNumber === 0;
        if (isFirstLine) return emptyTokens;
        const canScopeExtendOnPreviousLine = scopedLineTokens.firstCharOffset === 0;
        if (!canScopeExtendOnPreviousLine) return emptyTokens;
        const scopedLineTokensAtEndColumnOfPreviousLine = getScopedLineTokensAtEndColumnOfLine(previousLineNumber);
        const doesLanguageContinueOnPreviousLine = scopedLineTokens.languageId === scopedLineTokensAtEndColumnOfPreviousLine.languageId;
        if (!doesLanguageContinueOnPreviousLine) return emptyTokens;
        const previousSlicedLineTokens = scopedLineTokensAtEndColumnOfPreviousLine.toIViewLineTokens();
        const processedTokens = this.indentationLineProcessor.getProcessedTokens(previousSlicedLineTokens);
        return processedTokens;
    }
}
/**
 * This class performs the actual processing of the indentation lines.
 * The brackets of the language configuration are removed from the regex, string and comment tokens.
 */ class IndentationLineProcessor {
    constructor(model, languageConfigurationService){
        this.model = model;
        this.languageConfigurationService = languageConfigurationService;
    }
    /**
     * Get the processed line for the given line number and potentially adjust the indentation level.
     * Remove the language configuration brackets from the regex, string and comment tokens.
     */ getProcessedLine(lineNumber, newIndentation) {
        const replaceIndentation = (line, newIndentation)=>{
            const currentIndentation = _stringsJs.getLeadingWhitespace(line);
            const adjustedLine = newIndentation + line.substring(currentIndentation.length);
            return adjustedLine;
        };
        this.model.tokenization.forceTokenization?.(lineNumber);
        const tokens = this.model.tokenization.getLineTokens(lineNumber);
        let processedLine = this.getProcessedTokens(tokens).getLineContent();
        if (newIndentation !== undefined) processedLine = replaceIndentation(processedLine, newIndentation);
        return processedLine;
    }
    /**
     * Process the line with the given tokens, remove the language configuration brackets from the regex, string and comment tokens.
     */ getProcessedTokens(tokens) {
        const shouldRemoveBracketsFromTokenType = (tokenType)=>{
            return tokenType === 2 /* StandardTokenType.String */  || tokenType === 3 /* StandardTokenType.RegEx */  || tokenType === 1 /* StandardTokenType.Comment */ ;
        };
        const languageId = tokens.getLanguageId(0);
        const bracketsConfiguration = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew;
        const bracketsRegExp = bracketsConfiguration.getBracketRegExp({
            global: true
        });
        const textAndMetadata = [];
        tokens.forEach((tokenIndex)=>{
            const tokenType = tokens.getStandardTokenType(tokenIndex);
            let text = tokens.getTokenText(tokenIndex);
            if (shouldRemoveBracketsFromTokenType(tokenType)) text = text.replace(bracketsRegExp, "");
            const metadata = tokens.getMetadata(tokenIndex);
            textAndMetadata.push({
                text,
                metadata
            });
        });
        const processedLineTokens = (0, _lineTokensJs.LineTokens).createFromTextAndMetadata(textAndMetadata, tokens.languageIdCodec);
        return processedLineTokens;
    }
}
function isLanguageDifferentFromLineStart(model, position) {
    model.tokenization.forceTokenization(position.lineNumber);
    const lineTokens = model.tokenization.getLineTokens(position.lineNumber);
    const scopedLineTokens = (0, _supportsJs.createScopedLineTokens)(lineTokens, position.column - 1);
    const doesScopeStartAtOffsetZero = scopedLineTokens.firstCharOffset === 0;
    const isScopedLanguageEqualToFirstLanguageOnLine = lineTokens.getLanguageId(0) === scopedLineTokens.languageId;
    const languageIsDifferentFromLineStart = !doesScopeStartAtOffsetZero && !isScopedLanguageEqualToFirstLanguageOnLine;
    return languageIsDifferentFromLineStart;
}

},{"../../../../base/common/strings.js":"aA9I1","../supports.js":"aA5lJ","../../tokens/lineTokens.js":"6iUVx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5684n":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SurroundSelectionCommand", ()=>SurroundSelectionCommand);
/**
 * A surround selection command that runs after composition finished.
 */ parcelHelpers.export(exports, "CompositionSurroundSelectionCommand", ()=>CompositionSurroundSelectionCommand);
var _rangeJs = require("../core/range.js");
var _selectionJs = require("../core/selection.js");
class SurroundSelectionCommand {
    constructor(range, charBeforeSelection, charAfterSelection){
        this._range = range;
        this._charBeforeSelection = charBeforeSelection;
        this._charAfterSelection = charAfterSelection;
    }
    getEditOperations(model, builder) {
        builder.addTrackedEditOperation(new (0, _rangeJs.Range)(this._range.startLineNumber, this._range.startColumn, this._range.startLineNumber, this._range.startColumn), this._charBeforeSelection);
        builder.addTrackedEditOperation(new (0, _rangeJs.Range)(this._range.endLineNumber, this._range.endColumn, this._range.endLineNumber, this._range.endColumn), this._charAfterSelection);
    }
    computeCursorState(model, helper) {
        const inverseEditOperations = helper.getInverseEditOperations();
        const firstOperationRange = inverseEditOperations[0].range;
        const secondOperationRange = inverseEditOperations[1].range;
        return new (0, _selectionJs.Selection)(firstOperationRange.endLineNumber, firstOperationRange.endColumn, secondOperationRange.endLineNumber, secondOperationRange.endColumn - this._charAfterSelection.length);
    }
}
class CompositionSurroundSelectionCommand {
    constructor(_position, _text, _charAfter){
        this._position = _position;
        this._text = _text;
        this._charAfter = _charAfter;
    }
    getEditOperations(model, builder) {
        builder.addTrackedEditOperation(new (0, _rangeJs.Range)(this._position.lineNumber, this._position.column, this._position.lineNumber, this._position.column), this._text + this._charAfter);
    }
    computeCursorState(model, helper) {
        const inverseEditOperations = helper.getInverseEditOperations();
        const opRange = inverseEditOperations[0].range;
        return new (0, _selectionJs.Selection)(opRange.endLineNumber, opRange.startColumn, opRange.endLineNumber, opRange.endColumn - this._charAfter.length);
    }
}

},{"../core/range.js":"jmUPh","../core/selection.js":"kcwzU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iMjJX":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutoIndentOperation", ()=>AutoIndentOperation);
parcelHelpers.export(exports, "AutoClosingOvertypeOperation", ()=>AutoClosingOvertypeOperation);
parcelHelpers.export(exports, "AutoClosingOvertypeWithInterceptorsOperation", ()=>AutoClosingOvertypeWithInterceptorsOperation);
parcelHelpers.export(exports, "AutoClosingOpenCharTypeOperation", ()=>AutoClosingOpenCharTypeOperation);
parcelHelpers.export(exports, "SurroundSelectionOperation", ()=>SurroundSelectionOperation);
parcelHelpers.export(exports, "InterceptorElectricCharOperation", ()=>InterceptorElectricCharOperation);
parcelHelpers.export(exports, "SimpleCharacterTypeOperation", ()=>SimpleCharacterTypeOperation);
parcelHelpers.export(exports, "EnterOperation", ()=>EnterOperation);
parcelHelpers.export(exports, "PasteOperation", ()=>PasteOperation);
parcelHelpers.export(exports, "CompositionOperation", ()=>CompositionOperation);
parcelHelpers.export(exports, "TypeWithoutInterceptorsOperation", ()=>TypeWithoutInterceptorsOperation);
parcelHelpers.export(exports, "TabOperation", ()=>TabOperation);
parcelHelpers.export(exports, "BaseTypeWithAutoClosingCommand", ()=>BaseTypeWithAutoClosingCommand);
parcelHelpers.export(exports, "shiftIndent", ()=>shiftIndent);
parcelHelpers.export(exports, "unshiftIndent", ()=>unshiftIndent);
parcelHelpers.export(exports, "shouldSurroundChar", ()=>shouldSurroundChar);
var _errorsJs = require("../../../base/common/errors.js");
var _stringsJs = require("../../../base/common/strings.js");
var _replaceCommandJs = require("../commands/replaceCommand.js");
var _shiftCommandJs = require("../commands/shiftCommand.js");
var _surroundSelectionCommandJs = require("../commands/surroundSelectionCommand.js");
var _cursorCommonJs = require("../cursorCommon.js");
var _wordCharacterClassifierJs = require("../core/wordCharacterClassifier.js");
var _rangeJs = require("../core/range.js");
var _positionJs = require("../core/position.js");
var _languageConfigurationJs = require("../languages/languageConfiguration.js");
var _languageConfigurationRegistryJs = require("../languages/languageConfigurationRegistry.js");
var _supportsJs = require("../languages/supports.js");
var _autoIndentJs = require("../languages/autoIndent.js");
var _enterActionJs = require("../languages/enterAction.js");
class AutoIndentOperation {
    static getEdits(config, model, selections, ch, isDoingComposition) {
        if (!isDoingComposition && this._isAutoIndentType(config, model, selections)) {
            const indentationForSelections = [];
            for (const selection of selections){
                const indentation = this._findActualIndentationForSelection(config, model, selection, ch);
                if (indentation === null) // Auto indentation failed
                return;
                indentationForSelections.push({
                    selection,
                    indentation
                });
            }
            const autoClosingPairClose = AutoClosingOpenCharTypeOperation.getAutoClosingPairClose(config, model, selections, ch, false);
            return this._getIndentationAndAutoClosingPairEdits(config, model, indentationForSelections, ch, autoClosingPairClose);
        }
        return;
    }
    static _isAutoIndentType(config, model, selections) {
        if (config.autoIndent < 4 /* EditorAutoIndentStrategy.Full */ ) return false;
        for(let i = 0, len = selections.length; i < len; i++){
            if (!model.tokenization.isCheapToTokenize(selections[i].getEndPosition().lineNumber)) return false;
        }
        return true;
    }
    static _findActualIndentationForSelection(config, model, selection, ch) {
        const actualIndentation = (0, _autoIndentJs.getIndentActionForType)(config, model, selection, ch, {
            shiftIndent: (indentation)=>{
                return shiftIndent(config, indentation);
            },
            unshiftIndent: (indentation)=>{
                return unshiftIndent(config, indentation);
            }
        }, config.languageConfigurationService);
        if (actualIndentation === null) return null;
        const currentIndentation = (0, _languageConfigurationRegistryJs.getIndentationAtPosition)(model, selection.startLineNumber, selection.startColumn);
        if (actualIndentation === config.normalizeIndentation(currentIndentation)) return null;
        return actualIndentation;
    }
    static _getIndentationAndAutoClosingPairEdits(config, model, indentationForSelections, ch, autoClosingPairClose) {
        const commands = indentationForSelections.map(({ selection, indentation })=>{
            if (autoClosingPairClose !== null) {
                // Apply both auto closing pair edits and auto indentation edits
                const indentationEdit = this._getEditFromIndentationAndSelection(config, model, indentation, selection, ch, false);
                return new TypeWithIndentationAndAutoClosingCommand(indentationEdit, selection, ch, autoClosingPairClose);
            } else {
                // Apply only auto indentation edits
                const indentationEdit = this._getEditFromIndentationAndSelection(config, model, indentation, selection, ch, true);
                return typeCommand(indentationEdit.range, indentationEdit.text, false);
            }
        });
        const editOptions = {
            shouldPushStackElementBefore: true,
            shouldPushStackElementAfter: false
        };
        return new (0, _cursorCommonJs.EditOperationResult)(4 /* EditOperationType.TypingOther */ , commands, editOptions);
    }
    static _getEditFromIndentationAndSelection(config, model, indentation, selection, ch, includeChInEdit = true) {
        const startLineNumber = selection.startLineNumber;
        const firstNonWhitespaceColumn = model.getLineFirstNonWhitespaceColumn(startLineNumber);
        let text = config.normalizeIndentation(indentation);
        if (firstNonWhitespaceColumn !== 0) {
            const startLine = model.getLineContent(startLineNumber);
            text += startLine.substring(firstNonWhitespaceColumn - 1, selection.startColumn - 1);
        }
        text += includeChInEdit ? ch : "";
        const range = new (0, _rangeJs.Range)(startLineNumber, 1, selection.endLineNumber, selection.endColumn);
        return {
            range,
            text
        };
    }
}
class AutoClosingOvertypeOperation {
    static getEdits(prevEditOperationType, config, model, selections, autoClosedCharacters, ch) {
        if (isAutoClosingOvertype(config, model, selections, autoClosedCharacters, ch)) return this._runAutoClosingOvertype(prevEditOperationType, selections, ch);
        return;
    }
    static _runAutoClosingOvertype(prevEditOperationType, selections, ch) {
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++){
            const selection = selections[i];
            const position = selection.getPosition();
            const typeSelection = new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column + 1);
            commands[i] = new (0, _replaceCommandJs.ReplaceCommand)(typeSelection, ch);
        }
        return new (0, _cursorCommonJs.EditOperationResult)(4 /* EditOperationType.TypingOther */ , commands, {
            shouldPushStackElementBefore: shouldPushStackElementBetween(prevEditOperationType, 4 /* EditOperationType.TypingOther */ ),
            shouldPushStackElementAfter: false
        });
    }
}
class AutoClosingOvertypeWithInterceptorsOperation {
    static getEdits(config, model, selections, autoClosedCharacters, ch) {
        if (isAutoClosingOvertype(config, model, selections, autoClosedCharacters, ch)) {
            // Unfortunately, the close character is at this point "doubled", so we need to delete it...
            const commands = selections.map((s)=>new (0, _replaceCommandJs.ReplaceCommand)(new (0, _rangeJs.Range)(s.positionLineNumber, s.positionColumn, s.positionLineNumber, s.positionColumn + 1), "", false));
            return new (0, _cursorCommonJs.EditOperationResult)(4 /* EditOperationType.TypingOther */ , commands, {
                shouldPushStackElementBefore: true,
                shouldPushStackElementAfter: false
            });
        }
        return;
    }
}
class AutoClosingOpenCharTypeOperation {
    static getEdits(config, model, selections, ch, chIsAlreadyTyped, isDoingComposition) {
        if (!isDoingComposition) {
            const autoClosingPairClose = this.getAutoClosingPairClose(config, model, selections, ch, chIsAlreadyTyped);
            if (autoClosingPairClose !== null) return this._runAutoClosingOpenCharType(selections, ch, chIsAlreadyTyped, autoClosingPairClose);
        }
        return;
    }
    static _runAutoClosingOpenCharType(selections, ch, chIsAlreadyTyped, autoClosingPairClose) {
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++){
            const selection = selections[i];
            commands[i] = new TypeWithAutoClosingCommand(selection, ch, !chIsAlreadyTyped, autoClosingPairClose);
        }
        return new (0, _cursorCommonJs.EditOperationResult)(4 /* EditOperationType.TypingOther */ , commands, {
            shouldPushStackElementBefore: true,
            shouldPushStackElementAfter: false
        });
    }
    static getAutoClosingPairClose(config, model, selections, ch, chIsAlreadyTyped) {
        for (const selection of selections){
            if (!selection.isEmpty()) return null;
        }
        // This method is called both when typing (regularly) and when composition ends
        // This means that we need to work with a text buffer where sometimes `ch` is not
        // there (it is being typed right now) or with a text buffer where `ch` has already been typed
        //
        // In order to avoid adding checks for `chIsAlreadyTyped` in all places, we will work
        // with two conceptual positions, the position before `ch` and the position after `ch`
        //
        const positions = selections.map((s)=>{
            const position = s.getPosition();
            if (chIsAlreadyTyped) return {
                lineNumber: position.lineNumber,
                beforeColumn: position.column - ch.length,
                afterColumn: position.column
            };
            else return {
                lineNumber: position.lineNumber,
                beforeColumn: position.column,
                afterColumn: position.column
            };
        });
        // Find the longest auto-closing open pair in case of multiple ending in `ch`
        // e.g. when having [f","] and [","], it picks [f","] if the character before is f
        const pair = this._findAutoClosingPairOpen(config, model, positions.map((p)=>new (0, _positionJs.Position)(p.lineNumber, p.beforeColumn)), ch);
        if (!pair) return null;
        let autoCloseConfig;
        let shouldAutoCloseBefore;
        const chIsQuote = (0, _cursorCommonJs.isQuote)(ch);
        if (chIsQuote) {
            autoCloseConfig = config.autoClosingQuotes;
            shouldAutoCloseBefore = config.shouldAutoCloseBefore.quote;
        } else {
            const pairIsForComments = config.blockCommentStartToken ? pair.open.includes(config.blockCommentStartToken) : false;
            if (pairIsForComments) {
                autoCloseConfig = config.autoClosingComments;
                shouldAutoCloseBefore = config.shouldAutoCloseBefore.comment;
            } else {
                autoCloseConfig = config.autoClosingBrackets;
                shouldAutoCloseBefore = config.shouldAutoCloseBefore.bracket;
            }
        }
        if (autoCloseConfig === "never") return null;
        // Sometimes, it is possible to have two auto-closing pairs that have a containment relationship
        // e.g. when having [(,)] and [(*,*)]
        // - when typing (, the resulting state is (|)
        // - when typing *, the desired resulting state is (*|*), not (*|*))
        const containedPair = this._findContainedAutoClosingPair(config, pair);
        const containedPairClose = containedPair ? containedPair.close : "";
        let isContainedPairPresent = true;
        for (const position of positions){
            const { lineNumber, beforeColumn, afterColumn } = position;
            const lineText = model.getLineContent(lineNumber);
            const lineBefore = lineText.substring(0, beforeColumn - 1);
            const lineAfter = lineText.substring(afterColumn - 1);
            if (!lineAfter.startsWith(containedPairClose)) isContainedPairPresent = false;
            // Only consider auto closing the pair if an allowed character follows or if another autoclosed pair closing brace follows
            if (lineAfter.length > 0) {
                const characterAfter = lineAfter.charAt(0);
                const isBeforeCloseBrace = this._isBeforeClosingBrace(config, lineAfter);
                if (!isBeforeCloseBrace && !shouldAutoCloseBefore(characterAfter)) return null;
            }
            // Do not auto-close ' or " after a word character
            if (pair.open.length === 1 && (ch === "'" || ch === '"') && autoCloseConfig !== "always") {
                const wordSeparators = (0, _wordCharacterClassifierJs.getMapForWordSeparators)(config.wordSeparators, []);
                if (lineBefore.length > 0) {
                    const characterBefore = lineBefore.charCodeAt(lineBefore.length - 1);
                    if (wordSeparators.get(characterBefore) === 0 /* WordCharacterClass.Regular */ ) return null;
                }
            }
            if (!model.tokenization.isCheapToTokenize(lineNumber)) // Do not force tokenization
            return null;
            model.tokenization.forceTokenization(lineNumber);
            const lineTokens = model.tokenization.getLineTokens(lineNumber);
            const scopedLineTokens = (0, _supportsJs.createScopedLineTokens)(lineTokens, beforeColumn - 1);
            if (!pair.shouldAutoClose(scopedLineTokens, beforeColumn - scopedLineTokens.firstCharOffset)) return null;
            // Typing for example a quote could either start a new string, in which case auto-closing is desirable
            // or it could end a previously started string, in which case auto-closing is not desirable
            //
            // In certain cases, it is really not possible to look at the previous token to determine
            // what would happen. That's why we do something really unusual, we pretend to type a different
            // character and ask the tokenizer what the outcome of doing that is: after typing a neutral
            // character, are we in a string (i.e. the quote would most likely end a string) or not?
            //
            const neutralCharacter = pair.findNeutralCharacter();
            if (neutralCharacter) {
                const tokenType = model.tokenization.getTokenTypeIfInsertingCharacter(lineNumber, beforeColumn, neutralCharacter);
                if (!pair.isOK(tokenType)) return null;
            }
        }
        if (isContainedPairPresent) return pair.close.substring(0, pair.close.length - containedPairClose.length);
        else return pair.close;
    }
    /**
     * Find another auto-closing pair that is contained by the one passed in.
     *
     * e.g. when having [(,)] and [(*,*)] as auto-closing pairs
     * this method will find [(,)] as a containment pair for [(*,*)]
     */ static _findContainedAutoClosingPair(config, pair) {
        if (pair.open.length <= 1) return null;
        const lastChar = pair.close.charAt(pair.close.length - 1);
        // get candidates with the same last character as close
        const candidates = config.autoClosingPairs.autoClosingPairsCloseByEnd.get(lastChar) || [];
        let result = null;
        for (const candidate of candidates){
            if (candidate.open !== pair.open && pair.open.includes(candidate.open) && pair.close.endsWith(candidate.close)) {
                if (!result || candidate.open.length > result.open.length) result = candidate;
            }
        }
        return result;
    }
    /**
     * Determine if typing `ch` at all `positions` in the `model` results in an
     * auto closing open sequence being typed.
     *
     * Auto closing open sequences can consist of multiple characters, which
     * can lead to ambiguities. In such a case, the longest auto-closing open
     * sequence is returned.
     */ static _findAutoClosingPairOpen(config, model, positions, ch) {
        const candidates = config.autoClosingPairs.autoClosingPairsOpenByEnd.get(ch);
        if (!candidates) return null;
        // Determine which auto-closing pair it is
        let result = null;
        for (const candidate of candidates)if (result === null || candidate.open.length > result.open.length) {
            let candidateIsMatch = true;
            for (const position of positions){
                const relevantText = model.getValueInRange(new (0, _rangeJs.Range)(position.lineNumber, position.column - candidate.open.length + 1, position.lineNumber, position.column));
                if (relevantText + ch !== candidate.open) {
                    candidateIsMatch = false;
                    break;
                }
            }
            if (candidateIsMatch) result = candidate;
        }
        return result;
    }
    static _isBeforeClosingBrace(config, lineAfter) {
        // If the start of lineAfter can be interpretted as both a starting or ending brace, default to returning false
        const nextChar = lineAfter.charAt(0);
        const potentialStartingBraces = config.autoClosingPairs.autoClosingPairsOpenByStart.get(nextChar) || [];
        const potentialClosingBraces = config.autoClosingPairs.autoClosingPairsCloseByStart.get(nextChar) || [];
        const isBeforeStartingBrace = potentialStartingBraces.some((x)=>lineAfter.startsWith(x.open));
        const isBeforeClosingBrace = potentialClosingBraces.some((x)=>lineAfter.startsWith(x.close));
        return !isBeforeStartingBrace && isBeforeClosingBrace;
    }
}
class SurroundSelectionOperation {
    static getEdits(config, model, selections, ch, isDoingComposition) {
        if (!isDoingComposition && this._isSurroundSelectionType(config, model, selections, ch)) return this._runSurroundSelectionType(config, selections, ch);
        return;
    }
    static _runSurroundSelectionType(config, selections, ch) {
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++){
            const selection = selections[i];
            const closeCharacter = config.surroundingPairs[ch];
            commands[i] = new (0, _surroundSelectionCommandJs.SurroundSelectionCommand)(selection, ch, closeCharacter);
        }
        return new (0, _cursorCommonJs.EditOperationResult)(0 /* EditOperationType.Other */ , commands, {
            shouldPushStackElementBefore: true,
            shouldPushStackElementAfter: true
        });
    }
    static _isSurroundSelectionType(config, model, selections, ch) {
        if (!shouldSurroundChar(config, ch) || !config.surroundingPairs.hasOwnProperty(ch)) return false;
        const isTypingAQuoteCharacter = (0, _cursorCommonJs.isQuote)(ch);
        for (const selection of selections){
            if (selection.isEmpty()) return false;
            let selectionContainsOnlyWhitespace = true;
            for(let lineNumber = selection.startLineNumber; lineNumber <= selection.endLineNumber; lineNumber++){
                const lineText = model.getLineContent(lineNumber);
                const startIndex = lineNumber === selection.startLineNumber ? selection.startColumn - 1 : 0;
                const endIndex = lineNumber === selection.endLineNumber ? selection.endColumn - 1 : lineText.length;
                const selectedText = lineText.substring(startIndex, endIndex);
                if (/[^ \t]/.test(selectedText)) {
                    // this selected text contains something other than whitespace
                    selectionContainsOnlyWhitespace = false;
                    break;
                }
            }
            if (selectionContainsOnlyWhitespace) return false;
            if (isTypingAQuoteCharacter && selection.startLineNumber === selection.endLineNumber && selection.startColumn + 1 === selection.endColumn) {
                const selectionText = model.getValueInRange(selection);
                if ((0, _cursorCommonJs.isQuote)(selectionText)) // Typing a quote character on top of another quote character
                // => disable surround selection type
                return false;
            }
        }
        return true;
    }
}
class InterceptorElectricCharOperation {
    static getEdits(prevEditOperationType, config, model, selections, ch, isDoingComposition) {
        // Electric characters make sense only when dealing with a single cursor,
        // as multiple cursors typing brackets for example would interfer with bracket matching
        if (!isDoingComposition && this._isTypeInterceptorElectricChar(config, model, selections)) {
            const r = this._typeInterceptorElectricChar(prevEditOperationType, config, model, selections[0], ch);
            if (r) return r;
        }
        return;
    }
    static _isTypeInterceptorElectricChar(config, model, selections) {
        if (selections.length === 1 && model.tokenization.isCheapToTokenize(selections[0].getEndPosition().lineNumber)) return true;
        return false;
    }
    static _typeInterceptorElectricChar(prevEditOperationType, config, model, selection, ch) {
        if (!config.electricChars.hasOwnProperty(ch) || !selection.isEmpty()) return null;
        const position = selection.getPosition();
        model.tokenization.forceTokenization(position.lineNumber);
        const lineTokens = model.tokenization.getLineTokens(position.lineNumber);
        let electricAction;
        try {
            electricAction = config.onElectricCharacter(ch, lineTokens, position.column);
        } catch (e) {
            (0, _errorsJs.onUnexpectedError)(e);
            return null;
        }
        if (!electricAction) return null;
        if (electricAction.matchOpenBracket) {
            const endColumn = (lineTokens.getLineContent() + ch).lastIndexOf(electricAction.matchOpenBracket) + 1;
            const match = model.bracketPairs.findMatchingBracketUp(electricAction.matchOpenBracket, {
                lineNumber: position.lineNumber,
                column: endColumn
            }, 500 /* give at most 500ms to compute */ );
            if (match) {
                if (match.startLineNumber === position.lineNumber) // matched something on the same line => no change in indentation
                return null;
                const matchLine = model.getLineContent(match.startLineNumber);
                const matchLineIndentation = _stringsJs.getLeadingWhitespace(matchLine);
                const newIndentation = config.normalizeIndentation(matchLineIndentation);
                const lineText = model.getLineContent(position.lineNumber);
                const lineFirstNonBlankColumn = model.getLineFirstNonWhitespaceColumn(position.lineNumber) || position.column;
                const prefix = lineText.substring(lineFirstNonBlankColumn - 1, position.column - 1);
                const typeText = newIndentation + prefix + ch;
                const typeSelection = new (0, _rangeJs.Range)(position.lineNumber, 1, position.lineNumber, position.column);
                const command = new (0, _replaceCommandJs.ReplaceCommand)(typeSelection, typeText);
                return new (0, _cursorCommonJs.EditOperationResult)(getTypingOperation(typeText, prevEditOperationType), [
                    command
                ], {
                    shouldPushStackElementBefore: false,
                    shouldPushStackElementAfter: true
                });
            }
        }
        return null;
    }
}
class SimpleCharacterTypeOperation {
    static getEdits(prevEditOperationType, selections, ch) {
        // A simple character type
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++)commands[i] = new (0, _replaceCommandJs.ReplaceCommand)(selections[i], ch);
        const opType = getTypingOperation(ch, prevEditOperationType);
        return new (0, _cursorCommonJs.EditOperationResult)(opType, commands, {
            shouldPushStackElementBefore: shouldPushStackElementBetween(prevEditOperationType, opType),
            shouldPushStackElementAfter: false
        });
    }
}
class EnterOperation {
    static getEdits(config, model, selections, ch, isDoingComposition) {
        if (!isDoingComposition && ch === "\n") {
            const commands = [];
            for(let i = 0, len = selections.length; i < len; i++)commands[i] = this._enter(config, model, false, selections[i]);
            return new (0, _cursorCommonJs.EditOperationResult)(4 /* EditOperationType.TypingOther */ , commands, {
                shouldPushStackElementBefore: true,
                shouldPushStackElementAfter: false
            });
        }
        return;
    }
    static _enter(config, model, keepPosition, range) {
        if (config.autoIndent === 0 /* EditorAutoIndentStrategy.None */ ) return typeCommand(range, "\n", keepPosition);
        if (!model.tokenization.isCheapToTokenize(range.getStartPosition().lineNumber) || config.autoIndent === 1 /* EditorAutoIndentStrategy.Keep */ ) {
            const lineText = model.getLineContent(range.startLineNumber);
            const indentation = _stringsJs.getLeadingWhitespace(lineText).substring(0, range.startColumn - 1);
            return typeCommand(range, "\n" + config.normalizeIndentation(indentation), keepPosition);
        }
        const r = (0, _enterActionJs.getEnterAction)(config.autoIndent, model, range, config.languageConfigurationService);
        if (r) {
            if (r.indentAction === (0, _languageConfigurationJs.IndentAction).None) // Nothing special
            return typeCommand(range, "\n" + config.normalizeIndentation(r.indentation + r.appendText), keepPosition);
            else if (r.indentAction === (0, _languageConfigurationJs.IndentAction).Indent) // Indent once
            return typeCommand(range, "\n" + config.normalizeIndentation(r.indentation + r.appendText), keepPosition);
            else if (r.indentAction === (0, _languageConfigurationJs.IndentAction).IndentOutdent) {
                // Ultra special
                const normalIndent = config.normalizeIndentation(r.indentation);
                const increasedIndent = config.normalizeIndentation(r.indentation + r.appendText);
                const typeText = "\n" + increasedIndent + "\n" + normalIndent;
                if (keepPosition) return new (0, _replaceCommandJs.ReplaceCommandWithoutChangingPosition)(range, typeText, true);
                else return new (0, _replaceCommandJs.ReplaceCommandWithOffsetCursorState)(range, typeText, -1, increasedIndent.length - normalIndent.length, true);
            } else if (r.indentAction === (0, _languageConfigurationJs.IndentAction).Outdent) {
                const actualIndentation = unshiftIndent(config, r.indentation);
                return typeCommand(range, "\n" + config.normalizeIndentation(actualIndentation + r.appendText), keepPosition);
            }
        }
        const lineText = model.getLineContent(range.startLineNumber);
        const indentation = _stringsJs.getLeadingWhitespace(lineText).substring(0, range.startColumn - 1);
        if (config.autoIndent >= 4 /* EditorAutoIndentStrategy.Full */ ) {
            const ir = (0, _autoIndentJs.getIndentForEnter)(config.autoIndent, model, range, {
                unshiftIndent: (indent)=>{
                    return unshiftIndent(config, indent);
                },
                shiftIndent: (indent)=>{
                    return shiftIndent(config, indent);
                },
                normalizeIndentation: (indent)=>{
                    return config.normalizeIndentation(indent);
                }
            }, config.languageConfigurationService);
            if (ir) {
                let oldEndViewColumn = config.visibleColumnFromColumn(model, range.getEndPosition());
                const oldEndColumn = range.endColumn;
                const newLineContent = model.getLineContent(range.endLineNumber);
                const firstNonWhitespace = _stringsJs.firstNonWhitespaceIndex(newLineContent);
                if (firstNonWhitespace >= 0) range = range.setEndPosition(range.endLineNumber, Math.max(range.endColumn, firstNonWhitespace + 1));
                else range = range.setEndPosition(range.endLineNumber, model.getLineMaxColumn(range.endLineNumber));
                if (keepPosition) return new (0, _replaceCommandJs.ReplaceCommandWithoutChangingPosition)(range, "\n" + config.normalizeIndentation(ir.afterEnter), true);
                else {
                    let offset = 0;
                    if (oldEndColumn <= firstNonWhitespace + 1) {
                        if (!config.insertSpaces) oldEndViewColumn = Math.ceil(oldEndViewColumn / config.indentSize);
                        offset = Math.min(oldEndViewColumn + 1 - config.normalizeIndentation(ir.afterEnter).length - 1, 0);
                    }
                    return new (0, _replaceCommandJs.ReplaceCommandWithOffsetCursorState)(range, "\n" + config.normalizeIndentation(ir.afterEnter), 0, offset, true);
                }
            }
        }
        return typeCommand(range, "\n" + config.normalizeIndentation(indentation), keepPosition);
    }
    static lineInsertBefore(config, model, selections) {
        if (model === null || selections === null) return [];
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++){
            let lineNumber = selections[i].positionLineNumber;
            if (lineNumber === 1) commands[i] = new (0, _replaceCommandJs.ReplaceCommandWithoutChangingPosition)(new (0, _rangeJs.Range)(1, 1, 1, 1), "\n");
            else {
                lineNumber--;
                const column = model.getLineMaxColumn(lineNumber);
                commands[i] = this._enter(config, model, false, new (0, _rangeJs.Range)(lineNumber, column, lineNumber, column));
            }
        }
        return commands;
    }
    static lineInsertAfter(config, model, selections) {
        if (model === null || selections === null) return [];
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++){
            const lineNumber = selections[i].positionLineNumber;
            const column = model.getLineMaxColumn(lineNumber);
            commands[i] = this._enter(config, model, false, new (0, _rangeJs.Range)(lineNumber, column, lineNumber, column));
        }
        return commands;
    }
    static lineBreakInsert(config, model, selections) {
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++)commands[i] = this._enter(config, model, true, selections[i]);
        return commands;
    }
}
class PasteOperation {
    static getEdits(config, model, selections, text, pasteOnNewLine, multicursorText) {
        const distributedPaste = this._distributePasteToCursors(config, selections, text, pasteOnNewLine, multicursorText);
        if (distributedPaste) {
            selections = selections.sort((0, _rangeJs.Range).compareRangesUsingStarts);
            return this._distributedPaste(config, model, selections, distributedPaste);
        } else return this._simplePaste(config, model, selections, text, pasteOnNewLine);
    }
    static _distributePasteToCursors(config, selections, text, pasteOnNewLine, multicursorText) {
        if (pasteOnNewLine) return null;
        if (selections.length === 1) return null;
        if (multicursorText && multicursorText.length === selections.length) return multicursorText;
        if (config.multiCursorPaste === "spread") {
            // Try to spread the pasted text in case the line count matches the cursor count
            // Remove trailing \n if present
            if (text.charCodeAt(text.length - 1) === 10 /* CharCode.LineFeed */ ) text = text.substring(0, text.length - 1);
            // Remove trailing \r if present
            if (text.charCodeAt(text.length - 1) === 13 /* CharCode.CarriageReturn */ ) text = text.substring(0, text.length - 1);
            const lines = _stringsJs.splitLines(text);
            if (lines.length === selections.length) return lines;
        }
        return null;
    }
    static _distributedPaste(config, model, selections, text) {
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++)commands[i] = new (0, _replaceCommandJs.ReplaceCommand)(selections[i], text[i]);
        return new (0, _cursorCommonJs.EditOperationResult)(0 /* EditOperationType.Other */ , commands, {
            shouldPushStackElementBefore: true,
            shouldPushStackElementAfter: true
        });
    }
    static _simplePaste(config, model, selections, text, pasteOnNewLine) {
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++){
            const selection = selections[i];
            const position = selection.getPosition();
            if (pasteOnNewLine && !selection.isEmpty()) pasteOnNewLine = false;
            if (pasteOnNewLine && text.indexOf("\n") !== text.length - 1) pasteOnNewLine = false;
            if (pasteOnNewLine) {
                // Paste entire line at the beginning of line
                const typeSelection = new (0, _rangeJs.Range)(position.lineNumber, 1, position.lineNumber, 1);
                commands[i] = new (0, _replaceCommandJs.ReplaceCommandThatPreservesSelection)(typeSelection, text, selection, true);
            } else commands[i] = new (0, _replaceCommandJs.ReplaceCommand)(selection, text);
        }
        return new (0, _cursorCommonJs.EditOperationResult)(0 /* EditOperationType.Other */ , commands, {
            shouldPushStackElementBefore: true,
            shouldPushStackElementAfter: true
        });
    }
}
class CompositionOperation {
    static getEdits(prevEditOperationType, config, model, selections, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta) {
        const commands = selections.map((selection)=>this._compositionType(model, selection, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta));
        return new (0, _cursorCommonJs.EditOperationResult)(4 /* EditOperationType.TypingOther */ , commands, {
            shouldPushStackElementBefore: shouldPushStackElementBetween(prevEditOperationType, 4 /* EditOperationType.TypingOther */ ),
            shouldPushStackElementAfter: false
        });
    }
    static _compositionType(model, selection, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta) {
        if (!selection.isEmpty()) // looks like https://github.com/microsoft/vscode/issues/2773
        // where a cursor operation occurred before a canceled composition
        // => ignore composition
        return null;
        const pos = selection.getPosition();
        const startColumn = Math.max(1, pos.column - replacePrevCharCnt);
        const endColumn = Math.min(model.getLineMaxColumn(pos.lineNumber), pos.column + replaceNextCharCnt);
        const range = new (0, _rangeJs.Range)(pos.lineNumber, startColumn, pos.lineNumber, endColumn);
        const oldText = model.getValueInRange(range);
        if (oldText === text && positionDelta === 0) // => ignore composition that doesn't do anything
        return null;
        return new (0, _replaceCommandJs.ReplaceCommandWithOffsetCursorState)(range, text, 0, positionDelta);
    }
}
class TypeWithoutInterceptorsOperation {
    static getEdits(prevEditOperationType, selections, str) {
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++)commands[i] = new (0, _replaceCommandJs.ReplaceCommand)(selections[i], str);
        const opType = getTypingOperation(str, prevEditOperationType);
        return new (0, _cursorCommonJs.EditOperationResult)(opType, commands, {
            shouldPushStackElementBefore: shouldPushStackElementBetween(prevEditOperationType, opType),
            shouldPushStackElementAfter: false
        });
    }
}
class TabOperation {
    static getCommands(config, model, selections) {
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++){
            const selection = selections[i];
            if (selection.isEmpty()) {
                const lineText = model.getLineContent(selection.startLineNumber);
                if (/^\s*$/.test(lineText) && model.tokenization.isCheapToTokenize(selection.startLineNumber)) {
                    let goodIndent = this._goodIndentForLine(config, model, selection.startLineNumber);
                    goodIndent = goodIndent || "	";
                    const possibleTypeText = config.normalizeIndentation(goodIndent);
                    if (!lineText.startsWith(possibleTypeText)) {
                        commands[i] = new (0, _replaceCommandJs.ReplaceCommand)(new (0, _rangeJs.Range)(selection.startLineNumber, 1, selection.startLineNumber, lineText.length + 1), possibleTypeText, true);
                        continue;
                    }
                }
                commands[i] = this._replaceJumpToNextIndent(config, model, selection, true);
            } else {
                if (selection.startLineNumber === selection.endLineNumber) {
                    const lineMaxColumn = model.getLineMaxColumn(selection.startLineNumber);
                    if (selection.startColumn !== 1 || selection.endColumn !== lineMaxColumn) {
                        // This is a single line selection that is not the entire line
                        commands[i] = this._replaceJumpToNextIndent(config, model, selection, false);
                        continue;
                    }
                }
                commands[i] = new (0, _shiftCommandJs.ShiftCommand)(selection, {
                    isUnshift: false,
                    tabSize: config.tabSize,
                    indentSize: config.indentSize,
                    insertSpaces: config.insertSpaces,
                    useTabStops: config.useTabStops,
                    autoIndent: config.autoIndent
                }, config.languageConfigurationService);
            }
        }
        return commands;
    }
    static _goodIndentForLine(config, model, lineNumber) {
        let action = null;
        let indentation = "";
        const expectedIndentAction = (0, _autoIndentJs.getInheritIndentForLine)(config.autoIndent, model, lineNumber, false, config.languageConfigurationService);
        if (expectedIndentAction) {
            action = expectedIndentAction.action;
            indentation = expectedIndentAction.indentation;
        } else if (lineNumber > 1) {
            let lastLineNumber;
            for(lastLineNumber = lineNumber - 1; lastLineNumber >= 1; lastLineNumber--){
                const lineText = model.getLineContent(lastLineNumber);
                const nonWhitespaceIdx = _stringsJs.lastNonWhitespaceIndex(lineText);
                if (nonWhitespaceIdx >= 0) break;
            }
            if (lastLineNumber < 1) // No previous line with content found
            return null;
            const maxColumn = model.getLineMaxColumn(lastLineNumber);
            const expectedEnterAction = (0, _enterActionJs.getEnterAction)(config.autoIndent, model, new (0, _rangeJs.Range)(lastLineNumber, maxColumn, lastLineNumber, maxColumn), config.languageConfigurationService);
            if (expectedEnterAction) indentation = expectedEnterAction.indentation + expectedEnterAction.appendText;
        }
        if (action) {
            if (action === (0, _languageConfigurationJs.IndentAction).Indent) indentation = shiftIndent(config, indentation);
            if (action === (0, _languageConfigurationJs.IndentAction).Outdent) indentation = unshiftIndent(config, indentation);
            indentation = config.normalizeIndentation(indentation);
        }
        if (!indentation) return null;
        return indentation;
    }
    static _replaceJumpToNextIndent(config, model, selection, insertsAutoWhitespace) {
        let typeText = "";
        const position = selection.getStartPosition();
        if (config.insertSpaces) {
            const visibleColumnFromColumn = config.visibleColumnFromColumn(model, position);
            const indentSize = config.indentSize;
            const spacesCnt = indentSize - visibleColumnFromColumn % indentSize;
            for(let i = 0; i < spacesCnt; i++)typeText += " ";
        } else typeText = "	";
        return new (0, _replaceCommandJs.ReplaceCommand)(selection, typeText, insertsAutoWhitespace);
    }
}
class BaseTypeWithAutoClosingCommand extends (0, _replaceCommandJs.ReplaceCommandWithOffsetCursorState) {
    constructor(selection, text, lineNumberDeltaOffset, columnDeltaOffset, openCharacter, closeCharacter){
        super(selection, text, lineNumberDeltaOffset, columnDeltaOffset);
        this._openCharacter = openCharacter;
        this._closeCharacter = closeCharacter;
        this.closeCharacterRange = null;
        this.enclosingRange = null;
    }
    _computeCursorStateWithRange(model, range, helper) {
        this.closeCharacterRange = new (0, _rangeJs.Range)(range.startLineNumber, range.endColumn - this._closeCharacter.length, range.endLineNumber, range.endColumn);
        this.enclosingRange = new (0, _rangeJs.Range)(range.startLineNumber, range.endColumn - this._openCharacter.length - this._closeCharacter.length, range.endLineNumber, range.endColumn);
        return super.computeCursorState(model, helper);
    }
}
class TypeWithAutoClosingCommand extends BaseTypeWithAutoClosingCommand {
    constructor(selection, openCharacter, insertOpenCharacter, closeCharacter){
        const text = (insertOpenCharacter ? openCharacter : "") + closeCharacter;
        const lineNumberDeltaOffset = 0;
        const columnDeltaOffset = -closeCharacter.length;
        super(selection, text, lineNumberDeltaOffset, columnDeltaOffset, openCharacter, closeCharacter);
    }
    computeCursorState(model, helper) {
        const inverseEditOperations = helper.getInverseEditOperations();
        const range = inverseEditOperations[0].range;
        return this._computeCursorStateWithRange(model, range, helper);
    }
}
class TypeWithIndentationAndAutoClosingCommand extends BaseTypeWithAutoClosingCommand {
    constructor(autoIndentationEdit, selection, openCharacter, closeCharacter){
        const text = openCharacter + closeCharacter;
        const lineNumberDeltaOffset = 0;
        const columnDeltaOffset = openCharacter.length;
        super(selection, text, lineNumberDeltaOffset, columnDeltaOffset, openCharacter, closeCharacter);
        this._autoIndentationEdit = autoIndentationEdit;
        this._autoClosingEdit = {
            range: selection,
            text
        };
    }
    getEditOperations(model, builder) {
        builder.addTrackedEditOperation(this._autoIndentationEdit.range, this._autoIndentationEdit.text);
        builder.addTrackedEditOperation(this._autoClosingEdit.range, this._autoClosingEdit.text);
    }
    computeCursorState(model, helper) {
        const inverseEditOperations = helper.getInverseEditOperations();
        if (inverseEditOperations.length !== 2) throw new Error("There should be two inverse edit operations!");
        const range1 = inverseEditOperations[0].range;
        const range2 = inverseEditOperations[1].range;
        const range = range1.plusRange(range2);
        return this._computeCursorStateWithRange(model, range, helper);
    }
}
function getTypingOperation(typedText, previousTypingOperation) {
    if (typedText === " ") return previousTypingOperation === 5 /* EditOperationType.TypingFirstSpace */  || previousTypingOperation === 6 /* EditOperationType.TypingConsecutiveSpace */  ? 6 /* EditOperationType.TypingConsecutiveSpace */  : 5 /* EditOperationType.TypingFirstSpace */ ;
    return 4 /* EditOperationType.TypingOther */ ;
}
function shouldPushStackElementBetween(previousTypingOperation, typingOperation) {
    if (isTypingOperation(previousTypingOperation) && !isTypingOperation(typingOperation)) // Always set an undo stop before non-type operations
    return true;
    if (previousTypingOperation === 5 /* EditOperationType.TypingFirstSpace */ ) // `abc |d`: No undo stop
    // `abc  |d`: Undo stop
    return false;
    // Insert undo stop between different operation types
    return normalizeOperationType(previousTypingOperation) !== normalizeOperationType(typingOperation);
}
function normalizeOperationType(type) {
    return type === 6 /* EditOperationType.TypingConsecutiveSpace */  || type === 5 /* EditOperationType.TypingFirstSpace */  ? "space" : type;
}
function isTypingOperation(type) {
    return type === 4 /* EditOperationType.TypingOther */  || type === 5 /* EditOperationType.TypingFirstSpace */  || type === 6 /* EditOperationType.TypingConsecutiveSpace */ ;
}
function isAutoClosingOvertype(config, model, selections, autoClosedCharacters, ch) {
    if (config.autoClosingOvertype === "never") return false;
    if (!config.autoClosingPairs.autoClosingPairsCloseSingleChar.has(ch)) return false;
    for(let i = 0, len = selections.length; i < len; i++){
        const selection = selections[i];
        if (!selection.isEmpty()) return false;
        const position = selection.getPosition();
        const lineText = model.getLineContent(position.lineNumber);
        const afterCharacter = lineText.charAt(position.column - 1);
        if (afterCharacter !== ch) return false;
        // Do not over-type quotes after a backslash
        const chIsQuote = (0, _cursorCommonJs.isQuote)(ch);
        const beforeCharacter = position.column > 2 ? lineText.charCodeAt(position.column - 2) : 0 /* CharCode.Null */ ;
        if (beforeCharacter === 92 /* CharCode.Backslash */  && chIsQuote) return false;
        // Must over-type a closing character typed by the editor
        if (config.autoClosingOvertype === "auto") {
            let found = false;
            for(let j = 0, lenJ = autoClosedCharacters.length; j < lenJ; j++){
                const autoClosedCharacter = autoClosedCharacters[j];
                if (position.lineNumber === autoClosedCharacter.startLineNumber && position.column === autoClosedCharacter.startColumn) {
                    found = true;
                    break;
                }
            }
            if (!found) return false;
        }
    }
    return true;
}
function typeCommand(range, text, keepPosition) {
    if (keepPosition) return new (0, _replaceCommandJs.ReplaceCommandWithoutChangingPosition)(range, text, true);
    else return new (0, _replaceCommandJs.ReplaceCommand)(range, text, true);
}
function shiftIndent(config, indentation, count) {
    count = count || 1;
    return (0, _shiftCommandJs.ShiftCommand).shiftIndent(indentation, indentation.length + count, config.tabSize, config.indentSize, config.insertSpaces);
}
function unshiftIndent(config, indentation, count) {
    count = count || 1;
    return (0, _shiftCommandJs.ShiftCommand).unshiftIndent(indentation, indentation.length + count, config.tabSize, config.indentSize, config.insertSpaces);
}
function shouldSurroundChar(config, ch) {
    if ((0, _cursorCommonJs.isQuote)(ch)) return config.autoSurround === "quotes" || config.autoSurround === "languageDefined";
    else // Character is a bracket
    return config.autoSurround === "brackets" || config.autoSurround === "languageDefined";
}

},{"../../../base/common/errors.js":"divX8","../../../base/common/strings.js":"aA9I1","../commands/replaceCommand.js":"51hNH","../commands/shiftCommand.js":"3JtMW","../commands/surroundSelectionCommand.js":"5684n","../cursorCommon.js":"aKAuR","../core/wordCharacterClassifier.js":"a4wPa","../core/range.js":"jmUPh","../core/position.js":"lvrPe","../languages/languageConfiguration.js":"1ojaS","../languages/languageConfigurationRegistry.js":"2Lk9v","../languages/supports.js":"aA5lJ","../languages/autoIndent.js":"c4ZuY","../languages/enterAction.js":"0RBgX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c4ZuY":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get inherited indentation from above lines.
 * 1. Find the nearest preceding line which doesn't match unIndentedLinePattern.
 * 2. If this line matches indentNextLinePattern or increaseIndentPattern, it means that the indent level of `lineNumber` should be 1 greater than this line.
 * 3. If this line doesn't match any indent rules
 *   a. check whether the line above it matches indentNextLinePattern
 *   b. If not, the indent level of this line is the result
 *   c. If so, it means the indent of this line is *temporary*, go upward utill we find a line whose indent is not temporary (the same workflow a -> b -> c).
 * 4. Otherwise, we fail to get an inherited indent from aboves. Return null and we should not touch the indent of `lineNumber`
 *
 * This function only return the inherited indent based on above lines, it doesn't check whether current line should decrease or not.
 */ parcelHelpers.export(exports, "getInheritIndentForLine", ()=>getInheritIndentForLine);
parcelHelpers.export(exports, "getGoodIndentForLine", ()=>getGoodIndentForLine);
parcelHelpers.export(exports, "getIndentForEnter", ()=>getIndentForEnter);
/**
 * We should always allow intentional indentation. It means, if users change the indentation of `lineNumber` and the content of
 * this line doesn't match decreaseIndentPattern, we should not adjust the indentation.
 */ parcelHelpers.export(exports, "getIndentActionForType", ()=>getIndentActionForType);
parcelHelpers.export(exports, "getIndentMetadata", ()=>getIndentMetadata);
var _stringsJs = require("../../../base/common/strings.js");
var _languageConfigurationJs = require("./languageConfiguration.js");
var _indentationLineProcessorJs = require("./supports/indentationLineProcessor.js");
/**
 * Get nearest preceding line which doesn't match unIndentPattern or contains all whitespace.
 * Result:
 * -1: run into the boundary of embedded languages
 * 0: every line above are invalid
 * else: nearest preceding line of the same language
 */ function getPrecedingValidLine(model, lineNumber, processedIndentRulesSupport) {
    const languageId = model.tokenization.getLanguageIdAtPosition(lineNumber, 0);
    if (lineNumber > 1) {
        let lastLineNumber;
        let resultLineNumber = -1;
        for(lastLineNumber = lineNumber - 1; lastLineNumber >= 1; lastLineNumber--){
            if (model.tokenization.getLanguageIdAtPosition(lastLineNumber, 0) !== languageId) return resultLineNumber;
            const text = model.getLineContent(lastLineNumber);
            if (processedIndentRulesSupport.shouldIgnore(lastLineNumber) || /^\s+$/.test(text) || text === "") {
                resultLineNumber = lastLineNumber;
                continue;
            }
            return lastLineNumber;
        }
    }
    return -1;
}
function getInheritIndentForLine(autoIndent, model, lineNumber, honorIntentialIndent = true, languageConfigurationService) {
    if (autoIndent < 4 /* EditorAutoIndentStrategy.Full */ ) return null;
    const indentRulesSupport = languageConfigurationService.getLanguageConfiguration(model.tokenization.getLanguageId()).indentRulesSupport;
    if (!indentRulesSupport) return null;
    const processedIndentRulesSupport = new (0, _indentationLineProcessorJs.ProcessedIndentRulesSupport)(model, indentRulesSupport, languageConfigurationService);
    if (lineNumber <= 1) return {
        indentation: "",
        action: null
    };
    // Use no indent if this is the first non-blank line
    for(let priorLineNumber = lineNumber - 1; priorLineNumber > 0; priorLineNumber--){
        if (model.getLineContent(priorLineNumber) !== "") break;
        if (priorLineNumber === 1) return {
            indentation: "",
            action: null
        };
    }
    const precedingUnIgnoredLine = getPrecedingValidLine(model, lineNumber, processedIndentRulesSupport);
    if (precedingUnIgnoredLine < 0) return null;
    else if (precedingUnIgnoredLine < 1) return {
        indentation: "",
        action: null
    };
    if (processedIndentRulesSupport.shouldIncrease(precedingUnIgnoredLine) || processedIndentRulesSupport.shouldIndentNextLine(precedingUnIgnoredLine)) {
        const precedingUnIgnoredLineContent = model.getLineContent(precedingUnIgnoredLine);
        return {
            indentation: _stringsJs.getLeadingWhitespace(precedingUnIgnoredLineContent),
            action: (0, _languageConfigurationJs.IndentAction).Indent,
            line: precedingUnIgnoredLine
        };
    } else if (processedIndentRulesSupport.shouldDecrease(precedingUnIgnoredLine)) {
        const precedingUnIgnoredLineContent = model.getLineContent(precedingUnIgnoredLine);
        return {
            indentation: _stringsJs.getLeadingWhitespace(precedingUnIgnoredLineContent),
            action: null,
            line: precedingUnIgnoredLine
        };
    } else {
        // precedingUnIgnoredLine can not be ignored.
        // it doesn't increase indent of following lines
        // it doesn't increase just next line
        // so current line is not affect by precedingUnIgnoredLine
        // and then we should get a correct inheritted indentation from above lines
        if (precedingUnIgnoredLine === 1) return {
            indentation: _stringsJs.getLeadingWhitespace(model.getLineContent(precedingUnIgnoredLine)),
            action: null,
            line: precedingUnIgnoredLine
        };
        const previousLine = precedingUnIgnoredLine - 1;
        const previousLineIndentMetadata = indentRulesSupport.getIndentMetadata(model.getLineContent(previousLine));
        if (!(previousLineIndentMetadata & 3 /* IndentConsts.DECREASE_MASK */ ) && previousLineIndentMetadata & 4 /* IndentConsts.INDENT_NEXTLINE_MASK */ ) {
            let stopLine = 0;
            for(let i = previousLine - 1; i > 0; i--){
                if (processedIndentRulesSupport.shouldIndentNextLine(i)) continue;
                stopLine = i;
                break;
            }
            return {
                indentation: _stringsJs.getLeadingWhitespace(model.getLineContent(stopLine + 1)),
                action: null,
                line: stopLine + 1
            };
        }
        if (honorIntentialIndent) return {
            indentation: _stringsJs.getLeadingWhitespace(model.getLineContent(precedingUnIgnoredLine)),
            action: null,
            line: precedingUnIgnoredLine
        };
        else {
            // search from precedingUnIgnoredLine until we find one whose indent is not temporary
            for(let i = precedingUnIgnoredLine; i > 0; i--){
                if (processedIndentRulesSupport.shouldIncrease(i)) return {
                    indentation: _stringsJs.getLeadingWhitespace(model.getLineContent(i)),
                    action: (0, _languageConfigurationJs.IndentAction).Indent,
                    line: i
                };
                else if (processedIndentRulesSupport.shouldIndentNextLine(i)) {
                    let stopLine = 0;
                    for(let j = i - 1; j > 0; j--){
                        if (processedIndentRulesSupport.shouldIndentNextLine(i)) continue;
                        stopLine = j;
                        break;
                    }
                    return {
                        indentation: _stringsJs.getLeadingWhitespace(model.getLineContent(stopLine + 1)),
                        action: null,
                        line: stopLine + 1
                    };
                } else if (processedIndentRulesSupport.shouldDecrease(i)) return {
                    indentation: _stringsJs.getLeadingWhitespace(model.getLineContent(i)),
                    action: null,
                    line: i
                };
            }
            return {
                indentation: _stringsJs.getLeadingWhitespace(model.getLineContent(1)),
                action: null,
                line: 1
            };
        }
    }
}
function getGoodIndentForLine(autoIndent, virtualModel, languageId, lineNumber, indentConverter, languageConfigurationService) {
    if (autoIndent < 4 /* EditorAutoIndentStrategy.Full */ ) return null;
    const richEditSupport = languageConfigurationService.getLanguageConfiguration(languageId);
    if (!richEditSupport) return null;
    const indentRulesSupport = languageConfigurationService.getLanguageConfiguration(languageId).indentRulesSupport;
    if (!indentRulesSupport) return null;
    const processedIndentRulesSupport = new (0, _indentationLineProcessorJs.ProcessedIndentRulesSupport)(virtualModel, indentRulesSupport, languageConfigurationService);
    const indent = getInheritIndentForLine(autoIndent, virtualModel, lineNumber, undefined, languageConfigurationService);
    if (indent) {
        const inheritLine = indent.line;
        if (inheritLine !== undefined) {
            // Apply enter action as long as there are only whitespace lines between inherited line and this line.
            let shouldApplyEnterRules = true;
            for(let inBetweenLine = inheritLine; inBetweenLine < lineNumber - 1; inBetweenLine++)if (!/^\s*$/.test(virtualModel.getLineContent(inBetweenLine))) {
                shouldApplyEnterRules = false;
                break;
            }
            if (shouldApplyEnterRules) {
                const enterResult = richEditSupport.onEnter(autoIndent, "", virtualModel.getLineContent(inheritLine), "");
                if (enterResult) {
                    let indentation = _stringsJs.getLeadingWhitespace(virtualModel.getLineContent(inheritLine));
                    if (enterResult.removeText) indentation = indentation.substring(0, indentation.length - enterResult.removeText);
                    if (enterResult.indentAction === (0, _languageConfigurationJs.IndentAction).Indent || enterResult.indentAction === (0, _languageConfigurationJs.IndentAction).IndentOutdent) indentation = indentConverter.shiftIndent(indentation);
                    else if (enterResult.indentAction === (0, _languageConfigurationJs.IndentAction).Outdent) indentation = indentConverter.unshiftIndent(indentation);
                    if (processedIndentRulesSupport.shouldDecrease(lineNumber)) indentation = indentConverter.unshiftIndent(indentation);
                    if (enterResult.appendText) indentation += enterResult.appendText;
                    return _stringsJs.getLeadingWhitespace(indentation);
                }
            }
        }
        if (processedIndentRulesSupport.shouldDecrease(lineNumber)) {
            if (indent.action === (0, _languageConfigurationJs.IndentAction).Indent) return indent.indentation;
            else return indentConverter.unshiftIndent(indent.indentation);
        } else {
            if (indent.action === (0, _languageConfigurationJs.IndentAction).Indent) return indentConverter.shiftIndent(indent.indentation);
            else return indent.indentation;
        }
    }
    return null;
}
function getIndentForEnter(autoIndent, model, range, indentConverter, languageConfigurationService) {
    if (autoIndent < 4 /* EditorAutoIndentStrategy.Full */ ) return null;
    const languageId = model.getLanguageIdAtPosition(range.startLineNumber, range.startColumn);
    const indentRulesSupport = languageConfigurationService.getLanguageConfiguration(languageId).indentRulesSupport;
    if (!indentRulesSupport) return null;
    model.tokenization.forceTokenization(range.startLineNumber);
    const indentationContextProcessor = new (0, _indentationLineProcessorJs.IndentationContextProcessor)(model, languageConfigurationService);
    const processedContextTokens = indentationContextProcessor.getProcessedTokenContextAroundRange(range);
    const afterEnterProcessedTokens = processedContextTokens.afterRangeProcessedTokens;
    const beforeEnterProcessedTokens = processedContextTokens.beforeRangeProcessedTokens;
    const beforeEnterIndent = _stringsJs.getLeadingWhitespace(beforeEnterProcessedTokens.getLineContent());
    const virtualModel = createVirtualModelWithModifiedTokensAtLine(model, range.startLineNumber, beforeEnterProcessedTokens);
    const languageIsDifferentFromLineStart = (0, _indentationLineProcessorJs.isLanguageDifferentFromLineStart)(model, range.getStartPosition());
    const currentLine = model.getLineContent(range.startLineNumber);
    const currentLineIndent = _stringsJs.getLeadingWhitespace(currentLine);
    const afterEnterAction = getInheritIndentForLine(autoIndent, virtualModel, range.startLineNumber + 1, undefined, languageConfigurationService);
    if (!afterEnterAction) {
        const beforeEnter = languageIsDifferentFromLineStart ? currentLineIndent : beforeEnterIndent;
        return {
            beforeEnter: beforeEnter,
            afterEnter: beforeEnter
        };
    }
    let afterEnterIndent = languageIsDifferentFromLineStart ? currentLineIndent : afterEnterAction.indentation;
    if (afterEnterAction.action === (0, _languageConfigurationJs.IndentAction).Indent) afterEnterIndent = indentConverter.shiftIndent(afterEnterIndent);
    if (indentRulesSupport.shouldDecrease(afterEnterProcessedTokens.getLineContent())) afterEnterIndent = indentConverter.unshiftIndent(afterEnterIndent);
    return {
        beforeEnter: languageIsDifferentFromLineStart ? currentLineIndent : beforeEnterIndent,
        afterEnter: afterEnterIndent
    };
}
function getIndentActionForType(cursorConfig, model, range, ch, indentConverter, languageConfigurationService) {
    const autoIndent = cursorConfig.autoIndent;
    if (autoIndent < 4 /* EditorAutoIndentStrategy.Full */ ) return null;
    const languageIsDifferentFromLineStart = (0, _indentationLineProcessorJs.isLanguageDifferentFromLineStart)(model, range.getStartPosition());
    if (languageIsDifferentFromLineStart) // this line has mixed languages and indentation rules will not work
    return null;
    const languageId = model.getLanguageIdAtPosition(range.startLineNumber, range.startColumn);
    const indentRulesSupport = languageConfigurationService.getLanguageConfiguration(languageId).indentRulesSupport;
    if (!indentRulesSupport) return null;
    const indentationContextProcessor = new (0, _indentationLineProcessorJs.IndentationContextProcessor)(model, languageConfigurationService);
    const processedContextTokens = indentationContextProcessor.getProcessedTokenContextAroundRange(range);
    const beforeRangeText = processedContextTokens.beforeRangeProcessedTokens.getLineContent();
    const afterRangeText = processedContextTokens.afterRangeProcessedTokens.getLineContent();
    const textAroundRange = beforeRangeText + afterRangeText;
    const textAroundRangeWithCharacter = beforeRangeText + ch + afterRangeText;
    // If previous content already matches decreaseIndentPattern, it means indentation of this line should already be adjusted
    // Users might change the indentation by purpose and we should honor that instead of readjusting.
    if (!indentRulesSupport.shouldDecrease(textAroundRange) && indentRulesSupport.shouldDecrease(textAroundRangeWithCharacter)) {
        // after typing `ch`, the content matches decreaseIndentPattern, we should adjust the indent to a good manner.
        // 1. Get inherited indent action
        const r = getInheritIndentForLine(autoIndent, model, range.startLineNumber, false, languageConfigurationService);
        if (!r) return null;
        let indentation = r.indentation;
        if (r.action !== (0, _languageConfigurationJs.IndentAction).Indent) indentation = indentConverter.unshiftIndent(indentation);
        return indentation;
    }
    const previousLineNumber = range.startLineNumber - 1;
    if (previousLineNumber > 0) {
        const previousLine = model.getLineContent(previousLineNumber);
        if (indentRulesSupport.shouldIndentNextLine(previousLine) && indentRulesSupport.shouldIncrease(textAroundRangeWithCharacter)) {
            const inheritedIndentationData = getInheritIndentForLine(autoIndent, model, range.startLineNumber, false, languageConfigurationService);
            const inheritedIndentation = inheritedIndentationData?.indentation;
            if (inheritedIndentation !== undefined) {
                const currentLine = model.getLineContent(range.startLineNumber);
                const actualCurrentIndentation = _stringsJs.getLeadingWhitespace(currentLine);
                const inferredCurrentIndentation = indentConverter.shiftIndent(inheritedIndentation);
                // If the inferred current indentation is not equal to the actual current indentation, then the indentation has been intentionally changed, in that case keep it
                const inferredIndentationEqualsActual = inferredCurrentIndentation === actualCurrentIndentation;
                const textAroundRangeContainsOnlyWhitespace = /^\s*$/.test(textAroundRange);
                const autoClosingPairs = cursorConfig.autoClosingPairs.autoClosingPairsOpenByEnd.get(ch);
                const autoClosingPairExists = autoClosingPairs && autoClosingPairs.length > 0;
                const isChFirstNonWhitespaceCharacterAndInAutoClosingPair = autoClosingPairExists && textAroundRangeContainsOnlyWhitespace;
                if (inferredIndentationEqualsActual && isChFirstNonWhitespaceCharacterAndInAutoClosingPair) return inheritedIndentation;
            }
        }
    }
    return null;
}
function getIndentMetadata(model, lineNumber, languageConfigurationService) {
    const indentRulesSupport = languageConfigurationService.getLanguageConfiguration(model.getLanguageId()).indentRulesSupport;
    if (!indentRulesSupport) return null;
    if (lineNumber < 1 || lineNumber > model.getLineCount()) return null;
    return indentRulesSupport.getIndentMetadata(model.getLineContent(lineNumber));
}
function createVirtualModelWithModifiedTokensAtLine(model, modifiedLineNumber, modifiedTokens) {
    const virtualModel = {
        tokenization: {
            getLineTokens: (lineNumber)=>{
                if (lineNumber === modifiedLineNumber) return modifiedTokens;
                else return model.tokenization.getLineTokens(lineNumber);
            },
            getLanguageId: ()=>{
                return model.getLanguageId();
            },
            getLanguageIdAtPosition: (lineNumber, column)=>{
                return model.getLanguageIdAtPosition(lineNumber, column);
            }
        },
        getLineContent: (lineNumber)=>{
            if (lineNumber === modifiedLineNumber) return modifiedTokens.getLineContent();
            else return model.getLineContent(lineNumber);
        }
    };
    return virtualModel;
}

},{"../../../base/common/strings.js":"aA9I1","./languageConfiguration.js":"1ojaS","./supports/indentationLineProcessor.js":"44GwO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5exv9":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorContextKeys", ()=>EditorContextKeys);
var _nlsJs = require("../../nls.js");
var _contextkeyJs = require("../../platform/contextkey/common/contextkey.js");
var EditorContextKeys;
(function(EditorContextKeys) {
    EditorContextKeys.editorSimpleInput = new (0, _contextkeyJs.RawContextKey)("editorSimpleInput", false, true);
    /**
     * A context key that is set when the editor's text has focus (cursor is blinking).
     * Is false when focus is in simple editor widgets (repl input, scm commit input).
     */ EditorContextKeys.editorTextFocus = new (0, _contextkeyJs.RawContextKey)("editorTextFocus", false, _nlsJs.localize("editorTextFocus", "Whether the editor text has focus (cursor is blinking)"));
    /**
     * A context key that is set when the editor's text or an editor's widget has focus.
     */ EditorContextKeys.focus = new (0, _contextkeyJs.RawContextKey)("editorFocus", false, _nlsJs.localize("editorFocus", "Whether the editor or an editor widget has focus (e.g. focus is in the find widget)"));
    /**
     * A context key that is set when any editor input has focus (regular editor, repl input...).
     */ EditorContextKeys.textInputFocus = new (0, _contextkeyJs.RawContextKey)("textInputFocus", false, _nlsJs.localize("textInputFocus", "Whether an editor or a rich text input has focus (cursor is blinking)"));
    EditorContextKeys.readOnly = new (0, _contextkeyJs.RawContextKey)("editorReadonly", false, _nlsJs.localize("editorReadonly", "Whether the editor is read-only"));
    EditorContextKeys.inDiffEditor = new (0, _contextkeyJs.RawContextKey)("inDiffEditor", false, _nlsJs.localize("inDiffEditor", "Whether the context is a diff editor"));
    EditorContextKeys.isEmbeddedDiffEditor = new (0, _contextkeyJs.RawContextKey)("isEmbeddedDiffEditor", false, _nlsJs.localize("isEmbeddedDiffEditor", "Whether the context is an embedded diff editor"));
    EditorContextKeys.inMultiDiffEditor = new (0, _contextkeyJs.RawContextKey)("inMultiDiffEditor", false, _nlsJs.localize("inMultiDiffEditor", "Whether the context is a multi diff editor"));
    EditorContextKeys.multiDiffEditorAllCollapsed = new (0, _contextkeyJs.RawContextKey)("multiDiffEditorAllCollapsed", undefined, _nlsJs.localize("multiDiffEditorAllCollapsed", "Whether all files in multi diff editor are collapsed"));
    EditorContextKeys.hasChanges = new (0, _contextkeyJs.RawContextKey)("diffEditorHasChanges", false, _nlsJs.localize("diffEditorHasChanges", "Whether the diff editor has changes"));
    EditorContextKeys.comparingMovedCode = new (0, _contextkeyJs.RawContextKey)("comparingMovedCode", false, _nlsJs.localize("comparingMovedCode", "Whether a moved code block is selected for comparison"));
    EditorContextKeys.accessibleDiffViewerVisible = new (0, _contextkeyJs.RawContextKey)("accessibleDiffViewerVisible", false, _nlsJs.localize("accessibleDiffViewerVisible", "Whether the accessible diff viewer is visible"));
    EditorContextKeys.diffEditorRenderSideBySideInlineBreakpointReached = new (0, _contextkeyJs.RawContextKey)("diffEditorRenderSideBySideInlineBreakpointReached", false, _nlsJs.localize("diffEditorRenderSideBySideInlineBreakpointReached", "Whether the diff editor render side by side inline breakpoint is reached"));
    EditorContextKeys.diffEditorInlineMode = new (0, _contextkeyJs.RawContextKey)("diffEditorInlineMode", false, _nlsJs.localize("diffEditorInlineMode", "Whether inline mode is active"));
    EditorContextKeys.diffEditorOriginalWritable = new (0, _contextkeyJs.RawContextKey)("diffEditorOriginalWritable", false, _nlsJs.localize("diffEditorOriginalWritable", "Whether modified is writable in the diff editor"));
    EditorContextKeys.diffEditorModifiedWritable = new (0, _contextkeyJs.RawContextKey)("diffEditorModifiedWritable", false, _nlsJs.localize("diffEditorModifiedWritable", "Whether modified is writable in the diff editor"));
    EditorContextKeys.diffEditorOriginalUri = new (0, _contextkeyJs.RawContextKey)("diffEditorOriginalUri", "", _nlsJs.localize("diffEditorOriginalUri", "The uri of the original document"));
    EditorContextKeys.diffEditorModifiedUri = new (0, _contextkeyJs.RawContextKey)("diffEditorModifiedUri", "", _nlsJs.localize("diffEditorModifiedUri", "The uri of the modified document"));
    EditorContextKeys.columnSelection = new (0, _contextkeyJs.RawContextKey)("editorColumnSelection", false, _nlsJs.localize("editorColumnSelection", "Whether `editor.columnSelection` is enabled"));
    EditorContextKeys.writable = EditorContextKeys.readOnly.toNegated();
    EditorContextKeys.hasNonEmptySelection = new (0, _contextkeyJs.RawContextKey)("editorHasSelection", false, _nlsJs.localize("editorHasSelection", "Whether the editor has text selected"));
    EditorContextKeys.hasOnlyEmptySelection = EditorContextKeys.hasNonEmptySelection.toNegated();
    EditorContextKeys.hasMultipleSelections = new (0, _contextkeyJs.RawContextKey)("editorHasMultipleSelections", false, _nlsJs.localize("editorHasMultipleSelections", "Whether the editor has multiple selections"));
    EditorContextKeys.hasSingleSelection = EditorContextKeys.hasMultipleSelections.toNegated();
    EditorContextKeys.tabMovesFocus = new (0, _contextkeyJs.RawContextKey)("editorTabMovesFocus", false, _nlsJs.localize("editorTabMovesFocus", "Whether `Tab` will move focus out of the editor"));
    EditorContextKeys.tabDoesNotMoveFocus = EditorContextKeys.tabMovesFocus.toNegated();
    EditorContextKeys.isInEmbeddedEditor = new (0, _contextkeyJs.RawContextKey)("isInEmbeddedEditor", false, true);
    EditorContextKeys.canUndo = new (0, _contextkeyJs.RawContextKey)("canUndo", false, true);
    EditorContextKeys.canRedo = new (0, _contextkeyJs.RawContextKey)("canRedo", false, true);
    EditorContextKeys.hoverVisible = new (0, _contextkeyJs.RawContextKey)("editorHoverVisible", false, _nlsJs.localize("editorHoverVisible", "Whether the editor hover is visible"));
    EditorContextKeys.hoverFocused = new (0, _contextkeyJs.RawContextKey)("editorHoverFocused", false, _nlsJs.localize("editorHoverFocused", "Whether the editor hover is focused"));
    EditorContextKeys.stickyScrollFocused = new (0, _contextkeyJs.RawContextKey)("stickyScrollFocused", false, _nlsJs.localize("stickyScrollFocused", "Whether the sticky scroll is focused"));
    EditorContextKeys.stickyScrollVisible = new (0, _contextkeyJs.RawContextKey)("stickyScrollVisible", false, _nlsJs.localize("stickyScrollVisible", "Whether the sticky scroll is visible"));
    EditorContextKeys.standaloneColorPickerVisible = new (0, _contextkeyJs.RawContextKey)("standaloneColorPickerVisible", false, _nlsJs.localize("standaloneColorPickerVisible", "Whether the standalone color picker is visible"));
    EditorContextKeys.standaloneColorPickerFocused = new (0, _contextkeyJs.RawContextKey)("standaloneColorPickerFocused", false, _nlsJs.localize("standaloneColorPickerFocused", "Whether the standalone color picker is focused"));
    /**
     * A context key that is set when an editor is part of a larger editor, like notebooks or
     * (future) a diff editor
     */ EditorContextKeys.inCompositeEditor = new (0, _contextkeyJs.RawContextKey)("inCompositeEditor", undefined, _nlsJs.localize("inCompositeEditor", "Whether the editor is part of a larger editor (e.g. notebooks)"));
    EditorContextKeys.notInCompositeEditor = EditorContextKeys.inCompositeEditor.toNegated();
    // -- mode context keys
    EditorContextKeys.languageId = new (0, _contextkeyJs.RawContextKey)("editorLangId", "", _nlsJs.localize("editorLangId", "The language identifier of the editor"));
    EditorContextKeys.hasCompletionItemProvider = new (0, _contextkeyJs.RawContextKey)("editorHasCompletionItemProvider", false, _nlsJs.localize("editorHasCompletionItemProvider", "Whether the editor has a completion item provider"));
    EditorContextKeys.hasCodeActionsProvider = new (0, _contextkeyJs.RawContextKey)("editorHasCodeActionsProvider", false, _nlsJs.localize("editorHasCodeActionsProvider", "Whether the editor has a code actions provider"));
    EditorContextKeys.hasCodeLensProvider = new (0, _contextkeyJs.RawContextKey)("editorHasCodeLensProvider", false, _nlsJs.localize("editorHasCodeLensProvider", "Whether the editor has a code lens provider"));
    EditorContextKeys.hasDefinitionProvider = new (0, _contextkeyJs.RawContextKey)("editorHasDefinitionProvider", false, _nlsJs.localize("editorHasDefinitionProvider", "Whether the editor has a definition provider"));
    EditorContextKeys.hasDeclarationProvider = new (0, _contextkeyJs.RawContextKey)("editorHasDeclarationProvider", false, _nlsJs.localize("editorHasDeclarationProvider", "Whether the editor has a declaration provider"));
    EditorContextKeys.hasImplementationProvider = new (0, _contextkeyJs.RawContextKey)("editorHasImplementationProvider", false, _nlsJs.localize("editorHasImplementationProvider", "Whether the editor has an implementation provider"));
    EditorContextKeys.hasTypeDefinitionProvider = new (0, _contextkeyJs.RawContextKey)("editorHasTypeDefinitionProvider", false, _nlsJs.localize("editorHasTypeDefinitionProvider", "Whether the editor has a type definition provider"));
    EditorContextKeys.hasHoverProvider = new (0, _contextkeyJs.RawContextKey)("editorHasHoverProvider", false, _nlsJs.localize("editorHasHoverProvider", "Whether the editor has a hover provider"));
    EditorContextKeys.hasDocumentHighlightProvider = new (0, _contextkeyJs.RawContextKey)("editorHasDocumentHighlightProvider", false, _nlsJs.localize("editorHasDocumentHighlightProvider", "Whether the editor has a document highlight provider"));
    EditorContextKeys.hasDocumentSymbolProvider = new (0, _contextkeyJs.RawContextKey)("editorHasDocumentSymbolProvider", false, _nlsJs.localize("editorHasDocumentSymbolProvider", "Whether the editor has a document symbol provider"));
    EditorContextKeys.hasReferenceProvider = new (0, _contextkeyJs.RawContextKey)("editorHasReferenceProvider", false, _nlsJs.localize("editorHasReferenceProvider", "Whether the editor has a reference provider"));
    EditorContextKeys.hasRenameProvider = new (0, _contextkeyJs.RawContextKey)("editorHasRenameProvider", false, _nlsJs.localize("editorHasRenameProvider", "Whether the editor has a rename provider"));
    EditorContextKeys.hasSignatureHelpProvider = new (0, _contextkeyJs.RawContextKey)("editorHasSignatureHelpProvider", false, _nlsJs.localize("editorHasSignatureHelpProvider", "Whether the editor has a signature help provider"));
    EditorContextKeys.hasInlayHintsProvider = new (0, _contextkeyJs.RawContextKey)("editorHasInlayHintsProvider", false, _nlsJs.localize("editorHasInlayHintsProvider", "Whether the editor has an inline hints provider"));
    // -- mode context keys: formatting
    EditorContextKeys.hasDocumentFormattingProvider = new (0, _contextkeyJs.RawContextKey)("editorHasDocumentFormattingProvider", false, _nlsJs.localize("editorHasDocumentFormattingProvider", "Whether the editor has a document formatting provider"));
    EditorContextKeys.hasDocumentSelectionFormattingProvider = new (0, _contextkeyJs.RawContextKey)("editorHasDocumentSelectionFormattingProvider", false, _nlsJs.localize("editorHasDocumentSelectionFormattingProvider", "Whether the editor has a document selection formatting provider"));
    EditorContextKeys.hasMultipleDocumentFormattingProvider = new (0, _contextkeyJs.RawContextKey)("editorHasMultipleDocumentFormattingProvider", false, _nlsJs.localize("editorHasMultipleDocumentFormattingProvider", "Whether the editor has multiple document formatting providers"));
    EditorContextKeys.hasMultipleDocumentSelectionFormattingProvider = new (0, _contextkeyJs.RawContextKey)("editorHasMultipleDocumentSelectionFormattingProvider", false, _nlsJs.localize("editorHasMultipleDocumentSelectionFormattingProvider", "Whether the editor has multiple document selection formatting providers"));
})(EditorContextKeys || (EditorContextKeys = {}));

},{"../../nls.js":"l617d","../../platform/contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fr4HK":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewOverlays", ()=>ViewOverlays);
parcelHelpers.export(exports, "ViewOverlayLine", ()=>ViewOverlayLine);
parcelHelpers.export(exports, "ContentViewOverlays", ()=>ContentViewOverlays);
parcelHelpers.export(exports, "MarginViewOverlays", ()=>MarginViewOverlays);
var _fastDomNodeJs = require("../../../base/browser/fastDomNode.js");
var _domFontInfoJs = require("../config/domFontInfo.js");
var _viewLayerJs = require("./viewLayer.js");
var _viewPartJs = require("./viewPart.js");
class ViewOverlays extends (0, _viewPartJs.ViewPart) {
    constructor(context){
        super(context);
        this._dynamicOverlays = [];
        this._isFocused = false;
        this._visibleLines = new (0, _viewLayerJs.VisibleLinesCollection)({
            createLine: ()=>new ViewOverlayLine(this._dynamicOverlays)
        });
        this.domNode = this._visibleLines.domNode;
        const options = this._context.configuration.options;
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        (0, _domFontInfoJs.applyFontInfo)(this.domNode, fontInfo);
        this.domNode.setClassName("view-overlays");
    }
    shouldRender() {
        if (super.shouldRender()) return true;
        for(let i = 0, len = this._dynamicOverlays.length; i < len; i++){
            const dynamicOverlay = this._dynamicOverlays[i];
            if (dynamicOverlay.shouldRender()) return true;
        }
        return false;
    }
    dispose() {
        super.dispose();
        for(let i = 0, len = this._dynamicOverlays.length; i < len; i++){
            const dynamicOverlay = this._dynamicOverlays[i];
            dynamicOverlay.dispose();
        }
        this._dynamicOverlays = [];
    }
    getDomNode() {
        return this.domNode;
    }
    addDynamicOverlay(overlay) {
        this._dynamicOverlays.push(overlay);
    }
    // ----- event handlers
    onConfigurationChanged(e) {
        this._visibleLines.onConfigurationChanged(e);
        const options = this._context.configuration.options;
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        (0, _domFontInfoJs.applyFontInfo)(this.domNode, fontInfo);
        return true;
    }
    onFlushed(e) {
        return this._visibleLines.onFlushed(e);
    }
    onFocusChanged(e) {
        this._isFocused = e.isFocused;
        return true;
    }
    onLinesChanged(e) {
        return this._visibleLines.onLinesChanged(e);
    }
    onLinesDeleted(e) {
        return this._visibleLines.onLinesDeleted(e);
    }
    onLinesInserted(e) {
        return this._visibleLines.onLinesInserted(e);
    }
    onScrollChanged(e) {
        return this._visibleLines.onScrollChanged(e) || true;
    }
    onTokensChanged(e) {
        return this._visibleLines.onTokensChanged(e);
    }
    onZonesChanged(e) {
        return this._visibleLines.onZonesChanged(e);
    }
    // ----- end event handlers
    prepareRender(ctx) {
        const toRender = this._dynamicOverlays.filter((overlay)=>overlay.shouldRender());
        for(let i = 0, len = toRender.length; i < len; i++){
            const dynamicOverlay = toRender[i];
            dynamicOverlay.prepareRender(ctx);
            dynamicOverlay.onDidRender();
        }
    }
    render(ctx) {
        // Overwriting to bypass `shouldRender` flag
        this._viewOverlaysRender(ctx);
        this.domNode.toggleClassName("focused", this._isFocused);
    }
    _viewOverlaysRender(ctx) {
        this._visibleLines.renderLines(ctx.viewportData);
    }
}
class ViewOverlayLine {
    constructor(dynamicOverlays){
        this._dynamicOverlays = dynamicOverlays;
        this._domNode = null;
        this._renderedContent = null;
    }
    getDomNode() {
        if (!this._domNode) return null;
        return this._domNode.domNode;
    }
    setDomNode(domNode) {
        this._domNode = (0, _fastDomNodeJs.createFastDomNode)(domNode);
    }
    onContentChanged() {
    // Nothing
    }
    onTokensChanged() {
    // Nothing
    }
    renderLine(lineNumber, deltaTop, lineHeight, viewportData, sb) {
        let result = "";
        for(let i = 0, len = this._dynamicOverlays.length; i < len; i++){
            const dynamicOverlay = this._dynamicOverlays[i];
            result += dynamicOverlay.render(viewportData.startLineNumber, lineNumber);
        }
        if (this._renderedContent === result) // No rendering needed
        return false;
        this._renderedContent = result;
        sb.appendString('<div style="top:');
        sb.appendString(String(deltaTop));
        sb.appendString("px;height:");
        sb.appendString(String(lineHeight));
        sb.appendString('px;">');
        sb.appendString(result);
        sb.appendString("</div>");
        return true;
    }
    layoutLine(lineNumber, deltaTop, lineHeight) {
        if (this._domNode) {
            this._domNode.setTop(deltaTop);
            this._domNode.setHeight(lineHeight);
        }
    }
}
class ContentViewOverlays extends ViewOverlays {
    constructor(context){
        super(context);
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._contentWidth = layoutInfo.contentWidth;
        this.domNode.setHeight(0);
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._contentWidth = layoutInfo.contentWidth;
        return super.onConfigurationChanged(e) || true;
    }
    onScrollChanged(e) {
        return super.onScrollChanged(e) || e.scrollWidthChanged;
    }
    // --- end event handlers
    _viewOverlaysRender(ctx) {
        super._viewOverlaysRender(ctx);
        this.domNode.setWidth(Math.max(ctx.scrollWidth, this._contentWidth));
    }
}
class MarginViewOverlays extends ViewOverlays {
    constructor(context){
        super(context);
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._contentLeft = layoutInfo.contentLeft;
        this.domNode.setClassName("margin-view-overlays");
        this.domNode.setWidth(1);
        (0, _domFontInfoJs.applyFontInfo)(this.domNode, options.get(50 /* EditorOption.fontInfo */ ));
    }
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        (0, _domFontInfoJs.applyFontInfo)(this.domNode, options.get(50 /* EditorOption.fontInfo */ ));
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._contentLeft = layoutInfo.contentLeft;
        return super.onConfigurationChanged(e) || true;
    }
    onScrollChanged(e) {
        return super.onScrollChanged(e) || e.scrollHeightChanged;
    }
    _viewOverlaysRender(ctx) {
        super._viewOverlaysRender(ctx);
        const height = Math.min(ctx.scrollHeight, 1000000);
        this.domNode.setHeight(height);
        this.domNode.setWidth(this._contentLeft);
    }
}

},{"../../../base/browser/fastDomNode.js":"2SADf","../config/domFontInfo.js":"fQezv","./viewLayer.js":"7v2Ri","./viewPart.js":"kTsLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7v2Ri":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RenderedLinesCollection", ()=>RenderedLinesCollection);
parcelHelpers.export(exports, "VisibleLinesCollection", ()=>VisibleLinesCollection);
var _fastDomNodeJs = require("../../../base/browser/fastDomNode.js");
var _trustedTypesJs = require("../../../base/browser/trustedTypes.js");
var _errorsJs = require("../../../base/common/errors.js");
var _stringBuilderJs = require("../../common/core/stringBuilder.js");
class RenderedLinesCollection {
    constructor(_lineFactory){
        this._lineFactory = _lineFactory;
        this._set(1, []);
    }
    flush() {
        this._set(1, []);
    }
    _set(rendLineNumberStart, lines) {
        this._lines = lines;
        this._rendLineNumberStart = rendLineNumberStart;
    }
    _get() {
        return {
            rendLineNumberStart: this._rendLineNumberStart,
            lines: this._lines
        };
    }
    /**
     * @returns Inclusive line number that is inside this collection
     */ getStartLineNumber() {
        return this._rendLineNumberStart;
    }
    /**
     * @returns Inclusive line number that is inside this collection
     */ getEndLineNumber() {
        return this._rendLineNumberStart + this._lines.length - 1;
    }
    getCount() {
        return this._lines.length;
    }
    getLine(lineNumber) {
        const lineIndex = lineNumber - this._rendLineNumberStart;
        if (lineIndex < 0 || lineIndex >= this._lines.length) throw new (0, _errorsJs.BugIndicatingError)("Illegal value for lineNumber");
        return this._lines[lineIndex];
    }
    /**
     * @returns Lines that were removed from this collection
     */ onLinesDeleted(deleteFromLineNumber, deleteToLineNumber) {
        if (this.getCount() === 0) // no lines
        return null;
        const startLineNumber = this.getStartLineNumber();
        const endLineNumber = this.getEndLineNumber();
        if (deleteToLineNumber < startLineNumber) {
            // deleting above the viewport
            const deleteCnt = deleteToLineNumber - deleteFromLineNumber + 1;
            this._rendLineNumberStart -= deleteCnt;
            return null;
        }
        if (deleteFromLineNumber > endLineNumber) // deleted below the viewport
        return null;
        // Record what needs to be deleted
        let deleteStartIndex = 0;
        let deleteCount = 0;
        for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++){
            const lineIndex = lineNumber - this._rendLineNumberStart;
            if (deleteFromLineNumber <= lineNumber && lineNumber <= deleteToLineNumber) {
                // this is a line to be deleted
                if (deleteCount === 0) {
                    // this is the first line to be deleted
                    deleteStartIndex = lineIndex;
                    deleteCount = 1;
                } else deleteCount++;
            }
        }
        // Adjust this._rendLineNumberStart for lines deleted above
        if (deleteFromLineNumber < startLineNumber) {
            // Something was deleted above
            let deleteAboveCount = 0;
            if (deleteToLineNumber < startLineNumber) // the entire deleted lines are above
            deleteAboveCount = deleteToLineNumber - deleteFromLineNumber + 1;
            else deleteAboveCount = startLineNumber - deleteFromLineNumber;
            this._rendLineNumberStart -= deleteAboveCount;
        }
        const deleted = this._lines.splice(deleteStartIndex, deleteCount);
        return deleted;
    }
    onLinesChanged(changeFromLineNumber, changeCount) {
        const changeToLineNumber = changeFromLineNumber + changeCount - 1;
        if (this.getCount() === 0) // no lines
        return false;
        const startLineNumber = this.getStartLineNumber();
        const endLineNumber = this.getEndLineNumber();
        let someoneNotified = false;
        for(let changedLineNumber = changeFromLineNumber; changedLineNumber <= changeToLineNumber; changedLineNumber++)if (changedLineNumber >= startLineNumber && changedLineNumber <= endLineNumber) {
            // Notify the line
            this._lines[changedLineNumber - this._rendLineNumberStart].onContentChanged();
            someoneNotified = true;
        }
        return someoneNotified;
    }
    onLinesInserted(insertFromLineNumber, insertToLineNumber) {
        if (this.getCount() === 0) // no lines
        return null;
        const insertCnt = insertToLineNumber - insertFromLineNumber + 1;
        const startLineNumber = this.getStartLineNumber();
        const endLineNumber = this.getEndLineNumber();
        if (insertFromLineNumber <= startLineNumber) {
            // inserting above the viewport
            this._rendLineNumberStart += insertCnt;
            return null;
        }
        if (insertFromLineNumber > endLineNumber) // inserting below the viewport
        return null;
        if (insertCnt + insertFromLineNumber > endLineNumber) {
            // insert inside the viewport in such a way that all remaining lines are pushed outside
            const deleted = this._lines.splice(insertFromLineNumber - this._rendLineNumberStart, endLineNumber - insertFromLineNumber + 1);
            return deleted;
        }
        // insert inside the viewport, push out some lines, but not all remaining lines
        const newLines = [];
        for(let i = 0; i < insertCnt; i++)newLines[i] = this._lineFactory.createLine();
        const insertIndex = insertFromLineNumber - this._rendLineNumberStart;
        const beforeLines = this._lines.slice(0, insertIndex);
        const afterLines = this._lines.slice(insertIndex, this._lines.length - insertCnt);
        const deletedLines = this._lines.slice(this._lines.length - insertCnt, this._lines.length);
        this._lines = beforeLines.concat(newLines).concat(afterLines);
        return deletedLines;
    }
    onTokensChanged(ranges) {
        if (this.getCount() === 0) // no lines
        return false;
        const startLineNumber = this.getStartLineNumber();
        const endLineNumber = this.getEndLineNumber();
        let notifiedSomeone = false;
        for(let i = 0, len = ranges.length; i < len; i++){
            const rng = ranges[i];
            if (rng.toLineNumber < startLineNumber || rng.fromLineNumber > endLineNumber) continue;
            const from = Math.max(startLineNumber, rng.fromLineNumber);
            const to = Math.min(endLineNumber, rng.toLineNumber);
            for(let lineNumber = from; lineNumber <= to; lineNumber++){
                const lineIndex = lineNumber - this._rendLineNumberStart;
                this._lines[lineIndex].onTokensChanged();
                notifiedSomeone = true;
            }
        }
        return notifiedSomeone;
    }
}
class VisibleLinesCollection {
    constructor(_lineFactory){
        this._lineFactory = _lineFactory;
        this.domNode = this._createDomNode();
        this._linesCollection = new RenderedLinesCollection(this._lineFactory);
    }
    _createDomNode() {
        const domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        domNode.setClassName("view-layer");
        domNode.setPosition("absolute");
        domNode.domNode.setAttribute("role", "presentation");
        domNode.domNode.setAttribute("aria-hidden", "true");
        return domNode;
    }
    // ---- begin view event handlers
    onConfigurationChanged(e) {
        if (e.hasChanged(146 /* EditorOption.layoutInfo */ )) return true;
        return false;
    }
    onFlushed(e) {
        this._linesCollection.flush();
        // No need to clear the dom node because a full .innerHTML will occur in ViewLayerRenderer._render
        return true;
    }
    onLinesChanged(e) {
        return this._linesCollection.onLinesChanged(e.fromLineNumber, e.count);
    }
    onLinesDeleted(e) {
        const deleted = this._linesCollection.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
        if (deleted) // Remove from DOM
        for(let i = 0, len = deleted.length; i < len; i++){
            const lineDomNode = deleted[i].getDomNode();
            lineDomNode?.remove();
        }
        return true;
    }
    onLinesInserted(e) {
        const deleted = this._linesCollection.onLinesInserted(e.fromLineNumber, e.toLineNumber);
        if (deleted) // Remove from DOM
        for(let i = 0, len = deleted.length; i < len; i++){
            const lineDomNode = deleted[i].getDomNode();
            lineDomNode?.remove();
        }
        return true;
    }
    onScrollChanged(e) {
        return e.scrollTopChanged;
    }
    onTokensChanged(e) {
        return this._linesCollection.onTokensChanged(e.ranges);
    }
    onZonesChanged(e) {
        return true;
    }
    // ---- end view event handlers
    getStartLineNumber() {
        return this._linesCollection.getStartLineNumber();
    }
    getEndLineNumber() {
        return this._linesCollection.getEndLineNumber();
    }
    getVisibleLine(lineNumber) {
        return this._linesCollection.getLine(lineNumber);
    }
    renderLines(viewportData) {
        const inp = this._linesCollection._get();
        const renderer = new ViewLayerRenderer(this.domNode.domNode, this._lineFactory, viewportData);
        const ctx = {
            rendLineNumberStart: inp.rendLineNumberStart,
            lines: inp.lines,
            linesLength: inp.lines.length
        };
        // Decide if this render will do a single update (single large .innerHTML) or many updates (inserting/removing dom nodes)
        const resCtx = renderer.render(ctx, viewportData.startLineNumber, viewportData.endLineNumber, viewportData.relativeVerticalOffset);
        this._linesCollection._set(resCtx.rendLineNumberStart, resCtx.lines);
    }
}
class ViewLayerRenderer {
    static{
        this._ttPolicy = (0, _trustedTypesJs.createTrustedTypesPolicy)("editorViewLayer", {
            createHTML: (value)=>value
        });
    }
    constructor(_domNode, _lineFactory, _viewportData){
        this._domNode = _domNode;
        this._lineFactory = _lineFactory;
        this._viewportData = _viewportData;
    }
    render(inContext, startLineNumber, stopLineNumber, deltaTop) {
        const ctx = {
            rendLineNumberStart: inContext.rendLineNumberStart,
            lines: inContext.lines.slice(0),
            linesLength: inContext.linesLength
        };
        if (ctx.rendLineNumberStart + ctx.linesLength - 1 < startLineNumber || stopLineNumber < ctx.rendLineNumberStart) {
            // There is no overlap whatsoever
            ctx.rendLineNumberStart = startLineNumber;
            ctx.linesLength = stopLineNumber - startLineNumber + 1;
            ctx.lines = [];
            for(let x = startLineNumber; x <= stopLineNumber; x++)ctx.lines[x - startLineNumber] = this._lineFactory.createLine();
            this._finishRendering(ctx, true, deltaTop);
            return ctx;
        }
        // Update lines which will remain untouched
        this._renderUntouchedLines(ctx, Math.max(startLineNumber - ctx.rendLineNumberStart, 0), Math.min(stopLineNumber - ctx.rendLineNumberStart, ctx.linesLength - 1), deltaTop, startLineNumber);
        if (ctx.rendLineNumberStart > startLineNumber) {
            // Insert lines before
            const fromLineNumber = startLineNumber;
            const toLineNumber = Math.min(stopLineNumber, ctx.rendLineNumberStart - 1);
            if (fromLineNumber <= toLineNumber) {
                this._insertLinesBefore(ctx, fromLineNumber, toLineNumber, deltaTop, startLineNumber);
                ctx.linesLength += toLineNumber - fromLineNumber + 1;
            }
        } else if (ctx.rendLineNumberStart < startLineNumber) {
            // Remove lines before
            const removeCnt = Math.min(ctx.linesLength, startLineNumber - ctx.rendLineNumberStart);
            if (removeCnt > 0) {
                this._removeLinesBefore(ctx, removeCnt);
                ctx.linesLength -= removeCnt;
            }
        }
        ctx.rendLineNumberStart = startLineNumber;
        if (ctx.rendLineNumberStart + ctx.linesLength - 1 < stopLineNumber) {
            // Insert lines after
            const fromLineNumber = ctx.rendLineNumberStart + ctx.linesLength;
            const toLineNumber = stopLineNumber;
            if (fromLineNumber <= toLineNumber) {
                this._insertLinesAfter(ctx, fromLineNumber, toLineNumber, deltaTop, startLineNumber);
                ctx.linesLength += toLineNumber - fromLineNumber + 1;
            }
        } else if (ctx.rendLineNumberStart + ctx.linesLength - 1 > stopLineNumber) {
            // Remove lines after
            const fromLineNumber = Math.max(0, stopLineNumber - ctx.rendLineNumberStart + 1);
            const toLineNumber = ctx.linesLength - 1;
            const removeCnt = toLineNumber - fromLineNumber + 1;
            if (removeCnt > 0) {
                this._removeLinesAfter(ctx, removeCnt);
                ctx.linesLength -= removeCnt;
            }
        }
        this._finishRendering(ctx, false, deltaTop);
        return ctx;
    }
    _renderUntouchedLines(ctx, startIndex, endIndex, deltaTop, deltaLN) {
        const rendLineNumberStart = ctx.rendLineNumberStart;
        const lines = ctx.lines;
        for(let i = startIndex; i <= endIndex; i++){
            const lineNumber = rendLineNumberStart + i;
            lines[i].layoutLine(lineNumber, deltaTop[lineNumber - deltaLN], this._viewportData.lineHeight);
        }
    }
    _insertLinesBefore(ctx, fromLineNumber, toLineNumber, deltaTop, deltaLN) {
        const newLines = [];
        let newLinesLen = 0;
        for(let lineNumber = fromLineNumber; lineNumber <= toLineNumber; lineNumber++)newLines[newLinesLen++] = this._lineFactory.createLine();
        ctx.lines = newLines.concat(ctx.lines);
    }
    _removeLinesBefore(ctx, removeCount) {
        for(let i = 0; i < removeCount; i++){
            const lineDomNode = ctx.lines[i].getDomNode();
            lineDomNode?.remove();
        }
        ctx.lines.splice(0, removeCount);
    }
    _insertLinesAfter(ctx, fromLineNumber, toLineNumber, deltaTop, deltaLN) {
        const newLines = [];
        let newLinesLen = 0;
        for(let lineNumber = fromLineNumber; lineNumber <= toLineNumber; lineNumber++)newLines[newLinesLen++] = this._lineFactory.createLine();
        ctx.lines = ctx.lines.concat(newLines);
    }
    _removeLinesAfter(ctx, removeCount) {
        const removeIndex = ctx.linesLength - removeCount;
        for(let i = 0; i < removeCount; i++){
            const lineDomNode = ctx.lines[removeIndex + i].getDomNode();
            lineDomNode?.remove();
        }
        ctx.lines.splice(removeIndex, removeCount);
    }
    _finishRenderingNewLines(ctx, domNodeIsEmpty, newLinesHTML, wasNew) {
        if (ViewLayerRenderer._ttPolicy) newLinesHTML = ViewLayerRenderer._ttPolicy.createHTML(newLinesHTML);
        const lastChild = this._domNode.lastChild;
        if (domNodeIsEmpty || !lastChild) this._domNode.innerHTML = newLinesHTML; // explains the ugly casts -> https://github.com/microsoft/vscode/issues/106396#issuecomment-692625393;
        else lastChild.insertAdjacentHTML("afterend", newLinesHTML);
        let currChild = this._domNode.lastChild;
        for(let i = ctx.linesLength - 1; i >= 0; i--){
            const line = ctx.lines[i];
            if (wasNew[i]) {
                line.setDomNode(currChild);
                currChild = currChild.previousSibling;
            }
        }
    }
    _finishRenderingInvalidLines(ctx, invalidLinesHTML, wasInvalid) {
        const hugeDomNode = document.createElement("div");
        if (ViewLayerRenderer._ttPolicy) invalidLinesHTML = ViewLayerRenderer._ttPolicy.createHTML(invalidLinesHTML);
        hugeDomNode.innerHTML = invalidLinesHTML;
        for(let i = 0; i < ctx.linesLength; i++){
            const line = ctx.lines[i];
            if (wasInvalid[i]) {
                const source = hugeDomNode.firstChild;
                const lineDomNode = line.getDomNode();
                lineDomNode.parentNode.replaceChild(source, lineDomNode);
                line.setDomNode(source);
            }
        }
    }
    static{
        this._sb = new (0, _stringBuilderJs.StringBuilder)(100000);
    }
    _finishRendering(ctx, domNodeIsEmpty, deltaTop) {
        const sb = ViewLayerRenderer._sb;
        const linesLength = ctx.linesLength;
        const lines = ctx.lines;
        const rendLineNumberStart = ctx.rendLineNumberStart;
        const wasNew = [];
        {
            sb.reset();
            let hadNewLine = false;
            for(let i = 0; i < linesLength; i++){
                const line = lines[i];
                wasNew[i] = false;
                const lineDomNode = line.getDomNode();
                if (lineDomNode) continue;
                const renderResult = line.renderLine(i + rendLineNumberStart, deltaTop[i], this._viewportData.lineHeight, this._viewportData, sb);
                if (!renderResult) continue;
                wasNew[i] = true;
                hadNewLine = true;
            }
            if (hadNewLine) this._finishRenderingNewLines(ctx, domNodeIsEmpty, sb.build(), wasNew);
        }
        {
            sb.reset();
            let hadInvalidLine = false;
            const wasInvalid = [];
            for(let i = 0; i < linesLength; i++){
                const line = lines[i];
                wasInvalid[i] = false;
                if (wasNew[i]) continue;
                const renderResult = line.renderLine(i + rendLineNumberStart, deltaTop[i], this._viewportData.lineHeight, this._viewportData, sb);
                if (!renderResult) continue;
                wasInvalid[i] = true;
                hadInvalidLine = true;
            }
            if (hadInvalidLine) this._finishRenderingInvalidLines(ctx, sb.build(), wasInvalid);
        }
    }
}

},{"../../../base/browser/fastDomNode.js":"2SADf","../../../base/browser/trustedTypes.js":"bgQyv","../../../base/common/errors.js":"divX8","../../common/core/stringBuilder.js":"hHgWQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hueuV":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewUserInputEvents", ()=>ViewUserInputEvents);
var _positionJs = require("../../common/core/position.js");
class ViewUserInputEvents {
    constructor(coordinatesConverter){
        this.onKeyDown = null;
        this.onKeyUp = null;
        this.onContextMenu = null;
        this.onMouseMove = null;
        this.onMouseLeave = null;
        this.onMouseDown = null;
        this.onMouseUp = null;
        this.onMouseDrag = null;
        this.onMouseDrop = null;
        this.onMouseDropCanceled = null;
        this.onMouseWheel = null;
        this._coordinatesConverter = coordinatesConverter;
    }
    emitKeyDown(e) {
        this.onKeyDown?.(e);
    }
    emitKeyUp(e) {
        this.onKeyUp?.(e);
    }
    emitContextMenu(e) {
        this.onContextMenu?.(this._convertViewToModelMouseEvent(e));
    }
    emitMouseMove(e) {
        this.onMouseMove?.(this._convertViewToModelMouseEvent(e));
    }
    emitMouseLeave(e) {
        this.onMouseLeave?.(this._convertViewToModelMouseEvent(e));
    }
    emitMouseDown(e) {
        this.onMouseDown?.(this._convertViewToModelMouseEvent(e));
    }
    emitMouseUp(e) {
        this.onMouseUp?.(this._convertViewToModelMouseEvent(e));
    }
    emitMouseDrag(e) {
        this.onMouseDrag?.(this._convertViewToModelMouseEvent(e));
    }
    emitMouseDrop(e) {
        this.onMouseDrop?.(this._convertViewToModelMouseEvent(e));
    }
    emitMouseDropCanceled() {
        this.onMouseDropCanceled?.();
    }
    emitMouseWheel(e) {
        this.onMouseWheel?.(e);
    }
    _convertViewToModelMouseEvent(e) {
        if (e.target) return {
            event: e.event,
            target: this._convertViewToModelMouseTarget(e.target)
        };
        return e;
    }
    _convertViewToModelMouseTarget(target) {
        return ViewUserInputEvents.convertViewToModelMouseTarget(target, this._coordinatesConverter);
    }
    static convertViewToModelMouseTarget(target, coordinatesConverter) {
        const result = {
            ...target
        };
        if (result.position) result.position = coordinatesConverter.convertViewPositionToModelPosition(result.position);
        if (result.range) result.range = coordinatesConverter.convertViewRangeToModelRange(result.range);
        if (result.type === 5 /* MouseTargetType.GUTTER_VIEW_ZONE */  || result.type === 8 /* MouseTargetType.CONTENT_VIEW_ZONE */ ) result.detail = this.convertViewToModelViewZoneData(result.detail, coordinatesConverter);
        return result;
    }
    static convertViewToModelViewZoneData(data, coordinatesConverter) {
        return {
            viewZoneId: data.viewZoneId,
            positionBefore: data.positionBefore ? coordinatesConverter.convertViewPositionToModelPosition(data.positionBefore) : data.positionBefore,
            positionAfter: data.positionAfter ? coordinatesConverter.convertViewPositionToModelPosition(data.positionAfter) : data.positionAfter,
            position: coordinatesConverter.convertViewPositionToModelPosition(data.position),
            afterLineNumber: coordinatesConverter.convertViewPositionToModelPosition(new (0, _positionJs.Position)(data.afterLineNumber, 1)).lineNumber
        };
    }
}

},{"../../common/core/position.js":"lvrPe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3uTRE":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockDecorations", ()=>BlockDecorations);
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _blockDecorationsCss = require("./blockDecorations.css");
var _viewPartJs = require("../../view/viewPart.js");
class BlockDecorations extends (0, _viewPartJs.ViewPart) {
    constructor(context){
        super(context);
        this.blocks = [];
        this.contentWidth = -1;
        this.contentLeft = 0;
        this.domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this.domNode.setAttribute("role", "presentation");
        this.domNode.setAttribute("aria-hidden", "true");
        this.domNode.setClassName("blockDecorations-container");
        this.update();
    }
    update() {
        let didChange = false;
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        const newContentWidth = layoutInfo.contentWidth - layoutInfo.verticalScrollbarWidth;
        if (this.contentWidth !== newContentWidth) {
            this.contentWidth = newContentWidth;
            didChange = true;
        }
        const newContentLeft = layoutInfo.contentLeft;
        if (this.contentLeft !== newContentLeft) {
            this.contentLeft = newContentLeft;
            didChange = true;
        }
        return didChange;
    }
    dispose() {
        super.dispose();
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        return this.update();
    }
    onScrollChanged(e) {
        return e.scrollTopChanged || e.scrollLeftChanged;
    }
    onDecorationsChanged(e) {
        return true;
    }
    onZonesChanged(e) {
        return true;
    }
    // --- end event handlers
    prepareRender(ctx) {
    // Nothing to read
    }
    render(ctx) {
        let count = 0;
        const decorations = ctx.getDecorationsInViewport();
        for (const decoration of decorations){
            if (!decoration.options.blockClassName) continue;
            let block = this.blocks[count];
            if (!block) {
                block = this.blocks[count] = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
                this.domNode.appendChild(block);
            }
            let top;
            let bottom;
            if (decoration.options.blockIsAfterEnd) {
                // range must be empty
                top = ctx.getVerticalOffsetAfterLineNumber(decoration.range.endLineNumber, false);
                bottom = ctx.getVerticalOffsetAfterLineNumber(decoration.range.endLineNumber, true);
            } else {
                top = ctx.getVerticalOffsetForLineNumber(decoration.range.startLineNumber, true);
                bottom = decoration.range.isEmpty() && !decoration.options.blockDoesNotCollapse ? ctx.getVerticalOffsetForLineNumber(decoration.range.startLineNumber, false) : ctx.getVerticalOffsetAfterLineNumber(decoration.range.endLineNumber, true);
            }
            const [paddingTop, paddingRight, paddingBottom, paddingLeft] = decoration.options.blockPadding ?? [
                0,
                0,
                0,
                0
            ];
            block.setClassName("blockDecorations-block " + decoration.options.blockClassName);
            block.setLeft(this.contentLeft - paddingLeft);
            block.setWidth(this.contentWidth + paddingLeft + paddingRight);
            block.setTop(top - ctx.scrollTop - paddingTop);
            block.setHeight(bottom - top + paddingTop + paddingBottom);
            count++;
        }
        for(let i = count; i < this.blocks.length; i++)this.blocks[i].domNode.remove();
        this.blocks.length = count;
    }
}

},{"../../../../base/browser/fastDomNode.js":"2SADf","./blockDecorations.css":"7jfHX","../../view/viewPart.js":"kTsLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7jfHX":[function() {},{}],"40rVu":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewContentWidgets", ()=>ViewContentWidgets);
var _domJs = require("../../../../base/browser/dom.js");
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _viewPartJs = require("../../view/viewPart.js");
class ViewContentWidgets extends (0, _viewPartJs.ViewPart) {
    constructor(context, viewDomNode){
        super(context);
        this._viewDomNode = viewDomNode;
        this._widgets = {};
        this.domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        (0, _viewPartJs.PartFingerprints).write(this.domNode, 1 /* PartFingerprint.ContentWidgets */ );
        this.domNode.setClassName("contentWidgets");
        this.domNode.setPosition("absolute");
        this.domNode.setTop(0);
        this.overflowingContentWidgetsDomNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        (0, _viewPartJs.PartFingerprints).write(this.overflowingContentWidgetsDomNode, 2 /* PartFingerprint.OverflowingContentWidgets */ );
        this.overflowingContentWidgetsDomNode.setClassName("overflowingContentWidgets");
    }
    dispose() {
        super.dispose();
        this._widgets = {};
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        const keys = Object.keys(this._widgets);
        for (const widgetId of keys)this._widgets[widgetId].onConfigurationChanged(e);
        return true;
    }
    onDecorationsChanged(e) {
        // true for inline decorations that can end up relayouting text
        return true;
    }
    onFlushed(e) {
        return true;
    }
    onLineMappingChanged(e) {
        this._updateAnchorsViewPositions();
        return true;
    }
    onLinesChanged(e) {
        this._updateAnchorsViewPositions();
        return true;
    }
    onLinesDeleted(e) {
        this._updateAnchorsViewPositions();
        return true;
    }
    onLinesInserted(e) {
        this._updateAnchorsViewPositions();
        return true;
    }
    onScrollChanged(e) {
        return true;
    }
    onZonesChanged(e) {
        return true;
    }
    // ---- end view event handlers
    _updateAnchorsViewPositions() {
        const keys = Object.keys(this._widgets);
        for (const widgetId of keys)this._widgets[widgetId].updateAnchorViewPosition();
    }
    addWidget(_widget) {
        const myWidget = new Widget(this._context, this._viewDomNode, _widget);
        this._widgets[myWidget.id] = myWidget;
        if (myWidget.allowEditorOverflow) this.overflowingContentWidgetsDomNode.appendChild(myWidget.domNode);
        else this.domNode.appendChild(myWidget.domNode);
        this.setShouldRender();
    }
    setWidgetPosition(widget, primaryAnchor, secondaryAnchor, preference, affinity) {
        const myWidget = this._widgets[widget.getId()];
        myWidget.setPosition(primaryAnchor, secondaryAnchor, preference, affinity);
        this.setShouldRender();
    }
    removeWidget(widget) {
        const widgetId = widget.getId();
        if (this._widgets.hasOwnProperty(widgetId)) {
            const myWidget = this._widgets[widgetId];
            delete this._widgets[widgetId];
            const domNode = myWidget.domNode.domNode;
            domNode.remove();
            domNode.removeAttribute("monaco-visible-content-widget");
            this.setShouldRender();
        }
    }
    shouldSuppressMouseDownOnWidget(widgetId) {
        if (this._widgets.hasOwnProperty(widgetId)) return this._widgets[widgetId].suppressMouseDown;
        return false;
    }
    onBeforeRender(viewportData) {
        const keys = Object.keys(this._widgets);
        for (const widgetId of keys)this._widgets[widgetId].onBeforeRender(viewportData);
    }
    prepareRender(ctx) {
        const keys = Object.keys(this._widgets);
        for (const widgetId of keys)this._widgets[widgetId].prepareRender(ctx);
    }
    render(ctx) {
        const keys = Object.keys(this._widgets);
        for (const widgetId of keys)this._widgets[widgetId].render(ctx);
    }
}
class Widget {
    constructor(context, viewDomNode, actual){
        this._primaryAnchor = new PositionPair(null, null);
        this._secondaryAnchor = new PositionPair(null, null);
        this._context = context;
        this._viewDomNode = viewDomNode;
        this._actual = actual;
        this.domNode = (0, _fastDomNodeJs.createFastDomNode)(this._actual.getDomNode());
        this.id = this._actual.getId();
        this.allowEditorOverflow = this._actual.allowEditorOverflow || false;
        this.suppressMouseDown = this._actual.suppressMouseDown || false;
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._fixedOverflowWidgets = options.get(42 /* EditorOption.fixedOverflowWidgets */ );
        this._contentWidth = layoutInfo.contentWidth;
        this._contentLeft = layoutInfo.contentLeft;
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this._affinity = null;
        this._preference = [];
        this._cachedDomNodeOffsetWidth = -1;
        this._cachedDomNodeOffsetHeight = -1;
        this._maxWidth = this._getMaxWidth();
        this._isVisible = false;
        this._renderData = null;
        this.domNode.setPosition(this._fixedOverflowWidgets && this.allowEditorOverflow ? "fixed" : "absolute");
        this.domNode.setDisplay("none");
        this.domNode.setVisibility("hidden");
        this.domNode.setAttribute("widgetId", this.id);
        this.domNode.setMaxWidth(this._maxWidth);
    }
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        if (e.hasChanged(146 /* EditorOption.layoutInfo */ )) {
            const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
            this._contentLeft = layoutInfo.contentLeft;
            this._contentWidth = layoutInfo.contentWidth;
            this._maxWidth = this._getMaxWidth();
        }
    }
    updateAnchorViewPosition() {
        this._setPosition(this._affinity, this._primaryAnchor.modelPosition, this._secondaryAnchor.modelPosition);
    }
    _setPosition(affinity, primaryAnchor, secondaryAnchor) {
        this._affinity = affinity;
        this._primaryAnchor = getValidPositionPair(primaryAnchor, this._context.viewModel, this._affinity);
        this._secondaryAnchor = getValidPositionPair(secondaryAnchor, this._context.viewModel, this._affinity);
        function getValidPositionPair(position, viewModel, affinity) {
            if (!position) return new PositionPair(null, null);
            // Do not trust that widgets give a valid position
            const validModelPosition = viewModel.model.validatePosition(position);
            if (viewModel.coordinatesConverter.modelPositionIsVisible(validModelPosition)) {
                const viewPosition = viewModel.coordinatesConverter.convertModelPositionToViewPosition(validModelPosition, affinity ?? undefined);
                return new PositionPair(position, viewPosition);
            }
            return new PositionPair(position, null);
        }
    }
    _getMaxWidth() {
        const elDocument = this.domNode.domNode.ownerDocument;
        const elWindow = elDocument.defaultView;
        return this.allowEditorOverflow ? elWindow?.innerWidth || elDocument.documentElement.offsetWidth || elDocument.body.offsetWidth : this._contentWidth;
    }
    setPosition(primaryAnchor, secondaryAnchor, preference, affinity) {
        this._setPosition(affinity, primaryAnchor, secondaryAnchor);
        this._preference = preference;
        if (this._primaryAnchor.viewPosition && this._preference && this._preference.length > 0) // this content widget would like to be visible if possible
        // we change it from `display:none` to `display:block` even if it
        // might be outside the viewport such that we can measure its size
        // in `prepareRender`
        this.domNode.setDisplay("block");
        else this.domNode.setDisplay("none");
        this._cachedDomNodeOffsetWidth = -1;
        this._cachedDomNodeOffsetHeight = -1;
    }
    _layoutBoxInViewport(anchor, width, height, ctx) {
        // Our visible box is split horizontally by the current line => 2 boxes
        // a) the box above the line
        const aboveLineTop = anchor.top;
        const heightAvailableAboveLine = aboveLineTop;
        // b) the box under the line
        const underLineTop = anchor.top + anchor.height;
        const heightAvailableUnderLine = ctx.viewportHeight - underLineTop;
        const aboveTop = aboveLineTop - height;
        const fitsAbove = heightAvailableAboveLine >= height;
        const belowTop = underLineTop;
        const fitsBelow = heightAvailableUnderLine >= height;
        // And its left
        let left = anchor.left;
        if (left + width > ctx.scrollLeft + ctx.viewportWidth) left = ctx.scrollLeft + ctx.viewportWidth - width;
        if (left < ctx.scrollLeft) left = ctx.scrollLeft;
        return {
            fitsAbove,
            aboveTop,
            fitsBelow,
            belowTop,
            left
        };
    }
    _layoutHorizontalSegmentInPage(windowSize, domNodePosition, left, width) {
        // Leave some clearance to the left/right
        const LEFT_PADDING = 15;
        const RIGHT_PADDING = 15;
        // Initially, the limits are defined as the dom node limits
        const MIN_LIMIT = Math.max(LEFT_PADDING, domNodePosition.left - width);
        const MAX_LIMIT = Math.min(domNodePosition.left + domNodePosition.width + width, windowSize.width - RIGHT_PADDING);
        const elDocument = this._viewDomNode.domNode.ownerDocument;
        const elWindow = elDocument.defaultView;
        let absoluteLeft = domNodePosition.left + left - (elWindow?.scrollX ?? 0);
        if (absoluteLeft + width > MAX_LIMIT) {
            const delta = absoluteLeft - (MAX_LIMIT - width);
            absoluteLeft -= delta;
            left -= delta;
        }
        if (absoluteLeft < MIN_LIMIT) {
            const delta = absoluteLeft - MIN_LIMIT;
            absoluteLeft -= delta;
            left -= delta;
        }
        return [
            left,
            absoluteLeft
        ];
    }
    _layoutBoxInPage(anchor, width, height, ctx) {
        const aboveTop = anchor.top - height;
        const belowTop = anchor.top + anchor.height;
        const domNodePosition = _domJs.getDomNodePagePosition(this._viewDomNode.domNode);
        const elDocument = this._viewDomNode.domNode.ownerDocument;
        const elWindow = elDocument.defaultView;
        const absoluteAboveTop = domNodePosition.top + aboveTop - (elWindow?.scrollY ?? 0);
        const absoluteBelowTop = domNodePosition.top + belowTop - (elWindow?.scrollY ?? 0);
        const windowSize = _domJs.getClientArea(elDocument.body);
        const [left, absoluteAboveLeft] = this._layoutHorizontalSegmentInPage(windowSize, domNodePosition, anchor.left - ctx.scrollLeft + this._contentLeft, width);
        // Leave some clearance to the top/bottom
        const TOP_PADDING = 22;
        const BOTTOM_PADDING = 22;
        const fitsAbove = absoluteAboveTop >= TOP_PADDING;
        const fitsBelow = absoluteBelowTop + height <= windowSize.height - BOTTOM_PADDING;
        if (this._fixedOverflowWidgets) return {
            fitsAbove,
            aboveTop: Math.max(absoluteAboveTop, TOP_PADDING),
            fitsBelow,
            belowTop: absoluteBelowTop,
            left: absoluteAboveLeft
        };
        return {
            fitsAbove,
            aboveTop,
            fitsBelow,
            belowTop,
            left
        };
    }
    _prepareRenderWidgetAtExactPositionOverflowing(topLeft) {
        return new Coordinate(topLeft.top, topLeft.left + this._contentLeft);
    }
    /**
     * Compute the coordinates above and below the primary and secondary anchors.
     * The content widget *must* touch the primary anchor.
     * The content widget should touch if possible the secondary anchor.
     */ _getAnchorsCoordinates(ctx) {
        const primary = getCoordinates(this._primaryAnchor.viewPosition, this._affinity, this._lineHeight);
        const secondaryViewPosition = this._secondaryAnchor.viewPosition?.lineNumber === this._primaryAnchor.viewPosition?.lineNumber ? this._secondaryAnchor.viewPosition : null;
        const secondary = getCoordinates(secondaryViewPosition, this._affinity, this._lineHeight);
        return {
            primary,
            secondary
        };
        function getCoordinates(position, affinity, lineHeight) {
            if (!position) return null;
            const horizontalPosition = ctx.visibleRangeForPosition(position);
            if (!horizontalPosition) return null;
            // Left-align widgets that should appear :before content
            const left = position.column === 1 && affinity === 3 /* PositionAffinity.LeftOfInjectedText */  ? 0 : horizontalPosition.left;
            const top = ctx.getVerticalOffsetForLineNumber(position.lineNumber) - ctx.scrollTop;
            return new AnchorCoordinate(top, left, lineHeight);
        }
    }
    _reduceAnchorCoordinates(primary, secondary, width) {
        if (!secondary) return primary;
        const fontInfo = this._context.configuration.options.get(50 /* EditorOption.fontInfo */ );
        let left = secondary.left;
        if (left < primary.left) left = Math.max(left, primary.left - width + fontInfo.typicalFullwidthCharacterWidth);
        else left = Math.min(left, primary.left + width - fontInfo.typicalFullwidthCharacterWidth);
        return new AnchorCoordinate(primary.top, left, primary.height);
    }
    _prepareRenderWidget(ctx) {
        if (!this._preference || this._preference.length === 0) return null;
        const { primary, secondary } = this._getAnchorsCoordinates(ctx);
        if (!primary) return {
            kind: "offViewport",
            preserveFocus: this.domNode.domNode.contains(this.domNode.domNode.ownerDocument.activeElement)
        };
        if (this._cachedDomNodeOffsetWidth === -1 || this._cachedDomNodeOffsetHeight === -1) {
            let preferredDimensions = null;
            if (typeof this._actual.beforeRender === "function") preferredDimensions = safeInvoke(this._actual.beforeRender, this._actual);
            if (preferredDimensions) {
                this._cachedDomNodeOffsetWidth = preferredDimensions.width;
                this._cachedDomNodeOffsetHeight = preferredDimensions.height;
            } else {
                const domNode = this.domNode.domNode;
                const clientRect = domNode.getBoundingClientRect();
                this._cachedDomNodeOffsetWidth = Math.round(clientRect.width);
                this._cachedDomNodeOffsetHeight = Math.round(clientRect.height);
            }
        }
        const anchor = this._reduceAnchorCoordinates(primary, secondary, this._cachedDomNodeOffsetWidth);
        let placement;
        if (this.allowEditorOverflow) placement = this._layoutBoxInPage(anchor, this._cachedDomNodeOffsetWidth, this._cachedDomNodeOffsetHeight, ctx);
        else placement = this._layoutBoxInViewport(anchor, this._cachedDomNodeOffsetWidth, this._cachedDomNodeOffsetHeight, ctx);
        // Do two passes, first for perfect fit, second picks first option
        for(let pass = 1; pass <= 2; pass++)for (const pref of this._preference){
            // placement
            if (pref === 1 /* ContentWidgetPositionPreference.ABOVE */ ) {
                if (!placement) // Widget outside of viewport
                return null;
                if (pass === 2 || placement.fitsAbove) return {
                    kind: "inViewport",
                    coordinate: new Coordinate(placement.aboveTop, placement.left),
                    position: 1 /* ContentWidgetPositionPreference.ABOVE */ 
                };
            } else if (pref === 2 /* ContentWidgetPositionPreference.BELOW */ ) {
                if (!placement) // Widget outside of viewport
                return null;
                if (pass === 2 || placement.fitsBelow) return {
                    kind: "inViewport",
                    coordinate: new Coordinate(placement.belowTop, placement.left),
                    position: 2 /* ContentWidgetPositionPreference.BELOW */ 
                };
            } else {
                if (this.allowEditorOverflow) return {
                    kind: "inViewport",
                    coordinate: this._prepareRenderWidgetAtExactPositionOverflowing(new Coordinate(anchor.top, anchor.left)),
                    position: 0 /* ContentWidgetPositionPreference.EXACT */ 
                };
                else return {
                    kind: "inViewport",
                    coordinate: new Coordinate(anchor.top, anchor.left),
                    position: 0 /* ContentWidgetPositionPreference.EXACT */ 
                };
            }
        }
        return null;
    }
    /**
     * On this first pass, we ensure that the content widget (if it is in the viewport) has the max width set correctly.
     */ onBeforeRender(viewportData) {
        if (!this._primaryAnchor.viewPosition || !this._preference) return;
        if (this._primaryAnchor.viewPosition.lineNumber < viewportData.startLineNumber || this._primaryAnchor.viewPosition.lineNumber > viewportData.endLineNumber) // Outside of viewport
        return;
        this.domNode.setMaxWidth(this._maxWidth);
    }
    prepareRender(ctx) {
        this._renderData = this._prepareRenderWidget(ctx);
    }
    render(ctx) {
        if (!this._renderData || this._renderData.kind === "offViewport") {
            // This widget should be invisible
            if (this._isVisible) {
                this.domNode.removeAttribute("monaco-visible-content-widget");
                this._isVisible = false;
                if (this._renderData?.kind === "offViewport" && this._renderData.preserveFocus) // widget wants to be shown, but it is outside of the viewport and it
                // has focus which we need to preserve
                this.domNode.setTop(-1000);
                else this.domNode.setVisibility("hidden");
            }
            if (typeof this._actual.afterRender === "function") safeInvoke(this._actual.afterRender, this._actual, null);
            return;
        }
        // This widget should be visible
        if (this.allowEditorOverflow) {
            this.domNode.setTop(this._renderData.coordinate.top);
            this.domNode.setLeft(this._renderData.coordinate.left);
        } else {
            this.domNode.setTop(this._renderData.coordinate.top + ctx.scrollTop - ctx.bigNumbersDelta);
            this.domNode.setLeft(this._renderData.coordinate.left);
        }
        if (!this._isVisible) {
            this.domNode.setVisibility("inherit");
            this.domNode.setAttribute("monaco-visible-content-widget", "true");
            this._isVisible = true;
        }
        if (typeof this._actual.afterRender === "function") safeInvoke(this._actual.afterRender, this._actual, this._renderData.position);
    }
}
class PositionPair {
    constructor(modelPosition, viewPosition){
        this.modelPosition = modelPosition;
        this.viewPosition = viewPosition;
    }
}
class Coordinate {
    constructor(top, left){
        this.top = top;
        this.left = left;
        this._coordinateBrand = undefined;
    }
}
class AnchorCoordinate {
    constructor(top, left, height){
        this.top = top;
        this.left = left;
        this.height = height;
        this._anchorCoordinateBrand = undefined;
    }
}
function safeInvoke(fn, thisArg, ...args) {
    try {
        return fn.call(thisArg, ...args);
    } catch  {
        // ignore
        return null;
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/fastDomNode.js":"2SADf","../../view/viewPart.js":"kTsLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"272PD":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractLineHighlightOverlay", ()=>AbstractLineHighlightOverlay);
parcelHelpers.export(exports, "CurrentLineHighlightOverlay", ()=>CurrentLineHighlightOverlay);
parcelHelpers.export(exports, "CurrentLineMarginHighlightOverlay", ()=>CurrentLineMarginHighlightOverlay);
var _currentLineHighlightCss = require("./currentLineHighlight.css");
var _dynamicViewOverlayJs = require("../../view/dynamicViewOverlay.js");
var _editorColorRegistryJs = require("../../../common/core/editorColorRegistry.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _selectionJs = require("../../../common/core/selection.js");
var _themeJs = require("../../../../platform/theme/common/theme.js");
var _positionJs = require("../../../common/core/position.js");
class AbstractLineHighlightOverlay extends (0, _dynamicViewOverlayJs.DynamicViewOverlay) {
    constructor(context){
        super();
        this._context = context;
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._renderLineHighlight = options.get(97 /* EditorOption.renderLineHighlight */ );
        this._renderLineHighlightOnlyWhenFocus = options.get(98 /* EditorOption.renderLineHighlightOnlyWhenFocus */ );
        this._wordWrap = layoutInfo.isViewportWrapping;
        this._contentLeft = layoutInfo.contentLeft;
        this._contentWidth = layoutInfo.contentWidth;
        this._selectionIsEmpty = true;
        this._focused = false;
        this._cursorLineNumbers = [
            1
        ];
        this._selections = [
            new (0, _selectionJs.Selection)(1, 1, 1, 1)
        ];
        this._renderData = null;
        this._context.addEventHandler(this);
    }
    dispose() {
        this._context.removeEventHandler(this);
        super.dispose();
    }
    _readFromSelections() {
        let hasChanged = false;
        const lineNumbers = new Set();
        for (const selection of this._selections)lineNumbers.add(selection.positionLineNumber);
        const cursorsLineNumbers = Array.from(lineNumbers);
        cursorsLineNumbers.sort((a, b)=>a - b);
        if (!_arraysJs.equals(this._cursorLineNumbers, cursorsLineNumbers)) {
            this._cursorLineNumbers = cursorsLineNumbers;
            hasChanged = true;
        }
        const selectionIsEmpty = this._selections.every((s)=>s.isEmpty());
        if (this._selectionIsEmpty !== selectionIsEmpty) {
            this._selectionIsEmpty = selectionIsEmpty;
            hasChanged = true;
        }
        return hasChanged;
    }
    // --- begin event handlers
    onThemeChanged(e) {
        return this._readFromSelections();
    }
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._renderLineHighlight = options.get(97 /* EditorOption.renderLineHighlight */ );
        this._renderLineHighlightOnlyWhenFocus = options.get(98 /* EditorOption.renderLineHighlightOnlyWhenFocus */ );
        this._wordWrap = layoutInfo.isViewportWrapping;
        this._contentLeft = layoutInfo.contentLeft;
        this._contentWidth = layoutInfo.contentWidth;
        return true;
    }
    onCursorStateChanged(e) {
        this._selections = e.selections;
        return this._readFromSelections();
    }
    onFlushed(e) {
        return true;
    }
    onLinesDeleted(e) {
        return true;
    }
    onLinesInserted(e) {
        return true;
    }
    onScrollChanged(e) {
        return e.scrollWidthChanged || e.scrollTopChanged;
    }
    onZonesChanged(e) {
        return true;
    }
    onFocusChanged(e) {
        if (!this._renderLineHighlightOnlyWhenFocus) return false;
        this._focused = e.isFocused;
        return true;
    }
    // --- end event handlers
    prepareRender(ctx) {
        if (!this._shouldRenderThis()) {
            this._renderData = null;
            return;
        }
        const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        // initialize renderData
        const renderData = [];
        for(let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++){
            const lineIndex = lineNumber - visibleStartLineNumber;
            renderData[lineIndex] = "";
        }
        if (this._wordWrap) {
            // do a first pass to render wrapped lines
            const renderedLineWrapped = this._renderOne(ctx, false);
            for (const cursorLineNumber of this._cursorLineNumbers){
                const coordinatesConverter = this._context.viewModel.coordinatesConverter;
                const modelLineNumber = coordinatesConverter.convertViewPositionToModelPosition(new (0, _positionJs.Position)(cursorLineNumber, 1)).lineNumber;
                const firstViewLineNumber = coordinatesConverter.convertModelPositionToViewPosition(new (0, _positionJs.Position)(modelLineNumber, 1)).lineNumber;
                const lastViewLineNumber = coordinatesConverter.convertModelPositionToViewPosition(new (0, _positionJs.Position)(modelLineNumber, this._context.viewModel.model.getLineMaxColumn(modelLineNumber))).lineNumber;
                const firstLine = Math.max(firstViewLineNumber, visibleStartLineNumber);
                const lastLine = Math.min(lastViewLineNumber, visibleEndLineNumber);
                for(let lineNumber = firstLine; lineNumber <= lastLine; lineNumber++){
                    const lineIndex = lineNumber - visibleStartLineNumber;
                    renderData[lineIndex] = renderedLineWrapped;
                }
            }
        }
        // do a second pass to render exact lines
        const renderedLineExact = this._renderOne(ctx, true);
        for (const cursorLineNumber of this._cursorLineNumbers){
            if (cursorLineNumber < visibleStartLineNumber || cursorLineNumber > visibleEndLineNumber) continue;
            const lineIndex = cursorLineNumber - visibleStartLineNumber;
            renderData[lineIndex] = renderedLineExact;
        }
        this._renderData = renderData;
    }
    render(startLineNumber, lineNumber) {
        if (!this._renderData) return "";
        const lineIndex = lineNumber - startLineNumber;
        if (lineIndex >= this._renderData.length) return "";
        return this._renderData[lineIndex];
    }
    _shouldRenderInMargin() {
        return (this._renderLineHighlight === "gutter" || this._renderLineHighlight === "all") && (!this._renderLineHighlightOnlyWhenFocus || this._focused);
    }
    _shouldRenderInContent() {
        return (this._renderLineHighlight === "line" || this._renderLineHighlight === "all") && this._selectionIsEmpty && (!this._renderLineHighlightOnlyWhenFocus || this._focused);
    }
}
class CurrentLineHighlightOverlay extends AbstractLineHighlightOverlay {
    _renderOne(ctx, exact) {
        const className = "current-line" + (this._shouldRenderInMargin() ? " current-line-both" : "") + (exact ? " current-line-exact" : "");
        return `<div class="${className}" style="width:${Math.max(ctx.scrollWidth, this._contentWidth)}px;"></div>`;
    }
    _shouldRenderThis() {
        return this._shouldRenderInContent();
    }
    _shouldRenderOther() {
        return this._shouldRenderInMargin();
    }
}
class CurrentLineMarginHighlightOverlay extends AbstractLineHighlightOverlay {
    _renderOne(ctx, exact) {
        const className = "current-line" + (this._shouldRenderInMargin() ? " current-line-margin" : "") + (this._shouldRenderOther() ? " current-line-margin-both" : "") + (this._shouldRenderInMargin() && exact ? " current-line-exact-margin" : "");
        return `<div class="${className}" style="width:${this._contentLeft}px"></div>`;
    }
    _shouldRenderThis() {
        return true;
    }
    _shouldRenderOther() {
        return this._shouldRenderInContent();
    }
}
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const lineHighlight = theme.getColor((0, _editorColorRegistryJs.editorLineHighlight));
    if (lineHighlight) {
        collector.addRule(`.monaco-editor .view-overlays .current-line { background-color: ${lineHighlight}; }`);
        collector.addRule(`.monaco-editor .margin-view-overlays .current-line-margin { background-color: ${lineHighlight}; border: none; }`);
    }
    if (!lineHighlight || lineHighlight.isTransparent() || theme.defines((0, _editorColorRegistryJs.editorLineHighlightBorder))) {
        const lineHighlightBorder = theme.getColor((0, _editorColorRegistryJs.editorLineHighlightBorder));
        if (lineHighlightBorder) {
            collector.addRule(`.monaco-editor .view-overlays .current-line-exact { border: 2px solid ${lineHighlightBorder}; }`);
            collector.addRule(`.monaco-editor .margin-view-overlays .current-line-exact-margin { border: 2px solid ${lineHighlightBorder}; }`);
            if ((0, _themeJs.isHighContrast)(theme.type)) {
                collector.addRule(`.monaco-editor .view-overlays .current-line-exact { border-width: 1px; }`);
                collector.addRule(`.monaco-editor .margin-view-overlays .current-line-exact-margin { border-width: 1px; }`);
            }
        }
    }
});

},{"./currentLineHighlight.css":"9aucl","../../view/dynamicViewOverlay.js":"dULHQ","../../../common/core/editorColorRegistry.js":"5XqtL","../../../../base/common/arrays.js":"DECei","../../../../platform/theme/common/themeService.js":"jMkIC","../../../common/core/selection.js":"kcwzU","../../../../platform/theme/common/theme.js":"gh7Zf","../../../common/core/position.js":"lvrPe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9aucl":[function() {},{}],"44Gng":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DecorationsOverlay", ()=>DecorationsOverlay);
var _decorationsCss = require("./decorations.css");
var _dynamicViewOverlayJs = require("../../view/dynamicViewOverlay.js");
var _renderingContextJs = require("../../view/renderingContext.js");
var _rangeJs = require("../../../common/core/range.js");
class DecorationsOverlay extends (0, _dynamicViewOverlayJs.DynamicViewOverlay) {
    constructor(context){
        super();
        this._context = context;
        const options = this._context.configuration.options;
        this._typicalHalfwidthCharacterWidth = options.get(50 /* EditorOption.fontInfo */ ).typicalHalfwidthCharacterWidth;
        this._renderResult = null;
        this._context.addEventHandler(this);
    }
    dispose() {
        this._context.removeEventHandler(this);
        this._renderResult = null;
        super.dispose();
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        this._typicalHalfwidthCharacterWidth = options.get(50 /* EditorOption.fontInfo */ ).typicalHalfwidthCharacterWidth;
        return true;
    }
    onDecorationsChanged(e) {
        return true;
    }
    onFlushed(e) {
        return true;
    }
    onLinesChanged(e) {
        return true;
    }
    onLinesDeleted(e) {
        return true;
    }
    onLinesInserted(e) {
        return true;
    }
    onScrollChanged(e) {
        return e.scrollTopChanged || e.scrollWidthChanged;
    }
    onZonesChanged(e) {
        return true;
    }
    // --- end event handlers
    prepareRender(ctx) {
        const _decorations = ctx.getDecorationsInViewport();
        // Keep only decorations with `className`
        let decorations = [];
        let decorationsLen = 0;
        for(let i = 0, len = _decorations.length; i < len; i++){
            const d = _decorations[i];
            if (d.options.className) decorations[decorationsLen++] = d;
        }
        // Sort decorations for consistent render output
        decorations = decorations.sort((a, b)=>{
            if (a.options.zIndex < b.options.zIndex) return -1;
            if (a.options.zIndex > b.options.zIndex) return 1;
            const aClassName = a.options.className;
            const bClassName = b.options.className;
            if (aClassName < bClassName) return -1;
            if (aClassName > bClassName) return 1;
            return (0, _rangeJs.Range).compareRangesUsingStarts(a.range, b.range);
        });
        const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        const output = [];
        for(let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++){
            const lineIndex = lineNumber - visibleStartLineNumber;
            output[lineIndex] = "";
        }
        // Render first whole line decorations and then regular decorations
        this._renderWholeLineDecorations(ctx, decorations, output);
        this._renderNormalDecorations(ctx, decorations, output);
        this._renderResult = output;
    }
    _renderWholeLineDecorations(ctx, decorations, output) {
        const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        for(let i = 0, lenI = decorations.length; i < lenI; i++){
            const d = decorations[i];
            if (!d.options.isWholeLine) continue;
            const decorationOutput = '<div class="cdr ' + d.options.className + '" style="left:0;width:100%;"></div>';
            const startLineNumber = Math.max(d.range.startLineNumber, visibleStartLineNumber);
            const endLineNumber = Math.min(d.range.endLineNumber, visibleEndLineNumber);
            for(let j = startLineNumber; j <= endLineNumber; j++){
                const lineIndex = j - visibleStartLineNumber;
                output[lineIndex] += decorationOutput;
            }
        }
    }
    _renderNormalDecorations(ctx, decorations, output) {
        const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        let prevClassName = null;
        let prevShowIfCollapsed = false;
        let prevRange = null;
        let prevShouldFillLineOnLineBreak = false;
        for(let i = 0, lenI = decorations.length; i < lenI; i++){
            const d = decorations[i];
            if (d.options.isWholeLine) continue;
            const className = d.options.className;
            const showIfCollapsed = Boolean(d.options.showIfCollapsed);
            let range = d.range;
            if (showIfCollapsed && range.endColumn === 1 && range.endLineNumber !== range.startLineNumber) range = new (0, _rangeJs.Range)(range.startLineNumber, range.startColumn, range.endLineNumber - 1, this._context.viewModel.getLineMaxColumn(range.endLineNumber - 1));
            if (prevClassName === className && prevShowIfCollapsed === showIfCollapsed && (0, _rangeJs.Range).areIntersectingOrTouching(prevRange, range)) {
                // merge into previous decoration
                prevRange = (0, _rangeJs.Range).plusRange(prevRange, range);
                continue;
            }
            // flush previous decoration
            if (prevClassName !== null) this._renderNormalDecoration(ctx, prevRange, prevClassName, prevShouldFillLineOnLineBreak, prevShowIfCollapsed, visibleStartLineNumber, output);
            prevClassName = className;
            prevShowIfCollapsed = showIfCollapsed;
            prevRange = range;
            prevShouldFillLineOnLineBreak = d.options.shouldFillLineOnLineBreak ?? false;
        }
        if (prevClassName !== null) this._renderNormalDecoration(ctx, prevRange, prevClassName, prevShouldFillLineOnLineBreak, prevShowIfCollapsed, visibleStartLineNumber, output);
    }
    _renderNormalDecoration(ctx, range, className, shouldFillLineOnLineBreak, showIfCollapsed, visibleStartLineNumber, output) {
        const linesVisibleRanges = ctx.linesVisibleRangesForRange(range, /*TODO@Alex*/ className === "findMatch");
        if (!linesVisibleRanges) return;
        for(let j = 0, lenJ = linesVisibleRanges.length; j < lenJ; j++){
            const lineVisibleRanges = linesVisibleRanges[j];
            if (lineVisibleRanges.outsideRenderedLine) continue;
            const lineIndex = lineVisibleRanges.lineNumber - visibleStartLineNumber;
            if (showIfCollapsed && lineVisibleRanges.ranges.length === 1) {
                const singleVisibleRange = lineVisibleRanges.ranges[0];
                if (singleVisibleRange.width < this._typicalHalfwidthCharacterWidth) {
                    // collapsed/very small range case => make the decoration visible by expanding its width
                    // expand its size on both sides (both to the left and to the right, keeping it centered)
                    const center = Math.round(singleVisibleRange.left + singleVisibleRange.width / 2);
                    const left = Math.max(0, Math.round(center - this._typicalHalfwidthCharacterWidth / 2));
                    lineVisibleRanges.ranges[0] = new (0, _renderingContextJs.HorizontalRange)(left, this._typicalHalfwidthCharacterWidth);
                }
            }
            for(let k = 0, lenK = lineVisibleRanges.ranges.length; k < lenK; k++){
                const expandToLeft = shouldFillLineOnLineBreak && lineVisibleRanges.continuesOnNextLine && lenK === 1;
                const visibleRange = lineVisibleRanges.ranges[k];
                const decorationOutput = '<div class="cdr ' + className + '" style="left:' + String(visibleRange.left) + "px;width:" + (expandToLeft ? "100%;" : String(visibleRange.width) + "px;") + '"></div>';
                output[lineIndex] += decorationOutput;
            }
        }
    }
    render(startLineNumber, lineNumber) {
        if (!this._renderResult) return "";
        const lineIndex = lineNumber - startLineNumber;
        if (lineIndex < 0 || lineIndex >= this._renderResult.length) return "";
        return this._renderResult[lineIndex];
    }
}

},{"./decorations.css":"lyKeP","../../view/dynamicViewOverlay.js":"dULHQ","../../view/renderingContext.js":"bWoBX","../../../common/core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lyKeP":[function() {},{}],"fBX2x":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorScrollbar", ()=>EditorScrollbar);
var _domJs = require("../../../../base/browser/dom.js");
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _scrollableElementJs = require("../../../../base/browser/ui/scrollbar/scrollableElement.js");
var _viewPartJs = require("../../view/viewPart.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
class EditorScrollbar extends (0, _viewPartJs.ViewPart) {
    constructor(context, linesContent, viewDomNode, overflowGuardDomNode){
        super(context);
        const options = this._context.configuration.options;
        const scrollbar = options.get(104 /* EditorOption.scrollbar */ );
        const mouseWheelScrollSensitivity = options.get(75 /* EditorOption.mouseWheelScrollSensitivity */ );
        const fastScrollSensitivity = options.get(40 /* EditorOption.fastScrollSensitivity */ );
        const scrollPredominantAxis = options.get(107 /* EditorOption.scrollPredominantAxis */ );
        const scrollbarOptions = {
            listenOnDomNode: viewDomNode.domNode,
            className: "editor-scrollable " + (0, _themeServiceJs.getThemeTypeSelector)(context.theme.type),
            useShadows: false,
            lazyRender: true,
            vertical: scrollbar.vertical,
            horizontal: scrollbar.horizontal,
            verticalHasArrows: scrollbar.verticalHasArrows,
            horizontalHasArrows: scrollbar.horizontalHasArrows,
            verticalScrollbarSize: scrollbar.verticalScrollbarSize,
            verticalSliderSize: scrollbar.verticalSliderSize,
            horizontalScrollbarSize: scrollbar.horizontalScrollbarSize,
            horizontalSliderSize: scrollbar.horizontalSliderSize,
            handleMouseWheel: scrollbar.handleMouseWheel,
            alwaysConsumeMouseWheel: scrollbar.alwaysConsumeMouseWheel,
            arrowSize: scrollbar.arrowSize,
            mouseWheelScrollSensitivity: mouseWheelScrollSensitivity,
            fastScrollSensitivity: fastScrollSensitivity,
            scrollPredominantAxis: scrollPredominantAxis,
            scrollByPage: scrollbar.scrollByPage
        };
        this.scrollbar = this._register(new (0, _scrollableElementJs.SmoothScrollableElement)(linesContent.domNode, scrollbarOptions, this._context.viewLayout.getScrollable()));
        (0, _viewPartJs.PartFingerprints).write(this.scrollbar.getDomNode(), 6 /* PartFingerprint.ScrollableElement */ );
        this.scrollbarDomNode = (0, _fastDomNodeJs.createFastDomNode)(this.scrollbar.getDomNode());
        this.scrollbarDomNode.setPosition("absolute");
        this._setLayout();
        // When having a zone widget that calls .focus() on one of its dom elements,
        // the browser will try desperately to reveal that dom node, unexpectedly
        // changing the .scrollTop of this.linesContent
        const onBrowserDesperateReveal = (domNode, lookAtScrollTop, lookAtScrollLeft)=>{
            const newScrollPosition = {};
            if (lookAtScrollTop) {
                const deltaTop = domNode.scrollTop;
                if (deltaTop) {
                    newScrollPosition.scrollTop = this._context.viewLayout.getCurrentScrollTop() + deltaTop;
                    domNode.scrollTop = 0;
                }
            }
            if (lookAtScrollLeft) {
                const deltaLeft = domNode.scrollLeft;
                if (deltaLeft) {
                    newScrollPosition.scrollLeft = this._context.viewLayout.getCurrentScrollLeft() + deltaLeft;
                    domNode.scrollLeft = 0;
                }
            }
            this._context.viewModel.viewLayout.setScrollPosition(newScrollPosition, 1 /* ScrollType.Immediate */ );
        };
        // I've seen this happen both on the view dom node & on the lines content dom node.
        this._register(_domJs.addDisposableListener(viewDomNode.domNode, "scroll", (e)=>onBrowserDesperateReveal(viewDomNode.domNode, true, true)));
        this._register(_domJs.addDisposableListener(linesContent.domNode, "scroll", (e)=>onBrowserDesperateReveal(linesContent.domNode, true, false)));
        this._register(_domJs.addDisposableListener(overflowGuardDomNode.domNode, "scroll", (e)=>onBrowserDesperateReveal(overflowGuardDomNode.domNode, true, false)));
        this._register(_domJs.addDisposableListener(this.scrollbarDomNode.domNode, "scroll", (e)=>onBrowserDesperateReveal(this.scrollbarDomNode.domNode, true, false)));
    }
    dispose() {
        super.dispose();
    }
    _setLayout() {
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this.scrollbarDomNode.setLeft(layoutInfo.contentLeft);
        const minimap = options.get(73 /* EditorOption.minimap */ );
        const side = minimap.side;
        if (side === "right") this.scrollbarDomNode.setWidth(layoutInfo.contentWidth + layoutInfo.minimap.minimapWidth);
        else this.scrollbarDomNode.setWidth(layoutInfo.contentWidth);
        this.scrollbarDomNode.setHeight(layoutInfo.height);
    }
    getOverviewRulerLayoutInfo() {
        return this.scrollbar.getOverviewRulerLayoutInfo();
    }
    getDomNode() {
        return this.scrollbarDomNode;
    }
    delegateVerticalScrollbarPointerDown(browserEvent) {
        this.scrollbar.delegateVerticalScrollbarPointerDown(browserEvent);
    }
    delegateScrollFromMouseWheelEvent(browserEvent) {
        this.scrollbar.delegateScrollFromMouseWheelEvent(browserEvent);
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        if (e.hasChanged(104 /* EditorOption.scrollbar */ ) || e.hasChanged(75 /* EditorOption.mouseWheelScrollSensitivity */ ) || e.hasChanged(40 /* EditorOption.fastScrollSensitivity */ )) {
            const options = this._context.configuration.options;
            const scrollbar = options.get(104 /* EditorOption.scrollbar */ );
            const mouseWheelScrollSensitivity = options.get(75 /* EditorOption.mouseWheelScrollSensitivity */ );
            const fastScrollSensitivity = options.get(40 /* EditorOption.fastScrollSensitivity */ );
            const scrollPredominantAxis = options.get(107 /* EditorOption.scrollPredominantAxis */ );
            const newOpts = {
                vertical: scrollbar.vertical,
                horizontal: scrollbar.horizontal,
                verticalScrollbarSize: scrollbar.verticalScrollbarSize,
                horizontalScrollbarSize: scrollbar.horizontalScrollbarSize,
                scrollByPage: scrollbar.scrollByPage,
                handleMouseWheel: scrollbar.handleMouseWheel,
                mouseWheelScrollSensitivity: mouseWheelScrollSensitivity,
                fastScrollSensitivity: fastScrollSensitivity,
                scrollPredominantAxis: scrollPredominantAxis
            };
            this.scrollbar.updateOptions(newOpts);
        }
        if (e.hasChanged(146 /* EditorOption.layoutInfo */ )) this._setLayout();
        return true;
    }
    onScrollChanged(e) {
        return true;
    }
    onThemeChanged(e) {
        this.scrollbar.updateClassName("editor-scrollable " + (0, _themeServiceJs.getThemeTypeSelector)(this._context.theme.type));
        return true;
    }
    // --- end event handlers
    prepareRender(ctx) {
    // Nothing to do
    }
    render(ctx) {
        this.scrollbar.renderNow();
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/fastDomNode.js":"2SADf","../../../../base/browser/ui/scrollbar/scrollableElement.js":"h1C5l","../../view/viewPart.js":"kTsLR","../../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gKiXe":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a decoration that should be shown along the lines from `startLineNumber` to `endLineNumber`.
 * This can end up producing multiple `LineDecorationToRender`.
 */ parcelHelpers.export(exports, "DecorationToRender", ()=>DecorationToRender);
/**
 * A decoration that should be shown along a line.
 */ parcelHelpers.export(exports, "LineDecorationToRender", ()=>LineDecorationToRender);
/**
 * Decorations to render on a visible line.
 */ parcelHelpers.export(exports, "VisibleLineDecorationsToRender", ()=>VisibleLineDecorationsToRender);
parcelHelpers.export(exports, "DedupOverlay", ()=>DedupOverlay);
parcelHelpers.export(exports, "GlyphMarginWidgets", ()=>GlyphMarginWidgets);
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _glyphMarginCss = require("./glyphMargin.css");
var _dynamicViewOverlayJs = require("../../view/dynamicViewOverlay.js");
var _viewPartJs = require("../../view/viewPart.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _modelJs = require("../../../common/model.js");
class DecorationToRender {
    constructor(startLineNumber, endLineNumber, className, tooltip, zIndex){
        this.startLineNumber = startLineNumber;
        this.endLineNumber = endLineNumber;
        this.className = className;
        this.tooltip = tooltip;
        this._decorationToRenderBrand = undefined;
        this.zIndex = zIndex ?? 0;
    }
}
class LineDecorationToRender {
    constructor(className, zIndex, tooltip){
        this.className = className;
        this.zIndex = zIndex;
        this.tooltip = tooltip;
    }
}
class VisibleLineDecorationsToRender {
    constructor(){
        this.decorations = [];
    }
    add(decoration) {
        this.decorations.push(decoration);
    }
    getDecorations() {
        return this.decorations;
    }
}
class DedupOverlay extends (0, _dynamicViewOverlayJs.DynamicViewOverlay) {
    /**
     * Returns an array with an element for each visible line number.
     */ _render(visibleStartLineNumber, visibleEndLineNumber, decorations) {
        const output = [];
        for(let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++){
            const lineIndex = lineNumber - visibleStartLineNumber;
            output[lineIndex] = new VisibleLineDecorationsToRender();
        }
        if (decorations.length === 0) return output;
        // Sort decorations by className, then by startLineNumber and then by endLineNumber
        decorations.sort((a, b)=>{
            if (a.className === b.className) {
                if (a.startLineNumber === b.startLineNumber) return a.endLineNumber - b.endLineNumber;
                return a.startLineNumber - b.startLineNumber;
            }
            return a.className < b.className ? -1 : 1;
        });
        let prevClassName = null;
        let prevEndLineIndex = 0;
        for(let i = 0, len = decorations.length; i < len; i++){
            const d = decorations[i];
            const className = d.className;
            const zIndex = d.zIndex;
            let startLineIndex = Math.max(d.startLineNumber, visibleStartLineNumber) - visibleStartLineNumber;
            const endLineIndex = Math.min(d.endLineNumber, visibleEndLineNumber) - visibleStartLineNumber;
            if (prevClassName === className) {
                // Here we avoid rendering the same className multiple times on the same line
                startLineIndex = Math.max(prevEndLineIndex + 1, startLineIndex);
                prevEndLineIndex = Math.max(prevEndLineIndex, endLineIndex);
            } else {
                prevClassName = className;
                prevEndLineIndex = endLineIndex;
            }
            for(let i = startLineIndex; i <= prevEndLineIndex; i++)output[i].add(new LineDecorationToRender(className, zIndex, d.tooltip));
        }
        return output;
    }
}
class GlyphMarginWidgets extends (0, _viewPartJs.ViewPart) {
    constructor(context){
        super(context);
        this._widgets = {};
        this._context = context;
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this.domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this.domNode.setClassName("glyph-margin-widgets");
        this.domNode.setPosition("absolute");
        this.domNode.setTop(0);
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this._glyphMargin = options.get(57 /* EditorOption.glyphMargin */ );
        this._glyphMarginLeft = layoutInfo.glyphMarginLeft;
        this._glyphMarginWidth = layoutInfo.glyphMarginWidth;
        this._glyphMarginDecorationLaneCount = layoutInfo.glyphMarginDecorationLaneCount;
        this._managedDomNodes = [];
        this._decorationGlyphsToRender = [];
    }
    dispose() {
        this._managedDomNodes = [];
        this._decorationGlyphsToRender = [];
        this._widgets = {};
        super.dispose();
    }
    getWidgets() {
        return Object.values(this._widgets);
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this._glyphMargin = options.get(57 /* EditorOption.glyphMargin */ );
        this._glyphMarginLeft = layoutInfo.glyphMarginLeft;
        this._glyphMarginWidth = layoutInfo.glyphMarginWidth;
        this._glyphMarginDecorationLaneCount = layoutInfo.glyphMarginDecorationLaneCount;
        return true;
    }
    onDecorationsChanged(e) {
        return true;
    }
    onFlushed(e) {
        return true;
    }
    onLinesChanged(e) {
        return true;
    }
    onLinesDeleted(e) {
        return true;
    }
    onLinesInserted(e) {
        return true;
    }
    onScrollChanged(e) {
        return e.scrollTopChanged;
    }
    onZonesChanged(e) {
        return true;
    }
    // --- end event handlers
    // --- begin widget management
    addWidget(widget) {
        const domNode = (0, _fastDomNodeJs.createFastDomNode)(widget.getDomNode());
        this._widgets[widget.getId()] = {
            widget: widget,
            preference: widget.getPosition(),
            domNode: domNode,
            renderInfo: null
        };
        domNode.setPosition("absolute");
        domNode.setDisplay("none");
        domNode.setAttribute("widgetId", widget.getId());
        this.domNode.appendChild(domNode);
        this.setShouldRender();
    }
    setWidgetPosition(widget, preference) {
        const myWidget = this._widgets[widget.getId()];
        if (myWidget.preference.lane === preference.lane && myWidget.preference.zIndex === preference.zIndex && (0, _rangeJs.Range).equalsRange(myWidget.preference.range, preference.range)) return false;
        myWidget.preference = preference;
        this.setShouldRender();
        return true;
    }
    removeWidget(widget) {
        const widgetId = widget.getId();
        if (this._widgets[widgetId]) {
            const widgetData = this._widgets[widgetId];
            const domNode = widgetData.domNode.domNode;
            delete this._widgets[widgetId];
            domNode.remove();
            this.setShouldRender();
        }
    }
    // --- end widget management
    _collectDecorationBasedGlyphRenderRequest(ctx, requests) {
        const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        const decorations = ctx.getDecorationsInViewport();
        for (const d of decorations){
            const glyphMarginClassName = d.options.glyphMarginClassName;
            if (!glyphMarginClassName) continue;
            const startLineNumber = Math.max(d.range.startLineNumber, visibleStartLineNumber);
            const endLineNumber = Math.min(d.range.endLineNumber, visibleEndLineNumber);
            const lane = d.options.glyphMargin?.position ?? (0, _modelJs.GlyphMarginLane).Center;
            const zIndex = d.options.zIndex ?? 0;
            for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++){
                const modelPosition = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new (0, _positionJs.Position)(lineNumber, 0));
                const laneIndex = this._context.viewModel.glyphLanes.getLanesAtLine(modelPosition.lineNumber).indexOf(lane);
                requests.push(new DecorationBasedGlyphRenderRequest(lineNumber, laneIndex, zIndex, glyphMarginClassName));
            }
        }
    }
    _collectWidgetBasedGlyphRenderRequest(ctx, requests) {
        const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        for (const widget of Object.values(this._widgets)){
            const range = widget.preference.range;
            const { startLineNumber, endLineNumber } = this._context.viewModel.coordinatesConverter.convertModelRangeToViewRange((0, _rangeJs.Range).lift(range));
            if (!startLineNumber || !endLineNumber || endLineNumber < visibleStartLineNumber || startLineNumber > visibleEndLineNumber) continue;
            // The widget is in the viewport, find a good line for it
            const widgetLineNumber = Math.max(startLineNumber, visibleStartLineNumber);
            const modelPosition = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new (0, _positionJs.Position)(widgetLineNumber, 0));
            const laneIndex = this._context.viewModel.glyphLanes.getLanesAtLine(modelPosition.lineNumber).indexOf(widget.preference.lane);
            requests.push(new WidgetBasedGlyphRenderRequest(widgetLineNumber, laneIndex, widget.preference.zIndex, widget));
        }
    }
    _collectSortedGlyphRenderRequests(ctx) {
        const requests = [];
        this._collectDecorationBasedGlyphRenderRequest(ctx, requests);
        this._collectWidgetBasedGlyphRenderRequest(ctx, requests);
        // sort requests by lineNumber ASC, lane  ASC, zIndex DESC, type DESC (widgets first), className ASC
        // don't change this sort unless you understand `prepareRender` below.
        requests.sort((a, b)=>{
            if (a.lineNumber === b.lineNumber) {
                if (a.laneIndex === b.laneIndex) {
                    if (a.zIndex === b.zIndex) {
                        if (b.type === a.type) {
                            if (a.type === 0 /* GlyphRenderRequestType.Decoration */  && b.type === 0 /* GlyphRenderRequestType.Decoration */ ) return a.className < b.className ? -1 : 1;
                            return 0;
                        }
                        return b.type - a.type;
                    }
                    return b.zIndex - a.zIndex;
                }
                return a.laneIndex - b.laneIndex;
            }
            return a.lineNumber - b.lineNumber;
        });
        return requests;
    }
    /**
     * Will store render information in each widget's renderInfo and in `_decorationGlyphsToRender`.
     */ prepareRender(ctx) {
        if (!this._glyphMargin) {
            this._decorationGlyphsToRender = [];
            return;
        }
        for (const widget of Object.values(this._widgets))widget.renderInfo = null;
        const requests = new (0, _arraysJs.ArrayQueue)(this._collectSortedGlyphRenderRequests(ctx));
        const decorationGlyphsToRender = [];
        while(requests.length > 0){
            const first = requests.peek();
            if (!first) break;
            // Requests are sorted by lineNumber and lane, so we read all requests for this particular location
            const requestsAtLocation = requests.takeWhile((el)=>el.lineNumber === first.lineNumber && el.laneIndex === first.laneIndex);
            if (!requestsAtLocation || requestsAtLocation.length === 0) break;
            const winner = requestsAtLocation[0];
            if (winner.type === 0 /* GlyphRenderRequestType.Decoration */ ) {
                // combine all decorations with the same z-index
                const classNames = [];
                // requests are sorted by zIndex, type, and className so we can dedup className by looking at the previous one
                for (const request of requestsAtLocation){
                    if (request.zIndex !== winner.zIndex || request.type !== winner.type) break;
                    if (classNames.length === 0 || classNames[classNames.length - 1] !== request.className) classNames.push(request.className);
                }
                decorationGlyphsToRender.push(winner.accept(classNames.join(" "))); // TODO@joyceerhl Implement overflow for remaining decorations
            } else // widgets cannot be combined
            winner.widget.renderInfo = {
                lineNumber: winner.lineNumber,
                laneIndex: winner.laneIndex
            };
        }
        this._decorationGlyphsToRender = decorationGlyphsToRender;
    }
    render(ctx) {
        if (!this._glyphMargin) {
            for (const widget of Object.values(this._widgets))widget.domNode.setDisplay("none");
            while(this._managedDomNodes.length > 0){
                const domNode = this._managedDomNodes.pop();
                domNode?.domNode.remove();
            }
            return;
        }
        const width = Math.round(this._glyphMarginWidth / this._glyphMarginDecorationLaneCount);
        // Render widgets
        for (const widget of Object.values(this._widgets))if (!widget.renderInfo) // this widget is not visible
        widget.domNode.setDisplay("none");
        else {
            const top = ctx.viewportData.relativeVerticalOffset[widget.renderInfo.lineNumber - ctx.viewportData.startLineNumber];
            const left = this._glyphMarginLeft + widget.renderInfo.laneIndex * this._lineHeight;
            widget.domNode.setDisplay("block");
            widget.domNode.setTop(top);
            widget.domNode.setLeft(left);
            widget.domNode.setWidth(width);
            widget.domNode.setHeight(this._lineHeight);
        }
        // Render decorations, reusing previous dom nodes as possible
        for(let i = 0; i < this._decorationGlyphsToRender.length; i++){
            const dec = this._decorationGlyphsToRender[i];
            const top = ctx.viewportData.relativeVerticalOffset[dec.lineNumber - ctx.viewportData.startLineNumber];
            const left = this._glyphMarginLeft + dec.laneIndex * this._lineHeight;
            let domNode;
            if (i < this._managedDomNodes.length) domNode = this._managedDomNodes[i];
            else {
                domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
                this._managedDomNodes.push(domNode);
                this.domNode.appendChild(domNode);
            }
            domNode.setClassName(`cgmr codicon ` + dec.combinedClassName);
            domNode.setPosition(`absolute`);
            domNode.setTop(top);
            domNode.setLeft(left);
            domNode.setWidth(width);
            domNode.setHeight(this._lineHeight);
        }
        // remove extra dom nodes
        while(this._managedDomNodes.length > this._decorationGlyphsToRender.length){
            const domNode = this._managedDomNodes.pop();
            domNode?.domNode.remove();
        }
    }
}
/**
 * A request to render a decoration in the glyph margin at a certain location.
 */ class DecorationBasedGlyphRenderRequest {
    constructor(lineNumber, laneIndex, zIndex, className){
        this.lineNumber = lineNumber;
        this.laneIndex = laneIndex;
        this.zIndex = zIndex;
        this.className = className;
        this.type = 0 /* GlyphRenderRequestType.Decoration */ ;
    }
    accept(combinedClassName) {
        return new DecorationBasedGlyph(this.lineNumber, this.laneIndex, combinedClassName);
    }
}
/**
 * A request to render a widget in the glyph margin at a certain location.
 */ class WidgetBasedGlyphRenderRequest {
    constructor(lineNumber, laneIndex, zIndex, widget){
        this.lineNumber = lineNumber;
        this.laneIndex = laneIndex;
        this.zIndex = zIndex;
        this.widget = widget;
        this.type = 1 /* GlyphRenderRequestType.Widget */ ;
    }
}
class DecorationBasedGlyph {
    constructor(lineNumber, laneIndex, combinedClassName){
        this.lineNumber = lineNumber;
        this.laneIndex = laneIndex;
        this.combinedClassName = combinedClassName;
    }
}

},{"../../../../base/browser/fastDomNode.js":"2SADf","../../../../base/common/arrays.js":"DECei","./glyphMargin.css":"aYe3C","../../view/dynamicViewOverlay.js":"dULHQ","../../view/viewPart.js":"kTsLR","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/model.js":"1CSIB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aYe3C":[function() {},{}],"lNUuS":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IndentGuidesOverlay", ()=>IndentGuidesOverlay);
var _indentGuidesCss = require("./indentGuides.css");
var _dynamicViewOverlayJs = require("../../view/dynamicViewOverlay.js");
var _editorColorRegistryJs = require("../../../common/core/editorColorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _positionJs = require("../../../common/core/position.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _typesJs = require("../../../../base/common/types.js");
var _guidesTextModelPartJs = require("../../../common/model/guidesTextModelPart.js");
var _textModelGuidesJs = require("../../../common/textModelGuides.js");
class IndentGuidesOverlay extends (0, _dynamicViewOverlayJs.DynamicViewOverlay) {
    constructor(context){
        super();
        this._context = context;
        this._primaryPosition = null;
        const options = this._context.configuration.options;
        const wrappingInfo = options.get(147 /* EditorOption.wrappingInfo */ );
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        this._spaceWidth = fontInfo.spaceWidth;
        this._maxIndentLeft = wrappingInfo.wrappingColumn === -1 ? -1 : wrappingInfo.wrappingColumn * fontInfo.typicalHalfwidthCharacterWidth;
        this._bracketPairGuideOptions = options.get(16 /* EditorOption.guides */ );
        this._renderResult = null;
        this._context.addEventHandler(this);
    }
    dispose() {
        this._context.removeEventHandler(this);
        this._renderResult = null;
        super.dispose();
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        const wrappingInfo = options.get(147 /* EditorOption.wrappingInfo */ );
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        this._spaceWidth = fontInfo.spaceWidth;
        this._maxIndentLeft = wrappingInfo.wrappingColumn === -1 ? -1 : wrappingInfo.wrappingColumn * fontInfo.typicalHalfwidthCharacterWidth;
        this._bracketPairGuideOptions = options.get(16 /* EditorOption.guides */ );
        return true;
    }
    onCursorStateChanged(e) {
        const selection = e.selections[0];
        const newPosition = selection.getPosition();
        if (!this._primaryPosition?.equals(newPosition)) {
            this._primaryPosition = newPosition;
            return true;
        }
        return false;
    }
    onDecorationsChanged(e) {
        // true for inline decorations
        return true;
    }
    onFlushed(e) {
        return true;
    }
    onLinesChanged(e) {
        return true;
    }
    onLinesDeleted(e) {
        return true;
    }
    onLinesInserted(e) {
        return true;
    }
    onScrollChanged(e) {
        return e.scrollTopChanged; // || e.scrollWidthChanged;
    }
    onZonesChanged(e) {
        return true;
    }
    onLanguageConfigurationChanged(e) {
        return true;
    }
    // --- end event handlers
    prepareRender(ctx) {
        if (!this._bracketPairGuideOptions.indentation && this._bracketPairGuideOptions.bracketPairs === false) {
            this._renderResult = null;
            return;
        }
        const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        const scrollWidth = ctx.scrollWidth;
        const activeCursorPosition = this._primaryPosition;
        const indents = this.getGuidesByLine(visibleStartLineNumber, Math.min(visibleEndLineNumber + 1, this._context.viewModel.getLineCount()), activeCursorPosition);
        const output = [];
        for(let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++){
            const lineIndex = lineNumber - visibleStartLineNumber;
            const indent = indents[lineIndex];
            let result = "";
            const leftOffset = ctx.visibleRangeForPosition(new (0, _positionJs.Position)(lineNumber, 1))?.left ?? 0;
            for (const guide of indent){
                const left = guide.column === -1 ? leftOffset + (guide.visibleColumn - 1) * this._spaceWidth : ctx.visibleRangeForPosition(new (0, _positionJs.Position)(lineNumber, guide.column)).left;
                if (left > scrollWidth || this._maxIndentLeft > 0 && left > this._maxIndentLeft) break;
                const className = guide.horizontalLine ? guide.horizontalLine.top ? "horizontal-top" : "horizontal-bottom" : "vertical";
                const width = guide.horizontalLine ? (ctx.visibleRangeForPosition(new (0, _positionJs.Position)(lineNumber, guide.horizontalLine.endColumn))?.left ?? left + this._spaceWidth) - left : this._spaceWidth;
                result += `<div class="core-guide ${guide.className} ${className}" style="left:${left}px;width:${width}px"></div>`;
            }
            output[lineIndex] = result;
        }
        this._renderResult = output;
    }
    getGuidesByLine(visibleStartLineNumber, visibleEndLineNumber, activeCursorPosition) {
        const bracketGuides = this._bracketPairGuideOptions.bracketPairs !== false ? this._context.viewModel.getBracketGuidesInRangeByLine(visibleStartLineNumber, visibleEndLineNumber, activeCursorPosition, {
            highlightActive: this._bracketPairGuideOptions.highlightActiveBracketPair,
            horizontalGuides: this._bracketPairGuideOptions.bracketPairsHorizontal === true ? (0, _textModelGuidesJs.HorizontalGuidesState).Enabled : this._bracketPairGuideOptions.bracketPairsHorizontal === "active" ? (0, _textModelGuidesJs.HorizontalGuidesState).EnabledForActive : (0, _textModelGuidesJs.HorizontalGuidesState).Disabled,
            includeInactive: this._bracketPairGuideOptions.bracketPairs === true
        }) : null;
        const indentGuides = this._bracketPairGuideOptions.indentation ? this._context.viewModel.getLinesIndentGuides(visibleStartLineNumber, visibleEndLineNumber) : null;
        let activeIndentStartLineNumber = 0;
        let activeIndentEndLineNumber = 0;
        let activeIndentLevel = 0;
        if (this._bracketPairGuideOptions.highlightActiveIndentation !== false && activeCursorPosition) {
            const activeIndentInfo = this._context.viewModel.getActiveIndentGuide(activeCursorPosition.lineNumber, visibleStartLineNumber, visibleEndLineNumber);
            activeIndentStartLineNumber = activeIndentInfo.startLineNumber;
            activeIndentEndLineNumber = activeIndentInfo.endLineNumber;
            activeIndentLevel = activeIndentInfo.indent;
        }
        const { indentSize } = this._context.viewModel.model.getOptions();
        const result = [];
        for(let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++){
            const lineGuides = new Array();
            result.push(lineGuides);
            const bracketGuidesInLine = bracketGuides ? bracketGuides[lineNumber - visibleStartLineNumber] : [];
            const bracketGuidesInLineQueue = new (0, _arraysJs.ArrayQueue)(bracketGuidesInLine);
            const indentGuidesInLine = indentGuides ? indentGuides[lineNumber - visibleStartLineNumber] : 0;
            for(let indentLvl = 1; indentLvl <= indentGuidesInLine; indentLvl++){
                const indentGuide = (indentLvl - 1) * indentSize + 1;
                const isActive = // Disable active indent guide if there are bracket guides.
                (this._bracketPairGuideOptions.highlightActiveIndentation === "always" || bracketGuidesInLine.length === 0) && activeIndentStartLineNumber <= lineNumber && lineNumber <= activeIndentEndLineNumber && indentLvl === activeIndentLevel;
                lineGuides.push(...bracketGuidesInLineQueue.takeWhile((g)=>g.visibleColumn < indentGuide) || []);
                const peeked = bracketGuidesInLineQueue.peek();
                if (!peeked || peeked.visibleColumn !== indentGuide || peeked.horizontalLine) lineGuides.push(new (0, _textModelGuidesJs.IndentGuide)(indentGuide, -1, `core-guide-indent lvl-${(indentLvl - 1) % 30}` + (isActive ? " indent-active" : ""), null, -1, -1));
            }
            lineGuides.push(...bracketGuidesInLineQueue.takeWhile((g)=>true) || []);
        }
        return result;
    }
    render(startLineNumber, lineNumber) {
        if (!this._renderResult) return "";
        const lineIndex = lineNumber - startLineNumber;
        if (lineIndex < 0 || lineIndex >= this._renderResult.length) return "";
        return this._renderResult[lineIndex];
    }
}
function transparentToUndefined(color) {
    if (color && color.isTransparent()) return undefined;
    return color;
}
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const colors = [
        {
            bracketColor: (0, _editorColorRegistryJs.editorBracketHighlightingForeground1),
            guideColor: (0, _editorColorRegistryJs.editorBracketPairGuideBackground1),
            guideColorActive: (0, _editorColorRegistryJs.editorBracketPairGuideActiveBackground1)
        },
        {
            bracketColor: (0, _editorColorRegistryJs.editorBracketHighlightingForeground2),
            guideColor: (0, _editorColorRegistryJs.editorBracketPairGuideBackground2),
            guideColorActive: (0, _editorColorRegistryJs.editorBracketPairGuideActiveBackground2)
        },
        {
            bracketColor: (0, _editorColorRegistryJs.editorBracketHighlightingForeground3),
            guideColor: (0, _editorColorRegistryJs.editorBracketPairGuideBackground3),
            guideColorActive: (0, _editorColorRegistryJs.editorBracketPairGuideActiveBackground3)
        },
        {
            bracketColor: (0, _editorColorRegistryJs.editorBracketHighlightingForeground4),
            guideColor: (0, _editorColorRegistryJs.editorBracketPairGuideBackground4),
            guideColorActive: (0, _editorColorRegistryJs.editorBracketPairGuideActiveBackground4)
        },
        {
            bracketColor: (0, _editorColorRegistryJs.editorBracketHighlightingForeground5),
            guideColor: (0, _editorColorRegistryJs.editorBracketPairGuideBackground5),
            guideColorActive: (0, _editorColorRegistryJs.editorBracketPairGuideActiveBackground5)
        },
        {
            bracketColor: (0, _editorColorRegistryJs.editorBracketHighlightingForeground6),
            guideColor: (0, _editorColorRegistryJs.editorBracketPairGuideBackground6),
            guideColorActive: (0, _editorColorRegistryJs.editorBracketPairGuideActiveBackground6)
        }
    ];
    const colorProvider = new (0, _guidesTextModelPartJs.BracketPairGuidesClassNames)();
    const indentColors = [
        {
            indentColor: (0, _editorColorRegistryJs.editorIndentGuide1),
            indentColorActive: (0, _editorColorRegistryJs.editorActiveIndentGuide1)
        },
        {
            indentColor: (0, _editorColorRegistryJs.editorIndentGuide2),
            indentColorActive: (0, _editorColorRegistryJs.editorActiveIndentGuide2)
        },
        {
            indentColor: (0, _editorColorRegistryJs.editorIndentGuide3),
            indentColorActive: (0, _editorColorRegistryJs.editorActiveIndentGuide3)
        },
        {
            indentColor: (0, _editorColorRegistryJs.editorIndentGuide4),
            indentColorActive: (0, _editorColorRegistryJs.editorActiveIndentGuide4)
        },
        {
            indentColor: (0, _editorColorRegistryJs.editorIndentGuide5),
            indentColorActive: (0, _editorColorRegistryJs.editorActiveIndentGuide5)
        },
        {
            indentColor: (0, _editorColorRegistryJs.editorIndentGuide6),
            indentColorActive: (0, _editorColorRegistryJs.editorActiveIndentGuide6)
        }
    ];
    const colorValues = colors.map((c)=>{
        const bracketColor = theme.getColor(c.bracketColor);
        const guideColor = theme.getColor(c.guideColor);
        const guideColorActive = theme.getColor(c.guideColorActive);
        const effectiveGuideColor = transparentToUndefined(transparentToUndefined(guideColor) ?? bracketColor?.transparent(0.3));
        const effectiveGuideColorActive = transparentToUndefined(transparentToUndefined(guideColorActive) ?? bracketColor);
        if (!effectiveGuideColor || !effectiveGuideColorActive) return undefined;
        return {
            guideColor: effectiveGuideColor,
            guideColorActive: effectiveGuideColorActive
        };
    }).filter((0, _typesJs.isDefined));
    const indentColorValues = indentColors.map((c)=>{
        const indentColor = theme.getColor(c.indentColor);
        const indentColorActive = theme.getColor(c.indentColorActive);
        const effectiveIndentColor = transparentToUndefined(indentColor);
        const effectiveIndentColorActive = transparentToUndefined(indentColorActive);
        if (!effectiveIndentColor || !effectiveIndentColorActive) return undefined;
        return {
            indentColor: effectiveIndentColor,
            indentColorActive: effectiveIndentColorActive
        };
    }).filter((0, _typesJs.isDefined));
    if (colorValues.length > 0) {
        for(let level = 0; level < 30; level++){
            const colors = colorValues[level % colorValues.length];
            collector.addRule(`.monaco-editor .${colorProvider.getInlineClassNameOfLevel(level).replace(/ /g, ".")} { --guide-color: ${colors.guideColor}; --guide-color-active: ${colors.guideColorActive}; }`);
        }
        collector.addRule(`.monaco-editor .vertical { box-shadow: 1px 0 0 0 var(--guide-color) inset; }`);
        collector.addRule(`.monaco-editor .horizontal-top { border-top: 1px solid var(--guide-color); }`);
        collector.addRule(`.monaco-editor .horizontal-bottom { border-bottom: 1px solid var(--guide-color); }`);
        collector.addRule(`.monaco-editor .vertical.${colorProvider.activeClassName} { box-shadow: 1px 0 0 0 var(--guide-color-active) inset; }`);
        collector.addRule(`.monaco-editor .horizontal-top.${colorProvider.activeClassName} { border-top: 1px solid var(--guide-color-active); }`);
        collector.addRule(`.monaco-editor .horizontal-bottom.${colorProvider.activeClassName} { border-bottom: 1px solid var(--guide-color-active); }`);
    }
    if (indentColorValues.length > 0) {
        for(let level = 0; level < 30; level++){
            const colors = indentColorValues[level % indentColorValues.length];
            collector.addRule(`.monaco-editor .lines-content .core-guide-indent.lvl-${level} { --indent-color: ${colors.indentColor}; --indent-color-active: ${colors.indentColorActive}; }`);
        }
        collector.addRule(`.monaco-editor .lines-content .core-guide-indent { box-shadow: 1px 0 0 0 var(--indent-color) inset; }`);
        collector.addRule(`.monaco-editor .lines-content .core-guide-indent.indent-active { box-shadow: 1px 0 0 0 var(--indent-color-active) inset; }`);
    }
});

},{"./indentGuides.css":"52UV4","../../view/dynamicViewOverlay.js":"dULHQ","../../../common/core/editorColorRegistry.js":"5XqtL","../../../../platform/theme/common/themeService.js":"jMkIC","../../../common/core/position.js":"lvrPe","../../../../base/common/arrays.js":"DECei","../../../../base/common/types.js":"fb5yx","../../../common/model/guidesTextModelPart.js":"k7k2K","../../../common/textModelGuides.js":"fnW8P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"52UV4":[function() {},{}],"2Tih7":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewLines", ()=>ViewLines);
var _mouseCursorJs = require("../../../../base/browser/ui/mouseCursor/mouseCursor.js");
var _asyncJs = require("../../../../base/common/async.js");
var _platformJs = require("../../../../base/common/platform.js");
var _viewLinesCss = require("./viewLines.css");
var _domFontInfoJs = require("../../config/domFontInfo.js");
var _renderingContextJs = require("../../view/renderingContext.js");
var _viewLayerJs = require("../../view/viewLayer.js");
var _viewPartJs = require("../../view/viewPart.js");
var _domReadingContextJs = require("./domReadingContext.js");
var _viewLineJs = require("./viewLine.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
class LastRenderedData {
    constructor(){
        this._currentVisibleRange = new (0, _rangeJs.Range)(1, 1, 1, 1);
    }
    getCurrentVisibleRange() {
        return this._currentVisibleRange;
    }
    setCurrentVisibleRange(currentVisibleRange) {
        this._currentVisibleRange = currentVisibleRange;
    }
}
class HorizontalRevealRangeRequest {
    constructor(minimalReveal, lineNumber, startColumn, endColumn, startScrollTop, stopScrollTop, scrollType){
        this.minimalReveal = minimalReveal;
        this.lineNumber = lineNumber;
        this.startColumn = startColumn;
        this.endColumn = endColumn;
        this.startScrollTop = startScrollTop;
        this.stopScrollTop = stopScrollTop;
        this.scrollType = scrollType;
        this.type = "range";
        this.minLineNumber = lineNumber;
        this.maxLineNumber = lineNumber;
    }
}
class HorizontalRevealSelectionsRequest {
    constructor(minimalReveal, selections, startScrollTop, stopScrollTop, scrollType){
        this.minimalReveal = minimalReveal;
        this.selections = selections;
        this.startScrollTop = startScrollTop;
        this.stopScrollTop = stopScrollTop;
        this.scrollType = scrollType;
        this.type = "selections";
        let minLineNumber = selections[0].startLineNumber;
        let maxLineNumber = selections[0].endLineNumber;
        for(let i = 1, len = selections.length; i < len; i++){
            const selection = selections[i];
            minLineNumber = Math.min(minLineNumber, selection.startLineNumber);
            maxLineNumber = Math.max(maxLineNumber, selection.endLineNumber);
        }
        this.minLineNumber = minLineNumber;
        this.maxLineNumber = maxLineNumber;
    }
}
class ViewLines extends (0, _viewPartJs.ViewPart) {
    /**
     * Adds this amount of pixels to the right of lines (no-one wants to type near the edge of the viewport)
     */ static{
        this.HORIZONTAL_EXTRA_PX = 30;
    }
    constructor(context, linesContent){
        super(context);
        const conf = this._context.configuration;
        const options = this._context.configuration.options;
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        const wrappingInfo = options.get(147 /* EditorOption.wrappingInfo */ );
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this._typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
        this._isViewportWrapping = wrappingInfo.isViewportWrapping;
        this._revealHorizontalRightPadding = options.get(101 /* EditorOption.revealHorizontalRightPadding */ );
        this._cursorSurroundingLines = options.get(29 /* EditorOption.cursorSurroundingLines */ );
        this._cursorSurroundingLinesStyle = options.get(30 /* EditorOption.cursorSurroundingLinesStyle */ );
        this._canUseLayerHinting = !options.get(32 /* EditorOption.disableLayerHinting */ );
        this._viewLineOptions = new (0, _viewLineJs.ViewLineOptions)(conf, this._context.theme.type);
        this._linesContent = linesContent;
        this._textRangeRestingSpot = document.createElement("div");
        this._visibleLines = new (0, _viewLayerJs.VisibleLinesCollection)({
            createLine: ()=>new (0, _viewLineJs.ViewLine)(this._viewLineOptions)
        });
        this.domNode = this._visibleLines.domNode;
        (0, _viewPartJs.PartFingerprints).write(this.domNode, 8 /* PartFingerprint.ViewLines */ );
        this.domNode.setClassName(`view-lines ${(0, _mouseCursorJs.MOUSE_CURSOR_TEXT_CSS_CLASS_NAME)}`);
        (0, _domFontInfoJs.applyFontInfo)(this.domNode, fontInfo);
        // --- width & height
        this._maxLineWidth = 0;
        this._asyncUpdateLineWidths = new (0, _asyncJs.RunOnceScheduler)(()=>{
            this._updateLineWidthsSlow();
        }, 200);
        this._asyncCheckMonospaceFontAssumptions = new (0, _asyncJs.RunOnceScheduler)(()=>{
            this._checkMonospaceFontAssumptions();
        }, 2000);
        this._lastRenderedData = new LastRenderedData();
        this._horizontalRevealRequest = null;
        // sticky scroll widget
        this._stickyScrollEnabled = options.get(116 /* EditorOption.stickyScroll */ ).enabled;
        this._maxNumberStickyLines = options.get(116 /* EditorOption.stickyScroll */ ).maxLineCount;
    }
    dispose() {
        this._asyncUpdateLineWidths.dispose();
        this._asyncCheckMonospaceFontAssumptions.dispose();
        super.dispose();
    }
    getDomNode() {
        return this.domNode;
    }
    // ---- begin view event handlers
    onConfigurationChanged(e) {
        this._visibleLines.onConfigurationChanged(e);
        if (e.hasChanged(147 /* EditorOption.wrappingInfo */ )) this._maxLineWidth = 0;
        const options = this._context.configuration.options;
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        const wrappingInfo = options.get(147 /* EditorOption.wrappingInfo */ );
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this._typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
        this._isViewportWrapping = wrappingInfo.isViewportWrapping;
        this._revealHorizontalRightPadding = options.get(101 /* EditorOption.revealHorizontalRightPadding */ );
        this._cursorSurroundingLines = options.get(29 /* EditorOption.cursorSurroundingLines */ );
        this._cursorSurroundingLinesStyle = options.get(30 /* EditorOption.cursorSurroundingLinesStyle */ );
        this._canUseLayerHinting = !options.get(32 /* EditorOption.disableLayerHinting */ );
        // sticky scroll
        this._stickyScrollEnabled = options.get(116 /* EditorOption.stickyScroll */ ).enabled;
        this._maxNumberStickyLines = options.get(116 /* EditorOption.stickyScroll */ ).maxLineCount;
        (0, _domFontInfoJs.applyFontInfo)(this.domNode, fontInfo);
        this._onOptionsMaybeChanged();
        if (e.hasChanged(146 /* EditorOption.layoutInfo */ )) this._maxLineWidth = 0;
        return true;
    }
    _onOptionsMaybeChanged() {
        const conf = this._context.configuration;
        const newViewLineOptions = new (0, _viewLineJs.ViewLineOptions)(conf, this._context.theme.type);
        if (!this._viewLineOptions.equals(newViewLineOptions)) {
            this._viewLineOptions = newViewLineOptions;
            const startLineNumber = this._visibleLines.getStartLineNumber();
            const endLineNumber = this._visibleLines.getEndLineNumber();
            for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++){
                const line = this._visibleLines.getVisibleLine(lineNumber);
                line.onOptionsChanged(this._viewLineOptions);
            }
            return true;
        }
        return false;
    }
    onCursorStateChanged(e) {
        const rendStartLineNumber = this._visibleLines.getStartLineNumber();
        const rendEndLineNumber = this._visibleLines.getEndLineNumber();
        let r = false;
        for(let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++)r = this._visibleLines.getVisibleLine(lineNumber).onSelectionChanged() || r;
        return r;
    }
    onDecorationsChanged(e) {
        {
            const rendStartLineNumber = this._visibleLines.getStartLineNumber();
            const rendEndLineNumber = this._visibleLines.getEndLineNumber();
            for(let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++)this._visibleLines.getVisibleLine(lineNumber).onDecorationsChanged();
        }
        return true;
    }
    onFlushed(e) {
        const shouldRender = this._visibleLines.onFlushed(e);
        this._maxLineWidth = 0;
        return shouldRender;
    }
    onLinesChanged(e) {
        return this._visibleLines.onLinesChanged(e);
    }
    onLinesDeleted(e) {
        return this._visibleLines.onLinesDeleted(e);
    }
    onLinesInserted(e) {
        return this._visibleLines.onLinesInserted(e);
    }
    onRevealRangeRequest(e) {
        // Using the future viewport here in order to handle multiple
        // incoming reveal range requests that might all desire to be animated
        const desiredScrollTop = this._computeScrollTopToRevealRange(this._context.viewLayout.getFutureViewport(), e.source, e.minimalReveal, e.range, e.selections, e.verticalType);
        if (desiredScrollTop === -1) // marker to abort the reveal range request
        return false;
        // validate the new desired scroll top
        let newScrollPosition = this._context.viewLayout.validateScrollPosition({
            scrollTop: desiredScrollTop
        });
        if (e.revealHorizontal) {
            if (e.range && e.range.startLineNumber !== e.range.endLineNumber) // Two or more lines? => scroll to base (That's how you see most of the two lines)
            newScrollPosition = {
                scrollTop: newScrollPosition.scrollTop,
                scrollLeft: 0
            };
            else if (e.range) // We don't necessarily know the horizontal offset of this range since the line might not be in the view...
            this._horizontalRevealRequest = new HorizontalRevealRangeRequest(e.minimalReveal, e.range.startLineNumber, e.range.startColumn, e.range.endColumn, this._context.viewLayout.getCurrentScrollTop(), newScrollPosition.scrollTop, e.scrollType);
            else if (e.selections && e.selections.length > 0) this._horizontalRevealRequest = new HorizontalRevealSelectionsRequest(e.minimalReveal, e.selections, this._context.viewLayout.getCurrentScrollTop(), newScrollPosition.scrollTop, e.scrollType);
        } else this._horizontalRevealRequest = null;
        const scrollTopDelta = Math.abs(this._context.viewLayout.getCurrentScrollTop() - newScrollPosition.scrollTop);
        const scrollType = scrollTopDelta <= this._lineHeight ? 1 /* ScrollType.Immediate */  : e.scrollType;
        this._context.viewModel.viewLayout.setScrollPosition(newScrollPosition, scrollType);
        return true;
    }
    onScrollChanged(e) {
        if (this._horizontalRevealRequest && e.scrollLeftChanged) // cancel any outstanding horizontal reveal request if someone else scrolls horizontally.
        this._horizontalRevealRequest = null;
        if (this._horizontalRevealRequest && e.scrollTopChanged) {
            const min = Math.min(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop);
            const max = Math.max(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop);
            if (e.scrollTop < min || e.scrollTop > max) // cancel any outstanding horizontal reveal request if someone else scrolls vertically.
            this._horizontalRevealRequest = null;
        }
        this.domNode.setWidth(e.scrollWidth);
        return this._visibleLines.onScrollChanged(e) || true;
    }
    onTokensChanged(e) {
        return this._visibleLines.onTokensChanged(e);
    }
    onZonesChanged(e) {
        this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth);
        return this._visibleLines.onZonesChanged(e);
    }
    onThemeChanged(e) {
        return this._onOptionsMaybeChanged();
    }
    // ---- end view event handlers
    // ----------- HELPERS FOR OTHERS
    getPositionFromDOMInfo(spanNode, offset) {
        const viewLineDomNode = this._getViewLineDomNode(spanNode);
        if (viewLineDomNode === null) // Couldn't find view line node
        return null;
        const lineNumber = this._getLineNumberFor(viewLineDomNode);
        if (lineNumber === -1) // Couldn't find view line node
        return null;
        if (lineNumber < 1 || lineNumber > this._context.viewModel.getLineCount()) // lineNumber is outside range
        return null;
        if (this._context.viewModel.getLineMaxColumn(lineNumber) === 1) // Line is empty
        return new (0, _positionJs.Position)(lineNumber, 1);
        const rendStartLineNumber = this._visibleLines.getStartLineNumber();
        const rendEndLineNumber = this._visibleLines.getEndLineNumber();
        if (lineNumber < rendStartLineNumber || lineNumber > rendEndLineNumber) // Couldn't find line
        return null;
        let column = this._visibleLines.getVisibleLine(lineNumber).getColumnOfNodeOffset(spanNode, offset);
        const minColumn = this._context.viewModel.getLineMinColumn(lineNumber);
        if (column < minColumn) column = minColumn;
        return new (0, _positionJs.Position)(lineNumber, column);
    }
    _getViewLineDomNode(node) {
        while(node && node.nodeType === 1){
            if (node.className === (0, _viewLineJs.ViewLine).CLASS_NAME) return node;
            node = node.parentElement;
        }
        return null;
    }
    /**
     * @returns the line number of this view line dom node.
     */ _getLineNumberFor(domNode) {
        const startLineNumber = this._visibleLines.getStartLineNumber();
        const endLineNumber = this._visibleLines.getEndLineNumber();
        for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++){
            const line = this._visibleLines.getVisibleLine(lineNumber);
            if (domNode === line.getDomNode()) return lineNumber;
        }
        return -1;
    }
    getLineWidth(lineNumber) {
        const rendStartLineNumber = this._visibleLines.getStartLineNumber();
        const rendEndLineNumber = this._visibleLines.getEndLineNumber();
        if (lineNumber < rendStartLineNumber || lineNumber > rendEndLineNumber) // Couldn't find line
        return -1;
        const context = new (0, _domReadingContextJs.DomReadingContext)(this.domNode.domNode, this._textRangeRestingSpot);
        const result = this._visibleLines.getVisibleLine(lineNumber).getWidth(context);
        this._updateLineWidthsSlowIfDomDidLayout(context);
        return result;
    }
    linesVisibleRangesForRange(_range, includeNewLines) {
        if (this.shouldRender()) // Cannot read from the DOM because it is dirty
        // i.e. the model & the dom are out of sync, so I'd be reading something stale
        return null;
        const originalEndLineNumber = _range.endLineNumber;
        const range = (0, _rangeJs.Range).intersectRanges(_range, this._lastRenderedData.getCurrentVisibleRange());
        if (!range) return null;
        const visibleRanges = [];
        let visibleRangesLen = 0;
        const domReadingContext = new (0, _domReadingContextJs.DomReadingContext)(this.domNode.domNode, this._textRangeRestingSpot);
        let nextLineModelLineNumber = 0;
        if (includeNewLines) nextLineModelLineNumber = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new (0, _positionJs.Position)(range.startLineNumber, 1)).lineNumber;
        const rendStartLineNumber = this._visibleLines.getStartLineNumber();
        const rendEndLineNumber = this._visibleLines.getEndLineNumber();
        for(let lineNumber = range.startLineNumber; lineNumber <= range.endLineNumber; lineNumber++){
            if (lineNumber < rendStartLineNumber || lineNumber > rendEndLineNumber) continue;
            const startColumn = lineNumber === range.startLineNumber ? range.startColumn : 1;
            const continuesInNextLine = lineNumber !== range.endLineNumber;
            const endColumn = continuesInNextLine ? this._context.viewModel.getLineMaxColumn(lineNumber) : range.endColumn;
            const visibleRangesForLine = this._visibleLines.getVisibleLine(lineNumber).getVisibleRangesForRange(lineNumber, startColumn, endColumn, domReadingContext);
            if (!visibleRangesForLine) continue;
            if (includeNewLines && lineNumber < originalEndLineNumber) {
                const currentLineModelLineNumber = nextLineModelLineNumber;
                nextLineModelLineNumber = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new (0, _positionJs.Position)(lineNumber + 1, 1)).lineNumber;
                if (currentLineModelLineNumber !== nextLineModelLineNumber) visibleRangesForLine.ranges[visibleRangesForLine.ranges.length - 1].width += this._typicalHalfwidthCharacterWidth;
            }
            visibleRanges[visibleRangesLen++] = new (0, _renderingContextJs.LineVisibleRanges)(visibleRangesForLine.outsideRenderedLine, lineNumber, (0, _renderingContextJs.HorizontalRange).from(visibleRangesForLine.ranges), continuesInNextLine);
        }
        this._updateLineWidthsSlowIfDomDidLayout(domReadingContext);
        if (visibleRangesLen === 0) return null;
        return visibleRanges;
    }
    _visibleRangesForLineRange(lineNumber, startColumn, endColumn) {
        if (this.shouldRender()) // Cannot read from the DOM because it is dirty
        // i.e. the model & the dom are out of sync, so I'd be reading something stale
        return null;
        if (lineNumber < this._visibleLines.getStartLineNumber() || lineNumber > this._visibleLines.getEndLineNumber()) return null;
        const domReadingContext = new (0, _domReadingContextJs.DomReadingContext)(this.domNode.domNode, this._textRangeRestingSpot);
        const result = this._visibleLines.getVisibleLine(lineNumber).getVisibleRangesForRange(lineNumber, startColumn, endColumn, domReadingContext);
        this._updateLineWidthsSlowIfDomDidLayout(domReadingContext);
        return result;
    }
    visibleRangeForPosition(position) {
        const visibleRanges = this._visibleRangesForLineRange(position.lineNumber, position.column, position.column);
        if (!visibleRanges) return null;
        return new (0, _renderingContextJs.HorizontalPosition)(visibleRanges.outsideRenderedLine, visibleRanges.ranges[0].left);
    }
    /**
     * Updates the max line width if it is fast to compute.
     * Returns true if all lines were taken into account.
     * Returns false if some lines need to be reevaluated (in a slow fashion).
     */ _updateLineWidthsFast() {
        return this._updateLineWidths(true);
    }
    _updateLineWidthsSlow() {
        this._updateLineWidths(false);
    }
    /**
     * Update the line widths using DOM layout information after someone else
     * has caused a synchronous layout.
     */ _updateLineWidthsSlowIfDomDidLayout(domReadingContext) {
        if (!domReadingContext.didDomLayout) // only proceed if we just did a layout
        return;
        if (this._asyncUpdateLineWidths.isScheduled()) // reading widths is not scheduled => widths are up-to-date
        return;
        this._asyncUpdateLineWidths.cancel();
        this._updateLineWidthsSlow();
    }
    _updateLineWidths(fast) {
        const rendStartLineNumber = this._visibleLines.getStartLineNumber();
        const rendEndLineNumber = this._visibleLines.getEndLineNumber();
        let localMaxLineWidth = 1;
        let allWidthsComputed = true;
        for(let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++){
            const visibleLine = this._visibleLines.getVisibleLine(lineNumber);
            if (fast && !visibleLine.getWidthIsFast()) {
                // Cannot compute width in a fast way for this line
                allWidthsComputed = false;
                continue;
            }
            localMaxLineWidth = Math.max(localMaxLineWidth, visibleLine.getWidth(null));
        }
        if (allWidthsComputed && rendStartLineNumber === 1 && rendEndLineNumber === this._context.viewModel.getLineCount()) // we know the max line width for all the lines
        this._maxLineWidth = 0;
        this._ensureMaxLineWidth(localMaxLineWidth);
        return allWidthsComputed;
    }
    _checkMonospaceFontAssumptions() {
        // Problems with monospace assumptions are more apparent for longer lines,
        // as small rounding errors start to sum up, so we will select the longest
        // line for a closer inspection
        let longestLineNumber = -1;
        let longestWidth = -1;
        const rendStartLineNumber = this._visibleLines.getStartLineNumber();
        const rendEndLineNumber = this._visibleLines.getEndLineNumber();
        for(let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++){
            const visibleLine = this._visibleLines.getVisibleLine(lineNumber);
            if (visibleLine.needsMonospaceFontCheck()) {
                const lineWidth = visibleLine.getWidth(null);
                if (lineWidth > longestWidth) {
                    longestWidth = lineWidth;
                    longestLineNumber = lineNumber;
                }
            }
        }
        if (longestLineNumber === -1) return;
        if (!this._visibleLines.getVisibleLine(longestLineNumber).monospaceAssumptionsAreValid()) for(let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++){
            const visibleLine = this._visibleLines.getVisibleLine(lineNumber);
            visibleLine.onMonospaceAssumptionsInvalidated();
        }
    }
    prepareRender() {
        throw new Error("Not supported");
    }
    render() {
        throw new Error("Not supported");
    }
    renderText(viewportData) {
        // (1) render lines - ensures lines are in the DOM
        this._visibleLines.renderLines(viewportData);
        this._lastRenderedData.setCurrentVisibleRange(viewportData.visibleRange);
        this.domNode.setWidth(this._context.viewLayout.getScrollWidth());
        this.domNode.setHeight(Math.min(this._context.viewLayout.getScrollHeight(), 1000000));
        // (2) compute horizontal scroll position:
        //  - this must happen after the lines are in the DOM since it might need a line that rendered just now
        //  - it might change `scrollWidth` and `scrollLeft`
        if (this._horizontalRevealRequest) {
            const horizontalRevealRequest = this._horizontalRevealRequest;
            // Check that we have the line that contains the horizontal range in the viewport
            if (viewportData.startLineNumber <= horizontalRevealRequest.minLineNumber && horizontalRevealRequest.maxLineNumber <= viewportData.endLineNumber) {
                this._horizontalRevealRequest = null;
                // allow `visibleRangesForRange2` to work
                this.onDidRender();
                // compute new scroll position
                const newScrollLeft = this._computeScrollLeftToReveal(horizontalRevealRequest);
                if (newScrollLeft) {
                    if (!this._isViewportWrapping) // ensure `scrollWidth` is large enough
                    this._ensureMaxLineWidth(newScrollLeft.maxHorizontalOffset);
                    // set `scrollLeft`
                    this._context.viewModel.viewLayout.setScrollPosition({
                        scrollLeft: newScrollLeft.scrollLeft
                    }, horizontalRevealRequest.scrollType);
                }
            }
        }
        // Update max line width (not so important, it is just so the horizontal scrollbar doesn't get too small)
        if (!this._updateLineWidthsFast()) // Computing the width of some lines would be slow => delay it
        this._asyncUpdateLineWidths.schedule();
        else this._asyncUpdateLineWidths.cancel();
        if (_platformJs.isLinux && !this._asyncCheckMonospaceFontAssumptions.isScheduled()) {
            const rendStartLineNumber = this._visibleLines.getStartLineNumber();
            const rendEndLineNumber = this._visibleLines.getEndLineNumber();
            for(let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++){
                const visibleLine = this._visibleLines.getVisibleLine(lineNumber);
                if (visibleLine.needsMonospaceFontCheck()) {
                    this._asyncCheckMonospaceFontAssumptions.schedule();
                    break;
                }
            }
        }
        // (3) handle scrolling
        this._linesContent.setLayerHinting(this._canUseLayerHinting);
        this._linesContent.setContain("strict");
        const adjustedScrollTop = this._context.viewLayout.getCurrentScrollTop() - viewportData.bigNumbersDelta;
        this._linesContent.setTop(-adjustedScrollTop);
        this._linesContent.setLeft(-this._context.viewLayout.getCurrentScrollLeft());
    }
    // --- width
    _ensureMaxLineWidth(lineWidth) {
        const iLineWidth = Math.ceil(lineWidth);
        if (this._maxLineWidth < iLineWidth) {
            this._maxLineWidth = iLineWidth;
            this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth);
        }
    }
    _computeScrollTopToRevealRange(viewport, source, minimalReveal, range, selections, verticalType) {
        const viewportStartY = viewport.top;
        const viewportHeight = viewport.height;
        const viewportEndY = viewportStartY + viewportHeight;
        let boxIsSingleRange;
        let boxStartY;
        let boxEndY;
        if (selections && selections.length > 0) {
            let minLineNumber = selections[0].startLineNumber;
            let maxLineNumber = selections[0].endLineNumber;
            for(let i = 1, len = selections.length; i < len; i++){
                const selection = selections[i];
                minLineNumber = Math.min(minLineNumber, selection.startLineNumber);
                maxLineNumber = Math.max(maxLineNumber, selection.endLineNumber);
            }
            boxIsSingleRange = false;
            boxStartY = this._context.viewLayout.getVerticalOffsetForLineNumber(minLineNumber);
            boxEndY = this._context.viewLayout.getVerticalOffsetForLineNumber(maxLineNumber) + this._lineHeight;
        } else if (range) {
            boxIsSingleRange = true;
            boxStartY = this._context.viewLayout.getVerticalOffsetForLineNumber(range.startLineNumber);
            boxEndY = this._context.viewLayout.getVerticalOffsetForLineNumber(range.endLineNumber) + this._lineHeight;
        } else return -1;
        const shouldIgnoreScrollOff = (source === "mouse" || minimalReveal) && this._cursorSurroundingLinesStyle === "default";
        let paddingTop = 0;
        let paddingBottom = 0;
        if (!shouldIgnoreScrollOff) {
            const maxLinesInViewport = viewportHeight / this._lineHeight;
            const surroundingLines = Math.max(this._cursorSurroundingLines, this._stickyScrollEnabled ? this._maxNumberStickyLines : 0);
            const context = Math.min(maxLinesInViewport / 2, surroundingLines);
            paddingTop = context * this._lineHeight;
            paddingBottom = Math.max(0, context - 1) * this._lineHeight;
        } else if (!minimalReveal) // Reveal one more line above (this case is hit when dragging)
        paddingTop = this._lineHeight;
        if (!minimalReveal) {
            if (verticalType === 0 /* viewEvents.VerticalRevealType.Simple */  || verticalType === 4 /* viewEvents.VerticalRevealType.Bottom */ ) // Reveal one line more when the last line would be covered by the scrollbar - arrow down case or revealing a line explicitly at bottom
            paddingBottom += this._lineHeight;
        }
        boxStartY -= paddingTop;
        boxEndY += paddingBottom;
        let newScrollTop;
        if (boxEndY - boxStartY > viewportHeight) {
            // the box is larger than the viewport ... scroll to its top
            if (!boxIsSingleRange) // do not reveal multiple cursors if there are more than fit the viewport
            return -1;
            newScrollTop = boxStartY;
        } else if (verticalType === 5 /* viewEvents.VerticalRevealType.NearTop */  || verticalType === 6 /* viewEvents.VerticalRevealType.NearTopIfOutsideViewport */ ) {
            if (verticalType === 6 /* viewEvents.VerticalRevealType.NearTopIfOutsideViewport */  && viewportStartY <= boxStartY && boxEndY <= viewportEndY) // Box is already in the viewport... do nothing
            newScrollTop = viewportStartY;
            else {
                // We want a gap that is 20% of the viewport, but with a minimum of 5 lines
                const desiredGapAbove = Math.max(5 * this._lineHeight, viewportHeight * 0.2);
                // Try to scroll just above the box with the desired gap
                const desiredScrollTop = boxStartY - desiredGapAbove;
                // But ensure that the box is not pushed out of viewport
                const minScrollTop = boxEndY - viewportHeight;
                newScrollTop = Math.max(minScrollTop, desiredScrollTop);
            }
        } else if (verticalType === 1 /* viewEvents.VerticalRevealType.Center */  || verticalType === 2 /* viewEvents.VerticalRevealType.CenterIfOutsideViewport */ ) {
            if (verticalType === 2 /* viewEvents.VerticalRevealType.CenterIfOutsideViewport */  && viewportStartY <= boxStartY && boxEndY <= viewportEndY) // Box is already in the viewport... do nothing
            newScrollTop = viewportStartY;
            else {
                // Box is outside the viewport... center it
                const boxMiddleY = (boxStartY + boxEndY) / 2;
                newScrollTop = Math.max(0, boxMiddleY - viewportHeight / 2);
            }
        } else newScrollTop = this._computeMinimumScrolling(viewportStartY, viewportEndY, boxStartY, boxEndY, verticalType === 3 /* viewEvents.VerticalRevealType.Top */ , verticalType === 4 /* viewEvents.VerticalRevealType.Bottom */ );
        return newScrollTop;
    }
    _computeScrollLeftToReveal(horizontalRevealRequest) {
        const viewport = this._context.viewLayout.getCurrentViewport();
        const layoutInfo = this._context.configuration.options.get(146 /* EditorOption.layoutInfo */ );
        const viewportStartX = viewport.left;
        const viewportEndX = viewportStartX + viewport.width - layoutInfo.verticalScrollbarWidth;
        let boxStartX = 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ;
        let boxEndX = 0;
        if (horizontalRevealRequest.type === "range") {
            const visibleRanges = this._visibleRangesForLineRange(horizontalRevealRequest.lineNumber, horizontalRevealRequest.startColumn, horizontalRevealRequest.endColumn);
            if (!visibleRanges) return null;
            for (const visibleRange of visibleRanges.ranges){
                boxStartX = Math.min(boxStartX, Math.round(visibleRange.left));
                boxEndX = Math.max(boxEndX, Math.round(visibleRange.left + visibleRange.width));
            }
        } else for (const selection of horizontalRevealRequest.selections){
            if (selection.startLineNumber !== selection.endLineNumber) return null;
            const visibleRanges = this._visibleRangesForLineRange(selection.startLineNumber, selection.startColumn, selection.endColumn);
            if (!visibleRanges) return null;
            for (const visibleRange of visibleRanges.ranges){
                boxStartX = Math.min(boxStartX, Math.round(visibleRange.left));
                boxEndX = Math.max(boxEndX, Math.round(visibleRange.left + visibleRange.width));
            }
        }
        if (!horizontalRevealRequest.minimalReveal) {
            boxStartX = Math.max(0, boxStartX - ViewLines.HORIZONTAL_EXTRA_PX);
            boxEndX += this._revealHorizontalRightPadding;
        }
        if (horizontalRevealRequest.type === "selections" && boxEndX - boxStartX > viewport.width) return null;
        const newScrollLeft = this._computeMinimumScrolling(viewportStartX, viewportEndX, boxStartX, boxEndX);
        return {
            scrollLeft: newScrollLeft,
            maxHorizontalOffset: boxEndX
        };
    }
    _computeMinimumScrolling(viewportStart, viewportEnd, boxStart, boxEnd, revealAtStart, revealAtEnd) {
        viewportStart = viewportStart | 0;
        viewportEnd = viewportEnd | 0;
        boxStart = boxStart | 0;
        boxEnd = boxEnd | 0;
        revealAtStart = !!revealAtStart;
        revealAtEnd = !!revealAtEnd;
        const viewportLength = viewportEnd - viewportStart;
        const boxLength = boxEnd - boxStart;
        if (boxLength < viewportLength) {
            // The box would fit in the viewport
            if (revealAtStart) return boxStart;
            if (revealAtEnd) return Math.max(0, boxEnd - viewportLength);
            if (boxStart < viewportStart) // The box is above the viewport
            return boxStart;
            else if (boxEnd > viewportEnd) // The box is below the viewport
            return Math.max(0, boxEnd - viewportLength);
        } else // The box would not fit in the viewport
        // Reveal the beginning of the box
        return boxStart;
        return viewportStart;
    }
}

},{"../../../../base/browser/ui/mouseCursor/mouseCursor.js":"dizty","../../../../base/common/async.js":"4GJc4","../../../../base/common/platform.js":"7maJO","./viewLines.css":"iHeTK","../../config/domFontInfo.js":"fQezv","../../view/renderingContext.js":"bWoBX","../../view/viewLayer.js":"7v2Ri","../../view/viewPart.js":"kTsLR","./domReadingContext.js":"5HnH3","./viewLine.js":"9rxuY","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iHeTK":[function() {},{}],"5HnH3":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DomReadingContext", ()=>DomReadingContext);
class DomReadingContext {
    get didDomLayout() {
        return this._didDomLayout;
    }
    readClientRect() {
        if (!this._clientRectRead) {
            this._clientRectRead = true;
            const rect = this._domNode.getBoundingClientRect();
            this.markDidDomLayout();
            this._clientRectDeltaLeft = rect.left;
            this._clientRectScale = rect.width / this._domNode.offsetWidth;
        }
    }
    get clientRectDeltaLeft() {
        if (!this._clientRectRead) this.readClientRect();
        return this._clientRectDeltaLeft;
    }
    get clientRectScale() {
        if (!this._clientRectRead) this.readClientRect();
        return this._clientRectScale;
    }
    constructor(_domNode, endNode){
        this._domNode = _domNode;
        this.endNode = endNode;
        this._didDomLayout = false;
        this._clientRectDeltaLeft = 0;
        this._clientRectScale = 1;
        this._clientRectRead = false;
    }
    markDidDomLayout() {
        this._didDomLayout = true;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"88WDq":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinesDecorationsOverlay", ()=>LinesDecorationsOverlay);
var _linesDecorationsCss = require("./linesDecorations.css");
var _glyphMarginJs = require("../glyphMargin/glyphMargin.js");
class LinesDecorationsOverlay extends (0, _glyphMarginJs.DedupOverlay) {
    constructor(context){
        super();
        this._context = context;
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._decorationsLeft = layoutInfo.decorationsLeft;
        this._decorationsWidth = layoutInfo.decorationsWidth;
        this._renderResult = null;
        this._context.addEventHandler(this);
    }
    dispose() {
        this._context.removeEventHandler(this);
        this._renderResult = null;
        super.dispose();
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._decorationsLeft = layoutInfo.decorationsLeft;
        this._decorationsWidth = layoutInfo.decorationsWidth;
        return true;
    }
    onDecorationsChanged(e) {
        return true;
    }
    onFlushed(e) {
        return true;
    }
    onLinesChanged(e) {
        return true;
    }
    onLinesDeleted(e) {
        return true;
    }
    onLinesInserted(e) {
        return true;
    }
    onScrollChanged(e) {
        return e.scrollTopChanged;
    }
    onZonesChanged(e) {
        return true;
    }
    // --- end event handlers
    _getDecorations(ctx) {
        const decorations = ctx.getDecorationsInViewport();
        const r = [];
        let rLen = 0;
        for(let i = 0, len = decorations.length; i < len; i++){
            const d = decorations[i];
            const linesDecorationsClassName = d.options.linesDecorationsClassName;
            const zIndex = d.options.zIndex;
            if (linesDecorationsClassName) r[rLen++] = new (0, _glyphMarginJs.DecorationToRender)(d.range.startLineNumber, d.range.endLineNumber, linesDecorationsClassName, d.options.linesDecorationsTooltip ?? null, zIndex);
            const firstLineDecorationClassName = d.options.firstLineDecorationClassName;
            if (firstLineDecorationClassName) r[rLen++] = new (0, _glyphMarginJs.DecorationToRender)(d.range.startLineNumber, d.range.startLineNumber, firstLineDecorationClassName, d.options.linesDecorationsTooltip ?? null, zIndex);
        }
        return r;
    }
    prepareRender(ctx) {
        const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        const toRender = this._render(visibleStartLineNumber, visibleEndLineNumber, this._getDecorations(ctx));
        const left = this._decorationsLeft.toString();
        const width = this._decorationsWidth.toString();
        const common = '" style="left:' + left + "px;width:" + width + 'px;"></div>';
        const output = [];
        for(let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++){
            const lineIndex = lineNumber - visibleStartLineNumber;
            const decorations = toRender[lineIndex].getDecorations();
            let lineOutput = "";
            for (const decoration of decorations){
                let addition = '<div class="cldr ' + decoration.className;
                if (decoration.tooltip !== null) addition += '" title="' + decoration.tooltip; // The tooltip is already escaped.
                addition += common;
                lineOutput += addition;
            }
            output[lineIndex] = lineOutput;
        }
        this._renderResult = output;
    }
    render(startLineNumber, lineNumber) {
        if (!this._renderResult) return "";
        return this._renderResult[lineNumber - startLineNumber];
    }
}

},{"./linesDecorations.css":"2GAP1","../glyphMargin/glyphMargin.js":"gKiXe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2GAP1":[function() {},{}],"2B9sH":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarginViewLineDecorationsOverlay", ()=>MarginViewLineDecorationsOverlay);
var _marginDecorationsCss = require("./marginDecorations.css");
var _glyphMarginJs = require("../glyphMargin/glyphMargin.js");
class MarginViewLineDecorationsOverlay extends (0, _glyphMarginJs.DedupOverlay) {
    constructor(context){
        super();
        this._context = context;
        this._renderResult = null;
        this._context.addEventHandler(this);
    }
    dispose() {
        this._context.removeEventHandler(this);
        this._renderResult = null;
        super.dispose();
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        return true;
    }
    onDecorationsChanged(e) {
        return true;
    }
    onFlushed(e) {
        return true;
    }
    onLinesChanged(e) {
        return true;
    }
    onLinesDeleted(e) {
        return true;
    }
    onLinesInserted(e) {
        return true;
    }
    onScrollChanged(e) {
        return e.scrollTopChanged;
    }
    onZonesChanged(e) {
        return true;
    }
    // --- end event handlers
    _getDecorations(ctx) {
        const decorations = ctx.getDecorationsInViewport();
        const r = [];
        let rLen = 0;
        for(let i = 0, len = decorations.length; i < len; i++){
            const d = decorations[i];
            const marginClassName = d.options.marginClassName;
            const zIndex = d.options.zIndex;
            if (marginClassName) r[rLen++] = new (0, _glyphMarginJs.DecorationToRender)(d.range.startLineNumber, d.range.endLineNumber, marginClassName, null, zIndex);
        }
        return r;
    }
    prepareRender(ctx) {
        const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        const toRender = this._render(visibleStartLineNumber, visibleEndLineNumber, this._getDecorations(ctx));
        const output = [];
        for(let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++){
            const lineIndex = lineNumber - visibleStartLineNumber;
            const decorations = toRender[lineIndex].getDecorations();
            let lineOutput = "";
            for (const decoration of decorations)lineOutput += '<div class="cmdr ' + decoration.className + '" style=""></div>';
            output[lineIndex] = lineOutput;
        }
        this._renderResult = output;
    }
    render(startLineNumber, lineNumber) {
        if (!this._renderResult) return "";
        return this._renderResult[lineNumber - startLineNumber];
    }
}

},{"./marginDecorations.css":"av9CG","../glyphMargin/glyphMargin.js":"gKiXe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"av9CG":[function() {},{}],"fhtW4":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Minimap", ()=>Minimap);
var _minimapCss = require("./minimap.css");
var _domJs = require("../../../../base/browser/dom.js");
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _globalPointerMoveMonitorJs = require("../../../../base/browser/globalPointerMoveMonitor.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _platformJs = require("../../../../base/common/platform.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _viewLayerJs = require("../../view/viewLayer.js");
var _viewPartJs = require("../../view/viewPart.js");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
var _rangeJs = require("../../../common/core/range.js");
var _rgbaJs = require("../../../common/core/rgba.js");
var _minimapTokensColorTrackerJs = require("../../../common/viewModel/minimapTokensColorTracker.js");
var _viewModelJs = require("../../../common/viewModel.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _selectionJs = require("../../../common/core/selection.js");
var _touchJs = require("../../../../base/browser/touch.js");
var _minimapCharRendererFactoryJs = require("./minimapCharRendererFactory.js");
var _functionalJs = require("../../../../base/common/functional.js");
var _mapJs = require("../../../../base/common/map.js");
var _fontsJs = require("../../../../base/browser/fonts.js");
/**
 * The orthogonal distance to the slider at which dragging "resets". This implements "snapping"
 */ const POINTER_DRAG_RESET_DISTANCE = 140;
const GUTTER_DECORATION_WIDTH = 2;
class MinimapOptions {
    constructor(configuration, theme, tokensColorTracker){
        const options = configuration.options;
        const pixelRatio = options.get(144 /* EditorOption.pixelRatio */ );
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        const minimapLayout = layoutInfo.minimap;
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        const minimapOpts = options.get(73 /* EditorOption.minimap */ );
        this.renderMinimap = minimapLayout.renderMinimap;
        this.size = minimapOpts.size;
        this.minimapHeightIsEditorHeight = minimapLayout.minimapHeightIsEditorHeight;
        this.scrollBeyondLastLine = options.get(106 /* EditorOption.scrollBeyondLastLine */ );
        this.paddingTop = options.get(84 /* EditorOption.padding */ ).top;
        this.paddingBottom = options.get(84 /* EditorOption.padding */ ).bottom;
        this.showSlider = minimapOpts.showSlider;
        this.autohide = minimapOpts.autohide;
        this.pixelRatio = pixelRatio;
        this.typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
        this.lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this.minimapLeft = minimapLayout.minimapLeft;
        this.minimapWidth = minimapLayout.minimapWidth;
        this.minimapHeight = layoutInfo.height;
        this.canvasInnerWidth = minimapLayout.minimapCanvasInnerWidth;
        this.canvasInnerHeight = minimapLayout.minimapCanvasInnerHeight;
        this.canvasOuterWidth = minimapLayout.minimapCanvasOuterWidth;
        this.canvasOuterHeight = minimapLayout.minimapCanvasOuterHeight;
        this.isSampling = minimapLayout.minimapIsSampling;
        this.editorHeight = layoutInfo.height;
        this.fontScale = minimapLayout.minimapScale;
        this.minimapLineHeight = minimapLayout.minimapLineHeight;
        this.minimapCharWidth = 1 /* Constants.BASE_CHAR_WIDTH */  * this.fontScale;
        this.sectionHeaderFontFamily = (0, _fontsJs.DEFAULT_FONT_FAMILY);
        this.sectionHeaderFontSize = minimapOpts.sectionHeaderFontSize * pixelRatio;
        this.sectionHeaderLetterSpacing = minimapOpts.sectionHeaderLetterSpacing; // intentionally not multiplying by pixelRatio
        this.sectionHeaderFontColor = MinimapOptions._getSectionHeaderColor(theme, tokensColorTracker.getColor(1 /* ColorId.DefaultForeground */ ));
        this.charRenderer = (0, _functionalJs.createSingleCallFunction)(()=>(0, _minimapCharRendererFactoryJs.MinimapCharRendererFactory).create(this.fontScale, fontInfo.fontFamily));
        this.defaultBackgroundColor = tokensColorTracker.getColor(2 /* ColorId.DefaultBackground */ );
        this.backgroundColor = MinimapOptions._getMinimapBackground(theme, this.defaultBackgroundColor);
        this.foregroundAlpha = MinimapOptions._getMinimapForegroundOpacity(theme);
    }
    static _getMinimapBackground(theme, defaultBackgroundColor) {
        const themeColor = theme.getColor((0, _colorRegistryJs.minimapBackground));
        if (themeColor) return new (0, _rgbaJs.RGBA8)(themeColor.rgba.r, themeColor.rgba.g, themeColor.rgba.b, Math.round(255 * themeColor.rgba.a));
        return defaultBackgroundColor;
    }
    static _getMinimapForegroundOpacity(theme) {
        const themeColor = theme.getColor((0, _colorRegistryJs.minimapForegroundOpacity));
        if (themeColor) return (0, _rgbaJs.RGBA8)._clamp(Math.round(255 * themeColor.rgba.a));
        return 255;
    }
    static _getSectionHeaderColor(theme, defaultForegroundColor) {
        const themeColor = theme.getColor((0, _colorRegistryJs.editorForeground));
        if (themeColor) return new (0, _rgbaJs.RGBA8)(themeColor.rgba.r, themeColor.rgba.g, themeColor.rgba.b, Math.round(255 * themeColor.rgba.a));
        return defaultForegroundColor;
    }
    equals(other) {
        return this.renderMinimap === other.renderMinimap && this.size === other.size && this.minimapHeightIsEditorHeight === other.minimapHeightIsEditorHeight && this.scrollBeyondLastLine === other.scrollBeyondLastLine && this.paddingTop === other.paddingTop && this.paddingBottom === other.paddingBottom && this.showSlider === other.showSlider && this.autohide === other.autohide && this.pixelRatio === other.pixelRatio && this.typicalHalfwidthCharacterWidth === other.typicalHalfwidthCharacterWidth && this.lineHeight === other.lineHeight && this.minimapLeft === other.minimapLeft && this.minimapWidth === other.minimapWidth && this.minimapHeight === other.minimapHeight && this.canvasInnerWidth === other.canvasInnerWidth && this.canvasInnerHeight === other.canvasInnerHeight && this.canvasOuterWidth === other.canvasOuterWidth && this.canvasOuterHeight === other.canvasOuterHeight && this.isSampling === other.isSampling && this.editorHeight === other.editorHeight && this.fontScale === other.fontScale && this.minimapLineHeight === other.minimapLineHeight && this.minimapCharWidth === other.minimapCharWidth && this.sectionHeaderFontSize === other.sectionHeaderFontSize && this.sectionHeaderLetterSpacing === other.sectionHeaderLetterSpacing && this.defaultBackgroundColor && this.defaultBackgroundColor.equals(other.defaultBackgroundColor) && this.backgroundColor && this.backgroundColor.equals(other.backgroundColor) && this.foregroundAlpha === other.foregroundAlpha;
    }
}
class MinimapLayout {
    constructor(/**
     * The given editor scrollTop (input).
     */ scrollTop, /**
     * The given editor scrollHeight (input).
     */ scrollHeight, sliderNeeded, _computedSliderRatio, /**
     * slider dom node top (in CSS px)
     */ sliderTop, /**
     * slider dom node height (in CSS px)
     */ sliderHeight, /**
     * empty lines to reserve at the top of the minimap.
     */ topPaddingLineCount, /**
     * minimap render start line number.
     */ startLineNumber, /**
     * minimap render end line number.
     */ endLineNumber){
        this.scrollTop = scrollTop;
        this.scrollHeight = scrollHeight;
        this.sliderNeeded = sliderNeeded;
        this._computedSliderRatio = _computedSliderRatio;
        this.sliderTop = sliderTop;
        this.sliderHeight = sliderHeight;
        this.topPaddingLineCount = topPaddingLineCount;
        this.startLineNumber = startLineNumber;
        this.endLineNumber = endLineNumber;
    }
    /**
     * Compute a desired `scrollPosition` such that the slider moves by `delta`.
     */ getDesiredScrollTopFromDelta(delta) {
        return Math.round(this.scrollTop + delta / this._computedSliderRatio);
    }
    getDesiredScrollTopFromTouchLocation(pageY) {
        return Math.round((pageY - this.sliderHeight / 2) / this._computedSliderRatio);
    }
    /**
     * Intersect a line range with `this.startLineNumber` and `this.endLineNumber`.
     */ intersectWithViewport(range) {
        const startLineNumber = Math.max(this.startLineNumber, range.startLineNumber);
        const endLineNumber = Math.min(this.endLineNumber, range.endLineNumber);
        if (startLineNumber > endLineNumber) // entirely outside minimap's viewport
        return null;
        return [
            startLineNumber,
            endLineNumber
        ];
    }
    /**
     * Get the inner minimap y coordinate for a line number.
     */ getYForLineNumber(lineNumber, minimapLineHeight) {
        return +(lineNumber - this.startLineNumber + this.topPaddingLineCount) * minimapLineHeight;
    }
    static create(options, viewportStartLineNumber, viewportEndLineNumber, viewportStartLineNumberVerticalOffset, viewportHeight, viewportContainsWhitespaceGaps, lineCount, realLineCount, scrollTop, scrollHeight, previousLayout) {
        const pixelRatio = options.pixelRatio;
        const minimapLineHeight = options.minimapLineHeight;
        const minimapLinesFitting = Math.floor(options.canvasInnerHeight / minimapLineHeight);
        const lineHeight = options.lineHeight;
        if (options.minimapHeightIsEditorHeight) {
            let logicalScrollHeight = realLineCount * options.lineHeight + options.paddingTop + options.paddingBottom;
            if (options.scrollBeyondLastLine) logicalScrollHeight += Math.max(0, viewportHeight - options.lineHeight - options.paddingBottom);
            const sliderHeight = Math.max(1, Math.floor(viewportHeight * viewportHeight / logicalScrollHeight));
            const maxMinimapSliderTop = Math.max(0, options.minimapHeight - sliderHeight);
            // The slider can move from 0 to `maxMinimapSliderTop`
            // in the same way `scrollTop` can move from 0 to `scrollHeight` - `viewportHeight`.
            const computedSliderRatio = maxMinimapSliderTop / (scrollHeight - viewportHeight);
            const sliderTop = scrollTop * computedSliderRatio;
            const sliderNeeded = maxMinimapSliderTop > 0;
            const maxLinesFitting = Math.floor(options.canvasInnerHeight / options.minimapLineHeight);
            const topPaddingLineCount = Math.floor(options.paddingTop / options.lineHeight);
            return new MinimapLayout(scrollTop, scrollHeight, sliderNeeded, computedSliderRatio, sliderTop, sliderHeight, topPaddingLineCount, 1, Math.min(lineCount, maxLinesFitting));
        }
        // The visible line count in a viewport can change due to a number of reasons:
        //  a) with the same viewport width, different scroll positions can result in partial lines being visible:
        //    e.g. for a line height of 20, and a viewport height of 600
        //          * scrollTop = 0  => visible lines are [1, 30]
        //          * scrollTop = 10 => visible lines are [1, 31] (with lines 1 and 31 partially visible)
        //          * scrollTop = 20 => visible lines are [2, 31]
        //  b) whitespace gaps might make their way in the viewport (which results in a decrease in the visible line count)
        //  c) we could be in the scroll beyond last line case (which also results in a decrease in the visible line count, down to possibly only one line being visible)
        // We must first establish a desirable slider height.
        let sliderHeight;
        if (viewportContainsWhitespaceGaps && viewportEndLineNumber !== lineCount) {
            // case b) from above: there are whitespace gaps in the viewport.
            // In this case, the height of the slider directly reflects the visible line count.
            const viewportLineCount = viewportEndLineNumber - viewportStartLineNumber + 1;
            sliderHeight = Math.floor(viewportLineCount * minimapLineHeight / pixelRatio);
        } else {
            // The slider has a stable height
            const expectedViewportLineCount = viewportHeight / lineHeight;
            sliderHeight = Math.floor(expectedViewportLineCount * minimapLineHeight / pixelRatio);
        }
        const extraLinesAtTheTop = Math.floor(options.paddingTop / lineHeight);
        let extraLinesAtTheBottom = Math.floor(options.paddingBottom / lineHeight);
        if (options.scrollBeyondLastLine) {
            const expectedViewportLineCount = viewportHeight / lineHeight;
            extraLinesAtTheBottom = Math.max(extraLinesAtTheBottom, expectedViewportLineCount - 1);
        }
        let maxMinimapSliderTop;
        if (extraLinesAtTheBottom > 0) {
            const expectedViewportLineCount = viewportHeight / lineHeight;
            // The minimap slider, when dragged all the way down, will contain the last line at its top
            maxMinimapSliderTop = (extraLinesAtTheTop + lineCount + extraLinesAtTheBottom - expectedViewportLineCount - 1) * minimapLineHeight / pixelRatio;
        } else // The minimap slider, when dragged all the way down, will contain the last line at its bottom
        maxMinimapSliderTop = Math.max(0, (extraLinesAtTheTop + lineCount) * minimapLineHeight / pixelRatio - sliderHeight);
        maxMinimapSliderTop = Math.min(options.minimapHeight - sliderHeight, maxMinimapSliderTop);
        // The slider can move from 0 to `maxMinimapSliderTop`
        // in the same way `scrollTop` can move from 0 to `scrollHeight` - `viewportHeight`.
        const computedSliderRatio = maxMinimapSliderTop / (scrollHeight - viewportHeight);
        const sliderTop = scrollTop * computedSliderRatio;
        if (minimapLinesFitting >= extraLinesAtTheTop + lineCount + extraLinesAtTheBottom) {
            // All lines fit in the minimap
            const sliderNeeded = maxMinimapSliderTop > 0;
            return new MinimapLayout(scrollTop, scrollHeight, sliderNeeded, computedSliderRatio, sliderTop, sliderHeight, extraLinesAtTheTop, 1, lineCount);
        } else {
            let consideringStartLineNumber;
            if (viewportStartLineNumber > 1) consideringStartLineNumber = viewportStartLineNumber + extraLinesAtTheTop;
            else consideringStartLineNumber = Math.max(1, scrollTop / lineHeight);
            let topPaddingLineCount;
            let startLineNumber = Math.max(1, Math.floor(consideringStartLineNumber - sliderTop * pixelRatio / minimapLineHeight));
            if (startLineNumber < extraLinesAtTheTop) {
                topPaddingLineCount = extraLinesAtTheTop - startLineNumber + 1;
                startLineNumber = 1;
            } else {
                topPaddingLineCount = 0;
                startLineNumber = Math.max(1, startLineNumber - extraLinesAtTheTop);
            }
            // Avoid flickering caused by a partial viewport start line
            // by being consistent w.r.t. the previous layout decision
            if (previousLayout && previousLayout.scrollHeight === scrollHeight) {
                if (previousLayout.scrollTop > scrollTop) {
                    // Scrolling up => never increase `startLineNumber`
                    startLineNumber = Math.min(startLineNumber, previousLayout.startLineNumber);
                    topPaddingLineCount = Math.max(topPaddingLineCount, previousLayout.topPaddingLineCount);
                }
                if (previousLayout.scrollTop < scrollTop) {
                    // Scrolling down => never decrease `startLineNumber`
                    startLineNumber = Math.max(startLineNumber, previousLayout.startLineNumber);
                    topPaddingLineCount = Math.min(topPaddingLineCount, previousLayout.topPaddingLineCount);
                }
            }
            const endLineNumber = Math.min(lineCount, startLineNumber - topPaddingLineCount + minimapLinesFitting - 1);
            const partialLine = (scrollTop - viewportStartLineNumberVerticalOffset) / lineHeight;
            let sliderTopAligned;
            if (scrollTop >= options.paddingTop) sliderTopAligned = (viewportStartLineNumber - startLineNumber + topPaddingLineCount + partialLine) * minimapLineHeight / pixelRatio;
            else sliderTopAligned = scrollTop / options.paddingTop * (topPaddingLineCount + partialLine) * minimapLineHeight / pixelRatio;
            return new MinimapLayout(scrollTop, scrollHeight, true, computedSliderRatio, sliderTopAligned, sliderHeight, topPaddingLineCount, startLineNumber, endLineNumber);
        }
    }
}
class MinimapLine {
    static{
        this.INVALID = new MinimapLine(-1);
    }
    constructor(dy){
        this.dy = dy;
    }
    onContentChanged() {
        this.dy = -1;
    }
    onTokensChanged() {
        this.dy = -1;
    }
}
class RenderData {
    constructor(renderedLayout, imageData, lines){
        this.renderedLayout = renderedLayout;
        this._imageData = imageData;
        this._renderedLines = new (0, _viewLayerJs.RenderedLinesCollection)({
            createLine: ()=>MinimapLine.INVALID
        });
        this._renderedLines._set(renderedLayout.startLineNumber, lines);
    }
    /**
     * Check if the current RenderData matches accurately the new desired layout and no painting is needed.
     */ linesEquals(layout) {
        if (!this.scrollEquals(layout)) return false;
        const tmp = this._renderedLines._get();
        const lines = tmp.lines;
        for(let i = 0, len = lines.length; i < len; i++){
            if (lines[i].dy === -1) // This line is invalid
            return false;
        }
        return true;
    }
    /**
     * Check if the current RenderData matches the new layout's scroll position
     */ scrollEquals(layout) {
        return this.renderedLayout.startLineNumber === layout.startLineNumber && this.renderedLayout.endLineNumber === layout.endLineNumber;
    }
    _get() {
        const tmp = this._renderedLines._get();
        return {
            imageData: this._imageData,
            rendLineNumberStart: tmp.rendLineNumberStart,
            lines: tmp.lines
        };
    }
    onLinesChanged(changeFromLineNumber, changeCount) {
        return this._renderedLines.onLinesChanged(changeFromLineNumber, changeCount);
    }
    onLinesDeleted(deleteFromLineNumber, deleteToLineNumber) {
        this._renderedLines.onLinesDeleted(deleteFromLineNumber, deleteToLineNumber);
    }
    onLinesInserted(insertFromLineNumber, insertToLineNumber) {
        this._renderedLines.onLinesInserted(insertFromLineNumber, insertToLineNumber);
    }
    onTokensChanged(ranges) {
        return this._renderedLines.onTokensChanged(ranges);
    }
}
/**
 * Some sort of double buffering.
 *
 * Keeps two buffers around that will be rotated for painting.
 * Always gives a buffer that is filled with the background color.
 */ class MinimapBuffers {
    constructor(ctx, WIDTH, HEIGHT, background){
        this._backgroundFillData = MinimapBuffers._createBackgroundFillData(WIDTH, HEIGHT, background);
        this._buffers = [
            ctx.createImageData(WIDTH, HEIGHT),
            ctx.createImageData(WIDTH, HEIGHT)
        ];
        this._lastUsedBuffer = 0;
    }
    getBuffer() {
        // rotate buffers
        this._lastUsedBuffer = 1 - this._lastUsedBuffer;
        const result = this._buffers[this._lastUsedBuffer];
        // fill with background color
        result.data.set(this._backgroundFillData);
        return result;
    }
    static _createBackgroundFillData(WIDTH, HEIGHT, background) {
        const backgroundR = background.r;
        const backgroundG = background.g;
        const backgroundB = background.b;
        const backgroundA = background.a;
        const result = new Uint8ClampedArray(WIDTH * HEIGHT * 4);
        let offset = 0;
        for(let i = 0; i < HEIGHT; i++)for(let j = 0; j < WIDTH; j++){
            result[offset] = backgroundR;
            result[offset + 1] = backgroundG;
            result[offset + 2] = backgroundB;
            result[offset + 3] = backgroundA;
            offset += 4;
        }
        return result;
    }
}
class MinimapSamplingState {
    static compute(options, viewLineCount, oldSamplingState) {
        if (options.renderMinimap === 0 /* RenderMinimap.None */  || !options.isSampling) return [
            null,
            []
        ];
        // ratio is intentionally not part of the layout to avoid the layout changing all the time
        // so we need to recompute it again...
        const { minimapLineCount } = (0, _editorOptionsJs.EditorLayoutInfoComputer).computeContainedMinimapLineCount({
            viewLineCount: viewLineCount,
            scrollBeyondLastLine: options.scrollBeyondLastLine,
            paddingTop: options.paddingTop,
            paddingBottom: options.paddingBottom,
            height: options.editorHeight,
            lineHeight: options.lineHeight,
            pixelRatio: options.pixelRatio
        });
        const ratio = viewLineCount / minimapLineCount;
        const halfRatio = ratio / 2;
        if (!oldSamplingState || oldSamplingState.minimapLines.length === 0) {
            const result = [];
            result[0] = 1;
            if (minimapLineCount > 1) {
                for(let i = 0, lastIndex = minimapLineCount - 1; i < lastIndex; i++)result[i] = Math.round(i * ratio + halfRatio);
                result[minimapLineCount - 1] = viewLineCount;
            }
            return [
                new MinimapSamplingState(ratio, result),
                []
            ];
        }
        const oldMinimapLines = oldSamplingState.minimapLines;
        const oldLength = oldMinimapLines.length;
        const result = [];
        let oldIndex = 0;
        let oldDeltaLineCount = 0;
        let minViewLineNumber = 1;
        const MAX_EVENT_COUNT = 10; // generate at most 10 events, if there are more than 10 changes, just flush all previous data
        let events = [];
        let lastEvent = null;
        for(let i = 0; i < minimapLineCount; i++){
            const fromViewLineNumber = Math.max(minViewLineNumber, Math.round(i * ratio));
            const toViewLineNumber = Math.max(fromViewLineNumber, Math.round((i + 1) * ratio));
            while(oldIndex < oldLength && oldMinimapLines[oldIndex] < fromViewLineNumber){
                if (events.length < MAX_EVENT_COUNT) {
                    const oldMinimapLineNumber = oldIndex + 1 + oldDeltaLineCount;
                    if (lastEvent && lastEvent.type === "deleted" && lastEvent._oldIndex === oldIndex - 1) lastEvent.deleteToLineNumber++;
                    else {
                        lastEvent = {
                            type: "deleted",
                            _oldIndex: oldIndex,
                            deleteFromLineNumber: oldMinimapLineNumber,
                            deleteToLineNumber: oldMinimapLineNumber
                        };
                        events.push(lastEvent);
                    }
                    oldDeltaLineCount--;
                }
                oldIndex++;
            }
            let selectedViewLineNumber;
            if (oldIndex < oldLength && oldMinimapLines[oldIndex] <= toViewLineNumber) {
                // reuse the old sampled line
                selectedViewLineNumber = oldMinimapLines[oldIndex];
                oldIndex++;
            } else {
                if (i === 0) selectedViewLineNumber = 1;
                else if (i + 1 === minimapLineCount) selectedViewLineNumber = viewLineCount;
                else selectedViewLineNumber = Math.round(i * ratio + halfRatio);
                if (events.length < MAX_EVENT_COUNT) {
                    const oldMinimapLineNumber = oldIndex + 1 + oldDeltaLineCount;
                    if (lastEvent && lastEvent.type === "inserted" && lastEvent._i === i - 1) lastEvent.insertToLineNumber++;
                    else {
                        lastEvent = {
                            type: "inserted",
                            _i: i,
                            insertFromLineNumber: oldMinimapLineNumber,
                            insertToLineNumber: oldMinimapLineNumber
                        };
                        events.push(lastEvent);
                    }
                    oldDeltaLineCount++;
                }
            }
            result[i] = selectedViewLineNumber;
            minViewLineNumber = selectedViewLineNumber;
        }
        if (events.length < MAX_EVENT_COUNT) while(oldIndex < oldLength){
            const oldMinimapLineNumber = oldIndex + 1 + oldDeltaLineCount;
            if (lastEvent && lastEvent.type === "deleted" && lastEvent._oldIndex === oldIndex - 1) lastEvent.deleteToLineNumber++;
            else {
                lastEvent = {
                    type: "deleted",
                    _oldIndex: oldIndex,
                    deleteFromLineNumber: oldMinimapLineNumber,
                    deleteToLineNumber: oldMinimapLineNumber
                };
                events.push(lastEvent);
            }
            oldDeltaLineCount--;
            oldIndex++;
        }
        else // too many events, just give up
        events = [
            {
                type: "flush"
            }
        ];
        return [
            new MinimapSamplingState(ratio, result),
            events
        ];
    }
    constructor(samplingRatio, minimapLines // a map of 0-based minimap line indexes to 1-based view line numbers
    ){
        this.samplingRatio = samplingRatio;
        this.minimapLines = minimapLines;
    }
    modelLineToMinimapLine(lineNumber) {
        return Math.min(this.minimapLines.length, Math.max(1, Math.round(lineNumber / this.samplingRatio)));
    }
    /**
     * Will return null if the model line ranges are not intersecting with a sampled model line.
     */ modelLineRangeToMinimapLineRange(fromLineNumber, toLineNumber) {
        let fromLineIndex = this.modelLineToMinimapLine(fromLineNumber) - 1;
        while(fromLineIndex > 0 && this.minimapLines[fromLineIndex - 1] >= fromLineNumber)fromLineIndex--;
        let toLineIndex = this.modelLineToMinimapLine(toLineNumber) - 1;
        while(toLineIndex + 1 < this.minimapLines.length && this.minimapLines[toLineIndex + 1] <= toLineNumber)toLineIndex++;
        if (fromLineIndex === toLineIndex) {
            const sampledLineNumber = this.minimapLines[fromLineIndex];
            if (sampledLineNumber < fromLineNumber || sampledLineNumber > toLineNumber) // This line is not part of the sampled lines ==> nothing to do
            return null;
        }
        return [
            fromLineIndex + 1,
            toLineIndex + 1
        ];
    }
    /**
     * Will always return a range, even if it is not intersecting with a sampled model line.
     */ decorationLineRangeToMinimapLineRange(startLineNumber, endLineNumber) {
        let minimapLineStart = this.modelLineToMinimapLine(startLineNumber);
        let minimapLineEnd = this.modelLineToMinimapLine(endLineNumber);
        if (startLineNumber !== endLineNumber && minimapLineEnd === minimapLineStart) {
            if (minimapLineEnd === this.minimapLines.length) {
                if (minimapLineStart > 1) minimapLineStart--;
            } else minimapLineEnd++;
        }
        return [
            minimapLineStart,
            minimapLineEnd
        ];
    }
    onLinesDeleted(e) {
        // have the mapping be sticky
        const deletedLineCount = e.toLineNumber - e.fromLineNumber + 1;
        let changeStartIndex = this.minimapLines.length;
        let changeEndIndex = 0;
        for(let i = this.minimapLines.length - 1; i >= 0; i--){
            if (this.minimapLines[i] < e.fromLineNumber) break;
            if (this.minimapLines[i] <= e.toLineNumber) {
                // this line got deleted => move to previous available
                this.minimapLines[i] = Math.max(1, e.fromLineNumber - 1);
                changeStartIndex = Math.min(changeStartIndex, i);
                changeEndIndex = Math.max(changeEndIndex, i);
            } else this.minimapLines[i] -= deletedLineCount;
        }
        return [
            changeStartIndex,
            changeEndIndex
        ];
    }
    onLinesInserted(e) {
        // have the mapping be sticky
        const insertedLineCount = e.toLineNumber - e.fromLineNumber + 1;
        for(let i = this.minimapLines.length - 1; i >= 0; i--){
            if (this.minimapLines[i] < e.fromLineNumber) break;
            this.minimapLines[i] += insertedLineCount;
        }
    }
}
class Minimap extends (0, _viewPartJs.ViewPart) {
    constructor(context){
        super(context);
        this._sectionHeaderCache = new (0, _mapJs.LRUCache)(10, 1.5);
        this.tokensColorTracker = (0, _minimapTokensColorTrackerJs.MinimapTokensColorTracker).getInstance();
        this._selections = [];
        this._minimapSelections = null;
        this.options = new MinimapOptions(this._context.configuration, this._context.theme, this.tokensColorTracker);
        const [samplingState] = MinimapSamplingState.compute(this.options, this._context.viewModel.getLineCount(), null);
        this._samplingState = samplingState;
        this._shouldCheckSampling = false;
        this._actual = new InnerMinimap(context.theme, this);
    }
    dispose() {
        this._actual.dispose();
        super.dispose();
    }
    getDomNode() {
        return this._actual.getDomNode();
    }
    _onOptionsMaybeChanged() {
        const opts = new MinimapOptions(this._context.configuration, this._context.theme, this.tokensColorTracker);
        if (this.options.equals(opts)) return false;
        this.options = opts;
        this._recreateLineSampling();
        this._actual.onDidChangeOptions();
        return true;
    }
    // ---- begin view event handlers
    onConfigurationChanged(e) {
        return this._onOptionsMaybeChanged();
    }
    onCursorStateChanged(e) {
        this._selections = e.selections;
        this._minimapSelections = null;
        return this._actual.onSelectionChanged();
    }
    onDecorationsChanged(e) {
        if (e.affectsMinimap) return this._actual.onDecorationsChanged();
        return false;
    }
    onFlushed(e) {
        if (this._samplingState) this._shouldCheckSampling = true;
        return this._actual.onFlushed();
    }
    onLinesChanged(e) {
        if (this._samplingState) {
            const minimapLineRange = this._samplingState.modelLineRangeToMinimapLineRange(e.fromLineNumber, e.fromLineNumber + e.count - 1);
            if (minimapLineRange) return this._actual.onLinesChanged(minimapLineRange[0], minimapLineRange[1] - minimapLineRange[0] + 1);
            else return false;
        } else return this._actual.onLinesChanged(e.fromLineNumber, e.count);
    }
    onLinesDeleted(e) {
        if (this._samplingState) {
            const [changeStartIndex, changeEndIndex] = this._samplingState.onLinesDeleted(e);
            if (changeStartIndex <= changeEndIndex) this._actual.onLinesChanged(changeStartIndex + 1, changeEndIndex - changeStartIndex + 1);
            this._shouldCheckSampling = true;
            return true;
        } else return this._actual.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
    }
    onLinesInserted(e) {
        if (this._samplingState) {
            this._samplingState.onLinesInserted(e);
            this._shouldCheckSampling = true;
            return true;
        } else return this._actual.onLinesInserted(e.fromLineNumber, e.toLineNumber);
    }
    onScrollChanged(e) {
        return this._actual.onScrollChanged();
    }
    onThemeChanged(e) {
        this._actual.onThemeChanged();
        this._onOptionsMaybeChanged();
        return true;
    }
    onTokensChanged(e) {
        if (this._samplingState) {
            const ranges = [];
            for (const range of e.ranges){
                const minimapLineRange = this._samplingState.modelLineRangeToMinimapLineRange(range.fromLineNumber, range.toLineNumber);
                if (minimapLineRange) ranges.push({
                    fromLineNumber: minimapLineRange[0],
                    toLineNumber: minimapLineRange[1]
                });
            }
            if (ranges.length) return this._actual.onTokensChanged(ranges);
            else return false;
        } else return this._actual.onTokensChanged(e.ranges);
    }
    onTokensColorsChanged(e) {
        this._onOptionsMaybeChanged();
        return this._actual.onTokensColorsChanged();
    }
    onZonesChanged(e) {
        return this._actual.onZonesChanged();
    }
    // --- end event handlers
    prepareRender(ctx) {
        if (this._shouldCheckSampling) {
            this._shouldCheckSampling = false;
            this._recreateLineSampling();
        }
    }
    render(ctx) {
        let viewportStartLineNumber = ctx.visibleRange.startLineNumber;
        let viewportEndLineNumber = ctx.visibleRange.endLineNumber;
        if (this._samplingState) {
            viewportStartLineNumber = this._samplingState.modelLineToMinimapLine(viewportStartLineNumber);
            viewportEndLineNumber = this._samplingState.modelLineToMinimapLine(viewportEndLineNumber);
        }
        const minimapCtx = {
            viewportContainsWhitespaceGaps: ctx.viewportData.whitespaceViewportData.length > 0,
            scrollWidth: ctx.scrollWidth,
            scrollHeight: ctx.scrollHeight,
            viewportStartLineNumber: viewportStartLineNumber,
            viewportEndLineNumber: viewportEndLineNumber,
            viewportStartLineNumberVerticalOffset: ctx.getVerticalOffsetForLineNumber(viewportStartLineNumber),
            scrollTop: ctx.scrollTop,
            scrollLeft: ctx.scrollLeft,
            viewportWidth: ctx.viewportWidth,
            viewportHeight: ctx.viewportHeight
        };
        this._actual.render(minimapCtx);
    }
    //#region IMinimapModel
    _recreateLineSampling() {
        this._minimapSelections = null;
        const wasSampling = Boolean(this._samplingState);
        const [samplingState, events] = MinimapSamplingState.compute(this.options, this._context.viewModel.getLineCount(), this._samplingState);
        this._samplingState = samplingState;
        if (wasSampling && this._samplingState) // was sampling, is sampling
        for (const event of events)switch(event.type){
            case "deleted":
                this._actual.onLinesDeleted(event.deleteFromLineNumber, event.deleteToLineNumber);
                break;
            case "inserted":
                this._actual.onLinesInserted(event.insertFromLineNumber, event.insertToLineNumber);
                break;
            case "flush":
                this._actual.onFlushed();
                break;
        }
    }
    getLineCount() {
        if (this._samplingState) return this._samplingState.minimapLines.length;
        return this._context.viewModel.getLineCount();
    }
    getRealLineCount() {
        return this._context.viewModel.getLineCount();
    }
    getLineContent(lineNumber) {
        if (this._samplingState) return this._context.viewModel.getLineContent(this._samplingState.minimapLines[lineNumber - 1]);
        return this._context.viewModel.getLineContent(lineNumber);
    }
    getLineMaxColumn(lineNumber) {
        if (this._samplingState) return this._context.viewModel.getLineMaxColumn(this._samplingState.minimapLines[lineNumber - 1]);
        return this._context.viewModel.getLineMaxColumn(lineNumber);
    }
    getMinimapLinesRenderingData(startLineNumber, endLineNumber, needed) {
        if (this._samplingState) {
            const result = [];
            for(let lineIndex = 0, lineCount = endLineNumber - startLineNumber + 1; lineIndex < lineCount; lineIndex++)if (needed[lineIndex]) result[lineIndex] = this._context.viewModel.getViewLineData(this._samplingState.minimapLines[startLineNumber + lineIndex - 1]);
            else result[lineIndex] = null;
            return result;
        }
        return this._context.viewModel.getMinimapLinesRenderingData(startLineNumber, endLineNumber, needed).data;
    }
    getSelections() {
        if (this._minimapSelections === null) {
            if (this._samplingState) {
                this._minimapSelections = [];
                for (const selection of this._selections){
                    const [minimapLineStart, minimapLineEnd] = this._samplingState.decorationLineRangeToMinimapLineRange(selection.startLineNumber, selection.endLineNumber);
                    this._minimapSelections.push(new (0, _selectionJs.Selection)(minimapLineStart, selection.startColumn, minimapLineEnd, selection.endColumn));
                }
            } else this._minimapSelections = this._selections;
        }
        return this._minimapSelections;
    }
    getMinimapDecorationsInViewport(startLineNumber, endLineNumber) {
        const decorations = this._getMinimapDecorationsInViewport(startLineNumber, endLineNumber).filter((decoration)=>!decoration.options.minimap?.sectionHeaderStyle);
        if (this._samplingState) {
            const result = [];
            for (const decoration of decorations){
                if (!decoration.options.minimap) continue;
                const range = decoration.range;
                const minimapStartLineNumber = this._samplingState.modelLineToMinimapLine(range.startLineNumber);
                const minimapEndLineNumber = this._samplingState.modelLineToMinimapLine(range.endLineNumber);
                result.push(new (0, _viewModelJs.ViewModelDecoration)(new (0, _rangeJs.Range)(minimapStartLineNumber, range.startColumn, minimapEndLineNumber, range.endColumn), decoration.options));
            }
            return result;
        }
        return decorations;
    }
    getSectionHeaderDecorationsInViewport(startLineNumber, endLineNumber) {
        const minimapLineHeight = this.options.minimapLineHeight;
        const sectionHeaderFontSize = this.options.sectionHeaderFontSize;
        const headerHeightInMinimapLines = sectionHeaderFontSize / minimapLineHeight;
        startLineNumber = Math.floor(Math.max(1, startLineNumber - headerHeightInMinimapLines));
        return this._getMinimapDecorationsInViewport(startLineNumber, endLineNumber).filter((decoration)=>!!decoration.options.minimap?.sectionHeaderStyle);
    }
    _getMinimapDecorationsInViewport(startLineNumber, endLineNumber) {
        let visibleRange;
        if (this._samplingState) {
            const modelStartLineNumber = this._samplingState.minimapLines[startLineNumber - 1];
            const modelEndLineNumber = this._samplingState.minimapLines[endLineNumber - 1];
            visibleRange = new (0, _rangeJs.Range)(modelStartLineNumber, 1, modelEndLineNumber, this._context.viewModel.getLineMaxColumn(modelEndLineNumber));
        } else visibleRange = new (0, _rangeJs.Range)(startLineNumber, 1, endLineNumber, this._context.viewModel.getLineMaxColumn(endLineNumber));
        return this._context.viewModel.getMinimapDecorationsInRange(visibleRange);
    }
    getSectionHeaderText(decoration, fitWidth) {
        const headerText = decoration.options.minimap?.sectionHeaderText;
        if (!headerText) return null;
        const cachedText = this._sectionHeaderCache.get(headerText);
        if (cachedText) return cachedText;
        const fittedText = fitWidth(headerText);
        this._sectionHeaderCache.set(headerText, fittedText);
        return fittedText;
    }
    getOptions() {
        return this._context.viewModel.model.getOptions();
    }
    revealLineNumber(lineNumber) {
        if (this._samplingState) lineNumber = this._samplingState.minimapLines[lineNumber - 1];
        this._context.viewModel.revealRange("mouse", false, new (0, _rangeJs.Range)(lineNumber, 1, lineNumber, 1), 1 /* viewEvents.VerticalRevealType.Center */ , 0 /* ScrollType.Smooth */ );
    }
    setScrollTop(scrollTop) {
        this._context.viewModel.viewLayout.setScrollPosition({
            scrollTop: scrollTop
        }, 1 /* ScrollType.Immediate */ );
    }
}
class InnerMinimap extends (0, _lifecycleJs.Disposable) {
    constructor(theme, model){
        super();
        this._renderDecorations = false;
        this._gestureInProgress = false;
        this._theme = theme;
        this._model = model;
        this._lastRenderData = null;
        this._buffers = null;
        this._selectionColor = this._theme.getColor((0, _colorRegistryJs.minimapSelection));
        this._domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        (0, _viewPartJs.PartFingerprints).write(this._domNode, 9 /* PartFingerprint.Minimap */ );
        this._domNode.setClassName(this._getMinimapDomNodeClassName());
        this._domNode.setPosition("absolute");
        this._domNode.setAttribute("role", "presentation");
        this._domNode.setAttribute("aria-hidden", "true");
        this._shadow = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this._shadow.setClassName("minimap-shadow-hidden");
        this._domNode.appendChild(this._shadow);
        this._canvas = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("canvas"));
        this._canvas.setPosition("absolute");
        this._canvas.setLeft(0);
        this._domNode.appendChild(this._canvas);
        this._decorationsCanvas = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("canvas"));
        this._decorationsCanvas.setPosition("absolute");
        this._decorationsCanvas.setClassName("minimap-decorations-layer");
        this._decorationsCanvas.setLeft(0);
        this._domNode.appendChild(this._decorationsCanvas);
        this._slider = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this._slider.setPosition("absolute");
        this._slider.setClassName("minimap-slider");
        this._slider.setLayerHinting(true);
        this._slider.setContain("strict");
        this._domNode.appendChild(this._slider);
        this._sliderHorizontal = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this._sliderHorizontal.setPosition("absolute");
        this._sliderHorizontal.setClassName("minimap-slider-horizontal");
        this._slider.appendChild(this._sliderHorizontal);
        this._applyLayout();
        this._pointerDownListener = _domJs.addStandardDisposableListener(this._domNode.domNode, _domJs.EventType.POINTER_DOWN, (e)=>{
            e.preventDefault();
            const renderMinimap = this._model.options.renderMinimap;
            if (renderMinimap === 0 /* RenderMinimap.None */ ) return;
            if (!this._lastRenderData) return;
            if (this._model.options.size !== "proportional") {
                if (e.button === 0 && this._lastRenderData) {
                    // pretend the click occurred in the center of the slider
                    const position = _domJs.getDomNodePagePosition(this._slider.domNode);
                    const initialPosY = position.top + position.height / 2;
                    this._startSliderDragging(e, initialPosY, this._lastRenderData.renderedLayout);
                }
                return;
            }
            const minimapLineHeight = this._model.options.minimapLineHeight;
            const internalOffsetY = this._model.options.canvasInnerHeight / this._model.options.canvasOuterHeight * e.offsetY;
            const lineIndex = Math.floor(internalOffsetY / minimapLineHeight);
            let lineNumber = lineIndex + this._lastRenderData.renderedLayout.startLineNumber - this._lastRenderData.renderedLayout.topPaddingLineCount;
            lineNumber = Math.min(lineNumber, this._model.getLineCount());
            this._model.revealLineNumber(lineNumber);
        });
        this._sliderPointerMoveMonitor = new (0, _globalPointerMoveMonitorJs.GlobalPointerMoveMonitor)();
        this._sliderPointerDownListener = _domJs.addStandardDisposableListener(this._slider.domNode, _domJs.EventType.POINTER_DOWN, (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (e.button === 0 && this._lastRenderData) this._startSliderDragging(e, e.pageY, this._lastRenderData.renderedLayout);
        });
        this._gestureDisposable = (0, _touchJs.Gesture).addTarget(this._domNode.domNode);
        this._sliderTouchStartListener = _domJs.addDisposableListener(this._domNode.domNode, (0, _touchJs.EventType).Start, (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (this._lastRenderData) {
                this._slider.toggleClassName("active", true);
                this._gestureInProgress = true;
                this.scrollDueToTouchEvent(e);
            }
        }, {
            passive: false
        });
        this._sliderTouchMoveListener = _domJs.addDisposableListener(this._domNode.domNode, (0, _touchJs.EventType).Change, (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (this._lastRenderData && this._gestureInProgress) this.scrollDueToTouchEvent(e);
        }, {
            passive: false
        });
        this._sliderTouchEndListener = _domJs.addStandardDisposableListener(this._domNode.domNode, (0, _touchJs.EventType).End, (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this._gestureInProgress = false;
            this._slider.toggleClassName("active", false);
        });
    }
    _startSliderDragging(e, initialPosY, initialSliderState) {
        if (!e.target || !(e.target instanceof Element)) return;
        const initialPosX = e.pageX;
        this._slider.toggleClassName("active", true);
        const handlePointerMove = (posy, posx)=>{
            const minimapPosition = _domJs.getDomNodePagePosition(this._domNode.domNode);
            const pointerOrthogonalDelta = Math.min(Math.abs(posx - initialPosX), Math.abs(posx - minimapPosition.left), Math.abs(posx - minimapPosition.left - minimapPosition.width));
            if (_platformJs.isWindows && pointerOrthogonalDelta > POINTER_DRAG_RESET_DISTANCE) {
                // The pointer has wondered away from the scrollbar => reset dragging
                this._model.setScrollTop(initialSliderState.scrollTop);
                return;
            }
            const pointerDelta = posy - initialPosY;
            this._model.setScrollTop(initialSliderState.getDesiredScrollTopFromDelta(pointerDelta));
        };
        if (e.pageY !== initialPosY) handlePointerMove(e.pageY, initialPosX);
        this._sliderPointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (pointerMoveData)=>handlePointerMove(pointerMoveData.pageY, pointerMoveData.pageX), ()=>{
            this._slider.toggleClassName("active", false);
        });
    }
    scrollDueToTouchEvent(touch) {
        const startY = this._domNode.domNode.getBoundingClientRect().top;
        const scrollTop = this._lastRenderData.renderedLayout.getDesiredScrollTopFromTouchLocation(touch.pageY - startY);
        this._model.setScrollTop(scrollTop);
    }
    dispose() {
        this._pointerDownListener.dispose();
        this._sliderPointerMoveMonitor.dispose();
        this._sliderPointerDownListener.dispose();
        this._gestureDisposable.dispose();
        this._sliderTouchStartListener.dispose();
        this._sliderTouchMoveListener.dispose();
        this._sliderTouchEndListener.dispose();
        super.dispose();
    }
    _getMinimapDomNodeClassName() {
        const class_ = [
            "minimap"
        ];
        if (this._model.options.showSlider === "always") class_.push("slider-always");
        else class_.push("slider-mouseover");
        if (this._model.options.autohide) class_.push("autohide");
        return class_.join(" ");
    }
    getDomNode() {
        return this._domNode;
    }
    _applyLayout() {
        this._domNode.setLeft(this._model.options.minimapLeft);
        this._domNode.setWidth(this._model.options.minimapWidth);
        this._domNode.setHeight(this._model.options.minimapHeight);
        this._shadow.setHeight(this._model.options.minimapHeight);
        this._canvas.setWidth(this._model.options.canvasOuterWidth);
        this._canvas.setHeight(this._model.options.canvasOuterHeight);
        this._canvas.domNode.width = this._model.options.canvasInnerWidth;
        this._canvas.domNode.height = this._model.options.canvasInnerHeight;
        this._decorationsCanvas.setWidth(this._model.options.canvasOuterWidth);
        this._decorationsCanvas.setHeight(this._model.options.canvasOuterHeight);
        this._decorationsCanvas.domNode.width = this._model.options.canvasInnerWidth;
        this._decorationsCanvas.domNode.height = this._model.options.canvasInnerHeight;
        this._slider.setWidth(this._model.options.minimapWidth);
    }
    _getBuffer() {
        if (!this._buffers) {
            if (this._model.options.canvasInnerWidth > 0 && this._model.options.canvasInnerHeight > 0) this._buffers = new MinimapBuffers(this._canvas.domNode.getContext("2d"), this._model.options.canvasInnerWidth, this._model.options.canvasInnerHeight, this._model.options.backgroundColor);
        }
        return this._buffers ? this._buffers.getBuffer() : null;
    }
    // ---- begin view event handlers
    onDidChangeOptions() {
        this._lastRenderData = null;
        this._buffers = null;
        this._applyLayout();
        this._domNode.setClassName(this._getMinimapDomNodeClassName());
    }
    onSelectionChanged() {
        this._renderDecorations = true;
        return true;
    }
    onDecorationsChanged() {
        this._renderDecorations = true;
        return true;
    }
    onFlushed() {
        this._lastRenderData = null;
        return true;
    }
    onLinesChanged(changeFromLineNumber, changeCount) {
        if (this._lastRenderData) return this._lastRenderData.onLinesChanged(changeFromLineNumber, changeCount);
        return false;
    }
    onLinesDeleted(deleteFromLineNumber, deleteToLineNumber) {
        this._lastRenderData?.onLinesDeleted(deleteFromLineNumber, deleteToLineNumber);
        return true;
    }
    onLinesInserted(insertFromLineNumber, insertToLineNumber) {
        this._lastRenderData?.onLinesInserted(insertFromLineNumber, insertToLineNumber);
        return true;
    }
    onScrollChanged() {
        this._renderDecorations = true;
        return true;
    }
    onThemeChanged() {
        this._selectionColor = this._theme.getColor((0, _colorRegistryJs.minimapSelection));
        this._renderDecorations = true;
        return true;
    }
    onTokensChanged(ranges) {
        if (this._lastRenderData) return this._lastRenderData.onTokensChanged(ranges);
        return false;
    }
    onTokensColorsChanged() {
        this._lastRenderData = null;
        this._buffers = null;
        return true;
    }
    onZonesChanged() {
        this._lastRenderData = null;
        return true;
    }
    // --- end event handlers
    render(renderingCtx) {
        const renderMinimap = this._model.options.renderMinimap;
        if (renderMinimap === 0 /* RenderMinimap.None */ ) {
            this._shadow.setClassName("minimap-shadow-hidden");
            this._sliderHorizontal.setWidth(0);
            this._sliderHorizontal.setHeight(0);
            return;
        }
        if (renderingCtx.scrollLeft + renderingCtx.viewportWidth >= renderingCtx.scrollWidth) this._shadow.setClassName("minimap-shadow-hidden");
        else this._shadow.setClassName("minimap-shadow-visible");
        const layout = MinimapLayout.create(this._model.options, renderingCtx.viewportStartLineNumber, renderingCtx.viewportEndLineNumber, renderingCtx.viewportStartLineNumberVerticalOffset, renderingCtx.viewportHeight, renderingCtx.viewportContainsWhitespaceGaps, this._model.getLineCount(), this._model.getRealLineCount(), renderingCtx.scrollTop, renderingCtx.scrollHeight, this._lastRenderData ? this._lastRenderData.renderedLayout : null);
        this._slider.setDisplay(layout.sliderNeeded ? "block" : "none");
        this._slider.setTop(layout.sliderTop);
        this._slider.setHeight(layout.sliderHeight);
        // Compute horizontal slider coordinates
        this._sliderHorizontal.setLeft(0);
        this._sliderHorizontal.setWidth(this._model.options.minimapWidth);
        this._sliderHorizontal.setTop(0);
        this._sliderHorizontal.setHeight(layout.sliderHeight);
        this.renderDecorations(layout);
        this._lastRenderData = this.renderLines(layout);
    }
    renderDecorations(layout) {
        if (this._renderDecorations) {
            this._renderDecorations = false;
            const selections = this._model.getSelections();
            selections.sort((0, _rangeJs.Range).compareRangesUsingStarts);
            const decorations = this._model.getMinimapDecorationsInViewport(layout.startLineNumber, layout.endLineNumber);
            decorations.sort((a, b)=>(a.options.zIndex || 0) - (b.options.zIndex || 0));
            const { canvasInnerWidth, canvasInnerHeight } = this._model.options;
            const minimapLineHeight = this._model.options.minimapLineHeight;
            const minimapCharWidth = this._model.options.minimapCharWidth;
            const tabSize = this._model.getOptions().tabSize;
            const canvasContext = this._decorationsCanvas.domNode.getContext("2d");
            canvasContext.clearRect(0, 0, canvasInnerWidth, canvasInnerHeight);
            // We first need to render line highlights and then render decorations on top of those.
            // But we need to pick a single color for each line, and use that as a line highlight.
            // This needs to be the color of the decoration with the highest `zIndex`, but priority
            // is given to the selection.
            const highlightedLines = new ContiguousLineMap(layout.startLineNumber, layout.endLineNumber, false);
            this._renderSelectionLineHighlights(canvasContext, selections, highlightedLines, layout, minimapLineHeight);
            this._renderDecorationsLineHighlights(canvasContext, decorations, highlightedLines, layout, minimapLineHeight);
            const lineOffsetMap = new ContiguousLineMap(layout.startLineNumber, layout.endLineNumber, null);
            this._renderSelectionsHighlights(canvasContext, selections, lineOffsetMap, layout, minimapLineHeight, tabSize, minimapCharWidth, canvasInnerWidth);
            this._renderDecorationsHighlights(canvasContext, decorations, lineOffsetMap, layout, minimapLineHeight, tabSize, minimapCharWidth, canvasInnerWidth);
            this._renderSectionHeaders(layout);
        }
    }
    _renderSelectionLineHighlights(canvasContext, selections, highlightedLines, layout, minimapLineHeight) {
        if (!this._selectionColor || this._selectionColor.isTransparent()) return;
        canvasContext.fillStyle = this._selectionColor.transparent(0.5).toString();
        let y1 = 0;
        let y2 = 0;
        for (const selection of selections){
            const intersection = layout.intersectWithViewport(selection);
            if (!intersection) continue;
            const [startLineNumber, endLineNumber] = intersection;
            for(let line = startLineNumber; line <= endLineNumber; line++)highlightedLines.set(line, true);
            const yy1 = layout.getYForLineNumber(startLineNumber, minimapLineHeight);
            const yy2 = layout.getYForLineNumber(endLineNumber, minimapLineHeight);
            if (y2 >= yy1) // merge into previous
            y2 = yy2;
            else {
                if (y2 > y1) // flush
                canvasContext.fillRect((0, _editorOptionsJs.MINIMAP_GUTTER_WIDTH), y1, canvasContext.canvas.width, y2 - y1);
                y1 = yy1;
                y2 = yy2;
            }
        }
        if (y2 > y1) // flush
        canvasContext.fillRect((0, _editorOptionsJs.MINIMAP_GUTTER_WIDTH), y1, canvasContext.canvas.width, y2 - y1);
    }
    _renderDecorationsLineHighlights(canvasContext, decorations, highlightedLines, layout, minimapLineHeight) {
        const highlightColors = new Map();
        // Loop backwards to hit first decorations with higher `zIndex`
        for(let i = decorations.length - 1; i >= 0; i--){
            const decoration = decorations[i];
            const minimapOptions = decoration.options.minimap;
            if (!minimapOptions || minimapOptions.position !== 1 /* MinimapPosition.Inline */ ) continue;
            const intersection = layout.intersectWithViewport(decoration.range);
            if (!intersection) continue;
            const [startLineNumber, endLineNumber] = intersection;
            const decorationColor = minimapOptions.getColor(this._theme.value);
            if (!decorationColor || decorationColor.isTransparent()) continue;
            let highlightColor = highlightColors.get(decorationColor.toString());
            if (!highlightColor) {
                highlightColor = decorationColor.transparent(0.5).toString();
                highlightColors.set(decorationColor.toString(), highlightColor);
            }
            canvasContext.fillStyle = highlightColor;
            for(let line = startLineNumber; line <= endLineNumber; line++){
                if (highlightedLines.has(line)) continue;
                highlightedLines.set(line, true);
                const y = layout.getYForLineNumber(startLineNumber, minimapLineHeight);
                canvasContext.fillRect((0, _editorOptionsJs.MINIMAP_GUTTER_WIDTH), y, canvasContext.canvas.width, minimapLineHeight);
            }
        }
    }
    _renderSelectionsHighlights(canvasContext, selections, lineOffsetMap, layout, lineHeight, tabSize, characterWidth, canvasInnerWidth) {
        if (!this._selectionColor || this._selectionColor.isTransparent()) return;
        for (const selection of selections){
            const intersection = layout.intersectWithViewport(selection);
            if (!intersection) continue;
            const [startLineNumber, endLineNumber] = intersection;
            for(let line = startLineNumber; line <= endLineNumber; line++)this.renderDecorationOnLine(canvasContext, lineOffsetMap, selection, this._selectionColor, layout, line, lineHeight, lineHeight, tabSize, characterWidth, canvasInnerWidth);
        }
    }
    _renderDecorationsHighlights(canvasContext, decorations, lineOffsetMap, layout, minimapLineHeight, tabSize, characterWidth, canvasInnerWidth) {
        // Loop forwards to hit first decorations with lower `zIndex`
        for (const decoration of decorations){
            const minimapOptions = decoration.options.minimap;
            if (!minimapOptions) continue;
            const intersection = layout.intersectWithViewport(decoration.range);
            if (!intersection) continue;
            const [startLineNumber, endLineNumber] = intersection;
            const decorationColor = minimapOptions.getColor(this._theme.value);
            if (!decorationColor || decorationColor.isTransparent()) continue;
            for(let line = startLineNumber; line <= endLineNumber; line++)switch(minimapOptions.position){
                case 1 /* MinimapPosition.Inline */ :
                    this.renderDecorationOnLine(canvasContext, lineOffsetMap, decoration.range, decorationColor, layout, line, minimapLineHeight, minimapLineHeight, tabSize, characterWidth, canvasInnerWidth);
                    continue;
                case 2 /* MinimapPosition.Gutter */ :
                    {
                        const y = layout.getYForLineNumber(line, minimapLineHeight);
                        const x = 2;
                        this.renderDecoration(canvasContext, decorationColor, x, y, GUTTER_DECORATION_WIDTH, minimapLineHeight);
                        continue;
                    }
            }
        }
    }
    renderDecorationOnLine(canvasContext, lineOffsetMap, decorationRange, decorationColor, layout, lineNumber, height, minimapLineHeight, tabSize, charWidth, canvasInnerWidth) {
        const y = layout.getYForLineNumber(lineNumber, minimapLineHeight);
        // Skip rendering the line if it's vertically outside our viewport
        if (y + height < 0 || y > this._model.options.canvasInnerHeight) return;
        const { startLineNumber, endLineNumber } = decorationRange;
        const startColumn = startLineNumber === lineNumber ? decorationRange.startColumn : 1;
        const endColumn = endLineNumber === lineNumber ? decorationRange.endColumn : this._model.getLineMaxColumn(lineNumber);
        const x1 = this.getXOffsetForPosition(lineOffsetMap, lineNumber, startColumn, tabSize, charWidth, canvasInnerWidth);
        const x2 = this.getXOffsetForPosition(lineOffsetMap, lineNumber, endColumn, tabSize, charWidth, canvasInnerWidth);
        this.renderDecoration(canvasContext, decorationColor, x1, y, x2 - x1, height);
    }
    getXOffsetForPosition(lineOffsetMap, lineNumber, column, tabSize, charWidth, canvasInnerWidth) {
        if (column === 1) return 0, _editorOptionsJs.MINIMAP_GUTTER_WIDTH;
        const minimumXOffset = (column - 1) * charWidth;
        if (minimumXOffset >= canvasInnerWidth) // there is no need to look at actual characters,
        // as this column is certainly after the minimap width
        return canvasInnerWidth;
        // Cache line offset data so that it is only read once per line
        let lineIndexToXOffset = lineOffsetMap.get(lineNumber);
        if (!lineIndexToXOffset) {
            const lineData = this._model.getLineContent(lineNumber);
            lineIndexToXOffset = [
                (0, _editorOptionsJs.MINIMAP_GUTTER_WIDTH)
            ];
            let prevx = (0, _editorOptionsJs.MINIMAP_GUTTER_WIDTH);
            for(let i = 1; i < lineData.length + 1; i++){
                const charCode = lineData.charCodeAt(i - 1);
                const dx = charCode === 9 /* CharCode.Tab */  ? tabSize * charWidth : _stringsJs.isFullWidthCharacter(charCode) ? 2 * charWidth : charWidth;
                const x = prevx + dx;
                if (x >= canvasInnerWidth) {
                    // no need to keep on going, as we've hit the canvas width
                    lineIndexToXOffset[i] = canvasInnerWidth;
                    break;
                }
                lineIndexToXOffset[i] = x;
                prevx = x;
            }
            lineOffsetMap.set(lineNumber, lineIndexToXOffset);
        }
        if (column - 1 < lineIndexToXOffset.length) return lineIndexToXOffset[column - 1];
        // goes over the canvas width
        return canvasInnerWidth;
    }
    renderDecoration(canvasContext, decorationColor, x, y, width, height) {
        canvasContext.fillStyle = decorationColor && decorationColor.toString() || "";
        canvasContext.fillRect(x, y, width, height);
    }
    _renderSectionHeaders(layout) {
        const minimapLineHeight = this._model.options.minimapLineHeight;
        const sectionHeaderFontSize = this._model.options.sectionHeaderFontSize;
        const sectionHeaderLetterSpacing = this._model.options.sectionHeaderLetterSpacing;
        const backgroundFillHeight = sectionHeaderFontSize * 1.5;
        const { canvasInnerWidth } = this._model.options;
        const backgroundColor = this._model.options.backgroundColor;
        const backgroundFill = `rgb(${backgroundColor.r} ${backgroundColor.g} ${backgroundColor.b} / .7)`;
        const foregroundColor = this._model.options.sectionHeaderFontColor;
        const foregroundFill = `rgb(${foregroundColor.r} ${foregroundColor.g} ${foregroundColor.b})`;
        const separatorStroke = foregroundFill;
        const canvasContext = this._decorationsCanvas.domNode.getContext("2d");
        canvasContext.letterSpacing = sectionHeaderLetterSpacing + "px";
        canvasContext.font = "500 " + sectionHeaderFontSize + "px " + this._model.options.sectionHeaderFontFamily;
        canvasContext.strokeStyle = separatorStroke;
        canvasContext.lineWidth = 0.2;
        const decorations = this._model.getSectionHeaderDecorationsInViewport(layout.startLineNumber, layout.endLineNumber);
        decorations.sort((a, b)=>a.range.startLineNumber - b.range.startLineNumber);
        const fitWidth = InnerMinimap._fitSectionHeader.bind(null, canvasContext, canvasInnerWidth - (0, _editorOptionsJs.MINIMAP_GUTTER_WIDTH));
        for (const decoration of decorations){
            const y = layout.getYForLineNumber(decoration.range.startLineNumber, minimapLineHeight) + sectionHeaderFontSize;
            const backgroundFillY = y - sectionHeaderFontSize;
            const separatorY = backgroundFillY + 2;
            const headerText = this._model.getSectionHeaderText(decoration, fitWidth);
            InnerMinimap._renderSectionLabel(canvasContext, headerText, decoration.options.minimap?.sectionHeaderStyle === 2 /* MinimapSectionHeaderStyle.Underlined */ , backgroundFill, foregroundFill, canvasInnerWidth, backgroundFillY, backgroundFillHeight, y, separatorY);
        }
    }
    static _fitSectionHeader(target, maxWidth, headerText) {
        if (!headerText) return headerText;
        const ellipsis = "\u2026";
        const width = target.measureText(headerText).width;
        const ellipsisWidth = target.measureText(ellipsis).width;
        if (width <= maxWidth || width <= ellipsisWidth) return headerText;
        const len = headerText.length;
        const averageCharWidth = width / headerText.length;
        const maxCharCount = Math.floor((maxWidth - ellipsisWidth) / averageCharWidth) - 1;
        // Find a halfway point that isn't after whitespace
        let halfCharCount = Math.ceil(maxCharCount / 2);
        while(halfCharCount > 0 && /\s/.test(headerText[halfCharCount - 1]))--halfCharCount;
        // Split with ellipsis
        return headerText.substring(0, halfCharCount) + ellipsis + headerText.substring(len - (maxCharCount - halfCharCount));
    }
    static _renderSectionLabel(target, headerText, hasSeparatorLine, backgroundFill, foregroundFill, minimapWidth, backgroundFillY, backgroundFillHeight, textY, separatorY) {
        if (headerText) {
            target.fillStyle = backgroundFill;
            target.fillRect(0, backgroundFillY, minimapWidth, backgroundFillHeight);
            target.fillStyle = foregroundFill;
            target.fillText(headerText, (0, _editorOptionsJs.MINIMAP_GUTTER_WIDTH), textY);
        }
        if (hasSeparatorLine) {
            target.beginPath();
            target.moveTo(0, separatorY);
            target.lineTo(minimapWidth, separatorY);
            target.closePath();
            target.stroke();
        }
    }
    renderLines(layout) {
        const startLineNumber = layout.startLineNumber;
        const endLineNumber = layout.endLineNumber;
        const minimapLineHeight = this._model.options.minimapLineHeight;
        // Check if nothing changed w.r.t. lines from last frame
        if (this._lastRenderData && this._lastRenderData.linesEquals(layout)) {
            const _lastData = this._lastRenderData._get();
            // Nice!! Nothing changed from last frame
            return new RenderData(layout, _lastData.imageData, _lastData.lines);
        }
        // Oh well!! We need to repaint some lines...
        const imageData = this._getBuffer();
        if (!imageData) // 0 width or 0 height canvas, nothing to do
        return null;
        // Render untouched lines by using last rendered data.
        const [_dirtyY1, _dirtyY2, needed] = InnerMinimap._renderUntouchedLines(imageData, layout.topPaddingLineCount, startLineNumber, endLineNumber, minimapLineHeight, this._lastRenderData);
        // Fetch rendering info from view model for rest of lines that need rendering.
        const lineInfo = this._model.getMinimapLinesRenderingData(startLineNumber, endLineNumber, needed);
        const tabSize = this._model.getOptions().tabSize;
        const defaultBackground = this._model.options.defaultBackgroundColor;
        const background = this._model.options.backgroundColor;
        const foregroundAlpha = this._model.options.foregroundAlpha;
        const tokensColorTracker = this._model.tokensColorTracker;
        const useLighterFont = tokensColorTracker.backgroundIsLight();
        const renderMinimap = this._model.options.renderMinimap;
        const charRenderer = this._model.options.charRenderer();
        const fontScale = this._model.options.fontScale;
        const minimapCharWidth = this._model.options.minimapCharWidth;
        const baseCharHeight = renderMinimap === 1 /* RenderMinimap.Text */  ? 2 /* Constants.BASE_CHAR_HEIGHT */  : 3;
        const renderMinimapLineHeight = baseCharHeight * fontScale;
        const innerLinePadding = minimapLineHeight > renderMinimapLineHeight ? Math.floor((minimapLineHeight - renderMinimapLineHeight) / 2) : 0;
        // Render the rest of lines
        const backgroundA = background.a / 255;
        const renderBackground = new (0, _rgbaJs.RGBA8)(Math.round((background.r - defaultBackground.r) * backgroundA + defaultBackground.r), Math.round((background.g - defaultBackground.g) * backgroundA + defaultBackground.g), Math.round((background.b - defaultBackground.b) * backgroundA + defaultBackground.b), 255);
        let dy = layout.topPaddingLineCount * minimapLineHeight;
        const renderedLines = [];
        for(let lineIndex = 0, lineCount = endLineNumber - startLineNumber + 1; lineIndex < lineCount; lineIndex++){
            if (needed[lineIndex]) InnerMinimap._renderLine(imageData, renderBackground, background.a, useLighterFont, renderMinimap, minimapCharWidth, tokensColorTracker, foregroundAlpha, charRenderer, dy, innerLinePadding, tabSize, lineInfo[lineIndex], fontScale, minimapLineHeight);
            renderedLines[lineIndex] = new MinimapLine(dy);
            dy += minimapLineHeight;
        }
        const dirtyY1 = _dirtyY1 === -1 ? 0 : _dirtyY1;
        const dirtyY2 = _dirtyY2 === -1 ? imageData.height : _dirtyY2;
        const dirtyHeight = dirtyY2 - dirtyY1;
        // Finally, paint to the canvas
        const ctx = this._canvas.domNode.getContext("2d");
        ctx.putImageData(imageData, 0, 0, 0, dirtyY1, imageData.width, dirtyHeight);
        // Save rendered data for reuse on next frame if possible
        return new RenderData(layout, imageData, renderedLines);
    }
    static _renderUntouchedLines(target, topPaddingLineCount, startLineNumber, endLineNumber, minimapLineHeight, lastRenderData) {
        const needed = [];
        if (!lastRenderData) {
            for(let i = 0, len = endLineNumber - startLineNumber + 1; i < len; i++)needed[i] = true;
            return [
                -1,
                -1,
                needed
            ];
        }
        const _lastData = lastRenderData._get();
        const lastTargetData = _lastData.imageData.data;
        const lastStartLineNumber = _lastData.rendLineNumberStart;
        const lastLines = _lastData.lines;
        const lastLinesLength = lastLines.length;
        const WIDTH = target.width;
        const targetData = target.data;
        const maxDestPixel = (endLineNumber - startLineNumber + 1) * minimapLineHeight * WIDTH * 4;
        let dirtyPixel1 = -1; // the pixel offset up to which all the data is equal to the prev frame
        let dirtyPixel2 = -1; // the pixel offset after which all the data is equal to the prev frame
        let copySourceStart = -1;
        let copySourceEnd = -1;
        let copyDestStart = -1;
        let copyDestEnd = -1;
        let dest_dy = topPaddingLineCount * minimapLineHeight;
        for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++){
            const lineIndex = lineNumber - startLineNumber;
            const lastLineIndex = lineNumber - lastStartLineNumber;
            const source_dy = lastLineIndex >= 0 && lastLineIndex < lastLinesLength ? lastLines[lastLineIndex].dy : -1;
            if (source_dy === -1) {
                needed[lineIndex] = true;
                dest_dy += minimapLineHeight;
                continue;
            }
            const sourceStart = source_dy * WIDTH * 4;
            const sourceEnd = (source_dy + minimapLineHeight) * WIDTH * 4;
            const destStart = dest_dy * WIDTH * 4;
            const destEnd = (dest_dy + minimapLineHeight) * WIDTH * 4;
            if (copySourceEnd === sourceStart && copyDestEnd === destStart) {
                // contiguous zone => extend copy request
                copySourceEnd = sourceEnd;
                copyDestEnd = destEnd;
            } else {
                if (copySourceStart !== -1) {
                    // flush existing copy request
                    targetData.set(lastTargetData.subarray(copySourceStart, copySourceEnd), copyDestStart);
                    if (dirtyPixel1 === -1 && copySourceStart === 0 && copySourceStart === copyDestStart) dirtyPixel1 = copySourceEnd;
                    if (dirtyPixel2 === -1 && copySourceEnd === maxDestPixel && copySourceStart === copyDestStart) dirtyPixel2 = copySourceStart;
                }
                copySourceStart = sourceStart;
                copySourceEnd = sourceEnd;
                copyDestStart = destStart;
                copyDestEnd = destEnd;
            }
            needed[lineIndex] = false;
            dest_dy += minimapLineHeight;
        }
        if (copySourceStart !== -1) {
            // flush existing copy request
            targetData.set(lastTargetData.subarray(copySourceStart, copySourceEnd), copyDestStart);
            if (dirtyPixel1 === -1 && copySourceStart === 0 && copySourceStart === copyDestStart) dirtyPixel1 = copySourceEnd;
            if (dirtyPixel2 === -1 && copySourceEnd === maxDestPixel && copySourceStart === copyDestStart) dirtyPixel2 = copySourceStart;
        }
        const dirtyY1 = dirtyPixel1 === -1 ? -1 : dirtyPixel1 / (WIDTH * 4);
        const dirtyY2 = dirtyPixel2 === -1 ? -1 : dirtyPixel2 / (WIDTH * 4);
        return [
            dirtyY1,
            dirtyY2,
            needed
        ];
    }
    static _renderLine(target, backgroundColor, backgroundAlpha, useLighterFont, renderMinimap, charWidth, colorTracker, foregroundAlpha, minimapCharRenderer, dy, innerLinePadding, tabSize, lineData, fontScale, minimapLineHeight) {
        const content = lineData.content;
        const tokens = lineData.tokens;
        const maxDx = target.width - charWidth;
        const force1pxHeight = minimapLineHeight === 1;
        let dx = (0, _editorOptionsJs.MINIMAP_GUTTER_WIDTH);
        let charIndex = 0;
        let tabsCharDelta = 0;
        for(let tokenIndex = 0, tokensLen = tokens.getCount(); tokenIndex < tokensLen; tokenIndex++){
            const tokenEndIndex = tokens.getEndOffset(tokenIndex);
            const tokenColorId = tokens.getForeground(tokenIndex);
            const tokenColor = colorTracker.getColor(tokenColorId);
            for(; charIndex < tokenEndIndex; charIndex++){
                if (dx > maxDx) // hit edge of minimap
                return;
                const charCode = content.charCodeAt(charIndex);
                if (charCode === 9 /* CharCode.Tab */ ) {
                    const insertSpacesCount = tabSize - (charIndex + tabsCharDelta) % tabSize;
                    tabsCharDelta += insertSpacesCount - 1;
                    // No need to render anything since tab is invisible
                    dx += insertSpacesCount * charWidth;
                } else if (charCode === 32 /* CharCode.Space */ ) // No need to render anything since space is invisible
                dx += charWidth;
                else {
                    // Render twice for a full width character
                    const count = _stringsJs.isFullWidthCharacter(charCode) ? 2 : 1;
                    for(let i = 0; i < count; i++){
                        if (renderMinimap === 2 /* RenderMinimap.Blocks */ ) minimapCharRenderer.blockRenderChar(target, dx, dy + innerLinePadding, tokenColor, foregroundAlpha, backgroundColor, backgroundAlpha, force1pxHeight);
                        else minimapCharRenderer.renderChar(target, dx, dy + innerLinePadding, charCode, tokenColor, foregroundAlpha, backgroundColor, backgroundAlpha, fontScale, useLighterFont, force1pxHeight);
                        dx += charWidth;
                        if (dx > maxDx) // hit edge of minimap
                        return;
                    }
                }
            }
        }
    }
}
class ContiguousLineMap {
    constructor(startLineNumber, endLineNumber, defaultValue){
        this._startLineNumber = startLineNumber;
        this._endLineNumber = endLineNumber;
        this._defaultValue = defaultValue;
        this._values = [];
        for(let i = 0, count = this._endLineNumber - this._startLineNumber + 1; i < count; i++)this._values[i] = defaultValue;
    }
    has(lineNumber) {
        return this.get(lineNumber) !== this._defaultValue;
    }
    set(lineNumber, value) {
        if (lineNumber < this._startLineNumber || lineNumber > this._endLineNumber) return;
        this._values[lineNumber - this._startLineNumber] = value;
    }
    get(lineNumber) {
        if (lineNumber < this._startLineNumber || lineNumber > this._endLineNumber) return this._defaultValue;
        return this._values[lineNumber - this._startLineNumber];
    }
}

},{"./minimap.css":"lKmpz","../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/fastDomNode.js":"2SADf","../../../../base/browser/globalPointerMoveMonitor.js":"iDfLk","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/platform.js":"7maJO","../../../../base/common/strings.js":"aA9I1","../../view/viewLayer.js":"7v2Ri","../../view/viewPart.js":"kTsLR","../../../common/config/editorOptions.js":"3Xi00","../../../common/core/range.js":"jmUPh","../../../common/core/rgba.js":"bMAHi","../../../common/viewModel/minimapTokensColorTracker.js":"jCndl","../../../common/viewModel.js":"5EHxj","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../common/core/selection.js":"kcwzU","../../../../base/browser/touch.js":"6iGQn","./minimapCharRendererFactory.js":"gBBnn","../../../../base/common/functional.js":"75R2i","../../../../base/common/map.js":"leSjz","../../../../base/browser/fonts.js":"92j2K","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lKmpz":[function() {},{}],"bMAHi":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /**
 * A very VM friendly rgba datastructure.
 * Please don't touch unless you take a look at the IR.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RGBA8", ()=>RGBA8);
class RGBA8 {
    static{
        this.Empty = new RGBA8(0, 0, 0, 0);
    }
    constructor(r, g, b, a){
        this._rgba8Brand = undefined;
        this.r = RGBA8._clamp(r);
        this.g = RGBA8._clamp(g);
        this.b = RGBA8._clamp(b);
        this.a = RGBA8._clamp(a);
    }
    equals(other) {
        return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
    static _clamp(c) {
        if (c < 0) return 0;
        if (c > 255) return 255;
        return c | 0;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jCndl":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinimapTokensColorTracker", ()=>MinimapTokensColorTracker);
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _rgbaJs = require("../core/rgba.js");
var _languagesJs = require("../languages.js");
class MinimapTokensColorTracker extends (0, _lifecycleJs.Disposable) {
    static{
        this._INSTANCE = null;
    }
    static getInstance() {
        if (!this._INSTANCE) this._INSTANCE = (0, _lifecycleJs.markAsSingleton)(new MinimapTokensColorTracker());
        return this._INSTANCE;
    }
    constructor(){
        super();
        this._onDidChange = new (0, _eventJs.Emitter)();
        this.onDidChange = this._onDidChange.event;
        this._updateColorMap();
        this._register((0, _languagesJs.TokenizationRegistry).onDidChange((e)=>{
            if (e.changedColorMap) this._updateColorMap();
        }));
    }
    _updateColorMap() {
        const colorMap = (0, _languagesJs.TokenizationRegistry).getColorMap();
        if (!colorMap) {
            this._colors = [
                (0, _rgbaJs.RGBA8).Empty
            ];
            this._backgroundIsLight = true;
            return;
        }
        this._colors = [
            (0, _rgbaJs.RGBA8).Empty
        ];
        for(let colorId = 1; colorId < colorMap.length; colorId++){
            const source = colorMap[colorId].rgba;
            // Use a VM friendly data-type
            this._colors[colorId] = new (0, _rgbaJs.RGBA8)(source.r, source.g, source.b, Math.round(source.a * 255));
        }
        const backgroundLuminosity = colorMap[2 /* ColorId.DefaultBackground */ ].getRelativeLuminance();
        this._backgroundIsLight = backgroundLuminosity >= 0.5;
        this._onDidChange.fire(undefined);
    }
    getColor(colorId) {
        if (colorId < 1 || colorId >= this._colors.length) // background color (basically invisible)
        colorId = 2 /* ColorId.DefaultBackground */ ;
        return this._colors[colorId];
    }
    backgroundIsLight() {
        return this._backgroundIsLight;
    }
}

},{"../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../core/rgba.js":"bMAHi","../languages.js":"g5n96","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gBBnn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates character renderers. It takes a 'scale' that determines how large
 * characters should be drawn. Using this, it draws data into a canvas and
 * then downsamples the characters as necessary for the current display.
 * This makes rendering more efficient, rather than drawing a full (tiny)
 * font, or downsampling in real-time.
 */ parcelHelpers.export(exports, "MinimapCharRendererFactory", ()=>MinimapCharRendererFactory);
var _minimapCharRendererJs = require("./minimapCharRenderer.js");
var _minimapCharSheetJs = require("./minimapCharSheet.js");
var _minimapPreBakedJs = require("./minimapPreBaked.js");
var _uintJs = require("../../../../base/common/uint.js");
class MinimapCharRendererFactory {
    /**
     * Creates a new character renderer factory with the given scale.
     */ static create(scale, fontFamily) {
        // renderers are immutable. By default we'll 'create' a new minimap
        // character renderer whenever we switch editors, no need to do extra work.
        if (this.lastCreated && scale === this.lastCreated.scale && fontFamily === this.lastFontFamily) return this.lastCreated;
        let factory;
        if ((0, _minimapPreBakedJs.prebakedMiniMaps)[scale]) factory = new (0, _minimapCharRendererJs.MinimapCharRenderer)((0, _minimapPreBakedJs.prebakedMiniMaps)[scale](), scale);
        else factory = MinimapCharRendererFactory.createFromSampleData(MinimapCharRendererFactory.createSampleData(fontFamily).data, scale);
        this.lastFontFamily = fontFamily;
        this.lastCreated = factory;
        return factory;
    }
    /**
     * Creates the font sample data, writing to a canvas.
     */ static createSampleData(fontFamily) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.style.height = `${16 /* Constants.SAMPLED_CHAR_HEIGHT */ }px`;
        canvas.height = 16 /* Constants.SAMPLED_CHAR_HEIGHT */ ;
        canvas.width = 960 /* Constants.SAMPLED_CHAR_WIDTH */ ;
        canvas.style.width = "960px";
        ctx.fillStyle = "#ffffff";
        ctx.font = `bold ${16 /* Constants.SAMPLED_CHAR_HEIGHT */ }px ${fontFamily}`;
        ctx.textBaseline = "middle";
        let x = 0;
        for (const code of (0, _minimapCharSheetJs.allCharCodes)){
            ctx.fillText(String.fromCharCode(code), x, 8);
            x += 10 /* Constants.SAMPLED_CHAR_WIDTH */ ;
        }
        return ctx.getImageData(0, 0, 960 /* Constants.SAMPLED_CHAR_WIDTH */ , 16 /* Constants.SAMPLED_CHAR_HEIGHT */ );
    }
    /**
     * Creates a character renderer from the canvas sample data.
     */ static createFromSampleData(source, scale) {
        const expectedLength = 61440 /* Constants.CHAR_COUNT */ ;
        if (source.length !== expectedLength) throw new Error("Unexpected source in MinimapCharRenderer");
        const charData = MinimapCharRendererFactory._downsample(source, scale);
        return new (0, _minimapCharRendererJs.MinimapCharRenderer)(charData, scale);
    }
    static _downsampleChar(source, sourceOffset, dest, destOffset, scale) {
        const width = 1 /* Constants.BASE_CHAR_WIDTH */  * scale;
        const height = 2 /* Constants.BASE_CHAR_HEIGHT */  * scale;
        let targetIndex = destOffset;
        let brightest = 0;
        // This is essentially an ad-hoc rescaling algorithm. Standard approaches
        // like bicubic interpolation are awesome for scaling between image sizes,
        // but don't work so well when scaling to very small pixel values, we end
        // up with blurry, indistinct forms.
        //
        // The approach taken here is simply mapping each source pixel to the target
        // pixels, and taking the weighted values for all pixels in each, and then
        // averaging them out. Finally we apply an intensity boost in _downsample,
        // since when scaling to the smallest pixel sizes there's more black space
        // which causes characters to be much less distinct.
        for(let y = 0; y < height; y++){
            // 1. For this destination pixel, get the source pixels we're sampling
            // from (x1, y1) to the next pixel (x2, y2)
            const sourceY1 = y / height * 16 /* Constants.SAMPLED_CHAR_HEIGHT */ ;
            const sourceY2 = (y + 1) / height * 16 /* Constants.SAMPLED_CHAR_HEIGHT */ ;
            for(let x = 0; x < width; x++){
                const sourceX1 = x / width * 10 /* Constants.SAMPLED_CHAR_WIDTH */ ;
                const sourceX2 = (x + 1) / width * 10 /* Constants.SAMPLED_CHAR_WIDTH */ ;
                // 2. Sample all of them, summing them up and weighting them. Similar
                // to bilinear interpolation.
                let value = 0;
                let samples = 0;
                for(let sy = sourceY1; sy < sourceY2; sy++){
                    const sourceRow = sourceOffset + Math.floor(sy) * 3840 /* Constants.RGBA_SAMPLED_ROW_WIDTH */ ;
                    const yBalance = 1 - (sy - Math.floor(sy));
                    for(let sx = sourceX1; sx < sourceX2; sx++){
                        const xBalance = 1 - (sx - Math.floor(sx));
                        const sourceIndex = sourceRow + Math.floor(sx) * 4 /* Constants.RGBA_CHANNELS_CNT */ ;
                        const weight = xBalance * yBalance;
                        samples += weight;
                        value += source[sourceIndex] * source[sourceIndex + 3] / 255 * weight;
                    }
                }
                const final = value / samples;
                brightest = Math.max(brightest, final);
                dest[targetIndex++] = (0, _uintJs.toUint8)(final);
            }
        }
        return brightest;
    }
    static _downsample(data, scale) {
        const pixelsPerCharacter = 2 /* Constants.BASE_CHAR_HEIGHT */  * scale * 1 /* Constants.BASE_CHAR_WIDTH */  * scale;
        const resultLen = pixelsPerCharacter * 96 /* Constants.CHAR_COUNT */ ;
        const result = new Uint8ClampedArray(resultLen);
        let resultOffset = 0;
        let sourceOffset = 0;
        let brightest = 0;
        for(let charIndex = 0; charIndex < 96 /* Constants.CHAR_COUNT */ ; charIndex++){
            brightest = Math.max(brightest, this._downsampleChar(data, sourceOffset, result, resultOffset, scale));
            resultOffset += pixelsPerCharacter;
            sourceOffset += 40 /* Constants.RGBA_CHANNELS_CNT */ ;
        }
        if (brightest > 0) {
            const adjust = 255 / brightest;
            for(let i = 0; i < resultLen; i++)result[i] *= adjust;
        }
        return result;
    }
}

},{"./minimapCharRenderer.js":"8lGId","./minimapCharSheet.js":"3PgLn","./minimapPreBaked.js":"hUPHL","../../../../base/common/uint.js":"7fnps","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8lGId":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinimapCharRenderer", ()=>MinimapCharRenderer);
var _minimapCharSheetJs = require("./minimapCharSheet.js");
var _uintJs = require("../../../../base/common/uint.js");
class MinimapCharRenderer {
    constructor(charData, scale){
        this.scale = scale;
        this._minimapCharRendererBrand = undefined;
        this.charDataNormal = MinimapCharRenderer.soften(charData, 0.8);
        this.charDataLight = MinimapCharRenderer.soften(charData, 50 / 60);
    }
    static soften(input, ratio) {
        const result = new Uint8ClampedArray(input.length);
        for(let i = 0, len = input.length; i < len; i++)result[i] = (0, _uintJs.toUint8)(input[i] * ratio);
        return result;
    }
    renderChar(target, dx, dy, chCode, color, foregroundAlpha, backgroundColor, backgroundAlpha, fontScale, useLighterFont, force1pxHeight) {
        const charWidth = 1 /* Constants.BASE_CHAR_WIDTH */  * this.scale;
        const charHeight = 2 /* Constants.BASE_CHAR_HEIGHT */  * this.scale;
        const renderHeight = force1pxHeight ? 1 : charHeight;
        if (dx + charWidth > target.width || dy + renderHeight > target.height) {
            console.warn("bad render request outside image data");
            return;
        }
        const charData = useLighterFont ? this.charDataLight : this.charDataNormal;
        const charIndex = (0, _minimapCharSheetJs.getCharIndex)(chCode, fontScale);
        const destWidth = target.width * 4 /* Constants.RGBA_CHANNELS_CNT */ ;
        const backgroundR = backgroundColor.r;
        const backgroundG = backgroundColor.g;
        const backgroundB = backgroundColor.b;
        const deltaR = color.r - backgroundR;
        const deltaG = color.g - backgroundG;
        const deltaB = color.b - backgroundB;
        const destAlpha = Math.max(foregroundAlpha, backgroundAlpha);
        const dest = target.data;
        let sourceOffset = charIndex * charWidth * charHeight;
        let row = dy * destWidth + dx * 4 /* Constants.RGBA_CHANNELS_CNT */ ;
        for(let y = 0; y < renderHeight; y++){
            let column = row;
            for(let x = 0; x < charWidth; x++){
                const c = charData[sourceOffset++] / 255 * (foregroundAlpha / 255);
                dest[column++] = backgroundR + deltaR * c;
                dest[column++] = backgroundG + deltaG * c;
                dest[column++] = backgroundB + deltaB * c;
                dest[column++] = destAlpha;
            }
            row += destWidth;
        }
    }
    blockRenderChar(target, dx, dy, color, foregroundAlpha, backgroundColor, backgroundAlpha, force1pxHeight) {
        const charWidth = 1 /* Constants.BASE_CHAR_WIDTH */  * this.scale;
        const charHeight = 2 /* Constants.BASE_CHAR_HEIGHT */  * this.scale;
        const renderHeight = force1pxHeight ? 1 : charHeight;
        if (dx + charWidth > target.width || dy + renderHeight > target.height) {
            console.warn("bad render request outside image data");
            return;
        }
        const destWidth = target.width * 4 /* Constants.RGBA_CHANNELS_CNT */ ;
        const c = 0.5 * (foregroundAlpha / 255);
        const backgroundR = backgroundColor.r;
        const backgroundG = backgroundColor.g;
        const backgroundB = backgroundColor.b;
        const deltaR = color.r - backgroundR;
        const deltaG = color.g - backgroundG;
        const deltaB = color.b - backgroundB;
        const colorR = backgroundR + deltaR * c;
        const colorG = backgroundG + deltaG * c;
        const colorB = backgroundB + deltaB * c;
        const destAlpha = Math.max(foregroundAlpha, backgroundAlpha);
        const dest = target.data;
        let row = dy * destWidth + dx * 4 /* Constants.RGBA_CHANNELS_CNT */ ;
        for(let y = 0; y < renderHeight; y++){
            let column = row;
            for(let x = 0; x < charWidth; x++){
                dest[column++] = colorR;
                dest[column++] = colorG;
                dest[column++] = colorB;
                dest[column++] = destAlpha;
            }
            row += destWidth;
        }
    }
}

},{"./minimapCharSheet.js":"3PgLn","../../../../base/common/uint.js":"7fnps","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3PgLn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "allCharCodes", ()=>allCharCodes);
parcelHelpers.export(exports, "getCharIndex", ()=>getCharIndex);
const allCharCodes = (()=>{
    const v = [];
    for(let i = 32 /* Constants.START_CH_CODE */ ; i <= 126 /* Constants.END_CH_CODE */ ; i++)v.push(i);
    v.push(65533 /* Constants.UNKNOWN_CODE */ );
    return v;
})();
const getCharIndex = (chCode, fontScale)=>{
    chCode -= 32 /* Constants.START_CH_CODE */ ;
    if (chCode < 0 || chCode > 96 /* Constants.CHAR_COUNT */ ) {
        if (fontScale <= 2) // for smaller scales, we can get away with using any ASCII character...
        return (chCode + 96 /* Constants.CHAR_COUNT */ ) % 96 /* Constants.CHAR_COUNT */ ;
        return 95; // unknown symbol
    }
    return chCode;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUPHL":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prebakedMiniMaps", ()=>prebakedMiniMaps);
var _functionalJs = require("../../../../base/common/functional.js");
const charTable = {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15
};
const decodeData = (str)=>{
    const output = new Uint8ClampedArray(str.length / 2);
    for(let i = 0; i < str.length; i += 2)output[i >> 1] = charTable[str[i]] << 4 | charTable[str[i + 1]] & 0xF;
    return output;
};
const prebakedMiniMaps = {
    1: (0, _functionalJs.createSingleCallFunction)(()=>decodeData("0000511D6300CF609C709645A78432005642574171487021003C451900274D35D762755E8B629C5BA856AF57BA649530C167D1512A272A3F6038604460398526BCA2A968DB6F8957C768BE5FBE2FB467CF5D8D5B795DC7625B5DFF50DE64C466DB2FC47CD860A65E9A2EB96CB54CE06DA763AB2EA26860524D3763536601005116008177A8705E53AB738E6A982F88BAA35B5F5B626D9C636B449B737E5B7B678598869A662F6B5B8542706C704C80736A607578685B70594A49715A4522E792")),
    2: (0, _functionalJs.createSingleCallFunction)(()=>decodeData("000000000000000055394F383D2800008B8B1F210002000081B1CBCBCC820000847AAF6B9AAF2119BE08B8881AD60000A44FD07DCCF107015338130C00000000385972265F390B406E2437634B4B48031B12B8A0847000001E15B29A402F0000000000004B33460B00007A752C2A0000000000004D3900000084394B82013400ABA5CFC7AD9C0302A45A3E5A98AB000089A43382D97900008BA54AA087A70A0248A6A7AE6DBE0000BF6F94987EA40A01A06DCFA7A7A9030496C32F77891D0000A99FB1A0AFA80603B29AB9CA75930D010C0948354D3900000C0948354F37460D0028BE673D8400000000AF9D7B6E00002B007AA8933400007AA642675C2700007984CFB9C3985B768772A8A6B7B20000CAAECAAFC4B700009F94A6009F840009D09F9BA4CA9C0000CC8FC76DC87F0000C991C472A2000000A894A48CA7B501079BA2C9C69BA20000B19A5D3FA89000005CA6009DA2960901B0A7F0669FB200009D009E00B7890000DAD0F5D092820000D294D4C48BD10000B5A7A4A3B1A50402CAB6CBA6A2000000B5A7A4A3B1A8044FCDADD19D9CB00000B7778F7B8AAE0803C9AB5D3F5D3F00009EA09EA0BAB006039EA0989A8C7900009B9EF4D6B7C00000A9A7816CACA80000ABAC84705D3F000096DA635CDC8C00006F486F266F263D4784006124097B00374F6D2D6D2D6D4A3A95872322000000030000000000008D8939130000000000002E22A5C9CBC70600AB25C0B5C9B400061A2DB04CA67001082AA6BEBEBFC606002321DACBC19E03087AA08B6768380000282FBAC0B8CA7A88AD25BBA5A29900004C396C5894A6000040485A6E356E9442A32CD17EADA70000B4237923628600003E2DE9C1D7B500002F25BBA5A2990000231DB6AFB4A804023025C0B5CAB588062B2CBDBEC0C706882435A75CA20000002326BD6A82A908048B4B9A5A668000002423A09CB4BB060025259C9D8A7900001C1FCAB2C7C700002A2A9387ABA200002626A4A47D6E9D14333163A0C87500004B6F9C2D643A257049364936493647358A34438355497F1A0000A24C1D590000D38DFFBDD4CD3126"))
};

},{"../../../../base/common/functional.js":"75R2i","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"92j2K":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_FONT_FAMILY", ()=>DEFAULT_FONT_FAMILY);
var _platformJs = require("../common/platform.js");
const DEFAULT_FONT_FAMILY = (0, _platformJs.isWindows) ? '"Segoe WPC", "Segoe UI", sans-serif' : (0, _platformJs.isMacintosh) ? "-apple-system, BlinkMacSystemFont, sans-serif" : 'system-ui, "Ubuntu", "Droid Sans", sans-serif';

},{"../common/platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kHnNk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewOverlayWidgets", ()=>ViewOverlayWidgets);
var _overlayWidgetsCss = require("./overlayWidgets.css");
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _viewPartJs = require("../../view/viewPart.js");
var _domJs = require("../../../../base/browser/dom.js");
class ViewOverlayWidgets extends (0, _viewPartJs.ViewPart) {
    constructor(context, viewDomNode){
        super(context);
        this._viewDomNode = viewDomNode;
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._widgets = {};
        this._verticalScrollbarWidth = layoutInfo.verticalScrollbarWidth;
        this._minimapWidth = layoutInfo.minimap.minimapWidth;
        this._horizontalScrollbarHeight = layoutInfo.horizontalScrollbarHeight;
        this._editorHeight = layoutInfo.height;
        this._editorWidth = layoutInfo.width;
        this._viewDomNodeRect = {
            top: 0,
            left: 0,
            width: 0,
            height: 0
        };
        this._domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        (0, _viewPartJs.PartFingerprints).write(this._domNode, 4 /* PartFingerprint.OverlayWidgets */ );
        this._domNode.setClassName("overlayWidgets");
        this.overflowingOverlayWidgetsDomNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        (0, _viewPartJs.PartFingerprints).write(this.overflowingOverlayWidgetsDomNode, 5 /* PartFingerprint.OverflowingOverlayWidgets */ );
        this.overflowingOverlayWidgetsDomNode.setClassName("overflowingOverlayWidgets");
    }
    dispose() {
        super.dispose();
        this._widgets = {};
    }
    getDomNode() {
        return this._domNode;
    }
    // ---- begin view event handlers
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._verticalScrollbarWidth = layoutInfo.verticalScrollbarWidth;
        this._minimapWidth = layoutInfo.minimap.minimapWidth;
        this._horizontalScrollbarHeight = layoutInfo.horizontalScrollbarHeight;
        this._editorHeight = layoutInfo.height;
        this._editorWidth = layoutInfo.width;
        return true;
    }
    // ---- end view event handlers
    addWidget(widget) {
        const domNode = (0, _fastDomNodeJs.createFastDomNode)(widget.getDomNode());
        this._widgets[widget.getId()] = {
            widget: widget,
            preference: null,
            domNode: domNode
        };
        // This is sync because a widget wants to be in the dom
        domNode.setPosition("absolute");
        domNode.setAttribute("widgetId", widget.getId());
        if (widget.allowEditorOverflow) this.overflowingOverlayWidgetsDomNode.appendChild(domNode);
        else this._domNode.appendChild(domNode);
        this.setShouldRender();
        this._updateMaxMinWidth();
    }
    setWidgetPosition(widget, position) {
        const widgetData = this._widgets[widget.getId()];
        const preference = position ? position.preference : null;
        const stack = position?.stackOridinal;
        if (widgetData.preference === preference && widgetData.stack === stack) {
            this._updateMaxMinWidth();
            return false;
        }
        widgetData.preference = preference;
        widgetData.stack = stack;
        this.setShouldRender();
        this._updateMaxMinWidth();
        return true;
    }
    removeWidget(widget) {
        const widgetId = widget.getId();
        if (this._widgets.hasOwnProperty(widgetId)) {
            const widgetData = this._widgets[widgetId];
            const domNode = widgetData.domNode.domNode;
            delete this._widgets[widgetId];
            domNode.remove();
            this.setShouldRender();
            this._updateMaxMinWidth();
        }
    }
    _updateMaxMinWidth() {
        let maxMinWidth = 0;
        const keys = Object.keys(this._widgets);
        for(let i = 0, len = keys.length; i < len; i++){
            const widgetId = keys[i];
            const widget = this._widgets[widgetId];
            const widgetMinWidthInPx = widget.widget.getMinContentWidthInPx?.();
            if (typeof widgetMinWidthInPx !== "undefined") maxMinWidth = Math.max(maxMinWidth, widgetMinWidthInPx);
        }
        this._context.viewLayout.setOverlayWidgetsMinWidth(maxMinWidth);
    }
    _renderWidget(widgetData, stackCoordinates) {
        const domNode = widgetData.domNode;
        if (widgetData.preference === null) {
            domNode.setTop("");
            return;
        }
        const maxRight = 2 * this._verticalScrollbarWidth + this._minimapWidth;
        if (widgetData.preference === 0 /* OverlayWidgetPositionPreference.TOP_RIGHT_CORNER */  || widgetData.preference === 1 /* OverlayWidgetPositionPreference.BOTTOM_RIGHT_CORNER */ ) {
            if (widgetData.preference === 1 /* OverlayWidgetPositionPreference.BOTTOM_RIGHT_CORNER */ ) {
                const widgetHeight = domNode.domNode.clientHeight;
                domNode.setTop(this._editorHeight - widgetHeight - 2 * this._horizontalScrollbarHeight);
            } else domNode.setTop(0);
            if (widgetData.stack !== undefined) {
                domNode.setTop(stackCoordinates[widgetData.preference]);
                stackCoordinates[widgetData.preference] += domNode.domNode.clientWidth;
            } else domNode.setRight(maxRight);
        } else if (widgetData.preference === 2 /* OverlayWidgetPositionPreference.TOP_CENTER */ ) {
            domNode.domNode.style.right = "50%";
            if (widgetData.stack !== undefined) {
                domNode.setTop(stackCoordinates[2 /* OverlayWidgetPositionPreference.TOP_CENTER */ ]);
                stackCoordinates[2 /* OverlayWidgetPositionPreference.TOP_CENTER */ ] += domNode.domNode.clientHeight;
            } else domNode.setTop(0);
        } else {
            const { top, left } = widgetData.preference;
            const fixedOverflowWidgets = this._context.configuration.options.get(42 /* EditorOption.fixedOverflowWidgets */ );
            if (fixedOverflowWidgets && widgetData.widget.allowEditorOverflow) {
                // top, left are computed relative to the editor and we need them relative to the page
                const editorBoundingBox = this._viewDomNodeRect;
                domNode.setTop(top + editorBoundingBox.top);
                domNode.setLeft(left + editorBoundingBox.left);
                domNode.setPosition("fixed");
            } else {
                domNode.setTop(top);
                domNode.setLeft(left);
                domNode.setPosition("absolute");
            }
        }
    }
    prepareRender(ctx) {
        this._viewDomNodeRect = _domJs.getDomNodePagePosition(this._viewDomNode.domNode);
    }
    render(ctx) {
        this._domNode.setWidth(this._editorWidth);
        const keys = Object.keys(this._widgets);
        const stackCoordinates = Array.from({
            length: 3
        }, ()=>0);
        keys.sort((a, b)=>(this._widgets[a].stack || 0) - (this._widgets[b].stack || 0));
        for(let i = 0, len = keys.length; i < len; i++){
            const widgetId = keys[i];
            this._renderWidget(this._widgets[widgetId], stackCoordinates);
        }
    }
}

},{"./overlayWidgets.css":"cSCqw","../../../../base/browser/fastDomNode.js":"2SADf","../../view/viewPart.js":"kTsLR","../../../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cSCqw":[function() {},{}],"iUvcT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DecorationsOverviewRuler", ()=>DecorationsOverviewRuler);
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _colorJs = require("../../../../base/common/color.js");
var _viewPartJs = require("../../view/viewPart.js");
var _positionJs = require("../../../common/core/position.js");
var _languagesJs = require("../../../common/languages.js");
var _editorColorRegistryJs = require("../../../common/core/editorColorRegistry.js");
var _viewModelJs = require("../../../common/viewModel.js");
var _arraysJs = require("../../../../base/common/arrays.js");
class Settings {
    constructor(config, theme){
        const options = config.options;
        this.lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this.pixelRatio = options.get(144 /* EditorOption.pixelRatio */ );
        this.overviewRulerLanes = options.get(83 /* EditorOption.overviewRulerLanes */ );
        this.renderBorder = options.get(82 /* EditorOption.overviewRulerBorder */ );
        const borderColor = theme.getColor((0, _editorColorRegistryJs.editorOverviewRulerBorder));
        this.borderColor = borderColor ? borderColor.toString() : null;
        this.hideCursor = options.get(59 /* EditorOption.hideCursorInOverviewRuler */ );
        const cursorColorSingle = theme.getColor((0, _editorColorRegistryJs.editorCursorForeground));
        this.cursorColorSingle = cursorColorSingle ? cursorColorSingle.transparent(0.7).toString() : null;
        const cursorColorPrimary = theme.getColor((0, _editorColorRegistryJs.editorMultiCursorPrimaryForeground));
        this.cursorColorPrimary = cursorColorPrimary ? cursorColorPrimary.transparent(0.7).toString() : null;
        const cursorColorSecondary = theme.getColor((0, _editorColorRegistryJs.editorMultiCursorSecondaryForeground));
        this.cursorColorSecondary = cursorColorSecondary ? cursorColorSecondary.transparent(0.7).toString() : null;
        this.themeType = theme.type;
        const minimapOpts = options.get(73 /* EditorOption.minimap */ );
        const minimapEnabled = minimapOpts.enabled;
        const minimapSide = minimapOpts.side;
        const themeColor = theme.getColor((0, _editorColorRegistryJs.editorOverviewRulerBackground));
        const defaultBackground = (0, _languagesJs.TokenizationRegistry).getDefaultBackground();
        if (themeColor) this.backgroundColor = themeColor;
        else if (minimapEnabled && minimapSide === "right") this.backgroundColor = defaultBackground;
        else this.backgroundColor = null;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        const position = layoutInfo.overviewRuler;
        this.top = position.top;
        this.right = position.right;
        this.domWidth = position.width;
        this.domHeight = position.height;
        if (this.overviewRulerLanes === 0) {
            // overview ruler is off
            this.canvasWidth = 0;
            this.canvasHeight = 0;
        } else {
            this.canvasWidth = this.domWidth * this.pixelRatio | 0;
            this.canvasHeight = this.domHeight * this.pixelRatio | 0;
        }
        const [x, w] = this._initLanes(1, this.canvasWidth, this.overviewRulerLanes);
        this.x = x;
        this.w = w;
    }
    _initLanes(canvasLeftOffset, canvasWidth, laneCount) {
        const remainingWidth = canvasWidth - canvasLeftOffset;
        if (laneCount >= 3) {
            const leftWidth = Math.floor(remainingWidth / 3);
            const rightWidth = Math.floor(remainingWidth / 3);
            const centerWidth = remainingWidth - leftWidth - rightWidth;
            const leftOffset = canvasLeftOffset;
            const centerOffset = leftOffset + leftWidth;
            const rightOffset = leftOffset + leftWidth + centerWidth;
            return [
                [
                    0,
                    leftOffset,
                    centerOffset,
                    leftOffset,
                    rightOffset,
                    leftOffset,
                    centerOffset,
                    leftOffset
                ],
                [
                    0,
                    leftWidth,
                    centerWidth,
                    leftWidth + centerWidth,
                    rightWidth,
                    leftWidth + centerWidth + rightWidth,
                    centerWidth + rightWidth,
                    leftWidth + centerWidth + rightWidth
                ]
            ];
        } else if (laneCount === 2) {
            const leftWidth = Math.floor(remainingWidth / 2);
            const rightWidth = remainingWidth - leftWidth;
            const leftOffset = canvasLeftOffset;
            const rightOffset = leftOffset + leftWidth;
            return [
                [
                    0,
                    leftOffset,
                    leftOffset,
                    leftOffset,
                    rightOffset,
                    leftOffset,
                    leftOffset,
                    leftOffset
                ],
                [
                    0,
                    leftWidth,
                    leftWidth,
                    leftWidth,
                    rightWidth,
                    leftWidth + rightWidth,
                    leftWidth + rightWidth,
                    leftWidth + rightWidth
                ]
            ];
        } else {
            const offset = canvasLeftOffset;
            const width = remainingWidth;
            return [
                [
                    0,
                    offset,
                    offset,
                    offset,
                    offset,
                    offset,
                    offset,
                    offset
                ],
                [
                    0,
                    width,
                    width,
                    width,
                    width,
                    width,
                    width,
                    width
                ]
            ];
        }
    }
    equals(other) {
        return this.lineHeight === other.lineHeight && this.pixelRatio === other.pixelRatio && this.overviewRulerLanes === other.overviewRulerLanes && this.renderBorder === other.renderBorder && this.borderColor === other.borderColor && this.hideCursor === other.hideCursor && this.cursorColorSingle === other.cursorColorSingle && this.cursorColorPrimary === other.cursorColorPrimary && this.cursorColorSecondary === other.cursorColorSecondary && this.themeType === other.themeType && (0, _colorJs.Color).equals(this.backgroundColor, other.backgroundColor) && this.top === other.top && this.right === other.right && this.domWidth === other.domWidth && this.domHeight === other.domHeight && this.canvasWidth === other.canvasWidth && this.canvasHeight === other.canvasHeight;
    }
}
class DecorationsOverviewRuler extends (0, _viewPartJs.ViewPart) {
    constructor(context){
        super(context);
        this._actualShouldRender = 0 /* ShouldRenderValue.NotNeeded */ ;
        this._renderedDecorations = [];
        this._renderedCursorPositions = [];
        this._domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("canvas"));
        this._domNode.setClassName("decorationsOverviewRuler");
        this._domNode.setPosition("absolute");
        this._domNode.setLayerHinting(true);
        this._domNode.setContain("strict");
        this._domNode.setAttribute("aria-hidden", "true");
        this._updateSettings(false);
        this._tokensColorTrackerListener = (0, _languagesJs.TokenizationRegistry).onDidChange((e)=>{
            if (e.changedColorMap) this._updateSettings(true);
        });
        this._cursorPositions = [
            {
                position: new (0, _positionJs.Position)(1, 1),
                color: this._settings.cursorColorSingle
            }
        ];
    }
    dispose() {
        super.dispose();
        this._tokensColorTrackerListener.dispose();
    }
    _updateSettings(renderNow) {
        const newSettings = new Settings(this._context.configuration, this._context.theme);
        if (this._settings && this._settings.equals(newSettings)) // nothing to do
        return false;
        this._settings = newSettings;
        this._domNode.setTop(this._settings.top);
        this._domNode.setRight(this._settings.right);
        this._domNode.setWidth(this._settings.domWidth);
        this._domNode.setHeight(this._settings.domHeight);
        this._domNode.domNode.width = this._settings.canvasWidth;
        this._domNode.domNode.height = this._settings.canvasHeight;
        if (renderNow) this._render();
        return true;
    }
    // ---- begin view event handlers
    _markRenderingIsNeeded() {
        this._actualShouldRender = 2 /* ShouldRenderValue.Needed */ ;
        return true;
    }
    _markRenderingIsMaybeNeeded() {
        this._actualShouldRender = 1 /* ShouldRenderValue.Maybe */ ;
        return true;
    }
    onConfigurationChanged(e) {
        return this._updateSettings(false) ? this._markRenderingIsNeeded() : false;
    }
    onCursorStateChanged(e) {
        this._cursorPositions = [];
        for(let i = 0, len = e.selections.length; i < len; i++){
            let color = this._settings.cursorColorSingle;
            if (len > 1) color = i === 0 ? this._settings.cursorColorPrimary : this._settings.cursorColorSecondary;
            this._cursorPositions.push({
                position: e.selections[i].getPosition(),
                color
            });
        }
        this._cursorPositions.sort((a, b)=>(0, _positionJs.Position).compare(a.position, b.position));
        return this._markRenderingIsMaybeNeeded();
    }
    onDecorationsChanged(e) {
        if (e.affectsOverviewRuler) return this._markRenderingIsMaybeNeeded();
        return false;
    }
    onFlushed(e) {
        return this._markRenderingIsNeeded();
    }
    onScrollChanged(e) {
        return e.scrollHeightChanged ? this._markRenderingIsNeeded() : false;
    }
    onZonesChanged(e) {
        return this._markRenderingIsNeeded();
    }
    onThemeChanged(e) {
        return this._updateSettings(false) ? this._markRenderingIsNeeded() : false;
    }
    // ---- end view event handlers
    getDomNode() {
        return this._domNode.domNode;
    }
    prepareRender(ctx) {
    // Nothing to read
    }
    render(editorCtx) {
        this._render();
        this._actualShouldRender = 0 /* ShouldRenderValue.NotNeeded */ ;
    }
    _render() {
        const backgroundColor = this._settings.backgroundColor;
        if (this._settings.overviewRulerLanes === 0) {
            // overview ruler is off
            this._domNode.setBackgroundColor(backgroundColor ? (0, _colorJs.Color).Format.CSS.formatHexA(backgroundColor) : "");
            this._domNode.setDisplay("none");
            return;
        }
        const decorations = this._context.viewModel.getAllOverviewRulerDecorations(this._context.theme);
        decorations.sort((0, _viewModelJs.OverviewRulerDecorationsGroup).compareByRenderingProps);
        if (this._actualShouldRender === 1 /* ShouldRenderValue.Maybe */  && !(0, _viewModelJs.OverviewRulerDecorationsGroup).equalsArr(this._renderedDecorations, decorations)) this._actualShouldRender = 2 /* ShouldRenderValue.Needed */ ;
        if (this._actualShouldRender === 1 /* ShouldRenderValue.Maybe */  && !(0, _arraysJs.equals)(this._renderedCursorPositions, this._cursorPositions, (a, b)=>a.position.lineNumber === b.position.lineNumber && a.color === b.color)) this._actualShouldRender = 2 /* ShouldRenderValue.Needed */ ;
        if (this._actualShouldRender === 1 /* ShouldRenderValue.Maybe */ ) // both decorations and cursor positions are unchanged, nothing to do
        return;
        this._renderedDecorations = decorations;
        this._renderedCursorPositions = this._cursorPositions;
        this._domNode.setDisplay("block");
        const canvasWidth = this._settings.canvasWidth;
        const canvasHeight = this._settings.canvasHeight;
        const lineHeight = this._settings.lineHeight;
        const viewLayout = this._context.viewLayout;
        const outerHeight = this._context.viewLayout.getScrollHeight();
        const heightRatio = canvasHeight / outerHeight;
        const minDecorationHeight = 6 /* Constants.MIN_DECORATION_HEIGHT */  * this._settings.pixelRatio | 0;
        const halfMinDecorationHeight = minDecorationHeight / 2 | 0;
        const canvasCtx = this._domNode.domNode.getContext("2d");
        if (backgroundColor) {
            if (backgroundColor.isOpaque()) {
                // We have a background color which is opaque, we can just paint the entire surface with it
                canvasCtx.fillStyle = (0, _colorJs.Color).Format.CSS.formatHexA(backgroundColor);
                canvasCtx.fillRect(0, 0, canvasWidth, canvasHeight);
            } else {
                // We have a background color which is transparent, we need to first clear the surface and
                // then fill it
                canvasCtx.clearRect(0, 0, canvasWidth, canvasHeight);
                canvasCtx.fillStyle = (0, _colorJs.Color).Format.CSS.formatHexA(backgroundColor);
                canvasCtx.fillRect(0, 0, canvasWidth, canvasHeight);
            }
        } else // We don't have a background color
        canvasCtx.clearRect(0, 0, canvasWidth, canvasHeight);
        const x = this._settings.x;
        const w = this._settings.w;
        for (const decorationGroup of decorations){
            const color = decorationGroup.color;
            const decorationGroupData = decorationGroup.data;
            canvasCtx.fillStyle = color;
            let prevLane = 0;
            let prevY1 = 0;
            let prevY2 = 0;
            for(let i = 0, len = decorationGroupData.length / 3; i < len; i++){
                const lane = decorationGroupData[3 * i];
                const startLineNumber = decorationGroupData[3 * i + 1];
                const endLineNumber = decorationGroupData[3 * i + 2];
                let y1 = viewLayout.getVerticalOffsetForLineNumber(startLineNumber) * heightRatio | 0;
                let y2 = (viewLayout.getVerticalOffsetForLineNumber(endLineNumber) + lineHeight) * heightRatio | 0;
                const height = y2 - y1;
                if (height < minDecorationHeight) {
                    let yCenter = (y1 + y2) / 2 | 0;
                    if (yCenter < halfMinDecorationHeight) yCenter = halfMinDecorationHeight;
                    else if (yCenter + halfMinDecorationHeight > canvasHeight) yCenter = canvasHeight - halfMinDecorationHeight;
                    y1 = yCenter - halfMinDecorationHeight;
                    y2 = yCenter + halfMinDecorationHeight;
                }
                if (y1 > prevY2 + 1 || lane !== prevLane) {
                    // flush prev
                    if (i !== 0) canvasCtx.fillRect(x[prevLane], prevY1, w[prevLane], prevY2 - prevY1);
                    prevLane = lane;
                    prevY1 = y1;
                    prevY2 = y2;
                } else // merge into prev
                if (y2 > prevY2) prevY2 = y2;
            }
            canvasCtx.fillRect(x[prevLane], prevY1, w[prevLane], prevY2 - prevY1);
        }
        // Draw cursors
        if (!this._settings.hideCursor) {
            const cursorHeight = 2 * this._settings.pixelRatio | 0;
            const halfCursorHeight = cursorHeight / 2 | 0;
            const cursorX = this._settings.x[7 /* OverviewRulerLane.Full */ ];
            const cursorW = this._settings.w[7 /* OverviewRulerLane.Full */ ];
            let prevY1 = -100;
            let prevY2 = -100;
            let prevColor = null;
            for(let i = 0, len = this._cursorPositions.length; i < len; i++){
                const color = this._cursorPositions[i].color;
                if (!color) continue;
                const cursor = this._cursorPositions[i].position;
                let yCenter = viewLayout.getVerticalOffsetForLineNumber(cursor.lineNumber) * heightRatio | 0;
                if (yCenter < halfCursorHeight) yCenter = halfCursorHeight;
                else if (yCenter + halfCursorHeight > canvasHeight) yCenter = canvasHeight - halfCursorHeight;
                const y1 = yCenter - halfCursorHeight;
                const y2 = y1 + cursorHeight;
                if (y1 > prevY2 + 1 || color !== prevColor) {
                    // flush prev
                    if (i !== 0 && prevColor) canvasCtx.fillRect(cursorX, prevY1, cursorW, prevY2 - prevY1);
                    prevY1 = y1;
                    prevY2 = y2;
                } else // merge into prev
                if (y2 > prevY2) prevY2 = y2;
                prevColor = color;
                canvasCtx.fillStyle = color;
            }
            if (prevColor) canvasCtx.fillRect(cursorX, prevY1, cursorW, prevY2 - prevY1);
        }
        if (this._settings.renderBorder && this._settings.borderColor && this._settings.overviewRulerLanes > 0) {
            canvasCtx.beginPath();
            canvasCtx.lineWidth = 1;
            canvasCtx.strokeStyle = this._settings.borderColor;
            canvasCtx.moveTo(0, 0);
            canvasCtx.lineTo(0, canvasHeight);
            canvasCtx.moveTo(1, 0);
            canvasCtx.lineTo(canvasWidth, 0);
            canvasCtx.stroke();
        }
    }
}

},{"../../../../base/browser/fastDomNode.js":"2SADf","../../../../base/common/color.js":"at4gb","../../view/viewPart.js":"kTsLR","../../../common/core/position.js":"lvrPe","../../../common/languages.js":"g5n96","../../../common/core/editorColorRegistry.js":"5XqtL","../../../common/viewModel.js":"5EHxj","../../../../base/common/arrays.js":"DECei","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"61Bf6":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverviewRuler", ()=>OverviewRuler);
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _overviewZoneManagerJs = require("../../../common/viewModel/overviewZoneManager.js");
var _viewEventHandlerJs = require("../../../common/viewEventHandler.js");
class OverviewRuler extends (0, _viewEventHandlerJs.ViewEventHandler) {
    constructor(context, cssClassName){
        super();
        this._context = context;
        const options = this._context.configuration.options;
        this._domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("canvas"));
        this._domNode.setClassName(cssClassName);
        this._domNode.setPosition("absolute");
        this._domNode.setLayerHinting(true);
        this._domNode.setContain("strict");
        this._zoneManager = new (0, _overviewZoneManagerJs.OverviewZoneManager)((lineNumber)=>this._context.viewLayout.getVerticalOffsetForLineNumber(lineNumber));
        this._zoneManager.setDOMWidth(0);
        this._zoneManager.setDOMHeight(0);
        this._zoneManager.setOuterHeight(this._context.viewLayout.getScrollHeight());
        this._zoneManager.setLineHeight(options.get(67 /* EditorOption.lineHeight */ ));
        this._zoneManager.setPixelRatio(options.get(144 /* EditorOption.pixelRatio */ ));
        this._context.addEventHandler(this);
    }
    dispose() {
        this._context.removeEventHandler(this);
        super.dispose();
    }
    // ---- begin view event handlers
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        if (e.hasChanged(67 /* EditorOption.lineHeight */ )) {
            this._zoneManager.setLineHeight(options.get(67 /* EditorOption.lineHeight */ ));
            this._render();
        }
        if (e.hasChanged(144 /* EditorOption.pixelRatio */ )) {
            this._zoneManager.setPixelRatio(options.get(144 /* EditorOption.pixelRatio */ ));
            this._domNode.setWidth(this._zoneManager.getDOMWidth());
            this._domNode.setHeight(this._zoneManager.getDOMHeight());
            this._domNode.domNode.width = this._zoneManager.getCanvasWidth();
            this._domNode.domNode.height = this._zoneManager.getCanvasHeight();
            this._render();
        }
        return true;
    }
    onFlushed(e) {
        this._render();
        return true;
    }
    onScrollChanged(e) {
        if (e.scrollHeightChanged) {
            this._zoneManager.setOuterHeight(e.scrollHeight);
            this._render();
        }
        return true;
    }
    onZonesChanged(e) {
        this._render();
        return true;
    }
    // ---- end view event handlers
    getDomNode() {
        return this._domNode.domNode;
    }
    setLayout(position) {
        this._domNode.setTop(position.top);
        this._domNode.setRight(position.right);
        let hasChanged = false;
        hasChanged = this._zoneManager.setDOMWidth(position.width) || hasChanged;
        hasChanged = this._zoneManager.setDOMHeight(position.height) || hasChanged;
        if (hasChanged) {
            this._domNode.setWidth(this._zoneManager.getDOMWidth());
            this._domNode.setHeight(this._zoneManager.getDOMHeight());
            this._domNode.domNode.width = this._zoneManager.getCanvasWidth();
            this._domNode.domNode.height = this._zoneManager.getCanvasHeight();
            this._render();
        }
    }
    setZones(zones) {
        this._zoneManager.setZones(zones);
        this._render();
    }
    _render() {
        if (this._zoneManager.getOuterHeight() === 0) return false;
        const width = this._zoneManager.getCanvasWidth();
        const height = this._zoneManager.getCanvasHeight();
        const colorZones = this._zoneManager.resolveColorZones();
        const id2Color = this._zoneManager.getId2Color();
        const ctx = this._domNode.domNode.getContext("2d");
        ctx.clearRect(0, 0, width, height);
        if (colorZones.length > 0) this._renderOneLane(ctx, colorZones, id2Color, width);
        return true;
    }
    _renderOneLane(ctx, colorZones, id2Color, width) {
        let currentColorId = 0;
        let currentFrom = 0;
        let currentTo = 0;
        for (const zone of colorZones){
            const zoneColorId = zone.colorId;
            const zoneFrom = zone.from;
            const zoneTo = zone.to;
            if (zoneColorId !== currentColorId) {
                ctx.fillRect(0, currentFrom, width, currentTo - currentFrom);
                currentColorId = zoneColorId;
                ctx.fillStyle = id2Color[currentColorId];
                currentFrom = zoneFrom;
                currentTo = zoneTo;
            } else if (currentTo >= zoneFrom) currentTo = Math.max(currentTo, zoneTo);
            else {
                ctx.fillRect(0, currentFrom, width, currentTo - currentFrom);
                currentFrom = zoneFrom;
                currentTo = zoneTo;
            }
        }
        ctx.fillRect(0, currentFrom, width, currentTo - currentFrom);
    }
}

},{"../../../../base/browser/fastDomNode.js":"2SADf","../../../common/viewModel/overviewZoneManager.js":"6o33k","../../../common/viewEventHandler.js":"9pYyF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6o33k":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorZone", ()=>ColorZone);
/**
 * A zone in the overview ruler
 */ parcelHelpers.export(exports, "OverviewRulerZone", ()=>OverviewRulerZone);
parcelHelpers.export(exports, "OverviewZoneManager", ()=>OverviewZoneManager);
class ColorZone {
    constructor(from, to, colorId){
        this._colorZoneBrand = undefined;
        this.from = from | 0;
        this.to = to | 0;
        this.colorId = colorId | 0;
    }
    static compare(a, b) {
        if (a.colorId === b.colorId) {
            if (a.from === b.from) return a.to - b.to;
            return a.from - b.from;
        }
        return a.colorId - b.colorId;
    }
}
class OverviewRulerZone {
    constructor(startLineNumber, endLineNumber, heightInLines, color){
        this._overviewRulerZoneBrand = undefined;
        this.startLineNumber = startLineNumber;
        this.endLineNumber = endLineNumber;
        this.heightInLines = heightInLines;
        this.color = color;
        this._colorZone = null;
    }
    static compare(a, b) {
        if (a.color === b.color) {
            if (a.startLineNumber === b.startLineNumber) {
                if (a.heightInLines === b.heightInLines) return a.endLineNumber - b.endLineNumber;
                return a.heightInLines - b.heightInLines;
            }
            return a.startLineNumber - b.startLineNumber;
        }
        return a.color < b.color ? -1 : 1;
    }
    setColorZone(colorZone) {
        this._colorZone = colorZone;
    }
    getColorZones() {
        return this._colorZone;
    }
}
class OverviewZoneManager {
    constructor(getVerticalOffsetForLine){
        this._getVerticalOffsetForLine = getVerticalOffsetForLine;
        this._zones = [];
        this._colorZonesInvalid = false;
        this._lineHeight = 0;
        this._domWidth = 0;
        this._domHeight = 0;
        this._outerHeight = 0;
        this._pixelRatio = 1;
        this._lastAssignedId = 0;
        this._color2Id = Object.create(null);
        this._id2Color = [];
    }
    getId2Color() {
        return this._id2Color;
    }
    setZones(newZones) {
        this._zones = newZones;
        this._zones.sort(OverviewRulerZone.compare);
    }
    setLineHeight(lineHeight) {
        if (this._lineHeight === lineHeight) return false;
        this._lineHeight = lineHeight;
        this._colorZonesInvalid = true;
        return true;
    }
    setPixelRatio(pixelRatio) {
        this._pixelRatio = pixelRatio;
        this._colorZonesInvalid = true;
    }
    getDOMWidth() {
        return this._domWidth;
    }
    getCanvasWidth() {
        return this._domWidth * this._pixelRatio;
    }
    setDOMWidth(width) {
        if (this._domWidth === width) return false;
        this._domWidth = width;
        this._colorZonesInvalid = true;
        return true;
    }
    getDOMHeight() {
        return this._domHeight;
    }
    getCanvasHeight() {
        return this._domHeight * this._pixelRatio;
    }
    setDOMHeight(height) {
        if (this._domHeight === height) return false;
        this._domHeight = height;
        this._colorZonesInvalid = true;
        return true;
    }
    getOuterHeight() {
        return this._outerHeight;
    }
    setOuterHeight(outerHeight) {
        if (this._outerHeight === outerHeight) return false;
        this._outerHeight = outerHeight;
        this._colorZonesInvalid = true;
        return true;
    }
    resolveColorZones() {
        const colorZonesInvalid = this._colorZonesInvalid;
        const lineHeight = Math.floor(this._lineHeight);
        const totalHeight = Math.floor(this.getCanvasHeight());
        const outerHeight = Math.floor(this._outerHeight);
        const heightRatio = totalHeight / outerHeight;
        const halfMinimumHeight = Math.floor(4 /* Constants.MINIMUM_HEIGHT */  * this._pixelRatio / 2);
        const allColorZones = [];
        for(let i = 0, len = this._zones.length; i < len; i++){
            const zone = this._zones[i];
            if (!colorZonesInvalid) {
                const colorZone = zone.getColorZones();
                if (colorZone) {
                    allColorZones.push(colorZone);
                    continue;
                }
            }
            const offset1 = this._getVerticalOffsetForLine(zone.startLineNumber);
            const offset2 = zone.heightInLines === 0 ? this._getVerticalOffsetForLine(zone.endLineNumber) + lineHeight : offset1 + zone.heightInLines * lineHeight;
            const y1 = Math.floor(heightRatio * offset1);
            const y2 = Math.floor(heightRatio * offset2);
            let ycenter = Math.floor((y1 + y2) / 2);
            let halfHeight = y2 - ycenter;
            if (halfHeight < halfMinimumHeight) halfHeight = halfMinimumHeight;
            if (ycenter - halfHeight < 0) ycenter = halfHeight;
            if (ycenter + halfHeight > totalHeight) ycenter = totalHeight - halfHeight;
            const color = zone.color;
            let colorId = this._color2Id[color];
            if (!colorId) {
                colorId = ++this._lastAssignedId;
                this._color2Id[color] = colorId;
                this._id2Color[colorId] = color;
            }
            const colorZone = new ColorZone(ycenter - halfHeight, ycenter + halfHeight, colorId);
            zone.setColorZone(colorZone);
            allColorZones.push(colorZone);
        }
        this._colorZonesInvalid = false;
        allColorZones.sort(ColorZone.compare);
        return allColorZones;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3qAOT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Rulers", ()=>Rulers);
var _rulersCss = require("./rulers.css");
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _viewPartJs = require("../../view/viewPart.js");
class Rulers extends (0, _viewPartJs.ViewPart) {
    constructor(context){
        super(context);
        this.domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this.domNode.setAttribute("role", "presentation");
        this.domNode.setAttribute("aria-hidden", "true");
        this.domNode.setClassName("view-rulers");
        this._renderedRulers = [];
        const options = this._context.configuration.options;
        this._rulers = options.get(103 /* EditorOption.rulers */ );
        this._typicalHalfwidthCharacterWidth = options.get(50 /* EditorOption.fontInfo */ ).typicalHalfwidthCharacterWidth;
    }
    dispose() {
        super.dispose();
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        this._rulers = options.get(103 /* EditorOption.rulers */ );
        this._typicalHalfwidthCharacterWidth = options.get(50 /* EditorOption.fontInfo */ ).typicalHalfwidthCharacterWidth;
        return true;
    }
    onScrollChanged(e) {
        return e.scrollHeightChanged;
    }
    // --- end event handlers
    prepareRender(ctx) {
    // Nothing to read
    }
    _ensureRulersCount() {
        const currentCount = this._renderedRulers.length;
        const desiredCount = this._rulers.length;
        if (currentCount === desiredCount) // Nothing to do
        return;
        if (currentCount < desiredCount) {
            const { tabSize } = this._context.viewModel.model.getOptions();
            const rulerWidth = tabSize;
            let addCount = desiredCount - currentCount;
            while(addCount > 0){
                const node = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
                node.setClassName("view-ruler");
                node.setWidth(rulerWidth);
                this.domNode.appendChild(node);
                this._renderedRulers.push(node);
                addCount--;
            }
            return;
        }
        let removeCount = currentCount - desiredCount;
        while(removeCount > 0){
            const node = this._renderedRulers.pop();
            this.domNode.removeChild(node);
            removeCount--;
        }
    }
    render(ctx) {
        this._ensureRulersCount();
        for(let i = 0, len = this._rulers.length; i < len; i++){
            const node = this._renderedRulers[i];
            const ruler = this._rulers[i];
            node.setBoxShadow(ruler.color ? `1px 0 0 0 ${ruler.color} inset` : ``);
            node.setHeight(Math.min(ctx.scrollHeight, 1000000));
            node.setLeft(ruler.column * this._typicalHalfwidthCharacterWidth);
        }
    }
}

},{"./rulers.css":"dDuLd","../../../../base/browser/fastDomNode.js":"2SADf","../../view/viewPart.js":"kTsLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dDuLd":[function() {},{}],"1WwMU":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollDecorationViewPart", ()=>ScrollDecorationViewPart);
var _scrollDecorationCss = require("./scrollDecoration.css");
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _viewPartJs = require("../../view/viewPart.js");
class ScrollDecorationViewPart extends (0, _viewPartJs.ViewPart) {
    constructor(context){
        super(context);
        this._scrollTop = 0;
        this._width = 0;
        this._updateWidth();
        this._shouldShow = false;
        const options = this._context.configuration.options;
        const scrollbar = options.get(104 /* EditorOption.scrollbar */ );
        this._useShadows = scrollbar.useShadows;
        this._domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this._domNode.setAttribute("role", "presentation");
        this._domNode.setAttribute("aria-hidden", "true");
    }
    dispose() {
        super.dispose();
    }
    _updateShouldShow() {
        const newShouldShow = this._useShadows && this._scrollTop > 0;
        if (this._shouldShow !== newShouldShow) {
            this._shouldShow = newShouldShow;
            return true;
        }
        return false;
    }
    getDomNode() {
        return this._domNode;
    }
    _updateWidth() {
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        if (layoutInfo.minimap.renderMinimap === 0 || layoutInfo.minimap.minimapWidth > 0 && layoutInfo.minimap.minimapLeft === 0) this._width = layoutInfo.width;
        else this._width = layoutInfo.width - layoutInfo.verticalScrollbarWidth;
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        const scrollbar = options.get(104 /* EditorOption.scrollbar */ );
        this._useShadows = scrollbar.useShadows;
        this._updateWidth();
        this._updateShouldShow();
        return true;
    }
    onScrollChanged(e) {
        this._scrollTop = e.scrollTop;
        return this._updateShouldShow();
    }
    // --- end event handlers
    prepareRender(ctx) {
    // Nothing to read
    }
    render(ctx) {
        this._domNode.setWidth(this._width);
        this._domNode.setClassName(this._shouldShow ? "scroll-decoration" : "");
    }
}

},{"./scrollDecoration.css":"g3cYm","../../../../base/browser/fastDomNode.js":"2SADf","../../view/viewPart.js":"kTsLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g3cYm":[function() {},{}],"ceEPx":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectionsOverlay", ()=>SelectionsOverlay);
var _selectionsCss = require("./selections.css");
var _dynamicViewOverlayJs = require("../../view/dynamicViewOverlay.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
class HorizontalRangeWithStyle {
    constructor(other){
        this.left = other.left;
        this.width = other.width;
        this.startStyle = null;
        this.endStyle = null;
    }
}
class LineVisibleRangesWithStyle {
    constructor(lineNumber, ranges){
        this.lineNumber = lineNumber;
        this.ranges = ranges;
    }
}
function toStyledRange(item) {
    return new HorizontalRangeWithStyle(item);
}
function toStyled(item) {
    return new LineVisibleRangesWithStyle(item.lineNumber, item.ranges.map(toStyledRange));
}
class SelectionsOverlay extends (0, _dynamicViewOverlayJs.DynamicViewOverlay) {
    static{
        this.SELECTION_CLASS_NAME = "selected-text";
    }
    static{
        this.SELECTION_TOP_LEFT = "top-left-radius";
    }
    static{
        this.SELECTION_BOTTOM_LEFT = "bottom-left-radius";
    }
    static{
        this.SELECTION_TOP_RIGHT = "top-right-radius";
    }
    static{
        this.SELECTION_BOTTOM_RIGHT = "bottom-right-radius";
    }
    static{
        this.EDITOR_BACKGROUND_CLASS_NAME = "monaco-editor-background";
    }
    static{
        this.ROUNDED_PIECE_WIDTH = 10;
    }
    constructor(context){
        super();
        this._previousFrameVisibleRangesWithStyle = [];
        this._context = context;
        const options = this._context.configuration.options;
        this._roundedSelection = options.get(102 /* EditorOption.roundedSelection */ );
        this._typicalHalfwidthCharacterWidth = options.get(50 /* EditorOption.fontInfo */ ).typicalHalfwidthCharacterWidth;
        this._selections = [];
        this._renderResult = null;
        this._context.addEventHandler(this);
    }
    dispose() {
        this._context.removeEventHandler(this);
        this._renderResult = null;
        super.dispose();
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        this._roundedSelection = options.get(102 /* EditorOption.roundedSelection */ );
        this._typicalHalfwidthCharacterWidth = options.get(50 /* EditorOption.fontInfo */ ).typicalHalfwidthCharacterWidth;
        return true;
    }
    onCursorStateChanged(e) {
        this._selections = e.selections.slice(0);
        return true;
    }
    onDecorationsChanged(e) {
        // true for inline decorations that can end up relayouting text
        return true; //e.inlineDecorationsChanged;
    }
    onFlushed(e) {
        return true;
    }
    onLinesChanged(e) {
        return true;
    }
    onLinesDeleted(e) {
        return true;
    }
    onLinesInserted(e) {
        return true;
    }
    onScrollChanged(e) {
        return e.scrollTopChanged;
    }
    onZonesChanged(e) {
        return true;
    }
    // --- end event handlers
    _visibleRangesHaveGaps(linesVisibleRanges) {
        for(let i = 0, len = linesVisibleRanges.length; i < len; i++){
            const lineVisibleRanges = linesVisibleRanges[i];
            if (lineVisibleRanges.ranges.length > 1) // There are two ranges on the same line
            return true;
        }
        return false;
    }
    _enrichVisibleRangesWithStyle(viewport, linesVisibleRanges, previousFrame) {
        const epsilon = this._typicalHalfwidthCharacterWidth / 4;
        let previousFrameTop = null;
        let previousFrameBottom = null;
        if (previousFrame && previousFrame.length > 0 && linesVisibleRanges.length > 0) {
            const topLineNumber = linesVisibleRanges[0].lineNumber;
            if (topLineNumber === viewport.startLineNumber) {
                for(let i = 0; !previousFrameTop && i < previousFrame.length; i++)if (previousFrame[i].lineNumber === topLineNumber) previousFrameTop = previousFrame[i].ranges[0];
            }
            const bottomLineNumber = linesVisibleRanges[linesVisibleRanges.length - 1].lineNumber;
            if (bottomLineNumber === viewport.endLineNumber) {
                for(let i = previousFrame.length - 1; !previousFrameBottom && i >= 0; i--)if (previousFrame[i].lineNumber === bottomLineNumber) previousFrameBottom = previousFrame[i].ranges[0];
            }
            if (previousFrameTop && !previousFrameTop.startStyle) previousFrameTop = null;
            if (previousFrameBottom && !previousFrameBottom.startStyle) previousFrameBottom = null;
        }
        for(let i = 0, len = linesVisibleRanges.length; i < len; i++){
            // We know for a fact that there is precisely one range on each line
            const curLineRange = linesVisibleRanges[i].ranges[0];
            const curLeft = curLineRange.left;
            const curRight = curLineRange.left + curLineRange.width;
            const startStyle = {
                top: 0 /* CornerStyle.EXTERN */ ,
                bottom: 0 /* CornerStyle.EXTERN */ 
            };
            const endStyle = {
                top: 0 /* CornerStyle.EXTERN */ ,
                bottom: 0 /* CornerStyle.EXTERN */ 
            };
            if (i > 0) {
                // Look above
                const prevLeft = linesVisibleRanges[i - 1].ranges[0].left;
                const prevRight = linesVisibleRanges[i - 1].ranges[0].left + linesVisibleRanges[i - 1].ranges[0].width;
                if (abs(curLeft - prevLeft) < epsilon) startStyle.top = 2 /* CornerStyle.FLAT */ ;
                else if (curLeft > prevLeft) startStyle.top = 1 /* CornerStyle.INTERN */ ;
                if (abs(curRight - prevRight) < epsilon) endStyle.top = 2 /* CornerStyle.FLAT */ ;
                else if (prevLeft < curRight && curRight < prevRight) endStyle.top = 1 /* CornerStyle.INTERN */ ;
            } else if (previousFrameTop) {
                // Accept some hiccups near the viewport edges to save on repaints
                startStyle.top = previousFrameTop.startStyle.top;
                endStyle.top = previousFrameTop.endStyle.top;
            }
            if (i + 1 < len) {
                // Look below
                const nextLeft = linesVisibleRanges[i + 1].ranges[0].left;
                const nextRight = linesVisibleRanges[i + 1].ranges[0].left + linesVisibleRanges[i + 1].ranges[0].width;
                if (abs(curLeft - nextLeft) < epsilon) startStyle.bottom = 2 /* CornerStyle.FLAT */ ;
                else if (nextLeft < curLeft && curLeft < nextRight) startStyle.bottom = 1 /* CornerStyle.INTERN */ ;
                if (abs(curRight - nextRight) < epsilon) endStyle.bottom = 2 /* CornerStyle.FLAT */ ;
                else if (curRight < nextRight) endStyle.bottom = 1 /* CornerStyle.INTERN */ ;
            } else if (previousFrameBottom) {
                // Accept some hiccups near the viewport edges to save on repaints
                startStyle.bottom = previousFrameBottom.startStyle.bottom;
                endStyle.bottom = previousFrameBottom.endStyle.bottom;
            }
            curLineRange.startStyle = startStyle;
            curLineRange.endStyle = endStyle;
        }
    }
    _getVisibleRangesWithStyle(selection, ctx, previousFrame) {
        const _linesVisibleRanges = ctx.linesVisibleRangesForRange(selection, true) || [];
        const linesVisibleRanges = _linesVisibleRanges.map(toStyled);
        const visibleRangesHaveGaps = this._visibleRangesHaveGaps(linesVisibleRanges);
        if (!visibleRangesHaveGaps && this._roundedSelection) this._enrichVisibleRangesWithStyle(ctx.visibleRange, linesVisibleRanges, previousFrame);
        // The visible ranges are sorted TOP-BOTTOM and LEFT-RIGHT
        return linesVisibleRanges;
    }
    _createSelectionPiece(top, bottom, className, left, width) {
        return '<div class="cslr ' + className + '" style="' + "top:" + top.toString() + "px;" + "bottom:" + bottom.toString() + "px;" + "left:" + left.toString() + "px;" + "width:" + width.toString() + "px;" + '"></div>';
    }
    _actualRenderOneSelection(output2, visibleStartLineNumber, hasMultipleSelections, visibleRanges) {
        if (visibleRanges.length === 0) return;
        const visibleRangesHaveStyle = !!visibleRanges[0].ranges[0].startStyle;
        const firstLineNumber = visibleRanges[0].lineNumber;
        const lastLineNumber = visibleRanges[visibleRanges.length - 1].lineNumber;
        for(let i = 0, len = visibleRanges.length; i < len; i++){
            const lineVisibleRanges = visibleRanges[i];
            const lineNumber = lineVisibleRanges.lineNumber;
            const lineIndex = lineNumber - visibleStartLineNumber;
            const top = hasMultipleSelections ? lineNumber === firstLineNumber ? 1 : 0 : 0;
            const bottom = hasMultipleSelections ? lineNumber !== firstLineNumber && lineNumber === lastLineNumber ? 1 : 0 : 0;
            let innerCornerOutput = "";
            let restOfSelectionOutput = "";
            for(let j = 0, lenJ = lineVisibleRanges.ranges.length; j < lenJ; j++){
                const visibleRange = lineVisibleRanges.ranges[j];
                if (visibleRangesHaveStyle) {
                    const startStyle = visibleRange.startStyle;
                    const endStyle = visibleRange.endStyle;
                    if (startStyle.top === 1 /* CornerStyle.INTERN */  || startStyle.bottom === 1 /* CornerStyle.INTERN */ ) {
                        // Reverse rounded corner to the left
                        // First comes the selection (blue layer)
                        innerCornerOutput += this._createSelectionPiece(top, bottom, SelectionsOverlay.SELECTION_CLASS_NAME, visibleRange.left - SelectionsOverlay.ROUNDED_PIECE_WIDTH, SelectionsOverlay.ROUNDED_PIECE_WIDTH);
                        // Second comes the background (white layer) with inverse border radius
                        let className = SelectionsOverlay.EDITOR_BACKGROUND_CLASS_NAME;
                        if (startStyle.top === 1 /* CornerStyle.INTERN */ ) className += " " + SelectionsOverlay.SELECTION_TOP_RIGHT;
                        if (startStyle.bottom === 1 /* CornerStyle.INTERN */ ) className += " " + SelectionsOverlay.SELECTION_BOTTOM_RIGHT;
                        innerCornerOutput += this._createSelectionPiece(top, bottom, className, visibleRange.left - SelectionsOverlay.ROUNDED_PIECE_WIDTH, SelectionsOverlay.ROUNDED_PIECE_WIDTH);
                    }
                    if (endStyle.top === 1 /* CornerStyle.INTERN */  || endStyle.bottom === 1 /* CornerStyle.INTERN */ ) {
                        // Reverse rounded corner to the right
                        // First comes the selection (blue layer)
                        innerCornerOutput += this._createSelectionPiece(top, bottom, SelectionsOverlay.SELECTION_CLASS_NAME, visibleRange.left + visibleRange.width, SelectionsOverlay.ROUNDED_PIECE_WIDTH);
                        // Second comes the background (white layer) with inverse border radius
                        let className = SelectionsOverlay.EDITOR_BACKGROUND_CLASS_NAME;
                        if (endStyle.top === 1 /* CornerStyle.INTERN */ ) className += " " + SelectionsOverlay.SELECTION_TOP_LEFT;
                        if (endStyle.bottom === 1 /* CornerStyle.INTERN */ ) className += " " + SelectionsOverlay.SELECTION_BOTTOM_LEFT;
                        innerCornerOutput += this._createSelectionPiece(top, bottom, className, visibleRange.left + visibleRange.width, SelectionsOverlay.ROUNDED_PIECE_WIDTH);
                    }
                }
                let className = SelectionsOverlay.SELECTION_CLASS_NAME;
                if (visibleRangesHaveStyle) {
                    const startStyle = visibleRange.startStyle;
                    const endStyle = visibleRange.endStyle;
                    if (startStyle.top === 0 /* CornerStyle.EXTERN */ ) className += " " + SelectionsOverlay.SELECTION_TOP_LEFT;
                    if (startStyle.bottom === 0 /* CornerStyle.EXTERN */ ) className += " " + SelectionsOverlay.SELECTION_BOTTOM_LEFT;
                    if (endStyle.top === 0 /* CornerStyle.EXTERN */ ) className += " " + SelectionsOverlay.SELECTION_TOP_RIGHT;
                    if (endStyle.bottom === 0 /* CornerStyle.EXTERN */ ) className += " " + SelectionsOverlay.SELECTION_BOTTOM_RIGHT;
                }
                restOfSelectionOutput += this._createSelectionPiece(top, bottom, className, visibleRange.left, visibleRange.width);
            }
            output2[lineIndex][0] += innerCornerOutput;
            output2[lineIndex][1] += restOfSelectionOutput;
        }
    }
    prepareRender(ctx) {
        // Build HTML for inner corners separate from HTML for the rest of selections,
        // as the inner corner HTML can interfere with that of other selections.
        // In final render, make sure to place the inner corner HTML before the rest of selection HTML. See issue #77777.
        const output = [];
        const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
        const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
        for(let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++){
            const lineIndex = lineNumber - visibleStartLineNumber;
            output[lineIndex] = [
                "",
                ""
            ];
        }
        const thisFrameVisibleRangesWithStyle = [];
        for(let i = 0, len = this._selections.length; i < len; i++){
            const selection = this._selections[i];
            if (selection.isEmpty()) {
                thisFrameVisibleRangesWithStyle[i] = null;
                continue;
            }
            const visibleRangesWithStyle = this._getVisibleRangesWithStyle(selection, ctx, this._previousFrameVisibleRangesWithStyle[i]);
            thisFrameVisibleRangesWithStyle[i] = visibleRangesWithStyle;
            this._actualRenderOneSelection(output, visibleStartLineNumber, this._selections.length > 1, visibleRangesWithStyle);
        }
        this._previousFrameVisibleRangesWithStyle = thisFrameVisibleRangesWithStyle;
        this._renderResult = output.map(([internalCorners, restOfSelection])=>internalCorners + restOfSelection);
    }
    render(startLineNumber, lineNumber) {
        if (!this._renderResult) return "";
        const lineIndex = lineNumber - startLineNumber;
        if (lineIndex < 0 || lineIndex >= this._renderResult.length) return "";
        return this._renderResult[lineIndex];
    }
}
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const editorSelectionForegroundColor = theme.getColor((0, _colorRegistryJs.editorSelectionForeground));
    if (editorSelectionForegroundColor && !editorSelectionForegroundColor.isTransparent()) collector.addRule(`.monaco-editor .view-line span.inline-selected-text { color: ${editorSelectionForegroundColor}; }`);
});
function abs(n) {
    return n < 0 ? -n : n;
}

},{"./selections.css":"a9CBO","../../view/dynamicViewOverlay.js":"dULHQ","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a9CBO":[function() {},{}],"cYAdh":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewCursors", ()=>ViewCursors);
var _viewCursorsCss = require("./viewCursors.css");
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _asyncJs = require("../../../../base/common/async.js");
var _viewPartJs = require("../../view/viewPart.js");
var _viewCursorJs = require("./viewCursor.js");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
var _editorColorRegistryJs = require("../../../common/core/editorColorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _themeJs = require("../../../../platform/theme/common/theme.js");
var _domJs = require("../../../../base/browser/dom.js");
class ViewCursors extends (0, _viewPartJs.ViewPart) {
    static{
        this.BLINK_INTERVAL = 500;
    }
    constructor(context){
        super(context);
        const options = this._context.configuration.options;
        this._readOnly = options.get(92 /* EditorOption.readOnly */ );
        this._cursorBlinking = options.get(26 /* EditorOption.cursorBlinking */ );
        this._cursorStyle = options.get(28 /* EditorOption.cursorStyle */ );
        this._cursorSmoothCaretAnimation = options.get(27 /* EditorOption.cursorSmoothCaretAnimation */ );
        this._selectionIsEmpty = true;
        this._isComposingInput = false;
        this._isVisible = false;
        this._primaryCursor = new (0, _viewCursorJs.ViewCursor)(this._context, (0, _viewCursorJs.CursorPlurality).Single);
        this._secondaryCursors = [];
        this._renderData = [];
        this._domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this._domNode.setAttribute("role", "presentation");
        this._domNode.setAttribute("aria-hidden", "true");
        this._updateDomClassName();
        this._domNode.appendChild(this._primaryCursor.getDomNode());
        this._startCursorBlinkAnimation = new (0, _asyncJs.TimeoutTimer)();
        this._cursorFlatBlinkInterval = new (0, _domJs.WindowIntervalTimer)();
        this._blinkingEnabled = false;
        this._editorHasFocus = false;
        this._updateBlinking();
    }
    dispose() {
        super.dispose();
        this._startCursorBlinkAnimation.dispose();
        this._cursorFlatBlinkInterval.dispose();
    }
    getDomNode() {
        return this._domNode;
    }
    // --- begin event handlers
    onCompositionStart(e) {
        this._isComposingInput = true;
        this._updateBlinking();
        return true;
    }
    onCompositionEnd(e) {
        this._isComposingInput = false;
        this._updateBlinking();
        return true;
    }
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        this._readOnly = options.get(92 /* EditorOption.readOnly */ );
        this._cursorBlinking = options.get(26 /* EditorOption.cursorBlinking */ );
        this._cursorStyle = options.get(28 /* EditorOption.cursorStyle */ );
        this._cursorSmoothCaretAnimation = options.get(27 /* EditorOption.cursorSmoothCaretAnimation */ );
        this._updateBlinking();
        this._updateDomClassName();
        this._primaryCursor.onConfigurationChanged(e);
        for(let i = 0, len = this._secondaryCursors.length; i < len; i++)this._secondaryCursors[i].onConfigurationChanged(e);
        return true;
    }
    _onCursorPositionChanged(position, secondaryPositions, reason) {
        const pauseAnimation = this._secondaryCursors.length !== secondaryPositions.length || this._cursorSmoothCaretAnimation === "explicit" && reason !== 3 /* CursorChangeReason.Explicit */ ;
        this._primaryCursor.setPlurality(secondaryPositions.length ? (0, _viewCursorJs.CursorPlurality).MultiPrimary : (0, _viewCursorJs.CursorPlurality).Single);
        this._primaryCursor.onCursorPositionChanged(position, pauseAnimation);
        this._updateBlinking();
        if (this._secondaryCursors.length < secondaryPositions.length) {
            // Create new cursors
            const addCnt = secondaryPositions.length - this._secondaryCursors.length;
            for(let i = 0; i < addCnt; i++){
                const newCursor = new (0, _viewCursorJs.ViewCursor)(this._context, (0, _viewCursorJs.CursorPlurality).MultiSecondary);
                this._domNode.domNode.insertBefore(newCursor.getDomNode().domNode, this._primaryCursor.getDomNode().domNode.nextSibling);
                this._secondaryCursors.push(newCursor);
            }
        } else if (this._secondaryCursors.length > secondaryPositions.length) {
            // Remove some cursors
            const removeCnt = this._secondaryCursors.length - secondaryPositions.length;
            for(let i = 0; i < removeCnt; i++){
                this._domNode.removeChild(this._secondaryCursors[0].getDomNode());
                this._secondaryCursors.splice(0, 1);
            }
        }
        for(let i = 0; i < secondaryPositions.length; i++)this._secondaryCursors[i].onCursorPositionChanged(secondaryPositions[i], pauseAnimation);
    }
    onCursorStateChanged(e) {
        const positions = [];
        for(let i = 0, len = e.selections.length; i < len; i++)positions[i] = e.selections[i].getPosition();
        this._onCursorPositionChanged(positions[0], positions.slice(1), e.reason);
        const selectionIsEmpty = e.selections[0].isEmpty();
        if (this._selectionIsEmpty !== selectionIsEmpty) {
            this._selectionIsEmpty = selectionIsEmpty;
            this._updateDomClassName();
        }
        return true;
    }
    onDecorationsChanged(e) {
        // true for inline decorations that can end up relayouting text
        return true;
    }
    onFlushed(e) {
        return true;
    }
    onFocusChanged(e) {
        this._editorHasFocus = e.isFocused;
        this._updateBlinking();
        return false;
    }
    onLinesChanged(e) {
        return true;
    }
    onLinesDeleted(e) {
        return true;
    }
    onLinesInserted(e) {
        return true;
    }
    onScrollChanged(e) {
        return true;
    }
    onTokensChanged(e) {
        const shouldRender = (position)=>{
            for(let i = 0, len = e.ranges.length; i < len; i++){
                if (e.ranges[i].fromLineNumber <= position.lineNumber && position.lineNumber <= e.ranges[i].toLineNumber) return true;
            }
            return false;
        };
        if (shouldRender(this._primaryCursor.getPosition())) return true;
        for (const secondaryCursor of this._secondaryCursors){
            if (shouldRender(secondaryCursor.getPosition())) return true;
        }
        return false;
    }
    onZonesChanged(e) {
        return true;
    }
    // --- end event handlers
    // ---- blinking logic
    _getCursorBlinking() {
        if (this._isComposingInput) // avoid double cursors
        return 0 /* TextEditorCursorBlinkingStyle.Hidden */ ;
        if (!this._editorHasFocus) return 0 /* TextEditorCursorBlinkingStyle.Hidden */ ;
        if (this._readOnly) return 5 /* TextEditorCursorBlinkingStyle.Solid */ ;
        return this._cursorBlinking;
    }
    _updateBlinking() {
        this._startCursorBlinkAnimation.cancel();
        this._cursorFlatBlinkInterval.cancel();
        const blinkingStyle = this._getCursorBlinking();
        // hidden and solid are special as they involve no animations
        const isHidden = blinkingStyle === 0 /* TextEditorCursorBlinkingStyle.Hidden */ ;
        const isSolid = blinkingStyle === 5 /* TextEditorCursorBlinkingStyle.Solid */ ;
        if (isHidden) this._hide();
        else this._show();
        this._blinkingEnabled = false;
        this._updateDomClassName();
        if (!isHidden && !isSolid) {
            if (blinkingStyle === 1 /* TextEditorCursorBlinkingStyle.Blink */ ) // flat blinking is handled by JavaScript to save battery life due to Chromium step timing issue https://bugs.chromium.org/p/chromium/issues/detail?id=361587
            this._cursorFlatBlinkInterval.cancelAndSet(()=>{
                if (this._isVisible) this._hide();
                else this._show();
            }, ViewCursors.BLINK_INTERVAL, (0, _domJs.getWindow)(this._domNode.domNode));
            else this._startCursorBlinkAnimation.setIfNotSet(()=>{
                this._blinkingEnabled = true;
                this._updateDomClassName();
            }, ViewCursors.BLINK_INTERVAL);
        }
    }
    // --- end blinking logic
    _updateDomClassName() {
        this._domNode.setClassName(this._getClassName());
    }
    _getClassName() {
        let result = "cursors-layer";
        if (!this._selectionIsEmpty) result += " has-selection";
        switch(this._cursorStyle){
            case (0, _editorOptionsJs.TextEditorCursorStyle).Line:
                result += " cursor-line-style";
                break;
            case (0, _editorOptionsJs.TextEditorCursorStyle).Block:
                result += " cursor-block-style";
                break;
            case (0, _editorOptionsJs.TextEditorCursorStyle).Underline:
                result += " cursor-underline-style";
                break;
            case (0, _editorOptionsJs.TextEditorCursorStyle).LineThin:
                result += " cursor-line-thin-style";
                break;
            case (0, _editorOptionsJs.TextEditorCursorStyle).BlockOutline:
                result += " cursor-block-outline-style";
                break;
            case (0, _editorOptionsJs.TextEditorCursorStyle).UnderlineThin:
                result += " cursor-underline-thin-style";
                break;
            default:
                result += " cursor-line-style";
        }
        if (this._blinkingEnabled) switch(this._getCursorBlinking()){
            case 1 /* TextEditorCursorBlinkingStyle.Blink */ :
                result += " cursor-blink";
                break;
            case 2 /* TextEditorCursorBlinkingStyle.Smooth */ :
                result += " cursor-smooth";
                break;
            case 3 /* TextEditorCursorBlinkingStyle.Phase */ :
                result += " cursor-phase";
                break;
            case 4 /* TextEditorCursorBlinkingStyle.Expand */ :
                result += " cursor-expand";
                break;
            case 5 /* TextEditorCursorBlinkingStyle.Solid */ :
                result += " cursor-solid";
                break;
            default:
                result += " cursor-solid";
        }
        else result += " cursor-solid";
        if (this._cursorSmoothCaretAnimation === "on" || this._cursorSmoothCaretAnimation === "explicit") result += " cursor-smooth-caret-animation";
        return result;
    }
    _show() {
        this._primaryCursor.show();
        for(let i = 0, len = this._secondaryCursors.length; i < len; i++)this._secondaryCursors[i].show();
        this._isVisible = true;
    }
    _hide() {
        this._primaryCursor.hide();
        for(let i = 0, len = this._secondaryCursors.length; i < len; i++)this._secondaryCursors[i].hide();
        this._isVisible = false;
    }
    // ---- IViewPart implementation
    prepareRender(ctx) {
        this._primaryCursor.prepareRender(ctx);
        for(let i = 0, len = this._secondaryCursors.length; i < len; i++)this._secondaryCursors[i].prepareRender(ctx);
    }
    render(ctx) {
        const renderData = [];
        let renderDataLen = 0;
        const primaryRenderData = this._primaryCursor.render(ctx);
        if (primaryRenderData) renderData[renderDataLen++] = primaryRenderData;
        for(let i = 0, len = this._secondaryCursors.length; i < len; i++){
            const secondaryRenderData = this._secondaryCursors[i].render(ctx);
            if (secondaryRenderData) renderData[renderDataLen++] = secondaryRenderData;
        }
        this._renderData = renderData;
    }
    getLastRenderData() {
        return this._renderData;
    }
}
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const cursorThemes = [
        {
            class: ".cursor",
            foreground: (0, _editorColorRegistryJs.editorCursorForeground),
            background: (0, _editorColorRegistryJs.editorCursorBackground)
        },
        {
            class: ".cursor-primary",
            foreground: (0, _editorColorRegistryJs.editorMultiCursorPrimaryForeground),
            background: (0, _editorColorRegistryJs.editorMultiCursorPrimaryBackground)
        },
        {
            class: ".cursor-secondary",
            foreground: (0, _editorColorRegistryJs.editorMultiCursorSecondaryForeground),
            background: (0, _editorColorRegistryJs.editorMultiCursorSecondaryBackground)
        }
    ];
    for (const cursorTheme of cursorThemes){
        const caret = theme.getColor(cursorTheme.foreground);
        if (caret) {
            let caretBackground = theme.getColor(cursorTheme.background);
            if (!caretBackground) caretBackground = caret.opposite();
            collector.addRule(`.monaco-editor .cursors-layer ${cursorTheme.class} { background-color: ${caret}; border-color: ${caret}; color: ${caretBackground}; }`);
            if ((0, _themeJs.isHighContrast)(theme.type)) collector.addRule(`.monaco-editor .cursors-layer.has-selection ${cursorTheme.class} { border-left: 1px solid ${caretBackground}; border-right: 1px solid ${caretBackground}; }`);
        }
    }
});

},{"./viewCursors.css":"kbU3I","../../../../base/browser/fastDomNode.js":"2SADf","../../../../base/common/async.js":"4GJc4","../../view/viewPart.js":"kTsLR","./viewCursor.js":"atWi1","../../../common/config/editorOptions.js":"3Xi00","../../../common/core/editorColorRegistry.js":"5XqtL","../../../../platform/theme/common/themeService.js":"jMkIC","../../../../platform/theme/common/theme.js":"gh7Zf","../../../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kbU3I":[function() {},{}],"atWi1":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CursorPlurality", ()=>CursorPlurality);
parcelHelpers.export(exports, "ViewCursor", ()=>ViewCursor);
var _domJs = require("../../../../base/browser/dom.js");
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _domFontInfoJs = require("../../config/domFontInfo.js");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _mouseCursorJs = require("../../../../base/browser/ui/mouseCursor/mouseCursor.js");
class ViewCursorRenderData {
    constructor(top, left, paddingLeft, width, height, textContent, textContentClassName){
        this.top = top;
        this.left = left;
        this.paddingLeft = paddingLeft;
        this.width = width;
        this.height = height;
        this.textContent = textContent;
        this.textContentClassName = textContentClassName;
    }
}
var CursorPlurality;
(function(CursorPlurality) {
    CursorPlurality[CursorPlurality["Single"] = 0] = "Single";
    CursorPlurality[CursorPlurality["MultiPrimary"] = 1] = "MultiPrimary";
    CursorPlurality[CursorPlurality["MultiSecondary"] = 2] = "MultiSecondary";
})(CursorPlurality || (CursorPlurality = {}));
class ViewCursor {
    constructor(context, plurality){
        this._context = context;
        const options = this._context.configuration.options;
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        this._cursorStyle = options.get(28 /* EditorOption.cursorStyle */ );
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this._typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
        this._lineCursorWidth = Math.min(options.get(31 /* EditorOption.cursorWidth */ ), this._typicalHalfwidthCharacterWidth);
        this._isVisible = true;
        // Create the dom node
        this._domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this._domNode.setClassName(`cursor ${(0, _mouseCursorJs.MOUSE_CURSOR_TEXT_CSS_CLASS_NAME)}`);
        this._domNode.setHeight(this._lineHeight);
        this._domNode.setTop(0);
        this._domNode.setLeft(0);
        (0, _domFontInfoJs.applyFontInfo)(this._domNode, fontInfo);
        this._domNode.setDisplay("none");
        this._position = new (0, _positionJs.Position)(1, 1);
        this._pluralityClass = "";
        this.setPlurality(plurality);
        this._lastRenderedContent = "";
        this._renderData = null;
    }
    getDomNode() {
        return this._domNode;
    }
    getPosition() {
        return this._position;
    }
    setPlurality(plurality) {
        switch(plurality){
            default:
            case CursorPlurality.Single:
                this._pluralityClass = "";
                break;
            case CursorPlurality.MultiPrimary:
                this._pluralityClass = "cursor-primary";
                break;
            case CursorPlurality.MultiSecondary:
                this._pluralityClass = "cursor-secondary";
                break;
        }
    }
    show() {
        if (!this._isVisible) {
            this._domNode.setVisibility("inherit");
            this._isVisible = true;
        }
    }
    hide() {
        if (this._isVisible) {
            this._domNode.setVisibility("hidden");
            this._isVisible = false;
        }
    }
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        this._cursorStyle = options.get(28 /* EditorOption.cursorStyle */ );
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this._typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
        this._lineCursorWidth = Math.min(options.get(31 /* EditorOption.cursorWidth */ ), this._typicalHalfwidthCharacterWidth);
        (0, _domFontInfoJs.applyFontInfo)(this._domNode, fontInfo);
        return true;
    }
    onCursorPositionChanged(position, pauseAnimation) {
        if (pauseAnimation) this._domNode.domNode.style.transitionProperty = "none";
        else this._domNode.domNode.style.transitionProperty = "";
        this._position = position;
        return true;
    }
    /**
     * If `this._position` is inside a grapheme, returns the position where the grapheme starts.
     * Also returns the next grapheme.
     */ _getGraphemeAwarePosition() {
        const { lineNumber, column } = this._position;
        const lineContent = this._context.viewModel.getLineContent(lineNumber);
        const [startOffset, endOffset] = _stringsJs.getCharContainingOffset(lineContent, column - 1);
        return [
            new (0, _positionJs.Position)(lineNumber, startOffset + 1),
            lineContent.substring(startOffset, endOffset)
        ];
    }
    _prepareRender(ctx) {
        let textContent = "";
        let textContentClassName = "";
        const [position, nextGrapheme] = this._getGraphemeAwarePosition();
        if (this._cursorStyle === (0, _editorOptionsJs.TextEditorCursorStyle).Line || this._cursorStyle === (0, _editorOptionsJs.TextEditorCursorStyle).LineThin) {
            const visibleRange = ctx.visibleRangeForPosition(position);
            if (!visibleRange || visibleRange.outsideRenderedLine) // Outside viewport
            return null;
            const window = _domJs.getWindow(this._domNode.domNode);
            let width;
            if (this._cursorStyle === (0, _editorOptionsJs.TextEditorCursorStyle).Line) {
                width = _domJs.computeScreenAwareSize(window, this._lineCursorWidth > 0 ? this._lineCursorWidth : 2);
                if (width > 2) {
                    textContent = nextGrapheme;
                    textContentClassName = this._getTokenClassName(position);
                }
            } else width = _domJs.computeScreenAwareSize(window, 1);
            let left = visibleRange.left;
            let paddingLeft = 0;
            if (width >= 2 && left >= 1) {
                // shift the cursor a bit between the characters
                paddingLeft = 1;
                left -= paddingLeft;
            }
            const top = ctx.getVerticalOffsetForLineNumber(position.lineNumber) - ctx.bigNumbersDelta;
            return new ViewCursorRenderData(top, left, paddingLeft, width, this._lineHeight, textContent, textContentClassName);
        }
        const visibleRangeForCharacter = ctx.linesVisibleRangesForRange(new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column + nextGrapheme.length), false);
        if (!visibleRangeForCharacter || visibleRangeForCharacter.length === 0) // Outside viewport
        return null;
        const firstVisibleRangeForCharacter = visibleRangeForCharacter[0];
        if (firstVisibleRangeForCharacter.outsideRenderedLine || firstVisibleRangeForCharacter.ranges.length === 0) // Outside viewport
        return null;
        const range = firstVisibleRangeForCharacter.ranges[0];
        const width = nextGrapheme === "	" ? this._typicalHalfwidthCharacterWidth : range.width < 1 ? this._typicalHalfwidthCharacterWidth : range.width;
        if (this._cursorStyle === (0, _editorOptionsJs.TextEditorCursorStyle).Block) {
            textContent = nextGrapheme;
            textContentClassName = this._getTokenClassName(position);
        }
        let top = ctx.getVerticalOffsetForLineNumber(position.lineNumber) - ctx.bigNumbersDelta;
        let height = this._lineHeight;
        // Underline might interfere with clicking
        if (this._cursorStyle === (0, _editorOptionsJs.TextEditorCursorStyle).Underline || this._cursorStyle === (0, _editorOptionsJs.TextEditorCursorStyle).UnderlineThin) {
            top += this._lineHeight - 2;
            height = 2;
        }
        return new ViewCursorRenderData(top, range.left, 0, width, height, textContent, textContentClassName);
    }
    _getTokenClassName(position) {
        const lineData = this._context.viewModel.getViewLineData(position.lineNumber);
        const tokenIndex = lineData.tokens.findTokenIndexAtOffset(position.column - 1);
        return lineData.tokens.getClassName(tokenIndex);
    }
    prepareRender(ctx) {
        this._renderData = this._prepareRender(ctx);
    }
    render(ctx) {
        if (!this._renderData) {
            this._domNode.setDisplay("none");
            return null;
        }
        if (this._lastRenderedContent !== this._renderData.textContent) {
            this._lastRenderedContent = this._renderData.textContent;
            this._domNode.domNode.textContent = this._lastRenderedContent;
        }
        this._domNode.setClassName(`cursor ${this._pluralityClass} ${(0, _mouseCursorJs.MOUSE_CURSOR_TEXT_CSS_CLASS_NAME)} ${this._renderData.textContentClassName}`);
        this._domNode.setDisplay("block");
        this._domNode.setTop(this._renderData.top);
        this._domNode.setLeft(this._renderData.left);
        this._domNode.setPaddingLeft(this._renderData.paddingLeft);
        this._domNode.setWidth(this._renderData.width);
        this._domNode.setLineHeight(this._renderData.height);
        this._domNode.setHeight(this._renderData.height);
        return {
            domNode: this._domNode.domNode,
            position: this._position,
            contentLeft: this._renderData.left,
            height: this._renderData.height,
            width: 2
        };
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/fastDomNode.js":"2SADf","../../../../base/common/strings.js":"aA9I1","../../config/domFontInfo.js":"fQezv","../../../common/config/editorOptions.js":"3Xi00","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../../base/browser/ui/mouseCursor/mouseCursor.js":"dizty","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iV3Rc":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewZones", ()=>ViewZones);
var _fastDomNodeJs = require("../../../../base/browser/fastDomNode.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _viewPartJs = require("../../view/viewPart.js");
var _positionJs = require("../../../common/core/position.js");
const invalidFunc = ()=>{
    throw new Error(`Invalid change accessor`);
};
class ViewZones extends (0, _viewPartJs.ViewPart) {
    constructor(context){
        super(context);
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this._contentWidth = layoutInfo.contentWidth;
        this._contentLeft = layoutInfo.contentLeft;
        this.domNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this.domNode.setClassName("view-zones");
        this.domNode.setPosition("absolute");
        this.domNode.setAttribute("role", "presentation");
        this.domNode.setAttribute("aria-hidden", "true");
        this.marginDomNode = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        this.marginDomNode.setClassName("margin-view-zones");
        this.marginDomNode.setPosition("absolute");
        this.marginDomNode.setAttribute("role", "presentation");
        this.marginDomNode.setAttribute("aria-hidden", "true");
        this._zones = {};
    }
    dispose() {
        super.dispose();
        this._zones = {};
    }
    // ---- begin view event handlers
    _recomputeWhitespacesProps() {
        const whitespaces = this._context.viewLayout.getWhitespaces();
        const oldWhitespaces = new Map();
        for (const whitespace of whitespaces)oldWhitespaces.set(whitespace.id, whitespace);
        let hadAChange = false;
        this._context.viewModel.changeWhitespace((whitespaceAccessor)=>{
            const keys = Object.keys(this._zones);
            for(let i = 0, len = keys.length; i < len; i++){
                const id = keys[i];
                const zone = this._zones[id];
                const props = this._computeWhitespaceProps(zone.delegate);
                zone.isInHiddenArea = props.isInHiddenArea;
                const oldWhitespace = oldWhitespaces.get(id);
                if (oldWhitespace && (oldWhitespace.afterLineNumber !== props.afterViewLineNumber || oldWhitespace.height !== props.heightInPx)) {
                    whitespaceAccessor.changeOneWhitespace(id, props.afterViewLineNumber, props.heightInPx);
                    this._safeCallOnComputedHeight(zone.delegate, props.heightInPx);
                    hadAChange = true;
                }
            }
        });
        return hadAChange;
    }
    onConfigurationChanged(e) {
        const options = this._context.configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        this._lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this._contentWidth = layoutInfo.contentWidth;
        this._contentLeft = layoutInfo.contentLeft;
        if (e.hasChanged(67 /* EditorOption.lineHeight */ )) this._recomputeWhitespacesProps();
        return true;
    }
    onLineMappingChanged(e) {
        return this._recomputeWhitespacesProps();
    }
    onLinesDeleted(e) {
        return true;
    }
    onScrollChanged(e) {
        return e.scrollTopChanged || e.scrollWidthChanged;
    }
    onZonesChanged(e) {
        return true;
    }
    onLinesInserted(e) {
        return true;
    }
    // ---- end view event handlers
    _getZoneOrdinal(zone) {
        return zone.ordinal ?? zone.afterColumn ?? 10000;
    }
    _computeWhitespaceProps(zone) {
        if (zone.afterLineNumber === 0) return {
            isInHiddenArea: false,
            afterViewLineNumber: 0,
            heightInPx: this._heightInPixels(zone),
            minWidthInPx: this._minWidthInPixels(zone)
        };
        let zoneAfterModelPosition;
        if (typeof zone.afterColumn !== "undefined") zoneAfterModelPosition = this._context.viewModel.model.validatePosition({
            lineNumber: zone.afterLineNumber,
            column: zone.afterColumn
        });
        else {
            const validAfterLineNumber = this._context.viewModel.model.validatePosition({
                lineNumber: zone.afterLineNumber,
                column: 1
            }).lineNumber;
            zoneAfterModelPosition = new (0, _positionJs.Position)(validAfterLineNumber, this._context.viewModel.model.getLineMaxColumn(validAfterLineNumber));
        }
        let zoneBeforeModelPosition;
        if (zoneAfterModelPosition.column === this._context.viewModel.model.getLineMaxColumn(zoneAfterModelPosition.lineNumber)) zoneBeforeModelPosition = this._context.viewModel.model.validatePosition({
            lineNumber: zoneAfterModelPosition.lineNumber + 1,
            column: 1
        });
        else zoneBeforeModelPosition = this._context.viewModel.model.validatePosition({
            lineNumber: zoneAfterModelPosition.lineNumber,
            column: zoneAfterModelPosition.column + 1
        });
        const viewPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(zoneAfterModelPosition, zone.afterColumnAffinity, true);
        const isVisible = zone.showInHiddenAreas || this._context.viewModel.coordinatesConverter.modelPositionIsVisible(zoneBeforeModelPosition);
        return {
            isInHiddenArea: !isVisible,
            afterViewLineNumber: viewPosition.lineNumber,
            heightInPx: isVisible ? this._heightInPixels(zone) : 0,
            minWidthInPx: this._minWidthInPixels(zone)
        };
    }
    changeViewZones(callback) {
        let zonesHaveChanged = false;
        this._context.viewModel.changeWhitespace((whitespaceAccessor)=>{
            const changeAccessor = {
                addZone: (zone)=>{
                    zonesHaveChanged = true;
                    return this._addZone(whitespaceAccessor, zone);
                },
                removeZone: (id)=>{
                    if (!id) return;
                    zonesHaveChanged = this._removeZone(whitespaceAccessor, id) || zonesHaveChanged;
                },
                layoutZone: (id)=>{
                    if (!id) return;
                    zonesHaveChanged = this._layoutZone(whitespaceAccessor, id) || zonesHaveChanged;
                }
            };
            safeInvoke1Arg(callback, changeAccessor);
            // Invalidate changeAccessor
            changeAccessor.addZone = invalidFunc;
            changeAccessor.removeZone = invalidFunc;
            changeAccessor.layoutZone = invalidFunc;
        });
        return zonesHaveChanged;
    }
    _addZone(whitespaceAccessor, zone) {
        const props = this._computeWhitespaceProps(zone);
        const whitespaceId = whitespaceAccessor.insertWhitespace(props.afterViewLineNumber, this._getZoneOrdinal(zone), props.heightInPx, props.minWidthInPx);
        const myZone = {
            whitespaceId: whitespaceId,
            delegate: zone,
            isInHiddenArea: props.isInHiddenArea,
            isVisible: false,
            domNode: (0, _fastDomNodeJs.createFastDomNode)(zone.domNode),
            marginDomNode: zone.marginDomNode ? (0, _fastDomNodeJs.createFastDomNode)(zone.marginDomNode) : null
        };
        this._safeCallOnComputedHeight(myZone.delegate, props.heightInPx);
        myZone.domNode.setPosition("absolute");
        myZone.domNode.domNode.style.width = "100%";
        myZone.domNode.setDisplay("none");
        myZone.domNode.setAttribute("monaco-view-zone", myZone.whitespaceId);
        this.domNode.appendChild(myZone.domNode);
        if (myZone.marginDomNode) {
            myZone.marginDomNode.setPosition("absolute");
            myZone.marginDomNode.domNode.style.width = "100%";
            myZone.marginDomNode.setDisplay("none");
            myZone.marginDomNode.setAttribute("monaco-view-zone", myZone.whitespaceId);
            this.marginDomNode.appendChild(myZone.marginDomNode);
        }
        this._zones[myZone.whitespaceId] = myZone;
        this.setShouldRender();
        return myZone.whitespaceId;
    }
    _removeZone(whitespaceAccessor, id) {
        if (this._zones.hasOwnProperty(id)) {
            const zone = this._zones[id];
            delete this._zones[id];
            whitespaceAccessor.removeWhitespace(zone.whitespaceId);
            zone.domNode.removeAttribute("monaco-visible-view-zone");
            zone.domNode.removeAttribute("monaco-view-zone");
            zone.domNode.domNode.remove();
            if (zone.marginDomNode) {
                zone.marginDomNode.removeAttribute("monaco-visible-view-zone");
                zone.marginDomNode.removeAttribute("monaco-view-zone");
                zone.marginDomNode.domNode.remove();
            }
            this.setShouldRender();
            return true;
        }
        return false;
    }
    _layoutZone(whitespaceAccessor, id) {
        if (this._zones.hasOwnProperty(id)) {
            const zone = this._zones[id];
            const props = this._computeWhitespaceProps(zone.delegate);
            zone.isInHiddenArea = props.isInHiddenArea;
            // const newOrdinal = this._getZoneOrdinal(zone.delegate);
            whitespaceAccessor.changeOneWhitespace(zone.whitespaceId, props.afterViewLineNumber, props.heightInPx);
            // TODO@Alex: change `newOrdinal` too
            this._safeCallOnComputedHeight(zone.delegate, props.heightInPx);
            this.setShouldRender();
            return true;
        }
        return false;
    }
    shouldSuppressMouseDownOnViewZone(id) {
        if (this._zones.hasOwnProperty(id)) {
            const zone = this._zones[id];
            return Boolean(zone.delegate.suppressMouseDown);
        }
        return false;
    }
    _heightInPixels(zone) {
        if (typeof zone.heightInPx === "number") return zone.heightInPx;
        if (typeof zone.heightInLines === "number") return this._lineHeight * zone.heightInLines;
        return this._lineHeight;
    }
    _minWidthInPixels(zone) {
        if (typeof zone.minWidthInPx === "number") return zone.minWidthInPx;
        return 0;
    }
    _safeCallOnComputedHeight(zone, height) {
        if (typeof zone.onComputedHeight === "function") try {
            zone.onComputedHeight(height);
        } catch (e) {
            (0, _errorsJs.onUnexpectedError)(e);
        }
    }
    _safeCallOnDomNodeTop(zone, top) {
        if (typeof zone.onDomNodeTop === "function") try {
            zone.onDomNodeTop(top);
        } catch (e) {
            (0, _errorsJs.onUnexpectedError)(e);
        }
    }
    prepareRender(ctx) {
    // Nothing to read
    }
    render(ctx) {
        const visibleWhitespaces = ctx.viewportData.whitespaceViewportData;
        const visibleZones = {};
        let hasVisibleZone = false;
        for (const visibleWhitespace of visibleWhitespaces){
            if (this._zones[visibleWhitespace.id].isInHiddenArea) continue;
            visibleZones[visibleWhitespace.id] = visibleWhitespace;
            hasVisibleZone = true;
        }
        const keys = Object.keys(this._zones);
        for(let i = 0, len = keys.length; i < len; i++){
            const id = keys[i];
            const zone = this._zones[id];
            let newTop = 0;
            let newHeight = 0;
            let newDisplay = "none";
            if (visibleZones.hasOwnProperty(id)) {
                newTop = visibleZones[id].verticalOffset - ctx.bigNumbersDelta;
                newHeight = visibleZones[id].height;
                newDisplay = "block";
                // zone is visible
                if (!zone.isVisible) {
                    zone.domNode.setAttribute("monaco-visible-view-zone", "true");
                    zone.isVisible = true;
                }
                this._safeCallOnDomNodeTop(zone.delegate, ctx.getScrolledTopFromAbsoluteTop(visibleZones[id].verticalOffset));
            } else {
                if (zone.isVisible) {
                    zone.domNode.removeAttribute("monaco-visible-view-zone");
                    zone.isVisible = false;
                }
                this._safeCallOnDomNodeTop(zone.delegate, ctx.getScrolledTopFromAbsoluteTop(-1000000));
            }
            zone.domNode.setTop(newTop);
            zone.domNode.setHeight(newHeight);
            zone.domNode.setDisplay(newDisplay);
            if (zone.marginDomNode) {
                zone.marginDomNode.setTop(newTop);
                zone.marginDomNode.setHeight(newHeight);
                zone.marginDomNode.setDisplay(newDisplay);
            }
        }
        if (hasVisibleZone) {
            this.domNode.setWidth(Math.max(ctx.scrollWidth, this._contentWidth));
            this.marginDomNode.setWidth(this._contentLeft);
        }
    }
}
function safeInvoke1Arg(func, arg1) {
    try {
        return func(arg1);
    } catch (e) {
        (0, _errorsJs.onUnexpectedError)(e);
    }
}

},{"../../../../base/browser/fastDomNode.js":"2SADf","../../../../base/common/errors.js":"divX8","../../view/viewPart.js":"kTsLR","../../../common/core/position.js":"lvrPe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6KlIs":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WhitespaceOverlay", ()=>WhitespaceOverlay);
var _whitespaceCss = require("./whitespace.css");
var _dynamicViewOverlayJs = require("../../view/dynamicViewOverlay.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _viewLineRendererJs = require("../../../common/viewLayout/viewLineRenderer.js");
var _positionJs = require("../../../common/core/position.js");
var _editorColorRegistryJs = require("../../../common/core/editorColorRegistry.js");
class WhitespaceOverlay extends (0, _dynamicViewOverlayJs.DynamicViewOverlay) {
    constructor(context){
        super();
        this._context = context;
        this._options = new WhitespaceOptions(this._context.configuration);
        this._selection = [];
        this._renderResult = null;
        this._context.addEventHandler(this);
    }
    dispose() {
        this._context.removeEventHandler(this);
        this._renderResult = null;
        super.dispose();
    }
    // --- begin event handlers
    onConfigurationChanged(e) {
        const newOptions = new WhitespaceOptions(this._context.configuration);
        if (this._options.equals(newOptions)) return e.hasChanged(146 /* EditorOption.layoutInfo */ );
        this._options = newOptions;
        return true;
    }
    onCursorStateChanged(e) {
        this._selection = e.selections;
        if (this._options.renderWhitespace === "selection") return true;
        return false;
    }
    onDecorationsChanged(e) {
        return true;
    }
    onFlushed(e) {
        return true;
    }
    onLinesChanged(e) {
        return true;
    }
    onLinesDeleted(e) {
        return true;
    }
    onLinesInserted(e) {
        return true;
    }
    onScrollChanged(e) {
        return e.scrollTopChanged;
    }
    onZonesChanged(e) {
        return true;
    }
    // --- end event handlers
    prepareRender(ctx) {
        if (this._options.renderWhitespace === "none") {
            this._renderResult = null;
            return;
        }
        const startLineNumber = ctx.visibleRange.startLineNumber;
        const endLineNumber = ctx.visibleRange.endLineNumber;
        const lineCount = endLineNumber - startLineNumber + 1;
        const needed = new Array(lineCount);
        for(let i = 0; i < lineCount; i++)needed[i] = true;
        const viewportData = this._context.viewModel.getMinimapLinesRenderingData(ctx.viewportData.startLineNumber, ctx.viewportData.endLineNumber, needed);
        this._renderResult = [];
        for(let lineNumber = ctx.viewportData.startLineNumber; lineNumber <= ctx.viewportData.endLineNumber; lineNumber++){
            const lineIndex = lineNumber - ctx.viewportData.startLineNumber;
            const lineData = viewportData.data[lineIndex];
            let selectionsOnLine = null;
            if (this._options.renderWhitespace === "selection") {
                const selections = this._selection;
                for (const selection of selections){
                    if (selection.endLineNumber < lineNumber || selection.startLineNumber > lineNumber) continue;
                    const startColumn = selection.startLineNumber === lineNumber ? selection.startColumn : lineData.minColumn;
                    const endColumn = selection.endLineNumber === lineNumber ? selection.endColumn : lineData.maxColumn;
                    if (startColumn < endColumn) {
                        if (!selectionsOnLine) selectionsOnLine = [];
                        selectionsOnLine.push(new (0, _viewLineRendererJs.LineRange)(startColumn - 1, endColumn - 1));
                    }
                }
            }
            this._renderResult[lineIndex] = this._applyRenderWhitespace(ctx, lineNumber, selectionsOnLine, lineData);
        }
    }
    _applyRenderWhitespace(ctx, lineNumber, selections, lineData) {
        if (this._options.renderWhitespace === "selection" && !selections) return "";
        if (this._options.renderWhitespace === "trailing" && lineData.continuesWithWrappedLine) return "";
        const color = this._context.theme.getColor((0, _editorColorRegistryJs.editorWhitespaces));
        const USE_SVG = this._options.renderWithSVG;
        const lineContent = lineData.content;
        const len = this._options.stopRenderingLineAfter === -1 ? lineContent.length : Math.min(this._options.stopRenderingLineAfter, lineContent.length);
        const continuesWithWrappedLine = lineData.continuesWithWrappedLine;
        const fauxIndentLength = lineData.minColumn - 1;
        const onlyBoundary = this._options.renderWhitespace === "boundary";
        const onlyTrailing = this._options.renderWhitespace === "trailing";
        const lineHeight = this._options.lineHeight;
        const middotWidth = this._options.middotWidth;
        const wsmiddotWidth = this._options.wsmiddotWidth;
        const spaceWidth = this._options.spaceWidth;
        const wsmiddotDiff = Math.abs(wsmiddotWidth - spaceWidth);
        const middotDiff = Math.abs(middotWidth - spaceWidth);
        // U+2E31 - WORD SEPARATOR MIDDLE DOT
        // U+00B7 - MIDDLE DOT
        const renderSpaceCharCode = wsmiddotDiff < middotDiff ? 0x2E31 : 0xB7;
        const canUseHalfwidthRightwardsArrow = this._options.canUseHalfwidthRightwardsArrow;
        let result = "";
        let lineIsEmptyOrWhitespace = false;
        let firstNonWhitespaceIndex = _stringsJs.firstNonWhitespaceIndex(lineContent);
        let lastNonWhitespaceIndex;
        if (firstNonWhitespaceIndex === -1) {
            lineIsEmptyOrWhitespace = true;
            firstNonWhitespaceIndex = len;
            lastNonWhitespaceIndex = len;
        } else lastNonWhitespaceIndex = _stringsJs.lastNonWhitespaceIndex(lineContent);
        let currentSelectionIndex = 0;
        let currentSelection = selections && selections[currentSelectionIndex];
        let maxLeft = 0;
        for(let charIndex = fauxIndentLength; charIndex < len; charIndex++){
            const chCode = lineContent.charCodeAt(charIndex);
            if (currentSelection && charIndex >= currentSelection.endOffset) {
                currentSelectionIndex++;
                currentSelection = selections && selections[currentSelectionIndex];
            }
            if (chCode !== 9 /* CharCode.Tab */  && chCode !== 32 /* CharCode.Space */ ) continue;
            if (onlyTrailing && !lineIsEmptyOrWhitespace && charIndex <= lastNonWhitespaceIndex) continue;
            if (onlyBoundary && charIndex >= firstNonWhitespaceIndex && charIndex <= lastNonWhitespaceIndex && chCode === 32 /* CharCode.Space */ ) {
                // rendering only boundary whitespace
                const prevChCode = charIndex - 1 >= 0 ? lineContent.charCodeAt(charIndex - 1) : 0 /* CharCode.Null */ ;
                const nextChCode = charIndex + 1 < len ? lineContent.charCodeAt(charIndex + 1) : 0 /* CharCode.Null */ ;
                if (prevChCode !== 32 /* CharCode.Space */  && nextChCode !== 32 /* CharCode.Space */ ) continue;
            }
            if (onlyBoundary && continuesWithWrappedLine && charIndex === len - 1) {
                const prevCharCode = charIndex - 1 >= 0 ? lineContent.charCodeAt(charIndex - 1) : 0 /* CharCode.Null */ ;
                const isSingleTrailingSpace = chCode === 32 /* CharCode.Space */  && prevCharCode !== 32 /* CharCode.Space */  && prevCharCode !== 9 /* CharCode.Tab */ ;
                if (isSingleTrailingSpace) continue;
            }
            if (selections && (!currentSelection || currentSelection.startOffset > charIndex || currentSelection.endOffset <= charIndex)) continue;
            const visibleRange = ctx.visibleRangeForPosition(new (0, _positionJs.Position)(lineNumber, charIndex + 1));
            if (!visibleRange) continue;
            if (USE_SVG) {
                maxLeft = Math.max(maxLeft, visibleRange.left);
                if (chCode === 9 /* CharCode.Tab */ ) result += this._renderArrow(lineHeight, spaceWidth, visibleRange.left);
                else result += `<circle cx="${(visibleRange.left + spaceWidth / 2).toFixed(2)}" cy="${(lineHeight / 2).toFixed(2)}" r="${(spaceWidth / 7).toFixed(2)}" />`;
            } else if (chCode === 9 /* CharCode.Tab */ ) result += `<div class="mwh" style="left:${visibleRange.left}px;height:${lineHeight}px;">${canUseHalfwidthRightwardsArrow ? String.fromCharCode(0xFFEB) : String.fromCharCode(0x2192)}</div>`;
            else result += `<div class="mwh" style="left:${visibleRange.left}px;height:${lineHeight}px;">${String.fromCharCode(renderSpaceCharCode)}</div>`;
        }
        if (USE_SVG) {
            maxLeft = Math.round(maxLeft + spaceWidth);
            return `<svg style="bottom:0;position:absolute;width:${maxLeft}px;height:${lineHeight}px" viewBox="0 0 ${maxLeft} ${lineHeight}" xmlns="http://www.w3.org/2000/svg" fill="${color}">` + result + `</svg>`;
        }
        return result;
    }
    _renderArrow(lineHeight, spaceWidth, left) {
        const strokeWidth = spaceWidth / 7;
        const width = spaceWidth;
        const dy = lineHeight / 2;
        const dx = left;
        const p1 = {
            x: 0,
            y: strokeWidth / 2
        };
        const p2 = {
            x: 0.8 * width,
            y: p1.y
        };
        const p3 = {
            x: p2.x - 0.2 * p2.x,
            y: p2.y + 0.2 * p2.x
        };
        const p4 = {
            x: p3.x + 0.1 * p2.x,
            y: p3.y + 0.1 * p2.x
        };
        const p5 = {
            x: p4.x + 0.35 * p2.x,
            y: p4.y - 0.35 * p2.x
        };
        const p6 = {
            x: p5.x,
            y: -p5.y
        };
        const p7 = {
            x: p4.x,
            y: -p4.y
        };
        const p8 = {
            x: p3.x,
            y: -p3.y
        };
        const p9 = {
            x: p2.x,
            y: -p2.y
        };
        const p10 = {
            x: p1.x,
            y: -p1.y
        };
        const p = [
            p1,
            p2,
            p3,
            p4,
            p5,
            p6,
            p7,
            p8,
            p9,
            p10
        ];
        const parts = p.map((p)=>`${(dx + p.x).toFixed(2)} ${(dy + p.y).toFixed(2)}`).join(" L ");
        return `<path d="M ${parts}" />`;
    }
    render(startLineNumber, lineNumber) {
        if (!this._renderResult) return "";
        const lineIndex = lineNumber - startLineNumber;
        if (lineIndex < 0 || lineIndex >= this._renderResult.length) return "";
        return this._renderResult[lineIndex];
    }
}
class WhitespaceOptions {
    constructor(config){
        const options = config.options;
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        const experimentalWhitespaceRendering = options.get(38 /* EditorOption.experimentalWhitespaceRendering */ );
        if (experimentalWhitespaceRendering === "off") {
            // whitespace is rendered in the view line
            this.renderWhitespace = "none";
            this.renderWithSVG = false;
        } else if (experimentalWhitespaceRendering === "svg") {
            this.renderWhitespace = options.get(100 /* EditorOption.renderWhitespace */ );
            this.renderWithSVG = true;
        } else {
            this.renderWhitespace = options.get(100 /* EditorOption.renderWhitespace */ );
            this.renderWithSVG = false;
        }
        this.spaceWidth = fontInfo.spaceWidth;
        this.middotWidth = fontInfo.middotWidth;
        this.wsmiddotWidth = fontInfo.wsmiddotWidth;
        this.canUseHalfwidthRightwardsArrow = fontInfo.canUseHalfwidthRightwardsArrow;
        this.lineHeight = options.get(67 /* EditorOption.lineHeight */ );
        this.stopRenderingLineAfter = options.get(118 /* EditorOption.stopRenderingLineAfter */ );
    }
    equals(other) {
        return this.renderWhitespace === other.renderWhitespace && this.renderWithSVG === other.renderWithSVG && this.spaceWidth === other.spaceWidth && this.middotWidth === other.middotWidth && this.wsmiddotWidth === other.wsmiddotWidth && this.canUseHalfwidthRightwardsArrow === other.canUseHalfwidthRightwardsArrow && this.lineHeight === other.lineHeight && this.stopRenderingLineAfter === other.stopRenderingLineAfter;
    }
}

},{"./whitespace.css":"cNS4u","../../view/dynamicViewOverlay.js":"dULHQ","../../../../base/common/strings.js":"aA9I1","../../../common/viewLayout/viewLineRenderer.js":"1RGPz","../../../common/core/position.js":"lvrPe","../../../common/core/editorColorRegistry.js":"5XqtL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cNS4u":[function() {},{}],"emhOT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Contains all data needed to render at a specific viewport.
 */ parcelHelpers.export(exports, "ViewportData", ()=>ViewportData);
var _rangeJs = require("../core/range.js");
class ViewportData {
    constructor(selections, partialData, whitespaceViewportData, model){
        this.selections = selections;
        this.startLineNumber = partialData.startLineNumber | 0;
        this.endLineNumber = partialData.endLineNumber | 0;
        this.relativeVerticalOffset = partialData.relativeVerticalOffset;
        this.bigNumbersDelta = partialData.bigNumbersDelta | 0;
        this.lineHeight = partialData.lineHeight | 0;
        this.whitespaceViewportData = whitespaceViewportData;
        this._model = model;
        this.visibleRange = new (0, _rangeJs.Range)(partialData.startLineNumber, this._model.getLineMinColumn(partialData.startLineNumber), partialData.endLineNumber, this._model.getLineMaxColumn(partialData.endLineNumber));
    }
    getViewLineRenderingData(lineNumber) {
        return this._model.getViewportViewLineRenderingData(this.visibleRange, lineNumber);
    }
    getDecorationsInViewport() {
        return this._model.getDecorationsInViewport(this.visibleRange);
    }
}

},{"../core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gdMDu":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewContext", ()=>ViewContext);
var _editorThemeJs = require("../editorTheme.js");
class ViewContext {
    constructor(configuration, theme, model){
        this.configuration = configuration;
        this.theme = new (0, _editorThemeJs.EditorTheme)(theme);
        this.viewModel = model;
        this.viewLayout = model.viewLayout;
    }
    addEventHandler(eventHandler) {
        this.viewModel.addViewEventHandler(eventHandler);
    }
    removeEventHandler(eventHandler) {
        this.viewModel.removeViewEventHandler(eventHandler);
    }
}

},{"../editorTheme.js":"4rp5G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4rp5G":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorTheme", ()=>EditorTheme);
class EditorTheme {
    get type() {
        return this._theme.type;
    }
    get value() {
        return this._theme;
    }
    constructor(theme){
        this._theme = theme;
    }
    update(theme) {
        this._theme = theme;
    }
    getColor(color) {
        return this._theme.getColor(color);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6iGoB":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMLineBreaksComputerFactory", ()=>DOMLineBreaksComputerFactory);
var _trustedTypesJs = require("../../../base/browser/trustedTypes.js");
var _stringsJs = require("../../../base/common/strings.js");
var _typesJs = require("../../../base/common/types.js");
var _domFontInfoJs = require("../config/domFontInfo.js");
var _stringBuilderJs = require("../../common/core/stringBuilder.js");
var _modelLineProjectionDataJs = require("../../common/modelLineProjectionData.js");
var _textModelEventsJs = require("../../common/textModelEvents.js");
const ttPolicy = (0, _trustedTypesJs.createTrustedTypesPolicy)("domLineBreaksComputer", {
    createHTML: (value)=>value
});
class DOMLineBreaksComputerFactory {
    static create(targetWindow) {
        return new DOMLineBreaksComputerFactory(new WeakRef(targetWindow));
    }
    constructor(targetWindow){
        this.targetWindow = targetWindow;
    }
    createLineBreaksComputer(fontInfo, tabSize, wrappingColumn, wrappingIndent, wordBreak) {
        const requests = [];
        const injectedTexts = [];
        return {
            addRequest: (lineText, injectedText, previousLineBreakData)=>{
                requests.push(lineText);
                injectedTexts.push(injectedText);
            },
            finalize: ()=>{
                return createLineBreaks((0, _typesJs.assertIsDefined)(this.targetWindow.deref()), requests, fontInfo, tabSize, wrappingColumn, wrappingIndent, wordBreak, injectedTexts);
            }
        };
    }
}
function createLineBreaks(targetWindow, requests, fontInfo, tabSize, firstLineBreakColumn, wrappingIndent, wordBreak, injectedTextsPerLine) {
    function createEmptyLineBreakWithPossiblyInjectedText(requestIdx) {
        const injectedTexts = injectedTextsPerLine[requestIdx];
        if (injectedTexts) {
            const lineText = (0, _textModelEventsJs.LineInjectedText).applyInjectedText(requests[requestIdx], injectedTexts);
            const injectionOptions = injectedTexts.map((t)=>t.options);
            const injectionOffsets = injectedTexts.map((text)=>text.column - 1);
            // creating a `LineBreakData` with an invalid `breakOffsetsVisibleColumn` is OK
            // because `breakOffsetsVisibleColumn` will never be used because it contains injected text
            return new (0, _modelLineProjectionDataJs.ModelLineProjectionData)(injectionOffsets, injectionOptions, [
                lineText.length
            ], [], 0);
        } else return null;
    }
    if (firstLineBreakColumn === -1) {
        const result = [];
        for(let i = 0, len = requests.length; i < len; i++)result[i] = createEmptyLineBreakWithPossiblyInjectedText(i);
        return result;
    }
    const overallWidth = Math.round(firstLineBreakColumn * fontInfo.typicalHalfwidthCharacterWidth);
    const additionalIndent = wrappingIndent === 3 /* WrappingIndent.DeepIndent */  ? 2 : wrappingIndent === 2 /* WrappingIndent.Indent */  ? 1 : 0;
    const additionalIndentSize = Math.round(tabSize * additionalIndent);
    const additionalIndentLength = Math.ceil(fontInfo.spaceWidth * additionalIndentSize);
    const containerDomNode = document.createElement("div");
    (0, _domFontInfoJs.applyFontInfo)(containerDomNode, fontInfo);
    const sb = new (0, _stringBuilderJs.StringBuilder)(10000);
    const firstNonWhitespaceIndices = [];
    const wrappedTextIndentLengths = [];
    const renderLineContents = [];
    const allCharOffsets = [];
    const allVisibleColumns = [];
    for(let i = 0; i < requests.length; i++){
        const lineContent = (0, _textModelEventsJs.LineInjectedText).applyInjectedText(requests[i], injectedTextsPerLine[i]);
        let firstNonWhitespaceIndex = 0;
        let wrappedTextIndentLength = 0;
        let width = overallWidth;
        if (wrappingIndent !== 0 /* WrappingIndent.None */ ) {
            firstNonWhitespaceIndex = _stringsJs.firstNonWhitespaceIndex(lineContent);
            if (firstNonWhitespaceIndex === -1) // all whitespace line
            firstNonWhitespaceIndex = 0;
            else {
                // Track existing indent
                for(let i = 0; i < firstNonWhitespaceIndex; i++){
                    const charWidth = lineContent.charCodeAt(i) === 9 /* CharCode.Tab */  ? tabSize - wrappedTextIndentLength % tabSize : 1;
                    wrappedTextIndentLength += charWidth;
                }
                const indentWidth = Math.ceil(fontInfo.spaceWidth * wrappedTextIndentLength);
                // Force sticking to beginning of line if no character would fit except for the indentation
                if (indentWidth + fontInfo.typicalFullwidthCharacterWidth > overallWidth) {
                    firstNonWhitespaceIndex = 0;
                    wrappedTextIndentLength = 0;
                } else width = overallWidth - indentWidth;
            }
        }
        const renderLineContent = lineContent.substr(firstNonWhitespaceIndex);
        const tmp = renderLine(renderLineContent, wrappedTextIndentLength, tabSize, width, sb, additionalIndentLength);
        firstNonWhitespaceIndices[i] = firstNonWhitespaceIndex;
        wrappedTextIndentLengths[i] = wrappedTextIndentLength;
        renderLineContents[i] = renderLineContent;
        allCharOffsets[i] = tmp[0];
        allVisibleColumns[i] = tmp[1];
    }
    const html = sb.build();
    const trustedhtml = ttPolicy?.createHTML(html) ?? html;
    containerDomNode.innerHTML = trustedhtml;
    containerDomNode.style.position = "absolute";
    containerDomNode.style.top = "10000";
    if (wordBreak === "keepAll") {
        // word-break: keep-all; overflow-wrap: anywhere
        containerDomNode.style.wordBreak = "keep-all";
        containerDomNode.style.overflowWrap = "anywhere";
    } else {
        // overflow-wrap: break-word
        containerDomNode.style.wordBreak = "inherit";
        containerDomNode.style.overflowWrap = "break-word";
    }
    targetWindow.document.body.appendChild(containerDomNode);
    const range = document.createRange();
    const lineDomNodes = Array.prototype.slice.call(containerDomNode.children, 0);
    const result = [];
    for(let i = 0; i < requests.length; i++){
        const lineDomNode = lineDomNodes[i];
        const breakOffsets = readLineBreaks(range, lineDomNode, renderLineContents[i], allCharOffsets[i]);
        if (breakOffsets === null) {
            result[i] = createEmptyLineBreakWithPossiblyInjectedText(i);
            continue;
        }
        const firstNonWhitespaceIndex = firstNonWhitespaceIndices[i];
        const wrappedTextIndentLength = wrappedTextIndentLengths[i] + additionalIndentSize;
        const visibleColumns = allVisibleColumns[i];
        const breakOffsetsVisibleColumn = [];
        for(let j = 0, len = breakOffsets.length; j < len; j++)breakOffsetsVisibleColumn[j] = visibleColumns[breakOffsets[j]];
        if (firstNonWhitespaceIndex !== 0) // All break offsets are relative to the renderLineContent, make them absolute again
        for(let j = 0, len = breakOffsets.length; j < len; j++)breakOffsets[j] += firstNonWhitespaceIndex;
        let injectionOptions;
        let injectionOffsets;
        const curInjectedTexts = injectedTextsPerLine[i];
        if (curInjectedTexts) {
            injectionOptions = curInjectedTexts.map((t)=>t.options);
            injectionOffsets = curInjectedTexts.map((text)=>text.column - 1);
        } else {
            injectionOptions = null;
            injectionOffsets = null;
        }
        result[i] = new (0, _modelLineProjectionDataJs.ModelLineProjectionData)(injectionOffsets, injectionOptions, breakOffsets, breakOffsetsVisibleColumn, wrappedTextIndentLength);
    }
    containerDomNode.remove();
    return result;
}
function renderLine(lineContent, initialVisibleColumn, tabSize, width, sb, wrappingIndentLength) {
    if (wrappingIndentLength !== 0) {
        const hangingOffset = String(wrappingIndentLength);
        sb.appendString('<div style="text-indent: -');
        sb.appendString(hangingOffset);
        sb.appendString("px; padding-left: ");
        sb.appendString(hangingOffset);
        sb.appendString("px; box-sizing: border-box; width:");
    } else sb.appendString('<div style="width:');
    sb.appendString(String(width));
    sb.appendString('px;">');
    // if (containsRTL) {
    // 	sb.appendASCIIString('" dir="ltr');
    // }
    const len = lineContent.length;
    let visibleColumn = initialVisibleColumn;
    let charOffset = 0;
    const charOffsets = [];
    const visibleColumns = [];
    let nextCharCode = 0 < len ? lineContent.charCodeAt(0) : 0 /* CharCode.Null */ ;
    sb.appendString("<span>");
    for(let charIndex = 0; charIndex < len; charIndex++){
        if (charIndex !== 0 && charIndex % 16384 /* Constants.SPAN_MODULO_LIMIT */  === 0) sb.appendString("</span><span>");
        charOffsets[charIndex] = charOffset;
        visibleColumns[charIndex] = visibleColumn;
        const charCode = nextCharCode;
        nextCharCode = charIndex + 1 < len ? lineContent.charCodeAt(charIndex + 1) : 0 /* CharCode.Null */ ;
        let producedCharacters = 1;
        let charWidth = 1;
        switch(charCode){
            case 9 /* CharCode.Tab */ :
                producedCharacters = tabSize - visibleColumn % tabSize;
                charWidth = producedCharacters;
                for(let space = 1; space <= producedCharacters; space++)if (space < producedCharacters) sb.appendCharCode(0xA0); // &nbsp;
                else sb.appendASCIICharCode(32 /* CharCode.Space */ );
                break;
            case 32 /* CharCode.Space */ :
                if (nextCharCode === 32 /* CharCode.Space */ ) sb.appendCharCode(0xA0); // &nbsp;
                else sb.appendASCIICharCode(32 /* CharCode.Space */ );
                break;
            case 60 /* CharCode.LessThan */ :
                sb.appendString("&lt;");
                break;
            case 62 /* CharCode.GreaterThan */ :
                sb.appendString("&gt;");
                break;
            case 38 /* CharCode.Ampersand */ :
                sb.appendString("&amp;");
                break;
            case 0 /* CharCode.Null */ :
                sb.appendString("&#00;");
                break;
            case 65279 /* CharCode.UTF8_BOM */ :
            case 8232 /* CharCode.LINE_SEPARATOR */ :
            case 8233 /* CharCode.PARAGRAPH_SEPARATOR */ :
            case 133 /* CharCode.NEXT_LINE */ :
                sb.appendCharCode(0xFFFD);
                break;
            default:
                if (_stringsJs.isFullWidthCharacter(charCode)) charWidth++;
                if (charCode < 32) sb.appendCharCode(9216 + charCode);
                else sb.appendCharCode(charCode);
        }
        charOffset += producedCharacters;
        visibleColumn += charWidth;
    }
    sb.appendString("</span>");
    charOffsets[lineContent.length] = charOffset;
    visibleColumns[lineContent.length] = visibleColumn;
    sb.appendString("</div>");
    return [
        charOffsets,
        visibleColumns
    ];
}
function readLineBreaks(range, lineDomNode, lineContent, charOffsets) {
    if (lineContent.length <= 1) return null;
    const spans = Array.prototype.slice.call(lineDomNode.children, 0);
    const breakOffsets = [];
    try {
        discoverBreaks(range, spans, charOffsets, 0, null, lineContent.length - 1, null, breakOffsets);
    } catch (err) {
        console.log(err);
        return null;
    }
    if (breakOffsets.length === 0) return null;
    breakOffsets.push(lineContent.length);
    return breakOffsets;
}
function discoverBreaks(range, spans, charOffsets, low, lowRects, high, highRects, result) {
    if (low === high) return;
    lowRects = lowRects || readClientRect(range, spans, charOffsets[low], charOffsets[low + 1]);
    highRects = highRects || readClientRect(range, spans, charOffsets[high], charOffsets[high + 1]);
    if (Math.abs(lowRects[0].top - highRects[0].top) <= 0.1) // same line
    return;
    // there is at least one line break between these two offsets
    if (low + 1 === high) {
        // the two characters are adjacent, so the line break must be exactly between them
        result.push(high);
        return;
    }
    const mid = low + (high - low) / 2 | 0;
    const midRects = readClientRect(range, spans, charOffsets[mid], charOffsets[mid + 1]);
    discoverBreaks(range, spans, charOffsets, low, lowRects, mid, midRects, result);
    discoverBreaks(range, spans, charOffsets, mid, midRects, high, highRects, result);
}
function readClientRect(range, spans, startOffset, endOffset) {
    range.setStart(spans[startOffset / 16384 /* Constants.SPAN_MODULO_LIMIT */  | 0].firstChild, startOffset % 16384 /* Constants.SPAN_MODULO_LIMIT */ );
    range.setEnd(spans[endOffset / 16384 /* Constants.SPAN_MODULO_LIMIT */  | 0].firstChild, endOffset % 16384 /* Constants.SPAN_MODULO_LIMIT */ );
    return range.getClientRects();
}

},{"../../../base/browser/trustedTypes.js":"bgQyv","../../../base/common/strings.js":"aA9I1","../../../base/common/types.js":"fb5yx","../config/domFontInfo.js":"fQezv","../../common/core/stringBuilder.js":"hHgWQ","../../common/modelLineProjectionData.js":"g1ZNj","../../common/textModelEvents.js":"90evO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g1ZNj":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * *input*:
 * ```
 * xxxxxxxxxxxxxxxxxxxxxxxxxxx
 * ```
 *
 * -> Applying injections `[i...i]`, *inputWithInjections*:
 * ```
 * xxxxxx[iiiiiiiiii]xxxxxxxxxxxxxxxxx[ii]xxxx
 * ```
 *
 * -> breaking at offsets `|` in `xxxxxx[iiiiiii|iii]xxxxxxxxxxx|xxxxxx[ii]xxxx|`:
 * ```
 * xxxxxx[iiiiiii
 * iii]xxxxxxxxxxx
 * xxxxxx[ii]xxxx
 * ```
 *
 * -> applying wrappedTextIndentLength, *output*:
 * ```
 * xxxxxx[iiiiiii
 *    iii]xxxxxxxxxxx
 *    xxxxxx[ii]xxxx
 * ```
 */ parcelHelpers.export(exports, "ModelLineProjectionData", ()=>ModelLineProjectionData);
parcelHelpers.export(exports, "InjectedText", ()=>InjectedText);
parcelHelpers.export(exports, "OutputPosition", ()=>OutputPosition);
var _assertJs = require("../../base/common/assert.js");
var _positionJs = require("./core/position.js");
var _modelJs = require("./model.js");
class ModelLineProjectionData {
    constructor(injectionOffsets, /**
     * `injectionOptions.length` must equal `injectionOffsets.length`
     */ injectionOptions, /**
     * Refers to offsets after applying injections to the source.
     * The last break offset indicates the length of the source after applying injections.
     */ breakOffsets, /**
     * Refers to offsets after applying injections
     */ breakOffsetsVisibleColumn, wrappedTextIndentLength){
        this.injectionOffsets = injectionOffsets;
        this.injectionOptions = injectionOptions;
        this.breakOffsets = breakOffsets;
        this.breakOffsetsVisibleColumn = breakOffsetsVisibleColumn;
        this.wrappedTextIndentLength = wrappedTextIndentLength;
    }
    getOutputLineCount() {
        return this.breakOffsets.length;
    }
    getMinOutputOffset(outputLineIndex) {
        if (outputLineIndex > 0) return this.wrappedTextIndentLength;
        return 0;
    }
    getLineLength(outputLineIndex) {
        // These offsets refer to model text with injected text.
        const startOffset = outputLineIndex > 0 ? this.breakOffsets[outputLineIndex - 1] : 0;
        const endOffset = this.breakOffsets[outputLineIndex];
        let lineLength = endOffset - startOffset;
        if (outputLineIndex > 0) lineLength += this.wrappedTextIndentLength;
        return lineLength;
    }
    getMaxOutputOffset(outputLineIndex) {
        return this.getLineLength(outputLineIndex);
    }
    translateToInputOffset(outputLineIndex, outputOffset) {
        if (outputLineIndex > 0) outputOffset = Math.max(0, outputOffset - this.wrappedTextIndentLength);
        const offsetInInputWithInjection = outputLineIndex === 0 ? outputOffset : this.breakOffsets[outputLineIndex - 1] + outputOffset;
        let offsetInInput = offsetInInputWithInjection;
        if (this.injectionOffsets !== null) for(let i = 0; i < this.injectionOffsets.length; i++){
            if (offsetInInput > this.injectionOffsets[i]) {
                if (offsetInInput < this.injectionOffsets[i] + this.injectionOptions[i].content.length) // `inputOffset` is within injected text
                offsetInInput = this.injectionOffsets[i];
                else offsetInInput -= this.injectionOptions[i].content.length;
            } else break;
        }
        return offsetInInput;
    }
    translateToOutputPosition(inputOffset, affinity = 2 /* PositionAffinity.None */ ) {
        let inputOffsetInInputWithInjection = inputOffset;
        if (this.injectionOffsets !== null) for(let i = 0; i < this.injectionOffsets.length; i++){
            if (inputOffset < this.injectionOffsets[i]) break;
            if (affinity !== 1 /* PositionAffinity.Right */  && inputOffset === this.injectionOffsets[i]) break;
            inputOffsetInInputWithInjection += this.injectionOptions[i].content.length;
        }
        return this.offsetInInputWithInjectionsToOutputPosition(inputOffsetInInputWithInjection, affinity);
    }
    offsetInInputWithInjectionsToOutputPosition(offsetInInputWithInjections, affinity = 2 /* PositionAffinity.None */ ) {
        let low = 0;
        let high = this.breakOffsets.length - 1;
        let mid = 0;
        let midStart = 0;
        while(low <= high){
            mid = low + (high - low) / 2 | 0;
            const midStop = this.breakOffsets[mid];
            midStart = mid > 0 ? this.breakOffsets[mid - 1] : 0;
            if (affinity === 0 /* PositionAffinity.Left */ ) {
                if (offsetInInputWithInjections <= midStart) high = mid - 1;
                else if (offsetInInputWithInjections > midStop) low = mid + 1;
                else break;
            } else {
                if (offsetInInputWithInjections < midStart) high = mid - 1;
                else if (offsetInInputWithInjections >= midStop) low = mid + 1;
                else break;
            }
        }
        let outputOffset = offsetInInputWithInjections - midStart;
        if (mid > 0) outputOffset += this.wrappedTextIndentLength;
        return new OutputPosition(mid, outputOffset);
    }
    normalizeOutputPosition(outputLineIndex, outputOffset, affinity) {
        if (this.injectionOffsets !== null) {
            const offsetInInputWithInjections = this.outputPositionToOffsetInInputWithInjections(outputLineIndex, outputOffset);
            const normalizedOffsetInUnwrappedLine = this.normalizeOffsetInInputWithInjectionsAroundInjections(offsetInInputWithInjections, affinity);
            if (normalizedOffsetInUnwrappedLine !== offsetInInputWithInjections) // injected text caused a change
            return this.offsetInInputWithInjectionsToOutputPosition(normalizedOffsetInUnwrappedLine, affinity);
        }
        if (affinity === 0 /* PositionAffinity.Left */ ) {
            if (outputLineIndex > 0 && outputOffset === this.getMinOutputOffset(outputLineIndex)) return new OutputPosition(outputLineIndex - 1, this.getMaxOutputOffset(outputLineIndex - 1));
        } else if (affinity === 1 /* PositionAffinity.Right */ ) {
            const maxOutputLineIndex = this.getOutputLineCount() - 1;
            if (outputLineIndex < maxOutputLineIndex && outputOffset === this.getMaxOutputOffset(outputLineIndex)) return new OutputPosition(outputLineIndex + 1, this.getMinOutputOffset(outputLineIndex + 1));
        }
        return new OutputPosition(outputLineIndex, outputOffset);
    }
    outputPositionToOffsetInInputWithInjections(outputLineIndex, outputOffset) {
        if (outputLineIndex > 0) outputOffset = Math.max(0, outputOffset - this.wrappedTextIndentLength);
        const result = (outputLineIndex > 0 ? this.breakOffsets[outputLineIndex - 1] : 0) + outputOffset;
        return result;
    }
    normalizeOffsetInInputWithInjectionsAroundInjections(offsetInInputWithInjections, affinity) {
        const injectedText = this.getInjectedTextAtOffset(offsetInInputWithInjections);
        if (!injectedText) return offsetInInputWithInjections;
        if (affinity === 2 /* PositionAffinity.None */ ) {
            if (offsetInInputWithInjections === injectedText.offsetInInputWithInjections + injectedText.length && hasRightCursorStop(this.injectionOptions[injectedText.injectedTextIndex].cursorStops)) return injectedText.offsetInInputWithInjections + injectedText.length;
            else {
                let result = injectedText.offsetInInputWithInjections;
                if (hasLeftCursorStop(this.injectionOptions[injectedText.injectedTextIndex].cursorStops)) return result;
                let index = injectedText.injectedTextIndex - 1;
                while(index >= 0 && this.injectionOffsets[index] === this.injectionOffsets[injectedText.injectedTextIndex]){
                    if (hasRightCursorStop(this.injectionOptions[index].cursorStops)) break;
                    result -= this.injectionOptions[index].content.length;
                    if (hasLeftCursorStop(this.injectionOptions[index].cursorStops)) break;
                    index--;
                }
                return result;
            }
        } else if (affinity === 1 /* PositionAffinity.Right */  || affinity === 4 /* PositionAffinity.RightOfInjectedText */ ) {
            let result = injectedText.offsetInInputWithInjections + injectedText.length;
            let index = injectedText.injectedTextIndex;
            // traverse all injected text that touch each other
            while(index + 1 < this.injectionOffsets.length && this.injectionOffsets[index + 1] === this.injectionOffsets[index]){
                result += this.injectionOptions[index + 1].content.length;
                index++;
            }
            return result;
        } else if (affinity === 0 /* PositionAffinity.Left */  || affinity === 3 /* PositionAffinity.LeftOfInjectedText */ ) {
            // affinity is left
            let result = injectedText.offsetInInputWithInjections;
            let index = injectedText.injectedTextIndex;
            // traverse all injected text that touch each other
            while(index - 1 >= 0 && this.injectionOffsets[index - 1] === this.injectionOffsets[index]){
                result -= this.injectionOptions[index - 1].content.length;
                index--;
            }
            return result;
        }
        (0, _assertJs.assertNever)(affinity);
    }
    getInjectedText(outputLineIndex, outputOffset) {
        const offset = this.outputPositionToOffsetInInputWithInjections(outputLineIndex, outputOffset);
        const injectedText = this.getInjectedTextAtOffset(offset);
        if (!injectedText) return null;
        return {
            options: this.injectionOptions[injectedText.injectedTextIndex]
        };
    }
    getInjectedTextAtOffset(offsetInInputWithInjections) {
        const injectionOffsets = this.injectionOffsets;
        const injectionOptions = this.injectionOptions;
        if (injectionOffsets !== null) {
            let totalInjectedTextLengthBefore = 0;
            for(let i = 0; i < injectionOffsets.length; i++){
                const length = injectionOptions[i].content.length;
                const injectedTextStartOffsetInInputWithInjections = injectionOffsets[i] + totalInjectedTextLengthBefore;
                const injectedTextEndOffsetInInputWithInjections = injectionOffsets[i] + totalInjectedTextLengthBefore + length;
                if (injectedTextStartOffsetInInputWithInjections > offsetInInputWithInjections) break; // All later injected texts have an even larger offset.
                if (offsetInInputWithInjections <= injectedTextEndOffsetInInputWithInjections) // Injected text ends after or with the given position (but also starts with or before it).
                return {
                    injectedTextIndex: i,
                    offsetInInputWithInjections: injectedTextStartOffsetInInputWithInjections,
                    length
                };
                totalInjectedTextLengthBefore += length;
            }
        }
        return undefined;
    }
}
function hasRightCursorStop(cursorStop) {
    if (cursorStop === null || cursorStop === undefined) return true;
    return cursorStop === (0, _modelJs.InjectedTextCursorStops).Right || cursorStop === (0, _modelJs.InjectedTextCursorStops).Both;
}
function hasLeftCursorStop(cursorStop) {
    if (cursorStop === null || cursorStop === undefined) return true;
    return cursorStop === (0, _modelJs.InjectedTextCursorStops).Left || cursorStop === (0, _modelJs.InjectedTextCursorStops).Both;
}
class InjectedText {
    constructor(options){
        this.options = options;
    }
}
class OutputPosition {
    constructor(outputLineIndex, outputOffset){
        this.outputLineIndex = outputLineIndex;
        this.outputOffset = outputOffset;
    }
    toString() {
        return `${this.outputLineIndex}:${this.outputOffset}`;
    }
    toPosition(baseLineNumber) {
        return new (0, _positionJs.Position)(baseLineNumber + this.outputLineIndex, this.outputOffset + 1);
    }
}

},{"../../base/common/assert.js":"1nPIE","./core/position.js":"lvrPe","./model.js":"1CSIB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9WYGR":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeEditorContributions", ()=>CodeEditorContributions);
var _domJs = require("../../../../base/browser/dom.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
class CodeEditorContributions extends (0, _lifecycleJs.Disposable) {
    constructor(){
        super();
        this._editor = null;
        this._instantiationService = null;
        /**
         * Contains all instantiated contributions.
         */ this._instances = this._register(new (0, _lifecycleJs.DisposableMap)());
        /**
         * Contains contributions which are not yet instantiated.
         */ this._pending = new Map();
        /**
         * Tracks which instantiation kinds are still left in `_pending`.
         */ this._finishedInstantiation = [];
        this._finishedInstantiation[0 /* EditorContributionInstantiation.Eager */ ] = false;
        this._finishedInstantiation[1 /* EditorContributionInstantiation.AfterFirstRender */ ] = false;
        this._finishedInstantiation[2 /* EditorContributionInstantiation.BeforeFirstInteraction */ ] = false;
        this._finishedInstantiation[3 /* EditorContributionInstantiation.Eventually */ ] = false;
    }
    initialize(editor, contributions, instantiationService) {
        this._editor = editor;
        this._instantiationService = instantiationService;
        for (const desc of contributions){
            if (this._pending.has(desc.id)) {
                (0, _errorsJs.onUnexpectedError)(new Error(`Cannot have two contributions with the same id ${desc.id}`));
                continue;
            }
            this._pending.set(desc.id, desc);
        }
        this._instantiateSome(0 /* EditorContributionInstantiation.Eager */ );
        // AfterFirstRender
        // - these extensions will be instantiated at the latest 50ms after the first render.
        // - but if there is idle time, we will instantiate them sooner.
        this._register((0, _domJs.runWhenWindowIdle)((0, _domJs.getWindow)(this._editor.getDomNode()), ()=>{
            this._instantiateSome(1 /* EditorContributionInstantiation.AfterFirstRender */ );
        }));
        // BeforeFirstInteraction
        // - these extensions will be instantiated at the latest before a mouse or a keyboard event.
        // - but if there is idle time, we will instantiate them sooner.
        this._register((0, _domJs.runWhenWindowIdle)((0, _domJs.getWindow)(this._editor.getDomNode()), ()=>{
            this._instantiateSome(2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );
        }));
        // Eventually
        // - these extensions will only be instantiated when there is idle time.
        // - since there is no guarantee that there will ever be idle time, we set a timeout of 5s here.
        this._register((0, _domJs.runWhenWindowIdle)((0, _domJs.getWindow)(this._editor.getDomNode()), ()=>{
            this._instantiateSome(3 /* EditorContributionInstantiation.Eventually */ );
        }, 5000));
    }
    saveViewState() {
        const contributionsState = {};
        for (const [id, contribution] of this._instances)if (typeof contribution.saveViewState === "function") contributionsState[id] = contribution.saveViewState();
        return contributionsState;
    }
    restoreViewState(contributionsState) {
        for (const [id, contribution] of this._instances)if (typeof contribution.restoreViewState === "function") contribution.restoreViewState(contributionsState[id]);
    }
    get(id) {
        this._instantiateById(id);
        return this._instances.get(id) || null;
    }
    onBeforeInteractionEvent() {
        // this method is called very often by the editor!
        this._instantiateSome(2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );
    }
    onAfterModelAttached() {
        return (0, _domJs.runWhenWindowIdle)((0, _domJs.getWindow)(this._editor?.getDomNode()), ()=>{
            this._instantiateSome(1 /* EditorContributionInstantiation.AfterFirstRender */ );
        }, 50);
    }
    _instantiateSome(instantiation) {
        if (this._finishedInstantiation[instantiation]) // already done with this instantiation!
        return;
        this._finishedInstantiation[instantiation] = true;
        const contribs = this._findPendingContributionsByInstantiation(instantiation);
        for (const contrib of contribs)this._instantiateById(contrib.id);
    }
    _findPendingContributionsByInstantiation(instantiation) {
        const result = [];
        for (const [, desc] of this._pending)if (desc.instantiation === instantiation) result.push(desc);
        return result;
    }
    _instantiateById(id) {
        const desc = this._pending.get(id);
        if (!desc) return;
        this._pending.delete(id);
        if (!this._instantiationService || !this._editor) throw new Error(`Cannot instantiate contributions before being initialized!`);
        try {
            const instance = this._instantiationService.createInstance(desc.ctor, this._editor);
            this._instances.set(desc.id, instance);
            if (typeof instance.restoreViewState === "function" && desc.instantiation !== 0 /* EditorContributionInstantiation.Eager */ ) console.warn(`Editor contribution '${desc.id}' should be eager instantiated because it uses saveViewState / restoreViewState.`);
        } catch (err) {
            (0, _errorsJs.onUnexpectedError)(err);
        }
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l9eav":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalEditorAction", ()=>InternalEditorAction);
class InternalEditorAction {
    constructor(id, label, alias, metadata, _precondition, _run, _contextKeyService){
        this.id = id;
        this.label = label;
        this.alias = alias;
        this.metadata = metadata;
        this._precondition = _precondition;
        this._run = _run;
        this._contextKeyService = _contextKeyService;
    }
    isSupported() {
        return this._contextKeyService.contextMatchesRules(this._precondition);
    }
    run(args) {
        if (!this.isSupported()) return Promise.resolve(undefined);
        return this._run(args);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"emUHa":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonospaceLineBreaksComputerFactory", ()=>MonospaceLineBreaksComputerFactory);
var _stringsJs = require("../../../base/common/strings.js");
var _characterClassifierJs = require("../core/characterClassifier.js");
var _textModelEventsJs = require("../textModelEvents.js");
var _modelLineProjectionDataJs = require("../modelLineProjectionData.js");
class MonospaceLineBreaksComputerFactory {
    static create(options) {
        return new MonospaceLineBreaksComputerFactory(options.get(135 /* EditorOption.wordWrapBreakBeforeCharacters */ ), options.get(134 /* EditorOption.wordWrapBreakAfterCharacters */ ));
    }
    constructor(breakBeforeChars, breakAfterChars){
        this.classifier = new WrappingCharacterClassifier(breakBeforeChars, breakAfterChars);
    }
    createLineBreaksComputer(fontInfo, tabSize, wrappingColumn, wrappingIndent, wordBreak) {
        const requests = [];
        const injectedTexts = [];
        const previousBreakingData = [];
        return {
            addRequest: (lineText, injectedText, previousLineBreakData)=>{
                requests.push(lineText);
                injectedTexts.push(injectedText);
                previousBreakingData.push(previousLineBreakData);
            },
            finalize: ()=>{
                const columnsForFullWidthChar = fontInfo.typicalFullwidthCharacterWidth / fontInfo.typicalHalfwidthCharacterWidth;
                const result = [];
                for(let i = 0, len = requests.length; i < len; i++){
                    const injectedText = injectedTexts[i];
                    const previousLineBreakData = previousBreakingData[i];
                    if (previousLineBreakData && !previousLineBreakData.injectionOptions && !injectedText) result[i] = createLineBreaksFromPreviousLineBreaks(this.classifier, previousLineBreakData, requests[i], tabSize, wrappingColumn, columnsForFullWidthChar, wrappingIndent, wordBreak);
                    else result[i] = createLineBreaks(this.classifier, requests[i], injectedText, tabSize, wrappingColumn, columnsForFullWidthChar, wrappingIndent, wordBreak);
                }
                arrPool1.length = 0;
                arrPool2.length = 0;
                return result;
            }
        };
    }
}
class WrappingCharacterClassifier extends (0, _characterClassifierJs.CharacterClassifier) {
    constructor(BREAK_BEFORE, BREAK_AFTER){
        super(0 /* CharacterClass.NONE */ );
        for(let i = 0; i < BREAK_BEFORE.length; i++)this.set(BREAK_BEFORE.charCodeAt(i), 1 /* CharacterClass.BREAK_BEFORE */ );
        for(let i = 0; i < BREAK_AFTER.length; i++)this.set(BREAK_AFTER.charCodeAt(i), 2 /* CharacterClass.BREAK_AFTER */ );
    }
    get(charCode) {
        if (charCode >= 0 && charCode < 256) return this._asciiMap[charCode];
        else {
            // Initialize CharacterClass.BREAK_IDEOGRAPHIC for these Unicode ranges:
            // 1. CJK Unified Ideographs (0x4E00 -- 0x9FFF)
            // 2. CJK Unified Ideographs Extension A (0x3400 -- 0x4DBF)
            // 3. Hiragana and Katakana (0x3040 -- 0x30FF)
            if (charCode >= 0x3040 && charCode <= 0x30FF || charCode >= 0x3400 && charCode <= 0x4DBF || charCode >= 0x4E00 && charCode <= 0x9FFF) return 3 /* CharacterClass.BREAK_IDEOGRAPHIC */ ;
            return this._map.get(charCode) || this._defaultValue;
        }
    }
}
let arrPool1 = [];
let arrPool2 = [];
function createLineBreaksFromPreviousLineBreaks(classifier, previousBreakingData, lineText, tabSize, firstLineBreakColumn, columnsForFullWidthChar, wrappingIndent, wordBreak) {
    if (firstLineBreakColumn === -1) return null;
    const len = lineText.length;
    if (len <= 1) return null;
    const isKeepAll = wordBreak === "keepAll";
    const prevBreakingOffsets = previousBreakingData.breakOffsets;
    const prevBreakingOffsetsVisibleColumn = previousBreakingData.breakOffsetsVisibleColumn;
    const wrappedTextIndentLength = computeWrappedTextIndentLength(lineText, tabSize, firstLineBreakColumn, columnsForFullWidthChar, wrappingIndent);
    const wrappedLineBreakColumn = firstLineBreakColumn - wrappedTextIndentLength;
    const breakingOffsets = arrPool1;
    const breakingOffsetsVisibleColumn = arrPool2;
    let breakingOffsetsCount = 0;
    let lastBreakingOffset = 0;
    let lastBreakingOffsetVisibleColumn = 0;
    let breakingColumn = firstLineBreakColumn;
    const prevLen = prevBreakingOffsets.length;
    let prevIndex = 0;
    if (prevIndex >= 0) {
        let bestDistance = Math.abs(prevBreakingOffsetsVisibleColumn[prevIndex] - breakingColumn);
        while(prevIndex + 1 < prevLen){
            const distance = Math.abs(prevBreakingOffsetsVisibleColumn[prevIndex + 1] - breakingColumn);
            if (distance >= bestDistance) break;
            bestDistance = distance;
            prevIndex++;
        }
    }
    while(prevIndex < prevLen){
        // Allow for prevIndex to be -1 (for the case where we hit a tab when walking backwards from the first break)
        let prevBreakOffset = prevIndex < 0 ? 0 : prevBreakingOffsets[prevIndex];
        let prevBreakOffsetVisibleColumn = prevIndex < 0 ? 0 : prevBreakingOffsetsVisibleColumn[prevIndex];
        if (lastBreakingOffset > prevBreakOffset) {
            prevBreakOffset = lastBreakingOffset;
            prevBreakOffsetVisibleColumn = lastBreakingOffsetVisibleColumn;
        }
        let breakOffset = 0;
        let breakOffsetVisibleColumn = 0;
        let forcedBreakOffset = 0;
        let forcedBreakOffsetVisibleColumn = 0;
        // initially, we search as much as possible to the right (if it fits)
        if (prevBreakOffsetVisibleColumn <= breakingColumn) {
            let visibleColumn = prevBreakOffsetVisibleColumn;
            let prevCharCode = prevBreakOffset === 0 ? 0 /* CharCode.Null */  : lineText.charCodeAt(prevBreakOffset - 1);
            let prevCharCodeClass = prevBreakOffset === 0 ? 0 /* CharacterClass.NONE */  : classifier.get(prevCharCode);
            let entireLineFits = true;
            for(let i = prevBreakOffset; i < len; i++){
                const charStartOffset = i;
                const charCode = lineText.charCodeAt(i);
                let charCodeClass;
                let charWidth;
                if (_stringsJs.isHighSurrogate(charCode)) {
                    // A surrogate pair must always be considered as a single unit, so it is never to be broken
                    i++;
                    charCodeClass = 0 /* CharacterClass.NONE */ ;
                    charWidth = 2;
                } else {
                    charCodeClass = classifier.get(charCode);
                    charWidth = computeCharWidth(charCode, visibleColumn, tabSize, columnsForFullWidthChar);
                }
                if (charStartOffset > lastBreakingOffset && canBreak(prevCharCode, prevCharCodeClass, charCode, charCodeClass, isKeepAll)) {
                    breakOffset = charStartOffset;
                    breakOffsetVisibleColumn = visibleColumn;
                }
                visibleColumn += charWidth;
                // check if adding character at `i` will go over the breaking column
                if (visibleColumn > breakingColumn) {
                    // We need to break at least before character at `i`:
                    if (charStartOffset > lastBreakingOffset) {
                        forcedBreakOffset = charStartOffset;
                        forcedBreakOffsetVisibleColumn = visibleColumn - charWidth;
                    } else {
                        // we need to advance at least by one character
                        forcedBreakOffset = i + 1;
                        forcedBreakOffsetVisibleColumn = visibleColumn;
                    }
                    if (visibleColumn - breakOffsetVisibleColumn > wrappedLineBreakColumn) // Cannot break at `breakOffset` => reset it if it was set
                    breakOffset = 0;
                    entireLineFits = false;
                    break;
                }
                prevCharCode = charCode;
                prevCharCodeClass = charCodeClass;
            }
            if (entireLineFits) {
                // there is no more need to break => stop the outer loop!
                if (breakingOffsetsCount > 0) {
                    // Add last segment, no need to assign to `lastBreakingOffset` and `lastBreakingOffsetVisibleColumn`
                    breakingOffsets[breakingOffsetsCount] = prevBreakingOffsets[prevBreakingOffsets.length - 1];
                    breakingOffsetsVisibleColumn[breakingOffsetsCount] = prevBreakingOffsetsVisibleColumn[prevBreakingOffsets.length - 1];
                    breakingOffsetsCount++;
                }
                break;
            }
        }
        if (breakOffset === 0) {
            // must search left
            let visibleColumn = prevBreakOffsetVisibleColumn;
            let charCode = lineText.charCodeAt(prevBreakOffset);
            let charCodeClass = classifier.get(charCode);
            let hitATabCharacter = false;
            for(let i = prevBreakOffset - 1; i >= lastBreakingOffset; i--){
                const charStartOffset = i + 1;
                const prevCharCode = lineText.charCodeAt(i);
                if (prevCharCode === 9 /* CharCode.Tab */ ) {
                    // cannot determine the width of a tab when going backwards, so we must go forwards
                    hitATabCharacter = true;
                    break;
                }
                let prevCharCodeClass;
                let prevCharWidth;
                if (_stringsJs.isLowSurrogate(prevCharCode)) {
                    // A surrogate pair must always be considered as a single unit, so it is never to be broken
                    i--;
                    prevCharCodeClass = 0 /* CharacterClass.NONE */ ;
                    prevCharWidth = 2;
                } else {
                    prevCharCodeClass = classifier.get(prevCharCode);
                    prevCharWidth = _stringsJs.isFullWidthCharacter(prevCharCode) ? columnsForFullWidthChar : 1;
                }
                if (visibleColumn <= breakingColumn) {
                    if (forcedBreakOffset === 0) {
                        forcedBreakOffset = charStartOffset;
                        forcedBreakOffsetVisibleColumn = visibleColumn;
                    }
                    if (visibleColumn <= breakingColumn - wrappedLineBreakColumn) break;
                    if (canBreak(prevCharCode, prevCharCodeClass, charCode, charCodeClass, isKeepAll)) {
                        breakOffset = charStartOffset;
                        breakOffsetVisibleColumn = visibleColumn;
                        break;
                    }
                }
                visibleColumn -= prevCharWidth;
                charCode = prevCharCode;
                charCodeClass = prevCharCodeClass;
            }
            if (breakOffset !== 0) {
                const remainingWidthOfNextLine = wrappedLineBreakColumn - (forcedBreakOffsetVisibleColumn - breakOffsetVisibleColumn);
                if (remainingWidthOfNextLine <= tabSize) {
                    const charCodeAtForcedBreakOffset = lineText.charCodeAt(forcedBreakOffset);
                    let charWidth;
                    if (_stringsJs.isHighSurrogate(charCodeAtForcedBreakOffset)) // A surrogate pair must always be considered as a single unit, so it is never to be broken
                    charWidth = 2;
                    else charWidth = computeCharWidth(charCodeAtForcedBreakOffset, forcedBreakOffsetVisibleColumn, tabSize, columnsForFullWidthChar);
                    if (remainingWidthOfNextLine - charWidth < 0) // it is not worth it to break at breakOffset, it just introduces an extra needless line!
                    breakOffset = 0;
                }
            }
            if (hitATabCharacter) {
                // cannot determine the width of a tab when going backwards, so we must go forwards from the previous break
                prevIndex--;
                continue;
            }
        }
        if (breakOffset === 0) {
            // Could not find a good breaking point
            breakOffset = forcedBreakOffset;
            breakOffsetVisibleColumn = forcedBreakOffsetVisibleColumn;
        }
        if (breakOffset <= lastBreakingOffset) {
            // Make sure that we are advancing (at least one character)
            const charCode = lineText.charCodeAt(lastBreakingOffset);
            if (_stringsJs.isHighSurrogate(charCode)) {
                // A surrogate pair must always be considered as a single unit, so it is never to be broken
                breakOffset = lastBreakingOffset + 2;
                breakOffsetVisibleColumn = lastBreakingOffsetVisibleColumn + 2;
            } else {
                breakOffset = lastBreakingOffset + 1;
                breakOffsetVisibleColumn = lastBreakingOffsetVisibleColumn + computeCharWidth(charCode, lastBreakingOffsetVisibleColumn, tabSize, columnsForFullWidthChar);
            }
        }
        lastBreakingOffset = breakOffset;
        breakingOffsets[breakingOffsetsCount] = breakOffset;
        lastBreakingOffsetVisibleColumn = breakOffsetVisibleColumn;
        breakingOffsetsVisibleColumn[breakingOffsetsCount] = breakOffsetVisibleColumn;
        breakingOffsetsCount++;
        breakingColumn = breakOffsetVisibleColumn + wrappedLineBreakColumn;
        while(prevIndex < 0 || prevIndex < prevLen && prevBreakingOffsetsVisibleColumn[prevIndex] < breakOffsetVisibleColumn)prevIndex++;
        let bestDistance = Math.abs(prevBreakingOffsetsVisibleColumn[prevIndex] - breakingColumn);
        while(prevIndex + 1 < prevLen){
            const distance = Math.abs(prevBreakingOffsetsVisibleColumn[prevIndex + 1] - breakingColumn);
            if (distance >= bestDistance) break;
            bestDistance = distance;
            prevIndex++;
        }
    }
    if (breakingOffsetsCount === 0) return null;
    // Doing here some object reuse which ends up helping a huge deal with GC pauses!
    breakingOffsets.length = breakingOffsetsCount;
    breakingOffsetsVisibleColumn.length = breakingOffsetsCount;
    arrPool1 = previousBreakingData.breakOffsets;
    arrPool2 = previousBreakingData.breakOffsetsVisibleColumn;
    previousBreakingData.breakOffsets = breakingOffsets;
    previousBreakingData.breakOffsetsVisibleColumn = breakingOffsetsVisibleColumn;
    previousBreakingData.wrappedTextIndentLength = wrappedTextIndentLength;
    return previousBreakingData;
}
function createLineBreaks(classifier, _lineText, injectedTexts, tabSize, firstLineBreakColumn, columnsForFullWidthChar, wrappingIndent, wordBreak) {
    const lineText = (0, _textModelEventsJs.LineInjectedText).applyInjectedText(_lineText, injectedTexts);
    let injectionOptions;
    let injectionOffsets;
    if (injectedTexts && injectedTexts.length > 0) {
        injectionOptions = injectedTexts.map((t)=>t.options);
        injectionOffsets = injectedTexts.map((text)=>text.column - 1);
    } else {
        injectionOptions = null;
        injectionOffsets = null;
    }
    if (firstLineBreakColumn === -1) {
        if (!injectionOptions) return null;
        // creating a `LineBreakData` with an invalid `breakOffsetsVisibleColumn` is OK
        // because `breakOffsetsVisibleColumn` will never be used because it contains injected text
        return new (0, _modelLineProjectionDataJs.ModelLineProjectionData)(injectionOffsets, injectionOptions, [
            lineText.length
        ], [], 0);
    }
    const len = lineText.length;
    if (len <= 1) {
        if (!injectionOptions) return null;
        // creating a `LineBreakData` with an invalid `breakOffsetsVisibleColumn` is OK
        // because `breakOffsetsVisibleColumn` will never be used because it contains injected text
        return new (0, _modelLineProjectionDataJs.ModelLineProjectionData)(injectionOffsets, injectionOptions, [
            lineText.length
        ], [], 0);
    }
    const isKeepAll = wordBreak === "keepAll";
    const wrappedTextIndentLength = computeWrappedTextIndentLength(lineText, tabSize, firstLineBreakColumn, columnsForFullWidthChar, wrappingIndent);
    const wrappedLineBreakColumn = firstLineBreakColumn - wrappedTextIndentLength;
    const breakingOffsets = [];
    const breakingOffsetsVisibleColumn = [];
    let breakingOffsetsCount = 0;
    let breakOffset = 0;
    let breakOffsetVisibleColumn = 0;
    let breakingColumn = firstLineBreakColumn;
    let prevCharCode = lineText.charCodeAt(0);
    let prevCharCodeClass = classifier.get(prevCharCode);
    let visibleColumn = computeCharWidth(prevCharCode, 0, tabSize, columnsForFullWidthChar);
    let startOffset = 1;
    if (_stringsJs.isHighSurrogate(prevCharCode)) {
        // A surrogate pair must always be considered as a single unit, so it is never to be broken
        visibleColumn += 1;
        prevCharCode = lineText.charCodeAt(1);
        prevCharCodeClass = classifier.get(prevCharCode);
        startOffset++;
    }
    for(let i = startOffset; i < len; i++){
        const charStartOffset = i;
        const charCode = lineText.charCodeAt(i);
        let charCodeClass;
        let charWidth;
        if (_stringsJs.isHighSurrogate(charCode)) {
            // A surrogate pair must always be considered as a single unit, so it is never to be broken
            i++;
            charCodeClass = 0 /* CharacterClass.NONE */ ;
            charWidth = 2;
        } else {
            charCodeClass = classifier.get(charCode);
            charWidth = computeCharWidth(charCode, visibleColumn, tabSize, columnsForFullWidthChar);
        }
        if (canBreak(prevCharCode, prevCharCodeClass, charCode, charCodeClass, isKeepAll)) {
            breakOffset = charStartOffset;
            breakOffsetVisibleColumn = visibleColumn;
        }
        visibleColumn += charWidth;
        // check if adding character at `i` will go over the breaking column
        if (visibleColumn > breakingColumn) {
            // We need to break at least before character at `i`:
            if (breakOffset === 0 || visibleColumn - breakOffsetVisibleColumn > wrappedLineBreakColumn) {
                // Cannot break at `breakOffset`, must break at `i`
                breakOffset = charStartOffset;
                breakOffsetVisibleColumn = visibleColumn - charWidth;
            }
            breakingOffsets[breakingOffsetsCount] = breakOffset;
            breakingOffsetsVisibleColumn[breakingOffsetsCount] = breakOffsetVisibleColumn;
            breakingOffsetsCount++;
            breakingColumn = breakOffsetVisibleColumn + wrappedLineBreakColumn;
            breakOffset = 0;
        }
        prevCharCode = charCode;
        prevCharCodeClass = charCodeClass;
    }
    if (breakingOffsetsCount === 0 && (!injectedTexts || injectedTexts.length === 0)) return null;
    // Add last segment
    breakingOffsets[breakingOffsetsCount] = len;
    breakingOffsetsVisibleColumn[breakingOffsetsCount] = visibleColumn;
    return new (0, _modelLineProjectionDataJs.ModelLineProjectionData)(injectionOffsets, injectionOptions, breakingOffsets, breakingOffsetsVisibleColumn, wrappedTextIndentLength);
}
function computeCharWidth(charCode, visibleColumn, tabSize, columnsForFullWidthChar) {
    if (charCode === 9 /* CharCode.Tab */ ) return tabSize - visibleColumn % tabSize;
    if (_stringsJs.isFullWidthCharacter(charCode)) return columnsForFullWidthChar;
    if (charCode < 32) // when using `editor.renderControlCharacters`, the substitutions are often wide
    return columnsForFullWidthChar;
    return 1;
}
function tabCharacterWidth(visibleColumn, tabSize) {
    return tabSize - visibleColumn % tabSize;
}
/**
 * Kinsoku Shori : Don't break after a leading character, like an open bracket
 * Kinsoku Shori : Don't break before a trailing character, like a period
 */ function canBreak(prevCharCode, prevCharCodeClass, charCode, charCodeClass, isKeepAll) {
    return charCode !== 32 /* CharCode.Space */  && (prevCharCodeClass === 2 /* CharacterClass.BREAK_AFTER */  && charCodeClass !== 2 /* CharacterClass.BREAK_AFTER */  // break at the end of multiple BREAK_AFTER
     || prevCharCodeClass !== 1 /* CharacterClass.BREAK_BEFORE */  && charCodeClass === 1 /* CharacterClass.BREAK_BEFORE */  // break at the start of multiple BREAK_BEFORE
     || !isKeepAll && prevCharCodeClass === 3 /* CharacterClass.BREAK_IDEOGRAPHIC */  && charCodeClass !== 2 /* CharacterClass.BREAK_AFTER */  || !isKeepAll && charCodeClass === 3 /* CharacterClass.BREAK_IDEOGRAPHIC */  && prevCharCodeClass !== 1 /* CharacterClass.BREAK_BEFORE */ );
}
function computeWrappedTextIndentLength(lineText, tabSize, firstLineBreakColumn, columnsForFullWidthChar, wrappingIndent) {
    let wrappedTextIndentLength = 0;
    if (wrappingIndent !== 0 /* WrappingIndent.None */ ) {
        const firstNonWhitespaceIndex = _stringsJs.firstNonWhitespaceIndex(lineText);
        if (firstNonWhitespaceIndex !== -1) {
            // Track existing indent
            for(let i = 0; i < firstNonWhitespaceIndex; i++){
                const charWidth = lineText.charCodeAt(i) === 9 /* CharCode.Tab */  ? tabCharacterWidth(wrappedTextIndentLength, tabSize) : 1;
                wrappedTextIndentLength += charWidth;
            }
            // Increase indent of continuation lines, if desired
            const numberOfAdditionalTabs = wrappingIndent === 3 /* WrappingIndent.DeepIndent */  ? 2 : wrappingIndent === 2 /* WrappingIndent.Indent */  ? 1 : 0;
            for(let i = 0; i < numberOfAdditionalTabs; i++){
                const charWidth = tabCharacterWidth(wrappedTextIndentLength, tabSize);
                wrappedTextIndentLength += charWidth;
            }
            // Force sticking to beginning of line if no character would fit except for the indentation
            if (wrappedTextIndentLength + columnsForFullWidthChar > firstLineBreakColumn) wrappedTextIndentLength = 0;
        }
    }
    return wrappedTextIndentLength;
}

},{"../../../base/common/strings.js":"aA9I1","../core/characterClassifier.js":"hl8tq","../textModelEvents.js":"90evO","../modelLineProjectionData.js":"g1ZNj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k4sZN":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewModel", ()=>ViewModel);
var _arraysJs = require("../../../base/common/arrays.js");
var _asyncJs = require("../../../base/common/async.js");
var _colorJs = require("../../../base/common/color.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _platformJs = require("../../../base/common/platform.js");
var _stringsJs = require("../../../base/common/strings.js");
var _editorOptionsJs = require("../config/editorOptions.js");
var _cursorJs = require("../cursor/cursor.js");
var _cursorCommonJs = require("../cursorCommon.js");
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
var _textModelEventsJs = require("../textModelEvents.js");
var _languagesJs = require("../languages.js");
var _modesRegistryJs = require("../languages/modesRegistry.js");
var _textToHtmlTokenizerJs = require("../languages/textToHtmlTokenizer.js");
var _viewEventsJs = require("../viewEvents.js");
var _viewLayoutJs = require("../viewLayout/viewLayout.js");
var _minimapTokensColorTrackerJs = require("./minimapTokensColorTracker.js");
var _viewModelJs = require("../viewModel.js");
var _viewModelDecorationsJs = require("./viewModelDecorations.js");
var _viewModelEventDispatcherJs = require("../viewModelEventDispatcher.js");
var _viewModelLinesJs = require("./viewModelLines.js");
var _glyphLanesModelJs = require("./glyphLanesModel.js");
const USE_IDENTITY_LINES_COLLECTION = true;
class ViewModel extends (0, _lifecycleJs.Disposable) {
    constructor(editorId, configuration, model, domLineBreaksComputerFactory, monospaceLineBreaksComputerFactory, scheduleAtNextAnimationFrame, languageConfigurationService, _themeService, _attachedView, _transactionalTarget){
        super();
        this.languageConfigurationService = languageConfigurationService;
        this._themeService = _themeService;
        this._attachedView = _attachedView;
        this._transactionalTarget = _transactionalTarget;
        this.hiddenAreasModel = new HiddenAreasModel();
        this.previousHiddenAreas = [];
        this._editorId = editorId;
        this._configuration = configuration;
        this.model = model;
        this._eventDispatcher = new (0, _viewModelEventDispatcherJs.ViewModelEventDispatcher)();
        this.onEvent = this._eventDispatcher.onEvent;
        this.cursorConfig = new (0, _cursorCommonJs.CursorConfiguration)(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService);
        this._updateConfigurationViewLineCount = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._updateConfigurationViewLineCountNow(), 0));
        this._hasFocus = false;
        this._viewportStart = ViewportStart.create(this.model);
        this.glyphLanes = new (0, _glyphLanesModelJs.GlyphMarginLanesModel)(0);
        if (USE_IDENTITY_LINES_COLLECTION && this.model.isTooLargeForTokenization()) this._lines = new (0, _viewModelLinesJs.ViewModelLinesFromModelAsIs)(this.model);
        else {
            const options = this._configuration.options;
            const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
            const wrappingStrategy = options.get(140 /* EditorOption.wrappingStrategy */ );
            const wrappingInfo = options.get(147 /* EditorOption.wrappingInfo */ );
            const wrappingIndent = options.get(139 /* EditorOption.wrappingIndent */ );
            const wordBreak = options.get(130 /* EditorOption.wordBreak */ );
            this._lines = new (0, _viewModelLinesJs.ViewModelLinesFromProjectedModel)(this._editorId, this.model, domLineBreaksComputerFactory, monospaceLineBreaksComputerFactory, fontInfo, this.model.getOptions().tabSize, wrappingStrategy, wrappingInfo.wrappingColumn, wrappingIndent, wordBreak);
        }
        this.coordinatesConverter = this._lines.createCoordinatesConverter();
        this._cursor = this._register(new (0, _cursorJs.CursorsController)(model, this, this.coordinatesConverter, this.cursorConfig));
        this.viewLayout = this._register(new (0, _viewLayoutJs.ViewLayout)(this._configuration, this.getLineCount(), scheduleAtNextAnimationFrame));
        this._register(this.viewLayout.onDidScroll((e)=>{
            if (e.scrollTopChanged) this._handleVisibleLinesChanged();
            if (e.scrollTopChanged) this._viewportStart.invalidate();
            this._eventDispatcher.emitSingleViewEvent(new _viewEventsJs.ViewScrollChangedEvent(e));
            this._eventDispatcher.emitOutgoingEvent(new (0, _viewModelEventDispatcherJs.ScrollChangedEvent)(e.oldScrollWidth, e.oldScrollLeft, e.oldScrollHeight, e.oldScrollTop, e.scrollWidth, e.scrollLeft, e.scrollHeight, e.scrollTop));
        }));
        this._register(this.viewLayout.onDidContentSizeChange((e)=>{
            this._eventDispatcher.emitOutgoingEvent(e);
        }));
        this._decorations = new (0, _viewModelDecorationsJs.ViewModelDecorations)(this._editorId, this.model, this._configuration, this._lines, this.coordinatesConverter);
        this._registerModelEvents();
        this._register(this._configuration.onDidChangeFast((e)=>{
            try {
                const eventsCollector = this._eventDispatcher.beginEmitViewEvents();
                this._onConfigurationChanged(eventsCollector, e);
            } finally{
                this._eventDispatcher.endEmitViewEvents();
            }
        }));
        this._register((0, _minimapTokensColorTrackerJs.MinimapTokensColorTracker).getInstance().onDidChange(()=>{
            this._eventDispatcher.emitSingleViewEvent(new _viewEventsJs.ViewTokensColorsChangedEvent());
        }));
        this._register(this._themeService.onDidColorThemeChange((theme)=>{
            this._invalidateDecorationsColorCache();
            this._eventDispatcher.emitSingleViewEvent(new _viewEventsJs.ViewThemeChangedEvent(theme));
        }));
        this._updateConfigurationViewLineCountNow();
    }
    dispose() {
        // First remove listeners, as disposing the lines might end up sending
        // model decoration changed events ... and we no longer care about them ...
        super.dispose();
        this._decorations.dispose();
        this._lines.dispose();
        this._viewportStart.dispose();
        this._eventDispatcher.dispose();
    }
    createLineBreaksComputer() {
        return this._lines.createLineBreaksComputer();
    }
    addViewEventHandler(eventHandler) {
        this._eventDispatcher.addViewEventHandler(eventHandler);
    }
    removeViewEventHandler(eventHandler) {
        this._eventDispatcher.removeViewEventHandler(eventHandler);
    }
    _updateConfigurationViewLineCountNow() {
        this._configuration.setViewLineCount(this._lines.getViewLineCount());
    }
    getModelVisibleRanges() {
        const linesViewportData = this.viewLayout.getLinesViewportData();
        const viewVisibleRange = new (0, _rangeJs.Range)(linesViewportData.startLineNumber, this.getLineMinColumn(linesViewportData.startLineNumber), linesViewportData.endLineNumber, this.getLineMaxColumn(linesViewportData.endLineNumber));
        const modelVisibleRanges = this._toModelVisibleRanges(viewVisibleRange);
        return modelVisibleRanges;
    }
    visibleLinesStabilized() {
        const modelVisibleRanges = this.getModelVisibleRanges();
        this._attachedView.setVisibleLines(modelVisibleRanges, true);
    }
    _handleVisibleLinesChanged() {
        const modelVisibleRanges = this.getModelVisibleRanges();
        this._attachedView.setVisibleLines(modelVisibleRanges, false);
    }
    setHasFocus(hasFocus) {
        this._hasFocus = hasFocus;
        this._cursor.setHasFocus(hasFocus);
        this._eventDispatcher.emitSingleViewEvent(new _viewEventsJs.ViewFocusChangedEvent(hasFocus));
        this._eventDispatcher.emitOutgoingEvent(new (0, _viewModelEventDispatcherJs.FocusChangedEvent)(!hasFocus, hasFocus));
    }
    onCompositionStart() {
        this._eventDispatcher.emitSingleViewEvent(new _viewEventsJs.ViewCompositionStartEvent());
    }
    onCompositionEnd() {
        this._eventDispatcher.emitSingleViewEvent(new _viewEventsJs.ViewCompositionEndEvent());
    }
    _captureStableViewport() {
        // We might need to restore the current start view range, so save it (if available)
        // But only if the scroll position is not at the top of the file
        if (this._viewportStart.isValid && this.viewLayout.getCurrentScrollTop() > 0) {
            const previousViewportStartViewPosition = new (0, _positionJs.Position)(this._viewportStart.viewLineNumber, this.getLineMinColumn(this._viewportStart.viewLineNumber));
            const previousViewportStartModelPosition = this.coordinatesConverter.convertViewPositionToModelPosition(previousViewportStartViewPosition);
            return new StableViewport(previousViewportStartModelPosition, this._viewportStart.startLineDelta);
        }
        return new StableViewport(null, 0);
    }
    _onConfigurationChanged(eventsCollector, e) {
        const stableViewport = this._captureStableViewport();
        const options = this._configuration.options;
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        const wrappingStrategy = options.get(140 /* EditorOption.wrappingStrategy */ );
        const wrappingInfo = options.get(147 /* EditorOption.wrappingInfo */ );
        const wrappingIndent = options.get(139 /* EditorOption.wrappingIndent */ );
        const wordBreak = options.get(130 /* EditorOption.wordBreak */ );
        if (this._lines.setWrappingSettings(fontInfo, wrappingStrategy, wrappingInfo.wrappingColumn, wrappingIndent, wordBreak)) {
            eventsCollector.emitViewEvent(new _viewEventsJs.ViewFlushedEvent());
            eventsCollector.emitViewEvent(new _viewEventsJs.ViewLineMappingChangedEvent());
            eventsCollector.emitViewEvent(new _viewEventsJs.ViewDecorationsChangedEvent(null));
            this._cursor.onLineMappingChanged(eventsCollector);
            this._decorations.onLineMappingChanged();
            this.viewLayout.onFlushed(this.getLineCount());
            this._updateConfigurationViewLineCount.schedule();
        }
        if (e.hasChanged(92 /* EditorOption.readOnly */ )) {
            // Must read again all decorations due to readOnly filtering
            this._decorations.reset();
            eventsCollector.emitViewEvent(new _viewEventsJs.ViewDecorationsChangedEvent(null));
        }
        if (e.hasChanged(99 /* EditorOption.renderValidationDecorations */ )) {
            this._decorations.reset();
            eventsCollector.emitViewEvent(new _viewEventsJs.ViewDecorationsChangedEvent(null));
        }
        eventsCollector.emitViewEvent(new _viewEventsJs.ViewConfigurationChangedEvent(e));
        this.viewLayout.onConfigurationChanged(e);
        stableViewport.recoverViewportStart(this.coordinatesConverter, this.viewLayout);
        if ((0, _cursorCommonJs.CursorConfiguration).shouldRecreate(e)) {
            this.cursorConfig = new (0, _cursorCommonJs.CursorConfiguration)(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService);
            this._cursor.updateConfiguration(this.cursorConfig);
        }
    }
    _registerModelEvents() {
        this._register(this.model.onDidChangeContentOrInjectedText((e)=>{
            try {
                const eventsCollector = this._eventDispatcher.beginEmitViewEvents();
                let hadOtherModelChange = false;
                let hadModelLineChangeThatChangedLineMapping = false;
                const changes = e instanceof _textModelEventsJs.InternalModelContentChangeEvent ? e.rawContentChangedEvent.changes : e.changes;
                const versionId = e instanceof _textModelEventsJs.InternalModelContentChangeEvent ? e.rawContentChangedEvent.versionId : null;
                // Do a first pass to compute line mappings, and a second pass to actually interpret them
                const lineBreaksComputer = this._lines.createLineBreaksComputer();
                for (const change of changes)switch(change.changeType){
                    case 4 /* textModelEvents.RawContentChangedType.LinesInserted */ :
                        for(let lineIdx = 0; lineIdx < change.detail.length; lineIdx++){
                            const line = change.detail[lineIdx];
                            let injectedText = change.injectedTexts[lineIdx];
                            if (injectedText) injectedText = injectedText.filter((element)=>!element.ownerId || element.ownerId === this._editorId);
                            lineBreaksComputer.addRequest(line, injectedText, null);
                        }
                        break;
                    case 2 /* textModelEvents.RawContentChangedType.LineChanged */ :
                        {
                            let injectedText = null;
                            if (change.injectedText) injectedText = change.injectedText.filter((element)=>!element.ownerId || element.ownerId === this._editorId);
                            lineBreaksComputer.addRequest(change.detail, injectedText, null);
                            break;
                        }
                }
                const lineBreaks = lineBreaksComputer.finalize();
                const lineBreakQueue = new (0, _arraysJs.ArrayQueue)(lineBreaks);
                for (const change of changes)switch(change.changeType){
                    case 1 /* textModelEvents.RawContentChangedType.Flush */ :
                        this._lines.onModelFlushed();
                        eventsCollector.emitViewEvent(new _viewEventsJs.ViewFlushedEvent());
                        this._decorations.reset();
                        this.viewLayout.onFlushed(this.getLineCount());
                        hadOtherModelChange = true;
                        break;
                    case 3 /* textModelEvents.RawContentChangedType.LinesDeleted */ :
                        {
                            const linesDeletedEvent = this._lines.onModelLinesDeleted(versionId, change.fromLineNumber, change.toLineNumber);
                            if (linesDeletedEvent !== null) {
                                eventsCollector.emitViewEvent(linesDeletedEvent);
                                this.viewLayout.onLinesDeleted(linesDeletedEvent.fromLineNumber, linesDeletedEvent.toLineNumber);
                            }
                            hadOtherModelChange = true;
                            break;
                        }
                    case 4 /* textModelEvents.RawContentChangedType.LinesInserted */ :
                        {
                            const insertedLineBreaks = lineBreakQueue.takeCount(change.detail.length);
                            const linesInsertedEvent = this._lines.onModelLinesInserted(versionId, change.fromLineNumber, change.toLineNumber, insertedLineBreaks);
                            if (linesInsertedEvent !== null) {
                                eventsCollector.emitViewEvent(linesInsertedEvent);
                                this.viewLayout.onLinesInserted(linesInsertedEvent.fromLineNumber, linesInsertedEvent.toLineNumber);
                            }
                            hadOtherModelChange = true;
                            break;
                        }
                    case 2 /* textModelEvents.RawContentChangedType.LineChanged */ :
                        {
                            const changedLineBreakData = lineBreakQueue.dequeue();
                            const [lineMappingChanged, linesChangedEvent, linesInsertedEvent, linesDeletedEvent] = this._lines.onModelLineChanged(versionId, change.lineNumber, changedLineBreakData);
                            hadModelLineChangeThatChangedLineMapping = lineMappingChanged;
                            if (linesChangedEvent) eventsCollector.emitViewEvent(linesChangedEvent);
                            if (linesInsertedEvent) {
                                eventsCollector.emitViewEvent(linesInsertedEvent);
                                this.viewLayout.onLinesInserted(linesInsertedEvent.fromLineNumber, linesInsertedEvent.toLineNumber);
                            }
                            if (linesDeletedEvent) {
                                eventsCollector.emitViewEvent(linesDeletedEvent);
                                this.viewLayout.onLinesDeleted(linesDeletedEvent.fromLineNumber, linesDeletedEvent.toLineNumber);
                            }
                            break;
                        }
                    case 5 /* textModelEvents.RawContentChangedType.EOLChanged */ :
                        break;
                }
                if (versionId !== null) this._lines.acceptVersionId(versionId);
                this.viewLayout.onHeightMaybeChanged();
                if (!hadOtherModelChange && hadModelLineChangeThatChangedLineMapping) {
                    eventsCollector.emitViewEvent(new _viewEventsJs.ViewLineMappingChangedEvent());
                    eventsCollector.emitViewEvent(new _viewEventsJs.ViewDecorationsChangedEvent(null));
                    this._cursor.onLineMappingChanged(eventsCollector);
                    this._decorations.onLineMappingChanged();
                }
            } finally{
                this._eventDispatcher.endEmitViewEvents();
            }
            // Update the configuration and reset the centered view line
            const viewportStartWasValid = this._viewportStart.isValid;
            this._viewportStart.invalidate();
            this._configuration.setModelLineCount(this.model.getLineCount());
            this._updateConfigurationViewLineCountNow();
            // Recover viewport
            if (!this._hasFocus && this.model.getAttachedEditorCount() >= 2 && viewportStartWasValid) {
                const modelRange = this.model._getTrackedRange(this._viewportStart.modelTrackedRange);
                if (modelRange) {
                    const viewPosition = this.coordinatesConverter.convertModelPositionToViewPosition(modelRange.getStartPosition());
                    const viewPositionTop = this.viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber);
                    this.viewLayout.setScrollPosition({
                        scrollTop: viewPositionTop + this._viewportStart.startLineDelta
                    }, 1 /* ScrollType.Immediate */ );
                }
            }
            try {
                const eventsCollector = this._eventDispatcher.beginEmitViewEvents();
                if (e instanceof _textModelEventsJs.InternalModelContentChangeEvent) eventsCollector.emitOutgoingEvent(new (0, _viewModelEventDispatcherJs.ModelContentChangedEvent)(e.contentChangedEvent));
                this._cursor.onModelContentChanged(eventsCollector, e);
            } finally{
                this._eventDispatcher.endEmitViewEvents();
            }
            this._handleVisibleLinesChanged();
        }));
        this._register(this.model.onDidChangeTokens((e)=>{
            const viewRanges = [];
            for(let j = 0, lenJ = e.ranges.length; j < lenJ; j++){
                const modelRange = e.ranges[j];
                const viewStartLineNumber = this.coordinatesConverter.convertModelPositionToViewPosition(new (0, _positionJs.Position)(modelRange.fromLineNumber, 1)).lineNumber;
                const viewEndLineNumber = this.coordinatesConverter.convertModelPositionToViewPosition(new (0, _positionJs.Position)(modelRange.toLineNumber, this.model.getLineMaxColumn(modelRange.toLineNumber))).lineNumber;
                viewRanges[j] = {
                    fromLineNumber: viewStartLineNumber,
                    toLineNumber: viewEndLineNumber
                };
            }
            this._eventDispatcher.emitSingleViewEvent(new _viewEventsJs.ViewTokensChangedEvent(viewRanges));
            this._eventDispatcher.emitOutgoingEvent(new (0, _viewModelEventDispatcherJs.ModelTokensChangedEvent)(e));
        }));
        this._register(this.model.onDidChangeLanguageConfiguration((e)=>{
            this._eventDispatcher.emitSingleViewEvent(new _viewEventsJs.ViewLanguageConfigurationEvent());
            this.cursorConfig = new (0, _cursorCommonJs.CursorConfiguration)(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService);
            this._cursor.updateConfiguration(this.cursorConfig);
            this._eventDispatcher.emitOutgoingEvent(new (0, _viewModelEventDispatcherJs.ModelLanguageConfigurationChangedEvent)(e));
        }));
        this._register(this.model.onDidChangeLanguage((e)=>{
            this.cursorConfig = new (0, _cursorCommonJs.CursorConfiguration)(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService);
            this._cursor.updateConfiguration(this.cursorConfig);
            this._eventDispatcher.emitOutgoingEvent(new (0, _viewModelEventDispatcherJs.ModelLanguageChangedEvent)(e));
        }));
        this._register(this.model.onDidChangeOptions((e)=>{
            // A tab size change causes a line mapping changed event => all view parts will repaint OK, no further event needed here
            if (this._lines.setTabSize(this.model.getOptions().tabSize)) {
                try {
                    const eventsCollector = this._eventDispatcher.beginEmitViewEvents();
                    eventsCollector.emitViewEvent(new _viewEventsJs.ViewFlushedEvent());
                    eventsCollector.emitViewEvent(new _viewEventsJs.ViewLineMappingChangedEvent());
                    eventsCollector.emitViewEvent(new _viewEventsJs.ViewDecorationsChangedEvent(null));
                    this._cursor.onLineMappingChanged(eventsCollector);
                    this._decorations.onLineMappingChanged();
                    this.viewLayout.onFlushed(this.getLineCount());
                } finally{
                    this._eventDispatcher.endEmitViewEvents();
                }
                this._updateConfigurationViewLineCount.schedule();
            }
            this.cursorConfig = new (0, _cursorCommonJs.CursorConfiguration)(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService);
            this._cursor.updateConfiguration(this.cursorConfig);
            this._eventDispatcher.emitOutgoingEvent(new (0, _viewModelEventDispatcherJs.ModelOptionsChangedEvent)(e));
        }));
        this._register(this.model.onDidChangeDecorations((e)=>{
            this._decorations.onModelDecorationsChanged();
            this._eventDispatcher.emitSingleViewEvent(new _viewEventsJs.ViewDecorationsChangedEvent(e));
            this._eventDispatcher.emitOutgoingEvent(new (0, _viewModelEventDispatcherJs.ModelDecorationsChangedEvent)(e));
        }));
    }
    setHiddenAreas(ranges, source) {
        this.hiddenAreasModel.setHiddenAreas(source, ranges);
        const mergedRanges = this.hiddenAreasModel.getMergedRanges();
        if (mergedRanges === this.previousHiddenAreas) return;
        this.previousHiddenAreas = mergedRanges;
        const stableViewport = this._captureStableViewport();
        let lineMappingChanged = false;
        try {
            const eventsCollector = this._eventDispatcher.beginEmitViewEvents();
            lineMappingChanged = this._lines.setHiddenAreas(mergedRanges);
            if (lineMappingChanged) {
                eventsCollector.emitViewEvent(new _viewEventsJs.ViewFlushedEvent());
                eventsCollector.emitViewEvent(new _viewEventsJs.ViewLineMappingChangedEvent());
                eventsCollector.emitViewEvent(new _viewEventsJs.ViewDecorationsChangedEvent(null));
                this._cursor.onLineMappingChanged(eventsCollector);
                this._decorations.onLineMappingChanged();
                this.viewLayout.onFlushed(this.getLineCount());
                this.viewLayout.onHeightMaybeChanged();
            }
            const firstModelLineInViewPort = stableViewport.viewportStartModelPosition?.lineNumber;
            const firstModelLineIsHidden = firstModelLineInViewPort && mergedRanges.some((range)=>range.startLineNumber <= firstModelLineInViewPort && firstModelLineInViewPort <= range.endLineNumber);
            if (!firstModelLineIsHidden) stableViewport.recoverViewportStart(this.coordinatesConverter, this.viewLayout);
        } finally{
            this._eventDispatcher.endEmitViewEvents();
        }
        this._updateConfigurationViewLineCount.schedule();
        if (lineMappingChanged) this._eventDispatcher.emitOutgoingEvent(new (0, _viewModelEventDispatcherJs.HiddenAreasChangedEvent)());
    }
    getVisibleRangesPlusViewportAboveBelow() {
        const layoutInfo = this._configuration.options.get(146 /* EditorOption.layoutInfo */ );
        const lineHeight = this._configuration.options.get(67 /* EditorOption.lineHeight */ );
        const linesAround = Math.max(20, Math.round(layoutInfo.height / lineHeight));
        const partialData = this.viewLayout.getLinesViewportData();
        const startViewLineNumber = Math.max(1, partialData.completelyVisibleStartLineNumber - linesAround);
        const endViewLineNumber = Math.min(this.getLineCount(), partialData.completelyVisibleEndLineNumber + linesAround);
        return this._toModelVisibleRanges(new (0, _rangeJs.Range)(startViewLineNumber, this.getLineMinColumn(startViewLineNumber), endViewLineNumber, this.getLineMaxColumn(endViewLineNumber)));
    }
    getVisibleRanges() {
        const visibleViewRange = this.getCompletelyVisibleViewRange();
        return this._toModelVisibleRanges(visibleViewRange);
    }
    getHiddenAreas() {
        return this._lines.getHiddenAreas();
    }
    _toModelVisibleRanges(visibleViewRange) {
        const visibleRange = this.coordinatesConverter.convertViewRangeToModelRange(visibleViewRange);
        const hiddenAreas = this._lines.getHiddenAreas();
        if (hiddenAreas.length === 0) return [
            visibleRange
        ];
        const result = [];
        let resultLen = 0;
        let startLineNumber = visibleRange.startLineNumber;
        let startColumn = visibleRange.startColumn;
        const endLineNumber = visibleRange.endLineNumber;
        const endColumn = visibleRange.endColumn;
        for(let i = 0, len = hiddenAreas.length; i < len; i++){
            const hiddenStartLineNumber = hiddenAreas[i].startLineNumber;
            const hiddenEndLineNumber = hiddenAreas[i].endLineNumber;
            if (hiddenEndLineNumber < startLineNumber) continue;
            if (hiddenStartLineNumber > endLineNumber) continue;
            if (startLineNumber < hiddenStartLineNumber) result[resultLen++] = new (0, _rangeJs.Range)(startLineNumber, startColumn, hiddenStartLineNumber - 1, this.model.getLineMaxColumn(hiddenStartLineNumber - 1));
            startLineNumber = hiddenEndLineNumber + 1;
            startColumn = 1;
        }
        if (startLineNumber < endLineNumber || startLineNumber === endLineNumber && startColumn < endColumn) result[resultLen++] = new (0, _rangeJs.Range)(startLineNumber, startColumn, endLineNumber, endColumn);
        return result;
    }
    getCompletelyVisibleViewRange() {
        const partialData = this.viewLayout.getLinesViewportData();
        const startViewLineNumber = partialData.completelyVisibleStartLineNumber;
        const endViewLineNumber = partialData.completelyVisibleEndLineNumber;
        return new (0, _rangeJs.Range)(startViewLineNumber, this.getLineMinColumn(startViewLineNumber), endViewLineNumber, this.getLineMaxColumn(endViewLineNumber));
    }
    getCompletelyVisibleViewRangeAtScrollTop(scrollTop) {
        const partialData = this.viewLayout.getLinesViewportDataAtScrollTop(scrollTop);
        const startViewLineNumber = partialData.completelyVisibleStartLineNumber;
        const endViewLineNumber = partialData.completelyVisibleEndLineNumber;
        return new (0, _rangeJs.Range)(startViewLineNumber, this.getLineMinColumn(startViewLineNumber), endViewLineNumber, this.getLineMaxColumn(endViewLineNumber));
    }
    saveState() {
        const compatViewState = this.viewLayout.saveState();
        const scrollTop = compatViewState.scrollTop;
        const firstViewLineNumber = this.viewLayout.getLineNumberAtVerticalOffset(scrollTop);
        const firstPosition = this.coordinatesConverter.convertViewPositionToModelPosition(new (0, _positionJs.Position)(firstViewLineNumber, this.getLineMinColumn(firstViewLineNumber)));
        const firstPositionDeltaTop = this.viewLayout.getVerticalOffsetForLineNumber(firstViewLineNumber) - scrollTop;
        return {
            scrollLeft: compatViewState.scrollLeft,
            firstPosition: firstPosition,
            firstPositionDeltaTop: firstPositionDeltaTop
        };
    }
    reduceRestoreState(state) {
        if (typeof state.firstPosition === "undefined") // This is a view state serialized by an older version
        return this._reduceRestoreStateCompatibility(state);
        const modelPosition = this.model.validatePosition(state.firstPosition);
        const viewPosition = this.coordinatesConverter.convertModelPositionToViewPosition(modelPosition);
        const scrollTop = this.viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber) - state.firstPositionDeltaTop;
        return {
            scrollLeft: state.scrollLeft,
            scrollTop: scrollTop
        };
    }
    _reduceRestoreStateCompatibility(state) {
        return {
            scrollLeft: state.scrollLeft,
            scrollTop: state.scrollTopWithoutViewZones
        };
    }
    getTabSize() {
        return this.model.getOptions().tabSize;
    }
    getLineCount() {
        return this._lines.getViewLineCount();
    }
    /**
     * Gives a hint that a lot of requests are about to come in for these line numbers.
     */ setViewport(startLineNumber, endLineNumber, centeredLineNumber) {
        this._viewportStart.update(this, startLineNumber);
    }
    getActiveIndentGuide(lineNumber, minLineNumber, maxLineNumber) {
        return this._lines.getActiveIndentGuide(lineNumber, minLineNumber, maxLineNumber);
    }
    getLinesIndentGuides(startLineNumber, endLineNumber) {
        return this._lines.getViewLinesIndentGuides(startLineNumber, endLineNumber);
    }
    getBracketGuidesInRangeByLine(startLineNumber, endLineNumber, activePosition, options) {
        return this._lines.getViewLinesBracketGuides(startLineNumber, endLineNumber, activePosition, options);
    }
    getLineContent(lineNumber) {
        return this._lines.getViewLineContent(lineNumber);
    }
    getLineLength(lineNumber) {
        return this._lines.getViewLineLength(lineNumber);
    }
    getLineMinColumn(lineNumber) {
        return this._lines.getViewLineMinColumn(lineNumber);
    }
    getLineMaxColumn(lineNumber) {
        return this._lines.getViewLineMaxColumn(lineNumber);
    }
    getLineFirstNonWhitespaceColumn(lineNumber) {
        const result = _stringsJs.firstNonWhitespaceIndex(this.getLineContent(lineNumber));
        if (result === -1) return 0;
        return result + 1;
    }
    getLineLastNonWhitespaceColumn(lineNumber) {
        const result = _stringsJs.lastNonWhitespaceIndex(this.getLineContent(lineNumber));
        if (result === -1) return 0;
        return result + 2;
    }
    getMinimapDecorationsInRange(range) {
        return this._decorations.getMinimapDecorationsInRange(range);
    }
    getDecorationsInViewport(visibleRange) {
        return this._decorations.getDecorationsViewportData(visibleRange).decorations;
    }
    getInjectedTextAt(viewPosition) {
        return this._lines.getInjectedTextAt(viewPosition);
    }
    getViewportViewLineRenderingData(visibleRange, lineNumber) {
        const allInlineDecorations = this._decorations.getDecorationsViewportData(visibleRange).inlineDecorations;
        const inlineDecorations = allInlineDecorations[lineNumber - visibleRange.startLineNumber];
        return this._getViewLineRenderingData(lineNumber, inlineDecorations);
    }
    getViewLineRenderingData(lineNumber) {
        const inlineDecorations = this._decorations.getInlineDecorationsOnLine(lineNumber);
        return this._getViewLineRenderingData(lineNumber, inlineDecorations);
    }
    _getViewLineRenderingData(lineNumber, inlineDecorations) {
        const mightContainRTL = this.model.mightContainRTL();
        const mightContainNonBasicASCII = this.model.mightContainNonBasicASCII();
        const tabSize = this.getTabSize();
        const lineData = this._lines.getViewLineData(lineNumber);
        if (lineData.inlineDecorations) inlineDecorations = [
            ...inlineDecorations,
            ...lineData.inlineDecorations.map((d)=>d.toInlineDecoration(lineNumber))
        ];
        return new (0, _viewModelJs.ViewLineRenderingData)(lineData.minColumn, lineData.maxColumn, lineData.content, lineData.continuesWithWrappedLine, mightContainRTL, mightContainNonBasicASCII, lineData.tokens, inlineDecorations, tabSize, lineData.startVisibleColumn);
    }
    getViewLineData(lineNumber) {
        return this._lines.getViewLineData(lineNumber);
    }
    getMinimapLinesRenderingData(startLineNumber, endLineNumber, needed) {
        const result = this._lines.getViewLinesData(startLineNumber, endLineNumber, needed);
        return new (0, _viewModelJs.MinimapLinesRenderingData)(this.getTabSize(), result);
    }
    getAllOverviewRulerDecorations(theme) {
        const decorations = this.model.getOverviewRulerDecorations(this._editorId, (0, _editorOptionsJs.filterValidationDecorations)(this._configuration.options));
        const result = new OverviewRulerDecorations();
        for (const decoration of decorations){
            const decorationOptions = decoration.options;
            const opts = decorationOptions.overviewRuler;
            if (!opts) continue;
            const lane = opts.position;
            if (lane === 0) continue;
            const color = opts.getColor(theme.value);
            const viewStartLineNumber = this.coordinatesConverter.getViewLineNumberOfModelPosition(decoration.range.startLineNumber, decoration.range.startColumn);
            const viewEndLineNumber = this.coordinatesConverter.getViewLineNumberOfModelPosition(decoration.range.endLineNumber, decoration.range.endColumn);
            result.accept(color, decorationOptions.zIndex, viewStartLineNumber, viewEndLineNumber, lane);
        }
        return result.asArray;
    }
    _invalidateDecorationsColorCache() {
        const decorations = this.model.getOverviewRulerDecorations();
        for (const decoration of decorations){
            const opts1 = decoration.options.overviewRuler;
            opts1?.invalidateCachedColor();
            const opts2 = decoration.options.minimap;
            opts2?.invalidateCachedColor();
        }
    }
    getValueInRange(range, eol) {
        const modelRange = this.coordinatesConverter.convertViewRangeToModelRange(range);
        return this.model.getValueInRange(modelRange, eol);
    }
    getValueLengthInRange(range, eol) {
        const modelRange = this.coordinatesConverter.convertViewRangeToModelRange(range);
        return this.model.getValueLengthInRange(modelRange, eol);
    }
    modifyPosition(position, offset) {
        const modelPosition = this.coordinatesConverter.convertViewPositionToModelPosition(position);
        const resultModelPosition = this.model.modifyPosition(modelPosition, offset);
        return this.coordinatesConverter.convertModelPositionToViewPosition(resultModelPosition);
    }
    deduceModelPositionRelativeToViewPosition(viewAnchorPosition, deltaOffset, lineFeedCnt) {
        const modelAnchor = this.coordinatesConverter.convertViewPositionToModelPosition(viewAnchorPosition);
        if (this.model.getEOL().length === 2) {
            // This model uses CRLF, so the delta must take that into account
            if (deltaOffset < 0) deltaOffset -= lineFeedCnt;
            else deltaOffset += lineFeedCnt;
        }
        const modelAnchorOffset = this.model.getOffsetAt(modelAnchor);
        const resultOffset = modelAnchorOffset + deltaOffset;
        return this.model.getPositionAt(resultOffset);
    }
    getPlainTextToCopy(modelRanges, emptySelectionClipboard, forceCRLF) {
        const newLineCharacter = forceCRLF ? "\r\n" : this.model.getEOL();
        modelRanges = modelRanges.slice(0);
        modelRanges.sort((0, _rangeJs.Range).compareRangesUsingStarts);
        let hasEmptyRange = false;
        let hasNonEmptyRange = false;
        for (const range of modelRanges)if (range.isEmpty()) hasEmptyRange = true;
        else hasNonEmptyRange = true;
        if (!hasNonEmptyRange) {
            // all ranges are empty
            if (!emptySelectionClipboard) return "";
            const modelLineNumbers = modelRanges.map((r)=>r.startLineNumber);
            let result = "";
            for(let i = 0; i < modelLineNumbers.length; i++){
                if (i > 0 && modelLineNumbers[i - 1] === modelLineNumbers[i]) continue;
                result += this.model.getLineContent(modelLineNumbers[i]) + newLineCharacter;
            }
            return result;
        }
        if (hasEmptyRange && emptySelectionClipboard) {
            // mixed empty selections and non-empty selections
            const result = [];
            let prevModelLineNumber = 0;
            for (const modelRange of modelRanges){
                const modelLineNumber = modelRange.startLineNumber;
                if (modelRange.isEmpty()) {
                    if (modelLineNumber !== prevModelLineNumber) result.push(this.model.getLineContent(modelLineNumber));
                } else result.push(this.model.getValueInRange(modelRange, forceCRLF ? 2 /* EndOfLinePreference.CRLF */  : 0 /* EndOfLinePreference.TextDefined */ ));
                prevModelLineNumber = modelLineNumber;
            }
            return result.length === 1 ? result[0] : result;
        }
        const result = [];
        for (const modelRange of modelRanges)if (!modelRange.isEmpty()) result.push(this.model.getValueInRange(modelRange, forceCRLF ? 2 /* EndOfLinePreference.CRLF */  : 0 /* EndOfLinePreference.TextDefined */ ));
        return result.length === 1 ? result[0] : result;
    }
    getRichTextToCopy(modelRanges, emptySelectionClipboard) {
        const languageId = this.model.getLanguageId();
        if (languageId === (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID)) return null;
        if (modelRanges.length !== 1) // no multiple selection support at this time
        return null;
        let range = modelRanges[0];
        if (range.isEmpty()) {
            if (!emptySelectionClipboard) // nothing to copy
            return null;
            const lineNumber = range.startLineNumber;
            range = new (0, _rangeJs.Range)(lineNumber, this.model.getLineMinColumn(lineNumber), lineNumber, this.model.getLineMaxColumn(lineNumber));
        }
        const fontInfo = this._configuration.options.get(50 /* EditorOption.fontInfo */ );
        const colorMap = this._getColorMap();
        const hasBadChars = /[:;\\\/<>]/.test(fontInfo.fontFamily);
        const useDefaultFontFamily = hasBadChars || fontInfo.fontFamily === (0, _editorOptionsJs.EDITOR_FONT_DEFAULTS).fontFamily;
        let fontFamily;
        if (useDefaultFontFamily) fontFamily = (0, _editorOptionsJs.EDITOR_FONT_DEFAULTS).fontFamily;
        else {
            fontFamily = fontInfo.fontFamily;
            fontFamily = fontFamily.replace(/"/g, "'");
            const hasQuotesOrIsList = /[,']/.test(fontFamily);
            if (!hasQuotesOrIsList) {
                const needsQuotes = /[+ ]/.test(fontFamily);
                if (needsQuotes) fontFamily = `'${fontFamily}'`;
            }
            fontFamily = `${fontFamily}, ${(0, _editorOptionsJs.EDITOR_FONT_DEFAULTS).fontFamily}`;
        }
        return {
            mode: languageId,
            html: `<div style="` + `color: ${colorMap[1 /* ColorId.DefaultForeground */ ]};` + `background-color: ${colorMap[2 /* ColorId.DefaultBackground */ ]};` + `font-family: ${fontFamily};` + `font-weight: ${fontInfo.fontWeight};` + `font-size: ${fontInfo.fontSize}px;` + `line-height: ${fontInfo.lineHeight}px;` + `white-space: pre;` + `">` + this._getHTMLToCopy(range, colorMap) + "</div>"
        };
    }
    _getHTMLToCopy(modelRange, colorMap) {
        const startLineNumber = modelRange.startLineNumber;
        const startColumn = modelRange.startColumn;
        const endLineNumber = modelRange.endLineNumber;
        const endColumn = modelRange.endColumn;
        const tabSize = this.getTabSize();
        let result = "";
        for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++){
            const lineTokens = this.model.tokenization.getLineTokens(lineNumber);
            const lineContent = lineTokens.getLineContent();
            const startOffset = lineNumber === startLineNumber ? startColumn - 1 : 0;
            const endOffset = lineNumber === endLineNumber ? endColumn - 1 : lineContent.length;
            if (lineContent === "") result += "<br>";
            else result += (0, _textToHtmlTokenizerJs.tokenizeLineToHTML)(lineContent, lineTokens.inflate(), colorMap, startOffset, endOffset, tabSize, _platformJs.isWindows);
        }
        return result;
    }
    _getColorMap() {
        const colorMap = (0, _languagesJs.TokenizationRegistry).getColorMap();
        const result = [
            "#000000"
        ];
        if (colorMap) for(let i = 1, len = colorMap.length; i < len; i++)result[i] = (0, _colorJs.Color).Format.CSS.formatHex(colorMap[i]);
        return result;
    }
    //#region cursor operations
    getPrimaryCursorState() {
        return this._cursor.getPrimaryCursorState();
    }
    getLastAddedCursorIndex() {
        return this._cursor.getLastAddedCursorIndex();
    }
    getCursorStates() {
        return this._cursor.getCursorStates();
    }
    setCursorStates(source, reason, states) {
        return this._withViewEventsCollector((eventsCollector)=>this._cursor.setStates(eventsCollector, source, reason, states));
    }
    getCursorColumnSelectData() {
        return this._cursor.getCursorColumnSelectData();
    }
    getCursorAutoClosedCharacters() {
        return this._cursor.getAutoClosedCharacters();
    }
    setCursorColumnSelectData(columnSelectData) {
        this._cursor.setCursorColumnSelectData(columnSelectData);
    }
    getPrevEditOperationType() {
        return this._cursor.getPrevEditOperationType();
    }
    setPrevEditOperationType(type) {
        this._cursor.setPrevEditOperationType(type);
    }
    getSelection() {
        return this._cursor.getSelection();
    }
    getSelections() {
        return this._cursor.getSelections();
    }
    getPosition() {
        return this._cursor.getPrimaryCursorState().modelState.position;
    }
    setSelections(source, selections, reason = 0 /* CursorChangeReason.NotSet */ ) {
        this._withViewEventsCollector((eventsCollector)=>this._cursor.setSelections(eventsCollector, source, selections, reason));
    }
    saveCursorState() {
        return this._cursor.saveState();
    }
    restoreCursorState(states) {
        this._withViewEventsCollector((eventsCollector)=>this._cursor.restoreState(eventsCollector, states));
    }
    _executeCursorEdit(callback) {
        if (this._cursor.context.cursorConfig.readOnly) {
            // we cannot edit when read only...
            this._eventDispatcher.emitOutgoingEvent(new (0, _viewModelEventDispatcherJs.ReadOnlyEditAttemptEvent)());
            return;
        }
        this._withViewEventsCollector(callback);
    }
    executeEdits(source, edits, cursorStateComputer) {
        this._executeCursorEdit((eventsCollector)=>this._cursor.executeEdits(eventsCollector, source, edits, cursorStateComputer));
    }
    startComposition() {
        this._executeCursorEdit((eventsCollector)=>this._cursor.startComposition(eventsCollector));
    }
    endComposition(source) {
        this._executeCursorEdit((eventsCollector)=>this._cursor.endComposition(eventsCollector, source));
    }
    type(text, source) {
        this._executeCursorEdit((eventsCollector)=>this._cursor.type(eventsCollector, text, source));
    }
    compositionType(text, replacePrevCharCnt, replaceNextCharCnt, positionDelta, source) {
        this._executeCursorEdit((eventsCollector)=>this._cursor.compositionType(eventsCollector, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta, source));
    }
    paste(text, pasteOnNewLine, multicursorText, source) {
        this._executeCursorEdit((eventsCollector)=>this._cursor.paste(eventsCollector, text, pasteOnNewLine, multicursorText, source));
    }
    cut(source) {
        this._executeCursorEdit((eventsCollector)=>this._cursor.cut(eventsCollector, source));
    }
    executeCommand(command, source) {
        this._executeCursorEdit((eventsCollector)=>this._cursor.executeCommand(eventsCollector, command, source));
    }
    executeCommands(commands, source) {
        this._executeCursorEdit((eventsCollector)=>this._cursor.executeCommands(eventsCollector, commands, source));
    }
    revealAllCursors(source, revealHorizontal, minimalReveal = false) {
        this._withViewEventsCollector((eventsCollector)=>this._cursor.revealAll(eventsCollector, source, minimalReveal, 0 /* viewEvents.VerticalRevealType.Simple */ , revealHorizontal, 0 /* ScrollType.Smooth */ ));
    }
    revealPrimaryCursor(source, revealHorizontal, minimalReveal = false) {
        this._withViewEventsCollector((eventsCollector)=>this._cursor.revealPrimary(eventsCollector, source, minimalReveal, 0 /* viewEvents.VerticalRevealType.Simple */ , revealHorizontal, 0 /* ScrollType.Smooth */ ));
    }
    revealTopMostCursor(source) {
        const viewPosition = this._cursor.getTopMostViewPosition();
        const viewRange = new (0, _rangeJs.Range)(viewPosition.lineNumber, viewPosition.column, viewPosition.lineNumber, viewPosition.column);
        this._withViewEventsCollector((eventsCollector)=>eventsCollector.emitViewEvent(new _viewEventsJs.ViewRevealRangeRequestEvent(source, false, viewRange, null, 0 /* viewEvents.VerticalRevealType.Simple */ , true, 0 /* ScrollType.Smooth */ )));
    }
    revealBottomMostCursor(source) {
        const viewPosition = this._cursor.getBottomMostViewPosition();
        const viewRange = new (0, _rangeJs.Range)(viewPosition.lineNumber, viewPosition.column, viewPosition.lineNumber, viewPosition.column);
        this._withViewEventsCollector((eventsCollector)=>eventsCollector.emitViewEvent(new _viewEventsJs.ViewRevealRangeRequestEvent(source, false, viewRange, null, 0 /* viewEvents.VerticalRevealType.Simple */ , true, 0 /* ScrollType.Smooth */ )));
    }
    revealRange(source, revealHorizontal, viewRange, verticalType, scrollType) {
        this._withViewEventsCollector((eventsCollector)=>eventsCollector.emitViewEvent(new _viewEventsJs.ViewRevealRangeRequestEvent(source, false, viewRange, null, verticalType, revealHorizontal, scrollType)));
    }
    //#endregion
    //#region viewLayout
    changeWhitespace(callback) {
        const hadAChange = this.viewLayout.changeWhitespace(callback);
        if (hadAChange) {
            this._eventDispatcher.emitSingleViewEvent(new _viewEventsJs.ViewZonesChangedEvent());
            this._eventDispatcher.emitOutgoingEvent(new (0, _viewModelEventDispatcherJs.ViewZonesChangedEvent)());
        }
    }
    //#endregion
    _withViewEventsCollector(callback) {
        return this._transactionalTarget.batchChanges(()=>{
            try {
                const eventsCollector = this._eventDispatcher.beginEmitViewEvents();
                return callback(eventsCollector);
            } finally{
                this._eventDispatcher.endEmitViewEvents();
            }
        });
    }
    batchEvents(callback) {
        this._withViewEventsCollector(()=>{
            callback();
        });
    }
    normalizePosition(position, affinity) {
        return this._lines.normalizePosition(position, affinity);
    }
    /**
     * Gets the column at which indentation stops at a given line.
     * @internal
    */ getLineIndentColumn(lineNumber) {
        return this._lines.getLineIndentColumn(lineNumber);
    }
}
class ViewportStart {
    static create(model) {
        const viewportStartLineTrackedRange = model._setTrackedRange(null, new (0, _rangeJs.Range)(1, 1, 1, 1), 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ );
        return new ViewportStart(model, 1, false, viewportStartLineTrackedRange, 0);
    }
    get viewLineNumber() {
        return this._viewLineNumber;
    }
    get isValid() {
        return this._isValid;
    }
    get modelTrackedRange() {
        return this._modelTrackedRange;
    }
    get startLineDelta() {
        return this._startLineDelta;
    }
    constructor(_model, _viewLineNumber, _isValid, _modelTrackedRange, _startLineDelta){
        this._model = _model;
        this._viewLineNumber = _viewLineNumber;
        this._isValid = _isValid;
        this._modelTrackedRange = _modelTrackedRange;
        this._startLineDelta = _startLineDelta;
    }
    dispose() {
        this._model._setTrackedRange(this._modelTrackedRange, null, 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ );
    }
    update(viewModel, startLineNumber) {
        const position = viewModel.coordinatesConverter.convertViewPositionToModelPosition(new (0, _positionJs.Position)(startLineNumber, viewModel.getLineMinColumn(startLineNumber)));
        const viewportStartLineTrackedRange = viewModel.model._setTrackedRange(this._modelTrackedRange, new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column), 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ );
        const viewportStartLineTop = viewModel.viewLayout.getVerticalOffsetForLineNumber(startLineNumber);
        const scrollTop = viewModel.viewLayout.getCurrentScrollTop();
        this._viewLineNumber = startLineNumber;
        this._isValid = true;
        this._modelTrackedRange = viewportStartLineTrackedRange;
        this._startLineDelta = scrollTop - viewportStartLineTop;
    }
    invalidate() {
        this._isValid = false;
    }
}
class OverviewRulerDecorations {
    constructor(){
        this._asMap = Object.create(null);
        this.asArray = [];
    }
    accept(color, zIndex, startLineNumber, endLineNumber, lane) {
        const prevGroup = this._asMap[color];
        if (prevGroup) {
            const prevData = prevGroup.data;
            const prevLane = prevData[prevData.length - 3];
            const prevEndLineNumber = prevData[prevData.length - 1];
            if (prevLane === lane && prevEndLineNumber + 1 >= startLineNumber) {
                // merge into prev
                if (endLineNumber > prevEndLineNumber) prevData[prevData.length - 1] = endLineNumber;
                return;
            }
            // push
            prevData.push(lane, startLineNumber, endLineNumber);
        } else {
            const group = new (0, _viewModelJs.OverviewRulerDecorationsGroup)(color, zIndex, [
                lane,
                startLineNumber,
                endLineNumber
            ]);
            this._asMap[color] = group;
            this.asArray.push(group);
        }
    }
}
class HiddenAreasModel {
    constructor(){
        this.hiddenAreas = new Map();
        this.shouldRecompute = false;
        this.ranges = [];
    }
    setHiddenAreas(source, ranges) {
        const existing = this.hiddenAreas.get(source);
        if (existing && rangeArraysEqual(existing, ranges)) return;
        this.hiddenAreas.set(source, ranges);
        this.shouldRecompute = true;
    }
    /**
     * The returned array is immutable.
    */ getMergedRanges() {
        if (!this.shouldRecompute) return this.ranges;
        this.shouldRecompute = false;
        const newRanges = Array.from(this.hiddenAreas.values()).reduce((r, hiddenAreas)=>mergeLineRangeArray(r, hiddenAreas), []);
        if (rangeArraysEqual(this.ranges, newRanges)) return this.ranges;
        this.ranges = newRanges;
        return this.ranges;
    }
}
function mergeLineRangeArray(arr1, arr2) {
    const result = [];
    let i = 0;
    let j = 0;
    while(i < arr1.length && j < arr2.length){
        const item1 = arr1[i];
        const item2 = arr2[j];
        if (item1.endLineNumber < item2.startLineNumber - 1) result.push(arr1[i++]);
        else if (item2.endLineNumber < item1.startLineNumber - 1) result.push(arr2[j++]);
        else {
            const startLineNumber = Math.min(item1.startLineNumber, item2.startLineNumber);
            const endLineNumber = Math.max(item1.endLineNumber, item2.endLineNumber);
            result.push(new (0, _rangeJs.Range)(startLineNumber, 1, endLineNumber, 1));
            i++;
            j++;
        }
    }
    while(i < arr1.length)result.push(arr1[i++]);
    while(j < arr2.length)result.push(arr2[j++]);
    return result;
}
function rangeArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(let i = 0; i < arr1.length; i++){
        if (!arr1[i].equalsRange(arr2[i])) return false;
    }
    return true;
}
/**
 * Maintain a stable viewport by trying to keep the first line in the viewport constant.
 */ class StableViewport {
    constructor(viewportStartModelPosition, startLineDelta){
        this.viewportStartModelPosition = viewportStartModelPosition;
        this.startLineDelta = startLineDelta;
    }
    recoverViewportStart(coordinatesConverter, viewLayout) {
        if (!this.viewportStartModelPosition) return;
        const viewPosition = coordinatesConverter.convertModelPositionToViewPosition(this.viewportStartModelPosition);
        const viewPositionTop = viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber);
        viewLayout.setScrollPosition({
            scrollTop: viewPositionTop + this.startLineDelta
        }, 1 /* ScrollType.Immediate */ );
    }
}

},{"../../../base/common/arrays.js":"DECei","../../../base/common/async.js":"4GJc4","../../../base/common/color.js":"at4gb","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/platform.js":"7maJO","../../../base/common/strings.js":"aA9I1","../config/editorOptions.js":"3Xi00","../cursor/cursor.js":"1Esak","../cursorCommon.js":"aKAuR","../core/position.js":"lvrPe","../core/range.js":"jmUPh","../textModelEvents.js":"90evO","../languages.js":"g5n96","../languages/modesRegistry.js":"gqkb7","../languages/textToHtmlTokenizer.js":"je4FM","../viewEvents.js":"9BnMp","../viewLayout/viewLayout.js":"49Y5U","./minimapTokensColorTracker.js":"jCndl","../viewModel.js":"5EHxj","./viewModelDecorations.js":"lGBM0","../viewModelEventDispatcher.js":"5BQnB","./viewModelLines.js":"c6jcx","./glyphLanesModel.js":"dQ8TH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Esak":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CursorsController", ()=>CursorsController);
parcelHelpers.export(exports, "CommandExecutor", ()=>CommandExecutor);
var _errorsJs = require("../../../base/common/errors.js");
var _stringsJs = require("../../../base/common/strings.js");
var _cursorCollectionJs = require("./cursorCollection.js");
var _cursorCommonJs = require("../cursorCommon.js");
var _cursorContextJs = require("./cursorContext.js");
var _cursorDeleteOperationsJs = require("./cursorDeleteOperations.js");
var _cursorTypeOperationsJs = require("./cursorTypeOperations.js");
var _cursorTypeEditOperationsJs = require("./cursorTypeEditOperations.js");
var _rangeJs = require("../core/range.js");
var _selectionJs = require("../core/selection.js");
var _textModelEventsJs = require("../textModelEvents.js");
var _viewEventsJs = require("../viewEvents.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _viewModelEventDispatcherJs = require("../viewModelEventDispatcher.js");
class CursorsController extends (0, _lifecycleJs.Disposable) {
    constructor(model, viewModel, coordinatesConverter, cursorConfig){
        super();
        this._model = model;
        this._knownModelVersionId = this._model.getVersionId();
        this._viewModel = viewModel;
        this._coordinatesConverter = coordinatesConverter;
        this.context = new (0, _cursorContextJs.CursorContext)(this._model, this._viewModel, this._coordinatesConverter, cursorConfig);
        this._cursors = new (0, _cursorCollectionJs.CursorCollection)(this.context);
        this._hasFocus = false;
        this._isHandling = false;
        this._compositionState = null;
        this._columnSelectData = null;
        this._autoClosedActions = [];
        this._prevEditOperationType = 0 /* EditOperationType.Other */ ;
    }
    dispose() {
        this._cursors.dispose();
        this._autoClosedActions = (0, _lifecycleJs.dispose)(this._autoClosedActions);
        super.dispose();
    }
    updateConfiguration(cursorConfig) {
        this.context = new (0, _cursorContextJs.CursorContext)(this._model, this._viewModel, this._coordinatesConverter, cursorConfig);
        this._cursors.updateContext(this.context);
    }
    onLineMappingChanged(eventsCollector) {
        if (this._knownModelVersionId !== this._model.getVersionId()) // There are model change events that I didn't yet receive.
        //
        // This can happen when editing the model, and the view model receives the change events first,
        // and the view model emits line mapping changed events, all before the cursor gets a chance to
        // recover from markers.
        //
        // The model change listener above will be called soon and we'll ensure a valid cursor state there.
        return;
        // Ensure valid state
        this.setStates(eventsCollector, "viewModel", 0 /* CursorChangeReason.NotSet */ , this.getCursorStates());
    }
    setHasFocus(hasFocus) {
        this._hasFocus = hasFocus;
    }
    _validateAutoClosedActions() {
        if (this._autoClosedActions.length > 0) {
            const selections = this._cursors.getSelections();
            for(let i = 0; i < this._autoClosedActions.length; i++){
                const autoClosedAction = this._autoClosedActions[i];
                if (!autoClosedAction.isValid(selections)) {
                    autoClosedAction.dispose();
                    this._autoClosedActions.splice(i, 1);
                    i--;
                }
            }
        }
    }
    // ------ some getters/setters
    getPrimaryCursorState() {
        return this._cursors.getPrimaryCursor();
    }
    getLastAddedCursorIndex() {
        return this._cursors.getLastAddedCursorIndex();
    }
    getCursorStates() {
        return this._cursors.getAll();
    }
    setStates(eventsCollector, source, reason, states) {
        let reachedMaxCursorCount = false;
        const multiCursorLimit = this.context.cursorConfig.multiCursorLimit;
        if (states !== null && states.length > multiCursorLimit) {
            states = states.slice(0, multiCursorLimit);
            reachedMaxCursorCount = true;
        }
        const oldState = CursorModelState.from(this._model, this);
        this._cursors.setStates(states);
        this._cursors.normalize();
        this._columnSelectData = null;
        this._validateAutoClosedActions();
        return this._emitStateChangedIfNecessary(eventsCollector, source, reason, oldState, reachedMaxCursorCount);
    }
    setCursorColumnSelectData(columnSelectData) {
        this._columnSelectData = columnSelectData;
    }
    revealAll(eventsCollector, source, minimalReveal, verticalType, revealHorizontal, scrollType) {
        const viewPositions = this._cursors.getViewPositions();
        let revealViewRange = null;
        let revealViewSelections = null;
        if (viewPositions.length > 1) revealViewSelections = this._cursors.getViewSelections();
        else revealViewRange = (0, _rangeJs.Range).fromPositions(viewPositions[0], viewPositions[0]);
        eventsCollector.emitViewEvent(new (0, _viewEventsJs.ViewRevealRangeRequestEvent)(source, minimalReveal, revealViewRange, revealViewSelections, verticalType, revealHorizontal, scrollType));
    }
    revealPrimary(eventsCollector, source, minimalReveal, verticalType, revealHorizontal, scrollType) {
        const primaryCursor = this._cursors.getPrimaryCursor();
        const revealViewSelections = [
            primaryCursor.viewState.selection
        ];
        eventsCollector.emitViewEvent(new (0, _viewEventsJs.ViewRevealRangeRequestEvent)(source, minimalReveal, null, revealViewSelections, verticalType, revealHorizontal, scrollType));
    }
    saveState() {
        const result = [];
        const selections = this._cursors.getSelections();
        for(let i = 0, len = selections.length; i < len; i++){
            const selection = selections[i];
            result.push({
                inSelectionMode: !selection.isEmpty(),
                selectionStart: {
                    lineNumber: selection.selectionStartLineNumber,
                    column: selection.selectionStartColumn
                },
                position: {
                    lineNumber: selection.positionLineNumber,
                    column: selection.positionColumn
                }
            });
        }
        return result;
    }
    restoreState(eventsCollector, states) {
        const desiredSelections = [];
        for(let i = 0, len = states.length; i < len; i++){
            const state = states[i];
            let positionLineNumber = 1;
            let positionColumn = 1;
            // Avoid missing properties on the literal
            if (state.position && state.position.lineNumber) positionLineNumber = state.position.lineNumber;
            if (state.position && state.position.column) positionColumn = state.position.column;
            let selectionStartLineNumber = positionLineNumber;
            let selectionStartColumn = positionColumn;
            // Avoid missing properties on the literal
            if (state.selectionStart && state.selectionStart.lineNumber) selectionStartLineNumber = state.selectionStart.lineNumber;
            if (state.selectionStart && state.selectionStart.column) selectionStartColumn = state.selectionStart.column;
            desiredSelections.push({
                selectionStartLineNumber: selectionStartLineNumber,
                selectionStartColumn: selectionStartColumn,
                positionLineNumber: positionLineNumber,
                positionColumn: positionColumn
            });
        }
        this.setStates(eventsCollector, "restoreState", 0 /* CursorChangeReason.NotSet */ , (0, _cursorCommonJs.CursorState).fromModelSelections(desiredSelections));
        this.revealAll(eventsCollector, "restoreState", false, 0 /* VerticalRevealType.Simple */ , true, 1 /* editorCommon.ScrollType.Immediate */ );
    }
    onModelContentChanged(eventsCollector, event) {
        if (event instanceof (0, _textModelEventsJs.ModelInjectedTextChangedEvent)) {
            // If injected texts change, the view positions of all cursors need to be updated.
            if (this._isHandling) // The view positions will be updated when handling finishes
            return;
            // setStates might remove markers, which could trigger a decoration change.
            // If there are injected text decorations for that line, `onModelContentChanged` is emitted again
            // and an endless recursion happens.
            // _isHandling prevents that.
            this._isHandling = true;
            try {
                this.setStates(eventsCollector, "modelChange", 0 /* CursorChangeReason.NotSet */ , this.getCursorStates());
            } finally{
                this._isHandling = false;
            }
        } else {
            const e = event.rawContentChangedEvent;
            this._knownModelVersionId = e.versionId;
            if (this._isHandling) return;
            const hadFlushEvent = e.containsEvent(1 /* RawContentChangedType.Flush */ );
            this._prevEditOperationType = 0 /* EditOperationType.Other */ ;
            if (hadFlushEvent) {
                // a model.setValue() was called
                this._cursors.dispose();
                this._cursors = new (0, _cursorCollectionJs.CursorCollection)(this.context);
                this._validateAutoClosedActions();
                this._emitStateChangedIfNecessary(eventsCollector, "model", 1 /* CursorChangeReason.ContentFlush */ , null, false);
            } else if (this._hasFocus && e.resultingSelection && e.resultingSelection.length > 0) {
                const cursorState = (0, _cursorCommonJs.CursorState).fromModelSelections(e.resultingSelection);
                if (this.setStates(eventsCollector, "modelChange", e.isUndoing ? 5 /* CursorChangeReason.Undo */  : e.isRedoing ? 6 /* CursorChangeReason.Redo */  : 2 /* CursorChangeReason.RecoverFromMarkers */ , cursorState)) this.revealAll(eventsCollector, "modelChange", false, 0 /* VerticalRevealType.Simple */ , true, 0 /* editorCommon.ScrollType.Smooth */ );
            } else {
                const selectionsFromMarkers = this._cursors.readSelectionFromMarkers();
                this.setStates(eventsCollector, "modelChange", 2 /* CursorChangeReason.RecoverFromMarkers */ , (0, _cursorCommonJs.CursorState).fromModelSelections(selectionsFromMarkers));
            }
        }
    }
    getSelection() {
        return this._cursors.getPrimaryCursor().modelState.selection;
    }
    getTopMostViewPosition() {
        return this._cursors.getTopMostViewPosition();
    }
    getBottomMostViewPosition() {
        return this._cursors.getBottomMostViewPosition();
    }
    getCursorColumnSelectData() {
        if (this._columnSelectData) return this._columnSelectData;
        const primaryCursor = this._cursors.getPrimaryCursor();
        const viewSelectionStart = primaryCursor.viewState.selectionStart.getStartPosition();
        const viewPosition = primaryCursor.viewState.position;
        return {
            isReal: false,
            fromViewLineNumber: viewSelectionStart.lineNumber,
            fromViewVisualColumn: this.context.cursorConfig.visibleColumnFromColumn(this._viewModel, viewSelectionStart),
            toViewLineNumber: viewPosition.lineNumber,
            toViewVisualColumn: this.context.cursorConfig.visibleColumnFromColumn(this._viewModel, viewPosition)
        };
    }
    getSelections() {
        return this._cursors.getSelections();
    }
    setSelections(eventsCollector, source, selections, reason) {
        this.setStates(eventsCollector, source, reason, (0, _cursorCommonJs.CursorState).fromModelSelections(selections));
    }
    getPrevEditOperationType() {
        return this._prevEditOperationType;
    }
    setPrevEditOperationType(type) {
        this._prevEditOperationType = type;
    }
    // ------ auxiliary handling logic
    _pushAutoClosedAction(autoClosedCharactersRanges, autoClosedEnclosingRanges) {
        const autoClosedCharactersDeltaDecorations = [];
        const autoClosedEnclosingDeltaDecorations = [];
        for(let i = 0, len = autoClosedCharactersRanges.length; i < len; i++){
            autoClosedCharactersDeltaDecorations.push({
                range: autoClosedCharactersRanges[i],
                options: {
                    description: "auto-closed-character",
                    inlineClassName: "auto-closed-character",
                    stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ 
                }
            });
            autoClosedEnclosingDeltaDecorations.push({
                range: autoClosedEnclosingRanges[i],
                options: {
                    description: "auto-closed-enclosing",
                    stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ 
                }
            });
        }
        const autoClosedCharactersDecorations = this._model.deltaDecorations([], autoClosedCharactersDeltaDecorations);
        const autoClosedEnclosingDecorations = this._model.deltaDecorations([], autoClosedEnclosingDeltaDecorations);
        this._autoClosedActions.push(new AutoClosedAction(this._model, autoClosedCharactersDecorations, autoClosedEnclosingDecorations));
    }
    _executeEditOperation(opResult) {
        if (!opResult) // Nothing to execute
        return;
        if (opResult.shouldPushStackElementBefore) this._model.pushStackElement();
        const result = CommandExecutor.executeCommands(this._model, this._cursors.getSelections(), opResult.commands);
        if (result) {
            // The commands were applied correctly
            this._interpretCommandResult(result);
            // Check for auto-closing closed characters
            const autoClosedCharactersRanges = [];
            const autoClosedEnclosingRanges = [];
            for(let i = 0; i < opResult.commands.length; i++){
                const command = opResult.commands[i];
                if (command instanceof (0, _cursorTypeEditOperationsJs.BaseTypeWithAutoClosingCommand) && command.enclosingRange && command.closeCharacterRange) {
                    autoClosedCharactersRanges.push(command.closeCharacterRange);
                    autoClosedEnclosingRanges.push(command.enclosingRange);
                }
            }
            if (autoClosedCharactersRanges.length > 0) this._pushAutoClosedAction(autoClosedCharactersRanges, autoClosedEnclosingRanges);
            this._prevEditOperationType = opResult.type;
        }
        if (opResult.shouldPushStackElementAfter) this._model.pushStackElement();
    }
    _interpretCommandResult(cursorState) {
        if (!cursorState || cursorState.length === 0) cursorState = this._cursors.readSelectionFromMarkers();
        this._columnSelectData = null;
        this._cursors.setSelections(cursorState);
        this._cursors.normalize();
    }
    // -----------------------------------------------------------------------------------------------------------
    // ----- emitting events
    _emitStateChangedIfNecessary(eventsCollector, source, reason, oldState, reachedMaxCursorCount) {
        const newState = CursorModelState.from(this._model, this);
        if (newState.equals(oldState)) return false;
        const selections = this._cursors.getSelections();
        const viewSelections = this._cursors.getViewSelections();
        // Let the view get the event first.
        eventsCollector.emitViewEvent(new (0, _viewEventsJs.ViewCursorStateChangedEvent)(viewSelections, selections, reason));
        // Only after the view has been notified, let the rest of the world know...
        if (!oldState || oldState.cursorState.length !== newState.cursorState.length || newState.cursorState.some((newCursorState, i)=>!newCursorState.modelState.equals(oldState.cursorState[i].modelState))) {
            const oldSelections = oldState ? oldState.cursorState.map((s)=>s.modelState.selection) : null;
            const oldModelVersionId = oldState ? oldState.modelVersionId : 0;
            eventsCollector.emitOutgoingEvent(new (0, _viewModelEventDispatcherJs.CursorStateChangedEvent)(oldSelections, selections, oldModelVersionId, newState.modelVersionId, source || "keyboard", reason, reachedMaxCursorCount));
        }
        return true;
    }
    // -----------------------------------------------------------------------------------------------------------
    // ----- handlers beyond this point
    _findAutoClosingPairs(edits) {
        if (!edits.length) return null;
        const indices = [];
        for(let i = 0, len = edits.length; i < len; i++){
            const edit = edits[i];
            if (!edit.text || edit.text.indexOf("\n") >= 0) return null;
            const m = edit.text.match(/([)\]}>'"`])([^)\]}>'"`]*)$/);
            if (!m) return null;
            const closeChar = m[1];
            const autoClosingPairsCandidates = this.context.cursorConfig.autoClosingPairs.autoClosingPairsCloseSingleChar.get(closeChar);
            if (!autoClosingPairsCandidates || autoClosingPairsCandidates.length !== 1) return null;
            const openChar = autoClosingPairsCandidates[0].open;
            const closeCharIndex = edit.text.length - m[2].length - 1;
            const openCharIndex = edit.text.lastIndexOf(openChar, closeCharIndex - 1);
            if (openCharIndex === -1) return null;
            indices.push([
                openCharIndex,
                closeCharIndex
            ]);
        }
        return indices;
    }
    executeEdits(eventsCollector, source, edits, cursorStateComputer) {
        let autoClosingIndices = null;
        if (source === "snippet") autoClosingIndices = this._findAutoClosingPairs(edits);
        if (autoClosingIndices) edits[0]._isTracked = true;
        const autoClosedCharactersRanges = [];
        const autoClosedEnclosingRanges = [];
        const selections = this._model.pushEditOperations(this.getSelections(), edits, (undoEdits)=>{
            if (autoClosingIndices) for(let i = 0, len = autoClosingIndices.length; i < len; i++){
                const [openCharInnerIndex, closeCharInnerIndex] = autoClosingIndices[i];
                const undoEdit = undoEdits[i];
                const lineNumber = undoEdit.range.startLineNumber;
                const openCharIndex = undoEdit.range.startColumn - 1 + openCharInnerIndex;
                const closeCharIndex = undoEdit.range.startColumn - 1 + closeCharInnerIndex;
                autoClosedCharactersRanges.push(new (0, _rangeJs.Range)(lineNumber, closeCharIndex + 1, lineNumber, closeCharIndex + 2));
                autoClosedEnclosingRanges.push(new (0, _rangeJs.Range)(lineNumber, openCharIndex + 1, lineNumber, closeCharIndex + 2));
            }
            const selections = cursorStateComputer(undoEdits);
            if (selections) // Don't recover the selection from markers because
            // we know what it should be.
            this._isHandling = true;
            return selections;
        });
        if (selections) {
            this._isHandling = false;
            this.setSelections(eventsCollector, source, selections, 0 /* CursorChangeReason.NotSet */ );
        }
        if (autoClosedCharactersRanges.length > 0) this._pushAutoClosedAction(autoClosedCharactersRanges, autoClosedEnclosingRanges);
    }
    _executeEdit(callback, eventsCollector, source, cursorChangeReason = 0 /* CursorChangeReason.NotSet */ ) {
        if (this.context.cursorConfig.readOnly) // we cannot edit when read only...
        return;
        const oldState = CursorModelState.from(this._model, this);
        this._cursors.stopTrackingSelections();
        this._isHandling = true;
        try {
            this._cursors.ensureValidState();
            callback();
        } catch (err) {
            (0, _errorsJs.onUnexpectedError)(err);
        }
        this._isHandling = false;
        this._cursors.startTrackingSelections();
        this._validateAutoClosedActions();
        if (this._emitStateChangedIfNecessary(eventsCollector, source, cursorChangeReason, oldState, false)) this.revealAll(eventsCollector, source, false, 0 /* VerticalRevealType.Simple */ , true, 0 /* editorCommon.ScrollType.Smooth */ );
    }
    getAutoClosedCharacters() {
        return AutoClosedAction.getAllAutoClosedCharacters(this._autoClosedActions);
    }
    startComposition(eventsCollector) {
        this._compositionState = new CompositionState(this._model, this.getSelections());
    }
    endComposition(eventsCollector, source) {
        const compositionOutcome = this._compositionState ? this._compositionState.deduceOutcome(this._model, this.getSelections()) : null;
        this._compositionState = null;
        this._executeEdit(()=>{
            if (source === "keyboard") // composition finishes, let's check if we need to auto complete if necessary.
            this._executeEditOperation((0, _cursorTypeOperationsJs.TypeOperations).compositionEndWithInterceptors(this._prevEditOperationType, this.context.cursorConfig, this._model, compositionOutcome, this.getSelections(), this.getAutoClosedCharacters()));
        }, eventsCollector, source);
    }
    type(eventsCollector, text, source) {
        this._executeEdit(()=>{
            if (source === "keyboard") {
                // If this event is coming straight from the keyboard, look for electric characters and enter
                const len = text.length;
                let offset = 0;
                while(offset < len){
                    const charLength = _stringsJs.nextCharLength(text, offset);
                    const chr = text.substr(offset, charLength);
                    // Here we must interpret each typed character individually
                    this._executeEditOperation((0, _cursorTypeOperationsJs.TypeOperations).typeWithInterceptors(!!this._compositionState, this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), this.getAutoClosedCharacters(), chr));
                    offset += charLength;
                }
            } else this._executeEditOperation((0, _cursorTypeOperationsJs.TypeOperations).typeWithoutInterceptors(this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), text));
        }, eventsCollector, source);
    }
    compositionType(eventsCollector, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta, source) {
        if (text.length === 0 && replacePrevCharCnt === 0 && replaceNextCharCnt === 0) {
            // this edit is a no-op
            if (positionDelta !== 0) {
                // but it still wants to move the cursor
                const newSelections = this.getSelections().map((selection)=>{
                    const position = selection.getPosition();
                    return new (0, _selectionJs.Selection)(position.lineNumber, position.column + positionDelta, position.lineNumber, position.column + positionDelta);
                });
                this.setSelections(eventsCollector, source, newSelections, 0 /* CursorChangeReason.NotSet */ );
            }
            return;
        }
        this._executeEdit(()=>{
            this._executeEditOperation((0, _cursorTypeOperationsJs.TypeOperations).compositionType(this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), text, replacePrevCharCnt, replaceNextCharCnt, positionDelta));
        }, eventsCollector, source);
    }
    paste(eventsCollector, text, pasteOnNewLine, multicursorText, source) {
        this._executeEdit(()=>{
            this._executeEditOperation((0, _cursorTypeOperationsJs.TypeOperations).paste(this.context.cursorConfig, this._model, this.getSelections(), text, pasteOnNewLine, multicursorText || []));
        }, eventsCollector, source, 4 /* CursorChangeReason.Paste */ );
    }
    cut(eventsCollector, source) {
        this._executeEdit(()=>{
            this._executeEditOperation((0, _cursorDeleteOperationsJs.DeleteOperations).cut(this.context.cursorConfig, this._model, this.getSelections()));
        }, eventsCollector, source);
    }
    executeCommand(eventsCollector, command, source) {
        this._executeEdit(()=>{
            this._cursors.killSecondaryCursors();
            this._executeEditOperation(new (0, _cursorCommonJs.EditOperationResult)(0 /* EditOperationType.Other */ , [
                command
            ], {
                shouldPushStackElementBefore: false,
                shouldPushStackElementAfter: false
            }));
        }, eventsCollector, source);
    }
    executeCommands(eventsCollector, commands, source) {
        this._executeEdit(()=>{
            this._executeEditOperation(new (0, _cursorCommonJs.EditOperationResult)(0 /* EditOperationType.Other */ , commands, {
                shouldPushStackElementBefore: false,
                shouldPushStackElementAfter: false
            }));
        }, eventsCollector, source);
    }
}
/**
 * A snapshot of the cursor and the model state
 */ class CursorModelState {
    static from(model, cursor) {
        return new CursorModelState(model.getVersionId(), cursor.getCursorStates());
    }
    constructor(modelVersionId, cursorState){
        this.modelVersionId = modelVersionId;
        this.cursorState = cursorState;
    }
    equals(other) {
        if (!other) return false;
        if (this.modelVersionId !== other.modelVersionId) return false;
        if (this.cursorState.length !== other.cursorState.length) return false;
        for(let i = 0, len = this.cursorState.length; i < len; i++){
            if (!this.cursorState[i].equals(other.cursorState[i])) return false;
        }
        return true;
    }
}
class AutoClosedAction {
    static getAllAutoClosedCharacters(autoClosedActions) {
        let autoClosedCharacters = [];
        for (const autoClosedAction of autoClosedActions)autoClosedCharacters = autoClosedCharacters.concat(autoClosedAction.getAutoClosedCharactersRanges());
        return autoClosedCharacters;
    }
    constructor(model, autoClosedCharactersDecorations, autoClosedEnclosingDecorations){
        this._model = model;
        this._autoClosedCharactersDecorations = autoClosedCharactersDecorations;
        this._autoClosedEnclosingDecorations = autoClosedEnclosingDecorations;
    }
    dispose() {
        this._autoClosedCharactersDecorations = this._model.deltaDecorations(this._autoClosedCharactersDecorations, []);
        this._autoClosedEnclosingDecorations = this._model.deltaDecorations(this._autoClosedEnclosingDecorations, []);
    }
    getAutoClosedCharactersRanges() {
        const result = [];
        for(let i = 0; i < this._autoClosedCharactersDecorations.length; i++){
            const decorationRange = this._model.getDecorationRange(this._autoClosedCharactersDecorations[i]);
            if (decorationRange) result.push(decorationRange);
        }
        return result;
    }
    isValid(selections) {
        const enclosingRanges = [];
        for(let i = 0; i < this._autoClosedEnclosingDecorations.length; i++){
            const decorationRange = this._model.getDecorationRange(this._autoClosedEnclosingDecorations[i]);
            if (decorationRange) {
                enclosingRanges.push(decorationRange);
                if (decorationRange.startLineNumber !== decorationRange.endLineNumber) // Stop tracking if the range becomes multiline...
                return false;
            }
        }
        enclosingRanges.sort((0, _rangeJs.Range).compareRangesUsingStarts);
        selections.sort((0, _rangeJs.Range).compareRangesUsingStarts);
        for(let i = 0; i < selections.length; i++){
            if (i >= enclosingRanges.length) return false;
            if (!enclosingRanges[i].strictContainsRange(selections[i])) return false;
        }
        return true;
    }
}
class CommandExecutor {
    static executeCommands(model, selectionsBefore, commands) {
        const ctx = {
            model: model,
            selectionsBefore: selectionsBefore,
            trackedRanges: [],
            trackedRangesDirection: []
        };
        const result = this._innerExecuteCommands(ctx, commands);
        for(let i = 0, len = ctx.trackedRanges.length; i < len; i++)ctx.model._setTrackedRange(ctx.trackedRanges[i], null, 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ );
        return result;
    }
    static _innerExecuteCommands(ctx, commands) {
        if (this._arrayIsEmpty(commands)) return null;
        const commandsData = this._getEditOperations(ctx, commands);
        if (commandsData.operations.length === 0) return null;
        const rawOperations = commandsData.operations;
        const loserCursorsMap = this._getLoserCursorMap(rawOperations);
        if (loserCursorsMap.hasOwnProperty("0")) {
            // These commands are very messed up
            console.warn("Ignoring commands");
            return null;
        }
        // Remove operations belonging to losing cursors
        const filteredOperations = [];
        for(let i = 0, len = rawOperations.length; i < len; i++)if (!loserCursorsMap.hasOwnProperty(rawOperations[i].identifier.major.toString())) filteredOperations.push(rawOperations[i]);
        // TODO@Alex: find a better way to do this.
        // give the hint that edit operations are tracked to the model
        if (commandsData.hadTrackedEditOperation && filteredOperations.length > 0) filteredOperations[0]._isTracked = true;
        let selectionsAfter = ctx.model.pushEditOperations(ctx.selectionsBefore, filteredOperations, (inverseEditOperations)=>{
            const groupedInverseEditOperations = [];
            for(let i = 0; i < ctx.selectionsBefore.length; i++)groupedInverseEditOperations[i] = [];
            for (const op of inverseEditOperations){
                if (!op.identifier) continue;
                groupedInverseEditOperations[op.identifier.major].push(op);
            }
            const minorBasedSorter = (a, b)=>{
                return a.identifier.minor - b.identifier.minor;
            };
            const cursorSelections = [];
            for(let i = 0; i < ctx.selectionsBefore.length; i++)if (groupedInverseEditOperations[i].length > 0) {
                groupedInverseEditOperations[i].sort(minorBasedSorter);
                cursorSelections[i] = commands[i].computeCursorState(ctx.model, {
                    getInverseEditOperations: ()=>{
                        return groupedInverseEditOperations[i];
                    },
                    getTrackedSelection: (id)=>{
                        const idx = parseInt(id, 10);
                        const range = ctx.model._getTrackedRange(ctx.trackedRanges[idx]);
                        if (ctx.trackedRangesDirection[idx] === 0 /* SelectionDirection.LTR */ ) return new (0, _selectionJs.Selection)(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
                        return new (0, _selectionJs.Selection)(range.endLineNumber, range.endColumn, range.startLineNumber, range.startColumn);
                    }
                });
            } else cursorSelections[i] = ctx.selectionsBefore[i];
            return cursorSelections;
        });
        if (!selectionsAfter) selectionsAfter = ctx.selectionsBefore;
        // Extract losing cursors
        const losingCursors = [];
        for(const losingCursorIndex in loserCursorsMap)if (loserCursorsMap.hasOwnProperty(losingCursorIndex)) losingCursors.push(parseInt(losingCursorIndex, 10));
        // Sort losing cursors descending
        losingCursors.sort((a, b)=>{
            return b - a;
        });
        // Remove losing cursors
        for (const losingCursor of losingCursors)selectionsAfter.splice(losingCursor, 1);
        return selectionsAfter;
    }
    static _arrayIsEmpty(commands) {
        for(let i = 0, len = commands.length; i < len; i++){
            if (commands[i]) return false;
        }
        return true;
    }
    static _getEditOperations(ctx, commands) {
        let operations = [];
        let hadTrackedEditOperation = false;
        for(let i = 0, len = commands.length; i < len; i++){
            const command = commands[i];
            if (command) {
                const r = this._getEditOperationsFromCommand(ctx, i, command);
                operations = operations.concat(r.operations);
                hadTrackedEditOperation = hadTrackedEditOperation || r.hadTrackedEditOperation;
            }
        }
        return {
            operations: operations,
            hadTrackedEditOperation: hadTrackedEditOperation
        };
    }
    static _getEditOperationsFromCommand(ctx, majorIdentifier, command) {
        // This method acts as a transaction, if the command fails
        // everything it has done is ignored
        const operations = [];
        let operationMinor = 0;
        const addEditOperation = (range, text, forceMoveMarkers = false)=>{
            if ((0, _rangeJs.Range).isEmpty(range) && text === "") // This command wants to add a no-op => no thank you
            return;
            operations.push({
                identifier: {
                    major: majorIdentifier,
                    minor: operationMinor++
                },
                range: range,
                text: text,
                forceMoveMarkers: forceMoveMarkers,
                isAutoWhitespaceEdit: command.insertsAutoWhitespace
            });
        };
        let hadTrackedEditOperation = false;
        const addTrackedEditOperation = (selection, text, forceMoveMarkers)=>{
            hadTrackedEditOperation = true;
            addEditOperation(selection, text, forceMoveMarkers);
        };
        const trackSelection = (_selection, trackPreviousOnEmpty)=>{
            const selection = (0, _selectionJs.Selection).liftSelection(_selection);
            let stickiness;
            if (selection.isEmpty()) {
                if (typeof trackPreviousOnEmpty === "boolean") {
                    if (trackPreviousOnEmpty) stickiness = 2 /* TrackedRangeStickiness.GrowsOnlyWhenTypingBefore */ ;
                    else stickiness = 3 /* TrackedRangeStickiness.GrowsOnlyWhenTypingAfter */ ;
                } else {
                    // Try to lock it with surrounding text
                    const maxLineColumn = ctx.model.getLineMaxColumn(selection.startLineNumber);
                    if (selection.startColumn === maxLineColumn) stickiness = 2 /* TrackedRangeStickiness.GrowsOnlyWhenTypingBefore */ ;
                    else stickiness = 3 /* TrackedRangeStickiness.GrowsOnlyWhenTypingAfter */ ;
                }
            } else stickiness = 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ;
            const l = ctx.trackedRanges.length;
            const id = ctx.model._setTrackedRange(null, selection, stickiness);
            ctx.trackedRanges[l] = id;
            ctx.trackedRangesDirection[l] = selection.getDirection();
            return l.toString();
        };
        const editOperationBuilder = {
            addEditOperation: addEditOperation,
            addTrackedEditOperation: addTrackedEditOperation,
            trackSelection: trackSelection
        };
        try {
            command.getEditOperations(ctx.model, editOperationBuilder);
        } catch (e) {
            // TODO@Alex use notification service if this should be user facing
            // e.friendlyMessage = nls.localize('corrupt.commands', "Unexpected exception while executing command.");
            (0, _errorsJs.onUnexpectedError)(e);
            return {
                operations: [],
                hadTrackedEditOperation: false
            };
        }
        return {
            operations: operations,
            hadTrackedEditOperation: hadTrackedEditOperation
        };
    }
    static _getLoserCursorMap(operations) {
        // This is destructive on the array
        operations = operations.slice(0);
        // Sort operations with last one first
        operations.sort((a, b)=>{
            // Note the minus!
            return -(0, _rangeJs.Range).compareRangesUsingEnds(a.range, b.range);
        });
        // Operations can not overlap!
        const loserCursorsMap = {};
        for(let i = 1; i < operations.length; i++){
            const previousOp = operations[i - 1];
            const currentOp = operations[i];
            if ((0, _rangeJs.Range).getStartPosition(previousOp.range).isBefore((0, _rangeJs.Range).getEndPosition(currentOp.range))) {
                let loserMajor;
                if (previousOp.identifier.major > currentOp.identifier.major) // previousOp loses the battle
                loserMajor = previousOp.identifier.major;
                else loserMajor = currentOp.identifier.major;
                loserCursorsMap[loserMajor.toString()] = true;
                for(let j = 0; j < operations.length; j++)if (operations[j].identifier.major === loserMajor) {
                    operations.splice(j, 1);
                    if (j < i) i--;
                    j--;
                }
                if (i > 0) i--;
            }
        }
        return loserCursorsMap;
    }
}
class CompositionLineState {
    constructor(text, startSelection, endSelection){
        this.text = text;
        this.startSelection = startSelection;
        this.endSelection = endSelection;
    }
}
class CompositionState {
    static _capture(textModel, selections) {
        const result = [];
        for (const selection of selections){
            if (selection.startLineNumber !== selection.endLineNumber) return null;
            result.push(new CompositionLineState(textModel.getLineContent(selection.startLineNumber), selection.startColumn - 1, selection.endColumn - 1));
        }
        return result;
    }
    constructor(textModel, selections){
        this._original = CompositionState._capture(textModel, selections);
    }
    /**
     * Returns the inserted text during this composition.
     * If the composition resulted in existing text being changed (i.e. not a pure insertion) it returns null.
     */ deduceOutcome(textModel, selections) {
        if (!this._original) return null;
        const current = CompositionState._capture(textModel, selections);
        if (!current) return null;
        if (this._original.length !== current.length) return null;
        const result = [];
        for(let i = 0, len = this._original.length; i < len; i++)result.push(CompositionState._deduceOutcome(this._original[i], current[i]));
        return result;
    }
    static _deduceOutcome(original, current) {
        const commonPrefix = Math.min(original.startSelection, current.startSelection, _stringsJs.commonPrefixLength(original.text, current.text));
        const commonSuffix = Math.min(original.text.length - original.endSelection, current.text.length - current.endSelection, _stringsJs.commonSuffixLength(original.text, current.text));
        const deletedText = original.text.substring(commonPrefix, original.text.length - commonSuffix);
        const insertedText = current.text.substring(commonPrefix, current.text.length - commonSuffix);
        return new (0, _cursorTypeOperationsJs.CompositionOutcome)(deletedText, original.startSelection - commonPrefix, original.endSelection - commonPrefix, insertedText, current.startSelection - commonPrefix, current.endSelection - commonPrefix);
    }
}

},{"../../../base/common/errors.js":"divX8","../../../base/common/strings.js":"aA9I1","./cursorCollection.js":"2B9gk","../cursorCommon.js":"aKAuR","./cursorContext.js":"aNFcN","./cursorDeleteOperations.js":"kHqWV","./cursorTypeOperations.js":"8iSM3","./cursorTypeEditOperations.js":"iMjJX","../core/range.js":"jmUPh","../core/selection.js":"kcwzU","../textModelEvents.js":"90evO","../viewEvents.js":"9BnMp","../../../base/common/lifecycle.js":"9kg8d","../viewModelEventDispatcher.js":"5BQnB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2B9gk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CursorCollection", ()=>CursorCollection);
var _arraysJs = require("../../../base/common/arrays.js");
var _arraysFindJs = require("../../../base/common/arraysFind.js");
var _cursorCommonJs = require("../cursorCommon.js");
var _oneCursorJs = require("./oneCursor.js");
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
var _selectionJs = require("../core/selection.js");
class CursorCollection {
    constructor(context){
        this.context = context;
        this.cursors = [
            new (0, _oneCursorJs.Cursor)(context)
        ];
        this.lastAddedCursorIndex = 0;
    }
    dispose() {
        for (const cursor of this.cursors)cursor.dispose(this.context);
    }
    startTrackingSelections() {
        for (const cursor of this.cursors)cursor.startTrackingSelection(this.context);
    }
    stopTrackingSelections() {
        for (const cursor of this.cursors)cursor.stopTrackingSelection(this.context);
    }
    updateContext(context) {
        this.context = context;
    }
    ensureValidState() {
        for (const cursor of this.cursors)cursor.ensureValidState(this.context);
    }
    readSelectionFromMarkers() {
        return this.cursors.map((c)=>c.readSelectionFromMarkers(this.context));
    }
    getAll() {
        return this.cursors.map((c)=>c.asCursorState());
    }
    getViewPositions() {
        return this.cursors.map((c)=>c.viewState.position);
    }
    getTopMostViewPosition() {
        return (0, _arraysFindJs.findFirstMin)(this.cursors, (0, _arraysJs.compareBy)((c)=>c.viewState.position, (0, _positionJs.Position).compare)).viewState.position;
    }
    getBottomMostViewPosition() {
        return (0, _arraysFindJs.findLastMax)(this.cursors, (0, _arraysJs.compareBy)((c)=>c.viewState.position, (0, _positionJs.Position).compare)).viewState.position;
    }
    getSelections() {
        return this.cursors.map((c)=>c.modelState.selection);
    }
    getViewSelections() {
        return this.cursors.map((c)=>c.viewState.selection);
    }
    setSelections(selections) {
        this.setStates((0, _cursorCommonJs.CursorState).fromModelSelections(selections));
    }
    getPrimaryCursor() {
        return this.cursors[0].asCursorState();
    }
    setStates(states) {
        if (states === null) return;
        this.cursors[0].setState(this.context, states[0].modelState, states[0].viewState);
        this._setSecondaryStates(states.slice(1));
    }
    /**
     * Creates or disposes secondary cursors as necessary to match the number of `secondarySelections`.
     */ _setSecondaryStates(secondaryStates) {
        const secondaryCursorsLength = this.cursors.length - 1;
        const secondaryStatesLength = secondaryStates.length;
        if (secondaryCursorsLength < secondaryStatesLength) {
            const createCnt = secondaryStatesLength - secondaryCursorsLength;
            for(let i = 0; i < createCnt; i++)this._addSecondaryCursor();
        } else if (secondaryCursorsLength > secondaryStatesLength) {
            const removeCnt = secondaryCursorsLength - secondaryStatesLength;
            for(let i = 0; i < removeCnt; i++)this._removeSecondaryCursor(this.cursors.length - 2);
        }
        for(let i = 0; i < secondaryStatesLength; i++)this.cursors[i + 1].setState(this.context, secondaryStates[i].modelState, secondaryStates[i].viewState);
    }
    killSecondaryCursors() {
        this._setSecondaryStates([]);
    }
    _addSecondaryCursor() {
        this.cursors.push(new (0, _oneCursorJs.Cursor)(this.context));
        this.lastAddedCursorIndex = this.cursors.length - 1;
    }
    getLastAddedCursorIndex() {
        if (this.cursors.length === 1 || this.lastAddedCursorIndex === 0) return 0;
        return this.lastAddedCursorIndex;
    }
    _removeSecondaryCursor(removeIndex) {
        if (this.lastAddedCursorIndex >= removeIndex + 1) this.lastAddedCursorIndex--;
        this.cursors[removeIndex + 1].dispose(this.context);
        this.cursors.splice(removeIndex + 1, 1);
    }
    normalize() {
        if (this.cursors.length === 1) return;
        const cursors = this.cursors.slice(0);
        const sortedCursors = [];
        for(let i = 0, len = cursors.length; i < len; i++)sortedCursors.push({
            index: i,
            selection: cursors[i].modelState.selection
        });
        sortedCursors.sort((0, _arraysJs.compareBy)((s)=>s.selection, (0, _rangeJs.Range).compareRangesUsingStarts));
        for(let sortedCursorIndex = 0; sortedCursorIndex < sortedCursors.length - 1; sortedCursorIndex++){
            const current = sortedCursors[sortedCursorIndex];
            const next = sortedCursors[sortedCursorIndex + 1];
            const currentSelection = current.selection;
            const nextSelection = next.selection;
            if (!this.context.cursorConfig.multiCursorMergeOverlapping) continue;
            let shouldMergeCursors;
            if (nextSelection.isEmpty() || currentSelection.isEmpty()) // Merge touching cursors if one of them is collapsed
            shouldMergeCursors = nextSelection.getStartPosition().isBeforeOrEqual(currentSelection.getEndPosition());
            else // Merge only overlapping cursors (i.e. allow touching ranges)
            shouldMergeCursors = nextSelection.getStartPosition().isBefore(currentSelection.getEndPosition());
            if (shouldMergeCursors) {
                const winnerSortedCursorIndex = current.index < next.index ? sortedCursorIndex : sortedCursorIndex + 1;
                const looserSortedCursorIndex = current.index < next.index ? sortedCursorIndex + 1 : sortedCursorIndex;
                const looserIndex = sortedCursors[looserSortedCursorIndex].index;
                const winnerIndex = sortedCursors[winnerSortedCursorIndex].index;
                const looserSelection = sortedCursors[looserSortedCursorIndex].selection;
                const winnerSelection = sortedCursors[winnerSortedCursorIndex].selection;
                if (!looserSelection.equalsSelection(winnerSelection)) {
                    const resultingRange = looserSelection.plusRange(winnerSelection);
                    const looserSelectionIsLTR = looserSelection.selectionStartLineNumber === looserSelection.startLineNumber && looserSelection.selectionStartColumn === looserSelection.startColumn;
                    const winnerSelectionIsLTR = winnerSelection.selectionStartLineNumber === winnerSelection.startLineNumber && winnerSelection.selectionStartColumn === winnerSelection.startColumn;
                    // Give more importance to the last added cursor (think Ctrl-dragging + hitting another cursor)
                    let resultingSelectionIsLTR;
                    if (looserIndex === this.lastAddedCursorIndex) {
                        resultingSelectionIsLTR = looserSelectionIsLTR;
                        this.lastAddedCursorIndex = winnerIndex;
                    } else // Winner takes it all
                    resultingSelectionIsLTR = winnerSelectionIsLTR;
                    let resultingSelection;
                    if (resultingSelectionIsLTR) resultingSelection = new (0, _selectionJs.Selection)(resultingRange.startLineNumber, resultingRange.startColumn, resultingRange.endLineNumber, resultingRange.endColumn);
                    else resultingSelection = new (0, _selectionJs.Selection)(resultingRange.endLineNumber, resultingRange.endColumn, resultingRange.startLineNumber, resultingRange.startColumn);
                    sortedCursors[winnerSortedCursorIndex].selection = resultingSelection;
                    const resultingState = (0, _cursorCommonJs.CursorState).fromModelSelection(resultingSelection);
                    cursors[winnerIndex].setState(this.context, resultingState.modelState, resultingState.viewState);
                }
                for (const sortedCursor of sortedCursors)if (sortedCursor.index > looserIndex) sortedCursor.index--;
                cursors.splice(looserIndex, 1);
                sortedCursors.splice(looserSortedCursorIndex, 1);
                this._removeSecondaryCursor(looserIndex - 1);
                sortedCursorIndex--;
            }
        }
    }
}

},{"../../../base/common/arrays.js":"DECei","../../../base/common/arraysFind.js":"gWrU0","../cursorCommon.js":"aKAuR","./oneCursor.js":"6EBdE","../core/position.js":"lvrPe","../core/range.js":"jmUPh","../core/selection.js":"kcwzU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6EBdE":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a single cursor.
*/ parcelHelpers.export(exports, "Cursor", ()=>Cursor);
var _cursorCommonJs = require("../cursorCommon.js");
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
var _selectionJs = require("../core/selection.js");
class Cursor {
    constructor(context){
        this._selTrackedRange = null;
        this._trackSelection = true;
        this._setState(context, new (0, _cursorCommonJs.SingleCursorState)(new (0, _rangeJs.Range)(1, 1, 1, 1), 0 /* SelectionStartKind.Simple */ , 0, new (0, _positionJs.Position)(1, 1), 0), new (0, _cursorCommonJs.SingleCursorState)(new (0, _rangeJs.Range)(1, 1, 1, 1), 0 /* SelectionStartKind.Simple */ , 0, new (0, _positionJs.Position)(1, 1), 0));
    }
    dispose(context) {
        this._removeTrackedRange(context);
    }
    startTrackingSelection(context) {
        this._trackSelection = true;
        this._updateTrackedRange(context);
    }
    stopTrackingSelection(context) {
        this._trackSelection = false;
        this._removeTrackedRange(context);
    }
    _updateTrackedRange(context) {
        if (!this._trackSelection) // don't track the selection
        return;
        this._selTrackedRange = context.model._setTrackedRange(this._selTrackedRange, this.modelState.selection, 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ );
    }
    _removeTrackedRange(context) {
        this._selTrackedRange = context.model._setTrackedRange(this._selTrackedRange, null, 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ );
    }
    asCursorState() {
        return new (0, _cursorCommonJs.CursorState)(this.modelState, this.viewState);
    }
    readSelectionFromMarkers(context) {
        const range = context.model._getTrackedRange(this._selTrackedRange);
        if (this.modelState.selection.isEmpty() && !range.isEmpty()) // Avoid selecting text when recovering from markers
        return (0, _selectionJs.Selection).fromRange(range.collapseToEnd(), this.modelState.selection.getDirection());
        return (0, _selectionJs.Selection).fromRange(range, this.modelState.selection.getDirection());
    }
    ensureValidState(context) {
        this._setState(context, this.modelState, this.viewState);
    }
    setState(context, modelState, viewState) {
        this._setState(context, modelState, viewState);
    }
    static _validatePositionWithCache(viewModel, position, cacheInput, cacheOutput) {
        if (position.equals(cacheInput)) return cacheOutput;
        return viewModel.normalizePosition(position, 2 /* PositionAffinity.None */ );
    }
    static _validateViewState(viewModel, viewState) {
        const position = viewState.position;
        const sStartPosition = viewState.selectionStart.getStartPosition();
        const sEndPosition = viewState.selectionStart.getEndPosition();
        const validPosition = viewModel.normalizePosition(position, 2 /* PositionAffinity.None */ );
        const validSStartPosition = this._validatePositionWithCache(viewModel, sStartPosition, position, validPosition);
        const validSEndPosition = this._validatePositionWithCache(viewModel, sEndPosition, sStartPosition, validSStartPosition);
        if (position.equals(validPosition) && sStartPosition.equals(validSStartPosition) && sEndPosition.equals(validSEndPosition)) // fast path: the state is valid
        return viewState;
        return new (0, _cursorCommonJs.SingleCursorState)((0, _rangeJs.Range).fromPositions(validSStartPosition, validSEndPosition), viewState.selectionStartKind, viewState.selectionStartLeftoverVisibleColumns + sStartPosition.column - validSStartPosition.column, validPosition, viewState.leftoverVisibleColumns + position.column - validPosition.column);
    }
    _setState(context, modelState, viewState) {
        if (viewState) viewState = Cursor._validateViewState(context.viewModel, viewState);
        if (!modelState) {
            if (!viewState) return;
            // We only have the view state => compute the model state
            const selectionStart = context.model.validateRange(context.coordinatesConverter.convertViewRangeToModelRange(viewState.selectionStart));
            const position = context.model.validatePosition(context.coordinatesConverter.convertViewPositionToModelPosition(viewState.position));
            modelState = new (0, _cursorCommonJs.SingleCursorState)(selectionStart, viewState.selectionStartKind, viewState.selectionStartLeftoverVisibleColumns, position, viewState.leftoverVisibleColumns);
        } else {
            // Validate new model state
            const selectionStart = context.model.validateRange(modelState.selectionStart);
            const selectionStartLeftoverVisibleColumns = modelState.selectionStart.equalsRange(selectionStart) ? modelState.selectionStartLeftoverVisibleColumns : 0;
            const position = context.model.validatePosition(modelState.position);
            const leftoverVisibleColumns = modelState.position.equals(position) ? modelState.leftoverVisibleColumns : 0;
            modelState = new (0, _cursorCommonJs.SingleCursorState)(selectionStart, modelState.selectionStartKind, selectionStartLeftoverVisibleColumns, position, leftoverVisibleColumns);
        }
        if (!viewState) {
            // We only have the model state => compute the view state
            const viewSelectionStart1 = context.coordinatesConverter.convertModelPositionToViewPosition(new (0, _positionJs.Position)(modelState.selectionStart.startLineNumber, modelState.selectionStart.startColumn));
            const viewSelectionStart2 = context.coordinatesConverter.convertModelPositionToViewPosition(new (0, _positionJs.Position)(modelState.selectionStart.endLineNumber, modelState.selectionStart.endColumn));
            const viewSelectionStart = new (0, _rangeJs.Range)(viewSelectionStart1.lineNumber, viewSelectionStart1.column, viewSelectionStart2.lineNumber, viewSelectionStart2.column);
            const viewPosition = context.coordinatesConverter.convertModelPositionToViewPosition(modelState.position);
            viewState = new (0, _cursorCommonJs.SingleCursorState)(viewSelectionStart, modelState.selectionStartKind, modelState.selectionStartLeftoverVisibleColumns, viewPosition, modelState.leftoverVisibleColumns);
        } else {
            // Validate new view state
            const viewSelectionStart = context.coordinatesConverter.validateViewRange(viewState.selectionStart, modelState.selectionStart);
            const viewPosition = context.coordinatesConverter.validateViewPosition(viewState.position, modelState.position);
            viewState = new (0, _cursorCommonJs.SingleCursorState)(viewSelectionStart, modelState.selectionStartKind, modelState.selectionStartLeftoverVisibleColumns, viewPosition, modelState.leftoverVisibleColumns);
        }
        this.modelState = modelState;
        this.viewState = viewState;
        this._updateTrackedRange(context);
    }
}

},{"../cursorCommon.js":"aKAuR","../core/position.js":"lvrPe","../core/range.js":"jmUPh","../core/selection.js":"kcwzU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aNFcN":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CursorContext", ()=>CursorContext);
class CursorContext {
    constructor(model, viewModel, coordinatesConverter, cursorConfig){
        this._cursorContextBrand = undefined;
        this.model = model;
        this.viewModel = viewModel;
        this.coordinatesConverter = coordinatesConverter;
        this.cursorConfig = cursorConfig;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9BnMp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewCompositionStartEvent", ()=>ViewCompositionStartEvent);
parcelHelpers.export(exports, "ViewCompositionEndEvent", ()=>ViewCompositionEndEvent);
parcelHelpers.export(exports, "ViewConfigurationChangedEvent", ()=>ViewConfigurationChangedEvent);
parcelHelpers.export(exports, "ViewCursorStateChangedEvent", ()=>ViewCursorStateChangedEvent);
parcelHelpers.export(exports, "ViewDecorationsChangedEvent", ()=>ViewDecorationsChangedEvent);
parcelHelpers.export(exports, "ViewFlushedEvent", ()=>ViewFlushedEvent);
parcelHelpers.export(exports, "ViewFocusChangedEvent", ()=>ViewFocusChangedEvent);
parcelHelpers.export(exports, "ViewLanguageConfigurationEvent", ()=>ViewLanguageConfigurationEvent);
parcelHelpers.export(exports, "ViewLineMappingChangedEvent", ()=>ViewLineMappingChangedEvent);
parcelHelpers.export(exports, "ViewLinesChangedEvent", ()=>ViewLinesChangedEvent);
parcelHelpers.export(exports, "ViewLinesDeletedEvent", ()=>ViewLinesDeletedEvent);
parcelHelpers.export(exports, "ViewLinesInsertedEvent", ()=>ViewLinesInsertedEvent);
parcelHelpers.export(exports, "ViewRevealRangeRequestEvent", ()=>ViewRevealRangeRequestEvent);
parcelHelpers.export(exports, "ViewScrollChangedEvent", ()=>ViewScrollChangedEvent);
parcelHelpers.export(exports, "ViewThemeChangedEvent", ()=>ViewThemeChangedEvent);
parcelHelpers.export(exports, "ViewTokensChangedEvent", ()=>ViewTokensChangedEvent);
parcelHelpers.export(exports, "ViewTokensColorsChangedEvent", ()=>ViewTokensColorsChangedEvent);
parcelHelpers.export(exports, "ViewZonesChangedEvent", ()=>ViewZonesChangedEvent);
class ViewCompositionStartEvent {
    constructor(){
        this.type = 0 /* ViewEventType.ViewCompositionStart */ ;
    }
}
class ViewCompositionEndEvent {
    constructor(){
        this.type = 1 /* ViewEventType.ViewCompositionEnd */ ;
    }
}
class ViewConfigurationChangedEvent {
    constructor(source){
        this.type = 2 /* ViewEventType.ViewConfigurationChanged */ ;
        this._source = source;
    }
    hasChanged(id) {
        return this._source.hasChanged(id);
    }
}
class ViewCursorStateChangedEvent {
    constructor(selections, modelSelections, reason){
        this.selections = selections;
        this.modelSelections = modelSelections;
        this.reason = reason;
        this.type = 3 /* ViewEventType.ViewCursorStateChanged */ ;
    }
}
class ViewDecorationsChangedEvent {
    constructor(source){
        this.type = 4 /* ViewEventType.ViewDecorationsChanged */ ;
        if (source) {
            this.affectsMinimap = source.affectsMinimap;
            this.affectsOverviewRuler = source.affectsOverviewRuler;
            this.affectsGlyphMargin = source.affectsGlyphMargin;
            this.affectsLineNumber = source.affectsLineNumber;
        } else {
            this.affectsMinimap = true;
            this.affectsOverviewRuler = true;
            this.affectsGlyphMargin = true;
            this.affectsLineNumber = true;
        }
    }
}
class ViewFlushedEvent {
    constructor(){
        this.type = 5 /* ViewEventType.ViewFlushed */ ;
    // Nothing to do
    }
}
class ViewFocusChangedEvent {
    constructor(isFocused){
        this.type = 6 /* ViewEventType.ViewFocusChanged */ ;
        this.isFocused = isFocused;
    }
}
class ViewLanguageConfigurationEvent {
    constructor(){
        this.type = 7 /* ViewEventType.ViewLanguageConfigurationChanged */ ;
    }
}
class ViewLineMappingChangedEvent {
    constructor(){
        this.type = 8 /* ViewEventType.ViewLineMappingChanged */ ;
    // Nothing to do
    }
}
class ViewLinesChangedEvent {
    constructor(/**
     * The first line that has changed.
     */ fromLineNumber, /**
     * The number of lines that have changed.
     */ count){
        this.fromLineNumber = fromLineNumber;
        this.count = count;
        this.type = 9 /* ViewEventType.ViewLinesChanged */ ;
    }
}
class ViewLinesDeletedEvent {
    constructor(fromLineNumber, toLineNumber){
        this.type = 10 /* ViewEventType.ViewLinesDeleted */ ;
        this.fromLineNumber = fromLineNumber;
        this.toLineNumber = toLineNumber;
    }
}
class ViewLinesInsertedEvent {
    constructor(fromLineNumber, toLineNumber){
        this.type = 11 /* ViewEventType.ViewLinesInserted */ ;
        this.fromLineNumber = fromLineNumber;
        this.toLineNumber = toLineNumber;
    }
}
class ViewRevealRangeRequestEvent {
    constructor(/**
     * Source of the call that caused the event.
     */ source, /**
     * Reduce the revealing to a minimum (e.g. avoid scrolling if the bounding box is visible and near the viewport edge).
     */ minimalReveal, /**
     * Range to be reavealed.
     */ range, /**
     * Selections to be revealed.
     */ selections, /**
     * The vertical reveal strategy.
     */ verticalType, /**
     * If true: there should be a horizontal & vertical revealing.
     * If false: there should be just a vertical revealing.
     */ revealHorizontal, /**
     * The scroll type.
     */ scrollType){
        this.source = source;
        this.minimalReveal = minimalReveal;
        this.range = range;
        this.selections = selections;
        this.verticalType = verticalType;
        this.revealHorizontal = revealHorizontal;
        this.scrollType = scrollType;
        this.type = 12 /* ViewEventType.ViewRevealRangeRequest */ ;
    }
}
class ViewScrollChangedEvent {
    constructor(source){
        this.type = 13 /* ViewEventType.ViewScrollChanged */ ;
        this.scrollWidth = source.scrollWidth;
        this.scrollLeft = source.scrollLeft;
        this.scrollHeight = source.scrollHeight;
        this.scrollTop = source.scrollTop;
        this.scrollWidthChanged = source.scrollWidthChanged;
        this.scrollLeftChanged = source.scrollLeftChanged;
        this.scrollHeightChanged = source.scrollHeightChanged;
        this.scrollTopChanged = source.scrollTopChanged;
    }
}
class ViewThemeChangedEvent {
    constructor(theme){
        this.theme = theme;
        this.type = 14 /* ViewEventType.ViewThemeChanged */ ;
    }
}
class ViewTokensChangedEvent {
    constructor(ranges){
        this.type = 15 /* ViewEventType.ViewTokensChanged */ ;
        this.ranges = ranges;
    }
}
class ViewTokensColorsChangedEvent {
    constructor(){
        this.type = 16 /* ViewEventType.ViewTokensColorsChanged */ ;
    // Nothing to do
    }
}
class ViewZonesChangedEvent {
    constructor(){
        this.type = 17 /* ViewEventType.ViewZonesChanged */ ;
    // Nothing to do
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5BQnB":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewModelEventDispatcher", ()=>ViewModelEventDispatcher);
parcelHelpers.export(exports, "ViewModelEventsCollector", ()=>ViewModelEventsCollector);
parcelHelpers.export(exports, "ContentSizeChangedEvent", ()=>ContentSizeChangedEvent);
parcelHelpers.export(exports, "FocusChangedEvent", ()=>FocusChangedEvent);
parcelHelpers.export(exports, "ScrollChangedEvent", ()=>ScrollChangedEvent);
parcelHelpers.export(exports, "ViewZonesChangedEvent", ()=>ViewZonesChangedEvent);
parcelHelpers.export(exports, "HiddenAreasChangedEvent", ()=>HiddenAreasChangedEvent);
parcelHelpers.export(exports, "CursorStateChangedEvent", ()=>CursorStateChangedEvent);
parcelHelpers.export(exports, "ReadOnlyEditAttemptEvent", ()=>ReadOnlyEditAttemptEvent);
parcelHelpers.export(exports, "ModelDecorationsChangedEvent", ()=>ModelDecorationsChangedEvent);
parcelHelpers.export(exports, "ModelLanguageChangedEvent", ()=>ModelLanguageChangedEvent);
parcelHelpers.export(exports, "ModelLanguageConfigurationChangedEvent", ()=>ModelLanguageConfigurationChangedEvent);
parcelHelpers.export(exports, "ModelContentChangedEvent", ()=>ModelContentChangedEvent);
parcelHelpers.export(exports, "ModelOptionsChangedEvent", ()=>ModelOptionsChangedEvent);
parcelHelpers.export(exports, "ModelTokensChangedEvent", ()=>ModelTokensChangedEvent);
var _eventJs = require("../../base/common/event.js");
var _lifecycleJs = require("../../base/common/lifecycle.js");
class ViewModelEventDispatcher extends (0, _lifecycleJs.Disposable) {
    constructor(){
        super();
        this._onEvent = this._register(new (0, _eventJs.Emitter)());
        this.onEvent = this._onEvent.event;
        this._eventHandlers = [];
        this._viewEventQueue = null;
        this._isConsumingViewEventQueue = false;
        this._collector = null;
        this._collectorCnt = 0;
        this._outgoingEvents = [];
    }
    emitOutgoingEvent(e) {
        this._addOutgoingEvent(e);
        this._emitOutgoingEvents();
    }
    _addOutgoingEvent(e) {
        for(let i = 0, len = this._outgoingEvents.length; i < len; i++){
            const mergeResult = this._outgoingEvents[i].kind === e.kind ? this._outgoingEvents[i].attemptToMerge(e) : null;
            if (mergeResult) {
                this._outgoingEvents[i] = mergeResult;
                return;
            }
        }
        // not merged
        this._outgoingEvents.push(e);
    }
    _emitOutgoingEvents() {
        while(this._outgoingEvents.length > 0){
            if (this._collector || this._isConsumingViewEventQueue) // right now collecting or emitting view events, so let's postpone emitting
            return;
            const event = this._outgoingEvents.shift();
            if (event.isNoOp()) continue;
            this._onEvent.fire(event);
        }
    }
    addViewEventHandler(eventHandler) {
        for(let i = 0, len = this._eventHandlers.length; i < len; i++)if (this._eventHandlers[i] === eventHandler) console.warn("Detected duplicate listener in ViewEventDispatcher", eventHandler);
        this._eventHandlers.push(eventHandler);
    }
    removeViewEventHandler(eventHandler) {
        for(let i = 0; i < this._eventHandlers.length; i++)if (this._eventHandlers[i] === eventHandler) {
            this._eventHandlers.splice(i, 1);
            break;
        }
    }
    beginEmitViewEvents() {
        this._collectorCnt++;
        if (this._collectorCnt === 1) this._collector = new ViewModelEventsCollector();
        return this._collector;
    }
    endEmitViewEvents() {
        this._collectorCnt--;
        if (this._collectorCnt === 0) {
            const outgoingEvents = this._collector.outgoingEvents;
            const viewEvents = this._collector.viewEvents;
            this._collector = null;
            for (const outgoingEvent of outgoingEvents)this._addOutgoingEvent(outgoingEvent);
            if (viewEvents.length > 0) this._emitMany(viewEvents);
        }
        this._emitOutgoingEvents();
    }
    emitSingleViewEvent(event) {
        try {
            const eventsCollector = this.beginEmitViewEvents();
            eventsCollector.emitViewEvent(event);
        } finally{
            this.endEmitViewEvents();
        }
    }
    _emitMany(events) {
        if (this._viewEventQueue) this._viewEventQueue = this._viewEventQueue.concat(events);
        else this._viewEventQueue = events;
        if (!this._isConsumingViewEventQueue) this._consumeViewEventQueue();
    }
    _consumeViewEventQueue() {
        try {
            this._isConsumingViewEventQueue = true;
            this._doConsumeQueue();
        } finally{
            this._isConsumingViewEventQueue = false;
        }
    }
    _doConsumeQueue() {
        while(this._viewEventQueue){
            // Empty event queue, as events might come in while sending these off
            const events = this._viewEventQueue;
            this._viewEventQueue = null;
            // Use a clone of the event handlers list, as they might remove themselves
            const eventHandlers = this._eventHandlers.slice(0);
            for (const eventHandler of eventHandlers)eventHandler.handleEvents(events);
        }
    }
}
class ViewModelEventsCollector {
    constructor(){
        this.viewEvents = [];
        this.outgoingEvents = [];
    }
    emitViewEvent(event) {
        this.viewEvents.push(event);
    }
    emitOutgoingEvent(e) {
        this.outgoingEvents.push(e);
    }
}
class ContentSizeChangedEvent {
    constructor(oldContentWidth, oldContentHeight, contentWidth, contentHeight){
        this.kind = 0 /* OutgoingViewModelEventKind.ContentSizeChanged */ ;
        this._oldContentWidth = oldContentWidth;
        this._oldContentHeight = oldContentHeight;
        this.contentWidth = contentWidth;
        this.contentHeight = contentHeight;
        this.contentWidthChanged = this._oldContentWidth !== this.contentWidth;
        this.contentHeightChanged = this._oldContentHeight !== this.contentHeight;
    }
    isNoOp() {
        return !this.contentWidthChanged && !this.contentHeightChanged;
    }
    attemptToMerge(other) {
        if (other.kind !== this.kind) return null;
        return new ContentSizeChangedEvent(this._oldContentWidth, this._oldContentHeight, other.contentWidth, other.contentHeight);
    }
}
class FocusChangedEvent {
    constructor(oldHasFocus, hasFocus){
        this.kind = 1 /* OutgoingViewModelEventKind.FocusChanged */ ;
        this.oldHasFocus = oldHasFocus;
        this.hasFocus = hasFocus;
    }
    isNoOp() {
        return this.oldHasFocus === this.hasFocus;
    }
    attemptToMerge(other) {
        if (other.kind !== this.kind) return null;
        return new FocusChangedEvent(this.oldHasFocus, other.hasFocus);
    }
}
class ScrollChangedEvent {
    constructor(oldScrollWidth, oldScrollLeft, oldScrollHeight, oldScrollTop, scrollWidth, scrollLeft, scrollHeight, scrollTop){
        this.kind = 2 /* OutgoingViewModelEventKind.ScrollChanged */ ;
        this._oldScrollWidth = oldScrollWidth;
        this._oldScrollLeft = oldScrollLeft;
        this._oldScrollHeight = oldScrollHeight;
        this._oldScrollTop = oldScrollTop;
        this.scrollWidth = scrollWidth;
        this.scrollLeft = scrollLeft;
        this.scrollHeight = scrollHeight;
        this.scrollTop = scrollTop;
        this.scrollWidthChanged = this._oldScrollWidth !== this.scrollWidth;
        this.scrollLeftChanged = this._oldScrollLeft !== this.scrollLeft;
        this.scrollHeightChanged = this._oldScrollHeight !== this.scrollHeight;
        this.scrollTopChanged = this._oldScrollTop !== this.scrollTop;
    }
    isNoOp() {
        return !this.scrollWidthChanged && !this.scrollLeftChanged && !this.scrollHeightChanged && !this.scrollTopChanged;
    }
    attemptToMerge(other) {
        if (other.kind !== this.kind) return null;
        return new ScrollChangedEvent(this._oldScrollWidth, this._oldScrollLeft, this._oldScrollHeight, this._oldScrollTop, other.scrollWidth, other.scrollLeft, other.scrollHeight, other.scrollTop);
    }
}
class ViewZonesChangedEvent {
    constructor(){
        this.kind = 3 /* OutgoingViewModelEventKind.ViewZonesChanged */ ;
    }
    isNoOp() {
        return false;
    }
    attemptToMerge(other) {
        if (other.kind !== this.kind) return null;
        return this;
    }
}
class HiddenAreasChangedEvent {
    constructor(){
        this.kind = 4 /* OutgoingViewModelEventKind.HiddenAreasChanged */ ;
    }
    isNoOp() {
        return false;
    }
    attemptToMerge(other) {
        if (other.kind !== this.kind) return null;
        return this;
    }
}
class CursorStateChangedEvent {
    constructor(oldSelections, selections, oldModelVersionId, modelVersionId, source, reason, reachedMaxCursorCount){
        this.kind = 6 /* OutgoingViewModelEventKind.CursorStateChanged */ ;
        this.oldSelections = oldSelections;
        this.selections = selections;
        this.oldModelVersionId = oldModelVersionId;
        this.modelVersionId = modelVersionId;
        this.source = source;
        this.reason = reason;
        this.reachedMaxCursorCount = reachedMaxCursorCount;
    }
    static _selectionsAreEqual(a, b) {
        if (!a && !b) return true;
        if (!a || !b) return false;
        const aLen = a.length;
        const bLen = b.length;
        if (aLen !== bLen) return false;
        for(let i = 0; i < aLen; i++){
            if (!a[i].equalsSelection(b[i])) return false;
        }
        return true;
    }
    isNoOp() {
        return CursorStateChangedEvent._selectionsAreEqual(this.oldSelections, this.selections) && this.oldModelVersionId === this.modelVersionId;
    }
    attemptToMerge(other) {
        if (other.kind !== this.kind) return null;
        return new CursorStateChangedEvent(this.oldSelections, other.selections, this.oldModelVersionId, other.modelVersionId, other.source, other.reason, this.reachedMaxCursorCount || other.reachedMaxCursorCount);
    }
}
class ReadOnlyEditAttemptEvent {
    constructor(){
        this.kind = 5 /* OutgoingViewModelEventKind.ReadOnlyEditAttempt */ ;
    }
    isNoOp() {
        return false;
    }
    attemptToMerge(other) {
        if (other.kind !== this.kind) return null;
        return this;
    }
}
class ModelDecorationsChangedEvent {
    constructor(event){
        this.event = event;
        this.kind = 7 /* OutgoingViewModelEventKind.ModelDecorationsChanged */ ;
    }
    isNoOp() {
        return false;
    }
    attemptToMerge(other) {
        return null;
    }
}
class ModelLanguageChangedEvent {
    constructor(event){
        this.event = event;
        this.kind = 8 /* OutgoingViewModelEventKind.ModelLanguageChanged */ ;
    }
    isNoOp() {
        return false;
    }
    attemptToMerge(other) {
        return null;
    }
}
class ModelLanguageConfigurationChangedEvent {
    constructor(event){
        this.event = event;
        this.kind = 9 /* OutgoingViewModelEventKind.ModelLanguageConfigurationChanged */ ;
    }
    isNoOp() {
        return false;
    }
    attemptToMerge(other) {
        return null;
    }
}
class ModelContentChangedEvent {
    constructor(event){
        this.event = event;
        this.kind = 10 /* OutgoingViewModelEventKind.ModelContentChanged */ ;
    }
    isNoOp() {
        return false;
    }
    attemptToMerge(other) {
        return null;
    }
}
class ModelOptionsChangedEvent {
    constructor(event){
        this.event = event;
        this.kind = 11 /* OutgoingViewModelEventKind.ModelOptionsChanged */ ;
    }
    isNoOp() {
        return false;
    }
    attemptToMerge(other) {
        return null;
    }
}
class ModelTokensChangedEvent {
    constructor(event){
        this.event = event;
        this.kind = 12 /* OutgoingViewModelEventKind.ModelTokensChanged */ ;
    }
    isNoOp() {
        return false;
    }
    attemptToMerge(other) {
        return null;
    }
}

},{"../../base/common/event.js":"4Zi8b","../../base/common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"49Y5U":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewLayout", ()=>ViewLayout);
var _eventJs = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _scrollableJs = require("../../../base/common/scrollable.js");
var _linesLayoutJs = require("./linesLayout.js");
var _viewModelJs = require("../viewModel.js");
var _viewModelEventDispatcherJs = require("../viewModelEventDispatcher.js");
const SMOOTH_SCROLLING_TIME = 125;
class EditorScrollDimensions {
    constructor(width, contentWidth, height, contentHeight){
        width = width | 0;
        contentWidth = contentWidth | 0;
        height = height | 0;
        contentHeight = contentHeight | 0;
        if (width < 0) width = 0;
        if (contentWidth < 0) contentWidth = 0;
        if (height < 0) height = 0;
        if (contentHeight < 0) contentHeight = 0;
        this.width = width;
        this.contentWidth = contentWidth;
        this.scrollWidth = Math.max(width, contentWidth);
        this.height = height;
        this.contentHeight = contentHeight;
        this.scrollHeight = Math.max(height, contentHeight);
    }
    equals(other) {
        return this.width === other.width && this.contentWidth === other.contentWidth && this.height === other.height && this.contentHeight === other.contentHeight;
    }
}
class EditorScrollable extends (0, _lifecycleJs.Disposable) {
    constructor(smoothScrollDuration, scheduleAtNextAnimationFrame){
        super();
        this._onDidContentSizeChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidContentSizeChange = this._onDidContentSizeChange.event;
        this._dimensions = new EditorScrollDimensions(0, 0, 0, 0);
        this._scrollable = this._register(new (0, _scrollableJs.Scrollable)({
            forceIntegerValues: true,
            smoothScrollDuration,
            scheduleAtNextAnimationFrame
        }));
        this.onDidScroll = this._scrollable.onScroll;
    }
    getScrollable() {
        return this._scrollable;
    }
    setSmoothScrollDuration(smoothScrollDuration) {
        this._scrollable.setSmoothScrollDuration(smoothScrollDuration);
    }
    validateScrollPosition(scrollPosition) {
        return this._scrollable.validateScrollPosition(scrollPosition);
    }
    getScrollDimensions() {
        return this._dimensions;
    }
    setScrollDimensions(dimensions) {
        if (this._dimensions.equals(dimensions)) return;
        const oldDimensions = this._dimensions;
        this._dimensions = dimensions;
        this._scrollable.setScrollDimensions({
            width: dimensions.width,
            scrollWidth: dimensions.scrollWidth,
            height: dimensions.height,
            scrollHeight: dimensions.scrollHeight
        }, true);
        const contentWidthChanged = oldDimensions.contentWidth !== dimensions.contentWidth;
        const contentHeightChanged = oldDimensions.contentHeight !== dimensions.contentHeight;
        if (contentWidthChanged || contentHeightChanged) this._onDidContentSizeChange.fire(new (0, _viewModelEventDispatcherJs.ContentSizeChangedEvent)(oldDimensions.contentWidth, oldDimensions.contentHeight, dimensions.contentWidth, dimensions.contentHeight));
    }
    getFutureScrollPosition() {
        return this._scrollable.getFutureScrollPosition();
    }
    getCurrentScrollPosition() {
        return this._scrollable.getCurrentScrollPosition();
    }
    setScrollPositionNow(update) {
        this._scrollable.setScrollPositionNow(update);
    }
    setScrollPositionSmooth(update) {
        this._scrollable.setScrollPositionSmooth(update);
    }
    hasPendingScrollAnimation() {
        return this._scrollable.hasPendingScrollAnimation();
    }
}
class ViewLayout extends (0, _lifecycleJs.Disposable) {
    constructor(configuration, lineCount, scheduleAtNextAnimationFrame){
        super();
        this._configuration = configuration;
        const options = this._configuration.options;
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        const padding = options.get(84 /* EditorOption.padding */ );
        this._linesLayout = new (0, _linesLayoutJs.LinesLayout)(lineCount, options.get(67 /* EditorOption.lineHeight */ ), padding.top, padding.bottom);
        this._maxLineWidth = 0;
        this._overlayWidgetsMinWidth = 0;
        this._scrollable = this._register(new EditorScrollable(0, scheduleAtNextAnimationFrame));
        this._configureSmoothScrollDuration();
        this._scrollable.setScrollDimensions(new EditorScrollDimensions(layoutInfo.contentWidth, 0, layoutInfo.height, 0));
        this.onDidScroll = this._scrollable.onDidScroll;
        this.onDidContentSizeChange = this._scrollable.onDidContentSizeChange;
        this._updateHeight();
    }
    dispose() {
        super.dispose();
    }
    getScrollable() {
        return this._scrollable.getScrollable();
    }
    onHeightMaybeChanged() {
        this._updateHeight();
    }
    _configureSmoothScrollDuration() {
        this._scrollable.setSmoothScrollDuration(this._configuration.options.get(115 /* EditorOption.smoothScrolling */ ) ? SMOOTH_SCROLLING_TIME : 0);
    }
    // ---- begin view event handlers
    onConfigurationChanged(e) {
        const options = this._configuration.options;
        if (e.hasChanged(67 /* EditorOption.lineHeight */ )) this._linesLayout.setLineHeight(options.get(67 /* EditorOption.lineHeight */ ));
        if (e.hasChanged(84 /* EditorOption.padding */ )) {
            const padding = options.get(84 /* EditorOption.padding */ );
            this._linesLayout.setPadding(padding.top, padding.bottom);
        }
        if (e.hasChanged(146 /* EditorOption.layoutInfo */ )) {
            const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
            const width = layoutInfo.contentWidth;
            const height = layoutInfo.height;
            const scrollDimensions = this._scrollable.getScrollDimensions();
            const contentWidth = scrollDimensions.contentWidth;
            this._scrollable.setScrollDimensions(new EditorScrollDimensions(width, scrollDimensions.contentWidth, height, this._getContentHeight(width, height, contentWidth)));
        } else this._updateHeight();
        if (e.hasChanged(115 /* EditorOption.smoothScrolling */ )) this._configureSmoothScrollDuration();
    }
    onFlushed(lineCount) {
        this._linesLayout.onFlushed(lineCount);
    }
    onLinesDeleted(fromLineNumber, toLineNumber) {
        this._linesLayout.onLinesDeleted(fromLineNumber, toLineNumber);
    }
    onLinesInserted(fromLineNumber, toLineNumber) {
        this._linesLayout.onLinesInserted(fromLineNumber, toLineNumber);
    }
    // ---- end view event handlers
    _getHorizontalScrollbarHeight(width, scrollWidth) {
        const options = this._configuration.options;
        const scrollbar = options.get(104 /* EditorOption.scrollbar */ );
        if (scrollbar.horizontal === 2 /* ScrollbarVisibility.Hidden */ ) // horizontal scrollbar not visible
        return 0;
        if (width >= scrollWidth) // horizontal scrollbar not visible
        return 0;
        return scrollbar.horizontalScrollbarSize;
    }
    _getContentHeight(width, height, contentWidth) {
        const options = this._configuration.options;
        let result = this._linesLayout.getLinesTotalHeight();
        if (options.get(106 /* EditorOption.scrollBeyondLastLine */ )) result += Math.max(0, height - options.get(67 /* EditorOption.lineHeight */ ) - options.get(84 /* EditorOption.padding */ ).bottom);
        else if (!options.get(104 /* EditorOption.scrollbar */ ).ignoreHorizontalScrollbarInContentHeight) result += this._getHorizontalScrollbarHeight(width, contentWidth);
        return result;
    }
    _updateHeight() {
        const scrollDimensions = this._scrollable.getScrollDimensions();
        const width = scrollDimensions.width;
        const height = scrollDimensions.height;
        const contentWidth = scrollDimensions.contentWidth;
        this._scrollable.setScrollDimensions(new EditorScrollDimensions(width, scrollDimensions.contentWidth, height, this._getContentHeight(width, height, contentWidth)));
    }
    // ---- Layouting logic
    getCurrentViewport() {
        const scrollDimensions = this._scrollable.getScrollDimensions();
        const currentScrollPosition = this._scrollable.getCurrentScrollPosition();
        return new (0, _viewModelJs.Viewport)(currentScrollPosition.scrollTop, currentScrollPosition.scrollLeft, scrollDimensions.width, scrollDimensions.height);
    }
    getFutureViewport() {
        const scrollDimensions = this._scrollable.getScrollDimensions();
        const currentScrollPosition = this._scrollable.getFutureScrollPosition();
        return new (0, _viewModelJs.Viewport)(currentScrollPosition.scrollTop, currentScrollPosition.scrollLeft, scrollDimensions.width, scrollDimensions.height);
    }
    _computeContentWidth() {
        const options = this._configuration.options;
        const maxLineWidth = this._maxLineWidth;
        const wrappingInfo = options.get(147 /* EditorOption.wrappingInfo */ );
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        const layoutInfo = options.get(146 /* EditorOption.layoutInfo */ );
        if (wrappingInfo.isViewportWrapping) {
            const minimap = options.get(73 /* EditorOption.minimap */ );
            if (maxLineWidth > layoutInfo.contentWidth + fontInfo.typicalHalfwidthCharacterWidth) {
                // This is a case where viewport wrapping is on, but the line extends above the viewport
                if (minimap.enabled && minimap.side === "right") // We need to accomodate the scrollbar width
                return maxLineWidth + layoutInfo.verticalScrollbarWidth;
            }
            return maxLineWidth;
        } else {
            const extraHorizontalSpace = options.get(105 /* EditorOption.scrollBeyondLastColumn */ ) * fontInfo.typicalHalfwidthCharacterWidth;
            const whitespaceMinWidth = this._linesLayout.getWhitespaceMinWidth();
            return Math.max(maxLineWidth + extraHorizontalSpace + layoutInfo.verticalScrollbarWidth, whitespaceMinWidth, this._overlayWidgetsMinWidth);
        }
    }
    setMaxLineWidth(maxLineWidth) {
        this._maxLineWidth = maxLineWidth;
        this._updateContentWidth();
    }
    setOverlayWidgetsMinWidth(maxMinWidth) {
        this._overlayWidgetsMinWidth = maxMinWidth;
        this._updateContentWidth();
    }
    _updateContentWidth() {
        const scrollDimensions = this._scrollable.getScrollDimensions();
        this._scrollable.setScrollDimensions(new EditorScrollDimensions(scrollDimensions.width, this._computeContentWidth(), scrollDimensions.height, scrollDimensions.contentHeight));
        // The height might depend on the fact that there is a horizontal scrollbar or not
        this._updateHeight();
    }
    // ---- view state
    saveState() {
        const currentScrollPosition = this._scrollable.getFutureScrollPosition();
        const scrollTop = currentScrollPosition.scrollTop;
        const firstLineNumberInViewport = this._linesLayout.getLineNumberAtOrAfterVerticalOffset(scrollTop);
        const whitespaceAboveFirstLine = this._linesLayout.getWhitespaceAccumulatedHeightBeforeLineNumber(firstLineNumberInViewport);
        return {
            scrollTop: scrollTop,
            scrollTopWithoutViewZones: scrollTop - whitespaceAboveFirstLine,
            scrollLeft: currentScrollPosition.scrollLeft
        };
    }
    // ----
    changeWhitespace(callback) {
        const hadAChange = this._linesLayout.changeWhitespace(callback);
        if (hadAChange) this.onHeightMaybeChanged();
        return hadAChange;
    }
    getVerticalOffsetForLineNumber(lineNumber, includeViewZones = false) {
        return this._linesLayout.getVerticalOffsetForLineNumber(lineNumber, includeViewZones);
    }
    getVerticalOffsetAfterLineNumber(lineNumber, includeViewZones = false) {
        return this._linesLayout.getVerticalOffsetAfterLineNumber(lineNumber, includeViewZones);
    }
    isAfterLines(verticalOffset) {
        return this._linesLayout.isAfterLines(verticalOffset);
    }
    isInTopPadding(verticalOffset) {
        return this._linesLayout.isInTopPadding(verticalOffset);
    }
    isInBottomPadding(verticalOffset) {
        return this._linesLayout.isInBottomPadding(verticalOffset);
    }
    getLineNumberAtVerticalOffset(verticalOffset) {
        return this._linesLayout.getLineNumberAtOrAfterVerticalOffset(verticalOffset);
    }
    getWhitespaceAtVerticalOffset(verticalOffset) {
        return this._linesLayout.getWhitespaceAtVerticalOffset(verticalOffset);
    }
    getLinesViewportData() {
        const visibleBox = this.getCurrentViewport();
        return this._linesLayout.getLinesViewportData(visibleBox.top, visibleBox.top + visibleBox.height);
    }
    getLinesViewportDataAtScrollTop(scrollTop) {
        // do some minimal validations on scrollTop
        const scrollDimensions = this._scrollable.getScrollDimensions();
        if (scrollTop + scrollDimensions.height > scrollDimensions.scrollHeight) scrollTop = scrollDimensions.scrollHeight - scrollDimensions.height;
        if (scrollTop < 0) scrollTop = 0;
        return this._linesLayout.getLinesViewportData(scrollTop, scrollTop + scrollDimensions.height);
    }
    getWhitespaceViewportData() {
        const visibleBox = this.getCurrentViewport();
        return this._linesLayout.getWhitespaceViewportData(visibleBox.top, visibleBox.top + visibleBox.height);
    }
    getWhitespaces() {
        return this._linesLayout.getWhitespaces();
    }
    // ----
    getContentWidth() {
        const scrollDimensions = this._scrollable.getScrollDimensions();
        return scrollDimensions.contentWidth;
    }
    getScrollWidth() {
        const scrollDimensions = this._scrollable.getScrollDimensions();
        return scrollDimensions.scrollWidth;
    }
    getContentHeight() {
        const scrollDimensions = this._scrollable.getScrollDimensions();
        return scrollDimensions.contentHeight;
    }
    getScrollHeight() {
        const scrollDimensions = this._scrollable.getScrollDimensions();
        return scrollDimensions.scrollHeight;
    }
    getCurrentScrollLeft() {
        const currentScrollPosition = this._scrollable.getCurrentScrollPosition();
        return currentScrollPosition.scrollLeft;
    }
    getCurrentScrollTop() {
        const currentScrollPosition = this._scrollable.getCurrentScrollPosition();
        return currentScrollPosition.scrollTop;
    }
    validateScrollPosition(scrollPosition) {
        return this._scrollable.validateScrollPosition(scrollPosition);
    }
    setScrollPosition(position, type) {
        if (type === 1 /* ScrollType.Immediate */ ) this._scrollable.setScrollPositionNow(position);
        else this._scrollable.setScrollPositionSmooth(position);
    }
    hasPendingScrollAnimation() {
        return this._scrollable.hasPendingScrollAnimation();
    }
    deltaScrollNow(deltaScrollLeft, deltaScrollTop) {
        const currentScrollPosition = this._scrollable.getCurrentScrollPosition();
        this._scrollable.setScrollPositionNow({
            scrollLeft: currentScrollPosition.scrollLeft + deltaScrollLeft,
            scrollTop: currentScrollPosition.scrollTop + deltaScrollTop
        });
    }
}

},{"../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/scrollable.js":"8otcz","./linesLayout.js":"fgRm3","../viewModel.js":"5EHxj","../viewModelEventDispatcher.js":"5BQnB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fgRm3":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorWhitespace", ()=>EditorWhitespace);
/**
 * Layouting of objects that take vertical space (by having a height) and push down other objects.
 *
 * These objects are basically either text (lines) or spaces between those lines (whitespaces).
 * This provides commodity operations for working with lines that contain whitespace that pushes lines lower (vertically).
 */ parcelHelpers.export(exports, "LinesLayout", ()=>LinesLayout);
var _stringsJs = require("../../../base/common/strings.js");
class PendingChanges {
    constructor(){
        this._hasPending = false;
        this._inserts = [];
        this._changes = [];
        this._removes = [];
    }
    insert(x) {
        this._hasPending = true;
        this._inserts.push(x);
    }
    change(x) {
        this._hasPending = true;
        this._changes.push(x);
    }
    remove(x) {
        this._hasPending = true;
        this._removes.push(x);
    }
    mustCommit() {
        return this._hasPending;
    }
    commit(linesLayout) {
        if (!this._hasPending) return;
        const inserts = this._inserts;
        const changes = this._changes;
        const removes = this._removes;
        this._hasPending = false;
        this._inserts = [];
        this._changes = [];
        this._removes = [];
        linesLayout._commitPendingChanges(inserts, changes, removes);
    }
}
class EditorWhitespace {
    constructor(id, afterLineNumber, ordinal, height, minWidth){
        this.id = id;
        this.afterLineNumber = afterLineNumber;
        this.ordinal = ordinal;
        this.height = height;
        this.minWidth = minWidth;
        this.prefixSum = 0;
    }
}
class LinesLayout {
    static{
        this.INSTANCE_COUNT = 0;
    }
    constructor(lineCount, lineHeight, paddingTop, paddingBottom){
        this._instanceId = _stringsJs.singleLetterHash(++LinesLayout.INSTANCE_COUNT);
        this._pendingChanges = new PendingChanges();
        this._lastWhitespaceId = 0;
        this._arr = [];
        this._prefixSumValidIndex = -1;
        this._minWidth = -1; /* marker for not being computed */ 
        this._lineCount = lineCount;
        this._lineHeight = lineHeight;
        this._paddingTop = paddingTop;
        this._paddingBottom = paddingBottom;
    }
    /**
     * Find the insertion index for a new value inside a sorted array of values.
     * If the value is already present in the sorted array, the insertion index will be after the already existing value.
     */ static findInsertionIndex(arr, afterLineNumber, ordinal) {
        let low = 0;
        let high = arr.length;
        while(low < high){
            const mid = low + high >>> 1;
            if (afterLineNumber === arr[mid].afterLineNumber) {
                if (ordinal < arr[mid].ordinal) high = mid;
                else low = mid + 1;
            } else if (afterLineNumber < arr[mid].afterLineNumber) high = mid;
            else low = mid + 1;
        }
        return low;
    }
    /**
     * Change the height of a line in pixels.
     */ setLineHeight(lineHeight) {
        this._checkPendingChanges();
        this._lineHeight = lineHeight;
    }
    /**
     * Changes the padding used to calculate vertical offsets.
     */ setPadding(paddingTop, paddingBottom) {
        this._paddingTop = paddingTop;
        this._paddingBottom = paddingBottom;
    }
    /**
     * Set the number of lines.
     *
     * @param lineCount New number of lines.
     */ onFlushed(lineCount) {
        this._checkPendingChanges();
        this._lineCount = lineCount;
    }
    changeWhitespace(callback) {
        let hadAChange = false;
        try {
            const accessor = {
                insertWhitespace: (afterLineNumber, ordinal, heightInPx, minWidth)=>{
                    hadAChange = true;
                    afterLineNumber = afterLineNumber | 0;
                    ordinal = ordinal | 0;
                    heightInPx = heightInPx | 0;
                    minWidth = minWidth | 0;
                    const id = this._instanceId + ++this._lastWhitespaceId;
                    this._pendingChanges.insert(new EditorWhitespace(id, afterLineNumber, ordinal, heightInPx, minWidth));
                    return id;
                },
                changeOneWhitespace: (id, newAfterLineNumber, newHeight)=>{
                    hadAChange = true;
                    newAfterLineNumber = newAfterLineNumber | 0;
                    newHeight = newHeight | 0;
                    this._pendingChanges.change({
                        id,
                        newAfterLineNumber,
                        newHeight
                    });
                },
                removeWhitespace: (id)=>{
                    hadAChange = true;
                    this._pendingChanges.remove({
                        id
                    });
                }
            };
            callback(accessor);
        } finally{
            this._pendingChanges.commit(this);
        }
        return hadAChange;
    }
    _commitPendingChanges(inserts, changes, removes) {
        if (inserts.length > 0 || removes.length > 0) this._minWidth = -1; /* marker for not being computed */ 
        if (inserts.length + changes.length + removes.length <= 1) {
            // when only one thing happened, handle it "delicately"
            for (const insert of inserts)this._insertWhitespace(insert);
            for (const change of changes)this._changeOneWhitespace(change.id, change.newAfterLineNumber, change.newHeight);
            for (const remove of removes){
                const index = this._findWhitespaceIndex(remove.id);
                if (index === -1) continue;
                this._removeWhitespace(index);
            }
            return;
        }
        // simply rebuild the entire datastructure
        const toRemove = new Set();
        for (const remove of removes)toRemove.add(remove.id);
        const toChange = new Map();
        for (const change of changes)toChange.set(change.id, change);
        const applyRemoveAndChange = (whitespaces)=>{
            const result = [];
            for (const whitespace of whitespaces){
                if (toRemove.has(whitespace.id)) continue;
                if (toChange.has(whitespace.id)) {
                    const change = toChange.get(whitespace.id);
                    whitespace.afterLineNumber = change.newAfterLineNumber;
                    whitespace.height = change.newHeight;
                }
                result.push(whitespace);
            }
            return result;
        };
        const result = applyRemoveAndChange(this._arr).concat(applyRemoveAndChange(inserts));
        result.sort((a, b)=>{
            if (a.afterLineNumber === b.afterLineNumber) return a.ordinal - b.ordinal;
            return a.afterLineNumber - b.afterLineNumber;
        });
        this._arr = result;
        this._prefixSumValidIndex = -1;
    }
    _checkPendingChanges() {
        if (this._pendingChanges.mustCommit()) this._pendingChanges.commit(this);
    }
    _insertWhitespace(whitespace) {
        const insertIndex = LinesLayout.findInsertionIndex(this._arr, whitespace.afterLineNumber, whitespace.ordinal);
        this._arr.splice(insertIndex, 0, whitespace);
        this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, insertIndex - 1);
    }
    _findWhitespaceIndex(id) {
        const arr = this._arr;
        for(let i = 0, len = arr.length; i < len; i++){
            if (arr[i].id === id) return i;
        }
        return -1;
    }
    _changeOneWhitespace(id, newAfterLineNumber, newHeight) {
        const index = this._findWhitespaceIndex(id);
        if (index === -1) return;
        if (this._arr[index].height !== newHeight) {
            this._arr[index].height = newHeight;
            this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, index - 1);
        }
        if (this._arr[index].afterLineNumber !== newAfterLineNumber) {
            // `afterLineNumber` changed for this whitespace
            // Record old whitespace
            const whitespace = this._arr[index];
            // Since changing `afterLineNumber` can trigger a reordering, we're gonna remove this whitespace
            this._removeWhitespace(index);
            whitespace.afterLineNumber = newAfterLineNumber;
            // And add it again
            this._insertWhitespace(whitespace);
        }
    }
    _removeWhitespace(removeIndex) {
        this._arr.splice(removeIndex, 1);
        this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, removeIndex - 1);
    }
    /**
     * Notify the layouter that lines have been deleted (a continuous zone of lines).
     *
     * @param fromLineNumber The line number at which the deletion started, inclusive
     * @param toLineNumber The line number at which the deletion ended, inclusive
     */ onLinesDeleted(fromLineNumber, toLineNumber) {
        this._checkPendingChanges();
        fromLineNumber = fromLineNumber | 0;
        toLineNumber = toLineNumber | 0;
        this._lineCount -= toLineNumber - fromLineNumber + 1;
        for(let i = 0, len = this._arr.length; i < len; i++){
            const afterLineNumber = this._arr[i].afterLineNumber;
            if (fromLineNumber <= afterLineNumber && afterLineNumber <= toLineNumber) // The line this whitespace was after has been deleted
            //  => move whitespace to before first deleted line
            this._arr[i].afterLineNumber = fromLineNumber - 1;
            else if (afterLineNumber > toLineNumber) // The line this whitespace was after has been moved up
            //  => move whitespace up
            this._arr[i].afterLineNumber -= toLineNumber - fromLineNumber + 1;
        }
    }
    /**
     * Notify the layouter that lines have been inserted (a continuous zone of lines).
     *
     * @param fromLineNumber The line number at which the insertion started, inclusive
     * @param toLineNumber The line number at which the insertion ended, inclusive.
     */ onLinesInserted(fromLineNumber, toLineNumber) {
        this._checkPendingChanges();
        fromLineNumber = fromLineNumber | 0;
        toLineNumber = toLineNumber | 0;
        this._lineCount += toLineNumber - fromLineNumber + 1;
        for(let i = 0, len = this._arr.length; i < len; i++){
            const afterLineNumber = this._arr[i].afterLineNumber;
            if (fromLineNumber <= afterLineNumber) this._arr[i].afterLineNumber += toLineNumber - fromLineNumber + 1;
        }
    }
    /**
     * Get the sum of all the whitespaces.
     */ getWhitespacesTotalHeight() {
        this._checkPendingChanges();
        if (this._arr.length === 0) return 0;
        return this.getWhitespacesAccumulatedHeight(this._arr.length - 1);
    }
    /**
     * Return the sum of the heights of the whitespaces at [0..index].
     * This includes the whitespace at `index`.
     *
     * @param index The index of the whitespace.
     * @return The sum of the heights of all whitespaces before the one at `index`, including the one at `index`.
     */ getWhitespacesAccumulatedHeight(index) {
        this._checkPendingChanges();
        index = index | 0;
        let startIndex = Math.max(0, this._prefixSumValidIndex + 1);
        if (startIndex === 0) {
            this._arr[0].prefixSum = this._arr[0].height;
            startIndex++;
        }
        for(let i = startIndex; i <= index; i++)this._arr[i].prefixSum = this._arr[i - 1].prefixSum + this._arr[i].height;
        this._prefixSumValidIndex = Math.max(this._prefixSumValidIndex, index);
        return this._arr[index].prefixSum;
    }
    /**
     * Get the sum of heights for all objects.
     *
     * @return The sum of heights for all objects.
     */ getLinesTotalHeight() {
        this._checkPendingChanges();
        const linesHeight = this._lineHeight * this._lineCount;
        const whitespacesHeight = this.getWhitespacesTotalHeight();
        return linesHeight + whitespacesHeight + this._paddingTop + this._paddingBottom;
    }
    /**
     * Returns the accumulated height of whitespaces before the given line number.
     *
     * @param lineNumber The line number
     */ getWhitespaceAccumulatedHeightBeforeLineNumber(lineNumber) {
        this._checkPendingChanges();
        lineNumber = lineNumber | 0;
        const lastWhitespaceBeforeLineNumber = this._findLastWhitespaceBeforeLineNumber(lineNumber);
        if (lastWhitespaceBeforeLineNumber === -1) return 0;
        return this.getWhitespacesAccumulatedHeight(lastWhitespaceBeforeLineNumber);
    }
    _findLastWhitespaceBeforeLineNumber(lineNumber) {
        lineNumber = lineNumber | 0;
        // Find the whitespace before line number
        const arr = this._arr;
        let low = 0;
        let high = arr.length - 1;
        while(low <= high){
            const delta = high - low | 0;
            const halfDelta = delta / 2 | 0;
            const mid = low + halfDelta | 0;
            if (arr[mid].afterLineNumber < lineNumber) {
                if (mid + 1 >= arr.length || arr[mid + 1].afterLineNumber >= lineNumber) return mid;
                else low = mid + 1 | 0;
            } else high = mid - 1 | 0;
        }
        return -1;
    }
    _findFirstWhitespaceAfterLineNumber(lineNumber) {
        lineNumber = lineNumber | 0;
        const lastWhitespaceBeforeLineNumber = this._findLastWhitespaceBeforeLineNumber(lineNumber);
        const firstWhitespaceAfterLineNumber = lastWhitespaceBeforeLineNumber + 1;
        if (firstWhitespaceAfterLineNumber < this._arr.length) return firstWhitespaceAfterLineNumber;
        return -1;
    }
    /**
     * Find the index of the first whitespace which has `afterLineNumber` >= `lineNumber`.
     * @return The index of the first whitespace with `afterLineNumber` >= `lineNumber` or -1 if no whitespace is found.
     */ getFirstWhitespaceIndexAfterLineNumber(lineNumber) {
        this._checkPendingChanges();
        lineNumber = lineNumber | 0;
        return this._findFirstWhitespaceAfterLineNumber(lineNumber);
    }
    /**
     * Get the vertical offset (the sum of heights for all objects above) a certain line number.
     *
     * @param lineNumber The line number
     * @return The sum of heights for all objects above `lineNumber`.
     */ getVerticalOffsetForLineNumber(lineNumber, includeViewZones = false) {
        this._checkPendingChanges();
        lineNumber = lineNumber | 0;
        let previousLinesHeight;
        if (lineNumber > 1) previousLinesHeight = this._lineHeight * (lineNumber - 1);
        else previousLinesHeight = 0;
        const previousWhitespacesHeight = this.getWhitespaceAccumulatedHeightBeforeLineNumber(lineNumber - (includeViewZones ? 1 : 0));
        return previousLinesHeight + previousWhitespacesHeight + this._paddingTop;
    }
    /**
     * Get the vertical offset (the sum of heights for all objects above) a certain line number.
     *
     * @param lineNumber The line number
     * @return The sum of heights for all objects above `lineNumber`.
     */ getVerticalOffsetAfterLineNumber(lineNumber, includeViewZones = false) {
        this._checkPendingChanges();
        lineNumber = lineNumber | 0;
        const previousLinesHeight = this._lineHeight * lineNumber;
        const previousWhitespacesHeight = this.getWhitespaceAccumulatedHeightBeforeLineNumber(lineNumber + (includeViewZones ? 1 : 0));
        return previousLinesHeight + previousWhitespacesHeight + this._paddingTop;
    }
    /**
     * The maximum min width for all whitespaces.
     */ getWhitespaceMinWidth() {
        this._checkPendingChanges();
        if (this._minWidth === -1) {
            let minWidth = 0;
            for(let i = 0, len = this._arr.length; i < len; i++)minWidth = Math.max(minWidth, this._arr[i].minWidth);
            this._minWidth = minWidth;
        }
        return this._minWidth;
    }
    /**
     * Check if `verticalOffset` is below all lines.
     */ isAfterLines(verticalOffset) {
        this._checkPendingChanges();
        const totalHeight = this.getLinesTotalHeight();
        return verticalOffset > totalHeight;
    }
    isInTopPadding(verticalOffset) {
        if (this._paddingTop === 0) return false;
        this._checkPendingChanges();
        return verticalOffset < this._paddingTop;
    }
    isInBottomPadding(verticalOffset) {
        if (this._paddingBottom === 0) return false;
        this._checkPendingChanges();
        const totalHeight = this.getLinesTotalHeight();
        return verticalOffset >= totalHeight - this._paddingBottom;
    }
    /**
     * Find the first line number that is at or after vertical offset `verticalOffset`.
     * i.e. if getVerticalOffsetForLine(line) is x and getVerticalOffsetForLine(line + 1) is y, then
     * getLineNumberAtOrAfterVerticalOffset(i) = line, x <= i < y.
     *
     * @param verticalOffset The vertical offset to search at.
     * @return The line number at or after vertical offset `verticalOffset`.
     */ getLineNumberAtOrAfterVerticalOffset(verticalOffset) {
        this._checkPendingChanges();
        verticalOffset = verticalOffset | 0;
        if (verticalOffset < 0) return 1;
        const linesCount = this._lineCount | 0;
        const lineHeight = this._lineHeight;
        let minLineNumber = 1;
        let maxLineNumber = linesCount;
        while(minLineNumber < maxLineNumber){
            const midLineNumber = (minLineNumber + maxLineNumber) / 2 | 0;
            const midLineNumberVerticalOffset = this.getVerticalOffsetForLineNumber(midLineNumber) | 0;
            if (verticalOffset >= midLineNumberVerticalOffset + lineHeight) // vertical offset is after mid line number
            minLineNumber = midLineNumber + 1;
            else if (verticalOffset >= midLineNumberVerticalOffset) // Hit
            return midLineNumber;
            else // vertical offset is before mid line number, but mid line number could still be what we're searching for
            maxLineNumber = midLineNumber;
        }
        if (minLineNumber > linesCount) return linesCount;
        return minLineNumber;
    }
    /**
     * Get all the lines and their relative vertical offsets that are positioned between `verticalOffset1` and `verticalOffset2`.
     *
     * @param verticalOffset1 The beginning of the viewport.
     * @param verticalOffset2 The end of the viewport.
     * @return A structure describing the lines positioned between `verticalOffset1` and `verticalOffset2`.
     */ getLinesViewportData(verticalOffset1, verticalOffset2) {
        this._checkPendingChanges();
        verticalOffset1 = verticalOffset1 | 0;
        verticalOffset2 = verticalOffset2 | 0;
        const lineHeight = this._lineHeight;
        // Find first line number
        // We don't live in a perfect world, so the line number might start before or after verticalOffset1
        const startLineNumber = this.getLineNumberAtOrAfterVerticalOffset(verticalOffset1) | 0;
        const startLineNumberVerticalOffset = this.getVerticalOffsetForLineNumber(startLineNumber) | 0;
        let endLineNumber = this._lineCount | 0;
        // Also keep track of what whitespace we've got
        let whitespaceIndex = this.getFirstWhitespaceIndexAfterLineNumber(startLineNumber) | 0;
        const whitespaceCount = this.getWhitespacesCount() | 0;
        let currentWhitespaceHeight;
        let currentWhitespaceAfterLineNumber;
        if (whitespaceIndex === -1) {
            whitespaceIndex = whitespaceCount;
            currentWhitespaceAfterLineNumber = endLineNumber + 1;
            currentWhitespaceHeight = 0;
        } else {
            currentWhitespaceAfterLineNumber = this.getAfterLineNumberForWhitespaceIndex(whitespaceIndex) | 0;
            currentWhitespaceHeight = this.getHeightForWhitespaceIndex(whitespaceIndex) | 0;
        }
        let currentVerticalOffset = startLineNumberVerticalOffset;
        let currentLineRelativeOffset = currentVerticalOffset;
        // IE (all versions) cannot handle units above about 1,533,908 px, so every 500k pixels bring numbers down
        const STEP_SIZE = 500000;
        let bigNumbersDelta = 0;
        if (startLineNumberVerticalOffset >= STEP_SIZE) {
            // Compute a delta that guarantees that lines are positioned at `lineHeight` increments
            bigNumbersDelta = Math.floor(startLineNumberVerticalOffset / STEP_SIZE) * STEP_SIZE;
            bigNumbersDelta = Math.floor(bigNumbersDelta / lineHeight) * lineHeight;
            currentLineRelativeOffset -= bigNumbersDelta;
        }
        const linesOffsets = [];
        const verticalCenter = verticalOffset1 + (verticalOffset2 - verticalOffset1) / 2;
        let centeredLineNumber = -1;
        // Figure out how far the lines go
        for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++){
            if (centeredLineNumber === -1) {
                const currentLineTop = currentVerticalOffset;
                const currentLineBottom = currentVerticalOffset + lineHeight;
                if (currentLineTop <= verticalCenter && verticalCenter < currentLineBottom || currentLineTop > verticalCenter) centeredLineNumber = lineNumber;
            }
            // Count current line height in the vertical offsets
            currentVerticalOffset += lineHeight;
            linesOffsets[lineNumber - startLineNumber] = currentLineRelativeOffset;
            // Next line starts immediately after this one
            currentLineRelativeOffset += lineHeight;
            while(currentWhitespaceAfterLineNumber === lineNumber){
                // Push down next line with the height of the current whitespace
                currentLineRelativeOffset += currentWhitespaceHeight;
                // Count current whitespace in the vertical offsets
                currentVerticalOffset += currentWhitespaceHeight;
                whitespaceIndex++;
                if (whitespaceIndex >= whitespaceCount) currentWhitespaceAfterLineNumber = endLineNumber + 1;
                else {
                    currentWhitespaceAfterLineNumber = this.getAfterLineNumberForWhitespaceIndex(whitespaceIndex) | 0;
                    currentWhitespaceHeight = this.getHeightForWhitespaceIndex(whitespaceIndex) | 0;
                }
            }
            if (currentVerticalOffset >= verticalOffset2) {
                // We have covered the entire viewport area, time to stop
                endLineNumber = lineNumber;
                break;
            }
        }
        if (centeredLineNumber === -1) centeredLineNumber = endLineNumber;
        const endLineNumberVerticalOffset = this.getVerticalOffsetForLineNumber(endLineNumber) | 0;
        let completelyVisibleStartLineNumber = startLineNumber;
        let completelyVisibleEndLineNumber = endLineNumber;
        if (completelyVisibleStartLineNumber < completelyVisibleEndLineNumber) {
            if (startLineNumberVerticalOffset < verticalOffset1) completelyVisibleStartLineNumber++;
        }
        if (completelyVisibleStartLineNumber < completelyVisibleEndLineNumber) {
            if (endLineNumberVerticalOffset + lineHeight > verticalOffset2) completelyVisibleEndLineNumber--;
        }
        return {
            bigNumbersDelta: bigNumbersDelta,
            startLineNumber: startLineNumber,
            endLineNumber: endLineNumber,
            relativeVerticalOffset: linesOffsets,
            centeredLineNumber: centeredLineNumber,
            completelyVisibleStartLineNumber: completelyVisibleStartLineNumber,
            completelyVisibleEndLineNumber: completelyVisibleEndLineNumber,
            lineHeight: this._lineHeight
        };
    }
    getVerticalOffsetForWhitespaceIndex(whitespaceIndex) {
        this._checkPendingChanges();
        whitespaceIndex = whitespaceIndex | 0;
        const afterLineNumber = this.getAfterLineNumberForWhitespaceIndex(whitespaceIndex);
        let previousLinesHeight;
        if (afterLineNumber >= 1) previousLinesHeight = this._lineHeight * afterLineNumber;
        else previousLinesHeight = 0;
        let previousWhitespacesHeight;
        if (whitespaceIndex > 0) previousWhitespacesHeight = this.getWhitespacesAccumulatedHeight(whitespaceIndex - 1);
        else previousWhitespacesHeight = 0;
        return previousLinesHeight + previousWhitespacesHeight + this._paddingTop;
    }
    getWhitespaceIndexAtOrAfterVerticallOffset(verticalOffset) {
        this._checkPendingChanges();
        verticalOffset = verticalOffset | 0;
        let minWhitespaceIndex = 0;
        let maxWhitespaceIndex = this.getWhitespacesCount() - 1;
        if (maxWhitespaceIndex < 0) return -1;
        // Special case: nothing to be found
        const maxWhitespaceVerticalOffset = this.getVerticalOffsetForWhitespaceIndex(maxWhitespaceIndex);
        const maxWhitespaceHeight = this.getHeightForWhitespaceIndex(maxWhitespaceIndex);
        if (verticalOffset >= maxWhitespaceVerticalOffset + maxWhitespaceHeight) return -1;
        while(minWhitespaceIndex < maxWhitespaceIndex){
            const midWhitespaceIndex = Math.floor((minWhitespaceIndex + maxWhitespaceIndex) / 2);
            const midWhitespaceVerticalOffset = this.getVerticalOffsetForWhitespaceIndex(midWhitespaceIndex);
            const midWhitespaceHeight = this.getHeightForWhitespaceIndex(midWhitespaceIndex);
            if (verticalOffset >= midWhitespaceVerticalOffset + midWhitespaceHeight) // vertical offset is after whitespace
            minWhitespaceIndex = midWhitespaceIndex + 1;
            else if (verticalOffset >= midWhitespaceVerticalOffset) // Hit
            return midWhitespaceIndex;
            else // vertical offset is before whitespace, but midWhitespaceIndex might still be what we're searching for
            maxWhitespaceIndex = midWhitespaceIndex;
        }
        return minWhitespaceIndex;
    }
    /**
     * Get exactly the whitespace that is layouted at `verticalOffset`.
     *
     * @param verticalOffset The vertical offset.
     * @return Precisely the whitespace that is layouted at `verticaloffset` or null.
     */ getWhitespaceAtVerticalOffset(verticalOffset) {
        this._checkPendingChanges();
        verticalOffset = verticalOffset | 0;
        const candidateIndex = this.getWhitespaceIndexAtOrAfterVerticallOffset(verticalOffset);
        if (candidateIndex < 0) return null;
        if (candidateIndex >= this.getWhitespacesCount()) return null;
        const candidateTop = this.getVerticalOffsetForWhitespaceIndex(candidateIndex);
        if (candidateTop > verticalOffset) return null;
        const candidateHeight = this.getHeightForWhitespaceIndex(candidateIndex);
        const candidateId = this.getIdForWhitespaceIndex(candidateIndex);
        const candidateAfterLineNumber = this.getAfterLineNumberForWhitespaceIndex(candidateIndex);
        return {
            id: candidateId,
            afterLineNumber: candidateAfterLineNumber,
            verticalOffset: candidateTop,
            height: candidateHeight
        };
    }
    /**
     * Get a list of whitespaces that are positioned between `verticalOffset1` and `verticalOffset2`.
     *
     * @param verticalOffset1 The beginning of the viewport.
     * @param verticalOffset2 The end of the viewport.
     * @return An array with all the whitespaces in the viewport. If no whitespace is in viewport, the array is empty.
     */ getWhitespaceViewportData(verticalOffset1, verticalOffset2) {
        this._checkPendingChanges();
        verticalOffset1 = verticalOffset1 | 0;
        verticalOffset2 = verticalOffset2 | 0;
        const startIndex = this.getWhitespaceIndexAtOrAfterVerticallOffset(verticalOffset1);
        const endIndex = this.getWhitespacesCount() - 1;
        if (startIndex < 0) return [];
        const result = [];
        for(let i = startIndex; i <= endIndex; i++){
            const top = this.getVerticalOffsetForWhitespaceIndex(i);
            const height = this.getHeightForWhitespaceIndex(i);
            if (top >= verticalOffset2) break;
            result.push({
                id: this.getIdForWhitespaceIndex(i),
                afterLineNumber: this.getAfterLineNumberForWhitespaceIndex(i),
                verticalOffset: top,
                height: height
            });
        }
        return result;
    }
    /**
     * Get all whitespaces.
     */ getWhitespaces() {
        this._checkPendingChanges();
        return this._arr.slice(0);
    }
    /**
     * The number of whitespaces.
     */ getWhitespacesCount() {
        this._checkPendingChanges();
        return this._arr.length;
    }
    /**
     * Get the `id` for whitespace at index `index`.
     *
     * @param index The index of the whitespace.
     * @return `id` of whitespace at `index`.
     */ getIdForWhitespaceIndex(index) {
        this._checkPendingChanges();
        index = index | 0;
        return this._arr[index].id;
    }
    /**
     * Get the `afterLineNumber` for whitespace at index `index`.
     *
     * @param index The index of the whitespace.
     * @return `afterLineNumber` of whitespace at `index`.
     */ getAfterLineNumberForWhitespaceIndex(index) {
        this._checkPendingChanges();
        index = index | 0;
        return this._arr[index].afterLineNumber;
    }
    /**
     * Get the `height` for whitespace at index `index`.
     *
     * @param index The index of the whitespace.
     * @return `height` of whitespace at `index`.
     */ getHeightForWhitespaceIndex(index) {
        this._checkPendingChanges();
        index = index | 0;
        return this._arr[index].height;
    }
}

},{"../../../base/common/strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lGBM0":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewModelDecorations", ()=>ViewModelDecorations);
parcelHelpers.export(exports, "isModelDecorationVisible", ()=>isModelDecorationVisible);
parcelHelpers.export(exports, "isModelDecorationInComment", ()=>isModelDecorationInComment);
parcelHelpers.export(exports, "isModelDecorationInString", ()=>isModelDecorationInString);
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
var _viewModelJs = require("../viewModel.js");
var _editorOptionsJs = require("../config/editorOptions.js");
class ViewModelDecorations {
    constructor(editorId, model, configuration, linesCollection, coordinatesConverter){
        this.editorId = editorId;
        this.model = model;
        this.configuration = configuration;
        this._linesCollection = linesCollection;
        this._coordinatesConverter = coordinatesConverter;
        this._decorationsCache = Object.create(null);
        this._cachedModelDecorationsResolver = null;
        this._cachedModelDecorationsResolverViewRange = null;
    }
    _clearCachedModelDecorationsResolver() {
        this._cachedModelDecorationsResolver = null;
        this._cachedModelDecorationsResolverViewRange = null;
    }
    dispose() {
        this._decorationsCache = Object.create(null);
        this._clearCachedModelDecorationsResolver();
    }
    reset() {
        this._decorationsCache = Object.create(null);
        this._clearCachedModelDecorationsResolver();
    }
    onModelDecorationsChanged() {
        this._decorationsCache = Object.create(null);
        this._clearCachedModelDecorationsResolver();
    }
    onLineMappingChanged() {
        this._decorationsCache = Object.create(null);
        this._clearCachedModelDecorationsResolver();
    }
    _getOrCreateViewModelDecoration(modelDecoration) {
        const id = modelDecoration.id;
        let r = this._decorationsCache[id];
        if (!r) {
            const modelRange = modelDecoration.range;
            const options = modelDecoration.options;
            let viewRange;
            if (options.isWholeLine) {
                const start = this._coordinatesConverter.convertModelPositionToViewPosition(new (0, _positionJs.Position)(modelRange.startLineNumber, 1), 0 /* PositionAffinity.Left */ , false, true);
                const end = this._coordinatesConverter.convertModelPositionToViewPosition(new (0, _positionJs.Position)(modelRange.endLineNumber, this.model.getLineMaxColumn(modelRange.endLineNumber)), 1 /* PositionAffinity.Right */ );
                viewRange = new (0, _rangeJs.Range)(start.lineNumber, start.column, end.lineNumber, end.column);
            } else // For backwards compatibility reasons, we want injected text before any decoration.
            // Thus, move decorations to the right.
            viewRange = this._coordinatesConverter.convertModelRangeToViewRange(modelRange, 1 /* PositionAffinity.Right */ );
            r = new (0, _viewModelJs.ViewModelDecoration)(viewRange, options);
            this._decorationsCache[id] = r;
        }
        return r;
    }
    getMinimapDecorationsInRange(range) {
        return this._getDecorationsInRange(range, true, false).decorations;
    }
    getDecorationsViewportData(viewRange) {
        let cacheIsValid = this._cachedModelDecorationsResolver !== null;
        cacheIsValid = cacheIsValid && viewRange.equalsRange(this._cachedModelDecorationsResolverViewRange);
        if (!cacheIsValid) {
            this._cachedModelDecorationsResolver = this._getDecorationsInRange(viewRange, false, false);
            this._cachedModelDecorationsResolverViewRange = viewRange;
        }
        return this._cachedModelDecorationsResolver;
    }
    getInlineDecorationsOnLine(lineNumber, onlyMinimapDecorations = false, onlyMarginDecorations = false) {
        const range = new (0, _rangeJs.Range)(lineNumber, this._linesCollection.getViewLineMinColumn(lineNumber), lineNumber, this._linesCollection.getViewLineMaxColumn(lineNumber));
        return this._getDecorationsInRange(range, onlyMinimapDecorations, onlyMarginDecorations).inlineDecorations[0];
    }
    _getDecorationsInRange(viewRange, onlyMinimapDecorations, onlyMarginDecorations) {
        const modelDecorations = this._linesCollection.getDecorationsInRange(viewRange, this.editorId, (0, _editorOptionsJs.filterValidationDecorations)(this.configuration.options), onlyMinimapDecorations, onlyMarginDecorations);
        const startLineNumber = viewRange.startLineNumber;
        const endLineNumber = viewRange.endLineNumber;
        const decorationsInViewport = [];
        let decorationsInViewportLen = 0;
        const inlineDecorations = [];
        for(let j = startLineNumber; j <= endLineNumber; j++)inlineDecorations[j - startLineNumber] = [];
        for(let i = 0, len = modelDecorations.length; i < len; i++){
            const modelDecoration = modelDecorations[i];
            const decorationOptions = modelDecoration.options;
            if (!isModelDecorationVisible(this.model, modelDecoration)) continue;
            const viewModelDecoration = this._getOrCreateViewModelDecoration(modelDecoration);
            const viewRange = viewModelDecoration.range;
            decorationsInViewport[decorationsInViewportLen++] = viewModelDecoration;
            if (decorationOptions.inlineClassName) {
                const inlineDecoration = new (0, _viewModelJs.InlineDecoration)(viewRange, decorationOptions.inlineClassName, decorationOptions.inlineClassNameAffectsLetterSpacing ? 3 /* InlineDecorationType.RegularAffectingLetterSpacing */  : 0 /* InlineDecorationType.Regular */ );
                const intersectedStartLineNumber = Math.max(startLineNumber, viewRange.startLineNumber);
                const intersectedEndLineNumber = Math.min(endLineNumber, viewRange.endLineNumber);
                for(let j = intersectedStartLineNumber; j <= intersectedEndLineNumber; j++)inlineDecorations[j - startLineNumber].push(inlineDecoration);
            }
            if (decorationOptions.beforeContentClassName) {
                if (startLineNumber <= viewRange.startLineNumber && viewRange.startLineNumber <= endLineNumber) {
                    const inlineDecoration = new (0, _viewModelJs.InlineDecoration)(new (0, _rangeJs.Range)(viewRange.startLineNumber, viewRange.startColumn, viewRange.startLineNumber, viewRange.startColumn), decorationOptions.beforeContentClassName, 1 /* InlineDecorationType.Before */ );
                    inlineDecorations[viewRange.startLineNumber - startLineNumber].push(inlineDecoration);
                }
            }
            if (decorationOptions.afterContentClassName) {
                if (startLineNumber <= viewRange.endLineNumber && viewRange.endLineNumber <= endLineNumber) {
                    const inlineDecoration = new (0, _viewModelJs.InlineDecoration)(new (0, _rangeJs.Range)(viewRange.endLineNumber, viewRange.endColumn, viewRange.endLineNumber, viewRange.endColumn), decorationOptions.afterContentClassName, 2 /* InlineDecorationType.After */ );
                    inlineDecorations[viewRange.endLineNumber - startLineNumber].push(inlineDecoration);
                }
            }
        }
        return {
            decorations: decorationsInViewport,
            inlineDecorations: inlineDecorations
        };
    }
}
function isModelDecorationVisible(model, decoration) {
    if (decoration.options.hideInCommentTokens && isModelDecorationInComment(model, decoration)) return false;
    if (decoration.options.hideInStringTokens && isModelDecorationInString(model, decoration)) return false;
    return true;
}
function isModelDecorationInComment(model, decoration) {
    return testTokensInRange(model, decoration.range, (tokenType)=>tokenType === 1 /* StandardTokenType.Comment */ );
}
function isModelDecorationInString(model, decoration) {
    return testTokensInRange(model, decoration.range, (tokenType)=>tokenType === 2 /* StandardTokenType.String */ );
}
/**
 * Calls the callback for every token that intersects the range.
 * If the callback returns `false`, iteration stops and `false` is returned.
 * Otherwise, `true` is returned.
 */ function testTokensInRange(model, range, callback) {
    for(let lineNumber = range.startLineNumber; lineNumber <= range.endLineNumber; lineNumber++){
        const lineTokens = model.tokenization.getLineTokens(lineNumber);
        const isFirstLine = lineNumber === range.startLineNumber;
        const isEndLine = lineNumber === range.endLineNumber;
        let tokenIdx = isFirstLine ? lineTokens.findTokenIndexAtOffset(range.startColumn - 1) : 0;
        while(tokenIdx < lineTokens.getCount()){
            if (isEndLine) {
                const startOffset = lineTokens.getStartOffset(tokenIdx);
                if (startOffset > range.endColumn - 1) break;
            }
            const callbackResult = callback(lineTokens.getStandardTokenType(tokenIdx));
            if (!callbackResult) return false;
            tokenIdx++;
        }
    }
    return true;
}

},{"../core/position.js":"lvrPe","../core/range.js":"jmUPh","../viewModel.js":"5EHxj","../config/editorOptions.js":"3Xi00","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c6jcx":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewModelLinesFromProjectedModel", ()=>ViewModelLinesFromProjectedModel);
parcelHelpers.export(exports, "ViewModelLinesFromModelAsIs", ()=>ViewModelLinesFromModelAsIs);
var _arraysJs = require("../../../base/common/arrays.js");
var _positionJs = require("../core/position.js");
var _rangeJs = require("../core/range.js");
var _textModelGuidesJs = require("../textModelGuides.js");
var _textModelJs = require("../model/textModel.js");
var _textModelEventsJs = require("../textModelEvents.js");
var _viewEventsJs = require("../viewEvents.js");
var _modelLineProjectionJs = require("./modelLineProjection.js");
var _prefixSumComputerJs = require("../model/prefixSumComputer.js");
var _viewModelJs = require("../viewModel.js");
class ViewModelLinesFromProjectedModel {
    constructor(editorId, model, domLineBreaksComputerFactory, monospaceLineBreaksComputerFactory, fontInfo, tabSize, wrappingStrategy, wrappingColumn, wrappingIndent, wordBreak){
        this._editorId = editorId;
        this.model = model;
        this._validModelVersionId = -1;
        this._domLineBreaksComputerFactory = domLineBreaksComputerFactory;
        this._monospaceLineBreaksComputerFactory = monospaceLineBreaksComputerFactory;
        this.fontInfo = fontInfo;
        this.tabSize = tabSize;
        this.wrappingStrategy = wrappingStrategy;
        this.wrappingColumn = wrappingColumn;
        this.wrappingIndent = wrappingIndent;
        this.wordBreak = wordBreak;
        this._constructLines(/*resetHiddenAreas*/ true, null);
    }
    dispose() {
        this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, []);
    }
    createCoordinatesConverter() {
        return new CoordinatesConverter(this);
    }
    _constructLines(resetHiddenAreas, previousLineBreaks) {
        this.modelLineProjections = [];
        if (resetHiddenAreas) this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, []);
        const linesContent = this.model.getLinesContent();
        const injectedTextDecorations = this.model.getInjectedTextDecorations(this._editorId);
        const lineCount = linesContent.length;
        const lineBreaksComputer = this.createLineBreaksComputer();
        const injectedTextQueue = new _arraysJs.ArrayQueue((0, _textModelEventsJs.LineInjectedText).fromDecorations(injectedTextDecorations));
        for(let i = 0; i < lineCount; i++){
            const lineInjectedText = injectedTextQueue.takeWhile((t)=>t.lineNumber === i + 1);
            lineBreaksComputer.addRequest(linesContent[i], lineInjectedText, previousLineBreaks ? previousLineBreaks[i] : null);
        }
        const linesBreaks = lineBreaksComputer.finalize();
        const values = [];
        const hiddenAreas = this.hiddenAreasDecorationIds.map((areaId)=>this.model.getDecorationRange(areaId)).sort((0, _rangeJs.Range).compareRangesUsingStarts);
        let hiddenAreaStart = 1, hiddenAreaEnd = 0;
        let hiddenAreaIdx = -1;
        let nextLineNumberToUpdateHiddenArea = hiddenAreaIdx + 1 < hiddenAreas.length ? hiddenAreaEnd + 1 : lineCount + 2;
        for(let i = 0; i < lineCount; i++){
            const lineNumber = i + 1;
            if (lineNumber === nextLineNumberToUpdateHiddenArea) {
                hiddenAreaIdx++;
                hiddenAreaStart = hiddenAreas[hiddenAreaIdx].startLineNumber;
                hiddenAreaEnd = hiddenAreas[hiddenAreaIdx].endLineNumber;
                nextLineNumberToUpdateHiddenArea = hiddenAreaIdx + 1 < hiddenAreas.length ? hiddenAreaEnd + 1 : lineCount + 2;
            }
            const isInHiddenArea = lineNumber >= hiddenAreaStart && lineNumber <= hiddenAreaEnd;
            const line = (0, _modelLineProjectionJs.createModelLineProjection)(linesBreaks[i], !isInHiddenArea);
            values[i] = line.getViewLineCount();
            this.modelLineProjections[i] = line;
        }
        this._validModelVersionId = this.model.getVersionId();
        this.projectedModelLineLineCounts = new (0, _prefixSumComputerJs.ConstantTimePrefixSumComputer)(values);
    }
    getHiddenAreas() {
        return this.hiddenAreasDecorationIds.map((decId)=>this.model.getDecorationRange(decId));
    }
    setHiddenAreas(_ranges) {
        const validatedRanges = _ranges.map((r)=>this.model.validateRange(r));
        const newRanges = normalizeLineRanges(validatedRanges);
        // TODO@Martin: Please stop calling this method on each model change!
        // This checks if there really was a change
        const oldRanges = this.hiddenAreasDecorationIds.map((areaId)=>this.model.getDecorationRange(areaId)).sort((0, _rangeJs.Range).compareRangesUsingStarts);
        if (newRanges.length === oldRanges.length) {
            let hasDifference = false;
            for(let i = 0; i < newRanges.length; i++)if (!newRanges[i].equalsRange(oldRanges[i])) {
                hasDifference = true;
                break;
            }
            if (!hasDifference) return false;
        }
        const newDecorations = newRanges.map((r)=>({
                range: r,
                options: (0, _textModelJs.ModelDecorationOptions).EMPTY
            }));
        this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, newDecorations);
        const hiddenAreas = newRanges;
        let hiddenAreaStart = 1, hiddenAreaEnd = 0;
        let hiddenAreaIdx = -1;
        let nextLineNumberToUpdateHiddenArea = hiddenAreaIdx + 1 < hiddenAreas.length ? hiddenAreaEnd + 1 : this.modelLineProjections.length + 2;
        let hasVisibleLine = false;
        for(let i = 0; i < this.modelLineProjections.length; i++){
            const lineNumber = i + 1;
            if (lineNumber === nextLineNumberToUpdateHiddenArea) {
                hiddenAreaIdx++;
                hiddenAreaStart = hiddenAreas[hiddenAreaIdx].startLineNumber;
                hiddenAreaEnd = hiddenAreas[hiddenAreaIdx].endLineNumber;
                nextLineNumberToUpdateHiddenArea = hiddenAreaIdx + 1 < hiddenAreas.length ? hiddenAreaEnd + 1 : this.modelLineProjections.length + 2;
            }
            let lineChanged = false;
            if (lineNumber >= hiddenAreaStart && lineNumber <= hiddenAreaEnd) // Line should be hidden
            {
                if (this.modelLineProjections[i].isVisible()) {
                    this.modelLineProjections[i] = this.modelLineProjections[i].setVisible(false);
                    lineChanged = true;
                }
            } else {
                hasVisibleLine = true;
                // Line should be visible
                if (!this.modelLineProjections[i].isVisible()) {
                    this.modelLineProjections[i] = this.modelLineProjections[i].setVisible(true);
                    lineChanged = true;
                }
            }
            if (lineChanged) {
                const newOutputLineCount = this.modelLineProjections[i].getViewLineCount();
                this.projectedModelLineLineCounts.setValue(i, newOutputLineCount);
            }
        }
        if (!hasVisibleLine) // Cannot have everything be hidden => reveal everything!
        this.setHiddenAreas([]);
        return true;
    }
    modelPositionIsVisible(modelLineNumber, _modelColumn) {
        if (modelLineNumber < 1 || modelLineNumber > this.modelLineProjections.length) // invalid arguments
        return false;
        return this.modelLineProjections[modelLineNumber - 1].isVisible();
    }
    getModelLineViewLineCount(modelLineNumber) {
        if (modelLineNumber < 1 || modelLineNumber > this.modelLineProjections.length) // invalid arguments
        return 1;
        return this.modelLineProjections[modelLineNumber - 1].getViewLineCount();
    }
    setTabSize(newTabSize) {
        if (this.tabSize === newTabSize) return false;
        this.tabSize = newTabSize;
        this._constructLines(/*resetHiddenAreas*/ false, null);
        return true;
    }
    setWrappingSettings(fontInfo, wrappingStrategy, wrappingColumn, wrappingIndent, wordBreak) {
        const equalFontInfo = this.fontInfo.equals(fontInfo);
        const equalWrappingStrategy = this.wrappingStrategy === wrappingStrategy;
        const equalWrappingColumn = this.wrappingColumn === wrappingColumn;
        const equalWrappingIndent = this.wrappingIndent === wrappingIndent;
        const equalWordBreak = this.wordBreak === wordBreak;
        if (equalFontInfo && equalWrappingStrategy && equalWrappingColumn && equalWrappingIndent && equalWordBreak) return false;
        const onlyWrappingColumnChanged = equalFontInfo && equalWrappingStrategy && !equalWrappingColumn && equalWrappingIndent && equalWordBreak;
        this.fontInfo = fontInfo;
        this.wrappingStrategy = wrappingStrategy;
        this.wrappingColumn = wrappingColumn;
        this.wrappingIndent = wrappingIndent;
        this.wordBreak = wordBreak;
        let previousLineBreaks = null;
        if (onlyWrappingColumnChanged) {
            previousLineBreaks = [];
            for(let i = 0, len = this.modelLineProjections.length; i < len; i++)previousLineBreaks[i] = this.modelLineProjections[i].getProjectionData();
        }
        this._constructLines(/*resetHiddenAreas*/ false, previousLineBreaks);
        return true;
    }
    createLineBreaksComputer() {
        const lineBreaksComputerFactory = this.wrappingStrategy === "advanced" ? this._domLineBreaksComputerFactory : this._monospaceLineBreaksComputerFactory;
        return lineBreaksComputerFactory.createLineBreaksComputer(this.fontInfo, this.tabSize, this.wrappingColumn, this.wrappingIndent, this.wordBreak);
    }
    onModelFlushed() {
        this._constructLines(/*resetHiddenAreas*/ true, null);
    }
    onModelLinesDeleted(versionId, fromLineNumber, toLineNumber) {
        if (!versionId || versionId <= this._validModelVersionId) // Here we check for versionId in case the lines were reconstructed in the meantime.
        // We don't want to apply stale change events on top of a newer read model state.
        return null;
        const outputFromLineNumber = fromLineNumber === 1 ? 1 : this.projectedModelLineLineCounts.getPrefixSum(fromLineNumber - 1) + 1;
        const outputToLineNumber = this.projectedModelLineLineCounts.getPrefixSum(toLineNumber);
        this.modelLineProjections.splice(fromLineNumber - 1, toLineNumber - fromLineNumber + 1);
        this.projectedModelLineLineCounts.removeValues(fromLineNumber - 1, toLineNumber - fromLineNumber + 1);
        return new _viewEventsJs.ViewLinesDeletedEvent(outputFromLineNumber, outputToLineNumber);
    }
    onModelLinesInserted(versionId, fromLineNumber, _toLineNumber, lineBreaks) {
        if (!versionId || versionId <= this._validModelVersionId) // Here we check for versionId in case the lines were reconstructed in the meantime.
        // We don't want to apply stale change events on top of a newer read model state.
        return null;
        // cannot use this.getHiddenAreas() because those decorations have already seen the effect of this model change
        const isInHiddenArea = fromLineNumber > 2 && !this.modelLineProjections[fromLineNumber - 2].isVisible();
        const outputFromLineNumber = fromLineNumber === 1 ? 1 : this.projectedModelLineLineCounts.getPrefixSum(fromLineNumber - 1) + 1;
        let totalOutputLineCount = 0;
        const insertLines = [];
        const insertPrefixSumValues = [];
        for(let i = 0, len = lineBreaks.length; i < len; i++){
            const line = (0, _modelLineProjectionJs.createModelLineProjection)(lineBreaks[i], !isInHiddenArea);
            insertLines.push(line);
            const outputLineCount = line.getViewLineCount();
            totalOutputLineCount += outputLineCount;
            insertPrefixSumValues[i] = outputLineCount;
        }
        // TODO@Alex: use arrays.arrayInsert
        this.modelLineProjections = this.modelLineProjections.slice(0, fromLineNumber - 1).concat(insertLines).concat(this.modelLineProjections.slice(fromLineNumber - 1));
        this.projectedModelLineLineCounts.insertValues(fromLineNumber - 1, insertPrefixSumValues);
        return new _viewEventsJs.ViewLinesInsertedEvent(outputFromLineNumber, outputFromLineNumber + totalOutputLineCount - 1);
    }
    onModelLineChanged(versionId, lineNumber, lineBreakData) {
        if (versionId !== null && versionId <= this._validModelVersionId) // Here we check for versionId in case the lines were reconstructed in the meantime.
        // We don't want to apply stale change events on top of a newer read model state.
        return [
            false,
            null,
            null,
            null
        ];
        const lineIndex = lineNumber - 1;
        const oldOutputLineCount = this.modelLineProjections[lineIndex].getViewLineCount();
        const isVisible = this.modelLineProjections[lineIndex].isVisible();
        const line = (0, _modelLineProjectionJs.createModelLineProjection)(lineBreakData, isVisible);
        this.modelLineProjections[lineIndex] = line;
        const newOutputLineCount = this.modelLineProjections[lineIndex].getViewLineCount();
        let lineMappingChanged = false;
        let changeFrom = 0;
        let changeTo = -1;
        let insertFrom = 0;
        let insertTo = -1;
        let deleteFrom = 0;
        let deleteTo = -1;
        if (oldOutputLineCount > newOutputLineCount) {
            changeFrom = this.projectedModelLineLineCounts.getPrefixSum(lineNumber - 1) + 1;
            changeTo = changeFrom + newOutputLineCount - 1;
            deleteFrom = changeTo + 1;
            deleteTo = deleteFrom + (oldOutputLineCount - newOutputLineCount) - 1;
            lineMappingChanged = true;
        } else if (oldOutputLineCount < newOutputLineCount) {
            changeFrom = this.projectedModelLineLineCounts.getPrefixSum(lineNumber - 1) + 1;
            changeTo = changeFrom + oldOutputLineCount - 1;
            insertFrom = changeTo + 1;
            insertTo = insertFrom + (newOutputLineCount - oldOutputLineCount) - 1;
            lineMappingChanged = true;
        } else {
            changeFrom = this.projectedModelLineLineCounts.getPrefixSum(lineNumber - 1) + 1;
            changeTo = changeFrom + newOutputLineCount - 1;
        }
        this.projectedModelLineLineCounts.setValue(lineIndex, newOutputLineCount);
        const viewLinesChangedEvent = changeFrom <= changeTo ? new _viewEventsJs.ViewLinesChangedEvent(changeFrom, changeTo - changeFrom + 1) : null;
        const viewLinesInsertedEvent = insertFrom <= insertTo ? new _viewEventsJs.ViewLinesInsertedEvent(insertFrom, insertTo) : null;
        const viewLinesDeletedEvent = deleteFrom <= deleteTo ? new _viewEventsJs.ViewLinesDeletedEvent(deleteFrom, deleteTo) : null;
        return [
            lineMappingChanged,
            viewLinesChangedEvent,
            viewLinesInsertedEvent,
            viewLinesDeletedEvent
        ];
    }
    acceptVersionId(versionId) {
        this._validModelVersionId = versionId;
        if (this.modelLineProjections.length === 1 && !this.modelLineProjections[0].isVisible()) // At least one line must be visible => reset hidden areas
        this.setHiddenAreas([]);
    }
    getViewLineCount() {
        return this.projectedModelLineLineCounts.getTotalSum();
    }
    _toValidViewLineNumber(viewLineNumber) {
        if (viewLineNumber < 1) return 1;
        const viewLineCount = this.getViewLineCount();
        if (viewLineNumber > viewLineCount) return viewLineCount;
        return viewLineNumber | 0;
    }
    getActiveIndentGuide(viewLineNumber, minLineNumber, maxLineNumber) {
        viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
        minLineNumber = this._toValidViewLineNumber(minLineNumber);
        maxLineNumber = this._toValidViewLineNumber(maxLineNumber);
        const modelPosition = this.convertViewPositionToModelPosition(viewLineNumber, this.getViewLineMinColumn(viewLineNumber));
        const modelMinPosition = this.convertViewPositionToModelPosition(minLineNumber, this.getViewLineMinColumn(minLineNumber));
        const modelMaxPosition = this.convertViewPositionToModelPosition(maxLineNumber, this.getViewLineMinColumn(maxLineNumber));
        const result = this.model.guides.getActiveIndentGuide(modelPosition.lineNumber, modelMinPosition.lineNumber, modelMaxPosition.lineNumber);
        const viewStartPosition = this.convertModelPositionToViewPosition(result.startLineNumber, 1);
        const viewEndPosition = this.convertModelPositionToViewPosition(result.endLineNumber, this.model.getLineMaxColumn(result.endLineNumber));
        return {
            startLineNumber: viewStartPosition.lineNumber,
            endLineNumber: viewEndPosition.lineNumber,
            indent: result.indent
        };
    }
    // #region ViewLineInfo
    getViewLineInfo(viewLineNumber) {
        viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
        const r = this.projectedModelLineLineCounts.getIndexOf(viewLineNumber - 1);
        const lineIndex = r.index;
        const remainder = r.remainder;
        return new ViewLineInfo(lineIndex + 1, remainder);
    }
    getMinColumnOfViewLine(viewLineInfo) {
        return this.modelLineProjections[viewLineInfo.modelLineNumber - 1].getViewLineMinColumn(this.model, viewLineInfo.modelLineNumber, viewLineInfo.modelLineWrappedLineIdx);
    }
    getMaxColumnOfViewLine(viewLineInfo) {
        return this.modelLineProjections[viewLineInfo.modelLineNumber - 1].getViewLineMaxColumn(this.model, viewLineInfo.modelLineNumber, viewLineInfo.modelLineWrappedLineIdx);
    }
    getModelStartPositionOfViewLine(viewLineInfo) {
        const line = this.modelLineProjections[viewLineInfo.modelLineNumber - 1];
        const minViewColumn = line.getViewLineMinColumn(this.model, viewLineInfo.modelLineNumber, viewLineInfo.modelLineWrappedLineIdx);
        const column = line.getModelColumnOfViewPosition(viewLineInfo.modelLineWrappedLineIdx, minViewColumn);
        return new (0, _positionJs.Position)(viewLineInfo.modelLineNumber, column);
    }
    getModelEndPositionOfViewLine(viewLineInfo) {
        const line = this.modelLineProjections[viewLineInfo.modelLineNumber - 1];
        const maxViewColumn = line.getViewLineMaxColumn(this.model, viewLineInfo.modelLineNumber, viewLineInfo.modelLineWrappedLineIdx);
        const column = line.getModelColumnOfViewPosition(viewLineInfo.modelLineWrappedLineIdx, maxViewColumn);
        return new (0, _positionJs.Position)(viewLineInfo.modelLineNumber, column);
    }
    getViewLineInfosGroupedByModelRanges(viewStartLineNumber, viewEndLineNumber) {
        const startViewLine = this.getViewLineInfo(viewStartLineNumber);
        const endViewLine = this.getViewLineInfo(viewEndLineNumber);
        const result = new Array();
        let lastVisibleModelPos = this.getModelStartPositionOfViewLine(startViewLine);
        let viewLines = new Array();
        for(let curModelLine = startViewLine.modelLineNumber; curModelLine <= endViewLine.modelLineNumber; curModelLine++){
            const line = this.modelLineProjections[curModelLine - 1];
            if (line.isVisible()) {
                const startOffset = curModelLine === startViewLine.modelLineNumber ? startViewLine.modelLineWrappedLineIdx : 0;
                const endOffset = curModelLine === endViewLine.modelLineNumber ? endViewLine.modelLineWrappedLineIdx + 1 : line.getViewLineCount();
                for(let i = startOffset; i < endOffset; i++)viewLines.push(new ViewLineInfo(curModelLine, i));
            }
            if (!line.isVisible() && lastVisibleModelPos) {
                const lastVisibleModelPos2 = new (0, _positionJs.Position)(curModelLine - 1, this.model.getLineMaxColumn(curModelLine - 1) + 1);
                const modelRange = (0, _rangeJs.Range).fromPositions(lastVisibleModelPos, lastVisibleModelPos2);
                result.push(new ViewLineInfoGroupedByModelRange(modelRange, viewLines));
                viewLines = [];
                lastVisibleModelPos = null;
            } else if (line.isVisible() && !lastVisibleModelPos) lastVisibleModelPos = new (0, _positionJs.Position)(curModelLine, 1);
        }
        if (lastVisibleModelPos) {
            const modelRange = (0, _rangeJs.Range).fromPositions(lastVisibleModelPos, this.getModelEndPositionOfViewLine(endViewLine));
            result.push(new ViewLineInfoGroupedByModelRange(modelRange, viewLines));
        }
        return result;
    }
    // #endregion
    getViewLinesBracketGuides(viewStartLineNumber, viewEndLineNumber, activeViewPosition, options) {
        const modelActivePosition = activeViewPosition ? this.convertViewPositionToModelPosition(activeViewPosition.lineNumber, activeViewPosition.column) : null;
        const resultPerViewLine = [];
        for (const group of this.getViewLineInfosGroupedByModelRanges(viewStartLineNumber, viewEndLineNumber)){
            const modelRangeStartLineNumber = group.modelRange.startLineNumber;
            const bracketGuidesPerModelLine = this.model.guides.getLinesBracketGuides(modelRangeStartLineNumber, group.modelRange.endLineNumber, modelActivePosition, options);
            for (const viewLineInfo of group.viewLines){
                const bracketGuides = bracketGuidesPerModelLine[viewLineInfo.modelLineNumber - modelRangeStartLineNumber];
                // visibleColumns stay as they are (this is a bug and needs to be fixed, but it is not a regression)
                // model-columns must be converted to view-model columns.
                const result = bracketGuides.map((g)=>{
                    if (g.forWrappedLinesAfterColumn !== -1) {
                        const p = this.modelLineProjections[viewLineInfo.modelLineNumber - 1].getViewPositionOfModelPosition(0, g.forWrappedLinesAfterColumn);
                        if (p.lineNumber >= viewLineInfo.modelLineWrappedLineIdx) return undefined;
                    }
                    if (g.forWrappedLinesBeforeOrAtColumn !== -1) {
                        const p = this.modelLineProjections[viewLineInfo.modelLineNumber - 1].getViewPositionOfModelPosition(0, g.forWrappedLinesBeforeOrAtColumn);
                        if (p.lineNumber < viewLineInfo.modelLineWrappedLineIdx) return undefined;
                    }
                    if (!g.horizontalLine) return g;
                    let column = -1;
                    if (g.column !== -1) {
                        const p = this.modelLineProjections[viewLineInfo.modelLineNumber - 1].getViewPositionOfModelPosition(0, g.column);
                        if (p.lineNumber === viewLineInfo.modelLineWrappedLineIdx) column = p.column;
                        else if (p.lineNumber < viewLineInfo.modelLineWrappedLineIdx) column = this.getMinColumnOfViewLine(viewLineInfo);
                        else if (p.lineNumber > viewLineInfo.modelLineWrappedLineIdx) return undefined;
                    }
                    const viewPosition = this.convertModelPositionToViewPosition(viewLineInfo.modelLineNumber, g.horizontalLine.endColumn);
                    const p = this.modelLineProjections[viewLineInfo.modelLineNumber - 1].getViewPositionOfModelPosition(0, g.horizontalLine.endColumn);
                    if (p.lineNumber === viewLineInfo.modelLineWrappedLineIdx) return new (0, _textModelGuidesJs.IndentGuide)(g.visibleColumn, column, g.className, new (0, _textModelGuidesJs.IndentGuideHorizontalLine)(g.horizontalLine.top, viewPosition.column), -1, -1);
                    else if (p.lineNumber < viewLineInfo.modelLineWrappedLineIdx) return undefined;
                    else {
                        if (g.visibleColumn !== -1) // Don't repeat horizontal lines that use visibleColumn for unrelated lines.
                        return undefined;
                        return new (0, _textModelGuidesJs.IndentGuide)(g.visibleColumn, column, g.className, new (0, _textModelGuidesJs.IndentGuideHorizontalLine)(g.horizontalLine.top, this.getMaxColumnOfViewLine(viewLineInfo)), -1, -1);
                    }
                });
                resultPerViewLine.push(result.filter((r)=>!!r));
            }
        }
        return resultPerViewLine;
    }
    getViewLinesIndentGuides(viewStartLineNumber, viewEndLineNumber) {
        // TODO: Use the same code as in `getViewLinesBracketGuides`.
        // Future TODO: Merge with `getViewLinesBracketGuides`.
        // However, this requires more refactoring of indent guides.
        viewStartLineNumber = this._toValidViewLineNumber(viewStartLineNumber);
        viewEndLineNumber = this._toValidViewLineNumber(viewEndLineNumber);
        const modelStart = this.convertViewPositionToModelPosition(viewStartLineNumber, this.getViewLineMinColumn(viewStartLineNumber));
        const modelEnd = this.convertViewPositionToModelPosition(viewEndLineNumber, this.getViewLineMaxColumn(viewEndLineNumber));
        let result = [];
        const resultRepeatCount = [];
        const resultRepeatOption = [];
        const modelStartLineIndex = modelStart.lineNumber - 1;
        const modelEndLineIndex = modelEnd.lineNumber - 1;
        let reqStart = null;
        for(let modelLineIndex = modelStartLineIndex; modelLineIndex <= modelEndLineIndex; modelLineIndex++){
            const line = this.modelLineProjections[modelLineIndex];
            if (line.isVisible()) {
                const viewLineStartIndex = line.getViewLineNumberOfModelPosition(0, modelLineIndex === modelStartLineIndex ? modelStart.column : 1);
                const viewLineEndIndex = line.getViewLineNumberOfModelPosition(0, this.model.getLineMaxColumn(modelLineIndex + 1));
                const count = viewLineEndIndex - viewLineStartIndex + 1;
                let option = 0 /* IndentGuideRepeatOption.BlockNone */ ;
                if (count > 1 && line.getViewLineMinColumn(this.model, modelLineIndex + 1, viewLineEndIndex) === 1) // wrapped lines should block indent guides
                option = viewLineStartIndex === 0 ? 1 /* IndentGuideRepeatOption.BlockSubsequent */  : 2 /* IndentGuideRepeatOption.BlockAll */ ;
                resultRepeatCount.push(count);
                resultRepeatOption.push(option);
                // merge into previous request
                if (reqStart === null) reqStart = new (0, _positionJs.Position)(modelLineIndex + 1, 0);
            } else // hit invisible line => flush request
            if (reqStart !== null) {
                result = result.concat(this.model.guides.getLinesIndentGuides(reqStart.lineNumber, modelLineIndex));
                reqStart = null;
            }
        }
        if (reqStart !== null) {
            result = result.concat(this.model.guides.getLinesIndentGuides(reqStart.lineNumber, modelEnd.lineNumber));
            reqStart = null;
        }
        const viewLineCount = viewEndLineNumber - viewStartLineNumber + 1;
        const viewIndents = new Array(viewLineCount);
        let currIndex = 0;
        for(let i = 0, len = result.length; i < len; i++){
            let value = result[i];
            const count = Math.min(viewLineCount - currIndex, resultRepeatCount[i]);
            const option = resultRepeatOption[i];
            let blockAtIndex;
            if (option === 2 /* IndentGuideRepeatOption.BlockAll */ ) blockAtIndex = 0;
            else if (option === 1 /* IndentGuideRepeatOption.BlockSubsequent */ ) blockAtIndex = 1;
            else blockAtIndex = count;
            for(let j = 0; j < count; j++){
                if (j === blockAtIndex) value = 0;
                viewIndents[currIndex++] = value;
            }
        }
        return viewIndents;
    }
    getViewLineContent(viewLineNumber) {
        const info = this.getViewLineInfo(viewLineNumber);
        return this.modelLineProjections[info.modelLineNumber - 1].getViewLineContent(this.model, info.modelLineNumber, info.modelLineWrappedLineIdx);
    }
    getViewLineLength(viewLineNumber) {
        const info = this.getViewLineInfo(viewLineNumber);
        return this.modelLineProjections[info.modelLineNumber - 1].getViewLineLength(this.model, info.modelLineNumber, info.modelLineWrappedLineIdx);
    }
    getViewLineMinColumn(viewLineNumber) {
        const info = this.getViewLineInfo(viewLineNumber);
        return this.modelLineProjections[info.modelLineNumber - 1].getViewLineMinColumn(this.model, info.modelLineNumber, info.modelLineWrappedLineIdx);
    }
    getViewLineMaxColumn(viewLineNumber) {
        const info = this.getViewLineInfo(viewLineNumber);
        return this.modelLineProjections[info.modelLineNumber - 1].getViewLineMaxColumn(this.model, info.modelLineNumber, info.modelLineWrappedLineIdx);
    }
    getViewLineData(viewLineNumber) {
        const info = this.getViewLineInfo(viewLineNumber);
        return this.modelLineProjections[info.modelLineNumber - 1].getViewLineData(this.model, info.modelLineNumber, info.modelLineWrappedLineIdx);
    }
    getViewLinesData(viewStartLineNumber, viewEndLineNumber, needed) {
        viewStartLineNumber = this._toValidViewLineNumber(viewStartLineNumber);
        viewEndLineNumber = this._toValidViewLineNumber(viewEndLineNumber);
        const start = this.projectedModelLineLineCounts.getIndexOf(viewStartLineNumber - 1);
        let viewLineNumber = viewStartLineNumber;
        const startModelLineIndex = start.index;
        const startRemainder = start.remainder;
        const result = [];
        for(let modelLineIndex = startModelLineIndex, len = this.model.getLineCount(); modelLineIndex < len; modelLineIndex++){
            const line = this.modelLineProjections[modelLineIndex];
            if (!line.isVisible()) continue;
            const fromViewLineIndex = modelLineIndex === startModelLineIndex ? startRemainder : 0;
            let remainingViewLineCount = line.getViewLineCount() - fromViewLineIndex;
            let lastLine = false;
            if (viewLineNumber + remainingViewLineCount > viewEndLineNumber) {
                lastLine = true;
                remainingViewLineCount = viewEndLineNumber - viewLineNumber + 1;
            }
            line.getViewLinesData(this.model, modelLineIndex + 1, fromViewLineIndex, remainingViewLineCount, viewLineNumber - viewStartLineNumber, needed, result);
            viewLineNumber += remainingViewLineCount;
            if (lastLine) break;
        }
        return result;
    }
    validateViewPosition(viewLineNumber, viewColumn, expectedModelPosition) {
        viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
        const r = this.projectedModelLineLineCounts.getIndexOf(viewLineNumber - 1);
        const lineIndex = r.index;
        const remainder = r.remainder;
        const line = this.modelLineProjections[lineIndex];
        const minColumn = line.getViewLineMinColumn(this.model, lineIndex + 1, remainder);
        const maxColumn = line.getViewLineMaxColumn(this.model, lineIndex + 1, remainder);
        if (viewColumn < minColumn) viewColumn = minColumn;
        if (viewColumn > maxColumn) viewColumn = maxColumn;
        const computedModelColumn = line.getModelColumnOfViewPosition(remainder, viewColumn);
        const computedModelPosition = this.model.validatePosition(new (0, _positionJs.Position)(lineIndex + 1, computedModelColumn));
        if (computedModelPosition.equals(expectedModelPosition)) return new (0, _positionJs.Position)(viewLineNumber, viewColumn);
        return this.convertModelPositionToViewPosition(expectedModelPosition.lineNumber, expectedModelPosition.column);
    }
    validateViewRange(viewRange, expectedModelRange) {
        const validViewStart = this.validateViewPosition(viewRange.startLineNumber, viewRange.startColumn, expectedModelRange.getStartPosition());
        const validViewEnd = this.validateViewPosition(viewRange.endLineNumber, viewRange.endColumn, expectedModelRange.getEndPosition());
        return new (0, _rangeJs.Range)(validViewStart.lineNumber, validViewStart.column, validViewEnd.lineNumber, validViewEnd.column);
    }
    convertViewPositionToModelPosition(viewLineNumber, viewColumn) {
        const info = this.getViewLineInfo(viewLineNumber);
        const inputColumn = this.modelLineProjections[info.modelLineNumber - 1].getModelColumnOfViewPosition(info.modelLineWrappedLineIdx, viewColumn);
        // console.log('out -> in ' + viewLineNumber + ',' + viewColumn + ' ===> ' + (lineIndex+1) + ',' + inputColumn);
        return this.model.validatePosition(new (0, _positionJs.Position)(info.modelLineNumber, inputColumn));
    }
    convertViewRangeToModelRange(viewRange) {
        const start = this.convertViewPositionToModelPosition(viewRange.startLineNumber, viewRange.startColumn);
        const end = this.convertViewPositionToModelPosition(viewRange.endLineNumber, viewRange.endColumn);
        return new (0, _rangeJs.Range)(start.lineNumber, start.column, end.lineNumber, end.column);
    }
    convertModelPositionToViewPosition(_modelLineNumber, _modelColumn, affinity = 2 /* PositionAffinity.None */ , allowZeroLineNumber = false, belowHiddenRanges = false) {
        const validPosition = this.model.validatePosition(new (0, _positionJs.Position)(_modelLineNumber, _modelColumn));
        const inputLineNumber = validPosition.lineNumber;
        const inputColumn = validPosition.column;
        let lineIndex = inputLineNumber - 1, lineIndexChanged = false;
        if (belowHiddenRanges) while(lineIndex < this.modelLineProjections.length && !this.modelLineProjections[lineIndex].isVisible()){
            lineIndex++;
            lineIndexChanged = true;
        }
        else while(lineIndex > 0 && !this.modelLineProjections[lineIndex].isVisible()){
            lineIndex--;
            lineIndexChanged = true;
        }
        if (lineIndex === 0 && !this.modelLineProjections[lineIndex].isVisible()) // Could not reach a real line
        // console.log('in -> out ' + inputLineNumber + ',' + inputColumn + ' ===> ' + 1 + ',' + 1);
        // TODO@alexdima@hediet this isn't soo pretty
        return new (0, _positionJs.Position)(allowZeroLineNumber ? 0 : 1, 1);
        const deltaLineNumber = 1 + this.projectedModelLineLineCounts.getPrefixSum(lineIndex);
        let r;
        if (lineIndexChanged) {
            if (belowHiddenRanges) r = this.modelLineProjections[lineIndex].getViewPositionOfModelPosition(deltaLineNumber, 1, affinity);
            else r = this.modelLineProjections[lineIndex].getViewPositionOfModelPosition(deltaLineNumber, this.model.getLineMaxColumn(lineIndex + 1), affinity);
        } else r = this.modelLineProjections[inputLineNumber - 1].getViewPositionOfModelPosition(deltaLineNumber, inputColumn, affinity);
        // console.log('in -> out ' + inputLineNumber + ',' + inputColumn + ' ===> ' + r.lineNumber + ',' + r);
        return r;
    }
    /**
     * @param affinity The affinity in case of an empty range. Has no effect for non-empty ranges.
    */ convertModelRangeToViewRange(modelRange, affinity = 0 /* PositionAffinity.Left */ ) {
        if (modelRange.isEmpty()) {
            const start = this.convertModelPositionToViewPosition(modelRange.startLineNumber, modelRange.startColumn, affinity);
            return (0, _rangeJs.Range).fromPositions(start);
        } else {
            const start = this.convertModelPositionToViewPosition(modelRange.startLineNumber, modelRange.startColumn, 1 /* PositionAffinity.Right */ );
            const end = this.convertModelPositionToViewPosition(modelRange.endLineNumber, modelRange.endColumn, 0 /* PositionAffinity.Left */ );
            return new (0, _rangeJs.Range)(start.lineNumber, start.column, end.lineNumber, end.column);
        }
    }
    getViewLineNumberOfModelPosition(modelLineNumber, modelColumn) {
        let lineIndex = modelLineNumber - 1;
        if (this.modelLineProjections[lineIndex].isVisible()) {
            // this model line is visible
            const deltaLineNumber = 1 + this.projectedModelLineLineCounts.getPrefixSum(lineIndex);
            return this.modelLineProjections[lineIndex].getViewLineNumberOfModelPosition(deltaLineNumber, modelColumn);
        }
        // this model line is not visible
        while(lineIndex > 0 && !this.modelLineProjections[lineIndex].isVisible())lineIndex--;
        if (lineIndex === 0 && !this.modelLineProjections[lineIndex].isVisible()) // Could not reach a real line
        return 1;
        const deltaLineNumber = 1 + this.projectedModelLineLineCounts.getPrefixSum(lineIndex);
        return this.modelLineProjections[lineIndex].getViewLineNumberOfModelPosition(deltaLineNumber, this.model.getLineMaxColumn(lineIndex + 1));
    }
    getDecorationsInRange(range, ownerId, filterOutValidation, onlyMinimapDecorations, onlyMarginDecorations) {
        const modelStart = this.convertViewPositionToModelPosition(range.startLineNumber, range.startColumn);
        const modelEnd = this.convertViewPositionToModelPosition(range.endLineNumber, range.endColumn);
        if (modelEnd.lineNumber - modelStart.lineNumber <= range.endLineNumber - range.startLineNumber) // most likely there are no hidden lines => fast path
        // fetch decorations from column 1 to cover the case of wrapped lines that have whole line decorations at column 1
        return this.model.getDecorationsInRange(new (0, _rangeJs.Range)(modelStart.lineNumber, 1, modelEnd.lineNumber, modelEnd.column), ownerId, filterOutValidation, onlyMinimapDecorations, onlyMarginDecorations);
        let result = [];
        const modelStartLineIndex = modelStart.lineNumber - 1;
        const modelEndLineIndex = modelEnd.lineNumber - 1;
        let reqStart = null;
        for(let modelLineIndex = modelStartLineIndex; modelLineIndex <= modelEndLineIndex; modelLineIndex++){
            const line = this.modelLineProjections[modelLineIndex];
            if (line.isVisible()) // merge into previous request
            {
                if (reqStart === null) reqStart = new (0, _positionJs.Position)(modelLineIndex + 1, modelLineIndex === modelStartLineIndex ? modelStart.column : 1);
            } else // hit invisible line => flush request
            if (reqStart !== null) {
                const maxLineColumn = this.model.getLineMaxColumn(modelLineIndex);
                result = result.concat(this.model.getDecorationsInRange(new (0, _rangeJs.Range)(reqStart.lineNumber, reqStart.column, modelLineIndex, maxLineColumn), ownerId, filterOutValidation, onlyMinimapDecorations));
                reqStart = null;
            }
        }
        if (reqStart !== null) {
            result = result.concat(this.model.getDecorationsInRange(new (0, _rangeJs.Range)(reqStart.lineNumber, reqStart.column, modelEnd.lineNumber, modelEnd.column), ownerId, filterOutValidation, onlyMinimapDecorations));
            reqStart = null;
        }
        result.sort((a, b)=>{
            const res = (0, _rangeJs.Range).compareRangesUsingStarts(a.range, b.range);
            if (res === 0) {
                if (a.id < b.id) return -1;
                if (a.id > b.id) return 1;
                return 0;
            }
            return res;
        });
        // Eliminate duplicate decorations that might have intersected our visible ranges multiple times
        const finalResult = [];
        let finalResultLen = 0;
        let prevDecId = null;
        for (const dec of result){
            const decId = dec.id;
            if (prevDecId === decId) continue;
            prevDecId = decId;
            finalResult[finalResultLen++] = dec;
        }
        return finalResult;
    }
    getInjectedTextAt(position) {
        const info = this.getViewLineInfo(position.lineNumber);
        return this.modelLineProjections[info.modelLineNumber - 1].getInjectedTextAt(info.modelLineWrappedLineIdx, position.column);
    }
    normalizePosition(position, affinity) {
        const info = this.getViewLineInfo(position.lineNumber);
        return this.modelLineProjections[info.modelLineNumber - 1].normalizePosition(info.modelLineWrappedLineIdx, position, affinity);
    }
    getLineIndentColumn(lineNumber) {
        const info = this.getViewLineInfo(lineNumber);
        if (info.modelLineWrappedLineIdx === 0) return this.model.getLineIndentColumn(info.modelLineNumber);
        // wrapped lines have no indentation.
        // We deliberately don't handle the case that indentation is wrapped
        // to avoid two view lines reporting indentation for the very same model line.
        return 0;
    }
}
/**
 * Overlapping unsorted ranges:
 * [   )      [ )       [  )
 *    [    )      [       )
 * ->
 * Non overlapping sorted ranges:
 * [       )  [ ) [        )
 *
 * Note: This function only considers line information! Columns are ignored.
*/ function normalizeLineRanges(ranges) {
    if (ranges.length === 0) return [];
    const sortedRanges = ranges.slice();
    sortedRanges.sort((0, _rangeJs.Range).compareRangesUsingStarts);
    const result = [];
    let currentRangeStart = sortedRanges[0].startLineNumber;
    let currentRangeEnd = sortedRanges[0].endLineNumber;
    for(let i = 1, len = sortedRanges.length; i < len; i++){
        const range = sortedRanges[i];
        if (range.startLineNumber > currentRangeEnd + 1) {
            result.push(new (0, _rangeJs.Range)(currentRangeStart, 1, currentRangeEnd, 1));
            currentRangeStart = range.startLineNumber;
            currentRangeEnd = range.endLineNumber;
        } else if (range.endLineNumber > currentRangeEnd) currentRangeEnd = range.endLineNumber;
    }
    result.push(new (0, _rangeJs.Range)(currentRangeStart, 1, currentRangeEnd, 1));
    return result;
}
/**
 * Represents a view line. Can be used to efficiently query more information about it.
 */ class ViewLineInfo {
    constructor(modelLineNumber, modelLineWrappedLineIdx){
        this.modelLineNumber = modelLineNumber;
        this.modelLineWrappedLineIdx = modelLineWrappedLineIdx;
    }
}
/**
 * A list of view lines that have a contiguous span in the model.
*/ class ViewLineInfoGroupedByModelRange {
    constructor(modelRange, viewLines){
        this.modelRange = modelRange;
        this.viewLines = viewLines;
    }
}
class CoordinatesConverter {
    constructor(lines){
        this._lines = lines;
    }
    // View -> Model conversion and related methods
    convertViewPositionToModelPosition(viewPosition) {
        return this._lines.convertViewPositionToModelPosition(viewPosition.lineNumber, viewPosition.column);
    }
    convertViewRangeToModelRange(viewRange) {
        return this._lines.convertViewRangeToModelRange(viewRange);
    }
    validateViewPosition(viewPosition, expectedModelPosition) {
        return this._lines.validateViewPosition(viewPosition.lineNumber, viewPosition.column, expectedModelPosition);
    }
    validateViewRange(viewRange, expectedModelRange) {
        return this._lines.validateViewRange(viewRange, expectedModelRange);
    }
    // Model -> View conversion and related methods
    convertModelPositionToViewPosition(modelPosition, affinity, allowZero, belowHiddenRanges) {
        return this._lines.convertModelPositionToViewPosition(modelPosition.lineNumber, modelPosition.column, affinity, allowZero, belowHiddenRanges);
    }
    convertModelRangeToViewRange(modelRange, affinity) {
        return this._lines.convertModelRangeToViewRange(modelRange, affinity);
    }
    modelPositionIsVisible(modelPosition) {
        return this._lines.modelPositionIsVisible(modelPosition.lineNumber, modelPosition.column);
    }
    getModelLineViewLineCount(modelLineNumber) {
        return this._lines.getModelLineViewLineCount(modelLineNumber);
    }
    getViewLineNumberOfModelPosition(modelLineNumber, modelColumn) {
        return this._lines.getViewLineNumberOfModelPosition(modelLineNumber, modelColumn);
    }
}
class ViewModelLinesFromModelAsIs {
    constructor(model){
        this.model = model;
    }
    dispose() {}
    createCoordinatesConverter() {
        return new IdentityCoordinatesConverter(this);
    }
    getHiddenAreas() {
        return [];
    }
    setHiddenAreas(_ranges) {
        return false;
    }
    setTabSize(_newTabSize) {
        return false;
    }
    setWrappingSettings(_fontInfo, _wrappingStrategy, _wrappingColumn, _wrappingIndent) {
        return false;
    }
    createLineBreaksComputer() {
        const result = [];
        return {
            addRequest: (lineText, injectedText, previousLineBreakData)=>{
                result.push(null);
            },
            finalize: ()=>{
                return result;
            }
        };
    }
    onModelFlushed() {}
    onModelLinesDeleted(_versionId, fromLineNumber, toLineNumber) {
        return new _viewEventsJs.ViewLinesDeletedEvent(fromLineNumber, toLineNumber);
    }
    onModelLinesInserted(_versionId, fromLineNumber, toLineNumber, lineBreaks) {
        return new _viewEventsJs.ViewLinesInsertedEvent(fromLineNumber, toLineNumber);
    }
    onModelLineChanged(_versionId, lineNumber, lineBreakData) {
        return [
            false,
            new _viewEventsJs.ViewLinesChangedEvent(lineNumber, 1),
            null,
            null
        ];
    }
    acceptVersionId(_versionId) {}
    getViewLineCount() {
        return this.model.getLineCount();
    }
    getActiveIndentGuide(viewLineNumber, _minLineNumber, _maxLineNumber) {
        return {
            startLineNumber: viewLineNumber,
            endLineNumber: viewLineNumber,
            indent: 0
        };
    }
    getViewLinesBracketGuides(startLineNumber, endLineNumber, activePosition) {
        return new Array(endLineNumber - startLineNumber + 1).fill([]);
    }
    getViewLinesIndentGuides(viewStartLineNumber, viewEndLineNumber) {
        const viewLineCount = viewEndLineNumber - viewStartLineNumber + 1;
        const result = new Array(viewLineCount);
        for(let i = 0; i < viewLineCount; i++)result[i] = 0;
        return result;
    }
    getViewLineContent(viewLineNumber) {
        return this.model.getLineContent(viewLineNumber);
    }
    getViewLineLength(viewLineNumber) {
        return this.model.getLineLength(viewLineNumber);
    }
    getViewLineMinColumn(viewLineNumber) {
        return this.model.getLineMinColumn(viewLineNumber);
    }
    getViewLineMaxColumn(viewLineNumber) {
        return this.model.getLineMaxColumn(viewLineNumber);
    }
    getViewLineData(viewLineNumber) {
        const lineTokens = this.model.tokenization.getLineTokens(viewLineNumber);
        const lineContent = lineTokens.getLineContent();
        return new (0, _viewModelJs.ViewLineData)(lineContent, false, 1, lineContent.length + 1, 0, lineTokens.inflate(), null);
    }
    getViewLinesData(viewStartLineNumber, viewEndLineNumber, needed) {
        const lineCount = this.model.getLineCount();
        viewStartLineNumber = Math.min(Math.max(1, viewStartLineNumber), lineCount);
        viewEndLineNumber = Math.min(Math.max(1, viewEndLineNumber), lineCount);
        const result = [];
        for(let lineNumber = viewStartLineNumber; lineNumber <= viewEndLineNumber; lineNumber++){
            const idx = lineNumber - viewStartLineNumber;
            result[idx] = needed[idx] ? this.getViewLineData(lineNumber) : null;
        }
        return result;
    }
    getDecorationsInRange(range, ownerId, filterOutValidation, onlyMinimapDecorations, onlyMarginDecorations) {
        return this.model.getDecorationsInRange(range, ownerId, filterOutValidation, onlyMinimapDecorations, onlyMarginDecorations);
    }
    normalizePosition(position, affinity) {
        return this.model.normalizePosition(position, affinity);
    }
    getLineIndentColumn(lineNumber) {
        return this.model.getLineIndentColumn(lineNumber);
    }
    getInjectedTextAt(position) {
        // Identity lines collection does not support injected text.
        return null;
    }
}
class IdentityCoordinatesConverter {
    constructor(lines){
        this._lines = lines;
    }
    _validPosition(pos) {
        return this._lines.model.validatePosition(pos);
    }
    _validRange(range) {
        return this._lines.model.validateRange(range);
    }
    // View -> Model conversion and related methods
    convertViewPositionToModelPosition(viewPosition) {
        return this._validPosition(viewPosition);
    }
    convertViewRangeToModelRange(viewRange) {
        return this._validRange(viewRange);
    }
    validateViewPosition(_viewPosition, expectedModelPosition) {
        return this._validPosition(expectedModelPosition);
    }
    validateViewRange(_viewRange, expectedModelRange) {
        return this._validRange(expectedModelRange);
    }
    // Model -> View conversion and related methods
    convertModelPositionToViewPosition(modelPosition) {
        return this._validPosition(modelPosition);
    }
    convertModelRangeToViewRange(modelRange) {
        return this._validRange(modelRange);
    }
    modelPositionIsVisible(modelPosition) {
        const lineCount = this._lines.model.getLineCount();
        if (modelPosition.lineNumber < 1 || modelPosition.lineNumber > lineCount) // invalid arguments
        return false;
        return true;
    }
    getModelLineViewLineCount(modelLineNumber) {
        return 1;
    }
    getViewLineNumberOfModelPosition(modelLineNumber, modelColumn) {
        return modelLineNumber;
    }
}

},{"../../../base/common/arrays.js":"DECei","../core/position.js":"lvrPe","../core/range.js":"jmUPh","../textModelGuides.js":"fnW8P","../model/textModel.js":"9beDe","../textModelEvents.js":"90evO","../viewEvents.js":"9BnMp","./modelLineProjection.js":"3KLsd","../model/prefixSumComputer.js":"1Xo23","../viewModel.js":"5EHxj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3KLsd":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createModelLineProjection", ()=>createModelLineProjection);
var _lineTokensJs = require("../tokens/lineTokens.js");
var _positionJs = require("../core/position.js");
var _textModelEventsJs = require("../textModelEvents.js");
var _viewModelJs = require("../viewModel.js");
function createModelLineProjection(lineBreakData, isVisible) {
    if (lineBreakData === null) {
        // No mapping needed
        if (isVisible) return IdentityModelLineProjection.INSTANCE;
        return HiddenModelLineProjection.INSTANCE;
    } else return new ModelLineProjection(lineBreakData, isVisible);
}
/**
 * This projection is used to
 * * wrap model lines
 * * inject text
 */ class ModelLineProjection {
    constructor(lineBreakData, isVisible){
        this._projectionData = lineBreakData;
        this._isVisible = isVisible;
    }
    isVisible() {
        return this._isVisible;
    }
    setVisible(isVisible) {
        this._isVisible = isVisible;
        return this;
    }
    getProjectionData() {
        return this._projectionData;
    }
    getViewLineCount() {
        if (!this._isVisible) return 0;
        return this._projectionData.getOutputLineCount();
    }
    getViewLineContent(model, modelLineNumber, outputLineIndex) {
        this._assertVisible();
        const startOffsetInInputWithInjections = outputLineIndex > 0 ? this._projectionData.breakOffsets[outputLineIndex - 1] : 0;
        const endOffsetInInputWithInjections = this._projectionData.breakOffsets[outputLineIndex];
        let r;
        if (this._projectionData.injectionOffsets !== null) {
            const injectedTexts = this._projectionData.injectionOffsets.map((offset, idx)=>new (0, _textModelEventsJs.LineInjectedText)(0, 0, offset + 1, this._projectionData.injectionOptions[idx], 0));
            const lineWithInjections = (0, _textModelEventsJs.LineInjectedText).applyInjectedText(model.getLineContent(modelLineNumber), injectedTexts);
            r = lineWithInjections.substring(startOffsetInInputWithInjections, endOffsetInInputWithInjections);
        } else r = model.getValueInRange({
            startLineNumber: modelLineNumber,
            startColumn: startOffsetInInputWithInjections + 1,
            endLineNumber: modelLineNumber,
            endColumn: endOffsetInInputWithInjections + 1
        });
        if (outputLineIndex > 0) r = spaces(this._projectionData.wrappedTextIndentLength) + r;
        return r;
    }
    getViewLineLength(model, modelLineNumber, outputLineIndex) {
        this._assertVisible();
        return this._projectionData.getLineLength(outputLineIndex);
    }
    getViewLineMinColumn(_model, _modelLineNumber, outputLineIndex) {
        this._assertVisible();
        return this._projectionData.getMinOutputOffset(outputLineIndex) + 1;
    }
    getViewLineMaxColumn(model, modelLineNumber, outputLineIndex) {
        this._assertVisible();
        return this._projectionData.getMaxOutputOffset(outputLineIndex) + 1;
    }
    /**
     * Try using {@link getViewLinesData} instead.
    */ getViewLineData(model, modelLineNumber, outputLineIndex) {
        const arr = new Array();
        this.getViewLinesData(model, modelLineNumber, outputLineIndex, 1, 0, [
            true
        ], arr);
        return arr[0];
    }
    getViewLinesData(model, modelLineNumber, outputLineIdx, lineCount, globalStartIndex, needed, result) {
        this._assertVisible();
        const lineBreakData = this._projectionData;
        const injectionOffsets = lineBreakData.injectionOffsets;
        const injectionOptions = lineBreakData.injectionOptions;
        let inlineDecorationsPerOutputLine = null;
        if (injectionOffsets) {
            inlineDecorationsPerOutputLine = [];
            let totalInjectedTextLengthBefore = 0;
            let currentInjectedOffset = 0;
            for(let outputLineIndex = 0; outputLineIndex < lineBreakData.getOutputLineCount(); outputLineIndex++){
                const inlineDecorations = new Array();
                inlineDecorationsPerOutputLine[outputLineIndex] = inlineDecorations;
                const lineStartOffsetInInputWithInjections = outputLineIndex > 0 ? lineBreakData.breakOffsets[outputLineIndex - 1] : 0;
                const lineEndOffsetInInputWithInjections = lineBreakData.breakOffsets[outputLineIndex];
                while(currentInjectedOffset < injectionOffsets.length){
                    const length = injectionOptions[currentInjectedOffset].content.length;
                    const injectedTextStartOffsetInInputWithInjections = injectionOffsets[currentInjectedOffset] + totalInjectedTextLengthBefore;
                    const injectedTextEndOffsetInInputWithInjections = injectedTextStartOffsetInInputWithInjections + length;
                    if (injectedTextStartOffsetInInputWithInjections > lineEndOffsetInInputWithInjections) break;
                    if (lineStartOffsetInInputWithInjections < injectedTextEndOffsetInInputWithInjections) {
                        // Injected text ends after or in this line (but also starts in or before this line).
                        const options = injectionOptions[currentInjectedOffset];
                        if (options.inlineClassName) {
                            const offset = outputLineIndex > 0 ? lineBreakData.wrappedTextIndentLength : 0;
                            const start = offset + Math.max(injectedTextStartOffsetInInputWithInjections - lineStartOffsetInInputWithInjections, 0);
                            const end = offset + Math.min(injectedTextEndOffsetInInputWithInjections - lineStartOffsetInInputWithInjections, lineEndOffsetInInputWithInjections - lineStartOffsetInInputWithInjections);
                            if (start !== end) inlineDecorations.push(new (0, _viewModelJs.SingleLineInlineDecoration)(start, end, options.inlineClassName, options.inlineClassNameAffectsLetterSpacing));
                        }
                    }
                    if (injectedTextEndOffsetInInputWithInjections <= lineEndOffsetInInputWithInjections) {
                        totalInjectedTextLengthBefore += length;
                        currentInjectedOffset++;
                    } else break;
                }
            }
        }
        let lineWithInjections;
        if (injectionOffsets) lineWithInjections = model.tokenization.getLineTokens(modelLineNumber).withInserted(injectionOffsets.map((offset, idx)=>({
                offset,
                text: injectionOptions[idx].content,
                tokenMetadata: (0, _lineTokensJs.LineTokens).defaultTokenMetadata
            })));
        else lineWithInjections = model.tokenization.getLineTokens(modelLineNumber);
        for(let outputLineIndex = outputLineIdx; outputLineIndex < outputLineIdx + lineCount; outputLineIndex++){
            const globalIndex = globalStartIndex + outputLineIndex - outputLineIdx;
            if (!needed[globalIndex]) {
                result[globalIndex] = null;
                continue;
            }
            result[globalIndex] = this._getViewLineData(lineWithInjections, inlineDecorationsPerOutputLine ? inlineDecorationsPerOutputLine[outputLineIndex] : null, outputLineIndex);
        }
    }
    _getViewLineData(lineWithInjections, inlineDecorations, outputLineIndex) {
        this._assertVisible();
        const lineBreakData = this._projectionData;
        const deltaStartIndex = outputLineIndex > 0 ? lineBreakData.wrappedTextIndentLength : 0;
        const lineStartOffsetInInputWithInjections = outputLineIndex > 0 ? lineBreakData.breakOffsets[outputLineIndex - 1] : 0;
        const lineEndOffsetInInputWithInjections = lineBreakData.breakOffsets[outputLineIndex];
        const tokens = lineWithInjections.sliceAndInflate(lineStartOffsetInInputWithInjections, lineEndOffsetInInputWithInjections, deltaStartIndex);
        let lineContent = tokens.getLineContent();
        if (outputLineIndex > 0) lineContent = spaces(lineBreakData.wrappedTextIndentLength) + lineContent;
        const minColumn = this._projectionData.getMinOutputOffset(outputLineIndex) + 1;
        const maxColumn = lineContent.length + 1;
        const continuesWithWrappedLine = outputLineIndex + 1 < this.getViewLineCount();
        const startVisibleColumn = outputLineIndex === 0 ? 0 : lineBreakData.breakOffsetsVisibleColumn[outputLineIndex - 1];
        return new (0, _viewModelJs.ViewLineData)(lineContent, continuesWithWrappedLine, minColumn, maxColumn, startVisibleColumn, tokens, inlineDecorations);
    }
    getModelColumnOfViewPosition(outputLineIndex, outputColumn) {
        this._assertVisible();
        return this._projectionData.translateToInputOffset(outputLineIndex, outputColumn - 1) + 1;
    }
    getViewPositionOfModelPosition(deltaLineNumber, inputColumn, affinity = 2 /* PositionAffinity.None */ ) {
        this._assertVisible();
        const r = this._projectionData.translateToOutputPosition(inputColumn - 1, affinity);
        return r.toPosition(deltaLineNumber);
    }
    getViewLineNumberOfModelPosition(deltaLineNumber, inputColumn) {
        this._assertVisible();
        const r = this._projectionData.translateToOutputPosition(inputColumn - 1);
        return deltaLineNumber + r.outputLineIndex;
    }
    normalizePosition(outputLineIndex, outputPosition, affinity) {
        const baseViewLineNumber = outputPosition.lineNumber - outputLineIndex;
        const normalizedOutputPosition = this._projectionData.normalizeOutputPosition(outputLineIndex, outputPosition.column - 1, affinity);
        const result = normalizedOutputPosition.toPosition(baseViewLineNumber);
        return result;
    }
    getInjectedTextAt(outputLineIndex, outputColumn) {
        return this._projectionData.getInjectedText(outputLineIndex, outputColumn - 1);
    }
    _assertVisible() {
        if (!this._isVisible) throw new Error("Not supported");
    }
}
/**
 * This projection does not change the model line.
*/ class IdentityModelLineProjection {
    static{
        this.INSTANCE = new IdentityModelLineProjection();
    }
    constructor(){}
    isVisible() {
        return true;
    }
    setVisible(isVisible) {
        if (isVisible) return this;
        return HiddenModelLineProjection.INSTANCE;
    }
    getProjectionData() {
        return null;
    }
    getViewLineCount() {
        return 1;
    }
    getViewLineContent(model, modelLineNumber, _outputLineIndex) {
        return model.getLineContent(modelLineNumber);
    }
    getViewLineLength(model, modelLineNumber, _outputLineIndex) {
        return model.getLineLength(modelLineNumber);
    }
    getViewLineMinColumn(model, modelLineNumber, _outputLineIndex) {
        return model.getLineMinColumn(modelLineNumber);
    }
    getViewLineMaxColumn(model, modelLineNumber, _outputLineIndex) {
        return model.getLineMaxColumn(modelLineNumber);
    }
    getViewLineData(model, modelLineNumber, _outputLineIndex) {
        const lineTokens = model.tokenization.getLineTokens(modelLineNumber);
        const lineContent = lineTokens.getLineContent();
        return new (0, _viewModelJs.ViewLineData)(lineContent, false, 1, lineContent.length + 1, 0, lineTokens.inflate(), null);
    }
    getViewLinesData(model, modelLineNumber, _fromOuputLineIndex, _toOutputLineIndex, globalStartIndex, needed, result) {
        if (!needed[globalStartIndex]) {
            result[globalStartIndex] = null;
            return;
        }
        result[globalStartIndex] = this.getViewLineData(model, modelLineNumber, 0);
    }
    getModelColumnOfViewPosition(_outputLineIndex, outputColumn) {
        return outputColumn;
    }
    getViewPositionOfModelPosition(deltaLineNumber, inputColumn) {
        return new (0, _positionJs.Position)(deltaLineNumber, inputColumn);
    }
    getViewLineNumberOfModelPosition(deltaLineNumber, _inputColumn) {
        return deltaLineNumber;
    }
    normalizePosition(outputLineIndex, outputPosition, affinity) {
        return outputPosition;
    }
    getInjectedTextAt(_outputLineIndex, _outputColumn) {
        return null;
    }
}
/**
 * This projection hides the model line.
 */ class HiddenModelLineProjection {
    static{
        this.INSTANCE = new HiddenModelLineProjection();
    }
    constructor(){}
    isVisible() {
        return false;
    }
    setVisible(isVisible) {
        if (!isVisible) return this;
        return IdentityModelLineProjection.INSTANCE;
    }
    getProjectionData() {
        return null;
    }
    getViewLineCount() {
        return 0;
    }
    getViewLineContent(_model, _modelLineNumber, _outputLineIndex) {
        throw new Error("Not supported");
    }
    getViewLineLength(_model, _modelLineNumber, _outputLineIndex) {
        throw new Error("Not supported");
    }
    getViewLineMinColumn(_model, _modelLineNumber, _outputLineIndex) {
        throw new Error("Not supported");
    }
    getViewLineMaxColumn(_model, _modelLineNumber, _outputLineIndex) {
        throw new Error("Not supported");
    }
    getViewLineData(_model, _modelLineNumber, _outputLineIndex) {
        throw new Error("Not supported");
    }
    getViewLinesData(_model, _modelLineNumber, _fromOuputLineIndex, _toOutputLineIndex, _globalStartIndex, _needed, _result) {
        throw new Error("Not supported");
    }
    getModelColumnOfViewPosition(_outputLineIndex, _outputColumn) {
        throw new Error("Not supported");
    }
    getViewPositionOfModelPosition(_deltaLineNumber, _inputColumn) {
        throw new Error("Not supported");
    }
    getViewLineNumberOfModelPosition(_deltaLineNumber, _inputColumn) {
        throw new Error("Not supported");
    }
    normalizePosition(outputLineIndex, outputPosition, affinity) {
        throw new Error("Not supported");
    }
    getInjectedTextAt(_outputLineIndex, _outputColumn) {
        throw new Error("Not supported");
    }
}
const _spaces = [
    ""
];
function spaces(count) {
    if (count >= _spaces.length) for(let i = 1; i <= count; i++)_spaces[i] = _makeSpaces(i);
    return _spaces[count];
}
function _makeSpaces(count) {
    return new Array(count + 1).join(" ");
}

},{"../tokens/lineTokens.js":"6iUVx","../core/position.js":"lvrPe","../textModelEvents.js":"90evO","../viewModel.js":"5EHxj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dQ8TH":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlyphMarginLanesModel", ()=>GlyphMarginLanesModel);
var _modelJs = require("../model.js");
const MAX_LANE = (0, _modelJs.GlyphMarginLane).Right;
class GlyphMarginLanesModel {
    constructor(maxLine){
        this.persist = 0;
        this._requiredLanes = 1; // always render at least one lane
        this.lanes = new Uint8Array(Math.ceil((maxLine + 1) * MAX_LANE / 8));
    }
    reset(maxLine) {
        const bytes = Math.ceil((maxLine + 1) * MAX_LANE / 8);
        if (this.lanes.length < bytes) this.lanes = new Uint8Array(bytes);
        else this.lanes.fill(0);
        this._requiredLanes = 1;
    }
    get requiredLanes() {
        return this._requiredLanes;
    }
    push(lane, range, persist) {
        if (persist) this.persist |= 1 << lane - 1;
        for(let i = range.startLineNumber; i <= range.endLineNumber; i++){
            const bit = MAX_LANE * i + (lane - 1);
            this.lanes[bit >>> 3] |= 1 << bit % 8;
            this._requiredLanes = Math.max(this._requiredLanes, this.countAtLine(i));
        }
    }
    getLanesAtLine(lineNumber) {
        const lanes = [];
        let bit = MAX_LANE * lineNumber;
        for(let i = 0; i < MAX_LANE; i++){
            if (this.persist & 1 << i || this.lanes[bit >>> 3] & 1 << bit % 8) lanes.push(i + 1);
            bit++;
        }
        return lanes.length ? lanes : [
            (0, _modelJs.GlyphMarginLane).Center
        ];
    }
    countAtLine(lineNumber) {
        let bit = MAX_LANE * lineNumber;
        let count = 0;
        for(let i = 0; i < MAX_LANE; i++){
            if (this.persist & 1 << i || this.lanes[bit >>> 3] & 1 << bit % 8) count++;
            bit++;
        }
        return count;
    }
}

},{"../model.js":"1CSIB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"35Ond":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiffEditorWidget", ()=>DiffEditorWidget);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _domJs = require("../../../../base/browser/dom.js");
var _arraysFindJs = require("../../../../base/common/arraysFind.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _derivedJs = require("../../../../base/common/observableInternal/derived.js");
var _styleCss = require("./style.css");
var _editorExtensionsJs = require("../../editorExtensions.js");
var _codeEditorServiceJs = require("../../services/codeEditorService.js");
var _stableEditorScrollJs = require("../../stableEditorScroll.js");
var _codeEditorWidgetJs = require("../codeEditor/codeEditorWidget.js");
var _accessibleDiffViewerJs = require("./components/accessibleDiffViewer.js");
var _diffEditorDecorationsJs = require("./components/diffEditorDecorations.js");
var _diffEditorSashJs = require("./components/diffEditorSash.js");
var _diffEditorViewZonesJs = require("./components/diffEditorViewZones/diffEditorViewZones.js");
var _gutterFeatureJs = require("./features/gutterFeature.js");
var _hideUnchangedRegionsFeatureJs = require("./features/hideUnchangedRegionsFeature.js");
var _movedBlocksLinesFeatureJs = require("./features/movedBlocksLinesFeature.js");
var _overviewRulerFeatureJs = require("./features/overviewRulerFeature.js");
var _revertButtonsFeatureJs = require("./features/revertButtonsFeature.js");
var _utilsJs = require("./utils.js");
var _hotReloadHelpersJs = require("../../../../base/common/hotReloadHelpers.js");
var _platformObservableUtilsJs = require("../../../../platform/observable/common/platformObservableUtils.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorCommonJs = require("../../../common/editorCommon.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _accessibilitySignalServiceJs = require("../../../../platform/accessibilitySignal/browser/accessibilitySignalService.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _serviceCollectionJs = require("../../../../platform/instantiation/common/serviceCollection.js");
var _progressJs = require("../../../../platform/progress/common/progress.js");
var _diffEditorEditorsJs = require("./components/diffEditorEditors.js");
var _delegatingEditorImplJs = require("./delegatingEditorImpl.js");
var _diffEditorOptionsJs = require("./diffEditorOptions.js");
var _diffEditorViewModelJs = require("./diffEditorViewModel.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let DiffEditorWidget = class DiffEditorWidget extends (0, _delegatingEditorImplJs.DelegatingEditor) {
    get onDidContentSizeChange() {
        return this._editors.onDidContentSizeChange;
    }
    constructor(_domElement, options, codeEditorWidgetOptions, _parentContextKeyService, _parentInstantiationService, codeEditorService, _accessibilitySignalService, _editorProgressService){
        super();
        this._domElement = _domElement;
        this._parentContextKeyService = _parentContextKeyService;
        this._parentInstantiationService = _parentInstantiationService;
        this._accessibilitySignalService = _accessibilitySignalService;
        this._editorProgressService = _editorProgressService;
        this.elements = (0, _domJs.h)("div.monaco-diff-editor.side-by-side", {
            style: {
                position: "relative",
                height: "100%"
            }
        }, [
            (0, _domJs.h)("div.editor.original@original", {
                style: {
                    position: "absolute",
                    height: "100%"
                }
            }),
            (0, _domJs.h)("div.editor.modified@modified", {
                style: {
                    position: "absolute",
                    height: "100%"
                }
            }),
            (0, _domJs.h)("div.accessibleDiffViewer@accessibleDiffViewer", {
                style: {
                    position: "absolute",
                    height: "100%"
                }
            })
        ]);
        this._diffModelSrc = this._register((0, _observableJs.disposableObservableValue)(this, undefined));
        this._diffModel = (0, _observableJs.derived)(this, (reader)=>this._diffModelSrc.read(reader)?.object);
        this.onDidChangeModel = (0, _eventJs.Event).fromObservableLight(this._diffModel);
        this._contextKeyService = this._register(this._parentContextKeyService.createScoped(this._domElement));
        this._instantiationService = this._register(this._parentInstantiationService.createChild(new (0, _serviceCollectionJs.ServiceCollection)([
            (0, _contextkeyJs.IContextKeyService),
            this._contextKeyService
        ])));
        this._boundarySashes = (0, _observableJs.observableValue)(this, undefined);
        this._accessibleDiffViewerShouldBeVisible = (0, _observableJs.observableValue)(this, false);
        this._accessibleDiffViewerVisible = (0, _observableJs.derived)(this, (reader)=>this._options.onlyShowAccessibleDiffViewer.read(reader) ? true : this._accessibleDiffViewerShouldBeVisible.read(reader));
        this._movedBlocksLinesPart = (0, _observableJs.observableValue)(this, undefined);
        this._layoutInfo = (0, _observableJs.derived)(this, (reader)=>{
            const fullWidth = this._rootSizeObserver.width.read(reader);
            const fullHeight = this._rootSizeObserver.height.read(reader);
            if (this._rootSizeObserver.automaticLayout) this.elements.root.style.height = "100%";
            else this.elements.root.style.height = fullHeight + "px";
            const sash = this._sash.read(reader);
            const gutter = this._gutter.read(reader);
            const gutterWidth = gutter?.width.read(reader) ?? 0;
            const overviewRulerPartWidth = this._overviewRulerPart.read(reader)?.width ?? 0;
            let originalLeft, originalWidth, modifiedLeft, modifiedWidth, gutterLeft;
            const sideBySide = !!sash;
            if (sideBySide) {
                const sashLeft = sash.sashLeft.read(reader);
                const movedBlocksLinesWidth = this._movedBlocksLinesPart.read(reader)?.width.read(reader) ?? 0;
                originalLeft = 0;
                originalWidth = sashLeft - gutterWidth - movedBlocksLinesWidth;
                gutterLeft = sashLeft - gutterWidth;
                modifiedLeft = sashLeft;
                modifiedWidth = fullWidth - modifiedLeft - overviewRulerPartWidth;
            } else {
                gutterLeft = 0;
                const shouldHideOriginalLineNumbers = this._options.inlineViewHideOriginalLineNumbers.read(reader);
                originalLeft = gutterWidth;
                if (shouldHideOriginalLineNumbers) originalWidth = 0;
                else originalWidth = Math.max(5, this._editors.originalObs.layoutInfoDecorationsLeft.read(reader));
                modifiedLeft = gutterWidth + originalWidth;
                modifiedWidth = fullWidth - modifiedLeft - overviewRulerPartWidth;
            }
            this.elements.original.style.left = originalLeft + "px";
            this.elements.original.style.width = originalWidth + "px";
            this._editors.original.layout({
                width: originalWidth,
                height: fullHeight
            }, true);
            gutter?.layout(gutterLeft);
            this.elements.modified.style.left = modifiedLeft + "px";
            this.elements.modified.style.width = modifiedWidth + "px";
            this._editors.modified.layout({
                width: modifiedWidth,
                height: fullHeight
            }, true);
            return {
                modifiedEditor: this._editors.modified.getLayoutInfo(),
                originalEditor: this._editors.original.getLayoutInfo()
            };
        });
        this._diffValue = this._diffModel.map((m, r)=>m?.diff.read(r));
        this.onDidUpdateDiff = (0, _eventJs.Event).fromObservableLight(this._diffValue);
        codeEditorService.willCreateDiffEditor();
        this._contextKeyService.createKey("isInDiffEditor", true);
        this._domElement.appendChild(this.elements.root);
        this._register((0, _lifecycleJs.toDisposable)(()=>this.elements.root.remove()));
        this._rootSizeObserver = this._register(new (0, _utilsJs.ObservableElementSizeObserver)(this.elements.root, options.dimension));
        this._rootSizeObserver.setAutomaticLayout(options.automaticLayout ?? false);
        this._options = this._instantiationService.createInstance((0, _diffEditorOptionsJs.DiffEditorOptions), options);
        this._register((0, _observableJs.autorun)((reader)=>{
            this._options.setWidth(this._rootSizeObserver.width.read(reader));
        }));
        this._contextKeyService.createKey((0, _editorContextKeysJs.EditorContextKeys).isEmbeddedDiffEditor.key, false);
        this._register((0, _platformObservableUtilsJs.bindContextKey)((0, _editorContextKeysJs.EditorContextKeys).isEmbeddedDiffEditor, this._contextKeyService, (reader)=>this._options.isInEmbeddedEditor.read(reader)));
        this._register((0, _platformObservableUtilsJs.bindContextKey)((0, _editorContextKeysJs.EditorContextKeys).comparingMovedCode, this._contextKeyService, (reader)=>!!this._diffModel.read(reader)?.movedTextToCompare.read(reader)));
        this._register((0, _platformObservableUtilsJs.bindContextKey)((0, _editorContextKeysJs.EditorContextKeys).diffEditorRenderSideBySideInlineBreakpointReached, this._contextKeyService, (reader)=>this._options.couldShowInlineViewBecauseOfSize.read(reader)));
        this._register((0, _platformObservableUtilsJs.bindContextKey)((0, _editorContextKeysJs.EditorContextKeys).diffEditorInlineMode, this._contextKeyService, (reader)=>!this._options.renderSideBySide.read(reader)));
        this._register((0, _platformObservableUtilsJs.bindContextKey)((0, _editorContextKeysJs.EditorContextKeys).hasChanges, this._contextKeyService, (reader)=>(this._diffModel.read(reader)?.diff.read(reader)?.mappings.length ?? 0) > 0));
        this._editors = this._register(this._instantiationService.createInstance((0, _diffEditorEditorsJs.DiffEditorEditors), this.elements.original, this.elements.modified, this._options, codeEditorWidgetOptions, (i, c, o, o2)=>this._createInnerEditor(i, c, o, o2)));
        this._register((0, _platformObservableUtilsJs.bindContextKey)((0, _editorContextKeysJs.EditorContextKeys).diffEditorOriginalWritable, this._contextKeyService, (reader)=>this._options.originalEditable.read(reader)));
        this._register((0, _platformObservableUtilsJs.bindContextKey)((0, _editorContextKeysJs.EditorContextKeys).diffEditorModifiedWritable, this._contextKeyService, (reader)=>!this._options.readOnly.read(reader)));
        this._register((0, _platformObservableUtilsJs.bindContextKey)((0, _editorContextKeysJs.EditorContextKeys).diffEditorOriginalUri, this._contextKeyService, (reader)=>this._diffModel.read(reader)?.model.original.uri.toString() ?? ""));
        this._register((0, _platformObservableUtilsJs.bindContextKey)((0, _editorContextKeysJs.EditorContextKeys).diffEditorModifiedUri, this._contextKeyService, (reader)=>this._diffModel.read(reader)?.model.modified.uri.toString() ?? ""));
        this._overviewRulerPart = (0, _derivedJs.derivedDisposable)(this, (reader)=>!this._options.renderOverviewRuler.read(reader) ? undefined : this._instantiationService.createInstance((0, _hotReloadHelpersJs.readHotReloadableExport)((0, _overviewRulerFeatureJs.OverviewRulerFeature), reader), this._editors, this.elements.root, this._diffModel, this._rootSizeObserver.width, this._rootSizeObserver.height, this._layoutInfo.map((i)=>i.modifiedEditor))).recomputeInitiallyAndOnChange(this._store);
        const dimensions = {
            height: this._rootSizeObserver.height,
            width: this._rootSizeObserver.width.map((w, reader)=>w - (this._overviewRulerPart.read(reader)?.width ?? 0))
        };
        this._sashLayout = new (0, _diffEditorSashJs.SashLayout)(this._options, dimensions);
        this._sash = (0, _derivedJs.derivedDisposable)(this, (reader)=>{
            const showSash = this._options.renderSideBySide.read(reader);
            this.elements.root.classList.toggle("side-by-side", showSash);
            return !showSash ? undefined : new (0, _diffEditorSashJs.DiffEditorSash)(this.elements.root, dimensions, this._options.enableSplitViewResizing, this._boundarySashes, this._sashLayout.sashLeft, ()=>this._sashLayout.resetSash());
        }).recomputeInitiallyAndOnChange(this._store);
        const unchangedRangesFeature = (0, _derivedJs.derivedDisposable)(this, (reader)=>/** @description UnchangedRangesFeature */ this._instantiationService.createInstance((0, _hotReloadHelpersJs.readHotReloadableExport)((0, _hideUnchangedRegionsFeatureJs.HideUnchangedRegionsFeature), reader), this._editors, this._diffModel, this._options)).recomputeInitiallyAndOnChange(this._store);
        (0, _derivedJs.derivedDisposable)(this, (reader)=>/** @description DiffEditorDecorations */ this._instantiationService.createInstance((0, _hotReloadHelpersJs.readHotReloadableExport)((0, _diffEditorDecorationsJs.DiffEditorDecorations), reader), this._editors, this._diffModel, this._options, this)).recomputeInitiallyAndOnChange(this._store);
        const origViewZoneIdsToIgnore = new Set();
        const modViewZoneIdsToIgnore = new Set();
        let isUpdatingViewZones = false;
        const viewZoneManager = (0, _derivedJs.derivedDisposable)(this, (reader)=>/** @description ViewZoneManager */ this._instantiationService.createInstance((0, _hotReloadHelpersJs.readHotReloadableExport)((0, _diffEditorViewZonesJs.DiffEditorViewZones), reader), (0, _domJs.getWindow)(this._domElement), this._editors, this._diffModel, this._options, this, ()=>isUpdatingViewZones || unchangedRangesFeature.get().isUpdatingHiddenAreas, origViewZoneIdsToIgnore, modViewZoneIdsToIgnore)).recomputeInitiallyAndOnChange(this._store);
        const originalViewZones = (0, _observableJs.derived)(this, (reader)=>{
            const orig = viewZoneManager.read(reader).viewZones.read(reader).orig;
            const orig2 = unchangedRangesFeature.read(reader).viewZones.read(reader).origViewZones;
            return orig.concat(orig2);
        });
        const modifiedViewZones = (0, _observableJs.derived)(this, (reader)=>{
            const mod = viewZoneManager.read(reader).viewZones.read(reader).mod;
            const mod2 = unchangedRangesFeature.read(reader).viewZones.read(reader).modViewZones;
            return mod.concat(mod2);
        });
        this._register((0, _utilsJs.applyViewZones)(this._editors.original, originalViewZones, (isUpdatingOrigViewZones)=>{
            isUpdatingViewZones = isUpdatingOrigViewZones;
        }, origViewZoneIdsToIgnore));
        let scrollState;
        this._register((0, _utilsJs.applyViewZones)(this._editors.modified, modifiedViewZones, (isUpdatingModViewZones)=>{
            isUpdatingViewZones = isUpdatingModViewZones;
            if (isUpdatingViewZones) scrollState = (0, _stableEditorScrollJs.StableEditorScrollState).capture(this._editors.modified);
            else {
                scrollState?.restore(this._editors.modified);
                scrollState = undefined;
            }
        }, modViewZoneIdsToIgnore));
        this._accessibleDiffViewer = (0, _derivedJs.derivedDisposable)(this, (reader)=>this._instantiationService.createInstance((0, _hotReloadHelpersJs.readHotReloadableExport)((0, _accessibleDiffViewerJs.AccessibleDiffViewer), reader), this.elements.accessibleDiffViewer, this._accessibleDiffViewerVisible, (visible, tx)=>this._accessibleDiffViewerShouldBeVisible.set(visible, tx), this._options.onlyShowAccessibleDiffViewer.map((v)=>!v), this._rootSizeObserver.width, this._rootSizeObserver.height, this._diffModel.map((m, r)=>m?.diff.read(r)?.mappings.map((m)=>m.lineRangeMapping)), new (0, _accessibleDiffViewerJs.AccessibleDiffViewerModelFromEditors)(this._editors))).recomputeInitiallyAndOnChange(this._store);
        const visibility = this._accessibleDiffViewerVisible.map((v)=>v ? "hidden" : "visible");
        this._register((0, _utilsJs.applyStyle)(this.elements.modified, {
            visibility
        }));
        this._register((0, _utilsJs.applyStyle)(this.elements.original, {
            visibility
        }));
        this._createDiffEditorContributions();
        codeEditorService.addDiffEditor(this);
        this._gutter = (0, _derivedJs.derivedDisposable)(this, (reader)=>{
            return this._options.shouldRenderGutterMenu.read(reader) ? this._instantiationService.createInstance((0, _hotReloadHelpersJs.readHotReloadableExport)((0, _gutterFeatureJs.DiffEditorGutter), reader), this.elements.root, this._diffModel, this._editors, this._options, this._sashLayout, this._boundarySashes) : undefined;
        });
        this._register((0, _observableJs.recomputeInitiallyAndOnChange)(this._layoutInfo));
        (0, _derivedJs.derivedDisposable)(this, (reader)=>/** @description MovedBlocksLinesPart */ new ((0, _hotReloadHelpersJs.readHotReloadableExport)((0, _movedBlocksLinesFeatureJs.MovedBlocksLinesFeature), reader))(this.elements.root, this._diffModel, this._layoutInfo.map((i)=>i.originalEditor), this._layoutInfo.map((i)=>i.modifiedEditor), this._editors)).recomputeInitiallyAndOnChange(this._store, (value)=>{
            // This is to break the layout info <-> moved blocks lines part dependency cycle.
            this._movedBlocksLinesPart.set(value, undefined);
        });
        this._register((0, _eventJs.Event).runAndSubscribe(this._editors.modified.onDidChangeCursorPosition, (e)=>this._handleCursorPositionChange(e, true)));
        this._register((0, _eventJs.Event).runAndSubscribe(this._editors.original.onDidChangeCursorPosition, (e)=>this._handleCursorPositionChange(e, false)));
        const isInitializingDiff = this._diffModel.map(this, (m, reader)=>{
            /** @isInitializingDiff isDiffUpToDate */ if (!m) return undefined;
            return m.diff.read(reader) === undefined && !m.isDiffUpToDate.read(reader);
        });
        this._register((0, _observableJs.autorunWithStore)((reader, store)=>{
            /** @description DiffEditorWidgetHelper.ShowProgress */ if (isInitializingDiff.read(reader) === true) {
                const r = this._editorProgressService.show(true, 1000);
                store.add((0, _lifecycleJs.toDisposable)(()=>r.done()));
            }
        }));
        this._register((0, _observableJs.autorunWithStore)((reader, store)=>{
            store.add(new ((0, _hotReloadHelpersJs.readHotReloadableExport)((0, _revertButtonsFeatureJs.RevertButtonsFeature), reader))(this._editors, this._diffModel, this._options, this));
        }));
        this._register((0, _observableJs.autorunWithStore)((reader, store)=>{
            const model = this._diffModel.read(reader);
            if (!model) return;
            for (const m of [
                model.model.original,
                model.model.modified
            ])store.add(m.onWillDispose((e)=>{
                (0, _errorsJs.onUnexpectedError)(new (0, _errorsJs.BugIndicatingError)("TextModel got disposed before DiffEditorWidget model got reset"));
                this.setModel(null);
            }));
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            this._options.setModel(this._diffModel.read(reader));
        }));
    }
    _createInnerEditor(instantiationService, container, options, editorWidgetOptions) {
        const editor = instantiationService.createInstance((0, _codeEditorWidgetJs.CodeEditorWidget), container, options, editorWidgetOptions);
        return editor;
    }
    _createDiffEditorContributions() {
        const contributions = (0, _editorExtensionsJs.EditorExtensionsRegistry).getDiffEditorContributions();
        for (const desc of contributions)try {
            this._register(this._instantiationService.createInstance(desc.ctor, this));
        } catch (err) {
            (0, _errorsJs.onUnexpectedError)(err);
        }
    }
    get _targetEditor() {
        return this._editors.modified;
    }
    getEditorType() {
        return (0, _editorCommonJs.EditorType).IDiffEditor;
    }
    layout(dimension) {
        this._rootSizeObserver.observe(dimension);
    }
    hasTextFocus() {
        return this._editors.original.hasTextFocus() || this._editors.modified.hasTextFocus();
    }
    saveViewState() {
        const originalViewState = this._editors.original.saveViewState();
        const modifiedViewState = this._editors.modified.saveViewState();
        return {
            original: originalViewState,
            modified: modifiedViewState,
            modelState: this._diffModel.get()?.serializeState()
        };
    }
    restoreViewState(s) {
        if (s && s.original && s.modified) {
            const diffEditorState = s;
            this._editors.original.restoreViewState(diffEditorState.original);
            this._editors.modified.restoreViewState(diffEditorState.modified);
            if (diffEditorState.modelState) this._diffModel.get()?.restoreSerializedState(diffEditorState.modelState);
        }
    }
    handleInitialized() {
        this._editors.original.handleInitialized();
        this._editors.modified.handleInitialized();
    }
    createViewModel(model) {
        return this._instantiationService.createInstance((0, _diffEditorViewModelJs.DiffEditorViewModel), model, this._options);
    }
    getModel() {
        return this._diffModel.get()?.model ?? null;
    }
    setModel(model) {
        const vm = !model ? null : "model" in model ? (0, _utilsJs.RefCounted).create(model).createNewRef(this) : (0, _utilsJs.RefCounted).create(this.createViewModel(model), this);
        this.setDiffModel(vm);
    }
    setDiffModel(viewModel, tx) {
        const currentModel = this._diffModel.get();
        if (!viewModel && currentModel) // Transitioning from a model to no-model
        this._accessibleDiffViewer.get().close();
        if (this._diffModel.get() !== viewModel?.object) (0, _observableJs.subtransaction)(tx, (tx)=>{
            const vm = viewModel?.object;
            /** @description DiffEditorWidget.setModel */ (0, _observableJs.observableFromEvent).batchEventsGlobally(tx, ()=>{
                this._editors.original.setModel(vm ? vm.model.original : null);
                this._editors.modified.setModel(vm ? vm.model.modified : null);
            });
            const prevValueRef = this._diffModelSrc.get()?.createNewRef(this);
            this._diffModelSrc.set(viewModel?.createNewRef(this), tx);
            setTimeout(()=>{
                // async, so that this runs after the transaction finished.
                // TODO: use the transaction to schedule disposal
                prevValueRef?.dispose();
            }, 0);
        });
    }
    /**
     * @param changedOptions Only has values for top-level options that have actually changed.
     */ updateOptions(changedOptions) {
        this._options.updateOptions(changedOptions);
    }
    getContainerDomNode() {
        return this._domElement;
    }
    getOriginalEditor() {
        return this._editors.original;
    }
    getModifiedEditor() {
        return this._editors.modified;
    }
    /**
     * @deprecated Use `this.getDiffComputationResult().changes2` instead.
     */ getLineChanges() {
        const diffState = this._diffModel.get()?.diff.get();
        if (!diffState) return null;
        return toLineChanges(diffState);
    }
    revert(diff) {
        const model = this._diffModel.get();
        if (!model || !model.isDiffUpToDate.get()) return;
        this._editors.modified.executeEdits("diffEditor", [
            {
                range: diff.modified.toExclusiveRange(),
                text: model.model.original.getValueInRange(diff.original.toExclusiveRange())
            }
        ]);
    }
    revertRangeMappings(diffs) {
        const model = this._diffModel.get();
        if (!model || !model.isDiffUpToDate.get()) return;
        const changes = diffs.map((c)=>({
                range: c.modifiedRange,
                text: model.model.original.getValueInRange(c.originalRange)
            }));
        this._editors.modified.executeEdits("diffEditor", changes);
    }
    _goTo(diff) {
        this._editors.modified.setPosition(new (0, _positionJs.Position)(diff.lineRangeMapping.modified.startLineNumber, 1));
        this._editors.modified.revealRangeInCenter(diff.lineRangeMapping.modified.toExclusiveRange());
    }
    goToDiff(target) {
        const diffs = this._diffModel.get()?.diff.get()?.mappings;
        if (!diffs || diffs.length === 0) return;
        const curLineNumber = this._editors.modified.getPosition().lineNumber;
        let diff;
        if (target === "next") diff = diffs.find((d)=>d.lineRangeMapping.modified.startLineNumber > curLineNumber) ?? diffs[0];
        else diff = (0, _arraysFindJs.findLast)(diffs, (d)=>d.lineRangeMapping.modified.startLineNumber < curLineNumber) ?? diffs[diffs.length - 1];
        this._goTo(diff);
        if (diff.lineRangeMapping.modified.isEmpty) this._accessibilitySignalService.playSignal((0, _accessibilitySignalServiceJs.AccessibilitySignal).diffLineDeleted, {
            source: "diffEditor.goToDiff"
        });
        else if (diff.lineRangeMapping.original.isEmpty) this._accessibilitySignalService.playSignal((0, _accessibilitySignalServiceJs.AccessibilitySignal).diffLineInserted, {
            source: "diffEditor.goToDiff"
        });
        else if (diff) this._accessibilitySignalService.playSignal((0, _accessibilitySignalServiceJs.AccessibilitySignal).diffLineModified, {
            source: "diffEditor.goToDiff"
        });
    }
    revealFirstDiff() {
        const diffModel = this._diffModel.get();
        if (!diffModel) return;
        // wait for the diff computation to finish
        this.waitForDiff().then(()=>{
            const diffs = diffModel.diff.get()?.mappings;
            if (!diffs || diffs.length === 0) return;
            this._goTo(diffs[0]);
        });
    }
    accessibleDiffViewerNext() {
        this._accessibleDiffViewer.get().next();
    }
    accessibleDiffViewerPrev() {
        this._accessibleDiffViewer.get().prev();
    }
    async waitForDiff() {
        const diffModel = this._diffModel.get();
        if (!diffModel) return;
        await diffModel.waitForDiff();
    }
    mapToOtherSide() {
        const isModifiedFocus = this._editors.modified.hasWidgetFocus();
        const source = isModifiedFocus ? this._editors.modified : this._editors.original;
        const destination = isModifiedFocus ? this._editors.original : this._editors.modified;
        let destinationSelection;
        const sourceSelection = source.getSelection();
        if (sourceSelection) {
            const mappings = this._diffModel.get()?.diff.get()?.mappings.map((m)=>isModifiedFocus ? m.lineRangeMapping.flip() : m.lineRangeMapping);
            if (mappings) {
                const newRange1 = (0, _utilsJs.translatePosition)(sourceSelection.getStartPosition(), mappings);
                const newRange2 = (0, _utilsJs.translatePosition)(sourceSelection.getEndPosition(), mappings);
                destinationSelection = (0, _rangeJs.Range).plusRange(newRange1, newRange2);
            }
        }
        return {
            destination,
            destinationSelection
        };
    }
    switchSide() {
        const { destination, destinationSelection } = this.mapToOtherSide();
        destination.focus();
        if (destinationSelection) destination.setSelection(destinationSelection);
    }
    exitCompareMove() {
        const model = this._diffModel.get();
        if (!model) return;
        model.movedTextToCompare.set(undefined, undefined);
    }
    collapseAllUnchangedRegions() {
        const unchangedRegions = this._diffModel.get()?.unchangedRegions.get();
        if (!unchangedRegions) return;
        (0, _observableJs.transaction)((tx)=>{
            for (const region of unchangedRegions)region.collapseAll(tx);
        });
    }
    showAllUnchangedRegions() {
        const unchangedRegions = this._diffModel.get()?.unchangedRegions.get();
        if (!unchangedRegions) return;
        (0, _observableJs.transaction)((tx)=>{
            for (const region of unchangedRegions)region.showAll(tx);
        });
    }
    _handleCursorPositionChange(e, isModifiedEditor) {
        if (e?.reason === 3 /* CursorChangeReason.Explicit */ ) {
            const diff = this._diffModel.get()?.diff.get()?.mappings.find((m)=>isModifiedEditor ? m.lineRangeMapping.modified.contains(e.position.lineNumber) : m.lineRangeMapping.original.contains(e.position.lineNumber));
            if (diff?.lineRangeMapping.modified.isEmpty) this._accessibilitySignalService.playSignal((0, _accessibilitySignalServiceJs.AccessibilitySignal).diffLineDeleted, {
                source: "diffEditor.cursorPositionChanged"
            });
            else if (diff?.lineRangeMapping.original.isEmpty) this._accessibilitySignalService.playSignal((0, _accessibilitySignalServiceJs.AccessibilitySignal).diffLineInserted, {
                source: "diffEditor.cursorPositionChanged"
            });
            else if (diff) this._accessibilitySignalService.playSignal((0, _accessibilitySignalServiceJs.AccessibilitySignal).diffLineModified, {
                source: "diffEditor.cursorPositionChanged"
            });
        }
    }
};
DiffEditorWidget = __decorate([
    __param(3, (0, _contextkeyJs.IContextKeyService)),
    __param(4, (0, _instantiationJs.IInstantiationService)),
    __param(5, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(6, (0, _accessibilitySignalServiceJs.IAccessibilitySignalService)),
    __param(7, (0, _progressJs.IEditorProgressService))
], DiffEditorWidget);
function toLineChanges(state) {
    return state.mappings.map((x)=>{
        const m = x.lineRangeMapping;
        let originalStartLineNumber;
        let originalEndLineNumber;
        let modifiedStartLineNumber;
        let modifiedEndLineNumber;
        let innerChanges = m.innerChanges;
        if (m.original.isEmpty) {
            // Insertion
            originalStartLineNumber = m.original.startLineNumber - 1;
            originalEndLineNumber = 0;
            innerChanges = undefined;
        } else {
            originalStartLineNumber = m.original.startLineNumber;
            originalEndLineNumber = m.original.endLineNumberExclusive - 1;
        }
        if (m.modified.isEmpty) {
            // Deletion
            modifiedStartLineNumber = m.modified.startLineNumber - 1;
            modifiedEndLineNumber = 0;
            innerChanges = undefined;
        } else {
            modifiedStartLineNumber = m.modified.startLineNumber;
            modifiedEndLineNumber = m.modified.endLineNumberExclusive - 1;
        }
        return {
            originalStartLineNumber,
            originalEndLineNumber,
            modifiedStartLineNumber,
            modifiedEndLineNumber,
            charChanges: innerChanges?.map((m)=>({
                    originalStartLineNumber: m.originalRange.startLineNumber,
                    originalStartColumn: m.originalRange.startColumn,
                    originalEndLineNumber: m.originalRange.endLineNumber,
                    originalEndColumn: m.originalRange.endColumn,
                    modifiedStartLineNumber: m.modifiedRange.startLineNumber,
                    modifiedStartColumn: m.modifiedRange.startColumn,
                    modifiedEndLineNumber: m.modifiedRange.endLineNumber,
                    modifiedEndColumn: m.modifiedRange.endColumn
                }))
        };
    });
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/arraysFind.js":"gWrU0","../../../../base/common/errors.js":"divX8","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../../../base/common/observableInternal/derived.js":"hZb5S","./style.css":"8m6S8","../../editorExtensions.js":"kC3w6","../../services/codeEditorService.js":"bOWtl","../../stableEditorScroll.js":"5Bh72","../codeEditor/codeEditorWidget.js":"kFkuL","./components/accessibleDiffViewer.js":"kAG6x","./components/diffEditorDecorations.js":"iixGB","./components/diffEditorSash.js":"8adBv","./components/diffEditorViewZones/diffEditorViewZones.js":"h8oLv","./features/gutterFeature.js":"4tY39","./features/hideUnchangedRegionsFeature.js":"97RPC","./features/movedBlocksLinesFeature.js":"1UiXm","./features/overviewRulerFeature.js":"8bSV4","./features/revertButtonsFeature.js":"3GH28","./utils.js":"2G3Lp","../../../../base/common/hotReloadHelpers.js":"3t1eI","../../../../platform/observable/common/platformObservableUtils.js":"aB9DE","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/editorCommon.js":"681Ll","../../../common/editorContextKeys.js":"5exv9","../../../../platform/accessibilitySignal/browser/accessibilitySignalService.js":"hpeDM","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/instantiation/common/serviceCollection.js":"5sFx9","../../../../platform/progress/common/progress.js":"f49eD","./components/diffEditorEditors.js":"i3yc1","./delegatingEditorImpl.js":"WPqIw","./diffEditorOptions.js":"2A2oD","./diffEditorViewModel.js":"61Iqn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8m6S8":[function() {},{}],"5Bh72":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StableEditorScrollState", ()=>StableEditorScrollState);
class StableEditorScrollState {
    static capture(editor) {
        if (editor.getScrollTop() === 0 || editor.hasPendingScrollAnimation()) // Never mess with the scroll top if the editor is at the top of the file or if there is a pending scroll animation
        return new StableEditorScrollState(editor.getScrollTop(), editor.getContentHeight(), null, 0, null);
        let visiblePosition = null;
        let visiblePositionScrollDelta = 0;
        const visibleRanges = editor.getVisibleRanges();
        if (visibleRanges.length > 0) {
            visiblePosition = visibleRanges[0].getStartPosition();
            const visiblePositionScrollTop = editor.getTopForPosition(visiblePosition.lineNumber, visiblePosition.column);
            visiblePositionScrollDelta = editor.getScrollTop() - visiblePositionScrollTop;
        }
        return new StableEditorScrollState(editor.getScrollTop(), editor.getContentHeight(), visiblePosition, visiblePositionScrollDelta, editor.getPosition());
    }
    constructor(_initialScrollTop, _initialContentHeight, _visiblePosition, _visiblePositionScrollDelta, _cursorPosition){
        this._initialScrollTop = _initialScrollTop;
        this._initialContentHeight = _initialContentHeight;
        this._visiblePosition = _visiblePosition;
        this._visiblePositionScrollDelta = _visiblePositionScrollDelta;
        this._cursorPosition = _cursorPosition;
    }
    restore(editor) {
        if (this._initialContentHeight === editor.getContentHeight() && this._initialScrollTop === editor.getScrollTop()) // The editor's content height and scroll top haven't changed, so we don't need to do anything
        return;
        if (this._visiblePosition) {
            const visiblePositionScrollTop = editor.getTopForPosition(this._visiblePosition.lineNumber, this._visiblePosition.column);
            editor.setScrollTop(visiblePositionScrollTop + this._visiblePositionScrollDelta);
        }
    }
    restoreRelativeVerticalPositionOfCursor(editor) {
        if (this._initialContentHeight === editor.getContentHeight() && this._initialScrollTop === editor.getScrollTop()) // The editor's content height and scroll top haven't changed, so we don't need to do anything
        return;
        const currentCursorPosition = editor.getPosition();
        if (!this._cursorPosition || !currentCursorPosition) return;
        const offset = editor.getTopForLineNumber(currentCursorPosition.lineNumber) - editor.getTopForLineNumber(this._cursorPosition.lineNumber);
        editor.setScrollTop(editor.getScrollTop() + offset, 1 /* ScrollType.Immediate */ );
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kAG6x":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessibleDiffViewer", ()=>AccessibleDiffViewer);
parcelHelpers.export(exports, "AccessibleDiffViewerModelFromEditors", ()=>AccessibleDiffViewerModelFromEditors);
var _domJs = require("../../../../../base/browser/dom.js");
var _trustedTypesJs = require("../../../../../base/browser/trustedTypes.js");
var _actionbarJs = require("../../../../../base/browser/ui/actionbar/actionbar.js");
var _scrollableElementJs = require("../../../../../base/browser/ui/scrollbar/scrollableElement.js");
var _actionsJs = require("../../../../../base/common/actions.js");
var _arraysJs = require("../../../../../base/common/arrays.js");
var _codiconsJs = require("../../../../../base/common/codicons.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _themablesJs = require("../../../../../base/common/themables.js");
var _domFontInfoJs = require("../../../config/domFontInfo.js");
var _utilsJs = require("../utils.js");
var _editorOptionsJs = require("../../../../common/config/editorOptions.js");
var _lineRangeJs = require("../../../../common/core/lineRange.js");
var _offsetRangeJs = require("../../../../common/core/offsetRange.js");
var _positionJs = require("../../../../common/core/position.js");
var _rangeJs = require("../../../../common/core/range.js");
var _rangeMappingJs = require("../../../../common/diff/rangeMapping.js");
var _languageJs = require("../../../../common/languages/language.js");
var _lineTokensJs = require("../../../../common/tokens/lineTokens.js");
var _viewLineRendererJs = require("../../../../common/viewLayout/viewLineRenderer.js");
var _viewModelJs = require("../../../../common/viewModel.js");
var _nlsJs = require("../../../../../nls.js");
var _accessibilitySignalServiceJs = require("../../../../../platform/accessibilitySignal/browser/accessibilitySignalService.js");
var _instantiationJs = require("../../../../../platform/instantiation/common/instantiation.js");
var _iconRegistryJs = require("../../../../../platform/theme/common/iconRegistry.js");
var _accessibleDiffViewerCss = require("./accessibleDiffViewer.css");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const accessibleDiffViewerInsertIcon = (0, _iconRegistryJs.registerIcon)("diff-review-insert", (0, _codiconsJs.Codicon).add, (0, _nlsJs.localize)("accessibleDiffViewerInsertIcon", "Icon for 'Insert' in accessible diff viewer."));
const accessibleDiffViewerRemoveIcon = (0, _iconRegistryJs.registerIcon)("diff-review-remove", (0, _codiconsJs.Codicon).remove, (0, _nlsJs.localize)("accessibleDiffViewerRemoveIcon", "Icon for 'Remove' in accessible diff viewer."));
const accessibleDiffViewerCloseIcon = (0, _iconRegistryJs.registerIcon)("diff-review-close", (0, _codiconsJs.Codicon).close, (0, _nlsJs.localize)("accessibleDiffViewerCloseIcon", "Icon for 'Close' in accessible diff viewer."));
let AccessibleDiffViewer = class AccessibleDiffViewer extends (0, _lifecycleJs.Disposable) {
    static{
        this._ttPolicy = (0, _trustedTypesJs.createTrustedTypesPolicy)("diffReview", {
            createHTML: (value)=>value
        });
    }
    constructor(_parentNode, _visible, _setVisible, _canClose, _width, _height, _diffs, _models, _instantiationService){
        super();
        this._parentNode = _parentNode;
        this._visible = _visible;
        this._setVisible = _setVisible;
        this._canClose = _canClose;
        this._width = _width;
        this._height = _height;
        this._diffs = _diffs;
        this._models = _models;
        this._instantiationService = _instantiationService;
        this._state = (0, _observableJs.derivedWithStore)(this, (reader, store)=>{
            const visible = this._visible.read(reader);
            this._parentNode.style.visibility = visible ? "visible" : "hidden";
            if (!visible) return null;
            const model = store.add(this._instantiationService.createInstance(ViewModel, this._diffs, this._models, this._setVisible, this._canClose));
            const view = store.add(this._instantiationService.createInstance(View, this._parentNode, model, this._width, this._height, this._models));
            return {
                model,
                view
            };
        }).recomputeInitiallyAndOnChange(this._store);
    }
    next() {
        (0, _observableJs.transaction)((tx)=>{
            const isVisible = this._visible.get();
            this._setVisible(true, tx);
            if (isVisible) this._state.get().model.nextGroup(tx);
        });
    }
    prev() {
        (0, _observableJs.transaction)((tx)=>{
            this._setVisible(true, tx);
            this._state.get().model.previousGroup(tx);
        });
    }
    close() {
        (0, _observableJs.transaction)((tx)=>{
            this._setVisible(false, tx);
        });
    }
};
AccessibleDiffViewer = __decorate([
    __param(8, (0, _instantiationJs.IInstantiationService))
], AccessibleDiffViewer);
let ViewModel = class ViewModel extends (0, _lifecycleJs.Disposable) {
    constructor(_diffs, _models, _setVisible, canClose, _accessibilitySignalService){
        super();
        this._diffs = _diffs;
        this._models = _models;
        this._setVisible = _setVisible;
        this.canClose = canClose;
        this._accessibilitySignalService = _accessibilitySignalService;
        this._groups = (0, _observableJs.observableValue)(this, []);
        this._currentGroupIdx = (0, _observableJs.observableValue)(this, 0);
        this._currentElementIdx = (0, _observableJs.observableValue)(this, 0);
        this.groups = this._groups;
        this.currentGroup = this._currentGroupIdx.map((idx, r)=>this._groups.read(r)[idx]);
        this.currentGroupIndex = this._currentGroupIdx;
        this.currentElement = this._currentElementIdx.map((idx, r)=>this.currentGroup.read(r)?.lines[idx]);
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update groups */ const diffs = this._diffs.read(reader);
            if (!diffs) {
                this._groups.set([], undefined);
                return;
            }
            const groups = computeViewElementGroups(diffs, this._models.getOriginalModel().getLineCount(), this._models.getModifiedModel().getLineCount());
            (0, _observableJs.transaction)((tx)=>{
                const p = this._models.getModifiedPosition();
                if (p) {
                    const nextGroup = groups.findIndex((g)=>p?.lineNumber < g.range.modified.endLineNumberExclusive);
                    if (nextGroup !== -1) this._currentGroupIdx.set(nextGroup, tx);
                }
                this._groups.set(groups, tx);
            });
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description play audio-cue for diff */ const currentViewItem = this.currentElement.read(reader);
            if (currentViewItem?.type === LineType.Deleted) this._accessibilitySignalService.playSignal((0, _accessibilitySignalServiceJs.AccessibilitySignal).diffLineDeleted, {
                source: "accessibleDiffViewer.currentElementChanged"
            });
            else if (currentViewItem?.type === LineType.Added) this._accessibilitySignalService.playSignal((0, _accessibilitySignalServiceJs.AccessibilitySignal).diffLineInserted, {
                source: "accessibleDiffViewer.currentElementChanged"
            });
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description select lines in editor */ // This ensures editor commands (like revert/stage) work
            const currentViewItem = this.currentElement.read(reader);
            if (currentViewItem && currentViewItem.type !== LineType.Header) {
                const lineNumber = currentViewItem.modifiedLineNumber ?? currentViewItem.diff.modified.startLineNumber;
                this._models.modifiedSetSelection((0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(lineNumber, 1)));
            }
        }));
    }
    _goToGroupDelta(delta, tx) {
        const groups = this.groups.get();
        if (!groups || groups.length <= 1) return;
        (0, _observableJs.subtransaction)(tx, (tx)=>{
            this._currentGroupIdx.set((0, _offsetRangeJs.OffsetRange).ofLength(groups.length).clipCyclic(this._currentGroupIdx.get() + delta), tx);
            this._currentElementIdx.set(0, tx);
        });
    }
    nextGroup(tx) {
        this._goToGroupDelta(1, tx);
    }
    previousGroup(tx) {
        this._goToGroupDelta(-1, tx);
    }
    _goToLineDelta(delta) {
        const group = this.currentGroup.get();
        if (!group || group.lines.length <= 1) return;
        (0, _observableJs.transaction)((tx)=>{
            this._currentElementIdx.set((0, _offsetRangeJs.OffsetRange).ofLength(group.lines.length).clip(this._currentElementIdx.get() + delta), tx);
        });
    }
    goToNextLine() {
        this._goToLineDelta(1);
    }
    goToPreviousLine() {
        this._goToLineDelta(-1);
    }
    goToLine(line) {
        const group = this.currentGroup.get();
        if (!group) return;
        const idx = group.lines.indexOf(line);
        if (idx === -1) return;
        (0, _observableJs.transaction)((tx)=>{
            this._currentElementIdx.set(idx, tx);
        });
    }
    revealCurrentElementInEditor() {
        if (!this.canClose.get()) return;
        this._setVisible(false, undefined);
        const curElem = this.currentElement.get();
        if (curElem) {
            if (curElem.type === LineType.Deleted) this._models.originalReveal((0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(curElem.originalLineNumber, 1)));
            else this._models.modifiedReveal(curElem.type !== LineType.Header ? (0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(curElem.modifiedLineNumber, 1)) : undefined);
        }
    }
    close() {
        if (!this.canClose.get()) return;
        this._setVisible(false, undefined);
        this._models.modifiedFocus();
    }
};
ViewModel = __decorate([
    __param(4, (0, _accessibilitySignalServiceJs.IAccessibilitySignalService))
], ViewModel);
const viewElementGroupLineMargin = 3;
function computeViewElementGroups(diffs, originalLineCount, modifiedLineCount) {
    const result = [];
    for (const g of (0, _arraysJs.groupAdjacentBy)(diffs, (a, b)=>b.modified.startLineNumber - a.modified.endLineNumberExclusive < 2 * viewElementGroupLineMargin)){
        const viewElements = [];
        viewElements.push(new HeaderViewElement());
        const origFullRange = new (0, _lineRangeJs.LineRange)(Math.max(1, g[0].original.startLineNumber - viewElementGroupLineMargin), Math.min(g[g.length - 1].original.endLineNumberExclusive + viewElementGroupLineMargin, originalLineCount + 1));
        const modifiedFullRange = new (0, _lineRangeJs.LineRange)(Math.max(1, g[0].modified.startLineNumber - viewElementGroupLineMargin), Math.min(g[g.length - 1].modified.endLineNumberExclusive + viewElementGroupLineMargin, modifiedLineCount + 1));
        (0, _arraysJs.forEachAdjacent)(g, (a, b)=>{
            const origRange = new (0, _lineRangeJs.LineRange)(a ? a.original.endLineNumberExclusive : origFullRange.startLineNumber, b ? b.original.startLineNumber : origFullRange.endLineNumberExclusive);
            const modifiedRange = new (0, _lineRangeJs.LineRange)(a ? a.modified.endLineNumberExclusive : modifiedFullRange.startLineNumber, b ? b.modified.startLineNumber : modifiedFullRange.endLineNumberExclusive);
            origRange.forEach((origLineNumber)=>{
                viewElements.push(new UnchangedLineViewElement(origLineNumber, modifiedRange.startLineNumber + (origLineNumber - origRange.startLineNumber)));
            });
            if (b) {
                b.original.forEach((origLineNumber)=>{
                    viewElements.push(new DeletedLineViewElement(b, origLineNumber));
                });
                b.modified.forEach((modifiedLineNumber)=>{
                    viewElements.push(new AddedLineViewElement(b, modifiedLineNumber));
                });
            }
        });
        const modifiedRange = g[0].modified.join(g[g.length - 1].modified);
        const originalRange = g[0].original.join(g[g.length - 1].original);
        result.push(new ViewElementGroup(new (0, _rangeMappingJs.LineRangeMapping)(modifiedRange, originalRange), viewElements));
    }
    return result;
}
var LineType;
(function(LineType) {
    LineType[LineType["Header"] = 0] = "Header";
    LineType[LineType["Unchanged"] = 1] = "Unchanged";
    LineType[LineType["Deleted"] = 2] = "Deleted";
    LineType[LineType["Added"] = 3] = "Added";
})(LineType || (LineType = {}));
class ViewElementGroup {
    constructor(range, lines){
        this.range = range;
        this.lines = lines;
    }
}
class HeaderViewElement {
    constructor(){
        this.type = LineType.Header;
    }
}
class DeletedLineViewElement {
    constructor(diff, originalLineNumber){
        this.diff = diff;
        this.originalLineNumber = originalLineNumber;
        this.type = LineType.Deleted;
        this.modifiedLineNumber = undefined;
    }
}
class AddedLineViewElement {
    constructor(diff, modifiedLineNumber){
        this.diff = diff;
        this.modifiedLineNumber = modifiedLineNumber;
        this.type = LineType.Added;
        this.originalLineNumber = undefined;
    }
}
class UnchangedLineViewElement {
    constructor(originalLineNumber, modifiedLineNumber){
        this.originalLineNumber = originalLineNumber;
        this.modifiedLineNumber = modifiedLineNumber;
        this.type = LineType.Unchanged;
    }
}
let View = class View extends (0, _lifecycleJs.Disposable) {
    constructor(_element, _model, _width, _height, _models, _languageService){
        super();
        this._element = _element;
        this._model = _model;
        this._width = _width;
        this._height = _height;
        this._models = _models;
        this._languageService = _languageService;
        this.domNode = this._element;
        this.domNode.className = "monaco-component diff-review monaco-editor-background";
        const actionBarContainer = document.createElement("div");
        actionBarContainer.className = "diff-review-actions";
        this._actionBar = this._register(new (0, _actionbarJs.ActionBar)(actionBarContainer));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update actions */ this._actionBar.clear();
            if (this._model.canClose.read(reader)) this._actionBar.push(new (0, _actionsJs.Action)("diffreview.close", (0, _nlsJs.localize)("label.close", "Close"), "close-diff-review " + (0, _themablesJs.ThemeIcon).asClassName(accessibleDiffViewerCloseIcon), true, async ()=>_model.close()), {
                label: false,
                icon: true
            });
        }));
        this._content = document.createElement("div");
        this._content.className = "diff-review-content";
        this._content.setAttribute("role", "code");
        this._scrollbar = this._register(new (0, _scrollableElementJs.DomScrollableElement)(this._content, {}));
        (0, _domJs.reset)(this.domNode, this._scrollbar.getDomNode(), actionBarContainer);
        this._register((0, _observableJs.autorun)((r)=>{
            this._height.read(r);
            this._width.read(r);
            this._scrollbar.scanDomNode();
        }));
        this._register((0, _lifecycleJs.toDisposable)(()=>{
            (0, _domJs.reset)(this.domNode);
        }));
        this._register((0, _utilsJs.applyStyle)(this.domNode, {
            width: this._width,
            height: this._height
        }));
        this._register((0, _utilsJs.applyStyle)(this._content, {
            width: this._width,
            height: this._height
        }));
        this._register((0, _observableJs.autorunWithStore)((reader, store)=>{
            /** @description render */ this._model.currentGroup.read(reader);
            this._render(store);
        }));
        // TODO@hediet use commands
        this._register((0, _domJs.addStandardDisposableListener)(this.domNode, "keydown", (e)=>{
            if (e.equals(18 /* KeyCode.DownArrow */ ) || e.equals(2066 /* KeyCode.DownArrow */ ) || e.equals(530 /* KeyCode.DownArrow */ )) {
                e.preventDefault();
                this._model.goToNextLine();
            }
            if (e.equals(16 /* KeyCode.UpArrow */ ) || e.equals(2064 /* KeyCode.UpArrow */ ) || e.equals(528 /* KeyCode.UpArrow */ )) {
                e.preventDefault();
                this._model.goToPreviousLine();
            }
            if (e.equals(9 /* KeyCode.Escape */ ) || e.equals(2057 /* KeyCode.Escape */ ) || e.equals(521 /* KeyCode.Escape */ ) || e.equals(1033 /* KeyCode.Escape */ )) {
                e.preventDefault();
                this._model.close();
            }
            if (e.equals(10 /* KeyCode.Space */ ) || e.equals(3 /* KeyCode.Enter */ )) {
                e.preventDefault();
                this._model.revealCurrentElementInEditor();
            }
        }));
    }
    _render(store) {
        const originalOptions = this._models.getOriginalOptions();
        const modifiedOptions = this._models.getModifiedOptions();
        const container = document.createElement("div");
        container.className = "diff-review-table";
        container.setAttribute("role", "list");
        container.setAttribute("aria-label", (0, _nlsJs.localize)("ariaLabel", "Accessible Diff Viewer. Use arrow up and down to navigate."));
        (0, _domFontInfoJs.applyFontInfo)(container, modifiedOptions.get(50 /* EditorOption.fontInfo */ ));
        (0, _domJs.reset)(this._content, container);
        const originalModel = this._models.getOriginalModel();
        const modifiedModel = this._models.getModifiedModel();
        if (!originalModel || !modifiedModel) return;
        const originalModelOpts = originalModel.getOptions();
        const modifiedModelOpts = modifiedModel.getOptions();
        const lineHeight = modifiedOptions.get(67 /* EditorOption.lineHeight */ );
        const group = this._model.currentGroup.get();
        for (const viewItem of group?.lines || []){
            if (!group) break;
            let row;
            if (viewItem.type === LineType.Header) {
                const header = document.createElement("div");
                header.className = "diff-review-row";
                header.setAttribute("role", "listitem");
                const r = group.range;
                const diffIndex = this._model.currentGroupIndex.get();
                const diffsLength = this._model.groups.get().length;
                const getAriaLines = (lines)=>lines === 0 ? (0, _nlsJs.localize)("no_lines_changed", "no lines changed") : lines === 1 ? (0, _nlsJs.localize)("one_line_changed", "1 line changed") : (0, _nlsJs.localize)("more_lines_changed", "{0} lines changed", lines);
                const originalChangedLinesCntAria = getAriaLines(r.original.length);
                const modifiedChangedLinesCntAria = getAriaLines(r.modified.length);
                header.setAttribute("aria-label", (0, _nlsJs.localize)({
                    key: "header",
                    comment: [
                        "This is the ARIA label for a git diff header.",
                        "A git diff header looks like this: @@ -154,12 +159,39 @@.",
                        "That encodes that at original line 154 (which is now line 159), 12 lines were removed/changed with 39 lines.",
                        "Variables 0 and 1 refer to the diff index out of total number of diffs.",
                        "Variables 2 and 4 will be numbers (a line number).",
                        'Variables 3 and 5 will be "no lines changed", "1 line changed" or "X lines changed", localized separately.'
                    ]
                }, "Difference {0} of {1}: original line {2}, {3}, modified line {4}, {5}", diffIndex + 1, diffsLength, r.original.startLineNumber, originalChangedLinesCntAria, r.modified.startLineNumber, modifiedChangedLinesCntAria));
                const cell = document.createElement("div");
                cell.className = "diff-review-cell diff-review-summary";
                // e.g.: `1/10: @@ -504,7 +517,7 @@`
                cell.appendChild(document.createTextNode(`${diffIndex + 1}/${diffsLength}: @@ -${r.original.startLineNumber},${r.original.length} +${r.modified.startLineNumber},${r.modified.length} @@`));
                header.appendChild(cell);
                row = header;
            } else row = this._createRow(viewItem, lineHeight, this._width.get(), originalOptions, originalModel, originalModelOpts, modifiedOptions, modifiedModel, modifiedModelOpts);
            container.appendChild(row);
            const isSelectedObs = (0, _observableJs.derived)((reader)=>/** @description isSelected */ this._model.currentElement.read(reader) === viewItem);
            store.add((0, _observableJs.autorun)((reader)=>{
                /** @description update tab index */ const isSelected = isSelectedObs.read(reader);
                row.tabIndex = isSelected ? 0 : -1;
                if (isSelected) row.focus();
            }));
            store.add((0, _domJs.addDisposableListener)(row, "focus", ()=>{
                this._model.goToLine(viewItem);
            }));
        }
        this._scrollbar.scanDomNode();
    }
    _createRow(item, lineHeight, width, originalOptions, originalModel, originalModelOpts, modifiedOptions, modifiedModel, modifiedModelOpts) {
        const originalLayoutInfo = originalOptions.get(146 /* EditorOption.layoutInfo */ );
        const originalLineNumbersWidth = originalLayoutInfo.glyphMarginWidth + originalLayoutInfo.lineNumbersWidth;
        const modifiedLayoutInfo = modifiedOptions.get(146 /* EditorOption.layoutInfo */ );
        const modifiedLineNumbersWidth = 10 + modifiedLayoutInfo.glyphMarginWidth + modifiedLayoutInfo.lineNumbersWidth;
        let rowClassName = "diff-review-row";
        let lineNumbersExtraClassName = "";
        const spacerClassName = "diff-review-spacer";
        let spacerIcon = null;
        switch(item.type){
            case LineType.Added:
                rowClassName = "diff-review-row line-insert";
                lineNumbersExtraClassName = " char-insert";
                spacerIcon = accessibleDiffViewerInsertIcon;
                break;
            case LineType.Deleted:
                rowClassName = "diff-review-row line-delete";
                lineNumbersExtraClassName = " char-delete";
                spacerIcon = accessibleDiffViewerRemoveIcon;
                break;
        }
        const row = document.createElement("div");
        row.style.minWidth = width + "px";
        row.className = rowClassName;
        row.setAttribute("role", "listitem");
        row.ariaLevel = "";
        const cell = document.createElement("div");
        cell.className = "diff-review-cell";
        cell.style.height = `${lineHeight}px`;
        row.appendChild(cell);
        const originalLineNumber = document.createElement("span");
        originalLineNumber.style.width = originalLineNumbersWidth + "px";
        originalLineNumber.style.minWidth = originalLineNumbersWidth + "px";
        originalLineNumber.className = "diff-review-line-number" + lineNumbersExtraClassName;
        if (item.originalLineNumber !== undefined) originalLineNumber.appendChild(document.createTextNode(String(item.originalLineNumber)));
        else originalLineNumber.innerText = "\xa0";
        cell.appendChild(originalLineNumber);
        const modifiedLineNumber = document.createElement("span");
        modifiedLineNumber.style.width = modifiedLineNumbersWidth + "px";
        modifiedLineNumber.style.minWidth = modifiedLineNumbersWidth + "px";
        modifiedLineNumber.style.paddingRight = "10px";
        modifiedLineNumber.className = "diff-review-line-number" + lineNumbersExtraClassName;
        if (item.modifiedLineNumber !== undefined) modifiedLineNumber.appendChild(document.createTextNode(String(item.modifiedLineNumber)));
        else modifiedLineNumber.innerText = "\xa0";
        cell.appendChild(modifiedLineNumber);
        const spacer = document.createElement("span");
        spacer.className = spacerClassName;
        if (spacerIcon) {
            const spacerCodicon = document.createElement("span");
            spacerCodicon.className = (0, _themablesJs.ThemeIcon).asClassName(spacerIcon);
            spacerCodicon.innerText = "\xa0\xa0";
            spacer.appendChild(spacerCodicon);
        } else spacer.innerText = "\xa0\xa0";
        cell.appendChild(spacer);
        let lineContent;
        if (item.modifiedLineNumber !== undefined) {
            let html = this._getLineHtml(modifiedModel, modifiedOptions, modifiedModelOpts.tabSize, item.modifiedLineNumber, this._languageService.languageIdCodec);
            if (AccessibleDiffViewer._ttPolicy) html = AccessibleDiffViewer._ttPolicy.createHTML(html);
            cell.insertAdjacentHTML("beforeend", html);
            lineContent = modifiedModel.getLineContent(item.modifiedLineNumber);
        } else {
            let html = this._getLineHtml(originalModel, originalOptions, originalModelOpts.tabSize, item.originalLineNumber, this._languageService.languageIdCodec);
            if (AccessibleDiffViewer._ttPolicy) html = AccessibleDiffViewer._ttPolicy.createHTML(html);
            cell.insertAdjacentHTML("beforeend", html);
            lineContent = originalModel.getLineContent(item.originalLineNumber);
        }
        if (lineContent.length === 0) lineContent = (0, _nlsJs.localize)("blankLine", "blank");
        let ariaLabel = "";
        switch(item.type){
            case LineType.Unchanged:
                if (item.originalLineNumber === item.modifiedLineNumber) ariaLabel = (0, _nlsJs.localize)({
                    key: "unchangedLine",
                    comment: [
                        "The placeholders are contents of the line and should not be translated."
                    ]
                }, "{0} unchanged line {1}", lineContent, item.originalLineNumber);
                else ariaLabel = (0, _nlsJs.localize)("equalLine", "{0} original line {1} modified line {2}", lineContent, item.originalLineNumber, item.modifiedLineNumber);
                break;
            case LineType.Added:
                ariaLabel = (0, _nlsJs.localize)("insertLine", "+ {0} modified line {1}", lineContent, item.modifiedLineNumber);
                break;
            case LineType.Deleted:
                ariaLabel = (0, _nlsJs.localize)("deleteLine", "- {0} original line {1}", lineContent, item.originalLineNumber);
                break;
        }
        row.setAttribute("aria-label", ariaLabel);
        return row;
    }
    _getLineHtml(model, options, tabSize, lineNumber, languageIdCodec) {
        const lineContent = model.getLineContent(lineNumber);
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        const lineTokens = (0, _lineTokensJs.LineTokens).createEmpty(lineContent, languageIdCodec);
        const isBasicASCII = (0, _viewModelJs.ViewLineRenderingData).isBasicASCII(lineContent, model.mightContainNonBasicASCII());
        const containsRTL = (0, _viewModelJs.ViewLineRenderingData).containsRTL(lineContent, isBasicASCII, model.mightContainRTL());
        const r = (0, _viewLineRendererJs.renderViewLine2)(new (0, _viewLineRendererJs.RenderLineInput)(fontInfo.isMonospace && !options.get(33 /* EditorOption.disableMonospaceOptimizations */ ), fontInfo.canUseHalfwidthRightwardsArrow, lineContent, false, isBasicASCII, containsRTL, 0, lineTokens, [], tabSize, 0, fontInfo.spaceWidth, fontInfo.middotWidth, fontInfo.wsmiddotWidth, options.get(118 /* EditorOption.stopRenderingLineAfter */ ), options.get(100 /* EditorOption.renderWhitespace */ ), options.get(95 /* EditorOption.renderControlCharacters */ ), options.get(51 /* EditorOption.fontLigatures */ ) !== (0, _editorOptionsJs.EditorFontLigatures).OFF, null));
        return r.html;
    }
};
View = __decorate([
    __param(5, (0, _languageJs.ILanguageService))
], View);
class AccessibleDiffViewerModelFromEditors {
    constructor(editors){
        this.editors = editors;
    }
    getOriginalModel() {
        return this.editors.original.getModel();
    }
    getOriginalOptions() {
        return this.editors.original.getOptions();
    }
    originalReveal(range) {
        this.editors.original.revealRange(range);
        this.editors.original.setSelection(range);
        this.editors.original.focus();
    }
    getModifiedModel() {
        return this.editors.modified.getModel();
    }
    getModifiedOptions() {
        return this.editors.modified.getOptions();
    }
    modifiedReveal(range) {
        if (range) {
            this.editors.modified.revealRange(range);
            this.editors.modified.setSelection(range);
        }
        this.editors.modified.focus();
    }
    modifiedSetSelection(range) {
        this.editors.modified.setSelection(range);
    }
    modifiedFocus() {
        this.editors.modified.focus();
    }
    getModifiedPosition() {
        return this.editors.modified.getPosition() ?? undefined;
    }
}

},{"../../../../../base/browser/dom.js":"bnqsM","../../../../../base/browser/trustedTypes.js":"bgQyv","../../../../../base/browser/ui/actionbar/actionbar.js":"5Xmba","../../../../../base/browser/ui/scrollbar/scrollableElement.js":"h1C5l","../../../../../base/common/actions.js":"5GjLb","../../../../../base/common/arrays.js":"DECei","../../../../../base/common/codicons.js":"hWYNf","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../../base/common/themables.js":"hgyHi","../../../config/domFontInfo.js":"fQezv","../utils.js":"2G3Lp","../../../../common/config/editorOptions.js":"3Xi00","../../../../common/core/lineRange.js":"cmnMs","../../../../common/core/offsetRange.js":"ifHXk","../../../../common/core/position.js":"lvrPe","../../../../common/core/range.js":"jmUPh","../../../../common/diff/rangeMapping.js":"7QuJJ","../../../../common/languages/language.js":"ka2JQ","../../../../common/tokens/lineTokens.js":"6iUVx","../../../../common/viewLayout/viewLineRenderer.js":"1RGPz","../../../../common/viewModel.js":"5EHxj","../../../../../nls.js":"l617d","../../../../../platform/accessibilitySignal/browser/accessibilitySignalService.js":"hpeDM","../../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../../platform/theme/common/iconRegistry.js":"bRNEz","./accessibleDiffViewer.css":"bYwds","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2G3Lp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "joinCombine", ()=>joinCombine);
// TODO make utility
parcelHelpers.export(exports, "applyObservableDecorations", ()=>applyObservableDecorations);
parcelHelpers.export(exports, "appendRemoveOnDispose", ()=>appendRemoveOnDispose);
parcelHelpers.export(exports, "prependRemoveOnDispose", ()=>prependRemoveOnDispose);
parcelHelpers.export(exports, "ObservableElementSizeObserver", ()=>ObservableElementSizeObserver);
parcelHelpers.export(exports, "animatedObservable", ()=>animatedObservable);
parcelHelpers.export(exports, "ViewZoneOverlayWidget", ()=>ViewZoneOverlayWidget);
parcelHelpers.export(exports, "PlaceholderViewZone", ()=>PlaceholderViewZone);
parcelHelpers.export(exports, "ManagedOverlayWidget", ()=>ManagedOverlayWidget);
parcelHelpers.export(exports, "applyStyle", ()=>applyStyle);
parcelHelpers.export(exports, "applyViewZones", ()=>applyViewZones);
parcelHelpers.export(exports, "DisposableCancellationTokenSource", ()=>DisposableCancellationTokenSource);
parcelHelpers.export(exports, "translatePosition", ()=>translatePosition);
parcelHelpers.export(exports, "filterWithPrevious", ()=>filterWithPrevious);
parcelHelpers.export(exports, "RefCounted", ()=>RefCounted);
var _arraysFindJs = require("../../../../base/common/arraysFind.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _elementSizeObserverJs = require("../../config/elementSizeObserver.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _textLengthJs = require("../../../common/core/textLength.js");
function joinCombine(arr1, arr2, keySelector, combine) {
    if (arr1.length === 0) return arr2;
    if (arr2.length === 0) return arr1;
    const result = [];
    let i = 0;
    let j = 0;
    while(i < arr1.length && j < arr2.length){
        const val1 = arr1[i];
        const val2 = arr2[j];
        const key1 = keySelector(val1);
        const key2 = keySelector(val2);
        if (key1 < key2) {
            result.push(val1);
            i++;
        } else if (key1 > key2) {
            result.push(val2);
            j++;
        } else {
            result.push(combine(val1, val2));
            i++;
            j++;
        }
    }
    while(i < arr1.length){
        result.push(arr1[i]);
        i++;
    }
    while(j < arr2.length){
        result.push(arr2[j]);
        j++;
    }
    return result;
}
function applyObservableDecorations(editor, decorations) {
    const d = new (0, _lifecycleJs.DisposableStore)();
    const decorationsCollection = editor.createDecorationsCollection();
    d.add((0, _observableJs.autorunOpts)({
        debugName: ()=>`Apply decorations from ${decorations.debugName}`
    }, (reader)=>{
        const d = decorations.read(reader);
        decorationsCollection.set(d);
    }));
    d.add({
        dispose: ()=>{
            decorationsCollection.clear();
        }
    });
    return d;
}
function appendRemoveOnDispose(parent, child) {
    parent.appendChild(child);
    return (0, _lifecycleJs.toDisposable)(()=>{
        child.remove();
    });
}
function prependRemoveOnDispose(parent, child) {
    parent.prepend(child);
    return (0, _lifecycleJs.toDisposable)(()=>{
        child.remove();
    });
}
class ObservableElementSizeObserver extends (0, _lifecycleJs.Disposable) {
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    get automaticLayout() {
        return this._automaticLayout;
    }
    constructor(element, dimension){
        super();
        this._automaticLayout = false;
        this.elementSizeObserver = this._register(new (0, _elementSizeObserverJs.ElementSizeObserver)(element, dimension));
        this._width = (0, _observableJs.observableValue)(this, this.elementSizeObserver.getWidth());
        this._height = (0, _observableJs.observableValue)(this, this.elementSizeObserver.getHeight());
        this._register(this.elementSizeObserver.onDidChange((e)=>(0, _observableJs.transaction)((tx)=>{
                /** @description Set width/height from elementSizeObserver */ this._width.set(this.elementSizeObserver.getWidth(), tx);
                this._height.set(this.elementSizeObserver.getHeight(), tx);
            })));
    }
    observe(dimension) {
        this.elementSizeObserver.observe(dimension);
    }
    setAutomaticLayout(automaticLayout) {
        this._automaticLayout = automaticLayout;
        if (automaticLayout) this.elementSizeObserver.startObserving();
        else this.elementSizeObserver.stopObserving();
    }
}
function animatedObservable(targetWindow, base, store) {
    let targetVal = base.get();
    let startVal = targetVal;
    let curVal = targetVal;
    const result = (0, _observableJs.observableValue)("animatedValue", targetVal);
    let animationStartMs = -1;
    const durationMs = 300;
    let animationFrame = undefined;
    store.add((0, _observableJs.autorunHandleChanges)({
        createEmptyChangeSummary: ()=>({
                animate: false
            }),
        handleChange: (ctx, s)=>{
            if (ctx.didChange(base)) s.animate = s.animate || ctx.change;
            return true;
        }
    }, (reader, s)=>{
        /** @description update value */ if (animationFrame !== undefined) {
            targetWindow.cancelAnimationFrame(animationFrame);
            animationFrame = undefined;
        }
        startVal = curVal;
        targetVal = base.read(reader);
        animationStartMs = Date.now() - (s.animate ? 0 : durationMs);
        update();
    }));
    function update() {
        const passedMs = Date.now() - animationStartMs;
        curVal = Math.floor(easeOutExpo(passedMs, startVal, targetVal - startVal, durationMs));
        if (passedMs < durationMs) animationFrame = targetWindow.requestAnimationFrame(update);
        else curVal = targetVal;
        result.set(curVal, undefined);
    }
    return result;
}
function easeOutExpo(t, b, c, d) {
    return t === d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
}
class ViewZoneOverlayWidget extends (0, _lifecycleJs.Disposable) {
    constructor(editor, viewZone, htmlElement){
        super();
        this._register(new ManagedOverlayWidget(editor, htmlElement));
        this._register(applyStyle(htmlElement, {
            height: viewZone.actualHeight,
            top: viewZone.actualTop
        }));
    }
}
class PlaceholderViewZone {
    get afterLineNumber() {
        return this._afterLineNumber.get();
    }
    constructor(_afterLineNumber, heightInPx){
        this._afterLineNumber = _afterLineNumber;
        this.heightInPx = heightInPx;
        this.domNode = document.createElement("div");
        this._actualTop = (0, _observableJs.observableValue)(this, undefined);
        this._actualHeight = (0, _observableJs.observableValue)(this, undefined);
        this.actualTop = this._actualTop;
        this.actualHeight = this._actualHeight;
        this.showInHiddenAreas = true;
        this.onChange = this._afterLineNumber;
        this.onDomNodeTop = (top)=>{
            this._actualTop.set(top, undefined);
        };
        this.onComputedHeight = (height)=>{
            this._actualHeight.set(height, undefined);
        };
    }
}
class ManagedOverlayWidget {
    static{
        this._counter = 0;
    }
    constructor(_editor, _domElement){
        this._editor = _editor;
        this._domElement = _domElement;
        this._overlayWidgetId = `managedOverlayWidget-${ManagedOverlayWidget._counter++}`;
        this._overlayWidget = {
            getId: ()=>this._overlayWidgetId,
            getDomNode: ()=>this._domElement,
            getPosition: ()=>null
        };
        this._editor.addOverlayWidget(this._overlayWidget);
    }
    dispose() {
        this._editor.removeOverlayWidget(this._overlayWidget);
    }
}
function applyStyle(domNode, style) {
    return (0, _observableJs.autorun)((reader)=>{
        /** @description applyStyle */ for (let [key, val] of Object.entries(style)){
            if (val && typeof val === "object" && "read" in val) val = val.read(reader);
            if (typeof val === "number") val = `${val}px`;
            key = key.replace(/[A-Z]/g, (m)=>"-" + m.toLowerCase());
            domNode.style[key] = val;
        }
    });
}
function applyViewZones(editor, viewZones, setIsUpdating, zoneIds) {
    const store = new (0, _lifecycleJs.DisposableStore)();
    const lastViewZoneIds = [];
    store.add((0, _observableJs.autorunWithStore)((reader, store)=>{
        /** @description applyViewZones */ const curViewZones = viewZones.read(reader);
        const viewZonIdsPerViewZone = new Map();
        const viewZoneIdPerOnChangeObservable = new Map();
        // Add/remove view zones
        if (setIsUpdating) setIsUpdating(true);
        editor.changeViewZones((a)=>{
            for (const id of lastViewZoneIds){
                a.removeZone(id);
                zoneIds?.delete(id);
            }
            lastViewZoneIds.length = 0;
            for (const z of curViewZones){
                const id = a.addZone(z);
                if (z.setZoneId) z.setZoneId(id);
                lastViewZoneIds.push(id);
                zoneIds?.add(id);
                viewZonIdsPerViewZone.set(z, id);
            }
        });
        if (setIsUpdating) setIsUpdating(false);
        // Layout zone on change
        store.add((0, _observableJs.autorunHandleChanges)({
            createEmptyChangeSummary () {
                return {
                    zoneIds: []
                };
            },
            handleChange (context, changeSummary) {
                const id = viewZoneIdPerOnChangeObservable.get(context.changedObservable);
                if (id !== undefined) changeSummary.zoneIds.push(id);
                return true;
            }
        }, (reader, changeSummary)=>{
            /** @description layoutZone on change */ for (const vz of curViewZones)if (vz.onChange) {
                viewZoneIdPerOnChangeObservable.set(vz.onChange, viewZonIdsPerViewZone.get(vz));
                vz.onChange.read(reader);
            }
            if (setIsUpdating) setIsUpdating(true);
            editor.changeViewZones((a)=>{
                for (const id of changeSummary.zoneIds)a.layoutZone(id);
            });
            if (setIsUpdating) setIsUpdating(false);
        }));
    }));
    store.add({
        dispose () {
            if (setIsUpdating) setIsUpdating(true);
            editor.changeViewZones((a)=>{
                for (const id of lastViewZoneIds)a.removeZone(id);
            });
            zoneIds?.clear();
            if (setIsUpdating) setIsUpdating(false);
        }
    });
    return store;
}
class DisposableCancellationTokenSource extends (0, _cancellationJs.CancellationTokenSource) {
    dispose() {
        super.dispose(true);
    }
}
function translatePosition(posInOriginal, mappings) {
    const mapping = (0, _arraysFindJs.findLast)(mappings, (m)=>m.original.startLineNumber <= posInOriginal.lineNumber);
    if (!mapping) // No changes before the position
    return (0, _rangeJs.Range).fromPositions(posInOriginal);
    if (mapping.original.endLineNumberExclusive <= posInOriginal.lineNumber) {
        const newLineNumber = posInOriginal.lineNumber - mapping.original.endLineNumberExclusive + mapping.modified.endLineNumberExclusive;
        return (0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(newLineNumber, posInOriginal.column));
    }
    if (!mapping.innerChanges) // Only for legacy algorithm
    return (0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(mapping.modified.startLineNumber, 1));
    const innerMapping = (0, _arraysFindJs.findLast)(mapping.innerChanges, (m)=>m.originalRange.getStartPosition().isBeforeOrEqual(posInOriginal));
    if (!innerMapping) {
        const newLineNumber = posInOriginal.lineNumber - mapping.original.startLineNumber + mapping.modified.startLineNumber;
        return (0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(newLineNumber, posInOriginal.column));
    }
    if (innerMapping.originalRange.containsPosition(posInOriginal)) return innerMapping.modifiedRange;
    else {
        const l = lengthBetweenPositions(innerMapping.originalRange.getEndPosition(), posInOriginal);
        return (0, _rangeJs.Range).fromPositions(l.addToPosition(innerMapping.modifiedRange.getEndPosition()));
    }
}
function lengthBetweenPositions(position1, position2) {
    if (position1.lineNumber === position2.lineNumber) return new (0, _textLengthJs.TextLength)(0, position2.column - position1.column);
    else return new (0, _textLengthJs.TextLength)(position2.lineNumber - position1.lineNumber, position2.column - 1);
}
function filterWithPrevious(arr, filter) {
    let prev;
    return arr.filter((cur)=>{
        const result = filter(cur, prev);
        prev = cur;
        return result;
    });
}
class RefCounted {
    static create(value, debugOwner) {
        return new BaseRefCounted(value, value, debugOwner);
    }
    static createWithDisposable(value, disposable, debugOwner) {
        const store = new (0, _lifecycleJs.DisposableStore)();
        store.add(disposable);
        store.add(value);
        return new BaseRefCounted(value, store, debugOwner);
    }
}
class BaseRefCounted extends RefCounted {
    constructor(object, _disposable, _debugOwner){
        super();
        this.object = object;
        this._disposable = _disposable;
        this._debugOwner = _debugOwner;
        this._refCount = 1;
        this._isDisposed = false;
        this._owners = [];
        if (_debugOwner) this._addOwner(_debugOwner);
    }
    _addOwner(debugOwner) {
        if (debugOwner) this._owners.push(debugOwner);
    }
    createNewRef(debugOwner) {
        this._refCount++;
        if (debugOwner) this._addOwner(debugOwner);
        return new ClonedRefCounted(this, debugOwner);
    }
    dispose() {
        if (this._isDisposed) return;
        this._isDisposed = true;
        this._decreaseRefCount(this._debugOwner);
    }
    _decreaseRefCount(debugOwner) {
        this._refCount--;
        if (this._refCount === 0) this._disposable.dispose();
        if (debugOwner) {
            const idx = this._owners.indexOf(debugOwner);
            if (idx !== -1) this._owners.splice(idx, 1);
        }
    }
}
class ClonedRefCounted extends RefCounted {
    constructor(_base, _debugOwner){
        super();
        this._base = _base;
        this._debugOwner = _debugOwner;
        this._isDisposed = false;
    }
    get object() {
        return this._base.object;
    }
    createNewRef(debugOwner) {
        return this._base.createNewRef(debugOwner);
    }
    dispose() {
        if (this._isDisposed) return;
        this._isDisposed = true;
        this._base._decreaseRefCount(this._debugOwner);
    }
}

},{"../../../../base/common/arraysFind.js":"gWrU0","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../config/elementSizeObserver.js":"kvp5N","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/core/textLength.js":"Lk80L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bYwds":[function() {},{}],"iixGB":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiffEditorDecorations", ()=>DiffEditorDecorations);
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _diffEditorViewZonesJs = require("./diffEditorViewZones/diffEditorViewZones.js");
var _movedBlocksLinesFeatureJs = require("../features/movedBlocksLinesFeature.js");
var _registrationsContributionJs = require("../registrations.contribution.js");
var _utilsJs = require("../utils.js");
class DiffEditorDecorations extends (0, _lifecycleJs.Disposable) {
    constructor(_editors, _diffModel, _options, widget){
        super();
        this._editors = _editors;
        this._diffModel = _diffModel;
        this._options = _options;
        this._decorations = (0, _observableJs.derived)(this, (reader)=>{
            const diffModel = this._diffModel.read(reader);
            const diff = diffModel?.diff.read(reader);
            if (!diff) return null;
            const movedTextToCompare = this._diffModel.read(reader).movedTextToCompare.read(reader);
            const renderIndicators = this._options.renderIndicators.read(reader);
            const showEmptyDecorations = this._options.showEmptyDecorations.read(reader);
            const originalDecorations = [];
            const modifiedDecorations = [];
            if (!movedTextToCompare) for (const m of diff.mappings){
                if (!m.lineRangeMapping.original.isEmpty) originalDecorations.push({
                    range: m.lineRangeMapping.original.toInclusiveRange(),
                    options: renderIndicators ? (0, _registrationsContributionJs.diffLineDeleteDecorationBackgroundWithIndicator) : (0, _registrationsContributionJs.diffLineDeleteDecorationBackground)
                });
                if (!m.lineRangeMapping.modified.isEmpty) modifiedDecorations.push({
                    range: m.lineRangeMapping.modified.toInclusiveRange(),
                    options: renderIndicators ? (0, _registrationsContributionJs.diffLineAddDecorationBackgroundWithIndicator) : (0, _registrationsContributionJs.diffLineAddDecorationBackground)
                });
                if (m.lineRangeMapping.modified.isEmpty || m.lineRangeMapping.original.isEmpty) {
                    if (!m.lineRangeMapping.original.isEmpty) originalDecorations.push({
                        range: m.lineRangeMapping.original.toInclusiveRange(),
                        options: (0, _registrationsContributionJs.diffWholeLineDeleteDecoration)
                    });
                    if (!m.lineRangeMapping.modified.isEmpty) modifiedDecorations.push({
                        range: m.lineRangeMapping.modified.toInclusiveRange(),
                        options: (0, _registrationsContributionJs.diffWholeLineAddDecoration)
                    });
                } else {
                    const useInlineDiff = this._options.useTrueInlineDiffRendering.read(reader) && (0, _diffEditorViewZonesJs.allowsTrueInlineDiffRendering)(m.lineRangeMapping);
                    for (const i of m.lineRangeMapping.innerChanges || []){
                        // Don't show empty markers outside the line range
                        if (m.lineRangeMapping.original.contains(i.originalRange.startLineNumber)) originalDecorations.push({
                            range: i.originalRange,
                            options: i.originalRange.isEmpty() && showEmptyDecorations ? (0, _registrationsContributionJs.diffDeleteDecorationEmpty) : (0, _registrationsContributionJs.diffDeleteDecoration)
                        });
                        if (m.lineRangeMapping.modified.contains(i.modifiedRange.startLineNumber)) modifiedDecorations.push({
                            range: i.modifiedRange,
                            options: i.modifiedRange.isEmpty() && showEmptyDecorations && !useInlineDiff ? (0, _registrationsContributionJs.diffAddDecorationEmpty) : (0, _registrationsContributionJs.diffAddDecoration)
                        });
                        if (useInlineDiff) {
                            const deletedText = diffModel.model.original.getValueInRange(i.originalRange);
                            modifiedDecorations.push({
                                range: i.modifiedRange,
                                options: {
                                    description: "deleted-text",
                                    before: {
                                        content: deletedText,
                                        inlineClassName: "inline-deleted-text"
                                    },
                                    zIndex: 100000,
                                    showIfCollapsed: true
                                }
                            });
                        }
                    }
                }
            }
            if (movedTextToCompare) for (const m of movedTextToCompare.changes){
                const fullRangeOriginal = m.original.toInclusiveRange();
                if (fullRangeOriginal) originalDecorations.push({
                    range: fullRangeOriginal,
                    options: renderIndicators ? (0, _registrationsContributionJs.diffLineDeleteDecorationBackgroundWithIndicator) : (0, _registrationsContributionJs.diffLineDeleteDecorationBackground)
                });
                const fullRangeModified = m.modified.toInclusiveRange();
                if (fullRangeModified) modifiedDecorations.push({
                    range: fullRangeModified,
                    options: renderIndicators ? (0, _registrationsContributionJs.diffLineAddDecorationBackgroundWithIndicator) : (0, _registrationsContributionJs.diffLineAddDecorationBackground)
                });
                for (const i of m.innerChanges || []){
                    originalDecorations.push({
                        range: i.originalRange,
                        options: (0, _registrationsContributionJs.diffDeleteDecoration)
                    });
                    modifiedDecorations.push({
                        range: i.modifiedRange,
                        options: (0, _registrationsContributionJs.diffAddDecoration)
                    });
                }
            }
            const activeMovedText = this._diffModel.read(reader).activeMovedText.read(reader);
            for (const m of diff.movedTexts){
                originalDecorations.push({
                    range: m.lineRangeMapping.original.toInclusiveRange(),
                    options: {
                        description: "moved",
                        blockClassName: "movedOriginal" + (m === activeMovedText ? " currentMove" : ""),
                        blockPadding: [
                            (0, _movedBlocksLinesFeatureJs.MovedBlocksLinesFeature).movedCodeBlockPadding,
                            0,
                            (0, _movedBlocksLinesFeatureJs.MovedBlocksLinesFeature).movedCodeBlockPadding,
                            (0, _movedBlocksLinesFeatureJs.MovedBlocksLinesFeature).movedCodeBlockPadding
                        ]
                    }
                });
                modifiedDecorations.push({
                    range: m.lineRangeMapping.modified.toInclusiveRange(),
                    options: {
                        description: "moved",
                        blockClassName: "movedModified" + (m === activeMovedText ? " currentMove" : ""),
                        blockPadding: [
                            4,
                            0,
                            4,
                            4
                        ]
                    }
                });
            }
            return {
                originalDecorations,
                modifiedDecorations
            };
        });
        this._register((0, _utilsJs.applyObservableDecorations)(this._editors.original, this._decorations.map((d)=>d?.originalDecorations || [])));
        this._register((0, _utilsJs.applyObservableDecorations)(this._editors.modified, this._decorations.map((d)=>d?.modifiedDecorations || [])));
    }
}

},{"../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","./diffEditorViewZones/diffEditorViewZones.js":"h8oLv","../features/movedBlocksLinesFeature.js":"1UiXm","../registrations.contribution.js":"3EY0P","../utils.js":"2G3Lp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h8oLv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiffEditorViewZones", ()=>DiffEditorViewZones);
parcelHelpers.export(exports, "allowsTrueInlineDiffRendering", ()=>allowsTrueInlineDiffRendering);
var _domJs = require("../../../../../../base/browser/dom.js");
var _arraysJs = require("../../../../../../base/common/arrays.js");
var _asyncJs = require("../../../../../../base/common/async.js");
var _codiconsJs = require("../../../../../../base/common/codicons.js");
var _lifecycleJs = require("../../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../../base/common/observable.js");
var _themablesJs = require("../../../../../../base/common/themables.js");
var _typesJs = require("../../../../../../base/common/types.js");
var _domFontInfoJs = require("../../../../config/domFontInfo.js");
var _registrationsContributionJs = require("../../registrations.contribution.js");
var _diffEditorViewModelJs = require("../../diffEditorViewModel.js");
var _inlineDiffDeletedCodeMarginJs = require("./inlineDiffDeletedCodeMargin.js");
var _renderLinesJs = require("./renderLines.js");
var _utilsJs = require("../../utils.js");
var _lineRangeJs = require("../../../../../common/core/lineRange.js");
var _positionJs = require("../../../../../common/core/position.js");
var _viewModelJs = require("../../../../../common/viewModel.js");
var _clipboardServiceJs = require("../../../../../../platform/clipboard/common/clipboardService.js");
var _contextViewJs = require("../../../../../../platform/contextview/browser/contextView.js");
var _rangeJs = require("../../../../../common/core/range.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
/**
 * Ensures both editors have the same height by aligning unchanged lines.
 * In inline view mode, inserts viewzones to show deleted code from the original text model in the modified code editor.
 * Synchronizes scrolling.
 *
 * Make sure to add the view zones!
 */ let DiffEditorViewZones = class DiffEditorViewZones extends (0, _lifecycleJs.Disposable) {
    constructor(_targetWindow, _editors, _diffModel, _options, _diffEditorWidget, _canIgnoreViewZoneUpdateEvent, _origViewZonesToIgnore, _modViewZonesToIgnore, _clipboardService, _contextMenuService){
        super();
        this._targetWindow = _targetWindow;
        this._editors = _editors;
        this._diffModel = _diffModel;
        this._options = _options;
        this._diffEditorWidget = _diffEditorWidget;
        this._canIgnoreViewZoneUpdateEvent = _canIgnoreViewZoneUpdateEvent;
        this._origViewZonesToIgnore = _origViewZonesToIgnore;
        this._modViewZonesToIgnore = _modViewZonesToIgnore;
        this._clipboardService = _clipboardService;
        this._contextMenuService = _contextMenuService;
        this._originalTopPadding = (0, _observableJs.observableValue)(this, 0);
        this._originalScrollOffset = (0, _observableJs.observableValue)(this, 0);
        this._originalScrollOffsetAnimated = (0, _utilsJs.animatedObservable)(this._targetWindow, this._originalScrollOffset, this._store);
        this._modifiedTopPadding = (0, _observableJs.observableValue)(this, 0);
        this._modifiedScrollOffset = (0, _observableJs.observableValue)(this, 0);
        this._modifiedScrollOffsetAnimated = (0, _utilsJs.animatedObservable)(this._targetWindow, this._modifiedScrollOffset, this._store);
        const state = (0, _observableJs.observableValue)("invalidateAlignmentsState", 0);
        const updateImmediately = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>{
            state.set(state.get() + 1, undefined);
        }, 0));
        this._register(this._editors.original.onDidChangeViewZones((_args)=>{
            if (!this._canIgnoreViewZoneUpdateEvent()) updateImmediately.schedule();
        }));
        this._register(this._editors.modified.onDidChangeViewZones((_args)=>{
            if (!this._canIgnoreViewZoneUpdateEvent()) updateImmediately.schedule();
        }));
        this._register(this._editors.original.onDidChangeConfiguration((args)=>{
            if (args.hasChanged(147 /* EditorOption.wrappingInfo */ ) || args.hasChanged(67 /* EditorOption.lineHeight */ )) updateImmediately.schedule();
        }));
        this._register(this._editors.modified.onDidChangeConfiguration((args)=>{
            if (args.hasChanged(147 /* EditorOption.wrappingInfo */ ) || args.hasChanged(67 /* EditorOption.lineHeight */ )) updateImmediately.schedule();
        }));
        const originalModelTokenizationCompleted = this._diffModel.map((m)=>m ? (0, _observableJs.observableFromEvent)(this, m.model.original.onDidChangeTokens, ()=>m.model.original.tokenization.backgroundTokenizationState === 2 /* BackgroundTokenizationState.Completed */ ) : undefined).map((m, reader)=>m?.read(reader));
        const alignments = (0, _observableJs.derived)((reader)=>{
            /** @description alignments */ const diffModel = this._diffModel.read(reader);
            const diff = diffModel?.diff.read(reader);
            if (!diffModel || !diff) return null;
            state.read(reader);
            const renderSideBySide = this._options.renderSideBySide.read(reader);
            const innerHunkAlignment = renderSideBySide;
            return computeRangeAlignment(this._editors.original, this._editors.modified, diff.mappings, this._origViewZonesToIgnore, this._modViewZonesToIgnore, innerHunkAlignment);
        });
        const alignmentsSyncedMovedText = (0, _observableJs.derived)((reader)=>{
            /** @description alignmentsSyncedMovedText */ const syncedMovedText = this._diffModel.read(reader)?.movedTextToCompare.read(reader);
            if (!syncedMovedText) return null;
            state.read(reader);
            const mappings = syncedMovedText.changes.map((c)=>new (0, _diffEditorViewModelJs.DiffMapping)(c));
            // TODO dont include alignments outside syncedMovedText
            return computeRangeAlignment(this._editors.original, this._editors.modified, mappings, this._origViewZonesToIgnore, this._modViewZonesToIgnore, true);
        });
        function createFakeLinesDiv() {
            const r = document.createElement("div");
            r.className = "diagonal-fill";
            return r;
        }
        const alignmentViewZonesDisposables = this._register(new (0, _lifecycleJs.DisposableStore)());
        this.viewZones = (0, _observableJs.derivedWithStore)(this, (reader, store)=>{
            alignmentViewZonesDisposables.clear();
            const alignmentsVal = alignments.read(reader) || [];
            const origViewZones = [];
            const modViewZones = [];
            const modifiedTopPaddingVal = this._modifiedTopPadding.read(reader);
            if (modifiedTopPaddingVal > 0) modViewZones.push({
                afterLineNumber: 0,
                domNode: document.createElement("div"),
                heightInPx: modifiedTopPaddingVal,
                showInHiddenAreas: true,
                suppressMouseDown: true
            });
            const originalTopPaddingVal = this._originalTopPadding.read(reader);
            if (originalTopPaddingVal > 0) origViewZones.push({
                afterLineNumber: 0,
                domNode: document.createElement("div"),
                heightInPx: originalTopPaddingVal,
                showInHiddenAreas: true,
                suppressMouseDown: true
            });
            const renderSideBySide = this._options.renderSideBySide.read(reader);
            const deletedCodeLineBreaksComputer = !renderSideBySide ? this._editors.modified._getViewModel()?.createLineBreaksComputer() : undefined;
            if (deletedCodeLineBreaksComputer) {
                const originalModel = this._editors.original.getModel();
                for (const a of alignmentsVal){
                    if (a.diff) for(let i = a.originalRange.startLineNumber; i < a.originalRange.endLineNumberExclusive; i++){
                        // `i` can be out of bound when the diff has not been updated yet.
                        // In this case, we do an early return.
                        // TODO@hediet: Fix this by applying the edit directly to the diff model, so that the diff is always valid.
                        if (i > originalModel.getLineCount()) return {
                            orig: origViewZones,
                            mod: modViewZones
                        };
                        deletedCodeLineBreaksComputer?.addRequest(originalModel.getLineContent(i), null, null);
                    }
                }
            }
            const lineBreakData = deletedCodeLineBreaksComputer?.finalize() ?? [];
            let lineBreakDataIdx = 0;
            const modLineHeight = this._editors.modified.getOption(67 /* EditorOption.lineHeight */ );
            const syncedMovedText = this._diffModel.read(reader)?.movedTextToCompare.read(reader);
            const mightContainNonBasicASCII = this._editors.original.getModel()?.mightContainNonBasicASCII() ?? false;
            const mightContainRTL = this._editors.original.getModel()?.mightContainRTL() ?? false;
            const renderOptions = (0, _renderLinesJs.RenderOptions).fromEditor(this._editors.modified);
            for (const a of alignmentsVal)if (a.diff && !renderSideBySide && (!this._options.useTrueInlineDiffRendering.read(reader) || !allowsTrueInlineDiffRendering(a.diff))) {
                if (!a.originalRange.isEmpty) {
                    originalModelTokenizationCompleted.read(reader); // Update view-zones once tokenization completes
                    const deletedCodeDomNode = document.createElement("div");
                    deletedCodeDomNode.classList.add("view-lines", "line-delete", "monaco-mouse-cursor-text");
                    const originalModel = this._editors.original.getModel();
                    // `a.originalRange` can be out of bound when the diff has not been updated yet.
                    // In this case, we do an early return.
                    // TODO@hediet: Fix this by applying the edit directly to the diff model, so that the diff is always valid.
                    if (a.originalRange.endLineNumberExclusive - 1 > originalModel.getLineCount()) return {
                        orig: origViewZones,
                        mod: modViewZones
                    };
                    const source = new (0, _renderLinesJs.LineSource)(a.originalRange.mapToLineArray((l)=>originalModel.tokenization.getLineTokens(l)), a.originalRange.mapToLineArray((_)=>lineBreakData[lineBreakDataIdx++]), mightContainNonBasicASCII, mightContainRTL);
                    const decorations = [];
                    for (const i of a.diff.innerChanges || [])decorations.push(new (0, _viewModelJs.InlineDecoration)(i.originalRange.delta(-(a.diff.original.startLineNumber - 1)), (0, _registrationsContributionJs.diffDeleteDecoration).className, 0 /* InlineDecorationType.Regular */ ));
                    const result = (0, _renderLinesJs.renderLines)(source, renderOptions, decorations, deletedCodeDomNode);
                    const marginDomNode = document.createElement("div");
                    marginDomNode.className = "inline-deleted-margin-view-zone";
                    (0, _domFontInfoJs.applyFontInfo)(marginDomNode, renderOptions.fontInfo);
                    if (this._options.renderIndicators.read(reader)) for(let i = 0; i < result.heightInLines; i++){
                        const marginElement = document.createElement("div");
                        marginElement.className = `delete-sign ${(0, _themablesJs.ThemeIcon).asClassName((0, _registrationsContributionJs.diffRemoveIcon))}`;
                        marginElement.setAttribute("style", `position:absolute;top:${i * modLineHeight}px;width:${renderOptions.lineDecorationsWidth}px;height:${modLineHeight}px;right:0;`);
                        marginDomNode.appendChild(marginElement);
                    }
                    let zoneId = undefined;
                    alignmentViewZonesDisposables.add(new (0, _inlineDiffDeletedCodeMarginJs.InlineDiffDeletedCodeMargin)(()=>(0, _typesJs.assertIsDefined)(zoneId), marginDomNode, this._editors.modified, a.diff, this._diffEditorWidget, result.viewLineCounts, this._editors.original.getModel(), this._contextMenuService, this._clipboardService));
                    for(let i = 0; i < result.viewLineCounts.length; i++){
                        const count = result.viewLineCounts[i];
                        // Account for wrapped lines in the (collapsed) original editor (which doesn't wrap lines).
                        if (count > 1) origViewZones.push({
                            afterLineNumber: a.originalRange.startLineNumber + i,
                            domNode: createFakeLinesDiv(),
                            heightInPx: (count - 1) * modLineHeight,
                            showInHiddenAreas: true,
                            suppressMouseDown: true
                        });
                    }
                    modViewZones.push({
                        afterLineNumber: a.modifiedRange.startLineNumber - 1,
                        domNode: deletedCodeDomNode,
                        heightInPx: result.heightInLines * modLineHeight,
                        minWidthInPx: result.minWidthInPx,
                        marginDomNode,
                        setZoneId (id) {
                            zoneId = id;
                        },
                        showInHiddenAreas: true,
                        suppressMouseDown: true
                    });
                }
                const marginDomNode = document.createElement("div");
                marginDomNode.className = "gutter-delete";
                origViewZones.push({
                    afterLineNumber: a.originalRange.endLineNumberExclusive - 1,
                    domNode: createFakeLinesDiv(),
                    heightInPx: a.modifiedHeightInPx,
                    marginDomNode,
                    showInHiddenAreas: true,
                    suppressMouseDown: true
                });
            } else {
                const delta = a.modifiedHeightInPx - a.originalHeightInPx;
                if (delta > 0) {
                    if (syncedMovedText?.lineRangeMapping.original.delta(-1).deltaLength(2).contains(a.originalRange.endLineNumberExclusive - 1)) continue;
                    origViewZones.push({
                        afterLineNumber: a.originalRange.endLineNumberExclusive - 1,
                        domNode: createFakeLinesDiv(),
                        heightInPx: delta,
                        showInHiddenAreas: true,
                        suppressMouseDown: true
                    });
                } else {
                    if (syncedMovedText?.lineRangeMapping.modified.delta(-1).deltaLength(2).contains(a.modifiedRange.endLineNumberExclusive - 1)) continue;
                    function createViewZoneMarginArrow() {
                        const arrow = document.createElement("div");
                        arrow.className = "arrow-revert-change " + (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).arrowRight);
                        store.add((0, _domJs.addDisposableListener)(arrow, "mousedown", (e)=>e.stopPropagation()));
                        store.add((0, _domJs.addDisposableListener)(arrow, "click", (e)=>{
                            e.stopPropagation();
                            _diffEditorWidget.revert(a.diff);
                        }));
                        return (0, _domJs.$)("div", {}, arrow);
                    }
                    let marginDomNode = undefined;
                    if (a.diff && a.diff.modified.isEmpty && this._options.shouldRenderOldRevertArrows.read(reader)) marginDomNode = createViewZoneMarginArrow();
                    modViewZones.push({
                        afterLineNumber: a.modifiedRange.endLineNumberExclusive - 1,
                        domNode: createFakeLinesDiv(),
                        heightInPx: -delta,
                        marginDomNode,
                        showInHiddenAreas: true,
                        suppressMouseDown: true
                    });
                }
            }
            for (const a of alignmentsSyncedMovedText.read(reader) ?? []){
                if (!syncedMovedText?.lineRangeMapping.original.intersect(a.originalRange) || !syncedMovedText?.lineRangeMapping.modified.intersect(a.modifiedRange)) continue;
                const delta = a.modifiedHeightInPx - a.originalHeightInPx;
                if (delta > 0) origViewZones.push({
                    afterLineNumber: a.originalRange.endLineNumberExclusive - 1,
                    domNode: createFakeLinesDiv(),
                    heightInPx: delta,
                    showInHiddenAreas: true,
                    suppressMouseDown: true
                });
                else modViewZones.push({
                    afterLineNumber: a.modifiedRange.endLineNumberExclusive - 1,
                    domNode: createFakeLinesDiv(),
                    heightInPx: -delta,
                    showInHiddenAreas: true,
                    suppressMouseDown: true
                });
            }
            return {
                orig: origViewZones,
                mod: modViewZones
            };
        });
        let ignoreChange = false;
        this._register(this._editors.original.onDidScrollChange((e)=>{
            if (e.scrollLeftChanged && !ignoreChange) {
                ignoreChange = true;
                this._editors.modified.setScrollLeft(e.scrollLeft);
                ignoreChange = false;
            }
        }));
        this._register(this._editors.modified.onDidScrollChange((e)=>{
            if (e.scrollLeftChanged && !ignoreChange) {
                ignoreChange = true;
                this._editors.original.setScrollLeft(e.scrollLeft);
                ignoreChange = false;
            }
        }));
        this._originalScrollTop = (0, _observableJs.observableFromEvent)(this._editors.original.onDidScrollChange, ()=>/** @description original.getScrollTop */ this._editors.original.getScrollTop());
        this._modifiedScrollTop = (0, _observableJs.observableFromEvent)(this._editors.modified.onDidScrollChange, ()=>/** @description modified.getScrollTop */ this._editors.modified.getScrollTop());
        // origExtraHeight + origOffset - origScrollTop = modExtraHeight + modOffset - modScrollTop
        // origScrollTop = origExtraHeight + origOffset - modExtraHeight - modOffset + modScrollTop
        // modScrollTop = modExtraHeight + modOffset - origExtraHeight - origOffset + origScrollTop
        // origOffset - modOffset = heightOfLines(1..Y) - heightOfLines(1..X)
        // origScrollTop >= 0, modScrollTop >= 0
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update scroll modified */ const newScrollTopModified = this._originalScrollTop.read(reader) - (this._originalScrollOffsetAnimated.get() - this._modifiedScrollOffsetAnimated.read(reader)) - (this._originalTopPadding.get() - this._modifiedTopPadding.read(reader));
            if (newScrollTopModified !== this._editors.modified.getScrollTop()) this._editors.modified.setScrollTop(newScrollTopModified, 1 /* ScrollType.Immediate */ );
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update scroll original */ const newScrollTopOriginal = this._modifiedScrollTop.read(reader) - (this._modifiedScrollOffsetAnimated.get() - this._originalScrollOffsetAnimated.read(reader)) - (this._modifiedTopPadding.get() - this._originalTopPadding.read(reader));
            if (newScrollTopOriginal !== this._editors.original.getScrollTop()) this._editors.original.setScrollTop(newScrollTopOriginal, 1 /* ScrollType.Immediate */ );
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update editor top offsets */ const m = this._diffModel.read(reader)?.movedTextToCompare.read(reader);
            let deltaOrigToMod = 0;
            if (m) {
                const trueTopOriginal = this._editors.original.getTopForLineNumber(m.lineRangeMapping.original.startLineNumber, true) - this._originalTopPadding.get();
                const trueTopModified = this._editors.modified.getTopForLineNumber(m.lineRangeMapping.modified.startLineNumber, true) - this._modifiedTopPadding.get();
                deltaOrigToMod = trueTopModified - trueTopOriginal;
            }
            if (deltaOrigToMod > 0) {
                this._modifiedTopPadding.set(0, undefined);
                this._originalTopPadding.set(deltaOrigToMod, undefined);
            } else if (deltaOrigToMod < 0) {
                this._modifiedTopPadding.set(-deltaOrigToMod, undefined);
                this._originalTopPadding.set(0, undefined);
            } else setTimeout(()=>{
                this._modifiedTopPadding.set(0, undefined);
                this._originalTopPadding.set(0, undefined);
            }, 400);
            if (this._editors.modified.hasTextFocus()) this._originalScrollOffset.set(this._modifiedScrollOffset.get() - deltaOrigToMod, undefined, true);
            else this._modifiedScrollOffset.set(this._originalScrollOffset.get() + deltaOrigToMod, undefined, true);
        }));
    }
};
DiffEditorViewZones = __decorate([
    __param(8, (0, _clipboardServiceJs.IClipboardService)),
    __param(9, (0, _contextViewJs.IContextMenuService))
], DiffEditorViewZones);
function computeRangeAlignment(originalEditor, modifiedEditor, diffs, originalEditorAlignmentViewZones, modifiedEditorAlignmentViewZones, innerHunkAlignment) {
    const originalLineHeightOverrides = new (0, _arraysJs.ArrayQueue)(getAdditionalLineHeights(originalEditor, originalEditorAlignmentViewZones));
    const modifiedLineHeightOverrides = new (0, _arraysJs.ArrayQueue)(getAdditionalLineHeights(modifiedEditor, modifiedEditorAlignmentViewZones));
    const origLineHeight = originalEditor.getOption(67 /* EditorOption.lineHeight */ );
    const modLineHeight = modifiedEditor.getOption(67 /* EditorOption.lineHeight */ );
    const result = [];
    let lastOriginalLineNumber = 0;
    let lastModifiedLineNumber = 0;
    function handleAlignmentsOutsideOfDiffs(untilOriginalLineNumberExclusive, untilModifiedLineNumberExclusive) {
        while(true){
            let origNext = originalLineHeightOverrides.peek();
            let modNext = modifiedLineHeightOverrides.peek();
            if (origNext && origNext.lineNumber >= untilOriginalLineNumberExclusive) origNext = undefined;
            if (modNext && modNext.lineNumber >= untilModifiedLineNumberExclusive) modNext = undefined;
            if (!origNext && !modNext) break;
            const distOrig = origNext ? origNext.lineNumber - lastOriginalLineNumber : Number.MAX_VALUE;
            const distNext = modNext ? modNext.lineNumber - lastModifiedLineNumber : Number.MAX_VALUE;
            if (distOrig < distNext) {
                originalLineHeightOverrides.dequeue();
                modNext = {
                    lineNumber: origNext.lineNumber - lastOriginalLineNumber + lastModifiedLineNumber,
                    heightInPx: 0
                };
            } else if (distOrig > distNext) {
                modifiedLineHeightOverrides.dequeue();
                origNext = {
                    lineNumber: modNext.lineNumber - lastModifiedLineNumber + lastOriginalLineNumber,
                    heightInPx: 0
                };
            } else {
                originalLineHeightOverrides.dequeue();
                modifiedLineHeightOverrides.dequeue();
            }
            result.push({
                originalRange: (0, _lineRangeJs.LineRange).ofLength(origNext.lineNumber, 1),
                modifiedRange: (0, _lineRangeJs.LineRange).ofLength(modNext.lineNumber, 1),
                originalHeightInPx: origLineHeight + origNext.heightInPx,
                modifiedHeightInPx: modLineHeight + modNext.heightInPx,
                diff: undefined
            });
        }
    }
    for (const m of diffs){
        const c = m.lineRangeMapping;
        handleAlignmentsOutsideOfDiffs(c.original.startLineNumber, c.modified.startLineNumber);
        let first = true;
        let lastModLineNumber = c.modified.startLineNumber;
        let lastOrigLineNumber = c.original.startLineNumber;
        function emitAlignment(origLineNumberExclusive, modLineNumberExclusive, forceAlignment = false) {
            if (origLineNumberExclusive < lastOrigLineNumber || modLineNumberExclusive < lastModLineNumber) return;
            if (first) first = false;
            else if (!forceAlignment && (origLineNumberExclusive === lastOrigLineNumber || modLineNumberExclusive === lastModLineNumber)) // This causes a re-alignment of an already aligned line.
            // However, we don't care for the final alignment.
            return;
            const originalRange = new (0, _lineRangeJs.LineRange)(lastOrigLineNumber, origLineNumberExclusive);
            const modifiedRange = new (0, _lineRangeJs.LineRange)(lastModLineNumber, modLineNumberExclusive);
            if (originalRange.isEmpty && modifiedRange.isEmpty) return;
            const originalAdditionalHeight = originalLineHeightOverrides.takeWhile((v)=>v.lineNumber < origLineNumberExclusive)?.reduce((p, c)=>p + c.heightInPx, 0) ?? 0;
            const modifiedAdditionalHeight = modifiedLineHeightOverrides.takeWhile((v)=>v.lineNumber < modLineNumberExclusive)?.reduce((p, c)=>p + c.heightInPx, 0) ?? 0;
            result.push({
                originalRange,
                modifiedRange,
                originalHeightInPx: originalRange.length * origLineHeight + originalAdditionalHeight,
                modifiedHeightInPx: modifiedRange.length * modLineHeight + modifiedAdditionalHeight,
                diff: m.lineRangeMapping
            });
            lastOrigLineNumber = origLineNumberExclusive;
            lastModLineNumber = modLineNumberExclusive;
        }
        if (innerHunkAlignment) for (const i of c.innerChanges || []){
            if (i.originalRange.startColumn > 1 && i.modifiedRange.startColumn > 1) // There is some unmodified text on this line before the diff
            emitAlignment(i.originalRange.startLineNumber, i.modifiedRange.startLineNumber);
            const originalModel = originalEditor.getModel();
            // When the diff is invalid, the ranges might be out of bounds (this should be fixed in the diff model by applying edits directly).
            const maxColumn = i.originalRange.endLineNumber <= originalModel.getLineCount() ? originalModel.getLineMaxColumn(i.originalRange.endLineNumber) : Number.MAX_SAFE_INTEGER;
            if (i.originalRange.endColumn < maxColumn) // // There is some unmodified text on this line after the diff
            emitAlignment(i.originalRange.endLineNumber, i.modifiedRange.endLineNumber);
        }
        emitAlignment(c.original.endLineNumberExclusive, c.modified.endLineNumberExclusive, true);
        lastOriginalLineNumber = c.original.endLineNumberExclusive;
        lastModifiedLineNumber = c.modified.endLineNumberExclusive;
    }
    handleAlignmentsOutsideOfDiffs(Number.MAX_VALUE, Number.MAX_VALUE);
    return result;
}
function getAdditionalLineHeights(editor, viewZonesToIgnore) {
    const viewZoneHeights = [];
    const wrappingZoneHeights = [];
    const hasWrapping = editor.getOption(147 /* EditorOption.wrappingInfo */ ).wrappingColumn !== -1;
    const coordinatesConverter = editor._getViewModel().coordinatesConverter;
    const editorLineHeight = editor.getOption(67 /* EditorOption.lineHeight */ );
    if (hasWrapping) for(let i = 1; i <= editor.getModel().getLineCount(); i++){
        const lineCount = coordinatesConverter.getModelLineViewLineCount(i);
        if (lineCount > 1) wrappingZoneHeights.push({
            lineNumber: i,
            heightInPx: editorLineHeight * (lineCount - 1)
        });
    }
    for (const w of editor.getWhitespaces()){
        if (viewZonesToIgnore.has(w.id)) continue;
        const modelLineNumber = w.afterLineNumber === 0 ? 0 : coordinatesConverter.convertViewPositionToModelPosition(new (0, _positionJs.Position)(w.afterLineNumber, 1)).lineNumber;
        viewZoneHeights.push({
            lineNumber: modelLineNumber,
            heightInPx: w.height
        });
    }
    const result = (0, _utilsJs.joinCombine)(viewZoneHeights, wrappingZoneHeights, (v)=>v.lineNumber, (v1, v2)=>({
            lineNumber: v1.lineNumber,
            heightInPx: v1.heightInPx + v2.heightInPx
        }));
    return result;
}
function allowsTrueInlineDiffRendering(mapping) {
    if (!mapping.innerChanges) return false;
    return mapping.innerChanges.every((c)=>rangeIsSingleLine(c.modifiedRange) && rangeIsSingleLine(c.originalRange) || c.originalRange.equalsRange(new (0, _rangeJs.Range)(1, 1, 1, 1)));
}
function rangeIsSingleLine(range) {
    return range.startLineNumber === range.endLineNumber;
}

},{"../../../../../../base/browser/dom.js":"bnqsM","../../../../../../base/common/arrays.js":"DECei","../../../../../../base/common/async.js":"4GJc4","../../../../../../base/common/codicons.js":"hWYNf","../../../../../../base/common/lifecycle.js":"9kg8d","../../../../../../base/common/observable.js":"2xbG5","../../../../../../base/common/themables.js":"hgyHi","../../../../../../base/common/types.js":"fb5yx","../../../../config/domFontInfo.js":"fQezv","../../registrations.contribution.js":"3EY0P","../../diffEditorViewModel.js":"61Iqn","./inlineDiffDeletedCodeMargin.js":"8wXXv","./renderLines.js":"hjIDK","../../utils.js":"2G3Lp","../../../../../common/core/lineRange.js":"cmnMs","../../../../../common/core/position.js":"lvrPe","../../../../../common/viewModel.js":"5EHxj","../../../../../../platform/clipboard/common/clipboardService.js":"4IsFp","../../../../../../platform/contextview/browser/contextView.js":"2QlUR","../../../../../common/core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3EY0P":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "diffMoveBorder", ()=>diffMoveBorder);
parcelHelpers.export(exports, "diffMoveBorderActive", ()=>diffMoveBorderActive);
parcelHelpers.export(exports, "diffEditorUnchangedRegionShadow", ()=>diffEditorUnchangedRegionShadow);
parcelHelpers.export(exports, "diffInsertIcon", ()=>diffInsertIcon);
parcelHelpers.export(exports, "diffRemoveIcon", ()=>diffRemoveIcon);
parcelHelpers.export(exports, "diffLineAddDecorationBackgroundWithIndicator", ()=>diffLineAddDecorationBackgroundWithIndicator);
parcelHelpers.export(exports, "diffLineDeleteDecorationBackgroundWithIndicator", ()=>diffLineDeleteDecorationBackgroundWithIndicator);
parcelHelpers.export(exports, "diffLineAddDecorationBackground", ()=>diffLineAddDecorationBackground);
parcelHelpers.export(exports, "diffLineDeleteDecorationBackground", ()=>diffLineDeleteDecorationBackground);
parcelHelpers.export(exports, "diffAddDecoration", ()=>diffAddDecoration);
parcelHelpers.export(exports, "diffWholeLineAddDecoration", ()=>diffWholeLineAddDecoration);
parcelHelpers.export(exports, "diffAddDecorationEmpty", ()=>diffAddDecorationEmpty);
parcelHelpers.export(exports, "diffDeleteDecoration", ()=>diffDeleteDecoration);
parcelHelpers.export(exports, "diffWholeLineDeleteDecoration", ()=>diffWholeLineDeleteDecoration);
parcelHelpers.export(exports, "diffDeleteDecorationEmpty", ()=>diffDeleteDecorationEmpty);
var _codiconsJs = require("../../../../base/common/codicons.js");
var _themablesJs = require("../../../../base/common/themables.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _nlsJs = require("../../../../nls.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _iconRegistryJs = require("../../../../platform/theme/common/iconRegistry.js");
const diffMoveBorder = (0, _colorRegistryJs.registerColor)("diffEditor.move.border", "#8b8b8b9c", (0, _nlsJs.localize)("diffEditor.move.border", "The border color for text that got moved in the diff editor."));
const diffMoveBorderActive = (0, _colorRegistryJs.registerColor)("diffEditor.moveActive.border", "#FFA500", (0, _nlsJs.localize)("diffEditor.moveActive.border", "The active border color for text that got moved in the diff editor."));
const diffEditorUnchangedRegionShadow = (0, _colorRegistryJs.registerColor)("diffEditor.unchangedRegionShadow", {
    dark: "#000000",
    light: "#737373BF",
    hcDark: "#000000",
    hcLight: "#737373BF"
}, (0, _nlsJs.localize)("diffEditor.unchangedRegionShadow", "The color of the shadow around unchanged region widgets."));
const diffInsertIcon = (0, _iconRegistryJs.registerIcon)("diff-insert", (0, _codiconsJs.Codicon).add, (0, _nlsJs.localize)("diffInsertIcon", "Line decoration for inserts in the diff editor."));
const diffRemoveIcon = (0, _iconRegistryJs.registerIcon)("diff-remove", (0, _codiconsJs.Codicon).remove, (0, _nlsJs.localize)("diffRemoveIcon", "Line decoration for removals in the diff editor."));
const diffLineAddDecorationBackgroundWithIndicator = (0, _textModelJs.ModelDecorationOptions).register({
    className: "line-insert",
    description: "line-insert",
    isWholeLine: true,
    linesDecorationsClassName: "insert-sign " + (0, _themablesJs.ThemeIcon).asClassName(diffInsertIcon),
    marginClassName: "gutter-insert"
});
const diffLineDeleteDecorationBackgroundWithIndicator = (0, _textModelJs.ModelDecorationOptions).register({
    className: "line-delete",
    description: "line-delete",
    isWholeLine: true,
    linesDecorationsClassName: "delete-sign " + (0, _themablesJs.ThemeIcon).asClassName(diffRemoveIcon),
    marginClassName: "gutter-delete"
});
const diffLineAddDecorationBackground = (0, _textModelJs.ModelDecorationOptions).register({
    className: "line-insert",
    description: "line-insert",
    isWholeLine: true,
    marginClassName: "gutter-insert"
});
const diffLineDeleteDecorationBackground = (0, _textModelJs.ModelDecorationOptions).register({
    className: "line-delete",
    description: "line-delete",
    isWholeLine: true,
    marginClassName: "gutter-delete"
});
const diffAddDecoration = (0, _textModelJs.ModelDecorationOptions).register({
    className: "char-insert",
    description: "char-insert",
    shouldFillLineOnLineBreak: true
});
const diffWholeLineAddDecoration = (0, _textModelJs.ModelDecorationOptions).register({
    className: "char-insert",
    description: "char-insert",
    isWholeLine: true
});
const diffAddDecorationEmpty = (0, _textModelJs.ModelDecorationOptions).register({
    className: "char-insert diff-range-empty",
    description: "char-insert diff-range-empty"
});
const diffDeleteDecoration = (0, _textModelJs.ModelDecorationOptions).register({
    className: "char-delete",
    description: "char-delete",
    shouldFillLineOnLineBreak: true
});
const diffWholeLineDeleteDecoration = (0, _textModelJs.ModelDecorationOptions).register({
    className: "char-delete",
    description: "char-delete",
    isWholeLine: true
});
const diffDeleteDecorationEmpty = (0, _textModelJs.ModelDecorationOptions).register({
    className: "char-delete diff-range-empty",
    description: "char-delete diff-range-empty"
});

},{"../../../../base/common/codicons.js":"hWYNf","../../../../base/common/themables.js":"hgyHi","../../../common/model/textModel.js":"9beDe","../../../../nls.js":"l617d","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/iconRegistry.js":"bRNEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"61Iqn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiffEditorViewModel", ()=>DiffEditorViewModel);
parcelHelpers.export(exports, "DiffState", ()=>DiffState);
parcelHelpers.export(exports, "DiffMapping", ()=>DiffMapping);
parcelHelpers.export(exports, "UnchangedRegion", ()=>UnchangedRegion);
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _diffProviderFactoryServiceJs = require("./diffProviderFactoryService.js");
var _utilsJs = require("./utils.js");
var _hotReloadHelpersJs = require("../../../../base/common/hotReloadHelpers.js");
var _lineRangeJs = require("../../../common/core/lineRange.js");
var _defaultLinesDiffComputerJs = require("../../../common/diff/defaultLinesDiffComputer/defaultLinesDiffComputer.js");
var _rangeMappingJs = require("../../../common/diff/rangeMapping.js");
var _beforeEditPositionMapperJs = require("../../../common/model/bracketPairsTextModelPart/bracketPairsTree/beforeEditPositionMapper.js");
var _combineTextEditInfosJs = require("../../../common/model/bracketPairsTextModelPart/bracketPairsTree/combineTextEditInfos.js");
var _heuristicSequenceOptimizationsJs = require("../../../common/diff/defaultLinesDiffComputer/heuristicSequenceOptimizations.js");
var _typesJs = require("../../../../base/common/types.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _assertJs = require("../../../../base/common/assert.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let DiffEditorViewModel = class DiffEditorViewModel extends (0, _lifecycleJs.Disposable) {
    setActiveMovedText(movedText) {
        this._activeMovedText.set(movedText, undefined);
    }
    constructor(model, _options, _diffProviderFactoryService){
        super();
        this.model = model;
        this._options = _options;
        this._diffProviderFactoryService = _diffProviderFactoryService;
        this._isDiffUpToDate = (0, _observableJs.observableValue)(this, false);
        this.isDiffUpToDate = this._isDiffUpToDate;
        this._diff = (0, _observableJs.observableValue)(this, undefined);
        this.diff = this._diff;
        this._unchangedRegions = (0, _observableJs.observableValue)(this, undefined);
        this.unchangedRegions = (0, _observableJs.derived)(this, (r)=>{
            if (this._options.hideUnchangedRegions.read(r)) return this._unchangedRegions.read(r)?.regions ?? [];
            else {
                // Reset state
                (0, _observableJs.transaction)((tx)=>{
                    for (const r of this._unchangedRegions.get()?.regions || [])r.collapseAll(tx);
                });
                return [];
            }
        });
        this.movedTextToCompare = (0, _observableJs.observableValue)(this, undefined);
        this._activeMovedText = (0, _observableJs.observableValue)(this, undefined);
        this._hoveredMovedText = (0, _observableJs.observableValue)(this, undefined);
        this.activeMovedText = (0, _observableJs.derived)(this, (r)=>this.movedTextToCompare.read(r) ?? this._hoveredMovedText.read(r) ?? this._activeMovedText.read(r));
        this._cancellationTokenSource = new (0, _cancellationJs.CancellationTokenSource)();
        this._diffProvider = (0, _observableJs.derived)(this, (reader)=>{
            const diffProvider = this._diffProviderFactoryService.createDiffProvider({
                diffAlgorithm: this._options.diffAlgorithm.read(reader)
            });
            const onChangeSignal = (0, _observableJs.observableSignalFromEvent)("onDidChange", diffProvider.onDidChange);
            return {
                diffProvider,
                onChangeSignal
            };
        });
        this._register((0, _lifecycleJs.toDisposable)(()=>this._cancellationTokenSource.cancel()));
        const contentChangedSignal = (0, _observableJs.observableSignal)("contentChangedSignal");
        const debouncer = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>contentChangedSignal.trigger(undefined), 200));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description collapse touching unchanged ranges */ const lastUnchangedRegions = this._unchangedRegions.read(reader);
            if (!lastUnchangedRegions || lastUnchangedRegions.regions.some((r)=>r.isDragged.read(reader))) return;
            const lastUnchangedRegionsOrigRanges = lastUnchangedRegions.originalDecorationIds.map((id)=>model.original.getDecorationRange(id)).map((r)=>r ? (0, _lineRangeJs.LineRange).fromRangeInclusive(r) : undefined);
            const lastUnchangedRegionsModRanges = lastUnchangedRegions.modifiedDecorationIds.map((id)=>model.modified.getDecorationRange(id)).map((r)=>r ? (0, _lineRangeJs.LineRange).fromRangeInclusive(r) : undefined);
            const updatedLastUnchangedRegions = lastUnchangedRegions.regions.map((r, idx)=>!lastUnchangedRegionsOrigRanges[idx] || !lastUnchangedRegionsModRanges[idx] ? undefined : new UnchangedRegion(lastUnchangedRegionsOrigRanges[idx].startLineNumber, lastUnchangedRegionsModRanges[idx].startLineNumber, lastUnchangedRegionsOrigRanges[idx].length, r.visibleLineCountTop.read(reader), r.visibleLineCountBottom.read(reader))).filter((0, _typesJs.isDefined));
            const newRanges = [];
            let didChange = false;
            for (const touching of (0, _arraysJs.groupAdjacentBy)(updatedLastUnchangedRegions, (a, b)=>a.getHiddenModifiedRange(reader).endLineNumberExclusive === b.getHiddenModifiedRange(reader).startLineNumber))if (touching.length > 1) {
                didChange = true;
                const sumLineCount = touching.reduce((sum, r)=>sum + r.lineCount, 0);
                const r = new UnchangedRegion(touching[0].originalLineNumber, touching[0].modifiedLineNumber, sumLineCount, touching[0].visibleLineCountTop.get(), touching[touching.length - 1].visibleLineCountBottom.get());
                newRanges.push(r);
            } else newRanges.push(touching[0]);
            if (didChange) {
                const originalDecorationIds = model.original.deltaDecorations(lastUnchangedRegions.originalDecorationIds, newRanges.map((r)=>({
                        range: r.originalUnchangedRange.toInclusiveRange(),
                        options: {
                            description: "unchanged"
                        }
                    })));
                const modifiedDecorationIds = model.modified.deltaDecorations(lastUnchangedRegions.modifiedDecorationIds, newRanges.map((r)=>({
                        range: r.modifiedUnchangedRange.toInclusiveRange(),
                        options: {
                            description: "unchanged"
                        }
                    })));
                (0, _observableJs.transaction)((tx)=>{
                    this._unchangedRegions.set({
                        regions: newRanges,
                        originalDecorationIds,
                        modifiedDecorationIds
                    }, tx);
                });
            }
        }));
        const updateUnchangedRegions = (result, tx, reader)=>{
            const newUnchangedRegions = UnchangedRegion.fromDiffs(result.changes, model.original.getLineCount(), model.modified.getLineCount(), this._options.hideUnchangedRegionsMinimumLineCount.read(reader), this._options.hideUnchangedRegionsContextLineCount.read(reader));
            // Transfer state from cur state
            let visibleRegions = undefined;
            const lastUnchangedRegions = this._unchangedRegions.get();
            if (lastUnchangedRegions) {
                const lastUnchangedRegionsOrigRanges = lastUnchangedRegions.originalDecorationIds.map((id)=>model.original.getDecorationRange(id)).map((r)=>r ? (0, _lineRangeJs.LineRange).fromRangeInclusive(r) : undefined);
                const lastUnchangedRegionsModRanges = lastUnchangedRegions.modifiedDecorationIds.map((id)=>model.modified.getDecorationRange(id)).map((r)=>r ? (0, _lineRangeJs.LineRange).fromRangeInclusive(r) : undefined);
                const updatedLastUnchangedRegions = (0, _utilsJs.filterWithPrevious)(lastUnchangedRegions.regions.map((r, idx)=>{
                    if (!lastUnchangedRegionsOrigRanges[idx] || !lastUnchangedRegionsModRanges[idx]) return undefined;
                    const length = lastUnchangedRegionsOrigRanges[idx].length;
                    return new UnchangedRegion(lastUnchangedRegionsOrigRanges[idx].startLineNumber, lastUnchangedRegionsModRanges[idx].startLineNumber, length, // The visible area can shrink by edits -> we have to account for this
                    Math.min(r.visibleLineCountTop.get(), length), Math.min(r.visibleLineCountBottom.get(), length - r.visibleLineCountTop.get()));
                }).filter((0, _typesJs.isDefined)), (cur, prev)=>!prev || cur.modifiedLineNumber >= prev.modifiedLineNumber + prev.lineCount && cur.originalLineNumber >= prev.originalLineNumber + prev.lineCount);
                let hiddenRegions = updatedLastUnchangedRegions.map((r)=>new (0, _rangeMappingJs.LineRangeMapping)(r.getHiddenOriginalRange(reader), r.getHiddenModifiedRange(reader)));
                hiddenRegions = (0, _rangeMappingJs.LineRangeMapping).clip(hiddenRegions, (0, _lineRangeJs.LineRange).ofLength(1, model.original.getLineCount()), (0, _lineRangeJs.LineRange).ofLength(1, model.modified.getLineCount()));
                visibleRegions = (0, _rangeMappingJs.LineRangeMapping).inverse(hiddenRegions, model.original.getLineCount(), model.modified.getLineCount());
            }
            const newUnchangedRegions2 = [];
            if (visibleRegions) for (const r of newUnchangedRegions){
                const intersecting = visibleRegions.filter((f)=>f.original.intersectsStrict(r.originalUnchangedRange) && f.modified.intersectsStrict(r.modifiedUnchangedRange));
                newUnchangedRegions2.push(...r.setVisibleRanges(intersecting, tx));
            }
            else newUnchangedRegions2.push(...newUnchangedRegions);
            const originalDecorationIds = model.original.deltaDecorations(lastUnchangedRegions?.originalDecorationIds || [], newUnchangedRegions2.map((r)=>({
                    range: r.originalUnchangedRange.toInclusiveRange(),
                    options: {
                        description: "unchanged"
                    }
                })));
            const modifiedDecorationIds = model.modified.deltaDecorations(lastUnchangedRegions?.modifiedDecorationIds || [], newUnchangedRegions2.map((r)=>({
                    range: r.modifiedUnchangedRange.toInclusiveRange(),
                    options: {
                        description: "unchanged"
                    }
                })));
            this._unchangedRegions.set({
                regions: newUnchangedRegions2,
                originalDecorationIds,
                modifiedDecorationIds
            }, tx);
        };
        this._register(model.modified.onDidChangeContent((e)=>{
            const diff = this._diff.get();
            if (diff) {
                const textEdits = (0, _beforeEditPositionMapperJs.TextEditInfo).fromModelContentChanges(e.changes);
                const result = applyModifiedEdits(this._lastDiff, textEdits, model.original, model.modified);
                if (result) {
                    this._lastDiff = result;
                    (0, _observableJs.transaction)((tx)=>{
                        this._diff.set(DiffState.fromDiffResult(this._lastDiff), tx);
                        updateUnchangedRegions(result, tx);
                        const currentSyncedMovedText = this.movedTextToCompare.get();
                        this.movedTextToCompare.set(currentSyncedMovedText ? this._lastDiff.moves.find((m)=>m.lineRangeMapping.modified.intersect(currentSyncedMovedText.lineRangeMapping.modified)) : undefined, tx);
                    });
                }
            }
            this._isDiffUpToDate.set(false, undefined);
            debouncer.schedule();
        }));
        this._register(model.original.onDidChangeContent((e)=>{
            const diff = this._diff.get();
            if (diff) {
                const textEdits = (0, _beforeEditPositionMapperJs.TextEditInfo).fromModelContentChanges(e.changes);
                const result = applyOriginalEdits(this._lastDiff, textEdits, model.original, model.modified);
                if (result) {
                    this._lastDiff = result;
                    (0, _observableJs.transaction)((tx)=>{
                        this._diff.set(DiffState.fromDiffResult(this._lastDiff), tx);
                        updateUnchangedRegions(result, tx);
                        const currentSyncedMovedText = this.movedTextToCompare.get();
                        this.movedTextToCompare.set(currentSyncedMovedText ? this._lastDiff.moves.find((m)=>m.lineRangeMapping.modified.intersect(currentSyncedMovedText.lineRangeMapping.modified)) : undefined, tx);
                    });
                }
            }
            this._isDiffUpToDate.set(false, undefined);
            debouncer.schedule();
        }));
        this._register((0, _observableJs.autorunWithStore)(async (reader, store)=>{
            /** @description compute diff */ // So that they get recomputed when these settings change
            this._options.hideUnchangedRegionsMinimumLineCount.read(reader);
            this._options.hideUnchangedRegionsContextLineCount.read(reader);
            debouncer.cancel();
            contentChangedSignal.read(reader);
            const documentDiffProvider = this._diffProvider.read(reader);
            documentDiffProvider.onChangeSignal.read(reader);
            (0, _hotReloadHelpersJs.readHotReloadableExport)((0, _defaultLinesDiffComputerJs.DefaultLinesDiffComputer), reader);
            (0, _hotReloadHelpersJs.readHotReloadableExport)((0, _heuristicSequenceOptimizationsJs.optimizeSequenceDiffs), reader);
            this._isDiffUpToDate.set(false, undefined);
            let originalTextEditInfos = [];
            store.add(model.original.onDidChangeContent((e)=>{
                const edits = (0, _beforeEditPositionMapperJs.TextEditInfo).fromModelContentChanges(e.changes);
                originalTextEditInfos = (0, _combineTextEditInfosJs.combineTextEditInfos)(originalTextEditInfos, edits);
            }));
            let modifiedTextEditInfos = [];
            store.add(model.modified.onDidChangeContent((e)=>{
                const edits = (0, _beforeEditPositionMapperJs.TextEditInfo).fromModelContentChanges(e.changes);
                modifiedTextEditInfos = (0, _combineTextEditInfosJs.combineTextEditInfos)(modifiedTextEditInfos, edits);
            }));
            let result = await documentDiffProvider.diffProvider.computeDiff(model.original, model.modified, {
                ignoreTrimWhitespace: this._options.ignoreTrimWhitespace.read(reader),
                maxComputationTimeMs: this._options.maxComputationTimeMs.read(reader),
                computeMoves: this._options.showMoves.read(reader)
            }, this._cancellationTokenSource.token);
            if (this._cancellationTokenSource.token.isCancellationRequested) return;
            if (model.original.isDisposed() || model.modified.isDisposed()) // TODO@hediet fishy?
            return;
            result = normalizeDocumentDiff(result, model.original, model.modified);
            result = applyOriginalEdits(result, originalTextEditInfos, model.original, model.modified) ?? result;
            result = applyModifiedEdits(result, modifiedTextEditInfos, model.original, model.modified) ?? result;
            (0, _observableJs.transaction)((tx)=>{
                /** @description write diff result */ updateUnchangedRegions(result, tx);
                this._lastDiff = result;
                const state = DiffState.fromDiffResult(result);
                this._diff.set(state, tx);
                this._isDiffUpToDate.set(true, tx);
                const currentSyncedMovedText = this.movedTextToCompare.get();
                this.movedTextToCompare.set(currentSyncedMovedText ? this._lastDiff.moves.find((m)=>m.lineRangeMapping.modified.intersect(currentSyncedMovedText.lineRangeMapping.modified)) : undefined, tx);
            });
        }));
    }
    ensureModifiedLineIsVisible(lineNumber, preference, tx) {
        if (this.diff.get()?.mappings.length === 0) return;
        const unchangedRegions = this._unchangedRegions.get()?.regions || [];
        for (const r of unchangedRegions)if (r.getHiddenModifiedRange(undefined).contains(lineNumber)) {
            r.showModifiedLine(lineNumber, preference, tx);
            return;
        }
    }
    ensureOriginalLineIsVisible(lineNumber, preference, tx) {
        if (this.diff.get()?.mappings.length === 0) return;
        const unchangedRegions = this._unchangedRegions.get()?.regions || [];
        for (const r of unchangedRegions)if (r.getHiddenOriginalRange(undefined).contains(lineNumber)) {
            r.showOriginalLine(lineNumber, preference, tx);
            return;
        }
    }
    async waitForDiff() {
        await (0, _observableJs.waitForState)(this.isDiffUpToDate, (s)=>s);
    }
    serializeState() {
        const regions = this._unchangedRegions.get();
        return {
            collapsedRegions: regions?.regions.map((r)=>({
                    range: r.getHiddenModifiedRange(undefined).serialize()
                }))
        };
    }
    restoreSerializedState(state) {
        const ranges = state.collapsedRegions?.map((r)=>(0, _lineRangeJs.LineRange).deserialize(r.range));
        const regions = this._unchangedRegions.get();
        if (!regions || !ranges) return;
        (0, _observableJs.transaction)((tx)=>{
            for (const r of regions.regions){
                for (const range of ranges)if (r.modifiedUnchangedRange.intersect(range)) {
                    r.setHiddenModifiedRange(range, tx);
                    break;
                }
            }
        });
    }
};
DiffEditorViewModel = __decorate([
    __param(2, (0, _diffProviderFactoryServiceJs.IDiffProviderFactoryService))
], DiffEditorViewModel);
function normalizeDocumentDiff(diff, original, modified) {
    return {
        changes: diff.changes.map((c)=>new (0, _rangeMappingJs.DetailedLineRangeMapping)(c.original, c.modified, c.innerChanges ? c.innerChanges.map((i)=>normalizeRangeMapping(i, original, modified)) : undefined)),
        moves: diff.moves,
        identical: diff.identical,
        quitEarly: diff.quitEarly
    };
}
function normalizeRangeMapping(rangeMapping, original, modified) {
    let originalRange = rangeMapping.originalRange;
    let modifiedRange = rangeMapping.modifiedRange;
    if (originalRange.startColumn === 1 && modifiedRange.startColumn === 1 && (originalRange.endColumn !== 1 || modifiedRange.endColumn !== 1) && originalRange.endColumn === original.getLineMaxColumn(originalRange.endLineNumber) && modifiedRange.endColumn === modified.getLineMaxColumn(modifiedRange.endLineNumber) && originalRange.endLineNumber < original.getLineCount() && modifiedRange.endLineNumber < modified.getLineCount()) {
        originalRange = originalRange.setEndPosition(originalRange.endLineNumber + 1, 1);
        modifiedRange = modifiedRange.setEndPosition(modifiedRange.endLineNumber + 1, 1);
    }
    return new (0, _rangeMappingJs.RangeMapping)(originalRange, modifiedRange);
}
class DiffState {
    static fromDiffResult(result) {
        return new DiffState(result.changes.map((c)=>new DiffMapping(c)), result.moves || [], result.identical, result.quitEarly);
    }
    constructor(mappings, movedTexts, identical, quitEarly){
        this.mappings = mappings;
        this.movedTexts = movedTexts;
        this.identical = identical;
        this.quitEarly = quitEarly;
    }
}
class DiffMapping {
    constructor(lineRangeMapping){
        this.lineRangeMapping = lineRangeMapping;
    /*
        readonly movedTo: MovedText | undefined,
        readonly movedFrom: MovedText | undefined,

        if (movedTo) {
            assertFn(() =>
                movedTo.lineRangeMapping.modifiedRange.equals(lineRangeMapping.modifiedRange)
                && lineRangeMapping.originalRange.isEmpty
                && !movedFrom
            );
        } else if (movedFrom) {
            assertFn(() =>
                movedFrom.lineRangeMapping.originalRange.equals(lineRangeMapping.originalRange)
                && lineRangeMapping.modifiedRange.isEmpty
                && !movedTo
            );
        }
        */ }
}
class UnchangedRegion {
    static fromDiffs(changes, originalLineCount, modifiedLineCount, minHiddenLineCount, minContext) {
        const inversedMappings = (0, _rangeMappingJs.DetailedLineRangeMapping).inverse(changes, originalLineCount, modifiedLineCount);
        const result = [];
        for (const mapping of inversedMappings){
            let origStart = mapping.original.startLineNumber;
            let modStart = mapping.modified.startLineNumber;
            let length = mapping.original.length;
            const atStart = origStart === 1 && modStart === 1;
            const atEnd = origStart + length === originalLineCount + 1 && modStart + length === modifiedLineCount + 1;
            if ((atStart || atEnd) && length >= minContext + minHiddenLineCount) {
                if (atStart && !atEnd) length -= minContext;
                if (atEnd && !atStart) {
                    origStart += minContext;
                    modStart += minContext;
                    length -= minContext;
                }
                result.push(new UnchangedRegion(origStart, modStart, length, 0, 0));
            } else if (length >= minContext * 2 + minHiddenLineCount) {
                origStart += minContext;
                modStart += minContext;
                length -= minContext * 2;
                result.push(new UnchangedRegion(origStart, modStart, length, 0, 0));
            }
        }
        return result;
    }
    get originalUnchangedRange() {
        return (0, _lineRangeJs.LineRange).ofLength(this.originalLineNumber, this.lineCount);
    }
    get modifiedUnchangedRange() {
        return (0, _lineRangeJs.LineRange).ofLength(this.modifiedLineNumber, this.lineCount);
    }
    constructor(originalLineNumber, modifiedLineNumber, lineCount, visibleLineCountTop, visibleLineCountBottom){
        this.originalLineNumber = originalLineNumber;
        this.modifiedLineNumber = modifiedLineNumber;
        this.lineCount = lineCount;
        this._visibleLineCountTop = (0, _observableJs.observableValue)(this, 0);
        this.visibleLineCountTop = this._visibleLineCountTop;
        this._visibleLineCountBottom = (0, _observableJs.observableValue)(this, 0);
        this.visibleLineCountBottom = this._visibleLineCountBottom;
        this._shouldHideControls = (0, _observableJs.derived)(this, (reader)=>/** @description isVisible */ this.visibleLineCountTop.read(reader) + this.visibleLineCountBottom.read(reader) === this.lineCount && !this.isDragged.read(reader));
        this.isDragged = (0, _observableJs.observableValue)(this, undefined);
        const visibleLineCountTop2 = Math.max(Math.min(visibleLineCountTop, this.lineCount), 0);
        const visibleLineCountBottom2 = Math.max(Math.min(visibleLineCountBottom, this.lineCount - visibleLineCountTop), 0);
        (0, _assertJs.softAssert)(visibleLineCountTop === visibleLineCountTop2);
        (0, _assertJs.softAssert)(visibleLineCountBottom === visibleLineCountBottom2);
        this._visibleLineCountTop.set(visibleLineCountTop2, undefined);
        this._visibleLineCountBottom.set(visibleLineCountBottom2, undefined);
    }
    setVisibleRanges(visibleRanges, tx) {
        const result = [];
        const hiddenModified = new (0, _lineRangeJs.LineRangeSet)(visibleRanges.map((r)=>r.modified)).subtractFrom(this.modifiedUnchangedRange);
        let originalStartLineNumber = this.originalLineNumber;
        let modifiedStartLineNumber = this.modifiedLineNumber;
        const modifiedEndLineNumberEx = this.modifiedLineNumber + this.lineCount;
        if (hiddenModified.ranges.length === 0) {
            this.showAll(tx);
            result.push(this);
        } else {
            let i = 0;
            for (const r of hiddenModified.ranges){
                const isLast = i === hiddenModified.ranges.length - 1;
                i++;
                const length = (isLast ? modifiedEndLineNumberEx : r.endLineNumberExclusive) - modifiedStartLineNumber;
                const newR = new UnchangedRegion(originalStartLineNumber, modifiedStartLineNumber, length, 0, 0);
                newR.setHiddenModifiedRange(r, tx);
                result.push(newR);
                originalStartLineNumber = newR.originalUnchangedRange.endLineNumberExclusive;
                modifiedStartLineNumber = newR.modifiedUnchangedRange.endLineNumberExclusive;
            }
        }
        return result;
    }
    shouldHideControls(reader) {
        return this._shouldHideControls.read(reader);
    }
    getHiddenOriginalRange(reader) {
        return (0, _lineRangeJs.LineRange).ofLength(this.originalLineNumber + this._visibleLineCountTop.read(reader), this.lineCount - this._visibleLineCountTop.read(reader) - this._visibleLineCountBottom.read(reader));
    }
    getHiddenModifiedRange(reader) {
        return (0, _lineRangeJs.LineRange).ofLength(this.modifiedLineNumber + this._visibleLineCountTop.read(reader), this.lineCount - this._visibleLineCountTop.read(reader) - this._visibleLineCountBottom.read(reader));
    }
    setHiddenModifiedRange(range, tx) {
        const visibleLineCountTop = range.startLineNumber - this.modifiedLineNumber;
        const visibleLineCountBottom = this.modifiedLineNumber + this.lineCount - range.endLineNumberExclusive;
        this.setState(visibleLineCountTop, visibleLineCountBottom, tx);
    }
    getMaxVisibleLineCountTop() {
        return this.lineCount - this._visibleLineCountBottom.get();
    }
    getMaxVisibleLineCountBottom() {
        return this.lineCount - this._visibleLineCountTop.get();
    }
    showMoreAbove(count = 10, tx) {
        const maxVisibleLineCountTop = this.getMaxVisibleLineCountTop();
        this._visibleLineCountTop.set(Math.min(this._visibleLineCountTop.get() + count, maxVisibleLineCountTop), tx);
    }
    showMoreBelow(count = 10, tx) {
        const maxVisibleLineCountBottom = this.lineCount - this._visibleLineCountTop.get();
        this._visibleLineCountBottom.set(Math.min(this._visibleLineCountBottom.get() + count, maxVisibleLineCountBottom), tx);
    }
    showAll(tx) {
        this._visibleLineCountBottom.set(this.lineCount - this._visibleLineCountTop.get(), tx);
    }
    showModifiedLine(lineNumber, preference, tx) {
        const top = lineNumber + 1 - (this.modifiedLineNumber + this._visibleLineCountTop.get());
        const bottom = this.modifiedLineNumber - this._visibleLineCountBottom.get() + this.lineCount - lineNumber;
        if (preference === 0 /* RevealPreference.FromCloserSide */  && top < bottom || preference === 1 /* RevealPreference.FromTop */ ) this._visibleLineCountTop.set(this._visibleLineCountTop.get() + top, tx);
        else this._visibleLineCountBottom.set(this._visibleLineCountBottom.get() + bottom, tx);
    }
    showOriginalLine(lineNumber, preference, tx) {
        const top = lineNumber - this.originalLineNumber;
        const bottom = this.originalLineNumber + this.lineCount - lineNumber;
        if (preference === 0 /* RevealPreference.FromCloserSide */  && top < bottom || preference === 1 /* RevealPreference.FromTop */ ) this._visibleLineCountTop.set(Math.min(this._visibleLineCountTop.get() + bottom - top, this.getMaxVisibleLineCountTop()), tx);
        else this._visibleLineCountBottom.set(Math.min(this._visibleLineCountBottom.get() + top - bottom, this.getMaxVisibleLineCountBottom()), tx);
    }
    collapseAll(tx) {
        this._visibleLineCountTop.set(0, tx);
        this._visibleLineCountBottom.set(0, tx);
    }
    setState(visibleLineCountTop, visibleLineCountBottom, tx) {
        visibleLineCountTop = Math.max(Math.min(visibleLineCountTop, this.lineCount), 0);
        visibleLineCountBottom = Math.max(Math.min(visibleLineCountBottom, this.lineCount - visibleLineCountTop), 0);
        this._visibleLineCountTop.set(visibleLineCountTop, tx);
        this._visibleLineCountBottom.set(visibleLineCountBottom, tx);
    }
}
function applyOriginalEdits(diff, textEdits, originalTextModel, modifiedTextModel) {
    return undefined;
/*
    TODO@hediet
    if (textEdits.length === 0) {
        return diff;
    }

    const diff2 = flip(diff);
    const diff3 = applyModifiedEdits(diff2, textEdits, modifiedTextModel, originalTextModel);
    if (!diff3) {
        return undefined;
    }
    return flip(diff3);*/ }
/*
function flip(diff: IDocumentDiff): IDocumentDiff {
    return {
        changes: diff.changes.map(c => c.flip()),
        moves: diff.moves.map(m => m.flip()),
        identical: diff.identical,
        quitEarly: diff.quitEarly,
    };
}
*/ function applyModifiedEdits(diff, textEdits, originalTextModel, modifiedTextModel) {
    return undefined;
/*
    TODO@hediet
    if (textEdits.length === 0) {
        return diff;
    }
    if (diff.changes.some(c => !c.innerChanges) || diff.moves.length > 0) {
        // TODO support these cases
        return undefined;
    }

    const changes = applyModifiedEditsToLineRangeMappings(diff.changes, textEdits, originalTextModel, modifiedTextModel);

    const moves = diff.moves.map(m => {
        const newModifiedRange = applyEditToLineRange(m.lineRangeMapping.modified, textEdits);
        return newModifiedRange ? new MovedText(
            new SimpleLineRangeMapping(m.lineRangeMapping.original, newModifiedRange),
            applyModifiedEditsToLineRangeMappings(m.changes, textEdits, originalTextModel, modifiedTextModel),
        ) : undefined;
    }).filter(isDefined);

    return {
        identical: false,
        quitEarly: false,
        changes,
        moves,
    };*/ } /*
function applyEditToLineRange(range: LineRange, textEdits: TextEditInfo[]): LineRange | undefined {
    let rangeStartLineNumber = range.startLineNumber;
    let rangeEndLineNumberEx = range.endLineNumberExclusive;

    for (let i = textEdits.length - 1; i >= 0; i--) {
        const textEdit = textEdits[i];
        const textEditStartLineNumber = lengthGetLineCount(textEdit.startOffset) + 1;
        const textEditEndLineNumber = lengthGetLineCount(textEdit.endOffset) + 1;
        const newLengthLineCount = lengthGetLineCount(textEdit.newLength);
        const delta = newLengthLineCount - (textEditEndLineNumber - textEditStartLineNumber);

        if (textEditEndLineNumber < rangeStartLineNumber) {
            // the text edit is before us
            rangeStartLineNumber += delta;
            rangeEndLineNumberEx += delta;
        } else if (textEditStartLineNumber > rangeEndLineNumberEx) {
            // the text edit is after us
            // NOOP
        } else if (textEditStartLineNumber < rangeStartLineNumber && rangeEndLineNumberEx < textEditEndLineNumber) {
            // the range is fully contained in the text edit
            return undefined;
        } else if (textEditStartLineNumber < rangeStartLineNumber && textEditEndLineNumber <= rangeEndLineNumberEx) {
            // the text edit ends inside our range
            rangeStartLineNumber = textEditEndLineNumber + 1;
            rangeStartLineNumber += delta;
            rangeEndLineNumberEx += delta;
        } else if (rangeStartLineNumber <= textEditStartLineNumber && textEditEndLineNumber < rangeStartLineNumber) {
            // the text edit starts inside our range
            rangeEndLineNumberEx = textEditStartLineNumber;
        } else {
            rangeEndLineNumberEx += delta;
        }
    }

    return new LineRange(rangeStartLineNumber, rangeEndLineNumberEx);
}

function applyModifiedEditsToLineRangeMappings(changes: readonly LineRangeMapping[], textEdits: TextEditInfo[], originalTextModel: ITextModel, modifiedTextModel: ITextModel): LineRangeMapping[] {
    const diffTextEdits = changes.flatMap(c => c.innerChanges!.map(c => new TextEditInfo(
        positionToLength(c.originalRange.getStartPosition()),
        positionToLength(c.originalRange.getEndPosition()),
        lengthOfRange(c.modifiedRange).toLength(),
    )));

    const combined = combineTextEditInfos(diffTextEdits, textEdits);

    let lastOriginalEndOffset = lengthZero;
    let lastModifiedEndOffset = lengthZero;
    const rangeMappings = combined.map(c => {
        const modifiedStartOffset = lengthAdd(lastModifiedEndOffset, lengthDiffNonNegative(lastOriginalEndOffset, c.startOffset));
        lastOriginalEndOffset = c.endOffset;
        lastModifiedEndOffset = lengthAdd(modifiedStartOffset, c.newLength);

        return new RangeMapping(
            Range.fromPositions(lengthToPosition(c.startOffset), lengthToPosition(c.endOffset)),
            Range.fromPositions(lengthToPosition(modifiedStartOffset), lengthToPosition(lastModifiedEndOffset)),
        );
    });

    const newChanges = lineRangeMappingFromRangeMappings(
        rangeMappings,
        originalTextModel.getLinesContent(),
        modifiedTextModel.getLinesContent(),
    );
    return newChanges;
}
*/ 

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","./diffProviderFactoryService.js":"chJTA","./utils.js":"2G3Lp","../../../../base/common/hotReloadHelpers.js":"3t1eI","../../../common/core/lineRange.js":"cmnMs","../../../common/diff/defaultLinesDiffComputer/defaultLinesDiffComputer.js":"8qVeZ","../../../common/diff/rangeMapping.js":"7QuJJ","../../../common/model/bracketPairsTextModelPart/bracketPairsTree/beforeEditPositionMapper.js":"kLXi3","../../../common/model/bracketPairsTextModelPart/bracketPairsTree/combineTextEditInfos.js":"6PVkC","../../../common/diff/defaultLinesDiffComputer/heuristicSequenceOptimizations.js":"eLKvQ","../../../../base/common/types.js":"fb5yx","../../../../base/common/arrays.js":"DECei","../../../../base/common/assert.js":"1nPIE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"chJTA":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IDiffProviderFactoryService", ()=>IDiffProviderFactoryService);
parcelHelpers.export(exports, "WorkerBasedDiffProviderFactoryService", ()=>WorkerBasedDiffProviderFactoryService);
parcelHelpers.export(exports, "WorkerBasedDocumentDiffProvider", ()=>WorkerBasedDocumentDiffProvider);
var _extensionsJs = require("../../../../platform/instantiation/common/extensions.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _eventJs = require("../../../../base/common/event.js");
var _stopwatchJs = require("../../../../base/common/stopwatch.js");
var _lineRangeJs = require("../../../common/core/lineRange.js");
var _rangeMappingJs = require("../../../common/diff/rangeMapping.js");
var _editorWorkerJs = require("../../../common/services/editorWorker.js");
var _telemetryJs = require("../../../../platform/telemetry/common/telemetry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var WorkerBasedDocumentDiffProvider_1;
const IDiffProviderFactoryService = (0, _instantiationJs.createDecorator)("diffProviderFactoryService");
let WorkerBasedDiffProviderFactoryService = class WorkerBasedDiffProviderFactoryService {
    constructor(instantiationService){
        this.instantiationService = instantiationService;
    }
    createDiffProvider(options) {
        return this.instantiationService.createInstance(WorkerBasedDocumentDiffProvider, options);
    }
};
WorkerBasedDiffProviderFactoryService = __decorate([
    __param(0, (0, _instantiationJs.IInstantiationService))
], WorkerBasedDiffProviderFactoryService);
(0, _extensionsJs.registerSingleton)(IDiffProviderFactoryService, WorkerBasedDiffProviderFactoryService, 1 /* InstantiationType.Delayed */ );
let WorkerBasedDocumentDiffProvider = class WorkerBasedDocumentDiffProvider {
    static{
        WorkerBasedDocumentDiffProvider_1 = this;
    }
    static{
        this.diffCache = new Map();
    }
    constructor(options, editorWorkerService, telemetryService){
        this.editorWorkerService = editorWorkerService;
        this.telemetryService = telemetryService;
        this.onDidChangeEventEmitter = new (0, _eventJs.Emitter)();
        this.onDidChange = this.onDidChangeEventEmitter.event;
        this.diffAlgorithm = "advanced";
        this.diffAlgorithmOnDidChangeSubscription = undefined;
        this.setOptions(options);
    }
    dispose() {
        this.diffAlgorithmOnDidChangeSubscription?.dispose();
    }
    async computeDiff(original, modified, options, cancellationToken) {
        if (typeof this.diffAlgorithm !== "string") return this.diffAlgorithm.computeDiff(original, modified, options, cancellationToken);
        if (original.isDisposed() || modified.isDisposed()) // TODO@hediet
        return {
            changes: [],
            identical: true,
            quitEarly: false,
            moves: []
        };
        // This significantly speeds up the case when the original file is empty
        if (original.getLineCount() === 1 && original.getLineMaxColumn(1) === 1) {
            if (modified.getLineCount() === 1 && modified.getLineMaxColumn(1) === 1) return {
                changes: [],
                identical: true,
                quitEarly: false,
                moves: []
            };
            return {
                changes: [
                    new (0, _rangeMappingJs.DetailedLineRangeMapping)(new (0, _lineRangeJs.LineRange)(1, 2), new (0, _lineRangeJs.LineRange)(1, modified.getLineCount() + 1), [
                        new (0, _rangeMappingJs.RangeMapping)(original.getFullModelRange(), modified.getFullModelRange())
                    ])
                ],
                identical: false,
                quitEarly: false,
                moves: []
            };
        }
        const uriKey = JSON.stringify([
            original.uri.toString(),
            modified.uri.toString()
        ]);
        const context = JSON.stringify([
            original.id,
            modified.id,
            original.getAlternativeVersionId(),
            modified.getAlternativeVersionId(),
            JSON.stringify(options)
        ]);
        const c = WorkerBasedDocumentDiffProvider_1.diffCache.get(uriKey);
        if (c && c.context === context) return c.result;
        const sw = (0, _stopwatchJs.StopWatch).create();
        const result = await this.editorWorkerService.computeDiff(original.uri, modified.uri, options, this.diffAlgorithm);
        const timeMs = sw.elapsed();
        this.telemetryService.publicLog2("diffEditor.computeDiff", {
            timeMs,
            timedOut: result?.quitEarly ?? true,
            detectedMoves: options.computeMoves ? result?.moves.length ?? 0 : -1
        });
        if (cancellationToken.isCancellationRequested) // Text models might be disposed!
        return {
            changes: [],
            identical: false,
            quitEarly: true,
            moves: []
        };
        if (!result) throw new Error("no diff result available");
        // max 10 items in cache
        if (WorkerBasedDocumentDiffProvider_1.diffCache.size > 10) WorkerBasedDocumentDiffProvider_1.diffCache.delete(WorkerBasedDocumentDiffProvider_1.diffCache.keys().next().value);
        WorkerBasedDocumentDiffProvider_1.diffCache.set(uriKey, {
            result,
            context
        });
        return result;
    }
    setOptions(newOptions) {
        let didChange = false;
        if (newOptions.diffAlgorithm) {
            if (this.diffAlgorithm !== newOptions.diffAlgorithm) {
                this.diffAlgorithmOnDidChangeSubscription?.dispose();
                this.diffAlgorithmOnDidChangeSubscription = undefined;
                this.diffAlgorithm = newOptions.diffAlgorithm;
                if (typeof newOptions.diffAlgorithm !== "string") this.diffAlgorithmOnDidChangeSubscription = newOptions.diffAlgorithm.onDidChange(()=>this.onDidChangeEventEmitter.fire());
                didChange = true;
            }
        }
        if (didChange) this.onDidChangeEventEmitter.fire();
    }
};
WorkerBasedDocumentDiffProvider = WorkerBasedDocumentDiffProvider_1 = __decorate([
    __param(1, (0, _editorWorkerJs.IEditorWorkerService)),
    __param(2, (0, _telemetryJs.ITelemetryService))
], WorkerBasedDocumentDiffProvider);

},{"../../../../platform/instantiation/common/extensions.js":"6WJLq","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../base/common/event.js":"4Zi8b","../../../../base/common/stopwatch.js":"77PF9","../../../common/core/lineRange.js":"cmnMs","../../../common/diff/rangeMapping.js":"7QuJJ","../../../common/services/editorWorker.js":"aaYJd","../../../../platform/telemetry/common/telemetry.js":"7vW8j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3t1eI":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readHotReloadableExport", ()=>readHotReloadableExport);
parcelHelpers.export(exports, "observeHotReloadableExports", ()=>observeHotReloadableExports);
var _hotReloadJs = require("./hotReload.js");
var _observableJs = require("./observable.js");
function readHotReloadableExport(value, reader) {
    observeHotReloadableExports([
        value
    ], reader);
    return value;
}
function observeHotReloadableExports(values, reader) {
    if ((0, _hotReloadJs.isHotReloadEnabled)()) {
        const o = (0, _observableJs.observableSignalFromEvent)("reload", (event)=>(0, _hotReloadJs.registerHotReloadHandler)(({ oldExports })=>{
                if (![
                    ...Object.values(oldExports)
                ].some((v)=>values.includes(v))) return undefined;
                return (_newExports)=>{
                    event(undefined);
                    return true;
                };
            }));
        o.read(reader);
    }
}

},{"./hotReload.js":"hjduU","./observable.js":"2xbG5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hjduU":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHotReloadEnabled", ()=>isHotReloadEnabled);
parcelHelpers.export(exports, "registerHotReloadHandler", ()=>registerHotReloadHandler);
var _processJs = require("./process.js");
function isHotReloadEnabled() {
    return (0, _processJs.env) && !!(0, _processJs.env)["VSCODE_DEV"];
}
function registerHotReloadHandler(handler) {
    if (!isHotReloadEnabled()) return {
        dispose () {}
    };
    else {
        const handlers = registerGlobalHotReloadHandler();
        handlers.add(handler);
        return {
            dispose () {
                handlers.delete(handler);
            }
        };
    }
}
function registerGlobalHotReloadHandler() {
    if (!hotReloadHandlers) hotReloadHandlers = new Set();
    const g = globalThis;
    if (!g.$hotReload_applyNewExports) g.$hotReload_applyNewExports = (args)=>{
        const args2 = {
            config: {
                mode: undefined
            },
            ...args
        };
        const results = [];
        for (const h of hotReloadHandlers){
            const result = h(args2);
            if (result) results.push(result);
        }
        if (results.length > 0) return (newExports)=>{
            let result = false;
            for (const r of results)if (r(newExports)) result = true;
            return result;
        };
        return undefined;
    };
    return hotReloadHandlers;
}
let hotReloadHandlers = undefined;
if (isHotReloadEnabled()) // This code does not run in production.
registerHotReloadHandler(({ oldExports, newSrc, config })=>{
    if (config.mode !== "patch-prototype") return undefined;
    return (newExports)=>{
        for(const key in newExports){
            const exportedItem = newExports[key];
            console.log(`[hot-reload] Patching prototype methods of '${key}'`, {
                exportedItem
            });
            if (typeof exportedItem === "function" && exportedItem.prototype) {
                const oldExportedItem = oldExports[key];
                if (oldExportedItem) {
                    for (const prop of Object.getOwnPropertyNames(exportedItem.prototype)){
                        const descriptor = Object.getOwnPropertyDescriptor(exportedItem.prototype, prop);
                        const oldDescriptor = Object.getOwnPropertyDescriptor(oldExportedItem.prototype, prop);
                        if (descriptor?.value?.toString() !== oldDescriptor?.value?.toString()) console.log(`[hot-reload] Patching prototype method '${key}.${prop}'`);
                        Object.defineProperty(oldExportedItem.prototype, prop, descriptor);
                    }
                    newExports[key] = oldExportedItem;
                }
            }
        }
        return true;
    };
});

},{"./process.js":"fWvKM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8wXXv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineDiffDeletedCodeMargin", ()=>InlineDiffDeletedCodeMargin);
var _domJs = require("../../../../../../base/browser/dom.js");
var _actionsJs = require("../../../../../../base/common/actions.js");
var _codiconsJs = require("../../../../../../base/common/codicons.js");
var _lifecycleJs = require("../../../../../../base/common/lifecycle.js");
var _platformJs = require("../../../../../../base/common/platform.js");
var _themablesJs = require("../../../../../../base/common/themables.js");
var _nlsJs = require("../../../../../../nls.js");
class InlineDiffDeletedCodeMargin extends (0, _lifecycleJs.Disposable) {
    get visibility() {
        return this._visibility;
    }
    set visibility(_visibility) {
        if (this._visibility !== _visibility) {
            this._visibility = _visibility;
            this._diffActions.style.visibility = _visibility ? "visible" : "hidden";
        }
    }
    constructor(_getViewZoneId, _marginDomNode, _modifiedEditor, _diff, _editor, _viewLineCounts, _originalTextModel, _contextMenuService, _clipboardService){
        super();
        this._getViewZoneId = _getViewZoneId;
        this._marginDomNode = _marginDomNode;
        this._modifiedEditor = _modifiedEditor;
        this._diff = _diff;
        this._editor = _editor;
        this._viewLineCounts = _viewLineCounts;
        this._originalTextModel = _originalTextModel;
        this._contextMenuService = _contextMenuService;
        this._clipboardService = _clipboardService;
        this._visibility = false;
        // make sure the diff margin shows above overlay.
        this._marginDomNode.style.zIndex = "10";
        this._diffActions = document.createElement("div");
        this._diffActions.className = (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).lightBulb) + " lightbulb-glyph";
        this._diffActions.style.position = "absolute";
        const lineHeight = this._modifiedEditor.getOption(67 /* EditorOption.lineHeight */ );
        this._diffActions.style.right = "0px";
        this._diffActions.style.visibility = "hidden";
        this._diffActions.style.height = `${lineHeight}px`;
        this._diffActions.style.lineHeight = `${lineHeight}px`;
        this._marginDomNode.appendChild(this._diffActions);
        let currentLineNumberOffset = 0;
        const useShadowDOM = _modifiedEditor.getOption(128 /* EditorOption.useShadowDOM */ ) && !(0, _platformJs.isIOS); // Do not use shadow dom on IOS #122035
        const showContextMenu = (x, y)=>{
            this._contextMenuService.showContextMenu({
                domForShadowRoot: useShadowDOM ? _modifiedEditor.getDomNode() ?? undefined : undefined,
                getAnchor: ()=>({
                        x,
                        y
                    }),
                getActions: ()=>{
                    const actions = [];
                    const isDeletion = _diff.modified.isEmpty;
                    // default action
                    actions.push(new (0, _actionsJs.Action)("diff.clipboard.copyDeletedContent", isDeletion ? _diff.original.length > 1 ? (0, _nlsJs.localize)("diff.clipboard.copyDeletedLinesContent.label", "Copy deleted lines") : (0, _nlsJs.localize)("diff.clipboard.copyDeletedLinesContent.single.label", "Copy deleted line") : _diff.original.length > 1 ? (0, _nlsJs.localize)("diff.clipboard.copyChangedLinesContent.label", "Copy changed lines") : (0, _nlsJs.localize)("diff.clipboard.copyChangedLinesContent.single.label", "Copy changed line"), undefined, true, async ()=>{
                        const originalText = this._originalTextModel.getValueInRange(_diff.original.toExclusiveRange());
                        await this._clipboardService.writeText(originalText);
                    }));
                    if (_diff.original.length > 1) actions.push(new (0, _actionsJs.Action)("diff.clipboard.copyDeletedLineContent", isDeletion ? (0, _nlsJs.localize)("diff.clipboard.copyDeletedLineContent.label", "Copy deleted line ({0})", _diff.original.startLineNumber + currentLineNumberOffset) : (0, _nlsJs.localize)("diff.clipboard.copyChangedLineContent.label", "Copy changed line ({0})", _diff.original.startLineNumber + currentLineNumberOffset), undefined, true, async ()=>{
                        let lineContent = this._originalTextModel.getLineContent(_diff.original.startLineNumber + currentLineNumberOffset);
                        if (lineContent === "") {
                            // empty line -> new line
                            const eof = this._originalTextModel.getEndOfLineSequence();
                            lineContent = eof === 0 /* EndOfLineSequence.LF */  ? "\n" : "\r\n";
                        }
                        await this._clipboardService.writeText(lineContent);
                    }));
                    const readOnly = _modifiedEditor.getOption(92 /* EditorOption.readOnly */ );
                    if (!readOnly) actions.push(new (0, _actionsJs.Action)("diff.inline.revertChange", (0, _nlsJs.localize)("diff.inline.revertChange.label", "Revert this change"), undefined, true, async ()=>{
                        this._editor.revert(this._diff);
                    }));
                    return actions;
                },
                autoSelectFirstItem: true
            });
        };
        this._register((0, _domJs.addStandardDisposableListener)(this._diffActions, "mousedown", (e)=>{
            if (!e.leftButton) return;
            const { top, height } = (0, _domJs.getDomNodePagePosition)(this._diffActions);
            const pad = Math.floor(lineHeight / 3);
            e.preventDefault();
            showContextMenu(e.posx, top + height + pad);
        }));
        this._register(_modifiedEditor.onMouseMove((e)=>{
            if ((e.target.type === 8 /* MouseTargetType.CONTENT_VIEW_ZONE */  || e.target.type === 5 /* MouseTargetType.GUTTER_VIEW_ZONE */ ) && e.target.detail.viewZoneId === this._getViewZoneId()) {
                currentLineNumberOffset = this._updateLightBulbPosition(this._marginDomNode, e.event.browserEvent.y, lineHeight);
                this.visibility = true;
            } else this.visibility = false;
        }));
        this._register(_modifiedEditor.onMouseDown((e)=>{
            if (!e.event.leftButton) return;
            if (e.target.type === 8 /* MouseTargetType.CONTENT_VIEW_ZONE */  || e.target.type === 5 /* MouseTargetType.GUTTER_VIEW_ZONE */ ) {
                const viewZoneId = e.target.detail.viewZoneId;
                if (viewZoneId === this._getViewZoneId()) {
                    e.event.preventDefault();
                    currentLineNumberOffset = this._updateLightBulbPosition(this._marginDomNode, e.event.browserEvent.y, lineHeight);
                    showContextMenu(e.event.posx, e.event.posy + lineHeight);
                }
            }
        }));
    }
    _updateLightBulbPosition(marginDomNode, y, lineHeight) {
        const { top } = (0, _domJs.getDomNodePagePosition)(marginDomNode);
        const offset = y - top;
        const lineNumberOffset = Math.floor(offset / lineHeight);
        const newTop = lineNumberOffset * lineHeight;
        this._diffActions.style.top = `${newTop}px`;
        if (this._viewLineCounts) {
            let acc = 0;
            for(let i = 0; i < this._viewLineCounts.length; i++){
                acc += this._viewLineCounts[i];
                if (lineNumberOffset < acc) return i;
            }
        }
        return lineNumberOffset;
    }
}

},{"../../../../../../base/browser/dom.js":"bnqsM","../../../../../../base/common/actions.js":"5GjLb","../../../../../../base/common/codicons.js":"hWYNf","../../../../../../base/common/lifecycle.js":"9kg8d","../../../../../../base/common/platform.js":"7maJO","../../../../../../base/common/themables.js":"hgyHi","../../../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hjIDK":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderLines", ()=>renderLines);
parcelHelpers.export(exports, "LineSource", ()=>LineSource);
parcelHelpers.export(exports, "RenderOptions", ()=>RenderOptions);
var _trustedTypesJs = require("../../../../../../base/browser/trustedTypes.js");
var _domFontInfoJs = require("../../../../config/domFontInfo.js");
var _editorOptionsJs = require("../../../../../common/config/editorOptions.js");
var _stringBuilderJs = require("../../../../../common/core/stringBuilder.js");
var _lineDecorationsJs = require("../../../../../common/viewLayout/lineDecorations.js");
var _viewLineRendererJs = require("../../../../../common/viewLayout/viewLineRenderer.js");
var _viewModelJs = require("../../../../../common/viewModel.js");
const ttPolicy = (0, _trustedTypesJs.createTrustedTypesPolicy)("diffEditorWidget", {
    createHTML: (value)=>value
});
function renderLines(source, options, decorations, domNode) {
    (0, _domFontInfoJs.applyFontInfo)(domNode, options.fontInfo);
    const hasCharChanges = decorations.length > 0;
    const sb = new (0, _stringBuilderJs.StringBuilder)(10000);
    let maxCharsPerLine = 0;
    let renderedLineCount = 0;
    const viewLineCounts = [];
    for(let lineIndex = 0; lineIndex < source.lineTokens.length; lineIndex++){
        const lineNumber = lineIndex + 1;
        const lineTokens = source.lineTokens[lineIndex];
        const lineBreakData = source.lineBreakData[lineIndex];
        const actualDecorations = (0, _lineDecorationsJs.LineDecoration).filter(decorations, lineNumber, 1, Number.MAX_SAFE_INTEGER);
        if (lineBreakData) {
            let lastBreakOffset = 0;
            for (const breakOffset of lineBreakData.breakOffsets){
                const viewLineTokens = lineTokens.sliceAndInflate(lastBreakOffset, breakOffset, 0);
                maxCharsPerLine = Math.max(maxCharsPerLine, renderOriginalLine(renderedLineCount, viewLineTokens, (0, _lineDecorationsJs.LineDecoration).extractWrapped(actualDecorations, lastBreakOffset, breakOffset), hasCharChanges, source.mightContainNonBasicASCII, source.mightContainRTL, options, sb));
                renderedLineCount++;
                lastBreakOffset = breakOffset;
            }
            viewLineCounts.push(lineBreakData.breakOffsets.length);
        } else {
            viewLineCounts.push(1);
            maxCharsPerLine = Math.max(maxCharsPerLine, renderOriginalLine(renderedLineCount, lineTokens, actualDecorations, hasCharChanges, source.mightContainNonBasicASCII, source.mightContainRTL, options, sb));
            renderedLineCount++;
        }
    }
    maxCharsPerLine += options.scrollBeyondLastColumn;
    const html = sb.build();
    const trustedhtml = ttPolicy ? ttPolicy.createHTML(html) : html;
    domNode.innerHTML = trustedhtml;
    const minWidthInPx = maxCharsPerLine * options.typicalHalfwidthCharacterWidth;
    return {
        heightInLines: renderedLineCount,
        minWidthInPx,
        viewLineCounts
    };
}
class LineSource {
    constructor(lineTokens, lineBreakData, mightContainNonBasicASCII, mightContainRTL){
        this.lineTokens = lineTokens;
        this.lineBreakData = lineBreakData;
        this.mightContainNonBasicASCII = mightContainNonBasicASCII;
        this.mightContainRTL = mightContainRTL;
    }
}
class RenderOptions {
    static fromEditor(editor) {
        const modifiedEditorOptions = editor.getOptions();
        const fontInfo = modifiedEditorOptions.get(50 /* EditorOption.fontInfo */ );
        const layoutInfo = modifiedEditorOptions.get(146 /* EditorOption.layoutInfo */ );
        return new RenderOptions(editor.getModel()?.getOptions().tabSize || 0, fontInfo, modifiedEditorOptions.get(33 /* EditorOption.disableMonospaceOptimizations */ ), fontInfo.typicalHalfwidthCharacterWidth, modifiedEditorOptions.get(105 /* EditorOption.scrollBeyondLastColumn */ ), modifiedEditorOptions.get(67 /* EditorOption.lineHeight */ ), layoutInfo.decorationsWidth, modifiedEditorOptions.get(118 /* EditorOption.stopRenderingLineAfter */ ), modifiedEditorOptions.get(100 /* EditorOption.renderWhitespace */ ), modifiedEditorOptions.get(95 /* EditorOption.renderControlCharacters */ ), modifiedEditorOptions.get(51 /* EditorOption.fontLigatures */ ));
    }
    constructor(tabSize, fontInfo, disableMonospaceOptimizations, typicalHalfwidthCharacterWidth, scrollBeyondLastColumn, lineHeight, lineDecorationsWidth, stopRenderingLineAfter, renderWhitespace, renderControlCharacters, fontLigatures){
        this.tabSize = tabSize;
        this.fontInfo = fontInfo;
        this.disableMonospaceOptimizations = disableMonospaceOptimizations;
        this.typicalHalfwidthCharacterWidth = typicalHalfwidthCharacterWidth;
        this.scrollBeyondLastColumn = scrollBeyondLastColumn;
        this.lineHeight = lineHeight;
        this.lineDecorationsWidth = lineDecorationsWidth;
        this.stopRenderingLineAfter = stopRenderingLineAfter;
        this.renderWhitespace = renderWhitespace;
        this.renderControlCharacters = renderControlCharacters;
        this.fontLigatures = fontLigatures;
    }
}
function renderOriginalLine(viewLineIdx, lineTokens, decorations, hasCharChanges, mightContainNonBasicASCII, mightContainRTL, options, sb) {
    sb.appendString('<div class="view-line');
    if (!hasCharChanges) // No char changes
    sb.appendString(" char-delete");
    sb.appendString('" style="top:');
    sb.appendString(String(viewLineIdx * options.lineHeight));
    sb.appendString('px;width:1000000px;">');
    const lineContent = lineTokens.getLineContent();
    const isBasicASCII = (0, _viewModelJs.ViewLineRenderingData).isBasicASCII(lineContent, mightContainNonBasicASCII);
    const containsRTL = (0, _viewModelJs.ViewLineRenderingData).containsRTL(lineContent, isBasicASCII, mightContainRTL);
    const output = (0, _viewLineRendererJs.renderViewLine)(new (0, _viewLineRendererJs.RenderLineInput)(options.fontInfo.isMonospace && !options.disableMonospaceOptimizations, options.fontInfo.canUseHalfwidthRightwardsArrow, lineContent, false, isBasicASCII, containsRTL, 0, lineTokens, decorations, options.tabSize, 0, options.fontInfo.spaceWidth, options.fontInfo.middotWidth, options.fontInfo.wsmiddotWidth, options.stopRenderingLineAfter, options.renderWhitespace, options.renderControlCharacters, options.fontLigatures !== (0, _editorOptionsJs.EditorFontLigatures).OFF, null // Send no selections, original line cannot be selected
    ), sb);
    sb.appendString("</div>");
    return output.characterMapping.getHorizontalOffset(output.characterMapping.length);
}

},{"../../../../../../base/browser/trustedTypes.js":"bgQyv","../../../../config/domFontInfo.js":"fQezv","../../../../../common/config/editorOptions.js":"3Xi00","../../../../../common/core/stringBuilder.js":"hHgWQ","../../../../../common/viewLayout/lineDecorations.js":"m2bJX","../../../../../common/viewLayout/viewLineRenderer.js":"1RGPz","../../../../../common/viewModel.js":"5EHxj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1UiXm":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MovedBlocksLinesFeature", ()=>MovedBlocksLinesFeature);
var _domJs = require("../../../../../base/browser/dom.js");
var _actionbarJs = require("../../../../../base/browser/ui/actionbar/actionbar.js");
var _actionsJs = require("../../../../../base/common/actions.js");
var _arraysJs = require("../../../../../base/common/arrays.js");
var _arraysFindJs = require("../../../../../base/common/arraysFind.js");
var _codiconsJs = require("../../../../../base/common/codicons.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _themablesJs = require("../../../../../base/common/themables.js");
var _utilsJs = require("../utils.js");
var _offsetRangeJs = require("../../../../common/core/offsetRange.js");
var _nlsJs = require("../../../../../nls.js");
class MovedBlocksLinesFeature extends (0, _lifecycleJs.Disposable) {
    static{
        this.movedCodeBlockPadding = 4;
    }
    constructor(_rootElement, _diffModel, _originalEditorLayoutInfo, _modifiedEditorLayoutInfo, _editors){
        super();
        this._rootElement = _rootElement;
        this._diffModel = _diffModel;
        this._originalEditorLayoutInfo = _originalEditorLayoutInfo;
        this._modifiedEditorLayoutInfo = _modifiedEditorLayoutInfo;
        this._editors = _editors;
        this._originalScrollTop = (0, _observableJs.observableFromEvent)(this, this._editors.original.onDidScrollChange, ()=>this._editors.original.getScrollTop());
        this._modifiedScrollTop = (0, _observableJs.observableFromEvent)(this, this._editors.modified.onDidScrollChange, ()=>this._editors.modified.getScrollTop());
        this._viewZonesChanged = (0, _observableJs.observableSignalFromEvent)("onDidChangeViewZones", this._editors.modified.onDidChangeViewZones);
        this.width = (0, _observableJs.observableValue)(this, 0);
        this._modifiedViewZonesChangedSignal = (0, _observableJs.observableSignalFromEvent)("modified.onDidChangeViewZones", this._editors.modified.onDidChangeViewZones);
        this._originalViewZonesChangedSignal = (0, _observableJs.observableSignalFromEvent)("original.onDidChangeViewZones", this._editors.original.onDidChangeViewZones);
        this._state = (0, _observableJs.derivedWithStore)(this, (reader, store)=>{
            /** @description state */ this._element.replaceChildren();
            const model = this._diffModel.read(reader);
            const moves = model?.diff.read(reader)?.movedTexts;
            if (!moves || moves.length === 0) {
                this.width.set(0, undefined);
                return;
            }
            this._viewZonesChanged.read(reader);
            const infoOrig = this._originalEditorLayoutInfo.read(reader);
            const infoMod = this._modifiedEditorLayoutInfo.read(reader);
            if (!infoOrig || !infoMod) {
                this.width.set(0, undefined);
                return;
            }
            this._modifiedViewZonesChangedSignal.read(reader);
            this._originalViewZonesChangedSignal.read(reader);
            const lines = moves.map((move)=>{
                function computeLineStart(range, editor) {
                    const t1 = editor.getTopForLineNumber(range.startLineNumber, true);
                    const t2 = editor.getTopForLineNumber(range.endLineNumberExclusive, true);
                    return (t1 + t2) / 2;
                }
                const start = computeLineStart(move.lineRangeMapping.original, this._editors.original);
                const startOffset = this._originalScrollTop.read(reader);
                const end = computeLineStart(move.lineRangeMapping.modified, this._editors.modified);
                const endOffset = this._modifiedScrollTop.read(reader);
                const from = start - startOffset;
                const to = end - endOffset;
                const top = Math.min(start, end);
                const bottom = Math.max(start, end);
                return {
                    range: new (0, _offsetRangeJs.OffsetRange)(top, bottom),
                    from,
                    to,
                    fromWithoutScroll: start,
                    toWithoutScroll: end,
                    move
                };
            });
            lines.sort((0, _arraysJs.tieBreakComparators)((0, _arraysJs.compareBy)((l)=>l.fromWithoutScroll > l.toWithoutScroll, (0, _arraysJs.booleanComparator)), (0, _arraysJs.compareBy)((l)=>l.fromWithoutScroll > l.toWithoutScroll ? l.fromWithoutScroll : -l.toWithoutScroll, (0, _arraysJs.numberComparator))));
            const layout = LinesLayout.compute(lines.map((l)=>l.range));
            const padding = 10;
            const lineAreaLeft = infoOrig.verticalScrollbarWidth;
            const lineAreaWidth = (layout.getTrackCount() - 1) * 10 + padding * 2;
            const width = lineAreaLeft + lineAreaWidth + (infoMod.contentLeft - MovedBlocksLinesFeature.movedCodeBlockPadding);
            let idx = 0;
            for (const line of lines){
                const track = layout.getTrack(idx);
                const verticalY = lineAreaLeft + padding + track * 10;
                const arrowHeight = 15;
                const arrowWidth = 15;
                const right = width;
                const rectWidth = infoMod.glyphMarginWidth + infoMod.lineNumbersWidth;
                const rectHeight = 18;
                const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                rect.classList.add("arrow-rectangle");
                rect.setAttribute("x", `${right - rectWidth}`);
                rect.setAttribute("y", `${line.to - rectHeight / 2}`);
                rect.setAttribute("width", `${rectWidth}`);
                rect.setAttribute("height", `${rectHeight}`);
                this._element.appendChild(rect);
                const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
                const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
                path.setAttribute("d", `M ${0} ${line.from} L ${verticalY} ${line.from} L ${verticalY} ${line.to} L ${right - arrowWidth} ${line.to}`);
                path.setAttribute("fill", "none");
                g.appendChild(path);
                const arrowRight = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
                arrowRight.classList.add("arrow");
                store.add((0, _observableJs.autorun)((reader)=>{
                    path.classList.toggle("currentMove", line.move === model.activeMovedText.read(reader));
                    arrowRight.classList.toggle("currentMove", line.move === model.activeMovedText.read(reader));
                }));
                arrowRight.setAttribute("points", `${right - arrowWidth},${line.to - arrowHeight / 2} ${right},${line.to} ${right - arrowWidth},${line.to + arrowHeight / 2}`);
                g.appendChild(arrowRight);
                this._element.appendChild(g);
                /*
                TODO@hediet
                path.addEventListener('mouseenter', () => {
                    model.setHoveredMovedText(line.move);
                });
                path.addEventListener('mouseleave', () => {
                    model.setHoveredMovedText(undefined);
                });*/ idx++;
            }
            this.width.set(lineAreaWidth, undefined);
        });
        this._element = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        this._element.setAttribute("class", "moved-blocks-lines");
        this._rootElement.appendChild(this._element);
        this._register((0, _lifecycleJs.toDisposable)(()=>this._element.remove()));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update moved blocks lines positioning */ const info = this._originalEditorLayoutInfo.read(reader);
            const info2 = this._modifiedEditorLayoutInfo.read(reader);
            if (!info || !info2) return;
            this._element.style.left = `${info.width - info.verticalScrollbarWidth}px`;
            this._element.style.height = `${info.height}px`;
            this._element.style.width = `${info.verticalScrollbarWidth + info.contentLeft - MovedBlocksLinesFeature.movedCodeBlockPadding + this.width.read(reader)}px`;
        }));
        this._register((0, _observableJs.recomputeInitiallyAndOnChange)(this._state));
        const movedBlockViewZones = (0, _observableJs.derived)((reader)=>{
            const model = this._diffModel.read(reader);
            const d = model?.diff.read(reader);
            if (!d) return [];
            return d.movedTexts.map((move)=>({
                    move,
                    original: new (0, _utilsJs.PlaceholderViewZone)((0, _observableJs.constObservable)(move.lineRangeMapping.original.startLineNumber - 1), 18),
                    modified: new (0, _utilsJs.PlaceholderViewZone)((0, _observableJs.constObservable)(move.lineRangeMapping.modified.startLineNumber - 1), 18)
                }));
        });
        this._register((0, _utilsJs.applyViewZones)(this._editors.original, movedBlockViewZones.map((zones)=>/** @description movedBlockViewZones.original */ zones.map((z)=>z.original))));
        this._register((0, _utilsJs.applyViewZones)(this._editors.modified, movedBlockViewZones.map((zones)=>/** @description movedBlockViewZones.modified */ zones.map((z)=>z.modified))));
        this._register((0, _observableJs.autorunWithStore)((reader, store)=>{
            const blocks = movedBlockViewZones.read(reader);
            for (const b of blocks){
                store.add(new MovedBlockOverlayWidget(this._editors.original, b.original, b.move, "original", this._diffModel.get()));
                store.add(new MovedBlockOverlayWidget(this._editors.modified, b.modified, b.move, "modified", this._diffModel.get()));
            }
        }));
        const originalHasFocus = (0, _observableJs.observableSignalFromEvent)("original.onDidFocusEditorWidget", (e)=>this._editors.original.onDidFocusEditorWidget(()=>setTimeout(()=>e(undefined), 0)));
        const modifiedHasFocus = (0, _observableJs.observableSignalFromEvent)("modified.onDidFocusEditorWidget", (e)=>this._editors.modified.onDidFocusEditorWidget(()=>setTimeout(()=>e(undefined), 0)));
        let lastChangedEditor = "modified";
        this._register((0, _observableJs.autorunHandleChanges)({
            createEmptyChangeSummary: ()=>undefined,
            handleChange: (ctx, summary)=>{
                if (ctx.didChange(originalHasFocus)) lastChangedEditor = "original";
                if (ctx.didChange(modifiedHasFocus)) lastChangedEditor = "modified";
                return true;
            }
        }, (reader)=>{
            /** @description MovedBlocksLines.setActiveMovedTextFromCursor */ originalHasFocus.read(reader);
            modifiedHasFocus.read(reader);
            const m = this._diffModel.read(reader);
            if (!m) return;
            const diff = m.diff.read(reader);
            let movedText = undefined;
            if (diff && lastChangedEditor === "original") {
                const originalPos = this._editors.originalCursor.read(reader);
                if (originalPos) movedText = diff.movedTexts.find((m)=>m.lineRangeMapping.original.contains(originalPos.lineNumber));
            }
            if (diff && lastChangedEditor === "modified") {
                const modifiedPos = this._editors.modifiedCursor.read(reader);
                if (modifiedPos) movedText = diff.movedTexts.find((m)=>m.lineRangeMapping.modified.contains(modifiedPos.lineNumber));
            }
            if (movedText !== m.movedTextToCompare.get()) m.movedTextToCompare.set(undefined, undefined);
            m.setActiveMovedText(movedText);
        }));
    }
}
class LinesLayout {
    static compute(lines) {
        const setsPerTrack = [];
        const trackPerLineIdx = [];
        for (const line of lines){
            let trackIdx = setsPerTrack.findIndex((set)=>!set.intersectsStrict(line));
            if (trackIdx === -1) {
                const maxTrackCount = 6;
                if (setsPerTrack.length >= maxTrackCount) trackIdx = (0, _arraysFindJs.findMaxIdx)(setsPerTrack, (0, _arraysJs.compareBy)((set)=>set.intersectWithRangeLength(line), (0, _arraysJs.numberComparator)));
                else {
                    trackIdx = setsPerTrack.length;
                    setsPerTrack.push(new (0, _offsetRangeJs.OffsetRangeSet)());
                }
            }
            setsPerTrack[trackIdx].addRange(line);
            trackPerLineIdx.push(trackIdx);
        }
        return new LinesLayout(setsPerTrack.length, trackPerLineIdx);
    }
    constructor(_trackCount, trackPerLineIdx){
        this._trackCount = _trackCount;
        this.trackPerLineIdx = trackPerLineIdx;
    }
    getTrack(lineIdx) {
        return this.trackPerLineIdx[lineIdx];
    }
    getTrackCount() {
        return this._trackCount;
    }
}
class MovedBlockOverlayWidget extends (0, _utilsJs.ViewZoneOverlayWidget) {
    constructor(_editor, _viewZone, _move, _kind, _diffModel){
        const root = (0, _domJs.h)("div.diff-hidden-lines-widget");
        super(_editor, _viewZone, root.root);
        this._editor = _editor;
        this._move = _move;
        this._kind = _kind;
        this._diffModel = _diffModel;
        this._nodes = (0, _domJs.h)("div.diff-moved-code-block", {
            style: {
                marginRight: "4px"
            }
        }, [
            (0, _domJs.h)("div.text-content@textContent"),
            (0, _domJs.h)("div.action-bar@actionBar")
        ]);
        root.root.appendChild(this._nodes.root);
        const editorLayout = (0, _observableJs.observableFromEvent)(this._editor.onDidLayoutChange, ()=>this._editor.getLayoutInfo());
        this._register((0, _utilsJs.applyStyle)(this._nodes.root, {
            paddingRight: editorLayout.map((l)=>l.verticalScrollbarWidth)
        }));
        let text;
        if (_move.changes.length > 0) text = this._kind === "original" ? (0, _nlsJs.localize)("codeMovedToWithChanges", "Code moved with changes to line {0}-{1}", this._move.lineRangeMapping.modified.startLineNumber, this._move.lineRangeMapping.modified.endLineNumberExclusive - 1) : (0, _nlsJs.localize)("codeMovedFromWithChanges", "Code moved with changes from line {0}-{1}", this._move.lineRangeMapping.original.startLineNumber, this._move.lineRangeMapping.original.endLineNumberExclusive - 1);
        else text = this._kind === "original" ? (0, _nlsJs.localize)("codeMovedTo", "Code moved to line {0}-{1}", this._move.lineRangeMapping.modified.startLineNumber, this._move.lineRangeMapping.modified.endLineNumberExclusive - 1) : (0, _nlsJs.localize)("codeMovedFrom", "Code moved from line {0}-{1}", this._move.lineRangeMapping.original.startLineNumber, this._move.lineRangeMapping.original.endLineNumberExclusive - 1);
        const actionBar = this._register(new (0, _actionbarJs.ActionBar)(this._nodes.actionBar, {
            highlightToggledItems: true
        }));
        const caption = new (0, _actionsJs.Action)("", text, "", false);
        actionBar.push(caption, {
            icon: false,
            label: true
        });
        const actionCompare = new (0, _actionsJs.Action)("", "Compare", (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).compareChanges), true, ()=>{
            this._editor.focus();
            this._diffModel.movedTextToCompare.set(this._diffModel.movedTextToCompare.get() === _move ? undefined : this._move, undefined);
        });
        this._register((0, _observableJs.autorun)((reader)=>{
            const isActive = this._diffModel.movedTextToCompare.read(reader) === _move;
            actionCompare.checked = isActive;
        }));
        actionBar.push(actionCompare, {
            icon: false,
            label: true
        });
    }
}

},{"../../../../../base/browser/dom.js":"bnqsM","../../../../../base/browser/ui/actionbar/actionbar.js":"5Xmba","../../../../../base/common/actions.js":"5GjLb","../../../../../base/common/arrays.js":"DECei","../../../../../base/common/arraysFind.js":"gWrU0","../../../../../base/common/codicons.js":"hWYNf","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../../base/common/themables.js":"hgyHi","../utils.js":"2G3Lp","../../../../common/core/offsetRange.js":"ifHXk","../../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8adBv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SashLayout", ()=>SashLayout);
parcelHelpers.export(exports, "DiffEditorSash", ()=>DiffEditorSash);
var _sashJs = require("../../../../../base/browser/ui/sash/sash.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _derivedJs = require("../../../../../base/common/observableInternal/derived.js");
class SashLayout {
    resetSash() {
        this._sashRatio.set(undefined, undefined);
    }
    constructor(_options, dimensions){
        this._options = _options;
        this.dimensions = dimensions;
        this.sashLeft = (0, _derivedJs.derivedWithSetter)(this, (reader)=>{
            const ratio = this._sashRatio.read(reader) ?? this._options.splitViewDefaultRatio.read(reader);
            return this._computeSashLeft(ratio, reader);
        }, (value, tx)=>{
            const contentWidth = this.dimensions.width.get();
            this._sashRatio.set(value / contentWidth, tx);
        });
        this._sashRatio = (0, _observableJs.observableValue)(this, undefined);
    }
    /** @pure */ _computeSashLeft(desiredRatio, reader) {
        const contentWidth = this.dimensions.width.read(reader);
        const midPoint = Math.floor(this._options.splitViewDefaultRatio.read(reader) * contentWidth);
        const sashLeft = this._options.enableSplitViewResizing.read(reader) ? Math.floor(desiredRatio * contentWidth) : midPoint;
        const MINIMUM_EDITOR_WIDTH = 100;
        if (contentWidth <= MINIMUM_EDITOR_WIDTH * 2) return midPoint;
        if (sashLeft < MINIMUM_EDITOR_WIDTH) return MINIMUM_EDITOR_WIDTH;
        if (sashLeft > contentWidth - MINIMUM_EDITOR_WIDTH) return contentWidth - MINIMUM_EDITOR_WIDTH;
        return sashLeft;
    }
}
class DiffEditorSash extends (0, _lifecycleJs.Disposable) {
    constructor(_domNode, _dimensions, _enabled, _boundarySashes, sashLeft, _resetSash){
        super();
        this._domNode = _domNode;
        this._dimensions = _dimensions;
        this._enabled = _enabled;
        this._boundarySashes = _boundarySashes;
        this.sashLeft = sashLeft;
        this._resetSash = _resetSash;
        this._sash = this._register(new (0, _sashJs.Sash)(this._domNode, {
            getVerticalSashTop: (_sash)=>0,
            getVerticalSashLeft: (_sash)=>this.sashLeft.get(),
            getVerticalSashHeight: (_sash)=>this._dimensions.height.get()
        }, {
            orientation: 0 /* Orientation.VERTICAL */ 
        }));
        this._startSashPosition = undefined;
        this._register(this._sash.onDidStart(()=>{
            this._startSashPosition = this.sashLeft.get();
        }));
        this._register(this._sash.onDidChange((e)=>{
            this.sashLeft.set(this._startSashPosition + (e.currentX - e.startX), undefined);
        }));
        this._register(this._sash.onDidEnd(()=>this._sash.layout()));
        this._register(this._sash.onDidReset(()=>this._resetSash()));
        this._register((0, _observableJs.autorun)((reader)=>{
            const sashes = this._boundarySashes.read(reader);
            if (sashes) this._sash.orthogonalEndSash = sashes.bottom;
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description DiffEditorSash.layoutSash */ const enabled = this._enabled.read(reader);
            this._sash.state = enabled ? 3 /* SashState.Enabled */  : 0 /* SashState.Disabled */ ;
            this.sashLeft.read(reader);
            this._dimensions.height.read(reader);
            this._sash.layout();
        }));
    }
}

},{"../../../../../base/browser/ui/sash/sash.js":"2Pk4d","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../../base/common/observableInternal/derived.js":"hZb5S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4tY39":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiffEditorGutter", ()=>DiffEditorGutter);
var _domJs = require("../../../../../base/browser/dom.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _derivedJs = require("../../../../../base/common/observableInternal/derived.js");
var _diffEditorSashJs = require("../components/diffEditorSash.js");
var _utilsJs = require("../utils.js");
var _editorGutterJs = require("../utils/editorGutter.js");
var _utilsJs1 = require("../../multiDiffEditor/utils.js");
var _lineRangeJs = require("../../../../common/core/lineRange.js");
var _offsetRangeJs = require("../../../../common/core/offsetRange.js");
var _rangeJs = require("../../../../common/core/range.js");
var _textEditJs = require("../../../../common/core/textEdit.js");
var _rangeMappingJs = require("../../../../common/diff/rangeMapping.js");
var _textModelTextJs = require("../../../../common/model/textModelText.js");
var _toolbarJs = require("../../../../../platform/actions/browser/toolbar.js");
var _actionsJs = require("../../../../../platform/actions/common/actions.js");
var _contextkeyJs = require("../../../../../platform/contextkey/common/contextkey.js");
var _hoverJs = require("../../../../../platform/hover/browser/hover.js");
var _instantiationJs = require("../../../../../platform/instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const emptyArr = [];
const width = 35;
let DiffEditorGutter = class DiffEditorGutter extends (0, _lifecycleJs.Disposable) {
    constructor(diffEditorRoot, _diffModel, _editors, _options, _sashLayout, _boundarySashes, _instantiationService, _contextKeyService, _menuService){
        super();
        this._diffModel = _diffModel;
        this._editors = _editors;
        this._options = _options;
        this._sashLayout = _sashLayout;
        this._boundarySashes = _boundarySashes;
        this._instantiationService = _instantiationService;
        this._contextKeyService = _contextKeyService;
        this._menuService = _menuService;
        this._menu = this._register(this._menuService.createMenu((0, _actionsJs.MenuId).DiffEditorHunkToolbar, this._contextKeyService));
        this._actions = (0, _observableJs.observableFromEvent)(this, this._menu.onDidChange, ()=>this._menu.getActions());
        this._hasActions = this._actions.map((a)=>a.length > 0);
        this._showSash = (0, _observableJs.derived)(this, (reader)=>this._options.renderSideBySide.read(reader) && this._hasActions.read(reader));
        this.width = (0, _observableJs.derived)(this, (reader)=>this._hasActions.read(reader) ? width : 0);
        this.elements = (0, _domJs.h)("div.gutter@gutter", {
            style: {
                position: "absolute",
                height: "100%",
                width: width + "px"
            }
        }, []);
        this._currentDiff = (0, _observableJs.derived)(this, (reader)=>{
            const model = this._diffModel.read(reader);
            if (!model) return undefined;
            const mappings = model.diff.read(reader)?.mappings;
            const cursorPosition = this._editors.modifiedCursor.read(reader);
            if (!cursorPosition) return undefined;
            return mappings?.find((m)=>m.lineRangeMapping.modified.contains(cursorPosition.lineNumber));
        });
        this._selectedDiffs = (0, _observableJs.derived)(this, (reader)=>{
            /** @description selectedDiffs */ const model = this._diffModel.read(reader);
            const diff = model?.diff.read(reader);
            // Return `emptyArr` because it is a constant. [] is always a new array and would trigger a change.
            if (!diff) return emptyArr;
            const selections = this._editors.modifiedSelections.read(reader);
            if (selections.every((s)=>s.isEmpty())) return emptyArr;
            const selectedLineNumbers = new (0, _lineRangeJs.LineRangeSet)(selections.map((s)=>(0, _lineRangeJs.LineRange).fromRangeInclusive(s)));
            const selectedMappings = diff.mappings.filter((m)=>m.lineRangeMapping.innerChanges && selectedLineNumbers.intersects(m.lineRangeMapping.modified));
            const result = selectedMappings.map((mapping)=>({
                    mapping,
                    rangeMappings: mapping.lineRangeMapping.innerChanges.filter((c)=>selections.some((s)=>(0, _rangeJs.Range).areIntersecting(c.modifiedRange, s)))
                }));
            if (result.length === 0 || result.every((r)=>r.rangeMappings.length === 0)) return emptyArr;
            return result;
        });
        this._register((0, _utilsJs.prependRemoveOnDispose)(diffEditorRoot, this.elements.root));
        this._register((0, _domJs.addDisposableListener)(this.elements.root, "click", ()=>{
            this._editors.modified.focus();
        }));
        this._register((0, _utilsJs.applyStyle)(this.elements.root, {
            display: this._hasActions.map((a)=>a ? "block" : "none")
        }));
        (0, _derivedJs.derivedDisposable)(this, (reader)=>{
            const showSash = this._showSash.read(reader);
            return !showSash ? undefined : new (0, _diffEditorSashJs.DiffEditorSash)(diffEditorRoot, this._sashLayout.dimensions, this._options.enableSplitViewResizing, this._boundarySashes, (0, _derivedJs.derivedWithSetter)(this, (reader)=>this._sashLayout.sashLeft.read(reader) - width, (v, tx)=>this._sashLayout.sashLeft.set(v + width, tx)), ()=>this._sashLayout.resetSash());
        }).recomputeInitiallyAndOnChange(this._store);
        this._register(new (0, _editorGutterJs.EditorGutter)(this._editors.modified, this.elements.root, {
            getIntersectingGutterItems: (range, reader)=>{
                const model = this._diffModel.read(reader);
                if (!model) return [];
                const diffs = model.diff.read(reader);
                if (!diffs) return [];
                const selection = this._selectedDiffs.read(reader);
                if (selection.length > 0) {
                    const m = (0, _rangeMappingJs.DetailedLineRangeMapping).fromRangeMappings(selection.flatMap((s)=>s.rangeMappings));
                    return [
                        new DiffGutterItem(m, true, (0, _actionsJs.MenuId).DiffEditorSelectionToolbar, undefined, model.model.original.uri, model.model.modified.uri)
                    ];
                }
                const currentDiff = this._currentDiff.read(reader);
                return diffs.mappings.map((m)=>new DiffGutterItem(m.lineRangeMapping.withInnerChangesFromLineRanges(), m.lineRangeMapping === currentDiff?.lineRangeMapping, (0, _actionsJs.MenuId).DiffEditorHunkToolbar, undefined, model.model.original.uri, model.model.modified.uri));
            },
            createView: (item, target)=>{
                return this._instantiationService.createInstance(DiffToolBar, item, target, this);
            }
        }));
        this._register((0, _domJs.addDisposableListener)(this.elements.gutter, (0, _domJs.EventType).MOUSE_WHEEL, (e)=>{
            if (this._editors.modified.getOption(104 /* EditorOption.scrollbar */ ).handleMouseWheel) this._editors.modified.delegateScrollFromMouseWheelEvent(e);
        }, {
            passive: false
        }));
    }
    computeStagedValue(mapping) {
        const c = mapping.innerChanges ?? [];
        const modified = new (0, _textModelTextJs.TextModelText)(this._editors.modifiedModel.get());
        const original = new (0, _textModelTextJs.TextModelText)(this._editors.original.getModel());
        const edit = new (0, _textEditJs.TextEdit)(c.map((c)=>c.toTextEdit(modified)));
        const value = edit.apply(original);
        return value;
    }
    layout(left) {
        this.elements.gutter.style.left = left + "px";
    }
};
DiffEditorGutter = __decorate([
    __param(6, (0, _instantiationJs.IInstantiationService)),
    __param(7, (0, _contextkeyJs.IContextKeyService)),
    __param(8, (0, _actionsJs.IMenuService))
], DiffEditorGutter);
class DiffGutterItem {
    constructor(mapping, showAlways, menuId, rangeOverride, originalUri, modifiedUri){
        this.mapping = mapping;
        this.showAlways = showAlways;
        this.menuId = menuId;
        this.rangeOverride = rangeOverride;
        this.originalUri = originalUri;
        this.modifiedUri = modifiedUri;
    }
    get id() {
        return this.mapping.modified.toString();
    }
    get range() {
        return this.rangeOverride ?? this.mapping.modified;
    }
}
let DiffToolBar = class DiffToolBar extends (0, _lifecycleJs.Disposable) {
    constructor(_item, target, gutter, instantiationService){
        super();
        this._item = _item;
        this._elements = (0, _domJs.h)("div.gutterItem", {
            style: {
                height: "20px",
                width: "34px"
            }
        }, [
            (0, _domJs.h)("div.background@background", {}, []),
            (0, _domJs.h)("div.buttons@buttons", {}, [])
        ]);
        this._showAlways = this._item.map(this, (item)=>item.showAlways);
        this._menuId = this._item.map(this, (item)=>item.menuId);
        this._isSmall = (0, _observableJs.observableValue)(this, false);
        this._lastItemRange = undefined;
        this._lastViewRange = undefined;
        const hoverDelegate = this._register(instantiationService.createInstance((0, _hoverJs.WorkbenchHoverDelegate), "element", true, {
            position: {
                hoverPosition: 1 /* HoverPosition.RIGHT */ 
            }
        }));
        this._register((0, _utilsJs.appendRemoveOnDispose)(target, this._elements.root));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update showAlways */ const showAlways = this._showAlways.read(reader);
            this._elements.root.classList.toggle("noTransition", true);
            this._elements.root.classList.toggle("showAlways", showAlways);
            setTimeout(()=>{
                this._elements.root.classList.toggle("noTransition", false);
            }, 0);
        }));
        this._register((0, _observableJs.autorunWithStore)((reader, store)=>{
            this._elements.buttons.replaceChildren();
            const i = store.add(instantiationService.createInstance((0, _toolbarJs.MenuWorkbenchToolBar), this._elements.buttons, this._menuId.read(reader), {
                orientation: 1 /* ActionsOrientation.VERTICAL */ ,
                hoverDelegate,
                toolbarOptions: {
                    primaryGroup: (g)=>g.startsWith("primary")
                },
                overflowBehavior: {
                    maxItems: this._isSmall.read(reader) ? 1 : 3
                },
                hiddenItemStrategy: 0 /* HiddenItemStrategy.Ignore */ ,
                actionRunner: new (0, _utilsJs1.ActionRunnerWithContext)(()=>{
                    const item = this._item.get();
                    const mapping = item.mapping;
                    return {
                        mapping,
                        originalWithModifiedChanges: gutter.computeStagedValue(mapping),
                        originalUri: item.originalUri,
                        modifiedUri: item.modifiedUri
                    };
                }),
                menuOptions: {
                    shouldForwardArgs: true
                }
            }));
            store.add(i.onDidChangeMenuItems(()=>{
                if (this._lastItemRange) this.layout(this._lastItemRange, this._lastViewRange);
            }));
        }));
    }
    layout(itemRange, viewRange) {
        this._lastItemRange = itemRange;
        this._lastViewRange = viewRange;
        let itemHeight = this._elements.buttons.clientHeight;
        this._isSmall.set(this._item.get().mapping.original.startLineNumber === 1 && itemRange.length < 30, undefined);
        // Item might have changed
        itemHeight = this._elements.buttons.clientHeight;
        const middleHeight = itemRange.length / 2 - itemHeight / 2;
        const margin = itemHeight;
        let effectiveCheckboxTop = itemRange.start + middleHeight;
        const preferredViewPortRange = (0, _offsetRangeJs.OffsetRange).tryCreate(margin, viewRange.endExclusive - margin - itemHeight);
        const preferredParentRange = (0, _offsetRangeJs.OffsetRange).tryCreate(itemRange.start + margin, itemRange.endExclusive - itemHeight - margin);
        if (preferredParentRange && preferredViewPortRange && preferredParentRange.start < preferredParentRange.endExclusive) {
            effectiveCheckboxTop = preferredViewPortRange.clip(effectiveCheckboxTop);
            effectiveCheckboxTop = preferredParentRange.clip(effectiveCheckboxTop);
        }
        this._elements.buttons.style.top = `${effectiveCheckboxTop - itemRange.start}px`;
    }
};
DiffToolBar = __decorate([
    __param(3, (0, _instantiationJs.IInstantiationService))
], DiffToolBar);

},{"../../../../../base/browser/dom.js":"bnqsM","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../../base/common/observableInternal/derived.js":"hZb5S","../components/diffEditorSash.js":"8adBv","../utils.js":"2G3Lp","../utils/editorGutter.js":"aJ7Ao","../../multiDiffEditor/utils.js":"EdYae","../../../../common/core/lineRange.js":"cmnMs","../../../../common/core/offsetRange.js":"ifHXk","../../../../common/core/range.js":"jmUPh","../../../../common/core/textEdit.js":"hdqra","../../../../common/diff/rangeMapping.js":"7QuJJ","../../../../common/model/textModelText.js":"cmnSt","../../../../../platform/actions/browser/toolbar.js":"1ep75","../../../../../platform/actions/common/actions.js":"kyMtp","../../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../../platform/hover/browser/hover.js":"3QGXp","../../../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aJ7Ao":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorGutter", ()=>EditorGutter);
var _domJs = require("../../../../../base/browser/dom.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _lineRangeJs = require("../../../../common/core/lineRange.js");
var _offsetRangeJs = require("../../../../common/core/offsetRange.js");
class EditorGutter extends (0, _lifecycleJs.Disposable) {
    constructor(_editor, _domNode, itemProvider){
        super();
        this._editor = _editor;
        this._domNode = _domNode;
        this.itemProvider = itemProvider;
        this.scrollTop = (0, _observableJs.observableFromEvent)(this, this._editor.onDidScrollChange, (e)=>/** @description editor.onDidScrollChange */ this._editor.getScrollTop());
        this.isScrollTopZero = this.scrollTop.map((scrollTop)=>/** @description isScrollTopZero */ scrollTop === 0);
        this.modelAttached = (0, _observableJs.observableFromEvent)(this, this._editor.onDidChangeModel, (e)=>/** @description editor.onDidChangeModel */ this._editor.hasModel());
        this.editorOnDidChangeViewZones = (0, _observableJs.observableSignalFromEvent)("onDidChangeViewZones", this._editor.onDidChangeViewZones);
        this.editorOnDidContentSizeChange = (0, _observableJs.observableSignalFromEvent)("onDidContentSizeChange", this._editor.onDidContentSizeChange);
        this.domNodeSizeChanged = (0, _observableJs.observableSignal)("domNodeSizeChanged");
        this.views = new Map();
        this._domNode.className = "gutter monaco-editor";
        const scrollDecoration = this._domNode.appendChild((0, _domJs.h)("div.scroll-decoration", {
            role: "presentation",
            ariaHidden: "true",
            style: {
                width: "100%"
            }
        }).root);
        const o = new ResizeObserver(()=>{
            (0, _observableJs.transaction)((tx)=>{
                /** @description ResizeObserver: size changed */ this.domNodeSizeChanged.trigger(tx);
            });
        });
        o.observe(this._domNode);
        this._register((0, _lifecycleJs.toDisposable)(()=>o.disconnect()));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update scroll decoration */ scrollDecoration.className = this.isScrollTopZero.read(reader) ? "" : "scroll-decoration";
        }));
        this._register((0, _observableJs.autorun)((reader)=>/** @description EditorGutter.Render */ this.render(reader)));
    }
    dispose() {
        super.dispose();
        (0, _domJs.reset)(this._domNode);
    }
    render(reader) {
        if (!this.modelAttached.read(reader)) return;
        this.domNodeSizeChanged.read(reader);
        this.editorOnDidChangeViewZones.read(reader);
        this.editorOnDidContentSizeChange.read(reader);
        const scrollTop = this.scrollTop.read(reader);
        const visibleRanges = this._editor.getVisibleRanges();
        const unusedIds = new Set(this.views.keys());
        const viewRange = (0, _offsetRangeJs.OffsetRange).ofStartAndLength(0, this._domNode.clientHeight);
        if (!viewRange.isEmpty) for (const visibleRange of visibleRanges){
            const visibleRange2 = new (0, _lineRangeJs.LineRange)(visibleRange.startLineNumber, visibleRange.endLineNumber + 1);
            const gutterItems = this.itemProvider.getIntersectingGutterItems(visibleRange2, reader);
            (0, _observableJs.transaction)((tx)=>{
                /** EditorGutter.render */ for (const gutterItem of gutterItems){
                    if (!gutterItem.range.intersect(visibleRange2)) continue;
                    unusedIds.delete(gutterItem.id);
                    let view = this.views.get(gutterItem.id);
                    if (!view) {
                        const viewDomNode = document.createElement("div");
                        this._domNode.appendChild(viewDomNode);
                        const gutterItemObs = (0, _observableJs.observableValue)("item", gutterItem);
                        const itemView = this.itemProvider.createView(gutterItemObs, viewDomNode);
                        view = new ManagedGutterItemView(gutterItemObs, itemView, viewDomNode);
                        this.views.set(gutterItem.id, view);
                    } else view.item.set(gutterItem, tx);
                    const top = gutterItem.range.startLineNumber <= this._editor.getModel().getLineCount() ? this._editor.getTopForLineNumber(gutterItem.range.startLineNumber, true) - scrollTop : this._editor.getBottomForLineNumber(gutterItem.range.startLineNumber - 1, false) - scrollTop;
                    const bottom = gutterItem.range.endLineNumberExclusive === 1 ? Math.max(top, this._editor.getTopForLineNumber(gutterItem.range.startLineNumber, false) - scrollTop) : Math.max(top, this._editor.getBottomForLineNumber(gutterItem.range.endLineNumberExclusive - 1, true) - scrollTop);
                    const height = bottom - top;
                    view.domNode.style.top = `${top}px`;
                    view.domNode.style.height = `${height}px`;
                    view.gutterItemView.layout((0, _offsetRangeJs.OffsetRange).ofStartAndLength(top, height), viewRange);
                }
            });
        }
        for (const id of unusedIds){
            const view = this.views.get(id);
            view.gutterItemView.dispose();
            view.domNode.remove();
            this.views.delete(id);
        }
    }
}
class ManagedGutterItemView {
    constructor(item, gutterItemView, domNode){
        this.item = item;
        this.gutterItemView = gutterItemView;
        this.domNode = domNode;
    }
}

},{"../../../../../base/browser/dom.js":"bnqsM","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../common/core/lineRange.js":"cmnMs","../../../../common/core/offsetRange.js":"ifHXk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"EdYae":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionRunnerWithContext", ()=>ActionRunnerWithContext);
var _actionsJs = require("../../../../base/common/actions.js");
class ActionRunnerWithContext extends (0, _actionsJs.ActionRunner) {
    constructor(_getContext){
        super();
        this._getContext = _getContext;
    }
    runAction(action, _context) {
        const ctx = this._getContext();
        return super.runAction(action, ctx);
    }
}

},{"../../../../base/common/actions.js":"5GjLb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cmnSt":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextModelText", ()=>TextModelText);
var _textEditJs = require("../core/textEdit.js");
var _textLengthJs = require("../core/textLength.js");
class TextModelText extends (0, _textEditJs.AbstractText) {
    constructor(_textModel){
        super();
        this._textModel = _textModel;
    }
    getValueOfRange(range) {
        return this._textModel.getValueInRange(range);
    }
    get length() {
        const lastLineNumber = this._textModel.getLineCount();
        const lastLineLen = this._textModel.getLineLength(lastLineNumber);
        return new (0, _textLengthJs.TextLength)(lastLineNumber - 1, lastLineLen);
    }
}

},{"../core/textEdit.js":"hdqra","../core/textLength.js":"Lk80L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ep75":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WorkbenchToolBar", ()=>WorkbenchToolBar);
parcelHelpers.export(exports, "MenuWorkbenchToolBar", ()=>MenuWorkbenchToolBar);
var _domJs = require("../../../base/browser/dom.js");
var _mouseEventJs = require("../../../base/browser/mouseEvent.js");
var _toolbarJs = require("../../../base/browser/ui/toolbar/toolbar.js");
var _actionsJs = require("../../../base/common/actions.js");
var _arraysJs = require("../../../base/common/arrays.js");
var _collectionsJs = require("../../../base/common/collections.js");
var _errorsJs = require("../../../base/common/errors.js");
var _eventJs = require("../../../base/common/event.js");
var _iteratorJs = require("../../../base/common/iterator.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _nlsJs = require("../../../nls.js");
var _menuEntryActionViewItemJs = require("./menuEntryActionViewItem.js");
var _actionsJs1 = require("../common/actions.js");
var _menuServiceJs = require("../common/menuService.js");
var _commandsJs = require("../../commands/common/commands.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _contextViewJs = require("../../contextview/browser/contextView.js");
var _keybindingJs = require("../../keybinding/common/keybinding.js");
var _telemetryJs = require("../../telemetry/common/telemetry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
/**
 * The `WorkbenchToolBar` does
 * - support hiding of menu items
 * - lookup keybindings for each actions automatically
 * - send `workbenchActionExecuted`-events for each action
 *
 * See {@link MenuWorkbenchToolBar} for a toolbar that is backed by a menu.
 */ let WorkbenchToolBar = class WorkbenchToolBar extends (0, _toolbarJs.ToolBar) {
    constructor(container, _options, _menuService, _contextKeyService, _contextMenuService, _keybindingService, _commandService, telemetryService){
        super(container, _contextMenuService, {
            // defaults
            getKeyBinding: (action)=>_keybindingService.lookupKeybinding(action.id) ?? undefined,
            // options (override defaults)
            ..._options,
            // mandatory (overide options)
            allowContextMenu: true,
            skipTelemetry: typeof _options?.telemetrySource === "string"
        });
        this._options = _options;
        this._menuService = _menuService;
        this._contextKeyService = _contextKeyService;
        this._contextMenuService = _contextMenuService;
        this._keybindingService = _keybindingService;
        this._commandService = _commandService;
        this._sessionDisposables = this._store.add(new (0, _lifecycleJs.DisposableStore)());
        // telemetry logic
        const telemetrySource = _options?.telemetrySource;
        if (telemetrySource) this._store.add(this.actionBar.onDidRun((e)=>telemetryService.publicLog2("workbenchActionExecuted", {
                id: e.action.id,
                from: telemetrySource
            })));
    }
    setActions(_primary, _secondary = [], menuIds) {
        this._sessionDisposables.clear();
        const primary = _primary.slice(); // for hiding and overflow we set some items to undefined
        const secondary = _secondary.slice();
        const toggleActions = [];
        let toggleActionsCheckedCount = 0;
        const extraSecondary = [];
        let someAreHidden = false;
        // unless disabled, move all hidden items to secondary group or ignore them
        if (this._options?.hiddenItemStrategy !== -1 /* HiddenItemStrategy.NoHide */ ) for(let i = 0; i < primary.length; i++){
            const action = primary[i];
            if (!(action instanceof (0, _actionsJs1.MenuItemAction)) && !(action instanceof (0, _actionsJs1.SubmenuItemAction))) continue;
            if (!action.hideActions) continue;
            // collect all toggle actions
            toggleActions.push(action.hideActions.toggle);
            if (action.hideActions.toggle.checked) toggleActionsCheckedCount++;
            // hidden items move into overflow or ignore
            if (action.hideActions.isHidden) {
                someAreHidden = true;
                primary[i] = undefined;
                if (this._options?.hiddenItemStrategy !== 0 /* HiddenItemStrategy.Ignore */ ) extraSecondary[i] = action;
            }
        }
        // count for max
        if (this._options?.overflowBehavior !== undefined) {
            const exemptedIds = (0, _collectionsJs.intersection)(new Set(this._options.overflowBehavior.exempted), (0, _iteratorJs.Iterable).map(primary, (a)=>a?.id));
            const maxItems = this._options.overflowBehavior.maxItems - exemptedIds.size;
            let count = 0;
            for(let i = 0; i < primary.length; i++){
                const action = primary[i];
                if (!action) continue;
                count++;
                if (exemptedIds.has(action.id)) continue;
                if (count >= maxItems) {
                    primary[i] = undefined;
                    extraSecondary[i] = action;
                }
            }
        }
        // coalesce turns Array<IAction|undefined> into IAction[]
        (0, _arraysJs.coalesceInPlace)(primary);
        (0, _arraysJs.coalesceInPlace)(extraSecondary);
        super.setActions(primary, (0, _actionsJs.Separator).join(extraSecondary, secondary));
        // add context menu for toggle and configure keybinding actions
        if (toggleActions.length > 0 || primary.length > 0) this._sessionDisposables.add((0, _domJs.addDisposableListener)(this.getElement(), "contextmenu", (e)=>{
            const event = new (0, _mouseEventJs.StandardMouseEvent)((0, _domJs.getWindow)(this.getElement()), e);
            const action = this.getItemAction(event.target);
            if (!action) return;
            event.preventDefault();
            event.stopPropagation();
            const primaryActions = [];
            // -- Configure Keybinding Action --
            if (action instanceof (0, _actionsJs1.MenuItemAction) && action.menuKeybinding) primaryActions.push(action.menuKeybinding);
            else if (!(action instanceof (0, _actionsJs1.SubmenuItemAction) || action instanceof (0, _toolbarJs.ToggleMenuAction))) {
                // only enable the configure keybinding action for actions that support keybindings
                const supportsKeybindings = !!this._keybindingService.lookupKeybinding(action.id);
                primaryActions.push((0, _menuServiceJs.createConfigureKeybindingAction)(this._commandService, this._keybindingService, action.id, undefined, supportsKeybindings));
            }
            // -- Hide Actions --
            if (toggleActions.length > 0) {
                let noHide = false;
                // last item cannot be hidden when using ignore strategy
                if (toggleActionsCheckedCount === 1 && this._options?.hiddenItemStrategy === 0 /* HiddenItemStrategy.Ignore */ ) {
                    noHide = true;
                    for(let i = 0; i < toggleActions.length; i++)if (toggleActions[i].checked) {
                        toggleActions[i] = (0, _actionsJs.toAction)({
                            id: action.id,
                            label: action.label,
                            checked: true,
                            enabled: false,
                            run () {}
                        });
                        break; // there is only one
                    }
                }
                // add "hide foo" actions
                if (!noHide && (action instanceof (0, _actionsJs1.MenuItemAction) || action instanceof (0, _actionsJs1.SubmenuItemAction))) {
                    if (!action.hideActions) // no context menu for MenuItemAction instances that support no hiding
                    // those are fake actions and need to be cleaned up
                    return;
                    primaryActions.push(action.hideActions.hide);
                } else primaryActions.push((0, _actionsJs.toAction)({
                    id: "label",
                    label: (0, _nlsJs.localize)("hide", "Hide"),
                    enabled: false,
                    run () {}
                }));
            }
            const actions = (0, _actionsJs.Separator).join(primaryActions, toggleActions);
            // add "Reset Menu" action
            if (this._options?.resetMenu && !menuIds) menuIds = [
                this._options.resetMenu
            ];
            if (someAreHidden && menuIds) {
                actions.push(new (0, _actionsJs.Separator)());
                actions.push((0, _actionsJs.toAction)({
                    id: "resetThisMenu",
                    label: (0, _nlsJs.localize)("resetThisMenu", "Reset Menu"),
                    run: ()=>this._menuService.resetHiddenStates(menuIds)
                }));
            }
            if (actions.length === 0) return;
            this._contextMenuService.showContextMenu({
                getAnchor: ()=>event,
                getActions: ()=>actions,
                // add context menu actions (iff appicable)
                menuId: this._options?.contextMenu,
                menuActionOptions: {
                    renderShortTitle: true,
                    ...this._options?.menuOptions
                },
                skipTelemetry: typeof this._options?.telemetrySource === "string",
                contextKeyService: this._contextKeyService
            });
        }));
    }
};
WorkbenchToolBar = __decorate([
    __param(2, (0, _actionsJs1.IMenuService)),
    __param(3, (0, _contextkeyJs.IContextKeyService)),
    __param(4, (0, _contextViewJs.IContextMenuService)),
    __param(5, (0, _keybindingJs.IKeybindingService)),
    __param(6, (0, _commandsJs.ICommandService)),
    __param(7, (0, _telemetryJs.ITelemetryService))
], WorkbenchToolBar);
/**
 * A {@link WorkbenchToolBar workbench toolbar} that is purely driven from a {@link MenuId menu}-identifier.
 *
 * *Note* that Manual updates via `setActions` are NOT supported.
 */ let MenuWorkbenchToolBar = class MenuWorkbenchToolBar extends WorkbenchToolBar {
    constructor(container, menuId, options, menuService, contextKeyService, contextMenuService, keybindingService, commandService, telemetryService){
        super(container, {
            resetMenu: menuId,
            ...options
        }, menuService, contextKeyService, contextMenuService, keybindingService, commandService, telemetryService);
        this._onDidChangeMenuItems = this._store.add(new (0, _eventJs.Emitter)());
        this.onDidChangeMenuItems = this._onDidChangeMenuItems.event;
        // update logic
        const menu = this._store.add(menuService.createMenu(menuId, contextKeyService, {
            emitEventsForSubmenuChanges: true
        }));
        const updateToolbar = ()=>{
            const primary = [];
            const secondary = [];
            (0, _menuEntryActionViewItemJs.createAndFillInActionBarActions)(menu, options?.menuOptions, {
                primary,
                secondary
            }, options?.toolbarOptions?.primaryGroup, options?.toolbarOptions?.shouldInlineSubmenu, options?.toolbarOptions?.useSeparatorsInPrimaryActions);
            container.classList.toggle("has-no-actions", primary.length === 0 && secondary.length === 0);
            super.setActions(primary, secondary);
        };
        this._store.add(menu.onDidChange(()=>{
            updateToolbar();
            this._onDidChangeMenuItems.fire(this);
        }));
        updateToolbar();
    }
    /**
     * @deprecated The WorkbenchToolBar does not support this method because it works with menus.
     */ setActions() {
        throw new (0, _errorsJs.BugIndicatingError)("This toolbar is populated from a menu.");
    }
};
MenuWorkbenchToolBar = __decorate([
    __param(3, (0, _actionsJs1.IMenuService)),
    __param(4, (0, _contextkeyJs.IContextKeyService)),
    __param(5, (0, _contextViewJs.IContextMenuService)),
    __param(6, (0, _keybindingJs.IKeybindingService)),
    __param(7, (0, _commandsJs.ICommandService)),
    __param(8, (0, _telemetryJs.ITelemetryService))
], MenuWorkbenchToolBar);

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/mouseEvent.js":"4jTdu","../../../base/browser/ui/toolbar/toolbar.js":"fhxhZ","../../../base/common/actions.js":"5GjLb","../../../base/common/arrays.js":"DECei","../../../base/common/collections.js":"6NI7k","../../../base/common/errors.js":"divX8","../../../base/common/event.js":"4Zi8b","../../../base/common/iterator.js":"2FiS0","../../../base/common/lifecycle.js":"9kg8d","../../../nls.js":"l617d","./menuEntryActionViewItem.js":"evssn","../common/actions.js":"kyMtp","../common/menuService.js":"6ihaN","../../commands/common/commands.js":"ho6ic","../../contextkey/common/contextkey.js":"gXuBD","../../contextview/browser/contextView.js":"2QlUR","../../keybinding/common/keybinding.js":"25pLT","../../telemetry/common/telemetry.js":"7vW8j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fhxhZ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A widget that combines an action bar for primary actions and a dropdown for secondary actions.
 */ parcelHelpers.export(exports, "ToolBar", ()=>ToolBar);
parcelHelpers.export(exports, "ToggleMenuAction", ()=>ToggleMenuAction);
var _actionbarJs = require("../actionbar/actionbar.js");
var _dropdownActionViewItemJs = require("../dropdown/dropdownActionViewItem.js");
var _actionsJs = require("../../../common/actions.js");
var _codiconsJs = require("../../../common/codicons.js");
var _themablesJs = require("../../../common/themables.js");
var _eventJs = require("../../../common/event.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
var _toolbarCss = require("./toolbar.css");
var _nlsJs = require("../../../../nls.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
class ToolBar extends (0, _lifecycleJs.Disposable) {
    constructor(container, contextMenuProvider, options = {
        orientation: 0 /* ActionsOrientation.HORIZONTAL */ 
    }){
        super();
        this.submenuActionViewItems = [];
        this.hasSecondaryActions = false;
        this._onDidChangeDropdownVisibility = this._register(new (0, _eventJs.EventMultiplexer)());
        this.onDidChangeDropdownVisibility = this._onDidChangeDropdownVisibility.event;
        this.disposables = this._register(new (0, _lifecycleJs.DisposableStore)());
        options.hoverDelegate = options.hoverDelegate ?? this._register((0, _hoverDelegateFactoryJs.createInstantHoverDelegate)());
        this.options = options;
        this.toggleMenuAction = this._register(new ToggleMenuAction(()=>this.toggleMenuActionViewItem?.show(), options.toggleMenuTitle));
        this.element = document.createElement("div");
        this.element.className = "monaco-toolbar";
        container.appendChild(this.element);
        this.actionBar = this._register(new (0, _actionbarJs.ActionBar)(this.element, {
            orientation: options.orientation,
            ariaLabel: options.ariaLabel,
            actionRunner: options.actionRunner,
            allowContextMenu: options.allowContextMenu,
            highlightToggledItems: options.highlightToggledItems,
            hoverDelegate: options.hoverDelegate,
            actionViewItemProvider: (action, viewItemOptions)=>{
                if (action.id === ToggleMenuAction.ID) {
                    this.toggleMenuActionViewItem = new (0, _dropdownActionViewItemJs.DropdownMenuActionViewItem)(action, action.menuActions, contextMenuProvider, {
                        actionViewItemProvider: this.options.actionViewItemProvider,
                        actionRunner: this.actionRunner,
                        keybindingProvider: this.options.getKeyBinding,
                        classNames: (0, _themablesJs.ThemeIcon).asClassNameArray(options.moreIcon ?? (0, _codiconsJs.Codicon).toolBarMore),
                        anchorAlignmentProvider: this.options.anchorAlignmentProvider,
                        menuAsChild: !!this.options.renderDropdownAsChildElement,
                        skipTelemetry: this.options.skipTelemetry,
                        isMenu: true,
                        hoverDelegate: this.options.hoverDelegate
                    });
                    this.toggleMenuActionViewItem.setActionContext(this.actionBar.context);
                    this.disposables.add(this._onDidChangeDropdownVisibility.add(this.toggleMenuActionViewItem.onDidChangeVisibility));
                    return this.toggleMenuActionViewItem;
                }
                if (options.actionViewItemProvider) {
                    const result = options.actionViewItemProvider(action, viewItemOptions);
                    if (result) return result;
                }
                if (action instanceof (0, _actionsJs.SubmenuAction)) {
                    const result = new (0, _dropdownActionViewItemJs.DropdownMenuActionViewItem)(action, action.actions, contextMenuProvider, {
                        actionViewItemProvider: this.options.actionViewItemProvider,
                        actionRunner: this.actionRunner,
                        keybindingProvider: this.options.getKeyBinding,
                        classNames: action.class,
                        anchorAlignmentProvider: this.options.anchorAlignmentProvider,
                        menuAsChild: !!this.options.renderDropdownAsChildElement,
                        skipTelemetry: this.options.skipTelemetry,
                        hoverDelegate: this.options.hoverDelegate
                    });
                    result.setActionContext(this.actionBar.context);
                    this.submenuActionViewItems.push(result);
                    this.disposables.add(this._onDidChangeDropdownVisibility.add(result.onDidChangeVisibility));
                    return result;
                }
                return undefined;
            }
        }));
    }
    set actionRunner(actionRunner) {
        this.actionBar.actionRunner = actionRunner;
    }
    get actionRunner() {
        return this.actionBar.actionRunner;
    }
    getElement() {
        return this.element;
    }
    getItemAction(indexOrElement) {
        return this.actionBar.getAction(indexOrElement);
    }
    setActions(primaryActions, secondaryActions) {
        this.clear();
        const primaryActionsToSet = primaryActions ? primaryActions.slice(0) : [];
        // Inject additional action to open secondary actions if present
        this.hasSecondaryActions = !!(secondaryActions && secondaryActions.length > 0);
        if (this.hasSecondaryActions && secondaryActions) {
            this.toggleMenuAction.menuActions = secondaryActions.slice(0);
            primaryActionsToSet.push(this.toggleMenuAction);
        }
        primaryActionsToSet.forEach((action)=>{
            this.actionBar.push(action, {
                icon: this.options.icon ?? true,
                label: this.options.label ?? false,
                keybinding: this.getKeybindingLabel(action)
            });
        });
    }
    getKeybindingLabel(action) {
        const key = this.options.getKeyBinding?.(action);
        return key?.getLabel() ?? undefined;
    }
    clear() {
        this.submenuActionViewItems = [];
        this.disposables.clear();
        this.actionBar.clear();
    }
    dispose() {
        this.clear();
        this.disposables.dispose();
        super.dispose();
    }
}
class ToggleMenuAction extends (0, _actionsJs.Action) {
    static{
        this.ID = "toolbar.toggle.more";
    }
    constructor(toggleDropdownMenu, title){
        title = title || _nlsJs.localize("moreActions", "More Actions...");
        super(ToggleMenuAction.ID, title, undefined, true);
        this._menuActions = [];
        this.toggleDropdownMenu = toggleDropdownMenu;
    }
    async run() {
        this.toggleDropdownMenu();
    }
    get menuActions() {
        return this._menuActions;
    }
    set menuActions(actions) {
        this._menuActions = actions;
    }
}

},{"../actionbar/actionbar.js":"5Xmba","../dropdown/dropdownActionViewItem.js":"k8InY","../../../common/actions.js":"5GjLb","../../../common/codicons.js":"hWYNf","../../../common/themables.js":"hgyHi","../../../common/event.js":"4Zi8b","../../../common/lifecycle.js":"9kg8d","./toolbar.css":"ec2Nj","../../../../nls.js":"l617d","../hover/hoverDelegateFactory.js":"kll4h","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ec2Nj":[function() {},{}],"97RPC":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HideUnchangedRegionsFeature", ()=>HideUnchangedRegionsFeature);
var _domJs = require("../../../../../base/browser/dom.js");
var _iconLabelsJs = require("../../../../../base/browser/ui/iconLabel/iconLabels.js");
var _codiconsJs = require("../../../../../base/common/codicons.js");
var _htmlContentJs = require("../../../../../base/common/htmlContent.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _derivedJs = require("../../../../../base/common/observableInternal/derived.js");
var _themablesJs = require("../../../../../base/common/themables.js");
var _typesJs = require("../../../../../base/common/types.js");
var _observableCodeEditorJs = require("../../../observableCodeEditor.js");
var _utilsJs = require("../utils.js");
var _lineRangeJs = require("../../../../common/core/lineRange.js");
var _positionJs = require("../../../../common/core/position.js");
var _rangeJs = require("../../../../common/core/range.js");
var _languagesJs = require("../../../../common/languages.js");
var _nlsJs = require("../../../../../nls.js");
var _instantiationJs = require("../../../../../platform/instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var HideUnchangedRegionsFeature_1;
/**
 * Make sure to add the view zones to the editor!
 */ let HideUnchangedRegionsFeature = class HideUnchangedRegionsFeature extends (0, _lifecycleJs.Disposable) {
    static{
        HideUnchangedRegionsFeature_1 = this;
    }
    static{
        this._breadcrumbsSourceFactory = (0, _observableJs.observableValue)(HideUnchangedRegionsFeature_1, ()=>({
                dispose () {},
                getBreadcrumbItems (startRange, reader) {
                    return [];
                }
            }));
    }
    static setBreadcrumbsSourceFactory(factory) {
        this._breadcrumbsSourceFactory.set(factory, undefined);
    }
    get isUpdatingHiddenAreas() {
        return this._isUpdatingHiddenAreas;
    }
    constructor(_editors, _diffModel, _options, _instantiationService){
        super();
        this._editors = _editors;
        this._diffModel = _diffModel;
        this._options = _options;
        this._instantiationService = _instantiationService;
        this._modifiedOutlineSource = (0, _derivedJs.derivedDisposable)(this, (reader)=>{
            const m = this._editors.modifiedModel.read(reader);
            const factory = HideUnchangedRegionsFeature_1._breadcrumbsSourceFactory.read(reader);
            return !m || !factory ? undefined : factory(m, this._instantiationService);
        });
        this._isUpdatingHiddenAreas = false;
        this._register(this._editors.original.onDidChangeCursorPosition((e)=>{
            if (e.reason === 1 /* CursorChangeReason.ContentFlush */ ) return;
            const m = this._diffModel.get();
            (0, _observableJs.transaction)((tx)=>{
                for (const s of this._editors.original.getSelections() || []){
                    m?.ensureOriginalLineIsVisible(s.getStartPosition().lineNumber, 0 /* RevealPreference.FromCloserSide */ , tx);
                    m?.ensureOriginalLineIsVisible(s.getEndPosition().lineNumber, 0 /* RevealPreference.FromCloserSide */ , tx);
                }
            });
        }));
        this._register(this._editors.modified.onDidChangeCursorPosition((e)=>{
            if (e.reason === 1 /* CursorChangeReason.ContentFlush */ ) return;
            const m = this._diffModel.get();
            (0, _observableJs.transaction)((tx)=>{
                for (const s of this._editors.modified.getSelections() || []){
                    m?.ensureModifiedLineIsVisible(s.getStartPosition().lineNumber, 0 /* RevealPreference.FromCloserSide */ , tx);
                    m?.ensureModifiedLineIsVisible(s.getEndPosition().lineNumber, 0 /* RevealPreference.FromCloserSide */ , tx);
                }
            });
        }));
        const unchangedRegions = this._diffModel.map((m, reader)=>{
            const regions = m?.unchangedRegions.read(reader) ?? [];
            if (regions.length === 1 && regions[0].modifiedLineNumber === 1 && regions[0].lineCount === this._editors.modifiedModel.read(reader)?.getLineCount()) return [];
            return regions;
        });
        this.viewZones = (0, _observableJs.derivedWithStore)(this, (reader, store)=>{
            /** @description view Zones */ const modifiedOutlineSource = this._modifiedOutlineSource.read(reader);
            if (!modifiedOutlineSource) return {
                origViewZones: [],
                modViewZones: []
            };
            const origViewZones = [];
            const modViewZones = [];
            const sideBySide = this._options.renderSideBySide.read(reader);
            const compactMode = this._options.compactMode.read(reader);
            const curUnchangedRegions = unchangedRegions.read(reader);
            for(let i = 0; i < curUnchangedRegions.length; i++){
                const r = curUnchangedRegions[i];
                if (r.shouldHideControls(reader)) continue;
                if (compactMode && (i === 0 || i === curUnchangedRegions.length - 1)) continue;
                if (compactMode) {
                    {
                        const d = (0, _observableJs.derived)(this, (reader)=>/** @description hiddenOriginalRangeStart */ r.getHiddenOriginalRange(reader).startLineNumber - 1);
                        const origVz = new (0, _utilsJs.PlaceholderViewZone)(d, 12);
                        origViewZones.push(origVz);
                        store.add(new CompactCollapsedCodeOverlayWidget(this._editors.original, origVz, r, !sideBySide));
                    }
                    {
                        const d = (0, _observableJs.derived)(this, (reader)=>/** @description hiddenModifiedRangeStart */ r.getHiddenModifiedRange(reader).startLineNumber - 1);
                        const modViewZone = new (0, _utilsJs.PlaceholderViewZone)(d, 12);
                        modViewZones.push(modViewZone);
                        store.add(new CompactCollapsedCodeOverlayWidget(this._editors.modified, modViewZone, r));
                    }
                } else {
                    {
                        const d = (0, _observableJs.derived)(this, (reader)=>/** @description hiddenOriginalRangeStart */ r.getHiddenOriginalRange(reader).startLineNumber - 1);
                        const origVz = new (0, _utilsJs.PlaceholderViewZone)(d, 24);
                        origViewZones.push(origVz);
                        store.add(new CollapsedCodeOverlayWidget(this._editors.original, origVz, r, r.originalUnchangedRange, !sideBySide, modifiedOutlineSource, (l)=>this._diffModel.get().ensureModifiedLineIsVisible(l, 2 /* RevealPreference.FromBottom */ , undefined), this._options));
                    }
                    {
                        const d = (0, _observableJs.derived)(this, (reader)=>/** @description hiddenModifiedRangeStart */ r.getHiddenModifiedRange(reader).startLineNumber - 1);
                        const modViewZone = new (0, _utilsJs.PlaceholderViewZone)(d, 24);
                        modViewZones.push(modViewZone);
                        store.add(new CollapsedCodeOverlayWidget(this._editors.modified, modViewZone, r, r.modifiedUnchangedRange, false, modifiedOutlineSource, (l)=>this._diffModel.get().ensureModifiedLineIsVisible(l, 2 /* RevealPreference.FromBottom */ , undefined), this._options));
                    }
                }
            }
            return {
                origViewZones,
                modViewZones
            };
        });
        const unchangedLinesDecoration = {
            description: "unchanged lines",
            className: "diff-unchanged-lines",
            isWholeLine: true
        };
        const unchangedLinesDecorationShow = {
            description: "Fold Unchanged",
            glyphMarginHoverMessage: new (0, _htmlContentJs.MarkdownString)(undefined, {
                isTrusted: true,
                supportThemeIcons: true
            }).appendMarkdown((0, _nlsJs.localize)("foldUnchanged", "Fold Unchanged Region")),
            glyphMarginClassName: "fold-unchanged " + (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).fold),
            zIndex: 10001
        };
        this._register((0, _utilsJs.applyObservableDecorations)(this._editors.original, (0, _observableJs.derived)(this, (reader)=>{
            /** @description decorations */ const curUnchangedRegions = unchangedRegions.read(reader);
            const result = curUnchangedRegions.map((r)=>({
                    range: r.originalUnchangedRange.toInclusiveRange(),
                    options: unchangedLinesDecoration
                }));
            for (const r of curUnchangedRegions)if (r.shouldHideControls(reader)) result.push({
                range: (0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(r.originalLineNumber, 1)),
                options: unchangedLinesDecorationShow
            });
            return result;
        })));
        this._register((0, _utilsJs.applyObservableDecorations)(this._editors.modified, (0, _observableJs.derived)(this, (reader)=>{
            /** @description decorations */ const curUnchangedRegions = unchangedRegions.read(reader);
            const result = curUnchangedRegions.map((r)=>({
                    range: r.modifiedUnchangedRange.toInclusiveRange(),
                    options: unchangedLinesDecoration
                }));
            for (const r of curUnchangedRegions)if (r.shouldHideControls(reader)) result.push({
                range: (0, _lineRangeJs.LineRange).ofLength(r.modifiedLineNumber, 1).toInclusiveRange(),
                options: unchangedLinesDecorationShow
            });
            return result;
        })));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update folded unchanged regions */ const curUnchangedRegions = unchangedRegions.read(reader);
            this._isUpdatingHiddenAreas = true;
            try {
                this._editors.original.setHiddenAreas(curUnchangedRegions.map((r)=>r.getHiddenOriginalRange(reader).toInclusiveRange()).filter((0, _typesJs.isDefined)));
                this._editors.modified.setHiddenAreas(curUnchangedRegions.map((r)=>r.getHiddenModifiedRange(reader).toInclusiveRange()).filter((0, _typesJs.isDefined)));
            } finally{
                this._isUpdatingHiddenAreas = false;
            }
        }));
        this._register(this._editors.modified.onMouseUp((event)=>{
            if (!event.event.rightButton && event.target.position && event.target.element?.className.includes("fold-unchanged")) {
                const lineNumber = event.target.position.lineNumber;
                const model = this._diffModel.get();
                if (!model) return;
                const region = model.unchangedRegions.get().find((r)=>r.modifiedUnchangedRange.includes(lineNumber));
                if (!region) return;
                region.collapseAll(undefined);
                event.event.stopPropagation();
                event.event.preventDefault();
            }
        }));
        this._register(this._editors.original.onMouseUp((event)=>{
            if (!event.event.rightButton && event.target.position && event.target.element?.className.includes("fold-unchanged")) {
                const lineNumber = event.target.position.lineNumber;
                const model = this._diffModel.get();
                if (!model) return;
                const region = model.unchangedRegions.get().find((r)=>r.originalUnchangedRange.includes(lineNumber));
                if (!region) return;
                region.collapseAll(undefined);
                event.event.stopPropagation();
                event.event.preventDefault();
            }
        }));
    }
};
HideUnchangedRegionsFeature = HideUnchangedRegionsFeature_1 = __decorate([
    __param(3, (0, _instantiationJs.IInstantiationService))
], HideUnchangedRegionsFeature);
class CompactCollapsedCodeOverlayWidget extends (0, _utilsJs.ViewZoneOverlayWidget) {
    constructor(editor, _viewZone, _unchangedRegion, _hide = false){
        const root = (0, _domJs.h)("div.diff-hidden-lines-widget");
        super(editor, _viewZone, root.root);
        this._unchangedRegion = _unchangedRegion;
        this._hide = _hide;
        this._nodes = (0, _domJs.h)("div.diff-hidden-lines-compact", [
            (0, _domJs.h)("div.line-left", []),
            (0, _domJs.h)("div.text@text", []),
            (0, _domJs.h)("div.line-right", [])
        ]);
        root.root.appendChild(this._nodes.root);
        if (this._hide) this._nodes.root.replaceChildren();
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update labels */ if (!this._hide) {
                const lineCount = this._unchangedRegion.getHiddenModifiedRange(reader).length;
                const linesHiddenText = (0, _nlsJs.localize)("hiddenLines", "{0} hidden lines", lineCount);
                this._nodes.text.innerText = linesHiddenText;
            }
        }));
    }
}
class CollapsedCodeOverlayWidget extends (0, _utilsJs.ViewZoneOverlayWidget) {
    constructor(_editor, _viewZone, _unchangedRegion, _unchangedRegionRange, _hide, _modifiedOutlineSource, _revealModifiedHiddenLine, _options){
        const root = (0, _domJs.h)("div.diff-hidden-lines-widget");
        super(_editor, _viewZone, root.root);
        this._editor = _editor;
        this._unchangedRegion = _unchangedRegion;
        this._unchangedRegionRange = _unchangedRegionRange;
        this._hide = _hide;
        this._modifiedOutlineSource = _modifiedOutlineSource;
        this._revealModifiedHiddenLine = _revealModifiedHiddenLine;
        this._options = _options;
        this._nodes = (0, _domJs.h)("div.diff-hidden-lines", [
            (0, _domJs.h)("div.top@top", {
                title: (0, _nlsJs.localize)("diff.hiddenLines.top", "Click or drag to show more above")
            }),
            (0, _domJs.h)("div.center@content", {
                style: {
                    display: "flex"
                }
            }, [
                (0, _domJs.h)("div@first", {
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexShrink: "0"
                    }
                }, [
                    (0, _domJs.$)("a", {
                        title: (0, _nlsJs.localize)("showUnchangedRegion", "Show Unchanged Region"),
                        role: "button",
                        onclick: ()=>{
                            this._unchangedRegion.showAll(undefined);
                        }
                    }, ...(0, _iconLabelsJs.renderLabelWithIcons)("$(unfold)"))
                ]),
                (0, _domJs.h)("div@others", {
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }
                })
            ]),
            (0, _domJs.h)("div.bottom@bottom", {
                title: (0, _nlsJs.localize)("diff.bottom", "Click or drag to show more below"),
                role: "button"
            })
        ]);
        root.root.appendChild(this._nodes.root);
        if (!this._hide) this._register((0, _utilsJs.applyStyle)(this._nodes.first, {
            width: (0, _observableCodeEditorJs.observableCodeEditor)(this._editor).layoutInfoContentLeft
        }));
        else (0, _domJs.reset)(this._nodes.first);
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description Update CollapsedCodeOverlayWidget canMove* css classes */ const isFullyRevealed = this._unchangedRegion.visibleLineCountTop.read(reader) + this._unchangedRegion.visibleLineCountBottom.read(reader) === this._unchangedRegion.lineCount;
            this._nodes.bottom.classList.toggle("canMoveTop", !isFullyRevealed);
            this._nodes.bottom.classList.toggle("canMoveBottom", this._unchangedRegion.visibleLineCountBottom.read(reader) > 0);
            this._nodes.top.classList.toggle("canMoveTop", this._unchangedRegion.visibleLineCountTop.read(reader) > 0);
            this._nodes.top.classList.toggle("canMoveBottom", !isFullyRevealed);
            const isDragged = this._unchangedRegion.isDragged.read(reader);
            const domNode = this._editor.getDomNode();
            if (domNode) {
                domNode.classList.toggle("draggingUnchangedRegion", !!isDragged);
                if (isDragged === "top") {
                    domNode.classList.toggle("canMoveTop", this._unchangedRegion.visibleLineCountTop.read(reader) > 0);
                    domNode.classList.toggle("canMoveBottom", !isFullyRevealed);
                } else if (isDragged === "bottom") {
                    domNode.classList.toggle("canMoveTop", !isFullyRevealed);
                    domNode.classList.toggle("canMoveBottom", this._unchangedRegion.visibleLineCountBottom.read(reader) > 0);
                } else {
                    domNode.classList.toggle("canMoveTop", false);
                    domNode.classList.toggle("canMoveBottom", false);
                }
            }
        }));
        const editor = this._editor;
        this._register((0, _domJs.addDisposableListener)(this._nodes.top, "mousedown", (e)=>{
            if (e.button !== 0) return;
            this._nodes.top.classList.toggle("dragging", true);
            this._nodes.root.classList.toggle("dragging", true);
            e.preventDefault();
            const startTop = e.clientY;
            let didMove = false;
            const cur = this._unchangedRegion.visibleLineCountTop.get();
            this._unchangedRegion.isDragged.set("top", undefined);
            const window = (0, _domJs.getWindow)(this._nodes.top);
            const mouseMoveListener = (0, _domJs.addDisposableListener)(window, "mousemove", (e)=>{
                const currentTop = e.clientY;
                const delta = currentTop - startTop;
                didMove = didMove || Math.abs(delta) > 2;
                const lineDelta = Math.round(delta / editor.getOption(67 /* EditorOption.lineHeight */ ));
                const newVal = Math.max(0, Math.min(cur + lineDelta, this._unchangedRegion.getMaxVisibleLineCountTop()));
                this._unchangedRegion.visibleLineCountTop.set(newVal, undefined);
            });
            const mouseUpListener = (0, _domJs.addDisposableListener)(window, "mouseup", (e)=>{
                if (!didMove) this._unchangedRegion.showMoreAbove(this._options.hideUnchangedRegionsRevealLineCount.get(), undefined);
                this._nodes.top.classList.toggle("dragging", false);
                this._nodes.root.classList.toggle("dragging", false);
                this._unchangedRegion.isDragged.set(undefined, undefined);
                mouseMoveListener.dispose();
                mouseUpListener.dispose();
            });
        }));
        this._register((0, _domJs.addDisposableListener)(this._nodes.bottom, "mousedown", (e)=>{
            if (e.button !== 0) return;
            this._nodes.bottom.classList.toggle("dragging", true);
            this._nodes.root.classList.toggle("dragging", true);
            e.preventDefault();
            const startTop = e.clientY;
            let didMove = false;
            const cur = this._unchangedRegion.visibleLineCountBottom.get();
            this._unchangedRegion.isDragged.set("bottom", undefined);
            const window = (0, _domJs.getWindow)(this._nodes.bottom);
            const mouseMoveListener = (0, _domJs.addDisposableListener)(window, "mousemove", (e)=>{
                const currentTop = e.clientY;
                const delta = currentTop - startTop;
                didMove = didMove || Math.abs(delta) > 2;
                const lineDelta = Math.round(delta / editor.getOption(67 /* EditorOption.lineHeight */ ));
                const newVal = Math.max(0, Math.min(cur - lineDelta, this._unchangedRegion.getMaxVisibleLineCountBottom()));
                const top = this._unchangedRegionRange.endLineNumberExclusive > editor.getModel().getLineCount() ? editor.getContentHeight() : editor.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
                this._unchangedRegion.visibleLineCountBottom.set(newVal, undefined);
                const top2 = this._unchangedRegionRange.endLineNumberExclusive > editor.getModel().getLineCount() ? editor.getContentHeight() : editor.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
                editor.setScrollTop(editor.getScrollTop() + (top2 - top));
            });
            const mouseUpListener = (0, _domJs.addDisposableListener)(window, "mouseup", (e)=>{
                this._unchangedRegion.isDragged.set(undefined, undefined);
                if (!didMove) {
                    const top = editor.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
                    this._unchangedRegion.showMoreBelow(this._options.hideUnchangedRegionsRevealLineCount.get(), undefined);
                    const top2 = editor.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
                    editor.setScrollTop(editor.getScrollTop() + (top2 - top));
                }
                this._nodes.bottom.classList.toggle("dragging", false);
                this._nodes.root.classList.toggle("dragging", false);
                mouseMoveListener.dispose();
                mouseUpListener.dispose();
            });
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update labels */ const children = [];
            if (!this._hide) {
                const lineCount = _unchangedRegion.getHiddenModifiedRange(reader).length;
                const linesHiddenText = (0, _nlsJs.localize)("hiddenLines", "{0} hidden lines", lineCount);
                const span = (0, _domJs.$)("span", {
                    title: (0, _nlsJs.localize)("diff.hiddenLines.expandAll", "Double click to unfold")
                }, linesHiddenText);
                span.addEventListener("dblclick", (e)=>{
                    if (e.button !== 0) return;
                    e.preventDefault();
                    this._unchangedRegion.showAll(undefined);
                });
                children.push(span);
                const range = this._unchangedRegion.getHiddenModifiedRange(reader);
                const items = this._modifiedOutlineSource.getBreadcrumbItems(range, reader);
                if (items.length > 0) {
                    children.push((0, _domJs.$)("span", undefined, "\xa0\xa0|\xa0\xa0"));
                    for(let i = 0; i < items.length; i++){
                        const item = items[i];
                        const icon = (0, _languagesJs.SymbolKinds).toIcon(item.kind);
                        const divItem = (0, _domJs.h)("div.breadcrumb-item", {
                            style: {
                                display: "flex",
                                alignItems: "center"
                            }
                        }, [
                            (0, _iconLabelsJs.renderIcon)(icon),
                            "\xa0",
                            item.name,
                            ...i === items.length - 1 ? [] : [
                                (0, _iconLabelsJs.renderIcon)((0, _codiconsJs.Codicon).chevronRight)
                            ]
                        ]).root;
                        children.push(divItem);
                        divItem.onclick = ()=>{
                            this._revealModifiedHiddenLine(item.startLineNumber);
                        };
                    }
                }
            }
            (0, _domJs.reset)(this._nodes.others, ...children);
        }));
    }
}

},{"../../../../../base/browser/dom.js":"bnqsM","../../../../../base/browser/ui/iconLabel/iconLabels.js":"lXqhk","../../../../../base/common/codicons.js":"hWYNf","../../../../../base/common/htmlContent.js":"3Hxzm","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../../base/common/observableInternal/derived.js":"hZb5S","../../../../../base/common/themables.js":"hgyHi","../../../../../base/common/types.js":"fb5yx","../../../observableCodeEditor.js":"hfBd1","../utils.js":"2G3Lp","../../../../common/core/lineRange.js":"cmnMs","../../../../common/core/position.js":"lvrPe","../../../../common/core/range.js":"jmUPh","../../../../common/languages.js":"g5n96","../../../../../nls.js":"l617d","../../../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hfBd1":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a facade for the code editor that provides observables for various states/events.
*/ parcelHelpers.export(exports, "observableCodeEditor", ()=>observableCodeEditor);
parcelHelpers.export(exports, "ObservableCodeEditor", ()=>ObservableCodeEditor);
parcelHelpers.export(exports, "reactToChange", ()=>reactToChange);
parcelHelpers.export(exports, "reactToChangeWithStore", ()=>reactToChangeWithStore);
var _equalsJs = require("../../base/common/equals.js");
var _lifecycleJs = require("../../base/common/lifecycle.js");
var _observableJs = require("../../base/common/observable.js");
var _baseJs = require("../../base/common/observableInternal/base.js");
var _derivedJs = require("../../base/common/observableInternal/derived.js");
var _selectionJs = require("../common/core/selection.js");
function observableCodeEditor(editor) {
    return ObservableCodeEditor.get(editor);
}
class ObservableCodeEditor extends (0, _lifecycleJs.Disposable) {
    static{
        this._map = new Map();
    }
    /**
     * Make sure that editor is not disposed yet!
    */ static get(editor) {
        let result = ObservableCodeEditor._map.get(editor);
        if (!result) {
            result = new ObservableCodeEditor(editor);
            ObservableCodeEditor._map.set(editor, result);
            const d = editor.onDidDispose(()=>{
                const item = ObservableCodeEditor._map.get(editor);
                if (item) {
                    ObservableCodeEditor._map.delete(editor);
                    item.dispose();
                    d.dispose();
                }
            });
        }
        return result;
    }
    _beginUpdate() {
        this._updateCounter++;
        if (this._updateCounter === 1) this._currentTransaction = new (0, _baseJs.TransactionImpl)(()=>{
        /** @description Update editor state */ });
    }
    _endUpdate() {
        this._updateCounter--;
        if (this._updateCounter === 0) {
            const t = this._currentTransaction;
            this._currentTransaction = undefined;
            t.finish();
        }
    }
    constructor(editor){
        super();
        this.editor = editor;
        this._updateCounter = 0;
        this._currentTransaction = undefined;
        this._model = (0, _observableJs.observableValue)(this, this.editor.getModel());
        this.model = this._model;
        this.isReadonly = (0, _observableJs.observableFromEvent)(this, this.editor.onDidChangeConfiguration, ()=>this.editor.getOption(92 /* EditorOption.readOnly */ ));
        this._versionId = (0, _observableJs.observableValueOpts)({
            owner: this,
            lazy: true
        }, this.editor.getModel()?.getVersionId() ?? null);
        this.versionId = this._versionId;
        this._selections = (0, _observableJs.observableValueOpts)({
            owner: this,
            equalsFn: (0, _equalsJs.equalsIfDefined)((0, _equalsJs.itemsEquals)((0, _selectionJs.Selection).selectionsEqual)),
            lazy: true
        }, this.editor.getSelections() ?? null);
        this.selections = this._selections;
        this.isFocused = (0, _observableJs.observableFromEvent)(this, (e)=>{
            const d1 = this.editor.onDidFocusEditorWidget(e);
            const d2 = this.editor.onDidBlurEditorWidget(e);
            return {
                dispose () {
                    d1.dispose();
                    d2.dispose();
                }
            };
        }, ()=>this.editor.hasWidgetFocus());
        this.value = (0, _derivedJs.derivedWithSetter)(this, (reader)=>{
            this.versionId.read(reader);
            return this.model.read(reader)?.getValue() ?? "";
        }, (value, tx)=>{
            const model = this.model.get();
            if (model !== null) {
                if (value !== model.getValue()) model.setValue(value);
            }
        });
        this.valueIsEmpty = (0, _observableJs.derived)(this, (reader)=>{
            this.versionId.read(reader);
            return this.editor.getModel()?.getValueLength() === 0;
        });
        this.cursorSelection = (0, _observableJs.derivedOpts)({
            owner: this,
            equalsFn: (0, _equalsJs.equalsIfDefined)((0, _selectionJs.Selection).selectionsEqual)
        }, (reader)=>this.selections.read(reader)?.[0] ?? null);
        this.onDidType = (0, _observableJs.observableSignal)(this);
        this.scrollTop = (0, _observableJs.observableFromEvent)(this.editor.onDidScrollChange, ()=>this.editor.getScrollTop());
        this.scrollLeft = (0, _observableJs.observableFromEvent)(this.editor.onDidScrollChange, ()=>this.editor.getScrollLeft());
        this.layoutInfo = (0, _observableJs.observableFromEvent)(this.editor.onDidLayoutChange, ()=>this.editor.getLayoutInfo());
        this.layoutInfoContentLeft = this.layoutInfo.map((l)=>l.contentLeft);
        this.layoutInfoDecorationsLeft = this.layoutInfo.map((l)=>l.decorationsLeft);
        this.contentWidth = (0, _observableJs.observableFromEvent)(this.editor.onDidContentSizeChange, ()=>this.editor.getContentWidth());
        this._overlayWidgetCounter = 0;
        this._register(this.editor.onBeginUpdate(()=>this._beginUpdate()));
        this._register(this.editor.onEndUpdate(()=>this._endUpdate()));
        this._register(this.editor.onDidChangeModel(()=>{
            this._beginUpdate();
            try {
                this._model.set(this.editor.getModel(), this._currentTransaction);
                this._forceUpdate();
            } finally{
                this._endUpdate();
            }
        }));
        this._register(this.editor.onDidType((e)=>{
            this._beginUpdate();
            try {
                this._forceUpdate();
                this.onDidType.trigger(this._currentTransaction, e);
            } finally{
                this._endUpdate();
            }
        }));
        this._register(this.editor.onDidChangeModelContent((e)=>{
            this._beginUpdate();
            try {
                this._versionId.set(this.editor.getModel()?.getVersionId() ?? null, this._currentTransaction, e);
                this._forceUpdate();
            } finally{
                this._endUpdate();
            }
        }));
        this._register(this.editor.onDidChangeCursorSelection((e)=>{
            this._beginUpdate();
            try {
                this._selections.set(this.editor.getSelections(), this._currentTransaction, e);
                this._forceUpdate();
            } finally{
                this._endUpdate();
            }
        }));
    }
    forceUpdate(cb) {
        this._beginUpdate();
        try {
            this._forceUpdate();
            if (!cb) return undefined;
            return cb(this._currentTransaction);
        } finally{
            this._endUpdate();
        }
    }
    _forceUpdate() {
        this._beginUpdate();
        try {
            this._model.set(this.editor.getModel(), this._currentTransaction);
            this._versionId.set(this.editor.getModel()?.getVersionId() ?? null, this._currentTransaction, undefined);
            this._selections.set(this.editor.getSelections(), this._currentTransaction, undefined);
        } finally{
            this._endUpdate();
        }
    }
    getOption(id) {
        return (0, _observableJs.observableFromEvent)(this, (cb)=>this.editor.onDidChangeConfiguration((e)=>{
                if (e.hasChanged(id)) cb(undefined);
            }), ()=>this.editor.getOption(id));
    }
    setDecorations(decorations) {
        const d = new (0, _lifecycleJs.DisposableStore)();
        const decorationsCollection = this.editor.createDecorationsCollection();
        d.add((0, _observableJs.autorunOpts)({
            owner: this,
            debugName: ()=>`Apply decorations from ${decorations.debugName}`
        }, (reader)=>{
            const d = decorations.read(reader);
            decorationsCollection.set(d);
        }));
        d.add({
            dispose: ()=>{
                decorationsCollection.clear();
            }
        });
        return d;
    }
    createOverlayWidget(widget) {
        const overlayWidgetId = "observableOverlayWidget" + this._overlayWidgetCounter++;
        const w = {
            getDomNode: ()=>widget.domNode,
            getPosition: ()=>widget.position.get(),
            getId: ()=>overlayWidgetId,
            allowEditorOverflow: widget.allowEditorOverflow,
            getMinContentWidthInPx: ()=>widget.minContentWidthInPx.get()
        };
        this.editor.addOverlayWidget(w);
        const d = (0, _observableJs.autorun)((reader)=>{
            widget.position.read(reader);
            widget.minContentWidthInPx.read(reader);
            this.editor.layoutOverlayWidget(w);
        });
        return (0, _lifecycleJs.toDisposable)(()=>{
            d.dispose();
            this.editor.removeOverlayWidget(w);
        });
    }
}
function reactToChange(observable, cb) {
    return (0, _observableJs.autorunWithStoreHandleChanges)({
        createEmptyChangeSummary: ()=>({
                deltas: [],
                didChange: false
            }),
        handleChange: (context, changeSummary)=>{
            if (context.didChange(observable)) {
                const e = context.change;
                if (e !== undefined) changeSummary.deltas.push(e);
                changeSummary.didChange = true;
            }
            return true;
        }
    }, (reader, changeSummary)=>{
        const value = observable.read(reader);
        if (changeSummary.didChange) cb(value, changeSummary.deltas);
    });
}
function reactToChangeWithStore(observable, cb) {
    const store = new (0, _lifecycleJs.DisposableStore)();
    const disposable = reactToChange(observable, (value, deltas)=>{
        store.clear();
        cb(value, deltas, store);
    });
    return {
        dispose () {
            disposable.dispose();
            store.dispose();
        }
    };
}

},{"../../base/common/equals.js":"8hes7","../../base/common/lifecycle.js":"9kg8d","../../base/common/observable.js":"2xbG5","../../base/common/observableInternal/base.js":"lYJZ2","../../base/common/observableInternal/derived.js":"hZb5S","../common/core/selection.js":"kcwzU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8bSV4":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverviewRulerFeature", ()=>OverviewRulerFeature);
var _domJs = require("../../../../../base/browser/dom.js");
var _fastDomNodeJs = require("../../../../../base/browser/fastDomNode.js");
var _scrollbarStateJs = require("../../../../../base/browser/ui/scrollbar/scrollbarState.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _utilsJs = require("../utils.js");
var _positionJs = require("../../../../common/core/position.js");
var _overviewZoneManagerJs = require("../../../../common/viewModel/overviewZoneManager.js");
var _colorRegistryJs = require("../../../../../platform/theme/common/colorRegistry.js");
var _themeServiceJs = require("../../../../../platform/theme/common/themeService.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var OverviewRulerFeature_1;
let OverviewRulerFeature = class OverviewRulerFeature extends (0, _lifecycleJs.Disposable) {
    static{
        OverviewRulerFeature_1 = this;
    }
    static{
        this.ONE_OVERVIEW_WIDTH = 15;
    }
    static{
        this.ENTIRE_DIFF_OVERVIEW_WIDTH = this.ONE_OVERVIEW_WIDTH * 2;
    }
    constructor(_editors, _rootElement, _diffModel, _rootWidth, _rootHeight, _modifiedEditorLayoutInfo, _themeService){
        super();
        this._editors = _editors;
        this._rootElement = _rootElement;
        this._diffModel = _diffModel;
        this._rootWidth = _rootWidth;
        this._rootHeight = _rootHeight;
        this._modifiedEditorLayoutInfo = _modifiedEditorLayoutInfo;
        this._themeService = _themeService;
        this.width = OverviewRulerFeature_1.ENTIRE_DIFF_OVERVIEW_WIDTH;
        const currentColorTheme = (0, _observableJs.observableFromEvent)(this._themeService.onDidColorThemeChange, ()=>this._themeService.getColorTheme());
        const currentColors = (0, _observableJs.derived)((reader)=>{
            /** @description colors */ const theme = currentColorTheme.read(reader);
            const insertColor = theme.getColor((0, _colorRegistryJs.diffOverviewRulerInserted)) || (theme.getColor((0, _colorRegistryJs.diffInserted)) || (0, _colorRegistryJs.defaultInsertColor)).transparent(2);
            const removeColor = theme.getColor((0, _colorRegistryJs.diffOverviewRulerRemoved)) || (theme.getColor((0, _colorRegistryJs.diffRemoved)) || (0, _colorRegistryJs.defaultRemoveColor)).transparent(2);
            return {
                insertColor,
                removeColor
            };
        });
        const viewportDomElement = (0, _fastDomNodeJs.createFastDomNode)(document.createElement("div"));
        viewportDomElement.setClassName("diffViewport");
        viewportDomElement.setPosition("absolute");
        const diffOverviewRoot = (0, _domJs.h)("div.diffOverview", {
            style: {
                position: "absolute",
                top: "0px",
                width: OverviewRulerFeature_1.ENTIRE_DIFF_OVERVIEW_WIDTH + "px"
            }
        }).root;
        this._register((0, _utilsJs.appendRemoveOnDispose)(diffOverviewRoot, viewportDomElement.domNode));
        this._register((0, _domJs.addStandardDisposableListener)(diffOverviewRoot, (0, _domJs.EventType).POINTER_DOWN, (e)=>{
            this._editors.modified.delegateVerticalScrollbarPointerDown(e);
        }));
        this._register((0, _domJs.addDisposableListener)(diffOverviewRoot, (0, _domJs.EventType).MOUSE_WHEEL, (e)=>{
            this._editors.modified.delegateScrollFromMouseWheelEvent(e);
        }, {
            passive: false
        }));
        this._register((0, _utilsJs.appendRemoveOnDispose)(this._rootElement, diffOverviewRoot));
        this._register((0, _observableJs.autorunWithStore)((reader, store)=>{
            /** @description recreate overview rules when model changes */ const m = this._diffModel.read(reader);
            const originalOverviewRuler = this._editors.original.createOverviewRuler("original diffOverviewRuler");
            if (originalOverviewRuler) {
                store.add(originalOverviewRuler);
                store.add((0, _utilsJs.appendRemoveOnDispose)(diffOverviewRoot, originalOverviewRuler.getDomNode()));
            }
            const modifiedOverviewRuler = this._editors.modified.createOverviewRuler("modified diffOverviewRuler");
            if (modifiedOverviewRuler) {
                store.add(modifiedOverviewRuler);
                store.add((0, _utilsJs.appendRemoveOnDispose)(diffOverviewRoot, modifiedOverviewRuler.getDomNode()));
            }
            if (!originalOverviewRuler || !modifiedOverviewRuler) // probably no model
            return;
            const origViewZonesChanged = (0, _observableJs.observableSignalFromEvent)("viewZoneChanged", this._editors.original.onDidChangeViewZones);
            const modViewZonesChanged = (0, _observableJs.observableSignalFromEvent)("viewZoneChanged", this._editors.modified.onDidChangeViewZones);
            const origHiddenRangesChanged = (0, _observableJs.observableSignalFromEvent)("hiddenRangesChanged", this._editors.original.onDidChangeHiddenAreas);
            const modHiddenRangesChanged = (0, _observableJs.observableSignalFromEvent)("hiddenRangesChanged", this._editors.modified.onDidChangeHiddenAreas);
            store.add((0, _observableJs.autorun)((reader)=>{
                /** @description set overview ruler zones */ origViewZonesChanged.read(reader);
                modViewZonesChanged.read(reader);
                origHiddenRangesChanged.read(reader);
                modHiddenRangesChanged.read(reader);
                const colors = currentColors.read(reader);
                const diff = m?.diff.read(reader)?.mappings;
                function createZones(ranges, color, editor) {
                    const vm = editor._getViewModel();
                    if (!vm) return [];
                    return ranges.filter((d)=>d.length > 0).map((r)=>{
                        const start = vm.coordinatesConverter.convertModelPositionToViewPosition(new (0, _positionJs.Position)(r.startLineNumber, 1));
                        const end = vm.coordinatesConverter.convertModelPositionToViewPosition(new (0, _positionJs.Position)(r.endLineNumberExclusive, 1));
                        // By computing the lineCount, we won't ask the view model later for the bottom vertical position.
                        // (The view model will take into account the alignment viewzones, which will give
                        // modifications and deletetions always the same height.)
                        const lineCount = end.lineNumber - start.lineNumber;
                        return new (0, _overviewZoneManagerJs.OverviewRulerZone)(start.lineNumber, end.lineNumber, lineCount, color.toString());
                    });
                }
                const originalZones = createZones((diff || []).map((d)=>d.lineRangeMapping.original), colors.removeColor, this._editors.original);
                const modifiedZones = createZones((diff || []).map((d)=>d.lineRangeMapping.modified), colors.insertColor, this._editors.modified);
                originalOverviewRuler?.setZones(originalZones);
                modifiedOverviewRuler?.setZones(modifiedZones);
            }));
            store.add((0, _observableJs.autorun)((reader)=>{
                /** @description layout overview ruler */ const height = this._rootHeight.read(reader);
                const width = this._rootWidth.read(reader);
                const layoutInfo = this._modifiedEditorLayoutInfo.read(reader);
                if (layoutInfo) {
                    const freeSpace = OverviewRulerFeature_1.ENTIRE_DIFF_OVERVIEW_WIDTH - 2 * OverviewRulerFeature_1.ONE_OVERVIEW_WIDTH;
                    originalOverviewRuler.setLayout({
                        top: 0,
                        height: height,
                        right: freeSpace + OverviewRulerFeature_1.ONE_OVERVIEW_WIDTH,
                        width: OverviewRulerFeature_1.ONE_OVERVIEW_WIDTH
                    });
                    modifiedOverviewRuler.setLayout({
                        top: 0,
                        height: height,
                        right: 0,
                        width: OverviewRulerFeature_1.ONE_OVERVIEW_WIDTH
                    });
                    const scrollTop = this._editors.modifiedScrollTop.read(reader);
                    const scrollHeight = this._editors.modifiedScrollHeight.read(reader);
                    const scrollBarOptions = this._editors.modified.getOption(104 /* EditorOption.scrollbar */ );
                    const state = new (0, _scrollbarStateJs.ScrollbarState)(scrollBarOptions.verticalHasArrows ? scrollBarOptions.arrowSize : 0, scrollBarOptions.verticalScrollbarSize, 0, layoutInfo.height, scrollHeight, scrollTop);
                    viewportDomElement.setTop(state.getSliderPosition());
                    viewportDomElement.setHeight(state.getSliderSize());
                } else {
                    viewportDomElement.setTop(0);
                    viewportDomElement.setHeight(0);
                }
                diffOverviewRoot.style.height = height + "px";
                diffOverviewRoot.style.left = width - OverviewRulerFeature_1.ENTIRE_DIFF_OVERVIEW_WIDTH + "px";
                viewportDomElement.setWidth(OverviewRulerFeature_1.ENTIRE_DIFF_OVERVIEW_WIDTH);
            }));
        }));
    }
};
OverviewRulerFeature = OverviewRulerFeature_1 = __decorate([
    __param(6, (0, _themeServiceJs.IThemeService))
], OverviewRulerFeature);

},{"../../../../../base/browser/dom.js":"bnqsM","../../../../../base/browser/fastDomNode.js":"2SADf","../../../../../base/browser/ui/scrollbar/scrollbarState.js":"7f0ty","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../utils.js":"2G3Lp","../../../../common/core/position.js":"lvrPe","../../../../common/viewModel/overviewZoneManager.js":"6o33k","../../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3GH28":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RevertButtonsFeature", ()=>RevertButtonsFeature);
parcelHelpers.export(exports, "RevertButton", ()=>RevertButton);
var _domJs = require("../../../../../base/browser/dom.js");
var _iconLabelsJs = require("../../../../../base/browser/ui/iconLabel/iconLabels.js");
var _codiconsJs = require("../../../../../base/common/codicons.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _lineRangeJs = require("../../../../common/core/lineRange.js");
var _rangeJs = require("../../../../common/core/range.js");
var _rangeMappingJs = require("../../../../common/diff/rangeMapping.js");
var _modelJs = require("../../../../common/model.js");
var _nlsJs = require("../../../../../nls.js");
const emptyArr = [];
class RevertButtonsFeature extends (0, _lifecycleJs.Disposable) {
    constructor(_editors, _diffModel, _options, _widget){
        super();
        this._editors = _editors;
        this._diffModel = _diffModel;
        this._options = _options;
        this._widget = _widget;
        this._selectedDiffs = (0, _observableJs.derived)(this, (reader)=>{
            /** @description selectedDiffs */ const model = this._diffModel.read(reader);
            const diff = model?.diff.read(reader);
            // Return `emptyArr` because it is a constant. [] is always a new array and would trigger a change.
            if (!diff) return emptyArr;
            const selections = this._editors.modifiedSelections.read(reader);
            if (selections.every((s)=>s.isEmpty())) return emptyArr;
            const selectedLineNumbers = new (0, _lineRangeJs.LineRangeSet)(selections.map((s)=>(0, _lineRangeJs.LineRange).fromRangeInclusive(s)));
            const selectedMappings = diff.mappings.filter((m)=>m.lineRangeMapping.innerChanges && selectedLineNumbers.intersects(m.lineRangeMapping.modified));
            const result = selectedMappings.map((mapping)=>({
                    mapping,
                    rangeMappings: mapping.lineRangeMapping.innerChanges.filter((c)=>selections.some((s)=>(0, _rangeJs.Range).areIntersecting(c.modifiedRange, s)))
                }));
            if (result.length === 0 || result.every((r)=>r.rangeMappings.length === 0)) return emptyArr;
            return result;
        });
        this._register((0, _observableJs.autorunWithStore)((reader, store)=>{
            if (!this._options.shouldRenderOldRevertArrows.read(reader)) return;
            const model = this._diffModel.read(reader);
            const diff = model?.diff.read(reader);
            if (!model || !diff) return;
            if (model.movedTextToCompare.read(reader)) return;
            const glyphWidgetsModified = [];
            const selectedDiffs = this._selectedDiffs.read(reader);
            const selectedDiffsSet = new Set(selectedDiffs.map((d)=>d.mapping));
            if (selectedDiffs.length > 0) {
                // The button to revert the selection
                const selections = this._editors.modifiedSelections.read(reader);
                const btn = store.add(new RevertButton(selections[selections.length - 1].positionLineNumber, this._widget, selectedDiffs.flatMap((d)=>d.rangeMappings), true));
                this._editors.modified.addGlyphMarginWidget(btn);
                glyphWidgetsModified.push(btn);
            }
            for (const m of diff.mappings){
                if (selectedDiffsSet.has(m)) continue;
                if (!m.lineRangeMapping.modified.isEmpty && m.lineRangeMapping.innerChanges) {
                    const btn = store.add(new RevertButton(m.lineRangeMapping.modified.startLineNumber, this._widget, m.lineRangeMapping, false));
                    this._editors.modified.addGlyphMarginWidget(btn);
                    glyphWidgetsModified.push(btn);
                }
            }
            store.add((0, _lifecycleJs.toDisposable)(()=>{
                for (const w of glyphWidgetsModified)this._editors.modified.removeGlyphMarginWidget(w);
            }));
        }));
    }
}
class RevertButton extends (0, _lifecycleJs.Disposable) {
    static{
        this.counter = 0;
    }
    getId() {
        return this._id;
    }
    constructor(_lineNumber, _widget, _diffs, _revertSelection){
        super();
        this._lineNumber = _lineNumber;
        this._widget = _widget;
        this._diffs = _diffs;
        this._revertSelection = _revertSelection;
        this._id = `revertButton${RevertButton.counter++}`;
        this._domNode = (0, _domJs.h)("div.revertButton", {
            title: this._revertSelection ? (0, _nlsJs.localize)("revertSelectedChanges", "Revert Selected Changes") : (0, _nlsJs.localize)("revertChange", "Revert Change")
        }, [
            (0, _iconLabelsJs.renderIcon)((0, _codiconsJs.Codicon).arrowRight)
        ]).root;
        this._register((0, _domJs.addDisposableListener)(this._domNode, (0, _domJs.EventType).MOUSE_DOWN, (e)=>{
            // don't prevent context menu from showing up
            if (e.button !== 2) {
                e.stopPropagation();
                e.preventDefault();
            }
        }));
        this._register((0, _domJs.addDisposableListener)(this._domNode, (0, _domJs.EventType).MOUSE_UP, (e)=>{
            e.stopPropagation();
            e.preventDefault();
        }));
        this._register((0, _domJs.addDisposableListener)(this._domNode, (0, _domJs.EventType).CLICK, (e)=>{
            if (this._diffs instanceof (0, _rangeMappingJs.LineRangeMapping)) this._widget.revert(this._diffs);
            else this._widget.revertRangeMappings(this._diffs);
            e.stopPropagation();
            e.preventDefault();
        }));
    }
    /**
     * Get the dom node of the glyph widget.
     */ getDomNode() {
        return this._domNode;
    }
    /**
     * Get the placement of the glyph widget.
     */ getPosition() {
        return {
            lane: (0, _modelJs.GlyphMarginLane).Right,
            range: {
                startColumn: 1,
                startLineNumber: this._lineNumber,
                endColumn: 1,
                endLineNumber: this._lineNumber
            },
            zIndex: 10001
        };
    }
}

},{"../../../../../base/browser/dom.js":"bnqsM","../../../../../base/browser/ui/iconLabel/iconLabels.js":"lXqhk","../../../../../base/common/codicons.js":"hWYNf","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../common/core/lineRange.js":"cmnMs","../../../../common/core/range.js":"jmUPh","../../../../common/diff/rangeMapping.js":"7QuJJ","../../../../common/model.js":"1CSIB","../../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aB9DE":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Creates an observable update when a configuration key updates. */ parcelHelpers.export(exports, "observableConfigValue", ()=>observableConfigValue);
/** Update the configuration key with a value derived from observables. */ parcelHelpers.export(exports, "bindContextKey", ()=>bindContextKey);
var _observableJs = require("../../../base/common/observable.js");
var _utilsJs = require("../../../base/common/observableInternal/utils.js");
function observableConfigValue(key, defaultValue, configurationService) {
    return (0, _utilsJs.observableFromEventOpts)({
        debugName: ()=>`Configuration Key "${key}"`
    }, (handleChange)=>configurationService.onDidChangeConfiguration((e)=>{
            if (e.affectsConfiguration(key)) handleChange(e);
        }), ()=>configurationService.getValue(key) ?? defaultValue);
}
function bindContextKey(key, service, computeValue) {
    const boundKey = key.bindTo(service);
    return (0, _observableJs.autorunOpts)({
        debugName: ()=>`Set Context Key "${key.key}"`
    }, (reader)=>{
        boundKey.set(computeValue(reader));
    });
}

},{"../../../base/common/observable.js":"2xbG5","../../../base/common/observableInternal/utils.js":"4p38u","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i3yc1":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiffEditorEditors", ()=>DiffEditorEditors);
var _eventJs = require("../../../../../base/common/event.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _observableCodeEditorJs = require("../../../observableCodeEditor.js");
var _overviewRulerFeatureJs = require("../features/overviewRulerFeature.js");
var _editorOptionsJs = require("../../../../common/config/editorOptions.js");
var _positionJs = require("../../../../common/core/position.js");
var _nlsJs = require("../../../../../nls.js");
var _instantiationJs = require("../../../../../platform/instantiation/common/instantiation.js");
var _keybindingJs = require("../../../../../platform/keybinding/common/keybinding.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let DiffEditorEditors = class DiffEditorEditors extends (0, _lifecycleJs.Disposable) {
    get onDidContentSizeChange() {
        return this._onDidContentSizeChange.event;
    }
    constructor(originalEditorElement, modifiedEditorElement, _options, _argCodeEditorWidgetOptions, _createInnerEditor, _instantiationService, _keybindingService){
        super();
        this.originalEditorElement = originalEditorElement;
        this.modifiedEditorElement = modifiedEditorElement;
        this._options = _options;
        this._argCodeEditorWidgetOptions = _argCodeEditorWidgetOptions;
        this._createInnerEditor = _createInnerEditor;
        this._instantiationService = _instantiationService;
        this._keybindingService = _keybindingService;
        this.original = this._register(this._createLeftHandSideEditor(this._options.editorOptions.get(), this._argCodeEditorWidgetOptions.originalEditor || {}));
        this.modified = this._register(this._createRightHandSideEditor(this._options.editorOptions.get(), this._argCodeEditorWidgetOptions.modifiedEditor || {}));
        this._onDidContentSizeChange = this._register(new (0, _eventJs.Emitter)());
        this.modifiedScrollTop = (0, _observableJs.observableFromEvent)(this, this.modified.onDidScrollChange, ()=>/** @description modified.getScrollTop */ this.modified.getScrollTop());
        this.modifiedScrollHeight = (0, _observableJs.observableFromEvent)(this, this.modified.onDidScrollChange, ()=>/** @description modified.getScrollHeight */ this.modified.getScrollHeight());
        this.modifiedObs = (0, _observableCodeEditorJs.observableCodeEditor)(this.modified);
        this.originalObs = (0, _observableCodeEditorJs.observableCodeEditor)(this.original);
        this.modifiedModel = this.modifiedObs.model;
        this.modifiedSelections = (0, _observableJs.observableFromEvent)(this, this.modified.onDidChangeCursorSelection, ()=>this.modified.getSelections() ?? []);
        this.modifiedCursor = (0, _observableJs.derivedOpts)({
            owner: this,
            equalsFn: (0, _positionJs.Position).equals
        }, (reader)=>this.modifiedSelections.read(reader)[0]?.getPosition() ?? new (0, _positionJs.Position)(1, 1));
        this.originalCursor = (0, _observableJs.observableFromEvent)(this, this.original.onDidChangeCursorPosition, ()=>this.original.getPosition() ?? new (0, _positionJs.Position)(1, 1));
        this._argCodeEditorWidgetOptions = null;
        this._register((0, _observableJs.autorunHandleChanges)({
            createEmptyChangeSummary: ()=>({}),
            handleChange: (ctx, changeSummary)=>{
                if (ctx.didChange(_options.editorOptions)) Object.assign(changeSummary, ctx.change.changedOptions);
                return true;
            }
        }, (reader, changeSummary)=>{
            /** @description update editor options */ _options.editorOptions.read(reader);
            this._options.renderSideBySide.read(reader);
            this.modified.updateOptions(this._adjustOptionsForRightHandSide(reader, changeSummary));
            this.original.updateOptions(this._adjustOptionsForLeftHandSide(reader, changeSummary));
        }));
    }
    _createLeftHandSideEditor(options, codeEditorWidgetOptions) {
        const leftHandSideOptions = this._adjustOptionsForLeftHandSide(undefined, options);
        const editor = this._constructInnerEditor(this._instantiationService, this.originalEditorElement, leftHandSideOptions, codeEditorWidgetOptions);
        editor.setContextValue("isInDiffLeftEditor", true);
        return editor;
    }
    _createRightHandSideEditor(options, codeEditorWidgetOptions) {
        const rightHandSideOptions = this._adjustOptionsForRightHandSide(undefined, options);
        const editor = this._constructInnerEditor(this._instantiationService, this.modifiedEditorElement, rightHandSideOptions, codeEditorWidgetOptions);
        editor.setContextValue("isInDiffRightEditor", true);
        return editor;
    }
    _constructInnerEditor(instantiationService, container, options, editorWidgetOptions) {
        const editor = this._createInnerEditor(instantiationService, container, options, editorWidgetOptions);
        this._register(editor.onDidContentSizeChange((e)=>{
            const width = this.original.getContentWidth() + this.modified.getContentWidth() + (0, _overviewRulerFeatureJs.OverviewRulerFeature).ENTIRE_DIFF_OVERVIEW_WIDTH;
            const height = Math.max(this.modified.getContentHeight(), this.original.getContentHeight());
            this._onDidContentSizeChange.fire({
                contentHeight: height,
                contentWidth: width,
                contentHeightChanged: e.contentHeightChanged,
                contentWidthChanged: e.contentWidthChanged
            });
        }));
        return editor;
    }
    _adjustOptionsForLeftHandSide(_reader, changedOptions) {
        const result = this._adjustOptionsForSubEditor(changedOptions);
        if (!this._options.renderSideBySide.get()) {
            // never wrap hidden editor
            result.wordWrapOverride1 = "off";
            result.wordWrapOverride2 = "off";
            result.stickyScroll = {
                enabled: false
            };
            // Disable unicode highlighting for the original side in inline mode, as they are not shown anyway.
            result.unicodeHighlight = {
                nonBasicASCII: false,
                ambiguousCharacters: false,
                invisibleCharacters: false
            };
        } else {
            result.unicodeHighlight = this._options.editorOptions.get().unicodeHighlight || {};
            result.wordWrapOverride1 = this._options.diffWordWrap.get();
        }
        result.glyphMargin = this._options.renderSideBySide.get();
        if (changedOptions.originalAriaLabel) result.ariaLabel = changedOptions.originalAriaLabel;
        result.ariaLabel = this._updateAriaLabel(result.ariaLabel);
        result.readOnly = !this._options.originalEditable.get();
        result.dropIntoEditor = {
            enabled: !result.readOnly
        };
        result.extraEditorClassName = "original-in-monaco-diff-editor";
        return result;
    }
    _adjustOptionsForRightHandSide(reader, changedOptions) {
        const result = this._adjustOptionsForSubEditor(changedOptions);
        if (changedOptions.modifiedAriaLabel) result.ariaLabel = changedOptions.modifiedAriaLabel;
        result.ariaLabel = this._updateAriaLabel(result.ariaLabel);
        result.wordWrapOverride1 = this._options.diffWordWrap.get();
        result.revealHorizontalRightPadding = (0, _editorOptionsJs.EditorOptions).revealHorizontalRightPadding.defaultValue + (0, _overviewRulerFeatureJs.OverviewRulerFeature).ENTIRE_DIFF_OVERVIEW_WIDTH;
        result.scrollbar.verticalHasArrows = false;
        result.extraEditorClassName = "modified-in-monaco-diff-editor";
        return result;
    }
    _adjustOptionsForSubEditor(options) {
        const clonedOptions = {
            ...options,
            dimension: {
                height: 0,
                width: 0
            }
        };
        clonedOptions.inDiffEditor = true;
        clonedOptions.automaticLayout = false;
        // Clone scrollbar options before changing them
        clonedOptions.scrollbar = {
            ...clonedOptions.scrollbar || {}
        };
        clonedOptions.folding = false;
        clonedOptions.codeLens = this._options.diffCodeLens.get();
        clonedOptions.fixedOverflowWidgets = true;
        // Clone minimap options before changing them
        clonedOptions.minimap = {
            ...clonedOptions.minimap || {}
        };
        clonedOptions.minimap.enabled = false;
        if (this._options.hideUnchangedRegions.get()) clonedOptions.stickyScroll = {
            enabled: false
        };
        else clonedOptions.stickyScroll = this._options.editorOptions.get().stickyScroll;
        return clonedOptions;
    }
    _updateAriaLabel(ariaLabel) {
        if (!ariaLabel) ariaLabel = "";
        const ariaNavigationTip = (0, _nlsJs.localize)("diff-aria-navigation-tip", " use {0} to open the accessibility help.", this._keybindingService.lookupKeybinding("editor.action.accessibilityHelp")?.getAriaLabel());
        if (this._options.accessibilityVerbose.get()) return ariaLabel + ariaNavigationTip;
        else if (ariaLabel) return ariaLabel.replaceAll(ariaNavigationTip, "");
        return "";
    }
};
DiffEditorEditors = __decorate([
    __param(5, (0, _instantiationJs.IInstantiationService)),
    __param(6, (0, _keybindingJs.IKeybindingService))
], DiffEditorEditors);

},{"../../../../../base/common/event.js":"4Zi8b","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../observableCodeEditor.js":"hfBd1","../features/overviewRulerFeature.js":"8bSV4","../../../../common/config/editorOptions.js":"3Xi00","../../../../common/core/position.js":"lvrPe","../../../../../nls.js":"l617d","../../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../../platform/keybinding/common/keybinding.js":"25pLT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"WPqIw":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DelegatingEditor", ()=>DelegatingEditor);
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
class DelegatingEditor extends (0, _lifecycleJs.Disposable) {
    constructor(){
        super(...arguments);
        this._id = ++DelegatingEditor.idCounter;
        this._onDidDispose = this._register(new (0, _eventJs.Emitter)());
        this.onDidDispose = this._onDidDispose.event;
    // #endregion
    }
    static{
        this.idCounter = 0;
    }
    getId() {
        return this.getEditorType() + ":v2:" + this._id;
    }
    // #region editorBrowser.IDiffEditor: Delegating to modified Editor
    getVisibleColumnFromPosition(position) {
        return this._targetEditor.getVisibleColumnFromPosition(position);
    }
    getPosition() {
        return this._targetEditor.getPosition();
    }
    setPosition(position, source = "api") {
        this._targetEditor.setPosition(position, source);
    }
    revealLine(lineNumber, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealLine(lineNumber, scrollType);
    }
    revealLineInCenter(lineNumber, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealLineInCenter(lineNumber, scrollType);
    }
    revealLineInCenterIfOutsideViewport(lineNumber, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealLineInCenterIfOutsideViewport(lineNumber, scrollType);
    }
    revealLineNearTop(lineNumber, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealLineNearTop(lineNumber, scrollType);
    }
    revealPosition(position, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealPosition(position, scrollType);
    }
    revealPositionInCenter(position, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealPositionInCenter(position, scrollType);
    }
    revealPositionInCenterIfOutsideViewport(position, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealPositionInCenterIfOutsideViewport(position, scrollType);
    }
    revealPositionNearTop(position, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealPositionNearTop(position, scrollType);
    }
    getSelection() {
        return this._targetEditor.getSelection();
    }
    getSelections() {
        return this._targetEditor.getSelections();
    }
    setSelection(something, source = "api") {
        this._targetEditor.setSelection(something, source);
    }
    setSelections(ranges, source = "api") {
        this._targetEditor.setSelections(ranges, source);
    }
    revealLines(startLineNumber, endLineNumber, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealLines(startLineNumber, endLineNumber, scrollType);
    }
    revealLinesInCenter(startLineNumber, endLineNumber, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealLinesInCenter(startLineNumber, endLineNumber, scrollType);
    }
    revealLinesInCenterIfOutsideViewport(startLineNumber, endLineNumber, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealLinesInCenterIfOutsideViewport(startLineNumber, endLineNumber, scrollType);
    }
    revealLinesNearTop(startLineNumber, endLineNumber, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealLinesNearTop(startLineNumber, endLineNumber, scrollType);
    }
    revealRange(range, scrollType = 0 /* ScrollType.Smooth */ , revealVerticalInCenter = false, revealHorizontal = true) {
        this._targetEditor.revealRange(range, scrollType, revealVerticalInCenter, revealHorizontal);
    }
    revealRangeInCenter(range, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealRangeInCenter(range, scrollType);
    }
    revealRangeInCenterIfOutsideViewport(range, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealRangeInCenterIfOutsideViewport(range, scrollType);
    }
    revealRangeNearTop(range, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealRangeNearTop(range, scrollType);
    }
    revealRangeNearTopIfOutsideViewport(range, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealRangeNearTopIfOutsideViewport(range, scrollType);
    }
    revealRangeAtTop(range, scrollType = 0 /* ScrollType.Smooth */ ) {
        this._targetEditor.revealRangeAtTop(range, scrollType);
    }
    getSupportedActions() {
        return this._targetEditor.getSupportedActions();
    }
    focus() {
        this._targetEditor.focus();
    }
    trigger(source, handlerId, payload) {
        this._targetEditor.trigger(source, handlerId, payload);
    }
    createDecorationsCollection(decorations) {
        return this._targetEditor.createDecorationsCollection(decorations);
    }
    changeDecorations(callback) {
        return this._targetEditor.changeDecorations(callback);
    }
}

},{"../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2A2oD":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiffEditorOptions", ()=>DiffEditorOptions);
var _observableJs = require("../../../../base/common/observable.js");
var _utilsJs = require("../../../../base/common/observableInternal/utils.js");
var _diffEditorViewZonesJs = require("./components/diffEditorViewZones/diffEditorViewZones.js");
var _diffEditorJs = require("../../../common/config/diffEditor.js");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
var _accessibilityJs = require("../../../../platform/accessibility/common/accessibility.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let DiffEditorOptions = class DiffEditorOptions {
    get editorOptions() {
        return this._options;
    }
    constructor(options, _accessibilityService){
        this._accessibilityService = _accessibilityService;
        this._diffEditorWidth = (0, _observableJs.observableValue)(this, 0);
        this._screenReaderMode = (0, _observableJs.observableFromEvent)(this, this._accessibilityService.onDidChangeScreenReaderOptimized, ()=>this._accessibilityService.isScreenReaderOptimized());
        this.couldShowInlineViewBecauseOfSize = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).renderSideBySide && this._diffEditorWidth.read(reader) <= this._options.read(reader).renderSideBySideInlineBreakpoint);
        this.renderOverviewRuler = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).renderOverviewRuler);
        this.renderSideBySide = (0, _observableJs.derived)(this, (reader)=>{
            if (this.compactMode.read(reader)) {
                if (this.shouldRenderInlineViewInSmartMode.read(reader)) return false;
            }
            return this._options.read(reader).renderSideBySide && !(this._options.read(reader).useInlineViewWhenSpaceIsLimited && this.couldShowInlineViewBecauseOfSize.read(reader) && !this._screenReaderMode.read(reader));
        });
        this.readOnly = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).readOnly);
        this.shouldRenderOldRevertArrows = (0, _observableJs.derived)(this, (reader)=>{
            if (!this._options.read(reader).renderMarginRevertIcon) return false;
            if (!this.renderSideBySide.read(reader)) return false;
            if (this.readOnly.read(reader)) return false;
            if (this.shouldRenderGutterMenu.read(reader)) return false;
            return true;
        });
        this.shouldRenderGutterMenu = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).renderGutterMenu);
        this.renderIndicators = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).renderIndicators);
        this.enableSplitViewResizing = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).enableSplitViewResizing);
        this.splitViewDefaultRatio = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).splitViewDefaultRatio);
        this.ignoreTrimWhitespace = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).ignoreTrimWhitespace);
        this.maxComputationTimeMs = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).maxComputationTime);
        this.showMoves = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).experimental.showMoves && this.renderSideBySide.read(reader));
        this.isInEmbeddedEditor = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).isInEmbeddedEditor);
        this.diffWordWrap = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).diffWordWrap);
        this.originalEditable = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).originalEditable);
        this.diffCodeLens = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).diffCodeLens);
        this.accessibilityVerbose = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).accessibilityVerbose);
        this.diffAlgorithm = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).diffAlgorithm);
        this.showEmptyDecorations = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).experimental.showEmptyDecorations);
        this.onlyShowAccessibleDiffViewer = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).onlyShowAccessibleDiffViewer);
        this.compactMode = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).compactMode);
        this.trueInlineDiffRenderingEnabled = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).experimental.useTrueInlineView);
        this.useTrueInlineDiffRendering = (0, _observableJs.derived)(this, (reader)=>!this.renderSideBySide.read(reader) && this.trueInlineDiffRenderingEnabled.read(reader));
        this.hideUnchangedRegions = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).hideUnchangedRegions.enabled);
        this.hideUnchangedRegionsRevealLineCount = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).hideUnchangedRegions.revealLineCount);
        this.hideUnchangedRegionsContextLineCount = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).hideUnchangedRegions.contextLineCount);
        this.hideUnchangedRegionsMinimumLineCount = (0, _observableJs.derived)(this, (reader)=>this._options.read(reader).hideUnchangedRegions.minimumLineCount);
        this._model = (0, _observableJs.observableValue)(this, undefined);
        this.shouldRenderInlineViewInSmartMode = this._model.map(this, (model)=>(0, _utilsJs.derivedConstOnceDefined)(this, (reader)=>{
                const diffs = model?.diff.read(reader);
                return diffs ? isSimpleDiff(diffs, this.trueInlineDiffRenderingEnabled.read(reader)) : undefined;
            })).flatten().map(this, (v)=>!!v);
        this.inlineViewHideOriginalLineNumbers = this.compactMode;
        const optionsCopy = {
            ...options,
            ...validateDiffEditorOptions(options, (0, _diffEditorJs.diffEditorDefaultOptions))
        };
        this._options = (0, _observableJs.observableValue)(this, optionsCopy);
    }
    updateOptions(changedOptions) {
        const newDiffEditorOptions = validateDiffEditorOptions(changedOptions, this._options.get());
        const newOptions = {
            ...this._options.get(),
            ...changedOptions,
            ...newDiffEditorOptions
        };
        this._options.set(newOptions, undefined, {
            changedOptions: changedOptions
        });
    }
    setWidth(width) {
        this._diffEditorWidth.set(width, undefined);
    }
    setModel(model) {
        this._model.set(model, undefined);
    }
};
DiffEditorOptions = __decorate([
    __param(1, (0, _accessibilityJs.IAccessibilityService))
], DiffEditorOptions);
function isSimpleDiff(diff, supportsTrueDiffRendering) {
    return diff.mappings.every((m)=>isInsertion(m.lineRangeMapping) || isDeletion(m.lineRangeMapping) || supportsTrueDiffRendering && (0, _diffEditorViewZonesJs.allowsTrueInlineDiffRendering)(m.lineRangeMapping));
}
function isInsertion(mapping) {
    return mapping.original.length === 0;
}
function isDeletion(mapping) {
    return mapping.modified.length === 0;
}
function validateDiffEditorOptions(options, defaults) {
    return {
        enableSplitViewResizing: (0, _editorOptionsJs.boolean)(options.enableSplitViewResizing, defaults.enableSplitViewResizing),
        splitViewDefaultRatio: (0, _editorOptionsJs.clampedFloat)(options.splitViewDefaultRatio, 0.5, 0.1, 0.9),
        renderSideBySide: (0, _editorOptionsJs.boolean)(options.renderSideBySide, defaults.renderSideBySide),
        renderMarginRevertIcon: (0, _editorOptionsJs.boolean)(options.renderMarginRevertIcon, defaults.renderMarginRevertIcon),
        maxComputationTime: (0, _editorOptionsJs.clampedInt)(options.maxComputationTime, defaults.maxComputationTime, 0, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ),
        maxFileSize: (0, _editorOptionsJs.clampedInt)(options.maxFileSize, defaults.maxFileSize, 0, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ),
        ignoreTrimWhitespace: (0, _editorOptionsJs.boolean)(options.ignoreTrimWhitespace, defaults.ignoreTrimWhitespace),
        renderIndicators: (0, _editorOptionsJs.boolean)(options.renderIndicators, defaults.renderIndicators),
        originalEditable: (0, _editorOptionsJs.boolean)(options.originalEditable, defaults.originalEditable),
        diffCodeLens: (0, _editorOptionsJs.boolean)(options.diffCodeLens, defaults.diffCodeLens),
        renderOverviewRuler: (0, _editorOptionsJs.boolean)(options.renderOverviewRuler, defaults.renderOverviewRuler),
        diffWordWrap: (0, _editorOptionsJs.stringSet)(options.diffWordWrap, defaults.diffWordWrap, [
            "off",
            "on",
            "inherit"
        ]),
        diffAlgorithm: (0, _editorOptionsJs.stringSet)(options.diffAlgorithm, defaults.diffAlgorithm, [
            "legacy",
            "advanced"
        ], {
            "smart": "legacy",
            "experimental": "advanced"
        }),
        accessibilityVerbose: (0, _editorOptionsJs.boolean)(options.accessibilityVerbose, defaults.accessibilityVerbose),
        experimental: {
            showMoves: (0, _editorOptionsJs.boolean)(options.experimental?.showMoves, defaults.experimental.showMoves),
            showEmptyDecorations: (0, _editorOptionsJs.boolean)(options.experimental?.showEmptyDecorations, defaults.experimental.showEmptyDecorations),
            useTrueInlineView: (0, _editorOptionsJs.boolean)(options.experimental?.useTrueInlineView, defaults.experimental.useTrueInlineView)
        },
        hideUnchangedRegions: {
            enabled: (0, _editorOptionsJs.boolean)(options.hideUnchangedRegions?.enabled ?? options.experimental?.collapseUnchangedRegions, defaults.hideUnchangedRegions.enabled),
            contextLineCount: (0, _editorOptionsJs.clampedInt)(options.hideUnchangedRegions?.contextLineCount, defaults.hideUnchangedRegions.contextLineCount, 0, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ),
            minimumLineCount: (0, _editorOptionsJs.clampedInt)(options.hideUnchangedRegions?.minimumLineCount, defaults.hideUnchangedRegions.minimumLineCount, 0, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ),
            revealLineCount: (0, _editorOptionsJs.clampedInt)(options.hideUnchangedRegions?.revealLineCount, defaults.hideUnchangedRegions.revealLineCount, 0, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ )
        },
        isInEmbeddedEditor: (0, _editorOptionsJs.boolean)(options.isInEmbeddedEditor, defaults.isInEmbeddedEditor),
        onlyShowAccessibleDiffViewer: (0, _editorOptionsJs.boolean)(options.onlyShowAccessibleDiffViewer, defaults.onlyShowAccessibleDiffViewer),
        renderSideBySideInlineBreakpoint: (0, _editorOptionsJs.clampedInt)(options.renderSideBySideInlineBreakpoint, defaults.renderSideBySideInlineBreakpoint, 0, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ),
        useInlineViewWhenSpaceIsLimited: (0, _editorOptionsJs.boolean)(options.useInlineViewWhenSpaceIsLimited, defaults.useInlineViewWhenSpaceIsLimited),
        renderGutterMenu: (0, _editorOptionsJs.boolean)(options.renderGutterMenu, defaults.renderGutterMenu),
        compactMode: (0, _editorOptionsJs.boolean)(options.compactMode, defaults.compactMode)
    };
}

},{"../../../../base/common/observable.js":"2xbG5","../../../../base/common/observableInternal/utils.js":"4p38u","./components/diffEditorViewZones/diffEditorViewZones.js":"h8oLv","../../../common/config/diffEditor.js":"FPe1s","../../../common/config/editorOptions.js":"3Xi00","../../../../platform/accessibility/common/accessibility.js":"9Svqy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4RRPk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiDiffEditorWidget", ()=>MultiDiffEditorWidget);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _hotReloadHelpersJs = require("../../../../base/common/hotReloadHelpers.js");
var _multiDiffEditorWidgetImplJs = require("./multiDiffEditorWidgetImpl.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _colorsJs = require("./colors.js");
var _diffEditorItemTemplateJs = require("./diffEditorItemTemplate.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let MultiDiffEditorWidget = class MultiDiffEditorWidget extends (0, _lifecycleJs.Disposable) {
    constructor(_element, _workbenchUIElementFactory, _instantiationService){
        super();
        this._element = _element;
        this._workbenchUIElementFactory = _workbenchUIElementFactory;
        this._instantiationService = _instantiationService;
        this._dimension = (0, _observableJs.observableValue)(this, undefined);
        this._viewModel = (0, _observableJs.observableValue)(this, undefined);
        this._widgetImpl = (0, _observableJs.derivedWithStore)(this, (reader, store)=>{
            (0, _hotReloadHelpersJs.readHotReloadableExport)((0, _diffEditorItemTemplateJs.DiffEditorItemTemplate), reader);
            return store.add(this._instantiationService.createInstance((0, _hotReloadHelpersJs.readHotReloadableExport)((0, _multiDiffEditorWidgetImplJs.MultiDiffEditorWidgetImpl), reader), this._element, this._dimension, this._viewModel, this._workbenchUIElementFactory));
        });
        this._register((0, _observableJs.recomputeInitiallyAndOnChange)(this._widgetImpl));
    }
};
MultiDiffEditorWidget = __decorate([
    __param(2, (0, _instantiationJs.IInstantiationService))
], MultiDiffEditorWidget);

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../../../base/common/hotReloadHelpers.js":"3t1eI","./multiDiffEditorWidgetImpl.js":"ir6m5","../../../../platform/instantiation/common/instantiation.js":"fjwWx","./colors.js":"dhxY7","./diffEditorItemTemplate.js":"FHlXd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ir6m5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiDiffEditorWidgetImpl", ()=>MultiDiffEditorWidgetImpl);
var _domJs = require("../../../../base/browser/dom.js");
var _scrollableElementJs = require("../../../../base/browser/ui/scrollbar/scrollableElement.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _arraysFindJs = require("../../../../base/common/arraysFind.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _baseJs = require("../../../../base/common/observableInternal/base.js");
var _scrollableJs = require("../../../../base/common/scrollable.js");
var _styleCss = require("./style.css");
var _utilsJs = require("../diffEditor/utils.js");
var _offsetRangeJs = require("../../../common/core/offsetRange.js");
var _selectionJs = require("../../../common/core/selection.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _serviceCollectionJs = require("../../../../platform/instantiation/common/serviceCollection.js");
var _diffEditorItemTemplateJs = require("./diffEditorItemTemplate.js");
var _objectPoolJs = require("./objectPool.js");
var _nlsJs = require("../../../../nls.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let MultiDiffEditorWidgetImpl = class MultiDiffEditorWidgetImpl extends (0, _lifecycleJs.Disposable) {
    constructor(_element, _dimension, _viewModel, _workbenchUIElementFactory, _parentContextKeyService, _parentInstantiationService){
        super();
        this._element = _element;
        this._dimension = _dimension;
        this._viewModel = _viewModel;
        this._workbenchUIElementFactory = _workbenchUIElementFactory;
        this._parentContextKeyService = _parentContextKeyService;
        this._parentInstantiationService = _parentInstantiationService;
        this._scrollableElements = (0, _domJs.h)("div.scrollContent", [
            (0, _domJs.h)("div@content", {
                style: {
                    overflow: "hidden"
                }
            }),
            (0, _domJs.h)("div.monaco-editor@overflowWidgetsDomNode", {})
        ]);
        this._scrollable = this._register(new (0, _scrollableJs.Scrollable)({
            forceIntegerValues: false,
            scheduleAtNextAnimationFrame: (cb)=>(0, _domJs.scheduleAtNextAnimationFrame)((0, _domJs.getWindow)(this._element), cb),
            smoothScrollDuration: 100
        }));
        this._scrollableElement = this._register(new (0, _scrollableElementJs.SmoothScrollableElement)(this._scrollableElements.root, {
            vertical: 1 /* ScrollbarVisibility.Auto */ ,
            horizontal: 1 /* ScrollbarVisibility.Auto */ ,
            useShadows: false
        }, this._scrollable));
        this._elements = (0, _domJs.h)("div.monaco-component.multiDiffEditor", {}, [
            (0, _domJs.h)("div", {}, [
                this._scrollableElement.getDomNode()
            ]),
            (0, _domJs.h)("div.placeholder@placeholder", {}, [
                (0, _domJs.h)("div", [
                    (0, _nlsJs.localize)("noChangedFiles", "No Changed Files")
                ])
            ])
        ]);
        this._sizeObserver = this._register(new (0, _utilsJs.ObservableElementSizeObserver)(this._element, undefined));
        this._objectPool = this._register(new (0, _objectPoolJs.ObjectPool)((data)=>{
            const template = this._instantiationService.createInstance((0, _diffEditorItemTemplateJs.DiffEditorItemTemplate), this._scrollableElements.content, this._scrollableElements.overflowWidgetsDomNode, this._workbenchUIElementFactory);
            template.setData(data);
            return template;
        }));
        this.scrollTop = (0, _observableJs.observableFromEvent)(this, this._scrollableElement.onScroll, ()=>/** @description scrollTop */ this._scrollableElement.getScrollPosition().scrollTop);
        this.scrollLeft = (0, _observableJs.observableFromEvent)(this, this._scrollableElement.onScroll, ()=>/** @description scrollLeft */ this._scrollableElement.getScrollPosition().scrollLeft);
        this._viewItemsInfo = (0, _observableJs.derivedWithStore)(this, (reader, store)=>{
            const vm = this._viewModel.read(reader);
            if (!vm) return {
                items: [],
                getItem: (_d)=>{
                    throw new (0, _errorsJs.BugIndicatingError)();
                }
            };
            const viewModels = vm.items.read(reader);
            const map = new Map();
            const items = viewModels.map((d)=>{
                const item = store.add(new VirtualizedViewItem(d, this._objectPool, this.scrollLeft, (delta)=>{
                    this._scrollableElement.setScrollPosition({
                        scrollTop: this._scrollableElement.getScrollPosition().scrollTop + delta
                    });
                }));
                const data = this._lastDocStates?.[item.getKey()];
                if (data) (0, _baseJs.transaction)((tx)=>{
                    item.setViewState(data, tx);
                });
                map.set(d, item);
                return item;
            });
            return {
                items,
                getItem: (d)=>map.get(d)
            };
        });
        this._viewItems = this._viewItemsInfo.map(this, (items)=>items.items);
        this._spaceBetweenPx = 0;
        this._totalHeight = this._viewItems.map(this, (items, reader)=>items.reduce((r, i)=>r + i.contentHeight.read(reader) + this._spaceBetweenPx, 0));
        this._contextKeyService = this._register(this._parentContextKeyService.createScoped(this._element));
        this._instantiationService = this._register(this._parentInstantiationService.createChild(new (0, _serviceCollectionJs.ServiceCollection)([
            (0, _contextkeyJs.IContextKeyService),
            this._contextKeyService
        ])));
        /** This accounts for documents that are not loaded yet. */ this._lastDocStates = {};
        this._contextKeyService.createKey((0, _editorContextKeysJs.EditorContextKeys).inMultiDiffEditor.key, true);
        this._register((0, _observableJs.autorunWithStore)((reader, store)=>{
            const viewModel = this._viewModel.read(reader);
            if (viewModel && viewModel.contextKeys) for (const [key, value] of Object.entries(viewModel.contextKeys)){
                const contextKey = this._contextKeyService.createKey(key, undefined);
                contextKey.set(value);
                store.add((0, _lifecycleJs.toDisposable)(()=>contextKey.reset()));
            }
        }));
        const ctxAllCollapsed = this._parentContextKeyService.createKey((0, _editorContextKeysJs.EditorContextKeys).multiDiffEditorAllCollapsed.key, false);
        this._register((0, _observableJs.autorun)((reader)=>{
            const viewModel = this._viewModel.read(reader);
            if (viewModel) {
                const allCollapsed = viewModel.items.read(reader).every((item)=>item.collapsed.read(reader));
                ctxAllCollapsed.set(allCollapsed);
            }
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description Update widget dimension */ const dimension = this._dimension.read(reader);
            this._sizeObserver.observe(dimension);
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description Update widget dimension */ const items = this._viewItems.read(reader);
            this._elements.placeholder.classList.toggle("visible", items.length === 0);
        }));
        this._scrollableElements.content.style.position = "relative";
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description Update scroll dimensions */ const height = this._sizeObserver.height.read(reader);
            this._scrollableElements.root.style.height = `${height}px`;
            const totalHeight = this._totalHeight.read(reader);
            this._scrollableElements.content.style.height = `${totalHeight}px`;
            const width = this._sizeObserver.width.read(reader);
            let scrollWidth = width;
            const viewItems = this._viewItems.read(reader);
            const max = (0, _arraysFindJs.findFirstMax)(viewItems, (0, _arraysJs.compareBy)((i)=>i.maxScroll.read(reader).maxScroll, (0, _arraysJs.numberComparator)));
            if (max) {
                const maxScroll = max.maxScroll.read(reader);
                scrollWidth = width + maxScroll.maxScroll;
            }
            this._scrollableElement.setScrollDimensions({
                width: width,
                height: height,
                scrollHeight: totalHeight,
                scrollWidth
            });
        }));
        _element.replaceChildren(this._elements.root);
        this._register((0, _lifecycleJs.toDisposable)(()=>{
            _element.replaceChildren();
        }));
        this._register(this._register((0, _observableJs.autorun)((reader)=>{
            /** @description Render all */ (0, _baseJs.globalTransaction)((tx)=>{
                this.render(reader);
            });
        })));
    }
    render(reader) {
        const scrollTop = this.scrollTop.read(reader);
        let contentScrollOffsetToScrollOffset = 0;
        let itemHeightSumBefore = 0;
        let itemContentHeightSumBefore = 0;
        const viewPortHeight = this._sizeObserver.height.read(reader);
        const contentViewPort = (0, _offsetRangeJs.OffsetRange).ofStartAndLength(scrollTop, viewPortHeight);
        const width = this._sizeObserver.width.read(reader);
        for (const v of this._viewItems.read(reader)){
            const itemContentHeight = v.contentHeight.read(reader);
            const itemHeight = Math.min(itemContentHeight, viewPortHeight);
            const itemRange = (0, _offsetRangeJs.OffsetRange).ofStartAndLength(itemHeightSumBefore, itemHeight);
            const itemContentRange = (0, _offsetRangeJs.OffsetRange).ofStartAndLength(itemContentHeightSumBefore, itemContentHeight);
            if (itemContentRange.isBefore(contentViewPort)) {
                contentScrollOffsetToScrollOffset -= itemContentHeight - itemHeight;
                v.hide();
            } else if (itemContentRange.isAfter(contentViewPort)) v.hide();
            else {
                const scroll = Math.max(0, Math.min(contentViewPort.start - itemContentRange.start, itemContentHeight - itemHeight));
                contentScrollOffsetToScrollOffset -= scroll;
                const viewPort = (0, _offsetRangeJs.OffsetRange).ofStartAndLength(scrollTop + contentScrollOffsetToScrollOffset, viewPortHeight);
                v.render(itemRange, scroll, width, viewPort);
            }
            itemHeightSumBefore += itemHeight + this._spaceBetweenPx;
            itemContentHeightSumBefore += itemContentHeight + this._spaceBetweenPx;
        }
        this._scrollableElements.content.style.transform = `translateY(${-(scrollTop + contentScrollOffsetToScrollOffset)}px)`;
    }
};
MultiDiffEditorWidgetImpl = __decorate([
    __param(4, (0, _contextkeyJs.IContextKeyService)),
    __param(5, (0, _instantiationJs.IInstantiationService))
], MultiDiffEditorWidgetImpl);
class VirtualizedViewItem extends (0, _lifecycleJs.Disposable) {
    constructor(viewModel, _objectPool, _scrollLeft, _deltaScrollVertical){
        super();
        this.viewModel = viewModel;
        this._objectPool = _objectPool;
        this._scrollLeft = _scrollLeft;
        this._deltaScrollVertical = _deltaScrollVertical;
        this._templateRef = this._register((0, _baseJs.disposableObservableValue)(this, undefined));
        this.contentHeight = (0, _observableJs.derived)(this, (reader)=>this._templateRef.read(reader)?.object.contentHeight?.read(reader) ?? this.viewModel.lastTemplateData.read(reader).contentHeight);
        this.maxScroll = (0, _observableJs.derived)(this, (reader)=>this._templateRef.read(reader)?.object.maxScroll.read(reader) ?? {
                maxScroll: 0,
                scrollWidth: 0
            });
        this.template = (0, _observableJs.derived)(this, (reader)=>this._templateRef.read(reader)?.object);
        this._isHidden = (0, _observableJs.observableValue)(this, false);
        this._isFocused = (0, _observableJs.derived)(this, (reader)=>this.template.read(reader)?.isFocused.read(reader) ?? false);
        this.viewModel.setIsFocused(this._isFocused, undefined);
        this._register((0, _observableJs.autorun)((reader)=>{
            const scrollLeft = this._scrollLeft.read(reader);
            this._templateRef.read(reader)?.object.setScrollLeft(scrollLeft);
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            const ref = this._templateRef.read(reader);
            if (!ref) return;
            const isHidden = this._isHidden.read(reader);
            if (!isHidden) return;
            const isFocused = ref.object.isFocused.read(reader);
            if (isFocused) return;
            this._clear();
        }));
    }
    dispose() {
        this._clear();
        super.dispose();
    }
    toString() {
        return `VirtualViewItem(${this.viewModel.documentDiffItem.modified?.uri.toString()})`;
    }
    getKey() {
        return this.viewModel.getKey();
    }
    setViewState(viewState, tx) {
        this.viewModel.collapsed.set(viewState.collapsed, tx);
        this._updateTemplateData(tx);
        const data = this.viewModel.lastTemplateData.get();
        const selections = viewState.selections?.map((0, _selectionJs.Selection).liftSelection);
        this.viewModel.lastTemplateData.set({
            ...data,
            selections
        }, tx);
        const ref = this._templateRef.get();
        if (ref) {
            if (selections) ref.object.editor.setSelections(selections);
        }
    }
    _updateTemplateData(tx) {
        const ref = this._templateRef.get();
        if (!ref) return;
        this.viewModel.lastTemplateData.set({
            contentHeight: ref.object.contentHeight.get(),
            selections: ref.object.editor.getSelections() ?? undefined
        }, tx);
    }
    _clear() {
        const ref = this._templateRef.get();
        if (!ref) return;
        (0, _baseJs.transaction)((tx)=>{
            this._updateTemplateData(tx);
            ref.object.hide();
            this._templateRef.set(undefined, tx);
        });
    }
    hide() {
        this._isHidden.set(true, undefined);
    }
    render(verticalSpace, offset, width, viewPort) {
        this._isHidden.set(false, undefined);
        let ref = this._templateRef.get();
        if (!ref) {
            ref = this._objectPool.getUnusedObj(new (0, _diffEditorItemTemplateJs.TemplateData)(this.viewModel, this._deltaScrollVertical));
            this._templateRef.set(ref, undefined);
            const selections = this.viewModel.lastTemplateData.get().selections;
            if (selections) ref.object.editor.setSelections(selections);
        }
        ref.object.render(verticalSpace, width, offset, viewPort);
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/scrollbar/scrollableElement.js":"h1C5l","../../../../base/common/arrays.js":"DECei","../../../../base/common/arraysFind.js":"gWrU0","../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../../../base/common/observableInternal/base.js":"lYJZ2","../../../../base/common/scrollable.js":"8otcz","./style.css":"g17i9","../diffEditor/utils.js":"2G3Lp","../../../common/core/offsetRange.js":"ifHXk","../../../common/core/selection.js":"kcwzU","../../../common/editorContextKeys.js":"5exv9","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/instantiation/common/serviceCollection.js":"5sFx9","./diffEditorItemTemplate.js":"FHlXd","./objectPool.js":"kf04D","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g17i9":[function() {},{}],"FHlXd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TemplateData", ()=>TemplateData);
parcelHelpers.export(exports, "DiffEditorItemTemplate", ()=>DiffEditorItemTemplate);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _domJs = require("../../../../base/browser/dom.js");
var _buttonJs = require("../../../../base/browser/ui/button/button.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _baseJs = require("../../../../base/common/observableInternal/base.js");
var _observableCodeEditorJs = require("../../observableCodeEditor.js");
var _diffEditorWidgetJs = require("../diffEditor/diffEditorWidget.js");
var _menuEntryActionViewItemJs = require("../../../../platform/actions/browser/menuEntryActionViewItem.js");
var _toolbarJs = require("../../../../platform/actions/browser/toolbar.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _utilsJs = require("./utils.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _serviceCollectionJs = require("../../../../platform/instantiation/common/serviceCollection.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class TemplateData {
    constructor(viewModel, deltaScrollVertical){
        this.viewModel = viewModel;
        this.deltaScrollVertical = deltaScrollVertical;
    }
    getId() {
        return this.viewModel;
    }
}
let DiffEditorItemTemplate = class DiffEditorItemTemplate extends (0, _lifecycleJs.Disposable) {
    constructor(_container, _overflowWidgetsDomNode, _workbenchUIElementFactory, _instantiationService, _parentContextKeyService){
        super();
        this._container = _container;
        this._overflowWidgetsDomNode = _overflowWidgetsDomNode;
        this._workbenchUIElementFactory = _workbenchUIElementFactory;
        this._instantiationService = _instantiationService;
        this._viewModel = (0, _baseJs.observableValue)(this, undefined);
        this._collapsed = (0, _observableJs.derived)(this, (reader)=>this._viewModel.read(reader)?.collapsed.read(reader));
        this._editorContentHeight = (0, _baseJs.observableValue)(this, 500);
        this.contentHeight = (0, _observableJs.derived)(this, (reader)=>{
            const h = this._collapsed.read(reader) ? 0 : this._editorContentHeight.read(reader);
            return h + this._outerEditorHeight;
        });
        this._modifiedContentWidth = (0, _baseJs.observableValue)(this, 0);
        this._modifiedWidth = (0, _baseJs.observableValue)(this, 0);
        this._originalContentWidth = (0, _baseJs.observableValue)(this, 0);
        this._originalWidth = (0, _baseJs.observableValue)(this, 0);
        this.maxScroll = (0, _observableJs.derived)(this, (reader)=>{
            const scroll1 = this._modifiedContentWidth.read(reader) - this._modifiedWidth.read(reader);
            const scroll2 = this._originalContentWidth.read(reader) - this._originalWidth.read(reader);
            if (scroll1 > scroll2) return {
                maxScroll: scroll1,
                width: this._modifiedWidth.read(reader)
            };
            else return {
                maxScroll: scroll2,
                width: this._originalWidth.read(reader)
            };
        });
        this._elements = (0, _domJs.h)("div.multiDiffEntry", [
            (0, _domJs.h)("div.header@header", [
                (0, _domJs.h)("div.header-content", [
                    (0, _domJs.h)("div.collapse-button@collapseButton"),
                    (0, _domJs.h)("div.file-path", [
                        (0, _domJs.h)("div.title.modified.show-file-icons@primaryPath", []),
                        (0, _domJs.h)("div.status.deleted@status", [
                            "R"
                        ]),
                        (0, _domJs.h)("div.title.original.show-file-icons@secondaryPath", [])
                    ]),
                    (0, _domJs.h)("div.actions@actions")
                ])
            ]),
            (0, _domJs.h)("div.editorParent", [
                (0, _domJs.h)("div.editorContainer@editor")
            ])
        ]);
        this.editor = this._register(this._instantiationService.createInstance((0, _diffEditorWidgetJs.DiffEditorWidget), this._elements.editor, {
            overflowWidgetsDomNode: this._overflowWidgetsDomNode
        }, {}));
        this.isModifedFocused = (0, _observableCodeEditorJs.observableCodeEditor)(this.editor.getModifiedEditor()).isFocused;
        this.isOriginalFocused = (0, _observableCodeEditorJs.observableCodeEditor)(this.editor.getOriginalEditor()).isFocused;
        this.isFocused = (0, _observableJs.derived)(this, (reader)=>this.isModifedFocused.read(reader) || this.isOriginalFocused.read(reader));
        this._resourceLabel = this._workbenchUIElementFactory.createResourceLabel ? this._register(this._workbenchUIElementFactory.createResourceLabel(this._elements.primaryPath)) : undefined;
        this._resourceLabel2 = this._workbenchUIElementFactory.createResourceLabel ? this._register(this._workbenchUIElementFactory.createResourceLabel(this._elements.secondaryPath)) : undefined;
        this._dataStore = this._register(new (0, _lifecycleJs.DisposableStore)());
        this._headerHeight = 40;
        this._lastScrollTop = -1;
        this._isSettingScrollTop = false;
        const btn = new (0, _buttonJs.Button)(this._elements.collapseButton, {});
        this._register((0, _observableJs.autorun)((reader)=>{
            btn.element.className = "";
            btn.icon = this._collapsed.read(reader) ? (0, _codiconsJs.Codicon).chevronRight : (0, _codiconsJs.Codicon).chevronDown;
        }));
        this._register(btn.onDidClick(()=>{
            this._viewModel.get()?.collapsed.set(!this._collapsed.get(), undefined);
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            this._elements.editor.style.display = this._collapsed.read(reader) ? "none" : "block";
        }));
        this._register(this.editor.getModifiedEditor().onDidLayoutChange((e)=>{
            const width = this.editor.getModifiedEditor().getLayoutInfo().contentWidth;
            this._modifiedWidth.set(width, undefined);
        }));
        this._register(this.editor.getOriginalEditor().onDidLayoutChange((e)=>{
            const width = this.editor.getOriginalEditor().getLayoutInfo().contentWidth;
            this._originalWidth.set(width, undefined);
        }));
        this._register(this.editor.onDidContentSizeChange((e)=>{
            (0, _baseJs.globalTransaction)((tx)=>{
                this._editorContentHeight.set(e.contentHeight, tx);
                this._modifiedContentWidth.set(this.editor.getModifiedEditor().getContentWidth(), tx);
                this._originalContentWidth.set(this.editor.getOriginalEditor().getContentWidth(), tx);
            });
        }));
        this._register(this.editor.getOriginalEditor().onDidScrollChange((e)=>{
            if (this._isSettingScrollTop) return;
            if (!e.scrollTopChanged || !this._data) return;
            const delta = e.scrollTop - this._lastScrollTop;
            this._data.deltaScrollVertical(delta);
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            const isActive = this._viewModel.read(reader)?.isActive.read(reader);
            this._elements.root.classList.toggle("active", isActive);
        }));
        this._container.appendChild(this._elements.root);
        this._outerEditorHeight = this._headerHeight;
        this._contextKeyService = this._register(_parentContextKeyService.createScoped(this._elements.actions));
        const instantiationService = this._register(this._instantiationService.createChild(new (0, _serviceCollectionJs.ServiceCollection)([
            (0, _contextkeyJs.IContextKeyService),
            this._contextKeyService
        ])));
        this._register(instantiationService.createInstance((0, _toolbarJs.MenuWorkbenchToolBar), this._elements.actions, (0, _actionsJs.MenuId).MultiDiffEditorFileToolbar, {
            actionRunner: this._register(new (0, _utilsJs.ActionRunnerWithContext)(()=>this._viewModel.get()?.modifiedUri)),
            menuOptions: {
                shouldForwardArgs: true
            },
            toolbarOptions: {
                primaryGroup: (g)=>g.startsWith("navigation")
            },
            actionViewItemProvider: (action, options)=>(0, _menuEntryActionViewItemJs.createActionViewItem)(instantiationService, action, options)
        }));
    }
    setScrollLeft(left) {
        if (this._modifiedContentWidth.get() - this._modifiedWidth.get() > this._originalContentWidth.get() - this._originalWidth.get()) this.editor.getModifiedEditor().setScrollLeft(left);
        else this.editor.getOriginalEditor().setScrollLeft(left);
    }
    setData(data) {
        this._data = data;
        function updateOptions(options) {
            return {
                ...options,
                scrollBeyondLastLine: false,
                hideUnchangedRegions: {
                    enabled: true
                },
                scrollbar: {
                    vertical: "hidden",
                    horizontal: "hidden",
                    handleMouseWheel: false,
                    useShadows: false
                },
                renderOverviewRuler: false,
                fixedOverflowWidgets: true,
                overviewRulerBorder: false
            };
        }
        if (!data) {
            (0, _baseJs.globalTransaction)((tx)=>{
                this._viewModel.set(undefined, tx);
                this.editor.setDiffModel(null, tx);
                this._dataStore.clear();
            });
            return;
        }
        const value = data.viewModel.documentDiffItem;
        (0, _baseJs.globalTransaction)((tx)=>{
            this._resourceLabel?.setUri(data.viewModel.modifiedUri ?? data.viewModel.originalUri, {
                strikethrough: data.viewModel.modifiedUri === undefined
            });
            let isRenamed = false;
            let isDeleted = false;
            let isAdded = false;
            let flag = "";
            if (data.viewModel.modifiedUri && data.viewModel.originalUri && data.viewModel.modifiedUri.path !== data.viewModel.originalUri.path) {
                flag = "R";
                isRenamed = true;
            } else if (!data.viewModel.modifiedUri) {
                flag = "D";
                isDeleted = true;
            } else if (!data.viewModel.originalUri) {
                flag = "A";
                isAdded = true;
            }
            this._elements.status.classList.toggle("renamed", isRenamed);
            this._elements.status.classList.toggle("deleted", isDeleted);
            this._elements.status.classList.toggle("added", isAdded);
            this._elements.status.innerText = flag;
            this._resourceLabel2?.setUri(isRenamed ? data.viewModel.originalUri : undefined, {
                strikethrough: true
            });
            this._dataStore.clear();
            this._viewModel.set(data.viewModel, tx);
            this.editor.setDiffModel(data.viewModel.diffEditorViewModelRef, tx);
            this.editor.updateOptions(updateOptions(value.options ?? {}));
        });
        if (value.onOptionsDidChange) this._dataStore.add(value.onOptionsDidChange(()=>{
            this.editor.updateOptions(updateOptions(value.options ?? {}));
        }));
        data.viewModel.isAlive.recomputeInitiallyAndOnChange(this._dataStore, (value)=>{
            if (!value) this.setData(undefined);
        });
        if (data.viewModel.documentDiffItem.contextKeys) for (const [key, value] of Object.entries(data.viewModel.documentDiffItem.contextKeys))this._contextKeyService.createKey(key, value);
    }
    render(verticalRange, width, editorScroll, viewPort) {
        this._elements.root.style.visibility = "visible";
        this._elements.root.style.top = `${verticalRange.start}px`;
        this._elements.root.style.height = `${verticalRange.length}px`;
        this._elements.root.style.width = `${width}px`;
        this._elements.root.style.position = "absolute";
        // For sticky scroll
        const maxDelta = verticalRange.length - this._headerHeight;
        const delta = Math.max(0, Math.min(viewPort.start - verticalRange.start, maxDelta));
        this._elements.header.style.transform = `translateY(${delta}px)`;
        (0, _baseJs.globalTransaction)((tx)=>{
            this.editor.layout({
                width: width - 16 - 2,
                height: verticalRange.length - this._outerEditorHeight
            });
        });
        try {
            this._isSettingScrollTop = true;
            this._lastScrollTop = editorScroll;
            this.editor.getOriginalEditor().setScrollTop(editorScroll);
        } finally{
            this._isSettingScrollTop = false;
        }
        this._elements.header.classList.toggle("shadow", delta > 0 || editorScroll > 0);
        this._elements.header.classList.toggle("collapsed", delta === maxDelta);
    }
    hide() {
        this._elements.root.style.top = `-100000px`;
        this._elements.root.style.visibility = "hidden"; // Some editor parts are still visible
    }
};
DiffEditorItemTemplate = __decorate([
    __param(3, (0, _instantiationJs.IInstantiationService)),
    __param(4, (0, _contextkeyJs.IContextKeyService))
], DiffEditorItemTemplate);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/button/button.js":"fmbgq","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../../../base/common/observableInternal/base.js":"lYJZ2","../../observableCodeEditor.js":"hfBd1","../diffEditor/diffEditorWidget.js":"35Ond","../../../../platform/actions/browser/menuEntryActionViewItem.js":"evssn","../../../../platform/actions/browser/toolbar.js":"1ep75","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/instantiation/common/instantiation.js":"fjwWx","./utils.js":"EdYae","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/serviceCollection.js":"5sFx9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kf04D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectPool", ()=>ObjectPool);
class ObjectPool {
    constructor(_create){
        this._create = _create;
        this._unused = new Set();
        this._used = new Set();
        this._itemData = new Map();
    }
    getUnusedObj(data) {
        let obj;
        if (this._unused.size === 0) {
            obj = this._create(data);
            this._itemData.set(obj, data);
        } else {
            const values = [
                ...this._unused.values()
            ];
            obj = values.find((obj)=>this._itemData.get(obj).getId() === data.getId()) ?? values[0];
            this._unused.delete(obj);
            this._itemData.set(obj, data);
            obj.setData(data);
        }
        this._used.add(obj);
        return {
            object: obj,
            dispose: ()=>{
                this._used.delete(obj);
                if (this._unused.size > 5) obj.dispose();
                else this._unused.add(obj);
            }
        };
    }
    dispose() {
        for (const obj of this._used)obj.dispose();
        for (const obj of this._unused)obj.dispose();
        this._used.clear();
        this._unused.clear();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dhxY7":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "multiDiffEditorHeaderBackground", ()=>multiDiffEditorHeaderBackground);
parcelHelpers.export(exports, "multiDiffEditorBackground", ()=>multiDiffEditorBackground);
parcelHelpers.export(exports, "multiDiffEditorBorder", ()=>multiDiffEditorBorder);
var _nlsJs = require("../../../../nls.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
const multiDiffEditorHeaderBackground = (0, _colorRegistryJs.registerColor)("multiDiffEditor.headerBackground", {
    dark: "#262626",
    light: "tab.inactiveBackground",
    hcDark: "tab.inactiveBackground",
    hcLight: "tab.inactiveBackground"
}, (0, _nlsJs.localize)("multiDiffEditor.headerBackground", "The background color of the diff editor's header"));
const multiDiffEditorBackground = (0, _colorRegistryJs.registerColor)("multiDiffEditor.background", (0, _colorRegistryJs.editorBackground), (0, _nlsJs.localize)("multiDiffEditor.background", "The background color of the multi file diff editor"));
const multiDiffEditorBorder = (0, _colorRegistryJs.registerColor)("multiDiffEditor.border", {
    dark: "sideBarSectionHeader.border",
    light: "#cccccc",
    hcDark: "sideBarSectionHeader.border",
    hcLight: "#cccccc"
}, (0, _nlsJs.localize)("multiDiffEditor.border", "The border color of the multi file diff editor"));

},{"../../../../nls.js":"l617d","../../../../platform/theme/common/colorRegistry.js":"ik5kv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eQn4G":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Register information about a new language.
 */ parcelHelpers.export(exports, "register", ()=>register);
/**
 * Get the information of all the registered languages.
 */ parcelHelpers.export(exports, "getLanguages", ()=>getLanguages);
parcelHelpers.export(exports, "getEncodedLanguageId", ()=>getEncodedLanguageId);
/**
 * An event emitted when a language is associated for the first time with a text model.
 * @event
 */ parcelHelpers.export(exports, "onLanguage", ()=>onLanguage);
/**
 * An event emitted when a language is associated for the first time with a text model or
 * when a language is encountered during the tokenization of another language.
 * @event
 */ parcelHelpers.export(exports, "onLanguageEncountered", ()=>onLanguageEncountered);
/**
 * Set the editing configuration for a language.
 */ parcelHelpers.export(exports, "setLanguageConfiguration", ()=>setLanguageConfiguration);
/**
 * @internal
 */ parcelHelpers.export(exports, "EncodedTokenizationSupportAdapter", ()=>EncodedTokenizationSupportAdapter);
/**
 * @internal
 */ parcelHelpers.export(exports, "TokenizationSupportAdapter", ()=>TokenizationSupportAdapter);
/**
 * Change the color map that is used for token colors.
 * Supported formats (hex): #RRGGBB, $RRGGBBAA, #RGB, #RGBA
 */ parcelHelpers.export(exports, "setColorMap", ()=>setColorMap);
/**
 * Register a tokens provider factory for a language. This tokenizer will be exclusive with a tokenizer
 * set using `setTokensProvider` or one created using `setMonarchTokensProvider`, but will work together
 * with a tokens provider set using `registerDocumentSemanticTokensProvider` or `registerDocumentRangeSemanticTokensProvider`.
 */ parcelHelpers.export(exports, "registerTokensProviderFactory", ()=>registerTokensProviderFactory);
/**
 * Set the tokens provider for a language (manual implementation). This tokenizer will be exclusive
 * with a tokenizer created using `setMonarchTokensProvider`, or with `registerTokensProviderFactory`,
 * but will work together with a tokens provider set using `registerDocumentSemanticTokensProvider`
 * or `registerDocumentRangeSemanticTokensProvider`.
 */ parcelHelpers.export(exports, "setTokensProvider", ()=>setTokensProvider);
/**
 * Set the tokens provider for a language (monarch implementation). This tokenizer will be exclusive
 * with a tokenizer set using `setTokensProvider`, or with `registerTokensProviderFactory`, but will
 * work together with a tokens provider set using `registerDocumentSemanticTokensProvider` or
 * `registerDocumentRangeSemanticTokensProvider`.
 */ parcelHelpers.export(exports, "setMonarchTokensProvider", ()=>setMonarchTokensProvider);
/**
 * Register a reference provider (used by e.g. reference search).
 */ parcelHelpers.export(exports, "registerReferenceProvider", ()=>registerReferenceProvider);
/**
 * Register a rename provider (used by e.g. rename symbol).
 */ parcelHelpers.export(exports, "registerRenameProvider", ()=>registerRenameProvider);
/**
 * Register a new symbol-name provider (e.g., when a symbol is being renamed, show new possible symbol-names)
 */ parcelHelpers.export(exports, "registerNewSymbolNameProvider", ()=>registerNewSymbolNameProvider);
/**
 * Register a signature help provider (used by e.g. parameter hints).
 */ parcelHelpers.export(exports, "registerSignatureHelpProvider", ()=>registerSignatureHelpProvider);
/**
 * Register a hover provider (used by e.g. editor hover).
 */ parcelHelpers.export(exports, "registerHoverProvider", ()=>registerHoverProvider);
/**
 * Register a document symbol provider (used by e.g. outline).
 */ parcelHelpers.export(exports, "registerDocumentSymbolProvider", ()=>registerDocumentSymbolProvider);
/**
 * Register a document highlight provider (used by e.g. highlight occurrences).
 */ parcelHelpers.export(exports, "registerDocumentHighlightProvider", ()=>registerDocumentHighlightProvider);
/**
 * Register an linked editing range provider.
 */ parcelHelpers.export(exports, "registerLinkedEditingRangeProvider", ()=>registerLinkedEditingRangeProvider);
/**
 * Register a definition provider (used by e.g. go to definition).
 */ parcelHelpers.export(exports, "registerDefinitionProvider", ()=>registerDefinitionProvider);
/**
 * Register a implementation provider (used by e.g. go to implementation).
 */ parcelHelpers.export(exports, "registerImplementationProvider", ()=>registerImplementationProvider);
/**
 * Register a type definition provider (used by e.g. go to type definition).
 */ parcelHelpers.export(exports, "registerTypeDefinitionProvider", ()=>registerTypeDefinitionProvider);
/**
 * Register a code lens provider (used by e.g. inline code lenses).
 */ parcelHelpers.export(exports, "registerCodeLensProvider", ()=>registerCodeLensProvider);
/**
 * Register a code action provider (used by e.g. quick fix).
 */ parcelHelpers.export(exports, "registerCodeActionProvider", ()=>registerCodeActionProvider);
/**
 * Register a formatter that can handle only entire models.
 */ parcelHelpers.export(exports, "registerDocumentFormattingEditProvider", ()=>registerDocumentFormattingEditProvider);
/**
 * Register a formatter that can handle a range inside a model.
 */ parcelHelpers.export(exports, "registerDocumentRangeFormattingEditProvider", ()=>registerDocumentRangeFormattingEditProvider);
/**
 * Register a formatter than can do formatting as the user types.
 */ parcelHelpers.export(exports, "registerOnTypeFormattingEditProvider", ()=>registerOnTypeFormattingEditProvider);
/**
 * Register a link provider that can find links in text.
 */ parcelHelpers.export(exports, "registerLinkProvider", ()=>registerLinkProvider);
/**
 * Register a completion item provider (use by e.g. suggestions).
 */ parcelHelpers.export(exports, "registerCompletionItemProvider", ()=>registerCompletionItemProvider);
/**
 * Register a document color provider (used by Color Picker, Color Decorator).
 */ parcelHelpers.export(exports, "registerColorProvider", ()=>registerColorProvider);
/**
 * Register a folding range provider
 */ parcelHelpers.export(exports, "registerFoldingRangeProvider", ()=>registerFoldingRangeProvider);
/**
 * Register a declaration provider
 */ parcelHelpers.export(exports, "registerDeclarationProvider", ()=>registerDeclarationProvider);
/**
 * Register a selection range provider
 */ parcelHelpers.export(exports, "registerSelectionRangeProvider", ()=>registerSelectionRangeProvider);
/**
 * Register a document semantic tokens provider. A semantic tokens provider will complement and enhance a
 * simple top-down tokenizer. Simple top-down tokenizers can be set either via `setMonarchTokensProvider`
 * or `setTokensProvider`.
 *
 * For the best user experience, register both a semantic tokens provider and a top-down tokenizer.
 */ parcelHelpers.export(exports, "registerDocumentSemanticTokensProvider", ()=>registerDocumentSemanticTokensProvider);
/**
 * Register a document range semantic tokens provider. A semantic tokens provider will complement and enhance a
 * simple top-down tokenizer. Simple top-down tokenizers can be set either via `setMonarchTokensProvider`
 * or `setTokensProvider`.
 *
 * For the best user experience, register both a semantic tokens provider and a top-down tokenizer.
 */ parcelHelpers.export(exports, "registerDocumentRangeSemanticTokensProvider", ()=>registerDocumentRangeSemanticTokensProvider);
/**
 * Register an inline completions provider.
 */ parcelHelpers.export(exports, "registerInlineCompletionsProvider", ()=>registerInlineCompletionsProvider);
parcelHelpers.export(exports, "registerInlineEditProvider", ()=>registerInlineEditProvider);
/**
 * Register an inlay hints provider.
 */ parcelHelpers.export(exports, "registerInlayHintsProvider", ()=>registerInlayHintsProvider);
/**
 * @internal
 */ parcelHelpers.export(exports, "createMonacoLanguagesAPI", ()=>createMonacoLanguagesAPI);
var _colorJs = require("../../../base/common/color.js");
var _rangeJs = require("../../common/core/range.js");
var _languagesJs = require("../../common/languages.js");
var _languageJs = require("../../common/languages/language.js");
var _languageConfigurationRegistryJs = require("../../common/languages/languageConfigurationRegistry.js");
var _modesRegistryJs = require("../../common/languages/modesRegistry.js");
var _languageFeaturesJs = require("../../common/services/languageFeatures.js");
var _standaloneEnumsJs = require("../../common/standalone/standaloneEnums.js");
var _standaloneServicesJs = require("./standaloneServices.js");
var _monarchCompileJs = require("../common/monarch/monarchCompile.js");
var _monarchLexerJs = require("../common/monarch/monarchLexer.js");
var _standaloneThemeJs = require("../common/standaloneTheme.js");
var _configurationJs = require("../../../platform/configuration/common/configuration.js");
var _markersJs = require("../../../platform/markers/common/markers.js");
function register(language) {
    // Intentionally using the `ModesRegistry` here to avoid
    // instantiating services too quickly in the standalone editor.
    (0, _modesRegistryJs.ModesRegistry).registerLanguage(language);
}
function getLanguages() {
    let result = [];
    result = result.concat((0, _modesRegistryJs.ModesRegistry).getLanguages());
    return result;
}
function getEncodedLanguageId(languageId) {
    const languageService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageJs.ILanguageService));
    return languageService.languageIdCodec.encodeLanguageId(languageId);
}
function onLanguage(languageId, callback) {
    return (0, _standaloneServicesJs.StandaloneServices).withServices(()=>{
        const languageService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageJs.ILanguageService));
        const disposable = languageService.onDidRequestRichLanguageFeatures((encounteredLanguageId)=>{
            if (encounteredLanguageId === languageId) {
                // stop listening
                disposable.dispose();
                // invoke actual listener
                callback();
            }
        });
        return disposable;
    });
}
function onLanguageEncountered(languageId, callback) {
    return (0, _standaloneServicesJs.StandaloneServices).withServices(()=>{
        const languageService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageJs.ILanguageService));
        const disposable = languageService.onDidRequestBasicLanguageFeatures((encounteredLanguageId)=>{
            if (encounteredLanguageId === languageId) {
                // stop listening
                disposable.dispose();
                // invoke actual listener
                callback();
            }
        });
        return disposable;
    });
}
function setLanguageConfiguration(languageId, configuration) {
    const languageService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageJs.ILanguageService));
    if (!languageService.isRegisteredLanguageId(languageId)) throw new Error(`Cannot set configuration for unknown language ${languageId}`);
    const languageConfigurationService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageConfigurationRegistryJs.ILanguageConfigurationService));
    return languageConfigurationService.register(languageId, configuration, 100);
}
class EncodedTokenizationSupportAdapter {
    constructor(languageId, actual){
        this._languageId = languageId;
        this._actual = actual;
    }
    dispose() {
    // NOOP
    }
    getInitialState() {
        return this._actual.getInitialState();
    }
    tokenize(line, hasEOL, state) {
        if (typeof this._actual.tokenize === "function") return TokenizationSupportAdapter.adaptTokenize(this._languageId, this._actual, line, state);
        throw new Error("Not supported!");
    }
    tokenizeEncoded(line, hasEOL, state) {
        const result = this._actual.tokenizeEncoded(line, state);
        return new _languagesJs.EncodedTokenizationResult(result.tokens, result.endState);
    }
}
class TokenizationSupportAdapter {
    constructor(_languageId, _actual, _languageService, _standaloneThemeService){
        this._languageId = _languageId;
        this._actual = _actual;
        this._languageService = _languageService;
        this._standaloneThemeService = _standaloneThemeService;
    }
    dispose() {
    // NOOP
    }
    getInitialState() {
        return this._actual.getInitialState();
    }
    static _toClassicTokens(tokens, language) {
        const result = [];
        let previousStartIndex = 0;
        for(let i = 0, len = tokens.length; i < len; i++){
            const t = tokens[i];
            let startIndex = t.startIndex;
            // Prevent issues stemming from a buggy external tokenizer.
            if (i === 0) // Force first token to start at first index!
            startIndex = 0;
            else if (startIndex < previousStartIndex) // Force tokens to be after one another!
            startIndex = previousStartIndex;
            result[i] = new _languagesJs.Token(startIndex, t.scopes, language);
            previousStartIndex = startIndex;
        }
        return result;
    }
    static adaptTokenize(language, actual, line, state) {
        const actualResult = actual.tokenize(line, state);
        const tokens = TokenizationSupportAdapter._toClassicTokens(actualResult.tokens, language);
        let endState;
        // try to save an object if possible
        if (actualResult.endState.equals(state)) endState = state;
        else endState = actualResult.endState;
        return new _languagesJs.TokenizationResult(tokens, endState);
    }
    tokenize(line, hasEOL, state) {
        return TokenizationSupportAdapter.adaptTokenize(this._languageId, this._actual, line, state);
    }
    _toBinaryTokens(languageIdCodec, tokens) {
        const languageId = languageIdCodec.encodeLanguageId(this._languageId);
        const tokenTheme = this._standaloneThemeService.getColorTheme().tokenTheme;
        const result = [];
        let resultLen = 0;
        let previousStartIndex = 0;
        for(let i = 0, len = tokens.length; i < len; i++){
            const t = tokens[i];
            const metadata = tokenTheme.match(languageId, t.scopes) | 1024 /* MetadataConsts.BALANCED_BRACKETS_MASK */ ;
            if (resultLen > 0 && result[resultLen - 1] === metadata) continue;
            let startIndex = t.startIndex;
            // Prevent issues stemming from a buggy external tokenizer.
            if (i === 0) // Force first token to start at first index!
            startIndex = 0;
            else if (startIndex < previousStartIndex) // Force tokens to be after one another!
            startIndex = previousStartIndex;
            result[resultLen++] = startIndex;
            result[resultLen++] = metadata;
            previousStartIndex = startIndex;
        }
        const actualResult = new Uint32Array(resultLen);
        for(let i = 0; i < resultLen; i++)actualResult[i] = result[i];
        return actualResult;
    }
    tokenizeEncoded(line, hasEOL, state) {
        const actualResult = this._actual.tokenize(line, state);
        const tokens = this._toBinaryTokens(this._languageService.languageIdCodec, actualResult.tokens);
        let endState;
        // try to save an object if possible
        if (actualResult.endState.equals(state)) endState = state;
        else endState = actualResult.endState;
        return new _languagesJs.EncodedTokenizationResult(tokens, endState);
    }
}
function isATokensProvider(provider) {
    return typeof provider.getInitialState === "function";
}
function isEncodedTokensProvider(provider) {
    return "tokenizeEncoded" in provider;
}
function isThenable(obj) {
    return obj && typeof obj.then === "function";
}
function setColorMap(colorMap) {
    const standaloneThemeService = (0, _standaloneServicesJs.StandaloneServices).get((0, _standaloneThemeJs.IStandaloneThemeService));
    if (colorMap) {
        const result = [
            null
        ];
        for(let i = 1, len = colorMap.length; i < len; i++)result[i] = (0, _colorJs.Color).fromHex(colorMap[i]);
        standaloneThemeService.setColorMapOverride(result);
    } else standaloneThemeService.setColorMapOverride(null);
}
/**
 * @internal
 */ function createTokenizationSupportAdapter(languageId, provider) {
    if (isEncodedTokensProvider(provider)) return new EncodedTokenizationSupportAdapter(languageId, provider);
    else return new TokenizationSupportAdapter(languageId, provider, (0, _standaloneServicesJs.StandaloneServices).get((0, _languageJs.ILanguageService)), (0, _standaloneServicesJs.StandaloneServices).get((0, _standaloneThemeJs.IStandaloneThemeService)));
}
function registerTokensProviderFactory(languageId, factory) {
    const adaptedFactory = new _languagesJs.LazyTokenizationSupport(async ()=>{
        const result = await Promise.resolve(factory.create());
        if (!result) return null;
        if (isATokensProvider(result)) return createTokenizationSupportAdapter(languageId, result);
        return new (0, _monarchLexerJs.MonarchTokenizer)((0, _standaloneServicesJs.StandaloneServices).get((0, _languageJs.ILanguageService)), (0, _standaloneServicesJs.StandaloneServices).get((0, _standaloneThemeJs.IStandaloneThemeService)), languageId, (0, _monarchCompileJs.compile)(languageId, result), (0, _standaloneServicesJs.StandaloneServices).get((0, _configurationJs.IConfigurationService)));
    });
    return _languagesJs.TokenizationRegistry.registerFactory(languageId, adaptedFactory);
}
function setTokensProvider(languageId, provider) {
    const languageService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageJs.ILanguageService));
    if (!languageService.isRegisteredLanguageId(languageId)) throw new Error(`Cannot set tokens provider for unknown language ${languageId}`);
    if (isThenable(provider)) return registerTokensProviderFactory(languageId, {
        create: ()=>provider
    });
    return _languagesJs.TokenizationRegistry.register(languageId, createTokenizationSupportAdapter(languageId, provider));
}
function setMonarchTokensProvider(languageId, languageDef) {
    const create = (languageDef)=>{
        return new (0, _monarchLexerJs.MonarchTokenizer)((0, _standaloneServicesJs.StandaloneServices).get((0, _languageJs.ILanguageService)), (0, _standaloneServicesJs.StandaloneServices).get((0, _standaloneThemeJs.IStandaloneThemeService)), languageId, (0, _monarchCompileJs.compile)(languageId, languageDef), (0, _standaloneServicesJs.StandaloneServices).get((0, _configurationJs.IConfigurationService)));
    };
    if (isThenable(languageDef)) return registerTokensProviderFactory(languageId, {
        create: ()=>languageDef
    });
    return _languagesJs.TokenizationRegistry.register(languageId, create(languageDef));
}
function registerReferenceProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.referenceProvider.register(languageSelector, provider);
}
function registerRenameProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.renameProvider.register(languageSelector, provider);
}
function registerNewSymbolNameProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.newSymbolNamesProvider.register(languageSelector, provider);
}
function registerSignatureHelpProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.signatureHelpProvider.register(languageSelector, provider);
}
function registerHoverProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.hoverProvider.register(languageSelector, {
        provideHover: async (model, position, token, context)=>{
            const word = model.getWordAtPosition(position);
            return Promise.resolve(provider.provideHover(model, position, token, context)).then((value)=>{
                if (!value) return undefined;
                if (!value.range && word) value.range = new (0, _rangeJs.Range)(position.lineNumber, word.startColumn, position.lineNumber, word.endColumn);
                if (!value.range) value.range = new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column);
                return value;
            });
        }
    });
}
function registerDocumentSymbolProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.documentSymbolProvider.register(languageSelector, provider);
}
function registerDocumentHighlightProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.documentHighlightProvider.register(languageSelector, provider);
}
function registerLinkedEditingRangeProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.linkedEditingRangeProvider.register(languageSelector, provider);
}
function registerDefinitionProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.definitionProvider.register(languageSelector, provider);
}
function registerImplementationProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.implementationProvider.register(languageSelector, provider);
}
function registerTypeDefinitionProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.typeDefinitionProvider.register(languageSelector, provider);
}
function registerCodeLensProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.codeLensProvider.register(languageSelector, provider);
}
function registerCodeActionProvider(languageSelector, provider, metadata) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.codeActionProvider.register(languageSelector, {
        providedCodeActionKinds: metadata?.providedCodeActionKinds,
        documentation: metadata?.documentation,
        provideCodeActions: (model, range, context, token)=>{
            const markerService = (0, _standaloneServicesJs.StandaloneServices).get((0, _markersJs.IMarkerService));
            const markers = markerService.read({
                resource: model.uri
            }).filter((m)=>{
                return (0, _rangeJs.Range).areIntersectingOrTouching(m, range);
            });
            return provider.provideCodeActions(model, range, {
                markers,
                only: context.only,
                trigger: context.trigger
            }, token);
        },
        resolveCodeAction: provider.resolveCodeAction
    });
}
function registerDocumentFormattingEditProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.documentFormattingEditProvider.register(languageSelector, provider);
}
function registerDocumentRangeFormattingEditProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.documentRangeFormattingEditProvider.register(languageSelector, provider);
}
function registerOnTypeFormattingEditProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.onTypeFormattingEditProvider.register(languageSelector, provider);
}
function registerLinkProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.linkProvider.register(languageSelector, provider);
}
function registerCompletionItemProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.completionProvider.register(languageSelector, provider);
}
function registerColorProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.colorProvider.register(languageSelector, provider);
}
function registerFoldingRangeProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.foldingRangeProvider.register(languageSelector, provider);
}
function registerDeclarationProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.declarationProvider.register(languageSelector, provider);
}
function registerSelectionRangeProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.selectionRangeProvider.register(languageSelector, provider);
}
function registerDocumentSemanticTokensProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.documentSemanticTokensProvider.register(languageSelector, provider);
}
function registerDocumentRangeSemanticTokensProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.documentRangeSemanticTokensProvider.register(languageSelector, provider);
}
function registerInlineCompletionsProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.inlineCompletionsProvider.register(languageSelector, provider);
}
function registerInlineEditProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.inlineEditProvider.register(languageSelector, provider);
}
function registerInlayHintsProvider(languageSelector, provider) {
    const languageFeaturesService = (0, _standaloneServicesJs.StandaloneServices).get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return languageFeaturesService.inlayHintsProvider.register(languageSelector, provider);
}
function createMonacoLanguagesAPI() {
    return {
        register: register,
        getLanguages: getLanguages,
        onLanguage: onLanguage,
        onLanguageEncountered: onLanguageEncountered,
        getEncodedLanguageId: getEncodedLanguageId,
        // provider methods
        setLanguageConfiguration: setLanguageConfiguration,
        setColorMap: setColorMap,
        registerTokensProviderFactory: registerTokensProviderFactory,
        setTokensProvider: setTokensProvider,
        setMonarchTokensProvider: setMonarchTokensProvider,
        registerReferenceProvider: registerReferenceProvider,
        registerRenameProvider: registerRenameProvider,
        registerNewSymbolNameProvider: registerNewSymbolNameProvider,
        registerCompletionItemProvider: registerCompletionItemProvider,
        registerSignatureHelpProvider: registerSignatureHelpProvider,
        registerHoverProvider: registerHoverProvider,
        registerDocumentSymbolProvider: registerDocumentSymbolProvider,
        registerDocumentHighlightProvider: registerDocumentHighlightProvider,
        registerLinkedEditingRangeProvider: registerLinkedEditingRangeProvider,
        registerDefinitionProvider: registerDefinitionProvider,
        registerImplementationProvider: registerImplementationProvider,
        registerTypeDefinitionProvider: registerTypeDefinitionProvider,
        registerCodeLensProvider: registerCodeLensProvider,
        registerCodeActionProvider: registerCodeActionProvider,
        registerDocumentFormattingEditProvider: registerDocumentFormattingEditProvider,
        registerDocumentRangeFormattingEditProvider: registerDocumentRangeFormattingEditProvider,
        registerOnTypeFormattingEditProvider: registerOnTypeFormattingEditProvider,
        registerLinkProvider: registerLinkProvider,
        registerColorProvider: registerColorProvider,
        registerFoldingRangeProvider: registerFoldingRangeProvider,
        registerDeclarationProvider: registerDeclarationProvider,
        registerSelectionRangeProvider: registerSelectionRangeProvider,
        registerDocumentSemanticTokensProvider: registerDocumentSemanticTokensProvider,
        registerDocumentRangeSemanticTokensProvider: registerDocumentRangeSemanticTokensProvider,
        registerInlineCompletionsProvider: registerInlineCompletionsProvider,
        registerInlineEditProvider: registerInlineEditProvider,
        registerInlayHintsProvider: registerInlayHintsProvider,
        // enums
        DocumentHighlightKind: _standaloneEnumsJs.DocumentHighlightKind,
        CompletionItemKind: _standaloneEnumsJs.CompletionItemKind,
        CompletionItemTag: _standaloneEnumsJs.CompletionItemTag,
        CompletionItemInsertTextRule: _standaloneEnumsJs.CompletionItemInsertTextRule,
        SymbolKind: _standaloneEnumsJs.SymbolKind,
        SymbolTag: _standaloneEnumsJs.SymbolTag,
        IndentAction: _standaloneEnumsJs.IndentAction,
        CompletionTriggerKind: _standaloneEnumsJs.CompletionTriggerKind,
        SignatureHelpTriggerKind: _standaloneEnumsJs.SignatureHelpTriggerKind,
        InlayHintKind: _standaloneEnumsJs.InlayHintKind,
        InlineCompletionTriggerKind: _standaloneEnumsJs.InlineCompletionTriggerKind,
        InlineEditTriggerKind: _standaloneEnumsJs.InlineEditTriggerKind,
        CodeActionTriggerType: _standaloneEnumsJs.CodeActionTriggerType,
        NewSymbolNameTag: _standaloneEnumsJs.NewSymbolNameTag,
        NewSymbolNameTriggerKind: _standaloneEnumsJs.NewSymbolNameTriggerKind,
        PartialAcceptTriggerKind: _standaloneEnumsJs.PartialAcceptTriggerKind,
        HoverVerbosityAction: _standaloneEnumsJs.HoverVerbosityAction,
        // classes
        FoldingRangeKind: _languagesJs.FoldingRangeKind,
        SelectedSuggestionInfo: _languagesJs.SelectedSuggestionInfo
    };
}

},{"../../../base/common/color.js":"at4gb","../../common/core/range.js":"jmUPh","../../common/languages.js":"g5n96","../../common/languages/language.js":"ka2JQ","../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../common/languages/modesRegistry.js":"gqkb7","../../common/services/languageFeatures.js":"2IAko","../../common/standalone/standaloneEnums.js":"7JLc0","./standaloneServices.js":"3py7i","../common/monarch/monarchCompile.js":"5YCLK","../common/monarch/monarchLexer.js":"1mCsI","../common/standaloneTheme.js":"exW2E","../../../platform/configuration/common/configuration.js":"dXkjq","../../../platform/markers/common/markers.js":"aaeXc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5YCLK":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ /*
 * This module only exports 'compile' which compiles a JSON language definition
 * into a typed and checked ILexer definition.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Compiles a json description function into json where all regular expressions,
 * case matches etc, are compiled and all include rules are expanded.
 * We also compile the bracket definitions, supply defaults, and do many sanity checks.
 * If the 'jsonStrict' parameter is 'false', we allow at certain locations
 * regular expression objects and functions that get called during lexing.
 * (Currently we have no samples that need this so perhaps we should always have
 * jsonStrict to true).
 */ parcelHelpers.export(exports, "compile", ()=>compile);
var _monarchCommonJs = require("./monarchCommon.js");
/*
 * Type helpers
 *
 * Note: this is just for sanity checks on the JSON description which is
 * helpful for the programmer. No checks are done anymore once the lexer is
 * already 'compiled and checked'.
 *
 */ function isArrayOf(elemType, obj) {
    if (!obj) return false;
    if (!Array.isArray(obj)) return false;
    for (const el of obj){
        if (!elemType(el)) return false;
    }
    return true;
}
function bool(prop, defValue) {
    if (typeof prop === "boolean") return prop;
    return defValue;
}
function string(prop, defValue) {
    if (typeof prop === "string") return prop;
    return defValue;
}
function arrayToHash(array) {
    const result = {};
    for (const e of array)result[e] = true;
    return result;
}
function createKeywordMatcher(arr, caseInsensitive = false) {
    if (caseInsensitive) arr = arr.map(function(x) {
        return x.toLowerCase();
    });
    const hash = arrayToHash(arr);
    if (caseInsensitive) return function(word) {
        return hash[word.toLowerCase()] !== undefined && hash.hasOwnProperty(word.toLowerCase());
    };
    else return function(word) {
        return hash[word] !== undefined && hash.hasOwnProperty(word);
    };
}
function compileRegExp(lexer, str, handleSn) {
    // @@ must be interpreted as a literal @, so we replace all occurences of @@ with a placeholder character
    str = str.replace(/@@/g, `\x01`);
    let n = 0;
    let hadExpansion;
    do {
        hadExpansion = false;
        str = str.replace(/@(\w+)/g, function(s, attr) {
            hadExpansion = true;
            let sub = "";
            if (typeof lexer[attr] === "string") sub = lexer[attr];
            else if (lexer[attr] && lexer[attr] instanceof RegExp) sub = lexer[attr].source;
            else {
                if (lexer[attr] === undefined) throw _monarchCommonJs.createError(lexer, "language definition does not contain attribute '" + attr + "', used at: " + str);
                else throw _monarchCommonJs.createError(lexer, "attribute reference '" + attr + "' must be a string, used at: " + str);
            }
            return _monarchCommonJs.empty(sub) ? "" : "(?:" + sub + ")";
        });
        n++;
    }while (hadExpansion && n < 5);
    // handle escaped @@
    str = str.replace(/\x01/g, "@");
    const flags = (lexer.ignoreCase ? "i" : "") + (lexer.unicode ? "u" : "");
    // handle $Sn
    if (handleSn) {
        const match = str.match(/\$[sS](\d\d?)/g);
        if (match) {
            let lastState = null;
            let lastRegEx = null;
            return (state)=>{
                if (lastRegEx && lastState === state) return lastRegEx;
                lastState = state;
                lastRegEx = new RegExp(_monarchCommonJs.substituteMatchesRe(lexer, str, state), flags);
                return lastRegEx;
            };
        }
    }
    return new RegExp(str, flags);
}
/**
 * Compiles guard functions for case matches.
 * This compiles 'cases' attributes into efficient match functions.
 *
 */ function selectScrutinee(id, matches, state, num) {
    if (num < 0) return id;
    if (num < matches.length) return matches[num];
    if (num >= 100) {
        num = num - 100;
        const parts = state.split(".");
        parts.unshift(state);
        if (num < parts.length) return parts[num];
    }
    return null;
}
function createGuard(lexer, ruleName, tkey, val) {
    // get the scrutinee and pattern
    let scrut = -1; // -1: $!, 0-99: $n, 100+n: $Sn
    let oppat = tkey;
    let matches = tkey.match(/^\$(([sS]?)(\d\d?)|#)(.*)$/);
    if (matches) {
        if (matches[3]) {
            scrut = parseInt(matches[3]);
            if (matches[2]) scrut = scrut + 100; // if [sS] present
        }
        oppat = matches[4];
    }
    // get operator
    let op = "~";
    let pat = oppat;
    if (!oppat || oppat.length === 0) {
        op = "!=";
        pat = "";
    } else if (/^\w*$/.test(pat)) op = "==";
    else {
        matches = oppat.match(/^(@|!@|~|!~|==|!=)(.*)$/);
        if (matches) {
            op = matches[1];
            pat = matches[2];
        }
    }
    // set the tester function
    let tester;
    // special case a regexp that matches just words
    if ((op === "~" || op === "!~") && /^(\w|\|)*$/.test(pat)) {
        const inWords = createKeywordMatcher(pat.split("|"), lexer.ignoreCase);
        tester = function(s) {
            return op === "~" ? inWords(s) : !inWords(s);
        };
    } else if (op === "@" || op === "!@") {
        const words = lexer[pat];
        if (!words) throw _monarchCommonJs.createError(lexer, "the @ match target '" + pat + "' is not defined, in rule: " + ruleName);
        if (!isArrayOf(function(elem) {
            return typeof elem === "string";
        }, words)) throw _monarchCommonJs.createError(lexer, "the @ match target '" + pat + "' must be an array of strings, in rule: " + ruleName);
        const inWords = createKeywordMatcher(words, lexer.ignoreCase);
        tester = function(s) {
            return op === "@" ? inWords(s) : !inWords(s);
        };
    } else if (op === "~" || op === "!~") {
        if (pat.indexOf("$") < 0) {
            // precompile regular expression
            const re = compileRegExp(lexer, "^" + pat + "$", false);
            tester = function(s) {
                return op === "~" ? re.test(s) : !re.test(s);
            };
        } else tester = function(s, id, matches, state) {
            const re = compileRegExp(lexer, "^" + _monarchCommonJs.substituteMatches(lexer, pat, id, matches, state) + "$", false);
            return re.test(s);
        };
    } else if (pat.indexOf("$") < 0) {
        const patx = _monarchCommonJs.fixCase(lexer, pat);
        tester = function(s) {
            return op === "==" ? s === patx : s !== patx;
        };
    } else {
        const patx = _monarchCommonJs.fixCase(lexer, pat);
        tester = function(s, id, matches, state, eos) {
            const patexp = _monarchCommonJs.substituteMatches(lexer, patx, id, matches, state);
            return op === "==" ? s === patexp : s !== patexp;
        };
    }
    // return the branch object
    if (scrut === -1) return {
        name: tkey,
        value: val,
        test: function(id, matches, state, eos) {
            return tester(id, id, matches, state, eos);
        }
    };
    else return {
        name: tkey,
        value: val,
        test: function(id, matches, state, eos) {
            const scrutinee = selectScrutinee(id, matches, state, scrut);
            return tester(!scrutinee ? "" : scrutinee, id, matches, state, eos);
        }
    };
}
/**
 * Compiles an action: i.e. optimize regular expressions and case matches
 * and do many sanity checks.
 *
 * This is called only during compilation but if the lexer definition
 * contains user functions as actions (which is usually not allowed), then this
 * may be called during lexing. It is important therefore to compile common cases efficiently
 */ function compileAction(lexer, ruleName, action) {
    if (!action) return {
        token: ""
    };
    else if (typeof action === "string") return action; // { token: action };
    else if (action.token || action.token === "") {
        if (typeof action.token !== "string") throw _monarchCommonJs.createError(lexer, "a 'token' attribute must be of type string, in rule: " + ruleName);
        else {
            // only copy specific typed fields (only happens once during compile Lexer)
            const newAction = {
                token: action.token
            };
            if (action.token.indexOf("$") >= 0) newAction.tokenSubst = true;
            if (typeof action.bracket === "string") {
                if (action.bracket === "@open") newAction.bracket = 1 /* monarchCommon.MonarchBracket.Open */ ;
                else if (action.bracket === "@close") newAction.bracket = -1 /* monarchCommon.MonarchBracket.Close */ ;
                else throw _monarchCommonJs.createError(lexer, "a 'bracket' attribute must be either '@open' or '@close', in rule: " + ruleName);
            }
            if (action.next) {
                if (typeof action.next !== "string") throw _monarchCommonJs.createError(lexer, "the next state must be a string value in rule: " + ruleName);
                else {
                    let next = action.next;
                    if (!/^(@pop|@push|@popall)$/.test(next)) {
                        if (next[0] === "@") next = next.substr(1); // peel off starting @ sign
                        if (next.indexOf("$") < 0) {
                            if (!_monarchCommonJs.stateExists(lexer, _monarchCommonJs.substituteMatches(lexer, next, "", [], ""))) throw _monarchCommonJs.createError(lexer, "the next state '" + action.next + "' is not defined in rule: " + ruleName);
                        }
                    }
                    newAction.next = next;
                }
            }
            if (typeof action.goBack === "number") newAction.goBack = action.goBack;
            if (typeof action.switchTo === "string") newAction.switchTo = action.switchTo;
            if (typeof action.log === "string") newAction.log = action.log;
            if (typeof action.nextEmbedded === "string") {
                newAction.nextEmbedded = action.nextEmbedded;
                lexer.usesEmbedded = true;
            }
            return newAction;
        }
    } else if (Array.isArray(action)) {
        const results = [];
        for(let i = 0, len = action.length; i < len; i++)results[i] = compileAction(lexer, ruleName, action[i]);
        return {
            group: results
        };
    } else if (action.cases) {
        // build an array of test cases
        const cases = [];
        // for each case, push a test function and result value
        for(const tkey in action.cases)if (action.cases.hasOwnProperty(tkey)) {
            const val = compileAction(lexer, ruleName, action.cases[tkey]);
            // what kind of case
            if (tkey === "@default" || tkey === "@" || tkey === "") cases.push({
                test: undefined,
                value: val,
                name: tkey
            });
            else if (tkey === "@eos") cases.push({
                test: function(id, matches, state, eos) {
                    return eos;
                },
                value: val,
                name: tkey
            });
            else cases.push(createGuard(lexer, ruleName, tkey, val)); // call separate function to avoid local variable capture
        }
        // create a matching function
        const def = lexer.defaultToken;
        return {
            test: function(id, matches, state, eos) {
                for (const _case of cases){
                    const didmatch = !_case.test || _case.test(id, matches, state, eos);
                    if (didmatch) return _case.value;
                }
                return def;
            }
        };
    } else throw _monarchCommonJs.createError(lexer, "an action must be a string, an object with a 'token' or 'cases' attribute, or an array of actions; in rule: " + ruleName);
}
/**
 * Helper class for creating matching rules
 */ class Rule {
    constructor(name){
        this.regex = new RegExp("");
        this.action = {
            token: ""
        };
        this.matchOnlyAtLineStart = false;
        this.name = "";
        this.name = name;
    }
    setRegex(lexer, re) {
        let sregex;
        if (typeof re === "string") sregex = re;
        else if (re instanceof RegExp) sregex = re.source;
        else throw _monarchCommonJs.createError(lexer, "rules must start with a match string or regular expression: " + this.name);
        this.matchOnlyAtLineStart = sregex.length > 0 && sregex[0] === "^";
        this.name = this.name + ": " + sregex;
        this.regex = compileRegExp(lexer, "^(?:" + (this.matchOnlyAtLineStart ? sregex.substr(1) : sregex) + ")", true);
    }
    setAction(lexer, act) {
        this.action = compileAction(lexer, this.name, act);
    }
    resolveRegex(state) {
        if (this.regex instanceof RegExp) return this.regex;
        else return this.regex(state);
    }
}
function compile(languageId, json) {
    if (!json || typeof json !== "object") throw new Error("Monarch: expecting a language definition object");
    // Create our lexer
    const lexer = {
        languageId: languageId,
        includeLF: bool(json.includeLF, false),
        noThrow: false,
        maxStack: 100,
        start: typeof json.start === "string" ? json.start : null,
        ignoreCase: bool(json.ignoreCase, false),
        unicode: bool(json.unicode, false),
        tokenPostfix: string(json.tokenPostfix, "." + languageId),
        defaultToken: string(json.defaultToken, "source"),
        usesEmbedded: false,
        stateNames: {},
        tokenizer: {},
        brackets: []
    };
    // For calling compileAction later on
    const lexerMin = json;
    lexerMin.languageId = languageId;
    lexerMin.includeLF = lexer.includeLF;
    lexerMin.ignoreCase = lexer.ignoreCase;
    lexerMin.unicode = lexer.unicode;
    lexerMin.noThrow = lexer.noThrow;
    lexerMin.usesEmbedded = lexer.usesEmbedded;
    lexerMin.stateNames = json.tokenizer;
    lexerMin.defaultToken = lexer.defaultToken;
    // Compile an array of rules into newrules where RegExp objects are created.
    function addRules(state, newrules, rules) {
        for (const rule of rules){
            let include = rule.include;
            if (include) {
                if (typeof include !== "string") throw _monarchCommonJs.createError(lexer, "an 'include' attribute must be a string at: " + state);
                if (include[0] === "@") include = include.substr(1); // peel off starting @
                if (!json.tokenizer[include]) throw _monarchCommonJs.createError(lexer, "include target '" + include + "' is not defined at: " + state);
                addRules(state + "." + include, newrules, json.tokenizer[include]);
            } else {
                const newrule = new Rule(state);
                // Set up new rule attributes
                if (Array.isArray(rule) && rule.length >= 1 && rule.length <= 3) {
                    newrule.setRegex(lexerMin, rule[0]);
                    if (rule.length >= 3) {
                        if (typeof rule[1] === "string") newrule.setAction(lexerMin, {
                            token: rule[1],
                            next: rule[2]
                        });
                        else if (typeof rule[1] === "object") {
                            const rule1 = rule[1];
                            rule1.next = rule[2];
                            newrule.setAction(lexerMin, rule1);
                        } else throw _monarchCommonJs.createError(lexer, "a next state as the last element of a rule can only be given if the action is either an object or a string, at: " + state);
                    } else newrule.setAction(lexerMin, rule[1]);
                } else {
                    if (!rule.regex) throw _monarchCommonJs.createError(lexer, "a rule must either be an array, or an object with a 'regex' or 'include' field at: " + state);
                    if (rule.name) {
                        if (typeof rule.name === "string") newrule.name = rule.name;
                    }
                    if (rule.matchOnlyAtStart) newrule.matchOnlyAtLineStart = bool(rule.matchOnlyAtLineStart, false);
                    newrule.setRegex(lexerMin, rule.regex);
                    newrule.setAction(lexerMin, rule.action);
                }
                newrules.push(newrule);
            }
        }
    }
    // compile the tokenizer rules
    if (!json.tokenizer || typeof json.tokenizer !== "object") throw _monarchCommonJs.createError(lexer, "a language definition must define the 'tokenizer' attribute as an object");
    lexer.tokenizer = [];
    for(const key in json.tokenizer)if (json.tokenizer.hasOwnProperty(key)) {
        if (!lexer.start) lexer.start = key;
        const rules = json.tokenizer[key];
        lexer.tokenizer[key] = new Array();
        addRules("tokenizer." + key, lexer.tokenizer[key], rules);
    }
    lexer.usesEmbedded = lexerMin.usesEmbedded; // can be set during compileAction
    // Set simple brackets
    if (json.brackets) {
        if (!Array.isArray(json.brackets)) throw _monarchCommonJs.createError(lexer, "the 'brackets' attribute must be defined as an array");
    } else json.brackets = [
        {
            open: "{",
            close: "}",
            token: "delimiter.curly"
        },
        {
            open: "[",
            close: "]",
            token: "delimiter.square"
        },
        {
            open: "(",
            close: ")",
            token: "delimiter.parenthesis"
        },
        {
            open: "<",
            close: ">",
            token: "delimiter.angle"
        }
    ];
    const brackets = [];
    for (const el of json.brackets){
        let desc = el;
        if (desc && Array.isArray(desc) && desc.length === 3) desc = {
            token: desc[2],
            open: desc[0],
            close: desc[1]
        };
        if (desc.open === desc.close) throw _monarchCommonJs.createError(lexer, "open and close brackets in a 'brackets' attribute must be different: " + desc.open + "\n hint: use the 'bracket' attribute if matching on equal brackets is required.");
        if (typeof desc.open === "string" && typeof desc.token === "string" && typeof desc.close === "string") brackets.push({
            token: desc.token + lexer.tokenPostfix,
            open: _monarchCommonJs.fixCase(lexer, desc.open),
            close: _monarchCommonJs.fixCase(lexer, desc.close)
        });
        else throw _monarchCommonJs.createError(lexer, "every element in the 'brackets' array must be a '{open,close,token}' object or array");
    }
    lexer.brackets = brackets;
    // Disable throw so the syntax highlighter goes, no matter what
    lexer.noThrow = true;
    return lexer;
}

},{"./monarchCommon.js":"cx33T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cATs8":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRealAndSyntheticDocumentFormattersOrdered", ()=>getRealAndSyntheticDocumentFormattersOrdered);
parcelHelpers.export(exports, "FormattingConflicts", ()=>FormattingConflicts);
parcelHelpers.export(exports, "formatDocumentRangesWithSelectedProvider", ()=>formatDocumentRangesWithSelectedProvider);
parcelHelpers.export(exports, "formatDocumentRangesWithProvider", ()=>formatDocumentRangesWithProvider);
parcelHelpers.export(exports, "formatDocumentWithSelectedProvider", ()=>formatDocumentWithSelectedProvider);
parcelHelpers.export(exports, "formatDocumentWithProvider", ()=>formatDocumentWithProvider);
parcelHelpers.export(exports, "getDocumentRangeFormattingEditsUntilResult", ()=>getDocumentRangeFormattingEditsUntilResult);
parcelHelpers.export(exports, "getDocumentFormattingEditsUntilResult", ()=>getDocumentFormattingEditsUntilResult);
parcelHelpers.export(exports, "getOnTypeFormattingEdits", ()=>getOnTypeFormattingEdits);
var _arraysJs = require("../../../../base/common/arrays.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _iteratorJs = require("../../../../base/common/iterator.js");
var _linkedListJs = require("../../../../base/common/linkedList.js");
var _typesJs = require("../../../../base/common/types.js");
var _uriJs = require("../../../../base/common/uri.js");
var _editorStateJs = require("../../editorState/browser/editorState.js");
var _editorBrowserJs = require("../../../browser/editorBrowser.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _editorWorkerJs = require("../../../common/services/editorWorker.js");
var _resolverServiceJs = require("../../../common/services/resolverService.js");
var _formattingEditJs = require("./formattingEdit.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _extensionsJs = require("../../../../platform/extensions/common/extensions.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _logJs = require("../../../../platform/log/common/log.js");
var _accessibilitySignalServiceJs = require("../../../../platform/accessibilitySignal/browser/accessibilitySignalService.js");
function getRealAndSyntheticDocumentFormattersOrdered(documentFormattingEditProvider, documentRangeFormattingEditProvider, model) {
    const result = [];
    const seen = new (0, _extensionsJs.ExtensionIdentifierSet)();
    // (1) add all document formatter
    const docFormatter = documentFormattingEditProvider.ordered(model);
    for (const formatter of docFormatter){
        result.push(formatter);
        if (formatter.extensionId) seen.add(formatter.extensionId);
    }
    // (2) add all range formatter as document formatter (unless the same extension already did that)
    const rangeFormatter = documentRangeFormattingEditProvider.ordered(model);
    for (const formatter of rangeFormatter){
        if (formatter.extensionId) {
            if (seen.has(formatter.extensionId)) continue;
            seen.add(formatter.extensionId);
        }
        result.push({
            displayName: formatter.displayName,
            extensionId: formatter.extensionId,
            provideDocumentFormattingEdits (model, options, token) {
                return formatter.provideDocumentRangeFormattingEdits(model, model.getFullModelRange(), options, token);
            }
        });
    }
    return result;
}
class FormattingConflicts {
    static{
        this._selectors = new (0, _linkedListJs.LinkedList)();
    }
    static setFormatterSelector(selector) {
        const remove = FormattingConflicts._selectors.unshift(selector);
        return {
            dispose: remove
        };
    }
    static async select(formatter, document, mode, kind) {
        if (formatter.length === 0) return undefined;
        const selector = (0, _iteratorJs.Iterable).first(FormattingConflicts._selectors);
        if (selector) return await selector(formatter, document, mode, kind);
        return undefined;
    }
}
async function formatDocumentRangesWithSelectedProvider(accessor, editorOrModel, rangeOrRanges, mode, progress, token, userGesture) {
    const instaService = accessor.get((0, _instantiationJs.IInstantiationService));
    const { documentRangeFormattingEditProvider: documentRangeFormattingEditProviderRegistry } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const model = (0, _editorBrowserJs.isCodeEditor)(editorOrModel) ? editorOrModel.getModel() : editorOrModel;
    const provider = documentRangeFormattingEditProviderRegistry.ordered(model);
    const selected = await FormattingConflicts.select(provider, model, mode, 2 /* FormattingKind.Selection */ );
    if (selected) {
        progress.report(selected);
        await instaService.invokeFunction(formatDocumentRangesWithProvider, selected, editorOrModel, rangeOrRanges, token, userGesture);
    }
}
async function formatDocumentRangesWithProvider(accessor, provider, editorOrModel, rangeOrRanges, token, userGesture) {
    const workerService = accessor.get((0, _editorWorkerJs.IEditorWorkerService));
    const logService = accessor.get((0, _logJs.ILogService));
    const accessibilitySignalService = accessor.get((0, _accessibilitySignalServiceJs.IAccessibilitySignalService));
    let model;
    let cts;
    if ((0, _editorBrowserJs.isCodeEditor)(editorOrModel)) {
        model = editorOrModel.getModel();
        cts = new (0, _editorStateJs.EditorStateCancellationTokenSource)(editorOrModel, 5 /* CodeEditorStateFlag.Position */ , undefined, token);
    } else {
        model = editorOrModel;
        cts = new (0, _editorStateJs.TextModelCancellationTokenSource)(editorOrModel, token);
    }
    // make sure that ranges don't overlap nor touch each other
    const ranges = [];
    let len = 0;
    for (const range of (0, _arraysJs.asArray)(rangeOrRanges).sort((0, _rangeJs.Range).compareRangesUsingStarts))if (len > 0 && (0, _rangeJs.Range).areIntersectingOrTouching(ranges[len - 1], range)) ranges[len - 1] = (0, _rangeJs.Range).fromPositions(ranges[len - 1].getStartPosition(), range.getEndPosition());
    else len = ranges.push(range);
    const computeEdits = async (range)=>{
        logService.trace(`[format][provideDocumentRangeFormattingEdits] (request)`, provider.extensionId?.value, range);
        const result = await provider.provideDocumentRangeFormattingEdits(model, range, model.getFormattingOptions(), cts.token) || [];
        logService.trace(`[format][provideDocumentRangeFormattingEdits] (response)`, provider.extensionId?.value, result);
        return result;
    };
    const hasIntersectingEdit = (a, b)=>{
        if (!a.length || !b.length) return false;
        // quick exit if the list of ranges are completely unrelated [O(n)]
        const mergedA = a.reduce((acc, val)=>{
            return (0, _rangeJs.Range).plusRange(acc, val.range);
        }, a[0].range);
        if (!b.some((x)=>{
            return (0, _rangeJs.Range).intersectRanges(mergedA, x.range);
        })) return false;
        // fallback to a complete check [O(n^2)]
        for (const edit of a)for (const otherEdit of b){
            if ((0, _rangeJs.Range).intersectRanges(edit.range, otherEdit.range)) return true;
        }
        return false;
    };
    const allEdits = [];
    const rawEditsList = [];
    try {
        if (typeof provider.provideDocumentRangesFormattingEdits === "function") {
            logService.trace(`[format][provideDocumentRangeFormattingEdits] (request)`, provider.extensionId?.value, ranges);
            const result = await provider.provideDocumentRangesFormattingEdits(model, ranges, model.getFormattingOptions(), cts.token) || [];
            logService.trace(`[format][provideDocumentRangeFormattingEdits] (response)`, provider.extensionId?.value, result);
            rawEditsList.push(result);
        } else {
            for (const range of ranges){
                if (cts.token.isCancellationRequested) return true;
                rawEditsList.push(await computeEdits(range));
            }
            for(let i = 0; i < ranges.length; ++i)for(let j = i + 1; j < ranges.length; ++j){
                if (cts.token.isCancellationRequested) return true;
                if (hasIntersectingEdit(rawEditsList[i], rawEditsList[j])) {
                    // Merge ranges i and j into a single range, recompute the associated edits
                    const mergedRange = (0, _rangeJs.Range).plusRange(ranges[i], ranges[j]);
                    const edits = await computeEdits(mergedRange);
                    ranges.splice(j, 1);
                    ranges.splice(i, 1);
                    ranges.push(mergedRange);
                    rawEditsList.splice(j, 1);
                    rawEditsList.splice(i, 1);
                    rawEditsList.push(edits);
                    // Restart scanning
                    i = 0;
                    j = 0;
                }
            }
        }
        for (const rawEdits of rawEditsList){
            if (cts.token.isCancellationRequested) return true;
            const minimalEdits = await workerService.computeMoreMinimalEdits(model.uri, rawEdits);
            if (minimalEdits) allEdits.push(...minimalEdits);
        }
    } finally{
        cts.dispose();
    }
    if (allEdits.length === 0) return false;
    if ((0, _editorBrowserJs.isCodeEditor)(editorOrModel)) {
        // use editor to apply edits
        (0, _formattingEditJs.FormattingEdit).execute(editorOrModel, allEdits, true);
        editorOrModel.revealPositionInCenterIfOutsideViewport(editorOrModel.getPosition(), 1 /* ScrollType.Immediate */ );
    } else {
        // use model to apply edits
        const [{ range }] = allEdits;
        const initialSelection = new (0, _selectionJs.Selection)(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
        model.pushEditOperations([
            initialSelection
        ], allEdits.map((edit)=>{
            return {
                text: edit.text,
                range: (0, _rangeJs.Range).lift(edit.range),
                forceMoveMarkers: true
            };
        }), (undoEdits)=>{
            for (const { range } of undoEdits){
                if ((0, _rangeJs.Range).areIntersectingOrTouching(range, initialSelection)) return [
                    new (0, _selectionJs.Selection)(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn)
                ];
            }
            return null;
        });
    }
    accessibilitySignalService.playSignal((0, _accessibilitySignalServiceJs.AccessibilitySignal).format, {
        userGesture
    });
    return true;
}
async function formatDocumentWithSelectedProvider(accessor, editorOrModel, mode, progress, token, userGesture) {
    const instaService = accessor.get((0, _instantiationJs.IInstantiationService));
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const model = (0, _editorBrowserJs.isCodeEditor)(editorOrModel) ? editorOrModel.getModel() : editorOrModel;
    const provider = getRealAndSyntheticDocumentFormattersOrdered(languageFeaturesService.documentFormattingEditProvider, languageFeaturesService.documentRangeFormattingEditProvider, model);
    const selected = await FormattingConflicts.select(provider, model, mode, 1 /* FormattingKind.File */ );
    if (selected) {
        progress.report(selected);
        await instaService.invokeFunction(formatDocumentWithProvider, selected, editorOrModel, mode, token, userGesture);
    }
}
async function formatDocumentWithProvider(accessor, provider, editorOrModel, mode, token, userGesture) {
    const workerService = accessor.get((0, _editorWorkerJs.IEditorWorkerService));
    const accessibilitySignalService = accessor.get((0, _accessibilitySignalServiceJs.IAccessibilitySignalService));
    let model;
    let cts;
    if ((0, _editorBrowserJs.isCodeEditor)(editorOrModel)) {
        model = editorOrModel.getModel();
        cts = new (0, _editorStateJs.EditorStateCancellationTokenSource)(editorOrModel, 5 /* CodeEditorStateFlag.Position */ , undefined, token);
    } else {
        model = editorOrModel;
        cts = new (0, _editorStateJs.TextModelCancellationTokenSource)(editorOrModel, token);
    }
    let edits;
    try {
        const rawEdits = await provider.provideDocumentFormattingEdits(model, model.getFormattingOptions(), cts.token);
        edits = await workerService.computeMoreMinimalEdits(model.uri, rawEdits);
        if (cts.token.isCancellationRequested) return true;
    } finally{
        cts.dispose();
    }
    if (!edits || edits.length === 0) return false;
    if ((0, _editorBrowserJs.isCodeEditor)(editorOrModel)) {
        // use editor to apply edits
        (0, _formattingEditJs.FormattingEdit).execute(editorOrModel, edits, mode !== 2 /* FormattingMode.Silent */ );
        if (mode !== 2 /* FormattingMode.Silent */ ) editorOrModel.revealPositionInCenterIfOutsideViewport(editorOrModel.getPosition(), 1 /* ScrollType.Immediate */ );
    } else {
        // use model to apply edits
        const [{ range }] = edits;
        const initialSelection = new (0, _selectionJs.Selection)(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
        model.pushEditOperations([
            initialSelection
        ], edits.map((edit)=>{
            return {
                text: edit.text,
                range: (0, _rangeJs.Range).lift(edit.range),
                forceMoveMarkers: true
            };
        }), (undoEdits)=>{
            for (const { range } of undoEdits){
                if ((0, _rangeJs.Range).areIntersectingOrTouching(range, initialSelection)) return [
                    new (0, _selectionJs.Selection)(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn)
                ];
            }
            return null;
        });
    }
    accessibilitySignalService.playSignal((0, _accessibilitySignalServiceJs.AccessibilitySignal).format, {
        userGesture
    });
    return true;
}
async function getDocumentRangeFormattingEditsUntilResult(workerService, languageFeaturesService, model, range, options, token) {
    const providers = languageFeaturesService.documentRangeFormattingEditProvider.ordered(model);
    for (const provider of providers){
        const rawEdits = await Promise.resolve(provider.provideDocumentRangeFormattingEdits(model, range, options, token)).catch((0, _errorsJs.onUnexpectedExternalError));
        if ((0, _arraysJs.isNonEmptyArray)(rawEdits)) return await workerService.computeMoreMinimalEdits(model.uri, rawEdits);
    }
    return undefined;
}
async function getDocumentFormattingEditsUntilResult(workerService, languageFeaturesService, model, options, token) {
    const providers = getRealAndSyntheticDocumentFormattersOrdered(languageFeaturesService.documentFormattingEditProvider, languageFeaturesService.documentRangeFormattingEditProvider, model);
    for (const provider of providers){
        const rawEdits = await Promise.resolve(provider.provideDocumentFormattingEdits(model, options, token)).catch((0, _errorsJs.onUnexpectedExternalError));
        if ((0, _arraysJs.isNonEmptyArray)(rawEdits)) return await workerService.computeMoreMinimalEdits(model.uri, rawEdits);
    }
    return undefined;
}
function getOnTypeFormattingEdits(workerService, languageFeaturesService, model, position, ch, options, token) {
    const providers = languageFeaturesService.onTypeFormattingEditProvider.ordered(model);
    if (providers.length === 0) return Promise.resolve(undefined);
    if (providers[0].autoFormatTriggerCharacters.indexOf(ch) < 0) return Promise.resolve(undefined);
    return Promise.resolve(providers[0].provideOnTypeFormattingEdits(model, position, ch, options, token)).catch((0, _errorsJs.onUnexpectedExternalError)).then((edits)=>{
        return workerService.computeMoreMinimalEdits(model.uri, edits);
    });
}
(0, _commandsJs.CommandsRegistry).registerCommand("_executeFormatRangeProvider", async function(accessor, ...args) {
    const [resource, range, options] = args;
    (0, _typesJs.assertType)((0, _uriJs.URI).isUri(resource));
    (0, _typesJs.assertType)((0, _rangeJs.Range).isIRange(range));
    const resolverService = accessor.get((0, _resolverServiceJs.ITextModelService));
    const workerService = accessor.get((0, _editorWorkerJs.IEditorWorkerService));
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const reference = await resolverService.createModelReference(resource);
    try {
        return getDocumentRangeFormattingEditsUntilResult(workerService, languageFeaturesService, reference.object.textEditorModel, (0, _rangeJs.Range).lift(range), options, (0, _cancellationJs.CancellationToken).None);
    } finally{
        reference.dispose();
    }
});
(0, _commandsJs.CommandsRegistry).registerCommand("_executeFormatDocumentProvider", async function(accessor, ...args) {
    const [resource, options] = args;
    (0, _typesJs.assertType)((0, _uriJs.URI).isUri(resource));
    const resolverService = accessor.get((0, _resolverServiceJs.ITextModelService));
    const workerService = accessor.get((0, _editorWorkerJs.IEditorWorkerService));
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const reference = await resolverService.createModelReference(resource);
    try {
        return getDocumentFormattingEditsUntilResult(workerService, languageFeaturesService, reference.object.textEditorModel, options, (0, _cancellationJs.CancellationToken).None);
    } finally{
        reference.dispose();
    }
});
(0, _commandsJs.CommandsRegistry).registerCommand("_executeFormatOnTypeProvider", async function(accessor, ...args) {
    const [resource, position, ch, options] = args;
    (0, _typesJs.assertType)((0, _uriJs.URI).isUri(resource));
    (0, _typesJs.assertType)((0, _positionJs.Position).isIPosition(position));
    (0, _typesJs.assertType)(typeof ch === "string");
    const resolverService = accessor.get((0, _resolverServiceJs.ITextModelService));
    const workerService = accessor.get((0, _editorWorkerJs.IEditorWorkerService));
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const reference = await resolverService.createModelReference(resource);
    try {
        return getOnTypeFormattingEdits(workerService, languageFeaturesService, reference.object.textEditorModel, (0, _positionJs.Position).lift(position), ch, options, (0, _cancellationJs.CancellationToken).None);
    } finally{
        reference.dispose();
    }
});

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/iterator.js":"2FiS0","../../../../base/common/linkedList.js":"kv7Rg","../../../../base/common/types.js":"fb5yx","../../../../base/common/uri.js":"7qGS3","../../editorState/browser/editorState.js":"hyVHM","../../../browser/editorBrowser.js":"82sBe","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/services/editorWorker.js":"aaYJd","../../../common/services/resolverService.js":"ezAtF","./formattingEdit.js":"7wD82","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/extensions/common/extensions.js":"2zn8j","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../common/services/languageFeatures.js":"2IAko","../../../../platform/log/common/log.js":"ieJUF","../../../../platform/accessibilitySignal/browser/accessibilitySignalService.js":"hpeDM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hyVHM":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorState", ()=>EditorState);
/**
 * A cancellation token source that cancels when the editor changes as expressed
 * by the provided flags
 * @param range If provided, changes in position and selection within this range will not trigger cancellation
 */ parcelHelpers.export(exports, "EditorStateCancellationTokenSource", ()=>EditorStateCancellationTokenSource);
/**
 * A cancellation token source that cancels when the provided model changes
 */ parcelHelpers.export(exports, "TextModelCancellationTokenSource", ()=>TextModelCancellationTokenSource);
var _stringsJs = require("../../../../base/common/strings.js");
var _rangeJs = require("../../../common/core/range.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _keybindingCancellationJs = require("./keybindingCancellation.js");
class EditorState {
    constructor(editor, flags){
        this.flags = flags;
        if ((this.flags & 1 /* CodeEditorStateFlag.Value */ ) !== 0) {
            const model = editor.getModel();
            this.modelVersionId = model ? _stringsJs.format("{0}#{1}", model.uri.toString(), model.getVersionId()) : null;
        } else this.modelVersionId = null;
        if ((this.flags & 4 /* CodeEditorStateFlag.Position */ ) !== 0) this.position = editor.getPosition();
        else this.position = null;
        if ((this.flags & 2 /* CodeEditorStateFlag.Selection */ ) !== 0) this.selection = editor.getSelection();
        else this.selection = null;
        if ((this.flags & 8 /* CodeEditorStateFlag.Scroll */ ) !== 0) {
            this.scrollLeft = editor.getScrollLeft();
            this.scrollTop = editor.getScrollTop();
        } else {
            this.scrollLeft = -1;
            this.scrollTop = -1;
        }
    }
    _equals(other) {
        if (!(other instanceof EditorState)) return false;
        const state = other;
        if (this.modelVersionId !== state.modelVersionId) return false;
        if (this.scrollLeft !== state.scrollLeft || this.scrollTop !== state.scrollTop) return false;
        if (!this.position && state.position || this.position && !state.position || this.position && state.position && !this.position.equals(state.position)) return false;
        if (!this.selection && state.selection || this.selection && !state.selection || this.selection && state.selection && !this.selection.equalsRange(state.selection)) return false;
        return true;
    }
    validate(editor) {
        return this._equals(new EditorState(editor, this.flags));
    }
}
class EditorStateCancellationTokenSource extends (0, _keybindingCancellationJs.EditorKeybindingCancellationTokenSource) {
    constructor(editor, flags, range, parent){
        super(editor, parent);
        this._listener = new (0, _lifecycleJs.DisposableStore)();
        if (flags & 4 /* CodeEditorStateFlag.Position */ ) this._listener.add(editor.onDidChangeCursorPosition((e)=>{
            if (!range || !(0, _rangeJs.Range).containsPosition(range, e.position)) this.cancel();
        }));
        if (flags & 2 /* CodeEditorStateFlag.Selection */ ) this._listener.add(editor.onDidChangeCursorSelection((e)=>{
            if (!range || !(0, _rangeJs.Range).containsRange(range, e.selection)) this.cancel();
        }));
        if (flags & 8 /* CodeEditorStateFlag.Scroll */ ) this._listener.add(editor.onDidScrollChange((_)=>this.cancel()));
        if (flags & 1 /* CodeEditorStateFlag.Value */ ) {
            this._listener.add(editor.onDidChangeModel((_)=>this.cancel()));
            this._listener.add(editor.onDidChangeModelContent((_)=>this.cancel()));
        }
    }
    dispose() {
        this._listener.dispose();
        super.dispose();
    }
}
class TextModelCancellationTokenSource extends (0, _cancellationJs.CancellationTokenSource) {
    constructor(model, parent){
        super(parent);
        this._listener = model.onDidChangeContent(()=>this.cancel());
    }
    dispose() {
        this._listener.dispose();
        super.dispose();
    }
}

},{"../../../../base/common/strings.js":"aA9I1","../../../common/core/range.js":"jmUPh","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/lifecycle.js":"9kg8d","./keybindingCancellation.js":"sL7ko","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"sL7ko":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorKeybindingCancellationTokenSource", ()=>EditorKeybindingCancellationTokenSource);
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _linkedListJs = require("../../../../base/common/linkedList.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _extensionsJs = require("../../../../platform/instantiation/common/extensions.js");
var _nlsJs = require("../../../../nls.js");
const IEditorCancellationTokens = (0, _instantiationJs.createDecorator)("IEditorCancelService");
const ctxCancellableOperation = new (0, _contextkeyJs.RawContextKey)("cancellableOperation", false, (0, _nlsJs.localize)("cancellableOperation", "Whether the editor runs a cancellable operation, e.g. like 'Peek References'"));
(0, _extensionsJs.registerSingleton)(IEditorCancellationTokens, class {
    constructor(){
        this._tokens = new WeakMap();
    }
    add(editor, cts) {
        let data = this._tokens.get(editor);
        if (!data) {
            data = editor.invokeWithinContext((accessor)=>{
                const key = ctxCancellableOperation.bindTo(accessor.get((0, _contextkeyJs.IContextKeyService)));
                const tokens = new (0, _linkedListJs.LinkedList)();
                return {
                    key,
                    tokens
                };
            });
            this._tokens.set(editor, data);
        }
        let removeFn;
        data.key.set(true);
        removeFn = data.tokens.push(cts);
        return ()=>{
            // remove w/o cancellation
            if (removeFn) {
                removeFn();
                data.key.set(!data.tokens.isEmpty());
                removeFn = undefined;
            }
        };
    }
    cancel(editor) {
        const data = this._tokens.get(editor);
        if (!data) return;
        // remove with cancellation
        const cts = data.tokens.pop();
        if (cts) {
            cts.cancel();
            data.key.set(!data.tokens.isEmpty());
        }
    }
}, 1 /* InstantiationType.Delayed */ );
class EditorKeybindingCancellationTokenSource extends (0, _cancellationJs.CancellationTokenSource) {
    constructor(editor, parent){
        super(parent);
        this.editor = editor;
        this._unregister = editor.invokeWithinContext((accessor)=>accessor.get(IEditorCancellationTokens).add(editor, this));
    }
    dispose() {
        this._unregister();
        super.dispose();
    }
}
(0, _editorExtensionsJs.registerEditorCommand)(new class extends (0, _editorExtensionsJs.EditorCommand) {
    constructor(){
        super({
            id: "editor.cancelOperation",
            kbOpts: {
                weight: 100 /* KeybindingWeight.EditorContrib */ ,
                primary: 9 /* KeyCode.Escape */ 
            },
            precondition: ctxCancellableOperation
        });
    }
    runEditorCommand(accessor, editor) {
        accessor.get(IEditorCancellationTokens).cancel(editor);
    }
});

},{"../../../browser/editorExtensions.js":"kC3w6","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/linkedList.js":"kv7Rg","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/instantiation/common/extensions.js":"6WJLq","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"82sBe":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *@internal
 */ parcelHelpers.export(exports, "isCodeEditor", ()=>isCodeEditor);
/**
 *@internal
 */ parcelHelpers.export(exports, "isDiffEditor", ()=>isDiffEditor);
/**
 *@internal
 */ parcelHelpers.export(exports, "isCompositeEditor", ()=>isCompositeEditor);
/**
 *@internal
 */ parcelHelpers.export(exports, "getCodeEditor", ()=>getCodeEditor);
var _editorCommonJs = require("../common/editorCommon.js");
function isCodeEditor(thing) {
    if (thing && typeof thing.getEditorType === "function") return thing.getEditorType() === _editorCommonJs.EditorType.ICodeEditor;
    else return false;
}
function isDiffEditor(thing) {
    if (thing && typeof thing.getEditorType === "function") return thing.getEditorType() === _editorCommonJs.EditorType.IDiffEditor;
    else return false;
}
function isCompositeEditor(thing) {
    return !!thing && typeof thing === "object" && typeof thing.onDidChangeActiveEditor === "function";
}
function getCodeEditor(thing) {
    if (isCodeEditor(thing)) return thing;
    if (isDiffEditor(thing)) return thing.getModifiedEditor();
    if (isCompositeEditor(thing) && isCodeEditor(thing.activeCodeEditor)) return thing.activeCodeEditor;
    return null;
}

},{"../common/editorCommon.js":"681Ll","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7wD82":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormattingEdit", ()=>FormattingEdit);
var _editOperationJs = require("../../../common/core/editOperation.js");
var _rangeJs = require("../../../common/core/range.js");
var _stableEditorScrollJs = require("../../../browser/stableEditorScroll.js");
class FormattingEdit {
    static _handleEolEdits(editor, edits) {
        let newEol = undefined;
        const singleEdits = [];
        for (const edit of edits){
            if (typeof edit.eol === "number") newEol = edit.eol;
            if (edit.range && typeof edit.text === "string") singleEdits.push(edit);
        }
        if (typeof newEol === "number") {
            if (editor.hasModel()) editor.getModel().pushEOL(newEol);
        }
        return singleEdits;
    }
    static _isFullModelReplaceEdit(editor, edit) {
        if (!editor.hasModel()) return false;
        const model = editor.getModel();
        const editRange = model.validateRange(edit.range);
        const fullModelRange = model.getFullModelRange();
        return fullModelRange.equalsRange(editRange);
    }
    static execute(editor, _edits, addUndoStops) {
        if (addUndoStops) editor.pushUndoStop();
        const scrollState = (0, _stableEditorScrollJs.StableEditorScrollState).capture(editor);
        const edits = FormattingEdit._handleEolEdits(editor, _edits);
        if (edits.length === 1 && FormattingEdit._isFullModelReplaceEdit(editor, edits[0])) // We use replace semantics and hope that markers stay put...
        editor.executeEdits("formatEditsCommand", edits.map((edit)=>(0, _editOperationJs.EditOperation).replace((0, _rangeJs.Range).lift(edit.range), edit.text)));
        else editor.executeEdits("formatEditsCommand", edits.map((edit)=>(0, _editOperationJs.EditOperation).replaceMove((0, _rangeJs.Range).lift(edit.range), edit.text)));
        if (addUndoStops) editor.pushUndoStop();
        scrollState.restoreRelativeVerticalPositionOfCursor(editor);
    }
}

},{"../../../common/core/editOperation.js":"6r2FZ","../../../common/core/range.js":"jmUPh","../../../browser/stableEditorScroll.js":"5Bh72","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2zn8j":[function(require,module,exports) {
/**
 * **!Do not construct directly!**
 *
 * **!Only static methods because it gets serialized!**
 *
 * This represents the "canonical" version for an extension identifier. Extension ids
 * have to be case-insensitive (due to the marketplace), but we must ensure case
 * preservation because the extension API is already public at this time.
 *
 * For example, given an extension with the publisher `"Hello"` and the name `"World"`,
 * its canonical extension identifier is `"Hello.World"`. This extension could be
 * referenced in some other extension's dependencies using the string `"hello.world"`.
 *
 * To make matters more complicated, an extension can optionally have an UUID. When two
 * extensions have the same UUID, they are considered equal even if their identifier is different.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtensionIdentifier", ()=>ExtensionIdentifier);
parcelHelpers.export(exports, "ExtensionIdentifierSet", ()=>ExtensionIdentifierSet);
class ExtensionIdentifier {
    constructor(value){
        this.value = value;
        this._lower = value.toLowerCase();
    }
    /**
     * Gives the value by which to index (for equality).
     */ static toKey(id) {
        if (typeof id === "string") return id.toLowerCase();
        return id._lower;
    }
}
class ExtensionIdentifierSet {
    constructor(iterable){
        this._set = new Set();
        if (iterable) for (const value of iterable)this.add(value);
    }
    add(id) {
        this._set.add(ExtensionIdentifier.toKey(id));
    }
    has(id) {
        return this._set.has(ExtensionIdentifier.toKey(id));
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2dMNq":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/abap/abap.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "abap",
    extensions: [
        ".abap"
    ],
    aliases: [
        "abap",
        "ABAP"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("979e80ea21d710bb");
    }
});

},{"../_.contribution.js":"25RqS","979e80ea21d710bb":"ec4Tq"}],"25RqS":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadLanguage", ()=>loadLanguage);
parcelHelpers.export(exports, "registerLanguage", ()=>registerLanguage);
var _editorApiJs = require("../editor/editor.api.js");
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __reExport = (target, mod, secondTarget)=>(__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
// src/fillers/monaco-editor-core.ts
var monaco_editor_core_exports = {};
__reExport(monaco_editor_core_exports, _editorApiJs);
// src/basic-languages/_.contribution.ts
var languageDefinitions = {};
var lazyLanguageLoaders = {};
var LazyLanguageLoader = class _LazyLanguageLoader {
    static getOrCreate(languageId) {
        if (!lazyLanguageLoaders[languageId]) lazyLanguageLoaders[languageId] = new _LazyLanguageLoader(languageId);
        return lazyLanguageLoaders[languageId];
    }
    constructor(languageId){
        this._languageId = languageId;
        this._loadingTriggered = false;
        this._lazyLoadPromise = new Promise((resolve, reject)=>{
            this._lazyLoadPromiseResolve = resolve;
            this._lazyLoadPromiseReject = reject;
        });
    }
    load() {
        if (!this._loadingTriggered) {
            this._loadingTriggered = true;
            languageDefinitions[this._languageId].loader().then((mod)=>this._lazyLoadPromiseResolve(mod), (err)=>this._lazyLoadPromiseReject(err));
        }
        return this._lazyLoadPromise;
    }
};
async function loadLanguage(languageId) {
    await LazyLanguageLoader.getOrCreate(languageId).load();
    const model = monaco_editor_core_exports.editor.createModel("", languageId);
    model.dispose();
}
function registerLanguage(def) {
    const languageId = def.id;
    languageDefinitions[languageId] = def;
    monaco_editor_core_exports.languages.register(def);
    const lazyLanguageLoader = LazyLanguageLoader.getOrCreate(languageId);
    monaco_editor_core_exports.languages.registerTokensProviderFactory(languageId, {
        create: async ()=>{
            const mod = await lazyLanguageLoader.load();
            return mod.language;
        }
    });
    monaco_editor_core_exports.languages.onLanguageEncountered(languageId, async ()=>{
        const mod = await lazyLanguageLoader.load();
        monaco_editor_core_exports.languages.setLanguageConfiguration(languageId, mod.conf);
    });
}

},{"../editor/editor.api.js":"6ZKre","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ec4Tq":[function(require,module,exports) {
module.exports = require("427346f353fb1b12")(require("80697d58c61639bd").resolve("21Pwb")).then(()=>module.bundle.root("7zXck"));

},{"427346f353fb1b12":"hpx0h","80697d58c61639bd":"fyJL2"}],"aIJxm":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/apex/apex.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "apex",
    extensions: [
        ".cls"
    ],
    aliases: [
        "Apex",
        "apex"
    ],
    mimetypes: [
        "text/x-apex-source",
        "text/x-apex"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("ac9d02b88069b9db");
    }
});

},{"../_.contribution.js":"25RqS","ac9d02b88069b9db":"clmkZ"}],"clmkZ":[function(require,module,exports) {
module.exports = require("2ce1197936690da5")(require("1e18d24fea58f0b1").resolve("aJ2DO")).then(()=>module.bundle.root("keEvG"));

},{"2ce1197936690da5":"hpx0h","1e18d24fea58f0b1":"fyJL2"}],"hR5SX":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/azcli/azcli.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "azcli",
    extensions: [
        ".azcli"
    ],
    aliases: [
        "Azure CLI",
        "azcli"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("8869a79bca1654c5");
    }
});

},{"../_.contribution.js":"25RqS","8869a79bca1654c5":"fDodG"}],"fDodG":[function(require,module,exports) {
module.exports = require("a759c965fc6d47ca")(require("f765b2814e119dc9").resolve("kup68")).then(()=>module.bundle.root("8IotD"));

},{"a759c965fc6d47ca":"hpx0h","f765b2814e119dc9":"fyJL2"}],"6pvNu":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/bat/bat.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "bat",
    extensions: [
        ".bat",
        ".cmd"
    ],
    aliases: [
        "Batch",
        "bat"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("d48f07e34ece247b");
    }
});

},{"../_.contribution.js":"25RqS","d48f07e34ece247b":"ilde1"}],"ilde1":[function(require,module,exports) {
module.exports = require("60c63b34d15c4725")(require("dee51e69675c354a").resolve("a3PPe")).then(()=>module.bundle.root("eLDCQ"));

},{"60c63b34d15c4725":"hpx0h","dee51e69675c354a":"fyJL2"}],"bsW2d":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/bicep/bicep.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "bicep",
    extensions: [
        ".bicep"
    ],
    aliases: [
        "Bicep"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("fc7b858fe4a9d58d");
    }
});

},{"../_.contribution.js":"25RqS","fc7b858fe4a9d58d":"bwRyl"}],"bwRyl":[function(require,module,exports) {
module.exports = require("7107972c9f9c7be0")(require("45226d9116b9f19a").resolve("1oIfA")).then(()=>module.bundle.root("aL09P"));

},{"7107972c9f9c7be0":"hpx0h","45226d9116b9f19a":"fyJL2"}],"6QIeS":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/cameligo/cameligo.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "cameligo",
    extensions: [
        ".mligo"
    ],
    aliases: [
        "Cameligo"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("af6f77db96e2f1fe");
    }
});

},{"../_.contribution.js":"25RqS","af6f77db96e2f1fe":"2IDt0"}],"2IDt0":[function(require,module,exports) {
module.exports = require("5038c2b6208ff970")(require("94a18a4f1a3f3ccd").resolve("5zv2m")).then(()=>module.bundle.root("1WVfH"));

},{"5038c2b6208ff970":"hpx0h","94a18a4f1a3f3ccd":"fyJL2"}],"2xcYZ":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/clojure/clojure.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "clojure",
    extensions: [
        ".clj",
        ".cljs",
        ".cljc",
        ".edn"
    ],
    aliases: [
        "clojure",
        "Clojure"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("4812bf6460883cd0");
    }
});

},{"../_.contribution.js":"25RqS","4812bf6460883cd0":"8Itv6"}],"8Itv6":[function(require,module,exports) {
module.exports = require("27ea8e79e667f9bd")(require("4e5eda8abc61ffd5").resolve("1taQi")).then(()=>module.bundle.root("h2M8N"));

},{"27ea8e79e667f9bd":"hpx0h","4e5eda8abc61ffd5":"fyJL2"}],"lkHLO":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/coffee/coffee.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "coffeescript",
    extensions: [
        ".coffee"
    ],
    aliases: [
        "CoffeeScript",
        "coffeescript",
        "coffee"
    ],
    mimetypes: [
        "text/x-coffeescript",
        "text/coffeescript"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("927215569abcecd4");
    }
});

},{"../_.contribution.js":"25RqS","927215569abcecd4":"g8yvo"}],"g8yvo":[function(require,module,exports) {
module.exports = require("b95d1ebd3b44c3eb")(require("11d78419115b7404").resolve("g32TX")).then(()=>module.bundle.root("6fdGp"));

},{"b95d1ebd3b44c3eb":"hpx0h","11d78419115b7404":"fyJL2"}],"f6aFI":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/cpp/cpp.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "c",
    extensions: [
        ".c",
        ".h"
    ],
    aliases: [
        "C",
        "c"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("13593deec3d658f6");
    }
});
(0, _contributionJs.registerLanguage)({
    id: "cpp",
    extensions: [
        ".cpp",
        ".cc",
        ".cxx",
        ".hpp",
        ".hh",
        ".hxx"
    ],
    aliases: [
        "C++",
        "Cpp",
        "cpp"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("13593deec3d658f6");
    }
});

},{"../_.contribution.js":"25RqS","13593deec3d658f6":"emtqB"}],"emtqB":[function(require,module,exports) {
module.exports = require("fc9db60e72a04b98")(require("ca56c759ea823e22").resolve("cyc5u")).then(()=>module.bundle.root("4AYMJ"));

},{"fc9db60e72a04b98":"hpx0h","ca56c759ea823e22":"fyJL2"}],"ipo4C":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/csharp/csharp.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "csharp",
    extensions: [
        ".cs",
        ".csx",
        ".cake"
    ],
    aliases: [
        "C#",
        "csharp"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("7d46f992995eec30");
    }
});

},{"../_.contribution.js":"25RqS","7d46f992995eec30":"69198"}],"69198":[function(require,module,exports) {
module.exports = require("7ca5cf362f4cb7ae")(require("be449340533cd6f0").resolve("6gAdJ")).then(()=>module.bundle.root("l4aXD"));

},{"7ca5cf362f4cb7ae":"hpx0h","be449340533cd6f0":"fyJL2"}],"jTIxM":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/csp/csp.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "csp",
    extensions: [
        ".csp"
    ],
    aliases: [
        "CSP",
        "csp"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("1f78c99039be69aa");
    }
});

},{"../_.contribution.js":"25RqS","1f78c99039be69aa":"7wg6W"}],"7wg6W":[function(require,module,exports) {
module.exports = require("f70184587817addc")(require("43454020294063c5").resolve("a2TsP")).then(()=>module.bundle.root("7IAVf"));

},{"f70184587817addc":"hpx0h","43454020294063c5":"fyJL2"}],"3MHh1":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/css/css.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "css",
    extensions: [
        ".css"
    ],
    aliases: [
        "CSS",
        "css"
    ],
    mimetypes: [
        "text/css"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("b59afe218ba12a39");
    }
});

},{"../_.contribution.js":"25RqS","b59afe218ba12a39":"2y8MN"}],"2y8MN":[function(require,module,exports) {
module.exports = require("9a6bdbe37cfbb703")(require("cce146d465aad26c").resolve("iULxL")).then(()=>module.bundle.root("jKtU1"));

},{"9a6bdbe37cfbb703":"hpx0h","cce146d465aad26c":"fyJL2"}],"1UryK":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/cypher/cypher.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "cypher",
    extensions: [
        ".cypher",
        ".cyp"
    ],
    aliases: [
        "Cypher",
        "OpenCypher"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("c0a7fcca7a67f77");
    }
});

},{"../_.contribution.js":"25RqS","c0a7fcca7a67f77":"bvPwS"}],"bvPwS":[function(require,module,exports) {
module.exports = require("9bcc07227caab3f8")(require("b37f1b8223e3c852").resolve("6Ygr6")).then(()=>module.bundle.root("7PjFP"));

},{"9bcc07227caab3f8":"hpx0h","b37f1b8223e3c852":"fyJL2"}],"aEAhS":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/dart/dart.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "dart",
    extensions: [
        ".dart"
    ],
    aliases: [
        "Dart",
        "dart"
    ],
    mimetypes: [
        "text/x-dart-source",
        "text/x-dart"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("9d7f923094ab1ce3");
    }
});

},{"../_.contribution.js":"25RqS","9d7f923094ab1ce3":"cyqx7"}],"cyqx7":[function(require,module,exports) {
module.exports = require("89095e34c9e52cbf")(require("e5a9231fa0cd87ff").resolve("iSAvX")).then(()=>module.bundle.root("jflx2"));

},{"89095e34c9e52cbf":"hpx0h","e5a9231fa0cd87ff":"fyJL2"}],"iycQb":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/dockerfile/dockerfile.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "dockerfile",
    extensions: [
        ".dockerfile"
    ],
    filenames: [
        "Dockerfile"
    ],
    aliases: [
        "Dockerfile"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("cb6241640b75b932");
    }
});

},{"../_.contribution.js":"25RqS","cb6241640b75b932":"ggzSo"}],"ggzSo":[function(require,module,exports) {
module.exports = require("773d2de38fb04271")(require("d030f09373fcab8b").resolve("88QDr")).then(()=>module.bundle.root("gEnJK"));

},{"773d2de38fb04271":"hpx0h","d030f09373fcab8b":"fyJL2"}],"cpJGX":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/ecl/ecl.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "ecl",
    extensions: [
        ".ecl"
    ],
    aliases: [
        "ECL",
        "Ecl",
        "ecl"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("5699e0dfd69533e7");
    }
});

},{"../_.contribution.js":"25RqS","5699e0dfd69533e7":"e3nnK"}],"e3nnK":[function(require,module,exports) {
module.exports = require("e4e8dc02a494ac30")(require("41e59e246fccfb1e").resolve("5OOiF")).then(()=>module.bundle.root("8IHci"));

},{"e4e8dc02a494ac30":"hpx0h","41e59e246fccfb1e":"fyJL2"}],"e8IP3":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/elixir/elixir.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "elixir",
    extensions: [
        ".ex",
        ".exs"
    ],
    aliases: [
        "Elixir",
        "elixir",
        "ex"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("65ad126b4e3b7f3");
    }
});

},{"../_.contribution.js":"25RqS","65ad126b4e3b7f3":"iBshI"}],"iBshI":[function(require,module,exports) {
module.exports = require("a77268d502e6e6dd")(require("d91d09a8cde04200").resolve("jpQd1")).then(()=>module.bundle.root("ewQdw"));

},{"a77268d502e6e6dd":"hpx0h","d91d09a8cde04200":"fyJL2"}],"aBW57":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/flow9/flow9.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "flow9",
    extensions: [
        ".flow"
    ],
    aliases: [
        "Flow9",
        "Flow",
        "flow9",
        "flow"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("d6c77b299f9a0f06");
    }
});

},{"../_.contribution.js":"25RqS","d6c77b299f9a0f06":"3TAuo"}],"3TAuo":[function(require,module,exports) {
module.exports = require("be4b07e09753d316")(require("c7333f901d98656d").resolve("6fgDP")).then(()=>module.bundle.root("3fHdV"));

},{"be4b07e09753d316":"hpx0h","c7333f901d98656d":"fyJL2"}],"3YSwZ":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/fsharp/fsharp.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "fsharp",
    extensions: [
        ".fs",
        ".fsi",
        ".ml",
        ".mli",
        ".fsx",
        ".fsscript"
    ],
    aliases: [
        "F#",
        "FSharp",
        "fsharp"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("33b1df7f8e573ad7");
    }
});

},{"../_.contribution.js":"25RqS","33b1df7f8e573ad7":"eyXzb"}],"eyXzb":[function(require,module,exports) {
module.exports = require("54aadfde3d5af617")(require("49e8a5104035aa31").resolve("aZHCO")).then(()=>module.bundle.root("fiilb"));

},{"54aadfde3d5af617":"hpx0h","49e8a5104035aa31":"fyJL2"}],"efjiP":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/freemarker2/freemarker2.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "freemarker2",
    extensions: [
        ".ftl",
        ".ftlh",
        ".ftlx"
    ],
    aliases: [
        "FreeMarker2",
        "Apache FreeMarker2"
    ],
    loader: ()=>{
        var resolve, reject, m;
        return require("6f25636488ed491e").then((m)=>m.TagAutoInterpolationDollar);
    }
});
(0, _contributionJs.registerLanguage)({
    id: "freemarker2.tag-angle.interpolation-dollar",
    aliases: [
        "FreeMarker2 (Angle/Dollar)",
        "Apache FreeMarker2 (Angle/Dollar)"
    ],
    loader: ()=>{
        var resolve, reject, m;
        return require("6f25636488ed491e").then((m)=>m.TagAngleInterpolationDollar);
    }
});
(0, _contributionJs.registerLanguage)({
    id: "freemarker2.tag-bracket.interpolation-dollar",
    aliases: [
        "FreeMarker2 (Bracket/Dollar)",
        "Apache FreeMarker2 (Bracket/Dollar)"
    ],
    loader: ()=>{
        var resolve, reject, m;
        return require("6f25636488ed491e").then((m)=>m.TagBracketInterpolationDollar);
    }
});
(0, _contributionJs.registerLanguage)({
    id: "freemarker2.tag-angle.interpolation-bracket",
    aliases: [
        "FreeMarker2 (Angle/Bracket)",
        "Apache FreeMarker2 (Angle/Bracket)"
    ],
    loader: ()=>{
        var resolve, reject, m;
        return require("6f25636488ed491e").then((m)=>m.TagAngleInterpolationBracket);
    }
});
(0, _contributionJs.registerLanguage)({
    id: "freemarker2.tag-bracket.interpolation-bracket",
    aliases: [
        "FreeMarker2 (Bracket/Bracket)",
        "Apache FreeMarker2 (Bracket/Bracket)"
    ],
    loader: ()=>{
        var resolve, reject, m;
        return require("6f25636488ed491e").then((m)=>m.TagBracketInterpolationBracket);
    }
});
(0, _contributionJs.registerLanguage)({
    id: "freemarker2.tag-auto.interpolation-dollar",
    aliases: [
        "FreeMarker2 (Auto/Dollar)",
        "Apache FreeMarker2 (Auto/Dollar)"
    ],
    loader: ()=>{
        var resolve, reject, m;
        return require("6f25636488ed491e").then((m)=>m.TagAutoInterpolationDollar);
    }
});
(0, _contributionJs.registerLanguage)({
    id: "freemarker2.tag-auto.interpolation-bracket",
    aliases: [
        "FreeMarker2 (Auto/Bracket)",
        "Apache FreeMarker2 (Auto/Bracket)"
    ],
    loader: ()=>{
        var resolve, reject, m;
        return require("6f25636488ed491e").then((m)=>m.TagAutoInterpolationBracket);
    }
});

},{"../_.contribution.js":"25RqS","6f25636488ed491e":"33Mm8"}],"33Mm8":[function(require,module,exports) {
module.exports = require("b093aa71b02e6197")(require("cf9ca376c6e28cd2").resolve("j21IW")).then(()=>module.bundle.root("2bCEi"));

},{"b093aa71b02e6197":"hpx0h","cf9ca376c6e28cd2":"fyJL2"}],"6jHMX":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/go/go.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "go",
    extensions: [
        ".go"
    ],
    aliases: [
        "Go"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("71a63f9d1ff68db3");
    }
});

},{"../_.contribution.js":"25RqS","71a63f9d1ff68db3":"53sUT"}],"53sUT":[function(require,module,exports) {
module.exports = require("3b909f104be9bed4")(require("e9244cd33e5b838").resolve("4aKEt")).then(()=>module.bundle.root("6OrKg"));

},{"3b909f104be9bed4":"hpx0h","e9244cd33e5b838":"fyJL2"}],"aluC5":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/graphql/graphql.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "graphql",
    extensions: [
        ".graphql",
        ".gql"
    ],
    aliases: [
        "GraphQL",
        "graphql",
        "gql"
    ],
    mimetypes: [
        "application/graphql"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("ef5405828c2253c5");
    }
});

},{"../_.contribution.js":"25RqS","ef5405828c2253c5":"9ycoO"}],"9ycoO":[function(require,module,exports) {
module.exports = require("bb00070539d7ff44")(require("806fd614f0235d03").resolve("a3ZGY")).then(()=>module.bundle.root("bNA9f"));

},{"bb00070539d7ff44":"hpx0h","806fd614f0235d03":"fyJL2"}],"b1elH":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/handlebars/handlebars.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "handlebars",
    extensions: [
        ".handlebars",
        ".hbs"
    ],
    aliases: [
        "Handlebars",
        "handlebars",
        "hbs"
    ],
    mimetypes: [
        "text/x-handlebars-template"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("26c875c2a2e3ac80");
    }
});

},{"../_.contribution.js":"25RqS","26c875c2a2e3ac80":"koxP8"}],"koxP8":[function(require,module,exports) {
module.exports = require("86d1c9bb548e0e6a")(require("110ad899d26ab16").resolve("cpg90")).then(()=>module.bundle.root("ehnQP"));

},{"86d1c9bb548e0e6a":"hpx0h","110ad899d26ab16":"fyJL2"}],"8kc2v":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/hcl/hcl.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "hcl",
    extensions: [
        ".tf",
        ".tfvars",
        ".hcl"
    ],
    aliases: [
        "Terraform",
        "tf",
        "HCL",
        "hcl"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("4387bd6ac3eab111");
    }
});

},{"../_.contribution.js":"25RqS","4387bd6ac3eab111":"3MNCn"}],"3MNCn":[function(require,module,exports) {
module.exports = require("e7bfa9c56fd2706f")(require("b0ca5992eb3f041b").resolve("jgqke")).then(()=>module.bundle.root("7Ckom"));

},{"e7bfa9c56fd2706f":"hpx0h","b0ca5992eb3f041b":"fyJL2"}],"204Ie":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/html/html.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "html",
    extensions: [
        ".html",
        ".htm",
        ".shtml",
        ".xhtml",
        ".mdoc",
        ".jsp",
        ".asp",
        ".aspx",
        ".jshtm"
    ],
    aliases: [
        "HTML",
        "htm",
        "html",
        "xhtml"
    ],
    mimetypes: [
        "text/html",
        "text/x-jshtm",
        "text/template",
        "text/ng-template"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("2dffb9b0a134c8e5");
    }
});

},{"../_.contribution.js":"25RqS","2dffb9b0a134c8e5":"22YcS"}],"22YcS":[function(require,module,exports) {
module.exports = require("950666a216de16a3")(require("deb890ff7b999190").resolve("d31jB")).then(()=>module.bundle.root("52Iq5"));

},{"950666a216de16a3":"hpx0h","deb890ff7b999190":"fyJL2"}],"1m7Vv":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/ini/ini.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "ini",
    extensions: [
        ".ini",
        ".properties",
        ".gitconfig"
    ],
    filenames: [
        "config",
        ".gitattributes",
        ".gitconfig",
        ".editorconfig"
    ],
    aliases: [
        "Ini",
        "ini"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("196613603694ada4");
    }
});

},{"../_.contribution.js":"25RqS","196613603694ada4":"9MA7g"}],"9MA7g":[function(require,module,exports) {
module.exports = require("ac7e4d4cf121c95e")(require("808ecb24f8a417e6").resolve("bqqBG")).then(()=>module.bundle.root("7AFvu"));

},{"ac7e4d4cf121c95e":"hpx0h","808ecb24f8a417e6":"fyJL2"}],"3Uhe4":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/java/java.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "java",
    extensions: [
        ".java",
        ".jav"
    ],
    aliases: [
        "Java",
        "java"
    ],
    mimetypes: [
        "text/x-java-source",
        "text/x-java"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("a3d646538faf7c5f");
    }
});

},{"../_.contribution.js":"25RqS","a3d646538faf7c5f":"8xY6U"}],"8xY6U":[function(require,module,exports) {
module.exports = require("d4130872c0634a83")(require("a2e1b32c343d2cd").resolve("6f0Qk")).then(()=>module.bundle.root("5C3KW"));

},{"d4130872c0634a83":"hpx0h","a2e1b32c343d2cd":"fyJL2"}],"eA4tD":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/javascript/javascript.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "javascript",
    extensions: [
        ".js",
        ".es6",
        ".jsx",
        ".mjs",
        ".cjs"
    ],
    firstLine: "^#!.*\\bnode",
    filenames: [
        "jakefile"
    ],
    aliases: [
        "JavaScript",
        "javascript",
        "js"
    ],
    mimetypes: [
        "text/javascript"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("485ab2d98a58d80a");
    }
});

},{"../_.contribution.js":"25RqS","485ab2d98a58d80a":"7dQIg"}],"7dQIg":[function(require,module,exports) {
module.exports = Promise.all([
    require("2f4f03661fdba2e7")(require("bcc455f55256a99b").resolve("9hWSy")),
    require("2f4f03661fdba2e7")(require("bcc455f55256a99b").resolve("5cWrC"))
]).then(()=>module.bundle.root("h3V1i"));

},{"2f4f03661fdba2e7":"hpx0h","bcc455f55256a99b":"fyJL2"}],"fUXOu":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/julia/julia.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "julia",
    extensions: [
        ".jl"
    ],
    aliases: [
        "julia",
        "Julia"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("6f7d26be03ddb018");
    }
});

},{"../_.contribution.js":"25RqS","6f7d26be03ddb018":"e2Et1"}],"e2Et1":[function(require,module,exports) {
module.exports = require("862d6f24da9d51e7")(require("e0b24dc8e63bb39d").resolve("ltkw5")).then(()=>module.bundle.root("iwFf8"));

},{"862d6f24da9d51e7":"hpx0h","e0b24dc8e63bb39d":"fyJL2"}],"59qRo":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/kotlin/kotlin.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "kotlin",
    extensions: [
        ".kt",
        ".kts"
    ],
    aliases: [
        "Kotlin",
        "kotlin"
    ],
    mimetypes: [
        "text/x-kotlin-source",
        "text/x-kotlin"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("86ef523452be39a4");
    }
});

},{"../_.contribution.js":"25RqS","86ef523452be39a4":"884kN"}],"884kN":[function(require,module,exports) {
module.exports = require("a32a65e7b2467fea")(require("d79e65f865aecf20").resolve("gGi6H")).then(()=>module.bundle.root("gFTxY"));

},{"a32a65e7b2467fea":"hpx0h","d79e65f865aecf20":"fyJL2"}],"4Oalt":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/less/less.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "less",
    extensions: [
        ".less"
    ],
    aliases: [
        "Less",
        "less"
    ],
    mimetypes: [
        "text/x-less",
        "text/less"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("d196859b676239d4");
    }
});

},{"../_.contribution.js":"25RqS","d196859b676239d4":"7mMgn"}],"7mMgn":[function(require,module,exports) {
module.exports = require("6bcf6d71ee4ba0c8")(require("fadac672591dabbe").resolve("e5utS")).then(()=>module.bundle.root("1a4im"));

},{"6bcf6d71ee4ba0c8":"hpx0h","fadac672591dabbe":"fyJL2"}],"3PJLk":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/lexon/lexon.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "lexon",
    extensions: [
        ".lex"
    ],
    aliases: [
        "Lexon"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("632fb4ece3bbd689");
    }
});

},{"../_.contribution.js":"25RqS","632fb4ece3bbd689":"gUYK5"}],"gUYK5":[function(require,module,exports) {
module.exports = require("5755f5333684de23")(require("4e86892bb0837b04").resolve("bdGjA")).then(()=>module.bundle.root("gJ7dT"));

},{"5755f5333684de23":"hpx0h","4e86892bb0837b04":"fyJL2"}],"gq6GN":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/lua/lua.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "lua",
    extensions: [
        ".lua"
    ],
    aliases: [
        "Lua",
        "lua"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("c832f7576ac25dab");
    }
});

},{"../_.contribution.js":"25RqS","c832f7576ac25dab":"iSztg"}],"iSztg":[function(require,module,exports) {
module.exports = require("c460c554cffea3b2")(require("5db13fb97c4be2a0").resolve("kybtA")).then(()=>module.bundle.root("9VPwj"));

},{"c460c554cffea3b2":"hpx0h","5db13fb97c4be2a0":"fyJL2"}],"aXTOQ":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/liquid/liquid.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "liquid",
    extensions: [
        ".liquid",
        ".html.liquid"
    ],
    aliases: [
        "Liquid",
        "liquid"
    ],
    mimetypes: [
        "application/liquid"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("4b0a7e2793498945");
    }
});

},{"../_.contribution.js":"25RqS","4b0a7e2793498945":"6InjC"}],"6InjC":[function(require,module,exports) {
module.exports = require("5a11bed36957dbf4")(require("e900ca231f17e48f").resolve("hvglj")).then(()=>module.bundle.root("59sb0"));

},{"5a11bed36957dbf4":"hpx0h","e900ca231f17e48f":"fyJL2"}],"3FagO":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/m3/m3.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "m3",
    extensions: [
        ".m3",
        ".i3",
        ".mg",
        ".ig"
    ],
    aliases: [
        "Modula-3",
        "Modula3",
        "modula3",
        "m3"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("e635392d45793df");
    }
});

},{"../_.contribution.js":"25RqS","e635392d45793df":"97m4J"}],"97m4J":[function(require,module,exports) {
module.exports = require("a864d5543b96dfdc")(require("939714e658efc2e9").resolve("h4xwA")).then(()=>module.bundle.root("iFRa2"));

},{"a864d5543b96dfdc":"hpx0h","939714e658efc2e9":"fyJL2"}],"ecOVg":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/markdown/markdown.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "markdown",
    extensions: [
        ".md",
        ".markdown",
        ".mdown",
        ".mkdn",
        ".mkd",
        ".mdwn",
        ".mdtxt",
        ".mdtext"
    ],
    aliases: [
        "Markdown",
        "markdown"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("5dc1853c2637df6");
    }
});

},{"../_.contribution.js":"25RqS","5dc1853c2637df6":"1lqCB"}],"1lqCB":[function(require,module,exports) {
module.exports = require("c57285d804d1560")(require("dafeeca7d08fc130").resolve("biiLq")).then(()=>module.bundle.root("j9tCb"));

},{"c57285d804d1560":"hpx0h","dafeeca7d08fc130":"fyJL2"}],"3egkJ":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/mdx/mdx.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "mdx",
    extensions: [
        ".mdx"
    ],
    aliases: [
        "MDX",
        "mdx"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("c529bbf84a4e3fee");
    }
});

},{"../_.contribution.js":"25RqS","c529bbf84a4e3fee":"eE9fc"}],"eE9fc":[function(require,module,exports) {
module.exports = require("4a63e99b15d6a514")(require("dc68327e74d7c79b").resolve("1xgaD")).then(()=>module.bundle.root("f1HIo"));

},{"4a63e99b15d6a514":"hpx0h","dc68327e74d7c79b":"fyJL2"}],"cd0iA":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/mips/mips.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "mips",
    extensions: [
        ".s"
    ],
    aliases: [
        "MIPS",
        "MIPS-V"
    ],
    mimetypes: [
        "text/x-mips",
        "text/mips",
        "text/plaintext"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("434c657a3b2ee040");
    }
});

},{"../_.contribution.js":"25RqS","434c657a3b2ee040":"6O3iJ"}],"6O3iJ":[function(require,module,exports) {
module.exports = require("ad57498744a29a8d")(require("8e166a3bea554ff0").resolve("gkk9w")).then(()=>module.bundle.root("eI4Uw"));

},{"ad57498744a29a8d":"hpx0h","8e166a3bea554ff0":"fyJL2"}],"iExEi":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/msdax/msdax.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "msdax",
    extensions: [
        ".dax",
        ".msdax"
    ],
    aliases: [
        "DAX",
        "MSDAX"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("fa8391f7b1426240");
    }
});

},{"../_.contribution.js":"25RqS","fa8391f7b1426240":"clsgl"}],"clsgl":[function(require,module,exports) {
module.exports = require("9cf8b51afe5f7a39")(require("b8b3332cbf0355e4").resolve("irCpA")).then(()=>module.bundle.root("kYitb"));

},{"9cf8b51afe5f7a39":"hpx0h","b8b3332cbf0355e4":"fyJL2"}],"5PFvy":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/mysql/mysql.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "mysql",
    extensions: [],
    aliases: [
        "MySQL",
        "mysql"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("7d4691cbe3ea08f");
    }
});

},{"../_.contribution.js":"25RqS","7d4691cbe3ea08f":"fuoFC"}],"fuoFC":[function(require,module,exports) {
module.exports = require("4112c177888776bf")(require("b418b2dcf37e03fa").resolve("1qC9H")).then(()=>module.bundle.root("7boSX"));

},{"4112c177888776bf":"hpx0h","b418b2dcf37e03fa":"fyJL2"}],"16w3a":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/objective-c/objective-c.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "objective-c",
    extensions: [
        ".m"
    ],
    aliases: [
        "Objective-C"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("1631e158bf17bb2b");
    }
});

},{"../_.contribution.js":"25RqS","1631e158bf17bb2b":"50yDu"}],"50yDu":[function(require,module,exports) {
module.exports = require("89db2f96200d04ea")(require("f59353e924ac22b9").resolve("f3r9K")).then(()=>module.bundle.root("gldF6"));

},{"89db2f96200d04ea":"hpx0h","f59353e924ac22b9":"fyJL2"}],"fjpb6":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/pascal/pascal.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "pascal",
    extensions: [
        ".pas",
        ".p",
        ".pp"
    ],
    aliases: [
        "Pascal",
        "pas"
    ],
    mimetypes: [
        "text/x-pascal-source",
        "text/x-pascal"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("c4ed8218b3e49c3a");
    }
});

},{"../_.contribution.js":"25RqS","c4ed8218b3e49c3a":"2tbvp"}],"2tbvp":[function(require,module,exports) {
module.exports = require("55cf1d54a10de218")(require("1c181dbffb66dac0").resolve("6cK8x")).then(()=>module.bundle.root("aW4hI"));

},{"55cf1d54a10de218":"hpx0h","1c181dbffb66dac0":"fyJL2"}],"6sB0J":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/pascaligo/pascaligo.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "pascaligo",
    extensions: [
        ".ligo"
    ],
    aliases: [
        "Pascaligo",
        "ligo"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("9c44f480f3411654");
    }
});

},{"../_.contribution.js":"25RqS","9c44f480f3411654":"djTHf"}],"djTHf":[function(require,module,exports) {
module.exports = require("c22d3de6e9ece5fc")(require("3c69ad094dbfc049").resolve("ike5M")).then(()=>module.bundle.root("g1QOE"));

},{"c22d3de6e9ece5fc":"hpx0h","3c69ad094dbfc049":"fyJL2"}],"ghPSZ":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/perl/perl.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "perl",
    extensions: [
        ".pl",
        ".pm"
    ],
    aliases: [
        "Perl",
        "pl"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("f934d9190e1bdf25");
    }
});

},{"../_.contribution.js":"25RqS","f934d9190e1bdf25":"azH5l"}],"azH5l":[function(require,module,exports) {
module.exports = require("c23c9fc1e29bf1fe")(require("9f083586a27a33a9").resolve("fc9EY")).then(()=>module.bundle.root("i9EAL"));

},{"c23c9fc1e29bf1fe":"hpx0h","9f083586a27a33a9":"fyJL2"}],"i6tpJ":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/pgsql/pgsql.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "pgsql",
    extensions: [],
    aliases: [
        "PostgreSQL",
        "postgres",
        "pg",
        "postgre"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("e1c2b6222e747cc2");
    }
});

},{"../_.contribution.js":"25RqS","e1c2b6222e747cc2":"aMdc6"}],"aMdc6":[function(require,module,exports) {
module.exports = require("aa1e381c70383f89")(require("fb7d57375ac55b97").resolve("3dKfd")).then(()=>module.bundle.root("kfpgW"));

},{"aa1e381c70383f89":"hpx0h","fb7d57375ac55b97":"fyJL2"}],"4i4gW":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/php/php.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "php",
    extensions: [
        ".php",
        ".php4",
        ".php5",
        ".phtml",
        ".ctp"
    ],
    aliases: [
        "PHP",
        "php"
    ],
    mimetypes: [
        "application/x-php"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("e655963c3292ba28");
    }
});

},{"../_.contribution.js":"25RqS","e655963c3292ba28":"4rh9B"}],"4rh9B":[function(require,module,exports) {
module.exports = require("ba502debd28fa44")(require("d4c090116a4f3f8e").resolve("2KjUv")).then(()=>module.bundle.root("aki4d"));

},{"ba502debd28fa44":"hpx0h","d4c090116a4f3f8e":"fyJL2"}],"431De":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/pla/pla.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "pla",
    extensions: [
        ".pla"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("595b91e5db9f541d");
    }
});

},{"../_.contribution.js":"25RqS","595b91e5db9f541d":"a1TM1"}],"a1TM1":[function(require,module,exports) {
module.exports = require("906cadce62e03fee")(require("6ff7627a20581485").resolve("9IejE")).then(()=>module.bundle.root("7voGE"));

},{"906cadce62e03fee":"hpx0h","6ff7627a20581485":"fyJL2"}],"3m24o":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/postiats/postiats.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "postiats",
    extensions: [
        ".dats",
        ".sats",
        ".hats"
    ],
    aliases: [
        "ATS",
        "ATS/Postiats"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("b2d223ee0a89f2ab");
    }
});

},{"../_.contribution.js":"25RqS","b2d223ee0a89f2ab":"6gqma"}],"6gqma":[function(require,module,exports) {
module.exports = require("3af3042bce494ad9")(require("3914910a3c5cf1ff").resolve("licBB")).then(()=>module.bundle.root("90ulM"));

},{"3af3042bce494ad9":"hpx0h","3914910a3c5cf1ff":"fyJL2"}],"jXVSe":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/powerquery/powerquery.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "powerquery",
    extensions: [
        ".pq",
        ".pqm"
    ],
    aliases: [
        "PQ",
        "M",
        "Power Query",
        "Power Query M"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("e64514a5642d7be0");
    }
});

},{"../_.contribution.js":"25RqS","e64514a5642d7be0":"lnePt"}],"lnePt":[function(require,module,exports) {
module.exports = require("7610ebab043abd24")(require("889ebcbf3935e59b").resolve("jtiOK")).then(()=>module.bundle.root("52WIU"));

},{"7610ebab043abd24":"hpx0h","889ebcbf3935e59b":"fyJL2"}],"jbbQX":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/powershell/powershell.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "powershell",
    extensions: [
        ".ps1",
        ".psm1",
        ".psd1"
    ],
    aliases: [
        "PowerShell",
        "powershell",
        "ps",
        "ps1"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("e69fc51a7bde1e5f");
    }
});

},{"../_.contribution.js":"25RqS","e69fc51a7bde1e5f":"iTnyF"}],"iTnyF":[function(require,module,exports) {
module.exports = require("c356b902ea0216b")(require("871b7e83d9d52db1").resolve("eQixF")).then(()=>module.bundle.root("jKDKu"));

},{"c356b902ea0216b":"hpx0h","871b7e83d9d52db1":"fyJL2"}],"hfJ7w":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/protobuf/protobuf.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "proto",
    extensions: [
        ".proto"
    ],
    aliases: [
        "protobuf",
        "Protocol Buffers"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("3fa6d6080492eea2");
    }
});

},{"../_.contribution.js":"25RqS","3fa6d6080492eea2":"gqxL1"}],"gqxL1":[function(require,module,exports) {
module.exports = require("976d53abf023afc8")(require("39d8405177ec3da0").resolve("kfCFt")).then(()=>module.bundle.root("gWhR3"));

},{"976d53abf023afc8":"hpx0h","39d8405177ec3da0":"fyJL2"}],"kLesd":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/pug/pug.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "pug",
    extensions: [
        ".jade",
        ".pug"
    ],
    aliases: [
        "Pug",
        "Jade",
        "jade"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("91979c39f0528654");
    }
});

},{"../_.contribution.js":"25RqS","91979c39f0528654":"6nDxQ"}],"6nDxQ":[function(require,module,exports) {
module.exports = require("a991f2f3de449480")(require("1be459f0e8871ec4").resolve("8PhUa")).then(()=>module.bundle.root("lijk5"));

},{"a991f2f3de449480":"hpx0h","1be459f0e8871ec4":"fyJL2"}],"gV2x1":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/python/python.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "python",
    extensions: [
        ".py",
        ".rpy",
        ".pyw",
        ".cpy",
        ".gyp",
        ".gypi"
    ],
    aliases: [
        "Python",
        "py"
    ],
    firstLine: "^#!/.*\\bpython[0-9.-]*\\b",
    loader: ()=>{
        var resolve, reject;
        return require("16ee3538d93a697a");
    }
});

},{"../_.contribution.js":"25RqS","16ee3538d93a697a":"6vNQ9"}],"6vNQ9":[function(require,module,exports) {
module.exports = require("57f19603a417b287")(require("d579f311d65fa618").resolve("cV5g7")).then(()=>module.bundle.root("9kbXF"));

},{"57f19603a417b287":"hpx0h","d579f311d65fa618":"fyJL2"}],"8tcMV":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/qsharp/qsharp.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "qsharp",
    extensions: [
        ".qs"
    ],
    aliases: [
        "Q#",
        "qsharp"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("594c1f64e4ba2be8");
    }
});

},{"../_.contribution.js":"25RqS","594c1f64e4ba2be8":"i0YFV"}],"i0YFV":[function(require,module,exports) {
module.exports = require("88183e9f920a17fb")(require("ddfc60a26ce8b7b3").resolve("9sFw1")).then(()=>module.bundle.root("6abrQ"));

},{"88183e9f920a17fb":"hpx0h","ddfc60a26ce8b7b3":"fyJL2"}],"l7xXX":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/r/r.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "r",
    extensions: [
        ".r",
        ".rhistory",
        ".rmd",
        ".rprofile",
        ".rt"
    ],
    aliases: [
        "R",
        "r"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("11578b5d33c44410");
    }
});

},{"../_.contribution.js":"25RqS","11578b5d33c44410":"kxLzh"}],"kxLzh":[function(require,module,exports) {
module.exports = require("698b50b488e244b5")(require("56d100eb5b4a096c").resolve("1uJrY")).then(()=>module.bundle.root("enVcc"));

},{"698b50b488e244b5":"hpx0h","56d100eb5b4a096c":"fyJL2"}],"iNdbf":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/razor/razor.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "razor",
    extensions: [
        ".cshtml"
    ],
    aliases: [
        "Razor",
        "razor"
    ],
    mimetypes: [
        "text/x-cshtml"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("d782c7da07975fb4");
    }
});

},{"../_.contribution.js":"25RqS","d782c7da07975fb4":"cZk6r"}],"cZk6r":[function(require,module,exports) {
module.exports = require("ec33fc33fcb60f2")(require("a26545553215798a").resolve("2uBU6")).then(()=>module.bundle.root("8oOjE"));

},{"ec33fc33fcb60f2":"hpx0h","a26545553215798a":"fyJL2"}],"3Agir":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/redis/redis.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "redis",
    extensions: [
        ".redis"
    ],
    aliases: [
        "redis"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("e88e5679bda45557");
    }
});

},{"../_.contribution.js":"25RqS","e88e5679bda45557":"4Pesi"}],"4Pesi":[function(require,module,exports) {
module.exports = require("6c3889594f32e70f")(require("31360ae8c6588af1").resolve("4RE2d")).then(()=>module.bundle.root("hfdDJ"));

},{"6c3889594f32e70f":"hpx0h","31360ae8c6588af1":"fyJL2"}],"7pYrZ":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/redshift/redshift.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "redshift",
    extensions: [],
    aliases: [
        "Redshift",
        "redshift"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("84d0bbd9689439d3");
    }
});

},{"../_.contribution.js":"25RqS","84d0bbd9689439d3":"2N8DU"}],"2N8DU":[function(require,module,exports) {
module.exports = require("2e6550bf71c0f1fa")(require("c4f0c914a95dba76").resolve("jEC3g")).then(()=>module.bundle.root("3yw3W"));

},{"2e6550bf71c0f1fa":"hpx0h","c4f0c914a95dba76":"fyJL2"}],"g4w2c":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/restructuredtext/restructuredtext.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "restructuredtext",
    extensions: [
        ".rst"
    ],
    aliases: [
        "reStructuredText",
        "restructuredtext"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("b11929daeaeafa9");
    }
});

},{"../_.contribution.js":"25RqS","b11929daeaeafa9":"93ulQ"}],"93ulQ":[function(require,module,exports) {
module.exports = require("9de7715c5ac65f67")(require("b0a487ae4b9bd70").resolve("h6Wfy")).then(()=>module.bundle.root("hLliF"));

},{"9de7715c5ac65f67":"hpx0h","b0a487ae4b9bd70":"fyJL2"}],"b42Ma":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/ruby/ruby.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "ruby",
    extensions: [
        ".rb",
        ".rbx",
        ".rjs",
        ".gemspec",
        ".pp"
    ],
    filenames: [
        "rakefile",
        "Gemfile"
    ],
    aliases: [
        "Ruby",
        "rb"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("c67d73273dbd334a");
    }
});

},{"../_.contribution.js":"25RqS","c67d73273dbd334a":"hguFO"}],"hguFO":[function(require,module,exports) {
module.exports = require("fc1cbc40befe70f")(require("c0ea20eb107cb505").resolve("fOJff")).then(()=>module.bundle.root("3IJHF"));

},{"fc1cbc40befe70f":"hpx0h","c0ea20eb107cb505":"fyJL2"}],"85Y1o":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/rust/rust.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "rust",
    extensions: [
        ".rs",
        ".rlib"
    ],
    aliases: [
        "Rust",
        "rust"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("51d14921459c363d");
    }
});

},{"../_.contribution.js":"25RqS","51d14921459c363d":"lH4kH"}],"lH4kH":[function(require,module,exports) {
module.exports = require("c144b92f846f8c51")(require("454a71c2b702145").resolve("hZ8h9")).then(()=>module.bundle.root("lKaCl"));

},{"c144b92f846f8c51":"hpx0h","454a71c2b702145":"fyJL2"}],"gIto7":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/sb/sb.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "sb",
    extensions: [
        ".sb"
    ],
    aliases: [
        "Small Basic",
        "sb"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("36d29e7bcbbabfa8");
    }
});

},{"../_.contribution.js":"25RqS","36d29e7bcbbabfa8":"8b7Mp"}],"8b7Mp":[function(require,module,exports) {
module.exports = require("a04deb31381feae5")(require("226cc504ff43839d").resolve("7gGw4")).then(()=>module.bundle.root("eEegJ"));

},{"a04deb31381feae5":"hpx0h","226cc504ff43839d":"fyJL2"}],"RHgyA":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/scala/scala.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "scala",
    extensions: [
        ".scala",
        ".sc",
        ".sbt"
    ],
    aliases: [
        "Scala",
        "scala",
        "SBT",
        "Sbt",
        "sbt",
        "Dotty",
        "dotty"
    ],
    mimetypes: [
        "text/x-scala-source",
        "text/x-scala",
        "text/x-sbt",
        "text/x-dotty"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("91b9bb77ead98b6");
    }
});

},{"../_.contribution.js":"25RqS","91b9bb77ead98b6":"djwHd"}],"djwHd":[function(require,module,exports) {
module.exports = require("281f0a0cfff0765c")(require("2d1ee043b632c002").resolve("4xFFK")).then(()=>module.bundle.root("ff9DD"));

},{"281f0a0cfff0765c":"hpx0h","2d1ee043b632c002":"fyJL2"}],"fUrhd":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/scheme/scheme.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "scheme",
    extensions: [
        ".scm",
        ".ss",
        ".sch",
        ".rkt"
    ],
    aliases: [
        "scheme",
        "Scheme"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("7ed59eb707dd77a2");
    }
});

},{"../_.contribution.js":"25RqS","7ed59eb707dd77a2":"epg4c"}],"epg4c":[function(require,module,exports) {
module.exports = require("5cbfe337bb4139e9")(require("5211139f4a8dca55").resolve("fn4kJ")).then(()=>module.bundle.root("2QNHo"));

},{"5cbfe337bb4139e9":"hpx0h","5211139f4a8dca55":"fyJL2"}],"2pDOL":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/scss/scss.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "scss",
    extensions: [
        ".scss"
    ],
    aliases: [
        "Sass",
        "sass",
        "scss"
    ],
    mimetypes: [
        "text/x-scss",
        "text/scss"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("6b5b290e18a267d4");
    }
});

},{"../_.contribution.js":"25RqS","6b5b290e18a267d4":"6Cs81"}],"6Cs81":[function(require,module,exports) {
module.exports = require("97b4abc88b52ab90")(require("70c10ca6f08f9a8f").resolve("dvgrJ")).then(()=>module.bundle.root("yqfxK"));

},{"97b4abc88b52ab90":"hpx0h","70c10ca6f08f9a8f":"fyJL2"}],"bz7hw":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/shell/shell.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "shell",
    extensions: [
        ".sh",
        ".bash"
    ],
    aliases: [
        "Shell",
        "sh"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("88cc915cc0484bff");
    }
});

},{"../_.contribution.js":"25RqS","88cc915cc0484bff":"1fmKL"}],"1fmKL":[function(require,module,exports) {
module.exports = require("2e0a656a19a84f20")(require("959d3a5c76dea1d2").resolve("hffDT")).then(()=>module.bundle.root("jf5HI"));

},{"2e0a656a19a84f20":"hpx0h","959d3a5c76dea1d2":"fyJL2"}],"8cSrk":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/solidity/solidity.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "sol",
    extensions: [
        ".sol"
    ],
    aliases: [
        "sol",
        "solidity",
        "Solidity"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("b6cf89c9dc698331");
    }
});

},{"../_.contribution.js":"25RqS","b6cf89c9dc698331":"lkrfj"}],"lkrfj":[function(require,module,exports) {
module.exports = require("b687a47db7bb799c")(require("95992479c289480f").resolve("dHrdR")).then(()=>module.bundle.root("5x3gW"));

},{"b687a47db7bb799c":"hpx0h","95992479c289480f":"fyJL2"}],"dYLqL":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/sophia/sophia.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "aes",
    extensions: [
        ".aes"
    ],
    aliases: [
        "aes",
        "sophia",
        "Sophia"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("6501fa88381ec0e6");
    }
});

},{"../_.contribution.js":"25RqS","6501fa88381ec0e6":"6abiy"}],"6abiy":[function(require,module,exports) {
module.exports = require("c9a874110095de78")(require("a8e98706eb3df9cb").resolve("rQPie")).then(()=>module.bundle.root("lEbTd"));

},{"c9a874110095de78":"hpx0h","a8e98706eb3df9cb":"fyJL2"}],"b0Fi2":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/sparql/sparql.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "sparql",
    extensions: [
        ".rq"
    ],
    aliases: [
        "sparql",
        "SPARQL"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("a8c1599b4436b52b");
    }
});

},{"../_.contribution.js":"25RqS","a8c1599b4436b52b":"8oiyo"}],"8oiyo":[function(require,module,exports) {
module.exports = require("fda994c300582238")(require("570d503e2af98555").resolve("7Eojc")).then(()=>module.bundle.root("2jcyf"));

},{"fda994c300582238":"hpx0h","570d503e2af98555":"fyJL2"}],"iu8C4":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/sql/sql.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "sql",
    extensions: [
        ".sql"
    ],
    aliases: [
        "SQL"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("b4de9edb9b044e7e");
    }
});

},{"../_.contribution.js":"25RqS","b4de9edb9b044e7e":"iLR9f"}],"iLR9f":[function(require,module,exports) {
module.exports = require("344057dcd2bdd4e5")(require("e53060e2b82b8c06").resolve("4Oomy")).then(()=>module.bundle.root("iefQM"));

},{"344057dcd2bdd4e5":"hpx0h","e53060e2b82b8c06":"fyJL2"}],"9SSPf":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/st/st.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "st",
    extensions: [
        ".st",
        ".iecst",
        ".iecplc",
        ".lc3lib",
        ".TcPOU",
        ".TcDUT",
        ".TcGVL",
        ".TcIO"
    ],
    aliases: [
        "StructuredText",
        "scl",
        "stl"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("cf4d0d43fb4a8a7e");
    }
});

},{"../_.contribution.js":"25RqS","cf4d0d43fb4a8a7e":"aAVNX"}],"aAVNX":[function(require,module,exports) {
module.exports = require("e1f6e5615a3f6b01")(require("9dce0b6e79238a80").resolve("ZM729")).then(()=>module.bundle.root("9XZv2"));

},{"e1f6e5615a3f6b01":"hpx0h","9dce0b6e79238a80":"fyJL2"}],"iMrGT":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/swift/swift.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "swift",
    aliases: [
        "Swift",
        "swift"
    ],
    extensions: [
        ".swift"
    ],
    mimetypes: [
        "text/swift"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("39e1fc012fc91222");
    }
});

},{"../_.contribution.js":"25RqS","39e1fc012fc91222":"kYH1B"}],"kYH1B":[function(require,module,exports) {
module.exports = require("5cf119f7cd37abf5")(require("21259429fe3758d6").resolve("kOSnm")).then(()=>module.bundle.root("bS4jh"));

},{"5cf119f7cd37abf5":"hpx0h","21259429fe3758d6":"fyJL2"}],"i49tc":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/systemverilog/systemverilog.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "systemverilog",
    extensions: [
        ".sv",
        ".svh"
    ],
    aliases: [
        "SV",
        "sv",
        "SystemVerilog",
        "systemverilog"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("14851ff5f40c17b2");
    }
});
(0, _contributionJs.registerLanguage)({
    id: "verilog",
    extensions: [
        ".v",
        ".vh"
    ],
    aliases: [
        "V",
        "v",
        "Verilog",
        "verilog"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("14851ff5f40c17b2");
    }
});

},{"../_.contribution.js":"25RqS","14851ff5f40c17b2":"jjBmd"}],"jjBmd":[function(require,module,exports) {
module.exports = require("11715a4b3e42d990")(require("8be0425f8629a027").resolve("b8JJL")).then(()=>module.bundle.root("lhXA5"));

},{"11715a4b3e42d990":"hpx0h","8be0425f8629a027":"fyJL2"}],"dmtNI":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/tcl/tcl.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "tcl",
    extensions: [
        ".tcl"
    ],
    aliases: [
        "tcl",
        "Tcl",
        "tcltk",
        "TclTk",
        "tcl/tk",
        "Tcl/Tk"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("4c2b55452326128d");
    }
});

},{"../_.contribution.js":"25RqS","4c2b55452326128d":"cvYpt"}],"cvYpt":[function(require,module,exports) {
module.exports = require("88d68bde27f3f224")(require("e8eae90a9f5a8f20").resolve("kOIYU")).then(()=>module.bundle.root("k1AJl"));

},{"88d68bde27f3f224":"hpx0h","e8eae90a9f5a8f20":"fyJL2"}],"fvUfE":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/twig/twig.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "twig",
    extensions: [
        ".twig"
    ],
    aliases: [
        "Twig",
        "twig"
    ],
    mimetypes: [
        "text/x-twig"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("ffc9c6f4cc9af096");
    }
});

},{"../_.contribution.js":"25RqS","ffc9c6f4cc9af096":"hvrgy"}],"hvrgy":[function(require,module,exports) {
module.exports = require("49faf3e3b7d7a836")(require("9740e35de21d475").resolve("5ixKS")).then(()=>module.bundle.root("Qv2nR"));

},{"49faf3e3b7d7a836":"hpx0h","9740e35de21d475":"fyJL2"}],"blUbq":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/typescript/typescript.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "typescript",
    extensions: [
        ".ts",
        ".tsx",
        ".cts",
        ".mts"
    ],
    aliases: [
        "TypeScript",
        "ts",
        "typescript"
    ],
    mimetypes: [
        "text/typescript"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("3267964dd1aa7e60");
    }
});

},{"../_.contribution.js":"25RqS","3267964dd1aa7e60":"akMmx"}],"akMmx":[function(require,module,exports) {
module.exports = require("a835a7c6f0e8d7a")(require("8afb9bb9f757b061").resolve("9hWSy")).then(()=>module.bundle.root("cR09X"));

},{"a835a7c6f0e8d7a":"hpx0h","8afb9bb9f757b061":"fyJL2"}],"ftccF":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/typespec/typespec.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "typespec",
    extensions: [
        ".tsp"
    ],
    aliases: [
        "TypeSpec"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("f41333c49a0a3d8f");
    }
});

},{"../_.contribution.js":"25RqS","f41333c49a0a3d8f":"fSAND"}],"fSAND":[function(require,module,exports) {
module.exports = require("18540c3d76ffb42b")(require("ea64a07c657010ac").resolve("6H6vZ")).then(()=>module.bundle.root("a4sC5"));

},{"18540c3d76ffb42b":"hpx0h","ea64a07c657010ac":"fyJL2"}],"jAJ4M":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/vb/vb.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "vb",
    extensions: [
        ".vb"
    ],
    aliases: [
        "Visual Basic",
        "vb"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("5b832447963521c8");
    }
});

},{"../_.contribution.js":"25RqS","5b832447963521c8":"cxSIm"}],"cxSIm":[function(require,module,exports) {
module.exports = require("83b12ba3b20f34e4")(require("c21a0518a08eae9b").resolve("1x81c")).then(()=>module.bundle.root("l0RF0"));

},{"83b12ba3b20f34e4":"hpx0h","c21a0518a08eae9b":"fyJL2"}],"dS5Rp":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/wgsl/wgsl.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "wgsl",
    extensions: [
        ".wgsl"
    ],
    aliases: [
        "WebGPU Shading Language",
        "WGSL",
        "wgsl"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("60529e0798941a0c");
    }
});

},{"../_.contribution.js":"25RqS","60529e0798941a0c":"1MRiX"}],"1MRiX":[function(require,module,exports) {
module.exports = require("5ba6c3959a2b9c1e")(require("2626e4cbbab6e2ab").resolve("4V6Fe")).then(()=>module.bundle.root("eYamV"));

},{"5ba6c3959a2b9c1e":"hpx0h","2626e4cbbab6e2ab":"fyJL2"}],"fdU34":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/xml/xml.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "xml",
    extensions: [
        ".xml",
        ".xsd",
        ".dtd",
        ".ascx",
        ".csproj",
        ".config",
        ".props",
        ".targets",
        ".wxi",
        ".wxl",
        ".wxs",
        ".xaml",
        ".svg",
        ".svgz",
        ".opf",
        ".xslt",
        ".xsl"
    ],
    firstLine: "(\\<\\?xml.*)|(\\<svg)|(\\<\\!doctype\\s+svg)",
    aliases: [
        "XML",
        "xml"
    ],
    mimetypes: [
        "text/xml",
        "application/xml",
        "application/xaml+xml",
        "application/xml-dtd"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("bbb45b64c5cbf636");
    }
});

},{"../_.contribution.js":"25RqS","bbb45b64c5cbf636":"6noc5"}],"6noc5":[function(require,module,exports) {
module.exports = require("686e237f5ede845c")(require("444676d2f0ce0c63").resolve("4Us5b")).then(()=>module.bundle.root("aGXgC"));

},{"686e237f5ede845c":"hpx0h","444676d2f0ce0c63":"fyJL2"}],"gZr02":[function(require,module,exports) {
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ // src/basic-languages/yaml/yaml.contribution.ts
var _contributionJs = require("../_.contribution.js");
(0, _contributionJs.registerLanguage)({
    id: "yaml",
    extensions: [
        ".yaml",
        ".yml"
    ],
    aliases: [
        "YAML",
        "yaml",
        "YML",
        "yml"
    ],
    mimetypes: [
        "application/x-yaml",
        "text/x-yaml"
    ],
    loader: ()=>{
        var resolve, reject;
        return require("baa22d1f45dc92ca");
    }
});

},{"../_.contribution.js":"25RqS","baa22d1f45dc92ca":"gm7sF"}],"gm7sF":[function(require,module,exports) {
module.exports = require("607b19606d87f78c")(require("35478dd7c48609a6").resolve("3QIUZ")).then(()=>module.bundle.root("ipitf"));

},{"607b19606d87f78c":"hpx0h","35478dd7c48609a6":"fyJL2"}],"fp5U4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cssDefaults", ()=>cssDefaults);
parcelHelpers.export(exports, "lessDefaults", ()=>lessDefaults);
parcelHelpers.export(exports, "scssDefaults", ()=>scssDefaults);
var _editorApiJs = require("../../editor/editor.api.js");
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __reExport = (target, mod, secondTarget)=>(__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
// src/fillers/monaco-editor-core.ts
var monaco_editor_core_exports = {};
__reExport(monaco_editor_core_exports, _editorApiJs);
// src/language/css/monaco.contribution.ts
var LanguageServiceDefaultsImpl = class {
    constructor(languageId, options, modeConfiguration){
        this._onDidChange = new monaco_editor_core_exports.Emitter();
        this._languageId = languageId;
        this.setOptions(options);
        this.setModeConfiguration(modeConfiguration);
    }
    get onDidChange() {
        return this._onDidChange.event;
    }
    get languageId() {
        return this._languageId;
    }
    get modeConfiguration() {
        return this._modeConfiguration;
    }
    get diagnosticsOptions() {
        return this.options;
    }
    get options() {
        return this._options;
    }
    setOptions(options) {
        this._options = options || /* @__PURE__ */ Object.create(null);
        this._onDidChange.fire(this);
    }
    setDiagnosticsOptions(options) {
        this.setOptions(options);
    }
    setModeConfiguration(modeConfiguration) {
        this._modeConfiguration = modeConfiguration || /* @__PURE__ */ Object.create(null);
        this._onDidChange.fire(this);
    }
};
var optionsDefault = {
    validate: true,
    lint: {
        compatibleVendorPrefixes: "ignore",
        vendorPrefix: "warning",
        duplicateProperties: "warning",
        emptyRules: "warning",
        importStatement: "ignore",
        boxModel: "ignore",
        universalSelector: "ignore",
        zeroUnits: "ignore",
        fontFaceProperties: "warning",
        hexColorLength: "error",
        argumentsInColorFunction: "error",
        unknownProperties: "warning",
        ieHack: "ignore",
        unknownVendorSpecificProperties: "ignore",
        propertyIgnoredDueToDisplay: "warning",
        important: "ignore",
        float: "ignore",
        idSelector: "ignore"
    },
    data: {
        useDefaultDataProvider: true
    },
    format: {
        newlineBetweenSelectors: true,
        newlineBetweenRules: true,
        spaceAroundSelectorSeparator: false,
        braceStyle: "collapse",
        maxPreserveNewLines: void 0,
        preserveNewLines: true
    }
};
var modeConfigurationDefault = {
    completionItems: true,
    hovers: true,
    documentSymbols: true,
    definitions: true,
    references: true,
    documentHighlights: true,
    rename: true,
    colors: true,
    foldingRanges: true,
    diagnostics: true,
    selectionRanges: true,
    documentFormattingEdits: true,
    documentRangeFormattingEdits: true
};
var cssDefaults = new LanguageServiceDefaultsImpl("css", optionsDefault, modeConfigurationDefault);
var scssDefaults = new LanguageServiceDefaultsImpl("scss", optionsDefault, modeConfigurationDefault);
var lessDefaults = new LanguageServiceDefaultsImpl("less", optionsDefault, modeConfigurationDefault);
monaco_editor_core_exports.languages.css = {
    cssDefaults,
    lessDefaults,
    scssDefaults
};
function getMode() {
    var resolve, reject;
    return require("8a0d0d370f91b045");
}
monaco_editor_core_exports.languages.onLanguage("less", ()=>{
    getMode().then((mode)=>mode.setupMode(lessDefaults));
});
monaco_editor_core_exports.languages.onLanguage("scss", ()=>{
    getMode().then((mode)=>mode.setupMode(scssDefaults));
});
monaco_editor_core_exports.languages.onLanguage("css", ()=>{
    getMode().then((mode)=>mode.setupMode(cssDefaults));
});

},{"../../editor/editor.api.js":"6ZKre","8a0d0d370f91b045":"1cxCl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1cxCl":[function(require,module,exports) {
module.exports = require("fbbd300df60e8de2")(require("a8aaca5cb55d0409").resolve("8GN12")).then(()=>module.bundle.root("9LFsJ"));

},{"fbbd300df60e8de2":"hpx0h","a8aaca5cb55d0409":"fyJL2"}],"kwTBc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handlebarDefaults", ()=>handlebarDefaults);
parcelHelpers.export(exports, "handlebarLanguageService", ()=>handlebarLanguageService);
parcelHelpers.export(exports, "htmlDefaults", ()=>htmlDefaults);
parcelHelpers.export(exports, "htmlLanguageService", ()=>htmlLanguageService);
parcelHelpers.export(exports, "razorDefaults", ()=>razorDefaults);
parcelHelpers.export(exports, "razorLanguageService", ()=>razorLanguageService);
parcelHelpers.export(exports, "registerHTMLLanguageService", ()=>registerHTMLLanguageService);
var _editorApiJs = require("../../editor/editor.api.js");
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __reExport = (target, mod, secondTarget)=>(__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
// src/fillers/monaco-editor-core.ts
var monaco_editor_core_exports = {};
__reExport(monaco_editor_core_exports, _editorApiJs);
// src/language/html/monaco.contribution.ts
var LanguageServiceDefaultsImpl = class {
    constructor(languageId, options, modeConfiguration){
        this._onDidChange = new monaco_editor_core_exports.Emitter();
        this._languageId = languageId;
        this.setOptions(options);
        this.setModeConfiguration(modeConfiguration);
    }
    get onDidChange() {
        return this._onDidChange.event;
    }
    get languageId() {
        return this._languageId;
    }
    get options() {
        return this._options;
    }
    get modeConfiguration() {
        return this._modeConfiguration;
    }
    setOptions(options) {
        this._options = options || /* @__PURE__ */ Object.create(null);
        this._onDidChange.fire(this);
    }
    setModeConfiguration(modeConfiguration) {
        this._modeConfiguration = modeConfiguration || /* @__PURE__ */ Object.create(null);
        this._onDidChange.fire(this);
    }
};
var formatDefaults = {
    tabSize: 4,
    insertSpaces: false,
    wrapLineLength: 120,
    unformatted: 'default": "a, abbr, acronym, b, bdo, big, br, button, cite, code, dfn, em, i, img, input, kbd, label, map, object, q, samp, select, small, span, strong, sub, sup, textarea, tt, var',
    contentUnformatted: "pre",
    indentInnerHtml: false,
    preserveNewLines: true,
    maxPreserveNewLines: void 0,
    indentHandlebars: false,
    endWithNewline: false,
    extraLiners: "head, body, /html",
    wrapAttributes: "auto"
};
var optionsDefault = {
    format: formatDefaults,
    suggest: {},
    data: {
        useDefaultDataProvider: true
    }
};
function getConfigurationDefault(languageId) {
    return {
        completionItems: true,
        hovers: true,
        documentSymbols: true,
        links: true,
        documentHighlights: true,
        rename: true,
        colors: true,
        foldingRanges: true,
        selectionRanges: true,
        diagnostics: languageId === htmlLanguageId,
        // turned off for Razor and Handlebar
        documentFormattingEdits: languageId === htmlLanguageId,
        // turned off for Razor and Handlebar
        documentRangeFormattingEdits: languageId === htmlLanguageId
    };
}
var htmlLanguageId = "html";
var handlebarsLanguageId = "handlebars";
var razorLanguageId = "razor";
var htmlLanguageService = registerHTMLLanguageService(htmlLanguageId, optionsDefault, getConfigurationDefault(htmlLanguageId));
var htmlDefaults = htmlLanguageService.defaults;
var handlebarLanguageService = registerHTMLLanguageService(handlebarsLanguageId, optionsDefault, getConfigurationDefault(handlebarsLanguageId));
var handlebarDefaults = handlebarLanguageService.defaults;
var razorLanguageService = registerHTMLLanguageService(razorLanguageId, optionsDefault, getConfigurationDefault(razorLanguageId));
var razorDefaults = razorLanguageService.defaults;
monaco_editor_core_exports.languages.html = {
    htmlDefaults,
    razorDefaults,
    handlebarDefaults,
    htmlLanguageService,
    handlebarLanguageService,
    razorLanguageService,
    registerHTMLLanguageService
};
function getMode() {
    var resolve, reject;
    return require("797f9d5643999f63");
}
function registerHTMLLanguageService(languageId, options = optionsDefault, modeConfiguration = getConfigurationDefault(languageId)) {
    const defaults = new LanguageServiceDefaultsImpl(languageId, options, modeConfiguration);
    let mode;
    const onLanguageListener = monaco_editor_core_exports.languages.onLanguage(languageId, async ()=>{
        mode = (await getMode()).setupMode(defaults);
    });
    return {
        defaults,
        dispose () {
            onLanguageListener.dispose();
            mode?.dispose();
            mode = void 0;
        }
    };
}

},{"../../editor/editor.api.js":"6ZKre","797f9d5643999f63":"jplOn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jplOn":[function(require,module,exports) {
module.exports = require("78041e760ba5176b")(require("20cd4af656a9586b").resolve("2MkDw")).then(()=>module.bundle.root("gOFIT"));

},{"78041e760ba5176b":"hpx0h","20cd4af656a9586b":"fyJL2"}],"8ZBNP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWorker", ()=>getWorker);
parcelHelpers.export(exports, "jsonDefaults", ()=>jsonDefaults);
var _editorApiJs = require("../../editor/editor.api.js");
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __reExport = (target, mod, secondTarget)=>(__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
// src/fillers/monaco-editor-core.ts
var monaco_editor_core_exports = {};
__reExport(monaco_editor_core_exports, _editorApiJs);
// src/language/json/monaco.contribution.ts
var LanguageServiceDefaultsImpl = class {
    constructor(languageId, diagnosticsOptions, modeConfiguration){
        this._onDidChange = new monaco_editor_core_exports.Emitter();
        this._languageId = languageId;
        this.setDiagnosticsOptions(diagnosticsOptions);
        this.setModeConfiguration(modeConfiguration);
    }
    get onDidChange() {
        return this._onDidChange.event;
    }
    get languageId() {
        return this._languageId;
    }
    get modeConfiguration() {
        return this._modeConfiguration;
    }
    get diagnosticsOptions() {
        return this._diagnosticsOptions;
    }
    setDiagnosticsOptions(options) {
        this._diagnosticsOptions = options || /* @__PURE__ */ Object.create(null);
        this._onDidChange.fire(this);
    }
    setModeConfiguration(modeConfiguration) {
        this._modeConfiguration = modeConfiguration || /* @__PURE__ */ Object.create(null);
        this._onDidChange.fire(this);
    }
};
var diagnosticDefault = {
    validate: true,
    allowComments: true,
    schemas: [],
    enableSchemaRequest: false,
    schemaRequest: "warning",
    schemaValidation: "warning",
    comments: "error",
    trailingCommas: "error"
};
var modeConfigurationDefault = {
    documentFormattingEdits: true,
    documentRangeFormattingEdits: true,
    completionItems: true,
    hovers: true,
    documentSymbols: true,
    tokens: true,
    colors: true,
    foldingRanges: true,
    diagnostics: true,
    selectionRanges: true
};
var jsonDefaults = new LanguageServiceDefaultsImpl("json", diagnosticDefault, modeConfigurationDefault);
var getWorker = ()=>getMode().then((mode)=>mode.getWorker());
monaco_editor_core_exports.languages.json = {
    jsonDefaults,
    getWorker
};
function getMode() {
    var resolve, reject;
    return require("72fb18fee60b8939");
}
monaco_editor_core_exports.languages.register({
    id: "json",
    extensions: [
        ".json",
        ".bowerrc",
        ".jshintrc",
        ".jscsrc",
        ".eslintrc",
        ".babelrc",
        ".har"
    ],
    aliases: [
        "JSON",
        "json"
    ],
    mimetypes: [
        "application/json"
    ]
});
monaco_editor_core_exports.languages.onLanguage("json", ()=>{
    getMode().then((mode)=>mode.setupMode(jsonDefaults));
});

},{"../../editor/editor.api.js":"6ZKre","72fb18fee60b8939":"aE2nh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aE2nh":[function(require,module,exports) {
module.exports = require("2280d5b8f00d9f35")(require("e38f0b23f811a97b").resolve("JsyZ7")).then(()=>module.bundle.root("eVbMa"));

},{"2280d5b8f00d9f35":"hpx0h","e38f0b23f811a97b":"fyJL2"}],"jS83e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JsxEmit", ()=>JsxEmit);
parcelHelpers.export(exports, "ModuleKind", ()=>ModuleKind);
parcelHelpers.export(exports, "ModuleResolutionKind", ()=>ModuleResolutionKind);
parcelHelpers.export(exports, "NewLineKind", ()=>NewLineKind);
parcelHelpers.export(exports, "ScriptTarget", ()=>ScriptTarget);
parcelHelpers.export(exports, "getJavaScriptWorker", ()=>getJavaScriptWorker);
parcelHelpers.export(exports, "getTypeScriptWorker", ()=>getTypeScriptWorker);
parcelHelpers.export(exports, "javascriptDefaults", ()=>javascriptDefaults);
parcelHelpers.export(exports, "typescriptDefaults", ()=>typescriptDefaults);
parcelHelpers.export(exports, "typescriptVersion", ()=>typescriptVersion2);
var _editorApiJs = require("../../editor/editor.api.js");
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.52.0(f6dc0eb8fce67e57f6036f4769d92c1666cdf546)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/ var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __reExport = (target, mod, secondTarget)=>(__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
// src/language/typescript/lib/typescriptServicesMetadata.ts
var typescriptVersion = "5.4.5";
// src/fillers/monaco-editor-core.ts
var monaco_editor_core_exports = {};
__reExport(monaco_editor_core_exports, _editorApiJs);
// src/language/typescript/monaco.contribution.ts
var ModuleKind = /* @__PURE__ */ ((ModuleKind2)=>{
    ModuleKind2[ModuleKind2["None"] = 0] = "None";
    ModuleKind2[ModuleKind2["CommonJS"] = 1] = "CommonJS";
    ModuleKind2[ModuleKind2["AMD"] = 2] = "AMD";
    ModuleKind2[ModuleKind2["UMD"] = 3] = "UMD";
    ModuleKind2[ModuleKind2["System"] = 4] = "System";
    ModuleKind2[ModuleKind2["ES2015"] = 5] = "ES2015";
    ModuleKind2[ModuleKind2["ESNext"] = 99] = "ESNext";
    return ModuleKind2;
})(ModuleKind || {});
var JsxEmit = /* @__PURE__ */ ((JsxEmit2)=>{
    JsxEmit2[JsxEmit2["None"] = 0] = "None";
    JsxEmit2[JsxEmit2["Preserve"] = 1] = "Preserve";
    JsxEmit2[JsxEmit2["React"] = 2] = "React";
    JsxEmit2[JsxEmit2["ReactNative"] = 3] = "ReactNative";
    JsxEmit2[JsxEmit2["ReactJSX"] = 4] = "ReactJSX";
    JsxEmit2[JsxEmit2["ReactJSXDev"] = 5] = "ReactJSXDev";
    return JsxEmit2;
})(JsxEmit || {});
var NewLineKind = /* @__PURE__ */ ((NewLineKind2)=>{
    NewLineKind2[NewLineKind2["CarriageReturnLineFeed"] = 0] = "CarriageReturnLineFeed";
    NewLineKind2[NewLineKind2["LineFeed"] = 1] = "LineFeed";
    return NewLineKind2;
})(NewLineKind || {});
var ScriptTarget = /* @__PURE__ */ ((ScriptTarget2)=>{
    ScriptTarget2[ScriptTarget2["ES3"] = 0] = "ES3";
    ScriptTarget2[ScriptTarget2["ES5"] = 1] = "ES5";
    ScriptTarget2[ScriptTarget2["ES2015"] = 2] = "ES2015";
    ScriptTarget2[ScriptTarget2["ES2016"] = 3] = "ES2016";
    ScriptTarget2[ScriptTarget2["ES2017"] = 4] = "ES2017";
    ScriptTarget2[ScriptTarget2["ES2018"] = 5] = "ES2018";
    ScriptTarget2[ScriptTarget2["ES2019"] = 6] = "ES2019";
    ScriptTarget2[ScriptTarget2["ES2020"] = 7] = "ES2020";
    ScriptTarget2[ScriptTarget2["ESNext"] = 99] = "ESNext";
    ScriptTarget2[ScriptTarget2["JSON"] = 100] = "JSON";
    ScriptTarget2[ScriptTarget2["Latest"] = 99 /* ESNext */ ] = "Latest";
    return ScriptTarget2;
})(ScriptTarget || {});
var ModuleResolutionKind = /* @__PURE__ */ ((ModuleResolutionKind2)=>{
    ModuleResolutionKind2[ModuleResolutionKind2["Classic"] = 1] = "Classic";
    ModuleResolutionKind2[ModuleResolutionKind2["NodeJs"] = 2] = "NodeJs";
    return ModuleResolutionKind2;
})(ModuleResolutionKind || {});
var LanguageServiceDefaultsImpl = class {
    constructor(compilerOptions, diagnosticsOptions, workerOptions, inlayHintsOptions, modeConfiguration){
        this._onDidChange = new monaco_editor_core_exports.Emitter();
        this._onDidExtraLibsChange = new monaco_editor_core_exports.Emitter();
        this._extraLibs = /* @__PURE__ */ Object.create(null);
        this._removedExtraLibs = /* @__PURE__ */ Object.create(null);
        this._eagerModelSync = false;
        this.setCompilerOptions(compilerOptions);
        this.setDiagnosticsOptions(diagnosticsOptions);
        this.setWorkerOptions(workerOptions);
        this.setInlayHintsOptions(inlayHintsOptions);
        this.setModeConfiguration(modeConfiguration);
        this._onDidExtraLibsChangeTimeout = -1;
    }
    get onDidChange() {
        return this._onDidChange.event;
    }
    get onDidExtraLibsChange() {
        return this._onDidExtraLibsChange.event;
    }
    get modeConfiguration() {
        return this._modeConfiguration;
    }
    get workerOptions() {
        return this._workerOptions;
    }
    get inlayHintsOptions() {
        return this._inlayHintsOptions;
    }
    getExtraLibs() {
        return this._extraLibs;
    }
    addExtraLib(content, _filePath) {
        let filePath;
        if (typeof _filePath === "undefined") filePath = `ts:extralib-${Math.random().toString(36).substring(2, 15)}`;
        else filePath = _filePath;
        if (this._extraLibs[filePath] && this._extraLibs[filePath].content === content) return {
            dispose: ()=>{}
        };
        let myVersion = 1;
        if (this._removedExtraLibs[filePath]) myVersion = this._removedExtraLibs[filePath] + 1;
        if (this._extraLibs[filePath]) myVersion = this._extraLibs[filePath].version + 1;
        this._extraLibs[filePath] = {
            content,
            version: myVersion
        };
        this._fireOnDidExtraLibsChangeSoon();
        return {
            dispose: ()=>{
                let extraLib = this._extraLibs[filePath];
                if (!extraLib) return;
                if (extraLib.version !== myVersion) return;
                delete this._extraLibs[filePath];
                this._removedExtraLibs[filePath] = myVersion;
                this._fireOnDidExtraLibsChangeSoon();
            }
        };
    }
    setExtraLibs(libs) {
        for(const filePath in this._extraLibs)this._removedExtraLibs[filePath] = this._extraLibs[filePath].version;
        this._extraLibs = /* @__PURE__ */ Object.create(null);
        if (libs && libs.length > 0) for (const lib of libs){
            const filePath = lib.filePath || `ts:extralib-${Math.random().toString(36).substring(2, 15)}`;
            const content = lib.content;
            let myVersion = 1;
            if (this._removedExtraLibs[filePath]) myVersion = this._removedExtraLibs[filePath] + 1;
            this._extraLibs[filePath] = {
                content,
                version: myVersion
            };
        }
        this._fireOnDidExtraLibsChangeSoon();
    }
    _fireOnDidExtraLibsChangeSoon() {
        if (this._onDidExtraLibsChangeTimeout !== -1) return;
        this._onDidExtraLibsChangeTimeout = window.setTimeout(()=>{
            this._onDidExtraLibsChangeTimeout = -1;
            this._onDidExtraLibsChange.fire(void 0);
        }, 0);
    }
    getCompilerOptions() {
        return this._compilerOptions;
    }
    setCompilerOptions(options) {
        this._compilerOptions = options || /* @__PURE__ */ Object.create(null);
        this._onDidChange.fire(void 0);
    }
    getDiagnosticsOptions() {
        return this._diagnosticsOptions;
    }
    setDiagnosticsOptions(options) {
        this._diagnosticsOptions = options || /* @__PURE__ */ Object.create(null);
        this._onDidChange.fire(void 0);
    }
    setWorkerOptions(options) {
        this._workerOptions = options || /* @__PURE__ */ Object.create(null);
        this._onDidChange.fire(void 0);
    }
    setInlayHintsOptions(options) {
        this._inlayHintsOptions = options || /* @__PURE__ */ Object.create(null);
        this._onDidChange.fire(void 0);
    }
    setMaximumWorkerIdleTime(value) {}
    setEagerModelSync(value) {
        this._eagerModelSync = value;
    }
    getEagerModelSync() {
        return this._eagerModelSync;
    }
    setModeConfiguration(modeConfiguration) {
        this._modeConfiguration = modeConfiguration || /* @__PURE__ */ Object.create(null);
        this._onDidChange.fire(void 0);
    }
};
var typescriptVersion2 = typescriptVersion;
var modeConfigurationDefault = {
    completionItems: true,
    hovers: true,
    documentSymbols: true,
    definitions: true,
    references: true,
    documentHighlights: true,
    rename: true,
    diagnostics: true,
    documentRangeFormattingEdits: true,
    signatureHelp: true,
    onTypeFormattingEdits: true,
    codeActions: true,
    inlayHints: true
};
var typescriptDefaults = new LanguageServiceDefaultsImpl({
    allowNonTsExtensions: true,
    target: 99 /* Latest */ 
}, {
    noSemanticValidation: false,
    noSyntaxValidation: false,
    onlyVisible: false
}, {}, {}, modeConfigurationDefault);
var javascriptDefaults = new LanguageServiceDefaultsImpl({
    allowNonTsExtensions: true,
    allowJs: true,
    target: 99 /* Latest */ 
}, {
    noSemanticValidation: true,
    noSyntaxValidation: false,
    onlyVisible: false
}, {}, {}, modeConfigurationDefault);
var getTypeScriptWorker = ()=>{
    return getMode().then((mode)=>mode.getTypeScriptWorker());
};
var getJavaScriptWorker = ()=>{
    return getMode().then((mode)=>mode.getJavaScriptWorker());
};
monaco_editor_core_exports.languages.typescript = {
    ModuleKind,
    JsxEmit,
    NewLineKind,
    ScriptTarget,
    ModuleResolutionKind,
    typescriptVersion: typescriptVersion2,
    typescriptDefaults,
    javascriptDefaults,
    getTypeScriptWorker,
    getJavaScriptWorker
};
function getMode() {
    var resolve, reject;
    return require("8ab55ad7f213c06e");
}
monaco_editor_core_exports.languages.onLanguage("typescript", ()=>{
    return getMode().then((mode)=>mode.setupTypeScript(typescriptDefaults));
});
monaco_editor_core_exports.languages.onLanguage("javascript", ()=>{
    return getMode().then((mode)=>mode.setupJavaScript(javascriptDefaults));
});

},{"../../editor/editor.api.js":"6ZKre","8ab55ad7f213c06e":"etKBA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"etKBA":[function(require,module,exports) {
module.exports = require("762ec69becb03401")(require("fbbb852157940641").resolve("fw2jb")).then(()=>module.bundle.root("a2WUE"));

},{"762ec69becb03401":"hpx0h","fbbb852157940641":"fyJL2"}],"4wiGa":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _editorAllJs = require("./editor.all.js");
var _iPadShowKeyboardJs = require("./standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js");
var _inspectTokensJs = require("./standalone/browser/inspectTokens/inspectTokens.js");
var _standaloneHelpQuickAccessJs = require("./standalone/browser/quickAccess/standaloneHelpQuickAccess.js");
var _standaloneGotoLineQuickAccessJs = require("./standalone/browser/quickAccess/standaloneGotoLineQuickAccess.js");
var _standaloneGotoSymbolQuickAccessJs = require("./standalone/browser/quickAccess/standaloneGotoSymbolQuickAccess.js");
var _standaloneCommandsQuickAccessJs = require("./standalone/browser/quickAccess/standaloneCommandsQuickAccess.js");
var _standaloneReferenceSearchJs = require("./standalone/browser/referenceSearch/standaloneReferenceSearch.js");
var _toggleHighContrastJs = require("./standalone/browser/toggleHighContrast/toggleHighContrast.js");
var _editorApiJs = require("./editor.api.js");
parcelHelpers.exportAll(_editorApiJs, exports);

},{"./editor.all.js":"6eXof","./standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js":"gmEes","./standalone/browser/inspectTokens/inspectTokens.js":"bXurD","./standalone/browser/quickAccess/standaloneHelpQuickAccess.js":"lKwNi","./standalone/browser/quickAccess/standaloneGotoLineQuickAccess.js":"54Au8","./standalone/browser/quickAccess/standaloneGotoSymbolQuickAccess.js":"8tvuL","./standalone/browser/quickAccess/standaloneCommandsQuickAccess.js":"h2w7A","./standalone/browser/referenceSearch/standaloneReferenceSearch.js":"fLfR5","./standalone/browser/toggleHighContrast/toggleHighContrast.js":"4HxxH","./editor.api.js":"6ZKre","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6eXof":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _coreCommandsJs = require("./browser/coreCommands.js");
var _codeEditorWidgetJs = require("./browser/widget/codeEditor/codeEditorWidget.js");
var _diffEditorContributionJs = require("./browser/widget/diffEditor/diffEditor.contribution.js");
var _anchorSelectJs = require("./contrib/anchorSelect/browser/anchorSelect.js");
var _bracketMatchingJs = require("./contrib/bracketMatching/browser/bracketMatching.js");
var _caretOperationsJs = require("./contrib/caretOperations/browser/caretOperations.js");
var _transposeJs = require("./contrib/caretOperations/browser/transpose.js");
var _clipboardJs = require("./contrib/clipboard/browser/clipboard.js");
var _codeActionContributionsJs = require("./contrib/codeAction/browser/codeActionContributions.js");
var _codelensControllerJs = require("./contrib/codelens/browser/codelensController.js");
var _colorContributionsJs = require("./contrib/colorPicker/browser/colorContributions.js");
var _standaloneColorPickerActionsJs = require("./contrib/colorPicker/browser/standaloneColorPickerActions.js");
var _commentJs = require("./contrib/comment/browser/comment.js");
var _contextmenuJs = require("./contrib/contextmenu/browser/contextmenu.js");
var _cursorUndoJs = require("./contrib/cursorUndo/browser/cursorUndo.js");
var _dndJs = require("./contrib/dnd/browser/dnd.js");
var _copyPasteContributionJs = require("./contrib/dropOrPasteInto/browser/copyPasteContribution.js");
var _dropIntoEditorContributionJs = require("./contrib/dropOrPasteInto/browser/dropIntoEditorContribution.js");
var _findControllerJs = require("./contrib/find/browser/findController.js");
var _foldingJs = require("./contrib/folding/browser/folding.js");
var _fontZoomJs = require("./contrib/fontZoom/browser/fontZoom.js");
var _formatActionsJs = require("./contrib/format/browser/formatActions.js");
var _documentSymbolsJs = require("./contrib/documentSymbols/browser/documentSymbols.js");
var _inlineCompletionsContributionJs = require("./contrib/inlineCompletions/browser/inlineCompletions.contribution.js");
var _inlineProgressJs = require("./contrib/inlineProgress/browser/inlineProgress.js");
var _goToCommandsJs = require("./contrib/gotoSymbol/browser/goToCommands.js");
var _goToDefinitionAtPositionJs = require("./contrib/gotoSymbol/browser/link/goToDefinitionAtPosition.js");
var _gotoErrorJs = require("./contrib/gotoError/browser/gotoError.js");
var _hoverContributionJs = require("./contrib/hover/browser/hoverContribution.js");
var _indentationJs = require("./contrib/indentation/browser/indentation.js");
var _inlayHintsContributionJs = require("./contrib/inlayHints/browser/inlayHintsContribution.js");
var _inPlaceReplaceJs = require("./contrib/inPlaceReplace/browser/inPlaceReplace.js");
var _lineSelectionJs = require("./contrib/lineSelection/browser/lineSelection.js");
var _linesOperationsJs = require("./contrib/linesOperations/browser/linesOperations.js");
var _linkedEditingJs = require("./contrib/linkedEditing/browser/linkedEditing.js");
var _linksJs = require("./contrib/links/browser/links.js");
var _longLinesHelperJs = require("./contrib/longLinesHelper/browser/longLinesHelper.js");
var _multicursorJs = require("./contrib/multicursor/browser/multicursor.js");
var _inlineEditContributionJs = require("./contrib/inlineEdit/browser/inlineEdit.contribution.js");
var _inlineEditsContributionJs = require("./contrib/inlineEdits/browser/inlineEdits.contribution.js");
var _parameterHintsJs = require("./contrib/parameterHints/browser/parameterHints.js");
var _placeholderTextContributionJs = require("./contrib/placeholderText/browser/placeholderText.contribution.js");
var _renameJs = require("./contrib/rename/browser/rename.js");
var _sectionHeadersJs = require("./contrib/sectionHeaders/browser/sectionHeaders.js");
var _documentSemanticTokensJs = require("./contrib/semanticTokens/browser/documentSemanticTokens.js");
var _viewportSemanticTokensJs = require("./contrib/semanticTokens/browser/viewportSemanticTokens.js");
var _smartSelectJs = require("./contrib/smartSelect/browser/smartSelect.js");
var _snippetController2Js = require("./contrib/snippet/browser/snippetController2.js");
var _stickyScrollContributionJs = require("./contrib/stickyScroll/browser/stickyScrollContribution.js");
var _suggestControllerJs = require("./contrib/suggest/browser/suggestController.js");
var _suggestInlineCompletionsJs = require("./contrib/suggest/browser/suggestInlineCompletions.js");
var _tokenizationJs = require("./contrib/tokenization/browser/tokenization.js");
var _toggleTabFocusModeJs = require("./contrib/toggleTabFocusMode/browser/toggleTabFocusMode.js");
var _unicodeHighlighterJs = require("./contrib/unicodeHighlighter/browser/unicodeHighlighter.js");
var _unusualLineTerminatorsJs = require("./contrib/unusualLineTerminators/browser/unusualLineTerminators.js");
var _wordHighlighterJs = require("./contrib/wordHighlighter/browser/wordHighlighter.js");
var _wordOperationsJs = require("./contrib/wordOperations/browser/wordOperations.js");
var _wordPartOperationsJs = require("./contrib/wordPartOperations/browser/wordPartOperations.js");
var _contributionJs = require("./contrib/readOnlyMessage/browser/contribution.js");
var _contributionJs1 = require("./contrib/diffEditorBreadcrumbs/browser/contribution.js");
// Load up these strings even in VSCode, even if they are not used
// in order to get them translated
var _standaloneStringsJs = require("./common/standaloneStrings.js");
var _codiconStylesJs = require("../base/browser/ui/codicons/codiconStyles.js"); // The codicons are defined here and must be loaded

},{"./browser/coreCommands.js":"3GyQi","./browser/widget/codeEditor/codeEditorWidget.js":"kFkuL","./browser/widget/diffEditor/diffEditor.contribution.js":"9eDqO","./contrib/anchorSelect/browser/anchorSelect.js":"9OnRk","./contrib/bracketMatching/browser/bracketMatching.js":"26nnn","./contrib/caretOperations/browser/caretOperations.js":"6BJje","./contrib/caretOperations/browser/transpose.js":"adkK9","./contrib/clipboard/browser/clipboard.js":"iASLl","./contrib/codeAction/browser/codeActionContributions.js":"8D9IZ","./contrib/codelens/browser/codelensController.js":"37ZM8","./contrib/colorPicker/browser/colorContributions.js":"3wIOC","./contrib/colorPicker/browser/standaloneColorPickerActions.js":"4oYbU","./contrib/comment/browser/comment.js":"Nwp5Z","./contrib/contextmenu/browser/contextmenu.js":"dHaR7","./contrib/cursorUndo/browser/cursorUndo.js":"5cors","./contrib/dnd/browser/dnd.js":"b3Vt2","./contrib/dropOrPasteInto/browser/copyPasteContribution.js":"goWbc","./contrib/dropOrPasteInto/browser/dropIntoEditorContribution.js":"h3UhH","./contrib/find/browser/findController.js":"6yJPJ","./contrib/folding/browser/folding.js":"iWk0I","./contrib/fontZoom/browser/fontZoom.js":"3Ecgl","./contrib/format/browser/formatActions.js":"eUpMt","./contrib/documentSymbols/browser/documentSymbols.js":"3GSL5","./contrib/inlineCompletions/browser/inlineCompletions.contribution.js":"aA3C6","./contrib/inlineProgress/browser/inlineProgress.js":"a5six","./contrib/gotoSymbol/browser/goToCommands.js":"jkumD","./contrib/gotoSymbol/browser/link/goToDefinitionAtPosition.js":"7ATNy","./contrib/gotoError/browser/gotoError.js":"iqB4x","./contrib/hover/browser/hoverContribution.js":"gZ9QW","./contrib/indentation/browser/indentation.js":"lqLEk","./contrib/inlayHints/browser/inlayHintsContribution.js":"1WSAT","./contrib/inPlaceReplace/browser/inPlaceReplace.js":"bwMPX","./contrib/lineSelection/browser/lineSelection.js":"1Yron","./contrib/linesOperations/browser/linesOperations.js":"h0mDH","./contrib/linkedEditing/browser/linkedEditing.js":"eHsmo","./contrib/links/browser/links.js":"fLS4Z","./contrib/longLinesHelper/browser/longLinesHelper.js":"eebrG","./contrib/multicursor/browser/multicursor.js":"fdlsM","./contrib/inlineEdit/browser/inlineEdit.contribution.js":"7CXfw","./contrib/inlineEdits/browser/inlineEdits.contribution.js":"3wp28","./contrib/parameterHints/browser/parameterHints.js":"8QJnf","./contrib/placeholderText/browser/placeholderText.contribution.js":"jiZEv","./contrib/rename/browser/rename.js":"4nbx0","./contrib/sectionHeaders/browser/sectionHeaders.js":"6g5ke","./contrib/semanticTokens/browser/documentSemanticTokens.js":"kfVPn","./contrib/semanticTokens/browser/viewportSemanticTokens.js":"mYHoZ","./contrib/smartSelect/browser/smartSelect.js":"hWC3V","./contrib/snippet/browser/snippetController2.js":"0XDQb","./contrib/stickyScroll/browser/stickyScrollContribution.js":"362Xt","./contrib/suggest/browser/suggestController.js":"jcXag","./contrib/suggest/browser/suggestInlineCompletions.js":"hrN8f","./contrib/tokenization/browser/tokenization.js":"ekXzT","./contrib/toggleTabFocusMode/browser/toggleTabFocusMode.js":"asKZX","./contrib/unicodeHighlighter/browser/unicodeHighlighter.js":"kla5S","./contrib/unusualLineTerminators/browser/unusualLineTerminators.js":"4dLcZ","./contrib/wordHighlighter/browser/wordHighlighter.js":"hb76w","./contrib/wordOperations/browser/wordOperations.js":"kEDSr","./contrib/wordPartOperations/browser/wordPartOperations.js":"7NRbb","./contrib/readOnlyMessage/browser/contribution.js":"6qfo8","./contrib/diffEditorBreadcrumbs/browser/contribution.js":"2dZwI","./common/standaloneStrings.js":"D35dK","../base/browser/ui/codicons/codiconStyles.js":"guMVT"}],"9eDqO":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _codiconsJs = require("../../../../base/common/codicons.js");
var _commandsJs = require("./commands.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _commandsJs1 = require("../../../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _registrationsContributionJs = require("./registrations.contribution.js");
(0, _actionsJs.registerAction2)((0, _commandsJs.ToggleCollapseUnchangedRegions));
(0, _actionsJs.registerAction2)((0, _commandsJs.ToggleShowMovedCodeBlocks));
(0, _actionsJs.registerAction2)((0, _commandsJs.ToggleUseInlineViewWhenSpaceIsLimited));
(0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).EditorTitle, {
    command: {
        id: new (0, _commandsJs.ToggleUseInlineViewWhenSpaceIsLimited)().desc.id,
        title: (0, _nlsJs.localize)("useInlineViewWhenSpaceIsLimited", "Use Inline View When Space Is Limited"),
        toggled: (0, _contextkeyJs.ContextKeyExpr).has("config.diffEditor.useInlineViewWhenSpaceIsLimited"),
        precondition: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor")
    },
    order: 11,
    group: "1_diff",
    when: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).diffEditorRenderSideBySideInlineBreakpointReached, (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor"))
});
(0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).EditorTitle, {
    command: {
        id: new (0, _commandsJs.ToggleShowMovedCodeBlocks)().desc.id,
        title: (0, _nlsJs.localize)("showMoves", "Show Moved Code Blocks"),
        icon: (0, _codiconsJs.Codicon).move,
        toggled: (0, _contextkeyJs.ContextKeyEqualsExpr).create("config.diffEditor.experimental.showMoves", true),
        precondition: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor")
    },
    order: 10,
    group: "1_diff",
    when: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor")
});
(0, _actionsJs.registerAction2)((0, _commandsJs.RevertHunkOrSelection));
for (const ctx of [
    {
        icon: (0, _codiconsJs.Codicon).arrowRight,
        key: (0, _editorContextKeysJs.EditorContextKeys).diffEditorInlineMode.toNegated()
    },
    {
        icon: (0, _codiconsJs.Codicon).discard,
        key: (0, _editorContextKeysJs.EditorContextKeys).diffEditorInlineMode
    }
]){
    (0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).DiffEditorHunkToolbar, {
        command: {
            id: new (0, _commandsJs.RevertHunkOrSelection)().desc.id,
            title: (0, _nlsJs.localize)("revertHunk", "Revert Block"),
            icon: ctx.icon
        },
        when: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).diffEditorModifiedWritable, ctx.key),
        order: 5,
        group: "primary"
    });
    (0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).DiffEditorSelectionToolbar, {
        command: {
            id: new (0, _commandsJs.RevertHunkOrSelection)().desc.id,
            title: (0, _nlsJs.localize)("revertSelection", "Revert Selection"),
            icon: ctx.icon
        },
        when: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).diffEditorModifiedWritable, ctx.key),
        order: 5,
        group: "primary"
    });
}
(0, _actionsJs.registerAction2)((0, _commandsJs.SwitchSide));
(0, _actionsJs.registerAction2)((0, _commandsJs.ExitCompareMove));
(0, _actionsJs.registerAction2)((0, _commandsJs.CollapseAllUnchangedRegions));
(0, _actionsJs.registerAction2)((0, _commandsJs.ShowAllUnchangedRegions));
(0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).EditorTitle, {
    command: {
        id: (0, _commandsJs.AccessibleDiffViewerNext).id,
        title: (0, _nlsJs.localize)("Open Accessible Diff Viewer", "Open Accessible Diff Viewer"),
        precondition: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor")
    },
    order: 10,
    group: "2_diff",
    when: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).accessibleDiffViewerVisible.negate(), (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor"))
});
(0, _commandsJs1.CommandsRegistry).registerCommandAlias("editor.action.diffReview.next", (0, _commandsJs.AccessibleDiffViewerNext).id);
(0, _actionsJs.registerAction2)((0, _commandsJs.AccessibleDiffViewerNext));
(0, _commandsJs1.CommandsRegistry).registerCommandAlias("editor.action.diffReview.prev", (0, _commandsJs.AccessibleDiffViewerPrev).id);
(0, _actionsJs.registerAction2)((0, _commandsJs.AccessibleDiffViewerPrev));

},{"../../../../base/common/codicons.js":"hWYNf","./commands.js":"ai1Bv","../../../common/editorContextKeys.js":"5exv9","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/contextkey/common/contextkey.js":"gXuBD","./registrations.contribution.js":"3EY0P"}],"ai1Bv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleCollapseUnchangedRegions", ()=>ToggleCollapseUnchangedRegions);
parcelHelpers.export(exports, "ToggleShowMovedCodeBlocks", ()=>ToggleShowMovedCodeBlocks);
parcelHelpers.export(exports, "ToggleUseInlineViewWhenSpaceIsLimited", ()=>ToggleUseInlineViewWhenSpaceIsLimited);
parcelHelpers.export(exports, "SwitchSide", ()=>SwitchSide);
parcelHelpers.export(exports, "ExitCompareMove", ()=>ExitCompareMove);
parcelHelpers.export(exports, "CollapseAllUnchangedRegions", ()=>CollapseAllUnchangedRegions);
parcelHelpers.export(exports, "ShowAllUnchangedRegions", ()=>ShowAllUnchangedRegions);
parcelHelpers.export(exports, "RevertHunkOrSelection", ()=>RevertHunkOrSelection);
parcelHelpers.export(exports, "AccessibleDiffViewerNext", ()=>AccessibleDiffViewerNext);
parcelHelpers.export(exports, "AccessibleDiffViewerPrev", ()=>AccessibleDiffViewerPrev);
parcelHelpers.export(exports, "findDiffEditor", ()=>findDiffEditor);
parcelHelpers.export(exports, "findFocusedDiffEditor", ()=>findFocusedDiffEditor);
var _domJs = require("../../../../base/browser/dom.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _editorExtensionsJs = require("../../editorExtensions.js");
var _codeEditorServiceJs = require("../../services/codeEditorService.js");
var _diffEditorWidgetJs = require("./diffEditorWidget.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _registrationsContributionJs = require("./registrations.contribution.js");
class ToggleCollapseUnchangedRegions extends (0, _actionsJs.Action2) {
    constructor(){
        super({
            id: "diffEditor.toggleCollapseUnchangedRegions",
            title: (0, _nlsJs.localize2)("toggleCollapseUnchangedRegions", "Toggle Collapse Unchanged Regions"),
            icon: (0, _codiconsJs.Codicon).map,
            toggled: (0, _contextkeyJs.ContextKeyExpr).has("config.diffEditor.hideUnchangedRegions.enabled"),
            precondition: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor"),
            menu: {
                when: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor"),
                id: (0, _actionsJs.MenuId).EditorTitle,
                order: 22,
                group: "navigation"
            }
        });
    }
    run(accessor, ...args) {
        const configurationService = accessor.get((0, _configurationJs.IConfigurationService));
        const newValue = !configurationService.getValue("diffEditor.hideUnchangedRegions.enabled");
        configurationService.updateValue("diffEditor.hideUnchangedRegions.enabled", newValue);
    }
}
class ToggleShowMovedCodeBlocks extends (0, _actionsJs.Action2) {
    constructor(){
        super({
            id: "diffEditor.toggleShowMovedCodeBlocks",
            title: (0, _nlsJs.localize2)("toggleShowMovedCodeBlocks", "Toggle Show Moved Code Blocks"),
            precondition: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor")
        });
    }
    run(accessor, ...args) {
        const configurationService = accessor.get((0, _configurationJs.IConfigurationService));
        const newValue = !configurationService.getValue("diffEditor.experimental.showMoves");
        configurationService.updateValue("diffEditor.experimental.showMoves", newValue);
    }
}
class ToggleUseInlineViewWhenSpaceIsLimited extends (0, _actionsJs.Action2) {
    constructor(){
        super({
            id: "diffEditor.toggleUseInlineViewWhenSpaceIsLimited",
            title: (0, _nlsJs.localize2)("toggleUseInlineViewWhenSpaceIsLimited", "Toggle Use Inline View When Space Is Limited"),
            precondition: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor")
        });
    }
    run(accessor, ...args) {
        const configurationService = accessor.get((0, _configurationJs.IConfigurationService));
        const newValue = !configurationService.getValue("diffEditor.useInlineViewWhenSpaceIsLimited");
        configurationService.updateValue("diffEditor.useInlineViewWhenSpaceIsLimited", newValue);
    }
}
const diffEditorCategory = (0, _nlsJs.localize2)("diffEditor", "Diff Editor");
class SwitchSide extends (0, _editorExtensionsJs.EditorAction2) {
    constructor(){
        super({
            id: "diffEditor.switchSide",
            title: (0, _nlsJs.localize2)("switchSide", "Switch Side"),
            icon: (0, _codiconsJs.Codicon).arrowSwap,
            precondition: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor"),
            f1: true,
            category: diffEditorCategory
        });
    }
    runEditorCommand(accessor, editor, arg) {
        const diffEditor = findFocusedDiffEditor(accessor);
        if (diffEditor instanceof (0, _diffEditorWidgetJs.DiffEditorWidget)) {
            if (arg && arg.dryRun) return {
                destinationSelection: diffEditor.mapToOtherSide().destinationSelection
            };
            else diffEditor.switchSide();
        }
        return undefined;
    }
}
class ExitCompareMove extends (0, _editorExtensionsJs.EditorAction2) {
    constructor(){
        super({
            id: "diffEditor.exitCompareMove",
            title: (0, _nlsJs.localize2)("exitCompareMove", "Exit Compare Move"),
            icon: (0, _codiconsJs.Codicon).close,
            precondition: (0, _editorContextKeysJs.EditorContextKeys).comparingMovedCode,
            f1: false,
            category: diffEditorCategory,
            keybinding: {
                weight: 10000,
                primary: 9 /* KeyCode.Escape */ 
            }
        });
    }
    runEditorCommand(accessor, editor, ...args) {
        const diffEditor = findFocusedDiffEditor(accessor);
        if (diffEditor instanceof (0, _diffEditorWidgetJs.DiffEditorWidget)) diffEditor.exitCompareMove();
    }
}
class CollapseAllUnchangedRegions extends (0, _editorExtensionsJs.EditorAction2) {
    constructor(){
        super({
            id: "diffEditor.collapseAllUnchangedRegions",
            title: (0, _nlsJs.localize2)("collapseAllUnchangedRegions", "Collapse All Unchanged Regions"),
            icon: (0, _codiconsJs.Codicon).fold,
            precondition: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor"),
            f1: true,
            category: diffEditorCategory
        });
    }
    runEditorCommand(accessor, editor, ...args) {
        const diffEditor = findFocusedDiffEditor(accessor);
        if (diffEditor instanceof (0, _diffEditorWidgetJs.DiffEditorWidget)) diffEditor.collapseAllUnchangedRegions();
    }
}
class ShowAllUnchangedRegions extends (0, _editorExtensionsJs.EditorAction2) {
    constructor(){
        super({
            id: "diffEditor.showAllUnchangedRegions",
            title: (0, _nlsJs.localize2)("showAllUnchangedRegions", "Show All Unchanged Regions"),
            icon: (0, _codiconsJs.Codicon).unfold,
            precondition: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor"),
            f1: true,
            category: diffEditorCategory
        });
    }
    runEditorCommand(accessor, editor, ...args) {
        const diffEditor = findFocusedDiffEditor(accessor);
        if (diffEditor instanceof (0, _diffEditorWidgetJs.DiffEditorWidget)) diffEditor.showAllUnchangedRegions();
    }
}
class RevertHunkOrSelection extends (0, _actionsJs.Action2) {
    constructor(){
        super({
            id: "diffEditor.revert",
            title: (0, _nlsJs.localize2)("revert", "Revert"),
            f1: false,
            category: diffEditorCategory
        });
    }
    run(accessor, arg) {
        const diffEditor = findDiffEditor(accessor, arg.originalUri, arg.modifiedUri);
        if (diffEditor instanceof (0, _diffEditorWidgetJs.DiffEditorWidget)) diffEditor.revertRangeMappings(arg.mapping.innerChanges ?? []);
        return undefined;
    }
}
const accessibleDiffViewerCategory = (0, _nlsJs.localize2)("accessibleDiffViewer", "Accessible Diff Viewer");
class AccessibleDiffViewerNext extends (0, _actionsJs.Action2) {
    static{
        this.id = "editor.action.accessibleDiffViewer.next";
    }
    constructor(){
        super({
            id: AccessibleDiffViewerNext.id,
            title: (0, _nlsJs.localize2)("editor.action.accessibleDiffViewer.next", "Go to Next Difference"),
            category: accessibleDiffViewerCategory,
            precondition: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor"),
            keybinding: {
                primary: 65 /* KeyCode.F7 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            f1: true
        });
    }
    run(accessor) {
        const diffEditor = findFocusedDiffEditor(accessor);
        diffEditor?.accessibleDiffViewerNext();
    }
}
class AccessibleDiffViewerPrev extends (0, _actionsJs.Action2) {
    static{
        this.id = "editor.action.accessibleDiffViewer.prev";
    }
    constructor(){
        super({
            id: AccessibleDiffViewerPrev.id,
            title: (0, _nlsJs.localize2)("editor.action.accessibleDiffViewer.prev", "Go to Previous Difference"),
            category: accessibleDiffViewerCategory,
            precondition: (0, _contextkeyJs.ContextKeyExpr).has("isInDiffEditor"),
            keybinding: {
                primary: 1089 /* KeyCode.F7 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            f1: true
        });
    }
    run(accessor) {
        const diffEditor = findFocusedDiffEditor(accessor);
        diffEditor?.accessibleDiffViewerPrev();
    }
}
function findDiffEditor(accessor, originalUri, modifiedUri) {
    const codeEditorService = accessor.get((0, _codeEditorServiceJs.ICodeEditorService));
    const diffEditors = codeEditorService.listDiffEditors();
    return diffEditors.find((diffEditor)=>{
        const modified = diffEditor.getModifiedEditor();
        const original = diffEditor.getOriginalEditor();
        return modified && modified.getModel()?.uri.toString() === modifiedUri.toString() && original && original.getModel()?.uri.toString() === originalUri.toString();
    }) || null;
}
function findFocusedDiffEditor(accessor) {
    const codeEditorService = accessor.get((0, _codeEditorServiceJs.ICodeEditorService));
    const diffEditors = codeEditorService.listDiffEditors();
    const activeElement = (0, _domJs.getActiveElement)();
    if (activeElement) for (const d of diffEditors){
        const container = d.getContainerDomNode();
        if (isElementOrParentOf(container, activeElement)) return d;
    }
    return null;
}
function isElementOrParentOf(elementOrParent, element) {
    let e = element;
    while(e){
        if (e === elementOrParent) return true;
        e = e.parentElement;
    }
    return false;
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/codicons.js":"hWYNf","../../editorExtensions.js":"kC3w6","../../services/codeEditorService.js":"bOWtl","./diffEditorWidget.js":"35Ond","../../../common/editorContextKeys.js":"5exv9","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/contextkey/common/contextkey.js":"gXuBD","./registrations.contribution.js":"3EY0P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9OnRk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectionAnchorSet", ()=>SelectionAnchorSet);
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var _htmlContentJs = require("../../../../base/common/htmlContent.js");
var _keyCodesJs = require("../../../../base/common/keyCodes.js");
var _anchorSelectCss = require("./anchorSelect.css");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _selectionJs = require("../../../common/core/selection.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var SelectionAnchorController_1;
const SelectionAnchorSet = new (0, _contextkeyJs.RawContextKey)("selectionAnchorSet", false);
let SelectionAnchorController = class SelectionAnchorController {
    static{
        SelectionAnchorController_1 = this;
    }
    static{
        this.ID = "editor.contrib.selectionAnchorController";
    }
    static get(editor) {
        return editor.getContribution(SelectionAnchorController_1.ID);
    }
    constructor(editor, contextKeyService){
        this.editor = editor;
        this.selectionAnchorSetContextKey = SelectionAnchorSet.bindTo(contextKeyService);
        this.modelChangeListener = editor.onDidChangeModel(()=>this.selectionAnchorSetContextKey.reset());
    }
    setSelectionAnchor() {
        if (this.editor.hasModel()) {
            const position = this.editor.getPosition();
            this.editor.changeDecorations((accessor)=>{
                if (this.decorationId) accessor.removeDecoration(this.decorationId);
                this.decorationId = accessor.addDecoration((0, _selectionJs.Selection).fromPositions(position, position), {
                    description: "selection-anchor",
                    stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
                    hoverMessage: new (0, _htmlContentJs.MarkdownString)().appendText((0, _nlsJs.localize)("selectionAnchor", "Selection Anchor")),
                    className: "selection-anchor"
                });
            });
            this.selectionAnchorSetContextKey.set(!!this.decorationId);
            (0, _ariaJs.alert)((0, _nlsJs.localize)("anchorSet", "Anchor set at {0}:{1}", position.lineNumber, position.column));
        }
    }
    goToSelectionAnchor() {
        if (this.editor.hasModel() && this.decorationId) {
            const anchorPosition = this.editor.getModel().getDecorationRange(this.decorationId);
            if (anchorPosition) this.editor.setPosition(anchorPosition.getStartPosition());
        }
    }
    selectFromAnchorToCursor() {
        if (this.editor.hasModel() && this.decorationId) {
            const start = this.editor.getModel().getDecorationRange(this.decorationId);
            if (start) {
                const end = this.editor.getPosition();
                this.editor.setSelection((0, _selectionJs.Selection).fromPositions(start.getStartPosition(), end));
                this.cancelSelectionAnchor();
            }
        }
    }
    cancelSelectionAnchor() {
        if (this.decorationId) {
            const decorationId = this.decorationId;
            this.editor.changeDecorations((accessor)=>{
                accessor.removeDecoration(decorationId);
                this.decorationId = undefined;
            });
            this.selectionAnchorSetContextKey.set(false);
        }
    }
    dispose() {
        this.cancelSelectionAnchor();
        this.modelChangeListener.dispose();
    }
};
SelectionAnchorController = SelectionAnchorController_1 = __decorate([
    __param(1, (0, _contextkeyJs.IContextKeyService))
], SelectionAnchorController);
class SetSelectionAnchor extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.setSelectionAnchor",
            label: (0, _nlsJs.localize)("setSelectionAnchor", "Set Selection Anchor"),
            alias: "Set Selection Anchor",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2080 /* KeyCode.KeyB */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    async run(_accessor, editor) {
        SelectionAnchorController.get(editor)?.setSelectionAnchor();
    }
}
class GoToSelectionAnchor extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.goToSelectionAnchor",
            label: (0, _nlsJs.localize)("goToSelectionAnchor", "Go to Selection Anchor"),
            alias: "Go to Selection Anchor",
            precondition: SelectionAnchorSet
        });
    }
    async run(_accessor, editor) {
        SelectionAnchorController.get(editor)?.goToSelectionAnchor();
    }
}
class SelectFromAnchorToCursor extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.selectFromAnchorToCursor",
            label: (0, _nlsJs.localize)("selectFromAnchorToCursor", "Select from Anchor to Cursor"),
            alias: "Select from Anchor to Cursor",
            precondition: SelectionAnchorSet,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2089 /* KeyCode.KeyK */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    async run(_accessor, editor) {
        SelectionAnchorController.get(editor)?.selectFromAnchorToCursor();
    }
}
class CancelSelectionAnchor extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.cancelSelectionAnchor",
            label: (0, _nlsJs.localize)("cancelSelectionAnchor", "Cancel Selection Anchor"),
            alias: "Cancel Selection Anchor",
            precondition: SelectionAnchorSet,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 9 /* KeyCode.Escape */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    async run(_accessor, editor) {
        SelectionAnchorController.get(editor)?.cancelSelectionAnchor();
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(SelectionAnchorController.ID, SelectionAnchorController, 4 /* EditorContributionInstantiation.Lazy */ );
(0, _editorExtensionsJs.registerEditorAction)(SetSelectionAnchor);
(0, _editorExtensionsJs.registerEditorAction)(GoToSelectionAnchor);
(0, _editorExtensionsJs.registerEditorAction)(SelectFromAnchorToCursor);
(0, _editorExtensionsJs.registerEditorAction)(CancelSelectionAnchor);

},{"../../../../base/browser/ui/aria/aria.js":"asrsh","../../../../base/common/htmlContent.js":"3Hxzm","../../../../base/common/keyCodes.js":"bHiG9","./anchorSelect.css":"4jKFH","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/selection.js":"kcwzU","../../../common/editorContextKeys.js":"5exv9","../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4jKFH":[function() {},{}],"26nnn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BracketMatchingController", ()=>BracketMatchingController);
var _asyncJs = require("../../../../base/common/async.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _bracketMatchingCss = require("./bracketMatching.css");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _modelJs = require("../../../common/model.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
const overviewRulerBracketMatchForeground = (0, _colorRegistryJs.registerColor)("editorOverviewRuler.bracketMatchForeground", "#A0A0A0", _nlsJs.localize("overviewRulerBracketMatchForeground", "Overview ruler marker color for matching brackets."));
class JumpToBracketAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.jumpToBracket",
            label: _nlsJs.localize("smartSelect.jumpBracket", "Go to Bracket"),
            alias: "Go to Bracket",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 3165 /* KeyCode.Backslash */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(accessor, editor) {
        BracketMatchingController.get(editor)?.jumpToBracket();
    }
}
class SelectToBracketAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.selectToBracket",
            label: _nlsJs.localize("smartSelect.selectToBracket", "Select to Bracket"),
            alias: "Select to Bracket",
            precondition: undefined,
            metadata: {
                description: _nlsJs.localize2("smartSelect.selectToBracketDescription", "Select the text inside and including the brackets or curly braces"),
                args: [
                    {
                        name: "args",
                        schema: {
                            type: "object",
                            properties: {
                                "selectBrackets": {
                                    type: "boolean",
                                    default: true
                                }
                            }
                        }
                    }
                ]
            }
        });
    }
    run(accessor, editor, args) {
        let selectBrackets = true;
        if (args && args.selectBrackets === false) selectBrackets = false;
        BracketMatchingController.get(editor)?.selectToBracket(selectBrackets);
    }
}
class RemoveBracketsAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.removeBrackets",
            label: _nlsJs.localize("smartSelect.removeBrackets", "Remove Brackets"),
            alias: "Remove Brackets",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 2561 /* KeyCode.Backspace */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(accessor, editor) {
        BracketMatchingController.get(editor)?.removeBrackets(this.id);
    }
}
class BracketsData {
    constructor(position, brackets, options){
        this.position = position;
        this.brackets = brackets;
        this.options = options;
    }
}
class BracketMatchingController extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.bracketMatchingController";
    }
    static get(editor) {
        return editor.getContribution(BracketMatchingController.ID);
    }
    constructor(editor){
        super();
        this._editor = editor;
        this._lastBracketsData = [];
        this._lastVersionId = 0;
        this._decorations = this._editor.createDecorationsCollection();
        this._updateBracketsSoon = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._updateBrackets(), 50));
        this._matchBrackets = this._editor.getOption(72 /* EditorOption.matchBrackets */ );
        this._updateBracketsSoon.schedule();
        this._register(editor.onDidChangeCursorPosition((e)=>{
            if (this._matchBrackets === "never") // Early exit if nothing needs to be done!
            // Leave some form of early exit check here if you wish to continue being a cursor position change listener ;)
            return;
            this._updateBracketsSoon.schedule();
        }));
        this._register(editor.onDidChangeModelContent((e)=>{
            this._updateBracketsSoon.schedule();
        }));
        this._register(editor.onDidChangeModel((e)=>{
            this._lastBracketsData = [];
            this._updateBracketsSoon.schedule();
        }));
        this._register(editor.onDidChangeModelLanguageConfiguration((e)=>{
            this._lastBracketsData = [];
            this._updateBracketsSoon.schedule();
        }));
        this._register(editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(72 /* EditorOption.matchBrackets */ )) {
                this._matchBrackets = this._editor.getOption(72 /* EditorOption.matchBrackets */ );
                this._decorations.clear();
                this._lastBracketsData = [];
                this._lastVersionId = 0;
                this._updateBracketsSoon.schedule();
            }
        }));
        this._register(editor.onDidBlurEditorWidget(()=>{
            this._updateBracketsSoon.schedule();
        }));
        this._register(editor.onDidFocusEditorWidget(()=>{
            this._updateBracketsSoon.schedule();
        }));
    }
    jumpToBracket() {
        if (!this._editor.hasModel()) return;
        const model = this._editor.getModel();
        const newSelections = this._editor.getSelections().map((selection)=>{
            const position = selection.getStartPosition();
            // find matching brackets if position is on a bracket
            const brackets = model.bracketPairs.matchBracket(position);
            let newCursorPosition = null;
            if (brackets) {
                if (brackets[0].containsPosition(position) && !brackets[1].containsPosition(position)) newCursorPosition = brackets[1].getStartPosition();
                else if (brackets[1].containsPosition(position)) newCursorPosition = brackets[0].getStartPosition();
            } else {
                // find the enclosing brackets if the position isn't on a matching bracket
                const enclosingBrackets = model.bracketPairs.findEnclosingBrackets(position);
                if (enclosingBrackets) newCursorPosition = enclosingBrackets[1].getStartPosition();
                else {
                    // no enclosing brackets, try the very first next bracket
                    const nextBracket = model.bracketPairs.findNextBracket(position);
                    if (nextBracket && nextBracket.range) newCursorPosition = nextBracket.range.getStartPosition();
                }
            }
            if (newCursorPosition) return new (0, _selectionJs.Selection)(newCursorPosition.lineNumber, newCursorPosition.column, newCursorPosition.lineNumber, newCursorPosition.column);
            return new (0, _selectionJs.Selection)(position.lineNumber, position.column, position.lineNumber, position.column);
        });
        this._editor.setSelections(newSelections);
        this._editor.revealRange(newSelections[0]);
    }
    selectToBracket(selectBrackets) {
        if (!this._editor.hasModel()) return;
        const model = this._editor.getModel();
        const newSelections = [];
        this._editor.getSelections().forEach((selection)=>{
            const position = selection.getStartPosition();
            let brackets = model.bracketPairs.matchBracket(position);
            if (!brackets) {
                brackets = model.bracketPairs.findEnclosingBrackets(position);
                if (!brackets) {
                    const nextBracket = model.bracketPairs.findNextBracket(position);
                    if (nextBracket && nextBracket.range) brackets = model.bracketPairs.matchBracket(nextBracket.range.getStartPosition());
                }
            }
            let selectFrom = null;
            let selectTo = null;
            if (brackets) {
                brackets.sort((0, _rangeJs.Range).compareRangesUsingStarts);
                const [open, close] = brackets;
                selectFrom = selectBrackets ? open.getStartPosition() : open.getEndPosition();
                selectTo = selectBrackets ? close.getEndPosition() : close.getStartPosition();
                if (close.containsPosition(position)) {
                    // select backwards if the cursor was on the closing bracket
                    const tmp = selectFrom;
                    selectFrom = selectTo;
                    selectTo = tmp;
                }
            }
            if (selectFrom && selectTo) newSelections.push(new (0, _selectionJs.Selection)(selectFrom.lineNumber, selectFrom.column, selectTo.lineNumber, selectTo.column));
        });
        if (newSelections.length > 0) {
            this._editor.setSelections(newSelections);
            this._editor.revealRange(newSelections[0]);
        }
    }
    removeBrackets(editSource) {
        if (!this._editor.hasModel()) return;
        const model = this._editor.getModel();
        this._editor.getSelections().forEach((selection)=>{
            const position = selection.getPosition();
            let brackets = model.bracketPairs.matchBracket(position);
            if (!brackets) brackets = model.bracketPairs.findEnclosingBrackets(position);
            if (brackets) {
                this._editor.pushUndoStop();
                this._editor.executeEdits(editSource, [
                    {
                        range: brackets[0],
                        text: ""
                    },
                    {
                        range: brackets[1],
                        text: ""
                    }
                ]);
                this._editor.pushUndoStop();
            }
        });
    }
    static{
        this._DECORATION_OPTIONS_WITH_OVERVIEW_RULER = (0, _textModelJs.ModelDecorationOptions).register({
            description: "bracket-match-overview",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
            className: "bracket-match",
            overviewRuler: {
                color: (0, _themeServiceJs.themeColorFromId)(overviewRulerBracketMatchForeground),
                position: (0, _modelJs.OverviewRulerLane).Center
            }
        });
    }
    static{
        this._DECORATION_OPTIONS_WITHOUT_OVERVIEW_RULER = (0, _textModelJs.ModelDecorationOptions).register({
            description: "bracket-match-no-overview",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
            className: "bracket-match"
        });
    }
    _updateBrackets() {
        if (this._matchBrackets === "never") return;
        this._recomputeBrackets();
        const newDecorations = [];
        let newDecorationsLen = 0;
        for (const bracketData of this._lastBracketsData){
            const brackets = bracketData.brackets;
            if (brackets) {
                newDecorations[newDecorationsLen++] = {
                    range: brackets[0],
                    options: bracketData.options
                };
                newDecorations[newDecorationsLen++] = {
                    range: brackets[1],
                    options: bracketData.options
                };
            }
        }
        this._decorations.set(newDecorations);
    }
    _recomputeBrackets() {
        if (!this._editor.hasModel() || !this._editor.hasWidgetFocus()) {
            // no model or no focus => no brackets!
            this._lastBracketsData = [];
            this._lastVersionId = 0;
            return;
        }
        const selections = this._editor.getSelections();
        if (selections.length > 100) {
            // no bracket matching for high numbers of selections
            this._lastBracketsData = [];
            this._lastVersionId = 0;
            return;
        }
        const model = this._editor.getModel();
        const versionId = model.getVersionId();
        let previousData = [];
        if (this._lastVersionId === versionId) // use the previous data only if the model is at the same version id
        previousData = this._lastBracketsData;
        const positions = [];
        let positionsLen = 0;
        for(let i = 0, len = selections.length; i < len; i++){
            const selection = selections[i];
            if (selection.isEmpty()) // will bracket match a cursor only if the selection is collapsed
            positions[positionsLen++] = selection.getStartPosition();
        }
        // sort positions for `previousData` cache hits
        if (positions.length > 1) positions.sort((0, _positionJs.Position).compare);
        const newData = [];
        let newDataLen = 0;
        let previousIndex = 0;
        const previousLen = previousData.length;
        for(let i = 0, len = positions.length; i < len; i++){
            const position = positions[i];
            while(previousIndex < previousLen && previousData[previousIndex].position.isBefore(position))previousIndex++;
            if (previousIndex < previousLen && previousData[previousIndex].position.equals(position)) newData[newDataLen++] = previousData[previousIndex];
            else {
                let brackets = model.bracketPairs.matchBracket(position, 20 /* give at most 20ms to compute */ );
                let options = BracketMatchingController._DECORATION_OPTIONS_WITH_OVERVIEW_RULER;
                if (!brackets && this._matchBrackets === "always") {
                    brackets = model.bracketPairs.findEnclosingBrackets(position, 20 /* give at most 20ms to compute */ );
                    options = BracketMatchingController._DECORATION_OPTIONS_WITHOUT_OVERVIEW_RULER;
                }
                newData[newDataLen++] = new BracketsData(position, brackets, options);
            }
        }
        this._lastBracketsData = newData;
        this._lastVersionId = versionId;
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(BracketMatchingController.ID, BracketMatchingController, 1 /* EditorContributionInstantiation.AfterFirstRender */ );
(0, _editorExtensionsJs.registerEditorAction)(SelectToBracketAction);
(0, _editorExtensionsJs.registerEditorAction)(JumpToBracketAction);
(0, _editorExtensionsJs.registerEditorAction)(RemoveBracketsAction);
// Go to menu
(0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).MenubarGoMenu, {
    group: "5_infile_nav",
    command: {
        id: "editor.action.jumpToBracket",
        title: _nlsJs.localize({
            key: "miGoToBracket",
            comment: [
                "&& denotes a mnemonic"
            ]
        }, "Go to &&Bracket")
    },
    order: 2
});

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/lifecycle.js":"9kg8d","./bracketMatching.css":"bY3Fo","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/editorContextKeys.js":"5exv9","../../../common/model.js":"1CSIB","../../../common/model/textModel.js":"9beDe","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bY3Fo":[function() {},{}],"6BJje":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _moveCaretCommandJs = require("./moveCaretCommand.js");
var _nlsJs = require("../../../../nls.js");
class MoveCaretAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(left, opts){
        super(opts);
        this.left = left;
    }
    run(accessor, editor) {
        if (!editor.hasModel()) return;
        const commands = [];
        const selections = editor.getSelections();
        for (const selection of selections)commands.push(new (0, _moveCaretCommandJs.MoveCaretCommand)(selection, this.left));
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    }
}
class MoveCaretLeftAction extends MoveCaretAction {
    constructor(){
        super(true, {
            id: "editor.action.moveCarretLeftAction",
            label: _nlsJs.localize("caret.moveLeft", "Move Selected Text Left"),
            alias: "Move Selected Text Left",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
}
class MoveCaretRightAction extends MoveCaretAction {
    constructor(){
        super(false, {
            id: "editor.action.moveCarretRightAction",
            label: _nlsJs.localize("caret.moveRight", "Move Selected Text Right"),
            alias: "Move Selected Text Right",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
}
(0, _editorExtensionsJs.registerEditorAction)(MoveCaretLeftAction);
(0, _editorExtensionsJs.registerEditorAction)(MoveCaretRightAction);

},{"../../../browser/editorExtensions.js":"kC3w6","../../../common/editorContextKeys.js":"5exv9","./moveCaretCommand.js":"jaAiX","../../../../nls.js":"l617d"}],"jaAiX":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MoveCaretCommand", ()=>MoveCaretCommand);
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
class MoveCaretCommand {
    constructor(selection, isMovingLeft){
        this._selection = selection;
        this._isMovingLeft = isMovingLeft;
    }
    getEditOperations(model, builder) {
        if (this._selection.startLineNumber !== this._selection.endLineNumber || this._selection.isEmpty()) return;
        const lineNumber = this._selection.startLineNumber;
        const startColumn = this._selection.startColumn;
        const endColumn = this._selection.endColumn;
        if (this._isMovingLeft && startColumn === 1) return;
        if (!this._isMovingLeft && endColumn === model.getLineMaxColumn(lineNumber)) return;
        if (this._isMovingLeft) {
            const rangeBefore = new (0, _rangeJs.Range)(lineNumber, startColumn - 1, lineNumber, startColumn);
            const charBefore = model.getValueInRange(rangeBefore);
            builder.addEditOperation(rangeBefore, null);
            builder.addEditOperation(new (0, _rangeJs.Range)(lineNumber, endColumn, lineNumber, endColumn), charBefore);
        } else {
            const rangeAfter = new (0, _rangeJs.Range)(lineNumber, endColumn, lineNumber, endColumn + 1);
            const charAfter = model.getValueInRange(rangeAfter);
            builder.addEditOperation(rangeAfter, null);
            builder.addEditOperation(new (0, _rangeJs.Range)(lineNumber, startColumn, lineNumber, startColumn), charAfter);
        }
    }
    computeCursorState(model, helper) {
        if (this._isMovingLeft) return new (0, _selectionJs.Selection)(this._selection.startLineNumber, this._selection.startColumn - 1, this._selection.endLineNumber, this._selection.endColumn - 1);
        else return new (0, _selectionJs.Selection)(this._selection.startLineNumber, this._selection.startColumn + 1, this._selection.endLineNumber, this._selection.endColumn + 1);
    }
}

},{"../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"adkK9":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _replaceCommandJs = require("../../../common/commands/replaceCommand.js");
var _cursorMoveOperationsJs = require("../../../common/cursor/cursorMoveOperations.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _nlsJs = require("../../../../nls.js");
class TransposeLettersAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.transposeLetters",
            label: _nlsJs.localize("transposeLetters.label", "Transpose Letters"),
            alias: "Transpose Letters",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 0,
                mac: {
                    primary: 306 /* KeyCode.KeyT */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(accessor, editor) {
        if (!editor.hasModel()) return;
        const model = editor.getModel();
        const commands = [];
        const selections = editor.getSelections();
        for (const selection of selections){
            if (!selection.isEmpty()) continue;
            const lineNumber = selection.startLineNumber;
            const column = selection.startColumn;
            const lastColumn = model.getLineMaxColumn(lineNumber);
            if (lineNumber === 1 && (column === 1 || column === 2 && lastColumn === 2)) continue;
            // handle special case: when at end of line, transpose left two chars
            // otherwise, transpose left and right chars
            const endPosition = column === lastColumn ? selection.getPosition() : (0, _cursorMoveOperationsJs.MoveOperations).rightPosition(model, selection.getPosition().lineNumber, selection.getPosition().column);
            const middlePosition = (0, _cursorMoveOperationsJs.MoveOperations).leftPosition(model, endPosition);
            const beginPosition = (0, _cursorMoveOperationsJs.MoveOperations).leftPosition(model, middlePosition);
            const leftChar = model.getValueInRange((0, _rangeJs.Range).fromPositions(beginPosition, middlePosition));
            const rightChar = model.getValueInRange((0, _rangeJs.Range).fromPositions(middlePosition, endPosition));
            const replaceRange = (0, _rangeJs.Range).fromPositions(beginPosition, endPosition);
            commands.push(new (0, _replaceCommandJs.ReplaceCommand)(replaceRange, rightChar + leftChar));
        }
        if (commands.length > 0) {
            editor.pushUndoStop();
            editor.executeCommands(this.id, commands);
            editor.pushUndoStop();
        }
    }
}
(0, _editorExtensionsJs.registerEditorAction)(TransposeLettersAction);

},{"../../../browser/editorExtensions.js":"kC3w6","../../../common/commands/replaceCommand.js":"51hNH","../../../common/cursor/cursorMoveOperations.js":"74ZGL","../../../common/core/range.js":"jmUPh","../../../common/editorContextKeys.js":"5exv9","../../../../nls.js":"l617d"}],"iASLl":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CutAction", ()=>CutAction);
parcelHelpers.export(exports, "CopyAction", ()=>CopyAction);
parcelHelpers.export(exports, "PasteAction", ()=>PasteAction);
var _browserJs = require("../../../../base/browser/browser.js");
var _domJs = require("../../../../base/browser/dom.js");
var _platformJs = require("../../../../base/common/platform.js");
var _textAreaInputJs = require("../../../browser/controller/textAreaInput.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _copyPasteControllerJs = require("../../dropOrPasteInto/browser/copyPasteController.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _clipboardServiceJs = require("../../../../platform/clipboard/common/clipboardService.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
const CLIPBOARD_CONTEXT_MENU_GROUP = "9_cutcopypaste";
const supportsCut = _platformJs.isNative || document.queryCommandSupported("cut");
const supportsCopy = _platformJs.isNative || document.queryCommandSupported("copy");
// Firefox only supports navigator.clipboard.readText() in browser extensions.
// See https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/readText#Browser_compatibility
// When loading over http, navigator.clipboard can be undefined. See https://github.com/microsoft/monaco-editor/issues/2313
const supportsPaste = typeof navigator.clipboard === "undefined" || _browserJs.isFirefox ? document.queryCommandSupported("paste") : true;
function registerCommand(command) {
    command.register();
    return command;
}
const CutAction = supportsCut ? registerCommand(new (0, _editorExtensionsJs.MultiCommand)({
    id: "editor.action.clipboardCutAction",
    precondition: undefined,
    kbOpts: // Do not bind cut keybindings in the browser,
    // since browsers do that for us and it avoids security prompts
    _platformJs.isNative ? {
        primary: 2102 /* KeyCode.KeyX */ ,
        win: {
            primary: 2102 /* KeyCode.KeyX */ ,
            secondary: [
                1044 /* KeyCode.Delete */ 
            ]
        },
        weight: 100 /* KeybindingWeight.EditorContrib */ 
    } : undefined,
    menuOpts: [
        {
            menuId: (0, _actionsJs.MenuId).MenubarEditMenu,
            group: "2_ccp",
            title: _nlsJs.localize({
                key: "miCut",
                comment: [
                    "&& denotes a mnemonic"
                ]
            }, "Cu&&t"),
            order: 1
        },
        {
            menuId: (0, _actionsJs.MenuId).EditorContext,
            group: CLIPBOARD_CONTEXT_MENU_GROUP,
            title: _nlsJs.localize("actions.clipboard.cutLabel", "Cut"),
            when: (0, _editorContextKeysJs.EditorContextKeys).writable,
            order: 1
        },
        {
            menuId: (0, _actionsJs.MenuId).CommandPalette,
            group: "",
            title: _nlsJs.localize("actions.clipboard.cutLabel", "Cut"),
            order: 1
        },
        {
            menuId: (0, _actionsJs.MenuId).SimpleEditorContext,
            group: CLIPBOARD_CONTEXT_MENU_GROUP,
            title: _nlsJs.localize("actions.clipboard.cutLabel", "Cut"),
            when: (0, _editorContextKeysJs.EditorContextKeys).writable,
            order: 1
        }
    ]
})) : undefined;
const CopyAction = supportsCopy ? registerCommand(new (0, _editorExtensionsJs.MultiCommand)({
    id: "editor.action.clipboardCopyAction",
    precondition: undefined,
    kbOpts: // Do not bind copy keybindings in the browser,
    // since browsers do that for us and it avoids security prompts
    _platformJs.isNative ? {
        primary: 2081 /* KeyCode.KeyC */ ,
        win: {
            primary: 2081 /* KeyCode.KeyC */ ,
            secondary: [
                2067 /* KeyCode.Insert */ 
            ]
        },
        weight: 100 /* KeybindingWeight.EditorContrib */ 
    } : undefined,
    menuOpts: [
        {
            menuId: (0, _actionsJs.MenuId).MenubarEditMenu,
            group: "2_ccp",
            title: _nlsJs.localize({
                key: "miCopy",
                comment: [
                    "&& denotes a mnemonic"
                ]
            }, "&&Copy"),
            order: 2
        },
        {
            menuId: (0, _actionsJs.MenuId).EditorContext,
            group: CLIPBOARD_CONTEXT_MENU_GROUP,
            title: _nlsJs.localize("actions.clipboard.copyLabel", "Copy"),
            order: 2
        },
        {
            menuId: (0, _actionsJs.MenuId).CommandPalette,
            group: "",
            title: _nlsJs.localize("actions.clipboard.copyLabel", "Copy"),
            order: 1
        },
        {
            menuId: (0, _actionsJs.MenuId).SimpleEditorContext,
            group: CLIPBOARD_CONTEXT_MENU_GROUP,
            title: _nlsJs.localize("actions.clipboard.copyLabel", "Copy"),
            order: 2
        }
    ]
})) : undefined;
(0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).MenubarEditMenu, {
    submenu: (0, _actionsJs.MenuId).MenubarCopy,
    title: _nlsJs.localize2("copy as", "Copy As"),
    group: "2_ccp",
    order: 3
});
(0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).EditorContext, {
    submenu: (0, _actionsJs.MenuId).EditorContextCopy,
    title: _nlsJs.localize2("copy as", "Copy As"),
    group: CLIPBOARD_CONTEXT_MENU_GROUP,
    order: 3
});
(0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).EditorContext, {
    submenu: (0, _actionsJs.MenuId).EditorContextShare,
    title: _nlsJs.localize2("share", "Share"),
    group: "11_share",
    order: -1,
    when: (0, _contextkeyJs.ContextKeyExpr).and((0, _contextkeyJs.ContextKeyExpr).notEquals("resourceScheme", "output"), (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus)
});
(0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).ExplorerContext, {
    submenu: (0, _actionsJs.MenuId).ExplorerContextShare,
    title: _nlsJs.localize2("share", "Share"),
    group: "11_share",
    order: -1
});
const PasteAction = supportsPaste ? registerCommand(new (0, _editorExtensionsJs.MultiCommand)({
    id: "editor.action.clipboardPasteAction",
    precondition: undefined,
    kbOpts: // Do not bind paste keybindings in the browser,
    // since browsers do that for us and it avoids security prompts
    _platformJs.isNative ? {
        primary: 2100 /* KeyCode.KeyV */ ,
        win: {
            primary: 2100 /* KeyCode.KeyV */ ,
            secondary: [
                1043 /* KeyCode.Insert */ 
            ]
        },
        linux: {
            primary: 2100 /* KeyCode.KeyV */ ,
            secondary: [
                1043 /* KeyCode.Insert */ 
            ]
        },
        weight: 100 /* KeybindingWeight.EditorContrib */ 
    } : undefined,
    menuOpts: [
        {
            menuId: (0, _actionsJs.MenuId).MenubarEditMenu,
            group: "2_ccp",
            title: _nlsJs.localize({
                key: "miPaste",
                comment: [
                    "&& denotes a mnemonic"
                ]
            }, "&&Paste"),
            order: 4
        },
        {
            menuId: (0, _actionsJs.MenuId).EditorContext,
            group: CLIPBOARD_CONTEXT_MENU_GROUP,
            title: _nlsJs.localize("actions.clipboard.pasteLabel", "Paste"),
            when: (0, _editorContextKeysJs.EditorContextKeys).writable,
            order: 4
        },
        {
            menuId: (0, _actionsJs.MenuId).CommandPalette,
            group: "",
            title: _nlsJs.localize("actions.clipboard.pasteLabel", "Paste"),
            order: 1
        },
        {
            menuId: (0, _actionsJs.MenuId).SimpleEditorContext,
            group: CLIPBOARD_CONTEXT_MENU_GROUP,
            title: _nlsJs.localize("actions.clipboard.pasteLabel", "Paste"),
            when: (0, _editorContextKeysJs.EditorContextKeys).writable,
            order: 4
        }
    ]
})) : undefined;
class ExecCommandCopyWithSyntaxHighlightingAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.clipboardCopyWithSyntaxHighlightingAction",
            label: _nlsJs.localize("actions.clipboard.copyWithSyntaxHighlightingLabel", "Copy With Syntax Highlighting"),
            alias: "Copy With Syntax Highlighting",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 0,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(accessor, editor) {
        if (!editor.hasModel()) return;
        const emptySelectionClipboard = editor.getOption(37 /* EditorOption.emptySelectionClipboard */ );
        if (!emptySelectionClipboard && editor.getSelection().isEmpty()) return;
        (0, _textAreaInputJs.CopyOptions).forceCopyWithSyntaxHighlighting = true;
        editor.focus();
        editor.getContainerDomNode().ownerDocument.execCommand("copy");
        (0, _textAreaInputJs.CopyOptions).forceCopyWithSyntaxHighlighting = false;
    }
}
function registerExecCommandImpl(target, browserCommand) {
    if (!target) return;
    // 1. handle case when focus is in editor.
    target.addImplementation(10000, "code-editor", (accessor, args)=>{
        // Only if editor text focus (i.e. not if editor has widget focus).
        const focusedEditor = accessor.get((0, _codeEditorServiceJs.ICodeEditorService)).getFocusedCodeEditor();
        if (focusedEditor && focusedEditor.hasTextFocus()) {
            // Do not execute if there is no selection and empty selection clipboard is off
            const emptySelectionClipboard = focusedEditor.getOption(37 /* EditorOption.emptySelectionClipboard */ );
            const selection = focusedEditor.getSelection();
            if (selection && selection.isEmpty() && !emptySelectionClipboard) return true;
            focusedEditor.getContainerDomNode().ownerDocument.execCommand(browserCommand);
            return true;
        }
        return false;
    });
    // 2. (default) handle case when focus is somewhere else.
    target.addImplementation(0, "generic-dom", (accessor, args)=>{
        (0, _domJs.getActiveDocument)().execCommand(browserCommand);
        return true;
    });
}
registerExecCommandImpl(CutAction, "cut");
registerExecCommandImpl(CopyAction, "copy");
if (PasteAction) {
    // 1. Paste: handle case when focus is in editor.
    PasteAction.addImplementation(10000, "code-editor", (accessor, args)=>{
        const codeEditorService = accessor.get((0, _codeEditorServiceJs.ICodeEditorService));
        const clipboardService = accessor.get((0, _clipboardServiceJs.IClipboardService));
        // Only if editor text focus (i.e. not if editor has widget focus).
        const focusedEditor = codeEditorService.getFocusedCodeEditor();
        if (focusedEditor && focusedEditor.hasTextFocus()) {
            const result = focusedEditor.getContainerDomNode().ownerDocument.execCommand("paste");
            if (result) return (0, _copyPasteControllerJs.CopyPasteController).get(focusedEditor)?.finishedPaste() ?? Promise.resolve();
            else if (_platformJs.isWeb) // Use the clipboard service if document.execCommand('paste') was not successful
            return (async ()=>{
                const clipboardText = await clipboardService.readText();
                if (clipboardText !== "") {
                    const metadata = (0, _textAreaInputJs.InMemoryClipboardMetadataManager).INSTANCE.get(clipboardText);
                    let pasteOnNewLine = false;
                    let multicursorText = null;
                    let mode = null;
                    if (metadata) {
                        pasteOnNewLine = focusedEditor.getOption(37 /* EditorOption.emptySelectionClipboard */ ) && !!metadata.isFromEmptySelection;
                        multicursorText = typeof metadata.multicursorText !== "undefined" ? metadata.multicursorText : null;
                        mode = metadata.mode;
                    }
                    focusedEditor.trigger("keyboard", "paste" /* Handler.Paste */ , {
                        text: clipboardText,
                        pasteOnNewLine,
                        multicursorText,
                        mode
                    });
                }
            })();
            return true;
        }
        return false;
    });
    // 2. Paste: (default) handle case when focus is somewhere else.
    PasteAction.addImplementation(0, "generic-dom", (accessor, args)=>{
        (0, _domJs.getActiveDocument)().execCommand("paste");
        return true;
    });
}
if (supportsCopy) (0, _editorExtensionsJs.registerEditorAction)(ExecCommandCopyWithSyntaxHighlightingAction);

},{"../../../../base/browser/browser.js":"4Zquf","../../../../base/browser/dom.js":"bnqsM","../../../../base/common/platform.js":"7maJO","../../../browser/controller/textAreaInput.js":"d7Bw3","../../../browser/editorExtensions.js":"kC3w6","../../../browser/services/codeEditorService.js":"bOWtl","../../../common/editorContextKeys.js":"5exv9","../../dropOrPasteInto/browser/copyPasteController.js":"7cyou","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/clipboard/common/clipboardService.js":"4IsFp","../../../../platform/contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7cyou":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "changePasteTypeCommandId", ()=>changePasteTypeCommandId);
parcelHelpers.export(exports, "pasteWidgetVisibleCtx", ()=>pasteWidgetVisibleCtx);
parcelHelpers.export(exports, "CopyPasteController", ()=>CopyPasteController);
var _domJs = require("../../../../base/browser/dom.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _dataTransferJs = require("../../../../base/common/dataTransfer.js");
var _hierarchicalKindJs = require("../../../../base/common/hierarchicalKind.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _mimeJs = require("../../../../base/common/mime.js");
var _platformJs = require("../../../../base/common/platform.js");
var _uuidJs = require("../../../../base/common/uuid.js");
var _textAreaInputJs = require("../../../browser/controller/textAreaInput.js");
var _dndJs = require("../../../browser/dnd.js");
var _bulkEditServiceJs = require("../../../browser/services/bulkEditService.js");
var _rangeJs = require("../../../common/core/range.js");
var _languagesJs = require("../../../common/languages.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _defaultProvidersJs = require("./defaultProviders.js");
var _editJs = require("./edit.js");
var _editorStateJs = require("../../editorState/browser/editorState.js");
var _inlineProgressJs = require("../../inlineProgress/browser/inlineProgress.js");
var _messageControllerJs = require("../../message/browser/messageController.js");
var _nlsJs = require("../../../../nls.js");
var _clipboardServiceJs = require("../../../../platform/clipboard/common/clipboardService.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _progressJs = require("../../../../platform/progress/common/progress.js");
var _quickInputJs = require("../../../../platform/quickinput/common/quickInput.js");
var _postEditWidgetJs = require("./postEditWidget.js");
var _errorsJs = require("../../../../base/common/errors.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var CopyPasteController_1;
const changePasteTypeCommandId = "editor.changePasteType";
const pasteWidgetVisibleCtx = new (0, _contextkeyJs.RawContextKey)("pasteWidgetVisible", false, (0, _nlsJs.localize)("pasteWidgetVisible", "Whether the paste widget is showing"));
const vscodeClipboardMime = "application/vnd.code.copyMetadata";
let CopyPasteController = class CopyPasteController extends (0, _lifecycleJs.Disposable) {
    static{
        CopyPasteController_1 = this;
    }
    static{
        this.ID = "editor.contrib.copyPasteActionController";
    }
    static get(editor) {
        return editor.getContribution(CopyPasteController_1.ID);
    }
    constructor(editor, instantiationService, _bulkEditService, _clipboardService, _languageFeaturesService, _quickInputService, _progressService){
        super();
        this._bulkEditService = _bulkEditService;
        this._clipboardService = _clipboardService;
        this._languageFeaturesService = _languageFeaturesService;
        this._quickInputService = _quickInputService;
        this._progressService = _progressService;
        this._editor = editor;
        const container = editor.getContainerDomNode();
        this._register((0, _domJs.addDisposableListener)(container, "copy", (e)=>this.handleCopy(e)));
        this._register((0, _domJs.addDisposableListener)(container, "cut", (e)=>this.handleCopy(e)));
        this._register((0, _domJs.addDisposableListener)(container, "paste", (e)=>this.handlePaste(e), true));
        this._pasteProgressManager = this._register(new (0, _inlineProgressJs.InlineProgressManager)("pasteIntoEditor", editor, instantiationService));
        this._postPasteWidgetManager = this._register(instantiationService.createInstance((0, _postEditWidgetJs.PostEditWidgetManager), "pasteIntoEditor", editor, pasteWidgetVisibleCtx, {
            id: changePasteTypeCommandId,
            label: (0, _nlsJs.localize)("postPasteWidgetTitle", "Show paste options...")
        }));
    }
    changePasteType() {
        this._postPasteWidgetManager.tryShowSelector();
    }
    pasteAs(preferred) {
        this._editor.focus();
        try {
            this._pasteAsActionContext = {
                preferred
            };
            (0, _domJs.getActiveDocument)().execCommand("paste");
        } finally{
            this._pasteAsActionContext = undefined;
        }
    }
    clearWidgets() {
        this._postPasteWidgetManager.clear();
    }
    isPasteAsEnabled() {
        return this._editor.getOption(85 /* EditorOption.pasteAs */ ).enabled;
    }
    async finishedPaste() {
        await this._currentPasteOperation;
    }
    handleCopy(e) {
        if (!this._editor.hasTextFocus()) return;
        // Explicitly clear the clipboard internal state.
        // This is needed because on web, the browser clipboard is faked out using an in-memory store.
        // This means the resources clipboard is not properly updated when copying from the editor.
        this._clipboardService.clearInternalState?.();
        if (!e.clipboardData || !this.isPasteAsEnabled()) return;
        const model = this._editor.getModel();
        const selections = this._editor.getSelections();
        if (!model || !selections?.length) return;
        const enableEmptySelectionClipboard = this._editor.getOption(37 /* EditorOption.emptySelectionClipboard */ );
        let ranges = selections;
        const wasFromEmptySelection = selections.length === 1 && selections[0].isEmpty();
        if (wasFromEmptySelection) {
            if (!enableEmptySelectionClipboard) return;
            ranges = [
                new (0, _rangeJs.Range)(ranges[0].startLineNumber, 1, ranges[0].startLineNumber, 1 + model.getLineLength(ranges[0].startLineNumber))
            ];
        }
        const toCopy = this._editor._getViewModel()?.getPlainTextToCopy(selections, enableEmptySelectionClipboard, _platformJs.isWindows);
        const multicursorText = Array.isArray(toCopy) ? toCopy : null;
        const defaultPastePayload = {
            multicursorText,
            pasteOnNewLine: wasFromEmptySelection,
            mode: null
        };
        const providers = this._languageFeaturesService.documentPasteEditProvider.ordered(model).filter((x)=>!!x.prepareDocumentPaste);
        if (!providers.length) {
            this.setCopyMetadata(e.clipboardData, {
                defaultPastePayload
            });
            return;
        }
        const dataTransfer = (0, _dndJs.toVSDataTransfer)(e.clipboardData);
        const providerCopyMimeTypes = providers.flatMap((x)=>x.copyMimeTypes ?? []);
        // Save off a handle pointing to data that VS Code maintains.
        const handle = (0, _uuidJs.generateUuid)();
        this.setCopyMetadata(e.clipboardData, {
            id: handle,
            providerCopyMimeTypes,
            defaultPastePayload
        });
        const promise = (0, _asyncJs.createCancelablePromise)(async (token)=>{
            const results = (0, _arraysJs.coalesce)(await Promise.all(providers.map(async (provider)=>{
                try {
                    return await provider.prepareDocumentPaste(model, ranges, dataTransfer, token);
                } catch (err) {
                    console.error(err);
                    return undefined;
                }
            })));
            // Values from higher priority providers should overwrite values from lower priority ones.
            // Reverse the array to so that the calls to `replace` below will do this
            results.reverse();
            for (const result of results)for (const [mime, value] of result)dataTransfer.replace(mime, value);
            return dataTransfer;
        });
        CopyPasteController_1._currentCopyOperation?.dataTransferPromise.cancel();
        CopyPasteController_1._currentCopyOperation = {
            handle: handle,
            dataTransferPromise: promise
        };
    }
    async handlePaste(e) {
        if (!e.clipboardData || !this._editor.hasTextFocus()) return;
        (0, _messageControllerJs.MessageController).get(this._editor)?.closeMessage();
        this._currentPasteOperation?.cancel();
        this._currentPasteOperation = undefined;
        const model = this._editor.getModel();
        const selections = this._editor.getSelections();
        if (!selections?.length || !model) return;
        if (this._editor.getOption(92 /* EditorOption.readOnly */ ) // Never enabled if editor is readonly.
         || !this.isPasteAsEnabled() && !this._pasteAsActionContext // Or feature disabled (but still enable if paste was explicitly requested)
        ) return;
        const metadata = this.fetchCopyMetadata(e);
        const dataTransfer = (0, _dndJs.toExternalVSDataTransfer)(e.clipboardData);
        dataTransfer.delete(vscodeClipboardMime);
        const allPotentialMimeTypes = [
            ...e.clipboardData.types,
            ...metadata?.providerCopyMimeTypes ?? [],
            // TODO: always adds `uri-list` because this get set if there are resources in the system clipboard.
            // However we can only check the system clipboard async. For this early check, just add it in.
            // We filter providers again once we have the final dataTransfer we will use.
            (0, _mimeJs.Mimes).uriList
        ];
        const allProviders = this._languageFeaturesService.documentPasteEditProvider.ordered(model).filter((provider)=>{
            // Filter out providers that don't match the requested paste types
            const preference = this._pasteAsActionContext?.preferred;
            if (preference) {
                if (provider.providedPasteEditKinds && !this.providerMatchesPreference(provider, preference)) return false;
            }
            // And providers that don't handle any of mime types in the clipboard
            return provider.pasteMimeTypes?.some((type)=>(0, _dataTransferJs.matchesMimeType)(type, allPotentialMimeTypes));
        });
        if (!allProviders.length) {
            if (this._pasteAsActionContext?.preferred) this.showPasteAsNoEditMessage(selections, this._pasteAsActionContext.preferred);
            return;
        }
        // Prevent the editor's default paste handler from running.
        // Note that after this point, we are fully responsible for handling paste.
        // If we can't provider a paste for any reason, we need to explicitly delegate pasting back to the editor.
        e.preventDefault();
        e.stopImmediatePropagation();
        if (this._pasteAsActionContext) this.showPasteAsPick(this._pasteAsActionContext.preferred, allProviders, selections, dataTransfer, metadata);
        else this.doPasteInline(allProviders, selections, dataTransfer, metadata, e);
    }
    showPasteAsNoEditMessage(selections, preference) {
        (0, _messageControllerJs.MessageController).get(this._editor)?.showMessage((0, _nlsJs.localize)("pasteAsError", "No paste edits for '{0}' found", preference instanceof (0, _hierarchicalKindJs.HierarchicalKind) ? preference.value : preference.providerId), selections[0].getStartPosition());
    }
    doPasteInline(allProviders, selections, dataTransfer, metadata, clipboardEvent) {
        const editor = this._editor;
        if (!editor.hasModel()) return;
        const editorStateCts = new (0, _editorStateJs.EditorStateCancellationTokenSource)(editor, 3 /* CodeEditorStateFlag.Selection */ , undefined);
        const p = (0, _asyncJs.createCancelablePromise)(async (pToken)=>{
            const editor = this._editor;
            if (!editor.hasModel()) return;
            const model = editor.getModel();
            const disposables = new (0, _lifecycleJs.DisposableStore)();
            const cts = disposables.add(new (0, _cancellationJs.CancellationTokenSource)(pToken));
            disposables.add(editorStateCts.token.onCancellationRequested(()=>cts.cancel()));
            const token = cts.token;
            try {
                await this.mergeInDataFromCopy(dataTransfer, metadata, token);
                if (token.isCancellationRequested) return;
                const supportedProviders = allProviders.filter((provider)=>this.isSupportedPasteProvider(provider, dataTransfer));
                if (!supportedProviders.length || supportedProviders.length === 1 && supportedProviders[0] instanceof (0, _defaultProvidersJs.DefaultTextPasteOrDropEditProvider // Only our default text provider is active
                )) return this.applyDefaultPasteHandler(dataTransfer, metadata, token, clipboardEvent);
                const context = {
                    triggerKind: (0, _languagesJs.DocumentPasteTriggerKind).Automatic
                };
                const editSession = await this.getPasteEdits(supportedProviders, dataTransfer, model, selections, context, token);
                disposables.add(editSession);
                if (token.isCancellationRequested) return;
                // If the only edit returned is our default text edit, use the default paste handler
                if (editSession.edits.length === 1 && editSession.edits[0].provider instanceof (0, _defaultProvidersJs.DefaultTextPasteOrDropEditProvider)) return this.applyDefaultPasteHandler(dataTransfer, metadata, token, clipboardEvent);
                if (editSession.edits.length) {
                    const canShowWidget = editor.getOption(85 /* EditorOption.pasteAs */ ).showPasteSelector === "afterPaste";
                    return this._postPasteWidgetManager.applyEditAndShowIfNeeded(selections, {
                        activeEditIndex: 0,
                        allEdits: editSession.edits
                    }, canShowWidget, (edit, token)=>{
                        return new Promise((resolve, reject)=>{
                            (async ()=>{
                                try {
                                    const resolveP = edit.provider.resolveDocumentPasteEdit?.(edit, token);
                                    const showP = new (0, _asyncJs.DeferredPromise)();
                                    const resolved = resolveP && await this._pasteProgressManager.showWhile(selections[0].getEndPosition(), (0, _nlsJs.localize)("resolveProcess", "Resolving paste edit. Click to cancel"), Promise.race([
                                        showP.p,
                                        resolveP
                                    ]), {
                                        cancel: ()=>{
                                            showP.cancel();
                                            return reject(new (0, _errorsJs.CancellationError)());
                                        }
                                    }, 0);
                                    if (resolved) edit.additionalEdit = resolved.additionalEdit;
                                    return resolve(edit);
                                } catch (err) {
                                    return reject(err);
                                }
                            })();
                        });
                    }, token);
                }
                await this.applyDefaultPasteHandler(dataTransfer, metadata, token, clipboardEvent);
            } finally{
                disposables.dispose();
                if (this._currentPasteOperation === p) this._currentPasteOperation = undefined;
            }
        });
        this._pasteProgressManager.showWhile(selections[0].getEndPosition(), (0, _nlsJs.localize)("pasteIntoEditorProgress", "Running paste handlers. Click to cancel and do basic paste"), p, {
            cancel: async ()=>{
                try {
                    p.cancel();
                    if (editorStateCts.token.isCancellationRequested) return;
                    await this.applyDefaultPasteHandler(dataTransfer, metadata, editorStateCts.token, clipboardEvent);
                } finally{
                    editorStateCts.dispose();
                }
            }
        }).then(()=>{
            editorStateCts.dispose();
        });
        this._currentPasteOperation = p;
    }
    showPasteAsPick(preference, allProviders, selections, dataTransfer, metadata) {
        const p = (0, _asyncJs.createCancelablePromise)(async (token)=>{
            const editor = this._editor;
            if (!editor.hasModel()) return;
            const model = editor.getModel();
            const disposables = new (0, _lifecycleJs.DisposableStore)();
            const tokenSource = disposables.add(new (0, _editorStateJs.EditorStateCancellationTokenSource)(editor, 3 /* CodeEditorStateFlag.Selection */ , undefined, token));
            try {
                await this.mergeInDataFromCopy(dataTransfer, metadata, tokenSource.token);
                if (tokenSource.token.isCancellationRequested) return;
                // Filter out any providers the don't match the full data transfer we will send them.
                let supportedProviders = allProviders.filter((provider)=>this.isSupportedPasteProvider(provider, dataTransfer, preference));
                if (preference) // We are looking for a specific edit
                supportedProviders = supportedProviders.filter((provider)=>this.providerMatchesPreference(provider, preference));
                const context = {
                    triggerKind: (0, _languagesJs.DocumentPasteTriggerKind).PasteAs,
                    only: preference && preference instanceof (0, _hierarchicalKindJs.HierarchicalKind) ? preference : undefined
                };
                let editSession = disposables.add(await this.getPasteEdits(supportedProviders, dataTransfer, model, selections, context, tokenSource.token));
                if (tokenSource.token.isCancellationRequested) return;
                // Filter out any edits that don't match the requested kind
                if (preference) editSession = {
                    edits: editSession.edits.filter((edit)=>{
                        if (preference instanceof (0, _hierarchicalKindJs.HierarchicalKind)) return preference.contains(edit.kind);
                        else return preference.providerId === edit.provider.id;
                    }),
                    dispose: editSession.dispose
                };
                if (!editSession.edits.length) {
                    if (context.only) this.showPasteAsNoEditMessage(selections, context.only);
                    return;
                }
                let pickedEdit;
                if (preference) pickedEdit = editSession.edits.at(0);
                else {
                    const selected = await this._quickInputService.pick(editSession.edits.map((edit)=>({
                            label: edit.title,
                            description: edit.kind?.value,
                            edit
                        })), {
                        placeHolder: (0, _nlsJs.localize)("pasteAsPickerPlaceholder", "Select Paste Action")
                    });
                    pickedEdit = selected?.edit;
                }
                if (!pickedEdit) return;
                const combinedWorkspaceEdit = (0, _editJs.createCombinedWorkspaceEdit)(model.uri, selections, pickedEdit);
                await this._bulkEditService.apply(combinedWorkspaceEdit, {
                    editor: this._editor
                });
            } finally{
                disposables.dispose();
                if (this._currentPasteOperation === p) this._currentPasteOperation = undefined;
            }
        });
        this._progressService.withProgress({
            location: 10 /* ProgressLocation.Window */ ,
            title: (0, _nlsJs.localize)("pasteAsProgress", "Running paste handlers")
        }, ()=>p);
    }
    setCopyMetadata(dataTransfer, metadata) {
        dataTransfer.setData(vscodeClipboardMime, JSON.stringify(metadata));
    }
    fetchCopyMetadata(e) {
        if (!e.clipboardData) return;
        // Prefer using the clipboard data we saved off
        const rawMetadata = e.clipboardData.getData(vscodeClipboardMime);
        if (rawMetadata) try {
            return JSON.parse(rawMetadata);
        } catch  {
            return undefined;
        }
        // Otherwise try to extract the generic text editor metadata
        const [_, metadata] = (0, _textAreaInputJs.ClipboardEventUtils).getTextData(e.clipboardData);
        if (metadata) return {
            defaultPastePayload: {
                mode: metadata.mode,
                multicursorText: metadata.multicursorText ?? null,
                pasteOnNewLine: !!metadata.isFromEmptySelection
            }
        };
        return undefined;
    }
    async mergeInDataFromCopy(dataTransfer, metadata, token) {
        if (metadata?.id && CopyPasteController_1._currentCopyOperation?.handle === metadata.id) {
            const toMergeDataTransfer = await CopyPasteController_1._currentCopyOperation.dataTransferPromise;
            if (token.isCancellationRequested) return;
            for (const [key, value] of toMergeDataTransfer)dataTransfer.replace(key, value);
        }
        if (!dataTransfer.has((0, _mimeJs.Mimes).uriList)) {
            const resources = await this._clipboardService.readResources();
            if (token.isCancellationRequested) return;
            if (resources.length) dataTransfer.append((0, _mimeJs.Mimes).uriList, (0, _dataTransferJs.createStringDataTransferItem)((0, _dataTransferJs.UriList).create(resources)));
        }
    }
    async getPasteEdits(providers, dataTransfer, model, selections, context, token) {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        const results = await (0, _asyncJs.raceCancellation)(Promise.all(providers.map(async (provider)=>{
            try {
                const edits = await provider.provideDocumentPasteEdits?.(model, selections, dataTransfer, context, token);
                if (edits) disposables.add(edits);
                return edits?.edits?.map((edit)=>({
                        ...edit,
                        provider
                    }));
            } catch (err) {
                if (!(0, _errorsJs.isCancellationError)(err)) console.error(err);
                return undefined;
            }
        })), token);
        const edits = (0, _arraysJs.coalesce)(results ?? []).flat().filter((edit)=>{
            return !context.only || context.only.contains(edit.kind);
        });
        return {
            edits: (0, _editJs.sortEditsByYieldTo)(edits),
            dispose: ()=>disposables.dispose()
        };
    }
    async applyDefaultPasteHandler(dataTransfer, metadata, token, clipboardEvent) {
        const textDataTransfer = dataTransfer.get((0, _mimeJs.Mimes).text) ?? dataTransfer.get("text");
        const text = await textDataTransfer?.asString() ?? "";
        if (token.isCancellationRequested) return;
        const payload = {
            clipboardEvent,
            text,
            pasteOnNewLine: metadata?.defaultPastePayload.pasteOnNewLine ?? false,
            multicursorText: metadata?.defaultPastePayload.multicursorText ?? null,
            mode: null
        };
        this._editor.trigger("keyboard", "paste" /* Handler.Paste */ , payload);
    }
    /**
     * Filter out providers if they:
     * - Don't handle any of the data transfer types we have
     * - Don't match the preferred paste kind
     */ isSupportedPasteProvider(provider, dataTransfer, preference) {
        if (!provider.pasteMimeTypes?.some((type)=>dataTransfer.matches(type))) return false;
        return !preference || this.providerMatchesPreference(provider, preference);
    }
    providerMatchesPreference(provider, preference) {
        if (preference instanceof (0, _hierarchicalKindJs.HierarchicalKind)) {
            if (!provider.providedPasteEditKinds) return true;
            return provider.providedPasteEditKinds.some((providedKind)=>preference.contains(providedKind));
        } else return provider.id === preference.providerId;
    }
};
CopyPasteController = CopyPasteController_1 = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService)),
    __param(2, (0, _bulkEditServiceJs.IBulkEditService)),
    __param(3, (0, _clipboardServiceJs.IClipboardService)),
    __param(4, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(5, (0, _quickInputJs.IQuickInputService)),
    __param(6, (0, _progressJs.IProgressService))
], CopyPasteController);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/arrays.js":"DECei","../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/dataTransfer.js":"5wpxJ","../../../../base/common/hierarchicalKind.js":"eXua8","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/mime.js":"9CBNk","../../../../base/common/platform.js":"7maJO","../../../../base/common/uuid.js":"g8HjT","../../../browser/controller/textAreaInput.js":"d7Bw3","../../../browser/dnd.js":"eI7oO","../../../browser/services/bulkEditService.js":"fLMRG","../../../common/core/range.js":"jmUPh","../../../common/languages.js":"g5n96","../../../common/services/languageFeatures.js":"2IAko","./defaultProviders.js":"eXi6S","./edit.js":"fZ737","../../editorState/browser/editorState.js":"hyVHM","../../inlineProgress/browser/inlineProgress.js":"a5six","../../message/browser/messageController.js":"7FZE5","../../../../nls.js":"l617d","../../../../platform/clipboard/common/clipboardService.js":"4IsFp","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/progress/common/progress.js":"f49eD","../../../../platform/quickinput/common/quickInput.js":"a56M6","./postEditWidget.js":"64EIp","../../../../base/common/errors.js":"divX8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5wpxJ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStringDataTransferItem", ()=>createStringDataTransferItem);
parcelHelpers.export(exports, "createFileDataTransferItem", ()=>createFileDataTransferItem);
parcelHelpers.export(exports, "VSDataTransfer", ()=>VSDataTransfer);
parcelHelpers.export(exports, "matchesMimeType", ()=>matchesMimeType);
parcelHelpers.export(exports, "UriList", ()=>UriList);
var _arraysJs = require("./arrays.js");
var _iteratorJs = require("./iterator.js");
var _uuidJs = require("./uuid.js");
function createStringDataTransferItem(stringOrPromise) {
    return {
        asString: async ()=>stringOrPromise,
        asFile: ()=>undefined,
        value: typeof stringOrPromise === "string" ? stringOrPromise : undefined
    };
}
function createFileDataTransferItem(fileName, uri, data) {
    const file = {
        id: (0, _uuidJs.generateUuid)(),
        name: fileName,
        uri,
        data
    };
    return {
        asString: async ()=>"",
        asFile: ()=>file,
        value: undefined
    };
}
class VSDataTransfer {
    constructor(){
        this._entries = new Map();
    }
    get size() {
        let size = 0;
        for (const _ of this._entries)size++;
        return size;
    }
    has(mimeType) {
        return this._entries.has(this.toKey(mimeType));
    }
    matches(pattern) {
        const mimes = [
            ...this._entries.keys()
        ];
        if ((0, _iteratorJs.Iterable).some(this, ([_, item])=>item.asFile())) mimes.push("files");
        return matchesMimeType_normalized(normalizeMimeType(pattern), mimes);
    }
    get(mimeType) {
        return this._entries.get(this.toKey(mimeType))?.[0];
    }
    /**
     * Add a new entry to this data transfer.
     *
     * This does not replace existing entries for `mimeType`.
     */ append(mimeType, value) {
        const existing = this._entries.get(mimeType);
        if (existing) existing.push(value);
        else this._entries.set(this.toKey(mimeType), [
            value
        ]);
    }
    /**
     * Set the entry for a given mime type.
     *
     * This replaces all existing entries for `mimeType`.
     */ replace(mimeType, value) {
        this._entries.set(this.toKey(mimeType), [
            value
        ]);
    }
    /**
     * Remove all entries for `mimeType`.
     */ delete(mimeType) {
        this._entries.delete(this.toKey(mimeType));
    }
    /**
     * Iterate over all `[mime, item]` pairs in this data transfer.
     *
     * There may be multiple entries for each mime type.
     */ *[Symbol.iterator]() {
        for (const [mine, items] of this._entries)for (const item of items)yield [
            mine,
            item
        ];
    }
    toKey(mimeType) {
        return normalizeMimeType(mimeType);
    }
}
function normalizeMimeType(mimeType) {
    return mimeType.toLowerCase();
}
function matchesMimeType(pattern, mimeTypes) {
    return matchesMimeType_normalized(normalizeMimeType(pattern), mimeTypes.map(normalizeMimeType));
}
function matchesMimeType_normalized(normalizedPattern, normalizedMimeTypes) {
    // Anything wildcard
    if (normalizedPattern === "*/*") return normalizedMimeTypes.length > 0;
    // Exact match
    if (normalizedMimeTypes.includes(normalizedPattern)) return true;
    // Wildcard, such as `image/*`
    const wildcard = normalizedPattern.match(/^([a-z]+)\/([a-z]+|\*)$/i);
    if (!wildcard) return false;
    const [_, type, subtype] = wildcard;
    if (subtype === "*") return normalizedMimeTypes.some((mime)=>mime.startsWith(type + "/"));
    return false;
}
const UriList = Object.freeze({
    // http://amundsen.com/hypermedia/urilist/
    create: (entries)=>{
        return (0, _arraysJs.distinct)(entries.map((x)=>x.toString())).join("\r\n");
    },
    split: (str)=>{
        return str.split("\r\n");
    },
    parse: (str)=>{
        return UriList.split(str).filter((value)=>!value.startsWith("#"));
    }
});

},{"./arrays.js":"DECei","./iterator.js":"2FiS0","./uuid.js":"g8HjT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g8HjT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateUuid", ()=>generateUuid);
const generateUuid = function() {
    // use `randomUUID` if possible
    if (typeof crypto === "object" && typeof crypto.randomUUID === "function") return crypto.randomUUID.bind(crypto);
    // use `randomValues` if possible
    let getRandomValues;
    if (typeof crypto === "object" && typeof crypto.getRandomValues === "function") getRandomValues = crypto.getRandomValues.bind(crypto);
    else getRandomValues = function(bucket) {
        for(let i = 0; i < bucket.length; i++)bucket[i] = Math.floor(Math.random() * 256);
        return bucket;
    };
    // prep-work
    const _data = new Uint8Array(16);
    const _hex = [];
    for(let i = 0; i < 256; i++)_hex.push(i.toString(16).padStart(2, "0"));
    return function generateUuid() {
        // get data
        getRandomValues(_data);
        // set version bits
        _data[6] = _data[6] & 0x0f | 0x40;
        _data[8] = _data[8] & 0x3f | 0x80;
        // print as string
        let i = 0;
        let result = "";
        result += _hex[_data[i++]];
        result += _hex[_data[i++]];
        result += _hex[_data[i++]];
        result += _hex[_data[i++]];
        result += "-";
        result += _hex[_data[i++]];
        result += _hex[_data[i++]];
        result += "-";
        result += _hex[_data[i++]];
        result += _hex[_data[i++]];
        result += "-";
        result += _hex[_data[i++]];
        result += _hex[_data[i++]];
        result += "-";
        result += _hex[_data[i++]];
        result += _hex[_data[i++]];
        result += _hex[_data[i++]];
        result += _hex[_data[i++]];
        result += _hex[_data[i++]];
        result += _hex[_data[i++]];
        return result;
    };
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eXua8":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HierarchicalKind", ()=>HierarchicalKind);
class HierarchicalKind {
    static{
        this.sep = ".";
    }
    static{
        this.None = new HierarchicalKind("@@none@@");
    }
    static{
        this.Empty = new HierarchicalKind("");
    }
    constructor(value){
        this.value = value;
    }
    equals(other) {
        return this.value === other.value;
    }
    contains(other) {
        return this.equals(other) || this.value === "" || other.value.startsWith(this.value + HierarchicalKind.sep);
    }
    intersects(other) {
        return this.contains(other) || other.contains(this);
    }
    append(...parts) {
        return new HierarchicalKind((this.value ? [
            this.value,
            ...parts
        ] : parts).join(HierarchicalKind.sep));
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eI7oO":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toVSDataTransfer", ()=>toVSDataTransfer);
parcelHelpers.export(exports, "toExternalVSDataTransfer", ()=>toExternalVSDataTransfer);
var _dndJs = require("../../base/browser/dnd.js");
var _dataTransferJs = require("../../base/common/dataTransfer.js");
var _mimeJs = require("../../base/common/mime.js");
var _uriJs = require("../../base/common/uri.js");
var _dndJs1 = require("../../platform/dnd/browser/dnd.js");
function toVSDataTransfer(dataTransfer) {
    const vsDataTransfer = new (0, _dataTransferJs.VSDataTransfer)();
    for (const item of dataTransfer.items){
        const type = item.type;
        if (item.kind === "string") {
            const asStringValue = new Promise((resolve)=>item.getAsString(resolve));
            vsDataTransfer.append(type, (0, _dataTransferJs.createStringDataTransferItem)(asStringValue));
        } else if (item.kind === "file") {
            const file = item.getAsFile();
            if (file) vsDataTransfer.append(type, createFileDataTransferItemFromFile(file));
        }
    }
    return vsDataTransfer;
}
function createFileDataTransferItemFromFile(file) {
    const uri = file.path ? (0, _uriJs.URI).parse(file.path) : undefined;
    return (0, _dataTransferJs.createFileDataTransferItem)(file.name, uri, async ()=>{
        return new Uint8Array(await file.arrayBuffer());
    });
}
const INTERNAL_DND_MIME_TYPES = Object.freeze([
    (0, _dndJs1.CodeDataTransfers).EDITORS,
    (0, _dndJs1.CodeDataTransfers).FILES,
    (0, _dndJs.DataTransfers).RESOURCES,
    (0, _dndJs.DataTransfers).INTERNAL_URI_LIST
]);
function toExternalVSDataTransfer(sourceDataTransfer, overwriteUriList = false) {
    const vsDataTransfer = toVSDataTransfer(sourceDataTransfer);
    // Try to expose the internal uri-list type as the standard type
    const uriList = vsDataTransfer.get((0, _dndJs.DataTransfers).INTERNAL_URI_LIST);
    if (uriList) vsDataTransfer.replace((0, _mimeJs.Mimes).uriList, uriList);
    else if (overwriteUriList || !vsDataTransfer.has((0, _mimeJs.Mimes).uriList)) {
        // Otherwise, fallback to adding dragged resources to the uri list
        const editorData = [];
        for (const item of sourceDataTransfer.items){
            const file = item.getAsFile();
            if (file) {
                const path = file.path;
                try {
                    if (path) editorData.push((0, _uriJs.URI).file(path).toString());
                    else editorData.push((0, _uriJs.URI).parse(file.name, true).toString());
                } catch  {
                // Parsing failed. Leave out from list
                }
            }
        }
        if (editorData.length) vsDataTransfer.replace((0, _mimeJs.Mimes).uriList, (0, _dataTransferJs.createStringDataTransferItem)((0, _dataTransferJs.UriList).create(editorData)));
    }
    for (const internal of INTERNAL_DND_MIME_TYPES)vsDataTransfer.delete(internal);
    return vsDataTransfer;
}

},{"../../base/browser/dnd.js":"io6s1","../../base/common/dataTransfer.js":"5wpxJ","../../base/common/mime.js":"9CBNk","../../base/common/uri.js":"7qGS3","../../platform/dnd/browser/dnd.js":"a7xax","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a7xax":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeDataTransfers", ()=>CodeDataTransfers);
parcelHelpers.export(exports, "Extensions", ()=>Extensions);
//#endregion
//#region DND Utilities
/**
 * A singleton to store transfer data during drag & drop operations that are only valid within the application.
 */ parcelHelpers.export(exports, "LocalSelectionTransfer", ()=>LocalSelectionTransfer) //#endregion
;
var _platformJs = require("../../registry/common/platform.js");
const CodeDataTransfers = {
    EDITORS: "CodeEditors",
    FILES: "CodeFiles"
};
class DragAndDropContributionRegistry {
}
const Extensions = {
    DragAndDropContribution: "workbench.contributions.dragAndDrop"
};
(0, _platformJs.Registry).add(Extensions.DragAndDropContribution, new DragAndDropContributionRegistry());
class LocalSelectionTransfer {
    static{
        this.INSTANCE = new LocalSelectionTransfer();
    }
    constructor(){
    // protect against external instantiation
    }
    static getInstance() {
        return LocalSelectionTransfer.INSTANCE;
    }
    hasData(proto) {
        return proto && proto === this.proto;
    }
    getData(proto) {
        if (this.hasData(proto)) return this.data;
        return undefined;
    }
}

},{"../../registry/common/platform.js":"dzx11","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eXi6S":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultTextPasteOrDropEditProvider", ()=>DefaultTextPasteOrDropEditProvider);
parcelHelpers.export(exports, "DefaultDropProvidersFeature", ()=>DefaultDropProvidersFeature);
parcelHelpers.export(exports, "DefaultPasteProvidersFeature", ()=>DefaultPasteProvidersFeature);
var _arraysJs = require("../../../../base/common/arrays.js");
var _dataTransferJs = require("../../../../base/common/dataTransfer.js");
var _hierarchicalKindJs = require("../../../../base/common/hierarchicalKind.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _mimeJs = require("../../../../base/common/mime.js");
var _networkJs = require("../../../../base/common/network.js");
var _resourcesJs = require("../../../../base/common/resources.js");
var _uriJs = require("../../../../base/common/uri.js");
var _languagesJs = require("../../../common/languages.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _nlsJs = require("../../../../nls.js");
var _workspaceJs = require("../../../../platform/workspace/common/workspace.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class SimplePasteAndDropProvider {
    async provideDocumentPasteEdits(_model, _ranges, dataTransfer, context, token) {
        const edit = await this.getEdit(dataTransfer, token);
        if (!edit) return undefined;
        return {
            edits: [
                {
                    insertText: edit.insertText,
                    title: edit.title,
                    kind: edit.kind,
                    handledMimeType: edit.handledMimeType,
                    yieldTo: edit.yieldTo
                }
            ],
            dispose () {}
        };
    }
    async provideDocumentDropEdits(_model, _position, dataTransfer, token) {
        const edit = await this.getEdit(dataTransfer, token);
        if (!edit) return;
        return {
            edits: [
                {
                    insertText: edit.insertText,
                    title: edit.title,
                    kind: edit.kind,
                    handledMimeType: edit.handledMimeType,
                    yieldTo: edit.yieldTo
                }
            ],
            dispose () {}
        };
    }
}
class DefaultTextPasteOrDropEditProvider extends SimplePasteAndDropProvider {
    constructor(){
        super(...arguments);
        this.kind = DefaultTextPasteOrDropEditProvider.kind;
        this.dropMimeTypes = [
            (0, _mimeJs.Mimes).text
        ];
        this.pasteMimeTypes = [
            (0, _mimeJs.Mimes).text
        ];
    }
    static{
        this.id = "text";
    }
    static{
        this.kind = new (0, _hierarchicalKindJs.HierarchicalKind)("text.plain");
    }
    async getEdit(dataTransfer, _token) {
        const textEntry = dataTransfer.get((0, _mimeJs.Mimes).text);
        if (!textEntry) return;
        // Suppress if there's also a uriList entry.
        // Typically the uri-list contains the same text as the text entry so showing both is confusing.
        if (dataTransfer.has((0, _mimeJs.Mimes).uriList)) return;
        const insertText = await textEntry.asString();
        return {
            handledMimeType: (0, _mimeJs.Mimes).text,
            title: (0, _nlsJs.localize)("text.label", "Insert Plain Text"),
            insertText,
            kind: this.kind
        };
    }
}
class PathProvider extends SimplePasteAndDropProvider {
    constructor(){
        super(...arguments);
        this.kind = new (0, _hierarchicalKindJs.HierarchicalKind)("uri.absolute");
        this.dropMimeTypes = [
            (0, _mimeJs.Mimes).uriList
        ];
        this.pasteMimeTypes = [
            (0, _mimeJs.Mimes).uriList
        ];
    }
    async getEdit(dataTransfer, token) {
        const entries = await extractUriList(dataTransfer);
        if (!entries.length || token.isCancellationRequested) return;
        let uriCount = 0;
        const insertText = entries.map(({ uri, originalText })=>{
            if (uri.scheme === (0, _networkJs.Schemas).file) return uri.fsPath;
            else {
                uriCount++;
                return originalText;
            }
        }).join(" ");
        let label;
        if (uriCount > 0) // Dropping at least one generic uri (such as https) so use most generic label
        label = entries.length > 1 ? (0, _nlsJs.localize)("defaultDropProvider.uriList.uris", "Insert Uris") : (0, _nlsJs.localize)("defaultDropProvider.uriList.uri", "Insert Uri");
        else // All the paths are file paths
        label = entries.length > 1 ? (0, _nlsJs.localize)("defaultDropProvider.uriList.paths", "Insert Paths") : (0, _nlsJs.localize)("defaultDropProvider.uriList.path", "Insert Path");
        return {
            handledMimeType: (0, _mimeJs.Mimes).uriList,
            insertText,
            title: label,
            kind: this.kind
        };
    }
}
let RelativePathProvider = class RelativePathProvider extends SimplePasteAndDropProvider {
    constructor(_workspaceContextService){
        super();
        this._workspaceContextService = _workspaceContextService;
        this.kind = new (0, _hierarchicalKindJs.HierarchicalKind)("uri.relative");
        this.dropMimeTypes = [
            (0, _mimeJs.Mimes).uriList
        ];
        this.pasteMimeTypes = [
            (0, _mimeJs.Mimes).uriList
        ];
    }
    async getEdit(dataTransfer, token) {
        const entries = await extractUriList(dataTransfer);
        if (!entries.length || token.isCancellationRequested) return;
        const relativeUris = (0, _arraysJs.coalesce)(entries.map(({ uri })=>{
            const root = this._workspaceContextService.getWorkspaceFolder(uri);
            return root ? (0, _resourcesJs.relativePath)(root.uri, uri) : undefined;
        }));
        if (!relativeUris.length) return;
        return {
            handledMimeType: (0, _mimeJs.Mimes).uriList,
            insertText: relativeUris.join(" "),
            title: entries.length > 1 ? (0, _nlsJs.localize)("defaultDropProvider.uriList.relativePaths", "Insert Relative Paths") : (0, _nlsJs.localize)("defaultDropProvider.uriList.relativePath", "Insert Relative Path"),
            kind: this.kind
        };
    }
};
RelativePathProvider = __decorate([
    __param(0, (0, _workspaceJs.IWorkspaceContextService))
], RelativePathProvider);
class PasteHtmlProvider {
    constructor(){
        this.kind = new (0, _hierarchicalKindJs.HierarchicalKind)("html");
        this.pasteMimeTypes = [
            "text/html"
        ];
        this._yieldTo = [
            {
                mimeType: (0, _mimeJs.Mimes).text
            }
        ];
    }
    async provideDocumentPasteEdits(_model, _ranges, dataTransfer, context, token) {
        if (context.triggerKind !== (0, _languagesJs.DocumentPasteTriggerKind).PasteAs && !context.only?.contains(this.kind)) return;
        const entry = dataTransfer.get("text/html");
        const htmlText = await entry?.asString();
        if (!htmlText || token.isCancellationRequested) return;
        return {
            dispose () {},
            edits: [
                {
                    insertText: htmlText,
                    yieldTo: this._yieldTo,
                    title: (0, _nlsJs.localize)("pasteHtmlLabel", "Insert HTML"),
                    kind: this.kind
                }
            ]
        };
    }
}
async function extractUriList(dataTransfer) {
    const urlListEntry = dataTransfer.get((0, _mimeJs.Mimes).uriList);
    if (!urlListEntry) return [];
    const strUriList = await urlListEntry.asString();
    const entries = [];
    for (const entry of (0, _dataTransferJs.UriList).parse(strUriList))try {
        entries.push({
            uri: (0, _uriJs.URI).parse(entry),
            originalText: entry
        });
    } catch  {
    // noop
    }
    return entries;
}
let DefaultDropProvidersFeature = class DefaultDropProvidersFeature extends (0, _lifecycleJs.Disposable) {
    constructor(languageFeaturesService, workspaceContextService){
        super();
        this._register(languageFeaturesService.documentDropEditProvider.register("*", new DefaultTextPasteOrDropEditProvider()));
        this._register(languageFeaturesService.documentDropEditProvider.register("*", new PathProvider()));
        this._register(languageFeaturesService.documentDropEditProvider.register("*", new RelativePathProvider(workspaceContextService)));
    }
};
DefaultDropProvidersFeature = __decorate([
    __param(0, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(1, (0, _workspaceJs.IWorkspaceContextService))
], DefaultDropProvidersFeature);
let DefaultPasteProvidersFeature = class DefaultPasteProvidersFeature extends (0, _lifecycleJs.Disposable) {
    constructor(languageFeaturesService, workspaceContextService){
        super();
        this._register(languageFeaturesService.documentPasteEditProvider.register("*", new DefaultTextPasteOrDropEditProvider()));
        this._register(languageFeaturesService.documentPasteEditProvider.register("*", new PathProvider()));
        this._register(languageFeaturesService.documentPasteEditProvider.register("*", new RelativePathProvider(workspaceContextService)));
        this._register(languageFeaturesService.documentPasteEditProvider.register("*", new PasteHtmlProvider()));
    }
};
DefaultPasteProvidersFeature = __decorate([
    __param(0, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(1, (0, _workspaceJs.IWorkspaceContextService))
], DefaultPasteProvidersFeature);

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/dataTransfer.js":"5wpxJ","../../../../base/common/hierarchicalKind.js":"eXua8","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/mime.js":"9CBNk","../../../../base/common/network.js":"2c1AD","../../../../base/common/resources.js":"700EV","../../../../base/common/uri.js":"7qGS3","../../../common/languages.js":"g5n96","../../../common/services/languageFeatures.js":"2IAko","../../../../nls.js":"l617d","../../../../platform/workspace/common/workspace.js":"707vH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fZ737":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given a {@link DropOrPasteEdit} and set of ranges, creates a {@link WorkspaceEdit} that applies the insert text from
 * the {@link DropOrPasteEdit} at each range plus any additional edits.
 */ parcelHelpers.export(exports, "createCombinedWorkspaceEdit", ()=>createCombinedWorkspaceEdit);
parcelHelpers.export(exports, "sortEditsByYieldTo", ()=>sortEditsByYieldTo);
var _bulkEditServiceJs = require("../../../browser/services/bulkEditService.js");
var _snippetParserJs = require("../../snippet/browser/snippetParser.js");
function createCombinedWorkspaceEdit(uri, ranges, edit) {
    // If the edit insert text is empty, skip applying at each range
    if (typeof edit.insertText === "string" ? edit.insertText === "" : edit.insertText.snippet === "") return {
        edits: edit.additionalEdit?.edits ?? []
    };
    return {
        edits: [
            ...ranges.map((range)=>new (0, _bulkEditServiceJs.ResourceTextEdit)(uri, {
                    range,
                    text: typeof edit.insertText === "string" ? (0, _snippetParserJs.SnippetParser).escape(edit.insertText) + "$0" : edit.insertText.snippet,
                    insertAsSnippet: true
                })),
            ...edit.additionalEdit?.edits ?? []
        ]
    };
}
function sortEditsByYieldTo(edits) {
    function yieldsTo(yTo, other) {
        if ("mimeType" in yTo) return yTo.mimeType === other.handledMimeType;
        return !!other.kind && yTo.kind.contains(other.kind);
    }
    // Build list of nodes each node yields to
    const yieldsToMap = new Map();
    for (const edit of edits){
        for (const yTo of edit.yieldTo ?? [])for (const other of edits){
            if (other === edit) continue;
            if (yieldsTo(yTo, other)) {
                let arr = yieldsToMap.get(edit);
                if (!arr) {
                    arr = [];
                    yieldsToMap.set(edit, arr);
                }
                arr.push(other);
            }
        }
    }
    if (!yieldsToMap.size) return Array.from(edits);
    // Topological sort
    const visited = new Set();
    const tempStack = [];
    function visit(nodes) {
        if (!nodes.length) return [];
        const node = nodes[0];
        if (tempStack.includes(node)) {
            console.warn("Yield to cycle detected", node);
            return nodes;
        }
        if (visited.has(node)) return visit(nodes.slice(1));
        let pre = [];
        const yTo = yieldsToMap.get(node);
        if (yTo) {
            tempStack.push(node);
            pre = visit(yTo);
            tempStack.pop();
        }
        visited.add(node);
        return [
            ...pre,
            node,
            ...visit(nodes.slice(1))
        ];
    }
    return visit(Array.from(edits));
}

},{"../../../browser/services/bulkEditService.js":"fLMRG","../../snippet/browser/snippetParser.js":"6qHnq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6qHnq":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scanner", ()=>Scanner);
parcelHelpers.export(exports, "Marker", ()=>Marker);
parcelHelpers.export(exports, "Text", ()=>Text);
parcelHelpers.export(exports, "TransformableMarker", ()=>TransformableMarker);
parcelHelpers.export(exports, "Placeholder", ()=>Placeholder);
parcelHelpers.export(exports, "Choice", ()=>Choice);
parcelHelpers.export(exports, "Transform", ()=>Transform);
parcelHelpers.export(exports, "FormatString", ()=>FormatString);
parcelHelpers.export(exports, "Variable", ()=>Variable);
parcelHelpers.export(exports, "TextmateSnippet", ()=>TextmateSnippet);
parcelHelpers.export(exports, "SnippetParser", ()=>SnippetParser);
class Scanner {
    constructor(){
        this.value = "";
        this.pos = 0;
    }
    static{
        this._table = {
            [36 /* CharCode.DollarSign */ ]: 0 /* TokenType.Dollar */ ,
            [58 /* CharCode.Colon */ ]: 1 /* TokenType.Colon */ ,
            [44 /* CharCode.Comma */ ]: 2 /* TokenType.Comma */ ,
            [123 /* CharCode.OpenCurlyBrace */ ]: 3 /* TokenType.CurlyOpen */ ,
            [125 /* CharCode.CloseCurlyBrace */ ]: 4 /* TokenType.CurlyClose */ ,
            [92 /* CharCode.Backslash */ ]: 5 /* TokenType.Backslash */ ,
            [47 /* CharCode.Slash */ ]: 6 /* TokenType.Forwardslash */ ,
            [124 /* CharCode.Pipe */ ]: 7 /* TokenType.Pipe */ ,
            [43 /* CharCode.Plus */ ]: 11 /* TokenType.Plus */ ,
            [45 /* CharCode.Dash */ ]: 12 /* TokenType.Dash */ ,
            [63 /* CharCode.QuestionMark */ ]: 13 /* TokenType.QuestionMark */ 
        };
    }
    static isDigitCharacter(ch) {
        return ch >= 48 /* CharCode.Digit0 */  && ch <= 57 /* CharCode.Digit9 */ ;
    }
    static isVariableCharacter(ch) {
        return ch === 95 /* CharCode.Underline */  || ch >= 97 /* CharCode.a */  && ch <= 122 /* CharCode.z */  || ch >= 65 /* CharCode.A */  && ch <= 90 /* CharCode.Z */ ;
    }
    text(value) {
        this.value = value;
        this.pos = 0;
    }
    tokenText(token) {
        return this.value.substr(token.pos, token.len);
    }
    next() {
        if (this.pos >= this.value.length) return {
            type: 14 /* TokenType.EOF */ ,
            pos: this.pos,
            len: 0
        };
        const pos = this.pos;
        let len = 0;
        let ch = this.value.charCodeAt(pos);
        let type;
        // static types
        type = Scanner._table[ch];
        if (typeof type === "number") {
            this.pos += 1;
            return {
                type,
                pos,
                len: 1
            };
        }
        // number
        if (Scanner.isDigitCharacter(ch)) {
            type = 8 /* TokenType.Int */ ;
            do {
                len += 1;
                ch = this.value.charCodeAt(pos + len);
            }while (Scanner.isDigitCharacter(ch));
            this.pos += len;
            return {
                type,
                pos,
                len
            };
        }
        // variable name
        if (Scanner.isVariableCharacter(ch)) {
            type = 9 /* TokenType.VariableName */ ;
            do ch = this.value.charCodeAt(pos + ++len);
            while (Scanner.isVariableCharacter(ch) || Scanner.isDigitCharacter(ch));
            this.pos += len;
            return {
                type,
                pos,
                len
            };
        }
        // format
        type = 10 /* TokenType.Format */ ;
        do {
            len += 1;
            ch = this.value.charCodeAt(pos + len);
        }while (!isNaN(ch) && typeof Scanner._table[ch] === "undefined" // not static token
         && !Scanner.isDigitCharacter(ch) // not number
         && !Scanner.isVariableCharacter(ch) // not variable
        );
        this.pos += len;
        return {
            type,
            pos,
            len
        };
    }
}
class Marker {
    constructor(){
        this._children = [];
    }
    appendChild(child) {
        if (child instanceof Text && this._children[this._children.length - 1] instanceof Text) // this and previous child are text -> merge them
        this._children[this._children.length - 1].value += child.value;
        else {
            // normal adoption of child
            child.parent = this;
            this._children.push(child);
        }
        return this;
    }
    replace(child, others) {
        const { parent } = child;
        const idx = parent.children.indexOf(child);
        const newChildren = parent.children.slice(0);
        newChildren.splice(idx, 1, ...others);
        parent._children = newChildren;
        (function _fixParent(children, parent) {
            for (const child of children){
                child.parent = parent;
                _fixParent(child.children, child);
            }
        })(others, parent);
    }
    get children() {
        return this._children;
    }
    get rightMostDescendant() {
        if (this._children.length > 0) return this._children[this._children.length - 1].rightMostDescendant;
        return this;
    }
    get snippet() {
        let candidate = this;
        while(true){
            if (!candidate) return undefined;
            if (candidate instanceof TextmateSnippet) return candidate;
            candidate = candidate.parent;
        }
    }
    toString() {
        return this.children.reduce((prev, cur)=>prev + cur.toString(), "");
    }
    len() {
        return 0;
    }
}
class Text extends Marker {
    constructor(value){
        super();
        this.value = value;
    }
    toString() {
        return this.value;
    }
    len() {
        return this.value.length;
    }
    clone() {
        return new Text(this.value);
    }
}
class TransformableMarker extends Marker {
}
class Placeholder extends TransformableMarker {
    static compareByIndex(a, b) {
        if (a.index === b.index) return 0;
        else if (a.isFinalTabstop) return 1;
        else if (b.isFinalTabstop) return -1;
        else if (a.index < b.index) return -1;
        else if (a.index > b.index) return 1;
        else return 0;
    }
    constructor(index){
        super();
        this.index = index;
    }
    get isFinalTabstop() {
        return this.index === 0;
    }
    get choice() {
        return this._children.length === 1 && this._children[0] instanceof Choice ? this._children[0] : undefined;
    }
    clone() {
        const ret = new Placeholder(this.index);
        if (this.transform) ret.transform = this.transform.clone();
        ret._children = this.children.map((child)=>child.clone());
        return ret;
    }
}
class Choice extends Marker {
    constructor(){
        super(...arguments);
        this.options = [];
    }
    appendChild(marker) {
        if (marker instanceof Text) {
            marker.parent = this;
            this.options.push(marker);
        }
        return this;
    }
    toString() {
        return this.options[0].value;
    }
    len() {
        return this.options[0].len();
    }
    clone() {
        const ret = new Choice();
        this.options.forEach(ret.appendChild, ret);
        return ret;
    }
}
class Transform extends Marker {
    constructor(){
        super(...arguments);
        this.regexp = new RegExp("");
    }
    resolve(value) {
        const _this = this;
        let didMatch = false;
        let ret = value.replace(this.regexp, function() {
            didMatch = true;
            return _this._replace(Array.prototype.slice.call(arguments, 0, -2));
        });
        // when the regex didn't match and when the transform has
        // else branches, then run those
        if (!didMatch && this._children.some((child)=>child instanceof FormatString && Boolean(child.elseValue))) ret = this._replace([]);
        return ret;
    }
    _replace(groups) {
        let ret = "";
        for (const marker of this._children)if (marker instanceof FormatString) {
            let value = groups[marker.index] || "";
            value = marker.resolve(value);
            ret += value;
        } else ret += marker.toString();
        return ret;
    }
    toString() {
        return "";
    }
    clone() {
        const ret = new Transform();
        ret.regexp = new RegExp(this.regexp.source, "" + (this.regexp.ignoreCase ? "i" : "") + (this.regexp.global ? "g" : ""));
        ret._children = this.children.map((child)=>child.clone());
        return ret;
    }
}
class FormatString extends Marker {
    constructor(index, shorthandName, ifValue, elseValue){
        super();
        this.index = index;
        this.shorthandName = shorthandName;
        this.ifValue = ifValue;
        this.elseValue = elseValue;
    }
    resolve(value) {
        if (this.shorthandName === "upcase") return !value ? "" : value.toLocaleUpperCase();
        else if (this.shorthandName === "downcase") return !value ? "" : value.toLocaleLowerCase();
        else if (this.shorthandName === "capitalize") return !value ? "" : value[0].toLocaleUpperCase() + value.substr(1);
        else if (this.shorthandName === "pascalcase") return !value ? "" : this._toPascalCase(value);
        else if (this.shorthandName === "camelcase") return !value ? "" : this._toCamelCase(value);
        else if (Boolean(value) && typeof this.ifValue === "string") return this.ifValue;
        else if (!Boolean(value) && typeof this.elseValue === "string") return this.elseValue;
        else return value || "";
    }
    _toPascalCase(value) {
        const match = value.match(/[a-z0-9]+/gi);
        if (!match) return value;
        return match.map((word)=>{
            return word.charAt(0).toUpperCase() + word.substr(1);
        }).join("");
    }
    _toCamelCase(value) {
        const match = value.match(/[a-z0-9]+/gi);
        if (!match) return value;
        return match.map((word, index)=>{
            if (index === 0) return word.charAt(0).toLowerCase() + word.substr(1);
            return word.charAt(0).toUpperCase() + word.substr(1);
        }).join("");
    }
    clone() {
        const ret = new FormatString(this.index, this.shorthandName, this.ifValue, this.elseValue);
        return ret;
    }
}
class Variable extends TransformableMarker {
    constructor(name){
        super();
        this.name = name;
    }
    resolve(resolver) {
        let value = resolver.resolve(this);
        if (this.transform) value = this.transform.resolve(value || "");
        if (value !== undefined) {
            this._children = [
                new Text(value)
            ];
            return true;
        }
        return false;
    }
    clone() {
        const ret = new Variable(this.name);
        if (this.transform) ret.transform = this.transform.clone();
        ret._children = this.children.map((child)=>child.clone());
        return ret;
    }
}
function walk(marker, visitor) {
    const stack = [
        ...marker
    ];
    while(stack.length > 0){
        const marker = stack.shift();
        const recurse = visitor(marker);
        if (!recurse) break;
        stack.unshift(...marker.children);
    }
}
class TextmateSnippet extends Marker {
    get placeholderInfo() {
        if (!this._placeholders) {
            // fill in placeholders
            const all = [];
            let last;
            this.walk(function(candidate) {
                if (candidate instanceof Placeholder) {
                    all.push(candidate);
                    last = !last || last.index < candidate.index ? candidate : last;
                }
                return true;
            });
            this._placeholders = {
                all,
                last
            };
        }
        return this._placeholders;
    }
    get placeholders() {
        const { all } = this.placeholderInfo;
        return all;
    }
    offset(marker) {
        let pos = 0;
        let found = false;
        this.walk((candidate)=>{
            if (candidate === marker) {
                found = true;
                return false;
            }
            pos += candidate.len();
            return true;
        });
        if (!found) return -1;
        return pos;
    }
    fullLen(marker) {
        let ret = 0;
        walk([
            marker
        ], (marker)=>{
            ret += marker.len();
            return true;
        });
        return ret;
    }
    enclosingPlaceholders(placeholder) {
        const ret = [];
        let { parent } = placeholder;
        while(parent){
            if (parent instanceof Placeholder) ret.push(parent);
            parent = parent.parent;
        }
        return ret;
    }
    resolveVariables(resolver) {
        this.walk((candidate)=>{
            if (candidate instanceof Variable) {
                if (candidate.resolve(resolver)) this._placeholders = undefined;
            }
            return true;
        });
        return this;
    }
    appendChild(child) {
        this._placeholders = undefined;
        return super.appendChild(child);
    }
    replace(child, others) {
        this._placeholders = undefined;
        return super.replace(child, others);
    }
    clone() {
        const ret = new TextmateSnippet();
        this._children = this.children.map((child)=>child.clone());
        return ret;
    }
    walk(visitor) {
        walk(this.children, visitor);
    }
}
class SnippetParser {
    constructor(){
        this._scanner = new Scanner();
        this._token = {
            type: 14 /* TokenType.EOF */ ,
            pos: 0,
            len: 0
        };
    }
    static escape(value) {
        return value.replace(/\$|}|\\/g, "\\$&");
    }
    static guessNeedsClipboard(template) {
        return /\${?CLIPBOARD/.test(template);
    }
    parse(value, insertFinalTabstop, enforceFinalTabstop) {
        const snippet = new TextmateSnippet();
        this.parseFragment(value, snippet);
        this.ensureFinalTabstop(snippet, enforceFinalTabstop ?? false, insertFinalTabstop ?? false);
        return snippet;
    }
    parseFragment(value, snippet) {
        const offset = snippet.children.length;
        this._scanner.text(value);
        this._token = this._scanner.next();
        while(this._parse(snippet));
        // fill in values for placeholders. the first placeholder of an index
        // that has a value defines the value for all placeholders with that index
        const placeholderDefaultValues = new Map();
        const incompletePlaceholders = [];
        snippet.walk((marker)=>{
            if (marker instanceof Placeholder) {
                if (marker.isFinalTabstop) placeholderDefaultValues.set(0, undefined);
                else if (!placeholderDefaultValues.has(marker.index) && marker.children.length > 0) placeholderDefaultValues.set(marker.index, marker.children);
                else incompletePlaceholders.push(marker);
            }
            return true;
        });
        const fillInIncompletePlaceholder = (placeholder, stack)=>{
            const defaultValues = placeholderDefaultValues.get(placeholder.index);
            if (!defaultValues) return;
            const clone = new Placeholder(placeholder.index);
            clone.transform = placeholder.transform;
            for (const child of defaultValues){
                const newChild = child.clone();
                clone.appendChild(newChild);
                // "recurse" on children that are again placeholders
                if (newChild instanceof Placeholder && placeholderDefaultValues.has(newChild.index) && !stack.has(newChild.index)) {
                    stack.add(newChild.index);
                    fillInIncompletePlaceholder(newChild, stack);
                    stack.delete(newChild.index);
                }
            }
            snippet.replace(placeholder, [
                clone
            ]);
        };
        const stack = new Set();
        for (const placeholder of incompletePlaceholders)fillInIncompletePlaceholder(placeholder, stack);
        return snippet.children.slice(offset);
    }
    ensureFinalTabstop(snippet, enforceFinalTabstop, insertFinalTabstop) {
        if (enforceFinalTabstop || insertFinalTabstop && snippet.placeholders.length > 0) {
            const finalTabstop = snippet.placeholders.find((p)=>p.index === 0);
            if (!finalTabstop) // the snippet uses placeholders but has no
            // final tabstop defined -> insert at the end
            snippet.appendChild(new Placeholder(0));
        }
    }
    _accept(type, value) {
        if (type === undefined || this._token.type === type) {
            const ret = !value ? true : this._scanner.tokenText(this._token);
            this._token = this._scanner.next();
            return ret;
        }
        return false;
    }
    _backTo(token) {
        this._scanner.pos = token.pos + token.len;
        this._token = token;
        return false;
    }
    _until(type) {
        const start = this._token;
        while(this._token.type !== type){
            if (this._token.type === 14 /* TokenType.EOF */ ) return false;
            else if (this._token.type === 5 /* TokenType.Backslash */ ) {
                const nextToken = this._scanner.next();
                if (nextToken.type !== 0 /* TokenType.Dollar */  && nextToken.type !== 4 /* TokenType.CurlyClose */  && nextToken.type !== 5 /* TokenType.Backslash */ ) return false;
            }
            this._token = this._scanner.next();
        }
        const value = this._scanner.value.substring(start.pos, this._token.pos).replace(/\\(\$|}|\\)/g, "$1");
        this._token = this._scanner.next();
        return value;
    }
    _parse(marker) {
        return this._parseEscaped(marker) || this._parseTabstopOrVariableName(marker) || this._parseComplexPlaceholder(marker) || this._parseComplexVariable(marker) || this._parseAnything(marker);
    }
    // \$, \\, \} -> just text
    _parseEscaped(marker) {
        let value;
        if (value = this._accept(5 /* TokenType.Backslash */ , true)) {
            // saw a backslash, append escaped token or that backslash
            value = this._accept(0 /* TokenType.Dollar */ , true) || this._accept(4 /* TokenType.CurlyClose */ , true) || this._accept(5 /* TokenType.Backslash */ , true) || value;
            marker.appendChild(new Text(value));
            return true;
        }
        return false;
    }
    // $foo -> variable, $1 -> tabstop
    _parseTabstopOrVariableName(parent) {
        let value;
        const token = this._token;
        const match = this._accept(0 /* TokenType.Dollar */ ) && (value = this._accept(9 /* TokenType.VariableName */ , true) || this._accept(8 /* TokenType.Int */ , true));
        if (!match) return this._backTo(token);
        parent.appendChild(/^\d+$/.test(value) ? new Placeholder(Number(value)) : new Variable(value));
        return true;
    }
    // ${1:<children>}, ${1} -> placeholder
    _parseComplexPlaceholder(parent) {
        let index;
        const token = this._token;
        const match = this._accept(0 /* TokenType.Dollar */ ) && this._accept(3 /* TokenType.CurlyOpen */ ) && (index = this._accept(8 /* TokenType.Int */ , true));
        if (!match) return this._backTo(token);
        const placeholder = new Placeholder(Number(index));
        if (this._accept(1 /* TokenType.Colon */ )) // ${1:<children>}
        while(true){
            // ...} -> done
            if (this._accept(4 /* TokenType.CurlyClose */ )) {
                parent.appendChild(placeholder);
                return true;
            }
            if (this._parse(placeholder)) continue;
            // fallback
            parent.appendChild(new Text("${" + index + ":"));
            placeholder.children.forEach(parent.appendChild, parent);
            return true;
        }
        else if (placeholder.index > 0 && this._accept(7 /* TokenType.Pipe */ )) {
            // ${1|one,two,three|}
            const choice = new Choice();
            while(true){
                if (this._parseChoiceElement(choice)) {
                    if (this._accept(2 /* TokenType.Comma */ )) continue;
                    if (this._accept(7 /* TokenType.Pipe */ )) {
                        placeholder.appendChild(choice);
                        if (this._accept(4 /* TokenType.CurlyClose */ )) {
                            // ..|} -> done
                            parent.appendChild(placeholder);
                            return true;
                        }
                    }
                }
                this._backTo(token);
                return false;
            }
        } else if (this._accept(6 /* TokenType.Forwardslash */ )) {
            // ${1/<regex>/<format>/<options>}
            if (this._parseTransform(placeholder)) {
                parent.appendChild(placeholder);
                return true;
            }
            this._backTo(token);
            return false;
        } else if (this._accept(4 /* TokenType.CurlyClose */ )) {
            // ${1}
            parent.appendChild(placeholder);
            return true;
        } else // ${1 <- missing curly or colon
        return this._backTo(token);
    }
    _parseChoiceElement(parent) {
        const token = this._token;
        const values = [];
        while(true){
            if (this._token.type === 2 /* TokenType.Comma */  || this._token.type === 7 /* TokenType.Pipe */ ) break;
            let value;
            if (value = this._accept(5 /* TokenType.Backslash */ , true)) // \, \|, or \\
            value = this._accept(2 /* TokenType.Comma */ , true) || this._accept(7 /* TokenType.Pipe */ , true) || this._accept(5 /* TokenType.Backslash */ , true) || value;
            else value = this._accept(undefined, true);
            if (!value) {
                // EOF
                this._backTo(token);
                return false;
            }
            values.push(value);
        }
        if (values.length === 0) {
            this._backTo(token);
            return false;
        }
        parent.appendChild(new Text(values.join("")));
        return true;
    }
    // ${foo:<children>}, ${foo} -> variable
    _parseComplexVariable(parent) {
        let name;
        const token = this._token;
        const match = this._accept(0 /* TokenType.Dollar */ ) && this._accept(3 /* TokenType.CurlyOpen */ ) && (name = this._accept(9 /* TokenType.VariableName */ , true));
        if (!match) return this._backTo(token);
        const variable = new Variable(name);
        if (this._accept(1 /* TokenType.Colon */ )) // ${foo:<children>}
        while(true){
            // ...} -> done
            if (this._accept(4 /* TokenType.CurlyClose */ )) {
                parent.appendChild(variable);
                return true;
            }
            if (this._parse(variable)) continue;
            // fallback
            parent.appendChild(new Text("${" + name + ":"));
            variable.children.forEach(parent.appendChild, parent);
            return true;
        }
        else if (this._accept(6 /* TokenType.Forwardslash */ )) {
            // ${foo/<regex>/<format>/<options>}
            if (this._parseTransform(variable)) {
                parent.appendChild(variable);
                return true;
            }
            this._backTo(token);
            return false;
        } else if (this._accept(4 /* TokenType.CurlyClose */ )) {
            // ${foo}
            parent.appendChild(variable);
            return true;
        } else // ${foo <- missing curly or colon
        return this._backTo(token);
    }
    _parseTransform(parent) {
        // ...<regex>/<format>/<options>}
        const transform = new Transform();
        let regexValue = "";
        let regexOptions = "";
        // (1) /regex
        while(true){
            if (this._accept(6 /* TokenType.Forwardslash */ )) break;
            let escaped;
            if (escaped = this._accept(5 /* TokenType.Backslash */ , true)) {
                escaped = this._accept(6 /* TokenType.Forwardslash */ , true) || escaped;
                regexValue += escaped;
                continue;
            }
            if (this._token.type !== 14 /* TokenType.EOF */ ) {
                regexValue += this._accept(undefined, true);
                continue;
            }
            return false;
        }
        // (2) /format
        while(true){
            if (this._accept(6 /* TokenType.Forwardslash */ )) break;
            let escaped;
            if (escaped = this._accept(5 /* TokenType.Backslash */ , true)) {
                escaped = this._accept(5 /* TokenType.Backslash */ , true) || this._accept(6 /* TokenType.Forwardslash */ , true) || escaped;
                transform.appendChild(new Text(escaped));
                continue;
            }
            if (this._parseFormatString(transform) || this._parseAnything(transform)) continue;
            return false;
        }
        // (3) /option
        while(true){
            if (this._accept(4 /* TokenType.CurlyClose */ )) break;
            if (this._token.type !== 14 /* TokenType.EOF */ ) {
                regexOptions += this._accept(undefined, true);
                continue;
            }
            return false;
        }
        try {
            transform.regexp = new RegExp(regexValue, regexOptions);
        } catch (e) {
            // invalid regexp
            return false;
        }
        parent.transform = transform;
        return true;
    }
    _parseFormatString(parent) {
        const token = this._token;
        if (!this._accept(0 /* TokenType.Dollar */ )) return false;
        let complex = false;
        if (this._accept(3 /* TokenType.CurlyOpen */ )) complex = true;
        const index = this._accept(8 /* TokenType.Int */ , true);
        if (!index) {
            this._backTo(token);
            return false;
        } else if (!complex) {
            // $1
            parent.appendChild(new FormatString(Number(index)));
            return true;
        } else if (this._accept(4 /* TokenType.CurlyClose */ )) {
            // ${1}
            parent.appendChild(new FormatString(Number(index)));
            return true;
        } else if (!this._accept(1 /* TokenType.Colon */ )) {
            this._backTo(token);
            return false;
        }
        if (this._accept(6 /* TokenType.Forwardslash */ )) {
            // ${1:/upcase}
            const shorthand = this._accept(9 /* TokenType.VariableName */ , true);
            if (!shorthand || !this._accept(4 /* TokenType.CurlyClose */ )) {
                this._backTo(token);
                return false;
            } else {
                parent.appendChild(new FormatString(Number(index), shorthand));
                return true;
            }
        } else if (this._accept(11 /* TokenType.Plus */ )) {
            // ${1:+<if>}
            const ifValue = this._until(4 /* TokenType.CurlyClose */ );
            if (ifValue) {
                parent.appendChild(new FormatString(Number(index), undefined, ifValue, undefined));
                return true;
            }
        } else if (this._accept(12 /* TokenType.Dash */ )) {
            // ${2:-<else>}
            const elseValue = this._until(4 /* TokenType.CurlyClose */ );
            if (elseValue) {
                parent.appendChild(new FormatString(Number(index), undefined, undefined, elseValue));
                return true;
            }
        } else if (this._accept(13 /* TokenType.QuestionMark */ )) {
            // ${2:?<if>:<else>}
            const ifValue = this._until(1 /* TokenType.Colon */ );
            if (ifValue) {
                const elseValue = this._until(4 /* TokenType.CurlyClose */ );
                if (elseValue) {
                    parent.appendChild(new FormatString(Number(index), undefined, ifValue, elseValue));
                    return true;
                }
            }
        } else {
            // ${1:<else>}
            const elseValue = this._until(4 /* TokenType.CurlyClose */ );
            if (elseValue) {
                parent.appendChild(new FormatString(Number(index), undefined, undefined, elseValue));
                return true;
            }
        }
        this._backTo(token);
        return false;
    }
    _parseAnything(marker) {
        if (this._token.type !== 14 /* TokenType.EOF */ ) {
            marker.appendChild(new Text(this._scanner.tokenText(this._token)));
            this._accept(undefined);
            return true;
        }
        return false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a5six":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineProgressManager", ()=>InlineProgressManager);
var _domJs = require("../../../../base/browser/dom.js");
var _asyncJs = require("../../../../base/common/async.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _themablesJs = require("../../../../base/common/themables.js");
var _inlineProgressWidgetCss = require("./inlineProgressWidget.css");
var _rangeJs = require("../../../common/core/range.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const inlineProgressDecoration = (0, _textModelJs.ModelDecorationOptions).register({
    description: "inline-progress-widget",
    stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
    showIfCollapsed: true,
    after: {
        content: (0, _stringsJs.noBreakWhitespace),
        inlineClassName: "inline-editor-progress-decoration",
        inlineClassNameAffectsLetterSpacing: true
    }
});
class InlineProgressWidget extends (0, _lifecycleJs.Disposable) {
    static{
        this.baseId = "editor.widget.inlineProgressWidget";
    }
    constructor(typeId, editor, range, title, delegate){
        super();
        this.typeId = typeId;
        this.editor = editor;
        this.range = range;
        this.delegate = delegate;
        this.allowEditorOverflow = false;
        this.suppressMouseDown = true;
        this.create(title);
        this.editor.addContentWidget(this);
        this.editor.layoutContentWidget(this);
    }
    create(title) {
        this.domNode = _domJs.$(".inline-progress-widget");
        this.domNode.role = "button";
        this.domNode.title = title;
        const iconElement = _domJs.$("span.icon");
        this.domNode.append(iconElement);
        iconElement.classList.add(...(0, _themablesJs.ThemeIcon).asClassNameArray((0, _codiconsJs.Codicon).loading), "codicon-modifier-spin");
        const updateSize = ()=>{
            const lineHeight = this.editor.getOption(67 /* EditorOption.lineHeight */ );
            this.domNode.style.height = `${lineHeight}px`;
            this.domNode.style.width = `${Math.ceil(0.8 * lineHeight)}px`;
        };
        updateSize();
        this._register(this.editor.onDidChangeConfiguration((c)=>{
            if (c.hasChanged(52 /* EditorOption.fontSize */ ) || c.hasChanged(67 /* EditorOption.lineHeight */ )) updateSize();
        }));
        this._register(_domJs.addDisposableListener(this.domNode, _domJs.EventType.CLICK, (e)=>{
            this.delegate.cancel();
        }));
    }
    getId() {
        return InlineProgressWidget.baseId + "." + this.typeId;
    }
    getDomNode() {
        return this.domNode;
    }
    getPosition() {
        return {
            position: {
                lineNumber: this.range.startLineNumber,
                column: this.range.startColumn
            },
            preference: [
                0 /* ContentWidgetPositionPreference.EXACT */ 
            ]
        };
    }
    dispose() {
        super.dispose();
        this.editor.removeContentWidget(this);
    }
}
let InlineProgressManager = class InlineProgressManager extends (0, _lifecycleJs.Disposable) {
    constructor(id, _editor, _instantiationService){
        super();
        this.id = id;
        this._editor = _editor;
        this._instantiationService = _instantiationService;
        /** Delay before showing the progress widget */ this._showDelay = 500; // ms
        this._showPromise = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this._currentWidget = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this._operationIdPool = 0;
        this._currentDecorations = _editor.createDecorationsCollection();
    }
    dispose() {
        super.dispose();
        this._currentDecorations.clear();
    }
    async showWhile(position, title, promise, delegate, delayOverride) {
        const operationId = this._operationIdPool++;
        this._currentOperation = operationId;
        this.clear();
        this._showPromise.value = (0, _asyncJs.disposableTimeout)(()=>{
            const range = (0, _rangeJs.Range).fromPositions(position);
            const decorationIds = this._currentDecorations.set([
                {
                    range: range,
                    options: inlineProgressDecoration
                }
            ]);
            if (decorationIds.length > 0) this._currentWidget.value = this._instantiationService.createInstance(InlineProgressWidget, this.id, this._editor, range, title, delegate);
        }, delayOverride ?? this._showDelay);
        try {
            return await promise;
        } finally{
            if (this._currentOperation === operationId) {
                this.clear();
                this._currentOperation = undefined;
            }
        }
    }
    clear() {
        this._showPromise.clear();
        this._currentDecorations.clear();
        this._currentWidget.clear();
    }
};
InlineProgressManager = __decorate([
    __param(2, (0, _instantiationJs.IInstantiationService))
], InlineProgressManager);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/async.js":"4GJc4","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/strings.js":"aA9I1","../../../../base/common/themables.js":"hgyHi","./inlineProgressWidget.css":"l6Prd","../../../common/core/range.js":"jmUPh","../../../common/model/textModel.js":"9beDe","../../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l6Prd":[function() {},{}],"7FZE5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MessageController", ()=>MessageController);
var _markdownRendererJs = require("../../../../base/browser/markdownRenderer.js");
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var _eventJs = require("../../../../base/common/event.js");
var _htmlContentJs = require("../../../../base/common/htmlContent.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _messageControllerCss = require("./messageController.css");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _rangeJs = require("../../../common/core/range.js");
var _markdownRendererJs1 = require("../../../browser/widget/markdownRenderer/browser/markdownRenderer.js");
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _openerJs = require("../../../../platform/opener/common/opener.js");
var _domJs = require("../../../../base/browser/dom.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var MessageController_1;
let MessageController = class MessageController {
    static{
        MessageController_1 = this;
    }
    static{
        this.ID = "editor.contrib.messageController";
    }
    static{
        this.MESSAGE_VISIBLE = new (0, _contextkeyJs.RawContextKey)("messageVisible", false, _nlsJs.localize("messageVisible", "Whether the editor is currently showing an inline message"));
    }
    static get(editor) {
        return editor.getContribution(MessageController_1.ID);
    }
    constructor(editor, contextKeyService, _openerService){
        this._openerService = _openerService;
        this._messageWidget = new (0, _lifecycleJs.MutableDisposable)();
        this._messageListeners = new (0, _lifecycleJs.DisposableStore)();
        this._mouseOverMessage = false;
        this._editor = editor;
        this._visible = MessageController_1.MESSAGE_VISIBLE.bindTo(contextKeyService);
    }
    dispose() {
        this._message?.dispose();
        this._messageListeners.dispose();
        this._messageWidget.dispose();
        this._visible.reset();
    }
    showMessage(message, position) {
        (0, _ariaJs.alert)((0, _htmlContentJs.isMarkdownString)(message) ? message.value : message);
        this._visible.set(true);
        this._messageWidget.clear();
        this._messageListeners.clear();
        this._message = (0, _htmlContentJs.isMarkdownString)(message) ? (0, _markdownRendererJs.renderMarkdown)(message, {
            actionHandler: {
                callback: (url)=>{
                    this.closeMessage();
                    (0, _markdownRendererJs1.openLinkFromMarkdown)(this._openerService, url, (0, _htmlContentJs.isMarkdownString)(message) ? message.isTrusted : undefined);
                },
                disposables: this._messageListeners
            }
        }) : undefined;
        this._messageWidget.value = new MessageWidget(this._editor, position, typeof message === "string" ? message : this._message.element);
        // close on blur (debounced to allow to tab into the message), cursor, model change, dispose
        this._messageListeners.add((0, _eventJs.Event).debounce(this._editor.onDidBlurEditorText, (last, event)=>event, 0)(()=>{
            if (this._mouseOverMessage) return; // override when mouse over message
            if (this._messageWidget.value && _domJs.isAncestor(_domJs.getActiveElement(), this._messageWidget.value.getDomNode())) return; // override when focus is inside the message
            this.closeMessage();
        }));
        this._messageListeners.add(this._editor.onDidChangeCursorPosition(()=>this.closeMessage()));
        this._messageListeners.add(this._editor.onDidDispose(()=>this.closeMessage()));
        this._messageListeners.add(this._editor.onDidChangeModel(()=>this.closeMessage()));
        this._messageListeners.add(_domJs.addDisposableListener(this._messageWidget.value.getDomNode(), _domJs.EventType.MOUSE_ENTER, ()=>this._mouseOverMessage = true, true));
        this._messageListeners.add(_domJs.addDisposableListener(this._messageWidget.value.getDomNode(), _domJs.EventType.MOUSE_LEAVE, ()=>this._mouseOverMessage = false, true));
        // close on mouse move
        let bounds;
        this._messageListeners.add(this._editor.onMouseMove((e)=>{
            // outside the text area
            if (!e.target.position) return;
            if (!bounds) // define bounding box around position and first mouse occurance
            bounds = new (0, _rangeJs.Range)(position.lineNumber - 3, 1, e.target.position.lineNumber + 3, 1);
            else if (!bounds.containsPosition(e.target.position)) // check if position is still in bounds
            this.closeMessage();
        }));
    }
    closeMessage() {
        this._visible.reset();
        this._messageListeners.clear();
        if (this._messageWidget.value) this._messageListeners.add(MessageWidget.fadeOut(this._messageWidget.value));
    }
};
MessageController = MessageController_1 = __decorate([
    __param(1, (0, _contextkeyJs.IContextKeyService)),
    __param(2, (0, _openerJs.IOpenerService))
], MessageController);
const MessageCommand = (0, _editorExtensionsJs.EditorCommand).bindToContribution(MessageController.get);
(0, _editorExtensionsJs.registerEditorCommand)(new MessageCommand({
    id: "leaveEditorMessage",
    precondition: MessageController.MESSAGE_VISIBLE,
    handler: (c)=>c.closeMessage(),
    kbOpts: {
        weight: 130,
        primary: 9 /* KeyCode.Escape */ 
    }
}));
class MessageWidget {
    static fadeOut(messageWidget) {
        const dispose = ()=>{
            messageWidget.dispose();
            clearTimeout(handle);
            messageWidget.getDomNode().removeEventListener("animationend", dispose);
        };
        const handle = setTimeout(dispose, 110);
        messageWidget.getDomNode().addEventListener("animationend", dispose);
        messageWidget.getDomNode().classList.add("fadeOut");
        return {
            dispose
        };
    }
    constructor(editor, { lineNumber, column }, text){
        // Editor.IContentWidget.allowEditorOverflow
        this.allowEditorOverflow = true;
        this.suppressMouseDown = false;
        this._editor = editor;
        this._editor.revealLinesInCenterIfOutsideViewport(lineNumber, lineNumber, 0 /* ScrollType.Smooth */ );
        this._position = {
            lineNumber,
            column
        };
        this._domNode = document.createElement("div");
        this._domNode.classList.add("monaco-editor-overlaymessage");
        this._domNode.style.marginLeft = "-6px";
        const anchorTop = document.createElement("div");
        anchorTop.classList.add("anchor", "top");
        this._domNode.appendChild(anchorTop);
        const message = document.createElement("div");
        if (typeof text === "string") {
            message.classList.add("message");
            message.textContent = text;
        } else {
            text.classList.add("message");
            message.appendChild(text);
        }
        this._domNode.appendChild(message);
        const anchorBottom = document.createElement("div");
        anchorBottom.classList.add("anchor", "below");
        this._domNode.appendChild(anchorBottom);
        this._editor.addContentWidget(this);
        this._domNode.classList.add("fadeIn");
    }
    dispose() {
        this._editor.removeContentWidget(this);
    }
    getId() {
        return "messageoverlay";
    }
    getDomNode() {
        return this._domNode;
    }
    getPosition() {
        return {
            position: this._position,
            preference: [
                1 /* ContentWidgetPositionPreference.ABOVE */ ,
                2 /* ContentWidgetPositionPreference.BELOW */ 
            ],
            positionAffinity: 1 /* PositionAffinity.Right */ 
        };
    }
    afterRender(position) {
        this._domNode.classList.toggle("below", position === 2 /* ContentWidgetPositionPreference.BELOW */ );
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(MessageController.ID, MessageController, 4 /* EditorContributionInstantiation.Lazy */ );

},{"../../../../base/browser/markdownRenderer.js":"3fw7s","../../../../base/browser/ui/aria/aria.js":"asrsh","../../../../base/common/event.js":"4Zi8b","../../../../base/common/htmlContent.js":"3Hxzm","../../../../base/common/lifecycle.js":"9kg8d","./messageController.css":"eXntn","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/range.js":"jmUPh","../../../browser/widget/markdownRenderer/browser/markdownRenderer.js":"34xfZ","../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/opener/common/opener.js":"d3tj1","../../../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eXntn":[function() {},{}],"64EIp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PostEditWidgetManager", ()=>PostEditWidgetManager);
var _domJs = require("../../../../base/browser/dom.js");
var _buttonJs = require("../../../../base/browser/ui/button/button.js");
var _actionsJs = require("../../../../base/common/actions.js");
var _errorMessageJs = require("../../../../base/common/errorMessage.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _postEditWidgetCss = require("./postEditWidget.css");
var _bulkEditServiceJs = require("../../../browser/services/bulkEditService.js");
var _editJs = require("./edit.js");
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _contextViewJs = require("../../../../platform/contextview/browser/contextView.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var PostEditWidget_1;
let PostEditWidget = class PostEditWidget extends (0, _lifecycleJs.Disposable) {
    static{
        PostEditWidget_1 = this;
    }
    static{
        this.baseId = "editor.widget.postEditWidget";
    }
    constructor(typeId, editor, visibleContext, showCommand, range, edits, onSelectNewEdit, _contextMenuService, contextKeyService, _keybindingService){
        super();
        this.typeId = typeId;
        this.editor = editor;
        this.showCommand = showCommand;
        this.range = range;
        this.edits = edits;
        this.onSelectNewEdit = onSelectNewEdit;
        this._contextMenuService = _contextMenuService;
        this._keybindingService = _keybindingService;
        this.allowEditorOverflow = true;
        this.suppressMouseDown = true;
        this.create();
        this.visibleContext = visibleContext.bindTo(contextKeyService);
        this.visibleContext.set(true);
        this._register((0, _lifecycleJs.toDisposable)(()=>this.visibleContext.reset()));
        this.editor.addContentWidget(this);
        this.editor.layoutContentWidget(this);
        this._register((0, _lifecycleJs.toDisposable)(()=>this.editor.removeContentWidget(this)));
        this._register(this.editor.onDidChangeCursorPosition((e)=>{
            if (!range.containsPosition(e.position)) this.dispose();
        }));
        this._register((0, _eventJs.Event).runAndSubscribe(_keybindingService.onDidUpdateKeybindings, ()=>{
            this._updateButtonTitle();
        }));
    }
    _updateButtonTitle() {
        const binding = this._keybindingService.lookupKeybinding(this.showCommand.id)?.getLabel();
        this.button.element.title = this.showCommand.label + (binding ? ` (${binding})` : "");
    }
    create() {
        this.domNode = _domJs.$(".post-edit-widget");
        this.button = this._register(new (0, _buttonJs.Button)(this.domNode, {
            supportIcons: true
        }));
        this.button.label = "$(insert)";
        this._register(_domJs.addDisposableListener(this.domNode, _domJs.EventType.CLICK, ()=>this.showSelector()));
    }
    getId() {
        return PostEditWidget_1.baseId + "." + this.typeId;
    }
    getDomNode() {
        return this.domNode;
    }
    getPosition() {
        return {
            position: this.range.getEndPosition(),
            preference: [
                2 /* ContentWidgetPositionPreference.BELOW */ 
            ]
        };
    }
    showSelector() {
        this._contextMenuService.showContextMenu({
            getAnchor: ()=>{
                const pos = _domJs.getDomNodePagePosition(this.button.element);
                return {
                    x: pos.left + pos.width,
                    y: pos.top + pos.height
                };
            },
            getActions: ()=>{
                return this.edits.allEdits.map((edit, i)=>(0, _actionsJs.toAction)({
                        id: "",
                        label: edit.title,
                        checked: i === this.edits.activeEditIndex,
                        run: ()=>{
                            if (i !== this.edits.activeEditIndex) return this.onSelectNewEdit(i);
                        }
                    }));
            }
        });
    }
};
PostEditWidget = PostEditWidget_1 = __decorate([
    __param(7, (0, _contextViewJs.IContextMenuService)),
    __param(8, (0, _contextkeyJs.IContextKeyService)),
    __param(9, (0, _keybindingJs.IKeybindingService))
], PostEditWidget);
let PostEditWidgetManager = class PostEditWidgetManager extends (0, _lifecycleJs.Disposable) {
    constructor(_id, _editor, _visibleContext, _showCommand, _instantiationService, _bulkEditService, _notificationService){
        super();
        this._id = _id;
        this._editor = _editor;
        this._visibleContext = _visibleContext;
        this._showCommand = _showCommand;
        this._instantiationService = _instantiationService;
        this._bulkEditService = _bulkEditService;
        this._notificationService = _notificationService;
        this._currentWidget = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this._register((0, _eventJs.Event).any(_editor.onDidChangeModel, _editor.onDidChangeModelContent)(()=>this.clear()));
    }
    async applyEditAndShowIfNeeded(ranges, edits, canShowWidget, resolve, token) {
        const model = this._editor.getModel();
        if (!model || !ranges.length) return;
        const edit = edits.allEdits.at(edits.activeEditIndex);
        if (!edit) return;
        const onDidSelectEdit = async (newEditIndex)=>{
            const model = this._editor.getModel();
            if (!model) return;
            await model.undo();
            this.applyEditAndShowIfNeeded(ranges, {
                activeEditIndex: newEditIndex,
                allEdits: edits.allEdits
            }, canShowWidget, resolve, token);
        };
        const handleError = (e, message)=>{
            if ((0, _errorsJs.isCancellationError)(e)) return;
            this._notificationService.error(message);
            if (canShowWidget) this.show(ranges[0], edits, onDidSelectEdit);
        };
        let resolvedEdit;
        try {
            resolvedEdit = await resolve(edit, token);
        } catch (e) {
            return handleError(e, (0, _nlsJs.localize)("resolveError", "Error resolving edit '{0}':\n{1}", edit.title, (0, _errorMessageJs.toErrorMessage)(e)));
        }
        if (token.isCancellationRequested) return;
        const combinedWorkspaceEdit = (0, _editJs.createCombinedWorkspaceEdit)(model.uri, ranges, resolvedEdit);
        // Use a decoration to track edits around the trigger range
        const primaryRange = ranges[0];
        const editTrackingDecoration = model.deltaDecorations([], [
            {
                range: primaryRange,
                options: {
                    description: "paste-line-suffix",
                    stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ 
                }
            }
        ]);
        this._editor.focus();
        let editResult;
        let editRange;
        try {
            editResult = await this._bulkEditService.apply(combinedWorkspaceEdit, {
                editor: this._editor,
                token
            });
            editRange = model.getDecorationRange(editTrackingDecoration[0]);
        } catch (e) {
            return handleError(e, (0, _nlsJs.localize)("applyError", "Error applying edit '{0}':\n{1}", edit.title, (0, _errorMessageJs.toErrorMessage)(e)));
        } finally{
            model.deltaDecorations(editTrackingDecoration, []);
        }
        if (token.isCancellationRequested) return;
        if (canShowWidget && editResult.isApplied && edits.allEdits.length > 1) this.show(editRange ?? primaryRange, edits, onDidSelectEdit);
    }
    show(range, edits, onDidSelectEdit) {
        this.clear();
        if (this._editor.hasModel()) this._currentWidget.value = this._instantiationService.createInstance(PostEditWidget, this._id, this._editor, this._visibleContext, this._showCommand, range, edits, onDidSelectEdit);
    }
    clear() {
        this._currentWidget.clear();
    }
    tryShowSelector() {
        this._currentWidget.value?.showSelector();
    }
};
PostEditWidgetManager = __decorate([
    __param(4, (0, _instantiationJs.IInstantiationService)),
    __param(5, (0, _bulkEditServiceJs.IBulkEditService)),
    __param(6, (0, _notificationJs.INotificationService))
], PostEditWidgetManager);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/button/button.js":"fmbgq","../../../../base/common/actions.js":"5GjLb","../../../../base/common/errorMessage.js":"3JHUv","../../../../base/common/errors.js":"divX8","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","./postEditWidget.css":"elfif","../../../browser/services/bulkEditService.js":"fLMRG","./edit.js":"fZ737","../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/contextview/browser/contextView.js":"2QlUR","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../platform/notification/common/notification.js":"igv0W","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3JHUv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Tries to generate a human readable error message out of the error. If the verbose parameter
 * is set to true, the error message will include stacktrace details if provided.
 *
 * @returns A string containing the error message.
 */ parcelHelpers.export(exports, "toErrorMessage", ()=>toErrorMessage);
var _arraysJs = require("./arrays.js");
var _typesJs = require("./types.js");
var _nlsJs = require("../../nls.js");
function exceptionToErrorMessage(exception, verbose) {
    if (verbose && (exception.stack || exception.stacktrace)) return _nlsJs.localize("stackTrace.format", "{0}: {1}", detectSystemErrorMessage(exception), stackToString(exception.stack) || stackToString(exception.stacktrace));
    return detectSystemErrorMessage(exception);
}
function stackToString(stack) {
    if (Array.isArray(stack)) return stack.join("\n");
    return stack;
}
function detectSystemErrorMessage(exception) {
    // Custom node.js error from us
    if (exception.code === "ERR_UNC_HOST_NOT_ALLOWED") return `${exception.message}. Please update the 'security.allowedUNCHosts' setting if you want to allow this host.`;
    // See https://nodejs.org/api/errors.html#errors_class_system_error
    if (typeof exception.code === "string" && typeof exception.errno === "number" && typeof exception.syscall === "string") return _nlsJs.localize("nodeExceptionMessage", "A system error occurred ({0})", exception.message);
    return exception.message || _nlsJs.localize("error.defaultMessage", "An unknown error occurred. Please consult the log for more details.");
}
function toErrorMessage(error = null, verbose = false) {
    if (!error) return _nlsJs.localize("error.defaultMessage", "An unknown error occurred. Please consult the log for more details.");
    if (Array.isArray(error)) {
        const errors = _arraysJs.coalesce(error);
        const msg = toErrorMessage(errors[0], verbose);
        if (errors.length > 1) return _nlsJs.localize("error.moreErrors", "{0} ({1} errors in total)", msg, errors.length);
        return msg;
    }
    if (_typesJs.isString(error)) return error;
    if (error.detail) {
        const detail = error.detail;
        if (detail.error) return exceptionToErrorMessage(detail.error, verbose);
        if (detail.exception) return exceptionToErrorMessage(detail.exception, verbose);
    }
    if (error.stack) return exceptionToErrorMessage(error, verbose);
    if (error.message) return error.message;
    return _nlsJs.localize("error.defaultMessage", "An unknown error occurred. Please consult the log for more details.");
}

},{"./arrays.js":"DECei","./types.js":"fb5yx","../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"elfif":[function() {},{}],"8D9IZ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorConfigurationSchemaJs = require("../../../common/config/editorConfigurationSchema.js");
var _codeActionCommandsJs = require("./codeActionCommands.js");
var _codeActionControllerJs = require("./codeActionController.js");
var _lightBulbWidgetJs = require("./lightBulbWidget.js");
var _nlsJs = require("../../../../nls.js");
var _configurationRegistryJs = require("../../../../platform/configuration/common/configurationRegistry.js");
var _platformJs = require("../../../../platform/registry/common/platform.js");
(0, _editorExtensionsJs.registerEditorContribution)((0, _codeActionControllerJs.CodeActionController).ID, (0, _codeActionControllerJs.CodeActionController), 3 /* EditorContributionInstantiation.Eventually */ );
(0, _editorExtensionsJs.registerEditorContribution)((0, _lightBulbWidgetJs.LightBulbWidget).ID, (0, _lightBulbWidgetJs.LightBulbWidget), 4 /* EditorContributionInstantiation.Lazy */ );
(0, _editorExtensionsJs.registerEditorAction)((0, _codeActionCommandsJs.QuickFixAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _codeActionCommandsJs.RefactorAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _codeActionCommandsJs.SourceAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _codeActionCommandsJs.OrganizeImportsAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _codeActionCommandsJs.AutoFixAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _codeActionCommandsJs.FixAllAction));
(0, _editorExtensionsJs.registerEditorCommand)(new (0, _codeActionCommandsJs.CodeActionCommand)());
(0, _platformJs.Registry).as((0, _configurationRegistryJs.Extensions).Configuration).registerConfiguration({
    ...(0, _editorConfigurationSchemaJs.editorConfigurationBaseNode),
    properties: {
        "editor.codeActionWidget.showHeaders": {
            type: "boolean",
            scope: 5 /* ConfigurationScope.LANGUAGE_OVERRIDABLE */ ,
            description: _nlsJs.localize("showCodeActionHeaders", "Enable/disable showing group headers in the Code Action menu."),
            default: true
        }
    }
});
(0, _platformJs.Registry).as((0, _configurationRegistryJs.Extensions).Configuration).registerConfiguration({
    ...(0, _editorConfigurationSchemaJs.editorConfigurationBaseNode),
    properties: {
        "editor.codeActionWidget.includeNearbyQuickFixes": {
            type: "boolean",
            scope: 5 /* ConfigurationScope.LANGUAGE_OVERRIDABLE */ ,
            description: _nlsJs.localize("includeNearbyQuickFixes", "Enable/disable showing nearest Quick Fix within a line when not currently on a diagnostic."),
            default: true
        }
    }
});
(0, _platformJs.Registry).as((0, _configurationRegistryJs.Extensions).Configuration).registerConfiguration({
    ...(0, _editorConfigurationSchemaJs.editorConfigurationBaseNode),
    properties: {
        "editor.codeActions.triggerOnFocusChange": {
            type: "boolean",
            scope: 5 /* ConfigurationScope.LANGUAGE_OVERRIDABLE */ ,
            markdownDescription: _nlsJs.localize("triggerOnFocusChange", "Enable triggering {0} when {1} is set to {2}. Code Actions must be set to {3} to be triggered for window and focus changes.", "`#editor.codeActionsOnSave#`", "`#files.autoSave#`", "`afterDelay`", "`always`"),
            default: false
        }
    }
});

},{"../../../browser/editorExtensions.js":"kC3w6","../../../common/config/editorConfigurationSchema.js":"18Zc9","./codeActionCommands.js":"cB37M","./codeActionController.js":"bCH7J","./lightBulbWidget.js":"aR2pb","../../../../nls.js":"l617d","../../../../platform/configuration/common/configurationRegistry.js":"6y4yB","../../../../platform/registry/common/platform.js":"dzx11"}],"cB37M":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuickFixAction", ()=>QuickFixAction);
parcelHelpers.export(exports, "CodeActionCommand", ()=>CodeActionCommand);
parcelHelpers.export(exports, "RefactorAction", ()=>RefactorAction);
parcelHelpers.export(exports, "SourceAction", ()=>SourceAction);
parcelHelpers.export(exports, "OrganizeImportsAction", ()=>OrganizeImportsAction);
parcelHelpers.export(exports, "FixAllAction", ()=>FixAllAction);
parcelHelpers.export(exports, "AutoFixAction", ()=>AutoFixAction);
var _hierarchicalKindJs = require("../../../../base/common/hierarchicalKind.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _codeActionJs = require("./codeAction.js");
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _typesJs = require("../common/types.js");
var _codeActionControllerJs = require("./codeActionController.js");
var _codeActionModelJs = require("./codeActionModel.js");
function contextKeyForSupportedActions(kind) {
    return (0, _contextkeyJs.ContextKeyExpr).regex((0, _codeActionModelJs.SUPPORTED_CODE_ACTIONS).keys()[0], new RegExp("(\\s|^)" + (0, _stringsJs.escapeRegExpCharacters)(kind.value) + "\\b"));
}
const argsSchema = {
    type: "object",
    defaultSnippets: [
        {
            body: {
                kind: ""
            }
        }
    ],
    properties: {
        "kind": {
            type: "string",
            description: _nlsJs.localize("args.schema.kind", "Kind of the code action to run.")
        },
        "apply": {
            type: "string",
            description: _nlsJs.localize("args.schema.apply", "Controls when the returned actions are applied."),
            default: "ifSingle" /* CodeActionAutoApply.IfSingle */ ,
            enum: [
                "first" /* CodeActionAutoApply.First */ ,
                "ifSingle" /* CodeActionAutoApply.IfSingle */ ,
                "never" /* CodeActionAutoApply.Never */ 
            ],
            enumDescriptions: [
                _nlsJs.localize("args.schema.apply.first", "Always apply the first returned code action."),
                _nlsJs.localize("args.schema.apply.ifSingle", "Apply the first returned code action if it is the only one."),
                _nlsJs.localize("args.schema.apply.never", "Do not apply the returned code actions.")
            ]
        },
        "preferred": {
            type: "boolean",
            default: false,
            description: _nlsJs.localize("args.schema.preferred", "Controls if only preferred code actions should be returned.")
        }
    }
};
function triggerCodeActionsForEditorSelection(editor, notAvailableMessage, filter, autoApply, triggerAction = (0, _typesJs.CodeActionTriggerSource).Default) {
    if (editor.hasModel()) {
        const controller = (0, _codeActionControllerJs.CodeActionController).get(editor);
        controller?.manualTriggerAtCurrentPosition(notAvailableMessage, triggerAction, filter, autoApply);
    }
}
class QuickFixAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _codeActionJs.quickFixCommandId),
            label: _nlsJs.localize("quickfix.trigger.label", "Quick Fix..."),
            alias: "Quick Fix...",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _editorContextKeysJs.EditorContextKeys).hasCodeActionsProvider),
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 2137 /* KeyCode.Period */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(_accessor, editor) {
        return triggerCodeActionsForEditorSelection(editor, _nlsJs.localize("editor.action.quickFix.noneMessage", "No code actions available"), undefined, undefined, (0, _typesJs.CodeActionTriggerSource).QuickFix);
    }
}
class CodeActionCommand extends (0, _editorExtensionsJs.EditorCommand) {
    constructor(){
        super({
            id: (0, _codeActionJs.codeActionCommandId),
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _editorContextKeysJs.EditorContextKeys).hasCodeActionsProvider),
            metadata: {
                description: "Trigger a code action",
                args: [
                    {
                        name: "args",
                        schema: argsSchema
                    }
                ]
            }
        });
    }
    runEditorCommand(_accessor, editor, userArgs) {
        const args = (0, _typesJs.CodeActionCommandArgs).fromUser(userArgs, {
            kind: (0, _hierarchicalKindJs.HierarchicalKind).Empty,
            apply: "ifSingle" /* CodeActionAutoApply.IfSingle */ 
        });
        return triggerCodeActionsForEditorSelection(editor, typeof userArgs?.kind === "string" ? args.preferred ? _nlsJs.localize("editor.action.codeAction.noneMessage.preferred.kind", "No preferred code actions for '{0}' available", userArgs.kind) : _nlsJs.localize("editor.action.codeAction.noneMessage.kind", "No code actions for '{0}' available", userArgs.kind) : args.preferred ? _nlsJs.localize("editor.action.codeAction.noneMessage.preferred", "No preferred code actions available") : _nlsJs.localize("editor.action.codeAction.noneMessage", "No code actions available"), {
            include: args.kind,
            includeSourceActions: true,
            onlyIncludePreferredActions: args.preferred
        }, args.apply);
    }
}
class RefactorAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _codeActionJs.refactorCommandId),
            label: _nlsJs.localize("refactor.label", "Refactor..."),
            alias: "Refactor...",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _editorContextKeysJs.EditorContextKeys).hasCodeActionsProvider),
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 3120 /* KeyCode.KeyR */ ,
                mac: {
                    primary: 1328 /* KeyCode.KeyR */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            contextMenuOpts: {
                group: "1_modification",
                order: 2,
                when: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, contextKeyForSupportedActions((0, _typesJs.CodeActionKind).Refactor))
            },
            metadata: {
                description: "Refactor...",
                args: [
                    {
                        name: "args",
                        schema: argsSchema
                    }
                ]
            }
        });
    }
    run(_accessor, editor, userArgs) {
        const args = (0, _typesJs.CodeActionCommandArgs).fromUser(userArgs, {
            kind: (0, _typesJs.CodeActionKind).Refactor,
            apply: "never" /* CodeActionAutoApply.Never */ 
        });
        return triggerCodeActionsForEditorSelection(editor, typeof userArgs?.kind === "string" ? args.preferred ? _nlsJs.localize("editor.action.refactor.noneMessage.preferred.kind", "No preferred refactorings for '{0}' available", userArgs.kind) : _nlsJs.localize("editor.action.refactor.noneMessage.kind", "No refactorings for '{0}' available", userArgs.kind) : args.preferred ? _nlsJs.localize("editor.action.refactor.noneMessage.preferred", "No preferred refactorings available") : _nlsJs.localize("editor.action.refactor.noneMessage", "No refactorings available"), {
            include: (0, _typesJs.CodeActionKind).Refactor.contains(args.kind) ? args.kind : (0, _hierarchicalKindJs.HierarchicalKind).None,
            onlyIncludePreferredActions: args.preferred
        }, args.apply, (0, _typesJs.CodeActionTriggerSource).Refactor);
    }
}
class SourceAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _codeActionJs.sourceActionCommandId),
            label: _nlsJs.localize("source.label", "Source Action..."),
            alias: "Source Action...",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _editorContextKeysJs.EditorContextKeys).hasCodeActionsProvider),
            contextMenuOpts: {
                group: "1_modification",
                order: 2.1,
                when: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, contextKeyForSupportedActions((0, _typesJs.CodeActionKind).Source))
            },
            metadata: {
                description: "Source Action...",
                args: [
                    {
                        name: "args",
                        schema: argsSchema
                    }
                ]
            }
        });
    }
    run(_accessor, editor, userArgs) {
        const args = (0, _typesJs.CodeActionCommandArgs).fromUser(userArgs, {
            kind: (0, _typesJs.CodeActionKind).Source,
            apply: "never" /* CodeActionAutoApply.Never */ 
        });
        return triggerCodeActionsForEditorSelection(editor, typeof userArgs?.kind === "string" ? args.preferred ? _nlsJs.localize("editor.action.source.noneMessage.preferred.kind", "No preferred source actions for '{0}' available", userArgs.kind) : _nlsJs.localize("editor.action.source.noneMessage.kind", "No source actions for '{0}' available", userArgs.kind) : args.preferred ? _nlsJs.localize("editor.action.source.noneMessage.preferred", "No preferred source actions available") : _nlsJs.localize("editor.action.source.noneMessage", "No source actions available"), {
            include: (0, _typesJs.CodeActionKind).Source.contains(args.kind) ? args.kind : (0, _hierarchicalKindJs.HierarchicalKind).None,
            includeSourceActions: true,
            onlyIncludePreferredActions: args.preferred
        }, args.apply, (0, _typesJs.CodeActionTriggerSource).SourceAction);
    }
}
class OrganizeImportsAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _codeActionJs.organizeImportsCommandId),
            label: _nlsJs.localize("organizeImports.label", "Organize Imports"),
            alias: "Organize Imports",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, contextKeyForSupportedActions((0, _typesJs.CodeActionKind).SourceOrganizeImports)),
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 1581 /* KeyCode.KeyO */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(_accessor, editor) {
        return triggerCodeActionsForEditorSelection(editor, _nlsJs.localize("editor.action.organize.noneMessage", "No organize imports action available"), {
            include: (0, _typesJs.CodeActionKind).SourceOrganizeImports,
            includeSourceActions: true
        }, "ifSingle" /* CodeActionAutoApply.IfSingle */ , (0, _typesJs.CodeActionTriggerSource).OrganizeImports);
    }
}
class FixAllAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _codeActionJs.fixAllCommandId),
            label: _nlsJs.localize("fixAll.label", "Fix All"),
            alias: "Fix All",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, contextKeyForSupportedActions((0, _typesJs.CodeActionKind).SourceFixAll))
        });
    }
    run(_accessor, editor) {
        return triggerCodeActionsForEditorSelection(editor, _nlsJs.localize("fixAll.noneMessage", "No fix all action available"), {
            include: (0, _typesJs.CodeActionKind).SourceFixAll,
            includeSourceActions: true
        }, "ifSingle" /* CodeActionAutoApply.IfSingle */ , (0, _typesJs.CodeActionTriggerSource).FixAll);
    }
}
class AutoFixAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _codeActionJs.autoFixCommandId),
            label: _nlsJs.localize("autoFix.label", "Auto Fix..."),
            alias: "Auto Fix...",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, contextKeyForSupportedActions((0, _typesJs.CodeActionKind).QuickFix)),
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 1625 /* KeyCode.Period */ ,
                mac: {
                    primary: 2649 /* KeyCode.Period */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(_accessor, editor) {
        return triggerCodeActionsForEditorSelection(editor, _nlsJs.localize("editor.action.autoFix.noneMessage", "No auto fixes available"), {
            include: (0, _typesJs.CodeActionKind).QuickFix,
            onlyIncludePreferredActions: true
        }, "ifSingle" /* CodeActionAutoApply.IfSingle */ , (0, _typesJs.CodeActionTriggerSource).AutoFix);
    }
}

},{"../../../../base/common/hierarchicalKind.js":"eXua8","../../../../base/common/strings.js":"aA9I1","../../../browser/editorExtensions.js":"kC3w6","../../../common/editorContextKeys.js":"5exv9","./codeAction.js":"6jIB5","../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../common/types.js":"jJnno","./codeActionController.js":"bCH7J","./codeActionModel.js":"8KDSO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6jIB5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "codeActionCommandId", ()=>codeActionCommandId);
parcelHelpers.export(exports, "quickFixCommandId", ()=>quickFixCommandId);
parcelHelpers.export(exports, "autoFixCommandId", ()=>autoFixCommandId);
parcelHelpers.export(exports, "refactorCommandId", ()=>refactorCommandId);
parcelHelpers.export(exports, "sourceActionCommandId", ()=>sourceActionCommandId);
parcelHelpers.export(exports, "organizeImportsCommandId", ()=>organizeImportsCommandId);
parcelHelpers.export(exports, "fixAllCommandId", ()=>fixAllCommandId);
parcelHelpers.export(exports, "getCodeActions", ()=>getCodeActions);
parcelHelpers.export(exports, "ApplyCodeActionReason", ()=>ApplyCodeActionReason);
parcelHelpers.export(exports, "applyCodeAction", ()=>applyCodeAction);
var _arraysJs = require("../../../../base/common/arrays.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _uriJs = require("../../../../base/common/uri.js");
var _bulkEditServiceJs = require("../../../browser/services/bulkEditService.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _modelJs = require("../../../common/services/model.js");
var _editorStateJs = require("../../editorState/browser/editorState.js");
var _nlsJs = require("../../../../nls.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var _progressJs = require("../../../../platform/progress/common/progress.js");
var _telemetryJs = require("../../../../platform/telemetry/common/telemetry.js");
var _typesJs = require("../common/types.js");
var _hierarchicalKindJs = require("../../../../base/common/hierarchicalKind.js");
const codeActionCommandId = "editor.action.codeAction";
const quickFixCommandId = "editor.action.quickFix";
const autoFixCommandId = "editor.action.autoFix";
const refactorCommandId = "editor.action.refactor";
const sourceActionCommandId = "editor.action.sourceAction";
const organizeImportsCommandId = "editor.action.organizeImports";
const fixAllCommandId = "editor.action.fixAll";
class ManagedCodeActionSet extends (0, _lifecycleJs.Disposable) {
    static codeActionsPreferredComparator(a, b) {
        if (a.isPreferred && !b.isPreferred) return -1;
        else if (!a.isPreferred && b.isPreferred) return 1;
        else return 0;
    }
    static codeActionsComparator({ action: a }, { action: b }) {
        if (a.isAI && !b.isAI) return 1;
        else if (!a.isAI && b.isAI) return -1;
        if ((0, _arraysJs.isNonEmptyArray)(a.diagnostics)) return (0, _arraysJs.isNonEmptyArray)(b.diagnostics) ? ManagedCodeActionSet.codeActionsPreferredComparator(a, b) : -1;
        else if ((0, _arraysJs.isNonEmptyArray)(b.diagnostics)) return 1;
        else return ManagedCodeActionSet.codeActionsPreferredComparator(a, b); // both have no diagnostics
    }
    constructor(actions, documentation, disposables){
        super();
        this.documentation = documentation;
        this._register(disposables);
        this.allActions = [
            ...actions
        ].sort(ManagedCodeActionSet.codeActionsComparator);
        this.validActions = this.allActions.filter(({ action })=>!action.disabled);
    }
    get hasAutoFix() {
        return this.validActions.some(({ action: fix })=>!!fix.kind && (0, _typesJs.CodeActionKind).QuickFix.contains(new (0, _hierarchicalKindJs.HierarchicalKind)(fix.kind)) && !!fix.isPreferred);
    }
    get hasAIFix() {
        return this.validActions.some(({ action: fix })=>!!fix.isAI);
    }
    get allAIFixes() {
        return this.validActions.every(({ action: fix })=>!!fix.isAI);
    }
}
const emptyCodeActionsResponse = {
    actions: [],
    documentation: undefined
};
async function getCodeActions(registry, model, rangeOrSelection, trigger, progress, token) {
    const filter = trigger.filter || {};
    const notebookFilter = {
        ...filter,
        excludes: [
            ...filter.excludes || [],
            (0, _typesJs.CodeActionKind).Notebook
        ]
    };
    const codeActionContext = {
        only: filter.include?.value,
        trigger: trigger.type
    };
    const cts = new (0, _editorStateJs.TextModelCancellationTokenSource)(model, token);
    // if the trigger is auto (autosave, lightbulb, etc), we should exclude notebook codeActions
    const excludeNotebookCodeActions = trigger.type === 2 /* languages.CodeActionTriggerType.Auto */ ;
    const providers = getCodeActionProviders(registry, model, excludeNotebookCodeActions ? notebookFilter : filter);
    const disposables = new (0, _lifecycleJs.DisposableStore)();
    const promises = providers.map(async (provider)=>{
        try {
            progress.report(provider);
            const providedCodeActions = await provider.provideCodeActions(model, rangeOrSelection, codeActionContext, cts.token);
            if (providedCodeActions) disposables.add(providedCodeActions);
            if (cts.token.isCancellationRequested) return emptyCodeActionsResponse;
            const filteredActions = (providedCodeActions?.actions || []).filter((action)=>action && (0, _typesJs.filtersAction)(filter, action));
            const documentation = getDocumentationFromProvider(provider, filteredActions, filter.include);
            return {
                actions: filteredActions.map((action)=>new (0, _typesJs.CodeActionItem)(action, provider)),
                documentation
            };
        } catch (err) {
            if ((0, _errorsJs.isCancellationError)(err)) throw err;
            (0, _errorsJs.onUnexpectedExternalError)(err);
            return emptyCodeActionsResponse;
        }
    });
    const listener = registry.onDidChange(()=>{
        const newProviders = registry.all(model);
        if (!(0, _arraysJs.equals)(newProviders, providers)) cts.cancel();
    });
    try {
        const actions = await Promise.all(promises);
        const allActions = actions.map((x)=>x.actions).flat();
        const allDocumentation = [
            ...(0, _arraysJs.coalesce)(actions.map((x)=>x.documentation)),
            ...getAdditionalDocumentationForShowingActions(registry, model, trigger, allActions)
        ];
        return new ManagedCodeActionSet(allActions, allDocumentation, disposables);
    } finally{
        listener.dispose();
        cts.dispose();
    }
}
function getCodeActionProviders(registry, model, filter) {
    return registry.all(model)// Don't include providers that we know will not return code actions of interest
    .filter((provider)=>{
        if (!provider.providedCodeActionKinds) // We don't know what type of actions this provider will return.
        return true;
        return provider.providedCodeActionKinds.some((kind)=>(0, _typesJs.mayIncludeActionsOfKind)(filter, new (0, _hierarchicalKindJs.HierarchicalKind)(kind)));
    });
}
function* getAdditionalDocumentationForShowingActions(registry, model, trigger, actionsToShow) {
    if (model && actionsToShow.length) {
        for (const provider of registry.all(model))if (provider._getAdditionalMenuItems) yield* provider._getAdditionalMenuItems?.({
            trigger: trigger.type,
            only: trigger.filter?.include?.value
        }, actionsToShow.map((item)=>item.action));
    }
}
function getDocumentationFromProvider(provider, providedCodeActions, only) {
    if (!provider.documentation) return undefined;
    const documentation = provider.documentation.map((entry)=>({
            kind: new (0, _hierarchicalKindJs.HierarchicalKind)(entry.kind),
            command: entry.command
        }));
    if (only) {
        let currentBest;
        for (const entry of documentation)if (entry.kind.contains(only)) {
            if (!currentBest) currentBest = entry;
            else // Take best match
            if (currentBest.kind.contains(entry.kind)) currentBest = entry;
        }
        if (currentBest) return currentBest?.command;
    }
    // Otherwise, check to see if any of the provided actions match.
    for (const action of providedCodeActions){
        if (!action.kind) continue;
        for (const entry of documentation){
            if (entry.kind.contains(new (0, _hierarchicalKindJs.HierarchicalKind)(action.kind))) return entry.command;
        }
    }
    return undefined;
}
var ApplyCodeActionReason;
(function(ApplyCodeActionReason) {
    ApplyCodeActionReason["OnSave"] = "onSave";
    ApplyCodeActionReason["FromProblemsView"] = "fromProblemsView";
    ApplyCodeActionReason["FromCodeActions"] = "fromCodeActions";
    ApplyCodeActionReason["FromAILightbulb"] = "fromAILightbulb"; // direct invocation when clicking on the AI lightbulb
})(ApplyCodeActionReason || (ApplyCodeActionReason = {}));
async function applyCodeAction(accessor, item, codeActionReason, options, token = (0, _cancellationJs.CancellationToken).None) {
    const bulkEditService = accessor.get((0, _bulkEditServiceJs.IBulkEditService));
    const commandService = accessor.get((0, _commandsJs.ICommandService));
    const telemetryService = accessor.get((0, _telemetryJs.ITelemetryService));
    const notificationService = accessor.get((0, _notificationJs.INotificationService));
    telemetryService.publicLog2("codeAction.applyCodeAction", {
        codeActionTitle: item.action.title,
        codeActionKind: item.action.kind,
        codeActionIsPreferred: !!item.action.isPreferred,
        reason: codeActionReason
    });
    await item.resolve(token);
    if (token.isCancellationRequested) return;
    if (item.action.edit?.edits.length) {
        const result = await bulkEditService.apply(item.action.edit, {
            editor: options?.editor,
            label: item.action.title,
            quotableLabel: item.action.title,
            code: "undoredo.codeAction",
            respectAutoSaveConfig: codeActionReason !== ApplyCodeActionReason.OnSave,
            showPreview: options?.preview
        });
        if (!result.isApplied) return;
    }
    if (item.action.command) try {
        await commandService.executeCommand(item.action.command.id, ...item.action.command.arguments || []);
    } catch (err) {
        const message = asMessage(err);
        notificationService.error(typeof message === "string" ? message : _nlsJs.localize("applyCodeActionFailed", "An unknown error occurred while applying the code action"));
    }
}
function asMessage(err) {
    if (typeof err === "string") return err;
    else if (err instanceof Error && typeof err.message === "string") return err.message;
    else return undefined;
}
(0, _commandsJs.CommandsRegistry).registerCommand("_executeCodeActionProvider", async function(accessor, resource, rangeOrSelection, kind, itemResolveCount) {
    if (!(resource instanceof (0, _uriJs.URI))) throw (0, _errorsJs.illegalArgument)();
    const { codeActionProvider } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const model = accessor.get((0, _modelJs.IModelService)).getModel(resource);
    if (!model) throw (0, _errorsJs.illegalArgument)();
    const validatedRangeOrSelection = (0, _selectionJs.Selection).isISelection(rangeOrSelection) ? (0, _selectionJs.Selection).liftSelection(rangeOrSelection) : (0, _rangeJs.Range).isIRange(rangeOrSelection) ? model.validateRange(rangeOrSelection) : undefined;
    if (!validatedRangeOrSelection) throw (0, _errorsJs.illegalArgument)();
    const include = typeof kind === "string" ? new (0, _hierarchicalKindJs.HierarchicalKind)(kind) : undefined;
    const codeActionSet = await getCodeActions(codeActionProvider, model, validatedRangeOrSelection, {
        type: 1 /* languages.CodeActionTriggerType.Invoke */ ,
        triggerAction: (0, _typesJs.CodeActionTriggerSource).Default,
        filter: {
            includeSourceActions: true,
            include
        }
    }, (0, _progressJs.Progress).None, (0, _cancellationJs.CancellationToken).None);
    const resolving = [];
    const resolveCount = Math.min(codeActionSet.validActions.length, typeof itemResolveCount === "number" ? itemResolveCount : 0);
    for(let i = 0; i < resolveCount; i++)resolving.push(codeActionSet.validActions[i].resolve((0, _cancellationJs.CancellationToken).None));
    try {
        await Promise.all(resolving);
        return codeActionSet.validActions.map((item)=>item.action);
    } finally{
        setTimeout(()=>codeActionSet.dispose(), 100);
    }
});

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/uri.js":"7qGS3","../../../browser/services/bulkEditService.js":"fLMRG","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/services/languageFeatures.js":"2IAko","../../../common/services/model.js":"aciVm","../../editorState/browser/editorState.js":"hyVHM","../../../../nls.js":"l617d","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/notification/common/notification.js":"igv0W","../../../../platform/progress/common/progress.js":"f49eD","../../../../platform/telemetry/common/telemetry.js":"7vW8j","../common/types.js":"jJnno","../../../../base/common/hierarchicalKind.js":"eXua8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jJnno":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeActionKind", ()=>CodeActionKind);
parcelHelpers.export(exports, "CodeActionTriggerSource", ()=>CodeActionTriggerSource);
parcelHelpers.export(exports, "mayIncludeActionsOfKind", ()=>mayIncludeActionsOfKind);
parcelHelpers.export(exports, "filtersAction", ()=>filtersAction);
parcelHelpers.export(exports, "CodeActionCommandArgs", ()=>CodeActionCommandArgs);
parcelHelpers.export(exports, "CodeActionItem", ()=>CodeActionItem);
var _errorsJs = require("../../../../base/common/errors.js");
var _hierarchicalKindJs = require("../../../../base/common/hierarchicalKind.js");
const CodeActionKind = new class {
    constructor(){
        this.QuickFix = new (0, _hierarchicalKindJs.HierarchicalKind)("quickfix");
        this.Refactor = new (0, _hierarchicalKindJs.HierarchicalKind)("refactor");
        this.RefactorExtract = this.Refactor.append("extract");
        this.RefactorInline = this.Refactor.append("inline");
        this.RefactorMove = this.Refactor.append("move");
        this.RefactorRewrite = this.Refactor.append("rewrite");
        this.Notebook = new (0, _hierarchicalKindJs.HierarchicalKind)("notebook");
        this.Source = new (0, _hierarchicalKindJs.HierarchicalKind)("source");
        this.SourceOrganizeImports = this.Source.append("organizeImports");
        this.SourceFixAll = this.Source.append("fixAll");
        this.SurroundWith = this.Refactor.append("surround");
    }
};
var CodeActionTriggerSource;
(function(CodeActionTriggerSource) {
    CodeActionTriggerSource["Refactor"] = "refactor";
    CodeActionTriggerSource["RefactorPreview"] = "refactor preview";
    CodeActionTriggerSource["Lightbulb"] = "lightbulb";
    CodeActionTriggerSource["Default"] = "other (default)";
    CodeActionTriggerSource["SourceAction"] = "source action";
    CodeActionTriggerSource["QuickFix"] = "quick fix action";
    CodeActionTriggerSource["FixAll"] = "fix all";
    CodeActionTriggerSource["OrganizeImports"] = "organize imports";
    CodeActionTriggerSource["AutoFix"] = "auto fix";
    CodeActionTriggerSource["QuickFixHover"] = "quick fix hover window";
    CodeActionTriggerSource["OnSave"] = "save participants";
    CodeActionTriggerSource["ProblemsView"] = "problems view";
})(CodeActionTriggerSource || (CodeActionTriggerSource = {}));
function mayIncludeActionsOfKind(filter, providedKind) {
    // A provided kind may be a subset or superset of our filtered kind.
    if (filter.include && !filter.include.intersects(providedKind)) return false;
    if (filter.excludes) {
        if (filter.excludes.some((exclude)=>excludesAction(providedKind, exclude, filter.include))) return false;
    }
    // Don't return source actions unless they are explicitly requested
    if (!filter.includeSourceActions && CodeActionKind.Source.contains(providedKind)) return false;
    return true;
}
function filtersAction(filter, action) {
    const actionKind = action.kind ? new (0, _hierarchicalKindJs.HierarchicalKind)(action.kind) : undefined;
    // Filter out actions by kind
    if (filter.include) {
        if (!actionKind || !filter.include.contains(actionKind)) return false;
    }
    if (filter.excludes) {
        if (actionKind && filter.excludes.some((exclude)=>excludesAction(actionKind, exclude, filter.include))) return false;
    }
    // Don't return source actions unless they are explicitly requested
    if (!filter.includeSourceActions) {
        if (actionKind && CodeActionKind.Source.contains(actionKind)) return false;
    }
    if (filter.onlyIncludePreferredActions) {
        if (!action.isPreferred) return false;
    }
    return true;
}
function excludesAction(providedKind, exclude, include) {
    if (!exclude.contains(providedKind)) return false;
    if (include && exclude.contains(include)) // The include is more specific, don't filter out
    return false;
    return true;
}
class CodeActionCommandArgs {
    static fromUser(arg, defaults) {
        if (!arg || typeof arg !== "object") return new CodeActionCommandArgs(defaults.kind, defaults.apply, false);
        return new CodeActionCommandArgs(CodeActionCommandArgs.getKindFromUser(arg, defaults.kind), CodeActionCommandArgs.getApplyFromUser(arg, defaults.apply), CodeActionCommandArgs.getPreferredUser(arg));
    }
    static getApplyFromUser(arg, defaultAutoApply) {
        switch(typeof arg.apply === "string" ? arg.apply.toLowerCase() : ""){
            case "first":
                return "first" /* CodeActionAutoApply.First */ ;
            case "never":
                return "never" /* CodeActionAutoApply.Never */ ;
            case "ifsingle":
                return "ifSingle" /* CodeActionAutoApply.IfSingle */ ;
            default:
                return defaultAutoApply;
        }
    }
    static getKindFromUser(arg, defaultKind) {
        return typeof arg.kind === "string" ? new (0, _hierarchicalKindJs.HierarchicalKind)(arg.kind) : defaultKind;
    }
    static getPreferredUser(arg) {
        return typeof arg.preferred === "boolean" ? arg.preferred : false;
    }
    constructor(kind, apply, preferred){
        this.kind = kind;
        this.apply = apply;
        this.preferred = preferred;
    }
}
class CodeActionItem {
    constructor(action, provider, highlightRange){
        this.action = action;
        this.provider = provider;
        this.highlightRange = highlightRange;
    }
    async resolve(token) {
        if (this.provider?.resolveCodeAction && !this.action.edit) {
            let action;
            try {
                action = await this.provider.resolveCodeAction(this.action, token);
            } catch (err) {
                (0, _errorsJs.onUnexpectedExternalError)(err);
            }
            if (action) this.action.edit = action.edit;
        }
        return this;
    }
}

},{"../../../../base/common/errors.js":"divX8","../../../../base/common/hierarchicalKind.js":"eXua8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bCH7J":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeActionController", ()=>CodeActionController);
var _domJs = require("../../../../base/browser/dom.js");
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _lazyJs = require("../../../../base/common/lazy.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _positionJs = require("../../../common/core/position.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _codeActionJs = require("./codeAction.js");
var _codeActionKeybindingResolverJs = require("./codeActionKeybindingResolver.js");
var _codeActionMenuJs = require("./codeActionMenu.js");
var _lightBulbWidgetJs = require("./lightBulbWidget.js");
var _messageControllerJs = require("../../message/browser/messageController.js");
var _nlsJs = require("../../../../nls.js");
var _actionWidgetJs = require("../../../../platform/actionWidget/browser/actionWidget.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _markersJs = require("../../../../platform/markers/common/markers.js");
var _progressJs = require("../../../../platform/progress/common/progress.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _themeJs = require("../../../../platform/theme/common/theme.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _typesJs = require("../common/types.js");
var _codeActionModelJs = require("./codeActionModel.js");
var _hierarchicalKindJs = require("../../../../base/common/hierarchicalKind.js");
var _telemetryJs = require("../../../../platform/telemetry/common/telemetry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var CodeActionController_1;
const DECORATION_CLASS_NAME = "quickfix-edit-highlight";
let CodeActionController = class CodeActionController extends (0, _lifecycleJs.Disposable) {
    static{
        CodeActionController_1 = this;
    }
    static{
        this.ID = "editor.contrib.codeActionController";
    }
    static get(editor) {
        return editor.getContribution(CodeActionController_1.ID);
    }
    constructor(editor, markerService, contextKeyService, instantiationService, languageFeaturesService, progressService, _commandService, _configurationService, _actionWidgetService, _instantiationService, _telemetryService){
        super();
        this._commandService = _commandService;
        this._configurationService = _configurationService;
        this._actionWidgetService = _actionWidgetService;
        this._instantiationService = _instantiationService;
        this._telemetryService = _telemetryService;
        this._activeCodeActions = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this._showDisabled = false;
        this._disposed = false;
        this._editor = editor;
        this._model = this._register(new (0, _codeActionModelJs.CodeActionModel)(this._editor, languageFeaturesService.codeActionProvider, markerService, contextKeyService, progressService, _configurationService, this._telemetryService));
        this._register(this._model.onDidChangeState((newState)=>this.update(newState)));
        this._lightBulbWidget = new (0, _lazyJs.Lazy)(()=>{
            const widget = this._editor.getContribution((0, _lightBulbWidgetJs.LightBulbWidget).ID);
            if (widget) this._register(widget.onClick((e)=>this.showCodeActionsFromLightbulb(e.actions, e)));
            return widget;
        });
        this._resolver = instantiationService.createInstance((0, _codeActionKeybindingResolverJs.CodeActionKeybindingResolver));
        this._register(this._editor.onDidLayoutChange(()=>this._actionWidgetService.hide()));
    }
    dispose() {
        this._disposed = true;
        super.dispose();
    }
    async showCodeActionsFromLightbulb(actions, at) {
        if (actions.allAIFixes && actions.validActions.length === 1) {
            const actionItem = actions.validActions[0];
            const command = actionItem.action.command;
            if (command && command.id === "inlineChat.start") {
                if (command.arguments && command.arguments.length >= 1) command.arguments[0] = {
                    ...command.arguments[0],
                    autoSend: false
                };
            }
            await this._applyCodeAction(actionItem, false, false, (0, _codeActionJs.ApplyCodeActionReason).FromAILightbulb);
            return;
        }
        await this.showCodeActionList(actions, at, {
            includeDisabledActions: false,
            fromLightbulb: true
        });
    }
    showCodeActions(_trigger, actions, at) {
        return this.showCodeActionList(actions, at, {
            includeDisabledActions: false,
            fromLightbulb: false
        });
    }
    manualTriggerAtCurrentPosition(notAvailableMessage, triggerAction, filter, autoApply) {
        if (!this._editor.hasModel()) return;
        (0, _messageControllerJs.MessageController).get(this._editor)?.closeMessage();
        const triggerPosition = this._editor.getPosition();
        this._trigger({
            type: 1 /* CodeActionTriggerType.Invoke */ ,
            triggerAction,
            filter,
            autoApply,
            context: {
                notAvailableMessage,
                position: triggerPosition
            }
        });
    }
    _trigger(trigger) {
        return this._model.trigger(trigger);
    }
    async _applyCodeAction(action, retrigger, preview, actionReason) {
        try {
            await this._instantiationService.invokeFunction((0, _codeActionJs.applyCodeAction), action, actionReason, {
                preview,
                editor: this._editor
            });
        } finally{
            if (retrigger) this._trigger({
                type: 2 /* CodeActionTriggerType.Auto */ ,
                triggerAction: (0, _typesJs.CodeActionTriggerSource).QuickFix,
                filter: {}
            });
        }
    }
    hideLightBulbWidget() {
        this._lightBulbWidget.rawValue?.hide();
        this._lightBulbWidget.rawValue?.gutterHide();
    }
    async update(newState) {
        if (newState.type !== 1 /* CodeActionsState.Type.Triggered */ ) {
            this.hideLightBulbWidget();
            return;
        }
        let actions;
        try {
            actions = await newState.actions;
        } catch (e) {
            (0, _errorsJs.onUnexpectedError)(e);
            return;
        }
        if (this._disposed) return;
        const selection = this._editor.getSelection();
        if (selection?.startLineNumber !== newState.position.lineNumber) return;
        this._lightBulbWidget.value?.update(actions, newState.trigger, newState.position);
        if (newState.trigger.type === 1 /* CodeActionTriggerType.Invoke */ ) {
            if (newState.trigger.filter?.include) {
                // Check to see if we want to auto apply.
                const validActionToApply = this.tryGetValidActionToApply(newState.trigger, actions);
                if (validActionToApply) {
                    try {
                        this.hideLightBulbWidget();
                        await this._applyCodeAction(validActionToApply, false, false, (0, _codeActionJs.ApplyCodeActionReason).FromCodeActions);
                    } finally{
                        actions.dispose();
                    }
                    return;
                }
                // Check to see if there is an action that we would have applied were it not invalid
                if (newState.trigger.context) {
                    const invalidAction = this.getInvalidActionThatWouldHaveBeenApplied(newState.trigger, actions);
                    if (invalidAction && invalidAction.action.disabled) {
                        (0, _messageControllerJs.MessageController).get(this._editor)?.showMessage(invalidAction.action.disabled, newState.trigger.context.position);
                        actions.dispose();
                        return;
                    }
                }
            }
            const includeDisabledActions = !!newState.trigger.filter?.include;
            if (newState.trigger.context) {
                if (!actions.allActions.length || !includeDisabledActions && !actions.validActions.length) {
                    (0, _messageControllerJs.MessageController).get(this._editor)?.showMessage(newState.trigger.context.notAvailableMessage, newState.trigger.context.position);
                    this._activeCodeActions.value = actions;
                    actions.dispose();
                    return;
                }
            }
            this._activeCodeActions.value = actions;
            this.showCodeActionList(actions, this.toCoords(newState.position), {
                includeDisabledActions,
                fromLightbulb: false
            });
        } else // auto magically triggered
        if (this._actionWidgetService.isVisible) // TODO: Figure out if we should update the showing menu?
        actions.dispose();
        else this._activeCodeActions.value = actions;
    }
    getInvalidActionThatWouldHaveBeenApplied(trigger, actions) {
        if (!actions.allActions.length) return undefined;
        if (trigger.autoApply === "first" /* CodeActionAutoApply.First */  && actions.validActions.length === 0 || trigger.autoApply === "ifSingle" /* CodeActionAutoApply.IfSingle */  && actions.allActions.length === 1) return actions.allActions.find(({ action })=>action.disabled);
        return undefined;
    }
    tryGetValidActionToApply(trigger, actions) {
        if (!actions.validActions.length) return undefined;
        if (trigger.autoApply === "first" /* CodeActionAutoApply.First */  && actions.validActions.length > 0 || trigger.autoApply === "ifSingle" /* CodeActionAutoApply.IfSingle */  && actions.validActions.length === 1) return actions.validActions[0];
        return undefined;
    }
    static{
        this.DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "quickfix-highlight",
            className: DECORATION_CLASS_NAME
        });
    }
    async showCodeActionList(actions, at, options) {
        const currentDecorations = this._editor.createDecorationsCollection();
        const editorDom = this._editor.getDomNode();
        if (!editorDom) return;
        const actionsToShow = options.includeDisabledActions && (this._showDisabled || actions.validActions.length === 0) ? actions.allActions : actions.validActions;
        if (!actionsToShow.length) return;
        const anchor = (0, _positionJs.Position).isIPosition(at) ? this.toCoords(at) : at;
        const delegate = {
            onSelect: async (action, preview)=>{
                this._applyCodeAction(action, /* retrigger */ true, !!preview, options.fromLightbulb ? (0, _codeActionJs.ApplyCodeActionReason).FromAILightbulb : (0, _codeActionJs.ApplyCodeActionReason).FromCodeActions);
                this._actionWidgetService.hide(false);
                currentDecorations.clear();
            },
            onHide: (didCancel)=>{
                this._editor?.focus();
                currentDecorations.clear();
            },
            onHover: async (action, token)=>{
                if (token.isCancellationRequested) return;
                let canPreview = false;
                const actionKind = action.action.kind;
                if (actionKind) {
                    const hierarchicalKind = new (0, _hierarchicalKindJs.HierarchicalKind)(actionKind);
                    const refactorKinds = [
                        (0, _typesJs.CodeActionKind).RefactorExtract,
                        (0, _typesJs.CodeActionKind).RefactorInline,
                        (0, _typesJs.CodeActionKind).RefactorRewrite,
                        (0, _typesJs.CodeActionKind).RefactorMove,
                        (0, _typesJs.CodeActionKind).Source
                    ];
                    canPreview = refactorKinds.some((refactorKind)=>refactorKind.contains(hierarchicalKind));
                }
                return {
                    canPreview: canPreview || !!action.action.edit?.edits.length
                };
            },
            onFocus: (action)=>{
                if (action && action.action) {
                    const ranges = action.action.ranges;
                    const diagnostics = action.action.diagnostics;
                    currentDecorations.clear();
                    if (ranges && ranges.length > 0) {
                        // Handles case for `fix all` where there are multiple diagnostics.
                        const decorations = diagnostics && diagnostics?.length > 1 ? diagnostics.map((diagnostic)=>({
                                range: diagnostic,
                                options: CodeActionController_1.DECORATION
                            })) : ranges.map((range)=>({
                                range,
                                options: CodeActionController_1.DECORATION
                            }));
                        currentDecorations.set(decorations);
                    } else if (diagnostics && diagnostics.length > 0) {
                        const decorations = diagnostics.map((diagnostic)=>({
                                range: diagnostic,
                                options: CodeActionController_1.DECORATION
                            }));
                        currentDecorations.set(decorations);
                        const diagnostic = diagnostics[0];
                        if (diagnostic.startLineNumber && diagnostic.startColumn) {
                            const selectionText = this._editor.getModel()?.getWordAtPosition({
                                lineNumber: diagnostic.startLineNumber,
                                column: diagnostic.startColumn
                            })?.word;
                            _ariaJs.status((0, _nlsJs.localize)("editingNewSelection", "Context: {0} at line {1} and column {2}.", selectionText, diagnostic.startLineNumber, diagnostic.startColumn));
                        }
                    }
                } else currentDecorations.clear();
            }
        };
        this._actionWidgetService.show("codeActionWidget", true, (0, _codeActionMenuJs.toMenuItems)(actionsToShow, this._shouldShowHeaders(), this._resolver.getResolver()), delegate, anchor, editorDom, this._getActionBarActions(actions, at, options));
    }
    toCoords(position) {
        if (!this._editor.hasModel()) return {
            x: 0,
            y: 0
        };
        this._editor.revealPosition(position, 1 /* ScrollType.Immediate */ );
        this._editor.render();
        // Translate to absolute editor position
        const cursorCoords = this._editor.getScrolledVisiblePosition(position);
        const editorCoords = (0, _domJs.getDomNodePagePosition)(this._editor.getDomNode());
        const x = editorCoords.left + cursorCoords.left;
        const y = editorCoords.top + cursorCoords.top + cursorCoords.height;
        return {
            x,
            y
        };
    }
    _shouldShowHeaders() {
        const model = this._editor?.getModel();
        return this._configurationService.getValue("editor.codeActionWidget.showHeaders", {
            resource: model?.uri
        });
    }
    _getActionBarActions(actions, at, options) {
        if (options.fromLightbulb) return [];
        const resultActions = actions.documentation.map((command)=>({
                id: command.id,
                label: command.title,
                tooltip: command.tooltip ?? "",
                class: undefined,
                enabled: true,
                run: ()=>this._commandService.executeCommand(command.id, ...command.arguments ?? [])
            }));
        if (options.includeDisabledActions && actions.validActions.length > 0 && actions.allActions.length !== actions.validActions.length) resultActions.push(this._showDisabled ? {
            id: "hideMoreActions",
            label: (0, _nlsJs.localize)("hideMoreActions", "Hide Disabled"),
            enabled: true,
            tooltip: "",
            class: undefined,
            run: ()=>{
                this._showDisabled = false;
                return this.showCodeActionList(actions, at, options);
            }
        } : {
            id: "showMoreActions",
            label: (0, _nlsJs.localize)("showMoreActions", "Show Disabled"),
            enabled: true,
            tooltip: "",
            class: undefined,
            run: ()=>{
                this._showDisabled = true;
                return this.showCodeActionList(actions, at, options);
            }
        });
        return resultActions;
    }
};
CodeActionController = CodeActionController_1 = __decorate([
    __param(1, (0, _markersJs.IMarkerService)),
    __param(2, (0, _contextkeyJs.IContextKeyService)),
    __param(3, (0, _instantiationJs.IInstantiationService)),
    __param(4, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(5, (0, _progressJs.IEditorProgressService)),
    __param(6, (0, _commandsJs.ICommandService)),
    __param(7, (0, _configurationJs.IConfigurationService)),
    __param(8, (0, _actionWidgetJs.IActionWidgetService)),
    __param(9, (0, _instantiationJs.IInstantiationService)),
    __param(10, (0, _telemetryJs.ITelemetryService))
], CodeActionController);
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const addBackgroundColorRule = (selector, color)=>{
        if (color) collector.addRule(`.monaco-editor ${selector} { background-color: ${color}; }`);
    };
    addBackgroundColorRule(".quickfix-edit-highlight", theme.getColor((0, _colorRegistryJs.editorFindMatchHighlight)));
    const findMatchHighlightBorder = theme.getColor((0, _colorRegistryJs.editorFindMatchHighlightBorder));
    if (findMatchHighlightBorder) collector.addRule(`.monaco-editor .quickfix-edit-highlight { border: 1px ${(0, _themeJs.isHighContrast)(theme.type) ? "dotted" : "solid"} ${findMatchHighlightBorder}; box-sizing: border-box; }`);
});

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/aria/aria.js":"asrsh","../../../../base/common/errors.js":"divX8","../../../../base/common/lazy.js":"6e57N","../../../../base/common/lifecycle.js":"9kg8d","../../../common/core/position.js":"lvrPe","../../../common/model/textModel.js":"9beDe","../../../common/services/languageFeatures.js":"2IAko","./codeAction.js":"6jIB5","./codeActionKeybindingResolver.js":"joRCl","./codeActionMenu.js":"5x3ky","./lightBulbWidget.js":"aR2pb","../../message/browser/messageController.js":"7FZE5","../../../../nls.js":"l617d","../../../../platform/actionWidget/browser/actionWidget.js":"a4aK5","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/markers/common/markers.js":"aaeXc","../../../../platform/progress/common/progress.js":"f49eD","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/theme.js":"gh7Zf","../../../../platform/theme/common/themeService.js":"jMkIC","../common/types.js":"jJnno","./codeActionModel.js":"8KDSO","../../../../base/common/hierarchicalKind.js":"eXua8","../../../../platform/telemetry/common/telemetry.js":"7vW8j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"joRCl":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeActionKeybindingResolver", ()=>CodeActionKeybindingResolver);
var _hierarchicalKindJs = require("../../../../base/common/hierarchicalKind.js");
var _lazyJs = require("../../../../base/common/lazy.js");
var _codeActionJs = require("./codeAction.js");
var _typesJs = require("../common/types.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var CodeActionKeybindingResolver_1;
let CodeActionKeybindingResolver = class CodeActionKeybindingResolver {
    static{
        CodeActionKeybindingResolver_1 = this;
    }
    static{
        this.codeActionCommands = [
            (0, _codeActionJs.refactorCommandId),
            (0, _codeActionJs.codeActionCommandId),
            (0, _codeActionJs.sourceActionCommandId),
            (0, _codeActionJs.organizeImportsCommandId),
            (0, _codeActionJs.fixAllCommandId)
        ];
    }
    constructor(keybindingService){
        this.keybindingService = keybindingService;
    }
    getResolver() {
        // Lazy since we may not actually ever read the value
        const allCodeActionBindings = new (0, _lazyJs.Lazy)(()=>this.keybindingService.getKeybindings().filter((item)=>CodeActionKeybindingResolver_1.codeActionCommands.indexOf(item.command) >= 0).filter((item)=>item.resolvedKeybinding).map((item)=>{
                // Special case these commands since they come built-in with VS Code and don't use 'commandArgs'
                let commandArgs = item.commandArgs;
                if (item.command === (0, _codeActionJs.organizeImportsCommandId)) commandArgs = {
                    kind: (0, _typesJs.CodeActionKind).SourceOrganizeImports.value
                };
                else if (item.command === (0, _codeActionJs.fixAllCommandId)) commandArgs = {
                    kind: (0, _typesJs.CodeActionKind).SourceFixAll.value
                };
                return {
                    resolvedKeybinding: item.resolvedKeybinding,
                    ...(0, _typesJs.CodeActionCommandArgs).fromUser(commandArgs, {
                        kind: (0, _hierarchicalKindJs.HierarchicalKind).None,
                        apply: "never" /* CodeActionAutoApply.Never */ 
                    })
                };
            }));
        return (action)=>{
            if (action.kind) {
                const binding = this.bestKeybindingForCodeAction(action, allCodeActionBindings.value);
                return binding?.resolvedKeybinding;
            }
            return undefined;
        };
    }
    bestKeybindingForCodeAction(action, candidates) {
        if (!action.kind) return undefined;
        const kind = new (0, _hierarchicalKindJs.HierarchicalKind)(action.kind);
        return candidates.filter((candidate)=>candidate.kind.contains(kind)).filter((candidate)=>{
            if (candidate.preferred) // If the candidate keybinding only applies to preferred actions, the this action must also be preferred
            return action.isPreferred;
            return true;
        }).reduceRight((currentBest, candidate)=>{
            if (!currentBest) return candidate;
            // Select the more specific binding
            return currentBest.kind.contains(candidate.kind) ? candidate : currentBest;
        }, undefined);
    }
};
CodeActionKeybindingResolver = CodeActionKeybindingResolver_1 = __decorate([
    __param(0, (0, _keybindingJs.IKeybindingService))
], CodeActionKeybindingResolver);

},{"../../../../base/common/hierarchicalKind.js":"eXua8","../../../../base/common/lazy.js":"6e57N","./codeAction.js":"6jIB5","../common/types.js":"jJnno","../../../../platform/keybinding/common/keybinding.js":"25pLT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5x3ky":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toMenuItems", ()=>toMenuItems);
var _codiconStylesJs = require("../../../../base/browser/ui/codicons/codiconStyles.js"); // The codicon symbol styles are defined here and must be loaded
var _codiconsJs = require("../../../../base/common/codicons.js");
var _typesJs = require("../common/types.js");
var _symbolIconsJs = require("../../symbolIcons/browser/symbolIcons.js"); // The codicon symbol colors are defined here and must be loaded to get colors
var _nlsJs = require("../../../../nls.js");
var _hierarchicalKindJs = require("../../../../base/common/hierarchicalKind.js");
const uncategorizedCodeActionGroup = Object.freeze({
    kind: (0, _hierarchicalKindJs.HierarchicalKind).Empty,
    title: (0, _nlsJs.localize)("codeAction.widget.id.more", "More Actions...")
});
const codeActionGroups = Object.freeze([
    {
        kind: (0, _typesJs.CodeActionKind).QuickFix,
        title: (0, _nlsJs.localize)("codeAction.widget.id.quickfix", "Quick Fix")
    },
    {
        kind: (0, _typesJs.CodeActionKind).RefactorExtract,
        title: (0, _nlsJs.localize)("codeAction.widget.id.extract", "Extract"),
        icon: (0, _codiconsJs.Codicon).wrench
    },
    {
        kind: (0, _typesJs.CodeActionKind).RefactorInline,
        title: (0, _nlsJs.localize)("codeAction.widget.id.inline", "Inline"),
        icon: (0, _codiconsJs.Codicon).wrench
    },
    {
        kind: (0, _typesJs.CodeActionKind).RefactorRewrite,
        title: (0, _nlsJs.localize)("codeAction.widget.id.convert", "Rewrite"),
        icon: (0, _codiconsJs.Codicon).wrench
    },
    {
        kind: (0, _typesJs.CodeActionKind).RefactorMove,
        title: (0, _nlsJs.localize)("codeAction.widget.id.move", "Move"),
        icon: (0, _codiconsJs.Codicon).wrench
    },
    {
        kind: (0, _typesJs.CodeActionKind).SurroundWith,
        title: (0, _nlsJs.localize)("codeAction.widget.id.surround", "Surround With"),
        icon: (0, _codiconsJs.Codicon).surroundWith
    },
    {
        kind: (0, _typesJs.CodeActionKind).Source,
        title: (0, _nlsJs.localize)("codeAction.widget.id.source", "Source Action"),
        icon: (0, _codiconsJs.Codicon).symbolFile
    },
    uncategorizedCodeActionGroup
]);
function toMenuItems(inputCodeActions, showHeaders, keybindingResolver) {
    if (!showHeaders) return inputCodeActions.map((action)=>{
        return {
            kind: "action" /* ActionListItemKind.Action */ ,
            item: action,
            group: uncategorizedCodeActionGroup,
            disabled: !!action.action.disabled,
            label: action.action.disabled || action.action.title,
            canPreview: !!action.action.edit?.edits.length
        };
    });
    // Group code actions
    const menuEntries = codeActionGroups.map((group)=>({
            group,
            actions: []
        }));
    for (const action of inputCodeActions){
        const kind = action.action.kind ? new (0, _hierarchicalKindJs.HierarchicalKind)(action.action.kind) : (0, _hierarchicalKindJs.HierarchicalKind).None;
        for (const menuEntry of menuEntries)if (menuEntry.group.kind.contains(kind)) {
            menuEntry.actions.push(action);
            break;
        }
    }
    const allMenuItems = [];
    for (const menuEntry of menuEntries)if (menuEntry.actions.length) {
        allMenuItems.push({
            kind: "header" /* ActionListItemKind.Header */ ,
            group: menuEntry.group
        });
        for (const action of menuEntry.actions){
            const group = menuEntry.group;
            allMenuItems.push({
                kind: "action" /* ActionListItemKind.Action */ ,
                item: action,
                group: action.action.isAI ? {
                    title: group.title,
                    kind: group.kind,
                    icon: (0, _codiconsJs.Codicon).sparkle
                } : group,
                label: action.action.title,
                disabled: !!action.action.disabled,
                keybinding: keybindingResolver(action.action)
            });
        }
    }
    return allMenuItems;
}

},{"../../../../base/browser/ui/codicons/codiconStyles.js":"guMVT","../../../../base/common/codicons.js":"hWYNf","../common/types.js":"jJnno","../../symbolIcons/browser/symbolIcons.js":"4yhOw","../../../../nls.js":"l617d","../../../../base/common/hierarchicalKind.js":"eXua8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"guMVT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _codiconCss = require("./codicon/codicon.css");
var _codiconModifiersCss = require("./codicon/codicon-modifiers.css");

},{"./codicon/codicon.css":"dkAOD","./codicon/codicon-modifiers.css":"lmx2a"}],"dkAOD":[function() {},{}],"lmx2a":[function() {},{}],"4yhOw":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SYMBOL_ICON_ARRAY_FOREGROUND", ()=>SYMBOL_ICON_ARRAY_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_BOOLEAN_FOREGROUND", ()=>SYMBOL_ICON_BOOLEAN_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_CLASS_FOREGROUND", ()=>SYMBOL_ICON_CLASS_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_COLOR_FOREGROUND", ()=>SYMBOL_ICON_COLOR_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_CONSTANT_FOREGROUND", ()=>SYMBOL_ICON_CONSTANT_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_CONSTRUCTOR_FOREGROUND", ()=>SYMBOL_ICON_CONSTRUCTOR_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_ENUMERATOR_FOREGROUND", ()=>SYMBOL_ICON_ENUMERATOR_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_ENUMERATOR_MEMBER_FOREGROUND", ()=>SYMBOL_ICON_ENUMERATOR_MEMBER_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_EVENT_FOREGROUND", ()=>SYMBOL_ICON_EVENT_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_FIELD_FOREGROUND", ()=>SYMBOL_ICON_FIELD_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_FILE_FOREGROUND", ()=>SYMBOL_ICON_FILE_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_FOLDER_FOREGROUND", ()=>SYMBOL_ICON_FOLDER_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_FUNCTION_FOREGROUND", ()=>SYMBOL_ICON_FUNCTION_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_INTERFACE_FOREGROUND", ()=>SYMBOL_ICON_INTERFACE_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_KEY_FOREGROUND", ()=>SYMBOL_ICON_KEY_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_KEYWORD_FOREGROUND", ()=>SYMBOL_ICON_KEYWORD_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_METHOD_FOREGROUND", ()=>SYMBOL_ICON_METHOD_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_MODULE_FOREGROUND", ()=>SYMBOL_ICON_MODULE_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_NAMESPACE_FOREGROUND", ()=>SYMBOL_ICON_NAMESPACE_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_NULL_FOREGROUND", ()=>SYMBOL_ICON_NULL_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_NUMBER_FOREGROUND", ()=>SYMBOL_ICON_NUMBER_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_OBJECT_FOREGROUND", ()=>SYMBOL_ICON_OBJECT_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_OPERATOR_FOREGROUND", ()=>SYMBOL_ICON_OPERATOR_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_PACKAGE_FOREGROUND", ()=>SYMBOL_ICON_PACKAGE_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_PROPERTY_FOREGROUND", ()=>SYMBOL_ICON_PROPERTY_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_REFERENCE_FOREGROUND", ()=>SYMBOL_ICON_REFERENCE_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_SNIPPET_FOREGROUND", ()=>SYMBOL_ICON_SNIPPET_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_STRING_FOREGROUND", ()=>SYMBOL_ICON_STRING_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_STRUCT_FOREGROUND", ()=>SYMBOL_ICON_STRUCT_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_TEXT_FOREGROUND", ()=>SYMBOL_ICON_TEXT_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_TYPEPARAMETER_FOREGROUND", ()=>SYMBOL_ICON_TYPEPARAMETER_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_UNIT_FOREGROUND", ()=>SYMBOL_ICON_UNIT_FOREGROUND);
parcelHelpers.export(exports, "SYMBOL_ICON_VARIABLE_FOREGROUND", ()=>SYMBOL_ICON_VARIABLE_FOREGROUND);
var _symbolIconsCss = require("./symbolIcons.css");
var _nlsJs = require("../../../../nls.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
const SYMBOL_ICON_ARRAY_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.arrayForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.arrayForeground", "The foreground color for array symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_BOOLEAN_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.booleanForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.booleanForeground", "The foreground color for boolean symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_CLASS_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.classForeground", {
    dark: "#EE9D28",
    light: "#D67E00",
    hcDark: "#EE9D28",
    hcLight: "#D67E00"
}, (0, _nlsJs.localize)("symbolIcon.classForeground", "The foreground color for class symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_COLOR_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.colorForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.colorForeground", "The foreground color for color symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_CONSTANT_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.constantForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.constantForeground", "The foreground color for constant symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_CONSTRUCTOR_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.constructorForeground", {
    dark: "#B180D7",
    light: "#652D90",
    hcDark: "#B180D7",
    hcLight: "#652D90"
}, (0, _nlsJs.localize)("symbolIcon.constructorForeground", "The foreground color for constructor symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_ENUMERATOR_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.enumeratorForeground", {
    dark: "#EE9D28",
    light: "#D67E00",
    hcDark: "#EE9D28",
    hcLight: "#D67E00"
}, (0, _nlsJs.localize)("symbolIcon.enumeratorForeground", "The foreground color for enumerator symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_ENUMERATOR_MEMBER_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.enumeratorMemberForeground", {
    dark: "#75BEFF",
    light: "#007ACC",
    hcDark: "#75BEFF",
    hcLight: "#007ACC"
}, (0, _nlsJs.localize)("symbolIcon.enumeratorMemberForeground", "The foreground color for enumerator member symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_EVENT_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.eventForeground", {
    dark: "#EE9D28",
    light: "#D67E00",
    hcDark: "#EE9D28",
    hcLight: "#D67E00"
}, (0, _nlsJs.localize)("symbolIcon.eventForeground", "The foreground color for event symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_FIELD_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.fieldForeground", {
    dark: "#75BEFF",
    light: "#007ACC",
    hcDark: "#75BEFF",
    hcLight: "#007ACC"
}, (0, _nlsJs.localize)("symbolIcon.fieldForeground", "The foreground color for field symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_FILE_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.fileForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.fileForeground", "The foreground color for file symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_FOLDER_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.folderForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.folderForeground", "The foreground color for folder symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_FUNCTION_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.functionForeground", {
    dark: "#B180D7",
    light: "#652D90",
    hcDark: "#B180D7",
    hcLight: "#652D90"
}, (0, _nlsJs.localize)("symbolIcon.functionForeground", "The foreground color for function symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_INTERFACE_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.interfaceForeground", {
    dark: "#75BEFF",
    light: "#007ACC",
    hcDark: "#75BEFF",
    hcLight: "#007ACC"
}, (0, _nlsJs.localize)("symbolIcon.interfaceForeground", "The foreground color for interface symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_KEY_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.keyForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.keyForeground", "The foreground color for key symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_KEYWORD_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.keywordForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.keywordForeground", "The foreground color for keyword symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_METHOD_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.methodForeground", {
    dark: "#B180D7",
    light: "#652D90",
    hcDark: "#B180D7",
    hcLight: "#652D90"
}, (0, _nlsJs.localize)("symbolIcon.methodForeground", "The foreground color for method symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_MODULE_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.moduleForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.moduleForeground", "The foreground color for module symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_NAMESPACE_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.namespaceForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.namespaceForeground", "The foreground color for namespace symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_NULL_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.nullForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.nullForeground", "The foreground color for null symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_NUMBER_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.numberForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.numberForeground", "The foreground color for number symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_OBJECT_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.objectForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.objectForeground", "The foreground color for object symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_OPERATOR_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.operatorForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.operatorForeground", "The foreground color for operator symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_PACKAGE_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.packageForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.packageForeground", "The foreground color for package symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_PROPERTY_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.propertyForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.propertyForeground", "The foreground color for property symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_REFERENCE_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.referenceForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.referenceForeground", "The foreground color for reference symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_SNIPPET_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.snippetForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.snippetForeground", "The foreground color for snippet symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_STRING_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.stringForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.stringForeground", "The foreground color for string symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_STRUCT_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.structForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.structForeground", "The foreground color for struct symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_TEXT_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.textForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.textForeground", "The foreground color for text symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_TYPEPARAMETER_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.typeParameterForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.typeParameterForeground", "The foreground color for type parameter symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_UNIT_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.unitForeground", (0, _colorRegistryJs.foreground), (0, _nlsJs.localize)("symbolIcon.unitForeground", "The foreground color for unit symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));
const SYMBOL_ICON_VARIABLE_FOREGROUND = (0, _colorRegistryJs.registerColor)("symbolIcon.variableForeground", {
    dark: "#75BEFF",
    light: "#007ACC",
    hcDark: "#75BEFF",
    hcLight: "#007ACC"
}, (0, _nlsJs.localize)("symbolIcon.variableForeground", "The foreground color for variable symbols. These symbols appear in the outline, breadcrumb, and suggest widget."));

},{"./symbolIcons.css":"59Evt","../../../../nls.js":"l617d","../../../../platform/theme/common/colorRegistry.js":"ik5kv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"59Evt":[function() {},{}],"aR2pb":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LightBulbWidget", ()=>LightBulbWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _touchJs = require("../../../../base/browser/touch.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _themablesJs = require("../../../../base/common/themables.js");
var _lightBulbWidgetCss = require("./lightBulbWidget.css");
var _modelJs = require("../../../common/model.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _utilsJs = require("../../../common/model/utils.js");
var _codeActionJs = require("./codeAction.js");
var _nlsJs = require("../../../../nls.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _iconRegistryJs = require("../../../../platform/theme/common/iconRegistry.js");
var _rangeJs = require("../../../common/core/range.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var LightBulbWidget_1;
const GUTTER_LIGHTBULB_ICON = (0, _iconRegistryJs.registerIcon)("gutter-lightbulb", (0, _codiconsJs.Codicon).lightBulb, _nlsJs.localize("gutterLightbulbWidget", "Icon which spawns code actions menu from the gutter when there is no space in the editor."));
const GUTTER_LIGHTBULB_AUTO_FIX_ICON = (0, _iconRegistryJs.registerIcon)("gutter-lightbulb-auto-fix", (0, _codiconsJs.Codicon).lightbulbAutofix, _nlsJs.localize("gutterLightbulbAutoFixWidget", "Icon which spawns code actions menu from the gutter when there is no space in the editor and a quick fix is available."));
const GUTTER_LIGHTBULB_AIFIX_ICON = (0, _iconRegistryJs.registerIcon)("gutter-lightbulb-sparkle", (0, _codiconsJs.Codicon).lightbulbSparkle, _nlsJs.localize("gutterLightbulbAIFixWidget", "Icon which spawns code actions menu from the gutter when there is no space in the editor and an AI fix is available."));
const GUTTER_LIGHTBULB_AIFIX_AUTO_FIX_ICON = (0, _iconRegistryJs.registerIcon)("gutter-lightbulb-aifix-auto-fix", (0, _codiconsJs.Codicon).lightbulbSparkleAutofix, _nlsJs.localize("gutterLightbulbAIFixAutoFixWidget", "Icon which spawns code actions menu from the gutter when there is no space in the editor and an AI fix and a quick fix is available."));
const GUTTER_SPARKLE_FILLED_ICON = (0, _iconRegistryJs.registerIcon)("gutter-lightbulb-sparkle-filled", (0, _codiconsJs.Codicon).sparkleFilled, _nlsJs.localize("gutterLightbulbSparkleFilledWidget", "Icon which spawns code actions menu from the gutter when there is no space in the editor and an AI fix and a quick fix is available."));
var LightBulbState;
(function(LightBulbState) {
    LightBulbState.Hidden = {
        type: 0 /* Type.Hidden */ 
    };
    class Showing {
        constructor(actions, trigger, editorPosition, widgetPosition){
            this.actions = actions;
            this.trigger = trigger;
            this.editorPosition = editorPosition;
            this.widgetPosition = widgetPosition;
            this.type = 1 /* Type.Showing */ ;
        }
    }
    LightBulbState.Showing = Showing;
})(LightBulbState || (LightBulbState = {}));
let LightBulbWidget = class LightBulbWidget extends (0, _lifecycleJs.Disposable) {
    static{
        LightBulbWidget_1 = this;
    }
    static{
        this.GUTTER_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "codicon-gutter-lightbulb-decoration",
            glyphMarginClassName: (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).lightBulb),
            glyphMargin: {
                position: (0, _modelJs.GlyphMarginLane).Left
            },
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ 
        });
    }
    static{
        this.ID = "editor.contrib.lightbulbWidget";
    }
    static{
        this._posPref = [
            0 /* ContentWidgetPositionPreference.EXACT */ 
        ];
    }
    constructor(_editor, _keybindingService){
        super();
        this._editor = _editor;
        this._keybindingService = _keybindingService;
        this._onClick = this._register(new (0, _eventJs.Emitter)());
        this.onClick = this._onClick.event;
        this._state = LightBulbState.Hidden;
        this._gutterState = LightBulbState.Hidden;
        this._iconClasses = [];
        this.lightbulbClasses = [
            "codicon-" + GUTTER_LIGHTBULB_ICON.id,
            "codicon-" + GUTTER_LIGHTBULB_AIFIX_AUTO_FIX_ICON.id,
            "codicon-" + GUTTER_LIGHTBULB_AUTO_FIX_ICON.id,
            "codicon-" + GUTTER_LIGHTBULB_AIFIX_ICON.id,
            "codicon-" + GUTTER_SPARKLE_FILLED_ICON.id
        ];
        this.gutterDecoration = LightBulbWidget_1.GUTTER_DECORATION;
        this._domNode = _domJs.$("div.lightBulbWidget");
        this._domNode.role = "listbox";
        this._register((0, _touchJs.Gesture).ignoreTarget(this._domNode));
        this._editor.addContentWidget(this);
        this._register(this._editor.onDidChangeModelContent((_)=>{
            // cancel when the line in question has been removed
            const editorModel = this._editor.getModel();
            if (this.state.type !== 1 /* LightBulbState.Type.Showing */  || !editorModel || this.state.editorPosition.lineNumber >= editorModel.getLineCount()) this.hide();
            if (this.gutterState.type !== 1 /* LightBulbState.Type.Showing */  || !editorModel || this.gutterState.editorPosition.lineNumber >= editorModel.getLineCount()) this.gutterHide();
        }));
        this._register(_domJs.addStandardDisposableGenericMouseDownListener(this._domNode, (e)=>{
            if (this.state.type !== 1 /* LightBulbState.Type.Showing */ ) return;
            // Make sure that focus / cursor location is not lost when clicking widget icon
            this._editor.focus();
            e.preventDefault();
            // a bit of extra work to make sure the menu
            // doesn't cover the line-text
            const { top, height } = _domJs.getDomNodePagePosition(this._domNode);
            const lineHeight = this._editor.getOption(67 /* EditorOption.lineHeight */ );
            let pad = Math.floor(lineHeight / 3);
            if (this.state.widgetPosition.position !== null && this.state.widgetPosition.position.lineNumber < this.state.editorPosition.lineNumber) pad += lineHeight;
            this._onClick.fire({
                x: e.posx,
                y: top + height + pad,
                actions: this.state.actions,
                trigger: this.state.trigger
            });
        }));
        this._register(_domJs.addDisposableListener(this._domNode, "mouseenter", (e)=>{
            if ((e.buttons & 1) !== 1) return;
            // mouse enters lightbulb while the primary/left button
            // is being pressed -> hide the lightbulb
            this.hide();
        }));
        this._register((0, _eventJs.Event).runAndSubscribe(this._keybindingService.onDidUpdateKeybindings, ()=>{
            this._preferredKbLabel = this._keybindingService.lookupKeybinding((0, _codeActionJs.autoFixCommandId))?.getLabel() ?? undefined;
            this._quickFixKbLabel = this._keybindingService.lookupKeybinding((0, _codeActionJs.quickFixCommandId))?.getLabel() ?? undefined;
            this._updateLightBulbTitleAndIcon();
        }));
        this._register(this._editor.onMouseDown(async (e)=>{
            if (!e.target.element || !this.lightbulbClasses.some((cls)=>e.target.element && e.target.element.classList.contains(cls))) return;
            if (this.gutterState.type !== 1 /* LightBulbState.Type.Showing */ ) return;
            // Make sure that focus / cursor location is not lost when clicking widget icon
            this._editor.focus();
            // a bit of extra work to make sure the menu
            // doesn't cover the line-text
            const { top, height } = _domJs.getDomNodePagePosition(e.target.element);
            const lineHeight = this._editor.getOption(67 /* EditorOption.lineHeight */ );
            let pad = Math.floor(lineHeight / 3);
            if (this.gutterState.widgetPosition.position !== null && this.gutterState.widgetPosition.position.lineNumber < this.gutterState.editorPosition.lineNumber) pad += lineHeight;
            this._onClick.fire({
                x: e.event.posx,
                y: top + height + pad,
                actions: this.gutterState.actions,
                trigger: this.gutterState.trigger
            });
        }));
    }
    dispose() {
        super.dispose();
        this._editor.removeContentWidget(this);
        if (this._gutterDecorationID) this._removeGutterDecoration(this._gutterDecorationID);
    }
    getId() {
        return "LightBulbWidget";
    }
    getDomNode() {
        return this._domNode;
    }
    getPosition() {
        return this._state.type === 1 /* LightBulbState.Type.Showing */  ? this._state.widgetPosition : null;
    }
    update(actions, trigger, atPosition) {
        if (actions.validActions.length <= 0) {
            this.gutterHide();
            return this.hide();
        }
        const hasTextFocus = this._editor.hasTextFocus();
        if (!hasTextFocus) {
            this.gutterHide();
            return this.hide();
        }
        const options = this._editor.getOptions();
        if (!options.get(65 /* EditorOption.lightbulb */ ).enabled) {
            this.gutterHide();
            return this.hide();
        }
        const model = this._editor.getModel();
        if (!model) {
            this.gutterHide();
            return this.hide();
        }
        const { lineNumber, column } = model.validatePosition(atPosition);
        const tabSize = model.getOptions().tabSize;
        const fontInfo = this._editor.getOptions().get(50 /* EditorOption.fontInfo */ );
        const lineContent = model.getLineContent(lineNumber);
        const indent = (0, _utilsJs.computeIndentLevel)(lineContent, tabSize);
        const lineHasSpace = fontInfo.spaceWidth * indent > 22;
        const isFolded = (lineNumber)=>{
            return lineNumber > 2 && this._editor.getTopForLineNumber(lineNumber) === this._editor.getTopForLineNumber(lineNumber - 1);
        };
        // Check for glyph margin decorations of any kind
        const currLineDecorations = this._editor.getLineDecorations(lineNumber);
        let hasDecoration = false;
        if (currLineDecorations) for (const decoration of currLineDecorations){
            const glyphClass = decoration.options.glyphMarginClassName;
            if (glyphClass && !this.lightbulbClasses.some((className)=>glyphClass.includes(className))) {
                hasDecoration = true;
                break;
            }
        }
        let effectiveLineNumber = lineNumber;
        let effectiveColumnNumber = 1;
        if (!lineHasSpace) {
            // Checks if line is empty or starts with any amount of whitespace
            const isLineEmptyOrIndented = (lineNumber)=>{
                const lineContent = model.getLineContent(lineNumber);
                return /^\s*$|^\s+/.test(lineContent) || lineContent.length <= effectiveColumnNumber;
            };
            if (lineNumber > 1 && !isFolded(lineNumber - 1)) {
                const lineCount = model.getLineCount();
                const endLine = lineNumber === lineCount;
                const prevLineEmptyOrIndented = lineNumber > 1 && isLineEmptyOrIndented(lineNumber - 1);
                const nextLineEmptyOrIndented = !endLine && isLineEmptyOrIndented(lineNumber + 1);
                const currLineEmptyOrIndented = isLineEmptyOrIndented(lineNumber);
                const notEmpty = !nextLineEmptyOrIndented && !prevLineEmptyOrIndented;
                // check above and below. if both are blocked, display lightbulb in the gutter.
                if (!nextLineEmptyOrIndented && !prevLineEmptyOrIndented && !hasDecoration) {
                    this.gutterState = new LightBulbState.Showing(actions, trigger, atPosition, {
                        position: {
                            lineNumber: effectiveLineNumber,
                            column: effectiveColumnNumber
                        },
                        preference: LightBulbWidget_1._posPref
                    });
                    this.renderGutterLightbub();
                    return this.hide();
                } else if (prevLineEmptyOrIndented || endLine || prevLineEmptyOrIndented && !currLineEmptyOrIndented) effectiveLineNumber -= 1;
                else if (nextLineEmptyOrIndented || notEmpty && currLineEmptyOrIndented) effectiveLineNumber += 1;
            } else if (lineNumber === 1 && (lineNumber === model.getLineCount() || !isLineEmptyOrIndented(lineNumber + 1) && !isLineEmptyOrIndented(lineNumber))) {
                // special checks for first line blocked vs. not blocked.
                this.gutterState = new LightBulbState.Showing(actions, trigger, atPosition, {
                    position: {
                        lineNumber: effectiveLineNumber,
                        column: effectiveColumnNumber
                    },
                    preference: LightBulbWidget_1._posPref
                });
                if (hasDecoration) this.gutterHide();
                else {
                    this.renderGutterLightbub();
                    return this.hide();
                }
            } else if (lineNumber < model.getLineCount() && !isFolded(lineNumber + 1)) effectiveLineNumber += 1;
            else if (column * fontInfo.spaceWidth < 22) // cannot show lightbulb above/below and showing
            // it inline would overlay the cursor...
            return this.hide();
            effectiveColumnNumber = /^\S\s*$/.test(model.getLineContent(effectiveLineNumber)) ? 2 : 1;
        }
        this.state = new LightBulbState.Showing(actions, trigger, atPosition, {
            position: {
                lineNumber: effectiveLineNumber,
                column: effectiveColumnNumber
            },
            preference: LightBulbWidget_1._posPref
        });
        if (this._gutterDecorationID) {
            this._removeGutterDecoration(this._gutterDecorationID);
            this.gutterHide();
        }
        const validActions = actions.validActions;
        const actionKind = actions.validActions[0].action.kind;
        if (validActions.length !== 1 || !actionKind) {
            this._editor.layoutContentWidget(this);
            return;
        }
        this._editor.layoutContentWidget(this);
    }
    hide() {
        if (this.state === LightBulbState.Hidden) return;
        this.state = LightBulbState.Hidden;
        this._editor.layoutContentWidget(this);
    }
    gutterHide() {
        if (this.gutterState === LightBulbState.Hidden) return;
        if (this._gutterDecorationID) this._removeGutterDecoration(this._gutterDecorationID);
        this.gutterState = LightBulbState.Hidden;
    }
    get state() {
        return this._state;
    }
    set state(value) {
        this._state = value;
        this._updateLightBulbTitleAndIcon();
    }
    get gutterState() {
        return this._gutterState;
    }
    set gutterState(value) {
        this._gutterState = value;
        this._updateGutterLightBulbTitleAndIcon();
    }
    _updateLightBulbTitleAndIcon() {
        this._domNode.classList.remove(...this._iconClasses);
        this._iconClasses = [];
        if (this.state.type !== 1 /* LightBulbState.Type.Showing */ ) return;
        let icon;
        let autoRun = false;
        if (this.state.actions.allAIFixes) {
            icon = (0, _codiconsJs.Codicon).sparkleFilled;
            if (this.state.actions.validActions.length === 1) autoRun = true;
        } else if (this.state.actions.hasAutoFix) {
            if (this.state.actions.hasAIFix) icon = (0, _codiconsJs.Codicon).lightbulbSparkleAutofix;
            else icon = (0, _codiconsJs.Codicon).lightbulbAutofix;
        } else if (this.state.actions.hasAIFix) icon = (0, _codiconsJs.Codicon).lightbulbSparkle;
        else icon = (0, _codiconsJs.Codicon).lightBulb;
        this._updateLightbulbTitle(this.state.actions.hasAutoFix, autoRun);
        this._iconClasses = (0, _themablesJs.ThemeIcon).asClassNameArray(icon);
        this._domNode.classList.add(...this._iconClasses);
    }
    _updateGutterLightBulbTitleAndIcon() {
        if (this.gutterState.type !== 1 /* LightBulbState.Type.Showing */ ) return;
        let icon;
        let autoRun = false;
        if (this.gutterState.actions.allAIFixes) {
            icon = GUTTER_SPARKLE_FILLED_ICON;
            if (this.gutterState.actions.validActions.length === 1) autoRun = true;
        } else if (this.gutterState.actions.hasAutoFix) {
            if (this.gutterState.actions.hasAIFix) icon = GUTTER_LIGHTBULB_AIFIX_AUTO_FIX_ICON;
            else icon = GUTTER_LIGHTBULB_AUTO_FIX_ICON;
        } else if (this.gutterState.actions.hasAIFix) icon = GUTTER_LIGHTBULB_AIFIX_ICON;
        else icon = GUTTER_LIGHTBULB_ICON;
        this._updateLightbulbTitle(this.gutterState.actions.hasAutoFix, autoRun);
        const GUTTER_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "codicon-gutter-lightbulb-decoration",
            glyphMarginClassName: (0, _themablesJs.ThemeIcon).asClassName(icon),
            glyphMargin: {
                position: (0, _modelJs.GlyphMarginLane).Left
            },
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ 
        });
        this.gutterDecoration = GUTTER_DECORATION;
    }
    /* Gutter Helper Functions */ renderGutterLightbub() {
        const selection = this._editor.getSelection();
        if (!selection) return;
        if (this._gutterDecorationID === undefined) this._addGutterDecoration(selection.startLineNumber);
        else this._updateGutterDecoration(this._gutterDecorationID, selection.startLineNumber);
    }
    _addGutterDecoration(lineNumber) {
        this._editor.changeDecorations((accessor)=>{
            this._gutterDecorationID = accessor.addDecoration(new (0, _rangeJs.Range)(lineNumber, 0, lineNumber, 0), this.gutterDecoration);
        });
    }
    _removeGutterDecoration(decorationId) {
        this._editor.changeDecorations((accessor)=>{
            accessor.removeDecoration(decorationId);
            this._gutterDecorationID = undefined;
        });
    }
    _updateGutterDecoration(decorationId, lineNumber) {
        this._editor.changeDecorations((accessor)=>{
            accessor.changeDecoration(decorationId, new (0, _rangeJs.Range)(lineNumber, 0, lineNumber, 0));
            accessor.changeDecorationOptions(decorationId, this.gutterDecoration);
        });
    }
    _updateLightbulbTitle(autoFix, autoRun) {
        if (this.state.type !== 1 /* LightBulbState.Type.Showing */ ) return;
        if (autoRun) this.title = _nlsJs.localize("codeActionAutoRun", "Run: {0}", this.state.actions.validActions[0].action.title);
        else if (autoFix && this._preferredKbLabel) this.title = _nlsJs.localize("preferredcodeActionWithKb", "Show Code Actions. Preferred Quick Fix Available ({0})", this._preferredKbLabel);
        else if (!autoFix && this._quickFixKbLabel) this.title = _nlsJs.localize("codeActionWithKb", "Show Code Actions ({0})", this._quickFixKbLabel);
        else if (!autoFix) this.title = _nlsJs.localize("codeAction", "Show Code Actions");
    }
    set title(value) {
        this._domNode.title = value;
    }
};
LightBulbWidget = LightBulbWidget_1 = __decorate([
    __param(1, (0, _keybindingJs.IKeybindingService))
], LightBulbWidget);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/touch.js":"6iGQn","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/themables.js":"hgyHi","./lightBulbWidget.css":"hjYP3","../../../common/model.js":"1CSIB","../../../common/model/textModel.js":"9beDe","../../../common/model/utils.js":"gEgu8","./codeAction.js":"6jIB5","../../../../nls.js":"l617d","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../platform/theme/common/iconRegistry.js":"bRNEz","../../../common/core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hjYP3":[function() {},{}],"a4aK5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IActionWidgetService", ()=>IActionWidgetService);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _domJs = require("../../../base/browser/dom.js");
var _actionbarJs = require("../../../base/browser/ui/actionbar/actionbar.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _actionWidgetCss = require("./actionWidget.css");
var _nlsJs = require("../../../nls.js");
var _actionListJs = require("./actionList.js");
var _actionsJs = require("../../actions/common/actions.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _contextViewJs = require("../../contextview/browser/contextView.js");
var _extensionsJs = require("../../instantiation/common/extensions.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var _colorRegistryJs = require("../../theme/common/colorRegistry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
(0, _colorRegistryJs.registerColor)("actionBar.toggledBackground", (0, _colorRegistryJs.inputActiveOptionBackground), (0, _nlsJs.localize)("actionBar.toggledBackground", "Background color for toggled action items in action bar."));
const ActionWidgetContextKeys = {
    Visible: new (0, _contextkeyJs.RawContextKey)("codeActionMenuVisible", false, (0, _nlsJs.localize)("codeActionMenuVisible", "Whether the action widget list is visible"))
};
const IActionWidgetService = (0, _instantiationJs.createDecorator)("actionWidgetService");
let ActionWidgetService = class ActionWidgetService extends (0, _lifecycleJs.Disposable) {
    get isVisible() {
        return ActionWidgetContextKeys.Visible.getValue(this._contextKeyService) || false;
    }
    constructor(_contextViewService, _contextKeyService, _instantiationService){
        super();
        this._contextViewService = _contextViewService;
        this._contextKeyService = _contextKeyService;
        this._instantiationService = _instantiationService;
        this._list = this._register(new (0, _lifecycleJs.MutableDisposable)());
    }
    show(user, supportsPreview, items, delegate, anchor, container, actionBarActions) {
        const visibleContext = ActionWidgetContextKeys.Visible.bindTo(this._contextKeyService);
        const list = this._instantiationService.createInstance((0, _actionListJs.ActionList), user, supportsPreview, items, delegate);
        this._contextViewService.showContextView({
            getAnchor: ()=>anchor,
            render: (container)=>{
                visibleContext.set(true);
                return this._renderWidget(container, list, actionBarActions ?? []);
            },
            onHide: (didCancel)=>{
                visibleContext.reset();
                this._onWidgetClosed(didCancel);
            }
        }, container, false);
    }
    acceptSelected(preview) {
        this._list.value?.acceptSelected(preview);
    }
    focusPrevious() {
        this._list?.value?.focusPrevious();
    }
    focusNext() {
        this._list?.value?.focusNext();
    }
    hide(didCancel) {
        this._list.value?.hide(didCancel);
        this._list.clear();
    }
    _renderWidget(element, list, actionBarActions) {
        const widget = document.createElement("div");
        widget.classList.add("action-widget");
        element.appendChild(widget);
        this._list.value = list;
        if (this._list.value) widget.appendChild(this._list.value.domNode);
        else throw new Error("List has no value");
        const renderDisposables = new (0, _lifecycleJs.DisposableStore)();
        // Invisible div to block mouse interaction in the rest of the UI
        const menuBlock = document.createElement("div");
        const block = element.appendChild(menuBlock);
        block.classList.add("context-view-block");
        renderDisposables.add(_domJs.addDisposableListener(block, _domJs.EventType.MOUSE_DOWN, (e)=>e.stopPropagation()));
        // Invisible div to block mouse interaction with the menu
        const pointerBlockDiv = document.createElement("div");
        const pointerBlock = element.appendChild(pointerBlockDiv);
        pointerBlock.classList.add("context-view-pointerBlock");
        // Removes block on click INSIDE widget or ANY mouse movement
        renderDisposables.add(_domJs.addDisposableListener(pointerBlock, _domJs.EventType.POINTER_MOVE, ()=>pointerBlock.remove()));
        renderDisposables.add(_domJs.addDisposableListener(pointerBlock, _domJs.EventType.MOUSE_DOWN, ()=>pointerBlock.remove()));
        // Action bar
        let actionBarWidth = 0;
        if (actionBarActions.length) {
            const actionBar = this._createActionBar(".action-widget-action-bar", actionBarActions);
            if (actionBar) {
                widget.appendChild(actionBar.getContainer().parentElement);
                renderDisposables.add(actionBar);
                actionBarWidth = actionBar.getContainer().offsetWidth;
            }
        }
        const width = this._list.value?.layout(actionBarWidth);
        widget.style.width = `${width}px`;
        const focusTracker = renderDisposables.add(_domJs.trackFocus(element));
        renderDisposables.add(focusTracker.onDidBlur(()=>this.hide(true)));
        return renderDisposables;
    }
    _createActionBar(className, actions) {
        if (!actions.length) return undefined;
        const container = _domJs.$(className);
        const actionBar = new (0, _actionbarJs.ActionBar)(container);
        actionBar.push(actions, {
            icon: false,
            label: true
        });
        return actionBar;
    }
    _onWidgetClosed(didCancel) {
        this._list.value?.hide(didCancel);
    }
};
ActionWidgetService = __decorate([
    __param(0, (0, _contextViewJs.IContextViewService)),
    __param(1, (0, _contextkeyJs.IContextKeyService)),
    __param(2, (0, _instantiationJs.IInstantiationService))
], ActionWidgetService);
(0, _extensionsJs.registerSingleton)(IActionWidgetService, ActionWidgetService, 1 /* InstantiationType.Delayed */ );
const weight = 1100;
(0, _actionsJs.registerAction2)(class extends (0, _actionsJs.Action2) {
    constructor(){
        super({
            id: "hideCodeActionWidget",
            title: (0, _nlsJs.localize2)("hideCodeActionWidget.title", "Hide action widget"),
            precondition: ActionWidgetContextKeys.Visible,
            keybinding: {
                weight,
                primary: 9 /* KeyCode.Escape */ ,
                secondary: [
                    1033 /* KeyCode.Escape */ 
                ]
            }
        });
    }
    run(accessor) {
        accessor.get(IActionWidgetService).hide(true);
    }
});
(0, _actionsJs.registerAction2)(class extends (0, _actionsJs.Action2) {
    constructor(){
        super({
            id: "selectPrevCodeAction",
            title: (0, _nlsJs.localize2)("selectPrevCodeAction.title", "Select previous action"),
            precondition: ActionWidgetContextKeys.Visible,
            keybinding: {
                weight,
                primary: 16 /* KeyCode.UpArrow */ ,
                secondary: [
                    2064 /* KeyCode.UpArrow */ 
                ],
                mac: {
                    primary: 16 /* KeyCode.UpArrow */ ,
                    secondary: [
                        2064 /* KeyCode.UpArrow */ ,
                        302 /* KeyCode.KeyP */ 
                    ]
                }
            }
        });
    }
    run(accessor) {
        const widgetService = accessor.get(IActionWidgetService);
        if (widgetService instanceof ActionWidgetService) widgetService.focusPrevious();
    }
});
(0, _actionsJs.registerAction2)(class extends (0, _actionsJs.Action2) {
    constructor(){
        super({
            id: "selectNextCodeAction",
            title: (0, _nlsJs.localize2)("selectNextCodeAction.title", "Select next action"),
            precondition: ActionWidgetContextKeys.Visible,
            keybinding: {
                weight,
                primary: 18 /* KeyCode.DownArrow */ ,
                secondary: [
                    2066 /* KeyCode.DownArrow */ 
                ],
                mac: {
                    primary: 18 /* KeyCode.DownArrow */ ,
                    secondary: [
                        2066 /* KeyCode.DownArrow */ ,
                        300 /* KeyCode.KeyN */ 
                    ]
                }
            }
        });
    }
    run(accessor) {
        const widgetService = accessor.get(IActionWidgetService);
        if (widgetService instanceof ActionWidgetService) widgetService.focusNext();
    }
});
(0, _actionsJs.registerAction2)(class extends (0, _actionsJs.Action2) {
    constructor(){
        super({
            id: (0, _actionListJs.acceptSelectedActionCommand),
            title: (0, _nlsJs.localize2)("acceptSelected.title", "Accept selected action"),
            precondition: ActionWidgetContextKeys.Visible,
            keybinding: {
                weight,
                primary: 3 /* KeyCode.Enter */ ,
                secondary: [
                    2137 /* KeyCode.Period */ 
                ]
            }
        });
    }
    run(accessor) {
        const widgetService = accessor.get(IActionWidgetService);
        if (widgetService instanceof ActionWidgetService) widgetService.acceptSelected();
    }
});
(0, _actionsJs.registerAction2)(class extends (0, _actionsJs.Action2) {
    constructor(){
        super({
            id: (0, _actionListJs.previewSelectedActionCommand),
            title: (0, _nlsJs.localize2)("previewSelected.title", "Preview selected action"),
            precondition: ActionWidgetContextKeys.Visible,
            keybinding: {
                weight,
                primary: 2051 /* KeyCode.Enter */ 
            }
        });
    }
    run(accessor) {
        const widgetService = accessor.get(IActionWidgetService);
        if (widgetService instanceof ActionWidgetService) widgetService.acceptSelected(true);
    }
});

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/ui/actionbar/actionbar.js":"5Xmba","../../../base/common/lifecycle.js":"9kg8d","./actionWidget.css":"4ftEH","../../../nls.js":"l617d","./actionList.js":"dRfNJ","../../actions/common/actions.js":"kyMtp","../../contextkey/common/contextkey.js":"gXuBD","../../contextview/browser/contextView.js":"2QlUR","../../instantiation/common/extensions.js":"6WJLq","../../instantiation/common/instantiation.js":"fjwWx","../../theme/common/colorRegistry.js":"ik5kv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ftEH":[function() {},{}],"dRfNJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "acceptSelectedActionCommand", ()=>acceptSelectedActionCommand);
parcelHelpers.export(exports, "previewSelectedActionCommand", ()=>previewSelectedActionCommand);
parcelHelpers.export(exports, "ActionList", ()=>ActionList);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _domJs = require("../../../base/browser/dom.js");
var _keybindingLabelJs = require("../../../base/browser/ui/keybindingLabel/keybindingLabel.js");
var _listWidgetJs = require("../../../base/browser/ui/list/listWidget.js");
var _cancellationJs = require("../../../base/common/cancellation.js");
var _codiconsJs = require("../../../base/common/codicons.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _platformJs = require("../../../base/common/platform.js");
var _themablesJs = require("../../../base/common/themables.js");
var _actionWidgetCss = require("./actionWidget.css");
var _nlsJs = require("../../../nls.js");
var _contextViewJs = require("../../contextview/browser/contextView.js");
var _keybindingJs = require("../../keybinding/common/keybinding.js");
var _defaultStylesJs = require("../../theme/browser/defaultStyles.js");
var _colorRegistryJs = require("../../theme/common/colorRegistry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const acceptSelectedActionCommand = "acceptSelectedCodeAction";
const previewSelectedActionCommand = "previewSelectedCodeAction";
class HeaderRenderer {
    get templateId() {
        return "header" /* ActionListItemKind.Header */ ;
    }
    renderTemplate(container) {
        container.classList.add("group-header");
        const text = document.createElement("span");
        container.append(text);
        return {
            container,
            text
        };
    }
    renderElement(element, _index, templateData) {
        templateData.text.textContent = element.group?.title ?? "";
    }
    disposeTemplate(_templateData) {
    // noop
    }
}
let ActionItemRenderer = class ActionItemRenderer {
    get templateId() {
        return "action" /* ActionListItemKind.Action */ ;
    }
    constructor(_supportsPreview, _keybindingService){
        this._supportsPreview = _supportsPreview;
        this._keybindingService = _keybindingService;
    }
    renderTemplate(container) {
        container.classList.add(this.templateId);
        const icon = document.createElement("div");
        icon.className = "icon";
        container.append(icon);
        const text = document.createElement("span");
        text.className = "title";
        container.append(text);
        const keybinding = new (0, _keybindingLabelJs.KeybindingLabel)(container, (0, _platformJs.OS));
        return {
            container,
            icon,
            text,
            keybinding
        };
    }
    renderElement(element, _index, data) {
        if (element.group?.icon) {
            data.icon.className = (0, _themablesJs.ThemeIcon).asClassName(element.group.icon);
            if (element.group.icon.color) data.icon.style.color = (0, _colorRegistryJs.asCssVariable)(element.group.icon.color.id);
        } else {
            data.icon.className = (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).lightBulb);
            data.icon.style.color = "var(--vscode-editorLightBulb-foreground)";
        }
        if (!element.item || !element.label) return;
        data.text.textContent = stripNewlines(element.label);
        data.keybinding.set(element.keybinding);
        _domJs.setVisibility(!!element.keybinding, data.keybinding.element);
        const actionTitle = this._keybindingService.lookupKeybinding(acceptSelectedActionCommand)?.getLabel();
        const previewTitle = this._keybindingService.lookupKeybinding(previewSelectedActionCommand)?.getLabel();
        data.container.classList.toggle("option-disabled", element.disabled);
        if (element.disabled) data.container.title = element.label;
        else if (actionTitle && previewTitle) {
            if (this._supportsPreview && element.canPreview) data.container.title = (0, _nlsJs.localize)({
                key: "label-preview",
                comment: [
                    'placeholders are keybindings, e.g "F2 to Apply, Shift+F2 to Preview"'
                ]
            }, "{0} to Apply, {1} to Preview", actionTitle, previewTitle);
            else data.container.title = (0, _nlsJs.localize)({
                key: "label",
                comment: [
                    'placeholder is a keybinding, e.g "F2 to Apply"'
                ]
            }, "{0} to Apply", actionTitle);
        } else data.container.title = "";
    }
    disposeTemplate(_templateData) {
        _templateData.keybinding.dispose();
    }
};
ActionItemRenderer = __decorate([
    __param(1, (0, _keybindingJs.IKeybindingService))
], ActionItemRenderer);
class AcceptSelectedEvent extends UIEvent {
    constructor(){
        super("acceptSelectedAction");
    }
}
class PreviewSelectedEvent extends UIEvent {
    constructor(){
        super("previewSelectedAction");
    }
}
function getKeyboardNavigationLabel(item) {
    // Filter out header vs. action
    if (item.kind === "action") return item.label;
    return undefined;
}
let ActionList = class ActionList extends (0, _lifecycleJs.Disposable) {
    constructor(user, preview, items, _delegate, _contextViewService, _keybindingService){
        super();
        this._delegate = _delegate;
        this._contextViewService = _contextViewService;
        this._keybindingService = _keybindingService;
        this._actionLineHeight = 24;
        this._headerLineHeight = 26;
        this.cts = this._register(new (0, _cancellationJs.CancellationTokenSource)());
        this.domNode = document.createElement("div");
        this.domNode.classList.add("actionList");
        const virtualDelegate = {
            getHeight: (element)=>element.kind === "header" /* ActionListItemKind.Header */  ? this._headerLineHeight : this._actionLineHeight,
            getTemplateId: (element)=>element.kind
        };
        this._list = this._register(new (0, _listWidgetJs.List)(user, this.domNode, virtualDelegate, [
            new ActionItemRenderer(preview, this._keybindingService),
            new HeaderRenderer()
        ], {
            keyboardSupport: false,
            typeNavigationEnabled: true,
            keyboardNavigationLabelProvider: {
                getKeyboardNavigationLabel
            },
            accessibilityProvider: {
                getAriaLabel: (element)=>{
                    if (element.kind === "action" /* ActionListItemKind.Action */ ) {
                        let label = element.label ? stripNewlines(element?.label) : "";
                        if (element.disabled) label = (0, _nlsJs.localize)({
                            key: "customQuickFixWidget.labels",
                            comment: [
                                `Action widget labels for accessibility.`
                            ]
                        }, "{0}, Disabled Reason: {1}", label, element.disabled);
                        return label;
                    }
                    return null;
                },
                getWidgetAriaLabel: ()=>(0, _nlsJs.localize)({
                        key: "customQuickFixWidget",
                        comment: [
                            `An action widget option`
                        ]
                    }, "Action Widget"),
                getRole: (e)=>e.kind === "action" /* ActionListItemKind.Action */  ? "option" : "separator",
                getWidgetRole: ()=>"listbox"
            }
        }));
        this._list.style((0, _defaultStylesJs.defaultListStyles));
        this._register(this._list.onMouseClick((e)=>this.onListClick(e)));
        this._register(this._list.onMouseOver((e)=>this.onListHover(e)));
        this._register(this._list.onDidChangeFocus(()=>this.onFocus()));
        this._register(this._list.onDidChangeSelection((e)=>this.onListSelection(e)));
        this._allMenuItems = items;
        this._list.splice(0, this._list.length, this._allMenuItems);
        if (this._list.length) this.focusNext();
    }
    focusCondition(element) {
        return !element.disabled && element.kind === "action" /* ActionListItemKind.Action */ ;
    }
    hide(didCancel) {
        this._delegate.onHide(didCancel);
        this.cts.cancel();
        this._contextViewService.hideContextView();
    }
    layout(minWidth) {
        // Updating list height, depending on how many separators and headers there are.
        const numHeaders = this._allMenuItems.filter((item)=>item.kind === "header").length;
        const itemsHeight = this._allMenuItems.length * this._actionLineHeight;
        const heightWithHeaders = itemsHeight + numHeaders * this._headerLineHeight - numHeaders * this._actionLineHeight;
        this._list.layout(heightWithHeaders);
        let maxWidth = minWidth;
        if (this._allMenuItems.length >= 50) maxWidth = 380;
        else {
            // For finding width dynamically (not using resize observer)
            const itemWidths = this._allMenuItems.map((_, index)=>{
                const element = this.domNode.ownerDocument.getElementById(this._list.getElementID(index));
                if (element) {
                    element.style.width = "auto";
                    const width = element.getBoundingClientRect().width;
                    element.style.width = "";
                    return width;
                }
                return 0;
            });
            // resize observer - can be used in the future since list widget supports dynamic height but not width
            maxWidth = Math.max(...itemWidths, minWidth);
        }
        const maxVhPrecentage = 0.7;
        const height = Math.min(heightWithHeaders, this.domNode.ownerDocument.body.clientHeight * maxVhPrecentage);
        this._list.layout(height, maxWidth);
        this.domNode.style.height = `${height}px`;
        this._list.domFocus();
        return maxWidth;
    }
    focusPrevious() {
        this._list.focusPrevious(1, true, undefined, this.focusCondition);
    }
    focusNext() {
        this._list.focusNext(1, true, undefined, this.focusCondition);
    }
    acceptSelected(preview) {
        const focused = this._list.getFocus();
        if (focused.length === 0) return;
        const focusIndex = focused[0];
        const element = this._list.element(focusIndex);
        if (!this.focusCondition(element)) return;
        const event = preview ? new PreviewSelectedEvent() : new AcceptSelectedEvent();
        this._list.setSelection([
            focusIndex
        ], event);
    }
    onListSelection(e) {
        if (!e.elements.length) return;
        const element = e.elements[0];
        if (element.item && this.focusCondition(element)) this._delegate.onSelect(element.item, e.browserEvent instanceof PreviewSelectedEvent);
        else this._list.setSelection([]);
    }
    onFocus() {
        const focused = this._list.getFocus();
        if (focused.length === 0) return;
        const focusIndex = focused[0];
        const element = this._list.element(focusIndex);
        this._delegate.onFocus?.(element.item);
    }
    async onListHover(e) {
        const element = e.element;
        if (element && element.item && this.focusCondition(element)) {
            if (this._delegate.onHover && !element.disabled && element.kind === "action" /* ActionListItemKind.Action */ ) {
                const result = await this._delegate.onHover(element.item, this.cts.token);
                element.canPreview = result ? result.canPreview : undefined;
            }
            if (e.index) this._list.splice(e.index, 1, [
                element
            ]);
        }
        this._list.setFocus(typeof e.index === "number" ? [
            e.index
        ] : []);
    }
    onListClick(e) {
        if (e.element && this.focusCondition(e.element)) this._list.setFocus([]);
    }
};
ActionList = __decorate([
    __param(4, (0, _contextViewJs.IContextViewService)),
    __param(5, (0, _keybindingJs.IKeybindingService))
], ActionList);
function stripNewlines(str) {
    return str.replace(/\r\n|\r|\n/g, " ");
}

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/ui/keybindingLabel/keybindingLabel.js":"hpphu","../../../base/browser/ui/list/listWidget.js":"f6tmg","../../../base/common/cancellation.js":"hoVxw","../../../base/common/codicons.js":"hWYNf","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/platform.js":"7maJO","../../../base/common/themables.js":"hgyHi","./actionWidget.css":"4ftEH","../../../nls.js":"l617d","../../contextview/browser/contextView.js":"2QlUR","../../keybinding/common/keybinding.js":"25pLT","../../theme/browser/defaultStyles.js":"4exuA","../../theme/common/colorRegistry.js":"ik5kv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ftEH":[function() {},{}],"8KDSO":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SUPPORTED_CODE_ACTIONS", ()=>SUPPORTED_CODE_ACTIONS);
parcelHelpers.export(exports, "APPLY_FIX_ALL_COMMAND_ID", ()=>APPLY_FIX_ALL_COMMAND_ID);
parcelHelpers.export(exports, "CodeActionsState", ()=>CodeActionsState);
parcelHelpers.export(exports, "CodeActionModel", ()=>CodeActionModel);
var _asyncJs = require("../../../../base/common/async.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _resourcesJs = require("../../../../base/common/resources.js");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
var _positionJs = require("../../../common/core/position.js");
var _selectionJs = require("../../../common/core/selection.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _progressJs = require("../../../../platform/progress/common/progress.js");
var _typesJs = require("../common/types.js");
var _codeActionJs = require("./codeAction.js");
var _hierarchicalKindJs = require("../../../../base/common/hierarchicalKind.js");
var _stopwatchJs = require("../../../../base/common/stopwatch.js");
const SUPPORTED_CODE_ACTIONS = new (0, _contextkeyJs.RawContextKey)("supportedCodeAction", "");
const APPLY_FIX_ALL_COMMAND_ID = "_typescript.applyFixAllCodeAction";
class CodeActionOracle extends (0, _lifecycleJs.Disposable) {
    constructor(_editor, _markerService, _signalChange, _delay = 250){
        super();
        this._editor = _editor;
        this._markerService = _markerService;
        this._signalChange = _signalChange;
        this._delay = _delay;
        this._autoTriggerTimer = this._register(new (0, _asyncJs.TimeoutTimer)());
        this._register(this._markerService.onMarkerChanged((e)=>this._onMarkerChanges(e)));
        this._register(this._editor.onDidChangeCursorPosition(()=>this._tryAutoTrigger()));
    }
    trigger(trigger) {
        const selection = this._getRangeOfSelectionUnlessWhitespaceEnclosed(trigger);
        this._signalChange(selection ? {
            trigger,
            selection
        } : undefined);
    }
    _onMarkerChanges(resources) {
        const model = this._editor.getModel();
        if (model && resources.some((resource)=>(0, _resourcesJs.isEqual)(resource, model.uri))) this._tryAutoTrigger();
    }
    _tryAutoTrigger() {
        this._autoTriggerTimer.cancelAndSet(()=>{
            this.trigger({
                type: 2 /* CodeActionTriggerType.Auto */ ,
                triggerAction: (0, _typesJs.CodeActionTriggerSource).Default
            });
        }, this._delay);
    }
    _getRangeOfSelectionUnlessWhitespaceEnclosed(trigger) {
        if (!this._editor.hasModel()) return undefined;
        const selection = this._editor.getSelection();
        if (trigger.type === 1 /* CodeActionTriggerType.Invoke */ ) return selection;
        const enabled = this._editor.getOption(65 /* EditorOption.lightbulb */ ).enabled;
        if (enabled === (0, _editorOptionsJs.ShowLightbulbIconMode).Off) return undefined;
        else if (enabled === (0, _editorOptionsJs.ShowLightbulbIconMode).On) return selection;
        else if (enabled === (0, _editorOptionsJs.ShowLightbulbIconMode).OnCode) {
            const isSelectionEmpty = selection.isEmpty();
            if (!isSelectionEmpty) return selection;
            const model = this._editor.getModel();
            const { lineNumber, column } = selection.getPosition();
            const line = model.getLineContent(lineNumber);
            if (line.length === 0) // empty line
            return undefined;
            else if (column === 1) {
                // look only right
                if (/\s/.test(line[0])) return undefined;
            } else if (column === model.getLineMaxColumn(lineNumber)) {
                // look only left
                if (/\s/.test(line[line.length - 1])) return undefined;
            } else {
                // look left and right
                if (/\s/.test(line[column - 2]) && /\s/.test(line[column - 1])) return undefined;
            }
        }
        return selection;
    }
}
var CodeActionsState;
(function(CodeActionsState) {
    CodeActionsState.Empty = {
        type: 0 /* Type.Empty */ 
    };
    class Triggered {
        constructor(trigger, position, _cancellablePromise){
            this.trigger = trigger;
            this.position = position;
            this._cancellablePromise = _cancellablePromise;
            this.type = 1 /* Type.Triggered */ ;
            this.actions = _cancellablePromise.catch((e)=>{
                if ((0, _errorsJs.isCancellationError)(e)) return emptyCodeActionSet;
                throw e;
            });
        }
        cancel() {
            this._cancellablePromise.cancel();
        }
    }
    CodeActionsState.Triggered = Triggered;
})(CodeActionsState || (CodeActionsState = {}));
const emptyCodeActionSet = Object.freeze({
    allActions: [],
    validActions: [],
    dispose: ()=>{},
    documentation: [],
    hasAutoFix: false,
    hasAIFix: false,
    allAIFixes: false
});
class CodeActionModel extends (0, _lifecycleJs.Disposable) {
    constructor(_editor, _registry, _markerService, contextKeyService, _progressService, _configurationService, _telemetryService){
        super();
        this._editor = _editor;
        this._registry = _registry;
        this._markerService = _markerService;
        this._progressService = _progressService;
        this._configurationService = _configurationService;
        this._telemetryService = _telemetryService;
        this._codeActionOracle = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this._state = CodeActionsState.Empty;
        this._onDidChangeState = this._register(new (0, _eventJs.Emitter)());
        this.onDidChangeState = this._onDidChangeState.event;
        this._disposed = false;
        this._supportedCodeActions = SUPPORTED_CODE_ACTIONS.bindTo(contextKeyService);
        this._register(this._editor.onDidChangeModel(()=>this._update()));
        this._register(this._editor.onDidChangeModelLanguage(()=>this._update()));
        this._register(this._registry.onDidChange(()=>this._update()));
        this._register(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(65 /* EditorOption.lightbulb */ )) this._update();
        }));
        this._update();
    }
    dispose() {
        if (this._disposed) return;
        this._disposed = true;
        super.dispose();
        this.setState(CodeActionsState.Empty, true);
    }
    _settingEnabledNearbyQuickfixes() {
        const model = this._editor?.getModel();
        return this._configurationService ? this._configurationService.getValue("editor.codeActionWidget.includeNearbyQuickFixes", {
            resource: model?.uri
        }) : false;
    }
    _update() {
        if (this._disposed) return;
        this._codeActionOracle.value = undefined;
        this.setState(CodeActionsState.Empty);
        const model = this._editor.getModel();
        if (model && this._registry.has(model) && !this._editor.getOption(92 /* EditorOption.readOnly */ )) {
            const supportedActions = this._registry.all(model).flatMap((provider)=>provider.providedCodeActionKinds ?? []);
            this._supportedCodeActions.set(supportedActions.join(" "));
            this._codeActionOracle.value = new CodeActionOracle(this._editor, this._markerService, (trigger)=>{
                if (!trigger) {
                    this.setState(CodeActionsState.Empty);
                    return;
                }
                const startPosition = trigger.selection.getStartPosition();
                const actions = (0, _asyncJs.createCancelablePromise)(async (token)=>{
                    if (this._settingEnabledNearbyQuickfixes() && trigger.trigger.type === 1 /* CodeActionTriggerType.Invoke */  && (trigger.trigger.triggerAction === (0, _typesJs.CodeActionTriggerSource).QuickFix || trigger.trigger.filter?.include?.contains((0, _typesJs.CodeActionKind).QuickFix))) {
                        const codeActionSet = await (0, _codeActionJs.getCodeActions)(this._registry, model, trigger.selection, trigger.trigger, (0, _progressJs.Progress).None, token);
                        const allCodeActions = [
                            ...codeActionSet.allActions
                        ];
                        if (token.isCancellationRequested) return emptyCodeActionSet;
                        // Search for quickfixes in the curret code action set.
                        const foundQuickfix = codeActionSet.validActions?.some((action)=>action.action.kind ? (0, _typesJs.CodeActionKind).QuickFix.contains(new (0, _hierarchicalKindJs.HierarchicalKind)(action.action.kind)) : false);
                        const allMarkers = this._markerService.read({
                            resource: model.uri
                        });
                        if (foundQuickfix) {
                            for (const action of codeActionSet.validActions)if (action.action.command?.arguments?.some((arg)=>typeof arg === "string" && arg.includes(APPLY_FIX_ALL_COMMAND_ID))) action.action.diagnostics = [
                                ...allMarkers.filter((marker)=>marker.relatedInformation)
                            ];
                            return {
                                validActions: codeActionSet.validActions,
                                allActions: allCodeActions,
                                documentation: codeActionSet.documentation,
                                hasAutoFix: codeActionSet.hasAutoFix,
                                hasAIFix: codeActionSet.hasAIFix,
                                allAIFixes: codeActionSet.allAIFixes,
                                dispose: ()=>{
                                    codeActionSet.dispose();
                                }
                            };
                        } else if (!foundQuickfix) // If markers exists, and there are no quickfixes found or length is zero, check for quickfixes on that line.
                        {
                            if (allMarkers.length > 0) {
                                const currPosition = trigger.selection.getPosition();
                                let trackedPosition = currPosition;
                                let distance = Number.MAX_VALUE;
                                const currentActions = [
                                    ...codeActionSet.validActions
                                ];
                                for (const marker of allMarkers){
                                    const col = marker.endColumn;
                                    const row = marker.endLineNumber;
                                    const startRow = marker.startLineNumber;
                                    // Found quickfix on the same line and check relative distance to other markers
                                    if (row === currPosition.lineNumber || startRow === currPosition.lineNumber) {
                                        trackedPosition = new (0, _positionJs.Position)(row, col);
                                        const newCodeActionTrigger = {
                                            type: trigger.trigger.type,
                                            triggerAction: trigger.trigger.triggerAction,
                                            filter: {
                                                include: trigger.trigger.filter?.include ? trigger.trigger.filter?.include : (0, _typesJs.CodeActionKind).QuickFix
                                            },
                                            autoApply: trigger.trigger.autoApply,
                                            context: {
                                                notAvailableMessage: trigger.trigger.context?.notAvailableMessage || "",
                                                position: trackedPosition
                                            }
                                        };
                                        const selectionAsPosition = new (0, _selectionJs.Selection)(trackedPosition.lineNumber, trackedPosition.column, trackedPosition.lineNumber, trackedPosition.column);
                                        const actionsAtMarker = await (0, _codeActionJs.getCodeActions)(this._registry, model, selectionAsPosition, newCodeActionTrigger, (0, _progressJs.Progress).None, token);
                                        if (actionsAtMarker.validActions.length !== 0) {
                                            for (const action of actionsAtMarker.validActions)if (action.action.command?.arguments?.some((arg)=>typeof arg === "string" && arg.includes(APPLY_FIX_ALL_COMMAND_ID))) action.action.diagnostics = [
                                                ...allMarkers.filter((marker)=>marker.relatedInformation)
                                            ];
                                            if (codeActionSet.allActions.length === 0) allCodeActions.push(...actionsAtMarker.allActions);
                                            // Already filtered through to only get quickfixes, so no need to filter again.
                                            if (Math.abs(currPosition.column - col) < distance) currentActions.unshift(...actionsAtMarker.validActions);
                                            else currentActions.push(...actionsAtMarker.validActions);
                                        }
                                        distance = Math.abs(currPosition.column - col);
                                    }
                                }
                                const filteredActions = currentActions.filter((action, index, self)=>self.findIndex((a)=>a.action.title === action.action.title) === index);
                                filteredActions.sort((a, b)=>{
                                    if (a.action.isPreferred && !b.action.isPreferred) return -1;
                                    else if (!a.action.isPreferred && b.action.isPreferred) return 1;
                                    else if (a.action.isAI && !b.action.isAI) return 1;
                                    else if (!a.action.isAI && b.action.isAI) return -1;
                                    else return 0;
                                });
                                // Only retriggers if actually found quickfix on the same line as cursor
                                return {
                                    validActions: filteredActions,
                                    allActions: allCodeActions,
                                    documentation: codeActionSet.documentation,
                                    hasAutoFix: codeActionSet.hasAutoFix,
                                    hasAIFix: codeActionSet.hasAIFix,
                                    allAIFixes: codeActionSet.allAIFixes,
                                    dispose: ()=>{
                                        codeActionSet.dispose();
                                    }
                                };
                            }
                        }
                    }
                    // Case for manual triggers - specifically Source Actions and Refactors
                    if (trigger.trigger.type === 1 /* CodeActionTriggerType.Invoke */ ) {
                        const sw = new (0, _stopwatchJs.StopWatch)();
                        const codeActions = await (0, _codeActionJs.getCodeActions)(this._registry, model, trigger.selection, trigger.trigger, (0, _progressJs.Progress).None, token);
                        // Telemetry for duration of each code action on save.
                        if (this._telemetryService) this._telemetryService.publicLog2("codeAction.invokedDurations", {
                            codeActions: codeActions.validActions.length,
                            duration: sw.elapsed()
                        });
                        return codeActions;
                    }
                    return (0, _codeActionJs.getCodeActions)(this._registry, model, trigger.selection, trigger.trigger, (0, _progressJs.Progress).None, token);
                });
                if (trigger.trigger.type === 1 /* CodeActionTriggerType.Invoke */ ) this._progressService?.showWhile(actions, 250);
                const newState = new CodeActionsState.Triggered(trigger.trigger, startPosition, actions);
                let isManualToAutoTransition = false;
                if (this._state.type === 1 /* CodeActionsState.Type.Triggered */ ) // Check if the current state is manual and the new state is automatic
                isManualToAutoTransition = this._state.trigger.type === 1 /* CodeActionTriggerType.Invoke */  && newState.type === 1 /* CodeActionsState.Type.Triggered */  && newState.trigger.type === 2 /* CodeActionTriggerType.Auto */  && this._state.position !== newState.position;
                // Do not trigger state if current state is manual and incoming state is automatic
                if (!isManualToAutoTransition) this.setState(newState);
                else // Reset the new state after getting code actions back.
                setTimeout(()=>{
                    this.setState(newState);
                }, 500);
            }, undefined);
            this._codeActionOracle.value.trigger({
                type: 2 /* CodeActionTriggerType.Auto */ ,
                triggerAction: (0, _typesJs.CodeActionTriggerSource).Default
            });
        } else this._supportedCodeActions.reset();
    }
    trigger(trigger) {
        this._codeActionOracle.value?.trigger(trigger);
    }
    setState(newState, skipNotify) {
        if (newState === this._state) return;
        // Cancel old request
        if (this._state.type === 1 /* CodeActionsState.Type.Triggered */ ) this._state.cancel();
        this._state = newState;
        if (!skipNotify && !this._disposed) this._onDidChangeState.fire(newState);
    }
}

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/errors.js":"divX8","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/resources.js":"700EV","../../../common/config/editorOptions.js":"3Xi00","../../../common/core/position.js":"lvrPe","../../../common/core/selection.js":"kcwzU","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/progress/common/progress.js":"f49eD","../common/types.js":"jJnno","./codeAction.js":"6jIB5","../../../../base/common/hierarchicalKind.js":"eXua8","../../../../base/common/stopwatch.js":"77PF9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"37ZM8":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeLensContribution", ()=>CodeLensContribution);
var _asyncJs = require("../../../../base/common/async.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stableEditorScrollJs = require("../../../browser/stableEditorScroll.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _codelensJs = require("./codelens.js");
var _codeLensCacheJs = require("./codeLensCache.js");
var _codelensWidgetJs = require("./codelensWidget.js");
var _nlsJs = require("../../../../nls.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var _quickInputJs = require("../../../../platform/quickinput/common/quickInput.js");
var _languageFeatureDebounceJs = require("../../../common/services/languageFeatureDebounce.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let CodeLensContribution = class CodeLensContribution {
    static{
        this.ID = "css.editor.codeLens";
    }
    constructor(_editor, _languageFeaturesService, debounceService, _commandService, _notificationService, _codeLensCache){
        this._editor = _editor;
        this._languageFeaturesService = _languageFeaturesService;
        this._commandService = _commandService;
        this._notificationService = _notificationService;
        this._codeLensCache = _codeLensCache;
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._localToDispose = new (0, _lifecycleJs.DisposableStore)();
        this._lenses = [];
        this._oldCodeLensModels = new (0, _lifecycleJs.DisposableStore)();
        this._provideCodeLensDebounce = debounceService.for(_languageFeaturesService.codeLensProvider, "CodeLensProvide", {
            min: 250
        });
        this._resolveCodeLensesDebounce = debounceService.for(_languageFeaturesService.codeLensProvider, "CodeLensResolve", {
            min: 250,
            salt: "resolve"
        });
        this._resolveCodeLensesScheduler = new (0, _asyncJs.RunOnceScheduler)(()=>this._resolveCodeLensesInViewport(), this._resolveCodeLensesDebounce.default());
        this._disposables.add(this._editor.onDidChangeModel(()=>this._onModelChange()));
        this._disposables.add(this._editor.onDidChangeModelLanguage(()=>this._onModelChange()));
        this._disposables.add(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(50 /* EditorOption.fontInfo */ ) || e.hasChanged(19 /* EditorOption.codeLensFontSize */ ) || e.hasChanged(18 /* EditorOption.codeLensFontFamily */ )) this._updateLensStyle();
            if (e.hasChanged(17 /* EditorOption.codeLens */ )) this._onModelChange();
        }));
        this._disposables.add(_languageFeaturesService.codeLensProvider.onDidChange(this._onModelChange, this));
        this._onModelChange();
        this._updateLensStyle();
    }
    dispose() {
        this._localDispose();
        this._disposables.dispose();
        this._oldCodeLensModels.dispose();
        this._currentCodeLensModel?.dispose();
    }
    _getLayoutInfo() {
        const lineHeightFactor = Math.max(1.3, this._editor.getOption(67 /* EditorOption.lineHeight */ ) / this._editor.getOption(52 /* EditorOption.fontSize */ ));
        let fontSize = this._editor.getOption(19 /* EditorOption.codeLensFontSize */ );
        if (!fontSize || fontSize < 5) fontSize = this._editor.getOption(52 /* EditorOption.fontSize */ ) * .9 | 0;
        return {
            fontSize,
            codeLensHeight: fontSize * lineHeightFactor | 0
        };
    }
    _updateLensStyle() {
        const { codeLensHeight, fontSize } = this._getLayoutInfo();
        const fontFamily = this._editor.getOption(18 /* EditorOption.codeLensFontFamily */ );
        const editorFontInfo = this._editor.getOption(50 /* EditorOption.fontInfo */ );
        const { style } = this._editor.getContainerDomNode();
        style.setProperty("--vscode-editorCodeLens-lineHeight", `${codeLensHeight}px`);
        style.setProperty("--vscode-editorCodeLens-fontSize", `${fontSize}px`);
        style.setProperty("--vscode-editorCodeLens-fontFeatureSettings", editorFontInfo.fontFeatureSettings);
        if (fontFamily) {
            style.setProperty("--vscode-editorCodeLens-fontFamily", fontFamily);
            style.setProperty("--vscode-editorCodeLens-fontFamilyDefault", (0, _editorOptionsJs.EDITOR_FONT_DEFAULTS).fontFamily);
        }
        //
        this._editor.changeViewZones((accessor)=>{
            for (const lens of this._lenses)lens.updateHeight(codeLensHeight, accessor);
        });
    }
    _localDispose() {
        this._getCodeLensModelPromise?.cancel();
        this._getCodeLensModelPromise = undefined;
        this._resolveCodeLensesPromise?.cancel();
        this._resolveCodeLensesPromise = undefined;
        this._localToDispose.clear();
        this._oldCodeLensModels.clear();
        this._currentCodeLensModel?.dispose();
    }
    _onModelChange() {
        this._localDispose();
        const model = this._editor.getModel();
        if (!model) return;
        if (!this._editor.getOption(17 /* EditorOption.codeLens */ ) || model.isTooLargeForTokenization()) return;
        const cachedLenses = this._codeLensCache.get(model);
        if (cachedLenses) this._renderCodeLensSymbols(cachedLenses);
        if (!this._languageFeaturesService.codeLensProvider.has(model)) {
            // no provider -> return but check with
            // cached lenses. they expire after 30 seconds
            if (cachedLenses) (0, _asyncJs.disposableTimeout)(()=>{
                const cachedLensesNow = this._codeLensCache.get(model);
                if (cachedLenses === cachedLensesNow) {
                    this._codeLensCache.delete(model);
                    this._onModelChange();
                }
            }, 30000, this._localToDispose);
            return;
        }
        for (const provider of this._languageFeaturesService.codeLensProvider.all(model))if (typeof provider.onDidChange === "function") {
            const registration = provider.onDidChange(()=>scheduler.schedule());
            this._localToDispose.add(registration);
        }
        const scheduler = new (0, _asyncJs.RunOnceScheduler)(()=>{
            const t1 = Date.now();
            this._getCodeLensModelPromise?.cancel();
            this._getCodeLensModelPromise = (0, _asyncJs.createCancelablePromise)((token)=>(0, _codelensJs.getCodeLensModel)(this._languageFeaturesService.codeLensProvider, model, token));
            this._getCodeLensModelPromise.then((result)=>{
                if (this._currentCodeLensModel) this._oldCodeLensModels.add(this._currentCodeLensModel);
                this._currentCodeLensModel = result;
                // cache model to reduce flicker
                this._codeLensCache.put(model, result);
                // update moving average
                const newDelay = this._provideCodeLensDebounce.update(model, Date.now() - t1);
                scheduler.delay = newDelay;
                // render lenses
                this._renderCodeLensSymbols(result);
                // dom.scheduleAtNextAnimationFrame(() => this._resolveCodeLensesInViewport());
                this._resolveCodeLensesInViewportSoon();
            }, (0, _errorsJs.onUnexpectedError));
        }, this._provideCodeLensDebounce.get(model));
        this._localToDispose.add(scheduler);
        this._localToDispose.add((0, _lifecycleJs.toDisposable)(()=>this._resolveCodeLensesScheduler.cancel()));
        this._localToDispose.add(this._editor.onDidChangeModelContent(()=>{
            this._editor.changeDecorations((decorationsAccessor)=>{
                this._editor.changeViewZones((viewZonesAccessor)=>{
                    const toDispose = [];
                    let lastLensLineNumber = -1;
                    this._lenses.forEach((lens)=>{
                        if (!lens.isValid() || lastLensLineNumber === lens.getLineNumber()) // invalid -> lens collapsed, attach range doesn't exist anymore
                        // line_number -> lenses should never be on the same line
                        toDispose.push(lens);
                        else {
                            lens.update(viewZonesAccessor);
                            lastLensLineNumber = lens.getLineNumber();
                        }
                    });
                    const helper = new (0, _codelensWidgetJs.CodeLensHelper)();
                    toDispose.forEach((l)=>{
                        l.dispose(helper, viewZonesAccessor);
                        this._lenses.splice(this._lenses.indexOf(l), 1);
                    });
                    helper.commit(decorationsAccessor);
                });
            });
            // Ask for all references again
            scheduler.schedule();
            // Cancel pending and active resolve requests
            this._resolveCodeLensesScheduler.cancel();
            this._resolveCodeLensesPromise?.cancel();
            this._resolveCodeLensesPromise = undefined;
        }));
        this._localToDispose.add(this._editor.onDidFocusEditorText(()=>{
            scheduler.schedule();
        }));
        this._localToDispose.add(this._editor.onDidBlurEditorText(()=>{
            scheduler.cancel();
        }));
        this._localToDispose.add(this._editor.onDidScrollChange((e)=>{
            if (e.scrollTopChanged && this._lenses.length > 0) this._resolveCodeLensesInViewportSoon();
        }));
        this._localToDispose.add(this._editor.onDidLayoutChange(()=>{
            this._resolveCodeLensesInViewportSoon();
        }));
        this._localToDispose.add((0, _lifecycleJs.toDisposable)(()=>{
            if (this._editor.getModel()) {
                const scrollState = (0, _stableEditorScrollJs.StableEditorScrollState).capture(this._editor);
                this._editor.changeDecorations((decorationsAccessor)=>{
                    this._editor.changeViewZones((viewZonesAccessor)=>{
                        this._disposeAllLenses(decorationsAccessor, viewZonesAccessor);
                    });
                });
                scrollState.restore(this._editor);
            } else // No accessors available
            this._disposeAllLenses(undefined, undefined);
        }));
        this._localToDispose.add(this._editor.onMouseDown((e)=>{
            if (e.target.type !== 9 /* MouseTargetType.CONTENT_WIDGET */ ) return;
            let target = e.target.element;
            if (target?.tagName === "SPAN") target = target.parentElement;
            if (target?.tagName === "A") for (const lens of this._lenses){
                const command = lens.getCommand(target);
                if (command) {
                    this._commandService.executeCommand(command.id, ...command.arguments || []).catch((err)=>this._notificationService.error(err));
                    break;
                }
            }
        }));
        scheduler.schedule();
    }
    _disposeAllLenses(decChangeAccessor, viewZoneChangeAccessor) {
        const helper = new (0, _codelensWidgetJs.CodeLensHelper)();
        for (const lens of this._lenses)lens.dispose(helper, viewZoneChangeAccessor);
        if (decChangeAccessor) helper.commit(decChangeAccessor);
        this._lenses.length = 0;
    }
    _renderCodeLensSymbols(symbols) {
        if (!this._editor.hasModel()) return;
        const maxLineNumber = this._editor.getModel().getLineCount();
        const groups = [];
        let lastGroup;
        for (const symbol of symbols.lenses){
            const line = symbol.symbol.range.startLineNumber;
            if (line < 1 || line > maxLineNumber) continue;
            else if (lastGroup && lastGroup[lastGroup.length - 1].symbol.range.startLineNumber === line) // on same line as previous
            lastGroup.push(symbol);
            else {
                // on later line as previous
                lastGroup = [
                    symbol
                ];
                groups.push(lastGroup);
            }
        }
        if (!groups.length && !this._lenses.length) // Nothing to change
        return;
        const scrollState = (0, _stableEditorScrollJs.StableEditorScrollState).capture(this._editor);
        const layoutInfo = this._getLayoutInfo();
        this._editor.changeDecorations((decorationsAccessor)=>{
            this._editor.changeViewZones((viewZoneAccessor)=>{
                const helper = new (0, _codelensWidgetJs.CodeLensHelper)();
                let codeLensIndex = 0;
                let groupsIndex = 0;
                while(groupsIndex < groups.length && codeLensIndex < this._lenses.length){
                    const symbolsLineNumber = groups[groupsIndex][0].symbol.range.startLineNumber;
                    const codeLensLineNumber = this._lenses[codeLensIndex].getLineNumber();
                    if (codeLensLineNumber < symbolsLineNumber) {
                        this._lenses[codeLensIndex].dispose(helper, viewZoneAccessor);
                        this._lenses.splice(codeLensIndex, 1);
                    } else if (codeLensLineNumber === symbolsLineNumber) {
                        this._lenses[codeLensIndex].updateCodeLensSymbols(groups[groupsIndex], helper);
                        groupsIndex++;
                        codeLensIndex++;
                    } else {
                        this._lenses.splice(codeLensIndex, 0, new (0, _codelensWidgetJs.CodeLensWidget)(groups[groupsIndex], this._editor, helper, viewZoneAccessor, layoutInfo.codeLensHeight, ()=>this._resolveCodeLensesInViewportSoon()));
                        codeLensIndex++;
                        groupsIndex++;
                    }
                }
                // Delete extra code lenses
                while(codeLensIndex < this._lenses.length){
                    this._lenses[codeLensIndex].dispose(helper, viewZoneAccessor);
                    this._lenses.splice(codeLensIndex, 1);
                }
                // Create extra symbols
                while(groupsIndex < groups.length){
                    this._lenses.push(new (0, _codelensWidgetJs.CodeLensWidget)(groups[groupsIndex], this._editor, helper, viewZoneAccessor, layoutInfo.codeLensHeight, ()=>this._resolveCodeLensesInViewportSoon()));
                    groupsIndex++;
                }
                helper.commit(decorationsAccessor);
            });
        });
        scrollState.restore(this._editor);
    }
    _resolveCodeLensesInViewportSoon() {
        const model = this._editor.getModel();
        if (model) this._resolveCodeLensesScheduler.schedule();
    }
    _resolveCodeLensesInViewport() {
        this._resolveCodeLensesPromise?.cancel();
        this._resolveCodeLensesPromise = undefined;
        const model = this._editor.getModel();
        if (!model) return;
        const toResolve = [];
        const lenses = [];
        this._lenses.forEach((lens)=>{
            const request = lens.computeIfNecessary(model);
            if (request) {
                toResolve.push(request);
                lenses.push(lens);
            }
        });
        if (toResolve.length === 0) return;
        const t1 = Date.now();
        const resolvePromise = (0, _asyncJs.createCancelablePromise)((token)=>{
            const promises = toResolve.map((request, i)=>{
                const resolvedSymbols = new Array(request.length);
                const promises = request.map((request, i)=>{
                    if (!request.symbol.command && typeof request.provider.resolveCodeLens === "function") return Promise.resolve(request.provider.resolveCodeLens(model, request.symbol, token)).then((symbol)=>{
                        resolvedSymbols[i] = symbol;
                    }, (0, _errorsJs.onUnexpectedExternalError));
                    else {
                        resolvedSymbols[i] = request.symbol;
                        return Promise.resolve(undefined);
                    }
                });
                return Promise.all(promises).then(()=>{
                    if (!token.isCancellationRequested && !lenses[i].isDisposed()) lenses[i].updateCommands(resolvedSymbols);
                });
            });
            return Promise.all(promises);
        });
        this._resolveCodeLensesPromise = resolvePromise;
        this._resolveCodeLensesPromise.then(()=>{
            // update moving average
            const newDelay = this._resolveCodeLensesDebounce.update(model, Date.now() - t1);
            this._resolveCodeLensesScheduler.delay = newDelay;
            if (this._currentCodeLensModel) this._codeLensCache.put(model, this._currentCodeLensModel);
            this._oldCodeLensModels.clear(); // dispose old models once we have updated the UI with the current model
            if (resolvePromise === this._resolveCodeLensesPromise) this._resolveCodeLensesPromise = undefined;
        }, (err)=>{
            (0, _errorsJs.onUnexpectedError)(err); // can also be cancellation!
            if (resolvePromise === this._resolveCodeLensesPromise) this._resolveCodeLensesPromise = undefined;
        });
    }
    async getModel() {
        await this._getCodeLensModelPromise;
        await this._resolveCodeLensesPromise;
        return !this._currentCodeLensModel?.isDisposed ? this._currentCodeLensModel : undefined;
    }
};
CodeLensContribution = __decorate([
    __param(1, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(2, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService)),
    __param(3, (0, _commandsJs.ICommandService)),
    __param(4, (0, _notificationJs.INotificationService)),
    __param(5, (0, _codeLensCacheJs.ICodeLensCache))
], CodeLensContribution);
(0, _editorExtensionsJs.registerEditorContribution)(CodeLensContribution.ID, CodeLensContribution, 1 /* EditorContributionInstantiation.AfterFirstRender */ );
(0, _editorExtensionsJs.registerEditorAction)(class ShowLensesInCurrentLine extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "codelens.showLensesInCurrentLine",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hasCodeLensProvider,
            label: (0, _nlsJs.localize)("showLensOnLine", "Show CodeLens Commands For Current Line"),
            alias: "Show CodeLens Commands For Current Line"
        });
    }
    async run(accessor, editor) {
        if (!editor.hasModel()) return;
        const quickInputService = accessor.get((0, _quickInputJs.IQuickInputService));
        const commandService = accessor.get((0, _commandsJs.ICommandService));
        const notificationService = accessor.get((0, _notificationJs.INotificationService));
        const lineNumber = editor.getSelection().positionLineNumber;
        const codelensController = editor.getContribution(CodeLensContribution.ID);
        if (!codelensController) return;
        const model = await codelensController.getModel();
        if (!model) // nothing
        return;
        const items = [];
        for (const lens of model.lenses)if (lens.symbol.command && lens.symbol.range.startLineNumber === lineNumber) items.push({
            label: lens.symbol.command.title,
            command: lens.symbol.command
        });
        if (items.length === 0) // We dont want an empty picker
        return;
        const item = await quickInputService.pick(items, {
            canPickMany: false,
            placeHolder: (0, _nlsJs.localize)("placeHolder", "Select a command")
        });
        if (!item) // Nothing picked
        return;
        let command = item.command;
        if (model.isDisposed) {
            // try to find the same command again in-case the model has been re-created in the meantime
            // this is a best attempt approach which shouldn't be needed because eager model re-creates
            // shouldn't happen due to focus in/out anymore
            const newModel = await codelensController.getModel();
            const newLens = newModel?.lenses.find((lens)=>lens.symbol.range.startLineNumber === lineNumber && lens.symbol.command?.title === command.title);
            if (!newLens || !newLens.symbol.command) return;
            command = newLens.symbol.command;
        }
        try {
            await commandService.executeCommand(command.id, ...command.arguments || []);
        } catch (err) {
            notificationService.error(err);
        }
    }
});

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/stableEditorScroll.js":"5Bh72","../../../browser/editorExtensions.js":"kC3w6","../../../common/config/editorOptions.js":"3Xi00","../../../common/editorContextKeys.js":"5exv9","./codelens.js":"hamEJ","./codeLensCache.js":"5Tjgl","./codelensWidget.js":"d0H94","../../../../nls.js":"l617d","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/notification/common/notification.js":"igv0W","../../../../platform/quickinput/common/quickInput.js":"a56M6","../../../common/services/languageFeatureDebounce.js":"YGXXG","../../../common/services/languageFeatures.js":"2IAko","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hamEJ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeLensModel", ()=>CodeLensModel);
parcelHelpers.export(exports, "getCodeLensModel", ()=>getCodeLensModel);
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _typesJs = require("../../../../base/common/types.js");
var _uriJs = require("../../../../base/common/uri.js");
var _modelJs = require("../../../common/services/model.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
class CodeLensModel {
    constructor(){
        this.lenses = [];
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
    }
    dispose() {
        this._disposables.dispose();
    }
    get isDisposed() {
        return this._disposables.isDisposed;
    }
    add(list, provider) {
        this._disposables.add(list);
        for (const symbol of list.lenses)this.lenses.push({
            symbol,
            provider
        });
    }
}
async function getCodeLensModel(registry, model, token) {
    const provider = registry.ordered(model);
    const providerRanks = new Map();
    const result = new CodeLensModel();
    const promises = provider.map(async (provider, i)=>{
        providerRanks.set(provider, i);
        try {
            const list = await Promise.resolve(provider.provideCodeLenses(model, token));
            if (list) result.add(list, provider);
        } catch (err) {
            (0, _errorsJs.onUnexpectedExternalError)(err);
        }
    });
    await Promise.all(promises);
    result.lenses = result.lenses.sort((a, b)=>{
        // sort by lineNumber, provider-rank, and column
        if (a.symbol.range.startLineNumber < b.symbol.range.startLineNumber) return -1;
        else if (a.symbol.range.startLineNumber > b.symbol.range.startLineNumber) return 1;
        else if (providerRanks.get(a.provider) < providerRanks.get(b.provider)) return -1;
        else if (providerRanks.get(a.provider) > providerRanks.get(b.provider)) return 1;
        else if (a.symbol.range.startColumn < b.symbol.range.startColumn) return -1;
        else if (a.symbol.range.startColumn > b.symbol.range.startColumn) return 1;
        else return 0;
    });
    return result;
}
(0, _commandsJs.CommandsRegistry).registerCommand("_executeCodeLensProvider", function(accessor, ...args) {
    let [uri, itemResolveCount] = args;
    (0, _typesJs.assertType)((0, _uriJs.URI).isUri(uri));
    (0, _typesJs.assertType)(typeof itemResolveCount === "number" || !itemResolveCount);
    const { codeLensProvider } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const model = accessor.get((0, _modelJs.IModelService)).getModel(uri);
    if (!model) throw (0, _errorsJs.illegalArgument)();
    const result = [];
    const disposables = new (0, _lifecycleJs.DisposableStore)();
    return getCodeLensModel(codeLensProvider, model, (0, _cancellationJs.CancellationToken).None).then((value)=>{
        disposables.add(value);
        const resolve = [];
        for (const item of value.lenses){
            if (itemResolveCount === undefined || itemResolveCount === null || Boolean(item.symbol.command)) result.push(item.symbol);
            else if (itemResolveCount-- > 0 && item.provider.resolveCodeLens) resolve.push(Promise.resolve(item.provider.resolveCodeLens(model, item.symbol, (0, _cancellationJs.CancellationToken).None)).then((symbol)=>result.push(symbol || item.symbol)));
        }
        return Promise.all(resolve);
    }).then(()=>{
        return result;
    }).finally(()=>{
        // make sure to return results, then (on next tick)
        // dispose the results
        setTimeout(()=>disposables.dispose(), 100);
    });
});

},{"../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/types.js":"fb5yx","../../../../base/common/uri.js":"7qGS3","../../../common/services/model.js":"aciVm","../../../../platform/commands/common/commands.js":"ho6ic","../../../common/services/languageFeatures.js":"2IAko","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Tjgl":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ICodeLensCache", ()=>ICodeLensCache);
parcelHelpers.export(exports, "CodeLensCache", ()=>CodeLensCache);
var _eventJs = require("../../../../base/common/event.js");
var _mapJs = require("../../../../base/common/map.js");
var _rangeJs = require("../../../common/core/range.js");
var _codelensJs = require("./codelens.js");
var _extensionsJs = require("../../../../platform/instantiation/common/extensions.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _storageJs = require("../../../../platform/storage/common/storage.js");
var _windowJs = require("../../../../base/browser/window.js");
var _domJs = require("../../../../base/browser/dom.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const ICodeLensCache = (0, _instantiationJs.createDecorator)("ICodeLensCache");
class CacheItem {
    constructor(lineCount, data){
        this.lineCount = lineCount;
        this.data = data;
    }
}
let CodeLensCache = class CodeLensCache {
    constructor(storageService){
        this._fakeProvider = new class {
            provideCodeLenses() {
                throw new Error("not supported");
            }
        };
        this._cache = new (0, _mapJs.LRUCache)(20, 0.75);
        // remove old data
        const oldkey = "codelens/cache";
        (0, _domJs.runWhenWindowIdle)((0, _windowJs.mainWindow), ()=>storageService.remove(oldkey, 1 /* StorageScope.WORKSPACE */ ));
        // restore lens data on start
        const key = "codelens/cache2";
        const raw = storageService.get(key, 1 /* StorageScope.WORKSPACE */ , "{}");
        this._deserialize(raw);
        // store lens data on shutdown
        const onWillSaveStateBecauseOfShutdown = (0, _eventJs.Event).filter(storageService.onWillSaveState, (e)=>e.reason === (0, _storageJs.WillSaveStateReason).SHUTDOWN);
        (0, _eventJs.Event).once(onWillSaveStateBecauseOfShutdown)((e)=>{
            storageService.store(key, this._serialize(), 1 /* StorageScope.WORKSPACE */ , 1 /* StorageTarget.MACHINE */ );
        });
    }
    put(model, data) {
        // create a copy of the model that is without command-ids
        // but with comand-labels
        const copyItems = data.lenses.map((item)=>{
            return {
                range: item.symbol.range,
                command: item.symbol.command && {
                    id: "",
                    title: item.symbol.command?.title
                }
            };
        });
        const copyModel = new (0, _codelensJs.CodeLensModel)();
        copyModel.add({
            lenses: copyItems,
            dispose: ()=>{}
        }, this._fakeProvider);
        const item = new CacheItem(model.getLineCount(), copyModel);
        this._cache.set(model.uri.toString(), item);
    }
    get(model) {
        const item = this._cache.get(model.uri.toString());
        return item && item.lineCount === model.getLineCount() ? item.data : undefined;
    }
    delete(model) {
        this._cache.delete(model.uri.toString());
    }
    // --- persistence
    _serialize() {
        const data = Object.create(null);
        for (const [key, value] of this._cache){
            const lines = new Set();
            for (const d of value.data.lenses)lines.add(d.symbol.range.startLineNumber);
            data[key] = {
                lineCount: value.lineCount,
                lines: [
                    ...lines.values()
                ]
            };
        }
        return JSON.stringify(data);
    }
    _deserialize(raw) {
        try {
            const data = JSON.parse(raw);
            for(const key in data){
                const element = data[key];
                const lenses = [];
                for (const line of element.lines)lenses.push({
                    range: new (0, _rangeJs.Range)(line, 1, line, 11)
                });
                const model = new (0, _codelensJs.CodeLensModel)();
                model.add({
                    lenses,
                    dispose () {}
                }, this._fakeProvider);
                this._cache.set(key, new CacheItem(element.lineCount, model));
            }
        } catch  {
        // ignore...
        }
    }
};
CodeLensCache = __decorate([
    __param(0, (0, _storageJs.IStorageService))
], CodeLensCache);
(0, _extensionsJs.registerSingleton)(ICodeLensCache, CodeLensCache, 1 /* InstantiationType.Delayed */ );

},{"../../../../base/common/event.js":"4Zi8b","../../../../base/common/map.js":"leSjz","../../../common/core/range.js":"jmUPh","./codelens.js":"hamEJ","../../../../platform/instantiation/common/extensions.js":"6WJLq","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/storage/common/storage.js":"6AhR2","../../../../base/browser/window.js":"aJBhQ","../../../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d0H94":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CodeLensHelper", ()=>CodeLensHelper);
parcelHelpers.export(exports, "CodeLensWidget", ()=>CodeLensWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _iconLabelsJs = require("../../../../base/browser/ui/iconLabel/iconLabels.js");
var _codelensWidgetCss = require("./codelensWidget.css");
var _rangeJs = require("../../../common/core/range.js");
var _textModelJs = require("../../../common/model/textModel.js");
class CodeLensViewZone {
    constructor(afterLineNumber, heightInPx, onHeight){
        /**
         * We want that this view zone, which reserves space for a code lens appears
         * as close as possible to the next line, so we use a very large value here.
         */ this.afterColumn = 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ;
        this.afterLineNumber = afterLineNumber;
        this.heightInPx = heightInPx;
        this._onHeight = onHeight;
        this.suppressMouseDown = true;
        this.domNode = document.createElement("div");
    }
    onComputedHeight(height) {
        if (this._lastHeight === undefined) this._lastHeight = height;
        else if (this._lastHeight !== height) {
            this._lastHeight = height;
            this._onHeight();
        }
    }
    isVisible() {
        return this._lastHeight !== 0 && this.domNode.hasAttribute("monaco-visible-view-zone");
    }
}
class CodeLensContentWidget {
    static{
        this._idPool = 0;
    }
    constructor(editor, line){
        // Editor.IContentWidget.allowEditorOverflow
        this.allowEditorOverflow = false;
        this.suppressMouseDown = true;
        this._commands = new Map();
        this._isEmpty = true;
        this._editor = editor;
        this._id = `codelens.widget-${CodeLensContentWidget._idPool++}`;
        this.updatePosition(line);
        this._domNode = document.createElement("span");
        this._domNode.className = `codelens-decoration`;
    }
    withCommands(lenses, animate) {
        this._commands.clear();
        const children = [];
        let hasSymbol = false;
        for(let i = 0; i < lenses.length; i++){
            const lens = lenses[i];
            if (!lens) continue;
            hasSymbol = true;
            if (lens.command) {
                const title = (0, _iconLabelsJs.renderLabelWithIcons)(lens.command.title.trim());
                if (lens.command.id) {
                    const id = `c${CodeLensContentWidget._idPool++}`;
                    children.push(_domJs.$("a", {
                        id,
                        title: lens.command.tooltip,
                        role: "button"
                    }, ...title));
                    this._commands.set(id, lens.command);
                } else children.push(_domJs.$("span", {
                    title: lens.command.tooltip
                }, ...title));
                if (i + 1 < lenses.length) children.push(_domJs.$("span", undefined, "\xa0|\xa0"));
            }
        }
        if (!hasSymbol) // symbols but no commands
        _domJs.reset(this._domNode, _domJs.$("span", undefined, "no commands"));
        else {
            // symbols and commands
            _domJs.reset(this._domNode, ...children);
            if (this._isEmpty && animate) this._domNode.classList.add("fadein");
            this._isEmpty = false;
        }
    }
    getCommand(link) {
        return link.parentElement === this._domNode ? this._commands.get(link.id) : undefined;
    }
    getId() {
        return this._id;
    }
    getDomNode() {
        return this._domNode;
    }
    updatePosition(line) {
        const column = this._editor.getModel().getLineFirstNonWhitespaceColumn(line);
        this._widgetPosition = {
            position: {
                lineNumber: line,
                column: column
            },
            preference: [
                1 /* ContentWidgetPositionPreference.ABOVE */ 
            ]
        };
    }
    getPosition() {
        return this._widgetPosition || null;
    }
}
class CodeLensHelper {
    constructor(){
        this._removeDecorations = [];
        this._addDecorations = [];
        this._addDecorationsCallbacks = [];
    }
    addDecoration(decoration, callback) {
        this._addDecorations.push(decoration);
        this._addDecorationsCallbacks.push(callback);
    }
    removeDecoration(decorationId) {
        this._removeDecorations.push(decorationId);
    }
    commit(changeAccessor) {
        const resultingDecorations = changeAccessor.deltaDecorations(this._removeDecorations, this._addDecorations);
        for(let i = 0, len = resultingDecorations.length; i < len; i++)this._addDecorationsCallbacks[i](resultingDecorations[i]);
    }
}
const codeLensDecorationOptions = (0, _textModelJs.ModelDecorationOptions).register({
    collapseOnReplaceEdit: true,
    description: "codelens"
});
class CodeLensWidget {
    constructor(data, editor, helper, viewZoneChangeAccessor, heightInPx, updateCallback){
        this._isDisposed = false;
        this._editor = editor;
        this._data = data;
        // create combined range, track all ranges with decorations,
        // check if there is already something to render
        this._decorationIds = [];
        let range;
        const lenses = [];
        this._data.forEach((codeLensData, i)=>{
            if (codeLensData.symbol.command) lenses.push(codeLensData.symbol);
            helper.addDecoration({
                range: codeLensData.symbol.range,
                options: codeLensDecorationOptions
            }, (id)=>this._decorationIds[i] = id);
            // the range contains all lenses on this line
            if (!range) range = (0, _rangeJs.Range).lift(codeLensData.symbol.range);
            else range = (0, _rangeJs.Range).plusRange(range, codeLensData.symbol.range);
        });
        this._viewZone = new CodeLensViewZone(range.startLineNumber - 1, heightInPx, updateCallback);
        this._viewZoneId = viewZoneChangeAccessor.addZone(this._viewZone);
        if (lenses.length > 0) {
            this._createContentWidgetIfNecessary();
            this._contentWidget.withCommands(lenses, false);
        }
    }
    _createContentWidgetIfNecessary() {
        if (!this._contentWidget) {
            this._contentWidget = new CodeLensContentWidget(this._editor, this._viewZone.afterLineNumber + 1);
            this._editor.addContentWidget(this._contentWidget);
        } else this._editor.layoutContentWidget(this._contentWidget);
    }
    dispose(helper, viewZoneChangeAccessor) {
        this._decorationIds.forEach(helper.removeDecoration, helper);
        this._decorationIds = [];
        viewZoneChangeAccessor?.removeZone(this._viewZoneId);
        if (this._contentWidget) {
            this._editor.removeContentWidget(this._contentWidget);
            this._contentWidget = undefined;
        }
        this._isDisposed = true;
    }
    isDisposed() {
        return this._isDisposed;
    }
    isValid() {
        return this._decorationIds.some((id, i)=>{
            const range = this._editor.getModel().getDecorationRange(id);
            const symbol = this._data[i].symbol;
            return !!(range && (0, _rangeJs.Range).isEmpty(symbol.range) === range.isEmpty());
        });
    }
    updateCodeLensSymbols(data, helper) {
        this._decorationIds.forEach(helper.removeDecoration, helper);
        this._decorationIds = [];
        this._data = data;
        this._data.forEach((codeLensData, i)=>{
            helper.addDecoration({
                range: codeLensData.symbol.range,
                options: codeLensDecorationOptions
            }, (id)=>this._decorationIds[i] = id);
        });
    }
    updateHeight(height, viewZoneChangeAccessor) {
        this._viewZone.heightInPx = height;
        viewZoneChangeAccessor.layoutZone(this._viewZoneId);
        if (this._contentWidget) this._editor.layoutContentWidget(this._contentWidget);
    }
    computeIfNecessary(model) {
        if (!this._viewZone.isVisible()) return null;
        // Read editor current state
        for(let i = 0; i < this._decorationIds.length; i++){
            const range = model.getDecorationRange(this._decorationIds[i]);
            if (range) this._data[i].symbol.range = range;
        }
        return this._data;
    }
    updateCommands(symbols) {
        this._createContentWidgetIfNecessary();
        this._contentWidget.withCommands(symbols, true);
        for(let i = 0; i < this._data.length; i++){
            const resolved = symbols[i];
            if (resolved) {
                const { symbol } = this._data[i];
                symbol.command = resolved.command || symbol.command;
            }
        }
    }
    getCommand(link) {
        return this._contentWidget?.getCommand(link);
    }
    getLineNumber() {
        const range = this._editor.getModel().getDecorationRange(this._decorationIds[0]);
        if (range) return range.startLineNumber;
        return -1;
    }
    update(viewZoneChangeAccessor) {
        if (this.isValid()) {
            const range = this._editor.getModel().getDecorationRange(this._decorationIds[0]);
            if (range) {
                this._viewZone.afterLineNumber = range.startLineNumber - 1;
                viewZoneChangeAccessor.layoutZone(this._viewZoneId);
                if (this._contentWidget) {
                    this._contentWidget.updatePosition(range.startLineNumber);
                    this._editor.layoutContentWidget(this._contentWidget);
                }
            }
        }
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/iconLabel/iconLabels.js":"lXqhk","./codelensWidget.css":"78ERN","../../../common/core/range.js":"jmUPh","../../../common/model/textModel.js":"9beDe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"78ERN":[function() {},{}],"3wIOC":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorContribution", ()=>ColorContribution);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _rangeJs = require("../../../common/core/range.js");
var _colorDetectorJs = require("./colorDetector.js");
var _colorHoverParticipantJs = require("./colorHoverParticipant.js");
var _contentHoverController2Js = require("../../hover/browser/contentHoverController2.js");
var _hoverTypesJs = require("../../hover/browser/hoverTypes.js");
class ColorContribution extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.colorContribution";
    }
    constructor(_editor){
        super();
        this._editor = _editor;
        this._register(_editor.onMouseDown((e)=>this.onMouseDown(e)));
    }
    dispose() {
        super.dispose();
    }
    onMouseDown(mouseEvent) {
        const colorDecoratorsActivatedOn = this._editor.getOption(149 /* EditorOption.colorDecoratorsActivatedOn */ );
        if (colorDecoratorsActivatedOn !== "click" && colorDecoratorsActivatedOn !== "clickAndHover") return;
        const target = mouseEvent.target;
        if (target.type !== 6 /* MouseTargetType.CONTENT_TEXT */ ) return;
        if (!target.detail.injectedText) return;
        if (target.detail.injectedText.options.attachedData !== (0, _colorDetectorJs.ColorDecorationInjectedTextMarker)) return;
        if (!target.range) return;
        const hoverController = this._editor.getContribution((0, _contentHoverController2Js.ContentHoverController).ID);
        if (!hoverController) return;
        if (!hoverController.isColorPickerVisible) {
            const range = new (0, _rangeJs.Range)(target.range.startLineNumber, target.range.startColumn + 1, target.range.endLineNumber, target.range.endColumn + 1);
            hoverController.showContentHover(range, 1 /* HoverStartMode.Immediate */ , 0 /* HoverStartSource.Mouse */ , false, true);
        }
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(ColorContribution.ID, ColorContribution, 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );
(0, _hoverTypesJs.HoverParticipantRegistry).register((0, _colorHoverParticipantJs.ColorHoverParticipant));

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/range.js":"jmUPh","./colorDetector.js":"f19Gi","./colorHoverParticipant.js":"bidr4","../../hover/browser/contentHoverController2.js":"mYQJl","../../hover/browser/hoverTypes.js":"6vmRi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f19Gi":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorDecorationInjectedTextMarker", ()=>ColorDecorationInjectedTextMarker);
parcelHelpers.export(exports, "ColorDetector", ()=>ColorDetector);
parcelHelpers.export(exports, "DecoratorLimitReporter", ()=>DecoratorLimitReporter);
var _asyncJs = require("../../../../base/common/async.js");
var _colorJs = require("../../../../base/common/color.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stopwatchJs = require("../../../../base/common/stopwatch.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _editorDomJs = require("../../../browser/editorDom.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _rangeJs = require("../../../common/core/range.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _languageFeatureDebounceJs = require("../../../common/services/languageFeatureDebounce.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _colorJs1 = require("./color.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var ColorDetector_1;
const ColorDecorationInjectedTextMarker = Object.create({});
let ColorDetector = class ColorDetector extends (0, _lifecycleJs.Disposable) {
    static{
        ColorDetector_1 = this;
    }
    static{
        this.ID = "editor.contrib.colorDetector";
    }
    static{
        this.RECOMPUTE_TIME = 1000;
    }
    constructor(_editor, _configurationService, _languageFeaturesService, languageFeatureDebounceService){
        super();
        this._editor = _editor;
        this._configurationService = _configurationService;
        this._languageFeaturesService = _languageFeaturesService;
        this._localToDispose = this._register(new (0, _lifecycleJs.DisposableStore)());
        this._decorationsIds = [];
        this._colorDatas = new Map();
        this._colorDecoratorIds = this._editor.createDecorationsCollection();
        this._ruleFactory = new (0, _editorDomJs.DynamicCssRules)(this._editor);
        this._decoratorLimitReporter = new DecoratorLimitReporter();
        this._colorDecorationClassRefs = this._register(new (0, _lifecycleJs.DisposableStore)());
        this._debounceInformation = languageFeatureDebounceService.for(_languageFeaturesService.colorProvider, "Document Colors", {
            min: ColorDetector_1.RECOMPUTE_TIME
        });
        this._register(_editor.onDidChangeModel(()=>{
            this._isColorDecoratorsEnabled = this.isEnabled();
            this.updateColors();
        }));
        this._register(_editor.onDidChangeModelLanguage(()=>this.updateColors()));
        this._register(_languageFeaturesService.colorProvider.onDidChange(()=>this.updateColors()));
        this._register(_editor.onDidChangeConfiguration((e)=>{
            const prevIsEnabled = this._isColorDecoratorsEnabled;
            this._isColorDecoratorsEnabled = this.isEnabled();
            this._isDefaultColorDecoratorsEnabled = this._editor.getOption(148 /* EditorOption.defaultColorDecorators */ );
            const updatedColorDecoratorsSetting = prevIsEnabled !== this._isColorDecoratorsEnabled || e.hasChanged(21 /* EditorOption.colorDecoratorsLimit */ );
            const updatedDefaultColorDecoratorsSetting = e.hasChanged(148 /* EditorOption.defaultColorDecorators */ );
            if (updatedColorDecoratorsSetting || updatedDefaultColorDecoratorsSetting) {
                if (this._isColorDecoratorsEnabled) this.updateColors();
                else this.removeAllDecorations();
            }
        }));
        this._timeoutTimer = null;
        this._computePromise = null;
        this._isColorDecoratorsEnabled = this.isEnabled();
        this._isDefaultColorDecoratorsEnabled = this._editor.getOption(148 /* EditorOption.defaultColorDecorators */ );
        this.updateColors();
    }
    isEnabled() {
        const model = this._editor.getModel();
        if (!model) return false;
        const languageId = model.getLanguageId();
        // handle deprecated settings. [languageId].colorDecorators.enable
        const deprecatedConfig = this._configurationService.getValue(languageId);
        if (deprecatedConfig && typeof deprecatedConfig === "object") {
            const colorDecorators = deprecatedConfig["colorDecorators"]; // deprecatedConfig.valueOf('.colorDecorators.enable');
            if (colorDecorators && colorDecorators["enable"] !== undefined && !colorDecorators["enable"]) return colorDecorators["enable"];
        }
        return this._editor.getOption(20 /* EditorOption.colorDecorators */ );
    }
    static get(editor) {
        return editor.getContribution(this.ID);
    }
    dispose() {
        this.stop();
        this.removeAllDecorations();
        super.dispose();
    }
    updateColors() {
        this.stop();
        if (!this._isColorDecoratorsEnabled) return;
        const model = this._editor.getModel();
        if (!model || !this._languageFeaturesService.colorProvider.has(model)) return;
        this._localToDispose.add(this._editor.onDidChangeModelContent(()=>{
            if (!this._timeoutTimer) {
                this._timeoutTimer = new (0, _asyncJs.TimeoutTimer)();
                this._timeoutTimer.cancelAndSet(()=>{
                    this._timeoutTimer = null;
                    this.beginCompute();
                }, this._debounceInformation.get(model));
            }
        }));
        this.beginCompute();
    }
    async beginCompute() {
        this._computePromise = (0, _asyncJs.createCancelablePromise)(async (token)=>{
            const model = this._editor.getModel();
            if (!model) return [];
            const sw = new (0, _stopwatchJs.StopWatch)(false);
            const colors = await (0, _colorJs1.getColors)(this._languageFeaturesService.colorProvider, model, token, this._isDefaultColorDecoratorsEnabled);
            this._debounceInformation.update(model, sw.elapsed());
            return colors;
        });
        try {
            const colors = await this._computePromise;
            this.updateDecorations(colors);
            this.updateColorDecorators(colors);
            this._computePromise = null;
        } catch (e) {
            (0, _errorsJs.onUnexpectedError)(e);
        }
    }
    stop() {
        if (this._timeoutTimer) {
            this._timeoutTimer.cancel();
            this._timeoutTimer = null;
        }
        if (this._computePromise) {
            this._computePromise.cancel();
            this._computePromise = null;
        }
        this._localToDispose.clear();
    }
    updateDecorations(colorDatas) {
        const decorations = colorDatas.map((c)=>({
                range: {
                    startLineNumber: c.colorInfo.range.startLineNumber,
                    startColumn: c.colorInfo.range.startColumn,
                    endLineNumber: c.colorInfo.range.endLineNumber,
                    endColumn: c.colorInfo.range.endColumn
                },
                options: (0, _textModelJs.ModelDecorationOptions).EMPTY
            }));
        this._editor.changeDecorations((changeAccessor)=>{
            this._decorationsIds = changeAccessor.deltaDecorations(this._decorationsIds, decorations);
            this._colorDatas = new Map();
            this._decorationsIds.forEach((id, i)=>this._colorDatas.set(id, colorDatas[i]));
        });
    }
    updateColorDecorators(colorData) {
        this._colorDecorationClassRefs.clear();
        const decorations = [];
        const limit = this._editor.getOption(21 /* EditorOption.colorDecoratorsLimit */ );
        for(let i = 0; i < colorData.length && decorations.length < limit; i++){
            const { red, green, blue, alpha } = colorData[i].colorInfo.color;
            const rgba = new (0, _colorJs.RGBA)(Math.round(red * 255), Math.round(green * 255), Math.round(blue * 255), alpha);
            const color = `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
            const ref = this._colorDecorationClassRefs.add(this._ruleFactory.createClassNameRef({
                backgroundColor: color
            }));
            decorations.push({
                range: {
                    startLineNumber: colorData[i].colorInfo.range.startLineNumber,
                    startColumn: colorData[i].colorInfo.range.startColumn,
                    endLineNumber: colorData[i].colorInfo.range.endLineNumber,
                    endColumn: colorData[i].colorInfo.range.endColumn
                },
                options: {
                    description: "colorDetector",
                    before: {
                        content: (0, _stringsJs.noBreakWhitespace),
                        inlineClassName: `${ref.className} colorpicker-color-decoration`,
                        inlineClassNameAffectsLetterSpacing: true,
                        attachedData: ColorDecorationInjectedTextMarker
                    }
                }
            });
        }
        const limited = limit < colorData.length ? limit : false;
        this._decoratorLimitReporter.update(colorData.length, limited);
        this._colorDecoratorIds.set(decorations);
    }
    removeAllDecorations() {
        this._editor.removeDecorations(this._decorationsIds);
        this._decorationsIds = [];
        this._colorDecoratorIds.clear();
        this._colorDecorationClassRefs.clear();
    }
    getColorData(position) {
        const model = this._editor.getModel();
        if (!model) return null;
        const decorations = model.getDecorationsInRange((0, _rangeJs.Range).fromPositions(position, position)).filter((d)=>this._colorDatas.has(d.id));
        if (decorations.length === 0) return null;
        return this._colorDatas.get(decorations[0].id);
    }
    isColorDecoration(decoration) {
        return this._colorDecoratorIds.has(decoration);
    }
};
ColorDetector = ColorDetector_1 = __decorate([
    __param(1, (0, _configurationJs.IConfigurationService)),
    __param(2, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(3, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService))
], ColorDetector);
class DecoratorLimitReporter {
    constructor(){
        this._onDidChange = new (0, _eventJs.Emitter)();
        this._computed = 0;
        this._limited = false;
    }
    update(computed, limited) {
        if (computed !== this._computed || limited !== this._limited) {
            this._computed = computed;
            this._limited = limited;
            this._onDidChange.fire();
        }
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(ColorDetector.ID, ColorDetector, 1 /* EditorContributionInstantiation.AfterFirstRender */ );

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/color.js":"at4gb","../../../../base/common/errors.js":"divX8","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/stopwatch.js":"77PF9","../../../../base/common/strings.js":"aA9I1","../../../browser/editorDom.js":"8EVOq","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/range.js":"jmUPh","../../../common/model/textModel.js":"9beDe","../../../common/services/languageFeatureDebounce.js":"YGXXG","../../../common/services/languageFeatures.js":"2IAko","./color.js":"bzikv","../../../../platform/configuration/common/configuration.js":"dXkjq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzikv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getColors", ()=>getColors);
parcelHelpers.export(exports, "getColorPresentations", ()=>getColorPresentations);
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _uriJs = require("../../../../base/common/uri.js");
var _rangeJs = require("../../../common/core/range.js");
var _modelJs = require("../../../common/services/model.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _defaultDocumentColorProviderJs = require("./defaultDocumentColorProvider.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
async function getColors(colorProviderRegistry, model, token, isDefaultColorDecoratorsEnabled = true) {
    return _findColorData(new ColorDataCollector(), colorProviderRegistry, model, token, isDefaultColorDecoratorsEnabled);
}
function getColorPresentations(model, colorInfo, provider, token) {
    return Promise.resolve(provider.provideColorPresentations(model, colorInfo, token));
}
class ColorDataCollector {
    constructor(){}
    async compute(provider, model, token, colors) {
        const documentColors = await provider.provideDocumentColors(model, token);
        if (Array.isArray(documentColors)) for (const colorInfo of documentColors)colors.push({
            colorInfo,
            provider
        });
        return Array.isArray(documentColors);
    }
}
class ExtColorDataCollector {
    constructor(){}
    async compute(provider, model, token, colors) {
        const documentColors = await provider.provideDocumentColors(model, token);
        if (Array.isArray(documentColors)) for (const colorInfo of documentColors)colors.push({
            range: colorInfo.range,
            color: [
                colorInfo.color.red,
                colorInfo.color.green,
                colorInfo.color.blue,
                colorInfo.color.alpha
            ]
        });
        return Array.isArray(documentColors);
    }
}
class ColorPresentationsCollector {
    constructor(colorInfo){
        this.colorInfo = colorInfo;
    }
    async compute(provider, model, _token, colors) {
        const documentColors = await provider.provideColorPresentations(model, this.colorInfo, (0, _cancellationJs.CancellationToken).None);
        if (Array.isArray(documentColors)) colors.push(...documentColors);
        return Array.isArray(documentColors);
    }
}
async function _findColorData(collector, colorProviderRegistry, model, token, isDefaultColorDecoratorsEnabled) {
    let validDocumentColorProviderFound = false;
    let defaultProvider;
    const colorData = [];
    const documentColorProviders = colorProviderRegistry.ordered(model);
    for(let i = documentColorProviders.length - 1; i >= 0; i--){
        const provider = documentColorProviders[i];
        if (provider instanceof (0, _defaultDocumentColorProviderJs.DefaultDocumentColorProvider)) defaultProvider = provider;
        else try {
            if (await collector.compute(provider, model, token, colorData)) validDocumentColorProviderFound = true;
        } catch (e) {
            (0, _errorsJs.onUnexpectedExternalError)(e);
        }
    }
    if (validDocumentColorProviderFound) return colorData;
    if (defaultProvider && isDefaultColorDecoratorsEnabled) {
        await collector.compute(defaultProvider, model, token, colorData);
        return colorData;
    }
    return [];
}
function _setupColorCommand(accessor, resource) {
    const { colorProvider: colorProviderRegistry } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const model = accessor.get((0, _modelJs.IModelService)).getModel(resource);
    if (!model) throw (0, _errorsJs.illegalArgument)();
    const isDefaultColorDecoratorsEnabled = accessor.get((0, _configurationJs.IConfigurationService)).getValue("editor.defaultColorDecorators", {
        resource
    });
    return {
        model,
        colorProviderRegistry,
        isDefaultColorDecoratorsEnabled
    };
}
(0, _commandsJs.CommandsRegistry).registerCommand("_executeDocumentColorProvider", function(accessor, ...args) {
    const [resource] = args;
    if (!(resource instanceof (0, _uriJs.URI))) throw (0, _errorsJs.illegalArgument)();
    const { model, colorProviderRegistry, isDefaultColorDecoratorsEnabled } = _setupColorCommand(accessor, resource);
    return _findColorData(new ExtColorDataCollector(), colorProviderRegistry, model, (0, _cancellationJs.CancellationToken).None, isDefaultColorDecoratorsEnabled);
});
(0, _commandsJs.CommandsRegistry).registerCommand("_executeColorPresentationProvider", function(accessor, ...args) {
    const [color, context] = args;
    const { uri, range } = context;
    if (!(uri instanceof (0, _uriJs.URI)) || !Array.isArray(color) || color.length !== 4 || !(0, _rangeJs.Range).isIRange(range)) throw (0, _errorsJs.illegalArgument)();
    const { model, colorProviderRegistry, isDefaultColorDecoratorsEnabled } = _setupColorCommand(accessor, uri);
    const [red, green, blue, alpha] = color;
    return _findColorData(new ColorPresentationsCollector({
        range: range,
        color: {
            red,
            green,
            blue,
            alpha
        }
    }), colorProviderRegistry, model, (0, _cancellationJs.CancellationToken).None, isDefaultColorDecoratorsEnabled);
});

},{"../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/uri.js":"7qGS3","../../../common/core/range.js":"jmUPh","../../../common/services/model.js":"aciVm","../../../../platform/commands/common/commands.js":"ho6ic","../../../common/services/languageFeatures.js":"2IAko","./defaultDocumentColorProvider.js":"4drIE","../../../../platform/configuration/common/configuration.js":"dXkjq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4drIE":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultDocumentColorProvider", ()=>DefaultDocumentColorProvider);
var _colorJs = require("../../../../base/common/color.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _editorFeaturesJs = require("../../../common/editorFeatures.js");
var _editorWorkerJs = require("../../../common/services/editorWorker.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let DefaultDocumentColorProvider = class DefaultDocumentColorProvider {
    constructor(_editorWorkerService){
        this._editorWorkerService = _editorWorkerService;
    }
    async provideDocumentColors(model, _token) {
        return this._editorWorkerService.computeDefaultDocumentColors(model.uri);
    }
    provideColorPresentations(_model, colorInfo, _token) {
        const range = colorInfo.range;
        const colorFromInfo = colorInfo.color;
        const alpha = colorFromInfo.alpha;
        const color = new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(Math.round(255 * colorFromInfo.red), Math.round(255 * colorFromInfo.green), Math.round(255 * colorFromInfo.blue), alpha));
        const rgb = alpha ? (0, _colorJs.Color).Format.CSS.formatRGB(color) : (0, _colorJs.Color).Format.CSS.formatRGBA(color);
        const hsl = alpha ? (0, _colorJs.Color).Format.CSS.formatHSL(color) : (0, _colorJs.Color).Format.CSS.formatHSLA(color);
        const hex = alpha ? (0, _colorJs.Color).Format.CSS.formatHex(color) : (0, _colorJs.Color).Format.CSS.formatHexA(color);
        const colorPresentations = [];
        colorPresentations.push({
            label: rgb,
            textEdit: {
                range: range,
                text: rgb
            }
        });
        colorPresentations.push({
            label: hsl,
            textEdit: {
                range: range,
                text: hsl
            }
        });
        colorPresentations.push({
            label: hex,
            textEdit: {
                range: range,
                text: hex
            }
        });
        return colorPresentations;
    }
};
DefaultDocumentColorProvider = __decorate([
    __param(0, (0, _editorWorkerJs.IEditorWorkerService))
], DefaultDocumentColorProvider);
let DefaultDocumentColorProviderFeature = class DefaultDocumentColorProviderFeature extends (0, _lifecycleJs.Disposable) {
    constructor(_languageFeaturesService, editorWorkerService){
        super();
        this._register(_languageFeaturesService.colorProvider.register("*", new DefaultDocumentColorProvider(editorWorkerService)));
    }
};
DefaultDocumentColorProviderFeature = __decorate([
    __param(0, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(1, (0, _editorWorkerJs.IEditorWorkerService))
], DefaultDocumentColorProviderFeature);
(0, _editorFeaturesJs.registerEditorFeature)(DefaultDocumentColorProviderFeature);

},{"../../../../base/common/color.js":"at4gb","../../../../base/common/lifecycle.js":"9kg8d","../../../common/services/languageFeatures.js":"2IAko","../../../common/editorFeatures.js":"8AkS3","../../../common/services/editorWorker.js":"aaYJd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bidr4":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorHover", ()=>ColorHover);
parcelHelpers.export(exports, "ColorHoverParticipant", ()=>ColorHoverParticipant);
parcelHelpers.export(exports, "StandaloneColorPickerHover", ()=>StandaloneColorPickerHover);
parcelHelpers.export(exports, "StandaloneColorPickerParticipant", ()=>StandaloneColorPickerParticipant);
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _colorJs = require("../../../../base/common/color.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _rangeJs = require("../../../common/core/range.js");
var _colorJs1 = require("./color.js");
var _colorDetectorJs = require("./colorDetector.js");
var _colorPickerModelJs = require("./colorPickerModel.js");
var _colorPickerWidgetJs = require("./colorPickerWidget.js");
var _hoverTypesJs = require("../../hover/browser/hoverTypes.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _domJs = require("../../../../base/browser/dom.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class ColorHover {
    constructor(owner, range, model, provider){
        this.owner = owner;
        this.range = range;
        this.model = model;
        this.provider = provider;
        /**
         * Force the hover to always be rendered at this specific range,
         * even in the case of multiple hover parts.
         */ this.forceShowAtRange = true;
    }
    isValidForHoverAnchor(anchor) {
        return anchor.type === 1 /* HoverAnchorType.Range */  && this.range.startColumn <= anchor.range.startColumn && this.range.endColumn >= anchor.range.endColumn;
    }
}
let ColorHoverParticipant = class ColorHoverParticipant {
    constructor(_editor, _themeService){
        this._editor = _editor;
        this._themeService = _themeService;
        this.hoverOrdinal = 2;
    }
    computeSync(_anchor, _lineDecorations) {
        return [];
    }
    computeAsync(anchor, lineDecorations, token) {
        return (0, _asyncJs.AsyncIterableObject).fromPromise(this._computeAsync(anchor, lineDecorations, token));
    }
    async _computeAsync(_anchor, lineDecorations, _token) {
        if (!this._editor.hasModel()) return [];
        const colorDetector = (0, _colorDetectorJs.ColorDetector).get(this._editor);
        if (!colorDetector) return [];
        for (const d of lineDecorations){
            if (!colorDetector.isColorDecoration(d)) continue;
            const colorData = colorDetector.getColorData(d.range.getStartPosition());
            if (colorData) {
                const colorHover = await _createColorHover(this, this._editor.getModel(), colorData.colorInfo, colorData.provider);
                return [
                    colorHover
                ];
            }
        }
        return [];
    }
    renderHoverParts(context, hoverParts) {
        const renderedPart = renderHoverParts(this, this._editor, this._themeService, hoverParts, context);
        if (!renderedPart) return new (0, _hoverTypesJs.RenderedHoverParts)([]);
        this._colorPicker = renderedPart.colorPicker;
        const renderedHoverPart = {
            hoverPart: renderedPart.hoverPart,
            hoverElement: this._colorPicker.domNode,
            dispose () {
                renderedPart.disposables.dispose();
            }
        };
        return new (0, _hoverTypesJs.RenderedHoverParts)([
            renderedHoverPart
        ]);
    }
    handleResize() {
        this._colorPicker?.layout();
    }
    isColorPickerVisible() {
        return !!this._colorPicker;
    }
};
ColorHoverParticipant = __decorate([
    __param(1, (0, _themeServiceJs.IThemeService))
], ColorHoverParticipant);
class StandaloneColorPickerHover {
    constructor(owner, range, model, provider){
        this.owner = owner;
        this.range = range;
        this.model = model;
        this.provider = provider;
    }
}
let StandaloneColorPickerParticipant = class StandaloneColorPickerParticipant {
    constructor(_editor, _themeService){
        this._editor = _editor;
        this._themeService = _themeService;
        this._color = null;
    }
    async createColorHover(defaultColorInfo, defaultColorProvider, colorProviderRegistry) {
        if (!this._editor.hasModel()) return null;
        const colorDetector = (0, _colorDetectorJs.ColorDetector).get(this._editor);
        if (!colorDetector) return null;
        const colors = await (0, _colorJs1.getColors)(colorProviderRegistry, this._editor.getModel(), (0, _cancellationJs.CancellationToken).None);
        let foundColorInfo = null;
        let foundColorProvider = null;
        for (const colorData of colors){
            const colorInfo = colorData.colorInfo;
            if ((0, _rangeJs.Range).containsRange(colorInfo.range, defaultColorInfo.range)) {
                foundColorInfo = colorInfo;
                foundColorProvider = colorData.provider;
            }
        }
        const colorInfo = foundColorInfo ?? defaultColorInfo;
        const colorProvider = foundColorProvider ?? defaultColorProvider;
        const foundInEditor = !!foundColorInfo;
        return {
            colorHover: await _createColorHover(this, this._editor.getModel(), colorInfo, colorProvider),
            foundInEditor: foundInEditor
        };
    }
    async updateEditorModel(colorHoverData) {
        if (!this._editor.hasModel()) return;
        const colorPickerModel = colorHoverData.model;
        let range = new (0, _rangeJs.Range)(colorHoverData.range.startLineNumber, colorHoverData.range.startColumn, colorHoverData.range.endLineNumber, colorHoverData.range.endColumn);
        if (this._color) {
            await _updateColorPresentations(this._editor.getModel(), colorPickerModel, this._color, range, colorHoverData);
            range = _updateEditorModel(this._editor, range, colorPickerModel);
        }
    }
    renderHoverParts(context, hoverParts) {
        return renderHoverParts(this, this._editor, this._themeService, hoverParts, context);
    }
    set color(color) {
        this._color = color;
    }
    get color() {
        return this._color;
    }
};
StandaloneColorPickerParticipant = __decorate([
    __param(1, (0, _themeServiceJs.IThemeService))
], StandaloneColorPickerParticipant);
async function _createColorHover(participant, editorModel, colorInfo, provider) {
    const originalText = editorModel.getValueInRange(colorInfo.range);
    const { red, green, blue, alpha } = colorInfo.color;
    const rgba = new (0, _colorJs.RGBA)(Math.round(red * 255), Math.round(green * 255), Math.round(blue * 255), alpha);
    const color = new (0, _colorJs.Color)(rgba);
    const colorPresentations = await (0, _colorJs1.getColorPresentations)(editorModel, colorInfo, provider, (0, _cancellationJs.CancellationToken).None);
    const model = new (0, _colorPickerModelJs.ColorPickerModel)(color, [], 0);
    model.colorPresentations = colorPresentations || [];
    model.guessColorPresentation(color, originalText);
    if (participant instanceof ColorHoverParticipant) return new ColorHover(participant, (0, _rangeJs.Range).lift(colorInfo.range), model, provider);
    else return new StandaloneColorPickerHover(participant, (0, _rangeJs.Range).lift(colorInfo.range), model, provider);
}
function renderHoverParts(participant, editor, themeService, hoverParts, context) {
    if (hoverParts.length === 0 || !editor.hasModel()) return undefined;
    if (context.setMinimumDimensions) {
        const minimumHeight = editor.getOption(67 /* EditorOption.lineHeight */ ) + 8;
        context.setMinimumDimensions(new (0, _domJs.Dimension)(302, minimumHeight));
    }
    const disposables = new (0, _lifecycleJs.DisposableStore)();
    const colorHover = hoverParts[0];
    const editorModel = editor.getModel();
    const model = colorHover.model;
    const colorPicker = disposables.add(new (0, _colorPickerWidgetJs.ColorPickerWidget)(context.fragment, model, editor.getOption(144 /* EditorOption.pixelRatio */ ), themeService, participant instanceof StandaloneColorPickerParticipant));
    let editorUpdatedByColorPicker = false;
    let range = new (0, _rangeJs.Range)(colorHover.range.startLineNumber, colorHover.range.startColumn, colorHover.range.endLineNumber, colorHover.range.endColumn);
    if (participant instanceof StandaloneColorPickerParticipant) {
        const color = colorHover.model.color;
        participant.color = color;
        _updateColorPresentations(editorModel, model, color, range, colorHover);
        disposables.add(model.onColorFlushed((color)=>{
            participant.color = color;
        }));
    } else disposables.add(model.onColorFlushed(async (color)=>{
        await _updateColorPresentations(editorModel, model, color, range, colorHover);
        editorUpdatedByColorPicker = true;
        range = _updateEditorModel(editor, range, model);
    }));
    disposables.add(model.onDidChangeColor((color)=>{
        _updateColorPresentations(editorModel, model, color, range, colorHover);
    }));
    disposables.add(editor.onDidChangeModelContent((e)=>{
        if (editorUpdatedByColorPicker) editorUpdatedByColorPicker = false;
        else {
            context.hide();
            editor.focus();
        }
    }));
    return {
        hoverPart: colorHover,
        colorPicker,
        disposables
    };
}
function _updateEditorModel(editor, range, model) {
    const textEdits = [];
    const edit = model.presentation.textEdit ?? {
        range,
        text: model.presentation.label,
        forceMoveMarkers: false
    };
    textEdits.push(edit);
    if (model.presentation.additionalTextEdits) textEdits.push(...model.presentation.additionalTextEdits);
    const replaceRange = (0, _rangeJs.Range).lift(edit.range);
    const trackedRange = editor.getModel()._setTrackedRange(null, replaceRange, 3 /* TrackedRangeStickiness.GrowsOnlyWhenTypingAfter */ );
    editor.executeEdits("colorpicker", textEdits);
    editor.pushUndoStop();
    return editor.getModel()._getTrackedRange(trackedRange) ?? replaceRange;
}
async function _updateColorPresentations(editorModel, colorPickerModel, color, range, colorHover) {
    const colorPresentations = await (0, _colorJs1.getColorPresentations)(editorModel, {
        range: range,
        color: {
            red: color.rgba.r / 255,
            green: color.rgba.g / 255,
            blue: color.rgba.b / 255,
            alpha: color.rgba.a
        }
    }, colorHover.provider, (0, _cancellationJs.CancellationToken).None);
    colorPickerModel.colorPresentations = colorPresentations || [];
}

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/color.js":"at4gb","../../../../base/common/lifecycle.js":"9kg8d","../../../common/core/range.js":"jmUPh","./color.js":"bzikv","./colorDetector.js":"f19Gi","./colorPickerModel.js":"5pcbO","./colorPickerWidget.js":"I6lVE","../../hover/browser/hoverTypes.js":"6vmRi","../../../../platform/theme/common/themeService.js":"jMkIC","../../../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5pcbO":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorPickerModel", ()=>ColorPickerModel);
var _eventJs = require("../../../../base/common/event.js");
class ColorPickerModel {
    get color() {
        return this._color;
    }
    set color(color) {
        if (this._color.equals(color)) return;
        this._color = color;
        this._onDidChangeColor.fire(color);
    }
    get presentation() {
        return this.colorPresentations[this.presentationIndex];
    }
    get colorPresentations() {
        return this._colorPresentations;
    }
    set colorPresentations(colorPresentations) {
        this._colorPresentations = colorPresentations;
        if (this.presentationIndex > colorPresentations.length - 1) this.presentationIndex = 0;
        this._onDidChangePresentation.fire(this.presentation);
    }
    constructor(color, availableColorPresentations, presentationIndex){
        this.presentationIndex = presentationIndex;
        this._onColorFlushed = new (0, _eventJs.Emitter)();
        this.onColorFlushed = this._onColorFlushed.event;
        this._onDidChangeColor = new (0, _eventJs.Emitter)();
        this.onDidChangeColor = this._onDidChangeColor.event;
        this._onDidChangePresentation = new (0, _eventJs.Emitter)();
        this.onDidChangePresentation = this._onDidChangePresentation.event;
        this.originalColor = color;
        this._color = color;
        this._colorPresentations = availableColorPresentations;
    }
    selectNextColorPresentation() {
        this.presentationIndex = (this.presentationIndex + 1) % this.colorPresentations.length;
        this.flushColor();
        this._onDidChangePresentation.fire(this.presentation);
    }
    guessColorPresentation(color, originalText) {
        let presentationIndex = -1;
        for(let i = 0; i < this.colorPresentations.length; i++)if (originalText.toLowerCase() === this.colorPresentations[i].label) {
            presentationIndex = i;
            break;
        }
        if (presentationIndex === -1) {
            // check which color presentation text has same prefix as original text's prefix
            const originalTextPrefix = originalText.split("(")[0].toLowerCase();
            for(let i = 0; i < this.colorPresentations.length; i++)if (this.colorPresentations[i].label.toLowerCase().startsWith(originalTextPrefix)) {
                presentationIndex = i;
                break;
            }
        }
        if (presentationIndex !== -1 && presentationIndex !== this.presentationIndex) {
            this.presentationIndex = presentationIndex;
            this._onDidChangePresentation.fire(this.presentation);
        }
    }
    flushColor() {
        this._onColorFlushed.fire(this._color);
    }
}

},{"../../../../base/common/event.js":"4Zi8b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"I6lVE":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorPickerHeader", ()=>ColorPickerHeader);
parcelHelpers.export(exports, "ColorPickerBody", ()=>ColorPickerBody);
parcelHelpers.export(exports, "InsertButton", ()=>InsertButton);
parcelHelpers.export(exports, "ColorPickerWidget", ()=>ColorPickerWidget);
var _pixelRatioJs = require("../../../../base/browser/pixelRatio.js");
var _domJs = require("../../../../base/browser/dom.js");
var _globalPointerMoveMonitorJs = require("../../../../base/browser/globalPointerMoveMonitor.js");
var _widgetJs = require("../../../../base/browser/ui/widget.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _colorJs = require("../../../../base/common/color.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _themablesJs = require("../../../../base/common/themables.js");
var _colorPickerCss = require("./colorPicker.css");
var _nlsJs = require("../../../../nls.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _iconRegistryJs = require("../../../../platform/theme/common/iconRegistry.js");
const $ = _domJs.$;
class ColorPickerHeader extends (0, _lifecycleJs.Disposable) {
    constructor(container, model, themeService, showingStandaloneColorPicker = false){
        super();
        this.model = model;
        this.showingStandaloneColorPicker = showingStandaloneColorPicker;
        this._closeButton = null;
        this._domNode = $(".colorpicker-header");
        _domJs.append(container, this._domNode);
        this._pickedColorNode = _domJs.append(this._domNode, $(".picked-color"));
        _domJs.append(this._pickedColorNode, $("span.codicon.codicon-color-mode"));
        this._pickedColorPresentation = _domJs.append(this._pickedColorNode, document.createElement("span"));
        this._pickedColorPresentation.classList.add("picked-color-presentation");
        const tooltip = (0, _nlsJs.localize)("clickToToggleColorOptions", "Click to toggle color options (rgb/hsl/hex)");
        this._pickedColorNode.setAttribute("title", tooltip);
        this._originalColorNode = _domJs.append(this._domNode, $(".original-color"));
        this._originalColorNode.style.backgroundColor = (0, _colorJs.Color).Format.CSS.format(this.model.originalColor) || "";
        this.backgroundColor = themeService.getColorTheme().getColor((0, _colorRegistryJs.editorHoverBackground)) || (0, _colorJs.Color).white;
        this._register(themeService.onDidColorThemeChange((theme)=>{
            this.backgroundColor = theme.getColor((0, _colorRegistryJs.editorHoverBackground)) || (0, _colorJs.Color).white;
        }));
        this._register(_domJs.addDisposableListener(this._pickedColorNode, _domJs.EventType.CLICK, ()=>this.model.selectNextColorPresentation()));
        this._register(_domJs.addDisposableListener(this._originalColorNode, _domJs.EventType.CLICK, ()=>{
            this.model.color = this.model.originalColor;
            this.model.flushColor();
        }));
        this._register(model.onDidChangeColor(this.onDidChangeColor, this));
        this._register(model.onDidChangePresentation(this.onDidChangePresentation, this));
        this._pickedColorNode.style.backgroundColor = (0, _colorJs.Color).Format.CSS.format(model.color) || "";
        this._pickedColorNode.classList.toggle("light", model.color.rgba.a < 0.5 ? this.backgroundColor.isLighter() : model.color.isLighter());
        this.onDidChangeColor(this.model.color);
        // When the color picker widget is a standalone color picker widget, then add a close button
        if (this.showingStandaloneColorPicker) {
            this._domNode.classList.add("standalone-colorpicker");
            this._closeButton = this._register(new CloseButton(this._domNode));
        }
    }
    get closeButton() {
        return this._closeButton;
    }
    get pickedColorNode() {
        return this._pickedColorNode;
    }
    get originalColorNode() {
        return this._originalColorNode;
    }
    onDidChangeColor(color) {
        this._pickedColorNode.style.backgroundColor = (0, _colorJs.Color).Format.CSS.format(color) || "";
        this._pickedColorNode.classList.toggle("light", color.rgba.a < 0.5 ? this.backgroundColor.isLighter() : color.isLighter());
        this.onDidChangePresentation();
    }
    onDidChangePresentation() {
        this._pickedColorPresentation.textContent = this.model.presentation ? this.model.presentation.label : "";
    }
}
class CloseButton extends (0, _lifecycleJs.Disposable) {
    constructor(container){
        super();
        this._onClicked = this._register(new (0, _eventJs.Emitter)());
        this.onClicked = this._onClicked.event;
        this._button = document.createElement("div");
        this._button.classList.add("close-button");
        _domJs.append(container, this._button);
        const innerDiv = document.createElement("div");
        innerDiv.classList.add("close-button-inner-div");
        _domJs.append(this._button, innerDiv);
        const closeButton = _domJs.append(innerDiv, $(".button" + (0, _themablesJs.ThemeIcon).asCSSSelector((0, _iconRegistryJs.registerIcon)("color-picker-close", (0, _codiconsJs.Codicon).close, (0, _nlsJs.localize)("closeIcon", "Icon to close the color picker")))));
        closeButton.classList.add("close-icon");
        this._register(_domJs.addDisposableListener(this._button, _domJs.EventType.CLICK, ()=>{
            this._onClicked.fire();
        }));
    }
}
class ColorPickerBody extends (0, _lifecycleJs.Disposable) {
    constructor(container, model, pixelRatio, isStandaloneColorPicker = false){
        super();
        this.model = model;
        this.pixelRatio = pixelRatio;
        this._insertButton = null;
        this._domNode = $(".colorpicker-body");
        _domJs.append(container, this._domNode);
        this._saturationBox = new SaturationBox(this._domNode, this.model, this.pixelRatio);
        this._register(this._saturationBox);
        this._register(this._saturationBox.onDidChange(this.onDidSaturationValueChange, this));
        this._register(this._saturationBox.onColorFlushed(this.flushColor, this));
        this._opacityStrip = new OpacityStrip(this._domNode, this.model, isStandaloneColorPicker);
        this._register(this._opacityStrip);
        this._register(this._opacityStrip.onDidChange(this.onDidOpacityChange, this));
        this._register(this._opacityStrip.onColorFlushed(this.flushColor, this));
        this._hueStrip = new HueStrip(this._domNode, this.model, isStandaloneColorPicker);
        this._register(this._hueStrip);
        this._register(this._hueStrip.onDidChange(this.onDidHueChange, this));
        this._register(this._hueStrip.onColorFlushed(this.flushColor, this));
        if (isStandaloneColorPicker) {
            this._insertButton = this._register(new InsertButton(this._domNode));
            this._domNode.classList.add("standalone-colorpicker");
        }
    }
    flushColor() {
        this.model.flushColor();
    }
    onDidSaturationValueChange({ s, v }) {
        const hsva = this.model.color.hsva;
        this.model.color = new (0, _colorJs.Color)(new (0, _colorJs.HSVA)(hsva.h, s, v, hsva.a));
    }
    onDidOpacityChange(a) {
        const hsva = this.model.color.hsva;
        this.model.color = new (0, _colorJs.Color)(new (0, _colorJs.HSVA)(hsva.h, hsva.s, hsva.v, a));
    }
    onDidHueChange(value) {
        const hsva = this.model.color.hsva;
        const h = (1 - value) * 360;
        this.model.color = new (0, _colorJs.Color)(new (0, _colorJs.HSVA)(h === 360 ? 0 : h, hsva.s, hsva.v, hsva.a));
    }
    get domNode() {
        return this._domNode;
    }
    get saturationBox() {
        return this._saturationBox;
    }
    get enterButton() {
        return this._insertButton;
    }
    layout() {
        this._saturationBox.layout();
        this._opacityStrip.layout();
        this._hueStrip.layout();
    }
}
class SaturationBox extends (0, _lifecycleJs.Disposable) {
    constructor(container, model, pixelRatio){
        super();
        this.model = model;
        this.pixelRatio = pixelRatio;
        this._onDidChange = new (0, _eventJs.Emitter)();
        this.onDidChange = this._onDidChange.event;
        this._onColorFlushed = new (0, _eventJs.Emitter)();
        this.onColorFlushed = this._onColorFlushed.event;
        this._domNode = $(".saturation-wrap");
        _domJs.append(container, this._domNode);
        // Create canvas, draw selected color
        this._canvas = document.createElement("canvas");
        this._canvas.className = "saturation-box";
        _domJs.append(this._domNode, this._canvas);
        // Add selection circle
        this.selection = $(".saturation-selection");
        _domJs.append(this._domNode, this.selection);
        this.layout();
        this._register(_domJs.addDisposableListener(this._domNode, _domJs.EventType.POINTER_DOWN, (e)=>this.onPointerDown(e)));
        this._register(this.model.onDidChangeColor(this.onDidChangeColor, this));
        this.monitor = null;
    }
    get domNode() {
        return this._domNode;
    }
    onPointerDown(e) {
        if (!e.target || !(e.target instanceof Element)) return;
        this.monitor = this._register(new (0, _globalPointerMoveMonitorJs.GlobalPointerMoveMonitor)());
        const origin = _domJs.getDomNodePagePosition(this._domNode);
        if (e.target !== this.selection) this.onDidChangePosition(e.offsetX, e.offsetY);
        this.monitor.startMonitoring(e.target, e.pointerId, e.buttons, (event)=>this.onDidChangePosition(event.pageX - origin.left, event.pageY - origin.top), ()=>null);
        const pointerUpListener = _domJs.addDisposableListener(e.target.ownerDocument, _domJs.EventType.POINTER_UP, ()=>{
            this._onColorFlushed.fire();
            pointerUpListener.dispose();
            if (this.monitor) {
                this.monitor.stopMonitoring(true);
                this.monitor = null;
            }
        }, true);
    }
    onDidChangePosition(left, top) {
        const s = Math.max(0, Math.min(1, left / this.width));
        const v = Math.max(0, Math.min(1, 1 - top / this.height));
        this.paintSelection(s, v);
        this._onDidChange.fire({
            s,
            v
        });
    }
    layout() {
        this.width = this._domNode.offsetWidth;
        this.height = this._domNode.offsetHeight;
        this._canvas.width = this.width * this.pixelRatio;
        this._canvas.height = this.height * this.pixelRatio;
        this.paint();
        const hsva = this.model.color.hsva;
        this.paintSelection(hsva.s, hsva.v);
    }
    paint() {
        const hsva = this.model.color.hsva;
        const saturatedColor = new (0, _colorJs.Color)(new (0, _colorJs.HSVA)(hsva.h, 1, 1, 1));
        const ctx = this._canvas.getContext("2d");
        const whiteGradient = ctx.createLinearGradient(0, 0, this._canvas.width, 0);
        whiteGradient.addColorStop(0, "rgba(255, 255, 255, 1)");
        whiteGradient.addColorStop(0.5, "rgba(255, 255, 255, 0.5)");
        whiteGradient.addColorStop(1, "rgba(255, 255, 255, 0)");
        const blackGradient = ctx.createLinearGradient(0, 0, 0, this._canvas.height);
        blackGradient.addColorStop(0, "rgba(0, 0, 0, 0)");
        blackGradient.addColorStop(1, "rgba(0, 0, 0, 1)");
        ctx.rect(0, 0, this._canvas.width, this._canvas.height);
        ctx.fillStyle = (0, _colorJs.Color).Format.CSS.format(saturatedColor);
        ctx.fill();
        ctx.fillStyle = whiteGradient;
        ctx.fill();
        ctx.fillStyle = blackGradient;
        ctx.fill();
    }
    paintSelection(s, v) {
        this.selection.style.left = `${s * this.width}px`;
        this.selection.style.top = `${this.height - v * this.height}px`;
    }
    onDidChangeColor(color) {
        if (this.monitor && this.monitor.isMonitoring()) return;
        this.paint();
        const hsva = color.hsva;
        this.paintSelection(hsva.s, hsva.v);
    }
}
class Strip extends (0, _lifecycleJs.Disposable) {
    constructor(container, model, showingStandaloneColorPicker = false){
        super();
        this.model = model;
        this._onDidChange = new (0, _eventJs.Emitter)();
        this.onDidChange = this._onDidChange.event;
        this._onColorFlushed = new (0, _eventJs.Emitter)();
        this.onColorFlushed = this._onColorFlushed.event;
        if (showingStandaloneColorPicker) {
            this.domNode = _domJs.append(container, $(".standalone-strip"));
            this.overlay = _domJs.append(this.domNode, $(".standalone-overlay"));
        } else {
            this.domNode = _domJs.append(container, $(".strip"));
            this.overlay = _domJs.append(this.domNode, $(".overlay"));
        }
        this.slider = _domJs.append(this.domNode, $(".slider"));
        this.slider.style.top = `0px`;
        this._register(_domJs.addDisposableListener(this.domNode, _domJs.EventType.POINTER_DOWN, (e)=>this.onPointerDown(e)));
        this._register(model.onDidChangeColor(this.onDidChangeColor, this));
        this.layout();
    }
    layout() {
        this.height = this.domNode.offsetHeight - this.slider.offsetHeight;
        const value = this.getValue(this.model.color);
        this.updateSliderPosition(value);
    }
    onDidChangeColor(color) {
        const value = this.getValue(color);
        this.updateSliderPosition(value);
    }
    onPointerDown(e) {
        if (!e.target || !(e.target instanceof Element)) return;
        const monitor = this._register(new (0, _globalPointerMoveMonitorJs.GlobalPointerMoveMonitor)());
        const origin = _domJs.getDomNodePagePosition(this.domNode);
        this.domNode.classList.add("grabbing");
        if (e.target !== this.slider) this.onDidChangeTop(e.offsetY);
        monitor.startMonitoring(e.target, e.pointerId, e.buttons, (event)=>this.onDidChangeTop(event.pageY - origin.top), ()=>null);
        const pointerUpListener = _domJs.addDisposableListener(e.target.ownerDocument, _domJs.EventType.POINTER_UP, ()=>{
            this._onColorFlushed.fire();
            pointerUpListener.dispose();
            monitor.stopMonitoring(true);
            this.domNode.classList.remove("grabbing");
        }, true);
    }
    onDidChangeTop(top) {
        const value = Math.max(0, Math.min(1, 1 - top / this.height));
        this.updateSliderPosition(value);
        this._onDidChange.fire(value);
    }
    updateSliderPosition(value) {
        this.slider.style.top = `${(1 - value) * this.height}px`;
    }
}
class OpacityStrip extends Strip {
    constructor(container, model, showingStandaloneColorPicker = false){
        super(container, model, showingStandaloneColorPicker);
        this.domNode.classList.add("opacity-strip");
        this.onDidChangeColor(this.model.color);
    }
    onDidChangeColor(color) {
        super.onDidChangeColor(color);
        const { r, g, b } = color.rgba;
        const opaque = new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(r, g, b, 1));
        const transparent = new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(r, g, b, 0));
        this.overlay.style.background = `linear-gradient(to bottom, ${opaque} 0%, ${transparent} 100%)`;
    }
    getValue(color) {
        return color.hsva.a;
    }
}
class HueStrip extends Strip {
    constructor(container, model, showingStandaloneColorPicker = false){
        super(container, model, showingStandaloneColorPicker);
        this.domNode.classList.add("hue-strip");
    }
    getValue(color) {
        return 1 - color.hsva.h / 360;
    }
}
class InsertButton extends (0, _lifecycleJs.Disposable) {
    constructor(container){
        super();
        this._onClicked = this._register(new (0, _eventJs.Emitter)());
        this.onClicked = this._onClicked.event;
        this._button = _domJs.append(container, document.createElement("button"));
        this._button.classList.add("insert-button");
        this._button.textContent = "Insert";
        this._register(_domJs.addDisposableListener(this._button, _domJs.EventType.CLICK, ()=>{
            this._onClicked.fire();
        }));
    }
    get button() {
        return this._button;
    }
}
class ColorPickerWidget extends (0, _widgetJs.Widget) {
    constructor(container, model, pixelRatio, themeService, standaloneColorPicker = false){
        super();
        this.model = model;
        this.pixelRatio = pixelRatio;
        this._register((0, _pixelRatioJs.PixelRatio).getInstance(_domJs.getWindow(container)).onDidChange(()=>this.layout()));
        this._domNode = $(".colorpicker-widget");
        container.appendChild(this._domNode);
        this.header = this._register(new ColorPickerHeader(this._domNode, this.model, themeService, standaloneColorPicker));
        this.body = this._register(new ColorPickerBody(this._domNode, this.model, this.pixelRatio, standaloneColorPicker));
    }
    layout() {
        this.body.layout();
    }
    get domNode() {
        return this._domNode;
    }
}

},{"../../../../base/browser/pixelRatio.js":"2Kvgn","../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/globalPointerMoveMonitor.js":"iDfLk","../../../../base/browser/ui/widget.js":"kM4DP","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/color.js":"at4gb","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/themables.js":"hgyHi","./colorPicker.css":"iFkXG","../../../../nls.js":"l617d","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/iconRegistry.js":"bRNEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iFkXG":[function() {},{}],"6vmRi":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverRangeAnchor", ()=>HoverRangeAnchor);
parcelHelpers.export(exports, "HoverForeignElementAnchor", ()=>HoverForeignElementAnchor);
/**
 * Default implementation of IRenderedHoverParts.
 */ parcelHelpers.export(exports, "RenderedHoverParts", ()=>RenderedHoverParts);
parcelHelpers.export(exports, "HoverParticipantRegistry", ()=>HoverParticipantRegistry);
class HoverRangeAnchor {
    constructor(priority, range, initialMousePosX, initialMousePosY){
        this.priority = priority;
        this.range = range;
        this.initialMousePosX = initialMousePosX;
        this.initialMousePosY = initialMousePosY;
        this.type = 1 /* HoverAnchorType.Range */ ;
    }
    equals(other) {
        return other.type === 1 /* HoverAnchorType.Range */  && this.range.equalsRange(other.range);
    }
    canAdoptVisibleHover(lastAnchor, showAtPosition) {
        return lastAnchor.type === 1 /* HoverAnchorType.Range */  && showAtPosition.lineNumber === this.range.startLineNumber;
    }
}
class HoverForeignElementAnchor {
    constructor(priority, owner, range, initialMousePosX, initialMousePosY, supportsMarkerHover){
        this.priority = priority;
        this.owner = owner;
        this.range = range;
        this.initialMousePosX = initialMousePosX;
        this.initialMousePosY = initialMousePosY;
        this.supportsMarkerHover = supportsMarkerHover;
        this.type = 2 /* HoverAnchorType.ForeignElement */ ;
    }
    equals(other) {
        return other.type === 2 /* HoverAnchorType.ForeignElement */  && this.owner === other.owner;
    }
    canAdoptVisibleHover(lastAnchor, showAtPosition) {
        return lastAnchor.type === 2 /* HoverAnchorType.ForeignElement */  && this.owner === lastAnchor.owner;
    }
}
class RenderedHoverParts {
    constructor(renderedHoverParts){
        this.renderedHoverParts = renderedHoverParts;
    }
    dispose() {
        for (const part of this.renderedHoverParts)part.dispose();
    }
}
const HoverParticipantRegistry = new class HoverParticipantRegistry {
    constructor(){
        this._participants = [];
    }
    register(ctor) {
        this._participants.push(ctor);
    }
    getAll() {
        return this._participants;
    }
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"mYQJl":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContentHoverController", ()=>ContentHoverController);
var _hoverActionIdsJs = require("./hoverActionIds.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _inlineCompletionsHintsWidgetJs = require("../../inlineCompletions/browser/hintsWidget/inlineCompletionsHintsWidget.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _asyncJs = require("../../../../base/common/async.js");
var _hoverUtilsJs = require("./hoverUtils.js");
var _contentHoverWidgetWrapperJs = require("./contentHoverWidgetWrapper.js");
var _hoverCss = require("./hover.css");
var _eventJs = require("../../../../base/common/event.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var ContentHoverController_1;
// sticky hover widget which doesn't disappear on focus out and such
const _sticky = false;
let ContentHoverController = class ContentHoverController extends (0, _lifecycleJs.Disposable) {
    static{
        ContentHoverController_1 = this;
    }
    static{
        this.ID = "editor.contrib.contentHover";
    }
    constructor(_editor, _instantiationService, _keybindingService){
        super();
        this._editor = _editor;
        this._instantiationService = _instantiationService;
        this._keybindingService = _keybindingService;
        this._onHoverContentsChanged = this._register(new (0, _eventJs.Emitter)());
        this.shouldKeepOpenOnEditorMouseMoveOrLeave = false;
        this._listenersStore = new (0, _lifecycleJs.DisposableStore)();
        this._hoverState = {
            mouseDown: false,
            activatedByDecoratorClick: false
        };
        this._reactToEditorMouseMoveRunner = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._reactToEditorMouseMove(this._mouseMoveEvent), 0));
        this._hookListeners();
        this._register(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(60 /* EditorOption.hover */ )) {
                this._unhookListeners();
                this._hookListeners();
            }
        }));
    }
    static get(editor) {
        return editor.getContribution(ContentHoverController_1.ID);
    }
    _hookListeners() {
        const hoverOpts = this._editor.getOption(60 /* EditorOption.hover */ );
        this._hoverSettings = {
            enabled: hoverOpts.enabled,
            sticky: hoverOpts.sticky,
            hidingDelay: hoverOpts.hidingDelay
        };
        if (hoverOpts.enabled) {
            this._listenersStore.add(this._editor.onMouseDown((e)=>this._onEditorMouseDown(e)));
            this._listenersStore.add(this._editor.onMouseUp(()=>this._onEditorMouseUp()));
            this._listenersStore.add(this._editor.onMouseMove((e)=>this._onEditorMouseMove(e)));
            this._listenersStore.add(this._editor.onKeyDown((e)=>this._onKeyDown(e)));
        } else {
            this._listenersStore.add(this._editor.onMouseMove((e)=>this._onEditorMouseMove(e)));
            this._listenersStore.add(this._editor.onKeyDown((e)=>this._onKeyDown(e)));
        }
        this._listenersStore.add(this._editor.onMouseLeave((e)=>this._onEditorMouseLeave(e)));
        this._listenersStore.add(this._editor.onDidChangeModel(()=>{
            this._cancelScheduler();
            this._hideWidgets();
        }));
        this._listenersStore.add(this._editor.onDidChangeModelContent(()=>this._cancelScheduler()));
        this._listenersStore.add(this._editor.onDidScrollChange((e)=>this._onEditorScrollChanged(e)));
    }
    _unhookListeners() {
        this._listenersStore.clear();
    }
    _cancelScheduler() {
        this._mouseMoveEvent = undefined;
        this._reactToEditorMouseMoveRunner.cancel();
    }
    _onEditorScrollChanged(e) {
        if (e.scrollTopChanged || e.scrollLeftChanged) this._hideWidgets();
    }
    _onEditorMouseDown(mouseEvent) {
        this._hoverState.mouseDown = true;
        const shouldNotHideCurrentHoverWidget = this._shouldNotHideCurrentHoverWidget(mouseEvent);
        if (shouldNotHideCurrentHoverWidget) return;
        this._hideWidgets();
    }
    _shouldNotHideCurrentHoverWidget(mouseEvent) {
        return this._isMouseOnContentHoverWidget(mouseEvent) || this._isContentWidgetResizing();
    }
    _isMouseOnContentHoverWidget(mouseEvent) {
        const contentWidgetNode = this._contentWidget?.getDomNode();
        if (contentWidgetNode) return (0, _hoverUtilsJs.isMousePositionWithinElement)(contentWidgetNode, mouseEvent.event.posx, mouseEvent.event.posy);
        return false;
    }
    _onEditorMouseUp() {
        this._hoverState.mouseDown = false;
    }
    _onEditorMouseLeave(mouseEvent) {
        if (this.shouldKeepOpenOnEditorMouseMoveOrLeave) return;
        this._cancelScheduler();
        const shouldNotHideCurrentHoverWidget = this._shouldNotHideCurrentHoverWidget(mouseEvent);
        if (shouldNotHideCurrentHoverWidget) return;
        if (_sticky) return;
        this._hideWidgets();
    }
    _shouldNotRecomputeCurrentHoverWidget(mouseEvent) {
        const isHoverSticky = this._hoverSettings.sticky;
        const isMouseOnStickyContentHoverWidget = (mouseEvent, isHoverSticky)=>{
            const isMouseOnContentHoverWidget = this._isMouseOnContentHoverWidget(mouseEvent);
            return isHoverSticky && isMouseOnContentHoverWidget;
        };
        const isMouseOnColorPicker = (mouseEvent)=>{
            const isMouseOnContentHoverWidget = this._isMouseOnContentHoverWidget(mouseEvent);
            const isColorPickerVisible = this._contentWidget?.isColorPickerVisible ?? false;
            return isMouseOnContentHoverWidget && isColorPickerVisible;
        };
        // TODO@aiday-mar verify if the following is necessary code
        const isTextSelectedWithinContentHoverWidget = (mouseEvent, sticky)=>{
            return (sticky && this._contentWidget?.containsNode(mouseEvent.event.browserEvent.view?.document.activeElement) && !mouseEvent.event.browserEvent.view?.getSelection()?.isCollapsed) ?? false;
        };
        return isMouseOnStickyContentHoverWidget(mouseEvent, isHoverSticky) || isMouseOnColorPicker(mouseEvent) || isTextSelectedWithinContentHoverWidget(mouseEvent, isHoverSticky);
    }
    _onEditorMouseMove(mouseEvent) {
        if (this.shouldKeepOpenOnEditorMouseMoveOrLeave) return;
        this._mouseMoveEvent = mouseEvent;
        if (this._contentWidget?.isFocused || this._contentWidget?.isResizing) return;
        const sticky = this._hoverSettings.sticky;
        if (sticky && this._contentWidget?.isVisibleFromKeyboard) // Sticky mode is on and the hover has been shown via keyboard
        // so moving the mouse has no effect
        return;
        const shouldNotRecomputeCurrentHoverWidget = this._shouldNotRecomputeCurrentHoverWidget(mouseEvent);
        if (shouldNotRecomputeCurrentHoverWidget) {
            this._reactToEditorMouseMoveRunner.cancel();
            return;
        }
        const hidingDelay = this._hoverSettings.hidingDelay;
        const isContentHoverWidgetVisible = this._contentWidget?.isVisible;
        // If the mouse is not over the widget, and if sticky is on,
        // then give it a grace period before reacting to the mouse event
        const shouldRescheduleHoverComputation = isContentHoverWidgetVisible && sticky && hidingDelay > 0;
        if (shouldRescheduleHoverComputation) {
            if (!this._reactToEditorMouseMoveRunner.isScheduled()) this._reactToEditorMouseMoveRunner.schedule(hidingDelay);
            return;
        }
        this._reactToEditorMouseMove(mouseEvent);
    }
    _reactToEditorMouseMove(mouseEvent) {
        if (!mouseEvent) return;
        const target = mouseEvent.target;
        const mouseOnDecorator = target.element?.classList.contains("colorpicker-color-decoration");
        const decoratorActivatedOn = this._editor.getOption(149 /* EditorOption.colorDecoratorsActivatedOn */ );
        const enabled = this._hoverSettings.enabled;
        const activatedByDecoratorClick = this._hoverState.activatedByDecoratorClick;
        if (mouseOnDecorator && (decoratorActivatedOn === "click" && !activatedByDecoratorClick || decoratorActivatedOn === "hover" && !enabled && !_sticky || decoratorActivatedOn === "clickAndHover" && !enabled && !activatedByDecoratorClick) || !mouseOnDecorator && !enabled && !activatedByDecoratorClick) {
            this._hideWidgets();
            return;
        }
        const contentHoverShowsOrWillShow = this._tryShowHoverWidget(mouseEvent);
        if (contentHoverShowsOrWillShow) return;
        if (_sticky) return;
        this._hideWidgets();
    }
    _tryShowHoverWidget(mouseEvent) {
        const contentWidget = this._getOrCreateContentWidget();
        return contentWidget.showsOrWillShow(mouseEvent);
    }
    _onKeyDown(e) {
        if (!this._editor.hasModel()) return;
        const resolvedKeyboardEvent = this._keybindingService.softDispatch(e, this._editor.getDomNode());
        // If the beginning of a multi-chord keybinding is pressed,
        // or the command aims to focus the hover,
        // set the variable to true, otherwise false
        const shouldKeepHoverVisible = resolvedKeyboardEvent.kind === 1 /* ResultKind.MoreChordsNeeded */  || resolvedKeyboardEvent.kind === 2 /* ResultKind.KbFound */  && (resolvedKeyboardEvent.commandId === (0, _hoverActionIdsJs.SHOW_OR_FOCUS_HOVER_ACTION_ID) || resolvedKeyboardEvent.commandId === (0, _hoverActionIdsJs.INCREASE_HOVER_VERBOSITY_ACTION_ID) || resolvedKeyboardEvent.commandId === (0, _hoverActionIdsJs.DECREASE_HOVER_VERBOSITY_ACTION_ID)) && this._contentWidget?.isVisible;
        if (e.keyCode === 5 /* KeyCode.Ctrl */  || e.keyCode === 6 /* KeyCode.Alt */  || e.keyCode === 57 /* KeyCode.Meta */  || e.keyCode === 4 /* KeyCode.Shift */  || shouldKeepHoverVisible) // Do not hide hover when a modifier key is pressed
        return;
        this._hideWidgets();
    }
    _hideWidgets() {
        if (_sticky) return;
        if (this._hoverState.mouseDown && this._contentWidget?.isColorPickerVisible || (0, _inlineCompletionsHintsWidgetJs.InlineSuggestionHintsContentWidget).dropDownVisible) return;
        this._hoverState.activatedByDecoratorClick = false;
        this._contentWidget?.hide();
    }
    _getOrCreateContentWidget() {
        if (!this._contentWidget) {
            this._contentWidget = this._instantiationService.createInstance((0, _contentHoverWidgetWrapperJs.ContentHoverWidgetWrapper), this._editor);
            this._listenersStore.add(this._contentWidget.onContentsChanged(()=>this._onHoverContentsChanged.fire()));
        }
        return this._contentWidget;
    }
    showContentHover(range, mode, source, focus, activatedByColorDecoratorClick = false) {
        this._hoverState.activatedByDecoratorClick = activatedByColorDecoratorClick;
        this._getOrCreateContentWidget().startShowingAtRange(range, mode, source, focus);
    }
    _isContentWidgetResizing() {
        return this._contentWidget?.widget.isResizing || false;
    }
    focusedHoverPartIndex() {
        return this._getOrCreateContentWidget().focusedHoverPartIndex();
    }
    updateHoverVerbosityLevel(action, index, focus) {
        this._getOrCreateContentWidget().updateHoverVerbosityLevel(action, index, focus);
    }
    focus() {
        this._contentWidget?.focus();
    }
    scrollUp() {
        this._contentWidget?.scrollUp();
    }
    scrollDown() {
        this._contentWidget?.scrollDown();
    }
    scrollLeft() {
        this._contentWidget?.scrollLeft();
    }
    scrollRight() {
        this._contentWidget?.scrollRight();
    }
    pageUp() {
        this._contentWidget?.pageUp();
    }
    pageDown() {
        this._contentWidget?.pageDown();
    }
    goToTop() {
        this._contentWidget?.goToTop();
    }
    goToBottom() {
        this._contentWidget?.goToBottom();
    }
    get isColorPickerVisible() {
        return this._contentWidget?.isColorPickerVisible;
    }
    get isHoverVisible() {
        return this._contentWidget?.isVisible;
    }
    dispose() {
        super.dispose();
        this._unhookListeners();
        this._listenersStore.dispose();
        this._contentWidget?.dispose();
    }
};
ContentHoverController = ContentHoverController_1 = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService)),
    __param(2, (0, _keybindingJs.IKeybindingService))
], ContentHoverController);

},{"./hoverActionIds.js":"b3M99","../../../../base/common/lifecycle.js":"9kg8d","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../inlineCompletions/browser/hintsWidget/inlineCompletionsHintsWidget.js":"4zZCT","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../base/common/async.js":"4GJc4","./hoverUtils.js":"iINMK","./contentHoverWidgetWrapper.js":"6UNsA","./hover.css":"jKoKx","../../../../base/common/event.js":"4Zi8b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b3M99":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SHOW_OR_FOCUS_HOVER_ACTION_ID", ()=>SHOW_OR_FOCUS_HOVER_ACTION_ID);
parcelHelpers.export(exports, "SHOW_DEFINITION_PREVIEW_HOVER_ACTION_ID", ()=>SHOW_DEFINITION_PREVIEW_HOVER_ACTION_ID);
parcelHelpers.export(exports, "SCROLL_UP_HOVER_ACTION_ID", ()=>SCROLL_UP_HOVER_ACTION_ID);
parcelHelpers.export(exports, "SCROLL_DOWN_HOVER_ACTION_ID", ()=>SCROLL_DOWN_HOVER_ACTION_ID);
parcelHelpers.export(exports, "SCROLL_LEFT_HOVER_ACTION_ID", ()=>SCROLL_LEFT_HOVER_ACTION_ID);
parcelHelpers.export(exports, "SCROLL_RIGHT_HOVER_ACTION_ID", ()=>SCROLL_RIGHT_HOVER_ACTION_ID);
parcelHelpers.export(exports, "PAGE_UP_HOVER_ACTION_ID", ()=>PAGE_UP_HOVER_ACTION_ID);
parcelHelpers.export(exports, "PAGE_DOWN_HOVER_ACTION_ID", ()=>PAGE_DOWN_HOVER_ACTION_ID);
parcelHelpers.export(exports, "GO_TO_TOP_HOVER_ACTION_ID", ()=>GO_TO_TOP_HOVER_ACTION_ID);
parcelHelpers.export(exports, "GO_TO_BOTTOM_HOVER_ACTION_ID", ()=>GO_TO_BOTTOM_HOVER_ACTION_ID);
parcelHelpers.export(exports, "INCREASE_HOVER_VERBOSITY_ACTION_ID", ()=>INCREASE_HOVER_VERBOSITY_ACTION_ID);
parcelHelpers.export(exports, "INCREASE_HOVER_VERBOSITY_ACTION_LABEL", ()=>INCREASE_HOVER_VERBOSITY_ACTION_LABEL);
parcelHelpers.export(exports, "DECREASE_HOVER_VERBOSITY_ACTION_ID", ()=>DECREASE_HOVER_VERBOSITY_ACTION_ID);
parcelHelpers.export(exports, "DECREASE_HOVER_VERBOSITY_ACTION_LABEL", ()=>DECREASE_HOVER_VERBOSITY_ACTION_LABEL);
var _nlsJs = require("../../../../nls.js");
const SHOW_OR_FOCUS_HOVER_ACTION_ID = "editor.action.showHover";
const SHOW_DEFINITION_PREVIEW_HOVER_ACTION_ID = "editor.action.showDefinitionPreviewHover";
const SCROLL_UP_HOVER_ACTION_ID = "editor.action.scrollUpHover";
const SCROLL_DOWN_HOVER_ACTION_ID = "editor.action.scrollDownHover";
const SCROLL_LEFT_HOVER_ACTION_ID = "editor.action.scrollLeftHover";
const SCROLL_RIGHT_HOVER_ACTION_ID = "editor.action.scrollRightHover";
const PAGE_UP_HOVER_ACTION_ID = "editor.action.pageUpHover";
const PAGE_DOWN_HOVER_ACTION_ID = "editor.action.pageDownHover";
const GO_TO_TOP_HOVER_ACTION_ID = "editor.action.goToTopHover";
const GO_TO_BOTTOM_HOVER_ACTION_ID = "editor.action.goToBottomHover";
const INCREASE_HOVER_VERBOSITY_ACTION_ID = "editor.action.increaseHoverVerbosityLevel";
const INCREASE_HOVER_VERBOSITY_ACTION_LABEL = _nlsJs.localize({
    key: "increaseHoverVerbosityLevel",
    comment: [
        "Label for action that will increase the hover verbosity level."
    ]
}, "Increase Hover Verbosity Level");
const DECREASE_HOVER_VERBOSITY_ACTION_ID = "editor.action.decreaseHoverVerbosityLevel";
const DECREASE_HOVER_VERBOSITY_ACTION_LABEL = _nlsJs.localize({
    key: "decreaseHoverVerbosityLevel",
    comment: [
        "Label for action that will decrease the hover verbosity level."
    ]
}, "Decrease Hover Verbosity Level");

},{"../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4zZCT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineCompletionsHintsWidget", ()=>InlineCompletionsHintsWidget);
parcelHelpers.export(exports, "InlineSuggestionHintsContentWidget", ()=>InlineSuggestionHintsContentWidget);
parcelHelpers.export(exports, "CustomizedMenuWorkbenchToolBar", ()=>CustomizedMenuWorkbenchToolBar);
var _domJs = require("../../../../../base/browser/dom.js");
var _actionViewItemsJs = require("../../../../../base/browser/ui/actionbar/actionViewItems.js");
var _keybindingLabelJs = require("../../../../../base/browser/ui/keybindingLabel/keybindingLabel.js");
var _actionsJs = require("../../../../../base/common/actions.js");
var _arraysJs = require("../../../../../base/common/arrays.js");
var _asyncJs = require("../../../../../base/common/async.js");
var _codiconsJs = require("../../../../../base/common/codicons.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _derivedJs = require("../../../../../base/common/observableInternal/derived.js");
var _platformJs = require("../../../../../base/common/platform.js");
var _themablesJs = require("../../../../../base/common/themables.js");
var _inlineCompletionsHintsWidgetCss = require("./inlineCompletionsHintsWidget.css");
var _positionJs = require("../../../../common/core/position.js");
var _languagesJs = require("../../../../common/languages.js");
var _commandIdsJs = require("../controller/commandIds.js");
var _nlsJs = require("../../../../../nls.js");
var _menuEntryActionViewItemJs = require("../../../../../platform/actions/browser/menuEntryActionViewItem.js");
var _toolbarJs = require("../../../../../platform/actions/browser/toolbar.js");
var _actionsJs1 = require("../../../../../platform/actions/common/actions.js");
var _commandsJs = require("../../../../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../../../../platform/contextkey/common/contextkey.js");
var _contextViewJs = require("../../../../../platform/contextview/browser/contextView.js");
var _instantiationJs = require("../../../../../platform/instantiation/common/instantiation.js");
var _keybindingJs = require("../../../../../platform/keybinding/common/keybinding.js");
var _telemetryJs = require("../../../../../platform/telemetry/common/telemetry.js");
var _iconRegistryJs = require("../../../../../platform/theme/common/iconRegistry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var InlineSuggestionHintsContentWidget_1;
let InlineCompletionsHintsWidget = class InlineCompletionsHintsWidget extends (0, _lifecycleJs.Disposable) {
    constructor(editor, model, instantiationService){
        super();
        this.editor = editor;
        this.model = model;
        this.instantiationService = instantiationService;
        this.alwaysShowToolbar = (0, _observableJs.observableFromEvent)(this, this.editor.onDidChangeConfiguration, ()=>this.editor.getOption(62 /* EditorOption.inlineSuggest */ ).showToolbar === "always");
        this.sessionPosition = undefined;
        this.position = (0, _observableJs.derived)(this, (reader)=>{
            const ghostText = this.model.read(reader)?.primaryGhostText.read(reader);
            if (!this.alwaysShowToolbar.read(reader) || !ghostText || ghostText.parts.length === 0) {
                this.sessionPosition = undefined;
                return null;
            }
            const firstColumn = ghostText.parts[0].column;
            if (this.sessionPosition && this.sessionPosition.lineNumber !== ghostText.lineNumber) this.sessionPosition = undefined;
            const position = new (0, _positionJs.Position)(ghostText.lineNumber, Math.min(firstColumn, this.sessionPosition?.column ?? Number.MAX_SAFE_INTEGER));
            this.sessionPosition = position;
            return position;
        });
        this._register((0, _observableJs.autorunWithStore)((reader, store)=>{
            /** @description setup content widget */ const model = this.model.read(reader);
            if (!model || !this.alwaysShowToolbar.read(reader)) return;
            const contentWidgetValue = (0, _derivedJs.derivedWithStore)((reader, store)=>{
                const contentWidget = store.add(this.instantiationService.createInstance(InlineSuggestionHintsContentWidget, this.editor, true, this.position, model.selectedInlineCompletionIndex, model.inlineCompletionsCount, model.activeCommands));
                editor.addContentWidget(contentWidget);
                store.add((0, _lifecycleJs.toDisposable)(()=>editor.removeContentWidget(contentWidget)));
                store.add((0, _observableJs.autorun)((reader)=>{
                    /** @description request explicit */ const position = this.position.read(reader);
                    if (!position) return;
                    if (model.lastTriggerKind.read(reader) !== (0, _languagesJs.InlineCompletionTriggerKind).Explicit) model.triggerExplicitly();
                }));
                return contentWidget;
            });
            const hadPosition = (0, _observableJs.derivedObservableWithCache)(this, (reader, lastValue)=>!!this.position.read(reader) || !!lastValue);
            store.add((0, _observableJs.autorun)((reader)=>{
                if (hadPosition.read(reader)) contentWidgetValue.read(reader);
            }));
        }));
    }
};
InlineCompletionsHintsWidget = __decorate([
    __param(2, (0, _instantiationJs.IInstantiationService))
], InlineCompletionsHintsWidget);
const inlineSuggestionHintsNextIcon = (0, _iconRegistryJs.registerIcon)("inline-suggestion-hints-next", (0, _codiconsJs.Codicon).chevronRight, (0, _nlsJs.localize)("parameterHintsNextIcon", "Icon for show next parameter hint."));
const inlineSuggestionHintsPreviousIcon = (0, _iconRegistryJs.registerIcon)("inline-suggestion-hints-previous", (0, _codiconsJs.Codicon).chevronLeft, (0, _nlsJs.localize)("parameterHintsPreviousIcon", "Icon for show previous parameter hint."));
let InlineSuggestionHintsContentWidget = class InlineSuggestionHintsContentWidget extends (0, _lifecycleJs.Disposable) {
    static{
        InlineSuggestionHintsContentWidget_1 = this;
    }
    static{
        this._dropDownVisible = false;
    }
    static get dropDownVisible() {
        return this._dropDownVisible;
    }
    static{
        this.id = 0;
    }
    createCommandAction(commandId, label, iconClassName) {
        const action = new (0, _actionsJs.Action)(commandId, label, iconClassName, true, ()=>this._commandService.executeCommand(commandId));
        const kb = this.keybindingService.lookupKeybinding(commandId, this._contextKeyService);
        let tooltip = label;
        if (kb) tooltip = (0, _nlsJs.localize)({
            key: "content",
            comment: [
                "A label",
                "A keybinding"
            ]
        }, "{0} ({1})", label, kb.getLabel());
        action.tooltip = tooltip;
        return action;
    }
    constructor(editor, withBorder, _position, _currentSuggestionIdx, _suggestionCount, _extraCommands, _commandService, instantiationService, keybindingService, _contextKeyService, _menuService){
        super();
        this.editor = editor;
        this.withBorder = withBorder;
        this._position = _position;
        this._currentSuggestionIdx = _currentSuggestionIdx;
        this._suggestionCount = _suggestionCount;
        this._extraCommands = _extraCommands;
        this._commandService = _commandService;
        this.keybindingService = keybindingService;
        this._contextKeyService = _contextKeyService;
        this._menuService = _menuService;
        this.id = `InlineSuggestionHintsContentWidget${InlineSuggestionHintsContentWidget_1.id++}`;
        this.allowEditorOverflow = true;
        this.suppressMouseDown = false;
        this.nodes = (0, _domJs.h)("div.inlineSuggestionsHints", {
            className: this.withBorder ? ".withBorder" : ""
        }, [
            (0, _domJs.h)("div@toolBar")
        ]);
        this.previousAction = this.createCommandAction((0, _commandIdsJs.showPreviousInlineSuggestionActionId), (0, _nlsJs.localize)("previous", "Previous"), (0, _themablesJs.ThemeIcon).asClassName(inlineSuggestionHintsPreviousIcon));
        this.availableSuggestionCountAction = new (0, _actionsJs.Action)("inlineSuggestionHints.availableSuggestionCount", "", undefined, false);
        this.nextAction = this.createCommandAction((0, _commandIdsJs.showNextInlineSuggestionActionId), (0, _nlsJs.localize)("next", "Next"), (0, _themablesJs.ThemeIcon).asClassName(inlineSuggestionHintsNextIcon));
        // TODO@hediet: deprecate MenuId.InlineCompletionsActions
        this.inlineCompletionsActionsMenus = this._register(this._menuService.createMenu((0, _actionsJs1.MenuId).InlineCompletionsActions, this._contextKeyService));
        this.clearAvailableSuggestionCountLabelDebounced = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>{
            this.availableSuggestionCountAction.label = "";
        }, 100));
        this.disableButtonsDebounced = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>{
            this.previousAction.enabled = this.nextAction.enabled = false;
        }, 100));
        this.toolBar = this._register(instantiationService.createInstance(CustomizedMenuWorkbenchToolBar, this.nodes.toolBar, (0, _actionsJs1.MenuId).InlineSuggestionToolbar, {
            menuOptions: {
                renderShortTitle: true
            },
            toolbarOptions: {
                primaryGroup: (g)=>g.startsWith("primary")
            },
            actionViewItemProvider: (action, options)=>{
                if (action instanceof (0, _actionsJs1.MenuItemAction)) return instantiationService.createInstance(StatusBarViewItem, action, undefined);
                if (action === this.availableSuggestionCountAction) {
                    const a = new ActionViewItemWithClassName(undefined, action, {
                        label: true,
                        icon: false
                    });
                    a.setClass("availableSuggestionCount");
                    return a;
                }
                return undefined;
            },
            telemetrySource: "InlineSuggestionToolbar"
        }));
        this.toolBar.setPrependedPrimaryActions([
            this.previousAction,
            this.availableSuggestionCountAction,
            this.nextAction
        ]);
        this._register(this.toolBar.onDidChangeDropdownVisibility((e)=>{
            InlineSuggestionHintsContentWidget_1._dropDownVisible = e;
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update position */ this._position.read(reader);
            this.editor.layoutContentWidget(this);
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description counts */ const suggestionCount = this._suggestionCount.read(reader);
            const currentSuggestionIdx = this._currentSuggestionIdx.read(reader);
            if (suggestionCount !== undefined) {
                this.clearAvailableSuggestionCountLabelDebounced.cancel();
                this.availableSuggestionCountAction.label = `${currentSuggestionIdx + 1}/${suggestionCount}`;
            } else this.clearAvailableSuggestionCountLabelDebounced.schedule();
            if (suggestionCount !== undefined && suggestionCount > 1) {
                this.disableButtonsDebounced.cancel();
                this.previousAction.enabled = this.nextAction.enabled = true;
            } else this.disableButtonsDebounced.schedule();
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description extra commands */ const extraCommands = this._extraCommands.read(reader);
            const extraActions = extraCommands.map((c)=>({
                    class: undefined,
                    id: c.id,
                    enabled: true,
                    tooltip: c.tooltip || "",
                    label: c.title,
                    run: (event)=>{
                        return this._commandService.executeCommand(c.id);
                    }
                }));
            for (const [_, group] of this.inlineCompletionsActionsMenus.getActions()){
                for (const action of group)if (action instanceof (0, _actionsJs1.MenuItemAction)) extraActions.push(action);
            }
            if (extraActions.length > 0) extraActions.unshift(new (0, _actionsJs.Separator)());
            this.toolBar.setAdditionalSecondaryActions(extraActions);
        }));
    }
    getId() {
        return this.id;
    }
    getDomNode() {
        return this.nodes.root;
    }
    getPosition() {
        return {
            position: this._position.get(),
            preference: [
                1 /* ContentWidgetPositionPreference.ABOVE */ ,
                2 /* ContentWidgetPositionPreference.BELOW */ 
            ],
            positionAffinity: 3 /* PositionAffinity.LeftOfInjectedText */ 
        };
    }
};
InlineSuggestionHintsContentWidget = InlineSuggestionHintsContentWidget_1 = __decorate([
    __param(6, (0, _commandsJs.ICommandService)),
    __param(7, (0, _instantiationJs.IInstantiationService)),
    __param(8, (0, _keybindingJs.IKeybindingService)),
    __param(9, (0, _contextkeyJs.IContextKeyService)),
    __param(10, (0, _actionsJs1.IMenuService))
], InlineSuggestionHintsContentWidget);
class ActionViewItemWithClassName extends (0, _actionViewItemsJs.ActionViewItem) {
    constructor(){
        super(...arguments);
        this._className = undefined;
    }
    setClass(className) {
        this._className = className;
    }
    render(container) {
        super.render(container);
        if (this._className) container.classList.add(this._className);
    }
    updateTooltip() {
    // NOOP, disable tooltip
    }
}
class StatusBarViewItem extends (0, _menuEntryActionViewItemJs.MenuEntryActionViewItem) {
    updateLabel() {
        const kb = this._keybindingService.lookupKeybinding(this._action.id, this._contextKeyService);
        if (!kb) return super.updateLabel();
        if (this.label) {
            const div = (0, _domJs.h)("div.keybinding").root;
            const k = this._register(new (0, _keybindingLabelJs.KeybindingLabel)(div, (0, _platformJs.OS), {
                disableTitle: true,
                ...(0, _keybindingLabelJs.unthemedKeybindingLabelOptions)
            }));
            k.set(kb);
            this.label.textContent = this._action.label;
            this.label.appendChild(div);
            this.label.classList.add("inlineSuggestionStatusBarItemLabel");
        }
    }
    updateTooltip() {
    // NOOP, disable tooltip
    }
}
let CustomizedMenuWorkbenchToolBar = class CustomizedMenuWorkbenchToolBar extends (0, _toolbarJs.WorkbenchToolBar) {
    constructor(container, menuId, options2, menuService, contextKeyService, contextMenuService, keybindingService, commandService, telemetryService){
        super(container, {
            resetMenu: menuId,
            ...options2
        }, menuService, contextKeyService, contextMenuService, keybindingService, commandService, telemetryService);
        this.menuId = menuId;
        this.options2 = options2;
        this.menuService = menuService;
        this.contextKeyService = contextKeyService;
        this.menu = this._store.add(this.menuService.createMenu(this.menuId, this.contextKeyService, {
            emitEventsForSubmenuChanges: true
        }));
        this.additionalActions = [];
        this.prependedPrimaryActions = [];
        this._store.add(this.menu.onDidChange(()=>this.updateToolbar()));
        this.updateToolbar();
    }
    updateToolbar() {
        const primary = [];
        const secondary = [];
        (0, _menuEntryActionViewItemJs.createAndFillInActionBarActions)(this.menu, this.options2?.menuOptions, {
            primary,
            secondary
        }, this.options2?.toolbarOptions?.primaryGroup, this.options2?.toolbarOptions?.shouldInlineSubmenu, this.options2?.toolbarOptions?.useSeparatorsInPrimaryActions);
        secondary.push(...this.additionalActions);
        primary.unshift(...this.prependedPrimaryActions);
        this.setActions(primary, secondary);
    }
    setPrependedPrimaryActions(actions) {
        if ((0, _arraysJs.equals)(this.prependedPrimaryActions, actions, (a, b)=>a === b)) return;
        this.prependedPrimaryActions = actions;
        this.updateToolbar();
    }
    setAdditionalSecondaryActions(actions) {
        if ((0, _arraysJs.equals)(this.additionalActions, actions, (a, b)=>a === b)) return;
        this.additionalActions = actions;
        this.updateToolbar();
    }
};
CustomizedMenuWorkbenchToolBar = __decorate([
    __param(3, (0, _actionsJs1.IMenuService)),
    __param(4, (0, _contextkeyJs.IContextKeyService)),
    __param(5, (0, _contextViewJs.IContextMenuService)),
    __param(6, (0, _keybindingJs.IKeybindingService)),
    __param(7, (0, _commandsJs.ICommandService)),
    __param(8, (0, _telemetryJs.ITelemetryService))
], CustomizedMenuWorkbenchToolBar);

},{"../../../../../base/browser/dom.js":"bnqsM","../../../../../base/browser/ui/actionbar/actionViewItems.js":"6Yy9b","../../../../../base/browser/ui/keybindingLabel/keybindingLabel.js":"hpphu","../../../../../base/common/actions.js":"5GjLb","../../../../../base/common/arrays.js":"DECei","../../../../../base/common/async.js":"4GJc4","../../../../../base/common/codicons.js":"hWYNf","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../../base/common/observableInternal/derived.js":"hZb5S","../../../../../base/common/platform.js":"7maJO","../../../../../base/common/themables.js":"hgyHi","./inlineCompletionsHintsWidget.css":"2W6IU","../../../../common/core/position.js":"lvrPe","../../../../common/languages.js":"g5n96","../controller/commandIds.js":"5ZG0b","../../../../../nls.js":"l617d","../../../../../platform/actions/browser/menuEntryActionViewItem.js":"evssn","../../../../../platform/actions/browser/toolbar.js":"1ep75","../../../../../platform/actions/common/actions.js":"kyMtp","../../../../../platform/commands/common/commands.js":"ho6ic","../../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../../platform/contextview/browser/contextView.js":"2QlUR","../../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../../platform/telemetry/common/telemetry.js":"7vW8j","../../../../../platform/theme/common/iconRegistry.js":"bRNEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2W6IU":[function() {},{}],"5ZG0b":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inlineSuggestCommitId", ()=>inlineSuggestCommitId);
parcelHelpers.export(exports, "showPreviousInlineSuggestionActionId", ()=>showPreviousInlineSuggestionActionId);
parcelHelpers.export(exports, "showNextInlineSuggestionActionId", ()=>showNextInlineSuggestionActionId);
const inlineSuggestCommitId = "editor.action.inlineSuggest.commit";
const showPreviousInlineSuggestionActionId = "editor.action.inlineSuggest.showPrevious";
const showNextInlineSuggestionActionId = "editor.action.inlineSuggest.showNext";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iINMK":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMousePositionWithinElement", ()=>isMousePositionWithinElement);
var _domJs = require("../../../../base/browser/dom.js");
function isMousePositionWithinElement(element, posx, posy) {
    const elementRect = _domJs.getDomNodePagePosition(element);
    if (posx < elementRect.left || posx > elementRect.left + elementRect.width || posy < elementRect.top || posy > elementRect.top + elementRect.height) return false;
    return true;
}

},{"../../../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6UNsA":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContentHoverWidgetWrapper", ()=>ContentHoverWidgetWrapper);
var _domJs = require("../../../../base/browser/dom.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _languagesJs = require("../../../common/languages.js");
var _hoverOperationJs = require("./hoverOperation.js");
var _hoverTypesJs = require("./hoverTypes.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _contentHoverWidgetJs = require("./contentHoverWidget.js");
var _contentHoverComputerJs = require("./contentHoverComputer.js");
var _contentHoverTypesJs = require("./contentHoverTypes.js");
var _eventJs = require("../../../../base/common/event.js");
var _contentHoverRenderedJs = require("./contentHoverRendered.js");
var _hoverUtilsJs = require("./hoverUtils.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let ContentHoverWidgetWrapper = class ContentHoverWidgetWrapper extends (0, _lifecycleJs.Disposable) {
    constructor(_editor, _instantiationService, _keybindingService){
        super();
        this._editor = _editor;
        this._instantiationService = _instantiationService;
        this._keybindingService = _keybindingService;
        this._currentResult = null;
        this._onContentsChanged = this._register(new (0, _eventJs.Emitter)());
        this.onContentsChanged = this._onContentsChanged.event;
        this._contentHoverWidget = this._register(this._instantiationService.createInstance((0, _contentHoverWidgetJs.ContentHoverWidget), this._editor));
        this._participants = this._initializeHoverParticipants();
        this._computer = new (0, _contentHoverComputerJs.ContentHoverComputer)(this._editor, this._participants);
        this._hoverOperation = this._register(new (0, _hoverOperationJs.HoverOperation)(this._editor, this._computer));
        this._registerListeners();
    }
    _initializeHoverParticipants() {
        const participants = [];
        for (const participant of (0, _hoverTypesJs.HoverParticipantRegistry).getAll()){
            const participantInstance = this._instantiationService.createInstance(participant, this._editor);
            participants.push(participantInstance);
        }
        participants.sort((p1, p2)=>p1.hoverOrdinal - p2.hoverOrdinal);
        this._register(this._contentHoverWidget.onDidResize(()=>{
            this._participants.forEach((participant)=>participant.handleResize?.());
        }));
        return participants;
    }
    _registerListeners() {
        this._register(this._hoverOperation.onResult((result)=>{
            if (!this._computer.anchor) // invalid state, ignore result
            return;
            const messages = result.hasLoadingMessage ? this._addLoadingMessage(result.value) : result.value;
            this._withResult(new (0, _contentHoverTypesJs.HoverResult)(this._computer.anchor, messages, result.isComplete));
        }));
        const contentHoverWidgetNode = this._contentHoverWidget.getDomNode();
        this._register(_domJs.addStandardDisposableListener(contentHoverWidgetNode, "keydown", (e)=>{
            if (e.equals(9 /* KeyCode.Escape */ )) this.hide();
        }));
        this._register(_domJs.addStandardDisposableListener(contentHoverWidgetNode, "mouseleave", (e)=>{
            this._onMouseLeave(e);
        }));
        this._register((0, _languagesJs.TokenizationRegistry).onDidChange(()=>{
            if (this._contentHoverWidget.position && this._currentResult) this._setCurrentResult(this._currentResult); // render again
        }));
    }
    /**
     * Returns true if the hover shows now or will show.
     */ _startShowingOrUpdateHover(anchor, mode, source, focus, mouseEvent) {
        const contentHoverIsVisible = this._contentHoverWidget.position && this._currentResult;
        if (!contentHoverIsVisible) {
            if (anchor) {
                this._startHoverOperationIfNecessary(anchor, mode, source, focus, false);
                return true;
            }
            return false;
        }
        const isHoverSticky = this._editor.getOption(60 /* EditorOption.hover */ ).sticky;
        const isMouseGettingCloser = mouseEvent && this._contentHoverWidget.isMouseGettingCloser(mouseEvent.event.posx, mouseEvent.event.posy);
        const isHoverStickyAndIsMouseGettingCloser = isHoverSticky && isMouseGettingCloser;
        // The mouse is getting closer to the hover, so we will keep the hover untouched
        // But we will kick off a hover update at the new anchor, insisting on keeping the hover visible.
        if (isHoverStickyAndIsMouseGettingCloser) {
            if (anchor) this._startHoverOperationIfNecessary(anchor, mode, source, focus, true);
            return true;
        }
        // If mouse is not getting closer and anchor not defined, hide the hover
        if (!anchor) {
            this._setCurrentResult(null);
            return false;
        }
        // If mouse if not getting closer and anchor is defined, and the new anchor is the same as the previous anchor
        const currentAnchorEqualsPreviousAnchor = this._currentResult.anchor.equals(anchor);
        if (currentAnchorEqualsPreviousAnchor) return true;
        // If mouse if not getting closer and anchor is defined, and the new anchor is not compatible with the previous anchor
        const currentAnchorCompatibleWithPreviousAnchor = anchor.canAdoptVisibleHover(this._currentResult.anchor, this._contentHoverWidget.position);
        if (!currentAnchorCompatibleWithPreviousAnchor) {
            this._setCurrentResult(null);
            this._startHoverOperationIfNecessary(anchor, mode, source, focus, false);
            return true;
        }
        // We aren't getting any closer to the hover, so we will filter existing results
        // and keep those which also apply to the new anchor.
        this._setCurrentResult(this._currentResult.filter(anchor));
        this._startHoverOperationIfNecessary(anchor, mode, source, focus, false);
        return true;
    }
    _startHoverOperationIfNecessary(anchor, mode, source, focus, insistOnKeepingHoverVisible) {
        const currentAnchorEqualToPreviousHover = this._computer.anchor && this._computer.anchor.equals(anchor);
        if (currentAnchorEqualToPreviousHover) return;
        this._hoverOperation.cancel();
        this._computer.anchor = anchor;
        this._computer.shouldFocus = focus;
        this._computer.source = source;
        this._computer.insistOnKeepingHoverVisible = insistOnKeepingHoverVisible;
        this._hoverOperation.start(mode);
    }
    _setCurrentResult(hoverResult) {
        let currentHoverResult = hoverResult;
        const currentResultEqualToPreviousResult = this._currentResult === currentHoverResult;
        if (currentResultEqualToPreviousResult) return;
        const currentHoverResultIsEmpty = currentHoverResult && currentHoverResult.hoverParts.length === 0;
        if (currentHoverResultIsEmpty) currentHoverResult = null;
        this._currentResult = currentHoverResult;
        if (this._currentResult) this._showHover(this._currentResult);
        else this._hideHover();
    }
    _addLoadingMessage(result) {
        if (!this._computer.anchor) return result;
        for (const participant of this._participants){
            if (!participant.createLoadingMessage) continue;
            const loadingMessage = participant.createLoadingMessage(this._computer.anchor);
            if (!loadingMessage) continue;
            return result.slice(0).concat([
                loadingMessage
            ]);
        }
        return result;
    }
    _withResult(hoverResult) {
        const previousHoverIsVisibleWithCompleteResult = this._contentHoverWidget.position && this._currentResult && this._currentResult.isComplete;
        if (!previousHoverIsVisibleWithCompleteResult) this._setCurrentResult(hoverResult);
        // The hover is visible with a previous complete result.
        const isCurrentHoverResultComplete = hoverResult.isComplete;
        if (!isCurrentHoverResultComplete) // Instead of rendering the new partial result, we wait for the result to be complete.
        return;
        const currentHoverResultIsEmpty = hoverResult.hoverParts.length === 0;
        const insistOnKeepingPreviousHoverVisible = this._computer.insistOnKeepingHoverVisible;
        const shouldKeepPreviousHoverVisible = currentHoverResultIsEmpty && insistOnKeepingPreviousHoverVisible;
        if (shouldKeepPreviousHoverVisible) // The hover would now hide normally, so we'll keep the previous messages
        return;
        this._setCurrentResult(hoverResult);
    }
    _showHover(hoverResult) {
        const context = this._getHoverContext();
        this._renderedContentHover = new (0, _contentHoverRenderedJs.RenderedContentHover)(this._editor, hoverResult, this._participants, this._computer, context, this._keybindingService);
        if (this._renderedContentHover.domNodeHasChildren) this._contentHoverWidget.show(this._renderedContentHover);
        else this._renderedContentHover.dispose();
    }
    _hideHover() {
        this._contentHoverWidget.hide();
    }
    _getHoverContext() {
        const hide = ()=>{
            this.hide();
        };
        const onContentsChanged = ()=>{
            this._onContentsChanged.fire();
            this._contentHoverWidget.onContentsChanged();
        };
        const setMinimumDimensions = (dimensions)=>{
            this._contentHoverWidget.setMinimumDimensions(dimensions);
        };
        return {
            hide,
            onContentsChanged,
            setMinimumDimensions
        };
    }
    showsOrWillShow(mouseEvent) {
        const isContentWidgetResizing = this._contentHoverWidget.isResizing;
        if (isContentWidgetResizing) return true;
        const anchorCandidates = this._findHoverAnchorCandidates(mouseEvent);
        const anchorCandidatesExist = anchorCandidates.length > 0;
        if (!anchorCandidatesExist) return this._startShowingOrUpdateHover(null, 0 /* HoverStartMode.Delayed */ , 0 /* HoverStartSource.Mouse */ , false, mouseEvent);
        const anchor = anchorCandidates[0];
        return this._startShowingOrUpdateHover(anchor, 0 /* HoverStartMode.Delayed */ , 0 /* HoverStartSource.Mouse */ , false, mouseEvent);
    }
    _findHoverAnchorCandidates(mouseEvent) {
        const anchorCandidates = [];
        for (const participant of this._participants){
            if (!participant.suggestHoverAnchor) continue;
            const anchor = participant.suggestHoverAnchor(mouseEvent);
            if (!anchor) continue;
            anchorCandidates.push(anchor);
        }
        const target = mouseEvent.target;
        switch(target.type){
            case 6 /* MouseTargetType.CONTENT_TEXT */ :
                anchorCandidates.push(new (0, _hoverTypesJs.HoverRangeAnchor)(0, target.range, mouseEvent.event.posx, mouseEvent.event.posy));
                break;
            case 7 /* MouseTargetType.CONTENT_EMPTY */ :
                {
                    const epsilon = this._editor.getOption(50 /* EditorOption.fontInfo */ ).typicalHalfwidthCharacterWidth / 2;
                    // Let hover kick in even when the mouse is technically in the empty area after a line, given the distance is small enough
                    const mouseIsWithinLinesAndCloseToHover = !target.detail.isAfterLines && typeof target.detail.horizontalDistanceToText === "number" && target.detail.horizontalDistanceToText < epsilon;
                    if (!mouseIsWithinLinesAndCloseToHover) break;
                    anchorCandidates.push(new (0, _hoverTypesJs.HoverRangeAnchor)(0, target.range, mouseEvent.event.posx, mouseEvent.event.posy));
                    break;
                }
        }
        anchorCandidates.sort((a, b)=>b.priority - a.priority);
        return anchorCandidates;
    }
    _onMouseLeave(e) {
        const editorDomNode = this._editor.getDomNode();
        const isMousePositionOutsideOfEditor = !editorDomNode || !(0, _hoverUtilsJs.isMousePositionWithinElement)(editorDomNode, e.x, e.y);
        if (isMousePositionOutsideOfEditor) this.hide();
    }
    startShowingAtRange(range, mode, source, focus) {
        this._startShowingOrUpdateHover(new (0, _hoverTypesJs.HoverRangeAnchor)(0, range, undefined, undefined), mode, source, focus, null);
    }
    async updateHoverVerbosityLevel(action, index, focus) {
        this._renderedContentHover?.updateHoverVerbosityLevel(action, index, focus);
    }
    focusedHoverPartIndex() {
        return this._renderedContentHover?.focusedHoverPartIndex ?? -1;
    }
    containsNode(node) {
        return node ? this._contentHoverWidget.getDomNode().contains(node) : false;
    }
    focus() {
        this._contentHoverWidget.focus();
    }
    scrollUp() {
        this._contentHoverWidget.scrollUp();
    }
    scrollDown() {
        this._contentHoverWidget.scrollDown();
    }
    scrollLeft() {
        this._contentHoverWidget.scrollLeft();
    }
    scrollRight() {
        this._contentHoverWidget.scrollRight();
    }
    pageUp() {
        this._contentHoverWidget.pageUp();
    }
    pageDown() {
        this._contentHoverWidget.pageDown();
    }
    goToTop() {
        this._contentHoverWidget.goToTop();
    }
    goToBottom() {
        this._contentHoverWidget.goToBottom();
    }
    hide() {
        this._computer.anchor = null;
        this._hoverOperation.cancel();
        this._setCurrentResult(null);
    }
    getDomNode() {
        return this._contentHoverWidget.getDomNode();
    }
    get isColorPickerVisible() {
        return this._renderedContentHover?.isColorPickerVisible() ?? false;
    }
    get isVisibleFromKeyboard() {
        return this._contentHoverWidget.isVisibleFromKeyboard;
    }
    get isVisible() {
        return this._contentHoverWidget.isVisible;
    }
    get isFocused() {
        return this._contentHoverWidget.isFocused;
    }
    get isResizing() {
        return this._contentHoverWidget.isResizing;
    }
    get widget() {
        return this._contentHoverWidget;
    }
};
ContentHoverWidgetWrapper = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService)),
    __param(2, (0, _keybindingJs.IKeybindingService))
], ContentHoverWidgetWrapper);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/lifecycle.js":"9kg8d","../../../common/languages.js":"g5n96","./hoverOperation.js":"a6SJn","./hoverTypes.js":"6vmRi","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/keybinding/common/keybinding.js":"25pLT","./contentHoverWidget.js":"7Q1bB","./contentHoverComputer.js":"bYZCV","./contentHoverTypes.js":"jH4w5","../../../../base/common/event.js":"4Zi8b","./contentHoverRendered.js":"kUoPl","./hoverUtils.js":"iINMK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a6SJn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverResult", ()=>HoverResult);
/**
 * Computing the hover is very fine tuned.
 *
 * Suppose the hover delay is 300ms (the default). Then, when resting the mouse at an anchor:
 * - at 150ms, the async computation is triggered (i.e. semantic hover)
 *   - if async results already come in, they are not rendered yet.
 * - at 300ms, the sync computation is triggered (i.e. decorations, markers)
 *   - if there are sync or async results, they are rendered.
 * - at 900ms, if the async computation hasn't finished, a "Loading..." result is added.
 */ parcelHelpers.export(exports, "HoverOperation", ()=>HoverOperation);
var _asyncJs = require("../../../../base/common/async.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
class HoverResult {
    constructor(value, isComplete, hasLoadingMessage){
        this.value = value;
        this.isComplete = isComplete;
        this.hasLoadingMessage = hasLoadingMessage;
    }
}
class HoverOperation extends (0, _lifecycleJs.Disposable) {
    constructor(_editor, _computer){
        super();
        this._editor = _editor;
        this._computer = _computer;
        this._onResult = this._register(new (0, _eventJs.Emitter)());
        this.onResult = this._onResult.event;
        this._firstWaitScheduler = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._triggerAsyncComputation(), 0));
        this._secondWaitScheduler = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._triggerSyncComputation(), 0));
        this._loadingMessageScheduler = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._triggerLoadingMessage(), 0));
        this._state = 0 /* HoverOperationState.Idle */ ;
        this._asyncIterable = null;
        this._asyncIterableDone = false;
        this._result = [];
    }
    dispose() {
        if (this._asyncIterable) {
            this._asyncIterable.cancel();
            this._asyncIterable = null;
        }
        super.dispose();
    }
    get _hoverTime() {
        return this._editor.getOption(60 /* EditorOption.hover */ ).delay;
    }
    get _firstWaitTime() {
        return this._hoverTime / 2;
    }
    get _secondWaitTime() {
        return this._hoverTime - this._firstWaitTime;
    }
    get _loadingMessageTime() {
        return 3 * this._hoverTime;
    }
    _setState(state, fireResult = true) {
        this._state = state;
        if (fireResult) this._fireResult();
    }
    _triggerAsyncComputation() {
        this._setState(2 /* HoverOperationState.SecondWait */ );
        this._secondWaitScheduler.schedule(this._secondWaitTime);
        if (this._computer.computeAsync) {
            this._asyncIterableDone = false;
            this._asyncIterable = (0, _asyncJs.createCancelableAsyncIterable)((token)=>this._computer.computeAsync(token));
            (async ()=>{
                try {
                    for await (const item of this._asyncIterable)if (item) {
                        this._result.push(item);
                        this._fireResult();
                    }
                    this._asyncIterableDone = true;
                    if (this._state === 3 /* HoverOperationState.WaitingForAsync */  || this._state === 4 /* HoverOperationState.WaitingForAsyncShowingLoading */ ) this._setState(0 /* HoverOperationState.Idle */ );
                } catch (e) {
                    (0, _errorsJs.onUnexpectedError)(e);
                }
            })();
        } else this._asyncIterableDone = true;
    }
    _triggerSyncComputation() {
        if (this._computer.computeSync) this._result = this._result.concat(this._computer.computeSync());
        this._setState(this._asyncIterableDone ? 0 /* HoverOperationState.Idle */  : 3 /* HoverOperationState.WaitingForAsync */ );
    }
    _triggerLoadingMessage() {
        if (this._state === 3 /* HoverOperationState.WaitingForAsync */ ) this._setState(4 /* HoverOperationState.WaitingForAsyncShowingLoading */ );
    }
    _fireResult() {
        if (this._state === 1 /* HoverOperationState.FirstWait */  || this._state === 2 /* HoverOperationState.SecondWait */ ) // Do not send out results before the hover time
        return;
        const isComplete = this._state === 0 /* HoverOperationState.Idle */ ;
        const hasLoadingMessage = this._state === 4 /* HoverOperationState.WaitingForAsyncShowingLoading */ ;
        this._onResult.fire(new HoverResult(this._result.slice(0), isComplete, hasLoadingMessage));
    }
    start(mode) {
        if (mode === 0 /* HoverStartMode.Delayed */ ) {
            if (this._state === 0 /* HoverOperationState.Idle */ ) {
                this._setState(1 /* HoverOperationState.FirstWait */ );
                this._firstWaitScheduler.schedule(this._firstWaitTime);
                this._loadingMessageScheduler.schedule(this._loadingMessageTime);
            }
        } else switch(this._state){
            case 0 /* HoverOperationState.Idle */ :
                this._triggerAsyncComputation();
                this._secondWaitScheduler.cancel();
                this._triggerSyncComputation();
                break;
            case 2 /* HoverOperationState.SecondWait */ :
                this._secondWaitScheduler.cancel();
                this._triggerSyncComputation();
                break;
        }
    }
    cancel() {
        this._firstWaitScheduler.cancel();
        this._secondWaitScheduler.cancel();
        this._loadingMessageScheduler.cancel();
        if (this._asyncIterable) {
            this._asyncIterable.cancel();
            this._asyncIterable = null;
        }
        this._result = [];
        this._setState(0 /* HoverOperationState.Idle */ , false);
    }
}

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/errors.js":"divX8","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Q1bB":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContentHoverWidget", ()=>ContentHoverWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _resizableContentWidgetJs = require("./resizableContentWidget.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _accessibilityJs = require("../../../../platform/accessibility/common/accessibility.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _hoverWidgetJs = require("../../../../base/browser/ui/hover/hoverWidget.js");
var _eventJs = require("../../../../base/common/event.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var ContentHoverWidget_1;
const HORIZONTAL_SCROLLING_BY = 30;
const CONTAINER_HEIGHT_PADDING = 6;
let ContentHoverWidget = class ContentHoverWidget extends (0, _resizableContentWidgetJs.ResizableContentWidget) {
    static{
        ContentHoverWidget_1 = this;
    }
    static{
        this.ID = "editor.contrib.resizableContentHoverWidget";
    }
    static{
        this._lastDimensions = new _domJs.Dimension(0, 0);
    }
    get isVisibleFromKeyboard() {
        return this._renderedHover?.source === 1 /* HoverStartSource.Keyboard */ ;
    }
    get isVisible() {
        return this._hoverVisibleKey.get() ?? false;
    }
    get isFocused() {
        return this._hoverFocusedKey.get() ?? false;
    }
    constructor(editor, contextKeyService, _configurationService, _accessibilityService, _keybindingService){
        const minimumHeight = editor.getOption(67 /* EditorOption.lineHeight */ ) + 8;
        const minimumWidth = 150;
        const minimumSize = new _domJs.Dimension(minimumWidth, minimumHeight);
        super(editor, minimumSize);
        this._configurationService = _configurationService;
        this._accessibilityService = _accessibilityService;
        this._keybindingService = _keybindingService;
        this._hover = this._register(new (0, _hoverWidgetJs.HoverWidget)());
        this._onDidResize = this._register(new (0, _eventJs.Emitter)());
        this.onDidResize = this._onDidResize.event;
        this._minimumSize = minimumSize;
        this._hoverVisibleKey = (0, _editorContextKeysJs.EditorContextKeys).hoverVisible.bindTo(contextKeyService);
        this._hoverFocusedKey = (0, _editorContextKeysJs.EditorContextKeys).hoverFocused.bindTo(contextKeyService);
        _domJs.append(this._resizableNode.domNode, this._hover.containerDomNode);
        this._resizableNode.domNode.style.zIndex = "50";
        this._register(this._editor.onDidLayoutChange(()=>{
            if (this.isVisible) this._updateMaxDimensions();
        }));
        this._register(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(50 /* EditorOption.fontInfo */ )) this._updateFont();
        }));
        const focusTracker = this._register(_domJs.trackFocus(this._resizableNode.domNode));
        this._register(focusTracker.onDidFocus(()=>{
            this._hoverFocusedKey.set(true);
        }));
        this._register(focusTracker.onDidBlur(()=>{
            this._hoverFocusedKey.set(false);
        }));
        this._setRenderedHover(undefined);
        this._editor.addContentWidget(this);
    }
    dispose() {
        super.dispose();
        this._renderedHover?.dispose();
        this._editor.removeContentWidget(this);
    }
    getId() {
        return ContentHoverWidget_1.ID;
    }
    static _applyDimensions(container, width, height) {
        const transformedWidth = typeof width === "number" ? `${width}px` : width;
        const transformedHeight = typeof height === "number" ? `${height}px` : height;
        container.style.width = transformedWidth;
        container.style.height = transformedHeight;
    }
    _setContentsDomNodeDimensions(width, height) {
        const contentsDomNode = this._hover.contentsDomNode;
        return ContentHoverWidget_1._applyDimensions(contentsDomNode, width, height);
    }
    _setContainerDomNodeDimensions(width, height) {
        const containerDomNode = this._hover.containerDomNode;
        return ContentHoverWidget_1._applyDimensions(containerDomNode, width, height);
    }
    _setHoverWidgetDimensions(width, height) {
        this._setContentsDomNodeDimensions(width, height);
        this._setContainerDomNodeDimensions(width, height);
        this._layoutContentWidget();
    }
    static _applyMaxDimensions(container, width, height) {
        const transformedWidth = typeof width === "number" ? `${width}px` : width;
        const transformedHeight = typeof height === "number" ? `${height}px` : height;
        container.style.maxWidth = transformedWidth;
        container.style.maxHeight = transformedHeight;
    }
    _setHoverWidgetMaxDimensions(width, height) {
        ContentHoverWidget_1._applyMaxDimensions(this._hover.contentsDomNode, width, height);
        ContentHoverWidget_1._applyMaxDimensions(this._hover.containerDomNode, width, height);
        this._hover.containerDomNode.style.setProperty("--vscode-hover-maxWidth", typeof width === "number" ? `${width}px` : width);
        this._layoutContentWidget();
    }
    _setAdjustedHoverWidgetDimensions(size) {
        this._setHoverWidgetMaxDimensions("none", "none");
        const width = size.width;
        const height = size.height;
        this._setHoverWidgetDimensions(width, height);
    }
    _updateResizableNodeMaxDimensions() {
        const maxRenderingWidth = this._findMaximumRenderingWidth() ?? Infinity;
        const maxRenderingHeight = this._findMaximumRenderingHeight() ?? Infinity;
        this._resizableNode.maxSize = new _domJs.Dimension(maxRenderingWidth, maxRenderingHeight);
        this._setHoverWidgetMaxDimensions(maxRenderingWidth, maxRenderingHeight);
    }
    _resize(size) {
        ContentHoverWidget_1._lastDimensions = new _domJs.Dimension(size.width, size.height);
        this._setAdjustedHoverWidgetDimensions(size);
        this._resizableNode.layout(size.height, size.width);
        this._updateResizableNodeMaxDimensions();
        this._hover.scrollbar.scanDomNode();
        this._editor.layoutContentWidget(this);
        this._onDidResize.fire();
    }
    _findAvailableSpaceVertically() {
        const position = this._renderedHover?.showAtPosition;
        if (!position) return;
        return this._positionPreference === 1 /* ContentWidgetPositionPreference.ABOVE */  ? this._availableVerticalSpaceAbove(position) : this._availableVerticalSpaceBelow(position);
    }
    _findMaximumRenderingHeight() {
        const availableSpace = this._findAvailableSpaceVertically();
        if (!availableSpace) return;
        // Padding needed in order to stop the resizing down to a smaller height
        let maximumHeight = CONTAINER_HEIGHT_PADDING;
        Array.from(this._hover.contentsDomNode.children).forEach((hoverPart)=>{
            maximumHeight += hoverPart.clientHeight;
        });
        return Math.min(availableSpace, maximumHeight);
    }
    _isHoverTextOverflowing() {
        // To find out if the text is overflowing, we will disable wrapping, check the widths, and then re-enable wrapping
        this._hover.containerDomNode.style.setProperty("--vscode-hover-whiteSpace", "nowrap");
        this._hover.containerDomNode.style.setProperty("--vscode-hover-sourceWhiteSpace", "nowrap");
        const overflowing = Array.from(this._hover.contentsDomNode.children).some((hoverElement)=>{
            return hoverElement.scrollWidth > hoverElement.clientWidth;
        });
        this._hover.containerDomNode.style.removeProperty("--vscode-hover-whiteSpace");
        this._hover.containerDomNode.style.removeProperty("--vscode-hover-sourceWhiteSpace");
        return overflowing;
    }
    _findMaximumRenderingWidth() {
        if (!this._editor || !this._editor.hasModel()) return;
        const overflowing = this._isHoverTextOverflowing();
        const initialWidth = typeof this._contentWidth === "undefined" ? 0 : this._contentWidth - 2 // - 2 for the borders
        ;
        if (overflowing || this._hover.containerDomNode.clientWidth < initialWidth) {
            const bodyBoxWidth = _domJs.getClientArea(this._hover.containerDomNode.ownerDocument.body).width;
            const horizontalPadding = 14;
            return bodyBoxWidth - horizontalPadding;
        } else return this._hover.containerDomNode.clientWidth + 2;
    }
    isMouseGettingCloser(posx, posy) {
        if (!this._renderedHover) return false;
        if (this._renderedHover.initialMousePosX === undefined || this._renderedHover.initialMousePosY === undefined) {
            this._renderedHover.initialMousePosX = posx;
            this._renderedHover.initialMousePosY = posy;
            return false;
        }
        const widgetRect = _domJs.getDomNodePagePosition(this.getDomNode());
        if (this._renderedHover.closestMouseDistance === undefined) this._renderedHover.closestMouseDistance = computeDistanceFromPointToRectangle(this._renderedHover.initialMousePosX, this._renderedHover.initialMousePosY, widgetRect.left, widgetRect.top, widgetRect.width, widgetRect.height);
        const distance = computeDistanceFromPointToRectangle(posx, posy, widgetRect.left, widgetRect.top, widgetRect.width, widgetRect.height);
        if (distance > this._renderedHover.closestMouseDistance + 4 /* tolerance of 4 pixels */ ) // The mouse is getting farther away
        return false;
        this._renderedHover.closestMouseDistance = Math.min(this._renderedHover.closestMouseDistance, distance);
        return true;
    }
    _setRenderedHover(renderedHover) {
        this._renderedHover?.dispose();
        this._renderedHover = renderedHover;
        this._hoverVisibleKey.set(!!renderedHover);
        this._hover.containerDomNode.classList.toggle("hidden", !renderedHover);
    }
    _updateFont() {
        const { fontSize, lineHeight } = this._editor.getOption(50 /* EditorOption.fontInfo */ );
        const contentsDomNode = this._hover.contentsDomNode;
        contentsDomNode.style.fontSize = `${fontSize}px`;
        contentsDomNode.style.lineHeight = `${lineHeight / fontSize}`;
        const codeClasses = Array.prototype.slice.call(this._hover.contentsDomNode.getElementsByClassName("code"));
        codeClasses.forEach((node)=>this._editor.applyFontInfo(node));
    }
    _updateContent(node) {
        const contentsDomNode = this._hover.contentsDomNode;
        contentsDomNode.style.paddingBottom = "";
        contentsDomNode.textContent = "";
        contentsDomNode.appendChild(node);
    }
    _layoutContentWidget() {
        this._editor.layoutContentWidget(this);
        this._hover.onContentsChanged();
    }
    _updateMaxDimensions() {
        const height = Math.max(this._editor.getLayoutInfo().height / 4, 250, ContentHoverWidget_1._lastDimensions.height);
        const width = Math.max(this._editor.getLayoutInfo().width * 0.66, 500, ContentHoverWidget_1._lastDimensions.width);
        this._setHoverWidgetMaxDimensions(width, height);
    }
    _render(renderedHover) {
        this._setRenderedHover(renderedHover);
        this._updateFont();
        this._updateContent(renderedHover.domNode);
        this._updateMaxDimensions();
        this.onContentsChanged();
        // Simply force a synchronous render on the editor
        // such that the widget does not really render with left = '0px'
        this._editor.render();
    }
    getPosition() {
        if (!this._renderedHover) return null;
        return {
            position: this._renderedHover.showAtPosition,
            secondaryPosition: this._renderedHover.showAtSecondaryPosition,
            positionAffinity: this._renderedHover.shouldAppearBeforeContent ? 3 /* PositionAffinity.LeftOfInjectedText */  : undefined,
            preference: [
                this._positionPreference ?? 1 /* ContentWidgetPositionPreference.ABOVE */ 
            ]
        };
    }
    show(renderedHover) {
        if (!this._editor || !this._editor.hasModel()) return;
        this._render(renderedHover);
        const widgetHeight = _domJs.getTotalHeight(this._hover.containerDomNode);
        const widgetPosition = renderedHover.showAtPosition;
        this._positionPreference = this._findPositionPreference(widgetHeight, widgetPosition) ?? 1 /* ContentWidgetPositionPreference.ABOVE */ ;
        // See https://github.com/microsoft/vscode/issues/140339
        // TODO: Doing a second layout of the hover after force rendering the editor
        this.onContentsChanged();
        if (renderedHover.shouldFocus) this._hover.containerDomNode.focus();
        this._onDidResize.fire();
        // The aria label overrides the label, so if we add to it, add the contents of the hover
        const hoverFocused = this._hover.containerDomNode.ownerDocument.activeElement === this._hover.containerDomNode;
        const accessibleViewHint = hoverFocused && (0, _hoverWidgetJs.getHoverAccessibleViewHint)(this._configurationService.getValue("accessibility.verbosity.hover") === true && this._accessibilityService.isScreenReaderOptimized(), this._keybindingService.lookupKeybinding("editor.action.accessibleView")?.getAriaLabel() ?? "");
        if (accessibleViewHint) this._hover.contentsDomNode.ariaLabel = this._hover.contentsDomNode.textContent + ", " + accessibleViewHint;
    }
    hide() {
        if (!this._renderedHover) return;
        const hoverStoleFocus = this._renderedHover.shouldFocus || this._hoverFocusedKey.get();
        this._setRenderedHover(undefined);
        this._resizableNode.maxSize = new _domJs.Dimension(Infinity, Infinity);
        this._resizableNode.clearSashHoverState();
        this._hoverFocusedKey.set(false);
        this._editor.layoutContentWidget(this);
        if (hoverStoleFocus) this._editor.focus();
    }
    _removeConstraintsRenderNormally() {
        // Added because otherwise the initial size of the hover content is smaller than should be
        const layoutInfo = this._editor.getLayoutInfo();
        this._resizableNode.layout(layoutInfo.height, layoutInfo.width);
        this._setHoverWidgetDimensions("auto", "auto");
    }
    setMinimumDimensions(dimensions) {
        // We combine the new minimum dimensions with the previous ones
        this._minimumSize = new _domJs.Dimension(Math.max(this._minimumSize.width, dimensions.width), Math.max(this._minimumSize.height, dimensions.height));
        this._updateMinimumWidth();
    }
    _updateMinimumWidth() {
        const width = typeof this._contentWidth === "undefined" ? this._minimumSize.width : Math.min(this._contentWidth, this._minimumSize.width);
        // We want to avoid that the hover is artificially large, so we use the content width as minimum width
        this._resizableNode.minSize = new _domJs.Dimension(width, this._minimumSize.height);
    }
    onContentsChanged() {
        this._removeConstraintsRenderNormally();
        const containerDomNode = this._hover.containerDomNode;
        let height = _domJs.getTotalHeight(containerDomNode);
        let width = _domJs.getTotalWidth(containerDomNode);
        this._resizableNode.layout(height, width);
        this._setHoverWidgetDimensions(width, height);
        height = _domJs.getTotalHeight(containerDomNode);
        width = _domJs.getTotalWidth(containerDomNode);
        this._contentWidth = width;
        this._updateMinimumWidth();
        this._resizableNode.layout(height, width);
        if (this._renderedHover?.showAtPosition) {
            const widgetHeight = _domJs.getTotalHeight(this._hover.containerDomNode);
            this._positionPreference = this._findPositionPreference(widgetHeight, this._renderedHover.showAtPosition);
        }
        this._layoutContentWidget();
    }
    focus() {
        this._hover.containerDomNode.focus();
    }
    scrollUp() {
        const scrollTop = this._hover.scrollbar.getScrollPosition().scrollTop;
        const fontInfo = this._editor.getOption(50 /* EditorOption.fontInfo */ );
        this._hover.scrollbar.setScrollPosition({
            scrollTop: scrollTop - fontInfo.lineHeight
        });
    }
    scrollDown() {
        const scrollTop = this._hover.scrollbar.getScrollPosition().scrollTop;
        const fontInfo = this._editor.getOption(50 /* EditorOption.fontInfo */ );
        this._hover.scrollbar.setScrollPosition({
            scrollTop: scrollTop + fontInfo.lineHeight
        });
    }
    scrollLeft() {
        const scrollLeft = this._hover.scrollbar.getScrollPosition().scrollLeft;
        this._hover.scrollbar.setScrollPosition({
            scrollLeft: scrollLeft - HORIZONTAL_SCROLLING_BY
        });
    }
    scrollRight() {
        const scrollLeft = this._hover.scrollbar.getScrollPosition().scrollLeft;
        this._hover.scrollbar.setScrollPosition({
            scrollLeft: scrollLeft + HORIZONTAL_SCROLLING_BY
        });
    }
    pageUp() {
        const scrollTop = this._hover.scrollbar.getScrollPosition().scrollTop;
        const scrollHeight = this._hover.scrollbar.getScrollDimensions().height;
        this._hover.scrollbar.setScrollPosition({
            scrollTop: scrollTop - scrollHeight
        });
    }
    pageDown() {
        const scrollTop = this._hover.scrollbar.getScrollPosition().scrollTop;
        const scrollHeight = this._hover.scrollbar.getScrollDimensions().height;
        this._hover.scrollbar.setScrollPosition({
            scrollTop: scrollTop + scrollHeight
        });
    }
    goToTop() {
        this._hover.scrollbar.setScrollPosition({
            scrollTop: 0
        });
    }
    goToBottom() {
        this._hover.scrollbar.setScrollPosition({
            scrollTop: this._hover.scrollbar.getScrollDimensions().scrollHeight
        });
    }
};
ContentHoverWidget = ContentHoverWidget_1 = __decorate([
    __param(1, (0, _contextkeyJs.IContextKeyService)),
    __param(2, (0, _configurationJs.IConfigurationService)),
    __param(3, (0, _accessibilityJs.IAccessibilityService)),
    __param(4, (0, _keybindingJs.IKeybindingService))
], ContentHoverWidget);
function computeDistanceFromPointToRectangle(pointX, pointY, left, top, width, height) {
    const x = left + width / 2; // x center of rectangle
    const y = top + height / 2; // y center of rectangle
    const dx = Math.max(Math.abs(pointX - x) - width / 2, 0);
    const dy = Math.max(Math.abs(pointY - y) - height / 2, 0);
    return Math.sqrt(dx * dx + dy * dy);
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../platform/keybinding/common/keybinding.js":"25pLT","./resizableContentWidget.js":"jZ0OE","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/accessibility/common/accessibility.js":"9Svqy","../../../common/editorContextKeys.js":"5exv9","../../../../base/browser/ui/hover/hoverWidget.js":"5eWDy","../../../../base/common/event.js":"4Zi8b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jZ0OE":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizableContentWidget", ()=>ResizableContentWidget);
var _resizableJs = require("../../../../base/browser/ui/resizable/resizable.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _positionJs = require("../../../common/core/position.js");
var _domJs = require("../../../../base/browser/dom.js");
const TOP_HEIGHT = 30;
const BOTTOM_HEIGHT = 24;
class ResizableContentWidget extends (0, _lifecycleJs.Disposable) {
    constructor(_editor, minimumSize = new _domJs.Dimension(10, 10)){
        super();
        this._editor = _editor;
        this.allowEditorOverflow = true;
        this.suppressMouseDown = false;
        this._resizableNode = this._register(new (0, _resizableJs.ResizableHTMLElement)());
        this._contentPosition = null;
        this._isResizing = false;
        this._resizableNode.domNode.style.position = "absolute";
        this._resizableNode.minSize = _domJs.Dimension.lift(minimumSize);
        this._resizableNode.layout(minimumSize.height, minimumSize.width);
        this._resizableNode.enableSashes(true, true, true, true);
        this._register(this._resizableNode.onDidResize((e)=>{
            this._resize(new _domJs.Dimension(e.dimension.width, e.dimension.height));
            if (e.done) this._isResizing = false;
        }));
        this._register(this._resizableNode.onDidWillResize(()=>{
            this._isResizing = true;
        }));
    }
    get isResizing() {
        return this._isResizing;
    }
    getDomNode() {
        return this._resizableNode.domNode;
    }
    getPosition() {
        return this._contentPosition;
    }
    get position() {
        return this._contentPosition?.position ? (0, _positionJs.Position).lift(this._contentPosition.position) : undefined;
    }
    _availableVerticalSpaceAbove(position) {
        const editorDomNode = this._editor.getDomNode();
        const mouseBox = this._editor.getScrolledVisiblePosition(position);
        if (!editorDomNode || !mouseBox) return;
        const editorBox = _domJs.getDomNodePagePosition(editorDomNode);
        return editorBox.top + mouseBox.top - TOP_HEIGHT;
    }
    _availableVerticalSpaceBelow(position) {
        const editorDomNode = this._editor.getDomNode();
        const mouseBox = this._editor.getScrolledVisiblePosition(position);
        if (!editorDomNode || !mouseBox) return;
        const editorBox = _domJs.getDomNodePagePosition(editorDomNode);
        const bodyBox = _domJs.getClientArea(editorDomNode.ownerDocument.body);
        const mouseBottom = editorBox.top + mouseBox.top + mouseBox.height;
        return bodyBox.height - mouseBottom - BOTTOM_HEIGHT;
    }
    _findPositionPreference(widgetHeight, showAtPosition) {
        const maxHeightBelow = Math.min(this._availableVerticalSpaceBelow(showAtPosition) ?? Infinity, widgetHeight);
        const maxHeightAbove = Math.min(this._availableVerticalSpaceAbove(showAtPosition) ?? Infinity, widgetHeight);
        const maxHeight = Math.min(Math.max(maxHeightAbove, maxHeightBelow), widgetHeight);
        const height = Math.min(widgetHeight, maxHeight);
        let renderingAbove;
        if (this._editor.getOption(60 /* EditorOption.hover */ ).above) renderingAbove = height <= maxHeightAbove ? 1 /* ContentWidgetPositionPreference.ABOVE */  : 2 /* ContentWidgetPositionPreference.BELOW */ ;
        else renderingAbove = height <= maxHeightBelow ? 2 /* ContentWidgetPositionPreference.BELOW */  : 1 /* ContentWidgetPositionPreference.ABOVE */ ;
        if (renderingAbove === 1 /* ContentWidgetPositionPreference.ABOVE */ ) this._resizableNode.enableSashes(true, true, false, false);
        else this._resizableNode.enableSashes(false, true, true, false);
        return renderingAbove;
    }
    _resize(dimension) {
        this._resizableNode.layout(dimension.height, dimension.width);
    }
}

},{"../../../../base/browser/ui/resizable/resizable.js":"c8k7j","../../../../base/common/lifecycle.js":"9kg8d","../../../common/core/position.js":"lvrPe","../../../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c8k7j":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizableHTMLElement", ()=>ResizableHTMLElement);
var _domJs = require("../../dom.js");
var _sashJs = require("../sash/sash.js");
var _eventJs = require("../../../common/event.js");
var _lifecycleJs = require("../../../common/lifecycle.js");
class ResizableHTMLElement {
    constructor(){
        this._onDidWillResize = new (0, _eventJs.Emitter)();
        this.onDidWillResize = this._onDidWillResize.event;
        this._onDidResize = new (0, _eventJs.Emitter)();
        this.onDidResize = this._onDidResize.event;
        this._sashListener = new (0, _lifecycleJs.DisposableStore)();
        this._size = new (0, _domJs.Dimension)(0, 0);
        this._minSize = new (0, _domJs.Dimension)(0, 0);
        this._maxSize = new (0, _domJs.Dimension)(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
        this.domNode = document.createElement("div");
        this._eastSash = new (0, _sashJs.Sash)(this.domNode, {
            getVerticalSashLeft: ()=>this._size.width
        }, {
            orientation: 0 /* Orientation.VERTICAL */ 
        });
        this._westSash = new (0, _sashJs.Sash)(this.domNode, {
            getVerticalSashLeft: ()=>0
        }, {
            orientation: 0 /* Orientation.VERTICAL */ 
        });
        this._northSash = new (0, _sashJs.Sash)(this.domNode, {
            getHorizontalSashTop: ()=>0
        }, {
            orientation: 1 /* Orientation.HORIZONTAL */ ,
            orthogonalEdge: (0, _sashJs.OrthogonalEdge).North
        });
        this._southSash = new (0, _sashJs.Sash)(this.domNode, {
            getHorizontalSashTop: ()=>this._size.height
        }, {
            orientation: 1 /* Orientation.HORIZONTAL */ ,
            orthogonalEdge: (0, _sashJs.OrthogonalEdge).South
        });
        this._northSash.orthogonalStartSash = this._westSash;
        this._northSash.orthogonalEndSash = this._eastSash;
        this._southSash.orthogonalStartSash = this._westSash;
        this._southSash.orthogonalEndSash = this._eastSash;
        let currentSize;
        let deltaY = 0;
        let deltaX = 0;
        this._sashListener.add((0, _eventJs.Event).any(this._northSash.onDidStart, this._eastSash.onDidStart, this._southSash.onDidStart, this._westSash.onDidStart)(()=>{
            if (currentSize === undefined) {
                this._onDidWillResize.fire();
                currentSize = this._size;
                deltaY = 0;
                deltaX = 0;
            }
        }));
        this._sashListener.add((0, _eventJs.Event).any(this._northSash.onDidEnd, this._eastSash.onDidEnd, this._southSash.onDidEnd, this._westSash.onDidEnd)(()=>{
            if (currentSize !== undefined) {
                currentSize = undefined;
                deltaY = 0;
                deltaX = 0;
                this._onDidResize.fire({
                    dimension: this._size,
                    done: true
                });
            }
        }));
        this._sashListener.add(this._eastSash.onDidChange((e)=>{
            if (currentSize) {
                deltaX = e.currentX - e.startX;
                this.layout(currentSize.height + deltaY, currentSize.width + deltaX);
                this._onDidResize.fire({
                    dimension: this._size,
                    done: false,
                    east: true
                });
            }
        }));
        this._sashListener.add(this._westSash.onDidChange((e)=>{
            if (currentSize) {
                deltaX = -(e.currentX - e.startX);
                this.layout(currentSize.height + deltaY, currentSize.width + deltaX);
                this._onDidResize.fire({
                    dimension: this._size,
                    done: false,
                    west: true
                });
            }
        }));
        this._sashListener.add(this._northSash.onDidChange((e)=>{
            if (currentSize) {
                deltaY = -(e.currentY - e.startY);
                this.layout(currentSize.height + deltaY, currentSize.width + deltaX);
                this._onDidResize.fire({
                    dimension: this._size,
                    done: false,
                    north: true
                });
            }
        }));
        this._sashListener.add(this._southSash.onDidChange((e)=>{
            if (currentSize) {
                deltaY = e.currentY - e.startY;
                this.layout(currentSize.height + deltaY, currentSize.width + deltaX);
                this._onDidResize.fire({
                    dimension: this._size,
                    done: false,
                    south: true
                });
            }
        }));
        this._sashListener.add((0, _eventJs.Event).any(this._eastSash.onDidReset, this._westSash.onDidReset)((e)=>{
            if (this._preferredSize) {
                this.layout(this._size.height, this._preferredSize.width);
                this._onDidResize.fire({
                    dimension: this._size,
                    done: true
                });
            }
        }));
        this._sashListener.add((0, _eventJs.Event).any(this._northSash.onDidReset, this._southSash.onDidReset)((e)=>{
            if (this._preferredSize) {
                this.layout(this._preferredSize.height, this._size.width);
                this._onDidResize.fire({
                    dimension: this._size,
                    done: true
                });
            }
        }));
    }
    dispose() {
        this._northSash.dispose();
        this._southSash.dispose();
        this._eastSash.dispose();
        this._westSash.dispose();
        this._sashListener.dispose();
        this._onDidResize.dispose();
        this._onDidWillResize.dispose();
        this.domNode.remove();
    }
    enableSashes(north, east, south, west) {
        this._northSash.state = north ? 3 /* SashState.Enabled */  : 0 /* SashState.Disabled */ ;
        this._eastSash.state = east ? 3 /* SashState.Enabled */  : 0 /* SashState.Disabled */ ;
        this._southSash.state = south ? 3 /* SashState.Enabled */  : 0 /* SashState.Disabled */ ;
        this._westSash.state = west ? 3 /* SashState.Enabled */  : 0 /* SashState.Disabled */ ;
    }
    layout(height = this.size.height, width = this.size.width) {
        const { height: minHeight, width: minWidth } = this._minSize;
        const { height: maxHeight, width: maxWidth } = this._maxSize;
        height = Math.max(minHeight, Math.min(maxHeight, height));
        width = Math.max(minWidth, Math.min(maxWidth, width));
        const newSize = new (0, _domJs.Dimension)(width, height);
        if (!(0, _domJs.Dimension).equals(newSize, this._size)) {
            this.domNode.style.height = height + "px";
            this.domNode.style.width = width + "px";
            this._size = newSize;
            this._northSash.layout();
            this._eastSash.layout();
            this._southSash.layout();
            this._westSash.layout();
        }
    }
    clearSashHoverState() {
        this._eastSash.clearSashHoverState();
        this._westSash.clearSashHoverState();
        this._northSash.clearSashHoverState();
        this._southSash.clearSashHoverState();
    }
    get size() {
        return this._size;
    }
    set maxSize(value) {
        this._maxSize = value;
    }
    get maxSize() {
        return this._maxSize;
    }
    set minSize(value) {
        this._minSize = value;
    }
    get minSize() {
        return this._minSize;
    }
    set preferredSize(value) {
        this._preferredSize = value;
    }
    get preferredSize() {
        return this._preferredSize;
    }
}

},{"../../dom.js":"bnqsM","../sash/sash.js":"2Pk4d","../../../common/event.js":"4Zi8b","../../../common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bYZCV":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContentHoverComputer", ()=>ContentHoverComputer);
var _arraysJs = require("../../../../base/common/arrays.js");
var _asyncJs = require("../../../../base/common/async.js");
class ContentHoverComputer {
    get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        this._anchor = value;
    }
    get shouldFocus() {
        return this._shouldFocus;
    }
    set shouldFocus(value) {
        this._shouldFocus = value;
    }
    get source() {
        return this._source;
    }
    set source(value) {
        this._source = value;
    }
    get insistOnKeepingHoverVisible() {
        return this._insistOnKeepingHoverVisible;
    }
    set insistOnKeepingHoverVisible(value) {
        this._insistOnKeepingHoverVisible = value;
    }
    constructor(_editor, _participants){
        this._editor = _editor;
        this._participants = _participants;
        this._anchor = null;
        this._shouldFocus = false;
        this._source = 0 /* HoverStartSource.Mouse */ ;
        this._insistOnKeepingHoverVisible = false;
    }
    static _getLineDecorations(editor, anchor) {
        if (anchor.type !== 1 /* HoverAnchorType.Range */  && !anchor.supportsMarkerHover) return [];
        const model = editor.getModel();
        const lineNumber = anchor.range.startLineNumber;
        if (lineNumber > model.getLineCount()) // invalid line
        return [];
        const maxColumn = model.getLineMaxColumn(lineNumber);
        return editor.getLineDecorations(lineNumber).filter((d)=>{
            if (d.options.isWholeLine) return true;
            const startColumn = d.range.startLineNumber === lineNumber ? d.range.startColumn : 1;
            const endColumn = d.range.endLineNumber === lineNumber ? d.range.endColumn : maxColumn;
            if (d.options.showIfCollapsed) {
                // Relax check around `showIfCollapsed` decorations to also include +/- 1 character
                if (startColumn > anchor.range.startColumn + 1 || anchor.range.endColumn - 1 > endColumn) return false;
            } else {
                if (startColumn > anchor.range.startColumn || anchor.range.endColumn > endColumn) return false;
            }
            return true;
        });
    }
    computeAsync(token) {
        const anchor = this._anchor;
        if (!this._editor.hasModel() || !anchor) return (0, _asyncJs.AsyncIterableObject).EMPTY;
        const lineDecorations = ContentHoverComputer._getLineDecorations(this._editor, anchor);
        return (0, _asyncJs.AsyncIterableObject).merge(this._participants.map((participant)=>{
            if (!participant.computeAsync) return (0, _asyncJs.AsyncIterableObject).EMPTY;
            return participant.computeAsync(anchor, lineDecorations, token);
        }));
    }
    computeSync() {
        if (!this._editor.hasModel() || !this._anchor) return [];
        const lineDecorations = ContentHoverComputer._getLineDecorations(this._editor, this._anchor);
        let result = [];
        for (const participant of this._participants)result = result.concat(participant.computeSync(this._anchor, lineDecorations));
        return (0, _arraysJs.coalesce)(result);
    }
}

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/async.js":"4GJc4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jH4w5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverResult", ()=>HoverResult);
parcelHelpers.export(exports, "FilteredHoverResult", ()=>FilteredHoverResult);
class HoverResult {
    constructor(anchor, hoverParts, isComplete){
        this.anchor = anchor;
        this.hoverParts = hoverParts;
        this.isComplete = isComplete;
    }
    filter(anchor) {
        const filteredHoverParts = this.hoverParts.filter((m)=>m.isValidForHoverAnchor(anchor));
        if (filteredHoverParts.length === this.hoverParts.length) return this;
        return new FilteredHoverResult(this, this.anchor, filteredHoverParts, this.isComplete);
    }
}
class FilteredHoverResult extends HoverResult {
    constructor(original, anchor, messages, isComplete){
        super(anchor, messages, isComplete);
        this.original = original;
    }
    filter(anchor) {
        return this.original.filter(anchor);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kUoPl":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RenderedContentHover", ()=>RenderedContentHover);
var _hoverTypesJs = require("./hoverTypes.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _contentHoverStatusBarJs = require("./contentHoverStatusBar.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _domJs = require("../../../../base/browser/dom.js");
var _markdownHoverParticipantJs = require("./markdownHoverParticipant.js");
var _colorHoverParticipantJs = require("../../colorPicker/browser/colorHoverParticipant.js");
var _inlayHintsHoverJs = require("../../inlayHints/browser/inlayHintsHover.js");
var _errorsJs = require("../../../../base/common/errors.js");
class RenderedContentHover extends (0, _lifecycleJs.Disposable) {
    constructor(editor, hoverResult, participants, computer, context, keybindingService){
        super();
        const anchor = hoverResult.anchor;
        const parts = hoverResult.hoverParts;
        this._renderedHoverParts = this._register(new RenderedContentHoverParts(editor, participants, parts, keybindingService, context));
        const { showAtPosition, showAtSecondaryPosition } = RenderedContentHover.computeHoverPositions(editor, anchor.range, parts);
        this.shouldAppearBeforeContent = parts.some((m)=>m.isBeforeContent);
        this.showAtPosition = showAtPosition;
        this.showAtSecondaryPosition = showAtSecondaryPosition;
        this.initialMousePosX = anchor.initialMousePosX;
        this.initialMousePosY = anchor.initialMousePosY;
        this.shouldFocus = computer.shouldFocus;
        this.source = computer.source;
    }
    get domNode() {
        return this._renderedHoverParts.domNode;
    }
    get domNodeHasChildren() {
        return this._renderedHoverParts.domNodeHasChildren;
    }
    get focusedHoverPartIndex() {
        return this._renderedHoverParts.focusedHoverPartIndex;
    }
    async updateHoverVerbosityLevel(action, index, focus) {
        this._renderedHoverParts.updateHoverVerbosityLevel(action, index, focus);
    }
    isColorPickerVisible() {
        return this._renderedHoverParts.isColorPickerVisible();
    }
    static computeHoverPositions(editor, anchorRange, hoverParts) {
        let startColumnBoundary = 1;
        if (editor.hasModel()) {
            // Ensure the range is on the current view line
            const viewModel = editor._getViewModel();
            const coordinatesConverter = viewModel.coordinatesConverter;
            const anchorViewRange = coordinatesConverter.convertModelRangeToViewRange(anchorRange);
            const anchorViewMinColumn = viewModel.getLineMinColumn(anchorViewRange.startLineNumber);
            const anchorViewRangeStart = new (0, _positionJs.Position)(anchorViewRange.startLineNumber, anchorViewMinColumn);
            startColumnBoundary = coordinatesConverter.convertViewPositionToModelPosition(anchorViewRangeStart).column;
        }
        // The anchor range is always on a single line
        const anchorStartLineNumber = anchorRange.startLineNumber;
        let secondaryPositionColumn = anchorRange.startColumn;
        let forceShowAtRange;
        for (const hoverPart of hoverParts){
            const hoverPartRange = hoverPart.range;
            const hoverPartRangeOnAnchorStartLine = hoverPartRange.startLineNumber === anchorStartLineNumber;
            const hoverPartRangeOnAnchorEndLine = hoverPartRange.endLineNumber === anchorStartLineNumber;
            const hoverPartRangeIsOnAnchorLine = hoverPartRangeOnAnchorStartLine && hoverPartRangeOnAnchorEndLine;
            if (hoverPartRangeIsOnAnchorLine) {
                // this message has a range that is completely sitting on the line of the anchor
                const hoverPartStartColumn = hoverPartRange.startColumn;
                const minSecondaryPositionColumn = Math.min(secondaryPositionColumn, hoverPartStartColumn);
                secondaryPositionColumn = Math.max(minSecondaryPositionColumn, startColumnBoundary);
            }
            if (hoverPart.forceShowAtRange) forceShowAtRange = hoverPartRange;
        }
        let showAtPosition;
        let showAtSecondaryPosition;
        if (forceShowAtRange) {
            const forceShowAtPosition = forceShowAtRange.getStartPosition();
            showAtPosition = forceShowAtPosition;
            showAtSecondaryPosition = forceShowAtPosition;
        } else {
            showAtPosition = anchorRange.getStartPosition();
            showAtSecondaryPosition = new (0, _positionJs.Position)(anchorStartLineNumber, secondaryPositionColumn);
        }
        return {
            showAtPosition,
            showAtSecondaryPosition
        };
    }
}
class RenderedStatusBar {
    constructor(fragment, _statusBar){
        this._statusBar = _statusBar;
        fragment.appendChild(this._statusBar.hoverElement);
    }
    get hoverElement() {
        return this._statusBar.hoverElement;
    }
    get actions() {
        return this._statusBar.actions;
    }
    dispose() {
        this._statusBar.dispose();
    }
}
class RenderedContentHoverParts extends (0, _lifecycleJs.Disposable) {
    static{
        this._DECORATION_OPTIONS = (0, _textModelJs.ModelDecorationOptions).register({
            description: "content-hover-highlight",
            className: "hoverHighlight"
        });
    }
    constructor(editor, participants, hoverParts, keybindingService, context){
        super();
        this._renderedParts = [];
        this._focusedHoverPartIndex = -1;
        this._context = context;
        this._fragment = document.createDocumentFragment();
        this._register(this._renderParts(participants, hoverParts, context, keybindingService));
        this._register(this._registerListenersOnRenderedParts());
        this._register(this._createEditorDecorations(editor, hoverParts));
        this._updateMarkdownAndColorParticipantInfo(participants);
    }
    _createEditorDecorations(editor, hoverParts) {
        if (hoverParts.length === 0) return (0, _lifecycleJs.Disposable).None;
        let highlightRange = hoverParts[0].range;
        for (const hoverPart of hoverParts){
            const hoverPartRange = hoverPart.range;
            highlightRange = (0, _rangeJs.Range).plusRange(highlightRange, hoverPartRange);
        }
        const highlightDecoration = editor.createDecorationsCollection();
        highlightDecoration.set([
            {
                range: highlightRange,
                options: RenderedContentHoverParts._DECORATION_OPTIONS
            }
        ]);
        return (0, _lifecycleJs.toDisposable)(()=>{
            highlightDecoration.clear();
        });
    }
    _renderParts(participants, hoverParts, hoverContext, keybindingService) {
        const statusBar = new (0, _contentHoverStatusBarJs.EditorHoverStatusBar)(keybindingService);
        const hoverRenderingContext = {
            fragment: this._fragment,
            statusBar,
            ...hoverContext
        };
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        for (const participant of participants){
            const renderedHoverParts = this._renderHoverPartsForParticipant(hoverParts, participant, hoverRenderingContext);
            disposables.add(renderedHoverParts);
            for (const renderedHoverPart of renderedHoverParts.renderedHoverParts)this._renderedParts.push({
                type: "hoverPart",
                participant,
                hoverPart: renderedHoverPart.hoverPart,
                hoverElement: renderedHoverPart.hoverElement
            });
        }
        const renderedStatusBar = this._renderStatusBar(this._fragment, statusBar);
        if (renderedStatusBar) {
            disposables.add(renderedStatusBar);
            this._renderedParts.push({
                type: "statusBar",
                hoverElement: renderedStatusBar.hoverElement,
                actions: renderedStatusBar.actions
            });
        }
        return (0, _lifecycleJs.toDisposable)(()=>{
            disposables.dispose();
        });
    }
    _renderHoverPartsForParticipant(hoverParts, participant, hoverRenderingContext) {
        const hoverPartsForParticipant = hoverParts.filter((hoverPart)=>hoverPart.owner === participant);
        const hasHoverPartsForParticipant = hoverPartsForParticipant.length > 0;
        if (!hasHoverPartsForParticipant) return new (0, _hoverTypesJs.RenderedHoverParts)([]);
        return participant.renderHoverParts(hoverRenderingContext, hoverPartsForParticipant);
    }
    _renderStatusBar(fragment, statusBar) {
        if (!statusBar.hasContent) return undefined;
        return new RenderedStatusBar(fragment, statusBar);
    }
    _registerListenersOnRenderedParts() {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        this._renderedParts.forEach((renderedPart, index)=>{
            const element = renderedPart.hoverElement;
            element.tabIndex = 0;
            disposables.add(_domJs.addDisposableListener(element, _domJs.EventType.FOCUS_IN, (event)=>{
                event.stopPropagation();
                this._focusedHoverPartIndex = index;
            }));
            disposables.add(_domJs.addDisposableListener(element, _domJs.EventType.FOCUS_OUT, (event)=>{
                event.stopPropagation();
                this._focusedHoverPartIndex = -1;
            }));
        });
        return disposables;
    }
    _updateMarkdownAndColorParticipantInfo(participants) {
        const markdownHoverParticipant = participants.find((p)=>{
            return p instanceof (0, _markdownHoverParticipantJs.MarkdownHoverParticipant) && !(p instanceof (0, _inlayHintsHoverJs.InlayHintsHover));
        });
        if (markdownHoverParticipant) this._markdownHoverParticipant = markdownHoverParticipant;
        this._colorHoverParticipant = participants.find((p)=>p instanceof (0, _colorHoverParticipantJs.ColorHoverParticipant));
    }
    async updateHoverVerbosityLevel(action, index, focus) {
        if (!this._markdownHoverParticipant) return;
        const normalizedMarkdownHoverIndex = this._normalizedIndexToMarkdownHoverIndexRange(this._markdownHoverParticipant, index);
        if (normalizedMarkdownHoverIndex === undefined) return;
        const renderedPart = await this._markdownHoverParticipant.updateMarkdownHoverVerbosityLevel(action, normalizedMarkdownHoverIndex, focus);
        if (!renderedPart) return;
        this._renderedParts[index] = {
            type: "hoverPart",
            participant: this._markdownHoverParticipant,
            hoverPart: renderedPart.hoverPart,
            hoverElement: renderedPart.hoverElement
        };
        this._context.onContentsChanged();
    }
    isColorPickerVisible() {
        return this._colorHoverParticipant?.isColorPickerVisible() ?? false;
    }
    _normalizedIndexToMarkdownHoverIndexRange(markdownHoverParticipant, index) {
        const renderedPart = this._renderedParts[index];
        if (!renderedPart || renderedPart.type !== "hoverPart") return undefined;
        const isHoverPartMarkdownHover = renderedPart.participant === markdownHoverParticipant;
        if (!isHoverPartMarkdownHover) return undefined;
        const firstIndexOfMarkdownHovers = this._renderedParts.findIndex((renderedPart)=>renderedPart.type === "hoverPart" && renderedPart.participant === markdownHoverParticipant);
        if (firstIndexOfMarkdownHovers === -1) throw new (0, _errorsJs.BugIndicatingError)();
        return index - firstIndexOfMarkdownHovers;
    }
    get domNode() {
        return this._fragment;
    }
    get domNodeHasChildren() {
        return this._fragment.hasChildNodes();
    }
    get focusedHoverPartIndex() {
        return this._focusedHoverPartIndex;
    }
}

},{"./hoverTypes.js":"6vmRi","../../../../base/common/lifecycle.js":"9kg8d","./contentHoverStatusBar.js":"1zx4D","../../../common/model/textModel.js":"9beDe","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../../base/browser/dom.js":"bnqsM","./markdownHoverParticipant.js":"l8mtm","../../colorPicker/browser/colorHoverParticipant.js":"bidr4","../../inlayHints/browser/inlayHintsHover.js":"1SEMh","../../../../base/common/errors.js":"divX8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1zx4D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorHoverStatusBar", ()=>EditorHoverStatusBar);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _domJs = require("../../../../base/browser/dom.js");
var _hoverWidgetJs = require("../../../../base/browser/ui/hover/hoverWidget.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const $ = _domJs.$;
let EditorHoverStatusBar = class EditorHoverStatusBar extends (0, _lifecycleJs.Disposable) {
    get hasContent() {
        return this._hasContent;
    }
    constructor(_keybindingService){
        super();
        this._keybindingService = _keybindingService;
        this.actions = [];
        this._hasContent = false;
        this.hoverElement = $("div.hover-row.status-bar");
        this.hoverElement.tabIndex = 0;
        this.actionsElement = _domJs.append(this.hoverElement, $("div.actions"));
    }
    addAction(actionOptions) {
        const keybinding = this._keybindingService.lookupKeybinding(actionOptions.commandId);
        const keybindingLabel = keybinding ? keybinding.getLabel() : null;
        this._hasContent = true;
        const action = this._register((0, _hoverWidgetJs.HoverAction).render(this.actionsElement, actionOptions, keybindingLabel));
        this.actions.push(action);
        return action;
    }
    append(element) {
        const result = _domJs.append(this.actionsElement, element);
        this._hasContent = true;
        return result;
    }
};
EditorHoverStatusBar = __decorate([
    __param(0, (0, _keybindingJs.IKeybindingService))
], EditorHoverStatusBar);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/hover/hoverWidget.js":"5eWDy","../../../../base/common/lifecycle.js":"9kg8d","../../../../platform/keybinding/common/keybinding.js":"25pLT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l8mtm":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkdownHover", ()=>MarkdownHover);
parcelHelpers.export(exports, "MarkdownHoverParticipant", ()=>MarkdownHoverParticipant);
parcelHelpers.export(exports, "renderMarkdownHovers", ()=>renderMarkdownHovers);
parcelHelpers.export(exports, "labelForHoverVerbosityAction", ()=>labelForHoverVerbosityAction);
var _domJs = require("../../../../base/browser/dom.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _htmlContentJs = require("../../../../base/common/htmlContent.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _markdownRendererJs = require("../../../browser/widget/markdownRenderer/browser/markdownRenderer.js");
var _hoverActionIdsJs = require("./hoverActionIds.js");
var _rangeJs = require("../../../common/core/range.js");
var _languageJs = require("../../../common/languages/language.js");
var _hoverTypesJs = require("./hoverTypes.js");
var _nlsJs = require("../../../../nls.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _openerJs = require("../../../../platform/opener/common/opener.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _languagesJs = require("../../../common/languages.js");
var _iconRegistryJs = require("../../../../platform/theme/common/iconRegistry.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _themablesJs = require("../../../../base/common/themables.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _hoverWidgetJs = require("../../../../base/browser/ui/hover/hoverWidget.js");
var _hoverJs = require("../../../../platform/hover/browser/hover.js");
var _asyncJs = require("../../../../base/common/async.js");
var _getHoverJs = require("./getHover.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const $ = _domJs.$;
const increaseHoverVerbosityIcon = (0, _iconRegistryJs.registerIcon)("hover-increase-verbosity", (0, _codiconsJs.Codicon).add, _nlsJs.localize("increaseHoverVerbosity", "Icon for increaseing hover verbosity."));
const decreaseHoverVerbosityIcon = (0, _iconRegistryJs.registerIcon)("hover-decrease-verbosity", (0, _codiconsJs.Codicon).remove, _nlsJs.localize("decreaseHoverVerbosity", "Icon for decreasing hover verbosity."));
class MarkdownHover {
    constructor(owner, range, contents, isBeforeContent, ordinal, source){
        this.owner = owner;
        this.range = range;
        this.contents = contents;
        this.isBeforeContent = isBeforeContent;
        this.ordinal = ordinal;
        this.source = source;
    }
    isValidForHoverAnchor(anchor) {
        return anchor.type === 1 /* HoverAnchorType.Range */  && this.range.startColumn <= anchor.range.startColumn && this.range.endColumn >= anchor.range.endColumn;
    }
}
class HoverSource {
    constructor(hover, hoverProvider, hoverPosition){
        this.hover = hover;
        this.hoverProvider = hoverProvider;
        this.hoverPosition = hoverPosition;
    }
    supportsVerbosityAction(hoverVerbosityAction) {
        switch(hoverVerbosityAction){
            case (0, _languagesJs.HoverVerbosityAction).Increase:
                return this.hover.canIncreaseVerbosity ?? false;
            case (0, _languagesJs.HoverVerbosityAction).Decrease:
                return this.hover.canDecreaseVerbosity ?? false;
        }
    }
}
let MarkdownHoverParticipant = class MarkdownHoverParticipant {
    constructor(_editor, _languageService, _openerService, _configurationService, _languageFeaturesService, _keybindingService, _hoverService, _commandService){
        this._editor = _editor;
        this._languageService = _languageService;
        this._openerService = _openerService;
        this._configurationService = _configurationService;
        this._languageFeaturesService = _languageFeaturesService;
        this._keybindingService = _keybindingService;
        this._hoverService = _hoverService;
        this._commandService = _commandService;
        this.hoverOrdinal = 3;
    }
    createLoadingMessage(anchor) {
        return new MarkdownHover(this, anchor.range, [
            new (0, _htmlContentJs.MarkdownString)().appendText(_nlsJs.localize("modesContentHover.loading", "Loading..."))
        ], false, 2000);
    }
    computeSync(anchor, lineDecorations) {
        if (!this._editor.hasModel() || anchor.type !== 1 /* HoverAnchorType.Range */ ) return [];
        const model = this._editor.getModel();
        const lineNumber = anchor.range.startLineNumber;
        const maxColumn = model.getLineMaxColumn(lineNumber);
        const result = [];
        let index = 1000;
        const lineLength = model.getLineLength(lineNumber);
        const languageId = model.getLanguageIdAtPosition(anchor.range.startLineNumber, anchor.range.startColumn);
        const stopRenderingLineAfter = this._editor.getOption(118 /* EditorOption.stopRenderingLineAfter */ );
        const maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", {
            overrideIdentifier: languageId
        });
        let stopRenderingMessage = false;
        if (stopRenderingLineAfter >= 0 && lineLength > stopRenderingLineAfter && anchor.range.startColumn >= stopRenderingLineAfter) {
            stopRenderingMessage = true;
            result.push(new MarkdownHover(this, anchor.range, [
                {
                    value: _nlsJs.localize("stopped rendering", "Rendering paused for long line for performance reasons. This can be configured via `editor.stopRenderingLineAfter`.")
                }
            ], false, index++));
        }
        if (!stopRenderingMessage && typeof maxTokenizationLineLength === "number" && lineLength >= maxTokenizationLineLength) result.push(new MarkdownHover(this, anchor.range, [
            {
                value: _nlsJs.localize("too many characters", "Tokenization is skipped for long lines for performance reasons. This can be configured via `editor.maxTokenizationLineLength`.")
            }
        ], false, index++));
        let isBeforeContent = false;
        for (const d of lineDecorations){
            const startColumn = d.range.startLineNumber === lineNumber ? d.range.startColumn : 1;
            const endColumn = d.range.endLineNumber === lineNumber ? d.range.endColumn : maxColumn;
            const hoverMessage = d.options.hoverMessage;
            if (!hoverMessage || (0, _htmlContentJs.isEmptyMarkdownString)(hoverMessage)) continue;
            if (d.options.beforeContentClassName) isBeforeContent = true;
            const range = new (0, _rangeJs.Range)(anchor.range.startLineNumber, startColumn, anchor.range.startLineNumber, endColumn);
            result.push(new MarkdownHover(this, range, (0, _arraysJs.asArray)(hoverMessage), isBeforeContent, index++));
        }
        return result;
    }
    computeAsync(anchor, lineDecorations, token) {
        if (!this._editor.hasModel() || anchor.type !== 1 /* HoverAnchorType.Range */ ) return (0, _asyncJs.AsyncIterableObject).EMPTY;
        const model = this._editor.getModel();
        const hoverProviderRegistry = this._languageFeaturesService.hoverProvider;
        if (!hoverProviderRegistry.has(model)) return (0, _asyncJs.AsyncIterableObject).EMPTY;
        const markdownHovers = this._getMarkdownHovers(hoverProviderRegistry, model, anchor, token);
        return markdownHovers;
    }
    _getMarkdownHovers(hoverProviderRegistry, model, anchor, token) {
        const position = anchor.range.getStartPosition();
        const hoverProviderResults = (0, _getHoverJs.getHoverProviderResultsAsAsyncIterable)(hoverProviderRegistry, model, position, token);
        const markdownHovers = hoverProviderResults.filter((item)=>!(0, _htmlContentJs.isEmptyMarkdownString)(item.hover.contents)).map((item)=>{
            const range = item.hover.range ? (0, _rangeJs.Range).lift(item.hover.range) : anchor.range;
            const hoverSource = new HoverSource(item.hover, item.provider, position);
            return new MarkdownHover(this, range, item.hover.contents, false, item.ordinal, hoverSource);
        });
        return markdownHovers;
    }
    renderHoverParts(context, hoverParts) {
        this._renderedHoverParts = new MarkdownRenderedHoverParts(hoverParts, context.fragment, this, this._editor, this._languageService, this._openerService, this._commandService, this._keybindingService, this._hoverService, this._configurationService, context.onContentsChanged);
        return this._renderedHoverParts;
    }
    updateMarkdownHoverVerbosityLevel(action, index, focus) {
        return Promise.resolve(this._renderedHoverParts?.updateMarkdownHoverPartVerbosityLevel(action, index, focus));
    }
};
MarkdownHoverParticipant = __decorate([
    __param(1, (0, _languageJs.ILanguageService)),
    __param(2, (0, _openerJs.IOpenerService)),
    __param(3, (0, _configurationJs.IConfigurationService)),
    __param(4, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(5, (0, _keybindingJs.IKeybindingService)),
    __param(6, (0, _hoverJs.IHoverService)),
    __param(7, (0, _commandsJs.ICommandService))
], MarkdownHoverParticipant);
class RenderedMarkdownHoverPart {
    constructor(hoverPart, hoverElement, disposables){
        this.hoverPart = hoverPart;
        this.hoverElement = hoverElement;
        this.disposables = disposables;
    }
    dispose() {
        this.disposables.dispose();
    }
}
class MarkdownRenderedHoverParts {
    constructor(hoverParts, hoverPartsContainer, _hoverParticipant, _editor, _languageService, _openerService, _commandService, _keybindingService, _hoverService, _configurationService, _onFinishedRendering){
        this._hoverParticipant = _hoverParticipant;
        this._editor = _editor;
        this._languageService = _languageService;
        this._openerService = _openerService;
        this._commandService = _commandService;
        this._keybindingService = _keybindingService;
        this._hoverService = _hoverService;
        this._configurationService = _configurationService;
        this._onFinishedRendering = _onFinishedRendering;
        this._ongoingHoverOperations = new Map();
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this.renderedHoverParts = this._renderHoverParts(hoverParts, hoverPartsContainer, this._onFinishedRendering);
        this._disposables.add((0, _lifecycleJs.toDisposable)(()=>{
            this.renderedHoverParts.forEach((renderedHoverPart)=>{
                renderedHoverPart.dispose();
            });
            this._ongoingHoverOperations.forEach((operation)=>{
                operation.tokenSource.dispose(true);
            });
        }));
    }
    _renderHoverParts(hoverParts, hoverPartsContainer, onFinishedRendering) {
        hoverParts.sort((0, _arraysJs.compareBy)((hover)=>hover.ordinal, (0, _arraysJs.numberComparator)));
        return hoverParts.map((hoverPart)=>{
            const renderedHoverPart = this._renderHoverPart(hoverPart, onFinishedRendering);
            hoverPartsContainer.appendChild(renderedHoverPart.hoverElement);
            return renderedHoverPart;
        });
    }
    _renderHoverPart(hoverPart, onFinishedRendering) {
        const renderedMarkdownPart = this._renderMarkdownHover(hoverPart, onFinishedRendering);
        const renderedMarkdownElement = renderedMarkdownPart.hoverElement;
        const hoverSource = hoverPart.source;
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        disposables.add(renderedMarkdownPart);
        if (!hoverSource) return new RenderedMarkdownHoverPart(hoverPart, renderedMarkdownElement, disposables);
        const canIncreaseVerbosity = hoverSource.supportsVerbosityAction((0, _languagesJs.HoverVerbosityAction).Increase);
        const canDecreaseVerbosity = hoverSource.supportsVerbosityAction((0, _languagesJs.HoverVerbosityAction).Decrease);
        if (!canIncreaseVerbosity && !canDecreaseVerbosity) return new RenderedMarkdownHoverPart(hoverPart, renderedMarkdownElement, disposables);
        const actionsContainer = $("div.verbosity-actions");
        renderedMarkdownElement.prepend(actionsContainer);
        disposables.add(this._renderHoverExpansionAction(actionsContainer, (0, _languagesJs.HoverVerbosityAction).Increase, canIncreaseVerbosity));
        disposables.add(this._renderHoverExpansionAction(actionsContainer, (0, _languagesJs.HoverVerbosityAction).Decrease, canDecreaseVerbosity));
        return new RenderedMarkdownHoverPart(hoverPart, renderedMarkdownElement, disposables);
    }
    _renderMarkdownHover(markdownHover, onFinishedRendering) {
        const renderedMarkdownHover = renderMarkdownInContainer(this._editor, markdownHover, this._languageService, this._openerService, onFinishedRendering);
        return renderedMarkdownHover;
    }
    _renderHoverExpansionAction(container, action, actionEnabled) {
        const store = new (0, _lifecycleJs.DisposableStore)();
        const isActionIncrease = action === (0, _languagesJs.HoverVerbosityAction).Increase;
        const actionElement = _domJs.append(container, $((0, _themablesJs.ThemeIcon).asCSSSelector(isActionIncrease ? increaseHoverVerbosityIcon : decreaseHoverVerbosityIcon)));
        actionElement.tabIndex = 0;
        const hoverDelegate = new (0, _hoverJs.WorkbenchHoverDelegate)("mouse", false, {
            target: container,
            position: {
                hoverPosition: 0 /* HoverPosition.LEFT */ 
            }
        }, this._configurationService, this._hoverService);
        store.add(this._hoverService.setupManagedHover(hoverDelegate, actionElement, labelForHoverVerbosityAction(this._keybindingService, action)));
        if (!actionEnabled) {
            actionElement.classList.add("disabled");
            return store;
        }
        actionElement.classList.add("enabled");
        const actionFunction = ()=>this._commandService.executeCommand(action === (0, _languagesJs.HoverVerbosityAction).Increase ? (0, _hoverActionIdsJs.INCREASE_HOVER_VERBOSITY_ACTION_ID) : (0, _hoverActionIdsJs.DECREASE_HOVER_VERBOSITY_ACTION_ID));
        store.add(new (0, _hoverWidgetJs.ClickAction)(actionElement, actionFunction));
        store.add(new (0, _hoverWidgetJs.KeyDownAction)(actionElement, actionFunction, [
            3 /* KeyCode.Enter */ ,
            10 /* KeyCode.Space */ 
        ]));
        return store;
    }
    async updateMarkdownHoverPartVerbosityLevel(action, index, focus = true) {
        const model = this._editor.getModel();
        if (!model) return undefined;
        const hoverRenderedPart = this._getRenderedHoverPartAtIndex(index);
        const hoverSource = hoverRenderedPart?.hoverPart.source;
        if (!hoverRenderedPart || !hoverSource?.supportsVerbosityAction(action)) return undefined;
        const newHover = await this._fetchHover(hoverSource, model, action);
        if (!newHover) return undefined;
        const newHoverSource = new HoverSource(newHover, hoverSource.hoverProvider, hoverSource.hoverPosition);
        const initialHoverPart = hoverRenderedPart.hoverPart;
        const newHoverPart = new MarkdownHover(this._hoverParticipant, initialHoverPart.range, newHover.contents, initialHoverPart.isBeforeContent, initialHoverPart.ordinal, newHoverSource);
        const newHoverRenderedPart = this._renderHoverPart(newHoverPart, this._onFinishedRendering);
        this._replaceRenderedHoverPartAtIndex(index, newHoverRenderedPart, newHoverPart);
        if (focus) this._focusOnHoverPartWithIndex(index);
        return {
            hoverPart: newHoverPart,
            hoverElement: newHoverRenderedPart.hoverElement
        };
    }
    async _fetchHover(hoverSource, model, action) {
        let verbosityDelta = action === (0, _languagesJs.HoverVerbosityAction).Increase ? 1 : -1;
        const provider = hoverSource.hoverProvider;
        const ongoingHoverOperation = this._ongoingHoverOperations.get(provider);
        if (ongoingHoverOperation) {
            ongoingHoverOperation.tokenSource.cancel();
            verbosityDelta += ongoingHoverOperation.verbosityDelta;
        }
        const tokenSource = new (0, _cancellationJs.CancellationTokenSource)();
        this._ongoingHoverOperations.set(provider, {
            verbosityDelta,
            tokenSource
        });
        const context = {
            verbosityRequest: {
                verbosityDelta,
                previousHover: hoverSource.hover
            }
        };
        let hover;
        try {
            hover = await Promise.resolve(provider.provideHover(model, hoverSource.hoverPosition, tokenSource.token, context));
        } catch (e) {
            (0, _errorsJs.onUnexpectedExternalError)(e);
        }
        tokenSource.dispose();
        this._ongoingHoverOperations.delete(provider);
        return hover;
    }
    _replaceRenderedHoverPartAtIndex(index, renderedHoverPart, hoverPart) {
        if (index >= this.renderedHoverParts.length || index < 0) return;
        const currentRenderedHoverPart = this.renderedHoverParts[index];
        const currentRenderedMarkdown = currentRenderedHoverPart.hoverElement;
        const renderedMarkdown = renderedHoverPart.hoverElement;
        const renderedChildrenElements = Array.from(renderedMarkdown.children);
        currentRenderedMarkdown.replaceChildren(...renderedChildrenElements);
        const newRenderedHoverPart = new RenderedMarkdownHoverPart(hoverPart, currentRenderedMarkdown, renderedHoverPart.disposables);
        currentRenderedMarkdown.focus();
        currentRenderedHoverPart.dispose();
        this.renderedHoverParts[index] = newRenderedHoverPart;
    }
    _focusOnHoverPartWithIndex(index) {
        this.renderedHoverParts[index].hoverElement.focus();
    }
    _getRenderedHoverPartAtIndex(index) {
        return this.renderedHoverParts[index];
    }
    dispose() {
        this._disposables.dispose();
    }
}
function renderMarkdownHovers(context, markdownHovers, editor, languageService, openerService) {
    // Sort hover parts to keep them stable since they might come in async, out-of-order
    markdownHovers.sort((0, _arraysJs.compareBy)((hover)=>hover.ordinal, (0, _arraysJs.numberComparator)));
    const renderedHoverParts = [];
    for (const markdownHover of markdownHovers)renderedHoverParts.push(renderMarkdownInContainer(editor, markdownHover, languageService, openerService, context.onContentsChanged));
    return new (0, _hoverTypesJs.RenderedHoverParts)(renderedHoverParts);
}
function renderMarkdownInContainer(editor, markdownHover, languageService, openerService, onFinishedRendering) {
    const disposables = new (0, _lifecycleJs.DisposableStore)();
    const renderedMarkdown = $("div.hover-row");
    const renderedMarkdownContents = $("div.hover-row-contents");
    renderedMarkdown.appendChild(renderedMarkdownContents);
    const markdownStrings = markdownHover.contents;
    for (const markdownString of markdownStrings){
        if ((0, _htmlContentJs.isEmptyMarkdownString)(markdownString)) continue;
        const markdownHoverElement = $("div.markdown-hover");
        const hoverContentsElement = _domJs.append(markdownHoverElement, $("div.hover-contents"));
        const renderer = disposables.add(new (0, _markdownRendererJs.MarkdownRenderer)({
            editor
        }, languageService, openerService));
        disposables.add(renderer.onDidRenderAsync(()=>{
            hoverContentsElement.className = "hover-contents code-hover-contents";
            onFinishedRendering();
        }));
        const renderedContents = disposables.add(renderer.render(markdownString));
        hoverContentsElement.appendChild(renderedContents.element);
        renderedMarkdownContents.appendChild(markdownHoverElement);
    }
    const renderedHoverPart = {
        hoverPart: markdownHover,
        hoverElement: renderedMarkdown,
        dispose () {
            disposables.dispose();
        }
    };
    return renderedHoverPart;
}
function labelForHoverVerbosityAction(keybindingService, action) {
    switch(action){
        case (0, _languagesJs.HoverVerbosityAction).Increase:
            {
                const kb = keybindingService.lookupKeybinding((0, _hoverActionIdsJs.INCREASE_HOVER_VERBOSITY_ACTION_ID));
                return kb ? _nlsJs.localize("increaseVerbosityWithKb", "Increase Hover Verbosity ({0})", kb.getLabel()) : _nlsJs.localize("increaseVerbosity", "Increase Hover Verbosity");
            }
        case (0, _languagesJs.HoverVerbosityAction).Decrease:
            {
                const kb = keybindingService.lookupKeybinding((0, _hoverActionIdsJs.DECREASE_HOVER_VERBOSITY_ACTION_ID));
                return kb ? _nlsJs.localize("decreaseVerbosityWithKb", "Decrease Hover Verbosity ({0})", kb.getLabel()) : _nlsJs.localize("decreaseVerbosity", "Decrease Hover Verbosity");
            }
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/arrays.js":"DECei","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/htmlContent.js":"3Hxzm","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/widget/markdownRenderer/browser/markdownRenderer.js":"34xfZ","./hoverActionIds.js":"b3M99","../../../common/core/range.js":"jmUPh","../../../common/languages/language.js":"ka2JQ","./hoverTypes.js":"6vmRi","../../../../nls.js":"l617d","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/opener/common/opener.js":"d3tj1","../../../common/services/languageFeatures.js":"2IAko","../../../common/languages.js":"g5n96","../../../../platform/theme/common/iconRegistry.js":"bRNEz","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/themables.js":"hgyHi","../../../../base/common/errors.js":"divX8","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../base/browser/ui/hover/hoverWidget.js":"5eWDy","../../../../platform/hover/browser/hover.js":"3QGXp","../../../../base/common/async.js":"4GJc4","./getHover.js":"ky5R6","../../../../platform/commands/common/commands.js":"ho6ic","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ky5R6":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverProviderResult", ()=>HoverProviderResult);
parcelHelpers.export(exports, "getHoverProviderResultsAsAsyncIterable", ()=>getHoverProviderResultsAsAsyncIterable);
parcelHelpers.export(exports, "getHoversPromise", ()=>getHoversPromise);
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
class HoverProviderResult {
    constructor(provider, hover, ordinal){
        this.provider = provider;
        this.hover = hover;
        this.ordinal = ordinal;
    }
}
/**
 * Does not throw or return a rejected promise (returns undefined instead).
 */ async function executeProvider(provider, ordinal, model, position, token) {
    const result = await Promise.resolve(provider.provideHover(model, position, token)).catch((0, _errorsJs.onUnexpectedExternalError));
    if (!result || !isValid(result)) return undefined;
    return new HoverProviderResult(provider, result, ordinal);
}
function getHoverProviderResultsAsAsyncIterable(registry, model, position, token, recursive = false) {
    const providers = registry.ordered(model, recursive);
    const promises = providers.map((provider, index)=>executeProvider(provider, index, model, position, token));
    return (0, _asyncJs.AsyncIterableObject).fromPromises(promises).coalesce();
}
function getHoversPromise(registry, model, position, token, recursive = false) {
    return getHoverProviderResultsAsAsyncIterable(registry, model, position, token, recursive).map((item)=>item.hover).toPromise();
}
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeHoverProvider", (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return getHoversPromise(languageFeaturesService.hoverProvider, model, position, (0, _cancellationJs.CancellationToken).None);
});
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeHoverProvider_recursive", (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return getHoversPromise(languageFeaturesService.hoverProvider, model, position, (0, _cancellationJs.CancellationToken).None, true);
});
function isValid(result) {
    const hasRange = typeof result.range !== "undefined";
    const hasHtmlContent = typeof result.contents !== "undefined" && result.contents && result.contents.length > 0;
    return hasRange && hasHtmlContent;
}

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../browser/editorExtensions.js":"kC3w6","../../../common/services/languageFeatures.js":"2IAko","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1SEMh":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlayHintsHover", ()=>InlayHintsHover);
var _asyncJs = require("../../../../base/common/async.js");
var _htmlContentJs = require("../../../../base/common/htmlContent.js");
var _positionJs = require("../../../common/core/position.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _hoverTypesJs = require("../../hover/browser/hoverTypes.js");
var _languageJs = require("../../../common/languages/language.js");
var _resolverServiceJs = require("../../../common/services/resolverService.js");
var _getHoverJs = require("../../hover/browser/getHover.js");
var _markdownHoverParticipantJs = require("../../hover/browser/markdownHoverParticipant.js");
var _inlayHintsControllerJs = require("./inlayHintsController.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _openerJs = require("../../../../platform/opener/common/opener.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _nlsJs = require("../../../../nls.js");
var _platformJs = require("../../../../base/common/platform.js");
var _inlayHintsJs = require("./inlayHints.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _hoverJs = require("../../../../platform/hover/browser/hover.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class InlayHintsHoverAnchor extends (0, _hoverTypesJs.HoverForeignElementAnchor) {
    constructor(part, owner, initialMousePosX, initialMousePosY){
        super(10, owner, part.item.anchor.range, initialMousePosX, initialMousePosY, true);
        this.part = part;
    }
}
let InlayHintsHover = class InlayHintsHover extends (0, _markdownHoverParticipantJs.MarkdownHoverParticipant) {
    constructor(editor, languageService, openerService, keybindingService, hoverService, configurationService, _resolverService, languageFeaturesService, commandService){
        super(editor, languageService, openerService, configurationService, languageFeaturesService, keybindingService, hoverService, commandService);
        this._resolverService = _resolverService;
        this.hoverOrdinal = 6;
    }
    suggestHoverAnchor(mouseEvent) {
        const controller = (0, _inlayHintsControllerJs.InlayHintsController).get(this._editor);
        if (!controller) return null;
        if (mouseEvent.target.type !== 6 /* MouseTargetType.CONTENT_TEXT */ ) return null;
        const options = mouseEvent.target.detail.injectedText?.options;
        if (!(options instanceof (0, _textModelJs.ModelDecorationInjectedTextOptions) && options.attachedData instanceof (0, _inlayHintsControllerJs.RenderedInlayHintLabelPart))) return null;
        return new InlayHintsHoverAnchor(options.attachedData, this, mouseEvent.event.posx, mouseEvent.event.posy);
    }
    computeSync() {
        return [];
    }
    computeAsync(anchor, _lineDecorations, token) {
        if (!(anchor instanceof InlayHintsHoverAnchor)) return (0, _asyncJs.AsyncIterableObject).EMPTY;
        return new (0, _asyncJs.AsyncIterableObject)(async (executor)=>{
            const { part } = anchor;
            await part.item.resolve(token);
            if (token.isCancellationRequested) return;
            // (1) Inlay Tooltip
            let itemTooltip;
            if (typeof part.item.hint.tooltip === "string") itemTooltip = new (0, _htmlContentJs.MarkdownString)().appendText(part.item.hint.tooltip);
            else if (part.item.hint.tooltip) itemTooltip = part.item.hint.tooltip;
            if (itemTooltip) executor.emitOne(new (0, _markdownHoverParticipantJs.MarkdownHover)(this, anchor.range, [
                itemTooltip
            ], false, 0));
            // (1.2) Inlay dbl-click gesture
            if ((0, _arraysJs.isNonEmptyArray)(part.item.hint.textEdits)) executor.emitOne(new (0, _markdownHoverParticipantJs.MarkdownHover)(this, anchor.range, [
                new (0, _htmlContentJs.MarkdownString)().appendText((0, _nlsJs.localize)("hint.dbl", "Double-click to insert"))
            ], false, 10001));
            // (2) Inlay Label Part Tooltip
            let partTooltip;
            if (typeof part.part.tooltip === "string") partTooltip = new (0, _htmlContentJs.MarkdownString)().appendText(part.part.tooltip);
            else if (part.part.tooltip) partTooltip = part.part.tooltip;
            if (partTooltip) executor.emitOne(new (0, _markdownHoverParticipantJs.MarkdownHover)(this, anchor.range, [
                partTooltip
            ], false, 1));
            // (2.2) Inlay Label Part Help Hover
            if (part.part.location || part.part.command) {
                let linkHint;
                const useMetaKey = this._editor.getOption(78 /* EditorOption.multiCursorModifier */ ) === "altKey";
                const kb = useMetaKey ? _platformJs.isMacintosh ? (0, _nlsJs.localize)("links.navigate.kb.meta.mac", "cmd + click") : (0, _nlsJs.localize)("links.navigate.kb.meta", "ctrl + click") : _platformJs.isMacintosh ? (0, _nlsJs.localize)("links.navigate.kb.alt.mac", "option + click") : (0, _nlsJs.localize)("links.navigate.kb.alt", "alt + click");
                if (part.part.location && part.part.command) linkHint = new (0, _htmlContentJs.MarkdownString)().appendText((0, _nlsJs.localize)("hint.defAndCommand", "Go to Definition ({0}), right click for more", kb));
                else if (part.part.location) linkHint = new (0, _htmlContentJs.MarkdownString)().appendText((0, _nlsJs.localize)("hint.def", "Go to Definition ({0})", kb));
                else if (part.part.command) linkHint = new (0, _htmlContentJs.MarkdownString)(`[${(0, _nlsJs.localize)("hint.cmd", "Execute Command")}](${(0, _inlayHintsJs.asCommandLink)(part.part.command)} "${part.part.command.title}") (${kb})`, {
                    isTrusted: true
                });
                if (linkHint) executor.emitOne(new (0, _markdownHoverParticipantJs.MarkdownHover)(this, anchor.range, [
                    linkHint
                ], false, 10000));
            }
            // (3) Inlay Label Part Location tooltip
            const iterable = await this._resolveInlayHintLabelPartHover(part, token);
            for await (const item of iterable)executor.emitOne(item);
        });
    }
    async _resolveInlayHintLabelPartHover(part, token) {
        if (!part.part.location) return (0, _asyncJs.AsyncIterableObject).EMPTY;
        const { uri, range } = part.part.location;
        const ref = await this._resolverService.createModelReference(uri);
        try {
            const model = ref.object.textEditorModel;
            if (!this._languageFeaturesService.hoverProvider.has(model)) return (0, _asyncJs.AsyncIterableObject).EMPTY;
            return (0, _getHoverJs.getHoverProviderResultsAsAsyncIterable)(this._languageFeaturesService.hoverProvider, model, new (0, _positionJs.Position)(range.startLineNumber, range.startColumn), token).filter((item)=>!(0, _htmlContentJs.isEmptyMarkdownString)(item.hover.contents)).map((item)=>new (0, _markdownHoverParticipantJs.MarkdownHover)(this, part.item.anchor.range, item.hover.contents, false, 2 + item.ordinal));
        } finally{
            ref.dispose();
        }
    }
};
InlayHintsHover = __decorate([
    __param(1, (0, _languageJs.ILanguageService)),
    __param(2, (0, _openerJs.IOpenerService)),
    __param(3, (0, _keybindingJs.IKeybindingService)),
    __param(4, (0, _hoverJs.IHoverService)),
    __param(5, (0, _configurationJs.IConfigurationService)),
    __param(6, (0, _resolverServiceJs.ITextModelService)),
    __param(7, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(8, (0, _commandsJs.ICommandService))
], InlayHintsHover);

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/htmlContent.js":"3Hxzm","../../../common/core/position.js":"lvrPe","../../../common/model/textModel.js":"9beDe","../../hover/browser/hoverTypes.js":"6vmRi","../../../common/languages/language.js":"ka2JQ","../../../common/services/resolverService.js":"ezAtF","../../hover/browser/getHover.js":"ky5R6","../../hover/browser/markdownHoverParticipant.js":"l8mtm","./inlayHintsController.js":"hylHy","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/opener/common/opener.js":"d3tj1","../../../common/services/languageFeatures.js":"2IAko","../../../../nls.js":"l617d","../../../../base/common/platform.js":"7maJO","./inlayHints.js":"k6lDy","../../../../base/common/arrays.js":"DECei","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../platform/hover/browser/hover.js":"3QGXp","../../../../platform/commands/common/commands.js":"ho6ic","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hylHy":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// --- rendered label
parcelHelpers.export(exports, "RenderedInlayHintLabelPart", ()=>RenderedInlayHintLabelPart);
parcelHelpers.export(exports, "InlayHintsController", ()=>InlayHintsController);
var _domJs = require("../../../../base/browser/dom.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _mapJs = require("../../../../base/common/map.js");
var _typesJs = require("../../../../base/common/types.js");
var _uriJs = require("../../../../base/common/uri.js");
var _editorDomJs = require("../../../browser/editorDom.js");
var _stableEditorScrollJs = require("../../../browser/stableEditorScroll.js");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
var _editOperationJs = require("../../../common/core/editOperation.js");
var _rangeJs = require("../../../common/core/range.js");
var _languagesJs = require("../../../common/languages.js");
var _modelJs = require("../../../common/model.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _languageFeatureDebounceJs = require("../../../common/services/languageFeatureDebounce.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _resolverServiceJs = require("../../../common/services/resolverService.js");
var _clickLinkGestureJs = require("../../gotoSymbol/browser/link/clickLinkGesture.js");
var _inlayHintsJs = require("./inlayHints.js");
var _inlayHintsLocationsJs = require("./inlayHintsLocations.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _extensionsJs = require("../../../../platform/instantiation/common/extensions.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var InlayHintsController_1;
// --- hint caching service (per session)
class InlayHintsCache {
    constructor(){
        this._entries = new (0, _mapJs.LRUCache)(50);
    }
    get(model) {
        const key = InlayHintsCache._key(model);
        return this._entries.get(key);
    }
    set(model, value) {
        const key = InlayHintsCache._key(model);
        this._entries.set(key, value);
    }
    static _key(model) {
        return `${model.uri.toString()}/${model.getVersionId()}`;
    }
}
const IInlayHintsCache = (0, _instantiationJs.createDecorator)("IInlayHintsCache");
(0, _extensionsJs.registerSingleton)(IInlayHintsCache, InlayHintsCache, 1 /* InstantiationType.Delayed */ );
class RenderedInlayHintLabelPart {
    constructor(item, index){
        this.item = item;
        this.index = index;
    }
    get part() {
        const label = this.item.hint.label;
        if (typeof label === "string") return {
            label
        };
        else return label[this.index];
    }
}
class ActiveInlayHintInfo {
    constructor(part, hasTriggerModifier){
        this.part = part;
        this.hasTriggerModifier = hasTriggerModifier;
    }
}
// --- controller
let InlayHintsController = class InlayHintsController {
    static{
        InlayHintsController_1 = this;
    }
    static{
        this.ID = "editor.contrib.InlayHints";
    }
    static{
        this._MAX_DECORATORS = 1500;
    }
    static{
        this._MAX_LABEL_LEN = 43;
    }
    static get(editor) {
        return editor.getContribution(InlayHintsController_1.ID) ?? undefined;
    }
    constructor(_editor, _languageFeaturesService, _featureDebounce, _inlayHintsCache, _commandService, _notificationService, _instaService){
        this._editor = _editor;
        this._languageFeaturesService = _languageFeaturesService;
        this._inlayHintsCache = _inlayHintsCache;
        this._commandService = _commandService;
        this._notificationService = _notificationService;
        this._instaService = _instaService;
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._sessionDisposables = new (0, _lifecycleJs.DisposableStore)();
        this._decorationsMetadata = new Map();
        this._ruleFactory = new (0, _editorDomJs.DynamicCssRules)(this._editor);
        this._activeRenderMode = 0 /* RenderMode.Normal */ ;
        this._debounceInfo = _featureDebounce.for(_languageFeaturesService.inlayHintsProvider, "InlayHint", {
            min: 25
        });
        this._disposables.add(_languageFeaturesService.inlayHintsProvider.onDidChange(()=>this._update()));
        this._disposables.add(_editor.onDidChangeModel(()=>this._update()));
        this._disposables.add(_editor.onDidChangeModelLanguage(()=>this._update()));
        this._disposables.add(_editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(142 /* EditorOption.inlayHints */ )) this._update();
        }));
        this._update();
    }
    dispose() {
        this._sessionDisposables.dispose();
        this._removeAllDecorations();
        this._disposables.dispose();
    }
    _update() {
        this._sessionDisposables.clear();
        this._removeAllDecorations();
        const options = this._editor.getOption(142 /* EditorOption.inlayHints */ );
        if (options.enabled === "off") return;
        const model = this._editor.getModel();
        if (!model || !this._languageFeaturesService.inlayHintsProvider.has(model)) return;
        if (options.enabled === "on") // different "on" modes: always
        this._activeRenderMode = 0 /* RenderMode.Normal */ ;
        else {
            // different "on" modes: offUnlessPressed, or onUnlessPressed
            let defaultMode;
            let altMode;
            if (options.enabled === "onUnlessPressed") {
                defaultMode = 0 /* RenderMode.Normal */ ;
                altMode = 1 /* RenderMode.Invisible */ ;
            } else {
                defaultMode = 1 /* RenderMode.Invisible */ ;
                altMode = 0 /* RenderMode.Normal */ ;
            }
            this._activeRenderMode = defaultMode;
            this._sessionDisposables.add((0, _domJs.ModifierKeyEmitter).getInstance().event((e)=>{
                if (!this._editor.hasModel()) return;
                const newRenderMode = e.altKey && e.ctrlKey && !(e.shiftKey || e.metaKey) ? altMode : defaultMode;
                if (newRenderMode !== this._activeRenderMode) {
                    this._activeRenderMode = newRenderMode;
                    const model = this._editor.getModel();
                    const copies = this._copyInlayHintsWithCurrentAnchor(model);
                    this._updateHintsDecorators([
                        model.getFullModelRange()
                    ], copies);
                    scheduler.schedule(0);
                }
            }));
        }
        // iff possible, quickly update from cache
        const cached = this._inlayHintsCache.get(model);
        if (cached) this._updateHintsDecorators([
            model.getFullModelRange()
        ], cached);
        this._sessionDisposables.add((0, _lifecycleJs.toDisposable)(()=>{
            // cache items when switching files etc
            if (!model.isDisposed()) this._cacheHintsForFastRestore(model);
        }));
        let cts;
        const watchedProviders = new Set();
        const scheduler = new (0, _asyncJs.RunOnceScheduler)(async ()=>{
            const t1 = Date.now();
            cts?.dispose(true);
            cts = new (0, _cancellationJs.CancellationTokenSource)();
            const listener = model.onWillDispose(()=>cts?.cancel());
            try {
                const myToken = cts.token;
                const inlayHints = await (0, _inlayHintsJs.InlayHintsFragments).create(this._languageFeaturesService.inlayHintsProvider, model, this._getHintsRanges(), myToken);
                scheduler.delay = this._debounceInfo.update(model, Date.now() - t1);
                if (myToken.isCancellationRequested) {
                    inlayHints.dispose();
                    return;
                }
                // listen to provider changes
                for (const provider of inlayHints.provider)if (typeof provider.onDidChangeInlayHints === "function" && !watchedProviders.has(provider)) {
                    watchedProviders.add(provider);
                    this._sessionDisposables.add(provider.onDidChangeInlayHints(()=>{
                        if (!scheduler.isScheduled()) scheduler.schedule();
                    }));
                }
                this._sessionDisposables.add(inlayHints);
                this._updateHintsDecorators(inlayHints.ranges, inlayHints.items);
                this._cacheHintsForFastRestore(model);
            } catch (err) {
                (0, _errorsJs.onUnexpectedError)(err);
            } finally{
                cts.dispose();
                listener.dispose();
            }
        }, this._debounceInfo.get(model));
        this._sessionDisposables.add(scheduler);
        this._sessionDisposables.add((0, _lifecycleJs.toDisposable)(()=>cts?.dispose(true)));
        scheduler.schedule(0);
        this._sessionDisposables.add(this._editor.onDidScrollChange((e)=>{
            // update when scroll position changes
            // uses scrollTopChanged has weak heuristic to differenatiate between scrolling due to
            // typing or due to "actual" scrolling
            if (e.scrollTopChanged || !scheduler.isScheduled()) scheduler.schedule();
        }));
        this._sessionDisposables.add(this._editor.onDidChangeModelContent((e)=>{
            cts?.cancel();
            // update less aggressive when typing
            const delay = Math.max(scheduler.delay, 1250);
            scheduler.schedule(delay);
        }));
        // mouse gestures
        this._sessionDisposables.add(this._installDblClickGesture(()=>scheduler.schedule(0)));
        this._sessionDisposables.add(this._installLinkGesture());
        this._sessionDisposables.add(this._installContextMenu());
    }
    _installLinkGesture() {
        const store = new (0, _lifecycleJs.DisposableStore)();
        const gesture = store.add(new (0, _clickLinkGestureJs.ClickLinkGesture)(this._editor));
        // let removeHighlight = () => { };
        const sessionStore = new (0, _lifecycleJs.DisposableStore)();
        store.add(sessionStore);
        store.add(gesture.onMouseMoveOrRelevantKeyDown((e)=>{
            const [mouseEvent] = e;
            const labelPart = this._getInlayHintLabelPart(mouseEvent);
            const model = this._editor.getModel();
            if (!labelPart || !model) {
                sessionStore.clear();
                return;
            }
            // resolve the item
            const cts = new (0, _cancellationJs.CancellationTokenSource)();
            sessionStore.add((0, _lifecycleJs.toDisposable)(()=>cts.dispose(true)));
            labelPart.item.resolve(cts.token);
            // render link => when the modifier is pressed and when there is a command or location
            this._activeInlayHintPart = labelPart.part.command || labelPart.part.location ? new ActiveInlayHintInfo(labelPart, mouseEvent.hasTriggerModifier) : undefined;
            const lineNumber = model.validatePosition(labelPart.item.hint.position).lineNumber;
            const range = new (0, _rangeJs.Range)(lineNumber, 1, lineNumber, model.getLineMaxColumn(lineNumber));
            const lineHints = this._getInlineHintsForRange(range);
            this._updateHintsDecorators([
                range
            ], lineHints);
            sessionStore.add((0, _lifecycleJs.toDisposable)(()=>{
                this._activeInlayHintPart = undefined;
                this._updateHintsDecorators([
                    range
                ], lineHints);
            }));
        }));
        store.add(gesture.onCancel(()=>sessionStore.clear()));
        store.add(gesture.onExecute(async (e)=>{
            const label = this._getInlayHintLabelPart(e);
            if (label) {
                const part = label.part;
                if (part.location) // location -> execute go to def
                this._instaService.invokeFunction((0, _inlayHintsLocationsJs.goToDefinitionWithLocation), e, this._editor, part.location);
                else if (_languagesJs.Command.is(part.command)) // command -> execute it
                await this._invokeCommand(part.command, label.item);
            }
        }));
        return store;
    }
    _getInlineHintsForRange(range) {
        const lineHints = new Set();
        for (const data of this._decorationsMetadata.values())if (range.containsRange(data.item.anchor.range)) lineHints.add(data.item);
        return Array.from(lineHints);
    }
    _installDblClickGesture(updateInlayHints) {
        return this._editor.onMouseUp(async (e)=>{
            if (e.event.detail !== 2) return;
            const part = this._getInlayHintLabelPart(e);
            if (!part) return;
            e.event.preventDefault();
            await part.item.resolve((0, _cancellationJs.CancellationToken).None);
            if ((0, _arraysJs.isNonEmptyArray)(part.item.hint.textEdits)) {
                const edits = part.item.hint.textEdits.map((edit)=>(0, _editOperationJs.EditOperation).replace((0, _rangeJs.Range).lift(edit.range), edit.text));
                this._editor.executeEdits("inlayHint.default", edits);
                updateInlayHints();
            }
        });
    }
    _installContextMenu() {
        return this._editor.onContextMenu(async (e)=>{
            if (!(0, _domJs.isHTMLElement)(e.event.target)) return;
            const part = this._getInlayHintLabelPart(e);
            if (part) await this._instaService.invokeFunction((0, _inlayHintsLocationsJs.showGoToContextMenu), this._editor, e.event.target, part);
        });
    }
    _getInlayHintLabelPart(e) {
        if (e.target.type !== 6 /* MouseTargetType.CONTENT_TEXT */ ) return undefined;
        const options = e.target.detail.injectedText?.options;
        if (options instanceof (0, _textModelJs.ModelDecorationInjectedTextOptions) && options?.attachedData instanceof RenderedInlayHintLabelPart) return options.attachedData;
        return undefined;
    }
    async _invokeCommand(command, item) {
        try {
            await this._commandService.executeCommand(command.id, ...command.arguments ?? []);
        } catch (err) {
            this._notificationService.notify({
                severity: (0, _notificationJs.Severity).Error,
                source: item.provider.displayName,
                message: err
            });
        }
    }
    _cacheHintsForFastRestore(model) {
        const hints = this._copyInlayHintsWithCurrentAnchor(model);
        this._inlayHintsCache.set(model, hints);
    }
    // return inlay hints but with an anchor that reflects "updates"
    // that happened after receiving them, e.g adding new lines before a hint
    _copyInlayHintsWithCurrentAnchor(model) {
        const items = new Map();
        for (const [id, obj] of this._decorationsMetadata){
            if (items.has(obj.item)) continue;
            const range = model.getDecorationRange(id);
            if (range) {
                // update range with whatever the editor has tweaked it to
                const anchor = new (0, _inlayHintsJs.InlayHintAnchor)(range, obj.item.anchor.direction);
                const copy = obj.item.with({
                    anchor
                });
                items.set(obj.item, copy);
            }
        }
        return Array.from(items.values());
    }
    _getHintsRanges() {
        const extra = 30;
        const model = this._editor.getModel();
        const visibleRanges = this._editor.getVisibleRangesPlusViewportAboveBelow();
        const result = [];
        for (const range of visibleRanges.sort((0, _rangeJs.Range).compareRangesUsingStarts)){
            const extendedRange = model.validateRange(new (0, _rangeJs.Range)(range.startLineNumber - extra, range.startColumn, range.endLineNumber + extra, range.endColumn));
            if (result.length === 0 || !(0, _rangeJs.Range).areIntersectingOrTouching(result[result.length - 1], extendedRange)) result.push(extendedRange);
            else result[result.length - 1] = (0, _rangeJs.Range).plusRange(result[result.length - 1], extendedRange);
        }
        return result;
    }
    _updateHintsDecorators(ranges, items) {
        // utils to collect/create injected text decorations
        const newDecorationsData = [];
        const addInjectedText = (item, ref, content, cursorStops, attachedData)=>{
            const opts = {
                content,
                inlineClassNameAffectsLetterSpacing: true,
                inlineClassName: ref.className,
                cursorStops,
                attachedData
            };
            newDecorationsData.push({
                item,
                classNameRef: ref,
                decoration: {
                    range: item.anchor.range,
                    options: {
                        // className: "rangeHighlight", // DEBUG highlight to see to what range a hint is attached
                        description: "InlayHint",
                        showIfCollapsed: item.anchor.range.isEmpty(),
                        collapseOnReplaceEdit: !item.anchor.range.isEmpty(),
                        stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ,
                        [item.anchor.direction]: this._activeRenderMode === 0 /* RenderMode.Normal */  ? opts : undefined
                    }
                }
            });
        };
        const addInjectedWhitespace = (item, isLast)=>{
            const marginRule = this._ruleFactory.createClassNameRef({
                width: `${fontSize / 3 | 0}px`,
                display: "inline-block"
            });
            addInjectedText(item, marginRule, "\u200A", isLast ? (0, _modelJs.InjectedTextCursorStops).Right : (0, _modelJs.InjectedTextCursorStops).None);
        };
        //
        const { fontSize, fontFamily, padding, isUniform } = this._getLayoutInfo();
        const fontFamilyVar = "--code-editorInlayHintsFontFamily";
        this._editor.getContainerDomNode().style.setProperty(fontFamilyVar, fontFamily);
        let currentLineInfo = {
            line: 0,
            totalLen: 0
        };
        for (const item of items){
            if (currentLineInfo.line !== item.anchor.range.startLineNumber) currentLineInfo = {
                line: item.anchor.range.startLineNumber,
                totalLen: 0
            };
            if (currentLineInfo.totalLen > InlayHintsController_1._MAX_LABEL_LEN) continue;
            // whitespace leading the actual label
            if (item.hint.paddingLeft) addInjectedWhitespace(item, false);
            // the label with its parts
            const parts = typeof item.hint.label === "string" ? [
                {
                    label: item.hint.label
                }
            ] : item.hint.label;
            for(let i = 0; i < parts.length; i++){
                const part = parts[i];
                const isFirst = i === 0;
                const isLast = i === parts.length - 1;
                const cssProperties = {
                    fontSize: `${fontSize}px`,
                    fontFamily: `var(${fontFamilyVar}), ${(0, _editorOptionsJs.EDITOR_FONT_DEFAULTS).fontFamily}`,
                    verticalAlign: isUniform ? "baseline" : "middle",
                    unicodeBidi: "isolate"
                };
                if ((0, _arraysJs.isNonEmptyArray)(item.hint.textEdits)) cssProperties.cursor = "default";
                this._fillInColors(cssProperties, item.hint);
                if ((part.command || part.location) && this._activeInlayHintPart?.part.item === item && this._activeInlayHintPart.part.index === i) {
                    // active link!
                    cssProperties.textDecoration = "underline";
                    if (this._activeInlayHintPart.hasTriggerModifier) {
                        cssProperties.color = (0, _themeServiceJs.themeColorFromId)(_colorRegistryJs.editorActiveLinkForeground);
                        cssProperties.cursor = "pointer";
                    }
                }
                if (padding) {
                    if (isFirst && isLast) {
                        // only element
                        cssProperties.padding = `1px ${Math.max(1, fontSize / 4) | 0}px`;
                        cssProperties.borderRadius = `${fontSize / 4 | 0}px`;
                    } else if (isFirst) {
                        // first element
                        cssProperties.padding = `1px 0 1px ${Math.max(1, fontSize / 4) | 0}px`;
                        cssProperties.borderRadius = `${fontSize / 4 | 0}px 0 0 ${fontSize / 4 | 0}px`;
                    } else if (isLast) {
                        // last element
                        cssProperties.padding = `1px ${Math.max(1, fontSize / 4) | 0}px 1px 0`;
                        cssProperties.borderRadius = `0 ${fontSize / 4 | 0}px ${fontSize / 4 | 0}px 0`;
                    } else cssProperties.padding = `1px 0 1px 0`;
                }
                let textlabel = part.label;
                currentLineInfo.totalLen += textlabel.length;
                let tooLong = false;
                const over = currentLineInfo.totalLen - InlayHintsController_1._MAX_LABEL_LEN;
                if (over > 0) {
                    textlabel = textlabel.slice(0, -over) + "\u2026";
                    tooLong = true;
                }
                addInjectedText(item, this._ruleFactory.createClassNameRef(cssProperties), fixSpace(textlabel), isLast && !item.hint.paddingRight ? (0, _modelJs.InjectedTextCursorStops).Right : (0, _modelJs.InjectedTextCursorStops).None, new RenderedInlayHintLabelPart(item, i));
                if (tooLong) break;
            }
            // whitespace trailing the actual label
            if (item.hint.paddingRight) addInjectedWhitespace(item, true);
            if (newDecorationsData.length > InlayHintsController_1._MAX_DECORATORS) break;
        }
        // collect all decoration ids that are affected by the ranges
        // and only update those decorations
        const decorationIdsToReplace = [];
        for (const [id, metadata] of this._decorationsMetadata){
            const range = this._editor.getModel()?.getDecorationRange(id);
            if (range && ranges.some((r)=>r.containsRange(range))) {
                decorationIdsToReplace.push(id);
                metadata.classNameRef.dispose();
                this._decorationsMetadata.delete(id);
            }
        }
        const scrollState = (0, _stableEditorScrollJs.StableEditorScrollState).capture(this._editor);
        this._editor.changeDecorations((accessor)=>{
            const newDecorationIds = accessor.deltaDecorations(decorationIdsToReplace, newDecorationsData.map((d)=>d.decoration));
            for(let i = 0; i < newDecorationIds.length; i++){
                const data = newDecorationsData[i];
                this._decorationsMetadata.set(newDecorationIds[i], data);
            }
        });
        scrollState.restore(this._editor);
    }
    _fillInColors(props, hint) {
        if (hint.kind === _languagesJs.InlayHintKind.Parameter) {
            props.backgroundColor = (0, _themeServiceJs.themeColorFromId)(_colorRegistryJs.editorInlayHintParameterBackground);
            props.color = (0, _themeServiceJs.themeColorFromId)(_colorRegistryJs.editorInlayHintParameterForeground);
        } else if (hint.kind === _languagesJs.InlayHintKind.Type) {
            props.backgroundColor = (0, _themeServiceJs.themeColorFromId)(_colorRegistryJs.editorInlayHintTypeBackground);
            props.color = (0, _themeServiceJs.themeColorFromId)(_colorRegistryJs.editorInlayHintTypeForeground);
        } else {
            props.backgroundColor = (0, _themeServiceJs.themeColorFromId)(_colorRegistryJs.editorInlayHintBackground);
            props.color = (0, _themeServiceJs.themeColorFromId)(_colorRegistryJs.editorInlayHintForeground);
        }
    }
    _getLayoutInfo() {
        const options = this._editor.getOption(142 /* EditorOption.inlayHints */ );
        const padding = options.padding;
        const editorFontSize = this._editor.getOption(52 /* EditorOption.fontSize */ );
        const editorFontFamily = this._editor.getOption(49 /* EditorOption.fontFamily */ );
        let fontSize = options.fontSize;
        if (!fontSize || fontSize < 5 || fontSize > editorFontSize) fontSize = editorFontSize;
        const fontFamily = options.fontFamily || editorFontFamily;
        const isUniform = !padding && fontFamily === editorFontFamily && fontSize === editorFontSize;
        return {
            fontSize,
            fontFamily,
            padding,
            isUniform
        };
    }
    _removeAllDecorations() {
        this._editor.removeDecorations(Array.from(this._decorationsMetadata.keys()));
        for (const obj of this._decorationsMetadata.values())obj.classNameRef.dispose();
        this._decorationsMetadata.clear();
    }
};
InlayHintsController = InlayHintsController_1 = __decorate([
    __param(1, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(2, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService)),
    __param(3, IInlayHintsCache),
    __param(4, (0, _commandsJs.ICommandService)),
    __param(5, (0, _notificationJs.INotificationService)),
    __param(6, (0, _instantiationJs.IInstantiationService))
], InlayHintsController);
// Prevents the view from potentially visible whitespace
function fixSpace(str) {
    const noBreakWhitespace = "\xa0";
    return str.replace(/[ \t]/g, noBreakWhitespace);
}
(0, _commandsJs.CommandsRegistry).registerCommand("_executeInlayHintProvider", async (accessor, ...args)=>{
    const [uri, range] = args;
    (0, _typesJs.assertType)((0, _uriJs.URI).isUri(uri));
    (0, _typesJs.assertType)((0, _rangeJs.Range).isIRange(range));
    const { inlayHintsProvider } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const ref = await accessor.get((0, _resolverServiceJs.ITextModelService)).createModelReference(uri);
    try {
        const model = await (0, _inlayHintsJs.InlayHintsFragments).create(inlayHintsProvider, ref.object.textEditorModel, [
            (0, _rangeJs.Range).lift(range)
        ], (0, _cancellationJs.CancellationToken).None);
        const result = model.items.map((i)=>i.hint);
        setTimeout(()=>model.dispose(), 0); // dispose after sending to ext host
        return result;
    } finally{
        ref.dispose();
    }
});

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/arrays.js":"DECei","../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/map.js":"leSjz","../../../../base/common/types.js":"fb5yx","../../../../base/common/uri.js":"7qGS3","../../../browser/editorDom.js":"8EVOq","../../../browser/stableEditorScroll.js":"5Bh72","../../../common/config/editorOptions.js":"3Xi00","../../../common/core/editOperation.js":"6r2FZ","../../../common/core/range.js":"jmUPh","../../../common/languages.js":"g5n96","../../../common/model.js":"1CSIB","../../../common/model/textModel.js":"9beDe","../../../common/services/languageFeatureDebounce.js":"YGXXG","../../../common/services/languageFeatures.js":"2IAko","../../../common/services/resolverService.js":"ezAtF","../../gotoSymbol/browser/link/clickLinkGesture.js":"5rimz","./inlayHints.js":"k6lDy","./inlayHintsLocations.js":"04F32","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/instantiation/common/extensions.js":"6WJLq","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/notification/common/notification.js":"igv0W","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5rimz":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An event that encapsulates the various trigger modifiers logic needed for go to definition.
 */ parcelHelpers.export(exports, "ClickLinkMouseEvent", ()=>ClickLinkMouseEvent);
/**
 * An event that encapsulates the various trigger modifiers logic needed for go to definition.
 */ parcelHelpers.export(exports, "ClickLinkKeyboardEvent", ()=>ClickLinkKeyboardEvent);
parcelHelpers.export(exports, "ClickLinkOptions", ()=>ClickLinkOptions);
parcelHelpers.export(exports, "ClickLinkGesture", ()=>ClickLinkGesture);
var _eventJs = require("../../../../../base/common/event.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _platformJs = require("../../../../../base/common/platform.js");
function hasModifier(e, modifier) {
    return !!e[modifier];
}
class ClickLinkMouseEvent {
    constructor(source, opts){
        this.target = source.target;
        this.isLeftClick = source.event.leftButton;
        this.isMiddleClick = source.event.middleButton;
        this.isRightClick = source.event.rightButton;
        this.hasTriggerModifier = hasModifier(source.event, opts.triggerModifier);
        this.hasSideBySideModifier = hasModifier(source.event, opts.triggerSideBySideModifier);
        this.isNoneOrSingleMouseDown = source.event.detail <= 1;
    }
}
class ClickLinkKeyboardEvent {
    constructor(source, opts){
        this.keyCodeIsTriggerKey = source.keyCode === opts.triggerKey;
        this.keyCodeIsSideBySideKey = source.keyCode === opts.triggerSideBySideKey;
        this.hasTriggerModifier = hasModifier(source, opts.triggerModifier);
    }
}
class ClickLinkOptions {
    constructor(triggerKey, triggerModifier, triggerSideBySideKey, triggerSideBySideModifier){
        this.triggerKey = triggerKey;
        this.triggerModifier = triggerModifier;
        this.triggerSideBySideKey = triggerSideBySideKey;
        this.triggerSideBySideModifier = triggerSideBySideModifier;
    }
    equals(other) {
        return this.triggerKey === other.triggerKey && this.triggerModifier === other.triggerModifier && this.triggerSideBySideKey === other.triggerSideBySideKey && this.triggerSideBySideModifier === other.triggerSideBySideModifier;
    }
}
function createOptions(multiCursorModifier) {
    if (multiCursorModifier === "altKey") {
        if (_platformJs.isMacintosh) return new ClickLinkOptions(57 /* KeyCode.Meta */ , "metaKey", 6 /* KeyCode.Alt */ , "altKey");
        return new ClickLinkOptions(5 /* KeyCode.Ctrl */ , "ctrlKey", 6 /* KeyCode.Alt */ , "altKey");
    }
    if (_platformJs.isMacintosh) return new ClickLinkOptions(6 /* KeyCode.Alt */ , "altKey", 57 /* KeyCode.Meta */ , "metaKey");
    return new ClickLinkOptions(6 /* KeyCode.Alt */ , "altKey", 5 /* KeyCode.Ctrl */ , "ctrlKey");
}
class ClickLinkGesture extends (0, _lifecycleJs.Disposable) {
    constructor(editor, opts){
        super();
        this._onMouseMoveOrRelevantKeyDown = this._register(new (0, _eventJs.Emitter)());
        this.onMouseMoveOrRelevantKeyDown = this._onMouseMoveOrRelevantKeyDown.event;
        this._onExecute = this._register(new (0, _eventJs.Emitter)());
        this.onExecute = this._onExecute.event;
        this._onCancel = this._register(new (0, _eventJs.Emitter)());
        this.onCancel = this._onCancel.event;
        this._editor = editor;
        this._extractLineNumberFromMouseEvent = opts?.extractLineNumberFromMouseEvent ?? ((e)=>e.target.position ? e.target.position.lineNumber : 0);
        this._opts = createOptions(this._editor.getOption(78 /* EditorOption.multiCursorModifier */ ));
        this._lastMouseMoveEvent = null;
        this._hasTriggerKeyOnMouseDown = false;
        this._lineNumberOnMouseDown = 0;
        this._register(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(78 /* EditorOption.multiCursorModifier */ )) {
                const newOpts = createOptions(this._editor.getOption(78 /* EditorOption.multiCursorModifier */ ));
                if (this._opts.equals(newOpts)) return;
                this._opts = newOpts;
                this._lastMouseMoveEvent = null;
                this._hasTriggerKeyOnMouseDown = false;
                this._lineNumberOnMouseDown = 0;
                this._onCancel.fire();
            }
        }));
        this._register(this._editor.onMouseMove((e)=>this._onEditorMouseMove(new ClickLinkMouseEvent(e, this._opts))));
        this._register(this._editor.onMouseDown((e)=>this._onEditorMouseDown(new ClickLinkMouseEvent(e, this._opts))));
        this._register(this._editor.onMouseUp((e)=>this._onEditorMouseUp(new ClickLinkMouseEvent(e, this._opts))));
        this._register(this._editor.onKeyDown((e)=>this._onEditorKeyDown(new ClickLinkKeyboardEvent(e, this._opts))));
        this._register(this._editor.onKeyUp((e)=>this._onEditorKeyUp(new ClickLinkKeyboardEvent(e, this._opts))));
        this._register(this._editor.onMouseDrag(()=>this._resetHandler()));
        this._register(this._editor.onDidChangeCursorSelection((e)=>this._onDidChangeCursorSelection(e)));
        this._register(this._editor.onDidChangeModel((e)=>this._resetHandler()));
        this._register(this._editor.onDidChangeModelContent(()=>this._resetHandler()));
        this._register(this._editor.onDidScrollChange((e)=>{
            if (e.scrollTopChanged || e.scrollLeftChanged) this._resetHandler();
        }));
    }
    _onDidChangeCursorSelection(e) {
        if (e.selection && e.selection.startColumn !== e.selection.endColumn) this._resetHandler(); // immediately stop this feature if the user starts to select (https://github.com/microsoft/vscode/issues/7827)
    }
    _onEditorMouseMove(mouseEvent) {
        this._lastMouseMoveEvent = mouseEvent;
        this._onMouseMoveOrRelevantKeyDown.fire([
            mouseEvent,
            null
        ]);
    }
    _onEditorMouseDown(mouseEvent) {
        // We need to record if we had the trigger key on mouse down because someone might select something in the editor
        // holding the mouse down and then while mouse is down start to press Ctrl/Cmd to start a copy operation and then
        // release the mouse button without wanting to do the navigation.
        // With this flag we prevent goto definition if the mouse was down before the trigger key was pressed.
        this._hasTriggerKeyOnMouseDown = mouseEvent.hasTriggerModifier;
        this._lineNumberOnMouseDown = this._extractLineNumberFromMouseEvent(mouseEvent);
    }
    _onEditorMouseUp(mouseEvent) {
        const currentLineNumber = this._extractLineNumberFromMouseEvent(mouseEvent);
        if (this._hasTriggerKeyOnMouseDown && this._lineNumberOnMouseDown && this._lineNumberOnMouseDown === currentLineNumber) this._onExecute.fire(mouseEvent);
    }
    _onEditorKeyDown(e) {
        if (this._lastMouseMoveEvent && (e.keyCodeIsTriggerKey // User just pressed Ctrl/Cmd (normal goto definition)
         || e.keyCodeIsSideBySideKey && e.hasTriggerModifier // User pressed Ctrl/Cmd+Alt (goto definition to the side)
        )) this._onMouseMoveOrRelevantKeyDown.fire([
            this._lastMouseMoveEvent,
            e
        ]);
        else if (e.hasTriggerModifier) this._onCancel.fire(); // remove decorations if user holds another key with ctrl/cmd to prevent accident goto declaration
    }
    _onEditorKeyUp(e) {
        if (e.keyCodeIsTriggerKey) this._onCancel.fire();
    }
    _resetHandler() {
        this._lastMouseMoveEvent = null;
        this._hasTriggerKeyOnMouseDown = false;
        this._onCancel.fire();
    }
}

},{"../../../../../base/common/event.js":"4Zi8b","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k6lDy":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlayHintAnchor", ()=>InlayHintAnchor);
parcelHelpers.export(exports, "InlayHintItem", ()=>InlayHintItem);
parcelHelpers.export(exports, "InlayHintsFragments", ()=>InlayHintsFragments);
parcelHelpers.export(exports, "asCommandLink", ()=>asCommandLink);
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _networkJs = require("../../../../base/common/network.js");
var _uriJs = require("../../../../base/common/uri.js");
class InlayHintAnchor {
    constructor(range, direction){
        this.range = range;
        this.direction = direction;
    }
}
class InlayHintItem {
    constructor(hint, anchor, provider){
        this.hint = hint;
        this.anchor = anchor;
        this.provider = provider;
        this._isResolved = false;
    }
    with(delta) {
        const result = new InlayHintItem(this.hint, delta.anchor, this.provider);
        result._isResolved = this._isResolved;
        result._currentResolve = this._currentResolve;
        return result;
    }
    async resolve(token) {
        if (typeof this.provider.resolveInlayHint !== "function") return;
        if (this._currentResolve) {
            // wait for an active resolve operation and try again
            // when that's done.
            await this._currentResolve;
            if (token.isCancellationRequested) return;
            return this.resolve(token);
        }
        if (!this._isResolved) this._currentResolve = this._doResolve(token).finally(()=>this._currentResolve = undefined);
        await this._currentResolve;
    }
    async _doResolve(token) {
        try {
            const newHint = await Promise.resolve(this.provider.resolveInlayHint(this.hint, token));
            this.hint.tooltip = newHint?.tooltip ?? this.hint.tooltip;
            this.hint.label = newHint?.label ?? this.hint.label;
            this.hint.textEdits = newHint?.textEdits ?? this.hint.textEdits;
            this._isResolved = true;
        } catch (err) {
            (0, _errorsJs.onUnexpectedExternalError)(err);
            this._isResolved = false;
        }
    }
}
class InlayHintsFragments {
    static{
        this._emptyInlayHintList = Object.freeze({
            dispose () {},
            hints: []
        });
    }
    static async create(registry, model, ranges, token) {
        const data = [];
        const promises = registry.ordered(model).reverse().map((provider)=>ranges.map(async (range)=>{
                try {
                    const result = await provider.provideInlayHints(model, range, token);
                    if (result?.hints.length || provider.onDidChangeInlayHints) data.push([
                        result ?? InlayHintsFragments._emptyInlayHintList,
                        provider
                    ]);
                } catch (err) {
                    (0, _errorsJs.onUnexpectedExternalError)(err);
                }
            }));
        await Promise.all(promises.flat());
        if (token.isCancellationRequested || model.isDisposed()) throw new (0, _errorsJs.CancellationError)();
        return new InlayHintsFragments(ranges, data, model);
    }
    constructor(ranges, data, model){
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this.ranges = ranges;
        this.provider = new Set();
        const items = [];
        for (const [list, provider] of data){
            this._disposables.add(list);
            this.provider.add(provider);
            for (const hint of list.hints){
                // compute the range to which the item should be attached to
                const position = model.validatePosition(hint.position);
                let direction = "before";
                const wordRange = InlayHintsFragments._getRangeAtPosition(model, position);
                let range;
                if (wordRange.getStartPosition().isBefore(position)) {
                    range = (0, _rangeJs.Range).fromPositions(wordRange.getStartPosition(), position);
                    direction = "after";
                } else {
                    range = (0, _rangeJs.Range).fromPositions(position, wordRange.getEndPosition());
                    direction = "before";
                }
                items.push(new InlayHintItem(hint, new InlayHintAnchor(range, direction), provider));
            }
        }
        this.items = items.sort((a, b)=>(0, _positionJs.Position).compare(a.hint.position, b.hint.position));
    }
    dispose() {
        this._disposables.dispose();
    }
    static _getRangeAtPosition(model, position) {
        const line = position.lineNumber;
        const word = model.getWordAtPosition(position);
        if (word) // always prefer the word range
        return new (0, _rangeJs.Range)(line, word.startColumn, line, word.endColumn);
        model.tokenization.tokenizeIfCheap(line);
        const tokens = model.tokenization.getLineTokens(line);
        const offset = position.column - 1;
        const idx = tokens.findTokenIndexAtOffset(offset);
        let start = tokens.getStartOffset(idx);
        let end = tokens.getEndOffset(idx);
        if (end - start === 1) {
            // single character token, when at its end try leading/trailing token instead
            if (start === offset && idx > 1) {
                // leading token
                start = tokens.getStartOffset(idx - 1);
                end = tokens.getEndOffset(idx - 1);
            } else if (end === offset && idx < tokens.getCount() - 1) {
                // trailing token
                start = tokens.getStartOffset(idx + 1);
                end = tokens.getEndOffset(idx + 1);
            }
        }
        return new (0, _rangeJs.Range)(line, start + 1, line, end + 1);
    }
}
function asCommandLink(command) {
    return (0, _uriJs.URI).from({
        scheme: (0, _networkJs.Schemas).command,
        path: command.id,
        query: command.arguments && encodeURIComponent(JSON.stringify(command.arguments))
    }).toString();
}

},{"../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../../base/common/network.js":"2c1AD","../../../../base/common/uri.js":"7qGS3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"04F32":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "showGoToContextMenu", ()=>showGoToContextMenu);
parcelHelpers.export(exports, "goToDefinitionWithLocation", ()=>goToDefinitionWithLocation);
var _domJs = require("../../../../base/browser/dom.js");
var _actionsJs = require("../../../../base/common/actions.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _uuidJs = require("../../../../base/common/uuid.js");
var _rangeJs = require("../../../common/core/range.js");
var _resolverServiceJs = require("../../../common/services/resolverService.js");
var _goToCommandsJs = require("../../gotoSymbol/browser/goToCommands.js");
var _peekViewJs = require("../../peekView/browser/peekView.js");
var _actionsJs1 = require("../../../../platform/actions/common/actions.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _contextViewJs = require("../../../../platform/contextview/browser/contextView.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
async function showGoToContextMenu(accessor, editor, anchor, part) {
    const resolverService = accessor.get((0, _resolverServiceJs.ITextModelService));
    const contextMenuService = accessor.get((0, _contextViewJs.IContextMenuService));
    const commandService = accessor.get((0, _commandsJs.ICommandService));
    const instaService = accessor.get((0, _instantiationJs.IInstantiationService));
    const notificationService = accessor.get((0, _notificationJs.INotificationService));
    await part.item.resolve((0, _cancellationJs.CancellationToken).None);
    if (!part.part.location) return;
    const location = part.part.location;
    const menuActions = [];
    // from all registered (not active) context menu actions select those
    // that are a symbol navigation actions
    const filter = new Set((0, _actionsJs1.MenuRegistry).getMenuItems((0, _actionsJs1.MenuId).EditorContext).map((item)=>(0, _actionsJs1.isIMenuItem)(item) ? item.command.id : (0, _uuidJs.generateUuid)()));
    for (const delegate of (0, _goToCommandsJs.SymbolNavigationAction).all())if (filter.has(delegate.desc.id)) menuActions.push(new (0, _actionsJs.Action)(delegate.desc.id, (0, _actionsJs1.MenuItemAction).label(delegate.desc, {
        renderShortTitle: true
    }), undefined, true, async ()=>{
        const ref = await resolverService.createModelReference(location.uri);
        try {
            const symbolAnchor = new (0, _goToCommandsJs.SymbolNavigationAnchor)(ref.object.textEditorModel, (0, _rangeJs.Range).getStartPosition(location.range));
            const range = part.item.anchor.range;
            await instaService.invokeFunction(delegate.runEditorCommand.bind(delegate), editor, symbolAnchor, range);
        } finally{
            ref.dispose();
        }
    }));
    if (part.part.command) {
        const { command } = part.part;
        menuActions.push(new (0, _actionsJs.Separator)());
        menuActions.push(new (0, _actionsJs.Action)(command.id, command.title, undefined, true, async ()=>{
            try {
                await commandService.executeCommand(command.id, ...command.arguments ?? []);
            } catch (err) {
                notificationService.notify({
                    severity: (0, _notificationJs.Severity).Error,
                    source: part.item.provider.displayName,
                    message: err
                });
            }
        }));
    }
    // show context menu
    const useShadowDOM = editor.getOption(128 /* EditorOption.useShadowDOM */ );
    contextMenuService.showContextMenu({
        domForShadowRoot: useShadowDOM ? editor.getDomNode() ?? undefined : undefined,
        getAnchor: ()=>{
            const box = _domJs.getDomNodePagePosition(anchor);
            return {
                x: box.left,
                y: box.top + box.height + 8
            };
        },
        getActions: ()=>menuActions,
        onHide: ()=>{
            editor.focus();
        },
        autoSelectFirstItem: true
    });
}
async function goToDefinitionWithLocation(accessor, event, editor, location) {
    const resolverService = accessor.get((0, _resolverServiceJs.ITextModelService));
    const ref = await resolverService.createModelReference(location.uri);
    await editor.invokeWithinContext(async (accessor)=>{
        const openToSide = event.hasSideBySideModifier;
        const contextKeyService = accessor.get((0, _contextkeyJs.IContextKeyService));
        const isInPeek = (0, _peekViewJs.PeekContext).inPeekEditor.getValue(contextKeyService);
        const canPeek = !openToSide && editor.getOption(89 /* EditorOption.definitionLinkOpensInPeek */ ) && !isInPeek;
        const action = new (0, _goToCommandsJs.DefinitionAction)({
            openToSide,
            openInPeek: canPeek,
            muteMessage: true
        }, {
            title: {
                value: "",
                original: ""
            },
            id: "",
            precondition: undefined
        });
        return action.run(accessor, new (0, _goToCommandsJs.SymbolNavigationAnchor)(ref.object.textEditorModel, (0, _rangeJs.Range).getStartPosition(location.range)), (0, _rangeJs.Range).lift(location.range));
    });
    ref.dispose();
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/actions.js":"5GjLb","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/uuid.js":"g8HjT","../../../common/core/range.js":"jmUPh","../../../common/services/resolverService.js":"ezAtF","../../gotoSymbol/browser/goToCommands.js":"jkumD","../../peekView/browser/peekView.js":"jfvYD","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/contextview/browser/contextView.js":"2QlUR","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/notification/common/notification.js":"igv0W","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jkumD":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SymbolNavigationAnchor", ()=>SymbolNavigationAnchor);
parcelHelpers.export(exports, "SymbolNavigationAction", ()=>SymbolNavigationAction);
//#region --- DEFINITION
parcelHelpers.export(exports, "DefinitionAction", ()=>DefinitionAction);
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var _asyncJs = require("../../../../base/common/async.js");
var _keyCodesJs = require("../../../../base/common/keyCodes.js");
var _typesJs = require("../../../../base/common/types.js");
var _uriJs = require("../../../../base/common/uri.js");
var _editorStateJs = require("../../editorState/browser/editorState.js");
var _editorBrowserJs = require("../../../browser/editorBrowser.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _embeddedCodeEditorWidgetJs = require("../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _languagesJs = require("../../../common/languages.js");
var _referencesControllerJs = require("./peek/referencesController.js");
var _referencesModelJs = require("./referencesModel.js");
var _symbolNavigationJs = require("./symbolNavigation.js");
var _messageControllerJs = require("../../message/browser/messageController.js");
var _peekViewJs = require("../../peekView/browser/peekView.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var _progressJs = require("../../../../platform/progress/common/progress.js");
var _goToSymbolJs = require("./goToSymbol.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _iteratorJs = require("../../../../base/common/iterator.js");
var _contextkeysJs = require("../../../../platform/contextkey/common/contextkeys.js");
(0, _actionsJs.MenuRegistry).appendMenuItem((0, _actionsJs.MenuId).EditorContext, {
    submenu: (0, _actionsJs.MenuId).EditorContextPeek,
    title: _nlsJs.localize("peek.submenu", "Peek"),
    group: "navigation",
    order: 100
});
class SymbolNavigationAnchor {
    static is(thing) {
        if (!thing || typeof thing !== "object") return false;
        if (thing instanceof SymbolNavigationAnchor) return true;
        if (_positionJs.Position.isIPosition(thing.position) && thing.model) return true;
        return false;
    }
    constructor(model, position){
        this.model = model;
        this.position = position;
    }
}
class SymbolNavigationAction extends (0, _editorExtensionsJs.EditorAction2) {
    static{
        this._allSymbolNavigationCommands = new Map();
    }
    static{
        this._activeAlternativeCommands = new Set();
    }
    static all() {
        return SymbolNavigationAction._allSymbolNavigationCommands.values();
    }
    static _patchConfig(opts) {
        const result = {
            ...opts,
            f1: true
        };
        // patch context menu when clause
        if (result.menu) {
            for (const item of (0, _iteratorJs.Iterable).wrap(result.menu))if (item.id === (0, _actionsJs.MenuId).EditorContext || item.id === (0, _actionsJs.MenuId).EditorContextPeek) item.when = (0, _contextkeyJs.ContextKeyExpr).and(opts.precondition, item.when);
        }
        return result;
    }
    constructor(configuration, opts){
        super(SymbolNavigationAction._patchConfig(opts));
        this.configuration = configuration;
        SymbolNavigationAction._allSymbolNavigationCommands.set(opts.id, this);
    }
    runEditorCommand(accessor, editor, arg, range) {
        if (!editor.hasModel()) return Promise.resolve(undefined);
        const notificationService = accessor.get((0, _notificationJs.INotificationService));
        const editorService = accessor.get((0, _codeEditorServiceJs.ICodeEditorService));
        const progressService = accessor.get((0, _progressJs.IEditorProgressService));
        const symbolNavService = accessor.get((0, _symbolNavigationJs.ISymbolNavigationService));
        const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
        const instaService = accessor.get((0, _instantiationJs.IInstantiationService));
        const model = editor.getModel();
        const position = editor.getPosition();
        const anchor = SymbolNavigationAnchor.is(arg) ? arg : new SymbolNavigationAnchor(model, position);
        const cts = new (0, _editorStateJs.EditorStateCancellationTokenSource)(editor, 5 /* CodeEditorStateFlag.Position */ );
        const promise = (0, _asyncJs.raceCancellation)(this._getLocationModel(languageFeaturesService, anchor.model, anchor.position, cts.token), cts.token).then(async (references)=>{
            if (!references || cts.token.isCancellationRequested) return;
            (0, _ariaJs.alert)(references.ariaMessage);
            let altAction;
            if (references.referenceAt(model.uri, position)) {
                const altActionId = this._getAlternativeCommand(editor);
                if (!SymbolNavigationAction._activeAlternativeCommands.has(altActionId) && SymbolNavigationAction._allSymbolNavigationCommands.has(altActionId)) altAction = SymbolNavigationAction._allSymbolNavigationCommands.get(altActionId);
            }
            const referenceCount = references.references.length;
            if (referenceCount === 0) // no result -> show message
            {
                if (!this.configuration.muteMessage) {
                    const info = model.getWordAtPosition(position);
                    (0, _messageControllerJs.MessageController).get(editor)?.showMessage(this._getNoResultFoundMessage(info), position);
                }
            } else if (referenceCount === 1 && altAction) {
                // already at the only result, run alternative
                SymbolNavigationAction._activeAlternativeCommands.add(this.desc.id);
                instaService.invokeFunction((accessor)=>altAction.runEditorCommand(accessor, editor, arg, range).finally(()=>{
                        SymbolNavigationAction._activeAlternativeCommands.delete(this.desc.id);
                    }));
            } else // normal results handling
            return this._onResult(editorService, symbolNavService, editor, references, range);
        }, (err)=>{
            // report an error
            notificationService.error(err);
        }).finally(()=>{
            cts.dispose();
        });
        progressService.showWhile(promise, 250);
        return promise;
    }
    async _onResult(editorService, symbolNavService, editor, model, range) {
        const gotoLocation = this._getGoToPreference(editor);
        if (!(editor instanceof (0, _embeddedCodeEditorWidgetJs.EmbeddedCodeEditorWidget)) && (this.configuration.openInPeek || gotoLocation === "peek" && model.references.length > 1)) this._openInPeek(editor, model, range);
        else {
            const next = model.firstReference();
            const peek = model.references.length > 1 && gotoLocation === "gotoAndPeek";
            const targetEditor = await this._openReference(editor, editorService, next, this.configuration.openToSide, !peek);
            if (peek && targetEditor) this._openInPeek(targetEditor, model, range);
            else model.dispose();
            // keep remaining locations around when using
            // 'goto'-mode
            if (gotoLocation === "goto") symbolNavService.put(next);
        }
    }
    async _openReference(editor, editorService, reference, sideBySide, highlight) {
        // range is the target-selection-range when we have one
        // and the fallback is the 'full' range
        let range = undefined;
        if ((0, _languagesJs.isLocationLink)(reference)) range = reference.targetSelectionRange;
        if (!range) range = reference.range;
        if (!range) return undefined;
        const targetEditor = await editorService.openCodeEditor({
            resource: reference.uri,
            options: {
                selection: (0, _rangeJs.Range).collapseToStart(range),
                selectionRevealType: 3 /* TextEditorSelectionRevealType.NearTopIfOutsideViewport */ ,
                selectionSource: "code.jump" /* TextEditorSelectionSource.JUMP */ 
            }
        }, editor, sideBySide);
        if (!targetEditor) return undefined;
        if (highlight) {
            const modelNow = targetEditor.getModel();
            const decorations = targetEditor.createDecorationsCollection([
                {
                    range,
                    options: {
                        description: "symbol-navigate-action-highlight",
                        className: "symbolHighlight"
                    }
                }
            ]);
            setTimeout(()=>{
                if (targetEditor.getModel() === modelNow) decorations.clear();
            }, 350);
        }
        return targetEditor;
    }
    _openInPeek(target, model, range) {
        const controller = (0, _referencesControllerJs.ReferencesController).get(target);
        if (controller && target.hasModel()) controller.toggleWidget(range ?? target.getSelection(), (0, _asyncJs.createCancelablePromise)((_)=>Promise.resolve(model)), this.configuration.openInPeek);
        else model.dispose();
    }
}
class DefinitionAction extends SymbolNavigationAction {
    async _getLocationModel(languageFeaturesService, model, position, token) {
        return new (0, _referencesModelJs.ReferencesModel)(await (0, _goToSymbolJs.getDefinitionsAtPosition)(languageFeaturesService.definitionProvider, model, position, false, token), _nlsJs.localize("def.title", "Definitions"));
    }
    _getNoResultFoundMessage(info) {
        return info && info.word ? _nlsJs.localize("noResultWord", "No definition found for '{0}'", info.word) : _nlsJs.localize("generic.noResults", "No definition found");
    }
    _getAlternativeCommand(editor) {
        return editor.getOption(58 /* EditorOption.gotoLocation */ ).alternativeDefinitionCommand;
    }
    _getGoToPreference(editor) {
        return editor.getOption(58 /* EditorOption.gotoLocation */ ).multipleDefinitions;
    }
}
(0, _actionsJs.registerAction2)(class GoToDefinitionAction extends DefinitionAction {
    static{
        this.id = "editor.action.revealDefinition";
    }
    constructor(){
        super({
            openToSide: false,
            openInPeek: false,
            muteMessage: false
        }, {
            id: GoToDefinitionAction.id,
            title: {
                ..._nlsJs.localize2("actions.goToDecl.label", "Go to Definition"),
                mnemonicTitle: _nlsJs.localize({
                    key: "miGotoDefinition",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Go to &&Definition")
            },
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hasDefinitionProvider,
            keybinding: [
                {
                    when: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                    primary: 70 /* KeyCode.F12 */ ,
                    weight: 100 /* KeybindingWeight.EditorContrib */ 
                },
                {
                    when: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).editorTextFocus, (0, _contextkeysJs.IsWebContext)),
                    primary: 2118 /* KeyCode.F12 */ ,
                    weight: 100 /* KeybindingWeight.EditorContrib */ 
                }
            ],
            menu: [
                {
                    id: (0, _actionsJs.MenuId).EditorContext,
                    group: "navigation",
                    order: 1.1
                },
                {
                    id: (0, _actionsJs.MenuId).MenubarGoMenu,
                    precondition: null,
                    group: "4_symbol_nav",
                    order: 2
                }
            ]
        });
        (0, _commandsJs.CommandsRegistry).registerCommandAlias("editor.action.goToDeclaration", GoToDefinitionAction.id);
    }
});
(0, _actionsJs.registerAction2)(class OpenDefinitionToSideAction extends DefinitionAction {
    static{
        this.id = "editor.action.revealDefinitionAside";
    }
    constructor(){
        super({
            openToSide: true,
            openInPeek: false,
            muteMessage: false
        }, {
            id: OpenDefinitionToSideAction.id,
            title: _nlsJs.localize2("actions.goToDeclToSide.label", "Open Definition to the Side"),
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).hasDefinitionProvider, (0, _editorContextKeysJs.EditorContextKeys).isInEmbeddedEditor.toNegated()),
            keybinding: [
                {
                    when: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                    primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 70 /* KeyCode.F12 */ ),
                    weight: 100 /* KeybindingWeight.EditorContrib */ 
                },
                {
                    when: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).editorTextFocus, (0, _contextkeysJs.IsWebContext)),
                    primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2118 /* KeyCode.F12 */ ),
                    weight: 100 /* KeybindingWeight.EditorContrib */ 
                }
            ]
        });
        (0, _commandsJs.CommandsRegistry).registerCommandAlias("editor.action.openDeclarationToTheSide", OpenDefinitionToSideAction.id);
    }
});
(0, _actionsJs.registerAction2)(class PeekDefinitionAction extends DefinitionAction {
    static{
        this.id = "editor.action.peekDefinition";
    }
    constructor(){
        super({
            openToSide: false,
            openInPeek: true,
            muteMessage: false
        }, {
            id: PeekDefinitionAction.id,
            title: _nlsJs.localize2("actions.previewDecl.label", "Peek Definition"),
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).hasDefinitionProvider, (0, _peekViewJs.PeekContext).notInPeekEditor, (0, _editorContextKeysJs.EditorContextKeys).isInEmbeddedEditor.toNegated()),
            keybinding: {
                when: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 582 /* KeyCode.F12 */ ,
                linux: {
                    primary: 3140 /* KeyCode.F10 */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menu: {
                id: (0, _actionsJs.MenuId).EditorContextPeek,
                group: "peek",
                order: 2
            }
        });
        (0, _commandsJs.CommandsRegistry).registerCommandAlias("editor.action.previewDeclaration", PeekDefinitionAction.id);
    }
});
//#endregion
//#region --- DECLARATION
class DeclarationAction extends SymbolNavigationAction {
    async _getLocationModel(languageFeaturesService, model, position, token) {
        return new (0, _referencesModelJs.ReferencesModel)(await (0, _goToSymbolJs.getDeclarationsAtPosition)(languageFeaturesService.declarationProvider, model, position, false, token), _nlsJs.localize("decl.title", "Declarations"));
    }
    _getNoResultFoundMessage(info) {
        return info && info.word ? _nlsJs.localize("decl.noResultWord", "No declaration found for '{0}'", info.word) : _nlsJs.localize("decl.generic.noResults", "No declaration found");
    }
    _getAlternativeCommand(editor) {
        return editor.getOption(58 /* EditorOption.gotoLocation */ ).alternativeDeclarationCommand;
    }
    _getGoToPreference(editor) {
        return editor.getOption(58 /* EditorOption.gotoLocation */ ).multipleDeclarations;
    }
}
(0, _actionsJs.registerAction2)(class GoToDeclarationAction extends DeclarationAction {
    static{
        this.id = "editor.action.revealDeclaration";
    }
    constructor(){
        super({
            openToSide: false,
            openInPeek: false,
            muteMessage: false
        }, {
            id: GoToDeclarationAction.id,
            title: {
                ..._nlsJs.localize2("actions.goToDeclaration.label", "Go to Declaration"),
                mnemonicTitle: _nlsJs.localize({
                    key: "miGotoDeclaration",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Go to &&Declaration")
            },
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).hasDeclarationProvider, (0, _editorContextKeysJs.EditorContextKeys).isInEmbeddedEditor.toNegated()),
            menu: [
                {
                    id: (0, _actionsJs.MenuId).EditorContext,
                    group: "navigation",
                    order: 1.3
                },
                {
                    id: (0, _actionsJs.MenuId).MenubarGoMenu,
                    precondition: null,
                    group: "4_symbol_nav",
                    order: 3
                }
            ]
        });
    }
    _getNoResultFoundMessage(info) {
        return info && info.word ? _nlsJs.localize("decl.noResultWord", "No declaration found for '{0}'", info.word) : _nlsJs.localize("decl.generic.noResults", "No declaration found");
    }
});
(0, _actionsJs.registerAction2)(class PeekDeclarationAction extends DeclarationAction {
    constructor(){
        super({
            openToSide: false,
            openInPeek: true,
            muteMessage: false
        }, {
            id: "editor.action.peekDeclaration",
            title: _nlsJs.localize2("actions.peekDecl.label", "Peek Declaration"),
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).hasDeclarationProvider, (0, _peekViewJs.PeekContext).notInPeekEditor, (0, _editorContextKeysJs.EditorContextKeys).isInEmbeddedEditor.toNegated()),
            menu: {
                id: (0, _actionsJs.MenuId).EditorContextPeek,
                group: "peek",
                order: 3
            }
        });
    }
});
//#endregion
//#region --- TYPE DEFINITION
class TypeDefinitionAction extends SymbolNavigationAction {
    async _getLocationModel(languageFeaturesService, model, position, token) {
        return new (0, _referencesModelJs.ReferencesModel)(await (0, _goToSymbolJs.getTypeDefinitionsAtPosition)(languageFeaturesService.typeDefinitionProvider, model, position, false, token), _nlsJs.localize("typedef.title", "Type Definitions"));
    }
    _getNoResultFoundMessage(info) {
        return info && info.word ? _nlsJs.localize("goToTypeDefinition.noResultWord", "No type definition found for '{0}'", info.word) : _nlsJs.localize("goToTypeDefinition.generic.noResults", "No type definition found");
    }
    _getAlternativeCommand(editor) {
        return editor.getOption(58 /* EditorOption.gotoLocation */ ).alternativeTypeDefinitionCommand;
    }
    _getGoToPreference(editor) {
        return editor.getOption(58 /* EditorOption.gotoLocation */ ).multipleTypeDefinitions;
    }
}
(0, _actionsJs.registerAction2)(class GoToTypeDefinitionAction extends TypeDefinitionAction {
    static{
        this.ID = "editor.action.goToTypeDefinition";
    }
    constructor(){
        super({
            openToSide: false,
            openInPeek: false,
            muteMessage: false
        }, {
            id: GoToTypeDefinitionAction.ID,
            title: {
                ..._nlsJs.localize2("actions.goToTypeDefinition.label", "Go to Type Definition"),
                mnemonicTitle: _nlsJs.localize({
                    key: "miGotoTypeDefinition",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Go to &&Type Definition")
            },
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hasTypeDefinitionProvider,
            keybinding: {
                when: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 0,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menu: [
                {
                    id: (0, _actionsJs.MenuId).EditorContext,
                    group: "navigation",
                    order: 1.4
                },
                {
                    id: (0, _actionsJs.MenuId).MenubarGoMenu,
                    precondition: null,
                    group: "4_symbol_nav",
                    order: 3
                }
            ]
        });
    }
});
(0, _actionsJs.registerAction2)(class PeekTypeDefinitionAction extends TypeDefinitionAction {
    static{
        this.ID = "editor.action.peekTypeDefinition";
    }
    constructor(){
        super({
            openToSide: false,
            openInPeek: true,
            muteMessage: false
        }, {
            id: PeekTypeDefinitionAction.ID,
            title: _nlsJs.localize2("actions.peekTypeDefinition.label", "Peek Type Definition"),
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).hasTypeDefinitionProvider, (0, _peekViewJs.PeekContext).notInPeekEditor, (0, _editorContextKeysJs.EditorContextKeys).isInEmbeddedEditor.toNegated()),
            menu: {
                id: (0, _actionsJs.MenuId).EditorContextPeek,
                group: "peek",
                order: 4
            }
        });
    }
});
//#endregion
//#region --- IMPLEMENTATION
class ImplementationAction extends SymbolNavigationAction {
    async _getLocationModel(languageFeaturesService, model, position, token) {
        return new (0, _referencesModelJs.ReferencesModel)(await (0, _goToSymbolJs.getImplementationsAtPosition)(languageFeaturesService.implementationProvider, model, position, false, token), _nlsJs.localize("impl.title", "Implementations"));
    }
    _getNoResultFoundMessage(info) {
        return info && info.word ? _nlsJs.localize("goToImplementation.noResultWord", "No implementation found for '{0}'", info.word) : _nlsJs.localize("goToImplementation.generic.noResults", "No implementation found");
    }
    _getAlternativeCommand(editor) {
        return editor.getOption(58 /* EditorOption.gotoLocation */ ).alternativeImplementationCommand;
    }
    _getGoToPreference(editor) {
        return editor.getOption(58 /* EditorOption.gotoLocation */ ).multipleImplementations;
    }
}
(0, _actionsJs.registerAction2)(class GoToImplementationAction extends ImplementationAction {
    static{
        this.ID = "editor.action.goToImplementation";
    }
    constructor(){
        super({
            openToSide: false,
            openInPeek: false,
            muteMessage: false
        }, {
            id: GoToImplementationAction.ID,
            title: {
                ..._nlsJs.localize2("actions.goToImplementation.label", "Go to Implementations"),
                mnemonicTitle: _nlsJs.localize({
                    key: "miGotoImplementation",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Go to &&Implementations")
            },
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hasImplementationProvider,
            keybinding: {
                when: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 2118 /* KeyCode.F12 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menu: [
                {
                    id: (0, _actionsJs.MenuId).EditorContext,
                    group: "navigation",
                    order: 1.45
                },
                {
                    id: (0, _actionsJs.MenuId).MenubarGoMenu,
                    precondition: null,
                    group: "4_symbol_nav",
                    order: 4
                }
            ]
        });
    }
});
(0, _actionsJs.registerAction2)(class PeekImplementationAction extends ImplementationAction {
    static{
        this.ID = "editor.action.peekImplementation";
    }
    constructor(){
        super({
            openToSide: false,
            openInPeek: true,
            muteMessage: false
        }, {
            id: PeekImplementationAction.ID,
            title: _nlsJs.localize2("actions.peekImplementation.label", "Peek Implementations"),
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).hasImplementationProvider, (0, _peekViewJs.PeekContext).notInPeekEditor, (0, _editorContextKeysJs.EditorContextKeys).isInEmbeddedEditor.toNegated()),
            keybinding: {
                when: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 3142 /* KeyCode.F12 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menu: {
                id: (0, _actionsJs.MenuId).EditorContextPeek,
                group: "peek",
                order: 5
            }
        });
    }
});
//#endregion
//#region --- REFERENCES
class ReferencesAction extends SymbolNavigationAction {
    _getNoResultFoundMessage(info) {
        return info ? _nlsJs.localize("references.no", "No references found for '{0}'", info.word) : _nlsJs.localize("references.noGeneric", "No references found");
    }
    _getAlternativeCommand(editor) {
        return editor.getOption(58 /* EditorOption.gotoLocation */ ).alternativeReferenceCommand;
    }
    _getGoToPreference(editor) {
        return editor.getOption(58 /* EditorOption.gotoLocation */ ).multipleReferences;
    }
}
(0, _actionsJs.registerAction2)(class GoToReferencesAction extends ReferencesAction {
    constructor(){
        super({
            openToSide: false,
            openInPeek: false,
            muteMessage: false
        }, {
            id: "editor.action.goToReferences",
            title: {
                ..._nlsJs.localize2("goToReferences.label", "Go to References"),
                mnemonicTitle: _nlsJs.localize({
                    key: "miGotoReference",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Go to &&References")
            },
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).hasReferenceProvider, (0, _peekViewJs.PeekContext).notInPeekEditor, (0, _editorContextKeysJs.EditorContextKeys).isInEmbeddedEditor.toNegated()),
            keybinding: {
                when: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 1094 /* KeyCode.F12 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menu: [
                {
                    id: (0, _actionsJs.MenuId).EditorContext,
                    group: "navigation",
                    order: 1.45
                },
                {
                    id: (0, _actionsJs.MenuId).MenubarGoMenu,
                    precondition: null,
                    group: "4_symbol_nav",
                    order: 5
                }
            ]
        });
    }
    async _getLocationModel(languageFeaturesService, model, position, token) {
        return new (0, _referencesModelJs.ReferencesModel)(await (0, _goToSymbolJs.getReferencesAtPosition)(languageFeaturesService.referenceProvider, model, position, true, false, token), _nlsJs.localize("ref.title", "References"));
    }
});
(0, _actionsJs.registerAction2)(class PeekReferencesAction extends ReferencesAction {
    constructor(){
        super({
            openToSide: false,
            openInPeek: true,
            muteMessage: false
        }, {
            id: "editor.action.referenceSearch.trigger",
            title: _nlsJs.localize2("references.action.label", "Peek References"),
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).hasReferenceProvider, (0, _peekViewJs.PeekContext).notInPeekEditor, (0, _editorContextKeysJs.EditorContextKeys).isInEmbeddedEditor.toNegated()),
            menu: {
                id: (0, _actionsJs.MenuId).EditorContextPeek,
                group: "peek",
                order: 6
            }
        });
    }
    async _getLocationModel(languageFeaturesService, model, position, token) {
        return new (0, _referencesModelJs.ReferencesModel)(await (0, _goToSymbolJs.getReferencesAtPosition)(languageFeaturesService.referenceProvider, model, position, false, false, token), _nlsJs.localize("ref.title", "References"));
    }
});
//#endregion
//#region --- GENERIC goto symbols command
class GenericGoToLocationAction extends SymbolNavigationAction {
    constructor(config, _references, _gotoMultipleBehaviour){
        super(config, {
            id: "editor.action.goToLocation",
            title: _nlsJs.localize2("label.generic", "Go to Any Symbol"),
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _peekViewJs.PeekContext).notInPeekEditor, (0, _editorContextKeysJs.EditorContextKeys).isInEmbeddedEditor.toNegated())
        });
        this._references = _references;
        this._gotoMultipleBehaviour = _gotoMultipleBehaviour;
    }
    async _getLocationModel(languageFeaturesService, _model, _position, _token) {
        return new (0, _referencesModelJs.ReferencesModel)(this._references, _nlsJs.localize("generic.title", "Locations"));
    }
    _getNoResultFoundMessage(info) {
        return info && _nlsJs.localize("generic.noResult", "No results for '{0}'", info.word) || "";
    }
    _getGoToPreference(editor) {
        return this._gotoMultipleBehaviour ?? editor.getOption(58 /* EditorOption.gotoLocation */ ).multipleReferences;
    }
    _getAlternativeCommand() {
        return "";
    }
}
(0, _commandsJs.CommandsRegistry).registerCommand({
    id: "editor.action.goToLocations",
    metadata: {
        description: "Go to locations from a position in a file",
        args: [
            {
                name: "uri",
                description: "The text document in which to start",
                constraint: (0, _uriJs.URI)
            },
            {
                name: "position",
                description: "The position at which to start",
                constraint: _positionJs.Position.isIPosition
            },
            {
                name: "locations",
                description: "An array of locations.",
                constraint: Array
            },
            {
                name: "multiple",
                description: "Define what to do when having multiple results, either `peek`, `gotoAndPeek`, or `goto`"
            },
            {
                name: "noResultsMessage",
                description: "Human readable message that shows when locations is empty."
            }
        ]
    },
    handler: async (accessor, resource, position, references, multiple, noResultsMessage, openInPeek)=>{
        (0, _typesJs.assertType)((0, _uriJs.URI).isUri(resource));
        (0, _typesJs.assertType)(_positionJs.Position.isIPosition(position));
        (0, _typesJs.assertType)(Array.isArray(references));
        (0, _typesJs.assertType)(typeof multiple === "undefined" || typeof multiple === "string");
        (0, _typesJs.assertType)(typeof openInPeek === "undefined" || typeof openInPeek === "boolean");
        const editorService = accessor.get((0, _codeEditorServiceJs.ICodeEditorService));
        const editor = await editorService.openCodeEditor({
            resource
        }, editorService.getFocusedCodeEditor());
        if ((0, _editorBrowserJs.isCodeEditor)(editor)) {
            editor.setPosition(position);
            editor.revealPositionInCenterIfOutsideViewport(position, 0 /* ScrollType.Smooth */ );
            return editor.invokeWithinContext((accessor)=>{
                const command = new class extends GenericGoToLocationAction {
                    _getNoResultFoundMessage(info) {
                        return noResultsMessage || super._getNoResultFoundMessage(info);
                    }
                }({
                    muteMessage: !Boolean(noResultsMessage),
                    openInPeek: Boolean(openInPeek),
                    openToSide: false
                }, references, multiple);
                accessor.get((0, _instantiationJs.IInstantiationService)).invokeFunction(command.run.bind(command), editor);
            });
        }
    }
});
(0, _commandsJs.CommandsRegistry).registerCommand({
    id: "editor.action.peekLocations",
    metadata: {
        description: "Peek locations from a position in a file",
        args: [
            {
                name: "uri",
                description: "The text document in which to start",
                constraint: (0, _uriJs.URI)
            },
            {
                name: "position",
                description: "The position at which to start",
                constraint: _positionJs.Position.isIPosition
            },
            {
                name: "locations",
                description: "An array of locations.",
                constraint: Array
            },
            {
                name: "multiple",
                description: "Define what to do when having multiple results, either `peek`, `gotoAndPeek`, or `goto`"
            }
        ]
    },
    handler: async (accessor, resource, position, references, multiple)=>{
        accessor.get((0, _commandsJs.ICommandService)).executeCommand("editor.action.goToLocations", resource, position, references, multiple, undefined, true);
    }
});
//#endregion
//#region --- REFERENCE search special commands
(0, _commandsJs.CommandsRegistry).registerCommand({
    id: "editor.action.findReferences",
    handler: (accessor, resource, position)=>{
        (0, _typesJs.assertType)((0, _uriJs.URI).isUri(resource));
        (0, _typesJs.assertType)(_positionJs.Position.isIPosition(position));
        const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
        const codeEditorService = accessor.get((0, _codeEditorServiceJs.ICodeEditorService));
        return codeEditorService.openCodeEditor({
            resource
        }, codeEditorService.getFocusedCodeEditor()).then((control)=>{
            if (!(0, _editorBrowserJs.isCodeEditor)(control) || !control.hasModel()) return undefined;
            const controller = (0, _referencesControllerJs.ReferencesController).get(control);
            if (!controller) return undefined;
            const references = (0, _asyncJs.createCancelablePromise)((token)=>(0, _goToSymbolJs.getReferencesAtPosition)(languageFeaturesService.referenceProvider, control.getModel(), _positionJs.Position.lift(position), false, false, token).then((references)=>new (0, _referencesModelJs.ReferencesModel)(references, _nlsJs.localize("ref.title", "References"))));
            const range = new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column);
            return Promise.resolve(controller.toggleWidget(range, references, false));
        });
    }
});
// use NEW command
(0, _commandsJs.CommandsRegistry).registerCommandAlias("editor.action.showReferences", "editor.action.peekLocations"); //#endregion

},{"../../../../base/browser/ui/aria/aria.js":"asrsh","../../../../base/common/async.js":"4GJc4","../../../../base/common/keyCodes.js":"bHiG9","../../../../base/common/types.js":"fb5yx","../../../../base/common/uri.js":"7qGS3","../../editorState/browser/editorState.js":"hyVHM","../../../browser/editorBrowser.js":"82sBe","../../../browser/editorExtensions.js":"kC3w6","../../../browser/services/codeEditorService.js":"bOWtl","../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js":"8G1ik","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/editorContextKeys.js":"5exv9","../../../common/languages.js":"g5n96","./peek/referencesController.js":"1Zi9g","./referencesModel.js":"789Jj","./symbolNavigation.js":"2TMSV","../../message/browser/messageController.js":"7FZE5","../../peekView/browser/peekView.js":"jfvYD","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/notification/common/notification.js":"igv0W","../../../../platform/progress/common/progress.js":"f49eD","./goToSymbol.js":"gz1YX","../../../common/services/languageFeatures.js":"2IAko","../../../../base/common/iterator.js":"2FiS0","../../../../platform/contextkey/common/contextkeys.js":"jqcbi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8G1ik":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmbeddedCodeEditorWidget", ()=>EmbeddedCodeEditorWidget);
var _objectsJs = require("../../../../base/common/objects.js");
var _codeEditorServiceJs = require("../../services/codeEditorService.js");
var _codeEditorWidgetJs = require("./codeEditorWidget.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _accessibilityJs = require("../../../../platform/accessibility/common/accessibility.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let EmbeddedCodeEditorWidget = class EmbeddedCodeEditorWidget extends (0, _codeEditorWidgetJs.CodeEditorWidget) {
    constructor(domElement, options, codeEditorWidgetOptions, parentEditor, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService, accessibilityService, languageConfigurationService, languageFeaturesService){
        super(domElement, {
            ...parentEditor.getRawOptions(),
            overflowWidgetsDomNode: parentEditor.getOverflowWidgetsDomNode()
        }, codeEditorWidgetOptions, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService, accessibilityService, languageConfigurationService, languageFeaturesService);
        this._parentEditor = parentEditor;
        this._overwriteOptions = options;
        // Overwrite parent's options
        super.updateOptions(this._overwriteOptions);
        this._register(parentEditor.onDidChangeConfiguration((e)=>this._onParentConfigurationChanged(e)));
    }
    getParentEditor() {
        return this._parentEditor;
    }
    _onParentConfigurationChanged(e) {
        super.updateOptions(this._parentEditor.getRawOptions());
        super.updateOptions(this._overwriteOptions);
    }
    updateOptions(newOptions) {
        _objectsJs.mixin(this._overwriteOptions, newOptions, true);
        super.updateOptions(this._overwriteOptions);
    }
};
EmbeddedCodeEditorWidget = __decorate([
    __param(4, (0, _instantiationJs.IInstantiationService)),
    __param(5, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(6, (0, _commandsJs.ICommandService)),
    __param(7, (0, _contextkeyJs.IContextKeyService)),
    __param(8, (0, _themeServiceJs.IThemeService)),
    __param(9, (0, _notificationJs.INotificationService)),
    __param(10, (0, _accessibilityJs.IAccessibilityService)),
    __param(11, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService)),
    __param(12, (0, _languageFeaturesJs.ILanguageFeaturesService))
], EmbeddedCodeEditorWidget);

},{"../../../../base/common/objects.js":"j84mT","../../services/codeEditorService.js":"bOWtl","./codeEditorWidget.js":"kFkuL","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../common/services/languageFeatures.js":"2IAko","../../../../platform/accessibility/common/accessibility.js":"9Svqy","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/notification/common/notification.js":"igv0W","../../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Zi9g":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ctxReferenceSearchVisible", ()=>ctxReferenceSearchVisible);
parcelHelpers.export(exports, "ReferencesController", ()=>ReferencesController);
var _asyncJs = require("../../../../../base/common/async.js");
var _errorsJs = require("../../../../../base/common/errors.js");
var _keyCodesJs = require("../../../../../base/common/keyCodes.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _codeEditorServiceJs = require("../../../../browser/services/codeEditorService.js");
var _positionJs = require("../../../../common/core/position.js");
var _rangeJs = require("../../../../common/core/range.js");
var _peekViewJs = require("../../../peekView/browser/peekView.js");
var _nlsJs = require("../../../../../nls.js");
var _commandsJs = require("../../../../../platform/commands/common/commands.js");
var _configurationJs = require("../../../../../platform/configuration/common/configuration.js");
var _contextkeyJs = require("../../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../../platform/instantiation/common/instantiation.js");
var _keybindingsRegistryJs = require("../../../../../platform/keybinding/common/keybindingsRegistry.js");
var _listServiceJs = require("../../../../../platform/list/browser/listService.js");
var _notificationJs = require("../../../../../platform/notification/common/notification.js");
var _storageJs = require("../../../../../platform/storage/common/storage.js");
var _referencesModelJs = require("../referencesModel.js");
var _referencesWidgetJs = require("./referencesWidget.js");
var _editorContextKeysJs = require("../../../../common/editorContextKeys.js");
var _contextkeysJs = require("../../../../../platform/contextkey/common/contextkeys.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var ReferencesController_1;
const ctxReferenceSearchVisible = new (0, _contextkeyJs.RawContextKey)("referenceSearchVisible", false, _nlsJs.localize("referenceSearchVisible", "Whether reference peek is visible, like 'Peek References' or 'Peek Definition'"));
let ReferencesController = class ReferencesController {
    static{
        ReferencesController_1 = this;
    }
    static{
        this.ID = "editor.contrib.referencesController";
    }
    static get(editor) {
        return editor.getContribution(ReferencesController_1.ID);
    }
    constructor(_defaultTreeKeyboardSupport, _editor, contextKeyService, _editorService, _notificationService, _instantiationService, _storageService, _configurationService){
        this._defaultTreeKeyboardSupport = _defaultTreeKeyboardSupport;
        this._editor = _editor;
        this._editorService = _editorService;
        this._notificationService = _notificationService;
        this._instantiationService = _instantiationService;
        this._storageService = _storageService;
        this._configurationService = _configurationService;
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._requestIdPool = 0;
        this._ignoreModelChangeEvent = false;
        this._referenceSearchVisible = ctxReferenceSearchVisible.bindTo(contextKeyService);
    }
    dispose() {
        this._referenceSearchVisible.reset();
        this._disposables.dispose();
        this._widget?.dispose();
        this._model?.dispose();
        this._widget = undefined;
        this._model = undefined;
    }
    toggleWidget(range, modelPromise, peekMode) {
        // close current widget and return early is position didn't change
        let widgetPosition;
        if (this._widget) widgetPosition = this._widget.position;
        this.closeWidget();
        if (!!widgetPosition && range.containsPosition(widgetPosition)) return;
        this._peekMode = peekMode;
        this._referenceSearchVisible.set(true);
        // close the widget on model/mode changes
        this._disposables.add(this._editor.onDidChangeModelLanguage(()=>{
            this.closeWidget();
        }));
        this._disposables.add(this._editor.onDidChangeModel(()=>{
            if (!this._ignoreModelChangeEvent) this.closeWidget();
        }));
        const storageKey = "peekViewLayout";
        const data = (0, _referencesWidgetJs.LayoutData).fromJSON(this._storageService.get(storageKey, 0 /* StorageScope.PROFILE */ , "{}"));
        this._widget = this._instantiationService.createInstance((0, _referencesWidgetJs.ReferenceWidget), this._editor, this._defaultTreeKeyboardSupport, data);
        this._widget.setTitle(_nlsJs.localize("labelLoading", "Loading..."));
        this._widget.show(range);
        this._disposables.add(this._widget.onDidClose(()=>{
            modelPromise.cancel();
            if (this._widget) {
                this._storageService.store(storageKey, JSON.stringify(this._widget.layoutData), 0 /* StorageScope.PROFILE */ , 1 /* StorageTarget.MACHINE */ );
                if (!this._widget.isClosing) // to prevent calling this too many times, check whether it was already closing.
                this.closeWidget();
                this._widget = undefined;
            } else this.closeWidget();
        }));
        this._disposables.add(this._widget.onDidSelectReference((event)=>{
            const { element, kind } = event;
            if (!element) return;
            switch(kind){
                case "open":
                    if (event.source !== "editor" || !this._configurationService.getValue("editor.stablePeek")) // when stable peek is configured we don't close
                    // the peek window on selecting the editor
                    this.openReference(element, false, false);
                    break;
                case "side":
                    this.openReference(element, true, false);
                    break;
                case "goto":
                    if (peekMode) this._gotoReference(element, true);
                    else this.openReference(element, false, true);
                    break;
            }
        }));
        const requestId = ++this._requestIdPool;
        modelPromise.then((model)=>{
            // still current request? widget still open?
            if (requestId !== this._requestIdPool || !this._widget) {
                model.dispose();
                return undefined;
            }
            this._model?.dispose();
            this._model = model;
            // show widget
            return this._widget.setModel(this._model).then(()=>{
                if (this._widget && this._model && this._editor.hasModel()) {
                    // set title
                    if (!this._model.isEmpty) this._widget.setMetaTitle(_nlsJs.localize("metaTitle.N", "{0} ({1})", this._model.title, this._model.references.length));
                    else this._widget.setMetaTitle("");
                    // set 'best' selection
                    const uri = this._editor.getModel().uri;
                    const pos = new (0, _positionJs.Position)(range.startLineNumber, range.startColumn);
                    const selection = this._model.nearestReference(uri, pos);
                    if (selection) return this._widget.setSelection(selection).then(()=>{
                        if (this._widget && this._editor.getOption(87 /* EditorOption.peekWidgetDefaultFocus */ ) === "editor") this._widget.focusOnPreviewEditor();
                    });
                }
                return undefined;
            });
        }, (error)=>{
            this._notificationService.error(error);
        });
    }
    changeFocusBetweenPreviewAndReferences() {
        if (!this._widget) // can be called while still resolving...
        return;
        if (this._widget.isPreviewEditorFocused()) this._widget.focusOnReferenceTree();
        else this._widget.focusOnPreviewEditor();
    }
    async goToNextOrPreviousReference(fwd) {
        if (!this._editor.hasModel() || !this._model || !this._widget) // can be called while still resolving...
        return;
        const currentPosition = this._widget.position;
        if (!currentPosition) return;
        const source = this._model.nearestReference(this._editor.getModel().uri, currentPosition);
        if (!source) return;
        const target = this._model.nextOrPreviousReference(source, fwd);
        const editorFocus = this._editor.hasTextFocus();
        const previewEditorFocus = this._widget.isPreviewEditorFocused();
        await this._widget.setSelection(target);
        await this._gotoReference(target, false);
        if (editorFocus) this._editor.focus();
        else if (this._widget && previewEditorFocus) this._widget.focusOnPreviewEditor();
    }
    async revealReference(reference) {
        if (!this._editor.hasModel() || !this._model || !this._widget) // can be called while still resolving...
        return;
        await this._widget.revealReference(reference);
    }
    closeWidget(focusEditor = true) {
        this._widget?.dispose();
        this._model?.dispose();
        this._referenceSearchVisible.reset();
        this._disposables.clear();
        this._widget = undefined;
        this._model = undefined;
        if (focusEditor) this._editor.focus();
        this._requestIdPool += 1; // Cancel pending requests
    }
    _gotoReference(ref, pinned) {
        this._widget?.hide();
        this._ignoreModelChangeEvent = true;
        const range = (0, _rangeJs.Range).lift(ref.range).collapseToStart();
        return this._editorService.openCodeEditor({
            resource: ref.uri,
            options: {
                selection: range,
                selectionSource: "code.jump" /* TextEditorSelectionSource.JUMP */ ,
                pinned
            }
        }, this._editor).then((openedEditor)=>{
            this._ignoreModelChangeEvent = false;
            if (!openedEditor || !this._widget) {
                // something went wrong...
                this.closeWidget();
                return;
            }
            if (this._editor === openedEditor) {
                //
                this._widget.show(range);
                this._widget.focusOnReferenceTree();
            } else {
                // we opened a different editor instance which means a different controller instance.
                // therefore we stop with this controller and continue with the other
                const other = ReferencesController_1.get(openedEditor);
                const model = this._model.clone();
                this.closeWidget();
                openedEditor.focus();
                other?.toggleWidget(range, (0, _asyncJs.createCancelablePromise)((_)=>Promise.resolve(model)), this._peekMode ?? false);
            }
        }, (err)=>{
            this._ignoreModelChangeEvent = false;
            (0, _errorsJs.onUnexpectedError)(err);
        });
    }
    openReference(ref, sideBySide, pinned) {
        // clear stage
        if (!sideBySide) this.closeWidget();
        const { uri, range } = ref;
        this._editorService.openCodeEditor({
            resource: uri,
            options: {
                selection: range,
                selectionSource: "code.jump" /* TextEditorSelectionSource.JUMP */ ,
                pinned
            }
        }, this._editor, sideBySide);
    }
};
ReferencesController = ReferencesController_1 = __decorate([
    __param(2, (0, _contextkeyJs.IContextKeyService)),
    __param(3, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(4, (0, _notificationJs.INotificationService)),
    __param(5, (0, _instantiationJs.IInstantiationService)),
    __param(6, (0, _storageJs.IStorageService)),
    __param(7, (0, _configurationJs.IConfigurationService))
], ReferencesController);
function withController(accessor, fn) {
    const outerEditor = (0, _peekViewJs.getOuterEditor)(accessor);
    if (!outerEditor) return;
    const controller = ReferencesController.get(outerEditor);
    if (controller) fn(controller);
}
(0, _keybindingsRegistryJs.KeybindingsRegistry).registerCommandAndKeybindingRule({
    id: "togglePeekWidgetFocus",
    weight: 100 /* KeybindingWeight.EditorContrib */ ,
    primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 60 /* KeyCode.F2 */ ),
    when: (0, _contextkeyJs.ContextKeyExpr).or(ctxReferenceSearchVisible, (0, _peekViewJs.PeekContext).inPeekEditor),
    handler (accessor) {
        withController(accessor, (controller)=>{
            controller.changeFocusBetweenPreviewAndReferences();
        });
    }
});
(0, _keybindingsRegistryJs.KeybindingsRegistry).registerCommandAndKeybindingRule({
    id: "goToNextReference",
    weight: 90,
    primary: 62 /* KeyCode.F4 */ ,
    secondary: [
        70 /* KeyCode.F12 */ 
    ],
    when: (0, _contextkeyJs.ContextKeyExpr).or(ctxReferenceSearchVisible, (0, _peekViewJs.PeekContext).inPeekEditor),
    handler (accessor) {
        withController(accessor, (controller)=>{
            controller.goToNextOrPreviousReference(true);
        });
    }
});
(0, _keybindingsRegistryJs.KeybindingsRegistry).registerCommandAndKeybindingRule({
    id: "goToPreviousReference",
    weight: 90,
    primary: 1086 /* KeyCode.F4 */ ,
    secondary: [
        1094 /* KeyCode.F12 */ 
    ],
    when: (0, _contextkeyJs.ContextKeyExpr).or(ctxReferenceSearchVisible, (0, _peekViewJs.PeekContext).inPeekEditor),
    handler (accessor) {
        withController(accessor, (controller)=>{
            controller.goToNextOrPreviousReference(false);
        });
    }
});
// commands that aren't needed anymore because there is now ContextKeyExpr.OR
(0, _commandsJs.CommandsRegistry).registerCommandAlias("goToNextReferenceFromEmbeddedEditor", "goToNextReference");
(0, _commandsJs.CommandsRegistry).registerCommandAlias("goToPreviousReferenceFromEmbeddedEditor", "goToPreviousReference");
// close
(0, _commandsJs.CommandsRegistry).registerCommandAlias("closeReferenceSearchEditor", "closeReferenceSearch");
(0, _commandsJs.CommandsRegistry).registerCommand("closeReferenceSearch", (accessor)=>withController(accessor, (controller)=>controller.closeWidget()));
(0, _keybindingsRegistryJs.KeybindingsRegistry).registerKeybindingRule({
    id: "closeReferenceSearch",
    weight: -1,
    primary: 9 /* KeyCode.Escape */ ,
    secondary: [
        1033 /* KeyCode.Escape */ 
    ],
    when: (0, _contextkeyJs.ContextKeyExpr).and((0, _peekViewJs.PeekContext).inPeekEditor, (0, _contextkeyJs.ContextKeyExpr).not("config.editor.stablePeek"))
});
(0, _keybindingsRegistryJs.KeybindingsRegistry).registerKeybindingRule({
    id: "closeReferenceSearch",
    weight: 250,
    primary: 9 /* KeyCode.Escape */ ,
    secondary: [
        1033 /* KeyCode.Escape */ 
    ],
    when: (0, _contextkeyJs.ContextKeyExpr).and(ctxReferenceSearchVisible, (0, _contextkeyJs.ContextKeyExpr).not("config.editor.stablePeek"), (0, _contextkeyJs.ContextKeyExpr).or((0, _editorContextKeysJs.EditorContextKeys).editorTextFocus, (0, _contextkeysJs.InputFocusedContext).negate()))
});
(0, _keybindingsRegistryJs.KeybindingsRegistry).registerCommandAndKeybindingRule({
    id: "revealReference",
    weight: 200 /* KeybindingWeight.WorkbenchContrib */ ,
    primary: 3 /* KeyCode.Enter */ ,
    mac: {
        primary: 3 /* KeyCode.Enter */ ,
        secondary: [
            2066 /* KeyCode.DownArrow */ 
        ]
    },
    when: (0, _contextkeyJs.ContextKeyExpr).and(ctxReferenceSearchVisible, (0, _listServiceJs.WorkbenchListFocusContextKey), (0, _listServiceJs.WorkbenchTreeElementCanCollapse).negate(), (0, _listServiceJs.WorkbenchTreeElementCanExpand).negate()),
    handler (accessor) {
        const listService = accessor.get((0, _listServiceJs.IListService));
        const focus = listService.lastFocusedList?.getFocus();
        if (Array.isArray(focus) && focus[0] instanceof (0, _referencesModelJs.OneReference)) withController(accessor, (controller)=>controller.revealReference(focus[0]));
    }
});
(0, _keybindingsRegistryJs.KeybindingsRegistry).registerCommandAndKeybindingRule({
    id: "openReferenceToSide",
    weight: 100 /* KeybindingWeight.EditorContrib */ ,
    primary: 2051 /* KeyCode.Enter */ ,
    mac: {
        primary: 259 /* KeyCode.Enter */ 
    },
    when: (0, _contextkeyJs.ContextKeyExpr).and(ctxReferenceSearchVisible, (0, _listServiceJs.WorkbenchListFocusContextKey), (0, _listServiceJs.WorkbenchTreeElementCanCollapse).negate(), (0, _listServiceJs.WorkbenchTreeElementCanExpand).negate()),
    handler (accessor) {
        const listService = accessor.get((0, _listServiceJs.IListService));
        const focus = listService.lastFocusedList?.getFocus();
        if (Array.isArray(focus) && focus[0] instanceof (0, _referencesModelJs.OneReference)) withController(accessor, (controller)=>controller.openReference(focus[0], true, true));
    }
});
(0, _commandsJs.CommandsRegistry).registerCommand("openReference", (accessor)=>{
    const listService = accessor.get((0, _listServiceJs.IListService));
    const focus = listService.lastFocusedList?.getFocus();
    if (Array.isArray(focus) && focus[0] instanceof (0, _referencesModelJs.OneReference)) withController(accessor, (controller)=>controller.openReference(focus[0], false, true));
});

},{"../../../../../base/common/async.js":"4GJc4","../../../../../base/common/errors.js":"divX8","../../../../../base/common/keyCodes.js":"bHiG9","../../../../../base/common/lifecycle.js":"9kg8d","../../../../browser/services/codeEditorService.js":"bOWtl","../../../../common/core/position.js":"lvrPe","../../../../common/core/range.js":"jmUPh","../../../peekView/browser/peekView.js":"jfvYD","../../../../../nls.js":"l617d","../../../../../platform/commands/common/commands.js":"ho6ic","../../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../../platform/keybinding/common/keybindingsRegistry.js":"h9qfk","../../../../../platform/list/browser/listService.js":"cyGMs","../../../../../platform/notification/common/notification.js":"igv0W","../../../../../platform/storage/common/storage.js":"6AhR2","../referencesModel.js":"789Jj","./referencesWidget.js":"cHLmN","../../../../common/editorContextKeys.js":"5exv9","../../../../../platform/contextkey/common/contextkeys.js":"jqcbi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jfvYD":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IPeekViewService", ()=>IPeekViewService);
parcelHelpers.export(exports, "PeekContext", ()=>PeekContext);
parcelHelpers.export(exports, "getOuterEditor", ()=>getOuterEditor);
parcelHelpers.export(exports, "PeekViewWidget", ()=>PeekViewWidget);
parcelHelpers.export(exports, "peekViewTitleBackground", ()=>peekViewTitleBackground);
parcelHelpers.export(exports, "peekViewTitleForeground", ()=>peekViewTitleForeground);
parcelHelpers.export(exports, "peekViewTitleInfoForeground", ()=>peekViewTitleInfoForeground);
parcelHelpers.export(exports, "peekViewBorder", ()=>peekViewBorder);
parcelHelpers.export(exports, "peekViewResultsBackground", ()=>peekViewResultsBackground);
parcelHelpers.export(exports, "peekViewResultsMatchForeground", ()=>peekViewResultsMatchForeground);
parcelHelpers.export(exports, "peekViewResultsFileForeground", ()=>peekViewResultsFileForeground);
parcelHelpers.export(exports, "peekViewResultsSelectionBackground", ()=>peekViewResultsSelectionBackground);
parcelHelpers.export(exports, "peekViewResultsSelectionForeground", ()=>peekViewResultsSelectionForeground);
parcelHelpers.export(exports, "peekViewEditorBackground", ()=>peekViewEditorBackground);
parcelHelpers.export(exports, "peekViewEditorGutterBackground", ()=>peekViewEditorGutterBackground);
parcelHelpers.export(exports, "peekViewEditorStickyScrollBackground", ()=>peekViewEditorStickyScrollBackground);
parcelHelpers.export(exports, "peekViewResultsMatchHighlight", ()=>peekViewResultsMatchHighlight);
parcelHelpers.export(exports, "peekViewEditorMatchHighlight", ()=>peekViewEditorMatchHighlight);
parcelHelpers.export(exports, "peekViewEditorMatchHighlightBorder", ()=>peekViewEditorMatchHighlightBorder);
var _domJs = require("../../../../base/browser/dom.js");
var _actionbarJs = require("../../../../base/browser/ui/actionbar/actionbar.js");
var _actionsJs = require("../../../../base/common/actions.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _themablesJs = require("../../../../base/common/themables.js");
var _colorJs = require("../../../../base/common/color.js");
var _eventJs = require("../../../../base/common/event.js");
var _objectsJs = require("../../../../base/common/objects.js");
var _peekViewWidgetCss = require("./media/peekViewWidget.css");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _embeddedCodeEditorWidgetJs = require("../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js");
var _zoneWidgetJs = require("../../zoneWidget/browser/zoneWidget.js");
var _nlsJs = require("../../../../nls.js");
var _menuEntryActionViewItemJs = require("../../../../platform/actions/browser/menuEntryActionViewItem.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _extensionsJs = require("../../../../platform/instantiation/common/extensions.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const IPeekViewService = (0, _instantiationJs.createDecorator)("IPeekViewService");
(0, _extensionsJs.registerSingleton)(IPeekViewService, class {
    constructor(){
        this._widgets = new Map();
    }
    addExclusiveWidget(editor, widget) {
        const existing = this._widgets.get(editor);
        if (existing) {
            existing.listener.dispose();
            existing.widget.dispose();
        }
        const remove = ()=>{
            const data = this._widgets.get(editor);
            if (data && data.widget === widget) {
                data.listener.dispose();
                this._widgets.delete(editor);
            }
        };
        this._widgets.set(editor, {
            widget,
            listener: widget.onDidClose(remove)
        });
    }
}, 1 /* InstantiationType.Delayed */ );
var PeekContext;
(function(PeekContext) {
    PeekContext.inPeekEditor = new (0, _contextkeyJs.RawContextKey)("inReferenceSearchEditor", true, _nlsJs.localize("inReferenceSearchEditor", "Whether the current code editor is embedded inside peek"));
    PeekContext.notInPeekEditor = PeekContext.inPeekEditor.toNegated();
})(PeekContext || (PeekContext = {}));
let PeekContextController = class PeekContextController {
    static{
        this.ID = "editor.contrib.referenceController";
    }
    constructor(editor, contextKeyService){
        if (editor instanceof (0, _embeddedCodeEditorWidgetJs.EmbeddedCodeEditorWidget)) PeekContext.inPeekEditor.bindTo(contextKeyService);
    }
    dispose() {}
};
PeekContextController = __decorate([
    __param(1, (0, _contextkeyJs.IContextKeyService))
], PeekContextController);
(0, _editorExtensionsJs.registerEditorContribution)(PeekContextController.ID, PeekContextController, 0 /* EditorContributionInstantiation.Eager */ ); // eager because it needs to define a context key
function getOuterEditor(accessor) {
    const editor = accessor.get((0, _codeEditorServiceJs.ICodeEditorService)).getFocusedCodeEditor();
    if (editor instanceof (0, _embeddedCodeEditorWidgetJs.EmbeddedCodeEditorWidget)) return editor.getParentEditor();
    return editor;
}
const defaultOptions = {
    headerBackgroundColor: (0, _colorJs.Color).white,
    primaryHeadingColor: (0, _colorJs.Color).fromHex("#333333"),
    secondaryHeadingColor: (0, _colorJs.Color).fromHex("#6c6c6cb3")
};
let PeekViewWidget = class PeekViewWidget extends (0, _zoneWidgetJs.ZoneWidget) {
    constructor(editor, options, instantiationService){
        super(editor, options);
        this.instantiationService = instantiationService;
        this._onDidClose = new (0, _eventJs.Emitter)();
        this.onDidClose = this._onDidClose.event;
        _objectsJs.mixin(this.options, defaultOptions, false);
    }
    dispose() {
        if (!this.disposed) {
            this.disposed = true; // prevent consumers who dispose on onDidClose from looping
            super.dispose();
            this._onDidClose.fire(this);
        }
    }
    style(styles) {
        const options = this.options;
        if (styles.headerBackgroundColor) options.headerBackgroundColor = styles.headerBackgroundColor;
        if (styles.primaryHeadingColor) options.primaryHeadingColor = styles.primaryHeadingColor;
        if (styles.secondaryHeadingColor) options.secondaryHeadingColor = styles.secondaryHeadingColor;
        super.style(styles);
    }
    _applyStyles() {
        super._applyStyles();
        const options = this.options;
        if (this._headElement && options.headerBackgroundColor) this._headElement.style.backgroundColor = options.headerBackgroundColor.toString();
        if (this._primaryHeading && options.primaryHeadingColor) this._primaryHeading.style.color = options.primaryHeadingColor.toString();
        if (this._secondaryHeading && options.secondaryHeadingColor) this._secondaryHeading.style.color = options.secondaryHeadingColor.toString();
        if (this._bodyElement && options.frameColor) this._bodyElement.style.borderColor = options.frameColor.toString();
    }
    _fillContainer(container) {
        this.setCssClass("peekview-widget");
        this._headElement = _domJs.$(".head");
        this._bodyElement = _domJs.$(".body");
        this._fillHead(this._headElement);
        this._fillBody(this._bodyElement);
        container.appendChild(this._headElement);
        container.appendChild(this._bodyElement);
    }
    _fillHead(container, noCloseAction) {
        this._titleElement = _domJs.$(".peekview-title");
        if (this.options.supportOnTitleClick) {
            this._titleElement.classList.add("clickable");
            _domJs.addStandardDisposableListener(this._titleElement, "click", (event)=>this._onTitleClick(event));
        }
        _domJs.append(this._headElement, this._titleElement);
        this._fillTitleIcon(this._titleElement);
        this._primaryHeading = _domJs.$("span.filename");
        this._secondaryHeading = _domJs.$("span.dirname");
        this._metaHeading = _domJs.$("span.meta");
        _domJs.append(this._titleElement, this._primaryHeading, this._secondaryHeading, this._metaHeading);
        const actionsContainer = _domJs.$(".peekview-actions");
        _domJs.append(this._headElement, actionsContainer);
        const actionBarOptions = this._getActionBarOptions();
        this._actionbarWidget = new (0, _actionbarJs.ActionBar)(actionsContainer, actionBarOptions);
        this._disposables.add(this._actionbarWidget);
        if (!noCloseAction) this._actionbarWidget.push(new (0, _actionsJs.Action)("peekview.close", _nlsJs.localize("label.close", "Close"), (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).close), true, ()=>{
            this.dispose();
            return Promise.resolve();
        }), {
            label: false,
            icon: true
        });
    }
    _fillTitleIcon(container) {}
    _getActionBarOptions() {
        return {
            actionViewItemProvider: (0, _menuEntryActionViewItemJs.createActionViewItem).bind(undefined, this.instantiationService),
            orientation: 0 /* ActionsOrientation.HORIZONTAL */ 
        };
    }
    _onTitleClick(event) {
    // implement me if supportOnTitleClick option is set
    }
    setTitle(primaryHeading, secondaryHeading) {
        if (this._primaryHeading && this._secondaryHeading) {
            this._primaryHeading.innerText = primaryHeading;
            this._primaryHeading.setAttribute("title", primaryHeading);
            if (secondaryHeading) this._secondaryHeading.innerText = secondaryHeading;
            else _domJs.clearNode(this._secondaryHeading);
        }
    }
    setMetaTitle(value) {
        if (this._metaHeading) {
            if (value) {
                this._metaHeading.innerText = value;
                _domJs.show(this._metaHeading);
            } else _domJs.hide(this._metaHeading);
        }
    }
    _doLayout(heightInPixel, widthInPixel) {
        if (!this._isShowing && heightInPixel < 0) {
            // Looks like the view zone got folded away!
            this.dispose();
            return;
        }
        const headHeight = Math.ceil(this.editor.getOption(67 /* EditorOption.lineHeight */ ) * 1.2);
        const bodyHeight = Math.round(heightInPixel - (headHeight + 2 /* the border-top/bottom width*/ ));
        this._doLayoutHead(headHeight, widthInPixel);
        this._doLayoutBody(bodyHeight, widthInPixel);
    }
    _doLayoutHead(heightInPixel, widthInPixel) {
        if (this._headElement) {
            this._headElement.style.height = `${heightInPixel}px`;
            this._headElement.style.lineHeight = this._headElement.style.height;
        }
    }
    _doLayoutBody(heightInPixel, widthInPixel) {
        if (this._bodyElement) this._bodyElement.style.height = `${heightInPixel}px`;
    }
};
PeekViewWidget = __decorate([
    __param(2, (0, _instantiationJs.IInstantiationService))
], PeekViewWidget);
const peekViewTitleBackground = (0, _colorRegistryJs.registerColor)("peekViewTitle.background", {
    dark: "#252526",
    light: "#F3F3F3",
    hcDark: (0, _colorJs.Color).black,
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("peekViewTitleBackground", "Background color of the peek view title area."));
const peekViewTitleForeground = (0, _colorRegistryJs.registerColor)("peekViewTitleLabel.foreground", {
    dark: (0, _colorJs.Color).white,
    light: (0, _colorJs.Color).black,
    hcDark: (0, _colorJs.Color).white,
    hcLight: (0, _colorRegistryJs.editorForeground)
}, _nlsJs.localize("peekViewTitleForeground", "Color of the peek view title."));
const peekViewTitleInfoForeground = (0, _colorRegistryJs.registerColor)("peekViewTitleDescription.foreground", {
    dark: "#ccccccb3",
    light: "#616161",
    hcDark: "#FFFFFF99",
    hcLight: "#292929"
}, _nlsJs.localize("peekViewTitleInfoForeground", "Color of the peek view title info."));
const peekViewBorder = (0, _colorRegistryJs.registerColor)("peekView.border", {
    dark: (0, _colorRegistryJs.editorInfoForeground),
    light: (0, _colorRegistryJs.editorInfoForeground),
    hcDark: (0, _colorRegistryJs.contrastBorder),
    hcLight: (0, _colorRegistryJs.contrastBorder)
}, _nlsJs.localize("peekViewBorder", "Color of the peek view borders and arrow."));
const peekViewResultsBackground = (0, _colorRegistryJs.registerColor)("peekViewResult.background", {
    dark: "#252526",
    light: "#F3F3F3",
    hcDark: (0, _colorJs.Color).black,
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("peekViewResultsBackground", "Background color of the peek view result list."));
const peekViewResultsMatchForeground = (0, _colorRegistryJs.registerColor)("peekViewResult.lineForeground", {
    dark: "#bbbbbb",
    light: "#646465",
    hcDark: (0, _colorJs.Color).white,
    hcLight: (0, _colorRegistryJs.editorForeground)
}, _nlsJs.localize("peekViewResultsMatchForeground", "Foreground color for line nodes in the peek view result list."));
const peekViewResultsFileForeground = (0, _colorRegistryJs.registerColor)("peekViewResult.fileForeground", {
    dark: (0, _colorJs.Color).white,
    light: "#1E1E1E",
    hcDark: (0, _colorJs.Color).white,
    hcLight: (0, _colorRegistryJs.editorForeground)
}, _nlsJs.localize("peekViewResultsFileForeground", "Foreground color for file nodes in the peek view result list."));
const peekViewResultsSelectionBackground = (0, _colorRegistryJs.registerColor)("peekViewResult.selectionBackground", {
    dark: "#3399ff33",
    light: "#3399ff33",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("peekViewResultsSelectionBackground", "Background color of the selected entry in the peek view result list."));
const peekViewResultsSelectionForeground = (0, _colorRegistryJs.registerColor)("peekViewResult.selectionForeground", {
    dark: (0, _colorJs.Color).white,
    light: "#6C6C6C",
    hcDark: (0, _colorJs.Color).white,
    hcLight: (0, _colorRegistryJs.editorForeground)
}, _nlsJs.localize("peekViewResultsSelectionForeground", "Foreground color of the selected entry in the peek view result list."));
const peekViewEditorBackground = (0, _colorRegistryJs.registerColor)("peekViewEditor.background", {
    dark: "#001F33",
    light: "#F2F8FC",
    hcDark: (0, _colorJs.Color).black,
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("peekViewEditorBackground", "Background color of the peek view editor."));
const peekViewEditorGutterBackground = (0, _colorRegistryJs.registerColor)("peekViewEditorGutter.background", peekViewEditorBackground, _nlsJs.localize("peekViewEditorGutterBackground", "Background color of the gutter in the peek view editor."));
const peekViewEditorStickyScrollBackground = (0, _colorRegistryJs.registerColor)("peekViewEditorStickyScroll.background", peekViewEditorBackground, _nlsJs.localize("peekViewEditorStickScrollBackground", "Background color of sticky scroll in the peek view editor."));
const peekViewResultsMatchHighlight = (0, _colorRegistryJs.registerColor)("peekViewResult.matchHighlightBackground", {
    dark: "#ea5c004d",
    light: "#ea5c004d",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("peekViewResultsMatchHighlight", "Match highlight color in the peek view result list."));
const peekViewEditorMatchHighlight = (0, _colorRegistryJs.registerColor)("peekViewEditor.matchHighlightBackground", {
    dark: "#ff8f0099",
    light: "#f5d802de",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("peekViewEditorMatchHighlight", "Match highlight color in the peek view editor."));
const peekViewEditorMatchHighlightBorder = (0, _colorRegistryJs.registerColor)("peekViewEditor.matchHighlightBorder", {
    dark: null,
    light: null,
    hcDark: (0, _colorRegistryJs.activeContrastBorder),
    hcLight: (0, _colorRegistryJs.activeContrastBorder)
}, _nlsJs.localize("peekViewEditorMatchHighlightBorder", "Match highlight border in the peek view editor."));

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/actionbar/actionbar.js":"5Xmba","../../../../base/common/actions.js":"5GjLb","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/themables.js":"hgyHi","../../../../base/common/color.js":"at4gb","../../../../base/common/event.js":"4Zi8b","../../../../base/common/objects.js":"j84mT","./media/peekViewWidget.css":"iusv3","../../../browser/editorExtensions.js":"kC3w6","../../../browser/services/codeEditorService.js":"bOWtl","../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js":"8G1ik","../../zoneWidget/browser/zoneWidget.js":"iL6MP","../../../../nls.js":"l617d","../../../../platform/actions/browser/menuEntryActionViewItem.js":"evssn","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/extensions.js":"6WJLq","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/theme/common/colorRegistry.js":"ik5kv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iusv3":[function() {},{}],"iL6MP":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverlayWidgetDelegate", ()=>OverlayWidgetDelegate);
parcelHelpers.export(exports, "ZoneWidget", ()=>ZoneWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _sashJs = require("../../../../base/browser/ui/sash/sash.js");
var _colorJs = require("../../../../base/common/color.js");
var _idGeneratorJs = require("../../../../base/common/idGenerator.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _objectsJs = require("../../../../base/common/objects.js");
var _zoneWidgetCss = require("./zoneWidget.css");
var _rangeJs = require("../../../common/core/range.js");
var _textModelJs = require("../../../common/model/textModel.js");
const defaultColor = new (0, _colorJs.Color)(new (0, _colorJs.RGBA)(0, 122, 204));
const defaultOptions = {
    showArrow: true,
    showFrame: true,
    className: "",
    frameColor: defaultColor,
    arrowColor: defaultColor,
    keepEditorSelection: false
};
const WIDGET_ID = "vs.editor.contrib.zoneWidget";
class ViewZoneDelegate {
    constructor(domNode, afterLineNumber, afterColumn, heightInLines, onDomNodeTop, onComputedHeight, showInHiddenAreas, ordinal){
        this.id = ""; // A valid zone id should be greater than 0
        this.domNode = domNode;
        this.afterLineNumber = afterLineNumber;
        this.afterColumn = afterColumn;
        this.heightInLines = heightInLines;
        this.showInHiddenAreas = showInHiddenAreas;
        this.ordinal = ordinal;
        this._onDomNodeTop = onDomNodeTop;
        this._onComputedHeight = onComputedHeight;
    }
    onDomNodeTop(top) {
        this._onDomNodeTop(top);
    }
    onComputedHeight(height) {
        this._onComputedHeight(height);
    }
}
class OverlayWidgetDelegate {
    constructor(id, domNode){
        this._id = id;
        this._domNode = domNode;
    }
    getId() {
        return this._id;
    }
    getDomNode() {
        return this._domNode;
    }
    getPosition() {
        return null;
    }
}
class Arrow {
    static{
        this._IdGenerator = new (0, _idGeneratorJs.IdGenerator)(".arrow-decoration-");
    }
    constructor(_editor){
        this._editor = _editor;
        this._ruleName = Arrow._IdGenerator.nextId();
        this._decorations = this._editor.createDecorationsCollection();
        this._color = null;
        this._height = -1;
    }
    dispose() {
        this.hide();
        _domJs.removeCSSRulesContainingSelector(this._ruleName);
    }
    set color(value) {
        if (this._color !== value) {
            this._color = value;
            this._updateStyle();
        }
    }
    set height(value) {
        if (this._height !== value) {
            this._height = value;
            this._updateStyle();
        }
    }
    _updateStyle() {
        _domJs.removeCSSRulesContainingSelector(this._ruleName);
        _domJs.createCSSRule(`.monaco-editor ${this._ruleName}`, `border-style: solid; border-color: transparent; border-bottom-color: ${this._color}; border-width: ${this._height}px; bottom: -${this._height}px !important; margin-left: -${this._height}px; `);
    }
    show(where) {
        if (where.column === 1) // the arrow isn't pretty at column 1 and we need to push it out a little
        where = {
            lineNumber: where.lineNumber,
            column: 2
        };
        this._decorations.set([
            {
                range: (0, _rangeJs.Range).fromPositions(where),
                options: {
                    description: "zone-widget-arrow",
                    className: this._ruleName,
                    stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ 
                }
            }
        ]);
    }
    hide() {
        this._decorations.clear();
    }
}
class ZoneWidget {
    constructor(editor, options = {}){
        this._arrow = null;
        this._overlayWidget = null;
        this._resizeSash = null;
        this._viewZone = null;
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this.container = null;
        this._isShowing = false;
        this.editor = editor;
        this._positionMarkerId = this.editor.createDecorationsCollection();
        this.options = _objectsJs.deepClone(options);
        _objectsJs.mixin(this.options, defaultOptions, false);
        this.domNode = document.createElement("div");
        if (!this.options.isAccessible) {
            this.domNode.setAttribute("aria-hidden", "true");
            this.domNode.setAttribute("role", "presentation");
        }
        this._disposables.add(this.editor.onDidLayoutChange((info)=>{
            const width = this._getWidth(info);
            this.domNode.style.width = width + "px";
            this.domNode.style.left = this._getLeft(info) + "px";
            this._onWidth(width);
        }));
    }
    dispose() {
        if (this._overlayWidget) {
            this.editor.removeOverlayWidget(this._overlayWidget);
            this._overlayWidget = null;
        }
        if (this._viewZone) this.editor.changeViewZones((accessor)=>{
            if (this._viewZone) accessor.removeZone(this._viewZone.id);
            this._viewZone = null;
        });
        this._positionMarkerId.clear();
        this._disposables.dispose();
    }
    create() {
        this.domNode.classList.add("zone-widget");
        if (this.options.className) this.domNode.classList.add(this.options.className);
        this.container = document.createElement("div");
        this.container.classList.add("zone-widget-container");
        this.domNode.appendChild(this.container);
        if (this.options.showArrow) {
            this._arrow = new Arrow(this.editor);
            this._disposables.add(this._arrow);
        }
        this._fillContainer(this.container);
        this._initSash();
        this._applyStyles();
    }
    style(styles) {
        if (styles.frameColor) this.options.frameColor = styles.frameColor;
        if (styles.arrowColor) this.options.arrowColor = styles.arrowColor;
        this._applyStyles();
    }
    _applyStyles() {
        if (this.container && this.options.frameColor) {
            const frameColor = this.options.frameColor.toString();
            this.container.style.borderTopColor = frameColor;
            this.container.style.borderBottomColor = frameColor;
        }
        if (this._arrow && this.options.arrowColor) {
            const arrowColor = this.options.arrowColor.toString();
            this._arrow.color = arrowColor;
        }
    }
    _getWidth(info) {
        return info.width - info.minimap.minimapWidth - info.verticalScrollbarWidth;
    }
    _getLeft(info) {
        // If minimap is to the left, we move beyond it
        if (info.minimap.minimapWidth > 0 && info.minimap.minimapLeft === 0) return info.minimap.minimapWidth;
        return 0;
    }
    _onViewZoneTop(top) {
        this.domNode.style.top = top + "px";
    }
    _onViewZoneHeight(height) {
        this.domNode.style.height = `${height}px`;
        if (this.container) {
            const containerHeight = height - this._decoratingElementsHeight();
            this.container.style.height = `${containerHeight}px`;
            const layoutInfo = this.editor.getLayoutInfo();
            this._doLayout(containerHeight, this._getWidth(layoutInfo));
        }
        this._resizeSash?.layout();
    }
    get position() {
        const range = this._positionMarkerId.getRange(0);
        if (!range) return undefined;
        return range.getStartPosition();
    }
    show(rangeOrPos, heightInLines) {
        const range = (0, _rangeJs.Range).isIRange(rangeOrPos) ? (0, _rangeJs.Range).lift(rangeOrPos) : (0, _rangeJs.Range).fromPositions(rangeOrPos);
        this._isShowing = true;
        this._showImpl(range, heightInLines);
        this._isShowing = false;
        this._positionMarkerId.set([
            {
                range,
                options: (0, _textModelJs.ModelDecorationOptions).EMPTY
            }
        ]);
    }
    hide() {
        if (this._viewZone) {
            this.editor.changeViewZones((accessor)=>{
                if (this._viewZone) accessor.removeZone(this._viewZone.id);
            });
            this._viewZone = null;
        }
        if (this._overlayWidget) {
            this.editor.removeOverlayWidget(this._overlayWidget);
            this._overlayWidget = null;
        }
        this._arrow?.hide();
        this._positionMarkerId.clear();
    }
    _decoratingElementsHeight() {
        const lineHeight = this.editor.getOption(67 /* EditorOption.lineHeight */ );
        let result = 0;
        if (this.options.showArrow) {
            const arrowHeight = Math.round(lineHeight / 3);
            result += 2 * arrowHeight;
        }
        if (this.options.showFrame) {
            const frameThickness = Math.round(lineHeight / 9);
            result += 2 * frameThickness;
        }
        return result;
    }
    _showImpl(where, heightInLines) {
        const position = where.getStartPosition();
        const layoutInfo = this.editor.getLayoutInfo();
        const width = this._getWidth(layoutInfo);
        this.domNode.style.width = `${width}px`;
        this.domNode.style.left = this._getLeft(layoutInfo) + "px";
        // Render the widget as zone (rendering) and widget (lifecycle)
        const viewZoneDomNode = document.createElement("div");
        viewZoneDomNode.style.overflow = "hidden";
        const lineHeight = this.editor.getOption(67 /* EditorOption.lineHeight */ );
        // adjust heightInLines to viewport
        if (!this.options.allowUnlimitedHeight) {
            const maxHeightInLines = Math.max(12, this.editor.getLayoutInfo().height / lineHeight * 0.8);
            heightInLines = Math.min(heightInLines, maxHeightInLines);
        }
        let arrowHeight = 0;
        let frameThickness = 0;
        // Render the arrow one 1/3 of an editor line height
        if (this._arrow && this.options.showArrow) {
            arrowHeight = Math.round(lineHeight / 3);
            this._arrow.height = arrowHeight;
            this._arrow.show(position);
        }
        // Render the frame as 1/9 of an editor line height
        if (this.options.showFrame) frameThickness = Math.round(lineHeight / 9);
        // insert zone widget
        this.editor.changeViewZones((accessor)=>{
            if (this._viewZone) accessor.removeZone(this._viewZone.id);
            if (this._overlayWidget) {
                this.editor.removeOverlayWidget(this._overlayWidget);
                this._overlayWidget = null;
            }
            this.domNode.style.top = "-1000px";
            this._viewZone = new ViewZoneDelegate(viewZoneDomNode, position.lineNumber, position.column, heightInLines, (top)=>this._onViewZoneTop(top), (height)=>this._onViewZoneHeight(height), this.options.showInHiddenAreas, this.options.ordinal);
            this._viewZone.id = accessor.addZone(this._viewZone);
            this._overlayWidget = new OverlayWidgetDelegate(WIDGET_ID + this._viewZone.id, this.domNode);
            this.editor.addOverlayWidget(this._overlayWidget);
        });
        if (this.container && this.options.showFrame) {
            const width = this.options.frameWidth ? this.options.frameWidth : frameThickness;
            this.container.style.borderTopWidth = width + "px";
            this.container.style.borderBottomWidth = width + "px";
        }
        const containerHeight = heightInLines * lineHeight - this._decoratingElementsHeight();
        if (this.container) {
            this.container.style.top = arrowHeight + "px";
            this.container.style.height = containerHeight + "px";
            this.container.style.overflow = "hidden";
        }
        this._doLayout(containerHeight, width);
        if (!this.options.keepEditorSelection) this.editor.setSelection(where);
        const model = this.editor.getModel();
        if (model) {
            const range = model.validateRange(new (0, _rangeJs.Range)(where.startLineNumber, 1, where.endLineNumber + 1, 1));
            this.revealRange(range, range.startLineNumber === model.getLineCount());
        }
    }
    revealRange(range, isLastLine) {
        if (isLastLine) this.editor.revealLineNearTop(range.endLineNumber, 0 /* ScrollType.Smooth */ );
        else this.editor.revealRange(range, 0 /* ScrollType.Smooth */ );
    }
    setCssClass(className, classToReplace) {
        if (!this.container) return;
        if (classToReplace) this.container.classList.remove(classToReplace);
        this.container.classList.add(className);
    }
    _onWidth(widthInPixel) {
    // implement in subclass
    }
    _doLayout(heightInPixel, widthInPixel) {
    // implement in subclass
    }
    _relayout(newHeightInLines) {
        if (this._viewZone && this._viewZone.heightInLines !== newHeightInLines) this.editor.changeViewZones((accessor)=>{
            if (this._viewZone) {
                this._viewZone.heightInLines = newHeightInLines;
                accessor.layoutZone(this._viewZone.id);
            }
        });
    }
    // --- sash
    _initSash() {
        if (this._resizeSash) return;
        this._resizeSash = this._disposables.add(new (0, _sashJs.Sash)(this.domNode, this, {
            orientation: 1 /* Orientation.HORIZONTAL */ 
        }));
        if (!this.options.isResizeable) this._resizeSash.state = 0 /* SashState.Disabled */ ;
        let data;
        this._disposables.add(this._resizeSash.onDidStart((e)=>{
            if (this._viewZone) data = {
                startY: e.startY,
                heightInLines: this._viewZone.heightInLines
            };
        }));
        this._disposables.add(this._resizeSash.onDidEnd(()=>{
            data = undefined;
        }));
        this._disposables.add(this._resizeSash.onDidChange((evt)=>{
            if (data) {
                const lineDelta = (evt.currentY - data.startY) / this.editor.getOption(67 /* EditorOption.lineHeight */ );
                const roundedLineDelta = lineDelta < 0 ? Math.ceil(lineDelta) : Math.floor(lineDelta);
                const newHeightInLines = data.heightInLines + roundedLineDelta;
                if (newHeightInLines > 5 && newHeightInLines < 35) this._relayout(newHeightInLines);
            }
        }));
    }
    getHorizontalSashLeft() {
        return 0;
    }
    getHorizontalSashTop() {
        return (this.domNode.style.height === null ? 0 : parseInt(this.domNode.style.height)) - this._decoratingElementsHeight() / 2;
    }
    getHorizontalSashWidth() {
        const layoutInfo = this.editor.getLayoutInfo();
        return layoutInfo.width - layoutInfo.minimap.minimapWidth;
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/sash/sash.js":"2Pk4d","../../../../base/common/color.js":"at4gb","../../../../base/common/idGenerator.js":"jlFbp","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/objects.js":"j84mT","./zoneWidget.css":"gSypj","../../../common/core/range.js":"jmUPh","../../../common/model/textModel.js":"9beDe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gSypj":[function() {},{}],"789Jj":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OneReference", ()=>OneReference);
parcelHelpers.export(exports, "FilePreview", ()=>FilePreview);
parcelHelpers.export(exports, "FileReferences", ()=>FileReferences);
parcelHelpers.export(exports, "ReferencesModel", ()=>ReferencesModel);
var _errorsJs = require("../../../../base/common/errors.js");
var _eventJs = require("../../../../base/common/event.js");
var _idGeneratorJs = require("../../../../base/common/idGenerator.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _mapJs = require("../../../../base/common/map.js");
var _resourcesJs = require("../../../../base/common/resources.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _rangeJs = require("../../../common/core/range.js");
var _nlsJs = require("../../../../nls.js");
class OneReference {
    constructor(isProviderFirst, parent, link, _rangeCallback){
        this.isProviderFirst = isProviderFirst;
        this.parent = parent;
        this.link = link;
        this._rangeCallback = _rangeCallback;
        this.id = (0, _idGeneratorJs.defaultGenerator).nextId();
    }
    get uri() {
        return this.link.uri;
    }
    get range() {
        return this._range ?? this.link.targetSelectionRange ?? this.link.range;
    }
    set range(value) {
        this._range = value;
        this._rangeCallback(this);
    }
    get ariaMessage() {
        const preview = this.parent.getPreview(this)?.preview(this.range);
        if (!preview) return (0, _nlsJs.localize)("aria.oneReference", "in {0} on line {1} at column {2}", (0, _resourcesJs.basename)(this.uri), this.range.startLineNumber, this.range.startColumn);
        else return (0, _nlsJs.localize)({
            key: "aria.oneReference.preview",
            comment: [
                "Placeholders are: 0: filename, 1:line number, 2: column number, 3: preview snippet of source code"
            ]
        }, "{0} in {1} on line {2} at column {3}", preview.value, (0, _resourcesJs.basename)(this.uri), this.range.startLineNumber, this.range.startColumn);
    }
}
class FilePreview {
    constructor(_modelReference){
        this._modelReference = _modelReference;
    }
    dispose() {
        this._modelReference.dispose();
    }
    preview(range, n = 8) {
        const model = this._modelReference.object.textEditorModel;
        if (!model) return undefined;
        const { startLineNumber, startColumn, endLineNumber, endColumn } = range;
        const word = model.getWordUntilPosition({
            lineNumber: startLineNumber,
            column: startColumn - n
        });
        const beforeRange = new (0, _rangeJs.Range)(startLineNumber, word.startColumn, startLineNumber, startColumn);
        const afterRange = new (0, _rangeJs.Range)(endLineNumber, endColumn, endLineNumber, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ );
        const before = model.getValueInRange(beforeRange).replace(/^\s+/, "");
        const inside = model.getValueInRange(range);
        const after = model.getValueInRange(afterRange).replace(/\s+$/, "");
        return {
            value: before + inside + after,
            highlight: {
                start: before.length,
                end: before.length + inside.length
            }
        };
    }
}
class FileReferences {
    constructor(parent, uri){
        this.parent = parent;
        this.uri = uri;
        this.children = [];
        this._previews = new (0, _mapJs.ResourceMap)();
    }
    dispose() {
        (0, _lifecycleJs.dispose)(this._previews.values());
        this._previews.clear();
    }
    getPreview(child) {
        return this._previews.get(child.uri);
    }
    get ariaMessage() {
        const len = this.children.length;
        if (len === 1) return (0, _nlsJs.localize)("aria.fileReferences.1", "1 symbol in {0}, full path {1}", (0, _resourcesJs.basename)(this.uri), this.uri.fsPath);
        else return (0, _nlsJs.localize)("aria.fileReferences.N", "{0} symbols in {1}, full path {2}", len, (0, _resourcesJs.basename)(this.uri), this.uri.fsPath);
    }
    async resolve(textModelResolverService) {
        if (this._previews.size !== 0) return this;
        for (const child of this.children){
            if (this._previews.has(child.uri)) continue;
            try {
                const ref = await textModelResolverService.createModelReference(child.uri);
                this._previews.set(child.uri, new FilePreview(ref));
            } catch (err) {
                (0, _errorsJs.onUnexpectedError)(err);
            }
        }
        return this;
    }
}
class ReferencesModel {
    constructor(links, title){
        this.groups = [];
        this.references = [];
        this._onDidChangeReferenceRange = new (0, _eventJs.Emitter)();
        this.onDidChangeReferenceRange = this._onDidChangeReferenceRange.event;
        this._links = links;
        this._title = title;
        // grouping and sorting
        const [providersFirst] = links;
        links.sort(ReferencesModel._compareReferences);
        let current;
        for (const link of links){
            if (!current || !(0, _resourcesJs.extUri).isEqual(current.uri, link.uri, true)) {
                // new group
                current = new FileReferences(this, link.uri);
                this.groups.push(current);
            }
            // append, check for equality first!
            if (current.children.length === 0 || ReferencesModel._compareReferences(link, current.children[current.children.length - 1]) !== 0) {
                const oneRef = new OneReference(providersFirst === link, current, link, (ref)=>this._onDidChangeReferenceRange.fire(ref));
                this.references.push(oneRef);
                current.children.push(oneRef);
            }
        }
    }
    dispose() {
        (0, _lifecycleJs.dispose)(this.groups);
        this._onDidChangeReferenceRange.dispose();
        this.groups.length = 0;
    }
    clone() {
        return new ReferencesModel(this._links, this._title);
    }
    get title() {
        return this._title;
    }
    get isEmpty() {
        return this.groups.length === 0;
    }
    get ariaMessage() {
        if (this.isEmpty) return (0, _nlsJs.localize)("aria.result.0", "No results found");
        else if (this.references.length === 1) return (0, _nlsJs.localize)("aria.result.1", "Found 1 symbol in {0}", this.references[0].uri.fsPath);
        else if (this.groups.length === 1) return (0, _nlsJs.localize)("aria.result.n1", "Found {0} symbols in {1}", this.references.length, this.groups[0].uri.fsPath);
        else return (0, _nlsJs.localize)("aria.result.nm", "Found {0} symbols in {1} files", this.references.length, this.groups.length);
    }
    nextOrPreviousReference(reference, next) {
        const { parent } = reference;
        let idx = parent.children.indexOf(reference);
        const childCount = parent.children.length;
        const groupCount = parent.parent.groups.length;
        if (groupCount === 1 || next && idx + 1 < childCount || !next && idx > 0) {
            // cycling within one file
            if (next) idx = (idx + 1) % childCount;
            else idx = (idx + childCount - 1) % childCount;
            return parent.children[idx];
        }
        idx = parent.parent.groups.indexOf(parent);
        if (next) {
            idx = (idx + 1) % groupCount;
            return parent.parent.groups[idx].children[0];
        } else {
            idx = (idx + groupCount - 1) % groupCount;
            return parent.parent.groups[idx].children[parent.parent.groups[idx].children.length - 1];
        }
    }
    nearestReference(resource, position) {
        const nearest = this.references.map((ref, idx)=>{
            return {
                idx,
                prefixLen: _stringsJs.commonPrefixLength(ref.uri.toString(), resource.toString()),
                offsetDist: Math.abs(ref.range.startLineNumber - position.lineNumber) * 100 + Math.abs(ref.range.startColumn - position.column)
            };
        }).sort((a, b)=>{
            if (a.prefixLen > b.prefixLen) return -1;
            else if (a.prefixLen < b.prefixLen) return 1;
            else if (a.offsetDist < b.offsetDist) return -1;
            else if (a.offsetDist > b.offsetDist) return 1;
            else return 0;
        })[0];
        if (nearest) return this.references[nearest.idx];
        return undefined;
    }
    referenceAt(resource, position) {
        for (const ref of this.references)if (ref.uri.toString() === resource.toString()) {
            if ((0, _rangeJs.Range).containsPosition(ref.range, position)) return ref;
        }
        return undefined;
    }
    firstReference() {
        for (const ref of this.references){
            if (ref.isProviderFirst) return ref;
        }
        return this.references[0];
    }
    static _compareReferences(a, b) {
        return (0, _resourcesJs.extUri).compare(a.uri, b.uri) || (0, _rangeJs.Range).compareRangesUsingStarts(a.range, b.range);
    }
}

},{"../../../../base/common/errors.js":"divX8","../../../../base/common/event.js":"4Zi8b","../../../../base/common/idGenerator.js":"jlFbp","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/map.js":"leSjz","../../../../base/common/resources.js":"700EV","../../../../base/common/strings.js":"aA9I1","../../../common/core/range.js":"jmUPh","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cHLmN":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutData", ()=>LayoutData);
parcelHelpers.export(exports, "ReferenceWidget", ()=>ReferenceWidget);
var _domJs = require("../../../../../base/browser/dom.js");
var _splitviewJs = require("../../../../../base/browser/ui/splitview/splitview.js");
var _colorJs = require("../../../../../base/common/color.js");
var _eventJs = require("../../../../../base/common/event.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _networkJs = require("../../../../../base/common/network.js");
var _resourcesJs = require("../../../../../base/common/resources.js");
var _referencesWidgetCss = require("./referencesWidget.css");
var _embeddedCodeEditorWidgetJs = require("../../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js");
var _rangeJs = require("../../../../common/core/range.js");
var _textModelJs = require("../../../../common/model/textModel.js");
var _modesRegistryJs = require("../../../../common/languages/modesRegistry.js");
var _resolverServiceJs = require("../../../../common/services/resolverService.js");
var _referencesTreeJs = require("./referencesTree.js");
var _peekViewJs = require("../../../peekView/browser/peekView.js");
var _nlsJs = require("../../../../../nls.js");
var _instantiationJs = require("../../../../../platform/instantiation/common/instantiation.js");
var _keybindingJs = require("../../../../../platform/keybinding/common/keybinding.js");
var _labelJs = require("../../../../../platform/label/common/label.js");
var _listServiceJs = require("../../../../../platform/list/browser/listService.js");
var _themeServiceJs = require("../../../../../platform/theme/common/themeService.js");
var _referencesModelJs = require("../referencesModel.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class DecorationsManager {
    static{
        this.DecorationOptions = (0, _textModelJs.ModelDecorationOptions).register({
            description: "reference-decoration",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
            className: "reference-decoration"
        });
    }
    constructor(_editor, _model){
        this._editor = _editor;
        this._model = _model;
        this._decorations = new Map();
        this._decorationIgnoreSet = new Set();
        this._callOnDispose = new (0, _lifecycleJs.DisposableStore)();
        this._callOnModelChange = new (0, _lifecycleJs.DisposableStore)();
        this._callOnDispose.add(this._editor.onDidChangeModel(()=>this._onModelChanged()));
        this._onModelChanged();
    }
    dispose() {
        this._callOnModelChange.dispose();
        this._callOnDispose.dispose();
        this.removeDecorations();
    }
    _onModelChanged() {
        this._callOnModelChange.clear();
        const model = this._editor.getModel();
        if (!model) return;
        for (const ref of this._model.references)if (ref.uri.toString() === model.uri.toString()) {
            this._addDecorations(ref.parent);
            return;
        }
    }
    _addDecorations(reference) {
        if (!this._editor.hasModel()) return;
        this._callOnModelChange.add(this._editor.getModel().onDidChangeDecorations(()=>this._onDecorationChanged()));
        const newDecorations = [];
        const newDecorationsActualIndex = [];
        for(let i = 0, len = reference.children.length; i < len; i++){
            const oneReference = reference.children[i];
            if (this._decorationIgnoreSet.has(oneReference.id)) continue;
            if (oneReference.uri.toString() !== this._editor.getModel().uri.toString()) continue;
            newDecorations.push({
                range: oneReference.range,
                options: DecorationsManager.DecorationOptions
            });
            newDecorationsActualIndex.push(i);
        }
        this._editor.changeDecorations((changeAccessor)=>{
            const decorations = changeAccessor.deltaDecorations([], newDecorations);
            for(let i = 0; i < decorations.length; i++)this._decorations.set(decorations[i], reference.children[newDecorationsActualIndex[i]]);
        });
    }
    _onDecorationChanged() {
        const toRemove = [];
        const model = this._editor.getModel();
        if (!model) return;
        for (const [decorationId, reference] of this._decorations){
            const newRange = model.getDecorationRange(decorationId);
            if (!newRange) continue;
            let ignore = false;
            if ((0, _rangeJs.Range).equalsRange(newRange, reference.range)) continue;
            if ((0, _rangeJs.Range).spansMultipleLines(newRange)) ignore = true;
            else {
                const lineLength = reference.range.endColumn - reference.range.startColumn;
                const newLineLength = newRange.endColumn - newRange.startColumn;
                if (lineLength !== newLineLength) ignore = true;
            }
            if (ignore) {
                this._decorationIgnoreSet.add(reference.id);
                toRemove.push(decorationId);
            } else reference.range = newRange;
        }
        for(let i = 0, len = toRemove.length; i < len; i++)this._decorations.delete(toRemove[i]);
        this._editor.removeDecorations(toRemove);
    }
    removeDecorations() {
        this._editor.removeDecorations([
            ...this._decorations.keys()
        ]);
        this._decorations.clear();
    }
}
class LayoutData {
    constructor(){
        this.ratio = 0.7;
        this.heightInLines = 18;
    }
    static fromJSON(raw) {
        let ratio;
        let heightInLines;
        try {
            const data = JSON.parse(raw);
            ratio = data.ratio;
            heightInLines = data.heightInLines;
        } catch  {
        //
        }
        return {
            ratio: ratio || 0.7,
            heightInLines: heightInLines || 18
        };
    }
}
class ReferencesTree extends (0, _listServiceJs.WorkbenchAsyncDataTree) {
}
/**
 * ZoneWidget that is shown inside the editor
 */ let ReferenceWidget = class ReferenceWidget extends _peekViewJs.PeekViewWidget {
    constructor(editor, _defaultTreeKeyboardSupport, layoutData, themeService, _textModelResolverService, _instantiationService, _peekViewService, _uriLabel, _keybindingService){
        super(editor, {
            showFrame: false,
            showArrow: true,
            isResizeable: true,
            isAccessible: true,
            supportOnTitleClick: true
        }, _instantiationService);
        this._defaultTreeKeyboardSupport = _defaultTreeKeyboardSupport;
        this.layoutData = layoutData;
        this._textModelResolverService = _textModelResolverService;
        this._instantiationService = _instantiationService;
        this._peekViewService = _peekViewService;
        this._uriLabel = _uriLabel;
        this._keybindingService = _keybindingService;
        this._disposeOnNewModel = new (0, _lifecycleJs.DisposableStore)();
        this._callOnDispose = new (0, _lifecycleJs.DisposableStore)();
        this._onDidSelectReference = new (0, _eventJs.Emitter)();
        this.onDidSelectReference = this._onDidSelectReference.event;
        this._dim = new _domJs.Dimension(0, 0);
        this._isClosing = false; // whether or not a dispose is already in progress
        this._applyTheme(themeService.getColorTheme());
        this._callOnDispose.add(themeService.onDidColorThemeChange(this._applyTheme.bind(this)));
        this._peekViewService.addExclusiveWidget(editor, this);
        this.create();
    }
    get isClosing() {
        return this._isClosing;
    }
    dispose() {
        this._isClosing = true;
        this.setModel(undefined);
        this._callOnDispose.dispose();
        this._disposeOnNewModel.dispose();
        (0, _lifecycleJs.dispose)(this._preview);
        (0, _lifecycleJs.dispose)(this._previewNotAvailableMessage);
        (0, _lifecycleJs.dispose)(this._tree);
        (0, _lifecycleJs.dispose)(this._previewModelReference);
        this._splitView.dispose();
        super.dispose();
    }
    _applyTheme(theme) {
        const borderColor = theme.getColor(_peekViewJs.peekViewBorder) || (0, _colorJs.Color).transparent;
        this.style({
            arrowColor: borderColor,
            frameColor: borderColor,
            headerBackgroundColor: theme.getColor(_peekViewJs.peekViewTitleBackground) || (0, _colorJs.Color).transparent,
            primaryHeadingColor: theme.getColor(_peekViewJs.peekViewTitleForeground),
            secondaryHeadingColor: theme.getColor(_peekViewJs.peekViewTitleInfoForeground)
        });
    }
    show(where) {
        super.show(where, this.layoutData.heightInLines || 18);
    }
    focusOnReferenceTree() {
        this._tree.domFocus();
    }
    focusOnPreviewEditor() {
        this._preview.focus();
    }
    isPreviewEditorFocused() {
        return this._preview.hasTextFocus();
    }
    _onTitleClick(e) {
        if (this._preview && this._preview.getModel()) this._onDidSelectReference.fire({
            element: this._getFocusedReference(),
            kind: e.ctrlKey || e.metaKey || e.altKey ? "side" : "open",
            source: "title"
        });
    }
    _fillBody(containerElement) {
        this.setCssClass("reference-zone-widget");
        // message pane
        this._messageContainer = _domJs.append(containerElement, _domJs.$("div.messages"));
        _domJs.hide(this._messageContainer);
        this._splitView = new (0, _splitviewJs.SplitView)(containerElement, {
            orientation: 1 /* Orientation.HORIZONTAL */ 
        });
        // editor
        this._previewContainer = _domJs.append(containerElement, _domJs.$("div.preview.inline"));
        const options = {
            scrollBeyondLastLine: false,
            scrollbar: {
                verticalScrollbarSize: 14,
                horizontal: "auto",
                useShadows: true,
                verticalHasArrows: false,
                horizontalHasArrows: false,
                alwaysConsumeMouseWheel: true
            },
            overviewRulerLanes: 2,
            fixedOverflowWidgets: true,
            minimap: {
                enabled: false
            }
        };
        this._preview = this._instantiationService.createInstance((0, _embeddedCodeEditorWidgetJs.EmbeddedCodeEditorWidget), this._previewContainer, options, {}, this.editor);
        _domJs.hide(this._previewContainer);
        this._previewNotAvailableMessage = this._instantiationService.createInstance((0, _textModelJs.TextModel), _nlsJs.localize("missingPreviewMessage", "no preview available"), (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID), (0, _textModelJs.TextModel).DEFAULT_CREATION_OPTIONS, null);
        // tree
        this._treeContainer = _domJs.append(containerElement, _domJs.$("div.ref-tree.inline"));
        const treeOptions = {
            keyboardSupport: this._defaultTreeKeyboardSupport,
            accessibilityProvider: new (0, _referencesTreeJs.AccessibilityProvider)(),
            keyboardNavigationLabelProvider: this._instantiationService.createInstance((0, _referencesTreeJs.StringRepresentationProvider)),
            identityProvider: new (0, _referencesTreeJs.IdentityProvider)(),
            openOnSingleClick: true,
            selectionNavigation: true,
            overrideStyles: {
                listBackground: _peekViewJs.peekViewResultsBackground
            }
        };
        if (this._defaultTreeKeyboardSupport) // the tree will consume `Escape` and prevent the widget from closing
        this._callOnDispose.add(_domJs.addStandardDisposableListener(this._treeContainer, "keydown", (e)=>{
            if (e.equals(9 /* KeyCode.Escape */ )) {
                this._keybindingService.dispatchEvent(e, e.target);
                e.stopPropagation();
            }
        }, true));
        this._tree = this._instantiationService.createInstance(ReferencesTree, "ReferencesWidget", this._treeContainer, new (0, _referencesTreeJs.Delegate)(), [
            this._instantiationService.createInstance((0, _referencesTreeJs.FileReferencesRenderer)),
            this._instantiationService.createInstance((0, _referencesTreeJs.OneReferenceRenderer))
        ], this._instantiationService.createInstance((0, _referencesTreeJs.DataSource)), treeOptions);
        // split stuff
        this._splitView.addView({
            onDidChange: (0, _eventJs.Event).None,
            element: this._previewContainer,
            minimumSize: 200,
            maximumSize: Number.MAX_VALUE,
            layout: (width)=>{
                this._preview.layout({
                    height: this._dim.height,
                    width
                });
            }
        }, (0, _splitviewJs.Sizing).Distribute);
        this._splitView.addView({
            onDidChange: (0, _eventJs.Event).None,
            element: this._treeContainer,
            minimumSize: 100,
            maximumSize: Number.MAX_VALUE,
            layout: (width)=>{
                this._treeContainer.style.height = `${this._dim.height}px`;
                this._treeContainer.style.width = `${width}px`;
                this._tree.layout(this._dim.height, width);
            }
        }, (0, _splitviewJs.Sizing).Distribute);
        this._disposables.add(this._splitView.onDidSashChange(()=>{
            if (this._dim.width) this.layoutData.ratio = this._splitView.getViewSize(0) / this._dim.width;
        }, undefined));
        // listen on selection and focus
        const onEvent = (element, kind)=>{
            if (element instanceof (0, _referencesModelJs.OneReference)) {
                if (kind === "show") this._revealReference(element, false);
                this._onDidSelectReference.fire({
                    element,
                    kind,
                    source: "tree"
                });
            }
        };
        this._disposables.add(this._tree.onDidOpen((e)=>{
            if (e.sideBySide) onEvent(e.element, "side");
            else if (e.editorOptions.pinned) onEvent(e.element, "goto");
            else onEvent(e.element, "show");
        }));
        _domJs.hide(this._treeContainer);
    }
    _onWidth(width) {
        if (this._dim) this._doLayoutBody(this._dim.height, width);
    }
    _doLayoutBody(heightInPixel, widthInPixel) {
        super._doLayoutBody(heightInPixel, widthInPixel);
        this._dim = new _domJs.Dimension(widthInPixel, heightInPixel);
        this.layoutData.heightInLines = this._viewZone ? this._viewZone.heightInLines : this.layoutData.heightInLines;
        this._splitView.layout(widthInPixel);
        this._splitView.resizeView(0, widthInPixel * this.layoutData.ratio);
    }
    setSelection(selection) {
        return this._revealReference(selection, true).then(()=>{
            if (!this._model) // disposed
            return;
            // show in tree
            this._tree.setSelection([
                selection
            ]);
            this._tree.setFocus([
                selection
            ]);
        });
    }
    setModel(newModel) {
        // clean up
        this._disposeOnNewModel.clear();
        this._model = newModel;
        if (this._model) return this._onNewModel();
        return Promise.resolve();
    }
    _onNewModel() {
        if (!this._model) return Promise.resolve(undefined);
        if (this._model.isEmpty) {
            this.setTitle("");
            this._messageContainer.innerText = _nlsJs.localize("noResults", "No results");
            _domJs.show(this._messageContainer);
            return Promise.resolve(undefined);
        }
        _domJs.hide(this._messageContainer);
        this._decorationsManager = new DecorationsManager(this._preview, this._model);
        this._disposeOnNewModel.add(this._decorationsManager);
        // listen on model changes
        this._disposeOnNewModel.add(this._model.onDidChangeReferenceRange((reference)=>this._tree.rerender(reference)));
        // listen on editor
        this._disposeOnNewModel.add(this._preview.onMouseDown((e)=>{
            const { event, target } = e;
            if (event.detail !== 2) return;
            const element = this._getFocusedReference();
            if (!element) return;
            this._onDidSelectReference.fire({
                element: {
                    uri: element.uri,
                    range: target.range
                },
                kind: event.ctrlKey || event.metaKey || event.altKey ? "side" : "open",
                source: "editor"
            });
        }));
        // make sure things are rendered
        this.container.classList.add("results-loaded");
        _domJs.show(this._treeContainer);
        _domJs.show(this._previewContainer);
        this._splitView.layout(this._dim.width);
        this.focusOnReferenceTree();
        // pick input and a reference to begin with
        return this._tree.setInput(this._model.groups.length === 1 ? this._model.groups[0] : this._model);
    }
    _getFocusedReference() {
        const [element] = this._tree.getFocus();
        if (element instanceof (0, _referencesModelJs.OneReference)) return element;
        else if (element instanceof (0, _referencesModelJs.FileReferences)) {
            if (element.children.length > 0) return element.children[0];
        }
        return undefined;
    }
    async revealReference(reference) {
        await this._revealReference(reference, false);
        this._onDidSelectReference.fire({
            element: reference,
            kind: "goto",
            source: "tree"
        });
    }
    async _revealReference(reference, revealParent) {
        // check if there is anything to do...
        if (this._revealedReference === reference) return;
        this._revealedReference = reference;
        // Update widget header
        if (reference.uri.scheme !== (0, _networkJs.Schemas).inMemory) this.setTitle((0, _resourcesJs.basenameOrAuthority)(reference.uri), this._uriLabel.getUriLabel((0, _resourcesJs.dirname)(reference.uri)));
        else this.setTitle(_nlsJs.localize("peekView.alternateTitle", "References"));
        const promise = this._textModelResolverService.createModelReference(reference.uri);
        if (this._tree.getInput() === reference.parent) this._tree.reveal(reference);
        else {
            if (revealParent) this._tree.reveal(reference.parent);
            await this._tree.expand(reference.parent);
            this._tree.reveal(reference);
        }
        const ref = await promise;
        if (!this._model) {
            // disposed
            ref.dispose();
            return;
        }
        (0, _lifecycleJs.dispose)(this._previewModelReference);
        // show in editor
        const model = ref.object;
        if (model) {
            const scrollType = this._preview.getModel() === model.textEditorModel ? 0 /* ScrollType.Smooth */  : 1 /* ScrollType.Immediate */ ;
            const sel = (0, _rangeJs.Range).lift(reference.range).collapseToStart();
            this._previewModelReference = ref;
            this._preview.setModel(model.textEditorModel);
            this._preview.setSelection(sel);
            this._preview.revealRangeInCenter(sel, scrollType);
        } else {
            this._preview.setModel(this._previewNotAvailableMessage);
            ref.dispose();
        }
    }
};
ReferenceWidget = __decorate([
    __param(3, (0, _themeServiceJs.IThemeService)),
    __param(4, (0, _resolverServiceJs.ITextModelService)),
    __param(5, (0, _instantiationJs.IInstantiationService)),
    __param(6, _peekViewJs.IPeekViewService),
    __param(7, (0, _labelJs.ILabelService)),
    __param(8, (0, _keybindingJs.IKeybindingService))
], ReferenceWidget);

},{"../../../../../base/browser/dom.js":"bnqsM","../../../../../base/browser/ui/splitview/splitview.js":"kIDcw","../../../../../base/common/color.js":"at4gb","../../../../../base/common/event.js":"4Zi8b","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/network.js":"2c1AD","../../../../../base/common/resources.js":"700EV","./referencesWidget.css":"bNKv2","../../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js":"8G1ik","../../../../common/core/range.js":"jmUPh","../../../../common/model/textModel.js":"9beDe","../../../../common/languages/modesRegistry.js":"gqkb7","../../../../common/services/resolverService.js":"ezAtF","./referencesTree.js":"gvAuC","../../../peekView/browser/peekView.js":"jfvYD","../../../../../nls.js":"l617d","../../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../../platform/label/common/label.js":"esEqR","../../../../../platform/list/browser/listService.js":"cyGMs","../../../../../platform/theme/common/themeService.js":"jMkIC","../referencesModel.js":"789Jj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bNKv2":[function() {},{}],"gvAuC":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataSource", ()=>DataSource);
//#endregion
parcelHelpers.export(exports, "Delegate", ()=>Delegate);
parcelHelpers.export(exports, "StringRepresentationProvider", ()=>StringRepresentationProvider);
parcelHelpers.export(exports, "IdentityProvider", ()=>IdentityProvider);
parcelHelpers.export(exports, "FileReferencesRenderer", ()=>FileReferencesRenderer);
parcelHelpers.export(exports, "OneReferenceRenderer", ()=>OneReferenceRenderer);
//#endregion
parcelHelpers.export(exports, "AccessibilityProvider", ()=>AccessibilityProvider);
var _domJs = require("../../../../../base/browser/dom.js");
var _countBadgeJs = require("../../../../../base/browser/ui/countBadge/countBadge.js");
var _highlightedLabelJs = require("../../../../../base/browser/ui/highlightedlabel/highlightedLabel.js");
var _iconLabelJs = require("../../../../../base/browser/ui/iconLabel/iconLabel.js");
var _filtersJs = require("../../../../../base/common/filters.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _resourcesJs = require("../../../../../base/common/resources.js");
var _resolverServiceJs = require("../../../../common/services/resolverService.js");
var _nlsJs = require("../../../../../nls.js");
var _instantiationJs = require("../../../../../platform/instantiation/common/instantiation.js");
var _keybindingJs = require("../../../../../platform/keybinding/common/keybinding.js");
var _labelJs = require("../../../../../platform/label/common/label.js");
var _defaultStylesJs = require("../../../../../platform/theme/browser/defaultStyles.js");
var _referencesModelJs = require("../referencesModel.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var FileReferencesRenderer_1;
let DataSource = class DataSource {
    constructor(_resolverService){
        this._resolverService = _resolverService;
    }
    hasChildren(element) {
        if (element instanceof (0, _referencesModelJs.ReferencesModel)) return true;
        if (element instanceof (0, _referencesModelJs.FileReferences)) return true;
        return false;
    }
    getChildren(element) {
        if (element instanceof (0, _referencesModelJs.ReferencesModel)) return element.groups;
        if (element instanceof (0, _referencesModelJs.FileReferences)) return element.resolve(this._resolverService).then((val)=>{
            // if (element.failure) {
            // 	// refresh the element on failure so that
            // 	// we can update its rendering
            // 	return tree.refresh(element).then(() => val.children);
            // }
            return val.children;
        });
        throw new Error("bad tree");
    }
};
DataSource = __decorate([
    __param(0, (0, _resolverServiceJs.ITextModelService))
], DataSource);
class Delegate {
    getHeight() {
        return 23;
    }
    getTemplateId(element) {
        if (element instanceof (0, _referencesModelJs.FileReferences)) return FileReferencesRenderer.id;
        else return OneReferenceRenderer.id;
    }
}
let StringRepresentationProvider = class StringRepresentationProvider {
    constructor(_keybindingService){
        this._keybindingService = _keybindingService;
    }
    getKeyboardNavigationLabel(element) {
        if (element instanceof (0, _referencesModelJs.OneReference)) {
            const parts = element.parent.getPreview(element)?.preview(element.range);
            if (parts) return parts.value;
        }
        // FileReferences or unresolved OneReference
        return (0, _resourcesJs.basename)(element.uri);
    }
};
StringRepresentationProvider = __decorate([
    __param(0, (0, _keybindingJs.IKeybindingService))
], StringRepresentationProvider);
class IdentityProvider {
    getId(element) {
        return element instanceof (0, _referencesModelJs.OneReference) ? element.id : element.uri;
    }
}
//#region render: File
let FileReferencesTemplate = class FileReferencesTemplate extends (0, _lifecycleJs.Disposable) {
    constructor(container, _labelService){
        super();
        this._labelService = _labelService;
        const parent = document.createElement("div");
        parent.classList.add("reference-file");
        this.file = this._register(new (0, _iconLabelJs.IconLabel)(parent, {
            supportHighlights: true
        }));
        this.badge = new (0, _countBadgeJs.CountBadge)(_domJs.append(parent, _domJs.$(".count")), {}, (0, _defaultStylesJs.defaultCountBadgeStyles));
        container.appendChild(parent);
    }
    set(element, matches) {
        const parent = (0, _resourcesJs.dirname)(element.uri);
        this.file.setLabel(this._labelService.getUriBasenameLabel(element.uri), this._labelService.getUriLabel(parent, {
            relative: true
        }), {
            title: this._labelService.getUriLabel(element.uri),
            matches
        });
        const len = element.children.length;
        this.badge.setCount(len);
        if (len > 1) this.badge.setTitleFormat((0, _nlsJs.localize)("referencesCount", "{0} references", len));
        else this.badge.setTitleFormat((0, _nlsJs.localize)("referenceCount", "{0} reference", len));
    }
};
FileReferencesTemplate = __decorate([
    __param(1, (0, _labelJs.ILabelService))
], FileReferencesTemplate);
let FileReferencesRenderer = class FileReferencesRenderer {
    static{
        FileReferencesRenderer_1 = this;
    }
    static{
        this.id = "FileReferencesRenderer";
    }
    constructor(_instantiationService){
        this._instantiationService = _instantiationService;
        this.templateId = FileReferencesRenderer_1.id;
    }
    renderTemplate(container) {
        return this._instantiationService.createInstance(FileReferencesTemplate, container);
    }
    renderElement(node, index, template) {
        template.set(node.element, (0, _filtersJs.createMatches)(node.filterData));
    }
    disposeTemplate(templateData) {
        templateData.dispose();
    }
};
FileReferencesRenderer = FileReferencesRenderer_1 = __decorate([
    __param(0, (0, _instantiationJs.IInstantiationService))
], FileReferencesRenderer);
//#endregion
//#region render: Reference
class OneReferenceTemplate extends (0, _lifecycleJs.Disposable) {
    constructor(container){
        super();
        this.label = this._register(new (0, _highlightedLabelJs.HighlightedLabel)(container));
    }
    set(element, score) {
        const preview = element.parent.getPreview(element)?.preview(element.range);
        if (!preview || !preview.value) // this means we FAILED to resolve the document or the value is the empty string
        this.label.set(`${(0, _resourcesJs.basename)(element.uri)}:${element.range.startLineNumber + 1}:${element.range.startColumn + 1}`);
        else {
            // render search match as highlight unless
            // we have score, then render the score
            const { value, highlight } = preview;
            if (score && !(0, _filtersJs.FuzzyScore).isDefault(score)) {
                this.label.element.classList.toggle("referenceMatch", false);
                this.label.set(value, (0, _filtersJs.createMatches)(score));
            } else {
                this.label.element.classList.toggle("referenceMatch", true);
                this.label.set(value, [
                    highlight
                ]);
            }
        }
    }
}
class OneReferenceRenderer {
    constructor(){
        this.templateId = OneReferenceRenderer.id;
    }
    static{
        this.id = "OneReferenceRenderer";
    }
    renderTemplate(container) {
        return new OneReferenceTemplate(container);
    }
    renderElement(node, index, templateData) {
        templateData.set(node.element, node.filterData);
    }
    disposeTemplate(templateData) {
        templateData.dispose();
    }
}
class AccessibilityProvider {
    getWidgetAriaLabel() {
        return (0, _nlsJs.localize)("treeAriaLabel", "References");
    }
    getAriaLabel(element) {
        return element.ariaMessage;
    }
}

},{"../../../../../base/browser/dom.js":"bnqsM","../../../../../base/browser/ui/countBadge/countBadge.js":"2Bgie","../../../../../base/browser/ui/highlightedlabel/highlightedLabel.js":"dx5zl","../../../../../base/browser/ui/iconLabel/iconLabel.js":"jocWA","../../../../../base/common/filters.js":"40BGZ","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/resources.js":"700EV","../../../../common/services/resolverService.js":"ezAtF","../../../../../nls.js":"l617d","../../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../../platform/label/common/label.js":"esEqR","../../../../../platform/theme/browser/defaultStyles.js":"4exuA","../referencesModel.js":"789Jj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2TMSV":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ctxHasSymbols", ()=>ctxHasSymbols);
parcelHelpers.export(exports, "ISymbolNavigationService", ()=>ISymbolNavigationService);
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _resourcesJs = require("../../../../base/common/resources.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _rangeJs = require("../../../common/core/range.js");
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _extensionsJs = require("../../../../platform/instantiation/common/extensions.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _keybindingsRegistryJs = require("../../../../platform/keybinding/common/keybindingsRegistry.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const ctxHasSymbols = new (0, _contextkeyJs.RawContextKey)("hasSymbols", false, (0, _nlsJs.localize)("hasSymbols", "Whether there are symbol locations that can be navigated via keyboard-only."));
const ISymbolNavigationService = (0, _instantiationJs.createDecorator)("ISymbolNavigationService");
let SymbolNavigationService = class SymbolNavigationService {
    constructor(contextKeyService, _editorService, _notificationService, _keybindingService){
        this._editorService = _editorService;
        this._notificationService = _notificationService;
        this._keybindingService = _keybindingService;
        this._currentModel = undefined;
        this._currentIdx = -1;
        this._ignoreEditorChange = false;
        this._ctxHasSymbols = ctxHasSymbols.bindTo(contextKeyService);
    }
    reset() {
        this._ctxHasSymbols.reset();
        this._currentState?.dispose();
        this._currentMessage?.dispose();
        this._currentModel = undefined;
        this._currentIdx = -1;
    }
    put(anchor) {
        const refModel = anchor.parent.parent;
        if (refModel.references.length <= 1) {
            this.reset();
            return;
        }
        this._currentModel = refModel;
        this._currentIdx = refModel.references.indexOf(anchor);
        this._ctxHasSymbols.set(true);
        this._showMessage();
        const editorState = new EditorState(this._editorService);
        const listener = editorState.onDidChange((_)=>{
            if (this._ignoreEditorChange) return;
            const editor = this._editorService.getActiveCodeEditor();
            if (!editor) return;
            const model = editor.getModel();
            const position = editor.getPosition();
            if (!model || !position) return;
            let seenUri = false;
            let seenPosition = false;
            for (const reference of refModel.references){
                if ((0, _resourcesJs.isEqual)(reference.uri, model.uri)) {
                    seenUri = true;
                    seenPosition = seenPosition || (0, _rangeJs.Range).containsPosition(reference.range, position);
                } else if (seenUri) break;
            }
            if (!seenUri || !seenPosition) this.reset();
        });
        this._currentState = (0, _lifecycleJs.combinedDisposable)(editorState, listener);
    }
    revealNext(source) {
        if (!this._currentModel) return Promise.resolve();
        // get next result and advance
        this._currentIdx += 1;
        this._currentIdx %= this._currentModel.references.length;
        const reference = this._currentModel.references[this._currentIdx];
        // status
        this._showMessage();
        // open editor, ignore events while that happens
        this._ignoreEditorChange = true;
        return this._editorService.openCodeEditor({
            resource: reference.uri,
            options: {
                selection: (0, _rangeJs.Range).collapseToStart(reference.range),
                selectionRevealType: 3 /* TextEditorSelectionRevealType.NearTopIfOutsideViewport */ 
            }
        }, source).finally(()=>{
            this._ignoreEditorChange = false;
        });
    }
    _showMessage() {
        this._currentMessage?.dispose();
        const kb = this._keybindingService.lookupKeybinding("editor.gotoNextSymbolFromResult");
        const message = kb ? (0, _nlsJs.localize)("location.kb", "Symbol {0} of {1}, {2} for next", this._currentIdx + 1, this._currentModel.references.length, kb.getLabel()) : (0, _nlsJs.localize)("location", "Symbol {0} of {1}", this._currentIdx + 1, this._currentModel.references.length);
        this._currentMessage = this._notificationService.status(message);
    }
};
SymbolNavigationService = __decorate([
    __param(0, (0, _contextkeyJs.IContextKeyService)),
    __param(1, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(2, (0, _notificationJs.INotificationService)),
    __param(3, (0, _keybindingJs.IKeybindingService))
], SymbolNavigationService);
(0, _extensionsJs.registerSingleton)(ISymbolNavigationService, SymbolNavigationService, 1 /* InstantiationType.Delayed */ );
(0, _editorExtensionsJs.registerEditorCommand)(new class extends (0, _editorExtensionsJs.EditorCommand) {
    constructor(){
        super({
            id: "editor.gotoNextSymbolFromResult",
            precondition: ctxHasSymbols,
            kbOpts: {
                weight: 100 /* KeybindingWeight.EditorContrib */ ,
                primary: 70 /* KeyCode.F12 */ 
            }
        });
    }
    runEditorCommand(accessor, editor) {
        return accessor.get(ISymbolNavigationService).revealNext(editor);
    }
});
(0, _keybindingsRegistryJs.KeybindingsRegistry).registerCommandAndKeybindingRule({
    id: "editor.gotoNextSymbolFromResult.cancel",
    weight: 100 /* KeybindingWeight.EditorContrib */ ,
    when: ctxHasSymbols,
    primary: 9 /* KeyCode.Escape */ ,
    handler (accessor) {
        accessor.get(ISymbolNavigationService).reset();
    }
});
//
let EditorState = class EditorState {
    constructor(editorService){
        this._listener = new Map();
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._onDidChange = new (0, _eventJs.Emitter)();
        this.onDidChange = this._onDidChange.event;
        this._disposables.add(editorService.onCodeEditorRemove(this._onDidRemoveEditor, this));
        this._disposables.add(editorService.onCodeEditorAdd(this._onDidAddEditor, this));
        editorService.listCodeEditors().forEach(this._onDidAddEditor, this);
    }
    dispose() {
        this._disposables.dispose();
        this._onDidChange.dispose();
        (0, _lifecycleJs.dispose)(this._listener.values());
    }
    _onDidAddEditor(editor) {
        this._listener.set(editor, (0, _lifecycleJs.combinedDisposable)(editor.onDidChangeCursorPosition((_)=>this._onDidChange.fire({
                editor
            })), editor.onDidChangeModelContent((_)=>this._onDidChange.fire({
                editor
            }))));
    }
    _onDidRemoveEditor(editor) {
        this._listener.get(editor)?.dispose();
        this._listener.delete(editor);
    }
};
EditorState = __decorate([
    __param(0, (0, _codeEditorServiceJs.ICodeEditorService))
], EditorState);

},{"../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/resources.js":"700EV","../../../browser/editorExtensions.js":"kC3w6","../../../browser/services/codeEditorService.js":"bOWtl","../../../common/core/range.js":"jmUPh","../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/extensions.js":"6WJLq","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../platform/keybinding/common/keybindingsRegistry.js":"h9qfk","../../../../platform/notification/common/notification.js":"igv0W","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gz1YX":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefinitionsAtPosition", ()=>getDefinitionsAtPosition);
parcelHelpers.export(exports, "getDeclarationsAtPosition", ()=>getDeclarationsAtPosition);
parcelHelpers.export(exports, "getImplementationsAtPosition", ()=>getImplementationsAtPosition);
parcelHelpers.export(exports, "getTypeDefinitionsAtPosition", ()=>getTypeDefinitionsAtPosition);
parcelHelpers.export(exports, "getReferencesAtPosition", ()=>getReferencesAtPosition);
var _arraysJs = require("../../../../base/common/arrays.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _networkJs = require("../../../../base/common/network.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _referencesModelJs = require("./referencesModel.js");
function shouldIncludeLocationLink(sourceModel, loc) {
    // Always allow the location if the request comes from a document with the same scheme.
    if (loc.uri.scheme === sourceModel.uri.scheme) return true;
    // Otherwise filter out locations from internal schemes
    if ((0, _networkJs.matchesSomeScheme)(loc.uri, (0, _networkJs.Schemas).walkThroughSnippet, (0, _networkJs.Schemas).vscodeChatCodeBlock, (0, _networkJs.Schemas).vscodeChatCodeCompareBlock)) return false;
    return true;
}
async function getLocationLinks(model, position, registry, recursive, provide) {
    const provider = registry.ordered(model, recursive);
    // get results
    const promises = provider.map((provider)=>{
        return Promise.resolve(provide(provider, model, position)).then(undefined, (err)=>{
            (0, _errorsJs.onUnexpectedExternalError)(err);
            return undefined;
        });
    });
    const values = await Promise.all(promises);
    return (0, _arraysJs.coalesce)(values.flat()).filter((loc)=>shouldIncludeLocationLink(model, loc));
}
function getDefinitionsAtPosition(registry, model, position, recursive, token) {
    return getLocationLinks(model, position, registry, recursive, (provider, model, position)=>{
        return provider.provideDefinition(model, position, token);
    });
}
function getDeclarationsAtPosition(registry, model, position, recursive, token) {
    return getLocationLinks(model, position, registry, recursive, (provider, model, position)=>{
        return provider.provideDeclaration(model, position, token);
    });
}
function getImplementationsAtPosition(registry, model, position, recursive, token) {
    return getLocationLinks(model, position, registry, recursive, (provider, model, position)=>{
        return provider.provideImplementation(model, position, token);
    });
}
function getTypeDefinitionsAtPosition(registry, model, position, recursive, token) {
    return getLocationLinks(model, position, registry, recursive, (provider, model, position)=>{
        return provider.provideTypeDefinition(model, position, token);
    });
}
function getReferencesAtPosition(registry, model, position, compact, recursive, token) {
    return getLocationLinks(model, position, registry, recursive, async (provider, model, position)=>{
        const result = (await provider.provideReferences(model, position, {
            includeDeclaration: true
        }, token))?.filter((ref)=>shouldIncludeLocationLink(model, ref));
        if (!compact || !result || result.length !== 2) return result;
        const resultWithoutDeclaration = (await provider.provideReferences(model, position, {
            includeDeclaration: false
        }, token))?.filter((ref)=>shouldIncludeLocationLink(model, ref));
        if (resultWithoutDeclaration && resultWithoutDeclaration.length === 1) return resultWithoutDeclaration;
        return result;
    });
}
// -- API commands ----
async function _sortedAndDeduped(callback) {
    const rawLinks = await callback();
    const model = new (0, _referencesModelJs.ReferencesModel)(rawLinks, "");
    const modelLinks = model.references.map((ref)=>ref.link);
    model.dispose();
    return modelLinks;
}
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeDefinitionProvider", (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const promise = getDefinitionsAtPosition(languageFeaturesService.definitionProvider, model, position, false, (0, _cancellationJs.CancellationToken).None);
    return _sortedAndDeduped(()=>promise);
});
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeDefinitionProvider_recursive", (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const promise = getDefinitionsAtPosition(languageFeaturesService.definitionProvider, model, position, true, (0, _cancellationJs.CancellationToken).None);
    return _sortedAndDeduped(()=>promise);
});
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeTypeDefinitionProvider", (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const promise = getTypeDefinitionsAtPosition(languageFeaturesService.typeDefinitionProvider, model, position, false, (0, _cancellationJs.CancellationToken).None);
    return _sortedAndDeduped(()=>promise);
});
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeTypeDefinitionProvider_recursive", (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const promise = getTypeDefinitionsAtPosition(languageFeaturesService.typeDefinitionProvider, model, position, true, (0, _cancellationJs.CancellationToken).None);
    return _sortedAndDeduped(()=>promise);
});
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeDeclarationProvider", (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const promise = getDeclarationsAtPosition(languageFeaturesService.declarationProvider, model, position, false, (0, _cancellationJs.CancellationToken).None);
    return _sortedAndDeduped(()=>promise);
});
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeDeclarationProvider_recursive", (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const promise = getDeclarationsAtPosition(languageFeaturesService.declarationProvider, model, position, true, (0, _cancellationJs.CancellationToken).None);
    return _sortedAndDeduped(()=>promise);
});
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeReferenceProvider", (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const promise = getReferencesAtPosition(languageFeaturesService.referenceProvider, model, position, false, false, (0, _cancellationJs.CancellationToken).None);
    return _sortedAndDeduped(()=>promise);
});
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeReferenceProvider_recursive", (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const promise = getReferencesAtPosition(languageFeaturesService.referenceProvider, model, position, false, true, (0, _cancellationJs.CancellationToken).None);
    return _sortedAndDeduped(()=>promise);
});
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeImplementationProvider", (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const promise = getImplementationsAtPosition(languageFeaturesService.implementationProvider, model, position, false, (0, _cancellationJs.CancellationToken).None);
    return _sortedAndDeduped(()=>promise);
});
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeImplementationProvider_recursive", (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const promise = getImplementationsAtPosition(languageFeaturesService.implementationProvider, model, position, true, (0, _cancellationJs.CancellationToken).None);
    return _sortedAndDeduped(()=>promise);
});

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/network.js":"2c1AD","../../../browser/editorExtensions.js":"kC3w6","../../../common/services/languageFeatures.js":"2IAko","./referencesModel.js":"789Jj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jKoKx":[function() {},{}],"4oYbU":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShowOrFocusStandaloneColorPicker", ()=>ShowOrFocusStandaloneColorPicker);
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _nlsJs = require("../../../../nls.js");
var _standaloneColorPickerWidgetJs = require("./standaloneColorPickerWidget.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _colorPickerCss = require("./colorPicker.css");
class ShowOrFocusStandaloneColorPicker extends (0, _editorExtensionsJs.EditorAction2) {
    constructor(){
        super({
            id: "editor.action.showOrFocusStandaloneColorPicker",
            title: {
                ...(0, _nlsJs.localize2)("showOrFocusStandaloneColorPicker", "Show or Focus Standalone Color Picker"),
                mnemonicTitle: (0, _nlsJs.localize)({
                    key: "mishowOrFocusStandaloneColorPicker",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "&&Show or Focus Standalone Color Picker")
            },
            precondition: undefined,
            menu: [
                {
                    id: (0, _actionsJs.MenuId).CommandPalette
                }
            ],
            metadata: {
                description: (0, _nlsJs.localize2)("showOrFocusStandaloneColorPickerDescription", "Show or focus a standalone color picker which uses the default color provider. It displays hex/rgb/hsl colors.")
            }
        });
    }
    runEditorCommand(_accessor, editor) {
        (0, _standaloneColorPickerWidgetJs.StandaloneColorPickerController).get(editor)?.showOrFocus();
    }
}
class HideStandaloneColorPicker extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.hideColorPicker",
            label: (0, _nlsJs.localize)({
                key: "hideColorPicker",
                comment: [
                    "Action that hides the color picker"
                ]
            }, "Hide the Color Picker"),
            alias: "Hide the Color Picker",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).standaloneColorPickerVisible.isEqualTo(true),
            kbOpts: {
                primary: 9 /* KeyCode.Escape */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: (0, _nlsJs.localize2)("hideColorPickerDescription", "Hide the standalone color picker.")
            }
        });
    }
    run(_accessor, editor) {
        (0, _standaloneColorPickerWidgetJs.StandaloneColorPickerController).get(editor)?.hide();
    }
}
class InsertColorWithStandaloneColorPicker extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.insertColorWithStandaloneColorPicker",
            label: (0, _nlsJs.localize)({
                key: "insertColorWithStandaloneColorPicker",
                comment: [
                    "Action that inserts color with standalone color picker"
                ]
            }, "Insert Color with Standalone Color Picker"),
            alias: "Insert Color with Standalone Color Picker",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).standaloneColorPickerFocused.isEqualTo(true),
            kbOpts: {
                primary: 3 /* KeyCode.Enter */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: (0, _nlsJs.localize2)("insertColorWithStandaloneColorPickerDescription", "Insert hex/rgb/hsl colors with the focused standalone color picker.")
            }
        });
    }
    run(_accessor, editor) {
        (0, _standaloneColorPickerWidgetJs.StandaloneColorPickerController).get(editor)?.insertColor();
    }
}
(0, _editorExtensionsJs.registerEditorAction)(HideStandaloneColorPicker);
(0, _editorExtensionsJs.registerEditorAction)(InsertColorWithStandaloneColorPicker);
(0, _actionsJs.registerAction2)(ShowOrFocusStandaloneColorPicker);

},{"../../../browser/editorExtensions.js":"kC3w6","../../../../nls.js":"l617d","./standaloneColorPickerWidget.js":"5p6qP","../../../common/editorContextKeys.js":"5exv9","../../../../platform/actions/common/actions.js":"kyMtp","./colorPicker.css":"iFkXG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5p6qP":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandaloneColorPickerController", ()=>StandaloneColorPickerController);
parcelHelpers.export(exports, "StandaloneColorPickerWidget", ()=>StandaloneColorPickerWidget);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _colorHoverParticipantJs = require("./colorHoverParticipant.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _contentHoverStatusBarJs = require("../../hover/browser/contentHoverStatusBar.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _eventJs = require("../../../../base/common/event.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _defaultDocumentColorProviderJs = require("./defaultDocumentColorProvider.js");
var _domJs = require("../../../../base/browser/dom.js");
var _colorPickerCss = require("./colorPicker.css");
var _editorWorkerJs = require("../../../common/services/editorWorker.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var StandaloneColorPickerController_1, StandaloneColorPickerWidget_1;
let StandaloneColorPickerController = class StandaloneColorPickerController extends (0, _lifecycleJs.Disposable) {
    static{
        StandaloneColorPickerController_1 = this;
    }
    static{
        this.ID = "editor.contrib.standaloneColorPickerController";
    }
    constructor(_editor, _contextKeyService, _instantiationService){
        super();
        this._editor = _editor;
        this._instantiationService = _instantiationService;
        this._standaloneColorPickerWidget = null;
        this._standaloneColorPickerVisible = (0, _editorContextKeysJs.EditorContextKeys).standaloneColorPickerVisible.bindTo(_contextKeyService);
        this._standaloneColorPickerFocused = (0, _editorContextKeysJs.EditorContextKeys).standaloneColorPickerFocused.bindTo(_contextKeyService);
    }
    showOrFocus() {
        if (!this._editor.hasModel()) return;
        if (!this._standaloneColorPickerVisible.get()) this._standaloneColorPickerWidget = this._instantiationService.createInstance(StandaloneColorPickerWidget, this._editor, this._standaloneColorPickerVisible, this._standaloneColorPickerFocused);
        else if (!this._standaloneColorPickerFocused.get()) this._standaloneColorPickerWidget?.focus();
    }
    hide() {
        this._standaloneColorPickerFocused.set(false);
        this._standaloneColorPickerVisible.set(false);
        this._standaloneColorPickerWidget?.hide();
        this._editor.focus();
    }
    insertColor() {
        this._standaloneColorPickerWidget?.updateEditor();
        this.hide();
    }
    static get(editor) {
        return editor.getContribution(StandaloneColorPickerController_1.ID);
    }
};
StandaloneColorPickerController = StandaloneColorPickerController_1 = __decorate([
    __param(1, (0, _contextkeyJs.IContextKeyService)),
    __param(2, (0, _instantiationJs.IInstantiationService))
], StandaloneColorPickerController);
(0, _editorExtensionsJs.registerEditorContribution)(StandaloneColorPickerController.ID, StandaloneColorPickerController, 1 /* EditorContributionInstantiation.AfterFirstRender */ );
const PADDING = 8;
const CLOSE_BUTTON_WIDTH = 22;
let StandaloneColorPickerWidget = class StandaloneColorPickerWidget extends (0, _lifecycleJs.Disposable) {
    static{
        StandaloneColorPickerWidget_1 = this;
    }
    static{
        this.ID = "editor.contrib.standaloneColorPickerWidget";
    }
    constructor(_editor, _standaloneColorPickerVisible, _standaloneColorPickerFocused, _instantiationService, _keybindingService, _languageFeaturesService, _editorWorkerService){
        super();
        this._editor = _editor;
        this._standaloneColorPickerVisible = _standaloneColorPickerVisible;
        this._standaloneColorPickerFocused = _standaloneColorPickerFocused;
        this._keybindingService = _keybindingService;
        this._languageFeaturesService = _languageFeaturesService;
        this._editorWorkerService = _editorWorkerService;
        this.allowEditorOverflow = true;
        this._position = undefined;
        this._body = document.createElement("div");
        this._colorHover = null;
        this._selectionSetInEditor = false;
        this._onResult = this._register(new (0, _eventJs.Emitter)());
        this.onResult = this._onResult.event;
        this._standaloneColorPickerVisible.set(true);
        this._standaloneColorPickerParticipant = _instantiationService.createInstance((0, _colorHoverParticipantJs.StandaloneColorPickerParticipant), this._editor);
        this._position = this._editor._getViewModel()?.getPrimaryCursorState().modelState.position;
        const editorSelection = this._editor.getSelection();
        const selection = editorSelection ? {
            startLineNumber: editorSelection.startLineNumber,
            startColumn: editorSelection.startColumn,
            endLineNumber: editorSelection.endLineNumber,
            endColumn: editorSelection.endColumn
        } : {
            startLineNumber: 0,
            endLineNumber: 0,
            endColumn: 0,
            startColumn: 0
        };
        const focusTracker = this._register(_domJs.trackFocus(this._body));
        this._register(focusTracker.onDidBlur((_)=>{
            this.hide();
        }));
        this._register(focusTracker.onDidFocus((_)=>{
            this.focus();
        }));
        // When the cursor position changes, hide the color picker
        this._register(this._editor.onDidChangeCursorPosition(()=>{
            // Do not hide the color picker when the cursor changes position due to the keybindings
            if (!this._selectionSetInEditor) this.hide();
            else this._selectionSetInEditor = false;
        }));
        this._register(this._editor.onMouseMove((e)=>{
            const classList = e.target.element?.classList;
            if (classList && classList.contains("colorpicker-color-decoration")) this.hide();
        }));
        this._register(this.onResult((result)=>{
            this._render(result.value, result.foundInEditor);
        }));
        this._start(selection);
        this._body.style.zIndex = "50";
        this._editor.addContentWidget(this);
    }
    updateEditor() {
        if (this._colorHover) this._standaloneColorPickerParticipant.updateEditorModel(this._colorHover);
    }
    getId() {
        return StandaloneColorPickerWidget_1.ID;
    }
    getDomNode() {
        return this._body;
    }
    getPosition() {
        if (!this._position) return null;
        const positionPreference = this._editor.getOption(60 /* EditorOption.hover */ ).above;
        return {
            position: this._position,
            secondaryPosition: this._position,
            preference: positionPreference ? [
                1 /* ContentWidgetPositionPreference.ABOVE */ ,
                2 /* ContentWidgetPositionPreference.BELOW */ 
            ] : [
                2 /* ContentWidgetPositionPreference.BELOW */ ,
                1 /* ContentWidgetPositionPreference.ABOVE */ 
            ],
            positionAffinity: 2 /* PositionAffinity.None */ 
        };
    }
    hide() {
        this.dispose();
        this._standaloneColorPickerVisible.set(false);
        this._standaloneColorPickerFocused.set(false);
        this._editor.removeContentWidget(this);
        this._editor.focus();
    }
    focus() {
        this._standaloneColorPickerFocused.set(true);
        this._body.focus();
    }
    async _start(selection) {
        const computeAsyncResult = await this._computeAsync(selection);
        if (!computeAsyncResult) return;
        this._onResult.fire(new StandaloneColorPickerResult(computeAsyncResult.result, computeAsyncResult.foundInEditor));
    }
    async _computeAsync(range) {
        if (!this._editor.hasModel()) return null;
        const colorInfo = {
            range: range,
            color: {
                red: 0,
                green: 0,
                blue: 0,
                alpha: 1
            }
        };
        const colorHoverResult = await this._standaloneColorPickerParticipant.createColorHover(colorInfo, new (0, _defaultDocumentColorProviderJs.DefaultDocumentColorProvider)(this._editorWorkerService), this._languageFeaturesService.colorProvider);
        if (!colorHoverResult) return null;
        return {
            result: colorHoverResult.colorHover,
            foundInEditor: colorHoverResult.foundInEditor
        };
    }
    _render(colorHover, foundInEditor) {
        const fragment = document.createDocumentFragment();
        const statusBar = this._register(new (0, _contentHoverStatusBarJs.EditorHoverStatusBar)(this._keybindingService));
        const context = {
            fragment,
            statusBar,
            onContentsChanged: ()=>{},
            hide: ()=>this.hide()
        };
        this._colorHover = colorHover;
        const renderedHoverPart = this._standaloneColorPickerParticipant.renderHoverParts(context, [
            colorHover
        ]);
        if (!renderedHoverPart) return;
        this._register(renderedHoverPart.disposables);
        const colorPicker = renderedHoverPart.colorPicker;
        this._body.classList.add("standalone-colorpicker-body");
        this._body.style.maxHeight = Math.max(this._editor.getLayoutInfo().height / 4, 250) + "px";
        this._body.style.maxWidth = Math.max(this._editor.getLayoutInfo().width * 0.66, 500) + "px";
        this._body.tabIndex = 0;
        this._body.appendChild(fragment);
        colorPicker.layout();
        const colorPickerBody = colorPicker.body;
        const saturationBoxWidth = colorPickerBody.saturationBox.domNode.clientWidth;
        const widthOfOriginalColorBox = colorPickerBody.domNode.clientWidth - saturationBoxWidth - CLOSE_BUTTON_WIDTH - PADDING;
        const enterButton = colorPicker.body.enterButton;
        enterButton?.onClicked(()=>{
            this.updateEditor();
            this.hide();
        });
        const colorPickerHeader = colorPicker.header;
        const pickedColorNode = colorPickerHeader.pickedColorNode;
        pickedColorNode.style.width = saturationBoxWidth + PADDING + "px";
        const originalColorNode = colorPickerHeader.originalColorNode;
        originalColorNode.style.width = widthOfOriginalColorBox + "px";
        const closeButton = colorPicker.header.closeButton;
        closeButton?.onClicked(()=>{
            this.hide();
        });
        // When found in the editor, highlight the selection in the editor
        if (foundInEditor) {
            if (enterButton) enterButton.button.textContent = "Replace";
            this._selectionSetInEditor = true;
            this._editor.setSelection(colorHover.range);
        }
        this._editor.layoutContentWidget(this);
    }
};
StandaloneColorPickerWidget = StandaloneColorPickerWidget_1 = __decorate([
    __param(3, (0, _instantiationJs.IInstantiationService)),
    __param(4, (0, _keybindingJs.IKeybindingService)),
    __param(5, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(6, (0, _editorWorkerJs.IEditorWorkerService))
], StandaloneColorPickerWidget);
class StandaloneColorPickerResult {
    // The color picker result consists of: an array of color results and a boolean indicating if the color was found in the editor
    constructor(value, foundInEditor){
        this.value = value;
        this.foundInEditor = foundInEditor;
    }
}

},{"../../../../base/common/lifecycle.js":"9kg8d","./colorHoverParticipant.js":"bidr4","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../hover/browser/contentHoverStatusBar.js":"1zx4D","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../base/common/event.js":"4Zi8b","../../../common/services/languageFeatures.js":"2IAko","../../../browser/editorExtensions.js":"kC3w6","../../../common/editorContextKeys.js":"5exv9","../../../../platform/contextkey/common/contextkey.js":"gXuBD","./defaultDocumentColorProvider.js":"4drIE","../../../../base/browser/dom.js":"bnqsM","./colorPicker.css":"iFkXG","../../../common/services/editorWorker.js":"aaYJd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iFkXG":[function() {},{}],"iFkXG":[function() {},{}],"Nwp5Z":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _keyCodesJs = require("../../../../base/common/keyCodes.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _blockCommentCommandJs = require("./blockCommentCommand.js");
var _lineCommentCommandJs = require("./lineCommentCommand.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
class CommentLineAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(type, opts){
        super(opts);
        this._type = type;
    }
    run(accessor, editor) {
        const languageConfigurationService = accessor.get((0, _languageConfigurationRegistryJs.ILanguageConfigurationService));
        if (!editor.hasModel()) return;
        const model = editor.getModel();
        const commands = [];
        const modelOptions = model.getOptions();
        const commentsOptions = editor.getOption(23 /* EditorOption.comments */ );
        const selections = editor.getSelections().map((selection, index)=>({
                selection,
                index,
                ignoreFirstLine: false
            }));
        selections.sort((a, b)=>(0, _rangeJs.Range).compareRangesUsingStarts(a.selection, b.selection));
        // Remove selections that would result in copying the same line
        let prev = selections[0];
        for(let i = 1; i < selections.length; i++){
            const curr = selections[i];
            if (prev.selection.endLineNumber === curr.selection.startLineNumber) {
                // these two selections would copy the same line
                if (prev.index < curr.index) // prev wins
                curr.ignoreFirstLine = true;
                else {
                    // curr wins
                    prev.ignoreFirstLine = true;
                    prev = curr;
                }
            }
        }
        for (const selection of selections)commands.push(new (0, _lineCommentCommandJs.LineCommentCommand)(languageConfigurationService, selection.selection, modelOptions.indentSize, this._type, commentsOptions.insertSpace, commentsOptions.ignoreEmptyLines, selection.ignoreFirstLine));
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    }
}
class ToggleCommentLineAction extends CommentLineAction {
    constructor(){
        super(0 /* Type.Toggle */ , {
            id: "editor.action.commentLine",
            label: _nlsJs.localize("comment.line", "Toggle Line Comment"),
            alias: "Toggle Line Comment",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 2138 /* KeyCode.Slash */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarEditMenu,
                group: "5_insert",
                title: _nlsJs.localize({
                    key: "miToggleLineComment",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "&&Toggle Line Comment"),
                order: 1
            }
        });
    }
}
class AddLineCommentAction extends CommentLineAction {
    constructor(){
        super(1 /* Type.ForceAdd */ , {
            id: "editor.action.addCommentLine",
            label: _nlsJs.localize("comment.line.add", "Add Line Comment"),
            alias: "Add Line Comment",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2081 /* KeyCode.KeyC */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
class RemoveLineCommentAction extends CommentLineAction {
    constructor(){
        super(2 /* Type.ForceRemove */ , {
            id: "editor.action.removeCommentLine",
            label: _nlsJs.localize("comment.line.remove", "Remove Line Comment"),
            alias: "Remove Line Comment",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2099 /* KeyCode.KeyU */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
class BlockCommentAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.blockComment",
            label: _nlsJs.localize("comment.block", "Toggle Block Comment"),
            alias: "Toggle Block Comment",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 1567 /* KeyCode.KeyA */ ,
                linux: {
                    primary: 3103 /* KeyCode.KeyA */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarEditMenu,
                group: "5_insert",
                title: _nlsJs.localize({
                    key: "miToggleBlockComment",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Toggle &&Block Comment"),
                order: 2
            }
        });
    }
    run(accessor, editor) {
        const languageConfigurationService = accessor.get((0, _languageConfigurationRegistryJs.ILanguageConfigurationService));
        if (!editor.hasModel()) return;
        const commentsOptions = editor.getOption(23 /* EditorOption.comments */ );
        const commands = [];
        const selections = editor.getSelections();
        for (const selection of selections)commands.push(new (0, _blockCommentCommandJs.BlockCommentCommand)(selection, commentsOptions.insertSpace, languageConfigurationService));
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    }
}
(0, _editorExtensionsJs.registerEditorAction)(ToggleCommentLineAction);
(0, _editorExtensionsJs.registerEditorAction)(AddLineCommentAction);
(0, _editorExtensionsJs.registerEditorAction)(RemoveLineCommentAction);
(0, _editorExtensionsJs.registerEditorAction)(BlockCommentAction);

},{"../../../../base/common/keyCodes.js":"bHiG9","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/range.js":"jmUPh","../../../common/editorContextKeys.js":"5exv9","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","./blockCommentCommand.js":"6VpbX","./lineCommentCommand.js":"i6JOL","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp"}],"6VpbX":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockCommentCommand", ()=>BlockCommentCommand);
var _editOperationJs = require("../../../common/core/editOperation.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
class BlockCommentCommand {
    constructor(selection, insertSpace, languageConfigurationService){
        this.languageConfigurationService = languageConfigurationService;
        this._selection = selection;
        this._insertSpace = insertSpace;
        this._usedEndToken = null;
    }
    static _haystackHasNeedleAtOffset(haystack, needle, offset) {
        if (offset < 0) return false;
        const needleLength = needle.length;
        const haystackLength = haystack.length;
        if (offset + needleLength > haystackLength) return false;
        for(let i = 0; i < needleLength; i++){
            const codeA = haystack.charCodeAt(offset + i);
            const codeB = needle.charCodeAt(i);
            if (codeA === codeB) continue;
            if (codeA >= 65 /* CharCode.A */  && codeA <= 90 /* CharCode.Z */  && codeA + 32 === codeB) continue;
            if (codeB >= 65 /* CharCode.A */  && codeB <= 90 /* CharCode.Z */  && codeB + 32 === codeA) continue;
            return false;
        }
        return true;
    }
    _createOperationsForBlockComment(selection, startToken, endToken, insertSpace, model, builder) {
        const startLineNumber = selection.startLineNumber;
        const startColumn = selection.startColumn;
        const endLineNumber = selection.endLineNumber;
        const endColumn = selection.endColumn;
        const startLineText = model.getLineContent(startLineNumber);
        const endLineText = model.getLineContent(endLineNumber);
        let startTokenIndex = startLineText.lastIndexOf(startToken, startColumn - 1 + startToken.length);
        let endTokenIndex = endLineText.indexOf(endToken, endColumn - 1 - endToken.length);
        if (startTokenIndex !== -1 && endTokenIndex !== -1) {
            if (startLineNumber === endLineNumber) {
                const lineBetweenTokens = startLineText.substring(startTokenIndex + startToken.length, endTokenIndex);
                if (lineBetweenTokens.indexOf(endToken) >= 0) {
                    // force to add a block comment
                    startTokenIndex = -1;
                    endTokenIndex = -1;
                }
            } else {
                const startLineAfterStartToken = startLineText.substring(startTokenIndex + startToken.length);
                const endLineBeforeEndToken = endLineText.substring(0, endTokenIndex);
                if (startLineAfterStartToken.indexOf(endToken) >= 0 || endLineBeforeEndToken.indexOf(endToken) >= 0) {
                    // force to add a block comment
                    startTokenIndex = -1;
                    endTokenIndex = -1;
                }
            }
        }
        let ops;
        if (startTokenIndex !== -1 && endTokenIndex !== -1) {
            // Consider spaces as part of the comment tokens
            if (insertSpace && startTokenIndex + startToken.length < startLineText.length && startLineText.charCodeAt(startTokenIndex + startToken.length) === 32 /* CharCode.Space */ ) // Pretend the start token contains a trailing space
            startToken = startToken + " ";
            if (insertSpace && endTokenIndex > 0 && endLineText.charCodeAt(endTokenIndex - 1) === 32 /* CharCode.Space */ ) {
                // Pretend the end token contains a leading space
                endToken = " " + endToken;
                endTokenIndex -= 1;
            }
            ops = BlockCommentCommand._createRemoveBlockCommentOperations(new (0, _rangeJs.Range)(startLineNumber, startTokenIndex + startToken.length + 1, endLineNumber, endTokenIndex + 1), startToken, endToken);
        } else {
            ops = BlockCommentCommand._createAddBlockCommentOperations(selection, startToken, endToken, this._insertSpace);
            this._usedEndToken = ops.length === 1 ? endToken : null;
        }
        for (const op of ops)builder.addTrackedEditOperation(op.range, op.text);
    }
    static _createRemoveBlockCommentOperations(r, startToken, endToken) {
        const res = [];
        if (!(0, _rangeJs.Range).isEmpty(r)) {
            // Remove block comment start
            res.push((0, _editOperationJs.EditOperation).delete(new (0, _rangeJs.Range)(r.startLineNumber, r.startColumn - startToken.length, r.startLineNumber, r.startColumn)));
            // Remove block comment end
            res.push((0, _editOperationJs.EditOperation).delete(new (0, _rangeJs.Range)(r.endLineNumber, r.endColumn, r.endLineNumber, r.endColumn + endToken.length)));
        } else // Remove both continuously
        res.push((0, _editOperationJs.EditOperation).delete(new (0, _rangeJs.Range)(r.startLineNumber, r.startColumn - startToken.length, r.endLineNumber, r.endColumn + endToken.length)));
        return res;
    }
    static _createAddBlockCommentOperations(r, startToken, endToken, insertSpace) {
        const res = [];
        if (!(0, _rangeJs.Range).isEmpty(r)) {
            // Insert block comment start
            res.push((0, _editOperationJs.EditOperation).insert(new (0, _positionJs.Position)(r.startLineNumber, r.startColumn), startToken + (insertSpace ? " " : "")));
            // Insert block comment end
            res.push((0, _editOperationJs.EditOperation).insert(new (0, _positionJs.Position)(r.endLineNumber, r.endColumn), (insertSpace ? " " : "") + endToken));
        } else // Insert both continuously
        res.push((0, _editOperationJs.EditOperation).replace(new (0, _rangeJs.Range)(r.startLineNumber, r.startColumn, r.endLineNumber, r.endColumn), startToken + "  " + endToken));
        return res;
    }
    getEditOperations(model, builder) {
        const startLineNumber = this._selection.startLineNumber;
        const startColumn = this._selection.startColumn;
        model.tokenization.tokenizeIfCheap(startLineNumber);
        const languageId = model.getLanguageIdAtPosition(startLineNumber, startColumn);
        const config = this.languageConfigurationService.getLanguageConfiguration(languageId).comments;
        if (!config || !config.blockCommentStartToken || !config.blockCommentEndToken) // Mode does not support block comments
        return;
        this._createOperationsForBlockComment(this._selection, config.blockCommentStartToken, config.blockCommentEndToken, this._insertSpace, model, builder);
    }
    computeCursorState(model, helper) {
        const inverseEditOperations = helper.getInverseEditOperations();
        if (inverseEditOperations.length === 2) {
            const startTokenEditOperation = inverseEditOperations[0];
            const endTokenEditOperation = inverseEditOperations[1];
            return new (0, _selectionJs.Selection)(startTokenEditOperation.range.endLineNumber, startTokenEditOperation.range.endColumn, endTokenEditOperation.range.startLineNumber, endTokenEditOperation.range.startColumn);
        } else {
            const srcRange = inverseEditOperations[0].range;
            const deltaColumn = this._usedEndToken ? -this._usedEndToken.length - 1 : 0; // minus 1 space before endToken
            return new (0, _selectionJs.Selection)(srcRange.endLineNumber, srcRange.endColumn + deltaColumn, srcRange.endLineNumber, srcRange.endColumn + deltaColumn);
        }
    }
}

},{"../../../common/core/editOperation.js":"6r2FZ","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i6JOL":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineCommentCommand", ()=>LineCommentCommand);
var _stringsJs = require("../../../../base/common/strings.js");
var _editOperationJs = require("../../../common/core/editOperation.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _blockCommentCommandJs = require("./blockCommentCommand.js");
class LineCommentCommand {
    constructor(languageConfigurationService, selection, indentSize, type, insertSpace, ignoreEmptyLines, ignoreFirstLine){
        this.languageConfigurationService = languageConfigurationService;
        this._selection = selection;
        this._indentSize = indentSize;
        this._type = type;
        this._insertSpace = insertSpace;
        this._selectionId = null;
        this._deltaColumn = 0;
        this._moveEndPositionDown = false;
        this._ignoreEmptyLines = ignoreEmptyLines;
        this._ignoreFirstLine = ignoreFirstLine || false;
    }
    /**
     * Do an initial pass over the lines and gather info about the line comment string.
     * Returns null if any of the lines doesn't support a line comment string.
     */ static _gatherPreflightCommentStrings(model, startLineNumber, endLineNumber, languageConfigurationService) {
        model.tokenization.tokenizeIfCheap(startLineNumber);
        const languageId = model.getLanguageIdAtPosition(startLineNumber, 1);
        const config = languageConfigurationService.getLanguageConfiguration(languageId).comments;
        const commentStr = config ? config.lineCommentToken : null;
        if (!commentStr) // Mode does not support line comments
        return null;
        const lines = [];
        for(let i = 0, lineCount = endLineNumber - startLineNumber + 1; i < lineCount; i++)lines[i] = {
            ignore: false,
            commentStr: commentStr,
            commentStrOffset: 0,
            commentStrLength: commentStr.length
        };
        return lines;
    }
    /**
     * Analyze lines and decide which lines are relevant and what the toggle should do.
     * Also, build up several offsets and lengths useful in the generation of editor operations.
     */ static _analyzeLines(type, insertSpace, model, lines, startLineNumber, ignoreEmptyLines, ignoreFirstLine, languageConfigurationService) {
        let onlyWhitespaceLines = true;
        let shouldRemoveComments;
        if (type === 0 /* Type.Toggle */ ) shouldRemoveComments = true;
        else if (type === 1 /* Type.ForceAdd */ ) shouldRemoveComments = false;
        else shouldRemoveComments = true;
        for(let i = 0, lineCount = lines.length; i < lineCount; i++){
            const lineData = lines[i];
            const lineNumber = startLineNumber + i;
            if (lineNumber === startLineNumber && ignoreFirstLine) {
                // first line ignored
                lineData.ignore = true;
                continue;
            }
            const lineContent = model.getLineContent(lineNumber);
            const lineContentStartOffset = _stringsJs.firstNonWhitespaceIndex(lineContent);
            if (lineContentStartOffset === -1) {
                // Empty or whitespace only line
                lineData.ignore = ignoreEmptyLines;
                lineData.commentStrOffset = lineContent.length;
                continue;
            }
            onlyWhitespaceLines = false;
            lineData.ignore = false;
            lineData.commentStrOffset = lineContentStartOffset;
            if (shouldRemoveComments && !(0, _blockCommentCommandJs.BlockCommentCommand)._haystackHasNeedleAtOffset(lineContent, lineData.commentStr, lineContentStartOffset)) {
                if (type === 0 /* Type.Toggle */ ) // Every line so far has been a line comment, but this one is not
                shouldRemoveComments = false;
                else if (type === 1 /* Type.ForceAdd */ ) ;
                else lineData.ignore = true;
            }
            if (shouldRemoveComments && insertSpace) {
                // Remove a following space if present
                const commentStrEndOffset = lineContentStartOffset + lineData.commentStrLength;
                if (commentStrEndOffset < lineContent.length && lineContent.charCodeAt(commentStrEndOffset) === 32 /* CharCode.Space */ ) lineData.commentStrLength += 1;
            }
        }
        if (type === 0 /* Type.Toggle */  && onlyWhitespaceLines) {
            // For only whitespace lines, we insert comments
            shouldRemoveComments = false;
            // Also, no longer ignore them
            for(let i = 0, lineCount = lines.length; i < lineCount; i++)lines[i].ignore = false;
        }
        return {
            supported: true,
            shouldRemoveComments: shouldRemoveComments,
            lines: lines
        };
    }
    /**
     * Analyze all lines and decide exactly what to do => not supported | insert line comments | remove line comments
     */ static _gatherPreflightData(type, insertSpace, model, startLineNumber, endLineNumber, ignoreEmptyLines, ignoreFirstLine, languageConfigurationService) {
        const lines = LineCommentCommand._gatherPreflightCommentStrings(model, startLineNumber, endLineNumber, languageConfigurationService);
        if (lines === null) return {
            supported: false
        };
        return LineCommentCommand._analyzeLines(type, insertSpace, model, lines, startLineNumber, ignoreEmptyLines, ignoreFirstLine, languageConfigurationService);
    }
    /**
     * Given a successful analysis, execute either insert line comments, either remove line comments
     */ _executeLineComments(model, builder, data, s) {
        let ops;
        if (data.shouldRemoveComments) ops = LineCommentCommand._createRemoveLineCommentsOperations(data.lines, s.startLineNumber);
        else {
            LineCommentCommand._normalizeInsertionPoint(model, data.lines, s.startLineNumber, this._indentSize);
            ops = this._createAddLineCommentsOperations(data.lines, s.startLineNumber);
        }
        const cursorPosition = new (0, _positionJs.Position)(s.positionLineNumber, s.positionColumn);
        for(let i = 0, len = ops.length; i < len; i++){
            builder.addEditOperation(ops[i].range, ops[i].text);
            if ((0, _rangeJs.Range).isEmpty(ops[i].range) && (0, _rangeJs.Range).getStartPosition(ops[i].range).equals(cursorPosition)) {
                const lineContent = model.getLineContent(cursorPosition.lineNumber);
                if (lineContent.length + 1 === cursorPosition.column) this._deltaColumn = (ops[i].text || "").length;
            }
        }
        this._selectionId = builder.trackSelection(s);
    }
    _attemptRemoveBlockComment(model, s, startToken, endToken) {
        let startLineNumber = s.startLineNumber;
        let endLineNumber = s.endLineNumber;
        const startTokenAllowedBeforeColumn = endToken.length + Math.max(model.getLineFirstNonWhitespaceColumn(s.startLineNumber), s.startColumn);
        let startTokenIndex = model.getLineContent(startLineNumber).lastIndexOf(startToken, startTokenAllowedBeforeColumn - 1);
        let endTokenIndex = model.getLineContent(endLineNumber).indexOf(endToken, s.endColumn - 1 - startToken.length);
        if (startTokenIndex !== -1 && endTokenIndex === -1) {
            endTokenIndex = model.getLineContent(startLineNumber).indexOf(endToken, startTokenIndex + startToken.length);
            endLineNumber = startLineNumber;
        }
        if (startTokenIndex === -1 && endTokenIndex !== -1) {
            startTokenIndex = model.getLineContent(endLineNumber).lastIndexOf(startToken, endTokenIndex);
            startLineNumber = endLineNumber;
        }
        if (s.isEmpty() && (startTokenIndex === -1 || endTokenIndex === -1)) {
            startTokenIndex = model.getLineContent(startLineNumber).indexOf(startToken);
            if (startTokenIndex !== -1) endTokenIndex = model.getLineContent(startLineNumber).indexOf(endToken, startTokenIndex + startToken.length);
        }
        // We have to adjust to possible inner white space.
        // For Space after startToken, add Space to startToken - range math will work out.
        if (startTokenIndex !== -1 && model.getLineContent(startLineNumber).charCodeAt(startTokenIndex + startToken.length) === 32 /* CharCode.Space */ ) startToken += " ";
        // For Space before endToken, add Space before endToken and shift index one left.
        if (endTokenIndex !== -1 && model.getLineContent(endLineNumber).charCodeAt(endTokenIndex - 1) === 32 /* CharCode.Space */ ) {
            endToken = " " + endToken;
            endTokenIndex -= 1;
        }
        if (startTokenIndex !== -1 && endTokenIndex !== -1) return (0, _blockCommentCommandJs.BlockCommentCommand)._createRemoveBlockCommentOperations(new (0, _rangeJs.Range)(startLineNumber, startTokenIndex + startToken.length + 1, endLineNumber, endTokenIndex + 1), startToken, endToken);
        return null;
    }
    /**
     * Given an unsuccessful analysis, delegate to the block comment command
     */ _executeBlockComment(model, builder, s) {
        model.tokenization.tokenizeIfCheap(s.startLineNumber);
        const languageId = model.getLanguageIdAtPosition(s.startLineNumber, 1);
        const config = this.languageConfigurationService.getLanguageConfiguration(languageId).comments;
        if (!config || !config.blockCommentStartToken || !config.blockCommentEndToken) // Mode does not support block comments
        return;
        const startToken = config.blockCommentStartToken;
        const endToken = config.blockCommentEndToken;
        let ops = this._attemptRemoveBlockComment(model, s, startToken, endToken);
        if (!ops) {
            if (s.isEmpty()) {
                const lineContent = model.getLineContent(s.startLineNumber);
                let firstNonWhitespaceIndex = _stringsJs.firstNonWhitespaceIndex(lineContent);
                if (firstNonWhitespaceIndex === -1) // Line is empty or contains only whitespace
                firstNonWhitespaceIndex = lineContent.length;
                ops = (0, _blockCommentCommandJs.BlockCommentCommand)._createAddBlockCommentOperations(new (0, _rangeJs.Range)(s.startLineNumber, firstNonWhitespaceIndex + 1, s.startLineNumber, lineContent.length + 1), startToken, endToken, this._insertSpace);
            } else ops = (0, _blockCommentCommandJs.BlockCommentCommand)._createAddBlockCommentOperations(new (0, _rangeJs.Range)(s.startLineNumber, model.getLineFirstNonWhitespaceColumn(s.startLineNumber), s.endLineNumber, model.getLineMaxColumn(s.endLineNumber)), startToken, endToken, this._insertSpace);
            if (ops.length === 1) // Leave cursor after token and Space
            this._deltaColumn = startToken.length + 1;
        }
        this._selectionId = builder.trackSelection(s);
        for (const op of ops)builder.addEditOperation(op.range, op.text);
    }
    getEditOperations(model, builder) {
        let s = this._selection;
        this._moveEndPositionDown = false;
        if (s.startLineNumber === s.endLineNumber && this._ignoreFirstLine) {
            builder.addEditOperation(new (0, _rangeJs.Range)(s.startLineNumber, model.getLineMaxColumn(s.startLineNumber), s.startLineNumber + 1, 1), s.startLineNumber === model.getLineCount() ? "" : "\n");
            this._selectionId = builder.trackSelection(s);
            return;
        }
        if (s.startLineNumber < s.endLineNumber && s.endColumn === 1) {
            this._moveEndPositionDown = true;
            s = s.setEndPosition(s.endLineNumber - 1, model.getLineMaxColumn(s.endLineNumber - 1));
        }
        const data = LineCommentCommand._gatherPreflightData(this._type, this._insertSpace, model, s.startLineNumber, s.endLineNumber, this._ignoreEmptyLines, this._ignoreFirstLine, this.languageConfigurationService);
        if (data.supported) return this._executeLineComments(model, builder, data, s);
        return this._executeBlockComment(model, builder, s);
    }
    computeCursorState(model, helper) {
        let result = helper.getTrackedSelection(this._selectionId);
        if (this._moveEndPositionDown) result = result.setEndPosition(result.endLineNumber + 1, 1);
        return new (0, _selectionJs.Selection)(result.selectionStartLineNumber, result.selectionStartColumn + this._deltaColumn, result.positionLineNumber, result.positionColumn + this._deltaColumn);
    }
    /**
     * Generate edit operations in the remove line comment case
     */ static _createRemoveLineCommentsOperations(lines, startLineNumber) {
        const res = [];
        for(let i = 0, len = lines.length; i < len; i++){
            const lineData = lines[i];
            if (lineData.ignore) continue;
            res.push((0, _editOperationJs.EditOperation).delete(new (0, _rangeJs.Range)(startLineNumber + i, lineData.commentStrOffset + 1, startLineNumber + i, lineData.commentStrOffset + lineData.commentStrLength + 1)));
        }
        return res;
    }
    /**
     * Generate edit operations in the add line comment case
     */ _createAddLineCommentsOperations(lines, startLineNumber) {
        const res = [];
        const afterCommentStr = this._insertSpace ? " " : "";
        for(let i = 0, len = lines.length; i < len; i++){
            const lineData = lines[i];
            if (lineData.ignore) continue;
            res.push((0, _editOperationJs.EditOperation).insert(new (0, _positionJs.Position)(startLineNumber + i, lineData.commentStrOffset + 1), lineData.commentStr + afterCommentStr));
        }
        return res;
    }
    static nextVisibleColumn(currentVisibleColumn, indentSize, isTab, columnSize) {
        if (isTab) return currentVisibleColumn + (indentSize - currentVisibleColumn % indentSize);
        return currentVisibleColumn + columnSize;
    }
    /**
     * Adjust insertion points to have them vertically aligned in the add line comment case
     */ static _normalizeInsertionPoint(model, lines, startLineNumber, indentSize) {
        let minVisibleColumn = 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ ;
        let j;
        let lenJ;
        for(let i = 0, len = lines.length; i < len; i++){
            if (lines[i].ignore) continue;
            const lineContent = model.getLineContent(startLineNumber + i);
            let currentVisibleColumn = 0;
            for(let j = 0, lenJ = lines[i].commentStrOffset; currentVisibleColumn < minVisibleColumn && j < lenJ; j++)currentVisibleColumn = LineCommentCommand.nextVisibleColumn(currentVisibleColumn, indentSize, lineContent.charCodeAt(j) === 9 /* CharCode.Tab */ , 1);
            if (currentVisibleColumn < minVisibleColumn) minVisibleColumn = currentVisibleColumn;
        }
        minVisibleColumn = Math.floor(minVisibleColumn / indentSize) * indentSize;
        for(let i = 0, len = lines.length; i < len; i++){
            if (lines[i].ignore) continue;
            const lineContent = model.getLineContent(startLineNumber + i);
            let currentVisibleColumn = 0;
            for(j = 0, lenJ = lines[i].commentStrOffset; currentVisibleColumn < minVisibleColumn && j < lenJ; j++)currentVisibleColumn = LineCommentCommand.nextVisibleColumn(currentVisibleColumn, indentSize, lineContent.charCodeAt(j) === 9 /* CharCode.Tab */ , 1);
            if (currentVisibleColumn > minVisibleColumn) lines[i].commentStrOffset = j - 1;
            else lines[i].commentStrOffset = j;
        }
    }
}

},{"../../../../base/common/strings.js":"aA9I1","../../../common/core/editOperation.js":"6r2FZ","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","./blockCommentCommand.js":"6VpbX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dHaR7":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextMenuController", ()=>ContextMenuController);
var _domJs = require("../../../../base/browser/dom.js");
var _actionViewItemsJs = require("../../../../base/browser/ui/actionbar/actionViewItems.js");
var _actionsJs = require("../../../../base/common/actions.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _platformJs = require("../../../../base/common/platform.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs1 = require("../../../../platform/actions/common/actions.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _contextViewJs = require("../../../../platform/contextview/browser/contextView.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _workspaceJs = require("../../../../platform/workspace/common/workspace.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var ContextMenuController_1;
let ContextMenuController = class ContextMenuController {
    static{
        ContextMenuController_1 = this;
    }
    static{
        this.ID = "editor.contrib.contextmenu";
    }
    static get(editor) {
        return editor.getContribution(ContextMenuController_1.ID);
    }
    constructor(editor, _contextMenuService, _contextViewService, _contextKeyService, _keybindingService, _menuService, _configurationService, _workspaceContextService){
        this._contextMenuService = _contextMenuService;
        this._contextViewService = _contextViewService;
        this._contextKeyService = _contextKeyService;
        this._keybindingService = _keybindingService;
        this._menuService = _menuService;
        this._configurationService = _configurationService;
        this._workspaceContextService = _workspaceContextService;
        this._toDispose = new (0, _lifecycleJs.DisposableStore)();
        this._contextMenuIsBeingShownCount = 0;
        this._editor = editor;
        this._toDispose.add(this._editor.onContextMenu((e)=>this._onContextMenu(e)));
        this._toDispose.add(this._editor.onMouseWheel((e)=>{
            if (this._contextMenuIsBeingShownCount > 0) {
                const view = this._contextViewService.getContextViewElement();
                const target = e.srcElement;
                // Event triggers on shadow root host first
                // Check if the context view is under this host before hiding it #103169
                if (!(target.shadowRoot && _domJs.getShadowRoot(view) === target.shadowRoot)) this._contextViewService.hideContextView();
            }
        }));
        this._toDispose.add(this._editor.onKeyDown((e)=>{
            if (!this._editor.getOption(24 /* EditorOption.contextmenu */ )) return; // Context menu is turned off through configuration
            if (e.keyCode === 58 /* KeyCode.ContextMenu */ ) {
                // Chrome is funny like that
                e.preventDefault();
                e.stopPropagation();
                this.showContextMenu();
            }
        }));
    }
    _onContextMenu(e) {
        if (!this._editor.hasModel()) return;
        if (!this._editor.getOption(24 /* EditorOption.contextmenu */ )) {
            this._editor.focus();
            // Ensure the cursor is at the position of the mouse click
            if (e.target.position && !this._editor.getSelection().containsPosition(e.target.position)) this._editor.setPosition(e.target.position);
            return; // Context menu is turned off through configuration
        }
        if (e.target.type === 12 /* MouseTargetType.OVERLAY_WIDGET */ ) return; // allow native menu on widgets to support right click on input field for example in find
        if (e.target.type === 6 /* MouseTargetType.CONTENT_TEXT */  && e.target.detail.injectedText) return; // allow native menu on injected text
        e.event.preventDefault();
        e.event.stopPropagation();
        if (e.target.type === 11 /* MouseTargetType.SCROLLBAR */ ) return this._showScrollbarContextMenu(e.event);
        if (e.target.type !== 6 /* MouseTargetType.CONTENT_TEXT */  && e.target.type !== 7 /* MouseTargetType.CONTENT_EMPTY */  && e.target.type !== 1 /* MouseTargetType.TEXTAREA */ ) return; // only support mouse click into text or native context menu key for now
        // Ensure the editor gets focus if it hasn't, so the right events are being sent to other contributions
        this._editor.focus();
        // Ensure the cursor is at the position of the mouse click
        if (e.target.position) {
            let hasSelectionAtPosition = false;
            for (const selection of this._editor.getSelections())if (selection.containsPosition(e.target.position)) {
                hasSelectionAtPosition = true;
                break;
            }
            if (!hasSelectionAtPosition) this._editor.setPosition(e.target.position);
        }
        // Unless the user triggerd the context menu through Shift+F10, use the mouse position as menu position
        let anchor = null;
        if (e.target.type !== 1 /* MouseTargetType.TEXTAREA */ ) anchor = e.event;
        // Show the context menu
        this.showContextMenu(anchor);
    }
    showContextMenu(anchor) {
        if (!this._editor.getOption(24 /* EditorOption.contextmenu */ )) return; // Context menu is turned off through configuration
        if (!this._editor.hasModel()) return;
        // Find actions available for menu
        const menuActions = this._getMenuActions(this._editor.getModel(), this._editor.contextMenuId);
        // Show menu if we have actions to show
        if (menuActions.length > 0) this._doShowContextMenu(menuActions, anchor);
    }
    _getMenuActions(model, menuId) {
        const result = [];
        // get menu groups
        const groups = this._menuService.getMenuActions(menuId, this._contextKeyService, {
            arg: model.uri
        });
        // translate them into other actions
        for (const group of groups){
            const [, actions] = group;
            let addedItems = 0;
            for (const action of actions)if (action instanceof (0, _actionsJs1.SubmenuItemAction)) {
                const subActions = this._getMenuActions(model, action.item.submenu);
                if (subActions.length > 0) {
                    result.push(new (0, _actionsJs.SubmenuAction)(action.id, action.label, subActions));
                    addedItems++;
                }
            } else {
                result.push(action);
                addedItems++;
            }
            if (addedItems) result.push(new (0, _actionsJs.Separator)());
        }
        if (result.length) result.pop(); // remove last separator
        return result;
    }
    _doShowContextMenu(actions, event = null) {
        if (!this._editor.hasModel()) return;
        // Disable hover
        const oldHoverSetting = this._editor.getOption(60 /* EditorOption.hover */ );
        this._editor.updateOptions({
            hover: {
                enabled: false
            }
        });
        let anchor = event;
        if (!anchor) {
            // Ensure selection is visible
            this._editor.revealPosition(this._editor.getPosition(), 1 /* ScrollType.Immediate */ );
            this._editor.render();
            const cursorCoords = this._editor.getScrolledVisiblePosition(this._editor.getPosition());
            // Translate to absolute editor position
            const editorCoords = _domJs.getDomNodePagePosition(this._editor.getDomNode());
            const posx = editorCoords.left + cursorCoords.left;
            const posy = editorCoords.top + cursorCoords.top + cursorCoords.height;
            anchor = {
                x: posx,
                y: posy
            };
        }
        const useShadowDOM = this._editor.getOption(128 /* EditorOption.useShadowDOM */ ) && !(0, _platformJs.isIOS); // Do not use shadow dom on IOS #122035
        // Show menu
        this._contextMenuIsBeingShownCount++;
        this._contextMenuService.showContextMenu({
            domForShadowRoot: useShadowDOM ? this._editor.getOverflowWidgetsDomNode() ?? this._editor.getDomNode() : undefined,
            getAnchor: ()=>anchor,
            getActions: ()=>actions,
            getActionViewItem: (action)=>{
                const keybinding = this._keybindingFor(action);
                if (keybinding) return new (0, _actionViewItemsJs.ActionViewItem)(action, action, {
                    label: true,
                    keybinding: keybinding.getLabel(),
                    isMenu: true
                });
                const customActionViewItem = action;
                if (typeof customActionViewItem.getActionViewItem === "function") return customActionViewItem.getActionViewItem();
                return new (0, _actionViewItemsJs.ActionViewItem)(action, action, {
                    icon: true,
                    label: true,
                    isMenu: true
                });
            },
            getKeyBinding: (action)=>{
                return this._keybindingFor(action);
            },
            onHide: (wasCancelled)=>{
                this._contextMenuIsBeingShownCount--;
                this._editor.updateOptions({
                    hover: oldHoverSetting
                });
            }
        });
    }
    _showScrollbarContextMenu(anchor) {
        if (!this._editor.hasModel()) return;
        if ((0, _workspaceJs.isStandaloneEditorWorkspace)(this._workspaceContextService.getWorkspace())) // can't update the configuration properly in the standalone editor
        return;
        const minimapOptions = this._editor.getOption(73 /* EditorOption.minimap */ );
        let lastId = 0;
        const createAction = (opts)=>{
            return {
                id: `menu-action-${++lastId}`,
                label: opts.label,
                tooltip: "",
                class: undefined,
                enabled: typeof opts.enabled === "undefined" ? true : opts.enabled,
                checked: opts.checked,
                run: opts.run
            };
        };
        const createSubmenuAction = (label, actions)=>{
            return new (0, _actionsJs.SubmenuAction)(`menu-action-${++lastId}`, label, actions, undefined);
        };
        const createEnumAction = (label, enabled, configName, configuredValue, options)=>{
            if (!enabled) return createAction({
                label,
                enabled,
                run: ()=>{}
            });
            const createRunner = (value)=>{
                return ()=>{
                    this._configurationService.updateValue(configName, value);
                };
            };
            const actions = [];
            for (const option of options)actions.push(createAction({
                label: option.label,
                checked: configuredValue === option.value,
                run: createRunner(option.value)
            }));
            return createSubmenuAction(label, actions);
        };
        const actions = [];
        actions.push(createAction({
            label: _nlsJs.localize("context.minimap.minimap", "Minimap"),
            checked: minimapOptions.enabled,
            run: ()=>{
                this._configurationService.updateValue(`editor.minimap.enabled`, !minimapOptions.enabled);
            }
        }));
        actions.push(new (0, _actionsJs.Separator)());
        actions.push(createAction({
            label: _nlsJs.localize("context.minimap.renderCharacters", "Render Characters"),
            enabled: minimapOptions.enabled,
            checked: minimapOptions.renderCharacters,
            run: ()=>{
                this._configurationService.updateValue(`editor.minimap.renderCharacters`, !minimapOptions.renderCharacters);
            }
        }));
        actions.push(createEnumAction(_nlsJs.localize("context.minimap.size", "Vertical size"), minimapOptions.enabled, "editor.minimap.size", minimapOptions.size, [
            {
                label: _nlsJs.localize("context.minimap.size.proportional", "Proportional"),
                value: "proportional"
            },
            {
                label: _nlsJs.localize("context.minimap.size.fill", "Fill"),
                value: "fill"
            },
            {
                label: _nlsJs.localize("context.minimap.size.fit", "Fit"),
                value: "fit"
            }
        ]));
        actions.push(createEnumAction(_nlsJs.localize("context.minimap.slider", "Slider"), minimapOptions.enabled, "editor.minimap.showSlider", minimapOptions.showSlider, [
            {
                label: _nlsJs.localize("context.minimap.slider.mouseover", "Mouse Over"),
                value: "mouseover"
            },
            {
                label: _nlsJs.localize("context.minimap.slider.always", "Always"),
                value: "always"
            }
        ]));
        const useShadowDOM = this._editor.getOption(128 /* EditorOption.useShadowDOM */ ) && !(0, _platformJs.isIOS); // Do not use shadow dom on IOS #122035
        this._contextMenuIsBeingShownCount++;
        this._contextMenuService.showContextMenu({
            domForShadowRoot: useShadowDOM ? this._editor.getDomNode() : undefined,
            getAnchor: ()=>anchor,
            getActions: ()=>actions,
            onHide: (wasCancelled)=>{
                this._contextMenuIsBeingShownCount--;
                this._editor.focus();
            }
        });
    }
    _keybindingFor(action) {
        return this._keybindingService.lookupKeybinding(action.id);
    }
    dispose() {
        if (this._contextMenuIsBeingShownCount > 0) this._contextViewService.hideContextView();
        this._toDispose.dispose();
    }
};
ContextMenuController = ContextMenuController_1 = __decorate([
    __param(1, (0, _contextViewJs.IContextMenuService)),
    __param(2, (0, _contextViewJs.IContextViewService)),
    __param(3, (0, _contextkeyJs.IContextKeyService)),
    __param(4, (0, _keybindingJs.IKeybindingService)),
    __param(5, (0, _actionsJs1.IMenuService)),
    __param(6, (0, _configurationJs.IConfigurationService)),
    __param(7, (0, _workspaceJs.IWorkspaceContextService))
], ContextMenuController);
class ShowContextMenu extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.showContextMenu",
            label: _nlsJs.localize("action.showContextMenu.label", "Show Editor Context Menu"),
            alias: "Show Editor Context Menu",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 1092 /* KeyCode.F10 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(accessor, editor) {
        ContextMenuController.get(editor)?.showContextMenu();
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(ContextMenuController.ID, ContextMenuController, 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );
(0, _editorExtensionsJs.registerEditorAction)(ShowContextMenu);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/actionbar/actionViewItems.js":"6Yy9b","../../../../base/common/actions.js":"5GjLb","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/platform.js":"7maJO","../../../browser/editorExtensions.js":"kC3w6","../../../common/editorContextKeys.js":"5exv9","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/contextview/browser/contextView.js":"2QlUR","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/workspace/common/workspace.js":"707vH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5cors":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CursorUndoRedoController", ()=>CursorUndoRedoController);
parcelHelpers.export(exports, "CursorUndo", ()=>CursorUndo);
parcelHelpers.export(exports, "CursorRedo", ()=>CursorRedo);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _nlsJs = require("../../../../nls.js");
class CursorState {
    constructor(selections){
        this.selections = selections;
    }
    equals(other) {
        const thisLen = this.selections.length;
        const otherLen = other.selections.length;
        if (thisLen !== otherLen) return false;
        for(let i = 0; i < thisLen; i++){
            if (!this.selections[i].equalsSelection(other.selections[i])) return false;
        }
        return true;
    }
}
class StackElement {
    constructor(cursorState, scrollTop, scrollLeft){
        this.cursorState = cursorState;
        this.scrollTop = scrollTop;
        this.scrollLeft = scrollLeft;
    }
}
class CursorUndoRedoController extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.cursorUndoRedoController";
    }
    static get(editor) {
        return editor.getContribution(CursorUndoRedoController.ID);
    }
    constructor(editor){
        super();
        this._editor = editor;
        this._isCursorUndoRedo = false;
        this._undoStack = [];
        this._redoStack = [];
        this._register(editor.onDidChangeModel((e)=>{
            this._undoStack = [];
            this._redoStack = [];
        }));
        this._register(editor.onDidChangeModelContent((e)=>{
            this._undoStack = [];
            this._redoStack = [];
        }));
        this._register(editor.onDidChangeCursorSelection((e)=>{
            if (this._isCursorUndoRedo) return;
            if (!e.oldSelections) return;
            if (e.oldModelVersionId !== e.modelVersionId) return;
            const prevState = new CursorState(e.oldSelections);
            const isEqualToLastUndoStack = this._undoStack.length > 0 && this._undoStack[this._undoStack.length - 1].cursorState.equals(prevState);
            if (!isEqualToLastUndoStack) {
                this._undoStack.push(new StackElement(prevState, editor.getScrollTop(), editor.getScrollLeft()));
                this._redoStack = [];
                if (this._undoStack.length > 50) // keep the cursor undo stack bounded
                this._undoStack.shift();
            }
        }));
    }
    cursorUndo() {
        if (!this._editor.hasModel() || this._undoStack.length === 0) return;
        this._redoStack.push(new StackElement(new CursorState(this._editor.getSelections()), this._editor.getScrollTop(), this._editor.getScrollLeft()));
        this._applyState(this._undoStack.pop());
    }
    cursorRedo() {
        if (!this._editor.hasModel() || this._redoStack.length === 0) return;
        this._undoStack.push(new StackElement(new CursorState(this._editor.getSelections()), this._editor.getScrollTop(), this._editor.getScrollLeft()));
        this._applyState(this._redoStack.pop());
    }
    _applyState(stackElement) {
        this._isCursorUndoRedo = true;
        this._editor.setSelections(stackElement.cursorState.selections);
        this._editor.setScrollPosition({
            scrollTop: stackElement.scrollTop,
            scrollLeft: stackElement.scrollLeft
        });
        this._isCursorUndoRedo = false;
    }
}
class CursorUndo extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "cursorUndo",
            label: _nlsJs.localize("cursor.undo", "Cursor Undo"),
            alias: "Cursor Undo",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 2099 /* KeyCode.KeyU */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(accessor, editor, args) {
        CursorUndoRedoController.get(editor)?.cursorUndo();
    }
}
class CursorRedo extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "cursorRedo",
            label: _nlsJs.localize("cursor.redo", "Cursor Redo"),
            alias: "Cursor Redo",
            precondition: undefined
        });
    }
    run(accessor, editor, args) {
        CursorUndoRedoController.get(editor)?.cursorRedo();
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(CursorUndoRedoController.ID, CursorUndoRedoController, 0 /* EditorContributionInstantiation.Eager */ ); // eager because it needs to listen to record cursor state ASAP
(0, _editorExtensionsJs.registerEditorAction)(CursorUndo);
(0, _editorExtensionsJs.registerEditorAction)(CursorRedo);

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorExtensions.js":"kC3w6","../../../common/editorContextKeys.js":"5exv9","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b3Vt2":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragAndDropController", ()=>DragAndDropController);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _platformJs = require("../../../../base/common/platform.js");
var _dndCss = require("./dnd.css");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _dragAndDropCommandJs = require("./dragAndDropCommand.js");
function hasTriggerModifier(e) {
    if (0, _platformJs.isMacintosh) return e.altKey;
    else return e.ctrlKey;
}
class DragAndDropController extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.dragAndDrop";
    }
    static{
        this.TRIGGER_KEY_VALUE = (0, _platformJs.isMacintosh) ? 6 /* KeyCode.Alt */  : 5 /* KeyCode.Ctrl */ ;
    }
    constructor(editor){
        super();
        this._editor = editor;
        this._dndDecorationIds = this._editor.createDecorationsCollection();
        this._register(this._editor.onMouseDown((e)=>this._onEditorMouseDown(e)));
        this._register(this._editor.onMouseUp((e)=>this._onEditorMouseUp(e)));
        this._register(this._editor.onMouseDrag((e)=>this._onEditorMouseDrag(e)));
        this._register(this._editor.onMouseDrop((e)=>this._onEditorMouseDrop(e)));
        this._register(this._editor.onMouseDropCanceled(()=>this._onEditorMouseDropCanceled()));
        this._register(this._editor.onKeyDown((e)=>this.onEditorKeyDown(e)));
        this._register(this._editor.onKeyUp((e)=>this.onEditorKeyUp(e)));
        this._register(this._editor.onDidBlurEditorWidget(()=>this.onEditorBlur()));
        this._register(this._editor.onDidBlurEditorText(()=>this.onEditorBlur()));
        this._mouseDown = false;
        this._modifierPressed = false;
        this._dragSelection = null;
    }
    onEditorBlur() {
        this._removeDecoration();
        this._dragSelection = null;
        this._mouseDown = false;
        this._modifierPressed = false;
    }
    onEditorKeyDown(e) {
        if (!this._editor.getOption(35 /* EditorOption.dragAndDrop */ ) || this._editor.getOption(22 /* EditorOption.columnSelection */ )) return;
        if (hasTriggerModifier(e)) this._modifierPressed = true;
        if (this._mouseDown && hasTriggerModifier(e)) this._editor.updateOptions({
            mouseStyle: "copy"
        });
    }
    onEditorKeyUp(e) {
        if (!this._editor.getOption(35 /* EditorOption.dragAndDrop */ ) || this._editor.getOption(22 /* EditorOption.columnSelection */ )) return;
        if (hasTriggerModifier(e)) this._modifierPressed = false;
        if (this._mouseDown && e.keyCode === DragAndDropController.TRIGGER_KEY_VALUE) this._editor.updateOptions({
            mouseStyle: "default"
        });
    }
    _onEditorMouseDown(mouseEvent) {
        this._mouseDown = true;
    }
    _onEditorMouseUp(mouseEvent) {
        this._mouseDown = false;
        // Whenever users release the mouse, the drag and drop operation should finish and the cursor should revert to text.
        this._editor.updateOptions({
            mouseStyle: "text"
        });
    }
    _onEditorMouseDrag(mouseEvent) {
        const target = mouseEvent.target;
        if (this._dragSelection === null) {
            const selections = this._editor.getSelections() || [];
            const possibleSelections = selections.filter((selection)=>target.position && selection.containsPosition(target.position));
            if (possibleSelections.length === 1) this._dragSelection = possibleSelections[0];
            else return;
        }
        if (hasTriggerModifier(mouseEvent.event)) this._editor.updateOptions({
            mouseStyle: "copy"
        });
        else this._editor.updateOptions({
            mouseStyle: "default"
        });
        if (target.position) {
            if (this._dragSelection.containsPosition(target.position)) this._removeDecoration();
            else this.showAt(target.position);
        }
    }
    _onEditorMouseDropCanceled() {
        this._editor.updateOptions({
            mouseStyle: "text"
        });
        this._removeDecoration();
        this._dragSelection = null;
        this._mouseDown = false;
    }
    _onEditorMouseDrop(mouseEvent) {
        if (mouseEvent.target && (this._hitContent(mouseEvent.target) || this._hitMargin(mouseEvent.target)) && mouseEvent.target.position) {
            const newCursorPosition = new (0, _positionJs.Position)(mouseEvent.target.position.lineNumber, mouseEvent.target.position.column);
            if (this._dragSelection === null) {
                let newSelections = null;
                if (mouseEvent.event.shiftKey) {
                    const primarySelection = this._editor.getSelection();
                    if (primarySelection) {
                        const { selectionStartLineNumber, selectionStartColumn } = primarySelection;
                        newSelections = [
                            new (0, _selectionJs.Selection)(selectionStartLineNumber, selectionStartColumn, newCursorPosition.lineNumber, newCursorPosition.column)
                        ];
                    }
                } else newSelections = (this._editor.getSelections() || []).map((selection)=>{
                    if (selection.containsPosition(newCursorPosition)) return new (0, _selectionJs.Selection)(newCursorPosition.lineNumber, newCursorPosition.column, newCursorPosition.lineNumber, newCursorPosition.column);
                    else return selection;
                });
                // Use `mouse` as the source instead of `api` and setting the reason to explicit (to behave like any other mouse operation).
                this._editor.setSelections(newSelections || [], "mouse", 3 /* CursorChangeReason.Explicit */ );
            } else if (!this._dragSelection.containsPosition(newCursorPosition) || (hasTriggerModifier(mouseEvent.event) || this._modifierPressed) && (this._dragSelection.getEndPosition().equals(newCursorPosition) || this._dragSelection.getStartPosition().equals(newCursorPosition) // we allow users to paste content beside the selection
            )) {
                this._editor.pushUndoStop();
                this._editor.executeCommand(DragAndDropController.ID, new (0, _dragAndDropCommandJs.DragAndDropCommand)(this._dragSelection, newCursorPosition, hasTriggerModifier(mouseEvent.event) || this._modifierPressed));
                this._editor.pushUndoStop();
            }
        }
        this._editor.updateOptions({
            mouseStyle: "text"
        });
        this._removeDecoration();
        this._dragSelection = null;
        this._mouseDown = false;
    }
    static{
        this._DECORATION_OPTIONS = (0, _textModelJs.ModelDecorationOptions).register({
            description: "dnd-target",
            className: "dnd-target"
        });
    }
    showAt(position) {
        this._dndDecorationIds.set([
            {
                range: new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column),
                options: DragAndDropController._DECORATION_OPTIONS
            }
        ]);
        this._editor.revealPosition(position, 1 /* ScrollType.Immediate */ );
    }
    _removeDecoration() {
        this._dndDecorationIds.clear();
    }
    _hitContent(target) {
        return target.type === 6 /* MouseTargetType.CONTENT_TEXT */  || target.type === 7 /* MouseTargetType.CONTENT_EMPTY */ ;
    }
    _hitMargin(target) {
        return target.type === 2 /* MouseTargetType.GUTTER_GLYPH_MARGIN */  || target.type === 3 /* MouseTargetType.GUTTER_LINE_NUMBERS */  || target.type === 4 /* MouseTargetType.GUTTER_LINE_DECORATIONS */ ;
    }
    dispose() {
        this._removeDecoration();
        this._dragSelection = null;
        this._mouseDown = false;
        this._modifierPressed = false;
        super.dispose();
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(DragAndDropController.ID, DragAndDropController, 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/platform.js":"7maJO","./dnd.css":"hhsNu","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/model/textModel.js":"9beDe","./dragAndDropCommand.js":"8CxqA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hhsNu":[function() {},{}],"8CxqA":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragAndDropCommand", ()=>DragAndDropCommand);
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
class DragAndDropCommand {
    constructor(selection, targetPosition, copy){
        this.selection = selection;
        this.targetPosition = targetPosition;
        this.copy = copy;
        this.targetSelection = null;
    }
    getEditOperations(model, builder) {
        const text = model.getValueInRange(this.selection);
        if (!this.copy) builder.addEditOperation(this.selection, null);
        builder.addEditOperation(new (0, _rangeJs.Range)(this.targetPosition.lineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.targetPosition.column), text);
        if (this.selection.containsPosition(this.targetPosition) && !(this.copy && (this.selection.getEndPosition().equals(this.targetPosition) || this.selection.getStartPosition().equals(this.targetPosition) // we allow users to paste content beside the selection
        ))) {
            this.targetSelection = this.selection;
            return;
        }
        if (this.copy) {
            this.targetSelection = new (0, _selectionJs.Selection)(this.targetPosition.lineNumber, this.targetPosition.column, this.selection.endLineNumber - this.selection.startLineNumber + this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column + this.selection.endColumn - this.selection.startColumn : this.selection.endColumn);
            return;
        }
        if (this.targetPosition.lineNumber > this.selection.endLineNumber) {
            // Drag the selection downwards
            this.targetSelection = new (0, _selectionJs.Selection)(this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column + this.selection.endColumn - this.selection.startColumn : this.selection.endColumn);
            return;
        }
        if (this.targetPosition.lineNumber < this.selection.endLineNumber) {
            // Drag the selection upwards
            this.targetSelection = new (0, _selectionJs.Selection)(this.targetPosition.lineNumber, this.targetPosition.column, this.targetPosition.lineNumber + this.selection.endLineNumber - this.selection.startLineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column + this.selection.endColumn - this.selection.startColumn : this.selection.endColumn);
            return;
        }
        // The target position is at the same line as the selection's end position.
        if (this.selection.endColumn <= this.targetPosition.column) // The target position is after the selection's end position
        this.targetSelection = new (0, _selectionJs.Selection)(this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column - this.selection.endColumn + this.selection.startColumn : this.targetPosition.column - this.selection.endColumn + this.selection.startColumn, this.targetPosition.lineNumber, this.selection.startLineNumber === this.selection.endLineNumber ? this.targetPosition.column : this.selection.endColumn);
        else // The target position is before the selection's end position. Since the selection doesn't contain the target position, the selection is one-line and target position is before this selection.
        this.targetSelection = new (0, _selectionJs.Selection)(this.targetPosition.lineNumber - this.selection.endLineNumber + this.selection.startLineNumber, this.targetPosition.column, this.targetPosition.lineNumber, this.targetPosition.column + this.selection.endColumn - this.selection.startColumn);
    }
    computeCursorState(model, helper) {
        return this.targetSelection;
    }
}

},{"../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"goWbc":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _hierarchicalKindJs = require("../../../../base/common/hierarchicalKind.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _editorFeaturesJs = require("../../../common/editorFeatures.js");
var _copyPasteControllerJs = require("./copyPasteController.js");
var _defaultProvidersJs = require("./defaultProviders.js");
var _nlsJs = require("../../../../nls.js");
(0, _editorExtensionsJs.registerEditorContribution)((0, _copyPasteControllerJs.CopyPasteController).ID, (0, _copyPasteControllerJs.CopyPasteController), 0 /* EditorContributionInstantiation.Eager */ ); // eager because it listens to events on the container dom node of the editor
(0, _editorFeaturesJs.registerEditorFeature)((0, _defaultProvidersJs.DefaultPasteProvidersFeature));
(0, _editorExtensionsJs.registerEditorCommand)(new class extends (0, _editorExtensionsJs.EditorCommand) {
    constructor(){
        super({
            id: (0, _copyPasteControllerJs.changePasteTypeCommandId),
            precondition: (0, _copyPasteControllerJs.pasteWidgetVisibleCtx),
            kbOpts: {
                weight: 100 /* KeybindingWeight.EditorContrib */ ,
                primary: 2137 /* KeyCode.Period */ 
            }
        });
    }
    runEditorCommand(_accessor, editor) {
        return (0, _copyPasteControllerJs.CopyPasteController).get(editor)?.changePasteType();
    }
});
(0, _editorExtensionsJs.registerEditorCommand)(new class extends (0, _editorExtensionsJs.EditorCommand) {
    constructor(){
        super({
            id: "editor.hidePasteWidget",
            precondition: (0, _copyPasteControllerJs.pasteWidgetVisibleCtx),
            kbOpts: {
                weight: 100 /* KeybindingWeight.EditorContrib */ ,
                primary: 9 /* KeyCode.Escape */ 
            }
        });
    }
    runEditorCommand(_accessor, editor) {
        (0, _copyPasteControllerJs.CopyPasteController).get(editor)?.clearWidgets();
    }
});
(0, _editorExtensionsJs.registerEditorAction)(class PasteAsAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.argsSchema = {
            type: "object",
            properties: {
                kind: {
                    type: "string",
                    description: _nlsJs.localize("pasteAs.kind", "The kind of the paste edit to try applying. If not provided or there are multiple edits for this kind, the editor will show a picker.")
                }
            }
        };
    }
    constructor(){
        super({
            id: "editor.action.pasteAs",
            label: _nlsJs.localize("pasteAs", "Paste As..."),
            alias: "Paste As...",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            metadata: {
                description: "Paste as",
                args: [
                    {
                        name: "args",
                        schema: PasteAsAction.argsSchema
                    }
                ]
            }
        });
    }
    run(_accessor, editor, args) {
        let kind = typeof args?.kind === "string" ? args.kind : undefined;
        if (!kind && args) // Support old id property
        // TODO: remove this in the future
        kind = typeof args.id === "string" ? args.id : undefined;
        return (0, _copyPasteControllerJs.CopyPasteController).get(editor)?.pasteAs(kind ? new (0, _hierarchicalKindJs.HierarchicalKind)(kind) : undefined);
    }
});
(0, _editorExtensionsJs.registerEditorAction)(class extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.pasteAsText",
            label: _nlsJs.localize("pasteAsText", "Paste as Text"),
            alias: "Paste as Text",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
    run(_accessor, editor) {
        return (0, _copyPasteControllerJs.CopyPasteController).get(editor)?.pasteAs({
            providerId: (0, _defaultProvidersJs.DefaultTextPasteOrDropEditProvider).id
        });
    }
});

},{"../../../../base/common/hierarchicalKind.js":"eXua8","../../../browser/editorExtensions.js":"kC3w6","../../../common/editorContextKeys.js":"5exv9","../../../common/editorFeatures.js":"8AkS3","./copyPasteController.js":"7cyou","./defaultProviders.js":"eXi6S","../../../../nls.js":"l617d"}],"h3UhH":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorConfigurationSchemaJs = require("../../../common/config/editorConfigurationSchema.js");
var _editorFeaturesJs = require("../../../common/editorFeatures.js");
var _defaultProvidersJs = require("./defaultProviders.js");
var _nlsJs = require("../../../../nls.js");
var _configurationRegistryJs = require("../../../../platform/configuration/common/configurationRegistry.js");
var _platformJs = require("../../../../platform/registry/common/platform.js");
var _dropIntoEditorControllerJs = require("./dropIntoEditorController.js");
(0, _editorExtensionsJs.registerEditorContribution)((0, _dropIntoEditorControllerJs.DropIntoEditorController).ID, (0, _dropIntoEditorControllerJs.DropIntoEditorController), 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );
(0, _editorFeaturesJs.registerEditorFeature)((0, _defaultProvidersJs.DefaultDropProvidersFeature));
(0, _editorExtensionsJs.registerEditorCommand)(new class extends (0, _editorExtensionsJs.EditorCommand) {
    constructor(){
        super({
            id: (0, _dropIntoEditorControllerJs.changeDropTypeCommandId),
            precondition: (0, _dropIntoEditorControllerJs.dropWidgetVisibleCtx),
            kbOpts: {
                weight: 100 /* KeybindingWeight.EditorContrib */ ,
                primary: 2137 /* KeyCode.Period */ 
            }
        });
    }
    runEditorCommand(_accessor, editor, _args) {
        (0, _dropIntoEditorControllerJs.DropIntoEditorController).get(editor)?.changeDropType();
    }
});
(0, _editorExtensionsJs.registerEditorCommand)(new class extends (0, _editorExtensionsJs.EditorCommand) {
    constructor(){
        super({
            id: "editor.hideDropWidget",
            precondition: (0, _dropIntoEditorControllerJs.dropWidgetVisibleCtx),
            kbOpts: {
                weight: 100 /* KeybindingWeight.EditorContrib */ ,
                primary: 9 /* KeyCode.Escape */ 
            }
        });
    }
    runEditorCommand(_accessor, editor, _args) {
        (0, _dropIntoEditorControllerJs.DropIntoEditorController).get(editor)?.clearWidgets();
    }
});
(0, _platformJs.Registry).as((0, _configurationRegistryJs.Extensions).Configuration).registerConfiguration({
    ...(0, _editorConfigurationSchemaJs.editorConfigurationBaseNode),
    properties: {
        [(0, _dropIntoEditorControllerJs.defaultProviderConfig)]: {
            type: "object",
            scope: 5 /* ConfigurationScope.LANGUAGE_OVERRIDABLE */ ,
            description: _nlsJs.localize("defaultProviderDescription", "Configures the default drop provider to use for content of a given mime type."),
            default: {},
            additionalProperties: {
                type: "string"
            }
        }
    }
});

},{"../../../browser/editorExtensions.js":"kC3w6","../../../common/config/editorConfigurationSchema.js":"18Zc9","../../../common/editorFeatures.js":"8AkS3","./defaultProviders.js":"eXi6S","../../../../nls.js":"l617d","../../../../platform/configuration/common/configurationRegistry.js":"6y4yB","../../../../platform/registry/common/platform.js":"dzx11","./dropIntoEditorController.js":"1tOqr"}],"1tOqr":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultProviderConfig", ()=>defaultProviderConfig);
parcelHelpers.export(exports, "changeDropTypeCommandId", ()=>changeDropTypeCommandId);
parcelHelpers.export(exports, "dropWidgetVisibleCtx", ()=>dropWidgetVisibleCtx);
parcelHelpers.export(exports, "DropIntoEditorController", ()=>DropIntoEditorController);
var _arraysJs = require("../../../../base/common/arrays.js");
var _asyncJs = require("../../../../base/common/async.js");
var _dataTransferJs = require("../../../../base/common/dataTransfer.js");
var _hierarchicalKindJs = require("../../../../base/common/hierarchicalKind.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _dndJs = require("../../../browser/dnd.js");
var _rangeJs = require("../../../common/core/range.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _treeViewsDndJs = require("../../../common/services/treeViewsDnd.js");
var _treeViewsDndServiceJs = require("../../../common/services/treeViewsDndService.js");
var _editorStateJs = require("../../editorState/browser/editorState.js");
var _inlineProgressJs = require("../../inlineProgress/browser/inlineProgress.js");
var _nlsJs = require("../../../../nls.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _dndJs1 = require("../../../../platform/dnd/browser/dnd.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _editJs = require("./edit.js");
var _postEditWidgetJs = require("./postEditWidget.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var DropIntoEditorController_1;
const defaultProviderConfig = "editor.experimental.dropIntoEditor.defaultProvider";
const changeDropTypeCommandId = "editor.changeDropType";
const dropWidgetVisibleCtx = new (0, _contextkeyJs.RawContextKey)("dropWidgetVisible", false, (0, _nlsJs.localize)("dropWidgetVisible", "Whether the drop widget is showing"));
let DropIntoEditorController = class DropIntoEditorController extends (0, _lifecycleJs.Disposable) {
    static{
        DropIntoEditorController_1 = this;
    }
    static{
        this.ID = "editor.contrib.dropIntoEditorController";
    }
    static get(editor) {
        return editor.getContribution(DropIntoEditorController_1.ID);
    }
    constructor(editor, instantiationService, _configService, _languageFeaturesService, _treeViewsDragAndDropService){
        super();
        this._configService = _configService;
        this._languageFeaturesService = _languageFeaturesService;
        this._treeViewsDragAndDropService = _treeViewsDragAndDropService;
        this.treeItemsTransfer = (0, _dndJs1.LocalSelectionTransfer).getInstance();
        this._dropProgressManager = this._register(instantiationService.createInstance((0, _inlineProgressJs.InlineProgressManager), "dropIntoEditor", editor));
        this._postDropWidgetManager = this._register(instantiationService.createInstance((0, _postEditWidgetJs.PostEditWidgetManager), "dropIntoEditor", editor, dropWidgetVisibleCtx, {
            id: changeDropTypeCommandId,
            label: (0, _nlsJs.localize)("postDropWidgetTitle", "Show drop options...")
        }));
        this._register(editor.onDropIntoEditor((e)=>this.onDropIntoEditor(editor, e.position, e.event)));
    }
    clearWidgets() {
        this._postDropWidgetManager.clear();
    }
    changeDropType() {
        this._postDropWidgetManager.tryShowSelector();
    }
    async onDropIntoEditor(editor, position, dragEvent) {
        if (!dragEvent.dataTransfer || !editor.hasModel()) return;
        this._currentOperation?.cancel();
        editor.focus();
        editor.setPosition(position);
        const p = (0, _asyncJs.createCancelablePromise)(async (token)=>{
            const disposables = new (0, _lifecycleJs.DisposableStore)();
            const tokenSource = disposables.add(new (0, _editorStateJs.EditorStateCancellationTokenSource)(editor, 1 /* CodeEditorStateFlag.Value */ , undefined, token));
            try {
                const ourDataTransfer = await this.extractDataTransferData(dragEvent);
                if (ourDataTransfer.size === 0 || tokenSource.token.isCancellationRequested) return;
                const model = editor.getModel();
                if (!model) return;
                const providers = this._languageFeaturesService.documentDropEditProvider.ordered(model).filter((provider)=>{
                    if (!provider.dropMimeTypes) // Keep all providers that don't specify mime types
                    return true;
                    return provider.dropMimeTypes.some((mime)=>ourDataTransfer.matches(mime));
                });
                const editSession = disposables.add(await this.getDropEdits(providers, model, position, ourDataTransfer, tokenSource));
                if (tokenSource.token.isCancellationRequested) return;
                if (editSession.edits.length) {
                    const activeEditIndex = this.getInitialActiveEditIndex(model, editSession.edits);
                    const canShowWidget = editor.getOption(36 /* EditorOption.dropIntoEditor */ ).showDropSelector === "afterDrop";
                    // Pass in the parent token here as it tracks cancelling the entire drop operation
                    await this._postDropWidgetManager.applyEditAndShowIfNeeded([
                        (0, _rangeJs.Range).fromPositions(position)
                    ], {
                        activeEditIndex,
                        allEdits: editSession.edits
                    }, canShowWidget, async (edit)=>edit, token);
                }
            } finally{
                disposables.dispose();
                if (this._currentOperation === p) this._currentOperation = undefined;
            }
        });
        this._dropProgressManager.showWhile(position, (0, _nlsJs.localize)("dropIntoEditorProgress", "Running drop handlers. Click to cancel"), p, {
            cancel: ()=>p.cancel()
        });
        this._currentOperation = p;
    }
    async getDropEdits(providers, model, position, dataTransfer, tokenSource) {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        const results = await (0, _asyncJs.raceCancellation)(Promise.all(providers.map(async (provider)=>{
            try {
                const edits = await provider.provideDocumentDropEdits(model, position, dataTransfer, tokenSource.token);
                if (edits) disposables.add(edits);
                return edits?.edits.map((edit)=>({
                        ...edit,
                        providerId: provider.id
                    }));
            } catch (err) {
                console.error(err);
            }
            return undefined;
        })), tokenSource.token);
        const edits = (0, _arraysJs.coalesce)(results ?? []).flat();
        return {
            edits: (0, _editJs.sortEditsByYieldTo)(edits),
            dispose: ()=>disposables.dispose()
        };
    }
    getInitialActiveEditIndex(model, edits) {
        const preferredProviders = this._configService.getValue(defaultProviderConfig, {
            resource: model.uri
        });
        for (const [configMime, desiredKindStr] of Object.entries(preferredProviders)){
            const desiredKind = new (0, _hierarchicalKindJs.HierarchicalKind)(desiredKindStr);
            const editIndex = edits.findIndex((edit)=>desiredKind.value === edit.providerId && edit.handledMimeType && (0, _dataTransferJs.matchesMimeType)(configMime, [
                    edit.handledMimeType
                ]));
            if (editIndex >= 0) return editIndex;
        }
        return 0;
    }
    async extractDataTransferData(dragEvent) {
        if (!dragEvent.dataTransfer) return new (0, _dataTransferJs.VSDataTransfer)();
        const dataTransfer = (0, _dndJs.toExternalVSDataTransfer)(dragEvent.dataTransfer);
        if (this.treeItemsTransfer.hasData((0, _treeViewsDndJs.DraggedTreeItemsIdentifier).prototype)) {
            const data = this.treeItemsTransfer.getData((0, _treeViewsDndJs.DraggedTreeItemsIdentifier).prototype);
            if (Array.isArray(data)) for (const id of data){
                const treeDataTransfer = await this._treeViewsDragAndDropService.removeDragOperationTransfer(id.identifier);
                if (treeDataTransfer) for (const [type, value] of treeDataTransfer)dataTransfer.replace(type, value);
            }
        }
        return dataTransfer;
    }
};
DropIntoEditorController = DropIntoEditorController_1 = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService)),
    __param(2, (0, _configurationJs.IConfigurationService)),
    __param(3, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(4, (0, _treeViewsDndServiceJs.ITreeViewsDnDService))
], DropIntoEditorController);

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/async.js":"4GJc4","../../../../base/common/dataTransfer.js":"5wpxJ","../../../../base/common/hierarchicalKind.js":"eXua8","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/dnd.js":"eI7oO","../../../common/core/range.js":"jmUPh","../../../common/services/languageFeatures.js":"2IAko","../../../common/services/treeViewsDnd.js":"kpwgp","../../../common/services/treeViewsDndService.js":"bxaeu","../../editorState/browser/editorState.js":"hyVHM","../../inlineProgress/browser/inlineProgress.js":"a5six","../../../../nls.js":"l617d","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/dnd/browser/dnd.js":"a7xax","../../../../platform/instantiation/common/instantiation.js":"fjwWx","./edit.js":"fZ737","./postEditWidget.js":"64EIp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kpwgp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TreeViewsDnDService", ()=>TreeViewsDnDService);
parcelHelpers.export(exports, "DraggedTreeItemsIdentifier", ()=>DraggedTreeItemsIdentifier);
class TreeViewsDnDService {
    constructor(){
        this._dragOperations = new Map();
    }
    removeDragOperationTransfer(uuid) {
        if (uuid && this._dragOperations.has(uuid)) {
            const operation = this._dragOperations.get(uuid);
            this._dragOperations.delete(uuid);
            return operation;
        }
        return undefined;
    }
}
class DraggedTreeItemsIdentifier {
    constructor(identifier){
        this.identifier = identifier;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bxaeu":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ITreeViewsDnDService", ()=>ITreeViewsDnDService);
var _extensionsJs = require("../../../platform/instantiation/common/extensions.js");
var _instantiationJs = require("../../../platform/instantiation/common/instantiation.js");
var _treeViewsDndJs = require("./treeViewsDnd.js");
const ITreeViewsDnDService = (0, _instantiationJs.createDecorator)("treeViewsDndService");
(0, _extensionsJs.registerSingleton)(ITreeViewsDnDService, (0, _treeViewsDndJs.TreeViewsDnDService), 1 /* InstantiationType.Delayed */ );

},{"../../../platform/instantiation/common/extensions.js":"6WJLq","../../../platform/instantiation/common/instantiation.js":"fjwWx","./treeViewsDnd.js":"kpwgp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6yJPJ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSelectionSearchString", ()=>getSelectionSearchString);
parcelHelpers.export(exports, "CommonFindController", ()=>CommonFindController);
parcelHelpers.export(exports, "FindController", ()=>FindController);
parcelHelpers.export(exports, "StartFindAction", ()=>StartFindAction);
parcelHelpers.export(exports, "StartFindWithArgsAction", ()=>StartFindWithArgsAction);
parcelHelpers.export(exports, "StartFindWithSelectionAction", ()=>StartFindWithSelectionAction);
parcelHelpers.export(exports, "MatchFindAction", ()=>MatchFindAction);
parcelHelpers.export(exports, "NextMatchFindAction", ()=>NextMatchFindAction);
parcelHelpers.export(exports, "PreviousMatchFindAction", ()=>PreviousMatchFindAction);
parcelHelpers.export(exports, "MoveToMatchFindAction", ()=>MoveToMatchFindAction);
parcelHelpers.export(exports, "SelectionMatchFindAction", ()=>SelectionMatchFindAction);
parcelHelpers.export(exports, "NextSelectionMatchFindAction", ()=>NextSelectionMatchFindAction);
parcelHelpers.export(exports, "PreviousSelectionMatchFindAction", ()=>PreviousSelectionMatchFindAction);
parcelHelpers.export(exports, "StartFindReplaceAction", ()=>StartFindReplaceAction);
var _asyncJs = require("../../../../base/common/async.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorColorRegistryJs = require("../../../common/core/editorColorRegistry.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _modelJs = require("../../../common/model.js");
var _findModelJs = require("./findModel.js");
var _findOptionsWidgetJs = require("./findOptionsWidget.js");
var _findStateJs = require("./findState.js");
var _findWidgetJs = require("./findWidget.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _clipboardServiceJs = require("../../../../platform/clipboard/common/clipboardService.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _contextViewJs = require("../../../../platform/contextview/browser/contextView.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var _quickInputJs = require("../../../../platform/quickinput/common/quickInput.js");
var _storageJs = require("../../../../platform/storage/common/storage.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _hoverJs = require("../../../../platform/hover/browser/hover.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var CommonFindController_1;
const SEARCH_STRING_MAX_LENGTH = 524288;
function getSelectionSearchString(editor, seedSearchStringFromSelection = "single", seedSearchStringFromNonEmptySelection = false) {
    if (!editor.hasModel()) return null;
    const selection = editor.getSelection();
    // if selection spans multiple lines, default search string to empty
    if (seedSearchStringFromSelection === "single" && selection.startLineNumber === selection.endLineNumber || seedSearchStringFromSelection === "multiple") {
        if (selection.isEmpty()) {
            const wordAtPosition = editor.getConfiguredWordAtPosition(selection.getStartPosition());
            if (wordAtPosition && false === seedSearchStringFromNonEmptySelection) return wordAtPosition.word;
        } else {
            if (editor.getModel().getValueLengthInRange(selection) < SEARCH_STRING_MAX_LENGTH) return editor.getModel().getValueInRange(selection);
        }
    }
    return null;
}
let CommonFindController = class CommonFindController extends (0, _lifecycleJs.Disposable) {
    static{
        CommonFindController_1 = this;
    }
    static{
        this.ID = "editor.contrib.findController";
    }
    get editor() {
        return this._editor;
    }
    static get(editor) {
        return editor.getContribution(CommonFindController_1.ID);
    }
    constructor(editor, contextKeyService, storageService, clipboardService, notificationService, hoverService){
        super();
        this._editor = editor;
        this._findWidgetVisible = (0, _findModelJs.CONTEXT_FIND_WIDGET_VISIBLE).bindTo(contextKeyService);
        this._contextKeyService = contextKeyService;
        this._storageService = storageService;
        this._clipboardService = clipboardService;
        this._notificationService = notificationService;
        this._hoverService = hoverService;
        this._updateHistoryDelayer = new (0, _asyncJs.Delayer)(500);
        this._state = this._register(new (0, _findStateJs.FindReplaceState)());
        this.loadQueryState();
        this._register(this._state.onFindReplaceStateChange((e)=>this._onStateChanged(e)));
        this._model = null;
        this._register(this._editor.onDidChangeModel(()=>{
            const shouldRestartFind = this._editor.getModel() && this._state.isRevealed;
            this.disposeModel();
            this._state.change({
                searchScope: null,
                matchCase: this._storageService.getBoolean("editor.matchCase", 1 /* StorageScope.WORKSPACE */ , false),
                wholeWord: this._storageService.getBoolean("editor.wholeWord", 1 /* StorageScope.WORKSPACE */ , false),
                isRegex: this._storageService.getBoolean("editor.isRegex", 1 /* StorageScope.WORKSPACE */ , false),
                preserveCase: this._storageService.getBoolean("editor.preserveCase", 1 /* StorageScope.WORKSPACE */ , false)
            }, false);
            if (shouldRestartFind) this._start({
                forceRevealReplace: false,
                seedSearchStringFromSelection: "none",
                seedSearchStringFromNonEmptySelection: false,
                seedSearchStringFromGlobalClipboard: false,
                shouldFocus: 0 /* FindStartFocusAction.NoFocusChange */ ,
                shouldAnimate: false,
                updateSearchScope: false,
                loop: this._editor.getOption(41 /* EditorOption.find */ ).loop
            });
        }));
    }
    dispose() {
        this.disposeModel();
        super.dispose();
    }
    disposeModel() {
        if (this._model) {
            this._model.dispose();
            this._model = null;
        }
    }
    _onStateChanged(e) {
        this.saveQueryState(e);
        if (e.isRevealed) {
            if (this._state.isRevealed) this._findWidgetVisible.set(true);
            else {
                this._findWidgetVisible.reset();
                this.disposeModel();
            }
        }
        if (e.searchString) this.setGlobalBufferTerm(this._state.searchString);
    }
    saveQueryState(e) {
        if (e.isRegex) this._storageService.store("editor.isRegex", this._state.actualIsRegex, 1 /* StorageScope.WORKSPACE */ , 1 /* StorageTarget.MACHINE */ );
        if (e.wholeWord) this._storageService.store("editor.wholeWord", this._state.actualWholeWord, 1 /* StorageScope.WORKSPACE */ , 1 /* StorageTarget.MACHINE */ );
        if (e.matchCase) this._storageService.store("editor.matchCase", this._state.actualMatchCase, 1 /* StorageScope.WORKSPACE */ , 1 /* StorageTarget.MACHINE */ );
        if (e.preserveCase) this._storageService.store("editor.preserveCase", this._state.actualPreserveCase, 1 /* StorageScope.WORKSPACE */ , 1 /* StorageTarget.MACHINE */ );
    }
    loadQueryState() {
        this._state.change({
            matchCase: this._storageService.getBoolean("editor.matchCase", 1 /* StorageScope.WORKSPACE */ , this._state.matchCase),
            wholeWord: this._storageService.getBoolean("editor.wholeWord", 1 /* StorageScope.WORKSPACE */ , this._state.wholeWord),
            isRegex: this._storageService.getBoolean("editor.isRegex", 1 /* StorageScope.WORKSPACE */ , this._state.isRegex),
            preserveCase: this._storageService.getBoolean("editor.preserveCase", 1 /* StorageScope.WORKSPACE */ , this._state.preserveCase)
        }, false);
    }
    isFindInputFocused() {
        return !!(0, _findModelJs.CONTEXT_FIND_INPUT_FOCUSED).getValue(this._contextKeyService);
    }
    getState() {
        return this._state;
    }
    closeFindWidget() {
        this._state.change({
            isRevealed: false,
            searchScope: null
        }, false);
        this._editor.focus();
    }
    toggleCaseSensitive() {
        this._state.change({
            matchCase: !this._state.matchCase
        }, false);
        if (!this._state.isRevealed) this.highlightFindOptions();
    }
    toggleWholeWords() {
        this._state.change({
            wholeWord: !this._state.wholeWord
        }, false);
        if (!this._state.isRevealed) this.highlightFindOptions();
    }
    toggleRegex() {
        this._state.change({
            isRegex: !this._state.isRegex
        }, false);
        if (!this._state.isRevealed) this.highlightFindOptions();
    }
    togglePreserveCase() {
        this._state.change({
            preserveCase: !this._state.preserveCase
        }, false);
        if (!this._state.isRevealed) this.highlightFindOptions();
    }
    toggleSearchScope() {
        if (this._state.searchScope) this._state.change({
            searchScope: null
        }, true);
        else if (this._editor.hasModel()) {
            let selections = this._editor.getSelections();
            selections = selections.map((selection)=>{
                if (selection.endColumn === 1 && selection.endLineNumber > selection.startLineNumber) selection = selection.setEndPosition(selection.endLineNumber - 1, this._editor.getModel().getLineMaxColumn(selection.endLineNumber - 1));
                if (!selection.isEmpty()) return selection;
                return null;
            }).filter((element)=>!!element);
            if (selections.length) this._state.change({
                searchScope: selections
            }, true);
        }
    }
    setSearchString(searchString) {
        if (this._state.isRegex) searchString = _stringsJs.escapeRegExpCharacters(searchString);
        this._state.change({
            searchString: searchString
        }, false);
    }
    highlightFindOptions(ignoreWhenVisible = false) {
    // overwritten in subclass
    }
    async _start(opts, newState) {
        this.disposeModel();
        if (!this._editor.hasModel()) // cannot do anything with an editor that doesn't have a model...
        return;
        const stateChanges = {
            ...newState,
            isRevealed: true
        };
        if (opts.seedSearchStringFromSelection === "single") {
            const selectionSearchString = getSelectionSearchString(this._editor, opts.seedSearchStringFromSelection, opts.seedSearchStringFromNonEmptySelection);
            if (selectionSearchString) {
                if (this._state.isRegex) stateChanges.searchString = _stringsJs.escapeRegExpCharacters(selectionSearchString);
                else stateChanges.searchString = selectionSearchString;
            }
        } else if (opts.seedSearchStringFromSelection === "multiple" && !opts.updateSearchScope) {
            const selectionSearchString = getSelectionSearchString(this._editor, opts.seedSearchStringFromSelection);
            if (selectionSearchString) stateChanges.searchString = selectionSearchString;
        }
        if (!stateChanges.searchString && opts.seedSearchStringFromGlobalClipboard) {
            const selectionSearchString = await this.getGlobalBufferTerm();
            if (!this._editor.hasModel()) // the editor has lost its model in the meantime
            return;
            if (selectionSearchString) stateChanges.searchString = selectionSearchString;
        }
        // Overwrite isReplaceRevealed
        if (opts.forceRevealReplace || stateChanges.isReplaceRevealed) stateChanges.isReplaceRevealed = true;
        else if (!this._findWidgetVisible.get()) stateChanges.isReplaceRevealed = false;
        if (opts.updateSearchScope) {
            const currentSelections = this._editor.getSelections();
            if (currentSelections.some((selection)=>!selection.isEmpty())) stateChanges.searchScope = currentSelections;
        }
        stateChanges.loop = opts.loop;
        this._state.change(stateChanges, false);
        if (!this._model) this._model = new (0, _findModelJs.FindModelBoundToEditorModel)(this._editor, this._state);
    }
    start(opts, newState) {
        return this._start(opts, newState);
    }
    moveToNextMatch() {
        if (this._model) {
            this._model.moveToNextMatch();
            return true;
        }
        return false;
    }
    moveToPrevMatch() {
        if (this._model) {
            this._model.moveToPrevMatch();
            return true;
        }
        return false;
    }
    goToMatch(index) {
        if (this._model) {
            this._model.moveToMatch(index);
            return true;
        }
        return false;
    }
    replace() {
        if (this._model) {
            this._model.replace();
            return true;
        }
        return false;
    }
    replaceAll() {
        if (this._model) {
            if (this._editor.getModel()?.isTooLargeForHeapOperation()) {
                this._notificationService.warn(_nlsJs.localize("too.large.for.replaceall", "The file is too large to perform a replace all operation."));
                return false;
            }
            this._model.replaceAll();
            return true;
        }
        return false;
    }
    selectAllMatches() {
        if (this._model) {
            this._model.selectAllMatches();
            this._editor.focus();
            return true;
        }
        return false;
    }
    async getGlobalBufferTerm() {
        if (this._editor.getOption(41 /* EditorOption.find */ ).globalFindClipboard && this._editor.hasModel() && !this._editor.getModel().isTooLargeForSyncing()) return this._clipboardService.readFindText();
        return "";
    }
    setGlobalBufferTerm(text) {
        if (this._editor.getOption(41 /* EditorOption.find */ ).globalFindClipboard && this._editor.hasModel() && !this._editor.getModel().isTooLargeForSyncing()) // intentionally not awaited
        this._clipboardService.writeFindText(text);
    }
};
CommonFindController = CommonFindController_1 = __decorate([
    __param(1, (0, _contextkeyJs.IContextKeyService)),
    __param(2, (0, _storageJs.IStorageService)),
    __param(3, (0, _clipboardServiceJs.IClipboardService)),
    __param(4, (0, _notificationJs.INotificationService)),
    __param(5, (0, _hoverJs.IHoverService))
], CommonFindController);
let FindController = class FindController extends CommonFindController {
    constructor(editor, _contextViewService, _contextKeyService, _keybindingService, _themeService, notificationService, _storageService, clipboardService, hoverService){
        super(editor, _contextKeyService, _storageService, clipboardService, notificationService, hoverService);
        this._contextViewService = _contextViewService;
        this._keybindingService = _keybindingService;
        this._themeService = _themeService;
        this._widget = null;
        this._findOptionsWidget = null;
    }
    async _start(opts, newState) {
        if (!this._widget) this._createFindWidget();
        const selection = this._editor.getSelection();
        let updateSearchScope = false;
        switch(this._editor.getOption(41 /* EditorOption.find */ ).autoFindInSelection){
            case "always":
                updateSearchScope = true;
                break;
            case "never":
                updateSearchScope = false;
                break;
            case "multiline":
                {
                    const isSelectionMultipleLine = !!selection && selection.startLineNumber !== selection.endLineNumber;
                    updateSearchScope = isSelectionMultipleLine;
                    break;
                }
            default:
                break;
        }
        opts.updateSearchScope = opts.updateSearchScope || updateSearchScope;
        await super._start(opts, newState);
        if (this._widget) {
            if (opts.shouldFocus === 2 /* FindStartFocusAction.FocusReplaceInput */ ) this._widget.focusReplaceInput();
            else if (opts.shouldFocus === 1 /* FindStartFocusAction.FocusFindInput */ ) this._widget.focusFindInput();
        }
    }
    highlightFindOptions(ignoreWhenVisible = false) {
        if (!this._widget) this._createFindWidget();
        if (this._state.isRevealed && !ignoreWhenVisible) this._widget.highlightFindOptions();
        else this._findOptionsWidget.highlightFindOptions();
    }
    _createFindWidget() {
        this._widget = this._register(new (0, _findWidgetJs.FindWidget)(this._editor, this, this._state, this._contextViewService, this._keybindingService, this._contextKeyService, this._themeService, this._storageService, this._notificationService, this._hoverService));
        this._findOptionsWidget = this._register(new (0, _findOptionsWidgetJs.FindOptionsWidget)(this._editor, this._state, this._keybindingService));
    }
};
FindController = __decorate([
    __param(1, (0, _contextViewJs.IContextViewService)),
    __param(2, (0, _contextkeyJs.IContextKeyService)),
    __param(3, (0, _keybindingJs.IKeybindingService)),
    __param(4, (0, _themeServiceJs.IThemeService)),
    __param(5, (0, _notificationJs.INotificationService)),
    __param(6, (0, _storageJs.IStorageService)),
    __param(7, (0, _clipboardServiceJs.IClipboardService)),
    __param(8, (0, _hoverJs.IHoverService))
], FindController);
const StartFindAction = (0, _editorExtensionsJs.registerMultiEditorAction)(new (0, _editorExtensionsJs.MultiEditorAction)({
    id: (0, _findModelJs.FIND_IDS).StartFindAction,
    label: _nlsJs.localize("startFindAction", "Find"),
    alias: "Find",
    precondition: (0, _contextkeyJs.ContextKeyExpr).or((0, _editorContextKeysJs.EditorContextKeys).focus, (0, _contextkeyJs.ContextKeyExpr).has("editorIsOpen")),
    kbOpts: {
        kbExpr: null,
        primary: 2084 /* KeyCode.KeyF */ ,
        weight: 100 /* KeybindingWeight.EditorContrib */ 
    },
    menuOpts: {
        menuId: (0, _actionsJs.MenuId).MenubarEditMenu,
        group: "3_find",
        title: _nlsJs.localize({
            key: "miFind",
            comment: [
                "&& denotes a mnemonic"
            ]
        }, "&&Find"),
        order: 1
    }
}));
StartFindAction.addImplementation(0, (accessor, editor, args)=>{
    const controller = CommonFindController.get(editor);
    if (!controller) return false;
    return controller.start({
        forceRevealReplace: false,
        seedSearchStringFromSelection: editor.getOption(41 /* EditorOption.find */ ).seedSearchStringFromSelection !== "never" ? "single" : "none",
        seedSearchStringFromNonEmptySelection: editor.getOption(41 /* EditorOption.find */ ).seedSearchStringFromSelection === "selection",
        seedSearchStringFromGlobalClipboard: editor.getOption(41 /* EditorOption.find */ ).globalFindClipboard,
        shouldFocus: 1 /* FindStartFocusAction.FocusFindInput */ ,
        shouldAnimate: true,
        updateSearchScope: false,
        loop: editor.getOption(41 /* EditorOption.find */ ).loop
    });
});
const findArgDescription = {
    description: "Open a new In-Editor Find Widget.",
    args: [
        {
            name: "Open a new In-Editor Find Widget args",
            schema: {
                properties: {
                    searchString: {
                        type: "string"
                    },
                    replaceString: {
                        type: "string"
                    },
                    isRegex: {
                        type: "boolean"
                    },
                    matchWholeWord: {
                        type: "boolean"
                    },
                    isCaseSensitive: {
                        type: "boolean"
                    },
                    preserveCase: {
                        type: "boolean"
                    },
                    findInSelection: {
                        type: "boolean"
                    }
                }
            }
        }
    ]
};
class StartFindWithArgsAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _findModelJs.FIND_IDS).StartFindWithArgs,
            label: _nlsJs.localize("startFindWithArgsAction", "Find With Arguments"),
            alias: "Find With Arguments",
            precondition: undefined,
            kbOpts: {
                kbExpr: null,
                primary: 0,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: findArgDescription
        });
    }
    async run(accessor, editor, args) {
        const controller = CommonFindController.get(editor);
        if (controller) {
            const newState = args ? {
                searchString: args.searchString,
                replaceString: args.replaceString,
                isReplaceRevealed: args.replaceString !== undefined,
                isRegex: args.isRegex,
                // isRegexOverride: args.regexOverride,
                wholeWord: args.matchWholeWord,
                // wholeWordOverride: args.wholeWordOverride,
                matchCase: args.isCaseSensitive,
                // matchCaseOverride: args.matchCaseOverride,
                preserveCase: args.preserveCase
            } : {};
            await controller.start({
                forceRevealReplace: false,
                seedSearchStringFromSelection: controller.getState().searchString.length === 0 && editor.getOption(41 /* EditorOption.find */ ).seedSearchStringFromSelection !== "never" ? "single" : "none",
                seedSearchStringFromNonEmptySelection: editor.getOption(41 /* EditorOption.find */ ).seedSearchStringFromSelection === "selection",
                seedSearchStringFromGlobalClipboard: true,
                shouldFocus: 1 /* FindStartFocusAction.FocusFindInput */ ,
                shouldAnimate: true,
                updateSearchScope: args?.findInSelection || false,
                loop: editor.getOption(41 /* EditorOption.find */ ).loop
            }, newState);
            controller.setGlobalBufferTerm(controller.getState().searchString);
        }
    }
}
class StartFindWithSelectionAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _findModelJs.FIND_IDS).StartFindWithSelection,
            label: _nlsJs.localize("startFindWithSelectionAction", "Find With Selection"),
            alias: "Find With Selection",
            precondition: undefined,
            kbOpts: {
                kbExpr: null,
                primary: 0,
                mac: {
                    primary: 2083 /* KeyCode.KeyE */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    async run(accessor, editor) {
        const controller = CommonFindController.get(editor);
        if (controller) {
            await controller.start({
                forceRevealReplace: false,
                seedSearchStringFromSelection: "multiple",
                seedSearchStringFromNonEmptySelection: false,
                seedSearchStringFromGlobalClipboard: false,
                shouldFocus: 0 /* FindStartFocusAction.NoFocusChange */ ,
                shouldAnimate: true,
                updateSearchScope: false,
                loop: editor.getOption(41 /* EditorOption.find */ ).loop
            });
            controller.setGlobalBufferTerm(controller.getState().searchString);
        }
    }
}
class MatchFindAction extends (0, _editorExtensionsJs.EditorAction) {
    async run(accessor, editor) {
        const controller = CommonFindController.get(editor);
        if (controller && !this._run(controller)) {
            await controller.start({
                forceRevealReplace: false,
                seedSearchStringFromSelection: controller.getState().searchString.length === 0 && editor.getOption(41 /* EditorOption.find */ ).seedSearchStringFromSelection !== "never" ? "single" : "none",
                seedSearchStringFromNonEmptySelection: editor.getOption(41 /* EditorOption.find */ ).seedSearchStringFromSelection === "selection",
                seedSearchStringFromGlobalClipboard: true,
                shouldFocus: 0 /* FindStartFocusAction.NoFocusChange */ ,
                shouldAnimate: true,
                updateSearchScope: false,
                loop: editor.getOption(41 /* EditorOption.find */ ).loop
            });
            this._run(controller);
        }
    }
}
class NextMatchFindAction extends MatchFindAction {
    constructor(){
        super({
            id: (0, _findModelJs.FIND_IDS).NextMatchFindAction,
            label: _nlsJs.localize("findNextMatchAction", "Find Next"),
            alias: "Find Next",
            precondition: undefined,
            kbOpts: [
                {
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                    primary: 61 /* KeyCode.F3 */ ,
                    mac: {
                        primary: 2085 /* KeyCode.KeyG */ ,
                        secondary: [
                            61 /* KeyCode.F3 */ 
                        ]
                    },
                    weight: 100 /* KeybindingWeight.EditorContrib */ 
                },
                {
                    kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).focus, (0, _findModelJs.CONTEXT_FIND_INPUT_FOCUSED)),
                    primary: 3 /* KeyCode.Enter */ ,
                    weight: 100 /* KeybindingWeight.EditorContrib */ 
                }
            ]
        });
    }
    _run(controller) {
        const result = controller.moveToNextMatch();
        if (result) {
            controller.editor.pushUndoStop();
            return true;
        }
        return false;
    }
}
class PreviousMatchFindAction extends MatchFindAction {
    constructor(){
        super({
            id: (0, _findModelJs.FIND_IDS).PreviousMatchFindAction,
            label: _nlsJs.localize("findPreviousMatchAction", "Find Previous"),
            alias: "Find Previous",
            precondition: undefined,
            kbOpts: [
                {
                    kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                    primary: 1085 /* KeyCode.F3 */ ,
                    mac: {
                        primary: 3109 /* KeyCode.KeyG */ ,
                        secondary: [
                            1085 /* KeyCode.F3 */ 
                        ]
                    },
                    weight: 100 /* KeybindingWeight.EditorContrib */ 
                },
                {
                    kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).focus, (0, _findModelJs.CONTEXT_FIND_INPUT_FOCUSED)),
                    primary: 1027 /* KeyCode.Enter */ ,
                    weight: 100 /* KeybindingWeight.EditorContrib */ 
                }
            ]
        });
    }
    _run(controller) {
        return controller.moveToPrevMatch();
    }
}
class MoveToMatchFindAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _findModelJs.FIND_IDS).GoToMatchFindAction,
            label: _nlsJs.localize("findMatchAction.goToMatch", "Go to Match..."),
            alias: "Go to Match...",
            precondition: (0, _findModelJs.CONTEXT_FIND_WIDGET_VISIBLE)
        });
        this._highlightDecorations = [];
    }
    run(accessor, editor, args) {
        const controller = CommonFindController.get(editor);
        if (!controller) return;
        const matchesCount = controller.getState().matchesCount;
        if (matchesCount < 1) {
            const notificationService = accessor.get((0, _notificationJs.INotificationService));
            notificationService.notify({
                severity: (0, _notificationJs.Severity).Warning,
                message: _nlsJs.localize("findMatchAction.noResults", "No matches. Try searching for something else.")
            });
            return;
        }
        const quickInputService = accessor.get((0, _quickInputJs.IQuickInputService));
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        const inputBox = disposables.add(quickInputService.createInputBox());
        inputBox.placeholder = _nlsJs.localize("findMatchAction.inputPlaceHolder", "Type a number to go to a specific match (between 1 and {0})", matchesCount);
        const toFindMatchIndex = (value)=>{
            const index = parseInt(value);
            if (isNaN(index)) return undefined;
            const matchCount = controller.getState().matchesCount;
            if (index > 0 && index <= matchCount) return index - 1; // zero based
            else if (index < 0 && index >= -matchCount) return matchCount + index;
            return undefined;
        };
        const updatePickerAndEditor = (value)=>{
            const index = toFindMatchIndex(value);
            if (typeof index === "number") {
                // valid
                inputBox.validationMessage = undefined;
                controller.goToMatch(index);
                const currentMatch = controller.getState().currentMatch;
                if (currentMatch) this.addDecorations(editor, currentMatch);
            } else {
                inputBox.validationMessage = _nlsJs.localize("findMatchAction.inputValidationMessage", "Please type a number between 1 and {0}", controller.getState().matchesCount);
                this.clearDecorations(editor);
            }
        };
        disposables.add(inputBox.onDidChangeValue((value)=>{
            updatePickerAndEditor(value);
        }));
        disposables.add(inputBox.onDidAccept(()=>{
            const index = toFindMatchIndex(inputBox.value);
            if (typeof index === "number") {
                controller.goToMatch(index);
                inputBox.hide();
            } else inputBox.validationMessage = _nlsJs.localize("findMatchAction.inputValidationMessage", "Please type a number between 1 and {0}", controller.getState().matchesCount);
        }));
        disposables.add(inputBox.onDidHide(()=>{
            this.clearDecorations(editor);
            disposables.dispose();
        }));
        inputBox.show();
    }
    clearDecorations(editor) {
        editor.changeDecorations((changeAccessor)=>{
            this._highlightDecorations = changeAccessor.deltaDecorations(this._highlightDecorations, []);
        });
    }
    addDecorations(editor, range) {
        editor.changeDecorations((changeAccessor)=>{
            this._highlightDecorations = changeAccessor.deltaDecorations(this._highlightDecorations, [
                {
                    range,
                    options: {
                        description: "find-match-quick-access-range-highlight",
                        className: "rangeHighlight",
                        isWholeLine: true
                    }
                },
                {
                    range,
                    options: {
                        description: "find-match-quick-access-range-highlight-overview",
                        overviewRuler: {
                            color: (0, _themeServiceJs.themeColorFromId)((0, _editorColorRegistryJs.overviewRulerRangeHighlight)),
                            position: (0, _modelJs.OverviewRulerLane).Full
                        }
                    }
                }
            ]);
        });
    }
}
class SelectionMatchFindAction extends (0, _editorExtensionsJs.EditorAction) {
    async run(accessor, editor) {
        const controller = CommonFindController.get(editor);
        if (!controller) return;
        const selectionSearchString = getSelectionSearchString(editor, "single", false);
        if (selectionSearchString) controller.setSearchString(selectionSearchString);
        if (!this._run(controller)) {
            await controller.start({
                forceRevealReplace: false,
                seedSearchStringFromSelection: "none",
                seedSearchStringFromNonEmptySelection: false,
                seedSearchStringFromGlobalClipboard: false,
                shouldFocus: 0 /* FindStartFocusAction.NoFocusChange */ ,
                shouldAnimate: true,
                updateSearchScope: false,
                loop: editor.getOption(41 /* EditorOption.find */ ).loop
            });
            this._run(controller);
        }
    }
}
class NextSelectionMatchFindAction extends SelectionMatchFindAction {
    constructor(){
        super({
            id: (0, _findModelJs.FIND_IDS).NextSelectionMatchFindAction,
            label: _nlsJs.localize("nextSelectionMatchFindAction", "Find Next Selection"),
            alias: "Find Next Selection",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                primary: 2109 /* KeyCode.F3 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    _run(controller) {
        return controller.moveToNextMatch();
    }
}
class PreviousSelectionMatchFindAction extends SelectionMatchFindAction {
    constructor(){
        super({
            id: (0, _findModelJs.FIND_IDS).PreviousSelectionMatchFindAction,
            label: _nlsJs.localize("previousSelectionMatchFindAction", "Find Previous Selection"),
            alias: "Find Previous Selection",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                primary: 3133 /* KeyCode.F3 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    _run(controller) {
        return controller.moveToPrevMatch();
    }
}
const StartFindReplaceAction = (0, _editorExtensionsJs.registerMultiEditorAction)(new (0, _editorExtensionsJs.MultiEditorAction)({
    id: (0, _findModelJs.FIND_IDS).StartFindReplaceAction,
    label: _nlsJs.localize("startReplace", "Replace"),
    alias: "Replace",
    precondition: (0, _contextkeyJs.ContextKeyExpr).or((0, _editorContextKeysJs.EditorContextKeys).focus, (0, _contextkeyJs.ContextKeyExpr).has("editorIsOpen")),
    kbOpts: {
        kbExpr: null,
        primary: 2086 /* KeyCode.KeyH */ ,
        mac: {
            primary: 2596 /* KeyCode.KeyF */ 
        },
        weight: 100 /* KeybindingWeight.EditorContrib */ 
    },
    menuOpts: {
        menuId: (0, _actionsJs.MenuId).MenubarEditMenu,
        group: "3_find",
        title: _nlsJs.localize({
            key: "miReplace",
            comment: [
                "&& denotes a mnemonic"
            ]
        }, "&&Replace"),
        order: 2
    }
}));
StartFindReplaceAction.addImplementation(0, (accessor, editor, args)=>{
    if (!editor.hasModel() || editor.getOption(92 /* EditorOption.readOnly */ )) return false;
    const controller = CommonFindController.get(editor);
    if (!controller) return false;
    const currentSelection = editor.getSelection();
    const findInputFocused = controller.isFindInputFocused();
    // we only seed search string from selection when the current selection is single line and not empty,
    // + the find input is not focused
    const seedSearchStringFromSelection = !currentSelection.isEmpty() && currentSelection.startLineNumber === currentSelection.endLineNumber && editor.getOption(41 /* EditorOption.find */ ).seedSearchStringFromSelection !== "never" && !findInputFocused;
    /*
    * if the existing search string in find widget is empty and we don't seed search string from selection, it means the Find Input is still empty, so we should focus the Find Input instead of Replace Input.

    * findInputFocused true -> seedSearchStringFromSelection false, FocusReplaceInput
    * findInputFocused false, seedSearchStringFromSelection true FocusReplaceInput
    * findInputFocused false seedSearchStringFromSelection false FocusFindInput
    */ const shouldFocus = findInputFocused || seedSearchStringFromSelection ? 2 /* FindStartFocusAction.FocusReplaceInput */  : 1 /* FindStartFocusAction.FocusFindInput */ ;
    return controller.start({
        forceRevealReplace: true,
        seedSearchStringFromSelection: seedSearchStringFromSelection ? "single" : "none",
        seedSearchStringFromNonEmptySelection: editor.getOption(41 /* EditorOption.find */ ).seedSearchStringFromSelection === "selection",
        seedSearchStringFromGlobalClipboard: editor.getOption(41 /* EditorOption.find */ ).seedSearchStringFromSelection !== "never",
        shouldFocus: shouldFocus,
        shouldAnimate: true,
        updateSearchScope: false,
        loop: editor.getOption(41 /* EditorOption.find */ ).loop
    });
});
(0, _editorExtensionsJs.registerEditorContribution)(CommonFindController.ID, FindController, 0 /* EditorContributionInstantiation.Eager */ ); // eager because it uses `saveViewState`/`restoreViewState`
(0, _editorExtensionsJs.registerEditorAction)(StartFindWithArgsAction);
(0, _editorExtensionsJs.registerEditorAction)(StartFindWithSelectionAction);
(0, _editorExtensionsJs.registerEditorAction)(NextMatchFindAction);
(0, _editorExtensionsJs.registerEditorAction)(PreviousMatchFindAction);
(0, _editorExtensionsJs.registerEditorAction)(MoveToMatchFindAction);
(0, _editorExtensionsJs.registerEditorAction)(NextSelectionMatchFindAction);
(0, _editorExtensionsJs.registerEditorAction)(PreviousSelectionMatchFindAction);
const FindCommand = (0, _editorExtensionsJs.EditorCommand).bindToContribution(CommonFindController.get);
(0, _editorExtensionsJs.registerEditorCommand)(new FindCommand({
    id: (0, _findModelJs.FIND_IDS).CloseFindWidgetCommand,
    precondition: (0, _findModelJs.CONTEXT_FIND_WIDGET_VISIBLE),
    handler: (x)=>x.closeFindWidget(),
    kbOpts: {
        weight: 105,
        kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).focus, (0, _contextkeyJs.ContextKeyExpr).not("isComposing")),
        primary: 9 /* KeyCode.Escape */ ,
        secondary: [
            1033 /* KeyCode.Escape */ 
        ]
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new FindCommand({
    id: (0, _findModelJs.FIND_IDS).ToggleCaseSensitiveCommand,
    precondition: undefined,
    handler: (x)=>x.toggleCaseSensitive(),
    kbOpts: {
        weight: 105,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: (0, _findModelJs.ToggleCaseSensitiveKeybinding).primary,
        mac: (0, _findModelJs.ToggleCaseSensitiveKeybinding).mac,
        win: (0, _findModelJs.ToggleCaseSensitiveKeybinding).win,
        linux: (0, _findModelJs.ToggleCaseSensitiveKeybinding).linux
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new FindCommand({
    id: (0, _findModelJs.FIND_IDS).ToggleWholeWordCommand,
    precondition: undefined,
    handler: (x)=>x.toggleWholeWords(),
    kbOpts: {
        weight: 105,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: (0, _findModelJs.ToggleWholeWordKeybinding).primary,
        mac: (0, _findModelJs.ToggleWholeWordKeybinding).mac,
        win: (0, _findModelJs.ToggleWholeWordKeybinding).win,
        linux: (0, _findModelJs.ToggleWholeWordKeybinding).linux
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new FindCommand({
    id: (0, _findModelJs.FIND_IDS).ToggleRegexCommand,
    precondition: undefined,
    handler: (x)=>x.toggleRegex(),
    kbOpts: {
        weight: 105,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: (0, _findModelJs.ToggleRegexKeybinding).primary,
        mac: (0, _findModelJs.ToggleRegexKeybinding).mac,
        win: (0, _findModelJs.ToggleRegexKeybinding).win,
        linux: (0, _findModelJs.ToggleRegexKeybinding).linux
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new FindCommand({
    id: (0, _findModelJs.FIND_IDS).ToggleSearchScopeCommand,
    precondition: undefined,
    handler: (x)=>x.toggleSearchScope(),
    kbOpts: {
        weight: 105,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: (0, _findModelJs.ToggleSearchScopeKeybinding).primary,
        mac: (0, _findModelJs.ToggleSearchScopeKeybinding).mac,
        win: (0, _findModelJs.ToggleSearchScopeKeybinding).win,
        linux: (0, _findModelJs.ToggleSearchScopeKeybinding).linux
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new FindCommand({
    id: (0, _findModelJs.FIND_IDS).TogglePreserveCaseCommand,
    precondition: undefined,
    handler: (x)=>x.togglePreserveCase(),
    kbOpts: {
        weight: 105,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: (0, _findModelJs.TogglePreserveCaseKeybinding).primary,
        mac: (0, _findModelJs.TogglePreserveCaseKeybinding).mac,
        win: (0, _findModelJs.TogglePreserveCaseKeybinding).win,
        linux: (0, _findModelJs.TogglePreserveCaseKeybinding).linux
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new FindCommand({
    id: (0, _findModelJs.FIND_IDS).ReplaceOneAction,
    precondition: (0, _findModelJs.CONTEXT_FIND_WIDGET_VISIBLE),
    handler: (x)=>x.replace(),
    kbOpts: {
        weight: 105,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: 3094 /* KeyCode.Digit1 */ 
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new FindCommand({
    id: (0, _findModelJs.FIND_IDS).ReplaceOneAction,
    precondition: (0, _findModelJs.CONTEXT_FIND_WIDGET_VISIBLE),
    handler: (x)=>x.replace(),
    kbOpts: {
        weight: 105,
        kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).focus, (0, _findModelJs.CONTEXT_REPLACE_INPUT_FOCUSED)),
        primary: 3 /* KeyCode.Enter */ 
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new FindCommand({
    id: (0, _findModelJs.FIND_IDS).ReplaceAllAction,
    precondition: (0, _findModelJs.CONTEXT_FIND_WIDGET_VISIBLE),
    handler: (x)=>x.replaceAll(),
    kbOpts: {
        weight: 105,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: 2563 /* KeyCode.Enter */ 
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new FindCommand({
    id: (0, _findModelJs.FIND_IDS).ReplaceAllAction,
    precondition: (0, _findModelJs.CONTEXT_FIND_WIDGET_VISIBLE),
    handler: (x)=>x.replaceAll(),
    kbOpts: {
        weight: 105,
        kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).focus, (0, _findModelJs.CONTEXT_REPLACE_INPUT_FOCUSED)),
        primary: undefined,
        mac: {
            primary: 2051 /* KeyCode.Enter */ 
        }
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new FindCommand({
    id: (0, _findModelJs.FIND_IDS).SelectAllMatchesAction,
    precondition: (0, _findModelJs.CONTEXT_FIND_WIDGET_VISIBLE),
    handler: (x)=>x.selectAllMatches(),
    kbOpts: {
        weight: 105,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: 515 /* KeyCode.Enter */ 
    }
}));

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/strings.js":"aA9I1","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/editorColorRegistry.js":"5XqtL","../../../common/editorContextKeys.js":"5exv9","../../../common/model.js":"1CSIB","./findModel.js":"8SA2y","./findOptionsWidget.js":"aT9UY","./findState.js":"khiKH","./findWidget.js":"bXBKv","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/clipboard/common/clipboardService.js":"4IsFp","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/contextview/browser/contextView.js":"2QlUR","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../platform/notification/common/notification.js":"igv0W","../../../../platform/quickinput/common/quickInput.js":"a56M6","../../../../platform/storage/common/storage.js":"6AhR2","../../../../platform/theme/common/themeService.js":"jMkIC","../../../../platform/hover/browser/hover.js":"3QGXp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8SA2y":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTEXT_FIND_WIDGET_VISIBLE", ()=>CONTEXT_FIND_WIDGET_VISIBLE);
parcelHelpers.export(exports, "CONTEXT_FIND_WIDGET_NOT_VISIBLE", ()=>CONTEXT_FIND_WIDGET_NOT_VISIBLE);
parcelHelpers.export(exports, "CONTEXT_FIND_INPUT_FOCUSED", ()=>CONTEXT_FIND_INPUT_FOCUSED);
parcelHelpers.export(exports, "CONTEXT_REPLACE_INPUT_FOCUSED", ()=>CONTEXT_REPLACE_INPUT_FOCUSED);
parcelHelpers.export(exports, "ToggleCaseSensitiveKeybinding", ()=>ToggleCaseSensitiveKeybinding);
parcelHelpers.export(exports, "ToggleWholeWordKeybinding", ()=>ToggleWholeWordKeybinding);
parcelHelpers.export(exports, "ToggleRegexKeybinding", ()=>ToggleRegexKeybinding);
parcelHelpers.export(exports, "ToggleSearchScopeKeybinding", ()=>ToggleSearchScopeKeybinding);
parcelHelpers.export(exports, "TogglePreserveCaseKeybinding", ()=>TogglePreserveCaseKeybinding);
parcelHelpers.export(exports, "FIND_IDS", ()=>FIND_IDS);
parcelHelpers.export(exports, "MATCHES_LIMIT", ()=>MATCHES_LIMIT);
parcelHelpers.export(exports, "FindModelBoundToEditorModel", ()=>FindModelBoundToEditorModel);
var _arraysFindJs = require("../../../../base/common/arraysFind.js");
var _asyncJs = require("../../../../base/common/async.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _replaceCommandJs = require("../../../common/commands/replaceCommand.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _textModelSearchJs = require("../../../common/model/textModelSearch.js");
var _findDecorationsJs = require("./findDecorations.js");
var _replaceAllCommandJs = require("./replaceAllCommand.js");
var _replacePatternJs = require("./replacePattern.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
const CONTEXT_FIND_WIDGET_VISIBLE = new (0, _contextkeyJs.RawContextKey)("findWidgetVisible", false);
const CONTEXT_FIND_WIDGET_NOT_VISIBLE = CONTEXT_FIND_WIDGET_VISIBLE.toNegated();
const CONTEXT_FIND_INPUT_FOCUSED = new (0, _contextkeyJs.RawContextKey)("findInputFocussed", false);
const CONTEXT_REPLACE_INPUT_FOCUSED = new (0, _contextkeyJs.RawContextKey)("replaceInputFocussed", false);
const ToggleCaseSensitiveKeybinding = {
    primary: 545 /* KeyCode.KeyC */ ,
    mac: {
        primary: 2593 /* KeyCode.KeyC */ 
    }
};
const ToggleWholeWordKeybinding = {
    primary: 565 /* KeyCode.KeyW */ ,
    mac: {
        primary: 2613 /* KeyCode.KeyW */ 
    }
};
const ToggleRegexKeybinding = {
    primary: 560 /* KeyCode.KeyR */ ,
    mac: {
        primary: 2608 /* KeyCode.KeyR */ 
    }
};
const ToggleSearchScopeKeybinding = {
    primary: 554 /* KeyCode.KeyL */ ,
    mac: {
        primary: 2602 /* KeyCode.KeyL */ 
    }
};
const TogglePreserveCaseKeybinding = {
    primary: 558 /* KeyCode.KeyP */ ,
    mac: {
        primary: 2606 /* KeyCode.KeyP */ 
    }
};
const FIND_IDS = {
    StartFindAction: "actions.find",
    StartFindWithSelection: "actions.findWithSelection",
    StartFindWithArgs: "editor.actions.findWithArgs",
    NextMatchFindAction: "editor.action.nextMatchFindAction",
    PreviousMatchFindAction: "editor.action.previousMatchFindAction",
    GoToMatchFindAction: "editor.action.goToMatchFindAction",
    NextSelectionMatchFindAction: "editor.action.nextSelectionMatchFindAction",
    PreviousSelectionMatchFindAction: "editor.action.previousSelectionMatchFindAction",
    StartFindReplaceAction: "editor.action.startFindReplaceAction",
    CloseFindWidgetCommand: "closeFindWidget",
    ToggleCaseSensitiveCommand: "toggleFindCaseSensitive",
    ToggleWholeWordCommand: "toggleFindWholeWord",
    ToggleRegexCommand: "toggleFindRegex",
    ToggleSearchScopeCommand: "toggleFindInSelection",
    TogglePreserveCaseCommand: "togglePreserveCase",
    ReplaceOneAction: "editor.action.replaceOne",
    ReplaceAllAction: "editor.action.replaceAll",
    SelectAllMatchesAction: "editor.action.selectAllMatches"
};
const MATCHES_LIMIT = 19999;
const RESEARCH_DELAY = 240;
class FindModelBoundToEditorModel {
    constructor(editor, state){
        this._toDispose = new (0, _lifecycleJs.DisposableStore)();
        this._editor = editor;
        this._state = state;
        this._isDisposed = false;
        this._startSearchingTimer = new (0, _asyncJs.TimeoutTimer)();
        this._decorations = new (0, _findDecorationsJs.FindDecorations)(editor);
        this._toDispose.add(this._decorations);
        this._updateDecorationsScheduler = new (0, _asyncJs.RunOnceScheduler)(()=>{
            if (!this._editor.hasModel()) return;
            return this.research(false);
        }, 100);
        this._toDispose.add(this._updateDecorationsScheduler);
        this._toDispose.add(this._editor.onDidChangeCursorPosition((e)=>{
            if (e.reason === 3 /* CursorChangeReason.Explicit */  || e.reason === 5 /* CursorChangeReason.Undo */  || e.reason === 6 /* CursorChangeReason.Redo */ ) this._decorations.setStartPosition(this._editor.getPosition());
        }));
        this._ignoreModelContentChanged = false;
        this._toDispose.add(this._editor.onDidChangeModelContent((e)=>{
            if (this._ignoreModelContentChanged) return;
            if (e.isFlush) // a model.setValue() was called
            this._decorations.reset();
            this._decorations.setStartPosition(this._editor.getPosition());
            this._updateDecorationsScheduler.schedule();
        }));
        this._toDispose.add(this._state.onFindReplaceStateChange((e)=>this._onStateChanged(e)));
        this.research(false, this._state.searchScope);
    }
    dispose() {
        this._isDisposed = true;
        (0, _lifecycleJs.dispose)(this._startSearchingTimer);
        this._toDispose.dispose();
    }
    _onStateChanged(e) {
        if (this._isDisposed) // The find model is disposed during a find state changed event
        return;
        if (!this._editor.hasModel()) // The find model will be disposed momentarily
        return;
        if (e.searchString || e.isReplaceRevealed || e.isRegex || e.wholeWord || e.matchCase || e.searchScope) {
            const model = this._editor.getModel();
            if (model.isTooLargeForSyncing()) {
                this._startSearchingTimer.cancel();
                this._startSearchingTimer.setIfNotSet(()=>{
                    if (e.searchScope) this.research(e.moveCursor, this._state.searchScope);
                    else this.research(e.moveCursor);
                }, RESEARCH_DELAY);
            } else if (e.searchScope) this.research(e.moveCursor, this._state.searchScope);
            else this.research(e.moveCursor);
        }
    }
    static _getSearchRange(model, findScope) {
        // If we have set now or before a find scope, use it for computing the search range
        if (findScope) return findScope;
        return model.getFullModelRange();
    }
    research(moveCursor, newFindScope) {
        let findScopes = null;
        if (typeof newFindScope !== "undefined") {
            if (newFindScope !== null) {
                if (!Array.isArray(newFindScope)) findScopes = [
                    newFindScope
                ];
                else findScopes = newFindScope;
            }
        } else findScopes = this._decorations.getFindScopes();
        if (findScopes !== null) findScopes = findScopes.map((findScope)=>{
            if (findScope.startLineNumber !== findScope.endLineNumber) {
                let endLineNumber = findScope.endLineNumber;
                if (findScope.endColumn === 1) endLineNumber = endLineNumber - 1;
                return new (0, _rangeJs.Range)(findScope.startLineNumber, 1, endLineNumber, this._editor.getModel().getLineMaxColumn(endLineNumber));
            }
            return findScope;
        });
        const findMatches = this._findMatches(findScopes, false, MATCHES_LIMIT);
        this._decorations.set(findMatches, findScopes);
        const editorSelection = this._editor.getSelection();
        let currentMatchesPosition = this._decorations.getCurrentMatchesPosition(editorSelection);
        if (currentMatchesPosition === 0 && findMatches.length > 0) {
            // current selection is not on top of a match
            // try to find its nearest result from the top of the document
            const matchAfterSelection = (0, _arraysFindJs.findFirstIdxMonotonousOrArrLen)(findMatches.map((match)=>match.range), (range)=>(0, _rangeJs.Range).compareRangesUsingStarts(range, editorSelection) >= 0);
            currentMatchesPosition = matchAfterSelection > 0 ? matchAfterSelection - 1 + 1 /** match position is one based */  : currentMatchesPosition;
        }
        this._state.changeMatchInfo(currentMatchesPosition, this._decorations.getCount(), undefined);
        if (moveCursor && this._editor.getOption(41 /* EditorOption.find */ ).cursorMoveOnType) this._moveToNextMatch(this._decorations.getStartPosition());
    }
    _hasMatches() {
        return this._state.matchesCount > 0;
    }
    _cannotFind() {
        if (!this._hasMatches()) {
            const findScope = this._decorations.getFindScope();
            if (findScope) // Reveal the selection so user is reminded that 'selection find' is on.
            this._editor.revealRangeInCenterIfOutsideViewport(findScope, 0 /* ScrollType.Smooth */ );
            return true;
        }
        return false;
    }
    _setCurrentFindMatch(match) {
        const matchesPosition = this._decorations.setCurrentFindMatch(match);
        this._state.changeMatchInfo(matchesPosition, this._decorations.getCount(), match);
        this._editor.setSelection(match);
        this._editor.revealRangeInCenterIfOutsideViewport(match, 0 /* ScrollType.Smooth */ );
    }
    _prevSearchPosition(before) {
        const isUsingLineStops = this._state.isRegex && (this._state.searchString.indexOf("^") >= 0 || this._state.searchString.indexOf("$") >= 0);
        let { lineNumber, column } = before;
        const model = this._editor.getModel();
        if (isUsingLineStops || column === 1) {
            if (lineNumber === 1) lineNumber = model.getLineCount();
            else lineNumber--;
            column = model.getLineMaxColumn(lineNumber);
        } else column--;
        return new (0, _positionJs.Position)(lineNumber, column);
    }
    _moveToPrevMatch(before, isRecursed = false) {
        if (!this._state.canNavigateBack()) {
            // we are beyond the first matched find result
            // instead of doing nothing, we should refocus the first item
            const nextMatchRange = this._decorations.matchAfterPosition(before);
            if (nextMatchRange) this._setCurrentFindMatch(nextMatchRange);
            return;
        }
        if (this._decorations.getCount() < MATCHES_LIMIT) {
            let prevMatchRange = this._decorations.matchBeforePosition(before);
            if (prevMatchRange && prevMatchRange.isEmpty() && prevMatchRange.getStartPosition().equals(before)) {
                before = this._prevSearchPosition(before);
                prevMatchRange = this._decorations.matchBeforePosition(before);
            }
            if (prevMatchRange) this._setCurrentFindMatch(prevMatchRange);
            return;
        }
        if (this._cannotFind()) return;
        const findScope = this._decorations.getFindScope();
        const searchRange = FindModelBoundToEditorModel._getSearchRange(this._editor.getModel(), findScope);
        // ...(----)...|...
        if (searchRange.getEndPosition().isBefore(before)) before = searchRange.getEndPosition();
        // ...|...(----)...
        if (before.isBefore(searchRange.getStartPosition())) before = searchRange.getEndPosition();
        const { lineNumber, column } = before;
        const model = this._editor.getModel();
        let position = new (0, _positionJs.Position)(lineNumber, column);
        let prevMatch = model.findPreviousMatch(this._state.searchString, position, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(132 /* EditorOption.wordSeparators */ ) : null, false);
        if (prevMatch && prevMatch.range.isEmpty() && prevMatch.range.getStartPosition().equals(position)) {
            // Looks like we're stuck at this position, unacceptable!
            position = this._prevSearchPosition(position);
            prevMatch = model.findPreviousMatch(this._state.searchString, position, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(132 /* EditorOption.wordSeparators */ ) : null, false);
        }
        if (!prevMatch) // there is precisely one match and selection is on top of it
        return;
        if (!isRecursed && !searchRange.containsRange(prevMatch.range)) return this._moveToPrevMatch(prevMatch.range.getStartPosition(), true);
        this._setCurrentFindMatch(prevMatch.range);
    }
    moveToPrevMatch() {
        this._moveToPrevMatch(this._editor.getSelection().getStartPosition());
    }
    _nextSearchPosition(after) {
        const isUsingLineStops = this._state.isRegex && (this._state.searchString.indexOf("^") >= 0 || this._state.searchString.indexOf("$") >= 0);
        let { lineNumber, column } = after;
        const model = this._editor.getModel();
        if (isUsingLineStops || column === model.getLineMaxColumn(lineNumber)) {
            if (lineNumber === model.getLineCount()) lineNumber = 1;
            else lineNumber++;
            column = 1;
        } else column++;
        return new (0, _positionJs.Position)(lineNumber, column);
    }
    _moveToNextMatch(after) {
        if (!this._state.canNavigateForward()) {
            // we are beyond the last matched find result
            // instead of doing nothing, we should refocus the last item
            const prevMatchRange = this._decorations.matchBeforePosition(after);
            if (prevMatchRange) this._setCurrentFindMatch(prevMatchRange);
            return;
        }
        if (this._decorations.getCount() < MATCHES_LIMIT) {
            let nextMatchRange = this._decorations.matchAfterPosition(after);
            if (nextMatchRange && nextMatchRange.isEmpty() && nextMatchRange.getStartPosition().equals(after)) {
                // Looks like we're stuck at this position, unacceptable!
                after = this._nextSearchPosition(after);
                nextMatchRange = this._decorations.matchAfterPosition(after);
            }
            if (nextMatchRange) this._setCurrentFindMatch(nextMatchRange);
            return;
        }
        const nextMatch = this._getNextMatch(after, false, true);
        if (nextMatch) this._setCurrentFindMatch(nextMatch.range);
    }
    _getNextMatch(after, captureMatches, forceMove, isRecursed = false) {
        if (this._cannotFind()) return null;
        const findScope = this._decorations.getFindScope();
        const searchRange = FindModelBoundToEditorModel._getSearchRange(this._editor.getModel(), findScope);
        // ...(----)...|...
        if (searchRange.getEndPosition().isBefore(after)) after = searchRange.getStartPosition();
        // ...|...(----)...
        if (after.isBefore(searchRange.getStartPosition())) after = searchRange.getStartPosition();
        const { lineNumber, column } = after;
        const model = this._editor.getModel();
        let position = new (0, _positionJs.Position)(lineNumber, column);
        let nextMatch = model.findNextMatch(this._state.searchString, position, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(132 /* EditorOption.wordSeparators */ ) : null, captureMatches);
        if (forceMove && nextMatch && nextMatch.range.isEmpty() && nextMatch.range.getStartPosition().equals(position)) {
            // Looks like we're stuck at this position, unacceptable!
            position = this._nextSearchPosition(position);
            nextMatch = model.findNextMatch(this._state.searchString, position, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(132 /* EditorOption.wordSeparators */ ) : null, captureMatches);
        }
        if (!nextMatch) // there is precisely one match and selection is on top of it
        return null;
        if (!isRecursed && !searchRange.containsRange(nextMatch.range)) return this._getNextMatch(nextMatch.range.getEndPosition(), captureMatches, forceMove, true);
        return nextMatch;
    }
    moveToNextMatch() {
        this._moveToNextMatch(this._editor.getSelection().getEndPosition());
    }
    _moveToMatch(index) {
        const decorationRange = this._decorations.getDecorationRangeAt(index);
        if (decorationRange) this._setCurrentFindMatch(decorationRange);
    }
    moveToMatch(index) {
        this._moveToMatch(index);
    }
    _getReplacePattern() {
        if (this._state.isRegex) return (0, _replacePatternJs.parseReplaceString)(this._state.replaceString);
        return (0, _replacePatternJs.ReplacePattern).fromStaticValue(this._state.replaceString);
    }
    replace() {
        if (!this._hasMatches()) return;
        const replacePattern = this._getReplacePattern();
        const selection = this._editor.getSelection();
        const nextMatch = this._getNextMatch(selection.getStartPosition(), true, false);
        if (nextMatch) {
            if (selection.equalsRange(nextMatch.range)) {
                // selection sits on a find match => replace it!
                const replaceString = replacePattern.buildReplaceString(nextMatch.matches, this._state.preserveCase);
                const command = new (0, _replaceCommandJs.ReplaceCommand)(selection, replaceString);
                this._executeEditorCommand("replace", command);
                this._decorations.setStartPosition(new (0, _positionJs.Position)(selection.startLineNumber, selection.startColumn + replaceString.length));
                this.research(true);
            } else {
                this._decorations.setStartPosition(this._editor.getPosition());
                this._setCurrentFindMatch(nextMatch.range);
            }
        }
    }
    _findMatches(findScopes, captureMatches, limitResultCount) {
        const searchRanges = (findScopes || [
            null
        ]).map((scope)=>FindModelBoundToEditorModel._getSearchRange(this._editor.getModel(), scope));
        return this._editor.getModel().findMatches(this._state.searchString, searchRanges, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(132 /* EditorOption.wordSeparators */ ) : null, captureMatches, limitResultCount);
    }
    replaceAll() {
        if (!this._hasMatches()) return;
        const findScopes = this._decorations.getFindScopes();
        if (findScopes === null && this._state.matchesCount >= MATCHES_LIMIT) // Doing a replace on the entire file that is over ${MATCHES_LIMIT} matches
        this._largeReplaceAll();
        else this._regularReplaceAll(findScopes);
        this.research(false);
    }
    _largeReplaceAll() {
        const searchParams = new (0, _textModelSearchJs.SearchParams)(this._state.searchString, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(132 /* EditorOption.wordSeparators */ ) : null);
        const searchData = searchParams.parseSearchRequest();
        if (!searchData) return;
        let searchRegex = searchData.regex;
        if (!searchRegex.multiline) {
            let mod = "mu";
            if (searchRegex.ignoreCase) mod += "i";
            if (searchRegex.global) mod += "g";
            searchRegex = new RegExp(searchRegex.source, mod);
        }
        const model = this._editor.getModel();
        const modelText = model.getValue(1 /* EndOfLinePreference.LF */ );
        const fullModelRange = model.getFullModelRange();
        const replacePattern = this._getReplacePattern();
        let resultText;
        const preserveCase = this._state.preserveCase;
        if (replacePattern.hasReplacementPatterns || preserveCase) resultText = modelText.replace(searchRegex, function() {
            return replacePattern.buildReplaceString(arguments, preserveCase);
        });
        else resultText = modelText.replace(searchRegex, replacePattern.buildReplaceString(null, preserveCase));
        const command = new (0, _replaceCommandJs.ReplaceCommandThatPreservesSelection)(fullModelRange, resultText, this._editor.getSelection());
        this._executeEditorCommand("replaceAll", command);
    }
    _regularReplaceAll(findScopes) {
        const replacePattern = this._getReplacePattern();
        // Get all the ranges (even more than the highlighted ones)
        const matches = this._findMatches(findScopes, replacePattern.hasReplacementPatterns || this._state.preserveCase, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ );
        const replaceStrings = [];
        for(let i = 0, len = matches.length; i < len; i++)replaceStrings[i] = replacePattern.buildReplaceString(matches[i].matches, this._state.preserveCase);
        const command = new (0, _replaceAllCommandJs.ReplaceAllCommand)(this._editor.getSelection(), matches.map((m)=>m.range), replaceStrings);
        this._executeEditorCommand("replaceAll", command);
    }
    selectAllMatches() {
        if (!this._hasMatches()) return;
        const findScopes = this._decorations.getFindScopes();
        // Get all the ranges (even more than the highlighted ones)
        const matches = this._findMatches(findScopes, false, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ );
        let selections = matches.map((m)=>new (0, _selectionJs.Selection)(m.range.startLineNumber, m.range.startColumn, m.range.endLineNumber, m.range.endColumn));
        // If one of the ranges is the editor selection, then maintain it as primary
        const editorSelection = this._editor.getSelection();
        for(let i = 0, len = selections.length; i < len; i++){
            const sel = selections[i];
            if (sel.equalsRange(editorSelection)) {
                selections = [
                    editorSelection
                ].concat(selections.slice(0, i)).concat(selections.slice(i + 1));
                break;
            }
        }
        this._editor.setSelections(selections);
    }
    _executeEditorCommand(source, command) {
        try {
            this._ignoreModelContentChanged = true;
            this._editor.pushUndoStop();
            this._editor.executeCommand(source, command);
            this._editor.pushUndoStop();
        } finally{
            this._ignoreModelContentChanged = false;
        }
    }
}

},{"../../../../base/common/arraysFind.js":"gWrU0","../../../../base/common/async.js":"4GJc4","../../../../base/common/lifecycle.js":"9kg8d","../../../common/commands/replaceCommand.js":"51hNH","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/model/textModelSearch.js":"N1WkK","./findDecorations.js":"cGVsU","./replaceAllCommand.js":"cYWW8","./replacePattern.js":"czWfg","../../../../platform/contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cGVsU":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FindDecorations", ()=>FindDecorations);
var _rangeJs = require("../../../common/core/range.js");
var _modelJs = require("../../../common/model.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
class FindDecorations {
    constructor(editor){
        this._editor = editor;
        this._decorations = [];
        this._overviewRulerApproximateDecorations = [];
        this._findScopeDecorationIds = [];
        this._rangeHighlightDecorationId = null;
        this._highlightedDecorationId = null;
        this._startPosition = this._editor.getPosition();
    }
    dispose() {
        this._editor.removeDecorations(this._allDecorations());
        this._decorations = [];
        this._overviewRulerApproximateDecorations = [];
        this._findScopeDecorationIds = [];
        this._rangeHighlightDecorationId = null;
        this._highlightedDecorationId = null;
    }
    reset() {
        this._decorations = [];
        this._overviewRulerApproximateDecorations = [];
        this._findScopeDecorationIds = [];
        this._rangeHighlightDecorationId = null;
        this._highlightedDecorationId = null;
    }
    getCount() {
        return this._decorations.length;
    }
    /** @deprecated use getFindScopes to support multiple selections */ getFindScope() {
        if (this._findScopeDecorationIds[0]) return this._editor.getModel().getDecorationRange(this._findScopeDecorationIds[0]);
        return null;
    }
    getFindScopes() {
        if (this._findScopeDecorationIds.length) {
            const scopes = this._findScopeDecorationIds.map((findScopeDecorationId)=>this._editor.getModel().getDecorationRange(findScopeDecorationId)).filter((element)=>!!element);
            if (scopes.length) return scopes;
        }
        return null;
    }
    getStartPosition() {
        return this._startPosition;
    }
    setStartPosition(newStartPosition) {
        this._startPosition = newStartPosition;
        this.setCurrentFindMatch(null);
    }
    _getDecorationIndex(decorationId) {
        const index = this._decorations.indexOf(decorationId);
        if (index >= 0) return index + 1;
        return 1;
    }
    getDecorationRangeAt(index) {
        const decorationId = index < this._decorations.length ? this._decorations[index] : null;
        if (decorationId) return this._editor.getModel().getDecorationRange(decorationId);
        return null;
    }
    getCurrentMatchesPosition(desiredRange) {
        const candidates = this._editor.getModel().getDecorationsInRange(desiredRange);
        for (const candidate of candidates){
            const candidateOpts = candidate.options;
            if (candidateOpts === FindDecorations._FIND_MATCH_DECORATION || candidateOpts === FindDecorations._CURRENT_FIND_MATCH_DECORATION) return this._getDecorationIndex(candidate.id);
        }
        // We don't know the current match position, so returns zero to show '?' in find widget
        return 0;
    }
    setCurrentFindMatch(nextMatch) {
        let newCurrentDecorationId = null;
        let matchPosition = 0;
        if (nextMatch) for(let i = 0, len = this._decorations.length; i < len; i++){
            const range = this._editor.getModel().getDecorationRange(this._decorations[i]);
            if (nextMatch.equalsRange(range)) {
                newCurrentDecorationId = this._decorations[i];
                matchPosition = i + 1;
                break;
            }
        }
        if (this._highlightedDecorationId !== null || newCurrentDecorationId !== null) this._editor.changeDecorations((changeAccessor)=>{
            if (this._highlightedDecorationId !== null) {
                changeAccessor.changeDecorationOptions(this._highlightedDecorationId, FindDecorations._FIND_MATCH_DECORATION);
                this._highlightedDecorationId = null;
            }
            if (newCurrentDecorationId !== null) {
                this._highlightedDecorationId = newCurrentDecorationId;
                changeAccessor.changeDecorationOptions(this._highlightedDecorationId, FindDecorations._CURRENT_FIND_MATCH_DECORATION);
            }
            if (this._rangeHighlightDecorationId !== null) {
                changeAccessor.removeDecoration(this._rangeHighlightDecorationId);
                this._rangeHighlightDecorationId = null;
            }
            if (newCurrentDecorationId !== null) {
                let rng = this._editor.getModel().getDecorationRange(newCurrentDecorationId);
                if (rng.startLineNumber !== rng.endLineNumber && rng.endColumn === 1) {
                    const lineBeforeEnd = rng.endLineNumber - 1;
                    const lineBeforeEndMaxColumn = this._editor.getModel().getLineMaxColumn(lineBeforeEnd);
                    rng = new (0, _rangeJs.Range)(rng.startLineNumber, rng.startColumn, lineBeforeEnd, lineBeforeEndMaxColumn);
                }
                this._rangeHighlightDecorationId = changeAccessor.addDecoration(rng, FindDecorations._RANGE_HIGHLIGHT_DECORATION);
            }
        });
        return matchPosition;
    }
    set(findMatches, findScopes) {
        this._editor.changeDecorations((accessor)=>{
            let findMatchesOptions = FindDecorations._FIND_MATCH_DECORATION;
            const newOverviewRulerApproximateDecorations = [];
            if (findMatches.length > 1000) {
                // we go into a mode where the overview ruler gets "approximate" decorations
                // the reason is that the overview ruler paints all the decorations in the file and we don't want to cause freezes
                findMatchesOptions = FindDecorations._FIND_MATCH_NO_OVERVIEW_DECORATION;
                // approximate a distance in lines where matches should be merged
                const lineCount = this._editor.getModel().getLineCount();
                const height = this._editor.getLayoutInfo().height;
                const approxPixelsPerLine = height / lineCount;
                const mergeLinesDelta = Math.max(2, Math.ceil(3 / approxPixelsPerLine));
                // merge decorations as much as possible
                let prevStartLineNumber = findMatches[0].range.startLineNumber;
                let prevEndLineNumber = findMatches[0].range.endLineNumber;
                for(let i = 1, len = findMatches.length; i < len; i++){
                    const range = findMatches[i].range;
                    if (prevEndLineNumber + mergeLinesDelta >= range.startLineNumber) {
                        if (range.endLineNumber > prevEndLineNumber) prevEndLineNumber = range.endLineNumber;
                    } else {
                        newOverviewRulerApproximateDecorations.push({
                            range: new (0, _rangeJs.Range)(prevStartLineNumber, 1, prevEndLineNumber, 1),
                            options: FindDecorations._FIND_MATCH_ONLY_OVERVIEW_DECORATION
                        });
                        prevStartLineNumber = range.startLineNumber;
                        prevEndLineNumber = range.endLineNumber;
                    }
                }
                newOverviewRulerApproximateDecorations.push({
                    range: new (0, _rangeJs.Range)(prevStartLineNumber, 1, prevEndLineNumber, 1),
                    options: FindDecorations._FIND_MATCH_ONLY_OVERVIEW_DECORATION
                });
            }
            // Find matches
            const newFindMatchesDecorations = new Array(findMatches.length);
            for(let i = 0, len = findMatches.length; i < len; i++)newFindMatchesDecorations[i] = {
                range: findMatches[i].range,
                options: findMatchesOptions
            };
            this._decorations = accessor.deltaDecorations(this._decorations, newFindMatchesDecorations);
            // Overview ruler approximate decorations
            this._overviewRulerApproximateDecorations = accessor.deltaDecorations(this._overviewRulerApproximateDecorations, newOverviewRulerApproximateDecorations);
            // Range highlight
            if (this._rangeHighlightDecorationId) {
                accessor.removeDecoration(this._rangeHighlightDecorationId);
                this._rangeHighlightDecorationId = null;
            }
            // Find scope
            if (this._findScopeDecorationIds.length) {
                this._findScopeDecorationIds.forEach((findScopeDecorationId)=>accessor.removeDecoration(findScopeDecorationId));
                this._findScopeDecorationIds = [];
            }
            if (findScopes?.length) this._findScopeDecorationIds = findScopes.map((findScope)=>accessor.addDecoration(findScope, FindDecorations._FIND_SCOPE_DECORATION));
        });
    }
    matchBeforePosition(position) {
        if (this._decorations.length === 0) return null;
        for(let i = this._decorations.length - 1; i >= 0; i--){
            const decorationId = this._decorations[i];
            const r = this._editor.getModel().getDecorationRange(decorationId);
            if (!r || r.endLineNumber > position.lineNumber) continue;
            if (r.endLineNumber < position.lineNumber) return r;
            if (r.endColumn > position.column) continue;
            return r;
        }
        return this._editor.getModel().getDecorationRange(this._decorations[this._decorations.length - 1]);
    }
    matchAfterPosition(position) {
        if (this._decorations.length === 0) return null;
        for(let i = 0, len = this._decorations.length; i < len; i++){
            const decorationId = this._decorations[i];
            const r = this._editor.getModel().getDecorationRange(decorationId);
            if (!r || r.startLineNumber < position.lineNumber) continue;
            if (r.startLineNumber > position.lineNumber) return r;
            if (r.startColumn < position.column) continue;
            return r;
        }
        return this._editor.getModel().getDecorationRange(this._decorations[0]);
    }
    _allDecorations() {
        let result = [];
        result = result.concat(this._decorations);
        result = result.concat(this._overviewRulerApproximateDecorations);
        if (this._findScopeDecorationIds.length) result.push(...this._findScopeDecorationIds);
        if (this._rangeHighlightDecorationId) result.push(this._rangeHighlightDecorationId);
        return result;
    }
    static{
        this._CURRENT_FIND_MATCH_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "current-find-match",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
            zIndex: 13,
            className: "currentFindMatch",
            inlineClassName: "currentFindMatchInline",
            showIfCollapsed: true,
            overviewRuler: {
                color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.overviewRulerFindMatchForeground)),
                position: (0, _modelJs.OverviewRulerLane).Center
            },
            minimap: {
                color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.minimapFindMatch)),
                position: 1 /* MinimapPosition.Inline */ 
            }
        });
    }
    static{
        this._FIND_MATCH_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "find-match",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
            zIndex: 10,
            className: "findMatch",
            inlineClassName: "findMatchInline",
            showIfCollapsed: true,
            overviewRuler: {
                color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.overviewRulerFindMatchForeground)),
                position: (0, _modelJs.OverviewRulerLane).Center
            },
            minimap: {
                color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.minimapFindMatch)),
                position: 1 /* MinimapPosition.Inline */ 
            }
        });
    }
    static{
        this._FIND_MATCH_NO_OVERVIEW_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "find-match-no-overview",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
            className: "findMatch",
            showIfCollapsed: true
        });
    }
    static{
        this._FIND_MATCH_ONLY_OVERVIEW_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "find-match-only-overview",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
            overviewRuler: {
                color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.overviewRulerFindMatchForeground)),
                position: (0, _modelJs.OverviewRulerLane).Center
            }
        });
    }
    static{
        this._RANGE_HIGHLIGHT_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "find-range-highlight",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
            className: "rangeHighlight",
            isWholeLine: true
        });
    }
    static{
        this._FIND_SCOPE_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "find-scope",
            className: "findScope",
            isWholeLine: true
        });
    }
}

},{"../../../common/core/range.js":"jmUPh","../../../common/model.js":"1CSIB","../../../common/model/textModel.js":"9beDe","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cYWW8":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplaceAllCommand", ()=>ReplaceAllCommand);
var _rangeJs = require("../../../common/core/range.js");
class ReplaceAllCommand {
    constructor(editorSelection, ranges, replaceStrings){
        this._editorSelection = editorSelection;
        this._ranges = ranges;
        this._replaceStrings = replaceStrings;
        this._trackedEditorSelectionId = null;
    }
    getEditOperations(model, builder) {
        if (this._ranges.length > 0) {
            // Collect all edit operations
            const ops = [];
            for(let i = 0; i < this._ranges.length; i++)ops.push({
                range: this._ranges[i],
                text: this._replaceStrings[i]
            });
            // Sort them in ascending order by range starts
            ops.sort((o1, o2)=>{
                return (0, _rangeJs.Range).compareRangesUsingStarts(o1.range, o2.range);
            });
            // Merge operations that touch each other
            const resultOps = [];
            let previousOp = ops[0];
            for(let i = 1; i < ops.length; i++)if (previousOp.range.endLineNumber === ops[i].range.startLineNumber && previousOp.range.endColumn === ops[i].range.startColumn) {
                // These operations are one after another and can be merged
                previousOp.range = previousOp.range.plusRange(ops[i].range);
                previousOp.text = previousOp.text + ops[i].text;
            } else {
                resultOps.push(previousOp);
                previousOp = ops[i];
            }
            resultOps.push(previousOp);
            for (const op of resultOps)builder.addEditOperation(op.range, op.text);
        }
        this._trackedEditorSelectionId = builder.trackSelection(this._editorSelection);
    }
    computeCursorState(model, helper) {
        return helper.getTrackedSelection(this._trackedEditorSelectionId);
    }
}

},{"../../../common/core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"czWfg":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplacePattern", ()=>ReplacePattern);
/**
 * A replace piece can either be a static string or an index to a specific match.
 */ parcelHelpers.export(exports, "ReplacePiece", ()=>ReplacePiece);
/**
 * \n			=> inserts a LF
 * \t			=> inserts a TAB
 * \\			=> inserts a "\".
 * \u			=> upper-cases one character in a match.
 * \U			=> upper-cases ALL remaining characters in a match.
 * \l			=> lower-cases one character in a match.
 * \L			=> lower-cases ALL remaining characters in a match.
 * $$			=> inserts a "$".
 * $& and $0	=> inserts the matched substring.
 * $n			=> Where n is a non-negative integer lesser than 100, inserts the nth parenthesized submatch string
 * everything else stays untouched
 *
 * Also see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#Specifying_a_string_as_a_parameter
 */ parcelHelpers.export(exports, "parseReplaceString", ()=>parseReplaceString);
var _searchJs = require("../../../../base/common/search.js");
/**
 * Assigned when the replace pattern is entirely static.
 */ class StaticValueReplacePattern {
    constructor(staticValue){
        this.staticValue = staticValue;
        this.kind = 0 /* ReplacePatternKind.StaticValue */ ;
    }
}
/**
 * Assigned when the replace pattern has replacement patterns.
 */ class DynamicPiecesReplacePattern {
    constructor(pieces){
        this.pieces = pieces;
        this.kind = 1 /* ReplacePatternKind.DynamicPieces */ ;
    }
}
class ReplacePattern {
    static fromStaticValue(value) {
        return new ReplacePattern([
            ReplacePiece.staticValue(value)
        ]);
    }
    get hasReplacementPatterns() {
        return this._state.kind === 1 /* ReplacePatternKind.DynamicPieces */ ;
    }
    constructor(pieces){
        if (!pieces || pieces.length === 0) this._state = new StaticValueReplacePattern("");
        else if (pieces.length === 1 && pieces[0].staticValue !== null) this._state = new StaticValueReplacePattern(pieces[0].staticValue);
        else this._state = new DynamicPiecesReplacePattern(pieces);
    }
    buildReplaceString(matches, preserveCase) {
        if (this._state.kind === 0 /* ReplacePatternKind.StaticValue */ ) {
            if (preserveCase) return (0, _searchJs.buildReplaceStringWithCasePreserved)(matches, this._state.staticValue);
            else return this._state.staticValue;
        }
        let result = "";
        for(let i = 0, len = this._state.pieces.length; i < len; i++){
            const piece = this._state.pieces[i];
            if (piece.staticValue !== null) {
                // static value ReplacePiece
                result += piece.staticValue;
                continue;
            }
            // match index ReplacePiece
            let match = ReplacePattern._substitute(piece.matchIndex, matches);
            if (piece.caseOps !== null && piece.caseOps.length > 0) {
                const repl = [];
                const lenOps = piece.caseOps.length;
                let opIdx = 0;
                for(let idx = 0, len = match.length; idx < len; idx++){
                    if (opIdx >= lenOps) {
                        repl.push(match.slice(idx));
                        break;
                    }
                    switch(piece.caseOps[opIdx]){
                        case "U":
                            repl.push(match[idx].toUpperCase());
                            break;
                        case "u":
                            repl.push(match[idx].toUpperCase());
                            opIdx++;
                            break;
                        case "L":
                            repl.push(match[idx].toLowerCase());
                            break;
                        case "l":
                            repl.push(match[idx].toLowerCase());
                            opIdx++;
                            break;
                        default:
                            repl.push(match[idx]);
                    }
                }
                match = repl.join("");
            }
            result += match;
        }
        return result;
    }
    static _substitute(matchIndex, matches) {
        if (matches === null) return "";
        if (matchIndex === 0) return matches[0];
        let remainder = "";
        while(matchIndex > 0){
            if (matchIndex < matches.length) {
                // A match can be undefined
                const match = matches[matchIndex] || "";
                return match + remainder;
            }
            remainder = String(matchIndex % 10) + remainder;
            matchIndex = Math.floor(matchIndex / 10);
        }
        return "$" + remainder;
    }
}
class ReplacePiece {
    static staticValue(value) {
        return new ReplacePiece(value, -1, null);
    }
    static caseOps(index, caseOps) {
        return new ReplacePiece(null, index, caseOps);
    }
    constructor(staticValue, matchIndex, caseOps){
        this.staticValue = staticValue;
        this.matchIndex = matchIndex;
        if (!caseOps || caseOps.length === 0) this.caseOps = null;
        else this.caseOps = caseOps.slice(0);
    }
}
class ReplacePieceBuilder {
    constructor(source){
        this._source = source;
        this._lastCharIndex = 0;
        this._result = [];
        this._resultLen = 0;
        this._currentStaticPiece = "";
    }
    emitUnchanged(toCharIndex) {
        this._emitStatic(this._source.substring(this._lastCharIndex, toCharIndex));
        this._lastCharIndex = toCharIndex;
    }
    emitStatic(value, toCharIndex) {
        this._emitStatic(value);
        this._lastCharIndex = toCharIndex;
    }
    _emitStatic(value) {
        if (value.length === 0) return;
        this._currentStaticPiece += value;
    }
    emitMatchIndex(index, toCharIndex, caseOps) {
        if (this._currentStaticPiece.length !== 0) {
            this._result[this._resultLen++] = ReplacePiece.staticValue(this._currentStaticPiece);
            this._currentStaticPiece = "";
        }
        this._result[this._resultLen++] = ReplacePiece.caseOps(index, caseOps);
        this._lastCharIndex = toCharIndex;
    }
    finalize() {
        this.emitUnchanged(this._source.length);
        if (this._currentStaticPiece.length !== 0) {
            this._result[this._resultLen++] = ReplacePiece.staticValue(this._currentStaticPiece);
            this._currentStaticPiece = "";
        }
        return new ReplacePattern(this._result);
    }
}
function parseReplaceString(replaceString) {
    if (!replaceString || replaceString.length === 0) return new ReplacePattern(null);
    const caseOps = [];
    const result = new ReplacePieceBuilder(replaceString);
    for(let i = 0, len = replaceString.length; i < len; i++){
        const chCode = replaceString.charCodeAt(i);
        if (chCode === 92 /* CharCode.Backslash */ ) {
            // move to next char
            i++;
            if (i >= len) break;
            const nextChCode = replaceString.charCodeAt(i);
            // let replaceWithCharacter: string | null = null;
            switch(nextChCode){
                case 92 /* CharCode.Backslash */ :
                    // \\ => inserts a "\"
                    result.emitUnchanged(i - 1);
                    result.emitStatic("\\", i + 1);
                    break;
                case 110 /* CharCode.n */ :
                    // \n => inserts a LF
                    result.emitUnchanged(i - 1);
                    result.emitStatic("\n", i + 1);
                    break;
                case 116 /* CharCode.t */ :
                    // \t => inserts a TAB
                    result.emitUnchanged(i - 1);
                    result.emitStatic("	", i + 1);
                    break;
                // Case modification of string replacements, patterned after Boost, but only applied
                // to the replacement text, not subsequent content.
                case 117 /* CharCode.u */ :
                // \u => upper-cases one character.
                case 85 /* CharCode.U */ :
                // \U => upper-cases ALL following characters.
                case 108 /* CharCode.l */ :
                // \l => lower-cases one character.
                case 76 /* CharCode.L */ :
                    // \L => lower-cases ALL following characters.
                    result.emitUnchanged(i - 1);
                    result.emitStatic("", i + 1);
                    caseOps.push(String.fromCharCode(nextChCode));
                    break;
            }
            continue;
        }
        if (chCode === 36 /* CharCode.DollarSign */ ) {
            // move to next char
            i++;
            if (i >= len) break;
            const nextChCode = replaceString.charCodeAt(i);
            if (nextChCode === 36 /* CharCode.DollarSign */ ) {
                // $$ => inserts a "$"
                result.emitUnchanged(i - 1);
                result.emitStatic("$", i + 1);
                continue;
            }
            if (nextChCode === 48 /* CharCode.Digit0 */  || nextChCode === 38 /* CharCode.Ampersand */ ) {
                // $& and $0 => inserts the matched substring.
                result.emitUnchanged(i - 1);
                result.emitMatchIndex(0, i + 1, caseOps);
                caseOps.length = 0;
                continue;
            }
            if (49 /* CharCode.Digit1 */  <= nextChCode && nextChCode <= 57 /* CharCode.Digit9 */ ) {
                // $n
                let matchIndex = nextChCode - 48 /* CharCode.Digit0 */ ;
                // peek next char to probe for $nn
                if (i + 1 < len) {
                    const nextNextChCode = replaceString.charCodeAt(i + 1);
                    if (48 /* CharCode.Digit0 */  <= nextNextChCode && nextNextChCode <= 57 /* CharCode.Digit9 */ ) {
                        // $nn
                        // move to next char
                        i++;
                        matchIndex = matchIndex * 10 + (nextNextChCode - 48 /* CharCode.Digit0 */ );
                        result.emitUnchanged(i - 2);
                        result.emitMatchIndex(matchIndex, i + 1, caseOps);
                        caseOps.length = 0;
                        continue;
                    }
                }
                result.emitUnchanged(i - 1);
                result.emitMatchIndex(matchIndex, i + 1, caseOps);
                caseOps.length = 0;
                continue;
            }
        }
    }
    return result.finalize();
}

},{"../../../../base/common/search.js":"irr2P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"irr2P":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildReplaceStringWithCasePreserved", ()=>buildReplaceStringWithCasePreserved);
var _stringsJs = require("./strings.js");
function buildReplaceStringWithCasePreserved(matches, pattern) {
    if (matches && matches[0] !== "") {
        const containsHyphens = validateSpecificSpecialCharacter(matches, pattern, "-");
        const containsUnderscores = validateSpecificSpecialCharacter(matches, pattern, "_");
        if (containsHyphens && !containsUnderscores) return buildReplaceStringForSpecificSpecialCharacter(matches, pattern, "-");
        else if (!containsHyphens && containsUnderscores) return buildReplaceStringForSpecificSpecialCharacter(matches, pattern, "_");
        if (matches[0].toUpperCase() === matches[0]) return pattern.toUpperCase();
        else if (matches[0].toLowerCase() === matches[0]) return pattern.toLowerCase();
        else if (_stringsJs.containsUppercaseCharacter(matches[0][0]) && pattern.length > 0) return pattern[0].toUpperCase() + pattern.substr(1);
        else if (matches[0][0].toUpperCase() !== matches[0][0] && pattern.length > 0) return pattern[0].toLowerCase() + pattern.substr(1);
        else // we don't understand its pattern yet.
        return pattern;
    } else return pattern;
}
function validateSpecificSpecialCharacter(matches, pattern, specialCharacter) {
    const doesContainSpecialCharacter = matches[0].indexOf(specialCharacter) !== -1 && pattern.indexOf(specialCharacter) !== -1;
    return doesContainSpecialCharacter && matches[0].split(specialCharacter).length === pattern.split(specialCharacter).length;
}
function buildReplaceStringForSpecificSpecialCharacter(matches, pattern, specialCharacter) {
    const splitPatternAtSpecialCharacter = pattern.split(specialCharacter);
    const splitMatchAtSpecialCharacter = matches[0].split(specialCharacter);
    let replaceString = "";
    splitPatternAtSpecialCharacter.forEach((splitValue, index)=>{
        replaceString += buildReplaceStringWithCasePreserved([
            splitMatchAtSpecialCharacter[index]
        ], splitValue) + specialCharacter;
    });
    return replaceString.slice(0, -1);
}

},{"./strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aT9UY":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FindOptionsWidget", ()=>FindOptionsWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _findOptionsWidgetCss = require("./findOptionsWidget.css");
var _findInputTogglesJs = require("../../../../base/browser/ui/findinput/findInputToggles.js");
var _widgetJs = require("../../../../base/browser/ui/widget.js");
var _asyncJs = require("../../../../base/common/async.js");
var _findModelJs = require("./findModel.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _hoverDelegateFactoryJs = require("../../../../base/browser/ui/hover/hoverDelegateFactory.js");
class FindOptionsWidget extends (0, _widgetJs.Widget) {
    static{
        this.ID = "editor.contrib.findOptionsWidget";
    }
    constructor(editor, state, keybindingService){
        super();
        this._hideSoon = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._hide(), 2000));
        this._isVisible = false;
        this._editor = editor;
        this._state = state;
        this._keybindingService = keybindingService;
        this._domNode = document.createElement("div");
        this._domNode.className = "findOptionsWidget";
        this._domNode.style.display = "none";
        this._domNode.style.top = "10px";
        this._domNode.style.zIndex = "12";
        this._domNode.setAttribute("role", "presentation");
        this._domNode.setAttribute("aria-hidden", "true");
        const toggleStyles = {
            inputActiveOptionBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputActiveOptionBorder)),
            inputActiveOptionForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputActiveOptionForeground)),
            inputActiveOptionBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputActiveOptionBackground))
        };
        const hoverDelegate = this._register((0, _hoverDelegateFactoryJs.createInstantHoverDelegate)());
        this.caseSensitive = this._register(new (0, _findInputTogglesJs.CaseSensitiveToggle)({
            appendTitle: this._keybindingLabelFor((0, _findModelJs.FIND_IDS).ToggleCaseSensitiveCommand),
            isChecked: this._state.matchCase,
            hoverDelegate,
            ...toggleStyles
        }));
        this._domNode.appendChild(this.caseSensitive.domNode);
        this._register(this.caseSensitive.onChange(()=>{
            this._state.change({
                matchCase: this.caseSensitive.checked
            }, false);
        }));
        this.wholeWords = this._register(new (0, _findInputTogglesJs.WholeWordsToggle)({
            appendTitle: this._keybindingLabelFor((0, _findModelJs.FIND_IDS).ToggleWholeWordCommand),
            isChecked: this._state.wholeWord,
            hoverDelegate,
            ...toggleStyles
        }));
        this._domNode.appendChild(this.wholeWords.domNode);
        this._register(this.wholeWords.onChange(()=>{
            this._state.change({
                wholeWord: this.wholeWords.checked
            }, false);
        }));
        this.regex = this._register(new (0, _findInputTogglesJs.RegexToggle)({
            appendTitle: this._keybindingLabelFor((0, _findModelJs.FIND_IDS).ToggleRegexCommand),
            isChecked: this._state.isRegex,
            hoverDelegate,
            ...toggleStyles
        }));
        this._domNode.appendChild(this.regex.domNode);
        this._register(this.regex.onChange(()=>{
            this._state.change({
                isRegex: this.regex.checked
            }, false);
        }));
        this._editor.addOverlayWidget(this);
        this._register(this._state.onFindReplaceStateChange((e)=>{
            let somethingChanged = false;
            if (e.isRegex) {
                this.regex.checked = this._state.isRegex;
                somethingChanged = true;
            }
            if (e.wholeWord) {
                this.wholeWords.checked = this._state.wholeWord;
                somethingChanged = true;
            }
            if (e.matchCase) {
                this.caseSensitive.checked = this._state.matchCase;
                somethingChanged = true;
            }
            if (!this._state.isRevealed && somethingChanged) this._revealTemporarily();
        }));
        this._register(_domJs.addDisposableListener(this._domNode, _domJs.EventType.MOUSE_LEAVE, (e)=>this._onMouseLeave()));
        this._register(_domJs.addDisposableListener(this._domNode, "mouseover", (e)=>this._onMouseOver()));
    }
    _keybindingLabelFor(actionId) {
        const kb = this._keybindingService.lookupKeybinding(actionId);
        if (!kb) return "";
        return ` (${kb.getLabel()})`;
    }
    dispose() {
        this._editor.removeOverlayWidget(this);
        super.dispose();
    }
    // ----- IOverlayWidget API
    getId() {
        return FindOptionsWidget.ID;
    }
    getDomNode() {
        return this._domNode;
    }
    getPosition() {
        return {
            preference: 0 /* OverlayWidgetPositionPreference.TOP_RIGHT_CORNER */ 
        };
    }
    highlightFindOptions() {
        this._revealTemporarily();
    }
    _revealTemporarily() {
        this._show();
        this._hideSoon.schedule();
    }
    _onMouseLeave() {
        this._hideSoon.schedule();
    }
    _onMouseOver() {
        this._hideSoon.cancel();
    }
    _show() {
        if (this._isVisible) return;
        this._isVisible = true;
        this._domNode.style.display = "block";
    }
    _hide() {
        if (!this._isVisible) return;
        this._isVisible = false;
        this._domNode.style.display = "none";
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","./findOptionsWidget.css":"3VIdm","../../../../base/browser/ui/findinput/findInputToggles.js":"h4mwj","../../../../base/browser/ui/widget.js":"kM4DP","../../../../base/common/async.js":"4GJc4","./findModel.js":"8SA2y","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../base/browser/ui/hover/hoverDelegateFactory.js":"kll4h","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3VIdm":[function() {},{}],"khiKH":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FindReplaceState", ()=>FindReplaceState);
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _rangeJs = require("../../../common/core/range.js");
var _findModelJs = require("./findModel.js");
function effectiveOptionValue(override, value) {
    if (override === 1 /* FindOptionOverride.True */ ) return true;
    if (override === 2 /* FindOptionOverride.False */ ) return false;
    return value;
}
class FindReplaceState extends (0, _lifecycleJs.Disposable) {
    get searchString() {
        return this._searchString;
    }
    get replaceString() {
        return this._replaceString;
    }
    get isRevealed() {
        return this._isRevealed;
    }
    get isReplaceRevealed() {
        return this._isReplaceRevealed;
    }
    get isRegex() {
        return effectiveOptionValue(this._isRegexOverride, this._isRegex);
    }
    get wholeWord() {
        return effectiveOptionValue(this._wholeWordOverride, this._wholeWord);
    }
    get matchCase() {
        return effectiveOptionValue(this._matchCaseOverride, this._matchCase);
    }
    get preserveCase() {
        return effectiveOptionValue(this._preserveCaseOverride, this._preserveCase);
    }
    get actualIsRegex() {
        return this._isRegex;
    }
    get actualWholeWord() {
        return this._wholeWord;
    }
    get actualMatchCase() {
        return this._matchCase;
    }
    get actualPreserveCase() {
        return this._preserveCase;
    }
    get searchScope() {
        return this._searchScope;
    }
    get matchesPosition() {
        return this._matchesPosition;
    }
    get matchesCount() {
        return this._matchesCount;
    }
    get currentMatch() {
        return this._currentMatch;
    }
    constructor(){
        super();
        this._onFindReplaceStateChange = this._register(new (0, _eventJs.Emitter)());
        this.onFindReplaceStateChange = this._onFindReplaceStateChange.event;
        this._searchString = "";
        this._replaceString = "";
        this._isRevealed = false;
        this._isReplaceRevealed = false;
        this._isRegex = false;
        this._isRegexOverride = 0 /* FindOptionOverride.NotSet */ ;
        this._wholeWord = false;
        this._wholeWordOverride = 0 /* FindOptionOverride.NotSet */ ;
        this._matchCase = false;
        this._matchCaseOverride = 0 /* FindOptionOverride.NotSet */ ;
        this._preserveCase = false;
        this._preserveCaseOverride = 0 /* FindOptionOverride.NotSet */ ;
        this._searchScope = null;
        this._matchesPosition = 0;
        this._matchesCount = 0;
        this._currentMatch = null;
        this._loop = true;
        this._isSearching = false;
        this._filters = null;
    }
    changeMatchInfo(matchesPosition, matchesCount, currentMatch) {
        const changeEvent = {
            moveCursor: false,
            updateHistory: false,
            searchString: false,
            replaceString: false,
            isRevealed: false,
            isReplaceRevealed: false,
            isRegex: false,
            wholeWord: false,
            matchCase: false,
            preserveCase: false,
            searchScope: false,
            matchesPosition: false,
            matchesCount: false,
            currentMatch: false,
            loop: false,
            isSearching: false,
            filters: false
        };
        let somethingChanged = false;
        if (matchesCount === 0) matchesPosition = 0;
        if (matchesPosition > matchesCount) matchesPosition = matchesCount;
        if (this._matchesPosition !== matchesPosition) {
            this._matchesPosition = matchesPosition;
            changeEvent.matchesPosition = true;
            somethingChanged = true;
        }
        if (this._matchesCount !== matchesCount) {
            this._matchesCount = matchesCount;
            changeEvent.matchesCount = true;
            somethingChanged = true;
        }
        if (typeof currentMatch !== "undefined") {
            if (!(0, _rangeJs.Range).equalsRange(this._currentMatch, currentMatch)) {
                this._currentMatch = currentMatch;
                changeEvent.currentMatch = true;
                somethingChanged = true;
            }
        }
        if (somethingChanged) this._onFindReplaceStateChange.fire(changeEvent);
    }
    change(newState, moveCursor, updateHistory = true) {
        const changeEvent = {
            moveCursor: moveCursor,
            updateHistory: updateHistory,
            searchString: false,
            replaceString: false,
            isRevealed: false,
            isReplaceRevealed: false,
            isRegex: false,
            wholeWord: false,
            matchCase: false,
            preserveCase: false,
            searchScope: false,
            matchesPosition: false,
            matchesCount: false,
            currentMatch: false,
            loop: false,
            isSearching: false,
            filters: false
        };
        let somethingChanged = false;
        const oldEffectiveIsRegex = this.isRegex;
        const oldEffectiveWholeWords = this.wholeWord;
        const oldEffectiveMatchCase = this.matchCase;
        const oldEffectivePreserveCase = this.preserveCase;
        if (typeof newState.searchString !== "undefined") {
            if (this._searchString !== newState.searchString) {
                this._searchString = newState.searchString;
                changeEvent.searchString = true;
                somethingChanged = true;
            }
        }
        if (typeof newState.replaceString !== "undefined") {
            if (this._replaceString !== newState.replaceString) {
                this._replaceString = newState.replaceString;
                changeEvent.replaceString = true;
                somethingChanged = true;
            }
        }
        if (typeof newState.isRevealed !== "undefined") {
            if (this._isRevealed !== newState.isRevealed) {
                this._isRevealed = newState.isRevealed;
                changeEvent.isRevealed = true;
                somethingChanged = true;
            }
        }
        if (typeof newState.isReplaceRevealed !== "undefined") {
            if (this._isReplaceRevealed !== newState.isReplaceRevealed) {
                this._isReplaceRevealed = newState.isReplaceRevealed;
                changeEvent.isReplaceRevealed = true;
                somethingChanged = true;
            }
        }
        if (typeof newState.isRegex !== "undefined") this._isRegex = newState.isRegex;
        if (typeof newState.wholeWord !== "undefined") this._wholeWord = newState.wholeWord;
        if (typeof newState.matchCase !== "undefined") this._matchCase = newState.matchCase;
        if (typeof newState.preserveCase !== "undefined") this._preserveCase = newState.preserveCase;
        if (typeof newState.searchScope !== "undefined") {
            if (!newState.searchScope?.every((newSearchScope)=>{
                return this._searchScope?.some((existingSearchScope)=>{
                    return !(0, _rangeJs.Range).equalsRange(existingSearchScope, newSearchScope);
                });
            })) {
                this._searchScope = newState.searchScope;
                changeEvent.searchScope = true;
                somethingChanged = true;
            }
        }
        if (typeof newState.loop !== "undefined") {
            if (this._loop !== newState.loop) {
                this._loop = newState.loop;
                changeEvent.loop = true;
                somethingChanged = true;
            }
        }
        if (typeof newState.isSearching !== "undefined") {
            if (this._isSearching !== newState.isSearching) {
                this._isSearching = newState.isSearching;
                changeEvent.isSearching = true;
                somethingChanged = true;
            }
        }
        if (typeof newState.filters !== "undefined") {
            if (this._filters) this._filters.update(newState.filters);
            else this._filters = newState.filters;
            changeEvent.filters = true;
            somethingChanged = true;
        }
        // Overrides get set when they explicitly come in and get reset anytime something else changes
        this._isRegexOverride = typeof newState.isRegexOverride !== "undefined" ? newState.isRegexOverride : 0 /* FindOptionOverride.NotSet */ ;
        this._wholeWordOverride = typeof newState.wholeWordOverride !== "undefined" ? newState.wholeWordOverride : 0 /* FindOptionOverride.NotSet */ ;
        this._matchCaseOverride = typeof newState.matchCaseOverride !== "undefined" ? newState.matchCaseOverride : 0 /* FindOptionOverride.NotSet */ ;
        this._preserveCaseOverride = typeof newState.preserveCaseOverride !== "undefined" ? newState.preserveCaseOverride : 0 /* FindOptionOverride.NotSet */ ;
        if (oldEffectiveIsRegex !== this.isRegex) {
            somethingChanged = true;
            changeEvent.isRegex = true;
        }
        if (oldEffectiveWholeWords !== this.wholeWord) {
            somethingChanged = true;
            changeEvent.wholeWord = true;
        }
        if (oldEffectiveMatchCase !== this.matchCase) {
            somethingChanged = true;
            changeEvent.matchCase = true;
        }
        if (oldEffectivePreserveCase !== this.preserveCase) {
            somethingChanged = true;
            changeEvent.preserveCase = true;
        }
        if (somethingChanged) this._onFindReplaceStateChange.fire(changeEvent);
    }
    canNavigateBack() {
        return this.canNavigateInLoop() || this.matchesPosition !== 1;
    }
    canNavigateForward() {
        return this.canNavigateInLoop() || this.matchesPosition < this.matchesCount;
    }
    canNavigateInLoop() {
        return this._loop || this.matchesCount >= (0, _findModelJs.MATCHES_LIMIT);
    }
}

},{"../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../common/core/range.js":"jmUPh","./findModel.js":"8SA2y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bXBKv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findSelectionIcon", ()=>findSelectionIcon);
parcelHelpers.export(exports, "findReplaceIcon", ()=>findReplaceIcon);
parcelHelpers.export(exports, "findReplaceAllIcon", ()=>findReplaceAllIcon);
parcelHelpers.export(exports, "findPreviousMatchIcon", ()=>findPreviousMatchIcon);
parcelHelpers.export(exports, "findNextMatchIcon", ()=>findNextMatchIcon);
parcelHelpers.export(exports, "NLS_MATCHES_LOCATION", ()=>NLS_MATCHES_LOCATION);
parcelHelpers.export(exports, "NLS_NO_RESULTS", ()=>NLS_NO_RESULTS);
parcelHelpers.export(exports, "FindWidgetViewZone", ()=>FindWidgetViewZone);
parcelHelpers.export(exports, "FindWidget", ()=>FindWidget);
parcelHelpers.export(exports, "SimpleButton", ()=>SimpleButton);
var _domJs = require("../../../../base/browser/dom.js");
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var _toggleJs = require("../../../../base/browser/ui/toggle/toggle.js");
var _sashJs = require("../../../../base/browser/ui/sash/sash.js");
var _widgetJs = require("../../../../base/browser/ui/widget.js");
var _asyncJs = require("../../../../base/common/async.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _platformJs = require("../../../../base/common/platform.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _findWidgetCss = require("./findWidget.css");
var _rangeJs = require("../../../common/core/range.js");
var _findModelJs = require("./findModel.js");
var _nlsJs = require("../../../../nls.js");
var _contextScopedHistoryWidgetJs = require("../../../../platform/history/browser/contextScopedHistoryWidget.js");
var _historyWidgetKeybindingHintJs = require("../../../../platform/history/browser/historyWidgetKeybindingHint.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _iconRegistryJs = require("../../../../platform/theme/common/iconRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _themablesJs = require("../../../../base/common/themables.js");
var _themeJs = require("../../../../platform/theme/common/theme.js");
var _typesJs = require("../../../../base/common/types.js");
var _defaultStylesJs = require("../../../../platform/theme/browser/defaultStyles.js");
var _hoverDelegateFactoryJs = require("../../../../base/browser/ui/hover/hoverDelegateFactory.js");
const findCollapsedIcon = (0, _iconRegistryJs.registerIcon)("find-collapsed", (0, _codiconsJs.Codicon).chevronRight, _nlsJs.localize("findCollapsedIcon", "Icon to indicate that the editor find widget is collapsed."));
const findExpandedIcon = (0, _iconRegistryJs.registerIcon)("find-expanded", (0, _codiconsJs.Codicon).chevronDown, _nlsJs.localize("findExpandedIcon", "Icon to indicate that the editor find widget is expanded."));
const findSelectionIcon = (0, _iconRegistryJs.registerIcon)("find-selection", (0, _codiconsJs.Codicon).selection, _nlsJs.localize("findSelectionIcon", "Icon for 'Find in Selection' in the editor find widget."));
const findReplaceIcon = (0, _iconRegistryJs.registerIcon)("find-replace", (0, _codiconsJs.Codicon).replace, _nlsJs.localize("findReplaceIcon", "Icon for 'Replace' in the editor find widget."));
const findReplaceAllIcon = (0, _iconRegistryJs.registerIcon)("find-replace-all", (0, _codiconsJs.Codicon).replaceAll, _nlsJs.localize("findReplaceAllIcon", "Icon for 'Replace All' in the editor find widget."));
const findPreviousMatchIcon = (0, _iconRegistryJs.registerIcon)("find-previous-match", (0, _codiconsJs.Codicon).arrowUp, _nlsJs.localize("findPreviousMatchIcon", "Icon for 'Find Previous' in the editor find widget."));
const findNextMatchIcon = (0, _iconRegistryJs.registerIcon)("find-next-match", (0, _codiconsJs.Codicon).arrowDown, _nlsJs.localize("findNextMatchIcon", "Icon for 'Find Next' in the editor find widget."));
const NLS_FIND_DIALOG_LABEL = _nlsJs.localize("label.findDialog", "Find / Replace");
const NLS_FIND_INPUT_LABEL = _nlsJs.localize("label.find", "Find");
const NLS_FIND_INPUT_PLACEHOLDER = _nlsJs.localize("placeholder.find", "Find");
const NLS_PREVIOUS_MATCH_BTN_LABEL = _nlsJs.localize("label.previousMatchButton", "Previous Match");
const NLS_NEXT_MATCH_BTN_LABEL = _nlsJs.localize("label.nextMatchButton", "Next Match");
const NLS_TOGGLE_SELECTION_FIND_TITLE = _nlsJs.localize("label.toggleSelectionFind", "Find in Selection");
const NLS_CLOSE_BTN_LABEL = _nlsJs.localize("label.closeButton", "Close");
const NLS_REPLACE_INPUT_LABEL = _nlsJs.localize("label.replace", "Replace");
const NLS_REPLACE_INPUT_PLACEHOLDER = _nlsJs.localize("placeholder.replace", "Replace");
const NLS_REPLACE_BTN_LABEL = _nlsJs.localize("label.replaceButton", "Replace");
const NLS_REPLACE_ALL_BTN_LABEL = _nlsJs.localize("label.replaceAllButton", "Replace All");
const NLS_TOGGLE_REPLACE_MODE_BTN_LABEL = _nlsJs.localize("label.toggleReplaceButton", "Toggle Replace");
const NLS_MATCHES_COUNT_LIMIT_TITLE = _nlsJs.localize("title.matchesCountLimit", "Only the first {0} results are highlighted, but all find operations work on the entire text.", (0, _findModelJs.MATCHES_LIMIT));
const NLS_MATCHES_LOCATION = _nlsJs.localize("label.matchesLocation", "{0} of {1}");
const NLS_NO_RESULTS = _nlsJs.localize("label.noResults", "No results");
const FIND_WIDGET_INITIAL_WIDTH = 419;
const PART_WIDTH = 275;
const FIND_INPUT_AREA_WIDTH = PART_WIDTH - 54;
let MAX_MATCHES_COUNT_WIDTH = 69;
// let FIND_ALL_CONTROLS_WIDTH = 17/** Find Input margin-left */ + (MAX_MATCHES_COUNT_WIDTH + 3 + 1) /** Match Results */ + 23 /** Button */ * 4 + 2/** sash */;
const FIND_INPUT_AREA_HEIGHT = 33; // The height of Find Widget when Replace Input is not visible.
const ctrlEnterReplaceAllWarningPromptedKey = "ctrlEnterReplaceAll.windows.donotask";
const ctrlKeyMod = _platformJs.isMacintosh ? 256 /* KeyMod.WinCtrl */  : 2048 /* KeyMod.CtrlCmd */ ;
class FindWidgetViewZone {
    constructor(afterLineNumber){
        this.afterLineNumber = afterLineNumber;
        this.heightInPx = FIND_INPUT_AREA_HEIGHT;
        this.suppressMouseDown = false;
        this.domNode = document.createElement("div");
        this.domNode.className = "dock-find-viewzone";
    }
}
function stopPropagationForMultiLineUpwards(event, value, textarea) {
    const isMultiline = !!value.match(/\n/);
    if (textarea && isMultiline && textarea.selectionStart > 0) {
        event.stopPropagation();
        return;
    }
}
function stopPropagationForMultiLineDownwards(event, value, textarea) {
    const isMultiline = !!value.match(/\n/);
    if (textarea && isMultiline && textarea.selectionEnd < textarea.value.length) {
        event.stopPropagation();
        return;
    }
}
class FindWidget extends (0, _widgetJs.Widget) {
    static{
        this.ID = "editor.contrib.findWidget";
    }
    constructor(codeEditor, controller, state, contextViewProvider, keybindingService, contextKeyService, themeService, storageService, notificationService, _hoverService){
        super();
        this._hoverService = _hoverService;
        this._cachedHeight = null;
        this._revealTimeouts = [];
        this._codeEditor = codeEditor;
        this._controller = controller;
        this._state = state;
        this._contextViewProvider = contextViewProvider;
        this._keybindingService = keybindingService;
        this._contextKeyService = contextKeyService;
        this._storageService = storageService;
        this._notificationService = notificationService;
        this._ctrlEnterReplaceAllWarningPrompted = !!storageService.getBoolean(ctrlEnterReplaceAllWarningPromptedKey, 0 /* StorageScope.PROFILE */ );
        this._isVisible = false;
        this._isReplaceVisible = false;
        this._ignoreChangeEvent = false;
        this._updateHistoryDelayer = new (0, _asyncJs.Delayer)(500);
        this._register((0, _lifecycleJs.toDisposable)(()=>this._updateHistoryDelayer.cancel()));
        this._register(this._state.onFindReplaceStateChange((e)=>this._onStateChanged(e)));
        this._buildDomNode();
        this._updateButtons();
        this._tryUpdateWidgetWidth();
        this._findInput.inputBox.layout();
        this._register(this._codeEditor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(92 /* EditorOption.readOnly */ )) {
                if (this._codeEditor.getOption(92 /* EditorOption.readOnly */ )) // Hide replace part if editor becomes read only
                this._state.change({
                    isReplaceRevealed: false
                }, false);
                this._updateButtons();
            }
            if (e.hasChanged(146 /* EditorOption.layoutInfo */ )) this._tryUpdateWidgetWidth();
            if (e.hasChanged(2 /* EditorOption.accessibilitySupport */ )) this.updateAccessibilitySupport();
            if (e.hasChanged(41 /* EditorOption.find */ )) {
                const supportLoop = this._codeEditor.getOption(41 /* EditorOption.find */ ).loop;
                this._state.change({
                    loop: supportLoop
                }, false);
                const addExtraSpaceOnTop = this._codeEditor.getOption(41 /* EditorOption.find */ ).addExtraSpaceOnTop;
                if (addExtraSpaceOnTop && !this._viewZone) {
                    this._viewZone = new FindWidgetViewZone(0);
                    this._showViewZone();
                }
                if (!addExtraSpaceOnTop && this._viewZone) this._removeViewZone();
            }
        }));
        this.updateAccessibilitySupport();
        this._register(this._codeEditor.onDidChangeCursorSelection(()=>{
            if (this._isVisible) this._updateToggleSelectionFindButton();
        }));
        this._register(this._codeEditor.onDidFocusEditorWidget(async ()=>{
            if (this._isVisible) {
                const globalBufferTerm = await this._controller.getGlobalBufferTerm();
                if (globalBufferTerm && globalBufferTerm !== this._state.searchString) {
                    this._state.change({
                        searchString: globalBufferTerm
                    }, false);
                    this._findInput.select();
                }
            }
        }));
        this._findInputFocused = (0, _findModelJs.CONTEXT_FIND_INPUT_FOCUSED).bindTo(contextKeyService);
        this._findFocusTracker = this._register(_domJs.trackFocus(this._findInput.inputBox.inputElement));
        this._register(this._findFocusTracker.onDidFocus(()=>{
            this._findInputFocused.set(true);
            this._updateSearchScope();
        }));
        this._register(this._findFocusTracker.onDidBlur(()=>{
            this._findInputFocused.set(false);
        }));
        this._replaceInputFocused = (0, _findModelJs.CONTEXT_REPLACE_INPUT_FOCUSED).bindTo(contextKeyService);
        this._replaceFocusTracker = this._register(_domJs.trackFocus(this._replaceInput.inputBox.inputElement));
        this._register(this._replaceFocusTracker.onDidFocus(()=>{
            this._replaceInputFocused.set(true);
            this._updateSearchScope();
        }));
        this._register(this._replaceFocusTracker.onDidBlur(()=>{
            this._replaceInputFocused.set(false);
        }));
        this._codeEditor.addOverlayWidget(this);
        if (this._codeEditor.getOption(41 /* EditorOption.find */ ).addExtraSpaceOnTop) this._viewZone = new FindWidgetViewZone(0); // Put it before the first line then users can scroll beyond the first line.
        this._register(this._codeEditor.onDidChangeModel(()=>{
            if (!this._isVisible) return;
            this._viewZoneId = undefined;
        }));
        this._register(this._codeEditor.onDidScrollChange((e)=>{
            if (e.scrollTopChanged) {
                this._layoutViewZone();
                return;
            }
            // for other scroll changes, layout the viewzone in next tick to avoid ruining current rendering.
            setTimeout(()=>{
                this._layoutViewZone();
            }, 0);
        }));
    }
    // ----- IOverlayWidget API
    getId() {
        return FindWidget.ID;
    }
    getDomNode() {
        return this._domNode;
    }
    getPosition() {
        if (this._isVisible) return {
            preference: 0 /* OverlayWidgetPositionPreference.TOP_RIGHT_CORNER */ 
        };
        return null;
    }
    // ----- React to state changes
    _onStateChanged(e) {
        if (e.searchString) {
            try {
                this._ignoreChangeEvent = true;
                this._findInput.setValue(this._state.searchString);
            } finally{
                this._ignoreChangeEvent = false;
            }
            this._updateButtons();
        }
        if (e.replaceString) this._replaceInput.inputBox.value = this._state.replaceString;
        if (e.isRevealed) {
            if (this._state.isRevealed) this._reveal();
            else this._hide(true);
        }
        if (e.isReplaceRevealed) {
            if (this._state.isReplaceRevealed) {
                if (!this._codeEditor.getOption(92 /* EditorOption.readOnly */ ) && !this._isReplaceVisible) {
                    this._isReplaceVisible = true;
                    this._replaceInput.width = _domJs.getTotalWidth(this._findInput.domNode);
                    this._updateButtons();
                    this._replaceInput.inputBox.layout();
                }
            } else if (this._isReplaceVisible) {
                this._isReplaceVisible = false;
                this._updateButtons();
            }
        }
        if ((e.isRevealed || e.isReplaceRevealed) && (this._state.isRevealed || this._state.isReplaceRevealed)) {
            if (this._tryUpdateHeight()) this._showViewZone();
        }
        if (e.isRegex) this._findInput.setRegex(this._state.isRegex);
        if (e.wholeWord) this._findInput.setWholeWords(this._state.wholeWord);
        if (e.matchCase) this._findInput.setCaseSensitive(this._state.matchCase);
        if (e.preserveCase) this._replaceInput.setPreserveCase(this._state.preserveCase);
        if (e.searchScope) {
            if (this._state.searchScope) this._toggleSelectionFind.checked = true;
            else this._toggleSelectionFind.checked = false;
            this._updateToggleSelectionFindButton();
        }
        if (e.searchString || e.matchesCount || e.matchesPosition) {
            const showRedOutline = this._state.searchString.length > 0 && this._state.matchesCount === 0;
            this._domNode.classList.toggle("no-results", showRedOutline);
            this._updateMatchesCount();
            this._updateButtons();
        }
        if (e.searchString || e.currentMatch) this._layoutViewZone();
        if (e.updateHistory) this._delayedUpdateHistory();
        if (e.loop) this._updateButtons();
    }
    _delayedUpdateHistory() {
        this._updateHistoryDelayer.trigger(this._updateHistory.bind(this)).then(undefined, (0, _errorsJs.onUnexpectedError));
    }
    _updateHistory() {
        if (this._state.searchString) this._findInput.inputBox.addToHistory();
        if (this._state.replaceString) this._replaceInput.inputBox.addToHistory();
    }
    _updateMatchesCount() {
        this._matchesCount.style.minWidth = MAX_MATCHES_COUNT_WIDTH + "px";
        if (this._state.matchesCount >= (0, _findModelJs.MATCHES_LIMIT)) this._matchesCount.title = NLS_MATCHES_COUNT_LIMIT_TITLE;
        else this._matchesCount.title = "";
        // remove previous content
        this._matchesCount.firstChild?.remove();
        let label;
        if (this._state.matchesCount > 0) {
            let matchesCount = String(this._state.matchesCount);
            if (this._state.matchesCount >= (0, _findModelJs.MATCHES_LIMIT)) matchesCount += "+";
            let matchesPosition = String(this._state.matchesPosition);
            if (matchesPosition === "0") matchesPosition = "?";
            label = _stringsJs.format(NLS_MATCHES_LOCATION, matchesPosition, matchesCount);
        } else label = NLS_NO_RESULTS;
        this._matchesCount.appendChild(document.createTextNode(label));
        (0, _ariaJs.alert)(this._getAriaLabel(label, this._state.currentMatch, this._state.searchString));
        MAX_MATCHES_COUNT_WIDTH = Math.max(MAX_MATCHES_COUNT_WIDTH, this._matchesCount.clientWidth);
    }
    // ----- actions
    _getAriaLabel(label, currentMatch, searchString) {
        if (label === NLS_NO_RESULTS) return searchString === "" ? _nlsJs.localize("ariaSearchNoResultEmpty", "{0} found", label) : _nlsJs.localize("ariaSearchNoResult", "{0} found for '{1}'", label, searchString);
        if (currentMatch) {
            const ariaLabel = _nlsJs.localize("ariaSearchNoResultWithLineNum", "{0} found for '{1}', at {2}", label, searchString, currentMatch.startLineNumber + ":" + currentMatch.startColumn);
            const model = this._codeEditor.getModel();
            if (model && currentMatch.startLineNumber <= model.getLineCount() && currentMatch.startLineNumber >= 1) {
                const lineContent = model.getLineContent(currentMatch.startLineNumber);
                return `${lineContent}, ${ariaLabel}`;
            }
            return ariaLabel;
        }
        return _nlsJs.localize("ariaSearchNoResultWithLineNumNoCurrentMatch", "{0} found for '{1}'", label, searchString);
    }
    /**
     * If 'selection find' is ON we should not disable the button (its function is to cancel 'selection find').
     * If 'selection find' is OFF we enable the button only if there is a selection.
     */ _updateToggleSelectionFindButton() {
        const selection = this._codeEditor.getSelection();
        const isSelection = selection ? selection.startLineNumber !== selection.endLineNumber || selection.startColumn !== selection.endColumn : false;
        const isChecked = this._toggleSelectionFind.checked;
        if (this._isVisible && (isChecked || isSelection)) this._toggleSelectionFind.enable();
        else this._toggleSelectionFind.disable();
    }
    _updateButtons() {
        this._findInput.setEnabled(this._isVisible);
        this._replaceInput.setEnabled(this._isVisible && this._isReplaceVisible);
        this._updateToggleSelectionFindButton();
        this._closeBtn.setEnabled(this._isVisible);
        const findInputIsNonEmpty = this._state.searchString.length > 0;
        const matchesCount = this._state.matchesCount ? true : false;
        this._prevBtn.setEnabled(this._isVisible && findInputIsNonEmpty && matchesCount && this._state.canNavigateBack());
        this._nextBtn.setEnabled(this._isVisible && findInputIsNonEmpty && matchesCount && this._state.canNavigateForward());
        this._replaceBtn.setEnabled(this._isVisible && this._isReplaceVisible && findInputIsNonEmpty);
        this._replaceAllBtn.setEnabled(this._isVisible && this._isReplaceVisible && findInputIsNonEmpty);
        this._domNode.classList.toggle("replaceToggled", this._isReplaceVisible);
        this._toggleReplaceBtn.setExpanded(this._isReplaceVisible);
        const canReplace = !this._codeEditor.getOption(92 /* EditorOption.readOnly */ );
        this._toggleReplaceBtn.setEnabled(this._isVisible && canReplace);
    }
    _reveal() {
        this._revealTimeouts.forEach((e)=>{
            clearTimeout(e);
        });
        this._revealTimeouts = [];
        if (!this._isVisible) {
            this._isVisible = true;
            const selection = this._codeEditor.getSelection();
            switch(this._codeEditor.getOption(41 /* EditorOption.find */ ).autoFindInSelection){
                case "always":
                    this._toggleSelectionFind.checked = true;
                    break;
                case "never":
                    this._toggleSelectionFind.checked = false;
                    break;
                case "multiline":
                    {
                        const isSelectionMultipleLine = !!selection && selection.startLineNumber !== selection.endLineNumber;
                        this._toggleSelectionFind.checked = isSelectionMultipleLine;
                        break;
                    }
                default:
                    break;
            }
            this._tryUpdateWidgetWidth();
            this._updateButtons();
            this._revealTimeouts.push(setTimeout(()=>{
                this._domNode.classList.add("visible");
                this._domNode.setAttribute("aria-hidden", "false");
            }, 0));
            // validate query again as it's being dismissed when we hide the find widget.
            this._revealTimeouts.push(setTimeout(()=>{
                this._findInput.validate();
            }, 200));
            this._codeEditor.layoutOverlayWidget(this);
            let adjustEditorScrollTop = true;
            if (this._codeEditor.getOption(41 /* EditorOption.find */ ).seedSearchStringFromSelection && selection) {
                const domNode = this._codeEditor.getDomNode();
                if (domNode) {
                    const editorCoords = _domJs.getDomNodePagePosition(domNode);
                    const startCoords = this._codeEditor.getScrolledVisiblePosition(selection.getStartPosition());
                    const startLeft = editorCoords.left + (startCoords ? startCoords.left : 0);
                    const startTop = startCoords ? startCoords.top : 0;
                    if (this._viewZone && startTop < this._viewZone.heightInPx) {
                        if (selection.endLineNumber > selection.startLineNumber) adjustEditorScrollTop = false;
                        const leftOfFindWidget = _domJs.getTopLeftOffset(this._domNode).left;
                        if (startLeft > leftOfFindWidget) adjustEditorScrollTop = false;
                        const endCoords = this._codeEditor.getScrolledVisiblePosition(selection.getEndPosition());
                        const endLeft = editorCoords.left + (endCoords ? endCoords.left : 0);
                        if (endLeft > leftOfFindWidget) adjustEditorScrollTop = false;
                    }
                }
            }
            this._showViewZone(adjustEditorScrollTop);
        }
    }
    _hide(focusTheEditor) {
        this._revealTimeouts.forEach((e)=>{
            clearTimeout(e);
        });
        this._revealTimeouts = [];
        if (this._isVisible) {
            this._isVisible = false;
            this._updateButtons();
            this._domNode.classList.remove("visible");
            this._domNode.setAttribute("aria-hidden", "true");
            this._findInput.clearMessage();
            if (focusTheEditor) this._codeEditor.focus();
            this._codeEditor.layoutOverlayWidget(this);
            this._removeViewZone();
        }
    }
    _layoutViewZone(targetScrollTop) {
        const addExtraSpaceOnTop = this._codeEditor.getOption(41 /* EditorOption.find */ ).addExtraSpaceOnTop;
        if (!addExtraSpaceOnTop) {
            this._removeViewZone();
            return;
        }
        if (!this._isVisible) return;
        const viewZone = this._viewZone;
        if (this._viewZoneId !== undefined || !viewZone) return;
        this._codeEditor.changeViewZones((accessor)=>{
            viewZone.heightInPx = this._getHeight();
            this._viewZoneId = accessor.addZone(viewZone);
            // scroll top adjust to make sure the editor doesn't scroll when adding viewzone at the beginning.
            this._codeEditor.setScrollTop(targetScrollTop || this._codeEditor.getScrollTop() + viewZone.heightInPx);
        });
    }
    _showViewZone(adjustScroll = true) {
        if (!this._isVisible) return;
        const addExtraSpaceOnTop = this._codeEditor.getOption(41 /* EditorOption.find */ ).addExtraSpaceOnTop;
        if (!addExtraSpaceOnTop) return;
        if (this._viewZone === undefined) this._viewZone = new FindWidgetViewZone(0);
        const viewZone = this._viewZone;
        this._codeEditor.changeViewZones((accessor)=>{
            if (this._viewZoneId !== undefined) {
                // the view zone already exists, we need to update the height
                const newHeight = this._getHeight();
                if (newHeight === viewZone.heightInPx) return;
                const scrollAdjustment = newHeight - viewZone.heightInPx;
                viewZone.heightInPx = newHeight;
                accessor.layoutZone(this._viewZoneId);
                if (adjustScroll) this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() + scrollAdjustment);
                return;
            } else {
                let scrollAdjustment = this._getHeight();
                // if the editor has top padding, factor that into the zone height
                scrollAdjustment -= this._codeEditor.getOption(84 /* EditorOption.padding */ ).top;
                if (scrollAdjustment <= 0) return;
                viewZone.heightInPx = scrollAdjustment;
                this._viewZoneId = accessor.addZone(viewZone);
                if (adjustScroll) this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() + scrollAdjustment);
            }
        });
    }
    _removeViewZone() {
        this._codeEditor.changeViewZones((accessor)=>{
            if (this._viewZoneId !== undefined) {
                accessor.removeZone(this._viewZoneId);
                this._viewZoneId = undefined;
                if (this._viewZone) {
                    this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() - this._viewZone.heightInPx);
                    this._viewZone = undefined;
                }
            }
        });
    }
    _tryUpdateWidgetWidth() {
        if (!this._isVisible) return;
        if (!this._domNode.isConnected) // the widget is not in the DOM
        return;
        const layoutInfo = this._codeEditor.getLayoutInfo();
        const editorContentWidth = layoutInfo.contentWidth;
        if (editorContentWidth <= 0) {
            // for example, diff view original editor
            this._domNode.classList.add("hiddenEditor");
            return;
        } else if (this._domNode.classList.contains("hiddenEditor")) this._domNode.classList.remove("hiddenEditor");
        const editorWidth = layoutInfo.width;
        const minimapWidth = layoutInfo.minimap.minimapWidth;
        let collapsedFindWidget = false;
        let reducedFindWidget = false;
        let narrowFindWidget = false;
        if (this._resized) {
            const widgetWidth = _domJs.getTotalWidth(this._domNode);
            if (widgetWidth > FIND_WIDGET_INITIAL_WIDTH) {
                // as the widget is resized by users, we may need to change the max width of the widget as the editor width changes.
                this._domNode.style.maxWidth = `${editorWidth - 28 - minimapWidth - 15}px`;
                this._replaceInput.width = _domJs.getTotalWidth(this._findInput.domNode);
                return;
            }
        }
        if (FIND_WIDGET_INITIAL_WIDTH + 28 + minimapWidth >= editorWidth) reducedFindWidget = true;
        if (FIND_WIDGET_INITIAL_WIDTH + 28 + minimapWidth - MAX_MATCHES_COUNT_WIDTH >= editorWidth) narrowFindWidget = true;
        if (FIND_WIDGET_INITIAL_WIDTH + 28 + minimapWidth - MAX_MATCHES_COUNT_WIDTH >= editorWidth + 50) collapsedFindWidget = true;
        this._domNode.classList.toggle("collapsed-find-widget", collapsedFindWidget);
        this._domNode.classList.toggle("narrow-find-widget", narrowFindWidget);
        this._domNode.classList.toggle("reduced-find-widget", reducedFindWidget);
        if (!narrowFindWidget && !collapsedFindWidget) // the minimal left offset of findwidget is 15px.
        this._domNode.style.maxWidth = `${editorWidth - 28 - minimapWidth - 15}px`;
        this._findInput.layout({
            collapsedFindWidget,
            narrowFindWidget,
            reducedFindWidget
        });
        if (this._resized) {
            const findInputWidth = this._findInput.inputBox.element.clientWidth;
            if (findInputWidth > 0) this._replaceInput.width = findInputWidth;
        } else if (this._isReplaceVisible) this._replaceInput.width = _domJs.getTotalWidth(this._findInput.domNode);
    }
    _getHeight() {
        let totalheight = 0;
        // find input margin top
        totalheight += 4;
        // find input height
        totalheight += this._findInput.inputBox.height + 2 /** input box border */ ;
        if (this._isReplaceVisible) {
            // replace input margin
            totalheight += 4;
            totalheight += this._replaceInput.inputBox.height + 2 /** input box border */ ;
        }
        // margin bottom
        totalheight += 4;
        return totalheight;
    }
    _tryUpdateHeight() {
        const totalHeight = this._getHeight();
        if (this._cachedHeight !== null && this._cachedHeight === totalHeight) return false;
        this._cachedHeight = totalHeight;
        this._domNode.style.height = `${totalHeight}px`;
        return true;
    }
    // ----- Public
    focusFindInput() {
        this._findInput.select();
        // Edge browser requires focus() in addition to select()
        this._findInput.focus();
    }
    focusReplaceInput() {
        this._replaceInput.select();
        // Edge browser requires focus() in addition to select()
        this._replaceInput.focus();
    }
    highlightFindOptions() {
        this._findInput.highlightFindOptions();
    }
    _updateSearchScope() {
        if (!this._codeEditor.hasModel()) return;
        if (this._toggleSelectionFind.checked) {
            const selections = this._codeEditor.getSelections();
            selections.map((selection)=>{
                if (selection.endColumn === 1 && selection.endLineNumber > selection.startLineNumber) selection = selection.setEndPosition(selection.endLineNumber - 1, this._codeEditor.getModel().getLineMaxColumn(selection.endLineNumber - 1));
                const currentMatch = this._state.currentMatch;
                if (selection.startLineNumber !== selection.endLineNumber) {
                    if (!(0, _rangeJs.Range).equalsRange(selection, currentMatch)) return selection;
                }
                return null;
            }).filter((element)=>!!element);
            if (selections.length) this._state.change({
                searchScope: selections
            }, true);
        }
    }
    _onFindInputMouseDown(e) {
        // on linux, middle key does pasting.
        if (e.middleButton) e.stopPropagation();
    }
    _onFindInputKeyDown(e) {
        if (e.equals(ctrlKeyMod | 3 /* KeyCode.Enter */ )) {
            if (this._keybindingService.dispatchEvent(e, e.target)) {
                e.preventDefault();
                return;
            } else {
                this._findInput.inputBox.insertAtCursor("\n");
                e.preventDefault();
                return;
            }
        }
        if (e.equals(2 /* KeyCode.Tab */ )) {
            if (this._isReplaceVisible) this._replaceInput.focus();
            else this._findInput.focusOnCaseSensitive();
            e.preventDefault();
            return;
        }
        if (e.equals(2066 /* KeyCode.DownArrow */ )) {
            this._codeEditor.focus();
            e.preventDefault();
            return;
        }
        if (e.equals(16 /* KeyCode.UpArrow */ )) return stopPropagationForMultiLineUpwards(e, this._findInput.getValue(), this._findInput.domNode.querySelector("textarea"));
        if (e.equals(18 /* KeyCode.DownArrow */ )) return stopPropagationForMultiLineDownwards(e, this._findInput.getValue(), this._findInput.domNode.querySelector("textarea"));
    }
    _onReplaceInputKeyDown(e) {
        if (e.equals(ctrlKeyMod | 3 /* KeyCode.Enter */ )) {
            if (this._keybindingService.dispatchEvent(e, e.target)) {
                e.preventDefault();
                return;
            } else {
                if (_platformJs.isWindows && _platformJs.isNative && !this._ctrlEnterReplaceAllWarningPrompted) {
                    // this is the first time when users press Ctrl + Enter to replace all
                    this._notificationService.info(_nlsJs.localize("ctrlEnter.keybindingChanged", "Ctrl+Enter now inserts line break instead of replacing all. You can modify the keybinding for editor.action.replaceAll to override this behavior."));
                    this._ctrlEnterReplaceAllWarningPrompted = true;
                    this._storageService.store(ctrlEnterReplaceAllWarningPromptedKey, true, 0 /* StorageScope.PROFILE */ , 0 /* StorageTarget.USER */ );
                }
                this._replaceInput.inputBox.insertAtCursor("\n");
                e.preventDefault();
                return;
            }
        }
        if (e.equals(2 /* KeyCode.Tab */ )) {
            this._findInput.focusOnCaseSensitive();
            e.preventDefault();
            return;
        }
        if (e.equals(1026 /* KeyCode.Tab */ )) {
            this._findInput.focus();
            e.preventDefault();
            return;
        }
        if (e.equals(2066 /* KeyCode.DownArrow */ )) {
            this._codeEditor.focus();
            e.preventDefault();
            return;
        }
        if (e.equals(16 /* KeyCode.UpArrow */ )) return stopPropagationForMultiLineUpwards(e, this._replaceInput.inputBox.value, this._replaceInput.inputBox.element.querySelector("textarea"));
        if (e.equals(18 /* KeyCode.DownArrow */ )) return stopPropagationForMultiLineDownwards(e, this._replaceInput.inputBox.value, this._replaceInput.inputBox.element.querySelector("textarea"));
    }
    // ----- sash
    getVerticalSashLeft(_sash) {
        return 0;
    }
    // ----- initialization
    _keybindingLabelFor(actionId) {
        const kb = this._keybindingService.lookupKeybinding(actionId);
        if (!kb) return "";
        return ` (${kb.getLabel()})`;
    }
    _buildDomNode() {
        const flexibleHeight = true;
        const flexibleWidth = true;
        // Find input
        this._findInput = this._register(new (0, _contextScopedHistoryWidgetJs.ContextScopedFindInput)(null, this._contextViewProvider, {
            width: FIND_INPUT_AREA_WIDTH,
            label: NLS_FIND_INPUT_LABEL,
            placeholder: NLS_FIND_INPUT_PLACEHOLDER,
            appendCaseSensitiveLabel: this._keybindingLabelFor((0, _findModelJs.FIND_IDS).ToggleCaseSensitiveCommand),
            appendWholeWordsLabel: this._keybindingLabelFor((0, _findModelJs.FIND_IDS).ToggleWholeWordCommand),
            appendRegexLabel: this._keybindingLabelFor((0, _findModelJs.FIND_IDS).ToggleRegexCommand),
            validation: (value)=>{
                if (value.length === 0 || !this._findInput.getRegex()) return null;
                try {
                    // use `g` and `u` which are also used by the TextModel search
                    new RegExp(value, "gu");
                    return null;
                } catch (e) {
                    return {
                        content: e.message
                    };
                }
            },
            flexibleHeight,
            flexibleWidth,
            flexibleMaxHeight: 118,
            showCommonFindToggles: true,
            showHistoryHint: ()=>(0, _historyWidgetKeybindingHintJs.showHistoryKeybindingHint)(this._keybindingService),
            inputBoxStyles: (0, _defaultStylesJs.defaultInputBoxStyles),
            toggleStyles: (0, _defaultStylesJs.defaultToggleStyles)
        }, this._contextKeyService));
        this._findInput.setRegex(!!this._state.isRegex);
        this._findInput.setCaseSensitive(!!this._state.matchCase);
        this._findInput.setWholeWords(!!this._state.wholeWord);
        this._register(this._findInput.onKeyDown((e)=>this._onFindInputKeyDown(e)));
        this._register(this._findInput.inputBox.onDidChange(()=>{
            if (this._ignoreChangeEvent) return;
            this._state.change({
                searchString: this._findInput.getValue()
            }, true);
        }));
        this._register(this._findInput.onDidOptionChange(()=>{
            this._state.change({
                isRegex: this._findInput.getRegex(),
                wholeWord: this._findInput.getWholeWords(),
                matchCase: this._findInput.getCaseSensitive()
            }, true);
        }));
        this._register(this._findInput.onCaseSensitiveKeyDown((e)=>{
            if (e.equals(1026 /* KeyCode.Tab */ )) {
                if (this._isReplaceVisible) {
                    this._replaceInput.focus();
                    e.preventDefault();
                }
            }
        }));
        this._register(this._findInput.onRegexKeyDown((e)=>{
            if (e.equals(2 /* KeyCode.Tab */ )) {
                if (this._isReplaceVisible) {
                    this._replaceInput.focusOnPreserve();
                    e.preventDefault();
                }
            }
        }));
        this._register(this._findInput.inputBox.onDidHeightChange((e)=>{
            if (this._tryUpdateHeight()) this._showViewZone();
        }));
        if (_platformJs.isLinux) this._register(this._findInput.onMouseDown((e)=>this._onFindInputMouseDown(e)));
        this._matchesCount = document.createElement("div");
        this._matchesCount.className = "matchesCount";
        this._updateMatchesCount();
        // Create a scoped hover delegate for all find related buttons
        const hoverDelegate = this._register((0, _hoverDelegateFactoryJs.createInstantHoverDelegate)());
        // Previous button
        this._prevBtn = this._register(new SimpleButton({
            label: NLS_PREVIOUS_MATCH_BTN_LABEL + this._keybindingLabelFor((0, _findModelJs.FIND_IDS).PreviousMatchFindAction),
            icon: findPreviousMatchIcon,
            hoverDelegate,
            onTrigger: ()=>{
                (0, _typesJs.assertIsDefined)(this._codeEditor.getAction((0, _findModelJs.FIND_IDS).PreviousMatchFindAction)).run().then(undefined, (0, _errorsJs.onUnexpectedError));
            }
        }, this._hoverService));
        // Next button
        this._nextBtn = this._register(new SimpleButton({
            label: NLS_NEXT_MATCH_BTN_LABEL + this._keybindingLabelFor((0, _findModelJs.FIND_IDS).NextMatchFindAction),
            icon: findNextMatchIcon,
            hoverDelegate,
            onTrigger: ()=>{
                (0, _typesJs.assertIsDefined)(this._codeEditor.getAction((0, _findModelJs.FIND_IDS).NextMatchFindAction)).run().then(undefined, (0, _errorsJs.onUnexpectedError));
            }
        }, this._hoverService));
        const findPart = document.createElement("div");
        findPart.className = "find-part";
        findPart.appendChild(this._findInput.domNode);
        const actionsContainer = document.createElement("div");
        actionsContainer.className = "find-actions";
        findPart.appendChild(actionsContainer);
        actionsContainer.appendChild(this._matchesCount);
        actionsContainer.appendChild(this._prevBtn.domNode);
        actionsContainer.appendChild(this._nextBtn.domNode);
        // Toggle selection button
        this._toggleSelectionFind = this._register(new (0, _toggleJs.Toggle)({
            icon: findSelectionIcon,
            title: NLS_TOGGLE_SELECTION_FIND_TITLE + this._keybindingLabelFor((0, _findModelJs.FIND_IDS).ToggleSearchScopeCommand),
            isChecked: false,
            hoverDelegate: hoverDelegate,
            inputActiveOptionBackground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputActiveOptionBackground)),
            inputActiveOptionBorder: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputActiveOptionBorder)),
            inputActiveOptionForeground: (0, _colorRegistryJs.asCssVariable)((0, _colorRegistryJs.inputActiveOptionForeground))
        }));
        this._register(this._toggleSelectionFind.onChange(()=>{
            if (this._toggleSelectionFind.checked) {
                if (this._codeEditor.hasModel()) {
                    let selections = this._codeEditor.getSelections();
                    selections = selections.map((selection)=>{
                        if (selection.endColumn === 1 && selection.endLineNumber > selection.startLineNumber) selection = selection.setEndPosition(selection.endLineNumber - 1, this._codeEditor.getModel().getLineMaxColumn(selection.endLineNumber - 1));
                        if (!selection.isEmpty()) return selection;
                        return null;
                    }).filter((element)=>!!element);
                    if (selections.length) this._state.change({
                        searchScope: selections
                    }, true);
                }
            } else this._state.change({
                searchScope: null
            }, true);
        }));
        actionsContainer.appendChild(this._toggleSelectionFind.domNode);
        // Close button
        this._closeBtn = this._register(new SimpleButton({
            label: NLS_CLOSE_BTN_LABEL + this._keybindingLabelFor((0, _findModelJs.FIND_IDS).CloseFindWidgetCommand),
            icon: (0, _iconRegistryJs.widgetClose),
            hoverDelegate,
            onTrigger: ()=>{
                this._state.change({
                    isRevealed: false,
                    searchScope: null
                }, false);
            },
            onKeyDown: (e)=>{
                if (e.equals(2 /* KeyCode.Tab */ )) {
                    if (this._isReplaceVisible) {
                        if (this._replaceBtn.isEnabled()) this._replaceBtn.focus();
                        else this._codeEditor.focus();
                        e.preventDefault();
                    }
                }
            }
        }, this._hoverService));
        // Replace input
        this._replaceInput = this._register(new (0, _contextScopedHistoryWidgetJs.ContextScopedReplaceInput)(null, undefined, {
            label: NLS_REPLACE_INPUT_LABEL,
            placeholder: NLS_REPLACE_INPUT_PLACEHOLDER,
            appendPreserveCaseLabel: this._keybindingLabelFor((0, _findModelJs.FIND_IDS).TogglePreserveCaseCommand),
            history: [],
            flexibleHeight,
            flexibleWidth,
            flexibleMaxHeight: 118,
            showHistoryHint: ()=>(0, _historyWidgetKeybindingHintJs.showHistoryKeybindingHint)(this._keybindingService),
            inputBoxStyles: (0, _defaultStylesJs.defaultInputBoxStyles),
            toggleStyles: (0, _defaultStylesJs.defaultToggleStyles)
        }, this._contextKeyService, true));
        this._replaceInput.setPreserveCase(!!this._state.preserveCase);
        this._register(this._replaceInput.onKeyDown((e)=>this._onReplaceInputKeyDown(e)));
        this._register(this._replaceInput.inputBox.onDidChange(()=>{
            this._state.change({
                replaceString: this._replaceInput.inputBox.value
            }, false);
        }));
        this._register(this._replaceInput.inputBox.onDidHeightChange((e)=>{
            if (this._isReplaceVisible && this._tryUpdateHeight()) this._showViewZone();
        }));
        this._register(this._replaceInput.onDidOptionChange(()=>{
            this._state.change({
                preserveCase: this._replaceInput.getPreserveCase()
            }, true);
        }));
        this._register(this._replaceInput.onPreserveCaseKeyDown((e)=>{
            if (e.equals(2 /* KeyCode.Tab */ )) {
                if (this._prevBtn.isEnabled()) this._prevBtn.focus();
                else if (this._nextBtn.isEnabled()) this._nextBtn.focus();
                else if (this._toggleSelectionFind.enabled) this._toggleSelectionFind.focus();
                else if (this._closeBtn.isEnabled()) this._closeBtn.focus();
                e.preventDefault();
            }
        }));
        // Create scoped hover delegate for replace actions
        const replaceHoverDelegate = this._register((0, _hoverDelegateFactoryJs.createInstantHoverDelegate)());
        // Replace one button
        this._replaceBtn = this._register(new SimpleButton({
            label: NLS_REPLACE_BTN_LABEL + this._keybindingLabelFor((0, _findModelJs.FIND_IDS).ReplaceOneAction),
            icon: findReplaceIcon,
            hoverDelegate: replaceHoverDelegate,
            onTrigger: ()=>{
                this._controller.replace();
            },
            onKeyDown: (e)=>{
                if (e.equals(1026 /* KeyCode.Tab */ )) {
                    this._closeBtn.focus();
                    e.preventDefault();
                }
            }
        }, this._hoverService));
        // Replace all button
        this._replaceAllBtn = this._register(new SimpleButton({
            label: NLS_REPLACE_ALL_BTN_LABEL + this._keybindingLabelFor((0, _findModelJs.FIND_IDS).ReplaceAllAction),
            icon: findReplaceAllIcon,
            hoverDelegate: replaceHoverDelegate,
            onTrigger: ()=>{
                this._controller.replaceAll();
            }
        }, this._hoverService));
        const replacePart = document.createElement("div");
        replacePart.className = "replace-part";
        replacePart.appendChild(this._replaceInput.domNode);
        const replaceActionsContainer = document.createElement("div");
        replaceActionsContainer.className = "replace-actions";
        replacePart.appendChild(replaceActionsContainer);
        replaceActionsContainer.appendChild(this._replaceBtn.domNode);
        replaceActionsContainer.appendChild(this._replaceAllBtn.domNode);
        // Toggle replace button
        this._toggleReplaceBtn = this._register(new SimpleButton({
            label: NLS_TOGGLE_REPLACE_MODE_BTN_LABEL,
            className: "codicon toggle left",
            onTrigger: ()=>{
                this._state.change({
                    isReplaceRevealed: !this._isReplaceVisible
                }, false);
                if (this._isReplaceVisible) {
                    this._replaceInput.width = _domJs.getTotalWidth(this._findInput.domNode);
                    this._replaceInput.inputBox.layout();
                }
                this._showViewZone();
            }
        }, this._hoverService));
        this._toggleReplaceBtn.setExpanded(this._isReplaceVisible);
        // Widget
        this._domNode = document.createElement("div");
        this._domNode.className = "editor-widget find-widget";
        this._domNode.setAttribute("aria-hidden", "true");
        this._domNode.ariaLabel = NLS_FIND_DIALOG_LABEL;
        this._domNode.role = "dialog";
        // We need to set this explicitly, otherwise on IE11, the width inheritence of flex doesn't work.
        this._domNode.style.width = `${FIND_WIDGET_INITIAL_WIDTH}px`;
        this._domNode.appendChild(this._toggleReplaceBtn.domNode);
        this._domNode.appendChild(findPart);
        this._domNode.appendChild(this._closeBtn.domNode);
        this._domNode.appendChild(replacePart);
        this._resizeSash = this._register(new (0, _sashJs.Sash)(this._domNode, this, {
            orientation: 0 /* Orientation.VERTICAL */ ,
            size: 2
        }));
        this._resized = false;
        let originalWidth = FIND_WIDGET_INITIAL_WIDTH;
        this._register(this._resizeSash.onDidStart(()=>{
            originalWidth = _domJs.getTotalWidth(this._domNode);
        }));
        this._register(this._resizeSash.onDidChange((evt)=>{
            this._resized = true;
            const width = originalWidth + evt.startX - evt.currentX;
            if (width < FIND_WIDGET_INITIAL_WIDTH) // narrow down the find widget should be handled by CSS.
            return;
            const maxWidth = parseFloat(_domJs.getComputedStyle(this._domNode).maxWidth) || 0;
            if (width > maxWidth) return;
            this._domNode.style.width = `${width}px`;
            if (this._isReplaceVisible) this._replaceInput.width = _domJs.getTotalWidth(this._findInput.domNode);
            this._findInput.inputBox.layout();
            this._tryUpdateHeight();
        }));
        this._register(this._resizeSash.onDidReset(()=>{
            // users double click on the sash
            const currentWidth = _domJs.getTotalWidth(this._domNode);
            if (currentWidth < FIND_WIDGET_INITIAL_WIDTH) // The editor is narrow and the width of the find widget is controlled fully by CSS.
            return;
            let width = FIND_WIDGET_INITIAL_WIDTH;
            if (!this._resized || currentWidth === FIND_WIDGET_INITIAL_WIDTH) {
                // 1. never resized before, double click should maximizes it
                // 2. users resized it already but its width is the same as default
                const layoutInfo = this._codeEditor.getLayoutInfo();
                width = layoutInfo.width - 28 - layoutInfo.minimap.minimapWidth - 15;
                this._resized = true;
            }
            this._domNode.style.width = `${width}px`;
            if (this._isReplaceVisible) this._replaceInput.width = _domJs.getTotalWidth(this._findInput.domNode);
            this._findInput.inputBox.layout();
        }));
    }
    updateAccessibilitySupport() {
        const value = this._codeEditor.getOption(2 /* EditorOption.accessibilitySupport */ );
        this._findInput.setFocusInputOnOptionClick(value !== 2 /* AccessibilitySupport.Enabled */ );
    }
}
class SimpleButton extends (0, _widgetJs.Widget) {
    constructor(opts, hoverService){
        super();
        this._opts = opts;
        let className = "button";
        if (this._opts.className) className = className + " " + this._opts.className;
        if (this._opts.icon) className = className + " " + (0, _themablesJs.ThemeIcon).asClassName(this._opts.icon);
        this._domNode = document.createElement("div");
        this._domNode.tabIndex = 0;
        this._domNode.className = className;
        this._domNode.setAttribute("role", "button");
        this._domNode.setAttribute("aria-label", this._opts.label);
        this._register(hoverService.setupManagedHover(opts.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("element"), this._domNode, this._opts.label));
        this.onclick(this._domNode, (e)=>{
            this._opts.onTrigger();
            e.preventDefault();
        });
        this.onkeydown(this._domNode, (e)=>{
            if (e.equals(10 /* KeyCode.Space */ ) || e.equals(3 /* KeyCode.Enter */ )) {
                this._opts.onTrigger();
                e.preventDefault();
                return;
            }
            this._opts.onKeyDown?.(e);
        });
    }
    get domNode() {
        return this._domNode;
    }
    isEnabled() {
        return this._domNode.tabIndex >= 0;
    }
    focus() {
        this._domNode.focus();
    }
    setEnabled(enabled) {
        this._domNode.classList.toggle("disabled", !enabled);
        this._domNode.setAttribute("aria-disabled", String(!enabled));
        this._domNode.tabIndex = enabled ? 0 : -1;
    }
    setExpanded(expanded) {
        this._domNode.setAttribute("aria-expanded", String(!!expanded));
        if (expanded) {
            this._domNode.classList.remove(...(0, _themablesJs.ThemeIcon).asClassNameArray(findCollapsedIcon));
            this._domNode.classList.add(...(0, _themablesJs.ThemeIcon).asClassNameArray(findExpandedIcon));
        } else {
            this._domNode.classList.remove(...(0, _themablesJs.ThemeIcon).asClassNameArray(findExpandedIcon));
            this._domNode.classList.add(...(0, _themablesJs.ThemeIcon).asClassNameArray(findCollapsedIcon));
        }
    }
}
// theming
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const findMatchHighlightBorder = theme.getColor((0, _colorRegistryJs.editorFindMatchHighlightBorder));
    if (findMatchHighlightBorder) collector.addRule(`.monaco-editor .findMatch { border: 1px ${(0, _themeJs.isHighContrast)(theme.type) ? "dotted" : "solid"} ${findMatchHighlightBorder}; box-sizing: border-box; }`);
    const findRangeHighlightBorder = theme.getColor((0, _colorRegistryJs.editorFindRangeHighlightBorder));
    if (findRangeHighlightBorder) collector.addRule(`.monaco-editor .findScope { border: 1px ${(0, _themeJs.isHighContrast)(theme.type) ? "dashed" : "solid"} ${findRangeHighlightBorder}; }`);
    const hcBorder = theme.getColor((0, _colorRegistryJs.contrastBorder));
    if (hcBorder) collector.addRule(`.monaco-editor .find-widget { border: 1px solid ${hcBorder}; }`);
    const findMatchForeground = theme.getColor((0, _colorRegistryJs.editorFindMatchForeground));
    if (findMatchForeground) collector.addRule(`.monaco-editor .findMatchInline { color: ${findMatchForeground}; }`);
    const findMatchHighlightForeground = theme.getColor((0, _colorRegistryJs.editorFindMatchHighlightForeground));
    if (findMatchHighlightForeground) collector.addRule(`.monaco-editor .currentFindMatchInline { color: ${findMatchHighlightForeground}; }`);
});

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/aria/aria.js":"asrsh","../../../../base/browser/ui/toggle/toggle.js":"3QqQn","../../../../base/browser/ui/sash/sash.js":"2Pk4d","../../../../base/browser/ui/widget.js":"kM4DP","../../../../base/common/async.js":"4GJc4","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/platform.js":"7maJO","../../../../base/common/strings.js":"aA9I1","./findWidget.css":"oQVcp","../../../common/core/range.js":"jmUPh","./findModel.js":"8SA2y","../../../../nls.js":"l617d","../../../../platform/history/browser/contextScopedHistoryWidget.js":"k152x","../../../../platform/history/browser/historyWidgetKeybindingHint.js":"bFIzL","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/iconRegistry.js":"bRNEz","../../../../platform/theme/common/themeService.js":"jMkIC","../../../../base/common/themables.js":"hgyHi","../../../../platform/theme/common/theme.js":"gh7Zf","../../../../base/common/types.js":"fb5yx","../../../../platform/theme/browser/defaultStyles.js":"4exuA","../../../../base/browser/ui/hover/hoverDelegateFactory.js":"kll4h","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"oQVcp":[function() {},{}],"k152x":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "historyNavigationVisible", ()=>historyNavigationVisible);
parcelHelpers.export(exports, "registerAndCreateHistoryNavigationContext", ()=>registerAndCreateHistoryNavigationContext);
parcelHelpers.export(exports, "ContextScopedFindInput", ()=>ContextScopedFindInput);
parcelHelpers.export(exports, "ContextScopedReplaceInput", ()=>ContextScopedReplaceInput);
var _findInputJs = require("../../../base/browser/ui/findinput/findInput.js");
var _replaceInputJs = require("../../../base/browser/ui/findinput/replaceInput.js");
var _contextkeyJs = require("../../contextkey/common/contextkey.js");
var _keybindingsRegistryJs = require("../../keybinding/common/keybindingsRegistry.js");
var _nlsJs = require("../../../nls.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _domJs = require("../../../base/browser/dom.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const historyNavigationVisible = new (0, _contextkeyJs.RawContextKey)("suggestWidgetVisible", false, (0, _nlsJs.localize)("suggestWidgetVisible", "Whether suggestion are visible"));
const HistoryNavigationWidgetFocusContext = "historyNavigationWidgetFocus";
const HistoryNavigationForwardsEnablementContext = "historyNavigationForwardsEnabled";
const HistoryNavigationBackwardsEnablementContext = "historyNavigationBackwardsEnabled";
let lastFocusedWidget = undefined;
const widgets = [];
function registerAndCreateHistoryNavigationContext(scopedContextKeyService, widget) {
    if (widgets.includes(widget)) throw new Error("Cannot register the same widget multiple times");
    widgets.push(widget);
    const disposableStore = new (0, _lifecycleJs.DisposableStore)();
    const historyNavigationWidgetFocus = new (0, _contextkeyJs.RawContextKey)(HistoryNavigationWidgetFocusContext, false).bindTo(scopedContextKeyService);
    const historyNavigationForwardsEnablement = new (0, _contextkeyJs.RawContextKey)(HistoryNavigationForwardsEnablementContext, true).bindTo(scopedContextKeyService);
    const historyNavigationBackwardsEnablement = new (0, _contextkeyJs.RawContextKey)(HistoryNavigationBackwardsEnablementContext, true).bindTo(scopedContextKeyService);
    const onDidFocus = ()=>{
        historyNavigationWidgetFocus.set(true);
        lastFocusedWidget = widget;
    };
    const onDidBlur = ()=>{
        historyNavigationWidgetFocus.set(false);
        if (lastFocusedWidget === widget) lastFocusedWidget = undefined;
    };
    // Check for currently being focused
    if ((0, _domJs.isActiveElement)(widget.element)) onDidFocus();
    disposableStore.add(widget.onDidFocus(()=>onDidFocus()));
    disposableStore.add(widget.onDidBlur(()=>onDidBlur()));
    disposableStore.add((0, _lifecycleJs.toDisposable)(()=>{
        widgets.splice(widgets.indexOf(widget), 1);
        onDidBlur();
    }));
    return {
        historyNavigationForwardsEnablement,
        historyNavigationBackwardsEnablement,
        dispose () {
            disposableStore.dispose();
        }
    };
}
let ContextScopedFindInput = class ContextScopedFindInput extends (0, _findInputJs.FindInput) {
    constructor(container, contextViewProvider, options, contextKeyService){
        super(container, contextViewProvider, options);
        const scopedContextKeyService = this._register(contextKeyService.createScoped(this.inputBox.element));
        this._register(registerAndCreateHistoryNavigationContext(scopedContextKeyService, this.inputBox));
    }
};
ContextScopedFindInput = __decorate([
    __param(3, (0, _contextkeyJs.IContextKeyService))
], ContextScopedFindInput);
let ContextScopedReplaceInput = class ContextScopedReplaceInput extends (0, _replaceInputJs.ReplaceInput) {
    constructor(container, contextViewProvider, options, contextKeyService, showReplaceOptions = false){
        super(container, contextViewProvider, showReplaceOptions, options);
        const scopedContextKeyService = this._register(contextKeyService.createScoped(this.inputBox.element));
        this._register(registerAndCreateHistoryNavigationContext(scopedContextKeyService, this.inputBox));
    }
};
ContextScopedReplaceInput = __decorate([
    __param(3, (0, _contextkeyJs.IContextKeyService))
], ContextScopedReplaceInput);
(0, _keybindingsRegistryJs.KeybindingsRegistry).registerCommandAndKeybindingRule({
    id: "history.showPrevious",
    weight: 200 /* KeybindingWeight.WorkbenchContrib */ ,
    when: (0, _contextkeyJs.ContextKeyExpr).and((0, _contextkeyJs.ContextKeyExpr).has(HistoryNavigationWidgetFocusContext), (0, _contextkeyJs.ContextKeyExpr).equals(HistoryNavigationBackwardsEnablementContext, true), (0, _contextkeyJs.ContextKeyExpr).not("isComposing"), historyNavigationVisible.isEqualTo(false)),
    primary: 16 /* KeyCode.UpArrow */ ,
    secondary: [
        528 /* KeyCode.UpArrow */ 
    ],
    handler: (accessor)=>{
        lastFocusedWidget?.showPreviousValue();
    }
});
(0, _keybindingsRegistryJs.KeybindingsRegistry).registerCommandAndKeybindingRule({
    id: "history.showNext",
    weight: 200 /* KeybindingWeight.WorkbenchContrib */ ,
    when: (0, _contextkeyJs.ContextKeyExpr).and((0, _contextkeyJs.ContextKeyExpr).has(HistoryNavigationWidgetFocusContext), (0, _contextkeyJs.ContextKeyExpr).equals(HistoryNavigationForwardsEnablementContext, true), (0, _contextkeyJs.ContextKeyExpr).not("isComposing"), historyNavigationVisible.isEqualTo(false)),
    primary: 18 /* KeyCode.DownArrow */ ,
    secondary: [
        530 /* KeyCode.DownArrow */ 
    ],
    handler: (accessor)=>{
        lastFocusedWidget?.showNextValue();
    }
});

},{"../../../base/browser/ui/findinput/findInput.js":"dp0WT","../../../base/browser/ui/findinput/replaceInput.js":"irYJ0","../../contextkey/common/contextkey.js":"gXuBD","../../keybinding/common/keybindingsRegistry.js":"h9qfk","../../../nls.js":"l617d","../../../base/common/lifecycle.js":"9kg8d","../../../base/browser/dom.js":"bnqsM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"irYJ0":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplaceInput", ()=>ReplaceInput);
var _domJs = require("../../dom.js");
var _toggleJs = require("../toggle/toggle.js");
var _inputBoxJs = require("../inputbox/inputBox.js");
var _widgetJs = require("../widget.js");
var _codiconsJs = require("../../../common/codicons.js");
var _eventJs = require("../../../common/event.js");
var _findInputCss = require("./findInput.css");
var _nlsJs = require("../../../../nls.js");
var _hoverDelegateFactoryJs = require("../hover/hoverDelegateFactory.js");
const NLS_DEFAULT_LABEL = _nlsJs.localize("defaultLabel", "input");
const NLS_PRESERVE_CASE_LABEL = _nlsJs.localize("label.preserveCaseToggle", "Preserve Case");
class PreserveCaseToggle extends (0, _toggleJs.Toggle) {
    constructor(opts){
        super({
            // TODO: does this need its own icon?
            icon: (0, _codiconsJs.Codicon).preserveCase,
            title: NLS_PRESERVE_CASE_LABEL + opts.appendTitle,
            isChecked: opts.isChecked,
            hoverDelegate: opts.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("element"),
            inputActiveOptionBorder: opts.inputActiveOptionBorder,
            inputActiveOptionForeground: opts.inputActiveOptionForeground,
            inputActiveOptionBackground: opts.inputActiveOptionBackground
        });
    }
}
class ReplaceInput extends (0, _widgetJs.Widget) {
    constructor(parent, contextViewProvider, _showOptionButtons, options){
        super();
        this._showOptionButtons = _showOptionButtons;
        this.fixFocusOnOptionClickEnabled = true;
        this.cachedOptionsWidth = 0;
        this._onDidOptionChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidOptionChange = this._onDidOptionChange.event;
        this._onKeyDown = this._register(new (0, _eventJs.Emitter)());
        this.onKeyDown = this._onKeyDown.event;
        this._onMouseDown = this._register(new (0, _eventJs.Emitter)());
        this._onInput = this._register(new (0, _eventJs.Emitter)());
        this._onKeyUp = this._register(new (0, _eventJs.Emitter)());
        this._onPreserveCaseKeyDown = this._register(new (0, _eventJs.Emitter)());
        this.onPreserveCaseKeyDown = this._onPreserveCaseKeyDown.event;
        this.contextViewProvider = contextViewProvider;
        this.placeholder = options.placeholder || "";
        this.validation = options.validation;
        this.label = options.label || NLS_DEFAULT_LABEL;
        const appendPreserveCaseLabel = options.appendPreserveCaseLabel || "";
        const history = options.history || [];
        const flexibleHeight = !!options.flexibleHeight;
        const flexibleWidth = !!options.flexibleWidth;
        const flexibleMaxHeight = options.flexibleMaxHeight;
        this.domNode = document.createElement("div");
        this.domNode.classList.add("monaco-findInput");
        this.inputBox = this._register(new (0, _inputBoxJs.HistoryInputBox)(this.domNode, this.contextViewProvider, {
            ariaLabel: this.label || "",
            placeholder: this.placeholder || "",
            validationOptions: {
                validation: this.validation
            },
            history,
            showHistoryHint: options.showHistoryHint,
            flexibleHeight,
            flexibleWidth,
            flexibleMaxHeight,
            inputBoxStyles: options.inputBoxStyles
        }));
        this.preserveCase = this._register(new PreserveCaseToggle({
            appendTitle: appendPreserveCaseLabel,
            isChecked: false,
            ...options.toggleStyles
        }));
        this._register(this.preserveCase.onChange((viaKeyboard)=>{
            this._onDidOptionChange.fire(viaKeyboard);
            if (!viaKeyboard && this.fixFocusOnOptionClickEnabled) this.inputBox.focus();
            this.validate();
        }));
        this._register(this.preserveCase.onKeyDown((e)=>{
            this._onPreserveCaseKeyDown.fire(e);
        }));
        if (this._showOptionButtons) this.cachedOptionsWidth = this.preserveCase.width();
        else this.cachedOptionsWidth = 0;
        // Arrow-Key support to navigate between options
        const indexes = [
            this.preserveCase.domNode
        ];
        this.onkeydown(this.domNode, (event)=>{
            if (event.equals(15 /* KeyCode.LeftArrow */ ) || event.equals(17 /* KeyCode.RightArrow */ ) || event.equals(9 /* KeyCode.Escape */ )) {
                const index = indexes.indexOf(this.domNode.ownerDocument.activeElement);
                if (index >= 0) {
                    let newIndex = -1;
                    if (event.equals(17 /* KeyCode.RightArrow */ )) newIndex = (index + 1) % indexes.length;
                    else if (event.equals(15 /* KeyCode.LeftArrow */ )) {
                        if (index === 0) newIndex = indexes.length - 1;
                        else newIndex = index - 1;
                    }
                    if (event.equals(9 /* KeyCode.Escape */ )) {
                        indexes[index].blur();
                        this.inputBox.focus();
                    } else if (newIndex >= 0) indexes[newIndex].focus();
                    _domJs.EventHelper.stop(event, true);
                }
            }
        });
        const controls = document.createElement("div");
        controls.className = "controls";
        controls.style.display = this._showOptionButtons ? "block" : "none";
        controls.appendChild(this.preserveCase.domNode);
        this.domNode.appendChild(controls);
        parent?.appendChild(this.domNode);
        this.onkeydown(this.inputBox.inputElement, (e)=>this._onKeyDown.fire(e));
        this.onkeyup(this.inputBox.inputElement, (e)=>this._onKeyUp.fire(e));
        this.oninput(this.inputBox.inputElement, (e)=>this._onInput.fire());
        this.onmousedown(this.inputBox.inputElement, (e)=>this._onMouseDown.fire(e));
    }
    enable() {
        this.domNode.classList.remove("disabled");
        this.inputBox.enable();
        this.preserveCase.enable();
    }
    disable() {
        this.domNode.classList.add("disabled");
        this.inputBox.disable();
        this.preserveCase.disable();
    }
    setEnabled(enabled) {
        if (enabled) this.enable();
        else this.disable();
    }
    select() {
        this.inputBox.select();
    }
    focus() {
        this.inputBox.focus();
    }
    getPreserveCase() {
        return this.preserveCase.checked;
    }
    setPreserveCase(value) {
        this.preserveCase.checked = value;
    }
    focusOnPreserve() {
        this.preserveCase.focus();
    }
    validate() {
        this.inputBox?.validate();
    }
    set width(newWidth) {
        this.inputBox.paddingRight = this.cachedOptionsWidth;
        this.domNode.style.width = newWidth + "px";
    }
    dispose() {
        super.dispose();
    }
}

},{"../../dom.js":"bnqsM","../toggle/toggle.js":"3QqQn","../inputbox/inputBox.js":"aE5HZ","../widget.js":"kM4DP","../../../common/codicons.js":"hWYNf","../../../common/event.js":"4Zi8b","./findInput.css":"8KxY6","../../../../nls.js":"l617d","../hover/hoverDelegateFactory.js":"kll4h","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8KxY6":[function() {},{}],"bFIzL":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "showHistoryKeybindingHint", ()=>showHistoryKeybindingHint);
function showHistoryKeybindingHint(keybindingService) {
    return keybindingService.lookupKeybinding("history.showPrevious")?.getElectronAccelerator() === "Up" && keybindingService.lookupKeybinding("history.showNext")?.getElectronAccelerator() === "Down";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iWk0I":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FoldingController", ()=>FoldingController);
parcelHelpers.export(exports, "RangesLimitReporter", ()=>RangesLimitReporter);
parcelHelpers.export(exports, "toSelectedLines", ()=>toSelectedLines);
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _keyCodesJs = require("../../../../base/common/keyCodes.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _typesJs = require("../../../../base/common/types.js");
var _foldingCss = require("./folding.css");
var _stableEditorScrollJs = require("../../../browser/stableEditorScroll.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _languagesJs = require("../../../common/languages.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _foldingModelJs = require("./foldingModel.js");
var _hiddenRangeModelJs = require("./hiddenRangeModel.js");
var _indentRangeProviderJs = require("./indentRangeProvider.js");
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _foldingDecorationsJs = require("./foldingDecorations.js");
var _foldingRangesJs = require("./foldingRanges.js");
var _syntaxRangeProviderJs = require("./syntaxRangeProvider.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var _languageFeatureDebounceJs = require("../../../common/services/languageFeatureDebounce.js");
var _stopwatchJs = require("../../../../base/common/stopwatch.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _eventJs = require("../../../../base/common/event.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _uriJs = require("../../../../base/common/uri.js");
var _modelJs = require("../../../common/services/model.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var FoldingController_1;
const CONTEXT_FOLDING_ENABLED = new (0, _contextkeyJs.RawContextKey)("foldingEnabled", false);
let FoldingController = class FoldingController extends (0, _lifecycleJs.Disposable) {
    static{
        FoldingController_1 = this;
    }
    static{
        this.ID = "editor.contrib.folding";
    }
    static get(editor) {
        return editor.getContribution(FoldingController_1.ID);
    }
    static getFoldingRangeProviders(languageFeaturesService, model) {
        const foldingRangeProviders = languageFeaturesService.foldingRangeProvider.ordered(model);
        return FoldingController_1._foldingRangeSelector?.(foldingRangeProviders, model) ?? foldingRangeProviders;
    }
    constructor(editor, contextKeyService, languageConfigurationService, notificationService, languageFeatureDebounceService, languageFeaturesService){
        super();
        this.contextKeyService = contextKeyService;
        this.languageConfigurationService = languageConfigurationService;
        this.languageFeaturesService = languageFeaturesService;
        this.localToDispose = this._register(new (0, _lifecycleJs.DisposableStore)());
        this.editor = editor;
        this._foldingLimitReporter = new RangesLimitReporter(editor);
        const options = this.editor.getOptions();
        this._isEnabled = options.get(43 /* EditorOption.folding */ );
        this._useFoldingProviders = options.get(44 /* EditorOption.foldingStrategy */ ) !== "indentation";
        this._unfoldOnClickAfterEndOfLine = options.get(48 /* EditorOption.unfoldOnClickAfterEndOfLine */ );
        this._restoringViewState = false;
        this._currentModelHasFoldedImports = false;
        this._foldingImportsByDefault = options.get(46 /* EditorOption.foldingImportsByDefault */ );
        this.updateDebounceInfo = languageFeatureDebounceService.for(languageFeaturesService.foldingRangeProvider, "Folding", {
            min: 200
        });
        this.foldingModel = null;
        this.hiddenRangeModel = null;
        this.rangeProvider = null;
        this.foldingRegionPromise = null;
        this.foldingModelPromise = null;
        this.updateScheduler = null;
        this.cursorChangedScheduler = null;
        this.mouseDownInfo = null;
        this.foldingDecorationProvider = new (0, _foldingDecorationsJs.FoldingDecorationProvider)(editor);
        this.foldingDecorationProvider.showFoldingControls = options.get(111 /* EditorOption.showFoldingControls */ );
        this.foldingDecorationProvider.showFoldingHighlights = options.get(45 /* EditorOption.foldingHighlight */ );
        this.foldingEnabled = CONTEXT_FOLDING_ENABLED.bindTo(this.contextKeyService);
        this.foldingEnabled.set(this._isEnabled);
        this._register(this.editor.onDidChangeModel(()=>this.onModelChanged()));
        this._register(this.editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(43 /* EditorOption.folding */ )) {
                this._isEnabled = this.editor.getOptions().get(43 /* EditorOption.folding */ );
                this.foldingEnabled.set(this._isEnabled);
                this.onModelChanged();
            }
            if (e.hasChanged(47 /* EditorOption.foldingMaximumRegions */ )) this.onModelChanged();
            if (e.hasChanged(111 /* EditorOption.showFoldingControls */ ) || e.hasChanged(45 /* EditorOption.foldingHighlight */ )) {
                const options = this.editor.getOptions();
                this.foldingDecorationProvider.showFoldingControls = options.get(111 /* EditorOption.showFoldingControls */ );
                this.foldingDecorationProvider.showFoldingHighlights = options.get(45 /* EditorOption.foldingHighlight */ );
                this.triggerFoldingModelChanged();
            }
            if (e.hasChanged(44 /* EditorOption.foldingStrategy */ )) {
                this._useFoldingProviders = this.editor.getOptions().get(44 /* EditorOption.foldingStrategy */ ) !== "indentation";
                this.onFoldingStrategyChanged();
            }
            if (e.hasChanged(48 /* EditorOption.unfoldOnClickAfterEndOfLine */ )) this._unfoldOnClickAfterEndOfLine = this.editor.getOptions().get(48 /* EditorOption.unfoldOnClickAfterEndOfLine */ );
            if (e.hasChanged(46 /* EditorOption.foldingImportsByDefault */ )) this._foldingImportsByDefault = this.editor.getOptions().get(46 /* EditorOption.foldingImportsByDefault */ );
        }));
        this.onModelChanged();
    }
    /**
     * Store view state.
     */ saveViewState() {
        const model = this.editor.getModel();
        if (!model || !this._isEnabled || model.isTooLargeForTokenization()) return {};
        if (this.foldingModel) {
            const collapsedRegions = this.foldingModel.getMemento();
            const provider = this.rangeProvider ? this.rangeProvider.id : undefined;
            return {
                collapsedRegions,
                lineCount: model.getLineCount(),
                provider,
                foldedImports: this._currentModelHasFoldedImports
            };
        }
        return undefined;
    }
    /**
     * Restore view state.
     */ restoreViewState(state) {
        const model = this.editor.getModel();
        if (!model || !this._isEnabled || model.isTooLargeForTokenization() || !this.hiddenRangeModel) return;
        if (!state) return;
        this._currentModelHasFoldedImports = !!state.foldedImports;
        if (state.collapsedRegions && state.collapsedRegions.length > 0 && this.foldingModel) {
            this._restoringViewState = true;
            try {
                this.foldingModel.applyMemento(state.collapsedRegions);
            } finally{
                this._restoringViewState = false;
            }
        }
    }
    onModelChanged() {
        this.localToDispose.clear();
        const model = this.editor.getModel();
        if (!this._isEnabled || !model || model.isTooLargeForTokenization()) // huge files get no view model, so they cannot support hidden areas
        return;
        this._currentModelHasFoldedImports = false;
        this.foldingModel = new (0, _foldingModelJs.FoldingModel)(model, this.foldingDecorationProvider);
        this.localToDispose.add(this.foldingModel);
        this.hiddenRangeModel = new (0, _hiddenRangeModelJs.HiddenRangeModel)(this.foldingModel);
        this.localToDispose.add(this.hiddenRangeModel);
        this.localToDispose.add(this.hiddenRangeModel.onDidChange((hr)=>this.onHiddenRangesChanges(hr)));
        this.updateScheduler = new (0, _asyncJs.Delayer)(this.updateDebounceInfo.get(model));
        this.cursorChangedScheduler = new (0, _asyncJs.RunOnceScheduler)(()=>this.revealCursor(), 200);
        this.localToDispose.add(this.cursorChangedScheduler);
        this.localToDispose.add(this.languageFeaturesService.foldingRangeProvider.onDidChange(()=>this.onFoldingStrategyChanged()));
        this.localToDispose.add(this.editor.onDidChangeModelLanguageConfiguration(()=>this.onFoldingStrategyChanged())); // covers model language changes as well
        this.localToDispose.add(this.editor.onDidChangeModelContent((e)=>this.onDidChangeModelContent(e)));
        this.localToDispose.add(this.editor.onDidChangeCursorPosition(()=>this.onCursorPositionChanged()));
        this.localToDispose.add(this.editor.onMouseDown((e)=>this.onEditorMouseDown(e)));
        this.localToDispose.add(this.editor.onMouseUp((e)=>this.onEditorMouseUp(e)));
        this.localToDispose.add({
            dispose: ()=>{
                if (this.foldingRegionPromise) {
                    this.foldingRegionPromise.cancel();
                    this.foldingRegionPromise = null;
                }
                this.updateScheduler?.cancel();
                this.updateScheduler = null;
                this.foldingModel = null;
                this.foldingModelPromise = null;
                this.hiddenRangeModel = null;
                this.cursorChangedScheduler = null;
                this.rangeProvider?.dispose();
                this.rangeProvider = null;
            }
        });
        this.triggerFoldingModelChanged();
    }
    onFoldingStrategyChanged() {
        this.rangeProvider?.dispose();
        this.rangeProvider = null;
        this.triggerFoldingModelChanged();
    }
    getRangeProvider(editorModel) {
        if (this.rangeProvider) return this.rangeProvider;
        const indentRangeProvider = new (0, _indentRangeProviderJs.IndentRangeProvider)(editorModel, this.languageConfigurationService, this._foldingLimitReporter);
        this.rangeProvider = indentRangeProvider; // fallback
        if (this._useFoldingProviders && this.foldingModel) {
            const selectedProviders = FoldingController_1.getFoldingRangeProviders(this.languageFeaturesService, editorModel);
            if (selectedProviders.length > 0) this.rangeProvider = new (0, _syntaxRangeProviderJs.SyntaxRangeProvider)(editorModel, selectedProviders, ()=>this.triggerFoldingModelChanged(), this._foldingLimitReporter, indentRangeProvider);
        }
        return this.rangeProvider;
    }
    getFoldingModel() {
        return this.foldingModelPromise;
    }
    onDidChangeModelContent(e) {
        this.hiddenRangeModel?.notifyChangeModelContent(e);
        this.triggerFoldingModelChanged();
    }
    triggerFoldingModelChanged() {
        if (this.updateScheduler) {
            if (this.foldingRegionPromise) {
                this.foldingRegionPromise.cancel();
                this.foldingRegionPromise = null;
            }
            this.foldingModelPromise = this.updateScheduler.trigger(()=>{
                const foldingModel = this.foldingModel;
                if (!foldingModel) return null;
                const sw = new (0, _stopwatchJs.StopWatch)();
                const provider = this.getRangeProvider(foldingModel.textModel);
                const foldingRegionPromise = this.foldingRegionPromise = (0, _asyncJs.createCancelablePromise)((token)=>provider.compute(token));
                return foldingRegionPromise.then((foldingRanges)=>{
                    if (foldingRanges && foldingRegionPromise === this.foldingRegionPromise) {
                        let scrollState;
                        if (this._foldingImportsByDefault && !this._currentModelHasFoldedImports) {
                            const hasChanges = foldingRanges.setCollapsedAllOfType((0, _languagesJs.FoldingRangeKind).Imports.value, true);
                            if (hasChanges) {
                                scrollState = (0, _stableEditorScrollJs.StableEditorScrollState).capture(this.editor);
                                this._currentModelHasFoldedImports = hasChanges;
                            }
                        }
                        // some cursors might have moved into hidden regions, make sure they are in expanded regions
                        const selections = this.editor.getSelections();
                        foldingModel.update(foldingRanges, toSelectedLines(selections));
                        scrollState?.restore(this.editor);
                        // update debounce info
                        const newValue = this.updateDebounceInfo.update(foldingModel.textModel, sw.elapsed());
                        if (this.updateScheduler) this.updateScheduler.defaultDelay = newValue;
                    }
                    return foldingModel;
                });
            }).then(undefined, (err)=>{
                (0, _errorsJs.onUnexpectedError)(err);
                return null;
            });
        }
    }
    onHiddenRangesChanges(hiddenRanges) {
        if (this.hiddenRangeModel && hiddenRanges.length && !this._restoringViewState) {
            const selections = this.editor.getSelections();
            if (selections) {
                if (this.hiddenRangeModel.adjustSelections(selections)) this.editor.setSelections(selections);
            }
        }
        this.editor.setHiddenAreas(hiddenRanges, this);
    }
    onCursorPositionChanged() {
        if (this.hiddenRangeModel && this.hiddenRangeModel.hasRanges()) this.cursorChangedScheduler.schedule();
    }
    revealCursor() {
        const foldingModel = this.getFoldingModel();
        if (!foldingModel) return;
        foldingModel.then((foldingModel)=>{
            if (foldingModel) {
                const selections = this.editor.getSelections();
                if (selections && selections.length > 0) {
                    const toToggle = [];
                    for (const selection of selections){
                        const lineNumber = selection.selectionStartLineNumber;
                        if (this.hiddenRangeModel && this.hiddenRangeModel.isHidden(lineNumber)) toToggle.push(...foldingModel.getAllRegionsAtLine(lineNumber, (r)=>r.isCollapsed && lineNumber > r.startLineNumber));
                    }
                    if (toToggle.length) {
                        foldingModel.toggleCollapseState(toToggle);
                        this.reveal(selections[0].getPosition());
                    }
                }
            }
        }).then(undefined, (0, _errorsJs.onUnexpectedError));
    }
    onEditorMouseDown(e) {
        this.mouseDownInfo = null;
        if (!this.hiddenRangeModel || !e.target || !e.target.range) return;
        if (!e.event.leftButton && !e.event.middleButton) return;
        const range = e.target.range;
        let iconClicked = false;
        switch(e.target.type){
            case 4 /* MouseTargetType.GUTTER_LINE_DECORATIONS */ :
                {
                    const data = e.target.detail;
                    const offsetLeftInGutter = e.target.element.offsetLeft;
                    const gutterOffsetX = data.offsetX - offsetLeftInGutter;
                    // const gutterOffsetX = data.offsetX - data.glyphMarginWidth - data.lineNumbersWidth - data.glyphMarginLeft;
                    // TODO@joao TODO@alex TODO@martin this is such that we don't collide with dirty diff
                    if (gutterOffsetX < 4) return;
                    iconClicked = true;
                    break;
                }
            case 7 /* MouseTargetType.CONTENT_EMPTY */ :
                if (this._unfoldOnClickAfterEndOfLine && this.hiddenRangeModel.hasRanges()) {
                    const data = e.target.detail;
                    if (!data.isAfterLines) break;
                }
                return;
            case 6 /* MouseTargetType.CONTENT_TEXT */ :
                if (this.hiddenRangeModel.hasRanges()) {
                    const model = this.editor.getModel();
                    if (model && range.startColumn === model.getLineMaxColumn(range.startLineNumber)) break;
                }
                return;
            default:
                return;
        }
        this.mouseDownInfo = {
            lineNumber: range.startLineNumber,
            iconClicked
        };
    }
    onEditorMouseUp(e) {
        const foldingModel = this.foldingModel;
        if (!foldingModel || !this.mouseDownInfo || !e.target) return;
        const lineNumber = this.mouseDownInfo.lineNumber;
        const iconClicked = this.mouseDownInfo.iconClicked;
        const range = e.target.range;
        if (!range || range.startLineNumber !== lineNumber) return;
        if (iconClicked) {
            if (e.target.type !== 4 /* MouseTargetType.GUTTER_LINE_DECORATIONS */ ) return;
        } else {
            const model = this.editor.getModel();
            if (!model || range.startColumn !== model.getLineMaxColumn(lineNumber)) return;
        }
        const region = foldingModel.getRegionAtLine(lineNumber);
        if (region && region.startLineNumber === lineNumber) {
            const isCollapsed = region.isCollapsed;
            if (iconClicked || isCollapsed) {
                const surrounding = e.event.altKey;
                let toToggle = [];
                if (surrounding) {
                    const filter = (otherRegion)=>!otherRegion.containedBy(region) && !region.containedBy(otherRegion);
                    const toMaybeToggle = foldingModel.getRegionsInside(null, filter);
                    for (const r of toMaybeToggle)if (r.isCollapsed) toToggle.push(r);
                    // if any surrounding regions are folded, unfold those. Otherwise, fold all surrounding
                    if (toToggle.length === 0) toToggle = toMaybeToggle;
                } else {
                    const recursive = e.event.middleButton || e.event.shiftKey;
                    if (recursive) {
                        for (const r of foldingModel.getRegionsInside(region))if (r.isCollapsed === isCollapsed) toToggle.push(r);
                    }
                    // when recursive, first only collapse all children. If all are already folded or there are no children, also fold parent.
                    if (isCollapsed || !recursive || toToggle.length === 0) toToggle.push(region);
                }
                foldingModel.toggleCollapseState(toToggle);
                this.reveal({
                    lineNumber,
                    column: 1
                });
            }
        }
    }
    reveal(position) {
        this.editor.revealPositionInCenterIfOutsideViewport(position, 0 /* ScrollType.Smooth */ );
    }
};
FoldingController = FoldingController_1 = __decorate([
    __param(1, (0, _contextkeyJs.IContextKeyService)),
    __param(2, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService)),
    __param(3, (0, _notificationJs.INotificationService)),
    __param(4, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService)),
    __param(5, (0, _languageFeaturesJs.ILanguageFeaturesService))
], FoldingController);
class RangesLimitReporter {
    constructor(editor){
        this.editor = editor;
        this._onDidChange = new (0, _eventJs.Emitter)();
        this._computed = 0;
        this._limited = false;
    }
    get limit() {
        return this.editor.getOptions().get(47 /* EditorOption.foldingMaximumRegions */ );
    }
    update(computed, limited) {
        if (computed !== this._computed || limited !== this._limited) {
            this._computed = computed;
            this._limited = limited;
            this._onDidChange.fire();
        }
    }
}
class FoldingAction extends (0, _editorExtensionsJs.EditorAction) {
    runEditorCommand(accessor, editor, args) {
        const languageConfigurationService = accessor.get((0, _languageConfigurationRegistryJs.ILanguageConfigurationService));
        const foldingController = FoldingController.get(editor);
        if (!foldingController) return;
        const foldingModelPromise = foldingController.getFoldingModel();
        if (foldingModelPromise) {
            this.reportTelemetry(accessor, editor);
            return foldingModelPromise.then((foldingModel)=>{
                if (foldingModel) {
                    this.invoke(foldingController, foldingModel, editor, args, languageConfigurationService);
                    const selection = editor.getSelection();
                    if (selection) foldingController.reveal(selection.getStartPosition());
                }
            });
        }
    }
    getSelectedLines(editor) {
        const selections = editor.getSelections();
        return selections ? selections.map((s)=>s.startLineNumber) : [];
    }
    getLineNumbers(args, editor) {
        if (args && args.selectionLines) return args.selectionLines.map((l)=>l + 1); // to 0-bases line numbers
        return this.getSelectedLines(editor);
    }
    run(_accessor, _editor) {}
}
function toSelectedLines(selections) {
    if (!selections || selections.length === 0) return {
        startsInside: ()=>false
    };
    return {
        startsInside (startLine, endLine) {
            for (const s of selections){
                const line = s.startLineNumber;
                if (line >= startLine && line <= endLine) return true;
            }
            return false;
        }
    };
}
function foldingArgumentsConstraint(args) {
    if (!_typesJs.isUndefined(args)) {
        if (!_typesJs.isObject(args)) return false;
        const foldingArgs = args;
        if (!_typesJs.isUndefined(foldingArgs.levels) && !_typesJs.isNumber(foldingArgs.levels)) return false;
        if (!_typesJs.isUndefined(foldingArgs.direction) && !_typesJs.isString(foldingArgs.direction)) return false;
        if (!_typesJs.isUndefined(foldingArgs.selectionLines) && (!Array.isArray(foldingArgs.selectionLines) || !foldingArgs.selectionLines.every(_typesJs.isNumber))) return false;
    }
    return true;
}
class UnfoldAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.unfold",
            label: _nlsJs.localize("unfoldAction.label", "Unfold"),
            alias: "Unfold",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 3166 /* KeyCode.BracketRight */ ,
                mac: {
                    primary: 2654 /* KeyCode.BracketRight */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: "Unfold the content in the editor",
                args: [
                    {
                        name: "Unfold editor argument",
                        description: `Property-value pairs that can be passed through this argument:
						* 'levels': Number of levels to unfold. If not set, defaults to 1.
						* 'direction': If 'up', unfold given number of levels up otherwise unfolds down.
						* 'selectionLines': Array of the start lines (0-based) of the editor selections to apply the unfold action to. If not set, the active selection(s) will be used.
						`,
                        constraint: foldingArgumentsConstraint,
                        schema: {
                            "type": "object",
                            "properties": {
                                "levels": {
                                    "type": "number",
                                    "default": 1
                                },
                                "direction": {
                                    "type": "string",
                                    "enum": [
                                        "up",
                                        "down"
                                    ],
                                    "default": "down"
                                },
                                "selectionLines": {
                                    "type": "array",
                                    "items": {
                                        "type": "number"
                                    }
                                }
                            }
                        }
                    }
                ]
            }
        });
    }
    invoke(_foldingController, foldingModel, editor, args) {
        const levels = args && args.levels || 1;
        const lineNumbers = this.getLineNumbers(args, editor);
        if (args && args.direction === "up") (0, _foldingModelJs.setCollapseStateLevelsUp)(foldingModel, false, levels, lineNumbers);
        else (0, _foldingModelJs.setCollapseStateLevelsDown)(foldingModel, false, levels, lineNumbers);
    }
}
class UnFoldRecursivelyAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.unfoldRecursively",
            label: _nlsJs.localize("unFoldRecursivelyAction.label", "Unfold Recursively"),
            alias: "Unfold Recursively",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2142 /* KeyCode.BracketRight */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor, _args) {
        (0, _foldingModelJs.setCollapseStateLevelsDown)(foldingModel, false, Number.MAX_VALUE, this.getSelectedLines(editor));
    }
}
class FoldAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.fold",
            label: _nlsJs.localize("foldAction.label", "Fold"),
            alias: "Fold",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 3164 /* KeyCode.BracketLeft */ ,
                mac: {
                    primary: 2652 /* KeyCode.BracketLeft */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: "Fold the content in the editor",
                args: [
                    {
                        name: "Fold editor argument",
                        description: `Property-value pairs that can be passed through this argument:
							* 'levels': Number of levels to fold.
							* 'direction': If 'up', folds given number of levels up otherwise folds down.
							* 'selectionLines': Array of the start lines (0-based) of the editor selections to apply the fold action to. If not set, the active selection(s) will be used.
							If no levels or direction is set, folds the region at the locations or if already collapsed, the first uncollapsed parent instead.
						`,
                        constraint: foldingArgumentsConstraint,
                        schema: {
                            "type": "object",
                            "properties": {
                                "levels": {
                                    "type": "number"
                                },
                                "direction": {
                                    "type": "string",
                                    "enum": [
                                        "up",
                                        "down"
                                    ]
                                },
                                "selectionLines": {
                                    "type": "array",
                                    "items": {
                                        "type": "number"
                                    }
                                }
                            }
                        }
                    }
                ]
            }
        });
    }
    invoke(_foldingController, foldingModel, editor, args) {
        const lineNumbers = this.getLineNumbers(args, editor);
        const levels = args && args.levels;
        const direction = args && args.direction;
        if (typeof levels !== "number" && typeof direction !== "string") // fold the region at the location or if already collapsed, the first uncollapsed parent instead.
        (0, _foldingModelJs.setCollapseStateUp)(foldingModel, true, lineNumbers);
        else if (direction === "up") (0, _foldingModelJs.setCollapseStateLevelsUp)(foldingModel, true, levels || 1, lineNumbers);
        else (0, _foldingModelJs.setCollapseStateLevelsDown)(foldingModel, true, levels || 1, lineNumbers);
    }
}
class ToggleFoldAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.toggleFold",
            label: _nlsJs.localize("toggleFoldAction.label", "Toggle Fold"),
            alias: "Toggle Fold",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2090 /* KeyCode.KeyL */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor) {
        const selectedLines = this.getSelectedLines(editor);
        (0, _foldingModelJs.toggleCollapseState)(foldingModel, 1, selectedLines);
    }
}
class FoldRecursivelyAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.foldRecursively",
            label: _nlsJs.localize("foldRecursivelyAction.label", "Fold Recursively"),
            alias: "Fold Recursively",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2140 /* KeyCode.BracketLeft */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor) {
        const selectedLines = this.getSelectedLines(editor);
        (0, _foldingModelJs.setCollapseStateLevelsDown)(foldingModel, true, Number.MAX_VALUE, selectedLines);
    }
}
class ToggleFoldRecursivelyAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.toggleFoldRecursively",
            label: _nlsJs.localize("toggleFoldRecursivelyAction.label", "Toggle Fold Recursively"),
            alias: "Toggle Fold Recursively",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 3114 /* KeyCode.KeyL */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor) {
        const selectedLines = this.getSelectedLines(editor);
        (0, _foldingModelJs.toggleCollapseState)(foldingModel, Number.MAX_VALUE, selectedLines);
    }
}
class FoldAllBlockCommentsAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.foldAllBlockComments",
            label: _nlsJs.localize("foldAllBlockComments.label", "Fold All Block Comments"),
            alias: "Fold All Block Comments",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2138 /* KeyCode.Slash */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor, args, languageConfigurationService) {
        if (foldingModel.regions.hasTypes()) (0, _foldingModelJs.setCollapseStateForType)(foldingModel, (0, _languagesJs.FoldingRangeKind).Comment.value, true);
        else {
            const editorModel = editor.getModel();
            if (!editorModel) return;
            const comments = languageConfigurationService.getLanguageConfiguration(editorModel.getLanguageId()).comments;
            if (comments && comments.blockCommentStartToken) {
                const regExp = new RegExp("^\\s*" + (0, _stringsJs.escapeRegExpCharacters)(comments.blockCommentStartToken));
                (0, _foldingModelJs.setCollapseStateForMatchingLines)(foldingModel, regExp, true);
            }
        }
    }
}
class FoldAllRegionsAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.foldAllMarkerRegions",
            label: _nlsJs.localize("foldAllMarkerRegions.label", "Fold All Regions"),
            alias: "Fold All Regions",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2077 /* KeyCode.Digit8 */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor, args, languageConfigurationService) {
        if (foldingModel.regions.hasTypes()) (0, _foldingModelJs.setCollapseStateForType)(foldingModel, (0, _languagesJs.FoldingRangeKind).Region.value, true);
        else {
            const editorModel = editor.getModel();
            if (!editorModel) return;
            const foldingRules = languageConfigurationService.getLanguageConfiguration(editorModel.getLanguageId()).foldingRules;
            if (foldingRules && foldingRules.markers && foldingRules.markers.start) {
                const regExp = new RegExp(foldingRules.markers.start);
                (0, _foldingModelJs.setCollapseStateForMatchingLines)(foldingModel, regExp, true);
            }
        }
    }
}
class UnfoldAllRegionsAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.unfoldAllMarkerRegions",
            label: _nlsJs.localize("unfoldAllMarkerRegions.label", "Unfold All Regions"),
            alias: "Unfold All Regions",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2078 /* KeyCode.Digit9 */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor, args, languageConfigurationService) {
        if (foldingModel.regions.hasTypes()) (0, _foldingModelJs.setCollapseStateForType)(foldingModel, (0, _languagesJs.FoldingRangeKind).Region.value, false);
        else {
            const editorModel = editor.getModel();
            if (!editorModel) return;
            const foldingRules = languageConfigurationService.getLanguageConfiguration(editorModel.getLanguageId()).foldingRules;
            if (foldingRules && foldingRules.markers && foldingRules.markers.start) {
                const regExp = new RegExp(foldingRules.markers.start);
                (0, _foldingModelJs.setCollapseStateForMatchingLines)(foldingModel, regExp, false);
            }
        }
    }
}
class FoldAllExceptAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.foldAllExcept",
            label: _nlsJs.localize("foldAllExcept.label", "Fold All Except Selected"),
            alias: "Fold All Except Selected",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2136 /* KeyCode.Minus */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor) {
        const selectedLines = this.getSelectedLines(editor);
        (0, _foldingModelJs.setCollapseStateForRest)(foldingModel, true, selectedLines);
    }
}
class UnfoldAllExceptAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.unfoldAllExcept",
            label: _nlsJs.localize("unfoldAllExcept.label", "Unfold All Except Selected"),
            alias: "Unfold All Except Selected",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2134 /* KeyCode.Equal */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor) {
        const selectedLines = this.getSelectedLines(editor);
        (0, _foldingModelJs.setCollapseStateForRest)(foldingModel, false, selectedLines);
    }
}
class FoldAllAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.foldAll",
            label: _nlsJs.localize("foldAllAction.label", "Fold All"),
            alias: "Fold All",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2069 /* KeyCode.Digit0 */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, _editor) {
        (0, _foldingModelJs.setCollapseStateLevelsDown)(foldingModel, true);
    }
}
class UnfoldAllAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.unfoldAll",
            label: _nlsJs.localize("unfoldAllAction.label", "Unfold All"),
            alias: "Unfold All",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2088 /* KeyCode.KeyJ */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, _editor) {
        (0, _foldingModelJs.setCollapseStateLevelsDown)(foldingModel, false);
    }
}
class FoldLevelAction extends FoldingAction {
    static{
        this.ID_PREFIX = "editor.foldLevel";
    }
    static{
        this.ID = (level)=>FoldLevelAction.ID_PREFIX + level;
    }
    getFoldingLevel() {
        return parseInt(this.id.substr(FoldLevelAction.ID_PREFIX.length));
    }
    invoke(_foldingController, foldingModel, editor) {
        (0, _foldingModelJs.setCollapseStateAtLevel)(foldingModel, this.getFoldingLevel(), true, this.getSelectedLines(editor));
    }
}
/** Action to go to the parent fold of current line */ class GotoParentFoldAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.gotoParentFold",
            label: _nlsJs.localize("gotoParentFold.label", "Go to Parent Fold"),
            alias: "Go to Parent Fold",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor) {
        const selectedLines = this.getSelectedLines(editor);
        if (selectedLines.length > 0) {
            const startLineNumber = (0, _foldingModelJs.getParentFoldLine)(selectedLines[0], foldingModel);
            if (startLineNumber !== null) editor.setSelection({
                startLineNumber: startLineNumber,
                startColumn: 1,
                endLineNumber: startLineNumber,
                endColumn: 1
            });
        }
    }
}
/** Action to go to the previous fold of current line */ class GotoPreviousFoldAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.gotoPreviousFold",
            label: _nlsJs.localize("gotoPreviousFold.label", "Go to Previous Folding Range"),
            alias: "Go to Previous Folding Range",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor) {
        const selectedLines = this.getSelectedLines(editor);
        if (selectedLines.length > 0) {
            const startLineNumber = (0, _foldingModelJs.getPreviousFoldLine)(selectedLines[0], foldingModel);
            if (startLineNumber !== null) editor.setSelection({
                startLineNumber: startLineNumber,
                startColumn: 1,
                endLineNumber: startLineNumber,
                endColumn: 1
            });
        }
    }
}
/** Action to go to the next fold of current line */ class GotoNextFoldAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.gotoNextFold",
            label: _nlsJs.localize("gotoNextFold.label", "Go to Next Folding Range"),
            alias: "Go to Next Folding Range",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor) {
        const selectedLines = this.getSelectedLines(editor);
        if (selectedLines.length > 0) {
            const startLineNumber = (0, _foldingModelJs.getNextFoldLine)(selectedLines[0], foldingModel);
            if (startLineNumber !== null) editor.setSelection({
                startLineNumber: startLineNumber,
                startColumn: 1,
                endLineNumber: startLineNumber,
                endColumn: 1
            });
        }
    }
}
class FoldRangeFromSelectionAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.createFoldingRangeFromSelection",
            label: _nlsJs.localize("createManualFoldRange.label", "Create Folding Range from Selection"),
            alias: "Create Folding Range from Selection",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2135 /* KeyCode.Comma */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(_foldingController, foldingModel, editor) {
        const collapseRanges = [];
        const selections = editor.getSelections();
        if (selections) {
            for (const selection of selections){
                let endLineNumber = selection.endLineNumber;
                if (selection.endColumn === 1) --endLineNumber;
                if (endLineNumber > selection.startLineNumber) {
                    collapseRanges.push({
                        startLineNumber: selection.startLineNumber,
                        endLineNumber: endLineNumber,
                        type: undefined,
                        isCollapsed: true,
                        source: 1 /* FoldSource.userDefined */ 
                    });
                    editor.setSelection({
                        startLineNumber: selection.startLineNumber,
                        startColumn: 1,
                        endLineNumber: selection.startLineNumber,
                        endColumn: 1
                    });
                }
            }
            if (collapseRanges.length > 0) {
                collapseRanges.sort((a, b)=>{
                    return a.startLineNumber - b.startLineNumber;
                });
                const newRanges = (0, _foldingRangesJs.FoldingRegions).sanitizeAndMerge(foldingModel.regions, collapseRanges, editor.getModel()?.getLineCount());
                foldingModel.updatePost((0, _foldingRangesJs.FoldingRegions).fromFoldRanges(newRanges));
            }
        }
    }
}
class RemoveFoldRangeFromSelectionAction extends FoldingAction {
    constructor(){
        super({
            id: "editor.removeManualFoldingRanges",
            label: _nlsJs.localize("removeManualFoldingRanges.label", "Remove Manual Folding Ranges"),
            alias: "Remove Manual Folding Ranges",
            precondition: CONTEXT_FOLDING_ENABLED,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2137 /* KeyCode.Period */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    invoke(foldingController, foldingModel, editor) {
        const selections = editor.getSelections();
        if (selections) {
            const ranges = [];
            for (const selection of selections){
                const { startLineNumber, endLineNumber } = selection;
                ranges.push(endLineNumber >= startLineNumber ? {
                    startLineNumber,
                    endLineNumber
                } : {
                    endLineNumber,
                    startLineNumber
                });
            }
            foldingModel.removeManualRanges(ranges);
            foldingController.triggerFoldingModelChanged();
        }
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(FoldingController.ID, FoldingController, 0 /* EditorContributionInstantiation.Eager */ ); // eager because it uses `saveViewState`/`restoreViewState`
(0, _editorExtensionsJs.registerEditorAction)(UnfoldAction);
(0, _editorExtensionsJs.registerEditorAction)(UnFoldRecursivelyAction);
(0, _editorExtensionsJs.registerEditorAction)(FoldAction);
(0, _editorExtensionsJs.registerEditorAction)(FoldRecursivelyAction);
(0, _editorExtensionsJs.registerEditorAction)(ToggleFoldRecursivelyAction);
(0, _editorExtensionsJs.registerEditorAction)(FoldAllAction);
(0, _editorExtensionsJs.registerEditorAction)(UnfoldAllAction);
(0, _editorExtensionsJs.registerEditorAction)(FoldAllBlockCommentsAction);
(0, _editorExtensionsJs.registerEditorAction)(FoldAllRegionsAction);
(0, _editorExtensionsJs.registerEditorAction)(UnfoldAllRegionsAction);
(0, _editorExtensionsJs.registerEditorAction)(FoldAllExceptAction);
(0, _editorExtensionsJs.registerEditorAction)(UnfoldAllExceptAction);
(0, _editorExtensionsJs.registerEditorAction)(ToggleFoldAction);
(0, _editorExtensionsJs.registerEditorAction)(GotoParentFoldAction);
(0, _editorExtensionsJs.registerEditorAction)(GotoPreviousFoldAction);
(0, _editorExtensionsJs.registerEditorAction)(GotoNextFoldAction);
(0, _editorExtensionsJs.registerEditorAction)(FoldRangeFromSelectionAction);
(0, _editorExtensionsJs.registerEditorAction)(RemoveFoldRangeFromSelectionAction);
for(let i = 1; i <= 7; i++)(0, _editorExtensionsJs.registerInstantiatedEditorAction)(new FoldLevelAction({
    id: FoldLevelAction.ID(i),
    label: _nlsJs.localize("foldLevelAction.label", "Fold Level {0}", i),
    alias: `Fold Level ${i}`,
    precondition: CONTEXT_FOLDING_ENABLED,
    kbOpts: {
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
        primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2048 /* KeyMod.CtrlCmd */  | 21 /* KeyCode.Digit0 */  + i),
        weight: 100 /* KeybindingWeight.EditorContrib */ 
    }
}));
(0, _commandsJs.CommandsRegistry).registerCommand("_executeFoldingRangeProvider", async function(accessor, ...args) {
    const [resource] = args;
    if (!(resource instanceof (0, _uriJs.URI))) throw (0, _errorsJs.illegalArgument)();
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const model = accessor.get((0, _modelJs.IModelService)).getModel(resource);
    if (!model) throw (0, _errorsJs.illegalArgument)();
    const configurationService = accessor.get((0, _configurationJs.IConfigurationService));
    if (!configurationService.getValue("editor.folding", {
        resource
    })) return [];
    const languageConfigurationService = accessor.get((0, _languageConfigurationRegistryJs.ILanguageConfigurationService));
    const strategy = configurationService.getValue("editor.foldingStrategy", {
        resource
    });
    const foldingLimitReporter = {
        get limit () {
            return configurationService.getValue("editor.foldingMaximumRegions", {
                resource
            });
        },
        update: (computed, limited)=>{}
    };
    const indentRangeProvider = new (0, _indentRangeProviderJs.IndentRangeProvider)(model, languageConfigurationService, foldingLimitReporter);
    let rangeProvider = indentRangeProvider;
    if (strategy !== "indentation") {
        const providers = FoldingController.getFoldingRangeProviders(languageFeaturesService, model);
        if (providers.length) rangeProvider = new (0, _syntaxRangeProviderJs.SyntaxRangeProvider)(model, providers, ()=>{}, foldingLimitReporter, indentRangeProvider);
    }
    const ranges = await rangeProvider.compute((0, _cancellationJs.CancellationToken).None);
    const result = [];
    try {
        if (ranges) for(let i = 0; i < ranges.length; i++){
            const type = ranges.getType(i);
            result.push({
                start: ranges.getStartLineNumber(i),
                end: ranges.getEndLineNumber(i),
                kind: type ? (0, _languagesJs.FoldingRangeKind).fromValue(type) : undefined
            });
        }
        return result;
    } finally{
        rangeProvider.dispose();
    }
});

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/keyCodes.js":"bHiG9","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/strings.js":"aA9I1","../../../../base/common/types.js":"fb5yx","./folding.css":"85JCL","../../../browser/stableEditorScroll.js":"5Bh72","../../../browser/editorExtensions.js":"kC3w6","../../../common/editorContextKeys.js":"5exv9","../../../common/languages.js":"g5n96","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","./foldingModel.js":"fivpl","./hiddenRangeModel.js":"tQzKm","./indentRangeProvider.js":"c5EBp","../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","./foldingDecorations.js":"aCgT6","./foldingRanges.js":"gpQdF","./syntaxRangeProvider.js":"eOdXK","../../../../platform/notification/common/notification.js":"igv0W","../../../common/services/languageFeatureDebounce.js":"YGXXG","../../../../base/common/stopwatch.js":"77PF9","../../../common/services/languageFeatures.js":"2IAko","../../../../base/common/event.js":"4Zi8b","../../../../platform/commands/common/commands.js":"ho6ic","../../../../base/common/uri.js":"7qGS3","../../../common/services/model.js":"aciVm","../../../../platform/configuration/common/configuration.js":"dXkjq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"85JCL":[function() {},{}],"fivpl":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FoldingModel", ()=>FoldingModel);
/**
 * Collapse or expand the regions at the given locations
 * @param levels The number of levels. Use 1 to only impact the regions at the location, use Number.MAX_VALUE for all levels.
 * @param lineNumbers the location of the regions to collapse or expand, or if not set, all regions in the model.
 */ parcelHelpers.export(exports, "toggleCollapseState", ()=>toggleCollapseState);
/**
 * Collapse or expand the regions at the given locations including all children.
 * @param doCollapse Whether to collapse or expand
 * @param levels The number of levels. Use 1 to only impact the regions at the location, use Number.MAX_VALUE for all levels.
 * @param lineNumbers the location of the regions to collapse or expand, or if not set, all regions in the model.
 */ parcelHelpers.export(exports, "setCollapseStateLevelsDown", ()=>setCollapseStateLevelsDown);
/**
 * Collapse or expand the regions at the given locations including all parents.
 * @param doCollapse Whether to collapse or expand
 * @param levels The number of levels. Use 1 to only impact the regions at the location, use Number.MAX_VALUE for all levels.
 * @param lineNumbers the location of the regions to collapse or expand.
 */ parcelHelpers.export(exports, "setCollapseStateLevelsUp", ()=>setCollapseStateLevelsUp);
/**
 * Collapse or expand a region at the given locations. If the inner most region is already collapsed/expanded, uses the first parent instead.
 * @param doCollapse Whether to collapse or expand
 * @param lineNumbers the location of the regions to collapse or expand.
 */ parcelHelpers.export(exports, "setCollapseStateUp", ()=>setCollapseStateUp);
/**
 * Folds or unfolds all regions that have a given level, except if they contain one of the blocked lines.
 * @param foldLevel level. Level == 1 is the top level
 * @param doCollapse Whether to collapse or expand
*/ parcelHelpers.export(exports, "setCollapseStateAtLevel", ()=>setCollapseStateAtLevel);
/**
 * Folds or unfolds all regions, except if they contain or are contained by a region of one of the blocked lines.
 * @param doCollapse Whether to collapse or expand
 * @param blockedLineNumbers the location of regions to not collapse or expand
 */ parcelHelpers.export(exports, "setCollapseStateForRest", ()=>setCollapseStateForRest);
/**
 * Folds all regions for which the lines start with a given regex
 * @param foldingModel the folding model
 */ parcelHelpers.export(exports, "setCollapseStateForMatchingLines", ()=>setCollapseStateForMatchingLines);
/**
 * Folds all regions of the given type
 * @param foldingModel the folding model
 */ parcelHelpers.export(exports, "setCollapseStateForType", ()=>setCollapseStateForType);
/**
 * Get line to go to for parent fold of current line
 * @param lineNumber the current line number
 * @param foldingModel the folding model
 *
 * @return Parent fold start line
 */ parcelHelpers.export(exports, "getParentFoldLine", ()=>getParentFoldLine);
/**
 * Get line to go to for previous fold at the same level of current line
 * @param lineNumber the current line number
 * @param foldingModel the folding model
 *
 * @return Previous fold start line
 */ parcelHelpers.export(exports, "getPreviousFoldLine", ()=>getPreviousFoldLine);
/**
 * Get line to go to next fold at the same level of current line
 * @param lineNumber the current line number
 * @param foldingModel the folding model
 *
 * @return Next fold start line
 */ parcelHelpers.export(exports, "getNextFoldLine", ()=>getNextFoldLine);
var _eventJs = require("../../../../base/common/event.js");
var _foldingRangesJs = require("./foldingRanges.js");
var _hashJs = require("../../../../base/common/hash.js");
class FoldingModel {
    get regions() {
        return this._regions;
    }
    get textModel() {
        return this._textModel;
    }
    constructor(textModel, decorationProvider){
        this._updateEventEmitter = new (0, _eventJs.Emitter)();
        this.onDidChange = this._updateEventEmitter.event;
        this._textModel = textModel;
        this._decorationProvider = decorationProvider;
        this._regions = new (0, _foldingRangesJs.FoldingRegions)(new Uint32Array(0), new Uint32Array(0));
        this._editorDecorationIds = [];
    }
    toggleCollapseState(toggledRegions) {
        if (!toggledRegions.length) return;
        toggledRegions = toggledRegions.sort((r1, r2)=>r1.regionIndex - r2.regionIndex);
        const processed = {};
        this._decorationProvider.changeDecorations((accessor)=>{
            let k = 0; // index from [0 ... this.regions.length]
            let dirtyRegionEndLine = -1; // end of the range where decorations need to be updated
            let lastHiddenLine = -1; // the end of the last hidden lines
            const updateDecorationsUntil = (index)=>{
                while(k < index){
                    const endLineNumber = this._regions.getEndLineNumber(k);
                    const isCollapsed = this._regions.isCollapsed(k);
                    if (endLineNumber <= dirtyRegionEndLine) {
                        const isManual = this.regions.getSource(k) !== 0 /* FoldSource.provider */ ;
                        accessor.changeDecorationOptions(this._editorDecorationIds[k], this._decorationProvider.getDecorationOption(isCollapsed, endLineNumber <= lastHiddenLine, isManual));
                    }
                    if (isCollapsed && endLineNumber > lastHiddenLine) lastHiddenLine = endLineNumber;
                    k++;
                }
            };
            for (const region of toggledRegions){
                const index = region.regionIndex;
                const editorDecorationId = this._editorDecorationIds[index];
                if (editorDecorationId && !processed[editorDecorationId]) {
                    processed[editorDecorationId] = true;
                    updateDecorationsUntil(index); // update all decorations up to current index using the old dirtyRegionEndLine
                    const newCollapseState = !this._regions.isCollapsed(index);
                    this._regions.setCollapsed(index, newCollapseState);
                    dirtyRegionEndLine = Math.max(dirtyRegionEndLine, this._regions.getEndLineNumber(index));
                }
            }
            updateDecorationsUntil(this._regions.length);
        });
        this._updateEventEmitter.fire({
            model: this,
            collapseStateChanged: toggledRegions
        });
    }
    removeManualRanges(ranges) {
        const newFoldingRanges = new Array();
        const intersects = (foldRange)=>{
            for (const range of ranges){
                if (!(range.startLineNumber > foldRange.endLineNumber || foldRange.startLineNumber > range.endLineNumber)) return true;
            }
            return false;
        };
        for(let i = 0; i < this._regions.length; i++){
            const foldRange = this._regions.toFoldRange(i);
            if (foldRange.source === 0 /* FoldSource.provider */  || !intersects(foldRange)) newFoldingRanges.push(foldRange);
        }
        this.updatePost((0, _foldingRangesJs.FoldingRegions).fromFoldRanges(newFoldingRanges));
    }
    update(newRegions, selection) {
        const foldedOrManualRanges = this._currentFoldedOrManualRanges(selection);
        const newRanges = (0, _foldingRangesJs.FoldingRegions).sanitizeAndMerge(newRegions, foldedOrManualRanges, this._textModel.getLineCount(), selection);
        this.updatePost((0, _foldingRangesJs.FoldingRegions).fromFoldRanges(newRanges));
    }
    updatePost(newRegions) {
        const newEditorDecorations = [];
        let lastHiddenLine = -1;
        for(let index = 0, limit = newRegions.length; index < limit; index++){
            const startLineNumber = newRegions.getStartLineNumber(index);
            const endLineNumber = newRegions.getEndLineNumber(index);
            const isCollapsed = newRegions.isCollapsed(index);
            const isManual = newRegions.getSource(index) !== 0 /* FoldSource.provider */ ;
            const decorationRange = {
                startLineNumber: startLineNumber,
                startColumn: this._textModel.getLineMaxColumn(startLineNumber),
                endLineNumber: endLineNumber,
                endColumn: this._textModel.getLineMaxColumn(endLineNumber) + 1
            };
            newEditorDecorations.push({
                range: decorationRange,
                options: this._decorationProvider.getDecorationOption(isCollapsed, endLineNumber <= lastHiddenLine, isManual)
            });
            if (isCollapsed && endLineNumber > lastHiddenLine) lastHiddenLine = endLineNumber;
        }
        this._decorationProvider.changeDecorations((accessor)=>this._editorDecorationIds = accessor.deltaDecorations(this._editorDecorationIds, newEditorDecorations));
        this._regions = newRegions;
        this._updateEventEmitter.fire({
            model: this
        });
    }
    _currentFoldedOrManualRanges(selection) {
        const foldedRanges = [];
        for(let i = 0, limit = this._regions.length; i < limit; i++){
            let isCollapsed = this.regions.isCollapsed(i);
            const source = this.regions.getSource(i);
            if (isCollapsed || source !== 0 /* FoldSource.provider */ ) {
                const foldRange = this._regions.toFoldRange(i);
                const decRange = this._textModel.getDecorationRange(this._editorDecorationIds[i]);
                if (decRange) {
                    if (isCollapsed && selection?.startsInside(decRange.startLineNumber + 1, decRange.endLineNumber)) isCollapsed = false; // uncollapse is the range is blocked
                    foldedRanges.push({
                        startLineNumber: decRange.startLineNumber,
                        endLineNumber: decRange.endLineNumber,
                        type: foldRange.type,
                        isCollapsed,
                        source
                    });
                }
            }
        }
        return foldedRanges;
    }
    /**
     * Collapse state memento, for persistence only
     */ getMemento() {
        const foldedOrManualRanges = this._currentFoldedOrManualRanges();
        const result = [];
        const maxLineNumber = this._textModel.getLineCount();
        for(let i = 0, limit = foldedOrManualRanges.length; i < limit; i++){
            const range = foldedOrManualRanges[i];
            if (range.startLineNumber >= range.endLineNumber || range.startLineNumber < 1 || range.endLineNumber > maxLineNumber) continue;
            const checksum = this._getLinesChecksum(range.startLineNumber + 1, range.endLineNumber);
            result.push({
                startLineNumber: range.startLineNumber,
                endLineNumber: range.endLineNumber,
                isCollapsed: range.isCollapsed,
                source: range.source,
                checksum: checksum
            });
        }
        return result.length > 0 ? result : undefined;
    }
    /**
     * Apply persisted state, for persistence only
     */ applyMemento(state) {
        if (!Array.isArray(state)) return;
        const rangesToRestore = [];
        const maxLineNumber = this._textModel.getLineCount();
        for (const range of state){
            if (range.startLineNumber >= range.endLineNumber || range.startLineNumber < 1 || range.endLineNumber > maxLineNumber) continue;
            const checksum = this._getLinesChecksum(range.startLineNumber + 1, range.endLineNumber);
            if (!range.checksum || checksum === range.checksum) rangesToRestore.push({
                startLineNumber: range.startLineNumber,
                endLineNumber: range.endLineNumber,
                type: undefined,
                isCollapsed: range.isCollapsed ?? true,
                source: range.source ?? 0 /* FoldSource.provider */ 
            });
        }
        const newRanges = (0, _foldingRangesJs.FoldingRegions).sanitizeAndMerge(this._regions, rangesToRestore, maxLineNumber);
        this.updatePost((0, _foldingRangesJs.FoldingRegions).fromFoldRanges(newRanges));
    }
    _getLinesChecksum(lineNumber1, lineNumber2) {
        const h = (0, _hashJs.hash)(this._textModel.getLineContent(lineNumber1) + this._textModel.getLineContent(lineNumber2));
        return h % 1000000; // 6 digits is plenty
    }
    dispose() {
        this._decorationProvider.removeDecorations(this._editorDecorationIds);
    }
    getAllRegionsAtLine(lineNumber, filter) {
        const result = [];
        if (this._regions) {
            let index = this._regions.findRange(lineNumber);
            let level = 1;
            while(index >= 0){
                const current = this._regions.toRegion(index);
                if (!filter || filter(current, level)) result.push(current);
                level++;
                index = current.parentIndex;
            }
        }
        return result;
    }
    getRegionAtLine(lineNumber) {
        if (this._regions) {
            const index = this._regions.findRange(lineNumber);
            if (index >= 0) return this._regions.toRegion(index);
        }
        return null;
    }
    getRegionsInside(region, filter) {
        const result = [];
        const index = region ? region.regionIndex + 1 : 0;
        const endLineNumber = region ? region.endLineNumber : Number.MAX_VALUE;
        if (filter && filter.length === 2) {
            const levelStack = [];
            for(let i = index, len = this._regions.length; i < len; i++){
                const current = this._regions.toRegion(i);
                if (this._regions.getStartLineNumber(i) < endLineNumber) {
                    while(levelStack.length > 0 && !current.containedBy(levelStack[levelStack.length - 1]))levelStack.pop();
                    levelStack.push(current);
                    if (filter(current, levelStack.length)) result.push(current);
                } else break;
            }
        } else for(let i = index, len = this._regions.length; i < len; i++){
            const current = this._regions.toRegion(i);
            if (this._regions.getStartLineNumber(i) < endLineNumber) {
                if (!filter || filter(current)) result.push(current);
            } else break;
        }
        return result;
    }
}
function toggleCollapseState(foldingModel, levels, lineNumbers) {
    const toToggle = [];
    for (const lineNumber of lineNumbers){
        const region = foldingModel.getRegionAtLine(lineNumber);
        if (region) {
            const doCollapse = !region.isCollapsed;
            toToggle.push(region);
            if (levels > 1) {
                const regionsInside = foldingModel.getRegionsInside(region, (r, level)=>r.isCollapsed !== doCollapse && level < levels);
                toToggle.push(...regionsInside);
            }
        }
    }
    foldingModel.toggleCollapseState(toToggle);
}
function setCollapseStateLevelsDown(foldingModel, doCollapse, levels = Number.MAX_VALUE, lineNumbers) {
    const toToggle = [];
    if (lineNumbers && lineNumbers.length > 0) for (const lineNumber of lineNumbers){
        const region = foldingModel.getRegionAtLine(lineNumber);
        if (region) {
            if (region.isCollapsed !== doCollapse) toToggle.push(region);
            if (levels > 1) {
                const regionsInside = foldingModel.getRegionsInside(region, (r, level)=>r.isCollapsed !== doCollapse && level < levels);
                toToggle.push(...regionsInside);
            }
        }
    }
    else {
        const regionsInside = foldingModel.getRegionsInside(null, (r, level)=>r.isCollapsed !== doCollapse && level < levels);
        toToggle.push(...regionsInside);
    }
    foldingModel.toggleCollapseState(toToggle);
}
function setCollapseStateLevelsUp(foldingModel, doCollapse, levels, lineNumbers) {
    const toToggle = [];
    for (const lineNumber of lineNumbers){
        const regions = foldingModel.getAllRegionsAtLine(lineNumber, (region, level)=>region.isCollapsed !== doCollapse && level <= levels);
        toToggle.push(...regions);
    }
    foldingModel.toggleCollapseState(toToggle);
}
function setCollapseStateUp(foldingModel, doCollapse, lineNumbers) {
    const toToggle = [];
    for (const lineNumber of lineNumbers){
        const regions = foldingModel.getAllRegionsAtLine(lineNumber, (region)=>region.isCollapsed !== doCollapse);
        if (regions.length > 0) toToggle.push(regions[0]);
    }
    foldingModel.toggleCollapseState(toToggle);
}
function setCollapseStateAtLevel(foldingModel, foldLevel, doCollapse, blockedLineNumbers) {
    const filter = (region, level)=>level === foldLevel && region.isCollapsed !== doCollapse && !blockedLineNumbers.some((line)=>region.containsLine(line));
    const toToggle = foldingModel.getRegionsInside(null, filter);
    foldingModel.toggleCollapseState(toToggle);
}
function setCollapseStateForRest(foldingModel, doCollapse, blockedLineNumbers) {
    const filteredRegions = [];
    for (const lineNumber of blockedLineNumbers){
        const regions = foldingModel.getAllRegionsAtLine(lineNumber, undefined);
        if (regions.length > 0) filteredRegions.push(regions[0]);
    }
    const filter = (region)=>filteredRegions.every((filteredRegion)=>!filteredRegion.containedBy(region) && !region.containedBy(filteredRegion)) && region.isCollapsed !== doCollapse;
    const toToggle = foldingModel.getRegionsInside(null, filter);
    foldingModel.toggleCollapseState(toToggle);
}
function setCollapseStateForMatchingLines(foldingModel, regExp, doCollapse) {
    const editorModel = foldingModel.textModel;
    const regions = foldingModel.regions;
    const toToggle = [];
    for(let i = regions.length - 1; i >= 0; i--)if (doCollapse !== regions.isCollapsed(i)) {
        const startLineNumber = regions.getStartLineNumber(i);
        if (regExp.test(editorModel.getLineContent(startLineNumber))) toToggle.push(regions.toRegion(i));
    }
    foldingModel.toggleCollapseState(toToggle);
}
function setCollapseStateForType(foldingModel, type, doCollapse) {
    const regions = foldingModel.regions;
    const toToggle = [];
    for(let i = regions.length - 1; i >= 0; i--)if (doCollapse !== regions.isCollapsed(i) && type === regions.getType(i)) toToggle.push(regions.toRegion(i));
    foldingModel.toggleCollapseState(toToggle);
}
function getParentFoldLine(lineNumber, foldingModel) {
    let startLineNumber = null;
    const foldingRegion = foldingModel.getRegionAtLine(lineNumber);
    if (foldingRegion !== null) {
        startLineNumber = foldingRegion.startLineNumber;
        // If current line is not the start of the current fold, go to top line of current fold. If not, go to parent fold
        if (lineNumber === startLineNumber) {
            const parentFoldingIdx = foldingRegion.parentIndex;
            if (parentFoldingIdx !== -1) startLineNumber = foldingModel.regions.getStartLineNumber(parentFoldingIdx);
            else startLineNumber = null;
        }
    }
    return startLineNumber;
}
function getPreviousFoldLine(lineNumber, foldingModel) {
    let foldingRegion = foldingModel.getRegionAtLine(lineNumber);
    // If on the folding range start line, go to previous sibling.
    if (foldingRegion !== null && foldingRegion.startLineNumber === lineNumber) {
        // If current line is not the start of the current fold, go to top line of current fold. If not, go to previous fold.
        if (lineNumber !== foldingRegion.startLineNumber) return foldingRegion.startLineNumber;
        else {
            // Find min line number to stay within parent.
            const expectedParentIndex = foldingRegion.parentIndex;
            let minLineNumber = 0;
            if (expectedParentIndex !== -1) minLineNumber = foldingModel.regions.getStartLineNumber(foldingRegion.parentIndex);
            // Find fold at same level.
            while(foldingRegion !== null){
                if (foldingRegion.regionIndex > 0) {
                    foldingRegion = foldingModel.regions.toRegion(foldingRegion.regionIndex - 1);
                    // Keep at same level.
                    if (foldingRegion.startLineNumber <= minLineNumber) return null;
                    else if (foldingRegion.parentIndex === expectedParentIndex) return foldingRegion.startLineNumber;
                } else return null;
            }
        }
    } else // Go to last fold that's before the current line.
    if (foldingModel.regions.length > 0) {
        foldingRegion = foldingModel.regions.toRegion(foldingModel.regions.length - 1);
        while(foldingRegion !== null){
            // Found fold before current line.
            if (foldingRegion.startLineNumber < lineNumber) return foldingRegion.startLineNumber;
            if (foldingRegion.regionIndex > 0) foldingRegion = foldingModel.regions.toRegion(foldingRegion.regionIndex - 1);
            else foldingRegion = null;
        }
    }
    return null;
}
function getNextFoldLine(lineNumber, foldingModel) {
    let foldingRegion = foldingModel.getRegionAtLine(lineNumber);
    // If on the folding range start line, go to next sibling.
    if (foldingRegion !== null && foldingRegion.startLineNumber === lineNumber) {
        // Find max line number to stay within parent.
        const expectedParentIndex = foldingRegion.parentIndex;
        let maxLineNumber = 0;
        if (expectedParentIndex !== -1) maxLineNumber = foldingModel.regions.getEndLineNumber(foldingRegion.parentIndex);
        else if (foldingModel.regions.length === 0) return null;
        else maxLineNumber = foldingModel.regions.getEndLineNumber(foldingModel.regions.length - 1);
        // Find fold at same level.
        while(foldingRegion !== null){
            if (foldingRegion.regionIndex < foldingModel.regions.length) {
                foldingRegion = foldingModel.regions.toRegion(foldingRegion.regionIndex + 1);
                // Keep at same level.
                if (foldingRegion.startLineNumber >= maxLineNumber) return null;
                else if (foldingRegion.parentIndex === expectedParentIndex) return foldingRegion.startLineNumber;
            } else return null;
        }
    } else // Go to first fold that's after the current line.
    if (foldingModel.regions.length > 0) {
        foldingRegion = foldingModel.regions.toRegion(0);
        while(foldingRegion !== null){
            // Found fold after current line.
            if (foldingRegion.startLineNumber > lineNumber) return foldingRegion.startLineNumber;
            if (foldingRegion.regionIndex < foldingModel.regions.length) foldingRegion = foldingModel.regions.toRegion(foldingRegion.regionIndex + 1);
            else foldingRegion = null;
        }
    }
    return null;
}

},{"../../../../base/common/event.js":"4Zi8b","./foldingRanges.js":"gpQdF","../../../../base/common/hash.js":"hXc0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gpQdF":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "foldSourceAbbr", ()=>foldSourceAbbr);
parcelHelpers.export(exports, "MAX_FOLDING_REGIONS", ()=>MAX_FOLDING_REGIONS);
parcelHelpers.export(exports, "MAX_LINE_NUMBER", ()=>MAX_LINE_NUMBER);
parcelHelpers.export(exports, "FoldingRegions", ()=>FoldingRegions);
parcelHelpers.export(exports, "FoldingRegion", ()=>FoldingRegion);
const foldSourceAbbr = {
    [0 /* FoldSource.provider */ ]: " ",
    [1 /* FoldSource.userDefined */ ]: "u",
    [2 /* FoldSource.recovered */ ]: "r"
};
const MAX_FOLDING_REGIONS = 0xFFFF;
const MAX_LINE_NUMBER = 0xFFFFFF;
const MASK_INDENT = 0xFF000000;
class BitField {
    constructor(size){
        const numWords = Math.ceil(size / 32);
        this._states = new Uint32Array(numWords);
    }
    get(index) {
        const arrayIndex = index / 32 | 0;
        const bit = index % 32;
        return (this._states[arrayIndex] & 1 << bit) !== 0;
    }
    set(index, newState) {
        const arrayIndex = index / 32 | 0;
        const bit = index % 32;
        const value = this._states[arrayIndex];
        if (newState) this._states[arrayIndex] = value | 1 << bit;
        else this._states[arrayIndex] = value & ~(1 << bit);
    }
}
class FoldingRegions {
    constructor(startIndexes, endIndexes, types){
        if (startIndexes.length !== endIndexes.length || startIndexes.length > MAX_FOLDING_REGIONS) throw new Error("invalid startIndexes or endIndexes size");
        this._startIndexes = startIndexes;
        this._endIndexes = endIndexes;
        this._collapseStates = new BitField(startIndexes.length);
        this._userDefinedStates = new BitField(startIndexes.length);
        this._recoveredStates = new BitField(startIndexes.length);
        this._types = types;
        this._parentsComputed = false;
    }
    ensureParentIndices() {
        if (!this._parentsComputed) {
            this._parentsComputed = true;
            const parentIndexes = [];
            const isInsideLast = (startLineNumber, endLineNumber)=>{
                const index = parentIndexes[parentIndexes.length - 1];
                return this.getStartLineNumber(index) <= startLineNumber && this.getEndLineNumber(index) >= endLineNumber;
            };
            for(let i = 0, len = this._startIndexes.length; i < len; i++){
                const startLineNumber = this._startIndexes[i];
                const endLineNumber = this._endIndexes[i];
                if (startLineNumber > MAX_LINE_NUMBER || endLineNumber > MAX_LINE_NUMBER) throw new Error("startLineNumber or endLineNumber must not exceed " + MAX_LINE_NUMBER);
                while(parentIndexes.length > 0 && !isInsideLast(startLineNumber, endLineNumber))parentIndexes.pop();
                const parentIndex = parentIndexes.length > 0 ? parentIndexes[parentIndexes.length - 1] : -1;
                parentIndexes.push(i);
                this._startIndexes[i] = startLineNumber + ((parentIndex & 0xFF) << 24);
                this._endIndexes[i] = endLineNumber + ((parentIndex & 0xFF00) << 16);
            }
        }
    }
    get length() {
        return this._startIndexes.length;
    }
    getStartLineNumber(index) {
        return this._startIndexes[index] & MAX_LINE_NUMBER;
    }
    getEndLineNumber(index) {
        return this._endIndexes[index] & MAX_LINE_NUMBER;
    }
    getType(index) {
        return this._types ? this._types[index] : undefined;
    }
    hasTypes() {
        return !!this._types;
    }
    isCollapsed(index) {
        return this._collapseStates.get(index);
    }
    setCollapsed(index, newState) {
        this._collapseStates.set(index, newState);
    }
    isUserDefined(index) {
        return this._userDefinedStates.get(index);
    }
    setUserDefined(index, newState) {
        return this._userDefinedStates.set(index, newState);
    }
    isRecovered(index) {
        return this._recoveredStates.get(index);
    }
    setRecovered(index, newState) {
        return this._recoveredStates.set(index, newState);
    }
    getSource(index) {
        if (this.isUserDefined(index)) return 1 /* FoldSource.userDefined */ ;
        else if (this.isRecovered(index)) return 2 /* FoldSource.recovered */ ;
        return 0 /* FoldSource.provider */ ;
    }
    setSource(index, source) {
        if (source === 1 /* FoldSource.userDefined */ ) {
            this.setUserDefined(index, true);
            this.setRecovered(index, false);
        } else if (source === 2 /* FoldSource.recovered */ ) {
            this.setUserDefined(index, false);
            this.setRecovered(index, true);
        } else {
            this.setUserDefined(index, false);
            this.setRecovered(index, false);
        }
    }
    setCollapsedAllOfType(type, newState) {
        let hasChanged = false;
        if (this._types) {
            for(let i = 0; i < this._types.length; i++)if (this._types[i] === type) {
                this.setCollapsed(i, newState);
                hasChanged = true;
            }
        }
        return hasChanged;
    }
    toRegion(index) {
        return new FoldingRegion(this, index);
    }
    getParentIndex(index) {
        this.ensureParentIndices();
        const parent = ((this._startIndexes[index] & MASK_INDENT) >>> 24) + ((this._endIndexes[index] & MASK_INDENT) >>> 16);
        if (parent === MAX_FOLDING_REGIONS) return -1;
        return parent;
    }
    contains(index, line) {
        return this.getStartLineNumber(index) <= line && this.getEndLineNumber(index) >= line;
    }
    findIndex(line) {
        let low = 0, high = this._startIndexes.length;
        if (high === 0) return -1; // no children
        while(low < high){
            const mid = Math.floor((low + high) / 2);
            if (line < this.getStartLineNumber(mid)) high = mid;
            else low = mid + 1;
        }
        return low - 1;
    }
    findRange(line) {
        let index = this.findIndex(line);
        if (index >= 0) {
            const endLineNumber = this.getEndLineNumber(index);
            if (endLineNumber >= line) return index;
            index = this.getParentIndex(index);
            while(index !== -1){
                if (this.contains(index, line)) return index;
                index = this.getParentIndex(index);
            }
        }
        return -1;
    }
    toString() {
        const res = [];
        for(let i = 0; i < this.length; i++)res[i] = `[${foldSourceAbbr[this.getSource(i)]}${this.isCollapsed(i) ? "+" : "-"}] ${this.getStartLineNumber(i)}/${this.getEndLineNumber(i)}`;
        return res.join(", ");
    }
    toFoldRange(index) {
        return {
            startLineNumber: this._startIndexes[index] & MAX_LINE_NUMBER,
            endLineNumber: this._endIndexes[index] & MAX_LINE_NUMBER,
            type: this._types ? this._types[index] : undefined,
            isCollapsed: this.isCollapsed(index),
            source: this.getSource(index)
        };
    }
    static fromFoldRanges(ranges) {
        const rangesLength = ranges.length;
        const startIndexes = new Uint32Array(rangesLength);
        const endIndexes = new Uint32Array(rangesLength);
        let types = [];
        let gotTypes = false;
        for(let i = 0; i < rangesLength; i++){
            const range = ranges[i];
            startIndexes[i] = range.startLineNumber;
            endIndexes[i] = range.endLineNumber;
            types.push(range.type);
            if (range.type) gotTypes = true;
        }
        if (!gotTypes) types = undefined;
        const regions = new FoldingRegions(startIndexes, endIndexes, types);
        for(let i = 0; i < rangesLength; i++){
            if (ranges[i].isCollapsed) regions.setCollapsed(i, true);
            regions.setSource(i, ranges[i].source);
        }
        return regions;
    }
    /**
     * Two inputs, each a FoldingRegions or a FoldRange[], are merged.
     * Each input must be pre-sorted on startLineNumber.
     * The first list is assumed to always include all regions currently defined by range providers.
     * The second list only contains the previously collapsed and all manual ranges.
     * If the line position matches, the range of the new range is taken, and the range is no longer manual
     * When an entry in one list overlaps an entry in the other, the second list's entry "wins" and
     * overlapping entries in the first list are discarded.
     * Invalid entries are discarded. An entry is invalid if:
     * 		the start and end line numbers aren't a valid range of line numbers,
     * 		it is out of sequence or has the same start line as a preceding entry,
     * 		it overlaps a preceding entry and is not fully contained by that entry.
     */ static sanitizeAndMerge(rangesA, rangesB, maxLineNumber, selection) {
        maxLineNumber = maxLineNumber ?? Number.MAX_VALUE;
        const getIndexedFunction = (r, limit)=>{
            return Array.isArray(r) ? (i)=>{
                return i < limit ? r[i] : undefined;
            } : (i)=>{
                return i < limit ? r.toFoldRange(i) : undefined;
            };
        };
        const getA = getIndexedFunction(rangesA, rangesA.length);
        const getB = getIndexedFunction(rangesB, rangesB.length);
        let indexA = 0;
        let indexB = 0;
        let nextA = getA(0);
        let nextB = getB(0);
        const stackedRanges = [];
        let topStackedRange;
        let prevLineNumber = 0;
        const resultRanges = [];
        while(nextA || nextB){
            let useRange = undefined;
            if (nextB && (!nextA || nextA.startLineNumber >= nextB.startLineNumber)) {
                if (nextA && nextA.startLineNumber === nextB.startLineNumber) {
                    if (nextB.source === 1 /* FoldSource.userDefined */ ) // a user defined range (possibly unfolded)
                    useRange = nextB;
                    else {
                        // a previously folded range or a (possibly unfolded) recovered range
                        useRange = nextA;
                        // stays collapsed if the range still has the same number of lines or the selection is not in the range or after it
                        useRange.isCollapsed = nextB.isCollapsed && (nextA.endLineNumber === nextB.endLineNumber || !selection?.startsInside(nextA.startLineNumber + 1, nextA.endLineNumber + 1));
                        useRange.source = 0 /* FoldSource.provider */ ;
                    }
                    nextA = getA(++indexA); // not necessary, just for speed
                } else {
                    useRange = nextB;
                    if (nextB.isCollapsed && nextB.source === 0 /* FoldSource.provider */ ) // a previously collapsed range
                    useRange.source = 2 /* FoldSource.recovered */ ;
                }
                nextB = getB(++indexB);
            } else {
                // nextA is next. The user folded B set takes precedence and we sometimes need to look
                // ahead in it to check for an upcoming conflict.
                let scanIndex = indexB;
                let prescanB = nextB;
                while(true){
                    if (!prescanB || prescanB.startLineNumber > nextA.endLineNumber) {
                        useRange = nextA;
                        break; // no conflict, use this nextA
                    }
                    if (prescanB.source === 1 /* FoldSource.userDefined */  && prescanB.endLineNumber > nextA.endLineNumber) break; // without setting nextResult, so this nextA gets skipped
                    prescanB = getB(++scanIndex);
                }
                nextA = getA(++indexA);
            }
            if (useRange) {
                while(topStackedRange && topStackedRange.endLineNumber < useRange.startLineNumber)topStackedRange = stackedRanges.pop();
                if (useRange.endLineNumber > useRange.startLineNumber && useRange.startLineNumber > prevLineNumber && useRange.endLineNumber <= maxLineNumber && (!topStackedRange || topStackedRange.endLineNumber >= useRange.endLineNumber)) {
                    resultRanges.push(useRange);
                    prevLineNumber = useRange.startLineNumber;
                    if (topStackedRange) stackedRanges.push(topStackedRange);
                    topStackedRange = useRange;
                }
            }
        }
        return resultRanges;
    }
}
class FoldingRegion {
    constructor(ranges, index){
        this.ranges = ranges;
        this.index = index;
    }
    get startLineNumber() {
        return this.ranges.getStartLineNumber(this.index);
    }
    get endLineNumber() {
        return this.ranges.getEndLineNumber(this.index);
    }
    get regionIndex() {
        return this.index;
    }
    get parentIndex() {
        return this.ranges.getParentIndex(this.index);
    }
    get isCollapsed() {
        return this.ranges.isCollapsed(this.index);
    }
    containedBy(range) {
        return range.startLineNumber <= this.startLineNumber && range.endLineNumber >= this.endLineNumber;
    }
    containsLine(lineNumber) {
        return this.startLineNumber <= lineNumber && lineNumber <= this.endLineNumber;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"tQzKm":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HiddenRangeModel", ()=>HiddenRangeModel);
var _arraysFindJs = require("../../../../base/common/arraysFind.js");
var _eventJs = require("../../../../base/common/event.js");
var _rangeJs = require("../../../common/core/range.js");
var _eolCounterJs = require("../../../common/core/eolCounter.js");
class HiddenRangeModel {
    get onDidChange() {
        return this._updateEventEmitter.event;
    }
    get hiddenRanges() {
        return this._hiddenRanges;
    }
    constructor(model){
        this._updateEventEmitter = new (0, _eventJs.Emitter)();
        this._hasLineChanges = false;
        this._foldingModel = model;
        this._foldingModelListener = model.onDidChange((_)=>this.updateHiddenRanges());
        this._hiddenRanges = [];
        if (model.regions.length) this.updateHiddenRanges();
    }
    notifyChangeModelContent(e) {
        if (this._hiddenRanges.length && !this._hasLineChanges) this._hasLineChanges = e.changes.some((change)=>{
            return change.range.endLineNumber !== change.range.startLineNumber || (0, _eolCounterJs.countEOL)(change.text)[0] !== 0;
        });
    }
    updateHiddenRanges() {
        let updateHiddenAreas = false;
        const newHiddenAreas = [];
        let i = 0; // index into hidden
        let k = 0;
        let lastCollapsedStart = Number.MAX_VALUE;
        let lastCollapsedEnd = -1;
        const ranges = this._foldingModel.regions;
        for(; i < ranges.length; i++){
            if (!ranges.isCollapsed(i)) continue;
            const startLineNumber = ranges.getStartLineNumber(i) + 1; // the first line is not hidden
            const endLineNumber = ranges.getEndLineNumber(i);
            if (lastCollapsedStart <= startLineNumber && endLineNumber <= lastCollapsedEnd) continue;
            if (!updateHiddenAreas && k < this._hiddenRanges.length && this._hiddenRanges[k].startLineNumber === startLineNumber && this._hiddenRanges[k].endLineNumber === endLineNumber) {
                // reuse the old ranges
                newHiddenAreas.push(this._hiddenRanges[k]);
                k++;
            } else {
                updateHiddenAreas = true;
                newHiddenAreas.push(new (0, _rangeJs.Range)(startLineNumber, 1, endLineNumber, 1));
            }
            lastCollapsedStart = startLineNumber;
            lastCollapsedEnd = endLineNumber;
        }
        if (this._hasLineChanges || updateHiddenAreas || k < this._hiddenRanges.length) this.applyHiddenRanges(newHiddenAreas);
    }
    applyHiddenRanges(newHiddenAreas) {
        this._hiddenRanges = newHiddenAreas;
        this._hasLineChanges = false;
        this._updateEventEmitter.fire(newHiddenAreas);
    }
    hasRanges() {
        return this._hiddenRanges.length > 0;
    }
    isHidden(line) {
        return findRange(this._hiddenRanges, line) !== null;
    }
    adjustSelections(selections) {
        let hasChanges = false;
        const editorModel = this._foldingModel.textModel;
        let lastRange = null;
        const adjustLine = (line)=>{
            if (!lastRange || !isInside(line, lastRange)) lastRange = findRange(this._hiddenRanges, line);
            if (lastRange) return lastRange.startLineNumber - 1;
            return null;
        };
        for(let i = 0, len = selections.length; i < len; i++){
            let selection = selections[i];
            const adjustedStartLine = adjustLine(selection.startLineNumber);
            if (adjustedStartLine) {
                selection = selection.setStartPosition(adjustedStartLine, editorModel.getLineMaxColumn(adjustedStartLine));
                hasChanges = true;
            }
            const adjustedEndLine = adjustLine(selection.endLineNumber);
            if (adjustedEndLine) {
                selection = selection.setEndPosition(adjustedEndLine, editorModel.getLineMaxColumn(adjustedEndLine));
                hasChanges = true;
            }
            selections[i] = selection;
        }
        return hasChanges;
    }
    dispose() {
        if (this.hiddenRanges.length > 0) {
            this._hiddenRanges = [];
            this._updateEventEmitter.fire(this._hiddenRanges);
        }
        if (this._foldingModelListener) {
            this._foldingModelListener.dispose();
            this._foldingModelListener = null;
        }
    }
}
function isInside(line, range) {
    return line >= range.startLineNumber && line <= range.endLineNumber;
}
function findRange(ranges, line) {
    const i = (0, _arraysFindJs.findFirstIdxMonotonousOrArrLen)(ranges, (r)=>line < r.startLineNumber) - 1;
    if (i >= 0 && ranges[i].endLineNumber >= line) return ranges[i];
    return null;
}

},{"../../../../base/common/arraysFind.js":"gWrU0","../../../../base/common/event.js":"4Zi8b","../../../common/core/range.js":"jmUPh","../../../common/core/eolCounter.js":"4i42Y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c5EBp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IndentRangeProvider", ()=>IndentRangeProvider);
// public only for testing
parcelHelpers.export(exports, "RangesCollector", ()=>RangesCollector);
parcelHelpers.export(exports, "computeRanges", ()=>computeRanges);
var _utilsJs = require("../../../common/model/utils.js");
var _foldingRangesJs = require("./foldingRanges.js");
const MAX_FOLDING_REGIONS_FOR_INDENT_DEFAULT = 5000;
const ID_INDENT_PROVIDER = "indent";
class IndentRangeProvider {
    constructor(editorModel, languageConfigurationService, foldingRangesLimit){
        this.editorModel = editorModel;
        this.languageConfigurationService = languageConfigurationService;
        this.foldingRangesLimit = foldingRangesLimit;
        this.id = ID_INDENT_PROVIDER;
    }
    dispose() {}
    compute(cancelationToken) {
        const foldingRules = this.languageConfigurationService.getLanguageConfiguration(this.editorModel.getLanguageId()).foldingRules;
        const offSide = foldingRules && !!foldingRules.offSide;
        const markers = foldingRules && foldingRules.markers;
        return Promise.resolve(computeRanges(this.editorModel, offSide, markers, this.foldingRangesLimit));
    }
}
class RangesCollector {
    constructor(foldingRangesLimit){
        this._startIndexes = [];
        this._endIndexes = [];
        this._indentOccurrences = [];
        this._length = 0;
        this._foldingRangesLimit = foldingRangesLimit;
    }
    insertFirst(startLineNumber, endLineNumber, indent) {
        if (startLineNumber > (0, _foldingRangesJs.MAX_LINE_NUMBER) || endLineNumber > (0, _foldingRangesJs.MAX_LINE_NUMBER)) return;
        const index = this._length;
        this._startIndexes[index] = startLineNumber;
        this._endIndexes[index] = endLineNumber;
        this._length++;
        if (indent < 1000) this._indentOccurrences[indent] = (this._indentOccurrences[indent] || 0) + 1;
    }
    toIndentRanges(model) {
        const limit = this._foldingRangesLimit.limit;
        if (this._length <= limit) {
            this._foldingRangesLimit.update(this._length, false);
            // reverse and create arrays of the exact length
            const startIndexes = new Uint32Array(this._length);
            const endIndexes = new Uint32Array(this._length);
            for(let i = this._length - 1, k = 0; i >= 0; i--, k++){
                startIndexes[k] = this._startIndexes[i];
                endIndexes[k] = this._endIndexes[i];
            }
            return new (0, _foldingRangesJs.FoldingRegions)(startIndexes, endIndexes);
        } else {
            this._foldingRangesLimit.update(this._length, limit);
            let entries = 0;
            let maxIndent = this._indentOccurrences.length;
            for(let i = 0; i < this._indentOccurrences.length; i++){
                const n = this._indentOccurrences[i];
                if (n) {
                    if (n + entries > limit) {
                        maxIndent = i;
                        break;
                    }
                    entries += n;
                }
            }
            const tabSize = model.getOptions().tabSize;
            // reverse and create arrays of the exact length
            const startIndexes = new Uint32Array(limit);
            const endIndexes = new Uint32Array(limit);
            for(let i = this._length - 1, k = 0; i >= 0; i--){
                const startIndex = this._startIndexes[i];
                const lineContent = model.getLineContent(startIndex);
                const indent = (0, _utilsJs.computeIndentLevel)(lineContent, tabSize);
                if (indent < maxIndent || indent === maxIndent && entries++ < limit) {
                    startIndexes[k] = startIndex;
                    endIndexes[k] = this._endIndexes[i];
                    k++;
                }
            }
            return new (0, _foldingRangesJs.FoldingRegions)(startIndexes, endIndexes);
        }
    }
}
const foldingRangesLimitDefault = {
    limit: MAX_FOLDING_REGIONS_FOR_INDENT_DEFAULT,
    update: ()=>{}
};
function computeRanges(model, offSide, markers, foldingRangesLimit = foldingRangesLimitDefault) {
    const tabSize = model.getOptions().tabSize;
    const result = new RangesCollector(foldingRangesLimit);
    let pattern = undefined;
    if (markers) pattern = new RegExp(`(${markers.start.source})|(?:${markers.end.source})`);
    const previousRegions = [];
    const line = model.getLineCount() + 1;
    previousRegions.push({
        indent: -1,
        endAbove: line,
        line
    }); // sentinel, to make sure there's at least one entry
    for(let line = model.getLineCount(); line > 0; line--){
        const lineContent = model.getLineContent(line);
        const indent = (0, _utilsJs.computeIndentLevel)(lineContent, tabSize);
        let previous = previousRegions[previousRegions.length - 1];
        if (indent === -1) {
            if (offSide) // for offSide languages, empty lines are associated to the previous block
            // note: the next block is already written to the results, so this only
            // impacts the end position of the block before
            previous.endAbove = line;
            continue; // only whitespace
        }
        let m;
        if (pattern && (m = lineContent.match(pattern))) {
            // folding pattern match
            if (m[1]) {
                // discard all regions until the folding pattern
                let i = previousRegions.length - 1;
                while(i > 0 && previousRegions[i].indent !== -2)i--;
                if (i > 0) {
                    previousRegions.length = i + 1;
                    previous = previousRegions[i];
                    // new folding range from pattern, includes the end line
                    result.insertFirst(line, previous.line, indent);
                    previous.line = line;
                    previous.indent = indent;
                    previous.endAbove = line;
                    continue;
                }
            } else {
                previousRegions.push({
                    indent: -2,
                    endAbove: line,
                    line
                });
                continue;
            }
        }
        if (previous.indent > indent) {
            // discard all regions with larger indent
            do {
                previousRegions.pop();
                previous = previousRegions[previousRegions.length - 1];
            }while (previous.indent > indent);
            // new folding range
            const endLineNumber = previous.endAbove - 1;
            if (endLineNumber - line >= 1) result.insertFirst(line, endLineNumber, indent);
        }
        if (previous.indent === indent) previous.endAbove = line;
        else // new region with a bigger indent
        previousRegions.push({
            indent,
            endAbove: line,
            line
        });
    }
    return result.toIndentRanges(model);
}

},{"../../../common/model/utils.js":"gEgu8","./foldingRanges.js":"gpQdF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aCgT6":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "foldingExpandedIcon", ()=>foldingExpandedIcon);
parcelHelpers.export(exports, "foldingCollapsedIcon", ()=>foldingCollapsedIcon);
parcelHelpers.export(exports, "foldingManualCollapsedIcon", ()=>foldingManualCollapsedIcon);
parcelHelpers.export(exports, "foldingManualExpandedIcon", ()=>foldingManualExpandedIcon);
parcelHelpers.export(exports, "FoldingDecorationProvider", ()=>FoldingDecorationProvider);
var _codiconsJs = require("../../../../base/common/codicons.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _nlsJs = require("../../../../nls.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _iconRegistryJs = require("../../../../platform/theme/common/iconRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _themablesJs = require("../../../../base/common/themables.js");
const foldBackground = (0, _colorRegistryJs.registerColor)("editor.foldBackground", {
    light: (0, _colorRegistryJs.transparent)((0, _colorRegistryJs.editorSelectionBackground), 0.3),
    dark: (0, _colorRegistryJs.transparent)((0, _colorRegistryJs.editorSelectionBackground), 0.3),
    hcDark: null,
    hcLight: null
}, (0, _nlsJs.localize)("foldBackgroundBackground", "Background color behind folded ranges. The color must not be opaque so as not to hide underlying decorations."), true);
(0, _colorRegistryJs.registerColor)("editor.foldPlaceholderForeground", {
    light: "#808080",
    dark: "#808080",
    hcDark: null,
    hcLight: null
}, (0, _nlsJs.localize)("collapsedTextColor", "Color of the collapsed text after the first line of a folded range."));
(0, _colorRegistryJs.registerColor)("editorGutter.foldingControlForeground", (0, _colorRegistryJs.iconForeground), (0, _nlsJs.localize)("editorGutter.foldingControlForeground", "Color of the folding control in the editor gutter."));
const foldingExpandedIcon = (0, _iconRegistryJs.registerIcon)("folding-expanded", (0, _codiconsJs.Codicon).chevronDown, (0, _nlsJs.localize)("foldingExpandedIcon", "Icon for expanded ranges in the editor glyph margin."));
const foldingCollapsedIcon = (0, _iconRegistryJs.registerIcon)("folding-collapsed", (0, _codiconsJs.Codicon).chevronRight, (0, _nlsJs.localize)("foldingCollapsedIcon", "Icon for collapsed ranges in the editor glyph margin."));
const foldingManualCollapsedIcon = (0, _iconRegistryJs.registerIcon)("folding-manual-collapsed", foldingCollapsedIcon, (0, _nlsJs.localize)("foldingManualCollapedIcon", "Icon for manually collapsed ranges in the editor glyph margin."));
const foldingManualExpandedIcon = (0, _iconRegistryJs.registerIcon)("folding-manual-expanded", foldingExpandedIcon, (0, _nlsJs.localize)("foldingManualExpandedIcon", "Icon for manually expanded ranges in the editor glyph margin."));
const foldedBackgroundMinimap = {
    color: (0, _themeServiceJs.themeColorFromId)(foldBackground),
    position: 1 /* MinimapPosition.Inline */ 
};
const collapsed = (0, _nlsJs.localize)("linesCollapsed", "Click to expand the range.");
const expanded = (0, _nlsJs.localize)("linesExpanded", "Click to collapse the range.");
class FoldingDecorationProvider {
    static{
        this.COLLAPSED_VISUAL_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "folding-collapsed-visual-decoration",
            stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ,
            afterContentClassName: "inline-folded",
            isWholeLine: true,
            linesDecorationsTooltip: collapsed,
            firstLineDecorationClassName: (0, _themablesJs.ThemeIcon).asClassName(foldingCollapsedIcon)
        });
    }
    static{
        this.COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "folding-collapsed-highlighted-visual-decoration",
            stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ,
            afterContentClassName: "inline-folded",
            className: "folded-background",
            minimap: foldedBackgroundMinimap,
            isWholeLine: true,
            linesDecorationsTooltip: collapsed,
            firstLineDecorationClassName: (0, _themablesJs.ThemeIcon).asClassName(foldingCollapsedIcon)
        });
    }
    static{
        this.MANUALLY_COLLAPSED_VISUAL_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "folding-manually-collapsed-visual-decoration",
            stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ,
            afterContentClassName: "inline-folded",
            isWholeLine: true,
            linesDecorationsTooltip: collapsed,
            firstLineDecorationClassName: (0, _themablesJs.ThemeIcon).asClassName(foldingManualCollapsedIcon)
        });
    }
    static{
        this.MANUALLY_COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "folding-manually-collapsed-highlighted-visual-decoration",
            stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ,
            afterContentClassName: "inline-folded",
            className: "folded-background",
            minimap: foldedBackgroundMinimap,
            isWholeLine: true,
            linesDecorationsTooltip: collapsed,
            firstLineDecorationClassName: (0, _themablesJs.ThemeIcon).asClassName(foldingManualCollapsedIcon)
        });
    }
    static{
        this.NO_CONTROLS_COLLAPSED_RANGE_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "folding-no-controls-range-decoration",
            stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ,
            afterContentClassName: "inline-folded",
            isWholeLine: true,
            linesDecorationsTooltip: collapsed
        });
    }
    static{
        this.NO_CONTROLS_COLLAPSED_HIGHLIGHTED_RANGE_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "folding-no-controls-range-decoration",
            stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ,
            afterContentClassName: "inline-folded",
            className: "folded-background",
            minimap: foldedBackgroundMinimap,
            isWholeLine: true,
            linesDecorationsTooltip: collapsed
        });
    }
    static{
        this.EXPANDED_VISUAL_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "folding-expanded-visual-decoration",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
            isWholeLine: true,
            firstLineDecorationClassName: "alwaysShowFoldIcons " + (0, _themablesJs.ThemeIcon).asClassName(foldingExpandedIcon),
            linesDecorationsTooltip: expanded
        });
    }
    static{
        this.EXPANDED_AUTO_HIDE_VISUAL_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "folding-expanded-auto-hide-visual-decoration",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
            isWholeLine: true,
            firstLineDecorationClassName: (0, _themablesJs.ThemeIcon).asClassName(foldingExpandedIcon),
            linesDecorationsTooltip: expanded
        });
    }
    static{
        this.MANUALLY_EXPANDED_VISUAL_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "folding-manually-expanded-visual-decoration",
            stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ,
            isWholeLine: true,
            firstLineDecorationClassName: "alwaysShowFoldIcons " + (0, _themablesJs.ThemeIcon).asClassName(foldingManualExpandedIcon),
            linesDecorationsTooltip: expanded
        });
    }
    static{
        this.MANUALLY_EXPANDED_AUTO_HIDE_VISUAL_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "folding-manually-expanded-auto-hide-visual-decoration",
            stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ,
            isWholeLine: true,
            firstLineDecorationClassName: (0, _themablesJs.ThemeIcon).asClassName(foldingManualExpandedIcon),
            linesDecorationsTooltip: expanded
        });
    }
    static{
        this.NO_CONTROLS_EXPANDED_RANGE_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "folding-no-controls-range-decoration",
            stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ,
            isWholeLine: true
        });
    }
    static{
        this.HIDDEN_RANGE_DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "folding-hidden-range-decoration",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ 
        });
    }
    constructor(editor){
        this.editor = editor;
        this.showFoldingControls = "mouseover";
        this.showFoldingHighlights = true;
    }
    getDecorationOption(isCollapsed, isHidden, isManual) {
        if (isHidden) return FoldingDecorationProvider.HIDDEN_RANGE_DECORATION;
        if (this.showFoldingControls === "never") {
            if (isCollapsed) return this.showFoldingHighlights ? FoldingDecorationProvider.NO_CONTROLS_COLLAPSED_HIGHLIGHTED_RANGE_DECORATION : FoldingDecorationProvider.NO_CONTROLS_COLLAPSED_RANGE_DECORATION;
            return FoldingDecorationProvider.NO_CONTROLS_EXPANDED_RANGE_DECORATION;
        }
        if (isCollapsed) return isManual ? this.showFoldingHighlights ? FoldingDecorationProvider.MANUALLY_COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION : FoldingDecorationProvider.MANUALLY_COLLAPSED_VISUAL_DECORATION : this.showFoldingHighlights ? FoldingDecorationProvider.COLLAPSED_HIGHLIGHTED_VISUAL_DECORATION : FoldingDecorationProvider.COLLAPSED_VISUAL_DECORATION;
        else if (this.showFoldingControls === "mouseover") return isManual ? FoldingDecorationProvider.MANUALLY_EXPANDED_AUTO_HIDE_VISUAL_DECORATION : FoldingDecorationProvider.EXPANDED_AUTO_HIDE_VISUAL_DECORATION;
        else return isManual ? FoldingDecorationProvider.MANUALLY_EXPANDED_VISUAL_DECORATION : FoldingDecorationProvider.EXPANDED_VISUAL_DECORATION;
    }
    changeDecorations(callback) {
        return this.editor.changeDecorations(callback);
    }
    removeDecorations(decorationIds) {
        this.editor.removeDecorations(decorationIds);
    }
}

},{"../../../../base/common/codicons.js":"hWYNf","../../../common/model/textModel.js":"9beDe","../../../../nls.js":"l617d","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/iconRegistry.js":"bRNEz","../../../../platform/theme/common/themeService.js":"jMkIC","../../../../base/common/themables.js":"hgyHi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eOdXK":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyntaxRangeProvider", ()=>SyntaxRangeProvider);
parcelHelpers.export(exports, "sanitizeRanges", ()=>sanitizeRanges);
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _foldingRangesJs = require("./foldingRanges.js");
const foldingContext = {};
const ID_SYNTAX_PROVIDER = "syntax";
class SyntaxRangeProvider {
    constructor(editorModel, providers, handleFoldingRangesChange, foldingRangesLimit, fallbackRangeProvider // used when all providers return null
    ){
        this.editorModel = editorModel;
        this.providers = providers;
        this.handleFoldingRangesChange = handleFoldingRangesChange;
        this.foldingRangesLimit = foldingRangesLimit;
        this.fallbackRangeProvider = fallbackRangeProvider;
        this.id = ID_SYNTAX_PROVIDER;
        this.disposables = new (0, _lifecycleJs.DisposableStore)();
        if (fallbackRangeProvider) this.disposables.add(fallbackRangeProvider);
        for (const provider of providers)if (typeof provider.onDidChange === "function") this.disposables.add(provider.onDidChange(handleFoldingRangesChange));
    }
    compute(cancellationToken) {
        return collectSyntaxRanges(this.providers, this.editorModel, cancellationToken).then((ranges)=>{
            if (ranges) {
                const res = sanitizeRanges(ranges, this.foldingRangesLimit);
                return res;
            }
            return this.fallbackRangeProvider?.compute(cancellationToken) ?? null;
        });
    }
    dispose() {
        this.disposables.dispose();
    }
}
function collectSyntaxRanges(providers, model, cancellationToken) {
    let rangeData = null;
    const promises = providers.map((provider, i)=>{
        return Promise.resolve(provider.provideFoldingRanges(model, foldingContext, cancellationToken)).then((ranges)=>{
            if (cancellationToken.isCancellationRequested) return;
            if (Array.isArray(ranges)) {
                if (!Array.isArray(rangeData)) rangeData = [];
                const nLines = model.getLineCount();
                for (const r of ranges)if (r.start > 0 && r.end > r.start && r.end <= nLines) rangeData.push({
                    start: r.start,
                    end: r.end,
                    rank: i,
                    kind: r.kind
                });
            }
        }, (0, _errorsJs.onUnexpectedExternalError));
    });
    return Promise.all(promises).then((_)=>{
        return rangeData;
    });
}
class RangesCollector {
    constructor(foldingRangesLimit){
        this._startIndexes = [];
        this._endIndexes = [];
        this._nestingLevels = [];
        this._nestingLevelCounts = [];
        this._types = [];
        this._length = 0;
        this._foldingRangesLimit = foldingRangesLimit;
    }
    add(startLineNumber, endLineNumber, type, nestingLevel) {
        if (startLineNumber > (0, _foldingRangesJs.MAX_LINE_NUMBER) || endLineNumber > (0, _foldingRangesJs.MAX_LINE_NUMBER)) return;
        const index = this._length;
        this._startIndexes[index] = startLineNumber;
        this._endIndexes[index] = endLineNumber;
        this._nestingLevels[index] = nestingLevel;
        this._types[index] = type;
        this._length++;
        if (nestingLevel < 30) this._nestingLevelCounts[nestingLevel] = (this._nestingLevelCounts[nestingLevel] || 0) + 1;
    }
    toIndentRanges() {
        const limit = this._foldingRangesLimit.limit;
        if (this._length <= limit) {
            this._foldingRangesLimit.update(this._length, false);
            const startIndexes = new Uint32Array(this._length);
            const endIndexes = new Uint32Array(this._length);
            for(let i = 0; i < this._length; i++){
                startIndexes[i] = this._startIndexes[i];
                endIndexes[i] = this._endIndexes[i];
            }
            return new (0, _foldingRangesJs.FoldingRegions)(startIndexes, endIndexes, this._types);
        } else {
            this._foldingRangesLimit.update(this._length, limit);
            let entries = 0;
            let maxLevel = this._nestingLevelCounts.length;
            for(let i = 0; i < this._nestingLevelCounts.length; i++){
                const n = this._nestingLevelCounts[i];
                if (n) {
                    if (n + entries > limit) {
                        maxLevel = i;
                        break;
                    }
                    entries += n;
                }
            }
            const startIndexes = new Uint32Array(limit);
            const endIndexes = new Uint32Array(limit);
            const types = [];
            for(let i = 0, k = 0; i < this._length; i++){
                const level = this._nestingLevels[i];
                if (level < maxLevel || level === maxLevel && entries++ < limit) {
                    startIndexes[k] = this._startIndexes[i];
                    endIndexes[k] = this._endIndexes[i];
                    types[k] = this._types[i];
                    k++;
                }
            }
            return new (0, _foldingRangesJs.FoldingRegions)(startIndexes, endIndexes, types);
        }
    }
}
function sanitizeRanges(rangeData, foldingRangesLimit) {
    const sorted = rangeData.sort((d1, d2)=>{
        let diff = d1.start - d2.start;
        if (diff === 0) diff = d1.rank - d2.rank;
        return diff;
    });
    const collector = new RangesCollector(foldingRangesLimit);
    let top = undefined;
    const previous = [];
    for (const entry of sorted){
        if (!top) {
            top = entry;
            collector.add(entry.start, entry.end, entry.kind && entry.kind.value, previous.length);
        } else if (entry.start > top.start) {
            if (entry.end <= top.end) {
                previous.push(top);
                top = entry;
                collector.add(entry.start, entry.end, entry.kind && entry.kind.value, previous.length);
            } else {
                if (entry.start > top.end) {
                    do top = previous.pop();
                    while (top && entry.start > top.end);
                    if (top) previous.push(top);
                    top = entry;
                }
                collector.add(entry.start, entry.end, entry.kind && entry.kind.value, previous.length);
            }
        }
    }
    return collector.toIndentRanges();
}

},{"../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","./foldingRanges.js":"gpQdF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Ecgl":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorZoomJs = require("../../../common/config/editorZoom.js");
var _nlsJs = require("../../../../nls.js");
class EditorFontZoomIn extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.fontZoomIn",
            label: _nlsJs.localize("EditorFontZoomIn.label", "Increase Editor Font Size"),
            alias: "Increase Editor Font Size",
            precondition: undefined
        });
    }
    run(accessor, editor) {
        (0, _editorZoomJs.EditorZoom).setZoomLevel((0, _editorZoomJs.EditorZoom).getZoomLevel() + 1);
    }
}
class EditorFontZoomOut extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.fontZoomOut",
            label: _nlsJs.localize("EditorFontZoomOut.label", "Decrease Editor Font Size"),
            alias: "Decrease Editor Font Size",
            precondition: undefined
        });
    }
    run(accessor, editor) {
        (0, _editorZoomJs.EditorZoom).setZoomLevel((0, _editorZoomJs.EditorZoom).getZoomLevel() - 1);
    }
}
class EditorFontZoomReset extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.fontZoomReset",
            label: _nlsJs.localize("EditorFontZoomReset.label", "Reset Editor Font Size"),
            alias: "Reset Editor Font Size",
            precondition: undefined
        });
    }
    run(accessor, editor) {
        (0, _editorZoomJs.EditorZoom).setZoomLevel(0);
    }
}
(0, _editorExtensionsJs.registerEditorAction)(EditorFontZoomIn);
(0, _editorExtensionsJs.registerEditorAction)(EditorFontZoomOut);
(0, _editorExtensionsJs.registerEditorAction)(EditorFontZoomReset);

},{"../../../browser/editorExtensions.js":"kC3w6","../../../common/config/editorZoom.js":"7PVxj","../../../../nls.js":"l617d"}],"eUpMt":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormatOnType", ()=>FormatOnType);
var _arraysJs = require("../../../../base/common/arrays.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _keyCodesJs = require("../../../../base/common/keyCodes.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _characterClassifierJs = require("../../../common/core/characterClassifier.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _editorWorkerJs = require("../../../common/services/editorWorker.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _formatJs = require("./format.js");
var _formattingEditJs = require("./formattingEdit.js");
var _nlsJs = require("../../../../nls.js");
var _accessibilitySignalServiceJs = require("../../../../platform/accessibilitySignal/browser/accessibilitySignalService.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _progressJs = require("../../../../platform/progress/common/progress.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let FormatOnType = class FormatOnType {
    static{
        this.ID = "editor.contrib.autoFormat";
    }
    constructor(_editor, _languageFeaturesService, _workerService, _accessibilitySignalService){
        this._editor = _editor;
        this._languageFeaturesService = _languageFeaturesService;
        this._workerService = _workerService;
        this._accessibilitySignalService = _accessibilitySignalService;
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._sessionDisposables = new (0, _lifecycleJs.DisposableStore)();
        this._disposables.add(_languageFeaturesService.onTypeFormattingEditProvider.onDidChange(this._update, this));
        this._disposables.add(_editor.onDidChangeModel(()=>this._update()));
        this._disposables.add(_editor.onDidChangeModelLanguage(()=>this._update()));
        this._disposables.add(_editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(56 /* EditorOption.formatOnType */ )) this._update();
        }));
        this._update();
    }
    dispose() {
        this._disposables.dispose();
        this._sessionDisposables.dispose();
    }
    _update() {
        // clean up
        this._sessionDisposables.clear();
        // we are disabled
        if (!this._editor.getOption(56 /* EditorOption.formatOnType */ )) return;
        // no model
        if (!this._editor.hasModel()) return;
        const model = this._editor.getModel();
        // no support
        const [support] = this._languageFeaturesService.onTypeFormattingEditProvider.ordered(model);
        if (!support || !support.autoFormatTriggerCharacters) return;
        // register typing listeners that will trigger the format
        const triggerChars = new (0, _characterClassifierJs.CharacterSet)();
        for (const ch of support.autoFormatTriggerCharacters)triggerChars.add(ch.charCodeAt(0));
        this._sessionDisposables.add(this._editor.onDidType((text)=>{
            const lastCharCode = text.charCodeAt(text.length - 1);
            if (triggerChars.has(lastCharCode)) this._trigger(String.fromCharCode(lastCharCode));
        }));
    }
    _trigger(ch) {
        if (!this._editor.hasModel()) return;
        if (this._editor.getSelections().length > 1 || !this._editor.getSelection().isEmpty()) return;
        const model = this._editor.getModel();
        const position = this._editor.getPosition();
        const cts = new (0, _cancellationJs.CancellationTokenSource)();
        // install a listener that checks if edits happens before the
        // position on which we format right now. If so, we won't
        // apply the format edits
        const unbind = this._editor.onDidChangeModelContent((e)=>{
            if (e.isFlush) {
                // a model.setValue() was called
                // cancel only once
                cts.cancel();
                unbind.dispose();
                return;
            }
            for(let i = 0, len = e.changes.length; i < len; i++){
                const change = e.changes[i];
                if (change.range.endLineNumber <= position.lineNumber) {
                    // cancel only once
                    cts.cancel();
                    unbind.dispose();
                    return;
                }
            }
        });
        (0, _formatJs.getOnTypeFormattingEdits)(this._workerService, this._languageFeaturesService, model, position, ch, model.getFormattingOptions(), cts.token).then((edits)=>{
            if (cts.token.isCancellationRequested) return;
            if ((0, _arraysJs.isNonEmptyArray)(edits)) {
                this._accessibilitySignalService.playSignal((0, _accessibilitySignalServiceJs.AccessibilitySignal).format, {
                    userGesture: false
                });
                (0, _formattingEditJs.FormattingEdit).execute(this._editor, edits, true);
            }
        }).finally(()=>{
            unbind.dispose();
        });
    }
};
FormatOnType = __decorate([
    __param(1, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(2, (0, _editorWorkerJs.IEditorWorkerService)),
    __param(3, (0, _accessibilitySignalServiceJs.IAccessibilitySignalService))
], FormatOnType);
let FormatOnPaste = class FormatOnPaste {
    static{
        this.ID = "editor.contrib.formatOnPaste";
    }
    constructor(editor, _languageFeaturesService, _instantiationService){
        this.editor = editor;
        this._languageFeaturesService = _languageFeaturesService;
        this._instantiationService = _instantiationService;
        this._callOnDispose = new (0, _lifecycleJs.DisposableStore)();
        this._callOnModel = new (0, _lifecycleJs.DisposableStore)();
        this._callOnDispose.add(editor.onDidChangeConfiguration(()=>this._update()));
        this._callOnDispose.add(editor.onDidChangeModel(()=>this._update()));
        this._callOnDispose.add(editor.onDidChangeModelLanguage(()=>this._update()));
        this._callOnDispose.add(_languageFeaturesService.documentRangeFormattingEditProvider.onDidChange(this._update, this));
    }
    dispose() {
        this._callOnDispose.dispose();
        this._callOnModel.dispose();
    }
    _update() {
        // clean up
        this._callOnModel.clear();
        // we are disabled
        if (!this.editor.getOption(55 /* EditorOption.formatOnPaste */ )) return;
        // no model
        if (!this.editor.hasModel()) return;
        // no formatter
        if (!this._languageFeaturesService.documentRangeFormattingEditProvider.has(this.editor.getModel())) return;
        this._callOnModel.add(this.editor.onDidPaste(({ range })=>this._trigger(range)));
    }
    _trigger(range) {
        if (!this.editor.hasModel()) return;
        if (this.editor.getSelections().length > 1) return;
        this._instantiationService.invokeFunction((0, _formatJs.formatDocumentRangesWithSelectedProvider), this.editor, range, 2 /* FormattingMode.Silent */ , (0, _progressJs.Progress).None, (0, _cancellationJs.CancellationToken).None, false).catch((0, _errorsJs.onUnexpectedError));
    }
};
FormatOnPaste = __decorate([
    __param(1, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(2, (0, _instantiationJs.IInstantiationService))
], FormatOnPaste);
class FormatDocumentAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.formatDocument",
            label: _nlsJs.localize("formatDocument.label", "Format Document"),
            alias: "Format Document",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).notInCompositeEditor, (0, _editorContextKeysJs.EditorContextKeys).writable, (0, _editorContextKeysJs.EditorContextKeys).hasDocumentFormattingProvider),
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 1572 /* KeyCode.KeyF */ ,
                linux: {
                    primary: 3111 /* KeyCode.KeyI */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            contextMenuOpts: {
                group: "1_modification",
                order: 1.3
            }
        });
    }
    async run(accessor, editor) {
        if (editor.hasModel()) {
            const instaService = accessor.get((0, _instantiationJs.IInstantiationService));
            const progressService = accessor.get((0, _progressJs.IEditorProgressService));
            await progressService.showWhile(instaService.invokeFunction((0, _formatJs.formatDocumentWithSelectedProvider), editor, 1 /* FormattingMode.Explicit */ , (0, _progressJs.Progress).None, (0, _cancellationJs.CancellationToken).None, true), 250);
        }
    }
}
class FormatSelectionAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.formatSelection",
            label: _nlsJs.localize("formatSelection.label", "Format Selection"),
            alias: "Format Selection",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _editorContextKeysJs.EditorContextKeys).hasDocumentSelectionFormattingProvider),
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2084 /* KeyCode.KeyF */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            contextMenuOpts: {
                when: (0, _editorContextKeysJs.EditorContextKeys).hasNonEmptySelection,
                group: "1_modification",
                order: 1.31
            }
        });
    }
    async run(accessor, editor) {
        if (!editor.hasModel()) return;
        const instaService = accessor.get((0, _instantiationJs.IInstantiationService));
        const model = editor.getModel();
        const ranges = editor.getSelections().map((range)=>{
            return range.isEmpty() ? new (0, _rangeJs.Range)(range.startLineNumber, 1, range.startLineNumber, model.getLineMaxColumn(range.startLineNumber)) : range;
        });
        const progressService = accessor.get((0, _progressJs.IEditorProgressService));
        await progressService.showWhile(instaService.invokeFunction((0, _formatJs.formatDocumentRangesWithSelectedProvider), editor, ranges, 1 /* FormattingMode.Explicit */ , (0, _progressJs.Progress).None, (0, _cancellationJs.CancellationToken).None, true), 250);
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(FormatOnType.ID, FormatOnType, 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );
(0, _editorExtensionsJs.registerEditorContribution)(FormatOnPaste.ID, FormatOnPaste, 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );
(0, _editorExtensionsJs.registerEditorAction)(FormatDocumentAction);
(0, _editorExtensionsJs.registerEditorAction)(FormatSelectionAction);
// this is the old format action that does both (format document OR format selection)
// and we keep it here such that existing keybinding configurations etc will still work
(0, _commandsJs.CommandsRegistry).registerCommand("editor.action.format", async (accessor)=>{
    const editor = accessor.get((0, _codeEditorServiceJs.ICodeEditorService)).getFocusedCodeEditor();
    if (!editor || !editor.hasModel()) return;
    const commandService = accessor.get((0, _commandsJs.ICommandService));
    if (editor.getSelection().isEmpty()) await commandService.executeCommand("editor.action.formatDocument");
    else await commandService.executeCommand("editor.action.formatSelection");
});

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/keyCodes.js":"bHiG9","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorExtensions.js":"kC3w6","../../../browser/services/codeEditorService.js":"bOWtl","../../../common/core/characterClassifier.js":"hl8tq","../../../common/core/range.js":"jmUPh","../../../common/editorContextKeys.js":"5exv9","../../../common/services/editorWorker.js":"aaYJd","../../../common/services/languageFeatures.js":"2IAko","./format.js":"cATs8","./formattingEdit.js":"7wD82","../../../../nls.js":"l617d","../../../../platform/accessibilitySignal/browser/accessibilitySignalService.js":"hpeDM","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/progress/common/progress.js":"f49eD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3GSL5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _cancellationJs = require("../../../../base/common/cancellation.js");
var _typesJs = require("../../../../base/common/types.js");
var _uriJs = require("../../../../base/common/uri.js");
var _resolverServiceJs = require("../../../common/services/resolverService.js");
var _outlineModelJs = require("./outlineModel.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
(0, _commandsJs.CommandsRegistry).registerCommand("_executeDocumentSymbolProvider", async function(accessor, ...args) {
    const [resource] = args;
    (0, _typesJs.assertType)((0, _uriJs.URI).isUri(resource));
    const outlineService = accessor.get((0, _outlineModelJs.IOutlineModelService));
    const modelService = accessor.get((0, _resolverServiceJs.ITextModelService));
    const reference = await modelService.createModelReference(resource);
    try {
        return (await outlineService.getOrCreate(reference.object.textEditorModel, (0, _cancellationJs.CancellationToken).None)).getTopLevelSymbols();
    } finally{
        reference.dispose();
    }
});

},{"../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/types.js":"fb5yx","../../../../base/common/uri.js":"7qGS3","../../../common/services/resolverService.js":"ezAtF","./outlineModel.js":"13q6i","../../../../platform/commands/common/commands.js":"ho6ic"}],"13q6i":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TreeElement", ()=>TreeElement);
parcelHelpers.export(exports, "OutlineElement", ()=>OutlineElement);
parcelHelpers.export(exports, "OutlineGroup", ()=>OutlineGroup);
parcelHelpers.export(exports, "OutlineModel", ()=>OutlineModel);
parcelHelpers.export(exports, "IOutlineModelService", ()=>IOutlineModelService);
parcelHelpers.export(exports, "OutlineModelService", ()=>OutlineModelService);
var _arraysJs = require("../../../../base/common/arrays.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _iteratorJs = require("../../../../base/common/iterator.js");
var _mapJs = require("../../../../base/common/map.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _languageFeatureDebounceJs = require("../../../common/services/languageFeatureDebounce.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _extensionsJs = require("../../../../platform/instantiation/common/extensions.js");
var _modelJs = require("../../../common/services/model.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class TreeElement {
    remove() {
        this.parent?.children.delete(this.id);
    }
    static findId(candidate, container) {
        // complex id-computation which contains the origin/extension,
        // the parent path, and some dedupe logic when names collide
        let candidateId;
        if (typeof candidate === "string") candidateId = `${container.id}/${candidate}`;
        else {
            candidateId = `${container.id}/${candidate.name}`;
            if (container.children.get(candidateId) !== undefined) candidateId = `${container.id}/${candidate.name}_${candidate.range.startLineNumber}_${candidate.range.startColumn}`;
        }
        let id = candidateId;
        for(let i = 0; container.children.get(id) !== undefined; i++)id = `${candidateId}_${i}`;
        return id;
    }
    static empty(element) {
        return element.children.size === 0;
    }
}
class OutlineElement extends TreeElement {
    constructor(id, parent, symbol){
        super();
        this.id = id;
        this.parent = parent;
        this.symbol = symbol;
        this.children = new Map();
    }
}
class OutlineGroup extends TreeElement {
    constructor(id, parent, label, order){
        super();
        this.id = id;
        this.parent = parent;
        this.label = label;
        this.order = order;
        this.children = new Map();
    }
}
class OutlineModel extends TreeElement {
    static create(registry, textModel, token) {
        const cts = new (0, _cancellationJs.CancellationTokenSource)(token);
        const result = new OutlineModel(textModel.uri);
        const provider = registry.ordered(textModel);
        const promises = provider.map((provider, index)=>{
            const id = TreeElement.findId(`provider_${index}`, result);
            const group = new OutlineGroup(id, result, provider.displayName ?? "Unknown Outline Provider", index);
            return Promise.resolve(provider.provideDocumentSymbols(textModel, cts.token)).then((result)=>{
                for (const info of result || [])OutlineModel._makeOutlineElement(info, group);
                return group;
            }, (err)=>{
                (0, _errorsJs.onUnexpectedExternalError)(err);
                return group;
            }).then((group)=>{
                if (!TreeElement.empty(group)) result._groups.set(id, group);
                else group.remove();
            });
        });
        const listener = registry.onDidChange(()=>{
            const newProvider = registry.ordered(textModel);
            if (!(0, _arraysJs.equals)(newProvider, provider)) cts.cancel();
        });
        return Promise.all(promises).then(()=>{
            if (cts.token.isCancellationRequested && !token.isCancellationRequested) return OutlineModel.create(registry, textModel, token);
            else return result._compact();
        }).finally(()=>{
            cts.dispose();
            listener.dispose();
            cts.dispose();
        });
    }
    static _makeOutlineElement(info, container) {
        const id = TreeElement.findId(info, container);
        const res = new OutlineElement(id, container, info);
        if (info.children) for (const childInfo of info.children)OutlineModel._makeOutlineElement(childInfo, res);
        container.children.set(res.id, res);
    }
    constructor(uri){
        super();
        this.uri = uri;
        this.id = "root";
        this.parent = undefined;
        this._groups = new Map();
        this.children = new Map();
        this.id = "root";
        this.parent = undefined;
    }
    _compact() {
        let count = 0;
        for (const [key, group] of this._groups)if (group.children.size === 0) this._groups.delete(key);
        else count += 1;
        if (count !== 1) //
        this.children = this._groups;
        else {
            // adopt all elements of the first group
            const group = (0, _iteratorJs.Iterable).first(this._groups.values());
            for (const [, child] of group.children){
                child.parent = this;
                this.children.set(child.id, child);
            }
        }
        return this;
    }
    getTopLevelSymbols() {
        const roots = [];
        for (const child of this.children.values())if (child instanceof OutlineElement) roots.push(child.symbol);
        else roots.push(...(0, _iteratorJs.Iterable).map(child.children.values(), (child)=>child.symbol));
        return roots.sort((a, b)=>(0, _rangeJs.Range).compareRangesUsingStarts(a.range, b.range));
    }
    asListOfDocumentSymbols() {
        const roots = this.getTopLevelSymbols();
        const bucket = [];
        OutlineModel._flattenDocumentSymbols(bucket, roots, "");
        return bucket.sort((a, b)=>(0, _positionJs.Position).compare((0, _rangeJs.Range).getStartPosition(a.range), (0, _rangeJs.Range).getStartPosition(b.range)) || (0, _positionJs.Position).compare((0, _rangeJs.Range).getEndPosition(b.range), (0, _rangeJs.Range).getEndPosition(a.range)));
    }
    static _flattenDocumentSymbols(bucket, entries, overrideContainerLabel) {
        for (const entry of entries){
            bucket.push({
                kind: entry.kind,
                tags: entry.tags,
                name: entry.name,
                detail: entry.detail,
                containerName: entry.containerName || overrideContainerLabel,
                range: entry.range,
                selectionRange: entry.selectionRange,
                children: undefined
            });
            // Recurse over children
            if (entry.children) OutlineModel._flattenDocumentSymbols(bucket, entry.children, entry.name);
        }
    }
}
const IOutlineModelService = (0, _instantiationJs.createDecorator)("IOutlineModelService");
let OutlineModelService = class OutlineModelService {
    constructor(_languageFeaturesService, debounces, modelService){
        this._languageFeaturesService = _languageFeaturesService;
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._cache = new (0, _mapJs.LRUCache)(10, 0.7);
        this._debounceInformation = debounces.for(_languageFeaturesService.documentSymbolProvider, "DocumentSymbols", {
            min: 350
        });
        // don't cache outline models longer than their text model
        this._disposables.add(modelService.onModelRemoved((textModel)=>{
            this._cache.delete(textModel.id);
        }));
    }
    dispose() {
        this._disposables.dispose();
    }
    async getOrCreate(textModel, token) {
        const registry = this._languageFeaturesService.documentSymbolProvider;
        const provider = registry.ordered(textModel);
        let data = this._cache.get(textModel.id);
        if (!data || data.versionId !== textModel.getVersionId() || !(0, _arraysJs.equals)(data.provider, provider)) {
            const source = new (0, _cancellationJs.CancellationTokenSource)();
            data = {
                versionId: textModel.getVersionId(),
                provider,
                promiseCnt: 0,
                source,
                promise: OutlineModel.create(registry, textModel, source.token),
                model: undefined
            };
            this._cache.set(textModel.id, data);
            const now = Date.now();
            data.promise.then((outlineModel)=>{
                data.model = outlineModel;
                this._debounceInformation.update(textModel, Date.now() - now);
            }).catch((_err)=>{
                this._cache.delete(textModel.id);
            });
        }
        if (data.model) // resolved -> return data
        return data.model;
        // increase usage counter
        data.promiseCnt += 1;
        const listener = token.onCancellationRequested(()=>{
            // last -> cancel provider request, remove cached promise
            if (--data.promiseCnt === 0) {
                data.source.cancel();
                this._cache.delete(textModel.id);
            }
        });
        try {
            return await data.promise;
        } finally{
            listener.dispose();
        }
    }
};
OutlineModelService = __decorate([
    __param(0, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(1, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService)),
    __param(2, (0, _modelJs.IModelService))
], OutlineModelService);
(0, _extensionsJs.registerSingleton)(IOutlineModelService, OutlineModelService, 1 /* InstantiationType.Delayed */ );

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/iterator.js":"2FiS0","../../../../base/common/map.js":"leSjz","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/services/languageFeatureDebounce.js":"YGXXG","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/instantiation/common/extensions.js":"6WJLq","../../../common/services/model.js":"aciVm","../../../../base/common/lifecycle.js":"9kg8d","../../../common/services/languageFeatures.js":"2IAko","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aA3C6":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _hoverTypesJs = require("../../hover/browser/hoverTypes.js");
var _commandsJs = require("./controller/commands.js");
var _hoverParticipantJs = require("./hintsWidget/hoverParticipant.js");
var _inlineCompletionsAccessibleViewJs = require("./inlineCompletionsAccessibleView.js");
var _inlineCompletionsControllerJs = require("./controller/inlineCompletionsController.js");
var _accessibleViewRegistryJs = require("../../../../platform/accessibility/browser/accessibleViewRegistry.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
(0, _editorExtensionsJs.registerEditorContribution)((0, _inlineCompletionsControllerJs.InlineCompletionsController).ID, (0, _inlineCompletionsControllerJs.InlineCompletionsController), 3 /* EditorContributionInstantiation.Eventually */ );
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.TriggerInlineSuggestionAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.ShowNextInlineSuggestionAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.ShowPreviousInlineSuggestionAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.AcceptNextWordOfInlineCompletion));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.AcceptNextLineOfInlineCompletion));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.AcceptInlineCompletion));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.HideInlineCompletion));
(0, _actionsJs.registerAction2)((0, _commandsJs.ToggleAlwaysShowInlineSuggestionToolbar));
(0, _hoverTypesJs.HoverParticipantRegistry).register((0, _hoverParticipantJs.InlineCompletionsHoverParticipant));
(0, _accessibleViewRegistryJs.AccessibleViewRegistry).register(new (0, _inlineCompletionsAccessibleViewJs.InlineCompletionsAccessibleView)());

},{"../../../browser/editorExtensions.js":"kC3w6","../../hover/browser/hoverTypes.js":"6vmRi","./controller/commands.js":"ltv9u","./hintsWidget/hoverParticipant.js":"hK6o6","./inlineCompletionsAccessibleView.js":"iVZLo","./controller/inlineCompletionsController.js":"gcSfI","../../../../platform/accessibility/browser/accessibleViewRegistry.js":"khjwq","../../../../platform/actions/common/actions.js":"kyMtp"}],"ltv9u":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShowNextInlineSuggestionAction", ()=>ShowNextInlineSuggestionAction);
parcelHelpers.export(exports, "ShowPreviousInlineSuggestionAction", ()=>ShowPreviousInlineSuggestionAction);
parcelHelpers.export(exports, "TriggerInlineSuggestionAction", ()=>TriggerInlineSuggestionAction);
parcelHelpers.export(exports, "AcceptNextWordOfInlineCompletion", ()=>AcceptNextWordOfInlineCompletion);
parcelHelpers.export(exports, "AcceptNextLineOfInlineCompletion", ()=>AcceptNextLineOfInlineCompletion);
parcelHelpers.export(exports, "AcceptInlineCompletion", ()=>AcceptInlineCompletion);
parcelHelpers.export(exports, "HideInlineCompletion", ()=>HideInlineCompletion);
parcelHelpers.export(exports, "ToggleAlwaysShowInlineSuggestionToolbar", ()=>ToggleAlwaysShowInlineSuggestionToolbar);
var _observableJs = require("../../../../../base/common/observable.js");
var _baseJs = require("../../../../../base/common/observableInternal/base.js");
var _editorExtensionsJs = require("../../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../../common/editorContextKeys.js");
var _commandIdsJs = require("./commandIds.js");
var _inlineCompletionContextKeysJs = require("./inlineCompletionContextKeys.js");
var _inlineCompletionsControllerJs = require("./inlineCompletionsController.js");
var _suggestJs = require("../../../suggest/browser/suggest.js");
var _nlsJs = require("../../../../../nls.js");
var _actionsJs = require("../../../../../platform/actions/common/actions.js");
var _configurationJs = require("../../../../../platform/configuration/common/configuration.js");
var _contextkeyJs = require("../../../../../platform/contextkey/common/contextkey.js");
class ShowNextInlineSuggestionAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = (0, _commandIdsJs.showNextInlineSuggestionActionId);
    }
    constructor(){
        super({
            id: ShowNextInlineSuggestionAction.ID,
            label: _nlsJs.localize("action.inlineSuggest.showNext", "Show Next Inline Suggestion"),
            alias: "Show Next Inline Suggestion",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys).inlineSuggestionVisible),
            kbOpts: {
                weight: 100,
                primary: 606 /* KeyCode.BracketRight */ 
            }
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineCompletionsControllerJs.InlineCompletionsController).get(editor);
        controller?.model.get()?.next();
    }
}
class ShowPreviousInlineSuggestionAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = (0, _commandIdsJs.showPreviousInlineSuggestionActionId);
    }
    constructor(){
        super({
            id: ShowPreviousInlineSuggestionAction.ID,
            label: _nlsJs.localize("action.inlineSuggest.showPrevious", "Show Previous Inline Suggestion"),
            alias: "Show Previous Inline Suggestion",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys).inlineSuggestionVisible),
            kbOpts: {
                weight: 100,
                primary: 604 /* KeyCode.BracketLeft */ 
            }
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineCompletionsControllerJs.InlineCompletionsController).get(editor);
        controller?.model.get()?.previous();
    }
}
class TriggerInlineSuggestionAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.inlineSuggest.trigger",
            label: _nlsJs.localize("action.inlineSuggest.trigger", "Trigger Inline Suggestion"),
            alias: "Trigger Inline Suggestion",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineCompletionsControllerJs.InlineCompletionsController).get(editor);
        await (0, _baseJs.asyncTransaction)(async (tx)=>{
            /** @description triggerExplicitly from command */ await controller?.model.get()?.triggerExplicitly(tx);
            controller?.playAccessibilitySignal(tx);
        });
    }
}
class AcceptNextWordOfInlineCompletion extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.inlineSuggest.acceptNextWord",
            label: _nlsJs.localize("action.inlineSuggest.acceptNextWord", "Accept Next Word Of Inline Suggestion"),
            alias: "Accept Next Word Of Inline Suggestion",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys).inlineSuggestionVisible),
            kbOpts: {
                weight: 101,
                primary: 2065 /* KeyCode.RightArrow */ ,
                kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys).inlineSuggestionVisible)
            },
            menuOpts: [
                {
                    menuId: (0, _actionsJs.MenuId).InlineSuggestionToolbar,
                    title: _nlsJs.localize("acceptWord", "Accept Word"),
                    group: "primary",
                    order: 2
                }
            ]
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineCompletionsControllerJs.InlineCompletionsController).get(editor);
        await controller?.model.get()?.acceptNextWord(controller.editor);
    }
}
class AcceptNextLineOfInlineCompletion extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.inlineSuggest.acceptNextLine",
            label: _nlsJs.localize("action.inlineSuggest.acceptNextLine", "Accept Next Line Of Inline Suggestion"),
            alias: "Accept Next Line Of Inline Suggestion",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys).inlineSuggestionVisible),
            kbOpts: {
                weight: 101
            },
            menuOpts: [
                {
                    menuId: (0, _actionsJs.MenuId).InlineSuggestionToolbar,
                    title: _nlsJs.localize("acceptLine", "Accept Line"),
                    group: "secondary",
                    order: 2
                }
            ]
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineCompletionsControllerJs.InlineCompletionsController).get(editor);
        await controller?.model.get()?.acceptNextLine(controller.editor);
    }
}
class AcceptInlineCompletion extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _commandIdsJs.inlineSuggestCommitId),
            label: _nlsJs.localize("action.inlineSuggest.accept", "Accept Inline Suggestion"),
            alias: "Accept Inline Suggestion",
            precondition: (0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys).inlineSuggestionVisible,
            menuOpts: [
                {
                    menuId: (0, _actionsJs.MenuId).InlineSuggestionToolbar,
                    title: _nlsJs.localize("accept", "Accept"),
                    group: "primary",
                    order: 1
                }
            ],
            kbOpts: {
                primary: 2 /* KeyCode.Tab */ ,
                weight: 200,
                kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys).inlineSuggestionVisible, (0, _editorContextKeysJs.EditorContextKeys).tabMovesFocus.toNegated(), (0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys).inlineSuggestionHasIndentationLessThanTabSize, (0, _suggestJs.Context).Visible.toNegated(), (0, _editorContextKeysJs.EditorContextKeys).hoverFocused.toNegated())
            }
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineCompletionsControllerJs.InlineCompletionsController).get(editor);
        if (controller) {
            controller.model.get()?.accept(controller.editor);
            controller.editor.focus();
        }
    }
}
class HideInlineCompletion extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.inlineSuggest.hide";
    }
    constructor(){
        super({
            id: HideInlineCompletion.ID,
            label: _nlsJs.localize("action.inlineSuggest.hide", "Hide Inline Suggestion"),
            alias: "Hide Inline Suggestion",
            precondition: (0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys).inlineSuggestionVisible,
            kbOpts: {
                weight: 100,
                primary: 9 /* KeyCode.Escape */ 
            }
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineCompletionsControllerJs.InlineCompletionsController).get(editor);
        (0, _observableJs.transaction)((tx)=>{
            controller?.model.get()?.stop(tx);
        });
    }
}
class ToggleAlwaysShowInlineSuggestionToolbar extends (0, _actionsJs.Action2) {
    static{
        this.ID = "editor.action.inlineSuggest.toggleAlwaysShowToolbar";
    }
    constructor(){
        super({
            id: ToggleAlwaysShowInlineSuggestionToolbar.ID,
            title: _nlsJs.localize("action.inlineSuggest.alwaysShowToolbar", "Always Show Toolbar"),
            f1: false,
            precondition: undefined,
            menu: [
                {
                    id: (0, _actionsJs.MenuId).InlineSuggestionToolbar,
                    group: "secondary",
                    order: 10
                }
            ],
            toggled: (0, _contextkeyJs.ContextKeyExpr).equals("config.editor.inlineSuggest.showToolbar", "always")
        });
    }
    async run(accessor, editor) {
        const configService = accessor.get((0, _configurationJs.IConfigurationService));
        const currentValue = configService.getValue("editor.inlineSuggest.showToolbar");
        const newValue = currentValue === "always" ? "onHover" : "always";
        configService.updateValue("editor.inlineSuggest.showToolbar", newValue);
    }
}

},{"../../../../../base/common/observable.js":"2xbG5","../../../../../base/common/observableInternal/base.js":"lYJZ2","../../../../browser/editorExtensions.js":"kC3w6","../../../../common/editorContextKeys.js":"5exv9","./commandIds.js":"5ZG0b","./inlineCompletionContextKeys.js":"dbRGN","./inlineCompletionsController.js":"gcSfI","../../../suggest/browser/suggest.js":"8xSUV","../../../../../nls.js":"l617d","../../../../../platform/actions/common/actions.js":"kyMtp","../../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../../platform/contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dbRGN":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineCompletionContextKeys", ()=>InlineCompletionContextKeys);
var _observableJs = require("../../../../../base/common/observable.js");
var _stringsJs = require("../../../../../base/common/strings.js");
var _cursorColumnsJs = require("../../../../common/core/cursorColumns.js");
var _contextkeyJs = require("../../../../../platform/contextkey/common/contextkey.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _nlsJs = require("../../../../../nls.js");
class InlineCompletionContextKeys extends (0, _lifecycleJs.Disposable) {
    static{
        this.inlineSuggestionVisible = new (0, _contextkeyJs.RawContextKey)("inlineSuggestionVisible", false, (0, _nlsJs.localize)("inlineSuggestionVisible", "Whether an inline suggestion is visible"));
    }
    static{
        this.inlineSuggestionHasIndentation = new (0, _contextkeyJs.RawContextKey)("inlineSuggestionHasIndentation", false, (0, _nlsJs.localize)("inlineSuggestionHasIndentation", "Whether the inline suggestion starts with whitespace"));
    }
    static{
        this.inlineSuggestionHasIndentationLessThanTabSize = new (0, _contextkeyJs.RawContextKey)("inlineSuggestionHasIndentationLessThanTabSize", true, (0, _nlsJs.localize)("inlineSuggestionHasIndentationLessThanTabSize", "Whether the inline suggestion starts with whitespace that is less than what would be inserted by tab"));
    }
    static{
        this.suppressSuggestions = new (0, _contextkeyJs.RawContextKey)("inlineSuggestionSuppressSuggestions", undefined, (0, _nlsJs.localize)("suppressSuggestions", "Whether suggestions should be suppressed for the current suggestion"));
    }
    constructor(contextKeyService, model){
        super();
        this.contextKeyService = contextKeyService;
        this.model = model;
        this.inlineCompletionVisible = InlineCompletionContextKeys.inlineSuggestionVisible.bindTo(this.contextKeyService);
        this.inlineCompletionSuggestsIndentation = InlineCompletionContextKeys.inlineSuggestionHasIndentation.bindTo(this.contextKeyService);
        this.inlineCompletionSuggestsIndentationLessThanTabSize = InlineCompletionContextKeys.inlineSuggestionHasIndentationLessThanTabSize.bindTo(this.contextKeyService);
        this.suppressSuggestions = InlineCompletionContextKeys.suppressSuggestions.bindTo(this.contextKeyService);
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update context key: inlineCompletionVisible, suppressSuggestions */ const model = this.model.read(reader);
            const state = model?.state.read(reader);
            const isInlineCompletionVisible = !!state?.inlineCompletion && state?.primaryGhostText !== undefined && !state?.primaryGhostText.isEmpty();
            this.inlineCompletionVisible.set(isInlineCompletionVisible);
            if (state?.primaryGhostText && state?.inlineCompletion) this.suppressSuggestions.set(state.inlineCompletion.inlineCompletion.source.inlineCompletions.suppressSuggestions);
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update context key: inlineCompletionSuggestsIndentation, inlineCompletionSuggestsIndentationLessThanTabSize */ const model = this.model.read(reader);
            let startsWithIndentation = false;
            let startsWithIndentationLessThanTabSize = true;
            const ghostText = model?.primaryGhostText.read(reader);
            if (!!model?.selectedSuggestItem && ghostText && ghostText.parts.length > 0) {
                const { column, lines } = ghostText.parts[0];
                const firstLine = lines[0];
                const indentationEndColumn = model.textModel.getLineIndentColumn(ghostText.lineNumber);
                const inIndentation = column <= indentationEndColumn;
                if (inIndentation) {
                    let firstNonWsIdx = (0, _stringsJs.firstNonWhitespaceIndex)(firstLine);
                    if (firstNonWsIdx === -1) firstNonWsIdx = firstLine.length - 1;
                    startsWithIndentation = firstNonWsIdx > 0;
                    const tabSize = model.textModel.getOptions().tabSize;
                    const visibleColumnIndentation = (0, _cursorColumnsJs.CursorColumns).visibleColumnFromColumn(firstLine, firstNonWsIdx + 1, tabSize);
                    startsWithIndentationLessThanTabSize = visibleColumnIndentation < tabSize;
                }
            }
            this.inlineCompletionSuggestsIndentation.set(startsWithIndentation);
            this.inlineCompletionSuggestsIndentationLessThanTabSize.set(startsWithIndentationLessThanTabSize);
        }));
    }
}

},{"../../../../../base/common/observable.js":"2xbG5","../../../../../base/common/strings.js":"aA9I1","../../../../common/core/cursorColumns.js":"idX7D","../../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gcSfI":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineCompletionsController", ()=>InlineCompletionsController);
var _domObservableJs = require("../../../../../base/browser/domObservable.js");
var _ariaJs = require("../../../../../base/browser/ui/aria/aria.js");
var _asyncJs = require("../../../../../base/common/async.js");
var _cancellationJs = require("../../../../../base/common/cancellation.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _derivedJs = require("../../../../../base/common/observableInternal/derived.js");
var _utilsJs = require("../../../../../base/common/observableInternal/utils.js");
var _typesJs = require("../../../../../base/common/types.js");
var _coreCommandsJs = require("../../../../browser/coreCommands.js");
var _observableCodeEditorJs = require("../../../../browser/observableCodeEditor.js");
var _positionJs = require("../../../../common/core/position.js");
var _languageFeatureDebounceJs = require("../../../../common/services/languageFeatureDebounce.js");
var _languageFeaturesJs = require("../../../../common/services/languageFeatures.js");
var _commandIdsJs = require("./commandIds.js");
var _ghostTextViewJs = require("../view/ghostTextView.js");
var _inlineCompletionContextKeysJs = require("./inlineCompletionContextKeys.js");
var _inlineCompletionsHintsWidgetJs = require("../hintsWidget/inlineCompletionsHintsWidget.js");
var _inlineCompletionsModelJs = require("../model/inlineCompletionsModel.js");
var _suggestWidgetAdaptorJs = require("../model/suggestWidgetAdaptor.js");
var _nlsJs = require("../../../../../nls.js");
var _accessibilityJs = require("../../../../../platform/accessibility/common/accessibility.js");
var _accessibilitySignalServiceJs = require("../../../../../platform/accessibilitySignal/browser/accessibilitySignalService.js");
var _commandsJs = require("../../../../../platform/commands/common/commands.js");
var _configurationJs = require("../../../../../platform/configuration/common/configuration.js");
var _contextkeyJs = require("../../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../../platform/instantiation/common/instantiation.js");
var _keybindingJs = require("../../../../../platform/keybinding/common/keybinding.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var InlineCompletionsController_1;
let InlineCompletionsController = class InlineCompletionsController extends (0, _lifecycleJs.Disposable) {
    static{
        InlineCompletionsController_1 = this;
    }
    static{
        this.ID = "editor.contrib.inlineCompletionsController";
    }
    static get(editor) {
        return editor.getContribution(InlineCompletionsController_1.ID);
    }
    constructor(editor, _instantiationService, _contextKeyService, _configurationService, _commandService, _debounceService, _languageFeaturesService, _accessibilitySignalService, _keybindingService, _accessibilityService){
        super();
        this.editor = editor;
        this._instantiationService = _instantiationService;
        this._contextKeyService = _contextKeyService;
        this._configurationService = _configurationService;
        this._commandService = _commandService;
        this._debounceService = _debounceService;
        this._languageFeaturesService = _languageFeaturesService;
        this._accessibilitySignalService = _accessibilitySignalService;
        this._keybindingService = _keybindingService;
        this._accessibilityService = _accessibilityService;
        this._editorObs = (0, _observableCodeEditorJs.observableCodeEditor)(this.editor);
        this._positions = (0, _observableJs.derived)(this, (reader)=>this._editorObs.selections.read(reader)?.map((s)=>s.getEndPosition()) ?? [
                new (0, _positionJs.Position)(1, 1)
            ]);
        this._suggestWidgetAdaptor = this._register(new (0, _suggestWidgetAdaptorJs.SuggestWidgetAdaptor)(this.editor, ()=>{
            this._editorObs.forceUpdate();
            return this.model.get()?.selectedInlineCompletion.get()?.toSingleTextEdit(undefined);
        }, (item)=>this._editorObs.forceUpdate((_tx)=>{
                /** @description InlineCompletionsController.handleSuggestAccepted */ this.model.get()?.handleSuggestAccepted(item);
            })));
        this._suggestWidgetSelectedItem = (0, _observableJs.observableFromEvent)(this, (cb)=>this._suggestWidgetAdaptor.onDidSelectedItemChange(()=>{
                this._editorObs.forceUpdate((_tx)=>cb(undefined));
            }), ()=>this._suggestWidgetAdaptor.selectedItem);
        this._enabledInConfig = (0, _observableJs.observableFromEvent)(this, this.editor.onDidChangeConfiguration, ()=>this.editor.getOption(62 /* EditorOption.inlineSuggest */ ).enabled);
        this._isScreenReaderEnabled = (0, _observableJs.observableFromEvent)(this, this._accessibilityService.onDidChangeScreenReaderOptimized, ()=>this._accessibilityService.isScreenReaderOptimized());
        this._editorDictationInProgress = (0, _observableJs.observableFromEvent)(this, this._contextKeyService.onDidChangeContext, ()=>this._contextKeyService.getContext(this.editor.getDomNode()).getValue("editorDictation.inProgress") === true);
        this._enabled = (0, _observableJs.derived)(this, (reader)=>this._enabledInConfig.read(reader) && (!this._isScreenReaderEnabled.read(reader) || !this._editorDictationInProgress.read(reader)));
        this._debounceValue = this._debounceService.for(this._languageFeaturesService.inlineCompletionsProvider, "InlineCompletionsDebounce", {
            min: 50,
            max: 50
        });
        this.model = (0, _derivedJs.derivedDisposable)(this, (reader)=>{
            if (this._editorObs.isReadonly.read(reader)) return undefined;
            const textModel = this._editorObs.model.read(reader);
            if (!textModel) return undefined;
            const model = this._instantiationService.createInstance((0, _inlineCompletionsModelJs.InlineCompletionsModel), textModel, this._suggestWidgetSelectedItem, this._editorObs.versionId, this._positions, this._debounceValue, (0, _observableJs.observableFromEvent)(this.editor.onDidChangeConfiguration, ()=>this.editor.getOption(119 /* EditorOption.suggest */ ).preview), (0, _observableJs.observableFromEvent)(this.editor.onDidChangeConfiguration, ()=>this.editor.getOption(119 /* EditorOption.suggest */ ).previewMode), (0, _observableJs.observableFromEvent)(this.editor.onDidChangeConfiguration, ()=>this.editor.getOption(62 /* EditorOption.inlineSuggest */ ).mode), this._enabled);
            return model;
        }).recomputeInitiallyAndOnChange(this._store);
        this._ghostTexts = (0, _observableJs.derived)(this, (reader)=>{
            const model = this.model.read(reader);
            return model?.ghostTexts.read(reader) ?? [];
        });
        this._stablizedGhostTexts = convertItemsToStableObservables(this._ghostTexts, this._store);
        this._ghostTextWidgets = (0, _utilsJs.mapObservableArrayCached)(this, this._stablizedGhostTexts, (ghostText, store)=>store.add(this._instantiationService.createInstance((0, _ghostTextViewJs.GhostTextView), this.editor, {
                ghostText: ghostText,
                minReservedLineCount: (0, _observableJs.constObservable)(0),
                targetTextModel: this.model.map((v)=>v?.textModel)
            }))).recomputeInitiallyAndOnChange(this._store);
        this._playAccessibilitySignal = (0, _observableJs.observableSignal)(this);
        this._fontFamily = (0, _observableJs.observableFromEvent)(this, this.editor.onDidChangeConfiguration, ()=>this.editor.getOption(62 /* EditorOption.inlineSuggest */ ).fontFamily);
        this._register(new (0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys)(this._contextKeyService, this.model));
        this._register((0, _observableCodeEditorJs.reactToChange)(this._editorObs.onDidType, (_value, _changes)=>{
            if (this._enabled.get()) this.model.get()?.trigger();
        }));
        this._register(this._commandService.onDidExecuteCommand((e)=>{
            // These commands don't trigger onDidType.
            const commands = new Set([
                (0, _coreCommandsJs.CoreEditingCommands).Tab.id,
                (0, _coreCommandsJs.CoreEditingCommands).DeleteLeft.id,
                (0, _coreCommandsJs.CoreEditingCommands).DeleteRight.id,
                (0, _commandIdsJs.inlineSuggestCommitId),
                "acceptSelectedSuggestion"
            ]);
            if (commands.has(e.commandId) && editor.hasTextFocus() && this._enabled.get()) this._editorObs.forceUpdate((tx)=>{
                /** @description onDidExecuteCommand */ this.model.get()?.trigger(tx);
            });
        }));
        this._register((0, _observableCodeEditorJs.reactToChange)(this._editorObs.selections, (_value, changes)=>{
            if (changes.some((e)=>e.reason === 3 /* CursorChangeReason.Explicit */  || e.source === "api")) this.model.get()?.stop();
        }));
        this._register(this.editor.onDidBlurEditorWidget(()=>{
            // This is a hidden setting very useful for debugging
            if (this._contextKeyService.getContextKeyValue("accessibleViewIsShown") || this._configurationService.getValue("editor.inlineSuggest.keepOnBlur") || editor.getOption(62 /* EditorOption.inlineSuggest */ ).keepOnBlur || (0, _inlineCompletionsHintsWidgetJs.InlineSuggestionHintsContentWidget).dropDownVisible) return;
            (0, _observableJs.transaction)((tx)=>{
                /** @description InlineCompletionsController.onDidBlurEditorWidget */ this.model.get()?.stop(tx);
            });
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description InlineCompletionsController.forceRenderingAbove */ const state = this.model.read(reader)?.state.read(reader);
            if (state?.suggestItem) {
                if (state.primaryGhostText.lineCount >= 2) this._suggestWidgetAdaptor.forceRenderingAbove();
            } else this._suggestWidgetAdaptor.stopForceRenderingAbove();
        }));
        this._register((0, _lifecycleJs.toDisposable)(()=>{
            this._suggestWidgetAdaptor.stopForceRenderingAbove();
        }));
        const currentInlineCompletionBySemanticId = (0, _utilsJs.derivedObservableWithCache)(this, (reader, last)=>{
            const model = this.model.read(reader);
            const state = model?.state.read(reader);
            if (this._suggestWidgetSelectedItem.get()) return last;
            return state?.inlineCompletion?.semanticId;
        });
        this._register((0, _observableCodeEditorJs.reactToChangeWithStore)((0, _observableJs.derived)((reader)=>{
            this._playAccessibilitySignal.read(reader);
            currentInlineCompletionBySemanticId.read(reader);
            return {};
        }), async (_value, _deltas, store)=>{
            /** @description InlineCompletionsController.playAccessibilitySignalAndReadSuggestion */ const model = this.model.get();
            const state = model?.state.get();
            if (!state || !model) return;
            const lineText = model.textModel.getLineContent(state.primaryGhostText.lineNumber);
            await (0, _asyncJs.timeout)(50, (0, _cancellationJs.cancelOnDispose)(store));
            await (0, _observableJs.waitForState)(this._suggestWidgetSelectedItem, (0, _typesJs.isUndefined), ()=>false, (0, _cancellationJs.cancelOnDispose)(store));
            await this._accessibilitySignalService.playSignal((0, _accessibilitySignalServiceJs.AccessibilitySignal).inlineSuggestion);
            if (this.editor.getOption(8 /* EditorOption.screenReaderAnnounceInlineSuggestion */ )) this._provideScreenReaderUpdate(state.primaryGhostText.renderForScreenReader(lineText));
        }));
        this._register(new (0, _inlineCompletionsHintsWidgetJs.InlineCompletionsHintsWidget)(this.editor, this.model, this._instantiationService));
        this._register((0, _domObservableJs.createStyleSheetFromObservable)((0, _observableJs.derived)((reader)=>{
            const fontFamily = this._fontFamily.read(reader);
            if (fontFamily === "" || fontFamily === "default") return "";
            return `
.monaco-editor .ghost-text-decoration,
.monaco-editor .ghost-text-decoration-preview,
.monaco-editor .ghost-text {
	font-family: ${fontFamily};
}`;
        })));
        // TODO@hediet
        this._register(this._configurationService.onDidChangeConfiguration((e)=>{
            if (e.affectsConfiguration("accessibility.verbosity.inlineCompletions")) this.editor.updateOptions({
                inlineCompletionsAccessibilityVerbose: this._configurationService.getValue("accessibility.verbosity.inlineCompletions")
            });
        }));
        this.editor.updateOptions({
            inlineCompletionsAccessibilityVerbose: this._configurationService.getValue("accessibility.verbosity.inlineCompletions")
        });
    }
    playAccessibilitySignal(tx) {
        this._playAccessibilitySignal.trigger(tx);
    }
    _provideScreenReaderUpdate(content) {
        const accessibleViewShowing = this._contextKeyService.getContextKeyValue("accessibleViewIsShown");
        const accessibleViewKeybinding = this._keybindingService.lookupKeybinding("editor.action.accessibleView");
        let hint;
        if (!accessibleViewShowing && accessibleViewKeybinding && this.editor.getOption(150 /* EditorOption.inlineCompletionsAccessibilityVerbose */ )) hint = (0, _nlsJs.localize)("showAccessibleViewHint", "Inspect this in the accessible view ({0})", accessibleViewKeybinding.getAriaLabel());
        (0, _ariaJs.alert)(hint ? content + ", " + hint : content);
    }
    shouldShowHoverAt(range) {
        const ghostText = this.model.get()?.primaryGhostText.get();
        if (ghostText) return ghostText.parts.some((p)=>range.containsPosition(new (0, _positionJs.Position)(ghostText.lineNumber, p.column)));
        return false;
    }
    shouldShowHoverAtViewZone(viewZoneId) {
        return this._ghostTextWidgets.get()[0]?.ownsViewZone(viewZoneId) ?? false;
    }
};
InlineCompletionsController = InlineCompletionsController_1 = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService)),
    __param(2, (0, _contextkeyJs.IContextKeyService)),
    __param(3, (0, _configurationJs.IConfigurationService)),
    __param(4, (0, _commandsJs.ICommandService)),
    __param(5, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService)),
    __param(6, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(7, (0, _accessibilitySignalServiceJs.IAccessibilitySignalService)),
    __param(8, (0, _keybindingJs.IKeybindingService)),
    __param(9, (0, _accessibilityJs.IAccessibilityService))
], InlineCompletionsController);
function convertItemsToStableObservables(items, store) {
    const result = (0, _observableJs.observableValue)("result", []);
    const innerObservables = [];
    store.add((0, _observableJs.autorun)((reader)=>{
        const itemsValue = items.read(reader);
        (0, _observableJs.transaction)((tx)=>{
            if (itemsValue.length !== innerObservables.length) {
                innerObservables.length = itemsValue.length;
                for(let i = 0; i < innerObservables.length; i++)if (!innerObservables[i]) innerObservables[i] = (0, _observableJs.observableValue)("item", itemsValue[i]);
                result.set([
                    ...innerObservables
                ], tx);
            }
            innerObservables.forEach((o, i)=>o.set(itemsValue[i], tx));
        });
    }));
    return result;
}

},{"../../../../../base/browser/domObservable.js":"hjUTn","../../../../../base/browser/ui/aria/aria.js":"asrsh","../../../../../base/common/async.js":"4GJc4","../../../../../base/common/cancellation.js":"hoVxw","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../../base/common/observableInternal/derived.js":"hZb5S","../../../../../base/common/observableInternal/utils.js":"4p38u","../../../../../base/common/types.js":"fb5yx","../../../../browser/coreCommands.js":"3GyQi","../../../../browser/observableCodeEditor.js":"hfBd1","../../../../common/core/position.js":"lvrPe","../../../../common/services/languageFeatureDebounce.js":"YGXXG","../../../../common/services/languageFeatures.js":"2IAko","./commandIds.js":"5ZG0b","../view/ghostTextView.js":"lVd92","./inlineCompletionContextKeys.js":"dbRGN","../hintsWidget/inlineCompletionsHintsWidget.js":"4zZCT","../model/inlineCompletionsModel.js":"8yIka","../model/suggestWidgetAdaptor.js":"jsdpQ","../../../../../nls.js":"l617d","../../../../../platform/accessibility/common/accessibility.js":"9Svqy","../../../../../platform/accessibilitySignal/browser/accessibilitySignalService.js":"hpeDM","../../../../../platform/commands/common/commands.js":"ho6ic","../../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../../platform/keybinding/common/keybinding.js":"25pLT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hjUTn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStyleSheetFromObservable", ()=>createStyleSheetFromObservable);
var _domJs = require("./dom.js");
var _lifecycleJs = require("../common/lifecycle.js");
var _observableJs = require("../common/observable.js");
function createStyleSheetFromObservable(css) {
    const store = new (0, _lifecycleJs.DisposableStore)();
    const w = store.add((0, _domJs.createStyleSheet2)());
    store.add((0, _observableJs.autorun)((reader)=>{
        w.setStyle(css.read(reader));
    }));
    return store;
}

},{"./dom.js":"bnqsM","../common/lifecycle.js":"9kg8d","../common/observable.js":"2xbG5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lVd92":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GHOST_TEXT_DESCRIPTION", ()=>GHOST_TEXT_DESCRIPTION);
parcelHelpers.export(exports, "GhostTextView", ()=>GhostTextView);
parcelHelpers.export(exports, "AdditionalLinesWidget", ()=>AdditionalLinesWidget);
parcelHelpers.export(exports, "ttPolicy", ()=>ttPolicy);
var _trustedTypesJs = require("../../../../../base/browser/trustedTypes.js");
var _eventJs = require("../../../../../base/common/event.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _stringsJs = require("../../../../../base/common/strings.js");
var _ghostTextViewCss = require("./ghostTextView.css");
var _domFontInfoJs = require("../../../../browser/config/domFontInfo.js");
var _editorOptionsJs = require("../../../../common/config/editorOptions.js");
var _positionJs = require("../../../../common/core/position.js");
var _rangeJs = require("../../../../common/core/range.js");
var _stringBuilderJs = require("../../../../common/core/stringBuilder.js");
var _languageJs = require("../../../../common/languages/language.js");
var _modelJs = require("../../../../common/model.js");
var _lineTokensJs = require("../../../../common/tokens/lineTokens.js");
var _lineDecorationsJs = require("../../../../common/viewLayout/lineDecorations.js");
var _viewLineRendererJs = require("../../../../common/viewLayout/viewLineRenderer.js");
var _ghostTextJs = require("../model/ghostText.js");
var _utilsJs = require("../utils.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const GHOST_TEXT_DESCRIPTION = "ghost-text";
let GhostTextView = class GhostTextView extends (0, _lifecycleJs.Disposable) {
    constructor(editor, model, languageService){
        super();
        this.editor = editor;
        this.model = model;
        this.languageService = languageService;
        this.isDisposed = (0, _observableJs.observableValue)(this, false);
        this.currentTextModel = (0, _observableJs.observableFromEvent)(this, this.editor.onDidChangeModel, ()=>/** @description editor.model */ this.editor.getModel());
        this.uiState = (0, _observableJs.derived)(this, (reader)=>{
            if (this.isDisposed.read(reader)) return undefined;
            const textModel = this.currentTextModel.read(reader);
            if (textModel !== this.model.targetTextModel.read(reader)) return undefined;
            const ghostText = this.model.ghostText.read(reader);
            if (!ghostText) return undefined;
            const replacedRange = ghostText instanceof (0, _ghostTextJs.GhostTextReplacement) ? ghostText.columnRange : undefined;
            const inlineTexts = [];
            const additionalLines = [];
            function addToAdditionalLines(lines, className) {
                if (additionalLines.length > 0) {
                    const lastLine = additionalLines[additionalLines.length - 1];
                    if (className) lastLine.decorations.push(new (0, _lineDecorationsJs.LineDecoration)(lastLine.content.length + 1, lastLine.content.length + 1 + lines[0].length, className, 0 /* InlineDecorationType.Regular */ ));
                    lastLine.content += lines[0];
                    lines = lines.slice(1);
                }
                for (const line of lines)additionalLines.push({
                    content: line,
                    decorations: className ? [
                        new (0, _lineDecorationsJs.LineDecoration)(1, line.length + 1, className, 0 /* InlineDecorationType.Regular */ )
                    ] : []
                });
            }
            const textBufferLine = textModel.getLineContent(ghostText.lineNumber);
            let hiddenTextStartColumn = undefined;
            let lastIdx = 0;
            for (const part of ghostText.parts){
                let lines = part.lines;
                if (hiddenTextStartColumn === undefined) {
                    inlineTexts.push({
                        column: part.column,
                        text: lines[0],
                        preview: part.preview
                    });
                    lines = lines.slice(1);
                } else addToAdditionalLines([
                    textBufferLine.substring(lastIdx, part.column - 1)
                ], undefined);
                if (lines.length > 0) {
                    addToAdditionalLines(lines, GHOST_TEXT_DESCRIPTION);
                    if (hiddenTextStartColumn === undefined && part.column <= textBufferLine.length) hiddenTextStartColumn = part.column;
                }
                lastIdx = part.column - 1;
            }
            if (hiddenTextStartColumn !== undefined) addToAdditionalLines([
                textBufferLine.substring(lastIdx)
            ], undefined);
            const hiddenRange = hiddenTextStartColumn !== undefined ? new (0, _utilsJs.ColumnRange)(hiddenTextStartColumn, textBufferLine.length + 1) : undefined;
            return {
                replacedRange,
                inlineTexts,
                additionalLines,
                hiddenRange,
                lineNumber: ghostText.lineNumber,
                additionalReservedLineCount: this.model.minReservedLineCount.read(reader),
                targetTextModel: textModel
            };
        });
        this.decorations = (0, _observableJs.derived)(this, (reader)=>{
            const uiState = this.uiState.read(reader);
            if (!uiState) return [];
            const decorations = [];
            if (uiState.replacedRange) decorations.push({
                range: uiState.replacedRange.toRange(uiState.lineNumber),
                options: {
                    inlineClassName: "inline-completion-text-to-replace",
                    description: "GhostTextReplacement"
                }
            });
            if (uiState.hiddenRange) decorations.push({
                range: uiState.hiddenRange.toRange(uiState.lineNumber),
                options: {
                    inlineClassName: "ghost-text-hidden",
                    description: "ghost-text-hidden"
                }
            });
            for (const p of uiState.inlineTexts)decorations.push({
                range: (0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(uiState.lineNumber, p.column)),
                options: {
                    description: GHOST_TEXT_DESCRIPTION,
                    after: {
                        content: p.text,
                        inlineClassName: p.preview ? "ghost-text-decoration-preview" : "ghost-text-decoration",
                        cursorStops: (0, _modelJs.InjectedTextCursorStops).Left
                    },
                    showIfCollapsed: true
                }
            });
            return decorations;
        });
        this.additionalLinesWidget = this._register(new AdditionalLinesWidget(this.editor, this.languageService.languageIdCodec, (0, _observableJs.derived)((reader)=>{
            /** @description lines */ const uiState = this.uiState.read(reader);
            return uiState ? {
                lineNumber: uiState.lineNumber,
                additionalLines: uiState.additionalLines,
                minReservedLineCount: uiState.additionalReservedLineCount,
                targetTextModel: uiState.targetTextModel
            } : undefined;
        })));
        this._register((0, _lifecycleJs.toDisposable)(()=>{
            this.isDisposed.set(true, undefined);
        }));
        this._register((0, _utilsJs.applyObservableDecorations)(this.editor, this.decorations));
    }
    ownsViewZone(viewZoneId) {
        return this.additionalLinesWidget.viewZoneId === viewZoneId;
    }
};
GhostTextView = __decorate([
    __param(2, (0, _languageJs.ILanguageService))
], GhostTextView);
class AdditionalLinesWidget extends (0, _lifecycleJs.Disposable) {
    get viewZoneId() {
        return this._viewZoneId;
    }
    constructor(editor, languageIdCodec, lines){
        super();
        this.editor = editor;
        this.languageIdCodec = languageIdCodec;
        this.lines = lines;
        this._viewZoneId = undefined;
        this.editorOptionsChanged = (0, _observableJs.observableSignalFromEvent)("editorOptionChanged", (0, _eventJs.Event).filter(this.editor.onDidChangeConfiguration, (e)=>e.hasChanged(33 /* EditorOption.disableMonospaceOptimizations */ ) || e.hasChanged(118 /* EditorOption.stopRenderingLineAfter */ ) || e.hasChanged(100 /* EditorOption.renderWhitespace */ ) || e.hasChanged(95 /* EditorOption.renderControlCharacters */ ) || e.hasChanged(51 /* EditorOption.fontLigatures */ ) || e.hasChanged(50 /* EditorOption.fontInfo */ ) || e.hasChanged(67 /* EditorOption.lineHeight */ )));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update view zone */ const lines = this.lines.read(reader);
            this.editorOptionsChanged.read(reader);
            if (lines) this.updateLines(lines.lineNumber, lines.additionalLines, lines.minReservedLineCount);
            else this.clear();
        }));
    }
    dispose() {
        super.dispose();
        this.clear();
    }
    clear() {
        this.editor.changeViewZones((changeAccessor)=>{
            if (this._viewZoneId) {
                changeAccessor.removeZone(this._viewZoneId);
                this._viewZoneId = undefined;
            }
        });
    }
    updateLines(lineNumber, additionalLines, minReservedLineCount) {
        const textModel = this.editor.getModel();
        if (!textModel) return;
        const { tabSize } = textModel.getOptions();
        this.editor.changeViewZones((changeAccessor)=>{
            if (this._viewZoneId) {
                changeAccessor.removeZone(this._viewZoneId);
                this._viewZoneId = undefined;
            }
            const heightInLines = Math.max(additionalLines.length, minReservedLineCount);
            if (heightInLines > 0) {
                const domNode = document.createElement("div");
                renderLines(domNode, tabSize, additionalLines, this.editor.getOptions(), this.languageIdCodec);
                this._viewZoneId = changeAccessor.addZone({
                    afterLineNumber: lineNumber,
                    heightInLines: heightInLines,
                    domNode,
                    afterColumnAffinity: 1 /* PositionAffinity.Right */ 
                });
            }
        });
    }
}
function renderLines(domNode, tabSize, lines, opts, languageIdCodec) {
    const disableMonospaceOptimizations = opts.get(33 /* EditorOption.disableMonospaceOptimizations */ );
    const stopRenderingLineAfter = opts.get(118 /* EditorOption.stopRenderingLineAfter */ );
    // To avoid visual confusion, we don't want to render visible whitespace
    const renderWhitespace = "none";
    const renderControlCharacters = opts.get(95 /* EditorOption.renderControlCharacters */ );
    const fontLigatures = opts.get(51 /* EditorOption.fontLigatures */ );
    const fontInfo = opts.get(50 /* EditorOption.fontInfo */ );
    const lineHeight = opts.get(67 /* EditorOption.lineHeight */ );
    const sb = new (0, _stringBuilderJs.StringBuilder)(10000);
    sb.appendString('<div class="suggest-preview-text">');
    for(let i = 0, len = lines.length; i < len; i++){
        const lineData = lines[i];
        const line = lineData.content;
        sb.appendString('<div class="view-line');
        sb.appendString('" style="top:');
        sb.appendString(String(i * lineHeight));
        sb.appendString('px;width:1000000px;">');
        const isBasicASCII = _stringsJs.isBasicASCII(line);
        const containsRTL = _stringsJs.containsRTL(line);
        const lineTokens = (0, _lineTokensJs.LineTokens).createEmpty(line, languageIdCodec);
        (0, _viewLineRendererJs.renderViewLine)(new (0, _viewLineRendererJs.RenderLineInput)(fontInfo.isMonospace && !disableMonospaceOptimizations, fontInfo.canUseHalfwidthRightwardsArrow, line, false, isBasicASCII, containsRTL, 0, lineTokens, lineData.decorations, tabSize, 0, fontInfo.spaceWidth, fontInfo.middotWidth, fontInfo.wsmiddotWidth, stopRenderingLineAfter, renderWhitespace, renderControlCharacters, fontLigatures !== (0, _editorOptionsJs.EditorFontLigatures).OFF, null), sb);
        sb.appendString("</div>");
    }
    sb.appendString("</div>");
    (0, _domFontInfoJs.applyFontInfo)(domNode, fontInfo);
    const html = sb.build();
    const trustedhtml = ttPolicy ? ttPolicy.createHTML(html) : html;
    domNode.innerHTML = trustedhtml;
}
const ttPolicy = (0, _trustedTypesJs.createTrustedTypesPolicy)("editorGhostText", {
    createHTML: (value)=>value
});

},{"../../../../../base/browser/trustedTypes.js":"bgQyv","../../../../../base/common/event.js":"4Zi8b","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../../base/common/strings.js":"aA9I1","./ghostTextView.css":"eXQxR","../../../../browser/config/domFontInfo.js":"fQezv","../../../../common/config/editorOptions.js":"3Xi00","../../../../common/core/position.js":"lvrPe","../../../../common/core/range.js":"jmUPh","../../../../common/core/stringBuilder.js":"hHgWQ","../../../../common/languages/language.js":"ka2JQ","../../../../common/model.js":"1CSIB","../../../../common/tokens/lineTokens.js":"6iUVx","../../../../common/viewLayout/lineDecorations.js":"m2bJX","../../../../common/viewLayout/viewLineRenderer.js":"1RGPz","../model/ghostText.js":"htVY2","../utils.js":"4lO9A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eXQxR":[function() {},{}],"htVY2":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GhostText", ()=>GhostText);
parcelHelpers.export(exports, "GhostTextPart", ()=>GhostTextPart);
parcelHelpers.export(exports, "GhostTextReplacement", ()=>GhostTextReplacement);
parcelHelpers.export(exports, "ghostTextsOrReplacementsEqual", ()=>ghostTextsOrReplacementsEqual);
parcelHelpers.export(exports, "ghostTextOrReplacementEquals", ()=>ghostTextOrReplacementEquals);
var _arraysJs = require("../../../../../base/common/arrays.js");
var _stringsJs = require("../../../../../base/common/strings.js");
var _positionJs = require("../../../../common/core/position.js");
var _rangeJs = require("../../../../common/core/range.js");
var _textEditJs = require("../../../../common/core/textEdit.js");
class GhostText {
    constructor(lineNumber, parts){
        this.lineNumber = lineNumber;
        this.parts = parts;
    }
    equals(other) {
        return this.lineNumber === other.lineNumber && this.parts.length === other.parts.length && this.parts.every((part, index)=>part.equals(other.parts[index]));
    }
    renderForScreenReader(lineText) {
        if (this.parts.length === 0) return "";
        const lastPart = this.parts[this.parts.length - 1];
        const cappedLineText = lineText.substr(0, lastPart.column - 1);
        const text = new (0, _textEditJs.TextEdit)([
            ...this.parts.map((p)=>new (0, _textEditJs.SingleTextEdit)((0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(1, p.column)), p.lines.join("\n")))
        ]).applyToString(cappedLineText);
        return text.substring(this.parts[0].column - 1);
    }
    isEmpty() {
        return this.parts.every((p)=>p.lines.length === 0);
    }
    get lineCount() {
        return 1 + this.parts.reduce((r, p)=>r + p.lines.length - 1, 0);
    }
}
class GhostTextPart {
    constructor(column, text, /**
     * Indicates if this part is a preview of an inline suggestion when a suggestion is previewed.
    */ preview){
        this.column = column;
        this.text = text;
        this.preview = preview;
        this.lines = (0, _stringsJs.splitLines)(this.text);
    }
    equals(other) {
        return this.column === other.column && this.lines.length === other.lines.length && this.lines.every((line, index)=>line === other.lines[index]);
    }
}
class GhostTextReplacement {
    constructor(lineNumber, columnRange, text, additionalReservedLineCount = 0){
        this.lineNumber = lineNumber;
        this.columnRange = columnRange;
        this.text = text;
        this.additionalReservedLineCount = additionalReservedLineCount;
        this.parts = [
            new GhostTextPart(this.columnRange.endColumnExclusive, this.text, false)
        ];
        this.newLines = (0, _stringsJs.splitLines)(this.text);
    }
    renderForScreenReader(_lineText) {
        return this.newLines.join("\n");
    }
    get lineCount() {
        return this.newLines.length;
    }
    isEmpty() {
        return this.parts.every((p)=>p.lines.length === 0);
    }
    equals(other) {
        return this.lineNumber === other.lineNumber && this.columnRange.equals(other.columnRange) && this.newLines.length === other.newLines.length && this.newLines.every((line, index)=>line === other.newLines[index]) && this.additionalReservedLineCount === other.additionalReservedLineCount;
    }
}
function ghostTextsOrReplacementsEqual(a, b) {
    return (0, _arraysJs.equals)(a, b, ghostTextOrReplacementEquals);
}
function ghostTextOrReplacementEquals(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (a instanceof GhostText && b instanceof GhostText) return a.equals(b);
    if (a instanceof GhostTextReplacement && b instanceof GhostTextReplacement) return a.equals(b);
    return false;
}

},{"../../../../../base/common/arrays.js":"DECei","../../../../../base/common/strings.js":"aA9I1","../../../../common/core/position.js":"lvrPe","../../../../common/core/range.js":"jmUPh","../../../../common/core/textEdit.js":"hdqra","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4lO9A":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getReadonlyEmptyArray", ()=>getReadonlyEmptyArray);
parcelHelpers.export(exports, "ColumnRange", ()=>ColumnRange);
parcelHelpers.export(exports, "applyObservableDecorations", ()=>applyObservableDecorations);
parcelHelpers.export(exports, "addPositions", ()=>addPositions);
parcelHelpers.export(exports, "subtractPositions", ()=>subtractPositions);
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
const array = [];
function getReadonlyEmptyArray() {
    return array;
}
class ColumnRange {
    constructor(startColumn, endColumnExclusive){
        this.startColumn = startColumn;
        this.endColumnExclusive = endColumnExclusive;
        if (startColumn > endColumnExclusive) throw new (0, _errorsJs.BugIndicatingError)(`startColumn ${startColumn} cannot be after endColumnExclusive ${endColumnExclusive}`);
    }
    toRange(lineNumber) {
        return new (0, _rangeJs.Range)(lineNumber, this.startColumn, lineNumber, this.endColumnExclusive);
    }
    equals(other) {
        return this.startColumn === other.startColumn && this.endColumnExclusive === other.endColumnExclusive;
    }
}
function applyObservableDecorations(editor, decorations) {
    const d = new (0, _lifecycleJs.DisposableStore)();
    const decorationsCollection = editor.createDecorationsCollection();
    d.add((0, _observableJs.autorunOpts)({
        debugName: ()=>`Apply decorations from ${decorations.debugName}`
    }, (reader)=>{
        const d = decorations.read(reader);
        decorationsCollection.set(d);
    }));
    d.add({
        dispose: ()=>{
            decorationsCollection.clear();
        }
    });
    return d;
}
function addPositions(pos1, pos2) {
    return new (0, _positionJs.Position)(pos1.lineNumber + pos2.lineNumber - 1, pos2.lineNumber === 1 ? pos1.column + pos2.column - 1 : pos2.column);
}
function subtractPositions(pos1, pos2) {
    return new (0, _positionJs.Position)(pos1.lineNumber - pos2.lineNumber + 1, pos1.lineNumber - pos2.lineNumber === 0 ? pos1.column - pos2.column + 1 : pos1.column);
}

},{"../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8yIka":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineCompletionsModel", ()=>InlineCompletionsModel);
parcelHelpers.export(exports, "VersionIdChangeReason", ()=>VersionIdChangeReason);
parcelHelpers.export(exports, "getSecondaryEdits", ()=>getSecondaryEdits);
var _arraysJs = require("../../../../../base/common/arrays.js");
var _arraysFindJs = require("../../../../../base/common/arraysFind.js");
var _equalsJs = require("../../../../../base/common/equals.js");
var _errorsJs = require("../../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _stringsJs = require("../../../../../base/common/strings.js");
var _typesJs = require("../../../../../base/common/types.js");
var _editOperationJs = require("../../../../common/core/editOperation.js");
var _positionJs = require("../../../../common/core/position.js");
var _rangeJs = require("../../../../common/core/range.js");
var _selectionJs = require("../../../../common/core/selection.js");
var _textEditJs = require("../../../../common/core/textEdit.js");
var _textLengthJs = require("../../../../common/core/textLength.js");
var _languagesJs = require("../../../../common/languages.js");
var _languageConfigurationRegistryJs = require("../../../../common/languages/languageConfigurationRegistry.js");
var _ghostTextJs = require("./ghostText.js");
var _inlineCompletionsSourceJs = require("./inlineCompletionsSource.js");
var _singleTextEditJs = require("./singleTextEdit.js");
var _utilsJs = require("../utils.js");
var _snippetController2Js = require("../../../snippet/browser/snippetController2.js");
var _commandsJs = require("../../../../../platform/commands/common/commands.js");
var _instantiationJs = require("../../../../../platform/instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let InlineCompletionsModel = class InlineCompletionsModel extends (0, _lifecycleJs.Disposable) {
    get isAcceptingPartially() {
        return this._isAcceptingPartially;
    }
    constructor(textModel, selectedSuggestItem, _textModelVersionId, _positions, _debounceValue, _suggestPreviewEnabled, _suggestPreviewMode, _inlineSuggestMode, _enabled, _instantiationService, _commandService, _languageConfigurationService){
        super();
        this.textModel = textModel;
        this.selectedSuggestItem = selectedSuggestItem;
        this._textModelVersionId = _textModelVersionId;
        this._positions = _positions;
        this._debounceValue = _debounceValue;
        this._suggestPreviewEnabled = _suggestPreviewEnabled;
        this._suggestPreviewMode = _suggestPreviewMode;
        this._inlineSuggestMode = _inlineSuggestMode;
        this._enabled = _enabled;
        this._instantiationService = _instantiationService;
        this._commandService = _commandService;
        this._languageConfigurationService = _languageConfigurationService;
        this._source = this._register(this._instantiationService.createInstance((0, _inlineCompletionsSourceJs.InlineCompletionsSource), this.textModel, this._textModelVersionId, this._debounceValue));
        this._isActive = (0, _observableJs.observableValue)(this, false);
        this._forceUpdateExplicitlySignal = (0, _observableJs.observableSignal)(this);
        // We use a semantic id to keep the same inline completion selected even if the provider reorders the completions.
        this._selectedInlineCompletionId = (0, _observableJs.observableValue)(this, undefined);
        this._primaryPosition = (0, _observableJs.derived)(this, (reader)=>this._positions.read(reader)[0] ?? new (0, _positionJs.Position)(1, 1));
        this._isAcceptingPartially = false;
        this._preserveCurrentCompletionReasons = new Set([
            VersionIdChangeReason.Redo,
            VersionIdChangeReason.Undo,
            VersionIdChangeReason.AcceptWord
        ]);
        this._fetchInlineCompletionsPromise = (0, _observableJs.derivedHandleChanges)({
            owner: this,
            createEmptyChangeSummary: ()=>({
                    preserveCurrentCompletion: false,
                    inlineCompletionTriggerKind: (0, _languagesJs.InlineCompletionTriggerKind).Automatic
                }),
            handleChange: (ctx, changeSummary)=>{
                /** @description fetch inline completions */ if (ctx.didChange(this._textModelVersionId) && this._preserveCurrentCompletionReasons.has(this._getReason(ctx.change))) changeSummary.preserveCurrentCompletion = true;
                else if (ctx.didChange(this._forceUpdateExplicitlySignal)) changeSummary.inlineCompletionTriggerKind = (0, _languagesJs.InlineCompletionTriggerKind).Explicit;
                return true;
            }
        }, (reader, changeSummary)=>{
            this._forceUpdateExplicitlySignal.read(reader);
            const shouldUpdate = this._enabled.read(reader) && this.selectedSuggestItem.read(reader) || this._isActive.read(reader);
            if (!shouldUpdate) {
                this._source.cancelUpdate();
                return undefined;
            }
            this._textModelVersionId.read(reader); // Refetch on text change
            const suggestWidgetInlineCompletions = this._source.suggestWidgetInlineCompletions.get();
            const suggestItem = this.selectedSuggestItem.read(reader);
            if (suggestWidgetInlineCompletions && !suggestItem) {
                const inlineCompletions = this._source.inlineCompletions.get();
                (0, _observableJs.transaction)((tx)=>{
                    /** @description Seed inline completions with (newer) suggest widget inline completions */ if (!inlineCompletions || suggestWidgetInlineCompletions.request.versionId > inlineCompletions.request.versionId) this._source.inlineCompletions.set(suggestWidgetInlineCompletions.clone(), tx);
                    this._source.clearSuggestWidgetInlineCompletions(tx);
                });
            }
            const cursorPosition = this._primaryPosition.read(reader);
            const context = {
                triggerKind: changeSummary.inlineCompletionTriggerKind,
                selectedSuggestionInfo: suggestItem?.toSelectedSuggestionInfo()
            };
            const itemToPreserveCandidate = this.selectedInlineCompletion.get();
            const itemToPreserve = changeSummary.preserveCurrentCompletion || itemToPreserveCandidate?.forwardStable ? itemToPreserveCandidate : undefined;
            return this._source.fetch(cursorPosition, context, itemToPreserve);
        });
        this._filteredInlineCompletionItems = (0, _observableJs.derivedOpts)({
            owner: this,
            equalsFn: (0, _equalsJs.itemsEquals)()
        }, (reader)=>{
            const c = this._source.inlineCompletions.read(reader);
            if (!c) return [];
            const cursorPosition = this._primaryPosition.read(reader);
            const filteredCompletions = c.inlineCompletions.filter((c)=>c.isVisible(this.textModel, cursorPosition, reader));
            return filteredCompletions;
        });
        this.selectedInlineCompletionIndex = (0, _observableJs.derived)(this, (reader)=>{
            const selectedInlineCompletionId = this._selectedInlineCompletionId.read(reader);
            const filteredCompletions = this._filteredInlineCompletionItems.read(reader);
            const idx = this._selectedInlineCompletionId === undefined ? -1 : filteredCompletions.findIndex((v)=>v.semanticId === selectedInlineCompletionId);
            if (idx === -1) {
                // Reset the selection so that the selection does not jump back when it appears again
                this._selectedInlineCompletionId.set(undefined, undefined);
                return 0;
            }
            return idx;
        });
        this.selectedInlineCompletion = (0, _observableJs.derived)(this, (reader)=>{
            const filteredCompletions = this._filteredInlineCompletionItems.read(reader);
            const idx = this.selectedInlineCompletionIndex.read(reader);
            return filteredCompletions[idx];
        });
        this.activeCommands = (0, _observableJs.derivedOpts)({
            owner: this,
            equalsFn: (0, _equalsJs.itemsEquals)()
        }, (r)=>this.selectedInlineCompletion.read(r)?.inlineCompletion.source.inlineCompletions.commands ?? []);
        this.lastTriggerKind = this._source.inlineCompletions.map(this, (v)=>v?.request.context.triggerKind);
        this.inlineCompletionsCount = (0, _observableJs.derived)(this, (reader)=>{
            if (this.lastTriggerKind.read(reader) === (0, _languagesJs.InlineCompletionTriggerKind).Explicit) return this._filteredInlineCompletionItems.read(reader).length;
            else return undefined;
        });
        this.state = (0, _observableJs.derivedOpts)({
            owner: this,
            equalsFn: (a, b)=>{
                if (!a || !b) return a === b;
                return (0, _ghostTextJs.ghostTextsOrReplacementsEqual)(a.ghostTexts, b.ghostTexts) && a.inlineCompletion === b.inlineCompletion && a.suggestItem === b.suggestItem;
            }
        }, (reader)=>{
            const model = this.textModel;
            const suggestItem = this.selectedSuggestItem.read(reader);
            if (suggestItem) {
                const suggestCompletionEdit = (0, _singleTextEditJs.singleTextRemoveCommonPrefix)(suggestItem.toSingleTextEdit(), model);
                const augmentation = this._computeAugmentation(suggestCompletionEdit, reader);
                const isSuggestionPreviewEnabled = this._suggestPreviewEnabled.read(reader);
                if (!isSuggestionPreviewEnabled && !augmentation) return undefined;
                const fullEdit = augmentation?.edit ?? suggestCompletionEdit;
                const fullEditPreviewLength = augmentation ? augmentation.edit.text.length - suggestCompletionEdit.text.length : 0;
                const mode = this._suggestPreviewMode.read(reader);
                const positions = this._positions.read(reader);
                const edits = [
                    fullEdit,
                    ...getSecondaryEdits(this.textModel, positions, fullEdit)
                ];
                const ghostTexts = edits.map((edit, idx)=>(0, _singleTextEditJs.computeGhostText)(edit, model, mode, positions[idx], fullEditPreviewLength)).filter((0, _typesJs.isDefined));
                const primaryGhostText = ghostTexts[0] ?? new (0, _ghostTextJs.GhostText)(fullEdit.range.endLineNumber, []);
                return {
                    edits,
                    primaryGhostText,
                    ghostTexts,
                    inlineCompletion: augmentation?.completion,
                    suggestItem
                };
            } else {
                if (!this._isActive.read(reader)) return undefined;
                const inlineCompletion = this.selectedInlineCompletion.read(reader);
                if (!inlineCompletion) return undefined;
                const replacement = inlineCompletion.toSingleTextEdit(reader);
                const mode = this._inlineSuggestMode.read(reader);
                const positions = this._positions.read(reader);
                const edits = [
                    replacement,
                    ...getSecondaryEdits(this.textModel, positions, replacement)
                ];
                const ghostTexts = edits.map((edit, idx)=>(0, _singleTextEditJs.computeGhostText)(edit, model, mode, positions[idx], 0)).filter((0, _typesJs.isDefined));
                if (!ghostTexts[0]) return undefined;
                return {
                    edits,
                    primaryGhostText: ghostTexts[0],
                    ghostTexts,
                    inlineCompletion,
                    suggestItem: undefined
                };
            }
        });
        this.ghostTexts = (0, _observableJs.derivedOpts)({
            owner: this,
            equalsFn: (0, _ghostTextJs.ghostTextsOrReplacementsEqual)
        }, (reader)=>{
            const v = this.state.read(reader);
            if (!v) return undefined;
            return v.ghostTexts;
        });
        this.primaryGhostText = (0, _observableJs.derivedOpts)({
            owner: this,
            equalsFn: (0, _ghostTextJs.ghostTextOrReplacementEquals)
        }, (reader)=>{
            const v = this.state.read(reader);
            if (!v) return undefined;
            return v?.primaryGhostText;
        });
        this._register((0, _observableJs.recomputeInitiallyAndOnChange)(this._fetchInlineCompletionsPromise));
        let lastItem = undefined;
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description call handleItemDidShow */ const item = this.state.read(reader);
            const completion = item?.inlineCompletion;
            if (completion?.semanticId !== lastItem?.semanticId) {
                lastItem = completion;
                if (completion) {
                    const i = completion.inlineCompletion;
                    const src = i.source;
                    src.provider.handleItemDidShow?.(src.inlineCompletions, i.sourceInlineCompletion, i.insertText);
                }
            }
        }));
    }
    _getReason(e) {
        if (e?.isUndoing) return VersionIdChangeReason.Undo;
        if (e?.isRedoing) return VersionIdChangeReason.Redo;
        if (this.isAcceptingPartially) return VersionIdChangeReason.AcceptWord;
        return VersionIdChangeReason.Other;
    }
    async trigger(tx) {
        this._isActive.set(true, tx);
        await this._fetchInlineCompletionsPromise.get();
    }
    async triggerExplicitly(tx) {
        (0, _observableJs.subtransaction)(tx, (tx)=>{
            this._isActive.set(true, tx);
            this._forceUpdateExplicitlySignal.trigger(tx);
        });
        await this._fetchInlineCompletionsPromise.get();
    }
    stop(tx) {
        (0, _observableJs.subtransaction)(tx, (tx)=>{
            this._isActive.set(false, tx);
            this._source.clear(tx);
        });
    }
    _computeAugmentation(suggestCompletion, reader) {
        const model = this.textModel;
        const suggestWidgetInlineCompletions = this._source.suggestWidgetInlineCompletions.read(reader);
        const candidateInlineCompletions = suggestWidgetInlineCompletions ? suggestWidgetInlineCompletions.inlineCompletions : [
            this.selectedInlineCompletion.read(reader)
        ].filter((0, _typesJs.isDefined));
        const augmentedCompletion = (0, _arraysFindJs.mapFindFirst)(candidateInlineCompletions, (completion)=>{
            let r = completion.toSingleTextEdit(reader);
            r = (0, _singleTextEditJs.singleTextRemoveCommonPrefix)(r, model, (0, _rangeJs.Range).fromPositions(r.range.getStartPosition(), suggestCompletion.range.getEndPosition()));
            return (0, _singleTextEditJs.singleTextEditAugments)(r, suggestCompletion) ? {
                completion,
                edit: r
            } : undefined;
        });
        return augmentedCompletion;
    }
    async _deltaSelectedInlineCompletionIndex(delta) {
        await this.triggerExplicitly();
        const completions = this._filteredInlineCompletionItems.get() || [];
        if (completions.length > 0) {
            const newIdx = (this.selectedInlineCompletionIndex.get() + delta + completions.length) % completions.length;
            this._selectedInlineCompletionId.set(completions[newIdx].semanticId, undefined);
        } else this._selectedInlineCompletionId.set(undefined, undefined);
    }
    async next() {
        await this._deltaSelectedInlineCompletionIndex(1);
    }
    async previous() {
        await this._deltaSelectedInlineCompletionIndex(-1);
    }
    async accept(editor) {
        if (editor.getModel() !== this.textModel) throw new (0, _errorsJs.BugIndicatingError)();
        const state = this.state.get();
        if (!state || state.primaryGhostText.isEmpty() || !state.inlineCompletion) return;
        const completion = state.inlineCompletion.toInlineCompletion(undefined);
        if (completion.command) // Make sure the completion list will not be disposed.
        completion.source.addRef();
        editor.pushUndoStop();
        if (completion.snippetInfo) {
            editor.executeEdits("inlineSuggestion.accept", [
                (0, _editOperationJs.EditOperation).replace(completion.range, ""),
                ...completion.additionalTextEdits
            ]);
            editor.setPosition(completion.snippetInfo.range.getStartPosition(), "inlineCompletionAccept");
            (0, _snippetController2Js.SnippetController2).get(editor)?.insert(completion.snippetInfo.snippet, {
                undoStopBefore: false
            });
        } else {
            const edits = state.edits;
            const selections = getEndPositionsAfterApplying(edits).map((p)=>(0, _selectionJs.Selection).fromPositions(p));
            editor.executeEdits("inlineSuggestion.accept", [
                ...edits.map((edit)=>(0, _editOperationJs.EditOperation).replace(edit.range, edit.text)),
                ...completion.additionalTextEdits
            ]);
            editor.setSelections(selections, "inlineCompletionAccept");
        }
        // Reset before invoking the command, as the command might cause a follow up trigger (which we don't want to reset).
        this.stop();
        if (completion.command) {
            await this._commandService.executeCommand(completion.command.id, ...completion.command.arguments || []).then(undefined, (0, _errorsJs.onUnexpectedExternalError));
            completion.source.removeRef();
        }
    }
    async acceptNextWord(editor) {
        await this._acceptNext(editor, (pos, text)=>{
            const langId = this.textModel.getLanguageIdAtPosition(pos.lineNumber, pos.column);
            const config = this._languageConfigurationService.getLanguageConfiguration(langId);
            const wordRegExp = new RegExp(config.wordDefinition.source, config.wordDefinition.flags.replace("g", ""));
            const m1 = text.match(wordRegExp);
            let acceptUntilIndexExclusive = 0;
            if (m1 && m1.index !== undefined) {
                if (m1.index === 0) acceptUntilIndexExclusive = m1[0].length;
                else acceptUntilIndexExclusive = m1.index;
            } else acceptUntilIndexExclusive = text.length;
            const wsRegExp = /\s+/g;
            const m2 = wsRegExp.exec(text);
            if (m2 && m2.index !== undefined) {
                if (m2.index + m2[0].length < acceptUntilIndexExclusive) acceptUntilIndexExclusive = m2.index + m2[0].length;
            }
            return acceptUntilIndexExclusive;
        }, 0 /* PartialAcceptTriggerKind.Word */ );
    }
    async acceptNextLine(editor) {
        await this._acceptNext(editor, (pos, text)=>{
            const m = text.match(/\n/);
            if (m && m.index !== undefined) return m.index + 1;
            return text.length;
        }, 1 /* PartialAcceptTriggerKind.Line */ );
    }
    async _acceptNext(editor, getAcceptUntilIndex, kind) {
        if (editor.getModel() !== this.textModel) throw new (0, _errorsJs.BugIndicatingError)();
        const state = this.state.get();
        if (!state || state.primaryGhostText.isEmpty() || !state.inlineCompletion) return;
        const ghostText = state.primaryGhostText;
        const completion = state.inlineCompletion.toInlineCompletion(undefined);
        if (completion.snippetInfo || completion.filterText !== completion.insertText) {
            // not in WYSIWYG mode, partial commit might change completion, thus it is not supported
            await this.accept(editor);
            return;
        }
        const firstPart = ghostText.parts[0];
        const ghostTextPos = new (0, _positionJs.Position)(ghostText.lineNumber, firstPart.column);
        const ghostTextVal = firstPart.text;
        const acceptUntilIndexExclusive = getAcceptUntilIndex(ghostTextPos, ghostTextVal);
        if (acceptUntilIndexExclusive === ghostTextVal.length && ghostText.parts.length === 1) {
            this.accept(editor);
            return;
        }
        const partialGhostTextVal = ghostTextVal.substring(0, acceptUntilIndexExclusive);
        const positions = this._positions.get();
        const cursorPosition = positions[0];
        // Executing the edit might free the completion, so we have to hold a reference on it.
        completion.source.addRef();
        try {
            this._isAcceptingPartially = true;
            try {
                editor.pushUndoStop();
                const replaceRange = (0, _rangeJs.Range).fromPositions(cursorPosition, ghostTextPos);
                const newText = editor.getModel().getValueInRange(replaceRange) + partialGhostTextVal;
                const primaryEdit = new (0, _textEditJs.SingleTextEdit)(replaceRange, newText);
                const edits = [
                    primaryEdit,
                    ...getSecondaryEdits(this.textModel, positions, primaryEdit)
                ];
                const selections = getEndPositionsAfterApplying(edits).map((p)=>(0, _selectionJs.Selection).fromPositions(p));
                editor.executeEdits("inlineSuggestion.accept", edits.map((edit)=>(0, _editOperationJs.EditOperation).replace(edit.range, edit.text)));
                editor.setSelections(selections, "inlineCompletionPartialAccept");
                editor.revealPositionInCenterIfOutsideViewport(editor.getPosition(), 1 /* ScrollType.Immediate */ );
            } finally{
                this._isAcceptingPartially = false;
            }
            if (completion.source.provider.handlePartialAccept) {
                const acceptedRange = (0, _rangeJs.Range).fromPositions(completion.range.getStartPosition(), (0, _textLengthJs.TextLength).ofText(partialGhostTextVal).addToPosition(ghostTextPos));
                // This assumes that the inline completion and the model use the same EOL style.
                const text = editor.getModel().getValueInRange(acceptedRange, 1 /* EndOfLinePreference.LF */ );
                completion.source.provider.handlePartialAccept(completion.source.inlineCompletions, completion.sourceInlineCompletion, text.length, {
                    kind
                });
            }
        } finally{
            completion.source.removeRef();
        }
    }
    handleSuggestAccepted(item) {
        const itemEdit = (0, _singleTextEditJs.singleTextRemoveCommonPrefix)(item.toSingleTextEdit(), this.textModel);
        const augmentedCompletion = this._computeAugmentation(itemEdit, undefined);
        if (!augmentedCompletion) return;
        const inlineCompletion = augmentedCompletion.completion.inlineCompletion;
        inlineCompletion.source.provider.handlePartialAccept?.(inlineCompletion.source.inlineCompletions, inlineCompletion.sourceInlineCompletion, itemEdit.text.length, {
            kind: 2 /* PartialAcceptTriggerKind.Suggest */ 
        });
    }
};
InlineCompletionsModel = __decorate([
    __param(9, (0, _instantiationJs.IInstantiationService)),
    __param(10, (0, _commandsJs.ICommandService)),
    __param(11, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService))
], InlineCompletionsModel);
var VersionIdChangeReason;
(function(VersionIdChangeReason) {
    VersionIdChangeReason[VersionIdChangeReason["Undo"] = 0] = "Undo";
    VersionIdChangeReason[VersionIdChangeReason["Redo"] = 1] = "Redo";
    VersionIdChangeReason[VersionIdChangeReason["AcceptWord"] = 2] = "AcceptWord";
    VersionIdChangeReason[VersionIdChangeReason["Other"] = 3] = "Other";
})(VersionIdChangeReason || (VersionIdChangeReason = {}));
function getSecondaryEdits(textModel, positions, primaryEdit) {
    if (positions.length === 1) // No secondary cursor positions
    return [];
    const primaryPosition = positions[0];
    const secondaryPositions = positions.slice(1);
    const primaryEditStartPosition = primaryEdit.range.getStartPosition();
    const primaryEditEndPosition = primaryEdit.range.getEndPosition();
    const replacedTextAfterPrimaryCursor = textModel.getValueInRange((0, _rangeJs.Range).fromPositions(primaryPosition, primaryEditEndPosition));
    const positionWithinTextEdit = (0, _utilsJs.subtractPositions)(primaryPosition, primaryEditStartPosition);
    if (positionWithinTextEdit.lineNumber < 1) {
        (0, _errorsJs.onUnexpectedError)(new (0, _errorsJs.BugIndicatingError)(`positionWithinTextEdit line number should be bigger than 0.
			Invalid subtraction between ${primaryPosition.toString()} and ${primaryEditStartPosition.toString()}`));
        return [];
    }
    const secondaryEditText = substringPos(primaryEdit.text, positionWithinTextEdit);
    return secondaryPositions.map((pos)=>{
        const posEnd = (0, _utilsJs.addPositions)((0, _utilsJs.subtractPositions)(pos, primaryEditStartPosition), primaryEditEndPosition);
        const textAfterSecondaryCursor = textModel.getValueInRange((0, _rangeJs.Range).fromPositions(pos, posEnd));
        const l = (0, _stringsJs.commonPrefixLength)(replacedTextAfterPrimaryCursor, textAfterSecondaryCursor);
        const range = (0, _rangeJs.Range).fromPositions(pos, pos.delta(0, l));
        return new (0, _textEditJs.SingleTextEdit)(range, secondaryEditText);
    });
}
function substringPos(text, pos) {
    let subtext = "";
    const lines = (0, _stringsJs.splitLinesIncludeSeparators)(text);
    for(let i = pos.lineNumber - 1; i < lines.length; i++)subtext += lines[i].substring(i === pos.lineNumber - 1 ? pos.column - 1 : 0);
    return subtext;
}
function getEndPositionsAfterApplying(edits) {
    const sortPerm = (0, _arraysJs.Permutation).createSortPermutation(edits, (0, _arraysJs.compareBy)((e)=>e.range, (0, _rangeJs.Range).compareRangesUsingStarts));
    const edit = new (0, _textEditJs.TextEdit)(sortPerm.apply(edits));
    const sortedNewRanges = edit.getNewRanges();
    const newRanges = sortPerm.inverse().apply(sortedNewRanges);
    return newRanges.map((range)=>range.getEndPosition());
}

},{"../../../../../base/common/arrays.js":"DECei","../../../../../base/common/arraysFind.js":"gWrU0","../../../../../base/common/equals.js":"8hes7","../../../../../base/common/errors.js":"divX8","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../../base/common/strings.js":"aA9I1","../../../../../base/common/types.js":"fb5yx","../../../../common/core/editOperation.js":"6r2FZ","../../../../common/core/position.js":"lvrPe","../../../../common/core/range.js":"jmUPh","../../../../common/core/selection.js":"kcwzU","../../../../common/core/textEdit.js":"hdqra","../../../../common/core/textLength.js":"Lk80L","../../../../common/languages.js":"g5n96","../../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","./ghostText.js":"htVY2","./inlineCompletionsSource.js":"7Emi9","./singleTextEdit.js":"1zqK9","../utils.js":"4lO9A","../../../snippet/browser/snippetController2.js":"0XDQb","../../../../../platform/commands/common/commands.js":"ho6ic","../../../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Emi9":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineCompletionsSource", ()=>InlineCompletionsSource);
parcelHelpers.export(exports, "UpToDateInlineCompletions", ()=>UpToDateInlineCompletions);
parcelHelpers.export(exports, "InlineCompletionWithUpdatedRange", ()=>InlineCompletionWithUpdatedRange);
var _cancellationJs = require("../../../../../base/common/cancellation.js");
var _equalsJs = require("../../../../../base/common/equals.js");
var _filtersJs = require("../../../../../base/common/filters.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _rangeJs = require("../../../../common/core/range.js");
var _textEditJs = require("../../../../common/core/textEdit.js");
var _textLengthJs = require("../../../../common/core/textLength.js");
var _languagesJs = require("../../../../common/languages.js");
var _languageConfigurationRegistryJs = require("../../../../common/languages/languageConfigurationRegistry.js");
var _languageFeaturesJs = require("../../../../common/services/languageFeatures.js");
var _provideInlineCompletionsJs = require("./provideInlineCompletions.js");
var _singleTextEditJs = require("./singleTextEdit.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let InlineCompletionsSource = class InlineCompletionsSource extends (0, _lifecycleJs.Disposable) {
    constructor(textModel, versionId, _debounceValue, languageFeaturesService, languageConfigurationService){
        super();
        this.textModel = textModel;
        this.versionId = versionId;
        this._debounceValue = _debounceValue;
        this.languageFeaturesService = languageFeaturesService;
        this.languageConfigurationService = languageConfigurationService;
        this._updateOperation = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this.inlineCompletions = (0, _observableJs.disposableObservableValue)("inlineCompletions", undefined);
        this.suggestWidgetInlineCompletions = (0, _observableJs.disposableObservableValue)("suggestWidgetInlineCompletions", undefined);
        this._register(this.textModel.onDidChangeContent(()=>{
            this._updateOperation.clear();
        }));
    }
    fetch(position, context, activeInlineCompletion) {
        const request = new UpdateRequest(position, context, this.textModel.getVersionId());
        const target = context.selectedSuggestionInfo ? this.suggestWidgetInlineCompletions : this.inlineCompletions;
        if (this._updateOperation.value?.request.satisfies(request)) return this._updateOperation.value.promise;
        else if (target.get()?.request.satisfies(request)) return Promise.resolve(true);
        const updateOngoing = !!this._updateOperation.value;
        this._updateOperation.clear();
        const source = new (0, _cancellationJs.CancellationTokenSource)();
        const promise = (async ()=>{
            const shouldDebounce = updateOngoing || context.triggerKind === (0, _languagesJs.InlineCompletionTriggerKind).Automatic;
            if (shouldDebounce) // This debounces the operation
            await wait(this._debounceValue.get(this.textModel), source.token);
            if (source.token.isCancellationRequested || this._store.isDisposed || this.textModel.getVersionId() !== request.versionId) return false;
            const startTime = new Date();
            const updatedCompletions = await (0, _provideInlineCompletionsJs.provideInlineCompletions)(this.languageFeaturesService.inlineCompletionsProvider, position, this.textModel, context, source.token, this.languageConfigurationService);
            if (source.token.isCancellationRequested || this._store.isDisposed || this.textModel.getVersionId() !== request.versionId) return false;
            const endTime = new Date();
            this._debounceValue.update(this.textModel, endTime.getTime() - startTime.getTime());
            const completions = new UpToDateInlineCompletions(updatedCompletions, request, this.textModel, this.versionId);
            if (activeInlineCompletion) {
                const asInlineCompletion = activeInlineCompletion.toInlineCompletion(undefined);
                if (activeInlineCompletion.canBeReused(this.textModel, position) && !updatedCompletions.has(asInlineCompletion)) completions.prepend(activeInlineCompletion.inlineCompletion, asInlineCompletion.range, true);
            }
            this._updateOperation.clear();
            (0, _observableJs.transaction)((tx)=>{
                /** @description Update completions with provider result */ target.set(completions, tx);
            });
            return true;
        })();
        const updateOperation = new UpdateOperation(request, source, promise);
        this._updateOperation.value = updateOperation;
        return promise;
    }
    clear(tx) {
        this._updateOperation.clear();
        this.inlineCompletions.set(undefined, tx);
        this.suggestWidgetInlineCompletions.set(undefined, tx);
    }
    clearSuggestWidgetInlineCompletions(tx) {
        if (this._updateOperation.value?.request.context.selectedSuggestionInfo) this._updateOperation.clear();
        this.suggestWidgetInlineCompletions.set(undefined, tx);
    }
    cancelUpdate() {
        this._updateOperation.clear();
    }
};
InlineCompletionsSource = __decorate([
    __param(3, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(4, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService))
], InlineCompletionsSource);
function wait(ms, cancellationToken) {
    return new Promise((resolve)=>{
        let d = undefined;
        const handle = setTimeout(()=>{
            if (d) d.dispose();
            resolve();
        }, ms);
        if (cancellationToken) d = cancellationToken.onCancellationRequested(()=>{
            clearTimeout(handle);
            if (d) d.dispose();
            resolve();
        });
    });
}
class UpdateRequest {
    constructor(position, context, versionId){
        this.position = position;
        this.context = context;
        this.versionId = versionId;
    }
    satisfies(other) {
        return this.position.equals(other.position) && (0, _equalsJs.equalsIfDefined)(this.context.selectedSuggestionInfo, other.context.selectedSuggestionInfo, (0, _equalsJs.itemEquals)()) && (other.context.triggerKind === (0, _languagesJs.InlineCompletionTriggerKind).Automatic || this.context.triggerKind === (0, _languagesJs.InlineCompletionTriggerKind).Explicit) && this.versionId === other.versionId;
    }
}
class UpdateOperation {
    constructor(request, cancellationTokenSource, promise){
        this.request = request;
        this.cancellationTokenSource = cancellationTokenSource;
        this.promise = promise;
    }
    dispose() {
        this.cancellationTokenSource.cancel();
    }
}
class UpToDateInlineCompletions {
    get inlineCompletions() {
        return this._inlineCompletions;
    }
    constructor(inlineCompletionProviderResult, request, _textModel, _versionId){
        this.inlineCompletionProviderResult = inlineCompletionProviderResult;
        this.request = request;
        this._textModel = _textModel;
        this._versionId = _versionId;
        this._refCount = 1;
        this._prependedInlineCompletionItems = [];
        const ids = _textModel.deltaDecorations([], inlineCompletionProviderResult.completions.map((i)=>({
                range: i.range,
                options: {
                    description: "inline-completion-tracking-range"
                }
            })));
        this._inlineCompletions = inlineCompletionProviderResult.completions.map((i, index)=>new InlineCompletionWithUpdatedRange(i, ids[index], this._textModel, this._versionId));
    }
    clone() {
        this._refCount++;
        return this;
    }
    dispose() {
        this._refCount--;
        if (this._refCount === 0) {
            setTimeout(()=>{
                // To fix https://github.com/microsoft/vscode/issues/188348
                if (!this._textModel.isDisposed()) // This is just cleanup. It's ok if it happens with a delay.
                this._textModel.deltaDecorations(this._inlineCompletions.map((i)=>i.decorationId), []);
            }, 0);
            this.inlineCompletionProviderResult.dispose();
            for (const i of this._prependedInlineCompletionItems)i.source.removeRef();
        }
    }
    prepend(inlineCompletion, range, addRefToSource) {
        if (addRefToSource) inlineCompletion.source.addRef();
        const id = this._textModel.deltaDecorations([], [
            {
                range,
                options: {
                    description: "inline-completion-tracking-range"
                }
            }
        ])[0];
        this._inlineCompletions.unshift(new InlineCompletionWithUpdatedRange(inlineCompletion, id, this._textModel, this._versionId));
        this._prependedInlineCompletionItems.push(inlineCompletion);
    }
}
class InlineCompletionWithUpdatedRange {
    get forwardStable() {
        return this.inlineCompletion.source.inlineCompletions.enableForwardStability ?? false;
    }
    constructor(inlineCompletion, decorationId, _textModel, _modelVersion){
        this.inlineCompletion = inlineCompletion;
        this.decorationId = decorationId;
        this._textModel = _textModel;
        this._modelVersion = _modelVersion;
        this.semanticId = JSON.stringify([
            this.inlineCompletion.filterText,
            this.inlineCompletion.insertText,
            this.inlineCompletion.range.getStartPosition().toString()
        ]);
        this._updatedRange = (0, _observableJs.derivedOpts)({
            owner: this,
            equalsFn: (0, _rangeJs.Range).equalsRange
        }, (reader)=>{
            this._modelVersion.read(reader);
            return this._textModel.getDecorationRange(this.decorationId);
        });
    }
    toInlineCompletion(reader) {
        return this.inlineCompletion.withRange(this._updatedRange.read(reader) ?? emptyRange);
    }
    toSingleTextEdit(reader) {
        return new (0, _textEditJs.SingleTextEdit)(this._updatedRange.read(reader) ?? emptyRange, this.inlineCompletion.insertText);
    }
    isVisible(model, cursorPosition, reader) {
        const minimizedReplacement = (0, _singleTextEditJs.singleTextRemoveCommonPrefix)(this._toFilterTextReplacement(reader), model);
        const updatedRange = this._updatedRange.read(reader);
        if (!updatedRange || !this.inlineCompletion.range.getStartPosition().equals(updatedRange.getStartPosition()) || cursorPosition.lineNumber !== minimizedReplacement.range.startLineNumber) return false;
        // We might consider comparing by .toLowerText, but this requires GhostTextReplacement
        const originalValue = model.getValueInRange(minimizedReplacement.range, 1 /* EndOfLinePreference.LF */ );
        const filterText = minimizedReplacement.text;
        const cursorPosIndex = Math.max(0, cursorPosition.column - minimizedReplacement.range.startColumn);
        let filterTextBefore = filterText.substring(0, cursorPosIndex);
        let filterTextAfter = filterText.substring(cursorPosIndex);
        let originalValueBefore = originalValue.substring(0, cursorPosIndex);
        let originalValueAfter = originalValue.substring(cursorPosIndex);
        const originalValueIndent = model.getLineIndentColumn(minimizedReplacement.range.startLineNumber);
        if (minimizedReplacement.range.startColumn <= originalValueIndent) {
            // Remove indentation
            originalValueBefore = originalValueBefore.trimStart();
            if (originalValueBefore.length === 0) originalValueAfter = originalValueAfter.trimStart();
            filterTextBefore = filterTextBefore.trimStart();
            if (filterTextBefore.length === 0) filterTextAfter = filterTextAfter.trimStart();
        }
        return filterTextBefore.startsWith(originalValueBefore) && !!(0, _filtersJs.matchesSubString)(originalValueAfter, filterTextAfter);
    }
    canBeReused(model, position) {
        const updatedRange = this._updatedRange.read(undefined);
        const result = !!updatedRange && updatedRange.containsPosition(position) && this.isVisible(model, position, undefined) && (0, _textLengthJs.TextLength).ofRange(updatedRange).isGreaterThanOrEqualTo((0, _textLengthJs.TextLength).ofRange(this.inlineCompletion.range));
        return result;
    }
    _toFilterTextReplacement(reader) {
        return new (0, _textEditJs.SingleTextEdit)(this._updatedRange.read(reader) ?? emptyRange, this.inlineCompletion.filterText);
    }
}
const emptyRange = new (0, _rangeJs.Range)(1, 1, 1, 1);

},{"../../../../../base/common/cancellation.js":"hoVxw","../../../../../base/common/equals.js":"8hes7","../../../../../base/common/filters.js":"40BGZ","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../common/core/range.js":"jmUPh","../../../../common/core/textEdit.js":"hdqra","../../../../common/core/textLength.js":"Lk80L","../../../../common/languages.js":"g5n96","../../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../../common/services/languageFeatures.js":"2IAko","./provideInlineCompletions.js":"cMrUc","./singleTextEdit.js":"1zqK9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cMrUc":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "provideInlineCompletions", ()=>provideInlineCompletions);
parcelHelpers.export(exports, "InlineCompletionProviderResult", ()=>InlineCompletionProviderResult);
/**
 * A ref counted pointer to the computed `InlineCompletions` and the `InlineCompletionsProvider` that
 * computed them.
 */ parcelHelpers.export(exports, "InlineCompletionList", ()=>InlineCompletionList);
parcelHelpers.export(exports, "InlineCompletionItem", ()=>InlineCompletionItem);
var _assertJs = require("../../../../../base/common/assert.js");
var _asyncJs = require("../../../../../base/common/async.js");
var _cancellationJs = require("../../../../../base/common/cancellation.js");
var _mapJs = require("../../../../../base/common/map.js");
var _errorsJs = require("../../../../../base/common/errors.js");
var _positionJs = require("../../../../common/core/position.js");
var _rangeJs = require("../../../../common/core/range.js");
var _fixBracketsJs = require("../../../../common/model/bracketPairsTextModelPart/fixBrackets.js");
var _textEditJs = require("../../../../common/core/textEdit.js");
var _utilsJs = require("../utils.js");
var _snippetParserJs = require("../../../snippet/browser/snippetParser.js");
async function provideInlineCompletions(registry, positionOrRange, model, context, token = (0, _cancellationJs.CancellationToken).None, languageConfigurationService) {
    // Important: Don't use position after the await calls, as the model could have been changed in the meantime!
    const defaultReplaceRange = positionOrRange instanceof (0, _positionJs.Position) ? getDefaultRange(positionOrRange, model) : positionOrRange;
    const providers = registry.all(model);
    const multiMap = new (0, _mapJs.SetMap)();
    for (const provider of providers)if (provider.groupId) multiMap.add(provider.groupId, provider);
    function getPreferredProviders(provider) {
        if (!provider.yieldsToGroupIds) return [];
        const result = [];
        for (const groupId of provider.yieldsToGroupIds || []){
            const providers = multiMap.get(groupId);
            for (const p of providers)result.push(p);
        }
        return result;
    }
    const states = new Map();
    const seen = new Set();
    function findPreferredProviderCircle(provider, stack) {
        stack = [
            ...stack,
            provider
        ];
        if (seen.has(provider)) return stack;
        seen.add(provider);
        try {
            const preferred = getPreferredProviders(provider);
            for (const p of preferred){
                const c = findPreferredProviderCircle(p, stack);
                if (c) return c;
            }
        } finally{
            seen.delete(provider);
        }
        return undefined;
    }
    function processProvider(provider) {
        const state = states.get(provider);
        if (state) return state;
        const circle = findPreferredProviderCircle(provider, []);
        if (circle) (0, _errorsJs.onUnexpectedExternalError)(new Error(`Inline completions: cyclic yield-to dependency detected. Path: ${circle.map((s)=>s.toString ? s.toString() : "" + s).join(" -> ")}`));
        const deferredPromise = new (0, _asyncJs.DeferredPromise)();
        states.set(provider, deferredPromise.p);
        (async ()=>{
            if (!circle) {
                const preferred = getPreferredProviders(provider);
                for (const p of preferred){
                    const result = await processProvider(p);
                    if (result && result.items.length > 0) // Skip provider
                    return undefined;
                }
            }
            try {
                if (positionOrRange instanceof (0, _positionJs.Position)) {
                    const completions = await provider.provideInlineCompletions(model, positionOrRange, context, token);
                    return completions;
                } else {
                    const completions = await provider.provideInlineEdits?.(model, positionOrRange, context, token);
                    return completions;
                }
            } catch (e) {
                (0, _errorsJs.onUnexpectedExternalError)(e);
                return undefined;
            }
        })().then((c)=>deferredPromise.complete(c), (e)=>deferredPromise.error(e));
        return deferredPromise.p;
    }
    const providerResults = await Promise.all(providers.map(async (provider)=>({
            provider,
            completions: await processProvider(provider)
        })));
    const itemsByHash = new Map();
    const lists = [];
    for (const result of providerResults){
        const completions = result.completions;
        if (!completions) continue;
        const list = new InlineCompletionList(completions, result.provider);
        lists.push(list);
        for (const item of completions.items){
            const inlineCompletionItem = InlineCompletionItem.from(item, list, defaultReplaceRange, model, languageConfigurationService);
            itemsByHash.set(inlineCompletionItem.hash(), inlineCompletionItem);
        }
    }
    return new InlineCompletionProviderResult(Array.from(itemsByHash.values()), new Set(itemsByHash.keys()), lists);
}
class InlineCompletionProviderResult {
    constructor(/**
     * Free of duplicates.
     */ completions, hashs, providerResults){
        this.completions = completions;
        this.hashs = hashs;
        this.providerResults = providerResults;
    }
    has(item) {
        return this.hashs.has(item.hash());
    }
    dispose() {
        for (const result of this.providerResults)result.removeRef();
    }
}
class InlineCompletionList {
    constructor(inlineCompletions, provider){
        this.inlineCompletions = inlineCompletions;
        this.provider = provider;
        this.refCount = 1;
    }
    addRef() {
        this.refCount++;
    }
    removeRef() {
        this.refCount--;
        if (this.refCount === 0) this.provider.freeInlineCompletions(this.inlineCompletions);
    }
}
class InlineCompletionItem {
    static from(inlineCompletion, source, defaultReplaceRange, textModel, languageConfigurationService) {
        let insertText;
        let snippetInfo;
        let range = inlineCompletion.range ? (0, _rangeJs.Range).lift(inlineCompletion.range) : defaultReplaceRange;
        if (typeof inlineCompletion.insertText === "string") {
            insertText = inlineCompletion.insertText;
            if (languageConfigurationService && inlineCompletion.completeBracketPairs) {
                insertText = closeBrackets(insertText, range.getStartPosition(), textModel, languageConfigurationService);
                // Modify range depending on if brackets are added or removed
                const diff = insertText.length - inlineCompletion.insertText.length;
                if (diff !== 0) range = new (0, _rangeJs.Range)(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn + diff);
            }
            snippetInfo = undefined;
        } else if ("snippet" in inlineCompletion.insertText) {
            const preBracketCompletionLength = inlineCompletion.insertText.snippet.length;
            if (languageConfigurationService && inlineCompletion.completeBracketPairs) {
                inlineCompletion.insertText.snippet = closeBrackets(inlineCompletion.insertText.snippet, range.getStartPosition(), textModel, languageConfigurationService);
                // Modify range depending on if brackets are added or removed
                const diff = inlineCompletion.insertText.snippet.length - preBracketCompletionLength;
                if (diff !== 0) range = new (0, _rangeJs.Range)(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn + diff);
            }
            const snippet = new (0, _snippetParserJs.SnippetParser)().parse(inlineCompletion.insertText.snippet);
            if (snippet.children.length === 1 && snippet.children[0] instanceof (0, _snippetParserJs.Text)) {
                insertText = snippet.children[0].value;
                snippetInfo = undefined;
            } else {
                insertText = snippet.toString();
                snippetInfo = {
                    snippet: inlineCompletion.insertText.snippet,
                    range: range
                };
            }
        } else (0, _assertJs.assertNever)(inlineCompletion.insertText);
        return new InlineCompletionItem(insertText, inlineCompletion.command, range, insertText, snippetInfo, inlineCompletion.additionalTextEdits || (0, _utilsJs.getReadonlyEmptyArray)(), inlineCompletion, source);
    }
    constructor(filterText, command, range, insertText, snippetInfo, additionalTextEdits, /**
     * A reference to the original inline completion this inline completion has been constructed from.
     * Used for event data to ensure referential equality.
    */ sourceInlineCompletion, /**
     * A reference to the original inline completion list this inline completion has been constructed from.
     * Used for event data to ensure referential equality.
    */ source){
        this.filterText = filterText;
        this.command = command;
        this.range = range;
        this.insertText = insertText;
        this.snippetInfo = snippetInfo;
        this.additionalTextEdits = additionalTextEdits;
        this.sourceInlineCompletion = sourceInlineCompletion;
        this.source = source;
        filterText = filterText.replace(/\r\n|\r/g, "\n");
        insertText = filterText.replace(/\r\n|\r/g, "\n");
    }
    withRange(updatedRange) {
        return new InlineCompletionItem(this.filterText, this.command, updatedRange, this.insertText, this.snippetInfo, this.additionalTextEdits, this.sourceInlineCompletion, this.source);
    }
    hash() {
        return JSON.stringify({
            insertText: this.insertText,
            range: this.range.toString()
        });
    }
    toSingleTextEdit() {
        return new (0, _textEditJs.SingleTextEdit)(this.range, this.insertText);
    }
}
function getDefaultRange(position, model) {
    const word = model.getWordAtPosition(position);
    const maxColumn = model.getLineMaxColumn(position.lineNumber);
    // By default, always replace up until the end of the current line.
    // This default might be subject to change!
    return word ? new (0, _rangeJs.Range)(position.lineNumber, word.startColumn, position.lineNumber, maxColumn) : (0, _rangeJs.Range).fromPositions(position, position.with(undefined, maxColumn));
}
function closeBrackets(text, position, model, languageConfigurationService) {
    const lineStart = model.getLineContent(position.lineNumber).substring(0, position.column - 1);
    const newLine = lineStart + text;
    const newTokens = model.tokenization.tokenizeLineWithEdit(position, newLine.length - (position.column - 1), text);
    const slicedTokens = newTokens?.sliceAndInflate(position.column - 1, newLine.length, 0);
    if (!slicedTokens) return text;
    const newText = (0, _fixBracketsJs.fixBracketsInLine)(slicedTokens, languageConfigurationService);
    return newText;
}

},{"../../../../../base/common/assert.js":"1nPIE","../../../../../base/common/async.js":"4GJc4","../../../../../base/common/cancellation.js":"hoVxw","../../../../../base/common/map.js":"leSjz","../../../../../base/common/errors.js":"divX8","../../../../common/core/position.js":"lvrPe","../../../../common/core/range.js":"jmUPh","../../../../common/model/bracketPairsTextModelPart/fixBrackets.js":"ccTb4","../../../../common/core/textEdit.js":"hdqra","../utils.js":"4lO9A","../../../snippet/browser/snippetParser.js":"6qHnq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ccTb4":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fixBracketsInLine", ()=>fixBracketsInLine);
var _bracketsJs = require("./bracketPairsTree/brackets.js");
var _lengthJs = require("./bracketPairsTree/length.js");
var _parserJs = require("./bracketPairsTree/parser.js");
var _smallImmutableSetJs = require("./bracketPairsTree/smallImmutableSet.js");
var _tokenizerJs = require("./bracketPairsTree/tokenizer.js");
function fixBracketsInLine(tokens, languageConfigurationService) {
    const denseKeyProvider = new (0, _smallImmutableSetJs.DenseKeyProvider)();
    const bracketTokens = new (0, _bracketsJs.LanguageAgnosticBracketTokens)(denseKeyProvider, (languageId)=>languageConfigurationService.getLanguageConfiguration(languageId));
    const tokenizer = new (0, _tokenizerJs.TextBufferTokenizer)(new StaticTokenizerSource([
        tokens
    ]), bracketTokens);
    const node = (0, _parserJs.parseDocument)(tokenizer, [], undefined, true);
    let str = "";
    const line = tokens.getLineContent();
    function processNode(node, offset) {
        if (node.kind === 2 /* AstNodeKind.Pair */ ) {
            processNode(node.openingBracket, offset);
            offset = (0, _lengthJs.lengthAdd)(offset, node.openingBracket.length);
            if (node.child) {
                processNode(node.child, offset);
                offset = (0, _lengthJs.lengthAdd)(offset, node.child.length);
            }
            if (node.closingBracket) {
                processNode(node.closingBracket, offset);
                offset = (0, _lengthJs.lengthAdd)(offset, node.closingBracket.length);
            } else {
                const singleLangBracketTokens = bracketTokens.getSingleLanguageBracketTokens(node.openingBracket.languageId);
                const closingTokenText = singleLangBracketTokens.findClosingTokenText(node.openingBracket.bracketIds);
                str += closingTokenText;
            }
        } else if (node.kind === 3 /* AstNodeKind.UnexpectedClosingBracket */ ) ;
        else if (node.kind === 0 /* AstNodeKind.Text */  || node.kind === 1 /* AstNodeKind.Bracket */ ) str += line.substring((0, _lengthJs.lengthGetColumnCountIfZeroLineCount)(offset), (0, _lengthJs.lengthGetColumnCountIfZeroLineCount)((0, _lengthJs.lengthAdd)(offset, node.length)));
        else if (node.kind === 4 /* AstNodeKind.List */ ) for (const child of node.children){
            processNode(child, offset);
            offset = (0, _lengthJs.lengthAdd)(offset, child.length);
        }
    }
    processNode(node, (0, _lengthJs.lengthZero));
    return str;
}
class StaticTokenizerSource {
    constructor(lines){
        this.lines = lines;
        this.tokenization = {
            getLineTokens: (lineNumber)=>{
                return this.lines[lineNumber - 1];
            }
        };
    }
    getLineCount() {
        return this.lines.length;
    }
    getLineLength(lineNumber) {
        return this.lines[lineNumber - 1].getLineContent().length;
    }
}

},{"./bracketPairsTree/brackets.js":"i2EWB","./bracketPairsTree/length.js":"lbA4G","./bracketPairsTree/parser.js":"dwAx5","./bracketPairsTree/smallImmutableSet.js":"4iPAQ","./bracketPairsTree/tokenizer.js":"e4jw0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1zqK9":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "singleTextRemoveCommonPrefix", ()=>singleTextRemoveCommonPrefix);
parcelHelpers.export(exports, "singleTextEditAugments", ()=>singleTextEditAugments);
/**
 * @param previewSuffixLength Sets where to split `inlineCompletion.text`.
 * 	If the text is `hello` and the suffix length is 2, the non-preview part is `hel` and the preview-part is `lo`.
*/ parcelHelpers.export(exports, "computeGhostText", ()=>computeGhostText);
var _diffJs = require("../../../../../base/common/diff/diff.js");
var _stringsJs = require("../../../../../base/common/strings.js");
var _rangeJs = require("../../../../common/core/range.js");
var _textLengthJs = require("../../../../common/core/textLength.js");
var _textEditJs = require("../../../../common/core/textEdit.js");
var _ghostTextJs = require("./ghostText.js");
function singleTextRemoveCommonPrefix(edit, model, validModelRange) {
    const modelRange = validModelRange ? edit.range.intersectRanges(validModelRange) : edit.range;
    if (!modelRange) return edit;
    const valueToReplace = model.getValueInRange(modelRange, 1 /* EndOfLinePreference.LF */ );
    const commonPrefixLen = (0, _stringsJs.commonPrefixLength)(valueToReplace, edit.text);
    const start = (0, _textLengthJs.TextLength).ofText(valueToReplace.substring(0, commonPrefixLen)).addToPosition(edit.range.getStartPosition());
    const text = edit.text.substring(commonPrefixLen);
    const range = (0, _rangeJs.Range).fromPositions(start, edit.range.getEndPosition());
    return new (0, _textEditJs.SingleTextEdit)(range, text);
}
function singleTextEditAugments(edit, base) {
    // The augmented completion must replace the base range, but can replace even more
    return edit.text.startsWith(base.text) && rangeExtends(edit.range, base.range);
}
function computeGhostText(edit, model, mode, cursorPosition, previewSuffixLength = 0) {
    let e = singleTextRemoveCommonPrefix(edit, model);
    if (e.range.endLineNumber !== e.range.startLineNumber) // This edit might span multiple lines, but the first lines must be a common prefix.
    return undefined;
    const sourceLine = model.getLineContent(e.range.startLineNumber);
    const sourceIndentationLength = (0, _stringsJs.getLeadingWhitespace)(sourceLine).length;
    const suggestionTouchesIndentation = e.range.startColumn - 1 <= sourceIndentationLength;
    if (suggestionTouchesIndentation) {
        // source:      ··········[······abc]
        //                         ^^^^^^^^^ inlineCompletion.range
        //              ^^^^^^^^^^ ^^^^^^ sourceIndentationLength
        //                         ^^^^^^ replacedIndentation.length
        //                               ^^^ rangeThatDoesNotReplaceIndentation
        // inlineCompletion.text: '··foo'
        //                         ^^ suggestionAddedIndentationLength
        const suggestionAddedIndentationLength = (0, _stringsJs.getLeadingWhitespace)(e.text).length;
        const replacedIndentation = sourceLine.substring(e.range.startColumn - 1, sourceIndentationLength);
        const [startPosition, endPosition] = [
            e.range.getStartPosition(),
            e.range.getEndPosition()
        ];
        const newStartPosition = startPosition.column + replacedIndentation.length <= endPosition.column ? startPosition.delta(0, replacedIndentation.length) : endPosition;
        const rangeThatDoesNotReplaceIndentation = (0, _rangeJs.Range).fromPositions(newStartPosition, endPosition);
        const suggestionWithoutIndentationChange = e.text.startsWith(replacedIndentation) ? e.text.substring(replacedIndentation.length) : e.text.substring(suggestionAddedIndentationLength);
        e = new (0, _textEditJs.SingleTextEdit)(rangeThatDoesNotReplaceIndentation, suggestionWithoutIndentationChange);
    }
    // This is a single line string
    const valueToBeReplaced = model.getValueInRange(e.range);
    const changes = cachingDiff(valueToBeReplaced, e.text);
    if (!changes) // No ghost text in case the diff would be too slow to compute
    return undefined;
    const lineNumber = e.range.startLineNumber;
    const parts = new Array();
    if (mode === "prefix") {
        const filteredChanges = changes.filter((c)=>c.originalLength === 0);
        if (filteredChanges.length > 1 || filteredChanges.length === 1 && filteredChanges[0].originalStart !== valueToBeReplaced.length) // Prefixes only have a single change.
        return undefined;
    }
    const previewStartInCompletionText = e.text.length - previewSuffixLength;
    for (const c of changes){
        const insertColumn = e.range.startColumn + c.originalStart + c.originalLength;
        if (mode === "subwordSmart" && cursorPosition && cursorPosition.lineNumber === e.range.startLineNumber && insertColumn < cursorPosition.column) // No ghost text before cursor
        return undefined;
        if (c.originalLength > 0) return undefined;
        if (c.modifiedLength === 0) continue;
        const modifiedEnd = c.modifiedStart + c.modifiedLength;
        const nonPreviewTextEnd = Math.max(c.modifiedStart, Math.min(modifiedEnd, previewStartInCompletionText));
        const nonPreviewText = e.text.substring(c.modifiedStart, nonPreviewTextEnd);
        const italicText = e.text.substring(nonPreviewTextEnd, Math.max(c.modifiedStart, modifiedEnd));
        if (nonPreviewText.length > 0) parts.push(new (0, _ghostTextJs.GhostTextPart)(insertColumn, nonPreviewText, false));
        if (italicText.length > 0) parts.push(new (0, _ghostTextJs.GhostTextPart)(insertColumn, italicText, true));
    }
    return new (0, _ghostTextJs.GhostText)(lineNumber, parts);
}
function rangeExtends(extendingRange, rangeToExtend) {
    return rangeToExtend.getStartPosition().equals(extendingRange.getStartPosition()) && rangeToExtend.getEndPosition().isBeforeOrEqual(extendingRange.getEndPosition());
}
let lastRequest = undefined;
function cachingDiff(originalValue, newValue) {
    if (lastRequest?.originalValue === originalValue && lastRequest?.newValue === newValue) return lastRequest?.changes;
    else {
        let changes = smartDiff(originalValue, newValue, true);
        if (changes) {
            const deletedChars = deletedCharacters(changes);
            if (deletedChars > 0) {
                // For performance reasons, don't compute diff if there is nothing to improve
                const newChanges = smartDiff(originalValue, newValue, false);
                if (newChanges && deletedCharacters(newChanges) < deletedChars) // Disabling smartness seems to be better here
                changes = newChanges;
            }
        }
        lastRequest = {
            originalValue,
            newValue,
            changes
        };
        return changes;
    }
}
function deletedCharacters(changes) {
    let sum = 0;
    for (const c of changes)sum += c.originalLength;
    return sum;
}
/**
 * When matching `if ()` with `if (f() = 1) { g(); }`,
 * align it like this:        `if (       )`
 * Not like this:			  `if (  )`
 * Also not like this:		  `if (             )`.
 *
 * The parenthesis are preprocessed to ensure that they match correctly.
 */ function smartDiff(originalValue, newValue, smartBracketMatching) {
    if (originalValue.length > 5000 || newValue.length > 5000) // We don't want to work on strings that are too big
    return undefined;
    function getMaxCharCode(val) {
        let maxCharCode = 0;
        for(let i = 0, len = val.length; i < len; i++){
            const charCode = val.charCodeAt(i);
            if (charCode > maxCharCode) maxCharCode = charCode;
        }
        return maxCharCode;
    }
    const maxCharCode = Math.max(getMaxCharCode(originalValue), getMaxCharCode(newValue));
    function getUniqueCharCode(id) {
        if (id < 0) throw new Error("unexpected");
        return maxCharCode + id + 1;
    }
    function getElements(source) {
        let level = 0;
        let group = 0;
        const characters = new Int32Array(source.length);
        for(let i = 0, len = source.length; i < len; i++){
            // TODO support more brackets
            if (smartBracketMatching && source[i] === "(") {
                const id = group * 100 + level;
                characters[i] = getUniqueCharCode(2 * id);
                level++;
            } else if (smartBracketMatching && source[i] === ")") {
                level = Math.max(level - 1, 0);
                const id = group * 100 + level;
                characters[i] = getUniqueCharCode(2 * id + 1);
                if (level === 0) group++;
            } else characters[i] = source.charCodeAt(i);
        }
        return characters;
    }
    const elements1 = getElements(originalValue);
    const elements2 = getElements(newValue);
    return new (0, _diffJs.LcsDiff)({
        getElements: ()=>elements1
    }, {
        getElements: ()=>elements2
    }).ComputeDiff(false).changes;
}

},{"../../../../../base/common/diff/diff.js":"8KX5t","../../../../../base/common/strings.js":"aA9I1","../../../../common/core/range.js":"jmUPh","../../../../common/core/textLength.js":"Lk80L","../../../../common/core/textEdit.js":"hdqra","./ghostText.js":"htVY2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0XDQb":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SnippetController2", ()=>SnippetController2);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _typesJs = require("../../../../base/common/types.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _positionJs = require("../../../common/core/position.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _suggestJs = require("../../suggest/browser/suggest.js");
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _logJs = require("../../../../platform/log/common/log.js");
var _snippetSessionJs = require("./snippetSession.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var SnippetController2_1;
const _defaultOptions = {
    overwriteBefore: 0,
    overwriteAfter: 0,
    undoStopBefore: true,
    undoStopAfter: true,
    adjustWhitespace: true,
    clipboardText: undefined,
    overtypingCapturer: undefined
};
let SnippetController2 = class SnippetController2 {
    static{
        SnippetController2_1 = this;
    }
    static{
        this.ID = "snippetController2";
    }
    static get(editor) {
        return editor.getContribution(SnippetController2_1.ID);
    }
    static{
        this.InSnippetMode = new (0, _contextkeyJs.RawContextKey)("inSnippetMode", false, (0, _nlsJs.localize)("inSnippetMode", "Whether the editor in current in snippet mode"));
    }
    static{
        this.HasNextTabstop = new (0, _contextkeyJs.RawContextKey)("hasNextTabstop", false, (0, _nlsJs.localize)("hasNextTabstop", "Whether there is a next tab stop when in snippet mode"));
    }
    static{
        this.HasPrevTabstop = new (0, _contextkeyJs.RawContextKey)("hasPrevTabstop", false, (0, _nlsJs.localize)("hasPrevTabstop", "Whether there is a previous tab stop when in snippet mode"));
    }
    constructor(_editor, _logService, _languageFeaturesService, contextKeyService, _languageConfigurationService){
        this._editor = _editor;
        this._logService = _logService;
        this._languageFeaturesService = _languageFeaturesService;
        this._languageConfigurationService = _languageConfigurationService;
        this._snippetListener = new (0, _lifecycleJs.DisposableStore)();
        this._modelVersionId = -1;
        this._inSnippet = SnippetController2_1.InSnippetMode.bindTo(contextKeyService);
        this._hasNextTabstop = SnippetController2_1.HasNextTabstop.bindTo(contextKeyService);
        this._hasPrevTabstop = SnippetController2_1.HasPrevTabstop.bindTo(contextKeyService);
    }
    dispose() {
        this._inSnippet.reset();
        this._hasPrevTabstop.reset();
        this._hasNextTabstop.reset();
        this._session?.dispose();
        this._snippetListener.dispose();
    }
    insert(template, opts) {
        // this is here to find out more about the yet-not-understood
        // error that sometimes happens when we fail to inserted a nested
        // snippet
        try {
            this._doInsert(template, typeof opts === "undefined" ? _defaultOptions : {
                ..._defaultOptions,
                ...opts
            });
        } catch (e) {
            this.cancel();
            this._logService.error(e);
            this._logService.error("snippet_error");
            this._logService.error("insert_template=", template);
            this._logService.error("existing_template=", this._session ? this._session._logInfo() : "<no_session>");
        }
    }
    _doInsert(template, opts) {
        if (!this._editor.hasModel()) return;
        // don't listen while inserting the snippet
        // as that is the inflight state causing cancelation
        this._snippetListener.clear();
        if (opts.undoStopBefore) this._editor.getModel().pushStackElement();
        // don't merge
        if (this._session && typeof template !== "string") this.cancel();
        if (!this._session) {
            this._modelVersionId = this._editor.getModel().getAlternativeVersionId();
            this._session = new (0, _snippetSessionJs.SnippetSession)(this._editor, template, opts, this._languageConfigurationService);
            this._session.insert();
        } else {
            (0, _typesJs.assertType)(typeof template === "string");
            this._session.merge(template, opts);
        }
        if (opts.undoStopAfter) this._editor.getModel().pushStackElement();
        // regster completion item provider when there is any choice element
        if (this._session?.hasChoice) {
            const provider = {
                _debugDisplayName: "snippetChoiceCompletions",
                provideCompletionItems: (model, position)=>{
                    if (!this._session || model !== this._editor.getModel() || !(0, _positionJs.Position).equals(this._editor.getPosition(), position)) return undefined;
                    const { activeChoice } = this._session;
                    if (!activeChoice || activeChoice.choice.options.length === 0) return undefined;
                    const word = model.getValueInRange(activeChoice.range);
                    const isAnyOfOptions = Boolean(activeChoice.choice.options.find((o)=>o.value === word));
                    const suggestions = [];
                    for(let i = 0; i < activeChoice.choice.options.length; i++){
                        const option = activeChoice.choice.options[i];
                        suggestions.push({
                            kind: 13 /* CompletionItemKind.Value */ ,
                            label: option.value,
                            insertText: option.value,
                            sortText: "a".repeat(i + 1),
                            range: activeChoice.range,
                            filterText: isAnyOfOptions ? `${word}_${option.value}` : undefined,
                            command: {
                                id: "jumpToNextSnippetPlaceholder",
                                title: (0, _nlsJs.localize)("next", "Go to next placeholder...")
                            }
                        });
                    }
                    return {
                        suggestions
                    };
                }
            };
            const model = this._editor.getModel();
            let registration;
            let isRegistered = false;
            const disable = ()=>{
                registration?.dispose();
                isRegistered = false;
            };
            const enable = ()=>{
                if (!isRegistered) {
                    registration = this._languageFeaturesService.completionProvider.register({
                        language: model.getLanguageId(),
                        pattern: model.uri.fsPath,
                        scheme: model.uri.scheme,
                        exclusive: true
                    }, provider);
                    this._snippetListener.add(registration);
                    isRegistered = true;
                }
            };
            this._choiceCompletions = {
                provider,
                enable,
                disable
            };
        }
        this._updateState();
        this._snippetListener.add(this._editor.onDidChangeModelContent((e)=>e.isFlush && this.cancel()));
        this._snippetListener.add(this._editor.onDidChangeModel(()=>this.cancel()));
        this._snippetListener.add(this._editor.onDidChangeCursorSelection(()=>this._updateState()));
    }
    _updateState() {
        if (!this._session || !this._editor.hasModel()) // canceled in the meanwhile
        return;
        if (this._modelVersionId === this._editor.getModel().getAlternativeVersionId()) // undo until the 'before' state happened
        // and makes use cancel snippet mode
        return this.cancel();
        if (!this._session.hasPlaceholder) // don't listen for selection changes and don't
        // update context keys when the snippet is plain text
        return this.cancel();
        if (this._session.isAtLastPlaceholder || !this._session.isSelectionWithinPlaceholders()) {
            this._editor.getModel().pushStackElement();
            return this.cancel();
        }
        this._inSnippet.set(true);
        this._hasPrevTabstop.set(!this._session.isAtFirstPlaceholder);
        this._hasNextTabstop.set(!this._session.isAtLastPlaceholder);
        this._handleChoice();
    }
    _handleChoice() {
        if (!this._session || !this._editor.hasModel()) {
            this._currentChoice = undefined;
            return;
        }
        const { activeChoice } = this._session;
        if (!activeChoice || !this._choiceCompletions) {
            this._choiceCompletions?.disable();
            this._currentChoice = undefined;
            return;
        }
        if (this._currentChoice !== activeChoice.choice) {
            this._currentChoice = activeChoice.choice;
            this._choiceCompletions.enable();
            // trigger suggest with the special choice completion provider
            queueMicrotask(()=>{
                (0, _suggestJs.showSimpleSuggestions)(this._editor, this._choiceCompletions.provider);
            });
        }
    }
    finish() {
        while(this._inSnippet.get())this.next();
    }
    cancel(resetSelection = false) {
        this._inSnippet.reset();
        this._hasPrevTabstop.reset();
        this._hasNextTabstop.reset();
        this._snippetListener.clear();
        this._currentChoice = undefined;
        this._session?.dispose();
        this._session = undefined;
        this._modelVersionId = -1;
        if (resetSelection) // reset selection to the primary cursor when being asked
        // for. this happens when explicitly cancelling snippet mode,
        // e.g. when pressing ESC
        this._editor.setSelections([
            this._editor.getSelection()
        ]);
    }
    prev() {
        this._session?.prev();
        this._updateState();
    }
    next() {
        this._session?.next();
        this._updateState();
    }
    isInSnippet() {
        return Boolean(this._inSnippet.get());
    }
};
SnippetController2 = SnippetController2_1 = __decorate([
    __param(1, (0, _logJs.ILogService)),
    __param(2, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(3, (0, _contextkeyJs.IContextKeyService)),
    __param(4, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService))
], SnippetController2);
(0, _editorExtensionsJs.registerEditorContribution)(SnippetController2.ID, SnippetController2, 4 /* EditorContributionInstantiation.Lazy */ );
const CommandCtor = (0, _editorExtensionsJs.EditorCommand).bindToContribution(SnippetController2.get);
(0, _editorExtensionsJs.registerEditorCommand)(new CommandCtor({
    id: "jumpToNextSnippetPlaceholder",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and(SnippetController2.InSnippetMode, SnippetController2.HasNextTabstop),
    handler: (ctrl)=>ctrl.next(),
    kbOpts: {
        weight: 130,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 2 /* KeyCode.Tab */ 
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new CommandCtor({
    id: "jumpToPrevSnippetPlaceholder",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and(SnippetController2.InSnippetMode, SnippetController2.HasPrevTabstop),
    handler: (ctrl)=>ctrl.prev(),
    kbOpts: {
        weight: 130,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 1026 /* KeyCode.Tab */ 
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new CommandCtor({
    id: "leaveSnippet",
    precondition: SnippetController2.InSnippetMode,
    handler: (ctrl)=>ctrl.cancel(true),
    kbOpts: {
        weight: 130,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 9 /* KeyCode.Escape */ ,
        secondary: [
            1033 /* KeyCode.Escape */ 
        ]
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new CommandCtor({
    id: "acceptSnippet",
    precondition: SnippetController2.InSnippetMode,
    handler: (ctrl)=>ctrl.finish()
}));

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/types.js":"fb5yx","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/position.js":"lvrPe","../../../common/editorContextKeys.js":"5exv9","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../common/services/languageFeatures.js":"2IAko","../../suggest/browser/suggest.js":"8xSUV","../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/log/common/log.js":"ieJUF","./snippetSession.js":"dEh8D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8xSUV":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Context", ()=>Context);
parcelHelpers.export(exports, "suggestWidgetStatusbarMenu", ()=>suggestWidgetStatusbarMenu);
parcelHelpers.export(exports, "CompletionItem", ()=>CompletionItem);
parcelHelpers.export(exports, "CompletionOptions", ()=>CompletionOptions);
parcelHelpers.export(exports, "getSnippetSuggestSupport", ()=>getSnippetSuggestSupport);
parcelHelpers.export(exports, "CompletionItemModel", ()=>CompletionItemModel);
parcelHelpers.export(exports, "provideSuggestionItems", ()=>provideSuggestionItems);
parcelHelpers.export(exports, "getSuggestionComparator", ()=>getSuggestionComparator);
parcelHelpers.export(exports, "showSimpleSuggestions", ()=>showSimpleSuggestions);
parcelHelpers.export(exports, "QuickSuggestionsOptions", ()=>QuickSuggestionsOptions);
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _filtersJs = require("../../../../base/common/filters.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stopwatchJs = require("../../../../base/common/stopwatch.js");
var _typesJs = require("../../../../base/common/types.js");
var _uriJs = require("../../../../base/common/uri.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _resolverServiceJs = require("../../../common/services/resolverService.js");
var _snippetParserJs = require("../../snippet/browser/snippetParser.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _contextScopedHistoryWidgetJs = require("../../../../platform/history/browser/contextScopedHistoryWidget.js");
const Context = {
    Visible: (0, _contextScopedHistoryWidgetJs.historyNavigationVisible),
    HasFocusedSuggestion: new (0, _contextkeyJs.RawContextKey)("suggestWidgetHasFocusedSuggestion", false, (0, _nlsJs.localize)("suggestWidgetHasSelection", "Whether any suggestion is focused")),
    DetailsVisible: new (0, _contextkeyJs.RawContextKey)("suggestWidgetDetailsVisible", false, (0, _nlsJs.localize)("suggestWidgetDetailsVisible", "Whether suggestion details are visible")),
    MultipleSuggestions: new (0, _contextkeyJs.RawContextKey)("suggestWidgetMultipleSuggestions", false, (0, _nlsJs.localize)("suggestWidgetMultipleSuggestions", "Whether there are multiple suggestions to pick from")),
    MakesTextEdit: new (0, _contextkeyJs.RawContextKey)("suggestionMakesTextEdit", true, (0, _nlsJs.localize)("suggestionMakesTextEdit", "Whether inserting the current suggestion yields in a change or has everything already been typed")),
    AcceptSuggestionsOnEnter: new (0, _contextkeyJs.RawContextKey)("acceptSuggestionOnEnter", true, (0, _nlsJs.localize)("acceptSuggestionOnEnter", "Whether suggestions are inserted when pressing Enter")),
    HasInsertAndReplaceRange: new (0, _contextkeyJs.RawContextKey)("suggestionHasInsertAndReplaceRange", false, (0, _nlsJs.localize)("suggestionHasInsertAndReplaceRange", "Whether the current suggestion has insert and replace behaviour")),
    InsertMode: new (0, _contextkeyJs.RawContextKey)("suggestionInsertMode", undefined, {
        type: "string",
        description: (0, _nlsJs.localize)("suggestionInsertMode", "Whether the default behaviour is to insert or replace")
    }),
    CanResolve: new (0, _contextkeyJs.RawContextKey)("suggestionCanResolve", false, (0, _nlsJs.localize)("suggestionCanResolve", "Whether the current suggestion supports to resolve further details"))
};
const suggestWidgetStatusbarMenu = new (0, _actionsJs.MenuId)("suggestWidgetStatusBar");
class CompletionItem {
    constructor(position, completion, container, provider){
        this.position = position;
        this.completion = completion;
        this.container = container;
        this.provider = provider;
        // validation
        this.isInvalid = false;
        // sorting, filtering
        this.score = (0, _filtersJs.FuzzyScore).Default;
        this.distance = 0;
        this.textLabel = typeof completion.label === "string" ? completion.label : completion.label?.label;
        // ensure lower-variants (perf)
        this.labelLow = this.textLabel.toLowerCase();
        // validate label
        this.isInvalid = !this.textLabel;
        this.sortTextLow = completion.sortText && completion.sortText.toLowerCase();
        this.filterTextLow = completion.filterText && completion.filterText.toLowerCase();
        this.extensionId = completion.extensionId;
        // normalize ranges
        if ((0, _rangeJs.Range).isIRange(completion.range)) {
            this.editStart = new (0, _positionJs.Position)(completion.range.startLineNumber, completion.range.startColumn);
            this.editInsertEnd = new (0, _positionJs.Position)(completion.range.endLineNumber, completion.range.endColumn);
            this.editReplaceEnd = new (0, _positionJs.Position)(completion.range.endLineNumber, completion.range.endColumn);
            // validate range
            this.isInvalid = this.isInvalid || (0, _rangeJs.Range).spansMultipleLines(completion.range) || completion.range.startLineNumber !== position.lineNumber;
        } else {
            this.editStart = new (0, _positionJs.Position)(completion.range.insert.startLineNumber, completion.range.insert.startColumn);
            this.editInsertEnd = new (0, _positionJs.Position)(completion.range.insert.endLineNumber, completion.range.insert.endColumn);
            this.editReplaceEnd = new (0, _positionJs.Position)(completion.range.replace.endLineNumber, completion.range.replace.endColumn);
            // validate ranges
            this.isInvalid = this.isInvalid || (0, _rangeJs.Range).spansMultipleLines(completion.range.insert) || (0, _rangeJs.Range).spansMultipleLines(completion.range.replace) || completion.range.insert.startLineNumber !== position.lineNumber || completion.range.replace.startLineNumber !== position.lineNumber || completion.range.insert.startColumn !== completion.range.replace.startColumn;
        }
        // create the suggestion resolver
        if (typeof provider.resolveCompletionItem !== "function") {
            this._resolveCache = Promise.resolve();
            this._resolveDuration = 0;
        }
    }
    // ---- resolving
    get isResolved() {
        return this._resolveDuration !== undefined;
    }
    get resolveDuration() {
        return this._resolveDuration !== undefined ? this._resolveDuration : -1;
    }
    async resolve(token) {
        if (!this._resolveCache) {
            const sub = token.onCancellationRequested(()=>{
                this._resolveCache = undefined;
                this._resolveDuration = undefined;
            });
            const sw = new (0, _stopwatchJs.StopWatch)(true);
            this._resolveCache = Promise.resolve(this.provider.resolveCompletionItem(this.completion, token)).then((value)=>{
                Object.assign(this.completion, value);
                this._resolveDuration = sw.elapsed();
            }, (err)=>{
                if ((0, _errorsJs.isCancellationError)(err)) {
                    // the IPC queue will reject the request with the
                    // cancellation error -> reset cached
                    this._resolveCache = undefined;
                    this._resolveDuration = undefined;
                }
            }).finally(()=>{
                sub.dispose();
            });
        }
        return this._resolveCache;
    }
}
class CompletionOptions {
    static{
        this.default = new CompletionOptions();
    }
    constructor(snippetSortOrder = 2 /* SnippetSortOrder.Bottom */ , kindFilter = new Set(), providerFilter = new Set(), providerItemsToReuse = new Map(), showDeprecated = true){
        this.snippetSortOrder = snippetSortOrder;
        this.kindFilter = kindFilter;
        this.providerFilter = providerFilter;
        this.providerItemsToReuse = providerItemsToReuse;
        this.showDeprecated = showDeprecated;
    }
}
let _snippetSuggestSupport;
function getSnippetSuggestSupport() {
    return _snippetSuggestSupport;
}
class CompletionItemModel {
    constructor(items, needsClipboard, durations, disposable){
        this.items = items;
        this.needsClipboard = needsClipboard;
        this.durations = durations;
        this.disposable = disposable;
    }
}
async function provideSuggestionItems(registry, model, position, options = CompletionOptions.default, context = {
    triggerKind: 0 /* languages.CompletionTriggerKind.Invoke */ 
}, token = (0, _cancellationJs.CancellationToken).None) {
    const sw = new (0, _stopwatchJs.StopWatch)();
    position = position.clone();
    const word = model.getWordAtPosition(position);
    const defaultReplaceRange = word ? new (0, _rangeJs.Range)(position.lineNumber, word.startColumn, position.lineNumber, word.endColumn) : (0, _rangeJs.Range).fromPositions(position);
    const defaultRange = {
        replace: defaultReplaceRange,
        insert: defaultReplaceRange.setEndPosition(position.lineNumber, position.column)
    };
    const result = [];
    const disposables = new (0, _lifecycleJs.DisposableStore)();
    const durations = [];
    let needsClipboard = false;
    const onCompletionList = (provider, container, sw)=>{
        let didAddResult = false;
        if (!container) return didAddResult;
        for (const suggestion of container.suggestions)if (!options.kindFilter.has(suggestion.kind)) {
            // skip if not showing deprecated suggestions
            if (!options.showDeprecated && suggestion?.tags?.includes(1 /* languages.CompletionItemTag.Deprecated */ )) continue;
            // fill in default range when missing
            if (!suggestion.range) suggestion.range = defaultRange;
            // fill in default sortText when missing
            if (!suggestion.sortText) suggestion.sortText = typeof suggestion.label === "string" ? suggestion.label : suggestion.label.label;
            if (!needsClipboard && suggestion.insertTextRules && suggestion.insertTextRules & 4 /* languages.CompletionItemInsertTextRule.InsertAsSnippet */ ) needsClipboard = (0, _snippetParserJs.SnippetParser).guessNeedsClipboard(suggestion.insertText);
            result.push(new CompletionItem(position, suggestion, container, provider));
            didAddResult = true;
        }
        if ((0, _lifecycleJs.isDisposable)(container)) disposables.add(container);
        durations.push({
            providerName: provider._debugDisplayName ?? "unknown_provider",
            elapsedProvider: container.duration ?? -1,
            elapsedOverall: sw.elapsed()
        });
        return didAddResult;
    };
    // ask for snippets in parallel to asking "real" providers. Only do something if configured to
    // do so - no snippet filter, no special-providers-only request
    const snippetCompletions = (async ()=>{
        if (!_snippetSuggestSupport || options.kindFilter.has(27 /* languages.CompletionItemKind.Snippet */ )) return;
        // we have items from a previous session that we can reuse
        const reuseItems = options.providerItemsToReuse.get(_snippetSuggestSupport);
        if (reuseItems) {
            reuseItems.forEach((item)=>result.push(item));
            return;
        }
        if (options.providerFilter.size > 0 && !options.providerFilter.has(_snippetSuggestSupport)) return;
        const sw = new (0, _stopwatchJs.StopWatch)();
        const list = await _snippetSuggestSupport.provideCompletionItems(model, position, context, token);
        onCompletionList(_snippetSuggestSupport, list, sw);
    })();
    // add suggestions from contributed providers - providers are ordered in groups of
    // equal score and once a group produces a result the process stops
    // get provider groups, always add snippet suggestion provider
    for (const providerGroup of registry.orderedGroups(model)){
        // for each support in the group ask for suggestions
        let didAddResult = false;
        await Promise.all(providerGroup.map(async (provider)=>{
            // we have items from a previous session that we can reuse
            if (options.providerItemsToReuse.has(provider)) {
                const items = options.providerItemsToReuse.get(provider);
                items.forEach((item)=>result.push(item));
                didAddResult = didAddResult || items.length > 0;
                return;
            }
            // check if this provider is filtered out
            if (options.providerFilter.size > 0 && !options.providerFilter.has(provider)) return;
            try {
                const sw = new (0, _stopwatchJs.StopWatch)();
                const list = await provider.provideCompletionItems(model, position, context, token);
                didAddResult = onCompletionList(provider, list, sw) || didAddResult;
            } catch (err) {
                (0, _errorsJs.onUnexpectedExternalError)(err);
            }
        }));
        if (didAddResult || token.isCancellationRequested) break;
    }
    await snippetCompletions;
    if (token.isCancellationRequested) {
        disposables.dispose();
        return Promise.reject(new (0, _errorsJs.CancellationError)());
    }
    return new CompletionItemModel(result.sort(getSuggestionComparator(options.snippetSortOrder)), needsClipboard, {
        entries: durations,
        elapsed: sw.elapsed()
    }, disposables);
}
function defaultComparator(a, b) {
    // check with 'sortText'
    if (a.sortTextLow && b.sortTextLow) {
        if (a.sortTextLow < b.sortTextLow) return -1;
        else if (a.sortTextLow > b.sortTextLow) return 1;
    }
    // check with 'label'
    if (a.textLabel < b.textLabel) return -1;
    else if (a.textLabel > b.textLabel) return 1;
    // check with 'type'
    return a.completion.kind - b.completion.kind;
}
function snippetUpComparator(a, b) {
    if (a.completion.kind !== b.completion.kind) {
        if (a.completion.kind === 27 /* languages.CompletionItemKind.Snippet */ ) return -1;
        else if (b.completion.kind === 27 /* languages.CompletionItemKind.Snippet */ ) return 1;
    }
    return defaultComparator(a, b);
}
function snippetDownComparator(a, b) {
    if (a.completion.kind !== b.completion.kind) {
        if (a.completion.kind === 27 /* languages.CompletionItemKind.Snippet */ ) return 1;
        else if (b.completion.kind === 27 /* languages.CompletionItemKind.Snippet */ ) return -1;
    }
    return defaultComparator(a, b);
}
const _snippetComparators = new Map();
_snippetComparators.set(0 /* SnippetSortOrder.Top */ , snippetUpComparator);
_snippetComparators.set(2 /* SnippetSortOrder.Bottom */ , snippetDownComparator);
_snippetComparators.set(1 /* SnippetSortOrder.Inline */ , defaultComparator);
function getSuggestionComparator(snippetConfig) {
    return _snippetComparators.get(snippetConfig);
}
(0, _commandsJs.CommandsRegistry).registerCommand("_executeCompletionItemProvider", async (accessor, ...args)=>{
    const [uri, position, triggerCharacter, maxItemsToResolve] = args;
    (0, _typesJs.assertType)((0, _uriJs.URI).isUri(uri));
    (0, _typesJs.assertType)((0, _positionJs.Position).isIPosition(position));
    (0, _typesJs.assertType)(typeof triggerCharacter === "string" || !triggerCharacter);
    (0, _typesJs.assertType)(typeof maxItemsToResolve === "number" || !maxItemsToResolve);
    const { completionProvider } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const ref = await accessor.get((0, _resolverServiceJs.ITextModelService)).createModelReference(uri);
    try {
        const result = {
            incomplete: false,
            suggestions: []
        };
        const resolving = [];
        const actualPosition = ref.object.textEditorModel.validatePosition(position);
        const completions = await provideSuggestionItems(completionProvider, ref.object.textEditorModel, actualPosition, undefined, {
            triggerCharacter: triggerCharacter ?? undefined,
            triggerKind: triggerCharacter ? 1 /* languages.CompletionTriggerKind.TriggerCharacter */  : 0 /* languages.CompletionTriggerKind.Invoke */ 
        });
        for (const item of completions.items){
            if (resolving.length < (maxItemsToResolve ?? 0)) resolving.push(item.resolve((0, _cancellationJs.CancellationToken).None));
            result.incomplete = result.incomplete || item.container.incomplete;
            result.suggestions.push(item.completion);
        }
        try {
            await Promise.all(resolving);
            return result;
        } finally{
            setTimeout(()=>completions.disposable.dispose(), 100);
        }
    } finally{
        ref.dispose();
    }
});
function showSimpleSuggestions(editor, provider) {
    editor.getContribution("editor.contrib.suggestController")?.triggerSuggest(new Set().add(provider), undefined, true);
}
class QuickSuggestionsOptions {
    static isAllOff(config) {
        return config.other === "off" && config.comments === "off" && config.strings === "off";
    }
    static isAllOn(config) {
        return config.other === "on" && config.comments === "on" && config.strings === "on";
    }
    static valueFor(config, tokenType) {
        switch(tokenType){
            case 1 /* StandardTokenType.Comment */ :
                return config.comments;
            case 2 /* StandardTokenType.String */ :
                return config.strings;
            default:
                return config.other;
        }
    }
}

},{"../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/filters.js":"40BGZ","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/stopwatch.js":"77PF9","../../../../base/common/types.js":"fb5yx","../../../../base/common/uri.js":"7qGS3","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/services/resolverService.js":"ezAtF","../../snippet/browser/snippetParser.js":"6qHnq","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../common/services/languageFeatures.js":"2IAko","../../../../platform/history/browser/contextScopedHistoryWidget.js":"k152x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dEh8D":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OneSnippet", ()=>OneSnippet);
parcelHelpers.export(exports, "SnippetSession", ()=>SnippetSession);
var _arraysJs = require("../../../../base/common/arrays.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _snippetSessionCss = require("./snippetSession.css");
var _editOperationJs = require("../../../common/core/editOperation.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _labelJs = require("../../../../platform/label/common/label.js");
var _workspaceJs = require("../../../../platform/workspace/common/workspace.js");
var _snippetParserJs = require("./snippetParser.js");
var _snippetVariablesJs = require("./snippetVariables.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var SnippetSession_1;
class OneSnippet {
    static{
        this._decor = {
            active: (0, _textModelJs.ModelDecorationOptions).register({
                description: "snippet-placeholder-1",
                stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ,
                className: "snippet-placeholder"
            }),
            inactive: (0, _textModelJs.ModelDecorationOptions).register({
                description: "snippet-placeholder-2",
                stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
                className: "snippet-placeholder"
            }),
            activeFinal: (0, _textModelJs.ModelDecorationOptions).register({
                description: "snippet-placeholder-3",
                stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
                className: "finish-snippet-placeholder"
            }),
            inactiveFinal: (0, _textModelJs.ModelDecorationOptions).register({
                description: "snippet-placeholder-4",
                stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
                className: "finish-snippet-placeholder"
            })
        };
    }
    constructor(_editor, _snippet, _snippetLineLeadingWhitespace){
        this._editor = _editor;
        this._snippet = _snippet;
        this._snippetLineLeadingWhitespace = _snippetLineLeadingWhitespace;
        this._offset = -1;
        this._nestingLevel = 1;
        this._placeholderGroups = (0, _arraysJs.groupBy)(_snippet.placeholders, (0, _snippetParserJs.Placeholder).compareByIndex);
        this._placeholderGroupsIdx = -1;
    }
    initialize(textChange) {
        this._offset = textChange.newPosition;
    }
    dispose() {
        if (this._placeholderDecorations) this._editor.removeDecorations([
            ...this._placeholderDecorations.values()
        ]);
        this._placeholderGroups.length = 0;
    }
    _initDecorations() {
        if (this._offset === -1) throw new Error(`Snippet not initialized!`);
        if (this._placeholderDecorations) // already initialized
        return;
        this._placeholderDecorations = new Map();
        const model = this._editor.getModel();
        this._editor.changeDecorations((accessor)=>{
            // create a decoration for each placeholder
            for (const placeholder of this._snippet.placeholders){
                const placeholderOffset = this._snippet.offset(placeholder);
                const placeholderLen = this._snippet.fullLen(placeholder);
                const range = (0, _rangeJs.Range).fromPositions(model.getPositionAt(this._offset + placeholderOffset), model.getPositionAt(this._offset + placeholderOffset + placeholderLen));
                const options = placeholder.isFinalTabstop ? OneSnippet._decor.inactiveFinal : OneSnippet._decor.inactive;
                const handle = accessor.addDecoration(range, options);
                this._placeholderDecorations.set(placeholder, handle);
            }
        });
    }
    move(fwd) {
        if (!this._editor.hasModel()) return [];
        this._initDecorations();
        // Transform placeholder text if necessary
        if (this._placeholderGroupsIdx >= 0) {
            const operations = [];
            for (const placeholder of this._placeholderGroups[this._placeholderGroupsIdx])// Check if the placeholder has a transformation
            if (placeholder.transform) {
                const id = this._placeholderDecorations.get(placeholder);
                const range = this._editor.getModel().getDecorationRange(id);
                const currentValue = this._editor.getModel().getValueInRange(range);
                const transformedValueLines = placeholder.transform.resolve(currentValue).split(/\r\n|\r|\n/);
                // fix indentation for transformed lines
                for(let i = 1; i < transformedValueLines.length; i++)transformedValueLines[i] = this._editor.getModel().normalizeIndentation(this._snippetLineLeadingWhitespace + transformedValueLines[i]);
                operations.push((0, _editOperationJs.EditOperation).replace(range, transformedValueLines.join(this._editor.getModel().getEOL())));
            }
            if (operations.length > 0) this._editor.executeEdits("snippet.placeholderTransform", operations);
        }
        let couldSkipThisPlaceholder = false;
        if (fwd === true && this._placeholderGroupsIdx < this._placeholderGroups.length - 1) {
            this._placeholderGroupsIdx += 1;
            couldSkipThisPlaceholder = true;
        } else if (fwd === false && this._placeholderGroupsIdx > 0) {
            this._placeholderGroupsIdx -= 1;
            couldSkipThisPlaceholder = true;
        }
        const newSelections = this._editor.getModel().changeDecorations((accessor)=>{
            const activePlaceholders = new Set();
            // change stickiness to always grow when typing at its edges
            // because these decorations represent the currently active
            // tabstop.
            // Special case #1: reaching the final tabstop
            // Special case #2: placeholders enclosing active placeholders
            const selections = [];
            for (const placeholder of this._placeholderGroups[this._placeholderGroupsIdx]){
                const id = this._placeholderDecorations.get(placeholder);
                const range = this._editor.getModel().getDecorationRange(id);
                selections.push(new (0, _selectionJs.Selection)(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn));
                // consider to skip this placeholder index when the decoration
                // range is empty but when the placeholder wasn't. that's a strong
                // hint that the placeholder has been deleted. (all placeholder must match this)
                couldSkipThisPlaceholder = couldSkipThisPlaceholder && this._hasPlaceholderBeenCollapsed(placeholder);
                accessor.changeDecorationOptions(id, placeholder.isFinalTabstop ? OneSnippet._decor.activeFinal : OneSnippet._decor.active);
                activePlaceholders.add(placeholder);
                for (const enclosingPlaceholder of this._snippet.enclosingPlaceholders(placeholder)){
                    const id = this._placeholderDecorations.get(enclosingPlaceholder);
                    accessor.changeDecorationOptions(id, enclosingPlaceholder.isFinalTabstop ? OneSnippet._decor.activeFinal : OneSnippet._decor.active);
                    activePlaceholders.add(enclosingPlaceholder);
                }
            }
            // change stickness to never grow when typing at its edges
            // so that in-active tabstops never grow
            for (const [placeholder, id] of this._placeholderDecorations)if (!activePlaceholders.has(placeholder)) accessor.changeDecorationOptions(id, placeholder.isFinalTabstop ? OneSnippet._decor.inactiveFinal : OneSnippet._decor.inactive);
            return selections;
        });
        return !couldSkipThisPlaceholder ? newSelections ?? [] : this.move(fwd);
    }
    _hasPlaceholderBeenCollapsed(placeholder) {
        // A placeholder is empty when it wasn't empty when authored but
        // when its tracking decoration is empty. This also applies to all
        // potential parent placeholders
        let marker = placeholder;
        while(marker){
            if (marker instanceof (0, _snippetParserJs.Placeholder)) {
                const id = this._placeholderDecorations.get(marker);
                const range = this._editor.getModel().getDecorationRange(id);
                if (range.isEmpty() && marker.toString().length > 0) return true;
            }
            marker = marker.parent;
        }
        return false;
    }
    get isAtFirstPlaceholder() {
        return this._placeholderGroupsIdx <= 0 || this._placeholderGroups.length === 0;
    }
    get isAtLastPlaceholder() {
        return this._placeholderGroupsIdx === this._placeholderGroups.length - 1;
    }
    get hasPlaceholder() {
        return this._snippet.placeholders.length > 0;
    }
    /**
     * A snippet is trivial when it has no placeholder or only a final placeholder at
     * its very end
     */ get isTrivialSnippet() {
        if (this._snippet.placeholders.length === 0) return true;
        if (this._snippet.placeholders.length === 1) {
            const [placeholder] = this._snippet.placeholders;
            if (placeholder.isFinalTabstop) {
                if (this._snippet.rightMostDescendant === placeholder) return true;
            }
        }
        return false;
    }
    computePossibleSelections() {
        const result = new Map();
        for (const placeholdersWithEqualIndex of this._placeholderGroups){
            let ranges;
            for (const placeholder of placeholdersWithEqualIndex){
                if (placeholder.isFinalTabstop) break;
                if (!ranges) {
                    ranges = [];
                    result.set(placeholder.index, ranges);
                }
                const id = this._placeholderDecorations.get(placeholder);
                const range = this._editor.getModel().getDecorationRange(id);
                if (!range) {
                    // one of the placeholder lost its decoration and
                    // therefore we bail out and pretend the placeholder
                    // (with its mirrors) doesn't exist anymore.
                    result.delete(placeholder.index);
                    break;
                }
                ranges.push(range);
            }
        }
        return result;
    }
    get activeChoice() {
        if (!this._placeholderDecorations) return undefined;
        const placeholder = this._placeholderGroups[this._placeholderGroupsIdx][0];
        if (!placeholder?.choice) return undefined;
        const id = this._placeholderDecorations.get(placeholder);
        if (!id) return undefined;
        const range = this._editor.getModel().getDecorationRange(id);
        if (!range) return undefined;
        return {
            range,
            choice: placeholder.choice
        };
    }
    get hasChoice() {
        let result = false;
        this._snippet.walk((marker)=>{
            result = marker instanceof (0, _snippetParserJs.Choice);
            return !result;
        });
        return result;
    }
    merge(others) {
        const model = this._editor.getModel();
        this._nestingLevel *= 10;
        this._editor.changeDecorations((accessor)=>{
            // For each active placeholder take one snippet and merge it
            // in that the placeholder (can be many for `$1foo$1foo`). Because
            // everything is sorted by editor selection we can simply remove
            // elements from the beginning of the array
            for (const placeholder of this._placeholderGroups[this._placeholderGroupsIdx]){
                const nested = others.shift();
                console.assert(nested._offset !== -1);
                console.assert(!nested._placeholderDecorations);
                // Massage placeholder-indicies of the nested snippet to be
                // sorted right after the insertion point. This ensures we move
                // through the placeholders in the correct order
                const indexLastPlaceholder = nested._snippet.placeholderInfo.last.index;
                for (const nestedPlaceholder of nested._snippet.placeholderInfo.all)if (nestedPlaceholder.isFinalTabstop) nestedPlaceholder.index = placeholder.index + (indexLastPlaceholder + 1) / this._nestingLevel;
                else nestedPlaceholder.index = placeholder.index + nestedPlaceholder.index / this._nestingLevel;
                this._snippet.replace(placeholder, nested._snippet.children);
                // Remove the placeholder at which position are inserting
                // the snippet and also remove its decoration.
                const id = this._placeholderDecorations.get(placeholder);
                accessor.removeDecoration(id);
                this._placeholderDecorations.delete(placeholder);
                // For each *new* placeholder we create decoration to monitor
                // how and if it grows/shrinks.
                for (const placeholder of nested._snippet.placeholders){
                    const placeholderOffset = nested._snippet.offset(placeholder);
                    const placeholderLen = nested._snippet.fullLen(placeholder);
                    const range = (0, _rangeJs.Range).fromPositions(model.getPositionAt(nested._offset + placeholderOffset), model.getPositionAt(nested._offset + placeholderOffset + placeholderLen));
                    const handle = accessor.addDecoration(range, OneSnippet._decor.inactive);
                    this._placeholderDecorations.set(placeholder, handle);
                }
            }
            // Last, re-create the placeholder groups by sorting placeholders by their index.
            this._placeholderGroups = (0, _arraysJs.groupBy)(this._snippet.placeholders, (0, _snippetParserJs.Placeholder).compareByIndex);
        });
    }
}
const _defaultOptions = {
    overwriteBefore: 0,
    overwriteAfter: 0,
    adjustWhitespace: true,
    clipboardText: undefined,
    overtypingCapturer: undefined
};
let SnippetSession = SnippetSession_1 = class SnippetSession {
    static adjustWhitespace(model, position, adjustIndentation, snippet, filter) {
        const line = model.getLineContent(position.lineNumber);
        const lineLeadingWhitespace = (0, _stringsJs.getLeadingWhitespace)(line, 0, position.column - 1);
        // the snippet as inserted
        let snippetTextString;
        snippet.walk((marker)=>{
            // all text elements that are not inside choice
            if (!(marker instanceof (0, _snippetParserJs.Text)) || marker.parent instanceof (0, _snippetParserJs.Choice)) return true;
            // check with filter (iff provided)
            if (filter && !filter.has(marker)) return true;
            const lines = marker.value.split(/\r\n|\r|\n/);
            if (adjustIndentation) {
                // adjust indentation of snippet test
                // -the snippet-start doesn't get extra-indented (lineLeadingWhitespace), only normalized
                // -all N+1 lines get extra-indented and normalized
                // -the text start get extra-indented and normalized when following a linebreak
                const offset = snippet.offset(marker);
                if (offset === 0) // snippet start
                lines[0] = model.normalizeIndentation(lines[0]);
                else {
                    // check if text start is after a linebreak
                    snippetTextString = snippetTextString ?? snippet.toString();
                    const prevChar = snippetTextString.charCodeAt(offset - 1);
                    if (prevChar === 10 /* CharCode.LineFeed */  || prevChar === 13 /* CharCode.CarriageReturn */ ) lines[0] = model.normalizeIndentation(lineLeadingWhitespace + lines[0]);
                }
                for(let i = 1; i < lines.length; i++)lines[i] = model.normalizeIndentation(lineLeadingWhitespace + lines[i]);
            }
            const newValue = lines.join(model.getEOL());
            if (newValue !== marker.value) {
                marker.parent.replace(marker, [
                    new (0, _snippetParserJs.Text)(newValue)
                ]);
                snippetTextString = undefined;
            }
            return true;
        });
        return lineLeadingWhitespace;
    }
    static adjustSelection(model, selection, overwriteBefore, overwriteAfter) {
        if (overwriteBefore !== 0 || overwriteAfter !== 0) {
            // overwrite[Before|After] is compute using the position, not the whole
            // selection. therefore we adjust the selection around that position
            const { positionLineNumber, positionColumn } = selection;
            const positionColumnBefore = positionColumn - overwriteBefore;
            const positionColumnAfter = positionColumn + overwriteAfter;
            const range = model.validateRange({
                startLineNumber: positionLineNumber,
                startColumn: positionColumnBefore,
                endLineNumber: positionLineNumber,
                endColumn: positionColumnAfter
            });
            selection = (0, _selectionJs.Selection).createWithDirection(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn, selection.getDirection());
        }
        return selection;
    }
    static createEditsAndSnippetsFromSelections(editor, template, overwriteBefore, overwriteAfter, enforceFinalTabstop, adjustWhitespace, clipboardText, overtypingCapturer, languageConfigurationService) {
        const edits = [];
        const snippets = [];
        if (!editor.hasModel()) return {
            edits,
            snippets
        };
        const model = editor.getModel();
        const workspaceService = editor.invokeWithinContext((accessor)=>accessor.get((0, _workspaceJs.IWorkspaceContextService)));
        const modelBasedVariableResolver = editor.invokeWithinContext((accessor)=>new (0, _snippetVariablesJs.ModelBasedVariableResolver)(accessor.get((0, _labelJs.ILabelService)), model));
        const readClipboardText = ()=>clipboardText;
        // know what text the overwrite[Before|After] extensions
        // of the primary curser have selected because only when
        // secondary selections extend to the same text we can grow them
        const firstBeforeText = model.getValueInRange(SnippetSession_1.adjustSelection(model, editor.getSelection(), overwriteBefore, 0));
        const firstAfterText = model.getValueInRange(SnippetSession_1.adjustSelection(model, editor.getSelection(), 0, overwriteAfter));
        // remember the first non-whitespace column to decide if
        // `keepWhitespace` should be overruled for secondary selections
        const firstLineFirstNonWhitespace = model.getLineFirstNonWhitespaceColumn(editor.getSelection().positionLineNumber);
        // sort selections by their start position but remeber
        // the original index. that allows you to create correct
        // offset-based selection logic without changing the
        // primary selection
        const indexedSelections = editor.getSelections().map((selection, idx)=>({
                selection,
                idx
            })).sort((a, b)=>(0, _rangeJs.Range).compareRangesUsingStarts(a.selection, b.selection));
        for (const { selection, idx } of indexedSelections){
            // extend selection with the `overwriteBefore` and `overwriteAfter` and then
            // compare if this matches the extensions of the primary selection
            let extensionBefore = SnippetSession_1.adjustSelection(model, selection, overwriteBefore, 0);
            let extensionAfter = SnippetSession_1.adjustSelection(model, selection, 0, overwriteAfter);
            if (firstBeforeText !== model.getValueInRange(extensionBefore)) extensionBefore = selection;
            if (firstAfterText !== model.getValueInRange(extensionAfter)) extensionAfter = selection;
            // merge the before and after selection into one
            const snippetSelection = selection.setStartPosition(extensionBefore.startLineNumber, extensionBefore.startColumn).setEndPosition(extensionAfter.endLineNumber, extensionAfter.endColumn);
            const snippet = new (0, _snippetParserJs.SnippetParser)().parse(template, true, enforceFinalTabstop);
            // adjust the template string to match the indentation and
            // whitespace rules of this insert location (can be different for each cursor)
            // happens when being asked for (default) or when this is a secondary
            // cursor and the leading whitespace is different
            const start = snippetSelection.getStartPosition();
            const snippetLineLeadingWhitespace = SnippetSession_1.adjustWhitespace(model, start, adjustWhitespace || idx > 0 && firstLineFirstNonWhitespace !== model.getLineFirstNonWhitespaceColumn(selection.positionLineNumber), snippet);
            snippet.resolveVariables(new (0, _snippetVariablesJs.CompositeSnippetVariableResolver)([
                modelBasedVariableResolver,
                new (0, _snippetVariablesJs.ClipboardBasedVariableResolver)(readClipboardText, idx, indexedSelections.length, editor.getOption(79 /* EditorOption.multiCursorPaste */ ) === "spread"),
                new (0, _snippetVariablesJs.SelectionBasedVariableResolver)(model, selection, idx, overtypingCapturer),
                new (0, _snippetVariablesJs.CommentBasedVariableResolver)(model, selection, languageConfigurationService),
                new (0, _snippetVariablesJs.TimeBasedVariableResolver),
                new (0, _snippetVariablesJs.WorkspaceBasedVariableResolver)(workspaceService),
                new (0, _snippetVariablesJs.RandomBasedVariableResolver)
            ]));
            // store snippets with the index of their originating selection.
            // that ensures the primiary cursor stays primary despite not being
            // the one with lowest start position
            edits[idx] = (0, _editOperationJs.EditOperation).replace(snippetSelection, snippet.toString());
            edits[idx].identifier = {
                major: idx,
                minor: 0
            }; // mark the edit so only our undo edits will be used to generate end cursors
            edits[idx]._isTracked = true;
            snippets[idx] = new OneSnippet(editor, snippet, snippetLineLeadingWhitespace);
        }
        return {
            edits,
            snippets
        };
    }
    static createEditsAndSnippetsFromEdits(editor, snippetEdits, enforceFinalTabstop, adjustWhitespace, clipboardText, overtypingCapturer, languageConfigurationService) {
        if (!editor.hasModel() || snippetEdits.length === 0) return {
            edits: [],
            snippets: []
        };
        const edits = [];
        const model = editor.getModel();
        const parser = new (0, _snippetParserJs.SnippetParser)();
        const snippet = new (0, _snippetParserJs.TextmateSnippet)();
        // snippet variables resolver
        const resolver = new (0, _snippetVariablesJs.CompositeSnippetVariableResolver)([
            editor.invokeWithinContext((accessor)=>new (0, _snippetVariablesJs.ModelBasedVariableResolver)(accessor.get((0, _labelJs.ILabelService)), model)),
            new (0, _snippetVariablesJs.ClipboardBasedVariableResolver)(()=>clipboardText, 0, editor.getSelections().length, editor.getOption(79 /* EditorOption.multiCursorPaste */ ) === "spread"),
            new (0, _snippetVariablesJs.SelectionBasedVariableResolver)(model, editor.getSelection(), 0, overtypingCapturer),
            new (0, _snippetVariablesJs.CommentBasedVariableResolver)(model, editor.getSelection(), languageConfigurationService),
            new (0, _snippetVariablesJs.TimeBasedVariableResolver),
            new (0, _snippetVariablesJs.WorkspaceBasedVariableResolver)(editor.invokeWithinContext((accessor)=>accessor.get((0, _workspaceJs.IWorkspaceContextService)))),
            new (0, _snippetVariablesJs.RandomBasedVariableResolver)
        ]);
        //
        snippetEdits = snippetEdits.sort((a, b)=>(0, _rangeJs.Range).compareRangesUsingStarts(a.range, b.range));
        let offset = 0;
        for(let i = 0; i < snippetEdits.length; i++){
            const { range, template } = snippetEdits[i];
            // gaps between snippet edits are appended as text nodes. this
            // ensures placeholder-offsets are later correct
            if (i > 0) {
                const lastRange = snippetEdits[i - 1].range;
                const textRange = (0, _rangeJs.Range).fromPositions(lastRange.getEndPosition(), range.getStartPosition());
                const textNode = new (0, _snippetParserJs.Text)(model.getValueInRange(textRange));
                snippet.appendChild(textNode);
                offset += textNode.value.length;
            }
            const newNodes = parser.parseFragment(template, snippet);
            SnippetSession_1.adjustWhitespace(model, range.getStartPosition(), true, snippet, new Set(newNodes));
            snippet.resolveVariables(resolver);
            const snippetText = snippet.toString();
            const snippetFragmentText = snippetText.slice(offset);
            offset = snippetText.length;
            // make edit
            const edit = (0, _editOperationJs.EditOperation).replace(range, snippetFragmentText);
            edit.identifier = {
                major: i,
                minor: 0
            }; // mark the edit so only our undo edits will be used to generate end cursors
            edit._isTracked = true;
            edits.push(edit);
        }
        //
        parser.ensureFinalTabstop(snippet, enforceFinalTabstop, true);
        return {
            edits,
            snippets: [
                new OneSnippet(editor, snippet, "")
            ]
        };
    }
    constructor(_editor, _template, _options = _defaultOptions, _languageConfigurationService){
        this._editor = _editor;
        this._template = _template;
        this._options = _options;
        this._languageConfigurationService = _languageConfigurationService;
        this._templateMerges = [];
        this._snippets = [];
    }
    dispose() {
        (0, _lifecycleJs.dispose)(this._snippets);
    }
    _logInfo() {
        return `template="${this._template}", merged_templates="${this._templateMerges.join(" -> ")}"`;
    }
    insert() {
        if (!this._editor.hasModel()) return;
        // make insert edit and start with first selections
        const { edits, snippets } = typeof this._template === "string" ? SnippetSession_1.createEditsAndSnippetsFromSelections(this._editor, this._template, this._options.overwriteBefore, this._options.overwriteAfter, false, this._options.adjustWhitespace, this._options.clipboardText, this._options.overtypingCapturer, this._languageConfigurationService) : SnippetSession_1.createEditsAndSnippetsFromEdits(this._editor, this._template, false, this._options.adjustWhitespace, this._options.clipboardText, this._options.overtypingCapturer, this._languageConfigurationService);
        this._snippets = snippets;
        this._editor.executeEdits("snippet", edits, (_undoEdits)=>{
            // Sometimes, the text buffer will remove automatic whitespace when doing any edits,
            // so we need to look only at the undo edits relevant for us.
            // Our edits have an identifier set so that's how we can distinguish them
            const undoEdits = _undoEdits.filter((edit)=>!!edit.identifier);
            for(let idx = 0; idx < snippets.length; idx++)snippets[idx].initialize(undoEdits[idx].textChange);
            if (this._snippets[0].hasPlaceholder) return this._move(true);
            else return undoEdits.map((edit)=>(0, _selectionJs.Selection).fromPositions(edit.range.getEndPosition()));
        });
        this._editor.revealRange(this._editor.getSelections()[0]);
    }
    merge(template, options = _defaultOptions) {
        if (!this._editor.hasModel()) return;
        this._templateMerges.push([
            this._snippets[0]._nestingLevel,
            this._snippets[0]._placeholderGroupsIdx,
            template
        ]);
        const { edits, snippets } = SnippetSession_1.createEditsAndSnippetsFromSelections(this._editor, template, options.overwriteBefore, options.overwriteAfter, true, options.adjustWhitespace, options.clipboardText, options.overtypingCapturer, this._languageConfigurationService);
        this._editor.executeEdits("snippet", edits, (_undoEdits)=>{
            // Sometimes, the text buffer will remove automatic whitespace when doing any edits,
            // so we need to look only at the undo edits relevant for us.
            // Our edits have an identifier set so that's how we can distinguish them
            const undoEdits = _undoEdits.filter((edit)=>!!edit.identifier);
            for(let idx = 0; idx < snippets.length; idx++)snippets[idx].initialize(undoEdits[idx].textChange);
            // Trivial snippets have no placeholder or are just the final placeholder. That means they
            // are just text insertions and we don't need to merge the nested snippet into the existing
            // snippet
            const isTrivialSnippet = snippets[0].isTrivialSnippet;
            if (!isTrivialSnippet) {
                for (const snippet of this._snippets)snippet.merge(snippets);
                console.assert(snippets.length === 0);
            }
            if (this._snippets[0].hasPlaceholder && !isTrivialSnippet) return this._move(undefined);
            else return undoEdits.map((edit)=>(0, _selectionJs.Selection).fromPositions(edit.range.getEndPosition()));
        });
    }
    next() {
        const newSelections = this._move(true);
        this._editor.setSelections(newSelections);
        this._editor.revealPositionInCenterIfOutsideViewport(newSelections[0].getPosition());
    }
    prev() {
        const newSelections = this._move(false);
        this._editor.setSelections(newSelections);
        this._editor.revealPositionInCenterIfOutsideViewport(newSelections[0].getPosition());
    }
    _move(fwd) {
        const selections = [];
        for (const snippet of this._snippets){
            const oneSelection = snippet.move(fwd);
            selections.push(...oneSelection);
        }
        return selections;
    }
    get isAtFirstPlaceholder() {
        return this._snippets[0].isAtFirstPlaceholder;
    }
    get isAtLastPlaceholder() {
        return this._snippets[0].isAtLastPlaceholder;
    }
    get hasPlaceholder() {
        return this._snippets[0].hasPlaceholder;
    }
    get hasChoice() {
        return this._snippets[0].hasChoice;
    }
    get activeChoice() {
        return this._snippets[0].activeChoice;
    }
    isSelectionWithinPlaceholders() {
        if (!this.hasPlaceholder) return false;
        const selections = this._editor.getSelections();
        if (selections.length < this._snippets.length) // this means we started snippet mode with N
        // selections and have M (N > M) selections.
        // So one snippet is without selection -> cancel
        return false;
        const allPossibleSelections = new Map();
        for (const snippet of this._snippets){
            const possibleSelections = snippet.computePossibleSelections();
            // for the first snippet find the placeholder (and its ranges)
            // that contain at least one selection. for all remaining snippets
            // the same placeholder (and their ranges) must be used.
            if (allPossibleSelections.size === 0) for (const [index, ranges] of possibleSelections){
                ranges.sort((0, _rangeJs.Range).compareRangesUsingStarts);
                for (const selection of selections)if (ranges[0].containsRange(selection)) {
                    allPossibleSelections.set(index, []);
                    break;
                }
            }
            if (allPossibleSelections.size === 0) // return false if we couldn't associate a selection to
            // this (the first) snippet
            return false;
            // add selections from 'this' snippet so that we know all
            // selections for this placeholder
            allPossibleSelections.forEach((array, index)=>{
                array.push(...possibleSelections.get(index));
            });
        }
        // sort selections (and later placeholder-ranges). then walk both
        // arrays and make sure the placeholder-ranges contain the corresponding
        // selection
        selections.sort((0, _rangeJs.Range).compareRangesUsingStarts);
        for (const [index, ranges] of allPossibleSelections){
            if (ranges.length !== selections.length) {
                allPossibleSelections.delete(index);
                continue;
            }
            ranges.sort((0, _rangeJs.Range).compareRangesUsingStarts);
            for(let i = 0; i < ranges.length; i++)if (!ranges[i].containsRange(selections[i])) {
                allPossibleSelections.delete(index);
                continue;
            }
        }
        // from all possible selections we have deleted those
        // that don't match with the current selection. if we don't
        // have any left, we don't have a selection anymore
        return allPossibleSelections.size > 0;
    }
};
SnippetSession = SnippetSession_1 = __decorate([
    __param(3, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService))
], SnippetSession);

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/strings.js":"aA9I1","./snippetSession.css":"joFLI","../../../common/core/editOperation.js":"6r2FZ","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../common/model/textModel.js":"9beDe","../../../../platform/label/common/label.js":"esEqR","../../../../platform/workspace/common/workspace.js":"707vH","./snippetParser.js":"6qHnq","./snippetVariables.js":"jtjwC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"joFLI":[function() {},{}],"jtjwC":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KnownSnippetVariableNames", ()=>KnownSnippetVariableNames);
parcelHelpers.export(exports, "CompositeSnippetVariableResolver", ()=>CompositeSnippetVariableResolver);
parcelHelpers.export(exports, "SelectionBasedVariableResolver", ()=>SelectionBasedVariableResolver);
parcelHelpers.export(exports, "ModelBasedVariableResolver", ()=>ModelBasedVariableResolver);
parcelHelpers.export(exports, "ClipboardBasedVariableResolver", ()=>ClipboardBasedVariableResolver);
parcelHelpers.export(exports, "CommentBasedVariableResolver", ()=>CommentBasedVariableResolver);
parcelHelpers.export(exports, "TimeBasedVariableResolver", ()=>TimeBasedVariableResolver);
parcelHelpers.export(exports, "WorkspaceBasedVariableResolver", ()=>WorkspaceBasedVariableResolver);
parcelHelpers.export(exports, "RandomBasedVariableResolver", ()=>RandomBasedVariableResolver);
var _labelsJs = require("../../../../base/common/labels.js");
var _pathJs = require("../../../../base/common/path.js");
var _resourcesJs = require("../../../../base/common/resources.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _uuidJs = require("../../../../base/common/uuid.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _snippetParserJs = require("./snippetParser.js");
var _nlsJs = require("../../../../nls.js");
var _workspaceJs = require("../../../../platform/workspace/common/workspace.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const KnownSnippetVariableNames = Object.freeze({
    "CURRENT_YEAR": true,
    "CURRENT_YEAR_SHORT": true,
    "CURRENT_MONTH": true,
    "CURRENT_DATE": true,
    "CURRENT_HOUR": true,
    "CURRENT_MINUTE": true,
    "CURRENT_SECOND": true,
    "CURRENT_DAY_NAME": true,
    "CURRENT_DAY_NAME_SHORT": true,
    "CURRENT_MONTH_NAME": true,
    "CURRENT_MONTH_NAME_SHORT": true,
    "CURRENT_SECONDS_UNIX": true,
    "CURRENT_TIMEZONE_OFFSET": true,
    "SELECTION": true,
    "CLIPBOARD": true,
    "TM_SELECTED_TEXT": true,
    "TM_CURRENT_LINE": true,
    "TM_CURRENT_WORD": true,
    "TM_LINE_INDEX": true,
    "TM_LINE_NUMBER": true,
    "TM_FILENAME": true,
    "TM_FILENAME_BASE": true,
    "TM_DIRECTORY": true,
    "TM_FILEPATH": true,
    "CURSOR_INDEX": true,
    "CURSOR_NUMBER": true,
    "RELATIVE_FILEPATH": true,
    "BLOCK_COMMENT_START": true,
    "BLOCK_COMMENT_END": true,
    "LINE_COMMENT": true,
    "WORKSPACE_NAME": true,
    "WORKSPACE_FOLDER": true,
    "RANDOM": true,
    "RANDOM_HEX": true,
    "UUID": true
});
class CompositeSnippetVariableResolver {
    constructor(_delegates){
        this._delegates = _delegates;
    //
    }
    resolve(variable) {
        for (const delegate of this._delegates){
            const value = delegate.resolve(variable);
            if (value !== undefined) return value;
        }
        return undefined;
    }
}
class SelectionBasedVariableResolver {
    constructor(_model, _selection, _selectionIdx, _overtypingCapturer){
        this._model = _model;
        this._selection = _selection;
        this._selectionIdx = _selectionIdx;
        this._overtypingCapturer = _overtypingCapturer;
    //
    }
    resolve(variable) {
        const { name } = variable;
        if (name === "SELECTION" || name === "TM_SELECTED_TEXT") {
            let value = this._model.getValueInRange(this._selection) || undefined;
            let isMultiline = this._selection.startLineNumber !== this._selection.endLineNumber;
            // If there was no selected text, try to get last overtyped text
            if (!value && this._overtypingCapturer) {
                const info = this._overtypingCapturer.getLastOvertypedInfo(this._selectionIdx);
                if (info) {
                    value = info.value;
                    isMultiline = info.multiline;
                }
            }
            if (value && isMultiline && variable.snippet) {
                // Selection is a multiline string which we indentation we now
                // need to adjust. We compare the indentation of this variable
                // with the indentation at the editor position and add potential
                // extra indentation to the value
                const line = this._model.getLineContent(this._selection.startLineNumber);
                const lineLeadingWhitespace = (0, _stringsJs.getLeadingWhitespace)(line, 0, this._selection.startColumn - 1);
                let varLeadingWhitespace = lineLeadingWhitespace;
                variable.snippet.walk((marker)=>{
                    if (marker === variable) return false;
                    if (marker instanceof (0, _snippetParserJs.Text)) varLeadingWhitespace = (0, _stringsJs.getLeadingWhitespace)((0, _stringsJs.splitLines)(marker.value).pop());
                    return true;
                });
                const whitespaceCommonLength = (0, _stringsJs.commonPrefixLength)(varLeadingWhitespace, lineLeadingWhitespace);
                value = value.replace(/(\r\n|\r|\n)(.*)/g, (m, newline, rest)=>`${newline}${varLeadingWhitespace.substr(whitespaceCommonLength)}${rest}`);
            }
            return value;
        } else if (name === "TM_CURRENT_LINE") return this._model.getLineContent(this._selection.positionLineNumber);
        else if (name === "TM_CURRENT_WORD") {
            const info = this._model.getWordAtPosition({
                lineNumber: this._selection.positionLineNumber,
                column: this._selection.positionColumn
            });
            return info && info.word || undefined;
        } else if (name === "TM_LINE_INDEX") return String(this._selection.positionLineNumber - 1);
        else if (name === "TM_LINE_NUMBER") return String(this._selection.positionLineNumber);
        else if (name === "CURSOR_INDEX") return String(this._selectionIdx);
        else if (name === "CURSOR_NUMBER") return String(this._selectionIdx + 1);
        return undefined;
    }
}
class ModelBasedVariableResolver {
    constructor(_labelService, _model){
        this._labelService = _labelService;
        this._model = _model;
    //
    }
    resolve(variable) {
        const { name } = variable;
        if (name === "TM_FILENAME") return _pathJs.basename(this._model.uri.fsPath);
        else if (name === "TM_FILENAME_BASE") {
            const name = _pathJs.basename(this._model.uri.fsPath);
            const idx = name.lastIndexOf(".");
            if (idx <= 0) return name;
            else return name.slice(0, idx);
        } else if (name === "TM_DIRECTORY") {
            if (_pathJs.dirname(this._model.uri.fsPath) === ".") return "";
            return this._labelService.getUriLabel((0, _resourcesJs.dirname)(this._model.uri));
        } else if (name === "TM_FILEPATH") return this._labelService.getUriLabel(this._model.uri);
        else if (name === "RELATIVE_FILEPATH") return this._labelService.getUriLabel(this._model.uri, {
            relative: true,
            noPrefix: true
        });
        return undefined;
    }
}
class ClipboardBasedVariableResolver {
    constructor(_readClipboardText, _selectionIdx, _selectionCount, _spread){
        this._readClipboardText = _readClipboardText;
        this._selectionIdx = _selectionIdx;
        this._selectionCount = _selectionCount;
        this._spread = _spread;
    //
    }
    resolve(variable) {
        if (variable.name !== "CLIPBOARD") return undefined;
        const clipboardText = this._readClipboardText();
        if (!clipboardText) return undefined;
        // `spread` is assigning each cursor a line of the clipboard
        // text whenever there the line count equals the cursor count
        // and when enabled
        if (this._spread) {
            const lines = clipboardText.split(/\r\n|\n|\r/).filter((s)=>!(0, _stringsJs.isFalsyOrWhitespace)(s));
            if (lines.length === this._selectionCount) return lines[this._selectionIdx];
        }
        return clipboardText;
    }
}
let CommentBasedVariableResolver = class CommentBasedVariableResolver {
    constructor(_model, _selection, _languageConfigurationService){
        this._model = _model;
        this._selection = _selection;
        this._languageConfigurationService = _languageConfigurationService;
    //
    }
    resolve(variable) {
        const { name } = variable;
        const langId = this._model.getLanguageIdAtPosition(this._selection.selectionStartLineNumber, this._selection.selectionStartColumn);
        const config = this._languageConfigurationService.getLanguageConfiguration(langId).comments;
        if (!config) return undefined;
        if (name === "LINE_COMMENT") return config.lineCommentToken || undefined;
        else if (name === "BLOCK_COMMENT_START") return config.blockCommentStartToken || undefined;
        else if (name === "BLOCK_COMMENT_END") return config.blockCommentEndToken || undefined;
        return undefined;
    }
};
CommentBasedVariableResolver = __decorate([
    __param(2, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService))
], CommentBasedVariableResolver);
class TimeBasedVariableResolver {
    constructor(){
        this._date = new Date();
    }
    static{
        this.dayNames = [
            _nlsJs.localize("Sunday", "Sunday"),
            _nlsJs.localize("Monday", "Monday"),
            _nlsJs.localize("Tuesday", "Tuesday"),
            _nlsJs.localize("Wednesday", "Wednesday"),
            _nlsJs.localize("Thursday", "Thursday"),
            _nlsJs.localize("Friday", "Friday"),
            _nlsJs.localize("Saturday", "Saturday")
        ];
    }
    static{
        this.dayNamesShort = [
            _nlsJs.localize("SundayShort", "Sun"),
            _nlsJs.localize("MondayShort", "Mon"),
            _nlsJs.localize("TuesdayShort", "Tue"),
            _nlsJs.localize("WednesdayShort", "Wed"),
            _nlsJs.localize("ThursdayShort", "Thu"),
            _nlsJs.localize("FridayShort", "Fri"),
            _nlsJs.localize("SaturdayShort", "Sat")
        ];
    }
    static{
        this.monthNames = [
            _nlsJs.localize("January", "January"),
            _nlsJs.localize("February", "February"),
            _nlsJs.localize("March", "March"),
            _nlsJs.localize("April", "April"),
            _nlsJs.localize("May", "May"),
            _nlsJs.localize("June", "June"),
            _nlsJs.localize("July", "July"),
            _nlsJs.localize("August", "August"),
            _nlsJs.localize("September", "September"),
            _nlsJs.localize("October", "October"),
            _nlsJs.localize("November", "November"),
            _nlsJs.localize("December", "December")
        ];
    }
    static{
        this.monthNamesShort = [
            _nlsJs.localize("JanuaryShort", "Jan"),
            _nlsJs.localize("FebruaryShort", "Feb"),
            _nlsJs.localize("MarchShort", "Mar"),
            _nlsJs.localize("AprilShort", "Apr"),
            _nlsJs.localize("MayShort", "May"),
            _nlsJs.localize("JuneShort", "Jun"),
            _nlsJs.localize("JulyShort", "Jul"),
            _nlsJs.localize("AugustShort", "Aug"),
            _nlsJs.localize("SeptemberShort", "Sep"),
            _nlsJs.localize("OctoberShort", "Oct"),
            _nlsJs.localize("NovemberShort", "Nov"),
            _nlsJs.localize("DecemberShort", "Dec")
        ];
    }
    resolve(variable) {
        const { name } = variable;
        if (name === "CURRENT_YEAR") return String(this._date.getFullYear());
        else if (name === "CURRENT_YEAR_SHORT") return String(this._date.getFullYear()).slice(-2);
        else if (name === "CURRENT_MONTH") return String(this._date.getMonth().valueOf() + 1).padStart(2, "0");
        else if (name === "CURRENT_DATE") return String(this._date.getDate().valueOf()).padStart(2, "0");
        else if (name === "CURRENT_HOUR") return String(this._date.getHours().valueOf()).padStart(2, "0");
        else if (name === "CURRENT_MINUTE") return String(this._date.getMinutes().valueOf()).padStart(2, "0");
        else if (name === "CURRENT_SECOND") return String(this._date.getSeconds().valueOf()).padStart(2, "0");
        else if (name === "CURRENT_DAY_NAME") return TimeBasedVariableResolver.dayNames[this._date.getDay()];
        else if (name === "CURRENT_DAY_NAME_SHORT") return TimeBasedVariableResolver.dayNamesShort[this._date.getDay()];
        else if (name === "CURRENT_MONTH_NAME") return TimeBasedVariableResolver.monthNames[this._date.getMonth()];
        else if (name === "CURRENT_MONTH_NAME_SHORT") return TimeBasedVariableResolver.monthNamesShort[this._date.getMonth()];
        else if (name === "CURRENT_SECONDS_UNIX") return String(Math.floor(this._date.getTime() / 1000));
        else if (name === "CURRENT_TIMEZONE_OFFSET") {
            const rawTimeOffset = this._date.getTimezoneOffset();
            const sign = rawTimeOffset > 0 ? "-" : "+";
            const hours = Math.trunc(Math.abs(rawTimeOffset / 60));
            const hoursString = hours < 10 ? "0" + hours : hours;
            const minutes = Math.abs(rawTimeOffset) - hours * 60;
            const minutesString = minutes < 10 ? "0" + minutes : minutes;
            return sign + hoursString + ":" + minutesString;
        }
        return undefined;
    }
}
class WorkspaceBasedVariableResolver {
    constructor(_workspaceService){
        this._workspaceService = _workspaceService;
    //
    }
    resolve(variable) {
        if (!this._workspaceService) return undefined;
        const workspaceIdentifier = (0, _workspaceJs.toWorkspaceIdentifier)(this._workspaceService.getWorkspace());
        if ((0, _workspaceJs.isEmptyWorkspaceIdentifier)(workspaceIdentifier)) return undefined;
        if (variable.name === "WORKSPACE_NAME") return this._resolveWorkspaceName(workspaceIdentifier);
        else if (variable.name === "WORKSPACE_FOLDER") return this._resoveWorkspacePath(workspaceIdentifier);
        return undefined;
    }
    _resolveWorkspaceName(workspaceIdentifier) {
        if ((0, _workspaceJs.isSingleFolderWorkspaceIdentifier)(workspaceIdentifier)) return _pathJs.basename(workspaceIdentifier.uri.path);
        let filename = _pathJs.basename(workspaceIdentifier.configPath.path);
        if (filename.endsWith((0, _workspaceJs.WORKSPACE_EXTENSION))) filename = filename.substr(0, filename.length - (0, _workspaceJs.WORKSPACE_EXTENSION).length - 1);
        return filename;
    }
    _resoveWorkspacePath(workspaceIdentifier) {
        if ((0, _workspaceJs.isSingleFolderWorkspaceIdentifier)(workspaceIdentifier)) return (0, _labelsJs.normalizeDriveLetter)(workspaceIdentifier.uri.fsPath);
        const filename = _pathJs.basename(workspaceIdentifier.configPath.path);
        let folderpath = workspaceIdentifier.configPath.fsPath;
        if (folderpath.endsWith(filename)) folderpath = folderpath.substr(0, folderpath.length - filename.length - 1);
        return folderpath ? (0, _labelsJs.normalizeDriveLetter)(folderpath) : "/";
    }
}
class RandomBasedVariableResolver {
    resolve(variable) {
        const { name } = variable;
        if (name === "RANDOM") return Math.random().toString().slice(-6);
        else if (name === "RANDOM_HEX") return Math.random().toString(16).slice(-6);
        else if (name === "UUID") return (0, _uuidJs.generateUuid)();
        return undefined;
    }
}

},{"../../../../base/common/labels.js":"fUvXq","../../../../base/common/path.js":"vyRKJ","../../../../base/common/resources.js":"700EV","../../../../base/common/strings.js":"aA9I1","../../../../base/common/uuid.js":"g8HjT","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","./snippetParser.js":"6qHnq","../../../../nls.js":"l617d","../../../../platform/workspace/common/workspace.js":"707vH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fUvXq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeDriveLetter", ()=>normalizeDriveLetter);
var _extpathJs = require("./extpath.js");
var _platformJs = require("./platform.js");
function normalizeDriveLetter(path, isWindowsOS = (0, _platformJs.isWindows)) {
    if ((0, _extpathJs.hasDriveLetter)(path, isWindowsOS)) return path.charAt(0).toUpperCase() + path.slice(1);
    return path;
}
let normalizedUserHomeCached = Object.create(null);

},{"./extpath.js":"7a3D5","./platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jsdpQ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SuggestWidgetAdaptor", ()=>SuggestWidgetAdaptor);
parcelHelpers.export(exports, "SuggestItemInfo", ()=>SuggestItemInfo);
var _arraysJs = require("../../../../../base/common/arrays.js");
var _arraysFindJs = require("../../../../../base/common/arraysFind.js");
var _eventJs = require("../../../../../base/common/event.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _positionJs = require("../../../../common/core/position.js");
var _rangeJs = require("../../../../common/core/range.js");
var _textEditJs = require("../../../../common/core/textEdit.js");
var _languagesJs = require("../../../../common/languages.js");
var _singleTextEditJs = require("./singleTextEdit.js");
var _snippetParserJs = require("../../../snippet/browser/snippetParser.js");
var _snippetSessionJs = require("../../../snippet/browser/snippetSession.js");
var _suggestControllerJs = require("../../../suggest/browser/suggestController.js");
class SuggestWidgetAdaptor extends (0, _lifecycleJs.Disposable) {
    get selectedItem() {
        return this._currentSuggestItemInfo;
    }
    constructor(editor, suggestControllerPreselector, onWillAccept){
        super();
        this.editor = editor;
        this.suggestControllerPreselector = suggestControllerPreselector;
        this.onWillAccept = onWillAccept;
        this.isSuggestWidgetVisible = false;
        this.isShiftKeyPressed = false;
        this._isActive = false;
        this._currentSuggestItemInfo = undefined;
        this._onDidSelectedItemChange = this._register(new (0, _eventJs.Emitter)());
        this.onDidSelectedItemChange = this._onDidSelectedItemChange.event;
        // See the command acceptAlternativeSelectedSuggestion that is bound to shift+tab
        this._register(editor.onKeyDown((e)=>{
            if (e.shiftKey && !this.isShiftKeyPressed) {
                this.isShiftKeyPressed = true;
                this.update(this._isActive);
            }
        }));
        this._register(editor.onKeyUp((e)=>{
            if (e.shiftKey && this.isShiftKeyPressed) {
                this.isShiftKeyPressed = false;
                this.update(this._isActive);
            }
        }));
        const suggestController = (0, _suggestControllerJs.SuggestController).get(this.editor);
        if (suggestController) {
            this._register(suggestController.registerSelector({
                priority: 100,
                select: (model, pos, suggestItems)=>{
                    const textModel = this.editor.getModel();
                    if (!textModel) // Should not happen
                    return -1;
                    const i = this.suggestControllerPreselector();
                    const itemToPreselect = i ? (0, _singleTextEditJs.singleTextRemoveCommonPrefix)(i, textModel) : undefined;
                    if (!itemToPreselect) return -1;
                    const position = (0, _positionJs.Position).lift(pos);
                    const candidates = suggestItems.map((suggestItem, index)=>{
                        const suggestItemInfo = SuggestItemInfo.fromSuggestion(suggestController, textModel, position, suggestItem, this.isShiftKeyPressed);
                        const suggestItemTextEdit = (0, _singleTextEditJs.singleTextRemoveCommonPrefix)(suggestItemInfo.toSingleTextEdit(), textModel);
                        const valid = (0, _singleTextEditJs.singleTextEditAugments)(itemToPreselect, suggestItemTextEdit);
                        return {
                            index,
                            valid,
                            prefixLength: suggestItemTextEdit.text.length,
                            suggestItem
                        };
                    }).filter((item)=>item && item.valid && item.prefixLength > 0);
                    const result = (0, _arraysFindJs.findFirstMax)(candidates, (0, _arraysJs.compareBy)((s)=>s.prefixLength, (0, _arraysJs.numberComparator)));
                    return result ? result.index : -1;
                }
            }));
            let isBoundToSuggestWidget = false;
            const bindToSuggestWidget = ()=>{
                if (isBoundToSuggestWidget) return;
                isBoundToSuggestWidget = true;
                this._register(suggestController.widget.value.onDidShow(()=>{
                    this.isSuggestWidgetVisible = true;
                    this.update(true);
                }));
                this._register(suggestController.widget.value.onDidHide(()=>{
                    this.isSuggestWidgetVisible = false;
                    this.update(false);
                }));
                this._register(suggestController.widget.value.onDidFocus(()=>{
                    this.isSuggestWidgetVisible = true;
                    this.update(true);
                }));
            };
            this._register((0, _eventJs.Event).once(suggestController.model.onDidTrigger)((e)=>{
                bindToSuggestWidget();
            }));
            this._register(suggestController.onWillInsertSuggestItem((e)=>{
                const position = this.editor.getPosition();
                const model = this.editor.getModel();
                if (!position || !model) return undefined;
                const suggestItemInfo = SuggestItemInfo.fromSuggestion(suggestController, model, position, e.item, this.isShiftKeyPressed);
                this.onWillAccept(suggestItemInfo);
            }));
        }
        this.update(this._isActive);
    }
    update(newActive) {
        const newInlineCompletion = this.getSuggestItemInfo();
        if (this._isActive !== newActive || !suggestItemInfoEquals(this._currentSuggestItemInfo, newInlineCompletion)) {
            this._isActive = newActive;
            this._currentSuggestItemInfo = newInlineCompletion;
            this._onDidSelectedItemChange.fire();
        }
    }
    getSuggestItemInfo() {
        const suggestController = (0, _suggestControllerJs.SuggestController).get(this.editor);
        if (!suggestController || !this.isSuggestWidgetVisible) return undefined;
        const focusedItem = suggestController.widget.value.getFocusedItem();
        const position = this.editor.getPosition();
        const model = this.editor.getModel();
        if (!focusedItem || !position || !model) return undefined;
        return SuggestItemInfo.fromSuggestion(suggestController, model, position, focusedItem.item, this.isShiftKeyPressed);
    }
    stopForceRenderingAbove() {
        const suggestController = (0, _suggestControllerJs.SuggestController).get(this.editor);
        suggestController?.stopForceRenderingAbove();
    }
    forceRenderingAbove() {
        const suggestController = (0, _suggestControllerJs.SuggestController).get(this.editor);
        suggestController?.forceRenderingAbove();
    }
}
class SuggestItemInfo {
    static fromSuggestion(suggestController, model, position, item, toggleMode) {
        let { insertText } = item.completion;
        let isSnippetText = false;
        if (item.completion.insertTextRules & 4 /* CompletionItemInsertTextRule.InsertAsSnippet */ ) {
            const snippet = new (0, _snippetParserJs.SnippetParser)().parse(insertText);
            if (snippet.children.length < 100) // Adjust whitespace is expensive.
            (0, _snippetSessionJs.SnippetSession).adjustWhitespace(model, position, true, snippet);
            insertText = snippet.toString();
            isSnippetText = true;
        }
        const info = suggestController.getOverwriteInfo(item, toggleMode);
        return new SuggestItemInfo((0, _rangeJs.Range).fromPositions(position.delta(0, -info.overwriteBefore), position.delta(0, Math.max(info.overwriteAfter, 0))), insertText, item.completion.kind, isSnippetText);
    }
    constructor(range, insertText, completionItemKind, isSnippetText){
        this.range = range;
        this.insertText = insertText;
        this.completionItemKind = completionItemKind;
        this.isSnippetText = isSnippetText;
    }
    equals(other) {
        return this.range.equalsRange(other.range) && this.insertText === other.insertText && this.completionItemKind === other.completionItemKind && this.isSnippetText === other.isSnippetText;
    }
    toSelectedSuggestionInfo() {
        return new (0, _languagesJs.SelectedSuggestionInfo)(this.range, this.insertText, this.completionItemKind, this.isSnippetText);
    }
    toSingleTextEdit() {
        return new (0, _textEditJs.SingleTextEdit)(this.range, this.insertText);
    }
}
function suggestItemInfoEquals(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    return a.equals(b);
}

},{"../../../../../base/common/arrays.js":"DECei","../../../../../base/common/arraysFind.js":"gWrU0","../../../../../base/common/event.js":"4Zi8b","../../../../../base/common/lifecycle.js":"9kg8d","../../../../common/core/position.js":"lvrPe","../../../../common/core/range.js":"jmUPh","../../../../common/core/textEdit.js":"hdqra","../../../../common/languages.js":"g5n96","./singleTextEdit.js":"1zqK9","../../../snippet/browser/snippetParser.js":"6qHnq","../../../snippet/browser/snippetSession.js":"dEh8D","../../../suggest/browser/suggestController.js":"jcXag","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jcXag":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SuggestController", ()=>SuggestController);
parcelHelpers.export(exports, "TriggerSuggestAction", ()=>TriggerSuggestAction);
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _eventJs = require("../../../../base/common/event.js");
var _keybindingsJs = require("../../../../base/common/keybindings.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _platformJs = require("../../../../base/common/platform.js");
var _stopwatchJs = require("../../../../base/common/stopwatch.js");
var _typesJs = require("../../../../base/common/types.js");
var _stableEditorScrollJs = require("../../../browser/stableEditorScroll.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editOperationJs = require("../../../common/core/editOperation.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _snippetController2Js = require("../../snippet/browser/snippetController2.js");
var _snippetParserJs = require("../../snippet/browser/snippetParser.js");
var _suggestMemoryJs = require("./suggestMemory.js");
var _wordContextKeyJs = require("./wordContextKey.js");
var _nlsJs = require("../../../../nls.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _logJs = require("../../../../platform/log/common/log.js");
var _suggestJs = require("./suggest.js");
var _suggestAlternativesJs = require("./suggestAlternatives.js");
var _suggestCommitCharactersJs = require("./suggestCommitCharacters.js");
var _suggestModelJs = require("./suggestModel.js");
var _suggestOvertypingCapturerJs = require("./suggestOvertypingCapturer.js");
var _suggestWidgetJs = require("./suggestWidget.js");
var _telemetryJs = require("../../../../platform/telemetry/common/telemetry.js");
var _resourcesJs = require("../../../../base/common/resources.js");
var _hashJs = require("../../../../base/common/hash.js");
var _domJs = require("../../../../base/browser/dom.js");
var _textModelJs = require("../../../common/model/textModel.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var SuggestController_1;
// sticky suggest widget which doesn't disappear on focus out and such
const _sticky = false;
class LineSuffix {
    constructor(_model, _position){
        this._model = _model;
        this._position = _position;
        this._decorationOptions = (0, _textModelJs.ModelDecorationOptions).register({
            description: "suggest-line-suffix",
            stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ 
        });
        // spy on what's happening right of the cursor. two cases:
        // 1. end of line -> check that it's still end of line
        // 2. mid of line -> add a marker and compute the delta
        const maxColumn = _model.getLineMaxColumn(_position.lineNumber);
        if (maxColumn !== _position.column) {
            const offset = _model.getOffsetAt(_position);
            const end = _model.getPositionAt(offset + 1);
            _model.changeDecorations((accessor)=>{
                if (this._marker) accessor.removeDecoration(this._marker);
                this._marker = accessor.addDecoration((0, _rangeJs.Range).fromPositions(_position, end), this._decorationOptions);
            });
        }
    }
    dispose() {
        if (this._marker && !this._model.isDisposed()) this._model.changeDecorations((accessor)=>{
            accessor.removeDecoration(this._marker);
            this._marker = undefined;
        });
    }
    delta(position) {
        if (this._model.isDisposed() || this._position.lineNumber !== position.lineNumber) // bail out early if things seems fishy
        return 0;
        // read the marker (in case suggest was triggered at line end) or compare
        // the cursor to the line end.
        if (this._marker) {
            const range = this._model.getDecorationRange(this._marker);
            const end = this._model.getOffsetAt(range.getStartPosition());
            return end - this._model.getOffsetAt(position);
        } else return this._model.getLineMaxColumn(position.lineNumber) - position.column;
    }
}
let SuggestController = class SuggestController {
    static{
        SuggestController_1 = this;
    }
    static{
        this.ID = "editor.contrib.suggestController";
    }
    static get(editor) {
        return editor.getContribution(SuggestController_1.ID);
    }
    constructor(editor, _memoryService, _commandService, _contextKeyService, _instantiationService, _logService, _telemetryService){
        this._memoryService = _memoryService;
        this._commandService = _commandService;
        this._contextKeyService = _contextKeyService;
        this._instantiationService = _instantiationService;
        this._logService = _logService;
        this._telemetryService = _telemetryService;
        this._lineSuffix = new (0, _lifecycleJs.MutableDisposable)();
        this._toDispose = new (0, _lifecycleJs.DisposableStore)();
        this._selectors = new PriorityRegistry((s)=>s.priority);
        this._onWillInsertSuggestItem = new (0, _eventJs.Emitter)();
        this.onWillInsertSuggestItem = this._onWillInsertSuggestItem.event;
        this.editor = editor;
        this.model = _instantiationService.createInstance((0, _suggestModelJs.SuggestModel), this.editor);
        // default selector
        this._selectors.register({
            priority: 0,
            select: (model, pos, items)=>this._memoryService.select(model, pos, items)
        });
        // context key: update insert/replace mode
        const ctxInsertMode = (0, _suggestJs.Context).InsertMode.bindTo(_contextKeyService);
        ctxInsertMode.set(editor.getOption(119 /* EditorOption.suggest */ ).insertMode);
        this._toDispose.add(this.model.onDidTrigger(()=>ctxInsertMode.set(editor.getOption(119 /* EditorOption.suggest */ ).insertMode)));
        this.widget = this._toDispose.add(new (0, _domJs.WindowIdleValue)((0, _domJs.getWindow)(editor.getDomNode()), ()=>{
            const widget = this._instantiationService.createInstance((0, _suggestWidgetJs.SuggestWidget), this.editor);
            this._toDispose.add(widget);
            this._toDispose.add(widget.onDidSelect((item)=>this._insertSuggestion(item, 0 /* InsertFlags.None */ ), this));
            // Wire up logic to accept a suggestion on certain characters
            const commitCharacterController = new (0, _suggestCommitCharactersJs.CommitCharacterController)(this.editor, widget, this.model, (item)=>this._insertSuggestion(item, 2 /* InsertFlags.NoAfterUndoStop */ ));
            this._toDispose.add(commitCharacterController);
            // Wire up makes text edit context key
            const ctxMakesTextEdit = (0, _suggestJs.Context).MakesTextEdit.bindTo(this._contextKeyService);
            const ctxHasInsertAndReplace = (0, _suggestJs.Context).HasInsertAndReplaceRange.bindTo(this._contextKeyService);
            const ctxCanResolve = (0, _suggestJs.Context).CanResolve.bindTo(this._contextKeyService);
            this._toDispose.add((0, _lifecycleJs.toDisposable)(()=>{
                ctxMakesTextEdit.reset();
                ctxHasInsertAndReplace.reset();
                ctxCanResolve.reset();
            }));
            this._toDispose.add(widget.onDidFocus(({ item })=>{
                // (ctx: makesTextEdit)
                const position = this.editor.getPosition();
                const startColumn = item.editStart.column;
                const endColumn = position.column;
                let value = true;
                if (this.editor.getOption(1 /* EditorOption.acceptSuggestionOnEnter */ ) === "smart" && this.model.state === 2 /* State.Auto */  && !item.completion.additionalTextEdits && !(item.completion.insertTextRules & 4 /* CompletionItemInsertTextRule.InsertAsSnippet */ ) && endColumn - startColumn === item.completion.insertText.length) {
                    const oldText = this.editor.getModel().getValueInRange({
                        startLineNumber: position.lineNumber,
                        startColumn,
                        endLineNumber: position.lineNumber,
                        endColumn
                    });
                    value = oldText !== item.completion.insertText;
                }
                ctxMakesTextEdit.set(value);
                // (ctx: hasInsertAndReplaceRange)
                ctxHasInsertAndReplace.set(!(0, _positionJs.Position).equals(item.editInsertEnd, item.editReplaceEnd));
                // (ctx: canResolve)
                ctxCanResolve.set(Boolean(item.provider.resolveCompletionItem) || Boolean(item.completion.documentation) || item.completion.detail !== item.completion.label);
            }));
            this._toDispose.add(widget.onDetailsKeyDown((e)=>{
                // cmd + c on macOS, ctrl + c on Win / Linux
                if (e.toKeyCodeChord().equals(new (0, _keybindingsJs.KeyCodeChord)(true, false, false, false, 33 /* KeyCode.KeyC */ )) || _platformJs.isMacintosh && e.toKeyCodeChord().equals(new (0, _keybindingsJs.KeyCodeChord)(false, false, false, true, 33 /* KeyCode.KeyC */ ))) {
                    e.stopPropagation();
                    return;
                }
                if (!e.toKeyCodeChord().isModifierKey()) this.editor.focus();
            }));
            return widget;
        }));
        // Wire up text overtyping capture
        this._overtypingCapturer = this._toDispose.add(new (0, _domJs.WindowIdleValue)((0, _domJs.getWindow)(editor.getDomNode()), ()=>{
            return this._toDispose.add(new (0, _suggestOvertypingCapturerJs.OvertypingCapturer)(this.editor, this.model));
        }));
        this._alternatives = this._toDispose.add(new (0, _domJs.WindowIdleValue)((0, _domJs.getWindow)(editor.getDomNode()), ()=>{
            return this._toDispose.add(new (0, _suggestAlternativesJs.SuggestAlternatives)(this.editor, this._contextKeyService));
        }));
        this._toDispose.add(_instantiationService.createInstance((0, _wordContextKeyJs.WordContextKey), editor));
        this._toDispose.add(this.model.onDidTrigger((e)=>{
            this.widget.value.showTriggered(e.auto, e.shy ? 250 : 50);
            this._lineSuffix.value = new LineSuffix(this.editor.getModel(), e.position);
        }));
        this._toDispose.add(this.model.onDidSuggest((e)=>{
            if (e.triggerOptions.shy) return;
            let index = -1;
            for (const selector of this._selectors.itemsOrderedByPriorityDesc){
                index = selector.select(this.editor.getModel(), this.editor.getPosition(), e.completionModel.items);
                if (index !== -1) break;
            }
            if (index === -1) index = 0;
            if (this.model.state === 0 /* State.Idle */ ) // selecting an item can "pump" out selection/cursor change events
            // which can cancel suggest halfway through this function. therefore
            // we need to check again and bail if the session has been canceled
            return;
            let noFocus = false;
            if (e.triggerOptions.auto) {
                // don't "focus" item when configured to do
                const options = this.editor.getOption(119 /* EditorOption.suggest */ );
                if (options.selectionMode === "never" || options.selectionMode === "always") // simple: always or never
                noFocus = options.selectionMode === "never";
                else if (options.selectionMode === "whenTriggerCharacter") // on with trigger character
                noFocus = e.triggerOptions.triggerKind !== 1 /* CompletionTriggerKind.TriggerCharacter */ ;
                else if (options.selectionMode === "whenQuickSuggestion") // without trigger character or when refiltering
                noFocus = e.triggerOptions.triggerKind === 1 /* CompletionTriggerKind.TriggerCharacter */  && !e.triggerOptions.refilter;
            }
            this.widget.value.showSuggestions(e.completionModel, index, e.isFrozen, e.triggerOptions.auto, noFocus);
        }));
        this._toDispose.add(this.model.onDidCancel((e)=>{
            if (!e.retrigger) this.widget.value.hideWidget();
        }));
        this._toDispose.add(this.editor.onDidBlurEditorWidget(()=>{
            if (!_sticky) {
                this.model.cancel();
                this.model.clear();
            }
        }));
        // Manage the acceptSuggestionsOnEnter context key
        const acceptSuggestionsOnEnter = (0, _suggestJs.Context).AcceptSuggestionsOnEnter.bindTo(_contextKeyService);
        const updateFromConfig = ()=>{
            const acceptSuggestionOnEnter = this.editor.getOption(1 /* EditorOption.acceptSuggestionOnEnter */ );
            acceptSuggestionsOnEnter.set(acceptSuggestionOnEnter === "on" || acceptSuggestionOnEnter === "smart");
        };
        this._toDispose.add(this.editor.onDidChangeConfiguration(()=>updateFromConfig()));
        updateFromConfig();
    }
    dispose() {
        this._alternatives.dispose();
        this._toDispose.dispose();
        this.widget.dispose();
        this.model.dispose();
        this._lineSuffix.dispose();
        this._onWillInsertSuggestItem.dispose();
    }
    _insertSuggestion(event, flags) {
        if (!event || !event.item) {
            this._alternatives.value.reset();
            this.model.cancel();
            this.model.clear();
            return;
        }
        if (!this.editor.hasModel()) return;
        const snippetController = (0, _snippetController2Js.SnippetController2).get(this.editor);
        if (!snippetController) return;
        this._onWillInsertSuggestItem.fire({
            item: event.item
        });
        const model = this.editor.getModel();
        const modelVersionNow = model.getAlternativeVersionId();
        const { item } = event;
        //
        const tasks = [];
        const cts = new (0, _cancellationJs.CancellationTokenSource)();
        // pushing undo stops *before* additional text edits and
        // *after* the main edit
        if (!(flags & 1 /* InsertFlags.NoBeforeUndoStop */ )) this.editor.pushUndoStop();
        // compute overwrite[Before|After] deltas BEFORE applying extra edits
        const info = this.getOverwriteInfo(item, Boolean(flags & 8 /* InsertFlags.AlternativeOverwriteConfig */ ));
        // keep item in memory
        this._memoryService.memorize(model, this.editor.getPosition(), item);
        const isResolved = item.isResolved;
        // telemetry data points: duration of command execution, info about async additional edits (-1=n/a, -2=none, 1=success, 0=failed)
        let _commandExectionDuration = -1;
        let _additionalEditsAppliedAsync = -1;
        if (Array.isArray(item.completion.additionalTextEdits)) {
            // cancel -> stops all listening and closes widget
            this.model.cancel();
            // sync additional edits
            const scrollState = (0, _stableEditorScrollJs.StableEditorScrollState).capture(this.editor);
            this.editor.executeEdits("suggestController.additionalTextEdits.sync", item.completion.additionalTextEdits.map((edit)=>{
                let range = (0, _rangeJs.Range).lift(edit.range);
                if (range.startLineNumber === item.position.lineNumber && range.startColumn > item.position.column) {
                    // shift additional edit when it is "after" the completion insertion position
                    const columnDelta = this.editor.getPosition().column - item.position.column;
                    const startColumnDelta = columnDelta;
                    const endColumnDelta = (0, _rangeJs.Range).spansMultipleLines(range) ? 0 : columnDelta;
                    range = new (0, _rangeJs.Range)(range.startLineNumber, range.startColumn + startColumnDelta, range.endLineNumber, range.endColumn + endColumnDelta);
                }
                return (0, _editOperationJs.EditOperation).replaceMove(range, edit.text);
            }));
            scrollState.restoreRelativeVerticalPositionOfCursor(this.editor);
        } else if (!isResolved) {
            // async additional edits
            const sw = new (0, _stopwatchJs.StopWatch)();
            let position;
            const docListener = model.onDidChangeContent((e)=>{
                if (e.isFlush) {
                    cts.cancel();
                    docListener.dispose();
                    return;
                }
                for (const change of e.changes){
                    const thisPosition = (0, _rangeJs.Range).getEndPosition(change.range);
                    if (!position || (0, _positionJs.Position).isBefore(thisPosition, position)) position = thisPosition;
                }
            });
            const oldFlags = flags;
            flags |= 2 /* InsertFlags.NoAfterUndoStop */ ;
            let didType = false;
            const typeListener = this.editor.onWillType(()=>{
                typeListener.dispose();
                didType = true;
                if (!(oldFlags & 2 /* InsertFlags.NoAfterUndoStop */ )) this.editor.pushUndoStop();
            });
            tasks.push(item.resolve(cts.token).then(()=>{
                if (!item.completion.additionalTextEdits || cts.token.isCancellationRequested) return undefined;
                if (position && item.completion.additionalTextEdits.some((edit)=>(0, _positionJs.Position).isBefore(position, (0, _rangeJs.Range).getStartPosition(edit.range)))) return false;
                if (didType) this.editor.pushUndoStop();
                const scrollState = (0, _stableEditorScrollJs.StableEditorScrollState).capture(this.editor);
                this.editor.executeEdits("suggestController.additionalTextEdits.async", item.completion.additionalTextEdits.map((edit)=>(0, _editOperationJs.EditOperation).replaceMove((0, _rangeJs.Range).lift(edit.range), edit.text)));
                scrollState.restoreRelativeVerticalPositionOfCursor(this.editor);
                if (didType || !(oldFlags & 2 /* InsertFlags.NoAfterUndoStop */ )) this.editor.pushUndoStop();
                return true;
            }).then((applied)=>{
                this._logService.trace("[suggest] async resolving of edits DONE (ms, applied?)", sw.elapsed(), applied);
                _additionalEditsAppliedAsync = applied === true ? 1 : applied === false ? 0 : -2;
            }).finally(()=>{
                docListener.dispose();
                typeListener.dispose();
            }));
        }
        let { insertText } = item.completion;
        if (!(item.completion.insertTextRules & 4 /* CompletionItemInsertTextRule.InsertAsSnippet */ )) insertText = (0, _snippetParserJs.SnippetParser).escape(insertText);
        // cancel -> stops all listening and closes widget
        this.model.cancel();
        snippetController.insert(insertText, {
            overwriteBefore: info.overwriteBefore,
            overwriteAfter: info.overwriteAfter,
            undoStopBefore: false,
            undoStopAfter: false,
            adjustWhitespace: !(item.completion.insertTextRules & 1 /* CompletionItemInsertTextRule.KeepWhitespace */ ),
            clipboardText: event.model.clipboardText,
            overtypingCapturer: this._overtypingCapturer.value
        });
        if (!(flags & 2 /* InsertFlags.NoAfterUndoStop */ )) this.editor.pushUndoStop();
        if (item.completion.command) {
            if (item.completion.command.id === TriggerSuggestAction.id) // retigger
            this.model.trigger({
                auto: true,
                retrigger: true
            });
            else {
                // exec command, done
                const sw = new (0, _stopwatchJs.StopWatch)();
                tasks.push(this._commandService.executeCommand(item.completion.command.id, ...item.completion.command.arguments ? [
                    ...item.completion.command.arguments
                ] : []).catch((e)=>{
                    if (item.completion.extensionId) (0, _errorsJs.onUnexpectedExternalError)(e);
                    else (0, _errorsJs.onUnexpectedError)(e);
                }).finally(()=>{
                    _commandExectionDuration = sw.elapsed();
                }));
            }
        }
        if (flags & 4 /* InsertFlags.KeepAlternativeSuggestions */ ) this._alternatives.value.set(event, (next)=>{
            // cancel resolving of additional edits
            cts.cancel();
            // this is not so pretty. when inserting the 'next'
            // suggestion we undo until we are at the state at
            // which we were before inserting the previous suggestion...
            while(model.canUndo()){
                if (modelVersionNow !== model.getAlternativeVersionId()) model.undo();
                this._insertSuggestion(next, 3 /* InsertFlags.NoAfterUndoStop */  | (flags & 8 /* InsertFlags.AlternativeOverwriteConfig */  ? 8 /* InsertFlags.AlternativeOverwriteConfig */  : 0));
                break;
            }
        });
        this._alertCompletionItem(item);
        // clear only now - after all tasks are done
        Promise.all(tasks).finally(()=>{
            this._reportSuggestionAcceptedTelemetry(item, model, isResolved, _commandExectionDuration, _additionalEditsAppliedAsync, event.index, event.model.items);
            this.model.clear();
            cts.dispose();
        });
    }
    _reportSuggestionAcceptedTelemetry(item, model, itemResolved, commandExectionDuration, additionalEditsAppliedAsync, index, completionItems) {
        if (Math.floor(Math.random() * 100) === 0) // throttle telemetry event because accepting completions happens a lot
        return;
        const labelMap = new Map();
        for(let i = 0; i < Math.min(30, completionItems.length); i++){
            const label = completionItems[i].textLabel;
            if (labelMap.has(label)) labelMap.get(label).push(i);
            else labelMap.set(label, [
                i
            ]);
        }
        const firstIndexArray = labelMap.get(item.textLabel);
        const hasDuplicates = firstIndexArray && firstIndexArray.length > 1;
        const firstIndex = hasDuplicates ? firstIndexArray[0] : -1;
        this._telemetryService.publicLog2("suggest.acceptedSuggestion", {
            extensionId: item.extensionId?.value ?? "unknown",
            providerId: item.provider._debugDisplayName ?? "unknown",
            kind: item.completion.kind,
            basenameHash: (0, _hashJs.hash)((0, _resourcesJs.basename)(model.uri)).toString(16),
            languageId: model.getLanguageId(),
            fileExtension: (0, _resourcesJs.extname)(model.uri),
            resolveInfo: !item.provider.resolveCompletionItem ? -1 : itemResolved ? 1 : 0,
            resolveDuration: item.resolveDuration,
            commandDuration: commandExectionDuration,
            additionalEditsAsync: additionalEditsAppliedAsync,
            index,
            firstIndex
        });
    }
    getOverwriteInfo(item, toggleMode) {
        (0, _typesJs.assertType)(this.editor.hasModel());
        let replace = this.editor.getOption(119 /* EditorOption.suggest */ ).insertMode === "replace";
        if (toggleMode) replace = !replace;
        const overwriteBefore = item.position.column - item.editStart.column;
        const overwriteAfter = (replace ? item.editReplaceEnd.column : item.editInsertEnd.column) - item.position.column;
        const columnDelta = this.editor.getPosition().column - item.position.column;
        const suffixDelta = this._lineSuffix.value ? this._lineSuffix.value.delta(this.editor.getPosition()) : 0;
        return {
            overwriteBefore: overwriteBefore + columnDelta,
            overwriteAfter: overwriteAfter + suffixDelta
        };
    }
    _alertCompletionItem(item) {
        if ((0, _arraysJs.isNonEmptyArray)(item.completion.additionalTextEdits)) {
            const msg = _nlsJs.localize("aria.alert.snippet", "Accepting '{0}' made {1} additional edits", item.textLabel, item.completion.additionalTextEdits.length);
            (0, _ariaJs.alert)(msg);
        }
    }
    triggerSuggest(onlyFrom, auto, noFilter) {
        if (this.editor.hasModel()) {
            this.model.trigger({
                auto: auto ?? false,
                completionOptions: {
                    providerFilter: onlyFrom,
                    kindFilter: noFilter ? new Set() : undefined
                }
            });
            this.editor.revealPosition(this.editor.getPosition(), 0 /* ScrollType.Smooth */ );
            this.editor.focus();
        }
    }
    triggerSuggestAndAcceptBest(arg) {
        if (!this.editor.hasModel()) return;
        const positionNow = this.editor.getPosition();
        const fallback = ()=>{
            if (positionNow.equals(this.editor.getPosition())) this._commandService.executeCommand(arg.fallback);
        };
        const makesTextEdit = (item)=>{
            if (item.completion.insertTextRules & 4 /* CompletionItemInsertTextRule.InsertAsSnippet */  || item.completion.additionalTextEdits) // snippet, other editor -> makes edit
            return true;
            const position = this.editor.getPosition();
            const startColumn = item.editStart.column;
            const endColumn = position.column;
            if (endColumn - startColumn !== item.completion.insertText.length) // unequal lengths -> makes edit
            return true;
            const textNow = this.editor.getModel().getValueInRange({
                startLineNumber: position.lineNumber,
                startColumn,
                endLineNumber: position.lineNumber,
                endColumn
            });
            // unequal text -> makes edit
            return textNow !== item.completion.insertText;
        };
        (0, _eventJs.Event).once(this.model.onDidTrigger)((_)=>{
            // wait for trigger because only then the cancel-event is trustworthy
            const listener = [];
            (0, _eventJs.Event).any(this.model.onDidTrigger, this.model.onDidCancel)(()=>{
                // retrigger or cancel -> try to type default text
                (0, _lifecycleJs.dispose)(listener);
                fallback();
            }, undefined, listener);
            this.model.onDidSuggest(({ completionModel })=>{
                (0, _lifecycleJs.dispose)(listener);
                if (completionModel.items.length === 0) {
                    fallback();
                    return;
                }
                const index = this._memoryService.select(this.editor.getModel(), this.editor.getPosition(), completionModel.items);
                const item = completionModel.items[index];
                if (!makesTextEdit(item)) {
                    fallback();
                    return;
                }
                this.editor.pushUndoStop();
                this._insertSuggestion({
                    index,
                    item,
                    model: completionModel
                }, 7 /* InsertFlags.NoAfterUndoStop */ );
            }, undefined, listener);
        });
        this.model.trigger({
            auto: false,
            shy: true
        });
        this.editor.revealPosition(positionNow, 0 /* ScrollType.Smooth */ );
        this.editor.focus();
    }
    acceptSelectedSuggestion(keepAlternativeSuggestions, alternativeOverwriteConfig) {
        const item = this.widget.value.getFocusedItem();
        let flags = 0;
        if (keepAlternativeSuggestions) flags |= 4 /* InsertFlags.KeepAlternativeSuggestions */ ;
        if (alternativeOverwriteConfig) flags |= 8 /* InsertFlags.AlternativeOverwriteConfig */ ;
        this._insertSuggestion(item, flags);
    }
    acceptNextSuggestion() {
        this._alternatives.value.next();
    }
    acceptPrevSuggestion() {
        this._alternatives.value.prev();
    }
    cancelSuggestWidget() {
        this.model.cancel();
        this.model.clear();
        this.widget.value.hideWidget();
    }
    focusSuggestion() {
        this.widget.value.focusSelected();
    }
    selectNextSuggestion() {
        this.widget.value.selectNext();
    }
    selectNextPageSuggestion() {
        this.widget.value.selectNextPage();
    }
    selectLastSuggestion() {
        this.widget.value.selectLast();
    }
    selectPrevSuggestion() {
        this.widget.value.selectPrevious();
    }
    selectPrevPageSuggestion() {
        this.widget.value.selectPreviousPage();
    }
    selectFirstSuggestion() {
        this.widget.value.selectFirst();
    }
    toggleSuggestionDetails() {
        this.widget.value.toggleDetails();
    }
    toggleExplainMode() {
        this.widget.value.toggleExplainMode();
    }
    toggleSuggestionFocus() {
        this.widget.value.toggleDetailsFocus();
    }
    resetWidgetSize() {
        this.widget.value.resetPersistedSize();
    }
    forceRenderingAbove() {
        this.widget.value.forceRenderingAbove();
    }
    stopForceRenderingAbove() {
        if (!this.widget.isInitialized) // This method has no effect if the widget is not initialized yet.
        return;
        this.widget.value.stopForceRenderingAbove();
    }
    registerSelector(selector) {
        return this._selectors.register(selector);
    }
};
SuggestController = SuggestController_1 = __decorate([
    __param(1, (0, _suggestMemoryJs.ISuggestMemoryService)),
    __param(2, (0, _commandsJs.ICommandService)),
    __param(3, (0, _contextkeyJs.IContextKeyService)),
    __param(4, (0, _instantiationJs.IInstantiationService)),
    __param(5, (0, _logJs.ILogService)),
    __param(6, (0, _telemetryJs.ITelemetryService))
], SuggestController);
class PriorityRegistry {
    constructor(prioritySelector){
        this.prioritySelector = prioritySelector;
        this._items = new Array();
    }
    register(value) {
        if (this._items.indexOf(value) !== -1) throw new Error("Value is already registered");
        this._items.push(value);
        this._items.sort((s1, s2)=>this.prioritySelector(s2) - this.prioritySelector(s1));
        return {
            dispose: ()=>{
                const idx = this._items.indexOf(value);
                if (idx >= 0) this._items.splice(idx, 1);
            }
        };
    }
    get itemsOrderedByPriorityDesc() {
        return this._items;
    }
}
class TriggerSuggestAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.id = "editor.action.triggerSuggest";
    }
    constructor(){
        super({
            id: TriggerSuggestAction.id,
            label: _nlsJs.localize("suggest.trigger.label", "Trigger Suggest"),
            alias: "Trigger Suggest",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _editorContextKeysJs.EditorContextKeys).hasCompletionItemProvider, (0, _suggestJs.Context).Visible.toNegated()),
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 2058 /* KeyCode.Space */ ,
                secondary: [
                    2087 /* KeyCode.KeyI */ 
                ],
                mac: {
                    primary: 266 /* KeyCode.Space */ ,
                    secondary: [
                        521 /* KeyCode.Escape */ ,
                        2087 /* KeyCode.KeyI */ 
                    ]
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(_accessor, editor, args) {
        const controller = SuggestController.get(editor);
        if (!controller) return;
        let auto;
        if (args && typeof args === "object") {
            if (args.auto === true) auto = true;
        }
        controller.triggerSuggest(undefined, auto, undefined);
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(SuggestController.ID, SuggestController, 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );
(0, _editorExtensionsJs.registerEditorAction)(TriggerSuggestAction);
const weight = 190;
const SuggestCommand = (0, _editorExtensionsJs.EditorCommand).bindToContribution(SuggestController.get);
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "acceptSelectedSuggestion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _suggestJs.Context).HasFocusedSuggestion),
    handler (x) {
        x.acceptSelectedSuggestion(true, false);
    },
    kbOpts: [
        {
            // normal tab
            primary: 2 /* KeyCode.Tab */ ,
            kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _editorContextKeysJs.EditorContextKeys).textInputFocus),
            weight
        },
        {
            // accept on enter has special rules
            primary: 3 /* KeyCode.Enter */ ,
            kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _editorContextKeysJs.EditorContextKeys).textInputFocus, (0, _suggestJs.Context).AcceptSuggestionsOnEnter, (0, _suggestJs.Context).MakesTextEdit),
            weight
        }
    ],
    menuOpts: [
        {
            menuId: (0, _suggestJs.suggestWidgetStatusbarMenu),
            title: _nlsJs.localize("accept.insert", "Insert"),
            group: "left",
            order: 1,
            when: (0, _suggestJs.Context).HasInsertAndReplaceRange.toNegated()
        },
        {
            menuId: (0, _suggestJs.suggestWidgetStatusbarMenu),
            title: _nlsJs.localize("accept.insert", "Insert"),
            group: "left",
            order: 1,
            when: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).HasInsertAndReplaceRange, (0, _suggestJs.Context).InsertMode.isEqualTo("insert"))
        },
        {
            menuId: (0, _suggestJs.suggestWidgetStatusbarMenu),
            title: _nlsJs.localize("accept.replace", "Replace"),
            group: "left",
            order: 1,
            when: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).HasInsertAndReplaceRange, (0, _suggestJs.Context).InsertMode.isEqualTo("replace"))
        }
    ]
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "acceptAlternativeSelectedSuggestion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _editorContextKeysJs.EditorContextKeys).textInputFocus, (0, _suggestJs.Context).HasFocusedSuggestion),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 1027 /* KeyCode.Enter */ ,
        secondary: [
            1026 /* KeyCode.Tab */ 
        ]
    },
    handler (x) {
        x.acceptSelectedSuggestion(false, true);
    },
    menuOpts: [
        {
            menuId: (0, _suggestJs.suggestWidgetStatusbarMenu),
            group: "left",
            order: 2,
            when: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).HasInsertAndReplaceRange, (0, _suggestJs.Context).InsertMode.isEqualTo("insert")),
            title: _nlsJs.localize("accept.replace", "Replace")
        },
        {
            menuId: (0, _suggestJs.suggestWidgetStatusbarMenu),
            group: "left",
            order: 2,
            when: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).HasInsertAndReplaceRange, (0, _suggestJs.Context).InsertMode.isEqualTo("replace")),
            title: _nlsJs.localize("accept.insert", "Insert")
        }
    ]
}));
// continue to support the old command
(0, _commandsJs.CommandsRegistry).registerCommandAlias("acceptSelectedSuggestionOnEnter", "acceptSelectedSuggestion");
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "hideSuggestWidget",
    precondition: (0, _suggestJs.Context).Visible,
    handler: (x)=>x.cancelSuggestWidget(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 9 /* KeyCode.Escape */ ,
        secondary: [
            1033 /* KeyCode.Escape */ 
        ]
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "selectNextSuggestion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _contextkeyJs.ContextKeyExpr).or((0, _suggestJs.Context).MultipleSuggestions, (0, _suggestJs.Context).HasFocusedSuggestion.negate())),
    handler: (c)=>c.selectNextSuggestion(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 18 /* KeyCode.DownArrow */ ,
        secondary: [
            2066 /* KeyCode.DownArrow */ 
        ],
        mac: {
            primary: 18 /* KeyCode.DownArrow */ ,
            secondary: [
                2066 /* KeyCode.DownArrow */ ,
                300 /* KeyCode.KeyN */ 
            ]
        }
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "selectNextPageSuggestion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _contextkeyJs.ContextKeyExpr).or((0, _suggestJs.Context).MultipleSuggestions, (0, _suggestJs.Context).HasFocusedSuggestion.negate())),
    handler: (c)=>c.selectNextPageSuggestion(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 12 /* KeyCode.PageDown */ ,
        secondary: [
            2060 /* KeyCode.PageDown */ 
        ]
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "selectLastSuggestion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _contextkeyJs.ContextKeyExpr).or((0, _suggestJs.Context).MultipleSuggestions, (0, _suggestJs.Context).HasFocusedSuggestion.negate())),
    handler: (c)=>c.selectLastSuggestion()
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "selectPrevSuggestion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _contextkeyJs.ContextKeyExpr).or((0, _suggestJs.Context).MultipleSuggestions, (0, _suggestJs.Context).HasFocusedSuggestion.negate())),
    handler: (c)=>c.selectPrevSuggestion(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 16 /* KeyCode.UpArrow */ ,
        secondary: [
            2064 /* KeyCode.UpArrow */ 
        ],
        mac: {
            primary: 16 /* KeyCode.UpArrow */ ,
            secondary: [
                2064 /* KeyCode.UpArrow */ ,
                302 /* KeyCode.KeyP */ 
            ]
        }
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "selectPrevPageSuggestion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _contextkeyJs.ContextKeyExpr).or((0, _suggestJs.Context).MultipleSuggestions, (0, _suggestJs.Context).HasFocusedSuggestion.negate())),
    handler: (c)=>c.selectPrevPageSuggestion(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 11 /* KeyCode.PageUp */ ,
        secondary: [
            2059 /* KeyCode.PageUp */ 
        ]
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "selectFirstSuggestion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _contextkeyJs.ContextKeyExpr).or((0, _suggestJs.Context).MultipleSuggestions, (0, _suggestJs.Context).HasFocusedSuggestion.negate())),
    handler: (c)=>c.selectFirstSuggestion()
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "focusSuggestion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _suggestJs.Context).HasFocusedSuggestion.negate()),
    handler: (x)=>x.focusSuggestion(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 2058 /* KeyCode.Space */ ,
        secondary: [
            2087 /* KeyCode.KeyI */ 
        ],
        mac: {
            primary: 266 /* KeyCode.Space */ ,
            secondary: [
                2087 /* KeyCode.KeyI */ 
            ]
        }
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "focusAndAcceptSuggestion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _suggestJs.Context).HasFocusedSuggestion.negate()),
    handler: (c)=>{
        c.focusSuggestion();
        c.acceptSelectedSuggestion(true, false);
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "toggleSuggestionDetails",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).Visible, (0, _suggestJs.Context).HasFocusedSuggestion),
    handler: (x)=>x.toggleSuggestionDetails(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 2058 /* KeyCode.Space */ ,
        secondary: [
            2087 /* KeyCode.KeyI */ 
        ],
        mac: {
            primary: 266 /* KeyCode.Space */ ,
            secondary: [
                2087 /* KeyCode.KeyI */ 
            ]
        }
    },
    menuOpts: [
        {
            menuId: (0, _suggestJs.suggestWidgetStatusbarMenu),
            group: "right",
            order: 1,
            when: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).DetailsVisible, (0, _suggestJs.Context).CanResolve),
            title: _nlsJs.localize("detail.more", "Show Less")
        },
        {
            menuId: (0, _suggestJs.suggestWidgetStatusbarMenu),
            group: "right",
            order: 1,
            when: (0, _contextkeyJs.ContextKeyExpr).and((0, _suggestJs.Context).DetailsVisible.toNegated(), (0, _suggestJs.Context).CanResolve),
            title: _nlsJs.localize("detail.less", "Show More")
        }
    ]
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "toggleExplainMode",
    precondition: (0, _suggestJs.Context).Visible,
    handler: (x)=>x.toggleExplainMode(),
    kbOpts: {
        weight: 100 /* KeybindingWeight.EditorContrib */ ,
        primary: 2138 /* KeyCode.Slash */ 
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "toggleSuggestionFocus",
    precondition: (0, _suggestJs.Context).Visible,
    handler: (x)=>x.toggleSuggestionFocus(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 2570 /* KeyCode.Space */ ,
        mac: {
            primary: 778 /* KeyCode.Space */ 
        }
    }
}));
//#region tab completions
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "insertBestCompletion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).textInputFocus, (0, _contextkeyJs.ContextKeyExpr).equals("config.editor.tabCompletion", "on"), (0, _wordContextKeyJs.WordContextKey).AtEnd, (0, _suggestJs.Context).Visible.toNegated(), (0, _suggestAlternativesJs.SuggestAlternatives).OtherSuggestions.toNegated(), (0, _snippetController2Js.SnippetController2).InSnippetMode.toNegated()),
    handler: (x, arg)=>{
        x.triggerSuggestAndAcceptBest((0, _typesJs.isObject)(arg) ? {
            fallback: "tab",
            ...arg
        } : {
            fallback: "tab"
        });
    },
    kbOpts: {
        weight,
        primary: 2 /* KeyCode.Tab */ 
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "insertNextSuggestion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).textInputFocus, (0, _contextkeyJs.ContextKeyExpr).equals("config.editor.tabCompletion", "on"), (0, _suggestAlternativesJs.SuggestAlternatives).OtherSuggestions, (0, _suggestJs.Context).Visible.toNegated(), (0, _snippetController2Js.SnippetController2).InSnippetMode.toNegated()),
    handler: (x)=>x.acceptNextSuggestion(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 2 /* KeyCode.Tab */ 
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new SuggestCommand({
    id: "insertPrevSuggestion",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).textInputFocus, (0, _contextkeyJs.ContextKeyExpr).equals("config.editor.tabCompletion", "on"), (0, _suggestAlternativesJs.SuggestAlternatives).OtherSuggestions, (0, _suggestJs.Context).Visible.toNegated(), (0, _snippetController2Js.SnippetController2).InSnippetMode.toNegated()),
    handler: (x)=>x.acceptPrevSuggestion(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
        primary: 1026 /* KeyCode.Tab */ 
    }
}));
(0, _editorExtensionsJs.registerEditorAction)(class extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.resetSuggestSize",
            label: _nlsJs.localize("suggest.reset.label", "Reset Suggest Widget Size"),
            alias: "Reset Suggest Widget Size",
            precondition: undefined
        });
    }
    run(_accessor, editor) {
        SuggestController.get(editor)?.resetWidgetSize();
    }
});

},{"../../../../base/browser/ui/aria/aria.js":"asrsh","../../../../base/common/arrays.js":"DECei","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/event.js":"4Zi8b","../../../../base/common/keybindings.js":"cQ6F5","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/platform.js":"7maJO","../../../../base/common/stopwatch.js":"77PF9","../../../../base/common/types.js":"fb5yx","../../../browser/stableEditorScroll.js":"5Bh72","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/editOperation.js":"6r2FZ","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/editorContextKeys.js":"5exv9","../../snippet/browser/snippetController2.js":"0XDQb","../../snippet/browser/snippetParser.js":"6qHnq","./suggestMemory.js":"cZlLP","./wordContextKey.js":"7dGVm","../../../../nls.js":"l617d","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/log/common/log.js":"ieJUF","./suggest.js":"8xSUV","./suggestAlternatives.js":"azYnn","./suggestCommitCharacters.js":"4p8x8","./suggestModel.js":"bJ1b4","./suggestOvertypingCapturer.js":"cG5Ip","./suggestWidget.js":"iVklD","../../../../platform/telemetry/common/telemetry.js":"7vW8j","../../../../base/common/resources.js":"700EV","../../../../base/common/hash.js":"hXc0q","../../../../base/browser/dom.js":"bnqsM","../../../common/model/textModel.js":"9beDe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cZlLP":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Memory", ()=>Memory);
parcelHelpers.export(exports, "NoMemory", ()=>NoMemory);
parcelHelpers.export(exports, "LRUMemory", ()=>LRUMemory);
parcelHelpers.export(exports, "PrefixMemory", ()=>PrefixMemory);
parcelHelpers.export(exports, "SuggestMemoryService", ()=>SuggestMemoryService);
parcelHelpers.export(exports, "ISuggestMemoryService", ()=>ISuggestMemoryService);
var _asyncJs = require("../../../../base/common/async.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _mapJs = require("../../../../base/common/map.js");
var _ternarySearchTreeJs = require("../../../../base/common/ternarySearchTree.js");
var _languagesJs = require("../../../common/languages.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _extensionsJs = require("../../../../platform/instantiation/common/extensions.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _storageJs = require("../../../../platform/storage/common/storage.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var SuggestMemoryService_1;
class Memory {
    constructor(name){
        this.name = name;
    }
    select(model, pos, items) {
        if (items.length === 0) return 0;
        const topScore = items[0].score[0];
        for(let i = 0; i < items.length; i++){
            const { score, completion: suggestion } = items[i];
            if (score[0] !== topScore) break;
            if (suggestion.preselect) // stop when seeing an auto-select-item
            return i;
        }
        return 0;
    }
}
class NoMemory extends Memory {
    constructor(){
        super("first");
    }
    memorize(model, pos, item) {
    // no-op
    }
    toJSON() {
        return undefined;
    }
    fromJSON() {
    //
    }
}
class LRUMemory extends Memory {
    constructor(){
        super("recentlyUsed");
        this._cache = new (0, _mapJs.LRUCache)(300, 0.66);
        this._seq = 0;
    }
    memorize(model, pos, item) {
        const key = `${model.getLanguageId()}/${item.textLabel}`;
        this._cache.set(key, {
            touch: this._seq++,
            type: item.completion.kind,
            insertText: item.completion.insertText
        });
    }
    select(model, pos, items) {
        if (items.length === 0) return 0;
        const lineSuffix = model.getLineContent(pos.lineNumber).substr(pos.column - 10, pos.column - 1);
        if (/\s$/.test(lineSuffix)) return super.select(model, pos, items);
        const topScore = items[0].score[0];
        let indexPreselect = -1;
        let indexRecency = -1;
        let seq = -1;
        for(let i = 0; i < items.length; i++){
            if (items[i].score[0] !== topScore) break;
            const key = `${model.getLanguageId()}/${items[i].textLabel}`;
            const item = this._cache.peek(key);
            if (item && item.touch > seq && item.type === items[i].completion.kind && item.insertText === items[i].completion.insertText) {
                seq = item.touch;
                indexRecency = i;
            }
            if (items[i].completion.preselect && indexPreselect === -1) // stop when seeing an auto-select-item
            return indexPreselect = i;
        }
        if (indexRecency !== -1) return indexRecency;
        else if (indexPreselect !== -1) return indexPreselect;
        else return 0;
    }
    toJSON() {
        return this._cache.toJSON();
    }
    fromJSON(data) {
        this._cache.clear();
        const seq = 0;
        for (const [key, value] of data){
            value.touch = seq;
            value.type = typeof value.type === "number" ? value.type : (0, _languagesJs.CompletionItemKinds).fromString(value.type);
            this._cache.set(key, value);
        }
        this._seq = this._cache.size;
    }
}
class PrefixMemory extends Memory {
    constructor(){
        super("recentlyUsedByPrefix");
        this._trie = (0, _ternarySearchTreeJs.TernarySearchTree).forStrings();
        this._seq = 0;
    }
    memorize(model, pos, item) {
        const { word } = model.getWordUntilPosition(pos);
        const key = `${model.getLanguageId()}/${word}`;
        this._trie.set(key, {
            type: item.completion.kind,
            insertText: item.completion.insertText,
            touch: this._seq++
        });
    }
    select(model, pos, items) {
        const { word } = model.getWordUntilPosition(pos);
        if (!word) return super.select(model, pos, items);
        const key = `${model.getLanguageId()}/${word}`;
        let item = this._trie.get(key);
        if (!item) item = this._trie.findSubstr(key);
        if (item) for(let i = 0; i < items.length; i++){
            const { kind, insertText } = items[i].completion;
            if (kind === item.type && insertText === item.insertText) return i;
        }
        return super.select(model, pos, items);
    }
    toJSON() {
        const entries = [];
        this._trie.forEach((value, key)=>entries.push([
                key,
                value
            ]));
        // sort by last recently used (touch), then
        // take the top 200 item and normalize their
        // touch
        entries.sort((a, b)=>-(a[1].touch - b[1].touch)).forEach((value, i)=>value[1].touch = i);
        return entries.slice(0, 200);
    }
    fromJSON(data) {
        this._trie.clear();
        if (data.length > 0) {
            this._seq = data[0][1].touch + 1;
            for (const [key, value] of data){
                value.type = typeof value.type === "number" ? value.type : (0, _languagesJs.CompletionItemKinds).fromString(value.type);
                this._trie.set(key, value);
            }
        }
    }
}
let SuggestMemoryService = class SuggestMemoryService {
    static{
        SuggestMemoryService_1 = this;
    }
    static{
        this._strategyCtors = new Map([
            [
                "recentlyUsedByPrefix",
                PrefixMemory
            ],
            [
                "recentlyUsed",
                LRUMemory
            ],
            [
                "first",
                NoMemory
            ]
        ]);
    }
    static{
        this._storagePrefix = "suggest/memories";
    }
    constructor(_storageService, _configService){
        this._storageService = _storageService;
        this._configService = _configService;
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._persistSoon = new (0, _asyncJs.RunOnceScheduler)(()=>this._saveState(), 500);
        this._disposables.add(_storageService.onWillSaveState((e)=>{
            if (e.reason === (0, _storageJs.WillSaveStateReason).SHUTDOWN) this._saveState();
        }));
    }
    dispose() {
        this._disposables.dispose();
        this._persistSoon.dispose();
    }
    memorize(model, pos, item) {
        this._withStrategy(model, pos).memorize(model, pos, item);
        this._persistSoon.schedule();
    }
    select(model, pos, items) {
        return this._withStrategy(model, pos).select(model, pos, items);
    }
    _withStrategy(model, pos) {
        const mode = this._configService.getValue("editor.suggestSelection", {
            overrideIdentifier: model.getLanguageIdAtPosition(pos.lineNumber, pos.column),
            resource: model.uri
        });
        if (this._strategy?.name !== mode) {
            this._saveState();
            const ctor = SuggestMemoryService_1._strategyCtors.get(mode) || NoMemory;
            this._strategy = new ctor();
            try {
                const share = this._configService.getValue("editor.suggest.shareSuggestSelections");
                const scope = share ? 0 /* StorageScope.PROFILE */  : 1 /* StorageScope.WORKSPACE */ ;
                const raw = this._storageService.get(`${SuggestMemoryService_1._storagePrefix}/${mode}`, scope);
                if (raw) this._strategy.fromJSON(JSON.parse(raw));
            } catch (e) {
            // things can go wrong with JSON...
            }
        }
        return this._strategy;
    }
    _saveState() {
        if (this._strategy) {
            const share = this._configService.getValue("editor.suggest.shareSuggestSelections");
            const scope = share ? 0 /* StorageScope.PROFILE */  : 1 /* StorageScope.WORKSPACE */ ;
            const raw = JSON.stringify(this._strategy);
            this._storageService.store(`${SuggestMemoryService_1._storagePrefix}/${this._strategy.name}`, raw, scope, 1 /* StorageTarget.MACHINE */ );
        }
    }
};
SuggestMemoryService = SuggestMemoryService_1 = __decorate([
    __param(0, (0, _storageJs.IStorageService)),
    __param(1, (0, _configurationJs.IConfigurationService))
], SuggestMemoryService);
const ISuggestMemoryService = (0, _instantiationJs.createDecorator)("ISuggestMemories");
(0, _extensionsJs.registerSingleton)(ISuggestMemoryService, SuggestMemoryService, 1 /* InstantiationType.Delayed */ );

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/map.js":"leSjz","../../../../base/common/ternarySearchTree.js":"d54no","../../../common/languages.js":"g5n96","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/instantiation/common/extensions.js":"6WJLq","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/storage/common/storage.js":"6AhR2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7dGVm":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WordContextKey", ()=>WordContextKey);
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var WordContextKey_1;
let WordContextKey = class WordContextKey {
    static{
        WordContextKey_1 = this;
    }
    static{
        this.AtEnd = new (0, _contextkeyJs.RawContextKey)("atEndOfWord", false);
    }
    constructor(_editor, contextKeyService){
        this._editor = _editor;
        this._enabled = false;
        this._ckAtEnd = WordContextKey_1.AtEnd.bindTo(contextKeyService);
        this._configListener = this._editor.onDidChangeConfiguration((e)=>e.hasChanged(124 /* EditorOption.tabCompletion */ ) && this._update());
        this._update();
    }
    dispose() {
        this._configListener.dispose();
        this._selectionListener?.dispose();
        this._ckAtEnd.reset();
    }
    _update() {
        // only update this when tab completions are enabled
        const enabled = this._editor.getOption(124 /* EditorOption.tabCompletion */ ) === "on";
        if (this._enabled === enabled) return;
        this._enabled = enabled;
        if (this._enabled) {
            const checkForWordEnd = ()=>{
                if (!this._editor.hasModel()) {
                    this._ckAtEnd.set(false);
                    return;
                }
                const model = this._editor.getModel();
                const selection = this._editor.getSelection();
                const word = model.getWordAtPosition(selection.getStartPosition());
                if (!word) {
                    this._ckAtEnd.set(false);
                    return;
                }
                this._ckAtEnd.set(word.endColumn === selection.getStartPosition().column);
            };
            this._selectionListener = this._editor.onDidChangeCursorSelection(checkForWordEnd);
            checkForWordEnd();
        } else if (this._selectionListener) {
            this._ckAtEnd.reset();
            this._selectionListener.dispose();
            this._selectionListener = undefined;
        }
    }
};
WordContextKey = WordContextKey_1 = __decorate([
    __param(1, (0, _contextkeyJs.IContextKeyService))
], WordContextKey);

},{"../../../../platform/contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"azYnn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SuggestAlternatives", ()=>SuggestAlternatives);
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var SuggestAlternatives_1;
let SuggestAlternatives = class SuggestAlternatives {
    static{
        SuggestAlternatives_1 = this;
    }
    static{
        this.OtherSuggestions = new (0, _contextkeyJs.RawContextKey)("hasOtherSuggestions", false);
    }
    constructor(_editor, contextKeyService){
        this._editor = _editor;
        this._index = 0;
        this._ckOtherSuggestions = SuggestAlternatives_1.OtherSuggestions.bindTo(contextKeyService);
    }
    dispose() {
        this.reset();
    }
    reset() {
        this._ckOtherSuggestions.reset();
        this._listener?.dispose();
        this._model = undefined;
        this._acceptNext = undefined;
        this._ignore = false;
    }
    set({ model, index }, acceptNext) {
        // no suggestions -> nothing to do
        if (model.items.length === 0) {
            this.reset();
            return;
        }
        // no alternative suggestions -> nothing to do
        const nextIndex = SuggestAlternatives_1._moveIndex(true, model, index);
        if (nextIndex === index) {
            this.reset();
            return;
        }
        this._acceptNext = acceptNext;
        this._model = model;
        this._index = index;
        this._listener = this._editor.onDidChangeCursorPosition(()=>{
            if (!this._ignore) this.reset();
        });
        this._ckOtherSuggestions.set(true);
    }
    static _moveIndex(fwd, model, index) {
        let newIndex = index;
        for(let rounds = model.items.length; rounds > 0; rounds--){
            newIndex = (newIndex + model.items.length + (fwd ? 1 : -1)) % model.items.length;
            if (newIndex === index) break;
            if (!model.items[newIndex].completion.additionalTextEdits) break;
        }
        return newIndex;
    }
    next() {
        this._move(true);
    }
    prev() {
        this._move(false);
    }
    _move(fwd) {
        if (!this._model) // nothing to reason about
        return;
        try {
            this._ignore = true;
            this._index = SuggestAlternatives_1._moveIndex(fwd, this._model, this._index);
            this._acceptNext({
                index: this._index,
                item: this._model.items[this._index],
                model: this._model
            });
        } finally{
            this._ignore = false;
        }
    }
};
SuggestAlternatives = SuggestAlternatives_1 = __decorate([
    __param(1, (0, _contextkeyJs.IContextKeyService))
], SuggestAlternatives);

},{"../../../../platform/contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4p8x8":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CommitCharacterController", ()=>CommitCharacterController);
var _arraysJs = require("../../../../base/common/arrays.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _characterClassifierJs = require("../../../common/core/characterClassifier.js");
class CommitCharacterController {
    constructor(editor, widget, model, accept){
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._disposables.add(model.onDidSuggest((e)=>{
            if (e.completionModel.items.length === 0) this.reset();
        }));
        this._disposables.add(model.onDidCancel((e)=>{
            this.reset();
        }));
        this._disposables.add(widget.onDidShow(()=>this._onItem(widget.getFocusedItem())));
        this._disposables.add(widget.onDidFocus(this._onItem, this));
        this._disposables.add(widget.onDidHide(this.reset, this));
        this._disposables.add(editor.onWillType((text)=>{
            if (this._active && !widget.isFrozen() && model.state !== 0 /* State.Idle */ ) {
                const ch = text.charCodeAt(text.length - 1);
                if (this._active.acceptCharacters.has(ch) && editor.getOption(0 /* EditorOption.acceptSuggestionOnCommitCharacter */ )) accept(this._active.item);
            }
        }));
    }
    _onItem(selected) {
        if (!selected || !(0, _arraysJs.isNonEmptyArray)(selected.item.completion.commitCharacters)) {
            // no item or no commit characters
            this.reset();
            return;
        }
        if (this._active && this._active.item.item === selected.item) // still the same item
        return;
        // keep item and its commit characters
        const acceptCharacters = new (0, _characterClassifierJs.CharacterSet)();
        for (const ch of selected.item.completion.commitCharacters)if (ch.length > 0) acceptCharacters.add(ch.charCodeAt(0));
        this._active = {
            acceptCharacters,
            item: selected
        };
    }
    reset() {
        this._active = undefined;
    }
    dispose() {
        this._disposables.dispose();
    }
}

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/lifecycle.js":"9kg8d","../../../common/core/characterClassifier.js":"hl8tq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bJ1b4":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineContext", ()=>LineContext);
parcelHelpers.export(exports, "SuggestModel", ()=>SuggestModel);
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _selectionJs = require("../../../common/core/selection.js");
var _editorWorkerJs = require("../../../common/services/editorWorker.js");
var _wordDistanceJs = require("./wordDistance.js");
var _clipboardServiceJs = require("../../../../platform/clipboard/common/clipboardService.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _logJs = require("../../../../platform/log/common/log.js");
var _telemetryJs = require("../../../../platform/telemetry/common/telemetry.js");
var _completionModelJs = require("./completionModel.js");
var _suggestJs = require("./suggest.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _filtersJs = require("../../../../base/common/filters.js");
var _typesJs = require("../../../../base/common/types.js");
var _inlineCompletionContextKeysJs = require("../../inlineCompletions/browser/controller/inlineCompletionContextKeys.js");
var _snippetController2Js = require("../../snippet/browser/snippetController2.js");
var _environmentJs = require("../../../../platform/environment/common/environment.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var SuggestModel_1;
class LineContext {
    static shouldAutoTrigger(editor) {
        if (!editor.hasModel()) return false;
        const model = editor.getModel();
        const pos = editor.getPosition();
        model.tokenization.tokenizeIfCheap(pos.lineNumber);
        const word = model.getWordAtPosition(pos);
        if (!word) return false;
        if (word.endColumn !== pos.column && word.startColumn + 1 !== pos.column /* after typing a single character before a word */ ) return false;
        if (!isNaN(Number(word.word))) return false;
        return true;
    }
    constructor(model, position, triggerOptions){
        this.leadingLineContent = model.getLineContent(position.lineNumber).substr(0, position.column - 1);
        this.leadingWord = model.getWordUntilPosition(position);
        this.lineNumber = position.lineNumber;
        this.column = position.column;
        this.triggerOptions = triggerOptions;
    }
}
function canShowQuickSuggest(editor, contextKeyService, configurationService) {
    if (!Boolean(contextKeyService.getContextKeyValue((0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys).inlineSuggestionVisible.key))) // Allow if there is no inline suggestion.
    return true;
    const suppressSuggestions = contextKeyService.getContextKeyValue((0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys).suppressSuggestions.key);
    if (suppressSuggestions !== undefined) return !suppressSuggestions;
    return !editor.getOption(62 /* EditorOption.inlineSuggest */ ).suppressSuggestions;
}
function canShowSuggestOnTriggerCharacters(editor, contextKeyService, configurationService) {
    if (!Boolean(contextKeyService.getContextKeyValue("inlineSuggestionVisible"))) // Allow if there is no inline suggestion.
    return true;
    const suppressSuggestions = contextKeyService.getContextKeyValue((0, _inlineCompletionContextKeysJs.InlineCompletionContextKeys).suppressSuggestions.key);
    if (suppressSuggestions !== undefined) return !suppressSuggestions;
    return !editor.getOption(62 /* EditorOption.inlineSuggest */ ).suppressSuggestions;
}
let SuggestModel = SuggestModel_1 = class SuggestModel {
    constructor(_editor, _editorWorkerService, _clipboardService, _telemetryService, _logService, _contextKeyService, _configurationService, _languageFeaturesService, _envService){
        this._editor = _editor;
        this._editorWorkerService = _editorWorkerService;
        this._clipboardService = _clipboardService;
        this._telemetryService = _telemetryService;
        this._logService = _logService;
        this._contextKeyService = _contextKeyService;
        this._configurationService = _configurationService;
        this._languageFeaturesService = _languageFeaturesService;
        this._envService = _envService;
        this._toDispose = new (0, _lifecycleJs.DisposableStore)();
        this._triggerCharacterListener = new (0, _lifecycleJs.DisposableStore)();
        this._triggerQuickSuggest = new (0, _asyncJs.TimeoutTimer)();
        this._triggerState = undefined;
        this._completionDisposables = new (0, _lifecycleJs.DisposableStore)();
        this._onDidCancel = new (0, _eventJs.Emitter)();
        this._onDidTrigger = new (0, _eventJs.Emitter)();
        this._onDidSuggest = new (0, _eventJs.Emitter)();
        this.onDidCancel = this._onDidCancel.event;
        this.onDidTrigger = this._onDidTrigger.event;
        this.onDidSuggest = this._onDidSuggest.event;
        this._telemetryGate = 0;
        this._currentSelection = this._editor.getSelection() || new (0, _selectionJs.Selection)(1, 1, 1, 1);
        // wire up various listeners
        this._toDispose.add(this._editor.onDidChangeModel(()=>{
            this._updateTriggerCharacters();
            this.cancel();
        }));
        this._toDispose.add(this._editor.onDidChangeModelLanguage(()=>{
            this._updateTriggerCharacters();
            this.cancel();
        }));
        this._toDispose.add(this._editor.onDidChangeConfiguration(()=>{
            this._updateTriggerCharacters();
        }));
        this._toDispose.add(this._languageFeaturesService.completionProvider.onDidChange(()=>{
            this._updateTriggerCharacters();
            this._updateActiveSuggestSession();
        }));
        let editorIsComposing = false;
        this._toDispose.add(this._editor.onDidCompositionStart(()=>{
            editorIsComposing = true;
        }));
        this._toDispose.add(this._editor.onDidCompositionEnd(()=>{
            editorIsComposing = false;
            this._onCompositionEnd();
        }));
        this._toDispose.add(this._editor.onDidChangeCursorSelection((e)=>{
            // only trigger suggest when the editor isn't composing a character
            if (!editorIsComposing) this._onCursorChange(e);
        }));
        this._toDispose.add(this._editor.onDidChangeModelContent(()=>{
            // only filter completions when the editor isn't composing a character
            // allow-any-unicode-next-line
            // e.g. ¨ + u makes ü but just ¨ cannot be used for filtering
            if (!editorIsComposing && this._triggerState !== undefined) this._refilterCompletionItems();
        }));
        this._updateTriggerCharacters();
    }
    dispose() {
        (0, _lifecycleJs.dispose)(this._triggerCharacterListener);
        (0, _lifecycleJs.dispose)([
            this._onDidCancel,
            this._onDidSuggest,
            this._onDidTrigger,
            this._triggerQuickSuggest
        ]);
        this._toDispose.dispose();
        this._completionDisposables.dispose();
        this.cancel();
    }
    _updateTriggerCharacters() {
        this._triggerCharacterListener.clear();
        if (this._editor.getOption(92 /* EditorOption.readOnly */ ) || !this._editor.hasModel() || !this._editor.getOption(122 /* EditorOption.suggestOnTriggerCharacters */ )) return;
        const supportsByTriggerCharacter = new Map();
        for (const support of this._languageFeaturesService.completionProvider.all(this._editor.getModel()))for (const ch of support.triggerCharacters || []){
            let set = supportsByTriggerCharacter.get(ch);
            if (!set) {
                set = new Set();
                const suggestSupport = (0, _suggestJs.getSnippetSuggestSupport)();
                if (suggestSupport) set.add(suggestSupport);
                supportsByTriggerCharacter.set(ch, set);
            }
            set.add(support);
        }
        const checkTriggerCharacter = (text)=>{
            if (!canShowSuggestOnTriggerCharacters(this._editor, this._contextKeyService, this._configurationService)) return;
            if (LineContext.shouldAutoTrigger(this._editor)) // don't trigger by trigger characters when this is a case for quick suggest
            return;
            if (!text) {
                // came here from the compositionEnd-event
                const position = this._editor.getPosition();
                const model = this._editor.getModel();
                text = model.getLineContent(position.lineNumber).substr(0, position.column - 1);
            }
            let lastChar = "";
            if ((0, _stringsJs.isLowSurrogate)(text.charCodeAt(text.length - 1))) {
                if ((0, _stringsJs.isHighSurrogate)(text.charCodeAt(text.length - 2))) lastChar = text.substr(text.length - 2);
            } else lastChar = text.charAt(text.length - 1);
            const supports = supportsByTriggerCharacter.get(lastChar);
            if (supports) {
                // keep existing items that where not computed by the
                // supports/providers that want to trigger now
                const providerItemsToReuse = new Map();
                if (this._completionModel) {
                    for (const [provider, items] of this._completionModel.getItemsByProvider())if (!supports.has(provider)) providerItemsToReuse.set(provider, items);
                }
                this.trigger({
                    auto: true,
                    triggerKind: 1 /* CompletionTriggerKind.TriggerCharacter */ ,
                    triggerCharacter: lastChar,
                    retrigger: Boolean(this._completionModel),
                    clipboardText: this._completionModel?.clipboardText,
                    completionOptions: {
                        providerFilter: supports,
                        providerItemsToReuse
                    }
                });
            }
        };
        this._triggerCharacterListener.add(this._editor.onDidType(checkTriggerCharacter));
        this._triggerCharacterListener.add(this._editor.onDidCompositionEnd(()=>checkTriggerCharacter()));
    }
    // --- trigger/retrigger/cancel suggest
    get state() {
        if (!this._triggerState) return 0 /* State.Idle */ ;
        else if (!this._triggerState.auto) return 1 /* State.Manual */ ;
        else return 2 /* State.Auto */ ;
    }
    cancel(retrigger = false) {
        if (this._triggerState !== undefined) {
            this._triggerQuickSuggest.cancel();
            this._requestToken?.cancel();
            this._requestToken = undefined;
            this._triggerState = undefined;
            this._completionModel = undefined;
            this._context = undefined;
            this._onDidCancel.fire({
                retrigger
            });
        }
    }
    clear() {
        this._completionDisposables.clear();
    }
    _updateActiveSuggestSession() {
        if (this._triggerState !== undefined) {
            if (!this._editor.hasModel() || !this._languageFeaturesService.completionProvider.has(this._editor.getModel())) this.cancel();
            else this.trigger({
                auto: this._triggerState.auto,
                retrigger: true
            });
        }
    }
    _onCursorChange(e) {
        if (!this._editor.hasModel()) return;
        const prevSelection = this._currentSelection;
        this._currentSelection = this._editor.getSelection();
        if (!e.selection.isEmpty() || e.reason !== 0 /* CursorChangeReason.NotSet */  && e.reason !== 3 /* CursorChangeReason.Explicit */  || e.source !== "keyboard" && e.source !== "deleteLeft") {
            // Early exit if nothing needs to be done!
            // Leave some form of early exit check here if you wish to continue being a cursor position change listener ;)
            this.cancel();
            return;
        }
        if (this._triggerState === undefined && e.reason === 0 /* CursorChangeReason.NotSet */ ) {
            if (prevSelection.containsRange(this._currentSelection) || prevSelection.getEndPosition().isBeforeOrEqual(this._currentSelection.getPosition())) // cursor did move RIGHT due to typing -> trigger quick suggest
            this._doTriggerQuickSuggest();
        } else if (this._triggerState !== undefined && e.reason === 3 /* CursorChangeReason.Explicit */ ) // suggest is active and something like cursor keys are used to move
        // the cursor. this means we can refilter at the new position
        this._refilterCompletionItems();
    }
    _onCompositionEnd() {
        // trigger or refilter when composition ends
        if (this._triggerState === undefined) this._doTriggerQuickSuggest();
        else this._refilterCompletionItems();
    }
    _doTriggerQuickSuggest() {
        if ((0, _suggestJs.QuickSuggestionsOptions).isAllOff(this._editor.getOption(90 /* EditorOption.quickSuggestions */ ))) // not enabled
        return;
        if (this._editor.getOption(119 /* EditorOption.suggest */ ).snippetsPreventQuickSuggestions && (0, _snippetController2Js.SnippetController2).get(this._editor)?.isInSnippet()) // no quick suggestion when in snippet mode
        return;
        this.cancel();
        this._triggerQuickSuggest.cancelAndSet(()=>{
            if (this._triggerState !== undefined) return;
            if (!LineContext.shouldAutoTrigger(this._editor)) return;
            if (!this._editor.hasModel() || !this._editor.hasWidgetFocus()) return;
            const model = this._editor.getModel();
            const pos = this._editor.getPosition();
            // validate enabled now
            const config = this._editor.getOption(90 /* EditorOption.quickSuggestions */ );
            if ((0, _suggestJs.QuickSuggestionsOptions).isAllOff(config)) return;
            if (!(0, _suggestJs.QuickSuggestionsOptions).isAllOn(config)) {
                // Check the type of the token that triggered this
                model.tokenization.tokenizeIfCheap(pos.lineNumber);
                const lineTokens = model.tokenization.getLineTokens(pos.lineNumber);
                const tokenType = lineTokens.getStandardTokenType(lineTokens.findTokenIndexAtOffset(Math.max(pos.column - 1 - 1, 0)));
                if ((0, _suggestJs.QuickSuggestionsOptions).valueFor(config, tokenType) !== "on") return;
            }
            if (!canShowQuickSuggest(this._editor, this._contextKeyService, this._configurationService)) // do not trigger quick suggestions if inline suggestions are shown
            return;
            if (!this._languageFeaturesService.completionProvider.has(model)) return;
            // we made it till here -> trigger now
            this.trigger({
                auto: true
            });
        }, this._editor.getOption(91 /* EditorOption.quickSuggestionsDelay */ ));
    }
    _refilterCompletionItems() {
        (0, _typesJs.assertType)(this._editor.hasModel());
        (0, _typesJs.assertType)(this._triggerState !== undefined);
        const model = this._editor.getModel();
        const position = this._editor.getPosition();
        const ctx = new LineContext(model, position, {
            ...this._triggerState,
            refilter: true
        });
        this._onNewContext(ctx);
    }
    trigger(options) {
        if (!this._editor.hasModel()) return;
        const model = this._editor.getModel();
        const ctx = new LineContext(model, this._editor.getPosition(), options);
        // Cancel previous requests, change state & update UI
        this.cancel(options.retrigger);
        this._triggerState = options;
        this._onDidTrigger.fire({
            auto: options.auto,
            shy: options.shy ?? false,
            position: this._editor.getPosition()
        });
        // Capture context when request was sent
        this._context = ctx;
        // Build context for request
        let suggestCtx = {
            triggerKind: options.triggerKind ?? 0 /* CompletionTriggerKind.Invoke */ 
        };
        if (options.triggerCharacter) suggestCtx = {
            triggerKind: 1 /* CompletionTriggerKind.TriggerCharacter */ ,
            triggerCharacter: options.triggerCharacter
        };
        this._requestToken = new (0, _cancellationJs.CancellationTokenSource)();
        // kind filter and snippet sort rules
        const snippetSuggestions = this._editor.getOption(113 /* EditorOption.snippetSuggestions */ );
        let snippetSortOrder = 1 /* SnippetSortOrder.Inline */ ;
        switch(snippetSuggestions){
            case "top":
                snippetSortOrder = 0 /* SnippetSortOrder.Top */ ;
                break;
            // 	↓ that's the default anyways...
            // case 'inline':
            // 	snippetSortOrder = SnippetSortOrder.Inline;
            // 	break;
            case "bottom":
                snippetSortOrder = 2 /* SnippetSortOrder.Bottom */ ;
                break;
        }
        const { itemKind: itemKindFilter, showDeprecated } = SuggestModel_1.createSuggestFilter(this._editor);
        const completionOptions = new (0, _suggestJs.CompletionOptions)(snippetSortOrder, options.completionOptions?.kindFilter ?? itemKindFilter, options.completionOptions?.providerFilter, options.completionOptions?.providerItemsToReuse, showDeprecated);
        const wordDistance = (0, _wordDistanceJs.WordDistance).create(this._editorWorkerService, this._editor);
        const completions = (0, _suggestJs.provideSuggestionItems)(this._languageFeaturesService.completionProvider, model, this._editor.getPosition(), completionOptions, suggestCtx, this._requestToken.token);
        Promise.all([
            completions,
            wordDistance
        ]).then(async ([completions, wordDistance])=>{
            this._requestToken?.dispose();
            if (!this._editor.hasModel()) return;
            let clipboardText = options?.clipboardText;
            if (!clipboardText && completions.needsClipboard) clipboardText = await this._clipboardService.readText();
            if (this._triggerState === undefined) return;
            const model = this._editor.getModel();
            // const items = completions.items;
            // if (existing) {
            // 	const cmpFn = getSuggestionComparator(snippetSortOrder);
            // 	items = items.concat(existing.items).sort(cmpFn);
            // }
            const ctx = new LineContext(model, this._editor.getPosition(), options);
            const fuzzySearchOptions = {
                ...(0, _filtersJs.FuzzyScoreOptions).default,
                firstMatchCanBeWeak: !this._editor.getOption(119 /* EditorOption.suggest */ ).matchOnWordStartOnly
            };
            this._completionModel = new (0, _completionModelJs.CompletionModel)(completions.items, this._context.column, {
                leadingLineContent: ctx.leadingLineContent,
                characterCountDelta: ctx.column - this._context.column
            }, wordDistance, this._editor.getOption(119 /* EditorOption.suggest */ ), this._editor.getOption(113 /* EditorOption.snippetSuggestions */ ), fuzzySearchOptions, clipboardText);
            // store containers so that they can be disposed later
            this._completionDisposables.add(completions.disposable);
            this._onNewContext(ctx);
            // finally report telemetry about durations
            this._reportDurationsTelemetry(completions.durations);
            // report invalid completions by source
            if (!this._envService.isBuilt || this._envService.isExtensionDevelopment) {
                for (const item of completions.items)if (item.isInvalid) this._logService.warn(`[suggest] did IGNORE invalid completion item from ${item.provider._debugDisplayName}`, item.completion);
            }
        }).catch((0, _errorsJs.onUnexpectedError));
    }
    _reportDurationsTelemetry(durations) {
        if (this._telemetryGate++ % 230 !== 0) return;
        setTimeout(()=>{
            this._telemetryService.publicLog2("suggest.durations.json", {
                data: JSON.stringify(durations)
            });
            this._logService.debug("suggest.durations.json", durations);
        });
    }
    static createSuggestFilter(editor) {
        // kind filter and snippet sort rules
        const result = new Set();
        // snippet setting
        const snippetSuggestions = editor.getOption(113 /* EditorOption.snippetSuggestions */ );
        if (snippetSuggestions === "none") result.add(27 /* CompletionItemKind.Snippet */ );
        // type setting
        const suggestOptions = editor.getOption(119 /* EditorOption.suggest */ );
        if (!suggestOptions.showMethods) result.add(0 /* CompletionItemKind.Method */ );
        if (!suggestOptions.showFunctions) result.add(1 /* CompletionItemKind.Function */ );
        if (!suggestOptions.showConstructors) result.add(2 /* CompletionItemKind.Constructor */ );
        if (!suggestOptions.showFields) result.add(3 /* CompletionItemKind.Field */ );
        if (!suggestOptions.showVariables) result.add(4 /* CompletionItemKind.Variable */ );
        if (!suggestOptions.showClasses) result.add(5 /* CompletionItemKind.Class */ );
        if (!suggestOptions.showStructs) result.add(6 /* CompletionItemKind.Struct */ );
        if (!suggestOptions.showInterfaces) result.add(7 /* CompletionItemKind.Interface */ );
        if (!suggestOptions.showModules) result.add(8 /* CompletionItemKind.Module */ );
        if (!suggestOptions.showProperties) result.add(9 /* CompletionItemKind.Property */ );
        if (!suggestOptions.showEvents) result.add(10 /* CompletionItemKind.Event */ );
        if (!suggestOptions.showOperators) result.add(11 /* CompletionItemKind.Operator */ );
        if (!suggestOptions.showUnits) result.add(12 /* CompletionItemKind.Unit */ );
        if (!suggestOptions.showValues) result.add(13 /* CompletionItemKind.Value */ );
        if (!suggestOptions.showConstants) result.add(14 /* CompletionItemKind.Constant */ );
        if (!suggestOptions.showEnums) result.add(15 /* CompletionItemKind.Enum */ );
        if (!suggestOptions.showEnumMembers) result.add(16 /* CompletionItemKind.EnumMember */ );
        if (!suggestOptions.showKeywords) result.add(17 /* CompletionItemKind.Keyword */ );
        if (!suggestOptions.showWords) result.add(18 /* CompletionItemKind.Text */ );
        if (!suggestOptions.showColors) result.add(19 /* CompletionItemKind.Color */ );
        if (!suggestOptions.showFiles) result.add(20 /* CompletionItemKind.File */ );
        if (!suggestOptions.showReferences) result.add(21 /* CompletionItemKind.Reference */ );
        if (!suggestOptions.showColors) result.add(22 /* CompletionItemKind.Customcolor */ );
        if (!suggestOptions.showFolders) result.add(23 /* CompletionItemKind.Folder */ );
        if (!suggestOptions.showTypeParameters) result.add(24 /* CompletionItemKind.TypeParameter */ );
        if (!suggestOptions.showSnippets) result.add(27 /* CompletionItemKind.Snippet */ );
        if (!suggestOptions.showUsers) result.add(25 /* CompletionItemKind.User */ );
        if (!suggestOptions.showIssues) result.add(26 /* CompletionItemKind.Issue */ );
        return {
            itemKind: result,
            showDeprecated: suggestOptions.showDeprecated
        };
    }
    _onNewContext(ctx) {
        if (!this._context) // happens when 24x7 IntelliSense is enabled and still in its delay
        return;
        if (ctx.lineNumber !== this._context.lineNumber) {
            // e.g. happens when pressing Enter while IntelliSense is computed
            this.cancel();
            return;
        }
        if ((0, _stringsJs.getLeadingWhitespace)(ctx.leadingLineContent) !== (0, _stringsJs.getLeadingWhitespace)(this._context.leadingLineContent)) {
            // cancel IntelliSense when line start changes
            // happens when the current word gets outdented
            this.cancel();
            return;
        }
        if (ctx.column < this._context.column) {
            // typed -> moved cursor LEFT -> retrigger if still on a word
            if (ctx.leadingWord.word) this.trigger({
                auto: this._context.triggerOptions.auto,
                retrigger: true
            });
            else this.cancel();
            return;
        }
        if (!this._completionModel) // happens when IntelliSense is not yet computed
        return;
        if (ctx.leadingWord.word.length !== 0 && ctx.leadingWord.startColumn > this._context.leadingWord.startColumn) {
            // started a new word while IntelliSense shows -> retrigger but reuse all items that we currently have
            const shouldAutoTrigger = LineContext.shouldAutoTrigger(this._editor);
            if (shouldAutoTrigger && this._context) {
                // shouldAutoTrigger forces tokenization, which can cause pending cursor change events to be emitted, which can cause
                // suggestions to be cancelled, which causes `this._context` to be undefined
                const map = this._completionModel.getItemsByProvider();
                this.trigger({
                    auto: this._context.triggerOptions.auto,
                    retrigger: true,
                    clipboardText: this._completionModel.clipboardText,
                    completionOptions: {
                        providerItemsToReuse: map
                    }
                });
            }
            return;
        }
        if (ctx.column > this._context.column && this._completionModel.getIncompleteProvider().size > 0 && ctx.leadingWord.word.length !== 0) {
            // typed -> moved cursor RIGHT & incomple model & still on a word -> retrigger
            const providerItemsToReuse = new Map();
            const providerFilter = new Set();
            for (const [provider, items] of this._completionModel.getItemsByProvider())if (items.length > 0 && items[0].container.incomplete) providerFilter.add(provider);
            else providerItemsToReuse.set(provider, items);
            this.trigger({
                auto: this._context.triggerOptions.auto,
                triggerKind: 2 /* CompletionTriggerKind.TriggerForIncompleteCompletions */ ,
                retrigger: true,
                clipboardText: this._completionModel.clipboardText,
                completionOptions: {
                    providerFilter,
                    providerItemsToReuse
                }
            });
        } else {
            // typed -> moved cursor RIGHT -> update UI
            const oldLineContext = this._completionModel.lineContext;
            let isFrozen = false;
            this._completionModel.lineContext = {
                leadingLineContent: ctx.leadingLineContent,
                characterCountDelta: ctx.column - this._context.column
            };
            if (this._completionModel.items.length === 0) {
                const shouldAutoTrigger = LineContext.shouldAutoTrigger(this._editor);
                if (!this._context) {
                    // shouldAutoTrigger forces tokenization, which can cause pending cursor change events to be emitted, which can cause
                    // suggestions to be cancelled, which causes `this._context` to be undefined
                    this.cancel();
                    return;
                }
                if (shouldAutoTrigger && this._context.leadingWord.endColumn < ctx.leadingWord.startColumn) {
                    // retrigger when heading into a new word
                    this.trigger({
                        auto: this._context.triggerOptions.auto,
                        retrigger: true
                    });
                    return;
                }
                if (!this._context.triggerOptions.auto) {
                    // freeze when IntelliSense was manually requested
                    this._completionModel.lineContext = oldLineContext;
                    isFrozen = this._completionModel.items.length > 0;
                    if (isFrozen && ctx.leadingWord.word.length === 0) {
                        // there were results before but now there aren't
                        // and also we are not on a word anymore -> cancel
                        this.cancel();
                        return;
                    }
                } else {
                    // nothing left
                    this.cancel();
                    return;
                }
            }
            this._onDidSuggest.fire({
                completionModel: this._completionModel,
                triggerOptions: ctx.triggerOptions,
                isFrozen
            });
        }
    }
};
SuggestModel = SuggestModel_1 = __decorate([
    __param(1, (0, _editorWorkerJs.IEditorWorkerService)),
    __param(2, (0, _clipboardServiceJs.IClipboardService)),
    __param(3, (0, _telemetryJs.ITelemetryService)),
    __param(4, (0, _logJs.ILogService)),
    __param(5, (0, _contextkeyJs.IContextKeyService)),
    __param(6, (0, _configurationJs.IConfigurationService)),
    __param(7, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(8, (0, _environmentJs.IEnvironmentService))
], SuggestModel);

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/strings.js":"aA9I1","../../../common/core/selection.js":"kcwzU","../../../common/services/editorWorker.js":"aaYJd","./wordDistance.js":"6CPCo","../../../../platform/clipboard/common/clipboardService.js":"4IsFp","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/log/common/log.js":"ieJUF","../../../../platform/telemetry/common/telemetry.js":"7vW8j","./completionModel.js":"apYwy","./suggest.js":"8xSUV","../../../common/services/languageFeatures.js":"2IAko","../../../../base/common/filters.js":"40BGZ","../../../../base/common/types.js":"fb5yx","../../inlineCompletions/browser/controller/inlineCompletionContextKeys.js":"dbRGN","../../snippet/browser/snippetController2.js":"0XDQb","../../../../platform/environment/common/environment.js":"6y5Oq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6CPCo":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WordDistance", ()=>WordDistance);
var _arraysJs = require("../../../../base/common/arrays.js");
var _rangeJs = require("../../../common/core/range.js");
var _bracketSelectionsJs = require("../../smartSelect/browser/bracketSelections.js");
class WordDistance {
    static{
        this.None = new class extends WordDistance {
            distance() {
                return 0;
            }
        };
    }
    static async create(service, editor) {
        if (!editor.getOption(119 /* EditorOption.suggest */ ).localityBonus) return WordDistance.None;
        if (!editor.hasModel()) return WordDistance.None;
        const model = editor.getModel();
        const position = editor.getPosition();
        if (!service.canComputeWordRanges(model.uri)) return WordDistance.None;
        const [ranges] = await new (0, _bracketSelectionsJs.BracketSelectionRangeProvider)().provideSelectionRanges(model, [
            position
        ]);
        if (ranges.length === 0) return WordDistance.None;
        const wordRanges = await service.computeWordRanges(model.uri, ranges[0].range);
        if (!wordRanges) return WordDistance.None;
        // remove current word
        const wordUntilPos = model.getWordUntilPosition(position);
        delete wordRanges[wordUntilPos.word];
        return new class extends WordDistance {
            distance(anchor, item) {
                if (!position.equals(editor.getPosition())) return 0;
                if (item.kind === 17 /* CompletionItemKind.Keyword */ ) return 2097152;
                const word = typeof item.label === "string" ? item.label : item.label.label;
                const wordLines = wordRanges[word];
                if ((0, _arraysJs.isFalsyOrEmpty)(wordLines)) return 2097152;
                const idx = (0, _arraysJs.binarySearch)(wordLines, (0, _rangeJs.Range).fromPositions(anchor), (0, _rangeJs.Range).compareRangesUsingStarts);
                const bestWordRange = idx >= 0 ? wordLines[idx] : wordLines[Math.max(0, ~idx - 1)];
                let blockDistance = ranges.length;
                for (const range of ranges){
                    if (!(0, _rangeJs.Range).containsRange(range.range, bestWordRange)) break;
                    blockDistance -= 1;
                }
                return blockDistance;
            }
        };
    }
}

},{"../../../../base/common/arrays.js":"DECei","../../../common/core/range.js":"jmUPh","../../smartSelect/browser/bracketSelections.js":"9vFwf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9vFwf":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BracketSelectionRangeProvider", ()=>BracketSelectionRangeProvider);
var _linkedListJs = require("../../../../base/common/linkedList.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
class BracketSelectionRangeProvider {
    async provideSelectionRanges(model, positions) {
        const result = [];
        for (const position of positions){
            const bucket = [];
            result.push(bucket);
            const ranges = new Map();
            await new Promise((resolve)=>BracketSelectionRangeProvider._bracketsRightYield(resolve, 0, model, position, ranges));
            await new Promise((resolve)=>BracketSelectionRangeProvider._bracketsLeftYield(resolve, 0, model, position, ranges, bucket));
        }
        return result;
    }
    static{
        this._maxDuration = 30;
    }
    static{
        this._maxRounds = 2;
    }
    static _bracketsRightYield(resolve, round, model, pos, ranges) {
        const counts = new Map();
        const t1 = Date.now();
        while(true){
            if (round >= BracketSelectionRangeProvider._maxRounds) {
                resolve();
                break;
            }
            if (!pos) {
                resolve();
                break;
            }
            const bracket = model.bracketPairs.findNextBracket(pos);
            if (!bracket) {
                resolve();
                break;
            }
            const d = Date.now() - t1;
            if (d > BracketSelectionRangeProvider._maxDuration) {
                setTimeout(()=>BracketSelectionRangeProvider._bracketsRightYield(resolve, round + 1, model, pos, ranges));
                break;
            }
            if (bracket.bracketInfo.isOpeningBracket) {
                const key = bracket.bracketInfo.bracketText;
                // wait for closing
                const val = counts.has(key) ? counts.get(key) : 0;
                counts.set(key, val + 1);
            } else {
                const key = bracket.bracketInfo.getOpeningBrackets()[0].bracketText;
                // process closing
                let val = counts.has(key) ? counts.get(key) : 0;
                val -= 1;
                counts.set(key, Math.max(0, val));
                if (val < 0) {
                    let list = ranges.get(key);
                    if (!list) {
                        list = new (0, _linkedListJs.LinkedList)();
                        ranges.set(key, list);
                    }
                    list.push(bracket.range);
                }
            }
            pos = bracket.range.getEndPosition();
        }
    }
    static _bracketsLeftYield(resolve, round, model, pos, ranges, bucket) {
        const counts = new Map();
        const t1 = Date.now();
        while(true){
            if (round >= BracketSelectionRangeProvider._maxRounds && ranges.size === 0) {
                resolve();
                break;
            }
            if (!pos) {
                resolve();
                break;
            }
            const bracket = model.bracketPairs.findPrevBracket(pos);
            if (!bracket) {
                resolve();
                break;
            }
            const d = Date.now() - t1;
            if (d > BracketSelectionRangeProvider._maxDuration) {
                setTimeout(()=>BracketSelectionRangeProvider._bracketsLeftYield(resolve, round + 1, model, pos, ranges, bucket));
                break;
            }
            if (!bracket.bracketInfo.isOpeningBracket) {
                const key = bracket.bracketInfo.getOpeningBrackets()[0].bracketText;
                // wait for opening
                const val = counts.has(key) ? counts.get(key) : 0;
                counts.set(key, val + 1);
            } else {
                const key = bracket.bracketInfo.bracketText;
                // opening
                let val = counts.has(key) ? counts.get(key) : 0;
                val -= 1;
                counts.set(key, Math.max(0, val));
                if (val < 0) {
                    const list = ranges.get(key);
                    if (list) {
                        const closing = list.shift();
                        if (list.size === 0) ranges.delete(key);
                        const innerBracket = (0, _rangeJs.Range).fromPositions(bracket.range.getEndPosition(), closing.getStartPosition());
                        const outerBracket = (0, _rangeJs.Range).fromPositions(bracket.range.getStartPosition(), closing.getEndPosition());
                        bucket.push({
                            range: innerBracket
                        });
                        bucket.push({
                            range: outerBracket
                        });
                        BracketSelectionRangeProvider._addBracketLeading(model, outerBracket, bucket);
                    }
                }
            }
            pos = bracket.range.getStartPosition();
        }
    }
    static _addBracketLeading(model, bracket, bucket) {
        if (bracket.startLineNumber === bracket.endLineNumber) return;
        // xxxxxxxx {
        //
        // }
        const startLine = bracket.startLineNumber;
        const column = model.getLineFirstNonWhitespaceColumn(startLine);
        if (column !== 0 && column !== bracket.startColumn) {
            bucket.push({
                range: (0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(startLine, column), bracket.getEndPosition())
            });
            bucket.push({
                range: (0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(startLine, 1), bracket.getEndPosition())
            });
        }
        // xxxxxxxx
        // {
        //
        // }
        const aboveLine = startLine - 1;
        if (aboveLine > 0) {
            const column = model.getLineFirstNonWhitespaceColumn(aboveLine);
            if (column === bracket.startColumn && column !== model.getLineLastNonWhitespaceColumn(aboveLine)) {
                bucket.push({
                    range: (0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(aboveLine, column), bracket.getEndPosition())
                });
                bucket.push({
                    range: (0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(aboveLine, 1), bracket.getEndPosition())
                });
            }
        }
    }
}

},{"../../../../base/common/linkedList.js":"kv7Rg","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"apYwy":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineContext", ()=>LineContext);
/**
 * Sorted, filtered completion view model
 * */ parcelHelpers.export(exports, "CompletionModel", ()=>CompletionModel);
var _arraysJs = require("../../../../base/common/arrays.js");
var _filtersJs = require("../../../../base/common/filters.js");
var _stringsJs = require("../../../../base/common/strings.js");
class LineContext {
    constructor(leadingLineContent, characterCountDelta){
        this.leadingLineContent = leadingLineContent;
        this.characterCountDelta = characterCountDelta;
    }
}
class CompletionModel {
    constructor(items, column, lineContext, wordDistance, options, snippetSuggestions, fuzzyScoreOptions = (0, _filtersJs.FuzzyScoreOptions).default, clipboardText){
        this.clipboardText = clipboardText;
        this._snippetCompareFn = CompletionModel._compareCompletionItems;
        this._items = items;
        this._column = column;
        this._wordDistance = wordDistance;
        this._options = options;
        this._refilterKind = 1 /* Refilter.All */ ;
        this._lineContext = lineContext;
        this._fuzzyScoreOptions = fuzzyScoreOptions;
        if (snippetSuggestions === "top") this._snippetCompareFn = CompletionModel._compareCompletionItemsSnippetsUp;
        else if (snippetSuggestions === "bottom") this._snippetCompareFn = CompletionModel._compareCompletionItemsSnippetsDown;
    }
    get lineContext() {
        return this._lineContext;
    }
    set lineContext(value) {
        if (this._lineContext.leadingLineContent !== value.leadingLineContent || this._lineContext.characterCountDelta !== value.characterCountDelta) {
            this._refilterKind = this._lineContext.characterCountDelta < value.characterCountDelta && this._filteredItems ? 2 /* Refilter.Incr */  : 1 /* Refilter.All */ ;
            this._lineContext = value;
        }
    }
    get items() {
        this._ensureCachedState();
        return this._filteredItems;
    }
    getItemsByProvider() {
        this._ensureCachedState();
        return this._itemsByProvider;
    }
    getIncompleteProvider() {
        this._ensureCachedState();
        const result = new Set();
        for (const [provider, items] of this.getItemsByProvider())if (items.length > 0 && items[0].container.incomplete) result.add(provider);
        return result;
    }
    get stats() {
        this._ensureCachedState();
        return this._stats;
    }
    _ensureCachedState() {
        if (this._refilterKind !== 0 /* Refilter.Nothing */ ) this._createCachedState();
    }
    _createCachedState() {
        this._itemsByProvider = new Map();
        const labelLengths = [];
        const { leadingLineContent, characterCountDelta } = this._lineContext;
        let word = "";
        let wordLow = "";
        // incrementally filter less
        const source = this._refilterKind === 1 /* Refilter.All */  ? this._items : this._filteredItems;
        const target = [];
        // picks a score function based on the number of
        // items that we have to score/filter and based on the
        // user-configuration
        const scoreFn = !this._options.filterGraceful || source.length > 2000 ? (0, _filtersJs.fuzzyScore) : (0, _filtersJs.fuzzyScoreGracefulAggressive);
        for(let i = 0; i < source.length; i++){
            const item = source[i];
            if (item.isInvalid) continue; // SKIP invalid items
            // keep all items by their provider
            const arr = this._itemsByProvider.get(item.provider);
            if (arr) arr.push(item);
            else this._itemsByProvider.set(item.provider, [
                item
            ]);
            // 'word' is that remainder of the current line that we
            // filter and score against. In theory each suggestion uses a
            // different word, but in practice not - that's why we cache
            const overwriteBefore = item.position.column - item.editStart.column;
            const wordLen = overwriteBefore + characterCountDelta - (item.position.column - this._column);
            if (word.length !== wordLen) {
                word = wordLen === 0 ? "" : leadingLineContent.slice(-wordLen);
                wordLow = word.toLowerCase();
            }
            // remember the word against which this item was
            // scored
            item.word = word;
            if (wordLen === 0) // when there is nothing to score against, don't
            // event try to do. Use a const rank and rely on
            // the fallback-sort using the initial sort order.
            // use a score of `-100` because that is out of the
            // bound of values `fuzzyScore` will return
            item.score = (0, _filtersJs.FuzzyScore).Default;
            else {
                // skip word characters that are whitespace until
                // we have hit the replace range (overwriteBefore)
                let wordPos = 0;
                while(wordPos < overwriteBefore){
                    const ch = word.charCodeAt(wordPos);
                    if (ch === 32 /* CharCode.Space */  || ch === 9 /* CharCode.Tab */ ) wordPos += 1;
                    else break;
                }
                if (wordPos >= wordLen) // the wordPos at which scoring starts is the whole word
                // and therefore the same rules as not having a word apply
                item.score = (0, _filtersJs.FuzzyScore).Default;
                else if (typeof item.completion.filterText === "string") {
                    // when there is a `filterText` it must match the `word`.
                    // if it matches we check with the label to compute highlights
                    // and if that doesn't yield a result we have no highlights,
                    // despite having the match
                    const match = scoreFn(word, wordLow, wordPos, item.completion.filterText, item.filterTextLow, 0, this._fuzzyScoreOptions);
                    if (!match) continue; // NO match
                    if ((0, _stringsJs.compareIgnoreCase)(item.completion.filterText, item.textLabel) === 0) // filterText and label are actually the same -> use good highlights
                    item.score = match;
                    else {
                        // re-run the scorer on the label in the hope of a result BUT use the rank
                        // of the filterText-match
                        item.score = (0, _filtersJs.anyScore)(word, wordLow, wordPos, item.textLabel, item.labelLow, 0);
                        item.score[0] = match[0]; // use score from filterText
                    }
                } else {
                    // by default match `word` against the `label`
                    const match = scoreFn(word, wordLow, wordPos, item.textLabel, item.labelLow, 0, this._fuzzyScoreOptions);
                    if (!match) continue; // NO match
                    item.score = match;
                }
            }
            item.idx = i;
            item.distance = this._wordDistance.distance(item.position, item.completion);
            target.push(item);
            // update stats
            labelLengths.push(item.textLabel.length);
        }
        this._filteredItems = target.sort(this._snippetCompareFn);
        this._refilterKind = 0 /* Refilter.Nothing */ ;
        this._stats = {
            pLabelLen: labelLengths.length ? (0, _arraysJs.quickSelect)(labelLengths.length - .85, labelLengths, (a, b)=>a - b) : 0
        };
    }
    static _compareCompletionItems(a, b) {
        if (a.score[0] > b.score[0]) return -1;
        else if (a.score[0] < b.score[0]) return 1;
        else if (a.distance < b.distance) return -1;
        else if (a.distance > b.distance) return 1;
        else if (a.idx < b.idx) return -1;
        else if (a.idx > b.idx) return 1;
        else return 0;
    }
    static _compareCompletionItemsSnippetsDown(a, b) {
        if (a.completion.kind !== b.completion.kind) {
            if (a.completion.kind === 27 /* CompletionItemKind.Snippet */ ) return 1;
            else if (b.completion.kind === 27 /* CompletionItemKind.Snippet */ ) return -1;
        }
        return CompletionModel._compareCompletionItems(a, b);
    }
    static _compareCompletionItemsSnippetsUp(a, b) {
        if (a.completion.kind !== b.completion.kind) {
            if (a.completion.kind === 27 /* CompletionItemKind.Snippet */ ) return -1;
            else if (b.completion.kind === 27 /* CompletionItemKind.Snippet */ ) return 1;
        }
        return CompletionModel._compareCompletionItems(a, b);
    }
}

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/filters.js":"40BGZ","../../../../base/common/strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cG5Ip":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OvertypingCapturer", ()=>OvertypingCapturer);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
class OvertypingCapturer {
    static{
        this._maxSelectionLength = 51200;
    }
    constructor(editor, suggestModel){
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._lastOvertyped = [];
        this._locked = false;
        this._disposables.add(editor.onWillType(()=>{
            if (this._locked || !editor.hasModel()) return;
            const selections = editor.getSelections();
            const selectionsLength = selections.length;
            // Check if it will overtype any selections
            let willOvertype = false;
            for(let i = 0; i < selectionsLength; i++)if (!selections[i].isEmpty()) {
                willOvertype = true;
                break;
            }
            if (!willOvertype) {
                if (this._lastOvertyped.length !== 0) this._lastOvertyped.length = 0;
                return;
            }
            this._lastOvertyped = [];
            const model = editor.getModel();
            for(let i = 0; i < selectionsLength; i++){
                const selection = selections[i];
                // Check for overtyping capturer restrictions
                if (model.getValueLengthInRange(selection) > OvertypingCapturer._maxSelectionLength) return;
                this._lastOvertyped[i] = {
                    value: model.getValueInRange(selection),
                    multiline: selection.startLineNumber !== selection.endLineNumber
                };
            }
        }));
        this._disposables.add(suggestModel.onDidTrigger((e)=>{
            this._locked = true;
        }));
        this._disposables.add(suggestModel.onDidCancel((e)=>{
            this._locked = false;
        }));
    }
    getLastOvertypedInfo(idx) {
        if (idx >= 0 && idx < this._lastOvertyped.length) return this._lastOvertyped[idx];
        return undefined;
    }
    dispose() {
        this._disposables.dispose();
    }
}

},{"../../../../base/common/lifecycle.js":"9kg8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iVklD":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "editorSuggestWidgetSelectedBackground", ()=>editorSuggestWidgetSelectedBackground);
parcelHelpers.export(exports, "SuggestWidget", ()=>SuggestWidget);
parcelHelpers.export(exports, "SuggestContentWidget", ()=>SuggestContentWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _codiconStylesJs = require("../../../../base/browser/ui/codicons/codiconStyles.js"); // The codicon symbol styles are defined here and must be loaded
var _listWidgetJs = require("../../../../base/browser/ui/list/listWidget.js");
var _asyncJs = require("../../../../base/common/async.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _numbersJs = require("../../../../base/common/numbers.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _suggestCss = require("./media/suggest.css");
var _embeddedCodeEditorWidgetJs = require("../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js");
var _suggestWidgetStatusJs = require("./suggestWidgetStatus.js");
var _symbolIconsJs = require("../../symbolIcons/browser/symbolIcons.js"); // The codicon symbol colors are defined here and must be loaded to get colors
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _storageJs = require("../../../../platform/storage/common/storage.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _themeJs = require("../../../../platform/theme/common/theme.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _resizableJs = require("../../../../base/browser/ui/resizable/resizable.js");
var _suggestJs = require("./suggest.js");
var _suggestWidgetDetailsJs = require("./suggestWidgetDetails.js");
var _suggestWidgetRendererJs = require("./suggestWidgetRenderer.js");
var _defaultStylesJs = require("../../../../platform/theme/browser/defaultStyles.js");
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var SuggestWidget_1;
/**
 * Suggest widget colors
 */ (0, _colorRegistryJs.registerColor)("editorSuggestWidget.background", (0, _colorRegistryJs.editorWidgetBackground), _nlsJs.localize("editorSuggestWidgetBackground", "Background color of the suggest widget."));
(0, _colorRegistryJs.registerColor)("editorSuggestWidget.border", (0, _colorRegistryJs.editorWidgetBorder), _nlsJs.localize("editorSuggestWidgetBorder", "Border color of the suggest widget."));
const editorSuggestWidgetForeground = (0, _colorRegistryJs.registerColor)("editorSuggestWidget.foreground", (0, _colorRegistryJs.editorForeground), _nlsJs.localize("editorSuggestWidgetForeground", "Foreground color of the suggest widget."));
(0, _colorRegistryJs.registerColor)("editorSuggestWidget.selectedForeground", (0, _colorRegistryJs.quickInputListFocusForeground), _nlsJs.localize("editorSuggestWidgetSelectedForeground", "Foreground color of the selected entry in the suggest widget."));
(0, _colorRegistryJs.registerColor)("editorSuggestWidget.selectedIconForeground", (0, _colorRegistryJs.quickInputListFocusIconForeground), _nlsJs.localize("editorSuggestWidgetSelectedIconForeground", "Icon foreground color of the selected entry in the suggest widget."));
const editorSuggestWidgetSelectedBackground = (0, _colorRegistryJs.registerColor)("editorSuggestWidget.selectedBackground", (0, _colorRegistryJs.quickInputListFocusBackground), _nlsJs.localize("editorSuggestWidgetSelectedBackground", "Background color of the selected entry in the suggest widget."));
(0, _colorRegistryJs.registerColor)("editorSuggestWidget.highlightForeground", (0, _colorRegistryJs.listHighlightForeground), _nlsJs.localize("editorSuggestWidgetHighlightForeground", "Color of the match highlights in the suggest widget."));
(0, _colorRegistryJs.registerColor)("editorSuggestWidget.focusHighlightForeground", (0, _colorRegistryJs.listFocusHighlightForeground), _nlsJs.localize("editorSuggestWidgetFocusHighlightForeground", "Color of the match highlights in the suggest widget when an item is focused."));
(0, _colorRegistryJs.registerColor)("editorSuggestWidgetStatus.foreground", (0, _colorRegistryJs.transparent)(editorSuggestWidgetForeground, .5), _nlsJs.localize("editorSuggestWidgetStatusForeground", "Foreground color of the suggest widget status."));
class PersistedWidgetSize {
    constructor(_service, editor){
        this._service = _service;
        this._key = `suggestWidget.size/${editor.getEditorType()}/${editor instanceof (0, _embeddedCodeEditorWidgetJs.EmbeddedCodeEditorWidget)}`;
    }
    restore() {
        const raw = this._service.get(this._key, 0 /* StorageScope.PROFILE */ ) ?? "";
        try {
            const obj = JSON.parse(raw);
            if (_domJs.Dimension.is(obj)) return _domJs.Dimension.lift(obj);
        } catch  {
        // ignore
        }
        return undefined;
    }
    store(size) {
        this._service.store(this._key, JSON.stringify(size), 0 /* StorageScope.PROFILE */ , 1 /* StorageTarget.MACHINE */ );
    }
    reset() {
        this._service.remove(this._key, 0 /* StorageScope.PROFILE */ );
    }
}
let SuggestWidget = class SuggestWidget {
    static{
        SuggestWidget_1 = this;
    }
    static{
        this.LOADING_MESSAGE = _nlsJs.localize("suggestWidget.loading", "Loading...");
    }
    static{
        this.NO_SUGGESTIONS_MESSAGE = _nlsJs.localize("suggestWidget.noSuggestions", "No suggestions.");
    }
    constructor(editor, _storageService, _contextKeyService, _themeService, instantiationService){
        this.editor = editor;
        this._storageService = _storageService;
        this._state = 0 /* State.Hidden */ ;
        this._isAuto = false;
        this._pendingLayout = new (0, _lifecycleJs.MutableDisposable)();
        this._pendingShowDetails = new (0, _lifecycleJs.MutableDisposable)();
        this._ignoreFocusEvents = false;
        this._forceRenderingAbove = false;
        this._explainMode = false;
        this._showTimeout = new (0, _asyncJs.TimeoutTimer)();
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._onDidSelect = new (0, _eventJs.PauseableEmitter)();
        this._onDidFocus = new (0, _eventJs.PauseableEmitter)();
        this._onDidHide = new (0, _eventJs.Emitter)();
        this._onDidShow = new (0, _eventJs.Emitter)();
        this.onDidSelect = this._onDidSelect.event;
        this.onDidFocus = this._onDidFocus.event;
        this.onDidHide = this._onDidHide.event;
        this.onDidShow = this._onDidShow.event;
        this._onDetailsKeydown = new (0, _eventJs.Emitter)();
        this.onDetailsKeyDown = this._onDetailsKeydown.event;
        this.element = new (0, _resizableJs.ResizableHTMLElement)();
        this.element.domNode.classList.add("editor-widget", "suggest-widget");
        this._contentWidget = new SuggestContentWidget(this, editor);
        this._persistedSize = new PersistedWidgetSize(_storageService, editor);
        class ResizeState {
            constructor(persistedSize, currentSize, persistHeight = false, persistWidth = false){
                this.persistedSize = persistedSize;
                this.currentSize = currentSize;
                this.persistHeight = persistHeight;
                this.persistWidth = persistWidth;
            }
        }
        let state;
        this._disposables.add(this.element.onDidWillResize(()=>{
            this._contentWidget.lockPreference();
            state = new ResizeState(this._persistedSize.restore(), this.element.size);
        }));
        this._disposables.add(this.element.onDidResize((e)=>{
            this._resize(e.dimension.width, e.dimension.height);
            if (state) {
                state.persistHeight = state.persistHeight || !!e.north || !!e.south;
                state.persistWidth = state.persistWidth || !!e.east || !!e.west;
            }
            if (!e.done) return;
            if (state) {
                // only store width or height value that have changed and also
                // only store changes that are above a certain threshold
                const { itemHeight, defaultSize } = this.getLayoutInfo();
                const threshold = Math.round(itemHeight / 2);
                let { width, height } = this.element.size;
                if (!state.persistHeight || Math.abs(state.currentSize.height - height) <= threshold) height = state.persistedSize?.height ?? defaultSize.height;
                if (!state.persistWidth || Math.abs(state.currentSize.width - width) <= threshold) width = state.persistedSize?.width ?? defaultSize.width;
                this._persistedSize.store(new _domJs.Dimension(width, height));
            }
            // reset working state
            this._contentWidget.unlockPreference();
            state = undefined;
        }));
        this._messageElement = _domJs.append(this.element.domNode, _domJs.$(".message"));
        this._listElement = _domJs.append(this.element.domNode, _domJs.$(".tree"));
        const details = this._disposables.add(instantiationService.createInstance((0, _suggestWidgetDetailsJs.SuggestDetailsWidget), this.editor));
        details.onDidClose(this.toggleDetails, this, this._disposables);
        this._details = new (0, _suggestWidgetDetailsJs.SuggestDetailsOverlay)(details, this.editor);
        const applyIconStyle = ()=>this.element.domNode.classList.toggle("no-icons", !this.editor.getOption(119 /* EditorOption.suggest */ ).showIcons);
        applyIconStyle();
        const renderer = instantiationService.createInstance((0, _suggestWidgetRendererJs.ItemRenderer), this.editor);
        this._disposables.add(renderer);
        this._disposables.add(renderer.onDidToggleDetails(()=>this.toggleDetails()));
        this._list = new (0, _listWidgetJs.List)("SuggestWidget", this._listElement, {
            getHeight: (_element)=>this.getLayoutInfo().itemHeight,
            getTemplateId: (_element)=>"suggestion"
        }, [
            renderer
        ], {
            alwaysConsumeMouseWheel: true,
            useShadows: false,
            mouseSupport: false,
            multipleSelectionSupport: false,
            accessibilityProvider: {
                getRole: ()=>"option",
                getWidgetAriaLabel: ()=>_nlsJs.localize("suggest", "Suggest"),
                getWidgetRole: ()=>"listbox",
                getAriaLabel: (item)=>{
                    let label = item.textLabel;
                    if (typeof item.completion.label !== "string") {
                        const { detail, description } = item.completion.label;
                        if (detail && description) label = _nlsJs.localize("label.full", "{0} {1}, {2}", label, detail, description);
                        else if (detail) label = _nlsJs.localize("label.detail", "{0} {1}", label, detail);
                        else if (description) label = _nlsJs.localize("label.desc", "{0}, {1}", label, description);
                    }
                    if (!item.isResolved || !this._isDetailsVisible()) return label;
                    const { documentation, detail } = item.completion;
                    const docs = _stringsJs.format("{0}{1}", detail || "", documentation ? typeof documentation === "string" ? documentation : documentation.value : "");
                    return _nlsJs.localize("ariaCurrenttSuggestionReadDetails", "{0}, docs: {1}", label, docs);
                }
            }
        });
        this._list.style((0, _defaultStylesJs.getListStyles)({
            listInactiveFocusBackground: editorSuggestWidgetSelectedBackground,
            listInactiveFocusOutline: (0, _colorRegistryJs.activeContrastBorder)
        }));
        this._status = instantiationService.createInstance((0, _suggestWidgetStatusJs.SuggestWidgetStatus), this.element.domNode, (0, _suggestJs.suggestWidgetStatusbarMenu));
        const applyStatusBarStyle = ()=>this.element.domNode.classList.toggle("with-status-bar", this.editor.getOption(119 /* EditorOption.suggest */ ).showStatusBar);
        applyStatusBarStyle();
        this._disposables.add(_themeService.onDidColorThemeChange((t)=>this._onThemeChange(t)));
        this._onThemeChange(_themeService.getColorTheme());
        this._disposables.add(this._list.onMouseDown((e)=>this._onListMouseDownOrTap(e)));
        this._disposables.add(this._list.onTap((e)=>this._onListMouseDownOrTap(e)));
        this._disposables.add(this._list.onDidChangeSelection((e)=>this._onListSelection(e)));
        this._disposables.add(this._list.onDidChangeFocus((e)=>this._onListFocus(e)));
        this._disposables.add(this.editor.onDidChangeCursorSelection(()=>this._onCursorSelectionChanged()));
        this._disposables.add(this.editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(119 /* EditorOption.suggest */ )) {
                applyStatusBarStyle();
                applyIconStyle();
            }
            if (this._completionModel && (e.hasChanged(50 /* EditorOption.fontInfo */ ) || e.hasChanged(120 /* EditorOption.suggestFontSize */ ) || e.hasChanged(121 /* EditorOption.suggestLineHeight */ ))) this._list.splice(0, this._list.length, this._completionModel.items);
        }));
        this._ctxSuggestWidgetVisible = (0, _suggestJs.Context).Visible.bindTo(_contextKeyService);
        this._ctxSuggestWidgetDetailsVisible = (0, _suggestJs.Context).DetailsVisible.bindTo(_contextKeyService);
        this._ctxSuggestWidgetMultipleSuggestions = (0, _suggestJs.Context).MultipleSuggestions.bindTo(_contextKeyService);
        this._ctxSuggestWidgetHasFocusedSuggestion = (0, _suggestJs.Context).HasFocusedSuggestion.bindTo(_contextKeyService);
        this._disposables.add(_domJs.addStandardDisposableListener(this._details.widget.domNode, "keydown", (e)=>{
            this._onDetailsKeydown.fire(e);
        }));
        this._disposables.add(this.editor.onMouseDown((e)=>this._onEditorMouseDown(e)));
    }
    dispose() {
        this._details.widget.dispose();
        this._details.dispose();
        this._list.dispose();
        this._status.dispose();
        this._disposables.dispose();
        this._loadingTimeout?.dispose();
        this._pendingLayout.dispose();
        this._pendingShowDetails.dispose();
        this._showTimeout.dispose();
        this._contentWidget.dispose();
        this.element.dispose();
    }
    _onEditorMouseDown(mouseEvent) {
        if (this._details.widget.domNode.contains(mouseEvent.target.element)) // Clicking inside details
        this._details.widget.domNode.focus();
        else // Clicking outside details and inside suggest
        if (this.element.domNode.contains(mouseEvent.target.element)) this.editor.focus();
    }
    _onCursorSelectionChanged() {
        if (this._state !== 0 /* State.Hidden */ ) this._contentWidget.layout();
    }
    _onListMouseDownOrTap(e) {
        if (typeof e.element === "undefined" || typeof e.index === "undefined") return;
        // prevent stealing browser focus from the editor
        e.browserEvent.preventDefault();
        e.browserEvent.stopPropagation();
        this._select(e.element, e.index);
    }
    _onListSelection(e) {
        if (e.elements.length) this._select(e.elements[0], e.indexes[0]);
    }
    _select(item, index) {
        const completionModel = this._completionModel;
        if (completionModel) {
            this._onDidSelect.fire({
                item,
                index,
                model: completionModel
            });
            this.editor.focus();
        }
    }
    _onThemeChange(theme) {
        this._details.widget.borderWidth = (0, _themeJs.isHighContrast)(theme.type) ? 2 : 1;
    }
    _onListFocus(e) {
        if (this._ignoreFocusEvents) return;
        if (!e.elements.length) {
            if (this._currentSuggestionDetails) {
                this._currentSuggestionDetails.cancel();
                this._currentSuggestionDetails = undefined;
                this._focusedItem = undefined;
            }
            this.editor.setAriaOptions({
                activeDescendant: undefined
            });
            this._ctxSuggestWidgetHasFocusedSuggestion.set(false);
            return;
        }
        if (!this._completionModel) return;
        this._ctxSuggestWidgetHasFocusedSuggestion.set(true);
        const item = e.elements[0];
        const index = e.indexes[0];
        if (item !== this._focusedItem) {
            this._currentSuggestionDetails?.cancel();
            this._currentSuggestionDetails = undefined;
            this._focusedItem = item;
            this._list.reveal(index);
            this._currentSuggestionDetails = (0, _asyncJs.createCancelablePromise)(async (token)=>{
                const loading = (0, _asyncJs.disposableTimeout)(()=>{
                    if (this._isDetailsVisible()) this.showDetails(true);
                }, 250);
                const sub = token.onCancellationRequested(()=>loading.dispose());
                try {
                    return await item.resolve(token);
                } finally{
                    loading.dispose();
                    sub.dispose();
                }
            });
            this._currentSuggestionDetails.then(()=>{
                if (index >= this._list.length || item !== this._list.element(index)) return;
                // item can have extra information, so re-render
                this._ignoreFocusEvents = true;
                this._list.splice(index, 1, [
                    item
                ]);
                this._list.setFocus([
                    index
                ]);
                this._ignoreFocusEvents = false;
                if (this._isDetailsVisible()) this.showDetails(false);
                else this.element.domNode.classList.remove("docs-side");
                this.editor.setAriaOptions({
                    activeDescendant: (0, _suggestWidgetRendererJs.getAriaId)(index)
                });
            }).catch((0, _errorsJs.onUnexpectedError));
        }
        // emit an event
        this._onDidFocus.fire({
            item,
            index,
            model: this._completionModel
        });
    }
    _setState(state) {
        if (this._state === state) return;
        this._state = state;
        this.element.domNode.classList.toggle("frozen", state === 4 /* State.Frozen */ );
        this.element.domNode.classList.remove("message");
        switch(state){
            case 0 /* State.Hidden */ :
                _domJs.hide(this._messageElement, this._listElement, this._status.element);
                this._details.hide(true);
                this._status.hide();
                this._contentWidget.hide();
                this._ctxSuggestWidgetVisible.reset();
                this._ctxSuggestWidgetMultipleSuggestions.reset();
                this._ctxSuggestWidgetHasFocusedSuggestion.reset();
                this._showTimeout.cancel();
                this.element.domNode.classList.remove("visible");
                this._list.splice(0, this._list.length);
                this._focusedItem = undefined;
                this._cappedHeight = undefined;
                this._explainMode = false;
                break;
            case 1 /* State.Loading */ :
                this.element.domNode.classList.add("message");
                this._messageElement.textContent = SuggestWidget_1.LOADING_MESSAGE;
                _domJs.hide(this._listElement, this._status.element);
                _domJs.show(this._messageElement);
                this._details.hide();
                this._show();
                this._focusedItem = undefined;
                (0, _ariaJs.status)(SuggestWidget_1.LOADING_MESSAGE);
                break;
            case 2 /* State.Empty */ :
                this.element.domNode.classList.add("message");
                this._messageElement.textContent = SuggestWidget_1.NO_SUGGESTIONS_MESSAGE;
                _domJs.hide(this._listElement, this._status.element);
                _domJs.show(this._messageElement);
                this._details.hide();
                this._show();
                this._focusedItem = undefined;
                (0, _ariaJs.status)(SuggestWidget_1.NO_SUGGESTIONS_MESSAGE);
                break;
            case 3 /* State.Open */ :
                _domJs.hide(this._messageElement);
                _domJs.show(this._listElement, this._status.element);
                this._show();
                break;
            case 4 /* State.Frozen */ :
                _domJs.hide(this._messageElement);
                _domJs.show(this._listElement, this._status.element);
                this._show();
                break;
            case 5 /* State.Details */ :
                _domJs.hide(this._messageElement);
                _domJs.show(this._listElement, this._status.element);
                this._details.show();
                this._show();
                break;
        }
    }
    _show() {
        this._status.show();
        this._contentWidget.show();
        this._layout(this._persistedSize.restore());
        this._ctxSuggestWidgetVisible.set(true);
        this._showTimeout.cancelAndSet(()=>{
            this.element.domNode.classList.add("visible");
            this._onDidShow.fire(this);
        }, 100);
    }
    showTriggered(auto, delay) {
        if (this._state !== 0 /* State.Hidden */ ) return;
        this._contentWidget.setPosition(this.editor.getPosition());
        this._isAuto = !!auto;
        if (!this._isAuto) this._loadingTimeout = (0, _asyncJs.disposableTimeout)(()=>this._setState(1 /* State.Loading */ ), delay);
    }
    showSuggestions(completionModel, selectionIndex, isFrozen, isAuto, noFocus) {
        this._contentWidget.setPosition(this.editor.getPosition());
        this._loadingTimeout?.dispose();
        this._currentSuggestionDetails?.cancel();
        this._currentSuggestionDetails = undefined;
        if (this._completionModel !== completionModel) this._completionModel = completionModel;
        if (isFrozen && this._state !== 2 /* State.Empty */  && this._state !== 0 /* State.Hidden */ ) {
            this._setState(4 /* State.Frozen */ );
            return;
        }
        const visibleCount = this._completionModel.items.length;
        const isEmpty = visibleCount === 0;
        this._ctxSuggestWidgetMultipleSuggestions.set(visibleCount > 1);
        if (isEmpty) {
            this._setState(isAuto ? 0 /* State.Hidden */  : 2 /* State.Empty */ );
            this._completionModel = undefined;
            return;
        }
        this._focusedItem = undefined;
        // calling list.splice triggers focus event which this widget forwards. That can lead to
        // suggestions being cancelled and the widget being cleared (and hidden). All this happens
        // before revealing and focusing is done which means revealing and focusing will fail when
        // they get run.
        this._onDidFocus.pause();
        this._onDidSelect.pause();
        try {
            this._list.splice(0, this._list.length, this._completionModel.items);
            this._setState(isFrozen ? 4 /* State.Frozen */  : 3 /* State.Open */ );
            this._list.reveal(selectionIndex, 0);
            this._list.setFocus(noFocus ? [] : [
                selectionIndex
            ]);
        } finally{
            this._onDidFocus.resume();
            this._onDidSelect.resume();
        }
        this._pendingLayout.value = _domJs.runAtThisOrScheduleAtNextAnimationFrame(_domJs.getWindow(this.element.domNode), ()=>{
            this._pendingLayout.clear();
            this._layout(this.element.size);
            // Reset focus border
            this._details.widget.domNode.classList.remove("focused");
        });
    }
    focusSelected() {
        if (this._list.length > 0) this._list.setFocus([
            0
        ]);
    }
    selectNextPage() {
        switch(this._state){
            case 0 /* State.Hidden */ :
                return false;
            case 5 /* State.Details */ :
                this._details.widget.pageDown();
                return true;
            case 1 /* State.Loading */ :
                return !this._isAuto;
            default:
                this._list.focusNextPage();
                return true;
        }
    }
    selectNext() {
        switch(this._state){
            case 0 /* State.Hidden */ :
                return false;
            case 1 /* State.Loading */ :
                return !this._isAuto;
            default:
                this._list.focusNext(1, true);
                return true;
        }
    }
    selectLast() {
        switch(this._state){
            case 0 /* State.Hidden */ :
                return false;
            case 5 /* State.Details */ :
                this._details.widget.scrollBottom();
                return true;
            case 1 /* State.Loading */ :
                return !this._isAuto;
            default:
                this._list.focusLast();
                return true;
        }
    }
    selectPreviousPage() {
        switch(this._state){
            case 0 /* State.Hidden */ :
                return false;
            case 5 /* State.Details */ :
                this._details.widget.pageUp();
                return true;
            case 1 /* State.Loading */ :
                return !this._isAuto;
            default:
                this._list.focusPreviousPage();
                return true;
        }
    }
    selectPrevious() {
        switch(this._state){
            case 0 /* State.Hidden */ :
                return false;
            case 1 /* State.Loading */ :
                return !this._isAuto;
            default:
                this._list.focusPrevious(1, true);
                return false;
        }
    }
    selectFirst() {
        switch(this._state){
            case 0 /* State.Hidden */ :
                return false;
            case 5 /* State.Details */ :
                this._details.widget.scrollTop();
                return true;
            case 1 /* State.Loading */ :
                return !this._isAuto;
            default:
                this._list.focusFirst();
                return true;
        }
    }
    getFocusedItem() {
        if (this._state !== 0 /* State.Hidden */  && this._state !== 2 /* State.Empty */  && this._state !== 1 /* State.Loading */  && this._completionModel && this._list.getFocus().length > 0) return {
            item: this._list.getFocusedElements()[0],
            index: this._list.getFocus()[0],
            model: this._completionModel
        };
        return undefined;
    }
    toggleDetailsFocus() {
        if (this._state === 5 /* State.Details */ ) {
            this._setState(3 /* State.Open */ );
            this._details.widget.domNode.classList.remove("focused");
        } else if (this._state === 3 /* State.Open */  && this._isDetailsVisible()) {
            this._setState(5 /* State.Details */ );
            this._details.widget.domNode.classList.add("focused");
        }
    }
    toggleDetails() {
        if (this._isDetailsVisible()) {
            // hide details widget
            this._pendingShowDetails.clear();
            this._ctxSuggestWidgetDetailsVisible.set(false);
            this._setDetailsVisible(false);
            this._details.hide();
            this.element.domNode.classList.remove("shows-details");
        } else if (((0, _suggestWidgetDetailsJs.canExpandCompletionItem)(this._list.getFocusedElements()[0]) || this._explainMode) && (this._state === 3 /* State.Open */  || this._state === 5 /* State.Details */  || this._state === 4 /* State.Frozen */ )) {
            // show details widget (iff possible)
            this._ctxSuggestWidgetDetailsVisible.set(true);
            this._setDetailsVisible(true);
            this.showDetails(false);
        }
    }
    showDetails(loading) {
        this._pendingShowDetails.value = _domJs.runAtThisOrScheduleAtNextAnimationFrame(_domJs.getWindow(this.element.domNode), ()=>{
            this._pendingShowDetails.clear();
            this._details.show();
            if (loading) this._details.widget.renderLoading();
            else this._details.widget.renderItem(this._list.getFocusedElements()[0], this._explainMode);
            if (!this._details.widget.isEmpty) {
                this._positionDetails();
                this.element.domNode.classList.add("shows-details");
            } else this._details.hide();
            this.editor.focus();
        });
    }
    toggleExplainMode() {
        if (this._list.getFocusedElements()[0]) {
            this._explainMode = !this._explainMode;
            if (!this._isDetailsVisible()) this.toggleDetails();
            else this.showDetails(false);
        }
    }
    resetPersistedSize() {
        this._persistedSize.reset();
    }
    hideWidget() {
        this._pendingLayout.clear();
        this._pendingShowDetails.clear();
        this._loadingTimeout?.dispose();
        this._setState(0 /* State.Hidden */ );
        this._onDidHide.fire(this);
        this.element.clearSashHoverState();
        // ensure that a reasonable widget height is persisted so that
        // accidential "resize-to-single-items" cases aren't happening
        const dim = this._persistedSize.restore();
        const minPersistedHeight = Math.ceil(this.getLayoutInfo().itemHeight * 4.3);
        if (dim && dim.height < minPersistedHeight) this._persistedSize.store(dim.with(undefined, minPersistedHeight));
    }
    isFrozen() {
        return this._state === 4 /* State.Frozen */ ;
    }
    _afterRender(position) {
        if (position === null) {
            if (this._isDetailsVisible()) this._details.hide(); //todo@jrieken soft-hide
            return;
        }
        if (this._state === 2 /* State.Empty */  || this._state === 1 /* State.Loading */ ) // no special positioning when widget isn't showing list
        return;
        if (this._isDetailsVisible() && !this._details.widget.isEmpty) this._details.show();
        this._positionDetails();
    }
    _layout(size) {
        if (!this.editor.hasModel()) return;
        if (!this.editor.getDomNode()) // happens when running tests
        return;
        const bodyBox = _domJs.getClientArea(this.element.domNode.ownerDocument.body);
        const info = this.getLayoutInfo();
        if (!size) size = info.defaultSize;
        let height = size.height;
        let width = size.width;
        // status bar
        this._status.element.style.height = `${info.itemHeight}px`;
        if (this._state === 2 /* State.Empty */  || this._state === 1 /* State.Loading */ ) {
            // showing a message only
            height = info.itemHeight + info.borderHeight;
            width = info.defaultSize.width / 2;
            this.element.enableSashes(false, false, false, false);
            this.element.minSize = this.element.maxSize = new _domJs.Dimension(width, height);
            this._contentWidget.setPreference(2 /* ContentWidgetPositionPreference.BELOW */ );
        } else {
            // showing items
            // width math
            const maxWidth = bodyBox.width - info.borderHeight - 2 * info.horizontalPadding;
            if (width > maxWidth) width = maxWidth;
            const preferredWidth = this._completionModel ? this._completionModel.stats.pLabelLen * info.typicalHalfwidthCharacterWidth : width;
            // height math
            const fullHeight = info.statusBarHeight + this._list.contentHeight + info.borderHeight;
            const minHeight = info.itemHeight + info.statusBarHeight;
            const editorBox = _domJs.getDomNodePagePosition(this.editor.getDomNode());
            const cursorBox = this.editor.getScrolledVisiblePosition(this.editor.getPosition());
            const cursorBottom = editorBox.top + cursorBox.top + cursorBox.height;
            const maxHeightBelow = Math.min(bodyBox.height - cursorBottom - info.verticalPadding, fullHeight);
            const availableSpaceAbove = editorBox.top + cursorBox.top - info.verticalPadding;
            const maxHeightAbove = Math.min(availableSpaceAbove, fullHeight);
            let maxHeight = Math.min(Math.max(maxHeightAbove, maxHeightBelow) + info.borderHeight, fullHeight);
            if (height === this._cappedHeight?.capped) // Restore the old (wanted) height when the current
            // height is capped to fit
            height = this._cappedHeight.wanted;
            if (height < minHeight) height = minHeight;
            if (height > maxHeight) height = maxHeight;
            const forceRenderingAboveRequiredSpace = 150;
            if (height > maxHeightBelow || this._forceRenderingAbove && availableSpaceAbove > forceRenderingAboveRequiredSpace) {
                this._contentWidget.setPreference(1 /* ContentWidgetPositionPreference.ABOVE */ );
                this.element.enableSashes(true, true, false, false);
                maxHeight = maxHeightAbove;
            } else {
                this._contentWidget.setPreference(2 /* ContentWidgetPositionPreference.BELOW */ );
                this.element.enableSashes(false, true, true, false);
                maxHeight = maxHeightBelow;
            }
            this.element.preferredSize = new _domJs.Dimension(preferredWidth, info.defaultSize.height);
            this.element.maxSize = new _domJs.Dimension(maxWidth, maxHeight);
            this.element.minSize = new _domJs.Dimension(220, minHeight);
            // Know when the height was capped to fit and remember
            // the wanted height for later. This is required when going
            // left to widen suggestions.
            this._cappedHeight = height === fullHeight ? {
                wanted: this._cappedHeight?.wanted ?? size.height,
                capped: height
            } : undefined;
        }
        this._resize(width, height);
    }
    _resize(width, height) {
        const { width: maxWidth, height: maxHeight } = this.element.maxSize;
        width = Math.min(maxWidth, width);
        height = Math.min(maxHeight, height);
        const { statusBarHeight } = this.getLayoutInfo();
        this._list.layout(height - statusBarHeight, width);
        this._listElement.style.height = `${height - statusBarHeight}px`;
        this.element.layout(height, width);
        this._contentWidget.layout();
        this._positionDetails();
    }
    _positionDetails() {
        if (this._isDetailsVisible()) this._details.placeAtAnchor(this.element.domNode, this._contentWidget.getPosition()?.preference[0] === 2 /* ContentWidgetPositionPreference.BELOW */ );
    }
    getLayoutInfo() {
        const fontInfo = this.editor.getOption(50 /* EditorOption.fontInfo */ );
        const itemHeight = (0, _numbersJs.clamp)(this.editor.getOption(121 /* EditorOption.suggestLineHeight */ ) || fontInfo.lineHeight, 8, 1000);
        const statusBarHeight = !this.editor.getOption(119 /* EditorOption.suggest */ ).showStatusBar || this._state === 2 /* State.Empty */  || this._state === 1 /* State.Loading */  ? 0 : itemHeight;
        const borderWidth = this._details.widget.borderWidth;
        const borderHeight = 2 * borderWidth;
        return {
            itemHeight,
            statusBarHeight,
            borderWidth,
            borderHeight,
            typicalHalfwidthCharacterWidth: fontInfo.typicalHalfwidthCharacterWidth,
            verticalPadding: 22,
            horizontalPadding: 14,
            defaultSize: new _domJs.Dimension(430, statusBarHeight + 12 * itemHeight + borderHeight)
        };
    }
    _isDetailsVisible() {
        return this._storageService.getBoolean("expandSuggestionDocs", 0 /* StorageScope.PROFILE */ , false);
    }
    _setDetailsVisible(value) {
        this._storageService.store("expandSuggestionDocs", value, 0 /* StorageScope.PROFILE */ , 0 /* StorageTarget.USER */ );
    }
    forceRenderingAbove() {
        if (!this._forceRenderingAbove) {
            this._forceRenderingAbove = true;
            this._layout(this._persistedSize.restore());
        }
    }
    stopForceRenderingAbove() {
        this._forceRenderingAbove = false;
    }
};
SuggestWidget = SuggestWidget_1 = __decorate([
    __param(1, (0, _storageJs.IStorageService)),
    __param(2, (0, _contextkeyJs.IContextKeyService)),
    __param(3, (0, _themeServiceJs.IThemeService)),
    __param(4, (0, _instantiationJs.IInstantiationService))
], SuggestWidget);
class SuggestContentWidget {
    constructor(_widget, _editor){
        this._widget = _widget;
        this._editor = _editor;
        this.allowEditorOverflow = true;
        this.suppressMouseDown = false;
        this._preferenceLocked = false;
        this._added = false;
        this._hidden = false;
    }
    dispose() {
        if (this._added) {
            this._added = false;
            this._editor.removeContentWidget(this);
        }
    }
    getId() {
        return "editor.widget.suggestWidget";
    }
    getDomNode() {
        return this._widget.element.domNode;
    }
    show() {
        this._hidden = false;
        if (!this._added) {
            this._added = true;
            this._editor.addContentWidget(this);
        }
    }
    hide() {
        if (!this._hidden) {
            this._hidden = true;
            this.layout();
        }
    }
    layout() {
        this._editor.layoutContentWidget(this);
    }
    getPosition() {
        if (this._hidden || !this._position || !this._preference) return null;
        return {
            position: this._position,
            preference: [
                this._preference
            ]
        };
    }
    beforeRender() {
        const { height, width } = this._widget.element.size;
        const { borderWidth, horizontalPadding } = this._widget.getLayoutInfo();
        return new _domJs.Dimension(width + 2 * borderWidth + horizontalPadding, height + 2 * borderWidth);
    }
    afterRender(position) {
        this._widget._afterRender(position);
    }
    setPreference(preference) {
        if (!this._preferenceLocked) this._preference = preference;
    }
    lockPreference() {
        this._preferenceLocked = true;
    }
    unlockPreference() {
        this._preferenceLocked = false;
    }
    setPosition(position) {
        this._position = position;
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/codicons/codiconStyles.js":"guMVT","../../../../base/browser/ui/list/listWidget.js":"f6tmg","../../../../base/common/async.js":"4GJc4","../../../../base/common/errors.js":"divX8","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/numbers.js":"diWMG","../../../../base/common/strings.js":"aA9I1","./media/suggest.css":"i7x7j","../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js":"8G1ik","./suggestWidgetStatus.js":"ejIHk","../../symbolIcons/browser/symbolIcons.js":"4yhOw","../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/storage/common/storage.js":"6AhR2","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/theme.js":"gh7Zf","../../../../platform/theme/common/themeService.js":"jMkIC","../../../../base/browser/ui/resizable/resizable.js":"c8k7j","./suggest.js":"8xSUV","./suggestWidgetDetails.js":"5GPjs","./suggestWidgetRenderer.js":"jrXPS","../../../../platform/theme/browser/defaultStyles.js":"4exuA","../../../../base/browser/ui/aria/aria.js":"asrsh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i7x7j":[function() {},{}],"ejIHk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SuggestWidgetStatus", ()=>SuggestWidgetStatus);
var _domJs = require("../../../../base/browser/dom.js");
var _actionbarJs = require("../../../../base/browser/ui/actionbar/actionbar.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _menuEntryActionViewItemJs = require("../../../../platform/actions/browser/menuEntryActionViewItem.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let SuggestWidgetStatus = class SuggestWidgetStatus {
    constructor(container, _menuId, instantiationService, _menuService, _contextKeyService){
        this._menuId = _menuId;
        this._menuService = _menuService;
        this._contextKeyService = _contextKeyService;
        this._menuDisposables = new (0, _lifecycleJs.DisposableStore)();
        this.element = _domJs.append(container, _domJs.$(".suggest-status-bar"));
        const actionViewItemProvider = (action)=>{
            return action instanceof (0, _actionsJs.MenuItemAction) ? instantiationService.createInstance((0, _menuEntryActionViewItemJs.TextOnlyMenuEntryActionViewItem), action, {
                useComma: true
            }) : undefined;
        };
        this._leftActions = new (0, _actionbarJs.ActionBar)(this.element, {
            actionViewItemProvider
        });
        this._rightActions = new (0, _actionbarJs.ActionBar)(this.element, {
            actionViewItemProvider
        });
        this._leftActions.domNode.classList.add("left");
        this._rightActions.domNode.classList.add("right");
    }
    dispose() {
        this._menuDisposables.dispose();
        this._leftActions.dispose();
        this._rightActions.dispose();
        this.element.remove();
    }
    show() {
        const menu = this._menuService.createMenu(this._menuId, this._contextKeyService);
        const renderMenu = ()=>{
            const left = [];
            const right = [];
            for (const [group, actions] of menu.getActions())if (group === "left") left.push(...actions);
            else right.push(...actions);
            this._leftActions.clear();
            this._leftActions.push(left);
            this._rightActions.clear();
            this._rightActions.push(right);
        };
        this._menuDisposables.add(menu.onDidChange(()=>renderMenu()));
        this._menuDisposables.add(menu);
    }
    hide() {
        this._menuDisposables.clear();
    }
};
SuggestWidgetStatus = __decorate([
    __param(2, (0, _instantiationJs.IInstantiationService)),
    __param(3, (0, _actionsJs.IMenuService)),
    __param(4, (0, _contextkeyJs.IContextKeyService))
], SuggestWidgetStatus);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/actionbar/actionbar.js":"5Xmba","../../../../base/common/lifecycle.js":"9kg8d","../../../../platform/actions/browser/menuEntryActionViewItem.js":"evssn","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5GPjs":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canExpandCompletionItem", ()=>canExpandCompletionItem);
parcelHelpers.export(exports, "SuggestDetailsWidget", ()=>SuggestDetailsWidget);
parcelHelpers.export(exports, "SuggestDetailsOverlay", ()=>SuggestDetailsOverlay);
var _domJs = require("../../../../base/browser/dom.js");
var _scrollableElementJs = require("../../../../base/browser/ui/scrollbar/scrollableElement.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _themablesJs = require("../../../../base/common/themables.js");
var _eventJs = require("../../../../base/common/event.js");
var _htmlContentJs = require("../../../../base/common/htmlContent.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _markdownRendererJs = require("../../../browser/widget/markdownRenderer/browser/markdownRenderer.js");
var _resizableJs = require("../../../../base/browser/ui/resizable/resizable.js");
var _nlsJs = require("../../../../nls.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
function canExpandCompletionItem(item) {
    return !!item && Boolean(item.completion.documentation || item.completion.detail && item.completion.detail !== item.completion.label);
}
let SuggestDetailsWidget = class SuggestDetailsWidget {
    constructor(_editor, instaService){
        this._editor = _editor;
        this._onDidClose = new (0, _eventJs.Emitter)();
        this.onDidClose = this._onDidClose.event;
        this._onDidChangeContents = new (0, _eventJs.Emitter)();
        this.onDidChangeContents = this._onDidChangeContents.event;
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._renderDisposeable = new (0, _lifecycleJs.DisposableStore)();
        this._borderWidth = 1;
        this._size = new _domJs.Dimension(330, 0);
        this.domNode = _domJs.$(".suggest-details");
        this.domNode.classList.add("no-docs");
        this._markdownRenderer = instaService.createInstance((0, _markdownRendererJs.MarkdownRenderer), {
            editor: _editor
        });
        this._body = _domJs.$(".body");
        this._scrollbar = new (0, _scrollableElementJs.DomScrollableElement)(this._body, {
            alwaysConsumeMouseWheel: true
        });
        _domJs.append(this.domNode, this._scrollbar.getDomNode());
        this._disposables.add(this._scrollbar);
        this._header = _domJs.append(this._body, _domJs.$(".header"));
        this._close = _domJs.append(this._header, _domJs.$("span" + (0, _themablesJs.ThemeIcon).asCSSSelector((0, _codiconsJs.Codicon).close)));
        this._close.title = _nlsJs.localize("details.close", "Close");
        this._type = _domJs.append(this._header, _domJs.$("p.type"));
        this._docs = _domJs.append(this._body, _domJs.$("p.docs"));
        this._configureFont();
        this._disposables.add(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(50 /* EditorOption.fontInfo */ )) this._configureFont();
        }));
    }
    dispose() {
        this._disposables.dispose();
        this._renderDisposeable.dispose();
    }
    _configureFont() {
        const options = this._editor.getOptions();
        const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
        const fontFamily = fontInfo.getMassagedFontFamily();
        const fontSize = options.get(120 /* EditorOption.suggestFontSize */ ) || fontInfo.fontSize;
        const lineHeight = options.get(121 /* EditorOption.suggestLineHeight */ ) || fontInfo.lineHeight;
        const fontWeight = fontInfo.fontWeight;
        const fontSizePx = `${fontSize}px`;
        const lineHeightPx = `${lineHeight}px`;
        this.domNode.style.fontSize = fontSizePx;
        this.domNode.style.lineHeight = `${lineHeight / fontSize}`;
        this.domNode.style.fontWeight = fontWeight;
        this.domNode.style.fontFeatureSettings = fontInfo.fontFeatureSettings;
        this._type.style.fontFamily = fontFamily;
        this._close.style.height = lineHeightPx;
        this._close.style.width = lineHeightPx;
    }
    getLayoutInfo() {
        const lineHeight = this._editor.getOption(121 /* EditorOption.suggestLineHeight */ ) || this._editor.getOption(50 /* EditorOption.fontInfo */ ).lineHeight;
        const borderWidth = this._borderWidth;
        const borderHeight = borderWidth * 2;
        return {
            lineHeight,
            borderWidth,
            borderHeight,
            verticalPadding: 22,
            horizontalPadding: 14
        };
    }
    renderLoading() {
        this._type.textContent = _nlsJs.localize("loading", "Loading...");
        this._docs.textContent = "";
        this.domNode.classList.remove("no-docs", "no-type");
        this.layout(this.size.width, this.getLayoutInfo().lineHeight * 2);
        this._onDidChangeContents.fire(this);
    }
    renderItem(item, explainMode) {
        this._renderDisposeable.clear();
        let { detail, documentation } = item.completion;
        if (explainMode) {
            let md = "";
            md += `score: ${item.score[0]}\n`;
            md += `prefix: ${item.word ?? "(no prefix)"}\n`;
            md += `word: ${item.completion.filterText ? item.completion.filterText + " (filterText)" : item.textLabel}\n`;
            md += `distance: ${item.distance} (localityBonus-setting)\n`;
            md += `index: ${item.idx}, based on ${item.completion.sortText && `sortText: "${item.completion.sortText}"` || "label"}\n`;
            md += `commit_chars: ${item.completion.commitCharacters?.join("")}\n`;
            documentation = new (0, _htmlContentJs.MarkdownString)().appendCodeblock("empty", md);
            detail = `Provider: ${item.provider._debugDisplayName}`;
        }
        if (!explainMode && !canExpandCompletionItem(item)) {
            this.clearContents();
            return;
        }
        this.domNode.classList.remove("no-docs", "no-type");
        // --- details
        if (detail) {
            const cappedDetail = detail.length > 100000 ? `${detail.substr(0, 100000)}\u{2026}` : detail;
            this._type.textContent = cappedDetail;
            this._type.title = cappedDetail;
            _domJs.show(this._type);
            this._type.classList.toggle("auto-wrap", !/\r?\n^\s+/gmi.test(cappedDetail));
        } else {
            _domJs.clearNode(this._type);
            this._type.title = "";
            _domJs.hide(this._type);
            this.domNode.classList.add("no-type");
        }
        // --- documentation
        _domJs.clearNode(this._docs);
        if (typeof documentation === "string") {
            this._docs.classList.remove("markdown-docs");
            this._docs.textContent = documentation;
        } else if (documentation) {
            this._docs.classList.add("markdown-docs");
            _domJs.clearNode(this._docs);
            const renderedContents = this._markdownRenderer.render(documentation);
            this._docs.appendChild(renderedContents.element);
            this._renderDisposeable.add(renderedContents);
            this._renderDisposeable.add(this._markdownRenderer.onDidRenderAsync(()=>{
                this.layout(this._size.width, this._type.clientHeight + this._docs.clientHeight);
                this._onDidChangeContents.fire(this);
            }));
        }
        this.domNode.style.userSelect = "text";
        this.domNode.tabIndex = -1;
        this._close.onmousedown = (e)=>{
            e.preventDefault();
            e.stopPropagation();
        };
        this._close.onclick = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this._onDidClose.fire();
        };
        this._body.scrollTop = 0;
        this.layout(this._size.width, this._type.clientHeight + this._docs.clientHeight);
        this._onDidChangeContents.fire(this);
    }
    clearContents() {
        this.domNode.classList.add("no-docs");
        this._type.textContent = "";
        this._docs.textContent = "";
    }
    get isEmpty() {
        return this.domNode.classList.contains("no-docs");
    }
    get size() {
        return this._size;
    }
    layout(width, height) {
        const newSize = new _domJs.Dimension(width, height);
        if (!_domJs.Dimension.equals(newSize, this._size)) {
            this._size = newSize;
            _domJs.size(this.domNode, width, height);
        }
        this._scrollbar.scanDomNode();
    }
    scrollDown(much = 8) {
        this._body.scrollTop += much;
    }
    scrollUp(much = 8) {
        this._body.scrollTop -= much;
    }
    scrollTop() {
        this._body.scrollTop = 0;
    }
    scrollBottom() {
        this._body.scrollTop = this._body.scrollHeight;
    }
    pageDown() {
        this.scrollDown(80);
    }
    pageUp() {
        this.scrollUp(80);
    }
    set borderWidth(width) {
        this._borderWidth = width;
    }
    get borderWidth() {
        return this._borderWidth;
    }
};
SuggestDetailsWidget = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService))
], SuggestDetailsWidget);
class SuggestDetailsOverlay {
    constructor(widget, _editor){
        this.widget = widget;
        this._editor = _editor;
        this.allowEditorOverflow = true;
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._added = false;
        this._preferAlignAtTop = true;
        this._resizable = new (0, _resizableJs.ResizableHTMLElement)();
        this._resizable.domNode.classList.add("suggest-details-container");
        this._resizable.domNode.appendChild(widget.domNode);
        this._resizable.enableSashes(false, true, true, false);
        let topLeftNow;
        let sizeNow;
        let deltaTop = 0;
        let deltaLeft = 0;
        this._disposables.add(this._resizable.onDidWillResize(()=>{
            topLeftNow = this._topLeft;
            sizeNow = this._resizable.size;
        }));
        this._disposables.add(this._resizable.onDidResize((e)=>{
            if (topLeftNow && sizeNow) {
                this.widget.layout(e.dimension.width, e.dimension.height);
                let updateTopLeft = false;
                if (e.west) {
                    deltaLeft = sizeNow.width - e.dimension.width;
                    updateTopLeft = true;
                }
                if (e.north) {
                    deltaTop = sizeNow.height - e.dimension.height;
                    updateTopLeft = true;
                }
                if (updateTopLeft) this._applyTopLeft({
                    top: topLeftNow.top + deltaTop,
                    left: topLeftNow.left + deltaLeft
                });
            }
            if (e.done) {
                topLeftNow = undefined;
                sizeNow = undefined;
                deltaTop = 0;
                deltaLeft = 0;
                this._userSize = e.dimension;
            }
        }));
        this._disposables.add(this.widget.onDidChangeContents(()=>{
            if (this._anchorBox) this._placeAtAnchor(this._anchorBox, this._userSize ?? this.widget.size, this._preferAlignAtTop);
        }));
    }
    dispose() {
        this._resizable.dispose();
        this._disposables.dispose();
        this.hide();
    }
    getId() {
        return "suggest.details";
    }
    getDomNode() {
        return this._resizable.domNode;
    }
    getPosition() {
        return this._topLeft ? {
            preference: this._topLeft
        } : null;
    }
    show() {
        if (!this._added) {
            this._editor.addOverlayWidget(this);
            this._added = true;
        }
    }
    hide(sessionEnded = false) {
        this._resizable.clearSashHoverState();
        if (this._added) {
            this._editor.removeOverlayWidget(this);
            this._added = false;
            this._anchorBox = undefined;
            this._topLeft = undefined;
        }
        if (sessionEnded) {
            this._userSize = undefined;
            this.widget.clearContents();
        }
    }
    placeAtAnchor(anchor, preferAlignAtTop) {
        const anchorBox = anchor.getBoundingClientRect();
        this._anchorBox = anchorBox;
        this._preferAlignAtTop = preferAlignAtTop;
        this._placeAtAnchor(this._anchorBox, this._userSize ?? this.widget.size, preferAlignAtTop);
    }
    _placeAtAnchor(anchorBox, size, preferAlignAtTop) {
        const bodyBox = _domJs.getClientArea(this.getDomNode().ownerDocument.body);
        const info = this.widget.getLayoutInfo();
        const defaultMinSize = new _domJs.Dimension(220, 2 * info.lineHeight);
        const defaultTop = anchorBox.top;
        // EAST
        const eastPlacement = function() {
            const width = bodyBox.width - (anchorBox.left + anchorBox.width + info.borderWidth + info.horizontalPadding);
            const left = -info.borderWidth + anchorBox.left + anchorBox.width;
            const maxSizeTop = new _domJs.Dimension(width, bodyBox.height - anchorBox.top - info.borderHeight - info.verticalPadding);
            const maxSizeBottom = maxSizeTop.with(undefined, anchorBox.top + anchorBox.height - info.borderHeight - info.verticalPadding);
            return {
                top: defaultTop,
                left,
                fit: width - size.width,
                maxSizeTop,
                maxSizeBottom,
                minSize: defaultMinSize.with(Math.min(width, defaultMinSize.width))
            };
        }();
        // WEST
        const westPlacement = function() {
            const width = anchorBox.left - info.borderWidth - info.horizontalPadding;
            const left = Math.max(info.horizontalPadding, anchorBox.left - size.width - info.borderWidth);
            const maxSizeTop = new _domJs.Dimension(width, bodyBox.height - anchorBox.top - info.borderHeight - info.verticalPadding);
            const maxSizeBottom = maxSizeTop.with(undefined, anchorBox.top + anchorBox.height - info.borderHeight - info.verticalPadding);
            return {
                top: defaultTop,
                left,
                fit: width - size.width,
                maxSizeTop,
                maxSizeBottom,
                minSize: defaultMinSize.with(Math.min(width, defaultMinSize.width))
            };
        }();
        // SOUTH
        const southPacement = function() {
            const left = anchorBox.left;
            const top = -info.borderWidth + anchorBox.top + anchorBox.height;
            const maxSizeBottom = new _domJs.Dimension(anchorBox.width - info.borderHeight, bodyBox.height - anchorBox.top - anchorBox.height - info.verticalPadding);
            return {
                top,
                left,
                fit: maxSizeBottom.height - size.height,
                maxSizeBottom,
                maxSizeTop: maxSizeBottom,
                minSize: defaultMinSize.with(maxSizeBottom.width)
            };
        }();
        // take first placement that fits or the first with "least bad" fit
        const placements = [
            eastPlacement,
            westPlacement,
            southPacement
        ];
        const placement = placements.find((p)=>p.fit >= 0) ?? placements.sort((a, b)=>b.fit - a.fit)[0];
        // top/bottom placement
        const bottom = anchorBox.top + anchorBox.height - info.borderHeight;
        let alignAtTop;
        let height = size.height;
        const maxHeight = Math.max(placement.maxSizeTop.height, placement.maxSizeBottom.height);
        if (height > maxHeight) height = maxHeight;
        let maxSize;
        if (preferAlignAtTop) {
            if (height <= placement.maxSizeTop.height) {
                alignAtTop = true;
                maxSize = placement.maxSizeTop;
            } else {
                alignAtTop = false;
                maxSize = placement.maxSizeBottom;
            }
        } else if (height <= placement.maxSizeBottom.height) {
            alignAtTop = false;
            maxSize = placement.maxSizeBottom;
        } else {
            alignAtTop = true;
            maxSize = placement.maxSizeTop;
        }
        let { top, left } = placement;
        if (!alignAtTop && height > anchorBox.height) top = bottom - height;
        const editorDomNode = this._editor.getDomNode();
        if (editorDomNode) {
            // get bounding rectangle of the suggest widget relative to the editor
            const editorBoundingBox = editorDomNode.getBoundingClientRect();
            top -= editorBoundingBox.top;
            left -= editorBoundingBox.left;
        }
        this._applyTopLeft({
            left,
            top
        });
        this._resizable.enableSashes(!alignAtTop, placement === eastPlacement, alignAtTop, placement !== eastPlacement);
        this._resizable.minSize = placement.minSize;
        this._resizable.maxSize = maxSize;
        this._resizable.layout(height, Math.min(maxSize.width, size.width));
        this.widget.layout(this._resizable.size.width, this._resizable.size.height);
    }
    _applyTopLeft(topLeft) {
        this._topLeft = topLeft;
        this._editor.layoutOverlayWidget(this);
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/scrollbar/scrollableElement.js":"h1C5l","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/themables.js":"hgyHi","../../../../base/common/event.js":"4Zi8b","../../../../base/common/htmlContent.js":"3Hxzm","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/widget/markdownRenderer/browser/markdownRenderer.js":"34xfZ","../../../../base/browser/ui/resizable/resizable.js":"c8k7j","../../../../nls.js":"l617d","../../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jrXPS":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAriaId", ()=>getAriaId);
parcelHelpers.export(exports, "ItemRenderer", ()=>ItemRenderer);
var _domJs = require("../../../../base/browser/dom.js");
var _iconLabelJs = require("../../../../base/browser/ui/iconLabel/iconLabel.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _themablesJs = require("../../../../base/common/themables.js");
var _eventJs = require("../../../../base/common/event.js");
var _filtersJs = require("../../../../base/common/filters.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _uriJs = require("../../../../base/common/uri.js");
var _languagesJs = require("../../../common/languages.js");
var _getIconClassesJs = require("../../../common/services/getIconClasses.js");
var _modelJs = require("../../../common/services/model.js");
var _languageJs = require("../../../common/languages/language.js");
var _nlsJs = require("../../../../nls.js");
var _filesJs = require("../../../../platform/files/common/files.js");
var _iconRegistryJs = require("../../../../platform/theme/common/iconRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _suggestWidgetDetailsJs = require("./suggestWidgetDetails.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
function getAriaId(index) {
    return `suggest-aria-id:${index}`;
}
const suggestMoreInfoIcon = (0, _iconRegistryJs.registerIcon)("suggest-more-info", (0, _codiconsJs.Codicon).chevronRight, _nlsJs.localize("suggestMoreInfoIcon", "Icon for more information in the suggest widget."));
const _completionItemColor = new class ColorExtractor {
    static{
        this._regexRelaxed = /(#([\da-fA-F]{3}){1,2}|(rgb|hsl)a\(\s*(\d{1,3}%?\s*,\s*){3}(1|0?\.\d+)\)|(rgb|hsl)\(\s*\d{1,3}%?(\s*,\s*\d{1,3}%?){2}\s*\))/;
    }
    static{
        this._regexStrict = new RegExp(`^${ColorExtractor._regexRelaxed.source}$`, "i");
    }
    extract(item, out) {
        if (item.textLabel.match(ColorExtractor._regexStrict)) {
            out[0] = item.textLabel;
            return true;
        }
        if (item.completion.detail && item.completion.detail.match(ColorExtractor._regexStrict)) {
            out[0] = item.completion.detail;
            return true;
        }
        if (item.completion.documentation) {
            const value = typeof item.completion.documentation === "string" ? item.completion.documentation : item.completion.documentation.value;
            const match = ColorExtractor._regexRelaxed.exec(value);
            if (match && (match.index === 0 || match.index + match[0].length === value.length)) {
                out[0] = match[0];
                return true;
            }
        }
        return false;
    }
};
let ItemRenderer = class ItemRenderer {
    constructor(_editor, _modelService, _languageService, _themeService){
        this._editor = _editor;
        this._modelService = _modelService;
        this._languageService = _languageService;
        this._themeService = _themeService;
        this._onDidToggleDetails = new (0, _eventJs.Emitter)();
        this.onDidToggleDetails = this._onDidToggleDetails.event;
        this.templateId = "suggestion";
    }
    dispose() {
        this._onDidToggleDetails.dispose();
    }
    renderTemplate(container) {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        const root = container;
        root.classList.add("show-file-icons");
        const icon = (0, _domJs.append)(container, (0, _domJs.$)(".icon"));
        const colorspan = (0, _domJs.append)(icon, (0, _domJs.$)("span.colorspan"));
        const text = (0, _domJs.append)(container, (0, _domJs.$)(".contents"));
        const main = (0, _domJs.append)(text, (0, _domJs.$)(".main"));
        const iconContainer = (0, _domJs.append)(main, (0, _domJs.$)(".icon-label.codicon"));
        const left = (0, _domJs.append)(main, (0, _domJs.$)("span.left"));
        const right = (0, _domJs.append)(main, (0, _domJs.$)("span.right"));
        const iconLabel = new (0, _iconLabelJs.IconLabel)(left, {
            supportHighlights: true,
            supportIcons: true
        });
        disposables.add(iconLabel);
        const parametersLabel = (0, _domJs.append)(left, (0, _domJs.$)("span.signature-label"));
        const qualifierLabel = (0, _domJs.append)(left, (0, _domJs.$)("span.qualifier-label"));
        const detailsLabel = (0, _domJs.append)(right, (0, _domJs.$)("span.details-label"));
        const readMore = (0, _domJs.append)(right, (0, _domJs.$)("span.readMore" + (0, _themablesJs.ThemeIcon).asCSSSelector(suggestMoreInfoIcon)));
        readMore.title = _nlsJs.localize("readMore", "Read More");
        const configureFont = ()=>{
            const options = this._editor.getOptions();
            const fontInfo = options.get(50 /* EditorOption.fontInfo */ );
            const fontFamily = fontInfo.getMassagedFontFamily();
            const fontFeatureSettings = fontInfo.fontFeatureSettings;
            const fontSize = options.get(120 /* EditorOption.suggestFontSize */ ) || fontInfo.fontSize;
            const lineHeight = options.get(121 /* EditorOption.suggestLineHeight */ ) || fontInfo.lineHeight;
            const fontWeight = fontInfo.fontWeight;
            const letterSpacing = fontInfo.letterSpacing;
            const fontSizePx = `${fontSize}px`;
            const lineHeightPx = `${lineHeight}px`;
            const letterSpacingPx = `${letterSpacing}px`;
            root.style.fontSize = fontSizePx;
            root.style.fontWeight = fontWeight;
            root.style.letterSpacing = letterSpacingPx;
            main.style.fontFamily = fontFamily;
            main.style.fontFeatureSettings = fontFeatureSettings;
            main.style.lineHeight = lineHeightPx;
            icon.style.height = lineHeightPx;
            icon.style.width = lineHeightPx;
            readMore.style.height = lineHeightPx;
            readMore.style.width = lineHeightPx;
        };
        return {
            root,
            left,
            right,
            icon,
            colorspan,
            iconLabel,
            iconContainer,
            parametersLabel,
            qualifierLabel,
            detailsLabel,
            readMore,
            disposables,
            configureFont
        };
    }
    renderElement(element, index, data) {
        data.configureFont();
        const { completion } = element;
        data.root.id = getAriaId(index);
        data.colorspan.style.backgroundColor = "";
        const labelOptions = {
            labelEscapeNewLines: true,
            matches: (0, _filtersJs.createMatches)(element.score)
        };
        const color = [];
        if (completion.kind === 19 /* CompletionItemKind.Color */  && _completionItemColor.extract(element, color)) {
            // special logic for 'color' completion items
            data.icon.className = "icon customcolor";
            data.iconContainer.className = "icon hide";
            data.colorspan.style.backgroundColor = color[0];
        } else if (completion.kind === 20 /* CompletionItemKind.File */  && this._themeService.getFileIconTheme().hasFileIcons) {
            // special logic for 'file' completion items
            data.icon.className = "icon hide";
            data.iconContainer.className = "icon hide";
            const labelClasses = (0, _getIconClassesJs.getIconClasses)(this._modelService, this._languageService, (0, _uriJs.URI).from({
                scheme: "fake",
                path: element.textLabel
            }), (0, _filesJs.FileKind).FILE);
            const detailClasses = (0, _getIconClassesJs.getIconClasses)(this._modelService, this._languageService, (0, _uriJs.URI).from({
                scheme: "fake",
                path: completion.detail
            }), (0, _filesJs.FileKind).FILE);
            labelOptions.extraClasses = labelClasses.length > detailClasses.length ? labelClasses : detailClasses;
        } else if (completion.kind === 23 /* CompletionItemKind.Folder */  && this._themeService.getFileIconTheme().hasFolderIcons) {
            // special logic for 'folder' completion items
            data.icon.className = "icon hide";
            data.iconContainer.className = "icon hide";
            labelOptions.extraClasses = [
                (0, _getIconClassesJs.getIconClasses)(this._modelService, this._languageService, (0, _uriJs.URI).from({
                    scheme: "fake",
                    path: element.textLabel
                }), (0, _filesJs.FileKind).FOLDER),
                (0, _getIconClassesJs.getIconClasses)(this._modelService, this._languageService, (0, _uriJs.URI).from({
                    scheme: "fake",
                    path: completion.detail
                }), (0, _filesJs.FileKind).FOLDER)
            ].flat();
        } else {
            // normal icon
            data.icon.className = "icon hide";
            data.iconContainer.className = "";
            data.iconContainer.classList.add("suggest-icon", ...(0, _themablesJs.ThemeIcon).asClassNameArray((0, _languagesJs.CompletionItemKinds).toIcon(completion.kind)));
        }
        if (completion.tags && completion.tags.indexOf(1 /* CompletionItemTag.Deprecated */ ) >= 0) {
            labelOptions.extraClasses = (labelOptions.extraClasses || []).concat([
                "deprecated"
            ]);
            labelOptions.matches = [];
        }
        data.iconLabel.setLabel(element.textLabel, undefined, labelOptions);
        if (typeof completion.label === "string") {
            data.parametersLabel.textContent = "";
            data.detailsLabel.textContent = stripNewLines(completion.detail || "");
            data.root.classList.add("string-label");
        } else {
            data.parametersLabel.textContent = stripNewLines(completion.label.detail || "");
            data.detailsLabel.textContent = stripNewLines(completion.label.description || "");
            data.root.classList.remove("string-label");
        }
        if (this._editor.getOption(119 /* EditorOption.suggest */ ).showInlineDetails) (0, _domJs.show)(data.detailsLabel);
        else (0, _domJs.hide)(data.detailsLabel);
        if ((0, _suggestWidgetDetailsJs.canExpandCompletionItem)(element)) {
            data.right.classList.add("can-expand-details");
            (0, _domJs.show)(data.readMore);
            data.readMore.onmousedown = (e)=>{
                e.stopPropagation();
                e.preventDefault();
            };
            data.readMore.onclick = (e)=>{
                e.stopPropagation();
                e.preventDefault();
                this._onDidToggleDetails.fire();
            };
        } else {
            data.right.classList.remove("can-expand-details");
            (0, _domJs.hide)(data.readMore);
            data.readMore.onmousedown = null;
            data.readMore.onclick = null;
        }
    }
    disposeTemplate(templateData) {
        templateData.disposables.dispose();
    }
};
ItemRenderer = __decorate([
    __param(1, (0, _modelJs.IModelService)),
    __param(2, (0, _languageJs.ILanguageService)),
    __param(3, (0, _themeServiceJs.IThemeService))
], ItemRenderer);
function stripNewLines(str) {
    return str.replace(/\r\n|\r|\n/g, "");
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/iconLabel/iconLabel.js":"jocWA","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/themables.js":"hgyHi","../../../../base/common/event.js":"4Zi8b","../../../../base/common/filters.js":"40BGZ","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/uri.js":"7qGS3","../../../common/languages.js":"g5n96","../../../common/services/getIconClasses.js":"16a3A","../../../common/services/model.js":"aciVm","../../../common/languages/language.js":"ka2JQ","../../../../nls.js":"l617d","../../../../platform/files/common/files.js":"gyq0R","../../../../platform/theme/common/iconRegistry.js":"bRNEz","../../../../platform/theme/common/themeService.js":"jMkIC","./suggestWidgetDetails.js":"5GPjs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"16a3A":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIconClasses", ()=>getIconClasses);
var _networkJs = require("../../../base/common/network.js");
var _resourcesJs = require("../../../base/common/resources.js");
var _uriJs = require("../../../base/common/uri.js");
var _modesRegistryJs = require("../languages/modesRegistry.js");
var _filesJs = require("../../../platform/files/common/files.js");
var _themablesJs = require("../../../base/common/themables.js");
const fileIconDirectoryRegex = /(?:\/|^)(?:([^\/]+)\/)?([^\/]+)$/;
function getIconClasses(modelService, languageService, resource, fileKind, icon) {
    if ((0, _themablesJs.ThemeIcon).isThemeIcon(icon)) return [
        `codicon-${icon.id}`,
        "predefined-file-icon"
    ];
    if ((0, _uriJs.URI).isUri(icon)) return [];
    // we always set these base classes even if we do not have a path
    const classes = fileKind === (0, _filesJs.FileKind).ROOT_FOLDER ? [
        "rootfolder-icon"
    ] : fileKind === (0, _filesJs.FileKind).FOLDER ? [
        "folder-icon"
    ] : [
        "file-icon"
    ];
    if (resource) {
        // Get the path and name of the resource. For data-URIs, we need to parse specially
        let name;
        if (resource.scheme === (0, _networkJs.Schemas).data) {
            const metadata = (0, _resourcesJs.DataUri).parseMetaData(resource);
            name = metadata.get((0, _resourcesJs.DataUri).META_DATA_LABEL);
        } else {
            const match = resource.path.match(fileIconDirectoryRegex);
            if (match) {
                name = cssEscape(match[2].toLowerCase());
                if (match[1]) classes.push(`${cssEscape(match[1].toLowerCase())}-name-dir-icon`); // parent directory
            } else name = cssEscape(resource.authority.toLowerCase());
        }
        // Root Folders
        if (fileKind === (0, _filesJs.FileKind).ROOT_FOLDER) classes.push(`${name}-root-name-folder-icon`);
        else if (fileKind === (0, _filesJs.FileKind).FOLDER) classes.push(`${name}-name-folder-icon`);
        else {
            // Name & Extension(s)
            if (name) {
                classes.push(`${name}-name-file-icon`);
                classes.push(`name-file-icon`); // extra segment to increase file-name score
                // Avoid doing an explosive combination of extensions for very long filenames
                // (most file systems do not allow files > 255 length) with lots of `.` characters
                // https://github.com/microsoft/vscode/issues/116199
                if (name.length <= 255) {
                    const dotSegments = name.split(".");
                    for(let i = 1; i < dotSegments.length; i++)classes.push(`${dotSegments.slice(i).join(".")}-ext-file-icon`); // add each combination of all found extensions if more than one
                }
                classes.push(`ext-file-icon`); // extra segment to increase file-ext score
            }
            // Detected Mode
            const detectedLanguageId = detectLanguageId(modelService, languageService, resource);
            if (detectedLanguageId) classes.push(`${cssEscape(detectedLanguageId)}-lang-file-icon`);
        }
    }
    return classes;
}
function detectLanguageId(modelService, languageService, resource) {
    if (!resource) return null; // we need a resource at least
    let languageId = null;
    // Data URI: check for encoded metadata
    if (resource.scheme === (0, _networkJs.Schemas).data) {
        const metadata = (0, _resourcesJs.DataUri).parseMetaData(resource);
        const mime = metadata.get((0, _resourcesJs.DataUri).META_DATA_MIME);
        if (mime) languageId = languageService.getLanguageIdByMimeType(mime);
    } else {
        const model = modelService.getModel(resource);
        if (model) languageId = model.getLanguageId();
    }
    // only take if the language id is specific (aka no just plain text)
    if (languageId && languageId !== (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID)) return languageId;
    // otherwise fallback to path based detection
    return languageService.guessLanguageIdByFilepathOrFirstLine(resource);
}
function cssEscape(str) {
    return str.replace(/[\s]/g, "/"); // HTML class names can not contain certain whitespace characters (https://dom.spec.whatwg.org/#interface-domtokenlist), use / instead, which doesn't exist in file names.
}

},{"../../../base/common/network.js":"2c1AD","../../../base/common/resources.js":"700EV","../../../base/common/uri.js":"7qGS3","../languages/modesRegistry.js":"gqkb7","../../../platform/files/common/files.js":"gyq0R","../../../base/common/themables.js":"hgyHi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gyq0R":[function(require,module,exports) {
//#endregion
//#region Utilities
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FileKind", ()=>FileKind);
var FileKind;
(function(FileKind) {
    FileKind[FileKind["FILE"] = 0] = "FILE";
    FileKind[FileKind["FOLDER"] = 1] = "FOLDER";
    FileKind[FileKind["ROOT_FOLDER"] = 2] = "ROOT_FOLDER";
})(FileKind || (FileKind = {})); //#endregion

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hK6o6":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineCompletionsHover", ()=>InlineCompletionsHover);
parcelHelpers.export(exports, "InlineCompletionsHoverParticipant", ()=>InlineCompletionsHoverParticipant);
var _domJs = require("../../../../../base/browser/dom.js");
var _htmlContentJs = require("../../../../../base/common/htmlContent.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../../base/common/observable.js");
var _rangeJs = require("../../../../common/core/range.js");
var _languageJs = require("../../../../common/languages/language.js");
var _hoverTypesJs = require("../../../hover/browser/hoverTypes.js");
var _inlineCompletionsControllerJs = require("../controller/inlineCompletionsController.js");
var _inlineCompletionsHintsWidgetJs = require("./inlineCompletionsHintsWidget.js");
var _markdownRendererJs = require("../../../../browser/widget/markdownRenderer/browser/markdownRenderer.js");
var _nlsJs = require("../../../../../nls.js");
var _accessibilityJs = require("../../../../../platform/accessibility/common/accessibility.js");
var _instantiationJs = require("../../../../../platform/instantiation/common/instantiation.js");
var _openerJs = require("../../../../../platform/opener/common/opener.js");
var _telemetryJs = require("../../../../../platform/telemetry/common/telemetry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class InlineCompletionsHover {
    constructor(owner, range, controller){
        this.owner = owner;
        this.range = range;
        this.controller = controller;
    }
    isValidForHoverAnchor(anchor) {
        return anchor.type === 1 /* HoverAnchorType.Range */  && this.range.startColumn <= anchor.range.startColumn && this.range.endColumn >= anchor.range.endColumn;
    }
}
let InlineCompletionsHoverParticipant = class InlineCompletionsHoverParticipant {
    constructor(_editor, _languageService, _openerService, accessibilityService, _instantiationService, _telemetryService){
        this._editor = _editor;
        this._languageService = _languageService;
        this._openerService = _openerService;
        this.accessibilityService = accessibilityService;
        this._instantiationService = _instantiationService;
        this._telemetryService = _telemetryService;
        this.hoverOrdinal = 4;
    }
    suggestHoverAnchor(mouseEvent) {
        const controller = (0, _inlineCompletionsControllerJs.InlineCompletionsController).get(this._editor);
        if (!controller) return null;
        const target = mouseEvent.target;
        if (target.type === 8 /* MouseTargetType.CONTENT_VIEW_ZONE */ ) {
            // handle the case where the mouse is over the view zone
            const viewZoneData = target.detail;
            if (controller.shouldShowHoverAtViewZone(viewZoneData.viewZoneId)) return new (0, _hoverTypesJs.HoverForeignElementAnchor)(1000, this, (0, _rangeJs.Range).fromPositions(this._editor.getModel().validatePosition(viewZoneData.positionBefore || viewZoneData.position)), mouseEvent.event.posx, mouseEvent.event.posy, false);
        }
        if (target.type === 7 /* MouseTargetType.CONTENT_EMPTY */ ) {
            // handle the case where the mouse is over the empty portion of a line following ghost text
            if (controller.shouldShowHoverAt(target.range)) return new (0, _hoverTypesJs.HoverForeignElementAnchor)(1000, this, target.range, mouseEvent.event.posx, mouseEvent.event.posy, false);
        }
        if (target.type === 6 /* MouseTargetType.CONTENT_TEXT */ ) {
            // handle the case where the mouse is directly over ghost text
            const mightBeForeignElement = target.detail.mightBeForeignElement;
            if (mightBeForeignElement && controller.shouldShowHoverAt(target.range)) return new (0, _hoverTypesJs.HoverForeignElementAnchor)(1000, this, target.range, mouseEvent.event.posx, mouseEvent.event.posy, false);
        }
        return null;
    }
    computeSync(anchor, lineDecorations) {
        if (this._editor.getOption(62 /* EditorOption.inlineSuggest */ ).showToolbar !== "onHover") return [];
        const controller = (0, _inlineCompletionsControllerJs.InlineCompletionsController).get(this._editor);
        if (controller && controller.shouldShowHoverAt(anchor.range)) return [
            new InlineCompletionsHover(this, anchor.range, controller)
        ];
        return [];
    }
    renderHoverParts(context, hoverParts) {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        const part = hoverParts[0];
        this._telemetryService.publicLog2("inlineCompletionHover.shown");
        if (this.accessibilityService.isScreenReaderOptimized() && !this._editor.getOption(8 /* EditorOption.screenReaderAnnounceInlineSuggestion */ )) disposables.add(this.renderScreenReaderText(context, part));
        const model = part.controller.model.get();
        const w = this._instantiationService.createInstance((0, _inlineCompletionsHintsWidgetJs.InlineSuggestionHintsContentWidget), this._editor, false, (0, _observableJs.constObservable)(null), model.selectedInlineCompletionIndex, model.inlineCompletionsCount, model.activeCommands);
        const widgetNode = w.getDomNode();
        context.fragment.appendChild(widgetNode);
        model.triggerExplicitly();
        disposables.add(w);
        const renderedHoverPart = {
            hoverPart: part,
            hoverElement: widgetNode,
            dispose () {
                disposables.dispose();
            }
        };
        return new (0, _hoverTypesJs.RenderedHoverParts)([
            renderedHoverPart
        ]);
    }
    renderScreenReaderText(context, part) {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        const $ = _domJs.$;
        const markdownHoverElement = $("div.hover-row.markdown-hover");
        const hoverContentsElement = _domJs.append(markdownHoverElement, $("div.hover-contents", {
            ["aria-live"]: "assertive"
        }));
        const renderer = disposables.add(new (0, _markdownRendererJs.MarkdownRenderer)({
            editor: this._editor
        }, this._languageService, this._openerService));
        const render = (code)=>{
            disposables.add(renderer.onDidRenderAsync(()=>{
                hoverContentsElement.className = "hover-contents code-hover-contents";
                context.onContentsChanged();
            }));
            const inlineSuggestionAvailable = _nlsJs.localize("inlineSuggestionFollows", "Suggestion:");
            const renderedContents = disposables.add(renderer.render(new (0, _htmlContentJs.MarkdownString)().appendText(inlineSuggestionAvailable).appendCodeblock("text", code)));
            hoverContentsElement.replaceChildren(renderedContents.element);
        };
        disposables.add((0, _observableJs.autorun)((reader)=>{
            /** @description update hover */ const ghostText = part.controller.model.read(reader)?.primaryGhostText.read(reader);
            if (ghostText) {
                const lineText = this._editor.getModel().getLineContent(ghostText.lineNumber);
                render(ghostText.renderForScreenReader(lineText));
            } else _domJs.reset(hoverContentsElement);
        }));
        context.fragment.appendChild(markdownHoverElement);
        return disposables;
    }
};
InlineCompletionsHoverParticipant = __decorate([
    __param(1, (0, _languageJs.ILanguageService)),
    __param(2, (0, _openerJs.IOpenerService)),
    __param(3, (0, _accessibilityJs.IAccessibilityService)),
    __param(4, (0, _instantiationJs.IInstantiationService)),
    __param(5, (0, _telemetryJs.ITelemetryService))
], InlineCompletionsHoverParticipant);

},{"../../../../../base/browser/dom.js":"bnqsM","../../../../../base/common/htmlContent.js":"3Hxzm","../../../../../base/common/lifecycle.js":"9kg8d","../../../../../base/common/observable.js":"2xbG5","../../../../common/core/range.js":"jmUPh","../../../../common/languages/language.js":"ka2JQ","../../../hover/browser/hoverTypes.js":"6vmRi","../controller/inlineCompletionsController.js":"gcSfI","./inlineCompletionsHintsWidget.js":"4zZCT","../../../../browser/widget/markdownRenderer/browser/markdownRenderer.js":"34xfZ","../../../../../nls.js":"l617d","../../../../../platform/accessibility/common/accessibility.js":"9Svqy","../../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../../platform/opener/common/opener.js":"d3tj1","../../../../../platform/telemetry/common/telemetry.js":"7vW8j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iVZLo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineCompletionsAccessibleView", ()=>InlineCompletionsAccessibleView);
class InlineCompletionsAccessibleView {
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"khjwq":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessibleViewRegistry", ()=>AccessibleViewRegistry);
const AccessibleViewRegistry = new class AccessibleViewRegistry {
    constructor(){
        this._implementations = [];
    }
    register(implementation) {
        this._implementations.push(implementation);
        return {
            dispose: ()=>{
                const idx = this._implementations.indexOf(implementation);
                if (idx !== -1) this._implementations.splice(idx, 1);
            }
        };
    }
    getImplementations() {
        return this._implementations;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ATNy":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GotoDefinitionAtPositionEditorContribution", ()=>GotoDefinitionAtPositionEditorContribution);
var _asyncJs = require("../../../../../base/common/async.js");
var _errorsJs = require("../../../../../base/common/errors.js");
var _htmlContentJs = require("../../../../../base/common/htmlContent.js");
var _lifecycleJs = require("../../../../../base/common/lifecycle.js");
var _goToDefinitionAtPositionCss = require("./goToDefinitionAtPosition.css");
var _editorStateJs = require("../../../editorState/browser/editorState.js");
var _editorExtensionsJs = require("../../../../browser/editorExtensions.js");
var _rangeJs = require("../../../../common/core/range.js");
var _languageJs = require("../../../../common/languages/language.js");
var _resolverServiceJs = require("../../../../common/services/resolverService.js");
var _clickLinkGestureJs = require("./clickLinkGesture.js");
var _peekViewJs = require("../../../peekView/browser/peekView.js");
var _nlsJs = require("../../../../../nls.js");
var _contextkeyJs = require("../../../../../platform/contextkey/common/contextkey.js");
var _goToCommandsJs = require("../goToCommands.js");
var _goToSymbolJs = require("../goToSymbol.js");
var _languageFeaturesJs = require("../../../../common/services/languageFeatures.js");
var _textModelJs = require("../../../../common/model/textModel.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var GotoDefinitionAtPositionEditorContribution_1;
let GotoDefinitionAtPositionEditorContribution = class GotoDefinitionAtPositionEditorContribution {
    static{
        GotoDefinitionAtPositionEditorContribution_1 = this;
    }
    static{
        this.ID = "editor.contrib.gotodefinitionatposition";
    }
    static{
        this.MAX_SOURCE_PREVIEW_LINES = 8;
    }
    constructor(editor, textModelResolverService, languageService, languageFeaturesService){
        this.textModelResolverService = textModelResolverService;
        this.languageService = languageService;
        this.languageFeaturesService = languageFeaturesService;
        this.toUnhook = new (0, _lifecycleJs.DisposableStore)();
        this.toUnhookForKeyboard = new (0, _lifecycleJs.DisposableStore)();
        this.currentWordAtPosition = null;
        this.previousPromise = null;
        this.editor = editor;
        this.linkDecorations = this.editor.createDecorationsCollection();
        const linkGesture = new (0, _clickLinkGestureJs.ClickLinkGesture)(editor);
        this.toUnhook.add(linkGesture);
        this.toUnhook.add(linkGesture.onMouseMoveOrRelevantKeyDown(([mouseEvent, keyboardEvent])=>{
            this.startFindDefinitionFromMouse(mouseEvent, keyboardEvent ?? undefined);
        }));
        this.toUnhook.add(linkGesture.onExecute((mouseEvent)=>{
            if (this.isEnabled(mouseEvent)) this.gotoDefinition(mouseEvent.target.position, mouseEvent.hasSideBySideModifier).catch((error)=>{
                (0, _errorsJs.onUnexpectedError)(error);
            }).finally(()=>{
                this.removeLinkDecorations();
            });
        }));
        this.toUnhook.add(linkGesture.onCancel(()=>{
            this.removeLinkDecorations();
            this.currentWordAtPosition = null;
        }));
    }
    static get(editor) {
        return editor.getContribution(GotoDefinitionAtPositionEditorContribution_1.ID);
    }
    async startFindDefinitionFromCursor(position) {
        // For issue: https://github.com/microsoft/vscode/issues/46257
        // equivalent to mouse move with meta/ctrl key
        // First find the definition and add decorations
        // to the editor to be shown with the content hover widget
        await this.startFindDefinition(position);
        // Add listeners for editor cursor move and key down events
        // Dismiss the "extended" editor decorations when the user hides
        // the hover widget. There is no event for the widget itself so these
        // serve as a best effort. After removing the link decorations, the hover
        // widget is clean and will only show declarations per next request.
        this.toUnhookForKeyboard.add(this.editor.onDidChangeCursorPosition(()=>{
            this.currentWordAtPosition = null;
            this.removeLinkDecorations();
            this.toUnhookForKeyboard.clear();
        }));
        this.toUnhookForKeyboard.add(this.editor.onKeyDown((e)=>{
            if (e) {
                this.currentWordAtPosition = null;
                this.removeLinkDecorations();
                this.toUnhookForKeyboard.clear();
            }
        }));
    }
    startFindDefinitionFromMouse(mouseEvent, withKey) {
        // check if we are active and on a content widget
        if (mouseEvent.target.type === 9 /* MouseTargetType.CONTENT_WIDGET */  && this.linkDecorations.length > 0) return;
        if (!this.editor.hasModel() || !this.isEnabled(mouseEvent, withKey)) {
            this.currentWordAtPosition = null;
            this.removeLinkDecorations();
            return;
        }
        const position = mouseEvent.target.position;
        this.startFindDefinition(position);
    }
    async startFindDefinition(position) {
        // Dispose listeners for updating decorations when using keyboard to show definition hover
        this.toUnhookForKeyboard.clear();
        // Find word at mouse position
        const word = position ? this.editor.getModel()?.getWordAtPosition(position) : null;
        if (!word) {
            this.currentWordAtPosition = null;
            this.removeLinkDecorations();
            return;
        }
        // Return early if word at position is still the same
        if (this.currentWordAtPosition && this.currentWordAtPosition.startColumn === word.startColumn && this.currentWordAtPosition.endColumn === word.endColumn && this.currentWordAtPosition.word === word.word) return;
        this.currentWordAtPosition = word;
        // Find definition and decorate word if found
        const state = new (0, _editorStateJs.EditorState)(this.editor, 15 /* CodeEditorStateFlag.Scroll */ );
        if (this.previousPromise) {
            this.previousPromise.cancel();
            this.previousPromise = null;
        }
        this.previousPromise = (0, _asyncJs.createCancelablePromise)((token)=>this.findDefinition(position, token));
        let results;
        try {
            results = await this.previousPromise;
        } catch (error) {
            (0, _errorsJs.onUnexpectedError)(error);
            return;
        }
        if (!results || !results.length || !state.validate(this.editor)) {
            this.removeLinkDecorations();
            return;
        }
        const linkRange = results[0].originSelectionRange ? (0, _rangeJs.Range).lift(results[0].originSelectionRange) : new (0, _rangeJs.Range)(position.lineNumber, word.startColumn, position.lineNumber, word.endColumn);
        // Multiple results
        if (results.length > 1) {
            let combinedRange = linkRange;
            for (const { originSelectionRange } of results)if (originSelectionRange) combinedRange = (0, _rangeJs.Range).plusRange(combinedRange, originSelectionRange);
            this.addDecoration(combinedRange, new (0, _htmlContentJs.MarkdownString)().appendText(_nlsJs.localize("multipleResults", "Click to show {0} definitions.", results.length)));
        } else {
            // Single result
            const result = results[0];
            if (!result.uri) return;
            this.textModelResolverService.createModelReference(result.uri).then((ref)=>{
                if (!ref.object || !ref.object.textEditorModel) {
                    ref.dispose();
                    return;
                }
                const { object: { textEditorModel } } = ref;
                const { startLineNumber } = result.range;
                if (startLineNumber < 1 || startLineNumber > textEditorModel.getLineCount()) {
                    // invalid range
                    ref.dispose();
                    return;
                }
                const previewValue = this.getPreviewValue(textEditorModel, startLineNumber, result);
                const languageId = this.languageService.guessLanguageIdByFilepathOrFirstLine(textEditorModel.uri);
                this.addDecoration(linkRange, previewValue ? new (0, _htmlContentJs.MarkdownString)().appendCodeblock(languageId ? languageId : "", previewValue) : undefined);
                ref.dispose();
            });
        }
    }
    getPreviewValue(textEditorModel, startLineNumber, result) {
        let rangeToUse = result.range;
        const numberOfLinesInRange = rangeToUse.endLineNumber - rangeToUse.startLineNumber;
        if (numberOfLinesInRange >= GotoDefinitionAtPositionEditorContribution_1.MAX_SOURCE_PREVIEW_LINES) rangeToUse = this.getPreviewRangeBasedOnIndentation(textEditorModel, startLineNumber);
        const previewValue = this.stripIndentationFromPreviewRange(textEditorModel, startLineNumber, rangeToUse);
        return previewValue;
    }
    stripIndentationFromPreviewRange(textEditorModel, startLineNumber, previewRange) {
        const startIndent = textEditorModel.getLineFirstNonWhitespaceColumn(startLineNumber);
        let minIndent = startIndent;
        for(let endLineNumber = startLineNumber + 1; endLineNumber < previewRange.endLineNumber; endLineNumber++){
            const endIndent = textEditorModel.getLineFirstNonWhitespaceColumn(endLineNumber);
            minIndent = Math.min(minIndent, endIndent);
        }
        const previewValue = textEditorModel.getValueInRange(previewRange).replace(new RegExp(`^\\s{${minIndent - 1}}`, "gm"), "").trim();
        return previewValue;
    }
    getPreviewRangeBasedOnIndentation(textEditorModel, startLineNumber) {
        const startIndent = textEditorModel.getLineFirstNonWhitespaceColumn(startLineNumber);
        const maxLineNumber = Math.min(textEditorModel.getLineCount(), startLineNumber + GotoDefinitionAtPositionEditorContribution_1.MAX_SOURCE_PREVIEW_LINES);
        let endLineNumber = startLineNumber + 1;
        for(; endLineNumber < maxLineNumber; endLineNumber++){
            const endIndent = textEditorModel.getLineFirstNonWhitespaceColumn(endLineNumber);
            if (startIndent === endIndent) break;
        }
        return new (0, _rangeJs.Range)(startLineNumber, 1, endLineNumber + 1, 1);
    }
    addDecoration(range, hoverMessage) {
        const newDecorations = {
            range: range,
            options: {
                description: "goto-definition-link",
                inlineClassName: "goto-definition-link",
                hoverMessage
            }
        };
        this.linkDecorations.set([
            newDecorations
        ]);
    }
    removeLinkDecorations() {
        this.linkDecorations.clear();
    }
    isEnabled(mouseEvent, withKey) {
        return this.editor.hasModel() && mouseEvent.isLeftClick && mouseEvent.isNoneOrSingleMouseDown && mouseEvent.target.type === 6 /* MouseTargetType.CONTENT_TEXT */  && !(mouseEvent.target.detail.injectedText?.options instanceof (0, _textModelJs.ModelDecorationInjectedTextOptions)) && (mouseEvent.hasTriggerModifier || (withKey ? withKey.keyCodeIsTriggerKey : false)) && this.languageFeaturesService.definitionProvider.has(this.editor.getModel());
    }
    findDefinition(position, token) {
        const model = this.editor.getModel();
        if (!model) return Promise.resolve(null);
        return (0, _goToSymbolJs.getDefinitionsAtPosition)(this.languageFeaturesService.definitionProvider, model, position, false, token);
    }
    gotoDefinition(position, openToSide) {
        this.editor.setPosition(position);
        return this.editor.invokeWithinContext((accessor)=>{
            const canPeek = !openToSide && this.editor.getOption(89 /* EditorOption.definitionLinkOpensInPeek */ ) && !this.isInPeekEditor(accessor);
            const action = new (0, _goToCommandsJs.DefinitionAction)({
                openToSide,
                openInPeek: canPeek,
                muteMessage: true
            }, {
                title: {
                    value: "",
                    original: ""
                },
                id: "",
                precondition: undefined
            });
            return action.run(accessor);
        });
    }
    isInPeekEditor(accessor) {
        const contextKeyService = accessor.get((0, _contextkeyJs.IContextKeyService));
        return (0, _peekViewJs.PeekContext).inPeekEditor.getValue(contextKeyService);
    }
    dispose() {
        this.toUnhook.dispose();
        this.toUnhookForKeyboard.dispose();
    }
};
GotoDefinitionAtPositionEditorContribution = GotoDefinitionAtPositionEditorContribution_1 = __decorate([
    __param(1, (0, _resolverServiceJs.ITextModelService)),
    __param(2, (0, _languageJs.ILanguageService)),
    __param(3, (0, _languageFeaturesJs.ILanguageFeaturesService))
], GotoDefinitionAtPositionEditorContribution);
(0, _editorExtensionsJs.registerEditorContribution)(GotoDefinitionAtPositionEditorContribution.ID, GotoDefinitionAtPositionEditorContribution, 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );

},{"../../../../../base/common/async.js":"4GJc4","../../../../../base/common/errors.js":"divX8","../../../../../base/common/htmlContent.js":"3Hxzm","../../../../../base/common/lifecycle.js":"9kg8d","./goToDefinitionAtPosition.css":"2zFCs","../../../editorState/browser/editorState.js":"hyVHM","../../../../browser/editorExtensions.js":"kC3w6","../../../../common/core/range.js":"jmUPh","../../../../common/languages/language.js":"ka2JQ","../../../../common/services/resolverService.js":"ezAtF","./clickLinkGesture.js":"5rimz","../../../peekView/browser/peekView.js":"jfvYD","../../../../../nls.js":"l617d","../../../../../platform/contextkey/common/contextkey.js":"gXuBD","../goToCommands.js":"jkumD","../goToSymbol.js":"gz1YX","../../../../common/services/languageFeatures.js":"2IAko","../../../../common/model/textModel.js":"9beDe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2zFCs":[function() {},{}],"iqB4x":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkerController", ()=>MarkerController);
parcelHelpers.export(exports, "NextMarkerAction", ()=>NextMarkerAction);
var _codiconsJs = require("../../../../base/common/codicons.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _markerNavigationServiceJs = require("./markerNavigationService.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _iconRegistryJs = require("../../../../platform/theme/common/iconRegistry.js");
var _gotoErrorWidgetJs = require("./gotoErrorWidget.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var MarkerController_1;
let MarkerController = class MarkerController {
    static{
        MarkerController_1 = this;
    }
    static{
        this.ID = "editor.contrib.markerController";
    }
    static get(editor) {
        return editor.getContribution(MarkerController_1.ID);
    }
    constructor(editor, _markerNavigationService, _contextKeyService, _editorService, _instantiationService){
        this._markerNavigationService = _markerNavigationService;
        this._contextKeyService = _contextKeyService;
        this._editorService = _editorService;
        this._instantiationService = _instantiationService;
        this._sessionDispoables = new (0, _lifecycleJs.DisposableStore)();
        this._editor = editor;
        this._widgetVisible = CONTEXT_MARKERS_NAVIGATION_VISIBLE.bindTo(this._contextKeyService);
    }
    dispose() {
        this._cleanUp();
        this._sessionDispoables.dispose();
    }
    _cleanUp() {
        this._widgetVisible.reset();
        this._sessionDispoables.clear();
        this._widget = undefined;
        this._model = undefined;
    }
    _getOrCreateModel(uri) {
        if (this._model && this._model.matches(uri)) return this._model;
        let reusePosition = false;
        if (this._model) {
            reusePosition = true;
            this._cleanUp();
        }
        this._model = this._markerNavigationService.getMarkerList(uri);
        if (reusePosition) this._model.move(true, this._editor.getModel(), this._editor.getPosition());
        this._widget = this._instantiationService.createInstance((0, _gotoErrorWidgetJs.MarkerNavigationWidget), this._editor);
        this._widget.onDidClose(()=>this.close(), this, this._sessionDispoables);
        this._widgetVisible.set(true);
        this._sessionDispoables.add(this._model);
        this._sessionDispoables.add(this._widget);
        // follow cursor
        this._sessionDispoables.add(this._editor.onDidChangeCursorPosition((e)=>{
            if (!this._model?.selected || !(0, _rangeJs.Range).containsPosition(this._model?.selected.marker, e.position)) this._model?.resetIndex();
        }));
        // update markers
        this._sessionDispoables.add(this._model.onDidChange(()=>{
            if (!this._widget || !this._widget.position || !this._model) return;
            const info = this._model.find(this._editor.getModel().uri, this._widget.position);
            if (info) this._widget.updateMarker(info.marker);
            else this._widget.showStale();
        }));
        // open related
        this._sessionDispoables.add(this._widget.onDidSelectRelatedInformation((related)=>{
            this._editorService.openCodeEditor({
                resource: related.resource,
                options: {
                    pinned: true,
                    revealIfOpened: true,
                    selection: (0, _rangeJs.Range).lift(related).collapseToStart()
                }
            }, this._editor);
            this.close(false);
        }));
        this._sessionDispoables.add(this._editor.onDidChangeModel(()=>this._cleanUp()));
        return this._model;
    }
    close(focusEditor = true) {
        this._cleanUp();
        if (focusEditor) this._editor.focus();
    }
    showAtMarker(marker) {
        if (this._editor.hasModel()) {
            const model = this._getOrCreateModel(this._editor.getModel().uri);
            model.resetIndex();
            model.move(true, this._editor.getModel(), new (0, _positionJs.Position)(marker.startLineNumber, marker.startColumn));
            if (model.selected) this._widget.showAtMarker(model.selected.marker, model.selected.index, model.selected.total);
        }
    }
    async nagivate(next, multiFile) {
        if (this._editor.hasModel()) {
            const model = this._getOrCreateModel(multiFile ? undefined : this._editor.getModel().uri);
            model.move(next, this._editor.getModel(), this._editor.getPosition());
            if (!model.selected) return;
            if (model.selected.marker.resource.toString() !== this._editor.getModel().uri.toString()) {
                // show in different editor
                this._cleanUp();
                const otherEditor = await this._editorService.openCodeEditor({
                    resource: model.selected.marker.resource,
                    options: {
                        pinned: false,
                        revealIfOpened: true,
                        selectionRevealType: 2 /* TextEditorSelectionRevealType.NearTop */ ,
                        selection: model.selected.marker
                    }
                }, this._editor);
                if (otherEditor) {
                    MarkerController_1.get(otherEditor)?.close();
                    MarkerController_1.get(otherEditor)?.nagivate(next, multiFile);
                }
            } else // show in this editor
            this._widget.showAtMarker(model.selected.marker, model.selected.index, model.selected.total);
        }
    }
};
MarkerController = MarkerController_1 = __decorate([
    __param(1, (0, _markerNavigationServiceJs.IMarkerNavigationService)),
    __param(2, (0, _contextkeyJs.IContextKeyService)),
    __param(3, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(4, (0, _instantiationJs.IInstantiationService))
], MarkerController);
class MarkerNavigationAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(_next, _multiFile, opts){
        super(opts);
        this._next = _next;
        this._multiFile = _multiFile;
    }
    async run(_accessor, editor) {
        if (editor.hasModel()) MarkerController.get(editor)?.nagivate(this._next, this._multiFile);
    }
}
class NextMarkerAction extends MarkerNavigationAction {
    static{
        this.ID = "editor.action.marker.next";
    }
    static{
        this.LABEL = _nlsJs.localize("markerAction.next.label", "Go to Next Problem (Error, Warning, Info)");
    }
    constructor(){
        super(true, false, {
            id: NextMarkerAction.ID,
            label: NextMarkerAction.LABEL,
            alias: "Go to Next Problem (Error, Warning, Info)",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                primary: 578 /* KeyCode.F8 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _gotoErrorWidgetJs.MarkerNavigationWidget).TitleMenu,
                title: NextMarkerAction.LABEL,
                icon: (0, _iconRegistryJs.registerIcon)("marker-navigation-next", (0, _codiconsJs.Codicon).arrowDown, _nlsJs.localize("nextMarkerIcon", "Icon for goto next marker.")),
                group: "navigation",
                order: 1
            }
        });
    }
}
class PrevMarkerAction extends MarkerNavigationAction {
    static{
        this.ID = "editor.action.marker.prev";
    }
    static{
        this.LABEL = _nlsJs.localize("markerAction.previous.label", "Go to Previous Problem (Error, Warning, Info)");
    }
    constructor(){
        super(false, false, {
            id: PrevMarkerAction.ID,
            label: PrevMarkerAction.LABEL,
            alias: "Go to Previous Problem (Error, Warning, Info)",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                primary: 1602 /* KeyCode.F8 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _gotoErrorWidgetJs.MarkerNavigationWidget).TitleMenu,
                title: PrevMarkerAction.LABEL,
                icon: (0, _iconRegistryJs.registerIcon)("marker-navigation-previous", (0, _codiconsJs.Codicon).arrowUp, _nlsJs.localize("previousMarkerIcon", "Icon for goto previous marker.")),
                group: "navigation",
                order: 2
            }
        });
    }
}
class NextMarkerInFilesAction extends MarkerNavigationAction {
    constructor(){
        super(true, true, {
            id: "editor.action.marker.nextInFiles",
            label: _nlsJs.localize("markerAction.nextInFiles.label", "Go to Next Problem in Files (Error, Warning, Info)"),
            alias: "Go to Next Problem in Files (Error, Warning, Info)",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                primary: 66 /* KeyCode.F8 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarGoMenu,
                title: _nlsJs.localize({
                    key: "miGotoNextProblem",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Next &&Problem"),
                group: "6_problem_nav",
                order: 1
            }
        });
    }
}
class PrevMarkerInFilesAction extends MarkerNavigationAction {
    constructor(){
        super(false, true, {
            id: "editor.action.marker.prevInFiles",
            label: _nlsJs.localize("markerAction.previousInFiles.label", "Go to Previous Problem in Files (Error, Warning, Info)"),
            alias: "Go to Previous Problem in Files (Error, Warning, Info)",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                primary: 1090 /* KeyCode.F8 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarGoMenu,
                title: _nlsJs.localize({
                    key: "miGotoPreviousProblem",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Previous &&Problem"),
                group: "6_problem_nav",
                order: 2
            }
        });
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(MarkerController.ID, MarkerController, 4 /* EditorContributionInstantiation.Lazy */ );
(0, _editorExtensionsJs.registerEditorAction)(NextMarkerAction);
(0, _editorExtensionsJs.registerEditorAction)(PrevMarkerAction);
(0, _editorExtensionsJs.registerEditorAction)(NextMarkerInFilesAction);
(0, _editorExtensionsJs.registerEditorAction)(PrevMarkerInFilesAction);
const CONTEXT_MARKERS_NAVIGATION_VISIBLE = new (0, _contextkeyJs.RawContextKey)("markersNavigationVisible", false);
const MarkerCommand = (0, _editorExtensionsJs.EditorCommand).bindToContribution(MarkerController.get);
(0, _editorExtensionsJs.registerEditorCommand)(new MarkerCommand({
    id: "closeMarkersNavigation",
    precondition: CONTEXT_MARKERS_NAVIGATION_VISIBLE,
    handler: (x)=>x.close(),
    kbOpts: {
        weight: 150,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: 9 /* KeyCode.Escape */ ,
        secondary: [
            1033 /* KeyCode.Escape */ 
        ]
    }
}));

},{"../../../../base/common/codicons.js":"hWYNf","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorExtensions.js":"kC3w6","../../../browser/services/codeEditorService.js":"bOWtl","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/editorContextKeys.js":"5exv9","./markerNavigationService.js":"bv064","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/theme/common/iconRegistry.js":"bRNEz","./gotoErrorWidget.js":"iQggB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bv064":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkerCoordinate", ()=>MarkerCoordinate);
parcelHelpers.export(exports, "MarkerList", ()=>MarkerList);
parcelHelpers.export(exports, "IMarkerNavigationService", ()=>IMarkerNavigationService);
var _arraysJs = require("../../../../base/common/arrays.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _linkedListJs = require("../../../../base/common/linkedList.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _uriJs = require("../../../../base/common/uri.js");
var _rangeJs = require("../../../common/core/range.js");
var _extensionsJs = require("../../../../platform/instantiation/common/extensions.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _markersJs = require("../../../../platform/markers/common/markers.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class MarkerCoordinate {
    constructor(marker, index, total){
        this.marker = marker;
        this.index = index;
        this.total = total;
    }
}
let MarkerList = class MarkerList {
    constructor(resourceFilter, _markerService, _configService){
        this._markerService = _markerService;
        this._configService = _configService;
        this._onDidChange = new (0, _eventJs.Emitter)();
        this.onDidChange = this._onDidChange.event;
        this._dispoables = new (0, _lifecycleJs.DisposableStore)();
        this._markers = [];
        this._nextIdx = -1;
        if ((0, _uriJs.URI).isUri(resourceFilter)) this._resourceFilter = (uri)=>uri.toString() === resourceFilter.toString();
        else if (resourceFilter) this._resourceFilter = resourceFilter;
        const compareOrder = this._configService.getValue("problems.sortOrder");
        const compareMarker = (a, b)=>{
            let res = (0, _stringsJs.compare)(a.resource.toString(), b.resource.toString());
            if (res === 0) {
                if (compareOrder === "position") res = (0, _rangeJs.Range).compareRangesUsingStarts(a, b) || (0, _markersJs.MarkerSeverity).compare(a.severity, b.severity);
                else res = (0, _markersJs.MarkerSeverity).compare(a.severity, b.severity) || (0, _rangeJs.Range).compareRangesUsingStarts(a, b);
            }
            return res;
        };
        const updateMarker = ()=>{
            this._markers = this._markerService.read({
                resource: (0, _uriJs.URI).isUri(resourceFilter) ? resourceFilter : undefined,
                severities: (0, _markersJs.MarkerSeverity).Error | (0, _markersJs.MarkerSeverity).Warning | (0, _markersJs.MarkerSeverity).Info
            });
            if (typeof resourceFilter === "function") this._markers = this._markers.filter((m)=>this._resourceFilter(m.resource));
            this._markers.sort(compareMarker);
        };
        updateMarker();
        this._dispoables.add(_markerService.onMarkerChanged((uris)=>{
            if (!this._resourceFilter || uris.some((uri)=>this._resourceFilter(uri))) {
                updateMarker();
                this._nextIdx = -1;
                this._onDidChange.fire();
            }
        }));
    }
    dispose() {
        this._dispoables.dispose();
        this._onDidChange.dispose();
    }
    matches(uri) {
        if (!this._resourceFilter && !uri) return true;
        if (!this._resourceFilter || !uri) return false;
        return this._resourceFilter(uri);
    }
    get selected() {
        const marker = this._markers[this._nextIdx];
        return marker && new MarkerCoordinate(marker, this._nextIdx + 1, this._markers.length);
    }
    _initIdx(model, position, fwd) {
        let found = false;
        let idx = this._markers.findIndex((marker)=>marker.resource.toString() === model.uri.toString());
        if (idx < 0) {
            idx = (0, _arraysJs.binarySearch)(this._markers, {
                resource: model.uri
            }, (a, b)=>(0, _stringsJs.compare)(a.resource.toString(), b.resource.toString()));
            if (idx < 0) idx = ~idx;
        }
        for(let i = idx; i < this._markers.length; i++){
            let range = (0, _rangeJs.Range).lift(this._markers[i]);
            if (range.isEmpty()) {
                const word = model.getWordAtPosition(range.getStartPosition());
                if (word) range = new (0, _rangeJs.Range)(range.startLineNumber, word.startColumn, range.startLineNumber, word.endColumn);
            }
            if (position && (range.containsPosition(position) || position.isBeforeOrEqual(range.getStartPosition()))) {
                this._nextIdx = i;
                found = true;
                break;
            }
            if (this._markers[i].resource.toString() !== model.uri.toString()) break;
        }
        if (!found) // after the last change
        this._nextIdx = fwd ? 0 : this._markers.length - 1;
        if (this._nextIdx < 0) this._nextIdx = this._markers.length - 1;
    }
    resetIndex() {
        this._nextIdx = -1;
    }
    move(fwd, model, position) {
        if (this._markers.length === 0) return false;
        const oldIdx = this._nextIdx;
        if (this._nextIdx === -1) this._initIdx(model, position, fwd);
        else if (fwd) this._nextIdx = (this._nextIdx + 1) % this._markers.length;
        else if (!fwd) this._nextIdx = (this._nextIdx - 1 + this._markers.length) % this._markers.length;
        if (oldIdx !== this._nextIdx) return true;
        return false;
    }
    find(uri, position) {
        let idx = this._markers.findIndex((marker)=>marker.resource.toString() === uri.toString());
        if (idx < 0) return undefined;
        for(; idx < this._markers.length; idx++){
            if ((0, _rangeJs.Range).containsPosition(this._markers[idx], position)) return new MarkerCoordinate(this._markers[idx], idx + 1, this._markers.length);
        }
        return undefined;
    }
};
MarkerList = __decorate([
    __param(1, (0, _markersJs.IMarkerService)),
    __param(2, (0, _configurationJs.IConfigurationService))
], MarkerList);
const IMarkerNavigationService = (0, _instantiationJs.createDecorator)("IMarkerNavigationService");
let MarkerNavigationService = class MarkerNavigationService {
    constructor(_markerService, _configService){
        this._markerService = _markerService;
        this._configService = _configService;
        this._provider = new (0, _linkedListJs.LinkedList)();
    }
    getMarkerList(resource) {
        for (const provider of this._provider){
            const result = provider.getMarkerList(resource);
            if (result) return result;
        }
        // default
        return new MarkerList(resource, this._markerService, this._configService);
    }
};
MarkerNavigationService = __decorate([
    __param(0, (0, _markersJs.IMarkerService)),
    __param(1, (0, _configurationJs.IConfigurationService))
], MarkerNavigationService);
(0, _extensionsJs.registerSingleton)(IMarkerNavigationService, MarkerNavigationService, 1 /* InstantiationType.Delayed */ );

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/linkedList.js":"kv7Rg","../../../../base/common/strings.js":"aA9I1","../../../../base/common/uri.js":"7qGS3","../../../common/core/range.js":"jmUPh","../../../../platform/instantiation/common/extensions.js":"6WJLq","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/markers/common/markers.js":"aaeXc","../../../../platform/configuration/common/configuration.js":"dXkjq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iQggB":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkerNavigationWidget", ()=>MarkerNavigationWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _scrollableElementJs = require("../../../../base/browser/ui/scrollbar/scrollableElement.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _colorJs = require("../../../../base/common/color.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _resourcesJs = require("../../../../base/common/resources.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _gotoErrorWidgetCss = require("./media/gotoErrorWidget.css");
var _rangeJs = require("../../../common/core/range.js");
var _peekViewJs = require("../../peekView/browser/peekView.js");
var _nlsJs = require("../../../../nls.js");
var _menuEntryActionViewItemJs = require("../../../../platform/actions/browser/menuEntryActionViewItem.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _labelJs = require("../../../../platform/label/common/label.js");
var _markersJs = require("../../../../platform/markers/common/markers.js");
var _openerJs = require("../../../../platform/opener/common/opener.js");
var _severityIconJs = require("../../../../platform/severityIcon/browser/severityIcon.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var MarkerNavigationWidget_1;
class MessageWidget {
    constructor(parent, editor, onRelatedInformation, _openerService, _labelService){
        this._openerService = _openerService;
        this._labelService = _labelService;
        this._lines = 0;
        this._longestLineLength = 0;
        this._relatedDiagnostics = new WeakMap();
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._editor = editor;
        const domNode = document.createElement("div");
        domNode.className = "descriptioncontainer";
        this._messageBlock = document.createElement("div");
        this._messageBlock.classList.add("message");
        this._messageBlock.setAttribute("aria-live", "assertive");
        this._messageBlock.setAttribute("role", "alert");
        domNode.appendChild(this._messageBlock);
        this._relatedBlock = document.createElement("div");
        domNode.appendChild(this._relatedBlock);
        this._disposables.add(_domJs.addStandardDisposableListener(this._relatedBlock, "click", (event)=>{
            event.preventDefault();
            const related = this._relatedDiagnostics.get(event.target);
            if (related) onRelatedInformation(related);
        }));
        this._scrollable = new (0, _scrollableElementJs.ScrollableElement)(domNode, {
            horizontal: 1 /* ScrollbarVisibility.Auto */ ,
            vertical: 1 /* ScrollbarVisibility.Auto */ ,
            useShadows: false,
            horizontalScrollbarSize: 6,
            verticalScrollbarSize: 6
        });
        parent.appendChild(this._scrollable.getDomNode());
        this._disposables.add(this._scrollable.onScroll((e)=>{
            domNode.style.left = `-${e.scrollLeft}px`;
            domNode.style.top = `-${e.scrollTop}px`;
        }));
        this._disposables.add(this._scrollable);
    }
    dispose() {
        (0, _lifecycleJs.dispose)(this._disposables);
    }
    update(marker) {
        const { source, message, relatedInformation, code } = marker;
        let sourceAndCodeLength = (source?.length || 0) + 2;
        if (code) {
            if (typeof code === "string") sourceAndCodeLength += code.length;
            else sourceAndCodeLength += code.value.length;
        }
        const lines = (0, _stringsJs.splitLines)(message);
        this._lines = lines.length;
        this._longestLineLength = 0;
        for (const line of lines)this._longestLineLength = Math.max(line.length + sourceAndCodeLength, this._longestLineLength);
        _domJs.clearNode(this._messageBlock);
        this._messageBlock.setAttribute("aria-label", this.getAriaLabel(marker));
        this._editor.applyFontInfo(this._messageBlock);
        let lastLineElement = this._messageBlock;
        for (const line of lines){
            lastLineElement = document.createElement("div");
            lastLineElement.innerText = line;
            if (line === "") lastLineElement.style.height = this._messageBlock.style.lineHeight;
            this._messageBlock.appendChild(lastLineElement);
        }
        if (source || code) {
            const detailsElement = document.createElement("span");
            detailsElement.classList.add("details");
            lastLineElement.appendChild(detailsElement);
            if (source) {
                const sourceElement = document.createElement("span");
                sourceElement.innerText = source;
                sourceElement.classList.add("source");
                detailsElement.appendChild(sourceElement);
            }
            if (code) {
                if (typeof code === "string") {
                    const codeElement = document.createElement("span");
                    codeElement.innerText = `(${code})`;
                    codeElement.classList.add("code");
                    detailsElement.appendChild(codeElement);
                } else {
                    this._codeLink = _domJs.$("a.code-link");
                    this._codeLink.setAttribute("href", `${code.target.toString()}`);
                    this._codeLink.onclick = (e)=>{
                        this._openerService.open(code.target, {
                            allowCommands: true
                        });
                        e.preventDefault();
                        e.stopPropagation();
                    };
                    const codeElement = _domJs.append(this._codeLink, _domJs.$("span"));
                    codeElement.innerText = code.value;
                    detailsElement.appendChild(this._codeLink);
                }
            }
        }
        _domJs.clearNode(this._relatedBlock);
        this._editor.applyFontInfo(this._relatedBlock);
        if ((0, _arraysJs.isNonEmptyArray)(relatedInformation)) {
            const relatedInformationNode = this._relatedBlock.appendChild(document.createElement("div"));
            relatedInformationNode.style.paddingTop = `${Math.floor(this._editor.getOption(67 /* EditorOption.lineHeight */ ) * 0.66)}px`;
            this._lines += 1;
            for (const related of relatedInformation){
                const container = document.createElement("div");
                const relatedResource = document.createElement("a");
                relatedResource.classList.add("filename");
                relatedResource.innerText = `${this._labelService.getUriBasenameLabel(related.resource)}(${related.startLineNumber}, ${related.startColumn}): `;
                relatedResource.title = this._labelService.getUriLabel(related.resource);
                this._relatedDiagnostics.set(relatedResource, related);
                const relatedMessage = document.createElement("span");
                relatedMessage.innerText = related.message;
                container.appendChild(relatedResource);
                container.appendChild(relatedMessage);
                this._lines += 1;
                relatedInformationNode.appendChild(container);
            }
        }
        const fontInfo = this._editor.getOption(50 /* EditorOption.fontInfo */ );
        const scrollWidth = Math.ceil(fontInfo.typicalFullwidthCharacterWidth * this._longestLineLength * 0.75);
        const scrollHeight = fontInfo.lineHeight * this._lines;
        this._scrollable.setScrollDimensions({
            scrollWidth,
            scrollHeight
        });
    }
    layout(height, width) {
        this._scrollable.getDomNode().style.height = `${height}px`;
        this._scrollable.getDomNode().style.width = `${width}px`;
        this._scrollable.setScrollDimensions({
            width,
            height
        });
    }
    getHeightInLines() {
        return Math.min(17, this._lines);
    }
    getAriaLabel(marker) {
        let severityLabel = "";
        switch(marker.severity){
            case (0, _markersJs.MarkerSeverity).Error:
                severityLabel = _nlsJs.localize("Error", "Error");
                break;
            case (0, _markersJs.MarkerSeverity).Warning:
                severityLabel = _nlsJs.localize("Warning", "Warning");
                break;
            case (0, _markersJs.MarkerSeverity).Info:
                severityLabel = _nlsJs.localize("Info", "Info");
                break;
            case (0, _markersJs.MarkerSeverity).Hint:
                severityLabel = _nlsJs.localize("Hint", "Hint");
                break;
        }
        let ariaLabel = _nlsJs.localize("marker aria", "{0} at {1}. ", severityLabel, marker.startLineNumber + ":" + marker.startColumn);
        const model = this._editor.getModel();
        if (model && marker.startLineNumber <= model.getLineCount() && marker.startLineNumber >= 1) {
            const lineContent = model.getLineContent(marker.startLineNumber);
            ariaLabel = `${lineContent}, ${ariaLabel}`;
        }
        return ariaLabel;
    }
}
let MarkerNavigationWidget = class MarkerNavigationWidget extends (0, _peekViewJs.PeekViewWidget) {
    static{
        MarkerNavigationWidget_1 = this;
    }
    static{
        this.TitleMenu = new (0, _actionsJs.MenuId)("gotoErrorTitleMenu");
    }
    constructor(editor, _themeService, _openerService, _menuService, instantiationService, _contextKeyService, _labelService){
        super(editor, {
            showArrow: true,
            showFrame: true,
            isAccessible: true,
            frameWidth: 1
        }, instantiationService);
        this._themeService = _themeService;
        this._openerService = _openerService;
        this._menuService = _menuService;
        this._contextKeyService = _contextKeyService;
        this._labelService = _labelService;
        this._callOnDispose = new (0, _lifecycleJs.DisposableStore)();
        this._onDidSelectRelatedInformation = new (0, _eventJs.Emitter)();
        this.onDidSelectRelatedInformation = this._onDidSelectRelatedInformation.event;
        this._severity = (0, _markersJs.MarkerSeverity).Warning;
        this._backgroundColor = (0, _colorJs.Color).white;
        this._applyTheme(_themeService.getColorTheme());
        this._callOnDispose.add(_themeService.onDidColorThemeChange(this._applyTheme.bind(this)));
        this.create();
    }
    _applyTheme(theme) {
        this._backgroundColor = theme.getColor(editorMarkerNavigationBackground);
        let colorId = editorMarkerNavigationError;
        let headerBackground = editorMarkerNavigationErrorHeader;
        if (this._severity === (0, _markersJs.MarkerSeverity).Warning) {
            colorId = editorMarkerNavigationWarning;
            headerBackground = editorMarkerNavigationWarningHeader;
        } else if (this._severity === (0, _markersJs.MarkerSeverity).Info) {
            colorId = editorMarkerNavigationInfo;
            headerBackground = editorMarkerNavigationInfoHeader;
        }
        const frameColor = theme.getColor(colorId);
        const headerBg = theme.getColor(headerBackground);
        this.style({
            arrowColor: frameColor,
            frameColor: frameColor,
            headerBackgroundColor: headerBg,
            primaryHeadingColor: theme.getColor((0, _peekViewJs.peekViewTitleForeground)),
            secondaryHeadingColor: theme.getColor((0, _peekViewJs.peekViewTitleInfoForeground))
        }); // style() will trigger _applyStyles
    }
    _applyStyles() {
        if (this._parentContainer) this._parentContainer.style.backgroundColor = this._backgroundColor ? this._backgroundColor.toString() : "";
        super._applyStyles();
    }
    dispose() {
        this._callOnDispose.dispose();
        super.dispose();
    }
    _fillHead(container) {
        super._fillHead(container);
        this._disposables.add(this._actionbarWidget.actionRunner.onWillRun((e)=>this.editor.focus()));
        const actions = [];
        const menu = this._menuService.getMenuActions(MarkerNavigationWidget_1.TitleMenu, this._contextKeyService);
        (0, _menuEntryActionViewItemJs.createAndFillInActionBarActions)(menu, actions);
        this._actionbarWidget.push(actions, {
            label: false,
            icon: true,
            index: 0
        });
    }
    _fillTitleIcon(container) {
        this._icon = _domJs.append(container, _domJs.$(""));
    }
    _fillBody(container) {
        this._parentContainer = container;
        container.classList.add("marker-widget");
        this._parentContainer.tabIndex = 0;
        this._parentContainer.setAttribute("role", "tooltip");
        this._container = document.createElement("div");
        container.appendChild(this._container);
        this._message = new MessageWidget(this._container, this.editor, (related)=>this._onDidSelectRelatedInformation.fire(related), this._openerService, this._labelService);
        this._disposables.add(this._message);
    }
    show() {
        throw new Error("call showAtMarker");
    }
    showAtMarker(marker, markerIdx, markerCount) {
        // update:
        // * title
        // * message
        this._container.classList.remove("stale");
        this._message.update(marker);
        // update frame color (only applied on 'show')
        this._severity = marker.severity;
        this._applyTheme(this._themeService.getColorTheme());
        // show
        const range = (0, _rangeJs.Range).lift(marker);
        const editorPosition = this.editor.getPosition();
        const position = editorPosition && range.containsPosition(editorPosition) ? editorPosition : range.getStartPosition();
        super.show(position, this.computeRequiredHeight());
        const model = this.editor.getModel();
        if (model) {
            const detail = markerCount > 1 ? _nlsJs.localize("problems", "{0} of {1} problems", markerIdx, markerCount) : _nlsJs.localize("change", "{0} of {1} problem", markerIdx, markerCount);
            this.setTitle((0, _resourcesJs.basename)(model.uri), detail);
        }
        this._icon.className = `codicon ${(0, _severityIconJs.SeverityIcon).className((0, _markersJs.MarkerSeverity).toSeverity(this._severity))}`;
        this.editor.revealPositionNearTop(position, 0 /* ScrollType.Smooth */ );
        this.editor.focus();
    }
    updateMarker(marker) {
        this._container.classList.remove("stale");
        this._message.update(marker);
    }
    showStale() {
        this._container.classList.add("stale");
        this._relayout();
    }
    _doLayoutBody(heightInPixel, widthInPixel) {
        super._doLayoutBody(heightInPixel, widthInPixel);
        this._heightInPixel = heightInPixel;
        this._message.layout(heightInPixel, widthInPixel);
        this._container.style.height = `${heightInPixel}px`;
    }
    _onWidth(widthInPixel) {
        this._message.layout(this._heightInPixel, widthInPixel);
    }
    _relayout() {
        super._relayout(this.computeRequiredHeight());
    }
    computeRequiredHeight() {
        return 3 + this._message.getHeightInLines();
    }
};
MarkerNavigationWidget = MarkerNavigationWidget_1 = __decorate([
    __param(1, (0, _themeServiceJs.IThemeService)),
    __param(2, (0, _openerJs.IOpenerService)),
    __param(3, (0, _actionsJs.IMenuService)),
    __param(4, (0, _instantiationJs.IInstantiationService)),
    __param(5, (0, _contextkeyJs.IContextKeyService)),
    __param(6, (0, _labelJs.ILabelService))
], MarkerNavigationWidget);
// theming
const errorDefault = (0, _colorRegistryJs.oneOf)((0, _colorRegistryJs.editorErrorForeground), (0, _colorRegistryJs.editorErrorBorder));
const warningDefault = (0, _colorRegistryJs.oneOf)((0, _colorRegistryJs.editorWarningForeground), (0, _colorRegistryJs.editorWarningBorder));
const infoDefault = (0, _colorRegistryJs.oneOf)((0, _colorRegistryJs.editorInfoForeground), (0, _colorRegistryJs.editorInfoBorder));
const editorMarkerNavigationError = (0, _colorRegistryJs.registerColor)("editorMarkerNavigationError.background", {
    dark: errorDefault,
    light: errorDefault,
    hcDark: (0, _colorRegistryJs.contrastBorder),
    hcLight: (0, _colorRegistryJs.contrastBorder)
}, _nlsJs.localize("editorMarkerNavigationError", "Editor marker navigation widget error color."));
const editorMarkerNavigationErrorHeader = (0, _colorRegistryJs.registerColor)("editorMarkerNavigationError.headerBackground", {
    dark: (0, _colorRegistryJs.transparent)(editorMarkerNavigationError, .1),
    light: (0, _colorRegistryJs.transparent)(editorMarkerNavigationError, .1),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("editorMarkerNavigationErrorHeaderBackground", "Editor marker navigation widget error heading background."));
const editorMarkerNavigationWarning = (0, _colorRegistryJs.registerColor)("editorMarkerNavigationWarning.background", {
    dark: warningDefault,
    light: warningDefault,
    hcDark: (0, _colorRegistryJs.contrastBorder),
    hcLight: (0, _colorRegistryJs.contrastBorder)
}, _nlsJs.localize("editorMarkerNavigationWarning", "Editor marker navigation widget warning color."));
const editorMarkerNavigationWarningHeader = (0, _colorRegistryJs.registerColor)("editorMarkerNavigationWarning.headerBackground", {
    dark: (0, _colorRegistryJs.transparent)(editorMarkerNavigationWarning, .1),
    light: (0, _colorRegistryJs.transparent)(editorMarkerNavigationWarning, .1),
    hcDark: "#0C141F",
    hcLight: (0, _colorRegistryJs.transparent)(editorMarkerNavigationWarning, .2)
}, _nlsJs.localize("editorMarkerNavigationWarningBackground", "Editor marker navigation widget warning heading background."));
const editorMarkerNavigationInfo = (0, _colorRegistryJs.registerColor)("editorMarkerNavigationInfo.background", {
    dark: infoDefault,
    light: infoDefault,
    hcDark: (0, _colorRegistryJs.contrastBorder),
    hcLight: (0, _colorRegistryJs.contrastBorder)
}, _nlsJs.localize("editorMarkerNavigationInfo", "Editor marker navigation widget info color."));
const editorMarkerNavigationInfoHeader = (0, _colorRegistryJs.registerColor)("editorMarkerNavigationInfo.headerBackground", {
    dark: (0, _colorRegistryJs.transparent)(editorMarkerNavigationInfo, .1),
    light: (0, _colorRegistryJs.transparent)(editorMarkerNavigationInfo, .1),
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("editorMarkerNavigationInfoHeaderBackground", "Editor marker navigation widget info heading background."));
const editorMarkerNavigationBackground = (0, _colorRegistryJs.registerColor)("editorMarkerNavigation.background", (0, _colorRegistryJs.editorBackground), _nlsJs.localize("editorMarkerNavigationBackground", "Editor marker navigation widget background."));

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/scrollbar/scrollableElement.js":"h1C5l","../../../../base/common/arrays.js":"DECei","../../../../base/common/color.js":"at4gb","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/resources.js":"700EV","../../../../base/common/strings.js":"aA9I1","./media/gotoErrorWidget.css":"3MKUD","../../../common/core/range.js":"jmUPh","../../peekView/browser/peekView.js":"jfvYD","../../../../nls.js":"l617d","../../../../platform/actions/browser/menuEntryActionViewItem.js":"evssn","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/label/common/label.js":"esEqR","../../../../platform/markers/common/markers.js":"aaeXc","../../../../platform/opener/common/opener.js":"d3tj1","../../../../platform/severityIcon/browser/severityIcon.js":"dC9Tn","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3MKUD":[function() {},{}],"dC9Tn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeverityIcon", ()=>SeverityIcon);
var _severityIconCss = require("./media/severityIcon.css");
var _codiconsJs = require("../../../base/common/codicons.js");
var _themablesJs = require("../../../base/common/themables.js");
var _severityJs = require("../../../base/common/severity.js");
var _severityJsDefault = parcelHelpers.interopDefault(_severityJs);
var SeverityIcon;
(function(SeverityIcon) {
    function className(severity) {
        switch(severity){
            case (0, _severityJsDefault.default).Ignore:
                return "severity-ignore " + (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).info);
            case (0, _severityJsDefault.default).Info:
                return (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).info);
            case (0, _severityJsDefault.default).Warning:
                return (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).warning);
            case (0, _severityJsDefault.default).Error:
                return (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).error);
            default:
                return "";
        }
    }
    SeverityIcon.className = className;
})(SeverityIcon || (SeverityIcon = {}));

},{"./media/severityIcon.css":"gNey6","../../../base/common/codicons.js":"hWYNf","../../../base/common/themables.js":"hgyHi","../../../base/common/severity.js":"faBYp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gNey6":[function() {},{}],"gZ9QW":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _hoverActionsJs = require("./hoverActions.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _hoverTypesJs = require("./hoverTypes.js");
var _markdownHoverParticipantJs = require("./markdownHoverParticipant.js");
var _markerHoverParticipantJs = require("./markerHoverParticipant.js");
var _contentHoverController2Js = require("./contentHoverController2.js");
var _marginHoverControllerJs = require("./marginHoverController.js");
var _hoverCss = require("./hover.css");
var _accessibleViewRegistryJs = require("../../../../platform/accessibility/browser/accessibleViewRegistry.js");
var _hoverAccessibleViewsJs = require("./hoverAccessibleViews.js");
(0, _editorExtensionsJs.registerEditorContribution)((0, _contentHoverController2Js.ContentHoverController).ID, (0, _contentHoverController2Js.ContentHoverController), 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );
(0, _editorExtensionsJs.registerEditorContribution)((0, _marginHoverControllerJs.MarginHoverController).ID, (0, _marginHoverControllerJs.MarginHoverController), 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );
(0, _editorExtensionsJs.registerEditorAction)((0, _hoverActionsJs.ShowOrFocusHoverAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _hoverActionsJs.ShowDefinitionPreviewHoverAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _hoverActionsJs.ScrollUpHoverAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _hoverActionsJs.ScrollDownHoverAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _hoverActionsJs.ScrollLeftHoverAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _hoverActionsJs.ScrollRightHoverAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _hoverActionsJs.PageUpHoverAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _hoverActionsJs.PageDownHoverAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _hoverActionsJs.GoToTopHoverAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _hoverActionsJs.GoToBottomHoverAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _hoverActionsJs.IncreaseHoverVerbosityLevel));
(0, _editorExtensionsJs.registerEditorAction)((0, _hoverActionsJs.DecreaseHoverVerbosityLevel));
(0, _hoverTypesJs.HoverParticipantRegistry).register((0, _markdownHoverParticipantJs.MarkdownHoverParticipant));
(0, _hoverTypesJs.HoverParticipantRegistry).register((0, _markerHoverParticipantJs.MarkerHoverParticipant));
// theming
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const hoverBorder = theme.getColor((0, _colorRegistryJs.editorHoverBorder));
    if (hoverBorder) {
        collector.addRule(`.monaco-editor .monaco-hover .hover-row:not(:first-child):not(:empty) { border-top: 1px solid ${hoverBorder.transparent(0.5)}; }`);
        collector.addRule(`.monaco-editor .monaco-hover hr { border-top: 1px solid ${hoverBorder.transparent(0.5)}; }`);
        collector.addRule(`.monaco-editor .monaco-hover hr { border-bottom: 0px solid ${hoverBorder.transparent(0.5)}; }`);
    }
});
(0, _accessibleViewRegistryJs.AccessibleViewRegistry).register(new (0, _hoverAccessibleViewsJs.HoverAccessibleView)());
(0, _accessibleViewRegistryJs.AccessibleViewRegistry).register(new (0, _hoverAccessibleViewsJs.HoverAccessibilityHelp)());
(0, _accessibleViewRegistryJs.AccessibleViewRegistry).register(new (0, _hoverAccessibleViewsJs.ExtHoverAccessibleView)());

},{"./hoverActions.js":"MYWhh","../../../browser/editorExtensions.js":"kC3w6","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/themeService.js":"jMkIC","./hoverTypes.js":"6vmRi","./markdownHoverParticipant.js":"l8mtm","./markerHoverParticipant.js":"2woDS","./contentHoverController2.js":"mYQJl","./marginHoverController.js":"2npNC","./hover.css":"jKoKx","../../../../platform/accessibility/browser/accessibleViewRegistry.js":"khjwq","./hoverAccessibleViews.js":"jM2rh"}],"MYWhh":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShowOrFocusHoverAction", ()=>ShowOrFocusHoverAction);
parcelHelpers.export(exports, "ShowDefinitionPreviewHoverAction", ()=>ShowDefinitionPreviewHoverAction);
parcelHelpers.export(exports, "ScrollUpHoverAction", ()=>ScrollUpHoverAction);
parcelHelpers.export(exports, "ScrollDownHoverAction", ()=>ScrollDownHoverAction);
parcelHelpers.export(exports, "ScrollLeftHoverAction", ()=>ScrollLeftHoverAction);
parcelHelpers.export(exports, "ScrollRightHoverAction", ()=>ScrollRightHoverAction);
parcelHelpers.export(exports, "PageUpHoverAction", ()=>PageUpHoverAction);
parcelHelpers.export(exports, "PageDownHoverAction", ()=>PageDownHoverAction);
parcelHelpers.export(exports, "GoToTopHoverAction", ()=>GoToTopHoverAction);
parcelHelpers.export(exports, "GoToBottomHoverAction", ()=>GoToBottomHoverAction);
parcelHelpers.export(exports, "IncreaseHoverVerbosityLevel", ()=>IncreaseHoverVerbosityLevel);
parcelHelpers.export(exports, "DecreaseHoverVerbosityLevel", ()=>DecreaseHoverVerbosityLevel);
var _hoverActionIdsJs = require("./hoverActionIds.js");
var _keyCodesJs = require("../../../../base/common/keyCodes.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _goToDefinitionAtPositionJs = require("../../gotoSymbol/browser/link/goToDefinitionAtPosition.js");
var _contentHoverController2Js = require("./contentHoverController2.js");
var _languagesJs = require("../../../common/languages.js");
var _nlsJs = require("../../../../nls.js");
var _hoverCss = require("./hover.css");
var HoverFocusBehavior;
(function(HoverFocusBehavior) {
    HoverFocusBehavior["NoAutoFocus"] = "noAutoFocus";
    HoverFocusBehavior["FocusIfVisible"] = "focusIfVisible";
    HoverFocusBehavior["AutoFocusImmediately"] = "autoFocusImmediately";
})(HoverFocusBehavior || (HoverFocusBehavior = {}));
class ShowOrFocusHoverAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _hoverActionIdsJs.SHOW_OR_FOCUS_HOVER_ACTION_ID),
            label: _nlsJs.localize({
                key: "showOrFocusHover",
                comment: [
                    "Label for action that will trigger the showing/focusing of a hover in the editor.",
                    "If the hover is not visible, it will show the hover.",
                    "This allows for users to show the hover without using the mouse."
                ]
            }, "Show or Focus Hover"),
            metadata: {
                description: _nlsJs.localize2("showOrFocusHoverDescription", "Show or focus the editor hover which shows documentation, references, and other content for a symbol at the current cursor position."),
                args: [
                    {
                        name: "args",
                        schema: {
                            type: "object",
                            properties: {
                                "focus": {
                                    description: "Controls if and when the hover should take focus upon being triggered by this action.",
                                    enum: [
                                        HoverFocusBehavior.NoAutoFocus,
                                        HoverFocusBehavior.FocusIfVisible,
                                        HoverFocusBehavior.AutoFocusImmediately
                                    ],
                                    enumDescriptions: [
                                        _nlsJs.localize("showOrFocusHover.focus.noAutoFocus", "The hover will not automatically take focus."),
                                        _nlsJs.localize("showOrFocusHover.focus.focusIfVisible", "The hover will take focus only if it is already visible."),
                                        _nlsJs.localize("showOrFocusHover.focus.autoFocusImmediately", "The hover will automatically take focus when it appears.")
                                    ],
                                    default: HoverFocusBehavior.FocusIfVisible
                                }
                            }
                        }
                    }
                ]
            },
            alias: "Show or Focus Hover",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2087 /* KeyCode.KeyI */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(accessor, editor, args) {
        if (!editor.hasModel()) return;
        const controller = (0, _contentHoverController2Js.ContentHoverController).get(editor);
        if (!controller) return;
        const focusArgument = args?.focus;
        let focusOption = HoverFocusBehavior.FocusIfVisible;
        if (Object.values(HoverFocusBehavior).includes(focusArgument)) focusOption = focusArgument;
        else if (typeof focusArgument === "boolean" && focusArgument) focusOption = HoverFocusBehavior.AutoFocusImmediately;
        const showContentHover = (focus)=>{
            const position = editor.getPosition();
            const range = new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column);
            controller.showContentHover(range, 1 /* HoverStartMode.Immediate */ , 1 /* HoverStartSource.Keyboard */ , focus);
        };
        const accessibilitySupportEnabled = editor.getOption(2 /* EditorOption.accessibilitySupport */ ) === 2 /* AccessibilitySupport.Enabled */ ;
        if (controller.isHoverVisible) {
            if (focusOption !== HoverFocusBehavior.NoAutoFocus) controller.focus();
            else showContentHover(accessibilitySupportEnabled);
        } else showContentHover(accessibilitySupportEnabled || focusOption === HoverFocusBehavior.AutoFocusImmediately);
    }
}
class ShowDefinitionPreviewHoverAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _hoverActionIdsJs.SHOW_DEFINITION_PREVIEW_HOVER_ACTION_ID),
            label: _nlsJs.localize({
                key: "showDefinitionPreviewHover",
                comment: [
                    "Label for action that will trigger the showing of definition preview hover in the editor.",
                    "This allows for users to show the definition preview hover without using the mouse."
                ]
            }, "Show Definition Preview Hover"),
            alias: "Show Definition Preview Hover",
            precondition: undefined,
            metadata: {
                description: _nlsJs.localize2("showDefinitionPreviewHoverDescription", "Show the definition preview hover in the editor.")
            }
        });
    }
    run(accessor, editor) {
        const controller = (0, _contentHoverController2Js.ContentHoverController).get(editor);
        if (!controller) return;
        const position = editor.getPosition();
        if (!position) return;
        const range = new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column);
        const goto = (0, _goToDefinitionAtPositionJs.GotoDefinitionAtPositionEditorContribution).get(editor);
        if (!goto) return;
        const promise = goto.startFindDefinitionFromCursor(position);
        promise.then(()=>{
            controller.showContentHover(range, 1 /* HoverStartMode.Immediate */ , 1 /* HoverStartSource.Keyboard */ , true);
        });
    }
}
class ScrollUpHoverAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _hoverActionIdsJs.SCROLL_UP_HOVER_ACTION_ID),
            label: _nlsJs.localize({
                key: "scrollUpHover",
                comment: [
                    "Action that allows to scroll up in the hover widget with the up arrow when the hover widget is focused."
                ]
            }, "Scroll Up Hover"),
            alias: "Scroll Up Hover",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
                primary: 16 /* KeyCode.UpArrow */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: _nlsJs.localize2("scrollUpHoverDescription", "Scroll up the editor hover.")
            }
        });
    }
    run(accessor, editor) {
        const controller = (0, _contentHoverController2Js.ContentHoverController).get(editor);
        if (!controller) return;
        controller.scrollUp();
    }
}
class ScrollDownHoverAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _hoverActionIdsJs.SCROLL_DOWN_HOVER_ACTION_ID),
            label: _nlsJs.localize({
                key: "scrollDownHover",
                comment: [
                    "Action that allows to scroll down in the hover widget with the up arrow when the hover widget is focused."
                ]
            }, "Scroll Down Hover"),
            alias: "Scroll Down Hover",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
                primary: 18 /* KeyCode.DownArrow */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: _nlsJs.localize2("scrollDownHoverDescription", "Scroll down the editor hover.")
            }
        });
    }
    run(accessor, editor) {
        const controller = (0, _contentHoverController2Js.ContentHoverController).get(editor);
        if (!controller) return;
        controller.scrollDown();
    }
}
class ScrollLeftHoverAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _hoverActionIdsJs.SCROLL_LEFT_HOVER_ACTION_ID),
            label: _nlsJs.localize({
                key: "scrollLeftHover",
                comment: [
                    "Action that allows to scroll left in the hover widget with the left arrow when the hover widget is focused."
                ]
            }, "Scroll Left Hover"),
            alias: "Scroll Left Hover",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
                primary: 15 /* KeyCode.LeftArrow */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: _nlsJs.localize2("scrollLeftHoverDescription", "Scroll left the editor hover.")
            }
        });
    }
    run(accessor, editor) {
        const controller = (0, _contentHoverController2Js.ContentHoverController).get(editor);
        if (!controller) return;
        controller.scrollLeft();
    }
}
class ScrollRightHoverAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _hoverActionIdsJs.SCROLL_RIGHT_HOVER_ACTION_ID),
            label: _nlsJs.localize({
                key: "scrollRightHover",
                comment: [
                    "Action that allows to scroll right in the hover widget with the right arrow when the hover widget is focused."
                ]
            }, "Scroll Right Hover"),
            alias: "Scroll Right Hover",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
                primary: 17 /* KeyCode.RightArrow */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: _nlsJs.localize2("scrollRightHoverDescription", "Scroll right the editor hover.")
            }
        });
    }
    run(accessor, editor) {
        const controller = (0, _contentHoverController2Js.ContentHoverController).get(editor);
        if (!controller) return;
        controller.scrollRight();
    }
}
class PageUpHoverAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _hoverActionIdsJs.PAGE_UP_HOVER_ACTION_ID),
            label: _nlsJs.localize({
                key: "pageUpHover",
                comment: [
                    "Action that allows to page up in the hover widget with the page up command when the hover widget is focused."
                ]
            }, "Page Up Hover"),
            alias: "Page Up Hover",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
                primary: 11 /* KeyCode.PageUp */ ,
                secondary: [
                    528 /* KeyCode.UpArrow */ 
                ],
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: _nlsJs.localize2("pageUpHoverDescription", "Page up the editor hover.")
            }
        });
    }
    run(accessor, editor) {
        const controller = (0, _contentHoverController2Js.ContentHoverController).get(editor);
        if (!controller) return;
        controller.pageUp();
    }
}
class PageDownHoverAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _hoverActionIdsJs.PAGE_DOWN_HOVER_ACTION_ID),
            label: _nlsJs.localize({
                key: "pageDownHover",
                comment: [
                    "Action that allows to page down in the hover widget with the page down command when the hover widget is focused."
                ]
            }, "Page Down Hover"),
            alias: "Page Down Hover",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
                primary: 12 /* KeyCode.PageDown */ ,
                secondary: [
                    530 /* KeyCode.DownArrow */ 
                ],
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: _nlsJs.localize2("pageDownHoverDescription", "Page down the editor hover.")
            }
        });
    }
    run(accessor, editor) {
        const controller = (0, _contentHoverController2Js.ContentHoverController).get(editor);
        if (!controller) return;
        controller.pageDown();
    }
}
class GoToTopHoverAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _hoverActionIdsJs.GO_TO_TOP_HOVER_ACTION_ID),
            label: _nlsJs.localize({
                key: "goToTopHover",
                comment: [
                    "Action that allows to go to the top of the hover widget with the home command when the hover widget is focused."
                ]
            }, "Go To Top Hover"),
            alias: "Go To Bottom Hover",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
                primary: 14 /* KeyCode.Home */ ,
                secondary: [
                    2064 /* KeyCode.UpArrow */ 
                ],
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: _nlsJs.localize2("goToTopHoverDescription", "Go to the top of the editor hover.")
            }
        });
    }
    run(accessor, editor) {
        const controller = (0, _contentHoverController2Js.ContentHoverController).get(editor);
        if (!controller) return;
        controller.goToTop();
    }
}
class GoToBottomHoverAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _hoverActionIdsJs.GO_TO_BOTTOM_HOVER_ACTION_ID),
            label: _nlsJs.localize({
                key: "goToBottomHover",
                comment: [
                    "Action that allows to go to the bottom in the hover widget with the end command when the hover widget is focused."
                ]
            }, "Go To Bottom Hover"),
            alias: "Go To Bottom Hover",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).hoverFocused,
                primary: 13 /* KeyCode.End */ ,
                secondary: [
                    2066 /* KeyCode.DownArrow */ 
                ],
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: _nlsJs.localize2("goToBottomHoverDescription", "Go to the bottom of the editor hover.")
            }
        });
    }
    run(accessor, editor) {
        const controller = (0, _contentHoverController2Js.ContentHoverController).get(editor);
        if (!controller) return;
        controller.goToBottom();
    }
}
class IncreaseHoverVerbosityLevel extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _hoverActionIdsJs.INCREASE_HOVER_VERBOSITY_ACTION_ID),
            label: (0, _hoverActionIdsJs.INCREASE_HOVER_VERBOSITY_ACTION_LABEL),
            alias: "Increase Hover Verbosity Level",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hoverVisible
        });
    }
    run(accessor, editor, args) {
        const hoverController = (0, _contentHoverController2Js.ContentHoverController).get(editor);
        if (!hoverController) return;
        const index = args?.index !== undefined ? args.index : hoverController.focusedHoverPartIndex();
        hoverController.updateHoverVerbosityLevel((0, _languagesJs.HoverVerbosityAction).Increase, index, args?.focus);
    }
}
class DecreaseHoverVerbosityLevel extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _hoverActionIdsJs.DECREASE_HOVER_VERBOSITY_ACTION_ID),
            label: (0, _hoverActionIdsJs.DECREASE_HOVER_VERBOSITY_ACTION_LABEL),
            alias: "Decrease Hover Verbosity Level",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hoverVisible
        });
    }
    run(accessor, editor, args) {
        const hoverController = (0, _contentHoverController2Js.ContentHoverController).get(editor);
        if (!hoverController) return;
        const index = args?.index !== undefined ? args.index : hoverController.focusedHoverPartIndex();
        (0, _contentHoverController2Js.ContentHoverController).get(editor)?.updateHoverVerbosityLevel((0, _languagesJs.HoverVerbosityAction).Decrease, index, args?.focus);
    }
}

},{"./hoverActionIds.js":"b3M99","../../../../base/common/keyCodes.js":"bHiG9","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/range.js":"jmUPh","../../../common/editorContextKeys.js":"5exv9","../../gotoSymbol/browser/link/goToDefinitionAtPosition.js":"7ATNy","./contentHoverController2.js":"mYQJl","../../../common/languages.js":"g5n96","../../../../nls.js":"l617d","./hover.css":"jKoKx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jKoKx":[function() {},{}],"2woDS":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkerHover", ()=>MarkerHover);
parcelHelpers.export(exports, "MarkerHoverParticipant", ()=>MarkerHoverParticipant);
var _domJs = require("../../../../base/browser/dom.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _asyncJs = require("../../../../base/common/async.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _resourcesJs = require("../../../../base/common/resources.js");
var _rangeJs = require("../../../common/core/range.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _markerDecorationsJs = require("../../../common/services/markerDecorations.js");
var _codeActionJs = require("../../codeAction/browser/codeAction.js");
var _codeActionControllerJs = require("../../codeAction/browser/codeActionController.js");
var _typesJs = require("../../codeAction/common/types.js");
var _gotoErrorJs = require("../../gotoError/browser/gotoError.js");
var _hoverTypesJs = require("./hoverTypes.js");
var _nlsJs = require("../../../../nls.js");
var _markersJs = require("../../../../platform/markers/common/markers.js");
var _openerJs = require("../../../../platform/opener/common/opener.js");
var _progressJs = require("../../../../platform/progress/common/progress.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const $ = _domJs.$;
class MarkerHover {
    constructor(owner, range, marker){
        this.owner = owner;
        this.range = range;
        this.marker = marker;
    }
    isValidForHoverAnchor(anchor) {
        return anchor.type === 1 /* HoverAnchorType.Range */  && this.range.startColumn <= anchor.range.startColumn && this.range.endColumn >= anchor.range.endColumn;
    }
}
const markerCodeActionTrigger = {
    type: 1 /* CodeActionTriggerType.Invoke */ ,
    filter: {
        include: (0, _typesJs.CodeActionKind).QuickFix
    },
    triggerAction: (0, _typesJs.CodeActionTriggerSource).QuickFixHover
};
let MarkerHoverParticipant = class MarkerHoverParticipant {
    constructor(_editor, _markerDecorationsService, _openerService, _languageFeaturesService){
        this._editor = _editor;
        this._markerDecorationsService = _markerDecorationsService;
        this._openerService = _openerService;
        this._languageFeaturesService = _languageFeaturesService;
        this.hoverOrdinal = 1;
        this.recentMarkerCodeActionsInfo = undefined;
    }
    computeSync(anchor, lineDecorations) {
        if (!this._editor.hasModel() || anchor.type !== 1 /* HoverAnchorType.Range */  && !anchor.supportsMarkerHover) return [];
        const model = this._editor.getModel();
        const lineNumber = anchor.range.startLineNumber;
        const maxColumn = model.getLineMaxColumn(lineNumber);
        const result = [];
        for (const d of lineDecorations){
            const startColumn = d.range.startLineNumber === lineNumber ? d.range.startColumn : 1;
            const endColumn = d.range.endLineNumber === lineNumber ? d.range.endColumn : maxColumn;
            const marker = this._markerDecorationsService.getMarker(model.uri, d);
            if (!marker) continue;
            const range = new (0, _rangeJs.Range)(anchor.range.startLineNumber, startColumn, anchor.range.startLineNumber, endColumn);
            result.push(new MarkerHover(this, range, marker));
        }
        return result;
    }
    renderHoverParts(context, hoverParts) {
        if (!hoverParts.length) return new (0, _hoverTypesJs.RenderedHoverParts)([]);
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        const renderedHoverParts = [];
        hoverParts.forEach((hoverPart)=>{
            const renderedMarkerHover = this._renderMarkerHover(hoverPart);
            context.fragment.appendChild(renderedMarkerHover.hoverElement);
            renderedHoverParts.push(renderedMarkerHover);
        });
        const markerHoverForStatusbar = hoverParts.length === 1 ? hoverParts[0] : hoverParts.sort((a, b)=>(0, _markersJs.MarkerSeverity).compare(a.marker.severity, b.marker.severity))[0];
        this.renderMarkerStatusbar(context, markerHoverForStatusbar, disposables);
        return new (0, _hoverTypesJs.RenderedHoverParts)(renderedHoverParts);
    }
    _renderMarkerHover(markerHover) {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        const hoverElement = $("div.hover-row");
        const markerElement = _domJs.append(hoverElement, $("div.marker.hover-contents"));
        const { source, message, code, relatedInformation } = markerHover.marker;
        this._editor.applyFontInfo(markerElement);
        const messageElement = _domJs.append(markerElement, $("span"));
        messageElement.style.whiteSpace = "pre-wrap";
        messageElement.innerText = message;
        if (source || code) {
            // Code has link
            if (code && typeof code !== "string") {
                const sourceAndCodeElement = $("span");
                if (source) {
                    const sourceElement = _domJs.append(sourceAndCodeElement, $("span"));
                    sourceElement.innerText = source;
                }
                const codeLink = _domJs.append(sourceAndCodeElement, $("a.code-link"));
                codeLink.setAttribute("href", code.target.toString());
                disposables.add(_domJs.addDisposableListener(codeLink, "click", (e)=>{
                    this._openerService.open(code.target, {
                        allowCommands: true
                    });
                    e.preventDefault();
                    e.stopPropagation();
                }));
                const codeElement = _domJs.append(codeLink, $("span"));
                codeElement.innerText = code.value;
                const detailsElement = _domJs.append(markerElement, sourceAndCodeElement);
                detailsElement.style.opacity = "0.6";
                detailsElement.style.paddingLeft = "6px";
            } else {
                const detailsElement = _domJs.append(markerElement, $("span"));
                detailsElement.style.opacity = "0.6";
                detailsElement.style.paddingLeft = "6px";
                detailsElement.innerText = source && code ? `${source}(${code})` : source ? source : `(${code})`;
            }
        }
        if ((0, _arraysJs.isNonEmptyArray)(relatedInformation)) for (const { message, resource, startLineNumber, startColumn } of relatedInformation){
            const relatedInfoContainer = _domJs.append(markerElement, $("div"));
            relatedInfoContainer.style.marginTop = "8px";
            const a = _domJs.append(relatedInfoContainer, $("a"));
            a.innerText = `${(0, _resourcesJs.basename)(resource)}(${startLineNumber}, ${startColumn}): `;
            a.style.cursor = "pointer";
            disposables.add(_domJs.addDisposableListener(a, "click", (e)=>{
                e.stopPropagation();
                e.preventDefault();
                if (this._openerService) {
                    const editorOptions = {
                        selection: {
                            startLineNumber,
                            startColumn
                        }
                    };
                    this._openerService.open(resource, {
                        fromUserGesture: true,
                        editorOptions
                    }).catch((0, _errorsJs.onUnexpectedError));
                }
            }));
            const messageElement = _domJs.append(relatedInfoContainer, $("span"));
            messageElement.innerText = message;
            this._editor.applyFontInfo(messageElement);
        }
        const renderedHoverPart = {
            hoverPart: markerHover,
            hoverElement,
            dispose: ()=>disposables.dispose()
        };
        return renderedHoverPart;
    }
    renderMarkerStatusbar(context, markerHover, disposables) {
        if (markerHover.marker.severity === (0, _markersJs.MarkerSeverity).Error || markerHover.marker.severity === (0, _markersJs.MarkerSeverity).Warning || markerHover.marker.severity === (0, _markersJs.MarkerSeverity).Info) {
            const markerController = (0, _gotoErrorJs.MarkerController).get(this._editor);
            if (markerController) context.statusBar.addAction({
                label: _nlsJs.localize("view problem", "View Problem"),
                commandId: (0, _gotoErrorJs.NextMarkerAction).ID,
                run: ()=>{
                    context.hide();
                    markerController.showAtMarker(markerHover.marker);
                    this._editor.focus();
                }
            });
        }
        if (!this._editor.getOption(92 /* EditorOption.readOnly */ )) {
            const quickfixPlaceholderElement = context.statusBar.append($("div"));
            if (this.recentMarkerCodeActionsInfo) {
                if ((0, _markersJs.IMarkerData).makeKey(this.recentMarkerCodeActionsInfo.marker) === (0, _markersJs.IMarkerData).makeKey(markerHover.marker)) {
                    if (!this.recentMarkerCodeActionsInfo.hasCodeActions) quickfixPlaceholderElement.textContent = _nlsJs.localize("noQuickFixes", "No quick fixes available");
                } else this.recentMarkerCodeActionsInfo = undefined;
            }
            const updatePlaceholderDisposable = this.recentMarkerCodeActionsInfo && !this.recentMarkerCodeActionsInfo.hasCodeActions ? (0, _lifecycleJs.Disposable).None : (0, _asyncJs.disposableTimeout)(()=>quickfixPlaceholderElement.textContent = _nlsJs.localize("checkingForQuickFixes", "Checking for quick fixes..."), 200, disposables);
            if (!quickfixPlaceholderElement.textContent) // Have some content in here to avoid flickering
            quickfixPlaceholderElement.textContent = String.fromCharCode(0xA0); // &nbsp;
            const codeActionsPromise = this.getCodeActions(markerHover.marker);
            disposables.add((0, _lifecycleJs.toDisposable)(()=>codeActionsPromise.cancel()));
            codeActionsPromise.then((actions)=>{
                updatePlaceholderDisposable.dispose();
                this.recentMarkerCodeActionsInfo = {
                    marker: markerHover.marker,
                    hasCodeActions: actions.validActions.length > 0
                };
                if (!this.recentMarkerCodeActionsInfo.hasCodeActions) {
                    actions.dispose();
                    quickfixPlaceholderElement.textContent = _nlsJs.localize("noQuickFixes", "No quick fixes available");
                    return;
                }
                quickfixPlaceholderElement.style.display = "none";
                let showing = false;
                disposables.add((0, _lifecycleJs.toDisposable)(()=>{
                    if (!showing) actions.dispose();
                }));
                context.statusBar.addAction({
                    label: _nlsJs.localize("quick fixes", "Quick Fix..."),
                    commandId: (0, _codeActionJs.quickFixCommandId),
                    run: (target)=>{
                        showing = true;
                        const controller = (0, _codeActionControllerJs.CodeActionController).get(this._editor);
                        const elementPosition = _domJs.getDomNodePagePosition(target);
                        // Hide the hover pre-emptively, otherwise the editor can close the code actions
                        // context menu as well when using keyboard navigation
                        context.hide();
                        controller?.showCodeActions(markerCodeActionTrigger, actions, {
                            x: elementPosition.left,
                            y: elementPosition.top,
                            width: elementPosition.width,
                            height: elementPosition.height
                        });
                    }
                });
            }, (0, _errorsJs.onUnexpectedError));
        }
    }
    getCodeActions(marker) {
        return (0, _asyncJs.createCancelablePromise)((cancellationToken)=>{
            return (0, _codeActionJs.getCodeActions)(this._languageFeaturesService.codeActionProvider, this._editor.getModel(), new (0, _rangeJs.Range)(marker.startLineNumber, marker.startColumn, marker.endLineNumber, marker.endColumn), markerCodeActionTrigger, (0, _progressJs.Progress).None, cancellationToken);
        });
    }
};
MarkerHoverParticipant = __decorate([
    __param(1, (0, _markerDecorationsJs.IMarkerDecorationsService)),
    __param(2, (0, _openerJs.IOpenerService)),
    __param(3, (0, _languageFeaturesJs.ILanguageFeaturesService))
], MarkerHoverParticipant);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/arrays.js":"DECei","../../../../base/common/async.js":"4GJc4","../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/resources.js":"700EV","../../../common/core/range.js":"jmUPh","../../../common/services/languageFeatures.js":"2IAko","../../../common/services/markerDecorations.js":"jDz73","../../codeAction/browser/codeAction.js":"6jIB5","../../codeAction/browser/codeActionController.js":"bCH7J","../../codeAction/common/types.js":"jJnno","../../gotoError/browser/gotoError.js":"iqB4x","./hoverTypes.js":"6vmRi","../../../../nls.js":"l617d","../../../../platform/markers/common/markers.js":"aaeXc","../../../../platform/opener/common/opener.js":"d3tj1","../../../../platform/progress/common/progress.js":"f49eD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2npNC":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarginHoverController", ()=>MarginHoverController);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _asyncJs = require("../../../../base/common/async.js");
var _hoverUtilsJs = require("./hoverUtils.js");
var _hoverCss = require("./hover.css");
var _marginHoverWidgetJs = require("./marginHoverWidget.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
// sticky hover widget which doesn't disappear on focus out and such
const _sticky = false;
let MarginHoverController = class MarginHoverController extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.marginHover";
    }
    constructor(_editor, _instantiationService){
        super();
        this._editor = _editor;
        this._instantiationService = _instantiationService;
        this.shouldKeepOpenOnEditorMouseMoveOrLeave = false;
        this._listenersStore = new (0, _lifecycleJs.DisposableStore)();
        this._hoverState = {
            mouseDown: false
        };
        this._reactToEditorMouseMoveRunner = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._reactToEditorMouseMove(this._mouseMoveEvent), 0));
        this._hookListeners();
        this._register(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(60 /* EditorOption.hover */ )) {
                this._unhookListeners();
                this._hookListeners();
            }
        }));
    }
    _hookListeners() {
        const hoverOpts = this._editor.getOption(60 /* EditorOption.hover */ );
        this._hoverSettings = {
            enabled: hoverOpts.enabled,
            sticky: hoverOpts.sticky,
            hidingDelay: hoverOpts.hidingDelay
        };
        if (hoverOpts.enabled) {
            this._listenersStore.add(this._editor.onMouseDown((e)=>this._onEditorMouseDown(e)));
            this._listenersStore.add(this._editor.onMouseUp(()=>this._onEditorMouseUp()));
            this._listenersStore.add(this._editor.onMouseMove((e)=>this._onEditorMouseMove(e)));
            this._listenersStore.add(this._editor.onKeyDown((e)=>this._onKeyDown(e)));
        } else {
            this._listenersStore.add(this._editor.onMouseMove((e)=>this._onEditorMouseMove(e)));
            this._listenersStore.add(this._editor.onKeyDown((e)=>this._onKeyDown(e)));
        }
        this._listenersStore.add(this._editor.onMouseLeave((e)=>this._onEditorMouseLeave(e)));
        this._listenersStore.add(this._editor.onDidChangeModel(()=>{
            this._cancelScheduler();
            this._hideWidgets();
        }));
        this._listenersStore.add(this._editor.onDidChangeModelContent(()=>this._cancelScheduler()));
        this._listenersStore.add(this._editor.onDidScrollChange((e)=>this._onEditorScrollChanged(e)));
    }
    _unhookListeners() {
        this._listenersStore.clear();
    }
    _cancelScheduler() {
        this._mouseMoveEvent = undefined;
        this._reactToEditorMouseMoveRunner.cancel();
    }
    _onEditorScrollChanged(e) {
        if (e.scrollTopChanged || e.scrollLeftChanged) this._hideWidgets();
    }
    _onEditorMouseDown(mouseEvent) {
        this._hoverState.mouseDown = true;
        const shouldNotHideCurrentHoverWidget = this._isMouseOnMarginHoverWidget(mouseEvent);
        if (shouldNotHideCurrentHoverWidget) return;
        this._hideWidgets();
    }
    _isMouseOnMarginHoverWidget(mouseEvent) {
        const marginHoverWidgetNode = this._glyphWidget?.getDomNode();
        if (marginHoverWidgetNode) return (0, _hoverUtilsJs.isMousePositionWithinElement)(marginHoverWidgetNode, mouseEvent.event.posx, mouseEvent.event.posy);
        return false;
    }
    _onEditorMouseUp() {
        this._hoverState.mouseDown = false;
    }
    _onEditorMouseLeave(mouseEvent) {
        if (this.shouldKeepOpenOnEditorMouseMoveOrLeave) return;
        this._cancelScheduler();
        const shouldNotHideCurrentHoverWidget = this._isMouseOnMarginHoverWidget(mouseEvent);
        if (shouldNotHideCurrentHoverWidget) return;
        if (_sticky) return;
        this._hideWidgets();
    }
    _shouldNotRecomputeCurrentHoverWidget(mouseEvent) {
        const isHoverSticky = this._hoverSettings.sticky;
        const isMouseOnMarginHoverWidget = this._isMouseOnMarginHoverWidget(mouseEvent);
        return isHoverSticky && isMouseOnMarginHoverWidget;
    }
    _onEditorMouseMove(mouseEvent) {
        if (this.shouldKeepOpenOnEditorMouseMoveOrLeave) return;
        this._mouseMoveEvent = mouseEvent;
        const shouldNotRecomputeCurrentHoverWidget = this._shouldNotRecomputeCurrentHoverWidget(mouseEvent);
        if (shouldNotRecomputeCurrentHoverWidget) {
            this._reactToEditorMouseMoveRunner.cancel();
            return;
        }
        this._reactToEditorMouseMove(mouseEvent);
    }
    _reactToEditorMouseMove(mouseEvent) {
        if (!mouseEvent) return;
        const glyphWidgetShowsOrWillShow = this._tryShowHoverWidget(mouseEvent);
        if (glyphWidgetShowsOrWillShow) return;
        if (_sticky) return;
        this._hideWidgets();
    }
    _tryShowHoverWidget(mouseEvent) {
        const glyphWidget = this._getOrCreateGlyphWidget();
        return glyphWidget.showsOrWillShow(mouseEvent);
    }
    _onKeyDown(e) {
        if (!this._editor.hasModel()) return;
        if (e.keyCode === 5 /* KeyCode.Ctrl */  || e.keyCode === 6 /* KeyCode.Alt */  || e.keyCode === 57 /* KeyCode.Meta */  || e.keyCode === 4 /* KeyCode.Shift */ ) // Do not hide hover when a modifier key is pressed
        return;
        this._hideWidgets();
    }
    _hideWidgets() {
        if (_sticky) return;
        this._glyphWidget?.hide();
    }
    _getOrCreateGlyphWidget() {
        if (!this._glyphWidget) this._glyphWidget = this._instantiationService.createInstance((0, _marginHoverWidgetJs.MarginHoverWidget), this._editor);
        return this._glyphWidget;
    }
    dispose() {
        super.dispose();
        this._unhookListeners();
        this._listenersStore.dispose();
        this._glyphWidget?.dispose();
    }
};
MarginHoverController = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService))
], MarginHoverController);

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../base/common/async.js":"4GJc4","./hoverUtils.js":"iINMK","./hover.css":"jKoKx","./marginHoverWidget.js":"35MNe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jKoKx":[function() {},{}],"35MNe":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarginHoverWidget", ()=>MarginHoverWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _markdownRendererJs = require("../../../browser/widget/markdownRenderer/browser/markdownRenderer.js");
var _languageJs = require("../../../common/languages/language.js");
var _hoverOperationJs = require("./hoverOperation.js");
var _openerJs = require("../../../../platform/opener/common/opener.js");
var _hoverWidgetJs = require("../../../../base/browser/ui/hover/hoverWidget.js");
var _marginHoverComputerJs = require("./marginHoverComputer.js");
var _hoverUtilsJs = require("./hoverUtils.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var MarginHoverWidget_1;
const $ = _domJs.$;
let MarginHoverWidget = class MarginHoverWidget extends (0, _lifecycleJs.Disposable) {
    static{
        MarginHoverWidget_1 = this;
    }
    static{
        this.ID = "editor.contrib.modesGlyphHoverWidget";
    }
    constructor(editor, languageService, openerService){
        super();
        this._renderDisposeables = this._register(new (0, _lifecycleJs.DisposableStore)());
        this._editor = editor;
        this._isVisible = false;
        this._messages = [];
        this._hover = this._register(new (0, _hoverWidgetJs.HoverWidget)());
        this._hover.containerDomNode.classList.toggle("hidden", !this._isVisible);
        this._markdownRenderer = this._register(new (0, _markdownRendererJs.MarkdownRenderer)({
            editor: this._editor
        }, languageService, openerService));
        this._computer = new (0, _marginHoverComputerJs.MarginHoverComputer)(this._editor);
        this._hoverOperation = this._register(new (0, _hoverOperationJs.HoverOperation)(this._editor, this._computer));
        this._register(this._hoverOperation.onResult((result)=>{
            this._withResult(result.value);
        }));
        this._register(this._editor.onDidChangeModelDecorations(()=>this._onModelDecorationsChanged()));
        this._register(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(50 /* EditorOption.fontInfo */ )) this._updateFont();
        }));
        this._register(_domJs.addStandardDisposableListener(this._hover.containerDomNode, "mouseleave", (e)=>{
            this._onMouseLeave(e);
        }));
        this._editor.addOverlayWidget(this);
    }
    dispose() {
        this._editor.removeOverlayWidget(this);
        super.dispose();
    }
    getId() {
        return MarginHoverWidget_1.ID;
    }
    getDomNode() {
        return this._hover.containerDomNode;
    }
    getPosition() {
        return null;
    }
    _updateFont() {
        const codeClasses = Array.prototype.slice.call(this._hover.contentsDomNode.getElementsByClassName("code"));
        codeClasses.forEach((node)=>this._editor.applyFontInfo(node));
    }
    _onModelDecorationsChanged() {
        if (this._isVisible) {
            // The decorations have changed and the hover is visible,
            // we need to recompute the displayed text
            this._hoverOperation.cancel();
            this._hoverOperation.start(0 /* HoverStartMode.Delayed */ );
        }
    }
    showsOrWillShow(mouseEvent) {
        const target = mouseEvent.target;
        if (target.type === 2 /* MouseTargetType.GUTTER_GLYPH_MARGIN */  && target.detail.glyphMarginLane) {
            this._startShowingAt(target.position.lineNumber, target.detail.glyphMarginLane);
            return true;
        }
        if (target.type === 3 /* MouseTargetType.GUTTER_LINE_NUMBERS */ ) {
            this._startShowingAt(target.position.lineNumber, "lineNo");
            return true;
        }
        return false;
    }
    _startShowingAt(lineNumber, laneOrLine) {
        if (this._computer.lineNumber === lineNumber && this._computer.lane === laneOrLine) // We have to show the widget at the exact same line number as before, so no work is needed
        return;
        this._hoverOperation.cancel();
        this.hide();
        this._computer.lineNumber = lineNumber;
        this._computer.lane = laneOrLine;
        this._hoverOperation.start(0 /* HoverStartMode.Delayed */ );
    }
    hide() {
        this._computer.lineNumber = -1;
        this._hoverOperation.cancel();
        if (!this._isVisible) return;
        this._isVisible = false;
        this._hover.containerDomNode.classList.toggle("hidden", !this._isVisible);
    }
    _withResult(result) {
        this._messages = result;
        if (this._messages.length > 0) this._renderMessages(this._computer.lineNumber, this._messages);
        else this.hide();
    }
    _renderMessages(lineNumber, messages) {
        this._renderDisposeables.clear();
        const fragment = document.createDocumentFragment();
        for (const msg of messages){
            const markdownHoverElement = $("div.hover-row.markdown-hover");
            const hoverContentsElement = _domJs.append(markdownHoverElement, $("div.hover-contents"));
            const renderedContents = this._renderDisposeables.add(this._markdownRenderer.render(msg.value));
            hoverContentsElement.appendChild(renderedContents.element);
            fragment.appendChild(markdownHoverElement);
        }
        this._updateContents(fragment);
        this._showAt(lineNumber);
    }
    _updateContents(node) {
        this._hover.contentsDomNode.textContent = "";
        this._hover.contentsDomNode.appendChild(node);
        this._updateFont();
    }
    _showAt(lineNumber) {
        if (!this._isVisible) {
            this._isVisible = true;
            this._hover.containerDomNode.classList.toggle("hidden", !this._isVisible);
        }
        const editorLayout = this._editor.getLayoutInfo();
        const topForLineNumber = this._editor.getTopForLineNumber(lineNumber);
        const editorScrollTop = this._editor.getScrollTop();
        const lineHeight = this._editor.getOption(67 /* EditorOption.lineHeight */ );
        const nodeHeight = this._hover.containerDomNode.clientHeight;
        const top = topForLineNumber - editorScrollTop - (nodeHeight - lineHeight) / 2;
        const left = editorLayout.glyphMarginLeft + editorLayout.glyphMarginWidth + (this._computer.lane === "lineNo" ? editorLayout.lineNumbersWidth : 0);
        this._hover.containerDomNode.style.left = `${left}px`;
        this._hover.containerDomNode.style.top = `${Math.max(Math.round(top), 0)}px`;
    }
    _onMouseLeave(e) {
        const editorDomNode = this._editor.getDomNode();
        const isMousePositionOutsideOfEditor = !editorDomNode || !(0, _hoverUtilsJs.isMousePositionWithinElement)(editorDomNode, e.x, e.y);
        if (isMousePositionOutsideOfEditor) this.hide();
    }
};
MarginHoverWidget = MarginHoverWidget_1 = __decorate([
    __param(1, (0, _languageJs.ILanguageService)),
    __param(2, (0, _openerJs.IOpenerService))
], MarginHoverWidget);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/widget/markdownRenderer/browser/markdownRenderer.js":"34xfZ","../../../common/languages/language.js":"ka2JQ","./hoverOperation.js":"a6SJn","../../../../platform/opener/common/opener.js":"d3tj1","../../../../base/browser/ui/hover/hoverWidget.js":"5eWDy","./marginHoverComputer.js":"h75QC","./hoverUtils.js":"iINMK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h75QC":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarginHoverComputer", ()=>MarginHoverComputer);
var _arraysJs = require("../../../../base/common/arrays.js");
var _htmlContentJs = require("../../../../base/common/htmlContent.js");
var _modelJs = require("../../../common/model.js");
class MarginHoverComputer {
    get lineNumber() {
        return this._lineNumber;
    }
    set lineNumber(value) {
        this._lineNumber = value;
    }
    get lane() {
        return this._laneOrLine;
    }
    set lane(value) {
        this._laneOrLine = value;
    }
    constructor(_editor){
        this._editor = _editor;
        this._lineNumber = -1;
        this._laneOrLine = (0, _modelJs.GlyphMarginLane).Center;
    }
    computeSync() {
        const toHoverMessage = (contents)=>{
            return {
                value: contents
            };
        };
        const lineDecorations = this._editor.getLineDecorations(this._lineNumber);
        const result = [];
        const isLineHover = this._laneOrLine === "lineNo";
        if (!lineDecorations) return result;
        for (const d of lineDecorations){
            const lane = d.options.glyphMargin?.position ?? (0, _modelJs.GlyphMarginLane).Center;
            if (!isLineHover && lane !== this._laneOrLine) continue;
            const hoverMessage = isLineHover ? d.options.lineNumberHoverMessage : d.options.glyphMarginHoverMessage;
            if (!hoverMessage || (0, _htmlContentJs.isEmptyMarkdownString)(hoverMessage)) continue;
            result.push(...(0, _arraysJs.asArray)(hoverMessage).map(toHoverMessage));
        }
        return result;
    }
}

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/htmlContent.js":"3Hxzm","../../../common/model.js":"1CSIB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jKoKx":[function() {},{}],"jM2rh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverAccessibleView", ()=>HoverAccessibleView);
parcelHelpers.export(exports, "HoverAccessibilityHelp", ()=>HoverAccessibilityHelp);
parcelHelpers.export(exports, "ExtHoverAccessibleView", ()=>ExtHoverAccessibleView);
class HoverAccessibleView {
}
class HoverAccessibilityHelp {
}
class ExtHoverAccessibleView {
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lqLEk":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IndentationToSpacesAction", ()=>IndentationToSpacesAction);
parcelHelpers.export(exports, "IndentationToTabsAction", ()=>IndentationToTabsAction);
parcelHelpers.export(exports, "ChangeIndentationSizeAction", ()=>ChangeIndentationSizeAction);
parcelHelpers.export(exports, "IndentUsingTabs", ()=>IndentUsingTabs);
parcelHelpers.export(exports, "IndentUsingSpaces", ()=>IndentUsingSpaces);
parcelHelpers.export(exports, "ChangeTabDisplaySize", ()=>ChangeTabDisplaySize);
parcelHelpers.export(exports, "DetectIndentation", ()=>DetectIndentation);
parcelHelpers.export(exports, "ReindentLinesAction", ()=>ReindentLinesAction);
parcelHelpers.export(exports, "ReindentSelectedLinesAction", ()=>ReindentSelectedLinesAction);
parcelHelpers.export(exports, "AutoIndentOnPasteCommand", ()=>AutoIndentOnPasteCommand);
parcelHelpers.export(exports, "AutoIndentOnPaste", ()=>AutoIndentOnPaste);
parcelHelpers.export(exports, "IndentationToSpacesCommand", ()=>IndentationToSpacesCommand);
parcelHelpers.export(exports, "IndentationToTabsCommand", ()=>IndentationToTabsCommand);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _shiftCommandJs = require("../../../common/commands/shiftCommand.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _modelJs = require("../../../common/services/model.js");
var _indentUtilsJs = require("../common/indentUtils.js");
var _nlsJs = require("../../../../nls.js");
var _quickInputJs = require("../../../../platform/quickinput/common/quickInput.js");
var _autoIndentJs = require("../../../common/languages/autoIndent.js");
var _indentationJs = require("../common/indentation.js");
var _lineTokensJs = require("../../../common/tokens/lineTokens.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class IndentationToSpacesAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.indentationToSpaces";
    }
    constructor(){
        super({
            id: IndentationToSpacesAction.ID,
            label: _nlsJs.localize("indentationToSpaces", "Convert Indentation to Spaces"),
            alias: "Convert Indentation to Spaces",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            metadata: {
                description: _nlsJs.localize2("indentationToSpacesDescription", "Convert the tab indentation to spaces.")
            }
        });
    }
    run(accessor, editor) {
        const model = editor.getModel();
        if (!model) return;
        const modelOpts = model.getOptions();
        const selection = editor.getSelection();
        if (!selection) return;
        const command = new IndentationToSpacesCommand(selection, modelOpts.tabSize);
        editor.pushUndoStop();
        editor.executeCommands(this.id, [
            command
        ]);
        editor.pushUndoStop();
        model.updateOptions({
            insertSpaces: true
        });
    }
}
class IndentationToTabsAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.indentationToTabs";
    }
    constructor(){
        super({
            id: IndentationToTabsAction.ID,
            label: _nlsJs.localize("indentationToTabs", "Convert Indentation to Tabs"),
            alias: "Convert Indentation to Tabs",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            metadata: {
                description: _nlsJs.localize2("indentationToTabsDescription", "Convert the spaces indentation to tabs.")
            }
        });
    }
    run(accessor, editor) {
        const model = editor.getModel();
        if (!model) return;
        const modelOpts = model.getOptions();
        const selection = editor.getSelection();
        if (!selection) return;
        const command = new IndentationToTabsCommand(selection, modelOpts.tabSize);
        editor.pushUndoStop();
        editor.executeCommands(this.id, [
            command
        ]);
        editor.pushUndoStop();
        model.updateOptions({
            insertSpaces: false
        });
    }
}
class ChangeIndentationSizeAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(insertSpaces, displaySizeOnly, opts){
        super(opts);
        this.insertSpaces = insertSpaces;
        this.displaySizeOnly = displaySizeOnly;
    }
    run(accessor, editor) {
        const quickInputService = accessor.get((0, _quickInputJs.IQuickInputService));
        const modelService = accessor.get((0, _modelJs.IModelService));
        const model = editor.getModel();
        if (!model) return;
        const creationOpts = modelService.getCreationOptions(model.getLanguageId(), model.uri, model.isForSimpleWidget);
        const modelOpts = model.getOptions();
        const picks = [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8
        ].map((n)=>({
                id: n.toString(),
                label: n.toString(),
                // add description for tabSize value set in the configuration
                description: n === creationOpts.tabSize && n === modelOpts.tabSize ? _nlsJs.localize("configuredTabSize", "Configured Tab Size") : n === creationOpts.tabSize ? _nlsJs.localize("defaultTabSize", "Default Tab Size") : n === modelOpts.tabSize ? _nlsJs.localize("currentTabSize", "Current Tab Size") : undefined
            }));
        // auto focus the tabSize set for the current editor
        const autoFocusIndex = Math.min(model.getOptions().tabSize - 1, 7);
        setTimeout(()=>{
            quickInputService.pick(picks, {
                placeHolder: _nlsJs.localize({
                    key: "selectTabWidth",
                    comment: [
                        "Tab corresponds to the tab key"
                    ]
                }, "Select Tab Size for Current File"),
                activeItem: picks[autoFocusIndex]
            }).then((pick)=>{
                if (pick) {
                    if (model && !model.isDisposed()) {
                        const pickedVal = parseInt(pick.label, 10);
                        if (this.displaySizeOnly) model.updateOptions({
                            tabSize: pickedVal
                        });
                        else model.updateOptions({
                            tabSize: pickedVal,
                            indentSize: pickedVal,
                            insertSpaces: this.insertSpaces
                        });
                    }
                }
            });
        }, 50 /* quick input is sensitive to being opened so soon after another */ );
    }
}
class IndentUsingTabs extends ChangeIndentationSizeAction {
    static{
        this.ID = "editor.action.indentUsingTabs";
    }
    constructor(){
        super(false, false, {
            id: IndentUsingTabs.ID,
            label: _nlsJs.localize("indentUsingTabs", "Indent Using Tabs"),
            alias: "Indent Using Tabs",
            precondition: undefined,
            metadata: {
                description: _nlsJs.localize2("indentUsingTabsDescription", "Use indentation with tabs.")
            }
        });
    }
}
class IndentUsingSpaces extends ChangeIndentationSizeAction {
    static{
        this.ID = "editor.action.indentUsingSpaces";
    }
    constructor(){
        super(true, false, {
            id: IndentUsingSpaces.ID,
            label: _nlsJs.localize("indentUsingSpaces", "Indent Using Spaces"),
            alias: "Indent Using Spaces",
            precondition: undefined,
            metadata: {
                description: _nlsJs.localize2("indentUsingSpacesDescription", "Use indentation with spaces.")
            }
        });
    }
}
class ChangeTabDisplaySize extends ChangeIndentationSizeAction {
    static{
        this.ID = "editor.action.changeTabDisplaySize";
    }
    constructor(){
        super(true, true, {
            id: ChangeTabDisplaySize.ID,
            label: _nlsJs.localize("changeTabDisplaySize", "Change Tab Display Size"),
            alias: "Change Tab Display Size",
            precondition: undefined,
            metadata: {
                description: _nlsJs.localize2("changeTabDisplaySizeDescription", "Change the space size equivalent of the tab.")
            }
        });
    }
}
class DetectIndentation extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.detectIndentation";
    }
    constructor(){
        super({
            id: DetectIndentation.ID,
            label: _nlsJs.localize("detectIndentation", "Detect Indentation from Content"),
            alias: "Detect Indentation from Content",
            precondition: undefined,
            metadata: {
                description: _nlsJs.localize2("detectIndentationDescription", "Detect the indentation from content.")
            }
        });
    }
    run(accessor, editor) {
        const modelService = accessor.get((0, _modelJs.IModelService));
        const model = editor.getModel();
        if (!model) return;
        const creationOpts = modelService.getCreationOptions(model.getLanguageId(), model.uri, model.isForSimpleWidget);
        model.detectIndentation(creationOpts.insertSpaces, creationOpts.tabSize);
    }
}
class ReindentLinesAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.reindentlines",
            label: _nlsJs.localize("editor.reindentlines", "Reindent Lines"),
            alias: "Reindent Lines",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            metadata: {
                description: _nlsJs.localize2("editor.reindentlinesDescription", "Reindent the lines of the editor.")
            }
        });
    }
    run(accessor, editor) {
        const languageConfigurationService = accessor.get((0, _languageConfigurationRegistryJs.ILanguageConfigurationService));
        const model = editor.getModel();
        if (!model) return;
        const edits = (0, _indentationJs.getReindentEditOperations)(model, languageConfigurationService, 1, model.getLineCount());
        if (edits.length > 0) {
            editor.pushUndoStop();
            editor.executeEdits(this.id, edits);
            editor.pushUndoStop();
        }
    }
}
class ReindentSelectedLinesAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.reindentselectedlines",
            label: _nlsJs.localize("editor.reindentselectedlines", "Reindent Selected Lines"),
            alias: "Reindent Selected Lines",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            metadata: {
                description: _nlsJs.localize2("editor.reindentselectedlinesDescription", "Reindent the selected lines of the editor.")
            }
        });
    }
    run(accessor, editor) {
        const languageConfigurationService = accessor.get((0, _languageConfigurationRegistryJs.ILanguageConfigurationService));
        const model = editor.getModel();
        if (!model) return;
        const selections = editor.getSelections();
        if (selections === null) return;
        const edits = [];
        for (const selection of selections){
            let startLineNumber = selection.startLineNumber;
            let endLineNumber = selection.endLineNumber;
            if (startLineNumber !== endLineNumber && selection.endColumn === 1) endLineNumber--;
            if (startLineNumber === 1) {
                if (startLineNumber === endLineNumber) continue;
            } else startLineNumber--;
            const editOperations = (0, _indentationJs.getReindentEditOperations)(model, languageConfigurationService, startLineNumber, endLineNumber);
            edits.push(...editOperations);
        }
        if (edits.length > 0) {
            editor.pushUndoStop();
            editor.executeEdits(this.id, edits);
            editor.pushUndoStop();
        }
    }
}
class AutoIndentOnPasteCommand {
    constructor(edits, initialSelection){
        this._initialSelection = initialSelection;
        this._edits = [];
        this._selectionId = null;
        for (const edit of edits)if (edit.range && typeof edit.text === "string") this._edits.push(edit);
    }
    getEditOperations(model, builder) {
        for (const edit of this._edits)builder.addEditOperation((0, _rangeJs.Range).lift(edit.range), edit.text);
        let selectionIsSet = false;
        if (Array.isArray(this._edits) && this._edits.length === 1 && this._initialSelection.isEmpty()) {
            if (this._edits[0].range.startColumn === this._initialSelection.endColumn && this._edits[0].range.startLineNumber === this._initialSelection.endLineNumber) {
                selectionIsSet = true;
                this._selectionId = builder.trackSelection(this._initialSelection, true);
            } else if (this._edits[0].range.endColumn === this._initialSelection.startColumn && this._edits[0].range.endLineNumber === this._initialSelection.startLineNumber) {
                selectionIsSet = true;
                this._selectionId = builder.trackSelection(this._initialSelection, false);
            }
        }
        if (!selectionIsSet) this._selectionId = builder.trackSelection(this._initialSelection);
    }
    computeCursorState(model, helper) {
        return helper.getTrackedSelection(this._selectionId);
    }
}
let AutoIndentOnPaste = class AutoIndentOnPaste {
    static{
        this.ID = "editor.contrib.autoIndentOnPaste";
    }
    constructor(editor, _languageConfigurationService){
        this.editor = editor;
        this._languageConfigurationService = _languageConfigurationService;
        this.callOnDispose = new (0, _lifecycleJs.DisposableStore)();
        this.callOnModel = new (0, _lifecycleJs.DisposableStore)();
        this.callOnDispose.add(editor.onDidChangeConfiguration(()=>this.update()));
        this.callOnDispose.add(editor.onDidChangeModel(()=>this.update()));
        this.callOnDispose.add(editor.onDidChangeModelLanguage(()=>this.update()));
    }
    update() {
        // clean up
        this.callOnModel.clear();
        // we are disabled
        if (this.editor.getOption(12 /* EditorOption.autoIndent */ ) < 4 /* EditorAutoIndentStrategy.Full */  || this.editor.getOption(55 /* EditorOption.formatOnPaste */ )) return;
        // no model
        if (!this.editor.hasModel()) return;
        this.callOnModel.add(this.editor.onDidPaste(({ range })=>{
            this.trigger(range);
        }));
    }
    trigger(range) {
        const selections = this.editor.getSelections();
        if (selections === null || selections.length > 1) return;
        const model = this.editor.getModel();
        if (!model) return;
        const containsOnlyWhitespace = this.rangeContainsOnlyWhitespaceCharacters(model, range);
        if (containsOnlyWhitespace) return;
        if (isStartOrEndInString(model, range)) return;
        if (!model.tokenization.isCheapToTokenize(range.getStartPosition().lineNumber)) return;
        const autoIndent = this.editor.getOption(12 /* EditorOption.autoIndent */ );
        const { tabSize, indentSize, insertSpaces } = model.getOptions();
        const textEdits = [];
        const indentConverter = {
            shiftIndent: (indentation)=>{
                return (0, _shiftCommandJs.ShiftCommand).shiftIndent(indentation, indentation.length + 1, tabSize, indentSize, insertSpaces);
            },
            unshiftIndent: (indentation)=>{
                return (0, _shiftCommandJs.ShiftCommand).unshiftIndent(indentation, indentation.length + 1, tabSize, indentSize, insertSpaces);
            }
        };
        let startLineNumber = range.startLineNumber;
        while(startLineNumber <= range.endLineNumber){
            if (this.shouldIgnoreLine(model, startLineNumber)) {
                startLineNumber++;
                continue;
            }
            break;
        }
        if (startLineNumber > range.endLineNumber) return;
        let firstLineText = model.getLineContent(startLineNumber);
        if (!/\S/.test(firstLineText.substring(0, range.startColumn - 1))) {
            const indentOfFirstLine = (0, _autoIndentJs.getGoodIndentForLine)(autoIndent, model, model.getLanguageId(), startLineNumber, indentConverter, this._languageConfigurationService);
            if (indentOfFirstLine !== null) {
                const oldIndentation = _stringsJs.getLeadingWhitespace(firstLineText);
                const newSpaceCnt = _indentUtilsJs.getSpaceCnt(indentOfFirstLine, tabSize);
                const oldSpaceCnt = _indentUtilsJs.getSpaceCnt(oldIndentation, tabSize);
                if (newSpaceCnt !== oldSpaceCnt) {
                    const newIndent = _indentUtilsJs.generateIndent(newSpaceCnt, tabSize, insertSpaces);
                    textEdits.push({
                        range: new (0, _rangeJs.Range)(startLineNumber, 1, startLineNumber, oldIndentation.length + 1),
                        text: newIndent
                    });
                    firstLineText = newIndent + firstLineText.substring(oldIndentation.length);
                } else {
                    const indentMetadata = (0, _autoIndentJs.getIndentMetadata)(model, startLineNumber, this._languageConfigurationService);
                    if (indentMetadata === 0 || indentMetadata === 8 /* IndentConsts.UNINDENT_MASK */ ) // we paste content into a line where only contains whitespaces
                    // after pasting, the indentation of the first line is already correct
                    // the first line doesn't match any indentation rule
                    // then no-op.
                    return;
                }
            }
        }
        const firstLineNumber = startLineNumber;
        // ignore empty or ignored lines
        while(startLineNumber < range.endLineNumber){
            if (!/\S/.test(model.getLineContent(startLineNumber + 1))) {
                startLineNumber++;
                continue;
            }
            break;
        }
        if (startLineNumber !== range.endLineNumber) {
            const virtualModel = {
                tokenization: {
                    getLineTokens: (lineNumber)=>{
                        return model.tokenization.getLineTokens(lineNumber);
                    },
                    getLanguageId: ()=>{
                        return model.getLanguageId();
                    },
                    getLanguageIdAtPosition: (lineNumber, column)=>{
                        return model.getLanguageIdAtPosition(lineNumber, column);
                    }
                },
                getLineContent: (lineNumber)=>{
                    if (lineNumber === firstLineNumber) return firstLineText;
                    else return model.getLineContent(lineNumber);
                }
            };
            const indentOfSecondLine = (0, _autoIndentJs.getGoodIndentForLine)(autoIndent, virtualModel, model.getLanguageId(), startLineNumber + 1, indentConverter, this._languageConfigurationService);
            if (indentOfSecondLine !== null) {
                const newSpaceCntOfSecondLine = _indentUtilsJs.getSpaceCnt(indentOfSecondLine, tabSize);
                const oldSpaceCntOfSecondLine = _indentUtilsJs.getSpaceCnt(_stringsJs.getLeadingWhitespace(model.getLineContent(startLineNumber + 1)), tabSize);
                if (newSpaceCntOfSecondLine !== oldSpaceCntOfSecondLine) {
                    const spaceCntOffset = newSpaceCntOfSecondLine - oldSpaceCntOfSecondLine;
                    for(let i = startLineNumber + 1; i <= range.endLineNumber; i++){
                        const lineContent = model.getLineContent(i);
                        const originalIndent = _stringsJs.getLeadingWhitespace(lineContent);
                        const originalSpacesCnt = _indentUtilsJs.getSpaceCnt(originalIndent, tabSize);
                        const newSpacesCnt = originalSpacesCnt + spaceCntOffset;
                        const newIndent = _indentUtilsJs.generateIndent(newSpacesCnt, tabSize, insertSpaces);
                        if (newIndent !== originalIndent) textEdits.push({
                            range: new (0, _rangeJs.Range)(i, 1, i, originalIndent.length + 1),
                            text: newIndent
                        });
                    }
                }
            }
        }
        if (textEdits.length > 0) {
            this.editor.pushUndoStop();
            const cmd = new AutoIndentOnPasteCommand(textEdits, this.editor.getSelection());
            this.editor.executeCommand("autoIndentOnPaste", cmd);
            this.editor.pushUndoStop();
        }
    }
    rangeContainsOnlyWhitespaceCharacters(model, range) {
        const lineContainsOnlyWhitespace = (content)=>{
            return content.trim().length === 0;
        };
        let containsOnlyWhitespace = true;
        if (range.startLineNumber === range.endLineNumber) {
            const lineContent = model.getLineContent(range.startLineNumber);
            const linePart = lineContent.substring(range.startColumn - 1, range.endColumn - 1);
            containsOnlyWhitespace = lineContainsOnlyWhitespace(linePart);
        } else for(let i = range.startLineNumber; i <= range.endLineNumber; i++){
            const lineContent = model.getLineContent(i);
            if (i === range.startLineNumber) {
                const linePart = lineContent.substring(range.startColumn - 1);
                containsOnlyWhitespace = lineContainsOnlyWhitespace(linePart);
            } else if (i === range.endLineNumber) {
                const linePart = lineContent.substring(0, range.endColumn - 1);
                containsOnlyWhitespace = lineContainsOnlyWhitespace(linePart);
            } else containsOnlyWhitespace = model.getLineFirstNonWhitespaceColumn(i) === 0;
            if (!containsOnlyWhitespace) break;
        }
        return containsOnlyWhitespace;
    }
    shouldIgnoreLine(model, lineNumber) {
        model.tokenization.forceTokenization(lineNumber);
        const nonWhitespaceColumn = model.getLineFirstNonWhitespaceColumn(lineNumber);
        if (nonWhitespaceColumn === 0) return true;
        const tokens = model.tokenization.getLineTokens(lineNumber);
        if (tokens.getCount() > 0) {
            const firstNonWhitespaceTokenIndex = tokens.findTokenIndexAtOffset(nonWhitespaceColumn);
            if (firstNonWhitespaceTokenIndex >= 0 && tokens.getStandardTokenType(firstNonWhitespaceTokenIndex) === 1 /* StandardTokenType.Comment */ ) return true;
        }
        return false;
    }
    dispose() {
        this.callOnDispose.dispose();
        this.callOnModel.dispose();
    }
};
AutoIndentOnPaste = __decorate([
    __param(1, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService))
], AutoIndentOnPaste);
function isStartOrEndInString(model, range) {
    const isPositionInString = (position)=>{
        const tokenType = (0, _lineTokensJs.getStandardTokenTypeAtPosition)(model, position);
        return tokenType === 2 /* StandardTokenType.String */ ;
    };
    return isPositionInString(range.getStartPosition()) || isPositionInString(range.getEndPosition());
}
function getIndentationEditOperations(model, builder, tabSize, tabsToSpaces) {
    if (model.getLineCount() === 1 && model.getLineMaxColumn(1) === 1) // Model is empty
    return;
    let spaces = "";
    for(let i = 0; i < tabSize; i++)spaces += " ";
    const spacesRegExp = new RegExp(spaces, "gi");
    for(let lineNumber = 1, lineCount = model.getLineCount(); lineNumber <= lineCount; lineNumber++){
        let lastIndentationColumn = model.getLineFirstNonWhitespaceColumn(lineNumber);
        if (lastIndentationColumn === 0) lastIndentationColumn = model.getLineMaxColumn(lineNumber);
        if (lastIndentationColumn === 1) continue;
        const originalIndentationRange = new (0, _rangeJs.Range)(lineNumber, 1, lineNumber, lastIndentationColumn);
        const originalIndentation = model.getValueInRange(originalIndentationRange);
        const newIndentation = tabsToSpaces ? originalIndentation.replace(/\t/ig, spaces) : originalIndentation.replace(spacesRegExp, "	");
        builder.addEditOperation(originalIndentationRange, newIndentation);
    }
}
class IndentationToSpacesCommand {
    constructor(selection, tabSize){
        this.selection = selection;
        this.tabSize = tabSize;
        this.selectionId = null;
    }
    getEditOperations(model, builder) {
        this.selectionId = builder.trackSelection(this.selection);
        getIndentationEditOperations(model, builder, this.tabSize, true);
    }
    computeCursorState(model, helper) {
        return helper.getTrackedSelection(this.selectionId);
    }
}
class IndentationToTabsCommand {
    constructor(selection, tabSize){
        this.selection = selection;
        this.tabSize = tabSize;
        this.selectionId = null;
    }
    getEditOperations(model, builder) {
        this.selectionId = builder.trackSelection(this.selection);
        getIndentationEditOperations(model, builder, this.tabSize, false);
    }
    computeCursorState(model, helper) {
        return helper.getTrackedSelection(this.selectionId);
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(AutoIndentOnPaste.ID, AutoIndentOnPaste, 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );
(0, _editorExtensionsJs.registerEditorAction)(IndentationToSpacesAction);
(0, _editorExtensionsJs.registerEditorAction)(IndentationToTabsAction);
(0, _editorExtensionsJs.registerEditorAction)(IndentUsingTabs);
(0, _editorExtensionsJs.registerEditorAction)(IndentUsingSpaces);
(0, _editorExtensionsJs.registerEditorAction)(ChangeTabDisplaySize);
(0, _editorExtensionsJs.registerEditorAction)(DetectIndentation);
(0, _editorExtensionsJs.registerEditorAction)(ReindentLinesAction);
(0, _editorExtensionsJs.registerEditorAction)(ReindentSelectedLinesAction);

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/strings.js":"aA9I1","../../../browser/editorExtensions.js":"kC3w6","../../../common/commands/shiftCommand.js":"3JtMW","../../../common/core/range.js":"jmUPh","../../../common/editorContextKeys.js":"5exv9","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../common/services/model.js":"aciVm","../common/indentUtils.js":"bYvgh","../../../../nls.js":"l617d","../../../../platform/quickinput/common/quickInput.js":"a56M6","../../../common/languages/autoIndent.js":"c4ZuY","../common/indentation.js":"lPX2D","../../../common/tokens/lineTokens.js":"6iUVx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bYvgh":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSpaceCnt", ()=>getSpaceCnt);
parcelHelpers.export(exports, "generateIndent", ()=>generateIndent);
function getSpaceCnt(str, tabSize) {
    let spacesCnt = 0;
    for(let i = 0; i < str.length; i++)if (str.charAt(i) === "	") spacesCnt += tabSize;
    else spacesCnt++;
    return spacesCnt;
}
function generateIndent(spacesCnt, tabSize, insertSpaces) {
    spacesCnt = spacesCnt < 0 ? 0 : spacesCnt;
    let result = "";
    if (!insertSpaces) {
        const tabsCnt = Math.floor(spacesCnt / tabSize);
        spacesCnt = spacesCnt % tabSize;
        for(let i = 0; i < tabsCnt; i++)result += "	";
    }
    for(let i = 0; i < spacesCnt; i++)result += " ";
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lPX2D":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getReindentEditOperations", ()=>getReindentEditOperations);
var _stringsJs = require("../../../../base/common/strings.js");
var _shiftCommandJs = require("../../../common/commands/shiftCommand.js");
var _editOperationJs = require("../../../common/core/editOperation.js");
var _indentationJs = require("../../../common/core/indentation.js");
var _selectionJs = require("../../../common/core/selection.js");
var _indentationLineProcessorJs = require("../../../common/languages/supports/indentationLineProcessor.js");
function getReindentEditOperations(model, languageConfigurationService, startLineNumber, endLineNumber) {
    if (model.getLineCount() === 1 && model.getLineMaxColumn(1) === 1) // Model is empty
    return [];
    const indentationRulesSupport = languageConfigurationService.getLanguageConfiguration(model.getLanguageId()).indentRulesSupport;
    if (!indentationRulesSupport) return [];
    const processedIndentRulesSupport = new (0, _indentationLineProcessorJs.ProcessedIndentRulesSupport)(model, indentationRulesSupport, languageConfigurationService);
    endLineNumber = Math.min(endLineNumber, model.getLineCount());
    // Skip `unIndentedLinePattern` lines
    while(startLineNumber <= endLineNumber){
        if (!processedIndentRulesSupport.shouldIgnore(startLineNumber)) break;
        startLineNumber++;
    }
    if (startLineNumber > endLineNumber - 1) return [];
    const { tabSize, indentSize, insertSpaces } = model.getOptions();
    const shiftIndent = (indentation, count)=>{
        count = count || 1;
        return (0, _shiftCommandJs.ShiftCommand).shiftIndent(indentation, indentation.length + count, tabSize, indentSize, insertSpaces);
    };
    const unshiftIndent = (indentation, count)=>{
        count = count || 1;
        return (0, _shiftCommandJs.ShiftCommand).unshiftIndent(indentation, indentation.length + count, tabSize, indentSize, insertSpaces);
    };
    const indentEdits = [];
    // indentation being passed to lines below
    // Calculate indentation for the first line
    // If there is no passed-in indentation, we use the indentation of the first line as base.
    const currentLineText = model.getLineContent(startLineNumber);
    let globalIndent = _stringsJs.getLeadingWhitespace(currentLineText);
    // idealIndentForNextLine doesn't equal globalIndent when there is a line matching `indentNextLinePattern`.
    let idealIndentForNextLine = globalIndent;
    if (processedIndentRulesSupport.shouldIncrease(startLineNumber)) {
        idealIndentForNextLine = shiftIndent(idealIndentForNextLine);
        globalIndent = shiftIndent(globalIndent);
    } else if (processedIndentRulesSupport.shouldIndentNextLine(startLineNumber)) idealIndentForNextLine = shiftIndent(idealIndentForNextLine);
    startLineNumber++;
    // Calculate indentation adjustment for all following lines
    for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++){
        if (doesLineStartWithString(model, lineNumber)) continue;
        const text = model.getLineContent(lineNumber);
        const oldIndentation = _stringsJs.getLeadingWhitespace(text);
        const currentIdealIndent = idealIndentForNextLine;
        if (processedIndentRulesSupport.shouldDecrease(lineNumber, currentIdealIndent)) {
            idealIndentForNextLine = unshiftIndent(idealIndentForNextLine);
            globalIndent = unshiftIndent(globalIndent);
        }
        if (oldIndentation !== idealIndentForNextLine) indentEdits.push((0, _editOperationJs.EditOperation).replaceMove(new (0, _selectionJs.Selection)(lineNumber, 1, lineNumber, oldIndentation.length + 1), (0, _indentationJs.normalizeIndentation)(idealIndentForNextLine, indentSize, insertSpaces)));
        // calculate idealIndentForNextLine
        if (processedIndentRulesSupport.shouldIgnore(lineNumber)) continue;
        else if (processedIndentRulesSupport.shouldIncrease(lineNumber, currentIdealIndent)) {
            globalIndent = shiftIndent(globalIndent);
            idealIndentForNextLine = globalIndent;
        } else if (processedIndentRulesSupport.shouldIndentNextLine(lineNumber, currentIdealIndent)) idealIndentForNextLine = shiftIndent(idealIndentForNextLine);
        else idealIndentForNextLine = globalIndent;
    }
    return indentEdits;
}
function doesLineStartWithString(model, lineNumber) {
    if (!model.tokenization.isCheapToTokenize(lineNumber)) return false;
    const lineTokens = model.tokenization.getLineTokens(lineNumber);
    return lineTokens.getStandardTokenType(0) === 2 /* StandardTokenType.String */ ;
}

},{"../../../../base/common/strings.js":"aA9I1","../../../common/commands/shiftCommand.js":"3JtMW","../../../common/core/editOperation.js":"6r2FZ","../../../common/core/indentation.js":"7FtDC","../../../common/core/selection.js":"kcwzU","../../../common/languages/supports/indentationLineProcessor.js":"44GwO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1WSAT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _hoverTypesJs = require("../../hover/browser/hoverTypes.js");
var _inlayHintsControllerJs = require("./inlayHintsController.js");
var _inlayHintsHoverJs = require("./inlayHintsHover.js");
(0, _editorExtensionsJs.registerEditorContribution)((0, _inlayHintsControllerJs.InlayHintsController).ID, (0, _inlayHintsControllerJs.InlayHintsController), 1 /* EditorContributionInstantiation.AfterFirstRender */ );
(0, _hoverTypesJs.HoverParticipantRegistry).register((0, _inlayHintsHoverJs.InlayHintsHover));

},{"../../../browser/editorExtensions.js":"kC3w6","../../hover/browser/hoverTypes.js":"6vmRi","./inlayHintsController.js":"hylHy","./inlayHintsHover.js":"1SEMh"}],"bwMPX":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _asyncJs = require("../../../../base/common/async.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _editorStateJs = require("../../editorState/browser/editorState.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _editorWorkerJs = require("../../../common/services/editorWorker.js");
var _nlsJs = require("../../../../nls.js");
var _inPlaceReplaceCommandJs = require("./inPlaceReplaceCommand.js");
var _inPlaceReplaceCss = require("./inPlaceReplace.css");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var InPlaceReplaceController_1;
let InPlaceReplaceController = class InPlaceReplaceController {
    static{
        InPlaceReplaceController_1 = this;
    }
    static{
        this.ID = "editor.contrib.inPlaceReplaceController";
    }
    static get(editor) {
        return editor.getContribution(InPlaceReplaceController_1.ID);
    }
    static{
        this.DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "in-place-replace",
            className: "valueSetReplacement"
        });
    }
    constructor(editor, editorWorkerService){
        this.editor = editor;
        this.editorWorkerService = editorWorkerService;
        this.decorations = this.editor.createDecorationsCollection();
    }
    dispose() {}
    run(source, up) {
        // cancel any pending request
        this.currentRequest?.cancel();
        const editorSelection = this.editor.getSelection();
        const model = this.editor.getModel();
        if (!model || !editorSelection) return undefined;
        let selection = editorSelection;
        if (selection.startLineNumber !== selection.endLineNumber) // Can't accept multiline selection
        return undefined;
        const state = new (0, _editorStateJs.EditorState)(this.editor, 5 /* CodeEditorStateFlag.Position */ );
        const modelURI = model.uri;
        if (!this.editorWorkerService.canNavigateValueSet(modelURI)) return Promise.resolve(undefined);
        this.currentRequest = (0, _asyncJs.createCancelablePromise)((token)=>this.editorWorkerService.navigateValueSet(modelURI, selection, up));
        return this.currentRequest.then((result)=>{
            if (!result || !result.range || !result.value) // No proper result
            return;
            if (!state.validate(this.editor)) // state has changed
            return;
            // Selection
            const editRange = (0, _rangeJs.Range).lift(result.range);
            let highlightRange = result.range;
            const diff = result.value.length - (selection.endColumn - selection.startColumn);
            // highlight
            highlightRange = {
                startLineNumber: highlightRange.startLineNumber,
                startColumn: highlightRange.startColumn,
                endLineNumber: highlightRange.endLineNumber,
                endColumn: highlightRange.startColumn + result.value.length
            };
            if (diff > 1) selection = new (0, _selectionJs.Selection)(selection.startLineNumber, selection.startColumn, selection.endLineNumber, selection.endColumn + diff - 1);
            // Insert new text
            const command = new (0, _inPlaceReplaceCommandJs.InPlaceReplaceCommand)(editRange, selection, result.value);
            this.editor.pushUndoStop();
            this.editor.executeCommand(source, command);
            this.editor.pushUndoStop();
            // add decoration
            this.decorations.set([
                {
                    range: highlightRange,
                    options: InPlaceReplaceController_1.DECORATION
                }
            ]);
            // remove decoration after delay
            this.decorationRemover?.cancel();
            this.decorationRemover = (0, _asyncJs.timeout)(350);
            this.decorationRemover.then(()=>this.decorations.clear()).catch((0, _errorsJs.onUnexpectedError));
        }).catch((0, _errorsJs.onUnexpectedError));
    }
};
InPlaceReplaceController = InPlaceReplaceController_1 = __decorate([
    __param(1, (0, _editorWorkerJs.IEditorWorkerService))
], InPlaceReplaceController);
class InPlaceReplaceUp extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.inPlaceReplace.up",
            label: _nlsJs.localize("InPlaceReplaceAction.previous.label", "Replace with Previous Value"),
            alias: "Replace with Previous Value",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 3159 /* KeyCode.Comma */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(accessor, editor) {
        const controller = InPlaceReplaceController.get(editor);
        if (!controller) return Promise.resolve(undefined);
        return controller.run(this.id, false);
    }
}
class InPlaceReplaceDown extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.inPlaceReplace.down",
            label: _nlsJs.localize("InPlaceReplaceAction.next.label", "Replace with Next Value"),
            alias: "Replace with Next Value",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 3161 /* KeyCode.Period */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(accessor, editor) {
        const controller = InPlaceReplaceController.get(editor);
        if (!controller) return Promise.resolve(undefined);
        return controller.run(this.id, true);
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(InPlaceReplaceController.ID, InPlaceReplaceController, 4 /* EditorContributionInstantiation.Lazy */ );
(0, _editorExtensionsJs.registerEditorAction)(InPlaceReplaceUp);
(0, _editorExtensionsJs.registerEditorAction)(InPlaceReplaceDown);

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/errors.js":"divX8","../../editorState/browser/editorState.js":"hyVHM","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/editorContextKeys.js":"5exv9","../../../common/model/textModel.js":"9beDe","../../../common/services/editorWorker.js":"aaYJd","../../../../nls.js":"l617d","./inPlaceReplaceCommand.js":"2D806","./inPlaceReplace.css":"9kpb4"}],"2D806":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InPlaceReplaceCommand", ()=>InPlaceReplaceCommand);
var _selectionJs = require("../../../common/core/selection.js");
class InPlaceReplaceCommand {
    constructor(editRange, originalSelection, text){
        this._editRange = editRange;
        this._originalSelection = originalSelection;
        this._text = text;
    }
    getEditOperations(model, builder) {
        builder.addTrackedEditOperation(this._editRange, this._text);
    }
    computeCursorState(model, helper) {
        const inverseEditOperations = helper.getInverseEditOperations();
        const srcRange = inverseEditOperations[0].range;
        if (!this._originalSelection.isEmpty()) // Preserve selection and extends to typed text
        return new (0, _selectionJs.Selection)(srcRange.endLineNumber, srcRange.endColumn - this._text.length, srcRange.endLineNumber, srcRange.endColumn);
        return new (0, _selectionJs.Selection)(srcRange.endLineNumber, Math.min(this._originalSelection.positionColumn, srcRange.endColumn), srcRange.endLineNumber, Math.min(this._originalSelection.positionColumn, srcRange.endColumn));
    }
}

},{"../../../common/core/selection.js":"kcwzU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9kpb4":[function() {},{}],"1Yron":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExpandLineSelectionAction", ()=>ExpandLineSelectionAction);
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _cursorMoveCommandsJs = require("../../../common/cursor/cursorMoveCommands.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _nlsJs = require("../../../../nls.js");
class ExpandLineSelectionAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "expandLineSelection",
            label: _nlsJs.localize("expandLineSelection", "Expand Line Selection"),
            alias: "Expand Line Selection",
            precondition: undefined,
            kbOpts: {
                weight: 0 /* KeybindingWeight.EditorCore */ ,
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 2090 /* KeyCode.KeyL */ 
            }
        });
    }
    run(_accessor, editor, args) {
        args = args || {};
        if (!editor.hasModel()) return;
        const viewModel = editor._getViewModel();
        viewModel.model.pushStackElement();
        viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , (0, _cursorMoveCommandsJs.CursorMoveCommands).expandLineSelection(viewModel, viewModel.getCursorStates()));
        viewModel.revealAllCursors(args.source, true);
    }
}
(0, _editorExtensionsJs.registerEditorAction)(ExpandLineSelectionAction);

},{"../../../browser/editorExtensions.js":"kC3w6","../../../common/cursor/cursorMoveCommands.js":"sl4rn","../../../common/editorContextKeys.js":"5exv9","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h0mDH":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DuplicateSelectionAction", ()=>DuplicateSelectionAction);
parcelHelpers.export(exports, "AbstractSortLinesAction", ()=>AbstractSortLinesAction);
parcelHelpers.export(exports, "SortLinesAscendingAction", ()=>SortLinesAscendingAction);
parcelHelpers.export(exports, "SortLinesDescendingAction", ()=>SortLinesDescendingAction);
parcelHelpers.export(exports, "DeleteDuplicateLinesAction", ()=>DeleteDuplicateLinesAction);
parcelHelpers.export(exports, "TrimTrailingWhitespaceAction", ()=>TrimTrailingWhitespaceAction);
parcelHelpers.export(exports, "DeleteLinesAction", ()=>DeleteLinesAction);
parcelHelpers.export(exports, "IndentLinesAction", ()=>IndentLinesAction);
parcelHelpers.export(exports, "InsertLineBeforeAction", ()=>InsertLineBeforeAction);
parcelHelpers.export(exports, "InsertLineAfterAction", ()=>InsertLineAfterAction);
parcelHelpers.export(exports, "AbstractDeleteAllToBoundaryAction", ()=>AbstractDeleteAllToBoundaryAction);
parcelHelpers.export(exports, "DeleteAllLeftAction", ()=>DeleteAllLeftAction);
parcelHelpers.export(exports, "DeleteAllRightAction", ()=>DeleteAllRightAction);
parcelHelpers.export(exports, "JoinLinesAction", ()=>JoinLinesAction);
parcelHelpers.export(exports, "TransposeAction", ()=>TransposeAction);
parcelHelpers.export(exports, "AbstractCaseAction", ()=>AbstractCaseAction);
parcelHelpers.export(exports, "UpperCaseAction", ()=>UpperCaseAction);
parcelHelpers.export(exports, "LowerCaseAction", ()=>LowerCaseAction);
parcelHelpers.export(exports, "TitleCaseAction", ()=>TitleCaseAction);
parcelHelpers.export(exports, "SnakeCaseAction", ()=>SnakeCaseAction);
parcelHelpers.export(exports, "CamelCaseAction", ()=>CamelCaseAction);
parcelHelpers.export(exports, "PascalCaseAction", ()=>PascalCaseAction);
parcelHelpers.export(exports, "KebabCaseAction", ()=>KebabCaseAction);
var _keyCodesJs = require("../../../../base/common/keyCodes.js");
var _coreCommandsJs = require("../../../browser/coreCommands.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _replaceCommandJs = require("../../../common/commands/replaceCommand.js");
var _trimTrailingWhitespaceCommandJs = require("../../../common/commands/trimTrailingWhitespaceCommand.js");
var _cursorTypeOperationsJs = require("../../../common/cursor/cursorTypeOperations.js");
var _cursorTypeEditOperationsJs = require("../../../common/cursor/cursorTypeEditOperations.js");
var _editOperationJs = require("../../../common/core/editOperation.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _copyLinesCommandJs = require("./copyLinesCommand.js");
var _moveLinesCommandJs = require("./moveLinesCommand.js");
var _sortLinesCommandJs = require("./sortLinesCommand.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
// copy lines
class AbstractCopyLinesAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(down, opts){
        super(opts);
        this.down = down;
    }
    run(_accessor, editor) {
        if (!editor.hasModel()) return;
        const selections = editor.getSelections().map((selection, index)=>({
                selection,
                index,
                ignore: false
            }));
        selections.sort((a, b)=>(0, _rangeJs.Range).compareRangesUsingStarts(a.selection, b.selection));
        // Remove selections that would result in copying the same line
        let prev = selections[0];
        for(let i = 1; i < selections.length; i++){
            const curr = selections[i];
            if (prev.selection.endLineNumber === curr.selection.startLineNumber) {
                // these two selections would copy the same line
                if (prev.index < curr.index) // prev wins
                curr.ignore = true;
                else {
                    // curr wins
                    prev.ignore = true;
                    prev = curr;
                }
            }
        }
        const commands = [];
        for (const selection of selections)commands.push(new (0, _copyLinesCommandJs.CopyLinesCommand)(selection.selection, this.down, selection.ignore));
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    }
}
class CopyLinesUpAction extends AbstractCopyLinesAction {
    constructor(){
        super(false, {
            id: "editor.action.copyLinesUpAction",
            label: _nlsJs.localize("lines.copyUp", "Copy Line Up"),
            alias: "Copy Line Up",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 1552 /* KeyCode.UpArrow */ ,
                linux: {
                    primary: 3600 /* KeyCode.UpArrow */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "2_line",
                title: _nlsJs.localize({
                    key: "miCopyLinesUp",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "&&Copy Line Up"),
                order: 1
            }
        });
    }
}
class CopyLinesDownAction extends AbstractCopyLinesAction {
    constructor(){
        super(true, {
            id: "editor.action.copyLinesDownAction",
            label: _nlsJs.localize("lines.copyDown", "Copy Line Down"),
            alias: "Copy Line Down",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 1554 /* KeyCode.DownArrow */ ,
                linux: {
                    primary: 3602 /* KeyCode.DownArrow */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "2_line",
                title: _nlsJs.localize({
                    key: "miCopyLinesDown",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Co&&py Line Down"),
                order: 2
            }
        });
    }
}
class DuplicateSelectionAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.duplicateSelection",
            label: _nlsJs.localize("duplicateSelection", "Duplicate Selection"),
            alias: "Duplicate Selection",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "2_line",
                title: _nlsJs.localize({
                    key: "miDuplicateSelection",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "&&Duplicate Selection"),
                order: 5
            }
        });
    }
    run(accessor, editor, args) {
        if (!editor.hasModel()) return;
        const commands = [];
        const selections = editor.getSelections();
        const model = editor.getModel();
        for (const selection of selections)if (selection.isEmpty()) commands.push(new (0, _copyLinesCommandJs.CopyLinesCommand)(selection, true));
        else {
            const insertSelection = new (0, _selectionJs.Selection)(selection.endLineNumber, selection.endColumn, selection.endLineNumber, selection.endColumn);
            commands.push(new (0, _replaceCommandJs.ReplaceCommandThatSelectsText)(insertSelection, model.getValueInRange(selection)));
        }
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    }
}
// move lines
class AbstractMoveLinesAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(down, opts){
        super(opts);
        this.down = down;
    }
    run(accessor, editor) {
        const languageConfigurationService = accessor.get((0, _languageConfigurationRegistryJs.ILanguageConfigurationService));
        const commands = [];
        const selections = editor.getSelections() || [];
        const autoIndent = editor.getOption(12 /* EditorOption.autoIndent */ );
        for (const selection of selections)commands.push(new (0, _moveLinesCommandJs.MoveLinesCommand)(selection, this.down, autoIndent, languageConfigurationService));
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    }
}
class MoveLinesUpAction extends AbstractMoveLinesAction {
    constructor(){
        super(false, {
            id: "editor.action.moveLinesUpAction",
            label: _nlsJs.localize("lines.moveUp", "Move Line Up"),
            alias: "Move Line Up",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 528 /* KeyCode.UpArrow */ ,
                linux: {
                    primary: 528 /* KeyCode.UpArrow */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "2_line",
                title: _nlsJs.localize({
                    key: "miMoveLinesUp",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Mo&&ve Line Up"),
                order: 3
            }
        });
    }
}
class MoveLinesDownAction extends AbstractMoveLinesAction {
    constructor(){
        super(true, {
            id: "editor.action.moveLinesDownAction",
            label: _nlsJs.localize("lines.moveDown", "Move Line Down"),
            alias: "Move Line Down",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 530 /* KeyCode.DownArrow */ ,
                linux: {
                    primary: 530 /* KeyCode.DownArrow */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "2_line",
                title: _nlsJs.localize({
                    key: "miMoveLinesDown",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Move &&Line Down"),
                order: 4
            }
        });
    }
}
class AbstractSortLinesAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(descending, opts){
        super(opts);
        this.descending = descending;
    }
    run(_accessor, editor) {
        if (!editor.hasModel()) return;
        const model = editor.getModel();
        let selections = editor.getSelections();
        if (selections.length === 1 && selections[0].isEmpty()) // Apply to whole document.
        selections = [
            new (0, _selectionJs.Selection)(1, 1, model.getLineCount(), model.getLineMaxColumn(model.getLineCount()))
        ];
        for (const selection of selections){
            if (!(0, _sortLinesCommandJs.SortLinesCommand).canRun(editor.getModel(), selection, this.descending)) return;
        }
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++)commands[i] = new (0, _sortLinesCommandJs.SortLinesCommand)(selections[i], this.descending);
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    }
}
class SortLinesAscendingAction extends AbstractSortLinesAction {
    constructor(){
        super(false, {
            id: "editor.action.sortLinesAscending",
            label: _nlsJs.localize("lines.sortAscending", "Sort Lines Ascending"),
            alias: "Sort Lines Ascending",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
}
class SortLinesDescendingAction extends AbstractSortLinesAction {
    constructor(){
        super(true, {
            id: "editor.action.sortLinesDescending",
            label: _nlsJs.localize("lines.sortDescending", "Sort Lines Descending"),
            alias: "Sort Lines Descending",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
}
class DeleteDuplicateLinesAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.removeDuplicateLines",
            label: _nlsJs.localize("lines.deleteDuplicates", "Delete Duplicate Lines"),
            alias: "Delete Duplicate Lines",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
    run(_accessor, editor) {
        if (!editor.hasModel()) return;
        const model = editor.getModel();
        if (model.getLineCount() === 1 && model.getLineMaxColumn(1) === 1) return;
        const edits = [];
        const endCursorState = [];
        let linesDeleted = 0;
        let updateSelection = true;
        let selections = editor.getSelections();
        if (selections.length === 1 && selections[0].isEmpty()) {
            // Apply to whole document.
            selections = [
                new (0, _selectionJs.Selection)(1, 1, model.getLineCount(), model.getLineMaxColumn(model.getLineCount()))
            ];
            updateSelection = false;
        }
        for (const selection of selections){
            const uniqueLines = new Set();
            const lines = [];
            for(let i = selection.startLineNumber; i <= selection.endLineNumber; i++){
                const line = model.getLineContent(i);
                if (uniqueLines.has(line)) continue;
                lines.push(line);
                uniqueLines.add(line);
            }
            const selectionToReplace = new (0, _selectionJs.Selection)(selection.startLineNumber, 1, selection.endLineNumber, model.getLineMaxColumn(selection.endLineNumber));
            const adjustedSelectionStart = selection.startLineNumber - linesDeleted;
            const finalSelection = new (0, _selectionJs.Selection)(adjustedSelectionStart, 1, adjustedSelectionStart + lines.length - 1, lines[lines.length - 1].length);
            edits.push((0, _editOperationJs.EditOperation).replace(selectionToReplace, lines.join("\n")));
            endCursorState.push(finalSelection);
            linesDeleted += selection.endLineNumber - selection.startLineNumber + 1 - lines.length;
        }
        editor.pushUndoStop();
        editor.executeEdits(this.id, edits, updateSelection ? endCursorState : undefined);
        editor.pushUndoStop();
    }
}
class TrimTrailingWhitespaceAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.trimTrailingWhitespace";
    }
    constructor(){
        super({
            id: TrimTrailingWhitespaceAction.ID,
            label: _nlsJs.localize("lines.trimTrailingWhitespace", "Trim Trailing Whitespace"),
            alias: "Trim Trailing Whitespace",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2102 /* KeyCode.KeyX */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(_accessor, editor, args) {
        let cursors = [];
        if (args.reason === "auto-save") // See https://github.com/editorconfig/editorconfig-vscode/issues/47
        // It is very convenient for the editor config extension to invoke this action.
        // So, if we get a reason:'auto-save' passed in, let's preserve cursor positions.
        cursors = (editor.getSelections() || []).map((s)=>new (0, _positionJs.Position)(s.positionLineNumber, s.positionColumn));
        const selection = editor.getSelection();
        if (selection === null) return;
        const config = _accessor.get((0, _configurationJs.IConfigurationService));
        const model = editor.getModel();
        const trimInRegexAndStrings = config.getValue("files.trimTrailingWhitespaceInRegexAndStrings", {
            overrideIdentifier: model?.getLanguageId(),
            resource: model?.uri
        });
        const command = new (0, _trimTrailingWhitespaceCommandJs.TrimTrailingWhitespaceCommand)(selection, cursors, trimInRegexAndStrings);
        editor.pushUndoStop();
        editor.executeCommands(this.id, [
            command
        ]);
        editor.pushUndoStop();
    }
}
class DeleteLinesAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.deleteLines",
            label: _nlsJs.localize("lines.delete", "Delete Line"),
            alias: "Delete Line",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 3113 /* KeyCode.KeyK */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(_accessor, editor) {
        if (!editor.hasModel()) return;
        const ops = this._getLinesToRemove(editor);
        const model = editor.getModel();
        if (model.getLineCount() === 1 && model.getLineMaxColumn(1) === 1) // Model is empty
        return;
        let linesDeleted = 0;
        const edits = [];
        const cursorState = [];
        for(let i = 0, len = ops.length; i < len; i++){
            const op = ops[i];
            let startLineNumber = op.startLineNumber;
            let endLineNumber = op.endLineNumber;
            let startColumn = 1;
            let endColumn = model.getLineMaxColumn(endLineNumber);
            if (endLineNumber < model.getLineCount()) {
                endLineNumber += 1;
                endColumn = 1;
            } else if (startLineNumber > 1) {
                startLineNumber -= 1;
                startColumn = model.getLineMaxColumn(startLineNumber);
            }
            edits.push((0, _editOperationJs.EditOperation).replace(new (0, _selectionJs.Selection)(startLineNumber, startColumn, endLineNumber, endColumn), ""));
            cursorState.push(new (0, _selectionJs.Selection)(startLineNumber - linesDeleted, op.positionColumn, startLineNumber - linesDeleted, op.positionColumn));
            linesDeleted += op.endLineNumber - op.startLineNumber + 1;
        }
        editor.pushUndoStop();
        editor.executeEdits(this.id, edits, cursorState);
        editor.pushUndoStop();
    }
    _getLinesToRemove(editor) {
        // Construct delete operations
        const operations = editor.getSelections().map((s)=>{
            let endLineNumber = s.endLineNumber;
            if (s.startLineNumber < s.endLineNumber && s.endColumn === 1) endLineNumber -= 1;
            return {
                startLineNumber: s.startLineNumber,
                selectionStartColumn: s.selectionStartColumn,
                endLineNumber: endLineNumber,
                positionColumn: s.positionColumn
            };
        });
        // Sort delete operations
        operations.sort((a, b)=>{
            if (a.startLineNumber === b.startLineNumber) return a.endLineNumber - b.endLineNumber;
            return a.startLineNumber - b.startLineNumber;
        });
        // Merge delete operations which are adjacent or overlapping
        const mergedOperations = [];
        let previousOperation = operations[0];
        for(let i = 1; i < operations.length; i++)if (previousOperation.endLineNumber + 1 >= operations[i].startLineNumber) // Merge current operations into the previous one
        previousOperation.endLineNumber = operations[i].endLineNumber;
        else {
            // Push previous operation
            mergedOperations.push(previousOperation);
            previousOperation = operations[i];
        }
        // Push the last operation
        mergedOperations.push(previousOperation);
        return mergedOperations;
    }
}
class IndentLinesAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.indentLines",
            label: _nlsJs.localize("lines.indent", "Indent Line"),
            alias: "Indent Line",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 2142 /* KeyCode.BracketRight */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(_accessor, editor) {
        const viewModel = editor._getViewModel();
        if (!viewModel) return;
        editor.pushUndoStop();
        editor.executeCommands(this.id, (0, _cursorTypeOperationsJs.TypeOperations).indent(viewModel.cursorConfig, editor.getModel(), editor.getSelections()));
        editor.pushUndoStop();
    }
}
class OutdentLinesAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.outdentLines",
            label: _nlsJs.localize("lines.outdent", "Outdent Line"),
            alias: "Outdent Line",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 2140 /* KeyCode.BracketLeft */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(_accessor, editor) {
        (0, _coreCommandsJs.CoreEditingCommands).Outdent.runEditorCommand(_accessor, editor, null);
    }
}
class InsertLineBeforeAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.insertLineBefore",
            label: _nlsJs.localize("lines.insertBefore", "Insert Line Above"),
            alias: "Insert Line Above",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 3075 /* KeyCode.Enter */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(_accessor, editor) {
        const viewModel = editor._getViewModel();
        if (!viewModel) return;
        editor.pushUndoStop();
        editor.executeCommands(this.id, (0, _cursorTypeEditOperationsJs.EnterOperation).lineInsertBefore(viewModel.cursorConfig, editor.getModel(), editor.getSelections()));
    }
}
class InsertLineAfterAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.insertLineAfter",
            label: _nlsJs.localize("lines.insertAfter", "Insert Line Below"),
            alias: "Insert Line Below",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 2051 /* KeyCode.Enter */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(_accessor, editor) {
        const viewModel = editor._getViewModel();
        if (!viewModel) return;
        editor.pushUndoStop();
        editor.executeCommands(this.id, (0, _cursorTypeEditOperationsJs.EnterOperation).lineInsertAfter(viewModel.cursorConfig, editor.getModel(), editor.getSelections()));
    }
}
class AbstractDeleteAllToBoundaryAction extends (0, _editorExtensionsJs.EditorAction) {
    run(_accessor, editor) {
        if (!editor.hasModel()) return;
        const primaryCursor = editor.getSelection();
        const rangesToDelete = this._getRangesToDelete(editor);
        // merge overlapping selections
        const effectiveRanges = [];
        for(let i = 0, count = rangesToDelete.length - 1; i < count; i++){
            const range = rangesToDelete[i];
            const nextRange = rangesToDelete[i + 1];
            if ((0, _rangeJs.Range).intersectRanges(range, nextRange) === null) effectiveRanges.push(range);
            else rangesToDelete[i + 1] = (0, _rangeJs.Range).plusRange(range, nextRange);
        }
        effectiveRanges.push(rangesToDelete[rangesToDelete.length - 1]);
        const endCursorState = this._getEndCursorState(primaryCursor, effectiveRanges);
        const edits = effectiveRanges.map((range)=>{
            return (0, _editOperationJs.EditOperation).replace(range, "");
        });
        editor.pushUndoStop();
        editor.executeEdits(this.id, edits, endCursorState);
        editor.pushUndoStop();
    }
}
class DeleteAllLeftAction extends AbstractDeleteAllToBoundaryAction {
    constructor(){
        super({
            id: "deleteAllLeft",
            label: _nlsJs.localize("lines.deleteAllLeft", "Delete All Left"),
            alias: "Delete All Left",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 0,
                mac: {
                    primary: 2049 /* KeyCode.Backspace */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    _getEndCursorState(primaryCursor, rangesToDelete) {
        let endPrimaryCursor = null;
        const endCursorState = [];
        let deletedLines = 0;
        rangesToDelete.forEach((range)=>{
            let endCursor;
            if (range.endColumn === 1 && deletedLines > 0) {
                const newStartLine = range.startLineNumber - deletedLines;
                endCursor = new (0, _selectionJs.Selection)(newStartLine, range.startColumn, newStartLine, range.startColumn);
            } else endCursor = new (0, _selectionJs.Selection)(range.startLineNumber, range.startColumn, range.startLineNumber, range.startColumn);
            deletedLines += range.endLineNumber - range.startLineNumber;
            if (range.intersectRanges(primaryCursor)) endPrimaryCursor = endCursor;
            else endCursorState.push(endCursor);
        });
        if (endPrimaryCursor) endCursorState.unshift(endPrimaryCursor);
        return endCursorState;
    }
    _getRangesToDelete(editor) {
        const selections = editor.getSelections();
        if (selections === null) return [];
        let rangesToDelete = selections;
        const model = editor.getModel();
        if (model === null) return [];
        rangesToDelete.sort((0, _rangeJs.Range).compareRangesUsingStarts);
        rangesToDelete = rangesToDelete.map((selection)=>{
            if (selection.isEmpty()) {
                if (selection.startColumn === 1) {
                    const deleteFromLine = Math.max(1, selection.startLineNumber - 1);
                    const deleteFromColumn = selection.startLineNumber === 1 ? 1 : model.getLineLength(deleteFromLine) + 1;
                    return new (0, _rangeJs.Range)(deleteFromLine, deleteFromColumn, selection.startLineNumber, 1);
                } else return new (0, _rangeJs.Range)(selection.startLineNumber, 1, selection.startLineNumber, selection.startColumn);
            } else return new (0, _rangeJs.Range)(selection.startLineNumber, 1, selection.endLineNumber, selection.endColumn);
        });
        return rangesToDelete;
    }
}
class DeleteAllRightAction extends AbstractDeleteAllToBoundaryAction {
    constructor(){
        super({
            id: "deleteAllRight",
            label: _nlsJs.localize("lines.deleteAllRight", "Delete All Right"),
            alias: "Delete All Right",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 0,
                mac: {
                    primary: 297 /* KeyCode.KeyK */ ,
                    secondary: [
                        2068 /* KeyCode.Delete */ 
                    ]
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    _getEndCursorState(primaryCursor, rangesToDelete) {
        let endPrimaryCursor = null;
        const endCursorState = [];
        for(let i = 0, len = rangesToDelete.length, offset = 0; i < len; i++){
            const range = rangesToDelete[i];
            const endCursor = new (0, _selectionJs.Selection)(range.startLineNumber - offset, range.startColumn, range.startLineNumber - offset, range.startColumn);
            if (range.intersectRanges(primaryCursor)) endPrimaryCursor = endCursor;
            else endCursorState.push(endCursor);
        }
        if (endPrimaryCursor) endCursorState.unshift(endPrimaryCursor);
        return endCursorState;
    }
    _getRangesToDelete(editor) {
        const model = editor.getModel();
        if (model === null) return [];
        const selections = editor.getSelections();
        if (selections === null) return [];
        const rangesToDelete = selections.map((sel)=>{
            if (sel.isEmpty()) {
                const maxColumn = model.getLineMaxColumn(sel.startLineNumber);
                if (sel.startColumn === maxColumn) return new (0, _rangeJs.Range)(sel.startLineNumber, sel.startColumn, sel.startLineNumber + 1, 1);
                else return new (0, _rangeJs.Range)(sel.startLineNumber, sel.startColumn, sel.startLineNumber, maxColumn);
            }
            return sel;
        });
        rangesToDelete.sort((0, _rangeJs.Range).compareRangesUsingStarts);
        return rangesToDelete;
    }
}
class JoinLinesAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.joinLines",
            label: _nlsJs.localize("lines.joinLines", "Join Lines"),
            alias: "Join Lines",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 0,
                mac: {
                    primary: 296 /* KeyCode.KeyJ */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(_accessor, editor) {
        const selections = editor.getSelections();
        if (selections === null) return;
        let primaryCursor = editor.getSelection();
        if (primaryCursor === null) return;
        selections.sort((0, _rangeJs.Range).compareRangesUsingStarts);
        const reducedSelections = [];
        const lastSelection = selections.reduce((previousValue, currentValue)=>{
            if (previousValue.isEmpty()) {
                if (previousValue.endLineNumber === currentValue.startLineNumber) {
                    if (primaryCursor.equalsSelection(previousValue)) primaryCursor = currentValue;
                    return currentValue;
                }
                if (currentValue.startLineNumber > previousValue.endLineNumber + 1) {
                    reducedSelections.push(previousValue);
                    return currentValue;
                } else return new (0, _selectionJs.Selection)(previousValue.startLineNumber, previousValue.startColumn, currentValue.endLineNumber, currentValue.endColumn);
            } else {
                if (currentValue.startLineNumber > previousValue.endLineNumber) {
                    reducedSelections.push(previousValue);
                    return currentValue;
                } else return new (0, _selectionJs.Selection)(previousValue.startLineNumber, previousValue.startColumn, currentValue.endLineNumber, currentValue.endColumn);
            }
        });
        reducedSelections.push(lastSelection);
        const model = editor.getModel();
        if (model === null) return;
        const edits = [];
        const endCursorState = [];
        let endPrimaryCursor = primaryCursor;
        let lineOffset = 0;
        for(let i = 0, len = reducedSelections.length; i < len; i++){
            const selection = reducedSelections[i];
            const startLineNumber = selection.startLineNumber;
            const startColumn = 1;
            let columnDeltaOffset = 0;
            let endLineNumber, endColumn;
            const selectionEndPositionOffset = model.getLineLength(selection.endLineNumber) - selection.endColumn;
            if (selection.isEmpty() || selection.startLineNumber === selection.endLineNumber) {
                const position = selection.getStartPosition();
                if (position.lineNumber < model.getLineCount()) {
                    endLineNumber = startLineNumber + 1;
                    endColumn = model.getLineMaxColumn(endLineNumber);
                } else {
                    endLineNumber = position.lineNumber;
                    endColumn = model.getLineMaxColumn(position.lineNumber);
                }
            } else {
                endLineNumber = selection.endLineNumber;
                endColumn = model.getLineMaxColumn(endLineNumber);
            }
            let trimmedLinesContent = model.getLineContent(startLineNumber);
            for(let i = startLineNumber + 1; i <= endLineNumber; i++){
                const lineText = model.getLineContent(i);
                const firstNonWhitespaceIdx = model.getLineFirstNonWhitespaceColumn(i);
                if (firstNonWhitespaceIdx >= 1) {
                    let insertSpace = true;
                    if (trimmedLinesContent === "") insertSpace = false;
                    if (insertSpace && (trimmedLinesContent.charAt(trimmedLinesContent.length - 1) === " " || trimmedLinesContent.charAt(trimmedLinesContent.length - 1) === "	")) {
                        insertSpace = false;
                        trimmedLinesContent = trimmedLinesContent.replace(/[\s\uFEFF\xA0]+$/g, " ");
                    }
                    const lineTextWithoutIndent = lineText.substr(firstNonWhitespaceIdx - 1);
                    trimmedLinesContent += (insertSpace ? " " : "") + lineTextWithoutIndent;
                    if (insertSpace) columnDeltaOffset = lineTextWithoutIndent.length + 1;
                    else columnDeltaOffset = lineTextWithoutIndent.length;
                } else columnDeltaOffset = 0;
            }
            const deleteSelection = new (0, _rangeJs.Range)(startLineNumber, startColumn, endLineNumber, endColumn);
            if (!deleteSelection.isEmpty()) {
                let resultSelection;
                if (selection.isEmpty()) {
                    edits.push((0, _editOperationJs.EditOperation).replace(deleteSelection, trimmedLinesContent));
                    resultSelection = new (0, _selectionJs.Selection)(deleteSelection.startLineNumber - lineOffset, trimmedLinesContent.length - columnDeltaOffset + 1, startLineNumber - lineOffset, trimmedLinesContent.length - columnDeltaOffset + 1);
                } else if (selection.startLineNumber === selection.endLineNumber) {
                    edits.push((0, _editOperationJs.EditOperation).replace(deleteSelection, trimmedLinesContent));
                    resultSelection = new (0, _selectionJs.Selection)(selection.startLineNumber - lineOffset, selection.startColumn, selection.endLineNumber - lineOffset, selection.endColumn);
                } else {
                    edits.push((0, _editOperationJs.EditOperation).replace(deleteSelection, trimmedLinesContent));
                    resultSelection = new (0, _selectionJs.Selection)(selection.startLineNumber - lineOffset, selection.startColumn, selection.startLineNumber - lineOffset, trimmedLinesContent.length - selectionEndPositionOffset);
                }
                if ((0, _rangeJs.Range).intersectRanges(deleteSelection, primaryCursor) !== null) endPrimaryCursor = resultSelection;
                else endCursorState.push(resultSelection);
            }
            lineOffset += deleteSelection.endLineNumber - deleteSelection.startLineNumber;
        }
        endCursorState.unshift(endPrimaryCursor);
        editor.pushUndoStop();
        editor.executeEdits(this.id, edits, endCursorState);
        editor.pushUndoStop();
    }
}
class TransposeAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.transpose",
            label: _nlsJs.localize("editor.transpose", "Transpose Characters around the Cursor"),
            alias: "Transpose Characters around the Cursor",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
    run(_accessor, editor) {
        const selections = editor.getSelections();
        if (selections === null) return;
        const model = editor.getModel();
        if (model === null) return;
        const commands = [];
        for(let i = 0, len = selections.length; i < len; i++){
            const selection = selections[i];
            if (!selection.isEmpty()) continue;
            const cursor = selection.getStartPosition();
            const maxColumn = model.getLineMaxColumn(cursor.lineNumber);
            if (cursor.column >= maxColumn) {
                if (cursor.lineNumber === model.getLineCount()) continue;
                // The cursor is at the end of current line and current line is not empty
                // then we transpose the character before the cursor and the line break if there is any following line.
                const deleteSelection = new (0, _rangeJs.Range)(cursor.lineNumber, Math.max(1, cursor.column - 1), cursor.lineNumber + 1, 1);
                const chars = model.getValueInRange(deleteSelection).split("").reverse().join("");
                commands.push(new (0, _replaceCommandJs.ReplaceCommand)(new (0, _selectionJs.Selection)(cursor.lineNumber, Math.max(1, cursor.column - 1), cursor.lineNumber + 1, 1), chars));
            } else {
                const deleteSelection = new (0, _rangeJs.Range)(cursor.lineNumber, Math.max(1, cursor.column - 1), cursor.lineNumber, cursor.column + 1);
                const chars = model.getValueInRange(deleteSelection).split("").reverse().join("");
                commands.push(new (0, _replaceCommandJs.ReplaceCommandThatPreservesSelection)(deleteSelection, chars, new (0, _selectionJs.Selection)(cursor.lineNumber, cursor.column + 1, cursor.lineNumber, cursor.column + 1)));
            }
        }
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    }
}
class AbstractCaseAction extends (0, _editorExtensionsJs.EditorAction) {
    run(_accessor, editor) {
        const selections = editor.getSelections();
        if (selections === null) return;
        const model = editor.getModel();
        if (model === null) return;
        const wordSeparators = editor.getOption(132 /* EditorOption.wordSeparators */ );
        const textEdits = [];
        for (const selection of selections)if (selection.isEmpty()) {
            const cursor = selection.getStartPosition();
            const word = editor.getConfiguredWordAtPosition(cursor);
            if (!word) continue;
            const wordRange = new (0, _rangeJs.Range)(cursor.lineNumber, word.startColumn, cursor.lineNumber, word.endColumn);
            const text = model.getValueInRange(wordRange);
            textEdits.push((0, _editOperationJs.EditOperation).replace(wordRange, this._modifyText(text, wordSeparators)));
        } else {
            const text = model.getValueInRange(selection);
            textEdits.push((0, _editOperationJs.EditOperation).replace(selection, this._modifyText(text, wordSeparators)));
        }
        editor.pushUndoStop();
        editor.executeEdits(this.id, textEdits);
        editor.pushUndoStop();
    }
}
class UpperCaseAction extends AbstractCaseAction {
    constructor(){
        super({
            id: "editor.action.transformToUppercase",
            label: _nlsJs.localize("editor.transformToUppercase", "Transform to Uppercase"),
            alias: "Transform to Uppercase",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
    _modifyText(text, wordSeparators) {
        return text.toLocaleUpperCase();
    }
}
class LowerCaseAction extends AbstractCaseAction {
    constructor(){
        super({
            id: "editor.action.transformToLowercase",
            label: _nlsJs.localize("editor.transformToLowercase", "Transform to Lowercase"),
            alias: "Transform to Lowercase",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
    _modifyText(text, wordSeparators) {
        return text.toLocaleLowerCase();
    }
}
class BackwardsCompatibleRegExp {
    constructor(_pattern, _flags){
        this._pattern = _pattern;
        this._flags = _flags;
        this._actual = null;
        this._evaluated = false;
    }
    get() {
        if (!this._evaluated) {
            this._evaluated = true;
            try {
                this._actual = new RegExp(this._pattern, this._flags);
            } catch (err) {
            // this browser does not support this regular expression
            }
        }
        return this._actual;
    }
    isSupported() {
        return this.get() !== null;
    }
}
class TitleCaseAction extends AbstractCaseAction {
    static{
        this.titleBoundary = new BackwardsCompatibleRegExp("(^|[^\\p{L}\\p{N}']|((^|\\P{L})'))\\p{L}", "gmu");
    }
    constructor(){
        super({
            id: "editor.action.transformToTitlecase",
            label: _nlsJs.localize("editor.transformToTitlecase", "Transform to Title Case"),
            alias: "Transform to Title Case",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
    _modifyText(text, wordSeparators) {
        const titleBoundary = TitleCaseAction.titleBoundary.get();
        if (!titleBoundary) // cannot support this
        return text;
        return text.toLocaleLowerCase().replace(titleBoundary, (b)=>b.toLocaleUpperCase());
    }
}
class SnakeCaseAction extends AbstractCaseAction {
    static{
        this.caseBoundary = new BackwardsCompatibleRegExp("(\\p{Ll})(\\p{Lu})", "gmu");
    }
    static{
        this.singleLetters = new BackwardsCompatibleRegExp("(\\p{Lu}|\\p{N})(\\p{Lu})(\\p{Ll})", "gmu");
    }
    constructor(){
        super({
            id: "editor.action.transformToSnakecase",
            label: _nlsJs.localize("editor.transformToSnakecase", "Transform to Snake Case"),
            alias: "Transform to Snake Case",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
    _modifyText(text, wordSeparators) {
        const caseBoundary = SnakeCaseAction.caseBoundary.get();
        const singleLetters = SnakeCaseAction.singleLetters.get();
        if (!caseBoundary || !singleLetters) // cannot support this
        return text;
        return text.replace(caseBoundary, "$1_$2").replace(singleLetters, "$1_$2$3").toLocaleLowerCase();
    }
}
class CamelCaseAction extends AbstractCaseAction {
    static{
        this.wordBoundary = new BackwardsCompatibleRegExp("[_\\s-]", "gm");
    }
    constructor(){
        super({
            id: "editor.action.transformToCamelcase",
            label: _nlsJs.localize("editor.transformToCamelcase", "Transform to Camel Case"),
            alias: "Transform to Camel Case",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
    _modifyText(text, wordSeparators) {
        const wordBoundary = CamelCaseAction.wordBoundary.get();
        if (!wordBoundary) // cannot support this
        return text;
        const words = text.split(wordBoundary);
        const firstWord = words.shift();
        return firstWord + words.map((word)=>word.substring(0, 1).toLocaleUpperCase() + word.substring(1)).join("");
    }
}
class PascalCaseAction extends AbstractCaseAction {
    static{
        this.wordBoundary = new BackwardsCompatibleRegExp("[_\\s-]", "gm");
    }
    static{
        this.wordBoundaryToMaintain = new BackwardsCompatibleRegExp("(?<=\\.)", "gm");
    }
    constructor(){
        super({
            id: "editor.action.transformToPascalcase",
            label: _nlsJs.localize("editor.transformToPascalcase", "Transform to Pascal Case"),
            alias: "Transform to Pascal Case",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
    _modifyText(text, wordSeparators) {
        const wordBoundary = PascalCaseAction.wordBoundary.get();
        const wordBoundaryToMaintain = PascalCaseAction.wordBoundaryToMaintain.get();
        if (!wordBoundary || !wordBoundaryToMaintain) // cannot support this
        return text;
        const wordsWithMaintainBoundaries = text.split(wordBoundaryToMaintain);
        const words = wordsWithMaintainBoundaries.map((word)=>word.split(wordBoundary)).flat();
        return words.map((word)=>word.substring(0, 1).toLocaleUpperCase() + word.substring(1)).join("");
    }
}
class KebabCaseAction extends AbstractCaseAction {
    static isSupported() {
        const areAllRegexpsSupported = [
            this.caseBoundary,
            this.singleLetters,
            this.underscoreBoundary
        ].every((regexp)=>regexp.isSupported());
        return areAllRegexpsSupported;
    }
    static{
        this.caseBoundary = new BackwardsCompatibleRegExp("(\\p{Ll})(\\p{Lu})", "gmu");
    }
    static{
        this.singleLetters = new BackwardsCompatibleRegExp("(\\p{Lu}|\\p{N})(\\p{Lu}\\p{Ll})", "gmu");
    }
    static{
        this.underscoreBoundary = new BackwardsCompatibleRegExp("(\\S)(_)(\\S)", "gm");
    }
    constructor(){
        super({
            id: "editor.action.transformToKebabcase",
            label: _nlsJs.localize("editor.transformToKebabcase", "Transform to Kebab Case"),
            alias: "Transform to Kebab Case",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
    _modifyText(text, _) {
        const caseBoundary = KebabCaseAction.caseBoundary.get();
        const singleLetters = KebabCaseAction.singleLetters.get();
        const underscoreBoundary = KebabCaseAction.underscoreBoundary.get();
        if (!caseBoundary || !singleLetters || !underscoreBoundary) // one or more regexps aren't supported
        return text;
        return text.replace(underscoreBoundary, "$1-$3").replace(caseBoundary, "$1-$2").replace(singleLetters, "$1-$2").toLocaleLowerCase();
    }
}
(0, _editorExtensionsJs.registerEditorAction)(CopyLinesUpAction);
(0, _editorExtensionsJs.registerEditorAction)(CopyLinesDownAction);
(0, _editorExtensionsJs.registerEditorAction)(DuplicateSelectionAction);
(0, _editorExtensionsJs.registerEditorAction)(MoveLinesUpAction);
(0, _editorExtensionsJs.registerEditorAction)(MoveLinesDownAction);
(0, _editorExtensionsJs.registerEditorAction)(SortLinesAscendingAction);
(0, _editorExtensionsJs.registerEditorAction)(SortLinesDescendingAction);
(0, _editorExtensionsJs.registerEditorAction)(DeleteDuplicateLinesAction);
(0, _editorExtensionsJs.registerEditorAction)(TrimTrailingWhitespaceAction);
(0, _editorExtensionsJs.registerEditorAction)(DeleteLinesAction);
(0, _editorExtensionsJs.registerEditorAction)(IndentLinesAction);
(0, _editorExtensionsJs.registerEditorAction)(OutdentLinesAction);
(0, _editorExtensionsJs.registerEditorAction)(InsertLineBeforeAction);
(0, _editorExtensionsJs.registerEditorAction)(InsertLineAfterAction);
(0, _editorExtensionsJs.registerEditorAction)(DeleteAllLeftAction);
(0, _editorExtensionsJs.registerEditorAction)(DeleteAllRightAction);
(0, _editorExtensionsJs.registerEditorAction)(JoinLinesAction);
(0, _editorExtensionsJs.registerEditorAction)(TransposeAction);
(0, _editorExtensionsJs.registerEditorAction)(UpperCaseAction);
(0, _editorExtensionsJs.registerEditorAction)(LowerCaseAction);
if (SnakeCaseAction.caseBoundary.isSupported() && SnakeCaseAction.singleLetters.isSupported()) (0, _editorExtensionsJs.registerEditorAction)(SnakeCaseAction);
if (CamelCaseAction.wordBoundary.isSupported()) (0, _editorExtensionsJs.registerEditorAction)(CamelCaseAction);
if (PascalCaseAction.wordBoundary.isSupported()) (0, _editorExtensionsJs.registerEditorAction)(PascalCaseAction);
if (TitleCaseAction.titleBoundary.isSupported()) (0, _editorExtensionsJs.registerEditorAction)(TitleCaseAction);
if (KebabCaseAction.isSupported()) (0, _editorExtensionsJs.registerEditorAction)(KebabCaseAction);

},{"../../../../base/common/keyCodes.js":"bHiG9","../../../browser/coreCommands.js":"3GyQi","../../../browser/editorExtensions.js":"kC3w6","../../../common/commands/replaceCommand.js":"51hNH","../../../common/commands/trimTrailingWhitespaceCommand.js":"8Ivjs","../../../common/cursor/cursorTypeOperations.js":"8iSM3","../../../common/cursor/cursorTypeEditOperations.js":"iMjJX","../../../common/core/editOperation.js":"6r2FZ","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/editorContextKeys.js":"5exv9","./copyLinesCommand.js":"1NNtR","./moveLinesCommand.js":"hbTtq","./sortLinesCommand.js":"dYOHv","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../../platform/configuration/common/configuration.js":"dXkjq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Ivjs":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrimTrailingWhitespaceCommand", ()=>TrimTrailingWhitespaceCommand);
/**
 * Generate commands for trimming trailing whitespace on a model and ignore lines on which cursors are sitting.
 */ parcelHelpers.export(exports, "trimTrailingWhitespace", ()=>trimTrailingWhitespace);
var _stringsJs = require("../../../base/common/strings.js");
var _editOperationJs = require("../core/editOperation.js");
var _rangeJs = require("../core/range.js");
class TrimTrailingWhitespaceCommand {
    constructor(selection, cursors, trimInRegexesAndStrings){
        this._selection = selection;
        this._cursors = cursors;
        this._selectionId = null;
        this._trimInRegexesAndStrings = trimInRegexesAndStrings;
    }
    getEditOperations(model, builder) {
        const ops = trimTrailingWhitespace(model, this._cursors, this._trimInRegexesAndStrings);
        for(let i = 0, len = ops.length; i < len; i++){
            const op = ops[i];
            builder.addEditOperation(op.range, op.text);
        }
        this._selectionId = builder.trackSelection(this._selection);
    }
    computeCursorState(model, helper) {
        return helper.getTrackedSelection(this._selectionId);
    }
}
function trimTrailingWhitespace(model, cursors, trimInRegexesAndStrings) {
    // Sort cursors ascending
    cursors.sort((a, b)=>{
        if (a.lineNumber === b.lineNumber) return a.column - b.column;
        return a.lineNumber - b.lineNumber;
    });
    // Reduce multiple cursors on the same line and only keep the last one on the line
    for(let i = cursors.length - 2; i >= 0; i--)if (cursors[i].lineNumber === cursors[i + 1].lineNumber) // Remove cursor at `i`
    cursors.splice(i, 1);
    const r = [];
    let rLen = 0;
    let cursorIndex = 0;
    const cursorLen = cursors.length;
    for(let lineNumber = 1, lineCount = model.getLineCount(); lineNumber <= lineCount; lineNumber++){
        const lineContent = model.getLineContent(lineNumber);
        const maxLineColumn = lineContent.length + 1;
        let minEditColumn = 0;
        if (cursorIndex < cursorLen && cursors[cursorIndex].lineNumber === lineNumber) {
            minEditColumn = cursors[cursorIndex].column;
            cursorIndex++;
            if (minEditColumn === maxLineColumn) continue;
        }
        if (lineContent.length === 0) continue;
        const lastNonWhitespaceIndex = _stringsJs.lastNonWhitespaceIndex(lineContent);
        let fromColumn = 0;
        if (lastNonWhitespaceIndex === -1) // Entire line is whitespace
        fromColumn = 1;
        else if (lastNonWhitespaceIndex !== lineContent.length - 1) // There is trailing whitespace
        fromColumn = lastNonWhitespaceIndex + 2;
        else continue;
        if (!trimInRegexesAndStrings) {
            if (!model.tokenization.hasAccurateTokensForLine(lineNumber)) continue;
            const lineTokens = model.tokenization.getLineTokens(lineNumber);
            const fromColumnType = lineTokens.getStandardTokenType(lineTokens.findTokenIndexAtOffset(fromColumn));
            if (fromColumnType === 2 /* StandardTokenType.String */  || fromColumnType === 3 /* StandardTokenType.RegEx */ ) continue;
        }
        fromColumn = Math.max(minEditColumn, fromColumn);
        r[rLen++] = (0, _editOperationJs.EditOperation).delete(new (0, _rangeJs.Range)(lineNumber, fromColumn, lineNumber, maxLineColumn));
    }
    return r;
}

},{"../../../base/common/strings.js":"aA9I1","../core/editOperation.js":"6r2FZ","../core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1NNtR":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyLinesCommand", ()=>CopyLinesCommand);
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
class CopyLinesCommand {
    constructor(selection, isCopyingDown, noop){
        this._selection = selection;
        this._isCopyingDown = isCopyingDown;
        this._noop = noop || false;
        this._selectionDirection = 0 /* SelectionDirection.LTR */ ;
        this._selectionId = null;
        this._startLineNumberDelta = 0;
        this._endLineNumberDelta = 0;
    }
    getEditOperations(model, builder) {
        let s = this._selection;
        this._startLineNumberDelta = 0;
        this._endLineNumberDelta = 0;
        if (s.startLineNumber < s.endLineNumber && s.endColumn === 1) {
            this._endLineNumberDelta = 1;
            s = s.setEndPosition(s.endLineNumber - 1, model.getLineMaxColumn(s.endLineNumber - 1));
        }
        const sourceLines = [];
        for(let i = s.startLineNumber; i <= s.endLineNumber; i++)sourceLines.push(model.getLineContent(i));
        const sourceText = sourceLines.join("\n");
        if (sourceText === "") // Duplicating empty line
        {
            if (this._isCopyingDown) {
                this._startLineNumberDelta++;
                this._endLineNumberDelta++;
            }
        }
        if (this._noop) builder.addEditOperation(new (0, _rangeJs.Range)(s.endLineNumber, model.getLineMaxColumn(s.endLineNumber), s.endLineNumber + 1, 1), s.endLineNumber === model.getLineCount() ? "" : "\n");
        else if (!this._isCopyingDown) builder.addEditOperation(new (0, _rangeJs.Range)(s.endLineNumber, model.getLineMaxColumn(s.endLineNumber), s.endLineNumber, model.getLineMaxColumn(s.endLineNumber)), "\n" + sourceText);
        else builder.addEditOperation(new (0, _rangeJs.Range)(s.startLineNumber, 1, s.startLineNumber, 1), sourceText + "\n");
        this._selectionId = builder.trackSelection(s);
        this._selectionDirection = this._selection.getDirection();
    }
    computeCursorState(model, helper) {
        let result = helper.getTrackedSelection(this._selectionId);
        if (this._startLineNumberDelta !== 0 || this._endLineNumberDelta !== 0) {
            let startLineNumber = result.startLineNumber;
            let startColumn = result.startColumn;
            let endLineNumber = result.endLineNumber;
            let endColumn = result.endColumn;
            if (this._startLineNumberDelta !== 0) {
                startLineNumber = startLineNumber + this._startLineNumberDelta;
                startColumn = 1;
            }
            if (this._endLineNumberDelta !== 0) {
                endLineNumber = endLineNumber + this._endLineNumberDelta;
                endColumn = 1;
            }
            result = (0, _selectionJs.Selection).createWithDirection(startLineNumber, startColumn, endLineNumber, endColumn, this._selectionDirection);
        }
        return result;
    }
}

},{"../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hbTtq":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MoveLinesCommand", ()=>MoveLinesCommand);
var _stringsJs = require("../../../../base/common/strings.js");
var _shiftCommandJs = require("../../../common/commands/shiftCommand.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _languageConfigurationJs = require("../../../common/languages/languageConfiguration.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _indentUtilsJs = require("../../indentation/common/indentUtils.js");
var _autoIndentJs = require("../../../common/languages/autoIndent.js");
var _enterActionJs = require("../../../common/languages/enterAction.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let MoveLinesCommand = class MoveLinesCommand {
    constructor(selection, isMovingDown, autoIndent, _languageConfigurationService){
        this._languageConfigurationService = _languageConfigurationService;
        this._selection = selection;
        this._isMovingDown = isMovingDown;
        this._autoIndent = autoIndent;
        this._selectionId = null;
        this._moveEndLineSelectionShrink = false;
    }
    getEditOperations(model, builder) {
        const getLanguageId = ()=>{
            return model.getLanguageId();
        };
        const getLanguageIdAtPosition = (lineNumber, column)=>{
            return model.getLanguageIdAtPosition(lineNumber, column);
        };
        const modelLineCount = model.getLineCount();
        if (this._isMovingDown && this._selection.endLineNumber === modelLineCount) {
            this._selectionId = builder.trackSelection(this._selection);
            return;
        }
        if (!this._isMovingDown && this._selection.startLineNumber === 1) {
            this._selectionId = builder.trackSelection(this._selection);
            return;
        }
        this._moveEndPositionDown = false;
        let s = this._selection;
        if (s.startLineNumber < s.endLineNumber && s.endColumn === 1) {
            this._moveEndPositionDown = true;
            s = s.setEndPosition(s.endLineNumber - 1, model.getLineMaxColumn(s.endLineNumber - 1));
        }
        const { tabSize, indentSize, insertSpaces } = model.getOptions();
        const indentConverter = this.buildIndentConverter(tabSize, indentSize, insertSpaces);
        if (s.startLineNumber === s.endLineNumber && model.getLineMaxColumn(s.startLineNumber) === 1) {
            // Current line is empty
            const lineNumber = s.startLineNumber;
            const otherLineNumber = this._isMovingDown ? lineNumber + 1 : lineNumber - 1;
            if (model.getLineMaxColumn(otherLineNumber) === 1) // Other line number is empty too, so no editing is needed
            // Add a no-op to force running by the model
            builder.addEditOperation(new (0, _rangeJs.Range)(1, 1, 1, 1), null);
            else {
                // Type content from other line number on line number
                builder.addEditOperation(new (0, _rangeJs.Range)(lineNumber, 1, lineNumber, 1), model.getLineContent(otherLineNumber));
                // Remove content from other line number
                builder.addEditOperation(new (0, _rangeJs.Range)(otherLineNumber, 1, otherLineNumber, model.getLineMaxColumn(otherLineNumber)), null);
            }
            // Track selection at the other line number
            s = new (0, _selectionJs.Selection)(otherLineNumber, 1, otherLineNumber, 1);
        } else {
            let movingLineNumber;
            let movingLineText;
            if (this._isMovingDown) {
                movingLineNumber = s.endLineNumber + 1;
                movingLineText = model.getLineContent(movingLineNumber);
                // Delete line that needs to be moved
                builder.addEditOperation(new (0, _rangeJs.Range)(movingLineNumber - 1, model.getLineMaxColumn(movingLineNumber - 1), movingLineNumber, model.getLineMaxColumn(movingLineNumber)), null);
                let insertingText = movingLineText;
                if (this.shouldAutoIndent(model, s)) {
                    const movingLineMatchResult = this.matchEnterRule(model, indentConverter, tabSize, movingLineNumber, s.startLineNumber - 1);
                    // if s.startLineNumber - 1 matches onEnter rule, we still honor that.
                    if (movingLineMatchResult !== null) {
                        const oldIndentation = _stringsJs.getLeadingWhitespace(model.getLineContent(movingLineNumber));
                        const newSpaceCnt = movingLineMatchResult + _indentUtilsJs.getSpaceCnt(oldIndentation, tabSize);
                        const newIndentation = _indentUtilsJs.generateIndent(newSpaceCnt, tabSize, insertSpaces);
                        insertingText = newIndentation + this.trimStart(movingLineText);
                    } else {
                        // no enter rule matches, let's check indentatin rules then.
                        const virtualModel = {
                            tokenization: {
                                getLineTokens: (lineNumber)=>{
                                    if (lineNumber === s.startLineNumber) return model.tokenization.getLineTokens(movingLineNumber);
                                    else return model.tokenization.getLineTokens(lineNumber);
                                },
                                getLanguageId,
                                getLanguageIdAtPosition
                            },
                            getLineContent: (lineNumber)=>{
                                if (lineNumber === s.startLineNumber) return model.getLineContent(movingLineNumber);
                                else return model.getLineContent(lineNumber);
                            }
                        };
                        const indentOfMovingLine = (0, _autoIndentJs.getGoodIndentForLine)(this._autoIndent, virtualModel, model.getLanguageIdAtPosition(movingLineNumber, 1), s.startLineNumber, indentConverter, this._languageConfigurationService);
                        if (indentOfMovingLine !== null) {
                            const oldIndentation = _stringsJs.getLeadingWhitespace(model.getLineContent(movingLineNumber));
                            const newSpaceCnt = _indentUtilsJs.getSpaceCnt(indentOfMovingLine, tabSize);
                            const oldSpaceCnt = _indentUtilsJs.getSpaceCnt(oldIndentation, tabSize);
                            if (newSpaceCnt !== oldSpaceCnt) {
                                const newIndentation = _indentUtilsJs.generateIndent(newSpaceCnt, tabSize, insertSpaces);
                                insertingText = newIndentation + this.trimStart(movingLineText);
                            }
                        }
                    }
                    // add edit operations for moving line first to make sure it's executed after we make indentation change
                    // to s.startLineNumber
                    builder.addEditOperation(new (0, _rangeJs.Range)(s.startLineNumber, 1, s.startLineNumber, 1), insertingText + "\n");
                    const ret = this.matchEnterRuleMovingDown(model, indentConverter, tabSize, s.startLineNumber, movingLineNumber, insertingText);
                    // check if the line being moved before matches onEnter rules, if so let's adjust the indentation by onEnter rules.
                    if (ret !== null) {
                        if (ret !== 0) this.getIndentEditsOfMovingBlock(model, builder, s, tabSize, insertSpaces, ret);
                    } else {
                        // it doesn't match onEnter rules, let's check indentation rules then.
                        const virtualModel = {
                            tokenization: {
                                getLineTokens: (lineNumber)=>{
                                    if (lineNumber === s.startLineNumber) // TODO@aiday-mar: the tokens here don't correspond exactly to the corresponding content (after indentation adjustment), have to fix this.
                                    return model.tokenization.getLineTokens(movingLineNumber);
                                    else if (lineNumber >= s.startLineNumber + 1 && lineNumber <= s.endLineNumber + 1) return model.tokenization.getLineTokens(lineNumber - 1);
                                    else return model.tokenization.getLineTokens(lineNumber);
                                },
                                getLanguageId,
                                getLanguageIdAtPosition
                            },
                            getLineContent: (lineNumber)=>{
                                if (lineNumber === s.startLineNumber) return insertingText;
                                else if (lineNumber >= s.startLineNumber + 1 && lineNumber <= s.endLineNumber + 1) return model.getLineContent(lineNumber - 1);
                                else return model.getLineContent(lineNumber);
                            }
                        };
                        const newIndentatOfMovingBlock = (0, _autoIndentJs.getGoodIndentForLine)(this._autoIndent, virtualModel, model.getLanguageIdAtPosition(movingLineNumber, 1), s.startLineNumber + 1, indentConverter, this._languageConfigurationService);
                        if (newIndentatOfMovingBlock !== null) {
                            const oldIndentation = _stringsJs.getLeadingWhitespace(model.getLineContent(s.startLineNumber));
                            const newSpaceCnt = _indentUtilsJs.getSpaceCnt(newIndentatOfMovingBlock, tabSize);
                            const oldSpaceCnt = _indentUtilsJs.getSpaceCnt(oldIndentation, tabSize);
                            if (newSpaceCnt !== oldSpaceCnt) {
                                const spaceCntOffset = newSpaceCnt - oldSpaceCnt;
                                this.getIndentEditsOfMovingBlock(model, builder, s, tabSize, insertSpaces, spaceCntOffset);
                            }
                        }
                    }
                } else // Insert line that needs to be moved before
                builder.addEditOperation(new (0, _rangeJs.Range)(s.startLineNumber, 1, s.startLineNumber, 1), insertingText + "\n");
            } else {
                movingLineNumber = s.startLineNumber - 1;
                movingLineText = model.getLineContent(movingLineNumber);
                // Delete line that needs to be moved
                builder.addEditOperation(new (0, _rangeJs.Range)(movingLineNumber, 1, movingLineNumber + 1, 1), null);
                // Insert line that needs to be moved after
                builder.addEditOperation(new (0, _rangeJs.Range)(s.endLineNumber, model.getLineMaxColumn(s.endLineNumber), s.endLineNumber, model.getLineMaxColumn(s.endLineNumber)), "\n" + movingLineText);
                if (this.shouldAutoIndent(model, s)) {
                    const virtualModel = {
                        tokenization: {
                            getLineTokens: (lineNumber)=>{
                                if (lineNumber === movingLineNumber) return model.tokenization.getLineTokens(s.startLineNumber);
                                else return model.tokenization.getLineTokens(lineNumber);
                            },
                            getLanguageId,
                            getLanguageIdAtPosition
                        },
                        getLineContent: (lineNumber)=>{
                            if (lineNumber === movingLineNumber) return model.getLineContent(s.startLineNumber);
                            else return model.getLineContent(lineNumber);
                        }
                    };
                    const ret = this.matchEnterRule(model, indentConverter, tabSize, s.startLineNumber, s.startLineNumber - 2);
                    // check if s.startLineNumber - 2 matches onEnter rules, if so adjust the moving block by onEnter rules.
                    if (ret !== null) {
                        if (ret !== 0) this.getIndentEditsOfMovingBlock(model, builder, s, tabSize, insertSpaces, ret);
                    } else {
                        // it doesn't match any onEnter rule, let's check indentation rules then.
                        const indentOfFirstLine = (0, _autoIndentJs.getGoodIndentForLine)(this._autoIndent, virtualModel, model.getLanguageIdAtPosition(s.startLineNumber, 1), movingLineNumber, indentConverter, this._languageConfigurationService);
                        if (indentOfFirstLine !== null) {
                            // adjust the indentation of the moving block
                            const oldIndent = _stringsJs.getLeadingWhitespace(model.getLineContent(s.startLineNumber));
                            const newSpaceCnt = _indentUtilsJs.getSpaceCnt(indentOfFirstLine, tabSize);
                            const oldSpaceCnt = _indentUtilsJs.getSpaceCnt(oldIndent, tabSize);
                            if (newSpaceCnt !== oldSpaceCnt) {
                                const spaceCntOffset = newSpaceCnt - oldSpaceCnt;
                                this.getIndentEditsOfMovingBlock(model, builder, s, tabSize, insertSpaces, spaceCntOffset);
                            }
                        }
                    }
                }
            }
        }
        this._selectionId = builder.trackSelection(s);
    }
    buildIndentConverter(tabSize, indentSize, insertSpaces) {
        return {
            shiftIndent: (indentation)=>{
                return (0, _shiftCommandJs.ShiftCommand).shiftIndent(indentation, indentation.length + 1, tabSize, indentSize, insertSpaces);
            },
            unshiftIndent: (indentation)=>{
                return (0, _shiftCommandJs.ShiftCommand).unshiftIndent(indentation, indentation.length + 1, tabSize, indentSize, insertSpaces);
            }
        };
    }
    parseEnterResult(model, indentConverter, tabSize, line, enter) {
        if (enter) {
            let enterPrefix = enter.indentation;
            if (enter.indentAction === (0, _languageConfigurationJs.IndentAction).None) enterPrefix = enter.indentation + enter.appendText;
            else if (enter.indentAction === (0, _languageConfigurationJs.IndentAction).Indent) enterPrefix = enter.indentation + enter.appendText;
            else if (enter.indentAction === (0, _languageConfigurationJs.IndentAction).IndentOutdent) enterPrefix = enter.indentation;
            else if (enter.indentAction === (0, _languageConfigurationJs.IndentAction).Outdent) enterPrefix = indentConverter.unshiftIndent(enter.indentation) + enter.appendText;
            const movingLineText = model.getLineContent(line);
            if (this.trimStart(movingLineText).indexOf(this.trimStart(enterPrefix)) >= 0) {
                const oldIndentation = _stringsJs.getLeadingWhitespace(model.getLineContent(line));
                let newIndentation = _stringsJs.getLeadingWhitespace(enterPrefix);
                const indentMetadataOfMovelingLine = (0, _autoIndentJs.getIndentMetadata)(model, line, this._languageConfigurationService);
                if (indentMetadataOfMovelingLine !== null && indentMetadataOfMovelingLine & 2 /* IndentConsts.DECREASE_MASK */ ) newIndentation = indentConverter.unshiftIndent(newIndentation);
                const newSpaceCnt = _indentUtilsJs.getSpaceCnt(newIndentation, tabSize);
                const oldSpaceCnt = _indentUtilsJs.getSpaceCnt(oldIndentation, tabSize);
                return newSpaceCnt - oldSpaceCnt;
            }
        }
        return null;
    }
    /**
     *
     * @param model
     * @param indentConverter
     * @param tabSize
     * @param line the line moving down
     * @param futureAboveLineNumber the line which will be at the `line` position
     * @param futureAboveLineText
     */ matchEnterRuleMovingDown(model, indentConverter, tabSize, line, futureAboveLineNumber, futureAboveLineText) {
        if (_stringsJs.lastNonWhitespaceIndex(futureAboveLineText) >= 0) {
            // break
            const maxColumn = model.getLineMaxColumn(futureAboveLineNumber);
            const enter = (0, _enterActionJs.getEnterAction)(this._autoIndent, model, new (0, _rangeJs.Range)(futureAboveLineNumber, maxColumn, futureAboveLineNumber, maxColumn), this._languageConfigurationService);
            return this.parseEnterResult(model, indentConverter, tabSize, line, enter);
        } else {
            // go upwards, starting from `line - 1`
            let validPrecedingLine = line - 1;
            while(validPrecedingLine >= 1){
                const lineContent = model.getLineContent(validPrecedingLine);
                const nonWhitespaceIdx = _stringsJs.lastNonWhitespaceIndex(lineContent);
                if (nonWhitespaceIdx >= 0) break;
                validPrecedingLine--;
            }
            if (validPrecedingLine < 1 || line > model.getLineCount()) return null;
            const maxColumn = model.getLineMaxColumn(validPrecedingLine);
            const enter = (0, _enterActionJs.getEnterAction)(this._autoIndent, model, new (0, _rangeJs.Range)(validPrecedingLine, maxColumn, validPrecedingLine, maxColumn), this._languageConfigurationService);
            return this.parseEnterResult(model, indentConverter, tabSize, line, enter);
        }
    }
    matchEnterRule(model, indentConverter, tabSize, line, oneLineAbove, previousLineText) {
        let validPrecedingLine = oneLineAbove;
        while(validPrecedingLine >= 1){
            // ship empty lines as empty lines just inherit indentation
            let lineContent;
            if (validPrecedingLine === oneLineAbove && previousLineText !== undefined) lineContent = previousLineText;
            else lineContent = model.getLineContent(validPrecedingLine);
            const nonWhitespaceIdx = _stringsJs.lastNonWhitespaceIndex(lineContent);
            if (nonWhitespaceIdx >= 0) break;
            validPrecedingLine--;
        }
        if (validPrecedingLine < 1 || line > model.getLineCount()) return null;
        const maxColumn = model.getLineMaxColumn(validPrecedingLine);
        const enter = (0, _enterActionJs.getEnterAction)(this._autoIndent, model, new (0, _rangeJs.Range)(validPrecedingLine, maxColumn, validPrecedingLine, maxColumn), this._languageConfigurationService);
        return this.parseEnterResult(model, indentConverter, tabSize, line, enter);
    }
    trimStart(str) {
        return str.replace(/^\s+/, "");
    }
    shouldAutoIndent(model, selection) {
        if (this._autoIndent < 4 /* EditorAutoIndentStrategy.Full */ ) return false;
        // if it's not easy to tokenize, we stop auto indent.
        if (!model.tokenization.isCheapToTokenize(selection.startLineNumber)) return false;
        const languageAtSelectionStart = model.getLanguageIdAtPosition(selection.startLineNumber, 1);
        const languageAtSelectionEnd = model.getLanguageIdAtPosition(selection.endLineNumber, 1);
        if (languageAtSelectionStart !== languageAtSelectionEnd) return false;
        if (this._languageConfigurationService.getLanguageConfiguration(languageAtSelectionStart).indentRulesSupport === null) return false;
        return true;
    }
    getIndentEditsOfMovingBlock(model, builder, s, tabSize, insertSpaces, offset) {
        for(let i = s.startLineNumber; i <= s.endLineNumber; i++){
            const lineContent = model.getLineContent(i);
            const originalIndent = _stringsJs.getLeadingWhitespace(lineContent);
            const originalSpacesCnt = _indentUtilsJs.getSpaceCnt(originalIndent, tabSize);
            const newSpacesCnt = originalSpacesCnt + offset;
            const newIndent = _indentUtilsJs.generateIndent(newSpacesCnt, tabSize, insertSpaces);
            if (newIndent !== originalIndent) {
                builder.addEditOperation(new (0, _rangeJs.Range)(i, 1, i, originalIndent.length + 1), newIndent);
                if (i === s.endLineNumber && s.endColumn <= originalIndent.length + 1 && newIndent === "") // as users select part of the original indent white spaces
                // when we adjust the indentation of endLine, we should adjust the cursor position as well.
                this._moveEndLineSelectionShrink = true;
            }
        }
    }
    computeCursorState(model, helper) {
        let result = helper.getTrackedSelection(this._selectionId);
        if (this._moveEndPositionDown) result = result.setEndPosition(result.endLineNumber + 1, 1);
        if (this._moveEndLineSelectionShrink && result.startLineNumber < result.endLineNumber) result = result.setEndPosition(result.endLineNumber, 2);
        return result;
    }
};
MoveLinesCommand = __decorate([
    __param(3, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService))
], MoveLinesCommand);

},{"../../../../base/common/strings.js":"aA9I1","../../../common/commands/shiftCommand.js":"3JtMW","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/languages/languageConfiguration.js":"1ojaS","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../indentation/common/indentUtils.js":"bYvgh","../../../common/languages/autoIndent.js":"c4ZuY","../../../common/languages/enterAction.js":"0RBgX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dYOHv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortLinesCommand", ()=>SortLinesCommand);
var _editOperationJs = require("../../../common/core/editOperation.js");
var _rangeJs = require("../../../common/core/range.js");
class SortLinesCommand {
    static{
        this._COLLATOR = null;
    }
    static getCollator() {
        if (!SortLinesCommand._COLLATOR) SortLinesCommand._COLLATOR = new Intl.Collator();
        return SortLinesCommand._COLLATOR;
    }
    constructor(selection, descending){
        this.selection = selection;
        this.descending = descending;
        this.selectionId = null;
    }
    getEditOperations(model, builder) {
        const op = sortLines(model, this.selection, this.descending);
        if (op) builder.addEditOperation(op.range, op.text);
        this.selectionId = builder.trackSelection(this.selection);
    }
    computeCursorState(model, helper) {
        return helper.getTrackedSelection(this.selectionId);
    }
    static canRun(model, selection, descending) {
        if (model === null) return false;
        const data = getSortData(model, selection, descending);
        if (!data) return false;
        for(let i = 0, len = data.before.length; i < len; i++){
            if (data.before[i] !== data.after[i]) return true;
        }
        return false;
    }
}
function getSortData(model, selection, descending) {
    const startLineNumber = selection.startLineNumber;
    let endLineNumber = selection.endLineNumber;
    if (selection.endColumn === 1) endLineNumber--;
    // Nothing to sort if user didn't select anything.
    if (startLineNumber >= endLineNumber) return null;
    const linesToSort = [];
    // Get the contents of the selection to be sorted.
    for(let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++)linesToSort.push(model.getLineContent(lineNumber));
    let sorted = linesToSort.slice(0);
    sorted.sort(SortLinesCommand.getCollator().compare);
    // If descending, reverse the order.
    if (descending === true) sorted = sorted.reverse();
    return {
        startLineNumber: startLineNumber,
        endLineNumber: endLineNumber,
        before: linesToSort,
        after: sorted
    };
}
/**
 * Generate commands for sorting lines on a model.
 */ function sortLines(model, selection, descending) {
    const data = getSortData(model, selection, descending);
    if (!data) return null;
    return (0, _editOperationJs.EditOperation).replace(new (0, _rangeJs.Range)(data.startLineNumber, 1, data.endLineNumber, model.getLineMaxColumn(data.endLineNumber)), data.after.join("\n"));
}

},{"../../../common/core/editOperation.js":"6r2FZ","../../../common/core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eHsmo":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTEXT_ONTYPE_RENAME_INPUT_VISIBLE", ()=>CONTEXT_ONTYPE_RENAME_INPUT_VISIBLE);
parcelHelpers.export(exports, "LinkedEditingContribution", ()=>LinkedEditingContribution);
parcelHelpers.export(exports, "LinkedEditingAction", ()=>LinkedEditingAction);
parcelHelpers.export(exports, "editorLinkedEditingBackground", ()=>editorLinkedEditingBackground);
var _arraysJs = require("../../../../base/common/arrays.js");
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _colorJs = require("../../../../base/common/color.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _uriJs = require("../../../../base/common/uri.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _languageFeatureDebounceJs = require("../../../common/services/languageFeatureDebounce.js");
var _stopwatchJs = require("../../../../base/common/stopwatch.js");
var _linkedEditingCss = require("./linkedEditing.css");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var LinkedEditingContribution_1;
const CONTEXT_ONTYPE_RENAME_INPUT_VISIBLE = new (0, _contextkeyJs.RawContextKey)("LinkedEditingInputVisible", false);
const DECORATION_CLASS_NAME = "linked-editing-decoration";
let LinkedEditingContribution = class LinkedEditingContribution extends (0, _lifecycleJs.Disposable) {
    static{
        LinkedEditingContribution_1 = this;
    }
    static{
        this.ID = "editor.contrib.linkedEditing";
    }
    static{
        this.DECORATION = (0, _textModelJs.ModelDecorationOptions).register({
            description: "linked-editing",
            stickiness: 0 /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */ ,
            className: DECORATION_CLASS_NAME
        });
    }
    static get(editor) {
        return editor.getContribution(LinkedEditingContribution_1.ID);
    }
    constructor(editor, contextKeyService, languageFeaturesService, languageConfigurationService, languageFeatureDebounceService){
        super();
        this.languageConfigurationService = languageConfigurationService;
        this._syncRangesToken = 0;
        this._localToDispose = this._register(new (0, _lifecycleJs.DisposableStore)());
        this._editor = editor;
        this._providers = languageFeaturesService.linkedEditingRangeProvider;
        this._enabled = false;
        this._visibleContextKey = CONTEXT_ONTYPE_RENAME_INPUT_VISIBLE.bindTo(contextKeyService);
        this._debounceInformation = languageFeatureDebounceService.for(this._providers, "Linked Editing", {
            max: 200
        });
        this._currentDecorations = this._editor.createDecorationsCollection();
        this._languageWordPattern = null;
        this._currentWordPattern = null;
        this._ignoreChangeEvent = false;
        this._localToDispose = this._register(new (0, _lifecycleJs.DisposableStore)());
        this._rangeUpdateTriggerPromise = null;
        this._rangeSyncTriggerPromise = null;
        this._currentRequestCts = null;
        this._currentRequestPosition = null;
        this._currentRequestModelVersion = null;
        this._register(this._editor.onDidChangeModel(()=>this.reinitialize(true)));
        this._register(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(70 /* EditorOption.linkedEditing */ ) || e.hasChanged(94 /* EditorOption.renameOnType */ )) this.reinitialize(false);
        }));
        this._register(this._providers.onDidChange(()=>this.reinitialize(false)));
        this._register(this._editor.onDidChangeModelLanguage(()=>this.reinitialize(true)));
        this.reinitialize(true);
    }
    reinitialize(forceRefresh) {
        const model = this._editor.getModel();
        const isEnabled = model !== null && (this._editor.getOption(70 /* EditorOption.linkedEditing */ ) || this._editor.getOption(94 /* EditorOption.renameOnType */ )) && this._providers.has(model);
        if (isEnabled === this._enabled && !forceRefresh) return;
        this._enabled = isEnabled;
        this.clearRanges();
        this._localToDispose.clear();
        if (!isEnabled || model === null) return;
        this._localToDispose.add((0, _eventJs.Event).runAndSubscribe(model.onDidChangeLanguageConfiguration, ()=>{
            this._languageWordPattern = this.languageConfigurationService.getLanguageConfiguration(model.getLanguageId()).getWordDefinition();
        }));
        const rangeUpdateScheduler = new (0, _asyncJs.Delayer)(this._debounceInformation.get(model));
        const triggerRangeUpdate = ()=>{
            this._rangeUpdateTriggerPromise = rangeUpdateScheduler.trigger(()=>this.updateRanges(), this._debounceDuration ?? this._debounceInformation.get(model));
        };
        const rangeSyncScheduler = new (0, _asyncJs.Delayer)(0);
        const triggerRangeSync = (token)=>{
            this._rangeSyncTriggerPromise = rangeSyncScheduler.trigger(()=>this._syncRanges(token));
        };
        this._localToDispose.add(this._editor.onDidChangeCursorPosition(()=>{
            triggerRangeUpdate();
        }));
        this._localToDispose.add(this._editor.onDidChangeModelContent((e)=>{
            if (!this._ignoreChangeEvent) {
                if (this._currentDecorations.length > 0) {
                    const referenceRange = this._currentDecorations.getRange(0);
                    if (referenceRange && e.changes.every((c)=>referenceRange.intersectRanges(c.range))) {
                        triggerRangeSync(this._syncRangesToken);
                        return;
                    }
                }
            }
            triggerRangeUpdate();
        }));
        this._localToDispose.add({
            dispose: ()=>{
                rangeUpdateScheduler.dispose();
                rangeSyncScheduler.dispose();
            }
        });
        this.updateRanges();
    }
    _syncRanges(token) {
        // delayed invocation, make sure we're still on
        if (!this._editor.hasModel() || token !== this._syncRangesToken || this._currentDecorations.length === 0) // nothing to do
        return;
        const model = this._editor.getModel();
        const referenceRange = this._currentDecorations.getRange(0);
        if (!referenceRange || referenceRange.startLineNumber !== referenceRange.endLineNumber) return this.clearRanges();
        const referenceValue = model.getValueInRange(referenceRange);
        if (this._currentWordPattern) {
            const match = referenceValue.match(this._currentWordPattern);
            const matchLength = match ? match[0].length : 0;
            if (matchLength !== referenceValue.length) return this.clearRanges();
        }
        const edits = [];
        for(let i = 1, len = this._currentDecorations.length; i < len; i++){
            const mirrorRange = this._currentDecorations.getRange(i);
            if (!mirrorRange) continue;
            if (mirrorRange.startLineNumber !== mirrorRange.endLineNumber) edits.push({
                range: mirrorRange,
                text: referenceValue
            });
            else {
                let oldValue = model.getValueInRange(mirrorRange);
                let newValue = referenceValue;
                let rangeStartColumn = mirrorRange.startColumn;
                let rangeEndColumn = mirrorRange.endColumn;
                const commonPrefixLength = _stringsJs.commonPrefixLength(oldValue, newValue);
                rangeStartColumn += commonPrefixLength;
                oldValue = oldValue.substr(commonPrefixLength);
                newValue = newValue.substr(commonPrefixLength);
                const commonSuffixLength = _stringsJs.commonSuffixLength(oldValue, newValue);
                rangeEndColumn -= commonSuffixLength;
                oldValue = oldValue.substr(0, oldValue.length - commonSuffixLength);
                newValue = newValue.substr(0, newValue.length - commonSuffixLength);
                if (rangeStartColumn !== rangeEndColumn || newValue.length !== 0) edits.push({
                    range: new (0, _rangeJs.Range)(mirrorRange.startLineNumber, rangeStartColumn, mirrorRange.endLineNumber, rangeEndColumn),
                    text: newValue
                });
            }
        }
        if (edits.length === 0) return;
        try {
            this._editor.popUndoStop();
            this._ignoreChangeEvent = true;
            const prevEditOperationType = this._editor._getViewModel().getPrevEditOperationType();
            this._editor.executeEdits("linkedEditing", edits);
            this._editor._getViewModel().setPrevEditOperationType(prevEditOperationType);
        } finally{
            this._ignoreChangeEvent = false;
        }
    }
    dispose() {
        this.clearRanges();
        super.dispose();
    }
    clearRanges() {
        this._visibleContextKey.set(false);
        this._currentDecorations.clear();
        if (this._currentRequestCts) {
            this._currentRequestCts.cancel();
            this._currentRequestCts = null;
            this._currentRequestPosition = null;
        }
    }
    async updateRanges(force = false) {
        if (!this._editor.hasModel()) {
            this.clearRanges();
            return;
        }
        const position = this._editor.getPosition();
        if (!this._enabled && !force || this._editor.getSelections().length > 1) {
            // disabled or multicursor
            this.clearRanges();
            return;
        }
        const model = this._editor.getModel();
        const modelVersionId = model.getVersionId();
        if (this._currentRequestPosition && this._currentRequestModelVersion === modelVersionId) {
            if (position.equals(this._currentRequestPosition)) return; // same position
            if (this._currentDecorations.length > 0) {
                const range = this._currentDecorations.getRange(0);
                if (range && range.containsPosition(position)) return; // just moving inside the existing primary range
            }
        }
        // Clear existing decorations while we compute new ones
        this.clearRanges();
        this._currentRequestPosition = position;
        this._currentRequestModelVersion = modelVersionId;
        const currentRequestCts = this._currentRequestCts = new (0, _cancellationJs.CancellationTokenSource)();
        try {
            const sw = new (0, _stopwatchJs.StopWatch)(false);
            const response = await getLinkedEditingRanges(this._providers, model, position, currentRequestCts.token);
            this._debounceInformation.update(model, sw.elapsed());
            if (currentRequestCts !== this._currentRequestCts) return;
            this._currentRequestCts = null;
            if (modelVersionId !== model.getVersionId()) return;
            let ranges = [];
            if (response?.ranges) ranges = response.ranges;
            this._currentWordPattern = response?.wordPattern || this._languageWordPattern;
            let foundReferenceRange = false;
            for(let i = 0, len = ranges.length; i < len; i++)if ((0, _rangeJs.Range).containsPosition(ranges[i], position)) {
                foundReferenceRange = true;
                if (i !== 0) {
                    const referenceRange = ranges[i];
                    ranges.splice(i, 1);
                    ranges.unshift(referenceRange);
                }
                break;
            }
            if (!foundReferenceRange) {
                // Cannot do linked editing if the ranges are not where the cursor is...
                this.clearRanges();
                return;
            }
            const decorations = ranges.map((range)=>({
                    range: range,
                    options: LinkedEditingContribution_1.DECORATION
                }));
            this._visibleContextKey.set(true);
            this._currentDecorations.set(decorations);
            this._syncRangesToken++; // cancel any pending syncRanges call
        } catch (err) {
            if (!(0, _errorsJs.isCancellationError)(err)) (0, _errorsJs.onUnexpectedError)(err);
            if (this._currentRequestCts === currentRequestCts || !this._currentRequestCts) // stop if we are still the latest request
            this.clearRanges();
        }
    }
};
LinkedEditingContribution = LinkedEditingContribution_1 = __decorate([
    __param(1, (0, _contextkeyJs.IContextKeyService)),
    __param(2, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(3, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService)),
    __param(4, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService))
], LinkedEditingContribution);
class LinkedEditingAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.linkedEditing",
            label: _nlsJs.localize("linkedEditing.label", "Start Linked Editing"),
            alias: "Start Linked Editing",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _editorContextKeysJs.EditorContextKeys).hasRenameProvider),
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 3132 /* KeyCode.F2 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    runCommand(accessor, args) {
        const editorService = accessor.get((0, _codeEditorServiceJs.ICodeEditorService));
        const [uri, pos] = Array.isArray(args) && args || [
            undefined,
            undefined
        ];
        if ((0, _uriJs.URI).isUri(uri) && (0, _positionJs.Position).isIPosition(pos)) return editorService.openCodeEditor({
            resource: uri
        }, editorService.getActiveCodeEditor()).then((editor)=>{
            if (!editor) return;
            editor.setPosition(pos);
            editor.invokeWithinContext((accessor)=>{
                this.reportTelemetry(accessor, editor);
                return this.run(accessor, editor);
            });
        }, (0, _errorsJs.onUnexpectedError));
        return super.runCommand(accessor, args);
    }
    run(_accessor, editor) {
        const controller = LinkedEditingContribution.get(editor);
        if (controller) return Promise.resolve(controller.updateRanges(true));
        return Promise.resolve();
    }
}
const LinkedEditingCommand = (0, _editorExtensionsJs.EditorCommand).bindToContribution(LinkedEditingContribution.get);
(0, _editorExtensionsJs.registerEditorCommand)(new LinkedEditingCommand({
    id: "cancelLinkedEditingInput",
    precondition: CONTEXT_ONTYPE_RENAME_INPUT_VISIBLE,
    handler: (x)=>x.clearRanges(),
    kbOpts: {
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
        weight: 199,
        primary: 9 /* KeyCode.Escape */ ,
        secondary: [
            1033 /* KeyCode.Escape */ 
        ]
    }
}));
function getLinkedEditingRanges(providers, model, position, token) {
    const orderedByScore = providers.ordered(model);
    // in order of score ask the linked editing range provider
    // until someone response with a good result
    // (good = not null)
    return (0, _asyncJs.first)(orderedByScore.map((provider)=>async ()=>{
            try {
                return await provider.provideLinkedEditingRanges(model, position, token);
            } catch (e) {
                (0, _errorsJs.onUnexpectedExternalError)(e);
                return undefined;
            }
        }), (result)=>!!result && _arraysJs.isNonEmptyArray(result?.ranges));
}
const editorLinkedEditingBackground = (0, _colorRegistryJs.registerColor)("editor.linkedEditingBackground", {
    dark: (0, _colorJs.Color).fromHex("#f00").transparent(0.3),
    light: (0, _colorJs.Color).fromHex("#f00").transparent(0.3),
    hcDark: (0, _colorJs.Color).fromHex("#f00").transparent(0.3),
    hcLight: (0, _colorJs.Color).white
}, _nlsJs.localize("editorLinkedEditingBackground", "Background color when the editor auto renames on type."));
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeLinkedEditingProvider", (_accessor, model, position)=>{
    const { linkedEditingRangeProvider } = _accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return getLinkedEditingRanges(linkedEditingRangeProvider, model, position, (0, _cancellationJs.CancellationToken).None);
});
(0, _editorExtensionsJs.registerEditorContribution)(LinkedEditingContribution.ID, LinkedEditingContribution, 1 /* EditorContributionInstantiation.AfterFirstRender */ );
(0, _editorExtensionsJs.registerEditorAction)(LinkedEditingAction);

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/color.js":"at4gb","../../../../base/common/errors.js":"divX8","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/strings.js":"aA9I1","../../../../base/common/uri.js":"7qGS3","../../../browser/editorExtensions.js":"kC3w6","../../../browser/services/codeEditorService.js":"bOWtl","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/editorContextKeys.js":"5exv9","../../../common/model/textModel.js":"9beDe","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../common/services/languageFeatures.js":"2IAko","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../common/services/languageFeatureDebounce.js":"YGXXG","../../../../base/common/stopwatch.js":"77PF9","./linkedEditing.css":"6lcW9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6lcW9":[function() {},{}],"fLS4Z":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkDetector", ()=>LinkDetector);
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _htmlContentJs = require("../../../../base/common/htmlContent.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _networkJs = require("../../../../base/common/network.js");
var _platformJs = require("../../../../base/common/platform.js");
var _resourcesJs = require("../../../../base/common/resources.js");
var _stopwatchJs = require("../../../../base/common/stopwatch.js");
var _uriJs = require("../../../../base/common/uri.js");
var _linksCss = require("./links.css");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _languageFeatureDebounceJs = require("../../../common/services/languageFeatureDebounce.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _clickLinkGestureJs = require("../../gotoSymbol/browser/link/clickLinkGesture.js");
var _getLinksJs = require("./getLinks.js");
var _nlsJs = require("../../../../nls.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var _openerJs = require("../../../../platform/opener/common/opener.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var LinkDetector_1;
let LinkDetector = class LinkDetector extends (0, _lifecycleJs.Disposable) {
    static{
        LinkDetector_1 = this;
    }
    static{
        this.ID = "editor.linkDetector";
    }
    static get(editor) {
        return editor.getContribution(LinkDetector_1.ID);
    }
    constructor(editor, openerService, notificationService, languageFeaturesService, languageFeatureDebounceService){
        super();
        this.editor = editor;
        this.openerService = openerService;
        this.notificationService = notificationService;
        this.languageFeaturesService = languageFeaturesService;
        this.providers = this.languageFeaturesService.linkProvider;
        this.debounceInformation = languageFeatureDebounceService.for(this.providers, "Links", {
            min: 1000,
            max: 4000
        });
        this.computeLinks = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this.computeLinksNow(), 1000));
        this.computePromise = null;
        this.activeLinksList = null;
        this.currentOccurrences = {};
        this.activeLinkDecorationId = null;
        const clickLinkGesture = this._register(new (0, _clickLinkGestureJs.ClickLinkGesture)(editor));
        this._register(clickLinkGesture.onMouseMoveOrRelevantKeyDown(([mouseEvent, keyboardEvent])=>{
            this._onEditorMouseMove(mouseEvent, keyboardEvent);
        }));
        this._register(clickLinkGesture.onExecute((e)=>{
            this.onEditorMouseUp(e);
        }));
        this._register(clickLinkGesture.onCancel((e)=>{
            this.cleanUpActiveLinkDecoration();
        }));
        this._register(editor.onDidChangeConfiguration((e)=>{
            if (!e.hasChanged(71 /* EditorOption.links */ )) return;
            // Remove any links (for the getting disabled case)
            this.updateDecorations([]);
            // Stop any computation (for the getting disabled case)
            this.stop();
            // Start computing (for the getting enabled case)
            this.computeLinks.schedule(0);
        }));
        this._register(editor.onDidChangeModelContent((e)=>{
            if (!this.editor.hasModel()) return;
            this.computeLinks.schedule(this.debounceInformation.get(this.editor.getModel()));
        }));
        this._register(editor.onDidChangeModel((e)=>{
            this.currentOccurrences = {};
            this.activeLinkDecorationId = null;
            this.stop();
            this.computeLinks.schedule(0);
        }));
        this._register(editor.onDidChangeModelLanguage((e)=>{
            this.stop();
            this.computeLinks.schedule(0);
        }));
        this._register(this.providers.onDidChange((e)=>{
            this.stop();
            this.computeLinks.schedule(0);
        }));
        this.computeLinks.schedule(0);
    }
    async computeLinksNow() {
        if (!this.editor.hasModel() || !this.editor.getOption(71 /* EditorOption.links */ )) return;
        const model = this.editor.getModel();
        if (model.isTooLargeForSyncing()) return;
        if (!this.providers.has(model)) return;
        if (this.activeLinksList) {
            this.activeLinksList.dispose();
            this.activeLinksList = null;
        }
        this.computePromise = (0, _asyncJs.createCancelablePromise)((token)=>(0, _getLinksJs.getLinks)(this.providers, model, token));
        try {
            const sw = new (0, _stopwatchJs.StopWatch)(false);
            this.activeLinksList = await this.computePromise;
            this.debounceInformation.update(model, sw.elapsed());
            if (model.isDisposed()) return;
            this.updateDecorations(this.activeLinksList.links);
        } catch (err) {
            (0, _errorsJs.onUnexpectedError)(err);
        } finally{
            this.computePromise = null;
        }
    }
    updateDecorations(links) {
        const useMetaKey = this.editor.getOption(78 /* EditorOption.multiCursorModifier */ ) === "altKey";
        const oldDecorations = [];
        const keys = Object.keys(this.currentOccurrences);
        for (const decorationId of keys){
            const occurence = this.currentOccurrences[decorationId];
            oldDecorations.push(occurence.decorationId);
        }
        const newDecorations = [];
        if (links) // Not sure why this is sometimes null
        for (const link of links)newDecorations.push(LinkOccurrence.decoration(link, useMetaKey));
        this.editor.changeDecorations((changeAccessor)=>{
            const decorations = changeAccessor.deltaDecorations(oldDecorations, newDecorations);
            this.currentOccurrences = {};
            this.activeLinkDecorationId = null;
            for(let i = 0, len = decorations.length; i < len; i++){
                const occurence = new LinkOccurrence(links[i], decorations[i]);
                this.currentOccurrences[occurence.decorationId] = occurence;
            }
        });
    }
    _onEditorMouseMove(mouseEvent, withKey) {
        const useMetaKey = this.editor.getOption(78 /* EditorOption.multiCursorModifier */ ) === "altKey";
        if (this.isEnabled(mouseEvent, withKey)) {
            this.cleanUpActiveLinkDecoration(); // always remove previous link decoration as their can only be one
            const occurrence = this.getLinkOccurrence(mouseEvent.target.position);
            if (occurrence) this.editor.changeDecorations((changeAccessor)=>{
                occurrence.activate(changeAccessor, useMetaKey);
                this.activeLinkDecorationId = occurrence.decorationId;
            });
        } else this.cleanUpActiveLinkDecoration();
    }
    cleanUpActiveLinkDecoration() {
        const useMetaKey = this.editor.getOption(78 /* EditorOption.multiCursorModifier */ ) === "altKey";
        if (this.activeLinkDecorationId) {
            const occurrence = this.currentOccurrences[this.activeLinkDecorationId];
            if (occurrence) this.editor.changeDecorations((changeAccessor)=>{
                occurrence.deactivate(changeAccessor, useMetaKey);
            });
            this.activeLinkDecorationId = null;
        }
    }
    onEditorMouseUp(mouseEvent) {
        if (!this.isEnabled(mouseEvent)) return;
        const occurrence = this.getLinkOccurrence(mouseEvent.target.position);
        if (!occurrence) return;
        this.openLinkOccurrence(occurrence, mouseEvent.hasSideBySideModifier, true);
    }
    openLinkOccurrence(occurrence, openToSide, fromUserGesture = false) {
        if (!this.openerService) return;
        const { link } = occurrence;
        link.resolve((0, _cancellationJs.CancellationToken).None).then((uri)=>{
            // Support for relative file URIs of the shape file://./relativeFile.txt or file:///./relativeFile.txt
            if (typeof uri === "string" && this.editor.hasModel()) {
                const modelUri = this.editor.getModel().uri;
                if (modelUri.scheme === (0, _networkJs.Schemas).file && uri.startsWith(`${(0, _networkJs.Schemas).file}:`)) {
                    const parsedUri = (0, _uriJs.URI).parse(uri);
                    if (parsedUri.scheme === (0, _networkJs.Schemas).file) {
                        const fsPath = _resourcesJs.originalFSPath(parsedUri);
                        let relativePath = null;
                        if (fsPath.startsWith("/./") || fsPath.startsWith("\\.\\")) relativePath = `.${fsPath.substr(1)}`;
                        else if (fsPath.startsWith("//./") || fsPath.startsWith("\\\\.\\")) relativePath = `.${fsPath.substr(2)}`;
                        if (relativePath) uri = _resourcesJs.joinPath(modelUri, relativePath);
                    }
                }
            }
            return this.openerService.open(uri, {
                openToSide,
                fromUserGesture,
                allowContributedOpeners: true,
                allowCommands: true,
                fromWorkspace: true
            });
        }, (err)=>{
            const messageOrError = err instanceof Error ? err.message : err;
            // different error cases
            if (messageOrError === "invalid") this.notificationService.warn(_nlsJs.localize("invalid.url", "Failed to open this link because it is not well-formed: {0}", link.url.toString()));
            else if (messageOrError === "missing") this.notificationService.warn(_nlsJs.localize("missing.url", "Failed to open this link because its target is missing."));
            else (0, _errorsJs.onUnexpectedError)(err);
        });
    }
    getLinkOccurrence(position) {
        if (!this.editor.hasModel() || !position) return null;
        const decorations = this.editor.getModel().getDecorationsInRange({
            startLineNumber: position.lineNumber,
            startColumn: position.column,
            endLineNumber: position.lineNumber,
            endColumn: position.column
        }, 0, true);
        for (const decoration of decorations){
            const currentOccurrence = this.currentOccurrences[decoration.id];
            if (currentOccurrence) return currentOccurrence;
        }
        return null;
    }
    isEnabled(mouseEvent, withKey) {
        return Boolean(mouseEvent.target.type === 6 /* MouseTargetType.CONTENT_TEXT */  && (mouseEvent.hasTriggerModifier || withKey && withKey.keyCodeIsTriggerKey));
    }
    stop() {
        this.computeLinks.cancel();
        if (this.activeLinksList) {
            this.activeLinksList?.dispose();
            this.activeLinksList = null;
        }
        if (this.computePromise) {
            this.computePromise.cancel();
            this.computePromise = null;
        }
    }
    dispose() {
        super.dispose();
        this.stop();
    }
};
LinkDetector = LinkDetector_1 = __decorate([
    __param(1, (0, _openerJs.IOpenerService)),
    __param(2, (0, _notificationJs.INotificationService)),
    __param(3, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(4, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService))
], LinkDetector);
const decoration = {
    general: (0, _textModelJs.ModelDecorationOptions).register({
        description: "detected-link",
        stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
        collapseOnReplaceEdit: true,
        inlineClassName: "detected-link"
    }),
    active: (0, _textModelJs.ModelDecorationOptions).register({
        description: "detected-link-active",
        stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
        collapseOnReplaceEdit: true,
        inlineClassName: "detected-link-active"
    })
};
class LinkOccurrence {
    static decoration(link, useMetaKey) {
        return {
            range: link.range,
            options: LinkOccurrence._getOptions(link, useMetaKey, false)
        };
    }
    static _getOptions(link, useMetaKey, isActive) {
        const options = {
            ...isActive ? decoration.active : decoration.general
        };
        options.hoverMessage = getHoverMessage(link, useMetaKey);
        return options;
    }
    constructor(link, decorationId){
        this.link = link;
        this.decorationId = decorationId;
    }
    activate(changeAccessor, useMetaKey) {
        changeAccessor.changeDecorationOptions(this.decorationId, LinkOccurrence._getOptions(this.link, useMetaKey, true));
    }
    deactivate(changeAccessor, useMetaKey) {
        changeAccessor.changeDecorationOptions(this.decorationId, LinkOccurrence._getOptions(this.link, useMetaKey, false));
    }
}
function getHoverMessage(link, useMetaKey) {
    const executeCmd = link.url && /^command:/i.test(link.url.toString());
    const label = link.tooltip ? link.tooltip : executeCmd ? _nlsJs.localize("links.navigate.executeCmd", "Execute command") : _nlsJs.localize("links.navigate.follow", "Follow link");
    const kb = useMetaKey ? _platformJs.isMacintosh ? _nlsJs.localize("links.navigate.kb.meta.mac", "cmd + click") : _nlsJs.localize("links.navigate.kb.meta", "ctrl + click") : _platformJs.isMacintosh ? _nlsJs.localize("links.navigate.kb.alt.mac", "option + click") : _nlsJs.localize("links.navigate.kb.alt", "alt + click");
    if (link.url) {
        let nativeLabel = "";
        if (/^command:/i.test(link.url.toString())) {
            // Don't show complete command arguments in the native tooltip
            const match = link.url.toString().match(/^command:([^?#]+)/);
            if (match) {
                const commandId = match[1];
                nativeLabel = _nlsJs.localize("tooltip.explanation", "Execute command {0}", commandId);
            }
        }
        const hoverMessage = new (0, _htmlContentJs.MarkdownString)("", true).appendLink(link.url.toString(true).replace(/ /g, "%20"), label, nativeLabel).appendMarkdown(` (${kb})`);
        return hoverMessage;
    } else return new (0, _htmlContentJs.MarkdownString)().appendText(`${label} (${kb})`);
}
class OpenLinkAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.openLink",
            label: _nlsJs.localize("label", "Open Link"),
            alias: "Open Link",
            precondition: undefined
        });
    }
    run(accessor, editor) {
        const linkDetector = LinkDetector.get(editor);
        if (!linkDetector) return;
        if (!editor.hasModel()) return;
        const selections = editor.getSelections();
        for (const sel of selections){
            const link = linkDetector.getLinkOccurrence(sel.getEndPosition());
            if (link) linkDetector.openLinkOccurrence(link, false);
        }
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(LinkDetector.ID, LinkDetector, 1 /* EditorContributionInstantiation.AfterFirstRender */ );
(0, _editorExtensionsJs.registerEditorAction)(OpenLinkAction);

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/htmlContent.js":"3Hxzm","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/network.js":"2c1AD","../../../../base/common/platform.js":"7maJO","../../../../base/common/resources.js":"700EV","../../../../base/common/stopwatch.js":"77PF9","../../../../base/common/uri.js":"7qGS3","./links.css":"l6R4F","../../../browser/editorExtensions.js":"kC3w6","../../../common/model/textModel.js":"9beDe","../../../common/services/languageFeatureDebounce.js":"YGXXG","../../../common/services/languageFeatures.js":"2IAko","../../gotoSymbol/browser/link/clickLinkGesture.js":"5rimz","./getLinks.js":"hR7Kl","../../../../nls.js":"l617d","../../../../platform/notification/common/notification.js":"igv0W","../../../../platform/opener/common/opener.js":"d3tj1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l6R4F":[function() {},{}],"hR7Kl":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "LinksList", ()=>LinksList);
parcelHelpers.export(exports, "getLinks", ()=>getLinks);
var _arraysJs = require("../../../../base/common/arrays.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _typesJs = require("../../../../base/common/types.js");
var _uriJs = require("../../../../base/common/uri.js");
var _rangeJs = require("../../../common/core/range.js");
var _modelJs = require("../../../common/services/model.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
class Link {
    constructor(link, provider){
        this._link = link;
        this._provider = provider;
    }
    toJSON() {
        return {
            range: this.range,
            url: this.url,
            tooltip: this.tooltip
        };
    }
    get range() {
        return this._link.range;
    }
    get url() {
        return this._link.url;
    }
    get tooltip() {
        return this._link.tooltip;
    }
    async resolve(token) {
        if (this._link.url) return this._link.url;
        if (typeof this._provider.resolveLink === "function") return Promise.resolve(this._provider.resolveLink(this._link, token)).then((value)=>{
            this._link = value || this._link;
            if (this._link.url) // recurse
            return this.resolve(token);
            return Promise.reject(new Error("missing"));
        });
        return Promise.reject(new Error("missing"));
    }
}
class LinksList {
    constructor(tuples){
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        let links = [];
        for (const [list, provider] of tuples){
            // merge all links
            const newLinks = list.links.map((link)=>new Link(link, provider));
            links = LinksList._union(links, newLinks);
            // register disposables
            if ((0, _lifecycleJs.isDisposable)(list)) this._disposables.add(list);
        }
        this.links = links;
    }
    dispose() {
        this._disposables.dispose();
        this.links.length = 0;
    }
    static _union(oldLinks, newLinks) {
        // reunite oldLinks with newLinks and remove duplicates
        const result = [];
        let oldIndex;
        let oldLen;
        let newIndex;
        let newLen;
        for(oldIndex = 0, newIndex = 0, oldLen = oldLinks.length, newLen = newLinks.length; oldIndex < oldLen && newIndex < newLen;){
            const oldLink = oldLinks[oldIndex];
            const newLink = newLinks[newIndex];
            if ((0, _rangeJs.Range).areIntersectingOrTouching(oldLink.range, newLink.range)) {
                // Remove the oldLink
                oldIndex++;
                continue;
            }
            const comparisonResult = (0, _rangeJs.Range).compareRangesUsingStarts(oldLink.range, newLink.range);
            if (comparisonResult < 0) {
                // oldLink is before
                result.push(oldLink);
                oldIndex++;
            } else {
                // newLink is before
                result.push(newLink);
                newIndex++;
            }
        }
        for(; oldIndex < oldLen; oldIndex++)result.push(oldLinks[oldIndex]);
        for(; newIndex < newLen; newIndex++)result.push(newLinks[newIndex]);
        return result;
    }
}
function getLinks(providers, model, token) {
    const lists = [];
    // ask all providers for links in parallel
    const promises = providers.ordered(model).reverse().map((provider, i)=>{
        return Promise.resolve(provider.provideLinks(model, token)).then((result)=>{
            if (result) lists[i] = [
                result,
                provider
            ];
        }, (0, _errorsJs.onUnexpectedExternalError));
    });
    return Promise.all(promises).then(()=>{
        const result = new LinksList((0, _arraysJs.coalesce)(lists));
        if (!token.isCancellationRequested) return result;
        result.dispose();
        return new LinksList([]);
    });
}
(0, _commandsJs.CommandsRegistry).registerCommand("_executeLinkProvider", async (accessor, ...args)=>{
    let [uri, resolveCount] = args;
    (0, _typesJs.assertType)(uri instanceof (0, _uriJs.URI));
    if (typeof resolveCount !== "number") resolveCount = 0;
    const { linkProvider } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const model = accessor.get((0, _modelJs.IModelService)).getModel(uri);
    if (!model) return [];
    const list = await getLinks(linkProvider, model, (0, _cancellationJs.CancellationToken).None);
    if (!list) return [];
    // resolve links
    for(let i = 0; i < Math.min(resolveCount, list.links.length); i++)await list.links[i].resolve((0, _cancellationJs.CancellationToken).None);
    const result = list.links.slice(0);
    list.dispose();
    return result;
});

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/types.js":"fb5yx","../../../../base/common/uri.js":"7qGS3","../../../common/core/range.js":"jmUPh","../../../common/services/model.js":"aciVm","../../../../platform/commands/common/commands.js":"ho6ic","../../../common/services/languageFeatures.js":"2IAko","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eebrG":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
class LongLinesHelper extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.longLinesHelper";
    }
    constructor(_editor){
        super();
        this._editor = _editor;
        this._register(this._editor.onMouseDown((e)=>{
            const stopRenderingLineAfter = this._editor.getOption(118 /* EditorOption.stopRenderingLineAfter */ );
            if (stopRenderingLineAfter >= 0 && e.target.type === 6 /* MouseTargetType.CONTENT_TEXT */  && e.target.position.column >= stopRenderingLineAfter) this._editor.updateOptions({
                stopRenderingLineAfter: -1
            });
        }));
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(LongLinesHelper.ID, LongLinesHelper, 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorExtensions.js":"kC3w6"}],"fdlsM":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InsertCursorAbove", ()=>InsertCursorAbove);
parcelHelpers.export(exports, "InsertCursorBelow", ()=>InsertCursorBelow);
parcelHelpers.export(exports, "MultiCursorSessionResult", ()=>MultiCursorSessionResult);
parcelHelpers.export(exports, "MultiCursorSession", ()=>MultiCursorSession);
parcelHelpers.export(exports, "MultiCursorSelectionController", ()=>MultiCursorSelectionController);
parcelHelpers.export(exports, "MultiCursorSelectionControllerAction", ()=>MultiCursorSelectionControllerAction);
parcelHelpers.export(exports, "AddSelectionToNextFindMatchAction", ()=>AddSelectionToNextFindMatchAction);
parcelHelpers.export(exports, "AddSelectionToPreviousFindMatchAction", ()=>AddSelectionToPreviousFindMatchAction);
parcelHelpers.export(exports, "MoveSelectionToNextFindMatchAction", ()=>MoveSelectionToNextFindMatchAction);
parcelHelpers.export(exports, "MoveSelectionToPreviousFindMatchAction", ()=>MoveSelectionToPreviousFindMatchAction);
parcelHelpers.export(exports, "SelectHighlightsAction", ()=>SelectHighlightsAction);
parcelHelpers.export(exports, "CompatChangeAll", ()=>CompatChangeAll);
parcelHelpers.export(exports, "SelectionHighlighter", ()=>SelectionHighlighter);
parcelHelpers.export(exports, "FocusNextCursor", ()=>FocusNextCursor);
parcelHelpers.export(exports, "FocusPreviousCursor", ()=>FocusPreviousCursor);
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var _asyncJs = require("../../../../base/common/async.js");
var _keyCodesJs = require("../../../../base/common/keyCodes.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _cursorMoveCommandsJs = require("../../../common/cursor/cursorMoveCommands.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _findControllerJs = require("../../find/browser/findController.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _highlightDecorationsJs = require("../../wordHighlighter/browser/highlightDecorations.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var SelectionHighlighter_1;
function announceCursorChange(previousCursorState, cursorState) {
    const cursorDiff = cursorState.filter((cs)=>!previousCursorState.find((pcs)=>pcs.equals(cs)));
    if (cursorDiff.length >= 1) {
        const cursorPositions = cursorDiff.map((cs)=>`line ${cs.viewState.position.lineNumber} column ${cs.viewState.position.column}`).join(", ");
        const msg = cursorDiff.length === 1 ? _nlsJs.localize("cursorAdded", "Cursor added: {0}", cursorPositions) : _nlsJs.localize("cursorsAdded", "Cursors added: {0}", cursorPositions);
        (0, _ariaJs.status)(msg);
    }
}
class InsertCursorAbove extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.insertCursorAbove",
            label: _nlsJs.localize("mutlicursor.insertAbove", "Add Cursor Above"),
            alias: "Add Cursor Above",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 2576 /* KeyCode.UpArrow */ ,
                linux: {
                    primary: 1552 /* KeyCode.UpArrow */ ,
                    secondary: [
                        3088 /* KeyCode.UpArrow */ 
                    ]
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "3_multi",
                title: _nlsJs.localize({
                    key: "miInsertCursorAbove",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "&&Add Cursor Above"),
                order: 2
            }
        });
    }
    run(accessor, editor, args) {
        if (!editor.hasModel()) return;
        let useLogicalLine = true;
        if (args && args.logicalLine === false) useLogicalLine = false;
        const viewModel = editor._getViewModel();
        if (viewModel.cursorConfig.readOnly) return;
        viewModel.model.pushStackElement();
        const previousCursorState = viewModel.getCursorStates();
        viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , (0, _cursorMoveCommandsJs.CursorMoveCommands).addCursorUp(viewModel, previousCursorState, useLogicalLine));
        viewModel.revealTopMostCursor(args.source);
        announceCursorChange(previousCursorState, viewModel.getCursorStates());
    }
}
class InsertCursorBelow extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.insertCursorBelow",
            label: _nlsJs.localize("mutlicursor.insertBelow", "Add Cursor Below"),
            alias: "Add Cursor Below",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 2578 /* KeyCode.DownArrow */ ,
                linux: {
                    primary: 1554 /* KeyCode.DownArrow */ ,
                    secondary: [
                        3090 /* KeyCode.DownArrow */ 
                    ]
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "3_multi",
                title: _nlsJs.localize({
                    key: "miInsertCursorBelow",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "A&&dd Cursor Below"),
                order: 3
            }
        });
    }
    run(accessor, editor, args) {
        if (!editor.hasModel()) return;
        let useLogicalLine = true;
        if (args && args.logicalLine === false) useLogicalLine = false;
        const viewModel = editor._getViewModel();
        if (viewModel.cursorConfig.readOnly) return;
        viewModel.model.pushStackElement();
        const previousCursorState = viewModel.getCursorStates();
        viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , (0, _cursorMoveCommandsJs.CursorMoveCommands).addCursorDown(viewModel, previousCursorState, useLogicalLine));
        viewModel.revealBottomMostCursor(args.source);
        announceCursorChange(previousCursorState, viewModel.getCursorStates());
    }
}
class InsertCursorAtEndOfEachLineSelected extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.insertCursorAtEndOfEachLineSelected",
            label: _nlsJs.localize("mutlicursor.insertAtEndOfEachLineSelected", "Add Cursors to Line Ends"),
            alias: "Add Cursors to Line Ends",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 1575 /* KeyCode.KeyI */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "3_multi",
                title: _nlsJs.localize({
                    key: "miInsertCursorAtEndOfEachLineSelected",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Add C&&ursors to Line Ends"),
                order: 4
            }
        });
    }
    getCursorsForSelection(selection, model, result) {
        if (selection.isEmpty()) return;
        for(let i = selection.startLineNumber; i < selection.endLineNumber; i++){
            const currentLineMaxColumn = model.getLineMaxColumn(i);
            result.push(new (0, _selectionJs.Selection)(i, currentLineMaxColumn, i, currentLineMaxColumn));
        }
        if (selection.endColumn > 1) result.push(new (0, _selectionJs.Selection)(selection.endLineNumber, selection.endColumn, selection.endLineNumber, selection.endColumn));
    }
    run(accessor, editor) {
        if (!editor.hasModel()) return;
        const model = editor.getModel();
        const selections = editor.getSelections();
        const viewModel = editor._getViewModel();
        const previousCursorState = viewModel.getCursorStates();
        const newSelections = [];
        selections.forEach((sel)=>this.getCursorsForSelection(sel, model, newSelections));
        if (newSelections.length > 0) editor.setSelections(newSelections);
        announceCursorChange(previousCursorState, viewModel.getCursorStates());
    }
}
class InsertCursorAtEndOfLineSelected extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.addCursorsToBottom",
            label: _nlsJs.localize("mutlicursor.addCursorsToBottom", "Add Cursors To Bottom"),
            alias: "Add Cursors To Bottom",
            precondition: undefined
        });
    }
    run(accessor, editor) {
        if (!editor.hasModel()) return;
        const selections = editor.getSelections();
        const lineCount = editor.getModel().getLineCount();
        const newSelections = [];
        for(let i = selections[0].startLineNumber; i <= lineCount; i++)newSelections.push(new (0, _selectionJs.Selection)(i, selections[0].startColumn, i, selections[0].endColumn));
        const viewModel = editor._getViewModel();
        const previousCursorState = viewModel.getCursorStates();
        if (newSelections.length > 0) editor.setSelections(newSelections);
        announceCursorChange(previousCursorState, viewModel.getCursorStates());
    }
}
class InsertCursorAtTopOfLineSelected extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.addCursorsToTop",
            label: _nlsJs.localize("mutlicursor.addCursorsToTop", "Add Cursors To Top"),
            alias: "Add Cursors To Top",
            precondition: undefined
        });
    }
    run(accessor, editor) {
        if (!editor.hasModel()) return;
        const selections = editor.getSelections();
        const newSelections = [];
        for(let i = selections[0].startLineNumber; i >= 1; i--)newSelections.push(new (0, _selectionJs.Selection)(i, selections[0].startColumn, i, selections[0].endColumn));
        const viewModel = editor._getViewModel();
        const previousCursorState = viewModel.getCursorStates();
        if (newSelections.length > 0) editor.setSelections(newSelections);
        announceCursorChange(previousCursorState, viewModel.getCursorStates());
    }
}
class MultiCursorSessionResult {
    constructor(selections, revealRange, revealScrollType){
        this.selections = selections;
        this.revealRange = revealRange;
        this.revealScrollType = revealScrollType;
    }
}
class MultiCursorSession {
    static create(editor, findController) {
        if (!editor.hasModel()) return null;
        const findState = findController.getState();
        // Find widget owns entirely what we search for if:
        //  - focus is not in the editor (i.e. it is in the find widget)
        //  - and the search widget is visible
        //  - and the search string is non-empty
        if (!editor.hasTextFocus() && findState.isRevealed && findState.searchString.length > 0) // Find widget owns what is searched for
        return new MultiCursorSession(editor, findController, false, findState.searchString, findState.wholeWord, findState.matchCase, null);
        // Otherwise, the selection gives the search text, and the find widget gives the search settings
        // The exception is the find state disassociation case: when beginning with a single, collapsed selection
        let isDisconnectedFromFindController = false;
        let wholeWord;
        let matchCase;
        const selections = editor.getSelections();
        if (selections.length === 1 && selections[0].isEmpty()) {
            isDisconnectedFromFindController = true;
            wholeWord = true;
            matchCase = true;
        } else {
            wholeWord = findState.wholeWord;
            matchCase = findState.matchCase;
        }
        // Selection owns what is searched for
        const s = editor.getSelection();
        let searchText;
        let currentMatch = null;
        if (s.isEmpty()) {
            // selection is empty => expand to current word
            const word = editor.getConfiguredWordAtPosition(s.getStartPosition());
            if (!word) return null;
            searchText = word.word;
            currentMatch = new (0, _selectionJs.Selection)(s.startLineNumber, word.startColumn, s.startLineNumber, word.endColumn);
        } else searchText = editor.getModel().getValueInRange(s).replace(/\r\n/g, "\n");
        return new MultiCursorSession(editor, findController, isDisconnectedFromFindController, searchText, wholeWord, matchCase, currentMatch);
    }
    constructor(_editor, findController, isDisconnectedFromFindController, searchText, wholeWord, matchCase, currentMatch){
        this._editor = _editor;
        this.findController = findController;
        this.isDisconnectedFromFindController = isDisconnectedFromFindController;
        this.searchText = searchText;
        this.wholeWord = wholeWord;
        this.matchCase = matchCase;
        this.currentMatch = currentMatch;
    }
    addSelectionToNextFindMatch() {
        if (!this._editor.hasModel()) return null;
        const nextMatch = this._getNextMatch();
        if (!nextMatch) return null;
        const allSelections = this._editor.getSelections();
        return new MultiCursorSessionResult(allSelections.concat(nextMatch), nextMatch, 0 /* ScrollType.Smooth */ );
    }
    moveSelectionToNextFindMatch() {
        if (!this._editor.hasModel()) return null;
        const nextMatch = this._getNextMatch();
        if (!nextMatch) return null;
        const allSelections = this._editor.getSelections();
        return new MultiCursorSessionResult(allSelections.slice(0, allSelections.length - 1).concat(nextMatch), nextMatch, 0 /* ScrollType.Smooth */ );
    }
    _getNextMatch() {
        if (!this._editor.hasModel()) return null;
        if (this.currentMatch) {
            const result = this.currentMatch;
            this.currentMatch = null;
            return result;
        }
        this.findController.highlightFindOptions();
        const allSelections = this._editor.getSelections();
        const lastAddedSelection = allSelections[allSelections.length - 1];
        const nextMatch = this._editor.getModel().findNextMatch(this.searchText, lastAddedSelection.getEndPosition(), false, this.matchCase, this.wholeWord ? this._editor.getOption(132 /* EditorOption.wordSeparators */ ) : null, false);
        if (!nextMatch) return null;
        return new (0, _selectionJs.Selection)(nextMatch.range.startLineNumber, nextMatch.range.startColumn, nextMatch.range.endLineNumber, nextMatch.range.endColumn);
    }
    addSelectionToPreviousFindMatch() {
        if (!this._editor.hasModel()) return null;
        const previousMatch = this._getPreviousMatch();
        if (!previousMatch) return null;
        const allSelections = this._editor.getSelections();
        return new MultiCursorSessionResult(allSelections.concat(previousMatch), previousMatch, 0 /* ScrollType.Smooth */ );
    }
    moveSelectionToPreviousFindMatch() {
        if (!this._editor.hasModel()) return null;
        const previousMatch = this._getPreviousMatch();
        if (!previousMatch) return null;
        const allSelections = this._editor.getSelections();
        return new MultiCursorSessionResult(allSelections.slice(0, allSelections.length - 1).concat(previousMatch), previousMatch, 0 /* ScrollType.Smooth */ );
    }
    _getPreviousMatch() {
        if (!this._editor.hasModel()) return null;
        if (this.currentMatch) {
            const result = this.currentMatch;
            this.currentMatch = null;
            return result;
        }
        this.findController.highlightFindOptions();
        const allSelections = this._editor.getSelections();
        const lastAddedSelection = allSelections[allSelections.length - 1];
        const previousMatch = this._editor.getModel().findPreviousMatch(this.searchText, lastAddedSelection.getStartPosition(), false, this.matchCase, this.wholeWord ? this._editor.getOption(132 /* EditorOption.wordSeparators */ ) : null, false);
        if (!previousMatch) return null;
        return new (0, _selectionJs.Selection)(previousMatch.range.startLineNumber, previousMatch.range.startColumn, previousMatch.range.endLineNumber, previousMatch.range.endColumn);
    }
    selectAll(searchScope) {
        if (!this._editor.hasModel()) return [];
        this.findController.highlightFindOptions();
        const editorModel = this._editor.getModel();
        if (searchScope) return editorModel.findMatches(this.searchText, searchScope, false, this.matchCase, this.wholeWord ? this._editor.getOption(132 /* EditorOption.wordSeparators */ ) : null, false, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ );
        return editorModel.findMatches(this.searchText, true, false, this.matchCase, this.wholeWord ? this._editor.getOption(132 /* EditorOption.wordSeparators */ ) : null, false, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ );
    }
}
class MultiCursorSelectionController extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.multiCursorController";
    }
    static get(editor) {
        return editor.getContribution(MultiCursorSelectionController.ID);
    }
    constructor(editor){
        super();
        this._sessionDispose = this._register(new (0, _lifecycleJs.DisposableStore)());
        this._editor = editor;
        this._ignoreSelectionChange = false;
        this._session = null;
    }
    dispose() {
        this._endSession();
        super.dispose();
    }
    _beginSessionIfNeeded(findController) {
        if (!this._session) {
            // Create a new session
            const session = MultiCursorSession.create(this._editor, findController);
            if (!session) return;
            this._session = session;
            const newState = {
                searchString: this._session.searchText
            };
            if (this._session.isDisconnectedFromFindController) {
                newState.wholeWordOverride = 1 /* FindOptionOverride.True */ ;
                newState.matchCaseOverride = 1 /* FindOptionOverride.True */ ;
                newState.isRegexOverride = 2 /* FindOptionOverride.False */ ;
            }
            findController.getState().change(newState, false);
            this._sessionDispose.add(this._editor.onDidChangeCursorSelection((e)=>{
                if (this._ignoreSelectionChange) return;
                this._endSession();
            }));
            this._sessionDispose.add(this._editor.onDidBlurEditorText(()=>{
                this._endSession();
            }));
            this._sessionDispose.add(findController.getState().onFindReplaceStateChange((e)=>{
                if (e.matchCase || e.wholeWord) this._endSession();
            }));
        }
    }
    _endSession() {
        this._sessionDispose.clear();
        if (this._session && this._session.isDisconnectedFromFindController) {
            const newState = {
                wholeWordOverride: 0 /* FindOptionOverride.NotSet */ ,
                matchCaseOverride: 0 /* FindOptionOverride.NotSet */ ,
                isRegexOverride: 0 /* FindOptionOverride.NotSet */ 
            };
            this._session.findController.getState().change(newState, false);
        }
        this._session = null;
    }
    _setSelections(selections) {
        this._ignoreSelectionChange = true;
        this._editor.setSelections(selections);
        this._ignoreSelectionChange = false;
    }
    _expandEmptyToWord(model, selection) {
        if (!selection.isEmpty()) return selection;
        const word = this._editor.getConfiguredWordAtPosition(selection.getStartPosition());
        if (!word) return selection;
        return new (0, _selectionJs.Selection)(selection.startLineNumber, word.startColumn, selection.startLineNumber, word.endColumn);
    }
    _applySessionResult(result) {
        if (!result) return;
        this._setSelections(result.selections);
        if (result.revealRange) this._editor.revealRangeInCenterIfOutsideViewport(result.revealRange, result.revealScrollType);
    }
    getSession(findController) {
        return this._session;
    }
    addSelectionToNextFindMatch(findController) {
        if (!this._editor.hasModel()) return;
        if (!this._session) {
            // If there are multiple cursors, handle the case where they do not all select the same text.
            const allSelections = this._editor.getSelections();
            if (allSelections.length > 1) {
                const findState = findController.getState();
                const matchCase = findState.matchCase;
                const selectionsContainSameText = modelRangesContainSameText(this._editor.getModel(), allSelections, matchCase);
                if (!selectionsContainSameText) {
                    const model = this._editor.getModel();
                    const resultingSelections = [];
                    for(let i = 0, len = allSelections.length; i < len; i++)resultingSelections[i] = this._expandEmptyToWord(model, allSelections[i]);
                    this._editor.setSelections(resultingSelections);
                    return;
                }
            }
        }
        this._beginSessionIfNeeded(findController);
        if (this._session) this._applySessionResult(this._session.addSelectionToNextFindMatch());
    }
    addSelectionToPreviousFindMatch(findController) {
        this._beginSessionIfNeeded(findController);
        if (this._session) this._applySessionResult(this._session.addSelectionToPreviousFindMatch());
    }
    moveSelectionToNextFindMatch(findController) {
        this._beginSessionIfNeeded(findController);
        if (this._session) this._applySessionResult(this._session.moveSelectionToNextFindMatch());
    }
    moveSelectionToPreviousFindMatch(findController) {
        this._beginSessionIfNeeded(findController);
        if (this._session) this._applySessionResult(this._session.moveSelectionToPreviousFindMatch());
    }
    selectAll(findController) {
        if (!this._editor.hasModel()) return;
        let matches = null;
        const findState = findController.getState();
        // Special case: find widget owns entirely what we search for if:
        // - focus is not in the editor (i.e. it is in the find widget)
        // - and the search widget is visible
        // - and the search string is non-empty
        // - and we're searching for a regex
        if (findState.isRevealed && findState.searchString.length > 0 && findState.isRegex) {
            const editorModel = this._editor.getModel();
            if (findState.searchScope) matches = editorModel.findMatches(findState.searchString, findState.searchScope, findState.isRegex, findState.matchCase, findState.wholeWord ? this._editor.getOption(132 /* EditorOption.wordSeparators */ ) : null, false, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ );
            else matches = editorModel.findMatches(findState.searchString, true, findState.isRegex, findState.matchCase, findState.wholeWord ? this._editor.getOption(132 /* EditorOption.wordSeparators */ ) : null, false, 1073741824 /* Constants.MAX_SAFE_SMALL_INTEGER */ );
        } else {
            this._beginSessionIfNeeded(findController);
            if (!this._session) return;
            matches = this._session.selectAll(findState.searchScope);
        }
        if (matches.length > 0) {
            const editorSelection = this._editor.getSelection();
            // Have the primary cursor remain the one where the action was invoked
            for(let i = 0, len = matches.length; i < len; i++){
                const match = matches[i];
                const intersection = match.range.intersectRanges(editorSelection);
                if (intersection) {
                    // bingo!
                    matches[i] = matches[0];
                    matches[0] = match;
                    break;
                }
            }
            this._setSelections(matches.map((m)=>new (0, _selectionJs.Selection)(m.range.startLineNumber, m.range.startColumn, m.range.endLineNumber, m.range.endColumn)));
        }
    }
}
class MultiCursorSelectionControllerAction extends (0, _editorExtensionsJs.EditorAction) {
    run(accessor, editor) {
        const multiCursorController = MultiCursorSelectionController.get(editor);
        if (!multiCursorController) return;
        const viewModel = editor._getViewModel();
        if (viewModel) {
            const previousCursorState = viewModel.getCursorStates();
            const findController = (0, _findControllerJs.CommonFindController).get(editor);
            if (findController) this._run(multiCursorController, findController);
            else {
                const newFindController = accessor.get((0, _instantiationJs.IInstantiationService)).createInstance((0, _findControllerJs.CommonFindController), editor);
                this._run(multiCursorController, newFindController);
                newFindController.dispose();
            }
            announceCursorChange(previousCursorState, viewModel.getCursorStates());
        }
    }
}
class AddSelectionToNextFindMatchAction extends MultiCursorSelectionControllerAction {
    constructor(){
        super({
            id: "editor.action.addSelectionToNextFindMatch",
            label: _nlsJs.localize("addSelectionToNextFindMatch", "Add Selection To Next Find Match"),
            alias: "Add Selection To Next Find Match",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                primary: 2082 /* KeyCode.KeyD */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "3_multi",
                title: _nlsJs.localize({
                    key: "miAddSelectionToNextFindMatch",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Add &&Next Occurrence"),
                order: 5
            }
        });
    }
    _run(multiCursorController, findController) {
        multiCursorController.addSelectionToNextFindMatch(findController);
    }
}
class AddSelectionToPreviousFindMatchAction extends MultiCursorSelectionControllerAction {
    constructor(){
        super({
            id: "editor.action.addSelectionToPreviousFindMatch",
            label: _nlsJs.localize("addSelectionToPreviousFindMatch", "Add Selection To Previous Find Match"),
            alias: "Add Selection To Previous Find Match",
            precondition: undefined,
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "3_multi",
                title: _nlsJs.localize({
                    key: "miAddSelectionToPreviousFindMatch",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Add P&&revious Occurrence"),
                order: 6
            }
        });
    }
    _run(multiCursorController, findController) {
        multiCursorController.addSelectionToPreviousFindMatch(findController);
    }
}
class MoveSelectionToNextFindMatchAction extends MultiCursorSelectionControllerAction {
    constructor(){
        super({
            id: "editor.action.moveSelectionToNextFindMatch",
            label: _nlsJs.localize("moveSelectionToNextFindMatch", "Move Last Selection To Next Find Match"),
            alias: "Move Last Selection To Next Find Match",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                primary: (0, _keyCodesJs.KeyChord)(2089 /* KeyCode.KeyK */ , 2082 /* KeyCode.KeyD */ ),
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    _run(multiCursorController, findController) {
        multiCursorController.moveSelectionToNextFindMatch(findController);
    }
}
class MoveSelectionToPreviousFindMatchAction extends MultiCursorSelectionControllerAction {
    constructor(){
        super({
            id: "editor.action.moveSelectionToPreviousFindMatch",
            label: _nlsJs.localize("moveSelectionToPreviousFindMatch", "Move Last Selection To Previous Find Match"),
            alias: "Move Last Selection To Previous Find Match",
            precondition: undefined
        });
    }
    _run(multiCursorController, findController) {
        multiCursorController.moveSelectionToPreviousFindMatch(findController);
    }
}
class SelectHighlightsAction extends MultiCursorSelectionControllerAction {
    constructor(){
        super({
            id: "editor.action.selectHighlights",
            label: _nlsJs.localize("selectAllOccurrencesOfFindMatch", "Select All Occurrences of Find Match"),
            alias: "Select All Occurrences of Find Match",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                primary: 3114 /* KeyCode.KeyL */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "3_multi",
                title: _nlsJs.localize({
                    key: "miSelectHighlights",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "Select All &&Occurrences"),
                order: 7
            }
        });
    }
    _run(multiCursorController, findController) {
        multiCursorController.selectAll(findController);
    }
}
class CompatChangeAll extends MultiCursorSelectionControllerAction {
    constructor(){
        super({
            id: "editor.action.changeAll",
            label: _nlsJs.localize("changeAll.label", "Change All Occurrences"),
            alias: "Change All Occurrences",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus),
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 2108 /* KeyCode.F2 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            contextMenuOpts: {
                group: "1_modification",
                order: 1.2
            }
        });
    }
    _run(multiCursorController, findController) {
        multiCursorController.selectAll(findController);
    }
}
class SelectionHighlighterState {
    constructor(_model, _searchText, _matchCase, _wordSeparators, prevState){
        this._model = _model;
        this._searchText = _searchText;
        this._matchCase = _matchCase;
        this._wordSeparators = _wordSeparators;
        this._modelVersionId = this._model.getVersionId();
        this._cachedFindMatches = null;
        if (prevState && this._model === prevState._model && this._searchText === prevState._searchText && this._matchCase === prevState._matchCase && this._wordSeparators === prevState._wordSeparators && this._modelVersionId === prevState._modelVersionId) this._cachedFindMatches = prevState._cachedFindMatches;
    }
    findMatches() {
        if (this._cachedFindMatches === null) {
            this._cachedFindMatches = this._model.findMatches(this._searchText, true, false, this._matchCase, this._wordSeparators, false).map((m)=>m.range);
            this._cachedFindMatches.sort((0, _rangeJs.Range).compareRangesUsingStarts);
        }
        return this._cachedFindMatches;
    }
}
let SelectionHighlighter = class SelectionHighlighter extends (0, _lifecycleJs.Disposable) {
    static{
        SelectionHighlighter_1 = this;
    }
    static{
        this.ID = "editor.contrib.selectionHighlighter";
    }
    constructor(editor, _languageFeaturesService){
        super();
        this._languageFeaturesService = _languageFeaturesService;
        this.editor = editor;
        this._isEnabled = editor.getOption(109 /* EditorOption.selectionHighlight */ );
        this._decorations = editor.createDecorationsCollection();
        this.updateSoon = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._update(), 300));
        this.state = null;
        this._register(editor.onDidChangeConfiguration((e)=>{
            this._isEnabled = editor.getOption(109 /* EditorOption.selectionHighlight */ );
        }));
        this._register(editor.onDidChangeCursorSelection((e)=>{
            if (!this._isEnabled) // Early exit if nothing needs to be done!
            // Leave some form of early exit check here if you wish to continue being a cursor position change listener ;)
            return;
            if (e.selection.isEmpty()) {
                if (e.reason === 3 /* CursorChangeReason.Explicit */ ) {
                    if (this.state) // no longer valid
                    this._setState(null);
                    this.updateSoon.schedule();
                } else this._setState(null);
            } else this._update();
        }));
        this._register(editor.onDidChangeModel((e)=>{
            this._setState(null);
        }));
        this._register(editor.onDidChangeModelContent((e)=>{
            if (this._isEnabled) this.updateSoon.schedule();
        }));
        const findController = (0, _findControllerJs.CommonFindController).get(editor);
        if (findController) this._register(findController.getState().onFindReplaceStateChange((e)=>{
            this._update();
        }));
        this.updateSoon.schedule();
    }
    _update() {
        this._setState(SelectionHighlighter_1._createState(this.state, this._isEnabled, this.editor));
    }
    static _createState(oldState, isEnabled, editor) {
        if (!isEnabled) return null;
        if (!editor.hasModel()) return null;
        const s = editor.getSelection();
        if (s.startLineNumber !== s.endLineNumber) // multiline forbidden for perf reasons
        return null;
        const multiCursorController = MultiCursorSelectionController.get(editor);
        if (!multiCursorController) return null;
        const findController = (0, _findControllerJs.CommonFindController).get(editor);
        if (!findController) return null;
        let r = multiCursorController.getSession(findController);
        if (!r) {
            const allSelections = editor.getSelections();
            if (allSelections.length > 1) {
                const findState = findController.getState();
                const matchCase = findState.matchCase;
                const selectionsContainSameText = modelRangesContainSameText(editor.getModel(), allSelections, matchCase);
                if (!selectionsContainSameText) return null;
            }
            r = MultiCursorSession.create(editor, findController);
        }
        if (!r) return null;
        if (r.currentMatch) // This is an empty selection
        // Do not interfere with semantic word highlighting in the no selection case
        return null;
        if (/^[ \t]+$/.test(r.searchText)) // whitespace only selection
        return null;
        if (r.searchText.length > 200) // very long selection
        return null;
        // TODO: better handling of this case
        const findState = findController.getState();
        const caseSensitive = findState.matchCase;
        // Return early if the find widget shows the exact same matches
        if (findState.isRevealed) {
            let findStateSearchString = findState.searchString;
            if (!caseSensitive) findStateSearchString = findStateSearchString.toLowerCase();
            let mySearchString = r.searchText;
            if (!caseSensitive) mySearchString = mySearchString.toLowerCase();
            if (findStateSearchString === mySearchString && r.matchCase === findState.matchCase && r.wholeWord === findState.wholeWord && !findState.isRegex) return null;
        }
        return new SelectionHighlighterState(editor.getModel(), r.searchText, r.matchCase, r.wholeWord ? editor.getOption(132 /* EditorOption.wordSeparators */ ) : null, oldState);
    }
    _setState(newState) {
        this.state = newState;
        if (!this.state) {
            this._decorations.clear();
            return;
        }
        if (!this.editor.hasModel()) return;
        const model = this.editor.getModel();
        if (model.isTooLargeForTokenization()) // the file is too large, so searching word under cursor in the whole document would be blocking the UI.
        return;
        const allMatches = this.state.findMatches();
        const selections = this.editor.getSelections();
        selections.sort((0, _rangeJs.Range).compareRangesUsingStarts);
        // do not overlap with selection (issue #64 and #512)
        const matches = [];
        for(let i = 0, j = 0, len = allMatches.length, lenJ = selections.length; i < len;){
            const match = allMatches[i];
            if (j >= lenJ) {
                // finished all editor selections
                matches.push(match);
                i++;
            } else {
                const cmp = (0, _rangeJs.Range).compareRangesUsingStarts(match, selections[j]);
                if (cmp < 0) {
                    // match is before sel
                    if (selections[j].isEmpty() || !(0, _rangeJs.Range).areIntersecting(match, selections[j])) matches.push(match);
                    i++;
                } else if (cmp > 0) // sel is before match
                j++;
                else {
                    // sel is equal to match
                    i++;
                    j++;
                }
            }
        }
        const occurrenceHighlighting = this.editor.getOption(81 /* EditorOption.occurrencesHighlight */ ) !== "off";
        const hasSemanticHighlights = this._languageFeaturesService.documentHighlightProvider.has(model) && occurrenceHighlighting;
        const decorations = matches.map((r)=>{
            return {
                range: r,
                options: (0, _highlightDecorationsJs.getSelectionHighlightDecorationOptions)(hasSemanticHighlights)
            };
        });
        this._decorations.set(decorations);
    }
    dispose() {
        this._setState(null);
        super.dispose();
    }
};
SelectionHighlighter = SelectionHighlighter_1 = __decorate([
    __param(1, (0, _languageFeaturesJs.ILanguageFeaturesService))
], SelectionHighlighter);
function modelRangesContainSameText(model, ranges, matchCase) {
    const selectedText = getValueInRange(model, ranges[0], !matchCase);
    for(let i = 1, len = ranges.length; i < len; i++){
        const range = ranges[i];
        if (range.isEmpty()) return false;
        const thisSelectedText = getValueInRange(model, range, !matchCase);
        if (selectedText !== thisSelectedText) return false;
    }
    return true;
}
function getValueInRange(model, range, toLowerCase) {
    const text = model.getValueInRange(range);
    return toLowerCase ? text.toLowerCase() : text;
}
class FocusNextCursor extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.focusNextCursor",
            label: _nlsJs.localize("mutlicursor.focusNextCursor", "Focus Next Cursor"),
            metadata: {
                description: _nlsJs.localize("mutlicursor.focusNextCursor.description", "Focuses the next cursor"),
                args: []
            },
            alias: "Focus Next Cursor",
            precondition: undefined
        });
    }
    run(accessor, editor, args) {
        if (!editor.hasModel()) return;
        const viewModel = editor._getViewModel();
        if (viewModel.cursorConfig.readOnly) return;
        viewModel.model.pushStackElement();
        const previousCursorState = Array.from(viewModel.getCursorStates());
        const firstCursor = previousCursorState.shift();
        if (!firstCursor) return;
        previousCursorState.push(firstCursor);
        viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , previousCursorState);
        viewModel.revealPrimaryCursor(args.source, true);
        announceCursorChange(previousCursorState, viewModel.getCursorStates());
    }
}
class FocusPreviousCursor extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.focusPreviousCursor",
            label: _nlsJs.localize("mutlicursor.focusPreviousCursor", "Focus Previous Cursor"),
            metadata: {
                description: _nlsJs.localize("mutlicursor.focusPreviousCursor.description", "Focuses the previous cursor"),
                args: []
            },
            alias: "Focus Previous Cursor",
            precondition: undefined
        });
    }
    run(accessor, editor, args) {
        if (!editor.hasModel()) return;
        const viewModel = editor._getViewModel();
        if (viewModel.cursorConfig.readOnly) return;
        viewModel.model.pushStackElement();
        const previousCursorState = Array.from(viewModel.getCursorStates());
        const firstCursor = previousCursorState.pop();
        if (!firstCursor) return;
        previousCursorState.unshift(firstCursor);
        viewModel.setCursorStates(args.source, 3 /* CursorChangeReason.Explicit */ , previousCursorState);
        viewModel.revealPrimaryCursor(args.source, true);
        announceCursorChange(previousCursorState, viewModel.getCursorStates());
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(MultiCursorSelectionController.ID, MultiCursorSelectionController, 4 /* EditorContributionInstantiation.Lazy */ );
(0, _editorExtensionsJs.registerEditorContribution)(SelectionHighlighter.ID, SelectionHighlighter, 1 /* EditorContributionInstantiation.AfterFirstRender */ );
(0, _editorExtensionsJs.registerEditorAction)(InsertCursorAbove);
(0, _editorExtensionsJs.registerEditorAction)(InsertCursorBelow);
(0, _editorExtensionsJs.registerEditorAction)(InsertCursorAtEndOfEachLineSelected);
(0, _editorExtensionsJs.registerEditorAction)(AddSelectionToNextFindMatchAction);
(0, _editorExtensionsJs.registerEditorAction)(AddSelectionToPreviousFindMatchAction);
(0, _editorExtensionsJs.registerEditorAction)(MoveSelectionToNextFindMatchAction);
(0, _editorExtensionsJs.registerEditorAction)(MoveSelectionToPreviousFindMatchAction);
(0, _editorExtensionsJs.registerEditorAction)(SelectHighlightsAction);
(0, _editorExtensionsJs.registerEditorAction)(CompatChangeAll);
(0, _editorExtensionsJs.registerEditorAction)(InsertCursorAtEndOfLineSelected);
(0, _editorExtensionsJs.registerEditorAction)(InsertCursorAtTopOfLineSelected);
(0, _editorExtensionsJs.registerEditorAction)(FocusNextCursor);
(0, _editorExtensionsJs.registerEditorAction)(FocusPreviousCursor);

},{"../../../../base/browser/ui/aria/aria.js":"asrsh","../../../../base/common/async.js":"4GJc4","../../../../base/common/keyCodes.js":"bHiG9","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorExtensions.js":"kC3w6","../../../common/cursor/cursorMoveCommands.js":"sl4rn","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/editorContextKeys.js":"5exv9","../../find/browser/findController.js":"6yJPJ","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../common/services/languageFeatures.js":"2IAko","../../wordHighlighter/browser/highlightDecorations.js":"gdzcC","../../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gdzcC":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHighlightDecorationOptions", ()=>getHighlightDecorationOptions);
parcelHelpers.export(exports, "getSelectionHighlightDecorationOptions", ()=>getSelectionHighlightDecorationOptions);
var _highlightDecorationsCss = require("./highlightDecorations.css");
var _modelJs = require("../../../common/model.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _languagesJs = require("../../../common/languages.js");
var _nlsJs = require("../../../../nls.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
const wordHighlightBackground = (0, _colorRegistryJs.registerColor)("editor.wordHighlightBackground", {
    dark: "#575757B8",
    light: "#57575740",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("wordHighlight", "Background color of a symbol during read-access, like reading a variable. The color must not be opaque so as not to hide underlying decorations."), true);
(0, _colorRegistryJs.registerColor)("editor.wordHighlightStrongBackground", {
    dark: "#004972B8",
    light: "#0e639c40",
    hcDark: null,
    hcLight: null
}, _nlsJs.localize("wordHighlightStrong", "Background color of a symbol during write-access, like writing to a variable. The color must not be opaque so as not to hide underlying decorations."), true);
(0, _colorRegistryJs.registerColor)("editor.wordHighlightTextBackground", wordHighlightBackground, _nlsJs.localize("wordHighlightText", "Background color of a textual occurrence for a symbol. The color must not be opaque so as not to hide underlying decorations."), true);
const wordHighlightBorder = (0, _colorRegistryJs.registerColor)("editor.wordHighlightBorder", {
    light: null,
    dark: null,
    hcDark: (0, _colorRegistryJs.activeContrastBorder),
    hcLight: (0, _colorRegistryJs.activeContrastBorder)
}, _nlsJs.localize("wordHighlightBorder", "Border color of a symbol during read-access, like reading a variable."));
(0, _colorRegistryJs.registerColor)("editor.wordHighlightStrongBorder", {
    light: null,
    dark: null,
    hcDark: (0, _colorRegistryJs.activeContrastBorder),
    hcLight: (0, _colorRegistryJs.activeContrastBorder)
}, _nlsJs.localize("wordHighlightStrongBorder", "Border color of a symbol during write-access, like writing to a variable."));
(0, _colorRegistryJs.registerColor)("editor.wordHighlightTextBorder", wordHighlightBorder, _nlsJs.localize("wordHighlightTextBorder", "Border color of a textual occurrence for a symbol."));
const overviewRulerWordHighlightForeground = (0, _colorRegistryJs.registerColor)("editorOverviewRuler.wordHighlightForeground", "#A0A0A0CC", _nlsJs.localize("overviewRulerWordHighlightForeground", "Overview ruler marker color for symbol highlights. The color must not be opaque so as not to hide underlying decorations."), true);
const overviewRulerWordHighlightStrongForeground = (0, _colorRegistryJs.registerColor)("editorOverviewRuler.wordHighlightStrongForeground", "#C0A0C0CC", _nlsJs.localize("overviewRulerWordHighlightStrongForeground", "Overview ruler marker color for write-access symbol highlights. The color must not be opaque so as not to hide underlying decorations."), true);
const overviewRulerWordHighlightTextForeground = (0, _colorRegistryJs.registerColor)("editorOverviewRuler.wordHighlightTextForeground", (0, _colorRegistryJs.overviewRulerSelectionHighlightForeground), _nlsJs.localize("overviewRulerWordHighlightTextForeground", "Overview ruler marker color of a textual occurrence for a symbol. The color must not be opaque so as not to hide underlying decorations."), true);
const _WRITE_OPTIONS = (0, _textModelJs.ModelDecorationOptions).register({
    description: "word-highlight-strong",
    stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
    className: "wordHighlightStrong",
    overviewRuler: {
        color: (0, _themeServiceJs.themeColorFromId)(overviewRulerWordHighlightStrongForeground),
        position: (0, _modelJs.OverviewRulerLane).Center
    },
    minimap: {
        color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.minimapSelectionOccurrenceHighlight)),
        position: 1 /* MinimapPosition.Inline */ 
    }
});
const _TEXT_OPTIONS = (0, _textModelJs.ModelDecorationOptions).register({
    description: "word-highlight-text",
    stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
    className: "wordHighlightText",
    overviewRuler: {
        color: (0, _themeServiceJs.themeColorFromId)(overviewRulerWordHighlightTextForeground),
        position: (0, _modelJs.OverviewRulerLane).Center
    },
    minimap: {
        color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.minimapSelectionOccurrenceHighlight)),
        position: 1 /* MinimapPosition.Inline */ 
    }
});
const _SELECTION_HIGHLIGHT_OPTIONS = (0, _textModelJs.ModelDecorationOptions).register({
    description: "selection-highlight-overview",
    stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
    className: "selectionHighlight",
    overviewRuler: {
        color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.overviewRulerSelectionHighlightForeground)),
        position: (0, _modelJs.OverviewRulerLane).Center
    },
    minimap: {
        color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.minimapSelectionOccurrenceHighlight)),
        position: 1 /* MinimapPosition.Inline */ 
    }
});
const _SELECTION_HIGHLIGHT_OPTIONS_NO_OVERVIEW = (0, _textModelJs.ModelDecorationOptions).register({
    description: "selection-highlight",
    stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
    className: "selectionHighlight"
});
const _REGULAR_OPTIONS = (0, _textModelJs.ModelDecorationOptions).register({
    description: "word-highlight",
    stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
    className: "wordHighlight",
    overviewRuler: {
        color: (0, _themeServiceJs.themeColorFromId)(overviewRulerWordHighlightForeground),
        position: (0, _modelJs.OverviewRulerLane).Center
    },
    minimap: {
        color: (0, _themeServiceJs.themeColorFromId)((0, _colorRegistryJs.minimapSelectionOccurrenceHighlight)),
        position: 1 /* MinimapPosition.Inline */ 
    }
});
function getHighlightDecorationOptions(kind) {
    if (kind === (0, _languagesJs.DocumentHighlightKind).Write) return _WRITE_OPTIONS;
    else if (kind === (0, _languagesJs.DocumentHighlightKind).Text) return _TEXT_OPTIONS;
    else return _REGULAR_OPTIONS;
}
function getSelectionHighlightDecorationOptions(hasSemanticHighlights) {
    // Show in overviewRuler only if model has no semantic highlighting
    return hasSemanticHighlights ? _SELECTION_HIGHLIGHT_OPTIONS_NO_OVERVIEW : _SELECTION_HIGHLIGHT_OPTIONS;
}
(0, _themeServiceJs.registerThemingParticipant)((theme, collector)=>{
    const selectionHighlight = theme.getColor((0, _colorRegistryJs.editorSelectionHighlight));
    if (selectionHighlight) collector.addRule(`.monaco-editor .selectionHighlight { background-color: ${selectionHighlight.transparent(0.5)}; }`);
});

},{"./highlightDecorations.css":"aaXji","../../../common/model.js":"1CSIB","../../../common/model/textModel.js":"9beDe","../../../common/languages.js":"g5n96","../../../../nls.js":"l617d","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aaXji":[function() {},{}],"7CXfw":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
// import { HoverParticipantRegistry } from 'vs/editor/contrib/hover/browser/hoverTypes';
var _commandsJs = require("./commands.js");
// import { InlineEditHoverParticipant } from 'vs/editor/contrib/inlineEdit/browser/hoverParticipant';
var _inlineEditControllerJs = require("./inlineEditController.js");
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.AcceptInlineEdit));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.RejectInlineEdit));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.JumpToInlineEdit));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.JumpBackInlineEdit));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.TriggerInlineEdit));
(0, _editorExtensionsJs.registerEditorContribution)((0, _inlineEditControllerJs.InlineEditController).ID, (0, _inlineEditControllerJs.InlineEditController), 3 /* EditorContributionInstantiation.Eventually */ ); // HoverParticipantRegistry.register(InlineEditHoverParticipant);

},{"../../../browser/editorExtensions.js":"kC3w6","./commands.js":"cf4ot","./inlineEditController.js":"fHGnC"}],"cf4ot":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AcceptInlineEdit", ()=>AcceptInlineEdit);
parcelHelpers.export(exports, "TriggerInlineEdit", ()=>TriggerInlineEdit);
parcelHelpers.export(exports, "JumpToInlineEdit", ()=>JumpToInlineEdit);
parcelHelpers.export(exports, "JumpBackInlineEdit", ()=>JumpBackInlineEdit);
parcelHelpers.export(exports, "RejectInlineEdit", ()=>RejectInlineEdit);
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _commandIdsJs = require("./commandIds.js");
var _inlineEditControllerJs = require("./inlineEditController.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
class AcceptInlineEdit extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _commandIdsJs.inlineEditAcceptId),
            label: "Accept Inline Edit",
            alias: "Accept Inline Edit",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _inlineEditControllerJs.InlineEditController).inlineEditVisibleContext),
            kbOpts: [
                {
                    weight: 101,
                    primary: 2 /* KeyCode.Tab */ ,
                    kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _inlineEditControllerJs.InlineEditController).inlineEditVisibleContext, (0, _inlineEditControllerJs.InlineEditController).cursorAtInlineEditContext)
                }
            ],
            menuOpts: [
                {
                    menuId: (0, _actionsJs.MenuId).InlineEditToolbar,
                    title: "Accept",
                    group: "primary",
                    order: 1
                }
            ]
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineEditControllerJs.InlineEditController).get(editor);
        await controller?.accept();
    }
}
class TriggerInlineEdit extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        const activeExpr = (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _contextkeyJs.ContextKeyExpr).not((0, _inlineEditControllerJs.InlineEditController).inlineEditVisibleKey));
        super({
            id: "editor.action.inlineEdit.trigger",
            label: "Trigger Inline Edit",
            alias: "Trigger Inline Edit",
            precondition: activeExpr,
            kbOpts: {
                weight: 101,
                primary: 2646 /* KeyCode.Equal */ ,
                kbExpr: activeExpr
            }
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineEditControllerJs.InlineEditController).get(editor);
        controller?.trigger();
    }
}
class JumpToInlineEdit extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        const activeExpr = (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _inlineEditControllerJs.InlineEditController).inlineEditVisibleContext, (0, _contextkeyJs.ContextKeyExpr).not((0, _inlineEditControllerJs.InlineEditController).cursorAtInlineEditKey));
        super({
            id: (0, _commandIdsJs.inlineEditJumpToId),
            label: "Jump to Inline Edit",
            alias: "Jump to Inline Edit",
            precondition: activeExpr,
            kbOpts: {
                weight: 101,
                primary: 2646 /* KeyCode.Equal */ ,
                kbExpr: activeExpr
            },
            menuOpts: [
                {
                    menuId: (0, _actionsJs.MenuId).InlineEditToolbar,
                    title: "Jump To Edit",
                    group: "primary",
                    order: 3,
                    when: activeExpr
                }
            ]
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineEditControllerJs.InlineEditController).get(editor);
        controller?.jumpToCurrent();
    }
}
class JumpBackInlineEdit extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        const activeExpr = (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _inlineEditControllerJs.InlineEditController).cursorAtInlineEditContext);
        super({
            id: (0, _commandIdsJs.inlineEditJumpBackId),
            label: "Jump Back from Inline Edit",
            alias: "Jump Back from Inline Edit",
            precondition: activeExpr,
            kbOpts: {
                weight: 110,
                primary: 2646 /* KeyCode.Equal */ ,
                kbExpr: activeExpr
            },
            menuOpts: [
                {
                    menuId: (0, _actionsJs.MenuId).InlineEditToolbar,
                    title: "Jump Back",
                    group: "primary",
                    order: 3,
                    when: activeExpr
                }
            ]
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineEditControllerJs.InlineEditController).get(editor);
        controller?.jumpBack();
    }
}
class RejectInlineEdit extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        const activeExpr = (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _inlineEditControllerJs.InlineEditController).inlineEditVisibleContext);
        super({
            id: (0, _commandIdsJs.inlineEditRejectId),
            label: "Reject Inline Edit",
            alias: "Reject Inline Edit",
            precondition: activeExpr,
            kbOpts: {
                weight: 100 /* KeybindingWeight.EditorContrib */ ,
                primary: 9 /* KeyCode.Escape */ ,
                kbExpr: activeExpr
            },
            menuOpts: [
                {
                    menuId: (0, _actionsJs.MenuId).InlineEditToolbar,
                    title: "Reject",
                    group: "secondary",
                    order: 2
                }
            ]
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineEditControllerJs.InlineEditController).get(editor);
        await controller?.clear();
    }
}

},{"../../../browser/editorExtensions.js":"kC3w6","../../../common/editorContextKeys.js":"5exv9","./commandIds.js":"6QzMY","./inlineEditController.js":"fHGnC","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6QzMY":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inlineEditAcceptId", ()=>inlineEditAcceptId);
parcelHelpers.export(exports, "inlineEditRejectId", ()=>inlineEditRejectId);
parcelHelpers.export(exports, "inlineEditJumpToId", ()=>inlineEditJumpToId);
parcelHelpers.export(exports, "inlineEditJumpBackId", ()=>inlineEditJumpBackId);
const inlineEditAcceptId = "editor.action.inlineEdit.accept";
const inlineEditRejectId = "editor.action.inlineEdit.reject";
const inlineEditJumpToId = "editor.action.inlineEdit.jumpTo";
const inlineEditJumpBackId = "editor.action.inlineEdit.jumpBack";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fHGnC":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineEditController", ()=>InlineEditController);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _editOperationJs = require("../../../common/core/editOperation.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _ghostTextWidgetJs = require("./ghostTextWidget.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _languagesJs = require("../../../common/languages.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _ghostTextJs = require("../../inlineCompletions/browser/model/ghostText.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _inlineEditHintsWidgetJs = require("./inlineEditHintsWidget.js");
var _domJs = require("../../../../base/browser/dom.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _derivedJs = require("../../../../base/common/observableInternal/derived.js");
var _inlineEditSideBySideWidgetJs = require("./inlineEditSideBySideWidget.js");
var _diffProviderFactoryServiceJs = require("../../../browser/widget/diffEditor/diffProviderFactoryService.js");
var _modelJs = require("../../../common/services/model.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var InlineEditController_1;
let InlineEditController = class InlineEditController extends (0, _lifecycleJs.Disposable) {
    static{
        InlineEditController_1 = this;
    }
    static{
        this.ID = "editor.contrib.inlineEditController";
    }
    static{
        this.inlineEditVisibleKey = "inlineEditVisible";
    }
    static{
        this.inlineEditVisibleContext = new (0, _contextkeyJs.RawContextKey)(this.inlineEditVisibleKey, false);
    }
    static{
        this.cursorAtInlineEditKey = "cursorAtInlineEdit";
    }
    static{
        this.cursorAtInlineEditContext = new (0, _contextkeyJs.RawContextKey)(this.cursorAtInlineEditKey, false);
    }
    static get(editor) {
        return editor.getContribution(InlineEditController_1.ID);
    }
    constructor(editor, instantiationService, contextKeyService, languageFeaturesService, _commandService, _configurationService, _diffProviderFactoryService, _modelService){
        super();
        this.editor = editor;
        this.instantiationService = instantiationService;
        this.contextKeyService = contextKeyService;
        this.languageFeaturesService = languageFeaturesService;
        this._commandService = _commandService;
        this._configurationService = _configurationService;
        this._diffProviderFactoryService = _diffProviderFactoryService;
        this._modelService = _modelService;
        this._isVisibleContext = InlineEditController_1.inlineEditVisibleContext.bindTo(this.contextKeyService);
        this._isCursorAtInlineEditContext = InlineEditController_1.cursorAtInlineEditContext.bindTo(this.contextKeyService);
        this._currentEdit = (0, _observableJs.observableValue)(this, undefined);
        this._currentWidget = (0, _derivedJs.derivedDisposable)(this._currentEdit, (reader)=>{
            const edit = this._currentEdit.read(reader);
            if (!edit) return undefined;
            const line = edit.range.endLineNumber;
            const column = edit.range.endColumn;
            const textToDisplay = edit.text.endsWith("\n") && !(edit.range.startLineNumber === edit.range.endLineNumber && edit.range.startColumn === edit.range.endColumn) ? edit.text.slice(0, -1) : edit.text;
            const ghostText = new (0, _ghostTextJs.GhostText)(line, [
                new (0, _ghostTextJs.GhostTextPart)(column, textToDisplay, false)
            ]);
            //only show ghost text for single line edits
            //unless it is a pure removal
            //multi line edits are shown in the side by side widget
            const isSingleLine = edit.range.startLineNumber === edit.range.endLineNumber && ghostText.parts.length === 1 && ghostText.parts[0].lines.length === 1;
            const isPureRemoval = edit.text === "";
            if (!isSingleLine && !isPureRemoval) return undefined;
            const instance = this.instantiationService.createInstance((0, _ghostTextWidgetJs.GhostTextWidget), this.editor, {
                ghostText: (0, _observableJs.constObservable)(ghostText),
                minReservedLineCount: (0, _observableJs.constObservable)(0),
                targetTextModel: (0, _observableJs.constObservable)(this.editor.getModel() ?? undefined),
                range: (0, _observableJs.constObservable)(edit.range)
            });
            return instance;
        });
        this._isAccepting = (0, _observableJs.observableValue)(this, false);
        this._enabled = (0, _observableJs.observableFromEvent)(this, this.editor.onDidChangeConfiguration, ()=>this.editor.getOption(63 /* EditorOption.inlineEdit */ ).enabled);
        this._fontFamily = (0, _observableJs.observableFromEvent)(this, this.editor.onDidChangeConfiguration, ()=>this.editor.getOption(63 /* EditorOption.inlineEdit */ ).fontFamily);
        //Automatically request inline edit when the content was changed
        //Cancel the previous request if there is one
        //Remove the previous ghost text
        const modelChangedSignal = (0, _observableJs.observableSignalFromEvent)("InlineEditController.modelContentChangedSignal", editor.onDidChangeModelContent);
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description InlineEditController.modelContentChanged model */ if (!this._enabled.read(reader)) return;
            modelChangedSignal.read(reader);
            if (this._isAccepting.read(reader)) return;
            this.getInlineEdit(editor, true);
        }));
        //Check if the cursor is at the ghost text
        const cursorPosition = (0, _observableJs.observableFromEvent)(this, editor.onDidChangeCursorPosition, ()=>editor.getPosition());
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description InlineEditController.cursorPositionChanged model */ if (!this._enabled.read(reader)) return;
            const pos = cursorPosition.read(reader);
            if (pos) this.checkCursorPosition(pos);
        }));
        //Perform stuff when the current edit has changed
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description InlineEditController.update model */ const currentEdit = this._currentEdit.read(reader);
            this._isCursorAtInlineEditContext.set(false);
            if (!currentEdit) {
                this._isVisibleContext.set(false);
                return;
            }
            this._isVisibleContext.set(true);
            const pos = editor.getPosition();
            if (pos) this.checkCursorPosition(pos);
        }));
        //Clear suggestions on lost focus
        const editorBlurSingal = (0, _observableJs.observableSignalFromEvent)("InlineEditController.editorBlurSignal", editor.onDidBlurEditorWidget);
        this._register((0, _observableJs.autorun)(async (reader)=>{
            /** @description InlineEditController.editorBlur */ if (!this._enabled.read(reader)) return;
            editorBlurSingal.read(reader);
            // This is a hidden setting very useful for debugging
            if (this._configurationService.getValue("editor.experimentalInlineEdit.keepOnBlur") || editor.getOption(63 /* EditorOption.inlineEdit */ ).keepOnBlur) return;
            this._currentRequestCts?.dispose(true);
            this._currentRequestCts = undefined;
            await this.clear(false);
        }));
        //Invoke provider on focus
        const editorFocusSignal = (0, _observableJs.observableSignalFromEvent)("InlineEditController.editorFocusSignal", editor.onDidFocusEditorText);
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description InlineEditController.editorFocus */ if (!this._enabled.read(reader)) return;
            editorFocusSignal.read(reader);
            this.getInlineEdit(editor, true);
        }));
        //handle changes of font setting
        const styleElement = this._register((0, _domJs.createStyleSheet2)());
        this._register((0, _observableJs.autorun)((reader)=>{
            const fontFamily = this._fontFamily.read(reader);
            styleElement.setStyle(fontFamily === "" || fontFamily === "default" ? `` : `
.monaco-editor .inline-edit-decoration,
.monaco-editor .inline-edit-decoration-preview,
.monaco-editor .inline-edit {
	font-family: ${fontFamily};
}`);
        }));
        this._register(new (0, _inlineEditHintsWidgetJs.InlineEditHintsWidget)(this.editor, this._currentWidget, this.instantiationService));
        this._register(new (0, _inlineEditSideBySideWidgetJs.InlineEditSideBySideWidget)(this.editor, this._currentEdit, this.instantiationService, this._diffProviderFactoryService, this._modelService));
    }
    checkCursorPosition(position) {
        if (!this._currentEdit) {
            this._isCursorAtInlineEditContext.set(false);
            return;
        }
        const gt = this._currentEdit.get();
        if (!gt) {
            this._isCursorAtInlineEditContext.set(false);
            return;
        }
        this._isCursorAtInlineEditContext.set((0, _rangeJs.Range).containsPosition(gt.range, position));
    }
    validateInlineEdit(editor, edit) {
        //Multiline inline replacing edit must replace whole lines
        if (edit.text.includes("\n") && edit.range.startLineNumber !== edit.range.endLineNumber && edit.range.startColumn !== edit.range.endColumn) {
            const firstColumn = edit.range.startColumn;
            if (firstColumn !== 1) return false;
            const lastLine = edit.range.endLineNumber;
            const lastColumn = edit.range.endColumn;
            const lineLength = editor.getModel()?.getLineLength(lastLine) ?? 0;
            if (lastColumn !== lineLength + 1) return false;
        }
        return true;
    }
    async fetchInlineEdit(editor, auto) {
        if (this._currentRequestCts) this._currentRequestCts.dispose(true);
        const model = editor.getModel();
        if (!model) return;
        const modelVersion = model.getVersionId();
        const providers = this.languageFeaturesService.inlineEditProvider.all(model);
        if (providers.length === 0) return;
        const provider = providers[0];
        this._currentRequestCts = new (0, _cancellationJs.CancellationTokenSource)();
        const token = this._currentRequestCts.token;
        const triggerKind = auto ? (0, _languagesJs.InlineEditTriggerKind).Automatic : (0, _languagesJs.InlineEditTriggerKind).Invoke;
        const shouldDebounce = auto;
        if (shouldDebounce) await wait(50, token);
        if (token.isCancellationRequested || model.isDisposed() || model.getVersionId() !== modelVersion) return;
        const edit = await provider.provideInlineEdit(model, {
            triggerKind
        }, token);
        if (!edit) return;
        if (token.isCancellationRequested || model.isDisposed() || model.getVersionId() !== modelVersion) return;
        if (!this.validateInlineEdit(editor, edit)) return;
        return edit;
    }
    async getInlineEdit(editor, auto) {
        this._isCursorAtInlineEditContext.set(false);
        await this.clear();
        const edit = await this.fetchInlineEdit(editor, auto);
        if (!edit) return;
        this._currentEdit.set(edit, undefined);
    }
    async trigger() {
        await this.getInlineEdit(this.editor, false);
    }
    async jumpBack() {
        if (!this._jumpBackPosition) return;
        this.editor.setPosition(this._jumpBackPosition);
        //if position is outside viewports, scroll to it
        this.editor.revealPositionInCenterIfOutsideViewport(this._jumpBackPosition);
    }
    async accept() {
        this._isAccepting.set(true, undefined);
        const data = this._currentEdit.get();
        if (!data) return;
        //It should only happen in case of last line suggestion
        let text = data.text;
        if (data.text.startsWith("\n")) text = data.text.substring(1);
        this.editor.pushUndoStop();
        this.editor.executeEdits("acceptCurrent", [
            (0, _editOperationJs.EditOperation).replace((0, _rangeJs.Range).lift(data.range), text)
        ]);
        if (data.accepted) await this._commandService.executeCommand(data.accepted.id, ...data.accepted.arguments || []).then(undefined, (0, _errorsJs.onUnexpectedExternalError));
        this.freeEdit(data);
        (0, _observableJs.transaction)((tx)=>{
            this._currentEdit.set(undefined, tx);
            this._isAccepting.set(false, tx);
        });
    }
    jumpToCurrent() {
        this._jumpBackPosition = this.editor.getSelection()?.getStartPosition();
        const data = this._currentEdit.get();
        if (!data) return;
        const position = (0, _positionJs.Position).lift({
            lineNumber: data.range.startLineNumber,
            column: data.range.startColumn
        });
        this.editor.setPosition(position);
        //if position is outside viewports, scroll to it
        this.editor.revealPositionInCenterIfOutsideViewport(position);
    }
    async clear(sendRejection = true) {
        const edit = this._currentEdit.get();
        if (edit && edit?.rejected && sendRejection) await this._commandService.executeCommand(edit.rejected.id, ...edit.rejected.arguments || []).then(undefined, (0, _errorsJs.onUnexpectedExternalError));
        if (edit) this.freeEdit(edit);
        this._currentEdit.set(undefined, undefined);
    }
    freeEdit(edit) {
        const model = this.editor.getModel();
        if (!model) return;
        const providers = this.languageFeaturesService.inlineEditProvider.all(model);
        if (providers.length === 0) return;
        providers[0].freeInlineEdit(edit);
    }
};
InlineEditController = InlineEditController_1 = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService)),
    __param(2, (0, _contextkeyJs.IContextKeyService)),
    __param(3, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(4, (0, _commandsJs.ICommandService)),
    __param(5, (0, _configurationJs.IConfigurationService)),
    __param(6, (0, _diffProviderFactoryServiceJs.IDiffProviderFactoryService)),
    __param(7, (0, _modelJs.IModelService))
], InlineEditController);
function wait(ms, cancellationToken) {
    return new Promise((resolve)=>{
        let d = undefined;
        const handle = setTimeout(()=>{
            if (d) d.dispose();
            resolve();
        }, ms);
        if (cancellationToken) d = cancellationToken.onCancellationRequested(()=>{
            clearTimeout(handle);
            if (d) d.dispose();
            resolve();
        });
    });
}

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../../common/core/editOperation.js":"6r2FZ","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","./ghostTextWidget.js":"eJ1Uz","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../common/languages.js":"g5n96","../../../common/services/languageFeatures.js":"2IAko","../../../../base/common/cancellation.js":"hoVxw","../../inlineCompletions/browser/model/ghostText.js":"htVY2","../../../../platform/commands/common/commands.js":"ho6ic","./inlineEditHintsWidget.js":"ga6wn","../../../../base/browser/dom.js":"bnqsM","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../base/common/errors.js":"divX8","../../../../base/common/observableInternal/derived.js":"hZb5S","./inlineEditSideBySideWidget.js":"g25ot","../../../browser/widget/diffEditor/diffProviderFactoryService.js":"chJTA","../../../common/services/model.js":"aciVm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eJ1Uz":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INLINE_EDIT_DESCRIPTION", ()=>INLINE_EDIT_DESCRIPTION);
parcelHelpers.export(exports, "GhostTextWidget", ()=>GhostTextWidget);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _inlineEditCss = require("./inlineEdit.css");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _languageJs = require("../../../common/languages/language.js");
var _modelJs = require("../../../common/model.js");
var _lineDecorationsJs = require("../../../common/viewLayout/lineDecorations.js");
var _utilsJs = require("../../inlineCompletions/browser/utils.js");
var _registrationsContributionJs = require("../../../browser/widget/diffEditor/registrations.contribution.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const INLINE_EDIT_DESCRIPTION = "inline-edit";
let GhostTextWidget = class GhostTextWidget extends (0, _lifecycleJs.Disposable) {
    constructor(editor, model, languageService){
        super();
        this.editor = editor;
        this.model = model;
        this.languageService = languageService;
        this.isDisposed = (0, _observableJs.observableValue)(this, false);
        this.currentTextModel = (0, _observableJs.observableFromEvent)(this, this.editor.onDidChangeModel, ()=>/** @description editor.model */ this.editor.getModel());
        this.uiState = (0, _observableJs.derived)(this, (reader)=>{
            if (this.isDisposed.read(reader)) return undefined;
            const textModel = this.currentTextModel.read(reader);
            if (textModel !== this.model.targetTextModel.read(reader)) return undefined;
            const ghostText = this.model.ghostText.read(reader);
            if (!ghostText) return undefined;
            let range = this.model.range?.read(reader);
            //if range is empty, we want to remove it
            if (range && range.startLineNumber === range.endLineNumber && range.startColumn === range.endColumn) range = undefined;
            //check if both range and text are single line - in this case we want to do inline replacement
            //rather than replacing whole lines
            const isSingleLine = (range ? range.startLineNumber === range.endLineNumber : true) && ghostText.parts.length === 1 && ghostText.parts[0].lines.length === 1;
            //check if we're just removing code
            const isPureRemove = ghostText.parts.length === 1 && ghostText.parts[0].lines.every((l)=>l.length === 0);
            const inlineTexts = [];
            const additionalLines = [];
            function addToAdditionalLines(lines, className) {
                if (additionalLines.length > 0) {
                    const lastLine = additionalLines[additionalLines.length - 1];
                    if (className) lastLine.decorations.push(new (0, _lineDecorationsJs.LineDecoration)(lastLine.content.length + 1, lastLine.content.length + 1 + lines[0].length, className, 0 /* InlineDecorationType.Regular */ ));
                    lastLine.content += lines[0];
                    lines = lines.slice(1);
                }
                for (const line of lines)additionalLines.push({
                    content: line,
                    decorations: className ? [
                        new (0, _lineDecorationsJs.LineDecoration)(1, line.length + 1, className, 0 /* InlineDecorationType.Regular */ )
                    ] : []
                });
            }
            const textBufferLine = textModel.getLineContent(ghostText.lineNumber);
            let hiddenTextStartColumn = undefined;
            let lastIdx = 0;
            if (!isPureRemove && (isSingleLine || !range)) {
                for (const part of ghostText.parts){
                    let lines = part.lines;
                    //If remove range is set, we want to push all new liens to virtual area
                    if (range && !isSingleLine) {
                        addToAdditionalLines(lines, INLINE_EDIT_DESCRIPTION);
                        lines = [];
                    }
                    if (hiddenTextStartColumn === undefined) {
                        inlineTexts.push({
                            column: part.column,
                            text: lines[0],
                            preview: part.preview
                        });
                        lines = lines.slice(1);
                    } else addToAdditionalLines([
                        textBufferLine.substring(lastIdx, part.column - 1)
                    ], undefined);
                    if (lines.length > 0) {
                        addToAdditionalLines(lines, INLINE_EDIT_DESCRIPTION);
                        if (hiddenTextStartColumn === undefined && part.column <= textBufferLine.length) hiddenTextStartColumn = part.column;
                    }
                    lastIdx = part.column - 1;
                }
                if (hiddenTextStartColumn !== undefined) addToAdditionalLines([
                    textBufferLine.substring(lastIdx)
                ], undefined);
            }
            const hiddenRange = hiddenTextStartColumn !== undefined ? new (0, _utilsJs.ColumnRange)(hiddenTextStartColumn, textBufferLine.length + 1) : undefined;
            const lineNumber = isSingleLine || !range ? ghostText.lineNumber : range.endLineNumber - 1;
            return {
                inlineTexts,
                additionalLines,
                hiddenRange,
                lineNumber,
                additionalReservedLineCount: this.model.minReservedLineCount.read(reader),
                targetTextModel: textModel,
                range,
                isSingleLine,
                isPureRemove
            };
        });
        this.decorations = (0, _observableJs.derived)(this, (reader)=>{
            const uiState = this.uiState.read(reader);
            if (!uiState) return [];
            const decorations = [];
            if (uiState.hiddenRange) decorations.push({
                range: uiState.hiddenRange.toRange(uiState.lineNumber),
                options: {
                    inlineClassName: "inline-edit-hidden",
                    description: "inline-edit-hidden"
                }
            });
            if (uiState.range) {
                const ranges = [];
                if (uiState.isSingleLine) ranges.push(uiState.range);
                else if (!uiState.isPureRemove) {
                    const lines = uiState.range.endLineNumber - uiState.range.startLineNumber;
                    for(let i = 0; i < lines; i++){
                        const line = uiState.range.startLineNumber + i;
                        const firstNonWhitespace = uiState.targetTextModel.getLineFirstNonWhitespaceColumn(line);
                        const lastNonWhitespace = uiState.targetTextModel.getLineLastNonWhitespaceColumn(line);
                        const range = new (0, _rangeJs.Range)(line, firstNonWhitespace, line, lastNonWhitespace);
                        ranges.push(range);
                    }
                }
                for (const range of ranges)decorations.push({
                    range,
                    options: (0, _registrationsContributionJs.diffDeleteDecoration)
                });
            }
            if (uiState.range && !uiState.isSingleLine && uiState.isPureRemove) {
                const r = new (0, _rangeJs.Range)(uiState.range.startLineNumber, 1, uiState.range.endLineNumber - 1, 1);
                decorations.push({
                    range: r,
                    options: (0, _registrationsContributionJs.diffLineDeleteDecorationBackgroundWithIndicator)
                });
            }
            for (const p of uiState.inlineTexts)decorations.push({
                range: (0, _rangeJs.Range).fromPositions(new (0, _positionJs.Position)(uiState.lineNumber, p.column)),
                options: {
                    description: INLINE_EDIT_DESCRIPTION,
                    after: {
                        content: p.text,
                        inlineClassName: p.preview ? "inline-edit-decoration-preview" : "inline-edit-decoration",
                        cursorStops: (0, _modelJs.InjectedTextCursorStops).Left
                    },
                    showIfCollapsed: true
                }
            });
            return decorations;
        });
        this._register((0, _lifecycleJs.toDisposable)(()=>{
            this.isDisposed.set(true, undefined);
        }));
        this._register((0, _utilsJs.applyObservableDecorations)(this.editor, this.decorations));
    }
};
GhostTextWidget = __decorate([
    __param(2, (0, _languageJs.ILanguageService))
], GhostTextWidget);

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","./inlineEdit.css":"kYglu","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/languages/language.js":"ka2JQ","../../../common/model.js":"1CSIB","../../../common/viewLayout/lineDecorations.js":"m2bJX","../../inlineCompletions/browser/utils.js":"4lO9A","../../../browser/widget/diffEditor/registrations.contribution.js":"3EY0P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kYglu":[function() {},{}],"ga6wn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineEditHintsWidget", ()=>InlineEditHintsWidget);
parcelHelpers.export(exports, "InlineEditHintsContentWidget", ()=>InlineEditHintsContentWidget);
parcelHelpers.export(exports, "CustomizedMenuWorkbenchToolBar", ()=>CustomizedMenuWorkbenchToolBar);
var _domJs = require("../../../../base/browser/dom.js");
var _keybindingLabelJs = require("../../../../base/browser/ui/keybindingLabel/keybindingLabel.js");
var _actionsJs = require("../../../../base/common/actions.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _platformJs = require("../../../../base/common/platform.js");
var _inlineEditHintsWidgetCss = require("./inlineEditHintsWidget.css");
var _positionJs = require("../../../common/core/position.js");
var _menuEntryActionViewItemJs = require("../../../../platform/actions/browser/menuEntryActionViewItem.js");
var _toolbarJs = require("../../../../platform/actions/browser/toolbar.js");
var _actionsJs1 = require("../../../../platform/actions/common/actions.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _contextViewJs = require("../../../../platform/contextview/browser/contextView.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _telemetryJs = require("../../../../platform/telemetry/common/telemetry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var InlineEditHintsContentWidget_1;
let InlineEditHintsWidget = class InlineEditHintsWidget extends (0, _lifecycleJs.Disposable) {
    constructor(editor, model, instantiationService){
        super();
        this.editor = editor;
        this.model = model;
        this.instantiationService = instantiationService;
        this.alwaysShowToolbar = (0, _observableJs.observableFromEvent)(this, this.editor.onDidChangeConfiguration, ()=>this.editor.getOption(63 /* EditorOption.inlineEdit */ ).showToolbar === "always");
        this.sessionPosition = undefined;
        this.position = (0, _observableJs.derived)(this, (reader)=>{
            const ghostText = this.model.read(reader)?.model.ghostText.read(reader);
            if (!this.alwaysShowToolbar.read(reader) || !ghostText || ghostText.parts.length === 0) {
                this.sessionPosition = undefined;
                return null;
            }
            const firstColumn = ghostText.parts[0].column;
            if (this.sessionPosition && this.sessionPosition.lineNumber !== ghostText.lineNumber) this.sessionPosition = undefined;
            const position = new (0, _positionJs.Position)(ghostText.lineNumber, Math.min(firstColumn, this.sessionPosition?.column ?? Number.MAX_SAFE_INTEGER));
            this.sessionPosition = position;
            return position;
        });
        this._register((0, _observableJs.autorunWithStore)((reader, store)=>{
            /** @description setup content widget */ const model = this.model.read(reader);
            if (!model || !this.alwaysShowToolbar.read(reader)) return;
            const contentWidget = store.add(this.instantiationService.createInstance(InlineEditHintsContentWidget, this.editor, true, this.position));
            editor.addContentWidget(contentWidget);
            store.add((0, _lifecycleJs.toDisposable)(()=>editor.removeContentWidget(contentWidget)));
        }));
    }
};
InlineEditHintsWidget = __decorate([
    __param(2, (0, _instantiationJs.IInstantiationService))
], InlineEditHintsWidget);
let InlineEditHintsContentWidget = class InlineEditHintsContentWidget extends (0, _lifecycleJs.Disposable) {
    static{
        InlineEditHintsContentWidget_1 = this;
    }
    static{
        this._dropDownVisible = false;
    }
    static{
        this.id = 0;
    }
    constructor(editor, withBorder, _position, instantiationService, _contextKeyService, _menuService){
        super();
        this.editor = editor;
        this.withBorder = withBorder;
        this._position = _position;
        this._contextKeyService = _contextKeyService;
        this._menuService = _menuService;
        this.id = `InlineEditHintsContentWidget${InlineEditHintsContentWidget_1.id++}`;
        this.allowEditorOverflow = true;
        this.suppressMouseDown = false;
        this.nodes = (0, _domJs.h)("div.inlineEditHints", {
            className: this.withBorder ? ".withBorder" : ""
        }, [
            (0, _domJs.h)("div@toolBar")
        ]);
        this.inlineCompletionsActionsMenus = this._register(this._menuService.createMenu((0, _actionsJs1.MenuId).InlineEditActions, this._contextKeyService));
        this.toolBar = this._register(instantiationService.createInstance(CustomizedMenuWorkbenchToolBar, this.nodes.toolBar, this.editor, (0, _actionsJs1.MenuId).InlineEditToolbar, {
            menuOptions: {
                renderShortTitle: true
            },
            toolbarOptions: {
                primaryGroup: (g)=>g.startsWith("primary")
            },
            actionViewItemProvider: (action, options)=>{
                if (action instanceof (0, _actionsJs1.MenuItemAction)) return instantiationService.createInstance(StatusBarViewItem, action, undefined);
                return undefined;
            },
            telemetrySource: "InlineEditToolbar"
        }));
        this._register(this.toolBar.onDidChangeDropdownVisibility((e)=>{
            InlineEditHintsContentWidget_1._dropDownVisible = e;
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update position */ this._position.read(reader);
            this.editor.layoutContentWidget(this);
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description actions menu */ const extraActions = [];
            for (const [_, group] of this.inlineCompletionsActionsMenus.getActions()){
                for (const action of group)if (action instanceof (0, _actionsJs1.MenuItemAction)) extraActions.push(action);
            }
            if (extraActions.length > 0) extraActions.unshift(new (0, _actionsJs.Separator)());
            this.toolBar.setAdditionalSecondaryActions(extraActions);
        }));
    }
    getId() {
        return this.id;
    }
    getDomNode() {
        return this.nodes.root;
    }
    getPosition() {
        return {
            position: this._position.get(),
            preference: [
                1 /* ContentWidgetPositionPreference.ABOVE */ ,
                2 /* ContentWidgetPositionPreference.BELOW */ 
            ],
            positionAffinity: 3 /* PositionAffinity.LeftOfInjectedText */ 
        };
    }
};
InlineEditHintsContentWidget = InlineEditHintsContentWidget_1 = __decorate([
    __param(3, (0, _instantiationJs.IInstantiationService)),
    __param(4, (0, _contextkeyJs.IContextKeyService)),
    __param(5, (0, _actionsJs1.IMenuService))
], InlineEditHintsContentWidget);
class StatusBarViewItem extends (0, _menuEntryActionViewItemJs.MenuEntryActionViewItem) {
    updateLabel() {
        const kb = this._keybindingService.lookupKeybinding(this._action.id, this._contextKeyService);
        if (!kb) return super.updateLabel();
        if (this.label) {
            const div = (0, _domJs.h)("div.keybinding").root;
            const k = this._register(new (0, _keybindingLabelJs.KeybindingLabel)(div, (0, _platformJs.OS), {
                disableTitle: true,
                ...(0, _keybindingLabelJs.unthemedKeybindingLabelOptions)
            }));
            k.set(kb);
            this.label.textContent = this._action.label;
            this.label.appendChild(div);
            this.label.classList.add("inlineEditStatusBarItemLabel");
        }
    }
    updateTooltip() {
    // NOOP, disable tooltip
    }
}
let CustomizedMenuWorkbenchToolBar = class CustomizedMenuWorkbenchToolBar extends (0, _toolbarJs.WorkbenchToolBar) {
    constructor(container, editor, menuId, options2, menuService, contextKeyService, contextMenuService, keybindingService, commandService, telemetryService){
        super(container, {
            resetMenu: menuId,
            ...options2
        }, menuService, contextKeyService, contextMenuService, keybindingService, commandService, telemetryService);
        this.editor = editor;
        this.menuId = menuId;
        this.options2 = options2;
        this.menuService = menuService;
        this.contextKeyService = contextKeyService;
        this.menu = this._store.add(this.menuService.createMenu(this.menuId, this.contextKeyService, {
            emitEventsForSubmenuChanges: true
        }));
        this.additionalActions = [];
        this.prependedPrimaryActions = [];
        this._store.add(this.menu.onDidChange(()=>this.updateToolbar()));
        this._store.add(this.editor.onDidChangeCursorPosition(()=>this.updateToolbar()));
        this.updateToolbar();
    }
    updateToolbar() {
        const primary = [];
        const secondary = [];
        (0, _menuEntryActionViewItemJs.createAndFillInActionBarActions)(this.menu, this.options2?.menuOptions, {
            primary,
            secondary
        }, this.options2?.toolbarOptions?.primaryGroup, this.options2?.toolbarOptions?.shouldInlineSubmenu, this.options2?.toolbarOptions?.useSeparatorsInPrimaryActions);
        secondary.push(...this.additionalActions);
        primary.unshift(...this.prependedPrimaryActions);
        this.setActions(primary, secondary);
    }
    setAdditionalSecondaryActions(actions) {
        if ((0, _arraysJs.equals)(this.additionalActions, actions, (a, b)=>a === b)) return;
        this.additionalActions = actions;
        this.updateToolbar();
    }
};
CustomizedMenuWorkbenchToolBar = __decorate([
    __param(4, (0, _actionsJs1.IMenuService)),
    __param(5, (0, _contextkeyJs.IContextKeyService)),
    __param(6, (0, _contextViewJs.IContextMenuService)),
    __param(7, (0, _keybindingJs.IKeybindingService)),
    __param(8, (0, _commandsJs.ICommandService)),
    __param(9, (0, _telemetryJs.ITelemetryService))
], CustomizedMenuWorkbenchToolBar);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/keybindingLabel/keybindingLabel.js":"hpphu","../../../../base/common/actions.js":"5GjLb","../../../../base/common/arrays.js":"DECei","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../../../base/common/platform.js":"7maJO","./inlineEditHintsWidget.css":"3umOW","../../../common/core/position.js":"lvrPe","../../../../platform/actions/browser/menuEntryActionViewItem.js":"evssn","../../../../platform/actions/browser/toolbar.js":"1ep75","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/contextview/browser/contextView.js":"2QlUR","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../platform/telemetry/common/telemetry.js":"7vW8j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3umOW":[function() {},{}],"g25ot":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineEditSideBySideWidget", ()=>InlineEditSideBySideWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _derivedJs = require("../../../../base/common/observableInternal/derived.js");
var _uriJs = require("../../../../base/common/uri.js");
var _inlineEditSideBySideWidgetCss = require("./inlineEditSideBySideWidget.css");
var _observableCodeEditorJs = require("../../../browser/observableCodeEditor.js");
var _embeddedCodeEditorWidgetJs = require("../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js");
var _diffProviderFactoryServiceJs = require("../../../browser/widget/diffEditor/diffProviderFactoryService.js");
var _registrationsContributionJs = require("../../../browser/widget/diffEditor/registrations.contribution.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _modesRegistryJs = require("../../../common/languages/modesRegistry.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _modelJs = require("../../../common/services/model.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var InlineEditSideBySideWidget_1, InlineEditSideBySideContentWidget_1;
function* range(start, end, step = 1) {
    if (end === undefined) [end, start] = [
        start,
        0
    ];
    for(let n = start; n < end; n += step)yield n;
}
function removeIndentation(lines) {
    const indentation = lines[0].match(/^\s*/)?.[0] ?? "";
    const length = indentation.length;
    return {
        text: lines.map((l)=>l.replace(new RegExp("^" + indentation), "")),
        shift: length
    };
}
let InlineEditSideBySideWidget = class InlineEditSideBySideWidget extends (0, _lifecycleJs.Disposable) {
    static{
        InlineEditSideBySideWidget_1 = this;
    }
    static{
        this._modelId = 0;
    }
    static _createUniqueUri() {
        return (0, _uriJs.URI).from({
            scheme: "inline-edit-widget",
            path: new Date().toString() + String(InlineEditSideBySideWidget_1._modelId++)
        });
    }
    constructor(_editor, _model, _instantiationService, _diffProviderFactoryService, _modelService){
        super();
        this._editor = _editor;
        this._model = _model;
        this._instantiationService = _instantiationService;
        this._diffProviderFactoryService = _diffProviderFactoryService;
        this._modelService = _modelService;
        this._position = (0, _observableJs.derived)(this, (reader)=>{
            const ghostText = this._model.read(reader);
            if (!ghostText || ghostText.text.length === 0) return null;
            if (ghostText.range.startLineNumber === ghostText.range.endLineNumber && !(ghostText.range.startColumn === ghostText.range.endColumn && ghostText.range.startColumn === 1)) //for inner-line suggestions we still want to use minimal ghost text
            return null;
            const editorModel = this._editor.getModel();
            if (!editorModel) return null;
            const lines = Array.from(range(ghostText.range.startLineNumber, ghostText.range.endLineNumber + 1));
            const lengths = lines.map((lineNumber)=>editorModel.getLineLastNonWhitespaceColumn(lineNumber));
            const maxColumn = Math.max(...lengths);
            const lineOfMaxColumn = lines[lengths.indexOf(maxColumn)];
            const position = new (0, _positionJs.Position)(lineOfMaxColumn, maxColumn);
            const pos = {
                top: ghostText.range.startLineNumber,
                left: position
            };
            return pos;
        });
        this._text = (0, _observableJs.derived)(this, (reader)=>{
            const ghostText = this._model.read(reader);
            if (!ghostText) return {
                text: "",
                shift: 0
            };
            const t = removeIndentation(ghostText.text.split("\n"));
            return {
                text: t.text.join("\n"),
                shift: t.shift
            };
        });
        this._originalModel = (0, _derivedJs.derivedDisposable)(()=>this._modelService.createModel("", null, InlineEditSideBySideWidget_1._createUniqueUri())).keepObserved(this._store);
        this._modifiedModel = (0, _derivedJs.derivedDisposable)(()=>this._modelService.createModel("", null, InlineEditSideBySideWidget_1._createUniqueUri())).keepObserved(this._store);
        this._diff = (0, _observableJs.derived)(this, (reader)=>{
            return this._diffPromise.read(reader)?.promiseResult.read(reader)?.data;
        });
        this._diffPromise = (0, _observableJs.derived)(this, (reader)=>{
            const ghostText = this._model.read(reader);
            if (!ghostText) return;
            const editorModel = this._editor.getModel();
            if (!editorModel) return;
            const originalText = removeIndentation(editorModel.getValueInRange(ghostText.range).split("\n")).text.join("\n");
            const modifiedText = removeIndentation(ghostText.text.split("\n")).text.join("\n");
            this._originalModel.get().setValue(originalText);
            this._modifiedModel.get().setValue(modifiedText);
            const d = this._diffProviderFactoryService.createDiffProvider({
                diffAlgorithm: "advanced"
            });
            return (0, _observableJs.ObservablePromise).fromFn(async ()=>{
                const result = await d.computeDiff(this._originalModel.get(), this._modifiedModel.get(), {
                    computeMoves: false,
                    ignoreTrimWhitespace: false,
                    maxComputationTimeMs: 1000
                }, (0, _cancellationJs.CancellationToken).None);
                if (result.identical) return undefined;
                return result.changes;
            });
        });
        this._register((0, _observableJs.autorunWithStore)((reader, store)=>{
            /** @description setup content widget */ const model = this._model.read(reader);
            if (!model) return;
            if (this._position.get() === null) return;
            const contentWidget = store.add(this._instantiationService.createInstance(InlineEditSideBySideContentWidget, this._editor, this._position, this._text.map((t)=>t.text), this._text.map((t)=>t.shift), this._diff));
            _editor.addOverlayWidget(contentWidget);
            store.add((0, _lifecycleJs.toDisposable)(()=>_editor.removeOverlayWidget(contentWidget)));
        }));
    }
};
InlineEditSideBySideWidget = InlineEditSideBySideWidget_1 = __decorate([
    __param(2, (0, _instantiationJs.IInstantiationService)),
    __param(3, (0, _diffProviderFactoryServiceJs.IDiffProviderFactoryService)),
    __param(4, (0, _modelJs.IModelService))
], InlineEditSideBySideWidget);
let InlineEditSideBySideContentWidget = class InlineEditSideBySideContentWidget extends (0, _lifecycleJs.Disposable) {
    static{
        InlineEditSideBySideContentWidget_1 = this;
    }
    static{
        this.id = 0;
    }
    constructor(_editor, _position, _text, _shift, _diff, _instantiationService){
        super();
        this._editor = _editor;
        this._position = _position;
        this._text = _text;
        this._shift = _shift;
        this._diff = _diff;
        this._instantiationService = _instantiationService;
        this.id = `InlineEditSideBySideContentWidget${InlineEditSideBySideContentWidget_1.id++}`;
        this.allowEditorOverflow = false;
        this._nodes = (0, _domJs.$)("div.inlineEditSideBySide", undefined);
        this._scrollChanged = (0, _observableJs.observableSignalFromEvent)("editor.onDidScrollChange", this._editor.onDidScrollChange);
        this._previewEditor = this._register(this._instantiationService.createInstance((0, _embeddedCodeEditorWidgetJs.EmbeddedCodeEditorWidget), this._nodes, {
            glyphMargin: false,
            lineNumbers: "off",
            minimap: {
                enabled: false
            },
            guides: {
                indentation: false,
                bracketPairs: false,
                bracketPairsHorizontal: false,
                highlightActiveIndentation: false
            },
            folding: false,
            selectOnLineNumbers: false,
            selectionHighlight: false,
            columnSelection: false,
            overviewRulerBorder: false,
            overviewRulerLanes: 0,
            lineDecorationsWidth: 0,
            lineNumbersMinChars: 0,
            scrollbar: {
                vertical: "hidden",
                horizontal: "hidden",
                alwaysConsumeMouseWheel: false,
                handleMouseWheel: false
            },
            readOnly: true,
            wordWrap: "off",
            wordWrapOverride1: "off",
            wordWrapOverride2: "off",
            wrappingIndent: "none",
            wrappingStrategy: undefined
        }, {
            contributions: [],
            isSimpleWidget: true
        }, this._editor));
        this._previewEditorObs = (0, _observableCodeEditorJs.observableCodeEditor)(this._previewEditor);
        this._editorObs = (0, _observableCodeEditorJs.observableCodeEditor)(this._editor);
        this._previewTextModel = this._register(this._instantiationService.createInstance((0, _textModelJs.TextModel), "", this._editor.getModel()?.getLanguageId() ?? (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID), (0, _textModelJs.TextModel).DEFAULT_CREATION_OPTIONS, null));
        this._setText = (0, _observableJs.derived)((reader)=>{
            const edit = this._text.read(reader);
            if (!edit) return;
            this._previewTextModel.setValue(edit);
        }).recomputeInitiallyAndOnChange(this._store);
        this._decorations = (0, _observableJs.derived)(this, (reader)=>{
            this._setText.read(reader);
            const position = this._position.read(reader);
            if (!position) return {
                org: [],
                mod: []
            };
            const diff = this._diff.read(reader);
            if (!diff) return {
                org: [],
                mod: []
            };
            const originalDecorations = [];
            const modifiedDecorations = [];
            if (diff.length === 1 && diff[0].innerChanges[0].modifiedRange.equalsRange(this._previewTextModel.getFullModelRange())) return {
                org: [],
                mod: []
            };
            const shift = this._shift.get();
            const moveRange = (range)=>{
                return new (0, _rangeJs.Range)(range.startLineNumber + position.top - 1, range.startColumn + shift, range.endLineNumber + position.top - 1, range.endColumn + shift);
            };
            for (const m of diff){
                if (!m.original.isEmpty) originalDecorations.push({
                    range: moveRange(m.original.toInclusiveRange()),
                    options: (0, _registrationsContributionJs.diffLineDeleteDecorationBackgroundWithIndicator)
                });
                if (!m.modified.isEmpty) modifiedDecorations.push({
                    range: m.modified.toInclusiveRange(),
                    options: (0, _registrationsContributionJs.diffLineAddDecorationBackgroundWithIndicator)
                });
                if (m.modified.isEmpty || m.original.isEmpty) {
                    if (!m.original.isEmpty) originalDecorations.push({
                        range: moveRange(m.original.toInclusiveRange()),
                        options: (0, _registrationsContributionJs.diffWholeLineDeleteDecoration)
                    });
                    if (!m.modified.isEmpty) modifiedDecorations.push({
                        range: m.modified.toInclusiveRange(),
                        options: (0, _registrationsContributionJs.diffWholeLineAddDecoration)
                    });
                } else for (const i of m.innerChanges || []){
                    // Don't show empty markers outside the line range
                    if (m.original.contains(i.originalRange.startLineNumber)) originalDecorations.push({
                        range: moveRange(i.originalRange),
                        options: i.originalRange.isEmpty() ? (0, _registrationsContributionJs.diffDeleteDecorationEmpty) : (0, _registrationsContributionJs.diffDeleteDecoration)
                    });
                    if (m.modified.contains(i.modifiedRange.startLineNumber)) modifiedDecorations.push({
                        range: i.modifiedRange,
                        options: i.modifiedRange.isEmpty() ? (0, _registrationsContributionJs.diffAddDecorationEmpty) : (0, _registrationsContributionJs.diffAddDecoration)
                    });
                }
            }
            return {
                org: originalDecorations,
                mod: modifiedDecorations
            };
        });
        this._originalDecorations = (0, _observableJs.derived)(this, (reader)=>{
            return this._decorations.read(reader).org;
        });
        this._modifiedDecorations = (0, _observableJs.derived)(this, (reader)=>{
            return this._decorations.read(reader).mod;
        });
        this._previewEditor.setModel(this._previewTextModel);
        this._register(this._editorObs.setDecorations(this._originalDecorations));
        this._register(this._previewEditorObs.setDecorations(this._modifiedDecorations));
        this._register((0, _observableJs.autorun)((reader)=>{
            const width = this._previewEditorObs.contentWidth.read(reader);
            const lines = this._text.read(reader).split("\n").length - 1;
            const height = this._editor.getOption(67 /* EditorOption.lineHeight */ ) * lines;
            if (width <= 0) return;
            this._previewEditor.layout({
                height: height,
                width: width
            });
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description update position */ this._position.read(reader);
            this._editor.layoutOverlayWidget(this);
        }));
        this._register((0, _observableJs.autorun)((reader)=>{
            /** @description scroll change */ this._scrollChanged.read(reader);
            const position = this._position.read(reader);
            if (!position) return;
            this._editor.layoutOverlayWidget(this);
        }));
    }
    getId() {
        return this.id;
    }
    getDomNode() {
        return this._nodes;
    }
    getPosition() {
        const position = this._position.get();
        if (!position) return null;
        const layoutInfo = this._editor.getLayoutInfo();
        const visibPos = this._editor.getScrolledVisiblePosition(new (0, _positionJs.Position)(position.top, 1));
        if (!visibPos) return null;
        const top = visibPos.top - 1; //-1 to offset the border width
        const offset = this._editor.getOffsetForColumn(position.left.lineNumber, position.left.column);
        const left = layoutInfo.contentLeft + offset + 10;
        return {
            preference: {
                left,
                top
            }
        };
    }
};
InlineEditSideBySideContentWidget = InlineEditSideBySideContentWidget_1 = __decorate([
    __param(5, (0, _instantiationJs.IInstantiationService))
], InlineEditSideBySideContentWidget);

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../../../base/common/observableInternal/derived.js":"hZb5S","../../../../base/common/uri.js":"7qGS3","./inlineEditSideBySideWidget.css":"emmq7","../../../browser/observableCodeEditor.js":"hfBd1","../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js":"8G1ik","../../../browser/widget/diffEditor/diffProviderFactoryService.js":"chJTA","../../../browser/widget/diffEditor/registrations.contribution.js":"3EY0P","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/languages/modesRegistry.js":"gqkb7","../../../common/model/textModel.js":"9beDe","../../../common/services/model.js":"aciVm","../../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"emmq7":[function() {},{}],"3wp28":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _commandsJs = require("./commands.js");
var _inlineEditsControllerJs = require("./inlineEditsController.js");
(0, _editorExtensionsJs.registerEditorContribution)((0, _inlineEditsControllerJs.InlineEditsController).ID, (0, _inlineEditsControllerJs.InlineEditsController), 3 /* EditorContributionInstantiation.Eventually */ );
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.TriggerInlineEditAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.ShowNextInlineEditAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.ShowPreviousInlineEditAction));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.AcceptInlineEdit));
(0, _editorExtensionsJs.registerEditorAction)((0, _commandsJs.HideInlineEdit));

},{"../../../browser/editorExtensions.js":"kC3w6","./commands.js":"9B4mH","./inlineEditsController.js":"9JRn5"}],"9B4mH":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShowNextInlineEditAction", ()=>ShowNextInlineEditAction);
parcelHelpers.export(exports, "ShowPreviousInlineEditAction", ()=>ShowPreviousInlineEditAction);
parcelHelpers.export(exports, "TriggerInlineEditAction", ()=>TriggerInlineEditAction);
parcelHelpers.export(exports, "AcceptInlineEdit", ()=>AcceptInlineEdit);
/*
TODO@hediet
export class PinInlineEdit extends EditorAction {
    constructor() {
        super({
            id: 'editor.action.inlineEdits.pin',
            ...labelAndAlias(nls.localize2('action.inlineEdits.pin', "Pin Inline Edit")),
            precondition: undefined,
            kbOpts: {
                primary: KeyMod.Shift | KeyCode.Space,
                weight: 20000,
            }
        });
    }

    public async run(accessor: ServicesAccessor | undefined, editor: ICodeEditor): Promise<void> {
        const controller = InlineEditsController.get(editor);
        if (controller) {
            controller.model.get()?.togglePin();
        }
    }
}

MenuRegistry.appendMenuItem(MenuId.InlineEditsActions, {
    command: {
        id: 'editor.action.inlineEdits.pin',
        title: nls.localize('Pin', "Pin"),
        icon: Codicon.pin,
    },
    group: 'primary',
    order: 1,
    when: isPinnedContextKey.negate(),
});

MenuRegistry.appendMenuItem(MenuId.InlineEditsActions, {
    command: {
        id: 'editor.action.inlineEdits.unpin',
        title: nls.localize('Unpin', "Unpin"),
        icon: Codicon.pinned,
    },
    group: 'primary',
    order: 1,
    when: isPinnedContextKey,
});*/ parcelHelpers.export(exports, "HideInlineEdit", ()=>HideInlineEdit);
var _codiconsJs = require("../../../../base/common/codicons.js");
var _observableJs = require("../../../../base/common/observable.js");
var _baseJs = require("../../../../base/common/observableInternal/base.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _embeddedCodeEditorWidgetJs = require("../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _constsJs = require("./consts.js");
var _inlineEditsControllerJs = require("./inlineEditsController.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
function labelAndAlias(str) {
    return {
        label: str.value,
        alias: str.original
    };
}
class ShowNextInlineEditAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = (0, _constsJs.showNextInlineEditActionId);
    }
    constructor(){
        super({
            id: ShowNextInlineEditAction.ID,
            ...labelAndAlias(_nlsJs.localize2("action.inlineEdits.showNext", "Show Next Inline Edit")),
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _constsJs.inlineEditVisible)),
            kbOpts: {
                weight: 100,
                primary: 606 /* KeyCode.BracketRight */ 
            }
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineEditsControllerJs.InlineEditsController).get(editor);
        controller?.model.get()?.next();
    }
}
class ShowPreviousInlineEditAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = (0, _constsJs.showPreviousInlineEditActionId);
    }
    constructor(){
        super({
            id: ShowPreviousInlineEditAction.ID,
            ...labelAndAlias(_nlsJs.localize2("action.inlineEdits.showPrevious", "Show Previous Inline Edit")),
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _constsJs.inlineEditVisible)),
            kbOpts: {
                weight: 100,
                primary: 604 /* KeyCode.BracketLeft */ 
            }
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineEditsControllerJs.InlineEditsController).get(editor);
        controller?.model.get()?.previous();
    }
}
class TriggerInlineEditAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.inlineEdits.trigger",
            ...labelAndAlias(_nlsJs.localize2("action.inlineEdits.trigger", "Trigger Inline Edit")),
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineEditsControllerJs.InlineEditsController).get(editor);
        await (0, _baseJs.asyncTransaction)(async (tx)=>{
            /** @description triggerExplicitly from command */ await controller?.model.get()?.triggerExplicitly(tx);
        });
    }
}
class AcceptInlineEdit extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: (0, _constsJs.inlineEditAcceptId),
            ...labelAndAlias(_nlsJs.localize2("action.inlineEdits.accept", "Accept Inline Edit")),
            precondition: (0, _constsJs.inlineEditVisible),
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).InlineEditsActions,
                title: _nlsJs.localize("inlineEditsActions", "Accept Inline Edit"),
                group: "primary",
                order: 1,
                icon: (0, _codiconsJs.Codicon).check
            },
            kbOpts: {
                primary: 2058 /* KeyCode.Space */ ,
                weight: 20000,
                kbExpr: (0, _constsJs.inlineEditVisible)
            }
        });
    }
    async run(accessor, editor) {
        if (editor instanceof (0, _embeddedCodeEditorWidgetJs.EmbeddedCodeEditorWidget)) editor = editor.getParentEditor();
        const controller = (0, _inlineEditsControllerJs.InlineEditsController).get(editor);
        if (controller) {
            controller.model.get()?.accept(controller.editor);
            controller.editor.focus();
        }
    }
}
class HideInlineEdit extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.inlineEdits.hide";
    }
    constructor(){
        super({
            id: HideInlineEdit.ID,
            ...labelAndAlias(_nlsJs.localize2("action.inlineEdits.hide", "Hide Inline Edit")),
            precondition: (0, _constsJs.inlineEditVisible),
            kbOpts: {
                weight: 100,
                primary: 9 /* KeyCode.Escape */ 
            }
        });
    }
    async run(accessor, editor) {
        const controller = (0, _inlineEditsControllerJs.InlineEditsController).get(editor);
        (0, _observableJs.transaction)((tx)=>{
            controller?.model.get()?.stop(tx);
        });
    }
}

},{"../../../../base/common/codicons.js":"hWYNf","../../../../base/common/observable.js":"2xbG5","../../../../base/common/observableInternal/base.js":"lYJZ2","../../../browser/editorExtensions.js":"kC3w6","../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js":"8G1ik","../../../common/editorContextKeys.js":"5exv9","./consts.js":"hTc7j","./inlineEditsController.js":"9JRn5","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hTc7j":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inlineEditAcceptId", ()=>inlineEditAcceptId);
parcelHelpers.export(exports, "showPreviousInlineEditActionId", ()=>showPreviousInlineEditActionId);
parcelHelpers.export(exports, "showNextInlineEditActionId", ()=>showNextInlineEditActionId);
parcelHelpers.export(exports, "inlineEditVisible", ()=>inlineEditVisible);
parcelHelpers.export(exports, "isPinnedContextKey", ()=>isPinnedContextKey);
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
const inlineEditAcceptId = "editor.action.inlineEdits.accept";
const showPreviousInlineEditActionId = "editor.action.inlineEdits.showPrevious";
const showNextInlineEditActionId = "editor.action.inlineEdits.showNext";
const inlineEditVisible = new (0, _contextkeyJs.RawContextKey)("inlineEditsVisible", false, (0, _nlsJs.localize)("inlineEditsVisible", "Whether an inline edit is visible"));
const isPinnedContextKey = new (0, _contextkeyJs.RawContextKey)("inlineEditsIsPinned", false, (0, _nlsJs.localize)("isPinned", "Whether an inline edit is visible"));

},{"../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9JRn5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineEditsController", ()=>InlineEditsController);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _derivedJs = require("../../../../base/common/observableInternal/derived.js");
var _observableCodeEditorJs = require("../../../browser/observableCodeEditor.js");
var _hotReloadHelpersJs = require("../../../../base/common/hotReloadHelpers.js");
var _selectionJs = require("../../../common/core/selection.js");
var _languageFeatureDebounceJs = require("../../../common/services/languageFeatureDebounce.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _constsJs = require("./consts.js");
var _inlineEditsModelJs = require("./inlineEditsModel.js");
var _inlineEditsWidgetJs = require("./inlineEditsWidget.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _platformObservableUtilsJs = require("../../../../platform/observable/common/platformObservableUtils.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var InlineEditsController_1;
let InlineEditsController = class InlineEditsController extends (0, _lifecycleJs.Disposable) {
    static{
        InlineEditsController_1 = this;
    }
    static{
        this.ID = "editor.contrib.inlineEditsController";
    }
    static get(editor) {
        return editor.getContribution(InlineEditsController_1.ID);
    }
    constructor(editor, _instantiationService, _contextKeyService, _debounceService, _languageFeaturesService, _configurationService){
        super();
        this.editor = editor;
        this._instantiationService = _instantiationService;
        this._contextKeyService = _contextKeyService;
        this._debounceService = _debounceService;
        this._languageFeaturesService = _languageFeaturesService;
        this._configurationService = _configurationService;
        this._enabled = (0, _platformObservableUtilsJs.observableConfigValue)("editor.inlineEdits.enabled", false, this._configurationService);
        this._editorObs = (0, _observableCodeEditorJs.observableCodeEditor)(this.editor);
        this._selection = (0, _observableJs.derived)(this, (reader)=>this._editorObs.cursorSelection.read(reader) ?? new (0, _selectionJs.Selection)(1, 1, 1, 1));
        this._debounceValue = this._debounceService.for(this._languageFeaturesService.inlineCompletionsProvider, "InlineEditsDebounce", {
            min: 50,
            max: 50
        });
        this.model = (0, _derivedJs.derivedDisposable)(this, (reader)=>{
            if (!this._enabled.read(reader)) return undefined;
            if (this._editorObs.isReadonly.read(reader)) return undefined;
            const textModel = this._editorObs.model.read(reader);
            if (!textModel) return undefined;
            const model = this._instantiationService.createInstance((0, _hotReloadHelpersJs.readHotReloadableExport)((0, _inlineEditsModelJs.InlineEditsModel), reader), textModel, this._editorObs.versionId, this._selection, this._debounceValue);
            return model;
        });
        this._hadInlineEdit = (0, _observableJs.derivedObservableWithCache)(this, (reader, lastValue)=>lastValue || this.model.read(reader)?.inlineEdit.read(reader) !== undefined);
        this._widget = (0, _derivedJs.derivedDisposable)(this, (reader)=>{
            if (!this._hadInlineEdit.read(reader)) return undefined;
            return this._instantiationService.createInstance((0, _hotReloadHelpersJs.readHotReloadableExport)((0, _inlineEditsWidgetJs.InlineEditsWidget), reader), this.editor, this.model.map((m, reader)=>m?.inlineEdit.read(reader)), flattenSettableObservable((reader)=>this.model.read(reader)?.userPrompt ?? (0, _observableJs.observableValue)("empty", "")));
        });
        this._register((0, _platformObservableUtilsJs.bindContextKey)((0, _constsJs.inlineEditVisible), this._contextKeyService, (r)=>!!this.model.read(r)?.inlineEdit.read(r)));
        this._register((0, _platformObservableUtilsJs.bindContextKey)((0, _constsJs.isPinnedContextKey), this._contextKeyService, (r)=>!!this.model.read(r)?.isPinned.read(r)));
        this.model.recomputeInitiallyAndOnChange(this._store);
        this._widget.recomputeInitiallyAndOnChange(this._store);
    }
};
InlineEditsController = InlineEditsController_1 = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService)),
    __param(2, (0, _contextkeyJs.IContextKeyService)),
    __param(3, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService)),
    __param(4, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(5, (0, _configurationJs.IConfigurationService))
], InlineEditsController);
function flattenSettableObservable(fn) {
    return (0, _derivedJs.derivedWithSetter)(undefined, (reader)=>{
        const obs = fn(reader);
        return obs.read(reader);
    }, (value, tx)=>{
        fn(undefined).set(value, tx);
    });
}

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../../../base/common/observableInternal/derived.js":"hZb5S","../../../browser/observableCodeEditor.js":"hfBd1","../../../../base/common/hotReloadHelpers.js":"3t1eI","../../../common/core/selection.js":"kcwzU","../../../common/services/languageFeatureDebounce.js":"YGXXG","../../../common/services/languageFeatures.js":"2IAko","./consts.js":"hTc7j","./inlineEditsModel.js":"gJt9R","./inlineEditsWidget.js":"2vUWN","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/observable/common/platformObservableUtils.js":"aB9DE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gJt9R":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineEditsModel", ()=>InlineEditsModel);
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _equalsJs = require("../../../../base/common/equals.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _derivedJs = require("../../../../base/common/observableInternal/derived.js");
var _uriJs = require("../../../../base/common/uri.js");
var _diffProviderFactoryServiceJs = require("../../../browser/widget/diffEditor/diffProviderFactoryService.js");
var _lineRangeJs = require("../../../common/core/lineRange.js");
var _languagesJs = require("../../../common/languages.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _modelJs = require("../../../common/services/model.js");
var _provideInlineCompletionsJs = require("../../inlineCompletions/browser/model/provideInlineCompletions.js");
var _inlineEditsWidgetJs = require("./inlineEditsWidget.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var InlineEditsModel_1;
let InlineEditsModel = class InlineEditsModel extends (0, _lifecycleJs.Disposable) {
    static{
        InlineEditsModel_1 = this;
    }
    static{
        this._modelId = 0;
    }
    static _createUniqueUri() {
        return (0, _uriJs.URI).from({
            scheme: "inline-edits",
            path: new Date().toString() + String(InlineEditsModel_1._modelId++)
        });
    }
    constructor(textModel, _textModelVersionId, _selection, _debounceValue, languageFeaturesService, _diffProviderFactoryService, _modelService){
        super();
        this.textModel = textModel;
        this._textModelVersionId = _textModelVersionId;
        this._selection = _selection;
        this._debounceValue = _debounceValue;
        this.languageFeaturesService = languageFeaturesService;
        this._diffProviderFactoryService = _diffProviderFactoryService;
        this._modelService = _modelService;
        this._forceUpdateExplicitlySignal = (0, _observableJs.observableSignal)(this);
        // We use a semantic id to keep the same inline completion selected even if the provider reorders the completions.
        this._selectedInlineCompletionId = (0, _observableJs.observableValue)(this, undefined);
        this._isActive = (0, _observableJs.observableValue)(this, false);
        this._originalModel = (0, _derivedJs.derivedDisposable)(()=>this._modelService.createModel("", null, InlineEditsModel_1._createUniqueUri())).keepObserved(this._store);
        this._modifiedModel = (0, _derivedJs.derivedDisposable)(()=>this._modelService.createModel("", null, InlineEditsModel_1._createUniqueUri())).keepObserved(this._store);
        this._pinnedRange = new TrackedRange(this.textModel, this._textModelVersionId);
        this.isPinned = this._pinnedRange.range.map((range)=>!!range);
        this.userPrompt = (0, _observableJs.observableValue)(this, undefined);
        this.inlineEdit = (0, _observableJs.derived)(this, (reader)=>{
            return this._inlineEdit.read(reader)?.promiseResult.read(reader)?.data;
        });
        this._inlineEdit = (0, _observableJs.derived)(this, (reader)=>{
            const edit = this.selectedInlineEdit.read(reader);
            if (!edit) return undefined;
            const range = edit.inlineCompletion.range;
            if (edit.inlineCompletion.insertText.trim() === "") return undefined;
            let newLines = edit.inlineCompletion.insertText.split(/\r\n|\r|\n/);
            function removeIndentation(lines) {
                const indentation = lines[0].match(/^\s*/)?.[0] ?? "";
                return lines.map((l)=>l.replace(new RegExp("^" + indentation), ""));
            }
            newLines = removeIndentation(newLines);
            const existing = this.textModel.getValueInRange(range);
            let existingLines = existing.split(/\r\n|\r|\n/);
            existingLines = removeIndentation(existingLines);
            this._originalModel.get().setValue(existingLines.join("\n"));
            this._modifiedModel.get().setValue(newLines.join("\n"));
            const d = this._diffProviderFactoryService.createDiffProvider({
                diffAlgorithm: "advanced"
            });
            return (0, _observableJs.ObservablePromise).fromFn(async ()=>{
                const result = await d.computeDiff(this._originalModel.get(), this._modifiedModel.get(), {
                    computeMoves: false,
                    ignoreTrimWhitespace: false,
                    maxComputationTimeMs: 1000
                }, (0, _cancellationJs.CancellationToken).None);
                if (result.identical) return undefined;
                return new (0, _inlineEditsWidgetJs.InlineEdit)((0, _lineRangeJs.LineRange).fromRangeInclusive(range), removeIndentation(newLines), result.changes);
            });
        });
        this._fetchStore = this._register(new (0, _lifecycleJs.DisposableStore)());
        this._inlineEditsFetchResult = (0, _observableJs.disposableObservableValue)(this, undefined);
        this._inlineEdits = (0, _observableJs.derivedOpts)({
            owner: this,
            equalsFn: (0, _equalsJs.structuralEquals)
        }, (reader)=>{
            return this._inlineEditsFetchResult.read(reader)?.completions.map((c)=>new InlineEditData(c)) ?? [];
        });
        this._fetchInlineEditsPromise = (0, _observableJs.derivedHandleChanges)({
            owner: this,
            createEmptyChangeSummary: ()=>({
                    inlineCompletionTriggerKind: (0, _languagesJs.InlineCompletionTriggerKind).Automatic
                }),
            handleChange: (ctx, changeSummary)=>{
                /** @description fetch inline completions */ if (ctx.didChange(this._forceUpdateExplicitlySignal)) changeSummary.inlineCompletionTriggerKind = (0, _languagesJs.InlineCompletionTriggerKind).Explicit;
                return true;
            }
        }, async (reader, changeSummary)=>{
            this._fetchStore.clear();
            this._forceUpdateExplicitlySignal.read(reader);
            /*if (!this._isActive.read(reader)) {
                return undefined;
            }*/ this._textModelVersionId.read(reader);
            function mapValue(value, fn) {
                return fn(value);
            }
            const selection = this._pinnedRange.range.read(reader) ?? mapValue(this._selection.read(reader), (v)=>v.isEmpty() ? undefined : v);
            if (!selection) {
                this._inlineEditsFetchResult.set(undefined, undefined);
                this.userPrompt.set(undefined, undefined);
                return undefined;
            }
            const context = {
                triggerKind: changeSummary.inlineCompletionTriggerKind,
                selectedSuggestionInfo: undefined,
                userPrompt: this.userPrompt.read(reader)
            };
            const token = (0, _cancellationJs.cancelOnDispose)(this._fetchStore);
            await (0, _asyncJs.timeout)(200, token);
            const result = await (0, _provideInlineCompletionsJs.provideInlineCompletions)(this.languageFeaturesService.inlineCompletionsProvider, selection, this.textModel, context, token);
            if (token.isCancellationRequested) return;
            this._inlineEditsFetchResult.set(result, undefined);
        });
        this._filteredInlineEditItems = (0, _observableJs.derivedOpts)({
            owner: this,
            equalsFn: (0, _equalsJs.itemsEquals)()
        }, (reader)=>{
            return this._inlineEdits.read(reader);
        });
        this.selectedInlineCompletionIndex = (0, _observableJs.derived)(this, (reader)=>{
            const selectedInlineCompletionId = this._selectedInlineCompletionId.read(reader);
            const filteredCompletions = this._filteredInlineEditItems.read(reader);
            const idx = this._selectedInlineCompletionId === undefined ? -1 : filteredCompletions.findIndex((v)=>v.semanticId === selectedInlineCompletionId);
            if (idx === -1) {
                // Reset the selection so that the selection does not jump back when it appears again
                this._selectedInlineCompletionId.set(undefined, undefined);
                return 0;
            }
            return idx;
        });
        this.selectedInlineEdit = (0, _observableJs.derived)(this, (reader)=>{
            const filteredCompletions = this._filteredInlineEditItems.read(reader);
            const idx = this.selectedInlineCompletionIndex.read(reader);
            return filteredCompletions[idx];
        });
        this._register((0, _observableJs.recomputeInitiallyAndOnChange)(this._fetchInlineEditsPromise));
    }
    async triggerExplicitly(tx) {
        (0, _observableJs.subtransaction)(tx, (tx)=>{
            this._isActive.set(true, tx);
            this._forceUpdateExplicitlySignal.trigger(tx);
        });
        await this._fetchInlineEditsPromise.get();
    }
    stop(tx) {
        (0, _observableJs.subtransaction)(tx, (tx)=>{
            this.userPrompt.set(undefined, tx);
            this._isActive.set(false, tx);
            this._inlineEditsFetchResult.set(undefined, tx);
            this._pinnedRange.setRange(undefined, tx);
        //this._source.clear(tx);
        });
    }
    async _deltaSelectedInlineCompletionIndex(delta) {
        await this.triggerExplicitly();
        const completions = this._filteredInlineEditItems.get() || [];
        if (completions.length > 0) {
            const newIdx = (this.selectedInlineCompletionIndex.get() + delta + completions.length) % completions.length;
            this._selectedInlineCompletionId.set(completions[newIdx].semanticId, undefined);
        } else this._selectedInlineCompletionId.set(undefined, undefined);
    }
    async next() {
        await this._deltaSelectedInlineCompletionIndex(1);
    }
    async previous() {
        await this._deltaSelectedInlineCompletionIndex(-1);
    }
    async accept(editor) {
        if (editor.getModel() !== this.textModel) throw new (0, _errorsJs.BugIndicatingError)();
        const edit = this.selectedInlineEdit.get();
        if (!edit) return;
        editor.pushUndoStop();
        editor.executeEdits("inlineSuggestion.accept", [
            edit.inlineCompletion.toSingleTextEdit().toSingleEditOperation()
        ]);
        this.stop();
    }
};
InlineEditsModel = InlineEditsModel_1 = __decorate([
    __param(4, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(5, (0, _diffProviderFactoryServiceJs.IDiffProviderFactoryService)),
    __param(6, (0, _modelJs.IModelService))
], InlineEditsModel);
class InlineEditData {
    constructor(inlineCompletion){
        this.inlineCompletion = inlineCompletion;
        this.semanticId = this.inlineCompletion.hash();
    }
}
class TrackedRange extends (0, _lifecycleJs.Disposable) {
    constructor(_textModel, _versionId){
        super();
        this._textModel = _textModel;
        this._versionId = _versionId;
        this._decorations = (0, _observableJs.observableValue)(this, []);
        this.range = (0, _observableJs.derived)(this, (reader)=>{
            this._versionId.read(reader);
            const deco = this._decorations.read(reader)[0];
            if (!deco) return null;
            return this._textModel.getDecorationRange(deco) ?? null;
        });
        this._register((0, _lifecycleJs.toDisposable)(()=>{
            this._textModel.deltaDecorations(this._decorations.get(), []);
        }));
    }
    setRange(range, tx) {
        this._decorations.set(this._textModel.deltaDecorations(this._decorations.get(), range ? [
            {
                range,
                options: {
                    description: "trackedRange"
                }
            }
        ] : []), tx);
    }
}

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/equals.js":"8hes7","../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../../../base/common/observableInternal/derived.js":"hZb5S","../../../../base/common/uri.js":"7qGS3","../../../browser/widget/diffEditor/diffProviderFactoryService.js":"chJTA","../../../common/core/lineRange.js":"cmnMs","../../../common/languages.js":"g5n96","../../../common/services/languageFeatures.js":"2IAko","../../../common/services/model.js":"aciVm","../../inlineCompletions/browser/model/provideInlineCompletions.js":"cMrUc","./inlineEditsWidget.js":"2vUWN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2vUWN":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineEdit", ()=>InlineEdit);
parcelHelpers.export(exports, "InlineEditsWidget", ()=>InlineEditsWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _fontsJs = require("../../../../base/browser/fonts.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _derivedJs = require("../../../../base/common/observableInternal/derived.js");
var _inlineEditsWidgetCss = require("./inlineEditsWidget.css");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _observableCodeEditorJs = require("../../../browser/observableCodeEditor.js");
var _embeddedCodeEditorWidgetJs = require("../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js");
var _registrationsContributionJs = require("../../../browser/widget/diffEditor/registrations.contribution.js");
var _utilsJs = require("../../../browser/widget/diffEditor/utils.js");
var _modesRegistryJs = require("../../../common/languages/modesRegistry.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _contextmenuJs = require("../../contextmenu/browser/contextmenu.js");
var _placeholderTextContributionJs = require("../../placeholderText/browser/placeholderTextContribution.js");
var _suggestControllerJs = require("../../suggest/browser/suggestController.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class InlineEdit {
    constructor(range, newLines, changes){
        this.range = range;
        this.newLines = newLines;
        this.changes = changes;
    }
}
let InlineEditsWidget = class InlineEditsWidget extends (0, _lifecycleJs.Disposable) {
    constructor(_editor, _edit, _userPrompt, _instantiationService){
        super();
        this._editor = _editor;
        this._edit = _edit;
        this._userPrompt = _userPrompt;
        this._instantiationService = _instantiationService;
        this._editorObs = (0, _observableCodeEditorJs.observableCodeEditor)(this._editor);
        this._elements = (0, _domJs.h)("div.inline-edits-widget", {
            style: {
                position: "absolute",
                overflow: "visible",
                top: "0px",
                left: "0px"
            }
        }, [
            (0, _domJs.h)("div@editorContainer", {
                style: {
                    position: "absolute",
                    top: "0px",
                    left: "0px",
                    width: "500px",
                    height: "500px"
                }
            }, [
                (0, _domJs.h)("div.toolbar@toolbar", {
                    style: {
                        position: "absolute",
                        top: "-25px",
                        left: "0px"
                    }
                }),
                (0, _domJs.h)("div.promptEditor@promptEditor", {
                    style: {
                        position: "absolute",
                        top: "-25px",
                        left: "80px",
                        width: "300px",
                        height: "22px"
                    }
                }),
                (0, _domJs.h)("div.preview@editor", {
                    style: {
                        position: "absolute",
                        top: "0px",
                        left: "0px"
                    }
                })
            ]),
            (0, _domJs.svgElem)("svg", {
                style: {
                    overflow: "visible",
                    pointerEvents: "none"
                }
            }, [
                (0, _domJs.svgElem)("defs", [
                    (0, _domJs.svgElem)("linearGradient", {
                        id: "Gradient2",
                        x1: "0",
                        y1: "0",
                        x2: "1",
                        y2: "0"
                    }, [
                        /*svgElem('stop', { offset: '0%', class: 'gradient-start', }),
                        svgElem('stop', { offset: '0%', class: 'gradient-start', }),
                        svgElem('stop', { offset: '20%', class: 'gradient-stop', }),*/ (0, _domJs.svgElem)("stop", {
                            offset: "0%",
                            class: "gradient-stop"
                        }),
                        (0, _domJs.svgElem)("stop", {
                            offset: "100%",
                            class: "gradient-stop"
                        })
                    ])
                ]),
                (0, _domJs.svgElem)("path@path", {
                    d: "",
                    fill: "url(#Gradient2)"
                })
            ])
        ]);
        this._previewTextModel = this._register(this._instantiationService.createInstance((0, _textModelJs.TextModel), "", (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID), (0, _textModelJs.TextModel).DEFAULT_CREATION_OPTIONS, null));
        this._setText = (0, _observableJs.derived)((reader)=>{
            const edit = this._edit.read(reader);
            if (!edit) return;
            this._previewTextModel.setValue(edit.newLines.join("\n"));
        }).recomputeInitiallyAndOnChange(this._store);
        this._promptTextModel = this._register(this._instantiationService.createInstance((0, _textModelJs.TextModel), "", (0, _modesRegistryJs.PLAINTEXT_LANGUAGE_ID), (0, _textModelJs.TextModel).DEFAULT_CREATION_OPTIONS, null));
        this._promptEditor = this._register(this._instantiationService.createInstance((0, _embeddedCodeEditorWidgetJs.EmbeddedCodeEditorWidget), this._elements.promptEditor, {
            glyphMargin: false,
            lineNumbers: "off",
            minimap: {
                enabled: false
            },
            guides: {
                indentation: false,
                bracketPairs: false,
                bracketPairsHorizontal: false,
                highlightActiveIndentation: false
            },
            folding: false,
            selectOnLineNumbers: false,
            selectionHighlight: false,
            columnSelection: false,
            overviewRulerBorder: false,
            overviewRulerLanes: 0,
            lineDecorationsWidth: 0,
            lineNumbersMinChars: 0,
            placeholder: "Describe the change you want...",
            fontFamily: (0, _fontsJs.DEFAULT_FONT_FAMILY)
        }, {
            contributions: (0, _editorExtensionsJs.EditorExtensionsRegistry).getSomeEditorContributions([
                (0, _suggestControllerJs.SuggestController).ID,
                (0, _placeholderTextContributionJs.PlaceholderTextContribution).ID,
                (0, _contextmenuJs.ContextMenuController).ID
            ]),
            isSimpleWidget: true
        }, this._editor));
        this._previewEditor = this._register(this._instantiationService.createInstance((0, _embeddedCodeEditorWidgetJs.EmbeddedCodeEditorWidget), this._elements.editor, {
            glyphMargin: false,
            lineNumbers: "off",
            minimap: {
                enabled: false
            },
            guides: {
                indentation: false,
                bracketPairs: false,
                bracketPairsHorizontal: false,
                highlightActiveIndentation: false
            },
            folding: false,
            selectOnLineNumbers: false,
            selectionHighlight: false,
            columnSelection: false,
            overviewRulerBorder: false,
            overviewRulerLanes: 0,
            lineDecorationsWidth: 0,
            lineNumbersMinChars: 0
        }, {
            contributions: []
        }, this._editor));
        this._previewEditorObs = (0, _observableCodeEditorJs.observableCodeEditor)(this._previewEditor);
        this._decorations = (0, _observableJs.derived)(this, (reader)=>{
            this._setText.read(reader);
            const diff = this._edit.read(reader)?.changes;
            if (!diff) return [];
            const originalDecorations = [];
            const modifiedDecorations = [];
            if (diff.length === 1 && diff[0].innerChanges[0].modifiedRange.equalsRange(this._previewTextModel.getFullModelRange())) return [];
            for (const m of diff){
                if (!m.original.isEmpty) originalDecorations.push({
                    range: m.original.toInclusiveRange(),
                    options: (0, _registrationsContributionJs.diffLineDeleteDecorationBackgroundWithIndicator)
                });
                if (!m.modified.isEmpty) modifiedDecorations.push({
                    range: m.modified.toInclusiveRange(),
                    options: (0, _registrationsContributionJs.diffLineAddDecorationBackgroundWithIndicator)
                });
                if (m.modified.isEmpty || m.original.isEmpty) {
                    if (!m.original.isEmpty) originalDecorations.push({
                        range: m.original.toInclusiveRange(),
                        options: (0, _registrationsContributionJs.diffWholeLineDeleteDecoration)
                    });
                    if (!m.modified.isEmpty) modifiedDecorations.push({
                        range: m.modified.toInclusiveRange(),
                        options: (0, _registrationsContributionJs.diffWholeLineAddDecoration)
                    });
                } else for (const i of m.innerChanges || []){
                    // Don't show empty markers outside the line range
                    if (m.original.contains(i.originalRange.startLineNumber)) originalDecorations.push({
                        range: i.originalRange,
                        options: i.originalRange.isEmpty() ? (0, _registrationsContributionJs.diffDeleteDecorationEmpty) : (0, _registrationsContributionJs.diffDeleteDecoration)
                    });
                    if (m.modified.contains(i.modifiedRange.startLineNumber)) modifiedDecorations.push({
                        range: i.modifiedRange,
                        options: i.modifiedRange.isEmpty() ? (0, _registrationsContributionJs.diffAddDecorationEmpty) : (0, _registrationsContributionJs.diffAddDecoration)
                    });
                }
            }
            return modifiedDecorations;
        });
        this._layout1 = (0, _observableJs.derived)(this, (reader)=>{
            const model = this._editor.getModel();
            const inlineEdit = this._edit.read(reader);
            if (!inlineEdit) return null;
            const range = inlineEdit.range;
            let maxLeft = 0;
            for(let i = range.startLineNumber; i < range.endLineNumberExclusive; i++){
                const column = model.getLineMaxColumn(i);
                const left = this._editor.getOffsetForColumn(i, column);
                maxLeft = Math.max(maxLeft, left);
            }
            const layoutInfo = this._editor.getLayoutInfo();
            const contentLeft = layoutInfo.contentLeft;
            return {
                left: contentLeft + maxLeft
            };
        });
        this._layout = (0, _observableJs.derived)(this, (reader)=>{
            const inlineEdit = this._edit.read(reader);
            if (!inlineEdit) return null;
            const range = inlineEdit.range;
            const scrollLeft = this._editorObs.scrollLeft.read(reader);
            const left = this._layout1.read(reader).left + 20 - scrollLeft;
            const selectionTop = this._editor.getTopForLineNumber(range.startLineNumber) - this._editorObs.scrollTop.read(reader);
            const selectionBottom = this._editor.getTopForLineNumber(range.endLineNumberExclusive) - this._editorObs.scrollTop.read(reader);
            const topCode = new Point(left, selectionTop);
            const bottomCode = new Point(left, selectionBottom);
            const codeHeight = selectionBottom - selectionTop;
            const codeEditDist = 50;
            const editHeight = this._editor.getOption(67 /* EditorOption.lineHeight */ ) * inlineEdit.newLines.length;
            const difference = codeHeight - editHeight;
            const topEdit = new Point(left + codeEditDist, selectionTop + difference / 2);
            const bottomEdit = new Point(left + codeEditDist, selectionBottom - difference / 2);
            return {
                topCode,
                bottomCode,
                codeHeight,
                topEdit,
                bottomEdit,
                editHeight
            };
        });
        const visible = (0, _observableJs.derived)(this, (reader)=>this._edit.read(reader) !== undefined || this._userPrompt.read(reader) !== undefined);
        this._register((0, _utilsJs.applyStyle)(this._elements.root, {
            display: (0, _observableJs.derived)(this, (reader)=>visible.read(reader) ? "block" : "none")
        }));
        this._register((0, _utilsJs.appendRemoveOnDispose)(this._editor.getDomNode(), this._elements.root));
        this._register((0, _observableCodeEditorJs.observableCodeEditor)(_editor).createOverlayWidget({
            domNode: this._elements.root,
            position: (0, _observableJs.constObservable)(null),
            allowEditorOverflow: false,
            minContentWidthInPx: (0, _observableJs.derived)((reader)=>{
                const x = this._layout1.read(reader)?.left;
                if (x === undefined) return 0;
                const width = this._previewEditorObs.contentWidth.read(reader);
                return x + width;
            })
        }));
        this._previewEditor.setModel(this._previewTextModel);
        this._register(this._previewEditorObs.setDecorations(this._decorations));
        this._register((0, _observableJs.autorun)((reader)=>{
            const layoutInfo = this._layout.read(reader);
            if (!layoutInfo) return;
            const { topCode, bottomCode, topEdit, bottomEdit, editHeight } = layoutInfo;
            const straightWidthCode = 10;
            const straightWidthEdit = 0;
            const bezierDist = 40;
            const path = new PathBuilder().moveTo(topCode).lineTo(topCode.deltaX(straightWidthCode)).curveTo(topCode.deltaX(straightWidthCode + bezierDist), topEdit.deltaX(-bezierDist - straightWidthEdit), topEdit.deltaX(-straightWidthEdit)).lineTo(topEdit).lineTo(bottomEdit).lineTo(bottomEdit.deltaX(-straightWidthEdit)).curveTo(bottomEdit.deltaX(-bezierDist - straightWidthEdit), bottomCode.deltaX(straightWidthCode + bezierDist), bottomCode.deltaX(straightWidthCode)).lineTo(bottomCode).build();
            this._elements.path.setAttribute("d", path);
            this._elements.editorContainer.style.top = `${topEdit.y}px`;
            this._elements.editorContainer.style.left = `${topEdit.x}px`;
            this._elements.editorContainer.style.height = `${editHeight}px`;
            const width = this._previewEditorObs.contentWidth.read(reader);
            this._previewEditor.layout({
                height: editHeight,
                width
            });
        }));
        this._promptEditor.setModel(this._promptTextModel);
        this._promptEditor.layout();
        this._register(createTwoWaySync(mapSettableObservable(this._userPrompt, (v)=>v ?? "", (v)=>v), (0, _observableCodeEditorJs.observableCodeEditor)(this._promptEditor).value));
        this._register((0, _observableJs.autorun)((reader)=>{
            const isFocused = (0, _observableCodeEditorJs.observableCodeEditor)(this._promptEditor).isFocused.read(reader);
            this._elements.root.classList.toggle("focused", isFocused);
        }));
    }
};
InlineEditsWidget = __decorate([
    __param(3, (0, _instantiationJs.IInstantiationService))
], InlineEditsWidget);
function mapSettableObservable(obs, fn1, fn2) {
    return (0, _derivedJs.derivedWithSetter)(undefined, (reader)=>fn1(obs.read(reader)), (value, tx)=>obs.set(fn2(value), tx));
}
class Point {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    deltaX(delta) {
        return new Point(this.x + delta, this.y);
    }
}
class PathBuilder {
    constructor(){
        this._data = "";
    }
    moveTo(point) {
        this._data += `M ${point.x} ${point.y} `;
        return this;
    }
    lineTo(point) {
        this._data += `L ${point.x} ${point.y} `;
        return this;
    }
    curveTo(cp1, cp2, to) {
        this._data += `C ${cp1.x} ${cp1.y} ${cp2.x} ${cp2.y} ${to.x} ${to.y} `;
        return this;
    }
    build() {
        return this._data;
    }
}
function createTwoWaySync(main, target) {
    const store = new (0, _lifecycleJs.DisposableStore)();
    store.add((0, _observableJs.autorun)((reader)=>{
        const value = main.read(reader);
        target.set(value, undefined);
    }));
    store.add((0, _observableJs.autorun)((reader)=>{
        const value = target.read(reader);
        main.set(value, undefined);
    }));
    return store;
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/fonts.js":"92j2K","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../../../base/common/observableInternal/derived.js":"hZb5S","./inlineEditsWidget.css":"i4oUI","../../../browser/editorExtensions.js":"kC3w6","../../../browser/observableCodeEditor.js":"hfBd1","../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js":"8G1ik","../../../browser/widget/diffEditor/registrations.contribution.js":"3EY0P","../../../browser/widget/diffEditor/utils.js":"2G3Lp","../../../common/languages/modesRegistry.js":"gqkb7","../../../common/model/textModel.js":"9beDe","../../contextmenu/browser/contextmenu.js":"dHaR7","../../placeholderText/browser/placeholderTextContribution.js":"8Akh2","../../suggest/browser/suggestController.js":"jcXag","../../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i4oUI":[function() {},{}],"8Akh2":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Use the editor option to set the placeholder text.
*/ parcelHelpers.export(exports, "PlaceholderTextContribution", ()=>PlaceholderTextContribution);
var _domJs = require("../../../../base/browser/dom.js");
var _equalsJs = require("../../../../base/common/equals.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _observableJs = require("../../../../base/common/observable.js");
var _derivedJs = require("../../../../base/common/observableInternal/derived.js");
var _observableCodeEditorJs = require("../../../browser/observableCodeEditor.js");
class PlaceholderTextContribution extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.placeholderText";
    }
    constructor(_editor){
        super();
        this._editor = _editor;
        this._editorObs = (0, _observableCodeEditorJs.observableCodeEditor)(this._editor);
        this._placeholderText = this._editorObs.getOption(88 /* EditorOption.placeholder */ );
        this._state = (0, _observableJs.derivedOpts)({
            owner: this,
            equalsFn: (0, _equalsJs.structuralEquals)
        }, (reader)=>{
            const p = this._placeholderText.read(reader);
            if (!p) return undefined;
            if (!this._editorObs.valueIsEmpty.read(reader)) return undefined;
            return {
                placeholder: p
            };
        });
        this._shouldViewBeAlive = isOrWasTrue(this, (reader)=>this._state.read(reader)?.placeholder !== undefined);
        this._view = (0, _derivedJs.derivedWithStore)((reader, store)=>{
            if (!this._shouldViewBeAlive.read(reader)) return;
            const element = (0, _domJs.h)("div.editorPlaceholder");
            store.add((0, _observableJs.autorun)((reader)=>{
                const data = this._state.read(reader);
                const shouldBeVisibile = data?.placeholder !== undefined;
                element.root.style.display = shouldBeVisibile ? "block" : "none";
                element.root.innerText = data?.placeholder ?? "";
            }));
            store.add((0, _observableJs.autorun)((reader)=>{
                const info = this._editorObs.layoutInfo.read(reader);
                element.root.style.left = `${info.contentLeft}px`;
                element.root.style.width = info.contentWidth - info.verticalScrollbarWidth + "px";
                element.root.style.top = `${this._editor.getTopForLineNumber(0)}px`;
            }));
            store.add((0, _observableJs.autorun)((reader)=>{
                element.root.style.fontFamily = this._editorObs.getOption(49 /* EditorOption.fontFamily */ ).read(reader);
                element.root.style.fontSize = this._editorObs.getOption(52 /* EditorOption.fontSize */ ).read(reader) + "px";
                element.root.style.lineHeight = this._editorObs.getOption(67 /* EditorOption.lineHeight */ ).read(reader) + "px";
            }));
            store.add(this._editorObs.createOverlayWidget({
                allowEditorOverflow: false,
                minContentWidthInPx: (0, _observableJs.constObservable)(0),
                position: (0, _observableJs.constObservable)(null),
                domNode: element.root
            }));
        });
        this._view.recomputeInitiallyAndOnChange(this._store);
    }
}
function isOrWasTrue(owner, fn) {
    return (0, _observableJs.derivedObservableWithCache)(owner, (reader, lastValue)=>{
        if (lastValue === true) return true;
        return fn(reader);
    });
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/common/equals.js":"8hes7","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/observable.js":"2xbG5","../../../../base/common/observableInternal/derived.js":"hZb5S","../../../browser/observableCodeEditor.js":"hfBd1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8QJnf":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParameterHintsController", ()=>ParameterHintsController);
parcelHelpers.export(exports, "TriggerParameterHintsAction", ()=>TriggerParameterHintsAction);
var _lazyJs = require("../../../../base/common/lazy.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _languagesJs = require("../../../common/languages.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _parameterHintsModelJs = require("./parameterHintsModel.js");
var _provideSignatureHelpJs = require("./provideSignatureHelp.js");
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _parameterHintsWidgetJs = require("./parameterHintsWidget.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var ParameterHintsController_1;
let ParameterHintsController = class ParameterHintsController extends (0, _lifecycleJs.Disposable) {
    static{
        ParameterHintsController_1 = this;
    }
    static{
        this.ID = "editor.controller.parameterHints";
    }
    static get(editor) {
        return editor.getContribution(ParameterHintsController_1.ID);
    }
    constructor(editor, instantiationService, languageFeaturesService){
        super();
        this.editor = editor;
        this.model = this._register(new (0, _parameterHintsModelJs.ParameterHintsModel)(editor, languageFeaturesService.signatureHelpProvider));
        this._register(this.model.onChangedHints((newParameterHints)=>{
            if (newParameterHints) {
                this.widget.value.show();
                this.widget.value.render(newParameterHints);
            } else this.widget.rawValue?.hide();
        }));
        this.widget = new (0, _lazyJs.Lazy)(()=>this._register(instantiationService.createInstance((0, _parameterHintsWidgetJs.ParameterHintsWidget), this.editor, this.model)));
    }
    cancel() {
        this.model.cancel();
    }
    previous() {
        this.widget.rawValue?.previous();
    }
    next() {
        this.widget.rawValue?.next();
    }
    trigger(context) {
        this.model.trigger(context, 0);
    }
};
ParameterHintsController = ParameterHintsController_1 = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService)),
    __param(2, (0, _languageFeaturesJs.ILanguageFeaturesService))
], ParameterHintsController);
class TriggerParameterHintsAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.triggerParameterHints",
            label: _nlsJs.localize("parameterHints.trigger.label", "Trigger Parameter Hints"),
            alias: "Trigger Parameter Hints",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hasSignatureHelpProvider,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 3082 /* KeyCode.Space */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(accessor, editor) {
        const controller = ParameterHintsController.get(editor);
        controller?.trigger({
            triggerKind: _languagesJs.SignatureHelpTriggerKind.Invoke
        });
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(ParameterHintsController.ID, ParameterHintsController, 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );
(0, _editorExtensionsJs.registerEditorAction)(TriggerParameterHintsAction);
const weight = 175;
const ParameterHintsCommand = (0, _editorExtensionsJs.EditorCommand).bindToContribution(ParameterHintsController.get);
(0, _editorExtensionsJs.registerEditorCommand)(new ParameterHintsCommand({
    id: "closeParameterHints",
    precondition: (0, _provideSignatureHelpJs.Context).Visible,
    handler: (x)=>x.cancel(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: 9 /* KeyCode.Escape */ ,
        secondary: [
            1033 /* KeyCode.Escape */ 
        ]
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new ParameterHintsCommand({
    id: "showPrevParameterHint",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _provideSignatureHelpJs.Context).Visible, (0, _provideSignatureHelpJs.Context).MultipleSignatures),
    handler: (x)=>x.previous(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: 16 /* KeyCode.UpArrow */ ,
        secondary: [
            528 /* KeyCode.UpArrow */ 
        ],
        mac: {
            primary: 16 /* KeyCode.UpArrow */ ,
            secondary: [
                528 /* KeyCode.UpArrow */ ,
                302 /* KeyCode.KeyP */ 
            ]
        }
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new ParameterHintsCommand({
    id: "showNextParameterHint",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _provideSignatureHelpJs.Context).Visible, (0, _provideSignatureHelpJs.Context).MultipleSignatures),
    handler: (x)=>x.next(),
    kbOpts: {
        weight: weight,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: 18 /* KeyCode.DownArrow */ ,
        secondary: [
            530 /* KeyCode.DownArrow */ 
        ],
        mac: {
            primary: 18 /* KeyCode.DownArrow */ ,
            secondary: [
                530 /* KeyCode.DownArrow */ ,
                300 /* KeyCode.KeyN */ 
            ]
        }
    }
}));

},{"../../../../base/common/lazy.js":"6e57N","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorExtensions.js":"kC3w6","../../../common/editorContextKeys.js":"5exv9","../../../common/languages.js":"g5n96","../../../common/services/languageFeatures.js":"2IAko","./parameterHintsModel.js":"ipLSK","./provideSignatureHelp.js":"4wk0I","../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","./parameterHintsWidget.js":"8HYiJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ipLSK":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParameterHintsModel", ()=>ParameterHintsModel);
var _asyncJs = require("../../../../base/common/async.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _characterClassifierJs = require("../../../common/core/characterClassifier.js");
var _languagesJs = require("../../../common/languages.js");
var _provideSignatureHelpJs = require("./provideSignatureHelp.js");
var ParameterHintState;
(function(ParameterHintState) {
    ParameterHintState.Default = {
        type: 0 /* Type.Default */ 
    };
    class Pending {
        constructor(request, previouslyActiveHints){
            this.request = request;
            this.previouslyActiveHints = previouslyActiveHints;
            this.type = 2 /* Type.Pending */ ;
        }
    }
    ParameterHintState.Pending = Pending;
    class Active {
        constructor(hints){
            this.hints = hints;
            this.type = 1 /* Type.Active */ ;
        }
    }
    ParameterHintState.Active = Active;
})(ParameterHintState || (ParameterHintState = {}));
class ParameterHintsModel extends (0, _lifecycleJs.Disposable) {
    static{
        this.DEFAULT_DELAY = 120;
    }
    constructor(editor, providers, delay = ParameterHintsModel.DEFAULT_DELAY){
        super();
        this._onChangedHints = this._register(new (0, _eventJs.Emitter)());
        this.onChangedHints = this._onChangedHints.event;
        this.triggerOnType = false;
        this._state = ParameterHintState.Default;
        this._pendingTriggers = [];
        this._lastSignatureHelpResult = this._register(new (0, _lifecycleJs.MutableDisposable)());
        this.triggerChars = new (0, _characterClassifierJs.CharacterSet)();
        this.retriggerChars = new (0, _characterClassifierJs.CharacterSet)();
        this.triggerId = 0;
        this.editor = editor;
        this.providers = providers;
        this.throttledDelayer = new (0, _asyncJs.Delayer)(delay);
        this._register(this.editor.onDidBlurEditorWidget(()=>this.cancel()));
        this._register(this.editor.onDidChangeConfiguration(()=>this.onEditorConfigurationChange()));
        this._register(this.editor.onDidChangeModel((e)=>this.onModelChanged()));
        this._register(this.editor.onDidChangeModelLanguage((_)=>this.onModelChanged()));
        this._register(this.editor.onDidChangeCursorSelection((e)=>this.onCursorChange(e)));
        this._register(this.editor.onDidChangeModelContent((e)=>this.onModelContentChange()));
        this._register(this.providers.onDidChange(this.onModelChanged, this));
        this._register(this.editor.onDidType((text)=>this.onDidType(text)));
        this.onEditorConfigurationChange();
        this.onModelChanged();
    }
    get state() {
        return this._state;
    }
    set state(value) {
        if (this._state.type === 2 /* ParameterHintState.Type.Pending */ ) this._state.request.cancel();
        this._state = value;
    }
    cancel(silent = false) {
        this.state = ParameterHintState.Default;
        this.throttledDelayer.cancel();
        if (!silent) this._onChangedHints.fire(undefined);
    }
    trigger(context, delay) {
        const model = this.editor.getModel();
        if (!model || !this.providers.has(model)) return;
        const triggerId = ++this.triggerId;
        this._pendingTriggers.push(context);
        this.throttledDelayer.trigger(()=>{
            return this.doTrigger(triggerId);
        }, delay).catch((0, _errorsJs.onUnexpectedError));
    }
    next() {
        if (this.state.type !== 1 /* ParameterHintState.Type.Active */ ) return;
        const length = this.state.hints.signatures.length;
        const activeSignature = this.state.hints.activeSignature;
        const last = activeSignature % length === length - 1;
        const cycle = this.editor.getOption(86 /* EditorOption.parameterHints */ ).cycle;
        // If there is only one signature, or we're on last signature of list
        if ((length < 2 || last) && !cycle) {
            this.cancel();
            return;
        }
        this.updateActiveSignature(last && cycle ? 0 : activeSignature + 1);
    }
    previous() {
        if (this.state.type !== 1 /* ParameterHintState.Type.Active */ ) return;
        const length = this.state.hints.signatures.length;
        const activeSignature = this.state.hints.activeSignature;
        const first = activeSignature === 0;
        const cycle = this.editor.getOption(86 /* EditorOption.parameterHints */ ).cycle;
        // If there is only one signature, or we're on first signature of list
        if ((length < 2 || first) && !cycle) {
            this.cancel();
            return;
        }
        this.updateActiveSignature(first && cycle ? length - 1 : activeSignature - 1);
    }
    updateActiveSignature(activeSignature) {
        if (this.state.type !== 1 /* ParameterHintState.Type.Active */ ) return;
        this.state = new ParameterHintState.Active({
            ...this.state.hints,
            activeSignature
        });
        this._onChangedHints.fire(this.state.hints);
    }
    async doTrigger(triggerId) {
        const isRetrigger = this.state.type === 1 /* ParameterHintState.Type.Active */  || this.state.type === 2 /* ParameterHintState.Type.Pending */ ;
        const activeSignatureHelp = this.getLastActiveHints();
        this.cancel(true);
        if (this._pendingTriggers.length === 0) return false;
        const context = this._pendingTriggers.reduce(mergeTriggerContexts);
        this._pendingTriggers = [];
        const triggerContext = {
            triggerKind: context.triggerKind,
            triggerCharacter: context.triggerCharacter,
            isRetrigger: isRetrigger,
            activeSignatureHelp: activeSignatureHelp
        };
        if (!this.editor.hasModel()) return false;
        const model = this.editor.getModel();
        const position = this.editor.getPosition();
        this.state = new ParameterHintState.Pending((0, _asyncJs.createCancelablePromise)((token)=>(0, _provideSignatureHelpJs.provideSignatureHelp)(this.providers, model, position, triggerContext, token)), activeSignatureHelp);
        try {
            const result = await this.state.request;
            // Check that we are still resolving the correct signature help
            if (triggerId !== this.triggerId) {
                result?.dispose();
                return false;
            }
            if (!result || !result.value.signatures || result.value.signatures.length === 0) {
                result?.dispose();
                this._lastSignatureHelpResult.clear();
                this.cancel();
                return false;
            } else {
                this.state = new ParameterHintState.Active(result.value);
                this._lastSignatureHelpResult.value = result;
                this._onChangedHints.fire(this.state.hints);
                return true;
            }
        } catch (error) {
            if (triggerId === this.triggerId) this.state = ParameterHintState.Default;
            (0, _errorsJs.onUnexpectedError)(error);
            return false;
        }
    }
    getLastActiveHints() {
        switch(this.state.type){
            case 1 /* ParameterHintState.Type.Active */ :
                return this.state.hints;
            case 2 /* ParameterHintState.Type.Pending */ :
                return this.state.previouslyActiveHints;
            default:
                return undefined;
        }
    }
    get isTriggered() {
        return this.state.type === 1 /* ParameterHintState.Type.Active */  || this.state.type === 2 /* ParameterHintState.Type.Pending */  || this.throttledDelayer.isTriggered();
    }
    onModelChanged() {
        this.cancel();
        this.triggerChars.clear();
        this.retriggerChars.clear();
        const model = this.editor.getModel();
        if (!model) return;
        for (const support of this.providers.ordered(model)){
            for (const ch of support.signatureHelpTriggerCharacters || [])if (ch.length) {
                const charCode = ch.charCodeAt(0);
                this.triggerChars.add(charCode);
                // All trigger characters are also considered retrigger characters
                this.retriggerChars.add(charCode);
            }
            for (const ch of support.signatureHelpRetriggerCharacters || [])if (ch.length) this.retriggerChars.add(ch.charCodeAt(0));
        }
    }
    onDidType(text) {
        if (!this.triggerOnType) return;
        const lastCharIndex = text.length - 1;
        const triggerCharCode = text.charCodeAt(lastCharIndex);
        if (this.triggerChars.has(triggerCharCode) || this.isTriggered && this.retriggerChars.has(triggerCharCode)) this.trigger({
            triggerKind: _languagesJs.SignatureHelpTriggerKind.TriggerCharacter,
            triggerCharacter: text.charAt(lastCharIndex)
        });
    }
    onCursorChange(e) {
        if (e.source === "mouse") this.cancel();
        else if (this.isTriggered) this.trigger({
            triggerKind: _languagesJs.SignatureHelpTriggerKind.ContentChange
        });
    }
    onModelContentChange() {
        if (this.isTriggered) this.trigger({
            triggerKind: _languagesJs.SignatureHelpTriggerKind.ContentChange
        });
    }
    onEditorConfigurationChange() {
        this.triggerOnType = this.editor.getOption(86 /* EditorOption.parameterHints */ ).enabled;
        if (!this.triggerOnType) this.cancel();
    }
    dispose() {
        this.cancel(true);
        super.dispose();
    }
}
function mergeTriggerContexts(previous, current) {
    switch(current.triggerKind){
        case _languagesJs.SignatureHelpTriggerKind.Invoke:
            // Invoke overrides previous triggers.
            return current;
        case _languagesJs.SignatureHelpTriggerKind.ContentChange:
            // Ignore content changes triggers
            return previous;
        case _languagesJs.SignatureHelpTriggerKind.TriggerCharacter:
        default:
            return current;
    }
}

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/errors.js":"divX8","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../common/core/characterClassifier.js":"hl8tq","../../../common/languages.js":"g5n96","./provideSignatureHelp.js":"4wk0I","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4wk0I":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Context", ()=>Context);
parcelHelpers.export(exports, "provideSignatureHelp", ()=>provideSignatureHelp);
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _typesJs = require("../../../../base/common/types.js");
var _uriJs = require("../../../../base/common/uri.js");
var _positionJs = require("../../../common/core/position.js");
var _languagesJs = require("../../../common/languages.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _resolverServiceJs = require("../../../common/services/resolverService.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
const Context = {
    Visible: new (0, _contextkeyJs.RawContextKey)("parameterHintsVisible", false),
    MultipleSignatures: new (0, _contextkeyJs.RawContextKey)("parameterHintsMultipleSignatures", false)
};
async function provideSignatureHelp(registry, model, position, context, token) {
    const supports = registry.ordered(model);
    for (const support of supports)try {
        const result = await support.provideSignatureHelp(model, position, token, context);
        if (result) return result;
    } catch (err) {
        (0, _errorsJs.onUnexpectedExternalError)(err);
    }
    return undefined;
}
(0, _commandsJs.CommandsRegistry).registerCommand("_executeSignatureHelpProvider", async (accessor, ...args)=>{
    const [uri, position, triggerCharacter] = args;
    (0, _typesJs.assertType)((0, _uriJs.URI).isUri(uri));
    (0, _typesJs.assertType)((0, _positionJs.Position).isIPosition(position));
    (0, _typesJs.assertType)(typeof triggerCharacter === "string" || !triggerCharacter);
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const ref = await accessor.get((0, _resolverServiceJs.ITextModelService)).createModelReference(uri);
    try {
        const result = await provideSignatureHelp(languageFeaturesService.signatureHelpProvider, ref.object.textEditorModel, (0, _positionJs.Position).lift(position), {
            triggerKind: _languagesJs.SignatureHelpTriggerKind.Invoke,
            isRetrigger: false,
            triggerCharacter
        }, (0, _cancellationJs.CancellationToken).None);
        if (!result) return undefined;
        setTimeout(()=>result.dispose(), 0);
        return result.value;
    } finally{
        ref.dispose();
    }
});

},{"../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/types.js":"fb5yx","../../../../base/common/uri.js":"7qGS3","../../../common/core/position.js":"lvrPe","../../../common/languages.js":"g5n96","../../../common/services/languageFeatures.js":"2IAko","../../../common/services/resolverService.js":"ezAtF","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/contextkey/common/contextkey.js":"gXuBD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8HYiJ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParameterHintsWidget", ()=>ParameterHintsWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var _scrollableElementJs = require("../../../../base/browser/ui/scrollbar/scrollableElement.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _typesJs = require("../../../../base/common/types.js");
var _parameterHintsCss = require("./parameterHints.css");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
var _languageJs = require("../../../common/languages/language.js");
var _markdownRendererJs = require("../../../browser/widget/markdownRenderer/browser/markdownRenderer.js");
var _provideSignatureHelpJs = require("./provideSignatureHelp.js");
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _openerJs = require("../../../../platform/opener/common/opener.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _iconRegistryJs = require("../../../../platform/theme/common/iconRegistry.js");
var _themablesJs = require("../../../../base/common/themables.js");
var _stopwatchJs = require("../../../../base/common/stopwatch.js");
var _telemetryJs = require("../../../../platform/telemetry/common/telemetry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var ParameterHintsWidget_1;
const $ = _domJs.$;
const parameterHintsNextIcon = (0, _iconRegistryJs.registerIcon)("parameter-hints-next", (0, _codiconsJs.Codicon).chevronDown, _nlsJs.localize("parameterHintsNextIcon", "Icon for show next parameter hint."));
const parameterHintsPreviousIcon = (0, _iconRegistryJs.registerIcon)("parameter-hints-previous", (0, _codiconsJs.Codicon).chevronUp, _nlsJs.localize("parameterHintsPreviousIcon", "Icon for show previous parameter hint."));
let ParameterHintsWidget = class ParameterHintsWidget extends (0, _lifecycleJs.Disposable) {
    static{
        ParameterHintsWidget_1 = this;
    }
    static{
        this.ID = "editor.widget.parameterHintsWidget";
    }
    constructor(editor, model, contextKeyService, openerService, languageService, telemetryService){
        super();
        this.editor = editor;
        this.model = model;
        this.telemetryService = telemetryService;
        this.renderDisposeables = this._register(new (0, _lifecycleJs.DisposableStore)());
        this.visible = false;
        this.announcedLabel = null;
        // Editor.IContentWidget.allowEditorOverflow
        this.allowEditorOverflow = true;
        this.markdownRenderer = this._register(new (0, _markdownRendererJs.MarkdownRenderer)({
            editor
        }, languageService, openerService));
        this.keyVisible = (0, _provideSignatureHelpJs.Context).Visible.bindTo(contextKeyService);
        this.keyMultipleSignatures = (0, _provideSignatureHelpJs.Context).MultipleSignatures.bindTo(contextKeyService);
    }
    createParameterHintDOMNodes() {
        const element = $(".editor-widget.parameter-hints-widget");
        const wrapper = _domJs.append(element, $(".phwrapper"));
        wrapper.tabIndex = -1;
        const controls = _domJs.append(wrapper, $(".controls"));
        const previous = _domJs.append(controls, $(".button" + (0, _themablesJs.ThemeIcon).asCSSSelector(parameterHintsPreviousIcon)));
        const overloads = _domJs.append(controls, $(".overloads"));
        const next = _domJs.append(controls, $(".button" + (0, _themablesJs.ThemeIcon).asCSSSelector(parameterHintsNextIcon)));
        this._register(_domJs.addDisposableListener(previous, "click", (e)=>{
            _domJs.EventHelper.stop(e);
            this.previous();
        }));
        this._register(_domJs.addDisposableListener(next, "click", (e)=>{
            _domJs.EventHelper.stop(e);
            this.next();
        }));
        const body = $(".body");
        const scrollbar = new (0, _scrollableElementJs.DomScrollableElement)(body, {
            alwaysConsumeMouseWheel: true
        });
        this._register(scrollbar);
        wrapper.appendChild(scrollbar.getDomNode());
        const signature = _domJs.append(body, $(".signature"));
        const docs = _domJs.append(body, $(".docs"));
        element.style.userSelect = "text";
        this.domNodes = {
            element,
            signature,
            overloads,
            docs,
            scrollbar
        };
        this.editor.addContentWidget(this);
        this.hide();
        this._register(this.editor.onDidChangeCursorSelection((e)=>{
            if (this.visible) this.editor.layoutContentWidget(this);
        }));
        const updateFont = ()=>{
            if (!this.domNodes) return;
            const fontInfo = this.editor.getOption(50 /* EditorOption.fontInfo */ );
            const element = this.domNodes.element;
            element.style.fontSize = `${fontInfo.fontSize}px`;
            element.style.lineHeight = `${fontInfo.lineHeight / fontInfo.fontSize}`;
            element.style.setProperty("--vscode-parameterHintsWidget-editorFontFamily", fontInfo.fontFamily);
            element.style.setProperty("--vscode-parameterHintsWidget-editorFontFamilyDefault", (0, _editorOptionsJs.EDITOR_FONT_DEFAULTS).fontFamily);
        };
        updateFont();
        this._register((0, _eventJs.Event).chain(this.editor.onDidChangeConfiguration.bind(this.editor), ($)=>$.filter((e)=>e.hasChanged(50 /* EditorOption.fontInfo */ )))(updateFont));
        this._register(this.editor.onDidLayoutChange((e)=>this.updateMaxHeight()));
        this.updateMaxHeight();
    }
    show() {
        if (this.visible) return;
        if (!this.domNodes) this.createParameterHintDOMNodes();
        this.keyVisible.set(true);
        this.visible = true;
        setTimeout(()=>{
            this.domNodes?.element.classList.add("visible");
        }, 100);
        this.editor.layoutContentWidget(this);
    }
    hide() {
        this.renderDisposeables.clear();
        if (!this.visible) return;
        this.keyVisible.reset();
        this.visible = false;
        this.announcedLabel = null;
        this.domNodes?.element.classList.remove("visible");
        this.editor.layoutContentWidget(this);
    }
    getPosition() {
        if (this.visible) return {
            position: this.editor.getPosition(),
            preference: [
                1 /* ContentWidgetPositionPreference.ABOVE */ ,
                2 /* ContentWidgetPositionPreference.BELOW */ 
            ]
        };
        return null;
    }
    render(hints) {
        this.renderDisposeables.clear();
        if (!this.domNodes) return;
        const multiple = hints.signatures.length > 1;
        this.domNodes.element.classList.toggle("multiple", multiple);
        this.keyMultipleSignatures.set(multiple);
        this.domNodes.signature.innerText = "";
        this.domNodes.docs.innerText = "";
        const signature = hints.signatures[hints.activeSignature];
        if (!signature) return;
        const code = _domJs.append(this.domNodes.signature, $(".code"));
        const hasParameters = signature.parameters.length > 0;
        const activeParameterIndex = signature.activeParameter ?? hints.activeParameter;
        if (!hasParameters) {
            const label = _domJs.append(code, $("span"));
            label.textContent = signature.label;
        } else this.renderParameters(code, signature, activeParameterIndex);
        const activeParameter = signature.parameters[activeParameterIndex];
        if (activeParameter?.documentation) {
            const documentation = $("span.documentation");
            if (typeof activeParameter.documentation === "string") documentation.textContent = activeParameter.documentation;
            else {
                const renderedContents = this.renderMarkdownDocs(activeParameter.documentation);
                documentation.appendChild(renderedContents.element);
            }
            _domJs.append(this.domNodes.docs, $("p", {}, documentation));
        }
        if (signature.documentation === undefined) ;
        else if (typeof signature.documentation === "string") _domJs.append(this.domNodes.docs, $("p", {}, signature.documentation));
        else {
            const renderedContents = this.renderMarkdownDocs(signature.documentation);
            _domJs.append(this.domNodes.docs, renderedContents.element);
        }
        const hasDocs = this.hasDocs(signature, activeParameter);
        this.domNodes.signature.classList.toggle("has-docs", hasDocs);
        this.domNodes.docs.classList.toggle("empty", !hasDocs);
        this.domNodes.overloads.textContent = String(hints.activeSignature + 1).padStart(hints.signatures.length.toString().length, "0") + "/" + hints.signatures.length;
        if (activeParameter) {
            let labelToAnnounce = "";
            const param = signature.parameters[activeParameterIndex];
            if (Array.isArray(param.label)) labelToAnnounce = signature.label.substring(param.label[0], param.label[1]);
            else labelToAnnounce = param.label;
            if (param.documentation) labelToAnnounce += typeof param.documentation === "string" ? `, ${param.documentation}` : `, ${param.documentation.value}`;
            if (signature.documentation) labelToAnnounce += typeof signature.documentation === "string" ? `, ${signature.documentation}` : `, ${signature.documentation.value}`;
            // Select method gets called on every user type while parameter hints are visible.
            // We do not want to spam the user with same announcements, so we only announce if the current parameter changed.
            if (this.announcedLabel !== labelToAnnounce) {
                _ariaJs.alert(_nlsJs.localize("hint", "{0}, hint", labelToAnnounce));
                this.announcedLabel = labelToAnnounce;
            }
        }
        this.editor.layoutContentWidget(this);
        this.domNodes.scrollbar.scanDomNode();
    }
    renderMarkdownDocs(markdown) {
        const stopWatch = new (0, _stopwatchJs.StopWatch)();
        const renderedContents = this.renderDisposeables.add(this.markdownRenderer.render(markdown, {
            asyncRenderCallback: ()=>{
                this.domNodes?.scrollbar.scanDomNode();
            }
        }));
        renderedContents.element.classList.add("markdown-docs");
        const renderDuration = stopWatch.elapsed();
        if (renderDuration > 300) this.telemetryService.publicLog2("parameterHints.parseMarkdown", {
            renderDuration
        });
        return renderedContents;
    }
    hasDocs(signature, activeParameter) {
        if (activeParameter && typeof activeParameter.documentation === "string" && (0, _typesJs.assertIsDefined)(activeParameter.documentation).length > 0) return true;
        if (activeParameter && typeof activeParameter.documentation === "object" && (0, _typesJs.assertIsDefined)(activeParameter.documentation).value.length > 0) return true;
        if (signature.documentation && typeof signature.documentation === "string" && (0, _typesJs.assertIsDefined)(signature.documentation).length > 0) return true;
        if (signature.documentation && typeof signature.documentation === "object" && (0, _typesJs.assertIsDefined)(signature.documentation.value).length > 0) return true;
        return false;
    }
    renderParameters(parent, signature, activeParameterIndex) {
        const [start, end] = this.getParameterLabelOffsets(signature, activeParameterIndex);
        const beforeSpan = document.createElement("span");
        beforeSpan.textContent = signature.label.substring(0, start);
        const paramSpan = document.createElement("span");
        paramSpan.textContent = signature.label.substring(start, end);
        paramSpan.className = "parameter active";
        const afterSpan = document.createElement("span");
        afterSpan.textContent = signature.label.substring(end);
        _domJs.append(parent, beforeSpan, paramSpan, afterSpan);
    }
    getParameterLabelOffsets(signature, paramIdx) {
        const param = signature.parameters[paramIdx];
        if (!param) return [
            0,
            0
        ];
        else if (Array.isArray(param.label)) return param.label;
        else if (!param.label.length) return [
            0,
            0
        ];
        else {
            const regex = new RegExp(`(\\W|^)${(0, _stringsJs.escapeRegExpCharacters)(param.label)}(?=\\W|$)`, "g");
            regex.test(signature.label);
            const idx = regex.lastIndex - param.label.length;
            return idx >= 0 ? [
                idx,
                regex.lastIndex
            ] : [
                0,
                0
            ];
        }
    }
    next() {
        this.editor.focus();
        this.model.next();
    }
    previous() {
        this.editor.focus();
        this.model.previous();
    }
    getDomNode() {
        if (!this.domNodes) this.createParameterHintDOMNodes();
        return this.domNodes.element;
    }
    getId() {
        return ParameterHintsWidget_1.ID;
    }
    updateMaxHeight() {
        if (!this.domNodes) return;
        const height = Math.max(this.editor.getLayoutInfo().height / 4, 250);
        const maxHeight = `${height}px`;
        this.domNodes.element.style.maxHeight = maxHeight;
        const wrapper = this.domNodes.element.getElementsByClassName("phwrapper");
        if (wrapper.length) wrapper[0].style.maxHeight = maxHeight;
    }
};
ParameterHintsWidget = ParameterHintsWidget_1 = __decorate([
    __param(2, (0, _contextkeyJs.IContextKeyService)),
    __param(3, (0, _openerJs.IOpenerService)),
    __param(4, (0, _languageJs.ILanguageService)),
    __param(5, (0, _telemetryJs.ITelemetryService))
], ParameterHintsWidget);
(0, _colorRegistryJs.registerColor)("editorHoverWidget.highlightForeground", (0, _colorRegistryJs.listHighlightForeground), _nlsJs.localize("editorHoverWidgetHighlightForeground", "Foreground color of the active item in the parameter hint."));

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/aria/aria.js":"asrsh","../../../../base/browser/ui/scrollbar/scrollableElement.js":"h1C5l","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/strings.js":"aA9I1","../../../../base/common/types.js":"fb5yx","./parameterHints.css":"utLFD","../../../common/config/editorOptions.js":"3Xi00","../../../common/languages/language.js":"ka2JQ","../../../browser/widget/markdownRenderer/browser/markdownRenderer.js":"34xfZ","./provideSignatureHelp.js":"4wk0I","../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/opener/common/opener.js":"d3tj1","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/iconRegistry.js":"bRNEz","../../../../base/common/themables.js":"hgyHi","../../../../base/common/stopwatch.js":"77PF9","../../../../platform/telemetry/common/telemetry.js":"7vW8j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"utLFD":[function() {},{}],"jiZEv":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _placeholderTextCss = require("./placeholderText.css");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorColorRegistryJs = require("../../../common/core/editorColorRegistry.js");
var _nlsJs = require("../../../../nls.js");
var _colorUtilsJs = require("../../../../platform/theme/common/colorUtils.js");
var _placeholderTextContributionJs = require("./placeholderTextContribution.js");
var _wrapInReloadableClassJs = require("../../../../platform/observable/common/wrapInReloadableClass.js");
(0, _editorExtensionsJs.registerEditorContribution)((0, _placeholderTextContributionJs.PlaceholderTextContribution).ID, (0, _wrapInReloadableClassJs.wrapInReloadableClass1)(()=>(0, _placeholderTextContributionJs.PlaceholderTextContribution)), 0 /* EditorContributionInstantiation.Eager */ );
(0, _colorUtilsJs.registerColor)("editor.placeholder.foreground", (0, _editorColorRegistryJs.ghostTextForeground), (0, _nlsJs.localize)("placeholderForeground", "Foreground color of the placeholder text in the editor."));

},{"./placeholderText.css":"cAxVE","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/editorColorRegistry.js":"5XqtL","../../../../nls.js":"l617d","../../../../platform/theme/common/colorUtils.js":"7VkBg","./placeholderTextContribution.js":"8Akh2","../../../../platform/observable/common/wrapInReloadableClass.js":"9waox"}],"cAxVE":[function() {},{}],"9waox":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Wrap a class in a reloadable wrapper.
 * When the wrapper is created, the original class is created.
 * When the original class changes, the instance is re-created.
*/ parcelHelpers.export(exports, "wrapInReloadableClass1", ()=>wrapInReloadableClass1);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _hotReloadJs = require("../../../base/common/hotReload.js");
var _hotReloadHelpersJs = require("../../../base/common/hotReloadHelpers.js");
var _observableJs = require("../../../base/common/observable.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class BaseClass {
    constructor(instantiationService){
        this.instantiationService = instantiationService;
    }
    init(...params) {}
}
function createWrapper(getClass, B) {
    return class ReloadableWrapper extends B {
        constructor(){
            super(...arguments);
            this._autorun = undefined;
        }
        init(...params) {
            this._autorun = (0, _observableJs.autorunWithStore)((reader, store)=>{
                const clazz = (0, _hotReloadHelpersJs.readHotReloadableExport)(getClass(), reader);
                store.add(this.instantiationService.createInstance(clazz, ...params));
            });
        }
        dispose() {
            this._autorun?.dispose();
        }
    };
}
function wrapInReloadableClass1(getClass) {
    return !(0, _hotReloadJs.isHotReloadEnabled)() ? getClass() : createWrapper(getClass, BaseClass1);
}
let BaseClass1 = class BaseClass1 extends BaseClass {
    constructor(param1, i){
        super(i);
        this.init(param1);
    }
};
BaseClass1 = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService))
], BaseClass1);

},{"../../../base/common/hotReload.js":"hjduU","../../../base/common/hotReloadHelpers.js":"3t1eI","../../../base/common/observable.js":"2xbG5","../../instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4nbx0":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rename", ()=>rename);
// ---- action implementation
parcelHelpers.export(exports, "RenameAction", ()=>RenameAction);
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _htmlContentJs = require("../../../../base/common/htmlContent.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _typesJs = require("../../../../base/common/types.js");
var _uriJs = require("../../../../base/common/uri.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _bulkEditServiceJs = require("../../../browser/services/bulkEditService.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _languagesJs = require("../../../common/languages.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _textResourceConfigurationJs = require("../../../common/services/textResourceConfiguration.js");
var _editorStateJs = require("../../editorState/browser/editorState.js");
var _messageControllerJs = require("../../message/browser/messageController.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _configurationRegistryJs = require("../../../../platform/configuration/common/configurationRegistry.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _logJs = require("../../../../platform/log/common/log.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var _progressJs = require("../../../../platform/progress/common/progress.js");
var _platformJs = require("../../../../platform/registry/common/platform.js");
var _telemetryJs = require("../../../../platform/telemetry/common/telemetry.js");
var _renameWidgetJs = require("./renameWidget.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var RenameController_1;
class RenameSkeleton {
    constructor(model, position, registry){
        this.model = model;
        this.position = position;
        this._providerRenameIdx = 0;
        this._providers = registry.ordered(model);
    }
    hasProvider() {
        return this._providers.length > 0;
    }
    async resolveRenameLocation(token) {
        const rejects = [];
        for(this._providerRenameIdx = 0; this._providerRenameIdx < this._providers.length; this._providerRenameIdx++){
            const provider = this._providers[this._providerRenameIdx];
            if (!provider.resolveRenameLocation) break;
            const res = await provider.resolveRenameLocation(this.model, this.position, token);
            if (!res) continue;
            if (res.rejectReason) {
                rejects.push(res.rejectReason);
                continue;
            }
            return res;
        }
        // we are here when no provider prepared a location which means we can
        // just rely on the word under cursor and start with the first provider
        this._providerRenameIdx = 0;
        const word = this.model.getWordAtPosition(this.position);
        if (!word) return {
            range: (0, _rangeJs.Range).fromPositions(this.position),
            text: "",
            rejectReason: rejects.length > 0 ? rejects.join("\n") : undefined
        };
        return {
            range: new (0, _rangeJs.Range)(this.position.lineNumber, word.startColumn, this.position.lineNumber, word.endColumn),
            text: word.word,
            rejectReason: rejects.length > 0 ? rejects.join("\n") : undefined
        };
    }
    async provideRenameEdits(newName, token) {
        return this._provideRenameEdits(newName, this._providerRenameIdx, [], token);
    }
    async _provideRenameEdits(newName, i, rejects, token) {
        const provider = this._providers[i];
        if (!provider) return {
            edits: [],
            rejectReason: rejects.join("\n")
        };
        const result = await provider.provideRenameEdits(this.model, this.position, newName, token);
        if (!result) return this._provideRenameEdits(newName, i + 1, rejects.concat(_nlsJs.localize("no result", "No result.")), token);
        else if (result.rejectReason) return this._provideRenameEdits(newName, i + 1, rejects.concat(result.rejectReason), token);
        return result;
    }
}
async function rename(registry, model, position, newName) {
    const skeleton = new RenameSkeleton(model, position, registry);
    const loc = await skeleton.resolveRenameLocation((0, _cancellationJs.CancellationToken).None);
    if (loc?.rejectReason) return {
        edits: [],
        rejectReason: loc.rejectReason
    };
    return skeleton.provideRenameEdits(newName, (0, _cancellationJs.CancellationToken).None);
}
// ---  register actions and commands
let RenameController = class RenameController {
    static{
        RenameController_1 = this;
    }
    static{
        this.ID = "editor.contrib.renameController";
    }
    static get(editor) {
        return editor.getContribution(RenameController_1.ID);
    }
    constructor(editor, _instaService, _notificationService, _bulkEditService, _progressService, _logService, _configService, _languageFeaturesService, _telemetryService){
        this.editor = editor;
        this._instaService = _instaService;
        this._notificationService = _notificationService;
        this._bulkEditService = _bulkEditService;
        this._progressService = _progressService;
        this._logService = _logService;
        this._configService = _configService;
        this._languageFeaturesService = _languageFeaturesService;
        this._telemetryService = _telemetryService;
        this._disposableStore = new (0, _lifecycleJs.DisposableStore)();
        this._cts = new (0, _cancellationJs.CancellationTokenSource)();
        this._renameWidget = this._disposableStore.add(this._instaService.createInstance((0, _renameWidgetJs.RenameWidget), this.editor, [
            "acceptRenameInput",
            "acceptRenameInputWithPreview"
        ]));
    }
    dispose() {
        this._disposableStore.dispose();
        this._cts.dispose(true);
    }
    async run() {
        const trace = this._logService.trace.bind(this._logService, "[rename]");
        // set up cancellation token to prevent reentrant rename, this
        // is the parent to the resolve- and rename-tokens
        this._cts.dispose(true);
        this._cts = new (0, _cancellationJs.CancellationTokenSource)();
        if (!this.editor.hasModel()) {
            trace("editor has no model");
            return undefined;
        }
        const position = this.editor.getPosition();
        const skeleton = new RenameSkeleton(this.editor.getModel(), position, this._languageFeaturesService.renameProvider);
        if (!skeleton.hasProvider()) {
            trace("skeleton has no provider");
            return undefined;
        }
        // part 1 - resolve rename location
        const cts1 = new (0, _editorStateJs.EditorStateCancellationTokenSource)(this.editor, 5 /* CodeEditorStateFlag.Value */ , undefined, this._cts.token);
        let loc;
        try {
            trace("resolving rename location");
            const resolveLocationOperation = skeleton.resolveRenameLocation(cts1.token);
            this._progressService.showWhile(resolveLocationOperation, 250);
            loc = await resolveLocationOperation;
            trace("resolved rename location");
        } catch (e) {
            if (e instanceof (0, _errorsJs.CancellationError)) trace("resolve rename location cancelled", JSON.stringify(e, null, "	"));
            else {
                trace("resolve rename location failed", e instanceof Error ? e : JSON.stringify(e, null, "	"));
                if (typeof e === "string" || (0, _htmlContentJs.isMarkdownString)(e)) (0, _messageControllerJs.MessageController).get(this.editor)?.showMessage(e || _nlsJs.localize("resolveRenameLocationFailed", "An unknown error occurred while resolving rename location"), position);
            }
            return undefined;
        } finally{
            cts1.dispose();
        }
        if (!loc) {
            trace("returning early - no loc");
            return undefined;
        }
        if (loc.rejectReason) {
            trace(`returning early - rejected with reason: ${loc.rejectReason}`, loc.rejectReason);
            (0, _messageControllerJs.MessageController).get(this.editor)?.showMessage(loc.rejectReason, position);
            return undefined;
        }
        if (cts1.token.isCancellationRequested) {
            trace("returning early - cts1 cancelled");
            return undefined;
        }
        // part 2 - do rename at location
        const cts2 = new (0, _editorStateJs.EditorStateCancellationTokenSource)(this.editor, 5 /* CodeEditorStateFlag.Value */ , loc.range, this._cts.token);
        const model = this.editor.getModel(); // @ulugbekna: assumes editor still has a model, otherwise, cts1 should've been cancelled
        const newSymbolNamesProviders = this._languageFeaturesService.newSymbolNamesProvider.all(model);
        const resolvedNewSymbolnamesProviders = await Promise.all(newSymbolNamesProviders.map(async (p)=>[
                p,
                await p.supportsAutomaticNewSymbolNamesTriggerKind ?? false
            ]));
        const requestRenameSuggestions = (triggerKind, cts)=>{
            let providers = resolvedNewSymbolnamesProviders.slice();
            if (triggerKind === (0, _languagesJs.NewSymbolNameTriggerKind).Automatic) providers = providers.filter(([_, supportsAutomatic])=>supportsAutomatic);
            return providers.map(([p])=>p.provideNewSymbolNames(model, loc.range, triggerKind, cts));
        };
        trace("creating rename input field and awaiting its result");
        const supportPreview = this._bulkEditService.hasPreviewHandler() && this._configService.getValue(this.editor.getModel().uri, "editor.rename.enablePreview");
        const inputFieldResult = await this._renameWidget.getInput(loc.range, loc.text, supportPreview, newSymbolNamesProviders.length > 0 ? requestRenameSuggestions : undefined, cts2);
        trace("received response from rename input field");
        if (newSymbolNamesProviders.length > 0) this._reportTelemetry(newSymbolNamesProviders.length, model.getLanguageId(), inputFieldResult);
        // no result, only hint to focus the editor or not
        if (typeof inputFieldResult === "boolean") {
            trace(`returning early - rename input field response - ${inputFieldResult}`);
            if (inputFieldResult) this.editor.focus();
            cts2.dispose();
            return undefined;
        }
        this.editor.focus();
        trace("requesting rename edits");
        const renameOperation = (0, _asyncJs.raceCancellation)(skeleton.provideRenameEdits(inputFieldResult.newName, cts2.token), cts2.token).then(async (renameResult)=>{
            if (!renameResult) {
                trace("returning early - no rename edits result");
                return;
            }
            if (!this.editor.hasModel()) {
                trace("returning early - no model after rename edits are provided");
                return;
            }
            if (renameResult.rejectReason) {
                trace(`returning early - rejected with reason: ${renameResult.rejectReason}`);
                this._notificationService.info(renameResult.rejectReason);
                return;
            }
            // collapse selection to active end
            this.editor.setSelection((0, _rangeJs.Range).fromPositions(this.editor.getSelection().getPosition()));
            trace("applying edits");
            this._bulkEditService.apply(renameResult, {
                editor: this.editor,
                showPreview: inputFieldResult.wantsPreview,
                label: _nlsJs.localize("label", "Renaming '{0}' to '{1}'", loc?.text, inputFieldResult.newName),
                code: "undoredo.rename",
                quotableLabel: _nlsJs.localize("quotableLabel", "Renaming {0} to {1}", loc?.text, inputFieldResult.newName),
                respectAutoSaveConfig: true
            }).then((result)=>{
                trace("edits applied");
                if (result.ariaSummary) (0, _ariaJs.alert)(_nlsJs.localize("aria", "Successfully renamed '{0}' to '{1}'. Summary: {2}", loc.text, inputFieldResult.newName, result.ariaSummary));
            }).catch((err)=>{
                trace(`error when applying edits ${JSON.stringify(err, null, "	")}`);
                this._notificationService.error(_nlsJs.localize("rename.failedApply", "Rename failed to apply edits"));
                this._logService.error(err);
            });
        }, (err)=>{
            trace("error when providing rename edits", JSON.stringify(err, null, "	"));
            this._notificationService.error(_nlsJs.localize("rename.failed", "Rename failed to compute edits"));
            this._logService.error(err);
        }).finally(()=>{
            cts2.dispose();
        });
        trace("returning rename operation");
        this._progressService.showWhile(renameOperation, 250);
        return renameOperation;
    }
    acceptRenameInput(wantsPreview) {
        this._renameWidget.acceptInput(wantsPreview);
    }
    cancelRenameInput() {
        this._renameWidget.cancelInput(true, "cancelRenameInput command");
    }
    focusNextRenameSuggestion() {
        this._renameWidget.focusNextRenameSuggestion();
    }
    focusPreviousRenameSuggestion() {
        this._renameWidget.focusPreviousRenameSuggestion();
    }
    _reportTelemetry(nRenameSuggestionProviders, languageId, inputFieldResult) {
        const value = typeof inputFieldResult === "boolean" ? {
            kind: "cancelled",
            languageId,
            nRenameSuggestionProviders
        } : {
            kind: "accepted",
            languageId,
            nRenameSuggestionProviders,
            source: inputFieldResult.stats.source.k,
            nRenameSuggestions: inputFieldResult.stats.nRenameSuggestions,
            timeBeforeFirstInputFieldEdit: inputFieldResult.stats.timeBeforeFirstInputFieldEdit,
            wantsPreview: inputFieldResult.wantsPreview,
            nRenameSuggestionsInvocations: inputFieldResult.stats.nRenameSuggestionsInvocations,
            hadAutomaticRenameSuggestionsInvocation: inputFieldResult.stats.hadAutomaticRenameSuggestionsInvocation
        };
        this._telemetryService.publicLog2("renameInvokedEvent", value);
    }
};
RenameController = RenameController_1 = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService)),
    __param(2, (0, _notificationJs.INotificationService)),
    __param(3, (0, _bulkEditServiceJs.IBulkEditService)),
    __param(4, (0, _progressJs.IEditorProgressService)),
    __param(5, (0, _logJs.ILogService)),
    __param(6, (0, _textResourceConfigurationJs.ITextResourceConfigurationService)),
    __param(7, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(8, (0, _telemetryJs.ITelemetryService))
], RenameController);
class RenameAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.rename",
            label: _nlsJs.localize("rename.label", "Rename Symbol"),
            alias: "Rename Symbol",
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).writable, (0, _editorContextKeysJs.EditorContextKeys).hasRenameProvider),
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 60 /* KeyCode.F2 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            contextMenuOpts: {
                group: "1_modification",
                order: 1.1
            }
        });
    }
    runCommand(accessor, args) {
        const editorService = accessor.get((0, _codeEditorServiceJs.ICodeEditorService));
        const [uri, pos] = Array.isArray(args) && args || [
            undefined,
            undefined
        ];
        if ((0, _uriJs.URI).isUri(uri) && (0, _positionJs.Position).isIPosition(pos)) return editorService.openCodeEditor({
            resource: uri
        }, editorService.getActiveCodeEditor()).then((editor)=>{
            if (!editor) return;
            editor.setPosition(pos);
            editor.invokeWithinContext((accessor)=>{
                this.reportTelemetry(accessor, editor);
                return this.run(accessor, editor);
            });
        }, (0, _errorsJs.onUnexpectedError));
        return super.runCommand(accessor, args);
    }
    run(accessor, editor) {
        const logService = accessor.get((0, _logJs.ILogService));
        const controller = RenameController.get(editor);
        if (controller) {
            logService.trace("[RenameAction] got controller, running...");
            return controller.run();
        }
        logService.trace("[RenameAction] returning early - controller missing");
        return Promise.resolve();
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(RenameController.ID, RenameController, 4 /* EditorContributionInstantiation.Lazy */ );
(0, _editorExtensionsJs.registerEditorAction)(RenameAction);
const RenameCommand = (0, _editorExtensionsJs.EditorCommand).bindToContribution(RenameController.get);
(0, _editorExtensionsJs.registerEditorCommand)(new RenameCommand({
    id: "acceptRenameInput",
    precondition: (0, _renameWidgetJs.CONTEXT_RENAME_INPUT_VISIBLE),
    handler: (x)=>x.acceptRenameInput(false),
    kbOpts: {
        weight: 199,
        kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).focus, (0, _contextkeyJs.ContextKeyExpr).not("isComposing")),
        primary: 3 /* KeyCode.Enter */ 
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new RenameCommand({
    id: "acceptRenameInputWithPreview",
    precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _renameWidgetJs.CONTEXT_RENAME_INPUT_VISIBLE), (0, _contextkeyJs.ContextKeyExpr).has("config.editor.rename.enablePreview")),
    handler: (x)=>x.acceptRenameInput(true),
    kbOpts: {
        weight: 199,
        kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).focus, (0, _contextkeyJs.ContextKeyExpr).not("isComposing")),
        primary: 2051 /* KeyCode.Enter */ 
    }
}));
(0, _editorExtensionsJs.registerEditorCommand)(new RenameCommand({
    id: "cancelRenameInput",
    precondition: (0, _renameWidgetJs.CONTEXT_RENAME_INPUT_VISIBLE),
    handler: (x)=>x.cancelRenameInput(),
    kbOpts: {
        weight: 199,
        kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
        primary: 9 /* KeyCode.Escape */ ,
        secondary: [
            1033 /* KeyCode.Escape */ 
        ]
    }
}));
(0, _actionsJs.registerAction2)(class FocusNextRenameSuggestion extends (0, _actionsJs.Action2) {
    constructor(){
        super({
            id: "focusNextRenameSuggestion",
            title: {
                ..._nlsJs.localize2("focusNextRenameSuggestion", "Focus Next Rename Suggestion")
            },
            precondition: (0, _renameWidgetJs.CONTEXT_RENAME_INPUT_VISIBLE),
            keybinding: [
                {
                    primary: 18 /* KeyCode.DownArrow */ ,
                    weight: 199
                }
            ]
        });
    }
    run(accessor) {
        const currentEditor = accessor.get((0, _codeEditorServiceJs.ICodeEditorService)).getFocusedCodeEditor();
        if (!currentEditor) return;
        const controller = RenameController.get(currentEditor);
        if (!controller) return;
        controller.focusNextRenameSuggestion();
    }
});
(0, _actionsJs.registerAction2)(class FocusPreviousRenameSuggestion extends (0, _actionsJs.Action2) {
    constructor(){
        super({
            id: "focusPreviousRenameSuggestion",
            title: {
                ..._nlsJs.localize2("focusPreviousRenameSuggestion", "Focus Previous Rename Suggestion")
            },
            precondition: (0, _renameWidgetJs.CONTEXT_RENAME_INPUT_VISIBLE),
            keybinding: [
                {
                    primary: 16 /* KeyCode.UpArrow */ ,
                    weight: 199
                }
            ]
        });
    }
    run(accessor) {
        const currentEditor = accessor.get((0, _codeEditorServiceJs.ICodeEditorService)).getFocusedCodeEditor();
        if (!currentEditor) return;
        const controller = RenameController.get(currentEditor);
        if (!controller) return;
        controller.focusPreviousRenameSuggestion();
    }
});
// ---- api bridge command
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeDocumentRenameProvider", function(accessor, model, position, ...args) {
    const [newName] = args;
    (0, _typesJs.assertType)(typeof newName === "string");
    const { renameProvider } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    return rename(renameProvider, model, position, newName);
});
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executePrepareRename", async function(accessor, model, position) {
    const { renameProvider } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const skeleton = new RenameSkeleton(model, position, renameProvider);
    const loc = await skeleton.resolveRenameLocation((0, _cancellationJs.CancellationToken).None);
    if (loc?.rejectReason) throw new Error(loc.rejectReason);
    return loc;
});
//todo@jrieken use editor options world
(0, _platformJs.Registry).as((0, _configurationRegistryJs.Extensions).Configuration).registerConfiguration({
    id: "editor",
    properties: {
        "editor.rename.enablePreview": {
            scope: 5 /* ConfigurationScope.LANGUAGE_OVERRIDABLE */ ,
            description: _nlsJs.localize("enablePreview", "Enable/disable the ability to preview changes before renaming"),
            default: true,
            type: "boolean"
        }
    }
});

},{"../../../../base/browser/ui/aria/aria.js":"asrsh","../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/htmlContent.js":"3Hxzm","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/types.js":"fb5yx","../../../../base/common/uri.js":"7qGS3","../../../browser/editorExtensions.js":"kC3w6","../../../browser/services/bulkEditService.js":"fLMRG","../../../browser/services/codeEditorService.js":"bOWtl","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/editorContextKeys.js":"5exv9","../../../common/languages.js":"g5n96","../../../common/services/languageFeatures.js":"2IAko","../../../common/services/textResourceConfiguration.js":"4yrEB","../../editorState/browser/editorState.js":"hyVHM","../../message/browser/messageController.js":"7FZE5","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/configuration/common/configurationRegistry.js":"6y4yB","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/log/common/log.js":"ieJUF","../../../../platform/notification/common/notification.js":"igv0W","../../../../platform/progress/common/progress.js":"f49eD","../../../../platform/registry/common/platform.js":"dzx11","../../../../platform/telemetry/common/telemetry.js":"7vW8j","./renameWidget.js":"8TCch","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8TCch":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTEXT_RENAME_INPUT_VISIBLE", ()=>CONTEXT_RENAME_INPUT_VISIBLE);
parcelHelpers.export(exports, "CONTEXT_RENAME_INPUT_FOCUSED", ()=>CONTEXT_RENAME_INPUT_FOCUSED);
parcelHelpers.export(exports, "RenameWidget", ()=>RenameWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _keyboardEventJs = require("../../../../base/browser/keyboardEvent.js");
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var _hoverDelegate2Js = require("../../../../base/browser/ui/hover/hoverDelegate2.js");
var _hoverDelegateFactoryJs = require("../../../../base/browser/ui/hover/hoverDelegateFactory.js");
var _iconLabelsJs = require("../../../../base/browser/ui/iconLabel/iconLabels.js");
var _listWidgetJs = require("../../../../base/browser/ui/list/listWidget.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _eventJs = require("../../../../base/common/event.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stopwatchJs = require("../../../../base/common/stopwatch.js");
var _typesJs = require("../../../../base/common/types.js");
var _renameWidgetCss = require("./renameWidget.css");
var _domFontInfoJs = require("../../../browser/config/domFontInfo.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _languagesJs = require("../../../common/languages.js");
var _nlsJs = require("../../../../nls.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _logJs = require("../../../../platform/log/common/log.js");
var _defaultStylesJs = require("../../../../platform/theme/browser/defaultStyles.js");
var _colorRegistryJs = require("../../../../platform/theme/common/colorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
/** for debugging */ const _sticky = false;
const CONTEXT_RENAME_INPUT_VISIBLE = new (0, _contextkeyJs.RawContextKey)("renameInputVisible", false, _nlsJs.localize("renameInputVisible", "Whether the rename input widget is visible"));
const CONTEXT_RENAME_INPUT_FOCUSED = new (0, _contextkeyJs.RawContextKey)("renameInputFocused", false, _nlsJs.localize("renameInputFocused", "Whether the rename input widget is focused"));
let RenameWidget = class RenameWidget {
    constructor(_editor, _acceptKeybindings, _themeService, _keybindingService, contextKeyService, _logService){
        this._editor = _editor;
        this._acceptKeybindings = _acceptKeybindings;
        this._themeService = _themeService;
        this._keybindingService = _keybindingService;
        this._logService = _logService;
        // implement IContentWidget
        this.allowEditorOverflow = true;
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._visibleContextKey = CONTEXT_RENAME_INPUT_VISIBLE.bindTo(contextKeyService);
        this._isEditingRenameCandidate = false;
        this._nRenameSuggestionsInvocations = 0;
        this._hadAutomaticRenameSuggestionsInvocation = false;
        this._candidates = new Set();
        this._beforeFirstInputFieldEditSW = new (0, _stopwatchJs.StopWatch)();
        this._inputWithButton = new InputWithButton();
        this._disposables.add(this._inputWithButton);
        this._editor.addContentWidget(this);
        this._disposables.add(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(50 /* EditorOption.fontInfo */ )) this._updateFont();
        }));
        this._disposables.add(_themeService.onDidColorThemeChange(this._updateStyles, this));
    }
    dispose() {
        this._disposables.dispose();
        this._editor.removeContentWidget(this);
    }
    getId() {
        return "__renameInputWidget";
    }
    getDomNode() {
        if (!this._domNode) {
            this._domNode = document.createElement("div");
            this._domNode.className = "monaco-editor rename-box";
            this._domNode.appendChild(this._inputWithButton.domNode);
            this._renameCandidateListView = this._disposables.add(new RenameCandidateListView(this._domNode, {
                fontInfo: this._editor.getOption(50 /* EditorOption.fontInfo */ ),
                onFocusChange: (newSymbolName)=>{
                    this._inputWithButton.input.value = newSymbolName;
                    this._isEditingRenameCandidate = false; // @ulugbekna: reset
                },
                onSelectionChange: ()=>{
                    this._isEditingRenameCandidate = false; // @ulugbekna: because user picked a rename suggestion
                    this.acceptInput(false); // we don't allow preview with mouse click for now
                }
            }));
            this._disposables.add(this._inputWithButton.onDidInputChange(()=>{
                if (this._renameCandidateListView?.focusedCandidate !== undefined) this._isEditingRenameCandidate = true;
                this._timeBeforeFirstInputFieldEdit ??= this._beforeFirstInputFieldEditSW.elapsed();
                if (this._renameCandidateProvidersCts?.token.isCancellationRequested === false) this._renameCandidateProvidersCts.cancel();
                this._renameCandidateListView?.clearFocus();
            }));
            this._label = document.createElement("div");
            this._label.className = "rename-label";
            this._domNode.appendChild(this._label);
            this._updateFont();
            this._updateStyles(this._themeService.getColorTheme());
        }
        return this._domNode;
    }
    _updateStyles(theme) {
        if (!this._domNode) return;
        const widgetShadowColor = theme.getColor((0, _colorRegistryJs.widgetShadow));
        const widgetBorderColor = theme.getColor((0, _colorRegistryJs.widgetBorder));
        this._domNode.style.backgroundColor = String(theme.getColor((0, _colorRegistryJs.editorWidgetBackground)) ?? "");
        this._domNode.style.boxShadow = widgetShadowColor ? ` 0 0 8px 2px ${widgetShadowColor}` : "";
        this._domNode.style.border = widgetBorderColor ? `1px solid ${widgetBorderColor}` : "";
        this._domNode.style.color = String(theme.getColor((0, _colorRegistryJs.inputForeground)) ?? "");
        const border = theme.getColor((0, _colorRegistryJs.inputBorder));
        this._inputWithButton.domNode.style.backgroundColor = String(theme.getColor((0, _colorRegistryJs.inputBackground)) ?? "");
        this._inputWithButton.input.style.backgroundColor = String(theme.getColor((0, _colorRegistryJs.inputBackground)) ?? "");
        this._inputWithButton.domNode.style.borderWidth = border ? "1px" : "0px";
        this._inputWithButton.domNode.style.borderStyle = border ? "solid" : "none";
        this._inputWithButton.domNode.style.borderColor = border?.toString() ?? "none";
    }
    _updateFont() {
        if (this._domNode === undefined) return;
        (0, _typesJs.assertType)(this._label !== undefined, "RenameWidget#_updateFont: _label must not be undefined given _domNode is defined");
        this._editor.applyFontInfo(this._inputWithButton.input);
        const fontInfo = this._editor.getOption(50 /* EditorOption.fontInfo */ );
        this._label.style.fontSize = `${this._computeLabelFontSize(fontInfo.fontSize)}px`;
    }
    _computeLabelFontSize(editorFontSize) {
        return editorFontSize * 0.8;
    }
    getPosition() {
        if (!this._visible) return null;
        if (!this._editor.hasModel() || // @ulugbekna: shouldn't happen
        !this._editor.getDomNode() // @ulugbekna: can happen during tests based on suggestWidget's similar predicate check
        ) return null;
        const bodyBox = _domJs.getClientArea(this.getDomNode().ownerDocument.body);
        const editorBox = _domJs.getDomNodePagePosition(this._editor.getDomNode());
        const cursorBoxTop = this._getTopForPosition();
        this._nPxAvailableAbove = cursorBoxTop + editorBox.top;
        this._nPxAvailableBelow = bodyBox.height - this._nPxAvailableAbove;
        const lineHeight = this._editor.getOption(67 /* EditorOption.lineHeight */ );
        const { totalHeight: candidateViewHeight } = RenameCandidateView.getLayoutInfo({
            lineHeight
        });
        const positionPreference = this._nPxAvailableBelow > candidateViewHeight * 6 /* approximate # of candidates to fit in (inclusive of rename input box & rename label) */  ? [
            2 /* ContentWidgetPositionPreference.BELOW */ ,
            1 /* ContentWidgetPositionPreference.ABOVE */ 
        ] : [
            1 /* ContentWidgetPositionPreference.ABOVE */ ,
            2 /* ContentWidgetPositionPreference.BELOW */ 
        ];
        return {
            position: this._position,
            preference: positionPreference
        };
    }
    beforeRender() {
        const [accept, preview] = this._acceptKeybindings;
        this._label.innerText = _nlsJs.localize({
            key: "label",
            comment: [
                'placeholders are keybindings, e.g "F2 to Rename, Shift+F2 to Preview"'
            ]
        }, "{0} to Rename, {1} to Preview", this._keybindingService.lookupKeybinding(accept)?.getLabel(), this._keybindingService.lookupKeybinding(preview)?.getLabel());
        this._domNode.style.minWidth = `200px`; // to prevent from widening when candidates come in
        return null;
    }
    afterRender(position) {
        // FIXME@ulugbekna: commenting trace log out until we start unmounting the widget from editor properly - https://github.com/microsoft/vscode/issues/226975
        // this._trace('invoking afterRender, position: ', position ? 'not null' : 'null');
        if (position === null) {
            // cancel rename when input widget isn't rendered anymore
            this.cancelInput(true, "afterRender (because position is null)");
            return;
        }
        if (!this._editor.hasModel() || // shouldn't happen
        !this._editor.getDomNode() // can happen during tests based on suggestWidget's similar predicate check
        ) return;
        (0, _typesJs.assertType)(this._renameCandidateListView);
        (0, _typesJs.assertType)(this._nPxAvailableAbove !== undefined);
        (0, _typesJs.assertType)(this._nPxAvailableBelow !== undefined);
        const inputBoxHeight = _domJs.getTotalHeight(this._inputWithButton.domNode);
        const labelHeight = _domJs.getTotalHeight(this._label);
        let totalHeightAvailable;
        if (position === 2 /* ContentWidgetPositionPreference.BELOW */ ) totalHeightAvailable = this._nPxAvailableBelow;
        else totalHeightAvailable = this._nPxAvailableAbove;
        this._renameCandidateListView.layout({
            height: totalHeightAvailable - labelHeight - inputBoxHeight,
            width: _domJs.getTotalWidth(this._inputWithButton.domNode)
        });
    }
    acceptInput(wantsPreview) {
        this._trace(`invoking acceptInput`);
        this._currentAcceptInput?.(wantsPreview);
    }
    cancelInput(focusEditor, caller) {
        // this._trace(`invoking cancelInput, caller: ${caller}, _currentCancelInput: ${this._currentAcceptInput ? 'not undefined' : 'undefined'}`);
        this._currentCancelInput?.(focusEditor);
    }
    focusNextRenameSuggestion() {
        if (!this._renameCandidateListView?.focusNext()) this._inputWithButton.input.value = this._currentName;
    }
    focusPreviousRenameSuggestion() {
        if (!this._renameCandidateListView?.focusPrevious()) this._inputWithButton.input.value = this._currentName;
    }
    /**
     * @param requestRenameCandidates is `undefined` when there are no rename suggestion providers
     */ getInput(where, currentName, supportPreview, requestRenameCandidates, cts) {
        const { start: selectionStart, end: selectionEnd } = this._getSelection(where, currentName);
        this._renameCts = cts;
        const disposeOnDone = new (0, _lifecycleJs.DisposableStore)();
        this._nRenameSuggestionsInvocations = 0;
        this._hadAutomaticRenameSuggestionsInvocation = false;
        if (requestRenameCandidates === undefined) this._inputWithButton.button.style.display = "none";
        else {
            this._inputWithButton.button.style.display = "flex";
            this._requestRenameCandidatesOnce = requestRenameCandidates;
            this._requestRenameCandidates(currentName, false);
            disposeOnDone.add(_domJs.addDisposableListener(this._inputWithButton.button, "click", ()=>this._requestRenameCandidates(currentName, true)));
            disposeOnDone.add(_domJs.addDisposableListener(this._inputWithButton.button, _domJs.EventType.KEY_DOWN, (e)=>{
                const keyEvent = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
                if (keyEvent.equals(3 /* KeyCode.Enter */ ) || keyEvent.equals(10 /* KeyCode.Space */ )) {
                    keyEvent.stopPropagation();
                    keyEvent.preventDefault();
                    this._requestRenameCandidates(currentName, true);
                }
            }));
        }
        this._isEditingRenameCandidate = false;
        this._domNode.classList.toggle("preview", supportPreview);
        this._position = new (0, _positionJs.Position)(where.startLineNumber, where.startColumn);
        this._currentName = currentName;
        this._inputWithButton.input.value = currentName;
        this._inputWithButton.input.setAttribute("selectionStart", selectionStart.toString());
        this._inputWithButton.input.setAttribute("selectionEnd", selectionEnd.toString());
        this._inputWithButton.input.size = Math.max((where.endColumn - where.startColumn) * 1.1, 20); // determines width
        this._beforeFirstInputFieldEditSW.reset();
        disposeOnDone.add((0, _lifecycleJs.toDisposable)(()=>{
            this._renameCts = undefined;
            cts.dispose(true);
        })); // @ulugbekna: this may result in `this.cancelInput` being called twice, but it should be safe since we set it to undefined after 1st call
        disposeOnDone.add((0, _lifecycleJs.toDisposable)(()=>{
            if (this._renameCandidateProvidersCts !== undefined) {
                this._renameCandidateProvidersCts.dispose(true);
                this._renameCandidateProvidersCts = undefined;
            }
        }));
        disposeOnDone.add((0, _lifecycleJs.toDisposable)(()=>this._candidates.clear()));
        const inputResult = new (0, _asyncJs.DeferredPromise)();
        inputResult.p.finally(()=>{
            disposeOnDone.dispose();
            this._hide();
        });
        this._currentCancelInput = (focusEditor)=>{
            this._trace("invoking _currentCancelInput");
            this._currentAcceptInput = undefined;
            this._currentCancelInput = undefined;
            // fixme session cleanup
            this._renameCandidateListView?.clearCandidates();
            inputResult.complete(focusEditor);
            return true;
        };
        this._currentAcceptInput = (wantsPreview)=>{
            this._trace("invoking _currentAcceptInput");
            (0, _typesJs.assertType)(this._renameCandidateListView !== undefined);
            const nRenameSuggestions = this._renameCandidateListView.nCandidates;
            let newName;
            let source;
            const focusedCandidate = this._renameCandidateListView.focusedCandidate;
            if (focusedCandidate !== undefined) {
                this._trace("using new name from renameSuggestion");
                newName = focusedCandidate;
                source = {
                    k: "renameSuggestion"
                };
            } else {
                this._trace("using new name from inputField");
                newName = this._inputWithButton.input.value;
                source = this._isEditingRenameCandidate ? {
                    k: "userEditedRenameSuggestion"
                } : {
                    k: "inputField"
                };
            }
            if (newName === currentName || newName.trim().length === 0 /* is just whitespace */ ) {
                this.cancelInput(true, "_currentAcceptInput (because newName === value || newName.trim().length === 0)");
                return;
            }
            this._currentAcceptInput = undefined;
            this._currentCancelInput = undefined;
            this._renameCandidateListView.clearCandidates();
            // fixme session cleanup
            inputResult.complete({
                newName,
                wantsPreview: supportPreview && wantsPreview,
                stats: {
                    source,
                    nRenameSuggestions,
                    timeBeforeFirstInputFieldEdit: this._timeBeforeFirstInputFieldEdit,
                    nRenameSuggestionsInvocations: this._nRenameSuggestionsInvocations,
                    hadAutomaticRenameSuggestionsInvocation: this._hadAutomaticRenameSuggestionsInvocation
                }
            });
        };
        disposeOnDone.add(cts.token.onCancellationRequested(()=>this.cancelInput(true, "cts.token.onCancellationRequested")));
        if (!_sticky) disposeOnDone.add(this._editor.onDidBlurEditorWidget(()=>this.cancelInput(!this._domNode?.ownerDocument.hasFocus(), "editor.onDidBlurEditorWidget")));
        this._show();
        return inputResult.p;
    }
    _requestRenameCandidates(currentName, isManuallyTriggered) {
        if (this._requestRenameCandidatesOnce === undefined) return;
        if (this._renameCandidateProvidersCts !== undefined) this._renameCandidateProvidersCts.dispose(true);
        (0, _typesJs.assertType)(this._renameCts);
        if (this._inputWithButton.buttonState !== "stop") {
            this._renameCandidateProvidersCts = new (0, _cancellationJs.CancellationTokenSource)();
            const triggerKind = isManuallyTriggered ? (0, _languagesJs.NewSymbolNameTriggerKind).Invoke : (0, _languagesJs.NewSymbolNameTriggerKind).Automatic;
            const candidates = this._requestRenameCandidatesOnce(triggerKind, this._renameCandidateProvidersCts.token);
            if (candidates.length === 0) {
                this._inputWithButton.setSparkleButton();
                return;
            }
            if (!isManuallyTriggered) this._hadAutomaticRenameSuggestionsInvocation = true;
            this._nRenameSuggestionsInvocations += 1;
            this._inputWithButton.setStopButton();
            this._updateRenameCandidates(candidates, currentName, this._renameCts.token);
        }
    }
    /**
     * This allows selecting only part of the symbol name in the input field based on the selection in the editor
     */ _getSelection(where, currentName) {
        (0, _typesJs.assertType)(this._editor.hasModel());
        const selection = this._editor.getSelection();
        let start = 0;
        let end = currentName.length;
        if (!(0, _rangeJs.Range).isEmpty(selection) && !(0, _rangeJs.Range).spansMultipleLines(selection) && (0, _rangeJs.Range).containsRange(where, selection)) {
            start = Math.max(0, selection.startColumn - where.startColumn);
            end = Math.min(where.endColumn, selection.endColumn) - where.startColumn;
        }
        return {
            start,
            end
        };
    }
    _show() {
        this._trace("invoking _show");
        this._editor.revealLineInCenterIfOutsideViewport(this._position.lineNumber, 0 /* ScrollType.Smooth */ );
        this._visible = true;
        this._visibleContextKey.set(true);
        this._editor.layoutContentWidget(this);
        // TODO@ulugbekna: could this be simply run in `afterRender`?
        setTimeout(()=>{
            this._inputWithButton.input.focus();
            this._inputWithButton.input.setSelectionRange(parseInt(this._inputWithButton.input.getAttribute("selectionStart")), parseInt(this._inputWithButton.input.getAttribute("selectionEnd")));
        }, 100);
    }
    async _updateRenameCandidates(candidates, currentName, token) {
        const trace = (...args)=>this._trace("_updateRenameCandidates", ...args);
        trace("start");
        const namesListResults = await (0, _asyncJs.raceCancellation)(Promise.allSettled(candidates), token);
        this._inputWithButton.setSparkleButton();
        if (namesListResults === undefined) {
            trace("returning early - received updateRenameCandidates results - undefined");
            return;
        }
        const newNames = namesListResults.flatMap((namesListResult)=>namesListResult.status === "fulfilled" && (0, _typesJs.isDefined)(namesListResult.value) ? namesListResult.value : []);
        trace(`received updateRenameCandidates results - total (unfiltered) ${newNames.length} candidates.`);
        // deduplicate and filter out the current value
        const distinctNames = _arraysJs.distinct(newNames, (v)=>v.newSymbolName);
        trace(`distinct candidates - ${distinctNames.length} candidates.`);
        const validDistinctNames = distinctNames.filter(({ newSymbolName })=>newSymbolName.trim().length > 0 && newSymbolName !== this._inputWithButton.input.value && newSymbolName !== currentName && !this._candidates.has(newSymbolName));
        trace(`valid distinct candidates - ${newNames.length} candidates.`);
        validDistinctNames.forEach((n)=>this._candidates.add(n.newSymbolName));
        if (validDistinctNames.length < 1) {
            trace("returning early - no valid distinct candidates");
            return;
        }
        // show the candidates
        trace("setting candidates");
        this._renameCandidateListView.setCandidates(validDistinctNames);
        // ask editor to re-layout given that the widget is now of a different size after rendering rename candidates
        trace("asking editor to re-layout");
        this._editor.layoutContentWidget(this);
    }
    _hide() {
        this._trace("invoked _hide");
        this._visible = false;
        this._visibleContextKey.reset();
        this._editor.layoutContentWidget(this);
    }
    _getTopForPosition() {
        const visibleRanges = this._editor.getVisibleRanges();
        let firstLineInViewport;
        if (visibleRanges.length > 0) firstLineInViewport = visibleRanges[0].startLineNumber;
        else {
            this._logService.warn("RenameWidget#_getTopForPosition: this should not happen - visibleRanges is empty");
            firstLineInViewport = Math.max(1, this._position.lineNumber - 5); // @ulugbekna: fallback to current line minus 5
        }
        return this._editor.getTopForLineNumber(this._position.lineNumber) - this._editor.getTopForLineNumber(firstLineInViewport);
    }
    _trace(...args) {
        this._logService.trace("RenameWidget", ...args);
    }
};
RenameWidget = __decorate([
    __param(2, (0, _themeServiceJs.IThemeService)),
    __param(3, (0, _keybindingJs.IKeybindingService)),
    __param(4, (0, _contextkeyJs.IContextKeyService)),
    __param(5, (0, _logJs.ILogService))
], RenameWidget);
class RenameCandidateListView {
    // FIXME@ulugbekna: rewrite using event emitters
    constructor(parent, opts){
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
        this._availableHeight = 0;
        this._minimumWidth = 0;
        this._lineHeight = opts.fontInfo.lineHeight;
        this._typicalHalfwidthCharacterWidth = opts.fontInfo.typicalHalfwidthCharacterWidth;
        this._listContainer = document.createElement("div");
        this._listContainer.className = "rename-box rename-candidate-list-container";
        parent.appendChild(this._listContainer);
        this._listWidget = RenameCandidateListView._createListWidget(this._listContainer, this._candidateViewHeight, opts.fontInfo);
        this._listWidget.onDidChangeFocus((e)=>{
            if (e.elements.length === 1) opts.onFocusChange(e.elements[0].newSymbolName);
        }, this._disposables);
        this._listWidget.onDidChangeSelection((e)=>{
            if (e.elements.length === 1) opts.onSelectionChange();
        }, this._disposables);
        this._disposables.add(this._listWidget.onDidBlur((e)=>{
            this._listWidget.setFocus([]);
        }));
        this._listWidget.style((0, _defaultStylesJs.getListStyles)({
            listInactiveFocusForeground: (0, _colorRegistryJs.quickInputListFocusForeground),
            listInactiveFocusBackground: (0, _colorRegistryJs.quickInputListFocusBackground)
        }));
    }
    dispose() {
        this._listWidget.dispose();
        this._disposables.dispose();
    }
    // height - max height allowed by parent element
    layout({ height, width }) {
        this._availableHeight = height;
        this._minimumWidth = width;
    }
    setCandidates(candidates) {
        // insert candidates into list widget
        this._listWidget.splice(0, 0, candidates);
        // adjust list widget layout
        const height = this._pickListHeight(this._listWidget.length);
        const width = this._pickListWidth(candidates);
        this._listWidget.layout(height, width);
        // adjust list container layout
        this._listContainer.style.height = `${height}px`;
        this._listContainer.style.width = `${width}px`;
        _ariaJs.status(_nlsJs.localize("renameSuggestionsReceivedAria", "Received {0} rename suggestions", candidates.length));
    }
    clearCandidates() {
        this._listContainer.style.height = "0px";
        this._listContainer.style.width = "0px";
        this._listWidget.splice(0, this._listWidget.length, []);
    }
    get nCandidates() {
        return this._listWidget.length;
    }
    get focusedCandidate() {
        if (this._listWidget.length === 0) return;
        const selectedElement = this._listWidget.getSelectedElements()[0];
        if (selectedElement !== undefined) return selectedElement.newSymbolName;
        const focusedElement = this._listWidget.getFocusedElements()[0];
        if (focusedElement !== undefined) return focusedElement.newSymbolName;
        return;
    }
    focusNext() {
        if (this._listWidget.length === 0) return false;
        const focusedIxs = this._listWidget.getFocus();
        if (focusedIxs.length === 0) {
            this._listWidget.focusFirst();
            this._listWidget.reveal(0);
            return true;
        } else if (focusedIxs[0] === this._listWidget.length - 1) {
            this._listWidget.setFocus([]);
            this._listWidget.reveal(0); // @ulugbekna: without this, it seems like focused element is obstructed
            return false;
        } else {
            this._listWidget.focusNext();
            const focused = this._listWidget.getFocus()[0];
            this._listWidget.reveal(focused);
            return true;
        }
    }
    /**
     * @returns true if focus is moved to previous element
     */ focusPrevious() {
        if (this._listWidget.length === 0) return false;
        const focusedIxs = this._listWidget.getFocus();
        if (focusedIxs.length === 0) {
            this._listWidget.focusLast();
            const focused = this._listWidget.getFocus()[0];
            this._listWidget.reveal(focused);
            return true;
        } else if (focusedIxs[0] === 0) {
            this._listWidget.setFocus([]);
            return false;
        } else {
            this._listWidget.focusPrevious();
            const focused = this._listWidget.getFocus()[0];
            this._listWidget.reveal(focused);
            return true;
        }
    }
    clearFocus() {
        this._listWidget.setFocus([]);
    }
    get _candidateViewHeight() {
        const { totalHeight } = RenameCandidateView.getLayoutInfo({
            lineHeight: this._lineHeight
        });
        return totalHeight;
    }
    _pickListHeight(nCandidates) {
        const heightToFitAllCandidates = this._candidateViewHeight * nCandidates;
        const MAX_N_CANDIDATES = 7; // @ulugbekna: max # of candidates we want to show at once
        const height = Math.min(heightToFitAllCandidates, this._availableHeight, this._candidateViewHeight * MAX_N_CANDIDATES);
        return height;
    }
    _pickListWidth(candidates) {
        const longestCandidateWidth = Math.ceil(Math.max(...candidates.map((c)=>c.newSymbolName.length)) * this._typicalHalfwidthCharacterWidth);
        const width = Math.max(this._minimumWidth, 25 /* margin-left */  + longestCandidateWidth + 10 /* (possibly visible) scrollbar width */  // TODO@ulugbekna: approximate calc - clean this up
        );
        return width;
    }
    static _createListWidget(container, candidateViewHeight, fontInfo) {
        const virtualDelegate = new class {
            getTemplateId(element) {
                return "candidate";
            }
            getHeight(element) {
                return candidateViewHeight;
            }
        };
        const renderer = new class {
            constructor(){
                this.templateId = "candidate";
            }
            renderTemplate(container) {
                return new RenameCandidateView(container, fontInfo);
            }
            renderElement(candidate, index, templateData) {
                templateData.populate(candidate);
            }
            disposeTemplate(templateData) {
                templateData.dispose();
            }
        };
        return new (0, _listWidgetJs.List)("NewSymbolNameCandidates", container, virtualDelegate, [
            renderer
        ], {
            keyboardSupport: false,
            mouseSupport: true,
            multipleSelectionSupport: false
        });
    }
}
class InputWithButton {
    constructor(){
        this._onDidInputChange = new (0, _eventJs.Emitter)();
        this.onDidInputChange = this._onDidInputChange.event;
        this._disposables = new (0, _lifecycleJs.DisposableStore)();
    }
    get domNode() {
        if (!this._domNode) {
            this._domNode = document.createElement("div");
            this._domNode.className = "rename-input-with-button";
            this._domNode.style.display = "flex";
            this._domNode.style.flexDirection = "row";
            this._domNode.style.alignItems = "center";
            this._inputNode = document.createElement("input");
            this._inputNode.className = "rename-input";
            this._inputNode.type = "text";
            this._inputNode.style.border = "none";
            this._inputNode.setAttribute("aria-label", _nlsJs.localize("renameAriaLabel", "Rename input. Type new name and press Enter to commit."));
            this._domNode.appendChild(this._inputNode);
            this._buttonNode = document.createElement("div");
            this._buttonNode.className = "rename-suggestions-button";
            this._buttonNode.setAttribute("tabindex", "0");
            this._buttonGenHoverText = _nlsJs.localize("generateRenameSuggestionsButton", "Generate new name suggestions");
            this._buttonCancelHoverText = _nlsJs.localize("cancelRenameSuggestionsButton", "Cancel");
            this._buttonHover = (0, _hoverDelegate2Js.getBaseLayerHoverDelegate)().setupManagedHover((0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("element"), this._buttonNode, this._buttonGenHoverText);
            this._disposables.add(this._buttonHover);
            this._domNode.appendChild(this._buttonNode);
            // notify if selection changes to cancel request to rename-suggestion providers
            this._disposables.add(_domJs.addDisposableListener(this.input, _domJs.EventType.INPUT, ()=>this._onDidInputChange.fire()));
            this._disposables.add(_domJs.addDisposableListener(this.input, _domJs.EventType.KEY_DOWN, (e)=>{
                const keyEvent = new (0, _keyboardEventJs.StandardKeyboardEvent)(e);
                if (keyEvent.keyCode === 15 /* KeyCode.LeftArrow */  || keyEvent.keyCode === 17 /* KeyCode.RightArrow */ ) this._onDidInputChange.fire();
            }));
            this._disposables.add(_domJs.addDisposableListener(this.input, _domJs.EventType.CLICK, ()=>this._onDidInputChange.fire()));
            // focus "container" border instead of input box
            this._disposables.add(_domJs.addDisposableListener(this.input, _domJs.EventType.FOCUS, ()=>{
                this.domNode.style.outlineWidth = "1px";
                this.domNode.style.outlineStyle = "solid";
                this.domNode.style.outlineOffset = "-1px";
                this.domNode.style.outlineColor = "var(--vscode-focusBorder)";
            }));
            this._disposables.add(_domJs.addDisposableListener(this.input, _domJs.EventType.BLUR, ()=>{
                this.domNode.style.outline = "none";
            }));
        }
        return this._domNode;
    }
    get input() {
        (0, _typesJs.assertType)(this._inputNode);
        return this._inputNode;
    }
    get button() {
        (0, _typesJs.assertType)(this._buttonNode);
        return this._buttonNode;
    }
    get buttonState() {
        return this._buttonState;
    }
    setSparkleButton() {
        this._buttonState = "sparkle";
        this._sparkleIcon ??= (0, _iconLabelsJs.renderIcon)((0, _codiconsJs.Codicon).sparkle);
        _domJs.clearNode(this.button);
        this.button.appendChild(this._sparkleIcon);
        this.button.setAttribute("aria-label", "Generating new name suggestions");
        this._buttonHover?.update(this._buttonGenHoverText);
        this.input.focus();
    }
    setStopButton() {
        this._buttonState = "stop";
        this._stopIcon ??= (0, _iconLabelsJs.renderIcon)((0, _codiconsJs.Codicon).primitiveSquare);
        _domJs.clearNode(this.button);
        this.button.appendChild(this._stopIcon);
        this.button.setAttribute("aria-label", "Cancel generating new name suggestions");
        this._buttonHover?.update(this._buttonCancelHoverText);
        this.input.focus();
    }
    dispose() {
        this._disposables.dispose();
    }
}
class RenameCandidateView {
    static{
        this._PADDING = 2;
    }
    constructor(parent, fontInfo){
        this._domNode = document.createElement("div");
        this._domNode.className = "rename-box rename-candidate";
        this._domNode.style.display = `flex`;
        this._domNode.style.columnGap = `5px`;
        this._domNode.style.alignItems = `center`;
        this._domNode.style.height = `${fontInfo.lineHeight}px`;
        this._domNode.style.padding = `${RenameCandidateView._PADDING}px`;
        // @ulugbekna: needed to keep space when the `icon.style.display` is set to `none`
        const iconContainer = document.createElement("div");
        iconContainer.style.display = `flex`;
        iconContainer.style.alignItems = `center`;
        iconContainer.style.width = iconContainer.style.height = `${fontInfo.lineHeight * 0.8}px`;
        this._domNode.appendChild(iconContainer);
        this._icon = (0, _iconLabelsJs.renderIcon)((0, _codiconsJs.Codicon).sparkle);
        this._icon.style.display = `none`;
        iconContainer.appendChild(this._icon);
        this._label = document.createElement("div");
        _domFontInfoJs.applyFontInfo(this._label, fontInfo);
        this._domNode.appendChild(this._label);
        parent.appendChild(this._domNode);
    }
    populate(value) {
        this._updateIcon(value);
        this._updateLabel(value);
    }
    _updateIcon(value) {
        const isAIGenerated = !!value.tags?.includes((0, _languagesJs.NewSymbolNameTag).AIGenerated);
        this._icon.style.display = isAIGenerated ? "inherit" : "none";
    }
    _updateLabel(value) {
        this._label.innerText = value.newSymbolName;
    }
    static getLayoutInfo({ lineHeight }) {
        const totalHeight = lineHeight + RenameCandidateView._PADDING * 2 /* top & bottom padding */ ;
        return {
            totalHeight
        };
    }
    dispose() {}
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/keyboardEvent.js":"bxU9U","../../../../base/browser/ui/aria/aria.js":"asrsh","../../../../base/browser/ui/hover/hoverDelegate2.js":"5jqL3","../../../../base/browser/ui/hover/hoverDelegateFactory.js":"kll4h","../../../../base/browser/ui/iconLabel/iconLabels.js":"lXqhk","../../../../base/browser/ui/list/listWidget.js":"f6tmg","../../../../base/common/arrays.js":"DECei","../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/event.js":"4Zi8b","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/stopwatch.js":"77PF9","../../../../base/common/types.js":"fb5yx","./renameWidget.css":"aKDHq","../../../browser/config/domFontInfo.js":"fQezv","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/languages.js":"g5n96","../../../../nls.js":"l617d","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../platform/log/common/log.js":"ieJUF","../../../../platform/theme/browser/defaultStyles.js":"4exuA","../../../../platform/theme/common/colorRegistry.js":"ik5kv","../../../../platform/theme/common/themeService.js":"jMkIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aKDHq":[function() {},{}],"6g5ke":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionHeaderDetector", ()=>SectionHeaderDetector);
var _asyncJs = require("../../../../base/common/async.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _editorWorkerJs = require("../../../common/services/editorWorker.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let SectionHeaderDetector = class SectionHeaderDetector extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.sectionHeaderDetector";
    }
    constructor(editor, languageConfigurationService, editorWorkerService){
        super();
        this.editor = editor;
        this.languageConfigurationService = languageConfigurationService;
        this.editorWorkerService = editorWorkerService;
        this.decorations = this.editor.createDecorationsCollection();
        this.options = this.createOptions(editor.getOption(73 /* EditorOption.minimap */ ));
        this.computePromise = null;
        this.currentOccurrences = {};
        this._register(editor.onDidChangeModel((e)=>{
            this.currentOccurrences = {};
            this.options = this.createOptions(editor.getOption(73 /* EditorOption.minimap */ ));
            this.stop();
            this.computeSectionHeaders.schedule(0);
        }));
        this._register(editor.onDidChangeModelLanguage((e)=>{
            this.currentOccurrences = {};
            this.options = this.createOptions(editor.getOption(73 /* EditorOption.minimap */ ));
            this.stop();
            this.computeSectionHeaders.schedule(0);
        }));
        this._register(languageConfigurationService.onDidChange((e)=>{
            const editorLanguageId = this.editor.getModel()?.getLanguageId();
            if (editorLanguageId && e.affects(editorLanguageId)) {
                this.currentOccurrences = {};
                this.options = this.createOptions(editor.getOption(73 /* EditorOption.minimap */ ));
                this.stop();
                this.computeSectionHeaders.schedule(0);
            }
        }));
        this._register(editor.onDidChangeConfiguration((e)=>{
            if (this.options && !e.hasChanged(73 /* EditorOption.minimap */ )) return;
            this.options = this.createOptions(editor.getOption(73 /* EditorOption.minimap */ ));
            // Remove any links (for the getting disabled case)
            this.updateDecorations([]);
            // Stop any computation (for the getting disabled case)
            this.stop();
            // Start computing (for the getting enabled case)
            this.computeSectionHeaders.schedule(0);
        }));
        this._register(this.editor.onDidChangeModelContent((e)=>{
            this.computeSectionHeaders.schedule();
        }));
        this._register(editor.onDidChangeModelTokens((e)=>{
            if (!this.computeSectionHeaders.isScheduled()) this.computeSectionHeaders.schedule(1000);
        }));
        this.computeSectionHeaders = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>{
            this.findSectionHeaders();
        }, 250));
        this.computeSectionHeaders.schedule(0);
    }
    createOptions(minimap) {
        if (!minimap || !this.editor.hasModel()) return undefined;
        const languageId = this.editor.getModel().getLanguageId();
        if (!languageId) return undefined;
        const commentsConfiguration = this.languageConfigurationService.getLanguageConfiguration(languageId).comments;
        const foldingRules = this.languageConfigurationService.getLanguageConfiguration(languageId).foldingRules;
        if (!commentsConfiguration && !foldingRules?.markers) return undefined;
        return {
            foldingRules,
            findMarkSectionHeaders: minimap.showMarkSectionHeaders,
            findRegionSectionHeaders: minimap.showRegionSectionHeaders
        };
    }
    findSectionHeaders() {
        if (!this.editor.hasModel() || !this.options?.findMarkSectionHeaders && !this.options?.findRegionSectionHeaders) return;
        const model = this.editor.getModel();
        if (model.isDisposed() || model.isTooLargeForSyncing()) return;
        const modelVersionId = model.getVersionId();
        this.editorWorkerService.findSectionHeaders(model.uri, this.options).then((sectionHeaders)=>{
            if (model.isDisposed() || model.getVersionId() !== modelVersionId) // model changed in the meantime
            return;
            this.updateDecorations(sectionHeaders);
        });
    }
    updateDecorations(sectionHeaders) {
        const model = this.editor.getModel();
        if (model) // Remove all section headers that should be in comments and are not in comments
        sectionHeaders = sectionHeaders.filter((sectionHeader)=>{
            if (!sectionHeader.shouldBeInComments) return true;
            const validRange = model.validateRange(sectionHeader.range);
            const tokens = model.tokenization.getLineTokens(validRange.startLineNumber);
            const idx = tokens.findTokenIndexAtOffset(validRange.startColumn - 1);
            const tokenType = tokens.getStandardTokenType(idx);
            const languageId = tokens.getLanguageId(idx);
            return languageId === model.getLanguageId() && tokenType === 1 /* StandardTokenType.Comment */ ;
        });
        const oldDecorations = Object.values(this.currentOccurrences).map((occurrence)=>occurrence.decorationId);
        const newDecorations = sectionHeaders.map((sectionHeader)=>decoration(sectionHeader));
        this.editor.changeDecorations((changeAccessor)=>{
            const decorations = changeAccessor.deltaDecorations(oldDecorations, newDecorations);
            this.currentOccurrences = {};
            for(let i = 0, len = decorations.length; i < len; i++){
                const occurrence = {
                    sectionHeader: sectionHeaders[i],
                    decorationId: decorations[i]
                };
                this.currentOccurrences[occurrence.decorationId] = occurrence;
            }
        });
    }
    stop() {
        this.computeSectionHeaders.cancel();
        if (this.computePromise) {
            this.computePromise.cancel();
            this.computePromise = null;
        }
    }
    dispose() {
        super.dispose();
        this.stop();
        this.decorations.clear();
    }
};
SectionHeaderDetector = __decorate([
    __param(1, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService)),
    __param(2, (0, _editorWorkerJs.IEditorWorkerService))
], SectionHeaderDetector);
function decoration(sectionHeader) {
    return {
        range: sectionHeader.range,
        options: (0, _textModelJs.ModelDecorationOptions).createDynamic({
            description: "section-header",
            stickiness: 3 /* TrackedRangeStickiness.GrowsOnlyWhenTypingAfter */ ,
            collapseOnReplaceEdit: true,
            minimap: {
                color: undefined,
                position: 1 /* MinimapPosition.Inline */ ,
                sectionHeaderStyle: sectionHeader.hasSeparatorLine ? 2 /* MinimapSectionHeaderStyle.Underlined */  : 1 /* MinimapSectionHeaderStyle.Normal */ ,
                sectionHeaderText: sectionHeader.text
            }
        })
    };
}
(0, _editorExtensionsJs.registerEditorContribution)(SectionHeaderDetector.ID, SectionHeaderDetector, 1 /* EditorContributionInstantiation.AfterFirstRender */ );

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorExtensions.js":"kC3w6","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../common/model/textModel.js":"9beDe","../../../common/services/editorWorker.js":"aaYJd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kfVPn":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocumentSemanticTokensFeature", ()=>DocumentSemanticTokensFeature);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _modelJs = require("../../../common/services/model.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _semanticTokensProviderStylingJs = require("../../../common/services/semanticTokensProviderStyling.js");
var _getSemanticTokensJs = require("../common/getSemanticTokens.js");
var _languageFeatureDebounceJs = require("../../../common/services/languageFeatureDebounce.js");
var _stopwatchJs = require("../../../../base/common/stopwatch.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _semanticTokensStylingJs = require("../../../common/services/semanticTokensStyling.js");
var _editorFeaturesJs = require("../../../common/editorFeatures.js");
var _semanticTokensConfigJs = require("../common/semanticTokensConfig.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var ModelSemanticColoring_1;
let DocumentSemanticTokensFeature = class DocumentSemanticTokensFeature extends (0, _lifecycleJs.Disposable) {
    constructor(semanticTokensStylingService, modelService, themeService, configurationService, languageFeatureDebounceService, languageFeaturesService){
        super();
        this._watchers = Object.create(null);
        const register = (model)=>{
            this._watchers[model.uri.toString()] = new ModelSemanticColoring(model, semanticTokensStylingService, themeService, languageFeatureDebounceService, languageFeaturesService);
        };
        const deregister = (model, modelSemanticColoring)=>{
            modelSemanticColoring.dispose();
            delete this._watchers[model.uri.toString()];
        };
        const handleSettingOrThemeChange = ()=>{
            for (const model of modelService.getModels()){
                const curr = this._watchers[model.uri.toString()];
                if ((0, _semanticTokensConfigJs.isSemanticColoringEnabled)(model, themeService, configurationService)) {
                    if (!curr) register(model);
                } else if (curr) deregister(model, curr);
            }
        };
        modelService.getModels().forEach((model)=>{
            if ((0, _semanticTokensConfigJs.isSemanticColoringEnabled)(model, themeService, configurationService)) register(model);
        });
        this._register(modelService.onModelAdded((model)=>{
            if ((0, _semanticTokensConfigJs.isSemanticColoringEnabled)(model, themeService, configurationService)) register(model);
        }));
        this._register(modelService.onModelRemoved((model)=>{
            const curr = this._watchers[model.uri.toString()];
            if (curr) deregister(model, curr);
        }));
        this._register(configurationService.onDidChangeConfiguration((e)=>{
            if (e.affectsConfiguration((0, _semanticTokensConfigJs.SEMANTIC_HIGHLIGHTING_SETTING_ID))) handleSettingOrThemeChange();
        }));
        this._register(themeService.onDidColorThemeChange(handleSettingOrThemeChange));
    }
    dispose() {
        // Dispose all watchers
        for (const watcher of Object.values(this._watchers))watcher.dispose();
        super.dispose();
    }
};
DocumentSemanticTokensFeature = __decorate([
    __param(0, (0, _semanticTokensStylingJs.ISemanticTokensStylingService)),
    __param(1, (0, _modelJs.IModelService)),
    __param(2, (0, _themeServiceJs.IThemeService)),
    __param(3, (0, _configurationJs.IConfigurationService)),
    __param(4, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService)),
    __param(5, (0, _languageFeaturesJs.ILanguageFeaturesService))
], DocumentSemanticTokensFeature);
let ModelSemanticColoring = class ModelSemanticColoring extends (0, _lifecycleJs.Disposable) {
    static{
        ModelSemanticColoring_1 = this;
    }
    static{
        this.REQUEST_MIN_DELAY = 300;
    }
    static{
        this.REQUEST_MAX_DELAY = 2000;
    }
    constructor(model, _semanticTokensStylingService, themeService, languageFeatureDebounceService, languageFeaturesService){
        super();
        this._semanticTokensStylingService = _semanticTokensStylingService;
        this._isDisposed = false;
        this._model = model;
        this._provider = languageFeaturesService.documentSemanticTokensProvider;
        this._debounceInformation = languageFeatureDebounceService.for(this._provider, "DocumentSemanticTokens", {
            min: ModelSemanticColoring_1.REQUEST_MIN_DELAY,
            max: ModelSemanticColoring_1.REQUEST_MAX_DELAY
        });
        this._fetchDocumentSemanticTokens = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._fetchDocumentSemanticTokensNow(), ModelSemanticColoring_1.REQUEST_MIN_DELAY));
        this._currentDocumentResponse = null;
        this._currentDocumentRequestCancellationTokenSource = null;
        this._documentProvidersChangeListeners = [];
        this._providersChangedDuringRequest = false;
        this._register(this._model.onDidChangeContent(()=>{
            if (!this._fetchDocumentSemanticTokens.isScheduled()) this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
        }));
        this._register(this._model.onDidChangeAttached(()=>{
            if (!this._fetchDocumentSemanticTokens.isScheduled()) this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
        }));
        this._register(this._model.onDidChangeLanguage(()=>{
            // clear any outstanding state
            if (this._currentDocumentResponse) {
                this._currentDocumentResponse.dispose();
                this._currentDocumentResponse = null;
            }
            if (this._currentDocumentRequestCancellationTokenSource) {
                this._currentDocumentRequestCancellationTokenSource.cancel();
                this._currentDocumentRequestCancellationTokenSource = null;
            }
            this._setDocumentSemanticTokens(null, null, null, []);
            this._fetchDocumentSemanticTokens.schedule(0);
        }));
        const bindDocumentChangeListeners = ()=>{
            (0, _lifecycleJs.dispose)(this._documentProvidersChangeListeners);
            this._documentProvidersChangeListeners = [];
            for (const provider of this._provider.all(model))if (typeof provider.onDidChange === "function") this._documentProvidersChangeListeners.push(provider.onDidChange(()=>{
                if (this._currentDocumentRequestCancellationTokenSource) {
                    // there is already a request running,
                    this._providersChangedDuringRequest = true;
                    return;
                }
                this._fetchDocumentSemanticTokens.schedule(0);
            }));
        };
        bindDocumentChangeListeners();
        this._register(this._provider.onDidChange(()=>{
            bindDocumentChangeListeners();
            this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
        }));
        this._register(themeService.onDidColorThemeChange((_)=>{
            // clear out existing tokens
            this._setDocumentSemanticTokens(null, null, null, []);
            this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
        }));
        this._fetchDocumentSemanticTokens.schedule(0);
    }
    dispose() {
        if (this._currentDocumentResponse) {
            this._currentDocumentResponse.dispose();
            this._currentDocumentResponse = null;
        }
        if (this._currentDocumentRequestCancellationTokenSource) {
            this._currentDocumentRequestCancellationTokenSource.cancel();
            this._currentDocumentRequestCancellationTokenSource = null;
        }
        (0, _lifecycleJs.dispose)(this._documentProvidersChangeListeners);
        this._documentProvidersChangeListeners = [];
        this._setDocumentSemanticTokens(null, null, null, []);
        this._isDisposed = true;
        super.dispose();
    }
    _fetchDocumentSemanticTokensNow() {
        if (this._currentDocumentRequestCancellationTokenSource) // there is already a request running, let it finish...
        return;
        if (!(0, _getSemanticTokensJs.hasDocumentSemanticTokensProvider)(this._provider, this._model)) {
            // there is no provider
            if (this._currentDocumentResponse) // there are semantic tokens set
            this._model.tokenization.setSemanticTokens(null, false);
            return;
        }
        if (!this._model.isAttachedToEditor()) // this document is not visible, there is no need to fetch semantic tokens for it
        return;
        const cancellationTokenSource = new (0, _cancellationJs.CancellationTokenSource)();
        const lastProvider = this._currentDocumentResponse ? this._currentDocumentResponse.provider : null;
        const lastResultId = this._currentDocumentResponse ? this._currentDocumentResponse.resultId || null : null;
        const request = (0, _getSemanticTokensJs.getDocumentSemanticTokens)(this._provider, this._model, lastProvider, lastResultId, cancellationTokenSource.token);
        this._currentDocumentRequestCancellationTokenSource = cancellationTokenSource;
        this._providersChangedDuringRequest = false;
        const pendingChanges = [];
        const contentChangeListener = this._model.onDidChangeContent((e)=>{
            pendingChanges.push(e);
        });
        const sw = new (0, _stopwatchJs.StopWatch)(false);
        request.then((res)=>{
            this._debounceInformation.update(this._model, sw.elapsed());
            this._currentDocumentRequestCancellationTokenSource = null;
            contentChangeListener.dispose();
            if (!res) this._setDocumentSemanticTokens(null, null, null, pendingChanges);
            else {
                const { provider, tokens } = res;
                const styling = this._semanticTokensStylingService.getStyling(provider);
                this._setDocumentSemanticTokens(provider, tokens || null, styling, pendingChanges);
            }
        }, (err)=>{
            const isExpectedError = err && (_errorsJs.isCancellationError(err) || typeof err.message === "string" && err.message.indexOf("busy") !== -1);
            if (!isExpectedError) _errorsJs.onUnexpectedError(err);
            // Semantic tokens eats up all errors and considers errors to mean that the result is temporarily not available
            // The API does not have a special error kind to express this...
            this._currentDocumentRequestCancellationTokenSource = null;
            contentChangeListener.dispose();
            if (pendingChanges.length > 0 || this._providersChangedDuringRequest) // More changes occurred while the request was running
            {
                if (!this._fetchDocumentSemanticTokens.isScheduled()) this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
            }
        });
    }
    static _copy(src, srcOffset, dest, destOffset, length) {
        // protect against overflows
        length = Math.min(length, dest.length - destOffset, src.length - srcOffset);
        for(let i = 0; i < length; i++)dest[destOffset + i] = src[srcOffset + i];
    }
    _setDocumentSemanticTokens(provider, tokens, styling, pendingChanges) {
        const currentResponse = this._currentDocumentResponse;
        const rescheduleIfNeeded = ()=>{
            if ((pendingChanges.length > 0 || this._providersChangedDuringRequest) && !this._fetchDocumentSemanticTokens.isScheduled()) this._fetchDocumentSemanticTokens.schedule(this._debounceInformation.get(this._model));
        };
        if (this._currentDocumentResponse) {
            this._currentDocumentResponse.dispose();
            this._currentDocumentResponse = null;
        }
        if (this._isDisposed) {
            // disposed!
            if (provider && tokens) provider.releaseDocumentSemanticTokens(tokens.resultId);
            return;
        }
        if (!provider || !styling) {
            this._model.tokenization.setSemanticTokens(null, false);
            return;
        }
        if (!tokens) {
            this._model.tokenization.setSemanticTokens(null, true);
            rescheduleIfNeeded();
            return;
        }
        if ((0, _getSemanticTokensJs.isSemanticTokensEdits)(tokens)) {
            if (!currentResponse) {
                // not possible!
                this._model.tokenization.setSemanticTokens(null, true);
                return;
            }
            if (tokens.edits.length === 0) // nothing to do!
            tokens = {
                resultId: tokens.resultId,
                data: currentResponse.data
            };
            else {
                let deltaLength = 0;
                for (const edit of tokens.edits)deltaLength += (edit.data ? edit.data.length : 0) - edit.deleteCount;
                const srcData = currentResponse.data;
                const destData = new Uint32Array(srcData.length + deltaLength);
                let srcLastStart = srcData.length;
                let destLastStart = destData.length;
                for(let i = tokens.edits.length - 1; i >= 0; i--){
                    const edit = tokens.edits[i];
                    if (edit.start > srcData.length) {
                        styling.warnInvalidEditStart(currentResponse.resultId, tokens.resultId, i, edit.start, srcData.length);
                        // The edits are invalid and there's no way to recover
                        this._model.tokenization.setSemanticTokens(null, true);
                        return;
                    }
                    const copyCount = srcLastStart - (edit.start + edit.deleteCount);
                    if (copyCount > 0) {
                        ModelSemanticColoring_1._copy(srcData, srcLastStart - copyCount, destData, destLastStart - copyCount, copyCount);
                        destLastStart -= copyCount;
                    }
                    if (edit.data) {
                        ModelSemanticColoring_1._copy(edit.data, 0, destData, destLastStart - edit.data.length, edit.data.length);
                        destLastStart -= edit.data.length;
                    }
                    srcLastStart = edit.start;
                }
                if (srcLastStart > 0) ModelSemanticColoring_1._copy(srcData, 0, destData, 0, srcLastStart);
                tokens = {
                    resultId: tokens.resultId,
                    data: destData
                };
            }
        }
        if ((0, _getSemanticTokensJs.isSemanticTokens)(tokens)) {
            this._currentDocumentResponse = new SemanticTokensResponse(provider, tokens.resultId, tokens.data);
            const result = (0, _semanticTokensProviderStylingJs.toMultilineTokens2)(tokens, styling, this._model.getLanguageId());
            // Adjust incoming semantic tokens
            if (pendingChanges.length > 0) // More changes occurred while the request was running
            // We need to:
            // 1. Adjust incoming semantic tokens
            // 2. Request them again
            for (const change of pendingChanges){
                for (const area of result)for (const singleChange of change.changes)area.applyEdit(singleChange.range, singleChange.text);
            }
            this._model.tokenization.setSemanticTokens(result, true);
        } else this._model.tokenization.setSemanticTokens(null, true);
        rescheduleIfNeeded();
    }
};
ModelSemanticColoring = ModelSemanticColoring_1 = __decorate([
    __param(1, (0, _semanticTokensStylingJs.ISemanticTokensStylingService)),
    __param(2, (0, _themeServiceJs.IThemeService)),
    __param(3, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService)),
    __param(4, (0, _languageFeaturesJs.ILanguageFeaturesService))
], ModelSemanticColoring);
class SemanticTokensResponse {
    constructor(provider, resultId, data){
        this.provider = provider;
        this.resultId = resultId;
        this.data = data;
    }
    dispose() {
        this.provider.releaseDocumentSemanticTokens(this.resultId);
    }
}
(0, _editorFeaturesJs.registerEditorFeature)(DocumentSemanticTokensFeature);

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/errors.js":"divX8","../../../common/services/model.js":"aciVm","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../platform/theme/common/themeService.js":"jMkIC","../../../common/services/semanticTokensProviderStyling.js":"3j70w","../common/getSemanticTokens.js":"apSlQ","../../../common/services/languageFeatureDebounce.js":"YGXXG","../../../../base/common/stopwatch.js":"77PF9","../../../common/services/languageFeatures.js":"2IAko","../../../common/services/semanticTokensStyling.js":"gV4Rk","../../../common/editorFeatures.js":"8AkS3","../common/semanticTokensConfig.js":"a2Apo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"apSlQ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSemanticTokens", ()=>isSemanticTokens);
parcelHelpers.export(exports, "isSemanticTokensEdits", ()=>isSemanticTokensEdits);
parcelHelpers.export(exports, "DocumentSemanticTokensResult", ()=>DocumentSemanticTokensResult);
parcelHelpers.export(exports, "hasDocumentSemanticTokensProvider", ()=>hasDocumentSemanticTokensProvider);
parcelHelpers.export(exports, "getDocumentSemanticTokens", ()=>getDocumentSemanticTokens);
parcelHelpers.export(exports, "hasDocumentRangeSemanticTokensProvider", ()=>hasDocumentRangeSemanticTokensProvider);
parcelHelpers.export(exports, "getDocumentRangeSemanticTokens", ()=>getDocumentRangeSemanticTokens);
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _uriJs = require("../../../../base/common/uri.js");
var _modelJs = require("../../../common/services/model.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _typesJs = require("../../../../base/common/types.js");
var _semanticTokensDtoJs = require("../../../common/services/semanticTokensDto.js");
var _rangeJs = require("../../../common/core/range.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
function isSemanticTokens(v) {
    return v && !!v.data;
}
function isSemanticTokensEdits(v) {
    return v && Array.isArray(v.edits);
}
class DocumentSemanticTokensResult {
    constructor(provider, tokens, error){
        this.provider = provider;
        this.tokens = tokens;
        this.error = error;
    }
}
function hasDocumentSemanticTokensProvider(registry, model) {
    return registry.has(model);
}
function getDocumentSemanticTokensProviders(registry, model) {
    const groups = registry.orderedGroups(model);
    return groups.length > 0 ? groups[0] : [];
}
async function getDocumentSemanticTokens(registry, model, lastProvider, lastResultId, token) {
    const providers = getDocumentSemanticTokensProviders(registry, model);
    // Get tokens from all providers at the same time.
    const results = await Promise.all(providers.map(async (provider)=>{
        let result;
        let error = null;
        try {
            result = await provider.provideDocumentSemanticTokens(model, provider === lastProvider ? lastResultId : null, token);
        } catch (err) {
            error = err;
            result = null;
        }
        if (!result || !isSemanticTokens(result) && !isSemanticTokensEdits(result)) result = null;
        return new DocumentSemanticTokensResult(provider, result, error);
    }));
    // Try to return the first result with actual tokens or
    // the first result which threw an error (!!)
    for (const result of results){
        if (result.error) throw result.error;
        if (result.tokens) return result;
    }
    // Return the first result, even if it doesn't have tokens
    if (results.length > 0) return results[0];
    return null;
}
function _getDocumentSemanticTokensProviderHighestGroup(registry, model) {
    const result = registry.orderedGroups(model);
    return result.length > 0 ? result[0] : null;
}
class DocumentRangeSemanticTokensResult {
    constructor(provider, tokens){
        this.provider = provider;
        this.tokens = tokens;
    }
}
function hasDocumentRangeSemanticTokensProvider(providers, model) {
    return providers.has(model);
}
function getDocumentRangeSemanticTokensProviders(providers, model) {
    const groups = providers.orderedGroups(model);
    return groups.length > 0 ? groups[0] : [];
}
async function getDocumentRangeSemanticTokens(registry, model, range, token) {
    const providers = getDocumentRangeSemanticTokensProviders(registry, model);
    // Get tokens from all providers at the same time.
    const results = await Promise.all(providers.map(async (provider)=>{
        let result;
        try {
            result = await provider.provideDocumentRangeSemanticTokens(model, range, token);
        } catch (err) {
            (0, _errorsJs.onUnexpectedExternalError)(err);
            result = null;
        }
        if (!result || !isSemanticTokens(result)) result = null;
        return new DocumentRangeSemanticTokensResult(provider, result);
    }));
    // Try to return the first result with actual tokens
    for (const result of results){
        if (result.tokens) return result;
    }
    // Return the first result, even if it doesn't have tokens
    if (results.length > 0) return results[0];
    return null;
}
(0, _commandsJs.CommandsRegistry).registerCommand("_provideDocumentSemanticTokensLegend", async (accessor, ...args)=>{
    const [uri] = args;
    (0, _typesJs.assertType)(uri instanceof (0, _uriJs.URI));
    const model = accessor.get((0, _modelJs.IModelService)).getModel(uri);
    if (!model) return undefined;
    const { documentSemanticTokensProvider } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const providers = _getDocumentSemanticTokensProviderHighestGroup(documentSemanticTokensProvider, model);
    if (!providers) // there is no provider => fall back to a document range semantic tokens provider
    return accessor.get((0, _commandsJs.ICommandService)).executeCommand("_provideDocumentRangeSemanticTokensLegend", uri);
    return providers[0].getLegend();
});
(0, _commandsJs.CommandsRegistry).registerCommand("_provideDocumentSemanticTokens", async (accessor, ...args)=>{
    const [uri] = args;
    (0, _typesJs.assertType)(uri instanceof (0, _uriJs.URI));
    const model = accessor.get((0, _modelJs.IModelService)).getModel(uri);
    if (!model) return undefined;
    const { documentSemanticTokensProvider } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    if (!hasDocumentSemanticTokensProvider(documentSemanticTokensProvider, model)) // there is no provider => fall back to a document range semantic tokens provider
    return accessor.get((0, _commandsJs.ICommandService)).executeCommand("_provideDocumentRangeSemanticTokens", uri, model.getFullModelRange());
    const r = await getDocumentSemanticTokens(documentSemanticTokensProvider, model, null, null, (0, _cancellationJs.CancellationToken).None);
    if (!r) return undefined;
    const { provider, tokens } = r;
    if (!tokens || !isSemanticTokens(tokens)) return undefined;
    const buff = (0, _semanticTokensDtoJs.encodeSemanticTokensDto)({
        id: 0,
        type: "full",
        data: tokens.data
    });
    if (tokens.resultId) provider.releaseDocumentSemanticTokens(tokens.resultId);
    return buff;
});
(0, _commandsJs.CommandsRegistry).registerCommand("_provideDocumentRangeSemanticTokensLegend", async (accessor, ...args)=>{
    const [uri, range] = args;
    (0, _typesJs.assertType)(uri instanceof (0, _uriJs.URI));
    const model = accessor.get((0, _modelJs.IModelService)).getModel(uri);
    if (!model) return undefined;
    const { documentRangeSemanticTokensProvider } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const providers = getDocumentRangeSemanticTokensProviders(documentRangeSemanticTokensProvider, model);
    if (providers.length === 0) // no providers
    return undefined;
    if (providers.length === 1) // straight forward case, just a single provider
    return providers[0].getLegend();
    if (!range || !(0, _rangeJs.Range).isIRange(range)) {
        // if no range is provided, we cannot support multiple providers
        // as we cannot fall back to the one which would give results
        // => return the first legend for backwards compatibility and print a warning
        console.warn(`provideDocumentRangeSemanticTokensLegend might be out-of-sync with provideDocumentRangeSemanticTokens unless a range argument is passed in`);
        return providers[0].getLegend();
    }
    const result = await getDocumentRangeSemanticTokens(documentRangeSemanticTokensProvider, model, (0, _rangeJs.Range).lift(range), (0, _cancellationJs.CancellationToken).None);
    if (!result) return undefined;
    return result.provider.getLegend();
});
(0, _commandsJs.CommandsRegistry).registerCommand("_provideDocumentRangeSemanticTokens", async (accessor, ...args)=>{
    const [uri, range] = args;
    (0, _typesJs.assertType)(uri instanceof (0, _uriJs.URI));
    (0, _typesJs.assertType)((0, _rangeJs.Range).isIRange(range));
    const model = accessor.get((0, _modelJs.IModelService)).getModel(uri);
    if (!model) return undefined;
    const { documentRangeSemanticTokensProvider } = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const result = await getDocumentRangeSemanticTokens(documentRangeSemanticTokensProvider, model, (0, _rangeJs.Range).lift(range), (0, _cancellationJs.CancellationToken).None);
    if (!result || !result.tokens) // there is no provider or it didn't return tokens
    return undefined;
    return (0, _semanticTokensDtoJs.encodeSemanticTokensDto)({
        id: 0,
        type: "full",
        data: result.tokens.data
    });
});

},{"../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/uri.js":"7qGS3","../../../common/services/model.js":"aciVm","../../../../platform/commands/common/commands.js":"ho6ic","../../../../base/common/types.js":"fb5yx","../../../common/services/semanticTokensDto.js":"1HqaJ","../../../common/core/range.js":"jmUPh","../../../common/services/languageFeatures.js":"2IAko","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1HqaJ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encodeSemanticTokensDto", ()=>encodeSemanticTokensDto);
var _bufferJs = require("../../../base/common/buffer.js");
var _platformJs = require("../../../base/common/platform.js");
function reverseEndianness(arr) {
    for(let i = 0, len = arr.length; i < len; i += 4){
        // flip bytes 0<->3 and 1<->2
        const b0 = arr[i + 0];
        const b1 = arr[i + 1];
        const b2 = arr[i + 2];
        const b3 = arr[i + 3];
        arr[i + 0] = b3;
        arr[i + 1] = b2;
        arr[i + 2] = b1;
        arr[i + 3] = b0;
    }
}
function toLittleEndianBuffer(arr) {
    const uint8Arr = new Uint8Array(arr.buffer, arr.byteOffset, arr.length * 4);
    if (!_platformJs.isLittleEndian()) // the byte order must be changed
    reverseEndianness(uint8Arr);
    return (0, _bufferJs.VSBuffer).wrap(uint8Arr);
}
function encodeSemanticTokensDto(semanticTokens) {
    const dest = new Uint32Array(encodeSemanticTokensDtoSize(semanticTokens));
    let offset = 0;
    dest[offset++] = semanticTokens.id;
    if (semanticTokens.type === "full") {
        dest[offset++] = 1 /* EncodedSemanticTokensType.Full */ ;
        dest[offset++] = semanticTokens.data.length;
        dest.set(semanticTokens.data, offset);
        offset += semanticTokens.data.length;
    } else {
        dest[offset++] = 2 /* EncodedSemanticTokensType.Delta */ ;
        dest[offset++] = semanticTokens.deltas.length;
        for (const delta of semanticTokens.deltas){
            dest[offset++] = delta.start;
            dest[offset++] = delta.deleteCount;
            if (delta.data) {
                dest[offset++] = delta.data.length;
                dest.set(delta.data, offset);
                offset += delta.data.length;
            } else dest[offset++] = 0;
        }
    }
    return toLittleEndianBuffer(dest);
}
function encodeSemanticTokensDtoSize(semanticTokens) {
    let result = 0;
    result += 2 // type
    ;
    if (semanticTokens.type === "full") result += 1 // data length
     + semanticTokens.data.length;
    else {
        result += 1 // delta count
        ;
        result += 3 // data length
         * semanticTokens.deltas.length;
        for (const delta of semanticTokens.deltas)if (delta.data) result += delta.data.length;
    }
    return result;
}

},{"../../../base/common/buffer.js":"cRDFR","../../../base/common/platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a2Apo":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEMANTIC_HIGHLIGHTING_SETTING_ID", ()=>SEMANTIC_HIGHLIGHTING_SETTING_ID);
parcelHelpers.export(exports, "isSemanticColoringEnabled", ()=>isSemanticColoringEnabled);
const SEMANTIC_HIGHLIGHTING_SETTING_ID = "editor.semanticHighlighting";
function isSemanticColoringEnabled(model, themeService, configurationService) {
    const setting = configurationService.getValue(SEMANTIC_HIGHLIGHTING_SETTING_ID, {
        overrideIdentifier: model.getLanguageId(),
        resource: model.uri
    })?.enabled;
    if (typeof setting === "boolean") return setting;
    return themeService.getColorTheme().semanticHighlighting;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"mYHoZ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewportSemanticTokensContribution", ()=>ViewportSemanticTokensContribution);
var _asyncJs = require("../../../../base/common/async.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _getSemanticTokensJs = require("../common/getSemanticTokens.js");
var _semanticTokensConfigJs = require("../common/semanticTokensConfig.js");
var _semanticTokensProviderStylingJs = require("../../../common/services/semanticTokensProviderStyling.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _languageFeatureDebounceJs = require("../../../common/services/languageFeatureDebounce.js");
var _stopwatchJs = require("../../../../base/common/stopwatch.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _semanticTokensStylingJs = require("../../../common/services/semanticTokensStyling.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let ViewportSemanticTokensContribution = class ViewportSemanticTokensContribution extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.viewportSemanticTokens";
    }
    constructor(editor, _semanticTokensStylingService, _themeService, _configurationService, languageFeatureDebounceService, languageFeaturesService){
        super();
        this._semanticTokensStylingService = _semanticTokensStylingService;
        this._themeService = _themeService;
        this._configurationService = _configurationService;
        this._editor = editor;
        this._provider = languageFeaturesService.documentRangeSemanticTokensProvider;
        this._debounceInformation = languageFeatureDebounceService.for(this._provider, "DocumentRangeSemanticTokens", {
            min: 100,
            max: 500
        });
        this._tokenizeViewport = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._tokenizeViewportNow(), 100));
        this._outstandingRequests = [];
        const scheduleTokenizeViewport = ()=>{
            if (this._editor.hasModel()) this._tokenizeViewport.schedule(this._debounceInformation.get(this._editor.getModel()));
        };
        this._register(this._editor.onDidScrollChange(()=>{
            scheduleTokenizeViewport();
        }));
        this._register(this._editor.onDidChangeModel(()=>{
            this._cancelAll();
            scheduleTokenizeViewport();
        }));
        this._register(this._editor.onDidChangeModelContent((e)=>{
            this._cancelAll();
            scheduleTokenizeViewport();
        }));
        this._register(this._provider.onDidChange(()=>{
            this._cancelAll();
            scheduleTokenizeViewport();
        }));
        this._register(this._configurationService.onDidChangeConfiguration((e)=>{
            if (e.affectsConfiguration((0, _semanticTokensConfigJs.SEMANTIC_HIGHLIGHTING_SETTING_ID))) {
                this._cancelAll();
                scheduleTokenizeViewport();
            }
        }));
        this._register(this._themeService.onDidColorThemeChange(()=>{
            this._cancelAll();
            scheduleTokenizeViewport();
        }));
        scheduleTokenizeViewport();
    }
    _cancelAll() {
        for (const request of this._outstandingRequests)request.cancel();
        this._outstandingRequests = [];
    }
    _removeOutstandingRequest(req) {
        for(let i = 0, len = this._outstandingRequests.length; i < len; i++)if (this._outstandingRequests[i] === req) {
            this._outstandingRequests.splice(i, 1);
            return;
        }
    }
    _tokenizeViewportNow() {
        if (!this._editor.hasModel()) return;
        const model = this._editor.getModel();
        if (model.tokenization.hasCompleteSemanticTokens()) return;
        if (!(0, _semanticTokensConfigJs.isSemanticColoringEnabled)(model, this._themeService, this._configurationService)) {
            if (model.tokenization.hasSomeSemanticTokens()) model.tokenization.setSemanticTokens(null, false);
            return;
        }
        if (!(0, _getSemanticTokensJs.hasDocumentRangeSemanticTokensProvider)(this._provider, model)) {
            if (model.tokenization.hasSomeSemanticTokens()) model.tokenization.setSemanticTokens(null, false);
            return;
        }
        const visibleRanges = this._editor.getVisibleRangesPlusViewportAboveBelow();
        this._outstandingRequests = this._outstandingRequests.concat(visibleRanges.map((range)=>this._requestRange(model, range)));
    }
    _requestRange(model, range) {
        const requestVersionId = model.getVersionId();
        const request = (0, _asyncJs.createCancelablePromise)((token)=>Promise.resolve((0, _getSemanticTokensJs.getDocumentRangeSemanticTokens)(this._provider, model, range, token)));
        const sw = new (0, _stopwatchJs.StopWatch)(false);
        request.then((r)=>{
            this._debounceInformation.update(model, sw.elapsed());
            if (!r || !r.tokens || model.isDisposed() || model.getVersionId() !== requestVersionId) return;
            const { provider, tokens: result } = r;
            const styling = this._semanticTokensStylingService.getStyling(provider);
            model.tokenization.setPartialSemanticTokens(range, (0, _semanticTokensProviderStylingJs.toMultilineTokens2)(result, styling, model.getLanguageId()));
        }).then(()=>this._removeOutstandingRequest(request), ()=>this._removeOutstandingRequest(request));
        return request;
    }
};
ViewportSemanticTokensContribution = __decorate([
    __param(1, (0, _semanticTokensStylingJs.ISemanticTokensStylingService)),
    __param(2, (0, _themeServiceJs.IThemeService)),
    __param(3, (0, _configurationJs.IConfigurationService)),
    __param(4, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService)),
    __param(5, (0, _languageFeaturesJs.ILanguageFeaturesService))
], ViewportSemanticTokensContribution);
(0, _editorExtensionsJs.registerEditorContribution)(ViewportSemanticTokensContribution.ID, ViewportSemanticTokensContribution, 1 /* EditorContributionInstantiation.AfterFirstRender */ );

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorExtensions.js":"kC3w6","../common/getSemanticTokens.js":"apSlQ","../common/semanticTokensConfig.js":"a2Apo","../../../common/services/semanticTokensProviderStyling.js":"3j70w","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/theme/common/themeService.js":"jMkIC","../../../common/services/languageFeatureDebounce.js":"YGXXG","../../../../base/common/stopwatch.js":"77PF9","../../../common/services/languageFeatures.js":"2IAko","../../../common/services/semanticTokensStyling.js":"gV4Rk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hWC3V":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmartSelectController", ()=>SmartSelectController);
parcelHelpers.export(exports, "provideSelectionRanges", ()=>provideSelectionRanges);
var _arraysJs = require("../../../../base/common/arrays.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _bracketSelectionsJs = require("./bracketSelections.js");
var _wordSelectionsJs = require("./wordSelections.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _resolverServiceJs = require("../../../common/services/resolverService.js");
var _typesJs = require("../../../../base/common/types.js");
var _uriJs = require("../../../../base/common/uri.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var SmartSelectController_1;
class SelectionRanges {
    constructor(index, ranges){
        this.index = index;
        this.ranges = ranges;
    }
    mov(fwd) {
        const index = this.index + (fwd ? 1 : -1);
        if (index < 0 || index >= this.ranges.length) return this;
        const res = new SelectionRanges(index, this.ranges);
        if (res.ranges[index].equalsRange(this.ranges[this.index])) // next range equals this range, retry with next-next
        return res.mov(fwd);
        return res;
    }
}
let SmartSelectController = class SmartSelectController {
    static{
        SmartSelectController_1 = this;
    }
    static{
        this.ID = "editor.contrib.smartSelectController";
    }
    static get(editor) {
        return editor.getContribution(SmartSelectController_1.ID);
    }
    constructor(_editor, _languageFeaturesService){
        this._editor = _editor;
        this._languageFeaturesService = _languageFeaturesService;
        this._ignoreSelection = false;
    }
    dispose() {
        this._selectionListener?.dispose();
    }
    async run(forward) {
        if (!this._editor.hasModel()) return;
        const selections = this._editor.getSelections();
        const model = this._editor.getModel();
        if (!this._state) await provideSelectionRanges(this._languageFeaturesService.selectionRangeProvider, model, selections.map((s)=>s.getPosition()), this._editor.getOption(114 /* EditorOption.smartSelect */ ), (0, _cancellationJs.CancellationToken).None).then((ranges)=>{
            if (!_arraysJs.isNonEmptyArray(ranges) || ranges.length !== selections.length) // invalid result
            return;
            if (!this._editor.hasModel() || !_arraysJs.equals(this._editor.getSelections(), selections, (a, b)=>a.equalsSelection(b))) // invalid editor state
            return;
            for(let i = 0; i < ranges.length; i++){
                ranges[i] = ranges[i].filter((range)=>{
                    // filter ranges inside the selection
                    return range.containsPosition(selections[i].getStartPosition()) && range.containsPosition(selections[i].getEndPosition());
                });
                // prepend current selection
                ranges[i].unshift(selections[i]);
            }
            this._state = ranges.map((ranges)=>new SelectionRanges(0, ranges));
            // listen to caret move and forget about state
            this._selectionListener?.dispose();
            this._selectionListener = this._editor.onDidChangeCursorPosition(()=>{
                if (!this._ignoreSelection) {
                    this._selectionListener?.dispose();
                    this._state = undefined;
                }
            });
        });
        if (!this._state) // no state
        return;
        this._state = this._state.map((state)=>state.mov(forward));
        const newSelections = this._state.map((state)=>(0, _selectionJs.Selection).fromPositions(state.ranges[state.index].getStartPosition(), state.ranges[state.index].getEndPosition()));
        this._ignoreSelection = true;
        try {
            this._editor.setSelections(newSelections);
        } finally{
            this._ignoreSelection = false;
        }
    }
};
SmartSelectController = SmartSelectController_1 = __decorate([
    __param(1, (0, _languageFeaturesJs.ILanguageFeaturesService))
], SmartSelectController);
class AbstractSmartSelect extends (0, _editorExtensionsJs.EditorAction) {
    constructor(forward, opts){
        super(opts);
        this._forward = forward;
    }
    async run(_accessor, editor) {
        const controller = SmartSelectController.get(editor);
        if (controller) await controller.run(this._forward);
    }
}
class GrowSelectionAction extends AbstractSmartSelect {
    constructor(){
        super(true, {
            id: "editor.action.smartSelect.expand",
            label: _nlsJs.localize("smartSelect.expand", "Expand Selection"),
            alias: "Expand Selection",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 1553 /* KeyCode.RightArrow */ ,
                mac: {
                    primary: 3345 /* KeyCode.RightArrow */ ,
                    secondary: [
                        1297 /* KeyCode.RightArrow */ 
                    ]
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "1_basic",
                title: _nlsJs.localize({
                    key: "miSmartSelectGrow",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "&&Expand Selection"),
                order: 2
            }
        });
    }
}
// renamed command id
(0, _commandsJs.CommandsRegistry).registerCommandAlias("editor.action.smartSelect.grow", "editor.action.smartSelect.expand");
class ShrinkSelectionAction extends AbstractSmartSelect {
    constructor(){
        super(false, {
            id: "editor.action.smartSelect.shrink",
            label: _nlsJs.localize("smartSelect.shrink", "Shrink Selection"),
            alias: "Shrink Selection",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 1551 /* KeyCode.LeftArrow */ ,
                mac: {
                    primary: 3343 /* KeyCode.LeftArrow */ ,
                    secondary: [
                        1295 /* KeyCode.LeftArrow */ 
                    ]
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            menuOpts: {
                menuId: (0, _actionsJs.MenuId).MenubarSelectionMenu,
                group: "1_basic",
                title: _nlsJs.localize({
                    key: "miSmartSelectShrink",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "&&Shrink Selection"),
                order: 3
            }
        });
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(SmartSelectController.ID, SmartSelectController, 4 /* EditorContributionInstantiation.Lazy */ );
(0, _editorExtensionsJs.registerEditorAction)(GrowSelectionAction);
(0, _editorExtensionsJs.registerEditorAction)(ShrinkSelectionAction);
async function provideSelectionRanges(registry, model, positions, options, token) {
    const providers = registry.all(model).concat(new (0, _wordSelectionsJs.WordSelectionRangeProvider)(options.selectSubwords)); // ALWAYS have word based selection range
    if (providers.length === 1) // add word selection and bracket selection when no provider exists
    providers.unshift(new (0, _bracketSelectionsJs.BracketSelectionRangeProvider)());
    const work = [];
    const allRawRanges = [];
    for (const provider of providers)work.push(Promise.resolve(provider.provideSelectionRanges(model, positions, token)).then((allProviderRanges)=>{
        if (_arraysJs.isNonEmptyArray(allProviderRanges) && allProviderRanges.length === positions.length) for(let i = 0; i < positions.length; i++){
            if (!allRawRanges[i]) allRawRanges[i] = [];
            for (const oneProviderRanges of allProviderRanges[i])if ((0, _rangeJs.Range).isIRange(oneProviderRanges.range) && (0, _rangeJs.Range).containsPosition(oneProviderRanges.range, positions[i])) allRawRanges[i].push((0, _rangeJs.Range).lift(oneProviderRanges.range));
        }
    }, (0, _errorsJs.onUnexpectedExternalError)));
    await Promise.all(work);
    return allRawRanges.map((oneRawRanges)=>{
        if (oneRawRanges.length === 0) return [];
        // sort all by start/end position
        oneRawRanges.sort((a, b)=>{
            if ((0, _positionJs.Position).isBefore(a.getStartPosition(), b.getStartPosition())) return 1;
            else if ((0, _positionJs.Position).isBefore(b.getStartPosition(), a.getStartPosition())) return -1;
            else if ((0, _positionJs.Position).isBefore(a.getEndPosition(), b.getEndPosition())) return -1;
            else if ((0, _positionJs.Position).isBefore(b.getEndPosition(), a.getEndPosition())) return 1;
            else return 0;
        });
        // remove ranges that don't contain the former range or that are equal to the
        // former range
        const oneRanges = [];
        let last;
        for (const range of oneRawRanges)if (!last || (0, _rangeJs.Range).containsRange(range, last) && !(0, _rangeJs.Range).equalsRange(range, last)) {
            oneRanges.push(range);
            last = range;
        }
        if (!options.selectLeadingAndTrailingWhitespace) return oneRanges;
        // add ranges that expand trivia at line starts and ends whenever a range
        // wraps onto the a new line
        const oneRangesWithTrivia = [
            oneRanges[0]
        ];
        for(let i = 1; i < oneRanges.length; i++){
            const prev = oneRanges[i - 1];
            const cur = oneRanges[i];
            if (cur.startLineNumber !== prev.startLineNumber || cur.endLineNumber !== prev.endLineNumber) {
                // add line/block range without leading/failing whitespace
                const rangeNoWhitespace = new (0, _rangeJs.Range)(prev.startLineNumber, model.getLineFirstNonWhitespaceColumn(prev.startLineNumber), prev.endLineNumber, model.getLineLastNonWhitespaceColumn(prev.endLineNumber));
                if (rangeNoWhitespace.containsRange(prev) && !rangeNoWhitespace.equalsRange(prev) && cur.containsRange(rangeNoWhitespace) && !cur.equalsRange(rangeNoWhitespace)) oneRangesWithTrivia.push(rangeNoWhitespace);
                // add line/block range
                const rangeFull = new (0, _rangeJs.Range)(prev.startLineNumber, 1, prev.endLineNumber, model.getLineMaxColumn(prev.endLineNumber));
                if (rangeFull.containsRange(prev) && !rangeFull.equalsRange(rangeNoWhitespace) && cur.containsRange(rangeFull) && !cur.equalsRange(rangeFull)) oneRangesWithTrivia.push(rangeFull);
            }
            oneRangesWithTrivia.push(cur);
        }
        return oneRangesWithTrivia;
    });
}
(0, _commandsJs.CommandsRegistry).registerCommand("_executeSelectionRangeProvider", async function(accessor, ...args) {
    const [resource, positions] = args;
    (0, _typesJs.assertType)((0, _uriJs.URI).isUri(resource));
    const registry = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService)).selectionRangeProvider;
    const reference = await accessor.get((0, _resolverServiceJs.ITextModelService)).createModelReference(resource);
    try {
        return provideSelectionRanges(registry, reference.object.textEditorModel, positions, {
            selectLeadingAndTrailingWhitespace: true,
            selectSubwords: true
        }, (0, _cancellationJs.CancellationToken).None);
    } finally{
        reference.dispose();
    }
});

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../browser/editorExtensions.js":"kC3w6","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/editorContextKeys.js":"5exv9","./bracketSelections.js":"9vFwf","./wordSelections.js":"5LOho","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/commands/common/commands.js":"ho6ic","../../../common/services/languageFeatures.js":"2IAko","../../../common/services/resolverService.js":"ezAtF","../../../../base/common/types.js":"fb5yx","../../../../base/common/uri.js":"7qGS3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5LOho":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WordSelectionRangeProvider", ()=>WordSelectionRangeProvider);
var _stringsJs = require("../../../../base/common/strings.js");
var _rangeJs = require("../../../common/core/range.js");
class WordSelectionRangeProvider {
    constructor(selectSubwords = true){
        this.selectSubwords = selectSubwords;
    }
    provideSelectionRanges(model, positions) {
        const result = [];
        for (const position of positions){
            const bucket = [];
            result.push(bucket);
            if (this.selectSubwords) this._addInWordRanges(bucket, model, position);
            this._addWordRanges(bucket, model, position);
            this._addWhitespaceLine(bucket, model, position);
            bucket.push({
                range: model.getFullModelRange()
            });
        }
        return result;
    }
    _addInWordRanges(bucket, model, pos) {
        const obj = model.getWordAtPosition(pos);
        if (!obj) return;
        const { word, startColumn } = obj;
        const offset = pos.column - startColumn;
        let start = offset;
        let end = offset;
        let lastCh = 0;
        // LEFT anchor (start)
        for(; start >= 0; start--){
            const ch = word.charCodeAt(start);
            if (start !== offset && (ch === 95 /* CharCode.Underline */  || ch === 45 /* CharCode.Dash */ )) break;
            else if ((0, _stringsJs.isLowerAsciiLetter)(ch) && (0, _stringsJs.isUpperAsciiLetter)(lastCh)) break;
            lastCh = ch;
        }
        start += 1;
        // RIGHT anchor (end)
        for(; end < word.length; end++){
            const ch = word.charCodeAt(end);
            if ((0, _stringsJs.isUpperAsciiLetter)(ch) && (0, _stringsJs.isLowerAsciiLetter)(lastCh)) break;
            else if (ch === 95 /* CharCode.Underline */  || ch === 45 /* CharCode.Dash */ ) break;
            lastCh = ch;
        }
        if (start < end) bucket.push({
            range: new (0, _rangeJs.Range)(pos.lineNumber, startColumn + start, pos.lineNumber, startColumn + end)
        });
    }
    _addWordRanges(bucket, model, pos) {
        const word = model.getWordAtPosition(pos);
        if (word) bucket.push({
            range: new (0, _rangeJs.Range)(pos.lineNumber, word.startColumn, pos.lineNumber, word.endColumn)
        });
    }
    _addWhitespaceLine(bucket, model, pos) {
        if (model.getLineLength(pos.lineNumber) > 0 && model.getLineFirstNonWhitespaceColumn(pos.lineNumber) === 0 && model.getLineLastNonWhitespaceColumn(pos.lineNumber) === 0) bucket.push({
            range: new (0, _rangeJs.Range)(pos.lineNumber, 1, pos.lineNumber, model.getLineMaxColumn(pos.lineNumber))
        });
    }
}

},{"../../../../base/common/strings.js":"aA9I1","../../../common/core/range.js":"jmUPh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"362Xt":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _stickyScrollActionsJs = require("./stickyScrollActions.js");
var _stickyScrollControllerJs = require("./stickyScrollController.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
(0, _editorExtensionsJs.registerEditorContribution)((0, _stickyScrollControllerJs.StickyScrollController).ID, (0, _stickyScrollControllerJs.StickyScrollController), 1 /* EditorContributionInstantiation.AfterFirstRender */ );
(0, _actionsJs.registerAction2)((0, _stickyScrollActionsJs.ToggleStickyScroll));
(0, _actionsJs.registerAction2)((0, _stickyScrollActionsJs.FocusStickyScroll));
(0, _actionsJs.registerAction2)((0, _stickyScrollActionsJs.SelectPreviousStickyScrollLine));
(0, _actionsJs.registerAction2)((0, _stickyScrollActionsJs.SelectNextStickyScrollLine));
(0, _actionsJs.registerAction2)((0, _stickyScrollActionsJs.GoToStickyScrollLine));
(0, _actionsJs.registerAction2)((0, _stickyScrollActionsJs.SelectEditor));

},{"../../../browser/editorExtensions.js":"kC3w6","./stickyScrollActions.js":"2t0CL","./stickyScrollController.js":"fdm4n","../../../../platform/actions/common/actions.js":"kyMtp"}],"2t0CL":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleStickyScroll", ()=>ToggleStickyScroll);
parcelHelpers.export(exports, "FocusStickyScroll", ()=>FocusStickyScroll);
parcelHelpers.export(exports, "SelectNextStickyScrollLine", ()=>SelectNextStickyScrollLine);
parcelHelpers.export(exports, "SelectPreviousStickyScrollLine", ()=>SelectPreviousStickyScrollLine);
parcelHelpers.export(exports, "GoToStickyScrollLine", ()=>GoToStickyScrollLine);
parcelHelpers.export(exports, "SelectEditor", ()=>SelectEditor);
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _nlsJs = require("../../../../nls.js");
var _actionCommonCategoriesJs = require("../../../../platform/action/common/actionCommonCategories.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _stickyScrollControllerJs = require("./stickyScrollController.js");
class ToggleStickyScroll extends (0, _actionsJs.Action2) {
    constructor(){
        super({
            id: "editor.action.toggleStickyScroll",
            title: {
                ...(0, _nlsJs.localize2)("toggleEditorStickyScroll", "Toggle Editor Sticky Scroll"),
                mnemonicTitle: (0, _nlsJs.localize)({
                    key: "mitoggleStickyScroll",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "&&Toggle Editor Sticky Scroll")
            },
            metadata: {
                description: (0, _nlsJs.localize2)("toggleEditorStickyScroll.description", "Toggle/enable the editor sticky scroll which shows the nested scopes at the top of the viewport")
            },
            category: (0, _actionCommonCategoriesJs.Categories).View,
            toggled: {
                condition: (0, _contextkeyJs.ContextKeyExpr).equals("config.editor.stickyScroll.enabled", true),
                title: (0, _nlsJs.localize)("stickyScroll", "Sticky Scroll"),
                mnemonicTitle: (0, _nlsJs.localize)({
                    key: "miStickyScroll",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "&&Sticky Scroll")
            },
            menu: [
                {
                    id: (0, _actionsJs.MenuId).CommandPalette
                },
                {
                    id: (0, _actionsJs.MenuId).MenubarAppearanceMenu,
                    group: "4_editor",
                    order: 3
                },
                {
                    id: (0, _actionsJs.MenuId).StickyScrollContext
                }
            ]
        });
    }
    async run(accessor) {
        const configurationService = accessor.get((0, _configurationJs.IConfigurationService));
        const newValue = !configurationService.getValue("editor.stickyScroll.enabled");
        return configurationService.updateValue("editor.stickyScroll.enabled", newValue);
    }
}
const weight = 100 /* KeybindingWeight.EditorContrib */ ;
class FocusStickyScroll extends (0, _editorExtensionsJs.EditorAction2) {
    constructor(){
        super({
            id: "editor.action.focusStickyScroll",
            title: {
                ...(0, _nlsJs.localize2)("focusStickyScroll", "Focus on the editor sticky scroll"),
                mnemonicTitle: (0, _nlsJs.localize)({
                    key: "mifocusStickyScroll",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "&&Focus Sticky Scroll")
            },
            precondition: (0, _contextkeyJs.ContextKeyExpr).and((0, _contextkeyJs.ContextKeyExpr).has("config.editor.stickyScroll.enabled"), (0, _editorContextKeysJs.EditorContextKeys).stickyScrollVisible),
            menu: [
                {
                    id: (0, _actionsJs.MenuId).CommandPalette
                }
            ]
        });
    }
    runEditorCommand(_accessor, editor) {
        (0, _stickyScrollControllerJs.StickyScrollController).get(editor)?.focus();
    }
}
class SelectNextStickyScrollLine extends (0, _editorExtensionsJs.EditorAction2) {
    constructor(){
        super({
            id: "editor.action.selectNextStickyScrollLine",
            title: (0, _nlsJs.localize2)("selectNextStickyScrollLine.title", "Select the next editor sticky scroll line"),
            precondition: (0, _editorContextKeysJs.EditorContextKeys).stickyScrollFocused.isEqualTo(true),
            keybinding: {
                weight,
                primary: 18 /* KeyCode.DownArrow */ 
            }
        });
    }
    runEditorCommand(_accessor, editor) {
        (0, _stickyScrollControllerJs.StickyScrollController).get(editor)?.focusNext();
    }
}
class SelectPreviousStickyScrollLine extends (0, _editorExtensionsJs.EditorAction2) {
    constructor(){
        super({
            id: "editor.action.selectPreviousStickyScrollLine",
            title: (0, _nlsJs.localize2)("selectPreviousStickyScrollLine.title", "Select the previous sticky scroll line"),
            precondition: (0, _editorContextKeysJs.EditorContextKeys).stickyScrollFocused.isEqualTo(true),
            keybinding: {
                weight,
                primary: 16 /* KeyCode.UpArrow */ 
            }
        });
    }
    runEditorCommand(_accessor, editor) {
        (0, _stickyScrollControllerJs.StickyScrollController).get(editor)?.focusPrevious();
    }
}
class GoToStickyScrollLine extends (0, _editorExtensionsJs.EditorAction2) {
    constructor(){
        super({
            id: "editor.action.goToFocusedStickyScrollLine",
            title: (0, _nlsJs.localize2)("goToFocusedStickyScrollLine.title", "Go to the focused sticky scroll line"),
            precondition: (0, _editorContextKeysJs.EditorContextKeys).stickyScrollFocused.isEqualTo(true),
            keybinding: {
                weight,
                primary: 3 /* KeyCode.Enter */ 
            }
        });
    }
    runEditorCommand(_accessor, editor) {
        (0, _stickyScrollControllerJs.StickyScrollController).get(editor)?.goToFocused();
    }
}
class SelectEditor extends (0, _editorExtensionsJs.EditorAction2) {
    constructor(){
        super({
            id: "editor.action.selectEditor",
            title: (0, _nlsJs.localize2)("selectEditor.title", "Select Editor"),
            precondition: (0, _editorContextKeysJs.EditorContextKeys).stickyScrollFocused.isEqualTo(true),
            keybinding: {
                weight,
                primary: 9 /* KeyCode.Escape */ 
            }
        });
    }
    runEditorCommand(_accessor, editor) {
        (0, _stickyScrollControllerJs.StickyScrollController).get(editor)?.selectEditor();
    }
}

},{"../../../browser/editorExtensions.js":"kC3w6","../../../../nls.js":"l617d","../../../../platform/action/common/actionCommonCategories.js":"4fprp","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../common/editorContextKeys.js":"5exv9","./stickyScrollController.js":"fdm4n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4fprp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Categories", ()=>Categories);
var _nlsJs = require("../../../nls.js");
const Categories = Object.freeze({
    View: (0, _nlsJs.localize2)("view", "View"),
    Help: (0, _nlsJs.localize2)("help", "Help"),
    Test: (0, _nlsJs.localize2)("test", "Test"),
    File: (0, _nlsJs.localize2)("file", "File"),
    Preferences: (0, _nlsJs.localize2)("preferences", "Preferences"),
    Developer: (0, _nlsJs.localize2)({
        key: "developer",
        comment: [
            "A developer on Code itself or someone diagnosing issues in Code"
        ]
    }, "Developer")
});

},{"../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fdm4n":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StickyScrollController", ()=>StickyScrollController);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _stickyScrollWidgetJs = require("./stickyScrollWidget.js");
var _stickyScrollProviderJs = require("./stickyScrollProvider.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _contextViewJs = require("../../../../platform/contextview/browser/contextView.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _clickLinkGestureJs = require("../../gotoSymbol/browser/link/clickLinkGesture.js");
var _rangeJs = require("../../../common/core/range.js");
var _goToSymbolJs = require("../../gotoSymbol/browser/goToSymbol.js");
var _inlayHintsLocationsJs = require("../../inlayHints/browser/inlayHintsLocations.js");
var _positionJs = require("../../../common/core/position.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _languageFeatureDebounceJs = require("../../../common/services/languageFeatureDebounce.js");
var _domJs = require("../../../../base/browser/dom.js");
var _stickyScrollElementJs = require("./stickyScrollElement.js");
var _mouseEventJs = require("../../../../base/browser/mouseEvent.js");
var _foldingJs = require("../../folding/browser/folding.js");
var _foldingModelJs = require("../../folding/browser/foldingModel.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var StickyScrollController_1;
let StickyScrollController = class StickyScrollController extends (0, _lifecycleJs.Disposable) {
    static{
        StickyScrollController_1 = this;
    }
    static{
        this.ID = "store.contrib.stickyScrollController";
    }
    constructor(_editor, _contextMenuService, _languageFeaturesService, _instaService, _languageConfigurationService, _languageFeatureDebounceService, _contextKeyService){
        super();
        this._editor = _editor;
        this._contextMenuService = _contextMenuService;
        this._languageFeaturesService = _languageFeaturesService;
        this._instaService = _instaService;
        this._contextKeyService = _contextKeyService;
        this._sessionStore = new (0, _lifecycleJs.DisposableStore)();
        this._maxStickyLines = Number.MAX_SAFE_INTEGER;
        this._candidateDefinitionsLength = -1;
        this._focusedStickyElementIndex = -1;
        this._enabled = false;
        this._focused = false;
        this._positionRevealed = false;
        this._onMouseDown = false;
        this._endLineNumbers = [];
        this._stickyScrollWidget = new (0, _stickyScrollWidgetJs.StickyScrollWidget)(this._editor);
        this._stickyLineCandidateProvider = new (0, _stickyScrollProviderJs.StickyLineCandidateProvider)(this._editor, _languageFeaturesService, _languageConfigurationService);
        this._register(this._stickyScrollWidget);
        this._register(this._stickyLineCandidateProvider);
        this._widgetState = (0, _stickyScrollWidgetJs.StickyScrollWidgetState).Empty;
        this._onDidResize();
        this._readConfiguration();
        const stickyScrollDomNode = this._stickyScrollWidget.getDomNode();
        this._register(this._editor.onDidChangeConfiguration((e)=>{
            this._readConfigurationChange(e);
        }));
        this._register(_domJs.addDisposableListener(stickyScrollDomNode, _domJs.EventType.CONTEXT_MENU, async (event)=>{
            this._onContextMenu(_domJs.getWindow(stickyScrollDomNode), event);
        }));
        this._stickyScrollFocusedContextKey = (0, _editorContextKeysJs.EditorContextKeys).stickyScrollFocused.bindTo(this._contextKeyService);
        this._stickyScrollVisibleContextKey = (0, _editorContextKeysJs.EditorContextKeys).stickyScrollVisible.bindTo(this._contextKeyService);
        const focusTracker = this._register(_domJs.trackFocus(stickyScrollDomNode));
        this._register(focusTracker.onDidBlur((_)=>{
            // Suppose that the blurring is caused by scrolling, then keep the focus on the sticky scroll
            // This is determined by the fact that the height of the widget has become zero and there has been no position revealing
            if (this._positionRevealed === false && stickyScrollDomNode.clientHeight === 0) {
                this._focusedStickyElementIndex = -1;
                this.focus();
            } else this._disposeFocusStickyScrollStore();
        }));
        this._register(focusTracker.onDidFocus((_)=>{
            this.focus();
        }));
        this._registerMouseListeners();
        // Suppose that mouse down on the sticky scroll, then do not focus on the sticky scroll because this will be followed by the revealing of a position
        this._register(_domJs.addDisposableListener(stickyScrollDomNode, _domJs.EventType.MOUSE_DOWN, (e)=>{
            this._onMouseDown = true;
        }));
    }
    static get(editor) {
        return editor.getContribution(StickyScrollController_1.ID);
    }
    _disposeFocusStickyScrollStore() {
        this._stickyScrollFocusedContextKey.set(false);
        this._focusDisposableStore?.dispose();
        this._focused = false;
        this._positionRevealed = false;
        this._onMouseDown = false;
    }
    focus() {
        // If the mouse is down, do not focus on the sticky scroll
        if (this._onMouseDown) {
            this._onMouseDown = false;
            this._editor.focus();
            return;
        }
        const focusState = this._stickyScrollFocusedContextKey.get();
        if (focusState === true) return;
        this._focused = true;
        this._focusDisposableStore = new (0, _lifecycleJs.DisposableStore)();
        this._stickyScrollFocusedContextKey.set(true);
        this._focusedStickyElementIndex = this._stickyScrollWidget.lineNumbers.length - 1;
        this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex);
    }
    focusNext() {
        if (this._focusedStickyElementIndex < this._stickyScrollWidget.lineNumberCount - 1) this._focusNav(true);
    }
    focusPrevious() {
        if (this._focusedStickyElementIndex > 0) this._focusNav(false);
    }
    selectEditor() {
        this._editor.focus();
    }
    // True is next, false is previous
    _focusNav(direction) {
        this._focusedStickyElementIndex = direction ? this._focusedStickyElementIndex + 1 : this._focusedStickyElementIndex - 1;
        this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex);
    }
    goToFocused() {
        const lineNumbers = this._stickyScrollWidget.lineNumbers;
        this._disposeFocusStickyScrollStore();
        this._revealPosition({
            lineNumber: lineNumbers[this._focusedStickyElementIndex],
            column: 1
        });
    }
    _revealPosition(position) {
        this._reveaInEditor(position, ()=>this._editor.revealPosition(position));
    }
    _revealLineInCenterIfOutsideViewport(position) {
        this._reveaInEditor(position, ()=>this._editor.revealLineInCenterIfOutsideViewport(position.lineNumber, 0 /* ScrollType.Smooth */ ));
    }
    _reveaInEditor(position, revealFunction) {
        if (this._focused) this._disposeFocusStickyScrollStore();
        this._positionRevealed = true;
        revealFunction();
        this._editor.setSelection((0, _rangeJs.Range).fromPositions(position));
        this._editor.focus();
    }
    _registerMouseListeners() {
        const sessionStore = this._register(new (0, _lifecycleJs.DisposableStore)());
        const gesture = this._register(new (0, _clickLinkGestureJs.ClickLinkGesture)(this._editor, {
            extractLineNumberFromMouseEvent: (e)=>{
                const position = this._stickyScrollWidget.getEditorPositionFromNode(e.target.element);
                return position ? position.lineNumber : 0;
            }
        }));
        const getMouseEventTarget = (mouseEvent)=>{
            if (!this._editor.hasModel()) return null;
            if (mouseEvent.target.type !== 12 /* MouseTargetType.OVERLAY_WIDGET */  || mouseEvent.target.detail !== this._stickyScrollWidget.getId()) // not hovering over our widget
            return null;
            const mouseTargetElement = mouseEvent.target.element;
            if (!mouseTargetElement || mouseTargetElement.innerText !== mouseTargetElement.innerHTML) // not on a span element rendering text
            return null;
            const position = this._stickyScrollWidget.getEditorPositionFromNode(mouseTargetElement);
            if (!position) // not hovering a sticky scroll line
            return null;
            return {
                range: new (0, _rangeJs.Range)(position.lineNumber, position.column, position.lineNumber, position.column + mouseTargetElement.innerText.length),
                textElement: mouseTargetElement
            };
        };
        const stickyScrollWidgetDomNode = this._stickyScrollWidget.getDomNode();
        this._register(_domJs.addStandardDisposableListener(stickyScrollWidgetDomNode, _domJs.EventType.CLICK, (mouseEvent)=>{
            if (mouseEvent.ctrlKey || mouseEvent.altKey || mouseEvent.metaKey) // modifier pressed
            return;
            if (!mouseEvent.leftButton) // not left click
            return;
            if (mouseEvent.shiftKey) {
                // shift click
                const lineIndex = this._stickyScrollWidget.getLineIndexFromChildDomNode(mouseEvent.target);
                if (lineIndex === null) return;
                const position = new (0, _positionJs.Position)(this._endLineNumbers[lineIndex], 1);
                this._revealLineInCenterIfOutsideViewport(position);
                return;
            }
            const isInFoldingIconDomNode = this._stickyScrollWidget.isInFoldingIconDomNode(mouseEvent.target);
            if (isInFoldingIconDomNode) {
                // clicked on folding icon
                const lineNumber = this._stickyScrollWidget.getLineNumberFromChildDomNode(mouseEvent.target);
                this._toggleFoldingRegionForLine(lineNumber);
                return;
            }
            const isInStickyLine = this._stickyScrollWidget.isInStickyLine(mouseEvent.target);
            if (!isInStickyLine) return;
            // normal click
            let position = this._stickyScrollWidget.getEditorPositionFromNode(mouseEvent.target);
            if (!position) {
                const lineNumber = this._stickyScrollWidget.getLineNumberFromChildDomNode(mouseEvent.target);
                if (lineNumber === null) // not hovering a sticky scroll line
                return;
                position = new (0, _positionJs.Position)(lineNumber, 1);
            }
            this._revealPosition(position);
        }));
        this._register(_domJs.addStandardDisposableListener(stickyScrollWidgetDomNode, _domJs.EventType.MOUSE_MOVE, (mouseEvent)=>{
            if (mouseEvent.shiftKey) {
                const currentEndForLineIndex = this._stickyScrollWidget.getLineIndexFromChildDomNode(mouseEvent.target);
                if (currentEndForLineIndex === null || this._showEndForLine !== null && this._showEndForLine === currentEndForLineIndex) return;
                this._showEndForLine = currentEndForLineIndex;
                this._renderStickyScroll();
                return;
            }
            if (this._showEndForLine !== undefined) {
                this._showEndForLine = undefined;
                this._renderStickyScroll();
            }
        }));
        this._register(_domJs.addDisposableListener(stickyScrollWidgetDomNode, _domJs.EventType.MOUSE_LEAVE, (e)=>{
            if (this._showEndForLine !== undefined) {
                this._showEndForLine = undefined;
                this._renderStickyScroll();
            }
        }));
        this._register(gesture.onMouseMoveOrRelevantKeyDown(([mouseEvent, _keyboardEvent])=>{
            const mouseTarget = getMouseEventTarget(mouseEvent);
            if (!mouseTarget || !mouseEvent.hasTriggerModifier || !this._editor.hasModel()) {
                sessionStore.clear();
                return;
            }
            const { range, textElement } = mouseTarget;
            if (!range.equalsRange(this._stickyRangeProjectedOnEditor)) {
                this._stickyRangeProjectedOnEditor = range;
                sessionStore.clear();
            } else if (textElement.style.textDecoration === "underline") return;
            const cancellationToken = new (0, _cancellationJs.CancellationTokenSource)();
            sessionStore.add((0, _lifecycleJs.toDisposable)(()=>cancellationToken.dispose(true)));
            let currentHTMLChild;
            (0, _goToSymbolJs.getDefinitionsAtPosition)(this._languageFeaturesService.definitionProvider, this._editor.getModel(), new (0, _positionJs.Position)(range.startLineNumber, range.startColumn + 1), false, cancellationToken.token).then((candidateDefinitions)=>{
                if (cancellationToken.token.isCancellationRequested) return;
                if (candidateDefinitions.length !== 0) {
                    this._candidateDefinitionsLength = candidateDefinitions.length;
                    const childHTML = textElement;
                    if (currentHTMLChild !== childHTML) {
                        sessionStore.clear();
                        currentHTMLChild = childHTML;
                        currentHTMLChild.style.textDecoration = "underline";
                        sessionStore.add((0, _lifecycleJs.toDisposable)(()=>{
                            currentHTMLChild.style.textDecoration = "none";
                        }));
                    } else if (!currentHTMLChild) {
                        currentHTMLChild = childHTML;
                        currentHTMLChild.style.textDecoration = "underline";
                        sessionStore.add((0, _lifecycleJs.toDisposable)(()=>{
                            currentHTMLChild.style.textDecoration = "none";
                        }));
                    }
                } else sessionStore.clear();
            });
        }));
        this._register(gesture.onCancel(()=>{
            sessionStore.clear();
        }));
        this._register(gesture.onExecute(async (e)=>{
            if (e.target.type !== 12 /* MouseTargetType.OVERLAY_WIDGET */  || e.target.detail !== this._stickyScrollWidget.getId()) // not hovering over our widget
            return;
            const position = this._stickyScrollWidget.getEditorPositionFromNode(e.target.element);
            if (!position) // not hovering a sticky scroll line
            return;
            if (!this._editor.hasModel() || !this._stickyRangeProjectedOnEditor) return;
            if (this._candidateDefinitionsLength > 1) {
                if (this._focused) this._disposeFocusStickyScrollStore();
                this._revealPosition({
                    lineNumber: position.lineNumber,
                    column: 1
                });
            }
            this._instaService.invokeFunction((0, _inlayHintsLocationsJs.goToDefinitionWithLocation), e, this._editor, {
                uri: this._editor.getModel().uri,
                range: this._stickyRangeProjectedOnEditor
            });
        }));
    }
    _onContextMenu(targetWindow, e) {
        const event = new (0, _mouseEventJs.StandardMouseEvent)(targetWindow, e);
        this._contextMenuService.showContextMenu({
            menuId: (0, _actionsJs.MenuId).StickyScrollContext,
            getAnchor: ()=>event
        });
    }
    _toggleFoldingRegionForLine(line) {
        if (!this._foldingModel || line === null) return;
        const stickyLine = this._stickyScrollWidget.getRenderedStickyLine(line);
        const foldingIcon = stickyLine?.foldingIcon;
        if (!foldingIcon) return;
        (0, _foldingModelJs.toggleCollapseState)(this._foldingModel, Number.MAX_VALUE, [
            line
        ]);
        foldingIcon.isCollapsed = !foldingIcon.isCollapsed;
        const scrollTop = (foldingIcon.isCollapsed ? this._editor.getTopForLineNumber(foldingIcon.foldingEndLine) : this._editor.getTopForLineNumber(foldingIcon.foldingStartLine)) - this._editor.getOption(67 /* EditorOption.lineHeight */ ) * stickyLine.index + 1;
        this._editor.setScrollTop(scrollTop);
        this._renderStickyScroll(line);
    }
    _readConfiguration() {
        const options = this._editor.getOption(116 /* EditorOption.stickyScroll */ );
        if (options.enabled === false) {
            this._editor.removeOverlayWidget(this._stickyScrollWidget);
            this._sessionStore.clear();
            this._enabled = false;
            return;
        } else if (options.enabled && !this._enabled) {
            // When sticky scroll was just enabled, add the listeners on the sticky scroll
            this._editor.addOverlayWidget(this._stickyScrollWidget);
            this._sessionStore.add(this._editor.onDidScrollChange((e)=>{
                if (e.scrollTopChanged) {
                    this._showEndForLine = undefined;
                    this._renderStickyScroll();
                }
            }));
            this._sessionStore.add(this._editor.onDidLayoutChange(()=>this._onDidResize()));
            this._sessionStore.add(this._editor.onDidChangeModelTokens((e)=>this._onTokensChange(e)));
            this._sessionStore.add(this._stickyLineCandidateProvider.onDidChangeStickyScroll(()=>{
                this._showEndForLine = undefined;
                this._renderStickyScroll();
            }));
            this._enabled = true;
        }
        const lineNumberOption = this._editor.getOption(68 /* EditorOption.lineNumbers */ );
        if (lineNumberOption.renderType === 2 /* RenderLineNumbersType.Relative */ ) this._sessionStore.add(this._editor.onDidChangeCursorPosition(()=>{
            this._showEndForLine = undefined;
            this._renderStickyScroll(0);
        }));
    }
    _readConfigurationChange(event) {
        if (event.hasChanged(116 /* EditorOption.stickyScroll */ ) || event.hasChanged(73 /* EditorOption.minimap */ ) || event.hasChanged(67 /* EditorOption.lineHeight */ ) || event.hasChanged(111 /* EditorOption.showFoldingControls */ ) || event.hasChanged(68 /* EditorOption.lineNumbers */ )) this._readConfiguration();
        if (event.hasChanged(68 /* EditorOption.lineNumbers */ )) this._renderStickyScroll(0);
    }
    _needsUpdate(event) {
        const stickyLineNumbers = this._stickyScrollWidget.getCurrentLines();
        for (const stickyLineNumber of stickyLineNumbers)for (const range of event.ranges){
            if (stickyLineNumber >= range.fromLineNumber && stickyLineNumber <= range.toLineNumber) return true;
        }
        return false;
    }
    _onTokensChange(event) {
        if (this._needsUpdate(event)) // Rebuilding the whole widget from line 0
        this._renderStickyScroll(0);
    }
    _onDidResize() {
        const layoutInfo = this._editor.getLayoutInfo();
        // Make sure sticky scroll doesn't take up more than 25% of the editor
        const theoreticalLines = layoutInfo.height / this._editor.getOption(67 /* EditorOption.lineHeight */ );
        this._maxStickyLines = Math.round(theoreticalLines * .25);
    }
    async _renderStickyScroll(rebuildFromLine) {
        const model = this._editor.getModel();
        if (!model || model.isTooLargeForTokenization()) {
            this._resetState();
            return;
        }
        const nextRebuildFromLine = this._updateAndGetMinRebuildFromLine(rebuildFromLine);
        const stickyWidgetVersion = this._stickyLineCandidateProvider.getVersionId();
        const shouldUpdateState = stickyWidgetVersion === undefined || stickyWidgetVersion === model.getVersionId();
        if (shouldUpdateState) {
            if (!this._focused) await this._updateState(nextRebuildFromLine);
            else // Suppose that previously the sticky scroll widget had height 0, then if there are visible lines, set the last line as focused
            if (this._focusedStickyElementIndex === -1) {
                await this._updateState(nextRebuildFromLine);
                this._focusedStickyElementIndex = this._stickyScrollWidget.lineNumberCount - 1;
                if (this._focusedStickyElementIndex !== -1) this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex);
            } else {
                const focusedStickyElementLineNumber = this._stickyScrollWidget.lineNumbers[this._focusedStickyElementIndex];
                await this._updateState(nextRebuildFromLine);
                // Suppose that after setting the state, there are no sticky lines, set the focused index to -1
                if (this._stickyScrollWidget.lineNumberCount === 0) this._focusedStickyElementIndex = -1;
                else {
                    const previousFocusedLineNumberExists = this._stickyScrollWidget.lineNumbers.includes(focusedStickyElementLineNumber);
                    // If the line number is still there, do not change anything
                    // If the line number is not there, set the new focused line to be the last line
                    if (!previousFocusedLineNumberExists) this._focusedStickyElementIndex = this._stickyScrollWidget.lineNumberCount - 1;
                    this._stickyScrollWidget.focusLineWithIndex(this._focusedStickyElementIndex);
                }
            }
        }
    }
    _updateAndGetMinRebuildFromLine(rebuildFromLine) {
        if (rebuildFromLine !== undefined) {
            const minRebuildFromLineOrInfinity = this._minRebuildFromLine !== undefined ? this._minRebuildFromLine : Infinity;
            this._minRebuildFromLine = Math.min(rebuildFromLine, minRebuildFromLineOrInfinity);
        }
        return this._minRebuildFromLine;
    }
    async _updateState(rebuildFromLine) {
        this._minRebuildFromLine = undefined;
        this._foldingModel = await (0, _foldingJs.FoldingController).get(this._editor)?.getFoldingModel() ?? undefined;
        this._widgetState = this.findScrollWidgetState();
        const stickyWidgetHasLines = this._widgetState.startLineNumbers.length > 0;
        this._stickyScrollVisibleContextKey.set(stickyWidgetHasLines);
        this._stickyScrollWidget.setState(this._widgetState, this._foldingModel, rebuildFromLine);
    }
    async _resetState() {
        this._minRebuildFromLine = undefined;
        this._foldingModel = undefined;
        this._widgetState = (0, _stickyScrollWidgetJs.StickyScrollWidgetState).Empty;
        this._stickyScrollVisibleContextKey.set(false);
        this._stickyScrollWidget.setState(undefined, undefined);
    }
    findScrollWidgetState() {
        const lineHeight = this._editor.getOption(67 /* EditorOption.lineHeight */ );
        const maxNumberStickyLines = Math.min(this._maxStickyLines, this._editor.getOption(116 /* EditorOption.stickyScroll */ ).maxLineCount);
        const scrollTop = this._editor.getScrollTop();
        let lastLineRelativePosition = 0;
        const startLineNumbers = [];
        const endLineNumbers = [];
        const arrayVisibleRanges = this._editor.getVisibleRanges();
        if (arrayVisibleRanges.length !== 0) {
            const fullVisibleRange = new (0, _stickyScrollElementJs.StickyRange)(arrayVisibleRanges[0].startLineNumber, arrayVisibleRanges[arrayVisibleRanges.length - 1].endLineNumber);
            const candidateRanges = this._stickyLineCandidateProvider.getCandidateStickyLinesIntersecting(fullVisibleRange);
            for (const range of candidateRanges){
                const start = range.startLineNumber;
                const end = range.endLineNumber;
                const depth = range.nestingDepth;
                if (end - start > 0) {
                    const topOfElementAtDepth = (depth - 1) * lineHeight;
                    const bottomOfElementAtDepth = depth * lineHeight;
                    const bottomOfBeginningLine = this._editor.getBottomForLineNumber(start) - scrollTop;
                    const topOfEndLine = this._editor.getTopForLineNumber(end) - scrollTop;
                    const bottomOfEndLine = this._editor.getBottomForLineNumber(end) - scrollTop;
                    if (topOfElementAtDepth > topOfEndLine && topOfElementAtDepth <= bottomOfEndLine) {
                        startLineNumbers.push(start);
                        endLineNumbers.push(end + 1);
                        lastLineRelativePosition = bottomOfEndLine - bottomOfElementAtDepth;
                        break;
                    } else if (bottomOfElementAtDepth > bottomOfBeginningLine && bottomOfElementAtDepth <= bottomOfEndLine) {
                        startLineNumbers.push(start);
                        endLineNumbers.push(end + 1);
                    }
                    if (startLineNumbers.length === maxNumberStickyLines) break;
                }
            }
        }
        this._endLineNumbers = endLineNumbers;
        return new (0, _stickyScrollWidgetJs.StickyScrollWidgetState)(startLineNumbers, endLineNumbers, lastLineRelativePosition, this._showEndForLine);
    }
    dispose() {
        super.dispose();
        this._sessionStore.dispose();
    }
};
StickyScrollController = StickyScrollController_1 = __decorate([
    __param(1, (0, _contextViewJs.IContextMenuService)),
    __param(2, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(3, (0, _instantiationJs.IInstantiationService)),
    __param(4, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService)),
    __param(5, (0, _languageFeatureDebounceJs.ILanguageFeatureDebounceService)),
    __param(6, (0, _contextkeyJs.IContextKeyService))
], StickyScrollController);

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../common/services/languageFeatures.js":"2IAko","./stickyScrollWidget.js":"6wDa4","./stickyScrollProvider.js":"35jdB","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/contextview/browser/contextView.js":"2QlUR","../../../../platform/actions/common/actions.js":"kyMtp","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../common/editorContextKeys.js":"5exv9","../../gotoSymbol/browser/link/clickLinkGesture.js":"5rimz","../../../common/core/range.js":"jmUPh","../../gotoSymbol/browser/goToSymbol.js":"gz1YX","../../inlayHints/browser/inlayHintsLocations.js":"04F32","../../../common/core/position.js":"lvrPe","../../../../base/common/cancellation.js":"hoVxw","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../common/services/languageFeatureDebounce.js":"YGXXG","../../../../base/browser/dom.js":"bnqsM","./stickyScrollElement.js":"by3mp","../../../../base/browser/mouseEvent.js":"4jTdu","../../folding/browser/folding.js":"iWk0I","../../folding/browser/foldingModel.js":"fivpl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6wDa4":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StickyScrollWidgetState", ()=>StickyScrollWidgetState);
parcelHelpers.export(exports, "StickyScrollWidget", ()=>StickyScrollWidget);
var _domJs = require("../../../../base/browser/dom.js");
var _trustedTypesJs = require("../../../../base/browser/trustedTypes.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _themablesJs = require("../../../../base/common/themables.js");
var _stickyScrollCss = require("./stickyScroll.css");
var _viewLineJs = require("../../../browser/viewParts/lines/viewLine.js");
var _embeddedCodeEditorWidgetJs = require("../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js");
var _positionJs = require("../../../common/core/position.js");
var _stringBuilderJs = require("../../../common/core/stringBuilder.js");
var _lineDecorationsJs = require("../../../common/viewLayout/lineDecorations.js");
var _viewLineRendererJs = require("../../../common/viewLayout/viewLineRenderer.js");
var _foldingDecorationsJs = require("../../folding/browser/foldingDecorations.js");
class StickyScrollWidgetState {
    constructor(startLineNumbers, endLineNumbers, lastLineRelativePosition, showEndForLine = null){
        this.startLineNumbers = startLineNumbers;
        this.endLineNumbers = endLineNumbers;
        this.lastLineRelativePosition = lastLineRelativePosition;
        this.showEndForLine = showEndForLine;
    }
    equals(other) {
        return !!other && this.lastLineRelativePosition === other.lastLineRelativePosition && this.showEndForLine === other.showEndForLine && (0, _arraysJs.equals)(this.startLineNumbers, other.startLineNumbers) && (0, _arraysJs.equals)(this.endLineNumbers, other.endLineNumbers);
    }
    static get Empty() {
        return new StickyScrollWidgetState([], [], 0);
    }
}
const _ttPolicy = (0, _trustedTypesJs.createTrustedTypesPolicy)("stickyScrollViewLayer", {
    createHTML: (value)=>value
});
const STICKY_INDEX_ATTR = "data-sticky-line-index";
const STICKY_IS_LINE_ATTR = "data-sticky-is-line";
const STICKY_IS_LINE_NUMBER_ATTR = "data-sticky-is-line-number";
const STICKY_IS_FOLDING_ICON_ATTR = "data-sticky-is-folding-icon";
class StickyScrollWidget extends (0, _lifecycleJs.Disposable) {
    constructor(_editor){
        super();
        this._editor = _editor;
        this._foldingIconStore = new (0, _lifecycleJs.DisposableStore)();
        this._rootDomNode = document.createElement("div");
        this._lineNumbersDomNode = document.createElement("div");
        this._linesDomNodeScrollable = document.createElement("div");
        this._linesDomNode = document.createElement("div");
        this._lineHeight = this._editor.getOption(67 /* EditorOption.lineHeight */ );
        this._renderedStickyLines = [];
        this._lineNumbers = [];
        this._lastLineRelativePosition = 0;
        this._minContentWidthInPx = 0;
        this._isOnGlyphMargin = false;
        this._lineNumbersDomNode.className = "sticky-widget-line-numbers";
        this._lineNumbersDomNode.setAttribute("role", "none");
        this._linesDomNode.className = "sticky-widget-lines";
        this._linesDomNode.setAttribute("role", "list");
        this._linesDomNodeScrollable.className = "sticky-widget-lines-scrollable";
        this._linesDomNodeScrollable.appendChild(this._linesDomNode);
        this._rootDomNode.className = "sticky-widget";
        this._rootDomNode.classList.toggle("peek", _editor instanceof (0, _embeddedCodeEditorWidgetJs.EmbeddedCodeEditorWidget));
        this._rootDomNode.appendChild(this._lineNumbersDomNode);
        this._rootDomNode.appendChild(this._linesDomNodeScrollable);
        const updateScrollLeftPosition = ()=>{
            this._linesDomNode.style.left = this._editor.getOption(116 /* EditorOption.stickyScroll */ ).scrollWithEditor ? `-${this._editor.getScrollLeft()}px` : "0px";
        };
        this._register(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(116 /* EditorOption.stickyScroll */ )) updateScrollLeftPosition();
            if (e.hasChanged(67 /* EditorOption.lineHeight */ )) this._lineHeight = this._editor.getOption(67 /* EditorOption.lineHeight */ );
        }));
        this._register(this._editor.onDidScrollChange((e)=>{
            if (e.scrollLeftChanged) updateScrollLeftPosition();
            if (e.scrollWidthChanged) this._updateWidgetWidth();
        }));
        this._register(this._editor.onDidChangeModel(()=>{
            updateScrollLeftPosition();
            this._updateWidgetWidth();
        }));
        this._register(this._foldingIconStore);
        updateScrollLeftPosition();
        this._register(this._editor.onDidLayoutChange((e)=>{
            this._updateWidgetWidth();
        }));
        this._updateWidgetWidth();
    }
    get lineNumbers() {
        return this._lineNumbers;
    }
    get lineNumberCount() {
        return this._lineNumbers.length;
    }
    getRenderedStickyLine(lineNumber) {
        return this._renderedStickyLines.find((stickyLine)=>stickyLine.lineNumber === lineNumber);
    }
    getCurrentLines() {
        return this._lineNumbers;
    }
    setState(_state, foldingModel, _rebuildFromLine) {
        if (_rebuildFromLine === undefined && (!this._previousState && !_state || this._previousState && this._previousState.equals(_state))) return;
        const isWidgetHeightZero = this._isWidgetHeightZero(_state);
        const state = isWidgetHeightZero ? undefined : _state;
        const rebuildFromLine = isWidgetHeightZero ? 0 : this._findLineToRebuildWidgetFrom(_state, _rebuildFromLine);
        this._renderRootNode(state, foldingModel, rebuildFromLine);
        this._previousState = _state;
    }
    _isWidgetHeightZero(state) {
        if (!state) return true;
        const futureWidgetHeight = state.startLineNumbers.length * this._lineHeight + state.lastLineRelativePosition;
        if (futureWidgetHeight > 0) {
            this._lastLineRelativePosition = state.lastLineRelativePosition;
            const lineNumbers = [
                ...state.startLineNumbers
            ];
            if (state.showEndForLine !== null) lineNumbers[state.showEndForLine] = state.endLineNumbers[state.showEndForLine];
            this._lineNumbers = lineNumbers;
        } else {
            this._lastLineRelativePosition = 0;
            this._lineNumbers = [];
        }
        return futureWidgetHeight === 0;
    }
    _findLineToRebuildWidgetFrom(state, _rebuildFromLine) {
        if (!state || !this._previousState) return 0;
        if (_rebuildFromLine !== undefined) return _rebuildFromLine;
        const previousState = this._previousState;
        const indexOfLinesAlreadyRendered = state.startLineNumbers.findIndex((startLineNumber)=>!previousState.startLineNumbers.includes(startLineNumber));
        return indexOfLinesAlreadyRendered === -1 ? 0 : indexOfLinesAlreadyRendered;
    }
    _updateWidgetWidth() {
        const layoutInfo = this._editor.getLayoutInfo();
        const lineNumbersWidth = layoutInfo.contentLeft;
        this._lineNumbersDomNode.style.width = `${lineNumbersWidth}px`;
        this._linesDomNodeScrollable.style.setProperty("--vscode-editorStickyScroll-scrollableWidth", `${this._editor.getScrollWidth() - layoutInfo.verticalScrollbarWidth}px`);
        this._rootDomNode.style.width = `${layoutInfo.width - layoutInfo.verticalScrollbarWidth}px`;
    }
    _clearStickyLinesFromLine(clearFromLine) {
        this._foldingIconStore.clear();
        // Removing only the lines that need to be rerendered
        for(let i = clearFromLine; i < this._renderedStickyLines.length; i++){
            const stickyLine = this._renderedStickyLines[i];
            stickyLine.lineNumberDomNode.remove();
            stickyLine.lineDomNode.remove();
        }
        // Keep the lines that need to be updated
        this._renderedStickyLines = this._renderedStickyLines.slice(0, clearFromLine);
        this._rootDomNode.style.display = "none";
    }
    _useFoldingOpacityTransition(requireTransitions) {
        this._lineNumbersDomNode.style.setProperty("--vscode-editorStickyScroll-foldingOpacityTransition", `opacity ${requireTransitions ? 0.5 : 0}s`);
    }
    _setFoldingIconsVisibility(allVisible) {
        for (const line of this._renderedStickyLines){
            const foldingIcon = line.foldingIcon;
            if (!foldingIcon) continue;
            foldingIcon.setVisible(allVisible ? true : foldingIcon.isCollapsed);
        }
    }
    async _renderRootNode(state, foldingModel, rebuildFromLine) {
        this._clearStickyLinesFromLine(rebuildFromLine);
        if (!state) return;
        // For existing sticky lines update the top and z-index
        for (const stickyLine of this._renderedStickyLines)this._updateTopAndZIndexOfStickyLine(stickyLine);
        // For new sticky lines
        const layoutInfo = this._editor.getLayoutInfo();
        const linesToRender = this._lineNumbers.slice(rebuildFromLine);
        for (const [index, line] of linesToRender.entries()){
            const stickyLine = this._renderChildNode(index + rebuildFromLine, line, foldingModel, layoutInfo);
            if (!stickyLine) continue;
            this._linesDomNode.appendChild(stickyLine.lineDomNode);
            this._lineNumbersDomNode.appendChild(stickyLine.lineNumberDomNode);
            this._renderedStickyLines.push(stickyLine);
        }
        if (foldingModel) {
            this._setFoldingHoverListeners();
            this._useFoldingOpacityTransition(!this._isOnGlyphMargin);
        }
        const widgetHeight = this._lineNumbers.length * this._lineHeight + this._lastLineRelativePosition;
        this._rootDomNode.style.display = "block";
        this._lineNumbersDomNode.style.height = `${widgetHeight}px`;
        this._linesDomNodeScrollable.style.height = `${widgetHeight}px`;
        this._rootDomNode.style.height = `${widgetHeight}px`;
        this._rootDomNode.style.marginLeft = "0px";
        this._minContentWidthInPx = Math.max(...this._renderedStickyLines.map((l)=>l.scrollWidth)) + layoutInfo.verticalScrollbarWidth;
        this._editor.layoutOverlayWidget(this);
    }
    _setFoldingHoverListeners() {
        const showFoldingControls = this._editor.getOption(111 /* EditorOption.showFoldingControls */ );
        if (showFoldingControls !== "mouseover") return;
        this._foldingIconStore.add(_domJs.addDisposableListener(this._lineNumbersDomNode, _domJs.EventType.MOUSE_ENTER, ()=>{
            this._isOnGlyphMargin = true;
            this._setFoldingIconsVisibility(true);
        }));
        this._foldingIconStore.add(_domJs.addDisposableListener(this._lineNumbersDomNode, _domJs.EventType.MOUSE_LEAVE, ()=>{
            this._isOnGlyphMargin = false;
            this._useFoldingOpacityTransition(true);
            this._setFoldingIconsVisibility(false);
        }));
    }
    _renderChildNode(index, line, foldingModel, layoutInfo) {
        const viewModel = this._editor._getViewModel();
        if (!viewModel) return;
        const viewLineNumber = viewModel.coordinatesConverter.convertModelPositionToViewPosition(new (0, _positionJs.Position)(line, 1)).lineNumber;
        const lineRenderingData = viewModel.getViewLineRenderingData(viewLineNumber);
        const lineNumberOption = this._editor.getOption(68 /* EditorOption.lineNumbers */ );
        let actualInlineDecorations;
        try {
            actualInlineDecorations = (0, _lineDecorationsJs.LineDecoration).filter(lineRenderingData.inlineDecorations, viewLineNumber, lineRenderingData.minColumn, lineRenderingData.maxColumn);
        } catch (err) {
            actualInlineDecorations = [];
        }
        const renderLineInput = new (0, _viewLineRendererJs.RenderLineInput)(true, true, lineRenderingData.content, lineRenderingData.continuesWithWrappedLine, lineRenderingData.isBasicASCII, lineRenderingData.containsRTL, 0, lineRenderingData.tokens, actualInlineDecorations, lineRenderingData.tabSize, lineRenderingData.startVisibleColumn, 1, 1, 1, 500, "none", true, true, null);
        const sb = new (0, _stringBuilderJs.StringBuilder)(2000);
        const renderOutput = (0, _viewLineRendererJs.renderViewLine)(renderLineInput, sb);
        let newLine;
        if (_ttPolicy) newLine = _ttPolicy.createHTML(sb.build());
        else newLine = sb.build();
        const lineHTMLNode = document.createElement("span");
        lineHTMLNode.setAttribute(STICKY_INDEX_ATTR, String(index));
        lineHTMLNode.setAttribute(STICKY_IS_LINE_ATTR, "");
        lineHTMLNode.setAttribute("role", "listitem");
        lineHTMLNode.tabIndex = 0;
        lineHTMLNode.className = "sticky-line-content";
        lineHTMLNode.classList.add(`stickyLine${line}`);
        lineHTMLNode.style.lineHeight = `${this._lineHeight}px`;
        lineHTMLNode.innerHTML = newLine;
        const lineNumberHTMLNode = document.createElement("span");
        lineNumberHTMLNode.setAttribute(STICKY_INDEX_ATTR, String(index));
        lineNumberHTMLNode.setAttribute(STICKY_IS_LINE_NUMBER_ATTR, "");
        lineNumberHTMLNode.className = "sticky-line-number";
        lineNumberHTMLNode.style.lineHeight = `${this._lineHeight}px`;
        const lineNumbersWidth = layoutInfo.contentLeft;
        lineNumberHTMLNode.style.width = `${lineNumbersWidth}px`;
        const innerLineNumberHTML = document.createElement("span");
        if (lineNumberOption.renderType === 1 /* RenderLineNumbersType.On */  || lineNumberOption.renderType === 3 /* RenderLineNumbersType.Interval */  && line % 10 === 0) innerLineNumberHTML.innerText = line.toString();
        else if (lineNumberOption.renderType === 2 /* RenderLineNumbersType.Relative */ ) innerLineNumberHTML.innerText = Math.abs(line - this._editor.getPosition().lineNumber).toString();
        innerLineNumberHTML.className = "sticky-line-number-inner";
        innerLineNumberHTML.style.lineHeight = `${this._lineHeight}px`;
        innerLineNumberHTML.style.width = `${layoutInfo.lineNumbersWidth}px`;
        innerLineNumberHTML.style.paddingLeft = `${layoutInfo.lineNumbersLeft}px`;
        lineNumberHTMLNode.appendChild(innerLineNumberHTML);
        const foldingIcon = this._renderFoldingIconForLine(foldingModel, line);
        if (foldingIcon) lineNumberHTMLNode.appendChild(foldingIcon.domNode);
        this._editor.applyFontInfo(lineHTMLNode);
        this._editor.applyFontInfo(innerLineNumberHTML);
        lineNumberHTMLNode.style.lineHeight = `${this._lineHeight}px`;
        lineHTMLNode.style.lineHeight = `${this._lineHeight}px`;
        lineNumberHTMLNode.style.height = `${this._lineHeight}px`;
        lineHTMLNode.style.height = `${this._lineHeight}px`;
        const renderedLine = new RenderedStickyLine(index, line, lineHTMLNode, lineNumberHTMLNode, foldingIcon, renderOutput.characterMapping, lineHTMLNode.scrollWidth);
        return this._updateTopAndZIndexOfStickyLine(renderedLine);
    }
    _updateTopAndZIndexOfStickyLine(stickyLine) {
        const index = stickyLine.index;
        const lineHTMLNode = stickyLine.lineDomNode;
        const lineNumberHTMLNode = stickyLine.lineNumberDomNode;
        const isLastLine = index === this._lineNumbers.length - 1;
        const lastLineZIndex = "0";
        const intermediateLineZIndex = "1";
        lineHTMLNode.style.zIndex = isLastLine ? lastLineZIndex : intermediateLineZIndex;
        lineNumberHTMLNode.style.zIndex = isLastLine ? lastLineZIndex : intermediateLineZIndex;
        const lastLineTop = `${index * this._lineHeight + this._lastLineRelativePosition + (stickyLine.foldingIcon?.isCollapsed ? 1 : 0)}px`;
        const intermediateLineTop = `${index * this._lineHeight}px`;
        lineHTMLNode.style.top = isLastLine ? lastLineTop : intermediateLineTop;
        lineNumberHTMLNode.style.top = isLastLine ? lastLineTop : intermediateLineTop;
        return stickyLine;
    }
    _renderFoldingIconForLine(foldingModel, line) {
        const showFoldingControls = this._editor.getOption(111 /* EditorOption.showFoldingControls */ );
        if (!foldingModel || showFoldingControls === "never") return;
        const foldingRegions = foldingModel.regions;
        const indexOfFoldingRegion = foldingRegions.findRange(line);
        const startLineNumber = foldingRegions.getStartLineNumber(indexOfFoldingRegion);
        const isFoldingScope = line === startLineNumber;
        if (!isFoldingScope) return;
        const isCollapsed = foldingRegions.isCollapsed(indexOfFoldingRegion);
        const foldingIcon = new StickyFoldingIcon(isCollapsed, startLineNumber, foldingRegions.getEndLineNumber(indexOfFoldingRegion), this._lineHeight);
        foldingIcon.setVisible(this._isOnGlyphMargin ? true : isCollapsed || showFoldingControls === "always");
        foldingIcon.domNode.setAttribute(STICKY_IS_FOLDING_ICON_ATTR, "");
        return foldingIcon;
    }
    getId() {
        return "editor.contrib.stickyScrollWidget";
    }
    getDomNode() {
        return this._rootDomNode;
    }
    getPosition() {
        return {
            preference: 2 /* OverlayWidgetPositionPreference.TOP_CENTER */ ,
            stackOridinal: 10
        };
    }
    getMinContentWidthInPx() {
        return this._minContentWidthInPx;
    }
    focusLineWithIndex(index) {
        if (0 <= index && index < this._renderedStickyLines.length) this._renderedStickyLines[index].lineDomNode.focus();
    }
    /**
     * Given a leaf dom node, tries to find the editor position.
     */ getEditorPositionFromNode(spanDomNode) {
        if (!spanDomNode || spanDomNode.children.length > 0) // This is not a leaf node
        return null;
        const renderedStickyLine = this._getRenderedStickyLineFromChildDomNode(spanDomNode);
        if (!renderedStickyLine) return null;
        const column = (0, _viewLineJs.getColumnOfNodeOffset)(renderedStickyLine.characterMapping, spanDomNode, 0);
        return new (0, _positionJs.Position)(renderedStickyLine.lineNumber, column);
    }
    getLineNumberFromChildDomNode(domNode) {
        return this._getRenderedStickyLineFromChildDomNode(domNode)?.lineNumber ?? null;
    }
    _getRenderedStickyLineFromChildDomNode(domNode) {
        const index = this.getLineIndexFromChildDomNode(domNode);
        if (index === null || index < 0 || index >= this._renderedStickyLines.length) return null;
        return this._renderedStickyLines[index];
    }
    /**
     * Given a child dom node, tries to find the line number attribute that was stored in the node.
     * @returns the attribute value or null if none is found.
     */ getLineIndexFromChildDomNode(domNode) {
        const lineIndex = this._getAttributeValue(domNode, STICKY_INDEX_ATTR);
        return lineIndex ? parseInt(lineIndex, 10) : null;
    }
    /**
     * Given a child dom node, tries to find if it is (contained in) a sticky line.
     * @returns a boolean.
     */ isInStickyLine(domNode) {
        const isInLine = this._getAttributeValue(domNode, STICKY_IS_LINE_ATTR);
        return isInLine !== undefined;
    }
    /**
     * Given a child dom node, tries to find if this dom node is (contained in) a sticky folding icon.
     * @returns a boolean.
     */ isInFoldingIconDomNode(domNode) {
        const isInFoldingIcon = this._getAttributeValue(domNode, STICKY_IS_FOLDING_ICON_ATTR);
        return isInFoldingIcon !== undefined;
    }
    /**
     * Given the dom node, finds if it or its parent sequence contains the given attribute.
     * @returns the attribute value or undefined.
     */ _getAttributeValue(domNode, attribute) {
        while(domNode && domNode !== this._rootDomNode){
            const line = domNode.getAttribute(attribute);
            if (line !== null) return line;
            domNode = domNode.parentElement;
        }
        return;
    }
}
class RenderedStickyLine {
    constructor(index, lineNumber, lineDomNode, lineNumberDomNode, foldingIcon, characterMapping, scrollWidth){
        this.index = index;
        this.lineNumber = lineNumber;
        this.lineDomNode = lineDomNode;
        this.lineNumberDomNode = lineNumberDomNode;
        this.foldingIcon = foldingIcon;
        this.characterMapping = characterMapping;
        this.scrollWidth = scrollWidth;
    }
}
class StickyFoldingIcon {
    constructor(isCollapsed, foldingStartLine, foldingEndLine, dimension){
        this.isCollapsed = isCollapsed;
        this.foldingStartLine = foldingStartLine;
        this.foldingEndLine = foldingEndLine;
        this.dimension = dimension;
        this.domNode = document.createElement("div");
        this.domNode.style.width = `${dimension}px`;
        this.domNode.style.height = `${dimension}px`;
        this.domNode.className = (0, _themablesJs.ThemeIcon).asClassName(isCollapsed ? (0, _foldingDecorationsJs.foldingCollapsedIcon) : (0, _foldingDecorationsJs.foldingExpandedIcon));
    }
    setVisible(visible) {
        this.domNode.style.cursor = visible ? "pointer" : "default";
        this.domNode.style.opacity = visible ? "1" : "0";
    }
}

},{"../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/trustedTypes.js":"bgQyv","../../../../base/common/arrays.js":"DECei","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/themables.js":"hgyHi","./stickyScroll.css":"4Z4DJ","../../../browser/viewParts/lines/viewLine.js":"9rxuY","../../../browser/widget/codeEditor/embeddedCodeEditorWidget.js":"8G1ik","../../../common/core/position.js":"lvrPe","../../../common/core/stringBuilder.js":"hHgWQ","../../../common/viewLayout/lineDecorations.js":"m2bJX","../../../common/viewLayout/viewLineRenderer.js":"1RGPz","../../folding/browser/foldingDecorations.js":"aCgT6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Z4DJ":[function() {},{}],"35jdB":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StickyLineCandidate", ()=>StickyLineCandidate);
parcelHelpers.export(exports, "StickyLineCandidateProvider", ()=>StickyLineCandidateProvider);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _asyncJs = require("../../../../base/common/async.js");
var _arraysJs = require("../../../../base/common/arrays.js");
var _eventJs = require("../../../../base/common/event.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _stickyScrollModelProviderJs = require("./stickyScrollModelProvider.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class StickyLineCandidate {
    constructor(startLineNumber, endLineNumber, nestingDepth){
        this.startLineNumber = startLineNumber;
        this.endLineNumber = endLineNumber;
        this.nestingDepth = nestingDepth;
    }
}
let StickyLineCandidateProvider = class StickyLineCandidateProvider extends (0, _lifecycleJs.Disposable) {
    constructor(editor, _languageFeaturesService, _languageConfigurationService){
        super();
        this._languageFeaturesService = _languageFeaturesService;
        this._languageConfigurationService = _languageConfigurationService;
        this._onDidChangeStickyScroll = this._register(new (0, _eventJs.Emitter)());
        this.onDidChangeStickyScroll = this._onDidChangeStickyScroll.event;
        this._model = null;
        this._cts = null;
        this._stickyModelProvider = null;
        this._editor = editor;
        this._sessionStore = this._register(new (0, _lifecycleJs.DisposableStore)());
        this._updateSoon = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this.update(), 50));
        this._register(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(116 /* EditorOption.stickyScroll */ )) this.readConfiguration();
        }));
        this.readConfiguration();
    }
    readConfiguration() {
        this._sessionStore.clear();
        const options = this._editor.getOption(116 /* EditorOption.stickyScroll */ );
        if (!options.enabled) return;
        this._sessionStore.add(this._editor.onDidChangeModel(()=>{
            // We should not show an old model for a different file, it will always be wrong.
            // So we clear the model here immediately and then trigger an update.
            this._model = null;
            this.updateStickyModelProvider();
            this._onDidChangeStickyScroll.fire();
            this.update();
        }));
        this._sessionStore.add(this._editor.onDidChangeHiddenAreas(()=>this.update()));
        this._sessionStore.add(this._editor.onDidChangeModelContent(()=>this._updateSoon.schedule()));
        this._sessionStore.add(this._languageFeaturesService.documentSymbolProvider.onDidChange(()=>this.update()));
        this._sessionStore.add((0, _lifecycleJs.toDisposable)(()=>{
            this._stickyModelProvider?.dispose();
            this._stickyModelProvider = null;
        }));
        this.updateStickyModelProvider();
        this.update();
    }
    getVersionId() {
        return this._model?.version;
    }
    updateStickyModelProvider() {
        this._stickyModelProvider?.dispose();
        this._stickyModelProvider = null;
        const editor = this._editor;
        if (editor.hasModel()) this._stickyModelProvider = new (0, _stickyScrollModelProviderJs.StickyModelProvider)(editor, ()=>this._updateSoon.schedule(), this._languageConfigurationService, this._languageFeaturesService);
    }
    async update() {
        this._cts?.dispose(true);
        this._cts = new (0, _cancellationJs.CancellationTokenSource)();
        await this.updateStickyModel(this._cts.token);
        this._onDidChangeStickyScroll.fire();
    }
    async updateStickyModel(token) {
        if (!this._editor.hasModel() || !this._stickyModelProvider || this._editor.getModel().isTooLargeForTokenization()) {
            this._model = null;
            return;
        }
        const model = await this._stickyModelProvider.update(token);
        if (token.isCancellationRequested) // the computation was canceled, so do not overwrite the model
        return;
        this._model = model;
    }
    updateIndex(index) {
        if (index === -1) index = 0;
        else if (index < 0) index = -index - 2;
        return index;
    }
    getCandidateStickyLinesIntersectingFromStickyModel(range, outlineModel, result, depth, lastStartLineNumber) {
        if (outlineModel.children.length === 0) return;
        let lastLine = lastStartLineNumber;
        const childrenStartLines = [];
        for(let i = 0; i < outlineModel.children.length; i++){
            const child = outlineModel.children[i];
            if (child.range) childrenStartLines.push(child.range.startLineNumber);
        }
        const lowerBound = this.updateIndex((0, _arraysJs.binarySearch)(childrenStartLines, range.startLineNumber, (a, b)=>{
            return a - b;
        }));
        const upperBound = this.updateIndex((0, _arraysJs.binarySearch)(childrenStartLines, range.startLineNumber + depth, (a, b)=>{
            return a - b;
        }));
        for(let i = lowerBound; i <= upperBound; i++){
            const child = outlineModel.children[i];
            if (!child) return;
            if (child.range) {
                const childStartLine = child.range.startLineNumber;
                const childEndLine = child.range.endLineNumber;
                if (range.startLineNumber <= childEndLine + 1 && childStartLine - 1 <= range.endLineNumber && childStartLine !== lastLine) {
                    lastLine = childStartLine;
                    result.push(new StickyLineCandidate(childStartLine, childEndLine - 1, depth + 1));
                    this.getCandidateStickyLinesIntersectingFromStickyModel(range, child, result, depth + 1, childStartLine);
                }
            } else this.getCandidateStickyLinesIntersectingFromStickyModel(range, child, result, depth, lastStartLineNumber);
        }
    }
    getCandidateStickyLinesIntersecting(range) {
        if (!this._model?.element) return [];
        let stickyLineCandidates = [];
        this.getCandidateStickyLinesIntersectingFromStickyModel(range, this._model.element, stickyLineCandidates, 0, -1);
        const hiddenRanges = this._editor._getViewModel()?.getHiddenAreas();
        if (hiddenRanges) for (const hiddenRange of hiddenRanges)stickyLineCandidates = stickyLineCandidates.filter((stickyLine)=>!(stickyLine.startLineNumber >= hiddenRange.startLineNumber && stickyLine.endLineNumber <= hiddenRange.endLineNumber + 1));
        return stickyLineCandidates;
    }
};
StickyLineCandidateProvider = __decorate([
    __param(1, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(2, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService))
], StickyLineCandidateProvider);

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../common/services/languageFeatures.js":"2IAko","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/async.js":"4GJc4","../../../../base/common/arrays.js":"DECei","../../../../base/common/event.js":"4Zi8b","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","./stickyScrollModelProvider.js":"gmL0Y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gmL0Y":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StickyModelProvider", ()=>StickyModelProvider);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _outlineModelJs = require("../../documentSymbols/browser/outlineModel.js");
var _asyncJs = require("../../../../base/common/async.js");
var _foldingJs = require("../../folding/browser/folding.js");
var _syntaxRangeProviderJs = require("../../folding/browser/syntaxRangeProvider.js");
var _indentRangeProviderJs = require("../../folding/browser/indentRangeProvider.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _stickyScrollElementJs = require("./stickyScrollElement.js");
var _iteratorJs = require("../../../../base/common/iterator.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var ModelProvider;
(function(ModelProvider) {
    ModelProvider["OUTLINE_MODEL"] = "outlineModel";
    ModelProvider["FOLDING_PROVIDER_MODEL"] = "foldingProviderModel";
    ModelProvider["INDENTATION_MODEL"] = "indentationModel";
})(ModelProvider || (ModelProvider = {}));
var Status;
(function(Status) {
    Status[Status["VALID"] = 0] = "VALID";
    Status[Status["INVALID"] = 1] = "INVALID";
    Status[Status["CANCELED"] = 2] = "CANCELED";
})(Status || (Status = {}));
let StickyModelProvider = class StickyModelProvider extends (0, _lifecycleJs.Disposable) {
    constructor(_editor, onProviderUpdate, _languageConfigurationService, _languageFeaturesService){
        super();
        this._editor = _editor;
        this._modelProviders = [];
        this._modelPromise = null;
        this._updateScheduler = this._register(new (0, _asyncJs.Delayer)(300));
        this._updateOperation = this._register(new (0, _lifecycleJs.DisposableStore)());
        switch(this._editor.getOption(116 /* EditorOption.stickyScroll */ ).defaultModel){
            case ModelProvider.OUTLINE_MODEL:
                this._modelProviders.push(new StickyModelFromCandidateOutlineProvider(this._editor, _languageFeaturesService));
            // fall through
            case ModelProvider.FOLDING_PROVIDER_MODEL:
                this._modelProviders.push(new StickyModelFromCandidateSyntaxFoldingProvider(this._editor, onProviderUpdate, _languageFeaturesService));
            // fall through
            case ModelProvider.INDENTATION_MODEL:
                this._modelProviders.push(new StickyModelFromCandidateIndentationFoldingProvider(this._editor, _languageConfigurationService));
                break;
        }
    }
    dispose() {
        this._modelProviders.forEach((provider)=>provider.dispose());
        this._updateOperation.clear();
        this._cancelModelPromise();
        super.dispose();
    }
    _cancelModelPromise() {
        if (this._modelPromise) {
            this._modelPromise.cancel();
            this._modelPromise = null;
        }
    }
    async update(token) {
        this._updateOperation.clear();
        this._updateOperation.add({
            dispose: ()=>{
                this._cancelModelPromise();
                this._updateScheduler.cancel();
            }
        });
        this._cancelModelPromise();
        return await this._updateScheduler.trigger(async ()=>{
            for (const modelProvider of this._modelProviders){
                const { statusPromise, modelPromise } = modelProvider.computeStickyModel(token);
                this._modelPromise = modelPromise;
                const status = await statusPromise;
                if (this._modelPromise !== modelPromise) return null;
                switch(status){
                    case Status.CANCELED:
                        this._updateOperation.clear();
                        return null;
                    case Status.VALID:
                        return modelProvider.stickyModel;
                }
            }
            return null;
        }).catch((error)=>{
            (0, _errorsJs.onUnexpectedError)(error);
            return null;
        });
    }
};
StickyModelProvider = __decorate([
    __param(2, (0, _instantiationJs.IInstantiationService)),
    __param(3, (0, _languageFeaturesJs.ILanguageFeaturesService))
], StickyModelProvider);
class StickyModelCandidateProvider extends (0, _lifecycleJs.Disposable) {
    constructor(_editor){
        super();
        this._editor = _editor;
        this._stickyModel = null;
    }
    get stickyModel() {
        return this._stickyModel;
    }
    _invalid() {
        this._stickyModel = null;
        return Status.INVALID;
    }
    computeStickyModel(token) {
        if (token.isCancellationRequested || !this.isProviderValid()) return {
            statusPromise: this._invalid(),
            modelPromise: null
        };
        const providerModelPromise = (0, _asyncJs.createCancelablePromise)((token)=>this.createModelFromProvider(token));
        return {
            statusPromise: providerModelPromise.then((providerModel)=>{
                if (!this.isModelValid(providerModel)) return this._invalid();
                if (token.isCancellationRequested) return Status.CANCELED;
                this._stickyModel = this.createStickyModel(token, providerModel);
                return Status.VALID;
            }).then(undefined, (err)=>{
                (0, _errorsJs.onUnexpectedError)(err);
                return Status.CANCELED;
            }),
            modelPromise: providerModelPromise
        };
    }
    /**
     * Method which checks whether the model returned by the provider is valid and can be used to compute a sticky model.
     * This method by default returns true.
     * @param model model returned by the provider
     * @returns boolean indicating whether the model is valid
     */ isModelValid(model) {
        return true;
    }
    /**
     * Method which checks whether the provider is valid before applying it to find the provider model.
     * This method by default returns true.
     * @returns boolean indicating whether the provider is valid
     */ isProviderValid() {
        return true;
    }
}
let StickyModelFromCandidateOutlineProvider = class StickyModelFromCandidateOutlineProvider extends StickyModelCandidateProvider {
    constructor(_editor, _languageFeaturesService){
        super(_editor);
        this._languageFeaturesService = _languageFeaturesService;
    }
    createModelFromProvider(token) {
        return (0, _outlineModelJs.OutlineModel).create(this._languageFeaturesService.documentSymbolProvider, this._editor.getModel(), token);
    }
    createStickyModel(token, model) {
        const { stickyOutlineElement, providerID } = this._stickyModelFromOutlineModel(model, this._stickyModel?.outlineProviderId);
        const textModel = this._editor.getModel();
        return new (0, _stickyScrollElementJs.StickyModel)(textModel.uri, textModel.getVersionId(), stickyOutlineElement, providerID);
    }
    isModelValid(model) {
        return model && model.children.size > 0;
    }
    _stickyModelFromOutlineModel(outlineModel, preferredProvider) {
        let outlineElements;
        // When several possible outline providers
        if ((0, _iteratorJs.Iterable).first(outlineModel.children.values()) instanceof (0, _outlineModelJs.OutlineGroup)) {
            const provider = (0, _iteratorJs.Iterable).find(outlineModel.children.values(), (outlineGroupOfModel)=>outlineGroupOfModel.id === preferredProvider);
            if (provider) outlineElements = provider.children;
            else {
                let tempID = "";
                let maxTotalSumOfRanges = -1;
                let optimalOutlineGroup = undefined;
                for (const [_key, outlineGroup] of outlineModel.children.entries()){
                    const totalSumRanges = this._findSumOfRangesOfGroup(outlineGroup);
                    if (totalSumRanges > maxTotalSumOfRanges) {
                        optimalOutlineGroup = outlineGroup;
                        maxTotalSumOfRanges = totalSumRanges;
                        tempID = outlineGroup.id;
                    }
                }
                preferredProvider = tempID;
                outlineElements = optimalOutlineGroup.children;
            }
        } else outlineElements = outlineModel.children;
        const stickyChildren = [];
        const outlineElementsArray = Array.from(outlineElements.values()).sort((element1, element2)=>{
            const range1 = new (0, _stickyScrollElementJs.StickyRange)(element1.symbol.range.startLineNumber, element1.symbol.range.endLineNumber);
            const range2 = new (0, _stickyScrollElementJs.StickyRange)(element2.symbol.range.startLineNumber, element2.symbol.range.endLineNumber);
            return this._comparator(range1, range2);
        });
        for (const outlineElement of outlineElementsArray)stickyChildren.push(this._stickyModelFromOutlineElement(outlineElement, outlineElement.symbol.selectionRange.startLineNumber));
        const stickyOutlineElement = new (0, _stickyScrollElementJs.StickyElement)(undefined, stickyChildren, undefined);
        return {
            stickyOutlineElement: stickyOutlineElement,
            providerID: preferredProvider
        };
    }
    _stickyModelFromOutlineElement(outlineElement, previousStartLine) {
        const children = [];
        for (const child of outlineElement.children.values())if (child.symbol.selectionRange.startLineNumber !== child.symbol.range.endLineNumber) {
            if (child.symbol.selectionRange.startLineNumber !== previousStartLine) children.push(this._stickyModelFromOutlineElement(child, child.symbol.selectionRange.startLineNumber));
            else for (const subchild of child.children.values())children.push(this._stickyModelFromOutlineElement(subchild, child.symbol.selectionRange.startLineNumber));
        }
        children.sort((child1, child2)=>this._comparator(child1.range, child2.range));
        const range = new (0, _stickyScrollElementJs.StickyRange)(outlineElement.symbol.selectionRange.startLineNumber, outlineElement.symbol.range.endLineNumber);
        return new (0, _stickyScrollElementJs.StickyElement)(range, children, undefined);
    }
    _comparator(range1, range2) {
        if (range1.startLineNumber !== range2.startLineNumber) return range1.startLineNumber - range2.startLineNumber;
        else return range2.endLineNumber - range1.endLineNumber;
    }
    _findSumOfRangesOfGroup(outline) {
        let res = 0;
        for (const child of outline.children.values())res += this._findSumOfRangesOfGroup(child);
        if (outline instanceof (0, _outlineModelJs.OutlineElement)) return res + outline.symbol.range.endLineNumber - outline.symbol.selectionRange.startLineNumber;
        else return res;
    }
};
StickyModelFromCandidateOutlineProvider = __decorate([
    __param(1, (0, _languageFeaturesJs.ILanguageFeaturesService))
], StickyModelFromCandidateOutlineProvider);
class StickyModelFromCandidateFoldingProvider extends StickyModelCandidateProvider {
    constructor(editor){
        super(editor);
        this._foldingLimitReporter = new (0, _foldingJs.RangesLimitReporter)(editor);
    }
    createStickyModel(token, model) {
        const foldingElement = this._fromFoldingRegions(model);
        const textModel = this._editor.getModel();
        return new (0, _stickyScrollElementJs.StickyModel)(textModel.uri, textModel.getVersionId(), foldingElement, undefined);
    }
    isModelValid(model) {
        return model !== null;
    }
    _fromFoldingRegions(foldingRegions) {
        const length = foldingRegions.length;
        const orderedStickyElements = [];
        // The root sticky outline element
        const stickyOutlineElement = new (0, _stickyScrollElementJs.StickyElement)(undefined, [], undefined);
        for(let i = 0; i < length; i++){
            // Finding the parent index of the current range
            const parentIndex = foldingRegions.getParentIndex(i);
            let parentNode;
            if (parentIndex !== -1) // Access the reference of the parent node
            parentNode = orderedStickyElements[parentIndex];
            else // In that case the parent node is the root node
            parentNode = stickyOutlineElement;
            const child = new (0, _stickyScrollElementJs.StickyElement)(new (0, _stickyScrollElementJs.StickyRange)(foldingRegions.getStartLineNumber(i), foldingRegions.getEndLineNumber(i) + 1), [], parentNode);
            parentNode.children.push(child);
            orderedStickyElements.push(child);
        }
        return stickyOutlineElement;
    }
}
let StickyModelFromCandidateIndentationFoldingProvider = class StickyModelFromCandidateIndentationFoldingProvider extends StickyModelFromCandidateFoldingProvider {
    constructor(editor, _languageConfigurationService){
        super(editor);
        this._languageConfigurationService = _languageConfigurationService;
        this.provider = this._register(new (0, _indentRangeProviderJs.IndentRangeProvider)(editor.getModel(), this._languageConfigurationService, this._foldingLimitReporter));
    }
    async createModelFromProvider(token) {
        return this.provider.compute(token);
    }
};
StickyModelFromCandidateIndentationFoldingProvider = __decorate([
    __param(1, (0, _languageConfigurationRegistryJs.ILanguageConfigurationService))
], StickyModelFromCandidateIndentationFoldingProvider);
let StickyModelFromCandidateSyntaxFoldingProvider = class StickyModelFromCandidateSyntaxFoldingProvider extends StickyModelFromCandidateFoldingProvider {
    constructor(editor, onProviderUpdate, _languageFeaturesService){
        super(editor);
        this._languageFeaturesService = _languageFeaturesService;
        const selectedProviders = (0, _foldingJs.FoldingController).getFoldingRangeProviders(this._languageFeaturesService, editor.getModel());
        if (selectedProviders.length > 0) this.provider = this._register(new (0, _syntaxRangeProviderJs.SyntaxRangeProvider)(editor.getModel(), selectedProviders, onProviderUpdate, this._foldingLimitReporter, undefined));
    }
    isProviderValid() {
        return this.provider !== undefined;
    }
    async createModelFromProvider(token) {
        return this.provider?.compute(token) ?? null;
    }
};
StickyModelFromCandidateSyntaxFoldingProvider = __decorate([
    __param(2, (0, _languageFeaturesJs.ILanguageFeaturesService))
], StickyModelFromCandidateSyntaxFoldingProvider);

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../common/services/languageFeatures.js":"2IAko","../../documentSymbols/browser/outlineModel.js":"13q6i","../../../../base/common/async.js":"4GJc4","../../folding/browser/folding.js":"iWk0I","../../folding/browser/syntaxRangeProvider.js":"eOdXK","../../folding/browser/indentRangeProvider.js":"c5EBp","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../../base/common/errors.js":"divX8","./stickyScrollElement.js":"by3mp","../../../../base/common/iterator.js":"2FiS0","../../../../platform/instantiation/common/instantiation.js":"fjwWx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"by3mp":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StickyRange", ()=>StickyRange);
parcelHelpers.export(exports, "StickyElement", ()=>StickyElement);
parcelHelpers.export(exports, "StickyModel", ()=>StickyModel);
class StickyRange {
    constructor(startLineNumber, endLineNumber){
        this.startLineNumber = startLineNumber;
        this.endLineNumber = endLineNumber;
    }
}
class StickyElement {
    constructor(/**
     * Range of line numbers spanned by the current scope
     */ range, /**
     * Must be sorted by start line number
    */ children, /**
     * Parent sticky outline element
     */ parent){
        this.range = range;
        this.children = children;
        this.parent = parent;
    }
}
class StickyModel {
    constructor(uri, version, element, outlineProviderId){
        this.uri = uri;
        this.version = version;
        this.element = element;
        this.outlineProviderId = outlineProviderId;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hrN8f":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SuggestInlineCompletions", ()=>SuggestInlineCompletions);
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _filtersJs = require("../../../../base/common/filters.js");
var _iteratorJs = require("../../../../base/common/iterator.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorFeaturesJs = require("../../../common/editorFeatures.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _completionModelJs = require("./completionModel.js");
var _suggestJs = require("./suggest.js");
var _suggestMemoryJs = require("./suggestMemory.js");
var _suggestModelJs = require("./suggestModel.js");
var _wordDistanceJs = require("./wordDistance.js");
var _clipboardServiceJs = require("../../../../platform/clipboard/common/clipboardService.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class SuggestInlineCompletion {
    constructor(range, insertText, filterText, additionalTextEdits, command, completion){
        this.range = range;
        this.insertText = insertText;
        this.filterText = filterText;
        this.additionalTextEdits = additionalTextEdits;
        this.command = command;
        this.completion = completion;
    }
}
let InlineCompletionResults = class InlineCompletionResults extends (0, _lifecycleJs.RefCountedDisposable) {
    constructor(model, line, word, completionModel, completions, _suggestMemoryService){
        super(completions.disposable);
        this.model = model;
        this.line = line;
        this.word = word;
        this.completionModel = completionModel;
        this._suggestMemoryService = _suggestMemoryService;
    }
    canBeReused(model, line, word) {
        return this.model === model // same model
         && this.line === line && this.word.word.length > 0 && this.word.startColumn === word.startColumn && this.word.endColumn < word.endColumn // same word
         && this.completionModel.getIncompleteProvider().size === 0; // no incomplete results
    }
    get items() {
        const result = [];
        // Split items by preselected index. This ensures the memory-selected item shows first and that better/worst
        // ranked items are before/after
        const { items } = this.completionModel;
        const selectedIndex = this._suggestMemoryService.select(this.model, {
            lineNumber: this.line,
            column: this.word.endColumn + this.completionModel.lineContext.characterCountDelta
        }, items);
        const first = (0, _iteratorJs.Iterable).slice(items, selectedIndex);
        const second = (0, _iteratorJs.Iterable).slice(items, 0, selectedIndex);
        let resolveCount = 5;
        for (const item of (0, _iteratorJs.Iterable).concat(first, second)){
            if (item.score === (0, _filtersJs.FuzzyScore).Default) continue;
            const range = new (0, _rangeJs.Range)(item.editStart.lineNumber, item.editStart.column, item.editInsertEnd.lineNumber, item.editInsertEnd.column + this.completionModel.lineContext.characterCountDelta // end PLUS character delta
            );
            const insertText = item.completion.insertTextRules && item.completion.insertTextRules & 4 /* CompletionItemInsertTextRule.InsertAsSnippet */  ? {
                snippet: item.completion.insertText
            } : item.completion.insertText;
            result.push(new SuggestInlineCompletion(range, insertText, item.filterTextLow ?? item.labelLow, item.completion.additionalTextEdits, item.completion.command, item));
            // resolve the first N suggestions eagerly
            if (resolveCount-- >= 0) item.resolve((0, _cancellationJs.CancellationToken).None);
        }
        return result;
    }
};
InlineCompletionResults = __decorate([
    __param(5, (0, _suggestMemoryJs.ISuggestMemoryService))
], InlineCompletionResults);
let SuggestInlineCompletions = class SuggestInlineCompletions extends (0, _lifecycleJs.Disposable) {
    constructor(_languageFeatureService, _clipboardService, _suggestMemoryService, _editorService){
        super();
        this._languageFeatureService = _languageFeatureService;
        this._clipboardService = _clipboardService;
        this._suggestMemoryService = _suggestMemoryService;
        this._editorService = _editorService;
        this._store.add(_languageFeatureService.inlineCompletionsProvider.register("*", this));
    }
    async provideInlineCompletions(model, position, context, token) {
        if (context.selectedSuggestionInfo) return;
        let editor;
        for (const candidate of this._editorService.listCodeEditors())if (candidate.getModel() === model) {
            editor = candidate;
            break;
        }
        if (!editor) return;
        const config = editor.getOption(90 /* EditorOption.quickSuggestions */ );
        if ((0, _suggestJs.QuickSuggestionsOptions).isAllOff(config)) // quick suggest is off (for this model/language)
        return;
        model.tokenization.tokenizeIfCheap(position.lineNumber);
        const lineTokens = model.tokenization.getLineTokens(position.lineNumber);
        const tokenType = lineTokens.getStandardTokenType(lineTokens.findTokenIndexAtOffset(Math.max(position.column - 1 - 1, 0)));
        if ((0, _suggestJs.QuickSuggestionsOptions).valueFor(config, tokenType) !== "inline") // quick suggest is off (for this token)
        return undefined;
        // We consider non-empty leading words and trigger characters. The latter only
        // when no word is being typed (word characters superseed trigger characters)
        let wordInfo = model.getWordAtPosition(position);
        let triggerCharacterInfo;
        if (!wordInfo?.word) triggerCharacterInfo = this._getTriggerCharacterInfo(model, position);
        if (!wordInfo?.word && !triggerCharacterInfo) // not at word, not a trigger character
        return;
        // ensure that we have word information and that we are at the end of a word
        // otherwise we stop because we don't want to do quick suggestions inside words
        if (!wordInfo) wordInfo = model.getWordUntilPosition(position);
        if (wordInfo.endColumn !== position.column) return;
        let result;
        const leadingLineContents = model.getValueInRange(new (0, _rangeJs.Range)(position.lineNumber, 1, position.lineNumber, position.column));
        if (!triggerCharacterInfo && this._lastResult?.canBeReused(model, position.lineNumber, wordInfo)) {
            // reuse a previous result iff possible, only a refilter is needed
            // TODO@jrieken this can be improved further and only incomplete results can be updated
            // console.log(`REUSE with ${wordInfo.word}`);
            const newLineContext = new (0, _completionModelJs.LineContext)(leadingLineContents, position.column - this._lastResult.word.endColumn);
            this._lastResult.completionModel.lineContext = newLineContext;
            this._lastResult.acquire();
            result = this._lastResult;
        } else {
            // refesh model is required
            const completions = await (0, _suggestJs.provideSuggestionItems)(this._languageFeatureService.completionProvider, model, position, new (0, _suggestJs.CompletionOptions)(undefined, (0, _suggestModelJs.SuggestModel).createSuggestFilter(editor).itemKind, triggerCharacterInfo?.providers), triggerCharacterInfo && {
                triggerKind: 1 /* CompletionTriggerKind.TriggerCharacter */ ,
                triggerCharacter: triggerCharacterInfo.ch
            }, token);
            let clipboardText;
            if (completions.needsClipboard) clipboardText = await this._clipboardService.readText();
            const completionModel = new (0, _completionModelJs.CompletionModel)(completions.items, position.column, new (0, _completionModelJs.LineContext)(leadingLineContents, 0), (0, _wordDistanceJs.WordDistance).None, editor.getOption(119 /* EditorOption.suggest */ ), editor.getOption(113 /* EditorOption.snippetSuggestions */ ), {
                boostFullMatch: false,
                firstMatchCanBeWeak: false
            }, clipboardText);
            result = new InlineCompletionResults(model, position.lineNumber, wordInfo, completionModel, completions, this._suggestMemoryService);
        }
        this._lastResult = result;
        return result;
    }
    handleItemDidShow(_completions, item) {
        item.completion.resolve((0, _cancellationJs.CancellationToken).None);
    }
    freeInlineCompletions(result) {
        result.release();
    }
    _getTriggerCharacterInfo(model, position) {
        const ch = model.getValueInRange((0, _rangeJs.Range).fromPositions({
            lineNumber: position.lineNumber,
            column: position.column - 1
        }, position));
        const providers = new Set();
        for (const provider of this._languageFeatureService.completionProvider.all(model))if (provider.triggerCharacters?.includes(ch)) providers.add(provider);
        if (providers.size === 0) return undefined;
        return {
            providers,
            ch
        };
    }
};
SuggestInlineCompletions = __decorate([
    __param(0, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(1, (0, _clipboardServiceJs.IClipboardService)),
    __param(2, (0, _suggestMemoryJs.ISuggestMemoryService)),
    __param(3, (0, _codeEditorServiceJs.ICodeEditorService))
], SuggestInlineCompletions);
(0, _editorFeaturesJs.registerEditorFeature)(SuggestInlineCompletions);

},{"../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/filters.js":"40BGZ","../../../../base/common/iterator.js":"2FiS0","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/services/codeEditorService.js":"bOWtl","../../../common/core/range.js":"jmUPh","../../../common/editorFeatures.js":"8AkS3","../../../common/services/languageFeatures.js":"2IAko","./completionModel.js":"apYwy","./suggest.js":"8xSUV","./suggestMemory.js":"cZlLP","./suggestModel.js":"bJ1b4","./wordDistance.js":"6CPCo","../../../../platform/clipboard/common/clipboardService.js":"4IsFp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ekXzT":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _stopwatchJs = require("../../../../base/common/stopwatch.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _nlsJs = require("../../../../nls.js");
class ForceRetokenizeAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.forceRetokenize",
            label: _nlsJs.localize("forceRetokenize", "Developer: Force Retokenize"),
            alias: "Developer: Force Retokenize",
            precondition: undefined
        });
    }
    run(accessor, editor) {
        if (!editor.hasModel()) return;
        const model = editor.getModel();
        model.tokenization.resetTokenization();
        const sw = new (0, _stopwatchJs.StopWatch)();
        model.tokenization.forceTokenization(model.getLineCount());
        sw.stop();
        console.log(`tokenization took ${sw.elapsed()}`);
    }
}
(0, _editorExtensionsJs.registerEditorAction)(ForceRetokenizeAction);

},{"../../../../base/common/stopwatch.js":"77PF9","../../../browser/editorExtensions.js":"kC3w6","../../../../nls.js":"l617d"}],"asKZX":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleTabFocusModeAction", ()=>ToggleTabFocusModeAction);
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var _tabFocusJs = require("../../../browser/config/tabFocus.js");
var _nlsJs = require("../../../../nls.js");
var _actionsJs = require("../../../../platform/actions/common/actions.js");
class ToggleTabFocusModeAction extends (0, _actionsJs.Action2) {
    static{
        this.ID = "editor.action.toggleTabFocusMode";
    }
    constructor(){
        super({
            id: ToggleTabFocusModeAction.ID,
            title: _nlsJs.localize2({
                key: "toggle.tabMovesFocus",
                comment: [
                    "Turn on/off use of tab key for moving focus around VS Code"
                ]
            }, "Toggle Tab Key Moves Focus"),
            precondition: undefined,
            keybinding: {
                primary: 2091 /* KeyCode.KeyM */ ,
                mac: {
                    primary: 1323 /* KeyCode.KeyM */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            metadata: {
                description: _nlsJs.localize2("tabMovesFocusDescriptions", "Determines whether the tab key moves focus around the workbench or inserts the tab character in the current editor. This is also called tab trapping, tab navigation, or tab focus mode.")
            },
            f1: true
        });
    }
    run() {
        const oldValue = (0, _tabFocusJs.TabFocus).getTabFocusMode();
        const newValue = !oldValue;
        (0, _tabFocusJs.TabFocus).setTabFocusMode(newValue);
        if (newValue) (0, _ariaJs.alert)(_nlsJs.localize("toggle.tabMovesFocus.on", "Pressing Tab will now move focus to the next focusable element"));
        else (0, _ariaJs.alert)(_nlsJs.localize("toggle.tabMovesFocus.off", "Pressing Tab will now insert the tab character"));
    }
}
(0, _actionsJs.registerAction2)(ToggleTabFocusModeAction);

},{"../../../../base/browser/ui/aria/aria.js":"asrsh","../../../browser/config/tabFocus.js":"aWia7","../../../../nls.js":"l617d","../../../../platform/actions/common/actions.js":"kyMtp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kla5S":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warningIcon", ()=>warningIcon);
parcelHelpers.export(exports, "UnicodeHighlighter", ()=>UnicodeHighlighter);
parcelHelpers.export(exports, "UnicodeHighlighterHoverParticipant", ()=>UnicodeHighlighterHoverParticipant);
parcelHelpers.export(exports, "DisableHighlightingInCommentsAction", ()=>DisableHighlightingInCommentsAction);
parcelHelpers.export(exports, "DisableHighlightingInStringsAction", ()=>DisableHighlightingInStringsAction);
parcelHelpers.export(exports, "DisableHighlightingOfAmbiguousCharactersAction", ()=>DisableHighlightingOfAmbiguousCharactersAction);
parcelHelpers.export(exports, "DisableHighlightingOfInvisibleCharactersAction", ()=>DisableHighlightingOfInvisibleCharactersAction);
parcelHelpers.export(exports, "DisableHighlightingOfNonBasicAsciiCharactersAction", ()=>DisableHighlightingOfNonBasicAsciiCharactersAction);
parcelHelpers.export(exports, "ShowExcludeOptions", ()=>ShowExcludeOptions);
var _asyncJs = require("../../../../base/common/async.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _htmlContentJs = require("../../../../base/common/htmlContent.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _platformJs = require("../../../../base/common/platform.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _unicodeHighlighterCss = require("./unicodeHighlighter.css");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
var _textModelJs = require("../../../common/model/textModel.js");
var _unicodeTextModelHighlighterJs = require("../../../common/services/unicodeTextModelHighlighter.js");
var _editorWorkerJs = require("../../../common/services/editorWorker.js");
var _languageJs = require("../../../common/languages/language.js");
var _viewModelDecorationsJs = require("../../../common/viewModel/viewModelDecorations.js");
var _hoverTypesJs = require("../../hover/browser/hoverTypes.js");
var _markdownHoverParticipantJs = require("../../hover/browser/markdownHoverParticipant.js");
var _bannerControllerJs = require("./bannerController.js");
var _nlsJs = require("../../../../nls.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _openerJs = require("../../../../platform/opener/common/opener.js");
var _quickInputJs = require("../../../../platform/quickinput/common/quickInput.js");
var _iconRegistryJs = require("../../../../platform/theme/common/iconRegistry.js");
var _workspaceTrustJs = require("../../../../platform/workspace/common/workspaceTrust.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const warningIcon = (0, _iconRegistryJs.registerIcon)("extensions-warning-message", (0, _codiconsJs.Codicon).warning, _nlsJs.localize("warningIcon", "Icon shown with a warning message in the extensions editor."));
let UnicodeHighlighter = class UnicodeHighlighter extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.unicodeHighlighter";
    }
    constructor(_editor, _editorWorkerService, _workspaceTrustService, instantiationService){
        super();
        this._editor = _editor;
        this._editorWorkerService = _editorWorkerService;
        this._workspaceTrustService = _workspaceTrustService;
        this._highlighter = null;
        this._bannerClosed = false;
        this._updateState = (state)=>{
            if (state && state.hasMore) {
                if (this._bannerClosed) return;
                // This document contains many non-basic ASCII characters.
                const max = Math.max(state.ambiguousCharacterCount, state.nonBasicAsciiCharacterCount, state.invisibleCharacterCount);
                let data;
                if (state.nonBasicAsciiCharacterCount >= max) data = {
                    message: _nlsJs.localize("unicodeHighlighting.thisDocumentHasManyNonBasicAsciiUnicodeCharacters", "This document contains many non-basic ASCII unicode characters"),
                    command: new DisableHighlightingOfNonBasicAsciiCharactersAction()
                };
                else if (state.ambiguousCharacterCount >= max) data = {
                    message: _nlsJs.localize("unicodeHighlighting.thisDocumentHasManyAmbiguousUnicodeCharacters", "This document contains many ambiguous unicode characters"),
                    command: new DisableHighlightingOfAmbiguousCharactersAction()
                };
                else if (state.invisibleCharacterCount >= max) data = {
                    message: _nlsJs.localize("unicodeHighlighting.thisDocumentHasManyInvisibleUnicodeCharacters", "This document contains many invisible unicode characters"),
                    command: new DisableHighlightingOfInvisibleCharactersAction()
                };
                else throw new Error("Unreachable");
                this._bannerController.show({
                    id: "unicodeHighlightBanner",
                    message: data.message,
                    icon: warningIcon,
                    actions: [
                        {
                            label: data.command.shortLabel,
                            href: `command:${data.command.id}`
                        }
                    ],
                    onClose: ()=>{
                        this._bannerClosed = true;
                    }
                });
            } else this._bannerController.hide();
        };
        this._bannerController = this._register(instantiationService.createInstance((0, _bannerControllerJs.BannerController), _editor));
        this._register(this._editor.onDidChangeModel(()=>{
            this._bannerClosed = false;
            this._updateHighlighter();
        }));
        this._options = _editor.getOption(126 /* EditorOption.unicodeHighlighting */ );
        this._register(_workspaceTrustService.onDidChangeTrust((e)=>{
            this._updateHighlighter();
        }));
        this._register(_editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(126 /* EditorOption.unicodeHighlighting */ )) {
                this._options = _editor.getOption(126 /* EditorOption.unicodeHighlighting */ );
                this._updateHighlighter();
            }
        }));
        this._updateHighlighter();
    }
    dispose() {
        if (this._highlighter) {
            this._highlighter.dispose();
            this._highlighter = null;
        }
        super.dispose();
    }
    _updateHighlighter() {
        this._updateState(null);
        if (this._highlighter) {
            this._highlighter.dispose();
            this._highlighter = null;
        }
        if (!this._editor.hasModel()) return;
        const options = resolveOptions(this._workspaceTrustService.isWorkspaceTrusted(), this._options);
        if ([
            options.nonBasicASCII,
            options.ambiguousCharacters,
            options.invisibleCharacters
        ].every((option)=>option === false)) // Don't do anything if the feature is fully disabled
        return;
        const highlightOptions = {
            nonBasicASCII: options.nonBasicASCII,
            ambiguousCharacters: options.ambiguousCharacters,
            invisibleCharacters: options.invisibleCharacters,
            includeComments: options.includeComments,
            includeStrings: options.includeStrings,
            allowedCodePoints: Object.keys(options.allowedCharacters).map((c)=>c.codePointAt(0)),
            allowedLocales: Object.keys(options.allowedLocales).map((locale)=>{
                if (locale === "_os") {
                    const osLocale = new Intl.NumberFormat().resolvedOptions().locale;
                    return osLocale;
                } else if (locale === "_vscode") return _platformJs.language;
                return locale;
            })
        };
        if (this._editorWorkerService.canComputeUnicodeHighlights(this._editor.getModel().uri)) this._highlighter = new DocumentUnicodeHighlighter(this._editor, highlightOptions, this._updateState, this._editorWorkerService);
        else this._highlighter = new ViewportUnicodeHighlighter(this._editor, highlightOptions, this._updateState);
    }
    getDecorationInfo(decoration) {
        if (this._highlighter) return this._highlighter.getDecorationInfo(decoration);
        return null;
    }
};
UnicodeHighlighter = __decorate([
    __param(1, (0, _editorWorkerJs.IEditorWorkerService)),
    __param(2, (0, _workspaceTrustJs.IWorkspaceTrustManagementService)),
    __param(3, (0, _instantiationJs.IInstantiationService))
], UnicodeHighlighter);
function resolveOptions(trusted, options) {
    return {
        nonBasicASCII: options.nonBasicASCII === (0, _editorOptionsJs.inUntrustedWorkspace) ? !trusted : options.nonBasicASCII,
        ambiguousCharacters: options.ambiguousCharacters,
        invisibleCharacters: options.invisibleCharacters,
        includeComments: options.includeComments === (0, _editorOptionsJs.inUntrustedWorkspace) ? !trusted : options.includeComments,
        includeStrings: options.includeStrings === (0, _editorOptionsJs.inUntrustedWorkspace) ? !trusted : options.includeStrings,
        allowedCharacters: options.allowedCharacters,
        allowedLocales: options.allowedLocales
    };
}
let DocumentUnicodeHighlighter = class DocumentUnicodeHighlighter extends (0, _lifecycleJs.Disposable) {
    constructor(_editor, _options, _updateState, _editorWorkerService){
        super();
        this._editor = _editor;
        this._options = _options;
        this._updateState = _updateState;
        this._editorWorkerService = _editorWorkerService;
        this._model = this._editor.getModel();
        this._decorations = this._editor.createDecorationsCollection();
        this._updateSoon = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._update(), 250));
        this._register(this._editor.onDidChangeModelContent(()=>{
            this._updateSoon.schedule();
        }));
        this._updateSoon.schedule();
    }
    dispose() {
        this._decorations.clear();
        super.dispose();
    }
    _update() {
        if (this._model.isDisposed()) return;
        if (!this._model.mightContainNonBasicASCII()) {
            this._decorations.clear();
            return;
        }
        const modelVersionId = this._model.getVersionId();
        this._editorWorkerService.computedUnicodeHighlights(this._model.uri, this._options).then((info)=>{
            if (this._model.isDisposed()) return;
            if (this._model.getVersionId() !== modelVersionId) // model changed in the meantime
            return;
            this._updateState(info);
            const decorations = [];
            if (!info.hasMore) // Don't show decoration if there are too many.
            // In this case, a banner is shown.
            for (const range of info.ranges)decorations.push({
                range: range,
                options: Decorations.instance.getDecorationFromOptions(this._options)
            });
            this._decorations.set(decorations);
        });
    }
    getDecorationInfo(decoration) {
        if (!this._decorations.has(decoration)) return null;
        const model = this._editor.getModel();
        if (!(0, _viewModelDecorationsJs.isModelDecorationVisible)(model, decoration)) return null;
        const text = model.getValueInRange(decoration.range);
        return {
            reason: computeReason(text, this._options),
            inComment: (0, _viewModelDecorationsJs.isModelDecorationInComment)(model, decoration),
            inString: (0, _viewModelDecorationsJs.isModelDecorationInString)(model, decoration)
        };
    }
};
DocumentUnicodeHighlighter = __decorate([
    __param(3, (0, _editorWorkerJs.IEditorWorkerService))
], DocumentUnicodeHighlighter);
class ViewportUnicodeHighlighter extends (0, _lifecycleJs.Disposable) {
    constructor(_editor, _options, _updateState){
        super();
        this._editor = _editor;
        this._options = _options;
        this._updateState = _updateState;
        this._model = this._editor.getModel();
        this._decorations = this._editor.createDecorationsCollection();
        this._updateSoon = this._register(new (0, _asyncJs.RunOnceScheduler)(()=>this._update(), 250));
        this._register(this._editor.onDidLayoutChange(()=>{
            this._updateSoon.schedule();
        }));
        this._register(this._editor.onDidScrollChange(()=>{
            this._updateSoon.schedule();
        }));
        this._register(this._editor.onDidChangeHiddenAreas(()=>{
            this._updateSoon.schedule();
        }));
        this._register(this._editor.onDidChangeModelContent(()=>{
            this._updateSoon.schedule();
        }));
        this._updateSoon.schedule();
    }
    dispose() {
        this._decorations.clear();
        super.dispose();
    }
    _update() {
        if (this._model.isDisposed()) return;
        if (!this._model.mightContainNonBasicASCII()) {
            this._decorations.clear();
            return;
        }
        const ranges = this._editor.getVisibleRanges();
        const decorations = [];
        const totalResult = {
            ranges: [],
            ambiguousCharacterCount: 0,
            invisibleCharacterCount: 0,
            nonBasicAsciiCharacterCount: 0,
            hasMore: false
        };
        for (const range of ranges){
            const result = (0, _unicodeTextModelHighlighterJs.UnicodeTextModelHighlighter).computeUnicodeHighlights(this._model, this._options, range);
            for (const r of result.ranges)totalResult.ranges.push(r);
            totalResult.ambiguousCharacterCount += totalResult.ambiguousCharacterCount;
            totalResult.invisibleCharacterCount += totalResult.invisibleCharacterCount;
            totalResult.nonBasicAsciiCharacterCount += totalResult.nonBasicAsciiCharacterCount;
            totalResult.hasMore = totalResult.hasMore || result.hasMore;
        }
        if (!totalResult.hasMore) // Don't show decorations if there are too many.
        // A banner will be shown instead.
        for (const range of totalResult.ranges)decorations.push({
            range,
            options: Decorations.instance.getDecorationFromOptions(this._options)
        });
        this._updateState(totalResult);
        this._decorations.set(decorations);
    }
    getDecorationInfo(decoration) {
        if (!this._decorations.has(decoration)) return null;
        const model = this._editor.getModel();
        const text = model.getValueInRange(decoration.range);
        if (!(0, _viewModelDecorationsJs.isModelDecorationVisible)(model, decoration)) return null;
        return {
            reason: computeReason(text, this._options),
            inComment: (0, _viewModelDecorationsJs.isModelDecorationInComment)(model, decoration),
            inString: (0, _viewModelDecorationsJs.isModelDecorationInString)(model, decoration)
        };
    }
}
const configureUnicodeHighlightOptionsStr = _nlsJs.localize("unicodeHighlight.configureUnicodeHighlightOptions", "Configure Unicode Highlight Options");
let UnicodeHighlighterHoverParticipant = class UnicodeHighlighterHoverParticipant {
    constructor(_editor, _languageService, _openerService){
        this._editor = _editor;
        this._languageService = _languageService;
        this._openerService = _openerService;
        this.hoverOrdinal = 5;
    }
    computeSync(anchor, lineDecorations) {
        if (!this._editor.hasModel() || anchor.type !== 1 /* HoverAnchorType.Range */ ) return [];
        const model = this._editor.getModel();
        const unicodeHighlighter = this._editor.getContribution(UnicodeHighlighter.ID);
        if (!unicodeHighlighter) return [];
        const result = [];
        const existedReason = new Set();
        let index = 300;
        for (const d of lineDecorations){
            const highlightInfo = unicodeHighlighter.getDecorationInfo(d);
            if (!highlightInfo) continue;
            const char = model.getValueInRange(d.range);
            // text refers to a single character.
            const codePoint = char.codePointAt(0);
            const codePointStr = formatCodePointMarkdown(codePoint);
            let reason;
            switch(highlightInfo.reason.kind){
                case 0 /* UnicodeHighlighterReasonKind.Ambiguous */ :
                    if ((0, _stringsJs.isBasicASCII)(highlightInfo.reason.confusableWith)) reason = _nlsJs.localize("unicodeHighlight.characterIsAmbiguousASCII", "The character {0} could be confused with the ASCII character {1}, which is more common in source code.", codePointStr, formatCodePointMarkdown(highlightInfo.reason.confusableWith.codePointAt(0)));
                    else reason = _nlsJs.localize("unicodeHighlight.characterIsAmbiguous", "The character {0} could be confused with the character {1}, which is more common in source code.", codePointStr, formatCodePointMarkdown(highlightInfo.reason.confusableWith.codePointAt(0)));
                    break;
                case 1 /* UnicodeHighlighterReasonKind.Invisible */ :
                    reason = _nlsJs.localize("unicodeHighlight.characterIsInvisible", "The character {0} is invisible.", codePointStr);
                    break;
                case 2 /* UnicodeHighlighterReasonKind.NonBasicAscii */ :
                    reason = _nlsJs.localize("unicodeHighlight.characterIsNonBasicAscii", "The character {0} is not a basic ASCII character.", codePointStr);
                    break;
            }
            if (existedReason.has(reason)) continue;
            existedReason.add(reason);
            const adjustSettingsArgs = {
                codePoint: codePoint,
                reason: highlightInfo.reason,
                inComment: highlightInfo.inComment,
                inString: highlightInfo.inString
            };
            const adjustSettings = _nlsJs.localize("unicodeHighlight.adjustSettings", "Adjust settings");
            const uri = `command:${ShowExcludeOptions.ID}?${encodeURIComponent(JSON.stringify(adjustSettingsArgs))}`;
            const markdown = new (0, _htmlContentJs.MarkdownString)("", true).appendMarkdown(reason).appendText(" ").appendLink(uri, adjustSettings, configureUnicodeHighlightOptionsStr);
            result.push(new (0, _markdownHoverParticipantJs.MarkdownHover)(this, d.range, [
                markdown
            ], false, index++));
        }
        return result;
    }
    renderHoverParts(context, hoverParts) {
        return (0, _markdownHoverParticipantJs.renderMarkdownHovers)(context, hoverParts, this._editor, this._languageService, this._openerService);
    }
};
UnicodeHighlighterHoverParticipant = __decorate([
    __param(1, (0, _languageJs.ILanguageService)),
    __param(2, (0, _openerJs.IOpenerService))
], UnicodeHighlighterHoverParticipant);
function codePointToHex(codePoint) {
    return `U+${codePoint.toString(16).padStart(4, "0")}`;
}
function formatCodePointMarkdown(codePoint) {
    let value = `\`${codePointToHex(codePoint)}\``;
    if (!(0, _stringsJs.InvisibleCharacters).isInvisibleCharacter(codePoint)) // Don't render any control characters or any invisible characters, as they cannot be seen anyways.
    value += ` "${`${renderCodePointAsInlineCode(codePoint)}`}"`;
    return value;
}
function renderCodePointAsInlineCode(codePoint) {
    if (codePoint === 96 /* CharCode.BackTick */ ) return "`` ` ``";
    return "`" + String.fromCodePoint(codePoint) + "`";
}
function computeReason(char, options) {
    return (0, _unicodeTextModelHighlighterJs.UnicodeTextModelHighlighter).computeUnicodeHighlightReason(char, options);
}
class Decorations {
    constructor(){
        this.map = new Map();
    }
    static{
        this.instance = new Decorations();
    }
    getDecorationFromOptions(options) {
        return this.getDecoration(!options.includeComments, !options.includeStrings);
    }
    getDecoration(hideInComments, hideInStrings) {
        const key = `${hideInComments}${hideInStrings}`;
        let options = this.map.get(key);
        if (!options) {
            options = (0, _textModelJs.ModelDecorationOptions).createDynamic({
                description: "unicode-highlight",
                stickiness: 1 /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */ ,
                className: "unicode-highlight",
                showIfCollapsed: true,
                overviewRuler: null,
                minimap: null,
                hideInCommentTokens: hideInComments,
                hideInStringTokens: hideInStrings
            });
            this.map.set(key, options);
        }
        return options;
    }
}
class DisableHighlightingInCommentsAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: DisableHighlightingOfAmbiguousCharactersAction.ID,
            label: _nlsJs.localize("action.unicodeHighlight.disableHighlightingInComments", "Disable highlighting of characters in comments"),
            alias: "Disable highlighting of characters in comments",
            precondition: undefined
        });
        this.shortLabel = _nlsJs.localize("unicodeHighlight.disableHighlightingInComments.shortLabel", "Disable Highlight In Comments");
    }
    async run(accessor, editor, args) {
        const configurationService = accessor?.get((0, _configurationJs.IConfigurationService));
        if (configurationService) this.runAction(configurationService);
    }
    async runAction(configurationService) {
        await configurationService.updateValue((0, _editorOptionsJs.unicodeHighlightConfigKeys).includeComments, false, 2 /* ConfigurationTarget.USER */ );
    }
}
class DisableHighlightingInStringsAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: DisableHighlightingOfAmbiguousCharactersAction.ID,
            label: _nlsJs.localize("action.unicodeHighlight.disableHighlightingInStrings", "Disable highlighting of characters in strings"),
            alias: "Disable highlighting of characters in strings",
            precondition: undefined
        });
        this.shortLabel = _nlsJs.localize("unicodeHighlight.disableHighlightingInStrings.shortLabel", "Disable Highlight In Strings");
    }
    async run(accessor, editor, args) {
        const configurationService = accessor?.get((0, _configurationJs.IConfigurationService));
        if (configurationService) this.runAction(configurationService);
    }
    async runAction(configurationService) {
        await configurationService.updateValue((0, _editorOptionsJs.unicodeHighlightConfigKeys).includeStrings, false, 2 /* ConfigurationTarget.USER */ );
    }
}
class DisableHighlightingOfAmbiguousCharactersAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.unicodeHighlight.disableHighlightingOfAmbiguousCharacters";
    }
    constructor(){
        super({
            id: DisableHighlightingOfAmbiguousCharactersAction.ID,
            label: _nlsJs.localize("action.unicodeHighlight.disableHighlightingOfAmbiguousCharacters", "Disable highlighting of ambiguous characters"),
            alias: "Disable highlighting of ambiguous characters",
            precondition: undefined
        });
        this.shortLabel = _nlsJs.localize("unicodeHighlight.disableHighlightingOfAmbiguousCharacters.shortLabel", "Disable Ambiguous Highlight");
    }
    async run(accessor, editor, args) {
        const configurationService = accessor?.get((0, _configurationJs.IConfigurationService));
        if (configurationService) this.runAction(configurationService);
    }
    async runAction(configurationService) {
        await configurationService.updateValue((0, _editorOptionsJs.unicodeHighlightConfigKeys).ambiguousCharacters, false, 2 /* ConfigurationTarget.USER */ );
    }
}
class DisableHighlightingOfInvisibleCharactersAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.unicodeHighlight.disableHighlightingOfInvisibleCharacters";
    }
    constructor(){
        super({
            id: DisableHighlightingOfInvisibleCharactersAction.ID,
            label: _nlsJs.localize("action.unicodeHighlight.disableHighlightingOfInvisibleCharacters", "Disable highlighting of invisible characters"),
            alias: "Disable highlighting of invisible characters",
            precondition: undefined
        });
        this.shortLabel = _nlsJs.localize("unicodeHighlight.disableHighlightingOfInvisibleCharacters.shortLabel", "Disable Invisible Highlight");
    }
    async run(accessor, editor, args) {
        const configurationService = accessor?.get((0, _configurationJs.IConfigurationService));
        if (configurationService) this.runAction(configurationService);
    }
    async runAction(configurationService) {
        await configurationService.updateValue((0, _editorOptionsJs.unicodeHighlightConfigKeys).invisibleCharacters, false, 2 /* ConfigurationTarget.USER */ );
    }
}
class DisableHighlightingOfNonBasicAsciiCharactersAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.unicodeHighlight.disableHighlightingOfNonBasicAsciiCharacters";
    }
    constructor(){
        super({
            id: DisableHighlightingOfNonBasicAsciiCharactersAction.ID,
            label: _nlsJs.localize("action.unicodeHighlight.disableHighlightingOfNonBasicAsciiCharacters", "Disable highlighting of non basic ASCII characters"),
            alias: "Disable highlighting of non basic ASCII characters",
            precondition: undefined
        });
        this.shortLabel = _nlsJs.localize("unicodeHighlight.disableHighlightingOfNonBasicAsciiCharacters.shortLabel", "Disable Non ASCII Highlight");
    }
    async run(accessor, editor, args) {
        const configurationService = accessor?.get((0, _configurationJs.IConfigurationService));
        if (configurationService) this.runAction(configurationService);
    }
    async runAction(configurationService) {
        await configurationService.updateValue((0, _editorOptionsJs.unicodeHighlightConfigKeys).nonBasicASCII, false, 2 /* ConfigurationTarget.USER */ );
    }
}
class ShowExcludeOptions extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.unicodeHighlight.showExcludeOptions";
    }
    constructor(){
        super({
            id: ShowExcludeOptions.ID,
            label: _nlsJs.localize("action.unicodeHighlight.showExcludeOptions", "Show Exclude Options"),
            alias: "Show Exclude Options",
            precondition: undefined
        });
    }
    async run(accessor, editor, args) {
        const { codePoint, reason, inString, inComment } = args;
        const char = String.fromCodePoint(codePoint);
        const quickPickService = accessor.get((0, _quickInputJs.IQuickInputService));
        const configurationService = accessor.get((0, _configurationJs.IConfigurationService));
        function getExcludeCharFromBeingHighlightedLabel(codePoint) {
            if ((0, _stringsJs.InvisibleCharacters).isInvisibleCharacter(codePoint)) return _nlsJs.localize("unicodeHighlight.excludeInvisibleCharFromBeingHighlighted", "Exclude {0} (invisible character) from being highlighted", codePointToHex(codePoint));
            return _nlsJs.localize("unicodeHighlight.excludeCharFromBeingHighlighted", "Exclude {0} from being highlighted", `${codePointToHex(codePoint)} "${char}"`);
        }
        const options = [];
        if (reason.kind === 0 /* UnicodeHighlighterReasonKind.Ambiguous */ ) for (const locale of reason.notAmbiguousInLocales)options.push({
            label: _nlsJs.localize("unicodeHighlight.allowCommonCharactersInLanguage", 'Allow unicode characters that are more common in the language "{0}".', locale),
            run: async ()=>{
                excludeLocaleFromBeingHighlighted(configurationService, [
                    locale
                ]);
            }
        });
        options.push({
            label: getExcludeCharFromBeingHighlightedLabel(codePoint),
            run: ()=>excludeCharFromBeingHighlighted(configurationService, [
                    codePoint
                ])
        });
        if (inComment) {
            const action = new DisableHighlightingInCommentsAction();
            options.push({
                label: action.label,
                run: async ()=>action.runAction(configurationService)
            });
        } else if (inString) {
            const action = new DisableHighlightingInStringsAction();
            options.push({
                label: action.label,
                run: async ()=>action.runAction(configurationService)
            });
        }
        if (reason.kind === 0 /* UnicodeHighlighterReasonKind.Ambiguous */ ) {
            const action = new DisableHighlightingOfAmbiguousCharactersAction();
            options.push({
                label: action.label,
                run: async ()=>action.runAction(configurationService)
            });
        } else if (reason.kind === 1 /* UnicodeHighlighterReasonKind.Invisible */ ) {
            const action = new DisableHighlightingOfInvisibleCharactersAction();
            options.push({
                label: action.label,
                run: async ()=>action.runAction(configurationService)
            });
        } else if (reason.kind === 2 /* UnicodeHighlighterReasonKind.NonBasicAscii */ ) {
            const action = new DisableHighlightingOfNonBasicAsciiCharactersAction();
            options.push({
                label: action.label,
                run: async ()=>action.runAction(configurationService)
            });
        } else expectNever(reason);
        const result = await quickPickService.pick(options, {
            title: configureUnicodeHighlightOptionsStr
        });
        if (result) await result.run();
    }
}
async function excludeCharFromBeingHighlighted(configurationService, charCodes) {
    const existingValue = configurationService.getValue((0, _editorOptionsJs.unicodeHighlightConfigKeys).allowedCharacters);
    let value;
    if (typeof existingValue === "object" && existingValue) value = existingValue;
    else value = {};
    for (const charCode of charCodes)value[String.fromCodePoint(charCode)] = true;
    await configurationService.updateValue((0, _editorOptionsJs.unicodeHighlightConfigKeys).allowedCharacters, value, 2 /* ConfigurationTarget.USER */ );
}
async function excludeLocaleFromBeingHighlighted(configurationService, locales) {
    const existingValue = configurationService.inspect((0, _editorOptionsJs.unicodeHighlightConfigKeys).allowedLocales).user?.value;
    let value;
    if (typeof existingValue === "object" && existingValue) // Copy value, as the existing value is read only
    value = Object.assign({}, existingValue);
    else value = {};
    for (const locale of locales)value[locale] = true;
    await configurationService.updateValue((0, _editorOptionsJs.unicodeHighlightConfigKeys).allowedLocales, value, 2 /* ConfigurationTarget.USER */ );
}
function expectNever(value) {
    throw new Error(`Unexpected value: ${value}`);
}
(0, _editorExtensionsJs.registerEditorAction)(DisableHighlightingOfAmbiguousCharactersAction);
(0, _editorExtensionsJs.registerEditorAction)(DisableHighlightingOfInvisibleCharactersAction);
(0, _editorExtensionsJs.registerEditorAction)(DisableHighlightingOfNonBasicAsciiCharactersAction);
(0, _editorExtensionsJs.registerEditorAction)(ShowExcludeOptions);
(0, _editorExtensionsJs.registerEditorContribution)(UnicodeHighlighter.ID, UnicodeHighlighter, 1 /* EditorContributionInstantiation.AfterFirstRender */ );
(0, _hoverTypesJs.HoverParticipantRegistry).register(UnicodeHighlighterHoverParticipant);

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/htmlContent.js":"3Hxzm","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/platform.js":"7maJO","../../../../base/common/strings.js":"aA9I1","./unicodeHighlighter.css":"aWWo0","../../../browser/editorExtensions.js":"kC3w6","../../../common/config/editorOptions.js":"3Xi00","../../../common/model/textModel.js":"9beDe","../../../common/services/unicodeTextModelHighlighter.js":"av1me","../../../common/services/editorWorker.js":"aaYJd","../../../common/languages/language.js":"ka2JQ","../../../common/viewModel/viewModelDecorations.js":"lGBM0","../../hover/browser/hoverTypes.js":"6vmRi","../../hover/browser/markdownHoverParticipant.js":"l8mtm","./bannerController.js":"lBcfe","../../../../nls.js":"l617d","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/opener/common/opener.js":"d3tj1","../../../../platform/quickinput/common/quickInput.js":"a56M6","../../../../platform/theme/common/iconRegistry.js":"bRNEz","../../../../platform/workspace/common/workspaceTrust.js":"4R356","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aWWo0":[function() {},{}],"lBcfe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BannerController", ()=>BannerController);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _bannerControllerCss = require("./bannerController.css");
var _domJs = require("../../../../base/browser/dom.js");
var _actionbarJs = require("../../../../base/browser/ui/actionbar/actionbar.js");
var _actionsJs = require("../../../../base/common/actions.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _markdownRendererJs = require("../../../browser/widget/markdownRenderer/browser/markdownRenderer.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _linkJs = require("../../../../platform/opener/browser/link.js");
var _iconRegistryJs = require("../../../../platform/theme/common/iconRegistry.js");
var _themablesJs = require("../../../../base/common/themables.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const BANNER_ELEMENT_HEIGHT = 26;
let BannerController = class BannerController extends (0, _lifecycleJs.Disposable) {
    constructor(_editor, instantiationService){
        super();
        this._editor = _editor;
        this.instantiationService = instantiationService;
        this.banner = this._register(this.instantiationService.createInstance(Banner));
    }
    hide() {
        this._editor.setBanner(null, 0);
        this.banner.clear();
    }
    show(item) {
        this.banner.show({
            ...item,
            onClose: ()=>{
                this.hide();
                item.onClose?.();
            }
        });
        this._editor.setBanner(this.banner.element, BANNER_ELEMENT_HEIGHT);
    }
};
BannerController = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService))
], BannerController);
// TODO@hediet: Investigate if this can be reused by the workspace banner (bannerPart.ts).
let Banner = class Banner extends (0, _lifecycleJs.Disposable) {
    constructor(instantiationService){
        super();
        this.instantiationService = instantiationService;
        this.markdownRenderer = this.instantiationService.createInstance((0, _markdownRendererJs.MarkdownRenderer), {});
        this.element = (0, _domJs.$)("div.editor-banner");
        this.element.tabIndex = 0;
    }
    getAriaLabel(item) {
        if (item.ariaLabel) return item.ariaLabel;
        if (typeof item.message === "string") return item.message;
        return undefined;
    }
    getBannerMessage(message) {
        if (typeof message === "string") {
            const element = (0, _domJs.$)("span");
            element.innerText = message;
            return element;
        }
        return this.markdownRenderer.render(message).element;
    }
    clear() {
        (0, _domJs.clearNode)(this.element);
    }
    show(item) {
        // Clear previous item
        (0, _domJs.clearNode)(this.element);
        // Banner aria label
        const ariaLabel = this.getAriaLabel(item);
        if (ariaLabel) this.element.setAttribute("aria-label", ariaLabel);
        // Icon
        const iconContainer = (0, _domJs.append)(this.element, (0, _domJs.$)("div.icon-container"));
        iconContainer.setAttribute("aria-hidden", "true");
        if (item.icon) iconContainer.appendChild((0, _domJs.$)(`div${(0, _themablesJs.ThemeIcon).asCSSSelector(item.icon)}`));
        // Message
        const messageContainer = (0, _domJs.append)(this.element, (0, _domJs.$)("div.message-container"));
        messageContainer.setAttribute("aria-hidden", "true");
        messageContainer.appendChild(this.getBannerMessage(item.message));
        // Message Actions
        this.messageActionsContainer = (0, _domJs.append)(this.element, (0, _domJs.$)("div.message-actions-container"));
        if (item.actions) for (const action of item.actions)this._register(this.instantiationService.createInstance((0, _linkJs.Link), this.messageActionsContainer, {
            ...action,
            tabIndex: -1
        }, {}));
        // Action
        const actionBarContainer = (0, _domJs.append)(this.element, (0, _domJs.$)("div.action-container"));
        this.actionBar = this._register(new (0, _actionbarJs.ActionBar)(actionBarContainer));
        this.actionBar.push(this._register(new (0, _actionsJs.Action)("banner.close", "Close Banner", (0, _themablesJs.ThemeIcon).asClassName((0, _iconRegistryJs.widgetClose)), true, ()=>{
            if (typeof item.onClose === "function") item.onClose();
        })), {
            icon: true,
            label: false
        });
        this.actionBar.setFocusable(false);
    }
};
Banner = __decorate([
    __param(0, (0, _instantiationJs.IInstantiationService))
], Banner);

},{"./bannerController.css":"yrHhA","../../../../base/browser/dom.js":"bnqsM","../../../../base/browser/ui/actionbar/actionbar.js":"5Xmba","../../../../base/common/actions.js":"5GjLb","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/widget/markdownRenderer/browser/markdownRenderer.js":"34xfZ","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/opener/browser/link.js":"djTfw","../../../../platform/theme/common/iconRegistry.js":"bRNEz","../../../../base/common/themables.js":"hgyHi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"yrHhA":[function() {},{}],"djTfw":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Link", ()=>Link);
var _domJs = require("../../../base/browser/dom.js");
var _eventJs = require("../../../base/browser/event.js");
var _keyboardEventJs = require("../../../base/browser/keyboardEvent.js");
var _touchJs = require("../../../base/browser/touch.js");
var _eventJs1 = require("../../../base/common/event.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _openerJs = require("../common/opener.js");
var _linkCss = require("./link.css");
var _hoverDelegateFactoryJs = require("../../../base/browser/ui/hover/hoverDelegateFactory.js");
var _hoverJs = require("../../hover/browser/hover.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let Link = class Link extends (0, _lifecycleJs.Disposable) {
    get enabled() {
        return this._enabled;
    }
    set enabled(enabled) {
        if (enabled) {
            this.el.setAttribute("aria-disabled", "false");
            this.el.tabIndex = 0;
            this.el.style.pointerEvents = "auto";
            this.el.style.opacity = "1";
            this.el.style.cursor = "pointer";
            this._enabled = false;
        } else {
            this.el.setAttribute("aria-disabled", "true");
            this.el.tabIndex = -1;
            this.el.style.pointerEvents = "none";
            this.el.style.opacity = "0.4";
            this.el.style.cursor = "default";
            this._enabled = true;
        }
        this._enabled = enabled;
    }
    constructor(container, _link, options = {}, _hoverService, openerService){
        super();
        this._link = _link;
        this._hoverService = _hoverService;
        this._enabled = true;
        this.el = (0, _domJs.append)(container, (0, _domJs.$)("a.monaco-link", {
            tabIndex: _link.tabIndex ?? 0,
            href: _link.href
        }, _link.label));
        this.hoverDelegate = options.hoverDelegate ?? (0, _hoverDelegateFactoryJs.getDefaultHoverDelegate)("mouse");
        this.setTooltip(_link.title);
        this.el.setAttribute("role", "button");
        const onClickEmitter = this._register(new (0, _eventJs.DomEmitter)(this.el, "click"));
        const onKeyPress = this._register(new (0, _eventJs.DomEmitter)(this.el, "keypress"));
        const onEnterPress = (0, _eventJs1.Event).chain(onKeyPress.event, ($)=>$.map((e)=>new (0, _keyboardEventJs.StandardKeyboardEvent)(e)).filter((e)=>e.keyCode === 3 /* KeyCode.Enter */ ));
        const onTap = this._register(new (0, _eventJs.DomEmitter)(this.el, (0, _touchJs.EventType).Tap)).event;
        this._register((0, _touchJs.Gesture).addTarget(this.el));
        const onOpen = (0, _eventJs1.Event).any(onClickEmitter.event, onEnterPress, onTap);
        this._register(onOpen((e)=>{
            if (!this.enabled) return;
            (0, _domJs.EventHelper).stop(e, true);
            if (options?.opener) options.opener(this._link.href);
            else openerService.open(this._link.href, {
                allowCommands: true
            });
        }));
        this.enabled = true;
    }
    setTooltip(title) {
        if (this.hoverDelegate.showNativeHover) this.el.title = title ?? "";
        else if (!this.hover && title) this.hover = this._register(this._hoverService.setupManagedHover(this.hoverDelegate, this.el, title));
        else if (this.hover) this.hover.update(title);
    }
};
Link = __decorate([
    __param(3, (0, _hoverJs.IHoverService)),
    __param(4, (0, _openerJs.IOpenerService))
], Link);

},{"../../../base/browser/dom.js":"bnqsM","../../../base/browser/event.js":"PHN3G","../../../base/browser/keyboardEvent.js":"bxU9U","../../../base/browser/touch.js":"6iGQn","../../../base/common/event.js":"4Zi8b","../../../base/common/lifecycle.js":"9kg8d","../common/opener.js":"d3tj1","./link.css":"cTDc3","../../../base/browser/ui/hover/hoverDelegateFactory.js":"kll4h","../../hover/browser/hover.js":"3QGXp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cTDc3":[function() {},{}],"4dLcZ":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnusualLineTerminatorsDetector", ()=>UnusualLineTerminatorsDetector);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _resourcesJs = require("../../../../base/common/resources.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _nlsJs = require("../../../../nls.js");
var _dialogsJs = require("../../../../platform/dialogs/common/dialogs.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
const ignoreUnusualLineTerminators = "ignoreUnusualLineTerminators";
function writeIgnoreState(codeEditorService, model, state) {
    codeEditorService.setModelProperty(model.uri, ignoreUnusualLineTerminators, state);
}
function readIgnoreState(codeEditorService, model) {
    return codeEditorService.getModelProperty(model.uri, ignoreUnusualLineTerminators);
}
let UnusualLineTerminatorsDetector = class UnusualLineTerminatorsDetector extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.unusualLineTerminatorsDetector";
    }
    constructor(_editor, _dialogService, _codeEditorService){
        super();
        this._editor = _editor;
        this._dialogService = _dialogService;
        this._codeEditorService = _codeEditorService;
        this._isPresentingDialog = false;
        this._config = this._editor.getOption(127 /* EditorOption.unusualLineTerminators */ );
        this._register(this._editor.onDidChangeConfiguration((e)=>{
            if (e.hasChanged(127 /* EditorOption.unusualLineTerminators */ )) {
                this._config = this._editor.getOption(127 /* EditorOption.unusualLineTerminators */ );
                this._checkForUnusualLineTerminators();
            }
        }));
        this._register(this._editor.onDidChangeModel(()=>{
            this._checkForUnusualLineTerminators();
        }));
        this._register(this._editor.onDidChangeModelContent((e)=>{
            if (e.isUndoing) // skip checking in case of undoing
            return;
            this._checkForUnusualLineTerminators();
        }));
        this._checkForUnusualLineTerminators();
    }
    async _checkForUnusualLineTerminators() {
        if (this._config === "off") return;
        if (!this._editor.hasModel()) return;
        const model = this._editor.getModel();
        if (!model.mightContainUnusualLineTerminators()) return;
        const ignoreState = readIgnoreState(this._codeEditorService, model);
        if (ignoreState === true) // this model should be ignored
        return;
        if (this._editor.getOption(92 /* EditorOption.readOnly */ )) // read only editor => sorry!
        return;
        if (this._config === "auto") {
            // just do it!
            model.removeUnusualLineTerminators(this._editor.getSelections());
            return;
        }
        if (this._isPresentingDialog) // we're currently showing the dialog, which is async.
        // avoid spamming the user
        return;
        let result;
        try {
            this._isPresentingDialog = true;
            result = await this._dialogService.confirm({
                title: _nlsJs.localize("unusualLineTerminators.title", "Unusual Line Terminators"),
                message: _nlsJs.localize("unusualLineTerminators.message", "Detected unusual line terminators"),
                detail: _nlsJs.localize("unusualLineTerminators.detail", "The file '{0}' contains one or more unusual line terminator characters, like Line Separator (LS) or Paragraph Separator (PS).\n\nIt is recommended to remove them from the file. This can be configured via `editor.unusualLineTerminators`.", (0, _resourcesJs.basename)(model.uri)),
                primaryButton: _nlsJs.localize({
                    key: "unusualLineTerminators.fix",
                    comment: [
                        "&& denotes a mnemonic"
                    ]
                }, "&&Remove Unusual Line Terminators"),
                cancelButton: _nlsJs.localize("unusualLineTerminators.ignore", "Ignore")
            });
        } finally{
            this._isPresentingDialog = false;
        }
        if (!result.confirmed) {
            // this model should be ignored
            writeIgnoreState(this._codeEditorService, model, true);
            return;
        }
        model.removeUnusualLineTerminators(this._editor.getSelections());
    }
};
UnusualLineTerminatorsDetector = __decorate([
    __param(1, (0, _dialogsJs.IDialogService)),
    __param(2, (0, _codeEditorServiceJs.ICodeEditorService))
], UnusualLineTerminatorsDetector);
(0, _editorExtensionsJs.registerEditorContribution)(UnusualLineTerminatorsDetector.ID, UnusualLineTerminatorsDetector, 1 /* EditorContributionInstantiation.AfterFirstRender */ );

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/resources.js":"700EV","../../../browser/editorExtensions.js":"kC3w6","../../../browser/services/codeEditorService.js":"bOWtl","../../../../nls.js":"l617d","../../../../platform/dialogs/common/dialogs.js":"3ZDTa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hb76w":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOccurrencesAtPosition", ()=>getOccurrencesAtPosition);
parcelHelpers.export(exports, "getOccurrencesAcrossMultipleModels", ()=>getOccurrencesAcrossMultipleModels);
parcelHelpers.export(exports, "WordHighlighterContribution", ()=>WordHighlighterContribution);
var _nlsJs = require("../../../../nls.js");
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _errorsJs = require("../../../../base/common/errors.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorBrowserJs = require("../../../browser/editorBrowser.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _modelJs = require("../../../common/model.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _highlightDecorationsJs = require("./highlightDecorations.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _networkJs = require("../../../../base/common/network.js");
var _mapJs = require("../../../../base/common/map.js");
var _languageSelectorJs = require("../../../common/languageSelector.js");
var _resourcesJs = require("../../../../base/common/resources.js");
var _textualHighlightProviderJs = require("./textualHighlightProvider.js");
var _editorFeaturesJs = require("../../../common/editorFeatures.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var WordHighlighter_1, WordHighlighterContribution_1;
const ctxHasWordHighlights = new (0, _contextkeyJs.RawContextKey)("hasWordHighlights", false);
function getOccurrencesAtPosition(registry, model, position, token) {
    const orderedByScore = registry.ordered(model);
    // in order of score ask the occurrences provider
    // until someone response with a good result
    // (good = non undefined and non null value)
    // (result of size == 0 is valid, no highlights is a valid/expected result -- not a signal to fall back to other providers)
    return (0, _asyncJs.first)(orderedByScore.map((provider)=>()=>{
            return Promise.resolve(provider.provideDocumentHighlights(model, position, token)).then(undefined, (0, _errorsJs.onUnexpectedExternalError));
        }), (result)=>result !== undefined && result !== null).then((result)=>{
        if (result) {
            const map = new (0, _mapJs.ResourceMap)();
            map.set(model.uri, result);
            return map;
        }
        return new (0, _mapJs.ResourceMap)();
    });
}
function getOccurrencesAcrossMultipleModels(registry, model, position, wordSeparators, token, otherModels) {
    const orderedByScore = registry.ordered(model);
    // in order of score ask the occurrences provider
    // until someone response with a good result
    // (good = non undefined and non null ResourceMap)
    // (result of size == 0 is valid, no highlights is a valid/expected result -- not a signal to fall back to other providers)
    return (0, _asyncJs.first)(orderedByScore.map((provider)=>()=>{
            const filteredModels = otherModels.filter((otherModel)=>{
                return (0, _modelJs.shouldSynchronizeModel)(otherModel);
            }).filter((otherModel)=>{
                return (0, _languageSelectorJs.score)(provider.selector, otherModel.uri, otherModel.getLanguageId(), true, undefined, undefined) > 0;
            });
            return Promise.resolve(provider.provideMultiDocumentHighlights(model, position, filteredModels, token)).then(undefined, (0, _errorsJs.onUnexpectedExternalError));
        }), (result)=>result !== undefined && result !== null);
}
class OccurenceAtPositionRequest {
    constructor(_model, _selection, _wordSeparators){
        this._model = _model;
        this._selection = _selection;
        this._wordSeparators = _wordSeparators;
        this._wordRange = this._getCurrentWordRange(_model, _selection);
        this._result = null;
    }
    get result() {
        if (!this._result) this._result = (0, _asyncJs.createCancelablePromise)((token)=>this._compute(this._model, this._selection, this._wordSeparators, token));
        return this._result;
    }
    _getCurrentWordRange(model, selection) {
        const word = model.getWordAtPosition(selection.getPosition());
        if (word) return new (0, _rangeJs.Range)(selection.startLineNumber, word.startColumn, selection.startLineNumber, word.endColumn);
        return null;
    }
    isValid(model, selection, decorations) {
        const lineNumber = selection.startLineNumber;
        const startColumn = selection.startColumn;
        const endColumn = selection.endColumn;
        const currentWordRange = this._getCurrentWordRange(model, selection);
        let requestIsValid = Boolean(this._wordRange && this._wordRange.equalsRange(currentWordRange));
        // Even if we are on a different word, if that word is in the decorations ranges, the request is still valid
        // (Same symbol)
        for(let i = 0, len = decorations.length; !requestIsValid && i < len; i++){
            const range = decorations.getRange(i);
            if (range && range.startLineNumber === lineNumber) {
                if (range.startColumn <= startColumn && range.endColumn >= endColumn) requestIsValid = true;
            }
        }
        return requestIsValid;
    }
    cancel() {
        this.result.cancel();
    }
}
class SemanticOccurenceAtPositionRequest extends OccurenceAtPositionRequest {
    constructor(model, selection, wordSeparators, providers){
        super(model, selection, wordSeparators);
        this._providers = providers;
    }
    _compute(model, selection, wordSeparators, token) {
        return getOccurrencesAtPosition(this._providers, model, selection.getPosition(), token).then((value)=>{
            if (!value) return new (0, _mapJs.ResourceMap)();
            return value;
        });
    }
}
class MultiModelOccurenceRequest extends OccurenceAtPositionRequest {
    constructor(model, selection, wordSeparators, providers, otherModels){
        super(model, selection, wordSeparators);
        this._providers = providers;
        this._otherModels = otherModels;
    }
    _compute(model, selection, wordSeparators, token) {
        return getOccurrencesAcrossMultipleModels(this._providers, model, selection.getPosition(), wordSeparators, token, this._otherModels).then((value)=>{
            if (!value) return new (0, _mapJs.ResourceMap)();
            return value;
        });
    }
}
function computeOccurencesAtPosition(registry, model, selection, word, wordSeparators) {
    return new SemanticOccurenceAtPositionRequest(model, selection, wordSeparators, registry);
}
function computeOccurencesMultiModel(registry, model, selection, word, wordSeparators, otherModels) {
    return new MultiModelOccurenceRequest(model, selection, wordSeparators, registry, otherModels);
}
(0, _editorExtensionsJs.registerModelAndPositionCommand)("_executeDocumentHighlights", async (accessor, model, position)=>{
    const languageFeaturesService = accessor.get((0, _languageFeaturesJs.ILanguageFeaturesService));
    const map = await getOccurrencesAtPosition(languageFeaturesService.documentHighlightProvider, model, position, (0, _cancellationJs.CancellationToken).None);
    return map?.get(model.uri);
});
let WordHighlighter = class WordHighlighter {
    static{
        WordHighlighter_1 = this;
    }
    static{
        this.storedDecorationIDs = new (0, _mapJs.ResourceMap)();
    }
    static{
        this.query = null;
    }
    constructor(editor, providers, multiProviders, contextKeyService, codeEditorService){
        this.toUnhook = new (0, _lifecycleJs.DisposableStore)();
        this.workerRequestTokenId = 0;
        this.workerRequestCompleted = false;
        this.workerRequestValue = new (0, _mapJs.ResourceMap)();
        this.lastCursorPositionChangeTime = 0;
        this.renderDecorationsTimer = -1;
        this.runDelayer = this.toUnhook.add(new (0, _asyncJs.Delayer)(50));
        this.editor = editor;
        this.providers = providers;
        this.multiDocumentProviders = multiProviders;
        this.codeEditorService = codeEditorService;
        this._hasWordHighlights = ctxHasWordHighlights.bindTo(contextKeyService);
        this._ignorePositionChangeEvent = false;
        this.occurrencesHighlight = this.editor.getOption(81 /* EditorOption.occurrencesHighlight */ );
        this.model = this.editor.getModel();
        this.toUnhook.add(editor.onDidChangeCursorPosition((e)=>{
            if (this._ignorePositionChangeEvent) // We are changing the position => ignore this event
            return;
            if (this.occurrencesHighlight === "off") // Early exit if nothing needs to be done!
            // Leave some form of early exit check here if you wish to continue being a cursor position change listener ;)
            return;
            this.runDelayer.trigger(()=>{
                this._onPositionChanged(e);
            });
        }));
        this.toUnhook.add(editor.onDidFocusEditorText((e)=>{
            if (this.occurrencesHighlight === "off") // Early exit if nothing needs to be done
            return;
            if (!this.workerRequest) this.runDelayer.trigger(()=>{
                this._run();
            });
        }));
        this.toUnhook.add(editor.onDidChangeModelContent((e)=>{
            if (!(0, _networkJs.matchesScheme)(this.model.uri, "output")) this._stopAll();
        }));
        this.toUnhook.add(editor.onDidChangeModel((e)=>{
            if (!e.newModelUrl && e.oldModelUrl) this._stopSingular();
            else if (WordHighlighter_1.query) this._run();
        }));
        this.toUnhook.add(editor.onDidChangeConfiguration((e)=>{
            const newValue = this.editor.getOption(81 /* EditorOption.occurrencesHighlight */ );
            if (this.occurrencesHighlight !== newValue) {
                this.occurrencesHighlight = newValue;
                switch(newValue){
                    case "off":
                        this._stopAll();
                        break;
                    case "singleFile":
                        this._stopAll(WordHighlighter_1.query?.modelInfo?.model);
                        break;
                    case "multiFile":
                        if (WordHighlighter_1.query) this._run(true);
                        break;
                    default:
                        console.warn("Unknown occurrencesHighlight setting value:", newValue);
                        break;
                }
            }
        }));
        this.decorations = this.editor.createDecorationsCollection();
        this.workerRequestTokenId = 0;
        this.workerRequest = null;
        this.workerRequestCompleted = false;
        this.lastCursorPositionChangeTime = 0;
        this.renderDecorationsTimer = -1;
        // if there is a query already, highlight off that query
        if (WordHighlighter_1.query) this._run();
    }
    hasDecorations() {
        return this.decorations.length > 0;
    }
    restore() {
        if (this.occurrencesHighlight === "off") return;
        this.runDelayer.cancel();
        this._run();
    }
    _getSortedHighlights() {
        return this.decorations.getRanges().sort((0, _rangeJs.Range).compareRangesUsingStarts);
    }
    moveNext() {
        const highlights = this._getSortedHighlights();
        const index = highlights.findIndex((range)=>range.containsPosition(this.editor.getPosition()));
        const newIndex = (index + 1) % highlights.length;
        const dest = highlights[newIndex];
        try {
            this._ignorePositionChangeEvent = true;
            this.editor.setPosition(dest.getStartPosition());
            this.editor.revealRangeInCenterIfOutsideViewport(dest);
            const word = this._getWord();
            if (word) {
                const lineContent = this.editor.getModel().getLineContent(dest.startLineNumber);
                (0, _ariaJs.alert)(`${lineContent}, ${newIndex + 1} of ${highlights.length} for '${word.word}'`);
            }
        } finally{
            this._ignorePositionChangeEvent = false;
        }
    }
    moveBack() {
        const highlights = this._getSortedHighlights();
        const index = highlights.findIndex((range)=>range.containsPosition(this.editor.getPosition()));
        const newIndex = (index - 1 + highlights.length) % highlights.length;
        const dest = highlights[newIndex];
        try {
            this._ignorePositionChangeEvent = true;
            this.editor.setPosition(dest.getStartPosition());
            this.editor.revealRangeInCenterIfOutsideViewport(dest);
            const word = this._getWord();
            if (word) {
                const lineContent = this.editor.getModel().getLineContent(dest.startLineNumber);
                (0, _ariaJs.alert)(`${lineContent}, ${newIndex + 1} of ${highlights.length} for '${word.word}'`);
            }
        } finally{
            this._ignorePositionChangeEvent = false;
        }
    }
    _removeSingleDecorations() {
        // return if no model
        if (!this.editor.hasModel()) return;
        const currentDecorationIDs = WordHighlighter_1.storedDecorationIDs.get(this.editor.getModel().uri);
        if (!currentDecorationIDs) return;
        this.editor.removeDecorations(currentDecorationIDs);
        WordHighlighter_1.storedDecorationIDs.delete(this.editor.getModel().uri);
        if (this.decorations.length > 0) {
            this.decorations.clear();
            this._hasWordHighlights.set(false);
        }
    }
    _removeAllDecorations(preservedModel) {
        const currentEditors = this.codeEditorService.listCodeEditors();
        const deleteURI = [];
        // iterate over editors and store models in currentModels
        for (const editor of currentEditors){
            if (!editor.hasModel() || (0, _resourcesJs.isEqual)(editor.getModel().uri, preservedModel?.uri)) continue;
            const currentDecorationIDs = WordHighlighter_1.storedDecorationIDs.get(editor.getModel().uri);
            if (!currentDecorationIDs) continue;
            editor.removeDecorations(currentDecorationIDs);
            deleteURI.push(editor.getModel().uri);
            const editorHighlighterContrib = WordHighlighterContribution.get(editor);
            if (!editorHighlighterContrib?.wordHighlighter) continue;
            if (editorHighlighterContrib.wordHighlighter.decorations.length > 0) {
                editorHighlighterContrib.wordHighlighter.decorations.clear();
                editorHighlighterContrib.wordHighlighter.workerRequest = null;
                editorHighlighterContrib.wordHighlighter._hasWordHighlights.set(false);
            }
        }
        for (const uri of deleteURI)WordHighlighter_1.storedDecorationIDs.delete(uri);
    }
    _stopSingular() {
        // Remove any existing decorations + a possible query, and re - run to update decorations
        this._removeSingleDecorations();
        if (this.editor.hasTextFocus()) {
            if (this.editor.getModel()?.uri.scheme !== (0, _networkJs.Schemas).vscodeNotebookCell && WordHighlighter_1.query?.modelInfo?.model.uri.scheme !== (0, _networkJs.Schemas).vscodeNotebookCell) {
                WordHighlighter_1.query = null;
                this._run(); // TODO: @Yoyokrazy -- investigate why we need a full rerun here. likely addressed a case/patch in the first iteration of this feature
            } else if (WordHighlighter_1.query?.modelInfo) WordHighlighter_1.query.modelInfo = null;
        }
        // Cancel any renderDecorationsTimer
        if (this.renderDecorationsTimer !== -1) {
            clearTimeout(this.renderDecorationsTimer);
            this.renderDecorationsTimer = -1;
        }
        // Cancel any worker request
        if (this.workerRequest !== null) {
            this.workerRequest.cancel();
            this.workerRequest = null;
        }
        // Invalidate any worker request callback
        if (!this.workerRequestCompleted) {
            this.workerRequestTokenId++;
            this.workerRequestCompleted = true;
        }
    }
    _stopAll(preservedModel) {
        // Remove any existing decorations
        // TODO: @Yoyokrazy -- this triggers as notebooks scroll, causing highlights to disappear momentarily.
        // maybe a nb type check?
        this._removeAllDecorations(preservedModel);
        // Cancel any renderDecorationsTimer
        if (this.renderDecorationsTimer !== -1) {
            clearTimeout(this.renderDecorationsTimer);
            this.renderDecorationsTimer = -1;
        }
        // Cancel any worker request
        if (this.workerRequest !== null) {
            this.workerRequest.cancel();
            this.workerRequest = null;
        }
        // Invalidate any worker request callback
        if (!this.workerRequestCompleted) {
            this.workerRequestTokenId++;
            this.workerRequestCompleted = true;
        }
    }
    _onPositionChanged(e) {
        // disabled
        if (this.occurrencesHighlight === "off") {
            this._stopAll();
            return;
        }
        // ignore typing & other
        // need to check if the model is a notebook cell, should not stop if nb
        if (e.reason !== 3 /* CursorChangeReason.Explicit */  && this.editor.getModel()?.uri.scheme !== (0, _networkJs.Schemas).vscodeNotebookCell) {
            this._stopAll();
            return;
        }
        this._run();
    }
    _getWord() {
        const editorSelection = this.editor.getSelection();
        const lineNumber = editorSelection.startLineNumber;
        const startColumn = editorSelection.startColumn;
        if (this.model.isDisposed()) return null;
        return this.model.getWordAtPosition({
            lineNumber: lineNumber,
            column: startColumn
        });
    }
    getOtherModelsToHighlight(model) {
        if (!model) return [];
        // notebook case
        const isNotebookEditor = model.uri.scheme === (0, _networkJs.Schemas).vscodeNotebookCell;
        if (isNotebookEditor) {
            const currentModels = [];
            const currentEditors = this.codeEditorService.listCodeEditors();
            for (const editor of currentEditors){
                const tempModel = editor.getModel();
                if (tempModel && tempModel !== model && tempModel.uri.scheme === (0, _networkJs.Schemas).vscodeNotebookCell) currentModels.push(tempModel);
            }
            return currentModels;
        }
        // inline case
        // ? current works when highlighting outside of an inline diff, highlighting in.
        // ? broken when highlighting within a diff editor. highlighting the main editor does not work
        // ? editor group service could be useful here
        const currentModels = [];
        const currentEditors = this.codeEditorService.listCodeEditors();
        for (const editor of currentEditors){
            if (!(0, _editorBrowserJs.isDiffEditor)(editor)) continue;
            const diffModel = editor.getModel();
            if (!diffModel) continue;
            if (model === diffModel.modified) //? currentModels.push(diffModel.original);
            currentModels.push(diffModel.modified);
        }
        if (currentModels.length) return currentModels;
        // multi-doc OFF
        if (this.occurrencesHighlight === "singleFile") return [];
        // multi-doc ON
        for (const editor of currentEditors){
            const tempModel = editor.getModel();
            const isValidModel = tempModel && tempModel !== model;
            if (isValidModel) currentModels.push(tempModel);
        }
        return currentModels;
    }
    _run(multiFileConfigChange) {
        let workerRequestIsValid;
        const hasTextFocus = this.editor.hasTextFocus();
        if (!hasTextFocus) {
            if (!WordHighlighter_1.query) {
                this._stopAll();
                return;
            }
        } else {
            const editorSelection = this.editor.getSelection();
            // ignore multiline selection
            if (!editorSelection || editorSelection.startLineNumber !== editorSelection.endLineNumber) {
                WordHighlighter_1.query = null;
                this._stopAll();
                return;
            }
            const startColumn = editorSelection.startColumn;
            const endColumn = editorSelection.endColumn;
            const word = this._getWord();
            // The selection must be inside a word or surround one word at most
            if (!word || word.startColumn > startColumn || word.endColumn < endColumn) {
                // no previous query, nothing to highlight
                WordHighlighter_1.query = null;
                this._stopAll();
                return;
            }
            // All the effort below is trying to achieve this:
            // - when cursor is moved to a word, trigger immediately a findOccurrences request
            // - 250ms later after the last cursor move event, render the occurrences
            // - no flickering!
            workerRequestIsValid = this.workerRequest && this.workerRequest.isValid(this.model, editorSelection, this.decorations);
            WordHighlighter_1.query = {
                modelInfo: {
                    model: this.model,
                    selection: editorSelection
                },
                word: word
            };
        }
        // There are 4 cases:
        // a) old workerRequest is valid & completed, renderDecorationsTimer fired
        // b) old workerRequest is valid & completed, renderDecorationsTimer not fired
        // c) old workerRequest is valid, but not completed
        // d) old workerRequest is not valid
        // For a) no action is needed
        // For c), member 'lastCursorPositionChangeTime' will be used when installing the timer so no action is needed
        this.lastCursorPositionChangeTime = new Date().getTime();
        if (workerRequestIsValid) {
            if (this.workerRequestCompleted && this.renderDecorationsTimer !== -1) {
                // case b)
                // Delay the firing of renderDecorationsTimer by an extra 250 ms
                clearTimeout(this.renderDecorationsTimer);
                this.renderDecorationsTimer = -1;
                this._beginRenderDecorations();
            }
        } else if ((0, _resourcesJs.isEqual)(this.editor.getModel().uri, WordHighlighter_1.query.modelInfo?.model.uri)) {
            // case d)
            // check if the new queried word is contained in the range of a stored decoration for this model
            if (!multiFileConfigChange) {
                const currentModelDecorationRanges = this.decorations.getRanges();
                for (const storedRange of currentModelDecorationRanges){
                    if (storedRange.containsPosition(this.editor.getPosition())) return;
                }
            }
            // stop all previous actions if new word is highlighted
            // if we trigger the run off a setting change -> multifile highlighting, we do not want to remove decorations from this model
            this._stopAll(multiFileConfigChange ? this.model : undefined);
            const myRequestId = ++this.workerRequestTokenId;
            this.workerRequestCompleted = false;
            const otherModelsToHighlight = this.getOtherModelsToHighlight(this.editor.getModel());
            // when reaching here, there are two possible states.
            // 		1) we have text focus, and a valid query was updated.
            // 		2) we do not have text focus, and a valid query is cached.
            // the query will ALWAYS have the correct data for the current highlight request, so it can always be passed to the workerRequest safely
            if (!WordHighlighter_1.query || !WordHighlighter_1.query.modelInfo || WordHighlighter_1.query.modelInfo.model.isDisposed()) return;
            this.workerRequest = this.computeWithModel(WordHighlighter_1.query.modelInfo.model, WordHighlighter_1.query.modelInfo.selection, WordHighlighter_1.query.word, otherModelsToHighlight);
            this.workerRequest?.result.then((data)=>{
                if (myRequestId === this.workerRequestTokenId) {
                    this.workerRequestCompleted = true;
                    this.workerRequestValue = data || [];
                    this._beginRenderDecorations();
                }
            }, (0, _errorsJs.onUnexpectedError));
        }
    }
    computeWithModel(model, selection, word, otherModels) {
        if (!otherModels.length) return computeOccurencesAtPosition(this.providers, model, selection, word, this.editor.getOption(132 /* EditorOption.wordSeparators */ ));
        else return computeOccurencesMultiModel(this.multiDocumentProviders, model, selection, word, this.editor.getOption(132 /* EditorOption.wordSeparators */ ), otherModels);
    }
    _beginRenderDecorations() {
        const currentTime = new Date().getTime();
        const minimumRenderTime = this.lastCursorPositionChangeTime + 250;
        if (currentTime >= minimumRenderTime) {
            // Synchronous
            this.renderDecorationsTimer = -1;
            this.renderDecorations();
        } else // Asynchronous
        this.renderDecorationsTimer = setTimeout(()=>{
            this.renderDecorations();
        }, minimumRenderTime - currentTime);
    }
    renderDecorations() {
        this.renderDecorationsTimer = -1;
        // create new loop, iterate over current editors using this.codeEditorService.listCodeEditors(),
        // if the URI of that codeEditor is in the map, then add the decorations to the decorations array
        // then set the decorations for the editor
        const currentEditors = this.codeEditorService.listCodeEditors();
        for (const editor of currentEditors){
            const editorHighlighterContrib = WordHighlighterContribution.get(editor);
            if (!editorHighlighterContrib) continue;
            const newDecorations = [];
            const uri = editor.getModel()?.uri;
            if (uri && this.workerRequestValue.has(uri)) {
                const oldDecorationIDs = WordHighlighter_1.storedDecorationIDs.get(uri);
                const newDocumentHighlights = this.workerRequestValue.get(uri);
                if (newDocumentHighlights) for (const highlight of newDocumentHighlights){
                    if (!highlight.range) continue;
                    newDecorations.push({
                        range: highlight.range,
                        options: (0, _highlightDecorationsJs.getHighlightDecorationOptions)(highlight.kind)
                    });
                }
                let newDecorationIDs = [];
                editor.changeDecorations((changeAccessor)=>{
                    newDecorationIDs = changeAccessor.deltaDecorations(oldDecorationIDs ?? [], newDecorations);
                });
                WordHighlighter_1.storedDecorationIDs = WordHighlighter_1.storedDecorationIDs.set(uri, newDecorationIDs);
                if (newDecorations.length > 0) {
                    editorHighlighterContrib.wordHighlighter?.decorations.set(newDecorations);
                    editorHighlighterContrib.wordHighlighter?._hasWordHighlights.set(true);
                }
            }
        }
    }
    dispose() {
        this._stopSingular();
        this.toUnhook.dispose();
    }
};
WordHighlighter = WordHighlighter_1 = __decorate([
    __param(4, (0, _codeEditorServiceJs.ICodeEditorService))
], WordHighlighter);
let WordHighlighterContribution = class WordHighlighterContribution extends (0, _lifecycleJs.Disposable) {
    static{
        WordHighlighterContribution_1 = this;
    }
    static{
        this.ID = "editor.contrib.wordHighlighter";
    }
    static get(editor) {
        return editor.getContribution(WordHighlighterContribution_1.ID);
    }
    constructor(editor, contextKeyService, languageFeaturesService, codeEditorService){
        super();
        this._wordHighlighter = null;
        const createWordHighlighterIfPossible = ()=>{
            if (editor.hasModel() && !editor.getModel().isTooLargeForTokenization()) this._wordHighlighter = new WordHighlighter(editor, languageFeaturesService.documentHighlightProvider, languageFeaturesService.multiDocumentHighlightProvider, contextKeyService, codeEditorService);
        };
        this._register(editor.onDidChangeModel((e)=>{
            if (this._wordHighlighter) {
                this._wordHighlighter.dispose();
                this._wordHighlighter = null;
            }
            createWordHighlighterIfPossible();
        }));
        createWordHighlighterIfPossible();
    }
    get wordHighlighter() {
        return this._wordHighlighter;
    }
    saveViewState() {
        if (this._wordHighlighter && this._wordHighlighter.hasDecorations()) return true;
        return false;
    }
    moveNext() {
        this._wordHighlighter?.moveNext();
    }
    moveBack() {
        this._wordHighlighter?.moveBack();
    }
    restoreViewState(state) {
        if (this._wordHighlighter && state) this._wordHighlighter.restore();
    }
    dispose() {
        if (this._wordHighlighter) {
            this._wordHighlighter.dispose();
            this._wordHighlighter = null;
        }
        super.dispose();
    }
};
WordHighlighterContribution = WordHighlighterContribution_1 = __decorate([
    __param(1, (0, _contextkeyJs.IContextKeyService)),
    __param(2, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(3, (0, _codeEditorServiceJs.ICodeEditorService))
], WordHighlighterContribution);
class WordHighlightNavigationAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(next, opts){
        super(opts);
        this._isNext = next;
    }
    run(accessor, editor) {
        const controller = WordHighlighterContribution.get(editor);
        if (!controller) return;
        if (this._isNext) controller.moveNext();
        else controller.moveBack();
    }
}
class NextWordHighlightAction extends WordHighlightNavigationAction {
    constructor(){
        super(true, {
            id: "editor.action.wordHighlight.next",
            label: _nlsJs.localize("wordHighlight.next.label", "Go to Next Symbol Highlight"),
            alias: "Go to Next Symbol Highlight",
            precondition: ctxHasWordHighlights,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 65 /* KeyCode.F7 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
class PrevWordHighlightAction extends WordHighlightNavigationAction {
    constructor(){
        super(false, {
            id: "editor.action.wordHighlight.prev",
            label: _nlsJs.localize("wordHighlight.previous.label", "Go to Previous Symbol Highlight"),
            alias: "Go to Previous Symbol Highlight",
            precondition: ctxHasWordHighlights,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 1089 /* KeyCode.F7 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
class TriggerWordHighlightAction extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.wordHighlight.trigger",
            label: _nlsJs.localize("wordHighlight.trigger.label", "Trigger Symbol Highlight"),
            alias: "Trigger Symbol Highlight",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).editorTextFocus,
                primary: 0,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(accessor, editor, args) {
        const controller = WordHighlighterContribution.get(editor);
        if (!controller) return;
        controller.restoreViewState(true);
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(WordHighlighterContribution.ID, WordHighlighterContribution, 0 /* EditorContributionInstantiation.Eager */ ); // eager because it uses `saveViewState`/`restoreViewState`
(0, _editorExtensionsJs.registerEditorAction)(NextWordHighlightAction);
(0, _editorExtensionsJs.registerEditorAction)(PrevWordHighlightAction);
(0, _editorExtensionsJs.registerEditorAction)(TriggerWordHighlightAction);
(0, _editorFeaturesJs.registerEditorFeature)((0, _textualHighlightProviderJs.TextualMultiDocumentHighlightFeature));

},{"../../../../nls.js":"l617d","../../../../base/browser/ui/aria/aria.js":"asrsh","../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/errors.js":"divX8","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorBrowser.js":"82sBe","../../../browser/editorExtensions.js":"kC3w6","../../../browser/services/codeEditorService.js":"bOWtl","../../../common/core/range.js":"jmUPh","../../../common/editorContextKeys.js":"5exv9","../../../common/model.js":"1CSIB","../../../common/services/languageFeatures.js":"2IAko","./highlightDecorations.js":"gdzcC","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../base/common/network.js":"2c1AD","../../../../base/common/map.js":"leSjz","../../../common/languageSelector.js":"hho5L","../../../../base/common/resources.js":"700EV","./textualHighlightProvider.js":"h9afz","../../../common/editorFeatures.js":"8AkS3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h9afz":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextualMultiDocumentHighlightFeature", ()=>TextualMultiDocumentHighlightFeature);
var _wordHelperJs = require("../../../common/core/wordHelper.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _languagesJs = require("../../../common/languages.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _mapJs = require("../../../../base/common/map.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
class TextualDocumentHighlightProvider {
    constructor(){
        this.selector = {
            language: "*"
        };
    }
    provideDocumentHighlights(model, position, token) {
        const result = [];
        const word = model.getWordAtPosition({
            lineNumber: position.lineNumber,
            column: position.column
        });
        if (!word) return Promise.resolve(result);
        if (model.isDisposed()) return;
        const matches = model.findMatches(word.word, true, false, true, (0, _wordHelperJs.USUAL_WORD_SEPARATORS), false);
        return matches.map((m)=>({
                range: m.range,
                kind: (0, _languagesJs.DocumentHighlightKind).Text
            }));
    }
    provideMultiDocumentHighlights(primaryModel, position, otherModels, token) {
        const result = new (0, _mapJs.ResourceMap)();
        const word = primaryModel.getWordAtPosition({
            lineNumber: position.lineNumber,
            column: position.column
        });
        if (!word) return Promise.resolve(result);
        for (const model of [
            primaryModel,
            ...otherModels
        ]){
            if (model.isDisposed()) continue;
            const matches = model.findMatches(word.word, true, false, true, (0, _wordHelperJs.USUAL_WORD_SEPARATORS), false);
            const highlights = matches.map((m)=>({
                    range: m.range,
                    kind: (0, _languagesJs.DocumentHighlightKind).Text
                }));
            if (highlights) result.set(model.uri, highlights);
        }
        return result;
    }
}
let TextualMultiDocumentHighlightFeature = class TextualMultiDocumentHighlightFeature extends (0, _lifecycleJs.Disposable) {
    constructor(languageFeaturesService){
        super();
        this._register(languageFeaturesService.documentHighlightProvider.register("*", new TextualDocumentHighlightProvider()));
        this._register(languageFeaturesService.multiDocumentHighlightProvider.register("*", new TextualDocumentHighlightProvider()));
    }
};
TextualMultiDocumentHighlightFeature = __decorate([
    __param(0, (0, _languageFeaturesJs.ILanguageFeaturesService))
], TextualMultiDocumentHighlightFeature);

},{"../../../common/core/wordHelper.js":"9FjxX","../../../common/services/languageFeatures.js":"2IAko","../../../common/languages.js":"g5n96","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/map.js":"leSjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kEDSr":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MoveWordCommand", ()=>MoveWordCommand);
parcelHelpers.export(exports, "WordLeftCommand", ()=>WordLeftCommand);
parcelHelpers.export(exports, "WordRightCommand", ()=>WordRightCommand);
parcelHelpers.export(exports, "CursorWordStartLeft", ()=>CursorWordStartLeft);
parcelHelpers.export(exports, "CursorWordEndLeft", ()=>CursorWordEndLeft);
parcelHelpers.export(exports, "CursorWordLeft", ()=>CursorWordLeft);
parcelHelpers.export(exports, "CursorWordStartLeftSelect", ()=>CursorWordStartLeftSelect);
parcelHelpers.export(exports, "CursorWordEndLeftSelect", ()=>CursorWordEndLeftSelect);
parcelHelpers.export(exports, "CursorWordLeftSelect", ()=>CursorWordLeftSelect);
// Accessibility navigation commands should only be enabled on windows since they are tuned to what NVDA expects
parcelHelpers.export(exports, "CursorWordAccessibilityLeft", ()=>CursorWordAccessibilityLeft);
parcelHelpers.export(exports, "CursorWordAccessibilityLeftSelect", ()=>CursorWordAccessibilityLeftSelect);
parcelHelpers.export(exports, "CursorWordStartRight", ()=>CursorWordStartRight);
parcelHelpers.export(exports, "CursorWordEndRight", ()=>CursorWordEndRight);
parcelHelpers.export(exports, "CursorWordRight", ()=>CursorWordRight);
parcelHelpers.export(exports, "CursorWordStartRightSelect", ()=>CursorWordStartRightSelect);
parcelHelpers.export(exports, "CursorWordEndRightSelect", ()=>CursorWordEndRightSelect);
parcelHelpers.export(exports, "CursorWordRightSelect", ()=>CursorWordRightSelect);
parcelHelpers.export(exports, "CursorWordAccessibilityRight", ()=>CursorWordAccessibilityRight);
parcelHelpers.export(exports, "CursorWordAccessibilityRightSelect", ()=>CursorWordAccessibilityRightSelect);
parcelHelpers.export(exports, "DeleteWordCommand", ()=>DeleteWordCommand);
parcelHelpers.export(exports, "DeleteWordLeftCommand", ()=>DeleteWordLeftCommand);
parcelHelpers.export(exports, "DeleteWordRightCommand", ()=>DeleteWordRightCommand);
parcelHelpers.export(exports, "DeleteWordStartLeft", ()=>DeleteWordStartLeft);
parcelHelpers.export(exports, "DeleteWordEndLeft", ()=>DeleteWordEndLeft);
parcelHelpers.export(exports, "DeleteWordLeft", ()=>DeleteWordLeft);
parcelHelpers.export(exports, "DeleteWordStartRight", ()=>DeleteWordStartRight);
parcelHelpers.export(exports, "DeleteWordEndRight", ()=>DeleteWordEndRight);
parcelHelpers.export(exports, "DeleteWordRight", ()=>DeleteWordRight);
parcelHelpers.export(exports, "DeleteInsideWord", ()=>DeleteInsideWord);
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _replaceCommandJs = require("../../../common/commands/replaceCommand.js");
var _editorOptionsJs = require("../../../common/config/editorOptions.js");
var _cursorCommonJs = require("../../../common/cursorCommon.js");
var _cursorWordOperationsJs = require("../../../common/cursor/cursorWordOperations.js");
var _wordCharacterClassifierJs = require("../../../common/core/wordCharacterClassifier.js");
var _positionJs = require("../../../common/core/position.js");
var _rangeJs = require("../../../common/core/range.js");
var _selectionJs = require("../../../common/core/selection.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _languageConfigurationRegistryJs = require("../../../common/languages/languageConfigurationRegistry.js");
var _nlsJs = require("../../../../nls.js");
var _accessibilityJs = require("../../../../platform/accessibility/common/accessibility.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _contextkeysJs = require("../../../../platform/contextkey/common/contextkeys.js");
class MoveWordCommand extends (0, _editorExtensionsJs.EditorCommand) {
    constructor(opts){
        super(opts);
        this._inSelectionMode = opts.inSelectionMode;
        this._wordNavigationType = opts.wordNavigationType;
    }
    runEditorCommand(accessor, editor, args) {
        if (!editor.hasModel()) return;
        const wordSeparators = (0, _wordCharacterClassifierJs.getMapForWordSeparators)(editor.getOption(132 /* EditorOption.wordSeparators */ ), editor.getOption(131 /* EditorOption.wordSegmenterLocales */ ));
        const model = editor.getModel();
        const selections = editor.getSelections();
        const hasMulticursor = selections.length > 1;
        const result = selections.map((sel)=>{
            const inPosition = new (0, _positionJs.Position)(sel.positionLineNumber, sel.positionColumn);
            const outPosition = this._move(wordSeparators, model, inPosition, this._wordNavigationType, hasMulticursor);
            return this._moveTo(sel, outPosition, this._inSelectionMode);
        });
        model.pushStackElement();
        editor._getViewModel().setCursorStates("moveWordCommand", 3 /* CursorChangeReason.Explicit */ , result.map((r)=>(0, _cursorCommonJs.CursorState).fromModelSelection(r)));
        if (result.length === 1) {
            const pos = new (0, _positionJs.Position)(result[0].positionLineNumber, result[0].positionColumn);
            editor.revealPosition(pos, 0 /* ScrollType.Smooth */ );
        }
    }
    _moveTo(from, to, inSelectionMode) {
        if (inSelectionMode) // move just position
        return new (0, _selectionJs.Selection)(from.selectionStartLineNumber, from.selectionStartColumn, to.lineNumber, to.column);
        else // move everything
        return new (0, _selectionJs.Selection)(to.lineNumber, to.column, to.lineNumber, to.column);
    }
}
class WordLeftCommand extends MoveWordCommand {
    _move(wordSeparators, model, position, wordNavigationType, hasMulticursor) {
        return (0, _cursorWordOperationsJs.WordOperations).moveWordLeft(wordSeparators, model, position, wordNavigationType, hasMulticursor);
    }
}
class WordRightCommand extends MoveWordCommand {
    _move(wordSeparators, model, position, wordNavigationType, hasMulticursor) {
        return (0, _cursorWordOperationsJs.WordOperations).moveWordRight(wordSeparators, model, position, wordNavigationType);
    }
}
class CursorWordStartLeft extends WordLeftCommand {
    constructor(){
        super({
            inSelectionMode: false,
            wordNavigationType: 0 /* WordNavigationType.WordStart */ ,
            id: "cursorWordStartLeft",
            precondition: undefined
        });
    }
}
class CursorWordEndLeft extends WordLeftCommand {
    constructor(){
        super({
            inSelectionMode: false,
            wordNavigationType: 2 /* WordNavigationType.WordEnd */ ,
            id: "cursorWordEndLeft",
            precondition: undefined
        });
    }
}
class CursorWordLeft extends WordLeftCommand {
    constructor(){
        super({
            inSelectionMode: false,
            wordNavigationType: 1 /* WordNavigationType.WordStartFast */ ,
            id: "cursorWordLeft",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).textInputFocus, (0, _contextkeyJs.ContextKeyExpr).and((0, _accessibilityJs.CONTEXT_ACCESSIBILITY_MODE_ENABLED), (0, _contextkeysJs.IsWindowsContext))?.negate()),
                primary: 2063 /* KeyCode.LeftArrow */ ,
                mac: {
                    primary: 527 /* KeyCode.LeftArrow */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
class CursorWordStartLeftSelect extends WordLeftCommand {
    constructor(){
        super({
            inSelectionMode: true,
            wordNavigationType: 0 /* WordNavigationType.WordStart */ ,
            id: "cursorWordStartLeftSelect",
            precondition: undefined
        });
    }
}
class CursorWordEndLeftSelect extends WordLeftCommand {
    constructor(){
        super({
            inSelectionMode: true,
            wordNavigationType: 2 /* WordNavigationType.WordEnd */ ,
            id: "cursorWordEndLeftSelect",
            precondition: undefined
        });
    }
}
class CursorWordLeftSelect extends WordLeftCommand {
    constructor(){
        super({
            inSelectionMode: true,
            wordNavigationType: 1 /* WordNavigationType.WordStartFast */ ,
            id: "cursorWordLeftSelect",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).textInputFocus, (0, _contextkeyJs.ContextKeyExpr).and((0, _accessibilityJs.CONTEXT_ACCESSIBILITY_MODE_ENABLED), (0, _contextkeysJs.IsWindowsContext))?.negate()),
                primary: 3087 /* KeyCode.LeftArrow */ ,
                mac: {
                    primary: 1551 /* KeyCode.LeftArrow */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
class CursorWordAccessibilityLeft extends WordLeftCommand {
    constructor(){
        super({
            inSelectionMode: false,
            wordNavigationType: 3 /* WordNavigationType.WordAccessibility */ ,
            id: "cursorWordAccessibilityLeft",
            precondition: undefined
        });
    }
    _move(wordCharacterClassifier, model, position, wordNavigationType, hasMulticursor) {
        return super._move((0, _wordCharacterClassifierJs.getMapForWordSeparators)((0, _editorOptionsJs.EditorOptions).wordSeparators.defaultValue, wordCharacterClassifier.intlSegmenterLocales), model, position, wordNavigationType, hasMulticursor);
    }
}
class CursorWordAccessibilityLeftSelect extends WordLeftCommand {
    constructor(){
        super({
            inSelectionMode: true,
            wordNavigationType: 3 /* WordNavigationType.WordAccessibility */ ,
            id: "cursorWordAccessibilityLeftSelect",
            precondition: undefined
        });
    }
    _move(wordCharacterClassifier, model, position, wordNavigationType, hasMulticursor) {
        return super._move((0, _wordCharacterClassifierJs.getMapForWordSeparators)((0, _editorOptionsJs.EditorOptions).wordSeparators.defaultValue, wordCharacterClassifier.intlSegmenterLocales), model, position, wordNavigationType, hasMulticursor);
    }
}
class CursorWordStartRight extends WordRightCommand {
    constructor(){
        super({
            inSelectionMode: false,
            wordNavigationType: 0 /* WordNavigationType.WordStart */ ,
            id: "cursorWordStartRight",
            precondition: undefined
        });
    }
}
class CursorWordEndRight extends WordRightCommand {
    constructor(){
        super({
            inSelectionMode: false,
            wordNavigationType: 2 /* WordNavigationType.WordEnd */ ,
            id: "cursorWordEndRight",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).textInputFocus, (0, _contextkeyJs.ContextKeyExpr).and((0, _accessibilityJs.CONTEXT_ACCESSIBILITY_MODE_ENABLED), (0, _contextkeysJs.IsWindowsContext))?.negate()),
                primary: 2065 /* KeyCode.RightArrow */ ,
                mac: {
                    primary: 529 /* KeyCode.RightArrow */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
class CursorWordRight extends WordRightCommand {
    constructor(){
        super({
            inSelectionMode: false,
            wordNavigationType: 2 /* WordNavigationType.WordEnd */ ,
            id: "cursorWordRight",
            precondition: undefined
        });
    }
}
class CursorWordStartRightSelect extends WordRightCommand {
    constructor(){
        super({
            inSelectionMode: true,
            wordNavigationType: 0 /* WordNavigationType.WordStart */ ,
            id: "cursorWordStartRightSelect",
            precondition: undefined
        });
    }
}
class CursorWordEndRightSelect extends WordRightCommand {
    constructor(){
        super({
            inSelectionMode: true,
            wordNavigationType: 2 /* WordNavigationType.WordEnd */ ,
            id: "cursorWordEndRightSelect",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _contextkeyJs.ContextKeyExpr).and((0, _editorContextKeysJs.EditorContextKeys).textInputFocus, (0, _contextkeyJs.ContextKeyExpr).and((0, _accessibilityJs.CONTEXT_ACCESSIBILITY_MODE_ENABLED), (0, _contextkeysJs.IsWindowsContext))?.negate()),
                primary: 3089 /* KeyCode.RightArrow */ ,
                mac: {
                    primary: 1553 /* KeyCode.RightArrow */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
class CursorWordRightSelect extends WordRightCommand {
    constructor(){
        super({
            inSelectionMode: true,
            wordNavigationType: 2 /* WordNavigationType.WordEnd */ ,
            id: "cursorWordRightSelect",
            precondition: undefined
        });
    }
}
class CursorWordAccessibilityRight extends WordRightCommand {
    constructor(){
        super({
            inSelectionMode: false,
            wordNavigationType: 3 /* WordNavigationType.WordAccessibility */ ,
            id: "cursorWordAccessibilityRight",
            precondition: undefined
        });
    }
    _move(wordCharacterClassifier, model, position, wordNavigationType, hasMulticursor) {
        return super._move((0, _wordCharacterClassifierJs.getMapForWordSeparators)((0, _editorOptionsJs.EditorOptions).wordSeparators.defaultValue, wordCharacterClassifier.intlSegmenterLocales), model, position, wordNavigationType, hasMulticursor);
    }
}
class CursorWordAccessibilityRightSelect extends WordRightCommand {
    constructor(){
        super({
            inSelectionMode: true,
            wordNavigationType: 3 /* WordNavigationType.WordAccessibility */ ,
            id: "cursorWordAccessibilityRightSelect",
            precondition: undefined
        });
    }
    _move(wordCharacterClassifier, model, position, wordNavigationType, hasMulticursor) {
        return super._move((0, _wordCharacterClassifierJs.getMapForWordSeparators)((0, _editorOptionsJs.EditorOptions).wordSeparators.defaultValue, wordCharacterClassifier.intlSegmenterLocales), model, position, wordNavigationType, hasMulticursor);
    }
}
class DeleteWordCommand extends (0, _editorExtensionsJs.EditorCommand) {
    constructor(opts){
        super(opts);
        this._whitespaceHeuristics = opts.whitespaceHeuristics;
        this._wordNavigationType = opts.wordNavigationType;
    }
    runEditorCommand(accessor, editor, args) {
        const languageConfigurationService = accessor.get((0, _languageConfigurationRegistryJs.ILanguageConfigurationService));
        if (!editor.hasModel()) return;
        const wordSeparators = (0, _wordCharacterClassifierJs.getMapForWordSeparators)(editor.getOption(132 /* EditorOption.wordSeparators */ ), editor.getOption(131 /* EditorOption.wordSegmenterLocales */ ));
        const model = editor.getModel();
        const selections = editor.getSelections();
        const autoClosingBrackets = editor.getOption(6 /* EditorOption.autoClosingBrackets */ );
        const autoClosingQuotes = editor.getOption(11 /* EditorOption.autoClosingQuotes */ );
        const autoClosingPairs = languageConfigurationService.getLanguageConfiguration(model.getLanguageId()).getAutoClosingPairs();
        const viewModel = editor._getViewModel();
        const commands = selections.map((sel)=>{
            const deleteRange = this._delete({
                wordSeparators,
                model,
                selection: sel,
                whitespaceHeuristics: this._whitespaceHeuristics,
                autoClosingDelete: editor.getOption(9 /* EditorOption.autoClosingDelete */ ),
                autoClosingBrackets,
                autoClosingQuotes,
                autoClosingPairs,
                autoClosedCharacters: viewModel.getCursorAutoClosedCharacters()
            }, this._wordNavigationType);
            return new (0, _replaceCommandJs.ReplaceCommand)(deleteRange, "");
        });
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    }
}
class DeleteWordLeftCommand extends DeleteWordCommand {
    _delete(ctx, wordNavigationType) {
        const r = (0, _cursorWordOperationsJs.WordOperations).deleteWordLeft(ctx, wordNavigationType);
        if (r) return r;
        return new (0, _rangeJs.Range)(1, 1, 1, 1);
    }
}
class DeleteWordRightCommand extends DeleteWordCommand {
    _delete(ctx, wordNavigationType) {
        const r = (0, _cursorWordOperationsJs.WordOperations).deleteWordRight(ctx, wordNavigationType);
        if (r) return r;
        const lineCount = ctx.model.getLineCount();
        const maxColumn = ctx.model.getLineMaxColumn(lineCount);
        return new (0, _rangeJs.Range)(lineCount, maxColumn, lineCount, maxColumn);
    }
}
class DeleteWordStartLeft extends DeleteWordLeftCommand {
    constructor(){
        super({
            whitespaceHeuristics: false,
            wordNavigationType: 0 /* WordNavigationType.WordStart */ ,
            id: "deleteWordStartLeft",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
}
class DeleteWordEndLeft extends DeleteWordLeftCommand {
    constructor(){
        super({
            whitespaceHeuristics: false,
            wordNavigationType: 2 /* WordNavigationType.WordEnd */ ,
            id: "deleteWordEndLeft",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
}
class DeleteWordLeft extends DeleteWordLeftCommand {
    constructor(){
        super({
            whitespaceHeuristics: true,
            wordNavigationType: 0 /* WordNavigationType.WordStart */ ,
            id: "deleteWordLeft",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 2049 /* KeyCode.Backspace */ ,
                mac: {
                    primary: 513 /* KeyCode.Backspace */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
class DeleteWordStartRight extends DeleteWordRightCommand {
    constructor(){
        super({
            whitespaceHeuristics: false,
            wordNavigationType: 0 /* WordNavigationType.WordStart */ ,
            id: "deleteWordStartRight",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
}
class DeleteWordEndRight extends DeleteWordRightCommand {
    constructor(){
        super({
            whitespaceHeuristics: false,
            wordNavigationType: 2 /* WordNavigationType.WordEnd */ ,
            id: "deleteWordEndRight",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable
        });
    }
}
class DeleteWordRight extends DeleteWordRightCommand {
    constructor(){
        super({
            whitespaceHeuristics: true,
            wordNavigationType: 2 /* WordNavigationType.WordEnd */ ,
            id: "deleteWordRight",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 2068 /* KeyCode.Delete */ ,
                mac: {
                    primary: 532 /* KeyCode.Delete */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
class DeleteInsideWord extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "deleteInsideWord",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            label: _nlsJs.localize("deleteInsideWord", "Delete Word"),
            alias: "Delete Word"
        });
    }
    run(accessor, editor, args) {
        if (!editor.hasModel()) return;
        const wordSeparators = (0, _wordCharacterClassifierJs.getMapForWordSeparators)(editor.getOption(132 /* EditorOption.wordSeparators */ ), editor.getOption(131 /* EditorOption.wordSegmenterLocales */ ));
        const model = editor.getModel();
        const selections = editor.getSelections();
        const commands = selections.map((sel)=>{
            const deleteRange = (0, _cursorWordOperationsJs.WordOperations).deleteInsideWord(wordSeparators, model, sel);
            return new (0, _replaceCommandJs.ReplaceCommand)(deleteRange, "");
        });
        editor.pushUndoStop();
        editor.executeCommands(this.id, commands);
        editor.pushUndoStop();
    }
}
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordStartLeft());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordEndLeft());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordLeft());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordStartLeftSelect());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordEndLeftSelect());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordLeftSelect());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordStartRight());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordEndRight());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordRight());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordStartRightSelect());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordEndRightSelect());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordRightSelect());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordAccessibilityLeft());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordAccessibilityLeftSelect());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordAccessibilityRight());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordAccessibilityRightSelect());
(0, _editorExtensionsJs.registerEditorCommand)(new DeleteWordStartLeft());
(0, _editorExtensionsJs.registerEditorCommand)(new DeleteWordEndLeft());
(0, _editorExtensionsJs.registerEditorCommand)(new DeleteWordLeft());
(0, _editorExtensionsJs.registerEditorCommand)(new DeleteWordStartRight());
(0, _editorExtensionsJs.registerEditorCommand)(new DeleteWordEndRight());
(0, _editorExtensionsJs.registerEditorCommand)(new DeleteWordRight());
(0, _editorExtensionsJs.registerEditorAction)(DeleteInsideWord);

},{"../../../browser/editorExtensions.js":"kC3w6","../../../common/commands/replaceCommand.js":"51hNH","../../../common/config/editorOptions.js":"3Xi00","../../../common/cursorCommon.js":"aKAuR","../../../common/cursor/cursorWordOperations.js":"jmZq4","../../../common/core/wordCharacterClassifier.js":"a4wPa","../../../common/core/position.js":"lvrPe","../../../common/core/range.js":"jmUPh","../../../common/core/selection.js":"kcwzU","../../../common/editorContextKeys.js":"5exv9","../../../common/languages/languageConfigurationRegistry.js":"2Lk9v","../../../../nls.js":"l617d","../../../../platform/accessibility/common/accessibility.js":"9Svqy","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/contextkey/common/contextkeys.js":"jqcbi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7NRbb":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeleteWordPartLeft", ()=>DeleteWordPartLeft);
parcelHelpers.export(exports, "DeleteWordPartRight", ()=>DeleteWordPartRight);
parcelHelpers.export(exports, "WordPartLeftCommand", ()=>WordPartLeftCommand);
parcelHelpers.export(exports, "CursorWordPartLeft", ()=>CursorWordPartLeft);
parcelHelpers.export(exports, "CursorWordPartLeftSelect", ()=>CursorWordPartLeftSelect);
parcelHelpers.export(exports, "WordPartRightCommand", ()=>WordPartRightCommand);
parcelHelpers.export(exports, "CursorWordPartRight", ()=>CursorWordPartRight);
parcelHelpers.export(exports, "CursorWordPartRightSelect", ()=>CursorWordPartRightSelect);
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _cursorWordOperationsJs = require("../../../common/cursor/cursorWordOperations.js");
var _rangeJs = require("../../../common/core/range.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _wordOperationsJs = require("../../wordOperations/browser/wordOperations.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
class DeleteWordPartLeft extends (0, _wordOperationsJs.DeleteWordCommand) {
    constructor(){
        super({
            whitespaceHeuristics: true,
            wordNavigationType: 0 /* WordNavigationType.WordStart */ ,
            id: "deleteWordPartLeft",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 0,
                mac: {
                    primary: 769 /* KeyCode.Backspace */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    _delete(ctx, wordNavigationType) {
        const r = (0, _cursorWordOperationsJs.WordPartOperations).deleteWordPartLeft(ctx);
        if (r) return r;
        return new (0, _rangeJs.Range)(1, 1, 1, 1);
    }
}
class DeleteWordPartRight extends (0, _wordOperationsJs.DeleteWordCommand) {
    constructor(){
        super({
            whitespaceHeuristics: true,
            wordNavigationType: 2 /* WordNavigationType.WordEnd */ ,
            id: "deleteWordPartRight",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).writable,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 0,
                mac: {
                    primary: 788 /* KeyCode.Delete */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    _delete(ctx, wordNavigationType) {
        const r = (0, _cursorWordOperationsJs.WordPartOperations).deleteWordPartRight(ctx);
        if (r) return r;
        const lineCount = ctx.model.getLineCount();
        const maxColumn = ctx.model.getLineMaxColumn(lineCount);
        return new (0, _rangeJs.Range)(lineCount, maxColumn, lineCount, maxColumn);
    }
}
class WordPartLeftCommand extends (0, _wordOperationsJs.MoveWordCommand) {
    _move(wordSeparators, model, position, wordNavigationType, hasMulticursor) {
        return (0, _cursorWordOperationsJs.WordPartOperations).moveWordPartLeft(wordSeparators, model, position, hasMulticursor);
    }
}
class CursorWordPartLeft extends WordPartLeftCommand {
    constructor(){
        super({
            inSelectionMode: false,
            wordNavigationType: 0 /* WordNavigationType.WordStart */ ,
            id: "cursorWordPartLeft",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 0,
                mac: {
                    primary: 783 /* KeyCode.LeftArrow */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
// Register previous id for compatibility purposes
(0, _commandsJs.CommandsRegistry).registerCommandAlias("cursorWordPartStartLeft", "cursorWordPartLeft");
class CursorWordPartLeftSelect extends WordPartLeftCommand {
    constructor(){
        super({
            inSelectionMode: true,
            wordNavigationType: 0 /* WordNavigationType.WordStart */ ,
            id: "cursorWordPartLeftSelect",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 0,
                mac: {
                    primary: 1807 /* KeyCode.LeftArrow */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
// Register previous id for compatibility purposes
(0, _commandsJs.CommandsRegistry).registerCommandAlias("cursorWordPartStartLeftSelect", "cursorWordPartLeftSelect");
class WordPartRightCommand extends (0, _wordOperationsJs.MoveWordCommand) {
    _move(wordSeparators, model, position, wordNavigationType, hasMulticursor) {
        return (0, _cursorWordOperationsJs.WordPartOperations).moveWordPartRight(wordSeparators, model, position);
    }
}
class CursorWordPartRight extends WordPartRightCommand {
    constructor(){
        super({
            inSelectionMode: false,
            wordNavigationType: 2 /* WordNavigationType.WordEnd */ ,
            id: "cursorWordPartRight",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 0,
                mac: {
                    primary: 785 /* KeyCode.RightArrow */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
class CursorWordPartRightSelect extends WordPartRightCommand {
    constructor(){
        super({
            inSelectionMode: true,
            wordNavigationType: 2 /* WordNavigationType.WordEnd */ ,
            id: "cursorWordPartRightSelect",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).textInputFocus,
                primary: 0,
                mac: {
                    primary: 1809 /* KeyCode.RightArrow */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
}
(0, _editorExtensionsJs.registerEditorCommand)(new DeleteWordPartLeft());
(0, _editorExtensionsJs.registerEditorCommand)(new DeleteWordPartRight());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordPartLeft());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordPartLeftSelect());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordPartRight());
(0, _editorExtensionsJs.registerEditorCommand)(new CursorWordPartRightSelect());

},{"../../../browser/editorExtensions.js":"kC3w6","../../../common/cursor/cursorWordOperations.js":"jmZq4","../../../common/core/range.js":"jmUPh","../../../common/editorContextKeys.js":"5exv9","../../wordOperations/browser/wordOperations.js":"kEDSr","../../../../platform/commands/common/commands.js":"ho6ic","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6qfo8":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReadOnlyMessageController", ()=>ReadOnlyMessageController);
var _htmlContentJs = require("../../../../base/common/htmlContent.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _messageControllerJs = require("../../message/browser/messageController.js");
var _nlsJs = require("../../../../nls.js");
class ReadOnlyMessageController extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.readOnlyMessageController";
    }
    constructor(editor){
        super();
        this.editor = editor;
        this._register(this.editor.onDidAttemptReadOnlyEdit(()=>this._onDidAttemptReadOnlyEdit()));
    }
    _onDidAttemptReadOnlyEdit() {
        const messageController = (0, _messageControllerJs.MessageController).get(this.editor);
        if (messageController && this.editor.hasModel()) {
            let message = this.editor.getOptions().get(93 /* EditorOption.readOnlyMessage */ );
            if (!message) {
                if (this.editor.isSimpleWidget) message = new (0, _htmlContentJs.MarkdownString)(_nlsJs.localize("editor.simple.readonly", "Cannot edit in read-only input"));
                else message = new (0, _htmlContentJs.MarkdownString)(_nlsJs.localize("editor.readonly", "Cannot edit in read-only editor"));
            }
            messageController.showMessage(message, this.editor.getPosition());
        }
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(ReadOnlyMessageController.ID, ReadOnlyMessageController, 2 /* EditorContributionInstantiation.BeforeFirstInteraction */ );

},{"../../../../base/common/htmlContent.js":"3Hxzm","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorExtensions.js":"kC3w6","../../message/browser/messageController.js":"7FZE5","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2dZwI":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _arraysJs = require("../../../../base/common/arrays.js");
var _observableJs = require("../../../../base/common/observable.js");
var _hideUnchangedRegionsFeatureJs = require("../../../browser/widget/diffEditor/features/hideUnchangedRegionsFeature.js");
var _utilsJs = require("../../../browser/widget/diffEditor/utils.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _outlineModelJs = require("../../documentSymbols/browser/outlineModel.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _eventJs = require("../../../../base/common/event.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let DiffEditorBreadcrumbsSource = class DiffEditorBreadcrumbsSource extends (0, _lifecycleJs.Disposable) {
    constructor(_textModel, _languageFeaturesService, _outlineModelService){
        super();
        this._textModel = _textModel;
        this._languageFeaturesService = _languageFeaturesService;
        this._outlineModelService = _outlineModelService;
        this._currentModel = (0, _observableJs.observableValue)(this, undefined);
        const documentSymbolProviderChanged = (0, _observableJs.observableSignalFromEvent)("documentSymbolProvider.onDidChange", this._languageFeaturesService.documentSymbolProvider.onDidChange);
        const textModelChanged = (0, _observableJs.observableSignalFromEvent)("_textModel.onDidChangeContent", (0, _eventJs.Event).debounce((e)=>this._textModel.onDidChangeContent(e), ()=>undefined, 100));
        this._register((0, _observableJs.autorunWithStore)(async (reader, store)=>{
            documentSymbolProviderChanged.read(reader);
            textModelChanged.read(reader);
            const src = store.add(new (0, _utilsJs.DisposableCancellationTokenSource)());
            const model = await this._outlineModelService.getOrCreate(this._textModel, src.token);
            if (store.isDisposed) return;
            this._currentModel.set(model, undefined);
        }));
    }
    getBreadcrumbItems(startRange, reader) {
        const m = this._currentModel.read(reader);
        if (!m) return [];
        const symbols = m.asListOfDocumentSymbols().filter((s)=>startRange.contains(s.range.startLineNumber) && !startRange.contains(s.range.endLineNumber));
        symbols.sort((0, _arraysJs.reverseOrder)((0, _arraysJs.compareBy)((s)=>s.range.endLineNumber - s.range.startLineNumber, (0, _arraysJs.numberComparator))));
        return symbols.map((s)=>({
                name: s.name,
                kind: s.kind,
                startLineNumber: s.range.startLineNumber
            }));
    }
};
DiffEditorBreadcrumbsSource = __decorate([
    __param(1, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(2, (0, _outlineModelJs.IOutlineModelService))
], DiffEditorBreadcrumbsSource);
(0, _hideUnchangedRegionsFeatureJs.HideUnchangedRegionsFeature).setBreadcrumbsSourceFactory((textModel, instantiationService)=>{
    return instantiationService.createInstance(DiffEditorBreadcrumbsSource, textModel);
});

},{"../../../../base/common/arrays.js":"DECei","../../../../base/common/observable.js":"2xbG5","../../../browser/widget/diffEditor/features/hideUnchangedRegionsFeature.js":"97RPC","../../../browser/widget/diffEditor/utils.js":"2G3Lp","../../../common/services/languageFeatures.js":"2IAko","../../documentSymbols/browser/outlineModel.js":"13q6i","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/event.js":"4Zi8b"}],"gmEes":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IPadShowKeyboard", ()=>IPadShowKeyboard);
var _iPadShowKeyboardCss = require("./iPadShowKeyboard.css");
var _domJs = require("../../../../base/browser/dom.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _platformJs = require("../../../../base/common/platform.js");
class IPadShowKeyboard extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.iPadShowKeyboard";
    }
    constructor(editor){
        super();
        this.editor = editor;
        this.widget = null;
        if (0, _platformJs.isIOS) {
            this._register(editor.onDidChangeConfiguration(()=>this.update()));
            this.update();
        }
    }
    update() {
        const shouldHaveWidget = !this.editor.getOption(92 /* EditorOption.readOnly */ );
        if (!this.widget && shouldHaveWidget) this.widget = new ShowKeyboardWidget(this.editor);
        else if (this.widget && !shouldHaveWidget) {
            this.widget.dispose();
            this.widget = null;
        }
    }
    dispose() {
        super.dispose();
        if (this.widget) {
            this.widget.dispose();
            this.widget = null;
        }
    }
}
class ShowKeyboardWidget extends (0, _lifecycleJs.Disposable) {
    static{
        this.ID = "editor.contrib.ShowKeyboardWidget";
    }
    constructor(editor){
        super();
        this.editor = editor;
        this._domNode = document.createElement("textarea");
        this._domNode.className = "iPadShowKeyboard";
        this._register(_domJs.addDisposableListener(this._domNode, "touchstart", (e)=>{
            this.editor.focus();
        }));
        this._register(_domJs.addDisposableListener(this._domNode, "focus", (e)=>{
            this.editor.focus();
        }));
        this.editor.addOverlayWidget(this);
    }
    dispose() {
        this.editor.removeOverlayWidget(this);
        super.dispose();
    }
    // ----- IOverlayWidget API
    getId() {
        return ShowKeyboardWidget.ID;
    }
    getDomNode() {
        return this._domNode;
    }
    getPosition() {
        return {
            preference: 1 /* OverlayWidgetPositionPreference.BOTTOM_RIGHT_CORNER */ 
        };
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(IPadShowKeyboard.ID, IPadShowKeyboard, 3 /* EditorContributionInstantiation.Eventually */ );

},{"./iPadShowKeyboard.css":"594De","../../../../base/browser/dom.js":"bnqsM","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorExtensions.js":"kC3w6","../../../../base/common/platform.js":"7maJO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"594De":[function() {},{}],"bXurD":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _inspectTokensCss = require("./inspectTokens.css");
var _domJs = require("../../../../base/browser/dom.js");
var _colorJs = require("../../../../base/common/color.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _languagesJs = require("../../../common/languages.js");
var _encodedTokenAttributesJs = require("../../../common/encodedTokenAttributes.js");
var _nullTokenizeJs = require("../../../common/languages/nullTokenize.js");
var _languageJs = require("../../../common/languages/language.js");
var _standaloneThemeJs = require("../../common/standaloneTheme.js");
var _standaloneStringsJs = require("../../../common/standaloneStrings.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var InspectTokensController_1;
let InspectTokensController = class InspectTokensController extends (0, _lifecycleJs.Disposable) {
    static{
        InspectTokensController_1 = this;
    }
    static{
        this.ID = "editor.contrib.inspectTokens";
    }
    static get(editor) {
        return editor.getContribution(InspectTokensController_1.ID);
    }
    constructor(editor, standaloneColorService, languageService){
        super();
        this._editor = editor;
        this._languageService = languageService;
        this._widget = null;
        this._register(this._editor.onDidChangeModel((e)=>this.stop()));
        this._register(this._editor.onDidChangeModelLanguage((e)=>this.stop()));
        this._register((0, _languagesJs.TokenizationRegistry).onDidChange((e)=>this.stop()));
        this._register(this._editor.onKeyUp((e)=>e.keyCode === 9 /* KeyCode.Escape */  && this.stop()));
    }
    dispose() {
        this.stop();
        super.dispose();
    }
    launch() {
        if (this._widget) return;
        if (!this._editor.hasModel()) return;
        this._widget = new InspectTokensWidget(this._editor, this._languageService);
    }
    stop() {
        if (this._widget) {
            this._widget.dispose();
            this._widget = null;
        }
    }
};
InspectTokensController = InspectTokensController_1 = __decorate([
    __param(1, (0, _standaloneThemeJs.IStandaloneThemeService)),
    __param(2, (0, _languageJs.ILanguageService))
], InspectTokensController);
class InspectTokens extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.inspectTokens",
            label: (0, _standaloneStringsJs.InspectTokensNLS).inspectTokensAction,
            alias: "Developer: Inspect Tokens",
            precondition: undefined
        });
    }
    run(accessor, editor) {
        const controller = InspectTokensController.get(editor);
        controller?.launch();
    }
}
function renderTokenText(tokenText) {
    let result = "";
    for(let charIndex = 0, len = tokenText.length; charIndex < len; charIndex++){
        const charCode = tokenText.charCodeAt(charIndex);
        switch(charCode){
            case 9 /* CharCode.Tab */ :
                result += "\u2192"; // &rarr;
                break;
            case 32 /* CharCode.Space */ :
                result += "\xb7"; // &middot;
                break;
            default:
                result += String.fromCharCode(charCode);
        }
    }
    return result;
}
function getSafeTokenizationSupport(languageIdCodec, languageId) {
    const tokenizationSupport = (0, _languagesJs.TokenizationRegistry).get(languageId);
    if (tokenizationSupport) return tokenizationSupport;
    const encodedLanguageId = languageIdCodec.encodeLanguageId(languageId);
    return {
        getInitialState: ()=>(0, _nullTokenizeJs.NullState),
        tokenize: (line, hasEOL, state)=>(0, _nullTokenizeJs.nullTokenize)(languageId, state),
        tokenizeEncoded: (line, hasEOL, state)=>(0, _nullTokenizeJs.nullTokenizeEncoded)(encodedLanguageId, state)
    };
}
class InspectTokensWidget extends (0, _lifecycleJs.Disposable) {
    static{
        this._ID = "editor.contrib.inspectTokensWidget";
    }
    constructor(editor, languageService){
        super();
        // Editor.IContentWidget.allowEditorOverflow
        this.allowEditorOverflow = true;
        this._editor = editor;
        this._languageService = languageService;
        this._model = this._editor.getModel();
        this._domNode = document.createElement("div");
        this._domNode.className = "tokens-inspect-widget";
        this._tokenizationSupport = getSafeTokenizationSupport(this._languageService.languageIdCodec, this._model.getLanguageId());
        this._compute(this._editor.getPosition());
        this._register(this._editor.onDidChangeCursorPosition((e)=>this._compute(this._editor.getPosition())));
        this._editor.addContentWidget(this);
    }
    dispose() {
        this._editor.removeContentWidget(this);
        super.dispose();
    }
    getId() {
        return InspectTokensWidget._ID;
    }
    _compute(position) {
        const data = this._getTokensAtLine(position.lineNumber);
        let token1Index = 0;
        for(let i = data.tokens1.length - 1; i >= 0; i--){
            const t = data.tokens1[i];
            if (position.column - 1 >= t.offset) {
                token1Index = i;
                break;
            }
        }
        let token2Index = 0;
        for(let i = data.tokens2.length >>> 1; i >= 0; i--)if (position.column - 1 >= data.tokens2[i << 1]) {
            token2Index = i;
            break;
        }
        const lineContent = this._model.getLineContent(position.lineNumber);
        let tokenText = "";
        if (token1Index < data.tokens1.length) {
            const tokenStartIndex = data.tokens1[token1Index].offset;
            const tokenEndIndex = token1Index + 1 < data.tokens1.length ? data.tokens1[token1Index + 1].offset : lineContent.length;
            tokenText = lineContent.substring(tokenStartIndex, tokenEndIndex);
        }
        (0, _domJs.reset)(this._domNode, (0, _domJs.$)("h2.tm-token", undefined, renderTokenText(tokenText), (0, _domJs.$)("span.tm-token-length", undefined, `${tokenText.length} ${tokenText.length === 1 ? "char" : "chars"}`)));
        (0, _domJs.append)(this._domNode, (0, _domJs.$)("hr.tokens-inspect-separator", {
            "style": "clear:both"
        }));
        const metadata = (token2Index << 1) + 1 < data.tokens2.length ? this._decodeMetadata(data.tokens2[(token2Index << 1) + 1]) : null;
        (0, _domJs.append)(this._domNode, (0, _domJs.$)("table.tm-metadata-table", undefined, (0, _domJs.$)("tbody", undefined, (0, _domJs.$)("tr", undefined, (0, _domJs.$)("td.tm-metadata-key", undefined, "language"), (0, _domJs.$)("td.tm-metadata-value", undefined, `${metadata ? metadata.languageId : "-?-"}`)), (0, _domJs.$)("tr", undefined, (0, _domJs.$)("td.tm-metadata-key", undefined, "token type"), (0, _domJs.$)("td.tm-metadata-value", undefined, `${metadata ? this._tokenTypeToString(metadata.tokenType) : "-?-"}`)), (0, _domJs.$)("tr", undefined, (0, _domJs.$)("td.tm-metadata-key", undefined, "font style"), (0, _domJs.$)("td.tm-metadata-value", undefined, `${metadata ? this._fontStyleToString(metadata.fontStyle) : "-?-"}`)), (0, _domJs.$)("tr", undefined, (0, _domJs.$)("td.tm-metadata-key", undefined, "foreground"), (0, _domJs.$)("td.tm-metadata-value", undefined, `${metadata ? (0, _colorJs.Color).Format.CSS.formatHex(metadata.foreground) : "-?-"}`)), (0, _domJs.$)("tr", undefined, (0, _domJs.$)("td.tm-metadata-key", undefined, "background"), (0, _domJs.$)("td.tm-metadata-value", undefined, `${metadata ? (0, _colorJs.Color).Format.CSS.formatHex(metadata.background) : "-?-"}`)))));
        (0, _domJs.append)(this._domNode, (0, _domJs.$)("hr.tokens-inspect-separator"));
        if (token1Index < data.tokens1.length) (0, _domJs.append)(this._domNode, (0, _domJs.$)("span.tm-token-type", undefined, data.tokens1[token1Index].type));
        this._editor.layoutContentWidget(this);
    }
    _decodeMetadata(metadata) {
        const colorMap = (0, _languagesJs.TokenizationRegistry).getColorMap();
        const languageId = (0, _encodedTokenAttributesJs.TokenMetadata).getLanguageId(metadata);
        const tokenType = (0, _encodedTokenAttributesJs.TokenMetadata).getTokenType(metadata);
        const fontStyle = (0, _encodedTokenAttributesJs.TokenMetadata).getFontStyle(metadata);
        const foreground = (0, _encodedTokenAttributesJs.TokenMetadata).getForeground(metadata);
        const background = (0, _encodedTokenAttributesJs.TokenMetadata).getBackground(metadata);
        return {
            languageId: this._languageService.languageIdCodec.decodeLanguageId(languageId),
            tokenType: tokenType,
            fontStyle: fontStyle,
            foreground: colorMap[foreground],
            background: colorMap[background]
        };
    }
    _tokenTypeToString(tokenType) {
        switch(tokenType){
            case 0 /* StandardTokenType.Other */ :
                return "Other";
            case 1 /* StandardTokenType.Comment */ :
                return "Comment";
            case 2 /* StandardTokenType.String */ :
                return "String";
            case 3 /* StandardTokenType.RegEx */ :
                return "RegEx";
            default:
                return "??";
        }
    }
    _fontStyleToString(fontStyle) {
        let r = "";
        if (fontStyle & 1 /* FontStyle.Italic */ ) r += "italic ";
        if (fontStyle & 2 /* FontStyle.Bold */ ) r += "bold ";
        if (fontStyle & 4 /* FontStyle.Underline */ ) r += "underline ";
        if (fontStyle & 8 /* FontStyle.Strikethrough */ ) r += "strikethrough ";
        if (r.length === 0) r = "---";
        return r;
    }
    _getTokensAtLine(lineNumber) {
        const stateBeforeLine = this._getStateBeforeLine(lineNumber);
        const tokenizationResult1 = this._tokenizationSupport.tokenize(this._model.getLineContent(lineNumber), true, stateBeforeLine);
        const tokenizationResult2 = this._tokenizationSupport.tokenizeEncoded(this._model.getLineContent(lineNumber), true, stateBeforeLine);
        return {
            startState: stateBeforeLine,
            tokens1: tokenizationResult1.tokens,
            tokens2: tokenizationResult2.tokens,
            endState: tokenizationResult1.endState
        };
    }
    _getStateBeforeLine(lineNumber) {
        let state = this._tokenizationSupport.getInitialState();
        for(let i = 1; i < lineNumber; i++){
            const tokenizationResult = this._tokenizationSupport.tokenize(this._model.getLineContent(i), true, state);
            state = tokenizationResult.endState;
        }
        return state;
    }
    getDomNode() {
        return this._domNode;
    }
    getPosition() {
        return {
            position: this._editor.getPosition(),
            preference: [
                2 /* ContentWidgetPositionPreference.BELOW */ ,
                1 /* ContentWidgetPositionPreference.ABOVE */ 
            ]
        };
    }
}
(0, _editorExtensionsJs.registerEditorContribution)(InspectTokensController.ID, InspectTokensController, 4 /* EditorContributionInstantiation.Lazy */ );
(0, _editorExtensionsJs.registerEditorAction)(InspectTokens);

},{"./inspectTokens.css":"3puMh","../../../../base/browser/dom.js":"bnqsM","../../../../base/common/color.js":"at4gb","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorExtensions.js":"kC3w6","../../../common/languages.js":"g5n96","../../../common/encodedTokenAttributes.js":"eH8EQ","../../../common/languages/nullTokenize.js":"ekzGB","../../../common/languages/language.js":"ka2JQ","../../common/standaloneTheme.js":"exW2E","../../../common/standaloneStrings.js":"D35dK"}],"3puMh":[function() {},{}],"lKwNi":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _platformJs = require("../../../../platform/registry/common/platform.js");
var _quickAccessJs = require("../../../../platform/quickinput/common/quickAccess.js");
var _standaloneStringsJs = require("../../../common/standaloneStrings.js");
var _helpQuickAccessJs = require("../../../../platform/quickinput/browser/helpQuickAccess.js");
(0, _platformJs.Registry).as((0, _quickAccessJs.Extensions).Quickaccess).registerQuickAccessProvider({
    ctor: (0, _helpQuickAccessJs.HelpQuickAccessProvider),
    prefix: "",
    helpEntries: [
        {
            description: (0, _standaloneStringsJs.QuickHelpNLS).helpQuickAccessActionLabel
        }
    ]
});

},{"../../../../platform/registry/common/platform.js":"dzx11","../../../../platform/quickinput/common/quickAccess.js":"k9EM7","../../../common/standaloneStrings.js":"D35dK","../../../../platform/quickinput/browser/helpQuickAccess.js":"egve9"}],"egve9":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HelpQuickAccessProvider", ()=>HelpQuickAccessProvider);
var _nlsJs = require("../../../nls.js");
var _platformJs = require("../../registry/common/platform.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _keybindingJs = require("../../keybinding/common/keybinding.js");
var _quickAccessJs = require("../common/quickAccess.js");
var _quickInputJs = require("../common/quickInput.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var HelpQuickAccessProvider_1;
let HelpQuickAccessProvider = class HelpQuickAccessProvider {
    static{
        HelpQuickAccessProvider_1 = this;
    }
    static{
        this.PREFIX = "?";
    }
    constructor(quickInputService, keybindingService){
        this.quickInputService = quickInputService;
        this.keybindingService = keybindingService;
        this.registry = (0, _platformJs.Registry).as((0, _quickAccessJs.Extensions).Quickaccess);
    }
    provide(picker) {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        // Open a picker with the selected value if picked
        disposables.add(picker.onDidAccept(()=>{
            const [item] = picker.selectedItems;
            if (item) this.quickInputService.quickAccess.show(item.prefix, {
                preserveValue: true
            });
        }));
        // Also open a picker when we detect the user typed the exact
        // name of a provider (e.g. `?term` for terminals)
        disposables.add(picker.onDidChangeValue((value)=>{
            const providerDescriptor = this.registry.getQuickAccessProvider(value.substr(HelpQuickAccessProvider_1.PREFIX.length));
            if (providerDescriptor && providerDescriptor.prefix && providerDescriptor.prefix !== HelpQuickAccessProvider_1.PREFIX) this.quickInputService.quickAccess.show(providerDescriptor.prefix, {
                preserveValue: true
            });
        }));
        // Fill in all providers
        picker.items = this.getQuickAccessProviders().filter((p)=>p.prefix !== HelpQuickAccessProvider_1.PREFIX);
        return disposables;
    }
    getQuickAccessProviders() {
        const providers = this.registry.getQuickAccessProviders().sort((providerA, providerB)=>providerA.prefix.localeCompare(providerB.prefix)).flatMap((provider)=>this.createPicks(provider));
        return providers;
    }
    createPicks(provider) {
        return provider.helpEntries.map((helpEntry)=>{
            const prefix = helpEntry.prefix || provider.prefix;
            const label = prefix || "\u2026" /* ... */ ;
            return {
                prefix,
                label,
                keybinding: helpEntry.commandId ? this.keybindingService.lookupKeybinding(helpEntry.commandId) : undefined,
                ariaLabel: (0, _nlsJs.localize)("helpPickAriaLabel", "{0}, {1}", label, helpEntry.description),
                description: helpEntry.description
            };
        });
    }
};
HelpQuickAccessProvider = HelpQuickAccessProvider_1 = __decorate([
    __param(0, (0, _quickInputJs.IQuickInputService)),
    __param(1, (0, _keybindingJs.IKeybindingService))
], HelpQuickAccessProvider);

},{"../../../nls.js":"l617d","../../registry/common/platform.js":"dzx11","../../../base/common/lifecycle.js":"9kg8d","../../keybinding/common/keybinding.js":"25pLT","../common/quickAccess.js":"k9EM7","../common/quickInput.js":"a56M6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"54Au8":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandaloneGotoLineQuickAccessProvider", ()=>StandaloneGotoLineQuickAccessProvider);
parcelHelpers.export(exports, "GotoLineAction", ()=>GotoLineAction);
var _gotoLineQuickAccessJs = require("../../../contrib/quickAccess/browser/gotoLineQuickAccess.js");
var _platformJs = require("../../../../platform/registry/common/platform.js");
var _quickAccessJs = require("../../../../platform/quickinput/common/quickAccess.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _standaloneStringsJs = require("../../../common/standaloneStrings.js");
var _eventJs = require("../../../../base/common/event.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _quickInputJs = require("../../../../platform/quickinput/common/quickInput.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let StandaloneGotoLineQuickAccessProvider = class StandaloneGotoLineQuickAccessProvider extends (0, _gotoLineQuickAccessJs.AbstractGotoLineQuickAccessProvider) {
    constructor(editorService){
        super();
        this.editorService = editorService;
        this.onDidActiveTextEditorControlChange = (0, _eventJs.Event).None;
    }
    get activeTextEditorControl() {
        return this.editorService.getFocusedCodeEditor() ?? undefined;
    }
};
StandaloneGotoLineQuickAccessProvider = __decorate([
    __param(0, (0, _codeEditorServiceJs.ICodeEditorService))
], StandaloneGotoLineQuickAccessProvider);
class GotoLineAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.gotoLine";
    }
    constructor(){
        super({
            id: GotoLineAction.ID,
            label: (0, _standaloneStringsJs.GoToLineNLS).gotoLineActionLabel,
            alias: "Go to Line/Column...",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                primary: 2085 /* KeyCode.KeyG */ ,
                mac: {
                    primary: 293 /* KeyCode.KeyG */ 
                },
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            }
        });
    }
    run(accessor) {
        accessor.get((0, _quickInputJs.IQuickInputService)).quickAccess.show(StandaloneGotoLineQuickAccessProvider.PREFIX);
    }
}
(0, _editorExtensionsJs.registerEditorAction)(GotoLineAction);
(0, _platformJs.Registry).as((0, _quickAccessJs.Extensions).Quickaccess).registerQuickAccessProvider({
    ctor: StandaloneGotoLineQuickAccessProvider,
    prefix: StandaloneGotoLineQuickAccessProvider.PREFIX,
    helpEntries: [
        {
            description: (0, _standaloneStringsJs.GoToLineNLS).gotoLineActionLabel,
            commandId: GotoLineAction.ID
        }
    ]
});

},{"../../../contrib/quickAccess/browser/gotoLineQuickAccess.js":"lj4mM","../../../../platform/registry/common/platform.js":"dzx11","../../../../platform/quickinput/common/quickAccess.js":"k9EM7","../../../browser/services/codeEditorService.js":"bOWtl","../../../common/standaloneStrings.js":"D35dK","../../../../base/common/event.js":"4Zi8b","../../../browser/editorExtensions.js":"kC3w6","../../../common/editorContextKeys.js":"5exv9","../../../../platform/quickinput/common/quickInput.js":"a56M6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lj4mM":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractGotoLineQuickAccessProvider", ()=>AbstractGotoLineQuickAccessProvider);
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorBrowserJs = require("../../../browser/editorBrowser.js");
var _editorNavigationQuickAccessJs = require("./editorNavigationQuickAccess.js");
var _nlsJs = require("../../../../nls.js");
class AbstractGotoLineQuickAccessProvider extends (0, _editorNavigationQuickAccessJs.AbstractEditorNavigationQuickAccessProvider) {
    static{
        this.PREFIX = ":";
    }
    constructor(){
        super({
            canAcceptInBackground: true
        });
    }
    provideWithoutTextEditor(picker) {
        const label = (0, _nlsJs.localize)("cannotRunGotoLine", "Open a text editor first to go to a line.");
        picker.items = [
            {
                label
            }
        ];
        picker.ariaLabel = label;
        return (0, _lifecycleJs.Disposable).None;
    }
    provideWithTextEditor(context, picker, token) {
        const editor = context.editor;
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        // Goto line once picked
        disposables.add(picker.onDidAccept((event)=>{
            const [item] = picker.selectedItems;
            if (item) {
                if (!this.isValidLineNumber(editor, item.lineNumber)) return;
                this.gotoLocation(context, {
                    range: this.toRange(item.lineNumber, item.column),
                    keyMods: picker.keyMods,
                    preserveFocus: event.inBackground
                });
                if (!event.inBackground) picker.hide();
            }
        }));
        // React to picker changes
        const updatePickerAndEditor = ()=>{
            const position = this.parsePosition(editor, picker.value.trim().substr(AbstractGotoLineQuickAccessProvider.PREFIX.length));
            const label = this.getPickLabel(editor, position.lineNumber, position.column);
            // Picker
            picker.items = [
                {
                    lineNumber: position.lineNumber,
                    column: position.column,
                    label
                }
            ];
            // ARIA Label
            picker.ariaLabel = label;
            // Clear decorations for invalid range
            if (!this.isValidLineNumber(editor, position.lineNumber)) {
                this.clearDecorations(editor);
                return;
            }
            // Reveal
            const range = this.toRange(position.lineNumber, position.column);
            editor.revealRangeInCenter(range, 0 /* ScrollType.Smooth */ );
            // Decorate
            this.addDecorations(editor, range);
        };
        updatePickerAndEditor();
        disposables.add(picker.onDidChangeValue(()=>updatePickerAndEditor()));
        // Adjust line number visibility as needed
        const codeEditor = (0, _editorBrowserJs.getCodeEditor)(editor);
        if (codeEditor) {
            const options = codeEditor.getOptions();
            const lineNumbers = options.get(68 /* EditorOption.lineNumbers */ );
            if (lineNumbers.renderType === 2 /* RenderLineNumbersType.Relative */ ) {
                codeEditor.updateOptions({
                    lineNumbers: "on"
                });
                disposables.add((0, _lifecycleJs.toDisposable)(()=>codeEditor.updateOptions({
                        lineNumbers: "relative"
                    })));
            }
        }
        return disposables;
    }
    toRange(lineNumber = 1, column = 1) {
        return {
            startLineNumber: lineNumber,
            startColumn: column,
            endLineNumber: lineNumber,
            endColumn: column
        };
    }
    parsePosition(editor, value) {
        // Support line-col formats of `line,col`, `line:col`, `line#col`
        const numbers = value.split(/,|:|#/).map((part)=>parseInt(part, 10)).filter((part)=>!isNaN(part));
        const endLine = this.lineCount(editor) + 1;
        return {
            lineNumber: numbers[0] > 0 ? numbers[0] : endLine + numbers[0],
            column: numbers[1]
        };
    }
    getPickLabel(editor, lineNumber, column) {
        // Location valid: indicate this as picker label
        if (this.isValidLineNumber(editor, lineNumber)) {
            if (this.isValidColumn(editor, lineNumber, column)) return (0, _nlsJs.localize)("gotoLineColumnLabel", "Go to line {0} and character {1}.", lineNumber, column);
            return (0, _nlsJs.localize)("gotoLineLabel", "Go to line {0}.", lineNumber);
        }
        // Location invalid: show generic label
        const position = editor.getPosition() || {
            lineNumber: 1,
            column: 1
        };
        const lineCount = this.lineCount(editor);
        if (lineCount > 1) return (0, _nlsJs.localize)("gotoLineLabelEmptyWithLimit", "Current Line: {0}, Character: {1}. Type a line number between 1 and {2} to navigate to.", position.lineNumber, position.column, lineCount);
        return (0, _nlsJs.localize)("gotoLineLabelEmpty", "Current Line: {0}, Character: {1}. Type a line number to navigate to.", position.lineNumber, position.column);
    }
    isValidLineNumber(editor, lineNumber) {
        if (!lineNumber || typeof lineNumber !== "number") return false;
        return lineNumber > 0 && lineNumber <= this.lineCount(editor);
    }
    isValidColumn(editor, lineNumber, column) {
        if (!column || typeof column !== "number") return false;
        const model = this.getModel(editor);
        if (!model) return false;
        const positionCandidate = {
            lineNumber,
            column
        };
        return model.validatePosition(positionCandidate).equals(positionCandidate);
    }
    lineCount(editor) {
        return this.getModel(editor)?.getLineCount() ?? 0;
    }
}

},{"../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorBrowser.js":"82sBe","./editorNavigationQuickAccess.js":"ihmMd","../../../../nls.js":"l617d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ihmMd":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A reusable quick access provider for the editor with support
 * for adding decorations for navigating in the currently active file
 * (for example "Go to line", "Go to symbol").
 */ parcelHelpers.export(exports, "AbstractEditorNavigationQuickAccessProvider", ()=>AbstractEditorNavigationQuickAccessProvider);
var _functionalJs = require("../../../../base/common/functional.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _editorBrowserJs = require("../../../browser/editorBrowser.js");
var _modelJs = require("../../../common/model.js");
var _editorColorRegistryJs = require("../../../common/core/editorColorRegistry.js");
var _themeServiceJs = require("../../../../platform/theme/common/themeService.js");
var _ariaJs = require("../../../../base/browser/ui/aria/aria.js");
class AbstractEditorNavigationQuickAccessProvider {
    constructor(options){
        this.options = options;
        //#endregion
        //#region Decorations Utils
        this.rangeHighlightDecorationId = undefined;
    }
    //#region Provider methods
    provide(picker, token, runOptions) {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        // Apply options if any
        picker.canAcceptInBackground = !!this.options?.canAcceptInBackground;
        // Disable filtering & sorting, we control the results
        picker.matchOnLabel = picker.matchOnDescription = picker.matchOnDetail = picker.sortByLabel = false;
        // Provide based on current active editor
        const pickerDisposable = disposables.add(new (0, _lifecycleJs.MutableDisposable)());
        pickerDisposable.value = this.doProvide(picker, token, runOptions);
        // Re-create whenever the active editor changes
        disposables.add(this.onDidActiveTextEditorControlChange(()=>{
            // Clear old
            pickerDisposable.value = undefined;
            // Add new
            pickerDisposable.value = this.doProvide(picker, token);
        }));
        return disposables;
    }
    doProvide(picker, token, runOptions) {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        // With text control
        const editor = this.activeTextEditorControl;
        if (editor && this.canProvideWithTextEditor(editor)) {
            const context = {
                editor
            };
            // Restore any view state if this picker was closed
            // without actually going to a line
            const codeEditor = (0, _editorBrowserJs.getCodeEditor)(editor);
            if (codeEditor) {
                // Remember view state and update it when the cursor position
                // changes even later because it could be that the user has
                // configured quick access to remain open when focus is lost and
                // we always want to restore the current location.
                let lastKnownEditorViewState = editor.saveViewState() ?? undefined;
                disposables.add(codeEditor.onDidChangeCursorPosition(()=>{
                    lastKnownEditorViewState = editor.saveViewState() ?? undefined;
                }));
                context.restoreViewState = ()=>{
                    if (lastKnownEditorViewState && editor === this.activeTextEditorControl) editor.restoreViewState(lastKnownEditorViewState);
                };
                disposables.add((0, _functionalJs.createSingleCallFunction)(token.onCancellationRequested)(()=>context.restoreViewState?.()));
            }
            // Clean up decorations on dispose
            disposables.add((0, _lifecycleJs.toDisposable)(()=>this.clearDecorations(editor)));
            // Ask subclass for entries
            disposables.add(this.provideWithTextEditor(context, picker, token, runOptions));
        } else disposables.add(this.provideWithoutTextEditor(picker, token));
        return disposables;
    }
    /**
     * Subclasses to implement if they can operate on the text editor.
     */ canProvideWithTextEditor(editor) {
        return true;
    }
    gotoLocation({ editor }, options) {
        editor.setSelection(options.range, "code.jump" /* TextEditorSelectionSource.JUMP */ );
        editor.revealRangeInCenter(options.range, 0 /* ScrollType.Smooth */ );
        if (!options.preserveFocus) editor.focus();
        const model = editor.getModel();
        if (model && "getLineContent" in model) (0, _ariaJs.status)(`${model.getLineContent(options.range.startLineNumber)}`);
    }
    getModel(editor) {
        return (0, _editorBrowserJs.isDiffEditor)(editor) ? editor.getModel()?.modified : editor.getModel();
    }
    addDecorations(editor, range) {
        editor.changeDecorations((changeAccessor)=>{
            // Reset old decorations if any
            const deleteDecorations = [];
            if (this.rangeHighlightDecorationId) {
                deleteDecorations.push(this.rangeHighlightDecorationId.overviewRulerDecorationId);
                deleteDecorations.push(this.rangeHighlightDecorationId.rangeHighlightId);
                this.rangeHighlightDecorationId = undefined;
            }
            // Add new decorations for the range
            const newDecorations = [
                // highlight the entire line on the range
                {
                    range,
                    options: {
                        description: "quick-access-range-highlight",
                        className: "rangeHighlight",
                        isWholeLine: true
                    }
                },
                // also add overview ruler highlight
                {
                    range,
                    options: {
                        description: "quick-access-range-highlight-overview",
                        overviewRuler: {
                            color: (0, _themeServiceJs.themeColorFromId)((0, _editorColorRegistryJs.overviewRulerRangeHighlight)),
                            position: (0, _modelJs.OverviewRulerLane).Full
                        }
                    }
                }
            ];
            const [rangeHighlightId, overviewRulerDecorationId] = changeAccessor.deltaDecorations(deleteDecorations, newDecorations);
            this.rangeHighlightDecorationId = {
                rangeHighlightId,
                overviewRulerDecorationId
            };
        });
    }
    clearDecorations(editor) {
        const rangeHighlightDecorationId = this.rangeHighlightDecorationId;
        if (rangeHighlightDecorationId) {
            editor.changeDecorations((changeAccessor)=>{
                changeAccessor.deltaDecorations([
                    rangeHighlightDecorationId.overviewRulerDecorationId,
                    rangeHighlightDecorationId.rangeHighlightId
                ], []);
            });
            this.rangeHighlightDecorationId = undefined;
        }
    }
}

},{"../../../../base/common/functional.js":"75R2i","../../../../base/common/lifecycle.js":"9kg8d","../../../browser/editorBrowser.js":"82sBe","../../../common/model.js":"1CSIB","../../../common/core/editorColorRegistry.js":"5XqtL","../../../../platform/theme/common/themeService.js":"jMkIC","../../../../base/browser/ui/aria/aria.js":"asrsh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8tvuL":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandaloneGotoSymbolQuickAccessProvider", ()=>StandaloneGotoSymbolQuickAccessProvider);
parcelHelpers.export(exports, "GotoSymbolAction", ()=>GotoSymbolAction);
var _codiconStylesJs = require("../../../../base/browser/ui/codicons/codiconStyles.js"); // The codicon symbol styles are defined here and must be loaded
var _symbolIconsJs = require("../../../contrib/symbolIcons/browser/symbolIcons.js"); // The codicon symbol colors are defined here and must be loaded to get colors
var _gotoSymbolQuickAccessJs = require("../../../contrib/quickAccess/browser/gotoSymbolQuickAccess.js");
var _platformJs = require("../../../../platform/registry/common/platform.js");
var _quickAccessJs = require("../../../../platform/quickinput/common/quickAccess.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _standaloneStringsJs = require("../../../common/standaloneStrings.js");
var _eventJs = require("../../../../base/common/event.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _quickInputJs = require("../../../../platform/quickinput/common/quickInput.js");
var _outlineModelJs = require("../../../contrib/documentSymbols/browser/outlineModel.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let StandaloneGotoSymbolQuickAccessProvider = class StandaloneGotoSymbolQuickAccessProvider extends (0, _gotoSymbolQuickAccessJs.AbstractGotoSymbolQuickAccessProvider) {
    constructor(editorService, languageFeaturesService, outlineModelService){
        super(languageFeaturesService, outlineModelService);
        this.editorService = editorService;
        this.onDidActiveTextEditorControlChange = (0, _eventJs.Event).None;
    }
    get activeTextEditorControl() {
        return this.editorService.getFocusedCodeEditor() ?? undefined;
    }
};
StandaloneGotoSymbolQuickAccessProvider = __decorate([
    __param(0, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(1, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(2, (0, _outlineModelJs.IOutlineModelService))
], StandaloneGotoSymbolQuickAccessProvider);
class GotoSymbolAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.quickOutline";
    }
    constructor(){
        super({
            id: GotoSymbolAction.ID,
            label: (0, _standaloneStringsJs.QuickOutlineNLS).quickOutlineActionLabel,
            alias: "Go to Symbol...",
            precondition: (0, _editorContextKeysJs.EditorContextKeys).hasDocumentSymbolProvider,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                primary: 3117 /* KeyCode.KeyO */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            contextMenuOpts: {
                group: "navigation",
                order: 3
            }
        });
    }
    run(accessor) {
        accessor.get((0, _quickInputJs.IQuickInputService)).quickAccess.show((0, _gotoSymbolQuickAccessJs.AbstractGotoSymbolQuickAccessProvider).PREFIX, {
            itemActivation: (0, _quickInputJs.ItemActivation).NONE
        });
    }
}
(0, _editorExtensionsJs.registerEditorAction)(GotoSymbolAction);
(0, _platformJs.Registry).as((0, _quickAccessJs.Extensions).Quickaccess).registerQuickAccessProvider({
    ctor: StandaloneGotoSymbolQuickAccessProvider,
    prefix: (0, _gotoSymbolQuickAccessJs.AbstractGotoSymbolQuickAccessProvider).PREFIX,
    helpEntries: [
        {
            description: (0, _standaloneStringsJs.QuickOutlineNLS).quickOutlineActionLabel,
            prefix: (0, _gotoSymbolQuickAccessJs.AbstractGotoSymbolQuickAccessProvider).PREFIX,
            commandId: GotoSymbolAction.ID
        },
        {
            description: (0, _standaloneStringsJs.QuickOutlineNLS).quickOutlineByCategoryActionLabel,
            prefix: (0, _gotoSymbolQuickAccessJs.AbstractGotoSymbolQuickAccessProvider).PREFIX_BY_CATEGORY
        }
    ]
});

},{"../../../../base/browser/ui/codicons/codiconStyles.js":"guMVT","../../../contrib/symbolIcons/browser/symbolIcons.js":"4yhOw","../../../contrib/quickAccess/browser/gotoSymbolQuickAccess.js":"fi9WV","../../../../platform/registry/common/platform.js":"dzx11","../../../../platform/quickinput/common/quickAccess.js":"k9EM7","../../../browser/services/codeEditorService.js":"bOWtl","../../../common/standaloneStrings.js":"D35dK","../../../../base/common/event.js":"4Zi8b","../../../browser/editorExtensions.js":"kC3w6","../../../common/editorContextKeys.js":"5exv9","../../../../platform/quickinput/common/quickInput.js":"a56M6","../../../contrib/documentSymbols/browser/outlineModel.js":"13q6i","../../../common/services/languageFeatures.js":"2IAko","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fi9WV":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractGotoSymbolQuickAccessProvider", ()=>AbstractGotoSymbolQuickAccessProvider);
var _asyncJs = require("../../../../base/common/async.js");
var _cancellationJs = require("../../../../base/common/cancellation.js");
var _codiconsJs = require("../../../../base/common/codicons.js");
var _themablesJs = require("../../../../base/common/themables.js");
var _fuzzyScorerJs = require("../../../../base/common/fuzzyScorer.js");
var _lifecycleJs = require("../../../../base/common/lifecycle.js");
var _stringsJs = require("../../../../base/common/strings.js");
var _rangeJs = require("../../../common/core/range.js");
var _languagesJs = require("../../../common/languages.js");
var _outlineModelJs = require("../../documentSymbols/browser/outlineModel.js");
var _editorNavigationQuickAccessJs = require("./editorNavigationQuickAccess.js");
var _nlsJs = require("../../../../nls.js");
var _languageFeaturesJs = require("../../../common/services/languageFeatures.js");
var _arraysFindJs = require("../../../../base/common/arraysFind.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var AbstractGotoSymbolQuickAccessProvider_1;
let AbstractGotoSymbolQuickAccessProvider = class AbstractGotoSymbolQuickAccessProvider extends (0, _editorNavigationQuickAccessJs.AbstractEditorNavigationQuickAccessProvider) {
    static{
        AbstractGotoSymbolQuickAccessProvider_1 = this;
    }
    static{
        this.PREFIX = "@";
    }
    static{
        this.SCOPE_PREFIX = ":";
    }
    static{
        this.PREFIX_BY_CATEGORY = `${this.PREFIX}${this.SCOPE_PREFIX}`;
    }
    constructor(_languageFeaturesService, _outlineModelService, options = Object.create(null)){
        super(options);
        this._languageFeaturesService = _languageFeaturesService;
        this._outlineModelService = _outlineModelService;
        this.options = options;
        this.options.canAcceptInBackground = true;
    }
    provideWithoutTextEditor(picker) {
        this.provideLabelPick(picker, (0, _nlsJs.localize)("cannotRunGotoSymbolWithoutEditor", "To go to a symbol, first open a text editor with symbol information."));
        return (0, _lifecycleJs.Disposable).None;
    }
    provideWithTextEditor(context, picker, token, runOptions) {
        const editor = context.editor;
        const model = this.getModel(editor);
        if (!model) return (0, _lifecycleJs.Disposable).None;
        // Provide symbols from model if available in registry
        if (this._languageFeaturesService.documentSymbolProvider.has(model)) return this.doProvideWithEditorSymbols(context, model, picker, token, runOptions);
        // Otherwise show an entry for a model without registry
        // But give a chance to resolve the symbols at a later
        // point if possible
        return this.doProvideWithoutEditorSymbols(context, model, picker, token);
    }
    doProvideWithoutEditorSymbols(context, model, picker, token) {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        // Generic pick for not having any symbol information
        this.provideLabelPick(picker, (0, _nlsJs.localize)("cannotRunGotoSymbolWithoutSymbolProvider", "The active text editor does not provide symbol information."));
        // Wait for changes to the registry and see if eventually
        // we do get symbols. This can happen if the picker is opened
        // very early after the model has loaded but before the
        // language registry is ready.
        // https://github.com/microsoft/vscode/issues/70607
        (async ()=>{
            const result = await this.waitForLanguageSymbolRegistry(model, disposables);
            if (!result || token.isCancellationRequested) return;
            disposables.add(this.doProvideWithEditorSymbols(context, model, picker, token));
        })();
        return disposables;
    }
    provideLabelPick(picker, label) {
        picker.items = [
            {
                label,
                index: 0,
                kind: 14 /* SymbolKind.String */ 
            }
        ];
        picker.ariaLabel = label;
    }
    async waitForLanguageSymbolRegistry(model, disposables) {
        if (this._languageFeaturesService.documentSymbolProvider.has(model)) return true;
        const symbolProviderRegistryPromise = new (0, _asyncJs.DeferredPromise)();
        // Resolve promise when registry knows model
        const symbolProviderListener = disposables.add(this._languageFeaturesService.documentSymbolProvider.onDidChange(()=>{
            if (this._languageFeaturesService.documentSymbolProvider.has(model)) {
                symbolProviderListener.dispose();
                symbolProviderRegistryPromise.complete(true);
            }
        }));
        // Resolve promise when we get disposed too
        disposables.add((0, _lifecycleJs.toDisposable)(()=>symbolProviderRegistryPromise.complete(false)));
        return symbolProviderRegistryPromise.p;
    }
    doProvideWithEditorSymbols(context, model, picker, token, runOptions) {
        const editor = context.editor;
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        // Goto symbol once picked
        disposables.add(picker.onDidAccept((event)=>{
            const [item] = picker.selectedItems;
            if (item && item.range) {
                this.gotoLocation(context, {
                    range: item.range.selection,
                    keyMods: picker.keyMods,
                    preserveFocus: event.inBackground
                });
                runOptions?.handleAccept?.(item);
                if (!event.inBackground) picker.hide();
            }
        }));
        // Goto symbol side by side if enabled
        disposables.add(picker.onDidTriggerItemButton(({ item })=>{
            if (item && item.range) {
                this.gotoLocation(context, {
                    range: item.range.selection,
                    keyMods: picker.keyMods,
                    forceSideBySide: true
                });
                picker.hide();
            }
        }));
        // Resolve symbols from document once and reuse this
        // request for all filtering and typing then on
        const symbolsPromise = this.getDocumentSymbols(model, token);
        // Set initial picks and update on type
        let picksCts = undefined;
        const updatePickerItems = async (positionToEnclose)=>{
            // Cancel any previous ask for picks and busy
            picksCts?.dispose(true);
            picker.busy = false;
            // Create new cancellation source for this run
            picksCts = new (0, _cancellationJs.CancellationTokenSource)(token);
            // Collect symbol picks
            picker.busy = true;
            try {
                const query = (0, _fuzzyScorerJs.prepareQuery)(picker.value.substr(AbstractGotoSymbolQuickAccessProvider_1.PREFIX.length).trim());
                const items = await this.doGetSymbolPicks(symbolsPromise, query, undefined, picksCts.token, model);
                if (token.isCancellationRequested) return;
                if (items.length > 0) {
                    picker.items = items;
                    if (positionToEnclose && query.original.length === 0) {
                        const candidate = (0, _arraysFindJs.findLast)(items, (item)=>Boolean(item.type !== "separator" && item.range && (0, _rangeJs.Range).containsPosition(item.range.decoration, positionToEnclose)));
                        if (candidate) picker.activeItems = [
                            candidate
                        ];
                    }
                } else if (query.original.length > 0) this.provideLabelPick(picker, (0, _nlsJs.localize)("noMatchingSymbolResults", "No matching editor symbols"));
                else this.provideLabelPick(picker, (0, _nlsJs.localize)("noSymbolResults", "No editor symbols"));
            } finally{
                if (!token.isCancellationRequested) picker.busy = false;
            }
        };
        disposables.add(picker.onDidChangeValue(()=>updatePickerItems(undefined)));
        updatePickerItems(editor.getSelection()?.getPosition());
        // Reveal and decorate when active item changes
        disposables.add(picker.onDidChangeActive(()=>{
            const [item] = picker.activeItems;
            if (item && item.range) {
                // Reveal
                editor.revealRangeInCenter(item.range.selection, 0 /* ScrollType.Smooth */ );
                // Decorate
                this.addDecorations(editor, item.range.decoration);
            }
        }));
        return disposables;
    }
    async doGetSymbolPicks(symbolsPromise, query, options, token, model) {
        const symbols = await symbolsPromise;
        if (token.isCancellationRequested) return [];
        const filterBySymbolKind = query.original.indexOf(AbstractGotoSymbolQuickAccessProvider_1.SCOPE_PREFIX) === 0;
        const filterPos = filterBySymbolKind ? 1 : 0;
        // Split between symbol and container query
        let symbolQuery;
        let containerQuery;
        if (query.values && query.values.length > 1) {
            symbolQuery = (0, _fuzzyScorerJs.pieceToQuery)(query.values[0]); // symbol: only match on first part
            containerQuery = (0, _fuzzyScorerJs.pieceToQuery)(query.values.slice(1)); // container: match on all but first parts
        } else symbolQuery = query;
        // Convert to symbol picks and apply filtering
        let buttons;
        const openSideBySideDirection = this.options?.openSideBySideDirection?.();
        if (openSideBySideDirection) buttons = [
            {
                iconClass: openSideBySideDirection === "right" ? (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).splitHorizontal) : (0, _themablesJs.ThemeIcon).asClassName((0, _codiconsJs.Codicon).splitVertical),
                tooltip: openSideBySideDirection === "right" ? (0, _nlsJs.localize)("openToSide", "Open to the Side") : (0, _nlsJs.localize)("openToBottom", "Open to the Bottom")
            }
        ];
        const filteredSymbolPicks = [];
        for(let index = 0; index < symbols.length; index++){
            const symbol = symbols[index];
            const symbolLabel = (0, _stringsJs.trim)(symbol.name);
            const symbolLabelWithIcon = `$(${(0, _languagesJs.SymbolKinds).toIcon(symbol.kind).id}) ${symbolLabel}`;
            const symbolLabelIconOffset = symbolLabelWithIcon.length - symbolLabel.length;
            let containerLabel = symbol.containerName;
            if (options?.extraContainerLabel) {
                if (containerLabel) containerLabel = `${options.extraContainerLabel} \u{2022} ${containerLabel}`;
                else containerLabel = options.extraContainerLabel;
            }
            let symbolScore = undefined;
            let symbolMatches = undefined;
            let containerScore = undefined;
            let containerMatches = undefined;
            if (query.original.length > filterPos) {
                // First: try to score on the entire query, it is possible that
                // the symbol matches perfectly (e.g. searching for "change log"
                // can be a match on a markdown symbol "change log"). In that
                // case we want to skip the container query altogether.
                let skipContainerQuery = false;
                if (symbolQuery !== query) {
                    [symbolScore, symbolMatches] = (0, _fuzzyScorerJs.scoreFuzzy2)(symbolLabelWithIcon, {
                        ...query,
                        values: undefined /* disable multi-query support */ 
                    }, filterPos, symbolLabelIconOffset);
                    if (typeof symbolScore === "number") skipContainerQuery = true; // since we consumed the query, skip any container matching
                }
                // Otherwise: score on the symbol query and match on the container later
                if (typeof symbolScore !== "number") {
                    [symbolScore, symbolMatches] = (0, _fuzzyScorerJs.scoreFuzzy2)(symbolLabelWithIcon, symbolQuery, filterPos, symbolLabelIconOffset);
                    if (typeof symbolScore !== "number") continue;
                }
                // Score by container if specified
                if (!skipContainerQuery && containerQuery) {
                    if (containerLabel && containerQuery.original.length > 0) [containerScore, containerMatches] = (0, _fuzzyScorerJs.scoreFuzzy2)(containerLabel, containerQuery);
                    if (typeof containerScore !== "number") continue;
                    if (typeof symbolScore === "number") symbolScore += containerScore; // boost symbolScore by containerScore
                }
            }
            const deprecated = symbol.tags && symbol.tags.indexOf(1 /* SymbolTag.Deprecated */ ) >= 0;
            filteredSymbolPicks.push({
                index,
                kind: symbol.kind,
                score: symbolScore,
                label: symbolLabelWithIcon,
                ariaLabel: (0, _languagesJs.getAriaLabelForSymbol)(symbol.name, symbol.kind),
                description: containerLabel,
                highlights: deprecated ? undefined : {
                    label: symbolMatches,
                    description: containerMatches
                },
                range: {
                    selection: (0, _rangeJs.Range).collapseToStart(symbol.selectionRange),
                    decoration: symbol.range
                },
                uri: model.uri,
                symbolName: symbolLabel,
                strikethrough: deprecated,
                buttons
            });
        }
        // Sort by score
        const sortedFilteredSymbolPicks = filteredSymbolPicks.sort((symbolA, symbolB)=>filterBySymbolKind ? this.compareByKindAndScore(symbolA, symbolB) : this.compareByScore(symbolA, symbolB));
        // Add separator for types
        // - @  only total number of symbols
        // - @: grouped by symbol kind
        let symbolPicks = [];
        if (filterBySymbolKind) {
            let lastSymbolKind = undefined;
            let lastSeparator = undefined;
            let lastSymbolKindCounter = 0;
            function updateLastSeparatorLabel() {
                if (lastSeparator && typeof lastSymbolKind === "number" && lastSymbolKindCounter > 0) lastSeparator.label = (0, _stringsJs.format)(NLS_SYMBOL_KIND_CACHE[lastSymbolKind] || FALLBACK_NLS_SYMBOL_KIND, lastSymbolKindCounter);
            }
            for (const symbolPick of sortedFilteredSymbolPicks){
                // Found new kind
                if (lastSymbolKind !== symbolPick.kind) {
                    // Update last separator with number of symbols we found for kind
                    updateLastSeparatorLabel();
                    lastSymbolKind = symbolPick.kind;
                    lastSymbolKindCounter = 1;
                    // Add new separator for new kind
                    lastSeparator = {
                        type: "separator"
                    };
                    symbolPicks.push(lastSeparator);
                } else lastSymbolKindCounter++;
                // Add to final result
                symbolPicks.push(symbolPick);
            }
            // Update last separator with number of symbols we found for kind
            updateLastSeparatorLabel();
        } else if (sortedFilteredSymbolPicks.length > 0) symbolPicks = [
            {
                label: (0, _nlsJs.localize)("symbols", "symbols ({0})", filteredSymbolPicks.length),
                type: "separator"
            },
            ...sortedFilteredSymbolPicks
        ];
        return symbolPicks;
    }
    compareByScore(symbolA, symbolB) {
        if (typeof symbolA.score !== "number" && typeof symbolB.score === "number") return 1;
        else if (typeof symbolA.score === "number" && typeof symbolB.score !== "number") return -1;
        if (typeof symbolA.score === "number" && typeof symbolB.score === "number") {
            if (symbolA.score > symbolB.score) return -1;
            else if (symbolA.score < symbolB.score) return 1;
        }
        if (symbolA.index < symbolB.index) return -1;
        else if (symbolA.index > symbolB.index) return 1;
        return 0;
    }
    compareByKindAndScore(symbolA, symbolB) {
        const kindA = NLS_SYMBOL_KIND_CACHE[symbolA.kind] || FALLBACK_NLS_SYMBOL_KIND;
        const kindB = NLS_SYMBOL_KIND_CACHE[symbolB.kind] || FALLBACK_NLS_SYMBOL_KIND;
        // Sort by type first if scoped search
        const result = kindA.localeCompare(kindB);
        if (result === 0) return this.compareByScore(symbolA, symbolB);
        return result;
    }
    async getDocumentSymbols(document, token) {
        const model = await this._outlineModelService.getOrCreate(document, token);
        return token.isCancellationRequested ? [] : model.asListOfDocumentSymbols();
    }
};
AbstractGotoSymbolQuickAccessProvider = AbstractGotoSymbolQuickAccessProvider_1 = __decorate([
    __param(0, (0, _languageFeaturesJs.ILanguageFeaturesService)),
    __param(1, (0, _outlineModelJs.IOutlineModelService))
], AbstractGotoSymbolQuickAccessProvider);
// #region NLS Helpers
const FALLBACK_NLS_SYMBOL_KIND = (0, _nlsJs.localize)("property", "properties ({0})");
const NLS_SYMBOL_KIND_CACHE = {
    [5 /* SymbolKind.Method */ ]: (0, _nlsJs.localize)("method", "methods ({0})"),
    [11 /* SymbolKind.Function */ ]: (0, _nlsJs.localize)("function", "functions ({0})"),
    [8 /* SymbolKind.Constructor */ ]: (0, _nlsJs.localize)("_constructor", "constructors ({0})"),
    [12 /* SymbolKind.Variable */ ]: (0, _nlsJs.localize)("variable", "variables ({0})"),
    [4 /* SymbolKind.Class */ ]: (0, _nlsJs.localize)("class", "classes ({0})"),
    [22 /* SymbolKind.Struct */ ]: (0, _nlsJs.localize)("struct", "structs ({0})"),
    [23 /* SymbolKind.Event */ ]: (0, _nlsJs.localize)("event", "events ({0})"),
    [24 /* SymbolKind.Operator */ ]: (0, _nlsJs.localize)("operator", "operators ({0})"),
    [10 /* SymbolKind.Interface */ ]: (0, _nlsJs.localize)("interface", "interfaces ({0})"),
    [2 /* SymbolKind.Namespace */ ]: (0, _nlsJs.localize)("namespace", "namespaces ({0})"),
    [3 /* SymbolKind.Package */ ]: (0, _nlsJs.localize)("package", "packages ({0})"),
    [25 /* SymbolKind.TypeParameter */ ]: (0, _nlsJs.localize)("typeParameter", "type parameters ({0})"),
    [1 /* SymbolKind.Module */ ]: (0, _nlsJs.localize)("modules", "modules ({0})"),
    [6 /* SymbolKind.Property */ ]: (0, _nlsJs.localize)("property", "properties ({0})"),
    [9 /* SymbolKind.Enum */ ]: (0, _nlsJs.localize)("enum", "enumerations ({0})"),
    [21 /* SymbolKind.EnumMember */ ]: (0, _nlsJs.localize)("enumMember", "enumeration members ({0})"),
    [14 /* SymbolKind.String */ ]: (0, _nlsJs.localize)("string", "strings ({0})"),
    [0 /* SymbolKind.File */ ]: (0, _nlsJs.localize)("file", "files ({0})"),
    [17 /* SymbolKind.Array */ ]: (0, _nlsJs.localize)("array", "arrays ({0})"),
    [15 /* SymbolKind.Number */ ]: (0, _nlsJs.localize)("number", "numbers ({0})"),
    [16 /* SymbolKind.Boolean */ ]: (0, _nlsJs.localize)("boolean", "booleans ({0})"),
    [18 /* SymbolKind.Object */ ]: (0, _nlsJs.localize)("object", "objects ({0})"),
    [19 /* SymbolKind.Key */ ]: (0, _nlsJs.localize)("key", "keys ({0})"),
    [7 /* SymbolKind.Field */ ]: (0, _nlsJs.localize)("field", "fields ({0})"),
    [13 /* SymbolKind.Constant */ ]: (0, _nlsJs.localize)("constant", "constants ({0})")
}; //#endregion

},{"../../../../base/common/async.js":"4GJc4","../../../../base/common/cancellation.js":"hoVxw","../../../../base/common/codicons.js":"hWYNf","../../../../base/common/themables.js":"hgyHi","../../../../base/common/fuzzyScorer.js":"91dSu","../../../../base/common/lifecycle.js":"9kg8d","../../../../base/common/strings.js":"aA9I1","../../../common/core/range.js":"jmUPh","../../../common/languages.js":"g5n96","../../documentSymbols/browser/outlineModel.js":"13q6i","./editorNavigationQuickAccess.js":"ihmMd","../../../../nls.js":"l617d","../../../common/services/languageFeatures.js":"2IAko","../../../../base/common/arraysFind.js":"gWrU0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"91dSu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scoreFuzzy2", ()=>scoreFuzzy2);
parcelHelpers.export(exports, "prepareQuery", ()=>prepareQuery);
parcelHelpers.export(exports, "pieceToQuery", ()=>pieceToQuery) //#endregion
;
var _filtersJs = require("./filters.js");
var _pathJs = require("./path.js");
var _platformJs = require("./platform.js");
var _stringsJs = require("./strings.js");
const NO_SCORE2 = [
    undefined,
    []
];
function scoreFuzzy2(target, query, patternStart = 0, wordStart = 0) {
    // Score: multiple inputs
    const preparedQuery = query;
    if (preparedQuery.values && preparedQuery.values.length > 1) return doScoreFuzzy2Multiple(target, preparedQuery.values, patternStart, wordStart);
    // Score: single input
    return doScoreFuzzy2Single(target, query, patternStart, wordStart);
}
function doScoreFuzzy2Multiple(target, query, patternStart, wordStart) {
    let totalScore = 0;
    const totalMatches = [];
    for (const queryPiece of query){
        const [score, matches] = doScoreFuzzy2Single(target, queryPiece, patternStart, wordStart);
        if (typeof score !== "number") // if a single query value does not match, return with
        // no score entirely, we require all queries to match
        return NO_SCORE2;
        totalScore += score;
        totalMatches.push(...matches);
    }
    // if we have a score, ensure that the positions are
    // sorted in ascending order and distinct
    return [
        totalScore,
        normalizeMatches(totalMatches)
    ];
}
function doScoreFuzzy2Single(target, query, patternStart, wordStart) {
    const score = (0, _filtersJs.fuzzyScore)(query.original, query.originalLowercase, patternStart, target, target.toLowerCase(), wordStart, {
        firstMatchCanBeWeak: true,
        boostFullMatch: true
    });
    if (!score) return NO_SCORE2;
    return [
        score[0],
        (0, _filtersJs.createMatches)(score)
    ];
}
const NO_ITEM_SCORE = Object.freeze({
    score: 0
});
function normalizeMatches(matches) {
    // sort matches by start to be able to normalize
    const sortedMatches = matches.sort((matchA, matchB)=>{
        return matchA.start - matchB.start;
    });
    // merge matches that overlap
    const normalizedMatches = [];
    let currentMatch = undefined;
    for (const match of sortedMatches)// if we have no current match or the matches
    // do not overlap, we take it as is and remember
    // it for future merging
    if (!currentMatch || !matchOverlaps(currentMatch, match)) {
        currentMatch = match;
        normalizedMatches.push(match);
    } else {
        currentMatch.start = Math.min(currentMatch.start, match.start);
        currentMatch.end = Math.max(currentMatch.end, match.end);
    }
    return normalizedMatches;
}
function matchOverlaps(matchA, matchB) {
    if (matchA.end < matchB.start) return false; // A ends before B starts
    if (matchB.end < matchA.start) return false; // B ends before A starts
    return true;
}
/*
 * If a query is wrapped in quotes, the user does not want to
 * use fuzzy search for this query.
 */ function queryExpectsExactMatch(query) {
    return query.startsWith('"') && query.endsWith('"');
}
/**
 * Helper function to prepare a search value for scoring by removing unwanted characters
 * and allowing to score on multiple pieces separated by whitespace character.
 */ const MULTIPLE_QUERY_VALUES_SEPARATOR = " ";
function prepareQuery(original) {
    if (typeof original !== "string") original = "";
    const originalLowercase = original.toLowerCase();
    const { pathNormalized, normalized, normalizedLowercase } = normalizeQuery(original);
    const containsPathSeparator = pathNormalized.indexOf((0, _pathJs.sep)) >= 0;
    const expectExactMatch = queryExpectsExactMatch(original);
    let values = undefined;
    const originalSplit = original.split(MULTIPLE_QUERY_VALUES_SEPARATOR);
    if (originalSplit.length > 1) for (const originalPiece of originalSplit){
        const expectExactMatchPiece = queryExpectsExactMatch(originalPiece);
        const { pathNormalized: pathNormalizedPiece, normalized: normalizedPiece, normalizedLowercase: normalizedLowercasePiece } = normalizeQuery(originalPiece);
        if (normalizedPiece) {
            if (!values) values = [];
            values.push({
                original: originalPiece,
                originalLowercase: originalPiece.toLowerCase(),
                pathNormalized: pathNormalizedPiece,
                normalized: normalizedPiece,
                normalizedLowercase: normalizedLowercasePiece,
                expectContiguousMatch: expectExactMatchPiece
            });
        }
    }
    return {
        original,
        originalLowercase,
        pathNormalized,
        normalized,
        normalizedLowercase,
        values,
        containsPathSeparator,
        expectContiguousMatch: expectExactMatch
    };
}
function normalizeQuery(original) {
    let pathNormalized;
    if (0, _platformJs.isWindows) pathNormalized = original.replace(/\//g, (0, _pathJs.sep)); // Help Windows users to search for paths when using slash
    else pathNormalized = original.replace(/\\/g, (0, _pathJs.sep)); // Help macOS/Linux users to search for paths when using backslash
    // we remove quotes here because quotes are used for exact match search
    const normalized = (0, _stringsJs.stripWildcards)(pathNormalized).replace(/\s|"/g, "");
    return {
        pathNormalized,
        normalized,
        normalizedLowercase: normalized.toLowerCase()
    };
}
function pieceToQuery(arg1) {
    if (Array.isArray(arg1)) return prepareQuery(arg1.map((piece)=>piece.original).join(MULTIPLE_QUERY_VALUES_SEPARATOR));
    return prepareQuery(arg1.original);
}

},{"./filters.js":"40BGZ","./path.js":"vyRKJ","./platform.js":"7maJO","./strings.js":"aA9I1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h2w7A":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandaloneCommandsQuickAccessProvider", ()=>StandaloneCommandsQuickAccessProvider);
parcelHelpers.export(exports, "GotoLineAction", ()=>GotoLineAction);
var _platformJs = require("../../../../platform/registry/common/platform.js");
var _quickAccessJs = require("../../../../platform/quickinput/common/quickAccess.js");
var _standaloneStringsJs = require("../../../common/standaloneStrings.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _commandsQuickAccessJs = require("../../../contrib/quickAccess/browser/commandsQuickAccess.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _keybindingJs = require("../../../../platform/keybinding/common/keybinding.js");
var _commandsJs = require("../../../../platform/commands/common/commands.js");
var _telemetryJs = require("../../../../platform/telemetry/common/telemetry.js");
var _dialogsJs = require("../../../../platform/dialogs/common/dialogs.js");
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _editorContextKeysJs = require("../../../common/editorContextKeys.js");
var _quickInputJs = require("../../../../platform/quickinput/common/quickInput.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let StandaloneCommandsQuickAccessProvider = class StandaloneCommandsQuickAccessProvider extends (0, _commandsQuickAccessJs.AbstractEditorCommandsQuickAccessProvider) {
    get activeTextEditorControl() {
        return this.codeEditorService.getFocusedCodeEditor() ?? undefined;
    }
    constructor(instantiationService, codeEditorService, keybindingService, commandService, telemetryService, dialogService){
        super({
            showAlias: false
        }, instantiationService, keybindingService, commandService, telemetryService, dialogService);
        this.codeEditorService = codeEditorService;
    }
    async getCommandPicks() {
        return this.getCodeEditorCommandPicks();
    }
    hasAdditionalCommandPicks() {
        return false;
    }
    async getAdditionalCommandPicks() {
        return [];
    }
};
StandaloneCommandsQuickAccessProvider = __decorate([
    __param(0, (0, _instantiationJs.IInstantiationService)),
    __param(1, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(2, (0, _keybindingJs.IKeybindingService)),
    __param(3, (0, _commandsJs.ICommandService)),
    __param(4, (0, _telemetryJs.ITelemetryService)),
    __param(5, (0, _dialogsJs.IDialogService))
], StandaloneCommandsQuickAccessProvider);
class GotoLineAction extends (0, _editorExtensionsJs.EditorAction) {
    static{
        this.ID = "editor.action.quickCommand";
    }
    constructor(){
        super({
            id: GotoLineAction.ID,
            label: (0, _standaloneStringsJs.QuickCommandNLS).quickCommandActionLabel,
            alias: "Command Palette",
            precondition: undefined,
            kbOpts: {
                kbExpr: (0, _editorContextKeysJs.EditorContextKeys).focus,
                primary: 59 /* KeyCode.F1 */ ,
                weight: 100 /* KeybindingWeight.EditorContrib */ 
            },
            contextMenuOpts: {
                group: "z_commands",
                order: 1
            }
        });
    }
    run(accessor) {
        accessor.get((0, _quickInputJs.IQuickInputService)).quickAccess.show(StandaloneCommandsQuickAccessProvider.PREFIX);
    }
}
(0, _editorExtensionsJs.registerEditorAction)(GotoLineAction);
(0, _platformJs.Registry).as((0, _quickAccessJs.Extensions).Quickaccess).registerQuickAccessProvider({
    ctor: StandaloneCommandsQuickAccessProvider,
    prefix: StandaloneCommandsQuickAccessProvider.PREFIX,
    helpEntries: [
        {
            description: (0, _standaloneStringsJs.QuickCommandNLS).quickCommandHelp,
            commandId: GotoLineAction.ID
        }
    ]
});

},{"../../../../platform/registry/common/platform.js":"dzx11","../../../../platform/quickinput/common/quickAccess.js":"k9EM7","../../../common/standaloneStrings.js":"D35dK","../../../browser/services/codeEditorService.js":"bOWtl","../../../contrib/quickAccess/browser/commandsQuickAccess.js":"7D3mI","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/keybinding/common/keybinding.js":"25pLT","../../../../platform/commands/common/commands.js":"ho6ic","../../../../platform/telemetry/common/telemetry.js":"7vW8j","../../../../platform/dialogs/common/dialogs.js":"3ZDTa","../../../browser/editorExtensions.js":"kC3w6","../../../common/editorContextKeys.js":"5exv9","../../../../platform/quickinput/common/quickInput.js":"a56M6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7D3mI":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractEditorCommandsQuickAccessProvider", ()=>AbstractEditorCommandsQuickAccessProvider);
var _iconLabelsJs = require("../../../../base/common/iconLabels.js");
var _actionJs = require("../../../../platform/action/common/action.js");
var _commandsQuickAccessJs = require("../../../../platform/quickinput/browser/commandsQuickAccess.js");
class AbstractEditorCommandsQuickAccessProvider extends (0, _commandsQuickAccessJs.AbstractCommandsQuickAccessProvider) {
    constructor(options, instantiationService, keybindingService, commandService, telemetryService, dialogService){
        super(options, instantiationService, keybindingService, commandService, telemetryService, dialogService);
    }
    getCodeEditorCommandPicks() {
        const activeTextEditorControl = this.activeTextEditorControl;
        if (!activeTextEditorControl) return [];
        const editorCommandPicks = [];
        for (const editorAction of activeTextEditorControl.getSupportedActions()){
            let commandDescription;
            if (editorAction.metadata?.description) {
                if ((0, _actionJs.isLocalizedString)(editorAction.metadata.description)) commandDescription = editorAction.metadata.description;
                else commandDescription = {
                    original: editorAction.metadata.description,
                    value: editorAction.metadata.description
                };
            }
            editorCommandPicks.push({
                commandId: editorAction.id,
                commandAlias: editorAction.alias,
                commandDescription,
                label: (0, _iconLabelsJs.stripIcons)(editorAction.label) || editorAction.id
            });
        }
        return editorCommandPicks;
    }
}

},{"../../../../base/common/iconLabels.js":"3vhIZ","../../../../platform/action/common/action.js":"kzlRi","../../../../platform/quickinput/browser/commandsQuickAccess.js":"5ANT3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ANT3":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractCommandsQuickAccessProvider", ()=>AbstractCommandsQuickAccessProvider);
parcelHelpers.export(exports, "CommandsHistory", ()=>CommandsHistory);
var _errorMessageJs = require("../../../base/common/errorMessage.js");
var _errorsJs = require("../../../base/common/errors.js");
var _filtersJs = require("../../../base/common/filters.js");
var _functionalJs = require("../../../base/common/functional.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _mapJs = require("../../../base/common/map.js");
var _tfIdfJs = require("../../../base/common/tfIdf.js");
var _nlsJs = require("../../../nls.js");
var _commandsJs = require("../../commands/common/commands.js");
var _configurationJs = require("../../configuration/common/configuration.js");
var _dialogsJs = require("../../dialogs/common/dialogs.js");
var _instantiationJs = require("../../instantiation/common/instantiation.js");
var _keybindingJs = require("../../keybinding/common/keybinding.js");
var _logJs = require("../../log/common/log.js");
var _pickerQuickAccessJs = require("./pickerQuickAccess.js");
var _storageJs = require("../../storage/common/storage.js");
var _telemetryJs = require("../../telemetry/common/telemetry.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var AbstractCommandsQuickAccessProvider_1, CommandsHistory_1;
let AbstractCommandsQuickAccessProvider = class AbstractCommandsQuickAccessProvider extends (0, _pickerQuickAccessJs.PickerQuickAccessProvider) {
    static{
        AbstractCommandsQuickAccessProvider_1 = this;
    }
    static{
        this.PREFIX = ">";
    }
    static{
        this.TFIDF_THRESHOLD = 0.5;
    }
    static{
        this.TFIDF_MAX_RESULTS = 5;
    }
    static{
        this.WORD_FILTER = (0, _filtersJs.or)((0, _filtersJs.matchesPrefix), (0, _filtersJs.matchesWords), (0, _filtersJs.matchesContiguousSubString));
    }
    constructor(options, instantiationService, keybindingService, commandService, telemetryService, dialogService){
        super(AbstractCommandsQuickAccessProvider_1.PREFIX, options);
        this.instantiationService = instantiationService;
        this.keybindingService = keybindingService;
        this.commandService = commandService;
        this.telemetryService = telemetryService;
        this.dialogService = dialogService;
        this.commandsHistory = this._register(this.instantiationService.createInstance(CommandsHistory));
        this.options = options;
    }
    async _getPicks(filter, _disposables, token, runOptions) {
        // Ask subclass for all command picks
        const allCommandPicks = await this.getCommandPicks(token);
        if (token.isCancellationRequested) return [];
        const runTfidf = (0, _functionalJs.createSingleCallFunction)(()=>{
            const tfidf = new (0, _tfIdfJs.TfIdfCalculator)();
            tfidf.updateDocuments(allCommandPicks.map((commandPick)=>({
                    key: commandPick.commandId,
                    textChunks: [
                        this.getTfIdfChunk(commandPick)
                    ]
                })));
            const result = tfidf.calculateScores(filter, token);
            return (0, _tfIdfJs.normalizeTfIdfScores)(result).filter((score)=>score.score > AbstractCommandsQuickAccessProvider_1.TFIDF_THRESHOLD).slice(0, AbstractCommandsQuickAccessProvider_1.TFIDF_MAX_RESULTS);
        });
        // Filter
        const filteredCommandPicks = [];
        for (const commandPick of allCommandPicks){
            const labelHighlights = AbstractCommandsQuickAccessProvider_1.WORD_FILTER(filter, commandPick.label) ?? undefined;
            const aliasHighlights = commandPick.commandAlias ? AbstractCommandsQuickAccessProvider_1.WORD_FILTER(filter, commandPick.commandAlias) ?? undefined : undefined;
            // Add if matching in label or alias
            if (labelHighlights || aliasHighlights) {
                commandPick.highlights = {
                    label: labelHighlights,
                    detail: this.options.showAlias ? aliasHighlights : undefined
                };
                filteredCommandPicks.push(commandPick);
            } else if (filter === commandPick.commandId) filteredCommandPicks.push(commandPick);
            else if (filter.length >= 3) {
                const tfidf = runTfidf();
                if (token.isCancellationRequested) return [];
                // Add if we have a tf-idf score
                const tfidfScore = tfidf.find((score)=>score.key === commandPick.commandId);
                if (tfidfScore) {
                    commandPick.tfIdfScore = tfidfScore.score;
                    filteredCommandPicks.push(commandPick);
                }
            }
        }
        // Add description to commands that have duplicate labels
        const mapLabelToCommand = new Map();
        for (const commandPick of filteredCommandPicks){
            const existingCommandForLabel = mapLabelToCommand.get(commandPick.label);
            if (existingCommandForLabel) {
                commandPick.description = commandPick.commandId;
                existingCommandForLabel.description = existingCommandForLabel.commandId;
            } else mapLabelToCommand.set(commandPick.label, commandPick);
        }
        // Sort by MRU order and fallback to name otherwise
        filteredCommandPicks.sort((commandPickA, commandPickB)=>{
            // If a result came from tf-idf, we want to put that towards the bottom
            if (commandPickA.tfIdfScore && commandPickB.tfIdfScore) {
                if (commandPickA.tfIdfScore === commandPickB.tfIdfScore) return commandPickA.label.localeCompare(commandPickB.label); // prefer lexicographically smaller command
                return commandPickB.tfIdfScore - commandPickA.tfIdfScore; // prefer higher tf-idf score
            } else if (commandPickA.tfIdfScore) return 1; // first command has a score but other doesn't so other wins
            else if (commandPickB.tfIdfScore) return -1; // other command has a score but first doesn't so first wins
            const commandACounter = this.commandsHistory.peek(commandPickA.commandId);
            const commandBCounter = this.commandsHistory.peek(commandPickB.commandId);
            if (commandACounter && commandBCounter) return commandACounter > commandBCounter ? -1 : 1; // use more recently used command before older
            if (commandACounter) return -1; // first command was used, so it wins over the non used one
            if (commandBCounter) return 1; // other command was used so it wins over the command
            if (this.options.suggestedCommandIds) {
                const commandASuggestion = this.options.suggestedCommandIds.has(commandPickA.commandId);
                const commandBSuggestion = this.options.suggestedCommandIds.has(commandPickB.commandId);
                if (commandASuggestion && commandBSuggestion) return 0; // honor the order of the array
                if (commandASuggestion) return -1; // first command was suggested, so it wins over the non suggested one
                if (commandBSuggestion) return 1; // other command was suggested so it wins over the command
            }
            // both commands were never used, so we sort by name
            return commandPickA.label.localeCompare(commandPickB.label);
        });
        const commandPicks = [];
        let addOtherSeparator = false;
        let addSuggestedSeparator = true;
        let addCommonlyUsedSeparator = !!this.options.suggestedCommandIds;
        for(let i = 0; i < filteredCommandPicks.length; i++){
            const commandPick = filteredCommandPicks[i];
            // Separator: recently used
            if (i === 0 && this.commandsHistory.peek(commandPick.commandId)) {
                commandPicks.push({
                    type: "separator",
                    label: (0, _nlsJs.localize)("recentlyUsed", "recently used")
                });
                addOtherSeparator = true;
            }
            if (addSuggestedSeparator && commandPick.tfIdfScore !== undefined) {
                commandPicks.push({
                    type: "separator",
                    label: (0, _nlsJs.localize)("suggested", "similar commands")
                });
                addSuggestedSeparator = false;
            }
            // Separator: commonly used
            if (addCommonlyUsedSeparator && commandPick.tfIdfScore === undefined && !this.commandsHistory.peek(commandPick.commandId) && this.options.suggestedCommandIds?.has(commandPick.commandId)) {
                commandPicks.push({
                    type: "separator",
                    label: (0, _nlsJs.localize)("commonlyUsed", "commonly used")
                });
                addOtherSeparator = true;
                addCommonlyUsedSeparator = false;
            }
            // Separator: other commands
            if (addOtherSeparator && commandPick.tfIdfScore === undefined && !this.commandsHistory.peek(commandPick.commandId) && !this.options.suggestedCommandIds?.has(commandPick.commandId)) {
                commandPicks.push({
                    type: "separator",
                    label: (0, _nlsJs.localize)("morecCommands", "other commands")
                });
                addOtherSeparator = false;
            }
            // Command
            commandPicks.push(this.toCommandPick(commandPick, runOptions));
        }
        if (!this.hasAdditionalCommandPicks(filter, token)) return commandPicks;
        return {
            picks: commandPicks,
            additionalPicks: (async ()=>{
                const additionalCommandPicks = await this.getAdditionalCommandPicks(allCommandPicks, filteredCommandPicks, filter, token);
                if (token.isCancellationRequested) return [];
                const commandPicks = additionalCommandPicks.map((commandPick)=>this.toCommandPick(commandPick, runOptions));
                // Basically, if we haven't already added a separator, we add one before the additional picks so long
                // as one hasn't been added to the start of the array.
                if (addSuggestedSeparator && commandPicks[0]?.type !== "separator") commandPicks.unshift({
                    type: "separator",
                    label: (0, _nlsJs.localize)("suggested", "similar commands")
                });
                return commandPicks;
            })()
        };
    }
    toCommandPick(commandPick, runOptions) {
        if (commandPick.type === "separator") return commandPick;
        const keybinding = this.keybindingService.lookupKeybinding(commandPick.commandId);
        const ariaLabel = keybinding ? (0, _nlsJs.localize)("commandPickAriaLabelWithKeybinding", "{0}, {1}", commandPick.label, keybinding.getAriaLabel()) : commandPick.label;
        return {
            ...commandPick,
            ariaLabel,
            detail: this.options.showAlias && commandPick.commandAlias !== commandPick.label ? commandPick.commandAlias : undefined,
            keybinding,
            accept: async ()=>{
                // Add to history
                this.commandsHistory.push(commandPick.commandId);
                // Telementry
                this.telemetryService.publicLog2("workbenchActionExecuted", {
                    id: commandPick.commandId,
                    from: runOptions?.from ?? "quick open"
                });
                // Run
                try {
                    commandPick.args?.length ? await this.commandService.executeCommand(commandPick.commandId, ...commandPick.args) : await this.commandService.executeCommand(commandPick.commandId);
                } catch (error) {
                    if (!(0, _errorsJs.isCancellationError)(error)) this.dialogService.error((0, _nlsJs.localize)("canNotRun", "Command '{0}' resulted in an error", commandPick.label), (0, _errorMessageJs.toErrorMessage)(error));
                }
            }
        };
    }
    // TF-IDF string to be indexed
    getTfIdfChunk({ label, commandAlias, commandDescription }) {
        let chunk = label;
        if (commandAlias && commandAlias !== label) chunk += ` - ${commandAlias}`;
        if (commandDescription && commandDescription.value !== label) // If the original is the same as the value, don't add it
        chunk += ` - ${commandDescription.value === commandDescription.original ? commandDescription.value : `${commandDescription.value} (${commandDescription.original})`}`;
        return chunk;
    }
};
AbstractCommandsQuickAccessProvider = AbstractCommandsQuickAccessProvider_1 = __decorate([
    __param(1, (0, _instantiationJs.IInstantiationService)),
    __param(2, (0, _keybindingJs.IKeybindingService)),
    __param(3, (0, _commandsJs.ICommandService)),
    __param(4, (0, _telemetryJs.ITelemetryService)),
    __param(5, (0, _dialogsJs.IDialogService))
], AbstractCommandsQuickAccessProvider);
let CommandsHistory = class CommandsHistory extends (0, _lifecycleJs.Disposable) {
    static{
        CommandsHistory_1 = this;
    }
    static{
        this.DEFAULT_COMMANDS_HISTORY_LENGTH = 50;
    }
    static{
        this.PREF_KEY_CACHE = "commandPalette.mru.cache";
    }
    static{
        this.PREF_KEY_COUNTER = "commandPalette.mru.counter";
    }
    static{
        this.counter = 1;
    }
    static{
        this.hasChanges = false;
    }
    constructor(storageService, configurationService, logService){
        super();
        this.storageService = storageService;
        this.configurationService = configurationService;
        this.logService = logService;
        this.configuredCommandsHistoryLength = 0;
        this.updateConfiguration();
        this.load();
        this.registerListeners();
    }
    registerListeners() {
        this._register(this.configurationService.onDidChangeConfiguration((e)=>this.updateConfiguration(e)));
        this._register(this.storageService.onWillSaveState((e)=>{
            if (e.reason === (0, _storageJs.WillSaveStateReason).SHUTDOWN) // Commands history is very dynamic and so we limit impact
            // on storage to only save on shutdown. This helps reduce
            // the overhead of syncing this data across machines.
            this.saveState();
        }));
    }
    updateConfiguration(e) {
        if (e && !e.affectsConfiguration("workbench.commandPalette.history")) return;
        this.configuredCommandsHistoryLength = CommandsHistory_1.getConfiguredCommandHistoryLength(this.configurationService);
        if (CommandsHistory_1.cache && CommandsHistory_1.cache.limit !== this.configuredCommandsHistoryLength) {
            CommandsHistory_1.cache.limit = this.configuredCommandsHistoryLength;
            CommandsHistory_1.hasChanges = true;
        }
    }
    load() {
        const raw = this.storageService.get(CommandsHistory_1.PREF_KEY_CACHE, 0 /* StorageScope.PROFILE */ );
        let serializedCache;
        if (raw) try {
            serializedCache = JSON.parse(raw);
        } catch (error) {
            this.logService.error(`[CommandsHistory] invalid data: ${error}`);
        }
        const cache = CommandsHistory_1.cache = new (0, _mapJs.LRUCache)(this.configuredCommandsHistoryLength, 1);
        if (serializedCache) {
            let entries;
            if (serializedCache.usesLRU) entries = serializedCache.entries;
            else entries = serializedCache.entries.sort((a, b)=>a.value - b.value);
            entries.forEach((entry)=>cache.set(entry.key, entry.value));
        }
        CommandsHistory_1.counter = this.storageService.getNumber(CommandsHistory_1.PREF_KEY_COUNTER, 0 /* StorageScope.PROFILE */ , CommandsHistory_1.counter);
    }
    push(commandId) {
        if (!CommandsHistory_1.cache) return;
        CommandsHistory_1.cache.set(commandId, CommandsHistory_1.counter++); // set counter to command
        CommandsHistory_1.hasChanges = true;
    }
    peek(commandId) {
        return CommandsHistory_1.cache?.peek(commandId);
    }
    saveState() {
        if (!CommandsHistory_1.cache) return;
        if (!CommandsHistory_1.hasChanges) return;
        const serializedCache = {
            usesLRU: true,
            entries: []
        };
        CommandsHistory_1.cache.forEach((value, key)=>serializedCache.entries.push({
                key,
                value
            }));
        this.storageService.store(CommandsHistory_1.PREF_KEY_CACHE, JSON.stringify(serializedCache), 0 /* StorageScope.PROFILE */ , 0 /* StorageTarget.USER */ );
        this.storageService.store(CommandsHistory_1.PREF_KEY_COUNTER, CommandsHistory_1.counter, 0 /* StorageScope.PROFILE */ , 0 /* StorageTarget.USER */ );
        CommandsHistory_1.hasChanges = false;
    }
    static getConfiguredCommandHistoryLength(configurationService) {
        const config = configurationService.getValue();
        const configuredCommandHistoryLength = config.workbench?.commandPalette?.history;
        if (typeof configuredCommandHistoryLength === "number") return configuredCommandHistoryLength;
        return CommandsHistory_1.DEFAULT_COMMANDS_HISTORY_LENGTH;
    }
};
CommandsHistory = CommandsHistory_1 = __decorate([
    __param(0, (0, _storageJs.IStorageService)),
    __param(1, (0, _configurationJs.IConfigurationService)),
    __param(2, (0, _logJs.ILogService))
], CommandsHistory);

},{"../../../base/common/errorMessage.js":"3JHUv","../../../base/common/errors.js":"divX8","../../../base/common/filters.js":"40BGZ","../../../base/common/functional.js":"75R2i","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/map.js":"leSjz","../../../base/common/tfIdf.js":"798T9","../../../nls.js":"l617d","../../commands/common/commands.js":"ho6ic","../../configuration/common/configuration.js":"dXkjq","../../dialogs/common/dialogs.js":"3ZDTa","../../instantiation/common/instantiation.js":"fjwWx","../../keybinding/common/keybinding.js":"25pLT","../../log/common/log.js":"ieJUF","./pickerQuickAccess.js":"oNWBm","../../storage/common/storage.js":"6AhR2","../../telemetry/common/telemetry.js":"7vW8j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"798T9":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Implementation of tf-idf (term frequency-inverse document frequency) for a set of
 * documents where each document contains one or more chunks of text.
 * Each document is identified by a key, and the score for each document is computed
 * by taking the max score over all the chunks in the document.
 */ parcelHelpers.export(exports, "TfIdfCalculator", ()=>TfIdfCalculator);
/**
 * Normalize the scores to be between 0 and 1 and sort them decending.
 * @param scores array of scores from {@link TfIdfCalculator.calculateScores}
 * @returns normalized scores
 */ parcelHelpers.export(exports, "normalizeTfIdfScores", ()=>normalizeTfIdfScores);
function countMapFrom(values) {
    const map = new Map();
    for (const value of values)map.set(value, (map.get(value) ?? 0) + 1);
    return map;
}
class TfIdfCalculator {
    constructor(){
        /**
         * Total number of chunks
         */ this.chunkCount = 0;
        this.chunkOccurrences = new Map();
        this.documents = new Map();
    }
    calculateScores(query, token) {
        const embedding = this.computeEmbedding(query);
        const idfCache = new Map();
        const scores = [];
        // For each document, generate one score
        for (const [key, doc] of this.documents){
            if (token.isCancellationRequested) return [];
            for (const chunk of doc.chunks){
                const score = this.computeSimilarityScore(chunk, embedding, idfCache);
                if (score > 0) scores.push({
                    key,
                    score
                });
            }
        }
        return scores;
    }
    /**
     * Count how many times each term (word) appears in a string.
     */ static termFrequencies(input) {
        return countMapFrom(TfIdfCalculator.splitTerms(input));
    }
    /**
     * Break a string into terms (words).
     */ static *splitTerms(input) {
        const normalize = (word)=>word.toLowerCase();
        // Only match on words that are at least 3 characters long and start with a letter
        for (const [word] of input.matchAll(/\b\p{Letter}[\p{Letter}\d]{2,}\b/gu)){
            yield normalize(word);
            const camelParts = word.replace(/([a-z])([A-Z])/g, "$1 $2").split(/\s+/g);
            if (camelParts.length > 1) {
                for (const part of camelParts)// Require at least 3 letters in the parts of a camel case word
                if (part.length > 2 && /\p{Letter}{3,}/gu.test(part)) yield normalize(part);
            }
        }
    }
    updateDocuments(documents) {
        for (const { key } of documents)this.deleteDocument(key);
        for (const doc of documents){
            const chunks = [];
            for (const text of doc.textChunks){
                // TODO: See if we can compute the tf lazily
                // The challenge is that we need to also update the `chunkOccurrences`
                // and all of those updates need to get flushed before the real TF-IDF of
                // anything is computed.
                const tf = TfIdfCalculator.termFrequencies(text);
                // Update occurrences list
                for (const term of tf.keys())this.chunkOccurrences.set(term, (this.chunkOccurrences.get(term) ?? 0) + 1);
                chunks.push({
                    text,
                    tf
                });
            }
            this.chunkCount += chunks.length;
            this.documents.set(doc.key, {
                chunks
            });
        }
        return this;
    }
    deleteDocument(key) {
        const doc = this.documents.get(key);
        if (!doc) return;
        this.documents.delete(key);
        this.chunkCount -= doc.chunks.length;
        // Update term occurrences for the document
        for (const chunk of doc.chunks)for (const term of chunk.tf.keys()){
            const currentOccurrences = this.chunkOccurrences.get(term);
            if (typeof currentOccurrences === "number") {
                const newOccurrences = currentOccurrences - 1;
                if (newOccurrences <= 0) this.chunkOccurrences.delete(term);
                else this.chunkOccurrences.set(term, newOccurrences);
            }
        }
    }
    computeSimilarityScore(chunk, queryEmbedding, idfCache) {
        // Compute the dot product between the chunk's embedding and the query embedding
        // Note that the chunk embedding is computed lazily on a per-term basis.
        // This lets us skip a large number of calculations because the majority
        // of chunks do not share any terms with the query.
        let sum = 0;
        for (const [term, termTfidf] of Object.entries(queryEmbedding)){
            const chunkTf = chunk.tf.get(term);
            if (!chunkTf) continue;
            let chunkIdf = idfCache.get(term);
            if (typeof chunkIdf !== "number") {
                chunkIdf = this.computeIdf(term);
                idfCache.set(term, chunkIdf);
            }
            const chunkTfidf = chunkTf * chunkIdf;
            sum += chunkTfidf * termTfidf;
        }
        return sum;
    }
    computeEmbedding(input) {
        const tf = TfIdfCalculator.termFrequencies(input);
        return this.computeTfidf(tf);
    }
    computeIdf(term) {
        const chunkOccurrences = this.chunkOccurrences.get(term) ?? 0;
        return chunkOccurrences > 0 ? Math.log((this.chunkCount + 1) / chunkOccurrences) : 0;
    }
    computeTfidf(termFrequencies) {
        const embedding = Object.create(null);
        for (const [word, occurrences] of termFrequencies){
            const idf = this.computeIdf(word);
            if (idf > 0) embedding[word] = occurrences * idf;
        }
        return embedding;
    }
}
function normalizeTfIdfScores(scores) {
    // copy of scores
    const result = scores.slice(0);
    // sort descending
    result.sort((a, b)=>b.score - a.score);
    // normalize
    const max = result[0]?.score ?? 0;
    if (max > 0) for (const score of result)score.score /= max;
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"oNWBm":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TriggerAction", ()=>TriggerAction);
parcelHelpers.export(exports, "PickerQuickAccessProvider", ()=>PickerQuickAccessProvider);
var _asyncJs = require("../../../base/common/async.js");
var _cancellationJs = require("../../../base/common/cancellation.js");
var _lifecycleJs = require("../../../base/common/lifecycle.js");
var _typesJs = require("../../../base/common/types.js");
var TriggerAction;
(function(TriggerAction) {
    /**
     * Do nothing after the button was clicked.
     */ TriggerAction[TriggerAction["NO_ACTION"] = 0] = "NO_ACTION";
    /**
     * Close the picker.
     */ TriggerAction[TriggerAction["CLOSE_PICKER"] = 1] = "CLOSE_PICKER";
    /**
     * Update the results of the picker.
     */ TriggerAction[TriggerAction["REFRESH_PICKER"] = 2] = "REFRESH_PICKER";
    /**
     * Remove the item from the picker.
     */ TriggerAction[TriggerAction["REMOVE_ITEM"] = 3] = "REMOVE_ITEM";
})(TriggerAction || (TriggerAction = {}));
function isPicksWithActive(obj) {
    const candidate = obj;
    return Array.isArray(candidate.items);
}
function isFastAndSlowPicks(obj) {
    const candidate = obj;
    return !!candidate.picks && candidate.additionalPicks instanceof Promise;
}
class PickerQuickAccessProvider extends (0, _lifecycleJs.Disposable) {
    constructor(prefix, options){
        super();
        this.prefix = prefix;
        this.options = options;
    }
    provide(picker, token, runOptions) {
        const disposables = new (0, _lifecycleJs.DisposableStore)();
        // Apply options if any
        picker.canAcceptInBackground = !!this.options?.canAcceptInBackground;
        // Disable filtering & sorting, we control the results
        picker.matchOnLabel = picker.matchOnDescription = picker.matchOnDetail = picker.sortByLabel = false;
        // Set initial picks and update on type
        let picksCts = undefined;
        const picksDisposable = disposables.add(new (0, _lifecycleJs.MutableDisposable)());
        const updatePickerItems = async ()=>{
            const picksDisposables = picksDisposable.value = new (0, _lifecycleJs.DisposableStore)();
            // Cancel any previous ask for picks and busy
            picksCts?.dispose(true);
            picker.busy = false;
            // Create new cancellation source for this run
            picksCts = new (0, _cancellationJs.CancellationTokenSource)(token);
            // Collect picks and support both long running and short or combined
            const picksToken = picksCts.token;
            let picksFilter = picker.value.substring(this.prefix.length);
            if (!this.options?.shouldSkipTrimPickFilter) picksFilter = picksFilter.trim();
            const providedPicks = this._getPicks(picksFilter, picksDisposables, picksToken, runOptions);
            const applyPicks = (picks, skipEmpty)=>{
                let items;
                let activeItem = undefined;
                if (isPicksWithActive(picks)) {
                    items = picks.items;
                    activeItem = picks.active;
                } else items = picks;
                if (items.length === 0) {
                    if (skipEmpty) return false;
                    // We show the no results pick if we have no input to prevent completely empty pickers #172613
                    if ((picksFilter.length > 0 || picker.hideInput) && this.options?.noResultsPick) {
                        if ((0, _typesJs.isFunction)(this.options.noResultsPick)) items = [
                            this.options.noResultsPick(picksFilter)
                        ];
                        else items = [
                            this.options.noResultsPick
                        ];
                    }
                }
                picker.items = items;
                if (activeItem) picker.activeItems = [
                    activeItem
                ];
                return true;
            };
            const applyFastAndSlowPicks = async (fastAndSlowPicks)=>{
                let fastPicksApplied = false;
                let slowPicksApplied = false;
                await Promise.all([
                    // Fast Picks: if `mergeDelay` is configured, in order to reduce
                    // amount of flicker, we race against the slow picks over some delay
                    // and then set the fast picks.
                    // If the slow picks are faster, we reduce the flicker by only
                    // setting the items once.
                    (async ()=>{
                        if (typeof fastAndSlowPicks.mergeDelay === "number") {
                            await (0, _asyncJs.timeout)(fastAndSlowPicks.mergeDelay);
                            if (picksToken.isCancellationRequested) return;
                        }
                        if (!slowPicksApplied) fastPicksApplied = applyPicks(fastAndSlowPicks.picks, true);
                    })(),
                    // Slow Picks: we await the slow picks and then set them at
                    // once together with the fast picks, but only if we actually
                    // have additional results.
                    (async ()=>{
                        picker.busy = true;
                        try {
                            const awaitedAdditionalPicks = await fastAndSlowPicks.additionalPicks;
                            if (picksToken.isCancellationRequested) return;
                            let picks;
                            let activePick = undefined;
                            if (isPicksWithActive(fastAndSlowPicks.picks)) {
                                picks = fastAndSlowPicks.picks.items;
                                activePick = fastAndSlowPicks.picks.active;
                            } else picks = fastAndSlowPicks.picks;
                            let additionalPicks;
                            let additionalActivePick = undefined;
                            if (isPicksWithActive(awaitedAdditionalPicks)) {
                                additionalPicks = awaitedAdditionalPicks.items;
                                additionalActivePick = awaitedAdditionalPicks.active;
                            } else additionalPicks = awaitedAdditionalPicks;
                            if (additionalPicks.length > 0 || !fastPicksApplied) {
                                // If we do not have any activePick or additionalActivePick
                                // we try to preserve the currently active pick from the
                                // fast results. This fixes an issue where the user might
                                // have made a pick active before the additional results
                                // kick in.
                                // See https://github.com/microsoft/vscode/issues/102480
                                let fallbackActivePick = undefined;
                                if (!activePick && !additionalActivePick) {
                                    const fallbackActivePickCandidate = picker.activeItems[0];
                                    if (fallbackActivePickCandidate && picks.indexOf(fallbackActivePickCandidate) !== -1) fallbackActivePick = fallbackActivePickCandidate;
                                }
                                applyPicks({
                                    items: [
                                        ...picks,
                                        ...additionalPicks
                                    ],
                                    active: activePick || additionalActivePick || fallbackActivePick
                                });
                            }
                        } finally{
                            if (!picksToken.isCancellationRequested) picker.busy = false;
                            slowPicksApplied = true;
                        }
                    })()
                ]);
            };
            // No Picks
            if (providedPicks === null) ;
            else if (isFastAndSlowPicks(providedPicks)) await applyFastAndSlowPicks(providedPicks);
            else if (!(providedPicks instanceof Promise)) applyPicks(providedPicks);
            else {
                picker.busy = true;
                try {
                    const awaitedPicks = await providedPicks;
                    if (picksToken.isCancellationRequested) return;
                    if (isFastAndSlowPicks(awaitedPicks)) await applyFastAndSlowPicks(awaitedPicks);
                    else applyPicks(awaitedPicks);
                } finally{
                    if (!picksToken.isCancellationRequested) picker.busy = false;
                }
            }
        };
        disposables.add(picker.onDidChangeValue(()=>updatePickerItems()));
        updatePickerItems();
        // Accept the pick on accept and hide picker
        disposables.add(picker.onDidAccept((event)=>{
            if (runOptions?.handleAccept) {
                if (!event.inBackground) picker.hide(); // hide picker unless we accept in background
                runOptions.handleAccept?.(picker.activeItems[0]);
                return;
            }
            const [item] = picker.selectedItems;
            if (typeof item?.accept === "function") {
                if (!event.inBackground) picker.hide(); // hide picker unless we accept in background
                item.accept(picker.keyMods, event);
            }
        }));
        const buttonTrigger = async (button, item)=>{
            if (typeof item.trigger !== "function") return;
            const buttonIndex = item.buttons?.indexOf(button) ?? -1;
            if (buttonIndex >= 0) {
                const result = item.trigger(buttonIndex, picker.keyMods);
                const action = typeof result === "number" ? result : await result;
                if (token.isCancellationRequested) return;
                switch(action){
                    case TriggerAction.NO_ACTION:
                        break;
                    case TriggerAction.CLOSE_PICKER:
                        picker.hide();
                        break;
                    case TriggerAction.REFRESH_PICKER:
                        updatePickerItems();
                        break;
                    case TriggerAction.REMOVE_ITEM:
                        {
                            const index = picker.items.indexOf(item);
                            if (index !== -1) {
                                const items = picker.items.slice();
                                const removed = items.splice(index, 1);
                                const activeItems = picker.activeItems.filter((activeItem)=>activeItem !== removed[0]);
                                const keepScrollPositionBefore = picker.keepScrollPosition;
                                picker.keepScrollPosition = true;
                                picker.items = items;
                                if (activeItems) picker.activeItems = activeItems;
                                picker.keepScrollPosition = keepScrollPositionBefore;
                            }
                            break;
                        }
                }
            }
        };
        // Trigger the pick with button index if button triggered
        disposables.add(picker.onDidTriggerItemButton(({ button, item })=>buttonTrigger(button, item)));
        disposables.add(picker.onDidTriggerSeparatorButton(({ button, separator })=>buttonTrigger(button, separator)));
        return disposables;
    }
}

},{"../../../base/common/async.js":"4GJc4","../../../base/common/cancellation.js":"hoVxw","../../../base/common/lifecycle.js":"9kg8d","../../../base/common/types.js":"fb5yx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fLfR5":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandaloneReferencesController", ()=>StandaloneReferencesController);
var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _codeEditorServiceJs = require("../../../browser/services/codeEditorService.js");
var _referencesControllerJs = require("../../../contrib/gotoSymbol/browser/peek/referencesController.js");
var _configurationJs = require("../../../../platform/configuration/common/configuration.js");
var _contextkeyJs = require("../../../../platform/contextkey/common/contextkey.js");
var _instantiationJs = require("../../../../platform/instantiation/common/instantiation.js");
var _notificationJs = require("../../../../platform/notification/common/notification.js");
var _storageJs = require("../../../../platform/storage/common/storage.js");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = undefined && undefined.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
let StandaloneReferencesController = class StandaloneReferencesController extends (0, _referencesControllerJs.ReferencesController) {
    constructor(editor, contextKeyService, editorService, notificationService, instantiationService, storageService, configurationService){
        super(true, editor, contextKeyService, editorService, notificationService, instantiationService, storageService, configurationService);
    }
};
StandaloneReferencesController = __decorate([
    __param(1, (0, _contextkeyJs.IContextKeyService)),
    __param(2, (0, _codeEditorServiceJs.ICodeEditorService)),
    __param(3, (0, _notificationJs.INotificationService)),
    __param(4, (0, _instantiationJs.IInstantiationService)),
    __param(5, (0, _storageJs.IStorageService)),
    __param(6, (0, _configurationJs.IConfigurationService))
], StandaloneReferencesController);
(0, _editorExtensionsJs.registerEditorContribution)((0, _referencesControllerJs.ReferencesController).ID, StandaloneReferencesController, 4 /* EditorContributionInstantiation.Lazy */ );

},{"../../../browser/editorExtensions.js":"kC3w6","../../../browser/services/codeEditorService.js":"bOWtl","../../../contrib/gotoSymbol/browser/peek/referencesController.js":"1Zi9g","../../../../platform/configuration/common/configuration.js":"dXkjq","../../../../platform/contextkey/common/contextkey.js":"gXuBD","../../../../platform/instantiation/common/instantiation.js":"fjwWx","../../../../platform/notification/common/notification.js":"igv0W","../../../../platform/storage/common/storage.js":"6AhR2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4HxxH":[function(require,module,exports) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var _editorExtensionsJs = require("../../../browser/editorExtensions.js");
var _standaloneThemeJs = require("../../common/standaloneTheme.js");
var _standaloneStringsJs = require("../../../common/standaloneStrings.js");
var _themeJs = require("../../../../platform/theme/common/theme.js");
var _standaloneThemeServiceJs = require("../standaloneThemeService.js");
class ToggleHighContrast extends (0, _editorExtensionsJs.EditorAction) {
    constructor(){
        super({
            id: "editor.action.toggleHighContrast",
            label: (0, _standaloneStringsJs.ToggleHighContrastNLS).toggleHighContrast,
            alias: "Toggle High Contrast Theme",
            precondition: undefined
        });
        this._originalThemeName = null;
    }
    run(accessor, editor) {
        const standaloneThemeService = accessor.get((0, _standaloneThemeJs.IStandaloneThemeService));
        const currentTheme = standaloneThemeService.getColorTheme();
        if ((0, _themeJs.isHighContrast)(currentTheme.type)) {
            // We must toggle back to the integrator's theme
            standaloneThemeService.setTheme(this._originalThemeName || ((0, _themeJs.isDark)(currentTheme.type) ? (0, _standaloneThemeServiceJs.VS_DARK_THEME_NAME) : (0, _standaloneThemeServiceJs.VS_LIGHT_THEME_NAME)));
            this._originalThemeName = null;
        } else {
            standaloneThemeService.setTheme((0, _themeJs.isDark)(currentTheme.type) ? (0, _standaloneThemeServiceJs.HC_BLACK_THEME_NAME) : (0, _standaloneThemeServiceJs.HC_LIGHT_THEME_NAME));
            this._originalThemeName = currentTheme.themeName;
        }
    }
}
(0, _editorExtensionsJs.registerEditorAction)(ToggleHighContrast);

},{"../../../browser/editorExtensions.js":"kC3w6","../../common/standaloneTheme.js":"exW2E","../../../common/standaloneStrings.js":"D35dK","../../../../platform/theme/common/theme.js":"gh7Zf","../standaloneThemeService.js":"kMN9g"}],"z2COH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleAuth", ()=>GoogleAuth);
parcelHelpers.export(exports, "GoogleAuthToken", ()=>GoogleAuthToken);
parcelHelpers.export(exports, "googleAuth", ()=>googleAuth);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _utils = require("../utils");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
const PDQ_GOOGLE_STORAGE_KEY = "pdq-google-" + location.host;
const GOOGLE_GIS_URI = "https://accounts.google.com/gsi/client";
let __gis = undefined;
const log = (0, _debugDefault.default)("pdq:google:GoogleAuth");
class GoogleAuth {
    constructor(){
        this.loggedIn = new (0, _rxjs.BehaviorSubject)(false);
        this.tokenClient = new (0, _rxjs.BehaviorSubject)(undefined);
        this.token = new (0, _rxjs.BehaviorSubject)(new GoogleAuthToken(this.tokenClient));
        this.unsub = (0, _rxjs.Subscription).EMPTY;
        this.unsub = this.token.pipe((0, _operators.switchMap)((i)=>i.loggedIn)).subscribe((i)=>{
            log(`loggedIn changed to ${i}`);
            this.loggedIn.next(i);
            if (i) document.body.classList.add("pdq-google-logged-in");
            else document.body.classList.remove("pdq-google-logged-in");
        });
    }
    async getGIS() {
        if (!__gis) {
            const gisSoon = (0, _utils.defer)();
            const script = document.createElement("script");
            script.src = GOOGLE_GIS_URI;
            script.async = true;
            script.defer = true;
            script.onload = ()=>{
                __gis = window.google;
                gisSoon.resolve(__gis);
            };
            script.onerror = (e)=>{
                gisSoon.reject(e);
            };
            document.head.appendChild(script);
            await gisSoon.promise;
        }
        return __gis;
    }
    async setupAndLogin(clientId, scopes, attemptAutoLogin) {
        log(`setupAndLogin: ${clientId} ${scopes}`);
        const token = this.token.value;
        const gsi = await this.getGIS();
        if (!token.isLoginRequired(clientId, scopes)) {
            log("login not required...");
            return;
        }
        token.init(clientId, scopes);
        const tokenClient = gsi.accounts.oauth2.initTokenClient({
            client_id: token.clientId,
            scope: token.scope,
            callback: (response)=>{
                token.handleResponse(response, this.fetchUserDetails);
                this.token.next(token);
            },
            error_callback: (error)=>{
                log(`google auth error, ${error}`);
            }
        });
        this.tokenClient.next(tokenClient);
        this.token.next(token);
        if (attemptAutoLogin) {
            log("attempting auto log in");
            tokenClient.requestAccessToken();
        }
    }
    async fetchUserDetails(accessToken) {
        const response = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        const userDetails = await response.json();
        return userDetails;
    }
    async login() {
        const oathClient = this.tokenClient.value;
        if (oathClient) {
            log("login requested - tokenClient invited, requesting accessToken");
            return oathClient.requestAccessToken();
        }
        log("login requested - tokenClient is not in-place, calling setupAndLogin");
        const token = this.token.value;
        await this.setupAndLogin(token.clientId, token.scopes, true);
    }
    async getToken(resp) {
        log("google getToken()", resp);
        const err = resp.result;
        if (err.error?.code != 401 && err.error?.code != 403) {
            debugger;
            throw new Error(`Google API errror. ${err.error?.code} ${err.error?.message}`);
        }
        return this.token.value?.access_token;
    }
    async logout() {
        log("logout");
        const token = this.token.value;
        if (token.loggedIn.value) {
            const gis = await this.getGIS();
            gis.accounts.oauth2.revoke(token.access_token, token.loggedOut);
        }
    }
    async setToken(gapi) {
        let token = this.token.value;
        if (!token?.loggedIn.value) {
            log("setToken... waiting for valid token");
            await (0, _rxjs.firstValueFrom)(this.loggedIn.pipe((0, _rxjs.filter)((i)=>i), (0, _rxjs.first)(), (0, _rxjs.delay)(100)));
        }
        log("setToken... access_token available, setting on gapis");
        gapi.client.setToken({
            access_token: token.access_token
        });
    }
}
const atlog = (0, _debugDefault.default)("pdq:google:GoogleAuthToken");
class GoogleAuthToken {
    get scopes() {
        return this.scope.split(" ");
    }
    constructor(tokenClient){
        this.tokenClient = tokenClient;
        this.loggedIn = new (0, _rxjs.BehaviorSubject)(false);
        this.clientId = "";
        this.access_token = "";
        this.authuser = "";
        this.expires_in = 0;
        this.expires_at = new Date(1970, 0, 1);
        this.hd = "";
        this.prompt = "";
        this.scope = "";
        this.token_type = "";
        this.user = undefined;
        this.loggedOut = ()=>{
            atlog("logged out");
            this.init(this.clientId, this.scopes);
            this.save();
        };
        this.loggedIn.subscribe((i)=>atlog(`loggedIn=${i}`));
        this.load();
    }
    init(clientId, scopes) {
        atlog(`init`);
        this.clientId = clientId;
        this.access_token = "";
        this.authuser = "";
        this.expires_in = 0;
        this.expires_at = new Date(1970, 0, 1);
        this.hd = "";
        this.prompt = "";
        this.scope = this.getNormalizedScopes(scopes);
        this.token_type = "";
        this.updateIsLoggedIn();
    }
    load() {
        const storedToken = localStorage.getItem(PDQ_GOOGLE_STORAGE_KEY);
        if (!storedToken) {
            atlog("no stored token");
            this.updateIsLoggedIn();
            return;
        }
        try {
            const v = JSON.parse(atob(storedToken));
            if (v.access_token) {
                this.access_token = v.access_token;
                this.expires_in = parseInt(v.expires_in);
                this.expires_at = new Date(v.expires_at);
                this.clientId = v.client_id;
                this.authuser = v.authuser;
                this.hd = v.hd;
                this.prompt = v.prompt;
                this.scope = this.getNormalizedScopes(v.scope.split(" "));
                this.token_type = v.token_type;
                this.user = v.user;
            }
            atlog("loaded stored token, expires at", this.expires_at);
        } catch (e) {
            atlog("failed to parse stored token");
        }
        this.updateIsLoggedIn();
    }
    save() {
        const storedToken = {
            access_token: this.access_token,
            expires_in: this.expires_in,
            expires_at: this.expires_at,
            client_id: this.clientId,
            authuser: this.authuser,
            hd: this.hd,
            prompt: this.prompt,
            scope: this.getNormalizedScopes(this.scope.split(" ")),
            token_type: this.token_type,
            user: this.user
        };
        localStorage.setItem(PDQ_GOOGLE_STORAGE_KEY, btoa(JSON.stringify(storedToken)));
        atlog("saved token");
    }
    async handleResponse(response, fetchUserDetails) {
        if (!response.access_token) {
            atlog(`no access token in response`);
            this.updateIsLoggedIn();
            return;
        }
        this.access_token = response.access_token;
        this.expires_in = response.expires_in;
        this.expires_at = new Date(Date.now() + response.expires_in * 1000);
        this.authuser = response.authuser;
        this.hd = response.hd;
        this.prompt = response.prompt;
        this.token_type = response.token_type;
        atlog("updating user details");
        this.user = await fetchUserDetails(response.access_token);
        this.save();
        this.updateIsLoggedIn();
        setTimeout(()=>{
            atlog("token timeout");
            const client = this.tokenClient.value;
            if (client) {
                atlog("auto requesting access token");
                this.tokenClient.value?.requestAccessToken();
            } else {
                atlog("token expired, click is required to init login, so logging out");
                this.init(this.clientId, this.scopes);
            }
        }, this.expires_in * 1000 - 3000);
        atlog(`login success, expires at ${this.expires_at}`);
    }
    isLoginRequired(clientId, scopes) {
        atlog("isLoginRequired");
        if (!this.loggedIn.value) return true;
        if (this.clientId != clientId) return true;
        if (!this.doNormalizedScopesMatch(scopes)) return true;
        return false;
    }
    updateIsLoggedIn() {
        this.loggedIn.next(!!this.access_token && this.expires_at > new Date());
    }
    doNormalizedScopesMatch(scopes) {
        const nScopes = this.getNormalizedScopes(scopes);
        return nScopes === this.scope;
    }
    getNormalizedScopes(scopes) {
        const scopesSet = new Set([
            "https://www.googleapis.com/auth/userinfo.profile",
            "https://www.googleapis.com/auth/userinfo.email",
            ...scopes.map((i)=>i.trim())
        ]);
        return [
            ...scopesSet
        ].join(" ");
    }
}
const googleAuth = new GoogleAuth();

},{"debug":"17JIf","../utils":"i8jxn","rxjs":"d4Szo","rxjs/operators":"eR1yJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eR1yJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>(0, _audit.audit));
parcelHelpers.export(exports, "auditTime", ()=>(0, _auditTime.auditTime));
parcelHelpers.export(exports, "buffer", ()=>(0, _buffer.buffer));
parcelHelpers.export(exports, "bufferCount", ()=>(0, _bufferCount.bufferCount));
parcelHelpers.export(exports, "bufferTime", ()=>(0, _bufferTime.bufferTime));
parcelHelpers.export(exports, "bufferToggle", ()=>(0, _bufferToggle.bufferToggle));
parcelHelpers.export(exports, "bufferWhen", ()=>(0, _bufferWhen.bufferWhen));
parcelHelpers.export(exports, "catchError", ()=>(0, _catchError.catchError));
parcelHelpers.export(exports, "combineAll", ()=>(0, _combineAll.combineAll));
parcelHelpers.export(exports, "combineLatestAll", ()=>(0, _combineLatestAll.combineLatestAll));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "combineLatestWith", ()=>(0, _combineLatestWith.combineLatestWith));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "concatAll", ()=>(0, _concatAll.concatAll));
parcelHelpers.export(exports, "concatMap", ()=>(0, _concatMap.concatMap));
parcelHelpers.export(exports, "concatMapTo", ()=>(0, _concatMapTo.concatMapTo));
parcelHelpers.export(exports, "concatWith", ()=>(0, _concatWith.concatWith));
parcelHelpers.export(exports, "connect", ()=>(0, _connect.connect));
parcelHelpers.export(exports, "count", ()=>(0, _count.count));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounce.debounce));
parcelHelpers.export(exports, "debounceTime", ()=>(0, _debounceTime.debounceTime));
parcelHelpers.export(exports, "defaultIfEmpty", ()=>(0, _defaultIfEmpty.defaultIfEmpty));
parcelHelpers.export(exports, "delay", ()=>(0, _delay.delay));
parcelHelpers.export(exports, "delayWhen", ()=>(0, _delayWhen.delayWhen));
parcelHelpers.export(exports, "dematerialize", ()=>(0, _dematerialize.dematerialize));
parcelHelpers.export(exports, "distinct", ()=>(0, _distinct.distinct));
parcelHelpers.export(exports, "distinctUntilChanged", ()=>(0, _distinctUntilChanged.distinctUntilChanged));
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>(0, _distinctUntilKeyChanged.distinctUntilKeyChanged));
parcelHelpers.export(exports, "elementAt", ()=>(0, _elementAt.elementAt));
parcelHelpers.export(exports, "endWith", ()=>(0, _endWith.endWith));
parcelHelpers.export(exports, "every", ()=>(0, _every.every));
parcelHelpers.export(exports, "exhaust", ()=>(0, _exhaust.exhaust));
parcelHelpers.export(exports, "exhaustAll", ()=>(0, _exhaustAll.exhaustAll));
parcelHelpers.export(exports, "exhaustMap", ()=>(0, _exhaustMap.exhaustMap));
parcelHelpers.export(exports, "expand", ()=>(0, _expand.expand));
parcelHelpers.export(exports, "filter", ()=>(0, _filter.filter));
parcelHelpers.export(exports, "finalize", ()=>(0, _finalize.finalize));
parcelHelpers.export(exports, "find", ()=>(0, _find.find));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndex.findIndex));
parcelHelpers.export(exports, "first", ()=>(0, _first.first));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupBy.groupBy));
parcelHelpers.export(exports, "ignoreElements", ()=>(0, _ignoreElements.ignoreElements));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmpty.isEmpty));
parcelHelpers.export(exports, "last", ()=>(0, _last.last));
parcelHelpers.export(exports, "map", ()=>(0, _map.map));
parcelHelpers.export(exports, "mapTo", ()=>(0, _mapTo.mapTo));
parcelHelpers.export(exports, "materialize", ()=>(0, _materialize.materialize));
parcelHelpers.export(exports, "max", ()=>(0, _max.max));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAll.mergeAll));
parcelHelpers.export(exports, "flatMap", ()=>(0, _flatMap.flatMap));
parcelHelpers.export(exports, "mergeMap", ()=>(0, _mergeMap.mergeMap));
parcelHelpers.export(exports, "mergeMapTo", ()=>(0, _mergeMapTo.mergeMapTo));
parcelHelpers.export(exports, "mergeScan", ()=>(0, _mergeScan.mergeScan));
parcelHelpers.export(exports, "mergeWith", ()=>(0, _mergeWith.mergeWith));
parcelHelpers.export(exports, "min", ()=>(0, _min.min));
parcelHelpers.export(exports, "multicast", ()=>(0, _multicast.multicast));
parcelHelpers.export(exports, "observeOn", ()=>(0, _observeOn.observeOn));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNextWith.onErrorResumeNext));
parcelHelpers.export(exports, "pairwise", ()=>(0, _pairwise.pairwise));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluck.pluck));
parcelHelpers.export(exports, "publish", ()=>(0, _publish.publish));
parcelHelpers.export(exports, "publishBehavior", ()=>(0, _publishBehavior.publishBehavior));
parcelHelpers.export(exports, "publishLast", ()=>(0, _publishLast.publishLast));
parcelHelpers.export(exports, "publishReplay", ()=>(0, _publishReplay.publishReplay));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "raceWith", ()=>(0, _raceWith.raceWith));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduce.reduce));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeat.repeat));
parcelHelpers.export(exports, "repeatWhen", ()=>(0, _repeatWhen.repeatWhen));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "retryWhen", ()=>(0, _retryWhen.retryWhen));
parcelHelpers.export(exports, "refCount", ()=>(0, _refCount.refCount));
parcelHelpers.export(exports, "sample", ()=>(0, _sample.sample));
parcelHelpers.export(exports, "sampleTime", ()=>(0, _sampleTime.sampleTime));
parcelHelpers.export(exports, "scan", ()=>(0, _scan.scan));
parcelHelpers.export(exports, "sequenceEqual", ()=>(0, _sequenceEqual.sequenceEqual));
parcelHelpers.export(exports, "share", ()=>(0, _share.share));
parcelHelpers.export(exports, "shareReplay", ()=>(0, _shareReplay.shareReplay));
parcelHelpers.export(exports, "single", ()=>(0, _single.single));
parcelHelpers.export(exports, "skip", ()=>(0, _skip.skip));
parcelHelpers.export(exports, "skipLast", ()=>(0, _skipLast.skipLast));
parcelHelpers.export(exports, "skipUntil", ()=>(0, _skipUntil.skipUntil));
parcelHelpers.export(exports, "skipWhile", ()=>(0, _skipWhile.skipWhile));
parcelHelpers.export(exports, "startWith", ()=>(0, _startWith.startWith));
parcelHelpers.export(exports, "subscribeOn", ()=>(0, _subscribeOn.subscribeOn));
parcelHelpers.export(exports, "switchAll", ()=>(0, _switchAll.switchAll));
parcelHelpers.export(exports, "switchMap", ()=>(0, _switchMap.switchMap));
parcelHelpers.export(exports, "switchMapTo", ()=>(0, _switchMapTo.switchMapTo));
parcelHelpers.export(exports, "switchScan", ()=>(0, _switchScan.switchScan));
parcelHelpers.export(exports, "take", ()=>(0, _take.take));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLast.takeLast));
parcelHelpers.export(exports, "takeUntil", ()=>(0, _takeUntil.takeUntil));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhile.takeWhile));
parcelHelpers.export(exports, "tap", ()=>(0, _tap.tap));
parcelHelpers.export(exports, "throttle", ()=>(0, _throttle.throttle));
parcelHelpers.export(exports, "throttleTime", ()=>(0, _throttleTime.throttleTime));
parcelHelpers.export(exports, "throwIfEmpty", ()=>(0, _throwIfEmpty.throwIfEmpty));
parcelHelpers.export(exports, "timeInterval", ()=>(0, _timeInterval.timeInterval));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeout.timeout));
parcelHelpers.export(exports, "timeoutWith", ()=>(0, _timeoutWith.timeoutWith));
parcelHelpers.export(exports, "timestamp", ()=>(0, _timestamp.timestamp));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArray.toArray));
parcelHelpers.export(exports, "window", ()=>(0, _window.window));
parcelHelpers.export(exports, "windowCount", ()=>(0, _windowCount.windowCount));
parcelHelpers.export(exports, "windowTime", ()=>(0, _windowTime.windowTime));
parcelHelpers.export(exports, "windowToggle", ()=>(0, _windowToggle.windowToggle));
parcelHelpers.export(exports, "windowWhen", ()=>(0, _windowWhen.windowWhen));
parcelHelpers.export(exports, "withLatestFrom", ()=>(0, _withLatestFrom.withLatestFrom));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "zipAll", ()=>(0, _zipAll.zipAll));
parcelHelpers.export(exports, "zipWith", ()=>(0, _zipWith.zipWith));
var _audit = require("../internal/operators/audit");
var _auditTime = require("../internal/operators/auditTime");
var _buffer = require("../internal/operators/buffer");
var _bufferCount = require("../internal/operators/bufferCount");
var _bufferTime = require("../internal/operators/bufferTime");
var _bufferToggle = require("../internal/operators/bufferToggle");
var _bufferWhen = require("../internal/operators/bufferWhen");
var _catchError = require("../internal/operators/catchError");
var _combineAll = require("../internal/operators/combineAll");
var _combineLatestAll = require("../internal/operators/combineLatestAll");
var _combineLatest = require("../internal/operators/combineLatest");
var _combineLatestWith = require("../internal/operators/combineLatestWith");
var _concat = require("../internal/operators/concat");
var _concatAll = require("../internal/operators/concatAll");
var _concatMap = require("../internal/operators/concatMap");
var _concatMapTo = require("../internal/operators/concatMapTo");
var _concatWith = require("../internal/operators/concatWith");
var _connect = require("../internal/operators/connect");
var _count = require("../internal/operators/count");
var _debounce = require("../internal/operators/debounce");
var _debounceTime = require("../internal/operators/debounceTime");
var _defaultIfEmpty = require("../internal/operators/defaultIfEmpty");
var _delay = require("../internal/operators/delay");
var _delayWhen = require("../internal/operators/delayWhen");
var _dematerialize = require("../internal/operators/dematerialize");
var _distinct = require("../internal/operators/distinct");
var _distinctUntilChanged = require("../internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("../internal/operators/distinctUntilKeyChanged");
var _elementAt = require("../internal/operators/elementAt");
var _endWith = require("../internal/operators/endWith");
var _every = require("../internal/operators/every");
var _exhaust = require("../internal/operators/exhaust");
var _exhaustAll = require("../internal/operators/exhaustAll");
var _exhaustMap = require("../internal/operators/exhaustMap");
var _expand = require("../internal/operators/expand");
var _filter = require("../internal/operators/filter");
var _finalize = require("../internal/operators/finalize");
var _find = require("../internal/operators/find");
var _findIndex = require("../internal/operators/findIndex");
var _first = require("../internal/operators/first");
var _groupBy = require("../internal/operators/groupBy");
var _ignoreElements = require("../internal/operators/ignoreElements");
var _isEmpty = require("../internal/operators/isEmpty");
var _last = require("../internal/operators/last");
var _map = require("../internal/operators/map");
var _mapTo = require("../internal/operators/mapTo");
var _materialize = require("../internal/operators/materialize");
var _max = require("../internal/operators/max");
var _merge = require("../internal/operators/merge");
var _mergeAll = require("../internal/operators/mergeAll");
var _flatMap = require("../internal/operators/flatMap");
var _mergeMap = require("../internal/operators/mergeMap");
var _mergeMapTo = require("../internal/operators/mergeMapTo");
var _mergeScan = require("../internal/operators/mergeScan");
var _mergeWith = require("../internal/operators/mergeWith");
var _min = require("../internal/operators/min");
var _multicast = require("../internal/operators/multicast");
var _observeOn = require("../internal/operators/observeOn");
var _onErrorResumeNextWith = require("../internal/operators/onErrorResumeNextWith");
var _pairwise = require("../internal/operators/pairwise");
var _partition = require("../internal/operators/partition");
var _pluck = require("../internal/operators/pluck");
var _publish = require("../internal/operators/publish");
var _publishBehavior = require("../internal/operators/publishBehavior");
var _publishLast = require("../internal/operators/publishLast");
var _publishReplay = require("../internal/operators/publishReplay");
var _race = require("../internal/operators/race");
var _raceWith = require("../internal/operators/raceWith");
var _reduce = require("../internal/operators/reduce");
var _repeat = require("../internal/operators/repeat");
var _repeatWhen = require("../internal/operators/repeatWhen");
var _retry = require("../internal/operators/retry");
var _retryWhen = require("../internal/operators/retryWhen");
var _refCount = require("../internal/operators/refCount");
var _sample = require("../internal/operators/sample");
var _sampleTime = require("../internal/operators/sampleTime");
var _scan = require("../internal/operators/scan");
var _sequenceEqual = require("../internal/operators/sequenceEqual");
var _share = require("../internal/operators/share");
var _shareReplay = require("../internal/operators/shareReplay");
var _single = require("../internal/operators/single");
var _skip = require("../internal/operators/skip");
var _skipLast = require("../internal/operators/skipLast");
var _skipUntil = require("../internal/operators/skipUntil");
var _skipWhile = require("../internal/operators/skipWhile");
var _startWith = require("../internal/operators/startWith");
var _subscribeOn = require("../internal/operators/subscribeOn");
var _switchAll = require("../internal/operators/switchAll");
var _switchMap = require("../internal/operators/switchMap");
var _switchMapTo = require("../internal/operators/switchMapTo");
var _switchScan = require("../internal/operators/switchScan");
var _take = require("../internal/operators/take");
var _takeLast = require("../internal/operators/takeLast");
var _takeUntil = require("../internal/operators/takeUntil");
var _takeWhile = require("../internal/operators/takeWhile");
var _tap = require("../internal/operators/tap");
var _throttle = require("../internal/operators/throttle");
var _throttleTime = require("../internal/operators/throttleTime");
var _throwIfEmpty = require("../internal/operators/throwIfEmpty");
var _timeInterval = require("../internal/operators/timeInterval");
var _timeout = require("../internal/operators/timeout");
var _timeoutWith = require("../internal/operators/timeoutWith");
var _timestamp = require("../internal/operators/timestamp");
var _toArray = require("../internal/operators/toArray");
var _window = require("../internal/operators/window");
var _windowCount = require("../internal/operators/windowCount");
var _windowTime = require("../internal/operators/windowTime");
var _windowToggle = require("../internal/operators/windowToggle");
var _windowWhen = require("../internal/operators/windowWhen");
var _withLatestFrom = require("../internal/operators/withLatestFrom");
var _zip = require("../internal/operators/zip");
var _zipAll = require("../internal/operators/zipAll");
var _zipWith = require("../internal/operators/zipWith");

},{"../internal/operators/audit":false,"../internal/operators/auditTime":false,"../internal/operators/buffer":false,"../internal/operators/bufferCount":false,"../internal/operators/bufferTime":false,"../internal/operators/bufferToggle":false,"../internal/operators/bufferWhen":false,"../internal/operators/catchError":false,"../internal/operators/combineAll":false,"../internal/operators/combineLatestAll":false,"../internal/operators/combineLatest":false,"../internal/operators/combineLatestWith":false,"../internal/operators/concat":false,"../internal/operators/concatAll":false,"../internal/operators/concatMap":false,"../internal/operators/concatMapTo":false,"../internal/operators/concatWith":false,"../internal/operators/connect":false,"../internal/operators/count":false,"../internal/operators/debounce":false,"../internal/operators/debounceTime":false,"../internal/operators/defaultIfEmpty":false,"../internal/operators/delay":false,"../internal/operators/delayWhen":false,"../internal/operators/dematerialize":false,"../internal/operators/distinct":false,"../internal/operators/distinctUntilChanged":false,"../internal/operators/distinctUntilKeyChanged":false,"../internal/operators/elementAt":false,"../internal/operators/endWith":false,"../internal/operators/every":false,"../internal/operators/exhaust":false,"../internal/operators/exhaustAll":false,"../internal/operators/exhaustMap":false,"../internal/operators/expand":false,"../internal/operators/filter":false,"../internal/operators/finalize":false,"../internal/operators/find":false,"../internal/operators/findIndex":false,"../internal/operators/first":false,"../internal/operators/groupBy":false,"../internal/operators/ignoreElements":false,"../internal/operators/isEmpty":false,"../internal/operators/last":false,"../internal/operators/map":false,"../internal/operators/mapTo":false,"../internal/operators/materialize":false,"../internal/operators/max":false,"../internal/operators/merge":false,"../internal/operators/mergeAll":false,"../internal/operators/flatMap":false,"../internal/operators/mergeMap":false,"../internal/operators/mergeMapTo":false,"../internal/operators/mergeScan":false,"../internal/operators/mergeWith":false,"../internal/operators/min":false,"../internal/operators/multicast":false,"../internal/operators/observeOn":false,"../internal/operators/onErrorResumeNextWith":false,"../internal/operators/pairwise":false,"../internal/operators/partition":false,"../internal/operators/pluck":false,"../internal/operators/publish":false,"../internal/operators/publishBehavior":false,"../internal/operators/publishLast":false,"../internal/operators/publishReplay":false,"../internal/operators/race":false,"../internal/operators/raceWith":false,"../internal/operators/reduce":false,"../internal/operators/repeat":false,"../internal/operators/repeatWhen":false,"../internal/operators/retry":false,"../internal/operators/retryWhen":false,"../internal/operators/refCount":false,"../internal/operators/sample":false,"../internal/operators/sampleTime":false,"../internal/operators/scan":false,"../internal/operators/sequenceEqual":false,"../internal/operators/share":false,"../internal/operators/shareReplay":false,"../internal/operators/single":false,"../internal/operators/skip":false,"../internal/operators/skipLast":false,"../internal/operators/skipUntil":false,"../internal/operators/skipWhile":false,"../internal/operators/startWith":false,"../internal/operators/subscribeOn":false,"../internal/operators/switchAll":false,"../internal/operators/switchMap":"93G5G","../internal/operators/switchMapTo":false,"../internal/operators/switchScan":false,"../internal/operators/take":false,"../internal/operators/takeLast":false,"../internal/operators/takeUntil":false,"../internal/operators/takeWhile":false,"../internal/operators/tap":false,"../internal/operators/throttle":false,"../internal/operators/throttleTime":false,"../internal/operators/throwIfEmpty":false,"../internal/operators/timeInterval":false,"../internal/operators/timeout":false,"../internal/operators/timeoutWith":false,"../internal/operators/timestamp":false,"../internal/operators/toArray":false,"../internal/operators/window":false,"../internal/operators/windowCount":false,"../internal/operators/windowTime":false,"../internal/operators/windowToggle":false,"../internal/operators/windowWhen":false,"../internal/operators/withLatestFrom":false,"../internal/operators/zip":false,"../internal/operators/zipAll":false,"../internal/operators/zipWith":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eOEG5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleApi", ()=>GoogleApi);
parcelHelpers.export(exports, "googleApi", ()=>googleApi);
var _replaySubject = require("../observable/ReplaySubject");
var _googleAuth = require("./googleAuth");
var _utils = require("../utils");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
const GOOGLE_GIS_URI = "https://apis.google.com/js/api.js";
let __gapi = undefined;
const log = (0, _debugDefault.default)("pdq:google:GoogleApi");
class GoogleApi {
    constructor(googleAuth){
        this.googleAuth = googleAuth;
        this.loaded = new (0, _replaySubject.ReplaySubject)(1);
    }
    async getGAPI() {
        if (__gapi) return __gapi;
        const gapiSoon = (0, _utils.defer)();
        __gapi = gapiSoon.promise;
        const script = document.createElement("script");
        script.src = GOOGLE_GIS_URI;
        script.async = true;
        script.defer = true;
        script.onload = async ()=>{
            const gapi = window.gapi;
            const d = (0, _utils.defer)();
            gapi.load("client", d.resolve);
            await d.promise;
            //;(window as any).gapi;
            gapiSoon.resolve(gapi);
            log("google api init complete");
        };
        script.onerror = gapiSoon.reject;
        document.head.appendChild(script);
        await gapiSoon.promise;
        return __gapi;
    }
    async load(services) {
        log("loading discovery apis");
        this.loaded.next(false);
        const api = await this.getGAPI();
        const promises = Promise.all(services.map((i)=>{
            const d = (0, _utils.defer)();
            api.client.load(i.service, i.version, d.resolve);
            return d.promise;
        }));
        await promises;
        this.loaded.next(true);
        log("loaded api discovery");
    }
    async listFiles(driveId, parentId, q) {
        const gapi = await this.getGAPI();
        let pageToken;
        let allFiles = [];
        const fetchFiles = async ()=>{
            const queryParams = {
                "pageSize": 100,
                "fields": "nextPageToken, files(*)",
                "corpora": driveId ? "drive" : "user",
                "includeItemsFromAllDrives": !!driveId,
                "supportsAllDrives": !!driveId,
                "pageToken": pageToken
            };
            if (driveId) queryParams["driveId"] = driveId;
            if (parentId) queryParams["q"] = `'${parentId}' in parents`;
            if (q) queryParams["q"] = q in queryParams ? `${q} and ${queryParams["q"]}` : q;
            const response = await gapi.client.drive.files.list(queryParams);
            allFiles = allFiles.concat(response.result.files);
            pageToken = response.result.nextPageToken;
            if (pageToken) await fetchFiles();
        };
        if (!this.loaded.currentValue()) {
            log("list files... waiting for loaded");
            await (0, _replaySubject.first)(this.loaded, (x)=>x);
        }
        log("getting files...");
        await this.googleAuth.setToken(gapi);
        await fetchFiles();
        return allFiles;
    }
    async listDrives() {
        const gapi = await this.getGAPI();
        let pageToken;
        let allDrives = [];
        const fetchDrives = async ()=>{
            const response = await gapi.client.drive.drives.list({
                "pageSize": 100,
                "fields": "nextPageToken, drives(*)",
                "pageToken": pageToken
            });
            allDrives = allDrives.concat(response.result.drives);
            pageToken = response.result.nextPageToken;
            if (pageToken) await fetchDrives();
        };
        log(`getting list of drives...`);
        await this.googleAuth.setToken(gapi);
        await fetchDrives();
        return allDrives;
    }
    async getFileContent(fileId, alt = "media") {
        const gapi = await this.getGAPI();
        if (!this.loaded.currentValue()) {
            log("getFileContent: waiting for loaded");
            await (0, _replaySubject.first)(this.loaded, (x)=>x);
        }
        try {
            log(`getting file ${fileId}`);
            await this.googleAuth.setToken(gapi);
            const response = await gapi.client.drive.files.get({
                fileId: fileId,
                alt: alt
            });
            log("got response...", response.status);
            if (alt == "media") {
                const arr = this.stringToArrayBuffer(response.body);
                return new Blob([
                    arr
                ], {
                    type: response.headers["Content-Type"] || "application/octet-stream"
                });
            } else return response.Body;
        } catch (e) {
            log("error getting file content", e);
            throw e;
        }
    }
    async uploadDriveFile(driveId, parentFolderId, file, fileId, properties = {}) {
        const gapi = await this.getGAPI();
        const boundary = "-------314159265358979323846";
        const delimiter = "\r\n--" + boundary + "\r\n";
        const close_delim = "\r\n--" + boundary + "--";
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        return new Promise((resolve, reject)=>{
            reader.onload = async ()=>{
                const contentType = file.type || "application/octet-stream";
                const metadata = {
                    "name": file.name,
                    "mimeType": contentType,
                    "parents": parentFolderId && !fileId ? [
                        parentFolderId
                    ] : [],
                    "properties": properties
                };
                const base64Data = btoa(reader.result);
                const multipartRequestBody = delimiter + "Content-Type: application/json\r\n\r\n" + JSON.stringify(metadata) + delimiter + "Content-Type: " + contentType + "\r\n" + "Content-Transfer-Encoding: base64\r\n" + "\r\n" + base64Data + close_delim;
                let path;
                let method;
                if (fileId) {
                    path = `/upload/drive/v3/files/${fileId}?uploadType=multipart`;
                    method = "PATCH"; // Use PATCH to update the existing file
                } else {
                    path = driveId ? `/upload/drive/v3/files?driveId=${driveId}&uploadType=multipart` : "/upload/drive/v3/files?uploadType=multipart";
                    method = "POST";
                }
                try {
                    log(`sending request [${method}]${path} ...`);
                    await this.googleAuth.setToken(gapi);
                    const response = await gapi.client.request({
                        "path": path,
                        "method": method,
                        "headers": {
                            "Content-Type": 'multipart/related; boundary="' + boundary + '"'
                        },
                        "body": multipartRequestBody
                    });
                    resolve(response.result);
                } catch (error) {
                    reject(error);
                }
            };
        });
    }
    async getSheetRange(spreadsheetId, range) {
        const gapi = await this.getGAPI();
        log(`getting sheet range ${spreadsheetId} ${range}...`);
        await this.googleAuth.setToken(gapi);
        const response = await gapi.client.sheets.spreadsheets.values.get({
            spreadsheetId: spreadsheetId,
            range: range
        });
        return response.result;
    }
    async writeSheetRange(spreadsheetId, range, values) {
        const gapi = await this.getGAPI();
        log(`writing sheet range ${spreadsheetId} ${range}...`);
        await this.googleAuth.setToken(gapi);
        const response = await gapi.client.sheets.spreadsheets.values.append({
            spreadsheetId: spreadsheetId,
            range: range,
            valueInputOption: "RAW",
            insertDataOption: "INSERT_ROWS",
            resource: {
                values: values
            }
        });
        return response.result;
    }
    stringToArrayBuffer(str) {
        const buf = new ArrayBuffer(str.length);
        const bufView = new Uint8Array(buf);
        for(let i = 0; i < str.length; i++)bufView[i] = str.charCodeAt(i);
        return buf;
    }
}
const googleApi = new GoogleApi((0, _googleAuth.googleAuth));

},{"../observable/ReplaySubject":"k5r8V","./googleAuth":"z2COH","../utils":"i8jxn","debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hZ6Xd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqGoogleAuthElement", ()=>PdqGoogleAuthElement);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _modal = require("@carbon/web-components/es/components/modal");
var _googleAuth = require("./googleAuth");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:google:pdq-google-auth");
let PdqGoogleAuthElement = class PdqGoogleAuthElement extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.clientId = "";
        this.scopes = "";
        this.attemptAutoLogin = false;
        this.lastLoginKey = "";
    }
    render() {
        return 0, _lit.nothing;
    }
    updated(changedProperties) {
        log("updated");
        this.updateLoginIfNeeded();
    }
    firstUpdated() {
        log("firstUpdated");
        this.updateLoginIfNeeded();
    }
    updateLoginIfNeeded() {
        log("updateLoginIfNeeded", this.clientId && this.scopes, this.clientId, this.scopes);
        if (this.clientId && this.scopes) {
            const loginKey = this.clientId + this.scopes;
            if (this.lastLoginKey === loginKey) return;
            this.lastLoginKey = loginKey;
            log("calling setupAndLogin");
            (0, _googleAuth.googleAuth).setupAndLogin(this.clientId, this.scopes.split(",").map((i)=>i.trim()), this.attemptAutoLogin);
        }
    }
};
PdqGoogleAuthElement.styles = (0, _lit.css)``;
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqGoogleAuthElement.prototype, "clientId", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqGoogleAuthElement.prototype, "scopes", void 0);
__decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    __metadata("design:type", Object)
], PdqGoogleAuthElement.prototype, "attemptAutoLogin", void 0);
PdqGoogleAuthElement = __decorate([
    (0, _decorators.customElement)("pdq-google-auth")
], PdqGoogleAuthElement);

},{"lit/decorators":"kQrIl","lit":"aCmte","@carbon/web-components/es/components/modal":"6x6o7","./googleAuth":"z2COH","debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jUQn4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleIdentityBadge", ()=>GoogleIdentityBadge);
parcelHelpers.export(exports, "PdqGooglePassiveLoginButton", ()=>PdqGooglePassiveLoginButton);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _googleAuth = require("./googleAuth");
var _button = require("@carbon/web-components/es/components/button/button");
var _buttonSkeletonJs = require("@carbon/web-components/es/components/button/button-skeleton.js");
var _20 = require("@carbon/web-components/es/icons/user/20");
var _20Default = parcelHelpers.interopDefault(_20);
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _styles = require("../styles");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
const log = (0, _debugDefault.default)("pdq:google:pdq-google-login-button");
let GoogleIdentityBadge = class GoogleIdentityBadge extends (0, _lit.LitElement) {
    render() {
        const user = (0, _googleAuth.googleAuth).token.value?.user;
        if (!user) return 0, _lit.nothing;
        return (0, _lit.html)`<div class="row">
        <img src=${user.picture} class="icon profile-img">
        <div class="col">
          <div>Logged in as ${user.given_name} ${user.family_name}</div>
          <div>${user.email}</div>
        </div>
      </div>`;
    }
};
GoogleIdentityBadge.styles = [
    (0, _styles.row),
    (0, _styles.col),
    (0, _lit.css)` 
    .icon {
      margin-right: 8px
    }
    .profile-img {
        max-height: 36px;
        max-width: 36px;
    }
  `
];
GoogleIdentityBadge = __decorate([
    (0, _decorators.customElement)("pdq-google-identity")
], GoogleIdentityBadge);
let PdqGooglePassiveLoginButton = class PdqGooglePassiveLoginButton extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.size = (0, _button.BUTTON_SIZE).MEDIUM;
        this.kind = (0, _button.BUTTON_KIND).PRIMARY;
        this.showIdentity = true;
        this.loading = true;
        this.loggedIn = false;
        (0, _googleAuth.googleAuth).loggedIn.subscribe((i)=>{
            log(`loggedIn = ${i}`);
            this.loggedIn = i;
            this.loading = false;
        });
    }
    render() {
        log("render", this.showIdentity);
        if (this.loading) return (0, _lit.html)`
        <cds-button disabled="true" size=${this.size} >
          ${(0, _20Default.default)({
            class: "icon"
        })}
          Google Loading...
        </cds-button>
      `;
        if (!this.loggedIn) return (0, _lit.html)`
        <cds-button @click=${this.login} size=${this.size} kind=${this.kind}>
          ${(0, _20Default.default)({
            class: "icon"
        })}
          Sign In with Google
        </cds-button>`;
        return (0, _lit.html)`
      ${this.showIdentity ? (0, _lit.html)`<pdq-google-identity></pdq-google-identity>` : (0, _lit.nothing)}
      <cds-button @click=${this.logout} size=${this.size} kind=${this.kind}>
        ${(0, _20Default.default)({
            class: "icon"
        })}
        Sign Out of Google
      </cds-button>`;
    }
    login() {
        this.loading = true;
        (0, _googleAuth.googleAuth).login();
        setTimeout(()=>this.loading = false, 5000);
    }
    logout() {
        this.loading = true;
        (0, _googleAuth.googleAuth).logout();
    }
};
PdqGooglePassiveLoginButton.styles = [
    (0, _styles.row),
    (0, _styles.col),
    (0, _lit.css)` 
    .icon {
      margin-right: 8px
    }
    .profile-img {
        max-height: 36px;
        max-width: 36px;
    }
    `
];
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", typeof (_a = typeof (0, _button.BUTTON_SIZE) !== "undefined" && (0, _button.BUTTON_SIZE)) === "function" ? _a : Object)
], PdqGooglePassiveLoginButton.prototype, "size", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", typeof (_b = typeof (0, _button.BUTTON_KIND) !== "undefined" && (0, _button.BUTTON_KIND)) === "function" ? _b : Object)
], PdqGooglePassiveLoginButton.prototype, "kind", void 0);
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Object)
], PdqGooglePassiveLoginButton.prototype, "showIdentity", void 0);
__decorate([
    (0, _decorators.query)("#google-login-button"),
    __metadata("design:type", typeof (_c = typeof HTMLElement !== "undefined" && HTMLElement) === "function" ? _c : Object)
], PdqGooglePassiveLoginButton.prototype, "element", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Object)
], PdqGooglePassiveLoginButton.prototype, "loading", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Object)
], PdqGooglePassiveLoginButton.prototype, "loggedIn", void 0);
PdqGooglePassiveLoginButton = __decorate([
    (0, _decorators.customElement)("pdq-google-login-button"),
    __metadata("design:paramtypes", [])
], PdqGooglePassiveLoginButton);

},{"lit/decorators":"kQrIl","lit":"aCmte","./googleAuth":"z2COH","@carbon/web-components/es/components/button/button":"ca52G","@carbon/web-components/es/components/button/button-skeleton.js":"cfoNU","@carbon/web-components/es/icons/user/20":"c0ROG","debug":"17JIf","../styles":"86IFJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c0ROG":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2zM26 30H24V25a5 5 0 00-5-5H13a5 5 0 00-5 5v5H6V25a7 7 0 017-7h6a7 7 0 017 7z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1EVCV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqGoogleApiElement", ()=>PdqGoogleApiElement);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _modal = require("@carbon/web-components/es/components/modal");
var _googleApi = require("./googleApi");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _utils = require("../utils");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const log = (0, _debugDefault.default)("pdq:google:pdq-google-api");
let PdqGoogleApiElement = class PdqGoogleApiElement extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this._onSlotChange = async (event)=>{
            log(`${this.id} - slot change`);
            const slot = event.target;
            const nodes = slot.assignedNodes({
                flatten: true
            });
            const text = (0, _utils.extractTextFromScripts)(nodes);
            try {
                const services = JSON.parse(text);
                log(`loading services`);
                await (0, _googleApi.googleApi).load(services);
                log(`loaded services`);
            } catch (ex) {
                log(`Failed to load services... ${ex}`);
            }
        };
    }
    render() {
        return (0, _lit.html)`<slot name="services" style="display: none" @slotchange=${this._onSlotChange}></slot>`;
    }
};
PdqGoogleApiElement.styles = (0, _lit.css)``;
PdqGoogleApiElement = __decorate([
    (0, _decorators.customElement)("pdq-google-api")
], PdqGoogleApiElement);

},{"lit/decorators":"kQrIl","lit":"aCmte","@carbon/web-components/es/components/modal":"6x6o7","./googleApi":"eOEG5","debug":"17JIf","../utils":"i8jxn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"380pF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqGoogleFileRequest", ()=>PdqGoogleFileRequest);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _modal = require("@carbon/web-components/es/components/modal");
var _googleApi = require("./googleApi");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _blobCache = require("../services/BlobCache");
var _dataBroker = require("../services/DataBroker");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:google:PdqGoogleFileRequest");
let PdqGoogleFileRequest = class PdqGoogleFileRequest extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.fileId = "";
        this.alt = "media";
        this.index = undefined;
        this.expires = 1728000000; // 90 day
        this.lastCacheKey = "";
    }
    render() {
        return 0, _lit.nothing;
    }
    updated(changedProperties) {
        log("updated");
        this.updateFileAsRequired();
    }
    firstUpdated() {
        log("firstUpdated");
        this.updateFileAsRequired();
    }
    async updateFileAsRequired() {
        if (!this.fileId) return;
        const cacheKey = this.fileId;
        if (this.lastCacheKey === cacheKey) return;
        this.lastCacheKey = cacheKey;
        log(`loading file from google ${this.fileId}`);
        const meta = await (0, _blobCache.blobCache).get(`google-file-${this.fileId}`, ()=>(0, _googleApi.googleApi).getFileContent(this.fileId, this.alt), this.expires);
        const file = meta.blob;
        await (0, _dataBroker.dataBroker).addBlobToData(this.fileId, file);
    // log(`updating datasource[${this.table}] with file ${this.fileId}`);
    // try {
    //   const json = await blobToJson(file!);
    //   log(json)
    //   await perspectiveBroker.updateDataSource(this.table, [json], this.index);
    // } catch (ex) {
    //   log(`error updating datasource[${this.table}] with file ${this.fileId} ${ex}`)
    // }
    }
};
PdqGoogleFileRequest.styles = (0, _lit.css)``;
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqGoogleFileRequest.prototype, "fileId", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqGoogleFileRequest.prototype, "alt", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object)
], PdqGoogleFileRequest.prototype, "index", void 0);
__decorate([
    (0, _decorators.property)({
        type: Number
    }),
    __metadata("design:type", Object)
], PdqGoogleFileRequest.prototype, "expires", void 0);
PdqGoogleFileRequest = __decorate([
    (0, _decorators.customElement)("pdq-google-file-request")
], PdqGoogleFileRequest);

},{"lit/decorators":"kQrIl","lit":"aCmte","@carbon/web-components/es/components/modal":"6x6o7","./googleApi":"eOEG5","debug":"17JIf","../services/BlobCache":"cBC8K","../services/DataBroker":"kD6gB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cBC8K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlobCache", ()=>BlobCache);
parcelHelpers.export(exports, "blobCache", ()=>blobCache);
var _blobRegistry = require("./BlobRegistry");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _utils = require("../utils");
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _BlobCache_cache, _BlobCache_keyMutexes;
const log = (0, _debugDefault.default)("pdq:services:BlobCache");
const defaultExpires = 1728000000; // 20 day
class BlobCache {
    constructor(){
        _BlobCache_cache.set(this, new Map());
        _BlobCache_keyMutexes.set(this, new Map());
    }
    async get(key, func, expires = defaultExpires) {
        log(`requesting blob with key ${key}, expires in ${expires}ms`);
        const mutex = this.getKeyMutex(key);
        const unlock = await mutex.lock();
        try {
            let cacheKey = __classPrivateFieldGet(this, _BlobCache_cache, "f").get(key);
            if (cacheKey) {
                const blob = (0, _blobRegistry.blobRegistry).blobsByUrl.get(cacheKey.url);
                if (blob) {
                    log(`returning cached blob with key ${key}`);
                    return {
                        ...blob,
                        ...cacheKey
                    };
                }
            }
            log(`blob with key ${key} does not exist in cache... fetching new blob`);
            const newBlob = await func();
            const meta = await (0, _blobRegistry.blobRegistry).registerBlob(newBlob);
            cacheKey = {
                key,
                url: meta.url,
                expiresAt: new Date(Date.now() + expires)
            };
            __classPrivateFieldGet(this, _BlobCache_cache, "f").set(key, cacheKey);
            setTimeout(()=>{
                log(`removing expired blob with key ${key}`);
                __classPrivateFieldGet(this, _BlobCache_cache, "f").delete(key);
                meta.unregister();
            }, expires);
            log(`returning newly cached blob with key ${key} expires at ${cacheKey.expiresAt}`);
            return {
                ...meta,
                ...cacheKey
            };
        } finally{
            unlock();
            if (!mutex.hasQueue()) __classPrivateFieldGet(this, _BlobCache_keyMutexes, "f").delete(key);
        }
    }
    getKeyMutex(key) {
        let mutex = __classPrivateFieldGet(this, _BlobCache_keyMutexes, "f").get(key);
        if (!mutex) {
            mutex = new (0, _utils.Mutex)("BlobCache");
            __classPrivateFieldGet(this, _BlobCache_keyMutexes, "f").set(key, mutex);
        }
        return mutex;
    }
}
_BlobCache_cache = new WeakMap(), _BlobCache_keyMutexes = new WeakMap();
const blobCache = new BlobCache();

},{"./BlobRegistry":"ammIH","debug":"17JIf","../utils":"i8jxn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aeg5P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqGoogleFileViewer", ()=>PdqGoogleFileViewer);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _styles = require("../styles");
var _googleAuth = require("./googleAuth");
var _googleApi = require("./googleApi");
var _blobCache = require("../services/BlobCache");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _PdqGoogleFileViewer_cacheKey;
const log = (0, _debugDefault.default)("pdq:google:pdq-google-file-viewer");
let PdqGoogleFileViewer = class PdqGoogleFileViewer extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.loadingMessage = "Loading...";
        this.loading = true;
        this.loginRequired = false;
        this.url = "";
        _PdqGoogleFileViewer_cacheKey.set(this, "-");
    }
    get fileId() {
        return this._fileId;
    }
    set fileId(value) {
        this._fileId = value;
        this.loadAndRenderPDF();
    }
    firstUpdated() {
        log("firstUpdated");
        this.loadAndRenderPDF();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        log("update");
        if (changedProperties.has("fileId")) this.loadAndRenderPDF();
    }
    async loadAndRenderPDF() {
        if (__classPrivateFieldGet(this, _PdqGoogleFileViewer_cacheKey, "f") === this.fileId) return;
        __classPrivateFieldSet(this, _PdqGoogleFileViewer_cacheKey, this.fileId, "f");
        if (!this.fileId) {
            log(`cant load empty fileId`);
            this.url = "";
            return;
        }
        try {
            log(`loading file ${this.fileId}`);
            this.loading = true;
            this.loginRequired = !(0, _googleAuth.googleAuth).loggedIn.value;
            this.requestUpdate();
            this.url = (await (0, _blobCache.blobCache).get(`google-file-${this.fileId}`, ()=>(0, _googleApi.googleApi).getFileContent(this.fileId))).url;
            log(`loading file ${this.fileId} done ${this.url}`);
        } catch (error) {
            console.error("Error rendering PDF:", error);
        } finally{
            this.loading = false;
        }
    }
    render() {
        log(`rendering ${this.url} ${this.loading} ${this.loginRequired}`);
        if (!this.loading && !this.url) return (0, _lit.html)`<div class="center"><cds-inline-loading style="margin-left: 16px" status="error">No url set</cds-inline-loading></div>`;
        if (this.loading && this.loginRequired) return (0, _lit.html)`<div class="center"><cds-inline-loading style="margin-left: 16px" status="active">${this.loadingMessage} Awaiting Login</cds-inline-loading></div>`;
        if (this.loading) return (0, _lit.html)`<div class="center"><cds-inline-loading style="margin-left: 16px" status="active">${this.loadingMessage}</cds-inline-loading></div>`;
        return (0, _lit.html)`<iframe
      src=${this.url}
      style="width: 100%; height: 100%; display: block; border: 0">
      ></iframe>`;
    }
};
_PdqGoogleFileViewer_cacheKey = new WeakMap();
PdqGoogleFileViewer.styles = [
    (0, _styles.center),
    (0, _lit.css)`
    .pdf-page {
      margin-bottom: 10px;
    }
  `
];
__decorate([
    (0, _decorators.property)(),
    __metadata("design:type", Object)
], PdqGoogleFileViewer.prototype, "loadingMessage", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [
        Object
    ])
], PdqGoogleFileViewer.prototype, "fileId", null);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Object)
], PdqGoogleFileViewer.prototype, "loading", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", Object)
], PdqGoogleFileViewer.prototype, "loginRequired", void 0);
__decorate([
    (0, _decorators.state)(),
    __metadata("design:type", String)
], PdqGoogleFileViewer.prototype, "url", void 0);
PdqGoogleFileViewer = __decorate([
    (0, _decorators.customElement)("pdq-google-file-viewer")
], PdqGoogleFileViewer);

},{"lit/decorators":"kQrIl","lit":"aCmte","../styles":"86IFJ","./googleAuth":"z2COH","./googleApi":"eOEG5","../services/BlobCache":"cBC8K","debug":"17JIf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gGHDA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PdqGoogleFilelistDatasource", ()=>PdqGoogleFilelistDatasource);
var _decorators = require("lit/decorators");
var _lit = require("lit");
var _modal = require("@carbon/web-components/es/components/modal");
var _googleApi = require("./googleApi");
var _debug = require("debug");
var _debugDefault = parcelHelpers.interopDefault(_debug);
var _dataBroker = require("../services/DataBroker");
var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const log = (0, _debugDefault.default)("pdq:google:PdqGoogleFilelistDatasource");
let PdqGoogleFilelistDatasource = class PdqGoogleFilelistDatasource extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.id = "";
        this.driveId = "";
        this.parentId = "";
        this.q = "";
        this.lastCacheKey = "";
    }
    render() {
        return 0, _lit.nothing;
    }
    updated(changedProperties) {
        log("updated");
        this.updateFileAsRequired();
    }
    firstUpdated() {
        log("firstUpdated");
        this.updateFileAsRequired();
    }
    async updateFileAsRequired() {
        if (!this.id) {
            log(`not trying to list files due to no id`);
            return;
        }
        const cacheKey = this.driveId + this.parentId + this.q;
        if (this.lastCacheKey === cacheKey) return;
        this.lastCacheKey = cacheKey;
        log(`loading file list from google driveId:${this.driveId} parentId:${this.parentId} q=${this.q}`);
        const list = await (0, _googleApi.googleApi).listFiles(this.driveId, this.parentId, this.q);
        (0, _dataBroker.dataBroker).setDataSource(this.id, list);
    }
};
PdqGoogleFilelistDatasource.styles = (0, _lit.css)``;
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqGoogleFilelistDatasource.prototype, "id", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqGoogleFilelistDatasource.prototype, "driveId", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqGoogleFilelistDatasource.prototype, "parentId", void 0);
__decorate([
    (0, _decorators.property)({
        type: String
    }),
    __metadata("design:type", String)
], PdqGoogleFilelistDatasource.prototype, "q", void 0);
PdqGoogleFilelistDatasource = __decorate([
    (0, _decorators.customElement)("pdq-google-filelist-datasource")
], PdqGoogleFilelistDatasource);

},{"lit/decorators":"kQrIl","lit":"aCmte","@carbon/web-components/es/components/modal":"6x6o7","./googleApi":"eOEG5","debug":"17JIf","../services/DataBroker":"kD6gB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kVOi5":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _accordionJs = require("./accordion.js");
var _accordionItemJs = require("./accordion-item.js");
var _accordionItemSkeletonJs = require("./accordion-item-skeleton.js");
var _accordionSkeletonJs = require("./accordion-skeleton.js");

},{"./accordion.js":"c61OZ","./accordion-item.js":"3q6K6","./accordion-item-skeleton.js":"961Qb","./accordion-skeleton.js":"cXhqw"}],"c61OZ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACCORDION_ALIGNMENT", ()=>(0, _defsJs.ACCORDION_ALIGNMENT));
parcelHelpers.export(exports, "ACCORDION_SIZE", ()=>(0, _defsJs.ACCORDION_SIZE));
parcelHelpers.export(exports, "default", ()=>CDSAccordion$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _defsJs = require("./defs.js");
var _accordionScssJs = require("./accordion.scss.js");
var _accordionScssJsDefault = parcelHelpers.interopDefault(_accordionScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Accordion container.
 *
 * @element cds-accordion
 */ let CDSAccordion = class CDSAccordion extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Accordion size should be sm, md, lg.
         */ this.size = (0, _defsJs.ACCORDION_SIZE).MEDIUM;
        /**
         * Specify the alignment of the accordion heading title and chevron
         */ this.alignment = (0, _defsJs.ACCORDION_ALIGNMENT).END;
        /**
         * Specify whether Accordion text should be flush, default is false, does not work with align="start"
         */ this.isFlush = false;
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "list");
        super.connectedCallback();
    }
    updated(changedProperties) {
        if (changedProperties.has("size")) // Propagate `size` attribute to descendants until `:host-context()` gets supported in all major browsers
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorAccordionItems), (elem)=>{
            elem.setAttribute("size", this.size);
        });
        if (changedProperties.has("alignment")) // Propagate `alignment` attribute to descendants until `:host-context()` gets supported in all major browsers
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorAccordionItems), (elem)=>{
            elem.setAttribute("alignment", this.alignment);
        });
        if (changedProperties.has("isFlush") || changedProperties.has("alignment")) // Propagate `isFlush` attribute to descendants until `:host-context()` gets supported in all major browsers
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorAccordionItems), (elem)=>{
            this.isFlush && this.alignment !== "start" ? elem.setAttribute("isFlush", "") : elem.removeAttribute("isFlush");
        });
    }
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
    static get selectorAccordionItems() {
        return `${0, _settingsJs.prefix}-accordion-item`;
    }
};
CDSAccordion.styles = (0, _accordionScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSAccordion.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSAccordion.prototype, "alignment", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSAccordion.prototype, "isFlush", void 0);
CDSAccordion = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-accordion`)
], CDSAccordion);
var CDSAccordion$1 = CDSAccordion;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/internal/collection-helpers.js":"4aZkz","./defs.js":"3gw3p","./accordion.scss.js":"f6Jx3","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3gw3p":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Breakpoints for accordion items. It's different from one in `@carbon/layout` library.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACCORDION_ALIGNMENT", ()=>ACCORDION_ALIGNMENT);
parcelHelpers.export(exports, "ACCORDION_ITEM_BREAKPOINT", ()=>ACCORDION_ITEM_BREAKPOINT);
parcelHelpers.export(exports, "ACCORDION_SIZE", ()=>ACCORDION_SIZE);
var ACCORDION_ITEM_BREAKPOINT;
(function(ACCORDION_ITEM_BREAKPOINT) {
    /**
     * Small breakpoint.
     */ ACCORDION_ITEM_BREAKPOINT["SMALL"] = "sm";
    /**
     * Medium breakpoint.
     */ ACCORDION_ITEM_BREAKPOINT["MEDIUM"] = "md";
})(ACCORDION_ITEM_BREAKPOINT || (ACCORDION_ITEM_BREAKPOINT = {}));
/**
 * Accordion size.
 */ var ACCORDION_SIZE;
(function(ACCORDION_SIZE) {
    /**
     * Small size.
     */ ACCORDION_SIZE["SMALL"] = "sm";
    /**
     * Medium size.
     */ ACCORDION_SIZE["MEDIUM"] = "md";
    /**
     * Large size.
     */ ACCORDION_SIZE["LARGE"] = "lg";
})(ACCORDION_SIZE || (ACCORDION_SIZE = {}));
/**
 * Specify the alignment of the accordion heading title and chevron.
 */ var ACCORDION_ALIGNMENT;
(function(ACCORDION_ALIGNMENT) {
    /**
     * Alignment to the start
     */ ACCORDION_ALIGNMENT["START"] = "start";
    /**
     * Alignment to the end
     */ ACCORDION_ALIGNMENT["END"] = "END";
})(ACCORDION_ALIGNMENT || (ACCORDION_ALIGNMENT = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f6Jx3":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm,:host(cds-accordion-item-skeleton[size=sm]) button,:host(cds-accordion-item[size=sm]) button{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg,:host(cds-accordion-item-skeleton[size=lg]) button,:host(cds-accordion-item[size=lg]) button{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--accordion,:host(cds-accordion),:host(cds-accordion-skeleton){--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--accordion *,.cds--accordion :after,.cds--accordion :before,:host(cds-accordion) *,:host(cds-accordion) :after,:host(cds-accordion) :before,:host(cds-accordion-skeleton) *,:host(cds-accordion-skeleton) :after,:host(cds-accordion-skeleton) :before{box-sizing:inherit}.cds--accordion,:host(cds-accordion),:host(cds-accordion-skeleton){inline-size:100%;list-style:none}.cds--accordion__item,:host(cds-accordion-item),:host(cds-accordion-item-skeleton){border-block-start:1px solid var(--cds-border-subtle);display:list-item;overflow:visible;transition:border-color .11s cubic-bezier(.2,0,.38,.9)}.cds--accordion__item:last-child{border-block-end:1px solid var(--cds-border-subtle)}.cds--accordion__item:not(.cds--accordion__item--active):hover,.cds--accordion__item:not(.cds--accordion__item--active):hover+.cds--accordion__item,.cds--accordion__item:not(.cds--accordion__item--active):hover+:host(cds-accordion-item),.cds--accordion__item:not(.cds--accordion__item--active):hover+:host(cds-accordion-item-skeleton){border-block-start-color:var(--cds-layer-hover)}.cds--accordion__item:not(.cds--accordion__item--active):last-child:hover{border-block-end-color:var(--cds-layer-hover)}.cds--accordion__heading{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;display:inline-block;font-family:inherit;font-size:100%;padding:0;text-align:start;transition:background-color .11s cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--accordion__heading *,.cds--accordion__heading :after,.cds--accordion__heading :before{box-sizing:inherit}.cds--accordion__heading::-moz-focus-inner{border:0}.cds--accordion__heading{align-items:center;color:var(--cds-text-primary,#161616);cursor:pointer;display:flex;flex-direction:row-reverse;inline-size:100%;justify-content:flex-start;margin:0;min-block-size:var(--cds-layout-size-height-local);padding-inline-end:var(--cds-layout-density-padding-inline-local);position:relative}.cds--accordion__heading:hover{background-color:var(--cds-layer-hover);outline:none}.cds--accordion__heading:focus{box-shadow:0 -1px 0 0 var(--cds-focus,#0f62fe),inset 0 1px 0 0 var(--cds-focus,#0f62fe),inset 2px 0 0 0 var(--cds-focus,#0f62fe),0 1px 0 0 var(--cds-focus,#0f62fe),inset 0 -1px 0 0 var(--cds-focus,#0f62fe),inset -2px 0 0 0 var(--cds-focus,#0f62fe);outline:none;position:relative;z-index:2}.cds--accordion__heading[disabled]{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--accordion__heading[disabled] .cds--accordion__arrow{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--accordion__heading[disabled]:hover:before{background-color:transparent}.cds--accordion__item--disabled,.cds--accordion__item--disabled+.cds--accordion__item,.cds--accordion__item--disabled+:host(cds-accordion-item),.cds--accordion__item--disabled+:host(cds-accordion-item-skeleton){border-block-start:1px solid var(--cds-border-subtle)}li.cds--accordion__item--disabled:last-of-type{border-block-end:1px solid var(--cds-border-subtle)}.cds--accordion__arrow{block-size:1rem;flex:0 0 1rem;outline:2px solid transparent;outline-offset:-2px;transition:all .11s cubic-bezier(.2,0,.38,.9);fill:var(--cds-icon-primary,#161616);inline-size:1rem;transform:rotate(-270deg)}.cds--accordion__title{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);padding-inline-start:1rem;text-align:start;z-index:1}.cds--accordion__wrapper{display:none;max-block-size:0;opacity:0;overflow:hidden;padding:0;transition:all allow-discrete .11s cubic-bezier(0,0,.38,.9);writing-mode:horizontal-tb}.cds--accordion__content,:host(cds-accordion-item) .cds--accordion__content,:host(cds-accordion-item-skeleton) .cds--accordion__content{padding-inline:var(--cds-layout-density-padding-inline-local)}@media (min-width:480px){.cds--accordion__content,:host(cds-accordion-item) .cds--accordion__content,:host(cds-accordion-item-skeleton) .cds--accordion__content{padding-inline-end:3rem}}@media (min-width:640px){.cds--accordion__content,:host(cds-accordion-item) .cds--accordion__content,:host(cds-accordion-item-skeleton) .cds--accordion__content{padding-inline-end:25%}}.cds--accordion__content>p,:host(cds-accordion-item) .cds--accordion__content>p,:host(cds-accordion-item-skeleton) .cds--accordion__content>p{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857)}.cds--accordion--start .cds--accordion__heading,:host(cds-accordion-item-skeleton[alignment=start]) .cds--accordion__heading,:host(cds-accordion-item[alignment=start]) .cds--accordion__heading{flex-direction:row}.cds--accordion--start .cds--accordion__arrow,:host(cds-accordion-item-skeleton[alignment=start]) .cds--accordion__arrow,:host(cds-accordion-item[alignment=start]) .cds--accordion__arrow{margin:2px 0 0 var(--cds-layout-density-padding-inline-local)}.cds--accordion--start .cds--accordion__title,:host(cds-accordion-item-skeleton[alignment=start]) .cds--accordion__title,:host(cds-accordion-item[alignment=start]) .cds--accordion__title{margin-inline-end:1rem}.cds--accordion--start .cds--accordion__content,:host(cds-accordion-item-skeleton[alignment=start]) .cds--accordion__content,:host(cds-accordion-item[alignment=start]) .cds--accordion__content{margin-inline-start:calc(var(--cds-layout-density-padding-inline-local) + 1rem)}.cds--accordion__item--collapsing .cds--accordion__content,.cds--accordion__item--expanding .cds--accordion__content,:host(cds-accordion-item[collapsing]) .cds--accordion__content,:host(cds-accordion-item[expanding]) .cds--accordion__content{display:block}.cds--accordion__item--active,:host(cds-accordion-item[open]:not([disabled])){overflow:visible}.cds--accordion__item--active>.cds--accordion__wrapper,:host(cds-accordion-item[open]:not([disabled]))>.cds--accordion__wrapper{display:block;max-block-size:-moz-fit-content;max-block-size:fit-content;opacity:1;overflow:visible;padding-block:.5rem;padding-block-end:1.5rem}.cds--accordion__item--active>.cds--accordion__heading>.cds--accordion__arrow,:host(cds-accordion-item[open]:not([disabled]))>.cds--accordion__heading>.cds--accordion__arrow{fill:var(--cds-icon-primary,#161616);transform:rotate(-90deg)}@starting-style{.cds--accordion__item--active>.cds--accordion__wrapper,:host(cds-accordion-item[open]:not([disabled]))>.cds--accordion__wrapper{max-block-size:0;opacity:0;padding:0}}.cds--accordion--flush .cds--accordion__item,.cds--accordion--flush :host(cds-accordion-item),.cds--accordion--flush :host(cds-accordion-item-skeleton),:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__item,:host(cds-accordion-item-skeleton[isFlush]) :host(cds-accordion-item),:host(cds-accordion-item-skeleton[isFlush]) :host(cds-accordion-item-skeleton),:host(cds-accordion-item[isFlush]) .cds--accordion__item,:host(cds-accordion-item[isFlush]) :host(cds-accordion-item),:host(cds-accordion-item[isFlush]) :host(cds-accordion-item-skeleton){border-color:transparent;position:relative}.cds--accordion--flush .cds--accordion__item:hover,.cds--accordion--flush .cds--accordion__item:hover+.cds--accordion__item,.cds--accordion--flush .cds--accordion__item:hover+:host(cds-accordion-item),.cds--accordion--flush .cds--accordion__item:hover+:host(cds-accordion-item-skeleton),.cds--accordion--flush .cds--accordion__item:last-child,.cds--accordion--flush .cds--accordion__item:last-child:hover,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__item:hover,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__item:hover+.cds--accordion__item,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__item:hover+:host(cds-accordion-item),:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__item:hover+:host(cds-accordion-item-skeleton),:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__item:last-child,:host(cds-accordion-item[isFlush]) .cds--accordion__item:hover,:host(cds-accordion-item[isFlush]) .cds--accordion__item:hover+.cds--accordion__item,:host(cds-accordion-item[isFlush]) .cds--accordion__item:hover+:host(cds-accordion-item),:host(cds-accordion-item[isFlush]) .cds--accordion__item:hover+:host(cds-accordion-item-skeleton),:host(cds-accordion-item[isFlush]) .cds--accordion__item:last-child{border-color:transparent}.cds--accordion--flush .cds--accordion__item:after,.cds--accordion--flush .cds--accordion__item:before,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__item:after,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__item:before,:host(cds-accordion-item[isFlush]) .cds--accordion__item:after,:host(cds-accordion-item[isFlush]) .cds--accordion__item:before{block-size:1px;content:"";display:block;inline-size:calc(100% - 2rem);margin-inline-start:1rem;position:absolute;transition:background .11s cubic-bezier(.2,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--accordion--flush .cds--accordion__item:after,.cds--accordion--flush .cds--accordion__item:before,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__item:after,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__item:before,:host(cds-accordion-item[isFlush]) .cds--accordion__item:after,:host(cds-accordion-item[isFlush]) .cds--accordion__item:before{transition:none}}.cds--accordion--flush .cds--accordion__item:before,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__item:before,:host(cds-accordion-item[isFlush]) .cds--accordion__item:before{background:var(--cds-border-subtle);inset-block-start:-1px}.cds--accordion--flush .cds--accordion__item:last-child:after,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__item:last-child:after,:host(cds-accordion-item[isFlush]) .cds--accordion__item:last-child:after{background:var(--cds-border-subtle);inset-block-end:-1px}.cds--accordion--flush .cds--accordion__heading:hover,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__heading:hover,:host(cds-accordion-item[isFlush]) .cds--accordion__heading:hover{position:relative;z-index:1}.cds--accordion--flush .cds--accordion__heading:hover:after,.cds--accordion--flush .cds--accordion__heading:hover:before,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__heading:hover:after,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__heading:hover:before,:host(cds-accordion-item[isFlush]) .cds--accordion__heading:hover:after,:host(cds-accordion-item[isFlush]) .cds--accordion__heading:hover:before{background:var(--cds-layer-hover);block-size:1px;content:"";display:block;inline-size:100%;inset-inline-start:0;position:absolute;transition:background .11s cubic-bezier(.2,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--accordion--flush .cds--accordion__heading:hover:after,.cds--accordion--flush .cds--accordion__heading:hover:before,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__heading:hover:after,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__heading:hover:before,:host(cds-accordion-item[isFlush]) .cds--accordion__heading:hover:after,:host(cds-accordion-item[isFlush]) .cds--accordion__heading:hover:before{transition:none}}.cds--accordion--flush .cds--accordion__heading:hover:before,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__heading:hover:before,:host(cds-accordion-item[isFlush]) .cds--accordion__heading:hover:before{inset-block-start:-1px}.cds--accordion--flush .cds--accordion__heading:hover:after,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__heading:hover:after,:host(cds-accordion-item[isFlush]) .cds--accordion__heading:hover:after{inset-block-end:-1px}.cds--accordion--flush .cds--accordion__heading:hover:focus:after,.cds--accordion--flush .cds--accordion__heading:hover:focus:before,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__heading:hover:focus:after,:host(cds-accordion-item-skeleton[isFlush]) .cds--accordion__heading:hover:focus:before,:host(cds-accordion-item[isFlush]) .cds--accordion__heading:hover:focus:after,:host(cds-accordion-item[isFlush]) .cds--accordion__heading:hover:focus:before{background:none}.cds--accordion.cds--skeleton .cds--accordion__button,.cds--accordion.cds--skeleton .cds--accordion__heading{cursor:default}.cds--accordion.cds--skeleton .cds--accordion__arrow{cursor:default;fill:var(--cds-icon-primary,#161616);pointer-events:none}.cds--accordion.cds--skeleton .cds--accordion__arrow:active,.cds--accordion.cds--skeleton .cds--accordion__arrow:focus,.cds--accordion.cds--skeleton .cds--accordion__arrow:hover{border:none;cursor:default;outline:none}.cds--accordion.cds--skeleton .cds--accordion__heading:hover,.cds--accordion.cds--skeleton .cds--accordion__heading:hover:before{background-color:transparent}.cds--accordion--end.cds--skeleton .cds--accordion__arrow{margin-inline-start:1rem}.cds--skeleton .cds--accordion__heading:focus .cds--accordion__arrow{border:none;cursor:default;outline:none}.cds--accordion__title.cds--skeleton__text{margin-block-end:0}.cds--accordion.cds--skeleton .cds--accordion__title{margin-inline-start:1rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--accordion__arrow,.cds--accordion__item--active .cds--accordion__arrow{fill:ButtonText}}[dir=rtl] .cds--accordion--start .cds--accordion__heading,[dir=rtl] :host(cds-accordion-item-skeleton[alignment=start]) .cds--accordion__heading,[dir=rtl] :host(cds-accordion-item[alignment=start]) .cds--accordion__heading{padding-inline:var(--cds-layout-density-padding-inline-local) 0}[dir=rtl] .cds--accordion--start .cds--accordion__title,[dir=rtl] :host(cds-accordion-item-skeleton[alignment=start]) .cds--accordion__title,[dir=rtl] :host(cds-accordion-item[alignment=start]) .cds--accordion__title{margin-inline-end:0;padding-inline-start:0}:host(cds-accordion),:host(cds-accordion-skeleton){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}:host(cds-accordion-item),:host(cds-accordion-item-skeleton){display:block;outline:none}:host(cds-accordion-item) .cds--accordion__content ::slotted(p),:host(cds-accordion-item-skeleton) .cds--accordion__content ::slotted(p){font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);margin:0}:host(cds-accordion-item-skeleton[size=sm]) button,:host(cds-accordion-item[size=sm]) button{min-block-size:var(--cds-layout-size-height-context)}:host(cds-accordion-item-skeleton[size=lg]) button,:host(cds-accordion-item[size=lg]) button{min-block-size:var(--cds-layout-size-height-context)}:host(cds-accordion-item[open]:not([disabled])) .cds--accordion__content{padding-inline-end:1rem}:host(cds-accordion-item[open]:not([disabled])) .cds-ce--accordion__content--sm{padding-inline-end:3rem}:host(cds-accordion-item[open]:not([disabled])) .cds-ce--accordion__content--md{padding-inline-end:25%}:host(cds-accordion-item-skeleton) .cds--accordion__heading,:host(cds-accordion-skeleton) .cds--accordion__heading{cursor:default}:host(cds-accordion-item-skeleton) .cds--accordion__heading:hover:before,:host(cds-accordion-skeleton) .cds--accordion__heading:hover:before{background:transparent}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3q6K6":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACCORDION_ITEM_BREAKPOINT", ()=>(0, _defsJs.ACCORDION_ITEM_BREAKPOINT));
parcelHelpers.export(exports, "default", ()=>CDSAccordionItem$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _16Js = require("../../icons/chevron--right/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _defsJs = require("./defs.js");
var _accordionScssJs = require("./accordion.scss.js");
var _accordionScssJsDefault = parcelHelpers.interopDefault(_accordionScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Observes resize of the given element with the given resize observer.
 *
 * @param observer The resize observer.
 * @param elem The element to observe the resize.
 */ const observeResize = (observer, elem)=>{
    if (!elem) return null;
    observer.observe(elem);
    return {
        release () {
            observer.unobserve(elem);
            return null;
        }
    };
};
/**
 * Accordion item.
 *
 * @element cds-accordion-item
 * @fires cds-accordion-item-beingtoggled
 *   The custom event fired before this accordion item is being toggled upon a user gesture.
 *   Cancellation of this event stops the user-initiated action of toggling this accordion item.
 * @fires cds-accordion-item-toggled - The custom event fired after this accordion item is toggled upon a user gesture.
 * @csspart expando The expando button.
 * @csspart expando-icon The expando icon.
 * @csspart title The title.
 * @csspart content The content.
 */ let CDSAccordionItem = class CDSAccordionItem extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * The handle for observing resize of the parent element of this element.
         */ this._hObserveResize = null;
        /**
         * Handler for the `keydown` event on the expando button.
         */ this._handleKeydownExpando = ({ key })=>{
            if (this.open && (key === "Esc" || key === "Escape")) this._handleUserInitiatedToggle(false);
        };
        /**
         * The `ResizeObserver` instance for observing element resizes for re-positioning floating menu position.
         */ // TODO: Wait for `.d.ts` update to support `ResizeObserver`
        // @ts-ignore
        this._resizeObserver = new ResizeObserver((records)=>{
            const { width } = records[records.length - 1].contentRect;
            const { _sizesBreakpoints: sizesBreakpoints } = this.constructor;
            this._currentBreakpoint = Object.keys(sizesBreakpoints).sort((lhs, rhs)=>sizesBreakpoints[rhs] - sizesBreakpoints[lhs]).find((size)=>width >= sizesBreakpoints[size]);
            this.requestUpdate();
        });
        /**
         * `true` if the accordion item should be disabled.
         */ this.disabled = false;
        /**
         * `true` if the accordion item should be open.
         */ this.open = false;
        /**
         * The title text.
         */ this.title = "";
    }
    /**
     * Handles user-initiated toggle request of this accordion item.
     *
     * @param open The new open state.
     */ _handleUserInitiatedToggle(open = !this.open) {
        const init = {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: {
                open
            }
        };
        if (this.dispatchEvent(new CustomEvent(this.constructor.eventBeforeToggle, init))) {
            const { selectorAccordionContent } = this.constructor;
            !this.open ? this.setAttribute("expanding", "") : this.setAttribute("collapsing", "");
            this.shadowRoot.querySelector(selectorAccordionContent).addEventListener("animationend", ()=>{
                this.removeAttribute("expanding");
                this.removeAttribute("collapsing");
            });
            this.open = open;
            this.dispatchEvent(new CustomEvent(this.constructor.eventToggle, init));
        }
        const content = this.shadowRoot.querySelector(`.${(0, _settingsJs.prefix)}--accordion__wrapper`);
        if (this.open) // accordion opens
        content.style.maxBlockSize = content.scrollHeight + 15 + "px";
        else // accordion closes
        content.style.maxBlockSize = "";
    }
    /**
     * Handler for the `click` event on the expando button.
     */ _handleClickExpando() {
        this._handleUserInitiatedToggle();
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "listitem");
        super.connectedCallback();
        if (this._hObserveResize) this._hObserveResize = this._hObserveResize.release();
        this._hObserveResize = observeResize(this._resizeObserver, this);
    }
    disconnectedCallback() {
        if (this._hObserveResize) this._hObserveResize = this._hObserveResize.release();
    }
    render() {
        const { disabled, title, open, _currentBreakpoint: currentBreakpoint, _handleClickExpando: handleClickExpando, _handleKeydownExpando: handleKeydownExpando } = this;
        const { _classesBreakpoints: classesBreakpoints } = this.constructor;
        const { [currentBreakpoint]: classBreakpoint } = classesBreakpoints;
        const contentClasses = (0, _classMapJs.classMap)({
            [classBreakpoint]: classBreakpoint,
            [`${0, _settingsJs.prefix}--accordion__content`]: true
        });
        return (0, _lit.html)`
      <button
        ?disabled="${disabled}"
        type="button"
        part="expando"
        class="${0, _settingsJs.prefix}--accordion__heading"
        aria-controls="content"
        aria-expanded="${open}"
        @click="${handleClickExpando}"
        @keydown="${handleKeydownExpando}">
        ${(0, _16JsDefault.default)({
            part: "expando-icon",
            class: `${(0, _settingsJs.prefix)}--accordion__arrow`
        })}
        <div part="title" class="${0, _settingsJs.prefix}--accordion__title">
          <slot name="title">${title}</slot>
        </div>
      </button>
      <div class="${0, _settingsJs.prefix}--accordion__wrapper">
        <div id="content" part="content" class="${contentClasses}">
          <slot></slot>
        </div>
      </div>
    `;
    }
    /**
     * The CSS classes for breakpoints.
     *
     * @private
     */ static get _classesBreakpoints() {
        return {
            [(0, _defsJs.ACCORDION_ITEM_BREAKPOINT).SMALL]: `${0, _settingsJs.prefix}-ce--accordion__content--${(0, _defsJs.ACCORDION_ITEM_BREAKPOINT).SMALL}`,
            [(0, _defsJs.ACCORDION_ITEM_BREAKPOINT).MEDIUM]: `${0, _settingsJs.prefix}-ce--accordion__content--${(0, _defsJs.ACCORDION_ITEM_BREAKPOINT).MEDIUM}`
        };
    }
    /**
     * The breakpoints.
     *
     * @private
     */ static get _sizesBreakpoints() {
        return {
            [(0, _defsJs.ACCORDION_ITEM_BREAKPOINT).SMALL]: 480,
            [(0, _defsJs.ACCORDION_ITEM_BREAKPOINT).MEDIUM]: 640
        };
    }
    /**
     * The name of the custom event fired before this accordion item is being toggled upon a user gesture.
     * Cancellation of this event stops the user-initiated action of toggling this accordion item.
     */ static get eventBeforeToggle() {
        return `${0, _settingsJs.prefix}-accordion-item-beingtoggled`;
    }
    /**
     * The name of the custom event fired after this accordion item is toggled upon a user gesture.
     */ static get eventToggle() {
        return `${0, _settingsJs.prefix}-accordion-item-toggled`;
    }
    static get selectorAccordionContent() {
        return `.${0, _settingsJs.prefix}--accordion__content`;
    }
};
CDSAccordionItem.styles = (0, _accordionScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSAccordionItem.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSAccordionItem.prototype, "open", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "title"
    })
], CDSAccordionItem.prototype, "title", void 0);
CDSAccordionItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-accordion-item`)
], CDSAccordionItem);
var CDSAccordionItem$1 = CDSAccordionItem;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/chevron--right/16.js":"bkZcb","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./defs.js":"3gw3p","./accordion.scss.js":"f6Jx3","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bkZcb":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M11 8L6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"961Qb":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSAccordionItemSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _16Js = require("../../icons/chevron--right/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _settingsJs = require("../../globals/settings.js");
var _skeletonTextJs = require("../skeleton-text/skeleton-text.js");
var _accordionScssJs = require("./accordion.scss.js");
var _accordionScssJsDefault = parcelHelpers.interopDefault(_accordionScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of accordion item.
 */ let CDSAccordionItemSkeleton = class CDSAccordionItemSkeleton extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)`
      <span class="${0, _settingsJs.prefix}--accordion__heading">
        ${(0, _16JsDefault.default)({
            part: "expando-icon",
            class: `${(0, _settingsJs.prefix)}--accordion__arrow`
        })}
        <cds-skeleton-text
          class="${0, _settingsJs.prefix}--accordion__title"></cds-skeleton-text>
      </span>
    `;
    }
};
CDSAccordionItemSkeleton.styles = (0, _accordionScssJsDefault.default);
CDSAccordionItemSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-accordion-item-skeleton`)
], CDSAccordionItemSkeleton);
var CDSAccordionItemSkeleton$1 = CDSAccordionItemSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","../../icons/chevron--right/16.js":"bkZcb","../../globals/settings.js":"EipuL","../skeleton-text/skeleton-text.js":"9W6nb","./accordion.scss.js":"f6Jx3","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9W6nb":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SKELETON_TEXT_TYPE", ()=>(0, _defsJs.SKELETON_TEXT_TYPE));
parcelHelpers.export(exports, "default", ()=>CDSSkeletonText$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _defsJs = require("./defs.js");
var _skeletonTextScssJs = require("./skeleton-text.scss.js");
var _skeletonTextScssJsDefault = parcelHelpers.interopDefault(_skeletonTextScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ function getRandomInt(min, max, n) {
    const randoms = [
        0.973051493507435,
        0.15334737213558558,
        0.5671034553053769
    ];
    return Math.floor(randoms[n % 3] * (max - min + 1)) + min;
}
/**
 * Skeleton text.
 *
 * @element cds-skeleton-text
 */ let CDSSkeletonText = class CDSSkeletonText extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * The type of skeleton text.
         */ this.type = (0, _defsJs.SKELETON_TEXT_TYPE).REGULAR;
        /**
         * width (in px or %) of single line of text or max-width of paragraph lines
         */ this.width = "100%";
        /**
         * will generate multiple lines of text
         */ this.paragraph = false;
        /**
         * the number of lines in a paragraph
         */ this.lineCount = 3;
    }
    render() {
        const { optionalClasses, paragraph, lineCount, type, width } = this;
        let defaultClasses = {
            [`${0, _settingsJs.prefix}--skeleton__text`]: true,
            [`${0, _settingsJs.prefix}--skeleton__heading`]: type === (0, _defsJs.SKELETON_TEXT_TYPE).HEADING
        };
        if (optionalClasses) {
            const outputObject = {};
            optionalClasses === null || optionalClasses === void 0 || optionalClasses.split(" ").forEach((element)=>{
                outputObject[element] = true;
            });
            defaultClasses = Object.assign(Object.assign({}, defaultClasses), outputObject);
        }
        const classes = (0, _classMapJs.classMap)(defaultClasses);
        if (paragraph) {
            const widthNum = parseInt(this.width, 10);
            const widthPx = this.width.includes("px");
            const widthPercent = this.width.includes("%");
            const lines = [];
            for(let i = 0; i < lineCount; i++){
                const randomWidth = widthPercent && `${getRandomInt(0, 75, i)}px` || widthPx && `${getRandomInt(0, widthNum, i)}px`;
                const style = widthPercent && `width: calc(${width} - ${randomWidth})` || widthPx && `width: ${randomWidth}` || "";
                lines.push((0, _lit.html)`<p class="${classes}" style="${style}"></p>`);
            }
            return lines;
        }
        return (0, _lit.html)`<p class="${classes}" style="width:${width}"></p>`;
    }
};
CDSSkeletonText.styles = (0, _skeletonTextScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "optional-classes"
    })
], CDSSkeletonText.prototype, "optionalClasses", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSSkeletonText.prototype, "type", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSSkeletonText.prototype, "width", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSkeletonText.prototype, "paragraph", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true
    })
], CDSSkeletonText.prototype, "lineCount", void 0);
CDSSkeletonText = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-skeleton-text`)
], CDSSkeletonText);
var CDSSkeletonText$1 = CDSSkeletonText;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./defs.js":"6sWex","./skeleton-text.scss.js":"gcuiF","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6sWex":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton text types.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SKELETON_TEXT_TYPE", ()=>SKELETON_TEXT_TYPE);
var SKELETON_TEXT_TYPE;
(function(SKELETON_TEXT_TYPE) {
    /**
     * Regular variant.
     */ SKELETON_TEXT_TYPE["REGULAR"] = "";
    /**
     * Heading variant.
     */ SKELETON_TEXT_TYPE["HEADING"] = "heading";
})(SKELETON_TEXT_TYPE || (SKELETON_TEXT_TYPE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gcuiF":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}@keyframes ai-skeleton-animation{0%{transform:translateX(-100%)}to{transform:translateX(100%)}}.cds--icon--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;display:inline-block;inline-size:1rem;padding:0;pointer-events:none;position:relative}.cds--icon--skeleton:active,.cds--icon--skeleton:focus,.cds--icon--skeleton:hover{border:none;cursor:default;outline:none}.cds--icon--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--icon--skeleton:before{animation:none}}.cds--skeleton__placeholder{background:var(--cds-skeleton-background,#e8e8e8);block-size:6.25rem;border:none;box-shadow:none;inline-size:6.25rem;padding:0;pointer-events:none;position:relative}.cds--skeleton__placeholder:active,.cds--skeleton__placeholder:focus,.cds--skeleton__placeholder:hover{border:none;cursor:default;outline:none}.cds--skeleton__placeholder:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--skeleton__placeholder:before{animation:none}}.cds--skeleton__text{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;inline-size:100%;margin-block-end:.5rem;padding:0;pointer-events:none;position:relative}.cds--skeleton__text:active,.cds--skeleton__text:focus,.cds--skeleton__text:hover{border:none;cursor:default;outline:none}.cds--skeleton__text:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--skeleton__text:before{animation:none}}.cds--skeleton__heading{block-size:1.5rem}.cds--skeleton__icon--ai,.cds--skeleton__placeholder--ai,.cds--skeleton__text--ai{background:var(--cds-ai-skeleton-background,#d0e2ff);overflow:hidden}.cds--skeleton__icon--ai:before,.cds--skeleton__placeholder--ai:before,.cds--skeleton__text--ai:before{animation:ai-skeleton-animation 1.25s ease-in-out infinite;background:linear-gradient(90deg,rgba(69,137,255,0) 0,rgba(69,137,255,.5) 50%,rgba(69,137,255,0))}.cds--skeleton__icon--ai:before,.cds--skeleton__placeholder--ai:before{inline-size:200%}.cds--skeleton__placeholder--ai{border-radius:.5rem}.cds--skeleton__text--ai{border-radius:1rem}.cds--skeleton__icon--ai{border-radius:.125rem}:host(cds-skeleton-text){display:block;inline-size:100%}:host(cds-skeleton-text) .cds--skeleton__text{margin-block-start:0}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cXhqw":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSAccordionSkeleton$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _accordionJs = require("./accordion.js");
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _16Js = require("../../icons/chevron--right/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _accordionItemSkeletonJs = require("./accordion-item-skeleton.js");
var _skeletonTextJs = require("../skeleton-text/skeleton-text.js");
var _accordionScssJs = require("./accordion.scss.js");
var _accordionScssJsDefault = parcelHelpers.interopDefault(_accordionScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("./defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of code snippet.
 */ let CDSAccordionSkeleton = class CDSAccordionSkeleton extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Specify the alignment of the accordion heading title and chevron
         */ this.alignment = (0, _defsJs.ACCORDION_ALIGNMENT).END;
        /**
         * Set number of items to render
         */ this.count = 4;
        /**
         * Specify whether Accordion text should be flush, default is false, does not work with align="start"
         */ this.isFlush = false;
        /**
         * `true` if the first accordion item should be open.
         */ this.open = true;
    }
    updated(changedProperties) {
        if (changedProperties.has("alignment")) // Propagate `alignment` attribute to descendants until `:host-context()` gets supported in all major browsers
        (0, _collectionHelpersJs.forEach)(this.shadowRoot.querySelectorAll(this.constructor.selectorAccordionItemSkeletons), (elem)=>{
            elem.setAttribute("alignment", this.alignment);
        });
        if (changedProperties.has("isFlush") || changedProperties.has("alignment")) // Propagate `isFlush` attribute to descendants until `:host-context()` gets supported in all major browsers
        (0, _collectionHelpersJs.forEach)(this.shadowRoot.querySelectorAll(this.constructor.selectorAccordionItemSkeletons), (elem)=>{
            this.isFlush && this.alignment !== "start" ? elem.setAttribute("isFlush", "") : elem.removeAttribute("isFlush");
        });
    }
    render() {
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--accordion__item`]: true,
            [`${0, _settingsJs.prefix}--accordion__item--active`]: true,
            [`${0, _settingsJs.prefix}--accordion--${this.alignment}`]: this.alignment,
            [`${0, _settingsJs.prefix}--accordion--flush`]: this.isFlush && this.alignment !== "start"
        });
        const numSkeletonItems = this.open ? this.count - 1 : this.count;
        return (0, _lit.html)`
      ${this.open ? (0, _lit.html)`
            <li class="${classes}">
              <span class="${0, _settingsJs.prefix}--accordion__heading">
                ${(0, _16JsDefault.default)({
            part: "expando-icon",
            class: `${(0, _settingsJs.prefix)}--accordion__arrow`
        })}
                <cds-skeleton-text
                  class="${0, _settingsJs.prefix}--accordion__title"></cds-skeleton-text>
              </span>
              <div class="${0, _settingsJs.prefix}--accordion__content">
                <cds-skeleton-text width="90%"></cds-skeleton-text>
                <cds-skeleton-text width="80%"></cds-skeleton-text>
                <cds-skeleton-text width="85%"></cds-skeleton-text>
              </div>
            </li>
          ` : ``}
      ${Array.from(new Array(numSkeletonItems)).map((_, index)=>(0, _lit.html)`
          <cds-accordion-item-skeleton
            key=${index}></cds-accordion-item-skeleton>
        `)}
    `;
    }
    static get selectorAccordionItemSkeletons() {
        return `${0, _settingsJs.prefix}-accordion-item-skeleton`;
    }
};
CDSAccordionSkeleton.styles = (0, _accordionScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSAccordionSkeleton.prototype, "alignment", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        attribute: "count"
    })
], CDSAccordionSkeleton.prototype, "count", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSAccordionSkeleton.prototype, "isFlush", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSAccordionSkeleton.prototype, "open", void 0);
CDSAccordionSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-accordion-skeleton`)
], CDSAccordionSkeleton);
var CDSAccordionSkeleton$1 = CDSAccordionSkeleton;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./accordion.js":"c61OZ","../../globals/internal/collection-helpers.js":"4aZkz","../../icons/chevron--right/16.js":"bkZcb","./accordion-item-skeleton.js":"961Qb","../skeleton-text/skeleton-text.js":"9W6nb","./accordion.scss.js":"f6Jx3","../../globals/decorators/carbon-element.js":"kNhLR","./defs.js":"3gw3p","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cptjs":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _buttonJs = require("./button.js");
var _buttonSetJs = require("./button-set.js");
var _buttonSkeletonJs = require("./button-skeleton.js");

},{"./button.js":"ca52G","./button-set.js":"fcMCT","./button-skeleton.js":"cfoNU"}],"lcFsF":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _checkboxJs = require("./checkbox.js");
var _checkboxGroupJs = require("./checkbox-group.js");
var _checkboxSkeletonJs = require("./checkbox-skeleton.js");

},{"./checkbox.js":"kER9T","./checkbox-group.js":"f7lE9","./checkbox-skeleton.js":"gxttH"}],"kER9T":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSCheckbox$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _formJs = require("../../globals/mixins/form.js");
var _formJsDefault = parcelHelpers.interopDefault(_formJs);
var _16Js = require("../../icons/warning--filled/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/warning--alt--filled/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _checkboxScssJs = require("./checkbox.scss.js");
var _checkboxScssJsDefault = parcelHelpers.interopDefault(_checkboxScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Check box.
 *
 * @element cds-checkbox
 * @fires cds-checkbox-changed - The custom event fired after this changebox changes its checked state.
 * @csspart input The checkbox.
 * @csspart label The label.
 */ let CDSCheckbox = class CDSCheckbox extends (0, _focusJsDefault.default)((0, _formJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * Specify whether the underlying input should be checked
         */ this.checked = false;
        /**
         * Specify if checkbox is being used in a data table
         */ this.dataTable = false;
        /**
         * Specify whether the Checkbox should be disabled
         */ this.disabled = false;
        /**
         * Specify whether the checkbox should be present in the DOM,
         * but invisible and uninteractable. Used for data-table purposes.
         */ this.hideCheckbox = false;
        /**
         * Specify whether the label should be hidden, or not
         */ this.hideLabel = false;
        /**
         * Specify whether the Checkbox is in an indeterminate state
         */ this.indeterminate = false;
        /**
         * Provide a label to provide a description of the Checkbox input that you are
         * exposing to the user
         */ this.labelText = "";
        /**
         * Specify whether the Checkbox is read-only
         */ this.readonly = false;
        /**
         * Specify whether the Checkbox is currently invalid
         */ this.invalid = false;
        /**
         * Specify a title for the node for the Checkbox
         */ this.title = "";
        /**
         * Specify whether the Checkbox is in a warn state
         */ this.warn = false;
        /**
         * Provide the text that is displayed when the Checkbox is in a warn state
         */ this.warnText = false;
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
    }
    /**
     * Handles `click` event on the `<input>` in the shadow DOM.
     */ _handleChange() {
        const { checked, indeterminate } = this._checkboxNode;
        this.checked = checked;
        this.indeterminate = indeterminate;
        const { eventChange } = this.constructor;
        this.dispatchEvent(new CustomEvent(eventChange, {
            bubbles: true,
            composed: true,
            detail: {
                checked,
                indeterminate
            }
        }));
    }
    /**
     * Prevent checkbox state from updating when readonly
     */ _handleClick(event) {
        if (this.readonly) event.preventDefault();
    }
    _handleFormdata(event) {
        const { formData } = event; // TODO: Wait for `FormDataEvent` being available in `lib.dom.d.ts`
        const { checked, disabled, name, value = "on" } = this;
        if (!disabled && checked) formData.append(name, value);
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || // remove slug reference in v12
            elem.matches(this.constructor.slugItem) : false);
        this._hasAILabel = Boolean(hasContent);
        const type = hasContent[0].getAttribute("kind");
        hasContent[0].setAttribute("size", type === "inline" ? "md" : "mini");
        this.requestUpdate();
    }
    updated() {
        const { _hasAILabel: hasAILabel } = this;
        hasAILabel ? this.setAttribute("ai-label", "") : this.removeAttribute("ai-label");
    }
    render() {
        const { checked, disabled, helperText, hideLabel, indeterminate, invalid, invalidText, labelText, name, readonly, title, value, warn, warnText, _handleChange: handleChange, _handleClick: handleClick } = this;
        const showWarning = !readonly && !invalid && warn;
        const showHelper = !invalid && !warn;
        const helper = helperText ? (0, _lit.html)` <div class="${0, _settingsJs.prefix}--form__helper-text">${helperText}</div>` : null;
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--checkbox-label`]: true
        });
        const labelTextClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--checkbox-label-text`]: true,
            [`${0, _settingsJs.prefix}--visually-hidden`]: hideLabel
        });
        return (0, _lit.html)`
      <input
        id="checkbox"
        type="checkbox"
        part="input"
        class="${`${0, _settingsJs.prefix}--checkbox`}"
        aria-checked="${indeterminate ? "mixed" : String(Boolean(checked))}"
        aria-readonly="${String(Boolean(readonly))}"
        .checked="${checked}"
        ?disabled="${disabled}"
        .indeterminate="${indeterminate}"
        name="${(0, _ifDefinedJs.ifDefined)(name)}"
        value="${(0, _ifDefinedJs.ifDefined)(value)}"
        @change="${handleChange}"
        @click="${handleClick}" />
      <label
        for="checkbox"
        part="label"
        class="${labelClasses}"
        title="${(0, _ifDefinedJs.ifDefined)(title)}">
        <span class="${labelTextClasses}"
          >${labelText ? labelText : (0, _lit.html)`<slot></slot>`}</span
        >
      </label>
      <slot name="ai-label" @slotchange="${this._handleSlotChange}"></slot>
      <slot name="slug" @slotchange="${this._handleSlotChange}"></slot>
      <div class="${0, _settingsJs.prefix}--checkbox__validation-msg">
        ${!readonly && invalid ? (0, _lit.html)`
              ${(0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--checkbox__invalid-icon`
        })}
              <div class="${0, _settingsJs.prefix}--form-requirement">${invalidText}</div>
            ` : null}
        ${showWarning ? (0, _lit.html)`
              ${(0, _16JsDefault1.default)({
            class: `${(0, _settingsJs.prefix)}--checkbox__invalid-icon ${(0, _settingsJs.prefix)}--checkbox__invalid-icon--warning`
        })}
              <div class="${0, _settingsJs.prefix}--form-requirement">${warnText}</div>
            ` : null}
      </div>
      ${showHelper ? helper : null}
    `;
    }
    /**
     * The name of the custom event fired after this changebox changes its checked state.
     */ static get eventChange() {
        return `${0, _settingsJs.prefix}-checkbox-changed`;
    }
    /**
     * A selector that will return the slug item.
     *
     * Remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the ai-label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
};
CDSCheckbox.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSCheckbox.styles = (0, _checkboxScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("input")
], CDSCheckbox.prototype, "_checkboxNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "checked"
    })
], CDSCheckbox.prototype, "checked", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "data-table"
    })
], CDSCheckbox.prototype, "dataTable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSCheckbox.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        reflect: true,
        attribute: "helper-text"
    })
], CDSCheckbox.prototype, "helperText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "hide-checkbox"
    })
], CDSCheckbox.prototype, "hideCheckbox", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "hide-label"
    })
], CDSCheckbox.prototype, "hideLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSCheckbox.prototype, "indeterminate", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label-text"
    })
], CDSCheckbox.prototype, "labelText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSCheckbox.prototype, "name", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSCheckbox.prototype, "readonly", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSCheckbox.prototype, "invalid", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        attribute: "invalid-text"
    })
], CDSCheckbox.prototype, "invalidText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "title"
    })
], CDSCheckbox.prototype, "title", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSCheckbox.prototype, "value", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSCheckbox.prototype, "warn", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        attribute: "warn-text"
    })
], CDSCheckbox.prototype, "warnText", void 0);
CDSCheckbox = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-checkbox`)
], CDSCheckbox);
var CDSCheckbox$1 = CDSCheckbox;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit/directives/if-defined.js":"hSgrS","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","../../globals/mixins/form.js":"kISjL","../../icons/warning--filled/16.js":"ajngV","../../icons/warning--alt--filled/16.js":"21PDf","./checkbox.scss.js":"9Z8Xq","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Z8Xq":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item,:host(cds-checkbox){align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--checkbox-group *,.cds--checkbox-group :after,.cds--checkbox-group :before{box-sizing:inherit}.cds--form-item.cds--checkbox-wrapper,:host(cds-checkbox){margin-block-end:.375rem;position:relative}.cds--form-item.cds--checkbox-wrapper:first-of-type{margin-block-start:0}.cds--label+.cds--form-item.cds--checkbox-wrapper,.cds--label+:host(cds-checkbox){margin-block-start:-.125rem}.cds--form-item.cds--checkbox-wrapper:last-of-type{margin-block-end:.1875rem}.cds--checkbox{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;inset-block-start:1.25rem;inset-inline-start:.7rem;visibility:inherit;white-space:nowrap}.cds--checkbox-label{cursor:pointer;display:flex;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);min-block-size:1.25rem;padding-block-start:.0625rem;padding-inline-start:1.25rem;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none}.cds--checkbox-label html{font-size:100%}.cds--checkbox-label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--checkbox-label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--checkbox-label strong{font-weight:600}.cds--checkbox-label-text{padding-inline-start:.625rem}.cds--checkbox-label:after,.cds--checkbox-label:before{box-sizing:border-box}@media print{.cds--checkbox-label:after,.cds--checkbox-label:before{-webkit-print-color-adjust:exact;print-color-adjust:exact}}.cds--checkbox-label:before{background-color:transparent;block-size:1rem;border:1px solid var(--cds-icon-primary,#161616);border-radius:2px;content:"";inline-size:1rem;inset-block-start:.125rem;inset-inline-start:0;margin-block:.0625rem .125rem;margin-inline:.1875rem 0;position:absolute}.cds--checkbox-label:after{background:none;block-size:.3125rem;border-block-end:1.5px solid var(--cds-icon-inverse,#fff);border-inline-start:1.5px solid var(--cds-icon-inverse,#fff);content:"";inline-size:.5625rem;inset-block-start:.40625rem;inset-inline-start:.4375rem;margin-block-start:-.1875rem;position:absolute;transform:scale(0) rotate(-45deg);transform-origin:bottom right}.cds--checkbox-label[data-contained-checkbox-state=true]:before,.cds--checkbox:checked+.cds--checkbox-label:before,.cds--checkbox:indeterminate+.cds--checkbox-label:before{background-color:var(--cds-icon-primary,#161616);border:1px}.cds--checkbox-label[data-contained-checkbox-state=true]:after,.cds--checkbox:checked+.cds--checkbox-label:after{transform:scale(1) rotate(-45deg)}.cds--checkbox:indeterminate+.cds--checkbox-label:after{border-block-end:2px solid var(--cds-icon-inverse,#fff);border-inline-start:0 solid var(--cds-icon-inverse,#fff);inline-size:.5rem;inset-block-start:.6875rem;transform:scale(1) rotate(0deg)}.cds--checkbox-label[data-contained-checkbox-state=true].cds--checkbox-label__focus:before,.cds--checkbox-label__focus:before,.cds--checkbox:checked:focus+.cds--checkbox-label:before,.cds--checkbox:focus+.cds--checkbox-label:before,.cds--checkbox:indeterminate:focus+.cds--checkbox-label:before{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--checkbox-label[data-contained-checkbox-disabled=true],.cds--checkbox:disabled+.cds--checkbox-label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--checkbox-label[data-contained-checkbox-disabled=true]:before,.cds--checkbox:disabled+.cds--checkbox-label:before{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-label[data-contained-checkbox-state=true][data-contained-checkbox-disabled=true]:before,.cds--checkbox:checked:disabled+.cds--checkbox-label:before,.cds--checkbox:indeterminate:disabled+.cds--checkbox-label:before{background-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group[data-invalid] .cds--checkbox-label:before,.cds--checkbox-wrapper--invalid .cds--checkbox-label:before,.cds--checkbox-wrapper--invalid .cds--checkbox:checked+.cds--checkbox-label:before,:host(cds-checkbox:not([readonly])[invalid]) .cds--checkbox-label:before{border:1px solid var(--cds-support-error,#da1e28)}.cds--checkbox-group .cds--checkbox-wrapper--invalid>.cds--checkbox__validation-msg,.cds--checkbox-group .cds--checkbox-wrapper--warning>.cds--checkbox__validation-msg,.cds--checkbox-group .cds--checkbox-wrapper>.cds--form__helper-text,.cds--checkbox-group :host(cds-checkbox)>.cds--form__helper-text,.cds--checkbox-group :host(cds-checkbox:not([readonly]):not([invalid])[warn])>.cds--checkbox__validation-msg,.cds--checkbox-group :host(cds-checkbox:not([readonly])[invalid])>.cds--checkbox__validation-msg{display:none}.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox-label:before,.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox:checked+.cds--checkbox-label:before,.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) :host(cds-checkbox:not([readonly])[invalid]) .cds--checkbox-label:before{border:1px solid var(--cds-icon-primary,#161616)}.cds--checkbox-group__validation-msg,.cds--checkbox__validation-msg{align-items:flex-start;display:none;inline-size:100%;margin-block-start:.25rem}.cds--checkbox__invalid-icon{margin:.0625rem .0625rem 0 .1875rem;fill:var(--cds-support-error,#da1e28);min-inline-size:1rem}.cds--checkbox__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--checkbox__invalid-icon--warning path:first-of-type{fill:#000}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg,.cds--checkbox-group--warning .cds--checkbox-group__validation-msg,.cds--checkbox-wrapper--invalid>.cds--checkbox__validation-msg,.cds--checkbox-wrapper--warning>.cds--checkbox__validation-msg,:host(cds-checkbox:not([readonly]):not([invalid])[warn])>.cds--checkbox__validation-msg,:host(cds-checkbox:not([readonly])[invalid])>.cds--checkbox__validation-msg{display:flex}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-group--warning .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--warning .cds--checkbox__validation-msg .cds--form-requirement,:host(cds-checkbox:not([readonly]):not([invalid])[warn]) .cds--checkbox__validation-msg .cds--form-requirement,:host(cds-checkbox:not([readonly])[invalid]) .cds--checkbox__validation-msg .cds--form-requirement{display:block;margin-block-start:0;margin-inline-start:.5rem;max-block-size:100%;overflow:visible}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement,:host(cds-checkbox:not([readonly])[invalid]) .cds--checkbox__validation-msg .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--checkbox-group--readonly .cds--checkbox-label,.cds--checkbox-wrapper--readonly .cds--checkbox-label,:host(cds-checkbox[readonly]) .cds--checkbox-label{cursor:default}.cds--checkbox-group--readonly .cds--checkbox-label-text,.cds--checkbox-wrapper--readonly .cds--checkbox-label-text,:host(cds-checkbox[readonly]) .cds--checkbox-label-text{cursor:text;-webkit-user-select:text;-moz-user-select:text;user-select:text}.cds--checkbox-group--readonly .cds--checkbox+.cds--checkbox-label:before,.cds--checkbox-wrapper--readonly .cds--checkbox+.cds--checkbox-label:before,:host(cds-checkbox[readonly]) .cds--checkbox+.cds--checkbox-label:before{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group--readonly .cds--checkbox:checked+.cds--checkbox-label:before,.cds--checkbox-wrapper--readonly .cds--checkbox:checked+.cds--checkbox-label:before,:host(cds-checkbox[readonly]) .cds--checkbox:checked+.cds--checkbox-label:before{background:transparent;border:1px solid var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group--readonly .cds--checkbox:checked+.cds--checkbox-label:after,.cds--checkbox-wrapper--readonly .cds--checkbox:checked+.cds--checkbox-label:after,:host(cds-checkbox[readonly]) .cds--checkbox:checked+.cds--checkbox-label:after{border-color:var(--cds-text-primary,#161616)}.cds--checkbox-skeleton .cds--checkbox-label{cursor:default}.cds--checkbox-label-text.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;inline-size:6.25rem;margin-block:.0625rem 0;margin-inline:.375rem 0;padding:0;pointer-events:none;position:relative}.cds--checkbox-label-text.cds--skeleton:active,.cds--checkbox-label-text.cds--skeleton:focus,.cds--checkbox-label-text.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--checkbox-label-text.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--checkbox-label-text.cds--skeleton:before{animation:none}}.cds--checkbox--inline{position:relative}[dir=rtl] .cds--checkbox-label:after{margin-block-start:0;margin-inline-start:-.0625rem;transform-origin:center}[dir=rtl] .cds--checkbox-label[data-contained-checkbox-state=true]:after,[dir=rtl] .cds--checkbox:checked+.cds--checkbox-label:after{transform:scale(1.2) rotate3d(.5,1,0,158deg)}.cds--checkbox-group--decorator legend.cds--label,.cds--checkbox-group--slug legend.cds--label,.cds--checkbox-wrapper--decorator .cds--checkbox-label-text,.cds--checkbox-wrapper--slug .cds--checkbox-label-text{display:flex}.cds--checkbox-group--decorator legend.cds--label .cds--checkbox-group-inner--decorator>*,.cds--checkbox-group--slug legend.cds--label .cds--ai-label,.cds--checkbox-group--slug legend.cds--label .cds--slug,.cds--checkbox-wrapper--decorator .cds--checkbox-label-text .cds--checkbox-wrapper-inner--decorator>*,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--ai-label,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug{margin-inline-start:.5rem}.cds--checkbox-wrapper--decorator .cds--checkbox-label-text .cds--ai-label__button--inline,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--ai-label__button--inline,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug__button--inline{line-height:inherit;margin-block-start:-.0625rem}.cds--checkbox-group--horizontal{display:flex;flex-flow:row wrap;justify-content:flex-start;position:relative}.cds--checkbox-group--horizontal .cds--form-item,.cds--checkbox-group--horizontal :host(cds-checkbox){flex:none;margin-block-end:0}.cds--checkbox-group--horizontal .cds--form-item:not(:last-of-type),.cds--checkbox-group--horizontal :not(:last-of-type):host(cds-checkbox){margin-inline-end:1rem}.cds--checkbox-group--horizontal .cds--checkbox-label-text{padding-inline-start:.5rem}.cds--checkbox-group--horizontal .cds--label+.cds--form-item.cds--checkbox-wrapper,.cds--checkbox-group--horizontal .cds--label+:host(cds-checkbox){margin-block-start:0}:host(cds-checkbox:dir(rtl)) .cds--checkbox-label[data-contained-checkbox-state=true]:after,:host(cds-checkbox:dir(rtl)) .cds--checkbox:checked+.cds--checkbox-label:after{margin-block-start:0;margin-inline-start:to-rem(-1px);transform:scale(1.2) rotate3d(.5,1,0,158deg);transform-origin:center}:host(cds-checkbox[invalid-group]) .cds--checkbox-label:before{border-color:var(--cds-support-error,#da1e28)}:host(cds-checkbox[data-table]){margin:0}:host(cds-checkbox[data-table][hide-checkbox]){pointer-events:none}:host(cds-checkbox[data-table][hide-checkbox]) .cds--checkbox-label:after,:host(cds-checkbox[data-table][hide-checkbox]) .cds--checkbox-label:before{background-color:transparent;border-color:transparent}:host(cds-checkbox-skeleton) .cds--checkbox-label{cursor:default}:host(cds-checkbox-group){display:flex}:host(cds-checkbox-group) .cds--checkbox-group--slug ::slotted(cds-ai-label),:host(cds-checkbox-group) .cds--checkbox-group--slug ::slotted(cds-slug),:host(cds-checkbox[ai-label]) ::slotted(cds-ai-label),:host(cds-checkbox[ai-label]) ::slotted(cds-slug){margin-inline-start:.5rem}:host(cds-checkbox[ai-label]){flex-direction:row}:host(cds-checkbox[ai-label]) .cds--checkbox-label-text{display:flex}:host(cds-checkbox[ai-label]) ::slotted(cds-ai-label),:host(cds-checkbox[ai-label]) ::slotted(cds-slug){align-self:center}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f7lE9":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSCheckboxGroup$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _16Js = require("../../icons/warning--filled/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/warning--alt--filled/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _checkboxScssJs = require("./checkbox.scss.js");
var _checkboxScssJsDefault = parcelHelpers.interopDefault(_checkboxScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Check box.
 *
 * @element cds-checkbox
 * @fires cds-checkbox-changed - The custom event fired after this changebox changes its checked state.
 * @csspart input The checkbox.
 * @csspart label The label.
 */ let CDSCheckboxGroup = class CDSCheckboxGroup extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Whether the CheckboxGroup should be read-only
         */ this.readonly = false;
        /**
         * Specify whether the form group is currently in warning state
         */ this.warn = false;
        /**
         * Provide the text that is displayed when the form group is in warning state
         */ this.warnText = "";
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
    }
    /*
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || // remove slug reference in v12
            elem.matches(this.constructor.slugItem) : false);
        this._hasAILabel = Boolean(hasContent);
        hasContent[0].setAttribute("size", "mini");
        this.requestUpdate();
    }
    updated(changedProperties) {
        const { selectorCheckbox } = this.constructor;
        const checkboxes = this.querySelectorAll(selectorCheckbox);
        [
            "disabled",
            "readonly"
        ].forEach((name)=>{
            if (changedProperties.has(name)) {
                const { [name]: value } = this;
                // Propagate the property to descendants until `:host-context()` gets supported in all major browsers
                checkboxes.forEach((elem)=>{
                    elem[name] = value;
                });
            }
        });
        if (changedProperties.has("invalid")) {
            const { invalid } = this;
            checkboxes.forEach((elem)=>{
                if (invalid) elem.setAttribute("invalid-group", "");
                else elem.removeAttribute("invalid-group");
            });
        }
    }
    render() {
        const { ariaLabelledBy, disabled, helperText, invalid, invalidText, legendId, legendText, readonly, warn, warnText, _hasAILabel: hasAILabel, _handleSlotChange: handleSlotChange } = this;
        const showWarning = !readonly && !invalid && warn;
        const showHelper = !invalid && !warn;
        const checkboxGroupInstanceId = Math.random().toString(16).slice(2);
        const helperId = !helperText ? undefined : `checkbox-group-helper-text-${checkboxGroupInstanceId}`;
        const helper = helperText ? (0, _lit.html)` <div id="${helperId}" class="${0, _settingsJs.prefix}--form__helper-text">
          ${helperText}
        </div>` : null;
        const fieldsetClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--checkbox-group`]: true,
            [`${0, _settingsJs.prefix}--checkbox-group--readonly`]: readonly,
            [`${0, _settingsJs.prefix}--checkbox-group--invalid`]: !readonly && invalid,
            [`${0, _settingsJs.prefix}--checkbox-group--warning`]: showWarning,
            [`${0, _settingsJs.prefix}--checkbox-group--slug`]: hasAILabel
        });
        return (0, _lit.html)`
      <fieldset
        class="${fieldsetClasses}"
        ?data-invalid=${invalid}
        ?disabled=${disabled}
        aria-readonly=${readonly}
        ?aria-labelledby=${ariaLabelledBy || legendId}
        ?aria-describedby=${!invalid && !warn && helper ? helperId : undefined}>
        <legend class="${0, _settingsJs.prefix}--label" id=${legendId || ariaLabelledBy}>
          ${legendText}
          <slot name="ai-label" @slotchange="${handleSlotChange}"></slot>
          <slot name="slug" @slotchange="${handleSlotChange}"></slot>
        </legend>
        <slot></slot>
        <div class="${0, _settingsJs.prefix}--checkbox-group__validation-msg">
          ${!readonly && invalid ? (0, _lit.html)`
                ${(0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--checkbox__invalid-icon`
        })}
                <div class="${0, _settingsJs.prefix}--form-requirement">${invalidText}</div>
              ` : null}
          ${showWarning ? (0, _lit.html)`
                ${(0, _16JsDefault1.default)({
            class: `${(0, _settingsJs.prefix)}--checkbox__invalid-icon ${(0, _settingsJs.prefix)}--checkbox__invalid-icon--warning`
        })}
                <div class="${0, _settingsJs.prefix}--form-requirement">${warnText}</div>
              ` : null}
        </div>
        ${showHelper ? helper : null}
      </fieldset>
    `;
    }
    /**
     * A selector that will return the checkboxes.
     */ static get selectorCheckbox() {
        return `${0, _settingsJs.prefix}-checkbox`;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
};
CDSCheckboxGroup.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSCheckboxGroup.styles = (0, _checkboxScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        reflect: true,
        attribute: "aria-labelledby"
    })
], CDSCheckboxGroup.prototype, "ariaLabelledBy", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSCheckboxGroup.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        reflect: true,
        attribute: "helper-text"
    })
], CDSCheckboxGroup.prototype, "helperText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "invalid"
    })
], CDSCheckboxGroup.prototype, "invalid", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        reflect: true,
        attribute: "invalid-text"
    })
], CDSCheckboxGroup.prototype, "invalidText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        reflect: true,
        attribute: "legend-id"
    })
], CDSCheckboxGroup.prototype, "legendId", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        reflect: true,
        attribute: "legend-text"
    })
], CDSCheckboxGroup.prototype, "legendText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSCheckboxGroup.prototype, "readonly", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSCheckboxGroup.prototype, "warn", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        reflect: true,
        attribute: "warn-text"
    })
], CDSCheckboxGroup.prototype, "warnText", void 0);
CDSCheckboxGroup = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-checkbox-group`)
], CDSCheckboxGroup);
var CDSCheckboxGroup$1 = CDSCheckboxGroup;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../icons/warning--filled/16.js":"ajngV","../../icons/warning--alt--filled/16.js":"21PDf","./checkbox.scss.js":"9Z8Xq","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gxttH":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSCheckboxSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _checkboxScssJs = require("./checkbox.scss.js");
var _checkboxScssJsDefault = parcelHelpers.interopDefault(_checkboxScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of number input.
 */ let CDSCheckboxSkeleton = class CDSCheckboxSkeleton extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)`
      <label class="${0, _settingsJs.prefix}--checkbox-label" for="checkbox" part="label">
        <span class="${0, _settingsJs.prefix}--checkbox-label-text ${0, _settingsJs.prefix}--skeleton"
          ><slot></slot
        ></span>
      </label>
    `;
    }
};
CDSCheckboxSkeleton.styles = (0, _checkboxScssJsDefault.default);
CDSCheckboxSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-checkbox-skeleton`)
], CDSCheckboxSkeleton);
var CDSCheckboxSkeleton$1 = CDSCheckboxSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./checkbox.scss.js":"9Z8Xq","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2G8F5":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _codeSnippetJs = require("./code-snippet.js");
var _codeSnippetSkeletonJs = require("./code-snippet-skeleton.js");

},{"./code-snippet.js":"7EfhY","./code-snippet-skeleton.js":"5b0dc"}],"7EfhY":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CODE_SNIPPET_TYPE", ()=>(0, _defsJs.CODE_SNIPPET_TYPE));
parcelHelpers.export(exports, "CODE_SNIPPET_COLOR_SCHEME", ()=>(0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME));
parcelHelpers.export(exports, "default", ()=>CDSCodeSnippet$1);
var _tslib = require("tslib");
var _styleMapJs = require("lit/directives/style-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _16Js = require("../../icons/chevron--down/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _defsJs = require("./defs.js");
var _codeSnippetScssJs = require("./code-snippet.scss.js");
var _codeSnippetScssJsDefault = parcelHelpers.interopDefault(_codeSnippetScssJs);
var _copyButtonJs = require("../copy-button/copy-button.js");
var _copyJs = require("../copy/copy.js");
var _buttonJs = require("../button/button.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _sharedEnumsJs = require("../../globals/shared-enums.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Observes resize of the given element with the given resize observer.
 *
 * @param observer The resize observer.
 * @param elem The element to observe the resize.
 */ const observeResize = (observer, elem)=>{
    if (!elem) return null;
    observer.observe(elem);
    return {
        release () {
            observer.unobserve(elem);
            return null;
        }
    };
};
/**
 * Basic code snippet.
 *
 * @element cds-code-snippet
 */ let CDSCodeSnippet = class CDSCodeSnippet extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` to expand multi-line variant of code snippet.
         */ this._expandedCode = false;
        /**
         * The handle for observing resize of the parent element of this element.
         */ this._hObserveResize = null;
        /**
         * Row height in pixels
         */ this._rowHeightInPixels = 16;
        /**
         * `true` if code-snippet has right overflow
         */ this._hasRightOverflow = true;
        /**
         * `true` if code-snippet has left overflow
         */ this._hasLeftOverflow = false;
        /**
         * `true` if show more or show less btn is visible
         */ this._shouldShowMoreLessBtn = false;
        /**
         * The `ResizeObserver` instance for observing element resizes for re-positioning floating menu position.
         */ // TODO: Wait for `.d.ts` update to support `ResizeObserver`
        // @ts-ignore
        this._resizeObserver = new ResizeObserver(()=>{
            var _a;
            const codeContainerRef = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.${(0, _settingsJs.prefix)}--snippet-container`);
            const codeContentRef = codeContainerRef === null || codeContainerRef === void 0 ? void 0 : codeContainerRef.querySelector("code"); // PRE?
            const { type, maxCollapsedNumberOfRows, maxExpandedNumberOfRows, minExpandedNumberOfRows, _rowHeightInPixels: rowHeightInPixels, _handleScroll: handleScroll } = this;
            if (codeContentRef && type === (0, _defsJs.CODE_SNIPPET_TYPE).MULTI) {
                const { height } = codeContentRef.getBoundingClientRect();
                if (maxCollapsedNumberOfRows > 0 && (maxExpandedNumberOfRows <= 0 || maxExpandedNumberOfRows > maxCollapsedNumberOfRows) && height > maxCollapsedNumberOfRows * rowHeightInPixels) this._shouldShowMoreLessBtn = true;
                else this._shouldShowMoreLessBtn = false;
                if (this._expandedCode && minExpandedNumberOfRows > 0 && height <= minExpandedNumberOfRows * rowHeightInPixels) this._expandedCode = false;
            }
            if (codeContentRef && type === (0, _defsJs.CODE_SNIPPET_TYPE).MULTI || codeContainerRef && type === (0, _defsJs.CODE_SNIPPET_TYPE).SINGLE) handleScroll();
            this.requestUpdate();
        });
        /**
         * Optional text to copy. If not specified, the `children` node's `innerText`
         * will be used as the copy value.
         */ this.copyText = "";
        /**
         * `true` if the button should be disabled.
         */ this.disabled = false;
        /**
         * Specify the string displayed when the snippet is copied
         */ this.feedback = "Copied!";
        /**
         * Specify the time it takes for the feedback message to timeout
         */ this.feedbackTimeout = 2000;
        /**
         * Specify whether or not a copy button should be used/rendered.
         */ this.hideCopyButton = false;
        /**
         * Specify the maximum number of rows to be shown when in collapsed view
         */ this.maxCollapsedNumberOfRows = 15;
        /**
         * Specify the maximum number of rows to be shown when in expanded view
         */ this.maxExpandedNumberOfRows = 0;
        /**
         * Specify the minimum number of rows to be shown when in collapsed view
         */ this.minCollapsedNumberOfRows = 3;
        /**
         * Specify the minimum number of rows to be shown when in expanded view
         */ this.minExpandedNumberOfRows = 16;
        /**
         * Specify a string that is displayed when the Code Snippet has been
         * interacted with to show less lines
         */ this.showLessText = "Show less";
        /**
         * Specify a string that is displayed when the Code Snippet text is more
         * than 15 lines
         */ this.showMoreText = "Show more";
        /**
         * Tooltip content for the copy button.
         */ this.tooltipContent = "Copy to clipboard";
        /**
         * `true` if the button should be disabled.
         */ this.wrapText = false;
        /**
         * The type of code snippet.
         */ this.type = (0, _defsJs.CODE_SNIPPET_TYPE).SINGLE;
    }
    /**
     * Handles `click` event on the copy button.
     */ _handleCopyClick() {
        const { ownerDocument: doc } = this;
        const selection = doc.defaultView.getSelection();
        selection.removeAllRanges();
        const code = doc.createElement("code");
        code.className = `${0, _settingsJs.prefix}--visually-hidden`;
        const pre = doc.createElement("pre");
        const text = Array.from(this.childNodes).filter((node)=>node.nodeType === Node.TEXT_NODE);
        pre.textContent = this.copyText || text[0].textContent;
        code.appendChild(pre);
        // Using `<code>` in shadow DOM seems to lose the LFs in some browsers
        doc.body.appendChild(code);
        const range = doc.createRange();
        range.selectNodeContents(code);
        selection.addRange(range);
        doc.execCommand("copy");
        doc.body.removeChild(code);
        selection.removeAllRanges();
    }
    // eslint-disable-next-line class-methods-use-this
    _getCodeRefDimensions(ref) {
        const { clientWidth: codeClientWidth, scrollLeft: codeScrollLeft, scrollWidth: codeScrollWidth } = ref;
        return {
            horizontalOverflow: codeScrollWidth > codeClientWidth,
            codeClientWidth,
            codeScrollWidth,
            codeScrollLeft
        };
    }
    /**
     * Handles `scroll` event.
     */ _handleScroll() {
        var _a;
        if (this) {
            const codeContainerRef = (_a = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.${(0, _settingsJs.prefix)}--snippet-container`);
            const codeContentRef = codeContainerRef === null || codeContainerRef === void 0 ? void 0 : codeContainerRef.querySelector("pre");
            if (this.type === (0, _defsJs.CODE_SNIPPET_TYPE).INLINE || this.type === (0, _defsJs.CODE_SNIPPET_TYPE).SINGLE && !codeContainerRef || this.type === (0, _defsJs.CODE_SNIPPET_TYPE).MULTI && !codeContentRef) return;
            const { horizontalOverflow, codeClientWidth, codeScrollWidth, codeScrollLeft } = this.type === (0, _defsJs.CODE_SNIPPET_TYPE).SINGLE ? this._getCodeRefDimensions(codeContainerRef) : this._getCodeRefDimensions(codeContentRef);
            this._hasLeftOverflow = horizontalOverflow && !!codeScrollLeft;
            this._hasRightOverflow = horizontalOverflow && codeScrollLeft + codeClientWidth !== codeScrollWidth;
            this.requestUpdate();
        }
    }
    /**
     * Handles `click` event on the show more or show less button.
     */ _handleClickExpanded() {
        this._expandedCode = !this._expandedCode;
        this.requestUpdate();
    }
    connectedCallback() {
        super.connectedCallback();
        if (this._hObserveResize) this._hObserveResize = this._hObserveResize.release();
        this._hObserveResize = observeResize(this._resizeObserver, this);
    }
    disconnectedCallback() {
        if (this._hObserveResize) this._hObserveResize = this._hObserveResize.release();
    }
    updated() {
        if (this._expandedCode) this.setAttribute("expanded-code", "");
        else this.removeAttribute("expanded-code");
    }
    render() {
        const { disabled, feedback, feedbackTimeout, hideCopyButton, maxExpandedNumberOfRows, minExpandedNumberOfRows, maxCollapsedNumberOfRows, minCollapsedNumberOfRows, type, wrapText, tooltipContent, showMoreText, showLessText, _expandedCode: expandedCode, _handleCopyClick: handleCopyClick, _handleScroll: handleScroll, _hasRightOverflow: hasRightOverflow, _hasLeftOverflow: hasLeftOverflow, _rowHeightInPixels: rowHeightInPixels, _shouldShowMoreLessBtn: shouldShowMoreLessBtn } = this;
        let classes = `${(0, _settingsJs.prefix)}--snippet`;
        type && (classes += ` ${0, _settingsJs.prefix}--snippet--${type}`);
        type !== "inline" && disabled && (classes += ` ${0, _settingsJs.prefix}--snippet--disabled`);
        hideCopyButton && (classes += ` ${0, _settingsJs.prefix}--snippet--no-copy`);
        wrapText && (classes += ` ${0, _settingsJs.prefix}--snippet--wraptext`);
        type == "multi" && hasRightOverflow && (classes += ` ${0, _settingsJs.prefix}--snippet--has-right-overflow`);
        const expandButtonClass = `${(0, _settingsJs.prefix)}--snippet-btn--expand`;
        const disabledCopyButtonClasses = disabled ? `${0, _settingsJs.prefix}--snippet--disabled` : "";
        const expandCodeBtnText = expandedCode ? showLessText : showMoreText;
        if (type === (0, _defsJs.CODE_SNIPPET_TYPE).INLINE) // Ensures no extra whitespace text node
        // prettier-ignore
        return (0, _lit.html)`
        <cds-copy button-class-name="${classes}" @click="${handleCopyClick}">
          <code slot="icon"><slot></slot></code>
          <span slot="tooltip-content">${tooltipContent}</span>
        </cds-copy>
      `;
        const styles = {};
        if (type === "multi") {
            if (expandedCode) {
                if (maxExpandedNumberOfRows > 0) styles["max-height"] = maxExpandedNumberOfRows * rowHeightInPixels + "px";
                if (minExpandedNumberOfRows > 0) styles["min-height"] = minExpandedNumberOfRows * rowHeightInPixels + "px";
            } else {
                if (maxCollapsedNumberOfRows > 0) styles["max-height"] = maxCollapsedNumberOfRows * rowHeightInPixels + "px";
                if (minCollapsedNumberOfRows > 0) styles["min-height"] = minCollapsedNumberOfRows * rowHeightInPixels + "px";
            }
        }
        return (0, _lit.html)`
      <div
        role="${type === (0, _defsJs.CODE_SNIPPET_TYPE).SINGLE || type === (0, _defsJs.CODE_SNIPPET_TYPE).MULTI ? "textbox" : null}"
        tabindex="${(type === (0, _defsJs.CODE_SNIPPET_TYPE).SINGLE || type === (0, _defsJs.CODE_SNIPPET_TYPE).MULTI) && !disabled ? 0 : null}"
        class="${0, _settingsJs.prefix}--snippet-container"
        aria-label="${"code-snippet"}"
        aria-readonly="${type === (0, _defsJs.CODE_SNIPPET_TYPE).SINGLE || type === (0, _defsJs.CODE_SNIPPET_TYPE).MULTI ? true : null}"
        aria-multiline="${type === (0, _defsJs.CODE_SNIPPET_TYPE).MULTI ? true : null}"
        @scroll="${type === (0, _defsJs.CODE_SNIPPET_TYPE).SINGLE && handleScroll || null}"
        style=${(0, _styleMapJs.styleMap)(styles)}>
        <pre
          @scroll="${type === (0, _defsJs.CODE_SNIPPET_TYPE).MULTI && handleScroll || null}"><code><slot></slot></code></pre>
      </div>

      ${hasLeftOverflow ? (0, _lit.html)`
            <div class="${0, _settingsJs.prefix}--snippet__overflow-indicator--left"></div>
          ` : ``}
      ${hasRightOverflow && type !== (0, _defsJs.CODE_SNIPPET_TYPE).MULTI ? (0, _lit.html)`
            <div class="${0, _settingsJs.prefix}--snippet__overflow-indicator--right"></div>
          ` : ``}
      ${hideCopyButton ? `` : (0, _lit.html)`
            <cds-copy-button
              ?disabled=${disabled}
              button-class-name=${disabledCopyButtonClasses}
              feedback=${feedback}
              feedback-timeout=${feedbackTimeout}
              @click="${handleCopyClick}">
              ${tooltipContent}
            </cds-copy-button>
          `}
      ${shouldShowMoreLessBtn ? (0, _lit.html)`
            <cds-button
              kind="ghost"
              size="sm"
              button-class-name=${expandButtonClass}
              ?disabled=${disabled}
              @click=${()=>this._handleClickExpanded()}>
              <span class="${0, _settingsJs.prefix}--snippet-btn--text">
                ${expandCodeBtnText}
              </span>
              ${(0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--icon-chevron--down ${(0, _settingsJs.prefix)}--snippet__icon`,
            name: "cheveron--down",
            role: "img",
            slot: "icon"
        })}
            </cds-button>
          ` : ``}
    `;
    }
};
CDSCodeSnippet.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSCodeSnippet.styles = (0, _codeSnippetScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "copy-text"
    })
], CDSCodeSnippet.prototype, "copyText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSCodeSnippet.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSCodeSnippet.prototype, "feedback", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        attribute: "feedback-timeout"
    })
], CDSCodeSnippet.prototype, "feedbackTimeout", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "hide-copy-button"
    })
], CDSCodeSnippet.prototype, "hideCopyButton", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSCodeSnippet.prototype, "maxCollapsedNumberOfRows", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSCodeSnippet.prototype, "maxExpandedNumberOfRows", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSCodeSnippet.prototype, "minCollapsedNumberOfRows", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSCodeSnippet.prototype, "minExpandedNumberOfRows", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "show-less-text"
    })
], CDSCodeSnippet.prototype, "showLessText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "show-more-text"
    })
], CDSCodeSnippet.prototype, "showMoreText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "tooltip-content"
    })
], CDSCodeSnippet.prototype, "tooltipContent", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "wrap-text"
    })
], CDSCodeSnippet.prototype, "wrapText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSCodeSnippet.prototype, "type", void 0);
CDSCodeSnippet = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-code-snippet`)
], CDSCodeSnippet);
var CDSCodeSnippet$1 = CDSCodeSnippet;

},{"tslib":"gBS4y","lit/directives/style-map.js":"3KsV8","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/chevron--down/16.js":"kXGdJ","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./defs.js":"zAbor","./code-snippet.scss.js":"lgTl0","../copy-button/copy-button.js":"cyRrk","../copy/copy.js":"iHWQT","../button/button.js":"ca52G","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/shared-enums.js":"12kea","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3KsV8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styleMapJs = require("lit-html/directives/style-map.js");
parcelHelpers.exportAll(_styleMapJs, exports);

},{"lit-html/directives/style-map.js":"2iyIA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2iyIA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleMap", ()=>o);
var _litHtmlJs = require("../lit-html.js");
var _directiveJs = require("../directive.js");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const n = "important", i = " !" + n, o = (0, _directiveJs.directive)(class extends (0, _directiveJs.Directive) {
    constructor(t){
        if (super(t), t.type !== (0, _directiveJs.PartType).ATTRIBUTE || "style" !== t.name || t.strings?.length > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ft) return this.ft = new Set(Object.keys(r)), this.render(r);
        for (const t of this.ft)null == r[t] && (this.ft.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = null);
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ft.add(t);
                const r = "string" == typeof e && e.endsWith(i);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? n : "") : s[t] = e;
            }
        }
        return 0, _litHtmlJs.noChange;
    }
});

},{"../lit-html.js":"4A25t","../directive.js":"k6ssg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"zAbor":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CODE_SNIPPET_COLOR_SCHEME", ()=>(0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME));
parcelHelpers.export(exports, "CODE_SNIPPET_TYPE", ()=>CODE_SNIPPET_TYPE);
var _sharedEnumsJs = require("../../globals/shared-enums.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Code snippet types.
 */ var CODE_SNIPPET_TYPE;
(function(CODE_SNIPPET_TYPE) {
    /**
     * Single variant.
     */ CODE_SNIPPET_TYPE["SINGLE"] = "single";
    /**
     * Inline variant.
     */ CODE_SNIPPET_TYPE["INLINE"] = "inline";
    /**
     * Multi-line variant.
     */ CODE_SNIPPET_TYPE["MULTI"] = "multi";
})(CODE_SNIPPET_TYPE || (CODE_SNIPPET_TYPE = {}));

},{"../../globals/shared-enums.js":"12kea","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lgTl0":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--copy-btn{position:relative}.cds--copy-btn:hover{background-color:var(--cds-layer-hover)}.cds--copy-btn:active{background-color:var(--cds-layer-active)}.cds--copy-btn:before{block-size:0;border-style:solid;content:"";display:none;inline-size:0;position:absolute;z-index:6000}.cds--copy-btn .cds--copy-btn__feedback{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));box-sizing:content-box;color:var(--cds-text-inverse,#fff);display:none;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:auto;max-inline-size:13rem;min-inline-size:1.5rem;overflow:visible;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000;clip:auto}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--copy-btn .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-accelerator:true){.cds--copy-btn .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--copy-btn .cds--copy-btn__feedback{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--copy-btn .cds--copy-btn__feedback{border:1px solid transparent}}.cds--copy-btn.cds--copy-btn--animating .cds--copy-btn__feedback,.cds--copy-btn.cds--copy-btn--animating:before{display:block}.cds--copy-btn.cds--copy-btn--animating:before{border:none}.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-out .cds--copy-btn__feedback,.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-out:before{animation:cds--hide-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-in .cds--copy-btn__feedback,.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-in:before{animation:cds--show-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--copy-btn svg{fill:var(--cds-icon-primary,#161616)}.cds--copy{font-size:0}.cds--snippet html,:host(cds-code-snippet) html,:host(cds-code-snippet-skeleton) html{font-size:100%}.cds--snippet body,:host(cds-code-snippet) body,:host(cds-code-snippet-skeleton) body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--snippet code,:host(cds-code-snippet) code,:host(cds-code-snippet-skeleton) code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--snippet strong,:host(cds-code-snippet) strong,:host(cds-code-snippet-skeleton) strong{font-weight:600}.cds--snippet--disabled,.cds--snippet--disabled .cds--btn.cds--snippet-btn--expand,:host(cds-code-snippet[disabled]),:host(cds-code-snippet[disabled]) .cds--btn.cds--snippet-btn--expand{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--snippet--disabled .cds--copy-btn,.cds--snippet--disabled .cds--copy-btn:hover,.cds--snippet--disabled .cds--snippet-btn--expand:hover,:host(cds-code-snippet[disabled]) .cds--copy-btn,:host(cds-code-snippet[disabled]) .cds--snippet-btn--expand:hover{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--snippet--disabled .cds--snippet-btn--expand .cds--icon-chevron--down,.cds--snippet--disabled .cds--snippet__icon,:host(cds-code-snippet[disabled]) .cds--snippet-btn--expand .cds--icon-chevron--down,:host(cds-code-snippet[disabled]) .cds--snippet__icon{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--snippet code,:host(cds-code-snippet) code,:host(cds-code-snippet-skeleton) code{font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333)}.cds--snippet--inline{background-color:var(--cds-layer);border:1px solid transparent;border-radius:4px;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline;padding:0;position:relative}.cds--snippet--inline html{font-size:100%}.cds--snippet--inline body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--snippet--inline code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--snippet--inline strong{font-weight:600}.cds--snippet--inline:hover{background-color:var(--cds-layer-hover)}.cds--snippet--inline:active{background-color:var(--cds-layer-active)}.cds--snippet--inline:focus{border:1px solid var(--cds-focus,#0f62fe);outline:none}.cds--snippet--inline:before{block-size:0;border:none;content:"";display:none;inline-size:0;position:absolute;z-index:6000}.cds--snippet--inline .cds--copy-btn__feedback{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));box-sizing:content-box;color:var(--cds-text-inverse,#fff);display:none;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:auto;max-inline-size:13rem;min-inline-size:1.5rem;overflow:visible;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000;clip:auto}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--snippet--inline .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-accelerator:true){.cds--snippet--inline .cds--copy-btn__feedback{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--snippet--inline .cds--copy-btn__feedback{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--snippet--inline .cds--copy-btn__feedback{border:1px solid transparent}}.cds--snippet--inline.cds--copy-btn--animating .cds--copy-btn__feedback,.cds--snippet--inline.cds--copy-btn--animating:before{display:block}.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-out .cds--copy-btn__feedback,.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-out:before{animation:cds--hide-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-in .cds--copy-btn__feedback,.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-in:before{animation:cds--show-feedback .11s cubic-bezier(.2,0,.38,.9)}.cds--snippet--inline code{padding:0 .5rem}.cds--snippet--inline.cds--snippet--no-copy{display:inline-block}.cds--snippet--inline.cds--snippet--no-copy:hover{background-color:var(--cds-layer);cursor:auto}.cds--snippet--light.cds--snippet--inline.cds--snippet--no-copy:hover{background-color:var(--cds-layer-hover);cursor:auto}.cds--snippet--single,:host(cds-code-snippet-skeleton[type=single]),:host(cds-code-snippet[type=single]){align-items:center;background-color:var(--cds-layer);block-size:2.5rem;display:flex;font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);max-inline-size:48rem;padding-inline-end:2.5rem;position:relative}.cds--snippet--single.cds--snippet--no-copy,:host(cds-code-snippet-skeleton[type=single]):host(cds-code-snippet[hide-copy-button]),:host(cds-code-snippet[type=single]):host(cds-code-snippet[hide-copy-button]){padding:0}.cds--snippet--single.cds--snippet--no-copy:after{inset-inline-end:1rem}.cds--snippet--single .cds--snippet-container,:host(cds-code-snippet-skeleton[type=single]) .cds--snippet-container,:host(cds-code-snippet[type=single]) .cds--snippet-container{align-items:center;block-size:100%;display:flex;overflow-x:auto;padding-inline-start:1rem;position:relative}.cds--snippet--single .cds--snippet-container:focus,:host(cds-code-snippet-skeleton[type=single]) .cds--snippet-container:focus,:host(cds-code-snippet[type=single]) .cds--snippet-container:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--snippet--single .cds--snippet-container:focus,:host(cds-code-snippet-skeleton[type=single]) .cds--snippet-container:focus,:host(cds-code-snippet[type=single]) .cds--snippet-container:focus{outline-style:dotted}}.cds--snippet--single pre,:host(cds-code-snippet-skeleton[type=single]) pre,:host(cds-code-snippet[type=single]) pre{font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);padding-inline-end:.5rem}.cds--snippet--inline code,.cds--snippet--single pre,:host(cds-code-snippet-skeleton[type=single]) pre,:host(cds-code-snippet[type=single]) pre{white-space:pre}.cds--snippet--multi,:host(cds-code-snippet-skeleton[type=multi]),:host(cds-code-snippet[type=multi]),:host(cds-code-snippet[type=multi]) .cds--snippet-container{background-color:var(--cds-layer);display:flex;font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);max-inline-size:48rem;padding:1rem;position:relative}.cds--snippet--multi .cds--snippet-container,:host(cds-code-snippet-skeleton[type=multi]) .cds--snippet-container,:host(cds-code-snippet[type=multi]) .cds--snippet-container{max-block-size:100%;min-block-size:100%;order:1;overflow-y:auto;position:relative;transition:max-height .15s cubic-bezier(.2,0,.38,.9)}.cds--snippet--multi .cds--snippet-container:focus,:host(cds-code-snippet-skeleton[type=multi]) .cds--snippet-container:focus,:host(cds-code-snippet[type=multi]) .cds--snippet-container:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;outline-offset:0}@media screen and (prefers-contrast){.cds--snippet--multi .cds--snippet-container:focus,:host(cds-code-snippet-skeleton[type=multi]) .cds--snippet-container:focus,:host(cds-code-snippet[type=multi]) .cds--snippet-container:focus{outline-style:dotted}}.cds--snippet--multi.cds--snippet--expand .cds--snippet-container,:host(cds-code-snippet[type=multi]) .cds--snippet--expand.cds--snippet-container .cds--snippet-container{padding-block-end:1rem;transition:max-height .15s cubic-bezier(.2,0,.38,.9)}.cds--snippet--multi.cds--snippet--wraptext pre,:host(cds-code-snippet[type=multi]) .cds--snippet--wraptext.cds--snippet-container pre{white-space:pre-wrap;word-wrap:break-word}.cds--snippet--multi .cds--snippet-container pre,:host(cds-code-snippet-skeleton[type=multi]) .cds--snippet-container pre,:host(cds-code-snippet[type=multi]) .cds--snippet-container pre{padding-inline-end:2.5rem}.cds--snippet--multi.cds--snippet--no-copy .cds--snippet-container pre,:host(cds-code-snippet-skeleton[type=multi]):host(cds-code-snippet[hide-copy-button]) .cds--snippet-container pre,:host(cds-code-snippet[type=multi]) .cds--snippet--no-copy.cds--snippet-container .cds--snippet-container pre,:host(cds-code-snippet[type=multi]):host(cds-code-snippet[hide-copy-button]) .cds--snippet-container pre{padding-inline-end:0}.cds--snippet--multi.cds--snippet--has-right-overflow:after,:host(cds-code-snippet[type=multi]) .cds--snippet--has-right-overflow.cds--snippet-container:after{background-image:linear-gradient(to right,transparent,var(--cds-layer));block-size:100%;content:"";inline-size:1rem;inset-block-start:0;inset-inline-end:1rem;position:absolute}:host(cds-code-snippet[type=multi]) [dir=rtl] .cds--snippet--has-right-overflow.cds--snippet-container:after,[dir=rtl] .cds--snippet--multi.cds--snippet--has-right-overflow:after{background-image:linear-gradient(to left,transparent,var(--cds-layer))}.cds--snippet--multi .cds--snippet-container pre code,:host(cds-code-snippet-skeleton[type=multi]) .cds--snippet-container pre code,:host(cds-code-snippet[type=multi]) .cds--snippet-container pre code{overflow:hidden}.cds--snippet__icon{block-size:1rem;fill:var(--cds-icon-primary,#161616);inline-size:1rem;transition:all 70ms cubic-bezier(.2,0,.38,.9)}.cds--btn>.cds--snippet__icon{margin-block-start:0}.cds--copy-btn{align-items:center;background-color:var(--cds-layer);border:none;cursor:pointer;display:flex;justify-content:center;outline:none;overflow:visible;padding:0}.cds--copy-btn html{font-size:100%}.cds--copy-btn body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--copy-btn code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--copy-btn strong{font-weight:600}.cds--copy-btn:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-color:var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--copy-btn:focus{outline-style:dotted}}.cds--snippet .cds--popover-container,:host(cds-code-snippet) .cds--popover-container,:host(cds-code-snippet-skeleton) .cds--popover-container{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;inset-block-start:0;inset-inline-end:0;position:absolute}.cds--snippet--inline.cds--btn{block-size:1.25rem;inline-size:auto;max-inline-size:unset;min-block-size:1.25rem;padding-inline:0}.cds--snippet--inline.cds--btn.cds--btn--primary:hover{color:var(--cds-text-primary,#161616)}.cds--snippet.cds--snippet--multi .cds--popover-container,:host(cds-code-snippet):host(cds-code-snippet[type=multi]) .cds--popover-container,:host(cds-code-snippet-skeleton):host(cds-code-snippet-skeleton[type=multi]) .cds--popover-container{inset-block-start:.5rem;inset-inline-end:.5rem}.cds--snippet--multi .cds--copy-btn,:host(cds-code-snippet-skeleton[type=multi]) .cds--copy-btn,:host(cds-code-snippet[type=multi]) .cds--copy-btn{z-index:10}.cds--snippet-btn--expand{align-items:center;background-color:var(--cds-layer);block-size:2rem;border:0;color:var(--cds-text-primary,#161616);display:inline-flex;font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inset-block-end:0;inset-inline-end:0;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);padding:.5rem 1rem;position:absolute;z-index:10}.cds--snippet-btn--expand .cds--snippet-btn--text{inset-block-start:-.0625rem;position:relative}.cds--snippet-btn--expand--hide.cds--snippet-btn--expand{display:none}.cds--snippet-btn--expand .cds--icon-chevron--down{fill:var(--cds-icon-primary,#161616);margin-inline-start:.5rem;transform:rotate(0deg);transition:.15s cubic-bezier(.2,0,.38,.9)}.cds--snippet-btn--expand:hover{background:var(--cds-layer-hover);color:var(--cds-text-primary,#161616)}.cds--snippet-btn--expand:active{background-color:var(--cds-layer-active)}.cds--snippet-btn--expand:focus{border-color:transparent;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--snippet-btn--expand:focus{outline-style:dotted}}.cds--snippet--expand .cds--snippet-btn--expand .cds--icon-chevron--down{transform:rotate(180deg);transition:transform .3s}.cds--snippet--light,.cds--snippet--light .cds--btn.cds--snippet-btn--expand,.cds--snippet--light .cds--copy-btn,.cds--snippet--light .cds--snippet-button{background-color:var(--cds-layer)}.cds--snippet--light .cds--btn.cds--snippet-btn--expand:hover,.cds--snippet--light .cds--copy-btn:hover,.cds--snippet--light .cds--snippet-button:hover,.cds--snippet--light.cds--snippet--inline:hover{background-color:var(--cds-layer-hover)}.cds--snippet--light .cds--btn.cds--snippet-btn--expand:active,.cds--snippet--light .cds--copy-btn:active,.cds--snippet--light .cds--snippet-button:active,.cds--snippet--light.cds--snippet--inline:active{background-color:var(--cds-layer-active)}.cds--snippet--light.cds--snippet--multi:after,.cds--snippet--light.cds--snippet--single:after,:host(cds-code-snippet[type=multi]) .cds--snippet--light.cds--snippet-container:after{background-image:linear-gradient(to right,rgba(var(--cds-layer),0),var(--cds-layer))}.cds--snippet.cds--skeleton .cds--snippet-container,:host(cds-code-snippet-skeleton) .cds--snippet-container{block-size:100%;inline-size:100%}.cds--snippet-button .cds--btn--copy__feedback{inset-block-start:3.175rem;inset-inline:50% auto}.cds--snippet-button .cds--btn--copy__feedback:before{inset-block-start:0}.cds--snippet-button .cds--btn--copy__feedback:after{inset-block-start:-.25rem}.cds--snippet--multi .cds--snippet-button .cds--btn--copy__feedback,:host(cds-code-snippet-skeleton[type=multi]) .cds--snippet-button .cds--btn--copy__feedback,:host(cds-code-snippet[type=multi]) .cds--snippet-button .cds--btn--copy__feedback{inset-block-start:2.675rem}.cds--snippet--inline .cds--btn--copy__feedback{inset-block-start:calc(100% - .25rem);inset-inline:50% auto}.cds--snippet__overflow-indicator--left,.cds--snippet__overflow-indicator--right{flex:1 0 auto;inline-size:1rem;z-index:1}.cds--snippet__overflow-indicator--left{background-image:linear-gradient(to left,transparent,var(--cds-layer));margin-inline-end:-1rem;order:0}.cds--snippet__overflow-indicator--right{margin-inline-start:-1rem;order:2}.cds--snippet__overflow-indicator--right,[dir=rtl] .cds--snippet__overflow-indicator--left{background-image:linear-gradient(to right,transparent,var(--cds-layer))}[dir=rtl] .cds--snippet__overflow-indicator--right{background-image:linear-gradient(to left,transparent,var(--cds-layer))}.cds--snippet--single .cds--snippet__overflow-indicator--left,.cds--snippet--single .cds--snippet__overflow-indicator--right,:host(cds-code-snippet-skeleton[type=single]) .cds--snippet__overflow-indicator--left,:host(cds-code-snippet-skeleton[type=single]) .cds--snippet__overflow-indicator--right,:host(cds-code-snippet[type=single]) .cds--snippet__overflow-indicator--left,:host(cds-code-snippet[type=single]) .cds--snippet__overflow-indicator--right{block-size:calc(100% - .25rem);inline-size:2rem;position:absolute}.cds--snippet--single .cds--snippet__overflow-indicator--right,:host(cds-code-snippet-skeleton[type=single]) .cds--snippet__overflow-indicator--right,:host(cds-code-snippet[type=single]) .cds--snippet__overflow-indicator--right{inset-inline-end:2.5rem}.cds--snippet--single.cds--snippet--no-copy .cds--snippet__overflow-indicator--right,:host(cds-code-snippet-skeleton[type=single]):host(cds-code-snippet[hide-copy-button]) .cds--snippet__overflow-indicator--right,:host(cds-code-snippet[type=single]):host(cds-code-snippet[hide-copy-button]) .cds--snippet__overflow-indicator--right{inset-inline-end:0}.cds--snippet--single .cds--snippet-container:focus~.cds--snippet__overflow-indicator--right,:host(cds-code-snippet-skeleton[type=single]) .cds--snippet-container:focus~.cds--snippet__overflow-indicator--right,:host(cds-code-snippet[type=single]) .cds--snippet-container:focus~.cds--snippet__overflow-indicator--right{inset-inline-end:2.625rem}.cds--snippet--single .cds--snippet-container:focus+.cds--snippet__overflow-indicator--left,:host(cds-code-snippet-skeleton[type=single]) .cds--snippet-container:focus+.cds--snippet__overflow-indicator--left,:host(cds-code-snippet[type=single]) .cds--snippet-container:focus+.cds--snippet__overflow-indicator--left{inset-inline-start:.125rem}.cds--snippet--light .cds--snippet__overflow-indicator--left{background-image:linear-gradient(to left,transparent,var(--cds-layer))}.cds--snippet--light .cds--snippet__overflow-indicator--right{background-image:linear-gradient(to right,transparent,var(--cds-layer))}@media not all and (min-resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){.cds--snippet__overflow-indicator--left{background-image:linear-gradient(to left,rgba(var(--cds-layer),0),var(--cds-layer))}.cds--snippet__overflow-indicator--right{background-image:linear-gradient(to right,rgba(var(--cds-layer),0),var(--cds-layer))}}}.cds--snippet--multi.cds--skeleton,:host(cds-code-snippet-skeleton[type=multi]),:host(cds-code-snippet[type=multi]) .cds--skeleton.cds--snippet-container,:host(cds-code-snippet[type=multi]):host(cds-code-snippet-skeleton){block-size:6.125rem}.cds--snippet--single.cds--skeleton,:host(cds-code-snippet-skeleton[type=single]),:host(cds-code-snippet[type=single]):host(cds-code-snippet-skeleton){block-size:3.5rem}.cds--snippet.cds--skeleton span,:host(cds-code-snippet-skeleton) span{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;display:block;inline-size:100%;margin-block-start:.5rem;padding:0;pointer-events:none;position:relative}.cds--snippet.cds--skeleton span:active,.cds--snippet.cds--skeleton span:focus,.cds--snippet.cds--skeleton span:hover,:host(cds-code-snippet-skeleton) span:active,:host(cds-code-snippet-skeleton) span:focus,:host(cds-code-snippet-skeleton) span:hover{border:none;cursor:default;outline:none}.cds--snippet.cds--skeleton span:before,:host(cds-code-snippet-skeleton) span:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--snippet.cds--skeleton span:before,:host(cds-code-snippet-skeleton) span:before{animation:none}}.cds--snippet.cds--skeleton span:first-child,:host(cds-code-snippet-skeleton) span:first-child{margin:0}.cds--snippet.cds--skeleton span:nth-child(2),:host(cds-code-snippet-skeleton) span:nth-child(2){inline-size:85%}.cds--snippet.cds--skeleton span:nth-child(3),:host(cds-code-snippet-skeleton) span:nth-child(3){inline-size:95%}.cds--snippet--single.cds--skeleton .cds--snippet-container,:host(cds-code-snippet-skeleton[type=single]) .cds--snippet-container,:host(cds-code-snippet[type=single]):host(cds-code-snippet-skeleton) .cds--snippet-container{padding-block-end:0}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--snippet__icon{fill:ButtonText}.cds--snippet--inline:focus{color:Highlight;outline:1px solid Highlight}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--snippet--multi,.cds--snippet--single,:host(cds-code-snippet-skeleton[type=multi]),:host(cds-code-snippet-skeleton[type=single]),:host(cds-code-snippet[type=multi]),:host(cds-code-snippet[type=multi]) .cds--snippet-container,:host(cds-code-snippet[type=single]){outline:1px solid transparent}}:host(cds-code-snippet[wrap-text]) pre{white-space:pre-wrap;word-wrap:break-word}:host(cds-code-snippet[type=single]) pre{white-space:nowrap}:host(cds-code-snippet[type=single]) cds-copy-button{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;inset-block-start:0;inset-inline-end:0;position:absolute;code-overflow:hidden}cds-copy code{font-family:var(--cds-code-01-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:var(--cds-code-01-font-size,.75rem);font-weight:var(--cds-code-01-font-weight,400);letter-spacing:var(--cds-code-01-letter-spacing,.32px);line-height:var(--cds-code-01-line-height,1.33333);padding:0 .5rem}:host(cds-code-snippet[type=multi]) .cds--snippet-container{padding:0}:host(cds-code-snippet[type=multi]) pre{margin:0;overflow-x:auto;padding:0 2.5rem 1.5rem 0}:host(cds-code-snippet[type=multi]) pre:after{background-image:linear-gradient(to right,transparent,var(--cds-layer));block-size:100%;content:"";inline-size:1rem;inset-block-start:0;inset-inline-end:0;position:absolute}:host(cds-code-snippet[type=multi]) cds-button .cds--snippet__icon{margin-inline-start:.5rem}:host(cds-code-snippet[type=multi]) cds-button[disabled] .cds--snippet-btn--text{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}:host(cds-code-snippet[type=multi]) cds-copy-button{inset-block-start:.5rem;inset-inline-end:.5rem;position:absolute;z-index:10}:host(cds-code-snippet[type=multi][expanded-code]) .cds--snippet-container{padding-block-end:1rem;transition:max-height .15s cubic-bezier(.2,0,.38,.9)}:host(cds-code-snippet[type=multi][expanded-code]) cds-button .cds--snippet__icon{transform:rotate(180deg);transition:transform .3s}:host(cds-code-snippet-skeleton) span{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;display:block;inline-size:100%;margin-block-start:.5rem;padding:0;pointer-events:none;position:relative}:host(cds-code-snippet-skeleton) span:active,:host(cds-code-snippet-skeleton) span:focus,:host(cds-code-snippet-skeleton) span:hover{border:none;cursor:default;outline:none}:host(cds-code-snippet-skeleton) span:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){:host(cds-code-snippet-skeleton) span:before{animation:none}}:host(cds-code-snippet-skeleton) span:first-child{margin:0}:host(cds-code-snippet-skeleton) span:nth-child(2){inline-size:85%}:host(cds-code-snippet-skeleton) span:nth-child(3){inline-size:95%}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5b0dc":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSCodeSnippetSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _codeSnippetJs = require("./code-snippet.js");
var _codeSnippetScssJs = require("./code-snippet.scss.js");
var _codeSnippetScssJsDefault = parcelHelpers.interopDefault(_codeSnippetScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("./defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of code snippet.
 */ let CDSCodeSnippetSkeleton = class CDSCodeSnippetSkeleton extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * The type of code snippet. Corresponds to the attribute with the same name.
         */ this.type = (0, _defsJs.CODE_SNIPPET_TYPE).SINGLE;
    }
    render() {
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--snippet-container">
        ${this.type !== (0, _defsJs.CODE_SNIPPET_TYPE).MULTI ? (0, _lit.html)` <span></span> ` : (0, _lit.html)` <span></span><span></span><span></span> `}
      </div>
    `;
    }
};
CDSCodeSnippetSkeleton.styles = (0, _codeSnippetScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSCodeSnippetSkeleton.prototype, "type", void 0);
CDSCodeSnippetSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-code-snippet-skeleton`)
], CDSCodeSnippetSkeleton);
var CDSCodeSnippetSkeleton$1 = CDSCodeSnippetSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./code-snippet.js":"7EfhY","./code-snippet.scss.js":"lgTl0","../../globals/decorators/carbon-element.js":"kNhLR","./defs.js":"zAbor","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jT0Dn":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _comboBoxJs = require("./combo-box.js");
var _comboBoxItemJs = require("./combo-box-item.js");

},{"./combo-box.js":"bmQRx","./combo-box-item.js":"9gwdh"}],"bmQRx":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DROPDOWN_DIRECTION", ()=>(0, _defsJs.DROPDOWN_DIRECTION));
parcelHelpers.export(exports, "DROPDOWN_SIZE", ()=>(0, _defsJs.DROPDOWN_SIZE));
parcelHelpers.export(exports, "default", ()=>CDSComboBox$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _16Js = require("../../icons/close/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _settingsJs = require("../../globals/settings.js");
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _dropdownJs = require("../dropdown/dropdown.js");
var _dropdownJsDefault = parcelHelpers.interopDefault(_dropdownJs);
var _comboBoxScssJs = require("./combo-box.scss.js");
var _comboBoxScssJsDefault = parcelHelpers.interopDefault(_comboBoxScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _ifNonEmptyJs = require("../../globals/directives/if-non-empty.js");
var _ifNonEmptyJsDefault = parcelHelpers.interopDefault(_ifNonEmptyJs);
var _defsJs = require("../dropdown/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Combo box.
 *
 * @element cds-combo-box
 * @fires cds-combo-box-beingselected
 *   The custom event fired before a combo box item is selected upon a user gesture.
 *   Cancellation of this event stops changing the user-initiated selection.
 * @fires cds-combo-box-beingtoggled
 *   The custom event fired before the open state of this combo box is toggled upon a user gesture.
 *   Cancellation of this event stops the user-initiated toggling.
 * @fires cds-combo-box-selected - The custom event fired after a combo box item is selected upon a user gesture.
 * @fires cds-combo-box-toggled - The custom event fired after the open state of this combo box is toggled upon a user gesture.
 */ let CDSComboBox = class CDSComboBox extends (0, _dropdownJsDefault.default) {
    constructor(){
        super(...arguments);
        /**
         * The text content that should be set to the `<input>` for filtering.
         */ this._filterInputValue = "";
        this._shouldTriggerBeFocusable = false;
        /**
         * The `aria-label` attribute for the icon to clear selection.
         */ this.clearSelectionLabel = "Clear selection";
        /**
         * The `aria-label` attribute for the `<input>` for filtering.
         */ this.inputLabel = "";
    }
    /**
     * @param item A combo box item.
     * @returns `true` if the given combo box item matches the query text user types.
     */ _testItemWithQueryText(item) {
        return (this.itemMatches || this._defaultItemMatches)(item, this._filterInputNode.value);
    }
    /* eslint-disable class-methods-use-this */ /**
     * The default item matching callback.
     *
     * @param item The combo box item.
     * @param queryText The query text user types.
     * @returns `true` if the given combo box item matches the given query text.
     */ _defaultItemMatches(item, queryText) {
        return item.textContent.toLowerCase().indexOf(queryText.toLowerCase()) >= 0;
    }
    /* eslint-enable class-methods-use-this */ /**
     * Handles `input` event on the `<input>` for filtering.
     */ _handleInput() {
        if (this._filterInputValue.length != 0) this.setAttribute("isClosable", "");
        else this.removeAttribute("isClosable");
        const items = this.querySelectorAll(this.constructor.selectorItem);
        const index = !this._filterInputNode.value ? -1 : (0, _collectionHelpersJs.findIndex)(items, this._testItemWithQueryText, this);
        (0, _collectionHelpersJs.forEach)(items, (item, i)=>{
            var _a;
            if (i === index) {
                const menuRect = (_a = this._itemMenu) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                const itemRect = item.getBoundingClientRect();
                if (menuRect && itemRect) {
                    const isViewable = menuRect.top <= (itemRect === null || itemRect === void 0 ? void 0 : itemRect.top) && (itemRect === null || itemRect === void 0 ? void 0 : itemRect.bottom) <= (menuRect === null || menuRect === void 0 ? void 0 : menuRect.top) + this._itemMenu.clientHeight;
                    if (!isViewable) {
                        const scrollTop = (itemRect === null || itemRect === void 0 ? void 0 : itemRect.top) - (menuRect === null || menuRect === void 0 ? void 0 : menuRect.top);
                        const scrollBot = (itemRect === null || itemRect === void 0 ? void 0 : itemRect.bottom) - (menuRect === null || menuRect === void 0 ? void 0 : menuRect.bottom);
                        if (Math.abs(scrollTop) < Math.abs(scrollBot)) this._itemMenu.scrollTop += scrollTop;
                        else this._itemMenu.scrollTop += scrollBot;
                    }
                }
            }
            item.highlighted = i === index;
        });
        const { _filterInputNode: filterInput } = this;
        this._filterInputValue = !filterInput ? "" : filterInput.value;
        this.open = true;
        this.requestUpdate(); // If the only change is to `_filterInputValue`, auto-update doesn't happen
    }
    _handleClickInner(event) {
        var _a;
        const { target } = event;
        if ((_a = this._selectionButtonNode) === null || _a === void 0 ? void 0 : _a.contains(target)) this._handleUserInitiatedClearInput();
        else super._handleClickInner(event);
    }
    _handleKeypressInner(event) {
        var _a;
        const { key } = event;
        const action = this.constructor.getAction(key);
        const { TRIGGERING } = (0, _defsJs.DROPDOWN_KEYBOARD_ACTION);
        if (((_a = this._selectionButtonNode) === null || _a === void 0 ? void 0 : _a.contains(event.target)) && // Space key should be handled by `<input>` unless "clear selection" button has focus
        (action === TRIGGERING || key === " ")) this._handleUserInitiatedClearInput();
        else super._handleKeypressInner(event);
    }
    /**
     * Handles user-initiated clearing the `<input>` for filtering.
     */ _handleUserInitiatedClearInput() {
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorItem), (item)=>{
            item.highlighted = false;
        });
        this._filterInputValue = "";
        this._filterInputNode.focus();
        this._handleUserInitiatedSelectItem();
    }
    _handleUserInitiatedSelectItem(item) {
        if (item && !this._selectionShouldChange(item)) {
            // Escape hatch for `shouldUpdate()` logic that updates `._filterInputValue()` when selection changes,
            // given we want to update the `<input>` and close the dropdown even if selection doesn't update.
            // Use case:
            // 1. Select the 2nd item in combo box drop down
            // 2. Type some text in the `<input>`
            // 3. Re-select the 2nd item in combo box drop down,
            //    the `<input>` has to updated with the 2nd item and the dropdown should be closed,
            //    even if there is no change in the selected value
            this._filterInputValue = item.textContent || "";
            this.open = false;
            this.requestUpdate();
        }
        super._handleUserInitiatedSelectItem(item);
    }
    _selectionDidChange(itemToSelect) {
        this.value = !itemToSelect ? "" : itemToSelect.value;
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorItemSelected), (item)=>{
            item.selected = false;
            item.setAttribute("aria-selected", "false");
        });
        if (itemToSelect) {
            itemToSelect.selected = true;
            itemToSelect.setAttribute("aria-selected", "true");
        }
        this._handleUserInitiatedToggle(false);
    }
    _renderLabel() {
        var _a;
        const { disabled, inputLabel, label, open, readOnly, value, _activeDescendant: activeDescendant, _filterInputValue: filterInputValue, _handleInput: handleInput } = this;
        const inputClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--text-input`]: true,
            [`${0, _settingsJs.prefix}--text-input--empty`]: !value
        });
        let activeDescendantFallback;
        if (open && !activeDescendant) {
            const constructor = this.constructor;
            const items = this.querySelectorAll(constructor.selectorItem);
            activeDescendantFallback = (_a = items[0]) === null || _a === void 0 ? void 0 : _a.id;
        }
        return (0, _lit.html)`
      <input
        id="trigger-button"
        class="${inputClasses}"
        ?disabled=${disabled}
        placeholder="${label}"
        .value=${filterInputValue}
        role="combobox"
        aria-label="${(0, _ifNonEmptyJsDefault.default)(inputLabel)}"
        aria-controls="menu-body"
        aria-haspopup="listbox"
        aria-autocomplete="list"
        aria-expanded="${String(open)}"
        aria-activedescendant="${(0, _ifDefinedJs.ifDefined)(open ? activeDescendant !== null && activeDescendant !== void 0 ? activeDescendant : activeDescendantFallback : "")}"
        ?readonly=${readOnly}
        @input=${handleInput} />
    `;
    }
    _renderFollowingLabel() {
        const { clearSelectionLabel, _filterInputValue: filterInputValue } = this;
        if (filterInputValue.length != 0) this.setAttribute("isClosable", "");
        else this.removeAttribute("isClosable");
        return filterInputValue.length === 0 ? undefined : (0, _lit.html)`
          <div
            id="selection-button"
            role="button"
            class="${0, _settingsJs.prefix}--list-box__selection"
            tabindex="0"
            title="${clearSelectionLabel}">
            ${(0, _16JsDefault.default)({
            "aria-label": clearSelectionLabel
        })}
          </div>
        `;
    }
    shouldUpdate(changedProperties) {
        super.shouldUpdate(changedProperties);
        const { _selectedItemContent: selectedItemContent } = this;
        if (selectedItemContent && changedProperties.has("value")) this._filterInputValue = (selectedItemContent === null || selectedItemContent === void 0 ? void 0 : selectedItemContent.textContent) || "";
        return true;
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        const { _listBoxNode: listBoxNode } = this;
        if (listBoxNode) listBoxNode.classList.add(`${(0, _settingsJs.prefix)}--combo-box`);
    }
    /**
     * A selector that will return highlighted items.
     */ static get selectorItemHighlighted() {
        return `${0, _settingsJs.prefix}-combo-box-item[highlighted]`;
    }
    /**
     * A selector that will return combo box items.
     */ static get selectorItem() {
        return `${0, _settingsJs.prefix}-combo-box-item`;
    }
    /**
     * A selector that will return selected items.
     */ static get selectorItemSelected() {
        return `${0, _settingsJs.prefix}-combo-box-item[selected]`;
    }
    /**
     * The name of the custom event fired before this combo box item is being toggled upon a user gesture.
     * Cancellation of this event stops the user-initiated action of toggling this combo box item.
     */ static get eventBeforeToggle() {
        return `${0, _settingsJs.prefix}-combo-box-beingtoggled`;
    }
    /**
     * The name of the custom event fired after this combo box item is toggled upon a user gesture.
     */ static get eventToggle() {
        return `${0, _settingsJs.prefix}-combo-box-toggled`;
    }
    /**
     * The name of the custom event fired before a combo box item is selected upon a user gesture.
     * Cancellation of this event stops changing the user-initiated selection.
     */ static get eventBeforeSelect() {
        return `${0, _settingsJs.prefix}-combo-box-beingselected`;
    }
    /**
     * The name of the custom event fired after a a combo box item is selected upon a user gesture.
     */ static get eventSelect() {
        return `${0, _settingsJs.prefix}-combo-box-selected`;
    }
};
// For combo box, open/selection with space key is disabled given the input box should take it over
CDSComboBox.TRIGGER_KEYS = new Set([
    "Enter"
]);
CDSComboBox.styles = (0, _comboBoxScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("input")
], CDSComboBox.prototype, "_filterInputNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#menu-body")
], CDSComboBox.prototype, "_itemMenu", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#selection-button")
], CDSComboBox.prototype, "_selectionButtonNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "clear-selection-label"
    })
], CDSComboBox.prototype, "clearSelectionLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "input-label"
    })
], CDSComboBox.prototype, "inputLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: false
    })
], CDSComboBox.prototype, "itemMatches", void 0);
CDSComboBox = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-combo-box`)
], CDSComboBox);
var CDSComboBox$1 = CDSComboBox;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/close/16.js":"b7Sho","../../globals/settings.js":"EipuL","../../globals/internal/collection-helpers.js":"4aZkz","../dropdown/dropdown.js":"iHNPo","./combo-box.scss.js":"5v1qv","../../globals/decorators/carbon-element.js":"kNhLR","lit/directives/if-defined.js":"hSgrS","../../globals/directives/if-non-empty.js":"5Xlqk","../dropdown/defs.js":"9eS24","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iHNPo":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DROPDOWN_DIRECTION", ()=>(0, _defsJs.DROPDOWN_DIRECTION));
parcelHelpers.export(exports, "DROPDOWN_KEYBOARD_ACTION", ()=>(0, _defsJs.DROPDOWN_KEYBOARD_ACTION));
parcelHelpers.export(exports, "DROPDOWN_SIZE", ()=>(0, _defsJs.DROPDOWN_SIZE));
parcelHelpers.export(exports, "DROPDOWN_TYPE", ()=>(0, _defsJs.DROPDOWN_TYPE));
parcelHelpers.export(exports, "NAVIGATION_DIRECTION", ()=>(0, _defsJs.NAVIGATION_DIRECTION));
parcelHelpers.export(exports, "default", ()=>CDSDropdown$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _16Js = require("../../icons/chevron--down/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/warning--filled/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _16Js2 = require("../../icons/warning--alt--filled/16.js");
var _16JsDefault2 = parcelHelpers.interopDefault(_16Js2);
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _formJs = require("../../globals/mixins/form.js");
var _formJsDefault = parcelHelpers.interopDefault(_formJs);
var _hostListenerJs = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _validityJs = require("../../globals/mixins/validity.js");
var _validityJsDefault = parcelHelpers.interopDefault(_validityJs);
var _hostListenerJs1 = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _defsJs = require("./defs.js");
var _dropdownScssJs = require("./dropdown.scss.js");
var _dropdownScssJsDefault = parcelHelpers.interopDefault(_dropdownScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Dropdown.
 *
 * @element cds-dropdown
 * @csspart label-text The label text.
 * @csspart helper-text The helper text.
 * @csspart trigger-button The trigger button.
 * @csspart menu-body The menu body.
 * @csspart validity-message The validity message.
 * @fires cds-dropdown-beingselected
 *   The custom event fired before a dropdown item is selected upon a user gesture.
 *   Cancellation of this event stops changing the user-initiated selection.
 * @fires cds-dropdown-beingtoggled
 *   The custom event fired before the open state of this dropdown is toggled upon a user gesture.
 *   Cancellation of this event stops the user-initiated toggling.
 * @fires cds-dropdown-selected - The custom event fired after a dropdown item is selected upon a user gesture.
 * @fires cds-dropdown-toggled - The custom event fired after the open state of this dropdown is toggled upon a user gesture.
 */ let CDSDropdown = class CDSDropdown extends (0, _validityJsDefault.default)((0, _hostListenerJsDefault.default)((0, _formJsDefault.default)((0, _focusJsDefault.default)((0, _lit.LitElement))))) {
    constructor(){
        super(...arguments);
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
        /**
         * The content of the selected item.
         */ this._selectedItemContent = null;
        /**
         * `true` if the trigger button should be focusable.
         * Derived class can set `false` to this if the trigger button contains another primary focusable element (e.g. `<input>`).
         */ this._shouldTriggerBeFocusable = true;
        /**
         * 'aria-label' of the ListBox component.
         * Specify a label to be read by screen readers on the container node
         */ this.ariaLabel = "";
        /**
         * Specify the direction of the dropdown. Can be either top or bottom.
         */ this.direction = (0, _defsJs.DROPDOWN_DIRECTION).BOTTOM;
        /**
         * `true` if this dropdown should be disabled.
         */ this.disabled = false;
        /**
         * The helper text.
         */ this.helperText = "";
        /**
         * Specify whether the title text should be hidden or not
         */ this.hideLabel = false;
        /**
         * `true` to show the UI of the invalid state.
         */ this.invalid = false;
        /**
         * Message which is displayed if the value is invalid.
         */ this.invalidText = "";
        /**
         * Provide the title text that will be read by a screen reader when visiting this control
         */ this.titleText = "";
        /**
         * Name for the dropdown in the `FormData`
         */ this.name = "";
        /**
         * `true` if this dropdown should be open.
         */ this.open = false;
        /**
         * Whether or not the Dropdown is readonly
         */ this.readOnly = false;
        /**
         * `true` if the value is required.
         */ this.required = false;
        /**
         * The special validity message for `required`.
         */ this.requiredValidityMessage = "Please fill out this field.";
        /**
         * Dropdown size.
         */ this.size = (0, _defsJs.DROPDOWN_SIZE).MEDIUM;
        /**
         * The `aria-label` attribute for the UI indicating the closed state.
         */ this.toggleLabelClosed = "";
        /**
         * The `aria-label` attribute for the UI indicating the open state.
         */ this.toggleLabelOpen = "";
        /**
         * Generic label that will be used as the textual representation of what this field is for
         */ this.label = "";
        /**
         * `true` if this dropdown should use the inline UI variant.
         */ this.type = (0, _defsJs.DROPDOWN_TYPE).DEFAULT;
        /**
         * The validity message.
         */ this.validityMessage = "";
        /**
         * The value of the selected item.
         */ this.value = "";
        /**
         * Specify whether the control is currently in warning state
         */ this.warn = false;
        /**
         * Provide the text that is displayed when the control is in warning state
         */ this.warnText = "";
    }
    /**
     * @param itemToSelect A dropdown item. Absense of this argument means clearing selection.
     * @returns `true` if the selection of this dropdown should change if the given item is selected upon user interaction.
     */ _selectionShouldChange(itemToSelect) {
        return !itemToSelect || itemToSelect.value !== this.value;
    }
    /**
     * A callback that runs after change in dropdown selection upon user interaction is confirmed.
     *
     * @param itemToSelect
     *   A dropdown item.
     *   Absense of this argument means clearing selection, which may be handled by a derived class.
     */ _selectionDidChange(itemToSelect) {
        if (itemToSelect) {
            this.value = itemToSelect.value;
            this._activeDescendant = itemToSelect.id;
            (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorItemSelected), (item)=>{
                item.selected = false;
                item.setAttribute("aria-selected", "false");
            });
            itemToSelect.selected = true;
            itemToSelect.setAttribute("aria-selected", "true");
            this._handleUserInitiatedToggle(false);
        }
    }
    /**
     * Handles `click` event on the top-level element in the shadow DOM.
     *
     * @param event The event.
     */ _handleClickInner(event) {
        if (this.readOnly) return;
        if (this.shadowRoot.contains(event.target)) this._handleUserInitiatedToggle();
        else {
            const item = event.target.closest(this.constructor.selectorItem);
            if (this.contains(item)) this._handleUserInitiatedSelectItem(item);
        }
    }
    /**
     * Handler for the `keydown` event on the top-level element in the shadow DOM.
     */ _handleKeydownInner(event) {
        const { key } = event;
        const action = this.constructor.getAction(key);
        if (!this.open) switch(action){
            case (0, _defsJs.DROPDOWN_KEYBOARD_ACTION).NAVIGATING:
                this._handleUserInitiatedToggle(true);
                // If this menu gets open with an arrow key, reset the highlight
                this._clearHighlight();
                break;
        }
        else switch(action){
            case (0, _defsJs.DROPDOWN_KEYBOARD_ACTION).CLOSING:
                this._handleUserInitiatedToggle(false);
                break;
            case (0, _defsJs.DROPDOWN_KEYBOARD_ACTION).NAVIGATING:
                this._navigate((0, _defsJs.NAVIGATION_DIRECTION)[key]);
                break;
        }
    }
    /**
     * Handler for the `keypress` event on the top-level element in the shadow DOM.
     */ _handleKeypressInner(event) {
        const { key } = event;
        const action = this.constructor.getAction(key);
        if (!this.open) switch(action){
            case (0, _defsJs.DROPDOWN_KEYBOARD_ACTION).TRIGGERING:
                this._handleUserInitiatedToggle(true);
                break;
        }
        else switch(action){
            case (0, _defsJs.DROPDOWN_KEYBOARD_ACTION).TRIGGERING:
                {
                    const constructor = this.constructor;
                    const highlightedItem = this.querySelector(constructor.selectorItemHighlighted);
                    if (highlightedItem) this._handleUserInitiatedSelectItem(highlightedItem);
                    else this._handleUserInitiatedToggle(false);
                }
                break;
        }
    }
    /**
     * Handles `blur` event handler on the document this element is in.
     *
     * @param event The event.
     */ _handleFocusOut(event) {
        if (!this.contains(event.relatedTarget)) this._handleUserInitiatedToggle(false);
    }
    /**
     * Handles `slotchange` event for the `<slot>` for helper text.
     */ _handleSlotchangeHelperText() {
        this.requestUpdate();
    }
    /**
     * Handles `slotchange` event for the `<slot>` for label text.
     */ _handleSlotchangeLabelText() {
        this.requestUpdate();
    }
    /**
     * Handles `slotchange` event.
     */ _handleAILabelSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || // remove reference to slug in v12
            elem.matches(this.constructor.slugItem) : false);
        this._hasAILabel = Boolean(hasContent);
        hasContent[0].setAttribute("size", "mini");
        this.requestUpdate();
    }
    /**
     * Handles user-initiated selection of a dropdown item.
     *
     * @param [item] The dropdown item user wants to select. Absense of this argument means clearing selection.
     */ _handleUserInitiatedSelectItem(item) {
        if (item === null || item === void 0 ? void 0 : item.hasAttribute("disabled")) return;
        if (this._selectionShouldChange(item)) {
            const init = {
                bubbles: true,
                composed: true,
                detail: {
                    item
                }
            };
            const constructor = this.constructor;
            const beforeSelectEvent = new CustomEvent(constructor.eventBeforeSelect, Object.assign(Object.assign({}, init), {
                cancelable: true
            }));
            if (this.dispatchEvent(beforeSelectEvent)) {
                this._selectionDidChange(item);
                const afterSelectEvent = new CustomEvent(constructor.eventSelect, init);
                this.dispatchEvent(afterSelectEvent);
            }
        }
    }
    /**
     * Handles user-initiated toggling the open state.
     *
     * @param [force] If specified, forces the open state to the given one.
     */ _handleUserInitiatedToggle(force = !this.open) {
        const { eventBeforeToggle, eventToggle } = this.constructor;
        const { disabled } = this;
        const init = {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: {
                open: force
            }
        };
        if (!disabled) {
            if (this.dispatchEvent(new CustomEvent(eventBeforeToggle, init))) {
                this.open = force;
                if (!this.open) (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorItemHighlighted), (item)=>{
                    item.highlighted = false;
                });
                this.requestUpdate();
                this.dispatchEvent(new CustomEvent(eventToggle, init));
            }
        }
    }
    /**
     * Clears the selection of dropdown items.
     */ _clearHighlight() {
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorItem), (item)=>{
            item.highlighted = false;
        });
    }
    /**
     * Navigate through dropdown items.
     *
     * @param direction `-1` to navigate backward, `1` to navigate forward.
     */ _navigate(direction) {
        var _a;
        const constructor = this.constructor;
        const items = this.querySelectorAll(constructor.selectorItem);
        const highlightedItem = this.querySelector(constructor.selectorItemHighlighted);
        const highlightedIndex = (0, _collectionHelpersJs.indexOf)(items, highlightedItem);
        let nextIndex = highlightedIndex + direction;
        if ((_a = items[nextIndex]) === null || _a === void 0 ? void 0 : _a.hasAttribute("disabled")) nextIndex += direction;
        if (nextIndex < 0) nextIndex = items.length - 1;
        if (nextIndex >= items.length) nextIndex = 0;
        (0, _collectionHelpersJs.forEach)(items, (item, i)=>{
            item.highlighted = i === nextIndex;
        });
        const nextItem = items[nextIndex];
        // Using `{ block: 'nearest' }` to prevent scrolling unless scrolling is absolutely necessary.
        // `scrollIntoViewOptions` seems to work in latest Safari despite of MDN/caniuse table.
        // IE falls back to the old behavior.
        nextItem.scrollIntoView({
            block: "nearest"
        });
        const nextItemId = nextItem.id;
        if (nextItemId) this._activeDescendant = nextItemId;
    }
    /* eslint-disable class-methods-use-this */ /**
     * @returns The content preceding the trigger button.
     */ _renderPrecedingLabel() {
        return undefined;
    }
    /* eslint-enable class-methods-use-this */ /**
     * @returns The main content of the trigger button.
     */ _renderLabel() {
        const { label, _selectedItemContent: selectedItemContent } = this;
        return (0, _lit.html)`
      <span id="trigger-label" class="${0, _settingsJs.prefix}--list-box__label"
        >${selectedItemContent || label}</span
      >
    `;
    }
    /**
     * @returns The title label.
     */ _renderTitleLabel() {
        const { disabled, hideLabel, titleText, _slotTitleTextNode: slotTitleTextNode, _handleSlotchangeLabelText: handleSlotchangeLabelText } = this;
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--label`]: true,
            [`${0, _settingsJs.prefix}--label--disabled`]: disabled,
            [`${0, _settingsJs.prefix}--visually-hidden`]: hideLabel
        });
        const hasTitleText = titleText || slotTitleTextNode && slotTitleTextNode.assignedNodes().length > 0;
        return (0, _lit.html)`
      <label
        id="dropdown-label"
        part="title-text"
        class="${labelClasses}"
        for="trigger-button"
        ?hidden="${!hasTitleText}">
        <slot name="title-text" @slotchange="${handleSlotchangeLabelText}"
          >${titleText}</slot
        >
      </label>
    `;
    }
    /* eslint-disable class-methods-use-this */ /**
     * @returns The content following the trigger button.
     */ _renderFollowingLabel() {
        return undefined;
    }
    /* eslint-enable class-methods-use-this */ /**
     * Handles event to include selected value on the parent form.
     *
     * @param event The event.
     */ _handleFormdata(event) {
        const { formData } = event; // TODO: Wait for `FormDataEvent` being available in `lib.dom.d.ts`
        const { disabled, name, value } = this;
        if (!disabled) formData.append(name, value);
    }
    shouldUpdate(changedProperties) {
        const { selectorItem } = this.constructor;
        if (changedProperties.has("size")) (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorItem), (elem)=>{
            elem.size = this.size;
        });
        if (changedProperties.has("disabled") && this.disabled) {
            const { disabled } = this;
            // Propagate `disabled` attribute to descendants until `:host-context()` gets supported in all major browsers
            (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorItem), (elem)=>{
                if (disabled) elem.disabled = disabled;
                else elem.removeAttribute("disabled");
            });
        }
        if (changedProperties.has("value")) {
            // `<cds-multi-select>` updates selection beforehand
            // because our rendering logic for `<cds-multi-select>` looks for selected items via `qSA()`
            (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorItem), (elem)=>{
                elem.selected = elem.value === this.value;
            });
            const item = (0, _collectionHelpersJs.find)(this.querySelectorAll(selectorItem), (elem)=>elem.value === this.value);
            if (item) {
                const range = this.ownerDocument.createRange();
                range.selectNodeContents(item);
                this._selectedItemContent = range.cloneContents();
            } else this._selectedItemContent = null;
        }
        return true;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updated(_changedProperties) {
        var _a, _b, _c, _d, _e;
        this._hasAILabel ? this.setAttribute("ai-label", "") : this.removeAttribute("ai-label");
        const label = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("slot[name='ai-label']");
        if (label) label === null || label === void 0 || label.classList.toggle(`${(0, _settingsJs.prefix)}--slug--revert`, (_b = this.querySelector(`${(0, _settingsJs.prefix)}-ai-label`)) === null || _b === void 0 ? void 0 : _b.hasAttribute("revert-active"));
        else (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("slot[name='slug']")) === null || _d === void 0 || _d.classList.toggle(`${(0, _settingsJs.prefix)}--slug--revert`, (_e = this.querySelector(`${(0, _settingsJs.prefix)}-slug`)) === null || _e === void 0 ? void 0 : _e.hasAttribute("revert-active"));
    }
    /**
     * The CSS class list for dropdown listbox
     */ get _classes() {
        const { disabled, size, type, invalid, open, warn } = this;
        const inline = type === (0, _defsJs.DROPDOWN_TYPE).INLINE;
        const selectedItemsCount = this.querySelectorAll(this.constructor.selectorItemSelected).length;
        return (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--dropdown`]: true,
            [`${0, _settingsJs.prefix}--list-box`]: true,
            [`${0, _settingsJs.prefix}--list-box--disabled`]: disabled,
            [`${0, _settingsJs.prefix}--list-box--inline`]: inline,
            [`${0, _settingsJs.prefix}--list-box--expanded`]: open,
            [`${0, _settingsJs.prefix}--list-box--${size}`]: size,
            [`${0, _settingsJs.prefix}--dropdown--invalid`]: invalid,
            [`${0, _settingsJs.prefix}--dropdown--warn`]: warn,
            [`${0, _settingsJs.prefix}--dropdown--inline`]: inline,
            [`${0, _settingsJs.prefix}--dropdown--selected`]: selectedItemsCount > 0
        });
    }
    render() {
        var _a;
        const { ariaLabel, _classes: classes, disabled, helperText, invalid, invalidText, open, toggleLabelClosed, toggleLabelOpen, type, warn, warnText, _activeDescendant: activeDescendant, _shouldTriggerBeFocusable: shouldTriggerBeFocusable, _handleClickInner: handleClickInner, _handleKeydownInner: handleKeydownInner, _handleKeypressInner: handleKeypressInner, _handleSlotchangeHelperText: handleSlotchangeHelperText, _handleAILabelSlotChange: handleAILabelSlotChange, _slotHelperTextNode: slotHelperTextNode } = this;
        const inline = type === (0, _defsJs.DROPDOWN_TYPE).INLINE;
        let activeDescendantFallback;
        if (open && !activeDescendant) {
            const constructor = this.constructor;
            const items = this.querySelectorAll(constructor.selectorItem);
            activeDescendantFallback = (_a = items[0]) === null || _a === void 0 ? void 0 : _a.id;
        }
        const helperClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--form__helper-text`]: true,
            [`${0, _settingsJs.prefix}--form__helper-text--disabled`]: disabled
        });
        const iconContainerClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--list-box__menu-icon`]: true,
            [`${0, _settingsJs.prefix}--list-box__menu-icon--open`]: open
        });
        const toggleLabel = (open ? toggleLabelOpen : toggleLabelClosed) || undefined;
        const hasHelperText = helperText || invalidText || warnText || slotHelperTextNode && slotHelperTextNode.assignedNodes().length > 0;
        const validityIcon = !invalid ? undefined : (0, _16JsDefault1.default)({
            class: `${(0, _settingsJs.prefix)}--list-box__invalid-icon`,
            "aria-label": toggleLabel
        });
        const warningIcon = !warn || invalid && warn ? undefined : (0, _16JsDefault2.default)({
            class: `${(0, _settingsJs.prefix)}--list-box__invalid-icon ${(0, _settingsJs.prefix)}--list-box__invalid-icon--warning`,
            "aria-label": toggleLabel
        });
        const helperMessage = invalid ? invalidText : warn ? warnText : helperText;
        const menuBody = (0, _lit.html)`
      <div
        aria-labelledby="${(0, _ifDefinedJs.ifDefined)(ariaLabel ? undefined : "dropdown-label")}"
        aria-label="${(0, _ifDefinedJs.ifDefined)(ariaLabel ? ariaLabel : undefined)}"
        id="menu-body"
        part="menu-body"
        class="${(0, _settingsJs.prefix)}--list-box__menu"
        role="listbox"
        tabindex="-1"
        ?hidden=${!open}>
        <slot></slot>
      </div>
    `;
        return (0, _lit.html)`
      ${this._renderTitleLabel()}
      <div
        class="${classes}"
        ?data-invalid=${invalid}
        @click=${handleClickInner}
        @keydown=${handleKeydownInner}
        @keypress=${handleKeypressInner}>
        <div
          id="${(0, _ifDefinedJs.ifDefined)(!shouldTriggerBeFocusable ? undefined : "trigger-button")}"
          class="${0, _settingsJs.prefix}--list-box__field"
          part="trigger-button"
          tabindex="${(0, _ifDefinedJs.ifDefined)(!shouldTriggerBeFocusable ? undefined : "0")}"
          role="${(0, _ifDefinedJs.ifDefined)(!shouldTriggerBeFocusable ? undefined : "combobox")}"
          aria-labelledby="${(0, _ifDefinedJs.ifDefined)(!shouldTriggerBeFocusable ? undefined : "dropdown-label")}"
          aria-expanded="${(0, _ifDefinedJs.ifDefined)(!shouldTriggerBeFocusable ? undefined : String(open))}"
          aria-haspopup="${(0, _ifDefinedJs.ifDefined)(!shouldTriggerBeFocusable ? undefined : "listbox")}"
          aria-controls="${(0, _ifDefinedJs.ifDefined)(!shouldTriggerBeFocusable ? undefined : "menu-body")}"
          aria-activedescendant="${(0, _ifDefinedJs.ifDefined)(!shouldTriggerBeFocusable ? undefined : open ? activeDescendant !== null && activeDescendant !== void 0 ? activeDescendant : activeDescendantFallback : "")}">
          ${this._renderPrecedingLabel()}${this._renderLabel()}${validityIcon}${warningIcon}${this._renderFollowingLabel()}
          <div id="trigger-caret" class="${iconContainerClasses}">
            ${(0, _16JsDefault.default)({
            "aria-label": toggleLabel
        })}
          </div>
        </div>
        <slot name="ai-label" @slotchange=${handleAILabelSlotChange}></slot>
        <slot name="slug" @slotchange=${handleAILabelSlotChange}></slot>
        ${menuBody}
      </div>
      <div
        part="helper-text"
        class="${helperClasses}"
        ?hidden="${inline && !warn && !invalid || !hasHelperText}">
        <slot name="helper-text" @slotchange="${handleSlotchangeHelperText}"
          >${helperMessage}</slot
        >
      </div>
    `;
    }
    /**
     * A selector that will return highlighted items.
     */ static get selectorItemHighlighted() {
        return `${0, _settingsJs.prefix}-dropdown-item[highlighted]`;
    }
    /**
     * A selector that will return dropdown items.
     */ static get selectorItem() {
        return `${0, _settingsJs.prefix}-dropdown-item`;
    }
    /**
     * A selector that will return selected items.
     */ static get selectorItemSelected() {
        return `${0, _settingsJs.prefix}-dropdown-item[selected]`;
    }
    /**
     * The name of the custom event fired before a dropdown item is selected upon a user gesture.
     * Cancellation of this event stops changing the user-initiated selection.
     */ static get eventBeforeSelect() {
        return `${0, _settingsJs.prefix}-dropdown-beingselected`;
    }
    /**
     * The name of the custom event fired after a a dropdown item is selected upon a user gesture.
     */ static get eventSelect() {
        return `${0, _settingsJs.prefix}-dropdown-selected`;
    }
    /**
     * The name of the custom event fired before this dropdown item is being toggled upon a user gesture.
     * Cancellation of this event stops the user-initiated action of toggling this dropdown item.
     */ static get eventBeforeToggle() {
        return `${0, _settingsJs.prefix}-dropdown-beingtoggled`;
    }
    /**
     * The name of the custom event fired after this dropdown item is toggled upon a user gesture.
     */ static get eventToggle() {
        return `${0, _settingsJs.prefix}-dropdown-toggled`;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
    /**
     * @returns A action for dropdown for the given key symbol.
     */ static getAction(key) {
        if (key === "Escape") return (0, _defsJs.DROPDOWN_KEYBOARD_ACTION).CLOSING;
        if (key in (0, _defsJs.NAVIGATION_DIRECTION)) return (0, _defsJs.DROPDOWN_KEYBOARD_ACTION).NAVIGATING;
        if (this.TRIGGER_KEYS.has(key)) return (0, _defsJs.DROPDOWN_KEYBOARD_ACTION).TRIGGERING;
        return (0, _defsJs.DROPDOWN_KEYBOARD_ACTION).NONE;
    }
};
/**
 * Symbols of keys that triggers opening/closing menu and selecting/deselecting menu item.
 */ CDSDropdown.TRIGGER_KEYS = new Set([
    " ",
    "Enter"
]);
CDSDropdown.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSDropdown.styles = (0, _dropdownScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSDropdown.prototype, "_activeDescendant", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)(`.${(0, _settingsJs.prefix)}--list-box`)
], CDSDropdown.prototype, "_listBoxNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)('slot[name="helper-text"]')
], CDSDropdown.prototype, "_slotHelperTextNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)('slot[name="title-text"]')
], CDSDropdown.prototype, "_slotTitleTextNode", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("focusout")
], CDSDropdown.prototype, "_handleFocusOut", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        reflect: true,
        attribute: "aria-label"
    })
], CDSDropdown.prototype, "ariaLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        reflect: true
    })
], CDSDropdown.prototype, "direction", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDropdown.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "helper-text"
    })
], CDSDropdown.prototype, "helperText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "hide-label"
    })
], CDSDropdown.prototype, "hideLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDropdown.prototype, "invalid", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "invalid-text"
    })
], CDSDropdown.prototype, "invalidText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "title-text"
    })
], CDSDropdown.prototype, "titleText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSDropdown.prototype, "name", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDropdown.prototype, "open", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "read-only"
    })
], CDSDropdown.prototype, "readOnly", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDropdown.prototype, "required", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "required-validity-message"
    })
], CDSDropdown.prototype, "requiredValidityMessage", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSDropdown.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "toggle-label-closed"
    })
], CDSDropdown.prototype, "toggleLabelClosed", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "toggle-label-open"
    })
], CDSDropdown.prototype, "toggleLabelOpen", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label"
    })
], CDSDropdown.prototype, "label", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSDropdown.prototype, "type", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "validity-message"
    })
], CDSDropdown.prototype, "validityMessage", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSDropdown.prototype, "value", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDropdown.prototype, "warn", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "warn-text"
    })
], CDSDropdown.prototype, "warnText", void 0);
CDSDropdown = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-dropdown`)
], CDSDropdown);
var CDSDropdown$1 = CDSDropdown;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit/directives/if-defined.js":"hSgrS","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../icons/chevron--down/16.js":"kXGdJ","../../icons/warning--filled/16.js":"ajngV","../../icons/warning--alt--filled/16.js":"21PDf","../../globals/mixins/focus.js":"5k7ow","../../globals/mixins/form.js":"kISjL","../../globals/mixins/host-listener.js":"1SMUX","../../globals/mixins/validity.js":"6QCpZ","../../globals/decorators/host-listener.js":"f95Mj","../../globals/internal/collection-helpers.js":"4aZkz","./defs.js":"9eS24","./dropdown.scss.js":"55Q1R","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9eS24":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DROPDOWN_COLOR_SCHEME", ()=>(0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME));
parcelHelpers.export(exports, "DROPDOWN_DIRECTION", ()=>DROPDOWN_DIRECTION);
parcelHelpers.export(exports, "DROPDOWN_KEYBOARD_ACTION", ()=>DROPDOWN_KEYBOARD_ACTION);
parcelHelpers.export(exports, "DROPDOWN_SIZE", ()=>DROPDOWN_SIZE);
parcelHelpers.export(exports, "DROPDOWN_TYPE", ()=>DROPDOWN_TYPE);
parcelHelpers.export(exports, "NAVIGATION_DIRECTION", ()=>NAVIGATION_DIRECTION);
var _sharedEnumsJs = require("../../globals/shared-enums.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Navigation direction, associated with key symbols.
 */ const NAVIGATION_DIRECTION = {
    Up: -1,
    ArrowUp: -1,
    Down: 1,
    ArrowDown: 1
};
/**
 * The keyboard action categories for dropdown.
 */ var DROPDOWN_KEYBOARD_ACTION;
(function(DROPDOWN_KEYBOARD_ACTION) {
    /**
     * Not doing any action.
     */ DROPDOWN_KEYBOARD_ACTION["NONE"] = "none";
    /**
     * Keyboard action to close menu.
     */ DROPDOWN_KEYBOARD_ACTION["CLOSING"] = "closing";
    /**
     * Keyboard action to navigate back/forward.
     */ DROPDOWN_KEYBOARD_ACTION["NAVIGATING"] = "navigating";
    /**
     * Keyboard action to open/close menu on the trigger button or select/deselect a menu item.
     */ DROPDOWN_KEYBOARD_ACTION["TRIGGERING"] = "triggering";
})(DROPDOWN_KEYBOARD_ACTION || (DROPDOWN_KEYBOARD_ACTION = {}));
/**
 * Dropdown size.
 */ var DROPDOWN_SIZE;
(function(DROPDOWN_SIZE) {
    /**
     * Small size.
     */ DROPDOWN_SIZE["SMALL"] = "sm";
    /**
     * Medium size.
     */ DROPDOWN_SIZE["MEDIUM"] = "md";
    /**
     * Large size.
     */ DROPDOWN_SIZE["LARGE"] = "lg";
})(DROPDOWN_SIZE || (DROPDOWN_SIZE = {}));
/**
 * Dropdown types.
 */ var DROPDOWN_TYPE;
(function(DROPDOWN_TYPE) {
    /**
     * Default type.
     */ DROPDOWN_TYPE["DEFAULT"] = "";
    /**
     * Inline type.
     */ DROPDOWN_TYPE["INLINE"] = "inline";
})(DROPDOWN_TYPE || (DROPDOWN_TYPE = {}));
/**
 * Dropdown direction.
 */ var DROPDOWN_DIRECTION;
(function(DROPDOWN_DIRECTION) {
    /**
     * Top.
     */ DROPDOWN_DIRECTION["TOP"] = "top";
    /**
     * Bottom.
     */ DROPDOWN_DIRECTION["BOTTOM"] = "bottom";
})(DROPDOWN_DIRECTION || (DROPDOWN_DIRECTION = {}));

},{"../../globals/shared-enums.js":"12kea","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"55Q1R":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));background-color:var(--cds-field);block-size:var(--cds-layout-size-height-local);border:none;border-block-end:1px solid var(--cds-border-strong);box-sizing:border-box;color:var(--cds-text-primary,#161616);font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:2px solid transparent;outline-offset:-2px;padding:0;padding:0 var(--cds-layout-density-padding-inline-local);transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--text-input *,.cds--text-input :after,.cds--text-input :before{box-sizing:inherit}.cds--text-input:active,.cds--text-input:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input:active,.cds--text-input:focus{outline-style:dotted}}.cds--text-input-wrapper svg[hidden]{display:none}.cds--password-input{padding-inline-end:2.5rem}.cds--text-input--sm.cds--password-input{padding-inline-end:2rem}.cds--text-input--lg.cds--password-input{padding-inline-end:3rem}.cds--text-input::-moz-placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input::placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input--light{background-color:var(--cds-field-02,#fff)}.cds--text-input__field-wrapper{display:flex;inline-size:100%;position:relative}.cds--text-input__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:1rem;transform:translateY(-50%)}.cds--text-input__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--text-input__invalid-icon--warning path:first-of-type{fill:#000;opacity:1}.cds--text-input--password__visibility{align-items:center;cursor:pointer;display:inline-flex;overflow:visible;position:relative}.cds--text-input--password__visibility:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus{outline-style:dotted}}.cds--text-input--password__visibility:focus{outline:1px solid transparent}.cds--text-input--password__visibility:focus svg{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus svg{outline-style:dotted}}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{align-items:center;display:flex;opacity:0;pointer-events:none;position:absolute;z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{display:inline-block}}.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:opacity 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:none}}.cds--text-input--password__visibility.cds--tooltip--a11y:after,.cds--text-input--password__visibility.cds--tooltip--a11y:before{transition:none}.cds--text-input--password__visibility:before{block-size:0;border-style:solid;content:"";inline-size:0}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text{box-sizing:content-box;color:inherit;opacity:1;white-space:normal;word-break:break-word}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);max-inline-size:13rem;min-inline-size:1.5rem;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-accelerator:true){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{border:1px solid transparent}}.cds--text-input--password__visibility:after{content:attr(aria-label)}.cds--text-input--password__visibility.cds--tooltip--a11y:after{content:none}.cds--text-input--password__visibility.cds--tooltip--visible:after,.cds--text-input--password__visibility.cds--tooltip--visible:before,.cds--text-input--password__visibility:focus:after,.cds--text-input--password__visibility:focus:before,.cds--text-input--password__visibility:hover:after,.cds--text-input--password__visibility:hover:before{opacity:1}@keyframes cds--tooltip-fade{0%{opacity:0}to{opacity:1}}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text{margin:auto;overflow:visible;clip:auto}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible.cds--tooltip--a11y:before,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:focus.cds--tooltip--a11y:before,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text,.cds--text-input--password__visibility:hover.cds--tooltip--a11y:before{animation:cds--tooltip-fade 70ms cubic-bezier(.2,0,.38,.9)}.cds--text-input--password__visibility.cds--tooltip--hidden .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--hidden+.cds--assistive-text{margin:-1px;overflow:hidden;clip:rect(0,0,0,0)}.cds--text-input--password__visibility.cds--tooltip--hidden.cds--tooltip--a11y:before{animation:none;opacity:0}.cds--text-input--password__visibility .cds--assistive-text:after{block-size:.75rem;content:"";display:block;inline-size:100%;inset-block-start:-.75rem;inset-inline-start:0;position:absolute}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{inset-block-end:0;inset-inline-start:50%}.cds--text-input--password__visibility:before{border-color:transparent transparent var(--cds-background-inverse,#393939);border-width:0 .25rem .3125rem;inset-block-end:-.5rem;transform:translate(-50%,100%)}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inset-block-end:-.8125rem;transform:translate(-50%,100%)}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{align-items:center;background:none;block-size:100%;border:0;cursor:pointer;display:flex;inline-size:2.5rem;inset-inline-end:0;justify-content:center;min-block-size:auto;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--toggle-password-tooltip .cds--popover{inset-inline-start:-2.5rem}.cds--toggle-password-tooltip .cds--popover-content{min-inline-size:2.5rem}.cds--text-input--sm+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:2rem}.cds--text-input--lg+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:3rem}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252);transition:fill 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:ButtonText}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline-style:dotted}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus svg,.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-primary,#161616)}.cds--text-input--invalid,.cds--text-input--warning{padding-inline-end:2.5rem}.cds--text-input--invalid.cds--password-input{padding-inline-end:4rem}.cds--text-input--invalid+.cds--text-input--password__visibility__toggle{inset-inline-end:1rem}.cds--password-input-wrapper .cds--text-input__invalid-icon{inset-inline-end:2.5rem}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{cursor:not-allowed}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg:hover{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input__counter-alert{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px}.cds--text-input:disabled{background-color:var(--cds-field);border-block-end:1px solid transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;outline:2px solid transparent;outline-offset:-2px;-webkit-text-fill-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input--light:disabled{background-color:var(--cds-field-02,#fff)}.cds--text-input:disabled::-moz-placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input:disabled::placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input--invalid{box-shadow:none;outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input--invalid{outline-style:dotted}}.cds--text-input--invalid .cds--text-input--password__visibility__toggle{inset-inline-end:2.5rem}.cds--skeleton.cds--text-input{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;padding:0;pointer-events:none;position:relative}.cds--skeleton.cds--text-input:active,.cds--skeleton.cds--text-input:focus,.cds--skeleton.cds--text-input:hover{border:none;cursor:default;outline:none}.cds--skeleton.cds--text-input:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--skeleton.cds--text-input:before{animation:none}}.cds--form--fluid .cds--text-input-wrapper{background:var(--cds-field);position:relative;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--form--fluid .cds--label{align-items:center;block-size:1rem;display:flex;inset-block-start:.8125rem;inset-inline-start:1rem;margin:0;position:absolute;z-index:1}.cds--form--fluid .cds--form__helper-text{display:none}.cds--form--fluid .cds--text-input{min-block-size:4rem;padding:2rem 1rem .8125rem}.cds--form--fluid .cds--text-input__divider,.cds--text-input__divider{display:none}.cds--form--fluid .cds--text-input--invalid,.cds--form--fluid .cds--text-input--warning{border-block-end:none}.cds--form--fluid .cds--text-input--invalid+.cds--text-input__divider,.cds--form--fluid .cds--text-input--warning+.cds--text-input__divider{border-color:var(--cds-border-subtle);border-style:solid;border-block-end:none;display:block;margin:0 1rem}.cds--form--fluid .cds--text-input__invalid-icon{inset-block-start:5rem}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid{outline:none}.cds--form--fluid .cds--text-input__field-wrapper--warning{border-block-end:1px solid var(--cds-border-strong)}.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning:focus,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:focus{outline:none}.cds--text-input-wrapper.cds--text-input-wrapper--inline{flex-flow:row wrap}.cds--text-input-wrapper .cds--label--inline{flex:1;margin:.8125rem 0 0;overflow-wrap:break-word;word-break:break-word}.cds--text-input-wrapper .cds--label--inline--sm{margin-block-start:.5625rem}.cds--text-input-wrapper .cds--label--inline--lg{margin-block-start:1.0625rem}.cds--text-input__label-helper-wrapper{flex:2;flex-direction:column;margin-inline-end:1.5rem;max-inline-size:8rem;overflow-wrap:break-word}.cds--text-input-wrapper .cds--form__helper-text--inline{margin-block-start:.125rem}.cds--text-input__field-outer-wrapper{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;inline-size:100%}.cds--text-input__field-outer-wrapper--inline{flex:8;flex-direction:column}.cds--text-input-wrapper--inline .cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--text-input-wrapper--inline--invalid .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input-wrapper--readonly,.cds--text-input-wrapper--readonly .cds--text-input{background:transparent;border-block-end-color:var(--cds-border-subtle)}.cds--text-input__field-wrapper .cds--ai-label,.cds--text-input__field-wrapper .cds--slug,.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator>*{inset-block-start:50%;inset-inline-end:1rem;position:absolute;transform:translateY(-50%)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label):not(:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug):not(:has(~.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug){padding-inline-end:2.5rem}.cds--text-input--invalid:has(~.cds--ai-label),.cds--text-input--invalid:has(~.cds--slug),.cds--text-input--invalid:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input--warning:has(~.cds--ai-label),.cds--text-input--warning:has(~.cds--slug),.cds--text-input--warning:has(~.cds--text-input__field-inner-wrapper--decorator>*){padding-inline-end:4rem}.cds--text-input--invalid~.cds--ai-label,.cds--text-input--invalid~.cds--slug,.cds--text-input--invalid~.cds--text-input__field-inner-wrapper--decorator>*,.cds--text-input--warning~.cds--ai-label,.cds--text-input--warning~.cds--slug,.cds--text-input--warning~.cds--text-input__field-inner-wrapper--decorator>*{inset-inline-end:2.5rem}.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator:not(:has(.cds--ai-label))>*{block-size:1rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:ButtonText}}.cds--text-input__label-wrapper{display:flex;inline-size:100%;justify-content:space-between}.cds--text-input__label-wrapper .cds--text-input__label-counter{align-self:end}.cds--tag{--cds-layout-size-height-xs:1.125rem;--cds-layout-size-height-sm:1.125rem;--cds-layout-size-height-md:1.5rem;--cds-layout-size-height-lg:2rem;--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));align-items:center;background-color:var(--cds-tag-background-gray,#e0e0e0);border-radius:1rem;color:var(--cds-tag-color-gray,#161616);cursor:default;display:inline-flex;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem;max-inline-size:13rem;min-block-size:var(--cds-layout-size-height-local);min-inline-size:2rem;padding-inline:.5rem;vertical-align:middle;word-break:break-word}.cds--layout--size-xs .cds--tag{--cds-layout-size-height:var(--cds-layout-size-height-xs)}.cds--layout--size-sm .cds--tag{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--tag{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--tag{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--tag.cds--tag--operational{border:1px solid var(--cds-tag-background-gray,#e0e0e0)}.cds--tag .cds--tag__close-icon:hover,.cds--tag.cds--tag--operational:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1)}.cds--tag.cds--tag--lg{padding-inline-start:.75rem}.cds--tag:has(.cds--tag__custom-icon){padding-inline-start:.25rem}.cds--tag.cds--tag--lg:not(.cds--tag--filter){padding-inline:.75rem}.cds--tag.cds--tag--lg:has(.cds--tag__custom-icon){padding-inline-start:.5rem}.cds--tag:not(.cds--tag--selectable){border:0}.cds--tag:not(:first-child){margin-inline-start:0}.cds--tag--operational>span,.cds--tag--selectable>span,.cds--tag__label{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cds--tag--interactive:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--tag--filter{padding-block:0;padding-inline-end:0}.cds--tag--filter:hover{outline:none}.cds--tag--selectable{background-color:var(--cds-layer);border:1px solid var(--cds-border-inverse,#161616);color:var(--cds-text-primary,#161616);cursor:pointer}.cds--tag--selectable:hover{background-color:var(--cds-layer-hover);outline:none}.cds--tag--selectable:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--tag--selectable-selected{color:var(--cds-text-inverse,#fff)}.cds--tag--selectable-selected,.cds--tag--selectable-selected:hover{background-color:var(--cds-layer-selected-inverse,#161616)}.cds--tag--operational{background-color:var(--cds-tag-background-gray,#e0e0e0);border:1px solid var(--cds-tag-border-gray,#a8a8a8);color:var(--cds-tag-color-gray,#161616);cursor:pointer}.cds--tag--operational:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1);outline:none}.cds--tag--operational:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--tag--red{background-color:var(--cds-tag-background-red,#ffd7d9);color:var(--cds-tag-color-red,#a2191f)}.cds--tag--red.cds--tag--operational{border:1px solid var(--cds-tag-border-red,#ff8389)}.cds--tag--red .cds--tag__close-icon:hover,.cds--tag--red.cds--tag--operational:hover{background-color:var(--cds-tag-hover-red,#ffc2c5)}.cds--tag--magenta{background-color:var(--cds-tag-background-magenta,#ffd6e8);color:var(--cds-tag-color-magenta,#9f1853)}.cds--tag--magenta.cds--tag--operational{border:1px solid var(--cds-tag-border-magenta,#ff7eb6)}.cds--tag--magenta .cds--tag__close-icon:hover,.cds--tag--magenta.cds--tag--operational:hover{background-color:var(--cds-tag-hover-magenta,#ffbdda)}.cds--tag--purple{background-color:var(--cds-tag-background-purple,#e8daff);color:var(--cds-tag-color-purple,#6929c4)}.cds--tag--purple.cds--tag--operational{border:1px solid var(--cds-tag-border-purple,#be95ff)}.cds--tag--purple .cds--tag__close-icon:hover,.cds--tag--purple.cds--tag--operational:hover{background-color:var(--cds-tag-hover-purple,#dcc7ff)}.cds--tag--blue{background-color:var(--cds-tag-background-blue,#d0e2ff);color:var(--cds-tag-color-blue,#0043ce)}.cds--tag--blue.cds--tag--operational{border:1px solid var(--cds-tag-border-blue,#78a9ff)}.cds--tag--blue .cds--tag__close-icon:hover,.cds--tag--blue.cds--tag--operational:hover{background-color:var(--cds-tag-hover-blue,#b8d3ff)}.cds--tag--cyan{background-color:var(--cds-tag-background-cyan,#bae6ff);color:var(--cds-tag-color-cyan,#00539a)}.cds--tag--cyan.cds--tag--operational{border:1px solid var(--cds-tag-border-cyan,#33b1ff)}.cds--tag--cyan .cds--tag__close-icon:hover,.cds--tag--cyan.cds--tag--operational:hover{background-color:var(--cds-tag-hover-cyan,#99daff)}.cds--tag--teal{background-color:var(--cds-tag-background-teal,#9ef0f0);color:var(--cds-tag-color-teal,#005d5d)}.cds--tag--teal.cds--tag--operational{border:1px solid var(--cds-tag-border-teal,#08bdba)}.cds--tag--teal .cds--tag__close-icon:hover,.cds--tag--teal.cds--tag--operational:hover{background-color:var(--cds-tag-hover-teal,#57e5e5)}.cds--tag--green{background-color:var(--cds-tag-background-green,#a7f0ba);color:var(--cds-tag-color-green,#0e6027)}.cds--tag--green.cds--tag--operational{border:1px solid var(--cds-tag-border-green,#42be65)}.cds--tag--green .cds--tag__close-icon:hover,.cds--tag--green.cds--tag--operational:hover{background-color:var(--cds-tag-hover-green,#74e792)}.cds--tag--gray{background-color:var(--cds-tag-background-gray,#e0e0e0);color:var(--cds-tag-color-gray,#161616)}.cds--tag--gray.cds--tag--operational{border:1px solid var(--cds-tag-border-gray,#a8a8a8)}.cds--tag--gray .cds--tag__close-icon:hover,.cds--tag--gray.cds--tag--operational:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1)}.cds--tag--cool-gray{background-color:var(--cds-tag-background-cool-gray,#dde1e6);color:var(--cds-tag-color-cool-gray,#121619)}.cds--tag--cool-gray.cds--tag--operational{border:1px solid var(--cds-tag-border-cool-gray,#a2a9b0)}.cds--tag--cool-gray .cds--tag__close-icon:hover,.cds--tag--cool-gray.cds--tag--operational:hover{background-color:var(--cds-tag-hover-cool-gray,#cdd3da)}.cds--tag--warm-gray{background-color:var(--cds-tag-background-warm-gray,#e5e0df);color:var(--cds-tag-color-warm-gray,#171414)}.cds--tag--warm-gray.cds--tag--operational{border:1px solid var(--cds-tag-border-warm-gray,#ada8a8)}.cds--tag--warm-gray .cds--tag__close-icon:hover,.cds--tag--warm-gray.cds--tag--operational:hover{background-color:var(--cds-tag-hover-warm-gray,#d8d0cf)}.cds--tag--high-contrast:not(.cds--tag--operational){background-color:var(--cds-background-inverse,#393939);color:var(--cds-text-inverse,#fff)}.cds--tag--high-contrast:not(.cds--tag--operational).cds--tag--operational{border:1px solid var(--cds-background-inverse,#393939)}.cds--tag--high-contrast:not(.cds--tag--operational) .cds--tag__close-icon:hover,.cds--tag--high-contrast:not(.cds--tag--operational).cds--tag--operational:hover{background-color:var(--cds-background-inverse-hover,#474747)}.cds--multi-select--readonly .cds--tag--high-contrast:not(.cds--tag--operational) .cds--tag__close-icon:hover{background-color:transparent}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]){background-color:var(--cds-background,#fff);color:var(--cds-text-primary,#161616);outline:1px solid var(--cds-background-inverse,#393939);outline-offset:-1px}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]).cds--tag--operational{border:1px solid var(--cds-background,#fff)}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]) .cds--tag__close-icon:hover,.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]).cds--tag--operational:hover{background-color:var(--cds-layer-hover)}.cds--tag--disabled:not(.cds--tag--operational),.cds--tag--filter.cds--tag--disabled,.cds--tag--interactive.cds--tag--disabled{background-color:var(--cds-layer);box-shadow:none;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--tag--disabled:not(.cds--tag--operational).cds--tag--operational,.cds--tag--filter.cds--tag--disabled.cds--tag--operational,.cds--tag--interactive.cds--tag--disabled.cds--tag--operational{border:1px solid var(--cds-layer)}.cds--tag--disabled:not(.cds--tag--operational) .cds--tag__close-icon:hover,.cds--tag--disabled:not(.cds--tag--operational).cds--tag--operational:hover,.cds--tag--filter.cds--tag--disabled .cds--tag__close-icon:hover,.cds--tag--filter.cds--tag--disabled.cds--tag--operational:hover,.cds--tag--interactive.cds--tag--disabled .cds--tag__close-icon:hover,.cds--tag--interactive.cds--tag--disabled.cds--tag--operational:hover{background-color:var(--cds-layer)}.cds--tag--disabled:not(.cds--tag--operational):hover,.cds--tag--filter.cds--tag--disabled:hover,.cds--tag--interactive.cds--tag--disabled:hover{cursor:not-allowed}.cds--tag--disabled:not(.cds--tag--operational) .cds--tag__label,.cds--tag--filter.cds--tag--disabled .cds--tag__label,.cds--tag--interactive.cds--tag--disabled .cds--tag__label{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--tag--operational.cds--tag--disabled,.cds--tag--selectable.cds--tag--disabled{background-color:var(--cds-layer);border:1px solid var(--cds-border-disabled,#c6c6c6);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--tag--operational.cds--tag--disabled:hover,.cds--tag--selectable.cds--tag--disabled:hover{background-color:var(--cds-layer);cursor:not-allowed}.cds--tag--interactive{transition:background-color 70ms cubic-bezier(0,0,.38,.9)}.cds--tag__close-icon{align-items:center;background-color:transparent;block-size:var(--cds-layout-size-height-local);border:0;border-radius:50%;color:currentColor;cursor:pointer;display:flex;flex-shrink:0;inline-size:var(--cds-layout-size-height-local);justify-content:center;margin:0 0 0 .125rem;padding:0;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),box-shadow 70ms cubic-bezier(.2,0,.38,.9)}.cds--tag__close-icon svg{fill:currentColor}.cds--tag__custom-icon{background-color:transparent;block-size:1rem;border:0;color:currentColor;flex-shrink:0;inline-size:1rem;margin-inline-end:.25rem;outline:none;padding:0}.cds--tag__custom-icon svg{fill:currentColor}.cds--tag--disabled .cds--tag__close-icon{cursor:not-allowed}.cds--tag__close-icon:focus{border-radius:50%;box-shadow:inset 0 0 0 1px var(--cds-focus,#0f62fe);outline:none;z-index:99999}.cds--tag--high-contrast .cds--tag__close-icon:focus{box-shadow:inset 0 0 0 1px var(--cds-focus-inverse,#fff)}.cds--tag--filter.cds--tag--disabled .cds--tag__close-icon:hover{background-color:transparent}.cds--tag--filter.cds--tag--disabled svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--tag--sm.cds--tag--filter{padding-inline-end:0}.cds--tag--sm .cds--tag__close-icon{margin-inline-start:.3125rem}.cds--tag.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);background-color:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;color:var(--cds-text-primary,#161616);inline-size:3.75rem;overflow:hidden;padding:0;pointer-events:none;position:relative}.cds--tag.cds--skeleton:active,.cds--tag.cds--skeleton:focus,.cds--tag.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--tag.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--tag.cds--skeleton:before{animation:none}}.cds--tag.cds--skeleton.cds--tag--operational{border:1px solid var(--cds-skeleton-background,#e8e8e8)}.cds--tag.cds--skeleton .cds--tag__close-icon:hover,.cds--tag.cds--skeleton.cds--tag--operational:hover{background-color:var(--cds-skeleton-background,#e8e8e8)}@media not all and (min-resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){.cds--tag.cds--skeleton{transform:translateZ(0)}}}.cds--tag .cds--ai-label .cds--ai-label__button--inline,.cds--tag .cds--slug .cds--slug__button--inline{color:currentColor;margin-inline-start:.0625rem}.cds--tag .cds--ai-label .cds--ai-label__button--inline .cds--ai-label__text:before,.cds--tag .cds--slug .cds--slug__button--inline .cds--slug__text:before{background-color:currentColor}.cds--tag .cds--ai-label .cds--ai-label__button--inline:hover,.cds--tag .cds--slug .cds--slug__button--inline:hover{border-color:currentColor}.cds--tag--filter .cds--ai-label,.cds--tag--filter .cds--slug,.cds--tag--filter .cds--tag__decorator>*{min-inline-size:2.00875rem}.cds--tag .cds--tag__decorator:not(:has(.cds--ai-label)){block-size:1rem;text-align:center}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--tag{outline:1px solid transparent}.cds--tag__close-icon svg,.cds--tag__custom-icon svg{fill:ButtonText}.cds--tag__close-icon:focus{color:Highlight;outline:1px solid Highlight}}.cds--tag-label-tooltip{max-inline-size:-webkit-fill-available}.cds--tag__custom-icon+.cds--tag-label-tooltip{max-inline-size:11rem}.cds--tag--filter .cds--tag__custom-icon+.cds--tag-label-tooltip{max-inline-size:9.875rem}.cds--interactive--tag-children{display:inline-flex;max-inline-size:12.5rem;place-items:center}.cds--tag--filter .cds--tag__custom-icon+span>.cds--interactive--tag-children{max-inline-size:11.5rem}.cds--tag .cds--definition-term{border-block-end:none;cursor:default;max-inline-size:12rem}.cds--tag .cds--tag__custom-icon+span>.cds--definition-term{max-inline-size:11rem}.cds--tag>.cds--popover-container{display:flex}.cds--toggletip-button:has(.cds--tag--operational.cds--tag--disabled){pointer-events:none}.cds--dropdown__wrapper--inline{align-items:center;display:inline-grid;grid-gap:0 1.5rem;grid-template:auto/auto min-content}.cds--dropdown__wrapper--inline:has(.cds--label.cds--visually-hidden){grid-template:auto/auto}.cds--dropdown__wrapper--inline .cds--label{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--dropdown__wrapper--inline .cds--form-requirement,.cds--dropdown__wrapper--inline .cds--form__helper-text,.cds--dropdown__wrapper--inline .cds--label{margin:0}.cds--dropdown__wrapper--inline .cds--form-requirement{grid-column:2}.cds--dropdown{background-color:var(--cds-field);block-size:2.5rem;border:none;border-block-end:1px solid var(--cds-border-strong);color:var(--cds-text-primary,#161616);cursor:pointer;display:block;inline-size:100%;list-style:none;outline:2px solid transparent;outline-offset:-2px;position:relative;transition:background-color 70ms cubic-bezier(.2,0,.38,.9)}.cds--dropdown html{font-size:100%}.cds--dropdown body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--dropdown code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--dropdown strong{font-weight:600}.cds--dropdown:hover{background-color:var(--cds-field-hover)}.cds--dropdown .cds--list-box__field{text-align:start}.cds--dropdown--lg{block-size:3rem;max-block-size:3rem}.cds--dropdown--lg .cds--dropdown__arrow{inset-block-start:1rem}.cds--dropdown--sm{block-size:2rem;max-block-size:2rem}.cds--dropdown--sm .cds--dropdown__arrow{inset-block-start:.5rem}.cds--dropdown--open{border-block-end-color:var(--cds-border-subtle)}.cds--dropdown--open .cds--list-box__field{outline:none}.cds--dropdown--invalid{outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--dropdown--invalid{outline-style:dotted}}.cds--dropdown--invalid .cds--dropdown-text{padding-inline-end:3.5rem}.cds--dropdown--invalid+.cds--form-requirement{color:var(--cds-text-error,#da1e28);display:inline-block;max-block-size:12.5rem}.cds--dropdown__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:2.5rem;transform:translateY(-50%)}.cds--dropdown--open:hover{background-color:var(--cds-field)}.cds--dropdown--open:focus{outline:1px solid transparent}.cds--dropdown--open .cds--dropdown-list{box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));max-block-size:13.75rem;transition:max-height .11s cubic-bezier(0,0,.38,.9)}.cds--dropdown--light{background-color:var(--cds-field-02,#fff)}.cds--dropdown--light:hover{background-color:var(--cds-field-hover)}.cds--dropdown--up .cds--dropdown-list{inset-block-end:2rem}.cds--dropdown__arrow{position:absolute;fill:var(--cds-icon-primary,#161616);inset-block-start:.8125rem;inset-inline-end:1rem;pointer-events:none;transform-origin:50% 45%;transition:transform .11s cubic-bezier(.2,0,.38,.9)}button.cds--dropdown-text{background:none;border:none;color:var(--cds-text-primary,#161616);inline-size:100%;text-align:start}button.cds--dropdown-text:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){button.cds--dropdown-text:focus{outline-style:dotted}}.cds--dropdown-text{block-size:calc(100% + 1px);display:block;overflow:hidden;padding-inline:1rem 2.625rem;text-overflow:ellipsis;white-space:nowrap}.cds--dropdown-list,.cds--dropdown-text{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--dropdown-list{background-color:var(--cds-layer);box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));display:flex;flex-direction:column;inline-size:100%;list-style:none;max-block-size:0;outline:2px solid transparent;outline-offset:-2px;overflow:hidden auto;position:absolute;transition:max-height .11s cubic-bezier(.2,0,.38,.9);z-index:9100}.cds--dropdown-list html{font-size:100%}.cds--dropdown-list body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--dropdown-list code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--dropdown-list strong{font-weight:600}.cds--dropdown--light .cds--dropdown-list{background-color:var(--cds-layer)}.cds--dropdown:not(.cds--dropdown--open) .cds--dropdown-item{visibility:hidden}.cds--dropdown-item{opacity:0;position:relative;transition:visibility 70ms cubic-bezier(.2,0,.38,.9),opacity 70ms cubic-bezier(.2,0,.38,.9),background-color 70ms cubic-bezier(.2,0,.38,.9);visibility:inherit}.cds--dropdown-item:hover{background-color:var(--cds-layer-hover)}.cds--dropdown-item:hover+.cds--dropdown-item .cds--dropdown-link{border-color:transparent}.cds--dropdown-item:active{background-color:var(--cds-layer-selected)}.cds--dropdown-item:first-of-type .cds--dropdown-link{border-block-start-color:transparent}.cds--dropdown-item:last-of-type .cds--dropdown-link{border-block-end:none}.cds--dropdown-link{block-size:2.5rem;border:1px solid transparent;border-block-start-color:var(--cds-border-subtle);color:var(--cds-text-secondary,#525252);display:block;font-weight:400;line-height:1rem;margin:0 1rem;outline:2px solid transparent;outline-offset:-2px;overflow:hidden;padding:.6875rem 0;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.cds--dropdown-link:hover{border-color:transparent;color:var(--cds-text-primary,#161616)}.cds--dropdown--light .cds--dropdown-link{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--dropdown--sm .cds--dropdown-link{block-size:2rem;padding-block:.4375rem .4375rem}.cds--dropdown--focused,.cds--dropdown-link:focus{margin:0;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;padding:.6875rem 1rem}@media screen and (prefers-contrast){.cds--dropdown--focused,.cds--dropdown-link:focus{outline-style:dotted}}.cds--dropdown-list[aria-activedescendant] .cds--dropdown-link:focus{margin:0 1rem;outline:none;padding:.6875rem 0}.cds--dropdown-list[aria-activedescendant] .cds--dropdown--focused:focus{margin:0;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;padding:.6875rem 1rem}@media screen and (prefers-contrast){.cds--dropdown-list[aria-activedescendant] .cds--dropdown--focused:focus{outline-style:dotted}}.cds--dropdown-list[aria-activedescendant] .cds--dropdown-item:active{background-color:inherit}.cds--dropdown-item:hover .cds--dropdown-link{border-block-end-color:var(--cds-layer-hover)}.cds--dropdown--open .cds--dropdown__arrow{transform:rotate(-180deg)}.cds--dropdown--open.cds--dropdown--sm .cds--dropdown-list{max-block-size:11rem}.cds--dropdown--open .cds--dropdown-item{opacity:1}.cds--dropdown--disabled{border-block-end-color:transparent}.cds--dropdown--disabled:hover{background-color:var(--cds-field)}.cds--dropdown--disabled:focus{outline:none}.cds--dropdown--disabled .cds--dropdown-text,.cds--dropdown--disabled .cds--list-box__label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--dropdown--disabled .cds--dropdown__arrow,.cds--dropdown--disabled .cds--list-box__menu-icon svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--dropdown--disabled.cds--dropdown--light:hover{background-color:var(--cds-field-02,#fff)}.cds--dropdown--disabled .cds--list-box__field,.cds--dropdown--disabled .cds--list-box__menu-icon{cursor:not-allowed}.cds--dropdown--auto-width{inline-size:auto;max-inline-size:25rem}.cds--dropdown--inline{background-color:transparent;border-block-end-color:transparent;display:inline-block;inline-size:auto;justify-self:start;transition:background 70ms cubic-bezier(0,0,.38,.9)}.cds--dropdown--inline:hover{background-color:var(--cds-layer-hover)}.cds--dropdown--inline.cds--dropdown--disabled{background-color:transparent}.cds--dropdown--inline .cds--dropdown__arrow{inset-block-start:.5rem;inset-inline-end:.5rem}.cds--dropdown--inline.cds--dropdown--open{background-color:transparent}.cds--dropdown--inline .cds--dropdown-text{block-size:2rem;color:var(--cds-text-primary,#161616);display:inline-block;overflow:visible;padding:.4375rem 2rem .4375rem .75rem}.cds--dropdown--inline.cds--dropdown--disabled .cds--dropdown-text{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--dropdown--inline.cds--dropdown--disabled:focus .cds--dropdown-text{outline:0}.cds--dropdown--inline.cds--dropdown--invalid .cds--dropdown__invalid-icon{inset-inline-end:2rem}.cds--dropdown--inline.cds--dropdown--invalid .cds--dropdown-text{padding-inline-end:3.5rem}.cds--dropdown--inline.cds--dropdown--open:focus .cds--dropdown-list{box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3))}.cds--dropdown--inline .cds--dropdown-link{font-weight:400}.cds--dropdown--show-selected .cds--dropdown--selected{background-color:var(--cds-layer-selected);color:var(--cds-text-primary,#161616);display:block}.cds--dropdown--show-selected .cds--dropdown--selected:hover{background-color:var(--cds-layer-selected-hover)}.cds--dropdown--show-selected .cds--dropdown--selected .cds--dropdown-link,.cds--dropdown--show-selected .cds--dropdown--selected+.cds--dropdown-item .cds--dropdown-link{border-block-start-color:transparent}.cds--dropdown--show-selected .cds--dropdown--selected .cds--list-box__menu-item__selected-icon{display:block}.cds--dropdown-v2.cds--skeleton,.cds--dropdown.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;padding:0;pointer-events:none;position:relative}.cds--dropdown-v2.cds--skeleton:active,.cds--dropdown-v2.cds--skeleton:focus,.cds--dropdown-v2.cds--skeleton:hover,.cds--dropdown.cds--skeleton:active,.cds--dropdown.cds--skeleton:focus,.cds--dropdown.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--dropdown-v2.cds--skeleton:before,.cds--dropdown.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--dropdown-v2.cds--skeleton:before,.cds--dropdown.cds--skeleton:before{animation:none}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--dropdown .cds--list-box__field{outline:1px solid transparent}.cds--list-box__menu-item__option{outline:none}.cds--list-box__menu-item__selected-icon{fill:ButtonText}}.cds--dropdown--readonly,.cds--dropdown--readonly:hover,:host(cds-dropdown[read-only]){background-color:transparent;border-block-end-color:var(--cds-border-subtle)}.cds--dropdown--inline.cds--dropdown--readonly{border-block-end-color:transparent}.cds--dropdown--readonly .cds--list-box__field,.cds--dropdown--readonly .cds--list-box__menu-icon,:host(cds-dropdown[read-only]) .cds--list-box__field,:host(cds-dropdown[read-only]) .cds--list-box__menu-icon{cursor:default}.cds--dropdown--readonly .cds--list-box__menu-icon svg,:host(cds-dropdown[read-only]) .cds--list-box__menu-icon svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--checkbox-group *,.cds--checkbox-group :after,.cds--checkbox-group :before{box-sizing:inherit}.cds--form-item.cds--checkbox-wrapper{margin-block-end:.375rem;position:relative}.cds--form-item.cds--checkbox-wrapper:first-of-type{margin-block-start:0}.cds--label+.cds--form-item.cds--checkbox-wrapper{margin-block-start:-.125rem}.cds--form-item.cds--checkbox-wrapper:last-of-type{margin-block-end:.1875rem}.cds--checkbox{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;inset-block-start:1.25rem;inset-inline-start:.7rem;visibility:inherit;white-space:nowrap}.cds--checkbox-label{cursor:pointer;display:flex;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);min-block-size:1.25rem;padding-block-start:.0625rem;padding-inline-start:1.25rem;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none}.cds--checkbox-label html{font-size:100%}.cds--checkbox-label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--checkbox-label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--checkbox-label strong{font-weight:600}.cds--checkbox-label-text{padding-inline-start:.625rem}.cds--checkbox-label:after,.cds--checkbox-label:before{box-sizing:border-box}@media print{.cds--checkbox-label:after,.cds--checkbox-label:before{-webkit-print-color-adjust:exact;print-color-adjust:exact}}.cds--checkbox-label:before{background-color:transparent;block-size:1rem;border:1px solid var(--cds-icon-primary,#161616);border-radius:2px;content:"";inline-size:1rem;inset-block-start:.125rem;inset-inline-start:0;margin-block:.0625rem .125rem;margin-inline:.1875rem 0;position:absolute}.cds--checkbox-label:after{background:none;block-size:.3125rem;border-block-end:1.5px solid var(--cds-icon-inverse,#fff);border-inline-start:1.5px solid var(--cds-icon-inverse,#fff);content:"";inline-size:.5625rem;inset-block-start:.40625rem;inset-inline-start:.4375rem;margin-block-start:-.1875rem;position:absolute;transform:scale(0) rotate(-45deg);transform-origin:bottom right}.cds--checkbox-label[data-contained-checkbox-state=true]:before,.cds--checkbox:checked+.cds--checkbox-label:before,.cds--checkbox:indeterminate+.cds--checkbox-label:before{background-color:var(--cds-icon-primary,#161616);border:1px}.cds--checkbox-label[data-contained-checkbox-state=true]:after,.cds--checkbox:checked+.cds--checkbox-label:after{transform:scale(1) rotate(-45deg)}.cds--checkbox:indeterminate+.cds--checkbox-label:after{border-block-end:2px solid var(--cds-icon-inverse,#fff);border-inline-start:0 solid var(--cds-icon-inverse,#fff);inline-size:.5rem;inset-block-start:.6875rem;transform:scale(1) rotate(0deg)}.cds--checkbox-label[data-contained-checkbox-state=true].cds--checkbox-label__focus:before,.cds--checkbox-label__focus:before,.cds--checkbox:checked:focus+.cds--checkbox-label:before,.cds--checkbox:focus+.cds--checkbox-label:before,.cds--checkbox:indeterminate:focus+.cds--checkbox-label:before{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--checkbox-label[data-contained-checkbox-disabled=true],.cds--checkbox:disabled+.cds--checkbox-label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--checkbox-label[data-contained-checkbox-disabled=true]:before,.cds--checkbox:disabled+.cds--checkbox-label:before{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-label[data-contained-checkbox-state=true][data-contained-checkbox-disabled=true]:before,.cds--checkbox:checked:disabled+.cds--checkbox-label:before,.cds--checkbox:indeterminate:disabled+.cds--checkbox-label:before{background-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group[data-invalid] .cds--checkbox-label:before,.cds--checkbox-wrapper--invalid .cds--checkbox-label:before,.cds--checkbox-wrapper--invalid .cds--checkbox:checked+.cds--checkbox-label:before{border:1px solid var(--cds-support-error,#da1e28)}.cds--checkbox-group .cds--checkbox-wrapper--invalid>.cds--checkbox__validation-msg,.cds--checkbox-group .cds--checkbox-wrapper--warning>.cds--checkbox__validation-msg,.cds--checkbox-group .cds--checkbox-wrapper>.cds--form__helper-text{display:none}.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox-label:before,.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox:checked+.cds--checkbox-label:before{border:1px solid var(--cds-icon-primary,#161616)}.cds--checkbox-group__validation-msg,.cds--checkbox__validation-msg{align-items:flex-start;display:none;inline-size:100%;margin-block-start:.25rem}.cds--checkbox__invalid-icon{margin:.0625rem .0625rem 0 .1875rem;fill:var(--cds-support-error,#da1e28);min-inline-size:1rem}.cds--checkbox__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--checkbox__invalid-icon--warning path:first-of-type{fill:#000}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg,.cds--checkbox-group--warning .cds--checkbox-group__validation-msg,.cds--checkbox-wrapper--invalid>.cds--checkbox__validation-msg,.cds--checkbox-wrapper--warning>.cds--checkbox__validation-msg{display:flex}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-group--warning .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--warning .cds--checkbox__validation-msg .cds--form-requirement{display:block;margin-block-start:0;margin-inline-start:.5rem;max-block-size:100%;overflow:visible}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--checkbox-group--readonly .cds--checkbox-label,.cds--checkbox-wrapper--readonly .cds--checkbox-label{cursor:default}.cds--checkbox-group--readonly .cds--checkbox-label-text,.cds--checkbox-wrapper--readonly .cds--checkbox-label-text{cursor:text;-webkit-user-select:text;-moz-user-select:text;user-select:text}.cds--checkbox-group--readonly .cds--checkbox+.cds--checkbox-label:before,.cds--checkbox-wrapper--readonly .cds--checkbox+.cds--checkbox-label:before{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group--readonly .cds--checkbox:checked+.cds--checkbox-label:before,.cds--checkbox-wrapper--readonly .cds--checkbox:checked+.cds--checkbox-label:before{background:transparent;border:1px solid var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group--readonly .cds--checkbox:checked+.cds--checkbox-label:after,.cds--checkbox-wrapper--readonly .cds--checkbox:checked+.cds--checkbox-label:after{border-color:var(--cds-text-primary,#161616)}.cds--checkbox-skeleton .cds--checkbox-label{cursor:default}.cds--checkbox-label-text.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;inline-size:6.25rem;margin-block:.0625rem 0;margin-inline:.375rem 0;padding:0;pointer-events:none;position:relative}.cds--checkbox-label-text.cds--skeleton:active,.cds--checkbox-label-text.cds--skeleton:focus,.cds--checkbox-label-text.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--checkbox-label-text.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--checkbox-label-text.cds--skeleton:before{animation:none}}.cds--checkbox--inline{position:relative}[dir=rtl] .cds--checkbox-label:after{margin-block-start:0;margin-inline-start:-.0625rem;transform-origin:center}[dir=rtl] .cds--checkbox-label[data-contained-checkbox-state=true]:after,[dir=rtl] .cds--checkbox:checked+.cds--checkbox-label:after{transform:scale(1.2) rotate3d(.5,1,0,158deg)}.cds--checkbox-group--decorator legend.cds--label,.cds--checkbox-group--slug legend.cds--label,.cds--checkbox-wrapper--decorator .cds--checkbox-label-text,.cds--checkbox-wrapper--slug .cds--checkbox-label-text{display:flex}.cds--checkbox-group--decorator legend.cds--label .cds--checkbox-group-inner--decorator>*,.cds--checkbox-group--slug legend.cds--label .cds--ai-label,.cds--checkbox-group--slug legend.cds--label .cds--slug,.cds--checkbox-wrapper--decorator .cds--checkbox-label-text .cds--checkbox-wrapper-inner--decorator>*,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--ai-label,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug{margin-inline-start:.5rem}.cds--checkbox-wrapper--decorator .cds--checkbox-label-text .cds--ai-label__button--inline,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--ai-label__button--inline,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug__button--inline{line-height:inherit;margin-block-start:-.0625rem}.cds--checkbox-group--horizontal{display:flex;flex-flow:row wrap;justify-content:flex-start;position:relative}.cds--checkbox-group--horizontal .cds--form-item{flex:none;margin-block-end:0}.cds--checkbox-group--horizontal .cds--form-item:not(:last-of-type){margin-inline-end:1rem}.cds--checkbox-group--horizontal .cds--checkbox-label-text{padding-inline-start:.5rem}.cds--checkbox-group--horizontal .cds--label+.cds--form-item.cds--checkbox-wrapper{margin-block-start:0}.cds--list-box__wrapper{display:block}.cds--list-box__wrapper--inline,:host(cds-dropdown[type=inline]){align-items:center;display:inline-grid;grid-gap:.25rem;grid-template:auto auto/auto auto}.cds--list-box__wrapper--inline .cds--label,:host(cds-dropdown[type=inline]) .cds--label{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--list-box__wrapper--inline .cds--form-requirement,.cds--list-box__wrapper--inline .cds--form__helper-text,.cds--list-box__wrapper--inline .cds--label,:host(cds-dropdown[type=inline]) .cds--form-requirement,:host(cds-dropdown[type=inline]) .cds--form__helper-text,:host(cds-dropdown[type=inline]) .cds--label{margin:0}.cds--list-box__wrapper--inline .cds--form__helper-text,:host(cds-dropdown[type=inline]) .cds--form__helper-text{max-inline-size:none}.cds--list-box__wrapper--inline .cds--form-requirement,:host(cds-dropdown[type=inline]) .cds--form-requirement{grid-column:2}.cds--list-box{background-color:var(--cds-field);block-size:2.5rem;border:none;border-block-end:1px solid var(--cds-border-strong);color:var(--cds-text-primary,#161616);cursor:pointer;inline-size:100%;max-block-size:2.5rem;position:relative;transition:all 70ms cubic-bezier(.2,0,.38,.9)}.cds--list-box html{font-size:100%}.cds--list-box body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--list-box code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--list-box strong{font-weight:600}.cds--list-box:hover{background-color:var(--cds-field-hover)}.cds--multi-select.cds--multi-select--readonly.cds--list-box{cursor:default}.cds--list-box--lg{block-size:3rem;max-block-size:3rem}.cds--list-box--sm{block-size:2rem;max-block-size:2rem}.cds--list-box--expanded{border-block-end-color:var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--list-box--expanded{border-block-end-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box--expanded{border-block-end-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--list-box--expanded:hover{background-color:var(--cds-field)}.cds--list-box--expanded:hover.cds--list-box--light:hover{background-color:var(--cds-field-02,#fff)}.cds--list-box .cds--text-input{block-size:100%;min-inline-size:0}.cds--list-box__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:2.5rem;transform:translateY(-50%)}.cds--list-box__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--list-box__invalid-icon--warning path[fill]{fill:#000;opacity:1}.cds--list-box.cds--list-box--warning .cds--list-box__field,.cds--list-box[data-invalid] .cds--list-box__field{border-block-end:0;padding-inline-end:4rem}.cds--list-box.cds--list-box--warning.cds--list-box--inline .cds--list-box__field,.cds--list-box[data-invalid].cds--list-box--inline .cds--list-box__field{padding-inline-end:3.5rem}.cds--list-box--light{background-color:var(--cds-field-02,#fff)}.cds--list-box--light:hover{background-color:var(--cds-field-hover)}.cds--list-box--light .cds--list-box__menu{background:var(--cds-layer)}.cds--list-box--light .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle)}.cds--list-box--light.cds--list-box--expanded{border-block-end-color:transparent}.cds--list-box--disabled:hover{background-color:var(--cds-field)}.cds--list-box--light.cds--list-box--disabled{background-color:var(--cds-field-02,#fff)}.cds--list-box--disabled,.cds--list-box--disabled .cds--list-box__field,.cds--list-box--disabled .cds--list-box__field:focus{border-block-end-color:transparent;outline:none}.cds--list-box--disabled .cds--list-box__label,.cds--list-box--disabled.cds--list-box--inline .cds--list-box__label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled .cds--list-box__menu-icon>svg,.cds--list-box--disabled .cds--list-box__selection>svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled,.cds--list-box--disabled .cds--list-box__field,.cds--list-box--disabled .cds--list-box__menu-icon{cursor:not-allowed}.cds--list-box--disabled .cds--list-box__menu-item,.cds--list-box--disabled .cds--list-box__menu-item--highlighted,.cds--list-box--disabled .cds--list-box__menu-item:hover,.cds--list-box--disabled :host(cds-dropdown-item){color:var(--cds-text-disabled,hsla(0,0%,9%,.25));text-decoration:none}.cds--list-box--disabled .cds--list-box__selection:hover{cursor:not-allowed}.cds--list-box--disabled.cds--list-box[data-invalid] .cds--list-box__field{padding-inline-end:3rem}.cds--list-box--disabled.cds--list-box[data-invalid].cds--list-box--inline .cds--list-box__field{padding-inline-end:2rem}.cds--list-box.cds--list-box--inline{background-color:transparent;border-width:0}.cds--list-box.cds--list-box--inline:hover{background-color:var(--cds-layer-hover)}.cds--list-box.cds--list-box--inline.cds--list-box--expanded{border-block-end-width:0}.cds--list-box.cds--list-box--inline.cds--list-box--expanded .cds--list-box__field[aria-expanded=true]{border-width:0}.cds--list-box.cds--list-box--inline.cds--list-box--disabled:hover,.cds--list-box.cds--list-box--inline.cds--list-box--expanded:hover{background-color:transparent}.cds--list-box.cds--list-box--inline .cds--list-box__field{padding:0 2rem 0 .5rem}.cds--list-box.cds--list-box--inline .cds--list-box__menu-icon{inset-inline-end:.5rem}.cds--list-box.cds--list-box--inline .cds--list-box__invalid-icon{inset-inline-end:2rem}.cds--list-box--inline .cds--list-box__label{color:var(--cds-text-primary,#161616)}.cds--list-box--inline .cds--list-box__field{block-size:100%}.cds--dropdown--inline .cds--list-box__field{max-inline-size:30rem}.cds--dropdown--inline .cds--list-box__menu{max-inline-size:30rem;min-inline-size:18rem}.cds--list-box__field{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:calc(100% + 1px);border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;margin:0;outline:none;overflow:hidden;padding:0;padding-block:0;padding-inline:1rem 3rem;position:relative;text-align:start;text-overflow:ellipsis;vertical-align:baseline;vertical-align:top;white-space:nowrap}.cds--list-box__field *,.cds--list-box__field :after,.cds--list-box__field :before{box-sizing:inherit}.cds--list-box__field::-moz-focus-inner{border:0}.cds--list-box__field:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--list-box__field:focus{outline-style:dotted}}.cds--list-box__field[disabled]{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--list-box__field .cds--text-input{padding-inline-end:5rem}.cds--list-box--warning .cds--list-box__field .cds--text-input,.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input{padding-inline-end:6.5625rem}.cds--list-box--warning .cds--list-box__field .cds--text-input+.cds--list-box__invalid-icon,.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input+.cds--list-box__invalid-icon{inset-inline-end:5.125rem}.cds--list-box__field .cds--text-input--empty{padding-inline-end:3rem}.cds--list-box--warning .cds--list-box__field .cds--text-input--empty,.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input--empty{padding-inline-end:4rem}.cds--list-box--warning .cds--list-box__field .cds--text-input--empty+.cds--list-box__invalid-icon,.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input--empty+.cds--list-box__invalid-icon{inset-inline-end:2.5rem}.cds--list-box__label{color:var(--cds-text-primary,#161616);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);overflow:hidden;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;user-select:none;white-space:nowrap}.cds--list-box__menu-icon{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:1.5rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;inline-size:1.5rem;inset-inline-end:.75rem;justify-content:center;margin:0;outline:none;padding:0;position:absolute;text-align:start;transition:transform 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--list-box__menu-icon *,.cds--list-box__menu-icon :after,.cds--list-box__menu-icon :before{box-sizing:inherit}.cds--list-box__menu-icon::-moz-focus-inner{border:0}.cds--list-box__menu-icon>svg{fill:var(--cds-icon-primary,#161616)}.cds--list-box__menu-icon--open{inline-size:1.5rem;justify-content:center;transform:rotate(180deg)}.cds--list-box__selection{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:1.5rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;inline-size:1.5rem;inset-block-start:50%;inset-inline-end:2.8125rem;justify-content:center;margin:0;padding:0;position:absolute;text-align:start;transform:translateY(-50%);transition:background-color 70ms cubic-bezier(.2,0,.38,.9);-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:baseline}.cds--list-box__selection *,.cds--list-box__selection :after,.cds--list-box__selection :before{box-sizing:inherit}.cds--list-box__selection::-moz-focus-inner{border:0}.cds--list-box__selection:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--list-box__selection:focus{outline-style:dotted}}.cds--list-box__selection:focus:hover{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--list-box__selection:focus:hover{outline-style:dotted}}.cds--list-box__selection>svg{fill:var(--cds-icon-primary,#161616)}.cds--list-box--disabled .cds--list-box__selection:focus{outline:none}.cds--list-box__selection--multi{align-items:center;background-color:var(--cds-background-inverse,#393939);block-size:1.5rem;border-radius:.75rem;color:var(--cds-text-inverse,#fff);display:flex;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:auto;inset-block-start:auto;justify-content:space-between;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:0;margin-inline-end:.625rem;padding:.5rem;padding-inline-end:.125rem;position:static;transform:none}.cds--list-box__selection--multi>svg{block-size:1.25rem;padding:.125rem;fill:var(--cds-icon-inverse,#fff);inline-size:1.25rem;margin-inline-start:.25rem}.cds--list-box__selection--multi>svg:hover{background-color:var(--cds-button-secondary-hover,#474747);border-radius:50%}.cds--list-box--disabled .cds--list-box__selection--multi{background-color:var(--cds-text-disabled,hsla(0,0%,9%,.25));color:var(--cds-layer)}.cds--list-box--disabled .cds--list-box__selection--multi.cds--tag--operational{border:1px solid var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled .cds--list-box__selection--multi .cds--tag__close-icon:hover,.cds--list-box--disabled .cds--list-box__selection--multi.cds--tag--operational:hover{background-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled .cds--list-box__selection--multi>svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled .cds--list-box__selection--multi>svg:hover{background-color:initial}.cds--list-box__selection--multi:hover{outline:none}.cds--list-box__menu{background-color:var(--cds-layer);box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));display:none;inline-size:100%;inset-inline:0;overflow-y:auto;position:absolute;transition:max-height .11s cubic-bezier(.2,0,.38,.9);z-index:9100}.cds--list-box__menu:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--list-box__menu:focus{outline-style:dotted}}.cds--list-box .cds--list-box__field[aria-expanded=false] .cds--list-box__menu{display:none;max-block-size:0;visibility:hidden}.cds--list-box--expanded .cds--list-box__menu{display:block;max-block-size:13.75rem}.cds--list-box--expanded.cds--list-box--lg .cds--list-box__menu{max-block-size:16.5rem}.cds--list-box--expanded.cds--list-box--sm .cds--list-box__menu{max-block-size:11rem}.cds--list-box__menu-item,:host(cds-dropdown-item){block-size:2.5rem;color:var(--cds-text-secondary,#525252);cursor:pointer;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);position:relative;transition:background 70ms cubic-bezier(.2,0,.38,.9);-webkit-user-select:none;-moz-user-select:none;user-select:none}.cds--list-box__menu-item:hover{background-color:var(--cds-layer-hover)}.cds--list-box__menu-item:active{background-color:var(--cds-layer-selected)}.cds--list-box--light .cds--list-box__menu-item:hover{background-color:var(--cds-layer-hover)}.cds--list-box--sm .cds--list-box__menu-item,.cds--list-box--sm :host(cds-dropdown-item){block-size:2rem}.cds--list-box--lg .cds--list-box__menu-item,.cds--list-box--lg :host(cds-dropdown-item){block-size:3rem}.cds--list-box--disabled .cds--list-box__menu-item:hover{background-color:transparent}.cds--list-box--light .cds--list-box__menu-item:active{background-color:var(--cds-layer-selected)}.cds--list-box--disabled .cds--list-box__menu-item__option:hover{border-block-start-color:var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--list-box--disabled .cds--list-box__menu-item__option:hover{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box--disabled .cds--list-box__menu-item__option:hover{border-block-start-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--list-box__menu-item:first-of-type .cds--list-box__menu-item__option{border-block-start-color:transparent}.cds--list-box__menu-item:hover .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}.cds--list-box--disabled .cds--list-box__menu-item:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--list-box--disabled .cds--list-box__menu-item:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--list-box--disabled .cds--list-box__menu-item:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--layer-two .cds--list-box--disabled .cds--list-box__menu-item:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box--disabled .cds--list-box__menu-item:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--layer-three .cds--list-box--disabled .cds--list-box__menu-item:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--layer-two .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--list-box__menu-item__option{block-size:2.5rem;border:0;border-block-end:1px solid transparent;border-block-start:1px solid transparent;border-block-start-color:var(--cds-border-subtle-01,#c6c6c6);box-sizing:border-box;color:var(--cds-text-secondary,#525252);display:block;font-family:inherit;font-size:100%;font-weight:400;line-height:1rem;margin:0 1rem;outline:2px solid transparent;outline-offset:-2px;overflow:hidden;padding:.6875rem 0;padding-inline-end:1.5rem;text-decoration:none;text-overflow:ellipsis;transition:border-color 70ms cubic-bezier(.2,0,.38,.9),color 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline;white-space:nowrap}.cds--list-box__menu-item__option *,.cds--list-box__menu-item__option :after,.cds--list-box__menu-item__option :before{box-sizing:inherit}.cds--list-box__menu-item__option:focus{border-color:transparent;margin:0;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;padding:.6875rem 1rem}@media screen and (prefers-contrast){.cds--list-box__menu-item__option:focus{outline-style:dotted}}.cds--list-box__menu-item__option:hover{border-color:transparent;color:var(--cds-text-primary,#161616)}.cds--list-box--sm .cds--list-box__menu-item__option{block-size:2rem;padding-block:.4375rem .4375rem}.cds--list-box--lg .cds--list-box__menu-item__option{block-size:3rem;padding-block:.9375rem .9375rem}.cds--list-box--disabled .cds--list-box__menu-item:hover .cds--list-box__menu-item__option,.cds--list-box--disabled .cds--list-box__menu-item__option{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box__menu-item[disabled],.cds--list-box__menu-item[disabled] *,.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--list-box__menu-item[disabled]:hover{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;outline:none}.cds--list-box__menu-item[disabled]:hover{background-color:revert}.cds--list-box__menu-item[disabled] .cds--checkbox-label:before{border-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--list-box__menu-item[disabled]:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--list-box__menu-item[disabled]:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--layer-two .cds--list-box__menu-item[disabled]:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--layer-two .cds--list-box__menu-item[disabled]:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--layer-three .cds--list-box__menu-item[disabled]:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--layer-three .cds--list-box__menu-item[disabled]:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--list-box__menu-item--active+.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--list-box__menu-item:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--list-box__menu-item:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected])+.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option{border-block-start-color:transparent}.cds--list-box.cds--list-box--inline .cds--list-box__menu-item__option{margin:0 .5rem}.cds--list-box.cds--list-box--inline .cds--list-box__menu-item__option:focus{margin:0;padding-inline:.5rem .5rem}.cds--list-box__menu-item--highlighted,:host(cds-dropdown-item[highlighted]),:host(cds-dropdown-item[selected]){color:var(--cds-text-primary,#161616);outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--list-box__menu-item--highlighted,:host(cds-dropdown-item[highlighted]),:host(cds-dropdown-item[selected]){outline-style:dotted}}.cds--list-box__menu-item--highlighted .cds--list-box__menu-item__option,.cds--list-box__menu-item--highlighted+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--list-box__menu-item--highlighted+:host(cds-dropdown-item) .cds--list-box__menu-item__option,:host(cds-dropdown-item[highlighted]) .cds--list-box__menu-item__option,:host(cds-dropdown-item[highlighted])+.cds--list-box__menu-item .cds--list-box__menu-item__option,:host(cds-dropdown-item[highlighted])+:host(cds-dropdown-item) .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected])+.cds--list-box__menu-item .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected])+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:transparent}.cds--list-box__menu-item--highlighted .cds--list-box__menu-item__option,:host(cds-dropdown-item[highlighted]) .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}.cds--list-box__menu-item--active,:host(cds-dropdown-item[selected]){background-color:var(--cds-layer-selected);border-block-end-color:var(--cds-layer-selected);color:var(--cds-text-primary,#161616)}.cds--list-box--light .cds--list-box__menu-item--active,.cds--list-box--light :host(cds-dropdown-item[selected]){background-color:var(--cds-layer-selected);border-block-end-color:var(--cds-layer-selected)}.cds--list-box__menu-item--active:hover{background-color:var(--cds-layer-selected-hover);border-block-end-color:var(--cds-layer-selected-hover)}.cds--list-box__menu-item--active .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}.cds--list-box__menu-item--active+.cds--list-box__menu-item>.cds--list-box__menu-item__option,.cds--list-box__menu-item--active+:host(cds-dropdown-item)>.cds--list-box__menu-item__option,:host(cds-dropdown-item[selected])+.cds--list-box__menu-item>.cds--list-box__menu-item__option,:host(cds-dropdown-item[selected])+:host(cds-dropdown-item)>.cds--list-box__menu-item__option{border-block-start-color:transparent}.cds--list-box__menu-item__selected-icon{display:none;position:absolute;fill:var(--cds-icon-primary,#161616);inset-block-start:50%;inset-inline-end:1rem;transform:translateY(-50%)}.cds--list-box--inline .cds--list-box__menu-item__selected-icon{inset-inline-end:.5rem}.cds--list-box__menu-item--active .cds--list-box__menu-item__selected-icon,:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__selected-icon{display:block}.cds--list-box__menu-item .cds--checkbox-label,:host(cds-dropdown-item) .cds--checkbox-label{inline-size:100%}.cds--list-box__menu-item .cds--checkbox-label-text,:host(cds-dropdown-item) .cds--checkbox-label-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cds--list-box--up .cds--list-box__menu,:host(cds-combo-box[direction=top]) .cds--list-box__menu,:host(cds-dropdown[direction=top]) .cds--list-box__menu{inset-block-end:2.5rem}.cds--list-box--up .cds--list-box--sm .cds--list-box__menu,.cds--list-box--up.cds--dropdown--sm .cds--list-box__menu,.cds--list-box--up.cds--list-box--sm .cds--list-box__menu,:host(cds-combo-box[direction=top]) .cds--list-box--sm .cds--list-box__menu,:host(cds-dropdown[direction=top]) .cds--list-box--sm .cds--list-box__menu{inset-block-end:2rem}.cds--list-box--up .cds--list-box--lg .cds--list-box__menu,.cds--list-box--up.cds--dropdown--lg .cds--list-box__menu,.cds--list-box--up.cds--list-box--lg .cds--list-box__menu,:host(cds-combo-box[direction=top]) .cds--list-box--lg .cds--list-box__menu,:host(cds-dropdown[direction=top]) .cds--list-box--lg .cds--list-box__menu{inset-block-end:3rem}.cds--list-box input[role=combobox],.cds--list-box input[type=text]{background-color:inherit;min-inline-size:0;text-overflow:ellipsis}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>*,.cds--list-box__wrapper--slug .cds--ai-label,.cds--list-box__wrapper--slug .cds--slug,:host(cds-dropdown[ai-label]) .cds--ai-label,:host(cds-dropdown[ai-label]) .cds--slug{inset-block-start:50%;inset-inline-end:calc(2.5rem + 9px);margin-block-start:.03125rem;position:absolute;transform:translateY(-50%)}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>:after,.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>:before,.cds--list-box__wrapper--slug .cds--ai-label:after,.cds--list-box__wrapper--slug .cds--ai-label:before,.cds--list-box__wrapper--slug .cds--slug:after,.cds--list-box__wrapper--slug .cds--slug:before,:host(cds-dropdown[ai-label]) .cds--ai-label:after,:host(cds-dropdown[ai-label]) .cds--ai-label:before,:host(cds-dropdown[ai-label]) .cds--slug:after,:host(cds-dropdown[ai-label]) .cds--slug:before{background-color:var(--cds-border-subtle-01,#c6c6c6);block-size:1rem;content:"";inline-size:.0625rem;position:absolute}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>:before,.cds--list-box__wrapper--slug .cds--ai-label:before,.cds--list-box__wrapper--slug .cds--slug:before,:host(cds-dropdown[ai-label]) .cds--ai-label:before,:host(cds-dropdown[ai-label]) .cds--slug:before{display:none;inset-inline-start:-.5625rem}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>:after,.cds--list-box__wrapper--slug .cds--ai-label:after,.cds--list-box__wrapper--slug .cds--slug:after,:host(cds-dropdown[ai-label]) .cds--ai-label:after,:host(cds-dropdown[ai-label]) .cds--slug:after{display:block;inset-block-start:0;inset-inline-end:-.5625rem}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator .cds--ai-label--revert:after,.cds--list-box__wrapper--slug .cds--ai-label--revert:after,.cds--list-box__wrapper--slug .cds--slug--revert:after,:host(cds-dropdown[ai-label]) .cds--ai-label--revert:after,:host(cds-dropdown[ai-label]) .cds--slug--revert:after{inset-block-start:.5rem;inset-inline-end:-.0625rem}.cds--list-box__wrapper--decorator .cds--list-box:has(.cds--list-box__inner-wrapper--decorator .cds--ai-label):not(:has(.cds--list-box__inner-wrapper--decorator .cds--ai-label--revert)),.cds--list-box__wrapper--slug .cds--list-box:has(.cds--ai-label):not(:has(.cds--ai-label--revert)),.cds--list-box__wrapper--slug .cds--list-box:has(.cds--slug):not(:has(.cds--slug--revert)),:host(cds-dropdown[ai-label]) .cds--list-box:has(.cds--ai-label):not(:has(.cds--ai-label--revert)),:host(cds-dropdown[ai-label]) .cds--list-box:has(.cds--slug):not(:has(.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff)}.cds--list-box__wrapper--decorator .cds--list-box input[role=combobox],.cds--list-box__wrapper--slug .cds--list-box input[role=combobox],:host(cds-dropdown[ai-label]) .cds--list-box input[role=combobox]{border-block-end-color:transparent}.cds--list-box__wrapper--decorator .cds--list-box__field,.cds--list-box__wrapper--decorator .cds--text-input--empty,.cds--list-box__wrapper--slug .cds--list-box__field,.cds--list-box__wrapper--slug .cds--text-input--empty,:host(cds-dropdown[ai-label]) .cds--list-box__field,:host(cds-dropdown[ai-label]) .cds--text-input--empty{padding-inline-end:4rem}.cds--list-box__wrapper--decorator .cds--text-input:not(.cds--text-input--empty),.cds--list-box__wrapper--slug .cds--text-input:not(.cds--text-input--empty),:host(cds-dropdown[ai-label]) .cds--text-input:not(.cds--text-input--empty){padding-inline-end:6rem}.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--list-box__field,.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--text-input--empty,.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__field,.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--text-input--empty,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--list-box__field,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--text-input--empty,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--text-input--empty,:host(cds-dropdown[ai-label]) .cds--list-box--invalid[data-invalid] .cds--list-box__field,:host(cds-dropdown[ai-label]) .cds--list-box--invalid[data-invalid] .cds--text-input--empty,:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--list-box__field,:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--text-input--empty{padding-inline-end:6rem}.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--text-input:not(.cds--text-input--empty),.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--text-input:not(.cds--text-input--empty),.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--text-input:not(.cds--text-input--empty),.cds--list-box__wrapper--slug .cds--list-box--warning .cds--text-input:not(.cds--text-input--empty),:host(cds-dropdown[ai-label]) .cds--list-box--invalid[data-invalid] .cds--text-input:not(.cds--text-input--empty),:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--text-input:not(.cds--text-input--empty){padding-inline-end:8.8125rem}.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--list-box__invalid-icon,.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--text-input--empty+.cds--list-box__invalid-icon,.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__invalid-icon.cds--list-box__invalid-icon--warning,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--list-box__invalid-icon,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--text-input--empty+.cds--list-box__invalid-icon,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__invalid-icon.cds--list-box__invalid-icon--warning,:host(cds-dropdown[ai-label]) .cds--list-box--invalid[data-invalid] .cds--list-box__invalid-icon,:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--list-box__invalid-icon.cds--list-box__invalid-icon--warning{inset-inline-end:5.1875rem}.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid]>:before,.cds--list-box__wrapper--decorator .cds--list-box--warning>:before,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--ai-label:before,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--slug:before,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--ai-label:before,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--slug:before,:host(cds-dropdown[ai-label]) .cds--list-box--invalid[data-invalid] .cds--ai-label:before,:host(cds-dropdown[ai-label]) .cds--list-box--invalid[data-invalid] .cds--slug:before,:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--ai-label:before,:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--slug:before{display:block}.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,.cds--list-box__wrapper--decorator .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection)~.cds--slug,.cds--list-box__wrapper--slug .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,.cds--list-box__wrapper--slug .cds--list-box__field:has(.cds--list-box__selection)~.cds--slug,:host(cds-dropdown[ai-label]) .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,:host(cds-dropdown[ai-label]) .cds--list-box__field:has(.cds--list-box__selection)~.cds--slug{inset-inline-end:calc(4rem + 18px)}.cds--list-box__wrapper--decorator .cds--list-box--invalid .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,.cds--list-box__wrapper--slug .cds--list-box--invalid .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,:host(cds-dropdown[ai-label]) .cds--list-box--invalid .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon{inset-inline-end:7.25rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--list-box__field,.cds--list-box__menu,.cds--multi-select .cds--tag--filter{outline:1px solid transparent}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--list-box__field:focus,.cds--list-box__menu-item--highlighted .cds--list-box__menu-item__option,.cds--multi-select .cds--tag__close-icon:focus,:host(cds-dropdown-item[highlighted]) .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__option{color:Highlight;outline:1px solid Highlight}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--list-box__menu-icon>svg,.cds--list-box__selection--multi>svg,.cds--list-box__selection>svg{fill:ButtonText}}.cds--list-box__field:has(.cds--list-box__menu-icon) .cds--list-box__selection:after{background-color:var(--cds-border-subtle-01,#c6c6c6);block-size:1rem;content:"";inline-size:.0625rem;margin-inline-start:2.0625rem;position:absolute}.cds--list-box--invalid[data-invalid] .cds--list-box__field:has(.cds--list-box__menu-icon) .cds--list-box__selection:before,.cds--list-box--warning .cds--list-box__field:has(.cds--list-box__menu-icon) .cds--list-box__selection:before{background-color:var(--cds-border-subtle-01,#c6c6c6);block-size:1rem;content:"";inline-size:.0625rem;margin-inline-end:2.0625rem;position:absolute}.cds--list-box__wrapper--decorator:has(.cds--multi-select) .cds--list-box__menu-icon,.cds--list-box__wrapper--slug:has(.cds--multi-select) .cds--list-box__menu-icon,:has(.cds--multi-select):host(cds-dropdown[ai-label]) .cds--list-box__menu-icon{inset-inline-end:.75rem}.cds--list-box__wrapper--decorator:has(.cds--dropdown) .cds--list-box__menu-icon,.cds--list-box__wrapper--slug:has(.cds--dropdown) .cds--list-box__menu-icon,:has(.cds--dropdown):host(cds-dropdown[ai-label]) .cds--list-box__menu-icon{inset-inline-end:.75rem}:host(cds-dropdown){outline:none}:host(cds-dropdown) .cds--assistive-text{inset-block-start:-100%;inset-inline-start:-100%}:host(cds-dropdown) .cds--label[hidden]{display:none}:host(cds-dropdown) .cds--list-box__menu{inset-block-start:100%;margin-block-start:1px;outline:1px solid var(--cds-focus,#0f62fe)}:host(cds-dropdown[open]) .cds--list-box__field{outline:none}:host(cds-dropdown[invalid]) .cds--list-box__field{outline:none}:host(cds-dropdown[invalid]) .cds--form__helper-text{color:var(--cds-text-error,#da1e28)}:host(cds-dropdown[read-only]) .cds--list-box{background-color:transparent;border-block-end-color:var(--cds-border-subtle)}:host(cds-combo-box[direction=top]) .cds--list-box__menu,:host(cds-dropdown[direction=top]) .cds--list-box__menu{inset-block-start:auto}:host(cds-dropdown[type=inline]){grid-gap:0 1.5rem}:host(cds-dropdown[type=inline][warn]) .cds--list-box__field{padding-inline:1rem 3.5rem}:host(cds-dropdown[invalid]) .cds--form__helper-text,:host(cds-dropdown[warn]) .cds--form__helper-text{grid-column:2}:host(cds-dropdown-item){display:block}:host(cds-dropdown-item) .cds--list-box__menu-item__option{block-size:auto}:host(cds-dropdown-item:first-child) .cds--list-box__menu-item__option{border-block-start-width:0}:host(cds-dropdown-item:hover){background-color:var(--cds-layer-hover)}:host(cds-dropdown-item[disabled]) .cds--list-box__menu-item__option{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));text-decoration:none}:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__selected-icon{display:block}:host(cds-dropdown-item[size=sm]){block-size:2rem}:host(cds-dropdown-item[size=sm]) .cds--list-box__menu-item__option{padding-block:.4375rem}:host(cds-dropdown-item[size=lg]){block-size:3rem}:host(cds-dropdown-item[size=lg]) .cds--list-box__menu-item__option{padding-block:.9375rem}:host(cds-dropdown-skeleton) .cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;padding:0;pointer-events:none;position:relative}:host(cds-dropdown-skeleton) .cds--skeleton:active,:host(cds-dropdown-skeleton) .cds--skeleton:focus,:host(cds-dropdown-skeleton) .cds--skeleton:hover{border:none;cursor:default;outline:none}:host(cds-dropdown-skeleton) .cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){:host(cds-dropdown-skeleton) .cds--skeleton:before{animation:none}}:host(cds-dropdown[ai-label]) ::slotted(cds-ai-label),:host(cds-dropdown[ai-label]) ::slotted(cds-slug){inset-block-start:50%;inset-inline-end:2.5rem;position:absolute}:host(cds-dropdown[ai-label]) ::slotted(cds-ai-label:not([revert-active])),:host(cds-dropdown[ai-label]) ::slotted(cds-slug:not([revert-active])){transform:translateY(-50%)}:host(cds-dropdown[ai-label][invalid]) .cds--list-box .cds--list-box__field,:host(cds-dropdown[ai-label][warn]) .cds--list-box .cds--list-box__field{padding-inline-end:6rem}:host(cds-dropdown[ai-label][invalid]) ::slotted(cds-ai-label),:host(cds-dropdown[ai-label][invalid]) ::slotted(cds-slug),:host(cds-dropdown[ai-label][warn]) ::slotted(cds-ai-label),:host(cds-dropdown[ai-label][warn]) ::slotted(cds-slug){inset-inline-end:4rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5v1qv":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));background-color:var(--cds-field);block-size:var(--cds-layout-size-height-local);border:none;border-block-end:1px solid var(--cds-border-strong);box-sizing:border-box;color:var(--cds-text-primary,#161616);font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:2px solid transparent;outline-offset:-2px;padding:0;padding:0 var(--cds-layout-density-padding-inline-local);transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--text-input *,.cds--text-input :after,.cds--text-input :before{box-sizing:inherit}.cds--text-input:active,.cds--text-input:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input:active,.cds--text-input:focus{outline-style:dotted}}.cds--text-input-wrapper svg[hidden]{display:none}.cds--password-input{padding-inline-end:2.5rem}.cds--text-input--sm.cds--password-input{padding-inline-end:2rem}.cds--text-input--lg.cds--password-input{padding-inline-end:3rem}.cds--text-input::-moz-placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input::placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input--light{background-color:var(--cds-field-02,#fff)}.cds--text-input__field-wrapper{display:flex;inline-size:100%;position:relative}.cds--text-input__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:1rem;transform:translateY(-50%)}.cds--text-input__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--text-input__invalid-icon--warning path:first-of-type{fill:#000;opacity:1}.cds--text-input--password__visibility{align-items:center;cursor:pointer;display:inline-flex;overflow:visible;position:relative}.cds--text-input--password__visibility:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus{outline-style:dotted}}.cds--text-input--password__visibility:focus{outline:1px solid transparent}.cds--text-input--password__visibility:focus svg{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus svg{outline-style:dotted}}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{align-items:center;display:flex;opacity:0;pointer-events:none;position:absolute;z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{display:inline-block}}.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:opacity 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:none}}.cds--text-input--password__visibility.cds--tooltip--a11y:after,.cds--text-input--password__visibility.cds--tooltip--a11y:before{transition:none}.cds--text-input--password__visibility:before{block-size:0;border-style:solid;content:"";inline-size:0}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text{box-sizing:content-box;color:inherit;opacity:1;white-space:normal;word-break:break-word}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);max-inline-size:13rem;min-inline-size:1.5rem;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-accelerator:true){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{border:1px solid transparent}}.cds--text-input--password__visibility:after{content:attr(aria-label)}.cds--text-input--password__visibility.cds--tooltip--a11y:after{content:none}.cds--text-input--password__visibility.cds--tooltip--visible:after,.cds--text-input--password__visibility.cds--tooltip--visible:before,.cds--text-input--password__visibility:focus:after,.cds--text-input--password__visibility:focus:before,.cds--text-input--password__visibility:hover:after,.cds--text-input--password__visibility:hover:before{opacity:1}@keyframes cds--tooltip-fade{0%{opacity:0}to{opacity:1}}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text{margin:auto;overflow:visible;clip:auto}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible.cds--tooltip--a11y:before,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:focus.cds--tooltip--a11y:before,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text,.cds--text-input--password__visibility:hover.cds--tooltip--a11y:before{animation:cds--tooltip-fade 70ms cubic-bezier(.2,0,.38,.9)}.cds--text-input--password__visibility.cds--tooltip--hidden .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--hidden+.cds--assistive-text{margin:-1px;overflow:hidden;clip:rect(0,0,0,0)}.cds--text-input--password__visibility.cds--tooltip--hidden.cds--tooltip--a11y:before{animation:none;opacity:0}.cds--text-input--password__visibility .cds--assistive-text:after{block-size:.75rem;content:"";display:block;inline-size:100%;inset-block-start:-.75rem;inset-inline-start:0;position:absolute}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{inset-block-end:0;inset-inline-start:50%}.cds--text-input--password__visibility:before{border-color:transparent transparent var(--cds-background-inverse,#393939);border-width:0 .25rem .3125rem;inset-block-end:-.5rem;transform:translate(-50%,100%)}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inset-block-end:-.8125rem;transform:translate(-50%,100%)}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{align-items:center;background:none;block-size:100%;border:0;cursor:pointer;display:flex;inline-size:2.5rem;inset-inline-end:0;justify-content:center;min-block-size:auto;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--toggle-password-tooltip .cds--popover{inset-inline-start:-2.5rem}.cds--toggle-password-tooltip .cds--popover-content{min-inline-size:2.5rem}.cds--text-input--sm+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:2rem}.cds--text-input--lg+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:3rem}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252);transition:fill 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:ButtonText}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline-style:dotted}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus svg,.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-primary,#161616)}.cds--text-input--invalid,.cds--text-input--warning{padding-inline-end:2.5rem}.cds--text-input--invalid.cds--password-input{padding-inline-end:4rem}.cds--text-input--invalid+.cds--text-input--password__visibility__toggle{inset-inline-end:1rem}.cds--password-input-wrapper .cds--text-input__invalid-icon{inset-inline-end:2.5rem}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{cursor:not-allowed}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg:hover{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input__counter-alert{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px}.cds--text-input:disabled{background-color:var(--cds-field);border-block-end:1px solid transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;outline:2px solid transparent;outline-offset:-2px;-webkit-text-fill-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input--light:disabled{background-color:var(--cds-field-02,#fff)}.cds--text-input:disabled::-moz-placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input:disabled::placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input--invalid{box-shadow:none;outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input--invalid{outline-style:dotted}}.cds--text-input--invalid .cds--text-input--password__visibility__toggle{inset-inline-end:2.5rem}.cds--skeleton.cds--text-input{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;padding:0;pointer-events:none;position:relative}.cds--skeleton.cds--text-input:active,.cds--skeleton.cds--text-input:focus,.cds--skeleton.cds--text-input:hover{border:none;cursor:default;outline:none}.cds--skeleton.cds--text-input:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--skeleton.cds--text-input:before{animation:none}}.cds--form--fluid .cds--text-input-wrapper{background:var(--cds-field);position:relative;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--form--fluid .cds--label{align-items:center;block-size:1rem;display:flex;inset-block-start:.8125rem;inset-inline-start:1rem;margin:0;position:absolute;z-index:1}.cds--form--fluid .cds--form__helper-text{display:none}.cds--form--fluid .cds--text-input{min-block-size:4rem;padding:2rem 1rem .8125rem}.cds--form--fluid .cds--text-input__divider,.cds--text-input__divider{display:none}.cds--form--fluid .cds--text-input--invalid,.cds--form--fluid .cds--text-input--warning{border-block-end:none}.cds--form--fluid .cds--text-input--invalid+.cds--text-input__divider,.cds--form--fluid .cds--text-input--warning+.cds--text-input__divider{border-color:var(--cds-border-subtle);border-style:solid;border-block-end:none;display:block;margin:0 1rem}.cds--form--fluid .cds--text-input__invalid-icon{inset-block-start:5rem}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid{outline:none}.cds--form--fluid .cds--text-input__field-wrapper--warning{border-block-end:1px solid var(--cds-border-strong)}.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning:focus,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:focus{outline:none}.cds--text-input-wrapper.cds--text-input-wrapper--inline{flex-flow:row wrap}.cds--text-input-wrapper .cds--label--inline{flex:1;margin:.8125rem 0 0;overflow-wrap:break-word;word-break:break-word}.cds--text-input-wrapper .cds--label--inline--sm{margin-block-start:.5625rem}.cds--text-input-wrapper .cds--label--inline--lg{margin-block-start:1.0625rem}.cds--text-input__label-helper-wrapper{flex:2;flex-direction:column;margin-inline-end:1.5rem;max-inline-size:8rem;overflow-wrap:break-word}.cds--text-input-wrapper .cds--form__helper-text--inline{margin-block-start:.125rem}.cds--text-input__field-outer-wrapper{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;inline-size:100%}.cds--text-input__field-outer-wrapper--inline{flex:8;flex-direction:column}.cds--text-input-wrapper--inline .cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--text-input-wrapper--inline--invalid .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input-wrapper--readonly,.cds--text-input-wrapper--readonly .cds--text-input{background:transparent;border-block-end-color:var(--cds-border-subtle)}.cds--text-input__field-wrapper .cds--ai-label,.cds--text-input__field-wrapper .cds--slug,.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator>*{inset-block-start:50%;inset-inline-end:1rem;position:absolute;transform:translateY(-50%)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label):not(:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug):not(:has(~.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug){padding-inline-end:2.5rem}.cds--text-input--invalid:has(~.cds--ai-label),.cds--text-input--invalid:has(~.cds--slug),.cds--text-input--invalid:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input--warning:has(~.cds--ai-label),.cds--text-input--warning:has(~.cds--slug),.cds--text-input--warning:has(~.cds--text-input__field-inner-wrapper--decorator>*){padding-inline-end:4rem}.cds--text-input--invalid~.cds--ai-label,.cds--text-input--invalid~.cds--slug,.cds--text-input--invalid~.cds--text-input__field-inner-wrapper--decorator>*,.cds--text-input--warning~.cds--ai-label,.cds--text-input--warning~.cds--slug,.cds--text-input--warning~.cds--text-input__field-inner-wrapper--decorator>*{inset-inline-end:2.5rem}.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator:not(:has(.cds--ai-label))>*{block-size:1rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:ButtonText}}.cds--text-input__label-wrapper{display:flex;inline-size:100%;justify-content:space-between}.cds--text-input__label-wrapper .cds--text-input__label-counter{align-self:end}.cds--tag{--cds-layout-size-height-xs:1.125rem;--cds-layout-size-height-sm:1.125rem;--cds-layout-size-height-md:1.5rem;--cds-layout-size-height-lg:2rem;--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));align-items:center;background-color:var(--cds-tag-background-gray,#e0e0e0);border-radius:1rem;color:var(--cds-tag-color-gray,#161616);cursor:default;display:inline-flex;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem;max-inline-size:13rem;min-block-size:var(--cds-layout-size-height-local);min-inline-size:2rem;padding-inline:.5rem;vertical-align:middle;word-break:break-word}.cds--layout--size-xs .cds--tag{--cds-layout-size-height:var(--cds-layout-size-height-xs)}.cds--layout--size-sm .cds--tag{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--tag{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--tag{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--tag.cds--tag--operational{border:1px solid var(--cds-tag-background-gray,#e0e0e0)}.cds--tag .cds--tag__close-icon:hover,.cds--tag.cds--tag--operational:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1)}.cds--tag.cds--tag--lg{padding-inline-start:.75rem}.cds--tag:has(.cds--tag__custom-icon){padding-inline-start:.25rem}.cds--tag.cds--tag--lg:not(.cds--tag--filter){padding-inline:.75rem}.cds--tag.cds--tag--lg:has(.cds--tag__custom-icon){padding-inline-start:.5rem}.cds--tag:not(.cds--tag--selectable){border:0}.cds--tag:not(:first-child){margin-inline-start:0}.cds--tag--operational>span,.cds--tag--selectable>span,.cds--tag__label{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cds--tag--interactive:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--tag--filter{padding-block:0;padding-inline-end:0}.cds--tag--filter:hover{outline:none}.cds--tag--selectable{background-color:var(--cds-layer);border:1px solid var(--cds-border-inverse,#161616);color:var(--cds-text-primary,#161616);cursor:pointer}.cds--tag--selectable:hover{background-color:var(--cds-layer-hover);outline:none}.cds--tag--selectable:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--tag--selectable-selected{color:var(--cds-text-inverse,#fff)}.cds--tag--selectable-selected,.cds--tag--selectable-selected:hover{background-color:var(--cds-layer-selected-inverse,#161616)}.cds--tag--operational{background-color:var(--cds-tag-background-gray,#e0e0e0);border:1px solid var(--cds-tag-border-gray,#a8a8a8);color:var(--cds-tag-color-gray,#161616);cursor:pointer}.cds--tag--operational:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1);outline:none}.cds--tag--operational:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--tag--red{background-color:var(--cds-tag-background-red,#ffd7d9);color:var(--cds-tag-color-red,#a2191f)}.cds--tag--red.cds--tag--operational{border:1px solid var(--cds-tag-border-red,#ff8389)}.cds--tag--red .cds--tag__close-icon:hover,.cds--tag--red.cds--tag--operational:hover{background-color:var(--cds-tag-hover-red,#ffc2c5)}.cds--tag--magenta{background-color:var(--cds-tag-background-magenta,#ffd6e8);color:var(--cds-tag-color-magenta,#9f1853)}.cds--tag--magenta.cds--tag--operational{border:1px solid var(--cds-tag-border-magenta,#ff7eb6)}.cds--tag--magenta .cds--tag__close-icon:hover,.cds--tag--magenta.cds--tag--operational:hover{background-color:var(--cds-tag-hover-magenta,#ffbdda)}.cds--tag--purple{background-color:var(--cds-tag-background-purple,#e8daff);color:var(--cds-tag-color-purple,#6929c4)}.cds--tag--purple.cds--tag--operational{border:1px solid var(--cds-tag-border-purple,#be95ff)}.cds--tag--purple .cds--tag__close-icon:hover,.cds--tag--purple.cds--tag--operational:hover{background-color:var(--cds-tag-hover-purple,#dcc7ff)}.cds--tag--blue{background-color:var(--cds-tag-background-blue,#d0e2ff);color:var(--cds-tag-color-blue,#0043ce)}.cds--tag--blue.cds--tag--operational{border:1px solid var(--cds-tag-border-blue,#78a9ff)}.cds--tag--blue .cds--tag__close-icon:hover,.cds--tag--blue.cds--tag--operational:hover{background-color:var(--cds-tag-hover-blue,#b8d3ff)}.cds--tag--cyan{background-color:var(--cds-tag-background-cyan,#bae6ff);color:var(--cds-tag-color-cyan,#00539a)}.cds--tag--cyan.cds--tag--operational{border:1px solid var(--cds-tag-border-cyan,#33b1ff)}.cds--tag--cyan .cds--tag__close-icon:hover,.cds--tag--cyan.cds--tag--operational:hover{background-color:var(--cds-tag-hover-cyan,#99daff)}.cds--tag--teal{background-color:var(--cds-tag-background-teal,#9ef0f0);color:var(--cds-tag-color-teal,#005d5d)}.cds--tag--teal.cds--tag--operational{border:1px solid var(--cds-tag-border-teal,#08bdba)}.cds--tag--teal .cds--tag__close-icon:hover,.cds--tag--teal.cds--tag--operational:hover{background-color:var(--cds-tag-hover-teal,#57e5e5)}.cds--tag--green{background-color:var(--cds-tag-background-green,#a7f0ba);color:var(--cds-tag-color-green,#0e6027)}.cds--tag--green.cds--tag--operational{border:1px solid var(--cds-tag-border-green,#42be65)}.cds--tag--green .cds--tag__close-icon:hover,.cds--tag--green.cds--tag--operational:hover{background-color:var(--cds-tag-hover-green,#74e792)}.cds--tag--gray{background-color:var(--cds-tag-background-gray,#e0e0e0);color:var(--cds-tag-color-gray,#161616)}.cds--tag--gray.cds--tag--operational{border:1px solid var(--cds-tag-border-gray,#a8a8a8)}.cds--tag--gray .cds--tag__close-icon:hover,.cds--tag--gray.cds--tag--operational:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1)}.cds--tag--cool-gray{background-color:var(--cds-tag-background-cool-gray,#dde1e6);color:var(--cds-tag-color-cool-gray,#121619)}.cds--tag--cool-gray.cds--tag--operational{border:1px solid var(--cds-tag-border-cool-gray,#a2a9b0)}.cds--tag--cool-gray .cds--tag__close-icon:hover,.cds--tag--cool-gray.cds--tag--operational:hover{background-color:var(--cds-tag-hover-cool-gray,#cdd3da)}.cds--tag--warm-gray{background-color:var(--cds-tag-background-warm-gray,#e5e0df);color:var(--cds-tag-color-warm-gray,#171414)}.cds--tag--warm-gray.cds--tag--operational{border:1px solid var(--cds-tag-border-warm-gray,#ada8a8)}.cds--tag--warm-gray .cds--tag__close-icon:hover,.cds--tag--warm-gray.cds--tag--operational:hover{background-color:var(--cds-tag-hover-warm-gray,#d8d0cf)}.cds--tag--high-contrast:not(.cds--tag--operational){background-color:var(--cds-background-inverse,#393939);color:var(--cds-text-inverse,#fff)}.cds--tag--high-contrast:not(.cds--tag--operational).cds--tag--operational{border:1px solid var(--cds-background-inverse,#393939)}.cds--tag--high-contrast:not(.cds--tag--operational) .cds--tag__close-icon:hover,.cds--tag--high-contrast:not(.cds--tag--operational).cds--tag--operational:hover{background-color:var(--cds-background-inverse-hover,#474747)}.cds--multi-select--readonly .cds--tag--high-contrast:not(.cds--tag--operational) .cds--tag__close-icon:hover{background-color:transparent}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]){background-color:var(--cds-background,#fff);color:var(--cds-text-primary,#161616);outline:1px solid var(--cds-background-inverse,#393939);outline-offset:-1px}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]).cds--tag--operational{border:1px solid var(--cds-background,#fff)}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]) .cds--tag__close-icon:hover,.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]).cds--tag--operational:hover{background-color:var(--cds-layer-hover)}.cds--tag--disabled:not(.cds--tag--operational),.cds--tag--filter.cds--tag--disabled,.cds--tag--interactive.cds--tag--disabled{background-color:var(--cds-layer);box-shadow:none;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--tag--disabled:not(.cds--tag--operational).cds--tag--operational,.cds--tag--filter.cds--tag--disabled.cds--tag--operational,.cds--tag--interactive.cds--tag--disabled.cds--tag--operational{border:1px solid var(--cds-layer)}.cds--tag--disabled:not(.cds--tag--operational) .cds--tag__close-icon:hover,.cds--tag--disabled:not(.cds--tag--operational).cds--tag--operational:hover,.cds--tag--filter.cds--tag--disabled .cds--tag__close-icon:hover,.cds--tag--filter.cds--tag--disabled.cds--tag--operational:hover,.cds--tag--interactive.cds--tag--disabled .cds--tag__close-icon:hover,.cds--tag--interactive.cds--tag--disabled.cds--tag--operational:hover{background-color:var(--cds-layer)}.cds--tag--disabled:not(.cds--tag--operational):hover,.cds--tag--filter.cds--tag--disabled:hover,.cds--tag--interactive.cds--tag--disabled:hover{cursor:not-allowed}.cds--tag--disabled:not(.cds--tag--operational) .cds--tag__label,.cds--tag--filter.cds--tag--disabled .cds--tag__label,.cds--tag--interactive.cds--tag--disabled .cds--tag__label{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--tag--operational.cds--tag--disabled,.cds--tag--selectable.cds--tag--disabled{background-color:var(--cds-layer);border:1px solid var(--cds-border-disabled,#c6c6c6);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--tag--operational.cds--tag--disabled:hover,.cds--tag--selectable.cds--tag--disabled:hover{background-color:var(--cds-layer);cursor:not-allowed}.cds--tag--interactive{transition:background-color 70ms cubic-bezier(0,0,.38,.9)}.cds--tag__close-icon{align-items:center;background-color:transparent;block-size:var(--cds-layout-size-height-local);border:0;border-radius:50%;color:currentColor;cursor:pointer;display:flex;flex-shrink:0;inline-size:var(--cds-layout-size-height-local);justify-content:center;margin:0 0 0 .125rem;padding:0;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),box-shadow 70ms cubic-bezier(.2,0,.38,.9)}.cds--tag__close-icon svg{fill:currentColor}.cds--tag__custom-icon{background-color:transparent;block-size:1rem;border:0;color:currentColor;flex-shrink:0;inline-size:1rem;margin-inline-end:.25rem;outline:none;padding:0}.cds--tag__custom-icon svg{fill:currentColor}.cds--tag--disabled .cds--tag__close-icon{cursor:not-allowed}.cds--tag__close-icon:focus{border-radius:50%;box-shadow:inset 0 0 0 1px var(--cds-focus,#0f62fe);outline:none;z-index:99999}.cds--tag--high-contrast .cds--tag__close-icon:focus{box-shadow:inset 0 0 0 1px var(--cds-focus-inverse,#fff)}.cds--tag--filter.cds--tag--disabled .cds--tag__close-icon:hover{background-color:transparent}.cds--tag--filter.cds--tag--disabled svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--tag--sm.cds--tag--filter{padding-inline-end:0}.cds--tag--sm .cds--tag__close-icon{margin-inline-start:.3125rem}.cds--tag.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);background-color:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;color:var(--cds-text-primary,#161616);inline-size:3.75rem;overflow:hidden;padding:0;pointer-events:none;position:relative}.cds--tag.cds--skeleton:active,.cds--tag.cds--skeleton:focus,.cds--tag.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--tag.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--tag.cds--skeleton:before{animation:none}}.cds--tag.cds--skeleton.cds--tag--operational{border:1px solid var(--cds-skeleton-background,#e8e8e8)}.cds--tag.cds--skeleton .cds--tag__close-icon:hover,.cds--tag.cds--skeleton.cds--tag--operational:hover{background-color:var(--cds-skeleton-background,#e8e8e8)}@media not all and (min-resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){.cds--tag.cds--skeleton{transform:translateZ(0)}}}.cds--tag .cds--ai-label .cds--ai-label__button--inline,.cds--tag .cds--slug .cds--slug__button--inline{color:currentColor;margin-inline-start:.0625rem}.cds--tag .cds--ai-label .cds--ai-label__button--inline .cds--ai-label__text:before,.cds--tag .cds--slug .cds--slug__button--inline .cds--slug__text:before{background-color:currentColor}.cds--tag .cds--ai-label .cds--ai-label__button--inline:hover,.cds--tag .cds--slug .cds--slug__button--inline:hover{border-color:currentColor}.cds--tag--filter .cds--ai-label,.cds--tag--filter .cds--slug,.cds--tag--filter .cds--tag__decorator>*{min-inline-size:2.00875rem}.cds--tag .cds--tag__decorator:not(:has(.cds--ai-label)){block-size:1rem;text-align:center}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--tag{outline:1px solid transparent}.cds--tag__close-icon svg,.cds--tag__custom-icon svg{fill:ButtonText}.cds--tag__close-icon:focus{color:Highlight;outline:1px solid Highlight}}.cds--tag-label-tooltip{max-inline-size:-webkit-fill-available}.cds--tag__custom-icon+.cds--tag-label-tooltip{max-inline-size:11rem}.cds--tag--filter .cds--tag__custom-icon+.cds--tag-label-tooltip{max-inline-size:9.875rem}.cds--interactive--tag-children{display:inline-flex;max-inline-size:12.5rem;place-items:center}.cds--tag--filter .cds--tag__custom-icon+span>.cds--interactive--tag-children{max-inline-size:11.5rem}.cds--tag .cds--definition-term{border-block-end:none;cursor:default;max-inline-size:12rem}.cds--tag .cds--tag__custom-icon+span>.cds--definition-term{max-inline-size:11rem}.cds--tag>.cds--popover-container{display:flex}.cds--toggletip-button:has(.cds--tag--operational.cds--tag--disabled){pointer-events:none}.cds--combo-box:hover{background-color:var(--cds-field)}.cds--combo-box.cds--list-box--light:hover{background-color:var(--cds-field-02,#fff)}.cds--combo-box .cds--text-input::-ms-clear{display:none}.cds--combo-box.cds--list-box--expanded .cds--text-input{border-block-end-color:var(--cds-border-subtle)}.cds--combo-box--input--focus.cds--text-input{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box--input--focus.cds--text-input{outline-style:dotted}}.cds--combo-box.cds--list-box--expanded:has(input[aria-activedescendant]:not([aria-activedescendant=""])) .cds--combo-box--input--focus.cds--text-input{outline-offset:-.0625rem;outline-width:.0625rem}.cds--combo-box .cds--list-box__field,.cds--combo-box.cds--list-box--disabled.cds--list-box--warning .cds--list-box__field,.cds--combo-box.cds--list-box--disabled.cds--list-box[data-invalid] .cds--list-box__field,.cds--combo-box.cds--list-box--warning .cds--list-box__field,.cds--combo-box.cds--list-box[data-invalid] .cds--list-box__field{padding:0}.cds--combo-box--readonly,.cds--combo-box--readonly:hover{background-color:transparent}.cds--combo-box--readonly .cds--text-input{border-block-end-color:var(--cds-border-subtle)}.cds--combo-box--readonly .cds--list-box__menu-icon,.cds--combo-box--readonly .cds--list-box__selection{cursor:default}.cds--combo-box--readonly .cds--list-box__menu-icon svg,.cds--combo-box--readonly .cds--list-box__selection svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--dropdown__wrapper--inline{align-items:center;display:inline-grid;grid-gap:0 1.5rem;grid-template:auto/auto min-content}.cds--dropdown__wrapper--inline:has(.cds--label.cds--visually-hidden){grid-template:auto/auto}.cds--dropdown__wrapper--inline .cds--label{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--dropdown__wrapper--inline .cds--form-requirement,.cds--dropdown__wrapper--inline .cds--form__helper-text,.cds--dropdown__wrapper--inline .cds--label{margin:0}.cds--dropdown__wrapper--inline .cds--form-requirement{grid-column:2}.cds--dropdown{background-color:var(--cds-field);block-size:2.5rem;border:none;border-block-end:1px solid var(--cds-border-strong);color:var(--cds-text-primary,#161616);cursor:pointer;display:block;inline-size:100%;list-style:none;outline:2px solid transparent;outline-offset:-2px;position:relative;transition:background-color 70ms cubic-bezier(.2,0,.38,.9)}.cds--dropdown html{font-size:100%}.cds--dropdown body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--dropdown code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--dropdown strong{font-weight:600}.cds--dropdown:hover{background-color:var(--cds-field-hover)}.cds--dropdown .cds--list-box__field{text-align:start}.cds--dropdown--lg{block-size:3rem;max-block-size:3rem}.cds--dropdown--lg .cds--dropdown__arrow{inset-block-start:1rem}.cds--dropdown--sm{block-size:2rem;max-block-size:2rem}.cds--dropdown--sm .cds--dropdown__arrow{inset-block-start:.5rem}.cds--dropdown--open{border-block-end-color:var(--cds-border-subtle)}.cds--dropdown--open .cds--list-box__field{outline:none}.cds--dropdown--invalid{outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--dropdown--invalid{outline-style:dotted}}.cds--dropdown--invalid .cds--dropdown-text{padding-inline-end:3.5rem}.cds--dropdown--invalid+.cds--form-requirement{color:var(--cds-text-error,#da1e28);display:inline-block;max-block-size:12.5rem}.cds--dropdown__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:2.5rem;transform:translateY(-50%)}.cds--dropdown--open:hover{background-color:var(--cds-field)}.cds--dropdown--open:focus{outline:1px solid transparent}.cds--dropdown--open .cds--dropdown-list{box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));max-block-size:13.75rem;transition:max-height .11s cubic-bezier(0,0,.38,.9)}.cds--dropdown--light{background-color:var(--cds-field-02,#fff)}.cds--dropdown--light:hover{background-color:var(--cds-field-hover)}.cds--dropdown--up .cds--dropdown-list{inset-block-end:2rem}.cds--dropdown__arrow{position:absolute;fill:var(--cds-icon-primary,#161616);inset-block-start:.8125rem;inset-inline-end:1rem;pointer-events:none;transform-origin:50% 45%;transition:transform .11s cubic-bezier(.2,0,.38,.9)}button.cds--dropdown-text{background:none;border:none;color:var(--cds-text-primary,#161616);inline-size:100%;text-align:start}button.cds--dropdown-text:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){button.cds--dropdown-text:focus{outline-style:dotted}}.cds--dropdown-text{block-size:calc(100% + 1px);display:block;overflow:hidden;padding-inline:1rem 2.625rem;text-overflow:ellipsis;white-space:nowrap}.cds--dropdown-list,.cds--dropdown-text{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--dropdown-list{background-color:var(--cds-layer);box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));display:flex;flex-direction:column;inline-size:100%;list-style:none;max-block-size:0;outline:2px solid transparent;outline-offset:-2px;overflow:hidden auto;position:absolute;transition:max-height .11s cubic-bezier(.2,0,.38,.9);z-index:9100}.cds--dropdown-list html{font-size:100%}.cds--dropdown-list body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--dropdown-list code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--dropdown-list strong{font-weight:600}.cds--dropdown--light .cds--dropdown-list{background-color:var(--cds-layer)}.cds--dropdown:not(.cds--dropdown--open) .cds--dropdown-item{visibility:hidden}.cds--dropdown-item{opacity:0;position:relative;transition:visibility 70ms cubic-bezier(.2,0,.38,.9),opacity 70ms cubic-bezier(.2,0,.38,.9),background-color 70ms cubic-bezier(.2,0,.38,.9);visibility:inherit}.cds--dropdown-item:hover{background-color:var(--cds-layer-hover)}.cds--dropdown-item:hover+.cds--dropdown-item .cds--dropdown-link{border-color:transparent}.cds--dropdown-item:active{background-color:var(--cds-layer-selected)}.cds--dropdown-item:first-of-type .cds--dropdown-link{border-block-start-color:transparent}.cds--dropdown-item:last-of-type .cds--dropdown-link{border-block-end:none}.cds--dropdown-link{block-size:2.5rem;border:1px solid transparent;border-block-start-color:var(--cds-border-subtle);color:var(--cds-text-secondary,#525252);display:block;font-weight:400;line-height:1rem;margin:0 1rem;outline:2px solid transparent;outline-offset:-2px;overflow:hidden;padding:.6875rem 0;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.cds--dropdown-link:hover{border-color:transparent;color:var(--cds-text-primary,#161616)}.cds--dropdown--light .cds--dropdown-link{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--dropdown--sm .cds--dropdown-link{block-size:2rem;padding-block:.4375rem .4375rem}.cds--dropdown--focused,.cds--dropdown-link:focus{margin:0;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;padding:.6875rem 1rem}@media screen and (prefers-contrast){.cds--dropdown--focused,.cds--dropdown-link:focus{outline-style:dotted}}.cds--dropdown-list[aria-activedescendant] .cds--dropdown-link:focus{margin:0 1rem;outline:none;padding:.6875rem 0}.cds--dropdown-list[aria-activedescendant] .cds--dropdown--focused:focus{margin:0;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;padding:.6875rem 1rem}@media screen and (prefers-contrast){.cds--dropdown-list[aria-activedescendant] .cds--dropdown--focused:focus{outline-style:dotted}}.cds--dropdown-list[aria-activedescendant] .cds--dropdown-item:active{background-color:inherit}.cds--dropdown-item:hover .cds--dropdown-link{border-block-end-color:var(--cds-layer-hover)}.cds--dropdown--open .cds--dropdown__arrow{transform:rotate(-180deg)}.cds--dropdown--open.cds--dropdown--sm .cds--dropdown-list{max-block-size:11rem}.cds--dropdown--open .cds--dropdown-item{opacity:1}.cds--dropdown--disabled{border-block-end-color:transparent}.cds--dropdown--disabled:hover{background-color:var(--cds-field)}.cds--dropdown--disabled:focus{outline:none}.cds--dropdown--disabled .cds--dropdown-text,.cds--dropdown--disabled .cds--list-box__label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--dropdown--disabled .cds--dropdown__arrow,.cds--dropdown--disabled .cds--list-box__menu-icon svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--dropdown--disabled.cds--dropdown--light:hover{background-color:var(--cds-field-02,#fff)}.cds--dropdown--disabled .cds--list-box__field,.cds--dropdown--disabled .cds--list-box__menu-icon{cursor:not-allowed}.cds--dropdown--auto-width{inline-size:auto;max-inline-size:25rem}.cds--dropdown--inline{background-color:transparent;border-block-end-color:transparent;display:inline-block;inline-size:auto;justify-self:start;transition:background 70ms cubic-bezier(0,0,.38,.9)}.cds--dropdown--inline:hover{background-color:var(--cds-layer-hover)}.cds--dropdown--inline.cds--dropdown--disabled{background-color:transparent}.cds--dropdown--inline .cds--dropdown__arrow{inset-block-start:.5rem;inset-inline-end:.5rem}.cds--dropdown--inline.cds--dropdown--open{background-color:transparent}.cds--dropdown--inline .cds--dropdown-text{block-size:2rem;color:var(--cds-text-primary,#161616);display:inline-block;overflow:visible;padding:.4375rem 2rem .4375rem .75rem}.cds--dropdown--inline.cds--dropdown--disabled .cds--dropdown-text{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--dropdown--inline.cds--dropdown--disabled:focus .cds--dropdown-text{outline:0}.cds--dropdown--inline.cds--dropdown--invalid .cds--dropdown__invalid-icon{inset-inline-end:2rem}.cds--dropdown--inline.cds--dropdown--invalid .cds--dropdown-text{padding-inline-end:3.5rem}.cds--dropdown--inline.cds--dropdown--open:focus .cds--dropdown-list{box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3))}.cds--dropdown--inline .cds--dropdown-link{font-weight:400}.cds--dropdown--show-selected .cds--dropdown--selected{background-color:var(--cds-layer-selected);color:var(--cds-text-primary,#161616);display:block}.cds--dropdown--show-selected .cds--dropdown--selected:hover{background-color:var(--cds-layer-selected-hover)}.cds--dropdown--show-selected .cds--dropdown--selected .cds--dropdown-link,.cds--dropdown--show-selected .cds--dropdown--selected+.cds--dropdown-item .cds--dropdown-link{border-block-start-color:transparent}.cds--dropdown--show-selected .cds--dropdown--selected .cds--list-box__menu-item__selected-icon{display:block}.cds--dropdown-v2.cds--skeleton,.cds--dropdown.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;padding:0;pointer-events:none;position:relative}.cds--dropdown-v2.cds--skeleton:active,.cds--dropdown-v2.cds--skeleton:focus,.cds--dropdown-v2.cds--skeleton:hover,.cds--dropdown.cds--skeleton:active,.cds--dropdown.cds--skeleton:focus,.cds--dropdown.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--dropdown-v2.cds--skeleton:before,.cds--dropdown.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--dropdown-v2.cds--skeleton:before,.cds--dropdown.cds--skeleton:before{animation:none}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--dropdown .cds--list-box__field{outline:1px solid transparent}.cds--list-box__menu-item__option{outline:none}.cds--list-box__menu-item__selected-icon{fill:ButtonText}}.cds--dropdown--readonly,.cds--dropdown--readonly:hover,:host(cds-dropdown[read-only]){background-color:transparent;border-block-end-color:var(--cds-border-subtle)}.cds--dropdown--inline.cds--dropdown--readonly{border-block-end-color:transparent}.cds--dropdown--readonly .cds--list-box__field,.cds--dropdown--readonly .cds--list-box__menu-icon,:host(cds-dropdown[read-only]) .cds--list-box__field,:host(cds-dropdown[read-only]) .cds--list-box__menu-icon{cursor:default}.cds--dropdown--readonly .cds--list-box__menu-icon svg,:host(cds-dropdown[read-only]) .cds--list-box__menu-icon svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--checkbox-group *,.cds--checkbox-group :after,.cds--checkbox-group :before{box-sizing:inherit}.cds--form-item.cds--checkbox-wrapper{margin-block-end:.375rem;position:relative}.cds--form-item.cds--checkbox-wrapper:first-of-type{margin-block-start:0}.cds--label+.cds--form-item.cds--checkbox-wrapper{margin-block-start:-.125rem}.cds--form-item.cds--checkbox-wrapper:last-of-type{margin-block-end:.1875rem}.cds--checkbox{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;inset-block-start:1.25rem;inset-inline-start:.7rem;visibility:inherit;white-space:nowrap}.cds--checkbox-label{cursor:pointer;display:flex;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);min-block-size:1.25rem;padding-block-start:.0625rem;padding-inline-start:1.25rem;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none}.cds--checkbox-label html{font-size:100%}.cds--checkbox-label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--checkbox-label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--checkbox-label strong{font-weight:600}.cds--checkbox-label-text{padding-inline-start:.625rem}.cds--checkbox-label:after,.cds--checkbox-label:before{box-sizing:border-box}@media print{.cds--checkbox-label:after,.cds--checkbox-label:before{-webkit-print-color-adjust:exact;print-color-adjust:exact}}.cds--checkbox-label:before{background-color:transparent;block-size:1rem;border:1px solid var(--cds-icon-primary,#161616);border-radius:2px;content:"";inline-size:1rem;inset-block-start:.125rem;inset-inline-start:0;margin-block:.0625rem .125rem;margin-inline:.1875rem 0;position:absolute}.cds--checkbox-label:after{background:none;block-size:.3125rem;border-block-end:1.5px solid var(--cds-icon-inverse,#fff);border-inline-start:1.5px solid var(--cds-icon-inverse,#fff);content:"";inline-size:.5625rem;inset-block-start:.40625rem;inset-inline-start:.4375rem;margin-block-start:-.1875rem;position:absolute;transform:scale(0) rotate(-45deg);transform-origin:bottom right}.cds--checkbox-label[data-contained-checkbox-state=true]:before,.cds--checkbox:checked+.cds--checkbox-label:before,.cds--checkbox:indeterminate+.cds--checkbox-label:before{background-color:var(--cds-icon-primary,#161616);border:1px}.cds--checkbox-label[data-contained-checkbox-state=true]:after,.cds--checkbox:checked+.cds--checkbox-label:after{transform:scale(1) rotate(-45deg)}.cds--checkbox:indeterminate+.cds--checkbox-label:after{border-block-end:2px solid var(--cds-icon-inverse,#fff);border-inline-start:0 solid var(--cds-icon-inverse,#fff);inline-size:.5rem;inset-block-start:.6875rem;transform:scale(1) rotate(0deg)}.cds--checkbox-label[data-contained-checkbox-state=true].cds--checkbox-label__focus:before,.cds--checkbox-label__focus:before,.cds--checkbox:checked:focus+.cds--checkbox-label:before,.cds--checkbox:focus+.cds--checkbox-label:before,.cds--checkbox:indeterminate:focus+.cds--checkbox-label:before{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--checkbox-label[data-contained-checkbox-disabled=true],.cds--checkbox:disabled+.cds--checkbox-label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--checkbox-label[data-contained-checkbox-disabled=true]:before,.cds--checkbox:disabled+.cds--checkbox-label:before{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-label[data-contained-checkbox-state=true][data-contained-checkbox-disabled=true]:before,.cds--checkbox:checked:disabled+.cds--checkbox-label:before,.cds--checkbox:indeterminate:disabled+.cds--checkbox-label:before{background-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group[data-invalid] .cds--checkbox-label:before,.cds--checkbox-wrapper--invalid .cds--checkbox-label:before,.cds--checkbox-wrapper--invalid .cds--checkbox:checked+.cds--checkbox-label:before{border:1px solid var(--cds-support-error,#da1e28)}.cds--checkbox-group .cds--checkbox-wrapper--invalid>.cds--checkbox__validation-msg,.cds--checkbox-group .cds--checkbox-wrapper--warning>.cds--checkbox__validation-msg,.cds--checkbox-group .cds--checkbox-wrapper>.cds--form__helper-text{display:none}.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox-label:before,.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox:checked+.cds--checkbox-label:before{border:1px solid var(--cds-icon-primary,#161616)}.cds--checkbox-group__validation-msg,.cds--checkbox__validation-msg{align-items:flex-start;display:none;inline-size:100%;margin-block-start:.25rem}.cds--checkbox__invalid-icon{margin:.0625rem .0625rem 0 .1875rem;fill:var(--cds-support-error,#da1e28);min-inline-size:1rem}.cds--checkbox__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--checkbox__invalid-icon--warning path:first-of-type{fill:#000}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg,.cds--checkbox-group--warning .cds--checkbox-group__validation-msg,.cds--checkbox-wrapper--invalid>.cds--checkbox__validation-msg,.cds--checkbox-wrapper--warning>.cds--checkbox__validation-msg{display:flex}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-group--warning .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--warning .cds--checkbox__validation-msg .cds--form-requirement{display:block;margin-block-start:0;margin-inline-start:.5rem;max-block-size:100%;overflow:visible}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--checkbox-group--readonly .cds--checkbox-label,.cds--checkbox-wrapper--readonly .cds--checkbox-label{cursor:default}.cds--checkbox-group--readonly .cds--checkbox-label-text,.cds--checkbox-wrapper--readonly .cds--checkbox-label-text{cursor:text;-webkit-user-select:text;-moz-user-select:text;user-select:text}.cds--checkbox-group--readonly .cds--checkbox+.cds--checkbox-label:before,.cds--checkbox-wrapper--readonly .cds--checkbox+.cds--checkbox-label:before{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group--readonly .cds--checkbox:checked+.cds--checkbox-label:before,.cds--checkbox-wrapper--readonly .cds--checkbox:checked+.cds--checkbox-label:before{background:transparent;border:1px solid var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group--readonly .cds--checkbox:checked+.cds--checkbox-label:after,.cds--checkbox-wrapper--readonly .cds--checkbox:checked+.cds--checkbox-label:after{border-color:var(--cds-text-primary,#161616)}.cds--checkbox-skeleton .cds--checkbox-label{cursor:default}.cds--checkbox-label-text.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;inline-size:6.25rem;margin-block:.0625rem 0;margin-inline:.375rem 0;padding:0;pointer-events:none;position:relative}.cds--checkbox-label-text.cds--skeleton:active,.cds--checkbox-label-text.cds--skeleton:focus,.cds--checkbox-label-text.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--checkbox-label-text.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--checkbox-label-text.cds--skeleton:before{animation:none}}.cds--checkbox--inline{position:relative}[dir=rtl] .cds--checkbox-label:after{margin-block-start:0;margin-inline-start:-.0625rem;transform-origin:center}[dir=rtl] .cds--checkbox-label[data-contained-checkbox-state=true]:after,[dir=rtl] .cds--checkbox:checked+.cds--checkbox-label:after{transform:scale(1.2) rotate3d(.5,1,0,158deg)}.cds--checkbox-group--decorator legend.cds--label,.cds--checkbox-group--slug legend.cds--label,.cds--checkbox-wrapper--decorator .cds--checkbox-label-text,.cds--checkbox-wrapper--slug .cds--checkbox-label-text{display:flex}.cds--checkbox-group--decorator legend.cds--label .cds--checkbox-group-inner--decorator>*,.cds--checkbox-group--slug legend.cds--label .cds--ai-label,.cds--checkbox-group--slug legend.cds--label .cds--slug,.cds--checkbox-wrapper--decorator .cds--checkbox-label-text .cds--checkbox-wrapper-inner--decorator>*,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--ai-label,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug{margin-inline-start:.5rem}.cds--checkbox-wrapper--decorator .cds--checkbox-label-text .cds--ai-label__button--inline,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--ai-label__button--inline,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug__button--inline{line-height:inherit;margin-block-start:-.0625rem}.cds--checkbox-group--horizontal{display:flex;flex-flow:row wrap;justify-content:flex-start;position:relative}.cds--checkbox-group--horizontal .cds--form-item{flex:none;margin-block-end:0}.cds--checkbox-group--horizontal .cds--form-item:not(:last-of-type){margin-inline-end:1rem}.cds--checkbox-group--horizontal .cds--checkbox-label-text{padding-inline-start:.5rem}.cds--checkbox-group--horizontal .cds--label+.cds--form-item.cds--checkbox-wrapper{margin-block-start:0}.cds--list-box__wrapper{display:block}.cds--list-box__wrapper--inline,:host(cds-dropdown[type=inline]){align-items:center;display:inline-grid;grid-gap:.25rem;grid-template:auto auto/auto auto}.cds--list-box__wrapper--inline .cds--label,:host(cds-dropdown[type=inline]) .cds--label{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--list-box__wrapper--inline .cds--form-requirement,.cds--list-box__wrapper--inline .cds--form__helper-text,.cds--list-box__wrapper--inline .cds--label,:host(cds-dropdown[type=inline]) .cds--form-requirement,:host(cds-dropdown[type=inline]) .cds--form__helper-text,:host(cds-dropdown[type=inline]) .cds--label{margin:0}.cds--list-box__wrapper--inline .cds--form__helper-text,:host(cds-dropdown[type=inline]) .cds--form__helper-text{max-inline-size:none}.cds--list-box__wrapper--inline .cds--form-requirement,:host(cds-dropdown[type=inline]) .cds--form-requirement{grid-column:2}.cds--list-box{background-color:var(--cds-field);block-size:2.5rem;border:none;border-block-end:1px solid var(--cds-border-strong);color:var(--cds-text-primary,#161616);cursor:pointer;inline-size:100%;max-block-size:2.5rem;position:relative;transition:all 70ms cubic-bezier(.2,0,.38,.9)}.cds--list-box html{font-size:100%}.cds--list-box body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--list-box code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--list-box strong{font-weight:600}.cds--list-box:hover{background-color:var(--cds-field-hover)}.cds--multi-select.cds--multi-select--readonly.cds--list-box{cursor:default}.cds--list-box--lg{block-size:3rem;max-block-size:3rem}.cds--list-box--sm{block-size:2rem;max-block-size:2rem}.cds--list-box--expanded{border-block-end-color:var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--list-box--expanded{border-block-end-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box--expanded{border-block-end-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--list-box--expanded:hover{background-color:var(--cds-field)}.cds--list-box--expanded:hover.cds--list-box--light:hover{background-color:var(--cds-field-02,#fff)}.cds--list-box .cds--text-input{block-size:100%;min-inline-size:0}.cds--list-box__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:2.5rem;transform:translateY(-50%)}.cds--list-box__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--list-box__invalid-icon--warning path[fill]{fill:#000;opacity:1}.cds--list-box.cds--list-box--warning .cds--list-box__field,.cds--list-box[data-invalid] .cds--list-box__field{border-block-end:0;padding-inline-end:4rem}.cds--list-box.cds--list-box--warning.cds--list-box--inline .cds--list-box__field,.cds--list-box[data-invalid].cds--list-box--inline .cds--list-box__field{padding-inline-end:3.5rem}.cds--list-box--light{background-color:var(--cds-field-02,#fff)}.cds--list-box--light:hover{background-color:var(--cds-field-hover)}.cds--list-box--light .cds--list-box__menu{background:var(--cds-layer)}.cds--list-box--light .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle)}.cds--list-box--light.cds--list-box--expanded{border-block-end-color:transparent}.cds--list-box--disabled:hover{background-color:var(--cds-field)}.cds--list-box--light.cds--list-box--disabled{background-color:var(--cds-field-02,#fff)}.cds--list-box--disabled,.cds--list-box--disabled .cds--list-box__field,.cds--list-box--disabled .cds--list-box__field:focus{border-block-end-color:transparent;outline:none}.cds--list-box--disabled .cds--list-box__label,.cds--list-box--disabled.cds--list-box--inline .cds--list-box__label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled .cds--list-box__menu-icon>svg,.cds--list-box--disabled .cds--list-box__selection>svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled,.cds--list-box--disabled .cds--list-box__field,.cds--list-box--disabled .cds--list-box__menu-icon{cursor:not-allowed}.cds--list-box--disabled .cds--list-box__menu-item,.cds--list-box--disabled .cds--list-box__menu-item--highlighted,.cds--list-box--disabled .cds--list-box__menu-item:hover,.cds--list-box--disabled :host(cds-combo-box-item),.cds--list-box--disabled :host(cds-dropdown-item){color:var(--cds-text-disabled,hsla(0,0%,9%,.25));text-decoration:none}.cds--list-box--disabled .cds--list-box__selection:hover{cursor:not-allowed}.cds--list-box--disabled.cds--list-box[data-invalid] .cds--list-box__field{padding-inline-end:3rem}.cds--list-box--disabled.cds--list-box[data-invalid].cds--list-box--inline .cds--list-box__field{padding-inline-end:2rem}.cds--list-box.cds--list-box--inline{background-color:transparent;border-width:0}.cds--list-box.cds--list-box--inline:hover{background-color:var(--cds-layer-hover)}.cds--list-box.cds--list-box--inline.cds--list-box--expanded{border-block-end-width:0}.cds--list-box.cds--list-box--inline.cds--list-box--expanded .cds--list-box__field[aria-expanded=true]{border-width:0}.cds--list-box.cds--list-box--inline.cds--list-box--disabled:hover,.cds--list-box.cds--list-box--inline.cds--list-box--expanded:hover{background-color:transparent}.cds--list-box.cds--list-box--inline .cds--list-box__field{padding:0 2rem 0 .5rem}.cds--list-box.cds--list-box--inline .cds--list-box__menu-icon{inset-inline-end:.5rem}.cds--list-box.cds--list-box--inline .cds--list-box__invalid-icon{inset-inline-end:2rem}.cds--list-box--inline .cds--list-box__label{color:var(--cds-text-primary,#161616)}.cds--list-box--inline .cds--list-box__field{block-size:100%}.cds--dropdown--inline .cds--list-box__field{max-inline-size:30rem}.cds--dropdown--inline .cds--list-box__menu{max-inline-size:30rem;min-inline-size:18rem}.cds--list-box__field{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:calc(100% + 1px);border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;margin:0;outline:none;overflow:hidden;padding:0;padding-block:0;padding-inline:1rem 3rem;position:relative;text-align:start;text-overflow:ellipsis;vertical-align:baseline;vertical-align:top;white-space:nowrap}.cds--list-box__field *,.cds--list-box__field :after,.cds--list-box__field :before{box-sizing:inherit}.cds--list-box__field::-moz-focus-inner{border:0}.cds--list-box__field:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--list-box__field:focus{outline-style:dotted}}.cds--list-box__field[disabled]{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--list-box__field .cds--text-input{padding-inline-end:5rem}.cds--list-box--warning .cds--list-box__field .cds--text-input,.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input{padding-inline-end:6.5625rem}.cds--list-box--warning .cds--list-box__field .cds--text-input+.cds--list-box__invalid-icon,.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input+.cds--list-box__invalid-icon{inset-inline-end:5.125rem}.cds--list-box__field .cds--text-input--empty{padding-inline-end:3rem}.cds--list-box--warning .cds--list-box__field .cds--text-input--empty,.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input--empty{padding-inline-end:4rem}.cds--list-box--warning .cds--list-box__field .cds--text-input--empty+.cds--list-box__invalid-icon,.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input--empty+.cds--list-box__invalid-icon{inset-inline-end:2.5rem}.cds--list-box__label{color:var(--cds-text-primary,#161616);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);overflow:hidden;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;user-select:none;white-space:nowrap}.cds--list-box__menu-icon{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:1.5rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;inline-size:1.5rem;inset-inline-end:.75rem;justify-content:center;margin:0;outline:none;padding:0;position:absolute;text-align:start;transition:transform 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--list-box__menu-icon *,.cds--list-box__menu-icon :after,.cds--list-box__menu-icon :before{box-sizing:inherit}.cds--list-box__menu-icon::-moz-focus-inner{border:0}.cds--list-box__menu-icon>svg{fill:var(--cds-icon-primary,#161616)}.cds--list-box__menu-icon--open{inline-size:1.5rem;justify-content:center;transform:rotate(180deg)}.cds--list-box__selection{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:1.5rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;inline-size:1.5rem;inset-block-start:50%;inset-inline-end:2.8125rem;justify-content:center;margin:0;padding:0;position:absolute;text-align:start;transform:translateY(-50%);transition:background-color 70ms cubic-bezier(.2,0,.38,.9);-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:baseline}.cds--list-box__selection *,.cds--list-box__selection :after,.cds--list-box__selection :before{box-sizing:inherit}.cds--list-box__selection::-moz-focus-inner{border:0}.cds--list-box__selection:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--list-box__selection:focus{outline-style:dotted}}.cds--list-box__selection:focus:hover{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--list-box__selection:focus:hover{outline-style:dotted}}.cds--list-box__selection>svg{fill:var(--cds-icon-primary,#161616)}.cds--list-box--disabled .cds--list-box__selection:focus{outline:none}.cds--list-box__selection--multi{align-items:center;background-color:var(--cds-background-inverse,#393939);block-size:1.5rem;border-radius:.75rem;color:var(--cds-text-inverse,#fff);display:flex;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:auto;inset-block-start:auto;justify-content:space-between;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:0;margin-inline-end:.625rem;padding:.5rem;padding-inline-end:.125rem;position:static;transform:none}.cds--list-box__selection--multi>svg{block-size:1.25rem;padding:.125rem;fill:var(--cds-icon-inverse,#fff);inline-size:1.25rem;margin-inline-start:.25rem}.cds--list-box__selection--multi>svg:hover{background-color:var(--cds-button-secondary-hover,#474747);border-radius:50%}.cds--list-box--disabled .cds--list-box__selection--multi{background-color:var(--cds-text-disabled,hsla(0,0%,9%,.25));color:var(--cds-layer)}.cds--list-box--disabled .cds--list-box__selection--multi.cds--tag--operational{border:1px solid var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled .cds--list-box__selection--multi .cds--tag__close-icon:hover,.cds--list-box--disabled .cds--list-box__selection--multi.cds--tag--operational:hover{background-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled .cds--list-box__selection--multi>svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled .cds--list-box__selection--multi>svg:hover{background-color:initial}.cds--list-box__selection--multi:hover{outline:none}.cds--list-box__menu{background-color:var(--cds-layer);box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));display:none;inline-size:100%;inset-inline:0;overflow-y:auto;position:absolute;transition:max-height .11s cubic-bezier(.2,0,.38,.9);z-index:9100}.cds--list-box__menu:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--list-box__menu:focus{outline-style:dotted}}.cds--list-box .cds--list-box__field[aria-expanded=false] .cds--list-box__menu{display:none;max-block-size:0;visibility:hidden}.cds--list-box--expanded .cds--list-box__menu{display:block;max-block-size:13.75rem}.cds--list-box--expanded.cds--list-box--lg .cds--list-box__menu{max-block-size:16.5rem}.cds--list-box--expanded.cds--list-box--sm .cds--list-box__menu{max-block-size:11rem}.cds--list-box__menu-item,:host(cds-combo-box-item),:host(cds-dropdown-item){block-size:2.5rem;color:var(--cds-text-secondary,#525252);cursor:pointer;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);position:relative;transition:background 70ms cubic-bezier(.2,0,.38,.9);-webkit-user-select:none;-moz-user-select:none;user-select:none}.cds--list-box__menu-item:hover{background-color:var(--cds-layer-hover)}.cds--list-box__menu-item:active{background-color:var(--cds-layer-selected)}.cds--list-box--light .cds--list-box__menu-item:hover{background-color:var(--cds-layer-hover)}.cds--list-box--sm .cds--list-box__menu-item,.cds--list-box--sm :host(cds-combo-box-item),.cds--list-box--sm :host(cds-dropdown-item){block-size:2rem}.cds--list-box--lg .cds--list-box__menu-item,.cds--list-box--lg :host(cds-combo-box-item),.cds--list-box--lg :host(cds-dropdown-item){block-size:3rem}.cds--list-box--disabled .cds--list-box__menu-item:hover{background-color:transparent}.cds--list-box--light .cds--list-box__menu-item:active{background-color:var(--cds-layer-selected)}.cds--list-box--disabled .cds--list-box__menu-item__option:hover{border-block-start-color:var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--list-box--disabled .cds--list-box__menu-item__option:hover{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box--disabled .cds--list-box__menu-item__option:hover{border-block-start-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--list-box__menu-item:first-of-type .cds--list-box__menu-item__option{border-block-start-color:transparent}.cds--list-box__menu-item:hover .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}.cds--list-box--disabled .cds--list-box__menu-item:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--list-box--disabled .cds--list-box__menu-item:hover+:host(cds-combo-box-item) .cds--list-box__menu-item__option,.cds--list-box--disabled .cds--list-box__menu-item:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--list-box--disabled .cds--list-box__menu-item:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--layer-two .cds--list-box--disabled .cds--list-box__menu-item:hover+:host(cds-combo-box-item) .cds--list-box__menu-item__option,.cds--layer-two .cds--list-box--disabled .cds--list-box__menu-item:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box--disabled .cds--list-box__menu-item:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--layer-three .cds--list-box--disabled .cds--list-box__menu-item:hover+:host(cds-combo-box-item) .cds--list-box__menu-item__option,.cds--layer-three .cds--list-box--disabled .cds--list-box__menu-item:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--layer-two .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--list-box__menu-item__option{block-size:2.5rem;border:0;border-block-end:1px solid transparent;border-block-start:1px solid transparent;border-block-start-color:var(--cds-border-subtle-01,#c6c6c6);box-sizing:border-box;color:var(--cds-text-secondary,#525252);display:block;font-family:inherit;font-size:100%;font-weight:400;line-height:1rem;margin:0 1rem;outline:2px solid transparent;outline-offset:-2px;overflow:hidden;padding:.6875rem 0;padding-inline-end:1.5rem;text-decoration:none;text-overflow:ellipsis;transition:border-color 70ms cubic-bezier(.2,0,.38,.9),color 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline;white-space:nowrap}.cds--list-box__menu-item__option *,.cds--list-box__menu-item__option :after,.cds--list-box__menu-item__option :before{box-sizing:inherit}.cds--list-box__menu-item__option:focus{border-color:transparent;margin:0;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;padding:.6875rem 1rem}@media screen and (prefers-contrast){.cds--list-box__menu-item__option:focus{outline-style:dotted}}.cds--list-box__menu-item__option:hover{border-color:transparent;color:var(--cds-text-primary,#161616)}.cds--list-box--sm .cds--list-box__menu-item__option{block-size:2rem;padding-block:.4375rem .4375rem}.cds--list-box--lg .cds--list-box__menu-item__option{block-size:3rem;padding-block:.9375rem .9375rem}.cds--list-box--disabled .cds--list-box__menu-item:hover .cds--list-box__menu-item__option,.cds--list-box--disabled .cds--list-box__menu-item__option{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box__menu-item[disabled],.cds--list-box__menu-item[disabled] *,.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--list-box__menu-item[disabled]:hover{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;outline:none}.cds--list-box__menu-item[disabled]:hover{background-color:revert}.cds--list-box__menu-item[disabled] .cds--checkbox-label:before{border-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--list-box__menu-item[disabled]:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--list-box__menu-item[disabled]:hover+:host(cds-combo-box-item) .cds--list-box__menu-item__option,.cds--list-box__menu-item[disabled]:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--layer-two .cds--list-box__menu-item[disabled]:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--layer-two .cds--list-box__menu-item[disabled]:hover+:host(cds-combo-box-item) .cds--list-box__menu-item__option,.cds--layer-two .cds--list-box__menu-item[disabled]:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--layer-three .cds--list-box__menu-item[disabled]:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--layer-three .cds--list-box__menu-item[disabled]:hover+:host(cds-combo-box-item) .cds--list-box__menu-item__option,.cds--layer-three .cds--list-box__menu-item[disabled]:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--list-box__menu-item--active+.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--list-box__menu-item:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--list-box__menu-item:hover+:host(cds-combo-box-item) .cds--list-box__menu-item__option,.cds--list-box__menu-item:hover+:host(cds-dropdown-item) .cds--list-box__menu-item__option,:host(cds-combo-box-item[selected])+.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected])+.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option{border-block-start-color:transparent}.cds--list-box.cds--list-box--inline .cds--list-box__menu-item__option{margin:0 .5rem}.cds--list-box.cds--list-box--inline .cds--list-box__menu-item__option:focus{margin:0;padding-inline:.5rem .5rem}.cds--list-box__menu-item--highlighted,:host(cds-combo-box-item[highlighted]),:host(cds-combo-box-item[selected]),:host(cds-dropdown-item[highlighted]),:host(cds-dropdown-item[selected]){color:var(--cds-text-primary,#161616);outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--list-box__menu-item--highlighted,:host(cds-combo-box-item[highlighted]),:host(cds-combo-box-item[selected]),:host(cds-dropdown-item[highlighted]),:host(cds-dropdown-item[selected]){outline-style:dotted}}.cds--list-box__menu-item--highlighted .cds--list-box__menu-item__option,.cds--list-box__menu-item--highlighted+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--list-box__menu-item--highlighted+:host(cds-combo-box-item) .cds--list-box__menu-item__option,.cds--list-box__menu-item--highlighted+:host(cds-dropdown-item) .cds--list-box__menu-item__option,:host(cds-combo-box-item[highlighted]) .cds--list-box__menu-item__option,:host(cds-combo-box-item[highlighted])+.cds--list-box__menu-item .cds--list-box__menu-item__option,:host(cds-combo-box-item[highlighted])+:host(cds-combo-box-item) .cds--list-box__menu-item__option,:host(cds-combo-box-item[highlighted])+:host(cds-dropdown-item) .cds--list-box__menu-item__option,:host(cds-combo-box-item[selected]) .cds--list-box__menu-item__option,:host(cds-combo-box-item[selected])+.cds--list-box__menu-item .cds--list-box__menu-item__option,:host(cds-combo-box-item[selected])+:host(cds-combo-box-item) .cds--list-box__menu-item__option,:host(cds-combo-box-item[selected])+:host(cds-dropdown-item) .cds--list-box__menu-item__option,:host(cds-dropdown-item[highlighted]) .cds--list-box__menu-item__option,:host(cds-dropdown-item[highlighted])+.cds--list-box__menu-item .cds--list-box__menu-item__option,:host(cds-dropdown-item[highlighted])+:host(cds-combo-box-item) .cds--list-box__menu-item__option,:host(cds-dropdown-item[highlighted])+:host(cds-dropdown-item) .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected])+.cds--list-box__menu-item .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected])+:host(cds-combo-box-item) .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected])+:host(cds-dropdown-item) .cds--list-box__menu-item__option{border-block-start-color:transparent}.cds--list-box__menu-item--highlighted .cds--list-box__menu-item__option,:host(cds-combo-box-item[highlighted]) .cds--list-box__menu-item__option,:host(cds-combo-box-item[selected]) .cds--list-box__menu-item__option,:host(cds-dropdown-item[highlighted]) .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}.cds--list-box__menu-item--active,:host(cds-combo-box-item[selected]),:host(cds-dropdown-item[selected]){background-color:var(--cds-layer-selected);border-block-end-color:var(--cds-layer-selected);color:var(--cds-text-primary,#161616)}.cds--list-box--light .cds--list-box__menu-item--active,.cds--list-box--light :host(cds-combo-box-item[selected]),.cds--list-box--light :host(cds-dropdown-item[selected]){background-color:var(--cds-layer-selected);border-block-end-color:var(--cds-layer-selected)}.cds--list-box__menu-item--active:hover{background-color:var(--cds-layer-selected-hover);border-block-end-color:var(--cds-layer-selected-hover)}.cds--list-box__menu-item--active .cds--list-box__menu-item__option,:host(cds-combo-box-item[selected]) .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}.cds--list-box__menu-item--active+.cds--list-box__menu-item>.cds--list-box__menu-item__option,.cds--list-box__menu-item--active+:host(cds-combo-box-item)>.cds--list-box__menu-item__option,.cds--list-box__menu-item--active+:host(cds-dropdown-item)>.cds--list-box__menu-item__option,:host(cds-combo-box-item[selected])+.cds--list-box__menu-item>.cds--list-box__menu-item__option,:host(cds-combo-box-item[selected])+:host(cds-combo-box-item)>.cds--list-box__menu-item__option,:host(cds-combo-box-item[selected])+:host(cds-dropdown-item)>.cds--list-box__menu-item__option,:host(cds-dropdown-item[selected])+.cds--list-box__menu-item>.cds--list-box__menu-item__option,:host(cds-dropdown-item[selected])+:host(cds-combo-box-item)>.cds--list-box__menu-item__option,:host(cds-dropdown-item[selected])+:host(cds-dropdown-item)>.cds--list-box__menu-item__option{border-block-start-color:transparent}.cds--list-box__menu-item__selected-icon{display:none;position:absolute;fill:var(--cds-icon-primary,#161616);inset-block-start:50%;inset-inline-end:1rem;transform:translateY(-50%)}.cds--list-box--inline .cds--list-box__menu-item__selected-icon{inset-inline-end:.5rem}.cds--list-box__menu-item--active .cds--list-box__menu-item__selected-icon,:host(cds-combo-box-item[selected]) .cds--list-box__menu-item__selected-icon,:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__selected-icon{display:block}.cds--list-box__menu-item .cds--checkbox-label,:host(cds-combo-box-item) .cds--checkbox-label,:host(cds-dropdown-item) .cds--checkbox-label{inline-size:100%}.cds--list-box__menu-item .cds--checkbox-label-text,:host(cds-combo-box-item) .cds--checkbox-label-text,:host(cds-dropdown-item) .cds--checkbox-label-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cds--list-box--up .cds--list-box__menu,:host(cds-combo-box[direction=top]) .cds--list-box__menu,:host(cds-dropdown[direction=top]) .cds--list-box__menu{inset-block-end:2.5rem}.cds--list-box--up .cds--list-box--sm .cds--list-box__menu,.cds--list-box--up.cds--dropdown--sm .cds--list-box__menu,.cds--list-box--up.cds--list-box--sm .cds--list-box__menu,:host(cds-combo-box[direction=top]) .cds--list-box--sm .cds--list-box__menu,:host(cds-dropdown[direction=top]) .cds--list-box--sm .cds--list-box__menu{inset-block-end:2rem}.cds--list-box--up .cds--list-box--lg .cds--list-box__menu,.cds--list-box--up.cds--dropdown--lg .cds--list-box__menu,.cds--list-box--up.cds--list-box--lg .cds--list-box__menu,:host(cds-combo-box[direction=top]) .cds--list-box--lg .cds--list-box__menu,:host(cds-dropdown[direction=top]) .cds--list-box--lg .cds--list-box__menu{inset-block-end:3rem}.cds--list-box input[role=combobox],.cds--list-box input[type=text]{background-color:inherit;min-inline-size:0;text-overflow:ellipsis}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>*,.cds--list-box__wrapper--slug .cds--ai-label,.cds--list-box__wrapper--slug .cds--slug,:host(cds-combo-box[ai-label]) .cds--ai-label,:host(cds-combo-box[ai-label]) .cds--slug,:host(cds-dropdown[ai-label]) .cds--ai-label,:host(cds-dropdown[ai-label]) .cds--slug{inset-block-start:50%;inset-inline-end:calc(2.5rem + 9px);margin-block-start:.03125rem;position:absolute;transform:translateY(-50%)}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>:after,.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>:before,.cds--list-box__wrapper--slug .cds--ai-label:after,.cds--list-box__wrapper--slug .cds--ai-label:before,.cds--list-box__wrapper--slug .cds--slug:after,.cds--list-box__wrapper--slug .cds--slug:before,:host(cds-combo-box[ai-label]) .cds--ai-label:after,:host(cds-combo-box[ai-label]) .cds--ai-label:before,:host(cds-combo-box[ai-label]) .cds--slug:after,:host(cds-combo-box[ai-label]) .cds--slug:before,:host(cds-dropdown[ai-label]) .cds--ai-label:after,:host(cds-dropdown[ai-label]) .cds--ai-label:before,:host(cds-dropdown[ai-label]) .cds--slug:after,:host(cds-dropdown[ai-label]) .cds--slug:before{background-color:var(--cds-border-subtle-01,#c6c6c6);block-size:1rem;content:"";inline-size:.0625rem;position:absolute}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>:before,.cds--list-box__wrapper--slug .cds--ai-label:before,.cds--list-box__wrapper--slug .cds--slug:before,:host(cds-combo-box[ai-label]) .cds--ai-label:before,:host(cds-combo-box[ai-label]) .cds--slug:before,:host(cds-dropdown[ai-label]) .cds--ai-label:before,:host(cds-dropdown[ai-label]) .cds--slug:before{display:none;inset-inline-start:-.5625rem}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>:after,.cds--list-box__wrapper--slug .cds--ai-label:after,.cds--list-box__wrapper--slug .cds--slug:after,:host(cds-combo-box[ai-label]) .cds--ai-label:after,:host(cds-combo-box[ai-label]) .cds--slug:after,:host(cds-dropdown[ai-label]) .cds--ai-label:after,:host(cds-dropdown[ai-label]) .cds--slug:after{display:block;inset-block-start:0;inset-inline-end:-.5625rem}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator .cds--ai-label--revert:after,.cds--list-box__wrapper--slug .cds--ai-label--revert:after,.cds--list-box__wrapper--slug .cds--slug--revert:after,:host(cds-combo-box[ai-label]) .cds--ai-label--revert:after,:host(cds-combo-box[ai-label]) .cds--slug--revert:after,:host(cds-dropdown[ai-label]) .cds--ai-label--revert:after,:host(cds-dropdown[ai-label]) .cds--slug--revert:after{inset-block-start:.5rem;inset-inline-end:-.0625rem}.cds--list-box__wrapper--decorator .cds--list-box:has(.cds--list-box__inner-wrapper--decorator .cds--ai-label):not(:has(.cds--list-box__inner-wrapper--decorator .cds--ai-label--revert)),.cds--list-box__wrapper--slug .cds--list-box:has(.cds--ai-label):not(:has(.cds--ai-label--revert)),.cds--list-box__wrapper--slug .cds--list-box:has(.cds--slug):not(:has(.cds--slug--revert)),:host(cds-combo-box[ai-label]) .cds--list-box:has(.cds--ai-label):not(:has(.cds--ai-label--revert)),:host(cds-combo-box[ai-label]) .cds--list-box:has(.cds--slug):not(:has(.cds--slug--revert)),:host(cds-dropdown[ai-label]) .cds--list-box:has(.cds--ai-label):not(:has(.cds--ai-label--revert)),:host(cds-dropdown[ai-label]) .cds--list-box:has(.cds--slug):not(:has(.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff)}.cds--list-box__wrapper--decorator .cds--list-box input[role=combobox],.cds--list-box__wrapper--slug .cds--list-box input[role=combobox],:host(cds-combo-box[ai-label]) .cds--list-box input[role=combobox],:host(cds-dropdown[ai-label]) .cds--list-box input[role=combobox]{border-block-end-color:transparent}.cds--list-box__wrapper--decorator .cds--list-box__field,.cds--list-box__wrapper--decorator .cds--text-input--empty,.cds--list-box__wrapper--slug .cds--list-box__field,.cds--list-box__wrapper--slug .cds--text-input--empty,:host(cds-combo-box[ai-label]) .cds--list-box__field,:host(cds-combo-box[ai-label]) .cds--text-input--empty,:host(cds-dropdown[ai-label]) .cds--list-box__field,:host(cds-dropdown[ai-label]) .cds--text-input--empty{padding-inline-end:4rem}.cds--list-box__wrapper--decorator .cds--text-input:not(.cds--text-input--empty),.cds--list-box__wrapper--slug .cds--text-input:not(.cds--text-input--empty),:host(cds-combo-box[ai-label]) .cds--text-input:not(.cds--text-input--empty),:host(cds-dropdown[ai-label]) .cds--text-input:not(.cds--text-input--empty){padding-inline-end:6rem}.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--list-box__field,.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--text-input--empty,.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__field,.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--text-input--empty,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--list-box__field,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--text-input--empty,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--text-input--empty,:host(cds-combo-box[ai-label]) .cds--list-box--invalid[data-invalid] .cds--list-box__field,:host(cds-combo-box[ai-label]) .cds--list-box--invalid[data-invalid] .cds--text-input--empty,:host(cds-combo-box[ai-label]) .cds--list-box--warning .cds--list-box__field,:host(cds-combo-box[ai-label]) .cds--list-box--warning .cds--text-input--empty,:host(cds-dropdown[ai-label]) .cds--list-box--invalid[data-invalid] .cds--list-box__field,:host(cds-dropdown[ai-label]) .cds--list-box--invalid[data-invalid] .cds--text-input--empty,:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--list-box__field,:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--text-input--empty{padding-inline-end:6rem}.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--text-input:not(.cds--text-input--empty),.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--text-input:not(.cds--text-input--empty),.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--text-input:not(.cds--text-input--empty),.cds--list-box__wrapper--slug .cds--list-box--warning .cds--text-input:not(.cds--text-input--empty),:host(cds-combo-box[ai-label]) .cds--list-box--invalid[data-invalid] .cds--text-input:not(.cds--text-input--empty),:host(cds-combo-box[ai-label]) .cds--list-box--warning .cds--text-input:not(.cds--text-input--empty),:host(cds-dropdown[ai-label]) .cds--list-box--invalid[data-invalid] .cds--text-input:not(.cds--text-input--empty),:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--text-input:not(.cds--text-input--empty){padding-inline-end:8.8125rem}.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--list-box__invalid-icon,.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--text-input--empty+.cds--list-box__invalid-icon,.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__invalid-icon.cds--list-box__invalid-icon--warning,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--list-box__invalid-icon,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--text-input--empty+.cds--list-box__invalid-icon,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__invalid-icon.cds--list-box__invalid-icon--warning,:host(cds-combo-box[ai-label]) .cds--list-box--invalid[data-invalid] .cds--list-box__invalid-icon,:host(cds-combo-box[ai-label]) .cds--list-box--warning .cds--list-box__invalid-icon.cds--list-box__invalid-icon--warning,:host(cds-dropdown[ai-label]) .cds--list-box--invalid[data-invalid] .cds--list-box__invalid-icon,:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--list-box__invalid-icon.cds--list-box__invalid-icon--warning{inset-inline-end:5.1875rem}.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid]>:before,.cds--list-box__wrapper--decorator .cds--list-box--warning>:before,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--ai-label:before,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--slug:before,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--ai-label:before,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--slug:before,:host(cds-combo-box[ai-label]) .cds--list-box--invalid[data-invalid] .cds--ai-label:before,:host(cds-combo-box[ai-label]) .cds--list-box--invalid[data-invalid] .cds--slug:before,:host(cds-combo-box[ai-label]) .cds--list-box--warning .cds--ai-label:before,:host(cds-combo-box[ai-label]) .cds--list-box--warning .cds--slug:before,:host(cds-dropdown[ai-label]) .cds--list-box--invalid[data-invalid] .cds--ai-label:before,:host(cds-dropdown[ai-label]) .cds--list-box--invalid[data-invalid] .cds--slug:before,:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--ai-label:before,:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--slug:before{display:block}.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,.cds--list-box__wrapper--decorator .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection)~.cds--slug,.cds--list-box__wrapper--slug .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,.cds--list-box__wrapper--slug .cds--list-box__field:has(.cds--list-box__selection)~.cds--slug,:host(cds-combo-box[ai-label]) .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,:host(cds-combo-box[ai-label]) .cds--list-box__field:has(.cds--list-box__selection)~.cds--slug,:host(cds-dropdown[ai-label]) .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,:host(cds-dropdown[ai-label]) .cds--list-box__field:has(.cds--list-box__selection)~.cds--slug{inset-inline-end:calc(4rem + 18px)}.cds--list-box__wrapper--decorator .cds--list-box--invalid .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,.cds--list-box__wrapper--slug .cds--list-box--invalid .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,:host(cds-combo-box[ai-label]) .cds--list-box--invalid .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,:host(cds-combo-box[ai-label]) .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,:host(cds-dropdown[ai-label]) .cds--list-box--invalid .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,:host(cds-dropdown[ai-label]) .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon{inset-inline-end:7.25rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--list-box__field,.cds--list-box__menu,.cds--multi-select .cds--tag--filter{outline:1px solid transparent}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--list-box__field:focus,.cds--list-box__menu-item--highlighted .cds--list-box__menu-item__option,.cds--multi-select .cds--tag__close-icon:focus,:host(cds-combo-box-item[highlighted]) .cds--list-box__menu-item__option,:host(cds-combo-box-item[selected]) .cds--list-box__menu-item__option,:host(cds-dropdown-item[highlighted]) .cds--list-box__menu-item__option,:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__option{color:Highlight;outline:1px solid Highlight}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--list-box__menu-icon>svg,.cds--list-box__selection--multi>svg,.cds--list-box__selection>svg{fill:ButtonText}}.cds--list-box__field:has(.cds--list-box__menu-icon) .cds--list-box__selection:after{background-color:var(--cds-border-subtle-01,#c6c6c6);block-size:1rem;content:"";inline-size:.0625rem;margin-inline-start:2.0625rem;position:absolute}.cds--list-box--invalid[data-invalid] .cds--list-box__field:has(.cds--list-box__menu-icon) .cds--list-box__selection:before,.cds--list-box--warning .cds--list-box__field:has(.cds--list-box__menu-icon) .cds--list-box__selection:before{background-color:var(--cds-border-subtle-01,#c6c6c6);block-size:1rem;content:"";inline-size:.0625rem;margin-inline-end:2.0625rem;position:absolute}.cds--list-box__wrapper--decorator:has(.cds--multi-select) .cds--list-box__menu-icon,.cds--list-box__wrapper--slug:has(.cds--multi-select) .cds--list-box__menu-icon,:has(.cds--multi-select):host(cds-combo-box[ai-label]) .cds--list-box__menu-icon,:has(.cds--multi-select):host(cds-dropdown[ai-label]) .cds--list-box__menu-icon{inset-inline-end:.75rem}.cds--list-box__wrapper--decorator:has(.cds--dropdown) .cds--list-box__menu-icon,.cds--list-box__wrapper--slug:has(.cds--dropdown) .cds--list-box__menu-icon,:has(.cds--dropdown):host(cds-combo-box[ai-label]) .cds--list-box__menu-icon,:has(.cds--dropdown):host(cds-dropdown[ai-label]) .cds--list-box__menu-icon{inset-inline-end:.75rem}:host(cds-combo-box),:host(cds-dropdown){outline:none}:host(cds-combo-box) .cds--assistive-text,:host(cds-dropdown) .cds--assistive-text{inset-block-start:-100%;inset-inline-start:-100%}:host(cds-combo-box) .cds--label[hidden],:host(cds-dropdown) .cds--label[hidden]{display:none}:host(cds-combo-box) .cds--list-box__menu,:host(cds-dropdown) .cds--list-box__menu{inset-block-start:100%;margin-block-start:1px;outline:1px solid var(--cds-focus,#0f62fe)}:host(cds-dropdown[open]) .cds--list-box__field{outline:none}:host(cds-dropdown[invalid]) .cds--list-box__field{outline:none}:host(cds-dropdown[invalid]) .cds--form__helper-text{color:var(--cds-text-error,#da1e28)}:host(cds-dropdown[read-only]) .cds--list-box{background-color:transparent;border-block-end-color:var(--cds-border-subtle)}:host(cds-combo-box[direction=top]) .cds--list-box__menu,:host(cds-dropdown[direction=top]) .cds--list-box__menu{inset-block-start:auto}:host(cds-dropdown[type=inline]){grid-gap:0 1.5rem}:host(cds-dropdown[type=inline][warn]) .cds--list-box__field{padding-inline:1rem 3.5rem}:host(cds-dropdown[invalid]) .cds--form__helper-text,:host(cds-dropdown[warn]) .cds--form__helper-text{grid-column:2}:host(cds-dropdown-item){display:block}:host(cds-dropdown-item) .cds--list-box__menu-item__option{block-size:auto}:host(cds-dropdown-item:first-child) .cds--list-box__menu-item__option{border-block-start-width:0}:host(cds-dropdown-item:hover){background-color:var(--cds-layer-hover)}:host(cds-dropdown-item[disabled]) .cds--list-box__menu-item__option{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));text-decoration:none}:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}:host(cds-dropdown-item[selected]) .cds--list-box__menu-item__selected-icon{display:block}:host(cds-dropdown-item[size=sm]){block-size:2rem}:host(cds-dropdown-item[size=sm]) .cds--list-box__menu-item__option{padding-block:.4375rem}:host(cds-dropdown-item[size=lg]){block-size:3rem}:host(cds-dropdown-item[size=lg]) .cds--list-box__menu-item__option{padding-block:.9375rem}:host(cds-dropdown-skeleton) .cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;padding:0;pointer-events:none;position:relative}:host(cds-dropdown-skeleton) .cds--skeleton:active,:host(cds-dropdown-skeleton) .cds--skeleton:focus,:host(cds-dropdown-skeleton) .cds--skeleton:hover{border:none;cursor:default;outline:none}:host(cds-dropdown-skeleton) .cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){:host(cds-dropdown-skeleton) .cds--skeleton:before{animation:none}}:host(cds-dropdown[ai-label]) ::slotted(cds-ai-label),:host(cds-dropdown[ai-label]) ::slotted(cds-slug){inset-block-start:50%;inset-inline-end:2.5rem;position:absolute}:host(cds-dropdown[ai-label]) ::slotted(cds-ai-label:not([revert-active])),:host(cds-dropdown[ai-label]) ::slotted(cds-slug:not([revert-active])){transform:translateY(-50%)}:host(cds-dropdown[ai-label][invalid]) .cds--list-box .cds--list-box__field,:host(cds-dropdown[ai-label][warn]) .cds--list-box .cds--list-box__field{padding-inline-end:6rem}:host(cds-dropdown[ai-label][invalid]) ::slotted(cds-ai-label),:host(cds-dropdown[ai-label][invalid]) ::slotted(cds-slug),:host(cds-dropdown[ai-label][warn]) ::slotted(cds-ai-label),:host(cds-dropdown[ai-label][warn]) ::slotted(cds-slug){inset-inline-end:4rem}:host(cds-combo-box){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;outline:none}:host(cds-combo-box) .cds--assistive-text{inset-block-start:-100%;inset-inline-start:-100%}:host(cds-combo-box) .cds--list-box__field{padding:0}:host(cds-combo-box) .cds--list-box__menu{inset-block-start:100%;margin-block-start:1px;outline:none}:host(cds-combo-box[isClosable]) .cds--list-box__invalid-icon{inset-inline-end:4.125rem!important}:host(cds-combo-box[disabled]) .cds--list-box__selection,:host(cds-combo-box[read-only]) .cds--list-box__selection{pointer-events:none}:host(cds-combo-box[invalid]) .cds--form__helper-text{color:var(--cds-text-error,#da1e28)}:host(cds-combo-box[read-only]) .cds--list-box__selection svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}:host(cds-combo-box-item){display:block}:host(cds-combo-box-item) .cds--list-box__menu-item__option{block-size:auto}:host(cds-combo-box-item):hover{background-color:var(--cds-layer-hover)}:host(cds-combo-box-item[disabled]) .cds--list-box__menu-item__option{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));text-decoration:none}:host(cds-combo-box-item[selected]) .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}:host(cds-combo-box-item[selected]) .cds--list-box__menu-item__selected-icon{display:block}:host(cds-combo-box-item[size=sm]){block-size:2rem}:host(cds-combo-box-item[size=sm]) .cds--list-box__menu-item__option{padding-block:.4375rem}:host(cds-combo-box-item[size=lg]){block-size:3rem}:host(cds-combo-box-item[size=lg]) .cds--list-box__menu-item__option{padding-block:.9375rem}:host(cds-combo-box[ai-label]) .cds--list-box__field{padding:0}:host(cds-combo-box[ai-label]) ::slotted(cds-ai-label),:host(cds-combo-box[ai-label]) ::slotted(cds-slug){inset-block-start:50%;inset-inline-end:2.5rem;position:absolute}:host(cds-combo-box[ai-label]) ::slotted(cds-ai-label:not([revert-active])),:host(cds-combo-box[ai-label]) ::slotted(cds-slug:not([revert-active])){transform:translateY(-50%)}:host(cds-combo-box[ai-label][isclosable]) ::slotted(cds-ai-label),:host(cds-combo-box[ai-label][isclosable]) ::slotted(cds-slug){inset-inline-end:4rem}:host(cds-combo-box[invalid]) ::slotted(cds-ai-label),:host(cds-combo-box[invalid]) ::slotted(cds-slug),:host(cds-combo-box[warn]) ::slotted(cds-ai-label),:host(cds-combo-box[warn]) ::slotted(cds-slug){inset-inline-end:4rem}:host(cds-combo-box[invalid][isclosable]) ::slotted(cds-ai-label),:host(cds-combo-box[invalid][isclosable]) ::slotted(cds-slug),:host(cds-combo-box[warn][isclosable]) ::slotted(cds-ai-label),:host(cds-combo-box[warn][isclosable]) ::slotted(cds-slug){inset-inline-end:5.5rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9gwdh":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSComboBoxItem$1);
var _tslib = require("tslib");
var _settingsJs = require("../../globals/settings.js");
var _dropdownItemJs = require("../dropdown/dropdown-item.js");
var _dropdownItemJsDefault = parcelHelpers.interopDefault(_dropdownItemJs);
var _comboBoxScssJs = require("./combo-box.scss.js");
var _comboBoxScssJsDefault = parcelHelpers.interopDefault(_comboBoxScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Combo box item.
 *
 * @element cds-combo-box-item
 */ let CDSComboBoxItem = class CDSComboBoxItem extends (0, _dropdownItemJsDefault.default) {
};
CDSComboBoxItem.styles = (0, _comboBoxScssJsDefault.default);
CDSComboBoxItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-combo-box-item`)
], CDSComboBoxItem);
var CDSComboBoxItem$1 = CDSComboBoxItem;

},{"tslib":"gBS4y","../../globals/settings.js":"EipuL","../dropdown/dropdown-item.js":"cje0A","./combo-box.scss.js":"5v1qv","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cje0A":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSDropdownItem$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _16Js = require("../../icons/checkmark/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _settingsJs = require("../../globals/settings.js");
var _dropdownJs = require("./dropdown.js");
var _dropdownScssJs = require("./dropdown.scss.js");
var _dropdownScssJsDefault = parcelHelpers.interopDefault(_dropdownScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("./defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Dropdown item.
 *
 * @element cds-dropdown-item
 * @csspart selected-icon The selected icon.
 */ let CDSDropdownItem = class CDSDropdownItem extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if this dropdown item should be disabled.
         */ this.disabled = false;
        /**
         * `true` if this dropdown item should be highlighted.
         * If `true`, parent `<dropdown>` selects/deselects this dropdown item upon keyboard interaction.
         *
         * @private
         */ this.highlighted = false;
        /**
         * `true` if this dropdown item should be selected.
         *
         * @private
         */ this.selected = false;
        /**
         * Dropdown size.
         */ this.size = (0, _defsJs.DROPDOWN_SIZE).MEDIUM;
        /**
         * The `value` attribute that is set to the parent `<cds-dropdown>` when this dropdown item is selected.
         */ this.value = "";
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.hasAttribute("role")) this.setAttribute("role", "option");
        if (!this.hasAttribute("id")) this.setAttribute("id", `${(0, _settingsJs.prefix)}-dropdown-item-${this.constructor.id++}`);
        this.setAttribute("aria-selected", String(this.selected));
    }
    render() {
        const { selected } = this;
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--list-box__menu-item__option">
        <slot></slot>
        ${!selected ? undefined : (0, _16JsDefault.default)({
            part: "selected-icon",
            class: `${(0, _settingsJs.prefix)}--list-box__menu-item__selected-icon`
        })}
      </div>
    `;
    }
};
/**
 * Store an identifier for use in composing this item's id.
 *
 * Auto-increments anytime a new dropdown-item appears.
 */ CDSDropdownItem.id = 0;
CDSDropdownItem.styles = (0, _dropdownScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDropdownItem.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDropdownItem.prototype, "highlighted", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDropdownItem.prototype, "selected", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSDropdownItem.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSDropdownItem.prototype, "value", void 0);
CDSDropdownItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-dropdown-item`)
], CDSDropdownItem);
var CDSDropdownItem$1 = CDSDropdownItem;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/checkmark/16.js":"wAzn7","../../globals/settings.js":"EipuL","./dropdown.js":"iHNPo","./dropdown.scss.js":"55Q1R","../../globals/decorators/carbon-element.js":"kNhLR","./defs.js":"9eS24","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cF8Zr":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _tableJs = require("./table.js");
var _tableSkeletonJs = require("./table-skeleton.js");
var _tableHeaderTitleJs = require("./table-header-title.js");
var _tableHeaderDescriptionJs = require("./table-header-description.js");
var _tableBatchActionsJs = require("./table-batch-actions.js");
var _tableBodyJs = require("./table-body.js");
var _tableCellJs = require("./table-cell.js");
var _tableCellContentJs = require("./table-cell-content.js");
var _tableExpandedRowJs = require("./table-expanded-row.js");
var _tableHeadJs = require("./table-head.js");
var _tableHeaderCellJs = require("./table-header-cell.js");
var _tableHeaderRowJs = require("./table-header-row.js");
var _tableRowJs = require("./table-row.js");
var _tableToolbarJs = require("./table-toolbar.js");
var _tableToolbarContentJs = require("./table-toolbar-content.js");
var _tableToolbarSearchJs = require("./table-toolbar-search.js");

},{"./table.js":"7hwlf","./table-skeleton.js":"1tF1Q","./table-header-title.js":"GgIJy","./table-header-description.js":"gtCv0","./table-batch-actions.js":"ZgqGQ","./table-body.js":"bygFH","./table-cell.js":"RzpNl","./table-cell-content.js":"lEs5E","./table-expanded-row.js":"du5aW","./table-head.js":"1Zamo","./table-header-cell.js":"gndBx","./table-header-row.js":"1HXeX","./table-row.js":"dbWJ2","./table-toolbar.js":"ilOlc","./table-toolbar-content.js":"1BFk5","./table-toolbar-search.js":"aPog0"}],"7hwlf":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TABLE_SIZE", ()=>(0, _defsJs.TABLE_SIZE));
parcelHelpers.export(exports, "default", ()=>CDSTable$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _defsJs = require("./defs.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Data table.
 *
 * @element cds-table
 * @fires cds-table-header-cell-sort
 *   The name of the custom event fired before a new sort direction is set upon a user gesture.
 *   Cancellation of this event stops the user-initiated change in sort direction.
 * @fires cds-search input
 *   The name of the custom event fired during search bar input
 * @fires cds-table-change-selection-all
 *   The name of the custom event fired before header row is selected/unselected upon a user gesture.
 * @fires cds-table-row-change-selection
 *   The name of the custom event fired before a row is selected/unselected upon a user gesture.
 * @fires cds-table-batch-actions-cancel-clicked
 *   The name of the custom event fired after the Cancel button is clicked.
 * @fires cds-table-row-expando-toggled
 *   The name of the custom event fired after the expanded state of a row is toggled upon a user gesture.
 * @fires cds-table-row-selected
 *   The name of the custom event fired after a row has been selected.
 * @fires cds-table-row-all-selected
 *   The name of the custom event fired after all rows have been selected.
 * @fires cds-table-sorted
 *   The name of the custom event fired after the table has been sorted.
 * @fires cds-table-filtered
 *   The name of the custom event fired after the table has been filtered containing remaining rows.
 */ let CDSTable = class CDSTable extends (0, _hostListenerJsDefault1.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * The map of how sorting direction affects sorting order.
         */ this.collationFactors = {
            [(0, _defsJs.TABLE_SORT_DIRECTION).ASCENDING]: 1,
            [(0, _defsJs.TABLE_SORT_DIRECTION).DESCENDING]: -1
        };
        /**
         * Current search value for filtering
         */ this._searchValue = "";
        this._selectedRows = [];
        /**
         * `true` if this table should support batch expansion
         */ this.batchExpansion = false;
        /**
         * Specify whether the rows should be able to be expandable
         */ this.expandable = false;
        /**
         * The method used when filtering the table with the search bar.
         * Can be replaced with custom method.
         *
         * @param rowText A table row.
         * @param searchString A search string.
         * @returns `false` if the given table row matches the given search string.
         */ this.filterRows = (rowText, searchString)=>rowText.toLowerCase().indexOf(searchString.toLowerCase()) < 0;
        /**
         * The total headers
         */ this.headerCount = 0;
        /**
         * `true` if this table contains selectable rows
         */ this.isSelectable = false;
        /**
         * `true` if this table should support sorting.
         */ this.isSortable = false;
        /**
         * The table size.
         */ this.locale = "en";
        /**
         * Specify whether the overflow menu (if it exists) should be shown always, or only on hover
         */ this.overflowMenuOnHover = false;
        /**
         * Specify whether the control should be a radio button or inline checkbox
         */ this.radio = false;
        /**
         * The table size.
         */ this.size = (0, _defsJs.TABLE_SIZE).LG;
        /**
         * TODO: Uncomment when Carbon fully implements sticky header
         * Specify whether the header should be sticky.
         * Still experimental: may not work with every combination of table props
         */ // @property({ type: Boolean, attribute: 'sticky-header', reflect: true })
        // stickyHeader = false;
        /**
         *  If true, will use a width of 'auto' instead of 100%
         */ this.useStaticWidth = false;
        /**
         *  true to add useZebraStyles striping.
         */ this.useZebraStyles = false;
        /**
         *  true if AI Labels are added in the rows
         */ this.withRowAILabels = false;
        /**
         *  true if slugs are added in the rows
         *
         * @deprecated remove in v12, use `with-row-ai-labels` instead
         */ this.withRowSlugs = false;
        /**
         * Handles batch expansion
         */ this._handleBatchExpansion = async (event)=>{
            const { detail, target } = event;
            const { expanded } = detail;
            if (target === this._tableHeaderRow) this._tableRows.forEach((e)=>e.expanded = expanded);
        };
        /**
         * Handles sorting the table depending on the column selected
         */ this._handleSort = async (event)=>{
            const { detail, target } = event;
            const { sortDirection } = detail;
            if (!this.contains(target)) return;
            const columns = [
                ...this._tableHeaderRow.children
            ];
            const columnIndex = columns.indexOf(target);
            columns.forEach((e)=>{
                if (e !== target && this.isSortable) e.setAttribute("sort-direction", "none");
                else if (e.hasAttribute("is-sortable")) e.setAttribute("sort-direction", "none");
            });
            this._handleSortAction(columnIndex, sortDirection);
            const init = {
                bubbles: true,
                cancelable: true,
                composed: true,
                detail: {
                    sortedHeader: columns[columnIndex]
                }
            };
            this.dispatchEvent(new CustomEvent(this.constructor.eventTableSorted, init));
            this._handleFilterRows();
        };
        /**
         * Handles search input within the toolbar actions
         */ this._handleSearchInput = async (event)=>{
            const { detail, target } = event;
            if (this.contains(target)) {
                const { value } = detail;
                this._searchValue = value;
                this._handleFilterRows();
            }
        };
        /**
         * Handles row selection
         */ this._handleRowSelect = async (event)=>{
            var _a, _b;
            const { detail, target } = event;
            const { selected } = detail;
            const { _tableBatchActions: tableBatchActions, _tableToolbarContent: tableToolbarContent, _tableHeaderRow: tableHeaderRow, _selectedRows: selectedRows } = this;
            if (!this.contains(target)) return;
            if (this.radio) {
                this._tableRows.forEach((e)=>{
                    if (e !== target) {
                        e.removeAttribute("selected");
                        e.shadowRoot.querySelector(`${(0, _settingsJs.prefix)}-radio-button`).checked = false;
                    }
                });
                this._selectedRows.push(...[
                    target
                ]);
            } else {
                if (selectedRows.includes(target)) this._selectedRows = selectedRows.filter((e)=>e !== target);
                else selectedRows.push(target);
                if (tableBatchActions) {
                    tableBatchActions.active = (_a = this._selectedRows) === null || _a === void 0 ? void 0 : _a.length;
                    tableBatchActions.selectedRowsCount += selected ? 1 : -1;
                }
                if (tableToolbarContent) tableToolbarContent.hasBatchActions = this._selectedRows.length;
            }
            const totalRows = [
                ...this._tableRows
            ].filter((elem)=>!elem.hasAttribute("filtered")).length;
            // selected header checkbox upon all rows being selected
            const headerCheckbox = (_b = tableHeaderRow.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(`${(0, _settingsJs.prefix)}-checkbox`).shadowRoot.querySelector(`.${(0, _settingsJs.prefix)}--checkbox`);
            const allRowsSelected = this._selectedRows.length === totalRows;
            headerCheckbox.checked = !this._selectedRows.length ? false : true;
            headerCheckbox.indeterminate = !allRowsSelected && this._selectedRows.length > 0;
            const init = {
                bubbles: true,
                cancelable: true,
                composed: true,
                detail: {
                    selectedRow: target,
                    selectedRows: selectedRows
                }
            };
            this.dispatchEvent(new CustomEvent(this.constructor.eventTableRowSelect, init));
        };
        /**
         * Handles header row selection, selecting/unselecting all rows
         */ this._handleAllRowsSelect = async (event)=>{
            const { detail, target } = event;
            const { selected } = detail;
            const { _tableBatchActions: tableBatchActions, _tableToolbarContent: tableToolbarContent, _tableRows: tableRows } = this;
            if (!this.contains(target)) return;
            let totalRows = 0;
            (0, _collectionHelpersJs.forEach)(tableRows, (elem)=>{
                if (!elem.filtered) {
                    elem.selected = selected;
                    this.radio && (elem.shadowRoot.querySelector(`${(0, _settingsJs.prefix)}-radio-button`).checked = selected);
                    this._selectedRows.push(elem);
                    totalRows++;
                    const { selectorTableExpandedRows } = this.constructor;
                    const { nextElementSibling } = elem;
                    // selecting the expanded row as well
                    if (nextElementSibling === null || nextElementSibling === void 0 ? void 0 : nextElementSibling.matches(selectorTableExpandedRows)) elem.nextElementSibling.selected = selected;
                }
            });
            if (!selected) this._selectedRows = [];
            if (tableBatchActions) {
                tableBatchActions.selectedRowsCount = selected ? totalRows : 0;
                tableBatchActions.active = selected;
            }
            if (tableToolbarContent) tableToolbarContent.hasBatchActions = selected;
            const init = {
                bubbles: true,
                cancelable: true,
                composed: true,
                detail: {
                    selectedRows: this._selectedRows
                }
            };
            this.dispatchEvent(new CustomEvent(this.constructor.eventTableRowSelectAll, init));
        };
        /**
         * Handles cancel button within the toolbar actions
         */ this._handleCancelSelection = async (event)=>{
            var _a;
            const { target } = event;
            const { _tableHeaderRow: tableHeaderRow } = this;
            if (this.contains(target)) (_a = tableHeaderRow.shadowRoot) === null || _a === void 0 || _a.querySelector(`${(0, _settingsJs.prefix)}-checkbox`).shadowRoot.querySelector(`.${(0, _settingsJs.prefix)}--checkbox`).click();
        };
    }
    /**
     * @param lhs A value.
     * @param rhs Another value.
     * @param collator A custom collator.
     * @returns
     *   `0` if the given two values are equal
     *   A negative value to sort `lhs` to an index lower than `rhs`
     *   A positive value to sort `rhs` to an index lower than `lhs`
     */ // eslint-disable-next-line class-methods-use-this
    customSortRow(lhs, rhs, collator) {
        if (typeof lhs === "number" && typeof rhs === "number") return lhs - rhs;
        return collator.compare(lhs, rhs);
    }
    _handleSlotChange({ target }) {
        const hasContent = target.assignedNodes().some((node)=>node.nodeType !== Node.TEXT_NODE || node.textContent.trim());
        this.withHeader = hasContent;
    }
    _handleTableBodyChange() {
        // cds-table-head or cds-table-body may have changed
        this._tableBody = this.querySelector(this.constructor.selectorTableBody);
        this._tableExpandedRows = this.querySelectorAll(this.constructor.selectorTableExpandedRows);
        this._tableRows = this.querySelectorAll(this.constructor.selectorTableRow);
        // update any row dependant features
        this.updateExpandable();
    }
    _handleSortAction(columnIndex, sortDirection) {
        const rows = [
            ...this._tableRows
        ];
        // regular row sorting
        rows.sort((a, b)=>{
            const cellA = a.querySelectorAll(this.constructor.selectorTableRowCells)[columnIndex].textContent;
            const cellB = b.querySelectorAll(this.constructor.selectorTableRowCells)[columnIndex].textContent;
            return this.collationFactors[sortDirection] * this.customSortRow(cellA, cellB, this.collator);
        });
        // take into account the expanded rows, mapping each expandable row to its original for proper reinsertion
        if (this.expandable) {
            const originalRows = [
                ...this._tableRows
            ];
            const expandedRows = [
                ...this._tableExpandedRows
            ];
            const mapping = originalRows.reduce((acc, element, index)=>{
                const sortId = element.getAttribute("sort-id");
                acc[sortId] = expandedRows[index];
                return acc;
            }, {});
            const sortedWithExpanded = [];
            rows.forEach((e)=>{
                const sortId = e.getAttribute("sort-id");
                sortedWithExpanded.push(e);
                sortedWithExpanded.push(mapping[sortId]);
            });
            sortedWithExpanded.forEach((e)=>{
                this._tableBody.insertBefore(e, null);
            });
        } else rows.forEach((e)=>{
            this._tableBody.insertBefore(e, null);
        });
    }
    _handleFilterRows() {
        const unfilteredRows = [];
        (0, _collectionHelpersJs.forEach)(this._tableRows, (elem)=>{
            var _a, _b;
            let rowText = (_a = elem.textContent) === null || _a === void 0 ? void 0 : _a.trim();
            let filtered = this.filterRows(rowText, this._searchValue);
            elem.filtered = filtered;
            if (filtered && this.expandable) {
                rowText = (_b = elem.nextElementSibling.textContent) === null || _b === void 0 ? void 0 : _b.trim();
                filtered = this.filterRows(rowText, this._searchValue);
                elem.filtered = filtered;
            }
            if (!filtered) unfilteredRows.push(elem);
            if (this.expandable) elem.nextElementSibling.filtered = filtered;
        });
        const init = {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: {
                unfilteredRows
            }
        };
        this.dispatchEvent(new CustomEvent(this.constructor.eventTableFiltered, init));
    }
    /**
     * Download manager for selected rows.
     */ _handleDownload({ target }) {
        const data = [];
        const elementsToArray = (elements)=>Array.from(elements, (element)=>element.textContent);
        const headerCells = this.querySelectorAll(this.constructor.selectorHeaderCell);
        const rows = this._selectedRows;
        const headerTitleArray = elementsToArray(headerCells);
        rows.forEach((row)=>{
            const rowData = {};
            const cells = elementsToArray(row.querySelectorAll(this.constructor.selectorTableRowCells));
            cells.forEach((cellText, index)=>{
                const headerTitle = headerTitleArray[index];
                rowData[headerTitle] = cellText;
            });
            data.push(rowData);
        });
        const blob = new Blob([
            JSON.stringify(data)
        ], {
            type: "application/json"
        });
        target.href = URL.createObjectURL(blob);
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "table");
        /**
         * If using `with-row-slugs`, set `with-row-ai-labels` attribute to true so
         * the styles are applied for slug as well
         *
         * remove in v12
         */ if (this.withRowSlugs) {
            this.setAttribute("with-rows-ai-labels", "");
            this.withRowAILabels = true;
        }
        super.connectedCallback();
    }
    firstUpdated() {
        this._tableBatchActions = this.querySelector(this.constructor.selectorTableBatchActions);
        this._tableToolbar = this.querySelector(this.constructor.selectorTableToolbar);
        this._tableToolbarContent = this.querySelector(this.constructor.selectorTableToolbarContent);
        this._tableBody = this.querySelector(this.constructor.selectorTableBody);
        this._tableHeaderRow = this.querySelector(this.constructor.selectorRowsWithHeader);
        this._tableExpandedRows = this.querySelectorAll(this.constructor.selectorTableExpandedRows);
        this._tableRows = this.querySelectorAll(this.constructor.selectorTableRow);
        this._downloadButton = this.querySelector(this.constructor.selectorToolbarDownload);
        if (this._downloadButton) this._downloadButton.onclick = this._handleDownload.bind(this);
        this.headerCount = this._tableHeaderRow.children.length;
    }
    updateExpandable() {
        this._tableRows.forEach((e, index)=>{
            e.expandable = this.expandable;
            e.setAttribute("sort-id", index);
        });
        this._tableHeaderRow.expandable = this.expandable;
        this._tableHeaderRow.batchExpansion = this.batchExpansion;
        this.headerCount += this.expandable ? 1 : -1;
    }
    updated(changedProperties) {
        var _a;
        if (changedProperties.has("expandable")) this.updateExpandable();
        if (changedProperties.has("headerCount")) this._tableExpandedRows.forEach((e)=>{
            e.setAttribute("colspan", this.headerCount);
        });
        if (changedProperties.has("isSelectable")) {
            if (this.isSelectable) {
                this._tableHeaderRow.setAttribute("selection-name", "header");
                this._tableRows.forEach((e, index)=>{
                    if (!e.hasAttribute("selection-name")) e.setAttribute("selection-name", index);
                });
            }
            this.headerCount++;
        }
        if (changedProperties.has("locale")) this.collator = new Intl.Collator(this.locale);
        if (changedProperties.has("isSortable")) {
            if (this.isSortable) this._enableSortAction();
        }
        if (changedProperties.has("overflowMenuOnHover") || changedProperties.has("size")) (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorTableCellOverflowMenu), (elem)=>{
            const cell = elem.parentNode;
            const row = cell.parentNode;
            cell.overflowMenuOnHover = this.overflowMenuOnHover;
            row.overflowMenuOnHover = this.overflowMenuOnHover;
            cell.setAttribute("size", this.size);
            elem.setAttribute("size", this.size);
            elem.setAttribute("data-table", "");
        });
        if (changedProperties.has("radio")) // Propagate `size` attribute to descendants until `:host-context()` gets supported in all major browsers
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorTableRow), (elem)=>{
            elem.radio = this.radio;
        });
        if (changedProperties.has("size")) {
            // Propagate `size` attribute to descendants until `:host-context()` gets supported in all major browsers
            (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorAllRows), (elem)=>{
                elem.setAttribute("size", this.size);
            });
            (_a = this._tableToolbar) === null || _a === void 0 || _a.setAttribute("size", this.size);
        }
        // TODO: Uncomment when Carbon fully implements Sticky header feature
        // if (changedProperties.has('stickyHeader')) {
        //   const tableBody = this.querySelector(
        //     (this.constructor as typeof CDSTable).selectorTableBody
        //   );
        //   const tableHead = this.querySelector(
        //     (this.constructor as typeof CDSTable).selectorTableHead
        //   );
        //   (tableBody as any).stickyHeader = this.stickyHeader;
        //   (tableHead as any).stickyHeader = this.stickyHeader;
        //   forEach(
        //     this.querySelectorAll(
        //       (this.constructor as typeof CDSTable).selectorRowsWithHeader
        //     ),
        //     (elem) => {
        //       (elem as any).stickyHeader = this.stickyHeader;
        //     }
        //   );
        //   forEach(
        //     this.querySelectorAll(
        //       (this.constructor as typeof CDSTable).selectorTableCells
        //     ),
        //     (elem) => {
        //       (elem as any).stickyHeader = this.stickyHeader;
        //     }
        //   );
        // }
        if (changedProperties.has("useZebraStyles")) {
            const tableBody = this.querySelector(this.constructor.selectorTableBody);
            tableBody.useZebraStyles = this.useZebraStyles;
        }
        if (this.withRowAILabels) {
            this._tableHeaderRow.setAttribute("rows-with-ai-label", "");
            this._tableRows.forEach((row)=>{
                row.setAttribute("rows-with-ai-label", "");
            });
        } else {
            this._tableHeaderRow.removeAttribute("rows-with-ai-label");
            this._tableRows.forEach((row)=>{
                row.removeAttribute("rows-with-ai-label");
            });
        }
        // Gets table header info to add to the column cells for styles
        const headersWithAILabel = [];
        Array.prototype.slice.call(this._tableHeaderRow.children).forEach((headerCell, index)=>{
            if (headerCell.querySelector(`${(0, _settingsJs.prefix)}-ai-label`) || headerCell.querySelector(`${(0, _settingsJs.prefix)}-slug`)) {
                headerCell.setAttribute("ai-label", "");
                headersWithAILabel.push(index);
            } else headerCell.removeAttribute("ai-label");
        });
        this._tableRows.forEach((row)=>{
            Array.prototype.slice.call(row.children).forEach((cell, index)=>{
                headersWithAILabel.includes(index) ? cell.setAttribute("ai-label-in-header", "") : cell.removeAttribute("ai-label-in-header");
            });
        });
    }
    /* eslint-disable no-constant-condition */ render() {
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--data-table-header-container">
        <div ?hidden="${!this.withHeader}" class="${0, _settingsJs.prefix}--data-table-header">
          <slot @slotchange="${this._handleSlotChange}" name="title"></slot>
          <slot
            @slotchange="${this._handleSlotChange}"
            name="description"></slot>
        </div>
        <slot name="toolbar"></slot>
      </div>

      ${(0, _lit.html)`<slot
            @cds-table-body-content-change="${this._handleTableBodyChange}"></slot>`}
    `;
    }
    /**
     * Adds isSortable value for table header cells.
     */ _enableSortAction() {
        const headerCells = this.querySelectorAll(this.constructor.selectorHeaderCell);
        headerCells.forEach((e)=>{
            e.isSortable = this.isSortable;
            e.isSelectable = this.isSelectable;
            e.isExpandable = this.expandable;
        });
        const columns = [
            ...this._tableHeaderRow.children
        ];
        let sortDirection;
        let columnIndex = 0;
        columns.forEach((column, index)=>{
            if (column.hasAttribute("sort-direction") && column.getAttribute("sort-direction") !== "none") {
                sortDirection = column.getAttribute("sort-direction");
                columnIndex = index;
            }
        });
        columns.forEach((e, index)=>{
            if (index !== columnIndex && this.isSortable) e.setAttribute("sort-direction", "none");
            else if (e.hasAttribute("is-sortable")) e.setAttribute("sort-direction", "none");
        });
        this._handleSortAction(columnIndex, sortDirection);
    }
    /* eslint-enable no-constant-condition */ /**
     * The name of the custom event fired before a new sort direction is set upon a user gesture.
     * Cancellation of this event stops the user-initiated change in sort direction.
     */ static get eventBeforeSort() {
        return `${0, _settingsJs.prefix}-table-header-cell-sort`;
    }
    /**
     * The name of the custom event fired during search bar input
     */ static get eventSearchInput() {
        return `${0, _settingsJs.prefix}-search-input`;
    }
    /**
     * The name of the custom event fired before header row is selected/unselected upon a user gesture.
     */ static get eventBeforeChangeSelectionAll() {
        return `${0, _settingsJs.prefix}-table-change-selection-all`;
    }
    /**
     * The name of the custom event fired before a row is selected/unselected upon a user gesture.
     */ static get eventBeforeChangeSelection() {
        return `${0, _settingsJs.prefix}-table-row-change-selection`;
    }
    /**
     * The name of the custom event fired after the Cancel button is clicked.
     */ static get eventClickCancel() {
        return `${0, _settingsJs.prefix}-table-batch-actions-cancel-clicked`;
    }
    /**
     * The name of the custom event fired after the expanded state a row is toggled upon a user gesture.
     */ static get eventExpandoToggle() {
        return `${0, _settingsJs.prefix}-table-row-expando-toggled`;
    }
    /**
     * The name of the custom event fired after a row has been selected
     */ static get eventTableRowSelect() {
        return `${0, _settingsJs.prefix}-table-row-selected`;
    }
    /**
     * The name of the custom event fired after all rows have been selected
     */ static get eventTableRowSelectAll() {
        return `${0, _settingsJs.prefix}-table-row-all-selected`;
    }
    /**
     * The name of the custom event fired after the table has been sorted
     */ static get eventTableSorted() {
        return `${0, _settingsJs.prefix}-table-sorted`;
    }
    /**
     * The name of the custom event fired after the table has been filtered containing remaining rows.
     */ static get eventTableFiltered() {
        return `${0, _settingsJs.prefix}-table-filtered`;
    }
    /**
     * The CSS selector to find the overflow menu on the table cell
     */ static get selectorTableCellOverflowMenu() {
        return `${0, _settingsJs.prefix}-table-cell ${0, _settingsJs.prefix}-overflow-menu`;
    }
    /**
     * The CSS selector to find the download button
     */ static get selectorToolbarDownload() {
        return `${0, _settingsJs.prefix}-button[download]`;
    }
    /**
     * The CSS selector to find the table batch actions
     */ static get selectorTableBatchActions() {
        return `${0, _settingsJs.prefix}-table-batch-actions`;
    }
    /**
     * The CSS selector to find the table toolbar
     */ static get selectorTableToolbar() {
        return `${0, _settingsJs.prefix}-table-toolbar`;
    }
    /**
     * The CSS selector to find the table toolbar content
     */ static get selectorTableToolbarContent() {
        return `${0, _settingsJs.prefix}-table-toolbar-content`;
    }
    /**
     * The CSS selector to find the table toolbar search
     */ static get selectorTableToolbarSearch() {
        return `${0, _settingsJs.prefix}-table-toolbar-search`;
    }
    /**
     * The CSS selector to find the table head
     */ static get selectorTableHead() {
        return `${0, _settingsJs.prefix}-table-head`;
    }
    /**
     * The CSS selector to find the table body
     */ static get selectorTableBody() {
        return `${0, _settingsJs.prefix}-table-body`;
    }
    /**
     * The CSS selector to find the table expanded rows
     */ static get selectorTableExpandedRows() {
        return `${0, _settingsJs.prefix}-table-expanded-row`;
    }
    /**
     * The CSS selector to find the table rows
     */ static get selectorTableRow() {
        return `${0, _settingsJs.prefix}-table-row`;
    }
    /**
     * The CSS selector to find the rows cells.
     */ static get selectorTableRowCells() {
        return `${0, _settingsJs.prefix}-table-cell`;
    }
    /**
     * The CSS selector to find the rows cells, including header cells.
     */ static get selectorTableCells() {
        return `${0, _settingsJs.prefix}-table-cell, ${0, _settingsJs.prefix}-table-header-cell`;
    }
    /**
     * The CSS selector to find the header cell
     */ static get selectorHeaderCell() {
        return `${0, _settingsJs.prefix}-table-header-cell`;
    }
    /**
     * The CSS selector to find the rows, including header rows.
     */ static get selectorRowsWithHeader() {
        return `${0, _settingsJs.prefix}-table-header-row,${0, _settingsJs.prefix}-table-row`;
    }
    /**
     * The CSS selector to find all rows
     */ static get selectorAllRows() {
        return `${0, _settingsJs.prefix}-table-header-row,${0, _settingsJs.prefix}-table-row,${0, _settingsJs.prefix}-table-expanded-row`;
    }
};
CDSTable.styles = (0, _dataTableScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTable.prototype, "_downloadButton", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTable.prototype, "_searchValue", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTable.prototype, "_tableHeaderRow", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTable.prototype, "_tableBody", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTable.prototype, "_tableExpandedRows", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTable.prototype, "_tableRows", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTable.prototype, "_tableBatchActions", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTable.prototype, "_tableToolbar", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTable.prototype, "_tableToolbarContent", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTable.prototype, "_selectedRows", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "batch-expansion"
    })
], CDSTable.prototype, "batchExpansion", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: false
    })
], CDSTable.prototype, "collator", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTable.prototype, "expandable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTable.prototype, "filterRows", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTable.prototype, "headerCount", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "is-selectable"
    })
], CDSTable.prototype, "isSelectable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "is-sortable"
    })
], CDSTable.prototype, "isSortable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTable.prototype, "locale", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "overflow-menu-on-hover"
    })
], CDSTable.prototype, "overflowMenuOnHover", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTable.prototype, "radio", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTable.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "use-static-width",
        reflect: true
    })
], CDSTable.prototype, "useStaticWidth", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "use-zebra-styles",
        reflect: true
    })
], CDSTable.prototype, "useZebraStyles", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "with-header",
        reflect: true
    })
], CDSTable.prototype, "withHeader", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "with-row-ai-labels"
    })
], CDSTable.prototype, "withRowAILabels", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "with-row-slugs"
    })
], CDSTable.prototype, "withRowSlugs", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("eventExpandoToggle")
], CDSTable.prototype, "_handleBatchExpansion", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("eventBeforeSort")
], CDSTable.prototype, "_handleSort", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("eventSearchInput")
], CDSTable.prototype, "_handleSearchInput", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("eventBeforeChangeSelection")
], CDSTable.prototype, "_handleRowSelect", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("eventBeforeChangeSelectionAll")
], CDSTable.prototype, "_handleAllRowsSelect", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("eventClickCancel")
], CDSTable.prototype, "_handleCancelSelection", void 0);
CDSTable = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table`)
], CDSTable);
var CDSTable$1 = CDSTable;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/internal/collection-helpers.js":"4aZkz","./defs.js":"4ND6K","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/host-listener.js":"1SMUX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ND6K":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Table size.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TABLE_SIZE", ()=>TABLE_SIZE);
parcelHelpers.export(exports, "TABLE_SORT_CYCLE", ()=>TABLE_SORT_CYCLE);
parcelHelpers.export(exports, "TABLE_SORT_CYCLES", ()=>TABLE_SORT_CYCLES);
parcelHelpers.export(exports, "TABLE_SORT_DIRECTION", ()=>TABLE_SORT_DIRECTION);
var TABLE_SIZE;
(function(TABLE_SIZE) {
    /**
     * xs size.
     */ TABLE_SIZE["XS"] = "xs";
    /**
     * sm size.
     */ TABLE_SIZE["SM"] = "sm";
    /**
     * md size.
     */ TABLE_SIZE["MD"] = "md";
    /**
     * lg size - default.
     */ TABLE_SIZE["LG"] = "lg";
    /**
     * xl size.
     */ TABLE_SIZE["XL"] = "xl";
})(TABLE_SIZE || (TABLE_SIZE = {}));
/**
 * Table sort state.
 */ var TABLE_SORT_DIRECTION;
(function(TABLE_SORT_DIRECTION) {
    /**
     * Not sorted.
     */ TABLE_SORT_DIRECTION["NONE"] = "none";
    /**
     * Sorted ascendingly.
     */ TABLE_SORT_DIRECTION["ASCENDING"] = "ascending";
    /**
     * Sorted descendingly.
     */ TABLE_SORT_DIRECTION["DESCENDING"] = "descending";
})(TABLE_SORT_DIRECTION || (TABLE_SORT_DIRECTION = {}));
/**
 * Table sort cycle.
 */ var TABLE_SORT_CYCLE;
(function(TABLE_SORT_CYCLE) {
    TABLE_SORT_CYCLE["BI_STATES_FROM_ASCENDING"] = "bi-states-from-ascending";
    TABLE_SORT_CYCLE["BI_STATES_FROM_DESCENDING"] = "bi-states-from-descending";
    TABLE_SORT_CYCLE["TRI_STATES_FROM_ASCENDING"] = "tri-states-from-ascending";
    TABLE_SORT_CYCLE["TRI_STATES_FROM_DESCENDING"] = "tri-states-from-descending";
})(TABLE_SORT_CYCLE || (TABLE_SORT_CYCLE = {}));
/**
 * Mapping of table sort cycles to table sort states.
 */ const TABLE_SORT_CYCLES = {
    [TABLE_SORT_CYCLE.BI_STATES_FROM_ASCENDING]: [
        TABLE_SORT_DIRECTION.ASCENDING,
        TABLE_SORT_DIRECTION.DESCENDING
    ],
    [TABLE_SORT_CYCLE.BI_STATES_FROM_DESCENDING]: [
        TABLE_SORT_DIRECTION.DESCENDING,
        TABLE_SORT_DIRECTION.ASCENDING
    ],
    [TABLE_SORT_CYCLE.TRI_STATES_FROM_ASCENDING]: [
        TABLE_SORT_DIRECTION.NONE,
        TABLE_SORT_DIRECTION.ASCENDING,
        TABLE_SORT_DIRECTION.DESCENDING
    ],
    [TABLE_SORT_CYCLE.TRI_STATES_FROM_DESCENDING]: [
        TABLE_SORT_DIRECTION.NONE,
        TABLE_SORT_DIRECTION.DESCENDING,
        TABLE_SORT_DIRECTION.ASCENDING
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"UdnU6":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--checkbox-group{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--checkbox-group *,.cds--checkbox-group :after,.cds--checkbox-group :before{box-sizing:inherit}.cds--form-item.cds--checkbox-wrapper{margin-block-end:.375rem;position:relative}.cds--form-item.cds--checkbox-wrapper:first-of-type{margin-block-start:0}.cds--label+.cds--form-item.cds--checkbox-wrapper{margin-block-start:-.125rem}.cds--form-item.cds--checkbox-wrapper:last-of-type{margin-block-end:.1875rem}.cds--checkbox{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;inset-block-start:1.25rem;inset-inline-start:.7rem;visibility:inherit;white-space:nowrap}.cds--checkbox-label{cursor:pointer;display:flex;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);min-block-size:1.25rem;padding-block-start:.0625rem;padding-inline-start:1.25rem;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none}.cds--checkbox-label html{font-size:100%}.cds--checkbox-label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--checkbox-label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--checkbox-label strong{font-weight:600}.cds--checkbox-label-text{padding-inline-start:.625rem}.cds--checkbox-label:after,.cds--checkbox-label:before{box-sizing:border-box}@media print{.cds--checkbox-label:after,.cds--checkbox-label:before{-webkit-print-color-adjust:exact;print-color-adjust:exact}}.cds--checkbox-label:before{background-color:transparent;block-size:1rem;border:1px solid var(--cds-icon-primary,#161616);border-radius:2px;content:"";inline-size:1rem;inset-block-start:.125rem;inset-inline-start:0;margin-block:.0625rem .125rem;margin-inline:.1875rem 0;position:absolute}.cds--checkbox-label:after{background:none;block-size:.3125rem;border-block-end:1.5px solid var(--cds-icon-inverse,#fff);border-inline-start:1.5px solid var(--cds-icon-inverse,#fff);content:"";inline-size:.5625rem;inset-block-start:.40625rem;inset-inline-start:.4375rem;margin-block-start:-.1875rem;position:absolute;transform:scale(0) rotate(-45deg);transform-origin:bottom right}.cds--checkbox-label[data-contained-checkbox-state=true]:before,.cds--checkbox:checked+.cds--checkbox-label:before,.cds--checkbox:indeterminate+.cds--checkbox-label:before{background-color:var(--cds-icon-primary,#161616);border:1px}.cds--checkbox-label[data-contained-checkbox-state=true]:after,.cds--checkbox:checked+.cds--checkbox-label:after{transform:scale(1) rotate(-45deg)}.cds--checkbox:indeterminate+.cds--checkbox-label:after{border-block-end:2px solid var(--cds-icon-inverse,#fff);border-inline-start:0 solid var(--cds-icon-inverse,#fff);inline-size:.5rem;inset-block-start:.6875rem;transform:scale(1) rotate(0deg)}.cds--checkbox-label[data-contained-checkbox-state=true].cds--checkbox-label__focus:before,.cds--checkbox-label__focus:before,.cds--checkbox:checked:focus+.cds--checkbox-label:before,.cds--checkbox:focus+.cds--checkbox-label:before,.cds--checkbox:indeterminate:focus+.cds--checkbox-label:before{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--checkbox-label[data-contained-checkbox-disabled=true],.cds--checkbox:disabled+.cds--checkbox-label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--checkbox-label[data-contained-checkbox-disabled=true]:before,.cds--checkbox:disabled+.cds--checkbox-label:before{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-label[data-contained-checkbox-state=true][data-contained-checkbox-disabled=true]:before,.cds--checkbox:checked:disabled+.cds--checkbox-label:before,.cds--checkbox:indeterminate:disabled+.cds--checkbox-label:before{background-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group[data-invalid] .cds--checkbox-label:before,.cds--checkbox-wrapper--invalid .cds--checkbox-label:before,.cds--checkbox-wrapper--invalid .cds--checkbox:checked+.cds--checkbox-label:before{border:1px solid var(--cds-support-error,#da1e28)}.cds--checkbox-group .cds--checkbox-wrapper--invalid>.cds--checkbox__validation-msg,.cds--checkbox-group .cds--checkbox-wrapper--warning>.cds--checkbox__validation-msg,.cds--checkbox-group .cds--checkbox-wrapper>.cds--form__helper-text{display:none}.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox-label:before,.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox:checked+.cds--checkbox-label:before{border:1px solid var(--cds-icon-primary,#161616)}.cds--checkbox-group__validation-msg,.cds--checkbox__validation-msg{align-items:flex-start;display:none;inline-size:100%;margin-block-start:.25rem}.cds--checkbox__invalid-icon{margin:.0625rem .0625rem 0 .1875rem;fill:var(--cds-support-error,#da1e28);min-inline-size:1rem}.cds--checkbox__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--checkbox__invalid-icon--warning path:first-of-type{fill:#000}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg,.cds--checkbox-group--warning .cds--checkbox-group__validation-msg,.cds--checkbox-wrapper--invalid>.cds--checkbox__validation-msg,.cds--checkbox-wrapper--warning>.cds--checkbox__validation-msg{display:flex}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-group--warning .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--warning .cds--checkbox__validation-msg .cds--form-requirement{display:block;margin-block-start:0;margin-inline-start:.5rem;max-block-size:100%;overflow:visible}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--checkbox-group--readonly .cds--checkbox-label,.cds--checkbox-wrapper--readonly .cds--checkbox-label{cursor:default}.cds--checkbox-group--readonly .cds--checkbox-label-text,.cds--checkbox-wrapper--readonly .cds--checkbox-label-text{cursor:text;-webkit-user-select:text;-moz-user-select:text;user-select:text}.cds--checkbox-group--readonly .cds--checkbox+.cds--checkbox-label:before,.cds--checkbox-wrapper--readonly .cds--checkbox+.cds--checkbox-label:before{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group--readonly .cds--checkbox:checked+.cds--checkbox-label:before,.cds--checkbox-wrapper--readonly .cds--checkbox:checked+.cds--checkbox-label:before{background:transparent;border:1px solid var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group--readonly .cds--checkbox:checked+.cds--checkbox-label:after,.cds--checkbox-wrapper--readonly .cds--checkbox:checked+.cds--checkbox-label:after{border-color:var(--cds-text-primary,#161616)}.cds--checkbox-skeleton .cds--checkbox-label{cursor:default}.cds--checkbox-label-text.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;inline-size:6.25rem;margin-block:.0625rem 0;margin-inline:.375rem 0;padding:0;pointer-events:none;position:relative}.cds--checkbox-label-text.cds--skeleton:active,.cds--checkbox-label-text.cds--skeleton:focus,.cds--checkbox-label-text.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--checkbox-label-text.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--checkbox-label-text.cds--skeleton:before{animation:none}}.cds--checkbox--inline{position:relative}[dir=rtl] .cds--checkbox-label:after{margin-block-start:0;margin-inline-start:-.0625rem;transform-origin:center}[dir=rtl] .cds--checkbox-label[data-contained-checkbox-state=true]:after,[dir=rtl] .cds--checkbox:checked+.cds--checkbox-label:after{transform:scale(1.2) rotate3d(.5,1,0,158deg)}.cds--checkbox-group--decorator legend.cds--label,.cds--checkbox-group--slug legend.cds--label,.cds--checkbox-wrapper--decorator .cds--checkbox-label-text,.cds--checkbox-wrapper--slug .cds--checkbox-label-text{display:flex}.cds--checkbox-group--decorator legend.cds--label .cds--checkbox-group-inner--decorator>*,.cds--checkbox-group--slug legend.cds--label .cds--ai-label,.cds--checkbox-group--slug legend.cds--label .cds--slug,.cds--checkbox-wrapper--decorator .cds--checkbox-label-text .cds--checkbox-wrapper-inner--decorator>*,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--ai-label,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug{margin-inline-start:.5rem}.cds--checkbox-wrapper--decorator .cds--checkbox-label-text .cds--ai-label__button--inline,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--ai-label__button--inline,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug__button--inline{line-height:inherit;margin-block-start:-.0625rem}.cds--checkbox-group--horizontal{display:flex;flex-flow:row wrap;justify-content:flex-start;position:relative}.cds--checkbox-group--horizontal .cds--form-item{flex:none;margin-block-end:0}.cds--checkbox-group--horizontal .cds--form-item:not(:last-of-type){margin-inline-end:1rem}.cds--checkbox-group--horizontal .cds--checkbox-label-text{padding-inline-start:.5rem}.cds--checkbox-group--horizontal .cds--label+.cds--form-item.cds--checkbox-wrapper{margin-block-start:0}.cds--radio-button-group{align-items:center;border:0;box-sizing:border-box;display:flex;font-family:inherit;font-size:100%;margin:0;padding:0;position:relative;vertical-align:baseline}.cds--radio-button-group *,.cds--radio-button-group :after,.cds--radio-button-group :before{box-sizing:inherit}.cds--label+.cds--form-item .cds--radio-button-group{margin-block-start:0}.cds--radio-button-group--vertical{align-items:flex-start;flex-direction:column}.cds--radio-button-group--vertical.cds--radio-button-group--label-left{align-items:flex-end}.cds--radio-button-group--vertical .cds--radio-button__label{margin-inline-end:0}.cds--radio-button-group--vertical .cds--radio-button__label:not(:last-of-type){margin-block-end:.5rem}.cds--radio-button{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;margin-block-start:.9rem;margin-inline-start:.63rem;visibility:inherit;white-space:nowrap}.cds--radio-button__label{align-items:center;cursor:pointer;display:flex;margin-inline-end:1rem}.cds--radio-button__label-text{flex:1;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--radio-button__appearance{background-color:transparent;block-size:1.125rem;border:0;border:1px solid var(--cds-icon-primary,#161616);border-radius:50%;box-sizing:border-box;flex-shrink:0;font-family:inherit;font-size:100%;inline-size:1.125rem;margin:0;margin-block:.0625rem .125rem;margin-inline:.125rem .625rem;padding:0;vertical-align:baseline}.cds--radio-button__appearance *,.cds--radio-button__appearance :after,.cds--radio-button__appearance :before{box-sizing:inherit}.cds--radio-button-group--vertical .cds--radio-button__appearance{margin-block:0}.cds--radio-button:checked+.cds--radio-button__label .cds--radio-button__appearance{align-items:center;border-color:var(--cds-icon-primary,#161616);display:flex;justify-content:center}.cds--radio-button:checked+.cds--radio-button__label .cds--radio-button__appearance:before{background-color:var(--cds-icon-primary,#161616);block-size:100%;border-radius:50%;content:"";display:inline-block;inline-size:100%;position:relative;transform:scale(.5)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--radio-button:checked+.cds--radio-button__label .cds--radio-button__appearance:before{fill:ButtonText;background-color:ButtonText}}@media print{.cds--radio-button:checked+.cds--radio-button__label .cds--radio-button__appearance:before{-webkit-print-color-adjust:exact;print-color-adjust:exact}}.cds--radio-button:disabled+.cds--radio-button__label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--radio-button:disabled+.cds--radio-button__label .cds--radio-button__appearance,.cds--radio-button:disabled:checked+.cds--radio-button__label .cds--radio-button__appearance{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--radio-button:disabled+.cds--radio-button__label .cds--radio-button__appearance:before,.cds--radio-button:disabled:checked+.cds--radio-button__label .cds--radio-button__appearance:before{background-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--radio-button-group--readonly .cds--radio-button+.cds--radio-button__label .cds--radio-button__appearance{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--radio-button-group--readonly .cds--radio-button__label{cursor:default}.cds--radio-button-group--readonly .cds--radio-button__label-text{cursor:text;-webkit-user-select:text;-moz-user-select:text;user-select:text}.cds--radio-button-group--invalid .cds--radio-button+.cds--radio-button__label .cds--radio-button__appearance{border-color:var(--cds-support-error,#da1e28)}.cds--radio-button__validation-msg{align-items:flex-end;display:none;margin-block-start:.375rem}.cds--radio-button__invalid-icon{fill:var(--cds-support-error,#da1e28);margin-inline:.1875rem .0625rem}.cds--radio-button__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--radio-button__invalid-icon--warning path:first-of-type{fill:#000}.cds--radio-button-group--invalid+.cds--radio-button__validation-msg,.cds--radio-button-group--warning+.cds--radio-button__validation-msg{display:flex}.cds--radio-button-group--invalid+.cds--radio-button__validation-msg .cds--form-requirement,.cds--radio-button-group--warning+.cds--radio-button__validation-msg .cds--form-requirement{display:block;margin-block-start:0;margin-inline-start:.5rem;max-block-size:100%;overflow:visible}.cds--radio-button-group--invalid+.cds--radio-button__validation-msg .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--radio-button-group~.cds--form__helper-text{margin-block-start:.375rem}.cds--radio-button:focus+.cds--radio-button__label .cds--radio-button__appearance{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1.5px}.cds--radio-button__label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:1.125rem;border:none;box-shadow:none;inline-size:6.25rem;padding:0;pointer-events:none;position:relative}.cds--radio-button__label.cds--skeleton:active,.cds--radio-button__label.cds--skeleton:focus,.cds--radio-button__label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--radio-button__label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--radio-button__label.cds--skeleton:before{animation:none}}.cds--radio-button__label.cds--skeleton .cds--radio-button__appearance{display:none}.cds--radio-button-wrapper .cds--radio-button__label{align-items:flex-start;display:flex;justify-content:center;margin:0}.cds--radio-button-wrapper:not(:last-of-type){margin-inline-end:1rem}.cds--radio-button-group--vertical .cds--radio-button-wrapper{margin-block-end:.375rem;margin-inline-end:0}.cds--radio-button-group--vertical .cds--radio-button-wrapper .cds--radio-button__label{padding-block-start:.125rem}.cds--radio-button-group--label-right .cds--radio-button__label,.cds--radio-button-wrapper.cds--radio-button-wrapper--label-right .cds--radio-button__label{flex-direction:row}.cds--radio-button-group--label-left .cds--radio-button__label,.cds--radio-button-wrapper.cds--radio-button-wrapper--label-left .cds--radio-button__label{flex-direction:row-reverse}.cds--radio-button-group--label-left .cds--radio-button__appearance,.cds--radio-button-wrapper.cds--radio-button-wrapper--label-left .cds--radio-button__appearance{margin-inline:.5rem 0}.cds--radio-button-group--decorator legend.cds--label,.cds--radio-button-group--slug legend.cds--label,.cds--radio-button-wrapper--decorator .cds--radio-button__label-text,.cds--radio-button-wrapper--slug .cds--radio-button__label-text{display:flex}.cds--radio-button-group--decorator legend.cds--label .cds--radio-button-group-inner--decorator>*,.cds--radio-button-group--slug legend.cds--label .cds--ai-label,.cds--radio-button-group--slug legend.cds--label .cds--slug,.cds--radio-button-wrapper--decorator .cds--radio-button__label-text .cds--radio-button-wrapper-inner--decorator>*,.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--ai-label,.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--slug{margin-inline-start:.5rem}.cds--radio-button-wrapper--decorator .cds--radio-button__label-text .cds--ai-label__button--inline,.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--ai-label__button--inline,.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--slug__button--inline{line-height:inherit;margin-block-start:-.0625rem}.cds--data-table-container{padding-block-start:.125rem;position:relative}.cds--data-table-content{display:block;overflow-x:auto}.cds--data-table-content:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--data-table-content:focus{outline-style:dotted}}.cds--data-table-header{background-color:var(--cds-layer);padding-block:1rem 1.5rem;padding-inline:1rem}.cds--data-table-header__title,:host(cds-table-header-title){color:var(--cds-text-primary,#161616);font-size:var(--cds-heading-03-font-size,1.25rem);font-weight:var(--cds-heading-03-font-weight,400);letter-spacing:var(--cds-heading-03-letter-spacing,0);line-height:var(--cds-heading-03-line-height,1.4)}.cds--data-table-header__description,:host(cds-table-header-description){color:var(--cds-text-secondary,#525252);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}@media (min-width:42rem){.cds--data-table-header__description,:host(cds-table-header-description){max-inline-size:50ch}}@media (min-width:66rem){.cds--data-table-header__description,:host(cds-table-header-description){max-inline-size:80ch}}.cds--data-table,:host(cds-table){border-collapse:collapse;border-spacing:0;inline-size:100%}.cds--data-table thead,:host(cds-table) thead{background-color:var(--cds-layer-accent);font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572)}.cds--data-table tbody,:host(cds-table) tbody{background-color:var(--cds-layer);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--data-table tr,:host(cds-table) tr{block-size:3rem;border:none;inline-size:100%}.cds--data-table tbody tr,.cds--data-table tbody tr td,.cds--data-table tbody tr th,:host(cds-table) tbody tr,:host(cds-table) tbody tr td,:host(cds-table) tbody tr th{transition:background-color 70ms cubic-bezier(0,0,.38,.9)}.cds--data-table tbody tr:not([data-child-row]):hover,.cds--data-table tbody tr[data-child-row]:hover>td,:host(cds-table) tbody tr:not([data-child-row]):hover,:host(cds-table) tbody tr[data-child-row]:hover>td{background-color:var(--cds-layer-hover)}.cds--data-table tbody tr:hover td,.cds--data-table tbody tr:hover th,:host(cds-table) tbody tr:hover td,:host(cds-table) tbody tr:hover th{border-block-end:1px solid var(--cds-layer-hover);border-block-start:1px solid var(--cds-layer-hover);color:var(--cds-text-primary,#161616)}.cds--data-table tr:hover .cds--link:not(.cds--popover-container .cds--link),:host(cds-table) tr:hover .cds--link:not(.cds--popover-container .cds--link){color:var(--cds-link-secondary,#0043ce)}.cds--data-table tr:hover .cds--link--disabled:not(.cds--popover-container .cds--link),:host(cds-table) tr:hover .cds--link--disabled:not(.cds--popover-container .cds--link){color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--data-table td,.cds--data-table th,:host(cds-table) td,:host(cds-table) th{text-align:start;vertical-align:middle}.cds--data-table.cds--data-table--top-aligned-body.cds--data-table--lg tr:not([data-child-row]) td:not(.cds--table-expand){padding-block:1rem 1rem}.cds--data-table.cds--data-table--top-aligned-body.cds--data-table--lg tr:not([data-child-row]) td:not(.cds--table-expand).cds--table-column-menu{padding-block-start:.5rem}.cds--data-table.cds--data-table--top-aligned-body.cds--data-table--lg tr:not([data-child-row]) td:not(.cds--table-expand).cds--table-column-checkbox:not(.cds--table-column-radio){padding-block-start:.8125rem}.cds--data-table.cds--data-table--top-aligned-body td{vertical-align:top}.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--lg th:not(.cds--table-expand):not(.cds--table-sort__header){padding-block:1rem 1rem}.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--lg th:not(.cds--table-expand):not(.cds--table-sort__header).cds--table-column-menu{padding-block-start:.5rem}.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--lg th:not(.cds--table-expand):not(.cds--table-sort__header).cds--table-column-checkbox{padding-block-start:.8125rem}.cds--data-table.cds--data-table--top-aligned-header th{vertical-align:top}.cds--data-table td[align=right],.cds--data-table th[align=right],:host(cds-table) td[align=right],:host(cds-table) th[align=right]{text-align:end}.cds--data-table td[align=center],.cds--data-table th[align=center],:host(cds-table) td[align=center],:host(cds-table) th[align=center]{text-align:center}.cds--data-table th,:host(cds-table) th{background-color:var(--cds-layer-accent);color:var(--cds-text-primary,#161616);padding-inline:1rem 1rem}.cds--data-table th:last-of-type,:host(cds-table) th:last-of-type{inline-size:auto;position:static}.cds--data-table .cds--table-header-label,:host(cds-table) .cds--table-header-label{text-align:start}.cds--data-table tbody th,.cds--data-table td,:host(cds-table) tbody th,:host(cds-table) td{border-block-end:1px solid var(--cds-border-subtle-01,#c6c6c6);border-block-start:1px solid var(--cds-layer);color:var(--cds-text-secondary,#525252);padding-inline:1rem 1rem}.cds--data-table tbody th+td:first-of-type,.cds--data-table td+td:first-of-type,:host(cds-table) tbody th+td:first-of-type,:host(cds-table) td+td:first-of-type{padding-inline-start:.75rem}.cds--layer-two .cds--data-table tbody th,.cds--layer-two .cds--data-table td,.cds--layer-two :host(cds-table) tbody th,.cds--layer-two :host(cds-table) td{border-block-end:1px solid var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--data-table tbody th,.cds--layer-three .cds--data-table td,.cds--layer-three :host(cds-table) tbody th,.cds--layer-three :host(cds-table) td{border-block-end:1px solid var(--cds-border-subtle-03,#c6c6c6)}@supports (-moz-appearance:none){.cds--data-table td,:host(cds-table) td{background-clip:padding-box}}.cds--data-table .cds--dropdown,.cds--data-table .cds--list-box,.cds--data-table .cds--list-box input[role=combobox],.cds--data-table .cds--list-box input[type=text],.cds--data-table .cds--number input[type=number],.cds--data-table .cds--number__control-btn:after,.cds--data-table .cds--number__control-btn:before,.cds--data-table .cds--select-input,.cds--data-table .cds--text-input,:host(cds-table) .cds--dropdown,:host(cds-table) .cds--list-box,:host(cds-table) .cds--list-box input[role=combobox],:host(cds-table) .cds--list-box input[type=text],:host(cds-table) .cds--number input[type=number],:host(cds-table) .cds--number__control-btn:after,:host(cds-table) .cds--number__control-btn:before,:host(cds-table) .cds--select-input,:host(cds-table) .cds--text-input{background-color:var(--cds-field-02,#fff)}.cds--data-table td.cds--table-column-menu .cds--overflow-menu[aria-expanded=false]:focus,:host(cds-table) td.cds--table-column-menu .cds--overflow-menu[aria-expanded=false]:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--data-table td.cds--table-column-menu .cds--overflow-menu[aria-expanded=false]:focus,:host(cds-table) td.cds--table-column-menu .cds--overflow-menu[aria-expanded=false]:focus{outline-style:dotted}}.cds--data-table td.cds--table-column-menu .cds--overflow-menu[aria-expanded=true]:focus,:host(cds-table) td.cds--table-column-menu .cds--overflow-menu[aria-expanded=true]:focus{outline:none}@media (-ms-high-contrast:active),(-ms-high-contrast:none),screen and (hover:hover){.cds--data-table td.cds--table-column-menu .cds--overflow-menu .cds--overflow-menu__icon,:host(cds-table) td.cds--table-column-menu .cds--overflow-menu .cds--overflow-menu__icon{opacity:0}}.cds--data-table td.cds--table-column-menu .cds--overflow-menu.cds--overflow-menu--open .cds--overflow-menu__icon,:host(cds-table) td.cds--table-column-menu .cds--overflow-menu.cds--overflow-menu--open .cds--overflow-menu__icon{opacity:1}.cds--data-table td.cds--table-column-menu .cds--overflow-menu:focus .cds--overflow-menu__icon,.cds--data-table td.cds--table-column-menu .cds--overflow-menu:hover .cds--overflow-menu__icon,.cds--data-table tr:hover td.cds--table-column-menu .cds--overflow-menu .cds--overflow-menu__icon,.cds--data-table.cds--data-table--visible-overflow-menu td.cds--table-column-menu .cds--overflow-menu .cds--overflow-menu__icon,:host(cds-table) td.cds--table-column-menu .cds--overflow-menu:focus .cds--overflow-menu__icon,:host(cds-table) td.cds--table-column-menu .cds--overflow-menu:hover .cds--overflow-menu__icon,:host(cds-table) tr:hover td.cds--table-column-menu .cds--overflow-menu .cds--overflow-menu__icon{opacity:1}.cds--table-row--menu-option .cds--overflow-menu-options__btn .cds--overflow-menu-options__option-content svg{inset-block-start:.1875rem;margin-inline-end:.5rem;position:relative}.cds--data-table .cds--overflow-menu:hover,.cds--data-table .cds--overflow-menu__trigger:hover,:host(cds-table) .cds--overflow-menu:hover,:host(cds-table) .cds--overflow-menu__trigger:hover{background-color:var(--cds-layer-selected-hover)}.cds--data-table--selected .cds--overflow-menu:hover,.cds--data-table--selected .cds--overflow-menu__trigger:hover{background-color:var(--cds-layer-hover)}.cds--data-table--selected .cds--link:not(.cds--link--disabled){color:var(--cds-link-secondary,#0043ce)}.cds--data-table--sm td.cds--table-column-menu,.cds--data-table--xs td.cds--table-column-menu{block-size:1.5rem;padding-block:0}.cds--data-table--sm td.cds--table-column-menu{block-size:2rem}.cds--data-table--md td.cds--table-column-menu{block-size:2.5rem}.cds--data-table--xl .cds--table-column-menu{padding-block-start:.5rem}.cds--data-table--zebra tbody tr:not(.cds--parent-row):nth-child(odd) td{border-block-end:1px solid var(--cds-layer)}.cds--data-table--zebra tbody tr:not(.cds--parent-row):nth-child(2n) td{border-block-end:1px solid var(--cds-layer-accent);border-block-start:1px solid var(--cds-layer-accent)}.cds--data-table--zebra tbody tr:not(.cds--parent-row):not(.cds--data-table--selected):nth-child(2n){background-color:var(--cds-layer-accent)}.cds--data-table--zebra tbody tr:not(.cds--parent-row):hover td{border-block-end:1px solid var(--cds-layer-hover);border-block-start:1px solid var(--cds-layer-hover)}.cds--data-table--zebra tbody tr:not(.cds--parent-row):not(.cds--data-table--selected):hover{background-color:var(--cds-layer-hover)}.cds--table-column-checkbox .cds--checkbox-label{min-block-size:1.5rem;padding-inline-start:0}.cds--table-column-checkbox .cds--checkbox-label:before{margin-block-start:.125rem}.cds--table-column-checkbox .cds--checkbox-label:after{inset-block-start:.46875rem}.cds--data-table th.cds--table-column-checkbox,:host(cds-table) th.cds--table-column-checkbox{background-color:var(--cds-layer-accent);inline-size:2rem;position:static;transition:background-color 70ms cubic-bezier(0,0,.38,.9)}.cds--data-table tbody td.cds--table-column-checkbox,.cds--data-table tbody td.cds--table-expand,.cds--data-table thead th.cds--table-column-checkbox,.cds--data-table thead th.cds--table-expand,:host(cds-table) tbody td.cds--table-column-checkbox,:host(cds-table) tbody td.cds--table-expand,:host(cds-table) thead th.cds--table-column-checkbox,:host(cds-table) thead th.cds--table-expand{min-inline-size:0}.cds--data-table tbody td.cds--table-column-checkbox,.cds--data-table thead th.cds--table-column-checkbox,:host(cds-table) tbody td.cds--table-column-checkbox,:host(cds-table) thead th.cds--table-column-checkbox{min-inline-size:2.5rem;padding-inline:1rem .25rem}.cds--data-table tbody td.cds--table-expand,.cds--data-table thead th.cds--table-expand,:host(cds-table) tbody td.cds--table-expand,:host(cds-table) thead th.cds--table-expand{block-size:2rem;inline-size:2rem}.cds--data-table--xs tbody td.cds--table-expand,.cds--data-table--xs thead th.cds--table-expand{block-size:1.5rem;inline-size:1.5rem;padding:0 0 0 .5rem}.cds--data-table--sm tbody td.cds--table-expand,.cds--data-table--sm thead th.cds--table-expand{block-size:2rem;inline-size:2rem;padding:0;padding-inline-start:.5rem}.cds--data-table--md tbody td.cds--table-expand,.cds--data-table--md thead th.cds--table-expand{block-size:2.5rem;inline-size:2.5rem;padding:.25rem 0 .25rem .5rem}.cds--data-table--xl tbody td.cds--table-expand,.cds--data-table--xl thead th.cds--table-expand{block-size:4rem;padding-block:.625rem 1.375rem}.cds--data-table--xl .cds--table-column-checkbox{padding-block-start:.8125rem}.cds--data-table--xl .cds--table-column-radio{padding-block-start:1rem}.cds--table-column-radio{inline-size:48px}.cds--table-column-radio .cds--radio-button__appearance{margin-inline-end:-.125rem}.cds--data-table--zebra tbody tr:nth-child(odd).cds--data-table--selected td,tr.cds--data-table--selected td{border-block-end:1px solid var(--cds-layer-active);border-block-start:1px solid var(--cds-layer-selected);color:var(--cds-text-primary,#161616)}.cds--data-table--zebra tbody tr:nth-child(odd).cds--data-table--selected,tr.cds--data-table--selected{background-color:var(--cds-layer-selected)}.cds--data-table--zebra tbody tr:first-of-type:nth-child(odd).cds--data-table--selected td,tr.cds--data-table--selected:first-of-type td{border-block-start:1px solid var(--cds-border-subtle-selected)}.cds--data-table--zebra tbody tr:last-of-type:nth-child(2n).cds--data-table--selected td,.cds--data-table--zebra tbody tr:last-of-type:nth-child(odd).cds--data-table--selected td,tr.cds--data-table--selected:last-of-type td{border-block-end:1px solid var(--cds-layer-selected);border-block-start:1px solid var(--cds-layer-selected)}.cds--data-table--zebra tbody tr:nth-child(2n).cds--data-table--selected td{border-block-end:1px solid var(--cds-layer-active)}.cds--data-table--zebra tbody tr:nth-child(2n).cds--data-table--selected:hover td{border-block-end:1px solid var(--cds-layer-selected-hover)}.cds--data-table tbody .cds--data-table--selected:hover td,.cds--data-table--zebra tbody tr:nth-child(odd).cds--data-table--selected:hover td,:host(cds-table) tbody .cds--data-table--selected:hover td{border-block-end:1px solid var(--cds-layer-selected-hover);border-block-start:1px solid var(--cds-layer-selected-hover);color:var(--cds-text-primary,#161616)}.cds--data-table tbody .cds--data-table--selected:hover,.cds--data-table--zebra tbody tr:nth-child(odd).cds--data-table--selected:hover,:host(cds-table) tbody .cds--data-table--selected:hover{background-color:var(--cds-layer-selected-hover)}.cds--data-table--selected .cds--overflow-menu .cds--overflow-menu__icon{opacity:1}.cds--data-table--xs tbody tr,.cds--data-table--xs tbody tr th,.cds--data-table--xs thead tr{block-size:1.5rem}.cds--data-table--xs .cds--table-header-label,.cds--data-table--xs tbody tr th,.cds--data-table--xs td{padding-block:.125rem .125rem}.cds--data-table--xs .cds--overflow-menu{block-size:calc(100% + 1px);inline-size:2rem}.cds--data-table.cds--data-table--xs:not(.cds--data-table--top-aligned-body) td.cds--table-column-checkbox,.cds--data-table.cds--data-table--xs:not(.cds--data-table--top-aligned-header) th.cds--table-column-checkbox{padding-block:0}.cds--data-table.cds--data-table--xs .cds--table-column-checkbox .cds--checkbox-label{block-size:1.4375rem;min-block-size:1.4375rem}.cds--data-table--sm tbody tr,.cds--data-table--sm tbody tr th,.cds--data-table--sm thead tr{block-size:2rem}.cds--data-table--sm .cds--table-header-label{padding-block:.4375rem .4375rem}.cds--data-table--sm tbody tr th,.cds--data-table--sm td,.cds--data-table--sm.cds--data-table--top-aligned-header th.cds--table-column-checkbox{padding-block:.4375rem .375rem}.cds--data-table.cds--data-table--sm:not(.cds--data-table--top-aligned-body) td.cds--table-column-checkbox,.cds--data-table.cds--data-table--sm:not(.cds--data-table--top-aligned-header) th.cds--table-column-checkbox{padding-block:.1875rem .1875rem}.cds--data-table--sm .cds--overflow-menu{block-size:calc(100% + 1px)}.cds--data-table--md tbody tr,.cds--data-table--md tbody tr th,.cds--data-table--md thead tr{block-size:2.5rem}.cds--data-table--md .cds--table-header-label,.cds--data-table--md.cds--data-table--top-aligned-header th.cds--table-column-checkbox{padding-block:.4375rem .4375rem}.cds--data-table--md tbody tr th,.cds--data-table--md td{padding-block:.4375rem .375rem}.cds--data-table--md .cds--table-column-menu,.cds--data-table.cds--data-table--md:not(.cds--data-table--top-aligned-body) td.cds--table-column-checkbox,.cds--data-table.cds--data-table--md:not(.cds--data-table--top-aligned-header) th.cds--table-column-checkbox{padding-block:.1875rem .1875rem}.cds--data-table--xl tbody tr,.cds--data-table--xl tbody tr th,.cds--data-table--xl thead tr{block-size:4rem}.cds--data-table--xl .cds--table-header-label,.cds--data-table--xl tbody tr th,.cds--data-table--xl td{padding-block:1rem 1rem}.cds--data-table--xl td,.cds--data-table--xl th{vertical-align:top}.cds--data-table--xl .cds--data-table--cell-secondary-text{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--data-table--static{inline-size:auto}.cds--data-table-container--static{inline-size:-moz-fit-content;inline-size:fit-content}.cds--data-table_inner-container{background-color:var(--cds-layer-accent);transform:translateZ(0)}.cds--data-table--sticky-header{display:block;overflow-y:scroll}.cds--data-table--sticky-header tbody,.cds--data-table--sticky-header td,.cds--data-table--sticky-header th,.cds--data-table--sticky-header thead,.cds--data-table--sticky-header tr{display:flex}.cds--data-table--sticky-header thead{inline-size:100%;inset-block-start:0;overflow:scroll;position:sticky;z-index:1;-ms-overflow-style:none;will-change:transform}.cds--data-table--sticky-header thead tr th{border-block-end:1px solid var(--cds-layer-active)}.cds--data-table--sticky-header tbody{flex-direction:column;-ms-overflow-style:none;overflow-x:scroll;will-change:transform}.cds--data-table--sticky-header tr.cds--parent-row.cds--expandable-row{block-size:auto;min-block-size:3rem}.cds--data-table--sticky-header tr.cds--expandable-row:not(.cds--parent-row){block-size:auto}.cds--data-table--sticky-header .cds--table-expand{max-inline-size:3rem}.cds--data-table--sticky-header thead .cds--table-expand{align-items:center}.cds--data-table--sticky-header .cds--parent-row{min-block-size:3rem}.cds--data-table--sticky-header:not(.cds--data-table--xs):not(.cds--data-table--xl):not(.cds--data-table--sm) td:not(.cds--table-column-menu):not(.cds--table-column-checkbox){padding-block-start:.875rem}.cds--data-table--sticky-header tr.cds--parent-row.cds--expandable-row:hover+tr[data-child-row] td{border-block-start:1px solid var(--cds-layer-hover)}.cds--data-table--sticky-header tr.cds--expandable-row:last-of-type{overflow:hidden}.cds--data-table--sticky-header tr.cds--data-table--selected:first-of-type td{border-block-start:none}.cds--data-table--sticky-header tbody tr td.cds--table-column-checkbox,.cds--data-table--sticky-header thead th.cds--table-column-checkbox{align-items:center;inline-size:2.25rem;min-inline-size:2.25rem}.cds--data-table--sticky-header.cds--data-table--xl td.cds--table-column-checkbox,.cds--data-table--sticky-header.cds--data-table--xl thead th.cds--table-column-checkbox{align-items:flex-start}.cds--data-table--sticky-header th.cds--table-column-checkbox~th:last-of-type:empty{max-inline-size:4rem}.cds--data-table--sticky-header th:empty:not(.cds--table-expand){max-inline-size:2.25rem}.cds--data-table--sticky-header td.cds--table-column-menu{align-items:center;block-size:auto;padding-block-start:0}.cds--data-table--sticky-header tbody::-webkit-scrollbar,.cds--data-table--sticky-header thead::-webkit-scrollbar{display:none}@document url-prefix(){.cds--data-table--sticky-header tbody,.cds--data-table--sticky-header thead{scrollbar-width:none}}.cds--data-table--sticky-header tbody tr:last-of-type{border-block-end:0}.cds--data-table--sticky-header td:not(.cds--table-column-checkbox):not(.cds--table-column-menu):not(.cds--table-expand):not(.cds--table-column-icon),.cds--data-table--sticky-header th:not(.cds--table-column-checkbox):not(.cds--table-column-menu):not(.cds--table-expand):not(.cds--table-column-icon){inline-size:100%;min-inline-size:0}.cds--data-table--sticky-header.cds--data-table--sm tr:not(.cds--expandable-row),.cds--data-table--sticky-header.cds--data-table--xl tr:not(.cds--expandable-row),.cds--data-table--sticky-header.cds--data-table--xs tr:not(.cds--expandable-row){block-size:auto}.cds--data-table--sticky-header.cds--data-table--xs tr:not(.cds--expandable-row){min-block-size:1.5rem}.cds--data-table--sticky-header.cds--data-table--sm tr:not(.cds--expandable-row){min-block-size:2rem}.cds--data-table--sticky-header.cds--data-table--xl tr:not(.cds--expandable-row){min-block-size:4rem}.cds--data-table--sticky-header.cds--data-table--xs tr td.cds--table-expand{padding-block-start:.25rem}.cds--data-table--sticky-header.cds--data-table--sm tr td.cds--table-expand{padding-block-start:.5rem}.cds--data-table--sticky-header .cds--table-header-label{display:block;max-inline-size:calc(100% - 10px);overflow-x:hidden;overflow-y:hidden;padding-block:.9375rem 1rem;text-overflow:ellipsis;white-space:nowrap}.cds--data-table--sticky-header.cds--data-table--xs th .cds--table-header-label{padding-block:.1875rem 0}.cds--data-table--sticky-header.cds--data-table--sm th .cds--table-header-label{padding-block:.5rem 0}.cds--data-table--sticky-header.cds--data-table--xl th .cds--table-header-label{padding-block-start:1rem}.cds--data-table--sticky-header.cds--data-table--xl th.cds--table-expand{align-items:flex-start;display:flex}.cds--data-table--sticky-header.cds--data-table--sm tr.cds--parent-row .cds--table-column-checkbox,.cds--data-table--sticky-header.cds--data-table--xs tr.cds--parent-row .cds--table-column-checkbox{align-items:flex-start}.cds--data-table--max-width{max-inline-size:100%}.cds--data-table--sticky-header{max-block-size:18.75rem}.cds--data-table .cds--form-item.cds--checkbox-wrapper:last-of-type,:host(cds-table) .cds--form-item.cds--checkbox-wrapper:last-of-type{margin:0}.cds--data-table--sm .cds--form-item.cds--checkbox-wrapper:last-of-type,.cds--data-table--xs .cds--form-item.cds--checkbox-wrapper:last-of-type{margin:-.1875rem 0}.cds--data-table .cds--table-column-slug,:host(cds-table) .cds--table-column-slug{inline-size:1rem;padding-inline-end:0}tr.cds--data-table--slug-row,tr.cds--data-table--slug-row+.cds--expandable-row{background:linear-gradient(to right,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 50%);background-attachment:fixed}.cds--data-table--slug-row{box-shadow:inset 1px 0 var(--cds-ai-border-strong,#4589ff)}.cds--data-table tbody tr.cds--data-table--slug-row:hover td,:host(cds-table) tbody tr.cds--data-table--slug-row:hover td,tr.cds--data-table--selected.cds--data-table--slug-row.cds--expandable-row+tr.cds--expandable-row[data-child-row]>td,tr.cds--data-table--slug-row.cds--expandable-row--hover+.cds--expandable-row[data-child-row]:hover>td,tr.cds--data-table--slug-row.cds--expandable-row--hover>td,tr.cds--data-table--slug-row.cds--expandable-row:hover+.cds--expandable-row[data-child-row] td,tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected.cds--expandable-row--hover>td,tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected.cds--expandable-row--hover>td:first-of-type,tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td,tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td:first-of-type,tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover+tr[data-child-row]>td,tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected:not(.cds--expandable-row):hover>td{background-color:transparent}.cds--data-table tbody tr.cds--data-table--slug-row:hover,:host(cds-table) tbody tr.cds--data-table--slug-row:hover,tr.cds--data-table--selected.cds--parent-row.cds--expandable-row--hover.cds--data-table--slug-row,tr.cds--data-table--slug-row.cds--expandable-row--hover+.cds--expandable-row[data-child-row]:hover,tr.cds--data-table--slug-row:hover+.cds--expandable-row[data-child-row],tr.cds--expandable-row--hover.cds--data-table--slug-row{background:linear-gradient(to right,var(--cds-ai-aura-hover-start,rgba(69,137,255,.32)) 0,15%,var(--cds-ai-aura-hover-end,hsla(0,0%,100%,0)) 50%),var(--cds-ai-aura-hover-background,#edf5ff);background-attachment:fixed}.cds--data-table--selected.cds--data-table--slug-row,tr.cds--data-table--selected.cds--data-table--slug-row+.cds--expandable-row,tr.cds--parent-row.cds--data-table--selected.cds--data-table--slug-row{background:linear-gradient(to right,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 50%),var(--cds-layer-selected);background-attachment:fixed}tbody tr.cds--data-table--slug-row:hover td,tr.cds--data-table--slug-row.cds--data-table--selected td,tr.cds--data-table--slug-row.cds--data-table--selected:hover td,tr.cds--data-table--slug-row.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td:not(.cds--table-expand):not(.cds--table-column-checkbox):not(.cds--table-column-slug){border-block-end-color:var(--cds-border-subtle)}tr.cds--expandable-row.cds--data-table--selected.cds--data-table--slug-row[data-parent-row]>td:not(.cds--table-expand):not(.cds--table-column-checkbox):not(.cds--table-column-slug){border-block-end:1px solid var(--cds-layer-selected)}tr.cds--parent-row.cds--data-table--slug-row.cds--expandable-row:hover td:first-of-type{border-block-end:1px solid transparent}.cds--data-table thead th.cds--table-sort__header--slug .cds--table-sort,.cds--data-table thead th:has(>.cds--table-header-label--slug),:host(cds-table) thead th.cds--table-sort__header--slug .cds--table-sort,:host(cds-table) thead th:has(>.cds--table-header-label--slug){background:linear-gradient(to right,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 50%)}.cds--table-column-slug .cds--ai-label,.cds--table-column-slug .cds--slug{position:absolute;transform:translateY(-50%);z-index:2}.cds--data-table--xl .cds--table-column-slug .cds--ai-label,.cds--data-table--xl .cds--table-column-slug .cds--slug{transform:translateY(1px)}th .cds--table-header-label.cds--table-header-label--slug{align-items:center;display:flex}th .cds--table-header-label.cds--table-header-label--slug .cds--ai-label,th .cds--table-header-label.cds--table-header-label--slug .cds--slug{margin-inline-start:auto}th.cds--table-sort__header--slug,th:has(.cds--table-header-label--slug){box-shadow:inset 0 1px var(--cds-ai-border-strong,#4589ff)}td.cds--table-cell--column-slug{background:linear-gradient(to right,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 50%)}tr.cds--parent-row:not(.cds--expandable-row):not(:first-of-type) td.cds--table-cell--column-slug{border-block-start:linear-gradient(to right,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 50%)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--data-table-content,tr.cds--parent-row:not(.cds--expandable-row):not(:first-of-type) td.cds--table-cell--column-slug{outline:1px solid transparent}}.cds--link{border:0;box-sizing:border-box;color:var(--cds-link-text-color,var(--cds-link-primary,#0f62fe));display:inline-flex;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:none;padding:0;text-decoration:none;transition:color 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--link *,.cds--link :after,.cds--link :before{box-sizing:inherit}.cds--link:hover{color:var(--cds-link-hover-text-color,var(--cds-link-primary-hover,#0043ce));text-decoration:underline}.cds--link:active,.cds--link:active:visited,.cds--link:active:visited:hover{color:var(--cds-link-text-color,var(--cds-link-primary,#0f62fe));outline:1px solid var(--cds-focus,#0f62fe);outline-color:var(--cds-link-focus-text-color,var(--cds-focus,#0f62fe));text-decoration:underline}@media screen and (prefers-contrast){.cds--link:active,.cds--link:active:visited,.cds--link:active:visited:hover{outline-style:dotted}}.cds--link:focus{outline:1px solid var(--cds-focus,#0f62fe);outline-color:var(--cds-link-focus-text-color,var(--cds-focus,#0f62fe));text-decoration:underline}@media screen and (prefers-contrast){.cds--link:focus{outline-style:dotted}}.cds--link:visited{color:var(--cds-link-text-color,var(--cds-link-primary,#0f62fe))}.cds--link:visited:hover{color:var(--cds-link-hover-text-color,var(--cds-link-primary-hover,#0043ce))}.cds--link--disabled,.cds--link--disabled:hover{border:0;box-sizing:border-box;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;padding:0;text-decoration:none;vertical-align:baseline}.cds--link--disabled *,.cds--link--disabled :after,.cds--link--disabled :before,.cds--link--disabled:hover *,.cds--link--disabled:hover :after,.cds--link--disabled:hover :before{box-sizing:inherit}.cds--link.cds--link--visited:visited{color:var(--cds-link-visited-text-color,var(--cds-link-visited,#8a3ffc))}.cds--link.cds--link--visited:visited:hover{color:var(--cds-link-hover-text-color,var(--cds-link-primary-hover,#0043ce))}.cds--link.cds--link--inline{display:inline;text-decoration:underline}.cds--link--disabled.cds--link--inline{text-decoration:underline}.cds--link--sm,.cds--link--sm.cds--link--disabled:hover{font-size:var(--cds-helper-text-01-font-size,.75rem);letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333)}.cds--link--lg,.cds--link--lg.cds--link--disabled:hover{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375)}.cds--link__icon{align-self:center;display:inline-flex;margin-inline-start:.5rem}.cds--data-table tr.cds--parent-row:first-of-type td,:host(cds-table) tr.cds--parent-row:first-of-type td{border-block-start:1px solid var(--cds-border-subtle)}.cds--expandable-row--hidden td{border-block-start:0;inline-size:auto;padding:1rem}tr.cds--parent-row:not(.cds--expandable-row)+tr[data-child-row]{block-size:0;transition:height .15s cubic-bezier(.2,0,.38,.9)}tr.cds--parent-row:not(.cds--expandable-row)+tr[data-child-row] td{background-color:var(--cds-layer-hover);border:0;padding-block:0;transition:padding .15s cubic-bezier(.2,0,.38,.9),background-color 70ms cubic-bezier(.2,0,.38,.9)}tr.cds--parent-row:not(.cds--expandable-row)+tr[data-child-row] td .cds--child-row-inner-container{max-block-size:0;overflow:hidden}tr.cds--parent-row.cds--expandable-row+tr[data-child-row]{transition:height .15s cubic-bezier(.2,0,.38,.9),background-color 70ms cubic-bezier(.2,0,.38,.9)}tr.cds--parent-row.cds--expandable-row+tr[data-child-row] td{border-block-end:1px solid var(--cds-border-subtle);padding-inline-start:3.5rem;transition:padding-bottom .15s cubic-bezier(.2,0,.38,.9),transform .15s cubic-bezier(.2,0,.38,.9)}tbody:has(>tr.cds--data-table--slug-row)>tr.cds--expandable-row[data-child-row] td,tbody:has(td.cds--table-column-checkbox)>tr.cds--expandable-row[data-child-row] td{padding-inline-start:5.5rem}tbody:has(>tr.cds--data-table--slug-row):has(td.cds--table-column-checkbox)>tr.cds--expandable-row[data-child-row] td{padding-inline-start:7.5rem}tr.cds--parent-row.cds--expandable-row+tr[data-child-row] td .cds--child-row-inner-container{max-block-size:100%;padding-block:1rem;padding-block-end:1.5rem}.cds--parent-row.cds--expandable-row+tr[data-child-row]>td,.cds--parent-row.cds--expandable-row>td{border-block-end:1px solid var(--cds-border-subtle);box-shadow:0 1px var(--cds-border-subtle)}.cds--parent-row.cds--expandable-row>td:first-of-type,.cds--parent-row:not(.cds--expandable-row)+tr[data-child-row]>td{box-shadow:none}tr.cds--parent-row.cds--expandable-row,tr.cds--parent-row.cds--expandable-row td,tr.cds--parent-row:not(.cds--expandable-row) td{transition:height .15s cubic-bezier(.2,0,.38,.9),background-color 70ms cubic-bezier(.2,0,.38,.9),border-color 70ms cubic-bezier(.2,0,.38,.9)}tr.cds--parent-row.cds--expandable-row:hover td,tr.cds--parent-row:not(.cds--expandable-row):first-of-type:hover td{border-block-end:1px solid var(--cds-border-subtle);border-block-start:1px solid var(--cds-border-subtle)}tr.cds--parent-row.cds--expandable-row:hover td{background-color:var(--cds-layer-hover);color:var(--cds-text-primary,#161616)}tr.cds--parent-row.cds--expandable-row:hover td:first-of-type{border-block-end:1px solid var(--cds-layer-hover)}tr.cds--parent-row.cds--expandable-row:hover+tr[data-child-row] td{background-color:var(--cds-layer-hover);border-block-end:1px solid var(--cds-border-subtle);color:var(--cds-text-primary,#161616)}tr.cds--expandable-row--hover+tr[data-child-row] td{border-block-end:1px solid var(--cds-border-subtle)}tr.cds--expandable-row--hover,tr.cds--expandable-row--hover td{background-color:var(--cds-layer-hover)}tr.cds--expandable-row--hover td{border-block-end:1px solid var(--cds-border-subtle);border-block-start:1px solid var(--cds-border-subtle);color:var(--cds-text-primary,#161616)}tr.cds--parent-row.cds--expandable-row.cds--expandable-row--hover td:first-of-type{border-block-end:1px solid transparent}.cds--data-table td.cds--table-expand,:host(cds-table) td.cds--table-expand{border-block-end:1px solid var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--data-table td.cds--table-expand,.cds--layer-two :host(cds-table) td.cds--table-expand{border-block-end:1px solid var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--data-table td.cds--table-expand,.cds--layer-three :host(cds-table) td.cds--table-expand{border-block-end:1px solid var(--cds-border-subtle-03,#c6c6c6)}.cds--data-table td.cds--table-expand+.cds--table-column-checkbox,.cds--data-table th.cds--table-expand+.cds--table-column-checkbox,:host(cds-table) td.cds--table-expand+.cds--table-column-checkbox,:host(cds-table) th.cds--table-expand+.cds--table-column-checkbox{padding-inline:.375rem .375rem}.cds--data-table td.cds--table-expand[data-previous-value=collapsed]+.cds--table-column-checkbox,:host(cds-table) td.cds--table-expand[data-previous-value=collapsed]+.cds--table-column-checkbox{border-block-end:1px solid transparent;box-shadow:none}.cds--data-table td.cds--table-expand+.cds--table-column-checkbox+td,.cds--data-table th.cds--table-expand+.cds--table-column-checkbox+th,:host(cds-table) td.cds--table-expand+.cds--table-column-checkbox+td,:host(cds-table) th.cds--table-expand+.cds--table-column-checkbox+th{padding-inline-start:.5rem}.cds--data-table td.cds--table-expand,.cds--data-table th.cds--table-expand,:host(cds-table) td.cds--table-expand,:host(cds-table) th.cds--table-expand{padding:.5rem;padding-inline-end:0}.cds--data-table td.cds--table-expand[data-previous-value=collapsed],:host(cds-table) td.cds--table-expand[data-previous-value=collapsed]{border-block-end:1px solid transparent}.cds--table-expand[data-previous-value=collapsed] .cds--table-expand__svg{transform:rotate(270deg);transition:transform .15s cubic-bezier(.2,0,.38,.9)}.cds--table-expand__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:calc(100% + 1px);border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;justify-content:center;margin:0;padding:0 .5rem;text-align:start;vertical-align:baseline;vertical-align:inherit}.cds--table-expand__button *,.cds--table-expand__button :after,.cds--table-expand__button :before{box-sizing:inherit}.cds--table-expand__button::-moz-focus-inner{border:0}.cds--data-table--top-aligned-body td .cds--table-expand__button,.cds--data-table--top-aligned-header th .cds--table-expand__button{align-items:start;block-size:2rem;padding-block-start:.5rem}.cds--data-table--top-aligned-body.cds--data-table--xs td .cds--table-expand__button,.cds--data-table--top-aligned-header.cds--data-table--xs th .cds--table-expand__button{block-size:1.5rem;padding-block-start:.25rem}.cds--data-table--top-aligned-body.cds--data-table--md td .cds--table-expand__button,.cds--data-table--top-aligned-header.cds--data-table--md th .cds--table-expand__button{margin-block-start:-.25rem;padding-block-start:.5rem}.cds--table-expand__button:focus{box-shadow:inset 0 0 0 2px var(--cds-focus,#0f62fe);outline:none}.cds--table-expand__svg{fill:var(--cds-layer-selected-inverse,#161616);transform:rotate(90deg);transition:transform .15s cubic-bezier(.2,0,.38,.9)}.cds--data-table--xl .cds--table-expand__button{inline-size:2rem}tr.cds--parent-row.cds--expandable-row td.cds--table-expand+td:after{background-color:var(--cds-layer-accent);block-size:.0625rem;content:"";inline-size:.5rem;inset-block-end:-.0625rem;inset-inline-start:0;position:absolute}tr.cds--parent-row.cds--expandable-row.cds--expandable-row--hover td.cds--table-expand+td:after,tr.cds--parent-row.cds--expandable-row:hover td.cds--table-expand+td:after{background-color:var(--cds-layer-hover)}tr.cds--parent-row.cds--data-table--selected td.cds--table-expand+td:after{display:none}.cds--data-table--zebra tbody tr[data-child-row]:nth-child(4n+4) td,.cds--data-table--zebra tbody tr[data-parent-row]:nth-child(4n+3) td{border-block-end:1px solid var(--cds-layer)}.cds--data-table--zebra tbody tr[data-child-row]:nth-child(4n+2) td,.cds--data-table--zebra tbody tr[data-parent-row]:nth-child(4n+1) td{background-color:var(--cds-layer-accent);border-block-end:1px solid var(--cds-layer-accent);border-block-start:1px solid var(--cds-layer-accent)}.cds--data-table--zebra tr.cds--parent-row td,.cds--data-table--zebra tr.cds--parent-row.cds--expandable-row+tr[data-child-row] td{transition:transform .15s cubic-bezier(.2,0,.38,.9),border-bottom 70ms cubic-bezier(.2,0,.38,.9),border-top 70ms cubic-bezier(.2,0,.38,.9)}.cds--data-table--zebra tbody tr[data-child-row]:hover td,.cds--data-table--zebra tbody tr[data-parent-row]:hover td,.cds--data-table--zebra tbody tr[data-parent-row]:hover+tr[data-child-row] td,.cds--data-table--zebra tr.cds--parent-row.cds--expandable-row.cds--expandable-row--hover td{background-color:var(--cds-layer-hover);border-block-end:1px solid var(--cds-layer-hover);border-block-start:1px solid var(--cds-layer-hover)}tr.cds--parent-row.cds--data-table--selected{background-color:var(--cds-layer-selected)}tr.cds--parent-row.cds--data-table--selected:first-of-type td{border-block-start:1px solid var(--cds-layer-active);box-shadow:0 1px var(--cds-layer-active)}tr.cds--parent-row.cds--data-table--selected td{border-block-end:1px solid var(--cds-layer-active);box-shadow:0 1px var(--cds-layer-active);color:var(--cds-text-primary,#161616)}tr.cds--parent-row.cds--data-table--selected:last-of-type td{border-block-end:1px solid transparent;box-shadow:0 1px var(--cds-border-subtle)}tr.cds--parent-row.cds--data-table--selected:not(.cds--expandable-row):hover td{background-color:var(--cds-layer-selected-hover);border-block-end:1px solid var(--cds-border-subtle);border-block-start:1px solid var(--cds-layer-selected-hover);box-shadow:0 1px var(--cds-layer-selected-hover)}tr.cds--parent-row.cds--data-table--selected.cds--expandable-row td,tr.cds--parent-row.cds--data-table--selected.cds--expandable-row td:first-of-type{border-block-end:1px solid transparent;box-shadow:0 1px var(--cds-layer-selected)}tr.cds--parent-row.cds--data-table--selected.cds--expandable-row--hover td,tr.cds--parent-row.cds--data-table--selected.cds--expandable-row--hover td:first-of-type,tr.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td,tr.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td:first-of-type{background-color:var(--cds-layer-selected-hover);border-block-end:1px solid transparent;border-block-start:1px solid var(--cds-layer-selected-hover);box-shadow:0 1px var(--cds-layer-selected-hover)}tr.cds--parent-row.cds--data-table--selected.cds--expandable-row+tr[data-child-row] td{background-color:var(--cds-layer-hover);border-block-end:1px solid var(--cds-border-subtle);border-block-start:1px solid var(--cds-layer-active);box-shadow:0 1px var(--cds-layer-active);color:var(--cds-text-primary,#161616)}tr.cds--parent-row.cds--data-table--selected.cds--expandable-row+tr[data-child-row]:last-of-type td{box-shadow:inset 0 -1px var(--cds-layer-active);padding-block-end:1.5rem}tr.cds--parent-row.cds--data-table--selected.cds--expandable-row--hover+tr[data-child-row] td,tr.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover+tr[data-child-row] td{background-color:var(--cds-layer-selected)}.cds--parent-row .cds--table-column-slug,.cds--parent-row .cds--table-column-slug+td.cds--table-expand[data-previous-value=collapsed]{box-shadow:none}.cds--parent-row.cds--expandable-row .cds--table-column-slug,.cds--parent-row.cds--expandable-row .cds--table-column-slug+td.cds--table-expand[data-previous-value=collapsed]{border-block-end:1px solid transparent}.cds--data-table tr.cds--data-table--slug-row:hover td,.cds--data-table--slug-row td{border-block-start:1px solid transparent}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--table-expand__button:focus .cds--table-expand__svg{color:Highlight;outline:1px solid Highlight}.cds--table-expand__svg{fill:ButtonText}}.cds--data-table.cds--skeleton th{padding-inline-start:1rem;vertical-align:middle}.cds--data-table.cds--skeleton td span,.cds--data-table.cds--skeleton th span{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;display:block;inline-size:4rem;padding:0;pointer-events:none;position:relative}.cds--data-table.cds--skeleton td span:active,.cds--data-table.cds--skeleton td span:focus,.cds--data-table.cds--skeleton td span:hover,.cds--data-table.cds--skeleton th span:active,.cds--data-table.cds--skeleton th span:focus,.cds--data-table.cds--skeleton th span:hover{border:none;cursor:default;outline:none}.cds--data-table.cds--skeleton td span:before,.cds--data-table.cds--skeleton th span:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--data-table.cds--skeleton td span:before,.cds--data-table.cds--skeleton th span:before{animation:none}}.cds--data-table.cds--skeleton tr:hover td{background:transparent;border-color:var(--cds-border-subtle)}.cds--data-table.cds--skeleton tr:hover td:first-of-type,.cds--data-table.cds--skeleton tr:hover td:last-of-type{border-color:var(--cds-border-subtle)}.cds--data-table.cds--skeleton .cds--table-sort{pointer-events:none}.cds--data-table.cds--skeleton th span{background:var(--cds-skeleton-element,#c6c6c6)}.cds--data-table.cds--skeleton th span:before{background:var(--cds-skeleton-background,#e8e8e8)}.cds--data-table-container.cds--skeleton .cds--data-table-header__title,.cds--data-table-container.cds--skeleton :host(cds-table-header-title){background:var(--cds-skeleton-background,#e8e8e8);block-size:1.5rem;border:none;box-shadow:none;inline-size:7.5rem;padding:0;pointer-events:none;position:relative}.cds--data-table-container.cds--skeleton .cds--data-table-header__title:active,.cds--data-table-container.cds--skeleton .cds--data-table-header__title:focus,.cds--data-table-container.cds--skeleton .cds--data-table-header__title:hover{border:none;cursor:default;outline:none}.cds--data-table-container.cds--skeleton .cds--data-table-header__title:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--data-table-container.cds--skeleton .cds--data-table-header__title:before{animation:none}}.cds--data-table-container.cds--skeleton .cds--data-table-header__description,.cds--data-table-container.cds--skeleton :host(cds-table-header-description){background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;inline-size:10rem;margin-block-start:.5rem;padding:0;pointer-events:none;position:relative}.cds--data-table-container.cds--skeleton .cds--data-table-header__description:active,.cds--data-table-container.cds--skeleton .cds--data-table-header__description:focus,.cds--data-table-container.cds--skeleton .cds--data-table-header__description:hover{border:none;cursor:default;outline:none}.cds--data-table-container.cds--skeleton .cds--data-table-header__description:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--data-table-container.cds--skeleton .cds--data-table-header__description:before{animation:none}}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));background-color:var(--cds-field);block-size:var(--cds-layout-size-height-local);border:none;border-block-end:1px solid var(--cds-border-strong);box-sizing:border-box;color:var(--cds-text-primary,#161616);font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:2px solid transparent;outline-offset:-2px;padding:0;padding:0 var(--cds-layout-density-padding-inline-local);transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--text-input *,.cds--text-input :after,.cds--text-input :before{box-sizing:inherit}.cds--text-input:active,.cds--text-input:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input:active,.cds--text-input:focus{outline-style:dotted}}.cds--text-input-wrapper svg[hidden]{display:none}.cds--password-input{padding-inline-end:2.5rem}.cds--text-input--sm.cds--password-input{padding-inline-end:2rem}.cds--text-input--lg.cds--password-input{padding-inline-end:3rem}.cds--text-input::-moz-placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input::placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input--light{background-color:var(--cds-field-02,#fff)}.cds--text-input__field-wrapper{display:flex;inline-size:100%;position:relative}.cds--text-input__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:1rem;transform:translateY(-50%)}.cds--text-input__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--text-input__invalid-icon--warning path:first-of-type{fill:#000;opacity:1}.cds--text-input--password__visibility{align-items:center;cursor:pointer;display:inline-flex;overflow:visible;position:relative}.cds--text-input--password__visibility:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus{outline-style:dotted}}.cds--text-input--password__visibility:focus{outline:1px solid transparent}.cds--text-input--password__visibility:focus svg{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus svg{outline-style:dotted}}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{align-items:center;display:flex;opacity:0;pointer-events:none;position:absolute;z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{display:inline-block}}.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:opacity 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:none}}.cds--text-input--password__visibility.cds--tooltip--a11y:after,.cds--text-input--password__visibility.cds--tooltip--a11y:before{transition:none}.cds--text-input--password__visibility:before{block-size:0;border-style:solid;content:"";inline-size:0}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text{box-sizing:content-box;color:inherit;opacity:1;white-space:normal;word-break:break-word}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);max-inline-size:13rem;min-inline-size:1.5rem;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-accelerator:true){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{border:1px solid transparent}}.cds--text-input--password__visibility:after{content:attr(aria-label)}.cds--text-input--password__visibility.cds--tooltip--a11y:after{content:none}.cds--text-input--password__visibility.cds--tooltip--visible:after,.cds--text-input--password__visibility.cds--tooltip--visible:before,.cds--text-input--password__visibility:focus:after,.cds--text-input--password__visibility:focus:before,.cds--text-input--password__visibility:hover:after,.cds--text-input--password__visibility:hover:before{opacity:1}@keyframes cds--tooltip-fade{0%{opacity:0}to{opacity:1}}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text{margin:auto;overflow:visible;clip:auto}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible.cds--tooltip--a11y:before,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:focus.cds--tooltip--a11y:before,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text,.cds--text-input--password__visibility:hover.cds--tooltip--a11y:before{animation:cds--tooltip-fade 70ms cubic-bezier(.2,0,.38,.9)}.cds--text-input--password__visibility.cds--tooltip--hidden .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--hidden+.cds--assistive-text{margin:-1px;overflow:hidden;clip:rect(0,0,0,0)}.cds--text-input--password__visibility.cds--tooltip--hidden.cds--tooltip--a11y:before{animation:none;opacity:0}.cds--text-input--password__visibility .cds--assistive-text:after{block-size:.75rem;content:"";display:block;inline-size:100%;inset-block-start:-.75rem;inset-inline-start:0;position:absolute}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{inset-block-end:0;inset-inline-start:50%}.cds--text-input--password__visibility:before{border-color:transparent transparent var(--cds-background-inverse,#393939);border-width:0 .25rem .3125rem;inset-block-end:-.5rem;transform:translate(-50%,100%)}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inset-block-end:-.8125rem;transform:translate(-50%,100%)}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{align-items:center;background:none;block-size:100%;border:0;cursor:pointer;display:flex;inline-size:2.5rem;inset-inline-end:0;justify-content:center;min-block-size:auto;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--toggle-password-tooltip .cds--popover{inset-inline-start:-2.5rem}.cds--toggle-password-tooltip .cds--popover-content{min-inline-size:2.5rem}.cds--text-input--sm+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:2rem}.cds--text-input--lg+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:3rem}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252);transition:fill 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:ButtonText}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline-style:dotted}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus svg,.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-primary,#161616)}.cds--text-input--invalid,.cds--text-input--warning{padding-inline-end:2.5rem}.cds--text-input--invalid.cds--password-input{padding-inline-end:4rem}.cds--text-input--invalid+.cds--text-input--password__visibility__toggle{inset-inline-end:1rem}.cds--password-input-wrapper .cds--text-input__invalid-icon{inset-inline-end:2.5rem}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{cursor:not-allowed}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg:hover{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input__counter-alert{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px}.cds--text-input:disabled{background-color:var(--cds-field);border-block-end:1px solid transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;outline:2px solid transparent;outline-offset:-2px;-webkit-text-fill-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input--light:disabled{background-color:var(--cds-field-02,#fff)}.cds--text-input:disabled::-moz-placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input:disabled::placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input--invalid{box-shadow:none;outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input--invalid{outline-style:dotted}}.cds--text-input--invalid .cds--text-input--password__visibility__toggle{inset-inline-end:2.5rem}.cds--skeleton.cds--text-input{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;padding:0;pointer-events:none;position:relative}.cds--skeleton.cds--text-input:active,.cds--skeleton.cds--text-input:focus,.cds--skeleton.cds--text-input:hover{border:none;cursor:default;outline:none}.cds--skeleton.cds--text-input:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--skeleton.cds--text-input:before{animation:none}}.cds--form--fluid .cds--text-input-wrapper{background:var(--cds-field);position:relative;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--form--fluid .cds--label{align-items:center;block-size:1rem;display:flex;inset-block-start:.8125rem;inset-inline-start:1rem;margin:0;position:absolute;z-index:1}.cds--form--fluid .cds--form__helper-text{display:none}.cds--form--fluid .cds--text-input{min-block-size:4rem;padding:2rem 1rem .8125rem}.cds--form--fluid .cds--text-input__divider,.cds--text-input__divider{display:none}.cds--form--fluid .cds--text-input--invalid,.cds--form--fluid .cds--text-input--warning{border-block-end:none}.cds--form--fluid .cds--text-input--invalid+.cds--text-input__divider,.cds--form--fluid .cds--text-input--warning+.cds--text-input__divider{border-color:var(--cds-border-subtle);border-style:solid;border-block-end:none;display:block;margin:0 1rem}.cds--form--fluid .cds--text-input__invalid-icon{inset-block-start:5rem}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid{outline:none}.cds--form--fluid .cds--text-input__field-wrapper--warning{border-block-end:1px solid var(--cds-border-strong)}.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning:focus,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:focus{outline:none}.cds--text-input-wrapper.cds--text-input-wrapper--inline{flex-flow:row wrap}.cds--text-input-wrapper .cds--label--inline{flex:1;margin:.8125rem 0 0;overflow-wrap:break-word;word-break:break-word}.cds--text-input-wrapper .cds--label--inline--sm{margin-block-start:.5625rem}.cds--text-input-wrapper .cds--label--inline--lg{margin-block-start:1.0625rem}.cds--text-input__label-helper-wrapper{flex:2;flex-direction:column;margin-inline-end:1.5rem;max-inline-size:8rem;overflow-wrap:break-word}.cds--text-input-wrapper .cds--form__helper-text--inline{margin-block-start:.125rem}.cds--text-input__field-outer-wrapper{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;inline-size:100%}.cds--text-input__field-outer-wrapper--inline{flex:8;flex-direction:column}.cds--text-input-wrapper--inline .cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--text-input-wrapper--inline--invalid .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input-wrapper--readonly,.cds--text-input-wrapper--readonly .cds--text-input{background:transparent;border-block-end-color:var(--cds-border-subtle)}.cds--text-input__field-wrapper .cds--ai-label,.cds--text-input__field-wrapper .cds--slug,.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator>*{inset-block-start:50%;inset-inline-end:1rem;position:absolute;transform:translateY(-50%)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label):not(:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug):not(:has(~.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug){padding-inline-end:2.5rem}.cds--text-input--invalid:has(~.cds--ai-label),.cds--text-input--invalid:has(~.cds--slug),.cds--text-input--invalid:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input--warning:has(~.cds--ai-label),.cds--text-input--warning:has(~.cds--slug),.cds--text-input--warning:has(~.cds--text-input__field-inner-wrapper--decorator>*){padding-inline-end:4rem}.cds--text-input--invalid~.cds--ai-label,.cds--text-input--invalid~.cds--slug,.cds--text-input--invalid~.cds--text-input__field-inner-wrapper--decorator>*,.cds--text-input--warning~.cds--ai-label,.cds--text-input--warning~.cds--slug,.cds--text-input--warning~.cds--text-input__field-inner-wrapper--decorator>*{inset-inline-end:2.5rem}.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator:not(:has(.cds--ai-label))>*{block-size:1rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:ButtonText}}.cds--text-input__label-wrapper{display:flex;inline-size:100%;justify-content:space-between}.cds--text-input__label-wrapper .cds--text-input__label-counter{align-self:end}.cds--search{align-items:center;display:flex;inline-size:100%;position:relative}.cds--search .cds--label{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--search-input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--cds-field);border:none;border-block-end:1px solid var(--cds-border-strong);box-sizing:border-box;color:var(--cds-text-primary,#161616);font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;order:1;outline:2px solid transparent;outline-offset:-2px;padding:0 2.5rem;text-overflow:ellipsis;transition:background-color .11s cubic-bezier(.2,0,.38,.9),outline .11s cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--search-input *,.cds--search-input :after,.cds--search-input :before{box-sizing:inherit}.cds--search-input:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--search-input:focus{outline-style:dotted}}.cds--search-input::-moz-placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--search-input::placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--search-input::-ms-clear{display:none}.cds--search-input[disabled]{background-color:var(--cds-field);border-block-end:1px solid transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--search-input[disabled]::-moz-placeholder{color:var(--cds-field)}.cds--search-input[disabled]::placeholder{color:var(--cds-field)}.cds--search--light .cds--search-close:before,.cds--search--light .cds--search-input{background:var(--cds-field-02,#fff)}.cds--search--sm .cds--search-input,.cds--search--sm.cds--search--expandable.cds--search--expanded .cds--search-input{block-size:2rem;padding:0 2rem}.cds--search--sm .cds--search-magnifier-icon{inset-inline-start:.5rem}.cds--search--md .cds--search-input,.cds--search--md.cds--search--expandable.cds--search--expanded .cds--search-input{block-size:2.5rem;padding:0 2.5rem}.cds--search--md .cds--search-magnifier-icon{inset-inline-start:.75rem}.cds--search--lg .cds--search-input,.cds--search--lg.cds--search--expandable.cds--search--expanded .cds--search-input{block-size:3rem;padding:0 3rem}.cds--search-magnifier-icon{block-size:1rem;border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;position:absolute;vertical-align:baseline;z-index:2;fill:var(--cds-icon-secondary,#525252);inline-size:1rem;inset-block-start:50%;inset-inline-start:1rem;pointer-events:none;transform:translateY(-50%)}.cds--search-magnifier-icon *,.cds--search-magnifier-icon :after,.cds--search-magnifier-icon :before{box-sizing:inherit}.cds--search-close{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inset-block-start:0;inset-inline-end:0;margin:0;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;text-align:start;vertical-align:baseline}.cds--search-close *,.cds--search-close :after,.cds--search-close :before{box-sizing:inherit}.cds--search-close::-moz-focus-inner{border:0}.cds--search-close:before{background-color:var(--cds-field);block-size:calc(100% - 2px);content:"";display:block;inline-size:2px;inset-block-start:.0625rem;inset-inline-start:0;position:absolute;transition:background-color .11s cubic-bezier(.2,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--search-close:before{transition:none}}.cds--search-close:hover{border-block-end:1px solid var(--cds-border-strong)}.cds--search-close:hover:before{background-color:var(--cds-field-hover)}.cds--search-button{background-color:var(--cds-field);flex-shrink:0;margin-inline-start:.125rem}.cds--search-button svg{fill:currentColor;vertical-align:middle}.cds--search-close svg{fill:inherit}.cds--search-button,.cds--search-close{align-items:center;block-size:2.5rem;border-color:transparent;border-style:solid;border-width:1px 0;cursor:pointer;display:flex;justify-content:center;fill:var(--cds-icon-primary,#161616);inline-size:2.5rem;opacity:1;transition:opacity .11s cubic-bezier(.2,0,.38,.9),background-color .11s cubic-bezier(.2,0,.38,.9),outline .11s cubic-bezier(.2,0,.38,.9),border .11s cubic-bezier(.2,0,.38,.9);visibility:inherit}.cds--search-button:hover,.cds--search-close:hover{background-color:var(--cds-field-hover)}.cds--search-button:focus,.cds--search-close:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--search-button:focus,.cds--search-close:focus{outline-style:dotted}}.cds--search-button:active,.cds--search-close:active{background-color:var(--cds-background-selected,hsla(0,0%,55%,.2));outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--search-button:active,.cds--search-close:active{outline-style:dotted}}.cds--search--disabled .cds--search-close,.cds--search--disabled.cds--search--expandable .cds--search-magnifier{cursor:not-allowed;outline:none}.cds--search--disabled .cds--search-close:hover,.cds--search--disabled.cds--search--expandable .cds--search-magnifier:hover{background-color:transparent;border-block-end-color:transparent}.cds--search--disabled .cds--search-close:hover:before,.cds--search--disabled.cds--search--expandable .cds--search-magnifier:hover:before{background-color:transparent}.cds--search--disabled svg{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--search-close:active:before,.cds--search-close:focus:before{background-color:var(--cds-focus,#0f62fe)}.cds--search-input:focus~.cds--search-close:hover{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--search-input:focus~.cds--search-close:hover{outline-style:dotted}}.cds--search--sm .cds--search-close,.cds--search--sm.cds--search--expandable,.cds--search--sm.cds--search--expandable .cds--search-magnifier,.cds--search--sm~.cds--search-button{block-size:2rem;inline-size:2rem}.cds--search--sm.cds--search--expandable .cds--search-input::-moz-placeholder{padding:0 2rem}.cds--search--sm.cds--search--expandable .cds--search-input::placeholder{padding:0 2rem}.cds--search--md .cds--search-close,.cds--search--md.cds--search--expandable,.cds--search--md.cds--search--expandable .cds--search-magnifier,.cds--search--md~.cds--search-button{block-size:2.5rem;inline-size:2.5rem}.cds--search--md.cds--search--expandable .cds--search-input::-moz-placeholder{padding:0 2.5rem}.cds--search--md.cds--search--expandable .cds--search-input::placeholder{padding:0 2.5rem}.cds--search--lg .cds--search-close,.cds--search--lg.cds--search--expandable,.cds--search--lg.cds--search--expandable .cds--search-magnifier,.cds--search--lg~.cds--search-button{block-size:3rem;inline-size:3rem}.cds--search--lg.cds--search--expandable .cds--search-input::-moz-placeholder{padding:0 3rem}.cds--search--lg.cds--search--expandable .cds--search-input::placeholder{padding:0 3rem}.cds--search-close--hidden{opacity:0;visibility:hidden}.cds--search--lg.cds--skeleton .cds--search-input,.cds--search--md.cds--skeleton .cds--search-input,.cds--search--sm.cds--skeleton .cds--search-input{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:100%;padding:0;pointer-events:none;position:relative}.cds--search--lg.cds--skeleton .cds--search-input:active,.cds--search--lg.cds--skeleton .cds--search-input:focus,.cds--search--lg.cds--skeleton .cds--search-input:hover,.cds--search--md.cds--skeleton .cds--search-input:active,.cds--search--md.cds--skeleton .cds--search-input:focus,.cds--search--md.cds--skeleton .cds--search-input:hover,.cds--search--sm.cds--skeleton .cds--search-input:active,.cds--search--sm.cds--skeleton .cds--search-input:focus,.cds--search--sm.cds--skeleton .cds--search-input:hover{border:none;cursor:default;outline:none}.cds--search--lg.cds--skeleton .cds--search-input:before,.cds--search--md.cds--skeleton .cds--search-input:before,.cds--search--sm.cds--skeleton .cds--search-input:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--search--lg.cds--skeleton .cds--search-input:before,.cds--search--md.cds--skeleton .cds--search-input:before,.cds--search--sm.cds--skeleton .cds--search-input:before{animation:none}}.cds--search--lg.cds--skeleton .cds--search-input::-moz-placeholder,.cds--search--md.cds--skeleton .cds--search-input::-moz-placeholder,.cds--search--sm.cds--skeleton .cds--search-input::-moz-placeholder{color:transparent}.cds--search--lg.cds--skeleton .cds--search-input::placeholder,.cds--search--md.cds--skeleton .cds--search-input::placeholder,.cds--search--sm.cds--skeleton .cds--search-input::placeholder{color:transparent}.cds--search--expandable{transition:width 70ms cubic-bezier(.2,0,.38,.9)}.cds--search--expandable.cds--search--expanded{inline-size:100%}.cds--search--expandable .cds--search-input{inline-size:0;padding:0;transition:padding 70ms cubic-bezier(.2,0,.38,.9),width 0s linear 70ms}.cds--search--expandable .cds--search-input::-moz-placeholder{opacity:0;position:relative;transition-duration:70ms;-moz-transition-property:padding,opacity;transition-property:padding,opacity;transition-timing-function:cubic-bezier(.2,0,.38,.9)}.cds--search--expandable .cds--search-input::placeholder{opacity:0;position:relative;transition-duration:70ms;transition-property:padding,opacity;transition-timing-function:cubic-bezier(.2,0,.38,.9)}.cds--search--expandable.cds--search--expanded .cds--search-input{inline-size:100%;transition:padding 70ms cubic-bezier(.2,0,.38,.9)}.cds--search--expandable.cds--search--expanded .cds--search-input::-moz-placeholder{opacity:1;padding:0;position:relative}.cds--search--expandable.cds--search--expanded .cds--search-input::placeholder{opacity:1;padding:0;position:relative}.cds--search--expandable .cds--search-magnifier{cursor:pointer;position:absolute}.cds--search--expandable .cds--search-magnifier:focus{outline:2px solid var(--cds-focus,#0f62fe)}.cds--search--expandable .cds--search-magnifier:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--search--expandable.cds--search--expanded .cds--search-magnifier{pointer-events:none}.cds--search--expandable .cds--search-magnifier-icon{fill:var(--cds-icon-primary,#161616)}.cds--search--expandable.cds--search--expanded .cds--search-magnifier-icon{fill:var(--cds-icon-secondary,#525252)}.cds--search--expandable.cds--search--disabled svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--search-close svg,.cds--search-magnifier-icon{fill:ButtonText}}.cds--overflow-menu,.cds--overflow-menu__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2.5rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2.5rem;justify-content:center;margin:0;min-block-size:2.5rem;outline:2px solid transparent;outline-offset:-2px;padding:0;position:relative;text-align:start;transition:outline .11s cubic-bezier(0,0,.38,.9),background-color .11s cubic-bezier(0,0,.38,.9);vertical-align:baseline}.cds--overflow-menu::-moz-focus-inner,.cds--overflow-menu__trigger::-moz-focus-inner{border:0}.cds--overflow-menu *,.cds--overflow-menu :after,.cds--overflow-menu :before,.cds--overflow-menu__trigger *,.cds--overflow-menu__trigger :after,.cds--overflow-menu__trigger :before{box-sizing:inherit}.cds--overflow-menu:focus,.cds--overflow-menu__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--overflow-menu:focus,.cds--overflow-menu__trigger:focus{outline-style:dotted}}.cds--overflow-menu:hover,.cds--overflow-menu__trigger:hover{background-color:var(--cds-layer-hover)}.cds--overflow-menu>:first-child{margin-block-start:0}.cds--overflow-menu--sm{block-size:2rem;inline-size:2rem;min-block-size:2rem}.cds--overflow-menu--lg{block-size:3rem;inline-size:3rem}.cds--overflow-menu__trigger.cds--tooltip--a11y.cds--tooltip__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--overflow-menu__trigger.cds--tooltip--a11y.cds--tooltip__trigger:focus{outline-style:dotted}}.cds--overflow-menu__trigger.cds--tooltip--a11y.cds--tooltip__trigger:focus svg{outline:none}.cds--overflow-menu.cds--overflow-menu--open,.cds--overflow-menu.cds--overflow-menu--open .cds--overflow-menu__trigger{background-color:var(--cds-layer);box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));transition:none}.cds--overflow-menu--light.cds--overflow-menu--open,.cds--overflow-menu--light.cds--overflow-menu--open .cds--overflow-menu__trigger{background-color:var(--cds-layer)}.cds--overflow-menu__icon{block-size:1rem;fill:var(--cds-icon-primary,#161616);inline-size:1rem}.cds--overflow-menu__wrapper{line-height:0}.cds--overflow-menu-options{align-items:flex-start;background-color:var(--cds-layer);border:0;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));box-sizing:border-box;display:none;flex-direction:column;font-family:inherit;font-size:100%;inline-size:10rem;inset-block-start:32px;inset-inline-start:0;list-style:none;margin:0;padding:0;position:absolute;vertical-align:baseline;z-index:6000}.cds--overflow-menu-options *,.cds--overflow-menu-options :after,.cds--overflow-menu-options :before{box-sizing:inherit}.cds--overflow-menu-options:after{background-color:var(--cds-layer);content:"";display:block;position:absolute;transition:background-color .11s cubic-bezier(0,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--overflow-menu-options:after{transition:none}}.cds--overflow-menu-options--light,.cds--overflow-menu-options--light:after,.cds--overflow-menu.cds--overflow-menu--light.cds--overflow-menu--open:hover,.cds--overflow-menu.cds--overflow-menu--open:hover{background-color:var(--cds-layer)}.cds--overflow-menu-options[data-floating-menu-direction=bottom]:not(.cds--breadcrumb-menu-options):after{block-size:.1875rem;inline-size:2.5rem;inset-block-start:-.1875rem;inset-inline-start:0}.cds--overflow-menu-options[data-floating-menu-direction=top]:after{block-size:.5rem;inline-size:2.5rem;inset-block-end:-.5rem;inset-inline-start:0}.cds--overflow-menu-options[data-floating-menu-direction=left]:after{block-size:2.5rem;inline-size:.375rem;inset-block-start:0;inset-inline-end:-.375rem}.cds--overflow-menu-options[data-floating-menu-direction=right]:after{block-size:2.5rem;inline-size:.375rem;inset-block-start:0;inset-inline-start:-.375rem}.cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=bottom]:after,.cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=top]:after{inline-size:2rem}.cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=left]:after,.cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=right]:after{block-size:2rem}.cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=bottom]:after,.cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=top]:after{inline-size:3rem}.cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=left]:after,.cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=right]:after{block-size:3rem}.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=bottom]:after,.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=top]:after{inset-inline:auto 0}.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=left]:after,.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=right]:after{inset-block:auto 0}.cds--overflow-menu-options--open{display:flex}.cds--overflow-menu-options__content{inline-size:100%}.cds--overflow-menu-options__option{align-items:center;background-color:transparent;block-size:2.5rem;border:0;box-sizing:border-box;display:flex;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;transition:background-color .11s cubic-bezier(0,0,.38,.9);vertical-align:baseline}.cds--overflow-menu-options__option *,.cds--overflow-menu-options__option :after,.cds--overflow-menu-options__option :before{box-sizing:inherit}.cds--overflow-menu-options--sm .cds--overflow-menu-options__option{block-size:2rem}.cds--overflow-menu-options--lg .cds--overflow-menu-options__option{block-size:3rem}.cds--overflow-menu--divider,.cds--overflow-menu--light .cds--overflow-menu--divider{border-block-start:1px solid var(--cds-border-subtle)}a.cds--overflow-menu-options__btn:before{block-size:100%;content:"";display:inline-block;vertical-align:middle}.cds--overflow-menu-options__btn{align-items:center;background-color:transparent;block-size:100%;border:none;color:var(--cds-text-secondary,#525252);cursor:pointer;display:inline-flex;font-family:inherit;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);font-weight:400;inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);max-inline-size:11.25rem;outline:2px solid transparent;outline-offset:-2px;padding:0 1rem;text-align:start;transition:outline .11s cubic-bezier(0,0,.38,.9),background-color .11s cubic-bezier(0,0,.38,.9),color .11s cubic-bezier(0,0,.38,.9)}.cds--overflow-menu-options__btn:hover{color:var(--cds-text-primary,#161616)}.cds--overflow-menu-options__btn:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--overflow-menu-options__btn:focus{outline-style:dotted}}.cds--overflow-menu-options__btn::-moz-focus-inner{border:none}.cds--overflow-menu-options__btn svg{fill:var(--cds-icon-secondary,#525252)}.cds--overflow-menu-options__btn:hover svg{fill:var(--cds-icon-primary,#161616)}.cds--overflow-menu-options__option-content{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cds--overflow-menu-options__option:hover{background-color:var(--cds-layer-hover)}.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:focus,.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:hover{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:focus svg,.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:hover svg{fill:currentColor}.cds--overflow-menu-options__option--disabled:hover{background-color:var(--cds-layer);cursor:not-allowed}.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn:active,.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn:focus,.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn:hover{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:2px solid transparent;outline-offset:-2px}.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--overflow-menu--flip{inset-inline-start:-140px}.cds--overflow-menu--flip:before{inset-inline-start:145px}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--overflow-menu-options__btn:focus,.cds--overflow-menu:focus{color:Highlight;outline:1px solid Highlight}.cds--overflow-menu svg{fill:ButtonText}}.cds--overflow-menu__top-end,.cds--overflow-menu__top-start{transform:translateY(calc(-100% - var(--cds-popover-offset, 2.5rem)))}.cds--table-toolbar,:host(cds-table-toolbar){background-color:var(--cds-layer);display:flex;inline-size:100%;min-block-size:3rem;position:relative;z-index:1}.cds--toolbar-content,:host(cds-table-toolbar-content){block-size:3rem;display:flex;inline-size:100%;justify-content:flex-end;transform:translateZ(0);transition:transform .11s cubic-bezier(.2,0,.38,.9),clip-path .11s cubic-bezier(.2,0,.38,.9)}.cds--toolbar-content .cds--search .cds--search-input,:host(cds-table-toolbar-content) .cds--search .cds--search-input{background-color:transparent;block-size:3rem;padding:0 3rem}.cds--toolbar-content .cds--overflow-menu,:host(cds-table-toolbar-content) .cds--overflow-menu{block-size:3rem;inline-size:3rem}.cds--batch-actions~.cds--toolbar-search-container,:host(cds-table-batch-actions)~.cds--toolbar-search-container{align-items:center;display:flex;opacity:1;transition:opacity .11s}.cds--toolbar-search-container-expandable,:host(cds-table-toolbar-search){block-size:3rem;box-shadow:none;cursor:pointer;inline-size:3rem;position:relative;transition:width .3s cubic-bezier(.5,0,.1,1),background-color .11s cubic-bezier(0,0,.38,.9)}.cds--toolbar-search-container-expandable:hover{background-color:var(--cds-field-hover)}.cds--search.cds--toolbar-search-container-expandable{inline-size:3rem}.cds--toolbar-search-container-expandable .cds--search-input,:host(cds-table-toolbar-search) .cds--search-input{block-size:100%;cursor:pointer;opacity:0}.cds--toolbar-search-container-expandable:not(.cds--toolbar-search-container-active) .cds--search-input,:not(.cds--toolbar-search-container-active):host(cds-table-toolbar-search) .cds--search-input{padding:0}.cds--toolbar-search-container-disabled .cds--search-input{cursor:not-allowed}.cds--toolbar-search-container-expandable.cds--search .cds--label{visibility:hidden}.cds--toolbar-search-container-expandable.cds--search .cds--search-close{block-size:3rem;inline-size:3rem}.cds--toolbar-search-container-expandable.cds--search .cds--search-close:before{background-color:var(--cds-field-hover);block-size:calc(100% - .25rem);inset-block-start:.125rem}.cds--toolbar-search-container-expandable.cds--search .cds--search-close:focus:before{background-color:var(--cds-focus,#0f62fe)}.cds--table-toolbar .cds--search--lg .cds--search-magnifier-icon,:host(cds-table-toolbar) .cds--search--lg .cds--search-magnifier-icon{inset-inline-start:0}.cds--table-toolbar:not(.cds--table-toolbar--sm) .cds--toolbar-search-container-persistent.cds--search--lg .cds--search-magnifier-icon,:not(.cds--table-toolbar--sm):host(cds-table-toolbar) .cds--toolbar-search-container-persistent.cds--search--lg .cds--search-magnifier-icon{inset-inline-start:1rem}.cds--table-toolbar.cds--table-toolbar--sm .cds--search--sm:not(.cds--toolbar-search-container-active):not(.cds--toolbar-search-container-persistent) .cds--search-magnifier-icon{inset-inline-start:0}.cds--table-toolbar.cds--table-toolbar--sm .cds--search--sm.cds--toolbar-search-container-active .cds--search-magnifier-icon{inset-inline-start:.5rem}.cds--table-toolbar .cds--toolbar-search-container-persistent.cds--search--sm .cds--search-magnifier-icon,:host(cds-table-toolbar) .cds--toolbar-search-container-persistent.cds--search--sm .cds--search-magnifier-icon{inset-inline-start:.5rem}.cds--toolbar-search-container-expandable .cds--search-magnifier-icon,:host(cds-table-toolbar-search) .cds--search-magnifier-icon{block-size:3rem;inline-size:3rem;padding:1rem}.cds--toolbar-search-container-expandable.cds--search--disabled .cds--search-magnifier-icon{background-color:var(--cds-layer);cursor:not-allowed;transition:background-color none}.cds--toolbar-search-container-active .cds--search-magnifier-icon:active,.cds--toolbar-search-container-active .cds--search-magnifier-icon:focus,.cds--toolbar-search-container-active .cds--search-magnifier-icon:hover,:host(cds-table-toolbar-search[expanded]) .cds--search-magnifier-icon:active,:host(cds-table-toolbar-search[expanded]) .cds--search-magnifier-icon:focus,:host(cds-table-toolbar-search[expanded]) .cds--search-magnifier-icon:hover{background-color:transparent;border:none;outline:none}.cds--toolbar-search-container-active.cds--search{inline-size:100%}.cds--toolbar-search-container-active .cds--search-input,:host(cds-table-toolbar-search[expanded]) .cds--search-input{opacity:1}.cds--toolbar-search-container-active .cds--label,.cds--toolbar-search-container-active .cds--search-input,:host(cds-table-toolbar-search[expanded]) .cds--label,:host(cds-table-toolbar-search[expanded]) .cds--search-input{cursor:text;padding:0 3rem}.cds--toolbar-search-container-active .cds--search-input:focus+.cds--search-close,:host(cds-table-toolbar-search[expanded]) .cds--search-input:focus+.cds--search-close{border:none;box-shadow:none;outline:none}.cds--toolbar-search-container-active .cds--search-input:not(:-moz-placeholder-shown),:host(cds-table-toolbar-search[expanded]) .cds--search-input:not(:-moz-placeholder-shown){background-color:var(--cds-field-hover);border:none}.cds--toolbar-search-container-active .cds--search-input:not(:placeholder-shown),:host(cds-table-toolbar-search[expanded]) .cds--search-input:not(:placeholder-shown){background-color:var(--cds-field-hover);border:none}.cds--toolbar-search-container-active .cds--search-close,.cds--toolbar-search-container-active .cds--search-close:hover,.cds--toolbar-search-container-persistent .cds--search-close,.cds--toolbar-search-container-persistent .cds--search-close:hover,:host(cds-table-toolbar-search[expanded]) .cds--search-close{background-color:transparent;border:none}.cds--toolbar-search-container-persistent .cds--search-close:before{display:none}.cds--overflow-menu.cds--toolbar-action{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:3rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:3rem;margin:0;padding:1rem;text-align:start;transition:background .11s cubic-bezier(0,0,.38,.9);vertical-align:baseline}.cds--overflow-menu.cds--toolbar-action *,.cds--overflow-menu.cds--toolbar-action :after,.cds--overflow-menu.cds--toolbar-action :before{box-sizing:inherit}.cds--overflow-menu.cds--toolbar-action::-moz-focus-inner{border:0}.cds--toolbar-action,:host(cds-table-toolbar-search){-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:3rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:3rem;margin:0;padding:0;text-align:start;transition:background .11s cubic-bezier(0,0,.38,.9);vertical-align:baseline}.cds--toolbar-action *,.cds--toolbar-action :after,.cds--toolbar-action :before,:host(cds-table-toolbar-search) *,:host(cds-table-toolbar-search) :after,:host(cds-table-toolbar-search) :before{box-sizing:inherit}.cds--toolbar-action::-moz-focus-inner{border:0}.cds--toolbar-action:hover:not([disabled]){background-color:var(--cds-field-hover)}.cds--toolbar-action:hover[aria-expanded=true],.cds--toolbar-action[aria-expanded=true]{background-color:var(--cds-layer-02,#fff)}.cds--toolbar-action[disabled]{cursor:not-allowed}.cds--toolbar-action[disabled] .cds--toolbar-action__icon{cursor:not-allowed;fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--toolbar-action:active:not([disabled]),.cds--toolbar-action:focus:not([disabled]){outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--toolbar-action:active:not([disabled]),.cds--toolbar-action:focus:not([disabled]){outline-style:dotted}}.cds--toolbar-action:active:not([disabled]).cds--toolbar-search-container-expandable,.cds--toolbar-action:focus:not([disabled]).cds--toolbar-search-container-expandable{outline:none}.cds--toolbar-action~.cds--btn,:host(cds-table-toolbar-search)~.cds--btn{margin:0;max-inline-size:none;white-space:nowrap}.cds--overflow-menu--data-table{block-size:3rem}.cds--toolbar-action__icon{block-size:1rem;fill:var(--cds-icon-primary,#161616);inline-size:auto;max-inline-size:1rem}.cds--toolbar-action__menu,.cds--toolbar-action__menu.cds--overflow-menu-options:after{background-color:var(--cds-layer-02,#fff)}.cds--toolbar-search-container-persistent{block-size:3rem;inline-size:100%;opacity:1;position:relative}.cds--toolbar-search-container-persistent+.cds--toolbar-content,.cds--toolbar-search-container-persistent+:host(cds-table-toolbar-content){inline-size:auto;position:relative}.cds--toolbar-search-container-persistent .cds--search{position:static}.cds--toolbar-search-container-persistent .cds--search-magnifier-icon{inset-inline-start:1rem}.cds--toolbar-search-container-persistent .cds--search-input{block-size:3rem;border:none;padding:0 3rem}.cds--toolbar-search-container-persistent .cds--search-input:focus:not([disabled]){outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--toolbar-search-container-persistent .cds--search-input:focus:not([disabled]){outline-style:dotted}}.cds--toolbar-search-container-persistent .cds--search-input:hover:not([disabled]){background-color:var(--cds-field-hover)}.cds--toolbar-search-container-persistent .cds--search-input:not(:-moz-placeholder-shown){background-color:var(--cds-field-hover)}.cds--toolbar-search-container-persistent .cds--search-input:active:not([disabled]),.cds--toolbar-search-container-persistent .cds--search-input:not(:placeholder-shown){background-color:var(--cds-field-hover)}.cds--toolbar-search-container-persistent .cds--search-close{block-size:3rem;inline-size:3rem}.cds--batch-actions--active~.cds--toolbar-content,.cds--batch-actions--active~.cds--toolbar-search-container,.cds--batch-actions--active~:host(cds-table-toolbar-content),:host(cds-table-batch-actions[active])~.cds--toolbar-content,:host(cds-table-batch-actions[active])~.cds--toolbar-search-container,:host(cds-table-batch-actions[active])~:host(cds-table-toolbar-content){clip-path:polygon(0 0,100% 0,100% 0,0 0);transform:translate3d(0,48px,0);transition:transform .11s cubic-bezier(.2,0,.38,.9),clip-path .11s cubic-bezier(.2,0,.38,.9)}.cds--batch-actions,:host(cds-table-batch-actions){align-items:center;background-color:var(--cds-background-brand,#0f62fe);clip-path:polygon(0 0,100% 0,100% 0,0 0);display:flex;inset-block-end:0;inset-inline:0;justify-content:space-between;opacity:0;pointer-events:none;position:absolute;transform:translate3d(0,48px,0);transition:transform .11s cubic-bezier(.2,0,.38,.9),clip-path .11s cubic-bezier(.2,0,.38,.9),opacity .11s cubic-bezier(.2,0,.38,.9);will-change:transform}.cds--batch-actions:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--batch-actions:focus{outline-style:dotted}}.cds--batch-actions--active,:host(cds-table-batch-actions[active]){clip-path:polygon(0 0,300% 0,300% 300%,0 300%);opacity:1;pointer-events:all;transform:translateZ(0);z-index:1}.cds--action-list{align-items:center;display:flex}.cds--action-list .cds--btn,.cds--batch-summary .cds--btn{color:var(--cds-text-on-color,#fff);padding-inline:1rem 1rem;white-space:nowrap}.cds--action-list .cds--btn:disabled{background-color:transparent;border-color:transparent;color:var(--cds-text-on-color,#fff);opacity:.5}.cds--action-list .cds--btn .cds--btn__icon{position:static;fill:var(--cds-icon-on-color,#fff);margin-inline-start:.5rem}.cds--action-list .cds--btn .cds--btn__icon .st0{fill:none}.cds--batch-download{padding:.0625rem}.cds--action-list .cds--btn--primary:after,.cds--action-list .cds--btn--primary:before,.cds--action-list .cds--btn--primary:focus:after,.cds--action-list .cds--btn--primary:focus:before{display:none}.cds--action-list .cds--btn--primary:focus,.cds--batch-summary .cds--btn--primary:focus{outline:2px solid var(--cds-layer);outline-offset:-.125rem}.cds--action-list .cds--btn--primary:nth-child(3):focus+.cds--btn--primary.cds--batch-summary__cancel:before,.cds--action-list .cds--btn--primary:nth-child(3):hover+.cds--btn--primary.cds--batch-summary__cancel:before{opacity:0}.cds--btn--primary.cds--batch-summary__cancel:before{background-color:var(--cds-text-on-color,#fff);block-size:1rem;border:none;content:"";display:block;inline-size:.0625rem;inset-block-start:.9375rem;inset-inline-start:0;opacity:1;position:absolute;transition:opacity .11s cubic-bezier(.2,0,.38,.9)}.cds--btn--primary.cds--batch-summary__cancel:hover:before{opacity:0;transition:opacity .25s cubic-bezier(.5,0,.1,1)}.cds--batch-summary{align-items:center;background-color:var(--cds-background-brand,#0f62fe);color:var(--cds-text-on-color,#fff);display:flex;inset-inline-start:0;min-block-size:3rem;padding:0 1rem;position:sticky;z-index:100000}.cds--batch-summary__scroll{box-shadow:.5px 0 .2px var(--cds-link-primary-hover,#0043ce)}.cds--batch-summary__para{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--batch-summary__divider{padding-inline-start:.5rem}.cds--table-toolbar--sm{block-size:2rem;min-block-size:2rem}.cds--table-toolbar--sm .cds--toolbar-search-container-expandable,.cds--table-toolbar--sm .cds--toolbar-search-container-persistent,.cds--table-toolbar--sm :host(cds-table-toolbar-search){block-size:2rem}.cds--table-toolbar--sm .cds--toolbar-search-container-expandable .cds--search-input,.cds--table-toolbar--sm .cds--toolbar-search-container-persistent .cds--search-input,.cds--table-toolbar--sm :host(cds-table-toolbar-search) .cds--search-input{block-size:2rem}.cds--table-toolbar--sm .cds--toolbar-search-container-expandable .cds--search-close,.cds--table-toolbar--sm .cds--toolbar-search-container-persistent .cds--search-close,.cds--table-toolbar--sm :host(cds-table-toolbar-search) .cds--search-close{block-size:2rem;inline-size:2rem}.cds--table-toolbar--sm .cds--toolbar-search-container-expandable .cds--search-magnifier-icon,.cds--table-toolbar--sm .cds--toolbar-search-container-persistent .cds--search-magnifier-icon,.cds--table-toolbar--sm :host(cds-table-toolbar-search) .cds--search-magnifier-icon{block-size:2rem;inline-size:2rem;padding:.5rem}.cds--table-toolbar--sm .cds--toolbar-action.cds--toolbar-search-container-persistent{inline-size:100%}.cds--table-toolbar--sm .cds--toolbar-search-container-expandable,.cds--table-toolbar--sm :host(cds-table-toolbar-search){inline-size:2rem}.cds--table-toolbar--sm .cds--toolbar-search-container-expandable .cds--search .cds--search-input,.cds--table-toolbar--sm :host(cds-table-toolbar-search) .cds--search .cds--search-input{padding:0 3rem}.cds--table-toolbar--sm .cds--toolbar-search-container-active,.cds--table-toolbar--sm :host(cds-table-toolbar-search[expanded]){flex:auto;transition:flex 175ms cubic-bezier(.5,0,.1,1)}.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input,.cds--table-toolbar--sm :host(cds-table-toolbar-search[expanded]) .cds--search-input{visibility:inherit}.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:focus,.cds--table-toolbar--sm :host(cds-table-toolbar-search[expanded]) .cds--search-input:focus{background-color:var(--cds-field-hover);outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:focus,.cds--table-toolbar--sm :host(cds-table-toolbar-search[expanded]) .cds--search-input:focus{outline-style:dotted}}.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:not(:-moz-placeholder-shown),.cds--table-toolbar--sm :host(cds-table-toolbar-search[expanded]) .cds--search-input:not(:-moz-placeholder-shown){background-color:var(--cds-field-hover)}.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:active,.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:not(:placeholder-shown),.cds--table-toolbar--sm :host(cds-table-toolbar-search[expanded]) .cds--search-input:active,.cds--table-toolbar--sm :host(cds-table-toolbar-search[expanded]) .cds--search-input:not(:placeholder-shown){background-color:var(--cds-field-hover)}.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-magnifier-icon:active,.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-magnifier-icon:focus,.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-magnifier-icon:hover,.cds--table-toolbar--sm :host(cds-table-toolbar-search[expanded]) .cds--search-magnifier-icon:active,.cds--table-toolbar--sm :host(cds-table-toolbar-search[expanded]) .cds--search-magnifier-icon:focus,.cds--table-toolbar--sm :host(cds-table-toolbar-search[expanded]) .cds--search-magnifier-icon:hover{background-color:transparent;outline:2px solid transparent;outline-offset:-2px}.cds--table-toolbar--sm .cds--overflow-menu.cds--toolbar-action{block-size:2rem;inline-size:2rem;min-inline-size:2rem}.cds--table-toolbar--sm .cds--toolbar-content,.cds--table-toolbar--sm :host(cds-table-toolbar-content){block-size:2rem}.cds--table-toolbar--sm .cds--toolbar-content .cds--overflow-menu,.cds--table-toolbar--sm :host(cds-table-toolbar-content) .cds--overflow-menu{block-size:2rem;inline-size:2rem}.cds--search--disabled .cds--search-magnifier-icon:hover{background-color:transparent}.cds--table-toolbar--sm .cds--batch-actions .cds--action-list,.cds--table-toolbar--sm :host(cds-table-batch-actions) .cds--action-list{block-size:2rem}.cds--table-toolbar--sm .cds--toolbar-action,.cds--table-toolbar--sm :host(cds-table-toolbar-search){block-size:2rem;inline-size:2rem;padding:.5rem 0}.cds--table-toolbar--sm .cds--btn--primary{block-size:2rem;min-block-size:auto;padding-block:.375rem}.cds--table-toolbar--sm .cds--btn--primary.cds--batch-summary__cancel:before{inset-block-start:.5rem}.cds--table-toolbar--sm .cds--toolbar-action~.cds--btn,.cds--table-toolbar--sm :host(cds-table-toolbar-search)~.cds--btn{block-size:2rem;overflow:hidden}.cds--table-toolbar--sm .cds--batch-summary{min-block-size:2rem}:host(cds-table-toolbar){z-index:1}:host(cds-table-toolbar-content){clip-path:polygon(0 0,100% 0,100% 100%,0 100%)}:host(cds-table-toolbar-content) ::slotted(cds-overflow-menu){block-size:3rem;cursor:pointer;display:flex;inline-size:3rem;transition:background-color .11s cubic-bezier(0,0,.38,.9)}:host(cds-table-toolbar-content[has-batch-actions]){clip-path:polygon(0 0,100% 0,100% 0,0 0);transform:translate3d(0,3rem,0);transition:transform .11s cubic-bezier(.2,0,.38,.9),clip-path .11s cubic-bezier(.2,0,.38,.9)}:host(cds-table-toolbar-search){flex:none;transition:flex 175ms cubic-bezier(.5,0,.1,1)}:host(cds-table-toolbar-search):hover{background-color:var(--cds-field-hover)}:host(cds-table-toolbar-search) .cds--search{block-size:100%;inline-size:100%}:host(cds-table-toolbar-search) .cds--search .cds--search-magnifier{cursor:pointer;inset-inline-start:0;pointer-events:all;transition:background .11s cubic-bezier(0,0,.38,.9)}:host(cds-table-toolbar-search) .cds--search .cds--search-magnifier-icon{block-size:auto;inline-size:auto}:host(cds-table-toolbar-search) .cds--search .cds--search-input{border-block-end:0}:host(cds-table-toolbar-search) .cds--search .cds--search-close:before{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12));inline-size:0}:host(cds-table-toolbar-search) .cds--search .cds--search-close :hover{background-color:none}:host(cds-table-toolbar-search) .cds--search :hover{background-color:none}:host(cds-table-toolbar-search) svg{inset-inline-start:0}:host(cds-table-toolbar-search[size=sm]) svg,:host(cds-table-toolbar-search[size=xs]) svg{inset-inline-start:.5rem;padding:0}:host(cds-table-toolbar-search[expanded]){flex:auto}:host(cds-table-toolbar-search[size=sm][expanded]) svg,:host(cds-table-toolbar-search[size=xs][expanded]) svg{inset-inline-start:1rem}:host(cds-table-toolbar-search[persistent]:hover) .cds--search-input{background-color:var(--cds-field-hover)}:host(cds-table-batch-actions){box-sizing:border-box}:host(cds-table){display:table}:host(cds-table) ::slotted(cds-table-head){background-color:var(--cds-layer-accent-01,#e0e0e0);display:table-header-group;font-size:var(--cds-heading-01-font-size,.875rem);font-weight:var(--cds-heading-01-font-weight,600);letter-spacing:var(--cds-heading-01-letter-spacing,.16px);line-height:var(--cds-heading-01-line-height,1.42857)}:host(cds-table) ::slotted(cds-table-body){background-color:var(--cds-layer-01,#f4f4f4);display:table-row-group;font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);line-height:var(--cds-body-short-01-line-height,1.28572)}:host(cds-table[use-static-width]){inline-size:auto}:host(cds-table[sticky-header]) ::slotted(cds-table-body),:host(cds-table[sticky-header]) ::slotted(cds-table-head){display:flex;flex-direction:column;will-change:transform}:host(cds-table[sticky-header]) .cds--data-table-content{display:block;overflow-y:scroll}:host(cds-table[with-header]) .cds--data-table-header-container{display:table-caption}.cds--data-table-header-container{display:table-caption}:host(cds-table-head[sticky-header]){inline-size:100%;inset-block-start:0;position:sticky;will-change:transform;z-index:1}:host(cds-table-head[sticky-header]) ::slotted(cds-table-header-row){display:flex;inline-size:100%}:host(cds-table-header-cell[sort-direction]){block-size:3rem}:host(cds-table-header-cell[sort-direction]) .cds--table-sort__flex{align-items:center;block-size:100%;display:flex;inline-size:100%;justify-content:space-between}:host(cds-table-header-cell[ai-label]),:host(cds-table-header-cell[ai-label]) .cds--table-sort{background:linear-gradient(to right,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 50%);box-shadow:inset 0 1px var(--cds-ai-border-strong,#4589ff)}:host(cds-table-header-cell[ai-label]) .cds--table-sort{background:none}:host(cds-table-header-cell[sticky-header]){border-block-end:1px solid var(--cds-layer-active);inline-size:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host(cds-table-header-cell[sticky-header]:not([is-sortable])){padding-block-start:.875rem}:host(cds-table-header-cell[ai-label]:not([is-sortable])) .cds--table-header-label--slug{align-items:center;display:flex}:host(cds-table-header-cell[ai-label]:not([is-sortable])) ::slotted(cds-ai-label),:host(cds-table-header-cell[ai-label]:not([is-sortable])) ::slotted(cds-slug){margin-inline-start:auto}:host(cds-table-expand-row) .cds--table-column-checkbox,:host(cds-table-expand-row) .cds--table-expand,:host(cds-table-expand-row) ::slotted(cds-table-cell),:host(cds-table-expand-row) ::slotted(cds-table-cell-skeleton),:host(cds-table-header-expand-row) .cds--table-column-checkbox,:host(cds-table-header-expand-row) .cds--table-expand,:host(cds-table-header-expand-row) ::slotted(cds-table-header-cell),:host(cds-table-header-row) .cds--table-column-checkbox,:host(cds-table-header-row) ::slotted(cds-table-header-cell),:host(cds-table-row) .cds--table-column-checkbox,:host(cds-table-row) ::slotted(cds-table-cell),:host(cds-table-row) ::slotted(cds-table-cell-skeleton){display:table-cell}:host(cds-table-head) ::slotted(cds-table-header-expand-row),:host(cds-table-head) ::slotted(cds-table-header-row){block-size:3rem;display:table-row}:host(cds-table-header-row){outline:none}:host(cds-table-header-row) ::slotted(cds-table-header-cell),:host(cds-table-header-row) ::slotted(cds-table-header-cell-skeleton){background-color:var(--cds-layer-accent-01,#e0e0e0);color:var(--cds-text-primary,#161616);display:table-cell;outline:none;text-align:start}:host(cds-table-header-row) .cds--table-column-checkbox,:host(cds-table-header-row) .cds--table-expand,:host(cds-table-header-row) ::slotted(cds-table-header-cell){padding-inline:1rem;text-align:start;vertical-align:middle}:host(cds-table-header-row) ::slotted(cds-table-header-cell-skeleton:first-of-type),:host(cds-table-header-row) ::slotted(cds-table-header-cell:first-of-type){padding-inline-start:1rem}:host(cds-table-header-row:not([batch-expansion])) .cds--table-expand__button{display:none}:host(cds-table-header-row[selection-name]) .cds--table-expand{display:table-cell}:host(cds-table-header-row[sticky-header]) cds-checkbox{border-block-end:1px solid var(--cds-layer-active);margin:0;padding-block-start:.75rem}:host(cds-table-header-row[expandable]) .cds--table-expand,:host(cds-table-header-row[selection-name]) .cds--table-expand,:host(cds-table-row[expandable]) .cds--table-expand,:host(cds-table-row[selection-name]) .cds--table-expand{block-size:2rem;inline-size:2rem;padding:.5rem;padding-inline-end:0}:host(cds-table-header-row[expanded]),:host(cds-table-row[expanded]){transition:transform .15s cubic-bezier(.2,0,.38,.9)}:host(cds-table-header-row[expanded]) .cds--table-expand__svg,:host(cds-table-row[expanded]) .cds--table-expand__svg{transform:rotate(270deg)}:host(cds-table-header-row) .cds--table-column-checkbox div,:host(cds-table-header-row) .cds--table-expand div,:host(cds-table-row) .cds--table-column-checkbox div,:host(cds-table-row) .cds--table-expand div{align-items:center;block-size:100%;display:flex}:host(cds-table-body) ::slotted(cds-table-expand-row),:host(cds-table-body) ::slotted(cds-table-row){block-size:3rem;border:none;display:table-row;inline-size:100%;outline:none}:host(cds-table-body[sticky-header]) ::slotted(cds-table-expand-row),:host(cds-table-body[sticky-header]) ::slotted(cds-table-row){display:flex}:host(cds-table-cell){border-block-end:1px solid var(--cds-border-subtle);padding:0 1rem}:host(cds-table-cell) ::slotted(cds-overflow-menu:hover){background-color:none}:host(cds-table-cell[overflow-menu-on-hover]) ::slotted(*){opacity:0}:host(cds-table-cell[slug-in-header]){background:linear-gradient(to right,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 50%)}:host(cds-table-cell-content){display:block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}:host(cds-table-expand-row[sticky-header]) ::slotted(cds-table-cell),:host(cds-table-expand-row[sticky-header]) ::slotted(cds-table-cell-skeleton),:host(cds-table-row[sticky-header]) ::slotted(cds-table-cell),:host(cds-table-row[sticky-header]) ::slotted(cds-table-cell-skeleton){inline-size:100%;padding-block-start:.875rem}:host(cds-table-expand-row[size=xl]) ::slotted(cds-table-cell),:host(cds-table-expand-row[size=xl]) ::slotted(cds-table-cell-skeleton),:host(cds-table-row[size=xl]) ::slotted(cds-table-cell),:host(cds-table-row[size=xl]) ::slotted(cds-table-cell-skeleton){vertical-align:top}:host(cds-table-expand-row) .cds--table-column-checkbox,:host(cds-table-expand-row) .cds--table-expand,:host(cds-table-expand-row) ::slotted(cds-table-cell),:host(cds-table-expand-row) ::slotted(cds-table-cell-skeleton),:host(cds-table-row) .cds--table-column-checkbox,:host(cds-table-row) .cds--table-expand,:host(cds-table-row) ::slotted(cds-table-cell),:host(cds-table-row) ::slotted(cds-table-cell-skeleton){color:var(--cds-text-secondary,#525252);vertical-align:middle}:host(cds-table-row) ::slotted(cds-table-cell-skeleton:first-of-type),:host(cds-table-row) ::slotted(cds-table-cell:first-of-type){padding-inline-start:1rem}:host(cds-table-row) ::slotted(cds-table-cell-skeleton:last-of-type),:host(cds-table-row) ::slotted(cds-table-cell:last-of-type){padding-inline-end:1rem}:host(cds-table-row[expandable]) .cds--table-expand,:host(cds-table-row[selection-name]) .cds--table-expand{border-block-end:1px solid var(--cds-border-subtle);display:table-cell;padding-inline-end:0;transition:transform .15s cubic-bezier(.2,0,.38,.9)}:host(cds-table-row[expandable][expanded]) .cds--table-expand__svg,:host(cds-table-row[selection-name][expanded]) .cds--table-expand__svg{transform:rotate(270deg)}:host(cds-table-row[expandable][expanded]) .cds--table-expand,:host(cds-table-row[expandable][expanded][highlighted]) .cds--table-expand,:host(cds-table-row[selection-name][expandable][expanded]) .cds--table-expand,:host(cds-table-row[selection-name][expandable][expanded]:hover) .cds--table-expand,:host(cds-table-row[selection-name][expandable][expanded][highlighted]) :host(cds-table-row[expandable][expanded]:hover) .cds--table-expand{border-block-end-color:transparent}:host(cds-table-row[expandable][expanded][selected]) .cds--table-column-checkbox,:host(cds-table-row[expandable][expanded][selected]) .cds--table-expand,:host(cds-table-row[expandable][expanded][selected]) ::slotted(cds-table-cell),:host(cds-table-row[selection-name][expandable][expanded][selected]) .cds--table-column-checkbox,:host(cds-table-row[selection-name][expandable][expanded][selected]) .cds--table-expand,:host(cds-table-row[selection-name][expandable][expanded][selected]) ::slotted(cds-table-cell){background-color:var(--cds-layer-selected);border-block-end-color:var(--cds-border-subtle);border-block-start-color:var(--cds-layer-active)}:host(cds-table-row[expandable][expanded][selected]:hover) .cds--table-column-checkbox,:host(cds-table-row[expandable][expanded][selected]:hover) .cds--table-expand,:host(cds-table-row[expandable][expanded][selected]:hover) ::slotted(cds-table-cell),:host(cds-table-row[expandable][expanded][selected][highlighted]) .cds--table-column-checkbox,:host(cds-table-row[expandable][expanded][selected][highlighted]) .cds--table-expand,:host(cds-table-row[expandable][expanded][selected][highlighted]) ::slotted(cds-table-cell),:host(cds-table-row[selection-name][expandable][expanded][selected]:hover) .cds--table-column-checkbox,:host(cds-table-row[selection-name][expandable][expanded][selected]:hover) .cds--table-expand,:host(cds-table-row[selection-name][expandable][expanded][selected]:hover) ::slotted(cds-table-cell),:host(cds-table-row[selection-name][expandable][expanded][selected][highlighted]) .cds--table-column-checkbox,:host(cds-table-row[selection-name][expandable][expanded][selected][highlighted]) .cds--table-expand,:host(cds-table-row[selection-name][expandable][expanded][selected][highlighted]) ::slotted(cds-table-cell){background-color:var(--cds-layer-selected-hover)}:host(cds-table-row[expandable][selected]) .cds--table-column-checkbox,:host(cds-table-row[expandable][selected]) .cds--table-expand,:host(cds-table-row[expandable][selected]) ::slotted(cds-table-cell),:host(cds-table-row[selection-name][expandable][selected]) .cds--table-column-checkbox,:host(cds-table-row[selection-name][expandable][selected]) .cds--table-expand,:host(cds-table-row[selection-name][expandable][selected]) ::slotted(cds-table-cell){border-block-end-color:var(--cds-border-subtle)}:host(cds-table-row[expandable]:hover):not([ai-label]) .cds--table-column-checkbox,:host(cds-table-row[expandable]:hover):not([ai-label]) .cds--table-expand,:host(cds-table-row[expandable]:hover):not([ai-label]) ::slotted(cds-table-cell),:host(cds-table-row[expandable][highlighted]):not([ai-label]) .cds--table-column-checkbox,:host(cds-table-row[expandable][highlighted]):not([ai-label]) .cds--table-expand,:host(cds-table-row[expandable][highlighted]):not([ai-label]) ::slotted(cds-table-cell),:host(cds-table-row[selection-name][expandable]:hover):not([ai-label]) .cds--table-column-checkbox,:host(cds-table-row[selection-name][expandable]:hover):not([ai-label]) .cds--table-expand,:host(cds-table-row[selection-name][expandable]:hover):not([ai-label]) ::slotted(cds-table-cell),:host(cds-table-row[selection-name][expandable][highlighted]):not([ai-label]) .cds--table-column-checkbox,:host(cds-table-row[selection-name][expandable][highlighted]):not([ai-label]) .cds--table-expand,:host(cds-table-row[selection-name][expandable][highlighted]):not([ai-label]) ::slotted(cds-table-cell){border-block-end-color:var(--cds-border-subtle)}:host(cds-table-row[odd]) .cds--table-column-checkbox,:host(cds-table-row[odd]) .cds--table-expand,:host(cds-table-row[odd]) ::slotted(cds-table-cell),:host(cds-table-row[odd]) ::slotted(cds-table-cell-skeleton){border-block-end:1px solid var(--cds-layer-01,#f4f4f4)}:host(cds-table-row[even]) .cds--table-column-checkbox,:host(cds-table-row[even]) .cds--table-expand,:host(cds-table-row[even]) ::slotted(cds-table-cell),:host(cds-table-row[even]) ::slotted(cds-table-cell-skeleton){background-color:var(--cds-layer-accent-01,#e0e0e0);border-block-end:1px solid var(--cds-layer-accent-01,#e0e0e0)}:host(cds-table-expand-row:hover) .cds--table-column-checkbox,:host(cds-table-expand-row:hover) .cds--table-expand,:host(cds-table-expand-row:hover) ::slotted(cds-table-cell),:host(cds-table-expand-row:hover) ::slotted(cds-table-cell-skeleton),:host(cds-table-row:hover) .cds--table-column-checkbox,:host(cds-table-row:hover) .cds--table-expand,:host(cds-table-row:hover) ::slotted(cds-table-cell),:host(cds-table-row:hover) ::slotted(cds-table-cell-skeleton),:host(cds-table-row[highlighted]) .cds--table-column-checkbox,:host(cds-table-row[highlighted]) .cds--table-expand,:host(cds-table-row[highlighted]) ::slotted(cds-table-cell),:host(cds-table-row[highlighted]) ::slotted(cds-table-cell-skeleton){background-color:var(--cds-background-hover,hsla(0,0%,55%,.12));border-block-end-color:var(--cds-layer-hover-01,#e8e8e8);border-block-start-color:var(--cds-layer-hover-01,#e8e8e8);color:var(--cds-text-primary,#161616)}:host(cds-table-row[even]:hover) .cds--table-column-checkbox,:host(cds-table-row[even]:hover) .cds--table-expand,:host(cds-table-row[even]:hover) ::slotted(cds-table-cell),:host(cds-table-row[even]:hover) ::slotted(cds-table-cell-skeleton),:host(cds-table-row[highlighted]) .cds--table-column-checkbox,:host(cds-table-row[highlighted]) .cds--table-expand,:host(cds-table-row[highlighted]) ::slotted(cds-table-cell),:host(cds-table-row[highlighted]) ::slotted(cds-table-cell-skeleton),:host(cds-table-row[odd]:hover) .cds--table-column-checkbox,:host(cds-table-row[odd]:hover) .cds--table-expand,:host(cds-table-row[odd]:hover) ::slotted(cds-table-cell),:host(cds-table-row[odd]:hover) ::slotted(cds-table-cell-skeleton){background-color:var(--cds-background-hover,hsla(0,0%,55%,.12));border-block-end:1px solid var(--cds-layer-hover-01,#e8e8e8)}:host(cds-table-row[rows-with-ai-label]) cds-checkbox,:host(cds-table-row[rows-with-ai-label]) cds-radio-button{padding-inline-start:2rem}:host(cds-table-row[rows-with-ai-label]) .cds--table-expand{padding-inline-start:1rem}:host(cds-table-row[rows-with-ai-label]) .cds--table-expand__button{margin-inline-start:1.5rem}:host(cds-table-row[rows-with-ai-label][ai-label]) cds-checkbox,:host(cds-table-row[rows-with-ai-label][ai-label]) cds-radio-button{padding-inline-start:1rem}:host(cds-table-row[rows-with-ai-label][ai-label]) .cds--table-expand__button{margin-inline-start:.5rem}:host(cds-table-header-row[rows-with-ai-label]) .cds--table-expand{padding-inline-start:2.5rem}:host(cds-table-header-row[rows-with-ai-label]) .cds--table-column-checkbox{padding-inline-start:3rem}:host(cds-table-header-row[rows-with-ai-label][selection-name][expandable]) .cds--table-column-checkbox,:host(cds-table-row[rows-with-ai-label][selection-name][expandable]) .cds--table-column-checkbox{padding-inline-start:0}:host(cds-table-header-row[rows-with-ai-label][selection-name][expandable]) cds-checkbox,:host(cds-table-row[rows-with-ai-label][selection-name][expandable]) cds-checkbox{padding-inline-start:.5rem}:host(cds-table-row[ai-label]){background:linear-gradient(to right,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 50%);background-attachment:fixed;box-shadow:inset 1px 0 var(--cds-ai-border-strong,#4589ff)}:host(cds-table-row[ai-label]):hover{background:linear-gradient(to right,var(--cds-ai-aura-hover-start,rgba(69,137,255,.32)) 0,15%,var(--cds-ai-aura-hover-end,hsla(0,0%,100%,0)) 50%),var(--cds-ai-aura-hover-background,#edf5ff);background-attachment:fixed}:host(cds-table-header-title){display:block}:host(cds-table-header-description){display:block}@media (min-width:42rem){:host(cds-table-header-description){max-inline-size:50ch}}@media (min-width:66rem){:host(cds-table-header-description){max-inline-size:80ch}}:host(cds-table-expanded-row){block-size:0;display:table-row;transition:height .15s cubic-bezier(.2,0,.38,.9)}:host(cds-table-expanded-row) ::slotted(*){color:var(--cds-text-secondary,#525252)}@media screen and (prefers-reduced-motion:reduce){:host(cds-table-expanded-row) td{border-block-end-color:var(--cds-border-subtle);padding:0;padding-inline-start:4rem;transition:none;vertical-align:middle}:host(cds-table-expanded-row) td .cds--child-row-inner-container{block-size:0;overflow:hidden}}:host(cds-table-expanded-row) td{border-block-end-color:var(--cds-border-subtle);padding:0;padding-inline-start:4rem;transition:all .11s cubic-bezier(.2,0,.38,.9);vertical-align:middle}:host(cds-table-expanded-row) td .cds--child-row-inner-container{block-size:0;overflow:hidden}:host(cds-table-expanded-row[expanded]){block-size:3rem}:host(cds-table-expanded-row[expanded]) td{block-size:auto;border-block-end:1px solid var(--cds-border-subtle)}:host(cds-table-expanded-row[expanded]) td .cds--child-row-inner-container{block-size:auto}:host(cds-table-expanded-row:hover),:host(cds-table-expanded-row[highlighted]),:host(cds-table-expanded-row[selected]){background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}:host(cds-table-expanded-row:hover) ::slotted(*),:host(cds-table-expanded-row[highlighted]) ::slotted(*),:host(cds-table-expanded-row[selected]) ::slotted(*){color:var(--cds-text-primary,#161616)}:host(cds-table-expanded-row[selected][highlighted]){background-color:var(--cds-layer-selected)}:host(cds-table-row[ai-label][expandable]):hover,:host(cds-table-row[ai-label][expandable])[highlighted],:host(cds-table-row[ai-label][expandable][selection-name][selected]):hover,:host(cds-table-row[ai-label][expandable][selection-name][selected])[highlighted]{background:linear-gradient(to right,var(--cds-ai-aura-hover-start,rgba(69,137,255,.32)) 0,15%,var(--cds-ai-aura-hover-end,hsla(0,0%,100%,0)) 50%),var(--cds-ai-aura-hover-background,#edf5ff);background-attachment:fixed}:host(cds-table-row[ai-label][expandable]):hover .cds--table-column-checkbox,:host(cds-table-row[ai-label][expandable]):hover .cds--table-expand,:host(cds-table-row[ai-label][expandable]):hover ::slotted(cds-table-cell),:host(cds-table-row[ai-label][expandable]):hover ::slotted(cds-table-cell-skeleton),:host(cds-table-row[ai-label][expandable])[highlighted] .cds--table-column-checkbox,:host(cds-table-row[ai-label][expandable])[highlighted] .cds--table-expand,:host(cds-table-row[ai-label][expandable])[highlighted] ::slotted(cds-table-cell),:host(cds-table-row[ai-label][expandable])[highlighted] ::slotted(cds-table-cell-skeleton),:host(cds-table-row[ai-label][expandable][selection-name][selected]):hover .cds--table-column-checkbox,:host(cds-table-row[ai-label][expandable][selection-name][selected]):hover .cds--table-expand,:host(cds-table-row[ai-label][expandable][selection-name][selected]):hover ::slotted(cds-table-cell),:host(cds-table-row[ai-label][expandable][selection-name][selected]):hover ::slotted(cds-table-cell-skeleton),:host(cds-table-row[ai-label][expandable][selection-name][selected])[highlighted] .cds--table-column-checkbox,:host(cds-table-row[ai-label][expandable][selection-name][selected])[highlighted] .cds--table-expand,:host(cds-table-row[ai-label][expandable][selection-name][selected])[highlighted] ::slotted(cds-table-cell),:host(cds-table-row[ai-label][expandable][selection-name][selected])[highlighted] ::slotted(cds-table-cell-skeleton){background:none}:host(cds-table-row[ai-label][expandable]):hover[expanded] .cds--table-expand,:host(cds-table-row[ai-label][expandable])[highlighted][expanded] .cds--table-expand,:host(cds-table-row[ai-label][expandable][selection-name][selected]):hover[expanded] .cds--table-expand,:host(cds-table-row[ai-label][expandable][selection-name][selected])[highlighted][expanded] .cds--table-expand{border-block-end-color:transparent}:host(cds-table-row[ai-label][expandable]) .cds--table-column-checkbox,:host(cds-table-row[ai-label][expandable]) .cds--table-expand,:host(cds-table-row[ai-label][expandable]) ::slotted(cds-table-cell),:host(cds-table-row[ai-label][expandable]) ::slotted(cds-table-cell-skeleton),:host(cds-table-row[ai-label][expandable][selection-name][selected]) .cds--table-column-checkbox,:host(cds-table-row[ai-label][expandable][selection-name][selected]) .cds--table-expand,:host(cds-table-row[ai-label][expandable][selection-name][selected]) ::slotted(cds-table-cell),:host(cds-table-row[ai-label][expandable][selection-name][selected]) ::slotted(cds-table-cell-skeleton){background:none}:host(cds-table-row[ai-label][expandable])[expanded] .cds--table-expand,:host(cds-table-row[ai-label][expandable][selection-name][selected])[expanded] .cds--table-expand{border-block-end-color:transparent}:host(cds-table-expanded-row[ai-label]){background:linear-gradient(to right,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 50%)}:host(cds-table-expanded-row[ai-label])[highlighted]{background:linear-gradient(to right,var(--cds-ai-aura-hover-start,rgba(69,137,255,.32)) 0,15%,var(--cds-ai-aura-hover-end,hsla(0,0%,100%,0)) 50%),var(--cds-ai-aura-hover-background,#edf5ff)}:host(cds-table-expanded-row[rows-with-ai-label]) td{padding-inline-start:5.5rem}:host(cds-table-body) ::slotted(cds-table-row[size=xs]),:host(cds-table-head) ::slotted(cds-table-header-row[size=xs]){block-size:1.5rem}:host(cds-table-header-row[size=xs]) ::slotted(cds-table-header-cell),:host(cds-table-row[size=xs]) ::slotted(cds-table-header-cell){block-size:1.5rem}:host(cds-table-header-row[size=xs]) ::slotted(cds-table-cell),:host(cds-table-row[size=xs]) ::slotted(cds-table-cell){padding-block:.125rem;padding-inline-start:1rem}:host(cds-table-header-row[size=xs]) .cds--table-expand,:host(cds-table-row[size=xs]) .cds--table-expand{block-size:1.5rem;padding-block:0}:host(cds-table-body) ::slotted(cds-table-row[size=sm]),:host(cds-table-head) ::slotted(cds-table-header-row[size=sm]){block-size:2rem}:host(cds-table-header-row[size=sm]) ::slotted(cds-table-header-cell),:host(cds-table-row[size=sm]) ::slotted(cds-table-header-cell){block-size:2rem}:host(cds-table-header-row[size=sm]) ::slotted(cds-table-cell),:host(cds-table-row[size=sm]) ::slotted(cds-table-cell){padding-block:.4375rem .375rem;padding-inline-start:1rem}:host(cds-table-header-row[size=sm]) .cds--table-expand,:host(cds-table-row[size=sm]) .cds--table-expand{padding-block:0}:host(cds-table-header-row[size=sm]) ::slotted(cds-overflow-menu),:host(cds-table-row[size=sm]) ::slotted(cds-overflow-menu){block-size:2rem}:host(cds-table-body) ::slotted(cds-table-row[size=md]),:host(cds-table-head) ::slotted(cds-table-header-row[size=md]){block-size:2.5rem}:host(cds-table-header-row[size=md]) ::slotted(cds-table-header-cell),:host(cds-table-row[size=md]) ::slotted(cds-table-header-cell){block-size:2.5rem}:host(cds-table-header-row[size=md]) ::slotted(cds-table-cell),:host(cds-table-row[size=md]) ::slotted(cds-table-cell){padding-block:.4375rem .375rem;padding-inline-start:1rem}:host(cds-table-header-row[size=md]) .cds--table-expand,:host(cds-table-row[size=md]) .cds--table-expand{padding-block:.25rem}:host(cds-table-header-row[size=md]) ::slotted(cds-overflow-menu),:host(cds-table-row[size=md]) ::slotted(cds-overflow-menu){block-size:2.5rem}:host(cds-table-body) ::slotted(cds-table-row[size=lg]),:host(cds-table-head) ::slotted(cds-table-header-row[size=lg]){block-size:3rem}:host(cds-table-body) ::slotted(cds-table-row[size=xl]),:host(cds-table-head) ::slotted(cds-table-header-row[size=xl]){block-size:4rem}:host(cds-table-header-row[size=xl]) ::slotted(cds-table-header-cell){padding-block-start:1rem;vertical-align:top}:host(cds-table-header-row[size=xl]) ::slotted(cds-table-cell),:host(cds-table-row[size=xl]) ::slotted(cds-table-cell){padding-block-start:1rem}:host(cds-table-header-row[size=xl]) .cds--table-expand,:host(cds-table-row[size=xl]) .cds--table-expand{padding-block-end:1.375rem}:host(cds-table-header-row[size=xl]) .cds--table-column-checkbox,:host(cds-table-header-row[size=xl]) .cds--table-expand,:host(cds-table-row[size=xl]) .cds--table-column-checkbox,:host(cds-table-row[size=xl]) .cds--table-expand{padding-block-start:.625rem;vertical-align:top}:host(cds-table-header-row[size=xl])[radio] .cds--table-column-checkbox,:host(cds-table-row[size=xl])[radio] .cds--table-column-checkbox{padding-block-start:1rem}:host(cds-table-expanded-row[size=xl][expanded]) td{padding-block:1rem .5rem;padding-inline-end:1rem}:host(cds-table-toolbar-content[size=xs]),:host(cds-table-toolbar-content[size=xs]) ::slotted(cds-button),:host(cds-table-toolbar-content[size=xs]) ::slotted(cds-overflow-menu),:host(cds-table-toolbar-content[size=xs]) ::slotted(cds-table-toolbar-search),:host(cds-table-toolbar[size=xs]),:host(cds-table-toolbar[size=xs]) ::slotted(cds-button),:host(cds-table-toolbar[size=xs]) ::slotted(cds-overflow-menu),:host(cds-table-toolbar[size=xs]) ::slotted(cds-table-toolbar-search){block-size:2rem;min-block-size:2rem}:host(cds-table-toolbar-content[size=xs]) ::slotted(cds-overflow-menu),:host(cds-table-toolbar-content[size=xs]) ::slotted(cds-table-toolbar-search),:host(cds-table-toolbar[size=xs]) ::slotted(cds-overflow-menu),:host(cds-table-toolbar[size=xs]) ::slotted(cds-table-toolbar-search){inline-size:2rem}:host(cds-table-toolbar-content[size=sm]),:host(cds-table-toolbar-content[size=sm]) ::slotted(cds-button),:host(cds-table-toolbar-content[size=sm]) ::slotted(cds-overflow-menu),:host(cds-table-toolbar-content[size=sm]) ::slotted(cds-table-toolbar-search),:host(cds-table-toolbar[size=sm]),:host(cds-table-toolbar[size=sm]) ::slotted(cds-button),:host(cds-table-toolbar[size=sm]) ::slotted(cds-overflow-menu),:host(cds-table-toolbar[size=sm]) ::slotted(cds-table-toolbar-search){block-size:2rem;min-block-size:2rem}:host(cds-table-toolbar-content[size=sm]) ::slotted(cds-overflow-menu),:host(cds-table-toolbar-content[size=sm]) ::slotted(cds-table-toolbar-search),:host(cds-table-toolbar[size=sm]) ::slotted(cds-overflow-menu),:host(cds-table-toolbar[size=sm]) ::slotted(cds-table-toolbar-search){inline-size:2rem}:host(cds-table-header-row[selection-name][expandable][size=xs]) .cds--table-column-checkbox,:host(cds-table-row[selection-name][expandable][size=xs]) .cds--table-column-checkbox{padding:0 .375rem}:host(cds-table-header-row[selection-name][expandable][size=md]) .cds--table-column-checkbox,:host(cds-table-header-row[selection-name][expandable][size=sm]) .cds--table-column-checkbox,:host(cds-table-row[selection-name][expandable][size=md]) .cds--table-column-checkbox,:host(cds-table-row[selection-name][expandable][size=sm]) .cds--table-column-checkbox{padding:.1875rem .375rem}:host(cds-table-header-row[selection-name][expandable][size=xl]) .cds--table-column-checkbox{padding-inline:.375rem}:host(cds-table-cell[size=sm]) ::slotted(cds-overflow-menu),:host(cds-table-cell[size=xs]) ::slotted(cds-overflow-menu){block-size:calc(100% + 1px)}:host(cds-table-cell[size=md]) ::slotted(cds-overflow-menu){block-size:2.5rem}:host(cds-table-header-row) .cds--table-column-checkbox{border-block-end:none;border-block-start:none;padding-inline:1rem .25rem;transition:background-color 70ms cubic-bezier(0,0,.38,.9)}:host(cds-table-header-row) .cds--table-column-checkbox .cds--checkbox-label{inline-size:20px}:host(cds-table-row) .cds--table-column-checkbox{border-block-end:1px solid var(--cds-border-subtle);padding-inline:1rem .25rem}:host(cds-table-row) .cds--table-column-checkbox .cds--checkbox-label{padding-inline-start:1rem}:host(cds-table-row:hover) .cds--table-column-checkbox{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12));border-block-end-color:var(--cds-layer-hover-01,#e8e8e8);border-block-start-color:var(--cds-layer-hover-01,#e8e8e8)}:host(cds-table-row[selected]) .cds--table-column-checkbox,:host(cds-table-row[selected]) .cds--table-expand,:host(cds-table-row[selected]) ::slotted(cds-table-cell){background-color:var(--cds-layer-accent-01,#e0e0e0);border-block-end:1px solid var(--cds-layer-active);color:var(--cds-text-primary,#161616)}:host(cds-table-row[selected]):hover .cds--table-column-checkbox,:host(cds-table-row[selected]):hover .cds--table-expand,:host(cds-table-row[selected]):hover ::slotted(cds-table-cell){background-color:var(--cds-layer-selected-hover);border-block-end-color:var(--cds-layer-selected-hover)}:host(cds-table-expanded-row[filtered]),:host(cds-table-row[filtered]){display:none!important}:host(cds-table-expanded-row[selected][ai-label]:not([highlighted])),:host(cds-table-row[expandable][selected][ai-label]),:host(cds-table-row[selected][ai-label]){background:linear-gradient(to right,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 50%),var(--cds-layer-selected);background-attachment:fixed}:host(cds-table-expanded-row[selected][ai-label]:not([highlighted])):hover,:host(cds-table-expanded-row[selected][ai-label]:not([highlighted]))[highlighted],:host(cds-table-row[expandable][selected][ai-label]):hover,:host(cds-table-row[expandable][selected][ai-label])[highlighted],:host(cds-table-row[selected][ai-label]):hover,:host(cds-table-row[selected][ai-label])[highlighted]{background:linear-gradient(to right,var(--cds-ai-aura-hover-start,rgba(69,137,255,.32)) 0,15%,var(--cds-ai-aura-hover-end,hsla(0,0%,100%,0)) 50%),var(--cds-ai-aura-hover-background,#edf5ff);background-attachment:fixed}:host(cds-table-expanded-row[selected][ai-label]:not([highlighted])):hover .cds--table-column-checkbox,:host(cds-table-expanded-row[selected][ai-label]:not([highlighted])):hover .cds--table-expand,:host(cds-table-expanded-row[selected][ai-label]:not([highlighted])):hover ::slotted(cds-table-cell),:host(cds-table-expanded-row[selected][ai-label]:not([highlighted]))[highlighted] .cds--table-column-checkbox,:host(cds-table-expanded-row[selected][ai-label]:not([highlighted]))[highlighted] .cds--table-expand,:host(cds-table-expanded-row[selected][ai-label]:not([highlighted]))[highlighted] ::slotted(cds-table-cell),:host(cds-table-row[expandable][selected][ai-label]):hover .cds--table-column-checkbox,:host(cds-table-row[expandable][selected][ai-label]):hover .cds--table-expand,:host(cds-table-row[expandable][selected][ai-label]):hover ::slotted(cds-table-cell),:host(cds-table-row[expandable][selected][ai-label])[highlighted] .cds--table-column-checkbox,:host(cds-table-row[expandable][selected][ai-label])[highlighted] .cds--table-expand,:host(cds-table-row[expandable][selected][ai-label])[highlighted] ::slotted(cds-table-cell),:host(cds-table-row[selected][ai-label]):hover .cds--table-column-checkbox,:host(cds-table-row[selected][ai-label]):hover .cds--table-expand,:host(cds-table-row[selected][ai-label]):hover ::slotted(cds-table-cell),:host(cds-table-row[selected][ai-label])[highlighted] .cds--table-column-checkbox,:host(cds-table-row[selected][ai-label])[highlighted] .cds--table-expand,:host(cds-table-row[selected][ai-label])[highlighted] ::slotted(cds-table-cell){background:none}:host(cds-table-expanded-row[selected][ai-label]:not([highlighted])) .cds--table-column-checkbox,:host(cds-table-expanded-row[selected][ai-label]:not([highlighted])) .cds--table-expand,:host(cds-table-expanded-row[selected][ai-label]:not([highlighted])) ::slotted(cds-table-cell),:host(cds-table-row[expandable][selected][ai-label]) .cds--table-column-checkbox,:host(cds-table-row[expandable][selected][ai-label]) .cds--table-expand,:host(cds-table-row[expandable][selected][ai-label]) ::slotted(cds-table-cell),:host(cds-table-row[selected][ai-label]) .cds--table-column-checkbox,:host(cds-table-row[selected][ai-label]) .cds--table-expand,:host(cds-table-row[selected][ai-label]) ::slotted(cds-table-cell){background:none}.cds--data-table th[aria-sort],.cds--data-table--sort th,:host(cds-table) th[aria-sort]{block-size:3rem;border-block-end:none;border-block-start:none;padding:0}.cds--table-sort__description{display:none}.cds--table-sort{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;background-color:var(--cds-layer-accent);border:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font:inherit;inline-size:100%;justify-content:space-between;line-height:1;margin:0;min-block-size:100%;padding:0;padding-inline-start:1rem;text-align:start;transition:background-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline}.cds--table-sort *,.cds--table-sort :after,.cds--table-sort :before{box-sizing:inherit}.cds--table-sort::-moz-focus-inner{border:0}.cds--table-sort:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--table-sort:focus{outline-style:dotted}}.cds--table-sort:hover{background:var(--cds-layer-selected-hover)}.cds--table-sort:focus svg,.cds--table-sort:hover svg{opacity:1}.cds--data-table.cds--data-table--sort th>.cds--table-header-label{line-height:1;padding-inline:1rem 1rem}th .cds--table-sort__flex{align-items:center;block-size:100%;display:flex;inline-size:100%;justify-content:space-between;min-block-size:3rem}.cds--data-table--top-aligned-header th .cds--table-sort__flex{align-items:start}.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--lg th.cds--table-sort__header{padding-block-start:1rem}.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--sm th.cds--table-sort__header .cds--table-sort__flex .cds--table-header-label,.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--xs th.cds--table-sort__header .cds--table-sort__flex .cds--table-header-label{padding-block:0}.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--sm th.cds--table-sort__header{padding-block:.4375rem .4375rem}.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--xs th.cds--table-sort__header{padding-block:.125rem .125rem}@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){.cds--data-table--sort:not(.cds--data-table--xs):not(.cds--data-table--sm):not(.cds--data-table--md):not(.cds--data-table--xl) th .cds--table-sort__flex{block-size:2.99rem}}.cds--data-table--xs.cds--data-table--sort th .cds--table-sort__flex{min-block-size:1.5rem}.cds--data-table--sm.cds--data-table--sort th .cds--table-sort__flex{min-block-size:2rem}.cds--data-table--md.cds--data-table--sort th .cds--table-sort__flex{min-block-size:2.5rem}.cds--data-table--xl.cds--data-table--sort th .cds--table-sort__flex{align-items:flex-start;min-block-size:4rem}.cds--table-sort .cds--table-sort__icon-inactive{display:block}.cds--table-sort .cds--table-sort__icon{display:none}.cds--table-sort__icon-unsorted{fill:var(--cds-icon-primary,#161616);inline-size:1.25rem;margin-inline:.5rem .5rem;min-inline-size:1rem;opacity:0}.cds--table-sort.cds--table-sort--active{background:var(--cds-layer-selected-hover)}.cds--table-sort.cds--table-sort--active .cds--table-sort__icon-unsorted{display:none}.cds--table-sort.cds--table-sort--active .cds--table-sort__icon{display:block;opacity:1}.cds--table-sort--descending .cds--table-sort__icon{transform:rotate(180deg)}.cds--table-sort__icon{fill:var(--cds-icon-primary,#161616);inline-size:1.25rem;margin-inline:.5rem .5rem;min-inline-size:1rem;opacity:1;transform:rotate(0);transition:transform .25s cubic-bezier(.5,0,.1,1)}.cds--data-table--xs.cds--data-table--sort th{block-size:1.5rem}.cds--data-table--sm.cds--data-table--sort th{block-size:2rem}.cds--data-table--md.cds--data-table--sort th{block-size:2.5rem}.cds--data-table--xl.cds--data-table--sort th{block-size:4rem}.cds--data-table--xl.cds--data-table--sort th .cds--table-sort{block-size:4rem;display:inline-block}.cds--data-table--xl .cds--table-sort__icon,.cds--data-table--xl .cds--table-sort__icon-unsorted{margin-block-start:.8125rem}.cds--table-sort__header--slug .cds--table-sort__icon,.cds--table-sort__header--slug .cds--table-sort__icon-unsorted{margin-inline:auto .5rem}.cds--table-sort__header--slug .cds--ai-label,.cds--table-sort__header--slug .cds--slug{margin-inline-end:.5rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--table-sort__icon,.cds--table-sort__icon-unsorted{fill:ButtonText}}:host(cds-table-header-row) ::slotted(cds-table-header-cell[sort-direction]){padding-inline:0}:host(cds-table-header-cell[sort-direction]:first-of-type) .cds--table-sort{padding-inline-start:1rem}:host(cds-table-header-cell[sort-direction][expandable][selection-name]) .cds--table-sort{padding-inline-start:0}:host(cds-table-header-cell) .cds--table-sort:hover .cds--table-sort__icon,:host(cds-table-header-cell[sort-active]) .cds--table-sort .cds--table-sort__icon{opacity:1}:host(cds-table-header-cell[sort-direction]) .cds--table-sort .cds--table-sort__icon{display:block}:host(cds-table-header-cell[sort-direction=ascending]) .cds--table-sort__icon{transform:rotate(180deg)}:host(cds-table-header-cell[sort-direction][ai-label]) .cds--table-sort__icon,:host(cds-table-header-cell[sort-direction][ai-label]) .cds--table-sort__icon-unsorted{margin-inline:auto .5rem}:host(cds-table-header-cell[sort-direction][ai-label]) ::slotted(cds-ai-label),:host(cds-table-header-cell[sort-direction][ai-label]) ::slotted(cds-slug){margin-inline-end:.5rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1tF1Q":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableSkeleton$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _settingsJs = require("../../globals/settings.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Data table skeleton
 *
 * @element cds-table-skeleton
 */ let CDSTableSkeleton = class CDSTableSkeleton extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Optionally specify the displayed headers
         */ this.headers = [];
        /**
         * Optionally specify whether you want the Skeleton to be rendered as a compact DataTable
         */ this.compact = false;
        /**
         * Specify the number of columns that you want to render in the skeleton state
         */ this.columnCount = 5;
        /**
         * Specify the number of rows that you want to render in the skeleton state
         */ this.rowCount = 5;
        /**
         * Specify if the table header should be rendered as part of the skeleton.
         */ this.showHeader = true;
        /**
         * Specify if the table toolbar should be rendered as part of the skeleton.
         */ this.showToolbar = true;
        /**
         *  true to add useZebraStyles striping.
         */ this.zebra = false;
    }
    /**
     * @returns The header
     */ _renderHeader() {
        const { showHeader } = this;
        return !showHeader ? undefined : (0, _lit.html)`
          <div class="${0, _settingsJs.prefix}--skeleton ${0, _settingsJs.prefix}--data-table-container">
            <div class="${0, _settingsJs.prefix}--data-table-header">
              <div class="${0, _settingsJs.prefix}--data-table-header__title"></div>
              <div class="${0, _settingsJs.prefix}--data-table-header__description"></div>
            </div>
          </div>
        `;
    }
    /**
     * @returns The header
     */ _renderToolbar() {
        const { showToolbar } = this;
        return !showToolbar ? undefined : (0, _lit.html)`
          <section class="${0, _settingsJs.prefix}--table-toolbar">
            <div class="${0, _settingsJs.prefix}--toolbar-content">
              <span
                class="${0, _settingsJs.prefix}--skeleton ${0, _settingsJs.prefix}--btn ${0, _settingsJs.prefix}--btn--sm"></span>
            </div>
          </section>
        `;
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "table");
        super.connectedCallback();
    }
    updated() {
        if (this.headers.length) this.columnCount = this.headers.length;
        else this.headers = Array(this.columnCount).fill("");
    }
    render() {
        const { compact, columnCount, headers, rowCount, zebra } = this;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--skeleton`]: true,
            [`${0, _settingsJs.prefix}--data-table`]: true,
            [`${0, _settingsJs.prefix}--data-table--compact`]: compact,
            [`${0, _settingsJs.prefix}--data-table--zebra`]: zebra
        });
        return (0, _lit.html)`
      ${this._renderHeader()} ${this._renderToolbar()}

      <table class="${classes}">
        <thead>
          <tr>
            ${Array.from(new Array(columnCount)).map((_, index)=>(0, _lit.html)`
                <th>
                  <div class="${0, _settingsJs.prefix}--table-header-label">
                    ${headers[index]}
                  </div>
                </th>
              `)}
          </tr>
        </thead>
        <tbody>
          ${Array.from(new Array(rowCount)).map(()=>(0, _lit.html)`
              <tr>
                ${Array.from(new Array(columnCount)).map(()=>(0, _lit.html)`
                    <td>
                      <span></span>
                    </td>
                  `)}
              </tr>
            `)}
        </tbody>
      </table>
    `;
    }
};
CDSTableSkeleton.styles = (0, _dataTableScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTableSkeleton.prototype, "headers", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableSkeleton.prototype, "compact", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true,
        attribute: "column-count"
    })
], CDSTableSkeleton.prototype, "columnCount", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true,
        attribute: "row-count"
    })
], CDSTableSkeleton.prototype, "rowCount", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "show-header"
    })
], CDSTableSkeleton.prototype, "showHeader", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "show-toolbar"
    })
], CDSTableSkeleton.prototype, "showToolbar", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableSkeleton.prototype, "zebra", void 0);
CDSTableSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-skeleton`)
], CDSTableSkeleton);
var CDSTableSkeleton$1 = CDSTableSkeleton;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/settings.js":"EipuL","./data-table.scss.js":"UdnU6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"GgIJy":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableHeader$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Data table header title
 *
 * @element cds-table-header-title
 */ let CDSTableHeader = class CDSTableHeader extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSTableHeader.styles = (0, _dataTableScssJsDefault.default);
CDSTableHeader = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-header-title`)
], CDSTableHeader);
var CDSTableHeader$1 = CDSTableHeader;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gtCv0":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableHeaderDescription$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Data table header description
 *
 * @element cds-table-header-description
 */ let CDSTableHeaderDescription = class CDSTableHeaderDescription extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSTableHeaderDescription.styles = (0, _dataTableScssJsDefault.default);
CDSTableHeaderDescription = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-header-description`)
], CDSTableHeaderDescription);
var CDSTableHeaderDescription$1 = CDSTableHeaderDescription;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ZgqGQ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableBatchActions$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Table batch actions.
 *
 * @element cds-table-batch-actions
 * @fires cds-table-batch-actions-cancel-clicked - The custom event fired after the Cancel button is clicked.
 */ let CDSTableBatchActions = class CDSTableBatchActions extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if this batch actions bar should be active.
         */ this.active = false;
        /**
         * The formatter for selected items. Should be changed upon the locale the UI is rendered with.
         */ this.formatSelectedItemsCount = ({ count })=>`${count} item${count <= 1 ? "" : "s"} selected`;
        /**
         * Numeric representation of the total number of items selected in a table.
         * This number is used to derive the selection message.
         */ this.selectedRowsCount = 0;
    }
    /**
     * Handles `click` event on the Cancel button.
     */ _handleCancel() {
        const { eventClickCancel } = this.constructor;
        this.dispatchEvent(new CustomEvent(eventClickCancel, {
            bubbles: true,
            composed: true
        }));
    }
    firstUpdated() {
        this.querySelectorAll(this.constructor.selectorButtons).forEach((e)=>{
            e.setAttribute("batch-action", "");
        });
    }
    updated(changedProperties) {
        if (changedProperties.has("active")) this.setAttribute("tabindex", `${this.active ? "" : "-1"}`);
    }
    render() {
        const { formatSelectedItemsCount, selectedRowsCount, _handleCancel: handleCancel } = this;
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--batch-summary">
        <p class="${0, _settingsJs.prefix}--batch-summary__para">
          ${formatSelectedItemsCount({
            count: selectedRowsCount
        })}
        </p>
      </div>
      <div class="${0, _settingsJs.prefix}--action-list">
        <slot></slot>
        <button
          class="${0, _settingsJs.prefix}--btn ${0, _settingsJs.prefix}--btn--primary ${0, _settingsJs.prefix}--batch-summary__cancel"
          @click=${handleCancel}>
          <slot name="cancel-button-content">Cancel</slot>
        </button>
      </div>
    `;
    }
    /**
     * The CSS selector to find the action buttons.
     */ static get selectorButtons() {
        return `${0, _settingsJs.prefix}-button`;
    }
    /**
     * The name of the custom event fired after the Cancel button is clicked.
     */ static get eventClickCancel() {
        return `${0, _settingsJs.prefix}-table-batch-actions-cancel-clicked`;
    }
};
CDSTableBatchActions.styles = (0, _dataTableScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableBatchActions.prototype, "active", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: false
    })
], CDSTableBatchActions.prototype, "formatSelectedItemsCount", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        attribute: "selected-rows-count"
    })
], CDSTableBatchActions.prototype, "selectedRowsCount", void 0);
CDSTableBatchActions = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-batch-actions`)
], CDSTableBatchActions);
var CDSTableBatchActions$1 = CDSTableBatchActions;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bygFH":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableBody$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Data table body.
 *
 * @element cds-table-body
 */ let CDSTableBody = class CDSTableBody extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Handles `slotchange` event in the `<slot>` element in the shadow DOM.
         */ this._handleSlotChange = ()=>{
            this._updateZebra();
            this.dispatchEvent(new CustomEvent(this.constructor.eventTableBodyContentChange, {
                bubbles: true,
                cancelable: false
            }));
        };
        /**
         * TODO: Uncomment when Carbon fully implements sticky header
         * Specify whether the header should be sticky.
         * Still experimental: may not work with every combination of table props
         */ // @property({ type: Boolean, reflect: true, attribute: 'sticky-header' })
        // stickyHeader = false;
        /**
         * The color scheme.
         */ this.useZebraStyles = false;
    }
    /**
     * Updates `even`/`odd` properties of the child `<cds-table-row>`s.
     */ _updateZebra() {
        const { useZebraStyles, _slotNode: slotNode } = this;
        slotNode.assignedNodes().forEach((node)=>{
            if (node.nodeType === Node.ELEMENT_NODE) {
                const even = node.matches("*:nth-of-type(even)");
                node.even = useZebraStyles && even;
                node.odd = useZebraStyles && !even;
            }
        });
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "rowgroup");
        super.connectedCallback();
    }
    updated(changedProperties) {
        if (changedProperties.has("useZebraStyles")) this._updateZebra();
    }
    render() {
        const { _handleSlotChange: handleSlotChange } = this;
        return (0, _lit.html)` <slot @slotchange="${handleSlotChange}"></slot> `;
    }
    /**
     * The name of the custom event fired after the body slot content changes
     */ static get eventTableBodyContentChange() {
        return `${0, _settingsJs.prefix}-table-body-content-change`;
    }
};
CDSTableBody.styles = (0, _dataTableScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("slot")
], CDSTableBody.prototype, "_slotNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "use-zebra-styles"
    })
], CDSTableBody.prototype, "useZebraStyles", void 0);
CDSTableBody = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-body`)
], CDSTableBody);
var CDSTableBody$1 = CDSTableBody;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"RzpNl":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableCell$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Data table cell.
 *
 * @element cds-table-cell
 */ let CDSTableCell = class CDSTableCell extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Specify whether the overflow menu (if it exists) should be shown always, or only on hover
         */ this.overflowMenuOnHover = false;
    }
    /**
     * TODO: Uncomment when Carbon fully implements sticky header
     * Specify whether the header should be sticky.
     * Still experimental: may not work with every combination of table props
     */ // @property({ type: Boolean, reflect: true, attribute: 'sticky-header' })
    // stickyHeader = false;
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "cell");
        super.connectedCallback();
    }
    render() {
        return (0, _lit.html)`<slot></slot>`;
    }
};
CDSTableCell.styles = (0, _dataTableScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "overflow-menu-on-hover"
    })
], CDSTableCell.prototype, "overflowMenuOnHover", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTableCell.prototype, "size", void 0);
CDSTableCell = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-cell`)
], CDSTableCell);
var CDSTableCell$1 = CDSTableCell;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lEs5E":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableCellContent$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Data table cell content.
 *
 * @element cds-table-cell-content
 */ let CDSTableCellContent = class CDSTableCellContent extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSTableCellContent.styles = (0, _dataTableScssJsDefault.default);
CDSTableCellContent = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-cell-content`)
], CDSTableCellContent);
var CDSTableCellContent$1 = CDSTableCellContent;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"du5aW":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableExpandedRow$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Table row of collapsible details.
 *
 * @element cds-table-expanded-row
 */ let CDSTableExpandedRow = class CDSTableExpandedRow extends (0, _hostListenerJsDefault1.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * The colspan.
         */ this.colSpan = 1;
        /**
         * `true` if the table row should be expanded.
         */ this.expanded = false;
        /**
         * `true` if the table row should be filtered.
         */ this.filtered = false;
        /**
         * `true` if the table row should be highlighted.
         */ this.highlighted = false;
        /**
         * `true` if the previous table row has been selected
         */ this.selected = false;
    }
    /**
     * Handles `mouseover`/`mouseout` event handler on this element.
     *
     * @param event The event.
     */ _handleMouseOverOut(event) {
        const { selectorRow } = this.constructor;
        const { previousElementSibling } = this;
        if (previousElementSibling === null || previousElementSibling === void 0 ? void 0 : previousElementSibling.matches(selectorRow)) previousElementSibling.highlighted = event.type === "mouseover";
    }
    render() {
        const { colSpan } = this;
        return (0, _lit.html)`
      <td colspan="${colSpan}">
        <div class="${0, _settingsJs.prefix}--child-row-inner-container">
          <slot></slot>
        </div>
      </td>
    `;
    }
    updated() {
        var _a;
        ((_a = this.previousElementSibling) === null || _a === void 0 ? void 0 : _a.hasAttribute("ai-label")) ? this.setAttribute("ai-label", "") : this.removeAttribute("ai-label");
    }
    /**
     * A selector that will return the previous sibling row.
     */ static get selectorRow() {
        return `${0, _settingsJs.prefix}-table-row`;
    }
};
CDSTableExpandedRow.styles = (0, _dataTableScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("mouseover"),
    (0, _hostListenerJsDefault.default)("mouseout")
], CDSTableExpandedRow.prototype, "_handleMouseOverOut", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        attribute: "colspan"
    })
], CDSTableExpandedRow.prototype, "colSpan", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableExpandedRow.prototype, "expanded", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableExpandedRow.prototype, "filtered", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableExpandedRow.prototype, "highlighted", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableExpandedRow.prototype, "selected", void 0);
CDSTableExpandedRow = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-expanded-row`)
], CDSTableExpandedRow);
var CDSTableExpandedRow$1 = CDSTableExpandedRow;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/host-listener.js":"1SMUX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Zamo":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableHead$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Data table header.
 *
 * @element cds-table-head
 */ let CDSTableHead = class CDSTableHead extends (0, _lit.LitElement) {
    /**
     * TODO: Uncomment when Carbon fully implements sticky header
     * Specify whether the header should be sticky.
     * Still experimental: may not work with every combination of table props
     */ //@property({ type: Boolean, reflect: true, attribute: 'sticky-header' })
    // stickyHeader = false;
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "rowgroup");
        super.connectedCallback();
    }
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSTableHead.styles = (0, _dataTableScssJsDefault.default);
CDSTableHead = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-head`)
], CDSTableHead);
var CDSTableHead$1 = CDSTableHead;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gndBx":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TABLE_SORT_CYCLE", ()=>(0, _defsJs.TABLE_SORT_CYCLE));
parcelHelpers.export(exports, "TABLE_SORT_CYCLES", ()=>(0, _defsJs.TABLE_SORT_CYCLES));
parcelHelpers.export(exports, "TABLE_SORT_DIRECTION", ()=>(0, _defsJs.TABLE_SORT_DIRECTION));
parcelHelpers.export(exports, "default", ()=>CDSTableHeaderCell$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _classMapJs = require("lit/directives/class-map.js");
var _32Js = require("../../icons/arrows--vertical/32.js");
var _32JsDefault = parcelHelpers.interopDefault(_32Js);
var _32Js1 = require("../../icons/arrow--down/32.js");
var _32JsDefault1 = parcelHelpers.interopDefault(_32Js1);
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _defsJs = require("./defs.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Data table header cell.
 *
 * @element cds-table-header-cell
 * @fires cds-table-header-cell-sort
 *   The custom event fired before a new sort direction is set upon a user gesture.
 *   Cancellation of this event stops the user-initiated change in sort direction.
 */ let CDSTableHeaderCell = class CDSTableHeaderCell extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
        /**
         * `true` if the table has expandable rows
         */ this.isExpandable = false;
        /**
         * `true` if this table has selectable rows
         */ this.isSelectable = false;
        /**
         * `true` if this table header column should be sortable
         */ this.isSortable = false;
        /**
         * `true` if this table header cell is of a primary sorting column.
         */ this.sortActive = false;
    }
    /**
     * Handles `click` event on the sort button.
     *
     */ _handleClickSortButton(event) {
        if (!event.target.matches(this.constructor.aiLabelItem) && !event.target.matches(this.constructor.slugItem)) {
            const nextSortDirection = this._getNextSort();
            const init = {
                bubbles: true,
                cancelable: true,
                composed: true,
                detail: {
                    oldSortDirection: this.sortDirection,
                    sortDirection: nextSortDirection
                }
            };
            const constructor = this.constructor;
            if (this.dispatchEvent(new CustomEvent(constructor.eventBeforeSort, init))) {
                this.sortActive = true;
                this.sortDirection = nextSortDirection;
            }
        }
    }
    /**
     * Handles `slotchange` event.
     *
     */ _handleSlotChange() {
        this.requestUpdate();
    }
    /**
     * Handles `slotchange` event.
     */ _handleAILabelSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || elem.matches(this.constructor.slugItem) : false);
        if (hasContent.length > 0) {
            this._hasAILabel = Boolean(hasContent);
            hasContent[0].setAttribute("size", "mini");
        }
        this.requestUpdate();
    }
    /**
     * @returns The next sort direction.
     */ _getNextSort() {
        const { sortCycle = (0, _defsJs.TABLE_SORT_CYCLE).TRI_STATES_FROM_ASCENDING, sortDirection } = this;
        if (!sortDirection) throw new TypeError("Table sort direction is not defined. Likely that `_getNextSort()` is called with non-sorted table column, which should not happen in regular condition.");
        const directions = this.constructor.TABLE_SORT_CYCLES[sortCycle];
        const index = directions.indexOf(sortDirection);
        if (index < 0) {
            if (sortDirection === (0, _defsJs.TABLE_SORT_DIRECTION).NONE) // If the current sort direction is `none` in bi-state sort cycle, returns the first one in the cycle
            return directions[0];
            throw new RangeError(`The given sort state (${sortDirection}) is not found in the given table sort cycle: ${sortCycle}`);
        }
        return directions[(index + 1) % directions.length];
    }
    /**
     * TODO: Uncomment when Carbon fully implements sticky header
     * Specify whether the header should be sticky.
     * Still experimental: may not work with every combination of table props
     */ // @property({ type: Boolean, reflect: true, attribute: 'sticky-header' })
    // stickyHeader = false;
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "columnheader");
        super.connectedCallback();
    }
    updated(changedProperties) {
        if (this.isSortable && !changedProperties.has("sortDirection") && !this.sortDirection) this.sortDirection = (0, _defsJs.TABLE_SORT_DIRECTION).NONE;
        if (this._hasAILabel) this.setAttribute("ai-label", "");
        else this.removeAttribute("ai-label");
    }
    render() {
        const { sortDirection } = this;
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--table-header-label`]: true,
            [`${0, _settingsJs.prefix}--table-header-label--slug`]: this._hasAILabel
        });
        if (sortDirection) {
            const sortIcon = sortDirection === (0, _defsJs.TABLE_SORT_DIRECTION).NONE ? (0, _32JsDefault.default)({
                part: "sort-icon",
                class: `${(0, _settingsJs.prefix)}--table-sort__icon-unsorted`
            }) : (0, _32JsDefault1.default)({
                part: "sort-icon",
                class: `${(0, _settingsJs.prefix)}--table-sort__icon`
            });
            return (0, _lit.html)`
        <button
          part="sort-button"
          class="${0, _settingsJs.prefix}--table-sort"
          title="${this.innerText}"
          @click=${this._handleClickSortButton}>
          <span class="${0, _settingsJs.prefix}--table-sort__flex">
            <span part="label-text" class="${0, _settingsJs.prefix}--table-header-label"
              ><slot @slotchange=${this._handleSlotChange}></slot
            ></span>
            ${sortIcon}
            <slot
              name="ai-label"
              @slotchange="${this._handleAILabelSlotChange}"></slot>
            <slot
              name="slug"
              @slotchange="${this._handleAILabelSlotChange}"></slot>
          </span>
        </button>
      `;
        }
        return (0, _lit.html)`<span part="label-text" class="${labelClasses}">
      <slot></slot
      ><slot
        name="ai-label"
        @slotchange="${this._handleAILabelSlotChange}"></slot>
      <slot name="slug" @slotchange="${this._handleAILabelSlotChange}"></slot
    ></span> `;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
    /**
     * The name of the custom event fired before a new sort direction is set upon a user gesture.
     * Cancellation of this event stops the user-initiated change in sort direction.
     */ static get eventBeforeSort() {
        return `${0, _settingsJs.prefix}-table-header-cell-sort`;
    }
};
CDSTableHeaderCell.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSTableHeaderCell.styles = (0, _dataTableScssJsDefault.default);
/**
 * Mapping of table sort cycles to table sort states.
 */ CDSTableHeaderCell.TABLE_SORT_CYCLES = (0, _defsJs.TABLE_SORT_CYCLES);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "expandable"
    })
], CDSTableHeaderCell.prototype, "isExpandable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "is-selectable"
    })
], CDSTableHeaderCell.prototype, "isSelectable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "is-sortable"
    })
], CDSTableHeaderCell.prototype, "isSortable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "sort-active"
    })
], CDSTableHeaderCell.prototype, "sortActive", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "sort-cycle"
    })
], CDSTableHeaderCell.prototype, "sortCycle", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "sort-direction"
    })
], CDSTableHeaderCell.prototype, "sortDirection", void 0);
CDSTableHeaderCell = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-header-cell`)
], CDSTableHeaderCell);
var CDSTableHeaderCell$1 = CDSTableHeaderCell;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/class-map.js":"2fQud","../../icons/arrows--vertical/32.js":"g7ZFW","../../icons/arrow--down/32.js":"fJCLp","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./defs.js":"4ND6K","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g7ZFW":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">${children}<path d="M27.6 20.6L24 24.2 24 4 22 4 22 24.2 18.4 20.6 17 22 23 28 29 22zM9 4L3 10 4.4 11.4 8 7.8 8 28 10 28 10 7.8 13.6 11.4 15 10z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1HXeX":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableHeaderRow$1);
var _tslib = require("tslib");
var _settingsJs = require("../../globals/settings.js");
var _tableRowJs = require("./table-row.js");
var _tableRowJsDefault = parcelHelpers.interopDefault(_tableRowJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Data table header row.
 *
 * @element cds-table-header-row
 * @fires cds-table-change-selection-all
 *   The name of the custom event fired before this row is selected/unselected upon a user gesture.
 *   Cancellation of this event stops the user-initiated change in selection.
 */ let CDSTableHeaderRow = class CDSTableHeaderRow extends (0, _tableRowJsDefault.default) {
    /**
     * The name of the custom event fired before this row is selected/unselected upon a user gesture.
     * Cancellation of this event stops the user-initiated change in selection.
     */ static get eventBeforeChangeSelection() {
        return `${0, _settingsJs.prefix}-table-change-selection-all`;
    }
};
CDSTableHeaderRow = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-header-row`)
], CDSTableHeaderRow);
var CDSTableHeaderRow$1 = CDSTableHeaderRow;

},{"tslib":"gBS4y","../../globals/settings.js":"EipuL","./table-row.js":"dbWJ2","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dbWJ2":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableRow$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _16Js = require("../../icons/chevron--right/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _checkboxJs = require("../checkbox/checkbox.js");
var _checkboxGroupJs = require("../checkbox/checkbox-group.js");
var _checkboxSkeletonJs = require("../checkbox/checkbox-skeleton.js");
var _radioButtonJs = require("../radio-button/radio-button.js");
var _radioButtonGroupJs = require("../radio-button/radio-button-group.js");
var _radioButtonSkeletonJs = require("../radio-button/radio-button-skeleton.js");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Data table row.
 *
 * @element cds-table-row
 * @csspart selection-container The container of the checkbox.
 * @csspart selection The checkbox.
 * @fires cds-table-row-change-selection
 *   The custom event fired before this row is selected/unselected upon a user gesture.
 *   Cancellation of this event stops the user-initiated change in selection.
 * @fires cds-radio-button-changed
 *   The name of the custom event fired after this radio button changes its checked state.
 * @fires cds-checkbox-changed
 *   The name of the custom event fired after this checkbox changes its checked state.
 * @fires cds-table-row-expando-beingtoggled
 *   The name of the custom event fired before the expanded state of this row is being toggled upon a user gesture.
 *   Cancellation of this event stops the user-initiated action of toggling the expanded state.
 * @fires cds-table-row-expando-toggled
 *   The name of the custom event fired after the expanded state of this row is toggled upon a user gesture.
 */ let CDSTableRow = class CDSTableRow extends (0, _hostListenerJsDefault1.default)((0, _focusJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
        /**
         * `true` if this table should support batch expansion
         */ this.batchExpansion = false;
        /**
         * `true` if this table row should be disabled.
         */ this.disabled = false;
        /**
         * `true` if this table row is placed at an even position in parent `<cds-table-body>`.
         * `<cds-table-body>` sets this property, _only_ in zebra stripe mode.
         *
         * @private
         */ this.even = false;
        /**
         * `true` if this table row can be expanded to show content underneath
         *
         * @private
         */ this.expandable = false;
        /**
         * `true` when the table row expanded is showing
         *
         * @private
         */ this.expanded = false;
        /**
         * `true` if this table row should be filtered out.
         */ this.filtered = false;
        /**
         * Specify whether the checkbox should be present in the DOM,
         * but invisible and uninteractable.
         */ this.hideCheckbox = false;
        /**
         * `true` if the table row should be highlighted.
         */ this.highlighted = false;
        /**
         * `true` if this table row is placed at an odd position in parent `<cds-table-body>`.
         * `<cds-table-body>` sets this property, _only_ in zebra stripe mode.
         *
         * @private
         */ this.odd = false;
        /**
         * Specify whether the overflow menu (if it exists) should be shown always, or only on hover
         */ this.overflowMenuOnHover = false;
        /**
         * Specify whether the control should be a radio button or inline checkbox
         *
         * @private
         */ this.radio = false;
        /**
         * `true` if this table row should be selected.
         */ this.selected = false;
        /**
         * The `aria-label` attribute for the `<label>` for selection.
         */ this.selectionLabel = "";
        /**
         * The `name` attribute for the `<input>` for selection.
         * If present, this table row will be a selectable one.
         */ this.selectionName = "";
        /**
         * The `value` attribute for the `<input>` for selection.
         */ this.selectionValue = "";
    }
    /**
     * Handles `click` event on the radio button.
     *
     * @param event The event.
     */ _handleClickSelectionRadio(event) {
        var _a;
        const { detail } = event;
        const selected = detail.checked;
        const init = {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: {
                selected
            }
        };
        const constructor = this.constructor;
        if (this.dispatchEvent(new CustomEvent(constructor.eventBeforeChangeSelection, init))) {
            this.selected = selected;
            const { selectorExpandedRow } = this.constructor;
            if ((_a = this.nextElementSibling) === null || _a === void 0 ? void 0 : _a.matches(selectorExpandedRow)) this.nextElementSibling.selected = selected;
        }
    }
    /**
     * Handles `click` event on the check box.
     *
     * @param event The event.
     */ _handleClickSelectionCheckbox(event) {
        var _a;
        const { detail } = event;
        const selected = detail.checked;
        const init = {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: {
                selected
            }
        };
        const constructor = this.constructor;
        if (this.dispatchEvent(new CustomEvent(constructor.eventBeforeChangeSelection, init))) {
            this.selected = selected;
            const { selectorExpandedRow } = this.constructor;
            if ((_a = this.nextElementSibling) === null || _a === void 0 ? void 0 : _a.matches(selectorExpandedRow)) this.nextElementSibling.selected = selected;
        }
    }
    /**
     * Handles `click` event on the expando button.
     */ _handleClickExpando() {
        this._handleUserInitiatedToggleExpando();
    }
    /**
     * Handles `mouseover`/`mouseout` event handler on this element.
     *
     * @param event The event.
     */ _handleMouseOverOut(event) {
        const { selectorExpandedRow, selectorTableCellOverflowMenu } = this.constructor;
        const { nextElementSibling } = this;
        if (nextElementSibling === null || nextElementSibling === void 0 ? void 0 : nextElementSibling.matches(selectorExpandedRow)) nextElementSibling.highlighted = event.type === "mouseover";
        if (this.overflowMenuOnHover) {
            const overflowMenu = this.querySelector(selectorTableCellOverflowMenu);
            const parentCell = overflowMenu === null || overflowMenu === void 0 ? void 0 : overflowMenu.parentElement;
            if (event.type === "mouseout") parentCell.overflowMenuOnHover = true;
            else parentCell.overflowMenuOnHover = false;
        }
    }
    /**
     * Handles user-initiated toggle request of the expando button in this table row.
     *
     * @param expanded The new expanded state.
     */ _handleUserInitiatedToggleExpando(expanded = !this.expanded) {
        const init = {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: {
                expanded
            }
        };
        if (this.dispatchEvent(new CustomEvent(this.constructor.eventBeforeExpandoToggle, init))) {
            this.expanded = expanded;
            this.dispatchEvent(new CustomEvent(this.constructor.eventExpandoToggle, init));
        }
    }
    _renderExpandButton() {
        const { _handleClickExpando: handleClickExpando } = this;
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--table-expand">
        <div>
          <slot name="ai-label" @slotchange="${this._handleSlotChange}"></slot>
          <slot name="slug" @slotchange="${this._handleSlotChange}"></slot>
          <button
            class="${0, _settingsJs.prefix}--table-expand__button"
            @click="${handleClickExpando}">
            ${(0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--table-expand__svg`
        })}
          </button>
        </div>
      </div>
    `;
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || elem.matches(this.constructor.slugItem) : false);
        if (hasContent.length > 0) {
            this._hasAILabel = Boolean(hasContent);
            hasContent[0].setAttribute("size", "mini");
        }
        this.requestUpdate();
    }
    /**
     * @returns The first set of table cells.
     */ _renderFirstCells() {
        const { disabled, hideCheckbox, radio, selected, selectionLabel, selectionName, selectionValue } = this;
        return !selectionName ? undefined : (0, _lit.html)`
          <div class="${0, _settingsJs.prefix}--table-column-checkbox">
            <div>
              <slot
                name="ai-label"
                @slotchange="${this._handleSlotChange}"></slot>
              <slot name="slug" @slotchange="${this._handleSlotChange}"></slot>
              ${radio ? (0, _lit.html)`<cds-radio-button data-table></cds-radio-button>` : (0, _lit.html)`<cds-checkbox
                    hide-label
                    ?hide-checkbox="${hideCheckbox}"
                    label-text="${selectionLabel}"
                    name=${selectionName}
                    data-table
                    ?disabled=${disabled}
                    ?checked=${selected}
                    value=${selectionValue}></cds-checkbox> `}
            </div>
          </div>
        `;
    }
    /**
     * TODO: Uncomment when Carbon fully implements sticky header
     * Specify whether the header should be sticky.
     * Still experimental: may not work with every combination of table props
     */ // @property({ type: Boolean, reflect: true, attribute: 'sticky-header' })
    // stickyHeader = false;
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "row");
        super.connectedCallback();
    }
    updated(changedProperties) {
        if (changedProperties.has("expanded")) {
            const { selectorExpandedRow } = this.constructor;
            const { expanded, nextElementSibling } = this;
            if (nextElementSibling === null || nextElementSibling === void 0 ? void 0 : nextElementSibling.matches(selectorExpandedRow)) nextElementSibling.expanded = expanded;
        }
        if (changedProperties.has("highlighted")) {
            const { selectorExpandedRow } = this.constructor;
            const { highlighted, nextElementSibling } = this;
            if (nextElementSibling === null || nextElementSibling === void 0 ? void 0 : nextElementSibling.matches(selectorExpandedRow)) nextElementSibling.highlighted = highlighted;
        }
        if (this._hasAILabel) this.setAttribute("ai-label", "");
        else this.removeAttribute("ai-label");
    }
    render() {
        var _a;
        if (this.selectionName) (_a = this.closest(this.constructor.selectorTable)) === null || _a === void 0 || _a.setAttribute("is-selectable", "");
        return (0, _lit.html)`
      ${this.expandable ? this._renderExpandButton() : ""}
      ${this._renderFirstCells()}
      <slot></slot>
    `;
    }
    /**
     * The name of the custom event fired after this radio button changes its checked state.
     */ static get eventRadioChange() {
        return `${0, _settingsJs.prefix}-radio-button-changed`;
    }
    /**
     * The name of the custom event fired after this radio button changes its checked state.
     */ static get eventCheckboxChange() {
        return `${0, _settingsJs.prefix}-checkbox-changed`;
    }
    /**
     * The name of the custom event fired before this row is selected/unselected upon a user gesture.
     * Cancellation of this event stops the user-initiated change in selection.
     */ static get eventBeforeChangeSelection() {
        return `${0, _settingsJs.prefix}-table-row-change-selection`;
    }
    /**
     * A selector that will return the parent table
     */ static get selectorTable() {
        return `${0, _settingsJs.prefix}-table`;
    }
    /**
     * The CSS selector to find the overflow menu on the table cell
     */ static get selectorTableCellOverflowMenu() {
        return `${0, _settingsJs.prefix}-table-cell ${0, _settingsJs.prefix}-overflow-menu`;
    }
    /**
     * A selector that will return the corresponding expanded row.
     */ static get selectorExpandedRow() {
        return `${0, _settingsJs.prefix}-table-expanded-row`;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
    /**
     * The name of the custom event fired before the expanded state this row is being toggled upon a user gesture.
     * Cancellation of this event stops the user-initiated action of toggling the expanded state.
     */ static get eventBeforeExpandoToggle() {
        return `${0, _settingsJs.prefix}-table-row-expando-beingtoggled`;
    }
    /**
     * The name of the custom event fired after the expanded state this row is toggled upon a user gesture.
     */ static get eventExpandoToggle() {
        return `${0, _settingsJs.prefix}-table-row-expando-toggled`;
    }
};
CDSTableRow.styles = (0, _dataTableScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("eventRadioChange")
], CDSTableRow.prototype, "_handleClickSelectionRadio", null);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("eventCheckboxChange")
], CDSTableRow.prototype, "_handleClickSelectionCheckbox", null);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("mouseover"),
    (0, _hostListenerJsDefault.default)("mouseout")
], CDSTableRow.prototype, "_handleMouseOverOut", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "batch-expansion"
    })
], CDSTableRow.prototype, "batchExpansion", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableRow.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableRow.prototype, "even", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableRow.prototype, "expandable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableRow.prototype, "expanded", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableRow.prototype, "filtered", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "hide-checkbox"
    })
], CDSTableRow.prototype, "hideCheckbox", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableRow.prototype, "highlighted", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableRow.prototype, "odd", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "overflow-menu-on-hover"
    })
], CDSTableRow.prototype, "overflowMenuOnHover", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableRow.prototype, "radio", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableRow.prototype, "selected", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "selection-label"
    })
], CDSTableRow.prototype, "selectionLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "selection-name"
    })
], CDSTableRow.prototype, "selectionName", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "selection-value"
    })
], CDSTableRow.prototype, "selectionValue", void 0);
CDSTableRow = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-row`)
], CDSTableRow);
var CDSTableRow$1 = CDSTableRow;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../icons/chevron--right/16.js":"bkZcb","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/mixins/focus.js":"5k7ow","./data-table.scss.js":"UdnU6","../checkbox/checkbox.js":"kER9T","../checkbox/checkbox-group.js":"f7lE9","../checkbox/checkbox-skeleton.js":"gxttH","../radio-button/radio-button.js":"gwtyG","../radio-button/radio-button-group.js":"fRk8E","../radio-button/radio-button-skeleton.js":"6Dt6h","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/host-listener.js":"1SMUX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gwtyG":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RADIO_BUTTON_LABEL_POSITION", ()=>(0, _defsJs.RADIO_BUTTON_LABEL_POSITION));
parcelHelpers.export(exports, "default", ()=>CDSRadioButton$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _radioGroupManagerJs = require("../../globals/internal/radio-group-manager.js");
var _radioGroupManagerJsDefault = parcelHelpers.interopDefault(_radioGroupManagerJs);
var _defsJs = require("./defs.js");
var _radioButtonScssJs = require("./radio-button.scss.js");
var _radioButtonScssJsDefault = parcelHelpers.interopDefault(_radioButtonScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Map of navigation direction by key for horizontal alignment.
 */ const navigationDirectionForKeyHorizontal = {
    ArrowLeft: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).BACKWARD,
    Left: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).BACKWARD,
    ArrowRight: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).FORWARD,
    Right: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).FORWARD
};
/**
 * Map of navigation direction by key for vertical alignment.
 */ const navigationDirectionForKeyVertical = {
    ArrowUp: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).BACKWARD,
    Up: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).BACKWARD,
    ArrowDown: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).FORWARD,
    Down: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).FORWARD
};
/**
 * The interface for `RadioGroupManager` for radio button.
 */ class RadioButtonDelegate {
    constructor(radio){
        this._radio = radio;
    }
    get checked() {
        return this._radio.checked;
    }
    set checked(checked) {
        const { host } = this._radio.getRootNode();
        const { eventChange } = host.constructor; // eslint-disable-line no-use-before-define
        host.checked = checked;
        this._radio.tabIndex = checked ? 0 : -1;
        host.dispatchEvent(new CustomEvent(eventChange, {
            bubbles: true,
            composed: true,
            detail: {
                checked
            }
        }));
    }
    get tabIndex() {
        return this._radio.tabIndex;
    }
    set tabIndex(tabIndex) {
        this._radio.tabIndex = tabIndex;
    }
    get name() {
        return this._radio.name;
    }
    compareDocumentPosition(other) {
        return this._radio.compareDocumentPosition(other._radio);
    }
    focus() {
        this._radio.focus();
    }
}
/**
 * Radio button.
 *
 * @element cds-radio-button
 * @fires cds-radio-button-changed - The custom event fired after this radio button changes its checked state.
 */ let CDSRadioButton = class CDSRadioButton extends (0, _hostListenerJsDefault1.default)((0, _focusJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * The radio group manager associated with the radio button.
         */ this._manager = null;
        /**
         * Handles `click` event on this element.
         */ this._handleClick = (event)=>{
            var _a, _b;
            if (!event.target.matches((_a = this.constructor) === null || _a === void 0 ? void 0 : _a.aiLabelItem) && !event.target.matches((_b = this.constructor) === null || _b === void 0 ? void 0 : _b.slugItem)) {
                const { disabled, _radioButtonDelegate: radioButtonDelegate } = this;
                if (radioButtonDelegate && !disabled && !this.disabledItem) {
                    this.checked = true;
                    if (this._manager) this._manager.select(radioButtonDelegate, this.readOnly);
                    this.dispatchEvent(new CustomEvent(this.constructor.eventChange, {
                        bubbles: true,
                        composed: true,
                        detail: {
                            checked: this.checked
                        }
                    }));
                }
                this.dispatchEvent(new CustomEvent(this.constructor.eventChange, {
                    bubbles: true,
                    composed: true,
                    detail: {
                        checked: this.checked
                    }
                }));
            }
        };
        /**
         * Handles `keydown` event on this element.
         */ this._handleKeydown = (event)=>{
            var _a, _b;
            if (!event.target.matches((_a = this.constructor) === null || _a === void 0 ? void 0 : _a.aiLabelItem) && !event.target.matches((_b = this.constructor) === null || _b === void 0 ? void 0 : _b.slugItem)) {
                const { orientation, _radioButtonDelegate: radioButtonDelegate } = this;
                const manager = this._manager;
                if (radioButtonDelegate && manager) {
                    const navigationDirectionForKey = orientation === (0, _defsJs.RADIO_BUTTON_ORIENTATION).HORIZONTAL ? navigationDirectionForKeyHorizontal : navigationDirectionForKeyVertical;
                    const navigationDirection = navigationDirectionForKey[event.key];
                    if (navigationDirection) manager.select(manager.navigate(radioButtonDelegate, navigationDirection), this.readOnly);
                    if (event.key === " " || event.key === "Enter") manager.select(radioButtonDelegate, this.readOnly);
                }
            }
        };
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
        /**
         * `true` if this radio button should be checked.
         */ this.checked = false;
        /**
         * `true` if the radio button is used in a data table
         */ this.dataTable = false;
        /**
         * `true` if the radio button item should be disabled.
         */ this.disabledItem = false;
        /**
         * `true` if the radio button group should be disabled.
         */ this.disabled = false;
        /**
         * `true` if the label should be hidden.
         */ this.hideLabel = false;
        /**
         * Specify if the currently value is invalid.
         */ this.invalid = false;
        /**
         * The label position.
         */ this.labelPosition = (0, _defsJs.RADIO_BUTTON_LABEL_POSITION).RIGHT;
        /**
         * The label text.
         */ this.labelText = "";
        /**
         * The orientation to lay out radio buttons.
         */ this.orientation = (0, _defsJs.RADIO_BUTTON_ORIENTATION).HORIZONTAL;
        /**
         * `true` if the radio button group should be disabled.
         */ this.readOnly = false;
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || // remove reference to slug in v12
            elem.matches(this.constructor.slugItem) : false);
        this._hasAILabel = Boolean(hasContent);
        const type = hasContent[0].getAttribute("kind");
        hasContent[0].setAttribute("size", type === "inline" ? "md" : "mini");
        this.requestUpdate();
    }
    disconnectedCallback() {
        if (this._manager) this._manager.delete(this._radioButtonDelegate);
        super.disconnectedCallback();
    }
    firstUpdated() {
        this._radioButtonDelegate = new RadioButtonDelegate(this._inputNode);
    }
    updated(changedProperties) {
        const { _hasAILabel: hasAILabel, _inputNode: inputNode, _radioButtonDelegate: radioButtonDelegate, name } = this;
        if (changedProperties.has("checked") || changedProperties.has("name")) {
            if (this.readOnly) this.checked = false;
            if (!this._manager) this._manager = (0, _radioGroupManagerJsDefault.default).get(this.getRootNode({
                composed: true
            }));
            const { _manager: manager } = this;
            if (changedProperties.has("name")) {
                manager.delete(radioButtonDelegate, changedProperties.get("name"));
                if (name) manager.add(radioButtonDelegate);
            }
            inputNode.setAttribute("tabindex", !name || !manager || !manager.shouldBeFocusable(radioButtonDelegate) ? "-1" : "0");
        }
        hasAILabel ? this.setAttribute("ai-label", "") : this.removeAttribute("ai-label");
    }
    render() {
        const { checked, hideLabel, labelText, name, value, disabled, disabledItem } = this;
        const innerLabelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--radio-button__label-text`]: true,
            [`${0, _settingsJs.prefix}--visually-hidden`]: hideLabel
        });
        return (0, _lit.html)`
      <input
        id="radio"
        type="radio"
        class="${0, _settingsJs.prefix}--radio-button"
        .checked=${checked}
        ?disabled="${disabledItem || disabled}"
        name=${(0, _ifDefinedJs.ifDefined)(name)}
        value=${(0, _ifDefinedJs.ifDefined)(value)} />
      <label for="input" class="${0, _settingsJs.prefix}--radio-button__label">
        <span class="${0, _settingsJs.prefix}--radio-button__appearance"></span>
        <span class="${innerLabelClasses}">
          ${labelText}
          <slot name="ai-label" @slotchange="${this._handleSlotChange}"></slot>
          <slot name="slug" @slotchange="${this._handleSlotChange}"></slot
        ></span>
      </label>
    `;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
    /**
     * The name of the custom event fired after this radio button changes its checked state.
     */ static get eventChange() {
        return `${0, _settingsJs.prefix}-radio-button-changed`;
    }
};
CDSRadioButton.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSRadioButton.styles = (0, _radioButtonScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("input")
], CDSRadioButton.prototype, "_inputNode", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("click")
], CDSRadioButton.prototype, "_handleClick", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("keydown")
], CDSRadioButton.prototype, "_handleKeydown", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSRadioButton.prototype, "checked", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "data-table"
    })
], CDSRadioButton.prototype, "dataTable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSRadioButton.prototype, "disabledItem", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSRadioButton.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "hide-label"
    })
], CDSRadioButton.prototype, "hideLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSRadioButton.prototype, "invalid", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "label-position"
    })
], CDSRadioButton.prototype, "labelPosition", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label-text"
    })
], CDSRadioButton.prototype, "labelText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSRadioButton.prototype, "name", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSRadioButton.prototype, "orientation", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSRadioButton.prototype, "readOnly", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSRadioButton.prototype, "value", void 0);
CDSRadioButton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-radio-button`)
], CDSRadioButton);
var CDSRadioButton$1 = CDSRadioButton;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","lit/directives/if-defined.js":"hSgrS","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/focus.js":"5k7ow","../../globals/mixins/host-listener.js":"1SMUX","../../globals/internal/radio-group-manager.js":"jgXqY","./defs.js":"1nEz3","./radio-button.scss.js":"hnCkD","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jgXqY":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The navigation direction.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NAVIGATION_DIRECTION", ()=>NAVIGATION_DIRECTION);
parcelHelpers.export(exports, "default", ()=>RadioGroupManager);
var NAVIGATION_DIRECTION;
(function(NAVIGATION_DIRECTION) {
    /**
     * Navigating backward.
     */ NAVIGATION_DIRECTION[NAVIGATION_DIRECTION["BACKWARD"] = -1] = "BACKWARD";
    /**
     * Navigating forward.
     */ NAVIGATION_DIRECTION[NAVIGATION_DIRECTION["FORWARD"] = 1] = "FORWARD";
})(NAVIGATION_DIRECTION || (NAVIGATION_DIRECTION = {}));
/**
 * An object that manages radio groups in a document.
 * There must be only one instance for one document.
 */ class RadioGroupManager {
    constructor(document){
        /**
         * Radio groups, keyed by their names.
         */ this._groups = {};
        this.constructor._instances.set(document, this);
    }
    /**
     * @param radio A radio button.
     * @returns
     *   `true` if the given radio button should be focusable, which is either:
     *   - The radio button is selected
     *   - No radio button is selected and the radio button is first one in the radio group
     */ shouldBeFocusable(radio) {
        if (radio.checked) return true;
        const { name } = radio;
        const group = this._groups[name];
        const hasSelectedItemInGroup = group && Array.from(group).some((item)=>item.checked);
        if (hasSelectedItemInGroup) return false;
        const isFirstInGroup = !group || group.size === 1 || this.getSortedGroup(radio)[0] === radio;
        return isFirstInGroup;
    }
    /**
     * @param radio A radio button.
     * @returns The sorted radio group the given radio button is in.
     */ getSortedGroup(radio) {
        const group = this._groups[radio.name];
        return group && Array.from(group).sort((lhs, rhs)=>{
            const comparisonResult = lhs.compareDocumentPosition(rhs);
            // eslint-disable-next-line no-bitwise
            if (comparisonResult & Node.DOCUMENT_POSITION_FOLLOWING || comparisonResult & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
            // eslint-disable-next-line no-bitwise
            if (comparisonResult & Node.DOCUMENT_POSITION_PRECEDING || comparisonResult & Node.DOCUMENT_POSITION_CONTAINS) return 1;
            return 0;
        });
    }
    /**
     * Manages a radio button.
     *
     * @param radio The radio button to manage.
     * @returns This object.
     */ add(radio) {
        const { name } = radio;
        if (name) {
            const groups = this._groups;
            if (!groups[name]) groups[name] = new Set();
            groups[name].add(radio);
        }
        return this;
    }
    /**
     * Unmanages a radio button.
     *
     * @param radio The radio button to unmanage.
     * @param name The old name of the radio button to unmanage.
     * @returns `true` if `element` was actually managed.
     */ delete(radio, name = radio.name) {
        const group = this._groups[name];
        return !group ? false : group.delete(radio);
    }
    /**
     * Selects or focuses on a radio button.
     *
     * @param radio The radio button to select.
     * @param readOnly optional if radio button has readOnly.
     */ select(radio, readOnly) {
        const group = this._groups[radio.name];
        if (group) {
            // Updates the state of the one being selected up-front to avoid the state of no radio button is selected
            radio.checked = !readOnly || true;
            radio.tabIndex = 0;
            radio.focus();
            group.forEach((item)=>{
                if (radio !== item) {
                    item.checked = readOnly || false;
                    item.tabIndex = -1;
                }
            });
        }
    }
    /**
     * @param radio The currently selected radio button.
     * @param direction The direction to navigate to.
     * @returns The radio button that should be selected next.
     */ navigate(radio, direction) {
        const sortedGroup = this.getSortedGroup(radio);
        let newIndex = sortedGroup.indexOf(radio) + direction;
        if (newIndex < 0) newIndex = sortedGroup.length - 1;
        else if (newIndex >= sortedGroup.length) newIndex = 0;
        return sortedGroup[newIndex];
    }
    /**
     * @param document A document element.
     * @returns The `RadioGroupManager` instance associated with the given document.
     */ static get(document) {
        const found = this._instances.get(document);
        return found || new RadioGroupManager(document);
    }
}
/**
 * `RadioGroupManager` instances associated with documents.
 */ RadioGroupManager._instances = new WeakMap();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1nEz3":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The label position of radio button.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RADIO_BUTTON_LABEL_POSITION", ()=>RADIO_BUTTON_LABEL_POSITION);
parcelHelpers.export(exports, "RADIO_BUTTON_ORIENTATION", ()=>RADIO_BUTTON_ORIENTATION);
var RADIO_BUTTON_LABEL_POSITION;
(function(RADIO_BUTTON_LABEL_POSITION) {
    /**
     * Placed at left.
     */ RADIO_BUTTON_LABEL_POSITION["LEFT"] = "left";
    /**
     * Placed at right.
     */ RADIO_BUTTON_LABEL_POSITION["RIGHT"] = "right";
})(RADIO_BUTTON_LABEL_POSITION || (RADIO_BUTTON_LABEL_POSITION = {}));
/**
 * How to lay out radio buttons.
 */ var RADIO_BUTTON_ORIENTATION;
(function(RADIO_BUTTON_ORIENTATION) {
    /**
     * Laying out radio buttons horizontally.
     */ RADIO_BUTTON_ORIENTATION["HORIZONTAL"] = "horizontal";
    /**
     * Laying out radio buttons vertically.
     */ RADIO_BUTTON_ORIENTATION["VERTICAL"] = "vertical";
})(RADIO_BUTTON_ORIENTATION || (RADIO_BUTTON_ORIENTATION = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hnCkD":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item,:host(cds-radio-button-group){align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--radio-button-group{align-items:center;border:0;box-sizing:border-box;display:flex;font-family:inherit;font-size:100%;margin:0;padding:0;position:relative;vertical-align:baseline}.cds--radio-button-group *,.cds--radio-button-group :after,.cds--radio-button-group :before{box-sizing:inherit}.cds--label+.cds--form-item .cds--radio-button-group,.cds--label+:host(cds-radio-button-group) .cds--radio-button-group{margin-block-start:0}.cds--radio-button-group--vertical,:host(cds-radio-button-group[orientation=vertical]){align-items:flex-start;flex-direction:column}.cds--radio-button-group--vertical.cds--radio-button-group--label-left{align-items:flex-end}.cds--radio-button-group--vertical .cds--radio-button__label,:host(cds-radio-button-group[orientation=vertical]) .cds--radio-button__label{margin-inline-end:0}.cds--radio-button-group--vertical .cds--radio-button__label:not(:last-of-type),:host(cds-radio-button-group[orientation=vertical]) .cds--radio-button__label:not(:last-of-type){margin-block-end:.5rem}.cds--radio-button{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;margin-block-start:.9rem;margin-inline-start:.63rem;visibility:inherit;white-space:nowrap}.cds--radio-button__label{align-items:center;cursor:pointer;display:flex;margin-inline-end:1rem}.cds--radio-button__label-text{flex:1;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--radio-button__appearance{background-color:transparent;block-size:1.125rem;border:0;border:1px solid var(--cds-icon-primary,#161616);border-radius:50%;box-sizing:border-box;flex-shrink:0;font-family:inherit;font-size:100%;inline-size:1.125rem;margin:0;margin-block:.0625rem .125rem;margin-inline:.125rem .625rem;padding:0;vertical-align:baseline}.cds--radio-button__appearance *,.cds--radio-button__appearance :after,.cds--radio-button__appearance :before{box-sizing:inherit}.cds--radio-button-group--vertical .cds--radio-button__appearance,:host(cds-radio-button-group[orientation=vertical]) .cds--radio-button__appearance{margin-block:0}.cds--radio-button:checked+.cds--radio-button__label .cds--radio-button__appearance{align-items:center;border-color:var(--cds-icon-primary,#161616);display:flex;justify-content:center}.cds--radio-button:checked+.cds--radio-button__label .cds--radio-button__appearance:before{background-color:var(--cds-icon-primary,#161616);block-size:100%;border-radius:50%;content:"";display:inline-block;inline-size:100%;position:relative;transform:scale(.5)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--radio-button:checked+.cds--radio-button__label .cds--radio-button__appearance:before{fill:ButtonText;background-color:ButtonText}}@media print{.cds--radio-button:checked+.cds--radio-button__label .cds--radio-button__appearance:before{-webkit-print-color-adjust:exact;print-color-adjust:exact}}.cds--radio-button:disabled+.cds--radio-button__label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--radio-button:disabled+.cds--radio-button__label .cds--radio-button__appearance,.cds--radio-button:disabled:checked+.cds--radio-button__label .cds--radio-button__appearance{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--radio-button:disabled+.cds--radio-button__label .cds--radio-button__appearance:before,.cds--radio-button:disabled:checked+.cds--radio-button__label .cds--radio-button__appearance:before{background-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--radio-button-group--readonly .cds--radio-button+.cds--radio-button__label .cds--radio-button__appearance,:host(cds-radio-button[readOnly]) .cds--radio-button+.cds--radio-button__label .cds--radio-button__appearance{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--radio-button-group--readonly .cds--radio-button__label,:host(cds-radio-button[readOnly]) .cds--radio-button__label{cursor:default}.cds--radio-button-group--readonly .cds--radio-button__label-text,:host(cds-radio-button[readOnly]) .cds--radio-button__label-text{cursor:text;-webkit-user-select:text;-moz-user-select:text;user-select:text}.cds--radio-button-group--invalid .cds--radio-button+.cds--radio-button__label .cds--radio-button__appearance{border-color:var(--cds-support-error,#da1e28)}.cds--radio-button__validation-msg{align-items:flex-end;display:none;margin-block-start:.375rem}.cds--radio-button__invalid-icon{fill:var(--cds-support-error,#da1e28);margin-inline:.1875rem .0625rem}.cds--radio-button__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--radio-button__invalid-icon--warning path:first-of-type{fill:#000}.cds--radio-button-group--invalid+.cds--radio-button__validation-msg,.cds--radio-button-group--warning+.cds--radio-button__validation-msg{display:flex}.cds--radio-button-group--invalid+.cds--radio-button__validation-msg .cds--form-requirement,.cds--radio-button-group--warning+.cds--radio-button__validation-msg .cds--form-requirement{display:block;margin-block-start:0;margin-inline-start:.5rem;max-block-size:100%;overflow:visible}.cds--radio-button-group--invalid+.cds--radio-button__validation-msg .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--radio-button-group~.cds--form__helper-text{margin-block-start:.375rem}.cds--radio-button:focus+.cds--radio-button__label .cds--radio-button__appearance{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1.5px}.cds--radio-button__label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:1.125rem;border:none;box-shadow:none;inline-size:6.25rem;padding:0;pointer-events:none;position:relative}.cds--radio-button__label.cds--skeleton:active,.cds--radio-button__label.cds--skeleton:focus,.cds--radio-button__label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--radio-button__label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--radio-button__label.cds--skeleton:before{animation:none}}.cds--radio-button__label.cds--skeleton .cds--radio-button__appearance{display:none}.cds--radio-button-wrapper .cds--radio-button__label,:host(cds-radio-button) .cds--radio-button__label{align-items:flex-start;display:flex;justify-content:center;margin:0}.cds--radio-button-wrapper:not(:last-of-type),:not(:last-of-type):host(cds-radio-button){margin-inline-end:1rem}.cds--radio-button-group--vertical .cds--radio-button-wrapper,.cds--radio-button-group--vertical :host(cds-radio-button),:host(cds-radio-button-group[orientation=vertical]) .cds--radio-button-wrapper,:host(cds-radio-button-group[orientation=vertical]) :host(cds-radio-button){margin-block-end:.375rem;margin-inline-end:0}.cds--radio-button-group--vertical .cds--radio-button-wrapper .cds--radio-button__label,.cds--radio-button-group--vertical :host(cds-radio-button) .cds--radio-button__label,:host(cds-radio-button-group[orientation=vertical]) .cds--radio-button-wrapper .cds--radio-button__label,:host(cds-radio-button-group[orientation=vertical]) :host(cds-radio-button) .cds--radio-button__label{padding-block-start:.125rem}.cds--radio-button-group--label-right .cds--radio-button__label,.cds--radio-button-wrapper.cds--radio-button-wrapper--label-right .cds--radio-button__label{flex-direction:row}.cds--radio-button-group--label-left .cds--radio-button__label,.cds--radio-button-wrapper.cds--radio-button-wrapper--label-left .cds--radio-button__label,:host(cds-radio-button-group[label-position=left]) .cds--radio-button__label{flex-direction:row-reverse}.cds--radio-button-group--label-left .cds--radio-button__appearance,.cds--radio-button-wrapper.cds--radio-button-wrapper--label-left .cds--radio-button__appearance,:host(cds-radio-button-group[label-position=left]) .cds--radio-button__appearance{margin-inline:.5rem 0}.cds--radio-button-group--decorator legend.cds--label,.cds--radio-button-group--slug legend.cds--label,.cds--radio-button-wrapper--decorator .cds--radio-button__label-text,.cds--radio-button-wrapper--slug .cds--radio-button__label-text{display:flex}.cds--radio-button-group--decorator legend.cds--label .cds--radio-button-group-inner--decorator>*,.cds--radio-button-group--slug legend.cds--label .cds--ai-label,.cds--radio-button-group--slug legend.cds--label .cds--slug,.cds--radio-button-wrapper--decorator .cds--radio-button__label-text .cds--radio-button-wrapper-inner--decorator>*,.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--ai-label,.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--slug{margin-inline-start:.5rem}.cds--radio-button-wrapper--decorator .cds--radio-button__label-text .cds--ai-label__button--inline,.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--ai-label__button--inline,.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--slug__button--inline{line-height:inherit;margin-block-start:-.0625rem}:host(cds-radio-button-group[invalid]) .cds--radio-button__validation-msg,:host(cds-radio-button-group[warn]) .cds--radio-button__validation-msg{display:flex}:host(cds-radio-button-group[invalid]) .cds--radio-button__validation-msg .cds--form-requirement,:host(cds-radio-button-group[warn]) .cds--radio-button__validation-msg .cds--form-requirement{display:block;margin-block-start:0;margin-inline-start:.5rem;max-block-size:100%;overflow:visible}:host(cds-radio-button-group[invalid]) .cds--form-requirement{color:var(--cds-text-error,#da1e28)}:host(cds-radio-button){outline:none}:host(cds-radio-button) .cds--radio-button__label{flex-direction:row}:host(cds-radio-button:not(:last-of-type)){margin-inline-end:1rem}:host(cds-radio-button[orientation=vertical]){margin-block-end:.375rem;margin-inline-end:0}:host(cds-radio-button[invalid]) .cds--radio-button__appearance{border-color:var(--cds-support-error,#da1e28)!important}:host(cds-radio-button[data-table]) .cds--radio-button__label{inline-size:1.75rem}:host(cds-radio-button[data-table]) .cds--radio-button__appearance{margin-inline-end:-.125rem}:host(cds-radio-button[disabledItem]) .cds--radio-button__label,:host(cds-radio-button[disabled]) .cds--radio-button__label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}:host(cds-radio-button[disabledItem]) .cds--radio-button__appearance,:host(cds-radio-button[disabled]) .cds--radio-button__appearance{border-color:var(--cds-border-disabled,#c6c6c6)}:host(cds-radio-button[disabledItem]) .cds--radio-button__appearance:before,:host(cds-radio-button[disabled]) .cds--radio-button__appearance:before{background-color:var(--cds-border-disabled,#c6c6c6)}:host(cds-radio-button[label-position=left]) .cds--radio-button__label{flex-direction:row-reverse}:host(cds-radio-button[label-position=left]) .cds--radio-button__appearance{margin-inline:.5rem 0}:host(cds-radio-button[ai-label]) .cds--radio-button__label-text{display:flex}:host(cds-radio-button[ai-label]) ::slotted(cds-ai-label[inline]),:host(cds-radio-button[ai-label]) ::slotted(cds-slug[inline]){line-height:inherit;margin-block-start:-.0625rem}:host(cds-radio-button-group) .cds--radio-button-group--slug ::slotted(cds-ai-label),:host(cds-radio-button-group) .cds--radio-button-group--slug ::slotted(cds-slug),:host(cds-radio-button[ai-label]) ::slotted(cds-ai-label),:host(cds-radio-button[ai-label]) ::slotted(cds-slug){margin-inline-start:.5rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fRk8E":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RADIO_BUTTON_ORIENTATION", ()=>(0, _defsJs.RADIO_BUTTON_ORIENTATION));
parcelHelpers.export(exports, "default", ()=>CDSRadioButtonGroup$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _classMapJs = require("lit/directives/class-map.js");
var _settingsJs = require("../../globals/settings.js");
var _formJs = require("../../globals/mixins/form.js");
var _formJsDefault = parcelHelpers.interopDefault(_formJs);
var _hostListenerJs = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _defsJs = require("./defs.js");
var _16Js = require("../../icons/warning--filled/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/warning--alt--filled/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _radioButtonScssJs = require("./radio-button.scss.js");
var _radioButtonScssJsDefault = parcelHelpers.interopDefault(_radioButtonScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Radio button group.
 *
 * @element cds-radio-button-group
 * @fires cds-radio-button-group-changed - The custom event fired after this radio button group changes its selected item.
 * @fires cds-radio-button-changed
 *   The name of the custom event fired after a radio button changes its checked state.
 */ let CDSRadioButtonGroup = class CDSRadioButtonGroup extends (0, _formJsDefault.default)((0, _hostListenerJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * Handles user-initiated change in selected radio button.
         */ this._handleAfterChangeRadioButton = ()=>{
            const { selectorRadioButton } = this.constructor;
            const selected = (0, _collectionHelpersJs.find)(this.querySelectorAll(selectorRadioButton), (elem)=>elem.checked);
            const oldValue = this.value;
            this.value = selected && selected.value;
            if (oldValue !== this.value) {
                const { eventChange } = this.constructor;
                this.dispatchEvent(new CustomEvent(eventChange, {
                    bubbles: true,
                    composed: true,
                    detail: {
                        value: this.value
                    }
                }));
            }
        };
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
        /**
         * `true` if the radio button group should be disabled.
         */ this.disabled = false;
        /**
         * The label position.
         */ this.labelPosition = (0, _defsJs.RADIO_BUTTON_LABEL_POSITION).RIGHT;
        /**
         * The label position.
         */ this.legendText = "";
        /**
         * Specify whether the control is currently in warning state
         */ this.warn = false;
        /**
         * Provide the text that is displayed when the control is in warning state
         */ this.warnText = "";
        /**
         * Specify if the currently value is invalid.
         */ this.invalid = false;
        /**
         * Message which is displayed if the value is invalid.
         */ this.invalidText = "";
        /**
         * The orientation to lay out radio buttons.
         */ this.orientation = (0, _defsJs.RADIO_BUTTON_ORIENTATION).HORIZONTAL;
        /**
         * Controls the readonly state of the radio button group.
         */ this.readOnly = false;
    }
    _handleFormdata(event) {
        const { formData } = event; // TODO: Wait for `FormDataEvent` being available in `lib.dom.d.ts`
        const { disabled, name, value } = this;
        if (!disabled && typeof name !== "undefined" && typeof value !== "undefined") formData.append(name, value);
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || // remove reference to slug in v12
            elem.matches(this.constructor.slugItem) : false);
        this._hasAILabel = Boolean(hasContent);
        hasContent[0].setAttribute("size", "mini");
        this.requestUpdate();
    }
    updated(changedProperties) {
        const { selectorRadioButton } = this.constructor;
        [
            "disabled",
            "labelPosition",
            "orientation",
            "readOnly",
            "name"
        ].forEach((name)=>{
            if (changedProperties.has(name)) {
                const { [name]: value } = this;
                // Propagate the property to descendants until `:host-context()` gets supported in all major browsers
                (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorRadioButton), (elem)=>{
                    elem[name] = value;
                });
            }
        });
        if (changedProperties.has("value")) {
            const { value } = this;
            (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorRadioButton), (elem)=>{
                elem.checked = value === elem.value;
            });
        }
        if (changedProperties.has("invalid")) (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorRadioButton), (elem)=>{
            elem.invalid = this.invalid;
        });
    }
    render() {
        const { readOnly, invalid, invalidText, warn, warnText, disabled, orientation, legendText, helperText, _hasAILabel: hasAILabel, _handleSlotChange: handleSlotChange } = this;
        const showWarning = !readOnly && !invalid && warn;
        const showHelper = !invalid && !disabled && !warn;
        const invalidIcon = (0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--radio-button__invalid-icon`
        });
        const warnIcon = (0, _16JsDefault1.default)({
            class: `${(0, _settingsJs.prefix)}--radio-button__invalid-icon ${(0, _settingsJs.prefix)}--radio-button__invalid-icon--warning`
        });
        const helper = helperText ? (0, _lit.html)`<div class="${0, _settingsJs.prefix}--form__helper-text">${helperText}</div>` : null;
        const fieldsetClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--radio-button-group`]: true,
            [`${0, _settingsJs.prefix}--radio-button-group--readonly`]: readOnly,
            [`${0, _settingsJs.prefix}--radio-button-group--${orientation}`]: orientation === "vertical",
            [`${0, _settingsJs.prefix}--radio-button-group--slug`]: hasAILabel
        });
        return (0, _lit.html)` <fieldset
        class="${fieldsetClasses}"
        ?disabled="${disabled}"
        aria-readonly="${readOnly}">
        ${legendText ? (0, _lit.html)` <legend class="${0, _settingsJs.prefix}--label">
              ${legendText}
              <slot name="ai-label" @slotchange="${handleSlotChange}"></slot>
              <slot name="slug" @slotchange="${handleSlotChange}"></slot>
            </legend>` : ``}
        <slot></slot>
      </fieldset>
      <div class="${0, _settingsJs.prefix}--radio-button__validation-msg">
        ${!readOnly && invalid ? (0, _lit.html)`
              ${invalidIcon}
              <div class="${0, _settingsJs.prefix}--form-requirement">${invalidText}</div>
            ` : null}
        ${showWarning ? (0, _lit.html)`${warnIcon}
              <div class="${0, _settingsJs.prefix}--form-requirement">${warnText}</div>` : null}
      </div>
      ${showHelper ? helper : null}`;
    }
    /**
     * A selector that will return the radio buttons.
     */ static get selectorRadioButton() {
        return `${0, _settingsJs.prefix}-radio-button`;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
    /**
     * The name of the custom event fired after this radio button group changes its selected item.
     */ static get eventChange() {
        return `${0, _settingsJs.prefix}-radio-button-group-changed`;
    }
    /**
     * The name of the custom event fired after a radio button changes its checked state.
     */ static get eventChangeRadioButton() {
        return `${0, _settingsJs.prefix}-radio-button-changed`;
    }
};
CDSRadioButtonGroup.styles = (0, _radioButtonScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("eventChangeRadioButton")
], CDSRadioButtonGroup.prototype, "_handleAfterChangeRadioButton", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSRadioButtonGroup.prototype, "defaultSelected", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSRadioButtonGroup.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "label-position"
    })
], CDSRadioButtonGroup.prototype, "labelPosition", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "legend-text"
    })
], CDSRadioButtonGroup.prototype, "legendText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "helper-text"
    })
], CDSRadioButtonGroup.prototype, "helperText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSRadioButtonGroup.prototype, "warn", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "warn-text"
    })
], CDSRadioButtonGroup.prototype, "warnText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSRadioButtonGroup.prototype, "invalid", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "invalid-text"
    })
], CDSRadioButtonGroup.prototype, "invalidText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSRadioButtonGroup.prototype, "name", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSRadioButtonGroup.prototype, "orientation", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSRadioButtonGroup.prototype, "readOnly", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSRadioButtonGroup.prototype, "value", void 0);
CDSRadioButtonGroup = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-radio-button-group`)
], CDSRadioButtonGroup);
var CDSRadioButtonGroup$1 = CDSRadioButtonGroup;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/class-map.js":"2fQud","../../globals/settings.js":"EipuL","../../globals/mixins/form.js":"kISjL","../../globals/mixins/host-listener.js":"1SMUX","../../globals/decorators/host-listener.js":"f95Mj","../../globals/internal/collection-helpers.js":"4aZkz","./defs.js":"1nEz3","../../icons/warning--filled/16.js":"ajngV","../../icons/warning--alt--filled/16.js":"21PDf","./radio-button.scss.js":"hnCkD","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Dt6h":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSRadioButtonSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _radioButtonScssJs = require("./radio-button.scss.js");
var _radioButtonScssJsDefault = parcelHelpers.interopDefault(_radioButtonScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of radio button.
 */ let CDSRadioButtonSkeleton = class CDSRadioButtonSkeleton extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--radio-button ${0, _settingsJs.prefix}--skeleton"></div>
      <span class="${0, _settingsJs.prefix}--radio-button__label ${0, _settingsJs.prefix}--skeleton"></span>
    `;
    }
};
CDSRadioButtonSkeleton.styles = (0, _radioButtonScssJsDefault.default);
CDSRadioButtonSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-radio-button-skeleton`)
], CDSRadioButtonSkeleton);
var CDSRadioButtonSkeleton$1 = CDSRadioButtonSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./radio-button.scss.js":"hnCkD","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ilOlc":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableToolbar$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Table toolbar.
 *
 * @element cds-table-toolbar
 */ let CDSTableToolbar = class CDSTableToolbar extends (0, _lit.LitElement) {
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "section");
        super.connectedCallback();
    }
    updated(changedProperties) {
        if (changedProperties.has("size")) this.querySelector(this.constructor.selectorToolbarContent).size = this.size;
    }
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
    /**
     * The CSS selector to find the toolbar contents
     */ static get selectorToolbarContent() {
        return `${0, _settingsJs.prefix}-table-toolbar-content`;
    }
};
CDSTableToolbar.styles = (0, _dataTableScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTableToolbar.prototype, "size", void 0);
CDSTableToolbar = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-toolbar`)
], CDSTableToolbar);
var CDSTableToolbar$1 = CDSTableToolbar;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1BFk5":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableToolbarContent$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Table toolbar content.
 *
 * @element cds-table-toolbar-content
 */ let CDSTableToolbarContent = class CDSTableToolbarContent extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if this batch actions bar is active.
         */ this.hasBatchActions = false;
    }
    updated(changedProperties) {
        if (changedProperties.has("hasBatchActions")) this.setAttribute("tabindex", `${this.hasBatchActions ? "-1" : ""}`);
        if (changedProperties.has("size")) [
            ...this.children
        ].forEach((e)=>{
            const size = this.size === "xs" ? "sm" : this.size === "md" || this.size === "xl" ? "lg" : this.size;
            e.setAttribute("size", size);
        });
    }
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSTableToolbarContent.styles = (0, _dataTableScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "has-batch-actions"
    })
], CDSTableToolbarContent.prototype, "hasBatchActions", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTableToolbarContent.prototype, "size", void 0);
CDSTableToolbarContent = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-toolbar-content`)
], CDSTableToolbarContent);
var CDSTableToolbarContent$1 = CDSTableToolbarContent;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aPog0":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTableToolbarSearch$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _hostListenerJs = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _textInputJs = require("../text-input/text-input.js");
var _searchJs = require("../search/search.js");
var _searchJsDefault = parcelHelpers.interopDefault(_searchJs);
var _dataTableScssJs = require("./data-table.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("../text-input/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Table toolbar search.
 *
 * @element cds-table-toolbar-search
 * @fires cds-search-input - The custom event fired after the search content is changed upon a user gesture.
 */ let CDSTableToolbarSearch = class CDSTableToolbarSearch extends (0, _hostListenerJsDefault.default)((0, _searchJsDefault.default)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if the search box should be expanded.
         */ this.expanded = false;
        /**
         * `true` if the search box should be always be open.
         */ this.persistent = false;
        /**
         * The search box size.
         */ this.size = (0, _defsJs.INPUT_SIZE).LARGE;
    }
    /**
     * Handles user-initiated gestures for expanding the search box.
     */ async _handleUserInitiatedExpand() {
        this.expanded = true;
        await this.updateComplete;
        const { _inputNode: inputNode } = this;
        inputNode === null || inputNode === void 0 || inputNode.focus();
    }
    /**
     * Handles `focus` event handler on this element.
     */ _handleFocusIn() {
        this._handleUserInitiatedExpand();
    }
    /**
     * Handles `blur` event handler on this element.
     *
     * @param event The event.
     */ _handleFocusOut(event) {
        if (!this.contains(event.relatedTarget) && !this.value && !this.persistent) this.expanded = false;
    }
    /**
     * Handles `click` event handler on the search box.
     */ _handleSearchClick() {
        this._handleUserInitiatedExpand();
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "search");
        super.connectedCallback();
    }
    render() {
        const result = super.render();
        const { persistent, expanded, size, _handleSearchClick: handleSearchClick } = this;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--search`]: true,
            [`${0, _settingsJs.prefix}--search--${size}`]: size
        });
        if (persistent) this.expanded = true;
        return (0, _lit.html)`
      <div
        class="${classes}"
        tabindex="${expanded ? "-1" : "0"}"
        @click="${handleSearchClick}">
        ${result}
      </div>
    `;
    }
    /**
     * The name of the custom event fired after the search content is changed upon a user gesture.
     */ static get eventInput() {
        // The code uses on in `<cds-search>`, but definition is done also here for React event generation
        return `${0, _settingsJs.prefix}-search-input`;
    }
};
CDSTableToolbarSearch.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSTableToolbarSearch.styles = (0, _dataTableScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("input")
], CDSTableToolbarSearch.prototype, "_inputNode", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("focusin")
], CDSTableToolbarSearch.prototype, "_handleFocusIn", null);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("focusout")
], CDSTableToolbarSearch.prototype, "_handleFocusOut", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableToolbarSearch.prototype, "expanded", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTableToolbarSearch.prototype, "persistent", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTableToolbarSearch.prototype, "size", void 0);
CDSTableToolbarSearch = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-table-toolbar-search`)
], CDSTableToolbarSearch);
var CDSTableToolbarSearch$1 = CDSTableToolbarSearch;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/mixins/host-listener.js":"1SMUX","../../globals/decorators/host-listener.js":"f95Mj","../text-input/text-input.js":"lBj7P","../search/search.js":"hzhB5","./data-table.scss.js":"UdnU6","../../globals/decorators/carbon-element.js":"kNhLR","../text-input/defs.js":"83oMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hzhB5":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSearch$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _16Js = require("../../icons/close/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/search/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _settingsJs = require("../../globals/settings.js");
var _ifNonEmptyJs = require("../../globals/directives/if-non-empty.js");
var _ifNonEmptyJsDefault = parcelHelpers.interopDefault(_ifNonEmptyJs);
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _formJs = require("../../globals/mixins/form.js");
var _formJsDefault = parcelHelpers.interopDefault(_formJs);
var _textInputJs = require("../text-input/text-input.js");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _searchScssJs = require("./search.scss.js");
var _searchScssJsDefault = parcelHelpers.interopDefault(_searchScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("../text-input/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Search box.
 *
 * @element cds-search
 * @csspart search-icon The search icon.
 * @csspart label-text The label text.
 * @csspart input The input box.
 * @csspart close-button The close button.
 * @csspart close-icon The close icon.
 * @fires cds-search-input - The custom event fired after the search content is changed upon a user gesture.
 */ let CDSSearch = class CDSSearch extends (0, _hostListenerJsDefault1.default)((0, _focusJsDefault.default)((0, _formJsDefault.default)((0, _lit.LitElement)))) {
    constructor(){
        super(...arguments);
        /**
         * Specify an optional value for the autocomplete property on the underlying <input>,
         * defaults to "off"
         */ this.autoComplete = "off";
        /**
         * Specify a label to be read by screen readers on the "close" button
         */ this.closeButtonLabelText = "";
        /**
         * `true` if the search box should be disabled.
         */ this.disabled = false;
        /**
         * `true` if the search bar can be expandable
         */ this.expandable = false;
        /**
         * `true` if the expandable search has been expanded
         */ this.expanded = false;
        this.hasCustomIcon = false;
        /**
         * The label text.
         */ this.labelText = "";
        /**
         * The form name in `FormData`.
         */ this.name = "";
        /**
         * Specify the role for the underlying <input>, defaults to searchbox
         */ this.role = "";
        /**
         * The placeholder text.
         */ this.placeholder = "Search";
        /**
         * The search box size.
         */ this.size = (0, _defsJs.INPUT_SIZE).MEDIUM;
        /**
         * The `<input>` name.
         */ this.type = "";
        /**
         * The value.
         */ this.value = "";
    }
    /**
     * Handles `input` event on the `<input>` in the shadow DOM.
     */ _handleInput(event) {
        const { target } = event;
        const { value } = target;
        this.dispatchEvent(new CustomEvent(this.constructor.eventInput, {
            bubbles: true,
            composed: true,
            cancelable: false,
            detail: {
                value
            }
        }));
        this.value = value;
    }
    /**
     * Handles `click` event on the button to clear search box content.
     */ _handleClearInputButtonClick() {
        if (this.value) {
            this.dispatchEvent(new CustomEvent(this.constructor.eventInput, {
                bubbles: true,
                composed: true,
                cancelable: false,
                detail: {
                    value: ""
                }
            }));
            this.value = "";
            // set focus on back to input once search is cleared
            const input = this.shadowRoot.querySelector("input");
            input.focus();
        }
    }
    /**
     * Handles `focus` event on the button when the button can be expanded
     */ _handleExpand() {
        if (this.expandable && !this.expanded) this.setAttribute("expanded", "");
    }
    /**
     * Handles `focusout` event on the component to be closed after being expanded
     * Will not close if there is a value typed within.
     */ _handleClose() {
        if (this.expandable && this.expanded && !this.value) this.removeAttribute("expanded");
    }
    /**
     * Handler for @slotchange, will only be ran if user sets an element under the "icon" slot.
     *
     * @private
     */ _handleSlotChange() {
        const icon = this.querySelector("svg");
        icon === null || icon === void 0 || icon.setAttribute("part", "search-icon");
        icon === null || icon === void 0 || icon.setAttribute("class", `${(0, _settingsJs.prefix)}--search-magnifier-icon`);
        icon === null || icon === void 0 || icon.setAttribute("role", `img`);
        this.hasCustomIcon = true;
    }
    _handleFormdata(event) {
        const { formData } = event; // TODO: Wait for `FormDataEvent` being available in `lib.dom.d.ts`
        const { disabled, name, value } = this;
        if (!disabled) formData.append(name, value);
    }
    render() {
        const { autoComplete, closeButtonLabelText, disabled, hasCustomIcon, labelText, name, placeholder, role, type, value = "", _handleInput: handleInput, _handleClearInputButtonClick: handleClearInputButtonClick, _handleSlotChange: handleSlotChange } = this;
        const clearClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--search-close`]: true,
            [`${0, _settingsJs.prefix}--search-close--hidden`]: !this.value
        });
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--search-magnifier">
        <slot name="icon" @slotchange=${handleSlotChange}>
          ${hasCustomIcon ? (0, _lit.html)`` : (0, _lit.html)`${(0, _16JsDefault1.default)({
            part: "search-icon",
            class: `${(0, _settingsJs.prefix)}--search-magnifier-icon`,
            role: "img"
        })}`}
        </slot>
      </div>
      <label for="input" part="label-text" class="${0, _settingsJs.prefix}--label">
        <slot>${labelText}</slot>
      </label>
      <input
        autocomplete="${autoComplete}"
        id="input"
        part="input"
        type="${(0, _ifNonEmptyJsDefault.default)(type)}"
        class="${0, _settingsJs.prefix}--search-input"
        ?disabled="${disabled}"
        name="${(0, _ifNonEmptyJsDefault.default)(name)}"
        placeholder="${(0, _ifNonEmptyJsDefault.default)(placeholder)}"
        role="${role}"
        .value="${value}"
        @input="${handleInput}" />
      <button
        part="close-button"
        class="${clearClasses}"
        @click="${handleClearInputButtonClick}"
        type="button"
        aria-label="${closeButtonLabelText}">
        ${(0, _16JsDefault.default)({
            part: "close-icon",
            "aria-label": closeButtonLabelText,
            role: "img"
        })}
      </button>
    `;
    }
    /**
     * The name of the custom event fired after the search content is changed upon a user gesture.
     */ static get eventInput() {
        return `${0, _settingsJs.prefix}-search-input`;
    }
};
CDSSearch.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSSearch.styles = (0, _searchScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("focus")
], CDSSearch.prototype, "_handleExpand", null);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("focusout")
], CDSSearch.prototype, "_handleClose", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "autocomplete"
    })
], CDSSearch.prototype, "autoComplete", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "close-button-label-text"
    })
], CDSSearch.prototype, "closeButtonLabelText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSearch.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSearch.prototype, "expandable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSearch.prototype, "expanded", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSSearch.prototype, "hasCustomIcon", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label-text"
    })
], CDSSearch.prototype, "labelText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSearch.prototype, "name", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSearch.prototype, "role", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSearch.prototype, "placeholder", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSSearch.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSearch.prototype, "type", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String
    })
], CDSSearch.prototype, "value", void 0);
CDSSearch = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-search`)
], CDSSearch);
var CDSSearch$1 = CDSSearch;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/close/16.js":"b7Sho","../../icons/search/16.js":"ba4X4","../../globals/settings.js":"EipuL","../../globals/directives/if-non-empty.js":"5Xlqk","../../globals/mixins/focus.js":"5k7ow","../../globals/mixins/form.js":"kISjL","../text-input/text-input.js":"lBj7P","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/host-listener.js":"1SMUX","./search.scss.js":"hb40q","../../globals/decorators/carbon-element.js":"kNhLR","../text-input/defs.js":"83oMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hb40q":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));background-color:var(--cds-field);block-size:var(--cds-layout-size-height-local);border:none;border-block-end:1px solid var(--cds-border-strong);box-sizing:border-box;color:var(--cds-text-primary,#161616);font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:2px solid transparent;outline-offset:-2px;padding:0;padding:0 var(--cds-layout-density-padding-inline-local);transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--text-input *,.cds--text-input :after,.cds--text-input :before{box-sizing:inherit}.cds--text-input:active,.cds--text-input:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input:active,.cds--text-input:focus{outline-style:dotted}}.cds--text-input-wrapper svg[hidden]{display:none}.cds--password-input{padding-inline-end:2.5rem}.cds--text-input--sm.cds--password-input{padding-inline-end:2rem}.cds--text-input--lg.cds--password-input{padding-inline-end:3rem}.cds--text-input::-moz-placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input::placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input--light{background-color:var(--cds-field-02,#fff)}.cds--text-input__field-wrapper{display:flex;inline-size:100%;position:relative}.cds--text-input__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:1rem;transform:translateY(-50%)}.cds--text-input__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--text-input__invalid-icon--warning path:first-of-type{fill:#000;opacity:1}.cds--text-input--password__visibility{align-items:center;cursor:pointer;display:inline-flex;overflow:visible;position:relative}.cds--text-input--password__visibility:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus{outline-style:dotted}}.cds--text-input--password__visibility:focus{outline:1px solid transparent}.cds--text-input--password__visibility:focus svg{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus svg{outline-style:dotted}}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{align-items:center;display:flex;opacity:0;pointer-events:none;position:absolute;z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{display:inline-block}}.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:opacity 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:none}}.cds--text-input--password__visibility.cds--tooltip--a11y:after,.cds--text-input--password__visibility.cds--tooltip--a11y:before{transition:none}.cds--text-input--password__visibility:before{block-size:0;border-style:solid;content:"";inline-size:0}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text{box-sizing:content-box;color:inherit;opacity:1;white-space:normal;word-break:break-word}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);max-inline-size:13rem;min-inline-size:1.5rem;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-accelerator:true){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{border:1px solid transparent}}.cds--text-input--password__visibility:after{content:attr(aria-label)}.cds--text-input--password__visibility.cds--tooltip--a11y:after{content:none}.cds--text-input--password__visibility.cds--tooltip--visible:after,.cds--text-input--password__visibility.cds--tooltip--visible:before,.cds--text-input--password__visibility:focus:after,.cds--text-input--password__visibility:focus:before,.cds--text-input--password__visibility:hover:after,.cds--text-input--password__visibility:hover:before{opacity:1}@keyframes cds--tooltip-fade{0%{opacity:0}to{opacity:1}}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text{margin:auto;overflow:visible;clip:auto}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible.cds--tooltip--a11y:before,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:focus.cds--tooltip--a11y:before,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text,.cds--text-input--password__visibility:hover.cds--tooltip--a11y:before{animation:cds--tooltip-fade 70ms cubic-bezier(.2,0,.38,.9)}.cds--text-input--password__visibility.cds--tooltip--hidden .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--hidden+.cds--assistive-text{margin:-1px;overflow:hidden;clip:rect(0,0,0,0)}.cds--text-input--password__visibility.cds--tooltip--hidden.cds--tooltip--a11y:before{animation:none;opacity:0}.cds--text-input--password__visibility .cds--assistive-text:after{block-size:.75rem;content:"";display:block;inline-size:100%;inset-block-start:-.75rem;inset-inline-start:0;position:absolute}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{inset-block-end:0;inset-inline-start:50%}.cds--text-input--password__visibility:before{border-color:transparent transparent var(--cds-background-inverse,#393939);border-width:0 .25rem .3125rem;inset-block-end:-.5rem;transform:translate(-50%,100%)}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inset-block-end:-.8125rem;transform:translate(-50%,100%)}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{align-items:center;background:none;block-size:100%;border:0;cursor:pointer;display:flex;inline-size:2.5rem;inset-inline-end:0;justify-content:center;min-block-size:auto;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--toggle-password-tooltip .cds--popover{inset-inline-start:-2.5rem}.cds--toggle-password-tooltip .cds--popover-content{min-inline-size:2.5rem}.cds--text-input--sm+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:2rem}.cds--text-input--lg+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:3rem}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252);transition:fill 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:ButtonText}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline-style:dotted}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus svg,.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-primary,#161616)}.cds--text-input--invalid,.cds--text-input--warning{padding-inline-end:2.5rem}.cds--text-input--invalid.cds--password-input{padding-inline-end:4rem}.cds--text-input--invalid+.cds--text-input--password__visibility__toggle{inset-inline-end:1rem}.cds--password-input-wrapper .cds--text-input__invalid-icon{inset-inline-end:2.5rem}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{cursor:not-allowed}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg:hover{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input__counter-alert{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px}.cds--text-input:disabled{background-color:var(--cds-field);border-block-end:1px solid transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;outline:2px solid transparent;outline-offset:-2px;-webkit-text-fill-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input--light:disabled{background-color:var(--cds-field-02,#fff)}.cds--text-input:disabled::-moz-placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input:disabled::placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input--invalid{box-shadow:none;outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input--invalid{outline-style:dotted}}.cds--text-input--invalid .cds--text-input--password__visibility__toggle{inset-inline-end:2.5rem}.cds--skeleton.cds--text-input{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;padding:0;pointer-events:none;position:relative}.cds--skeleton.cds--text-input:active,.cds--skeleton.cds--text-input:focus,.cds--skeleton.cds--text-input:hover{border:none;cursor:default;outline:none}.cds--skeleton.cds--text-input:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--skeleton.cds--text-input:before{animation:none}}.cds--form--fluid .cds--text-input-wrapper{background:var(--cds-field);position:relative;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--form--fluid .cds--label{align-items:center;block-size:1rem;display:flex;inset-block-start:.8125rem;inset-inline-start:1rem;margin:0;position:absolute;z-index:1}.cds--form--fluid .cds--form__helper-text{display:none}.cds--form--fluid .cds--text-input{min-block-size:4rem;padding:2rem 1rem .8125rem}.cds--form--fluid .cds--text-input__divider,.cds--text-input__divider{display:none}.cds--form--fluid .cds--text-input--invalid,.cds--form--fluid .cds--text-input--warning{border-block-end:none}.cds--form--fluid .cds--text-input--invalid+.cds--text-input__divider,.cds--form--fluid .cds--text-input--warning+.cds--text-input__divider{border-color:var(--cds-border-subtle);border-style:solid;border-block-end:none;display:block;margin:0 1rem}.cds--form--fluid .cds--text-input__invalid-icon{inset-block-start:5rem}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid{outline:none}.cds--form--fluid .cds--text-input__field-wrapper--warning{border-block-end:1px solid var(--cds-border-strong)}.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning:focus,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:focus{outline:none}.cds--text-input-wrapper.cds--text-input-wrapper--inline{flex-flow:row wrap}.cds--text-input-wrapper .cds--label--inline{flex:1;margin:.8125rem 0 0;overflow-wrap:break-word;word-break:break-word}.cds--text-input-wrapper .cds--label--inline--sm{margin-block-start:.5625rem}.cds--text-input-wrapper .cds--label--inline--lg{margin-block-start:1.0625rem}.cds--text-input__label-helper-wrapper{flex:2;flex-direction:column;margin-inline-end:1.5rem;max-inline-size:8rem;overflow-wrap:break-word}.cds--text-input-wrapper .cds--form__helper-text--inline{margin-block-start:.125rem}.cds--text-input__field-outer-wrapper{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;inline-size:100%}.cds--text-input__field-outer-wrapper--inline{flex:8;flex-direction:column}.cds--text-input-wrapper--inline .cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--text-input-wrapper--inline--invalid .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input-wrapper--readonly,.cds--text-input-wrapper--readonly .cds--text-input{background:transparent;border-block-end-color:var(--cds-border-subtle)}.cds--text-input__field-wrapper .cds--ai-label,.cds--text-input__field-wrapper .cds--slug,.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator>*{inset-block-start:50%;inset-inline-end:1rem;position:absolute;transform:translateY(-50%)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label):not(:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug):not(:has(~.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug){padding-inline-end:2.5rem}.cds--text-input--invalid:has(~.cds--ai-label),.cds--text-input--invalid:has(~.cds--slug),.cds--text-input--invalid:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input--warning:has(~.cds--ai-label),.cds--text-input--warning:has(~.cds--slug),.cds--text-input--warning:has(~.cds--text-input__field-inner-wrapper--decorator>*){padding-inline-end:4rem}.cds--text-input--invalid~.cds--ai-label,.cds--text-input--invalid~.cds--slug,.cds--text-input--invalid~.cds--text-input__field-inner-wrapper--decorator>*,.cds--text-input--warning~.cds--ai-label,.cds--text-input--warning~.cds--slug,.cds--text-input--warning~.cds--text-input__field-inner-wrapper--decorator>*{inset-inline-end:2.5rem}.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator:not(:has(.cds--ai-label))>*{block-size:1rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:ButtonText}}.cds--text-input__label-wrapper{display:flex;inline-size:100%;justify-content:space-between}.cds--text-input__label-wrapper .cds--text-input__label-counter{align-self:end}.cds--search--sm .cds--search-close,.cds--search--sm.cds--search--expandable,.cds--search--sm.cds--search--expandable .cds--search-magnifier,.cds--search--sm~.cds--search-button,:host(cds-search-skeleton[size=sm]) .cds--search-close,:host(cds-search-skeleton[size=sm]):host(cds-search[expandable]),:host(cds-search-skeleton[size=sm]):host(cds-search[expandable]) .cds--search-magnifier,:host(cds-search-skeleton[size=sm])~.cds--search-button,:host(cds-search[size=sm]) .cds--search-close,:host(cds-search[size=sm]):host(cds-search[expandable]),:host(cds-search[size=sm]):host(cds-search[expandable]) .cds--search-magnifier,:host(cds-search[size=sm])~.cds--search-button{block-size:2rem;inline-size:2rem}.cds--search--sm.cds--search--expandable .cds--search-input::-moz-placeholder,:host(cds-search-skeleton[size=sm]):host(cds-search[expandable]) .cds--search-input::-moz-placeholder,:host(cds-search[size=sm]):host(cds-search[expandable]) .cds--search-input::-moz-placeholder{padding:0 2rem}.cds--search--sm.cds--search--expandable .cds--search-input::placeholder,:host(cds-search-skeleton[size=sm]):host(cds-search[expandable]) .cds--search-input::placeholder,:host(cds-search[size=sm]):host(cds-search[expandable]) .cds--search-input::placeholder{padding:0 2rem}.cds--search--md .cds--search-close,.cds--search--md.cds--search--expandable,.cds--search--md.cds--search--expandable .cds--search-magnifier,.cds--search--md~.cds--search-button,:host(cds-search-skeleton[size=md]) .cds--search-close,:host(cds-search-skeleton[size=md]):host(cds-search[expandable]),:host(cds-search-skeleton[size=md]):host(cds-search[expandable]) .cds--search-magnifier,:host(cds-search-skeleton[size=md])~.cds--search-button,:host(cds-search[size=md]) .cds--search-close,:host(cds-search[size=md]):host(cds-search[expandable]),:host(cds-search[size=md]):host(cds-search[expandable]) .cds--search-magnifier,:host(cds-search[size=md])~.cds--search-button{block-size:2.5rem;inline-size:2.5rem}.cds--search--md.cds--search--expandable .cds--search-input::-moz-placeholder,:host(cds-search-skeleton[size=md]):host(cds-search[expandable]) .cds--search-input::-moz-placeholder,:host(cds-search[size=md]):host(cds-search[expandable]) .cds--search-input::-moz-placeholder{padding:0 2.5rem}.cds--search--md.cds--search--expandable .cds--search-input::placeholder,:host(cds-search-skeleton[size=md]):host(cds-search[expandable]) .cds--search-input::placeholder,:host(cds-search[size=md]):host(cds-search[expandable]) .cds--search-input::placeholder{padding:0 2.5rem}.cds--search--lg .cds--search-close,.cds--search--lg.cds--search--expandable,.cds--search--lg.cds--search--expandable .cds--search-magnifier,.cds--search--lg~.cds--search-button,:host(cds-search-skeleton[size=lg]) .cds--search-close,:host(cds-search-skeleton[size=lg]):host(cds-search[expandable]),:host(cds-search-skeleton[size=lg]):host(cds-search[expandable]) .cds--search-magnifier,:host(cds-search-skeleton[size=lg])~.cds--search-button,:host(cds-search[size=lg]) .cds--search-close,:host(cds-search[size=lg]):host(cds-search[expandable]),:host(cds-search[size=lg]):host(cds-search[expandable]) .cds--search-magnifier,:host(cds-search[size=lg])~.cds--search-button{block-size:3rem;inline-size:3rem}.cds--search--lg.cds--search--expandable .cds--search-input::-moz-placeholder,:host(cds-search-skeleton[size=lg]):host(cds-search[expandable]) .cds--search-input::-moz-placeholder,:host(cds-search[size=lg]):host(cds-search[expandable]) .cds--search-input::-moz-placeholder{padding:0 3rem}.cds--search--lg.cds--search--expandable .cds--search-input::placeholder,:host(cds-search-skeleton[size=lg]):host(cds-search[expandable]) .cds--search-input::placeholder,:host(cds-search[size=lg]):host(cds-search[expandable]) .cds--search-input::placeholder{padding:0 3rem}.cds--search--expandable.cds--search--expanded,:host(cds-search[expandable]):host(cds-search[expandable][expanded]){inline-size:100%}.cds--search--expandable.cds--search--expanded .cds--search-input,:host(cds-search[expandable]):host(cds-search[expandable][expanded]) .cds--search-input{inline-size:100%;transition:padding 70ms cubic-bezier(.2,0,.38,.9)}.cds--search--expandable.cds--search--expanded .cds--search-input::-moz-placeholder,:host(cds-search[expandable]):host(cds-search[expandable][expanded]) .cds--search-input::-moz-placeholder{opacity:1;padding:0;position:relative}.cds--search--expandable.cds--search--expanded .cds--search-input::placeholder,:host(cds-search[expandable]):host(cds-search[expandable][expanded]) .cds--search-input::placeholder{opacity:1;padding:0;position:relative}.cds--search--expandable.cds--search--expanded .cds--search-magnifier,:host(cds-search[expandable]):host(cds-search[expandable][expanded]) .cds--search-magnifier{pointer-events:none}.cds--search--expandable.cds--search--expanded .cds--search-magnifier-icon,:host(cds-search[expandable]):host(cds-search[expandable][expanded]) .cds--search-magnifier-icon{fill:var(--cds-icon-secondary,#525252)}.cds--search,:host(cds-search){align-items:center;display:flex;inline-size:100%;position:relative}.cds--search .cds--label,:host(cds-search) .cds--label{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--search-input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--cds-field);border:none;border-block-end:1px solid var(--cds-border-strong);box-sizing:border-box;color:var(--cds-text-primary,#161616);font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;order:1;outline:2px solid transparent;outline-offset:-2px;padding:0 2.5rem;text-overflow:ellipsis;transition:background-color .11s cubic-bezier(.2,0,.38,.9),outline .11s cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--search-input *,.cds--search-input :after,.cds--search-input :before{box-sizing:inherit}.cds--search-input:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--search-input:focus{outline-style:dotted}}.cds--search-input::-moz-placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--search-input::placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--search-input::-ms-clear{display:none}.cds--search-input[disabled]{background-color:var(--cds-field);border-block-end:1px solid transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--search-input[disabled]::-moz-placeholder{color:var(--cds-field)}.cds--search-input[disabled]::placeholder{color:var(--cds-field)}.cds--search--light .cds--search-close:before,.cds--search--light .cds--search-input{background:var(--cds-field-02,#fff)}.cds--search--sm .cds--search-input,.cds--search--sm.cds--search--expandable.cds--search--expanded .cds--search-input,:host(cds-search-skeleton[size=sm]) .cds--search-input,:host(cds-search[size=sm]) .cds--search-input{block-size:2rem;padding:0 2rem}.cds--search--sm .cds--search-magnifier-icon,:host(cds-search-skeleton[size=sm]) .cds--search-magnifier-icon,:host(cds-search[size=sm]) .cds--search-magnifier-icon{inset-inline-start:.5rem}.cds--search--md .cds--search-input,.cds--search--md.cds--search--expandable.cds--search--expanded .cds--search-input,:host(cds-search-skeleton[size=md]) .cds--search-input,:host(cds-search[size=md]) .cds--search-input{block-size:2.5rem;padding:0 2.5rem}.cds--search--md .cds--search-magnifier-icon,:host(cds-search-skeleton[size=md]) .cds--search-magnifier-icon,:host(cds-search[size=md]) .cds--search-magnifier-icon{inset-inline-start:.75rem}.cds--search--lg .cds--search-input,.cds--search--lg.cds--search--expandable.cds--search--expanded .cds--search-input,:host(cds-search-skeleton[size=lg]) .cds--search-input,:host(cds-search[size=lg]) .cds--search-input{block-size:3rem;padding:0 3rem}.cds--search-magnifier-icon{block-size:1rem;border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;position:absolute;vertical-align:baseline;z-index:2;fill:var(--cds-icon-secondary,#525252);inline-size:1rem;inset-block-start:50%;inset-inline-start:1rem;pointer-events:none;transform:translateY(-50%)}.cds--search-magnifier-icon *,.cds--search-magnifier-icon :after,.cds--search-magnifier-icon :before{box-sizing:inherit}.cds--search-close{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inset-block-start:0;inset-inline-end:0;margin:0;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;text-align:start;vertical-align:baseline}.cds--search-close *,.cds--search-close :after,.cds--search-close :before{box-sizing:inherit}.cds--search-close::-moz-focus-inner{border:0}.cds--search-close:before{background-color:var(--cds-field);block-size:calc(100% - 2px);content:"";display:block;inline-size:2px;inset-block-start:.0625rem;inset-inline-start:0;position:absolute;transition:background-color .11s cubic-bezier(.2,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--search-close:before{transition:none}}.cds--search-close:hover{border-block-end:1px solid var(--cds-border-strong)}.cds--search-close:hover:before{background-color:var(--cds-field-hover)}.cds--search-button{background-color:var(--cds-field);flex-shrink:0;margin-inline-start:.125rem}.cds--search-button svg{fill:currentColor;vertical-align:middle}.cds--search-close svg{fill:inherit}.cds--search-button,.cds--search-close{align-items:center;block-size:2.5rem;border-color:transparent;border-style:solid;border-width:1px 0;cursor:pointer;display:flex;justify-content:center;fill:var(--cds-icon-primary,#161616);inline-size:2.5rem;opacity:1;transition:opacity .11s cubic-bezier(.2,0,.38,.9),background-color .11s cubic-bezier(.2,0,.38,.9),outline .11s cubic-bezier(.2,0,.38,.9),border .11s cubic-bezier(.2,0,.38,.9);visibility:inherit}.cds--search-button:hover,.cds--search-close:hover{background-color:var(--cds-field-hover)}.cds--search-button:focus,.cds--search-close:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--search-button:focus,.cds--search-close:focus{outline-style:dotted}}.cds--search-button:active,.cds--search-close:active{background-color:var(--cds-background-selected,hsla(0,0%,55%,.2));outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--search-button:active,.cds--search-close:active{outline-style:dotted}}.cds--search--disabled .cds--search-close,.cds--search--disabled.cds--search--expandable .cds--search-magnifier{cursor:not-allowed;outline:none}.cds--search--disabled .cds--search-close:hover,.cds--search--disabled.cds--search--expandable .cds--search-magnifier:hover{background-color:transparent;border-block-end-color:transparent}.cds--search--disabled .cds--search-close:hover:before,.cds--search--disabled.cds--search--expandable .cds--search-magnifier:hover:before{background-color:transparent}.cds--search--disabled svg{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--search-close:active:before,.cds--search-close:focus:before{background-color:var(--cds-focus,#0f62fe)}.cds--search-input:focus~.cds--search-close:hover{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--search-input:focus~.cds--search-close:hover{outline-style:dotted}}.cds--search--sm .cds--search-close,.cds--search--sm.cds--search--expandable,.cds--search--sm.cds--search--expandable .cds--search-magnifier,.cds--search--sm~.cds--search-button,:host(cds-search-skeleton[size=sm]) .cds--search-close,:host(cds-search-skeleton[size=sm])~.cds--search-button,:host(cds-search[size=sm]) .cds--search-close,:host(cds-search[size=sm])~.cds--search-button{block-size:2rem;inline-size:2rem}.cds--search--sm.cds--search--expandable .cds--search-input::-moz-placeholder{padding:0 2rem}.cds--search--sm.cds--search--expandable .cds--search-input::placeholder{padding:0 2rem}.cds--search--md .cds--search-close,.cds--search--md.cds--search--expandable,.cds--search--md.cds--search--expandable .cds--search-magnifier,.cds--search--md~.cds--search-button,:host(cds-search-skeleton[size=md]) .cds--search-close,:host(cds-search-skeleton[size=md])~.cds--search-button,:host(cds-search[size=md]) .cds--search-close,:host(cds-search[size=md])~.cds--search-button{block-size:2.5rem;inline-size:2.5rem}.cds--search--md.cds--search--expandable .cds--search-input::-moz-placeholder{padding:0 2.5rem}.cds--search--md.cds--search--expandable .cds--search-input::placeholder{padding:0 2.5rem}.cds--search--lg .cds--search-close,.cds--search--lg.cds--search--expandable,.cds--search--lg.cds--search--expandable .cds--search-magnifier,.cds--search--lg~.cds--search-button,:host(cds-search-skeleton[size=lg]) .cds--search-close,:host(cds-search-skeleton[size=lg])~.cds--search-button,:host(cds-search[size=lg]) .cds--search-close,:host(cds-search[size=lg])~.cds--search-button{block-size:3rem;inline-size:3rem}.cds--search--lg.cds--search--expandable .cds--search-input::-moz-placeholder{padding:0 3rem}.cds--search--lg.cds--search--expandable .cds--search-input::placeholder{padding:0 3rem}.cds--search-close--hidden{opacity:0;visibility:hidden}.cds--search--lg.cds--skeleton .cds--search-input,.cds--search--md.cds--skeleton .cds--search-input,.cds--search--sm.cds--skeleton .cds--search-input{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:100%;padding:0;pointer-events:none;position:relative}.cds--search--lg.cds--skeleton .cds--search-input:active,.cds--search--lg.cds--skeleton .cds--search-input:focus,.cds--search--lg.cds--skeleton .cds--search-input:hover,.cds--search--md.cds--skeleton .cds--search-input:active,.cds--search--md.cds--skeleton .cds--search-input:focus,.cds--search--md.cds--skeleton .cds--search-input:hover,.cds--search--sm.cds--skeleton .cds--search-input:active,.cds--search--sm.cds--skeleton .cds--search-input:focus,.cds--search--sm.cds--skeleton .cds--search-input:hover{border:none;cursor:default;outline:none}.cds--search--lg.cds--skeleton .cds--search-input:before,.cds--search--md.cds--skeleton .cds--search-input:before,.cds--search--sm.cds--skeleton .cds--search-input:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--search--lg.cds--skeleton .cds--search-input:before,.cds--search--md.cds--skeleton .cds--search-input:before,.cds--search--sm.cds--skeleton .cds--search-input:before{animation:none}}.cds--search--lg.cds--skeleton .cds--search-input::-moz-placeholder,.cds--search--md.cds--skeleton .cds--search-input::-moz-placeholder,.cds--search--sm.cds--skeleton .cds--search-input::-moz-placeholder{color:transparent}.cds--search--lg.cds--skeleton .cds--search-input::placeholder,.cds--search--md.cds--skeleton .cds--search-input::placeholder,.cds--search--sm.cds--skeleton .cds--search-input::placeholder{color:transparent}.cds--search--expandable,:host(cds-search[expandable]){transition:width 70ms cubic-bezier(.2,0,.38,.9)}.cds--search--expandable.cds--search--expanded{inline-size:100%}.cds--search--expandable .cds--search-input,:host(cds-search[expandable]) .cds--search-input{inline-size:0;padding:0;transition:padding 70ms cubic-bezier(.2,0,.38,.9),width 0s linear 70ms}.cds--search--expandable .cds--search-input::-moz-placeholder,:host(cds-search[expandable]) .cds--search-input::-moz-placeholder{opacity:0;position:relative;transition-duration:70ms;-moz-transition-property:padding,opacity;transition-property:padding,opacity;transition-timing-function:cubic-bezier(.2,0,.38,.9)}.cds--search--expandable .cds--search-input::placeholder,:host(cds-search[expandable]) .cds--search-input::placeholder{opacity:0;position:relative;transition-duration:70ms;transition-property:padding,opacity;transition-timing-function:cubic-bezier(.2,0,.38,.9)}.cds--search--expandable.cds--search--expanded .cds--search-input{inline-size:100%;transition:padding 70ms cubic-bezier(.2,0,.38,.9)}.cds--search--expandable.cds--search--expanded .cds--search-input::-moz-placeholder{opacity:1;padding:0;position:relative}.cds--search--expandable.cds--search--expanded .cds--search-input::placeholder{opacity:1;padding:0;position:relative}.cds--search--expandable .cds--search-magnifier,:host(cds-search[expandable]) .cds--search-magnifier{cursor:pointer;position:absolute}.cds--search--expandable .cds--search-magnifier:focus,:host(cds-search[expandable]) .cds--search-magnifier:focus{outline:2px solid var(--cds-focus,#0f62fe)}.cds--search--expandable .cds--search-magnifier:hover,:host(cds-search[expandable]) .cds--search-magnifier:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--search--expandable.cds--search--expanded .cds--search-magnifier{pointer-events:none}.cds--search--expandable .cds--search-magnifier-icon,:host(cds-search[expandable]) .cds--search-magnifier-icon{fill:var(--cds-icon-primary,#161616)}.cds--search--expandable.cds--search--expanded .cds--search-magnifier-icon{fill:var(--cds-icon-secondary,#525252)}.cds--search--expandable.cds--search--disabled svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--search-close svg,.cds--search-magnifier-icon{fill:ButtonText}}:host(cds-search){outline:none}:host(cds-search[expandable][size=sm]) .cds--search-magnifier{block-size:2rem;inline-size:2rem}:host(cds-search[expandable][size=md]) .cds--search-magnifier{block-size:2.5rem;inline-size:2.5rem}:host(cds-search[expandable][size=lg]) .cds--search-magnifier{block-size:3rem;inline-size:3rem}:host(cds-search[expandable][expanded]) .cds--search-input{inline-size:100%}:host(cds-search[expandable][expanded]) .cds--search-magnifier{pointer-events:none}:host(cds-search[expandable][expanded][size=sm]) .cds--search-input{padding:0 2rem}:host(cds-search[expandable][expanded][size=md]) .cds--search-input{padding:0 2.5rem}:host(cds-search[expandable][expanded][size=lg]) .cds--search-input{padding:0 3rem}:host(cds-search[expandable][expanded][size=lg]) ::slotted(.cds--search-magnifier){block-size:3rem;inline-size:3rem}:host(cds-search[disabled]) svg{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}:host(cds-search[disabled]) .cds--search-close{outline:none;pointer-events:none}:host(cds-search[disabled]) .cds--search-close:before{background:none}:host(cds-search-skeleton){inline-size:100%}:host(cds-search-skeleton) .cds--search-input{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:100%;padding:0;pointer-events:none;position:relative}:host(cds-search-skeleton) .cds--search-input:active,:host(cds-search-skeleton) .cds--search-input:focus,:host(cds-search-skeleton) .cds--search-input:hover{border:none;cursor:default;outline:none}:host(cds-search-skeleton) .cds--search-input:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){:host(cds-search-skeleton) .cds--search-input:before{animation:none}}:host(cds-search-skeleton) .cds--search-input::-moz-placeholder{color:transparent}:host(cds-search-skeleton) .cds--search-input::placeholder{color:transparent}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7NQmV":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _datePickerJs = require("./date-picker.js");
var _datePickerInputJs = require("./date-picker-input.js");
var _datePickerInputSkeletonJs = require("./date-picker-input-skeleton.js");

},{"./date-picker.js":"lysw1","./date-picker-input.js":"hREA1","./date-picker-input-skeleton.js":"6G40A"}],"lysw1":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSDatePicker$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _flatpickr = require("flatpickr");
var _flatpickrDefault = parcelHelpers.interopDefault(_flatpickr);
var _settingsJs = require("../../globals/settings.js");
var _formJs = require("../../globals/mixins/form.js");
var _formJsDefault = parcelHelpers.interopDefault(_formJs);
var _hostListenerJs = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _isoDateJs = require("./iso-date.js");
var _appendToPluginJs = require("./append-to-plugin.js");
var _appendToPluginJsDefault = parcelHelpers.interopDefault(_appendToPluginJs);
var _cssClassPluginJs = require("./css-class-plugin.js");
var _cssClassPluginJsDefault = parcelHelpers.interopDefault(_cssClassPluginJs);
var _fixEventsPluginJs = require("./fix-events-plugin.js");
var _fixEventsPluginJsDefault = parcelHelpers.interopDefault(_fixEventsPluginJs);
var _focusPluginJs = require("./focus-plugin.js");
var _focusPluginJsDefault = parcelHelpers.interopDefault(_focusPluginJs);
var _iconPluginJs = require("./icon-plugin.js");
var _iconPluginJsDefault = parcelHelpers.interopDefault(_iconPluginJs);
var _monthSelectPluginJs = require("./month-select-plugin.js");
var _monthSelectPluginJsDefault = parcelHelpers.interopDefault(_monthSelectPluginJs);
var _rangePluginJs = require("./range-plugin.js");
var _rangePluginJsDefault = parcelHelpers.interopDefault(_rangePluginJs);
var _shadowDomEventsPluginJs = require("./shadow-dom-events-plugin.js");
var _shadowDomEventsPluginJsDefault = parcelHelpers.interopDefault(_shadowDomEventsPluginJs);
var _stateHandshakePluginJs = require("./state-handshake-plugin.js");
var _stateHandshakePluginJsDefault = parcelHelpers.interopDefault(_stateHandshakePluginJs);
var _datePickerScssJs = require("./date-picker.scss.js");
var _datePickerScssJsDefault = parcelHelpers.interopDefault(_datePickerScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Date picker modes.
 */ var DATE_PICKER_MODE;
(function(DATE_PICKER_MODE) {
    /**
     * Simple mode, without calendar dropdown.
     */ DATE_PICKER_MODE["SIMPLE"] = "simple";
    /**
     * Single date mode.
     */ DATE_PICKER_MODE["SINGLE"] = "single";
    /**
     * Range mode.
     */ DATE_PICKER_MODE["RANGE"] = "range";
})(DATE_PICKER_MODE || (DATE_PICKER_MODE = {}));
// Weekdays shorthand for english locale
(0, _flatpickrDefault.default).l10ns.en.weekdays.shorthand.forEach((_day, index)=>{
    const currentDay = (0, _flatpickrDefault.default).l10ns.en.weekdays.shorthand;
    if (currentDay[index] === "Thu" || currentDay[index] === "Th") currentDay[index] = "Th";
    else currentDay[index] = currentDay[index].charAt(0);
});
/**
 * Date picker.
 *
 * @element cds-date-picker
 * @fires cds-date-picker-changed - The custom event fired on this element when Flatpickr updates its value.
 * @fires cds-date-picker-flatpickr-error
 *   The name of the custom event when Flatpickr throws an error.
 */ let CDSDatePicker = class CDSDatePicker extends (0, _hostListenerJsDefault.default)((0, _formJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * The slotted `<cds-date-input kind="from">`.
         */ this._dateInteractNode = null;
        /**
         * Handles `${prefix}-date-picker-changed` event on this element.
         */ this._handleChange = ({ detail })=>{
            this._value = detail.selectedDates.map((date)=>(0, _isoDateJs.getISODateString)(date)).join("/");
        };
        /**
         * Fires a custom event to notify an error in Flatpickr.
         */ this._handleFlatpickrError = (error)=>{
            this.dispatchEvent(new CustomEvent(this.constructor.eventFlatpickrError, {
                bubbles: true,
                cancelable: false,
                composed: true,
                detail: {
                    error
                }
            }));
        };
        /**
         * The Flatpickr instance.
         */ this.calendar = null;
        /**
         * flatpickr prop passthrough. Allows the user to enter a date directly into the input field
         */ this.allowInput = true;
        /**
         * flatpickr prop passthrough. Controls whether the calendar dropdown closes upon selection.
         */ this.closeOnSelect = true;
        /**
         * Controls the disabled state of the input
         */ this.disabled = false;
        /**
         * Name for the input in the `FormData`
         */ this.name = "";
        /**
         * `true` if the date picker should be open.
         */ this.open = false;
        /**
         * Specify if the component should be read-only
         */ this.readonly = false;
    }
    /**
     * @returns The effective date picker mode, determined by the child `<cds-date-picker-input>`.
     */ get _mode() {
        const { selectorInputFrom, selectorInputTo } = this.constructor;
        if (this.querySelector(selectorInputTo)) return DATE_PICKER_MODE.RANGE;
        if (this.querySelector(selectorInputFrom)) return DATE_PICKER_MODE.SINGLE;
        return DATE_PICKER_MODE.SIMPLE;
    }
    /**
     * @returns The Flatpickr plugins to use.
     */ get _datePickerPlugins() {
        const { classCalendarContainer, classMonth, classWeekdays, classDays, classWeekday, classDay, classNoBorder, selectorInputFrom, selectorInputTo, _selectorFlatpickrMonthYearContainer: selectorFlatpickrMonthYearContainer, _selectorFlatpickrYearContainer: selectorFlatpickrYearContainer, _selectorFlatpickrCurrentMonth: selectorFlatpickrCurrentMonth, _selectorFlatpickrMonth: selectorFlatpickrMonth, _selectorFlatpickrWeekdays: selectorFlatpickrWeekdays, _selectorFlatpickrDays: selectorFlatpickrDays, _selectorFlatpickrWeekday: selectorFlatpickrWeekday, _selectorFlatpickrDay: selectorFlatpickrDay, _classFlatpickrCurrentMonth: classFlatpickrCurrentMonth, _classFlatpickrToday: classFlatpickrToday } = this.constructor;
        const { _floatingMenuContainerNode: floatingMenuContainerNode, _mode: mode } = this;
        const inputFrom = this.querySelector(selectorInputFrom);
        const inputTo = this.querySelector(selectorInputTo);
        const plugins = [
            (0, _appendToPluginJsDefault.default)({
                appendTo: floatingMenuContainerNode
            }),
            (0, _cssClassPluginJsDefault.default)({
                classCalendarContainer,
                classMonth,
                classWeekdays,
                classDays,
                classWeekday,
                classDay,
                classNoBorder,
                selectorFlatpickrMonth,
                selectorFlatpickrWeekdays,
                selectorFlatpickrDays,
                selectorFlatpickrWeekday,
                selectorFlatpickrDay,
                classFlatpickrToday
            }),
            (0, _fixEventsPluginJsDefault.default)({
                inputFrom: inputFrom,
                inputTo: inputTo
            }),
            (0, _focusPluginJsDefault.default)({
                inputFrom: inputFrom,
                inputTo: inputTo
            }),
            (0, _iconPluginJsDefault.default)(),
            (0, _monthSelectPluginJsDefault.default)({
                selectorFlatpickrMonthYearContainer,
                selectorFlatpickrYearContainer,
                selectorFlatpickrCurrentMonth,
                classFlatpickrCurrentMonth
            }),
            (0, _shadowDomEventsPluginJsDefault.default)(),
            (0, _stateHandshakePluginJsDefault.default)(this)
        ];
        if (mode === DATE_PICKER_MODE.RANGE) // Flatpickr runs event handlers of last registered plugins first.
        // Ensures `onValueUpdate` of `rangePlugin` runs first
        // given Flatpickr puts `01/01/1970 to 01/02/1970` to from date
        // where `rangePlugin` overrides it to separate them to from/to dates.
        // We want to ensure our handler of `onValueUpdate` (notably one in `<cds-date-picker-input>`)
        // gets the `<input>` value set by `rangePlugin` instead of Flatpickr core.
        plugins.push((0, _rangePluginJsDefault.default)({
            input: inputTo
        }));
        return plugins;
    }
    /**
     * @returns The options to instantiate Flatpickr with.
     */ get _datePickerOptions() {
        var _a;
        const { locale = this.constructor.defaultLocale, enabledRange, _dateInteractNode: dateInteractNode, _datePickerPlugins: plugins, _handleFlatpickrError: handleFlatpickrError } = this;
        // We use `<cds-date-picker-input>` to communicate values/events with Flatpickr,
        // but want to use `<input>` in shadow DOM to base the calendar dropdown's position on
        const { input: positionElement } = dateInteractNode;
        const [minDate, maxDate] = !enabledRange ? [] : enabledRange.split("/");
        return {
            allowInput: this.allowInput,
            closeOnSelect: this.closeOnSelect,
            dateFormat: (_a = this.dateFormat) !== null && _a !== void 0 ? _a : this.constructor.defaultDateFormat,
            disableMobile: true,
            errorHandler: handleFlatpickrError,
            locale,
            maxDate,
            minDate,
            positionElement,
            plugins
        };
    }
    _handleFormdata(event) {
        const { formData } = event; // TODO: Wait for `FormDataEvent` being available in `lib.dom.d.ts`
        const { disabled, name, value } = this;
        if (!disabled) formData.append(name, value);
    }
    /**
     * Handles `slotchange` event in the `<slot>`.
     */ _handleSlotChange({ target }) {
        const { _dateInteractNode: oldDateInteractNode } = this;
        const dateInteractNode = target.assignedNodes().find((node)=>node.nodeType === Node.ELEMENT_NODE && node.matches(this.constructor.selectorInputFrom));
        if (oldDateInteractNode !== dateInteractNode) {
            this._dateInteractNode = dateInteractNode;
            this._instantiateDatePicker();
        }
    }
    /**
     * Sets calendar options
     * @param property property to set
     * @param calendar calendar object
     */ _setCalendar(property, calendar) {
        const { disabled, dateFormat, open, readonly, minDate, maxDate, value } = this;
        const { selectorInputFrom, selectorInputTo } = this.constructor;
        const inputFrom = this.querySelector(selectorInputFrom);
        const inputTo = this.querySelector(selectorInputTo);
        if (property === "dateFormat") calendar.set({
            dateFormat
        });
        if (property === "date") {
            if (!(0, _isoDateJs.parseISODateString)(minDate)) // Allows empty start/end
            throw new Error(`Wrong date format found in \`minDate\` property: ${minDate}`);
            if (!(0, _isoDateJs.parseISODateString)(maxDate)) // Allows empty start/end
            throw new Error(`Wrong date format found in \`maxDate\` property: ${maxDate}`);
            if (minDate && maxDate && minDate > maxDate) throw new Error(`\`maxDate\` property, shouldn't be smaller than the \`minDate\` property. You have: minDate: ${minDate}, maxDate: ${maxDate}`);
            calendar.set({
                minDate,
                maxDate
            });
        }
        if (property === "open") {
            if (open && !readonly) calendar.open();
            else calendar.close();
        }
        if (property === "disabled") [
            inputFrom,
            inputTo
        ].forEach((input)=>{
            if (input) {
                input.disabled = disabled;
                input.readonly = readonly;
            }
        });
        if (property === "value") {
            const dates = value.split("/").filter(Boolean).map((item)=>(0, _isoDateJs.parseISODateString)(item));
            if (dates.some((item)=>isNaN(Number(item)))) throw new Error(`Wrong date format found in \`value\` property: ${value}`);
            const [startDate, endDate] = dates;
            if (startDate && endDate && startDate > endDate) throw new Error(`In \`value\` property, the end date shouldn't be smaller than the start date. You have: ${value}`);
            if (calendar) {
                calendar.setDate(dates);
                [
                    inputFrom,
                    inputTo
                ].forEach((input, i)=>{
                    if (input) input.value = !dates[i] ? "" : calendar.formatDate(new Date(dates[i]), calendar.config.dateFormat);
                });
            }
        }
        return calendar;
    }
    /**
     * Instantiates Flatpickr.
     *
     * @returns The Flatpickr instance.
     */ _instantiateDatePicker() {
        this._releaseDatePicker();
        const { _dateInteractNode: dateInteractNode } = this;
        // `this._dateInteractNode` won't be there unless there is a slotted `<cds-date-input type="from">`,
        // which means Flatpickr will never be instantiated in "simple" mode.
        if (dateInteractNode && dateInteractNode.input) this.calendar = (0, _flatpickrDefault.default)(dateInteractNode.input, this._datePickerOptions);
        const { calendar, disabled, dateFormat, open, readonly, minDate, maxDate, value } = this;
        if (dateFormat) this._setCalendar("dateFormat", calendar);
        if (minDate || maxDate) this._setCalendar("date", calendar);
        if (open) this._setCalendar("open", calendar);
        if (disabled || readonly) this._setCalendar("disabled", calendar);
        if (value) this._setCalendar("value", calendar);
        return this.calendar;
    }
    /**
     * Releases Flatpickr instances.
     */ _releaseDatePicker() {
        if (this.calendar) {
            this.calendar.destroy();
            this.calendar = null;
        }
        return this.calendar;
    }
    /**
     * The date(s) in ISO8601 format (date portion only), for range mode, '/' is used for separate start/end dates.
     */ get value() {
        return this._value;
    }
    set value(value) {
        const { _value: oldValue } = this;
        this._value = value;
        this.requestUpdate("value", oldValue);
    }
    connectedCallback() {
        super.connectedCallback();
        this._instantiateDatePicker();
    }
    disconnectedCallback() {
        this._releaseDatePicker();
        super.disconnectedCallback();
    }
    updated(changedProperties) {
        const { calendar } = this;
        if (calendar && changedProperties.has("dateFormat")) this._setCalendar("dateFormat", calendar);
        if (changedProperties.has("minDate") || changedProperties.has("maxDate")) this._setCalendar("date", calendar);
        if (changedProperties.has("open") && calendar) this._setCalendar("open", calendar);
        if (changedProperties.has("disabled") || changedProperties.has("readonly")) this._setCalendar("disabled", calendar);
        if (changedProperties.has("value")) this._setCalendar("value", calendar);
    }
    render() {
        const { _handleSlotChange: handleSlotChange } = this;
        return (0, _lit.html)`
      <a
        class="${0, _settingsJs.prefix}--visually-hidden"
        href="javascript:void 0"
        role="navigation"></a>
      <slot @slotchange="${handleSlotChange}"></slot>
      <div id="floating-menu-container"></div>
      <a
        class="${0, _settingsJs.prefix}--visually-hidden"
        href="javascript:void 0"
        role="navigation"></a>
    `;
    }
    /**
     * The CSS class for the calendar dropdown.
     */ static get classCalendarContainer() {
        return `${0, _settingsJs.prefix}--date-picker__calendar`;
    }
    /**
     * The CSS class for the month navigator.
     */ static get classMonth() {
        return `${0, _settingsJs.prefix}--date-picker__month`;
    }
    /**
     * The CSS class for the container of the weekdays.
     */ static get classWeekdays() {
        return `${0, _settingsJs.prefix}--date-picker__weekdays`;
    }
    /**
     * The CSS class for the container of the days.
     */ static get classDays() {
        return `${0, _settingsJs.prefix}--date-picker__days`;
    }
    /**
     * The CSS class applied to each weekdays.
     */ static get classWeekday() {
        return `${0, _settingsJs.prefix}--date-picker__weekday`;
    }
    /**
     * The CSS class applied to each days.
     */ static get classDay() {
        return `${0, _settingsJs.prefix}--date-picker__day`;
    }
    /**
     * A selector that will return the `<input>` to enter starting date.
     */ static get selectorInputFrom() {
        return `${0, _settingsJs.prefix}-date-picker-input,${0, _settingsJs.prefix}-date-picker-input[kind="from"]`;
    }
    /**
     * A selector that will return the `<input>` to enter end date.
     */ static get selectorInputTo() {
        return `${0, _settingsJs.prefix}-date-picker-input[kind="to"]`;
    }
    /**
     * The name of the custom event when Flatpickr throws an error.
     */ static get eventFlatpickrError() {
        return `${0, _settingsJs.prefix}-date-picker-flatpickr-error`;
    }
    /**
     * The name of the custom event fired on this element when Flatpickr updates its value.
     */ static get eventChange() {
        return `${0, _settingsJs.prefix}-date-picker-changed`;
    }
};
/**
 * The CSS selector for Flatpickr's month/year portion.
 */ CDSDatePicker._selectorFlatpickrMonthYearContainer = ".flatpickr-current-month";
/**
 * The CSS selector for Flatpickr's year portion.
 */ CDSDatePicker._selectorFlatpickrYearContainer = ".numInputWrapper";
/**
 * The CSS selector for the inner element of Flatpickr's month portion.
 */ CDSDatePicker._selectorFlatpickrCurrentMonth = ".cur-month";
/**
 * The CSS selector for Flatpickr's month navigator.
 */ CDSDatePicker._selectorFlatpickrMonth = ".flatpickr-month";
/**
 * The CSS selector for Flatpickr's container of the weekdays.
 */ CDSDatePicker._selectorFlatpickrWeekdays = ".flatpickr-weekdays";
/**
 * The CSS selector for Flatpickr's container of the days.
 */ CDSDatePicker._selectorFlatpickrDays = ".flatpickr-days";
/**
 * The CSS selector applied to Flatpickr's each weekdays.
 */ CDSDatePicker._selectorFlatpickrWeekday = ".flatpickr-weekday";
/**
 * The CSS selector applied to Flatpickr's each days.
 */ CDSDatePicker._selectorFlatpickrDay = ".flatpickr-day";
/**
 * The CSS class for the inner element of Flatpickr's month portion.
 */ CDSDatePicker._classFlatpickrCurrentMonth = "cur-month";
/**
 * The CSS class applied to Flatpickr's "today" highlight.
 */ CDSDatePicker._classFlatpickrToday = "today";
/**
 * The CSS class applied to the "today" highlight if there are any dates selected.
 */ CDSDatePicker.classNoBorder = "no-border";
/**
 * The default date format.
 */ CDSDatePicker.defaultDateFormat = "m/d/Y";
/**
 * The default localization data.
 */ CDSDatePicker.defaultLocale = (0, _flatpickrDefault.default).l10ns.default;
CDSDatePicker.styles = (0, _datePickerScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#floating-menu-container")
], CDSDatePicker.prototype, "_floatingMenuContainerNode", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("eventChange")
], CDSDatePicker.prototype, "_handleChange", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "allow-input"
    })
], CDSDatePicker.prototype, "allowInput", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "close-on-select"
    })
], CDSDatePicker.prototype, "closeOnSelect", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "date-format"
    })
], CDSDatePicker.prototype, "dateFormat", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDatePicker.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: false
    })
], CDSDatePicker.prototype, "locale", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "enabled-range"
    })
], CDSDatePicker.prototype, "enabledRange", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "min-date"
    })
], CDSDatePicker.prototype, "minDate", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "max-date"
    })
], CDSDatePicker.prototype, "maxDate", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSDatePicker.prototype, "name", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDatePicker.prototype, "open", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDatePicker.prototype, "readonly", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSDatePicker.prototype, "value", null);
CDSDatePicker = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-date-picker`)
], CDSDatePicker);
var CDSDatePicker$1 = CDSDatePicker;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","flatpickr":"SWAMN","../../globals/settings.js":"EipuL","../../globals/mixins/form.js":"kISjL","../../globals/mixins/host-listener.js":"1SMUX","../../globals/decorators/host-listener.js":"f95Mj","./iso-date.js":"gpRj0","./append-to-plugin.js":"avy1g","./css-class-plugin.js":"4uhyD","./fix-events-plugin.js":"hpvYN","./focus-plugin.js":"6I3zT","./icon-plugin.js":"55sm3","./month-select-plugin.js":"egQni","./range-plugin.js":"kEA3o","./shadow-dom-events-plugin.js":"MAtNB","./state-handshake-plugin.js":"c8iaP","./date-picker.scss.js":"6GenX","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"SWAMN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _options = require("./types/options");
var _default = require("./l10n/default");
var _defaultDefault = parcelHelpers.interopDefault(_default);
var _utils = require("./utils");
var _dom = require("./utils/dom");
var _dates = require("./utils/dates");
var _formatting = require("./utils/formatting");
var _polyfills = require("./utils/polyfills");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var DEBOUNCED_CHANGE_MS = 300;
function FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: __assign(__assign({}, (0, _options.defaults)), flatpickr.defaultConfig),
        l10n: (0, _defaultDefault.default)
    };
    self.parseDate = (0, _dates.createDateParser)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, _dom.createElement);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, _dates.compareDates)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, _dates.getDefaultHours)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, _utils.int)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, _dates.compareDates)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, _dates.compareDates)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, _dates.calculateSecondsSinceMidnight)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, _dates.calculateSecondsSinceMidnight)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, _dates.calculateSecondsSinceMidnight)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, _dates.parseSeconds)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, _utils.pad)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, _utils.int)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, _utils.pad)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, _utils.int)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, _utils.pad)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, _dom.getEventTarget)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, _utils.debounce)(onResize, 50);
        self._debouncedChange = (0, _utils.debounce)(triggerChange, DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, _dom.getEventTarget)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, _dom.getEventTarget)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, _dom.getEventTarget)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, _dom.getEventTarget)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, _dom.createElement)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, _dom.createElement)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, _dom.createElement)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, _dom.createElement)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, _dom.toggleClass)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, _dom.toggleClass)(self.calendarContainer, "animate", self.config.animate === true);
        (0, _dom.toggleClass)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, _dom.createElement)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, _dom.createElement)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, _dates.compareDates)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, _dom.toggleClass)(dayElement, "startRange", self.selectedDates[0] && (0, _dates.compareDates)(date, self.selectedDates[0], true) === 0);
                    (0, _dom.toggleClass)(dayElement, "endRange", self.selectedDates[1] && (0, _dates.compareDates)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, _dom.createElement)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, _dom.clearNode)(self.daysContainer);
        if (self.weekNumbers) (0, _dom.clearNode)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, _dom.createElement)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, _formatting.monthToStr)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, _dom.createElement)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, _dom.createElement)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, _dom.createElement)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, _dom.getEventTarget)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, _dom.createNumberInput)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, _dom.createElement)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, _dom.clearNode)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, _dom.createElement)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, _dom.createElement)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, _dom.createElement)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, _dom.toggleClass)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, _dom.toggleClass)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, _dates.getDefaultHours)(self.config);
        self.timeContainer = (0, _dom.createElement)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, _dom.createElement)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, _dom.createNumberInput)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, _dom.createNumberInput)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, _utils.pad)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, _utils.pad)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, _dom.createNumberInput)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, _utils.pad)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, _dom.createElement)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, _dom.createElement)("span", "flatpickr-am-pm", self.l10n.amPM[(0, _utils.int)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, _dom.createElement)("div", "flatpickr-weekdays");
        else (0, _dom.clearNode)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, _dom.createElement)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = __spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = __spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, _dom.createElement)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, _dom.createElement)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, _dom.createElement)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, _dates.getDefaultHours)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, _dom.getEventTarget)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, _dates.compareDates)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, _dates.compareDates)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, _dom.getEventTarget)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, _dates.duration).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, _dates.isBetween)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, _dom.getEventTarget)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = __assign(__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = flatpickr.defaultConfig.dateFormat || (0, _options.defaults).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = flatpickr.defaultConfig.altFormat || (0, _options.defaults).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, _options.HOOKS).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, _utils.arrayify)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, _options.HOOKS).indexOf(key) > -1) self.config[key] = (0, _utils.arrayify)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = __assign(__assign({}, flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? flatpickr.l10ns[self.config.locale] : undefined);
        (0, _formatting.tokenRegex).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, _formatting.tokenRegex).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, _formatting.tokenRegex).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, _formatting.tokenRegex).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, _formatting.tokenRegex).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = __assign(__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, _dates.createDateFormatter)(self);
        self.parseDate = (0, _dates.createDateParser)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, _dom.toggleClass)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, _dom.toggleClass)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, _dom.toggleClass)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, _dom.toggleClass)(self.calendarContainer, "arrowCenter", isCenter);
        (0, _dom.toggleClass)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, _dom.toggleClass)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, _dom.toggleClass)(self.calendarContainer, "rightMost", false);
            (0, _dom.toggleClass)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, _dom.findParent)((0, _dom.getEventTarget)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, _dates.compareDates)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, _options.HOOKS).indexOf(option) > -1) self.config[option] = (0, _utils.arrayify)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, _dom.createElement)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, _dom.createElement)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, _dom.getEventTarget)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, _dates.compareDates)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, _dates.compareDates)(date, self.selectedDates[0]) >= 0 && (0, _dates.compareDates)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, _formatting.monthToStr)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, _dom.getEventTarget)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, _dom.getEventTarget)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, _utils.int)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, _utils.int)(!isHourElem) + ((0, _utils.int)(isHourElem) && (0, _utils.int)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, _utils.int)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, _utils.int)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, _utils.pad)(newValue);
        }
    }
    init();
    return self;
}
function _flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return _flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return _flatpickr([
            this
        ], config);
    };
}
var flatpickr = function(selector, config) {
    if (typeof selector === "string") return _flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return _flatpickr([
        selector
    ], config);
    else return _flatpickr(selector, config);
};
flatpickr.defaultConfig = {};
flatpickr.l10ns = {
    en: __assign({}, (0, _defaultDefault.default)),
    default: __assign({}, (0, _defaultDefault.default))
};
flatpickr.localize = function(l10n) {
    flatpickr.l10ns.default = __assign(__assign({}, flatpickr.l10ns.default), l10n);
};
flatpickr.setDefaults = function(config) {
    flatpickr.defaultConfig = __assign(__assign({}, flatpickr.defaultConfig), config);
};
flatpickr.parseDate = (0, _dates.createDateParser)({});
flatpickr.formatDate = (0, _dates.createDateFormatter)({});
flatpickr.compareDates = (0, _dates.compareDates);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return _flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = flatpickr;
exports.default = flatpickr;

},{"./types/options":"fBqlE","./l10n/default":"liUEe","./utils":"5PUj6","./utils/dom":"dbMpk","./utils/dates":"lxUuz","./utils/formatting":"2p97F","./utils/polyfills":"71UJ8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fBqlE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HOOKS", ()=>HOOKS);
parcelHelpers.export(exports, "defaults", ()=>defaults);
var HOOKS = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var defaults = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"liUEe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "english", ()=>english);
var english = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
exports.default = english;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5PUj6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pad", ()=>pad);
parcelHelpers.export(exports, "int", ()=>int);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "arrayify", ()=>arrayify);
var pad = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var int = function(bool) {
    return bool === true ? 1 : 0;
};
function debounce(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var arrayify = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dbMpk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toggleClass", ()=>toggleClass);
parcelHelpers.export(exports, "createElement", ()=>createElement);
parcelHelpers.export(exports, "clearNode", ()=>clearNode);
parcelHelpers.export(exports, "findParent", ()=>findParent);
parcelHelpers.export(exports, "createNumberInput", ()=>createNumberInput);
parcelHelpers.export(exports, "getEventTarget", ()=>getEventTarget);
function toggleClass(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function createElement(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function clearNode(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function findParent(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return findParent(node.parentNode, condition);
    return undefined;
}
function createNumberInput(inputClassName, opts) {
    var wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function getEventTarget(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lxUuz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDateFormatter", ()=>createDateFormatter);
parcelHelpers.export(exports, "createDateParser", ()=>createDateParser);
parcelHelpers.export(exports, "compareDates", ()=>compareDates);
parcelHelpers.export(exports, "compareTimes", ()=>compareTimes);
parcelHelpers.export(exports, "isBetween", ()=>isBetween);
parcelHelpers.export(exports, "calculateSecondsSinceMidnight", ()=>calculateSecondsSinceMidnight);
parcelHelpers.export(exports, "parseSeconds", ()=>parseSeconds);
parcelHelpers.export(exports, "duration", ()=>duration);
parcelHelpers.export(exports, "getDefaultHours", ()=>getDefaultHours);
var _formatting = require("./formatting");
var _options = require("../types/options");
var _default = require("../l10n/default");
var createDateFormatter = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, _options.defaults) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, _default.english) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, _formatting.formats)[c] && arr[i - 1] !== "\\" ? (0, _formatting.formats)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var createDateParser = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, _options.defaults) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, _default.english) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, _options.defaults)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, _formatting.tokenRegex)[token] && !escaped) {
                        regexStr += (0, _formatting.tokenRegex)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, _formatting.revFormat)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function compareDates(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function compareTimes(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var isBetween = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var calculateSecondsSinceMidnight = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var parseSeconds = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var duration = {
    DAY: 86400000
};
function getDefaultHours(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}

},{"./formatting":"2p97F","../types/options":"fBqlE","../l10n/default":"liUEe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2p97F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monthToStr", ()=>monthToStr);
parcelHelpers.export(exports, "revFormat", ()=>revFormat);
parcelHelpers.export(exports, "tokenRegex", ()=>tokenRegex);
parcelHelpers.export(exports, "formats", ()=>formats);
var _utils = require("../utils");
var doNothing = function() {
    return undefined;
};
var monthToStr = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var revFormat = {
    D: doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, _utils.int)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var tokenRegex = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var formats = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[formats.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return monthToStr(formats.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, _utils.pad)(formats.h(date, locale, options));
    },
    H: function(date) {
        return (0, _utils.pad)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, _utils.int)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return monthToStr(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, _utils.pad)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, _utils.pad)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, _utils.pad)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, _utils.pad)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, _utils.pad)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};

},{"../utils":"5PUj6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"71UJ8":[function(require,module,exports) {
"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};

},{}],"gpRj0":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2019, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param date A date.
 * @returns Date portion of the ISO8601 string of the given date, based on the local timezone.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getISODateString", ()=>getISODateString);
parcelHelpers.export(exports, "parseISODateString", ()=>parseISODateString);
const getISODateString = (date)=>new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString().split("T")[0];
/**
 * @param s A date portion of an ISO8601 string, based on the local timezone.
 * @returns The date object corresponding to the given ISO8601 string.
 */ const parseISODateString = (s)=>{
    const utcDate = new Date(Date.parse(s));
    return new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"avy1g":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to put the calendar dropdown in shadow DOM.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>appendToPlugin);
var appendToPlugin = (config)=>(fp)=>{
        /**
     * Adjusts the floating meun position after Flatpicker sets it.
     */ const handlePreCalendarPosition = async ()=>{
            await Promise.resolve();
            const { calendarContainer, config: fpConfig, _positionElement: positionElement } = fp;
            const { appendTo } = fpConfig;
            const { top: containerTop } = appendTo.getBoundingClientRect();
            const { bottom: refBottom } = positionElement.getBoundingClientRect();
            const isRtl = appendTo.ownerDocument.defaultView.getComputedStyle(appendTo).getPropertyValue("direction") === "rtl";
            calendarContainer.style.top = `${refBottom - containerTop}px`;
            calendarContainer.style.left = !isRtl ? "0" : "auto";
            calendarContainer.style.right = !isRtl ? "auto" : "0";
        };
        /**
     * Registers this Flatpickr plugin.
     *
     */ const register = ()=>{
            fp.loadedPlugins.push("carbonFlatpickrAppendToPlugin");
        };
        return {
            appendTo: config.appendTo,
            onReady: register,
            onPreCalendarPosition: handlePreCalendarPosition
        };
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4uhyD":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cssClassPlugin);
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to set CSS classes specific to this design system.
 */ var cssClassPlugin = (config)=>(fp)=>{
        /**
     * Adds class names specific to our design system to calendar dropdown.
     */ const ensureClassesInDatePicker = ()=>{
            const { calendarContainer, selectedDates } = fp;
            if (calendarContainer) {
                const { classCalendarContainer, classMonth, classWeekdays, classDays, classWeekday, classDay, classNoBorder, selectorFlatpickrMonth, selectorFlatpickrWeekdays, selectorFlatpickrDays, selectorFlatpickrWeekday, selectorFlatpickrDay, classFlatpickrToday } = config;
                calendarContainer.classList.add(classCalendarContainer);
                const month = calendarContainer.querySelector(selectorFlatpickrMonth);
                if (month) month.classList.add(classMonth);
                const weekdays = calendarContainer.querySelector(selectorFlatpickrWeekdays);
                if (weekdays) weekdays.classList.add(classWeekdays);
                const days = calendarContainer.querySelector(selectorFlatpickrDays);
                if (days) days.classList.add(classDays);
                (0, _collectionHelpersJs.forEach)(calendarContainer.querySelectorAll(selectorFlatpickrWeekday), (item)=>{
                    item.innerHTML = item.innerHTML.replace(/\s+/g, "");
                    item.classList.add(classWeekday);
                });
                (0, _collectionHelpersJs.forEach)(calendarContainer.querySelectorAll(selectorFlatpickrDay), (item)=>{
                    item.classList.add(classDay);
                    if (item.classList.contains(classFlatpickrToday) && selectedDates.length > 0) item.classList.add(classNoBorder);
                    else if (item.classList.contains(classFlatpickrToday) && selectedDates.length === 0) item.classList.remove(classNoBorder);
                });
            }
        };
        /**
     * Registers this Flatpickr plugin.
     */ const register = ()=>{
            fp.loadedPlugins.push("carbonFlatpickrCSSClassPlugin");
        };
        return {
            onMonthChange: ensureClassesInDatePicker,
            onYearChange: ensureClassesInDatePicker,
            onValueUpdate: ensureClassesInDatePicker,
            onOpen: ensureClassesInDatePicker,
            onReady: [
                register
            ]
        };
    };

},{"../../globals/internal/collection-helpers.js":"4aZkz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hpvYN":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>fixEventsPlugin);
var _onJs = require("../../globals/mixins/on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to fix Flatpickr's behavior of certain events.
 */ var fixEventsPlugin = (config)=>(fp)=>{
        /**
     * Handles `keydown` event.
     */ const handleKeydown = (event)=>{
            const { inputFrom, inputTo } = config;
            const { key, target } = event;
            if (inputFrom === target || inputTo === target) switch(key){
                case "Enter":
                    // Makes sure the hitting enter key picks up pending values of both `<input>`
                    // Workaround for: https://github.com/flatpickr/flatpickr/issues/1942
                    fp.setDate([
                        inputFrom.value,
                        inputTo && inputTo.value
                    ], true, fp.config.dateFormat);
                    event.stopPropagation();
                    break;
                case "ArrowLeft":
                case "Left":
                case "ArrowRight":
                case "Right":
                    // Prevents Flatpickr code from canceling the event if left/right arrow keys are hit on `<input>`,
                    // so user can move the keyboard cursor for editing dates
                    // Workaround for: https://github.com/flatpickr/flatpickr/issues/1943
                    event.stopPropagation();
                    break;
            }
        };
        /**
     * Releases event listeners used in this Flatpickr plugin.
     */ const release = ()=>{
            if (fp._hCDSCEDatePickerFixEventsPluginKeydownTo) fp._hCDSCEDatePickerFixEventsPluginKeydownTo = fp._hCDSCEDatePickerFixEventsPluginKeydownTo.release();
            if (fp._hCDSCEDatePickerFixEventsPluginKeydownFrom) fp._hCDSCEDatePickerFixEventsPluginKeydownFrom = fp._hCDSCEDatePickerFixEventsPluginKeydownFrom.release();
        };
        /**
     * Sets up event listeners used for this Flatpickr plugin.
     */ const init = ()=>{
            release();
            const { inputFrom, inputTo } = config;
            fp._hCDSCEDatePickerFixEventsPluginKeydownFrom = (0, _onJsDefault.default)(inputFrom, "keydown", handleKeydown, true);
            if (inputTo) fp._hCDSCEDatePickerFixEventsPluginKeydownTo = (0, _onJsDefault.default)(inputTo, "keydown", handleKeydown, true);
        };
        /**
     * Registers this Flatpickr plugin.
     */ const register = ()=>{
            fp.loadedPlugins.push("carbonFlatpickrFixEventsPlugin");
        };
        return {
            onReady: [
                register,
                init
            ],
            onDestroy: [
                release
            ]
        };
    };

},{"../../globals/mixins/on.js":"hYHF3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6I3zT":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>focusPlugin);
var _onJs = require("../../globals/mixins/on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to manage focus to align with the UX pattern in our design system.
 */ var focusPlugin = (config)=>(fp)=>{
        /**
     * Focuses on calendar dropdown.
     */ const focusCalendar = ()=>{
            const { calendarContainer, selectedDateElem, todayDateElem } = fp;
            (selectedDateElem || todayDateElem || calendarContainer).focus();
        };
        /**
     * Handles `blur` event to move the focus back to the `<input>`.
     */ const handleBlur = ({ target, relatedTarget })=>{
            // Obtains `beingUpdated` up-front because it'll be flushed out shortly
            const { calendarContainer, isOpen } = fp;
            if (isOpen && calendarContainer.contains(target) && !calendarContainer.contains(relatedTarget) && relatedTarget !== config.inputFrom && relatedTarget !== config.inputTo) Promise.resolve().then(()=>{
                const rootNode = target.getRootNode();
                // This `blur` event handler can be called from Flatpickr's code,
                // cleaning up the calendar dropdowns DOM. Changing focus in such
                // condition causes removing an orphaned DOM node, because Flatpickr
                // redraws the calendar dropdown when the `<input>` gets focus.
                if (rootNode.nodeType === Node.DOCUMENT_NODE || rootNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                    if (fp._lastFocusInput === config.inputTo) config.inputTo.focus();
                    else config.inputFrom.focus();
                    // Closing after moving focus. Reversing the order will cause re-opening calendar dropdown upon focusing
                    fp.close();
                }
            });
        };
        /**
     * Handles `keydown` event to move focus on calendar dropdown.
     */ const handleInputKeydown = (event)=>{
            const { key } = event;
            if (key === "ArrowDown" || key === "Down" || key === "Enter") {
                event.preventDefault();
                fp.open();
                if (key !== "Enter") focusCalendar();
                else // Hitting Enter key blurs the `<input>`, causing any element to lose focus
                setTimeout(focusCalendar, 0);
            }
        };
        /**
     * Handles `focus` event on `<input>` for starting/end date to track the lastly focused one.
     */ const handleInputFocus = ({ target })=>{
            fp._lastFocusInput = target;
        };
        /**
     * Releases event listeners used in this Flatpickr plugin.
     */ const release = ()=>{
            if (fp._hCDSCEDatePickerFocusPluginBlur) fp._hCDSCEDatePickerFocusPluginBlur = fp._hCDSCEDatePickerFocusPluginBlur.release();
            if (fp._hCDSCEDatePickerFocusPluginFocusTo) fp._hCDSCEDatePickerFocusPluginFocusTo = fp._hCDSCEDatePickerFocusPluginFocusTo.release();
            if (fp._hCDSCEDatePickerFocusPluginFocusFrom) fp._hCDSCEDatePickerFocusPluginFocusFrom = fp._hCDSCEDatePickerFocusPluginFocusFrom.release();
            if (fp._hCDSCEDatePickerFocusPluginKeydownTo) fp._hCDSCEDatePickerFocusPluginKeydownTo = fp._hCDSCEDatePickerFocusPluginKeydownTo.release();
            if (fp._hCDSCEDatePickerFocusPluginKeydownFrom) fp._hCDSCEDatePickerFocusPluginKeydownFrom = fp._hCDSCEDatePickerFocusPluginKeydownFrom.release();
        };
        /**
     * Sets up event listeners used for this Flatpickr plugin.
     */ const init = ()=>{
            release();
            const { inputFrom, inputTo } = config;
            fp._hCDSCEDatePickerFocusPluginBlur = (0, _onJsDefault.default)(fp.calendarContainer, "blur", handleBlur, true);
            fp._hCDSCEDatePickerFocusPluginKeydownFrom = (0, _onJsDefault.default)(inputFrom, "keydown", handleInputKeydown);
            if (inputTo) fp._hCDSCEDatePickerFocusPluginKeydownTo = (0, _onJsDefault.default)(inputTo, "keydown", handleInputKeydown);
            fp._hCDSCEDatePickerFocusPluginFocusFrom = (0, _onJsDefault.default)(inputFrom, "focus", handleInputFocus);
            if (inputTo) fp._hCDSCEDatePickerFocusPluginFocusTo = (0, _onJsDefault.default)(inputTo, "focus", handleInputFocus);
        };
        /**
     * Registers this Flatpickr plugin.
     *
     */ const register = ()=>{
            fp.loadedPlugins.push("carbonFlatpickrFocusPlugin");
        };
        return {
            onReady: [
                register,
                init
            ],
            onDestroy: release
        };
    };

},{"../../globals/mixins/on.js":"hYHF3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"55sm3":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>iconPlugin);
var _lit = require("lit");
var _16Js = require("../../icons/chevron--left/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/chevron--right/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @returns A Flatpickr plugin to set the right icons in the design system.
 */ var iconPlugin = ()=>(fp)=>{
        /**
     * Sets the icon in the design system.
     */ const setIcon = ()=>{
            const { prevMonthNav, nextMonthNav } = fp;
            (0, _lit.render)((0, _16JsDefault.default)(), prevMonthNav);
            (0, _lit.render)((0, _16JsDefault1.default)(), nextMonthNav);
        };
        /**
     * Sets empty arrow icon contents as we render those icons after initialization.
     */ const parseConfig = ()=>{
            const { config } = fp;
            config.prevArrow = "";
            config.nextArrow = "";
        };
        /**
     * Registers this Flatpickr plugin.
     *
     */ const register = ()=>{
            fp.loadedPlugins.push("carbonFlatpickrIconPlugin");
        };
        return {
            onParseConfig: parseConfig,
            onReady: [
                register,
                setIcon
            ]
        };
    };

},{"lit":"aCmte","../../icons/chevron--left/16.js":"gOtHL","../../icons/chevron--right/16.js":"bkZcb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gOtHL":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M5 8L10 3 10.7 3.7 6.4 8 10.7 12.3 10 13z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"egQni":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>monthSelectPlugin);
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param monthNumber The month number.
 * @param shorthand `true` to use shorthand month.
 * @param locale The Flatpickr locale data.
 * @returns The month string.
 */ const monthToStr = (monthNumber, shorthand, locale)=>locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
/**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to use text instead of `<select>` for month picker.
 */ var monthSelectPlugin = (config)=>(fp)=>{
        /**
     * Replaces `<select>` for month with text content.
     */ const setupElements = ()=>{
            const { monthElements, yearElements, currentMonth, l10n, _createElement: createElement } = fp;
            if (!monthElements) return;
            const { shorthand, selectorFlatpickrMonthYearContainer, selectorFlatpickrYearContainer, classFlatpickrCurrentMonth } = config;
            monthElements.forEach((elem)=>{
                if (!elem.parentNode) return;
                elem.parentNode.removeChild(elem);
            });
            monthElements.splice(0, monthElements.length, ...monthElements.map(()=>{
                const monthElement = createElement("span", classFlatpickrCurrentMonth);
                monthElement.textContent = monthToStr(currentMonth, shorthand === true, l10n);
                const monthYearContainer = yearElements[0].closest(selectorFlatpickrMonthYearContainer);
                if (monthYearContainer) monthYearContainer.insertBefore(monthElement, yearElements[0].closest(selectorFlatpickrYearContainer));
                return monthElement;
            }));
        };
        /**
     * Updates the text-based month UI with the latest selected date.
     */ const updateCurrentMonth = ()=>{
            const { yearElements, currentMonth, l10n } = fp;
            const { shorthand, selectorFlatpickrMonthYearContainer, selectorFlatpickrCurrentMonth } = config;
            const monthStr = monthToStr(currentMonth, shorthand === true, l10n);
            yearElements.forEach((elem)=>{
                const currentMonthContainer = elem.closest(selectorFlatpickrMonthYearContainer);
                if (currentMonthContainer) (0, _collectionHelpersJs.forEach)(currentMonthContainer.querySelectorAll(selectorFlatpickrCurrentMonth), (monthElement)=>{
                    monthElement.textContent = monthStr;
                });
            });
        };
        /**
     * Registers this Flatpickr plugin.
     */ const register = ()=>{
            fp.loadedPlugins.push("carbonFlatpickrMonthSelectPlugin");
        };
        return {
            onMonthChange: updateCurrentMonth,
            onValueUpdate: updateCurrentMonth,
            onOpen: updateCurrentMonth,
            onReady: [
                setupElements,
                updateCurrentMonth,
                register
            ]
        };
    };

},{"../../globals/internal/collection-helpers.js":"4aZkz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kEA3o":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rangePlugin);
var _rangePlugin = require("flatpickr/dist/plugins/rangePlugin");
var _rangePluginDefault = parcelHelpers.interopDefault(_rangePlugin);
var _onJs = require("../../globals/mixins/on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param config Plugin configuration.
 * @returns
 *   An extension of Flatpickr `rangePlugin` that does the following:
 *
 *   Better ensures the calendar dropdown is always aligned to the `<input>` for the starting date.
 *     Workaround for: https://github.com/flatpickr/flatpickr/issues/1944
 *   Disables the logic in Flatpickr `rangePlugin` that calculates the new range with the old selected date
 *     when user selects a date from calendar dropdown.
 *     We'd like to reset the selection when user re-opens calendar dropdown and re-selects a date.
 *     Workaround for: https://github.com/flatpickr/flatpickr/issues/1958
 *   Disables the logic in Flatpickr `rangePlugin` that closes the calendar dropdown
 *     when it's launched from the `<input>` for the end date and user selects a date.
 *     Workaround for: https://github.com/flatpickr/flatpickr/issues/1958
 *   Ensures that the `<input>` in shadow DOM is treated as part of Flatpickr UI,
 *     by ensuring such `<input>` hits `.contains()` search from `fp.config.ignoredFocusElements`.
 *     Without that, Flatpickr clears the `<input>` when end date hasn't been selected yet (which we don't want).
 */ var rangePlugin = (config)=>{
    const factory = (0, _rangePluginDefault.default)(Object.assign({
        position: "left"
    }, config));
    return (fp)=>{
        const origRangePlugin = factory(fp);
        const { onReady: origOnReady } = origRangePlugin;
        const getDateStrFromInputs = (dates)=>{
            return dates.filter((value)=>value).filter((d, i, arr)=>fp.config.mode !== "range" || fp.config.enableTime || arr.indexOf(d) === i).join(fp.config.mode !== "range" ? fp.config.conjunction : fp.l10n.rangeSeparator);
        };
        const handleBlur = (event)=>{
            event.stopPropagation();
            const firstInput = fp._input;
            const secondInput = config.input;
            const isInput = event.target === firstInput || event.target === secondInput;
            const valueChanged = getDateStrFromInputs([
                firstInput.value,
                secondInput.value
            ]) !== fp.getDateStr();
            const relatedTargetIsCalendar = event.relatedTarget && event.relatedTarget instanceof Node && fp.calendarContainer.contains(event.relatedTarget);
            if (isInput && valueChanged && !relatedTargetIsCalendar) fp.setDate([
                firstInput.value,
                secondInput.value
            ], true, firstInput === fp.altInput ? fp.config.altFormat : fp.config.dateFormat);
        };
        const release = ()=>{
            if (fp._hBXCEDatePickerRangePluginOnBlurFrom) fp._hBXCEDatePickerRangePluginOnBlurFrom = fp._hBXCEDatePickerRangePluginOnBlurFrom.release();
            if (fp._hBXCEDatePickerRangePluginOnBlurTo) fp._hBXCEDatePickerRangePluginOnBlurTo = fp._hBXCEDatePickerRangePluginOnBlurTo.release();
        };
        return Object.assign(origRangePlugin, {
            onReady () {
                origOnReady.call(this);
                const { ignoredFocusElements } = fp.config;
                ignoredFocusElements.push(...ignoredFocusElements.map((elem)=>elem.shadowRoot).filter(Boolean));
                // Setup event listeners for the blur even on both inputs. In the case
                // of the first input, we're overriding the blur event handler from
                // the library to fix it by setting it on the capture phase and then
                // stopping propagation. This is necessary b/c the library does not take
                // the range plugin into consideration when it calls setDate.
                // Workaround for: https://github.com/flatpickr/flatpickr/issues/2918
                release();
                if (fp.config.allowInput) {
                    fp._hBXCEDatePickerRangePluginOnBlurFrom = (0, _onJsDefault.default)(fp._input, "blur", handleBlur, {
                        capture: true
                    });
                    fp._hBXCEDatePickerRangePluginOnBlurTo = (0, _onJsDefault.default)(config.input, "blur", handleBlur, {
                        capture: true
                    });
                }
            }
        });
    };
};

},{"flatpickr/dist/plugins/rangePlugin":"3Lk4Q","../../globals/mixins/on.js":"hYHF3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Lk4Q":[function(require,module,exports) {
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ function __spreadArrays() {
        for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
        for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
        return r;
    }
    function rangePlugin(config) {
        if (config === void 0) config = {};
        return function(fp) {
            var dateFormat = "", secondInput, _secondInputFocused, _prevDates;
            var createSecondInput = function() {
                if (config.input) {
                    secondInput = config.input instanceof Element ? config.input : window.document.querySelector(config.input);
                    if (!secondInput) {
                        fp.config.errorHandler(new Error("Invalid input element specified"));
                        return;
                    }
                    if (fp.config.wrap) secondInput = secondInput.querySelector("[data-input]");
                } else {
                    secondInput = fp._input.cloneNode();
                    secondInput.removeAttribute("id");
                    secondInput._flatpickr = undefined;
                }
                if (secondInput.value) {
                    var parsedDate = fp.parseDate(secondInput.value);
                    if (parsedDate) fp.selectedDates.push(parsedDate);
                }
                secondInput.setAttribute("data-fp-omit", "");
                if (fp.config.clickOpens) {
                    fp._bind(secondInput, [
                        "focus",
                        "click"
                    ], function() {
                        if (fp.selectedDates[1]) {
                            fp.latestSelectedDateObj = fp.selectedDates[1];
                            fp._setHoursFromDate(fp.selectedDates[1]);
                            fp.jumpToDate(fp.selectedDates[1]);
                        }
                        _secondInputFocused = true;
                        fp.isOpen = false;
                        fp.open(undefined, config.position === "left" ? fp._input : secondInput);
                    });
                    fp._bind(fp._input, [
                        "focus",
                        "click"
                    ], function(e) {
                        e.preventDefault();
                        fp.isOpen = false;
                        fp.open();
                    });
                }
                if (fp.config.allowInput) fp._bind(secondInput, "keydown", function(e) {
                    if (e.key === "Enter") {
                        fp.setDate([
                            fp.selectedDates[0],
                            secondInput.value
                        ], true, dateFormat);
                        secondInput.click();
                    }
                });
                if (!config.input) fp._input.parentNode && fp._input.parentNode.insertBefore(secondInput, fp._input.nextSibling);
            };
            var plugin = {
                onParseConfig: function() {
                    fp.config.mode = "range";
                    dateFormat = fp.config.altInput ? fp.config.altFormat : fp.config.dateFormat;
                },
                onReady: function() {
                    createSecondInput();
                    fp.config.ignoredFocusElements.push(secondInput);
                    if (fp.config.allowInput) {
                        fp._input.removeAttribute("readonly");
                        secondInput.removeAttribute("readonly");
                    } else secondInput.setAttribute("readonly", "readonly");
                    fp._bind(fp._input, "focus", function() {
                        fp.latestSelectedDateObj = fp.selectedDates[0];
                        fp._setHoursFromDate(fp.selectedDates[0]);
                        _secondInputFocused = false;
                        fp.jumpToDate(fp.selectedDates[0]);
                    });
                    if (fp.config.allowInput) fp._bind(fp._input, "keydown", function(e) {
                        if (e.key === "Enter") fp.setDate([
                            fp._input.value,
                            fp.selectedDates[1]
                        ], true, dateFormat);
                    });
                    fp.setDate(fp.selectedDates, false);
                    plugin.onValueUpdate(fp.selectedDates);
                    fp.loadedPlugins.push("range");
                },
                onPreCalendarPosition: function() {
                    if (_secondInputFocused) {
                        fp._positionElement = secondInput;
                        setTimeout(function() {
                            fp._positionElement = fp._input;
                        }, 0);
                    }
                },
                onChange: function() {
                    if (!fp.selectedDates.length) setTimeout(function() {
                        if (fp.selectedDates.length) return;
                        secondInput.value = "";
                        _prevDates = [];
                    }, 10);
                    if (_secondInputFocused) setTimeout(function() {
                        secondInput.focus();
                    }, 0);
                },
                onDestroy: function() {
                    if (!config.input) secondInput.parentNode && secondInput.parentNode.removeChild(secondInput);
                },
                onValueUpdate: function(selDates) {
                    var _a, _b, _c;
                    if (!secondInput) return;
                    _prevDates = !_prevDates || selDates.length >= _prevDates.length ? __spreadArrays(selDates) : _prevDates;
                    if (_prevDates.length > selDates.length) {
                        var newSelectedDate = selDates[0];
                        var newDates = _secondInputFocused ? [
                            _prevDates[0],
                            newSelectedDate
                        ] : [
                            newSelectedDate,
                            _prevDates[1]
                        ];
                        if (newDates[0].getTime() > newDates[1].getTime()) {
                            if (_secondInputFocused) newDates[0] = newDates[1];
                            else newDates[1] = newDates[0];
                        }
                        fp.setDate(newDates, false);
                        _prevDates = __spreadArrays(newDates);
                    }
                    _a = fp.selectedDates.map(function(d) {
                        return fp.formatDate(d, dateFormat);
                    }), _b = _a[0], fp._input.value = _b === void 0 ? "" : _b, _c = _a[1], secondInput.value = _c === void 0 ? "" : _c;
                }
            };
            return plugin;
        };
    }
    return rangePlugin;
});

},{}],"MAtNB":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shadowDOMEventPlugin);
var _onJs = require("../../globals/mixins/on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The amount of days to adjust, keyed by the key code.
 */ const moveDateForKeys = {
    ArrowLeft: -1,
    Left: -1,
    ArrowUp: -7,
    Up: -7,
    ArrowRight: 1,
    Right: 1,
    ArrowDown: 7,
    Down: 7
};
/**
 * The amount of months to adjust, keyed by the key code. Used with Ctrl modifier key.
 */ const moveMonthForKeys = {
    ArrowLeft: -1,
    Left: -1,
    ArrowUp: -12,
    Up: -12,
    ArrowRight: 1,
    Right: 1,
    ArrowDown: 12,
    Down: 12
};
/**
 * The number of milliseconds per day.
 */ const MILLISECONDS_IN_DAY = 86400000;
/**
 * Adjusts the date with the given amount of days.
 *
 * @param localDate The original date.
 * @param options The options.
 * @param [options.date=0] The amount of days to adjust.
 */ const adjustDate = (localDate, { date: moveDate = 0 })=>{
    const utcDate = new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate()) + moveDate * MILLISECONDS_IN_DAY);
    return new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
};
/**
 * @returns
 *   A Flatpickr plugin to handle events.
 *   Some event handlers in Flatpickr won't work is the calendar dropdown is put in shadow DOM, due to event retargetting.
 */ var shadowDOMEventPlugin = ()=>(fp)=>{
        const getDateElem = (localDate)=>(0, _collectionHelpersJs.find)(fp.daysContainer.firstElementChild.children, ({ dateObj })=>localDate.getTime() === dateObj.getTime());
        /**
     * Handles `keydown` event.
     */ const handleKeydown = (event)=>{
            const { ctrlKey, key, target } = event;
            if (key === "Enter") target.dispatchEvent(Object.assign(new CustomEvent("mousedown", {
                bubbles: true
            }), {
                which: 1
            }));
            else if (!ctrlKey && key in moveDateForKeys) {
                const { dateObj } = target;
                const movedDate = adjustDate(dateObj, {
                    date: moveDateForKeys[key]
                });
                const movedDateElem = getDateElem(movedDate);
                if (movedDateElem) movedDateElem.focus();
                else {
                    const innerDaysContainer = fp.daysContainer.firstElementChild;
                    if (movedDate.getTime() < innerDaysContainer.firstElementChild.dateObj.getTime()) {
                        fp.changeMonth(-1);
                        // `fp.daysContainer` is updated by `fp.changeMonth()`
                        fp.daysContainer.firstElementChild.lastElementChild.focus();
                    } else if (movedDate.getTime() > innerDaysContainer.lastElementChild.dateObj.getTime()) {
                        fp.changeMonth(1);
                        // `fp.daysContainer` is updated by `fp.changeMonth()`
                        fp.daysContainer.firstElementChild.firstElementChild.focus();
                    }
                }
                event.preventDefault();
            } else if (ctrlKey && key in moveMonthForKeys) {
                fp.changeMonth(moveMonthForKeys[key]);
                fp.daysContainer.firstElementChild.firstElementChild.focus();
                event.preventDefault();
            }
        };
        /**
     * Releases event listeners used in this Flatpickr plugin.
     */ const release = ()=>{
            if (fp._hCDSCEDatePickerShadowDOMEventsPluginKeydown) fp._hCDSCEDatePickerShadowDOMEventsPluginKeydown = fp._hCDSCEDatePickerShadowDOMEventsPluginKeydown.release();
        };
        /**
     * Sets up event listeners used for this Flatpickr plugin.
     */ const init = ()=>{
            release();
            fp._hCDSCEDatePickerShadowDOMEventsPluginKeydown = (0, _onJsDefault.default)(fp.calendarContainer, "keydown", handleKeydown);
        };
        /**
     * Registers this Flatpickr plugin.
     */ const register = ()=>{
            fp.loadedPlugins.push("carbonFlatpickrShadowDOMEventsPlugin");
        };
        return {
            onReady: [
                register,
                init
            ],
            onDestroy: [
                release
            ]
        };
    };

},{"../../globals/mixins/on.js":"hYHF3","../../globals/internal/collection-helpers.js":"4aZkz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c8iaP":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param datePicker Plugin configuration.
 * @returns A Flatpickr plugin to handshake states with `<cds-date-picker>`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>stateHandshakePlugin);
var stateHandshakePlugin = (datePicker)=>(fp)=>{
        /**
     * Sets open state.
     */ const setOpen = ()=>{
            datePicker.open = true;
        };
        /**
     * Sets closed state.
     */ const setClosed = ()=>{
            datePicker.open = false;
        };
        /**
     * Propagates Flatpickr's `onChange` event to `<cds-date-picker>`.
     *
     * @param selectedDates The latest selected dates.
     */ const handleChange = (selectedDates)=>{
            const { eventChange } = datePicker.constructor;
            datePicker.dispatchEvent(new CustomEvent(eventChange, {
                bubbles: true,
                cancelable: true,
                composed: true,
                detail: {
                    selectedDates
                }
            }));
        };
        /**
     * Registers this Flatpickr plugin.
     *
     * @param _selectedDates The selected dates.
     * @param _value The value.
     * @param calendar The Flatpickr instance.
     */ const register = (_selectedDates, _value, calendar)=>{
            datePicker.calendar = calendar;
            fp.loadedPlugins.push("carbonFlatpickrStateHandshakePlugin");
        };
        return {
            onOpen: setOpen,
            onClose: setClosed,
            onChange: handleChange,
            onReady: [
                register
            ]
        };
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6GenX":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}@keyframes fp-fade-in-down{0%{opacity:0;transform:translate3d(0,-20px,0)}to{opacity:1;transform:translateZ(0)}}@keyframes fp-slide-left{0%{transform:translateZ(0)}to{transform:translate3d(-100%,0,0)}}@keyframes fp-slide-left-new{0%{transform:translate3d(100%,0,0)}to{transform:translateZ(0)}}@keyframes fp-slide-right{0%{transform:translateZ(0)}to{transform:translate3d(100%,0,0)}}@keyframes fp-slide-right-new{0%{transform:translate3d(-100%,0,0)}to{transform:translateZ(0)}}@keyframes fp-fade-out{0%{opacity:1}to{opacity:0}}@keyframes fp-fade-in{0%{opacity:0}to{opacity:1}}.flatpickr-calendar{animation:none;border:0;border-radius:0;box-sizing:border-box;direction:ltr;inline-size:19.6875rem;max-block-size:0;opacity:0;overflow:hidden;padding:0;position:absolute;text-align:center;touch-action:manipulation;visibility:hidden}@media (forced-colors:active),screen and (-ms-high-contrast:active){.flatpickr-calendar{outline:1px solid transparent}}.flatpickr-calendar.inline,.flatpickr-calendar.open{max-block-size:40rem;opacity:1;overflow:visible;visibility:inherit}.flatpickr-calendar.open{align-items:center;background-color:var(--cds-layer-01,#f4f4f4);block-size:21rem;border:none;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));display:flex;flex-direction:column;inline-size:18rem;justify-content:center;margin-block-start:-.125rem;overflow:hidden;padding:.25rem .25rem .5rem;z-index:99999}.flatpickr-calendar.open:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.flatpickr-calendar.open:focus{outline-style:dotted}}.flatpickr-calendar.animate.open{animation:fp-fade-in-down .11s cubic-bezier(0,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.flatpickr-calendar.animate.open{animation:none}}.flatpickr-calendar.inline{display:block;inset-block-start:auto;position:absolute}.flatpickr-calendar.static{inset-block-start:calc(100% + 2px);position:absolute}.flatpickr-calendar.static.open{display:block;z-index:999}.flatpickr-calendar.hasWeeks{inline-size:auto}.dayContainer{block-size:15.375rem;display:flex;flex-wrap:wrap;justify-content:space-around;outline:0;padding:0}.flatpickr-calendar .hasTime .dayContainer,.flatpickr-calendar .hasWeeks .dayContainer{border-block-end:0;border-end-end-radius:0;border-end-start-radius:0}.flatpickr-calendar .hasWeeks .dayContainer{border-inline-start:0}.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time{block-size:2.5rem;border-block-start:1px solid #e6e6e6}.flatpickr-calendar.noCalendar.hasTime .flatpickr-time{block-size:auto}.flatpickr-calendar:focus{outline:0}.flatpickr-months{display:flex;inline-size:100%;justify-content:space-between}.flatpickr-month{align-items:center;background-color:transparent;block-size:2.5rem;color:var(--cds-text-primary,#161616);display:flex;font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);line-height:1;text-align:center}.flatpickr-next-month,.flatpickr-prev-month{align-items:center;block-size:2.5rem;cursor:pointer;display:flex;justify-content:center;padding:0;z-index:3;fill:var(--cds-icon-primary,#161616);inline-size:2.5rem;line-height:16px;text-decoration:none;transform:scale(1);transition:background-color 70ms cubic-bezier(.2,0,.38,.9);-webkit-user-select:none;-moz-user-select:none;user-select:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.flatpickr-next-month,.flatpickr-prev-month{fill:ButtonText}}@media screen and (prefers-reduced-motion:reduce){.flatpickr-next-month,.flatpickr-prev-month{transition:none}}.flatpickr-next-month:hover,.flatpickr-prev-month:hover{background-color:var(--cds-layer-hover)}.flatpickr-next-month.disabled svg,.flatpickr-prev-month.disabled svg{cursor:not-allowed;fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.flatpickr-next-month.disabled:hover svg,.flatpickr-prev-month.disabled:hover svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.flatpickr-current-month{align-items:center;block-size:1.75rem;display:flex;font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);justify-content:center;letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);text-align:center}.flatpickr-current-month .cur-month{margin-inline:.25rem .25rem}.flatpickr-current-month .cur-month:hover{background-color:var(--cds-layer-hover)}.numInputWrapper{inline-size:3.75rem;position:relative}.numInputWrapper:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.numInputWrapper .numInput{-moz-appearance:textfield;background-color:var(--cds-field-01,#f4f4f4);border:none;color:var(--cds-text-primary,#161616);cursor:default;display:inline-block;font-family:inherit;font-size:inherit;font-weight:600;inline-size:100%;margin:0;padding:.25rem}.numInputWrapper .numInput::-webkit-inner-spin-button,.numInputWrapper .numInput::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.numInputWrapper .numInput:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.numInputWrapper .numInput:focus{outline-style:dotted}}.numInputWrapper .numInput[disabled],.numInputWrapper .numInput[disabled]:hover{background-color:var(--cds-layer-01,#f4f4f4);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));pointer-events:none}.numInputWrapper .arrowUp{border-block-end:0;inset-block-start:.25rem}.numInputWrapper .arrowUp:after{border-block-end:.25rem solid var(--cds-icon-primary,#161616)}.numInputWrapper .arrowDown{inset-block-start:.6875rem}.numInputWrapper .arrowDown:after{border-block-start:.25rem solid var(--cds-icon-primary,#161616)}.numInputWrapper .arrowDown,.numInputWrapper .arrowUp{block-size:50%;border:none;cursor:pointer;inline-size:.75rem;inset-inline-start:2.6rem;line-height:50%;opacity:0;padding:0 .25rem 0 .125rem;position:absolute}.numInputWrapper .arrowDown:after,.numInputWrapper .arrowUp:after{border-inline-end:.25rem solid transparent;border-inline-start:.25rem solid transparent;content:"";display:block;inset-block-start:33%;position:absolute}.numInputWrapper .arrowDown:hover:after,.numInputWrapper .arrowUp:hover:after{border-block-end-color:var(--cds-button-primary,#0f62fe);border-block-start-color:var(--cds-button-primary,#0f62fe)}.numInputWrapper .arrowDown:active:after,.numInputWrapper .arrowUp:active:after{border-block-end-color:var(--cds-border-interactive,#0f62fe);border-block-start-color:var(--cds-border-interactive,#0f62fe)}.numInput[disabled]~.arrowUp:after{border-block-end-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.numInput[disabled]~.arrowDown:after{border-block-start-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.numInputWrapper:hover .arrowDown,.numInputWrapper:hover .arrowUp{opacity:1}.numInputWrapper:hover .numInput[disabled]~.arrowDown,.numInputWrapper:hover .numInput[disabled]~.arrowUp{opacity:0}.flatpickr-weekdays{align-items:center;block-size:2.5rem;display:flex}.flatpickr-weekdaycontainer{display:flex;inline-size:100%}.flatpickr-weekday{color:var(--cds-text-primary,#161616);cursor:default;flex:1;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.flatpickr-days:focus{outline:0}.flatpickr-calendar.animate .dayContainer.slideLeft{animation:fp-fade-out .4s cubic-bezier(.23,1,.32,1),fp-slide-left .4s cubic-bezier(.23,1,.32,1)}.flatpickr-calendar.animate .dayContainer.slideLeft,.flatpickr-calendar.animate .dayContainer.slideLeftNew{transform:translate3d(-100%,0,0)}.flatpickr-calendar.animate .dayContainer.slideLeftNew{animation:fp-fade-in .4s cubic-bezier(.23,1,.32,1),fp-slide-left .4s cubic-bezier(.23,1,.32,1)}.flatpickr-calendar.animate .dayContainer.slideRight{animation:fp-fade-out .4s cubic-bezier(.23,1,.32,1),fp-slide-right .4s cubic-bezier(.23,1,.32,1);transform:translate3d(100%,0,0)}.flatpickr-calendar.animate .dayContainer.slideRightNew{animation:fp-fade-in .4s cubic-bezier(.23,1,.32,1),fp-slide-right-new .4s cubic-bezier(.23,1,.32,1)}.flatpickr-day{align-items:center;block-size:2.5rem;color:var(--cds-text-primary,#161616);cursor:pointer;display:flex;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:2.5rem;justify-content:center;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);transition:all 70ms cubic-bezier(.2,0,.38,.9)}.flatpickr-day:hover{background:var(--cds-layer-hover)}.flatpickr-day:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-color:var(--cds-button-primary,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.flatpickr-day:focus{outline-style:dotted}}.nextMonthDay,.prevMonthDay{color:var(--cds-text-helper,#6f6f6f)}.flatpickr-day.today{color:var(--cds-link-primary,#0f62fe);font-weight:600;position:relative}.flatpickr-day.today:after{background-color:var(--cds-link-primary,#0f62fe);block-size:.25rem;content:"";display:block;inline-size:.25rem;inset-block-end:.4375rem;inset-inline-start:50%;position:absolute;transform:translateX(-50%)}.flatpickr-day.today.no-border{border:none}.flatpickr-day.today.selected{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.flatpickr-day.today.selected{outline-style:dotted}}.flatpickr-day.today.selected:after{display:none}.flatpickr-day.inRange{background-color:var(--cds-highlight,#d0e2ff);color:var(--cds-text-primary,#161616)}.flatpickr-day.selected{background-color:var(--cds-button-primary,#0f62fe);color:var(--cds-text-on-color,#fff)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.flatpickr-day.selected{color:Highlight;outline:1px solid Highlight;outline-style:dotted}}.flatpickr-day.selected:focus{outline:.0625rem solid var(--cds-layer-02,#fff);outline-offset:-.1875rem}.flatpickr-day.startRange.selected{box-shadow:none;z-index:2}.flatpickr-day.endRange.inRange,.flatpickr-day.startRange.inRange:not(.selected){background:var(--cds-layer-01,#f4f4f4);outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;z-index:3}@media screen and (prefers-contrast){.flatpickr-day.endRange.inRange,.flatpickr-day.startRange.inRange:not(.selected){outline-style:dotted}}.flatpickr-day.endRange:hover{background:var(--cds-layer-01,#f4f4f4);color:var(--cds-text-primary,#161616);outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.flatpickr-day.endRange:hover{outline-style:dotted}}.flatpickr-day.endRange.inRange.selected{background:var(--cds-button-primary,#0f62fe);color:var(--cds-text-on-color,#fff)}.flatpickr-day.flatpickr-disabled{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.flatpickr-day.flatpickr-disabled:hover{background-color:transparent}.flatpickr-input[readonly]{cursor:pointer}@media (forced-colors:active),screen and (-ms-high-contrast:active){.flatpickr-day.inRange,.flatpickr-day.today{color:Highlight}}.cds--date-picker,:host(cds-date-picker){display:flex}.cds--date-picker--light .cds--date-picker__input{background:var(--cds-field-02,#fff)}.cds--date-picker~.cds--label,:host(cds-date-picker)~.cds--label{order:1}.cds--date-picker-container,:host(cds-date-picker-input),:host(cds-date-picker-input-skeleton){display:flex;flex-direction:column;justify-content:space-between;position:relative}.cds--date-picker-container .cds--label,:host(cds-date-picker-input) .cds--label,:host(cds-date-picker-input-skeleton) .cds--label{display:flex}.cds--date-picker-input__wrapper{align-items:center;display:flex}.cds--date-picker-input__wrapper>span{position:relative}.cds--date-picker.cds--date-picker--simple .cds--date-picker__input,.cds--date-picker.cds--date-picker--simple .cds--label{inline-size:7.5rem}.cds--date-picker.cds--date-picker--simple .cds--date-picker-input__wrapper--invalid .cds--date-picker__input,.cds--date-picker.cds--date-picker--simple .cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker.cds--date-picker--simple .cds--date-picker-input__wrapper--warn .cds--date-picker__input,.cds--date-picker.cds--date-picker--simple .cds--date-picker-input__wrapper--warn~.cds--form-requirement{inline-size:9.5rem}.cds--date-picker.cds--date-picker--simple.cds--date-picker--short .cds--date-picker__input{inline-size:5.7rem}.cds--date-picker.cds--date-picker--single .cds--date-picker__input{inline-size:18rem}.cds--date-picker .cds--date-picker-input__wrapper--warn~.cds--form-requirement,:host(cds-date-picker) .cds--date-picker-input__wrapper--warn~.cds--form-requirement{color:var(--cds-text-primary,#161616)}.cds--date-picker__input{background-color:var(--cds-field);block-size:2.5rem;border:none;border-block-end:1px solid var(--cds-border-strong);box-sizing:border-box;color:var(--cds-text-primary,#161616);display:block;font-family:inherit;font-family:var(--cds-code-02-font-family,"IBM Plex Mono",system-ui,-apple-system,BlinkMacSystemFont,".SFNSText-Regular",monospace);font-size:100%;font-size:var(--cds-code-02-font-size,.875rem);font-weight:var(--cds-code-02-font-weight,400);letter-spacing:var(--cds-code-02-letter-spacing,.32px);line-height:var(--cds-code-02-line-height,1.42857);margin:0;outline:2px solid transparent;outline-offset:-2px;padding:0 1rem;position:relative;transition:all 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--date-picker__input *,.cds--date-picker__input :after,.cds--date-picker__input :before{box-sizing:inherit}.cds--date-picker__input.cds--focused,.cds--date-picker__input:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--date-picker__input.cds--focused,.cds--date-picker__input:focus{outline-style:dotted}}.cds--date-picker__input:disabled{background-color:var(--cds-field);border-block-end:1px solid transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--date-picker__input:disabled::-moz-placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--date-picker__input:disabled::placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--date-picker__input:disabled:hover{border-block-end:1px solid transparent}.cds--date-picker__input::-moz-placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--date-picker__input::placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--date-picker__input--lg{block-size:3rem}.cds--date-picker__input--sm{block-size:2rem}.cds--date-picker__icon,:host(cds-date-picker-input) .cds--date-picker__icon{position:absolute;z-index:1;fill:var(--cds-icon-primary,#161616);inset-block-start:50%;inset-inline-end:1rem;pointer-events:none;transform:translateY(-50%)}.cds--date-picker__icon--invalid,.cds--date-picker__icon--warn,:host(cds-date-picker-input) .cds--date-picker__icon--invalid,:host(cds-date-picker-input) .cds--date-picker__icon--warn{cursor:auto}.cds--date-picker__icon--warn,:host(cds-date-picker-input) .cds--date-picker__icon--warn{fill:var(--cds-support-warning,#f1c21b)}.cds--date-picker__icon--warn path:first-of-type{fill:#000;opacity:1}.cds--date-picker__icon--invalid,:host(cds-date-picker-input) .cds--date-picker__icon--invalid{fill:var(--cds-support-error,#da1e28)}.cds--date-picker__icon~.cds--date-picker__input{padding-inline-end:3rem}.cds--date-picker__input:disabled~.cds--date-picker__icon{cursor:not-allowed;fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--date-picker--range>.cds--date-picker-container:first-child{margin-inline-end:.0625rem}.cds--date-picker--range .cds--date-picker-container,.cds--date-picker--range .cds--date-picker__input,.cds--date-picker--range :host(cds-date-picker-input),.cds--date-picker--range :host(cds-date-picker-input-skeleton){inline-size:8.96875rem}.cds--date-picker-input__wrapper--decorator .cds--date-picker-input-inner-wrapper--decorator>*,.cds--date-picker-input__wrapper--slug .cds--ai-label,.cds--date-picker-input__wrapper--slug .cds--slug{inset-block-start:50%;inset-inline-end:2.5rem;position:absolute;transform:translateY(-50%)}.cds--date-picker-input__wrapper--decorator .cds--date-picker-input-inner-wrapper--decorator:not(:has(.cds--ai-label))>*{block-size:1rem}.cds--date-picker-input__wrapper--decorator .cds--date-picker__input:has(~.cds--date-picker-input-inner-wrapper--decorator .cds--ai-label):not(:has(~.cds--date-picker-input-inner-wrapper--decorator .cds--ai-label--revert)),.cds--date-picker-input__wrapper--slug .cds--date-picker__input:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--date-picker-input__wrapper--slug .cds--date-picker__input:has(~.cds--slug):not(:has(~.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff);padding-inline-end:4rem}.cds--date-picker__input[readonly]{background:transparent;border-block-end-color:var(--cds-border-subtle);cursor:text}.cds--date-picker__input[readonly]+.cds--date-picker__icon{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--date-picker.cds--skeleton input,.cds--date-picker__input.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:100%;padding:0;pointer-events:none;position:relative}.cds--date-picker.cds--skeleton input:active,.cds--date-picker.cds--skeleton input:focus,.cds--date-picker.cds--skeleton input:hover,.cds--date-picker__input.cds--skeleton:active,.cds--date-picker__input.cds--skeleton:focus,.cds--date-picker__input.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--date-picker.cds--skeleton input:before,.cds--date-picker__input.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--date-picker.cds--skeleton input:before,.cds--date-picker__input.cds--skeleton:before{animation:none}}.cds--date-picker.cds--skeleton input::-moz-placeholder,.cds--date-picker__input.cds--skeleton::-moz-placeholder{color:transparent}.cds--date-picker.cds--skeleton input::placeholder,.cds--date-picker__input.cds--skeleton::placeholder{color:transparent}.cds--date-picker.cds--skeleton .cds--label{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--date-picker.cds--skeleton .cds--label:active,.cds--date-picker.cds--skeleton .cds--label:focus,.cds--date-picker.cds--skeleton .cds--label:hover{border:none;cursor:default;outline:none}.cds--date-picker.cds--skeleton .cds--label:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--date-picker.cds--skeleton .cds--label:before{animation:none}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--date-picker__icon,:host(cds-date-picker-input) .cds--date-picker__icon{fill:ButtonText}}:host(cds-date-picker) #floating-menu-container{inline-size:100%;position:absolute}:host(cds-date-picker) .cds--date-picker__calendar.open{margin-block-start:0}:host(cds-date-picker) .flatpickr-next-month svg,:host(cds-date-picker) .flatpickr-prev-month svg{transform:rotate(0)}:host(cds-date-picker) .cds--date-picker__day.flatpickr-disabled,:host(cds-date-picker) .flatpickr-day.flatpickr-disabled{color:var(--cds-layer-selected-inverse,#161616);cursor:not-allowed;opacity:.5}:host(cds-date-picker) .cds--date-picker__day.flatpickr-disabled:hover,:host(cds-date-picker) .flatpickr-day.flatpickr-disabled:hover{background:transparent}:host(cds-date-picker) .flatpickr-next-month.flatpickr-disabled svg,:host(cds-date-picker) .flatpickr-prev-month.flatpickr-disabled svg{cursor:not-allowed;fill:var(--cds-layer-selected-inverse,#161616);opacity:.5}:host(cds-date-picker) .flatpickr-next-month.flatpickr-disabled:hover svg,:host(cds-date-picker) .flatpickr-prev-month.flatpickr-disabled:hover svg{fill:var(--cds-layer-selected-inverse,#161616)}:host(cds-date-picker-input),:host(cds-date-picker-input-skeleton){outline:none}:host(cds-date-picker-input) .cds--form-requirement[hidden],:host(cds-date-picker-input-skeleton) .cds--form-requirement[hidden]{display:none}:host(cds-date-picker-input[warn]) .cds--form-requirement{color:var(--cds-text-primary,#161616)}:host(cds-date-picker-input-skeleton[kind=simple]) .cds--date-picker__input,:host(cds-date-picker-input[kind=simple]) .cds--date-picker__input{inline-size:7.5rem}:host(cds-date-picker-input-skeleton[kind=simple]) .cds--date-picker__input--invalid,:host(cds-date-picker-input-skeleton[kind=simple]) .cds--date-picker__input--warn,:host(cds-date-picker-input[kind=simple]) .cds--date-picker__input--invalid,:host(cds-date-picker-input[kind=simple]) .cds--date-picker__input--warn{inline-size:9.5rem}:host(cds-date-picker-input-skeleton[kind=simple][short]) .cds--date-picker__input,:host(cds-date-picker-input[kind=simple][short]) .cds--date-picker__input{inline-size:5.625rem}:host(cds-date-picker-input-skeleton[kind=single]),:host(cds-date-picker-input[kind=single]){max-inline-size:18rem}:host(cds-date-picker-input-skeleton[kind=single]) .cds--date-picker__input,:host(cds-date-picker-input[kind=single]) .cds--date-picker__input{inline-size:18rem}:host(cds-date-picker-input-skeleton[kind=from]),:host(cds-date-picker-input[kind=from]){margin-inline-end:.0625rem}:host(cds-date-picker-input-skeleton[kind=from]),:host(cds-date-picker-input-skeleton[kind=to]),:host(cds-date-picker-input[kind=from]),:host(cds-date-picker-input[kind=to]){inline-size:8.96875rem}:host(cds-date-picker-input-skeleton[kind=from]) .cds--date-picker__input,:host(cds-date-picker-input-skeleton[kind=to]) .cds--date-picker__input,:host(cds-date-picker-input[kind=from]) .cds--date-picker__input,:host(cds-date-picker-input[kind=to]) .cds--date-picker__input{inline-size:8.96875rem}:host(cds-date-picker-input) ::slotted(cds-ai-label),:host(cds-date-picker-input) ::slotted(cds-slug){inset-block-start:50%;inset-inline-end:2.5rem;position:absolute}:host(cds-date-picker-input) ::slotted(cds-ai-label:not([revert-active])),:host(cds-date-picker-input) ::slotted(cds-slug:not([revert-active])){transform:translateY(-50%)}:host(cds-date-picker-input-skeleton){display:inline-block}:host(cds-date-picker-input-skeleton) .cds--label{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}:host(cds-date-picker-input-skeleton) .cds--label:active,:host(cds-date-picker-input-skeleton) .cds--label:focus,:host(cds-date-picker-input-skeleton) .cds--label:hover{border:none;cursor:default;outline:none}:host(cds-date-picker-input-skeleton) .cds--label:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){:host(cds-date-picker-input-skeleton) .cds--label:before{animation:none}}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hREA1":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATE_PICKER_INPUT_KIND", ()=>(0, _defsJs.DATE_PICKER_INPUT_KIND));
parcelHelpers.export(exports, "DATE_PICKER_INPUT_COLOR_SCHEME", ()=>(0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME));
parcelHelpers.export(exports, "default", ()=>CDSDatePickerInput$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _16Js = require("../../icons/calendar/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _textInputJs = require("../text-input/text-input.js");
var _defsJs = require("./defs.js");
var _16Js1 = require("../../icons/warning--filled/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _16Js2 = require("../../icons/warning--alt--filled/16.js");
var _16JsDefault2 = parcelHelpers.interopDefault(_16Js2);
var _datePickerScssJs = require("./date-picker.scss.js");
var _datePickerScssJsDefault = parcelHelpers.interopDefault(_datePickerScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _sharedEnumsJs = require("../../globals/shared-enums.js");
var _defsJs1 = require("../text-input/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The input box for date picker.
 *
 * @element cds-date-picker-input
 */ let CDSDatePickerInput = class CDSDatePickerInput extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
        /**
         * `true` if there is helper text content.
         */ this._hasHelperText = false;
        /**
         * The color scheme.
         */ this.colorScheme = (0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME).REGULAR;
        /**
         * `true` if the check box should be disabled.
         */ this.disabled = false;
        /**
         * `true` if the label should be hidden.
         */ this.hideLabel = false;
        /**
         * Specify whether the control is currently in warning state
         */ this.warn = false;
        /**
         * Provide the text that is displayed when the control is in warning state
         */ this.warnText = "";
        /**
         * Message which is displayed if the value is invalid.
         */ this.invalidText = "";
        /**
         * Controls the invalid state and visibility of the `validityMessage`.
         */ this.invalid = false;
        /**
         * Date picker input kind.
         */ this.kind = (0, _defsJs.DATE_PICKER_INPUT_KIND).SIMPLE;
        /**
         * Specify if the component should be read-only
         */ this.readonly = false;
        /**
         * `true` if the value is required.
         */ this.required = false;
        /**
         * Vertical size of this date picker input.
         */ this.size = (0, _defsJs1.INPUT_SIZE).MEDIUM;
        /**
         * true to use the short version.
         */ this.short = false;
    }
    /**
     * Handles `slotchange` event.
     */ _handleAILabelSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || // remove reference to slug in v12
            elem.matches(this.constructor.slugItem) : false);
        this._hasAILabel = Boolean(hasContent);
        hasContent[0].setAttribute("size", "mini");
        this.requestUpdate();
    }
    /**
     * Handles `click` event on the calendar icon.
     *
     * @param event The event.
     */ _handleClickWrapper(event) {
        if (event.target === this._iconNode) this.input.focus();
    }
    /**
     * Handles `input` event on `<input>` in the shadow DOM.
     *
     * @param event The event.
     * @param event.target The event target.
     */ _handleInput({ target }) {
        const { value } = target;
        this.value = value;
    }
    /**
     * @returns The template for the the calendar icon.
     */ _renderIcon() {
        return this.kind === (0, _defsJs.DATE_PICKER_INPUT_KIND).SIMPLE ? undefined : (0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--date-picker__icon`,
            role: "img",
            children: [
                (0, _lit.html)` <title>Open calendar</title> `
            ]
        });
    }
    /**
     * Handles `slotchange` event on the default `<slot>`.
     */ _handleSlotChange({ target }) {
        if (!target.name) {
            const hasContent = target.assignedNodes().some((node)=>node.nodeType !== Node.TEXT_NODE || node.textContent.trim());
            this._hasHelperText = hasContent;
        }
    }
    render() {
        const constructor = this.constructor;
        const { disabled, _hasHelperText: hasHelperText, hideLabel, invalid, invalidText, labelText, pattern = constructor.defaultPattern, placeholder, readonly, size, type = constructor.defaultType, value, warn, warnText, _handleClickWrapper: handleClickWrapper, _handleInput: handleInput, _hasAILabel: hasAILabel } = this;
        const invalidIcon = (0, _16JsDefault1.default)({
            class: `${(0, _settingsJs.prefix)}--date-picker__icon ${(0, _settingsJs.prefix)}--date-picker__icon--invalid`
        });
        const warnIcon = (0, _16JsDefault2.default)({
            class: `${(0, _settingsJs.prefix)}--date-picker__icon ${(0, _settingsJs.prefix)}--date-picker__icon--warn`
        });
        const normalizedProps = {
            disabled: !readonly && disabled,
            invalid: !readonly && invalid,
            warn: !readonly && !invalid && warn,
            "slot-name": "",
            "slot-text": "",
            icon: null
        };
        if (normalizedProps.invalid) {
            normalizedProps.icon = invalidIcon;
            normalizedProps["slot-name"] = "invalid-text";
            normalizedProps["slot-text"] = invalidText;
        } else if (normalizedProps.warn) {
            normalizedProps.icon = warnIcon;
            normalizedProps["slot-name"] = "warn-text";
            normalizedProps["slot-text"] = warnText;
        }
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--label`]: true,
            [`${0, _settingsJs.prefix}--visually-hidden`]: hideLabel,
            [`${0, _settingsJs.prefix}--label--disabled`]: disabled
        });
        const inputClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--date-picker__input`]: true,
            [`${0, _settingsJs.prefix}--date-picker__input--invalid`]: normalizedProps.invalid,
            [`${0, _settingsJs.prefix}--date-picker__input--warn`]: normalizedProps.warn,
            [`${0, _settingsJs.prefix}--date-picker__input--${size}`]: size
        });
        const inputWrapperClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--date-picker-input__wrapper`]: true,
            [`${0, _settingsJs.prefix}--date-picker-input__wrapper--invalid`]: normalizedProps.invalid,
            [`${0, _settingsJs.prefix}--date-picker-input__wrapper--warn`]: normalizedProps.warn,
            [`${0, _settingsJs.prefix}--date-picker-input__wrapper--slug`]: hasAILabel
        });
        const helperTextClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--form__helper-text`]: true,
            [`${0, _settingsJs.prefix}--form__helper-text--disabled`]: disabled
        });
        return (0, _lit.html)`
      <label for="input" class="${labelClasses}">
        <slot name="label-text">${labelText}</slot>
      </label>
      <div class="${inputWrapperClasses}" @click="${handleClickWrapper}">
        <span>
          <input
            id="input"
            type="${type}"
            class="${inputClasses}"
            ?disabled="${disabled}"
            pattern="${pattern}"
            placeholder="${(0, _ifDefinedJs.ifDefined)(placeholder)}"
            .value="${(0, _ifDefinedJs.ifDefined)(value)}"
            ?data-invalid="${invalid}"
            @input="${handleInput}"
            ?readonly="${readonly}" />
          ${normalizedProps.icon || this._renderIcon()}
          <slot
            name="ai-label"
            @slotchange="${this._handleAILabelSlotChange}"></slot>
          <slot
            name="slug"
            @slotchange="${this._handleAILabelSlotChange}"></slot>
        </span>
      </div>
      <div
        class="${0, _settingsJs.prefix}--form-requirement"
        ?hidden="${!normalizedProps.invalid && !normalizedProps.warn}">
        <slot name="${normalizedProps["slot-name"]}">
          ${normalizedProps["slot-text"]}
        </slot>
      </div>
      <div ?hidden="${hasHelperText}" class="${helperTextClasses}">
        <slot name="helper-text" @slotchange="${this._handleSlotChange}"></slot>
      </div>
    `;
    }
    updated() {
        var _a, _b, _c, _d, _e;
        const label = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("slot[name='ai-label']");
        if (label) label === null || label === void 0 || label.classList.toggle(`${(0, _settingsJs.prefix)}--slug--revert`, (_b = this.querySelector(`${(0, _settingsJs.prefix)}-ai-label`)) === null || _b === void 0 ? void 0 : _b.hasAttribute("revert-active"));
        else (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("slot[name='slug']")) === null || _d === void 0 || _d.classList.toggle(`${(0, _settingsJs.prefix)}--slug--revert`, (_e = this.querySelector(`${(0, _settingsJs.prefix)}-slug`)) === null || _e === void 0 ? void 0 : _e.hasAttribute("revert-active"));
    }
    /**
     * A selector that will return the parent date picker.
     */ static get selectorParent() {
        return `${0, _settingsJs.prefix}-date-picker`;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
};
/**
 * The default value for `pattern` property.
 */ CDSDatePickerInput.defaultPattern = "\\d{1,2}\\/\\d{1,2}\\/\\d{4}";
/**
 * The default value for `type` property.
 */ CDSDatePickerInput.defaultType = "text";
CDSDatePickerInput.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSDatePickerInput.styles = (0, _datePickerScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)(`.${(0, _settingsJs.prefix)}--date-picker__icon`)
], CDSDatePickerInput.prototype, "_iconNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSDatePickerInput.prototype, "_hasHelperText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("input")
], CDSDatePickerInput.prototype, "input", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "color-scheme",
        reflect: true
    })
], CDSDatePickerInput.prototype, "colorScheme", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDatePickerInput.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "hide-label"
    })
], CDSDatePickerInput.prototype, "hideLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDatePickerInput.prototype, "warn", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "warn-text"
    })
], CDSDatePickerInput.prototype, "warnText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "invalid-text"
    })
], CDSDatePickerInput.prototype, "invalidText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDatePickerInput.prototype, "invalid", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSDatePickerInput.prototype, "kind", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label-text"
    })
], CDSDatePickerInput.prototype, "labelText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSDatePickerInput.prototype, "pattern", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSDatePickerInput.prototype, "placeholder", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDatePickerInput.prototype, "readonly", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDatePickerInput.prototype, "required", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "size",
        reflect: true
    })
], CDSDatePickerInput.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSDatePickerInput.prototype, "short", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSDatePickerInput.prototype, "type", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSDatePickerInput.prototype, "value", void 0);
CDSDatePickerInput = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-date-picker-input`)
], CDSDatePickerInput);
var CDSDatePickerInput$1 = CDSDatePickerInput;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/calendar/16.js":"h4Zkb","lit/directives/if-defined.js":"hSgrS","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","../text-input/text-input.js":"lBj7P","./defs.js":"aKN7g","../../icons/warning--filled/16.js":"ajngV","../../icons/warning--alt--filled/16.js":"21PDf","./date-picker.scss.js":"6GenX","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/shared-enums.js":"12kea","../text-input/defs.js":"83oMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h4Zkb":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20	V26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aKN7g":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATE_PICKER_INPUT_COLOR_SCHEME", ()=>(0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME));
parcelHelpers.export(exports, "DATE_PICKER_INPUT_KIND", ()=>DATE_PICKER_INPUT_KIND);
var _sharedEnumsJs = require("../../globals/shared-enums.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Date picker input kinds.
 */ var DATE_PICKER_INPUT_KIND;
(function(DATE_PICKER_INPUT_KIND) {
    /**
     * One for simple variant of date picker, comes without the calendar dropdown.
     */ DATE_PICKER_INPUT_KIND["SIMPLE"] = "simple";
    /**
     * One for single variant of date picker.
     */ DATE_PICKER_INPUT_KIND["SINGLE"] = "single";
    /**
     * One for the start date for the range variant.
     */ DATE_PICKER_INPUT_KIND["FROM"] = "from";
    /**
     * One for the end date for the range variant.
     */ DATE_PICKER_INPUT_KIND["TO"] = "to";
})(DATE_PICKER_INPUT_KIND || (DATE_PICKER_INPUT_KIND = {}));

},{"../../globals/shared-enums.js":"12kea","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6G40A":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSDatePickerInputSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _datePickerInputJs = require("./date-picker-input.js");
var _datePickerScssJs = require("./date-picker.scss.js");
var _datePickerScssJsDefault = parcelHelpers.interopDefault(_datePickerScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("./defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton version of the input box for date picker.
 */ let CDSDatePickerInputSkeleton = class CDSDatePickerInputSkeleton extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Date picker input kind. Corresponds to the attribute with the same name.
         */ this.kind = (0, _defsJs.DATE_PICKER_INPUT_KIND).SIMPLE;
    }
    render() {
        return (0, _lit.html)`
      <span class="${0, _settingsJs.prefix}--label"></span>
      <div class="${0, _settingsJs.prefix}--date-picker__input ${0, _settingsJs.prefix}--skeleton"></div>
    `;
    }
};
CDSDatePickerInputSkeleton.styles = (0, _datePickerScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSDatePickerInputSkeleton.prototype, "kind", void 0);
CDSDatePickerInputSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-date-picker-input-skeleton`)
], CDSDatePickerInputSkeleton);
var CDSDatePickerInputSkeleton$1 = CDSDatePickerInputSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./date-picker-input.js":"hREA1","./date-picker.scss.js":"6GenX","../../globals/decorators/carbon-element.js":"kNhLR","./defs.js":"aKN7g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cSKNX":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _dropdownJs = require("./dropdown.js");
var _dropdownItemJs = require("./dropdown-item.js");
var _dropdownSkeletonJs = require("./dropdown-skeleton.js");

},{"./dropdown.js":"iHNPo","./dropdown-item.js":"cje0A","./dropdown-skeleton.js":"03L5m"}],"03L5m":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSDropdownSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _dropdownScssJs = require("./dropdown.scss.js");
var _dropdownScssJsDefault = parcelHelpers.interopDefault(_dropdownScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton version of dropdown.
 */ let CDSDropdownSkeleton = class CDSDropdownSkeleton extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)`
      <div
        class="${0, _settingsJs.prefix}--skeleton ${0, _settingsJs.prefix}--dropdown-v2 ${0, _settingsJs.prefix}--list-box ${0, _settingsJs.prefix}--form-item">
        <div class="${0, _settingsJs.prefix}--list-box__field">
          <span class="${0, _settingsJs.prefix}--list-box__label"></span>
        </div>
      </div>
    `;
    }
};
CDSDropdownSkeleton.styles = (0, _dropdownScssJsDefault.default);
CDSDropdownSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-dropdown-skeleton`)
], CDSDropdownSkeleton);
var CDSDropdownSkeleton$1 = CDSDropdownSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./dropdown.scss.js":"55Q1R","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"28Hqz":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _fileUploaderJs = require("./file-uploader.js");
var _fileUploaderItemJs = require("./file-uploader-item.js");
var _fileUploaderDropContainerJs = require("./file-uploader-drop-container.js");
var _fileUploaderButtonJs = require("./file-uploader-button.js");
var _fileUploaderSkeletonJs = require("./file-uploader-skeleton.js");

},{"./file-uploader.js":"bFOE4","./file-uploader-item.js":"byr9L","./file-uploader-drop-container.js":"kYAzT","./file-uploader-button.js":"ktiU2","./file-uploader-skeleton.js":"hWxJs"}],"bFOE4":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSFileUploader$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _fileUploaderScssJs = require("./file-uploader.scss.js");
var _fileUploaderScssJsDefault = parcelHelpers.interopDefault(_fileUploaderScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The shell UI for file uploader.
 *
 * @element cds-file-uploader
 * @slot label-title.
 * @slot lebel-description.
 */ let CDSFileUploader = class CDSFileUploader extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if the file uploader should disabled.
         */ this.disabled = false;
        /**
         * The description text.
         */ this.labelDescription = "";
        /**
         * The label title.
         */ this.labelTitle = "";
    }
    updated(changedProperties) {
        if (changedProperties.has("disabled")) {
            const { selectorUploaderItem } = this.constructor;
            const uploaderItem = this.querySelector(selectorUploaderItem);
            uploaderItem.disabled = this.disabled;
        }
    }
    render() {
        const { disabled, labelDescription, labelTitle } = this;
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--file--label`]: true,
            [`${0, _settingsJs.prefix}--label-description--disabled`]: disabled
        });
        const descriptionClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--label-description`]: true,
            [`${0, _settingsJs.prefix}--label-description--disabled`]: disabled
        });
        return (0, _lit.html)`
      <p class="${labelClasses}">
        <slot name="label-title">${labelTitle}</slot>
      </p>
      <p class="${descriptionClasses}">
        <slot name="label-description">${labelDescription}</slot>
      </p>
      <slot name="drop-container"></slot>
      <div class="${0, _settingsJs.prefix}--file-container">
        <slot></slot>
      </div>
    `;
    }
    /**
     * A selector that will return the `<input>` to enter starting date.
     */ static get selectorUploaderItem() {
        return `${0, _settingsJs.prefix}-file-uploader-button,${0, _settingsJs.prefix}-file-uploader-drop-container`;
    }
};
CDSFileUploader.styles = (0, _fileUploaderScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSFileUploader.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label-description"
    })
], CDSFileUploader.prototype, "labelDescription", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label-title"
    })
], CDSFileUploader.prototype, "labelTitle", void 0);
CDSFileUploader = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-file-uploader`)
], CDSFileUploader);
var CDSFileUploader$1 = CDSFileUploader;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./file-uploader.scss.js":"4oN5w","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4oN5w":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item,:host(cds-file-uploader-shell){align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--loading{animation-duration:.69s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:cds--rotate;animation-timing-function:linear;block-size:5.5rem;border:0;box-sizing:border-box;font-family:inherit;font-size:100%;inline-size:5.5rem;margin:0;padding:0;vertical-align:baseline}.cds--loading *,.cds--loading :after,.cds--loading :before{box-sizing:inherit}.cds--loading svg circle{animation-duration:10ms;animation-name:cds--init-stroke;animation-timing-function:cubic-bezier(.5,0,.1,1)}@media screen and (prefers-reduced-motion:reduce){.cds--loading svg circle{animation:none}}.cds--loading__svg{fill:transparent}.cds--loading__svg circle{stroke-dasharray:276.4608 276.4608;stroke-linecap:butt;stroke-width:10}.cds--loading__stroke{stroke:var(--cds-interactive,#0f62fe);stroke-dashoffset:52.527552}.cds--loading--small .cds--loading__stroke{stroke-dashoffset:143.759616}.cds--loading--stop{animation:cds--rotate-end-p1 .7s cubic-bezier(0,0,.25,1) forwards,cds--rotate-end-p2 .7s cubic-bezier(0,0,.25,1) .7s forwards}.cds--loading--stop svg circle{animation-delay:.7s;animation-duration:.7s;animation-fill-mode:forwards;animation-name:cds--stroke-end;animation-timing-function:cubic-bezier(0,0,.25,1)}@media screen and (prefers-reduced-motion:reduce){.cds--loading--stop svg circle{animation:none}}.cds--loading--small{block-size:1rem;inline-size:1rem;line-height:1rem}.cds--loading--small circle{stroke-width:16}.cds--loading--small .cds--loading__svg{stroke:var(--cds-interactive,#0f62fe)}.cds--loading__background{stroke:var(--cds-layer-accent);stroke-dashoffset:-22}@media not all and (resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){circle.cds--loading__background{stroke-dasharray:265;stroke-dashoffset:0}}}.cds--loading-overlay{align-items:center;background-color:var(--cds-overlay,hsla(0,0%,9%,.5));block-size:100%;display:flex;inline-size:100%;inset-block-start:0;inset-inline-start:0;justify-content:center;position:fixed;transition:background-color .7s cubic-bezier(.4,.14,.3,1);z-index:6000}.cds--loading-overlay--stop{display:none}@keyframes cds--rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes cds--rotate-end-p1{to{transform:rotate(1turn)}}@keyframes cds--rotate-end-p2{to{transform:rotate(-1turn)}}@keyframes cds--init-stroke{0%{stroke-dashoffset:276.4608}to{stroke-dashoffset:52.527552}}@keyframes cds--stroke-end{0%{stroke-dashoffset:52.527552}to{stroke-dashoffset:276.4608}}.cds--file,:host(cds-file-drop-container){inline-size:100%}.cds--file--invalid{fill:var(--cds-support-error,#da1e28);margin-inline-end:.5rem}.cds--file--label{color:var(--cds-text-primary,#161616);font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);margin-block-end:.5rem}.cds--file--label html{font-size:100%}.cds--file--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--file--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--file--label strong{font-weight:600}.cds--file--label--disabled{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--file-input{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--file-btn{display:inline-flex;margin:0;padding-inline-end:4rem}.cds--file-browse-btn{color:var(--cds-link-primary,#0f62fe);cursor:pointer;display:inline-block;inline-size:100%;max-inline-size:20rem;outline:2px solid transparent;outline-offset:-2px;transition:.11s cubic-bezier(.2,0,.38,.9)}.cds--file-browse-btn:focus,.cds--file-browse-btn:hover{outline:2px solid var(--cds-focus,#0f62fe)}.cds--file-browse-btn:active,.cds--file-browse-btn:active:visited,.cds--file-browse-btn:focus,.cds--file-browse-btn:hover{text-decoration:underline}.cds--file-browse-btn:active{color:var(--cds-text-primary,#161616)}.cds--file-browse-btn--disabled{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:no-drop;text-decoration:none;transition:none}.cds--file-browse-btn--disabled:focus,.cds--file-browse-btn--disabled:hover{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none;text-decoration:none}.cds--file-browse-btn--disabled .cds--file__drop-container{border:1px dashed var(--cds-button-disabled,#c6c6c6)}.cds--label-description{color:var(--cds-text-secondary,#525252);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin-block-end:1rem}.cds--label-description html{font-size:100%}.cds--label-description body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label-description code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label-description strong{font-weight:600}.cds--label-description--disabled{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--file-container--drop{inline-size:100%}.cds--file-btn~.cds--file-container{margin-block-start:1.5rem}.cds--btn~.cds--file-container{margin-block-start:1rem}.cds--file .cds--file-container,.cds--file~.cds--file-container,:host(cds-file-drop-container) .cds--file-container,:host(cds-file-drop-container)~.cds--file-container{margin-block-start:.5rem}.cds--file__selected-file,:host(cds-file-uploader-item){align-items:center;background-color:var(--cds-layer);display:grid;gap:.75rem 0;grid-auto-rows:auto;grid-template-columns:1fr auto;margin-block-end:.5rem;max-inline-size:20rem;min-block-size:3rem;word-break:break-word}.cds--file__selected-file:last-child{margin-block-end:0}.cds--file__selected-file .cds--form-requirement,:host(cds-file-uploader-item) .cds--form-requirement{display:block;grid-column:1/-1;margin:0;max-block-size:none}.cds--file__selected-file .cds--inline-loading__animation .cds--loading,:host(cds-file-uploader-item) .cds--inline-loading__animation .cds--loading{margin-inline-end:0}.cds--file__selected-file .cds--file-filename,:host(cds-file-uploader-item) .cds--file-filename{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin-inline-start:1rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cds--file__selected-file .cds--file-filename-container-wrap,:host(cds-file-uploader-item) .cds--file-filename-container-wrap{margin-block-start:1px;max-inline-size:17.5rem;padding-inline-start:1rem}@media (max-width:410px){.cds--file__selected-file .cds--file-filename-container-wrap,:host(cds-file-uploader-item) .cds--file-filename-container-wrap{max-inline-size:13.5rem}}.cds--file__selected-file .cds--file-filename-container-wrap-invalid,:host(cds-file-uploader-item) .cds--file-filename-container-wrap-invalid{max-inline-size:15.5rem}.cds--file__selected-file .cds--file-filename-container-wrap-invalid .cds--file-filename-tooltip,:host(cds-file-uploader-item) .cds--file-filename-container-wrap-invalid .cds--file-filename-tooltip{inline-size:-webkit-fill-available;padding-inline-start:1rem}@document url-prefix(){.cds--file__selected-file .cds--file-filename-container-wrap-invalid .cds--file-filename-tooltip,:host(cds-file-uploader-item) .cds--file-filename-container-wrap-invalid .cds--file-filename-tooltip{inline-size:-moz-available}}.cds--file__selected-file .cds--file-filename-tooltip,:host(cds-file-uploader-item) .cds--file-filename-tooltip{inline-size:-webkit-fill-available}@document url-prefix(){.cds--file__selected-file .cds--file-filename-tooltip,:host(cds-file-uploader-item) .cds--file-filename-tooltip{inline-size:-moz-available}}.cds--file__selected-file .cds--file-filename-button,:host(cds-file-uploader-item) .cds--file-filename-button{background:none;border:none;color:inherit;cursor:pointer;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);font:inherit;inline-size:-webkit-fill-available;outline:inherit;overflow:hidden;padding:0;text-overflow:ellipsis;white-space:nowrap}@document url-prefix(){.cds--file__selected-file .cds--file-filename-button,:host(cds-file-uploader-item) .cds--file-filename-button{inline-size:-moz-available}}.cds--file__selected-file .cds--file-filename-button:focus,:host(cds-file-uploader-item) .cds--file-filename-button:focus{outline:revert}.cds--file__selected-file--md,:host(cds-file-uploader-item[size=md]){gap:.5rem 0;min-block-size:2.5rem}.cds--file__selected-file--sm,:host(cds-file-uploader-item[size=sm]){gap:.25rem 0;min-block-size:2rem}.cds--file__selected-file--invalid__wrapper{background-color:var(--cds-layer);margin-block-end:.5rem;max-inline-size:20rem;outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px;outline-width:1px}@media screen and (prefers-contrast){.cds--file__selected-file--invalid__wrapper{outline-style:dotted}}.cds--file__selected-file--invalid,:host(cds-file-uploader-item[invalid]){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px;padding:.75rem 0}@media screen and (prefers-contrast){.cds--file__selected-file--invalid,:host(cds-file-uploader-item[invalid]){outline-style:dotted}}.cds--file__selected-file--invalid.cds--file__selected-file--sm{padding:.25rem 0}.cds--file__selected-file--invalid.cds--file__selected-file--md{padding:.5rem 0}.cds--file__selected-file--invalid .cds--form-requirement,:host(cds-file-uploader-item[invalid]) .cds--form-requirement{border-block-start:1px solid var(--cds-border-subtle);padding-block-start:1rem}.cds--file__selected-file--invalid.cds--file__selected-file--sm .cds--form-requirement{padding-block-start:.4375rem}.cds--file__selected-file--invalid.cds--file__selected-file--md .cds--form-requirement{padding-block-start:.6875rem}.cds--file__selected-file--invalid .cds--form-requirement__supplement,.cds--file__selected-file--invalid .cds--form-requirement__title,:host(cds-file-uploader-item[invalid]) .cds--form-requirement__supplement,:host(cds-file-uploader-item[invalid]) .cds--form-requirement__title{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);padding:0 1rem}.cds--file__selected-file--invalid .cds--form-requirement__title,:host(cds-file-uploader-item[invalid]) .cds--form-requirement__title{color:var(--cds-text-error,#da1e28)}.cds--file__selected-file--invalid .cds--form-requirement__supplement,:host(cds-file-uploader-item[invalid]) .cds--form-requirement__supplement{color:var(--cds-text-primary,#161616)}.cds--file__selected-file--invalid+.cds--form-requirement,:host(cds-file-uploader-item[invalid])+.cds--form-requirement{color:var(--cds-text-error,#da1e28);display:block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);max-block-size:12.5rem;overflow:visible;padding:.5rem 1rem}.cds--file__selected-file--invalid+.cds--form-requirement .cds--form-requirement__supplement,:host(cds-file-uploader-item[invalid])+.cds--form-requirement .cds--form-requirement__supplement{color:var(--cds-text-primary,#161616);padding-block-end:.5rem}.cds--file__state-container{align-items:center;display:flex;justify-content:center;min-inline-size:1.5rem;padding-inline-end:.75rem}.cds--file__state-container .cds--loading__svg{stroke:var(--cds-icon-primary,#161616)}.cds--file__state-container .cds--file-loading{align-items:center;background-color:transparent;block-size:1rem;border:none;display:flex;inline-size:1.5rem;justify-content:center;padding:.25rem}.cds--file__state-container .cds--file-complete{fill:var(--cds-interactive,#0f62fe);inline-size:1.5rem}.cds--file__state-container .cds--file-complete:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--file__state-container .cds--file-complete:focus{outline-style:dotted}}.cds--file__state-container .cds--file-complete [data-icon-path=inner-path]{fill:var(--cds-icon-inverse,#fff);opacity:1}.cds--file__state-container .cds--file-invalid{block-size:1rem;fill:var(--cds-support-error,#da1e28);inline-size:1rem}.cds--file__state-container .cds--file-close{align-items:center;background-color:transparent;block-size:1.5rem;border:none;cursor:pointer;display:flex;justify-content:center;padding:0;fill:var(--cds-icon-primary,#161616);inline-size:1.5rem}.cds--file__state-container .cds--file-close:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--file__state-container .cds--file-close:focus{outline-style:dotted}}.cds--file__state-container .cds--file-close svg path{fill:var(--cds-icon-primary,#161616)}.cds--file__state-container .cds--inline-loading__animation{margin-inline-end:-.5rem}.cds--file__drop-container{align-items:flex-start;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:6rem;border:0;border:1px dashed var(--cds-border-strong);box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;overflow:hidden;padding:1rem;text-align:start;vertical-align:baseline}.cds--file__drop-container *,.cds--file__drop-container :after,.cds--file__drop-container :before{box-sizing:inherit}.cds--file__drop-container::-moz-focus-inner{border:0}.cds--file__drop-container--drag-over{background:none;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--file__selected-file,:host(cds-file-uploader-item){outline:1px solid transparent}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--file__state-container .cds--file-close svg path{fill:ButtonText}}:host(cds-file-uploader-shell){align-items:stretch}:host(cds-file-uploader-item) .cds--file-filename{margin-block:0}:host(cds-file-uploader-item) .cds--form-requirement[hidden]{display:none}:host(cds-file-uploader-item[invalid]) .cds--form-requirement__supplement{margin:0}:host(cds-file-uploader){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}:host(cds-file-uploader) .cds--file--label,:host(cds-file-uploader) .cds--label-description{margin-block-start:0}:host(cds-file-uploader) .cds--file-container{margin-block-start:.5rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"byr9L":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FILE_UPLOADER_ITEM_SIZE", ()=>(0, _defsJs.FILE_UPLOADER_ITEM_SIZE));
parcelHelpers.export(exports, "FILE_UPLOADER_ITEM_STATE", ()=>(0, _defsJs.FILE_UPLOADER_ITEM_STATE));
parcelHelpers.export(exports, "default", ()=>CDSFileUploaderItem$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _16Js = require("../../icons/checkmark--filled/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/close/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _16Js2 = require("../../icons/warning--filled/16.js");
var _16JsDefault2 = parcelHelpers.interopDefault(_16Js2);
var _settingsJs = require("../../globals/settings.js");
var _loadingJs = require("../loading/loading.js");
var _defsJs = require("./defs.js");
var _fileUploaderScssJs = require("./file-uploader.scss.js");
var _fileUploaderScssJsDefault = parcelHelpers.interopDefault(_fileUploaderScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs1 = require("../loading/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * File uploader item.
 *
 * @element cds-file-uploader-item
 * @slot validity-message The validity message.
 * @slot validity-message-supplement The supplemental validity message.
 * @fires cds-file-uploader-item-beingdeleted
 *   The custom event fired before this file uploader item is being deleted upon a user gesture.
 *   Cancellation of this event stops the user-initiated action of deleting this file uploader item.
 * @fires cds-file-uploader-item-deleted - The custom event fired after this file uploader item is deleted upon a user gesture.
 */ let CDSFileUploaderItem = class CDSFileUploaderItem extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * The `aria-label` attribute for the icon to delete this file uploader item.
         */ this.iconDescription = "Delete this file";
        /**
         * Controls the invalid state and visibility of the `validityMessage`.
         */ this.invalid = false;
        /**
         * The size of this file uploader item.
         */ this.size = (0, _defsJs.FILE_UPLOADER_ITEM_SIZE).MEDIUM;
        /**
         * The state of this file uploader item.
         */ this.state = (0, _defsJs.FILE_UPLOADER_ITEM_STATE).UPLOADING;
        /**
         * The error subject text.
         */ this.errorSubject = "";
        /**
         * The error body text
         */ this.errorBody = "";
    }
    /**
     * Handles `click` event on the delete button.
     */ _handleClickDeleteButton() {
        const init = {
            bubbles: true,
            cancelable: true,
            composed: true
        };
        const { eventBeforeDelete, eventDelete } = this.constructor;
        if (this.dispatchEvent(new CustomEvent(eventBeforeDelete, init))) this.dispatchEvent(new CustomEvent(eventDelete, init));
    }
    /**
     * @returns The content showing the editing UI of this file uploader item.
     */ _renderEditing() {
        const { iconDescription, invalid, _handleClickDeleteButton: handleClickDeleteButton } = this;
        return (0, _lit.html)`
      ${!invalid ? undefined : (0, _16JsDefault2.default)({
            class: `${(0, _settingsJs.prefix)}--file-invalid`
        })}
      <button
        type="button"
        aria-label="${iconDescription}"
        class="${0, _settingsJs.prefix}--file-close"
        @click="${handleClickDeleteButton}">
        ${(0, _16JsDefault1.default)()}
      </button>
    `;
    }
    /**
     * @returns The content showing this file uploader's file uploading status as in progress.
     */ _renderUploading() {
        const { iconDescription } = this;
        return (0, _lit.html)`
      <cds-loading
        assistive-text="${iconDescription}"
        type="${(0, _defsJs1.LOADING_TYPE).SMALL}"></cds-loading>
    `;
    }
    /**
     * @returns The content showing this file uploader's file uploading status as complete.
     */ _renderUploaded() {
        const { iconDescription } = this;
        return (0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--file-complete`,
            "aria-label": iconDescription
        });
    }
    /**
     * @returns The content showing this file uploader's status.
     */ _renderStatus() {
        const { state } = this;
        switch(state){
            case (0, _defsJs.FILE_UPLOADER_ITEM_STATE).EDIT:
                return this._renderEditing();
            case (0, _defsJs.FILE_UPLOADER_ITEM_STATE).UPLOADING:
                return this._renderUploading();
            case (0, _defsJs.FILE_UPLOADER_ITEM_STATE).COMPLETE:
                return this._renderUploaded();
            default:
                return undefined;
        }
    }
    render() {
        const { invalid, errorSubject, errorBody } = this;
        return (0, _lit.html)` <p class="${0, _settingsJs.prefix}--file-filename"><slot></slot></p>
      <span class="${0, _settingsJs.prefix}--file__state-container"
        >${this._renderStatus()}</span
      >
      <div
        class="${0, _settingsJs.prefix}--form-requirement"
        ?hidden="${!invalid && !errorSubject}">
        <div class="${0, _settingsJs.prefix}--form-requirement__title">${errorSubject}</div>
        <p
          class="${0, _settingsJs.prefix}--form-requirement__supplement"
          ?hidden="${!errorBody}">
          ${errorBody}
        </p>
      </div>`;
    }
    /**
     * The name of the custom event fired before this file uplodaer item is being deleted upon a user gesture.
     * Cancellation of this event stops the user-initiated action of deleting this file uploader item.
     */ static get eventBeforeDelete() {
        return `${0, _settingsJs.prefix}-file-uploader-item-beingdeleted`;
    }
    /**
     * The name of the custom event fired after this file uplodaer item is deleted upon a user gesture.
     */ static get eventDelete() {
        return `${0, _settingsJs.prefix}-file-uploader-item-deleted`;
    }
};
CDSFileUploaderItem.styles = (0, _fileUploaderScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "icon-description"
    })
], CDSFileUploaderItem.prototype, "iconDescription", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSFileUploaderItem.prototype, "invalid", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSFileUploaderItem.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSFileUploaderItem.prototype, "state", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "error-subject"
    })
], CDSFileUploaderItem.prototype, "errorSubject", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "error-body"
    })
], CDSFileUploaderItem.prototype, "errorBody", void 0);
CDSFileUploaderItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-file-uploader-item`)
], CDSFileUploaderItem);
var CDSFileUploaderItem$1 = CDSFileUploaderItem;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/checkmark--filled/16.js":"EwXOT","../../icons/close/16.js":"b7Sho","../../icons/warning--filled/16.js":"ajngV","../../globals/settings.js":"EipuL","../loading/loading.js":"jiOnP","./defs.js":"5Hbbu","./file-uploader.scss.js":"4oN5w","../../globals/decorators/carbon-element.js":"kNhLR","../loading/defs.js":"ebnHh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"EwXOT":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z"></path><path d="M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z" data-icon-path="inner-path" opacity="0"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jiOnP":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOADING_TYPE", ()=>(0, _defsJs.LOADING_TYPE));
parcelHelpers.export(exports, "default", ()=>CDSLoading$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _defsJs = require("./defs.js");
var _loadingIconJs = require("./loading-icon.js");
var _loadingIconJsDefault = parcelHelpers.interopDefault(_loadingIconJs);
var _loadingScssJs = require("./loading.scss.js");
var _loadingScssJsDefault = parcelHelpers.interopDefault(_loadingScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Spinner indicating loading state.
 *
 * @element cds-loading
 */ let CDSLoading = class CDSLoading extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * The assistive text for the spinner icon.
         */ this.assistiveText = "Loading";
        /**
         * Spinner type.
         */ this.type = (0, _defsJs.LOADING_TYPE).REGULAR;
        /**
         * `true` if overlay should be applied.
         */ this.overlay = false;
        /**
         * `true` if spinner should stop.
         */ this.inactive = false;
    }
    render() {
        const { inactive, assistiveText, type, overlay } = this;
        const innerClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--loading`]: true,
            [`${0, _settingsJs.prefix}--loading--stop`]: inactive,
            [`${0, _settingsJs.prefix}--loading--small`]: type === (0, _defsJs.LOADING_TYPE).SMALL
        });
        const icon = (0, _loadingIconJsDefault.default)({
            assistiveText,
            type
        });
        return overlay ? (0, _lit.html)`<div class="${innerClasses}">${icon}</div>` : icon;
    }
};
CDSLoading.styles = (0, _loadingScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "assistive-text"
    })
], CDSLoading.prototype, "assistiveText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSLoading.prototype, "type", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSLoading.prototype, "overlay", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSLoading.prototype, "inactive", void 0);
CDSLoading = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-loading`)
], CDSLoading);
var CDSLoading$1 = CDSLoading;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./defs.js":"ebnHh","./loading-icon.js":"SBMIA","./loading.scss.js":"fOhQ1","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ebnHh":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Spinner types.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOADING_TYPE", ()=>LOADING_TYPE);
var LOADING_TYPE;
(function(LOADING_TYPE) {
    /**
     * Regular spinner.
     */ LOADING_TYPE["REGULAR"] = "regular";
    /**
     * Small spinner.
     */ LOADING_TYPE["SMALL"] = "small";
})(LOADING_TYPE || (LOADING_TYPE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"SBMIA":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLoadingIcon);
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _typesJs = require("./types.js");
var _typesJsDefault = parcelHelpers.interopDefault(_typesJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param Object options The options.
 * @param [Object.assistiveText] The assistive text for the spinner icon.
 * @param [Object.type] The spinner type.
 * @returns The spinner icon.
 */ var getLoadingIcon = ({ assistiveText, type })=>{
    const radius = type === (0, _typesJsDefault.default).SMALL ? "42" : "44";
    return (0, _lit.html)`
    <svg class="${0, _settingsJs.prefix}--loading__svg" viewBox="0 0 100 100">
      ${!assistiveText ? undefined : (0, _lit.html)` <title>${assistiveText}</title> `}
      <circle
        ?hidden="${type !== (0, _typesJsDefault.default).SMALL}"
        class="${0, _settingsJs.prefix}--loading__background"
        cx="50%"
        cy="50%"
        r="${radius}" />
      <circle
        class="${0, _settingsJs.prefix}--loading__stroke"
        cx="50%"
        cy="50%"
        r="${radius}" />
    </svg>
  `;
};

},{"lit":"aCmte","../../globals/settings.js":"EipuL","./types.js":"5a963","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5a963":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LOADING_TYPE);
var _defsJs = require("./defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @deprecated Use `defs.ts`
 */ var LOADING_TYPE = (0, _defsJs.LOADING_TYPE);

},{"./defs.js":"ebnHh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fOhQ1":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    ".cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--loading,:host(cds-loading){animation-duration:.69s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:cds--rotate;animation-timing-function:linear;block-size:5.5rem;border:0;box-sizing:border-box;font-family:inherit;font-size:100%;inline-size:5.5rem;margin:0;padding:0;vertical-align:baseline}.cds--loading *,.cds--loading :after,.cds--loading :before,:host(cds-loading) *,:host(cds-loading) :after,:host(cds-loading) :before{box-sizing:inherit}.cds--loading svg circle,:host(cds-loading) svg circle{animation-duration:10ms;animation-name:cds--init-stroke;animation-timing-function:cubic-bezier(.5,0,.1,1)}@media screen and (prefers-reduced-motion:reduce){.cds--loading svg circle,:host(cds-loading) svg circle{animation:none}}.cds--loading__svg{fill:transparent}.cds--loading__svg circle{stroke-dasharray:276.4608 276.4608;stroke-linecap:butt;stroke-width:10}.cds--loading__stroke{stroke:var(--cds-interactive,#0f62fe);stroke-dashoffset:52.527552}.cds--loading--small .cds--loading__stroke,:host(cds-loading[type=small]) .cds--loading__stroke{stroke-dashoffset:143.759616}.cds--loading--stop,:host(cds-loading[inactive]){animation:cds--rotate-end-p1 .7s cubic-bezier(0,0,.25,1) forwards,cds--rotate-end-p2 .7s cubic-bezier(0,0,.25,1) .7s forwards}.cds--loading--stop svg circle,:host(cds-loading[inactive]) svg circle{animation-delay:.7s;animation-duration:.7s;animation-fill-mode:forwards;animation-name:cds--stroke-end;animation-timing-function:cubic-bezier(0,0,.25,1)}@media screen and (prefers-reduced-motion:reduce){.cds--loading--stop svg circle,:host(cds-loading[inactive]) svg circle{animation:none}}.cds--loading--small,:host(cds-loading[type=small]){block-size:1rem;inline-size:1rem;line-height:1rem}.cds--loading--small circle,:host(cds-loading[type=small]) circle{stroke-width:16}.cds--loading--small .cds--loading__svg,:host(cds-loading[type=small]) .cds--loading__svg{stroke:var(--cds-interactive,#0f62fe)}.cds--loading__background{stroke:var(--cds-layer-accent);stroke-dashoffset:-22}@media not all and (resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){circle.cds--loading__background{stroke-dasharray:265;stroke-dashoffset:0}}}.cds--loading-overlay,:host(cds-loading[overlay]){align-items:center;background-color:var(--cds-overlay,hsla(0,0%,9%,.5));block-size:100%;display:flex;inline-size:100%;inset-block-start:0;inset-inline-start:0;justify-content:center;position:fixed;transition:background-color .7s cubic-bezier(.4,.14,.3,1);z-index:6000}.cds--loading-overlay--stop{display:none}@keyframes cds--rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes cds--rotate-end-p1{to{transform:rotate(1turn)}}@keyframes cds--rotate-end-p2{to{transform:rotate(-1turn)}}@keyframes cds--init-stroke{0%{stroke-dashoffset:276.4608}to{stroke-dashoffset:52.527552}}@keyframes cds--stroke-end{0%{stroke-dashoffset:52.527552}to{stroke-dashoffset:276.4608}}:host(cds-loading){display:block}:host(cds-loading[overlay]){animation:none}.cds--loading__background[hidden]{display:none}"
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Hbbu":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The state of `<cds-file-uploader-item>`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FILE_UPLOADER_ITEM_SIZE", ()=>FILE_UPLOADER_ITEM_SIZE);
parcelHelpers.export(exports, "FILE_UPLOADER_ITEM_STATE", ()=>FILE_UPLOADER_ITEM_STATE);
var FILE_UPLOADER_ITEM_STATE;
(function(FILE_UPLOADER_ITEM_STATE) {
    /**
     * Upload in progress.
     */ FILE_UPLOADER_ITEM_STATE["UPLOADING"] = "uploading";
    /**
     * Upload complete.
     */ FILE_UPLOADER_ITEM_STATE["COMPLETE"] = "complete";
    /**
     * Editing.
     */ FILE_UPLOADER_ITEM_STATE["EDIT"] = "edit";
})(FILE_UPLOADER_ITEM_STATE || (FILE_UPLOADER_ITEM_STATE = {}));
/**
 * File uploader item size.
 */ var FILE_UPLOADER_ITEM_SIZE;
(function(FILE_UPLOADER_ITEM_SIZE) {
    /**
     * Small size.
     */ FILE_UPLOADER_ITEM_SIZE["SMALL"] = "sm";
    /**
     * Medium size.
     */ FILE_UPLOADER_ITEM_SIZE["MEDIUM"] = "md";
    /**
     * Large size.
     */ FILE_UPLOADER_ITEM_SIZE["LARGE"] = "lg";
})(FILE_UPLOADER_ITEM_SIZE || (FILE_UPLOADER_ITEM_SIZE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kYAzT":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TILE_COLOR_SCHEME", ()=>(0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME));
parcelHelpers.export(exports, "default", ()=>CDSFileUploaderDropContainer$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _hostListenerJs = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _ifNonEmptyJs = require("../../globals/directives/if-non-empty.js");
var _ifNonEmptyJsDefault = parcelHelpers.interopDefault(_ifNonEmptyJs);
var _fileUploaderScssJs = require("./file-uploader.scss.js");
var _fileUploaderScssJsDefault = parcelHelpers.interopDefault(_fileUploaderScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _sharedEnumsJs = require("../../globals/shared-enums.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The value to set to `event.dataTransfer.dropEffect`, keyed by the event nane.
 */ const dropEffects = {
    dragover: "copy",
    dragleave: "move"
};
/**
 * File uploader drop container.
 *
 * @element cds-file-uploader-drop-container
 * @fires cds-file-uploader-drop-container-changed The custom event fired when there is a user gesture to select files to upload.
 */ let CDSFileUploaderDropContainer = class CDSFileUploaderDropContainer extends (0, _hostListenerJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` to show the active state of this UI.
         */ this._active = false;
        /**
         * The file types the file input should accept, separated by space.
         */ this.accept = "";
        /**
         * `true` if this drop container should be disabled.
         */ this.disabled = false;
        /**
         * `true` if this drop container should accept more than one files at once.
         * Note that even with `false` set here, user _can_ select multiple files one by one.
         */ this.multiple = false;
        /**
         * The name of the input.
         */ this.name = "";
        /**
         * The shadow DOM slot to put this drop container in.
         */ this.slot = "drop-container";
    }
    /**
     * Handles user gesture to select files to upload.
     *
     * @param event The event.
     */ _handleChange(event) {
        var _a, _b;
        const { eventChange, selectorInput } = this.constructor;
        const { files } = (_a = event.type === "drop" ? event.dataTransfer : event.target) !== null && _a !== void 0 ? _a : {};
        const addedFiles = this._getFiles(event, files);
        this.dispatchEvent(new CustomEvent(eventChange, {
            bubbles: true,
            composed: true,
            detail: {
                addedFiles
            }
        }));
        const fileInput = (_b = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(selectorInput);
        if (fileInput) fileInput.value = ""; // carbon-web-components#904
    }
    /**
     * Handles `dragover`, `dragleave` and `drop` events.
     *
     * @param event The event.
     */ _handleDrag(event) {
        event.preventDefault(); // Prevents page navigation upon dropping
        if (this.disabled) return;
        const { dataTransfer, type } = event;
        const dropEffect = dropEffects[type];
        if (dataTransfer && dropEffect) dataTransfer.dropEffect = dropEffect;
        this._active = type === "dragover";
        if (type === "drop") this._handleChange(event);
        this.requestUpdate();
    }
    /**
     * @param event The event.
     * @returns The list of files user chose to upload.
     */ _getFiles(event, files) {
        const { accept } = this;
        if (!accept || !/^(change|drop)$/.test(event.type)) return Array.from(files !== null && files !== void 0 ? files : []);
        const acceptedTypes = new Set(accept.split(" "));
        return Array.prototype.filter.call(files, ({ name, type: mimeType = "" })=>{
            var _a;
            const fileExtensionRegExp = /\.[^.]+$/;
            const hasFileExtension = fileExtensionRegExp.test(name);
            const [fileExtension] = !hasFileExtension ? [
                undefined
            ] : (_a = fileExtensionRegExp.exec(name)) !== null && _a !== void 0 ? _a : [];
            return acceptedTypes.has(mimeType) || fileExtension && acceptedTypes.has(fileExtension);
        });
    }
    render() {
        const { accept, disabled, multiple, name, _active: active, _handleChange: handleChange } = this;
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--file-browse-btn`]: true,
            [`${0, _settingsJs.prefix}--file-browse-btn--disabled`]: disabled
        });
        const dropareaClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--file__drop-container`]: true,
            [`${0, _settingsJs.prefix}--file__drop-container--drag-over`]: active
        });
        return (0, _lit.html)`
      <label class="${labelClasses}" for="file" tabindex="0">
        <div class="${dropareaClasses}" role="button">
          <slot></slot>
          <input
            id="file"
            type="file"
            name="${(0, _ifNonEmptyJsDefault.default)(name)}"
            class="${0, _settingsJs.prefix}--file-input"
            tabindex="-1"
            accept="${(0, _ifNonEmptyJsDefault.default)(accept)}"
            ?disabled="${disabled}"
            ?multiple="${multiple}"
            @change="${handleChange}" />
        </div>
      </label>
    `;
    }
    /**
     * The name of the custom event fired when there is a user gesture to select files to upload.
     */ static get eventChange() {
        return `${0, _settingsJs.prefix}-file-uploader-drop-container-changed`;
    }
    /**
     * A selector that will return the file `<input>`.
     */ static get selectorInput() {
        return `.${0, _settingsJs.prefix}--file-input`;
    }
};
CDSFileUploaderDropContainer.styles = (0, _fileUploaderScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("dragover"),
    (0, _hostListenerJsDefault1.default)("dragleave"),
    (0, _hostListenerJsDefault1.default)("drop")
], CDSFileUploaderDropContainer.prototype, "_handleDrag", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSFileUploaderDropContainer.prototype, "accept", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSFileUploaderDropContainer.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSFileUploaderDropContainer.prototype, "multiple", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSFileUploaderDropContainer.prototype, "name", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSFileUploaderDropContainer.prototype, "slot", void 0);
CDSFileUploaderDropContainer = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-file-uploader-drop-container`)
], CDSFileUploaderDropContainer);
var CDSFileUploaderDropContainer$1 = CDSFileUploaderDropContainer;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/mixins/host-listener.js":"1SMUX","../../globals/decorators/host-listener.js":"f95Mj","../../globals/directives/if-non-empty.js":"5Xlqk","./file-uploader.scss.js":"4oN5w","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/shared-enums.js":"12kea","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ktiU2":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TILE_COLOR_SCHEME", ()=>(0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME));
parcelHelpers.export(exports, "default", ()=>CDSFileUploaderButton$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _settingsJs = require("../../globals/settings.js");
var _hostListenerJs = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _ifNonEmptyJs = require("../../globals/directives/if-non-empty.js");
var _ifNonEmptyJsDefault = parcelHelpers.interopDefault(_ifNonEmptyJs);
var _fileUploaderScssJs = require("./file-uploader.scss.js");
var _fileUploaderScssJsDefault = parcelHelpers.interopDefault(_fileUploaderScssJs);
var _defsJs = require("../button/defs.js");
var _sharedEnumsJs = require("../../globals/shared-enums.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * File uploader button .
 *
 * @element cds-file-uploader-container
 * @fires cds-file-uploader-button-changed The custom event fired when there is a user gesture to select files to upload.
 */ let CDSFileUploaderButton = class CDSFileUploaderButton extends (0, _hostListenerJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * Button kind.
         */ this.buttonKind = (0, _defsJs.BUTTON_KIND).PRIMARY;
        /**
         * Button size.
         */ this.size = (0, _defsJs.BUTTON_SIZE).MEDIUM;
        /**
         * The file types the file input should accept, separated by space.
         */ this.accept = "";
        /**
         * `true` if this drop container should be disabled.
         */ this.disabled = false;
        /**
         * `true` if this drop container should accept more than one files at once.
         * Note that even with `false` set here, user _can_ select multiple files one by one.
         */ this.multiple = false;
        /**
         * The name of the input.
         */ this.name = "";
        /**
         * The shadow DOM slot to put this drop container in.
         */ this.slot = "drop-container";
    }
    /**
     * Handles `click` event on the button.
     */ _handleClick(event) {
        var _a, _b, _c;
        event.target.value = null;
        const { selectorInput } = this.constructor;
        (_b = (_a = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(selectorInput)) === null || _b === void 0 || _b.setAttribute("value", "");
        ((_c = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(selectorInput)).click();
    }
    /**
     * Handles `keydown` event on the button.
     */ _handleKeyDown(event) {
        var _a, _b, _c;
        const { selectorInput } = this.constructor;
        if (event.key === "Enter" || event.key === "Space") {
            (_b = (_a = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(selectorInput)) === null || _b === void 0 || _b.setAttribute("value", "");
            ((_c = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(selectorInput)).click();
        }
    }
    /**
     * Handles user gesture to select files to upload.
     *
     * @param event The event.
     */ _handleChange(event) {
        var _a;
        const addedFiles = this._getFiles(event);
        const { eventChange, selectorInput } = this.constructor;
        this.dispatchEvent(new CustomEvent(eventChange, {
            bubbles: true,
            composed: true,
            detail: {
                addedFiles
            }
        }));
        const fileInput = (_a = this === null || this === void 0 ? void 0 : this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(selectorInput);
        if (fileInput) fileInput.value = "";
    }
    /**
     * @param event The event.
     * @returns The list of files user chose to upload.
     */ _getFiles(event) {
        var _a;
        const { files } = (_a = event.type === "drop" ? event.dataTransfer : event.target) !== null && _a !== void 0 ? _a : {};
        const { accept } = this;
        if (!accept || !/^(change|drop)$/.test(event.type)) return Array.from(files !== null && files !== void 0 ? files : []);
        const acceptedTypes = new Set(accept.split(" "));
        return Array.prototype.filter.call(files, ({ name, type: mimeType = "" })=>{
            var _a;
            const fileExtensionRegExp = /\.[^.]+$/;
            const hasFileExtension = fileExtensionRegExp.test(name);
            const [fileExtension] = !hasFileExtension ? [
                undefined
            ] : (_a = fileExtensionRegExp.exec(name)) !== null && _a !== void 0 ? _a : [];
            return acceptedTypes.has(mimeType) || fileExtension && acceptedTypes.has(fileExtension);
        });
    }
    render() {
        const { accept, disabled, multiple, name, buttonKind, size, _handleChange: handleChange } = this;
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--file-browse-btn`]: true,
            [`${0, _settingsJs.prefix}--file-browse-btn--disabled`]: disabled
        });
        const buttonClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--btn`]: true,
            [`${0, _settingsJs.prefix}--btn--${buttonKind}`]: buttonKind,
            [`${0, _settingsJs.prefix}--layout--size-${size}`]: size,
            [`${0, _settingsJs.prefix}--btn--disabled`]: disabled,
            [`${0, _settingsJs.prefix}--btn--${size}`]: size
        });
        return (0, _lit.html)`
      <button
        type="button"
        class="${buttonClasses}"
        @click="${this._handleClick}"
        @keydown="${this._handleKeyDown}">
        <slot></slot>
      </button>
      <label class="${labelClasses}" for="file"> </label>
      <input
        id="file"
        type="file"
        class="${0, _settingsJs.prefix}--file-input"
        tabindex="-1"
        accept="${(0, _ifNonEmptyJsDefault.default)(accept)}"
        ?disabled="${disabled}"
        ?multiple="${multiple}"
        name="${(0, _ifNonEmptyJsDefault.default)(name)}"
        @change="${handleChange}" />
    `;
    }
    /**
     * The name of the custom event fired when there is a user gesture to select files to upload.
     */ static get eventChange() {
        return `${0, _settingsJs.prefix}-file-uploader-button-changed`;
    }
    /**
     * A selector that will return the file `<input>`.
     */ static get selectorInput() {
        return `.${0, _settingsJs.prefix}--file-input`;
    }
};
CDSFileUploaderButton.styles = (0, _fileUploaderScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "button-kind"
    })
], CDSFileUploaderButton.prototype, "buttonKind", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSFileUploaderButton.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSFileUploaderButton.prototype, "accept", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSFileUploaderButton.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSFileUploaderButton.prototype, "multiple", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSFileUploaderButton.prototype, "name", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSFileUploaderButton.prototype, "slot", void 0);
CDSFileUploaderButton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-file-uploader-button`)
], CDSFileUploaderButton);
var CDSFileUploaderButton$1 = CDSFileUploaderButton;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/settings.js":"EipuL","../../globals/mixins/host-listener.js":"1SMUX","../../globals/directives/if-non-empty.js":"5Xlqk","./file-uploader.scss.js":"4oN5w","../button/defs.js":"3XZFP","../../globals/shared-enums.js":"12kea","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hWxJs":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSFileUploaderSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _skeletonTextJs = require("../skeleton-text/skeleton-text.js");
var _buttonSkeletonJs = require("../button/button-skeleton.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("../skeleton-text/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The File uploader skeleton.
 *
 * @element cds-file-uploader-skeleton
 */ let CDSFileUploaderSkeleton = class CDSFileUploaderSkeleton extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)`
      <cds-skeleton-text
        type="${(0, _defsJs.SKELETON_TEXT_TYPE).HEADING}"
        width="100px"></cds-skeleton-text>
      <cds-skeleton-text width="225px"></cds-skeleton-text>
      <cds-button-skeleton></cds-button-skeleton>
    `;
    }
};
CDSFileUploaderSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-file-uploader-skeleton`)
], CDSFileUploaderSkeleton);
var CDSFileUploaderSkeleton$1 = CDSFileUploaderSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","../skeleton-text/skeleton-text.js":"9W6nb","../button/button-skeleton.js":"cfoNU","../../globals/decorators/carbon-element.js":"kNhLR","../skeleton-text/defs.js":"6sWex","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4JwcQ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _formItemJs = require("./form-item.js");

},{"./form-item.js":"9DRI0"}],"9DRI0":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSFormItem$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _formItemScssJs = require("./form-item.scss.js");
var _formItemScssJsDefault = parcelHelpers.interopDefault(_formItemScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Presentational element for form items
 *
 * @element cds-form-item
 */ let CDSFormItem = class CDSFormItem extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSFormItem.styles = (0, _formItemScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
CDSFormItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-form-item`)
], CDSFormItem);
var CDSFormItem$1 = CDSFormItem;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./form-item.scss.js":"6xWbm","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6xWbm":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item,:host(cds-form-item){align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ab5WP":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _inlineLoadingJs = require("./inline-loading.js");

},{"./inline-loading.js":"fmJwO"}],"fmJwO":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INLINE_LOADING_STATE", ()=>(0, _defsJs.INLINE_LOADING_STATE));
parcelHelpers.export(exports, "default", ()=>CDSInlineLoading$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _classMapJs = require("lit/directives/class-map.js");
var _16Js = require("../../icons/checkmark--filled/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/error--filled/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _settingsJs = require("../../globals/settings.js");
var _typesJs = require("../loading/types.js");
var _typesJsDefault = parcelHelpers.interopDefault(_typesJs);
var _loadingIconJs = require("../loading/loading-icon.js");
var _loadingIconJsDefault = parcelHelpers.interopDefault(_loadingIconJs);
var _defsJs = require("./defs.js");
var _inlineLoadingScssJs = require("./inline-loading.scss.js");
var _inlineLoadingScssJsDefault = parcelHelpers.interopDefault(_inlineLoadingScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Lnline loading spinner.
 *
 * @element cds-inline-loading
 */ let CDSInlineLoading = class CDSInlineLoading extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * The assistive text for the spinner icon.
         */ this.assistiveText = "Loading";
        /**
         * The loading status.
         */ this.status = (0, _defsJs.INLINE_LOADING_STATE).ACTIVE;
    }
    /**
     * @returns The template for the status icon.
     */ _renderIcon() {
        const { assistiveText, status } = this;
        if (status === (0, _defsJs.INLINE_LOADING_STATE).ERROR) return (0, _16JsDefault1.default)({
            class: `${(0, _settingsJs.prefix)}--inline-loading--error`
        });
        if (status === (0, _defsJs.INLINE_LOADING_STATE).FINISHED) return (0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--inline-loading__checkmark-container`
        });
        if (status === (0, _defsJs.INLINE_LOADING_STATE).INACTIVE || status === (0, _defsJs.INLINE_LOADING_STATE).ACTIVE) {
            const classes = (0, _classMapJs.classMap)({
                [`${0, _settingsJs.prefix}--loading`]: true,
                [`${0, _settingsJs.prefix}--loading--small`]: true,
                [`${0, _settingsJs.prefix}--loading--stop`]: status === (0, _defsJs.INLINE_LOADING_STATE).INACTIVE
            });
            return (0, _lit.html)`
        <div class="${classes}">
          ${(0, _loadingIconJsDefault.default)({
                assistiveText,
                type: (0, _typesJsDefault.default).SMALL
            })}
        </div>
      `;
        }
        return undefined;
    }
    connectedCallback() {
        if (!this.hasAttribute("aria-live")) this.setAttribute("aria-live", "assertive");
        super.connectedCallback();
    }
    render() {
        const statusIconResult = this._renderIcon();
        const statusIconWrapperResult = !statusIconResult ? undefined : (0, _lit.html)`
          <div class="${0, _settingsJs.prefix}--inline-loading__animation">
            ${statusIconResult}
          </div>
        `;
        return (0, _lit.html)`
      ${statusIconWrapperResult}
      <p class="${0, _settingsJs.prefix}--inline-loading__text"><slot></slot></p>
    `;
    }
};
CDSInlineLoading.styles = (0, _inlineLoadingScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "assistive-text"
    })
], CDSInlineLoading.prototype, "assistiveText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSInlineLoading.prototype, "status", void 0);
CDSInlineLoading = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-inline-loading`)
], CDSInlineLoading);
var CDSInlineLoading$1 = CDSInlineLoading;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/class-map.js":"2fQud","../../icons/checkmark--filled/16.js":"EwXOT","../../icons/error--filled/16.js":"9QDat","../../globals/settings.js":"EipuL","../loading/types.js":"5a963","../loading/loading-icon.js":"SBMIA","./defs.js":"9KjjB","./inline-loading.scss.js":"i4ZTb","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9QDat":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}<path d="M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z"></path><path fill="none" d="M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z" data-icon-path="inner-path" opacity="0"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9KjjB":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Loading state for inline loading spinner.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INLINE_LOADING_STATE", ()=>INLINE_LOADING_STATE);
var INLINE_LOADING_STATE;
(function(INLINE_LOADING_STATE) {
    /**
     * Inactive state.
     */ INLINE_LOADING_STATE["INACTIVE"] = "inactive";
    /**
     * State for loading in progress.
     */ INLINE_LOADING_STATE["ACTIVE"] = "active";
    /**
     * State for loading successful.
     */ INLINE_LOADING_STATE["FINISHED"] = "finished";
    /**
     * State for loading failure.
     */ INLINE_LOADING_STATE["ERROR"] = "error";
})(INLINE_LOADING_STATE || (INLINE_LOADING_STATE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i4ZTb":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    ".cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--loading{animation-duration:.69s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:cds--rotate;animation-timing-function:linear;block-size:5.5rem;border:0;box-sizing:border-box;font-family:inherit;font-size:100%;inline-size:5.5rem;margin:0;padding:0;vertical-align:baseline}.cds--loading *,.cds--loading :after,.cds--loading :before{box-sizing:inherit}.cds--loading svg circle{animation-duration:10ms;animation-name:cds--init-stroke;animation-timing-function:cubic-bezier(.5,0,.1,1)}@media screen and (prefers-reduced-motion:reduce){.cds--loading svg circle{animation:none}}.cds--loading__svg{fill:transparent}.cds--loading__svg circle{stroke-dasharray:276.4608 276.4608;stroke-linecap:butt;stroke-width:10}.cds--loading__stroke{stroke:var(--cds-interactive,#0f62fe);stroke-dashoffset:52.527552}.cds--loading--small .cds--loading__stroke{stroke-dashoffset:143.759616}.cds--loading--stop{animation:cds--rotate-end-p1 .7s cubic-bezier(0,0,.25,1) forwards,cds--rotate-end-p2 .7s cubic-bezier(0,0,.25,1) .7s forwards}.cds--loading--stop svg circle{animation-delay:.7s;animation-duration:.7s;animation-fill-mode:forwards;animation-name:cds--stroke-end;animation-timing-function:cubic-bezier(0,0,.25,1)}@media screen and (prefers-reduced-motion:reduce){.cds--loading--stop svg circle{animation:none}}.cds--loading--small{block-size:1rem;inline-size:1rem;line-height:1rem}.cds--loading--small circle{stroke-width:16}.cds--loading--small .cds--loading__svg{stroke:var(--cds-interactive,#0f62fe)}.cds--loading__background{stroke:var(--cds-layer-accent);stroke-dashoffset:-22}@media not all and (resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){circle.cds--loading__background{stroke-dasharray:265;stroke-dashoffset:0}}}.cds--loading-overlay{align-items:center;background-color:var(--cds-overlay,hsla(0,0%,9%,.5));block-size:100%;display:flex;inline-size:100%;inset-block-start:0;inset-inline-start:0;justify-content:center;position:fixed;transition:background-color .7s cubic-bezier(.4,.14,.3,1);z-index:6000}.cds--loading-overlay--stop{display:none}@keyframes cds--rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes cds--rotate-end-p1{to{transform:rotate(1turn)}}@keyframes cds--rotate-end-p2{to{transform:rotate(-1turn)}}@keyframes cds--init-stroke{0%{stroke-dashoffset:276.4608}to{stroke-dashoffset:52.527552}}@keyframes cds--stroke-end{0%{stroke-dashoffset:52.527552}to{stroke-dashoffset:276.4608}}@keyframes prefix--stroke{to{stroke-dashoffset:0}}.cds--inline-loading,:host(cds-inline-loading){align-items:center;display:flex;inline-size:100%;min-block-size:2rem}.cds--inline-loading__text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-label-02-font-size,.875rem);font-weight:var(--cds-label-02-font-weight,400);letter-spacing:var(--cds-label-02-letter-spacing,.16px);line-height:var(--cds-label-02-line-height,1.28572)}.cds--inline-loading__animation{align-items:center;display:flex;justify-content:center;margin-inline-end:.5rem;position:relative}.cds--inline-loading__checkmark-container{fill:var(--cds-support-success,#24a148)}.cds--inline-loading__checkmark-container.cds--inline-loading__svg{inline-size:.75rem;inset-block-start:.75rem;position:absolute}.cds--inline-loading__checkmark-container[hidden]{display:none}.cds--inline-loading__checkmark{animation-duration:.25s;animation-fill-mode:forwards;animation-name:cds--stroke;fill:none;stroke:var(--cds-interactive,#0f62fe);stroke-dasharray:12;stroke-dashoffset:12;stroke-width:1.8;transform-origin:50% 50%}.cds--inline-loading--error{block-size:1rem;fill:var(--cds-support-error,#da1e28);inline-size:1rem}.cds--inline-loading--error[hidden]{display:none}.cds--loading--small .cds--inline-loading__svg{stroke:var(--cds-interactive,#0f62fe)}.cds--btn .cds--inline-loading--btn{min-block-size:0}.cds--btn .cds--inline-loading--btn .cds--inline-loading__text{font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);line-height:var(--cds-body-short-01-line-height,1.28572)}@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){.cds--inline-loading__checkmark-container{inset-block-start:1px;inset-inline-end:.5rem}.cds--inline-loading__checkmark{animation:none;stroke-dasharray:0;stroke-dashoffset:0}}"
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f7VnJ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _linkJs = require("./link.js");

},{"./link.js":"7peJx"}],"7peJx":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LINK_SIZE", ()=>LINK_SIZE);
parcelHelpers.export(exports, "default", ()=>CDSLink$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _linkScssJs = require("./link.scss.js");
var _linkScssJsDefault = parcelHelpers.interopDefault(_linkScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Link size.
 */ const LINK_SIZE = {
    MEDIUM: "md",
    SMALL: "sm",
    LARGE: "lg"
};
/**
 * Link.
 *
 * @element cds-link
 * @csspart link The link.
 */ let CDSLink = class CDSLink extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if there is an icon.
         */ this._hasIcon = false;
        /**
         * `true` if the link should be disabled.
         */ this.disabled = false;
        /**
         * `true` if the link should be inline.
         */ this.inline = false;
        /**
         * Link size.
         */ this.size = LINK_SIZE.MEDIUM;
        /**
         * `true` if the link has been visited.
         */ this.visited = false;
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const { name } = target;
        const hasContent = target.assignedNodes().some((node)=>node.nodeType !== Node.TEXT_NODE || node.textContent.trim());
        this[name === "icon" ? "_hasIcon" : ""] = hasContent;
        this.requestUpdate();
    }
    /**
     * The CSS class list for the link node.
     */ get _classes() {
        const { disabled, size, inline, visited, _hasIcon } = this;
        return (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--link`]: true,
            [`${0, _settingsJs.prefix}--link--disabled`]: disabled,
            [`${0, _settingsJs.prefix}--link--icon`]: _hasIcon,
            [`${0, _settingsJs.prefix}--link--inline`]: inline,
            [`${0, _settingsJs.prefix}--link--${size}`]: size,
            [`${0, _settingsJs.prefix}--link--visited`]: visited
        });
    }
    /**
     * Handles `click` event on the `<a>`.
     */ // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
    _handleClick(_) {}
    /**
     * @returns The inner content.
     */ // eslint-disable-next-line class-methods-use-this
    _renderInner() {
        const { _hasIcon: hasIcon, _handleSlotChange: handleSlotChange } = this;
        return (0, _lit.html)`
      <slot @slotchange="${handleSlotChange}"></slot>
      <div ?hidden="${!hasIcon}" class="${0, _settingsJs.prefix}--link__icon">
        <slot name="icon" @slotchange="${handleSlotChange}"></slot>
      </div>
    `;
    }
    /**
     * @returns The disabled link content.
     */ _renderDisabledLink() {
        const { _classes: classes } = this;
        return (0, _lit.html)`
      <p id="link" part="link" class="${classes}">${this._renderInner()}</p>
    `;
    }
    /**
     * @returns The link content.
     */ _renderLink() {
        const { download, href, hreflang, linkRole, ping, rel, target, type, _classes: classes, _handleClick: handleClick } = this;
        return (0, _lit.html)`
      <a
        tabindex="0"
        id="link"
        role="${(0, _ifDefinedJs.ifDefined)(linkRole)}"
        class="${classes}"
        part="link"
        download="${(0, _ifDefinedJs.ifDefined)(download)}"
        href="${(0, _ifDefinedJs.ifDefined)(href)}"
        hreflang="${(0, _ifDefinedJs.ifDefined)(hreflang)}"
        ping="${(0, _ifDefinedJs.ifDefined)(ping)}"
        rel="${(0, _ifDefinedJs.ifDefined)(rel)}"
        target="${(0, _ifDefinedJs.ifDefined)(target)}"
        type="${(0, _ifDefinedJs.ifDefined)(type)}"
        @click="${handleClick}">
        ${this._renderInner()}
      </a>
    `;
    }
    render() {
        const { disabled } = this;
        return disabled ? this._renderDisabledLink() : this._renderLink();
    }
};
CDSLink.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSLink.styles = (0, _linkScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#link")
], CDSLink.prototype, "_linkNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSLink.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSLink.prototype, "download", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSLink.prototype, "href", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSLink.prototype, "hreflang", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSLink.prototype, "inline", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "link-role"
    })
], CDSLink.prototype, "linkRole", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSLink.prototype, "ping", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSLink.prototype, "rel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSLink.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSLink.prototype, "target", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSLink.prototype, "type", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSLink.prototype, "visited", void 0);
CDSLink = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-link`)
], CDSLink);
var CDSLink$1 = CDSLink;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit/directives/if-defined.js":"hSgrS","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./link.scss.js":"h03m3","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h03m3":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    ".cds--link{border:0;box-sizing:border-box;color:var(--cds-link-text-color,var(--cds-link-primary,#0f62fe));display:inline-flex;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:none;padding:0;text-decoration:none;transition:color 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--link *,.cds--link :after,.cds--link :before{box-sizing:inherit}.cds--link:hover{color:var(--cds-link-hover-text-color,var(--cds-link-primary-hover,#0043ce));text-decoration:underline}.cds--link:active,.cds--link:active:visited,.cds--link:active:visited:hover{color:var(--cds-link-text-color,var(--cds-link-primary,#0f62fe));outline:1px solid var(--cds-focus,#0f62fe);outline-color:var(--cds-link-focus-text-color,var(--cds-focus,#0f62fe));text-decoration:underline}@media screen and (prefers-contrast){.cds--link:active,.cds--link:active:visited,.cds--link:active:visited:hover{outline-style:dotted}}.cds--link:focus{outline:1px solid var(--cds-focus,#0f62fe);outline-color:var(--cds-link-focus-text-color,var(--cds-focus,#0f62fe));text-decoration:underline}@media screen and (prefers-contrast){.cds--link:focus{outline-style:dotted}}.cds--link:visited{color:var(--cds-link-text-color,var(--cds-link-primary,#0f62fe))}.cds--link:visited:hover{color:var(--cds-link-hover-text-color,var(--cds-link-primary-hover,#0043ce))}.cds--link--disabled,.cds--link--disabled:hover{border:0;box-sizing:border-box;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;padding:0;text-decoration:none;vertical-align:baseline}.cds--link--disabled *,.cds--link--disabled :after,.cds--link--disabled :before,.cds--link--disabled:hover *,.cds--link--disabled:hover :after,.cds--link--disabled:hover :before{box-sizing:inherit}.cds--link.cds--link--visited:visited{color:var(--cds-link-visited-text-color,var(--cds-link-visited,#8a3ffc))}.cds--link.cds--link--visited:visited:hover{color:var(--cds-link-hover-text-color,var(--cds-link-primary-hover,#0043ce))}.cds--link.cds--link--inline{display:inline;text-decoration:underline}.cds--link--disabled.cds--link--inline{text-decoration:underline}.cds--link--sm,.cds--link--sm.cds--link--disabled:hover{font-size:var(--cds-helper-text-01-font-size,.75rem);letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333)}.cds--link--lg,.cds--link--lg.cds--link--disabled:hover{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375)}.cds--link__icon{align-self:center;display:inline-flex;margin-inline-start:.5rem}:host(cds-link){outline:none}:host(cds-link) .cds--link--disabled{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}:host(cds-link) .cds--link__icon[hidden]{display:none}"
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g3gxU":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _listItemJs = require("./list-item.js");
var _orderedListJs = require("./ordered-list.js");
var _unorderedListJs = require("./unordered-list.js");

},{"./list-item.js":"3Eijp","./ordered-list.js":"NqxXT","./unordered-list.js":"fM8D6"}],"3Eijp":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSListItem$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _listScssJs = require("./list.scss.js");
var _listScssJsDefault = parcelHelpers.interopDefault(_listScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * List item.
 *
 * @element cds-list-item
 * @slot nested - The nested child list.
 */ let CDSListItem = class CDSListItem extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if there is slotted nested child list.
         */ this._hasNestedChild = false;
        /**
         * `true` if this list item is a child of a nested list.
         * `<cds-ordered-list>` or `<cds-unordered-list>` automatically sets this property.
         */ this.nested = false;
    }
    /**
     * Handles `slotchange` event for the `<slot>` for the nested child list.
     *
     * @param event The event.
     * @param event.target The event target.
     */ _handleSlotChangeNested({ target }) {
        this._hasNestedChild = target.assignedNodes().length > 0;
        this.requestUpdate();
    }
    connectedCallback() {
        // Uses attribute for lookup from child
        this.toggleAttribute("nested", Boolean(this.closest(this.constructor.selectorNestedList)));
        if (!this.hasAttribute("role")) this.setAttribute("role", "listitem");
        super.connectedCallback();
    }
    render() {
        const { _hasNestedChild: hasNestedChild, _handleSlotChangeNested: handleSlotChangeNested } = this;
        return (0, _lit.html)`
      <slot></slot>
      <div
        ?hidden="${!hasNestedChild}"
        class="${0, _settingsJs.prefix}-ce--list__item__nested-child">
        <slot name="nested" @slotchange="${handleSlotChangeNested}"></slot>
      </div>
    `;
    }
    /**
     * A selector that will return nested list.
     */ static get selectorNestedList() {
        return `${0, _settingsJs.prefix}-ordered-list[slot="nested"],${0, _settingsJs.prefix}-unordered-list[slot="nested"]`;
    }
};
CDSListItem.styles = (0, _listScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSListItem.prototype, "nested", void 0);
CDSListItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-list-item`)
], CDSListItem);
var CDSListItem$1 = CDSListItem;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./list.scss.js":"4MZck","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4MZck":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@charset "UTF-8";.cds--list--nested,.cds--list--ordered,.cds--list--ordered--native,.cds--list--unordered{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);list-style:none;margin:0;padding:0;vertical-align:baseline}.cds--list--nested *,.cds--list--nested :after,.cds--list--nested :before,.cds--list--ordered *,.cds--list--ordered :after,.cds--list--ordered :before,.cds--list--ordered--native *,.cds--list--ordered--native :after,.cds--list--ordered--native :before,.cds--list--unordered *,.cds--list--unordered :after,.cds--list--unordered :before{box-sizing:inherit}.cds--list--unordered:not(.cds--list--nested){margin-inline-start:1rem}.cds--list--expressive,.cds--list--expressive .cds--list--nested{font-size:var(--cds-body-02-font-size,1rem);font-weight:var(--cds-body-02-font-weight,400);letter-spacing:var(--cds-body-02-letter-spacing,0);line-height:var(--cds-body-02-line-height,1.5)}.cds--list--ordered--native{list-style:decimal}.cds--list__item{color:var(--cds-text-primary,#161616)}.cds--list--nested{margin-inline-start:2rem}.cds--list--nested .cds--list__item{padding-inline-start:.25rem}.cds--list--ordered:not(.cds--list--nested){counter-reset:item}.cds--list--ordered:not(.cds--list--nested)>.cds--list__item{position:relative}.cds--list--ordered:not(.cds--list--nested)>.cds--list__item:before{content:counter(item) ".";counter-increment:item;inset-inline-start:-1.5rem;position:absolute}.cds--list--ordered--native.cds--list--nested,.cds--list--ordered.cds--list--nested{list-style-type:lower-latin}.cds--list--unordered>.cds--list__item{position:relative}.cds--list--unordered>.cds--list__item:before{content:"\u2013";inset-inline-start:-1rem;position:absolute}.cds--list--unordered.cds--list--nested>.cds--list__item:before{content:"\u25AA";inset-inline-start:-.75rem}:host(cds-ordered-list) .cds--list--nested,:host(cds-unordered-list) .cds--list--nested{margin-inline-start:2rem}:host(cds-ordered-list) .cds--list--nested ::slotted(cds-list-item),:host(cds-unordered-list) .cds--list--nested ::slotted(cds-list-item){padding-inline-start:.25rem}:host(cds-ordered-list) .cds--list--ordered.cds--list--nested{list-style-type:lower-latin}:host(cds-ordered-list):not(.cds--list--nested){counter-reset:item}:host(cds-ordered-list):not(.cds--list--nested) ::slotted(cds-list-item){position:relative}:host(cds-ordered-list) .cds--list--ordered:not(.cds--list--nested) ::slotted(cds-list-item):before{content:counter(item) ".";counter-increment:item;inset-inline-start:-1.5rem;position:absolute}:host(cds-unordered-list){--cds-ce--list-marker:"\u2013"}:host(cds-unordered-list)[slot=nested]{--cds-ce--list-marker:"\u25AA"}:host(cds-unordered-list) ::slotted(cds-list-item){position:relative}:host(cds-unordered-list) ::slotted(cds-list-item):before{content:"\u2013";inset-inline-start:-1rem;position:absolute}:host(cds-unordered-list[slot=nested]) ::slotted(cds-list-item):before{content:"\u25AA";inset-inline-start:-.75rem}:host(cds-list-item){color:var(--cds-text-primary,#161616);display:list-item}:host(cds-list-item):before{content:var(--cds-ce--list-marker,none);inset-inline-start:-1rem;position:absolute}:host(cds-list-item[nested]){margin-block:0}:host(cds-list-item[nested]) .cds-ce--list__item__nested-child{padding-block-start:0}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"NqxXT":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSOrderedList$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _unorderedListJs = require("./unordered-list.js");
var _unorderedListJsDefault = parcelHelpers.interopDefault(_unorderedListJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Ordered list.
 */ let CDSOrderedList = class CDSOrderedList extends (0, _unorderedListJsDefault.default) {
    constructor(){
        super(...arguments);
        /**
         * Specify whether the ordered list should use native list styles instead of
         * custom counter
         */ this.native = false;
    }
    render() {
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--list--ordered`]: !this.native,
            [`${0, _settingsJs.prefix}--list--ordered--native`]: this.native,
            [`${0, _settingsJs.prefix}--list--nested`]: this.getAttribute("slot") === "nested",
            [`${0, _settingsJs.prefix}--list--expressive`]: this.isExpressive
        });
        return (0, _lit.html)`
      <ol class="${classes}">
        <slot></slot>
      </ol>
    `;
    }
};
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSOrderedList.prototype, "native", void 0);
CDSOrderedList = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-ordered-list`)
], CDSOrderedList);
var CDSOrderedList$1 = CDSOrderedList;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./unordered-list.js":"fM8D6","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fM8D6":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSUnorderedList$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _listScssJs = require("./list.scss.js");
var _listScssJsDefault = parcelHelpers.interopDefault(_listScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Ordered list.
 */ let CDSUnorderedList = class CDSUnorderedList extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if expressive theme enabled.
         */ this.isExpressive = false;
    }
    connectedCallback() {
        // Uses attribute for lookup from child
        if (this.closest(this.constructor.selectorListItem)) this.setAttribute("slot", "nested");
        else this.removeAttribute("slot");
        super.connectedCallback();
    }
    render() {
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--list--unordered`]: true,
            [`${0, _settingsJs.prefix}--list--nested`]: this.getAttribute("slot") === "nested",
            [`${0, _settingsJs.prefix}--list--expressive`]: this.isExpressive
        });
        return (0, _lit.html)`
      <ul class="${classes}">
        <slot></slot>
      </ul>
    `;
    }
    /**
     * A selector that will return list item.
     */ static get selectorListItem() {
        return `${0, _settingsJs.prefix}-list-item`;
    }
};
CDSUnorderedList.styles = (0, _listScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSUnorderedList.prototype, "isExpressive", void 0);
CDSUnorderedList = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-unordered-list`)
], CDSUnorderedList);
var CDSUnorderedList$1 = CDSUnorderedList;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./list.scss.js":"4MZck","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fOxrn":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _loadingJs = require("./loading.js");
var _lit = require("lit");
var _defsJs = require("./defs.js");

},{"./loading.js":"jiOnP","lit":"aCmte","./defs.js":"ebnHh"}],"1KZwa":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _multiSelectJs = require("./multi-select.js");
var _multiSelectItemJs = require("./multi-select-item.js");

},{"./multi-select.js":"hFvTI","./multi-select-item.js":"c3M5O"}],"hFvTI":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SELECTION_FEEDBACK_OPTION", ()=>(0, _defsJs.SELECTION_FEEDBACK_OPTION));
parcelHelpers.export(exports, "DROPDOWN_DIRECTION", ()=>(0, _defsJs1.DROPDOWN_DIRECTION));
parcelHelpers.export(exports, "DROPDOWN_SIZE", ()=>(0, _defsJs1.DROPDOWN_SIZE));
parcelHelpers.export(exports, "DROPDOWN_TYPE", ()=>(0, _defsJs1.DROPDOWN_TYPE));
parcelHelpers.export(exports, "default", ()=>CDSMultiSelect$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _classMapJs = require("lit/directives/class-map.js");
var _16Js = require("../../icons/close/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _settingsJs = require("../../globals/settings.js");
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _dropdownJs = require("../dropdown/dropdown.js");
var _dropdownJsDefault = parcelHelpers.interopDefault(_dropdownJs);
var _defsJs = require("./defs.js");
var _multiSelectScssJs = require("./multi-select.scss.js");
var _multiSelectScssJsDefault = parcelHelpers.interopDefault(_multiSelectScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs1 = require("../dropdown/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Multi select.
 *
 * @element cds-multi-select
 * @fires cds-multi-select-beingselected
 *   The custom event fired before a multi select item is selected upon a user gesture.
 *   Cancellation of this event stops changing the user-initiated selection.
 * @fires cds-multi-select-selected - The custom event fired after a multi select item is selected upon a user gesture.
 * @fires cds-multi-select-beingtoggled
 *   The custom event fired before the open state of this multi select is toggled upon a user gesture.
 *   Cancellation of this event stops the user-initiated toggling.
 * @fires cds-multi-select-toggled
 *   The custom event fired after the open state of this multi select is toggled upon a user gesture.
 */ let CDSMultiSelect = class CDSMultiSelect extends (0, _dropdownJsDefault.default) {
    constructor(){
        super(...arguments);
        /**
         * The count of selected items.
         */ this._selectedItemsCount = 0;
        /**
         * The `aria-label` attribute for the icon to clear selection.
         */ this.clearSelectionLabel = "";
        /**
         * Specify the text that should be read for screen readers that describes total items selected
         */ this.clearSelectionDescription = "Total items selected: ";
        /**
         * Specify the text that should be read for screen readers to clear selection.
         */ this.clearSelectionText = "To clear selection, press Delete or Backspace.";
        /**
         * Specify the locale of the control. Used for the default compareItems used for sorting the list of items in the control.
         */ this.locale = "en";
        /**
         * Specify feedback (mode) of the selection.
         * `top`: selected item jumps to top
         * `fixed`: selected item stays at it's position
         * `top-after-reopen`: selected item jump to top after reopen dropdown
         */ this.selectionFeedback = (0, _defsJs.SELECTION_FEEDBACK_OPTION).TOP_AFTER_REOPEN;
        this.compareItems = (itemA, itemB, { locale })=>{
            itemA.localeCompare(itemB, locale, {
                numeric: true
            });
        };
        this.sortItems = (menuItems, { values, compareItems, locale = "en" })=>{
            const menuItemsArray = Array.from(menuItems);
            const sortedArray = menuItemsArray.sort((itemA, itemB)=>{
                const hasItemA = values.includes(itemA.value);
                const hasItemB = values.includes(itemB.value);
                // Prefer whichever item is in the `value` array first
                if (hasItemA && !hasItemB) return -1;
                if (hasItemB && !hasItemA) return 1;
                return compareItems(itemA.value, itemB.value, {
                    locale
                });
            });
            return sortedArray;
        };
    }
    _selectionShouldChange(itemToSelect) {
        // If we are selecting an item, assumes we always toggle
        return Boolean(this.value || itemToSelect);
    }
    _selectionDidChange(itemToSelect) {
        if (itemToSelect) itemToSelect.selected = !itemToSelect.selected;
        else {
            (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorItemSelected), (item)=>{
                item.selected = false;
            });
            this._handleUserInitiatedToggle(false);
        }
        // Change in `.selected` hasn't been reflected to the corresponding attribute yet
        this.value = (0, _collectionHelpersJs.filter)(this.querySelectorAll(this.constructor.selectorItem), (item)=>item.selected).map((item)=>item.value).join(",");
    }
    _handleClickInner(event) {
        var _a, _b, _c, _d;
        if (((_a = this._selectionButtonNode) === null || _a === void 0 ? void 0 : _a.contains(event.target)) && !this.readOnly) {
            this._handleUserInitiatedSelectItem();
            if (this.filterable) this._filterInputNode.focus();
            else this._triggerNode.focus();
        } else if ((_b = this._clearButtonNode) === null || _b === void 0 ? void 0 : _b.contains(event.target)) this._handleUserInitiatedClearInput();
        else if (!((_c = event.target) === null || _c === void 0 ? void 0 : _c.matches(this.constructor.aiLabelItem)) && // remove reference to slug in v12
        !((_d = event.target) === null || _d === void 0 ? void 0 : _d.matches(this.constructor.slugItem))) {
            super._handleClickInner(event);
            if (this.filterable) this._filterInputNode.focus();
        }
    }
    /**
     * Handler for the `keypress` event, ensures filter still works upon entering space
     */ _handleKeypressInner(event) {
        var _a, _b;
        const { key } = event;
        const action = this.constructor.getAction(key);
        const { TRIGGERING } = (0, _defsJs1.DROPDOWN_KEYBOARD_ACTION);
        if (((_a = this._clearButtonNode) === null || _a === void 0 ? void 0 : _a.contains(event.target)) && // Space key should be handled by `<input>` unless "clear selection" button has focus
        (action === TRIGGERING || key === " ")) this._handleUserInitiatedClearInput();
        else if ((_b = this._selectionButtonNode) === null || _b === void 0 ? void 0 : _b.contains(event.target)) {
            this._handleUserInitiatedSelectItem();
            this.open = true;
            if (this.filterable) this._filterInputNode.focus();
            else this._triggerNode.focus();
        } else if (this.filterable) this._handleKeypressInnerFlterable(event);
        else super._handleKeypressInner(event);
    }
    /**
     * Special andler for the `keypress` event, ensures space selection for filterable
     * variation is disabled
     */ _handleKeypressInnerFlterable(event) {
        const { key } = event;
        const action = this.constructor.getAction(key);
        if (!this.open) switch(action){
            case (0, _defsJs1.DROPDOWN_KEYBOARD_ACTION).TRIGGERING:
                this._handleUserInitiatedToggle(true);
                break;
        }
        else switch(key){
            case "Enter":
                {
                    const constructor = this.constructor;
                    const highlightedItem = this.querySelector(constructor.selectorItemHighlighted);
                    if (highlightedItem) this._handleUserInitiatedSelectItem(highlightedItem);
                    else this._handleUserInitiatedToggle(false);
                }
                break;
        }
    }
    _renderTitleLabel() {
        const { clearSelectionDescription, clearSelectionText, disabled, hideLabel, titleText, _selectedItemsCount: selectedItemsCount, _slotTitleTextNode: slotTitleTextNode, _handleSlotchangeLabelText: handleSlotchangeLabelText } = this;
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--label`]: true,
            [`${0, _settingsJs.prefix}--label--disabled`]: disabled,
            [`${0, _settingsJs.prefix}--visually-hidden`]: hideLabel
        });
        const hasTitleText = titleText || slotTitleTextNode && slotTitleTextNode.assignedNodes().length > 0;
        return (0, _lit.html)`
      <label
        part="title-text"
        class="${labelClasses}"
        ?hidden="${!hasTitleText}">
        <slot name="title-text" @slotchange="${handleSlotchangeLabelText}"
          >${titleText}</slot
        >
        ${selectedItemsCount > 0 ? (0, _lit.html)`
              <span class="${0, _settingsJs.prefix}--visually-hidden">
                ${clearSelectionDescription} ${selectedItemsCount},
                ${clearSelectionText}
              </span>
            ` : null}
      </label>
    `;
    }
    _renderPrecedingLabel() {
        const { disabled, readOnly, clearSelectionLabel, _selectedItemsCount: selectedItemsCount } = this;
        const selectionButtonClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--list-box__selection`]: true,
            [`${0, _settingsJs.prefix}--list-box__selection--multi`]: true,
            [`${0, _settingsJs.prefix}--tag`]: true,
            [`${0, _settingsJs.prefix}--tag--filter`]: true,
            [`${0, _settingsJs.prefix}--tag--high-contrast`]: true,
            [`${0, _settingsJs.prefix}--tag--disabled`]: disabled
        });
        return selectedItemsCount === 0 ? undefined : (0, _lit.html)`
          <div
            id="selection-button"
            role="button"
            class="${selectionButtonClasses}"
            tabindex="-1"
            aria-disabled=${readOnly}
            title="${clearSelectionLabel}">
            ${selectedItemsCount}
            ${(0, _16JsDefault.default)({
            "aria-label": clearSelectionLabel,
            class: `${(0, _settingsJs.prefix)}--tag__close-icon`
        })}
          </div>
        `;
    }
    /**
      @returns The main content of the trigger button.
     */ _renderLabel() {
        const { label, value, _selectedItemContent: selectedItemContent } = this;
        const inputClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--text-input`]: true,
            [`${0, _settingsJs.prefix}--text-input--empty`]: !value
        });
        return !this.filterable ? (0, _lit.html)`
          <span id="trigger-label" class="${0, _settingsJs.prefix}--list-box__label"
            >${selectedItemContent || label}</span
          >
        ` : (0, _lit.html)`
          <input
            id="trigger-label"
            class="${inputClasses}"
            placeholder="${label}"
            role="combobox"
            aria-controls="menu-body"
            aria-autocomplete="list"
            @input="${this._handleInput}" />
        `;
    }
    _renderFollowingLabel() {
        const { clearSelectionLabel, _filterInputNode: filterInputNode } = this;
        return filterInputNode && filterInputNode.value.length > 0 && this.filterable ? (0, _lit.html)`
          <div
            id="clear-button"
            role="button"
            class="${0, _settingsJs.prefix}--list-box__selection"
            tabindex="0"
            title="${clearSelectionLabel}">
            ${(0, _16JsDefault.default)({
            "aria-label": clearSelectionLabel
        })}
          </div>
        ` : undefined;
    }
    /**
     * Handles `input` event on the `<input>` for filtering.
     */ _handleInput() {
        const items = this.querySelectorAll(this.constructor.selectorItem);
        const inputValue = this._filterInputNode.value.toLocaleLowerCase();
        if (!this.open) this.open = true;
        (0, _collectionHelpersJs.forEach)(items, (item)=>{
            const itemValue = item.innerText.toLocaleLowerCase();
            if (!itemValue.includes(inputValue)) {
                item.setAttribute("filtered", "");
                item.removeAttribute("highlighted");
            } else item.removeAttribute("filtered");
        });
        this.requestUpdate();
    }
    /**
     * Navigate through dropdown items.
     *
     * @param direction `-1` to navigate backward, `1` to navigate forward.
     */ _navigate(direction) {
        if (!this.filterable) super._navigate(direction);
        else {
            // only navigate through remaining item
            const constructor = this.constructor;
            const items = this.querySelectorAll(constructor.selectorItemResults);
            const highlightedItem = this.querySelector(constructor.selectorItemHighlighted);
            const highlightedIndex = (0, _collectionHelpersJs.indexOf)(items, highlightedItem);
            let nextIndex = highlightedIndex + direction;
            if (nextIndex < 0) nextIndex = items.length - 1;
            if (nextIndex >= items.length) nextIndex = 0;
            (0, _collectionHelpersJs.forEach)(items, (item, i)=>{
                item.highlighted = i === nextIndex;
            });
        }
    }
    /**
     * Handles user-initiated clearing the `<input>` for filtering.
     */ _handleUserInitiatedClearInput() {
        const constructor = this.constructor;
        const items = this.querySelectorAll(constructor.selectorItemFiltered);
        this._filterInputNode.value = "";
        this.open = true;
        this._filterInputNode.focus();
        (0, _collectionHelpersJs.forEach)(items, (item)=>{
            item.removeAttribute("filtered");
        });
    }
    /**
     * The CSS class list for multi-select listbox
     */ get _classes() {
        const { disabled, size, type, invalid, readOnly, open, warn, _selectedItemsCount: selectedItemsCount } = this;
        const inline = type === (0, _defsJs1.DROPDOWN_TYPE).INLINE;
        return (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--multi-select`]: true,
            [`${0, _settingsJs.prefix}--list-box`]: true,
            [`${0, _settingsJs.prefix}--list-box--disabled`]: disabled,
            [`${0, _settingsJs.prefix}--list-box--inline`]: inline,
            [`${0, _settingsJs.prefix}--list-box--expanded`]: open,
            [`${0, _settingsJs.prefix}--list-box--${size}`]: size,
            [`${0, _settingsJs.prefix}--multi-select--invalid`]: invalid,
            [`${0, _settingsJs.prefix}--multi-select--warn`]: warn,
            [`${0, _settingsJs.prefix}--multi-select--inline`]: inline,
            [`${0, _settingsJs.prefix}--multi-select--readonly`]: readOnly,
            [`${0, _settingsJs.prefix}--multi-select--selected`]: selectedItemsCount > 0
        });
    }
    shouldUpdate(changedProperties) {
        const { selectorItem, aiLabelItem, slugItem } = this.constructor;
        const aiLabel = this.querySelector(aiLabelItem) || this.querySelector(slugItem);
        const items = this.querySelectorAll(selectorItem);
        const { value, locale } = this;
        const values = !value ? [] : value.split(",");
        if (changedProperties.has("size")) (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorItem), (elem)=>{
            elem.size = this.size;
        });
        if (changedProperties.has("value")) {
            // Updates selection beforehand because our rendering logic for `<cds-multi-select>` looks for selected items via `qSA()`
            (0, _collectionHelpersJs.forEach)(items, (elem)=>{
                elem.selected = values.indexOf(elem.value) >= 0;
            });
            this._selectedItemsCount = (0, _collectionHelpersJs.filter)(items, (elem)=>values.indexOf(elem.value) >= 0).length;
            if (this.selectionFeedback === (0, _defsJs.SELECTION_FEEDBACK_OPTION).TOP) {
                const sortedMenuItems = this.sortItems(items, {
                    values,
                    compareItems: this.compareItems,
                    locale
                });
                aiLabel && sortedMenuItems.unshift(aiLabel);
                // @todo remove typecast once we've updated to Typescript.
                this.replaceChildren(...sortedMenuItems);
            }
        }
        if (changedProperties.has("open")) {
            if (this.selectionFeedback === (0, _defsJs.SELECTION_FEEDBACK_OPTION).TOP_AFTER_REOPEN) {
                const sortedMenuItems = this.sortItems(items, {
                    values,
                    compareItems: this.compareItems,
                    locale
                });
                aiLabel && sortedMenuItems.unshift(aiLabel);
                // @todo remove typecast once we've updated to Typescript.
                this.replaceChildren(...sortedMenuItems);
            }
        }
        return true;
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("open") && this.open && !this.filterable) // move focus to menu body when open for non-filterable mulit-select
        this._menuBodyNode.focus();
    }
    connectedCallback() {
        super.connectedCallback();
        /**
         * Detect if multi-select already has initially selected items
         */ this.value = (0, _collectionHelpersJs.filter)(this.querySelectorAll(this.constructor.selectorItem), (item)=>item.selected).map((item)=>item.value).join(",");
    }
    /**
     * A selector that will return menu body.
     */ static get selectorMenuBody() {
        return `div[part="menu-body"]`;
    }
    /**
     * A selector that will return highlighted items.
     */ static get selectorItemHighlighted() {
        return `${0, _settingsJs.prefix}-multi-select-item[highlighted]`;
    }
    /**
     * A selector that will return multi select items.
     * We use a separate property from `.itemTagName` due to the nature in difference of tag name vs. selector.
     */ static get selectorItem() {
        return `${0, _settingsJs.prefix}-multi-select-item`;
    }
    /**
     * A selector that will return remaining items after a filter.
     */ static get selectorItemFiltered() {
        return `${0, _settingsJs.prefix}-multi-select-item[filtered]`;
    }
    /**
     * A selector that will return remaining items after a filter.
     */ static get selectorItemResults() {
        return `${0, _settingsJs.prefix}-multi-select-item:not([filtered])`;
    }
    /**
     * A selector that will return selected items.
     */ static get selectorItemSelected() {
        return `${0, _settingsJs.prefix}-multi-select-item[selected]`;
    }
    /**
     * The name of the custom event fired before this multi select item is being toggled upon a user gesture.
     * Cancellation of this event stops the user-initiated action of toggling this multi select item.
     */ static get eventBeforeToggle() {
        return `${0, _settingsJs.prefix}-multi-select-beingtoggled`;
    }
    /**
     * The name of the custom event fired after this multi select item is toggled upon a user gesture.
     */ static get eventToggle() {
        return `${0, _settingsJs.prefix}-multi-select-toggled`;
    }
    /**
     * The name of the custom event fired before a multi select item is selected upon a user gesture.
     * Cancellation of this event stops changing the user-initiated selection.
     */ static get eventBeforeSelect() {
        return `${0, _settingsJs.prefix}-multi-select-beingselected`;
    }
    /**
     * The name of the custom event fired after a a multi select item is selected upon a user gesture.
     */ static get eventSelect() {
        return `${0, _settingsJs.prefix}-multi-select-selected`;
    }
};
CDSMultiSelect.styles = (0, _multiSelectScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSMultiSelect.prototype, "filterable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#clear-button")
], CDSMultiSelect.prototype, "_clearButtonNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#selection-button")
], CDSMultiSelect.prototype, "_selectionButtonNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#menu-body")
], CDSMultiSelect.prototype, "_menuBodyNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("input")
], CDSMultiSelect.prototype, "_filterInputNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)(`.${(0, _settingsJs.prefix)}--list-box__field`)
], CDSMultiSelect.prototype, "_triggerNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "clear-selection-label"
    })
], CDSMultiSelect.prototype, "clearSelectionLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "clear-selection-description"
    })
], CDSMultiSelect.prototype, "clearSelectionDescription", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "clear-selection-text"
    })
], CDSMultiSelect.prototype, "clearSelectionText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSMultiSelect.prototype, "locale", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "selection-feedback"
    })
], CDSMultiSelect.prototype, "selectionFeedback", void 0);
CDSMultiSelect = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-multi-select`)
], CDSMultiSelect);
var CDSMultiSelect$1 = CDSMultiSelect;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/class-map.js":"2fQud","../../icons/close/16.js":"b7Sho","../../globals/settings.js":"EipuL","../../globals/internal/collection-helpers.js":"4aZkz","../dropdown/dropdown.js":"iHNPo","./defs.js":"02JOa","./multi-select.scss.js":"9zurK","../../globals/decorators/carbon-element.js":"kNhLR","../dropdown/defs.js":"9eS24","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"02JOa":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Multi-select selection feedback options.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SELECTION_FEEDBACK_OPTION", ()=>SELECTION_FEEDBACK_OPTION);
var SELECTION_FEEDBACK_OPTION;
(function(SELECTION_FEEDBACK_OPTION) {
    /**
     * selected item stays at it's position
     */ SELECTION_FEEDBACK_OPTION["FIXED"] = "fixed";
    /**
     * selected item jumps to top
     */ SELECTION_FEEDBACK_OPTION["TOP"] = "top";
    /**
     * selected item jump to top after reopen dropdown
     */ SELECTION_FEEDBACK_OPTION["TOP_AFTER_REOPEN"] = "top-after-reopen";
})(SELECTION_FEEDBACK_OPTION || (SELECTION_FEEDBACK_OPTION = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9zurK":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));background-color:var(--cds-field);block-size:var(--cds-layout-size-height-local);border:none;border-block-end:1px solid var(--cds-border-strong);box-sizing:border-box;color:var(--cds-text-primary,#161616);font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:2px solid transparent;outline-offset:-2px;padding:0;padding:0 var(--cds-layout-density-padding-inline-local);transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--text-input *,.cds--text-input :after,.cds--text-input :before{box-sizing:inherit}.cds--text-input:active,.cds--text-input:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input:active,.cds--text-input:focus{outline-style:dotted}}.cds--text-input-wrapper svg[hidden]{display:none}.cds--password-input{padding-inline-end:2.5rem}.cds--text-input--sm.cds--password-input{padding-inline-end:2rem}.cds--text-input--lg.cds--password-input{padding-inline-end:3rem}.cds--text-input::-moz-placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input::placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input--light{background-color:var(--cds-field-02,#fff)}.cds--text-input__field-wrapper{display:flex;inline-size:100%;position:relative}.cds--text-input__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:1rem;transform:translateY(-50%)}.cds--text-input__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--text-input__invalid-icon--warning path:first-of-type{fill:#000;opacity:1}.cds--text-input--password__visibility{align-items:center;cursor:pointer;display:inline-flex;overflow:visible;position:relative}.cds--text-input--password__visibility:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus{outline-style:dotted}}.cds--text-input--password__visibility:focus{outline:1px solid transparent}.cds--text-input--password__visibility:focus svg{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus svg{outline-style:dotted}}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{align-items:center;display:flex;opacity:0;pointer-events:none;position:absolute;z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{display:inline-block}}.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:opacity 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:none}}.cds--text-input--password__visibility.cds--tooltip--a11y:after,.cds--text-input--password__visibility.cds--tooltip--a11y:before{transition:none}.cds--text-input--password__visibility:before{block-size:0;border-style:solid;content:"";inline-size:0}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text{box-sizing:content-box;color:inherit;opacity:1;white-space:normal;word-break:break-word}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);max-inline-size:13rem;min-inline-size:1.5rem;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-accelerator:true){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{border:1px solid transparent}}.cds--text-input--password__visibility:after{content:attr(aria-label)}.cds--text-input--password__visibility.cds--tooltip--a11y:after{content:none}.cds--text-input--password__visibility.cds--tooltip--visible:after,.cds--text-input--password__visibility.cds--tooltip--visible:before,.cds--text-input--password__visibility:focus:after,.cds--text-input--password__visibility:focus:before,.cds--text-input--password__visibility:hover:after,.cds--text-input--password__visibility:hover:before{opacity:1}@keyframes cds--tooltip-fade{0%{opacity:0}to{opacity:1}}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text{margin:auto;overflow:visible;clip:auto}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible.cds--tooltip--a11y:before,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:focus.cds--tooltip--a11y:before,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text,.cds--text-input--password__visibility:hover.cds--tooltip--a11y:before{animation:cds--tooltip-fade 70ms cubic-bezier(.2,0,.38,.9)}.cds--text-input--password__visibility.cds--tooltip--hidden .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--hidden+.cds--assistive-text{margin:-1px;overflow:hidden;clip:rect(0,0,0,0)}.cds--text-input--password__visibility.cds--tooltip--hidden.cds--tooltip--a11y:before{animation:none;opacity:0}.cds--text-input--password__visibility .cds--assistive-text:after{block-size:.75rem;content:"";display:block;inline-size:100%;inset-block-start:-.75rem;inset-inline-start:0;position:absolute}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{inset-block-end:0;inset-inline-start:50%}.cds--text-input--password__visibility:before{border-color:transparent transparent var(--cds-background-inverse,#393939);border-width:0 .25rem .3125rem;inset-block-end:-.5rem;transform:translate(-50%,100%)}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inset-block-end:-.8125rem;transform:translate(-50%,100%)}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{align-items:center;background:none;block-size:100%;border:0;cursor:pointer;display:flex;inline-size:2.5rem;inset-inline-end:0;justify-content:center;min-block-size:auto;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--toggle-password-tooltip .cds--popover{inset-inline-start:-2.5rem}.cds--toggle-password-tooltip .cds--popover-content{min-inline-size:2.5rem}.cds--text-input--sm+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:2rem}.cds--text-input--lg+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:3rem}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252);transition:fill 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:ButtonText}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline-style:dotted}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus svg,.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-primary,#161616)}.cds--text-input--invalid,.cds--text-input--warning{padding-inline-end:2.5rem}.cds--text-input--invalid.cds--password-input{padding-inline-end:4rem}.cds--text-input--invalid+.cds--text-input--password__visibility__toggle{inset-inline-end:1rem}.cds--password-input-wrapper .cds--text-input__invalid-icon{inset-inline-end:2.5rem}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{cursor:not-allowed}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg:hover{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input__counter-alert{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px}.cds--text-input:disabled{background-color:var(--cds-field);border-block-end:1px solid transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;outline:2px solid transparent;outline-offset:-2px;-webkit-text-fill-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input--light:disabled{background-color:var(--cds-field-02,#fff)}.cds--text-input:disabled::-moz-placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input:disabled::placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input--invalid{box-shadow:none;outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input--invalid{outline-style:dotted}}.cds--text-input--invalid .cds--text-input--password__visibility__toggle{inset-inline-end:2.5rem}.cds--skeleton.cds--text-input{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;padding:0;pointer-events:none;position:relative}.cds--skeleton.cds--text-input:active,.cds--skeleton.cds--text-input:focus,.cds--skeleton.cds--text-input:hover{border:none;cursor:default;outline:none}.cds--skeleton.cds--text-input:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--skeleton.cds--text-input:before{animation:none}}.cds--form--fluid .cds--text-input-wrapper{background:var(--cds-field);position:relative;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--form--fluid .cds--label{align-items:center;block-size:1rem;display:flex;inset-block-start:.8125rem;inset-inline-start:1rem;margin:0;position:absolute;z-index:1}.cds--form--fluid .cds--form__helper-text{display:none}.cds--form--fluid .cds--text-input{min-block-size:4rem;padding:2rem 1rem .8125rem}.cds--form--fluid .cds--text-input__divider,.cds--text-input__divider{display:none}.cds--form--fluid .cds--text-input--invalid,.cds--form--fluid .cds--text-input--warning{border-block-end:none}.cds--form--fluid .cds--text-input--invalid+.cds--text-input__divider,.cds--form--fluid .cds--text-input--warning+.cds--text-input__divider{border-color:var(--cds-border-subtle);border-style:solid;border-block-end:none;display:block;margin:0 1rem}.cds--form--fluid .cds--text-input__invalid-icon{inset-block-start:5rem}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid{outline:none}.cds--form--fluid .cds--text-input__field-wrapper--warning{border-block-end:1px solid var(--cds-border-strong)}.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning:focus,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:focus{outline:none}.cds--text-input-wrapper.cds--text-input-wrapper--inline{flex-flow:row wrap}.cds--text-input-wrapper .cds--label--inline{flex:1;margin:.8125rem 0 0;overflow-wrap:break-word;word-break:break-word}.cds--text-input-wrapper .cds--label--inline--sm{margin-block-start:.5625rem}.cds--text-input-wrapper .cds--label--inline--lg{margin-block-start:1.0625rem}.cds--text-input__label-helper-wrapper{flex:2;flex-direction:column;margin-inline-end:1.5rem;max-inline-size:8rem;overflow-wrap:break-word}.cds--text-input-wrapper .cds--form__helper-text--inline{margin-block-start:.125rem}.cds--text-input__field-outer-wrapper{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;inline-size:100%}.cds--text-input__field-outer-wrapper--inline{flex:8;flex-direction:column}.cds--text-input-wrapper--inline .cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--text-input-wrapper--inline--invalid .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input-wrapper--readonly,.cds--text-input-wrapper--readonly .cds--text-input{background:transparent;border-block-end-color:var(--cds-border-subtle)}.cds--text-input__field-wrapper .cds--ai-label,.cds--text-input__field-wrapper .cds--slug,.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator>*{inset-block-start:50%;inset-inline-end:1rem;position:absolute;transform:translateY(-50%)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label):not(:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug):not(:has(~.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug){padding-inline-end:2.5rem}.cds--text-input--invalid:has(~.cds--ai-label),.cds--text-input--invalid:has(~.cds--slug),.cds--text-input--invalid:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input--warning:has(~.cds--ai-label),.cds--text-input--warning:has(~.cds--slug),.cds--text-input--warning:has(~.cds--text-input__field-inner-wrapper--decorator>*){padding-inline-end:4rem}.cds--text-input--invalid~.cds--ai-label,.cds--text-input--invalid~.cds--slug,.cds--text-input--invalid~.cds--text-input__field-inner-wrapper--decorator>*,.cds--text-input--warning~.cds--ai-label,.cds--text-input--warning~.cds--slug,.cds--text-input--warning~.cds--text-input__field-inner-wrapper--decorator>*{inset-inline-end:2.5rem}.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator:not(:has(.cds--ai-label))>*{block-size:1rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:ButtonText}}.cds--text-input__label-wrapper{display:flex;inline-size:100%;justify-content:space-between}.cds--text-input__label-wrapper .cds--text-input__label-counter{align-self:end}.cds--tag{--cds-layout-size-height-xs:1.125rem;--cds-layout-size-height-sm:1.125rem;--cds-layout-size-height-md:1.5rem;--cds-layout-size-height-lg:2rem;--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));align-items:center;background-color:var(--cds-tag-background-gray,#e0e0e0);border-radius:1rem;color:var(--cds-tag-color-gray,#161616);cursor:default;display:inline-flex;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem;max-inline-size:13rem;min-block-size:var(--cds-layout-size-height-local);min-inline-size:2rem;padding-inline:.5rem;vertical-align:middle;word-break:break-word}.cds--layout--size-xs .cds--tag{--cds-layout-size-height:var(--cds-layout-size-height-xs)}.cds--layout--size-sm .cds--tag{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--tag{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--tag{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--tag.cds--tag--operational{border:1px solid var(--cds-tag-background-gray,#e0e0e0)}.cds--tag .cds--tag__close-icon:hover,.cds--tag.cds--tag--operational:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1)}.cds--tag.cds--tag--lg{padding-inline-start:.75rem}.cds--tag:has(.cds--tag__custom-icon){padding-inline-start:.25rem}.cds--tag.cds--tag--lg:not(.cds--tag--filter){padding-inline:.75rem}.cds--tag.cds--tag--lg:has(.cds--tag__custom-icon){padding-inline-start:.5rem}.cds--tag:not(.cds--tag--selectable){border:0}.cds--tag:not(:first-child){margin-inline-start:0}.cds--tag--operational>span,.cds--tag--selectable>span,.cds--tag__label{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cds--tag--interactive:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--tag--filter{padding-block:0;padding-inline-end:0}.cds--tag--filter:hover{outline:none}.cds--tag--selectable{background-color:var(--cds-layer);border:1px solid var(--cds-border-inverse,#161616);color:var(--cds-text-primary,#161616);cursor:pointer}.cds--tag--selectable:hover{background-color:var(--cds-layer-hover);outline:none}.cds--tag--selectable:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--tag--selectable-selected{color:var(--cds-text-inverse,#fff)}.cds--tag--selectable-selected,.cds--tag--selectable-selected:hover{background-color:var(--cds-layer-selected-inverse,#161616)}.cds--tag--operational{background-color:var(--cds-tag-background-gray,#e0e0e0);border:1px solid var(--cds-tag-border-gray,#a8a8a8);color:var(--cds-tag-color-gray,#161616);cursor:pointer}.cds--tag--operational:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1);outline:none}.cds--tag--operational:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--tag--red{background-color:var(--cds-tag-background-red,#ffd7d9);color:var(--cds-tag-color-red,#a2191f)}.cds--tag--red.cds--tag--operational{border:1px solid var(--cds-tag-border-red,#ff8389)}.cds--tag--red .cds--tag__close-icon:hover,.cds--tag--red.cds--tag--operational:hover{background-color:var(--cds-tag-hover-red,#ffc2c5)}.cds--tag--magenta{background-color:var(--cds-tag-background-magenta,#ffd6e8);color:var(--cds-tag-color-magenta,#9f1853)}.cds--tag--magenta.cds--tag--operational{border:1px solid var(--cds-tag-border-magenta,#ff7eb6)}.cds--tag--magenta .cds--tag__close-icon:hover,.cds--tag--magenta.cds--tag--operational:hover{background-color:var(--cds-tag-hover-magenta,#ffbdda)}.cds--tag--purple{background-color:var(--cds-tag-background-purple,#e8daff);color:var(--cds-tag-color-purple,#6929c4)}.cds--tag--purple.cds--tag--operational{border:1px solid var(--cds-tag-border-purple,#be95ff)}.cds--tag--purple .cds--tag__close-icon:hover,.cds--tag--purple.cds--tag--operational:hover{background-color:var(--cds-tag-hover-purple,#dcc7ff)}.cds--tag--blue{background-color:var(--cds-tag-background-blue,#d0e2ff);color:var(--cds-tag-color-blue,#0043ce)}.cds--tag--blue.cds--tag--operational{border:1px solid var(--cds-tag-border-blue,#78a9ff)}.cds--tag--blue .cds--tag__close-icon:hover,.cds--tag--blue.cds--tag--operational:hover{background-color:var(--cds-tag-hover-blue,#b8d3ff)}.cds--tag--cyan{background-color:var(--cds-tag-background-cyan,#bae6ff);color:var(--cds-tag-color-cyan,#00539a)}.cds--tag--cyan.cds--tag--operational{border:1px solid var(--cds-tag-border-cyan,#33b1ff)}.cds--tag--cyan .cds--tag__close-icon:hover,.cds--tag--cyan.cds--tag--operational:hover{background-color:var(--cds-tag-hover-cyan,#99daff)}.cds--tag--teal{background-color:var(--cds-tag-background-teal,#9ef0f0);color:var(--cds-tag-color-teal,#005d5d)}.cds--tag--teal.cds--tag--operational{border:1px solid var(--cds-tag-border-teal,#08bdba)}.cds--tag--teal .cds--tag__close-icon:hover,.cds--tag--teal.cds--tag--operational:hover{background-color:var(--cds-tag-hover-teal,#57e5e5)}.cds--tag--green{background-color:var(--cds-tag-background-green,#a7f0ba);color:var(--cds-tag-color-green,#0e6027)}.cds--tag--green.cds--tag--operational{border:1px solid var(--cds-tag-border-green,#42be65)}.cds--tag--green .cds--tag__close-icon:hover,.cds--tag--green.cds--tag--operational:hover{background-color:var(--cds-tag-hover-green,#74e792)}.cds--tag--gray{background-color:var(--cds-tag-background-gray,#e0e0e0);color:var(--cds-tag-color-gray,#161616)}.cds--tag--gray.cds--tag--operational{border:1px solid var(--cds-tag-border-gray,#a8a8a8)}.cds--tag--gray .cds--tag__close-icon:hover,.cds--tag--gray.cds--tag--operational:hover{background-color:var(--cds-tag-hover-gray,#d1d1d1)}.cds--tag--cool-gray{background-color:var(--cds-tag-background-cool-gray,#dde1e6);color:var(--cds-tag-color-cool-gray,#121619)}.cds--tag--cool-gray.cds--tag--operational{border:1px solid var(--cds-tag-border-cool-gray,#a2a9b0)}.cds--tag--cool-gray .cds--tag__close-icon:hover,.cds--tag--cool-gray.cds--tag--operational:hover{background-color:var(--cds-tag-hover-cool-gray,#cdd3da)}.cds--tag--warm-gray{background-color:var(--cds-tag-background-warm-gray,#e5e0df);color:var(--cds-tag-color-warm-gray,#171414)}.cds--tag--warm-gray.cds--tag--operational{border:1px solid var(--cds-tag-border-warm-gray,#ada8a8)}.cds--tag--warm-gray .cds--tag__close-icon:hover,.cds--tag--warm-gray.cds--tag--operational:hover{background-color:var(--cds-tag-hover-warm-gray,#d8d0cf)}.cds--tag--high-contrast:not(.cds--tag--operational){background-color:var(--cds-background-inverse,#393939);color:var(--cds-text-inverse,#fff)}.cds--tag--high-contrast:not(.cds--tag--operational).cds--tag--operational{border:1px solid var(--cds-background-inverse,#393939)}.cds--tag--high-contrast:not(.cds--tag--operational) .cds--tag__close-icon:hover,.cds--tag--high-contrast:not(.cds--tag--operational).cds--tag--operational:hover{background-color:var(--cds-background-inverse-hover,#474747)}.cds--multi-select--readonly .cds--tag--high-contrast:not(.cds--tag--operational) .cds--tag__close-icon:hover{background-color:transparent}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]){background-color:var(--cds-background,#fff);color:var(--cds-text-primary,#161616);outline:1px solid var(--cds-background-inverse,#393939);outline-offset:-1px}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]).cds--tag--operational{border:1px solid var(--cds-background,#fff)}.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]) .cds--tag__close-icon:hover,.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]).cds--tag--operational:hover{background-color:var(--cds-layer-hover)}.cds--tag--disabled:not(.cds--tag--operational),.cds--tag--filter.cds--tag--disabled,.cds--tag--interactive.cds--tag--disabled{background-color:var(--cds-layer);box-shadow:none;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--tag--disabled:not(.cds--tag--operational).cds--tag--operational,.cds--tag--filter.cds--tag--disabled.cds--tag--operational,.cds--tag--interactive.cds--tag--disabled.cds--tag--operational{border:1px solid var(--cds-layer)}.cds--tag--disabled:not(.cds--tag--operational) .cds--tag__close-icon:hover,.cds--tag--disabled:not(.cds--tag--operational).cds--tag--operational:hover,.cds--tag--filter.cds--tag--disabled .cds--tag__close-icon:hover,.cds--tag--filter.cds--tag--disabled.cds--tag--operational:hover,.cds--tag--interactive.cds--tag--disabled .cds--tag__close-icon:hover,.cds--tag--interactive.cds--tag--disabled.cds--tag--operational:hover{background-color:var(--cds-layer)}.cds--tag--disabled:not(.cds--tag--operational):hover,.cds--tag--filter.cds--tag--disabled:hover,.cds--tag--interactive.cds--tag--disabled:hover{cursor:not-allowed}.cds--tag--disabled:not(.cds--tag--operational) .cds--tag__label,.cds--tag--filter.cds--tag--disabled .cds--tag__label,.cds--tag--interactive.cds--tag--disabled .cds--tag__label{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--tag--operational.cds--tag--disabled,.cds--tag--selectable.cds--tag--disabled{background-color:var(--cds-layer);border:1px solid var(--cds-border-disabled,#c6c6c6);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--tag--operational.cds--tag--disabled:hover,.cds--tag--selectable.cds--tag--disabled:hover{background-color:var(--cds-layer);cursor:not-allowed}.cds--tag--interactive{transition:background-color 70ms cubic-bezier(0,0,.38,.9)}.cds--tag__close-icon{align-items:center;background-color:transparent;block-size:var(--cds-layout-size-height-local);border:0;border-radius:50%;color:currentColor;cursor:pointer;display:flex;flex-shrink:0;inline-size:var(--cds-layout-size-height-local);justify-content:center;margin:0 0 0 .125rem;padding:0;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),box-shadow 70ms cubic-bezier(.2,0,.38,.9)}.cds--tag__close-icon svg{fill:currentColor}.cds--tag__custom-icon{background-color:transparent;block-size:1rem;border:0;color:currentColor;flex-shrink:0;inline-size:1rem;margin-inline-end:.25rem;outline:none;padding:0}.cds--tag__custom-icon svg{fill:currentColor}.cds--tag--disabled .cds--tag__close-icon{cursor:not-allowed}.cds--tag__close-icon:focus{border-radius:50%;box-shadow:inset 0 0 0 1px var(--cds-focus,#0f62fe);outline:none;z-index:99999}.cds--tag--high-contrast .cds--tag__close-icon:focus{box-shadow:inset 0 0 0 1px var(--cds-focus-inverse,#fff)}.cds--tag--filter.cds--tag--disabled .cds--tag__close-icon:hover{background-color:transparent}.cds--tag--filter.cds--tag--disabled svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--tag--sm.cds--tag--filter{padding-inline-end:0}.cds--tag--sm .cds--tag__close-icon{margin-inline-start:.3125rem}.cds--tag.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);background-color:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;color:var(--cds-text-primary,#161616);inline-size:3.75rem;overflow:hidden;padding:0;pointer-events:none;position:relative}.cds--tag.cds--skeleton:active,.cds--tag.cds--skeleton:focus,.cds--tag.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--tag.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--tag.cds--skeleton:before{animation:none}}.cds--tag.cds--skeleton.cds--tag--operational{border:1px solid var(--cds-skeleton-background,#e8e8e8)}.cds--tag.cds--skeleton .cds--tag__close-icon:hover,.cds--tag.cds--skeleton.cds--tag--operational:hover{background-color:var(--cds-skeleton-background,#e8e8e8)}@media not all and (min-resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){.cds--tag.cds--skeleton{transform:translateZ(0)}}}.cds--tag .cds--ai-label .cds--ai-label__button--inline,.cds--tag .cds--slug .cds--slug__button--inline{color:currentColor;margin-inline-start:.0625rem}.cds--tag .cds--ai-label .cds--ai-label__button--inline .cds--ai-label__text:before,.cds--tag .cds--slug .cds--slug__button--inline .cds--slug__text:before{background-color:currentColor}.cds--tag .cds--ai-label .cds--ai-label__button--inline:hover,.cds--tag .cds--slug .cds--slug__button--inline:hover{border-color:currentColor}.cds--tag--filter .cds--ai-label,.cds--tag--filter .cds--slug,.cds--tag--filter .cds--tag__decorator>*{min-inline-size:2.00875rem}.cds--tag .cds--tag__decorator:not(:has(.cds--ai-label)){block-size:1rem;text-align:center}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--tag{outline:1px solid transparent}.cds--tag__close-icon svg,.cds--tag__custom-icon svg{fill:ButtonText}.cds--tag__close-icon:focus{color:Highlight;outline:1px solid Highlight}}.cds--tag-label-tooltip{max-inline-size:-webkit-fill-available}.cds--tag__custom-icon+.cds--tag-label-tooltip{max-inline-size:11rem}.cds--tag--filter .cds--tag__custom-icon+.cds--tag-label-tooltip{max-inline-size:9.875rem}.cds--interactive--tag-children{display:inline-flex;max-inline-size:12.5rem;place-items:center}.cds--tag--filter .cds--tag__custom-icon+span>.cds--interactive--tag-children{max-inline-size:11.5rem}.cds--tag .cds--definition-term{border-block-end:none;cursor:default;max-inline-size:12rem}.cds--tag .cds--tag__custom-icon+span>.cds--definition-term{max-inline-size:11rem}.cds--tag>.cds--popover-container{display:flex}.cds--toggletip-button:has(.cds--tag--operational.cds--tag--disabled){pointer-events:none}.cds--checkbox-group{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--checkbox-group *,.cds--checkbox-group :after,.cds--checkbox-group :before{box-sizing:inherit}.cds--form-item.cds--checkbox-wrapper{margin-block-end:.375rem;position:relative}.cds--form-item.cds--checkbox-wrapper:first-of-type{margin-block-start:0}.cds--label+.cds--form-item.cds--checkbox-wrapper{margin-block-start:-.125rem}.cds--form-item.cds--checkbox-wrapper:last-of-type{margin-block-end:.1875rem}.cds--checkbox{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;inset-block-start:1.25rem;inset-inline-start:.7rem;visibility:inherit;white-space:nowrap}.cds--checkbox-label{cursor:pointer;display:flex;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);min-block-size:1.25rem;padding-block-start:.0625rem;padding-inline-start:1.25rem;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none}.cds--checkbox-label html{font-size:100%}.cds--checkbox-label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--checkbox-label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--checkbox-label strong{font-weight:600}.cds--checkbox-label-text{padding-inline-start:.625rem}.cds--checkbox-label:after,.cds--checkbox-label:before{box-sizing:border-box}@media print{.cds--checkbox-label:after,.cds--checkbox-label:before{-webkit-print-color-adjust:exact;print-color-adjust:exact}}.cds--checkbox-label:before{background-color:transparent;block-size:1rem;border:1px solid var(--cds-icon-primary,#161616);border-radius:2px;content:"";inline-size:1rem;inset-block-start:.125rem;inset-inline-start:0;margin-block:.0625rem .125rem;margin-inline:.1875rem 0;position:absolute}.cds--checkbox-label:after{background:none;block-size:.3125rem;border-block-end:1.5px solid var(--cds-icon-inverse,#fff);border-inline-start:1.5px solid var(--cds-icon-inverse,#fff);content:"";inline-size:.5625rem;inset-block-start:.40625rem;inset-inline-start:.4375rem;margin-block-start:-.1875rem;position:absolute;transform:scale(0) rotate(-45deg);transform-origin:bottom right}.cds--checkbox-label[data-contained-checkbox-state=true]:before,.cds--checkbox:checked+.cds--checkbox-label:before,.cds--checkbox:indeterminate+.cds--checkbox-label:before{background-color:var(--cds-icon-primary,#161616);border:1px}.cds--checkbox-label[data-contained-checkbox-state=true]:after,.cds--checkbox:checked+.cds--checkbox-label:after{transform:scale(1) rotate(-45deg)}.cds--checkbox:indeterminate+.cds--checkbox-label:after{border-block-end:2px solid var(--cds-icon-inverse,#fff);border-inline-start:0 solid var(--cds-icon-inverse,#fff);inline-size:.5rem;inset-block-start:.6875rem;transform:scale(1) rotate(0deg)}.cds--checkbox-label[data-contained-checkbox-state=true].cds--checkbox-label__focus:before,.cds--checkbox-label__focus:before,.cds--checkbox:checked:focus+.cds--checkbox-label:before,.cds--checkbox:focus+.cds--checkbox-label:before,.cds--checkbox:indeterminate:focus+.cds--checkbox-label:before{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.cds--checkbox-label[data-contained-checkbox-disabled=true],.cds--checkbox:disabled+.cds--checkbox-label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--checkbox-label[data-contained-checkbox-disabled=true]:before,.cds--checkbox:disabled+.cds--checkbox-label:before{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-label[data-contained-checkbox-state=true][data-contained-checkbox-disabled=true]:before,.cds--checkbox:checked:disabled+.cds--checkbox-label:before,.cds--checkbox:indeterminate:disabled+.cds--checkbox-label:before{background-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group[data-invalid] .cds--checkbox-label:before,.cds--checkbox-wrapper--invalid .cds--checkbox-label:before,.cds--checkbox-wrapper--invalid .cds--checkbox:checked+.cds--checkbox-label:before{border:1px solid var(--cds-support-error,#da1e28)}.cds--checkbox-group .cds--checkbox-wrapper--invalid>.cds--checkbox__validation-msg,.cds--checkbox-group .cds--checkbox-wrapper--warning>.cds--checkbox__validation-msg,.cds--checkbox-group .cds--checkbox-wrapper>.cds--form__helper-text{display:none}.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox-label:before,.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox:checked+.cds--checkbox-label:before{border:1px solid var(--cds-icon-primary,#161616)}.cds--checkbox-group__validation-msg,.cds--checkbox__validation-msg{align-items:flex-start;display:none;inline-size:100%;margin-block-start:.25rem}.cds--checkbox__invalid-icon{margin:.0625rem .0625rem 0 .1875rem;fill:var(--cds-support-error,#da1e28);min-inline-size:1rem}.cds--checkbox__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--checkbox__invalid-icon--warning path:first-of-type{fill:#000}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg,.cds--checkbox-group--warning .cds--checkbox-group__validation-msg,.cds--checkbox-wrapper--invalid>.cds--checkbox__validation-msg,.cds--checkbox-wrapper--warning>.cds--checkbox__validation-msg{display:flex}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-group--warning .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--warning .cds--checkbox__validation-msg .cds--form-requirement{display:block;margin-block-start:0;margin-inline-start:.5rem;max-block-size:100%;overflow:visible}.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--checkbox-group--readonly .cds--checkbox-label,.cds--checkbox-wrapper--readonly .cds--checkbox-label{cursor:default}.cds--checkbox-group--readonly .cds--checkbox-label-text,.cds--checkbox-wrapper--readonly .cds--checkbox-label-text{cursor:text;-webkit-user-select:text;-moz-user-select:text;user-select:text}.cds--checkbox-group--readonly .cds--checkbox+.cds--checkbox-label:before,.cds--checkbox-wrapper--readonly .cds--checkbox+.cds--checkbox-label:before{border-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group--readonly .cds--checkbox:checked+.cds--checkbox-label:before,.cds--checkbox-wrapper--readonly .cds--checkbox:checked+.cds--checkbox-label:before{background:transparent;border:1px solid var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--checkbox-group--readonly .cds--checkbox:checked+.cds--checkbox-label:after,.cds--checkbox-wrapper--readonly .cds--checkbox:checked+.cds--checkbox-label:after{border-color:var(--cds-text-primary,#161616)}.cds--checkbox-skeleton .cds--checkbox-label{cursor:default}.cds--checkbox-label-text.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;inline-size:6.25rem;margin-block:.0625rem 0;margin-inline:.375rem 0;padding:0;pointer-events:none;position:relative}.cds--checkbox-label-text.cds--skeleton:active,.cds--checkbox-label-text.cds--skeleton:focus,.cds--checkbox-label-text.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--checkbox-label-text.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--checkbox-label-text.cds--skeleton:before{animation:none}}.cds--checkbox--inline{position:relative}[dir=rtl] .cds--checkbox-label:after{margin-block-start:0;margin-inline-start:-.0625rem;transform-origin:center}[dir=rtl] .cds--checkbox-label[data-contained-checkbox-state=true]:after,[dir=rtl] .cds--checkbox:checked+.cds--checkbox-label:after{transform:scale(1.2) rotate3d(.5,1,0,158deg)}.cds--checkbox-group--decorator legend.cds--label,.cds--checkbox-group--slug legend.cds--label,.cds--checkbox-wrapper--decorator .cds--checkbox-label-text,.cds--checkbox-wrapper--slug .cds--checkbox-label-text{display:flex}.cds--checkbox-group--decorator legend.cds--label .cds--checkbox-group-inner--decorator>*,.cds--checkbox-group--slug legend.cds--label .cds--ai-label,.cds--checkbox-group--slug legend.cds--label .cds--slug,.cds--checkbox-wrapper--decorator .cds--checkbox-label-text .cds--checkbox-wrapper-inner--decorator>*,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--ai-label,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug{margin-inline-start:.5rem}.cds--checkbox-wrapper--decorator .cds--checkbox-label-text .cds--ai-label__button--inline,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--ai-label__button--inline,.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug__button--inline{line-height:inherit;margin-block-start:-.0625rem}.cds--checkbox-group--horizontal{display:flex;flex-flow:row wrap;justify-content:flex-start;position:relative}.cds--checkbox-group--horizontal .cds--form-item{flex:none;margin-block-end:0}.cds--checkbox-group--horizontal .cds--form-item:not(:last-of-type){margin-inline-end:1rem}.cds--checkbox-group--horizontal .cds--checkbox-label-text{padding-inline-start:.5rem}.cds--checkbox-group--horizontal .cds--label+.cds--form-item.cds--checkbox-wrapper{margin-block-start:0}.cds--list-box__wrapper{display:block}.cds--list-box__wrapper--inline,:host(cds-multi-select[type=inline]){align-items:center;display:inline-grid;grid-gap:.25rem;grid-template:auto auto/auto auto}.cds--list-box__wrapper--inline .cds--label,:host(cds-multi-select[type=inline]) .cds--label{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--list-box__wrapper--inline .cds--form-requirement,.cds--list-box__wrapper--inline .cds--form__helper-text,.cds--list-box__wrapper--inline .cds--label,:host(cds-multi-select[type=inline]) .cds--form-requirement,:host(cds-multi-select[type=inline]) .cds--form__helper-text,:host(cds-multi-select[type=inline]) .cds--label{margin:0}.cds--list-box__wrapper--inline .cds--form__helper-text,:host(cds-multi-select[type=inline]) .cds--form__helper-text{max-inline-size:none}.cds--list-box__wrapper--inline .cds--form-requirement,:host(cds-multi-select[type=inline]) .cds--form-requirement{grid-column:2}.cds--list-box{background-color:var(--cds-field);block-size:2.5rem;border:none;border-block-end:1px solid var(--cds-border-strong);color:var(--cds-text-primary,#161616);cursor:pointer;inline-size:100%;max-block-size:2.5rem;position:relative;transition:all 70ms cubic-bezier(.2,0,.38,.9)}.cds--list-box html{font-size:100%}.cds--list-box body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--list-box code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--list-box strong{font-weight:600}.cds--list-box:hover{background-color:var(--cds-field-hover)}.cds--multi-select.cds--multi-select--readonly.cds--list-box{cursor:default}.cds--list-box--lg{block-size:3rem;max-block-size:3rem}.cds--list-box--sm{block-size:2rem;max-block-size:2rem}.cds--list-box--expanded{border-block-end-color:var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--list-box--expanded{border-block-end-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box--expanded{border-block-end-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--list-box--expanded:hover{background-color:var(--cds-field)}.cds--list-box--expanded:hover.cds--list-box--light:hover{background-color:var(--cds-field-02,#fff)}.cds--list-box .cds--text-input{block-size:100%;min-inline-size:0}.cds--list-box__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:2.5rem;transform:translateY(-50%)}.cds--list-box__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--list-box__invalid-icon--warning path[fill]{fill:#000;opacity:1}.cds--list-box.cds--list-box--warning .cds--list-box__field,.cds--list-box[data-invalid] .cds--list-box__field{border-block-end:0;padding-inline-end:4rem}.cds--list-box.cds--list-box--warning.cds--list-box--inline .cds--list-box__field,.cds--list-box[data-invalid].cds--list-box--inline .cds--list-box__field{padding-inline-end:3.5rem}.cds--list-box--light{background-color:var(--cds-field-02,#fff)}.cds--list-box--light:hover{background-color:var(--cds-field-hover)}.cds--list-box--light .cds--list-box__menu{background:var(--cds-layer)}.cds--list-box--light .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle)}.cds--list-box--light.cds--list-box--expanded{border-block-end-color:transparent}.cds--list-box--disabled:hover{background-color:var(--cds-field)}.cds--list-box--light.cds--list-box--disabled{background-color:var(--cds-field-02,#fff)}.cds--list-box--disabled,.cds--list-box--disabled .cds--list-box__field,.cds--list-box--disabled .cds--list-box__field:focus{border-block-end-color:transparent;outline:none}.cds--list-box--disabled .cds--list-box__label,.cds--list-box--disabled.cds--list-box--inline .cds--list-box__label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled .cds--list-box__menu-icon>svg,.cds--list-box--disabled .cds--list-box__selection>svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled,.cds--list-box--disabled .cds--list-box__field,.cds--list-box--disabled .cds--list-box__menu-icon{cursor:not-allowed}.cds--list-box--disabled .cds--list-box__menu-item,.cds--list-box--disabled .cds--list-box__menu-item--highlighted,.cds--list-box--disabled .cds--list-box__menu-item:hover,.cds--list-box--disabled :host(cds-multi-select-item){color:var(--cds-text-disabled,hsla(0,0%,9%,.25));text-decoration:none}.cds--list-box--disabled .cds--list-box__selection:hover{cursor:not-allowed}.cds--list-box--disabled.cds--list-box[data-invalid] .cds--list-box__field{padding-inline-end:3rem}.cds--list-box--disabled.cds--list-box[data-invalid].cds--list-box--inline .cds--list-box__field{padding-inline-end:2rem}.cds--list-box.cds--list-box--inline{background-color:transparent;border-width:0}.cds--list-box.cds--list-box--inline:hover{background-color:var(--cds-layer-hover)}.cds--list-box.cds--list-box--inline.cds--list-box--expanded{border-block-end-width:0}.cds--list-box.cds--list-box--inline.cds--list-box--expanded .cds--list-box__field[aria-expanded=true]{border-width:0}.cds--list-box.cds--list-box--inline.cds--list-box--disabled:hover,.cds--list-box.cds--list-box--inline.cds--list-box--expanded:hover{background-color:transparent}.cds--list-box.cds--list-box--inline .cds--list-box__field{padding:0 2rem 0 .5rem}.cds--list-box.cds--list-box--inline .cds--list-box__menu-icon{inset-inline-end:.5rem}.cds--list-box.cds--list-box--inline .cds--list-box__invalid-icon{inset-inline-end:2rem}.cds--list-box--inline .cds--list-box__label{color:var(--cds-text-primary,#161616)}.cds--list-box--inline .cds--list-box__field{block-size:100%}.cds--dropdown--inline .cds--list-box__field{max-inline-size:30rem}.cds--dropdown--inline .cds--list-box__menu{max-inline-size:30rem;min-inline-size:18rem}.cds--list-box__field{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:calc(100% + 1px);border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;margin:0;outline:none;overflow:hidden;padding:0;padding-block:0;padding-inline:1rem 3rem;position:relative;text-align:start;text-overflow:ellipsis;vertical-align:baseline;vertical-align:top;white-space:nowrap}.cds--list-box__field *,.cds--list-box__field :after,.cds--list-box__field :before{box-sizing:inherit}.cds--list-box__field::-moz-focus-inner{border:0}.cds--list-box__field:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--list-box__field:focus{outline-style:dotted}}.cds--list-box__field[disabled]{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--list-box__field .cds--text-input{padding-inline-end:5rem}.cds--list-box--warning .cds--list-box__field .cds--text-input,.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input{padding-inline-end:6.5625rem}.cds--list-box--warning .cds--list-box__field .cds--text-input+.cds--list-box__invalid-icon,.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input+.cds--list-box__invalid-icon{inset-inline-end:5.125rem}.cds--list-box__field .cds--text-input--empty{padding-inline-end:3rem}.cds--list-box--warning .cds--list-box__field .cds--text-input--empty,.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input--empty{padding-inline-end:4rem}.cds--list-box--warning .cds--list-box__field .cds--text-input--empty+.cds--list-box__invalid-icon,.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input--empty+.cds--list-box__invalid-icon{inset-inline-end:2.5rem}.cds--list-box__label{color:var(--cds-text-primary,#161616);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);overflow:hidden;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;user-select:none;white-space:nowrap}.cds--list-box__menu-icon{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:1.5rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;inline-size:1.5rem;inset-inline-end:.75rem;justify-content:center;margin:0;outline:none;padding:0;position:absolute;text-align:start;transition:transform 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--list-box__menu-icon *,.cds--list-box__menu-icon :after,.cds--list-box__menu-icon :before{box-sizing:inherit}.cds--list-box__menu-icon::-moz-focus-inner{border:0}.cds--list-box__menu-icon>svg{fill:var(--cds-icon-primary,#161616)}.cds--list-box__menu-icon--open{inline-size:1.5rem;justify-content:center;transform:rotate(180deg)}.cds--list-box__selection{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:1.5rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;inline-size:1.5rem;inset-block-start:50%;inset-inline-end:2.8125rem;justify-content:center;margin:0;padding:0;position:absolute;text-align:start;transform:translateY(-50%);transition:background-color 70ms cubic-bezier(.2,0,.38,.9);-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:baseline}.cds--list-box__selection *,.cds--list-box__selection :after,.cds--list-box__selection :before{box-sizing:inherit}.cds--list-box__selection::-moz-focus-inner{border:0}.cds--list-box__selection:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--list-box__selection:focus{outline-style:dotted}}.cds--list-box__selection:focus:hover{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--list-box__selection:focus:hover{outline-style:dotted}}.cds--list-box__selection>svg{fill:var(--cds-icon-primary,#161616)}.cds--list-box--disabled .cds--list-box__selection:focus{outline:none}.cds--list-box__selection--multi{align-items:center;background-color:var(--cds-background-inverse,#393939);block-size:1.5rem;border-radius:.75rem;color:var(--cds-text-inverse,#fff);display:flex;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:auto;inset-block-start:auto;justify-content:space-between;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:0;margin-inline-end:.625rem;padding:.5rem;padding-inline-end:.125rem;position:static;transform:none}.cds--list-box__selection--multi>svg{block-size:1.25rem;padding:.125rem;fill:var(--cds-icon-inverse,#fff);inline-size:1.25rem;margin-inline-start:.25rem}.cds--list-box__selection--multi>svg:hover{background-color:var(--cds-button-secondary-hover,#474747);border-radius:50%}.cds--list-box--disabled .cds--list-box__selection--multi{background-color:var(--cds-text-disabled,hsla(0,0%,9%,.25));color:var(--cds-layer)}.cds--list-box--disabled .cds--list-box__selection--multi.cds--tag--operational{border:1px solid var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled .cds--list-box__selection--multi .cds--tag__close-icon:hover,.cds--list-box--disabled .cds--list-box__selection--multi.cds--tag--operational:hover{background-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled .cds--list-box__selection--multi>svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--list-box--disabled .cds--list-box__selection--multi>svg:hover{background-color:initial}.cds--list-box__selection--multi:hover{outline:none}.cds--list-box__menu{background-color:var(--cds-layer);box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));display:none;inline-size:100%;inset-inline:0;overflow-y:auto;position:absolute;transition:max-height .11s cubic-bezier(.2,0,.38,.9);z-index:9100}.cds--list-box__menu:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--list-box__menu:focus{outline-style:dotted}}.cds--list-box .cds--list-box__field[aria-expanded=false] .cds--list-box__menu{display:none;max-block-size:0;visibility:hidden}.cds--list-box--expanded .cds--list-box__menu{display:block;max-block-size:13.75rem}.cds--list-box--expanded.cds--list-box--lg .cds--list-box__menu{max-block-size:16.5rem}.cds--list-box--expanded.cds--list-box--sm .cds--list-box__menu{max-block-size:11rem}.cds--list-box__menu-item,:host(cds-multi-select-item){block-size:2.5rem;color:var(--cds-text-secondary,#525252);cursor:pointer;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);position:relative;transition:background 70ms cubic-bezier(.2,0,.38,.9);-webkit-user-select:none;-moz-user-select:none;user-select:none}.cds--list-box__menu-item:hover{background-color:var(--cds-layer-hover)}.cds--list-box__menu-item:active{background-color:var(--cds-layer-selected)}.cds--list-box--light .cds--list-box__menu-item:hover{background-color:var(--cds-layer-hover)}.cds--list-box--sm .cds--list-box__menu-item,.cds--list-box--sm :host(cds-multi-select-item){block-size:2rem}.cds--list-box--lg .cds--list-box__menu-item,.cds--list-box--lg :host(cds-multi-select-item){block-size:3rem}.cds--list-box--disabled .cds--list-box__menu-item:hover{background-color:transparent}.cds--list-box--light .cds--list-box__menu-item:active{background-color:var(--cds-layer-selected)}.cds--list-box--disabled .cds--list-box__menu-item__option:hover{border-block-start-color:var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--list-box--disabled .cds--list-box__menu-item__option:hover{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box--disabled .cds--list-box__menu-item__option:hover{border-block-start-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--list-box__menu-item:first-of-type .cds--list-box__menu-item__option{border-block-start-color:transparent}.cds--list-box__menu-item:hover .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}.cds--list-box--disabled .cds--list-box__menu-item:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--list-box--disabled .cds--list-box__menu-item:hover+:host(cds-multi-select-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--list-box--disabled .cds--list-box__menu-item:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--layer-two .cds--list-box--disabled .cds--list-box__menu-item:hover+:host(cds-multi-select-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box--disabled .cds--list-box__menu-item:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--layer-three .cds--list-box--disabled .cds--list-box__menu-item:hover+:host(cds-multi-select-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--layer-two .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--list-box__menu-item__option{block-size:2.5rem;border:0;border-block-end:1px solid transparent;border-block-start:1px solid transparent;border-block-start-color:var(--cds-border-subtle-01,#c6c6c6);box-sizing:border-box;color:var(--cds-text-secondary,#525252);display:block;font-family:inherit;font-size:100%;font-weight:400;line-height:1rem;margin:0 1rem;outline:2px solid transparent;outline-offset:-2px;overflow:hidden;padding:.6875rem 0;padding-inline-end:1.5rem;text-decoration:none;text-overflow:ellipsis;transition:border-color 70ms cubic-bezier(.2,0,.38,.9),color 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline;white-space:nowrap}.cds--list-box__menu-item__option *,.cds--list-box__menu-item__option :after,.cds--list-box__menu-item__option :before{box-sizing:inherit}.cds--list-box__menu-item__option:focus{border-color:transparent;margin:0;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;padding:.6875rem 1rem}@media screen and (prefers-contrast){.cds--list-box__menu-item__option:focus{outline-style:dotted}}.cds--list-box__menu-item__option:hover{border-color:transparent;color:var(--cds-text-primary,#161616)}.cds--list-box--sm .cds--list-box__menu-item__option{block-size:2rem;padding-block:.4375rem .4375rem}.cds--list-box--lg .cds--list-box__menu-item__option{block-size:3rem;padding-block:.9375rem .9375rem}.cds--list-box--disabled .cds--list-box__menu-item:hover .cds--list-box__menu-item__option,.cds--list-box--disabled .cds--list-box__menu-item__option{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box__menu-item[disabled],.cds--list-box__menu-item[disabled] *,.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--list-box__menu-item[disabled]:hover{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;outline:none}.cds--list-box__menu-item[disabled]:hover{background-color:revert}.cds--list-box__menu-item[disabled] .cds--checkbox-label:before{border-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--list-box__menu-item[disabled]:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--list-box__menu-item[disabled]:hover+:host(cds-multi-select-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-01,#c6c6c6)}.cds--layer-two .cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--layer-two .cds--list-box__menu-item[disabled]:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--layer-two .cds--list-box__menu-item[disabled]:hover+:host(cds-multi-select-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--layer-three .cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--layer-three .cds--list-box__menu-item[disabled]:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--layer-three .cds--list-box__menu-item[disabled]:hover+:host(cds-multi-select-item) .cds--list-box__menu-item__option{border-block-start-color:var(--cds-border-subtle-03,#c6c6c6)}.cds--list-box__menu-item--active+.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,.cds--list-box__menu-item:hover+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--list-box__menu-item:hover+:host(cds-multi-select-item) .cds--list-box__menu-item__option,:host(cds-multi-select-item[selected])+.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option{border-block-start-color:transparent}.cds--list-box.cds--list-box--inline .cds--list-box__menu-item__option{margin:0 .5rem}.cds--list-box.cds--list-box--inline .cds--list-box__menu-item__option:focus{margin:0;padding-inline:.5rem .5rem}.cds--list-box__menu-item--highlighted,:host(cds-multi-select-item[highlighted]),:host(cds-multi-select-item[selected]){color:var(--cds-text-primary,#161616);outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--list-box__menu-item--highlighted,:host(cds-multi-select-item[highlighted]),:host(cds-multi-select-item[selected]){outline-style:dotted}}.cds--list-box__menu-item--highlighted .cds--list-box__menu-item__option,.cds--list-box__menu-item--highlighted+.cds--list-box__menu-item .cds--list-box__menu-item__option,.cds--list-box__menu-item--highlighted+:host(cds-multi-select-item) .cds--list-box__menu-item__option,:host(cds-multi-select-item[highlighted]) .cds--list-box__menu-item__option,:host(cds-multi-select-item[highlighted])+.cds--list-box__menu-item .cds--list-box__menu-item__option,:host(cds-multi-select-item[highlighted])+:host(cds-multi-select-item) .cds--list-box__menu-item__option,:host(cds-multi-select-item[selected]) .cds--list-box__menu-item__option,:host(cds-multi-select-item[selected])+.cds--list-box__menu-item .cds--list-box__menu-item__option,:host(cds-multi-select-item[selected])+:host(cds-multi-select-item) .cds--list-box__menu-item__option{border-block-start-color:transparent}.cds--list-box__menu-item--highlighted .cds--list-box__menu-item__option,:host(cds-multi-select-item[highlighted]) .cds--list-box__menu-item__option,:host(cds-multi-select-item[selected]) .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}.cds--list-box__menu-item--active,:host(cds-multi-select-item[selected]){background-color:var(--cds-layer-selected);border-block-end-color:var(--cds-layer-selected);color:var(--cds-text-primary,#161616)}.cds--list-box--light .cds--list-box__menu-item--active,.cds--list-box--light :host(cds-multi-select-item[selected]){background-color:var(--cds-layer-selected);border-block-end-color:var(--cds-layer-selected)}.cds--list-box__menu-item--active:hover{background-color:var(--cds-layer-selected-hover);border-block-end-color:var(--cds-layer-selected-hover)}.cds--list-box__menu-item--active .cds--list-box__menu-item__option,:host(cds-multi-select-item[selected]) .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}.cds--list-box__menu-item--active+.cds--list-box__menu-item>.cds--list-box__menu-item__option,.cds--list-box__menu-item--active+:host(cds-multi-select-item)>.cds--list-box__menu-item__option,:host(cds-multi-select-item[selected])+.cds--list-box__menu-item>.cds--list-box__menu-item__option,:host(cds-multi-select-item[selected])+:host(cds-multi-select-item)>.cds--list-box__menu-item__option{border-block-start-color:transparent}.cds--list-box__menu-item__selected-icon{display:none;position:absolute;fill:var(--cds-icon-primary,#161616);inset-block-start:50%;inset-inline-end:1rem;transform:translateY(-50%)}.cds--list-box--inline .cds--list-box__menu-item__selected-icon{inset-inline-end:.5rem}.cds--list-box__menu-item--active .cds--list-box__menu-item__selected-icon,:host(cds-multi-select-item[selected]) .cds--list-box__menu-item__selected-icon{display:block}.cds--list-box__menu-item .cds--checkbox-label,:host(cds-multi-select-item) .cds--checkbox-label{inline-size:100%}.cds--list-box__menu-item .cds--checkbox-label-text,:host(cds-multi-select-item) .cds--checkbox-label-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cds--list-box--up .cds--list-box__menu,:host(cds-multi-select[direction=top]) .cds--list-box__menu{inset-block-end:2.5rem}.cds--list-box--up .cds--list-box--sm .cds--list-box__menu,.cds--list-box--up.cds--dropdown--sm .cds--list-box__menu,.cds--list-box--up.cds--list-box--sm .cds--list-box__menu,:host(cds-multi-select[direction=top]) .cds--list-box--sm .cds--list-box__menu{inset-block-end:2rem}.cds--list-box--up .cds--list-box--lg .cds--list-box__menu,.cds--list-box--up.cds--dropdown--lg .cds--list-box__menu,.cds--list-box--up.cds--list-box--lg .cds--list-box__menu,:host(cds-multi-select[direction=top]) .cds--list-box--lg .cds--list-box__menu{inset-block-end:3rem}.cds--list-box input[role=combobox],.cds--list-box input[type=text]{background-color:inherit;min-inline-size:0;text-overflow:ellipsis}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>*,.cds--list-box__wrapper--slug .cds--ai-label,.cds--list-box__wrapper--slug .cds--slug,:host(cds-multi-select[ai-label]) .cds--ai-label,:host(cds-multi-select[ai-label]) .cds--slug{inset-block-start:50%;inset-inline-end:calc(2.5rem + 9px);margin-block-start:.03125rem;position:absolute;transform:translateY(-50%)}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>:after,.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>:before,.cds--list-box__wrapper--slug .cds--ai-label:after,.cds--list-box__wrapper--slug .cds--ai-label:before,.cds--list-box__wrapper--slug .cds--slug:after,.cds--list-box__wrapper--slug .cds--slug:before,:host(cds-multi-select[ai-label]) .cds--ai-label:after,:host(cds-multi-select[ai-label]) .cds--ai-label:before,:host(cds-multi-select[ai-label]) .cds--slug:after,:host(cds-multi-select[ai-label]) .cds--slug:before{background-color:var(--cds-border-subtle-01,#c6c6c6);block-size:1rem;content:"";inline-size:.0625rem;position:absolute}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>:before,.cds--list-box__wrapper--slug .cds--ai-label:before,.cds--list-box__wrapper--slug .cds--slug:before,:host(cds-multi-select[ai-label]) .cds--ai-label:before,:host(cds-multi-select[ai-label]) .cds--slug:before{display:none;inset-inline-start:-.5625rem}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator>:after,.cds--list-box__wrapper--slug .cds--ai-label:after,.cds--list-box__wrapper--slug .cds--slug:after,:host(cds-multi-select[ai-label]) .cds--ai-label:after,:host(cds-multi-select[ai-label]) .cds--slug:after{display:block;inset-block-start:0;inset-inline-end:-.5625rem}.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator .cds--ai-label--revert:after,.cds--list-box__wrapper--slug .cds--ai-label--revert:after,.cds--list-box__wrapper--slug .cds--slug--revert:after,:host(cds-multi-select[ai-label]) .cds--ai-label--revert:after,:host(cds-multi-select[ai-label]) .cds--slug--revert:after{inset-block-start:.5rem;inset-inline-end:-.0625rem}.cds--list-box__wrapper--decorator .cds--list-box:has(.cds--list-box__inner-wrapper--decorator .cds--ai-label):not(:has(.cds--list-box__inner-wrapper--decorator .cds--ai-label--revert)),.cds--list-box__wrapper--slug .cds--list-box:has(.cds--ai-label):not(:has(.cds--ai-label--revert)),.cds--list-box__wrapper--slug .cds--list-box:has(.cds--slug):not(:has(.cds--slug--revert)),:host(cds-multi-select[ai-label]) .cds--list-box:has(.cds--ai-label):not(:has(.cds--ai-label--revert)),:host(cds-multi-select[ai-label]) .cds--list-box:has(.cds--slug):not(:has(.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff)}.cds--list-box__wrapper--decorator .cds--list-box input[role=combobox],.cds--list-box__wrapper--slug .cds--list-box input[role=combobox],:host(cds-multi-select[ai-label]) .cds--list-box input[role=combobox]{border-block-end-color:transparent}.cds--list-box__wrapper--decorator .cds--list-box__field,.cds--list-box__wrapper--decorator .cds--text-input--empty,.cds--list-box__wrapper--slug .cds--list-box__field,.cds--list-box__wrapper--slug .cds--text-input--empty,:host(cds-multi-select[ai-label]) .cds--list-box__field,:host(cds-multi-select[ai-label]) .cds--text-input--empty{padding-inline-end:4rem}.cds--list-box__wrapper--decorator .cds--text-input:not(.cds--text-input--empty),.cds--list-box__wrapper--slug .cds--text-input:not(.cds--text-input--empty),:host(cds-multi-select[ai-label]) .cds--text-input:not(.cds--text-input--empty){padding-inline-end:6rem}.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--list-box__field,.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--text-input--empty,.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__field,.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--text-input--empty,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--list-box__field,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--text-input--empty,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--text-input--empty,:host(cds-multi-select[ai-label]) .cds--list-box--invalid[data-invalid] .cds--list-box__field,:host(cds-multi-select[ai-label]) .cds--list-box--invalid[data-invalid] .cds--text-input--empty,:host(cds-multi-select[ai-label]) .cds--list-box--warning .cds--list-box__field,:host(cds-multi-select[ai-label]) .cds--list-box--warning .cds--text-input--empty{padding-inline-end:6rem}.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--text-input:not(.cds--text-input--empty),.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--text-input:not(.cds--text-input--empty),.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--text-input:not(.cds--text-input--empty),.cds--list-box__wrapper--slug .cds--list-box--warning .cds--text-input:not(.cds--text-input--empty),:host(cds-multi-select[ai-label]) .cds--list-box--invalid[data-invalid] .cds--text-input:not(.cds--text-input--empty),:host(cds-multi-select[ai-label]) .cds--list-box--warning .cds--text-input:not(.cds--text-input--empty){padding-inline-end:8.8125rem}.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--list-box__invalid-icon,.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--text-input--empty+.cds--list-box__invalid-icon,.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__invalid-icon.cds--list-box__invalid-icon--warning,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--list-box__invalid-icon,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--text-input--empty+.cds--list-box__invalid-icon,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__invalid-icon.cds--list-box__invalid-icon--warning,:host(cds-multi-select[ai-label]) .cds--list-box--invalid[data-invalid] .cds--list-box__invalid-icon,:host(cds-multi-select[ai-label]) .cds--list-box--warning .cds--list-box__invalid-icon.cds--list-box__invalid-icon--warning{inset-inline-end:5.1875rem}.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid]>:before,.cds--list-box__wrapper--decorator .cds--list-box--warning>:before,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--ai-label:before,.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--slug:before,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--ai-label:before,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--slug:before,:host(cds-multi-select[ai-label]) .cds--list-box--invalid[data-invalid] .cds--ai-label:before,:host(cds-multi-select[ai-label]) .cds--list-box--invalid[data-invalid] .cds--slug:before,:host(cds-multi-select[ai-label]) .cds--list-box--warning .cds--ai-label:before,:host(cds-multi-select[ai-label]) .cds--list-box--warning .cds--slug:before{display:block}.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,.cds--list-box__wrapper--decorator .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection)~.cds--slug,.cds--list-box__wrapper--slug .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,.cds--list-box__wrapper--slug .cds--list-box__field:has(.cds--list-box__selection)~.cds--slug,:host(cds-multi-select[ai-label]) .cds--list-box__field:has(.cds--list-box__selection)~.cds--ai-label,:host(cds-multi-select[ai-label]) .cds--list-box__field:has(.cds--list-box__selection)~.cds--slug{inset-inline-end:calc(4rem + 18px)}.cds--list-box__wrapper--decorator .cds--list-box--invalid .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,.cds--list-box__wrapper--slug .cds--list-box--invalid .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,:host(cds-multi-select[ai-label]) .cds--list-box--invalid .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,:host(cds-multi-select[ai-label]) .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon{inset-inline-end:7.25rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--list-box__field,.cds--list-box__menu,.cds--multi-select .cds--tag--filter{outline:1px solid transparent}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--list-box__field:focus,.cds--list-box__menu-item--highlighted .cds--list-box__menu-item__option,.cds--multi-select .cds--tag__close-icon:focus,:host(cds-multi-select-item[highlighted]) .cds--list-box__menu-item__option,:host(cds-multi-select-item[selected]) .cds--list-box__menu-item__option{color:Highlight;outline:1px solid Highlight}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--list-box__menu-icon>svg,.cds--list-box__selection--multi>svg,.cds--list-box__selection>svg{fill:ButtonText}}.cds--list-box__field:has(.cds--list-box__menu-icon) .cds--list-box__selection:after{background-color:var(--cds-border-subtle-01,#c6c6c6);block-size:1rem;content:"";inline-size:.0625rem;margin-inline-start:2.0625rem;position:absolute}.cds--list-box--invalid[data-invalid] .cds--list-box__field:has(.cds--list-box__menu-icon) .cds--list-box__selection:before,.cds--list-box--warning .cds--list-box__field:has(.cds--list-box__menu-icon) .cds--list-box__selection:before{background-color:var(--cds-border-subtle-01,#c6c6c6);block-size:1rem;content:"";inline-size:.0625rem;margin-inline-end:2.0625rem;position:absolute}.cds--list-box__wrapper--decorator:has(.cds--multi-select) .cds--list-box__menu-icon,.cds--list-box__wrapper--slug:has(.cds--multi-select) .cds--list-box__menu-icon,:has(.cds--multi-select):host(cds-multi-select[ai-label]) .cds--list-box__menu-icon{inset-inline-end:.75rem}.cds--list-box__wrapper--decorator:has(.cds--dropdown) .cds--list-box__menu-icon,.cds--list-box__wrapper--slug:has(.cds--dropdown) .cds--list-box__menu-icon,:has(.cds--dropdown):host(cds-multi-select[ai-label]) .cds--list-box__menu-icon{inset-inline-end:.75rem}.cds--multi-select .cds--list-box__field--wrapper{align-items:center;block-size:calc(100% + 1px);display:inline-flex;inline-size:100%}.cds--multi-select .cds--list-box__field:focus{outline:2px solid transparent;outline-offset:-2px}.cds--multi-select--filterable .cds--list-box__field{padding:0}.cds--multi-select .cds--tag{margin:0 .5rem 0 1rem;min-inline-size:auto}.cds--multi-select .cds--list-box__menu{min-inline-size:auto}.cds--multi-select.cds--multi-select--selectall .cds--list-box__menu-item:first-child .cds--list-box__menu-item__option{border-block-end:1px solid var(--cds-border-subtle-01,#c6c6c6);margin:0;padding:.6875rem 1rem}.cds--multi-select.cds--multi-select--selectall .cds--list-box__menu-item:nth-child(2) .cds--list-box__menu-item__option{border-block-start:none}.cds--multi-select .cds--list-box__menu-item__option .cds--checkbox-wrapper{align-items:center;block-size:100%;display:flex;inline-size:100%}.cds--multi-select .cds--list-box__menu-item__option .cds--checkbox-label{display:inline-block;inline-size:100%;overflow:hidden;padding-inline-start:1.75rem;text-overflow:ellipsis;white-space:nowrap}.cds--multi-select .cds--list-box__menu-item__option .cds--checkbox-label:before{margin-block:0}.cds--multi-select .cds--list-box__menu-item__option .cds--checkbox:indeterminate+.cds--checkbox-label:after{inset-block-start:.5625rem}.cds--multi-select .cds--list-box__menu-item__option .cds--checkbox-label:after{inset-block-start:.3125rem}.cds--multi-select .cds--list-box__menu-item__option>.cds--form-item{flex-direction:row;margin:0}.cds--multi-select .cds--list-box__menu-item .cds--checkbox:checked~.cds--checkbox-label-text,.cds--multi-select :host(cds-multi-select-item) .cds--checkbox:checked~.cds--checkbox-label-text{color:var(--cds-text-primary,#161616)}.cds--multi-select--filterable{transition:outline-color 70ms cubic-bezier(.2,0,.38,.9)}.cds--multi-select--filterable.cds--combo-box .cds--text-input{background-clip:padding-box;border:.125rem solid transparent;outline:none}.cds--multi-select .cds--list-box__field--wrapper--input-focused:has(button[aria-expanded=false]),.cds--multi-select .cds--list-box__field--wrapper--input-focused:has(button[aria-expanded=true]),.cds--multi-select--filterable--input-focused,:host(cds-multi-select) .cds--list-box__field:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--multi-select .cds--list-box__field--wrapper--input-focused:has(button[aria-expanded=false]),.cds--multi-select .cds--list-box__field--wrapper--input-focused:has(button[aria-expanded=true]),.cds--multi-select--filterable--input-focused,:host(cds-multi-select) .cds--list-box__field:focus{outline-style:dotted}}.cds--multi-select--filterable.cds--list-box--expanded:has(input[aria-activedescendant]:not([aria-activedescendant=""])),.cds--multi-select.cds--list-box--expanded .cds--list-box__field--wrapper:has(button[aria-activedescendant]:not([aria-activedescendant=""])){outline-offset:-.0625rem;outline-width:.0625rem}.cds--multi-select--filterable.cds--multi-select--selected .cds--text-input,.cds--multi-select.cds--multi-select--selected .cds--list-box__field{padding-inline-start:0}.cds--multi-select--filterable.cds--list-box--disabled:hover:not(.cds--multi-select--filterable) .cds--text-input{background-color:var(--cds-field)}.cds--multi-select--filterable .cds--list-box__selection--multi{margin:0 0 0 1rem}.cds--multi-select--filterable.cds--multi-select--inline,.cds--multi-select--filterable.cds--multi-select--inline .cds--text-input{background-color:transparent;border-block-end:0}.cds--multi-select:not(.cds--list-box--expanded) .cds--list-box__menu{visibility:hidden}.cds--multi-select.cds--multi-select--readonly,.cds--multi-select.cds--multi-select--readonly:hover{background-color:transparent;border-block-end-color:var(--cds-border-subtle)}.cds--multi-select.cds--multi-select--readonly .cds--list-box__menu-icon svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--multi-select.cds--multi-select--readonly .cds--tag--filter,.cds--multi-select.cds--multi-select--readonly .cds--tag__close-icon:hover{background-color:transparent;color:var(--cds-text-primary,#161616);cursor:default}.cds--multi-select.cds--multi-select--readonly .cds--tag--filter{box-shadow:0 0 0 1px var(--cds-border-subtle)}.cds--multi-select.cds--multi-select--readonly .cds--tag--filter svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--multi-select.cds--multi-select--readonly .cds--list-box__field,.cds--multi-select.cds--multi-select--readonly .cds--list-box__menu-icon{cursor:default}:host(cds-multi-select){outline:none}:host(cds-multi-select) .cds--assistive-text{inset-block-start:-100%;inset-inline-start:-100%}:host(cds-multi-select) .cds--label[hidden]{display:none}:host(cds-multi-select) .cds--list-box__menu{inset-block-start:100%;margin-block-start:1px}:host(cds-multi-select) .cds--text-input{border:none;padding-inline-start:0}:host(cds-multi-select) .cds--text-input:focus{outline:none}:host(cds-multi-select[filterable]) .cds--list-box__field:focus-within{outline:.125rem solid var(--cds-focus,#0f62fe);outline-offset:-.125rem}:host(cds-multi-select[direction=top]) .cds--list-box__menu{inset-block-start:auto}:host(cds-multi-select[invalid]) .cds--list-box__field{outline:none}:host(cds-multi-select[invalid]) .cds--form__helper-text{color:var(--cds-text-error,#da1e28)}:host(cds-multi-select[type=inline]) .cds--form__helper-text{grid-column:2}:host(cds-multi-select[type=inline][warn]) .cds--list-box__field{padding-inline-end:3.5rem}:host(cds-multi-select-item){display:block}:host(cds-multi-select-item) .cds--checkbox-label{display:inline-block;inline-size:100%;overflow:hidden;padding-inline-start:1.75rem;text-overflow:ellipsis;white-space:nowrap}:host(cds-multi-select-item) .cds--list-box__menu-item__option{box-sizing:border-box}:host(cds-multi-select-item) .cds--list-box__menu-item__option .cds--checkbox-wrapper{align-items:center;block-size:100%;display:flex;inline-size:100%}:host(cds-multi-select-item) .cds--list-box__menu-item__option>.cds--form-item{flex-direction:row}:host(cds-multi-select-item:hover){background-color:var(--cds-layer-hover)}:host(cds-multi-select-item[filtered]){display:none}:host(cds-multi-select-item[size=sm]){block-size:-moz-fit-content;block-size:fit-content}:host(cds-multi-select-item[size=sm]) .cds--list-box__menu-item__option{block-size:2rem;padding-block:.4375rem}:host(cds-multi-select-item[size=lg]){block-size:-moz-fit-content;block-size:fit-content}:host(cds-multi-select-item[size=lg]) .cds--list-box__menu-item__option{block-size:3rem;padding-block:.9375rem}:host(cds-multi-select-item[disabled]){color:var(--cds-text-disabled,hsla(0,0%,9%,.25));text-decoration:none}:host(cds-multi-select-item[selected]) .cds--list-box__menu-item__option{color:var(--cds-text-primary,#161616)}:host(cds-multi-select[ai-label]) ::slotted(cds-ai-label),:host(cds-multi-select[ai-label]) ::slotted(cds-slug){inset-block-start:50%;inset-inline-end:2.5rem;position:absolute}:host(cds-multi-select[ai-label]) ::slotted(cds-ai-label:not([revert-active])),:host(cds-multi-select[ai-label]) ::slotted(cds-slug:not([revert-active])){transform:translateY(-50%)}:host(cds-multi-select[ai-label][invalid]) .cds--list-box .cds--list-box__field,:host(cds-multi-select[ai-label][warn]) .cds--list-box .cds--list-box__field{padding-inline-end:6rem}:host(cds-multi-select[ai-label][invalid]) ::slotted(cds-ai-label),:host(cds-multi-select[ai-label][invalid]) ::slotted(cds-slug),:host(cds-multi-select[ai-label][warn]) ::slotted(cds-ai-label),:host(cds-multi-select[ai-label][warn]) ::slotted(cds-slug){inset-inline-end:4rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c3M5O":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSMultiSelectItem$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _settingsJs = require("../../globals/settings.js");
var _dropdownItemJs = require("../dropdown/dropdown-item.js");
var _dropdownItemJsDefault = parcelHelpers.interopDefault(_dropdownItemJs);
var _multiSelectScssJs = require("./multi-select.scss.js");
var _multiSelectScssJsDefault = parcelHelpers.interopDefault(_multiSelectScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Multi select item.
 *
 * @element cds-multi-select-item
 */ let CDSMultiSelectItem = class CDSMultiSelectItem extends (0, _dropdownItemJsDefault.default) {
    constructor(){
        super(...arguments);
        /**
         * The `name` attribute for the `<input>` for selection.
         */ this.selectionName = "";
    }
    render() {
        const { disabled, selected, selectionName, value } = this;
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--list-box__menu-item__option">
        <div class="${0, _settingsJs.prefix}--form-item ${0, _settingsJs.prefix}--checkbox-wrapper">
          <span
            value="${value}"
            name="${(0, _ifDefinedJs.ifDefined)(selectionName || undefined)}"
            class="${0, _settingsJs.prefix}--checkbox-label"
            ?disabled=${disabled}
            data-contained-checkbox-state=${selected}
            ><slot></slot
          ></span>
        </div>
      </div>
    `;
    }
    /**
     * A selector that will return multi select.
     */ static get selectorList() {
        return `${0, _settingsJs.prefix}-multi-select`;
    }
};
CDSMultiSelectItem.styles = (0, _multiSelectScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSMultiSelectItem.prototype, "filtered", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "selection-name"
    })
], CDSMultiSelectItem.prototype, "selectionName", void 0);
CDSMultiSelectItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-multi-select-item`)
], CDSMultiSelectItem);
var CDSMultiSelectItem$1 = CDSMultiSelectItem;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/if-defined.js":"hSgrS","../../globals/settings.js":"EipuL","../dropdown/dropdown-item.js":"cje0A","./multi-select.scss.js":"9zurK","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iXbVz":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _numberInputJs = require("./number-input.js");
var _numberInputSkeletonJs = require("./number-input-skeleton.js");

},{"./number-input.js":"6E2Of","./number-input-skeleton.js":"guF5G"}],"6E2Of":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NUMBER_INPUT_VALIDATION_STATUS", ()=>(0, _defsJs.NUMBER_INPUT_VALIDATION_STATUS));
parcelHelpers.export(exports, "default", ()=>CDSNumberInput$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _classMapJs = require("lit/directives/class-map.js");
var _settingsJs = require("../../globals/settings.js");
var _16Js = require("../../icons/warning--filled/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/warning--alt--filled/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _16Js2 = require("../../icons/add/16.js");
var _16JsDefault2 = parcelHelpers.interopDefault(_16Js2);
var _16Js3 = require("../../icons/subtract/16.js");
var _16JsDefault3 = parcelHelpers.interopDefault(_16Js3);
var _ifNonEmptyJs = require("../../globals/directives/if-non-empty.js");
var _ifNonEmptyJsDefault = parcelHelpers.interopDefault(_ifNonEmptyJs);
var _defsJs = require("./defs.js");
var _numberInputScssJs = require("./number-input.scss.js");
var _numberInputScssJsDefault = parcelHelpers.interopDefault(_numberInputScssJs);
var _textInputJs = require("../text-input/text-input.js");
var _textInputJsDefault = parcelHelpers.interopDefault(_textInputJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs1 = require("../text-input/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Number input.
 *
 * @element cds-number-input
 * @fires cds-number-input
 *   The name of the custom event fired after the value is changed upon a user gesture.
 * @slot helper-text - The helper text.
 * @slot label-text - The label text.
 * @slot validity-message - The validity message. If present and non-empty, this input shows the UI of its invalid state.
 */ let CDSNumberInput = class CDSNumberInput extends (0, _textInputJsDefault.default) {
    constructor(){
        super(...arguments);
        this._min = "";
        this._max = "";
        this._step = "1";
        /**
         * Aria text for the button that increments the value
         */ this.incrementButtonAssistiveText = "increase number input";
        /**
         * Aria text for the button that decrements the value
         */ this.decrementButtonAssistiveText = "decrease number input";
        /**
         * Specify whether you want the steppers to be hidden
         */ this.hideSteppers = false;
        /**
         * `true` to allow empty string.
         */ this.allowEmpty = false;
        /**
         * The input box size.
         */ this.size = (0, _defsJs1.INPUT_SIZE).MEDIUM;
    }
    /**
     * Handles `input` event on the `<input>` in the shadow DOM.
     */ _handleInput(event) {
        const { target } = event;
        const { value } = target;
        this.dispatchEvent(new CustomEvent(this.constructor.eventInput, {
            bubbles: true,
            composed: true,
            cancelable: false,
            detail: {
                value
            }
        }));
        super._handleInput(event);
    }
    /**
     * Handles `click` event on the up button in the shadow DOM.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _handleUserInitiatedStepDown(_) {
        const { _input: input } = this;
        this.stepDown();
        this.dispatchEvent(new CustomEvent(this.constructor.eventInput, {
            bubbles: true,
            composed: true,
            cancelable: false,
            detail: {
                value: input.value
            }
        }));
    }
    /**
     * Handles `click` event on the down button in the shadow DOM.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _handleUserInitiatedStepUp(_) {
        const { _input: input } = this;
        this.stepUp();
        this.dispatchEvent(new CustomEvent(this.constructor.eventInput, {
            bubbles: true,
            composed: true,
            cancelable: false,
            detail: {
                value: input.value
            }
        }));
    }
    _getInputValidity() {
        var _a, _b;
        if (this.invalid) return false;
        if (((_a = this._input) === null || _a === void 0 ? void 0 : _a.valueAsNumber) > Number(this.max) || ((_b = this._input) === null || _b === void 0 ? void 0 : _b.valueAsNumber) < Number(this.min)) return false;
        if (this.value === "") return this.allowEmpty;
        return true;
    }
    /**
     * The minimum value allowed in the input
     */ get min() {
        return this._min.toString();
    }
    set min(value) {
        const oldValue = this.min;
        this._min = value;
        this.requestUpdate("min", oldValue);
    }
    /**
     * The maximum value allowed in the input
     */ get max() {
        return this._max.toString();
    }
    set max(value) {
        const oldValue = this.max;
        this._max = value;
        this.requestUpdate("max", oldValue);
    }
    /**
     * The amount the value should increase or decrease by
     */ get step() {
        return this._step.toString();
    }
    set step(value) {
        const oldValue = this.step;
        this._step = value;
        this.requestUpdate("step", oldValue);
    }
    /**
     * Handles incrementing the value in the input
     */ stepUp() {
        this._input.stepUp();
    }
    /**
     * Handles decrementing the value in the input
     */ stepDown() {
        this._input.stepDown();
    }
    render() {
        const { _handleInput: handleInput, _handleUserInitiatedStepDown: handleUserInitiatedStepDown, _handleUserInitiatedStepUp: handleUserInitiatedStepUp } = this;
        const isValid = this._getInputValidity();
        const invalidIcon = (0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--number__invalid`
        });
        const warnIcon = (0, _16JsDefault1.default)({
            class: `${(0, _settingsJs.prefix)}--number__invalid ${(0, _settingsJs.prefix)}--number__invalid--warning`
        });
        const normalizedProps = {
            disabled: !this.readonly && this.disabled,
            invalid: !this.readonly && !isValid,
            warn: !this.readonly && isValid && this.warn,
            "slot-name": "",
            "slot-text": "",
            icon: null
        };
        const wrapperClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--number`]: true,
            [`${0, _settingsJs.prefix}--number--${this.size}`]: this.size,
            [`${0, _settingsJs.prefix}--number--nosteppers`]: this.hideSteppers,
            [`${0, _settingsJs.prefix}--number--readonly`]: this.readonly
        });
        const inputWrapperClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--number__input-wrapper`]: true,
            [`${0, _settingsJs.prefix}--number__input-wrapper--warning`]: normalizedProps.warn,
            [`${0, _settingsJs.prefix}--number__input-wrapper--slug`]: this._hasAILabel
        });
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--label`]: true,
            [`${0, _settingsJs.prefix}--label--disabled`]: normalizedProps.disabled,
            [`${0, _settingsJs.prefix}--visually-hidden`]: this.hideLabel
        });
        const helperTextClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--form__helper-text`]: true,
            [`${0, _settingsJs.prefix}--form__helper-text--disabled`]: normalizedProps.disabled
        });
        const incrementButton = (0, _lit.html)`
      <button
        class="${(0, _settingsJs.prefix)}--number__control-btn up-icon"
        aria-label="${this.incrementButtonAssistiveText}"
        aria-live="polite"
        aria-atomic="true"
        type="button"
        ?disabled=${normalizedProps.disabled}
        @click=${handleUserInitiatedStepUp}>
        ${(0, _16JsDefault2.default)()}
      </button>
      <div class="${(0, _settingsJs.prefix)}--number__rule-divider"></div>
    `;
        const decrementButton = (0, _lit.html)`
      <button
        class="${(0, _settingsJs.prefix)}--number__control-btn down-icon"
        aria-label="${this.decrementButtonAssistiveText}"
        aria-live="polite"
        aria-atomic="true"
        type="button"
        ?disabled=${normalizedProps.disabled}
        @click=${handleUserInitiatedStepDown}>
        ${(0, _16JsDefault3.default)()}
      </button>
      <div class="${(0, _settingsJs.prefix)}--number__rule-divider"></div>
    `;
        const input = (0, _lit.html)`
      <input
        autocomplete="${this.autocomplete}"
        ?autofocus="${this.autofocus}"
        ?data-invalid="${normalizedProps.invalid}"
        ?disabled="${normalizedProps.disabled}"
        id="input"
        name="${(0, _ifNonEmptyJsDefault.default)(this.name)}"
        pattern="${(0, _ifNonEmptyJsDefault.default)(this.pattern)}"
        ?readonly="${this.readonly}"
        ?required="${this.required}"
        type="number"
        .value="${this._value}"
        @input="${handleInput}"
        min="${(0, _ifNonEmptyJsDefault.default)(this.min)}"
        max="${(0, _ifNonEmptyJsDefault.default)(this.max)}"
        step="${(0, _ifNonEmptyJsDefault.default)(this.step)}"
        role="alert"
        aria-atomic="true" />
    `;
        if (normalizedProps.invalid) {
            normalizedProps.icon = invalidIcon;
            normalizedProps["slot-name"] = "invalid-text";
            normalizedProps["slot-text"] = this.invalidText;
        } else if (normalizedProps.warn) {
            normalizedProps.icon = warnIcon;
            normalizedProps["slot-name"] = "warn-text";
            normalizedProps["slot-text"] = this.warnText;
        }
        return (0, _lit.html)`
      <div class="${wrapperClasses}" ?data-invalid=${normalizedProps.invalid}>
        <label class="${labelClasses}" for="input">
          <slot name="label-text"> ${this.label} </slot>
        </label>
        <div class="${inputWrapperClasses}">
          ${normalizedProps.icon} ${input}
          <slot name="ai-label" @slotchange="${this._handleSlotChange}"></slot>
          <slot name="slug" @slotchange="${this._handleSlotChange}"></slot>
          <div class="${0, _settingsJs.prefix}--number__controls">
            ${!this.hideSteppers ? (0, _lit.html)`${decrementButton} ${incrementButton}` : null}
          </div>
        </div>
        <div
          class="${helperTextClasses}"
          ?hidden="${normalizedProps.invalid || normalizedProps.warn}">
          <slot name="helper-text"> ${this.helperText} </slot>
        </div>
        <div
          class="${0, _settingsJs.prefix}--form-requirement"
          ?hidden="${!normalizedProps.invalid && !normalizedProps.warn}">
          <slot name="${normalizedProps["slot-name"]}">
            ${normalizedProps["slot-text"]}
          </slot>
        </div>
      </div>
    `;
    }
    /**
     * The name of the custom event fired after the value is changed upon a user gesture.
     */ static get eventInput() {
        return `${0, _settingsJs.prefix}-number-input`;
    }
};
CDSNumberInput.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSNumberInput.styles = (0, _numberInputScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("input")
], CDSNumberInput.prototype, "_input", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSNumberInput.prototype, "min", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSNumberInput.prototype, "max", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSNumberInput.prototype, "step", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "increment-button-assistive-text"
    })
], CDSNumberInput.prototype, "incrementButtonAssistiveText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "decrement-button-assistive-text"
    })
], CDSNumberInput.prototype, "decrementButtonAssistiveText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "hide-steppers",
        reflect: true
    })
], CDSNumberInput.prototype, "hideSteppers", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "allow-empty",
        reflect: true
    })
], CDSNumberInput.prototype, "allowEmpty", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSNumberInput.prototype, "size", void 0);
CDSNumberInput = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-number-input`)
], CDSNumberInput);
var CDSNumberInput$1 = CDSNumberInput;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/class-map.js":"2fQud","../../globals/settings.js":"EipuL","../../icons/warning--filled/16.js":"ajngV","../../icons/warning--alt--filled/16.js":"21PDf","../../icons/add/16.js":"ks2lc","../../icons/subtract/16.js":"iXQGp","../../globals/directives/if-non-empty.js":"5Xlqk","./defs.js":"lVHp1","./number-input.scss.js":"45mOP","../text-input/text-input.js":"lBj7P","../../globals/decorators/carbon-element.js":"kNhLR","../text-input/defs.js":"83oMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iXQGp":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M8 15H24V17H8z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lVHp1":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NUMBER_INPUT_COLOR_SCHEME", ()=>(0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME));
parcelHelpers.export(exports, "NUMBER_INPUT_VALIDATION_STATUS", ()=>NUMBER_INPUT_VALIDATION_STATUS);
var _sharedEnumsJs = require("../../globals/shared-enums.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Works in conjunction with VALIDATION_STATUS
 */ var NUMBER_INPUT_VALIDATION_STATUS;
(function(NUMBER_INPUT_VALIDATION_STATUS) {
    NUMBER_INPUT_VALIDATION_STATUS["EXCEEDED_MAXIMUM"] = "exceeded_maximum";
    NUMBER_INPUT_VALIDATION_STATUS["EXCEEDED_MINIMUM"] = "exceeded_minimum";
})(NUMBER_INPUT_VALIDATION_STATUS || (NUMBER_INPUT_VALIDATION_STATUS = {}));

},{"../../globals/shared-enums.js":"12kea","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"45mOP":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--number__controls:hover .cds--number__control-btn:after,.cds--number__input-wrapper--decorator .cds--number__rule-divider,.cds--number__input-wrapper--slug .cds--number__rule-divider{display:none}.cds--number__input-wrapper--decorator .cds--number__control-btn:hover,.cds--number__input-wrapper--slug .cds--number__control-btn:hover{box-shadow:0 -1px 0 var(--cds-ai-border-strong,#4589ff) inset}.cds--number__controls:focus-within .cds--number__control-btn:after{display:none}.cds--number{display:flex;flex-direction:column;inline-size:100%;position:relative}.cds--number html{font-size:100%}.cds--number body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--number code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--number strong{font-weight:600}.cds--number .cds--number__input-wrapper--warning input[type=number]{padding-inline-end:8rem}.cds--number input[type=number]{-moz-appearance:textfield;-webkit-appearance:textfield;appearance:textfield;background-color:var(--cds-field);block-size:2.5rem;border:0;border-block-end:.0625rem solid var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);display:inline-flex;font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);font-weight:400;inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);min-inline-size:9.375rem;outline:2px solid transparent;outline-offset:-2px;padding-inline:1rem 6rem;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--number input[type=number]:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--number input[type=number]:focus{outline-style:dotted}}.cds--number input[type=number]:disabled~.cds--number__controls{cursor:not-allowed;pointer-events:none}.cds--number input[type=number]:disabled~.cds--number__controls svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--number input[type=number]::-ms-clear{display:none}.cds--number input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none;appearance:none}.cds--number input[type=number][data-invalid]{padding-inline-end:8rem}.cds--number--lg.cds--number input[type=number]{padding-inline-end:7rem}.cds--number--lg.cds--number .cds--number__input-wrapper--warning input[type=number],.cds--number--lg.cds--number input[type=number][data-invalid]{padding-inline-end:9rem}.cds--number--sm.cds--number input[type=number]{padding-inline-end:5rem}.cds--number--sm.cds--number .cds--number__input-wrapper--warning input[type=number],.cds--number--sm.cds--number input[type=number][data-invalid]{padding-inline-end:7rem}.cds--number input[type=number]:disabled{background-color:var(--cds-field);border-block-end-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--number__input-wrapper{align-items:center;display:flex;position:relative}.cds--number__controls{align-items:center;block-size:100%;display:flex;flex-direction:row;inline-size:5rem;inset-block-start:50%;inset-inline-end:0;justify-content:center;position:absolute;transform:translateY(-50%)}.cds--number__controls html{font-size:100%}.cds--number__controls body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--number__controls code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--number__controls strong{font-weight:600}.cds--number__control-btn{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:100%;border:0;box-sizing:border-box;color:var(--cds-icon-primary,#161616);cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--number__control-btn *,.cds--number__control-btn :after,.cds--number__control-btn :before{box-sizing:inherit}.cds--number__control-btn::-moz-focus-inner{border:0}.cds--number__control-btn svg{fill:currentColor}.cds--number__control-btn:focus{color:var(--cds-icon-primary,#161616);outline:1px solid var(--cds-focus,#0f62fe);outline-offset:-2px;outline-width:2px}@media screen and (prefers-contrast){.cds--number__control-btn:focus{outline-style:dotted}}.cds--number__control-btn:hover{background-color:var(--cds-field-hover);box-shadow:0 -1px 0 var(--cds-border-strong) inset;color:var(--cds-icon-primary,#161616);cursor:pointer}.cds--number__control-btn:disabled{border-block-end-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--number__control-btn.down-icon{order:1}.cds--number__control-btn.up-icon{order:2}.cds--number input[type=number][data-invalid]~.cds--number__controls .cds--number__control-btn{border-block-end-color:var(--cds-support-error,#da1e28)}.cds--number input[type=number]:focus~.cds--number__controls .cds--number__control-btn{border-color:var(--cds-focus,#0f62fe);border-style:solid;border-width:2px 0;box-shadow:none;outline-offset:-2px}.cds--number input[type=number]:focus~.cds--number__controls .cds--number__control-btn:last-of-type:hover{box-shadow:-4px 0 0 -2px var(--cds-focus,#0f62fe) inset}.cds--number input[type=number][data-invalid]:not(:focus)~.cds--number__controls .cds--number__control-btn:last-of-type:hover{box-shadow:-4px 0 0 -2px var(--cds-support-error,#da1e28) inset}.cds--number input[type=number][data-invalid]:not(:focus)~.cds--number__controls .cds--number__control-btn:hover{border-color:var(--cds-support-error,#da1e28);border-style:solid;border-width:2px 0;box-shadow:none;outline-offset:-2px}.cds--number input[type=number][data-invalid]:not(:focus)~.cds--number__controls .cds--number__control-btn:focus:hover{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--number input[type=number][data-invalid]:not(:focus)~.cds--number__controls .cds--number__control-btn:focus:hover{outline-style:dotted}}.cds--number__rule-divider{background-color:var(--cds-border-subtle);block-size:1rem;inline-size:.0625rem;position:absolute;z-index:6000}.cds--number__rule-divider:first-of-type{order:0}.cds--number__controls .cds--number__rule-divider:first-of-type{background-color:transparent;inset-inline-start:0}.cds--number__invalid+.cds--number__controls .cds--number__rule-divider:first-of-type{background-color:var(--cds-border-subtle)}.cds--number--light .cds--number__invalid+.cds--number__controls .cds--number__rule-divider:first-of-type,.cds--number--light .cds--number__rule-divider{background-color:var(--cds-border-subtle-02,#e0e0e0)}.cds--number input[type=number]:disabled+.cds--number__controls .cds--number__rule-divider:first-of-type{background-color:transparent}.cds--number input[type=number]:disabled+.cds--number__controls .cds--number__rule-divider{background-color:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--number__control-btn:focus~.cds--number__rule-divider{background-color:transparent}.cds--number__invalid{position:absolute;fill:var(--cds-support-error,#da1e28);inset-inline-end:6rem}.cds--number--lg .cds--number__invalid{inset-inline-end:7rem}.cds--number--sm .cds--number__invalid{inset-inline-end:5rem}.cds--number__invalid+.cds--number__rule-divider{inset-inline-end:5rem;position:absolute}.cds--number--lg .cds--number__invalid+.cds--number__rule-divider{inset-inline-end:6rem}.cds--number--sm .cds--number__invalid+.cds--number__rule-divider{inset-inline-end:4rem}.cds--number__control-btn.down-icon:focus~.cds--number__rule-divider,.cds--number__control-btn.down-icon:hover~.cds--number__rule-divider,.cds--number__control-btn.up-icon:focus+.cds--number__rule-divider,.cds--number__control-btn.up-icon:hover+.cds--number__rule-divider{background-color:transparent}.cds--number__invalid--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--number__invalid--warning path:first-of-type{fill:#000;opacity:1}.cds--number--lg input[type=number]{block-size:3rem}.cds--number--lg .cds--number__controls{inline-size:6rem}.cds--number--lg .cds--number__control-btn{inline-size:3rem}.cds--number--sm input[type=number]{block-size:2rem}.cds--number--sm .cds--number__controls{inline-size:4rem}.cds--number--sm .cds--number__control-btn{inline-size:2rem}.cds--number--nolabel .cds--label+.cds--form__helper-text{margin-block-start:0}.cds--number--nosteppers input[type=number]{padding-inline-end:0}.cds--number--nosteppers .cds--number__input-wrapper--warning input[type=number],.cds--number--nosteppers input[type=number][data-invalid]{padding-inline-end:3rem}.cds--number--nosteppers .cds--number__invalid{inset-inline-end:1rem}.cds--number--readonly input[type=number]{background:transparent;border-block-end-color:var(--cds-border-subtle)}.cds--number--readonly .cds--number__control-btn{color:var(--cds-icon-disabled,hsla(0,0%,9%,.25));pointer-events:none}.cds--number--readonly .cds--number__control-btn:hover{background-color:transparent;cursor:pointer}.cds--number--readonly input[type=number]:focus~.cds--number__controls .cds--number__control-btn:hover{outline:none}.cds--number--readonly .cds--number__controls:hover .cds--number__rule-divider:not(:first-of-type){background-color:var(--cds-border-subtle)}.cds--number__input-wrapper--decorator .cds--number__input-inner-wrapper--decorator>*,.cds--number__input-wrapper--slug .cds--ai-label,.cds--number__input-wrapper--slug .cds--slug{inset-block-start:50%;inset-inline-end:6rem;position:absolute;transform:translateY(-50%)}.cds--number__input-wrapper--decorator .cds--number__input-inner-wrapper--decorator:not(:has(.cds--ai-label))>*{block-size:1rem}.cds--number__input-wrapper--decorator .cds--number__control-btn:after,.cds--number__input-wrapper--decorator .cds--number__control-btn:before,.cds--number__input-wrapper--decorator .cds--number__input-inner-wrapper--decorator>:before,.cds--number__input-wrapper--slug .cds--ai-label:before,.cds--number__input-wrapper--slug .cds--number__control-btn:after,.cds--number__input-wrapper--slug .cds--number__control-btn:before,.cds--number__input-wrapper--slug .cds--slug:before{background-color:var(--cds-border-subtle);block-size:1rem;content:"";inline-size:.0625rem;position:absolute}.cds--number__input-wrapper--decorator .cds--number__input-inner-wrapper--decorator>:before,.cds--number__input-wrapper--slug .cds--ai-label:before,.cds--number__input-wrapper--slug .cds--slug:before{display:none;inset-inline-start:-1rem}.cds--number__control-btn:after{display:block;inset-inline-end:0}.cds--number__input-wrapper--decorator .cds--number__control-btn:before,.cds--number__input-wrapper--slug .cds--number__control-btn:before{display:block;inset-inline-end:2.5rem}.cds--number__input-wrapper--decorator .cds--number__control-btn:focus:before,.cds--number__input-wrapper--slug .cds--number__control-btn:focus:before{display:none}.cds--number__control-btn:hover:after,.cds--number__control-btn:hover:before{display:none;inset-inline-end:0}.cds--number__input-wrapper:has(.cds--number__control-btn:hover)~.cds--number__input-wrapper--decorator:after,.cds--number__input-wrapper:has(.cds--number__control-btn:hover)~.cds--number__input-wrapper--slug:after{display:none}.cds--number__control-btn:has(.up-icon):after,.cds--number__control-btn:has(.up-icon):before{display:none}.cds--number__input-wrapper--decorator .cds--number__invalid,.cds--number__input-wrapper--slug .cds--number__invalid{inset-inline-end:9rem}.cds--number__input-wrapper--decorator:has(.cds--number__invalid) .cds--number__input-inner-wrapper--decorator>:before,.cds--number__input-wrapper--slug:has(.cds--number__invalid) .cds--ai-label:before,.cds--number__input-wrapper--slug:has(.cds--number__invalid) .cds--slug:before{display:block}.cds--number .cds--number__input-wrapper--decorator input[data-invalid],.cds--number .cds--number__input-wrapper--decorator.cds--number__input-wrapper--warning input,.cds--number .cds--number__input-wrapper--slug input[data-invalid],.cds--number .cds--number__input-wrapper--slug.cds--number__input-wrapper--warning input{padding-inline-end:9rem}.cds--number__input-wrapper--decorator input[type=number]:has(~.cds--number__input-inner-wrapper--decorator .cds--ai-label):not(:has(~.cds--number__input-inner-wrapper--decorator .cds--ai-label--revert)),.cds--number__input-wrapper--slug input[type=number]:disabled,.cds--number__input-wrapper--slug input[type=number]:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--number__input-wrapper--slug input[type=number]:has(~.cds--slug):not(:has(~.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff);padding-inline-end:9.0625rem}.cds--number.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:100%;padding:0;pointer-events:none;position:relative}.cds--number.cds--skeleton:active,.cds--number.cds--skeleton:focus,.cds--number.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--number.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--number.cds--skeleton:before{animation:none}}.cds--number.cds--skeleton input[type=number]{display:none}.cds--number.cds--skeleton.cds--number--sm{block-size:2rem}.cds--number.cds--skeleton.cds--number--md{block-size:2.5rem}.cds--number.cds--skeleton.cds--number--lg{block-size:3rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--number__control-btn:focus,.cds--number__control-btn:hover{color:Highlight;outline:1px solid Highlight}.cds--number__control-btn{outline:1px solid transparent}.cds--number__control-btn svg{fill:ButtonText}}:host(cds-number-input),:host(cds-number-input-skeleton){inline-size:100%;outline:none}:host(cds-number-input) .cds--form-requirement[hidden],:host(cds-number-input-skeleton) .cds--form-requirement[hidden]{display:none}.cds--number .cds--number__invalid~input[type=number]:disabled+.cds--number__controls .cds--number__rule-divider:first-of-type,.cds--number__invalid~.cds--number__controls .cds--number__rule-divider:first-of-type{background-color:var(--cds-border-subtle)}.cds--number--readonly .cds--number__controls .cds--number__control-btn{border-block-end:0}:host(cds-number-input) ::slotted(cds-ai-label),:host(cds-number-input) ::slotted(cds-slug){inset-block-start:50%;inset-inline-end:5.5rem;position:absolute}:host(cds-number-input) ::slotted(cds-ai-label:not([revert-active])),:host(cds-number-input) ::slotted(cds-slug:not([revert-active])){transform:translateY(-50%)}:host(cds-number-input) .cds--number[data-invalid] ::slotted(cds-ai-label),:host(cds-number-input) .cds--number[data-invalid] ::slotted(cds-slug),:host(cds-number-input[invalid]) ::slotted(cds-ai-label),:host(cds-number-input[invalid]) ::slotted(cds-slug),:host(cds-number-input[warn]) ::slotted(cds-ai-label),:host(cds-number-input[warn]) ::slotted(cds-slug){inset-inline-end:7.5rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"guF5G":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSNumberInputSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _numberInputScssJs = require("./number-input.scss.js");
var _numberInputScssJsDefault = parcelHelpers.interopDefault(_numberInputScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of number input.
 */ let CDSNumberInputSkeleton = class CDSNumberInputSkeleton extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if the label should be hidden. Corresponds to the attribute with the same name.
         */ this.hideLabel = false;
    }
    render() {
        const { hideLabel } = this;
        return (0, _lit.html)`
      ${!hideLabel && (0, _lit.html)` <span class="${0, _settingsJs.prefix}--label ${0, _settingsJs.prefix}--skeleton"></span> `}
      <div class="${0, _settingsJs.prefix}--number ${0, _settingsJs.prefix}--skeleton"></div>
    `;
    }
};
CDSNumberInputSkeleton.styles = (0, _numberInputScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "hide-label"
    })
], CDSNumberInputSkeleton.prototype, "hideLabel", void 0);
CDSNumberInputSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-number-input-skeleton`)
], CDSNumberInputSkeleton);
var CDSNumberInputSkeleton$1 = CDSNumberInputSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./number-input.scss.js":"45mOP","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUifs":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _overflowMenuJs = require("./overflow-menu.js");
var _overflowMenuBodyJs = require("./overflow-menu-body.js");
var _overflowMenuItemJs = require("./overflow-menu-item.js");

},{"./overflow-menu.js":"4ZuXC","./overflow-menu-body.js":"aNSR6","./overflow-menu-item.js":"80Ejl"}],"4ZuXC":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OVERFLOW_MENU_SIZE", ()=>(0, _defsJs.OVERFLOW_MENU_SIZE));
parcelHelpers.export(exports, "default", ()=>CDSOverflowMenu$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _defsJs = require("./defs.js");
var _overflowMenuScssJs = require("./overflow-menu.scss.js");
var _overflowMenuScssJsDefault = parcelHelpers.interopDefault(_overflowMenuScssJs);
var _iconButtonJs = require("../icon-button/icon-button.js");
var _iconButtonJsDefault = parcelHelpers.interopDefault(_iconButtonJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Overflow menu.
 *
 * @element cds-overflow-menu
 * @slot icon - The icon for the trigger button.
 */ let CDSOverflowMenu = class CDSOverflowMenu extends (0, _hostListenerJsDefault1.default)((0, _focusJsDefault.default)((0, _iconButtonJsDefault.default))) {
    constructor(){
        super(...arguments);
        /**
         * The menu body.
         */ this._menuBody = null;
        /**
         * Handles `click` event on the trigger button.
         */ this._handleClickTrigger = async ()=>{
            this._handleUserInitiatedToggle();
        };
        /**
         * Handles `keydown` event on the trigger button.
         */ this._handleKeydownTrigger = async (event)=>{
            if (event.key === " " || event.key === "Enter") {
                this._handleUserInitiatedToggle();
                event.preventDefault();
            }
        };
        /**
         * `true` if this tooltip is in a data table row
         */ this.dataTable = false;
        /**
         * `true` if this overflow menu should be disabled.
         */ this.disabled = false;
        /**
         * `true` if this overflow menu body should be flipped.
         */ this.flipped = false;
        /**
         * `true` if the dropdown should be open.
         */ this.open = false;
        /**
         * Index (starting at 1) of overflow menu item to focus on open.
         */ this.index = 1;
        /**
         * Overflow menu size.
         */ this.size = (0, _defsJs.OVERFLOW_MENU_SIZE).MEDIUM;
        /**
         * `true` if this menu is a toolbar action
         */ this.toolbarAction = false;
    }
    /**
     * Handles user-initiated toggling of the menu.
     */ async _handleUserInitiatedToggle() {
        this.open = !this.open;
        const { index, open, updateComplete } = this;
        if (open) {
            await updateComplete;
            const { _menuBody: menuBody } = this;
            const menuItem = menuBody === null || menuBody === void 0 ? void 0 : menuBody.querySelector(`${(0, _settingsJs.prefix)}-overflow-menu-item:nth-of-type(${index})`);
            menuItem === null || menuItem === void 0 || menuItem.focus();
        }
    }
    /**
     * @returns The position of the trigger button in the viewport.
     */ get triggerPosition() {
        return this.getBoundingClientRect();
    }
    connectedCallback() {
        if (!this.hasAttribute("aria-haspopup")) this.setAttribute("aria-haspopup", "true");
        if (!this.shadowRoot) this.attachShadow({
            mode: "open"
        });
        super.connectedCallback();
    }
    updated(changedProperties) {
        var _a, _b, _c, _d, _e, _f, _g;
        const button = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`${(0, _settingsJs.prefix)}-tooltip`)) === null || _b === void 0 ? void 0 : _b.querySelector("button");
        button === null || button === void 0 || button.classList.add(`${(0, _settingsJs.prefix)}--btn--icon-only`, `${(0, _settingsJs.prefix)}--overflow-menu`);
        if (changedProperties.has("open")) {
            const { open } = this;
            if (open && !this._menuBody) this._menuBody = (0, _collectionHelpersJs.find)(this.childNodes, (elem)=>elem.constructor.FLOATING_MENU);
            const { _menuBody: menuBody } = this;
            if (menuBody) {
                menuBody.open = open;
                const tooltipContent = (_c = this.querySelector("[slot=tooltip-content]")) === null || _c === void 0 ? void 0 : _c.textContent;
                button === null || button === void 0 || button.setAttribute("aria-expanded", String(Boolean(open)));
                button === null || button === void 0 || button.setAttribute("aria-label", String(tooltipContent));
            }
        }
        if (changedProperties.has("dataTable")) {
            const tooltip = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector(`${(0, _settingsJs.prefix)}-tooltip`);
            tooltip === null || tooltip === void 0 || tooltip.setAttribute("data-table", "");
        }
        if (changedProperties.has("size")) {
            const { size } = this;
            const { _menuBody: menuBody } = this;
            if (menuBody) menuBody.size = size;
            button === null || button === void 0 || button.classList.forEach((item)=>{
                if (item.startsWith(`${(0, _settingsJs.prefix)}--overflow-menu--`)) button === null || button === void 0 || button.classList.remove(item);
            });
            button === null || button === void 0 || button.classList.add(`${(0, _settingsJs.prefix)}--overflow-menu--${this.size}`);
            const tooltip = (_e = this.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector(`${(0, _settingsJs.prefix)}-tooltip`);
            tooltip === null || tooltip === void 0 || tooltip.setAttribute("size", this.size);
        }
        if (changedProperties.has("toolbarAction") && this.toolbarAction) (_g = (_f = this.shadowRoot) === null || _f === void 0 ? void 0 : _f.querySelector(`${(0, _settingsJs.prefix)}-tooltip`)) === null || _g === void 0 || _g.setAttribute("toolbar-action", "");
        super.updated(changedProperties);
    }
    render() {
        return (0, _lit.html)` ${super.render()} `;
    }
};
CDSOverflowMenu.styles = (0, _overflowMenuScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("click")
], CDSOverflowMenu.prototype, "_handleClickTrigger", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("keydown")
], CDSOverflowMenu.prototype, "_handleKeydownTrigger", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "data-table"
    })
], CDSOverflowMenu.prototype, "dataTable", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSOverflowMenu.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSOverflowMenu.prototype, "flipped", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSOverflowMenu.prototype, "open", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSOverflowMenu.prototype, "index", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSOverflowMenu.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "toolbar-action",
        reflect: true
    })
], CDSOverflowMenu.prototype, "toolbarAction", void 0);
CDSOverflowMenu = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-overflow-menu`)
], CDSOverflowMenu);
var CDSOverflowMenu$1 = CDSOverflowMenu;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/focus.js":"5k7ow","../../globals/mixins/host-listener.js":"1SMUX","../../globals/internal/collection-helpers.js":"4aZkz","./defs.js":"de8Gh","./overflow-menu.scss.js":"cr7YM","../icon-button/icon-button.js":"8LTa1","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"de8Gh":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Overflow menu size.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NAVIGATION_DIRECTION", ()=>NAVIGATION_DIRECTION);
parcelHelpers.export(exports, "OVERFLOW_MENU_SIZE", ()=>OVERFLOW_MENU_SIZE);
var OVERFLOW_MENU_SIZE;
(function(OVERFLOW_MENU_SIZE) {
    /**
     * Small size.
     */ OVERFLOW_MENU_SIZE["SMALL"] = "sm";
    /**
     * Medium size.
     */ OVERFLOW_MENU_SIZE["MEDIUM"] = "md";
    /**
     * Large size.
     */ OVERFLOW_MENU_SIZE["LARGE"] = "lg";
})(OVERFLOW_MENU_SIZE || (OVERFLOW_MENU_SIZE = {}));
const NAVIGATION_DIRECTION = {
    ArrowDown: 1,
    ArrowUp: -1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cr7YM":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--overflow-menu,.cds--overflow-menu__trigger,:host(cds-breadcrumb-overflow-menu),:host(cds-overflow-menu){align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2.5rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2.5rem;justify-content:center;margin:0;min-block-size:2.5rem;outline:2px solid transparent;outline-offset:-2px;padding:0;position:relative;text-align:start;transition:outline .11s cubic-bezier(0,0,.38,.9),background-color .11s cubic-bezier(0,0,.38,.9);vertical-align:baseline}.cds--overflow-menu::-moz-focus-inner,.cds--overflow-menu__trigger::-moz-focus-inner{border:0}.cds--overflow-menu *,.cds--overflow-menu :after,.cds--overflow-menu :before,.cds--overflow-menu__trigger *,.cds--overflow-menu__trigger :after,.cds--overflow-menu__trigger :before,:host(cds-breadcrumb-overflow-menu) *,:host(cds-breadcrumb-overflow-menu) :after,:host(cds-breadcrumb-overflow-menu) :before,:host(cds-overflow-menu) *,:host(cds-overflow-menu) :after,:host(cds-overflow-menu) :before{box-sizing:inherit}.cds--overflow-menu:focus,.cds--overflow-menu__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--overflow-menu:focus,.cds--overflow-menu__trigger:focus{outline-style:dotted}}.cds--overflow-menu:hover,.cds--overflow-menu__trigger:hover{background-color:var(--cds-layer-hover)}.cds--overflow-menu>:first-child,:host(cds-breadcrumb-overflow-menu)>:first-child,:host(cds-overflow-menu)>:first-child{margin-block-start:0}.cds--overflow-menu--sm,:host(cds-breadcrumb-overflow-menu[size=sm]),:host(cds-overflow-menu[size=sm]){block-size:2rem;inline-size:2rem;min-block-size:2rem}.cds--overflow-menu--lg,:host(cds-breadcrumb-overflow-menu[size=lg]),:host(cds-overflow-menu[size=lg]){block-size:3rem;inline-size:3rem}.cds--overflow-menu__trigger.cds--tooltip--a11y.cds--tooltip__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--overflow-menu__trigger.cds--tooltip--a11y.cds--tooltip__trigger:focus{outline-style:dotted}}.cds--overflow-menu__trigger.cds--tooltip--a11y.cds--tooltip__trigger:focus svg{outline:none}.cds--overflow-menu.cds--overflow-menu--open,.cds--overflow-menu.cds--overflow-menu--open .cds--overflow-menu__trigger{background-color:var(--cds-layer);box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));transition:none}.cds--overflow-menu--light.cds--overflow-menu--open,.cds--overflow-menu--light.cds--overflow-menu--open .cds--overflow-menu__trigger{background-color:var(--cds-layer)}.cds--overflow-menu__icon,:host(cds-breadcrumb-overflow-menu) ::slotted(.cds--overflow-menu__icon),:host(cds-overflow-menu) ::slotted(.cds--overflow-menu__icon){block-size:1rem;fill:var(--cds-icon-primary,#161616);inline-size:1rem}.cds--overflow-menu__wrapper{line-height:0}.cds--overflow-menu-options,:host(cds-overflow-menu-body){align-items:flex-start;background-color:var(--cds-layer);border:0;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));box-sizing:border-box;display:none;flex-direction:column;font-family:inherit;font-size:100%;inline-size:10rem;inset-block-start:32px;inset-inline-start:0;list-style:none;margin:0;padding:0;position:absolute;vertical-align:baseline;z-index:6000}.cds--overflow-menu-options *,.cds--overflow-menu-options :after,.cds--overflow-menu-options :before,:host(cds-overflow-menu-body) *,:host(cds-overflow-menu-body) :after,:host(cds-overflow-menu-body) :before{box-sizing:inherit}.cds--overflow-menu-options:after{background-color:var(--cds-layer);content:"";display:block;position:absolute;transition:background-color .11s cubic-bezier(0,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--overflow-menu-options:after{transition:none}}.cds--overflow-menu-options--light,.cds--overflow-menu-options--light:after,.cds--overflow-menu.cds--overflow-menu--light.cds--overflow-menu--open:hover,.cds--overflow-menu.cds--overflow-menu--open:hover{background-color:var(--cds-layer)}.cds--overflow-menu-options[data-floating-menu-direction=bottom]:not(.cds--breadcrumb-menu-options):after{block-size:.1875rem;inline-size:2.5rem;inset-block-start:-.1875rem;inset-inline-start:0}.cds--overflow-menu-options[data-floating-menu-direction=top]:after{block-size:.5rem;inline-size:2.5rem;inset-block-end:-.5rem;inset-inline-start:0}.cds--overflow-menu-options[data-floating-menu-direction=left]:after{block-size:2.5rem;inline-size:.375rem;inset-block-start:0;inset-inline-end:-.375rem}.cds--overflow-menu-options[data-floating-menu-direction=right]:after{block-size:2.5rem;inline-size:.375rem;inset-block-start:0;inset-inline-start:-.375rem}.cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=bottom]:after,.cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=top]:after{inline-size:2rem}.cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=left]:after,.cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=right]:after{block-size:2rem}.cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=bottom]:after,.cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=top]:after{inline-size:3rem}.cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=left]:after,.cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=right]:after{block-size:3rem}.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=bottom]:after,.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=top]:after{inset-inline:auto 0}.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=left]:after,.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=right]:after{inset-block:auto 0}.cds--overflow-menu-options--open,:host(cds-overflow-menu-body[open]){display:flex}.cds--overflow-menu-options__content{inline-size:100%}.cds--overflow-menu-options__option,:host(cds-overflow-menu-item){align-items:center;background-color:transparent;block-size:2.5rem;border:0;box-sizing:border-box;display:flex;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;transition:background-color .11s cubic-bezier(0,0,.38,.9);vertical-align:baseline}.cds--overflow-menu-options__option *,.cds--overflow-menu-options__option :after,.cds--overflow-menu-options__option :before,:host(cds-overflow-menu-item) *,:host(cds-overflow-menu-item) :after,:host(cds-overflow-menu-item) :before{box-sizing:inherit}.cds--overflow-menu-options--sm .cds--overflow-menu-options__option,.cds--overflow-menu-options--sm :host(cds-overflow-menu-item),:host(cds-overflow-menu-body[size=sm]) .cds--overflow-menu-options__option,:host(cds-overflow-menu-body[size=sm]) :host(cds-overflow-menu-item){block-size:2rem}.cds--overflow-menu-options--lg .cds--overflow-menu-options__option,.cds--overflow-menu-options--lg :host(cds-overflow-menu-item),:host(cds-overflow-menu-body[size=lg]) .cds--overflow-menu-options__option,:host(cds-overflow-menu-body[size=lg]) :host(cds-overflow-menu-item){block-size:3rem}.cds--overflow-menu--divider,:host(cds-overflow-menu-item[divider]){border-block-start:1px solid var(--cds-border-subtle)}.cds--overflow-menu--light .cds--overflow-menu--divider,.cds--overflow-menu--light :host(cds-overflow-menu-item[divider]){border-block-start:1px solid var(--cds-border-subtle)}a.cds--overflow-menu-options__btn:before{block-size:100%;content:"";display:inline-block;vertical-align:middle}.cds--overflow-menu-options__btn{align-items:center;background-color:transparent;block-size:100%;border:none;color:var(--cds-text-secondary,#525252);cursor:pointer;display:inline-flex;font-family:inherit;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);font-weight:400;inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);max-inline-size:11.25rem;outline:2px solid transparent;outline-offset:-2px;padding:0 1rem;text-align:start;transition:outline .11s cubic-bezier(0,0,.38,.9),background-color .11s cubic-bezier(0,0,.38,.9),color .11s cubic-bezier(0,0,.38,.9)}.cds--overflow-menu-options__btn:hover{color:var(--cds-text-primary,#161616)}.cds--overflow-menu-options__btn:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--overflow-menu-options__btn:focus{outline-style:dotted}}.cds--overflow-menu-options__btn::-moz-focus-inner{border:none}.cds--overflow-menu-options__btn svg{fill:var(--cds-icon-secondary,#525252)}.cds--overflow-menu-options__btn:hover svg{fill:var(--cds-icon-primary,#161616)}.cds--overflow-menu-options__option-content{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cds--overflow-menu-options__option:hover{background-color:var(--cds-layer-hover)}.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:focus,.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:hover,:host(cds-overflow-menu-item[danger]) .cds--overflow-menu-options__btn:focus,:host(cds-overflow-menu-item[danger]) .cds--overflow-menu-options__btn:hover{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:focus svg,.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:hover svg,:host(cds-overflow-menu-item[danger]) .cds--overflow-menu-options__btn:focus svg,:host(cds-overflow-menu-item[danger]) .cds--overflow-menu-options__btn:hover svg{fill:currentColor}.cds--overflow-menu-options__option--disabled:hover{background-color:var(--cds-layer);cursor:not-allowed}.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn,:host(cds-overflow-menu-item[disabled]) .cds--overflow-menu-options__btn{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn:active,.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn:focus,.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn:hover,:host(cds-overflow-menu-item[disabled]) .cds--overflow-menu-options__btn:active,:host(cds-overflow-menu-item[disabled]) .cds--overflow-menu-options__btn:focus,:host(cds-overflow-menu-item[disabled]) .cds--overflow-menu-options__btn:hover{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:2px solid transparent;outline-offset:-2px}.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn svg,:host(cds-overflow-menu-item[disabled]) .cds--overflow-menu-options__btn svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--overflow-menu--flip{inset-inline-start:-140px}.cds--overflow-menu--flip:before{inset-inline-start:145px}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--overflow-menu-options__btn:focus,.cds--overflow-menu:focus{color:Highlight;outline:1px solid Highlight}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--overflow-menu svg,:host(cds-breadcrumb-overflow-menu) svg,:host(cds-overflow-menu) svg{fill:ButtonText}}.cds--overflow-menu__top-end,.cds--overflow-menu__top-start{transform:translateY(calc(-100% - var(--cds-popover-offset, 2.5rem)))}:host(cds-breadcrumb-overflow-menu[disabled]),:host(cds-overflow-menu[disabled]){cursor:not-allowed}:host(cds-breadcrumb-overflow-menu[disabled]) svg,:host(cds-overflow-menu[disabled]) svg{cursor:not-allowed;fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}:host(cds-breadcrumb-overflow-menu[disabled]:hover),:host(cds-overflow-menu[disabled]:hover){background-color:transparent}:host(cds-breadcrumb-overflow-menu[open]),:host(cds-overflow-menu[open]){background-color:var(--cds-layer-01,#f4f4f4);box-shadow:0 .125rem 6px 0 rgba(0,0,0,.3);transition:none}:host(cds-breadcrumb-overflow-menu[open]) :hover,:host(cds-overflow-menu[open]) :hover{background-color:var(--cds-layer)}:host(cds-overflow-menu-body[direction=top]){margin-block:0 .25rem}:host(cds-overflow-menu-item){outline:none}:host(cds-overflow-menu-item) button:hover{background-color:var(--cds-layer-hover)}:host(cds-overflow-menu-item[size=sm]){block-size:2rem}:host(cds-overflow-menu-item[size=lg]){block-size:3rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aNSR6":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSOverflowMenuBody$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _floatingMenuJs = require("../floating-menu/floating-menu.js");
var _floatingMenuJsDefault = parcelHelpers.interopDefault(_floatingMenuJs);
var _defsJs = require("./defs.js");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _overflowMenuScssJs = require("./overflow-menu.scss.js");
var _overflowMenuScssJsDefault = parcelHelpers.interopDefault(_overflowMenuScssJs);
var _defsJs1 = require("../floating-menu/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param index The index
 * @param length The length of the array.
 * @returns The new index, adjusting overflow/underflow.
 */ const capIndex = (index, length)=>{
    if (index < 0) return length - 1;
    if (index >= length) return 0;
    return index;
};
/**
 * Overflow menu body.
 *
 * @element cds-overflow-menu-body
 */ let CDSOverflowMenuBody = class CDSOverflowMenuBody extends (0, _floatingMenuJsDefault.default) {
    constructor(){
        super(...arguments);
        /**
         * The menu direction.
         */ this.direction = (0, _defsJs1.FLOATING_MENU_DIRECTION).BOTTOM;
        /**
         * How the menu is aligned to the trigger button.
         */ this.flipped = false;
        /**
         * `true` if the menu should be open.
         *
         * @private
         */ this.open = false;
        this.selected = null;
        /**
         * The overflow menu size.
         */ this.size = (0, _defsJs.OVERFLOW_MENU_SIZE).MEDIUM;
        /**
         * Handles `keydown` event on the menu body.
         */ this._handleKeydown = async (event)=>{
            const { key } = event;
            if (this.open) {
                /**
                 * sets this.selected to focused menu item. the menu item is focused
                 * automatically due to FocusMixin
                 */ if (this.contains(document.activeElement)) this.selected = document.activeElement;
                if (key in (0, _defsJs.NAVIGATION_DIRECTION)) this._navigate((0, _defsJs.NAVIGATION_DIRECTION)[key]);
                if (key === "Escape") this.open = false;
            }
        };
    }
    /**
     * @param currentItem The currently selected item.
     * @param direction The navigation direction.
     * @returns The item to be selected.
     */ _getNextItem(currentItem, direction) {
        const { selectorItemEnabled } = this.constructor;
        const menuItems = this.querySelectorAll(selectorItemEnabled);
        const currentIndex = (0, _collectionHelpersJs.indexOf)(menuItems, currentItem);
        const nextIndex = capIndex(currentIndex + direction, menuItems.length);
        return nextIndex === currentIndex ? null : menuItems[nextIndex];
    }
    /**
     * Navigates through overflow menu items.
     *
     * @param direction `-1` to navigate backward, `1` to navigate forward.
     */ _navigate(direction) {
        if (this.selected) {
            const nextItem = this._getNextItem(this.selected, direction);
            nextItem === null || nextItem === void 0 || nextItem.focus();
        }
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "menu");
        if (!this.hasAttribute("tabindex")) // TODO: Should we use a property?
        this.setAttribute("tabindex", "-1");
        super.connectedCallback();
    }
    updated(changedProperties) {
        if (changedProperties.has("size")) {
            const { selectorMenuItem } = this.constructor;
            const menuItems = this.querySelectorAll(selectorMenuItem);
            menuItems.forEach((item)=>{
                item.setAttribute("size", this.size);
            });
        }
        super.updated(changedProperties);
    }
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
    /**
     * A selector that will return menu items.
     */ static get selectorMenuItem() {
        return `${0, _settingsJs.prefix}-overflow-menu-item`;
    }
    /**
     * A selector that will return enabled menu items.
     */ static get selectorItemEnabled() {
        return `${0, _settingsJs.prefix}-overflow-menu-item:not([disabled])`;
    }
};
CDSOverflowMenuBody.styles = (0, _overflowMenuScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSOverflowMenuBody.prototype, "direction", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSOverflowMenuBody.prototype, "flipped", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSOverflowMenuBody.prototype, "open", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSOverflowMenuBody.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("keydown")
], CDSOverflowMenuBody.prototype, "_handleKeydown", void 0);
CDSOverflowMenuBody = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-overflow-menu-body`)
], CDSOverflowMenuBody);
var CDSOverflowMenuBody$1 = CDSOverflowMenuBody;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../floating-menu/floating-menu.js":"idlk7","./defs.js":"de8Gh","../../globals/decorators/host-listener.js":"f95Mj","../../globals/internal/collection-helpers.js":"4aZkz","../../globals/decorators/carbon-element.js":"kNhLR","./overflow-menu.scss.js":"cr7YM","../floating-menu/defs.js":"kkxy6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"idlk7":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FLOATING_MENU_DIRECTION", ()=>(0, _defsJs.FLOATING_MENU_DIRECTION));
parcelHelpers.export(exports, "FLOATING_MENU_POSITION_DIRECTION", ()=>(0, _defsJs.FLOATING_MENU_POSITION_DIRECTION));
parcelHelpers.export(exports, "default", ()=>CDSFloatingMenu);
var _tslib = require("tslib");
var _lit = require("lit");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _defsJs = require("./defs.js");
var _settingsJs = require("../../globals/settings.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Observes resize of the given element with the given resize observer.
 *
 * @param observer The resize observer.
 * @param elem The element to observe the resize.
 */ const observeResize = (observer, elem)=>{
    observer.observe(elem);
    return {
        release () {
            observer.unobserve(elem);
            return null;
        }
    };
};
/**
 * @param elem The starting element.
 * @param selector The CSS selector.
 * @returns {Element}
 *   The closest ancestor node of the given element that matches the given selector, crossing Shadow DOM boundary.
 */ const closestComposed = (elem, selector)=>{
    const found = elem.closest(selector);
    if (found) return found;
    const { host } = elem.getRootNode();
    if (host) return closestComposed(host, selector);
    return null;
};
/**
 * Floating menu.
 */ class CDSFloatingMenu extends (0, _hostListenerJsDefault1.default)((0, _focusJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * The handle for observing resize of the element containing the trigger button.
         */ this._hObserveResizeParent = null;
        /**
         * The handle for observing resize of the floating menu container.
         */ this._hObserveResizeContainer = null;
        /**
         * The `ResizeObserver` instance for observing element resizes for re-positioning floating menu position.
         */ // TODO: Wait for `.d.ts` update to support `ResizeObserver`
        // @ts-ignore
        this._resizeObserver = new ResizeObserver(()=>{
            const { container, open, parent, position } = this;
            if (container && open && parent) {
                const { direction, start, top } = position;
                this.style[direction !== (0, _defsJs.FLOATING_MENU_POSITION_DIRECTION).RTL ? "left" : "right"] = `${start}px`;
                this.style.top = `${top}px`;
            }
        });
        this._handleBlur = ({ relatedTarget })=>{
            if (!this.contains(relatedTarget)) {
                const { parent } = this;
                if (parent && parent !== relatedTarget) {
                    parent.open = false;
                    HTMLElement.prototype.focus.call(this.parent); // SVGElement in IE11 does not have `.focus()` method
                }
            }
        };
        this._click = ()=>{
            const { parent } = this;
            if (parent) parent.open = false;
        };
        this._handleKeyDown = (event)=>{
            if (event.key === "Tab") {
                if (event.shiftKey) {
                    const { parent } = this;
                    if (parent) parent.open = false;
                }
            }
        };
        /**
         * The DOM element, typically a custom element in this library, launching this floating menu.
         */ this.parent = null;
    }
    /**
     * The DOM element to put this menu into.
     */ get container() {
        return closestComposed(this, this.constructor.selectorContainer) || this.ownerDocument.body;
    }
    /**
     * The position of this floating menu.
     */ get position() {
        const { triggerPosition } = this.parent;
        if (!triggerPosition) throw new TypeError("Missing information of trigger button position.");
        const { container } = this;
        const { left: refLeft = 0, top: refTop = 0, right: refRight = 0 } = triggerPosition;
        let { bottom: refBottom = 0 } = triggerPosition;
        const { width, height } = this.getBoundingClientRect();
        const { left: containerLeft = 0, right: containerRight = 0, top: containerTop = 0 } = container.getBoundingClientRect();
        refBottom = refBottom - containerTop;
        const containerComputedStyle = container.ownerDocument.defaultView.getComputedStyle(container);
        const positionDirection = containerComputedStyle.getPropertyValue("direction");
        const isRtl = positionDirection === (0, _defsJs.FLOATING_MENU_POSITION_DIRECTION).RTL;
        const containerStartFromViewport = !isRtl ? containerLeft : container.ownerDocument.defaultView.innerWidth - containerRight;
        const refStartFromContainer = !isRtl ? refLeft - containerLeft : containerRight - refRight;
        const refEndFromContainer = !isRtl ? refRight - containerLeft : containerRight - refLeft;
        const refTopFromContainer = refTop - containerTop;
        if ((container !== this.ownerDocument.body || containerStartFromViewport !== 0 || containerTop !== 0) && containerComputedStyle.getPropertyValue("position") === "static") throw new Error("Floating menu container must not have `position:static`.");
        const { flipped, direction } = this;
        if (Object.values((0, _defsJs.FLOATING_MENU_DIRECTION)).indexOf(direction) < 0) throw new Error(`Wrong menu position direction: ${direction}`);
        const alignmentStart = flipped ? refEndFromContainer - width : refStartFromContainer;
        const { start, top } = ({
            [(0, _defsJs.FLOATING_MENU_DIRECTION).TOP]: ()=>({
                    start: alignmentStart,
                    top: refTopFromContainer - height
                }),
            [(0, _defsJs.FLOATING_MENU_DIRECTION).BOTTOM]: ()=>({
                    start: alignmentStart,
                    top: refBottom
                })
        })[direction]();
        return {
            direction: positionDirection,
            start,
            top
        };
    }
    disconnectedCallback() {
        if (this._hObserveResizeContainer) this._hObserveResizeContainer = this._hObserveResizeContainer.release();
        if (this._hObserveResizeParent) this._hObserveResizeParent = this._hObserveResizeParent.release();
    }
    updated(changedProperties) {
        var _a;
        const { container, open, parent } = this;
        if ((changedProperties.has("flipped") || changedProperties.has("direction") || changedProperties.has("open")) && open) {
            if (!parent) {
                this.parent = this.parentElement;
                container.appendChild(this);
            }
            // Note: `this.position` cannot be referenced until `this.parent` is set
            const { direction, start, top } = this.position;
            this.style[direction !== (0, _defsJs.FLOATING_MENU_POSITION_DIRECTION).RTL ? "left" : "right"] = `${start}px`;
            this.style.top = `${top}px`;
        }
        if (changedProperties.has("open")) {
            if (this._hObserveResizeContainer) this._hObserveResizeContainer = this._hObserveResizeContainer.release();
            if (this._hObserveResizeParent) this._hObserveResizeParent = this._hObserveResizeParent.release();
            if (open) {
                const { parentElement } = (_a = this.parent) !== null && _a !== void 0 ? _a : {};
                this._hObserveResizeContainer = observeResize(this._resizeObserver, container);
                if (parentElement) this._hObserveResizeParent = observeResize(this._resizeObserver, parentElement);
            }
        }
    }
    /**
     * The CSS selector to find the element to put this floating menu in.
     */ static get selectorContainer() {
        return `[data-floating-menu-container],${0, _settingsJs.prefix}-modal`;
    }
}
/**
 * A constant indicating that this class is a floating menu.
 */ CDSFloatingMenu.FLOATING_MENU = true;
CDSFloatingMenu.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("focusout")
], CDSFloatingMenu.prototype, "_handleBlur", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("click")
], CDSFloatingMenu.prototype, "_click", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("keydown")
], CDSFloatingMenu.prototype, "_handleKeyDown", void 0);

},{"tslib":"gBS4y","lit":"aCmte","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/focus.js":"5k7ow","../../globals/mixins/host-listener.js":"1SMUX","./defs.js":"kkxy6","../../globals/settings.js":"EipuL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kkxy6":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The LTR/RTL direction used for positioning floating menu.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FLOATING_MENU_DIRECTION", ()=>FLOATING_MENU_DIRECTION);
parcelHelpers.export(exports, "FLOATING_MENU_POSITION_DIRECTION", ()=>FLOATING_MENU_POSITION_DIRECTION);
var FLOATING_MENU_POSITION_DIRECTION;
(function(FLOATING_MENU_POSITION_DIRECTION) {
    /**
     * LTR.
     */ FLOATING_MENU_POSITION_DIRECTION["LTR"] = "ltr";
    /**
     * RTL.
     */ FLOATING_MENU_POSITION_DIRECTION["RTL"] = "rtl";
})(FLOATING_MENU_POSITION_DIRECTION || (FLOATING_MENU_POSITION_DIRECTION = {}));
/**
 * The direction/positioning/orientation choices of floating menu.
 */ var FLOATING_MENU_DIRECTION;
(function(FLOATING_MENU_DIRECTION) {
    /**
     * Put menu body at the top of its trigger button.
     */ FLOATING_MENU_DIRECTION["TOP"] = "top";
    /**
     * Put menu body at the bottom of its trigger button.
     */ FLOATING_MENU_DIRECTION["BOTTOM"] = "bottom";
})(FLOATING_MENU_DIRECTION || (FLOATING_MENU_DIRECTION = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"80Ejl":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSOverflowMenuItem$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _defsJs = require("./defs.js");
var _overflowMenuScssJs = require("./overflow-menu.scss.js");
var _overflowMenuScssJsDefault = parcelHelpers.interopDefault(_overflowMenuScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Overflow menu item.
 *
 * @element cds-overflow-menu-item
 */ let CDSOverflowMenuItem = class CDSOverflowMenuItem extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if the action is danger.
         */ this.danger = false;
        /**
         * `true` if the overflow menu item should be disabled.
         */ this.disabled = false;
        /**
         * `true` if the item has a divider
         */ this.divider = false;
        /**
         * The link href of the overflow menu item.
         */ this.href = "";
        /**
         * The size of the overflow menu item.
         */ this.size = (0, _defsJs.OVERFLOW_MENU_SIZE).MEDIUM;
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "menuitem");
        super.connectedCallback();
    }
    render() {
        return this.href ? (0, _lit.html)`
          <a
            class="${0, _settingsJs.prefix}--overflow-menu-options__btn"
            ?disabled=${this.disabled}
            href="${this.href}"
            tabindex="-1">
            <div class="${0, _settingsJs.prefix}--overflow-menu-options__option-content">
              <slot></slot>
            </div>
          </a>
        ` : (0, _lit.html)`
          <button
            class="${0, _settingsJs.prefix}--overflow-menu-options__btn"
            ?disabled=${this.disabled}
            tabindex="-1">
            <div class="${0, _settingsJs.prefix}--overflow-menu-options__option-content">
              <slot></slot>
            </div>
          </button>
        `;
    }
};
CDSOverflowMenuItem.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSOverflowMenuItem.styles = (0, _overflowMenuScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSOverflowMenuItem.prototype, "danger", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSOverflowMenuItem.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSOverflowMenuItem.prototype, "divider", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSOverflowMenuItem.prototype, "href", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSOverflowMenuItem.prototype, "size", void 0);
CDSOverflowMenuItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-overflow-menu-item`)
], CDSOverflowMenuItem);
var CDSOverflowMenuItem$1 = CDSOverflowMenuItem;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/mixins/focus.js":"5k7ow","./defs.js":"de8Gh","./overflow-menu.scss.js":"cr7YM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d4u0Z":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _selectItemJs = require("../select/select-item.js");
var _selectJs = require("../select/select.js");
var _paginationJs = require("./pagination.js");

},{"../select/select-item.js":"2uF8Y","../select/select.js":"8lIGI","./pagination.js":"3mNoB"}],"3mNoB":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSPagination$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _16Js = require("../../icons/caret--left/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/caret--right/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _hostListenerJs = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _paginationScssJs = require("./pagination.scss.js");
var _paginationScssJsDefault = parcelHelpers.interopDefault(_paginationScssJs);
var _defsJs = require("./defs.js");
var _buttonJs = require("../button/button.js");
var _buttonSetJs = require("../button/button-set.js");
var _buttonSkeletonJs = require("../button/button-skeleton.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Pagination UI.
 *
 * @element cds-pagination
 * @slot page-sizes-select - Where to put in the `<page-sizes-select>`.
 * @fires cds-pagination-changed-current - The custom event fired after the current page is changed from `<cds-pages-select>`.
 * @fires cds-page-sizes-select-changed - The custom event fired after the number of rows per page is changed from `<cds-page-sizes-select>`.
 */ let CDSPagination = class CDSPagination extends (0, _focusJsDefault.default)((0, _hostListenerJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * The assistive text for the button to go to previous page.
         */ this.backwardText = "Previous page";
        /**
         * The current page
         */ this.page = 1;
        /**
         * The formatter for the assistive text for screen readers to announce.
         * Should be changed upon the locale the UI is rendered with.
         */ this.formatLabelText = ({ count })=>`Page number, of ${count} page${count <= 1 ? "" : "s"}`;
        /**
         * The formatter, used with determinate the total pages. Should be changed upon the locale the UI is rendered with.
         */ this.formatStatusWithDeterminateTotal = ({ start, end, count })=>`${start}\u{2013}${end} of ${count} item${count <= 1 ? "" : "s"}`;
        /**
         * The formatter, used with indeterminate the total pages. Should be changed upon the locale the UI is rendered with.
         */ this.formatStatusWithIndeterminateTotal = ({ start, end, count })=>end == null ? `Item ${start}\u{2013}` : `${start}\u{2013}${end} item${count <= 1 ? "" : "s"}`;
        /**
         * The formatter for the text next to the select box. Should be changed upon the locale the UI is rendered with.
         */ this.formatSupplementalText = ({ count })=>this.pagesUnknown || !this.totalItems ? `page` : `of ${count} page${count <= 1 ? "" : "s"}`;
        /**
         * The translatable text indicating the number of items per page.
         */ this.itemsPerPageText = "Items per page:";
        /**
         * `true` if the pagination UI should be disabled.
         */ this.disabled = false;
        /**
         * The assistive text for the button to go to next page.
         */ this.forwardText = "Next page";
        /**
         * true if the select box to change the page should be disabled.
         */ this.pageInputDisabled = false;
        /**
         * Number of items per page.
         */ this.pageSize = 10;
        /**
         * true if the total number of items is unknown.
         */ this.pagesUnknown = false;
        /**
         * Specify the size of the Pagination.
         */ this.size = (0, _defsJs.PAGINATION_SIZE).MEDIUM;
        /**
         * The row number where current page start with, index that starts with zero.
         */ this.start = 0;
        /**
         * The number of total pages.
         */ this.totalPages = 1;
    }
    _handleSlotChange({ target }) {
        const content = target.assignedNodes().filter((node)=>node.nodeType !== Node.TEXT_NODE || node.textContent.trim());
        content.forEach((item)=>{
            this._pageSizeSelect.appendChild(item);
        });
    }
    /**
     * @returns Page status text.
     */ _renderStatusText() {
        const { start, pageSize, totalItems, pagesUnknown, formatStatusWithDeterminateTotal, formatStatusWithIndeterminateTotal } = this;
        // * Regular: `1-10 of 100 items`
        // * Indeterminate total: `Item 1-10` (`Item 11-` at the last page)
        const end = Math.min(start + pageSize, totalItems == null ? Infinity : totalItems);
        const format = totalItems == null || pagesUnknown ? formatStatusWithIndeterminateTotal : formatStatusWithDeterminateTotal;
        // `start`/`end` properties starts with zero, whereas we want to show number starting with 1
        return format({
            start: start + 1,
            end,
            count: totalItems
        });
    }
    /**
     * Handles user-initiated change in the row number the current page starts with.
     *
     * @param start The new current row number, index that starts with zero.
     */ _handleUserInitiatedChangeStart(start) {
        this.start = start;
        this.dispatchEvent(new CustomEvent(this.constructor.eventChangeCurrent, {
            bubbles: true,
            composed: true,
            detail: {
                page: this.page,
                pageSize: this.pageSize
            }
        }));
    }
    /**
     * Handles user-initiated change in the size of the page.
     */ _handleUserInitiatedPageSizeChange() {
        this.dispatchEvent(new CustomEvent(this.constructor.eventPageSizeChanged, {
            bubbles: true,
            composed: true,
            detail: {
                page: this.page,
                pageSize: this.pageSize
            }
        }));
    }
    /**
     * Handles `click` event on the previous button.
     */ _handleClickPrevButton() {
        const { start: oldStart, pageSize } = this;
        this.page--;
        const newStart = Math.max(oldStart - pageSize, 0);
        if (newStart !== oldStart) this._handleUserInitiatedChangeStart(newStart);
    }
    /**
     * Handles `click` event on the next button.
     */ _handleClickNextButton() {
        const { start: oldStart, pageSize, totalItems } = this;
        this.page++;
        const newStart = oldStart + pageSize;
        if (newStart < (totalItems == null ? Infinity : totalItems)) this._handleUserInitiatedChangeStart(newStart);
    }
    /**
     * Handles user-initiated change in number of rows per page.
     *
     * @param event The event.
     */ _handleChangeSelector(event) {
        const { value } = event.detail;
        const { totalItems, pageSize } = this;
        if (event.composedPath()[0] === this._pageSizeSelect) {
            this.pageSize = parseInt(value);
            // Default pageSize to effectively be 1 when we have a value of 0 to avoid
            // division by 0.
            this.totalPages = pageSize > 0 ? Math.ceil(totalItems / pageSize) : totalItems;
            this.page = 1;
            this.start = 0;
            this._handleUserInitiatedPageSizeChange();
        } else {
            this.page = value;
            this._handleUserInitiatedChangeStart((value - 1) * pageSize);
        }
    }
    updated(changedProperties) {
        const { page, pageSize, totalItems } = this;
        const { selectorPageSizesSelect, selectorPagesSelect } = this.constructor;
        if (changedProperties.has("pageSize")) this.shadowRoot.querySelector(selectorPageSizesSelect).value = pageSize;
        if (changedProperties.has("pageSize") || changedProperties.has("start")) {
            // Default pageSize to effectively be 1 when we have a value of 0 to avoid
            // division by 0.
            this.totalPages = pageSize > 0 ? Math.ceil(totalItems / pageSize) : totalItems;
            this.shadowRoot.querySelector(selectorPagesSelect).value = this.page.toString();
        }
        if (changedProperties.has("page")) this._handleUserInitiatedChangeStart((page - 1) * pageSize);
    }
    render() {
        const { page, disabled, forwardText, backwardText, itemsPerPageText, pageInputDisabled, pageSize, pageSizeInputDisabled, pagesUnknown, size, start, totalItems, totalPages, _handleClickPrevButton: handleClickPrevButton, _handleClickNextButton: handleClickNextButton, _handleSlotChange: handleSlotChange, formatLabelText, formatSupplementalText } = this;
        const { isLastPage = start + pageSize >= totalItems } = this;
        const prevButtonDisabled = disabled || start === 0;
        const nextButtonDisabled = disabled || isLastPage;
        const prevButtonClassMap = {
            [`${0, _settingsJs.prefix}--btn`]: true,
            [`${0, _settingsJs.prefix}--btn--icon-only`]: true,
            [`${0, _settingsJs.prefix}--pagination__button`]: true,
            [`${0, _settingsJs.prefix}--pagination__button--backward`]: true,
            [`${0, _settingsJs.prefix}--pagination__button--no-index`]: prevButtonDisabled,
            [`${0, _settingsJs.prefix}--btn--${size}`]: true,
            [`${0, _settingsJs.prefix}--btn--ghost`]: true
        };
        const nextButtonClassMap = {
            [`${0, _settingsJs.prefix}--btn`]: true,
            [`${0, _settingsJs.prefix}--btn--icon-only`]: true,
            [`${0, _settingsJs.prefix}--pagination__button`]: true,
            [`${0, _settingsJs.prefix}--pagination__button--forward`]: true,
            [`${0, _settingsJs.prefix}--pagination__button--no-index`]: nextButtonDisabled,
            [`${0, _settingsJs.prefix}--btn--${size}`]: true,
            [`${0, _settingsJs.prefix}--btn--ghost`]: true
        };
        const prevButtonClasses = Object.entries(prevButtonClassMap).filter(([, value])=>value === true).map(([key])=>key).join(" ");
        const nextButtonClasses = Object.entries(nextButtonClassMap).filter(([, value])=>value === true).map(([key])=>key).join(" ");
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--pagination__left">
        <label for="select" class="${0, _settingsJs.prefix}--pagination__text"
          ><slot name="label-text">${itemsPerPageText}</slot></label
        >
        <cds-select
          ?disabled=${disabled || pageSizeInputDisabled}
          id="page-size-select"
          left-select
          pagination
          size="${size}"
          inline
          value="${pageSize}">
          <slot @slotchange=${handleSlotChange}></slot>
        </cds-select>
        <span
          class="${0, _settingsJs.prefix}--pagination__text ${0, _settingsJs.prefix}--pagination__items-count"
          >${this._renderStatusText()}</span
        >
      </div>
      <div class="${0, _settingsJs.prefix}--pagination__right">
        <label for="select" class="${0, _settingsJs.prefix}--label ${0, _settingsJs.prefix}--visually-hidden">
          ${formatLabelText({
            count: totalPages
        })}
        </label>
        ${pagesUnknown || !totalItems ? (0, _lit.html)`
              <span
                class="${0, _settingsJs.prefix}--pagination__text ${0, _settingsJs.prefix}--pagination__page-text"
                >${formatSupplementalText({
            count: totalPages
        })}</span
              >

              <cds-select
                ?disabled=${disabled || pageInputDisabled}
                id="pages-select"
                pagination
                size="${size}"
                inline
                value="${page}">
                ${Array.from(new Array(totalPages)).map((_item, index)=>(0, _lit.html)`
                    <cds-select-item value="${index + 1}">
                      ${index + 1}
                    </cds-select-item>
                  `)}
              </cds-select>
            ` : (0, _lit.html)`
              <cds-select
                ?disabled=${disabled || pageInputDisabled}
                id="pages-select"
                pagination
                size="${size}"
                inline
                value="${page}">
                ${Array.from(new Array(totalPages)).map((_item, index)=>(0, _lit.html)`
                    <cds-select-item value="${index + 1}" ?selected=${index + 1 == page}>
                      ${index + 1}
                    </cds-select-item>
                  `)}
              </cds-select>
              <span class="${0, _settingsJs.prefix}--pagination__text"
                >${formatSupplementalText({
            count: totalPages
        })}</span
              >
            `}

        <div class="${0, _settingsJs.prefix}--pagination__control-buttons">
          <cds-button
            pagination
            size="${size}"
            ?disabled="${prevButtonDisabled}"
            button-class-name="${prevButtonClasses}"
            tooltip-text="${backwardText}"
            @click="${handleClickPrevButton}">
            ${(0, _16JsDefault.default)({
            slot: "icon"
        })}
          </cds-button>
          <cds-button
            tooltip-position="top-right"
            pagination
            size="${size}"
            ?disabled="${nextButtonDisabled}"
            button-class-name="${nextButtonClasses}"
            tooltip-text="${forwardText}"
            @click="${handleClickNextButton}">
            ${(0, _16JsDefault1.default)({
            slot: "icon"
        })}
          </cds-button>
        </div>
      </div>
    `;
    }
    /**
     * A selector that will return the select box for the current page.
     */ static get selectorPagesSelect() {
        return `${0, _settingsJs.prefix}-select#pages-select`;
    }
    /**
     * A selector that will return the select box for page sizes.
     */ static get selectorPageSizesSelect() {
        return `${0, _settingsJs.prefix}-select`;
    }
    /**
     * The name of the custom event fired after the current row number is changed.
     */ static get eventChangeCurrent() {
        return `${0, _settingsJs.prefix}-pagination-changed-current`;
    }
    /**
     * The name of the custom event fired after the number of rows per page is changed from `<cds-page-sizes-select>`.
     */ static get eventPageSizeChanged() {
        return `${0, _settingsJs.prefix}-page-sizes-select-changed`;
    }
};
CDSPagination.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSPagination.styles = (0, _paginationScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)(`${(0, _settingsJs.prefix)}-select`)
], CDSPagination.prototype, "_pageSizeSelect", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)(`${(0, _settingsJs.prefix)}-select-selected`)
], CDSPagination.prototype, "_handleChangeSelector", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "backward-text"
    })
], CDSPagination.prototype, "backwardText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true
    })
], CDSPagination.prototype, "page", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: false
    })
], CDSPagination.prototype, "formatLabelText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: false
    })
], CDSPagination.prototype, "formatStatusWithDeterminateTotal", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: false
    })
], CDSPagination.prototype, "formatStatusWithIndeterminateTotal", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: false
    })
], CDSPagination.prototype, "formatSupplementalText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "is-last-page"
    })
], CDSPagination.prototype, "isLastPage", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "items-per-page-text"
    })
], CDSPagination.prototype, "itemsPerPageText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSPagination.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "forward-text"
    })
], CDSPagination.prototype, "forwardText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "page-input-disabled"
    })
], CDSPagination.prototype, "pageInputDisabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        attribute: "page-size",
        reflect: true
    })
], CDSPagination.prototype, "pageSize", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "page-size-input-disabled"
    })
], CDSPagination.prototype, "pageSizeInputDisabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "page-size-label-text"
    })
], CDSPagination.prototype, "pageSizeLabelText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "pages-unknown"
    })
], CDSPagination.prototype, "pagesUnknown", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSPagination.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number
    })
], CDSPagination.prototype, "start", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        attribute: "total-items"
    })
], CDSPagination.prototype, "totalItems", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number
    })
], CDSPagination.prototype, "totalPages", void 0);
CDSPagination = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-pagination`)
], CDSPagination);
var CDSPagination$1 = CDSPagination;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/caret--left/16.js":"9QIqA","../../icons/caret--right/16.js":"inbJS","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","../../globals/mixins/host-listener.js":"1SMUX","../../globals/decorators/host-listener.js":"f95Mj","./pagination.scss.js":"lC49l","./defs.js":"hamcW","../button/button.js":"ca52G","../button/button-set.js":"fcMCT","../button/button-skeleton.js":"cfoNU","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9QIqA":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M20 24L10 16 20 8z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"inbJS":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M12 8L22 16 12 24z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lC49l":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--select{align-items:flex-start;border:0;box-sizing:border-box;display:flex;flex-direction:column;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;position:relative;vertical-align:baseline}.cds--select *,.cds--select :after,.cds--select :before{box-sizing:inherit}.cds--select-input__wrapper{align-items:center;display:flex;inline-size:100%;position:relative}.cds--select-input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--cds-field);block-size:2.5rem;border:none;border-block-end:1px solid var(--cds-border-strong);border-radius:0;color:var(--cds-text-primary,#161616);cursor:pointer;display:block;font-family:inherit;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);opacity:1;outline:2px solid transparent;outline-offset:-2px;padding-block:0;padding-inline:1rem 3rem;text-overflow:ellipsis;transition:outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--select-input:hover{background-color:var(--cds-field-hover)}.cds--select-input::-ms-expand{display:none}@document url-prefix(){.cds--select-input:-moz-focusring,.cds--select-input::-moz-focus-inner{background-image:none;color:transparent;text-shadow:0 0 0 #000}}.cds--select-input:focus{color:var(--cds-text-primary,#161616);outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--select-input:focus{outline-style:dotted}}.cds--select-input:disabled,.cds--select-input:hover:disabled{background-color:var(--cds-field);border-block-end-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--select-input--sm{block-size:2rem;max-block-size:2rem}.cds--select-input--lg{block-size:3rem;max-block-size:3rem}.cds--select--disabled .cds--form__helper-text,.cds--select--disabled .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--select--warning .cds--select-input,.cds--select-input__wrapper[data-invalid] .cds--select-input{padding-inline-end:4rem}.cds--select-input:disabled~.cds--select__arrow{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--select--light .cds--select-input{background-color:var(--cds-field-02,#fff)}.cds--select--light .cds--select-input:hover{background-color:var(--cds-field-hover)}.cds--select--light .cds--select-input:disabled,.cds--select--light .cds--select-input:hover:disabled{background-color:var(--cds-field-02,#fff);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--select__arrow{block-size:100%;position:absolute;fill:var(--cds-icon-primary,#161616);inset-block-start:0;inset-inline-end:1rem;pointer-events:none}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--select__arrow path{fill:ButtonText}}.cds--select__invalid-icon{inset-inline-end:2.5rem;position:absolute}.cds--select-input__wrapper[data-invalid] .cds--select-input~.cds--select__invalid-icon{fill:var(--cds-support-error,#da1e28)}.cds--select__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--select__invalid-icon--warning path[fill]{fill:#000;opacity:1}.cds--select-option,optgroup.cds--select-optgroup{background-color:var(--cds-layer-hover);color:var(--cds-text-primary,#161616)}.cds--select-option:disabled,optgroup.cds--select-optgroup:disabled{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--select--inline{align-items:center;display:flex;flex-direction:row}.cds--select--inline.cds--select--invalid .cds--form__helper-text,.cds--select--inline.cds--select--invalid .cds--label{align-self:flex-start;margin-block-start:.8125rem}.cds--select--inline .cds--form__helper-text{margin-block-end:0;margin-inline-start:.5rem}.cds--select--inline .cds--label{margin:0 .5rem 0 0;white-space:nowrap}.cds--select--inline .cds--select-input{background-color:transparent;border-block-end:none;color:var(--cds-text-primary,#161616);inline-size:auto;padding-inline:.5rem 2rem}.cds--select--inline .cds--select-input:focus,.cds--select--inline .cds--select-input:focus optgroup,.cds--select--inline .cds--select-input:focus option{background-color:var(--cds-background,#fff)}.cds--select--inline .cds--select-input[disabled],.cds--select--inline .cds--select-input[disabled]:hover{background-color:var(--cds-field)}.cds--select--inline .cds--select__arrow{inset-inline-end:.5rem}.cds--select--inline.cds--select--invalid .cds--select-input{padding-inline-end:3.5rem}.cds--select--inline.cds--select--invalid .cds--select-input~.cds--select__invalid-icon{inset-inline-end:2rem}.cds--select--inline .cds--select-input:disabled{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--select--inline .cds--select-input:disabled~*{cursor:not-allowed}.cds--select--readonly .cds--select-input{background-color:transparent;border-block-end-color:var(--cds-border-subtle);cursor:default}.cds--select--readonly .cds--select__arrow{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--select.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:2.5rem;border:none;box-shadow:none;inline-size:100%;padding:0;pointer-events:none;position:relative}.cds--select.cds--skeleton:active,.cds--select.cds--skeleton:focus,.cds--select.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--select.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--select.cds--skeleton:before{animation:none}}.cds--select.cds--skeleton .cds--select-input{display:none}.cds--select--slug .cds--ai-label,.cds--select--slug .cds--slug{inset-block-start:50%;inset-inline-end:calc(2.5rem + 9px);margin-block-start:.03125rem;position:absolute;transform:translateY(-50%)}.cds--select--slug .cds--ai-label:after,.cds--select--slug .cds--ai-label:before,.cds--select--slug .cds--slug:after,.cds--select--slug .cds--slug:before{background-color:var(--cds-border-subtle-01,#c6c6c6);block-size:1rem;content:"";inline-size:.0625rem;position:absolute}.cds--select--slug .cds--ai-label:before,.cds--select--slug .cds--slug:before{display:none;inset-inline-start:calc(-.5rem - 1px)}.cds--select--slug .cds--ai-label:after,.cds--select--slug .cds--slug:after{display:block;inset-inline-end:calc(-.5rem - 1px)}.cds--select--slug .cds--ai-label--revert:after,.cds--select--slug .cds--slug--revert:after{inset-block-start:.5rem;inset-inline-end:-.0625rem}.cds--select--slug .cds--select-input:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--select--slug .cds--select-input:has(~.cds--slug):not(:has(~.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff);padding-inline-end:4rem}.cds--select--slug:has(.cds--select__invalid-icon) .cds--select-input:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--select--slug:has(.cds--select__invalid-icon) .cds--select-input:has(~.cds--slug):not(:has(~.cds--slug--revert)){padding-inline-end:6rem}.cds--select--slug:has(.cds--select__invalid-icon) .cds--ai-label:before,.cds--select--slug:has(.cds--select__invalid-icon) .cds--slug:before{display:block}.cds--select--slug .cds--select-input__wrapper .cds--select-input~.cds--select__invalid-icon,.cds--select--slug .cds--select-input__wrapper[data-invalid] .cds--select-input~.cds--select__invalid-icon{inset-inline-end:5rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--select__arrow{fill:ButtonText}}.cds--data-table-container+.cds--pagination,.cds--data-table-container+:host(cds-pagination){border-block-start:0}.cds--pagination,:host(cds-pagination){align-items:center;background-color:var(--cds-layer);border:0;border-block-start:1px solid var(--cds-border-subtle);box-sizing:border-box;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:calc(100% - 1px);justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;min-block-size:2.5rem;overflow-x:auto;padding:0;vertical-align:baseline}.cds--pagination *,.cds--pagination :after,.cds--pagination :before,:host(cds-pagination) *,:host(cds-pagination) :after,:host(cds-pagination) :before{box-sizing:inherit}@media (min-width:42rem){.cds--pagination,:host(cds-pagination){overflow:initial}.cds--pagination .cds--pagination__control-buttons,:host(cds-pagination) .cds--pagination__control-buttons{display:flex}}@media (max-width:41.98rem){.cds--pagination .cds--pagination__left>*,.cds--pagination .cds--pagination__right>*,:host(cds-pagination) .cds--pagination__left>*,:host(cds-pagination) .cds--pagination__right>*{display:none}.cds--pagination .cds--pagination__items-count,:host(cds-pagination) .cds--pagination__items-count{display:initial}.cds--pagination .cds--pagination__control-buttons,:host(cds-pagination) .cds--pagination__control-buttons{display:flex}}.cds--pagination--sm,:host(cds-pagination[size=sm]){min-block-size:2rem}.cds--pagination--lg,:host(cds-pagination[size=lg]){min-block-size:3rem}.cds--pagination .cds--select,:host(cds-pagination) .cds--select{align-items:center;block-size:100%}.cds--pagination .cds--select-input--inline__wrapper,:host(cds-pagination) .cds--select-input--inline__wrapper{block-size:100%;display:flex}.cds--pagination .cds--select-input,:host(cds-pagination) .cds--select-input{block-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:auto;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);line-height:2.5rem;min-inline-size:auto}.cds--pagination .cds--select--inline .cds--select-input,:host(cds-pagination) .cds--select--inline .cds--select-input{padding-inline:1rem 2.25rem}.cds--pagination--sm .cds--select-input,:host(cds-pagination[size=sm]) .cds--select-input{line-height:2rem}.cds--pagination--lg .cds--select-input,:host(cds-pagination[size=lg]) .cds--select-input{line-height:3rem}.cds--pagination .cds--select-input:hover,:host(cds-pagination) .cds--select-input:hover{background:var(--cds-layer-hover)}.cds--pagination .cds--select--inline .cds--select-input:focus,.cds--pagination .cds--select--inline .cds--select-input:focus optgroup,.cds--pagination .cds--select--inline .cds--select-input:focus option,:host(cds-pagination) .cds--select--inline .cds--select-input:focus,:host(cds-pagination) .cds--select--inline .cds--select-input:focus optgroup,:host(cds-pagination) .cds--select--inline .cds--select-input:focus option{background-color:var(--cds-layer)}.cds--pagination .cds--select__arrow,:host(cds-pagination) .cds--select__arrow{inset-block-start:50%;transform:translate(-.5rem,-50%)}.cds--pagination .cds--select__item-count .cds--select-input,:host(cds-pagination) .cds--select__item-count .cds--select-input{border-inline-end:1px solid var(--cds-border-subtle)}.cds--pagination__right{border-inline-start:1px solid var(--cds-border-subtle)}.cds--pagination__left,.cds--pagination__right{align-items:center;block-size:100%;display:flex}.cds--pagination__left>.cds--form-item,.cds--pagination__right>.cds--form-item{block-size:100%}.cds--pagination__left .cds--pagination__text,.cds--pagination__right .cds--pagination__text{white-space:nowrap}.cds--pagination__left .cds--pagination__text{margin-inline-end:.0625rem}.cds--pagination__right .cds--pagination__text{margin-inline:.0625rem 1rem}.cds--pagination__right .cds--pagination__text.cds--pagination__page-text{margin-inline:1rem .0625rem}.cds--pagination__right .cds--pagination__text.cds--pagination__page-text.cds--pagination__unknown-pages-text{margin-inline-end:1rem}.cds--pagination__right .cds--pagination__text:empty{margin:0}.cds--pagination__left{padding:0 1rem 0 0}@media (min-width:42rem){.cds--pagination__left{padding:0 1rem}.cds--pagination__text{display:inline-block}}span.cds--pagination__text{color:var(--cds-text-primary,#161616);margin-inline-start:1rem}span.cds--pagination__text.cds--pagination__items-count{color:var(--cds-text-secondary,#525252)}.cds--btn--ghost.cds--pagination__button,.cds--pagination__button{align-items:center;background:none;block-size:2.5rem;border:none;border-inline-start:1px solid var(--cds-border-subtle);box-sizing:border-box;cursor:pointer;display:flex;font-family:inherit;font-size:100%;justify-content:center;margin:0;padding:0;vertical-align:baseline;fill:var(--cds-icon-primary,#161616);inline-size:2.5rem;min-block-size:2rem;transition:outline .11s cubic-bezier(.2,0,.38,.9),background-color .11s cubic-bezier(.2,0,.38,.9)}.cds--btn--ghost.cds--pagination__button *,.cds--btn--ghost.cds--pagination__button :after,.cds--btn--ghost.cds--pagination__button :before,.cds--pagination__button *,.cds--pagination__button :after,.cds--pagination__button :before{box-sizing:inherit}.cds--btn--ghost.cds--pagination__button>svg,.cds--pagination__button>svg{margin-block-start:0}[dir=rtl] .cds--btn--ghost.cds--pagination__button>svg,[dir=rtl] .cds--pagination__button>svg{transform:rotate(.5turn)}.cds--pagination--sm .cds--btn--ghost.cds--pagination__button,.cds--pagination--sm .cds--pagination__button,:host(cds-pagination[size=sm]) .cds--pagination__button{block-size:2rem;inline-size:2rem}.cds--pagination--lg .cds--btn--ghost.cds--pagination__button,.cds--pagination--lg .cds--pagination__button,:host(cds-pagination[size=lg]) .cds--pagination__button{block-size:3rem;inline-size:3rem}.cds--btn--ghost:focus.cds--pagination__button,.cds--pagination__button:focus{border-inline-start:0;outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--btn--ghost:focus.cds--pagination__button,.cds--pagination__button:focus{outline-style:dotted}}.cds--btn--ghost:hover.cds--pagination__button,.cds--pagination__button:hover{background:var(--cds-layer-hover)}.cds--btn--ghost.cds--pagination__button--no-index,.cds--pagination__button--no-index{cursor:not-allowed;fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--btn--ghost:disabled:hover.cds--pagination__button,.cds--btn--ghost:hover.cds--pagination__button--no-index,.cds--pagination__button--no-index:hover,.cds--pagination__button:disabled:hover{background:var(--cds-layer);border-color:var(--cds-border-subtle);cursor:not-allowed;fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--pagination.cds--skeleton .cds--skeleton__text{margin-block-end:0;margin-inline-end:1rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn--ghost.cds--pagination__button,.cds--pagination__button{outline:1px solid transparent}}[dir=rtl] .cds--pagination .cds--select__arrow,[dir=rtl] :host(cds-pagination) .cds--select__arrow{transform:translate(.5rem,-50%)}.cds--unstable-pagination{align-items:center;background-color:var(--cds-layer);border:0;border-block-end:1px solid transparent;border-block-start:1px solid var(--cds-border-subtle);box-sizing:border-box;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;min-block-size:2.5rem;padding:0;vertical-align:baseline}.cds--unstable-pagination *,.cds--unstable-pagination :after,.cds--unstable-pagination :before{box-sizing:inherit}.cds--unstable-pagination__text{color:var(--cds-text-secondary,#525252);margin:0 1rem}@media (min-width:42rem){.cds--unstable-pagination__text{display:inline-block}}.cds--unstable-pagination__left,.cds--unstable-pagination__right{align-items:center;block-size:100%;display:flex}.cds--unstable-pagination__left{padding:0 1rem 0 0}.cds--unstable-pagination__left>.cds--form-item,.cds--unstable-pagination__right>.cds--form-item{block-size:100%}.cds--unstable-pagination__left .cds--unstable-pagination__text{margin-inline-end:.0625rem}.cds--unstable-pagination__right .cds--unstable-pagination__text{margin-inline:.0625rem 1rem}.cds--unstable-pagination__button{align-items:center;background:none;block-size:2.5rem;border:none;border-inline-start:1px solid var(--cds-border-subtle);box-sizing:border-box;color:var(--cds-icon-primary,#161616);cursor:pointer;display:flex;font-family:inherit;font-size:100%;justify-content:center;margin:0;padding:0;vertical-align:baseline;fill:var(--cds-icon-primary,#161616);inline-size:2.5rem;min-block-size:2rem;transition:outline .11s cubic-bezier(.2,0,.38,.9),background-color .11s cubic-bezier(.2,0,.38,.9)}.cds--unstable-pagination__button *,.cds--unstable-pagination__button :after,.cds--unstable-pagination__button :before{box-sizing:inherit}.cds--unstable-pagination__button .cds--btn__icon{block-size:auto;inline-size:auto}.cds--unstable-pagination__button.cds--btn--icon-only.cds--tooltip__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--unstable-pagination__button.cds--btn--icon-only.cds--tooltip__trigger:focus{outline-style:dotted}}.cds--unstable-pagination__button:hover{background:var(--cds-layer-hover);color:var(--cds-icon-primary,#161616)}.cds--unstable-pagination__button--no-index{cursor:not-allowed;fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--unstable-pagination__button.cds--btn:disabled{background:transparent;border-color:var(--cds-border-subtle)}.cds--unstable-pagination__button--no-index:hover,.cds--unstable-pagination__button:disabled:hover{background:transparent;cursor:not-allowed;fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--unstable-pagination__page-selector,.cds--unstable-pagination__page-sizer{align-items:center;block-size:100%}.cds--unstable-pagination__page-selector .cds--select-input--inline__wrapper,.cds--unstable-pagination__page-sizer .cds--select-input--inline__wrapper{block-size:100%;display:flex}.cds--unstable-pagination__page-selector .cds--select-input,.cds--unstable-pagination__page-sizer .cds--select-input{block-size:100%;font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);inline-size:auto;letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);line-height:var(--cds-body-short-01-line-height,1.28572);line-height:2.5rem;min-inline-size:auto;padding:0 2.25rem 0 1rem}.cds--unstable-pagination__page-selector .cds--select-input:hover,.cds--unstable-pagination__page-sizer .cds--select-input:hover{background:var(--cds-layer-hover)}.cds--unstable-pagination__page-selector .cds--select__arrow,.cds--unstable-pagination__page-sizer .cds--select__arrow{inset-block-start:50%;transform:translateY(-50%)}@media (min-width:42rem){.cds--unstable-pagination__page-selector .cds--select__arrow,.cds--unstable-pagination__page-sizer .cds--select__arrow{inset-inline-end:1rem}}.cds--unstable-pagination__page-selector{border-inline-start:1px solid var(--cds-border-subtle)}.cds--unstable-pagination__page-sizer{border-inline-end:1px solid var(--cds-border-subtle)}:host(cds-pagination){outline:none;position:relative}:host(cds-pagination) .cds-ce--pagination__divider{background-color:var(--cds-layer-accent-01,#e0e0e0);block-size:100%;inline-size:to-rem(1px)}:host(cds-pagination) .cds--pagination__control-buttons{block-size:100%}:host(cds-pagination) .cds--pagination__button svg{transform:rotate(0)}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hamcW":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Pagination size.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PAGINATION_SIZE", ()=>PAGINATION_SIZE);
var PAGINATION_SIZE;
(function(PAGINATION_SIZE) {
    /**
     * Small size.
     */ PAGINATION_SIZE["SMALL"] = "sm";
    /**
     * Medium size.
     */ PAGINATION_SIZE["MEDIUM"] = "md";
    /**
     * Large size.
     */ PAGINATION_SIZE["LARGE"] = "lg";
})(PAGINATION_SIZE || (PAGINATION_SIZE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aHihW":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _progressIndicatorJs = require("./progress-indicator.js");
var _progressIndicatorSkeletonJs = require("./progress-indicator-skeleton.js");
var _progressStepJs = require("./progress-step.js");
var _progressStepSkeletonJs = require("./progress-step-skeleton.js");

},{"./progress-indicator.js":"6bKJo","./progress-indicator-skeleton.js":"hAZ2n","./progress-step.js":"9d7Ju","./progress-step-skeleton.js":"lg9eE"}],"6bKJo":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSProgressIndicator$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _progressIndicatorScssJs = require("./progress-indicator.scss.js");
var _progressIndicatorScssJsDefault = parcelHelpers.interopDefault(_progressIndicatorScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Progress indicator.
 *
 * @element cds-progress-indicator
 */ let CDSProgressIndicator = class CDSProgressIndicator extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Determines whether or not the progress indicator should be rendered
         * vertically.
         */ this.vertical = false;
        /**
         * Specify whether the progress steps should be split equally in size in the
         * div
         */ this.spaceEqually = false;
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "list");
        super.connectedCallback();
    }
    updated(changedProperties) {
        const spacingValue = this.vertical ? false : this.spaceEqually;
        if (changedProperties.has("vertical")) // Propagate `vertical` attribute to descendants until
        // `:host-context()` gets supported in all major browsers
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorStep), (item)=>{
            item.vertical = this.vertical;
            item.spaceEqually = spacingValue;
        });
        if (changedProperties.has("spaceEqually")) // Propagate `spaceEqually` attribute to descendants until
        // `:host-context()` gets supported in all major browsers
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorStep), (item)=>{
            item.spaceEqually = spacingValue;
        });
    }
    render() {
        return (0, _lit.html)`<slot></slot>`;
    }
    /**
     * A selector that will return progress steps.
     */ static get selectorStep() {
        return `${0, _settingsJs.prefix}-progress-step`;
    }
};
CDSProgressIndicator.styles = (0, _progressIndicatorScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSProgressIndicator.prototype, "vertical", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "space-equally"
    })
], CDSProgressIndicator.prototype, "spaceEqually", void 0);
CDSProgressIndicator = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-progress-indicator`)
], CDSProgressIndicator);
var CDSProgressIndicator$1 = CDSProgressIndicator;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/internal/collection-helpers.js":"4aZkz","./progress-indicator.scss.js":"gpxU7","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gpxU7":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--progress,:host(cds-progress-indicator),:host(cds-progress-indicator-skeleton){border:0;box-sizing:border-box;display:flex;font-family:inherit;font-size:100%;list-style:none;margin:0;padding:0;vertical-align:baseline}.cds--progress *,.cds--progress :after,.cds--progress :before,:host(cds-progress-indicator) *,:host(cds-progress-indicator) :after,:host(cds-progress-indicator) :before,:host(cds-progress-indicator-skeleton) *,:host(cds-progress-indicator-skeleton) :after,:host(cds-progress-indicator-skeleton) :before{box-sizing:inherit}.cds--progress-step,:host(cds-progress-step),:host(cds-progress-step-skeleton){display:inline-flex;flex-direction:row;inline-size:8rem;min-inline-size:7rem;overflow:visible;position:relative}.cds--progress-step .cds--tooltip__label,:host(cds-progress-step) .cds--tooltip__label,:host(cds-progress-step-skeleton) .cds--tooltip__label{display:block}.cds--progress--space-equal .cds--progress-step,.cds--progress--space-equal :host(cds-progress-step),.cds--progress--space-equal :host(cds-progress-step-skeleton){flex-grow:1;min-inline-size:8rem}.cds--progress-line{block-size:2px;border:1px inset transparent;inline-size:8rem;inset-inline-start:0;position:absolute}.cds--progress--space-equal .cds--progress-line{inline-size:100%;min-inline-size:8rem}.cds--progress-step svg,:host(cds-progress-step) svg,:host(cds-progress-step-skeleton) svg{block-size:1rem;border-radius:50%;flex-shrink:0;position:relative;z-index:1;fill:var(--cds-interactive,#0f62fe);inline-size:1rem;margin-block-start:.625rem;margin-inline-end:.5rem}.cds--progress--space-equal .cds--progress-text{overflow:hidden}.cds--progress-label{color:var(--cds-text-primary,#161616);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);line-height:1.45;margin:.5rem 0 0;max-inline-size:5.5rem;overflow:hidden;text-overflow:ellipsis;transition:box-shadow .11s cubic-bezier(.2,0,.38,.9),color .11s cubic-bezier(.2,0,.38,.9);white-space:nowrap}.cds--progress-label:before{content:"";display:block}.cds--progress-label:hover{box-shadow:0 .0625rem var(--cds-link-primary-hover,#0043ce);color:var(--cds-link-primary-hover,#0043ce);cursor:pointer}.cds--progress--space-equal .cds--progress-label{margin-inline-end:.75rem;max-inline-size:100%}.cds--progress-step-button:not(.cds--progress-step-button--unclickable):focus{outline:none}.cds--progress-step-button:not(.cds--progress-step-button--unclickable):focus-visible .cds--progress-label{color:var(--cds-focus,#0f62fe);outline:.0625rem solid var(--cds-focus,#0f62fe)}.cds--progress-step-button:not(.cds--progress-step-button--unclickable) .cds--progress-label:active{box-shadow:0 .0625rem 0 0 var(--cds-text-primary,#161616);color:var(--cds-text-primary,#161616)}.cds--progress-label-overflow:focus~.cds--tooltip,.cds--progress-label-overflow:hover~.cds--tooltip{visibility:inherit}.cds--progress-step .cds--tooltip .cds--tooltip__caret,:host(cds-progress-step) .cds--tooltip .cds--tooltip__caret,:host(cds-progress-step-skeleton) .cds--tooltip .cds--tooltip__caret{margin-inline-start:.625rem}.cds--tooltip__text{font-weight:400;margin:0;padding:0}.cds--progress-step .cds--tooltip,:host(cds-progress-step) .cds--tooltip,:host(cds-progress-step-skeleton) .cds--tooltip{color:var(--cds-text-inverse,#fff);display:block;font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);inline-size:7.8125rem;letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);margin-block-start:2.5rem;margin-inline-start:1.375rem;min-block-size:1.5rem;min-inline-size:7.1875rem;padding:.5rem 1rem;visibility:hidden}.cds--progress-step .cds--tooltip_multi,:host(cds-progress-step) .cds--tooltip_multi,:host(cds-progress-step-skeleton) .cds--tooltip_multi{block-size:auto;color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);inline-size:9.375rem;letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857)}.cds--progress-optional{color:var(--cds-text-secondary,#525252);font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inset-inline-start:0;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin-block-start:1.75rem;margin-inline-start:1.5rem;position:absolute;text-align:start}.cds--progress-step--current .cds--progress-line,:host(cds-progress-step[state=current]) .cds--progress-line{background-color:var(--cds-interactive,#0f62fe)}.cds--progress-step--incomplete svg,:host(cds-progress-step) svg,:host(cds-progress-step-skeleton) svg{fill:var(--cds-icon-primary,#161616)}.cds--progress-step--incomplete .cds--progress-line,:host(cds-progress-step) .cds--progress-line,:host(cds-progress-step-skeleton) .cds--progress-line{background-color:var(--cds-border-subtle)}.cds--progress-step--complete .cds--progress-line,:host(cds-progress-step[state=complete]) .cds--progress-line{background-color:var(--cds-interactive,#0f62fe)}.cds--progress-step-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--progress-step-button *,.cds--progress-step-button :after,.cds--progress-step-button :before{box-sizing:inherit}.cds--progress-step-button::-moz-focus-inner{border:0}.cds--progress-step-button--unclickable{cursor:default;outline:none}.cds--progress-step-button--unclickable .cds--progress-label:hover{box-shadow:none;color:var(--cds-text-primary,#161616);cursor:default}.cds--progress-step-button--unclickable .cds--tooltip__label:hover{box-shadow:0 .0625rem var(--cds-link-primary,#0f62fe);color:var(--cds-link-primary,#0f62fe);cursor:pointer}.cds--progress-step--disabled,:host(cds-progress-step[disabled]){cursor:not-allowed;pointer-events:none}.cds--progress-step--disabled svg,:host(cds-progress-step[disabled]) svg{cursor:not-allowed;fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--progress-step--disabled .cds--progress-label,.cds--progress-step--disabled .cds--progress-label:hover,:host(cds-progress-step[disabled]) .cds--progress-label{box-shadow:none;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--progress-step--disabled .cds--progress-line,:host(cds-progress-step[disabled]) .cds--progress-line{cursor:not-allowed}.cds--progress-step--disabled .cds--progress-label-overflow:hover~.cds--tooltip--definition .cds--tooltip--definition__bottom,:host(cds-progress-step[disabled]) .cds--progress-label-overflow:hover~.cds--tooltip--definition .cds--tooltip--definition__bottom{display:none}.cds--progress__warning>*{fill:var(--cds-support-error,#da1e28)}.cds--progress.cds--skeleton .cds--progress-label{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:2.5rem;margin-block-start:.625rem;padding:0;pointer-events:none;position:relative}.cds--progress.cds--skeleton .cds--progress-label:active,.cds--progress.cds--skeleton .cds--progress-label:focus,.cds--progress.cds--skeleton .cds--progress-label:hover{border:none;cursor:default;outline:none}.cds--progress.cds--skeleton .cds--progress-label:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--progress.cds--skeleton .cds--progress-label:before{animation:none}}.cds--progress.cds--progress--vertical.cds--skeleton .cds--progress-label{margin-block-start:.0625rem}.cds--progress--vertical,:host(cds-progress-indicator-skeleton[vertical]),:host(cds-progress-indicator[vertical]){display:flex;flex-direction:column}.cds--progress--vertical,.cds--progress-text,:host(cds-progress-indicator-skeleton[vertical]),:host(cds-progress-indicator[vertical]){display:flex;flex-direction:column}.cds--progress--vertical .cds--progress-step,.cds--progress--vertical .cds--progress-step-button,.cds--progress--vertical :host(cds-progress-step),.cds--progress--vertical :host(cds-progress-step-skeleton),:host(cds-progress-indicator-skeleton[vertical]) .cds--progress-step,:host(cds-progress-indicator-skeleton[vertical]) .cds--progress-step-button,:host(cds-progress-indicator-skeleton[vertical]) :host(cds-progress-step),:host(cds-progress-indicator-skeleton[vertical]) :host(cds-progress-step-skeleton),:host(cds-progress-indicator[vertical]) .cds--progress-step,:host(cds-progress-indicator[vertical]) .cds--progress-step-button,:host(cds-progress-indicator[vertical]) :host(cds-progress-step),:host(cds-progress-indicator[vertical]) :host(cds-progress-step-skeleton){align-content:flex-start;inline-size:auto;min-block-size:3.625rem;min-inline-size:0}.cds--progress--vertical .cds--progress-step svg,.cds--progress--vertical .cds--progress-step-button svg,.cds--progress--vertical :host(cds-progress-step) svg,.cds--progress--vertical :host(cds-progress-step-skeleton) svg,:host(cds-progress-indicator-skeleton[vertical]) .cds--progress-step svg,:host(cds-progress-indicator-skeleton[vertical]) .cds--progress-step-button svg,:host(cds-progress-indicator-skeleton[vertical]) :host(cds-progress-step) svg,:host(cds-progress-indicator-skeleton[vertical]) :host(cds-progress-step-skeleton) svg,:host(cds-progress-indicator[vertical]) .cds--progress-step svg,:host(cds-progress-indicator[vertical]) .cds--progress-step-button svg,:host(cds-progress-indicator[vertical]) :host(cds-progress-step) svg,:host(cds-progress-indicator[vertical]) :host(cds-progress-step-skeleton) svg{display:inline-block;margin:.0625rem .5rem 0}.cds--progress--vertical .cds--progress-label,:host(cds-progress-indicator-skeleton[vertical]) .cds--progress-label,:host(cds-progress-indicator[vertical]) .cds--progress-label{display:inline-block;inline-size:auto;margin:0;max-inline-size:10rem;vertical-align:top;white-space:normal}.cds--progress--vertical .cds--progress-step .cds--tooltip,.cds--progress--vertical :host(cds-progress-step) .cds--tooltip,.cds--progress--vertical :host(cds-progress-step-skeleton) .cds--tooltip,:host(cds-progress-indicator-skeleton[vertical]) .cds--progress-step .cds--tooltip,:host(cds-progress-indicator-skeleton[vertical]) :host(cds-progress-step) .cds--tooltip,:host(cds-progress-indicator-skeleton[vertical]) :host(cds-progress-step-skeleton) .cds--tooltip,:host(cds-progress-indicator[vertical]) .cds--progress-step .cds--tooltip,:host(cds-progress-indicator[vertical]) :host(cds-progress-step) .cds--tooltip,:host(cds-progress-indicator[vertical]) :host(cds-progress-step-skeleton) .cds--tooltip{margin-block-start:.5rem}.cds--progress--vertical .cds--progress-optional,:host(cds-progress-indicator-skeleton[vertical]) .cds--progress-optional,:host(cds-progress-indicator[vertical]) .cds--progress-optional{inline-size:100%;margin:0 0 auto;position:static}.cds--progress--vertical .cds--progress-line,:host(cds-progress-indicator-skeleton[vertical]) .cds--progress-line,:host(cds-progress-indicator[vertical]) .cds--progress-line{block-size:100%;inline-size:1px;inset-block-start:0;inset-inline-start:0;position:absolute}:host(cds-progress-step),:host(cds-progress-step-skeleton){outline:none}:host(cds-progress-step) .cds--progress-line,:host(cds-progress-step-skeleton) .cds--progress-line{inline-size:100%}:host(cds-progress-step-skeleton[vertical]),:host(cds-progress-step[vertical]){display:list-item;inline-size:auto;min-block-size:3.625rem;min-inline-size:0}:host(cds-progress-step-skeleton[vertical]) svg,:host(cds-progress-step[vertical]) svg{display:inline-block;margin:.1rem .25rem .1rem .5rem}:host(cds-progress-step-skeleton[vertical]) .cds--progress-label,:host(cds-progress-step[vertical]) .cds--progress-label{display:inline-block;margin:0;max-inline-size:none;vertical-align:top}:host(cds-progress-step-skeleton[vertical]) .cds--progress-line,:host(cds-progress-step[vertical]) .cds--progress-line{block-size:100%;inline-size:1px;inset-block-start:0;inset-inline-start:0}:host(cds-progress-step[vertical]) .cds--progress-label{inline-size:auto}:host(cds-progress-step[vertical]) .cds--progress-optional{margin-block-start:auto;margin-inline-start:2rem;position:static}:host(cds-progress-step[vertical]) .cds--progress-step-button{display:block}:host(cds-progress-step[vertical][state=current]) svg{margin-inline-start:.563rem}:host(cds-progress-step[state=current]) svg{fill:var(--cds-interactive,#0f62fe)}:host(cds-progress-step[state=complete]) svg{fill:var(--cds-interactive,#0f62fe)}:host(cds-progress-step-skeleton) svg{fill:var(--cds-layer-selected-inverse,#161616)}:host(cds-progress-step-skeleton) .cds--progress-line{background-color:var(--cds-layer-accent-01,#e0e0e0)}:host(cds-progress-step[spaceEqually]){flex-grow:1}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hAZ2n":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSProgressIndicatorSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _progressIndicatorScssJs = require("./progress-indicator.scss.js");
var _progressIndicatorScssJsDefault = parcelHelpers.interopDefault(_progressIndicatorScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of progress indicator.
 */ let CDSProgressIndicatorSkeleton = class CDSProgressIndicatorSkeleton extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if the progress indicator should be vertical. Corresponds to the attribute with the same name.
         */ this.vertical = false;
    }
    updated(changedProperties) {
        if (changedProperties.has("vertical")) // Propagate `vertical` attribute to descendants until `:host-context()` gets supported in all major browsers
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorStep), (item)=>{
            item.vertical = this.vertical;
        });
    }
    render() {
        return (0, _lit.html)`<slot></slot>`;
    }
    /**
     * A selector that will return progress steps.
     */ static get selectorStep() {
        return `${0, _settingsJs.prefix}-progress-step-skeleton`;
    }
};
CDSProgressIndicatorSkeleton.styles = (0, _progressIndicatorScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSProgressIndicatorSkeleton.prototype, "vertical", void 0);
CDSProgressIndicatorSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-progress-indicator-skeleton`)
], CDSProgressIndicatorSkeleton);
var CDSProgressIndicatorSkeleton$1 = CDSProgressIndicatorSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/internal/collection-helpers.js":"4aZkz","./progress-indicator.scss.js":"gpxU7","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9d7Ju":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROGRESS_STEP_STAT", ()=>(0, _defsJs.PROGRESS_STEP_STAT));
parcelHelpers.export(exports, "default", ()=>CDSProgressStep$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _16Js = require("../../icons/checkmark--outline/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/circle-dash/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _16Js2 = require("../../icons/incomplete/16.js");
var _16JsDefault2 = parcelHelpers.interopDefault(_16Js2);
var _16Js3 = require("../../icons/warning/16.js");
var _16JsDefault3 = parcelHelpers.interopDefault(_16Js3);
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _defsJs = require("./defs.js");
var _progressIndicatorScssJs = require("./progress-indicator.scss.js");
var _progressIndicatorScssJsDefault = parcelHelpers.interopDefault(_progressIndicatorScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Icons, keyed by state.
 */ const icons = {
    [(0, _defsJs.PROGRESS_STEP_STAT).COMPLETE]: (0, _16JsDefault.default),
    [(0, _defsJs.PROGRESS_STEP_STAT).INCOMPLETE]: (0, _16JsDefault1.default),
    [(0, _defsJs.PROGRESS_STEP_STAT).INVALID]: (0, _16JsDefault3.default),
    [(0, _defsJs.PROGRESS_STEP_STAT).CURRENT]: (0, _16JsDefault2.default)
};
/**
 * Progress step.
 *
 * @element cds-progress-step
 * @slot secondary-label-text - The secondary progress label.
 */ let CDSProgressStep = class CDSProgressStep extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if the progress step should be disabled.
         */ this.disabled = false;
        /**
         * The progress state.
         */ this.state = (0, _defsJs.PROGRESS_STEP_STAT).INCOMPLETE;
        /**
         * `true` if the progress step should be vertical.
         *
         * @private
         */ this.vertical = false;
        /**
         * `true` if the progress step should be spaced equally.
         *
         * @private
         */ this.spaceEqually = false;
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "listitem");
        super.connectedCallback();
    }
    updated(changedProperties) {
        if (changedProperties.has("disabled")) this.setAttribute("aria-disabled", String(Boolean(this.disabled)));
    }
    render() {
        const { description, iconLabel, label, secondaryLabelText, secondaryLabel, state } = this;
        const svgLabel = iconLabel || description;
        const optionalLabel = secondaryLabelText || secondaryLabel;
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--progress-step-button" tabindex="0">
        ${icons[state]({
            class: {
                [(0, _defsJs.PROGRESS_STEP_STAT).INVALID]: `${(0, _settingsJs.prefix)}--progress__warning`
            }[state],
            children: svgLabel ? (0, _lit.svg)`<title>${svgLabel}</title>` : undefined
        })}
        <slot name="label-text">
          <p
            role="button"
            class="${0, _settingsJs.prefix}--progress-label"
            aria-describedby="label-tooltip"
            title="${label}">
            ${label}
          </p>
        </slot>
        <slot name="secondary-label-text">
          ${!optionalLabel ? undefined : (0, _lit.html)`<p class="${0, _settingsJs.prefix}--progress-optional">
                ${optionalLabel}
              </p>`}
        </slot>
        <span class="${0, _settingsJs.prefix}--progress-line"></span>
      </div>
    `;
    }
};
CDSProgressStep.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSProgressStep.styles = (0, _progressIndicatorScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSProgressStep.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "icon-label"
    })
], CDSProgressStep.prototype, "iconLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSProgressStep.prototype, "description", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label-text"
    })
], CDSProgressStep.prototype, "labelText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSProgressStep.prototype, "label", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "secondary-label-text"
    })
], CDSProgressStep.prototype, "secondaryLabelText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "secondary-label"
    })
], CDSProgressStep.prototype, "secondaryLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSProgressStep.prototype, "state", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSProgressStep.prototype, "vertical", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSProgressStep.prototype, "spaceEqually", void 0);
CDSProgressStep = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-progress-step`)
], CDSProgressStep);
var CDSProgressStep$1 = CDSProgressStep;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/checkmark--outline/16.js":"i4uh7","../../icons/circle-dash/16.js":"3fUih","../../icons/incomplete/16.js":"1alit","../../icons/warning/16.js":"9PYbD","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./defs.js":"aYLFs","./progress-indicator.scss.js":"gpxU7","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i4uh7":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"></path><path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3fUih":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1alit":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aYLFs":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * State of progress step.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROGRESS_STEP_STAT", ()=>PROGRESS_STEP_STAT);
var PROGRESS_STEP_STAT;
(function(PROGRESS_STEP_STAT) {
    /**
     * Complete one.
     */ PROGRESS_STEP_STAT["COMPLETE"] = "complete";
    /**
     * One that is being executed now.
     */ PROGRESS_STEP_STAT["CURRENT"] = "current";
    /**
     * One for future execution.
     */ PROGRESS_STEP_STAT["INCOMPLETE"] = "incomplete";
    /**
     * Invalid one.
     */ PROGRESS_STEP_STAT["INVALID"] = "invalid";
})(PROGRESS_STEP_STAT || (PROGRESS_STEP_STAT = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lg9eE":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSProgressStepSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _progressIndicatorScssJs = require("./progress-indicator.scss.js");
var _progressIndicatorScssJsDefault = parcelHelpers.interopDefault(_progressIndicatorScssJs);
var _16 = require("../../icons/circle-dash/16");
var _16Default = parcelHelpers.interopDefault(_16);
var _skeletonTextJs = require("../skeleton-text/skeleton-text.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of progress step.
 */ let CDSProgressStepSkeleton = class CDSProgressStepSkeleton extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if the progress indicator should be vertical. Corresponds to the attribute with the same name.
         */ this.vertical = false;
    }
    render() {
        return (0, _lit.html)`
      <div
        class="${0, _settingsJs.prefix}--progress-step-button ${0, _settingsJs.prefix}--progress-step-button--unclickable">
        ${(0, _16Default.default)()}
        <p class="${0, _settingsJs.prefix}--progress-label">
          <cds-skeleton-text width="40px" linecount="1"></cds-skeleton-text>
        </p>
        <span class="${0, _settingsJs.prefix}--progress-line"></span>
      </div>
    `;
    }
};
CDSProgressStepSkeleton.styles = (0, _progressIndicatorScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSProgressStepSkeleton.prototype, "vertical", void 0);
CDSProgressStepSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-progress-step-skeleton`)
], CDSProgressStepSkeleton);
var CDSProgressStepSkeleton$1 = CDSProgressStepSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","./progress-indicator.scss.js":"gpxU7","../../icons/circle-dash/16":"3fUih","../skeleton-text/skeleton-text.js":"9W6nb","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"E51aG":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _radioButtonJs = require("./radio-button.js");
var _radioButtonGroupJs = require("./radio-button-group.js");
var _radioButtonSkeletonJs = require("./radio-button-skeleton.js");

},{"./radio-button.js":"gwtyG","./radio-button-group.js":"fRk8E","./radio-button-skeleton.js":"6Dt6h"}],"3bVoZ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _searchJs = require("./search.js");
var _searchSkeletonJs = require("./search-skeleton.js");

},{"./search.js":"hzhB5","./search-skeleton.js":"8zzNt"}],"8zzNt":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSearchSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _textInputJs = require("../text-input/text-input.js");
var _searchScssJs = require("./search.scss.js");
var _searchScssJsDefault = parcelHelpers.interopDefault(_searchScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("../text-input/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of search.
 */ let CDSSearchSkeleton = class CDSSearchSkeleton extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * The search box size. Corresponds to the attribute with the same name.
         */ this.size = (0, _defsJs.INPUT_SIZE).MEDIUM;
    }
    render() {
        return (0, _lit.html)`
      <span class="${0, _settingsJs.prefix}--label"></span>
      <div class="${0, _settingsJs.prefix}--search-input"></div>
    `;
    }
};
CDSSearchSkeleton.styles = (0, _searchScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSSearchSkeleton.prototype, "size", void 0);
CDSSearchSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-search-skeleton`)
], CDSSearchSkeleton);
var CDSSearchSkeleton$1 = CDSSearchSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../text-input/text-input.js":"lBj7P","./search.scss.js":"hb40q","../../globals/decorators/carbon-element.js":"kNhLR","../text-input/defs.js":"83oMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g8w4O":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _sliderJs = require("./slider.js");
var _sliderInputJs = require("./slider-input.js");
var _sliderSkeletonJs = require("./slider-skeleton.js");

},{"./slider.js":"kxWsE","./slider-input.js":"6l3da","./slider-skeleton.js":"5jduq"}],"kxWsE":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSlider$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _classMapJs = require("lit/directives/class-map.js");
var _throttle = require("lodash-es/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _formJs = require("../../globals/mixins/form.js");
var _formJsDefault = parcelHelpers.interopDefault(_formJs);
var _hostListenerJs = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _sliderScssJs = require("./slider.scss.js");
var _sliderScssJsDefault = parcelHelpers.interopDefault(_sliderScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The direction to move the thumb, associated with key symbols.
 */ const THUMB_DIRECTION = {
    Left: -1,
    ArrowLeft: -1,
    Up: -1,
    ArrowUp: -1,
    Right: 1,
    ArrowRight: 1,
    Down: 1,
    ArrowDown: 1
};
/**
 * Slider.
 *
 * @element cds-slider
 * @fires cds-slider-input-changed
 *   The name of the custom event fired after the value is changed in `<cds-slider-input>` by user gesture.
 * @slot label-text - The label text.
 * @slot max-text - The text for maximum value.
 * @slot min-text - The text for minimum value.
 * @fires cds-slider-changed - The custom event fired after the value is changed by user gesture.
 */ let CDSSlider = class CDSSlider extends (0, _hostListenerJsDefault.default)((0, _formJsDefault.default)((0, _focusJsDefault.default)((0, _lit.LitElement)))) {
    constructor(){
        super(...arguments);
        /**
         * The internal value of `max` property.
         */ this._max = "100";
        /**
         * The internal value of `min` property.
         */ this._min = "0";
        /**
         * The internal value of `step` property.
         */ this._step = "1";
        /**
         * The internal value of `stepMultiplier` property.
         */ this._stepMultiplier = "4";
        /**
         * The handle for the throttled listener of `pointermove` event.
         */ this._throttledHandlePointermoveImpl = null;
        /**
         * `true` if dragging of thumb is in progress.
         */ this._dragging = false;
        /**
         * Handles `pointermove` to update the thumb position and the value as necessary.
         *
         * @param event The event.
         */ this._handlePointermove = (event)=>{
            const { disabled, _dragging: dragging } = this;
            if (!disabled && dragging) this._throttledHandlePointermoveImpl(event);
        };
        /**
         * Handles `pointerup` and `pointerleave` event to finishing dragging.
         */ this._endDrag = ()=>{
            if (this._dragging) {
                this.dispatchEvent(new CustomEvent(this.constructor.eventChange, {
                    bubbles: true,
                    composed: true,
                    detail: {
                        value: this.value
                    }
                }));
                this._dragging = false;
                this._thumbNode.style.touchAction = "";
            }
        };
        /**
         * Handles `${prefix}-slider-input-changed` event to update the value.
         */ this._handleChangeInput = ({ detail })=>{
            const { intermediate, value } = detail;
            this.value = value;
            this.dispatchEvent(new CustomEvent(this.constructor.eventChange, {
                bubbles: true,
                composed: true,
                detail: {
                    value,
                    intermediate
                }
            }));
        };
        /**
         * `true` if the check box should be disabled.
         */ this.disabled = false;
        /**
         * 	true to specify if the control is required.
         */ this.required = false;
        /**
         * 	Whether the slider should be read-only
         */ this.readonly = false;
        /**
         * The label text.
         */ this.labelText = "";
        /**
         * The label associated with the maximum value.
         */ this.maxLabel = "";
        /**
         * The label associated with the minimum value.
         */ this.minLabel = "";
        /**
         * The formatter for the text for maximum value.
         * Should be changed upon the locale the UI is rendered with.
         */ this.formatMaxText = (max, maxLabel)=>`${max}${maxLabel}`;
        /**
         * The formatter for the text for min/max value.
         * Should be changed upon the locale the UI is rendered with.
         */ this.formatMinText = (min, minLabel)=>`${min}${minLabel}`;
        /**
         * true to specify if the control is invalid.
         */ this.invalid = false;
        /**
         * Message which is displayed if the value is invalid.
         */ this.invalidText = "";
        /**
         * true to specify if the control should display warn icon and text.
         */ this.warn = false;
        /**
         * Provide the text that is displayed when the control is in warning state
         */ this.warnText = "";
    }
    /**
     * The rate of the thumb position in the track.
     * When we try to set a new value, we adjust the value considering `step` property.
     */ get _rate() {
        const { max, min, value } = this;
        // Copes with out-of-range value coming programmatically or from `<cds-slider-input>`
        return (Math.min(Number(max), Math.max(Number(min), value)) - Number(min)) / (Number(max) - Number(min));
    }
    set _rate(rate) {
        const { max, min, step } = this;
        this.value = Number(min) + Math.round((Number(max) - Number(min)) * Math.min(1, Math.max(0, rate)) / Number(step)) * Number(step);
    }
    /**
     * Handles `click` event on the `<label>` to focus on the thumb.
     */ _handleClickLabel() {
        var _a;
        (_a = this._thumbNode) === null || _a === void 0 || _a.focus();
    }
    _handleFormdata(event) {
        const { formData } = event; // TODO: Wait for `FormDataEvent` being available in `lib.dom.d.ts`
        const { disabled, name, value } = this;
        if (!disabled) formData.append(name, String(value));
    }
    /**
     * Handles `keydown` event on the thumb to increase/decrease the value.
     */ _handleKeydown({ key, shiftKey }) {
        if (!this.disabled) {
            if (key in THUMB_DIRECTION) {
                const { max: rawMax, min: rawMin, step: rawStep, stepMultiplier: rawstepMultiplier, value } = this;
                const max = Number(rawMax);
                const min = Number(rawMin);
                const step = Number(rawStep);
                const stepMultiplier = Number(rawstepMultiplier);
                const diff = (!shiftKey ? step : (max - min) / stepMultiplier) * THUMB_DIRECTION[key];
                const stepCount = (value + diff) / step;
                // Snaps to next
                this.value = Math.min(max, Math.max(min, (diff >= 0 ? Math.floor(stepCount) : Math.ceil(stepCount)) * step));
                this.dispatchEvent(new CustomEvent(this.constructor.eventChange, {
                    bubbles: true,
                    composed: true,
                    detail: {
                        value: this.value,
                        intermediate: false
                    }
                }));
            }
        }
    }
    /**
     * Handles `pointerdown` event on the thumb to start dragging.
     */ _startDrag() {
        this._dragging = true;
        this._thumbNode.style.touchAction = "none";
    }
    /**
     * Handles `pointerdown` event on the track to update the thumb position and the value as necessary.
     */ _handleClick(event) {
        if (!this.disabled) {
            const { _trackNode: trackNode } = this;
            const isRtl = trackNode.ownerDocument.defaultView.getComputedStyle(trackNode).getPropertyValue("direction") === "rtl";
            const thumbPosition = event.clientX;
            const { left: trackLeft, width: trackWidth } = trackNode.getBoundingClientRect();
            this._rate = (isRtl ? trackLeft + trackWidth - thumbPosition : thumbPosition - trackLeft) / trackWidth;
            this.dispatchEvent(new CustomEvent(this.constructor.eventChange, {
                bubbles: true,
                composed: true,
                detail: {
                    value: this.value
                }
            }));
        }
    }
    /**
     * Updates thumb position and value upon user's `pointermove` gesture.
     *
     * @param event The event.
     */ _handlePointermoveImpl(event) {
        const { disabled, _dragging: dragging, _trackNode: trackNode } = this;
        if (!disabled && dragging) {
            const isRtl = trackNode.ownerDocument.defaultView.getComputedStyle(trackNode).getPropertyValue("direction") === "rtl";
            const thumbPosition = event.clientX;
            const { left: trackLeft, width: trackWidth } = this._trackNode.getBoundingClientRect();
            this._rate = (isRtl ? trackLeft + trackWidth - thumbPosition : thumbPosition - trackLeft) / trackWidth;
            this.dispatchEvent(new CustomEvent(this.constructor.eventChange, {
                bubbles: true,
                composed: true,
                detail: {
                    value: this.value,
                    intermediate: true
                }
            }));
        }
    }
    /**
     * The maximum value.
     */ get max() {
        return this._max.toString();
    }
    set max(value) {
        const { max: oldMax } = this;
        this._max = value;
        this.requestUpdate("max", oldMax);
    }
    /**
     * The minimum value.
     */ get min() {
        return this._min.toString();
    }
    set min(value) {
        const { min: oldMin } = this;
        this._min = value;
        this.requestUpdate("min", oldMin);
    }
    /**
     * The snapping step of the value.
     */ get step() {
        return this._step.toString();
    }
    set step(value) {
        const { step: oldStep } = this;
        this._step = value;
        this.requestUpdate("step", oldStep);
    }
    /**
     * A value determining how much the value should increase/decrease by Shift+arrow keys,
     * which will be `(max - min) / stepMultiplier`.
     */ get stepMultiplier() {
        return this._stepMultiplier.toString();
    }
    set stepMultiplier(value) {
        const { stepMultiplier: oldstepMultiplier } = this;
        this._stepMultiplier = value;
        this.requestUpdate("stepMultiplier", oldstepMultiplier);
    }
    _getInputValidity(input) {
        if (this.invalid) return false;
        if ((input === null || input === void 0 ? void 0 : input.valueAsNumber) > Number(this.max) || (input === null || input === void 0 ? void 0 : input.valueAsNumber) < Number(this.min)) return false;
        return true;
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this._throttledHandlePointermoveImpl) this._throttledHandlePointermoveImpl = (0, _throttleDefault.default)(this._handlePointermoveImpl, 10);
    }
    disconnectedCallback() {
        if (this._throttledHandlePointermoveImpl) {
            this._throttledHandlePointermoveImpl.cancel();
            this._throttledHandlePointermoveImpl = null;
        }
        super.disconnectedCallback();
    }
    shouldUpdate(changedProperties) {
        var _a;
        const input = this.querySelector(this.constructor.selectorInput);
        if (changedProperties.has("disabled")) {
            if (input) input.disabled = this.disabled;
            if (this.disabled) this._dragging = false;
        }
        if (changedProperties.has("readonly")) {
            if (input) input.readonly = this.readonly;
            if (this.readonly) this._dragging = false;
        }
        if (input) {
            [
                "max",
                "min",
                "step",
                "value"
            ].forEach((name)=>{
                if (changedProperties.has(name)) input[name] = this[name];
            });
            if (changedProperties.has("value") || changedProperties.has("invalid") || changedProperties.has("warn") || changedProperties.has("readonly")) {
                const innerInput = (_a = input === null || input === void 0 ? void 0 : input.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("input");
                this.isValid = this._getInputValidity(innerInput);
                if (!this.readonly && !this.isValid) input.invalid = true;
                else input.invalid = false;
                if (!this.readonly && !this.invalid && this.warn && this.isValid) input.warn = true;
                else input.warn = false;
            }
        }
        return true;
    }
    render() {
        const { disabled, formatMaxText, formatMinText, labelText, max, min, maxLabel, minLabel, readonly, invalidText, isValid, warn, warnText, value, _rate: rate, _handleClickLabel: handleClickLabel, _handleKeydown: handleKeydown, _handleClick: handleClick, _startDrag: startDrag, _endDrag: endDrag } = this;
        const labelClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--label`]: true,
            [`${0, _settingsJs.prefix}--label--disabled`]: disabled
        });
        const sliderClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--slider`]: true,
            [`${0, _settingsJs.prefix}--slider--disabled`]: disabled,
            [`${0, _settingsJs.prefix}--slider--readonly`]: readonly
        });
        return (0, _lit.html)`
      <label class="${labelClasses}" @click="${handleClickLabel}">
        <slot name="label-text">${labelText}</slot>
      </label>
      <div class="${0, _settingsJs.prefix}--slider-container">
        <span class="${0, _settingsJs.prefix}--slider__range-label">
          <slot name="min-text">${formatMinText(min, minLabel)}</slot>
        </span>
        <div
          @keydown="${handleKeydown}"
          @click="${handleClick}"
          @pointerup="${endDrag}"
          @pointerleave="${endDrag}"
          class="${sliderClasses}"
          tabindex="-1"
          role="presentation">
          <div
            id="thumb"
            class="${0, _settingsJs.prefix}--slider__thumb"
            role="slider"
            tabindex="${!readonly ? 0 : -1}"
            aria-valuemax="${max}"
            aria-valuemin="${min}"
            aria-valuenow="${value}"
            style="left: ${rate * 100}%"
            @pointerdown="${startDrag}"></div>
          <div id="track" class="${0, _settingsJs.prefix}--slider__track"></div>
          <div class="${0, _settingsJs.prefix}-ce--slider__filled-track-container">
            <div
              class="${0, _settingsJs.prefix}--slider__filled-track"
              style="transform: translate(0%, -50%) scaleX(${rate})"></div>
          </div>
        </div>
        <span class="${0, _settingsJs.prefix}--slider__range-label">
          <slot name="max-text">${formatMaxText(max, maxLabel)}</slot>
        </span>
        <slot></slot>
      </div>

      ${!readonly && !isValid ? (0, _lit.html)`
            <div
              class="${0, _settingsJs.prefix}--slider__validation-msg ${0, _settingsJs.prefix}--slider__validation-msg--invalid ${0, _settingsJs.prefix}--form-requirement">
              ${invalidText}
            </div>
          ` : null}
      ${!readonly && warn && isValid ? (0, _lit.html)`<div
            class="${0, _settingsJs.prefix}--slider__validation-msg ${0, _settingsJs.prefix}--form-requirement">
            ${warnText}
          </div>` : null}
    `;
    }
    /**
     * A selector that will return the `<input>` box got entering the value directly.
     */ static get selectorInput() {
        return `${0, _settingsJs.prefix}-slider-input`;
    }
    /**
     * The name of the custom event fired after the value is changed by user gesture.
     */ static get eventChange() {
        return `${0, _settingsJs.prefix}-slider-changed`;
    }
    /**
     * The name of the custom event fired after the value is changed in `<cds-slider-input>` by user gesture.
     */ static get eventChangeInput() {
        return `${0, _settingsJs.prefix}-slider-input-changed`;
    }
};
CDSSlider.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSSlider.styles = (0, _sliderScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#thumb")
], CDSSlider.prototype, "_thumbNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#track")
], CDSSlider.prototype, "_trackNode", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("document:pointermove")
], CDSSlider.prototype, "_handlePointermove", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("eventChangeInput")
], CDSSlider.prototype, "_handleChangeInput", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSlider.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSlider.prototype, "required", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSlider.prototype, "readonly", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label-text"
    })
], CDSSlider.prototype, "labelText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "max-label",
        reflect: true
    })
], CDSSlider.prototype, "maxLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "min-label",
        reflect: true
    })
], CDSSlider.prototype, "minLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: false
    })
], CDSSlider.prototype, "formatMaxText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: false
    })
], CDSSlider.prototype, "formatMinText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true
    })
], CDSSlider.prototype, "max", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true
    })
], CDSSlider.prototype, "min", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSlider.prototype, "name", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSlider.prototype, "invalid", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "invalid-text"
    })
], CDSSlider.prototype, "invalidText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSlider.prototype, "warn", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "warn-text"
    })
], CDSSlider.prototype, "warnText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true
    })
], CDSSlider.prototype, "step", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true,
        attribute: "step-multiplier"
    })
], CDSSlider.prototype, "stepMultiplier", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number
    })
], CDSSlider.prototype, "value", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSSlider.prototype, "isValid", void 0);
CDSSlider = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-slider`)
], CDSSlider);
var CDSSlider$1 = CDSSlider;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/class-map.js":"2fQud","lodash-es/throttle":"9NpdZ","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","../../globals/mixins/form.js":"kISjL","../../globals/mixins/host-listener.js":"1SMUX","../../globals/decorators/host-listener.js":"f95Mj","./slider.scss.js":"4QEG9","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9NpdZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _debounceJs = require("./debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    if ((0, _isObjectJsDefault.default)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, _debounceJsDefault.default)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
exports.default = throttle;

},{"./debounce.js":"GpTQc","./isObject.js":"boUsC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"GpTQc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _nowJs = require("./now.js");
var _nowJsDefault = parcelHelpers.interopDefault(_nowJs);
var _toNumberJs = require("./toNumber.js");
var _toNumberJsDefault = parcelHelpers.interopDefault(_toNumberJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    wait = (0, _toNumberJsDefault.default)(wait) || 0;
    if ((0, _isObjectJsDefault.default)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax((0, _toNumberJsDefault.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, _nowJsDefault.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, _nowJsDefault.default)());
    }
    function debounced() {
        var time = (0, _nowJsDefault.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
exports.default = debounce;

},{"./isObject.js":"boUsC","./now.js":"gzUuE","./toNumber.js":"kcAV3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"boUsC":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
exports.default = isObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gzUuE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return (0, _rootJsDefault.default).Date.now();
};
exports.default = now;

},{"./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cTEWZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = (0, _freeGlobalJsDefault.default) || freeSelf || Function("return this")();
exports.default = root;

},{"./_freeGlobal.js":"39xL9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"39xL9":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
exports.default = freeGlobal;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kcAV3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTrimJs = require("./_baseTrim.js");
var _baseTrimJsDefault = parcelHelpers.interopDefault(_baseTrimJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, _isSymbolJsDefault.default)(value)) return NAN;
    if ((0, _isObjectJsDefault.default)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, _isObjectJsDefault.default)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, _baseTrimJsDefault.default)(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
exports.default = toNumber;

},{"./_baseTrim.js":"1MrU6","./isObject.js":"boUsC","./isSymbol.js":"bAp74","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1MrU6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trimmedEndIndexJs = require("./_trimmedEndIndex.js");
var _trimmedEndIndexJsDefault = parcelHelpers.interopDefault(_trimmedEndIndexJs);
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, (0, _trimmedEndIndexJsDefault.default)(string) + 1).replace(reTrimStart, "") : string;
}
exports.default = baseTrim;

},{"./_trimmedEndIndex.js":"1Li8u","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Li8u":[function(require,module,exports) {
/** Used to match a single whitespace character. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
exports.default = trimmedEndIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bAp74":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == symbolTag;
}
exports.default = isSymbol;

},{"./_baseGetTag.js":"cZgKC","./isObjectLike.js":"hcFFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cZgKC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _getRawTagJs = require("./_getRawTag.js");
var _getRawTagJsDefault = parcelHelpers.interopDefault(_getRawTagJs);
var _objectToStringJs = require("./_objectToString.js");
var _objectToStringJsDefault = parcelHelpers.interopDefault(_objectToStringJs);
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? (0, _getRawTagJsDefault.default)(value) : (0, _objectToStringJsDefault.default)(value);
}
exports.default = baseGetTag;

},{"./_Symbol.js":"xSCm6","./_getRawTag.js":"bWJbh","./_objectToString.js":"fQVkR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"xSCm6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Symbol = (0, _rootJsDefault.default).Symbol;
exports.default = Symbol;

},{"./_root.js":"cTEWZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bWJbh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
exports.default = getRawTag;

},{"./_Symbol.js":"xSCm6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fQVkR":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
exports.default = objectToString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hcFFR":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObjectLike(value) {
    return value != null && typeof value == "object";
}
exports.default = isObjectLike;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4QEG9":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--text-input{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));background-color:var(--cds-field);block-size:var(--cds-layout-size-height-local);border:none;border-block-end:1px solid var(--cds-border-strong);box-sizing:border-box;color:var(--cds-text-primary,#161616);font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:2px solid transparent;outline-offset:-2px;padding:0;padding:0 var(--cds-layout-density-padding-inline-local);transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--text-input *,.cds--text-input :after,.cds--text-input :before{box-sizing:inherit}.cds--text-input:active,.cds--text-input:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input:active,.cds--text-input:focus{outline-style:dotted}}.cds--text-input-wrapper svg[hidden]{display:none}.cds--password-input{padding-inline-end:2.5rem}.cds--text-input--sm.cds--password-input{padding-inline-end:2rem}.cds--text-input--lg.cds--password-input{padding-inline-end:3rem}.cds--text-input::-moz-placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input::placeholder{color:var(--cds-text-placeholder,hsla(0,0%,9%,.4));opacity:1}.cds--text-input--light{background-color:var(--cds-field-02,#fff)}.cds--text-input__field-wrapper{display:flex;inline-size:100%;position:relative}.cds--text-input__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:1rem;transform:translateY(-50%)}.cds--text-input__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--text-input__invalid-icon--warning path:first-of-type{fill:#000;opacity:1}.cds--text-input--password__visibility{align-items:center;cursor:pointer;display:inline-flex;overflow:visible;position:relative}.cds--text-input--password__visibility:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus{outline-style:dotted}}.cds--text-input--password__visibility:focus{outline:1px solid transparent}.cds--text-input--password__visibility:focus svg{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--text-input--password__visibility:focus svg{outline-style:dotted}}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{align-items:center;display:flex;opacity:0;pointer-events:none;position:absolute;z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{display:inline-block}}.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:opacity 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{transition:none}}.cds--text-input--password__visibility.cds--tooltip--a11y:after,.cds--text-input--password__visibility.cds--tooltip--a11y:before{transition:none}.cds--text-input--password__visibility:before{block-size:0;border-style:solid;content:"";inline-size:0}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text{box-sizing:content-box;color:inherit;opacity:1;white-space:normal;word-break:break-word}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{background-color:var(--cds-background-inverse,#393939);block-size:auto;border-radius:.125rem;box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:400;font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);max-inline-size:13rem;min-inline-size:1.5rem;padding:.1875rem 1rem;text-align:start;transform:translateX(-50%);z-index:6000}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-accelerator:true){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@supports (-ms-ime-align:auto){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inline-size:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{border:1px solid transparent}}.cds--text-input--password__visibility:after{content:attr(aria-label)}.cds--text-input--password__visibility.cds--tooltip--a11y:after{content:none}.cds--text-input--password__visibility.cds--tooltip--visible:after,.cds--text-input--password__visibility.cds--tooltip--visible:before,.cds--text-input--password__visibility:focus:after,.cds--text-input--password__visibility:focus:before,.cds--text-input--password__visibility:hover:after,.cds--text-input--password__visibility:hover:before{opacity:1}@keyframes cds--tooltip-fade{0%{opacity:0}to{opacity:1}}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text{margin:auto;overflow:visible;clip:auto}.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible+.cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--visible.cds--tooltip--a11y:before,.cds--text-input--password__visibility:focus .cds--assistive-text,.cds--text-input--password__visibility:focus+.cds--assistive-text,.cds--text-input--password__visibility:focus.cds--tooltip--a11y:before,.cds--text-input--password__visibility:hover .cds--assistive-text,.cds--text-input--password__visibility:hover+.cds--assistive-text,.cds--text-input--password__visibility:hover.cds--tooltip--a11y:before{animation:cds--tooltip-fade 70ms cubic-bezier(.2,0,.38,.9)}.cds--text-input--password__visibility.cds--tooltip--hidden .cds--assistive-text,.cds--text-input--password__visibility.cds--tooltip--hidden+.cds--assistive-text{margin:-1px;overflow:hidden;clip:rect(0,0,0,0)}.cds--text-input--password__visibility.cds--tooltip--hidden.cds--tooltip--a11y:before{animation:none;opacity:0}.cds--text-input--password__visibility .cds--assistive-text:after{block-size:.75rem;content:"";display:block;inline-size:100%;inset-block-start:-.75rem;inset-inline-start:0;position:absolute}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after,.cds--text-input--password__visibility:before{inset-block-end:0;inset-inline-start:50%}.cds--text-input--password__visibility:before{border-color:transparent transparent var(--cds-background-inverse,#393939);border-width:0 .25rem .3125rem;inset-block-end:-.5rem;transform:translate(-50%,100%)}.cds--text-input--password__visibility .cds--assistive-text,.cds--text-input--password__visibility+.cds--assistive-text,.cds--text-input--password__visibility:after{inset-block-end:-.8125rem;transform:translate(-50%,100%)}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{align-items:center;background:none;block-size:100%;border:0;cursor:pointer;display:flex;inline-size:2.5rem;inset-inline-end:0;justify-content:center;min-block-size:auto;outline:2px solid transparent;outline-offset:-2px;padding:0;position:absolute;transition:outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--toggle-password-tooltip .cds--popover{inset-inline-start:-2.5rem}.cds--toggle-password-tooltip .cds--popover-content{min-inline-size:2.5rem}.cds--text-input--sm+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:2rem}.cds--text-input--lg+.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{inline-size:3rem}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252);transition:fill 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg{fill:ButtonText}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus{outline-style:dotted}}.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus svg,.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-primary,#161616)}.cds--text-input--invalid,.cds--text-input--warning{padding-inline-end:2.5rem}.cds--text-input--invalid.cds--password-input{padding-inline-end:4rem}.cds--text-input--invalid+.cds--text-input--password__visibility__toggle{inset-inline-end:1rem}.cds--password-input-wrapper .cds--text-input__invalid-icon{inset-inline-end:2.5rem}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger{cursor:not-allowed}.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--text-input:disabled~.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg:hover{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover{cursor:default}.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--text-input__counter-alert{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px}.cds--text-input:disabled{background-color:var(--cds-field);border-block-end:1px solid transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;outline:2px solid transparent;outline-offset:-2px;-webkit-text-fill-color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--text-input--light:disabled{background-color:var(--cds-field-02,#fff)}.cds--text-input:disabled::-moz-placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input:disabled::placeholder{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));opacity:1}.cds--text-input--invalid{box-shadow:none;outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--text-input--invalid{outline-style:dotted}}.cds--text-input--invalid .cds--text-input--password__visibility__toggle{inset-inline-end:2.5rem}.cds--skeleton.cds--text-input{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;padding:0;pointer-events:none;position:relative}.cds--skeleton.cds--text-input:active,.cds--skeleton.cds--text-input:focus,.cds--skeleton.cds--text-input:hover{border:none;cursor:default;outline:none}.cds--skeleton.cds--text-input:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--skeleton.cds--text-input:before{animation:none}}.cds--form--fluid .cds--text-input-wrapper{background:var(--cds-field);position:relative;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--form--fluid .cds--label{align-items:center;block-size:1rem;display:flex;inset-block-start:.8125rem;inset-inline-start:1rem;margin:0;position:absolute;z-index:1}.cds--form--fluid .cds--form__helper-text{display:none}.cds--form--fluid .cds--text-input{min-block-size:4rem;padding:2rem 1rem .8125rem}.cds--form--fluid .cds--text-input__divider,.cds--text-input__divider{display:none}.cds--form--fluid .cds--text-input--invalid,.cds--form--fluid .cds--text-input--warning{border-block-end:none}.cds--form--fluid .cds--text-input--invalid+.cds--text-input__divider,.cds--form--fluid .cds--text-input--warning+.cds--text-input__divider{border-color:var(--cds-border-subtle);border-style:solid;border-block-end:none;display:block;margin:0 1rem}.cds--form--fluid .cds--text-input__invalid-icon{inset-block-start:5rem}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid{outline:none}.cds--form--fluid .cds--text-input__field-wrapper--warning{border-block-end:1px solid var(--cds-border-strong)}.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus){outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within{outline-style:dotted}}.cds--form--fluid .cds--text-input__field-wrapper--warning>.cds--text-input--warning:focus,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:focus{outline:none}.cds--text-input-wrapper.cds--text-input-wrapper--inline{flex-flow:row wrap}.cds--text-input-wrapper .cds--label--inline{flex:1;margin:.8125rem 0 0;overflow-wrap:break-word;word-break:break-word}.cds--text-input-wrapper .cds--label--inline--sm{margin-block-start:.5625rem}.cds--text-input-wrapper .cds--label--inline--lg{margin-block-start:1.0625rem}.cds--text-input__label-helper-wrapper{flex:2;flex-direction:column;margin-inline-end:1.5rem;max-inline-size:8rem;overflow-wrap:break-word}.cds--text-input-wrapper .cds--form__helper-text--inline{margin-block-start:.125rem}.cds--text-input__field-outer-wrapper{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;inline-size:100%}.cds--text-input__field-outer-wrapper--inline{flex:8;flex-direction:column}.cds--text-input-wrapper--inline .cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--text-input-wrapper--inline--invalid .cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input-wrapper--readonly,.cds--text-input-wrapper--readonly .cds--text-input{background:transparent;border-block-end-color:var(--cds-border-subtle)}.cds--text-input__field-wrapper .cds--ai-label,.cds--text-input__field-wrapper .cds--slug,.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator>*{inset-block-start:50%;inset-inline-end:1rem;position:absolute;transform:translateY(-50%)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label):not(:has(~.cds--text-input__field-inner-wrapper--decorator .cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label):not(:has(~.cds--ai-label--revert)),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug):not(:has(~.cds--slug--revert)){background-image:linear-gradient(0deg,var(--cds-ai-aura-start-sm,rgba(69,137,255,.16)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%,transparent 100%);border-block-end-color:var(--cds-ai-border-strong,#4589ff)}.cds--text-input__field-wrapper--decorator .cds--text-input:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--ai-label),.cds--text-input__field-wrapper--slug .cds--text-input:has(~.cds--slug){padding-inline-end:2.5rem}.cds--text-input--invalid:has(~.cds--ai-label),.cds--text-input--invalid:has(~.cds--slug),.cds--text-input--invalid:has(~.cds--text-input__field-inner-wrapper--decorator>*),.cds--text-input--warning:has(~.cds--ai-label),.cds--text-input--warning:has(~.cds--slug),.cds--text-input--warning:has(~.cds--text-input__field-inner-wrapper--decorator>*){padding-inline-end:4rem}.cds--text-input--invalid~.cds--ai-label,.cds--text-input--invalid~.cds--slug,.cds--text-input--invalid~.cds--text-input__field-inner-wrapper--decorator>*,.cds--text-input--warning~.cds--ai-label,.cds--text-input--warning~.cds--slug,.cds--text-input--warning~.cds--text-input__field-inner-wrapper--decorator>*{inset-inline-end:2.5rem}.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator:not(:has(.cds--ai-label))>*{block-size:1rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg,.cds--btn.cds--btn--icon-only.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:hover svg{fill:ButtonText}}.cds--text-input__label-wrapper{display:flex;inline-size:100%;justify-content:space-between}.cds--text-input__label-wrapper .cds--text-input__label-counter{align-self:end}.cds--slider-container{align-items:center;display:flex;gap:1rem;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none}.cds--slider{cursor:pointer;inline-size:100%;max-inline-size:40rem;min-inline-size:12.5rem;padding:1rem 0;position:relative}.cds--slider-container--two-handles .cds--slider{margin-inline:.25rem}.cds--slider__range-label{color:var(--cds-text-primary,#161616);font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);white-space:nowrap}.cds--slider__track{block-size:.125rem;inline-size:100%;transform:translateY(-50%)}.cds--slider__track,.cds--slider__track:before{background:var(--cds-border-subtle);position:absolute}.cds--slider__track:before{block-size:.25rem;content:"";display:inline-block;inline-size:.125rem;inset-block-start:-.3125rem;inset-inline-start:50%;transform:translate(-50%)}.cds--slider__filled-track{background:var(--cds-layer-selected-inverse,#161616);block-size:.125rem;inline-size:100%;pointer-events:none;position:absolute;transform:translateY(-50%);transform-origin:left;transition:background .11s cubic-bezier(.2,0,.38,.9)}.cds--slider__thumb-wrapper{block-size:.875rem;inline-size:.875rem;position:absolute;transform:translate(-50%,-50%);z-index:3;--cds-tooltip-padding-inline:0.5rem;--cds-popover-offset:0.5rem}.cds--slider-container--rtl .cds--slider__thumb-wrapper{transform:translate(50%,-50%)}.cds--slider__thumb-wrapper--lower,.cds--slider__thumb-wrapper--upper{block-size:24px;inline-size:16px;--cds-popover-offset:var(--cds-popover-caret-height,0.5rem)}.cds--slider__thumb-wrapper--lower{transform:translate(-100%,-50%)}.cds--slider__thumb-wrapper--lower>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--slider__thumb-wrapper--lower>.cds--popover>.cds--popover-caret{inset-inline-start:revert;transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--slider-container--rtl .cds--slider__thumb-wrapper--lower{transform:translate(100%,-50%)}.cds--slider-container--rtl .cds--slider__thumb-wrapper--lower>.cds--popover>.cds--popover-content{transform:translateY(calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--slider-container--rtl .cds--slider__thumb-wrapper--lower>.cds--popover>.cds--popover-caret{transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--slider__thumb-wrapper--upper{transform:translateY(-50%)}.cds--slider__thumb-wrapper--upper>.cds--popover>.cds--popover-content{transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--slider__thumb-wrapper--upper>.cds--popover>.cds--popover-caret{transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--slider-container--rtl .cds--slider__thumb-wrapper--upper{transform:translateY(-50%)}.cds--slider-container--rtl .cds--slider__thumb-wrapper--upper>.cds--popover>.cds--popover-content{transform:translateY(calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--slider-container--rtl .cds--slider__thumb-wrapper--upper>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--slider__thumb{background:var(--cds-layer-selected-inverse,#161616);border-radius:50%;box-shadow:inset 0 0 0 1px transparent,inset 0 0 0 2px transparent;inset:0;outline:none;position:absolute;transition:transform .11s cubic-bezier(.2,0,.38,.9),background .11s cubic-bezier(.2,0,.38,.9),box-shadow .11s cubic-bezier(.2,0,.38,.9)}.cds--slider__thumb:hover{transform:scale(1.4286)}.cds--slider__thumb:focus{background-color:var(--cds-interactive,#0f62fe);box-shadow:inset 0 0 0 2px var(--cds-interactive,#0f62fe),inset 0 0 0 3px var(--cds-layer);transform:scale(1.4286)}.cds--slider__thumb:active{box-shadow:inset 0 0 0 2px var(--cds-interactive,#0f62fe);transform:scale(1.4286)}.cds--slider__thumb-icon{fill:var(--cds-layer-selected-inverse,#161616)}.cds--slider__thumb-icon--focus{display:none;fill:var(--cds-interactive,#0f62fe)}.cds--slider__thumb--lower,.cds--slider__thumb--upper{background-color:transparent;border-radius:unset;box-shadow:none;inset:0;position:absolute;transition:none}.cds--slider__thumb--lower:before,.cds--slider__thumb--upper:before{background:var(--cds-background,#fff);block-size:.125rem;content:"";display:block;inline-size:.375rem;inset-block-start:calc(50% - .0625rem);inset-inline-end:0;position:absolute;z-index:-1}.cds--slider__thumb--lower:hover,.cds--slider__thumb--upper:hover{transform:none}.cds--slider__thumb--lower:hover .cds--slider__thumb-icon,.cds--slider__thumb--upper:hover .cds--slider__thumb-icon{fill:var(--cds-text-secondary,#525252)}.cds--slider__thumb--lower:active,.cds--slider__thumb--upper:active{box-shadow:none;transform:none}.cds--slider__thumb--lower:focus,.cds--slider__thumb--upper:focus{background-color:transparent;box-shadow:none;transform:none}.cds--slider__thumb--lower:focus .cds--slider__thumb-icon,.cds--slider__thumb--upper:focus .cds--slider__thumb-icon{display:none;fill:var(--cds-interactive,#0f62fe)}.cds--slider__thumb--lower:focus .cds--slider__thumb-icon--focus,.cds--slider__thumb--upper:focus .cds--slider__thumb-icon--focus{display:block}.cds--slider__thumb--lower:focus:before,.cds--slider__thumb--upper:focus:before{inline-size:100%}.cds--slider__thumb--upper{transform:none}.cds--slider__thumb--upper:before{inset-inline:0 auto}.cds--slider__thumb--upper:active,.cds--slider__thumb--upper:focus,.cds--slider__thumb--upper:hover{transform:none}.cds--slider__input{display:none}.cds--slider-text-input-wrapper{position:relative}.cds--slider-text-input-wrapper--hidden{display:none}.cds--slider-text-input,.cds-slider-text-input{-moz-appearance:textfield;-webkit-appearance:textfield;appearance:textfield;block-size:2.5rem;inline-size:4rem}.cds--slider-text-input::-webkit-inner-spin-button,.cds--slider-text-input::-webkit-outer-spin-button,.cds-slider-text-input::-webkit-inner-spin-button,.cds-slider-text-input::-webkit-outer-spin-button{display:none}.cds--slider__thumb-wrapper:focus-within~.cds--slider__filled-track,.cds--slider__thumb:focus~.cds--slider__filled-track{background-color:var(--cds-border-interactive,#0f62fe)}.cds--slider-text-input--warn,.cds--slider-text-input.cds--text-input--invalid{inline-size:6rem;padding-inline-end:3rem}.cds--slider__invalid-icon{position:absolute;fill:var(--cds-support-error,#da1e28);inset-block-start:50%;inset-inline-end:1rem;transform:translateY(-50%)}.cds--slider__validation-msg.cds--form-requirement{display:block;max-block-size:100%;overflow:visible}.cds--slider__validation-msg--invalid{color:var(--cds-text-error,#da1e28)}.cds--slider__invalid-icon.cds--slider__invalid-icon--warning{fill:var(--cds-support-warning,#f1c21b)}.cds--slider__invalid-icon--warning path:first-of-type{fill:#000;opacity:1}.cds--label--disabled~.cds--slider-container>.cds--slider__range-label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--slider--disabled.cds--slider{cursor:not-allowed}.cds--slider--disabled .cds--slider__thumb{background-color:var(--cds-border-disabled,#c6c6c6)}.cds--slider--disabled .cds--slider__thumb:hover{cursor:not-allowed;transform:none}.cds--slider--disabled .cds--slider__thumb:focus{background-color:var(--cds-border-disabled,#c6c6c6);box-shadow:none;outline:none;transform:none}.cds--slider--disabled .cds--slider__thumb:active{background:var(--cds-border-disabled,#c6c6c6);box-shadow:none;transform:none}.cds--slider--disabled .cds--slider__thumb--lower,.cds--slider--disabled .cds--slider__thumb--upper{background-color:transparent}.cds--slider--disabled .cds--slider__thumb--lower:active,.cds--slider--disabled .cds--slider__thumb--lower:focus,.cds--slider--disabled .cds--slider__thumb--lower:hover,.cds--slider--disabled .cds--slider__thumb--upper:active,.cds--slider--disabled .cds--slider__thumb--upper:focus,.cds--slider--disabled .cds--slider__thumb--upper:hover{background-color:transparent;transform:none}.cds--slider--disabled .cds--slider__thumb--lower .cds--slider__thumb-icon,.cds--slider--disabled .cds--slider__thumb--upper .cds--slider__thumb-icon{fill:var(--cds-border-disabled,#c6c6c6)}.cds--slider--disabled .cds--slider__filled-track,.cds--slider--disabled .cds--slider__thumb:focus~.cds--slider__filled-track,.cds--slider--disabled .cds--slider__track{background-color:var(--cds-border-disabled,#c6c6c6)}.cds--slider--disabled~.cds--form-item .cds--slider-text-input,.cds--slider--disabled~.cds--slider-text-input{background-color:var(--cds-field);border:none;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;transition:none}.cds--slider--disabled~.cds--form-item .cds--slider-text-input:active,.cds--slider--disabled~.cds--form-item .cds--slider-text-input:focus,.cds--slider--disabled~.cds--form-item .cds--slider-text-input:hover,.cds--slider--disabled~.cds--slider-text-input:active,.cds--slider--disabled~.cds--slider-text-input:focus,.cds--slider--disabled~.cds--slider-text-input:hover{color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--slider--readonly{cursor:default}.cds--slider-container--readonly .cds--slider__thumb{block-size:0;inline-size:0}.cds--slider-container--readonly .cds--slider__thumb:after,.cds--slider-container--readonly .cds--slider__thumb:before{display:none}.cds--slider-container--readonly .cds--slider-text-input{background-color:transparent}.cds--slider__status-msg.cds--form-requirement{display:block;max-block-size:100%;overflow:visible}.cds--slider-container.cds--skeleton .cds--slider__range-label{background:var(--cds-skeleton-background,#e8e8e8);block-size:.75rem;border:none;box-shadow:none;inline-size:1.25rem;padding:0;pointer-events:none;position:relative}.cds--slider-container.cds--skeleton .cds--slider__range-label:active,.cds--slider-container.cds--skeleton .cds--slider__range-label:focus,.cds--slider-container.cds--skeleton .cds--slider__range-label:hover{border:none;cursor:default;outline:none}.cds--slider-container.cds--skeleton .cds--slider__range-label:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--slider-container.cds--skeleton .cds--slider__range-label:before{animation:none}}.cds--slider-container.cds--skeleton .cds--slider__track{cursor:default;pointer-events:none}.cds--slider-container.cds--skeleton .cds--slider__thumb-wrapper{inset-inline-start:50%}.cds--slider-container.cds--skeleton .cds--slider__thumb{cursor:default;pointer-events:none}.cds--slider-container.cds--skeleton .cds--slider__thumb-wrapper--lower{inset-inline-start:0}.cds--slider-container.cds--skeleton .cds--slider__thumb-wrapper--upper{inset-inline-start:100%}.cds--popover-container.cds--slider__thumb-wrapper{position:absolute}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--slider__thumb{outline:1px solid transparent}.cds--slider__thumb:focus{color:Highlight;outline:1px solid Highlight}.cds--slider__track{outline:1px solid transparent}}:host(cds-slider){outline:none;--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}:host(cds-slider) .cds--slider{transform:rotate(0)}:host(cds-slider) .cds-ce--slider__filled-track-container{transform:rotate(0)}:host(cds-slider) .cds--slider__thumb{block-size:.875rem;inline-size:.875rem;inset:inherit;transform:translate(-50%,-50%);z-index:3}:host(cds-slider) .cds--slider__thumb:focus~.cds-ce--slider__filled-track-container .cds--slider__filled-track{background-color:var(--cds-interactive,#0f62fe)}:host(cds-slider-input) input{box-sizing:border-box}:host(cds-slider-input[readonly]) input{background-color:transparent}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6l3da":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSliderInput$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _settingsJs = require("../../globals/settings.js");
var _16Js = require("../../icons/warning--filled/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/warning--alt--filled/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _sliderScssJs = require("./slider.scss.js");
var _sliderScssJsDefault = parcelHelpers.interopDefault(_sliderScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The `<input>` box for slider.
 *
 * @element cds-slider-input
 * @fires cds-slider-input-changed - The custom event fired after the value is changed by user gesture.
 */ let CDSSliderInput = class CDSSliderInput extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * The internal value of `max` property.
         */ this._max = "100";
        /**
         * The internal value of `min` property.
         */ this._min = "0";
        /**
         * The internal value of `step` property.
         */ this._step = "1";
        /**
         * `true` if the input should be disabled.
         */ this.disabled = false;
        /**
         * true to specify if the control is invalid.
         */ this.invalid = false;
        /**
         * true to specify if the control should display warn icon and text.
         */ this.warn = false;
        /**
         * The type of the `<input>`.
         */ this.type = "number";
        /**
         * true` if the input should be readonly.
         */ this.readonly = false;
    }
    /**
     * Handles `change` event to fire a normalized custom event.
     */ _handleChange({ target }) {
        this.dispatchEvent(new CustomEvent(this.constructor.eventChange, {
            bubbles: true,
            composed: true,
            detail: {
                value: Number(target.value)
            }
        }));
    }
    /**
     * Handles `input` event to fire a normalized custom event.
     */ _handleInput({ target }) {
        this.dispatchEvent(new CustomEvent(this.constructor.eventChange, {
            bubbles: true,
            composed: true,
            detail: {
                value: Number(target.value),
                intermediate: true
            }
        }));
    }
    /**
     * The maximum value.
     */ get max() {
        return this._max.toString();
    }
    set max(value) {
        const { max: oldMax } = this;
        this._max = value;
        this.requestUpdate("max", oldMax);
    }
    /**
     * The minimum value.
     */ get min() {
        return this._min.toString();
    }
    set min(value) {
        const { min: oldMin } = this;
        this._min = value;
        this.requestUpdate("min", oldMin);
    }
    /**
     * The snapping step of the value.
     */ get step() {
        return this._step.toString();
    }
    set step(value) {
        const { step: oldStep } = this;
        this._step = value;
        this.requestUpdate("step", oldStep);
    }
    render() {
        const { disabled, max, min, readonly, step, type, value, invalid, warn, _handleChange: handleChange, _handleInput: handleInput } = this;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--text-input`]: true,
            [`${0, _settingsJs.prefix}--slider-text-input`]: true,
            [`${0, _settingsJs.prefix}--text-input--invalid`]: invalid,
            [`${0, _settingsJs.prefix}--slider-text-input--warn`]: warn
        });
        const invalidIcon = (0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--slider__invalid-icon`
        });
        const warnIcon = (0, _16JsDefault1.default)({
            class: `${(0, _settingsJs.prefix)}--slider__invalid-icon ${(0, _settingsJs.prefix)}--slider__invalid-icon--warning`
        });
        return (0, _lit.html)`
      <input
        ?disabled="${disabled}"
        ?data-invalid="${invalid}"
        type="${(0, _ifDefinedJs.ifDefined)(type)}"
        class="${classes}"
        max="${max}"
        min="${min}"
        ?readonly="${(0, _ifDefinedJs.ifDefined)(readonly)}"
        step="${step}"
        .value="${value}"
        @change="${handleChange}"
        @input="${handleInput}" />
      ${invalid ? (0, _lit.html)`${invalidIcon}` : null}
      ${warn ? (0, _lit.html)`${warnIcon}` : null}
    `;
    }
    /**
     * A selector that will return the parent slider.
     */ static get selectorParent() {
        return `${0, _settingsJs.prefix}-slider`;
    }
    /**
     * The name of the custom event fired after the value is changed by user gesture.
     */ static get eventChange() {
        return `${0, _settingsJs.prefix}-slider-input-changed`;
    }
};
CDSSliderInput.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSSliderInput.styles = (0, _sliderScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSliderInput.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSliderInput.prototype, "invalid", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSliderInput.prototype, "warn", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true
    })
], CDSSliderInput.prototype, "max", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true
    })
], CDSSliderInput.prototype, "min", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true
    })
], CDSSliderInput.prototype, "step", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSliderInput.prototype, "type", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number
    })
], CDSSliderInput.prototype, "value", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSliderInput.prototype, "readonly", void 0);
CDSSliderInput = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-slider-input`)
], CDSSliderInput);
var CDSSliderInput$1 = CDSSliderInput;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/if-defined.js":"hSgrS","../../globals/settings.js":"EipuL","../../icons/warning--filled/16.js":"ajngV","../../icons/warning--alt--filled/16.js":"21PDf","../../globals/mixins/focus.js":"5k7ow","./slider.scss.js":"4QEG9","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5jduq":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSliderSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _sliderScssJs = require("./slider.scss.js");
var _sliderScssJsDefault = parcelHelpers.interopDefault(_sliderScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of slider.
 */ let CDSSliderSkeleton = class CDSSliderSkeleton extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)`
      <span class="${0, _settingsJs.prefix}--label ${0, _settingsJs.prefix}--skeleton"></span>
      <div class="${0, _settingsJs.prefix}--slider-container ${0, _settingsJs.prefix}--skeleton">
        <span class="${0, _settingsJs.prefix}--slider__range-label"></span>
        <div class="${0, _settingsJs.prefix}--slider">
          <div class="${0, _settingsJs.prefix}--slider__track"></div>
          <div class="${0, _settingsJs.prefix}--slider__filled-track"></div>
          <div class="${0, _settingsJs.prefix}--slider__thumb"></div>
        </div>
        <span class="${0, _settingsJs.prefix}--slider__range-label"></span>
      </div>
    `;
    }
};
CDSSliderSkeleton.styles = (0, _sliderScssJsDefault.default);
CDSSliderSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-slider-skeleton`)
], CDSSliderSkeleton);
var CDSSliderSkeleton$1 = CDSSliderSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./slider.scss.js":"4QEG9","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jzPDw":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _structuredListJs = require("./structured-list.js");
var _structuredListBodyJs = require("./structured-list-body.js");
var _structuredListCellJs = require("./structured-list-cell.js");
var _structuredListHeadJs = require("./structured-list-head.js");
var _structuredListHeaderCellJs = require("./structured-list-header-cell.js");
var _structuredListHeaderCellSkeletonJs = require("./structured-list-header-cell-skeleton.js");
var _structuredListHeaderRowJs = require("./structured-list-header-row.js");
var _structuredListRowJs = require("./structured-list-row.js");

},{"./structured-list.js":"l8Fxc","./structured-list-body.js":"hYX4p","./structured-list-cell.js":"ldQo9","./structured-list-head.js":"hzII5","./structured-list-header-cell.js":"4yKGz","./structured-list-header-cell-skeleton.js":"bZQwT","./structured-list-header-row.js":"gDBkM","./structured-list-row.js":"jYjbr"}],"l8Fxc":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSStructuredList$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _structuredListScssJs = require("./structured-list.scss.js");
var _structuredListScssJsDefault = parcelHelpers.interopDefault(_structuredListScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Structured list wrapper.
 *
 * @element cds-structured-list
 */ let CDSStructuredList = class CDSStructuredList extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * The `name` attribute for the `<input>` for selection.
         * If present, this structured list will be a selectable one.
         */ this.selectionName = "";
        /**
         * Specify if structured list is condensed, default is false
         */ this.condensed = false;
        /**
         * Specify if structured list is flush, default is false
         */ this.flush = false;
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "table");
        super.connectedCallback();
    }
    shouldUpdate(changedProperties) {
        if (changedProperties.has("selectionName")) // Propagate `selectionName` attribute to descendants until `:host-context()` gets supported in all major browsers
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorRowsWithHeader), (elem)=>{
            elem.selectionName = this.selectionName;
        });
        return true;
    }
    updated(changedProperties) {
        const attributes = [
            "condensed",
            "flush"
        ];
        attributes.forEach((attr)=>{
            if (changedProperties.has(attr)) // Propagate watched attribute to descendants until `:host-context()` gets supported in all major browsers
            (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorRowsWithHeader), (elem)=>{
                this[`${attr}`] ? elem.setAttribute(attr, "") : elem.removeAttribute(attr);
            });
        });
    }
    render() {
        const { condensed, flush, selectionName } = this;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--structured-list`]: true,
            [`${0, _settingsJs.prefix}--structured-list--selection`]: Boolean(selectionName),
            [`${0, _settingsJs.prefix}--structured-list--condensed`]: condensed,
            [`${0, _settingsJs.prefix}--structured-list--flush`]: flush
        });
        return (0, _lit.html)`
      <section id="section" class=${classes}><slot></slot></section>
    `;
    }
};
/**
 * The CSS selector to find the rows, including header rows.
 */ CDSStructuredList.selectorRowsWithHeader = `${0, _settingsJs.prefix}-structured-list-row,${0, _settingsJs.prefix}-structured-list-header-row`;
CDSStructuredList.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSStructuredList.styles = (0, _structuredListScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "selection-name"
    })
], CDSStructuredList.prototype, "selectionName", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSStructuredList.prototype, "condensed", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSStructuredList.prototype, "flush", void 0);
CDSStructuredList = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-structured-list`)
], CDSStructuredList);
var CDSStructuredList$1 = CDSStructuredList;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/internal/collection-helpers.js":"4aZkz","../../globals/mixins/focus.js":"5k7ow","./structured-list.scss.js":"lyqm3","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lyqm3":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--structured-list--selection .cds--structured-list-td,.cds--structured-list--selection .cds--structured-list-th,:host(cds-structured-list-header-row) .cds--structured-list--selection ::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row) .cds--structured-list--selection ::slotted(cds-structured-list-header-cell-skeleton),:host(cds-structured-list-row) .cds--structured-list--selection ::slotted(cds-structured-list-cell){padding-inline:1rem 1rem}.cds--structured-list--selection .cds--structured-list-td:first-child,.cds--structured-list--selection .cds--structured-list-th:first-child,:host(cds-structured-list-header-row) .cds--structured-list--selection :first-child::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row) .cds--structured-list--selection :first-child::slotted(cds-structured-list-header-cell-skeleton),:host(cds-structured-list-row) .cds--structured-list--selection :first-child::slotted(cds-structured-list-cell){padding-inline:1rem 1rem}.cds--structured-list-row--focused-within{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--structured-list-row--focused-within{outline-style:dotted}}.cds--structured-list{background-color:var(--cds-layer) transparent;border:0;border-collapse:collapse;border-spacing:0;box-sizing:border-box;display:table;font-family:inherit;font-size:100%;inline-size:100%;margin:0;overflow-x:auto;padding:0;vertical-align:baseline}.cds--structured-list *,.cds--structured-list :after,.cds--structured-list :before{box-sizing:inherit}.cds--structured-list.cds--structured-list--condensed .cds--structured-list-td,.cds--structured-list.cds--structured-list--condensed .cds--structured-list-th,:host(cds-structured-list-header-row) .cds--structured-list.cds--structured-list--condensed ::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row) .cds--structured-list.cds--structured-list--condensed ::slotted(cds-structured-list-header-cell-skeleton),:host(cds-structured-list-row) .cds--structured-list.cds--structured-list--condensed ::slotted(cds-structured-list-cell){padding:.5rem}.cds--structured-list .cds--structured-list-row .cds--structured-list-td:first-of-type,.cds--structured-list .cds--structured-list-row .cds--structured-list-th:first-of-type,:host(cds-structured-list-body) .cds--structured-list ::slotted(cds-structured-list-row) .cds--structured-list-td:first-of-type,:host(cds-structured-list-body) .cds--structured-list ::slotted(cds-structured-list-row) .cds--structured-list-th:first-of-type,:host(cds-structured-list-body):host(cds-structured-list-header-row) .cds--structured-list ::slotted(cds-structured-list-row) :first-of-type::slotted(cds-structured-list-header-cell),:host(cds-structured-list-body):host(cds-structured-list-header-row) .cds--structured-list ::slotted(cds-structured-list-row) :first-of-type::slotted(cds-structured-list-header-cell-skeleton),:host(cds-structured-list-head) .cds--structured-list ::slotted(cds-structured-list-header-row) .cds--structured-list-td:first-of-type,:host(cds-structured-list-head) .cds--structured-list ::slotted(cds-structured-list-header-row) .cds--structured-list-th:first-of-type,:host(cds-structured-list-header-row) .cds--structured-list .cds--structured-list-row :first-of-type::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row) .cds--structured-list .cds--structured-list-row :first-of-type::slotted(cds-structured-list-header-cell-skeleton),:host(cds-structured-list-header-row):host(cds-structured-list-head) .cds--structured-list ::slotted(cds-structured-list-header-row) :first-of-type::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row):host(cds-structured-list-head) .cds--structured-list ::slotted(cds-structured-list-header-row) :first-of-type::slotted(cds-structured-list-header-cell-skeleton),:host(cds-structured-list-row) .cds--structured-list .cds--structured-list-row :first-of-type::slotted(cds-structured-list-cell),:host(cds-structured-list-row):host(cds-structured-list-body) .cds--structured-list ::slotted(cds-structured-list-row) :first-of-type::slotted(cds-structured-list-cell),:host(cds-structured-list-row):host(cds-structured-list-head) .cds--structured-list ::slotted(cds-structured-list-header-row) :first-of-type::slotted(cds-structured-list-cell){padding-inline-start:1rem}.cds--structured-list.cds--structured-list--flush .cds--structured-list-row .cds--structured-list-td,.cds--structured-list.cds--structured-list--flush .cds--structured-list-row .cds--structured-list-td:first-of-type,.cds--structured-list.cds--structured-list--flush .cds--structured-list-row .cds--structured-list-th,.cds--structured-list.cds--structured-list--flush .cds--structured-list-row .cds--structured-list-th:first-of-type,:host(cds-structured-list-body) .cds--structured-list.cds--structured-list--flush ::slotted(cds-structured-list-row) .cds--structured-list-td,:host(cds-structured-list-body) .cds--structured-list.cds--structured-list--flush ::slotted(cds-structured-list-row) .cds--structured-list-th,:host(cds-structured-list-body):host(cds-structured-list-header-row) .cds--structured-list.cds--structured-list--flush ::slotted(cds-structured-list-row) ::slotted(cds-structured-list-header-cell),:host(cds-structured-list-body):host(cds-structured-list-header-row) .cds--structured-list.cds--structured-list--flush ::slotted(cds-structured-list-row) ::slotted(cds-structured-list-header-cell-skeleton),:host(cds-structured-list-head) .cds--structured-list.cds--structured-list--flush ::slotted(cds-structured-list-header-row) .cds--structured-list-td,:host(cds-structured-list-head) .cds--structured-list.cds--structured-list--flush ::slotted(cds-structured-list-header-row) .cds--structured-list-th,:host(cds-structured-list-header-row) .cds--structured-list.cds--structured-list--flush .cds--structured-list-row ::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row) .cds--structured-list.cds--structured-list--flush .cds--structured-list-row ::slotted(cds-structured-list-header-cell-skeleton),:host(cds-structured-list-header-row):host(cds-structured-list-head) .cds--structured-list.cds--structured-list--flush ::slotted(cds-structured-list-header-row) ::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row):host(cds-structured-list-head) .cds--structured-list.cds--structured-list--flush ::slotted(cds-structured-list-header-row) ::slotted(cds-structured-list-header-cell-skeleton),:host(cds-structured-list-row) .cds--structured-list.cds--structured-list--flush .cds--structured-list-row ::slotted(cds-structured-list-cell),:host(cds-structured-list-row):host(cds-structured-list-body) .cds--structured-list.cds--structured-list--flush ::slotted(cds-structured-list-row) ::slotted(cds-structured-list-cell),:host(cds-structured-list-row):host(cds-structured-list-head) .cds--structured-list.cds--structured-list--flush ::slotted(cds-structured-list-header-row) ::slotted(cds-structured-list-cell){padding-inline:0 1rem}.cds--structured-list-row,:host(cds-structured-list-body) ::slotted(cds-structured-list-row),:host(cds-structured-list-head) ::slotted(cds-structured-list-header-row){border-block-start:1px solid var(--cds-border-subtle);display:table-row;transition:background-color .11s cubic-bezier(.2,0,.38,.9)}.cds--structured-list ::slotted(cds-structured-list-body) .cds--structured-list-row:last-child,.cds--structured-list-tbody .cds--structured-list-row:last-child,:host(cds-structured-list-body) .cds--structured-list ::slotted(cds-structured-list-body) :last-child::slotted(cds-structured-list-row),:host(cds-structured-list-body) .cds--structured-list-tbody :last-child::slotted(cds-structured-list-row),:host(cds-structured-list-head) .cds--structured-list ::slotted(cds-structured-list-body) :last-child::slotted(cds-structured-list-header-row),:host(cds-structured-list-head) .cds--structured-list-tbody :last-child::slotted(cds-structured-list-header-row){border-block-end:1px solid var(--cds-border-subtle)}.cds--structured-list-row--header-row,:host(cds-structured-list-head) ::slotted(cds-structured-list-header-row){border:none}.cds--structured-list--selection .cds--structured-list-row:hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected),:host(cds-structured-list-body) .cds--structured-list--selection :hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected)::slotted(cds-structured-list-row),:host(cds-structured-list-head) .cds--structured-list--selection :hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected)::slotted(cds-structured-list-header-row){background-color:var(--cds-layer-hover);border-color:var(--cds-layer-hover);cursor:pointer}.cds--structured-list--selection .cds--structured-list-row:hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected)+.cds--structured-list-row,:host(cds-structured-list-body) .cds--structured-list--selection .cds--structured-list-row:hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected)+::slotted(cds-structured-list-row),:host(cds-structured-list-body) .cds--structured-list--selection :hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected)::slotted(cds-structured-list-row)+.cds--structured-list-row,:host(cds-structured-list-body) .cds--structured-list--selection :hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected)::slotted(cds-structured-list-row)+::slotted(cds-structured-list-row),:host(cds-structured-list-body):host(cds-structured-list-head) .cds--structured-list--selection :hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected)::slotted(cds-structured-list-header-row)+::slotted(cds-structured-list-row),:host(cds-structured-list-body):host(cds-structured-list-head) .cds--structured-list--selection :hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected)::slotted(cds-structured-list-row)+::slotted(cds-structured-list-header-row),:host(cds-structured-list-head) .cds--structured-list--selection .cds--structured-list-row:hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected)+::slotted(cds-structured-list-header-row),:host(cds-structured-list-head) .cds--structured-list--selection :hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected)::slotted(cds-structured-list-header-row)+.cds--structured-list-row,:host(cds-structured-list-head) .cds--structured-list--selection :hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected)::slotted(cds-structured-list-header-row)+::slotted(cds-structured-list-header-row){border-color:var(--cds-layer-hover)}.cds--structured-list--selection .cds--structured-list-row.cds--structured-list-row--selected,:host(cds-structured-list-body) .cds--structured-list--selection .cds--structured-list-row--selected::slotted(cds-structured-list-row),:host(cds-structured-list-head) .cds--structured-list--selection .cds--structured-list-row--selected::slotted(cds-structured-list-header-row){background-color:var(--cds-layer-selected);border-color:var(--cds-layer-selected)}.cds--structured-list--selection .cds--structured-list-row--selected+.cds--structured-list-row,:host(cds-structured-list-body) .cds--structured-list--selection .cds--structured-list-row--selected+::slotted(cds-structured-list-row),:host(cds-structured-list-head) .cds--structured-list--selection .cds--structured-list-row--selected+::slotted(cds-structured-list-header-row){border-color:var(--cds-layer-selected)}.cds--structured-list--selection .cds--structured-list-row.cds--structured-list-row--selected .cds--structured-list-td,:host(cds-structured-list-body) .cds--structured-list--selection .cds--structured-list-row--selected::slotted(cds-structured-list-row) .cds--structured-list-td,:host(cds-structured-list-head) .cds--structured-list--selection .cds--structured-list-row--selected::slotted(cds-structured-list-header-row) .cds--structured-list-td,:host(cds-structured-list-row) .cds--structured-list--selection .cds--structured-list-row.cds--structured-list-row--selected ::slotted(cds-structured-list-cell),:host(cds-structured-list-row):host(cds-structured-list-body) .cds--structured-list--selection .cds--structured-list-row--selected::slotted(cds-structured-list-row) ::slotted(cds-structured-list-cell),:host(cds-structured-list-row):host(cds-structured-list-head) .cds--structured-list--selection .cds--structured-list-row--selected::slotted(cds-structured-list-header-row) ::slotted(cds-structured-list-cell){color:var(--cds-text-primary,#161616)}.cds--structured-list-row.cds--structured-list-row--header-row,:host(cds-structured-list-body) .cds--structured-list-row--header-row::slotted(cds-structured-list-row),:host(cds-structured-list-head) ::slotted(cds-structured-list-header-row){cursor:inherit}.cds--structured-list--selection .cds--structured-list-row.cds--structured-list-row--selected>.cds--structured-list-td,.cds--structured-list--selection .cds--structured-list-row:hover:not(.cds--structured-list-row--header-row)>.cds--structured-list-td,:host(cds-structured-list-body) .cds--structured-list--selection .cds--structured-list-row--selected::slotted(cds-structured-list-row)>.cds--structured-list-td,:host(cds-structured-list-body) .cds--structured-list--selection :hover:not(.cds--structured-list-row--header-row)::slotted(cds-structured-list-row)>.cds--structured-list-td,:host(cds-structured-list-head) .cds--structured-list--selection .cds--structured-list-row--selected::slotted(cds-structured-list-header-row)>.cds--structured-list-td,:host(cds-structured-list-head) .cds--structured-list--selection :hover:not(.cds--structured-list-row--header-row)::slotted(cds-structured-list-header-row)>.cds--structured-list-td,:host(cds-structured-list-row) .cds--structured-list--selection .cds--structured-list-row.cds--structured-list-row--selected>::slotted(cds-structured-list-cell),:host(cds-structured-list-row) .cds--structured-list--selection .cds--structured-list-row:hover:not(.cds--structured-list-row--header-row)>::slotted(cds-structured-list-cell),:host(cds-structured-list-row):host(cds-structured-list-body) .cds--structured-list--selection .cds--structured-list-row--selected::slotted(cds-structured-list-row)>::slotted(cds-structured-list-cell),:host(cds-structured-list-row):host(cds-structured-list-body) .cds--structured-list--selection :hover:not(.cds--structured-list-row--header-row)::slotted(cds-structured-list-row)>::slotted(cds-structured-list-cell),:host(cds-structured-list-row):host(cds-structured-list-head) .cds--structured-list--selection .cds--structured-list-row--selected::slotted(cds-structured-list-header-row)>::slotted(cds-structured-list-cell),:host(cds-structured-list-row):host(cds-structured-list-head) .cds--structured-list--selection :hover:not(.cds--structured-list-row--header-row)::slotted(cds-structured-list-header-row)>::slotted(cds-structured-list-cell){color:var(--cds-text-primary,#161616)}.cds--structured-list ::slotted(cds-structured-list-head),.cds--structured-list-thead{display:table-header-group;vertical-align:middle}.cds--structured-list-th,:host(cds-structured-list-header-row) ::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row) ::slotted(cds-structured-list-header-cell-skeleton){block-size:2.5rem;border:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);display:table-cell;font-family:inherit;font-size:100%;font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);font-weight:600;letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);margin:0;padding:1rem .5rem .5rem;text-align:start;text-transform:none;vertical-align:baseline;vertical-align:top}.cds--structured-list-th *,.cds--structured-list-th :after,.cds--structured-list-th :before,:host(cds-structured-list-header-row) ::slotted(cds-structured-list-header-cell) *,:host(cds-structured-list-header-row) ::slotted(cds-structured-list-header-cell) :after,:host(cds-structured-list-header-row) ::slotted(cds-structured-list-header-cell) :before,:host(cds-structured-list-header-row) ::slotted(cds-structured-list-header-cell-skeleton) *,:host(cds-structured-list-header-row) ::slotted(cds-structured-list-header-cell-skeleton) :after,:host(cds-structured-list-header-row) ::slotted(cds-structured-list-header-cell-skeleton) :before{box-sizing:inherit}.cds--structured-list ::slotted(cds-structured-list-body),.cds--structured-list-tbody{display:table-row-group;vertical-align:middle}.cds--structured-list-td,:host(cds-structured-list-row) ::slotted(cds-structured-list-cell){border:0;box-sizing:border-box;color:var(--cds-text-secondary,#525252);display:table-cell;font-family:inherit;font-size:100%;font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);margin:0;max-inline-size:36rem;padding:1rem .5rem 1.5rem;position:relative;transition:color .11s cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--structured-list-td *,.cds--structured-list-td :after,.cds--structured-list-td :before,:host(cds-structured-list-row) ::slotted(cds-structured-list-cell) *,:host(cds-structured-list-row) ::slotted(cds-structured-list-cell) :after,:host(cds-structured-list-row) ::slotted(cds-structured-list-cell) :before{box-sizing:inherit}.cds--structured-list ::slotted(cds-structured-list-header-cell[nowrap]),.cds--structured-list-content--nowrap,:host(cds-structured-list-row) ::slotted(cds-structured-list-cell[nowrap]){white-space:nowrap}.cds--structured-list-input+.cds--structured-list-td,:host(cds-structured-list-row) .cds--structured-list-input+::slotted(cds-structured-list-cell){text-align:end}.cds--structured-list-svg{display:inline-block;margin-block-start:.125rem;transition:all .11s cubic-bezier(.2,0,.38,.9);vertical-align:top}.cds--structured-list-input:checked+.cds--structured-list-row .cds--structured-list-svg,.cds--structured-list-input:checked+.cds--structured-list-td .cds--structured-list-svg,:host(cds-structured-list-body) .cds--structured-list-input:checked+::slotted(cds-structured-list-row) .cds--structured-list-svg,:host(cds-structured-list-head) .cds--structured-list-input:checked+::slotted(cds-structured-list-header-row) .cds--structured-list-svg,:host(cds-structured-list-row) .cds--structured-list-input:checked+::slotted(cds-structured-list-cell) .cds--structured-list-svg{fill:var(--cds-icon-primary,#161616)}.cds--structured-list-svg{fill:transparent}.cds--structured-list--selection .cds--structured-list-td:last-child,:host(cds-structured-list-row) .cds--structured-list--selection :last-child::slotted(cds-structured-list-cell){inline-size:2rem;padding-inline-start:0}.cds--structured-list.cds--skeleton .cds--structured-list-th:first-child,:host(cds-structured-list-header-row) .cds--structured-list.cds--skeleton :first-child::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row) .cds--structured-list.cds--skeleton :first-child::slotted(cds-structured-list-header-cell-skeleton){inline-size:8%}.cds--structured-list.cds--skeleton .cds--structured-list-th:nth-child(3n+2),:host(cds-structured-list-header-row) .cds--structured-list.cds--skeleton :nth-child(3n+2)::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row) .cds--structured-list.cds--skeleton :nth-child(3n+2)::slotted(cds-structured-list-header-cell-skeleton){inline-size:30%}.cds--structured-list.cds--skeleton .cds--structured-list-th:nth-child(3n+3),:host(cds-structured-list-header-row) .cds--structured-list.cds--skeleton :nth-child(3n+3)::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row) .cds--structured-list.cds--skeleton :nth-child(3n+3)::slotted(cds-structured-list-header-cell-skeleton){inline-size:15%}.cds--structured-list.cds--skeleton span{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;display:block;inline-size:75%;padding:0;pointer-events:none;position:relative}.cds--structured-list.cds--skeleton span:active,.cds--structured-list.cds--skeleton span:focus,.cds--structured-list.cds--skeleton span:hover{border:none;cursor:default;outline:none}.cds--structured-list.cds--skeleton span:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--structured-list.cds--skeleton span:before{animation:none}}.cds--structured-list.cds--structured-list--selection.cds--skeleton .cds--structured-list-th:first-child,:host(cds-structured-list-header-row) .cds--structured-list.cds--structured-list--selection.cds--skeleton :first-child::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row) .cds--structured-list.cds--structured-list--selection.cds--skeleton :first-child::slotted(cds-structured-list-header-cell-skeleton){inline-size:5%}.cds--structured-list.cds--structured-list--selection.cds--skeleton .cds--structured-list-th:first-child span,:host(cds-structured-list-header-row) .cds--structured-list.cds--structured-list--selection.cds--skeleton :first-child::slotted(cds-structured-list-header-cell) span,:host(cds-structured-list-header-row) .cds--structured-list.cds--structured-list--selection.cds--skeleton :first-child::slotted(cds-structured-list-header-cell-skeleton) span{display:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--structured-list-input:checked+.cds--structured-list-td .cds--structured-list-svg,:host(cds-structured-list-row) .cds--structured-list-input:checked+::slotted(cds-structured-list-cell) .cds--structured-list-svg{fill:ButtonText}}.cds--structured-list__icon{margin-block-start:.125rem;vertical-align:top}.cds--structured-list--selection .cds--structured-list-td:first-child:has(.cds--structured-list__icon),:host(cds-structured-list-row) .cds--structured-list--selection :first-child:has(.cds--structured-list__icon)::slotted(cds-structured-list-cell){inline-size:2rem;padding-inline-end:0}:host(cds-structured-list-header-row) ::slotted(cds-structured-list-header-cell:first-of-type){padding-inline-start:1rem}:host(cds-structured-list-body) ::slotted(cds-structured-list-row:last-child){border-block-end:1px solid var(--cds-border-subtle)}:host(cds-structured-list-row) ::slotted(cds-structured-list-cell:first-of-type){padding-inline-start:1rem}:host(cds-structured-list-row[selection-value]:hover){background-color:var(--cds-layer-hover);border-block-end:1px solid var(--cds-layer-hover);cursor:pointer}:host(cds-structured-list-row[selection-value]:hover) ::slotted(cds-structured-list-cell){color:var(--cds-text-primary,#161616)}:host(cds-structured-list-row[selected]){background-color:var(--cds-layer-selected)}:host(cds-structured-list-row[selected]) .cds--structured-list-input:checked+.cds--structured-list-cell .cds--structured-list-svg{fill:var(--cds-text-primary,#161616)}:host(cds-structured-list-row[selected]) ::slotted(cds-structured-list-cell){color:var(--cds-text-primary,#161616)}:host(cds-structured-list-header-cell-skeleton):first-of-type{inline-size:8%}:host(cds-structured-list-header-cell-skeleton):nth-of-type(3n+2){inline-size:30%}:host(cds-structured-list-header-cell-skeleton):nth-of-type(3n+3){inline-size:15%}:host(cds-structured-list-header-cell-skeleton) span{background:var(--cds-skeleton-background,#e8e8e8);block-size:1rem;border:none;box-shadow:none;display:block;inline-size:75%;padding:0;pointer-events:none;position:relative}:host(cds-structured-list-header-cell-skeleton) span:active,:host(cds-structured-list-header-cell-skeleton) span:focus,:host(cds-structured-list-header-cell-skeleton) span:hover{border:none;cursor:default;outline:none}:host(cds-structured-list-header-cell-skeleton) span:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){:host(cds-structured-list-header-cell-skeleton) span:before{animation:none}}:host(cds-structured-list-header-row[condensed]) ::slotted(cds-structured-list-header-cell),:host(cds-structured-list-row[condensed]) ::slotted(cds-structured-list-cell){padding:.5rem}:host(cds-structured-list-header-row[condensed]) ::slotted(cds-structured-list-header-cell:first-of-type),:host(cds-structured-list-row[condensed]) ::slotted(cds-structured-list-cell:first-of-type){padding-inline-start:1rem}:host(cds-structured-list-header-row[condensed][flush]) ::slotted(cds-structured-list-header-cell),:host(cds-structured-list-header-row[flush]) ::slotted(cds-structured-list-header-cell),:host(cds-structured-list-row[condensed][flush]) ::slotted(cds-structured-list-cell),:host(cds-structured-list-row[flush]) ::slotted(cds-structured-list-cell){padding-inline:0 1rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hYX4p":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSStructuredListBody$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _structuredListScssJs = require("./structured-list.scss.js");
var _structuredListScssJsDefault = parcelHelpers.interopDefault(_structuredListScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Structured list body.
 *
 * @element cds-structured-list-body
 */ let CDSStructuredListBody = class CDSStructuredListBody extends (0, _lit.LitElement) {
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "rowgroup");
        super.connectedCallback();
    }
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSStructuredListBody.styles = (0, _structuredListScssJsDefault.default);
CDSStructuredListBody = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-structured-list-body`)
], CDSStructuredListBody);
var CDSStructuredListBody$1 = CDSStructuredListBody;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","./structured-list.scss.js":"lyqm3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ldQo9":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSStructuredListCell$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _structuredListScssJs = require("./structured-list.scss.js");
var _structuredListScssJsDefault = parcelHelpers.interopDefault(_structuredListScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Structured list cell.
 *
 * @element cds-structured-list-cell
 */ let CDSStructuredListCell = class CDSStructuredListCell extends (0, _lit.LitElement) {
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "cell");
        super.connectedCallback();
    }
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSStructuredListCell.styles = (0, _structuredListScssJsDefault.default);
CDSStructuredListCell = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-structured-list-cell`)
], CDSStructuredListCell);
var CDSStructuredListCell$1 = CDSStructuredListCell;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./structured-list.scss.js":"lyqm3","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hzII5":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSStructuredListHeader$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _structuredListScssJs = require("./structured-list.scss.js");
var _structuredListScssJsDefault = parcelHelpers.interopDefault(_structuredListScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Structured list header.
 *
 * @element cds-structured-list-head
 */ let CDSStructuredListHeader = class CDSStructuredListHeader extends (0, _lit.LitElement) {
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "rowgroup");
        super.connectedCallback();
    }
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSStructuredListHeader.styles = (0, _structuredListScssJsDefault.default);
CDSStructuredListHeader = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-structured-list-head`)
], CDSStructuredListHeader);
var CDSStructuredListHeader$1 = CDSStructuredListHeader;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","./structured-list.scss.js":"lyqm3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4yKGz":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSStructuredListHeaderCell$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _structuredListScssJs = require("./structured-list.scss.js");
var _structuredListScssJsDefault = parcelHelpers.interopDefault(_structuredListScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Structured list header cell.
 *
 * @element cds-structured-list-header-cell
 */ let CDSStructuredListHeaderCell = class CDSStructuredListHeaderCell extends (0, _lit.LitElement) {
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "columnheader");
        super.connectedCallback();
    }
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSStructuredListHeaderCell.styles = (0, _structuredListScssJsDefault.default);
CDSStructuredListHeaderCell = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-structured-list-header-cell`)
], CDSStructuredListHeaderCell);
var CDSStructuredListHeaderCell$1 = CDSStructuredListHeaderCell;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./structured-list.scss.js":"lyqm3","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bZQwT":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSStructuredListHeaderCellSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _structuredListScssJs = require("./structured-list.scss.js");
var _structuredListScssJsDefault = parcelHelpers.interopDefault(_structuredListScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of structured list header cell.
 */ let CDSStructuredListHeaderCellSkeleton = class CDSStructuredListHeaderCellSkeleton extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)` <span></span> `;
    }
};
CDSStructuredListHeaderCellSkeleton.styles = (0, _structuredListScssJsDefault.default);
CDSStructuredListHeaderCellSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-structured-list-header-cell-skeleton`)
], CDSStructuredListHeaderCellSkeleton);
var CDSStructuredListHeaderCellSkeleton$1 = CDSStructuredListHeaderCellSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./structured-list.scss.js":"lyqm3","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gDBkM":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSStructuredListHeaderRow$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _structuredListScssJs = require("./structured-list.scss.js");
var _structuredListScssJsDefault = parcelHelpers.interopDefault(_structuredListScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Structured list header row.
 *
 * @element cds-structured-list-header-row
 */ let CDSStructuredListHeaderRow = class CDSStructuredListHeaderRow extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * The `name` attribute for the `<input>` for selection.
         * If present, this structured list header row will show its selectable version of the UI.
         */ this.selectionName = "";
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "row");
        super.connectedCallback();
    }
    render() {
        // We could look up in DOM for `${prefix}-structured-list[hasSelection]`,
        // but uses `hasSelection` prop to utilize attribute change callback
        if (this.selectionName) return (0, _lit.html)`
        <slot></slot>
        <div class="${0, _settingsJs.prefix}--structured-list-th"></div>
      `;
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSStructuredListHeaderRow.styles = (0, _structuredListScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "selection-name"
    })
], CDSStructuredListHeaderRow.prototype, "selectionName", void 0);
CDSStructuredListHeaderRow = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-structured-list-header-row`)
], CDSStructuredListHeaderRow);
var CDSStructuredListHeaderRow$1 = CDSStructuredListHeaderRow;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","./structured-list.scss.js":"lyqm3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jYjbr":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSStructuredListRow$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _16Js = require("../../icons/checkmark--filled/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _settingsJs = require("../../globals/settings.js");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _radioGroupManagerJs = require("../../globals/internal/radio-group-manager.js");
var _radioGroupManagerJsDefault = parcelHelpers.interopDefault(_radioGroupManagerJs);
var _structuredListScssJs = require("./structured-list.scss.js");
var _structuredListScssJsDefault = parcelHelpers.interopDefault(_structuredListScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Map of navigation direction by key.
 */ const navigationDirectionForKey = {
    ArrowUp: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).BACKWARD,
    Up: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).BACKWARD,
    ArrowDown: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).FORWARD,
    Down: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).FORWARD
};
/**
 * The interface for `RadioGroupManager` for structured list row.
 */ class StructuredListRowRadioButtonDelegate {
    constructor(row){
        this._row = row;
    }
    get checked() {
        return this._row.selected;
    }
    set checked(checked) {
        this._row.selected = checked;
        this._row.tabIndex = checked ? 0 : -1;
    }
    get tabIndex() {
        return this._row.tabIndex;
    }
    set tabIndex(tabIndex) {
        this._row.tabIndex = tabIndex;
    }
    get name() {
        return this._row.selectionName;
    }
    compareDocumentPosition(other) {
        return this._row.compareDocumentPosition(other._row);
    }
    focus() {
        this._row.focus();
    }
}
/**
 * Structured list row.
 *
 * @element cds-structured-list-row
 */ let CDSStructuredListRow = class CDSStructuredListRow extends (0, _hostListenerJsDefault1.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * The radio group manager associated with the radio button.
         */ this._manager = null;
        /**
         * The interface for `RadioGroupManager` for structured list row.
         */ this._radioButtonDelegate = new StructuredListRowRadioButtonDelegate(this);
        /**
         * Handles `click` event on this element.
         */ this._handleClick = ()=>{
            const { _inputNode: inputNode } = this;
            if (inputNode) {
                this.selected = true;
                if (this._manager) this._manager.select(this._radioButtonDelegate);
            }
        };
        /**
         * Handles `keydown` event on this element.
         */ this._handleKeydown = (event)=>{
            const { _inputNode: inputNode } = this;
            const manager = this._manager;
            if (inputNode && manager) {
                const navigationDirection = navigationDirectionForKey[event.key];
                if (navigationDirection) manager.select(manager.navigate(this._radioButtonDelegate, navigationDirection));
                if (event.key === " " || event.key === "Enter") manager.select(this._radioButtonDelegate);
            }
        };
        /**
         * `true` if this structured list row should be selectable and selected.
         */ this.selected = false;
        /**
         * The `name` attribute for the `<input>` for selection.
         * If present, this structured list row will be a selectable one.
         */ this.selectionName = "";
        /**
         * The `value` attribute for the `<input>` for selection.
         */ this.selectionValue = "";
        /**
         * The content to put into the `<title>` attribute of the selection icon.
         */ this.selectionIconTitle = "";
    }
    connectedCallback() {
        var _a;
        if (!this.hasAttribute("role")) this.setAttribute("role", "row");
        super.connectedCallback();
        if (!this._manager) {
            this._manager = (0, _radioGroupManagerJsDefault.default).get(this.getRootNode({
                composed: true
            }));
            const { selectionName } = this;
            if (selectionName) (_a = this._manager) === null || _a === void 0 || _a.add(this._radioButtonDelegate);
        }
    }
    disconnectedCallback() {
        if (this._manager) this._manager.delete(this._radioButtonDelegate);
        super.disconnectedCallback();
    }
    updated(changedProperties) {
        const { _manager: manager, selectionName } = this;
        if (changedProperties.has("selectionName")) {
            if (manager) {
                manager.delete(this._radioButtonDelegate, changedProperties.get("selectionName"));
                if (selectionName) manager.add(this._radioButtonDelegate);
            }
            this.setAttribute("tabindex", !selectionName || !manager || !manager.shouldBeFocusable(this._radioButtonDelegate) ? "-1" : "0");
        }
    }
    render() {
        const { selected, selectionName, selectionValue, selectionIconTitle } = this;
        if (selectionName) // "Selected" style with `.${prefix}--structured-list-td` does not work somehow - Need investigation
        return (0, _lit.html)`
        <slot></slot>
        <input
          id="input"
          type="radio"
          class="${0, _settingsJs.prefix}--structured-list-input ${0, _settingsJs.prefix}--visually-hidden"
          .checked=${selected}
          name=${selectionName}
          value=${(0, _ifDefinedJs.ifDefined)(selectionValue)} />
        <div
          class="${0, _settingsJs.prefix}--structured-list-td ${0, _settingsJs.prefix}--structured-list-cell">
          ${(0, _16JsDefault.default)({
            class: `${(0, _settingsJs.prefix)}--structured-list-svg`,
            title: selectionIconTitle
        })}
        </div>
      `;
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSStructuredListRow.styles = (0, _structuredListScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#input")
], CDSStructuredListRow.prototype, "_inputNode", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("click")
], CDSStructuredListRow.prototype, "_handleClick", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("keydown")
], CDSStructuredListRow.prototype, "_handleKeydown", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSStructuredListRow.prototype, "selected", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "selection-name"
    })
], CDSStructuredListRow.prototype, "selectionName", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "selection-value"
    })
], CDSStructuredListRow.prototype, "selectionValue", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "selection-icon-title"
    })
], CDSStructuredListRow.prototype, "selectionIconTitle", void 0);
CDSStructuredListRow = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-structured-list-row`)
], CDSStructuredListRow);
var CDSStructuredListRow$1 = CDSStructuredListRow;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/if-defined.js":"hSgrS","../../icons/checkmark--filled/16.js":"EwXOT","../../globals/settings.js":"EipuL","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/host-listener.js":"1SMUX","../../globals/internal/radio-group-manager.js":"jgXqY","./structured-list.scss.js":"lyqm3","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8gBtv":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _tabJs = require("./tab.js");
var _tabSkeletonJs = require("./tab-skeleton.js");
var _tabsSkeletonJs = require("./tabs-skeleton.js");

},{"./tab.js":"9g8CR","./tab-skeleton.js":"i8csq","./tabs-skeleton.js":"9RpfS"}],"9g8CR":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTab$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _contentSwitcherItemJs = require("../content-switcher/content-switcher-item.js");
var _contentSwitcherItemJsDefault = parcelHelpers.interopDefault(_contentSwitcherItemJs);
var _tabsJs = require("./tabs.js");
var _tabsScssJs = require("./tabs.scss.js");
var _tabsScssJsDefault = parcelHelpers.interopDefault(_tabsScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("./defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Basic tab.
 *
 * @element cds-tab
 */ let CDSTab = class CDSTab extends (0, _contentSwitcherItemJsDefault.default) {
    constructor(){
        super(...arguments);
        /**
         * `true` if this tab should be highlighted.
         * If `true`, parent `<cds-tabs>` selects/deselects this tab upon keyboard interaction.
         *
         * @private
         */ this.highlighted = false;
        /**
         * Tab type.
         */ this.type = (0, _defsJs.TABS_TYPE).REGULAR;
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        // Retrieve content of the slot to use for aria-label.
        const content = target.assignedNodes();
        this.tabTitle = content[0].textContent;
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "listitem");
        super.connectedCallback();
    }
    render() {
        const { disabled, selected, tabTitle, _handleSlotChange: handleSlotChange } = this;
        // No `href`/`tabindex` to not to make this `<a>` click-focusable
        return (0, _lit.html)`
      <a
        class="${0, _settingsJs.prefix}--tabs__nav-link"
        role="tab"
        aria-label="${tabTitle}"
        tabindex="${selected ? 0 : -1}"
        ?disabled="${disabled}"
        aria-selected="${Boolean(selected)}">
        <slot @slotchange="${handleSlotChange}"></slot>
      </a>
    `;
    }
};
CDSTab.styles = (0, _tabsScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSTab.prototype, "highlighted", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTab.prototype, "type", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTab.prototype, "tabTitle", void 0);
CDSTab = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-tab`)
], CDSTab);
var CDSTab$1 = CDSTab;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../content-switcher/content-switcher-item.js":"lQkFu","./tabs.js":"v5gWo","./tabs.scss.js":"jJqqz","../../globals/decorators/carbon-element.js":"kNhLR","./defs.js":"3kWkF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lQkFu":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSContentSwitcherItem$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _contentSwitcherScssJs = require("./content-switcher.scss.js");
var _contentSwitcherScssJsDefault = parcelHelpers.interopDefault(_contentSwitcherScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Content switcher button.
 *
 * @element cds-content-switcher-item
 */ let CDSContentSwitcherItem = class CDSContentSwitcherItem extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if this content switcher item should be disabled.
         */ this.disabled = false;
        /**
         * `true` to hide the divider at the left.
         *
         * @private
         */ this.hideDivider = false;
        /**
         * `true` if the content switcher button should be selected.
         *
         * @private
         */ this.selected = false;
        /**
         * The `value` attribute that is set to the parent `<cds-content-switcher>`
         * when this content switcher item is selected.
         */ this.value = "";
        /**
         * `true` if the content switcher button should be icon-only.
         */ this.icon = false;
        /**
         * Specify how the trigger should align with the tooltip for icon-only
         * switcher item
         */ this.align = "top";
        /**
         * Determines whether the tooltip should close when inner content is
         * activated (click, Enter or Space)
         */ this.closeOnActivation = true;
        /**
         * Specify the duration in milliseconds to delay before displaying the
         * tooltip for icon-only switcher item
         */ this.enterDelayMs = 100;
        /**
         * Specify the duration in milliseconds to delay before hiding the tooltip
         * for icon-only switcher-item
         *
         * TODO: match upstream value once #10471 is resolved
         */ this.leaveDelayMs = 100;
    }
    updated(changedProperties) {
        var _a, _b, _c, _d;
        if (changedProperties) (_d = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`${(0, _settingsJs.prefix)}-tooltip`)) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(`.${(0, _settingsJs.prefix)}--tooltip`)) === null || _d === void 0 || _d.classList.add(`${(0, _settingsJs.prefix)}--icon-tooltip`);
    }
    // eslint-disable-next-line class-methods-use-this
    _renderTooltipContent() {
        return (0, _lit.html)`
      <cds-tooltip-content>
        <slot name="tooltip-content"></slot>
      </cds-tooltip-content>
    `;
    }
    shouldUpdate(changedProperties) {
        if (changedProperties.has("selected") || changedProperties.has("target")) {
            const { selected, target } = this;
            if (target) {
                const doc = this.getRootNode();
                // `doc` can be an element if such element is orphaned
                const targetNode = doc === null || doc === void 0 ? void 0 : doc.getElementById(target);
                targetNode === null || targetNode === void 0 || targetNode.toggleAttribute("hidden", !selected);
            }
        }
        return true;
    }
    render() {
        const { disabled, selected, target } = this;
        const className = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--content-switcher-btn`]: true,
            [`${0, _settingsJs.prefix}--content-switcher--selected`]: selected
        });
        const switcherItem = (0, _lit.html)`<button
      type="button"
      role="tab"
      class="${className}"
      ?disabled="${disabled}"
      tabindex="${selected ? "0" : "-1"}"
      aria-controls="${(0, _ifDefinedJs.ifDefined)(target)}"
      aria-selected="${Boolean(selected)}">
      <span class="${(0, _settingsJs.prefix)}--content-switcher__label"><slot></slot></span>
    </button>`;
        if (this.icon) {
            const { align, closeOnActivation, enterDelayMs, leaveDelayMs } = this;
            return (0, _lit.html)`<cds-tooltip
        align=${align}
        close-on-activation="${closeOnActivation}"
        enter-delay-ms=${enterDelayMs}
        leave-delay-ms=${leaveDelayMs}>
        ${switcherItem} ${this._renderTooltipContent()}
      </cds-tooltip>`;
        }
        return switcherItem;
    }
};
CDSContentSwitcherItem.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSContentSwitcherItem.styles = (0, _contentSwitcherScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSContentSwitcherItem.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "hide-divider"
    })
], CDSContentSwitcherItem.prototype, "hideDivider", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSContentSwitcherItem.prototype, "selected", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSContentSwitcherItem.prototype, "target", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSContentSwitcherItem.prototype, "value", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSContentSwitcherItem.prototype, "icon", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        type: String
    })
], CDSContentSwitcherItem.prototype, "align", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "close-on-activation",
        reflect: true,
        type: Boolean
    })
], CDSContentSwitcherItem.prototype, "closeOnActivation", void 0);
CDSContentSwitcherItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-content-switcher-item`)
], CDSContentSwitcherItem);
var CDSContentSwitcherItem$1 = CDSContentSwitcherItem;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit/directives/if-defined.js":"hSgrS","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./content-switcher.scss.js":"azEq0","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"azEq0":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm,:host(cds-content-switcher[size=sm]){--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg,:host(cds-content-switcher[size=lg]){--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content,:host(cds-content-switcher[size=sm]) .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content,:host(cds-content-switcher[size=lg]) .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--content-switcher,:host(cds-content-switcher){--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));block-size:var(--cds-layout-size-height-local);display:flex;inline-size:100%;justify-content:space-evenly}.cds--content-switcher-btn{background-color:transparent;border:none;border-block-end:.0625rem solid var(--cds-border-inverse,#161616);border-block-start:.0625rem solid var(--cds-border-inverse,#161616);color:var(--cds-text-secondary,#525252);display:inline-flex;font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:2px solid transparent;outline-offset:-2px;overflow:hidden;position:relative;text-align:start;text-decoration:none;transition:all .15s cubic-bezier(.2,0,.38,.9);white-space:nowrap}.cds--content-switcher-btn html{font-size:100%}.cds--content-switcher-btn body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--content-switcher-btn code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--content-switcher-btn strong{font-weight:600}.cds--content-switcher-btn:after{background-color:var(--cds-layer-selected-inverse,#161616);block-size:100%;content:"";display:block;inline-size:100%;inset-block-start:0;inset-inline-start:0;position:absolute;transform:scaleY(0);transform-origin:bottom;transition:all .15s cubic-bezier(.2,0,.38,.9)}@media (prefers-reduced-motion:reduce){.cds--content-switcher-btn:after{transition:none}}.cds--content-switcher-btn:disabled:after{display:none}.cds--content-switcher-btn:focus{border-color:var(--cds-focus,#0f62fe);box-shadow:inset 0 0 0 2px var(--cds-focus,#0f62fe),inset 0 0 0 3px var(--cds-focus-inset,#fff);z-index:3}.cds--content-switcher-btn:focus:after{clip-path:inset(3px 3px 3px 3px)}.cds--content-switcher-btn:hover{color:var(--cds-text-primary,#161616);cursor:pointer}.cds--content-switcher-btn:active,.cds--content-switcher-btn:hover{background-color:var(--cds-layer-hover);color:var(--cds-text-primary,#161616);z-index:3}.cds--content-switcher-btn:disabled{background-color:transparent;border-color:var(--cds-border-disabled,#c6c6c6);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--content-switcher-btn:disabled:hover{cursor:not-allowed}.cds--content-switcher-btn:disabled:first-child,.cds--content-switcher-btn:disabled:last-child{border-color:var(--cds-border-disabled,#c6c6c6)}.cds--content-switcher:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn,:not(.cds--content-switcher--icon-only):host(cds-content-switcher) .cds--content-switcher-btn{align-items:center;inline-size:100%;padding:.5rem var(--cds-layout-density-padding-inline-local)}.cds--content-switcher:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn:first-child,:not(.cds--content-switcher--icon-only):host(cds-content-switcher) .cds--content-switcher-btn:first-child{border-end-start-radius:.25rem;border-inline-start:.0625rem solid var(--cds-border-inverse,#161616);border-start-start-radius:.25rem}.cds--content-switcher:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn:first-child:disabled,:not(.cds--content-switcher--icon-only):host(cds-content-switcher) .cds--content-switcher-btn:first-child:disabled{border-color:var(--cds-border-disabled,#c6c6c6);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--content-switcher:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn:last-child,:not(.cds--content-switcher--icon-only):host(cds-content-switcher) .cds--content-switcher-btn:last-child{border-end-end-radius:.25rem;border-inline-end:.0625rem solid var(--cds-border-inverse,#161616);border-start-end-radius:.25rem}.cds--content-switcher:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn:last-child:disabled,:not(.cds--content-switcher--icon-only):host(cds-content-switcher) .cds--content-switcher-btn:last-child:disabled{border-color:var(--cds-border-disabled,#c6c6c6);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--content-switcher .cds--content-switcher-btn.cds--content-switcher--selected,.cds--content-switcher .cds--content-switcher-btn.cds--content-switcher--selected:first-child,.cds--content-switcher .cds--content-switcher-btn.cds--content-switcher--selected:last-child,:host(cds-content-switcher) .cds--content-switcher-btn.cds--content-switcher--selected{border:0}.cds--content-switcher-btn:before{background-color:var(--cds-border-subtle);block-size:1rem;content:"";display:block;inline-size:.0625rem;inset-inline-start:0;position:absolute;z-index:2}.cds--content-switcher:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn:first-of-type:before,:not(.cds--content-switcher--icon-only):host(cds-content-switcher) .cds--content-switcher-btn:first-of-type:before{display:none}.cds--content-switcher--selected+.cds--content-switcher-btn:before,.cds--content-switcher--selected:before,.cds--content-switcher-btn:focus+.cds--content-switcher-btn:before,.cds--content-switcher-btn:focus:before,.cds--content-switcher-btn:hover+.cds--content-switcher-btn:before,.cds--content-switcher-btn:hover:before{background-color:transparent}.cds--content-switcher-btn:disabled:before,.cds--content-switcher-btn:disabled:hover+.cds--content-switcher-btn:disabled:before{background-color:var(--cds-border-disabled,#c6c6c6)}.cds--content-switcher-btn.cds--content-switcher--selected:disabled+.cds--content-switcher-btn:before,.cds--content-switcher-btn.cds--content-switcher--selected:disabled:hover+.cds--content-switcher-btn:before{background-color:transparent}.cds--content-switcher__icon{fill:var(--cds-icon-secondary,#525252);transition:fill 70ms cubic-bezier(.2,0,.38,.9)}.cds--content-switcher__icon+span{margin-inline-start:.5rem}.cds--content-switcher__label{max-inline-size:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;z-index:1}.cds--content-switcher-btn:focus .cds--content-switcher__icon,.cds--content-switcher-btn:hover .cds--content-switcher__icon{fill:var(--cds-icon-primary,#161616)}.cds--content-switcher-btn.cds--content-switcher--selected{background-color:var(--cds-layer-selected-inverse,#161616);color:var(--cds-text-inverse,#fff);z-index:3}.cds--content-switcher-btn.cds--content-switcher--selected:disabled{background-color:var(--cds-layer-selected-disabled,#8d8d8d);color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--content-switcher-btn.cds--content-switcher--selected:after{transform:scaleY(1)}.cds--content-switcher-btn.cds--content-switcher--selected .cds--content-switcher__icon{fill:var(--cds-icon-inverse,#fff)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--content-switcher-btn:focus{color:Highlight;outline:1px solid Highlight}}.cds--content-switcher--icon-only,:host(cds-content-switcher[icon]){justify-content:flex-start}.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:first-child .cds--content-switcher-btn,:host(cds-content-switcher[icon]) .cds--content-switcher-popover__wrapper:first-child .cds--content-switcher-btn{border-end-start-radius:.25rem;border-inline-start:.0625rem solid var(--cds-border-inverse,#161616);border-start-start-radius:.25rem}.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:first-child .cds--content-switcher--selected[disabled],.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:last-child .cds--content-switcher--selected[disabled],:host(cds-content-switcher[icon]) .cds--content-switcher-popover__wrapper:first-child .cds--content-switcher--selected[disabled],:host(cds-content-switcher[icon]) .cds--content-switcher-popover__wrapper:last-child .cds--content-switcher--selected[disabled]{border-color:var(--cds-layer-selected-disabled,#8d8d8d)}.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:last-child .cds--content-switcher-btn,:host(cds-content-switcher[icon]) .cds--content-switcher-popover__wrapper:last-child .cds--content-switcher-btn{border-end-end-radius:.25rem;border-inline-end:.0625rem solid var(--cds-border-inverse,#161616);border-start-end-radius:.25rem}.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:first-child .cds--content-switcher-btn.cds--content-switcher--selected,.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:last-child .cds--content-switcher-btn.cds--content-switcher--selected,:host(cds-content-switcher[icon]) .cds--content-switcher-popover__wrapper:first-child .cds--content-switcher-btn.cds--content-switcher--selected,:host(cds-content-switcher[icon]) .cds--content-switcher-popover__wrapper:last-child .cds--content-switcher-btn.cds--content-switcher--selected{border-color:var(--cds-background,#fff)}.cds--content-switcher--lg .cds--content-switcher-btn{padding-inline:.875rem .875rem}.cds--content-switcher--lg .cds--content-switcher-btn svg{block-size:20px;inline-size:20px}.cds--content-switcher--icon-only .cds--content-switcher-btn svg,:host(cds-content-switcher[icon]) .cds--content-switcher-btn svg{fill:var(--cds-icon-primary,#161616)}.cds--content-switcher--icon-only .cds--content-switcher-btn.cds--content-switcher--selected svg,:host(cds-content-switcher[icon]) .cds--content-switcher-btn.cds--content-switcher--selected svg{z-index:1;fill:var(--cds-icon-inverse,#fff)}.cds--content-switcher--icon-only.cds--content-switcher--sm .cds--btn--sm{block-size:2rem}.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:first-of-type .cds--content-switcher-btn:before,:host(cds-content-switcher[icon]) .cds--content-switcher-popover__wrapper:first-of-type .cds--content-switcher-btn:before{display:none}.cds--content-switcher--selected:before,.cds--content-switcher-btn:focus:before,.cds--content-switcher-btn:hover:before,.cds--content-switcher-popover--selected+.cds--content-switcher-popover__wrapper .cds--content-switcher-btn:before,.cds--content-switcher-popover__wrapper:focus-within+.cds--content-switcher-popover__wrapper .cds--content-switcher-btn:before,.cds--content-switcher-popover__wrapper:not(.cds--content-switcher-popover--disabled):hover+.cds--content-switcher-popover__wrapper .cds--content-switcher-btn:before{background-color:transparent}.cds--content-switcher--icon-only .cds--content-switcher-btn[disabled],:host(cds-content-switcher[icon]) .cds--content-switcher-btn[disabled]{border-color:var(--cds-border-inverse,#161616)}.cds--content-switcher--icon-only .cds--content-switcher-btn[disabled] svg,:host(cds-content-switcher[icon]) .cds--content-switcher-btn[disabled] svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--content-switcher--icon-only .cds--content-switcher-btn[disabled]:not(.cds--content-switcher--selected):hover,.cds--content-switcher--icon-only .cds--content-switcher-popover--selected+.cds--content-switcher-popover--disabled .cds--content-switcher-btn[disabled]:hover:before,:host(cds-content-switcher[icon]) .cds--content-switcher-btn[disabled]:not(.cds--content-switcher--selected):hover,:host(cds-content-switcher[icon]) .cds--content-switcher-popover--selected+.cds--content-switcher-popover--disabled .cds--content-switcher-btn[disabled]:hover:before{background-color:transparent}.cds--content-switcher--icon-only .cds--content-switcher-btn[disabled]:hover:before,:host(cds-content-switcher[icon]) .cds--content-switcher-btn[disabled]:hover:before{background-color:var(--cds-border-subtle)}:host(cds-content-switcher){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}:host(cds-content-switcher-item){inline-size:100%;outline:none}:host(cds-content-switcher-item) .cds--content-switcher-btn{align-items:center;block-size:100%;inline-size:100%;padding:.5rem var(--cds-layout-density-padding-inline-local)}:host(cds-content-switcher-item) .cds--content-switcher-btn:first-child,:host(cds-content-switcher-item) .cds--content-switcher-btn:last-child{border-inline-end:none;border-inline-start:none;border-radius:0}:host(cds-content-switcher-item) .cds--content-switcher-btn:before{background-color:var(--cds-border-subtle);block-size:1rem;content:"";display:block;inline-size:.0625rem;inset-inline-start:0;position:absolute;z-index:2}:host(cds-content-switcher-item) .cds--content-switcher-btn.cds--content-switcher--selected:before,:host(cds-content-switcher-item) .cds--content-switcher-btn:focus:before,:host(cds-content-switcher-item) .cds--content-switcher-btn:hover:before{background-color:transparent}:host(cds-content-switcher-item) .cds--content-switcher-btn:disabled{border-block-end-color:var(--cds-border-inverse,#161616);border-block-start-color:var(--cds-border-inverse,#161616)}:host(cds-content-switcher-item[icon]){inline-size:auto}:host(cds-content-switcher-item[icon]) .cds--content-switcher-btn{block-size:2.5rem;padding-inline:.6875rem}:host(cds-content-switcher-item[icon]) .cds--content-switcher__label{align-items:center;display:flex}:host(cds-content-switcher-item[hide-divider]) .cds--content-switcher-btn:before{background-color:transparent}:host(cds-content-switcher-item:first-of-type) .cds--content-switcher-btn{border-end-start-radius:.25rem;border-inline-start:.0625rem solid var(--cds-border-inverse,#161616);border-start-start-radius:.25rem}:host(cds-content-switcher-item:first-of-type) .cds--content-switcher-btn:before{content:none}:host(cds-content-switcher-item:last-of-type) .cds--content-switcher-btn{border-end-end-radius:.25rem;border-inline-end:.0625rem solid var(--cds-border-inverse,#161616);border-start-end-radius:.25rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"v5gWo":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TABS_KEYBOARD_ACTION", ()=>(0, _defsJs.TABS_KEYBOARD_ACTION));
parcelHelpers.export(exports, "TABS_TYPE", ()=>(0, _defsJs.TABS_TYPE));
parcelHelpers.export(exports, "NAVIGATION_DIRECTION", ()=>(0, _defsJs1.NAVIGATION_DIRECTION));
parcelHelpers.export(exports, "default", ()=>CDSTabs$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _classMapJs = require("lit/directives/class-map.js");
var _settingsJs = require("../../globals/settings.js");
var _hostListenerJs = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _16Js = require("../../icons/chevron--right/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/chevron--left/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _contentSwitcherJs = require("../content-switcher/content-switcher.js");
var _contentSwitcherJsDefault = parcelHelpers.interopDefault(_contentSwitcherJs);
var _defsJs = require("./defs.js");
var _tabsScssJs = require("./tabs.scss.js");
var _tabsScssJsDefault = parcelHelpers.interopDefault(_tabsScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs1 = require("../content-switcher/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Tabs.
 *
 * @element cds-tabs
 * @fires cds-tabs-beingselected
 *   The custom event fired before a tab is selected upon a user gesture.
 *   Cancellation of this event stops changing the user-initiated selection.
 * @fires cds-tabs-selected - The custom event fired after a a tab is selected upon a user gesture.
 */ let CDSTabs = class CDSTabs extends (0, _hostListenerJsDefault.default)((0, _contentSwitcherJsDefault.default)) {
    constructor(){
        super(...arguments);
        /**
         * The currently selected index
         */ // @ts-ignore: TS thinks this method is not referred to
        this._currentIndex = 0;
        /**
         * Total number of tabs in the component
         */ this._totalTabs = 0;
        /**
         * `true` if the tablist is scrollable
         */ // @ts-ignore: TS thinks this method is not referred to
        this._isScrollable = false;
        /**
         * The DOM element for the tablist.
         */ this.tablist = null;
        /**
         * The width of the overflow scroll buttons.
         */ this.BUTTON_WIDTH = 44;
        /**
         * The current scroll position.
         */ this._currentScrollPosition = 0;
        /**
         * An assistive text for screen reader to announce, telling the open state.
         */ this.selectingItemsAssistiveText = "Selecting items. Use up and down arrow keys to navigate.";
        /**
         * An assistive text for screen reader to announce, telling that an item is selected.
         */ this.selectedItemAssistiveText = "Selected an item.";
        /**
         * The content of the trigger button for narrow mode.
         */ this.triggerContent = "";
        /**
         * Tabs type.
         */ this.type = (0, _defsJs.TABS_TYPE).REGULAR;
        /**
         * `true` if left-hand scroll intersection sentinel intersects with the host element.
         * In this condition, the left-hand paginator button should be hidden.
         */ this._isIntersectionLeftTrackerInContent = true;
        /**
         * `true` if right-hand scroll intersection sentinel intersects with the host element.
         * In this condition, the right-hand paginator button should be hidden.
         */ this._isIntersectionRightTrackerInContent = true;
        /**
         * The observer for the intersection of left-side content edge.
         */ this._observerIntersection = null;
        /**
         * The intersection observer callback for the scrolling container.
         *
         * @param records The intersection observer records.
         */ this._observeIntersectionContainer = (records)=>{
            const { _intersectionLeftSentinelNode: intersectionLeftSentinelNode, _intersectionRightSentinelNode: intersectionRightSentinelNode } = this;
            records.forEach(({ isIntersecting, target })=>{
                if (target === intersectionLeftSentinelNode) this._isIntersectionLeftTrackerInContent = isIntersecting;
                if (target === intersectionRightSentinelNode) this._isIntersectionRightTrackerInContent = isIntersecting;
            });
        };
    }
    /**
     * Navigates through tabs.
     *
     * @param direction `-1` to navigate backward, `1` to navigate forward.
     * @param [options] The options.
     * @param [options.immediate]
     *   Defaults to `true`
     *   `true` to make it "immediate selection change" mode, which does:
     *
     *   Starts with the selected item
     *   Going prev/next item immediately changes the selection
     */ _navigate(direction, { immediate = true } = {}) {
        const { selectorItem, selectorItemHighlighted, selectorItemSelected } = this.constructor;
        const nextItem = this._getNextItem(this.querySelector(immediate ? selectorItemSelected : selectorItemHighlighted), direction);
        if (!nextItem) return;
        if (immediate) this._handleUserInitiatedSelectItem(nextItem);
        else (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorItem), (item)=>{
            item[immediate ? "selected" : "highlighted"] = nextItem === item;
        });
        // Using `{ block: 'nearest' }` to prevent scrolling unless scrolling is absolutely necessary.
        // `scrollIntoViewOptions` seems to work in latest Safari despite of MDN/caniuse table.
        // IE falls back to the old behavior.
        nextItem.scrollIntoView({
            block: "nearest",
            inline: "nearest"
        });
        const nextItemText = nextItem.textContent;
        if (nextItemText) this._assistiveStatusText = nextItemText;
        this._currentIndex += direction;
        this.requestUpdate();
    }
    _handleClick(event) {
        super._handleClick(event);
    }
    _handleKeydown(event) {
        const { key } = event;
        const action = this.constructor.getAction(key);
        const enabledTabs = this.querySelectorAll(`${(0, _settingsJs.prefix)}-tab:not([disabled])`);
        switch(action){
            case (0, _defsJs.TABS_KEYBOARD_ACTION).HOME:
                {
                    const [firstEnabledTab] = enabledTabs;
                    firstEnabledTab.scrollIntoView({
                        block: "nearest",
                        inline: "nearest"
                    });
                    this._handleUserInitiatedSelectItem(firstEnabledTab);
                    this.requestUpdate();
                }
                break;
            case (0, _defsJs.TABS_KEYBOARD_ACTION).END:
                {
                    const lastEnabledTab = enabledTabs[enabledTabs.length - 1];
                    lastEnabledTab.scrollIntoView({
                        block: "nearest",
                        inline: "nearest"
                    });
                    this._handleUserInitiatedSelectItem(lastEnabledTab);
                    this.requestUpdate();
                }
                break;
            case (0, _defsJs.TABS_KEYBOARD_ACTION).NAVIGATING:
                {
                    const direction = (0, _defsJs1.NAVIGATION_DIRECTION)[key];
                    if (direction) this._navigate(direction);
                }
                break;
        }
    }
    /**
     * Handles click on overflow scroll buttons.
     *
     * @param _ Event object
     * @param [options] The options.
     * @param [options.direction] `-1` to scroll forward, `1` to scroll backward.
     */ _handleScrollButtonClick(_, { direction }) {
        if (!this.tablist) return;
        const { scrollLeft, clientWidth, scrollWidth } = this._contentContainerNode;
        switch(direction){
            case -1:
                this._contentContainerNode.scrollLeft = Math.max(scrollLeft - scrollWidth / this._totalTabs * 1.5, 0);
                break;
            case 1:
                this._contentContainerNode.scrollLeft = Math.min(scrollLeft + scrollWidth / this._totalTabs * 1.5, scrollWidth - clientWidth) + 1;
                break;
        }
    }
    _handleSlotchange() {
        const { selectorItemSelected } = this.constructor;
        const selectedItem = this.querySelector(selectorItemSelected);
        const nextItem = this._getNextItem(selectedItem, 1);
        // Specifies child `<cds-tab>` to hide its divider instead of using CSS,
        // until `:host-context()` gets supported in all major browsers
        nextItem.hideDivider = true;
    }
    _selectionDidChange(itemToSelect) {
        super._selectionDidChange(itemToSelect);
        this._assistiveStatusText = this.selectedItemAssistiveText;
    }
    /**
     * Cleans-up and creates the intersection observer for the scrolling container.
     *
     * @param [options] The options.
     * @param [options.create] `true` to create the new intersection observer.
     */ _cleanAndCreateIntersectionObserverContainer({ create } = {}) {
        const { _intersectionLeftSentinelNode: intersectionLeftSentinelNode, _intersectionRightSentinelNode: intersectionRightSentinelNode } = this;
        if (this._observerIntersection) {
            this._observerIntersection.disconnect();
            this._observerIntersection = null;
        }
        if (create) {
            this._observerIntersection = new IntersectionObserver(this._observeIntersectionContainer, {
                root: this,
                threshold: 0
            });
            if (intersectionLeftSentinelNode) this._observerIntersection.observe(intersectionLeftSentinelNode);
            if (intersectionRightSentinelNode) this._observerIntersection.observe(intersectionRightSentinelNode);
        }
    }
    disconnectedCallback() {
        this._cleanAndCreateIntersectionObserverContainer();
        super.disconnectedCallback();
    }
    shouldUpdate(changedProperties) {
        super.shouldUpdate(changedProperties);
        if (this.tablist) {
            const { clientWidth, scrollWidth } = this.tablist;
            this._isScrollable = scrollWidth > clientWidth;
        }
        const { selectorItem } = this.constructor;
        if (changedProperties.has("type")) (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorItem), (elem)=>{
            this._totalTabs++;
            elem.type = this.type;
        });
        return true;
    }
    firstUpdated() {
        const { selectorTablist } = this.constructor;
        const tablist = this.shadowRoot.querySelector(selectorTablist);
        this.tablist = tablist;
        this._cleanAndCreateIntersectionObserverContainer({
            create: true
        });
    }
    updated(changedProperties) {
        var _a, _b;
        if (changedProperties.has("value")) {
            const tab = this.querySelector(`${(0, _settingsJs.prefix)}-tab[value="${this.value}"]`);
            if (tab) {
                const { width: tabWidth } = (_a = tab === null || tab === void 0 ? void 0 : tab.getBoundingClientRect()) !== null && _a !== void 0 ? _a : {};
                const start = (_b = tab.offsetLeft) !== null && _b !== void 0 ? _b : 0;
                const end = tab.offsetLeft + tabWidth;
                // The start and end of the visible area of the tablist
                const visibleStart = this.tablist.scrollLeft + this.BUTTON_WIDTH;
                const visibleEnd = this.tablist.scrollLeft + this.tablist.clientWidth - this.BUTTON_WIDTH;
                // The beginning of the tab is clipped and not visible
                if (start < visibleStart) this.tablist.scrollLeft = start - this.BUTTON_WIDTH;
                // The end of the tab is clipped and not visible
                if (end > visibleEnd) this.tablist.scrollLeft = end + this.BUTTON_WIDTH - this.tablist.clientWidth;
            }
        }
        if (changedProperties.has("_currentScrollPosition")) {
            if (this._contentNode) this._contentNode.style.insetInlineStart = `-${this._currentScrollPosition}px`;
        }
    }
    /**
     * Render the previous button if tablist is wider than container.
     */ renderPreviousButton() {
        const { _isIntersectionLeftTrackerInContent: isIntersectionLeftTrackerInContent } = this;
        const previousButtonClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--tab--overflow-nav-button`]: true,
            [`${0, _settingsJs.prefix}--tabs__nav-caret-left`]: true,
            [`${0, _settingsJs.prefix}--tab--overflow-nav-button--previous`]: true,
            [`${0, _settingsJs.prefix}--tab--overflow-nav-button--hidden`]: isIntersectionLeftTrackerInContent
        });
        return (0, _lit.html)`
      <button
        part="prev-button"
        tabindex="-1"
        aria-hidden="true"
        class="${previousButtonClasses}"
        @click=${(_)=>this._handleScrollButtonClick(_, {
                direction: (0, _defsJs1.NAVIGATION_DIRECTION).Left
            })}>
        ${(0, _16JsDefault1.default)()}
      </button>
    `;
    }
    /**
     * Render the next button if tablist is wider than container.
     */ renderNextButton() {
        const { _isIntersectionRightTrackerInContent: isIntersectionRightTrackerInContent } = this;
        const nextButtonClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--tab--overflow-nav-button`]: true,
            [`${0, _settingsJs.prefix}--tabs__nav-caret-right`]: true,
            [`${0, _settingsJs.prefix}--tab--overflow-nav-button--next`]: true,
            [`${0, _settingsJs.prefix}--tab--overflow-nav-button--hidden`]: isIntersectionRightTrackerInContent
        });
        return (0, _lit.html)`
      <button
        part="next-button"
        tabindex="-1"
        aria-hidden="true"
        class="${nextButtonClasses}"
        @click=${(_)=>this._handleScrollButtonClick(_, {
                direction: (0, _defsJs1.NAVIGATION_DIRECTION).Right
            })}>
        ${(0, _16JsDefault.default)()}
      </button>
    `;
    }
    render() {
        const { _assistiveStatusText: assistiveStatusText, _handleSlotchange: handleSlotchange } = this;
        return (0, _lit.html)`
      ${this.renderPreviousButton()}
      <div class="${0, _settingsJs.prefix}--tabs-nav-content-container">
        <div class="${0, _settingsJs.prefix}--tabs-nav-content">
          <div class="${0, _settingsJs.prefix}--tabs-nav">
            <div id="tablist" role="tablist" class="${0, _settingsJs.prefix}--tab--list">
              <div class="${0, _settingsJs.prefix}--sub-content-left"></div>
              <slot @slotchange=${handleSlotchange}></slot>
              <div class="${0, _settingsJs.prefix}--sub-content-right"></div>
            </div>
          </div>
        </div>
      </div>
      ${this.renderNextButton()}
      <div
        class="${0, _settingsJs.prefix}--assistive-text"
        role="status"
        aria-live="assertive"
        aria-relevant="additions text">
        ${assistiveStatusText}
      </div>
    `;
    }
    /**
     * A selector that will return tabs.
     */ static get selectorItem() {
        return `${0, _settingsJs.prefix}-tab`;
    }
    /**
     * A selector that will return enabled tabs.
     */ static get selectorItemEnabled() {
        return `${0, _settingsJs.prefix}-tab:not([disabled])`;
    }
    /**
     * A selector that will return highlighted tabs.
     */ static get selectorItemHighlighted() {
        return `${0, _settingsJs.prefix}-tab[highlighted]`;
    }
    /**
     * A selector that will return selected tabs.
     */ static get selectorItemSelected() {
        return `${0, _settingsJs.prefix}-tab[selected]`;
    }
    /**
     * A selector that returns the tablist
     */ static get selectorTablist() {
        return `.${0, _settingsJs.prefix}--tab--list`;
    }
    /**
     * The name of the custom event fired before a tab is selected upon a user gesture.
     * Cancellation of this event stops changing the user-initiated selection.
     */ static get eventBeforeSelect() {
        return `${0, _settingsJs.prefix}-tabs-beingselected`;
    }
    /**
     * The name of the custom event fired after a a tab is selected upon a user gesture.
     */ static get eventSelect() {
        return `${0, _settingsJs.prefix}-tabs-selected`;
    }
    /**
     * @param key The key symbol.
     * @returns A action for dropdown for the given key symbol.
     */ static getAction(key) {
        if (key === "Home") return (0, _defsJs.TABS_KEYBOARD_ACTION).HOME;
        if (key === "End") return (0, _defsJs.TABS_KEYBOARD_ACTION).END;
        if (key in (0, _defsJs1.NAVIGATION_DIRECTION)) return (0, _defsJs.TABS_KEYBOARD_ACTION).NAVIGATING;
        return (0, _defsJs.TABS_KEYBOARD_ACTION).NONE;
    }
};
/**
 * Symbols of keys that triggers opening/closing menu and selecting/deselecting menu item.
 */ CDSTabs.TRIGGER_KEYS = new Set([
    " ",
    "Enter"
]);
CDSTabs.styles = (0, _tabsScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("click")
], CDSTabs.prototype, "_handleClick", null);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("keydown")
], CDSTabs.prototype, "_handleKeydown", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)(`.${(0, _settingsJs.prefix)}--tabs-nav-content-container`)
], CDSTabs.prototype, "_contentContainerNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)(`.${(0, _settingsJs.prefix)}--tabs-nav-content`)
], CDSTabs.prototype, "_contentNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTabs.prototype, "_currentScrollPosition", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)(`.${(0, _settingsJs.prefix)}--sub-content-left`)
], CDSTabs.prototype, "_intersectionLeftSentinelNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)(`.${(0, _settingsJs.prefix)}--sub-content-right`)
], CDSTabs.prototype, "_intersectionRightSentinelNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "selecting-items-assistive-text"
    })
], CDSTabs.prototype, "selectingItemsAssistiveText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "selected-item-assistive-text"
    })
], CDSTabs.prototype, "selectedItemAssistiveText", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "trigger-content"
    })
], CDSTabs.prototype, "triggerContent", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSTabs.prototype, "type", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTabs.prototype, "_isIntersectionLeftTrackerInContent", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.state)()
], CDSTabs.prototype, "_isIntersectionRightTrackerInContent", void 0);
CDSTabs = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-tabs`)
], CDSTabs);
var CDSTabs$1 = CDSTabs;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/class-map.js":"2fQud","../../globals/settings.js":"EipuL","../../globals/mixins/host-listener.js":"1SMUX","../../globals/decorators/host-listener.js":"f95Mj","../../globals/internal/collection-helpers.js":"4aZkz","../../icons/chevron--right/16.js":"bkZcb","../../icons/chevron--left/16.js":"gOtHL","../content-switcher/content-switcher.js":"6PH4s","./defs.js":"3kWkF","./tabs.scss.js":"jJqqz","../../globals/decorators/carbon-element.js":"kNhLR","../content-switcher/defs.js":"cATez","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6PH4s":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTENT_SWITCHER_SIZE", ()=>(0, _defsJs.CONTENT_SWITCHER_SIZE));
parcelHelpers.export(exports, "NAVIGATION_DIRECTION", ()=>(0, _defsJs.NAVIGATION_DIRECTION));
parcelHelpers.export(exports, "default", ()=>CDSContentSwitcher$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _defsJs = require("./defs.js");
var _contentSwitcherScssJs = require("./content-switcher.scss.js");
var _contentSwitcherScssJsDefault = parcelHelpers.interopDefault(_contentSwitcherScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param index The index
 * @param length The length of the array.
 * @returns The new index, adjusting overflow/underflow.
 */ const capIndex = (index, length)=>{
    if (index < 0) return length - 1;
    if (index >= length) return 0;
    return index;
};
/**
 * Content switcher.
 *
 * @element cds-content-switcher
 * @fires cds-content-switcher-beingselected
 *   The custom event fired before a content switcher item is selected upon a user gesture.
 *   Cancellation of this event stops changing the user-initiated selection.
 * @fires cds-content-switcher-selected - The custom event fired after a a content switcher item is selected upon a user gesture.
 */ let CDSContentSwitcher = class CDSContentSwitcher extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * The value of the selected item.
         */ this.value = "";
        /**
         * Content switcher size.
         */ this.size = (0, _defsJs.CONTENT_SWITCHER_SIZE).REGULAR;
        /**
         * Icon only.
         */ this.iconOnly = false;
    }
    /**
     * Handles `mouseover`/`mouseout` events on `<slot>`.
     *
     * @param event The event.
     * @param event.target The event target.
     * @param event.type The event type.
     */ _handleHover({ target, type }) {
        const { selectorItem } = this.constructor;
        const items = this.querySelectorAll(selectorItem);
        const index = type !== "mouseover" ? -1 : (0, _collectionHelpersJs.indexOf)(items, target.closest(selectorItem));
        const nextIndex = index < 0 ? index : index + 1;
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorItem), (elem, i)=>{
            // Specifies child `<cds-content-switcher-item>` to hide its divider instead of using CSS,
            // until `:host-context()` gets supported in all major browsers
            elem.hideDivider = i === nextIndex;
        });
        const { selectorItemSelected } = this.constructor;
        const selectedItem = this.querySelector(selectorItemSelected);
        const nextItem = this._getNextItem(selectedItem, 1);
        nextItem.hideDivider = true;
    }
    /**
     * @param target The current event target.
     * @returns The item to be selected.
     */ _getCurrentItem(target) {
        var _a;
        const items = this.querySelectorAll(this.constructor.selectorItemEnabled);
        const { selectorItem } = this.constructor;
        const containerItem = target.closest(selectorItem);
        const index = (0, _collectionHelpersJs.indexOf)(items, containerItem);
        return (_a = items[index]) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * @param currentItem The currently selected item.
     * @param direction The navigation direction.
     * @returns The item to be selected.
     */ _getNextItem(currentItem, direction) {
        const items = this.querySelectorAll(this.constructor.selectorItemEnabled);
        const currentIndex = (0, _collectionHelpersJs.indexOf)(items, currentItem);
        const nextIndex = capIndex(currentIndex + direction, items.length);
        return nextIndex === currentIndex ? null : items[nextIndex];
    }
    /**
     * Handles `click` event on content switcher item.
     *
     * @param event The event.
     * @param event.target The event target.
     */ _handleClick({ target }) {
        const currentItem = this._getCurrentItem(target);
        this._handleUserInitiatedSelectItem(currentItem);
    }
    /**
     * Handles `keydown` event on the top-level element in the shadow DOM.
     *
     * @param event The event.
     * @param event.key The event key.
     */ _handleKeydown({ key }) {
        if (key in (0, _defsJs.NAVIGATION_DIRECTION)) this._navigate((0, _defsJs.NAVIGATION_DIRECTION)[key]);
    }
    /**
     * Handles user-initiated selection of a content switcher item.
     *
     * @param [item] The content switcher item user wants to select.
     */ _handleUserInitiatedSelectItem(item) {
        if (!item.disabled && item.value !== this.value) {
            const init = {
                bubbles: true,
                composed: true,
                detail: {
                    item
                }
            };
            const constructor = this.constructor;
            const beforeSelectEvent = new CustomEvent(constructor.eventBeforeSelect, Object.assign(Object.assign({}, init), {
                cancelable: true
            }));
            if (this.dispatchEvent(beforeSelectEvent)) {
                this._selectionDidChange(item);
                const afterSelectEvent = new CustomEvent(constructor.eventSelect, init);
                this.dispatchEvent(afterSelectEvent);
            }
        }
    }
    /**
     * Navigates through content switcher items.
     *
     * @param direction `-1` to navigate backward, `1` to navigate forward.
     */ _navigate(direction) {
        const { selectorItemSelected } = this.constructor;
        const nextItem = this._getNextItem(this.querySelector(selectorItemSelected), direction);
        if (nextItem) {
            this._handleUserInitiatedSelectItem(nextItem);
            this.requestUpdate();
        }
    }
    /**
     * A callback that runs after change in content switcher selection upon user interaction is confirmed.
     *
     * @param itemToSelect A content switcher item.
     */ _selectionDidChange(itemToSelect) {
        this.value = itemToSelect.value;
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorItemSelected), (item)=>{
            item.selected = false;
        });
        itemToSelect.selected = true;
        // Waits for rendering with the new state that updates `tabindex`
        Promise.resolve().then(()=>{
            itemToSelect.focus();
            const { selectorItem } = this.constructor;
            const items = this.querySelectorAll(selectorItem);
            const index = (0, _collectionHelpersJs.indexOf)(items, itemToSelect.closest(selectorItem));
            const nextIndex = index < 0 ? index : index + 1;
            (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorItem), (elem, i)=>{
                // Specifies child `<cds-content-switcher-item>` to hide its divider instead of using CSS,
                // until `:host-context()` gets supported in all major browsers
                elem.hideDivider = i === nextIndex;
            });
        });
    }
    shouldUpdate(changedProperties) {
        if (changedProperties.has("value")) {
            const { selectorItem } = this.constructor;
            (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorItem), (elem)=>{
                elem.selected = elem.value === this.value;
            });
        }
        const { selectorIconItem } = this.constructor;
        if (this.querySelector(selectorIconItem)) this.iconOnly = true;
        return true;
    }
    _handleSlotchange() {
        const { selectorItemSelected } = this.constructor;
        const selectedItem = this.querySelector(selectorItemSelected);
        const nextItem = this._getNextItem(selectedItem, 1);
        // Specifies child `<cds-content-switcher-item>` to hide its divider instead of using CSS,
        // until `:host-context()` gets supported in all major browsers
        nextItem.hideDivider = true;
    }
    /**
     * A selector that will return content switcher items.
     */ static get selectorItem() {
        return `${0, _settingsJs.prefix}-content-switcher-item`;
    }
    /**
     * A selector that will return content switcher icon items.
     */ static get selectorIconItem() {
        return `${0, _settingsJs.prefix}-content-switcher-item[icon]`;
    }
    /**
     * A selector that will return enabled content switcher items.
     */ static get selectorItemEnabled() {
        return `${0, _settingsJs.prefix}-content-switcher-item:not([disabled])`;
    }
    /**
     * A selector that will return selected items.
     */ static get selectorItemSelected() {
        return `${0, _settingsJs.prefix}-content-switcher-item[selected]`;
    }
    /**
     * The name of the custom event fired before a content switcher item is selected upon a user gesture.
     * Cancellation of this event stops changing the user-initiated selection.
     */ static get eventBeforeSelect() {
        return `${0, _settingsJs.prefix}-content-switcher-beingselected`;
    }
    /**
     * The name of the custom event fired after a a content switcher item is selected upon a user gesture.
     */ static get eventSelect() {
        return `${0, _settingsJs.prefix}-content-switcher-selected`;
    }
    render() {
        const { _handleHover: handleHover, _handleKeydown: handleKeydown, _handleSlotchange: handleSlotchange } = this;
        return (0, _lit.html)`
      <slot
        @click="${this._handleClick}"
        @keydown="${handleKeydown}"
        @mouseover="${handleHover}"
        @mouseout="${handleHover}"
        @slotchange=${handleSlotchange}></slot>
    `;
    }
};
CDSContentSwitcher.styles = (0, _contentSwitcherScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSContentSwitcher.prototype, "value", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSContentSwitcher.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "icon"
    })
], CDSContentSwitcher.prototype, "iconOnly", void 0);
CDSContentSwitcher = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-content-switcher`)
], CDSContentSwitcher);
var CDSContentSwitcher$1 = CDSContentSwitcher;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/internal/collection-helpers.js":"4aZkz","./defs.js":"cATez","./content-switcher.scss.js":"azEq0","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cATez":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Navigation direction, associated with key symbols.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTENT_SWITCHER_SIZE", ()=>CONTENT_SWITCHER_SIZE);
parcelHelpers.export(exports, "NAVIGATION_DIRECTION", ()=>NAVIGATION_DIRECTION);
const NAVIGATION_DIRECTION = {
    Left: -1,
    ArrowLeft: -1,
    Right: 1,
    ArrowRight: 1
};
/**
 * Button size.
 */ var CONTENT_SWITCHER_SIZE;
(function(CONTENT_SWITCHER_SIZE) {
    /**
     * Regular size.
     */ CONTENT_SWITCHER_SIZE["REGULAR"] = "";
    /**
     * Small size.
     */ CONTENT_SWITCHER_SIZE["SMALL"] = "sm";
    /**
     * Large size.
     */ CONTENT_SWITCHER_SIZE["LARGE"] = "lg";
    // TODO: deprecate
    /**
     * X-Large size.
     */ CONTENT_SWITCHER_SIZE["EXTRA_LARGE"] = "xl";
})(CONTENT_SWITCHER_SIZE || (CONTENT_SWITCHER_SIZE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3kWkF":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The keyboard action categories for dropdown.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TABS_KEYBOARD_ACTION", ()=>TABS_KEYBOARD_ACTION);
parcelHelpers.export(exports, "TABS_TYPE", ()=>TABS_TYPE);
var TABS_KEYBOARD_ACTION;
(function(TABS_KEYBOARD_ACTION) {
    /**
     * Not doing any action.
     */ TABS_KEYBOARD_ACTION["NONE"] = "none";
    /**
     * Keyboard action to navigate back/forward.
     */ TABS_KEYBOARD_ACTION["NAVIGATING"] = "navigating";
    /**
     * Keyboard action to navigate to first tab using home key
     */ TABS_KEYBOARD_ACTION["HOME"] = "home";
    /**
     * Keyboard action to navigate to last tab using end key
     */ TABS_KEYBOARD_ACTION["END"] = "end";
})(TABS_KEYBOARD_ACTION || (TABS_KEYBOARD_ACTION = {}));
/**
 * Tabs types.
 */ var TABS_TYPE;
(function(TABS_TYPE) {
    /**
     * Regular tabs.
     */ TABS_TYPE["REGULAR"] = "";
    /**
     * Container type.
     */ TABS_TYPE["CONTAINER"] = "container";
    /**
     * Contained type.
     */ TABS_TYPE["CONTAINED"] = "contained";
})(TABS_TYPE || (TABS_TYPE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jJqqz":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tab--list{display:grid;grid-template-columns:repeat(auto-fit,minmax(0,1fr));inline-size:100%}.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tab--list .cds--tabs__nav-link .cds--tabs__nav-item-label,.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tab--list .cds--tabs__nav-link .cds--tabs__nav-item-secondary-label{overflow:hidden;text-overflow:ellipsis}.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tab--list .cds--tabs__nav-link .cds--tabs__nav-item--icon{margin-inline-start:auto}.cds--tabs.cds--tabs--vertical .cds--tabs__nav-link .cds--tabs__nav-item-label{display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:2;text-overflow:ellipsis;white-space:normal}.cds--tab-content,.cds--tabs,:host(cds-tabs),:host(cds-tabs-skeleton){--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max))}.cds--tabs.cds--tabs--contained.cds--tabs--tall,.cds--tabs.cds--tabs--tall{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-lg)),var(--cds-layout-size-height,var(--cds-layout-size-height-xl)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-xl)))}.cds--tabs,:host(cds-tabs),:host(cds-tabs-skeleton){font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-md)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-lg)));block-size:auto;color:var(--cds-text-primary,#161616);display:flex;inline-size:100%;max-block-size:var(--cds-layout-size-height-xl);min-block-size:var(--cds-layout-size-height-local);overflow-x:hidden;position:relative}.cds--tabs html,:host(cds-tabs) html,:host(cds-tabs-skeleton) html{font-size:100%}.cds--tabs body,:host(cds-tabs) body,:host(cds-tabs-skeleton) body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--tabs code,:host(cds-tabs) code,:host(cds-tabs-skeleton) code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--tabs strong,:host(cds-tabs) strong,:host(cds-tabs-skeleton) strong{font-weight:600}.cds--tabs.cds--tabs--contained{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-xl)))}.cds--tabs .cds--tab--list,:host(cds-tabs) .cds--tab--list,:host(cds-tabs-skeleton) .cds--tab--list{display:flex;inline-size:auto;overflow-x:auto;scroll-behavior:smooth;scrollbar-width:none;will-change:scroll-position}.cds--tabs .cds--tab--list::-webkit-scrollbar,:host(cds-tabs) .cds--tab--list::-webkit-scrollbar,:host(cds-tabs-skeleton) .cds--tab--list::-webkit-scrollbar{display:none}.cds--tabs.cds--tabs--vertical{background:var(--cds-layer);box-shadow:inset -1px 0 var(--cds-border-subtle);grid-column:span 2;max-block-size:none}@media (min-width:66rem){.cds--tabs.cds--tabs--vertical{grid-column:span 4}}.cds--tabs.cds--tabs--vertical .cds--tab--list{flex-direction:column;inline-size:100%;overflow:visible auto}.cds--tabs.cds--tabs--vertical .cds--tab--list-gradient_bottom{background:linear-gradient(to bottom,transparent,var(--cds-layer));block-size:4rem;inset-block-end:0;inset-inline:0;pointer-events:none;position:absolute}.cds--tabs.cds--tabs--vertical .cds--tab--list-gradient_top{background:linear-gradient(to top,transparent,var(--cds-layer));block-size:4rem;inset-block-start:0;inset-inline:0;pointer-events:none;position:absolute}.cds--tabs .cds--tabs__nav,:host(cds-tabs) .cds--tabs__nav,:host(cds-tabs-skeleton) .cds--tabs__nav{border:0;box-sizing:border-box;display:flex;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--tabs .cds--tabs__nav *,.cds--tabs .cds--tabs__nav :after,.cds--tabs .cds--tabs__nav :before,:host(cds-tabs) .cds--tabs__nav *,:host(cds-tabs) .cds--tabs__nav :after,:host(cds-tabs) .cds--tabs__nav :before,:host(cds-tabs-skeleton) .cds--tabs__nav *,:host(cds-tabs-skeleton) .cds--tabs__nav :after,:host(cds-tabs-skeleton) .cds--tabs__nav :before{box-sizing:inherit}.cds--tabs .cds--tab--overflow-nav-button,:host(cds-tabs) .cds--tab--overflow-nav-button,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;background-color:var(--cds-background,#fff);border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;flex-shrink:0;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2.5rem;justify-content:center;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--tabs .cds--tab--overflow-nav-button *,.cds--tabs .cds--tab--overflow-nav-button :after,.cds--tabs .cds--tab--overflow-nav-button :before,:host(cds-tabs) .cds--tab--overflow-nav-button *,:host(cds-tabs) .cds--tab--overflow-nav-button :after,:host(cds-tabs) .cds--tab--overflow-nav-button :before,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button *,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button :after,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button :before{box-sizing:inherit}.cds--tabs .cds--tab--overflow-nav-button::-moz-focus-inner,:host(cds-tabs) .cds--tab--overflow-nav-button::-moz-focus-inner,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button::-moz-focus-inner{border:0}.cds--tabs .cds--tab--overflow-nav-button:focus,:host(cds-tabs) .cds--tab--overflow-nav-button:focus,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--tabs .cds--tab--overflow-nav-button:focus,:host(cds-tabs) .cds--tab--overflow-nav-button:focus,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button:focus{outline-style:dotted}}.cds--tabs .cds--tab--overflow-nav-button:hover,:host(cds-tabs) .cds--tab--overflow-nav-button:hover,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--tabs .cds--tab--overflow-nav-button:active,:host(cds-tabs) .cds--tab--overflow-nav-button:active,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--tabs .cds--tab--overflow-nav-button--hidden,:host(cds-tabs) .cds--tab--overflow-nav-button--hidden,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button--hidden{display:none}.cds--tabs.cds--tabs--contained .cds--tab--overflow-nav-button{background-color:var(--cds-layer-accent);inline-size:3rem;margin:0}.cds--tabs.cds--tabs--contained .cds--tab--overflow-nav-button:hover{background-color:var(--cds-layer-accent-hover)}.cds--tabs.cds--tabs--contained .cds--tab--overflow-nav-button:active{background-color:var(--cds-layer-accent-active)}.cds--tabs .cds--tab--overflow-nav-button svg,:host(cds-tabs) .cds--tab--overflow-nav-button svg,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button svg{z-index:2;fill:var(--cds-icon-primary,#161616)}.cds--tabs .cds--tab--overflow-nav-button svg:active,.cds--tabs .cds--tab--overflow-nav-button svg:hover,:host(cds-tabs) .cds--tab--overflow-nav-button svg:active,:host(cds-tabs) .cds--tab--overflow-nav-button svg:hover,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button svg:active,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button svg:hover{fill:var(--cds-icon-primary,#161616)}.cds--tabs .cds--tab--overflow-nav-button--next,:host(cds-tabs) .cds--tab--overflow-nav-button--next,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button--next{inset-block:0;inset-inline-end:0;position:relative}.cds--tabs .cds--tab--overflow-nav-button--next:before,:host(cds-tabs) .cds--tab--overflow-nav-button--next:before,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button--next:before{block-size:100%;content:"";inline-size:.5rem;inset-inline-start:-.5rem;position:absolute;z-index:1}.cds--tabs:not(.cds--tabs--contained) .cds--tab--overflow-nav-button--next:before,:not(.cds--tabs--contained):host(cds-tabs) .cds--tab--overflow-nav-button--next:before,:not(.cds--tabs--contained):host(cds-tabs-skeleton) .cds--tab--overflow-nav-button--next:before{background:linear-gradient(to right,hsla(0,0%,100%,0),var(--cds-background,#fff))}.cds--tabs:not(.cds--tabs--contained) .cds--tab--overflow-nav-button--previous:before,:not(.cds--tabs--contained):host(cds-tabs) .cds--tab--overflow-nav-button--previous:before,:not(.cds--tabs--contained):host(cds-tabs-skeleton) .cds--tab--overflow-nav-button--previous:before{background:linear-gradient(to left,hsla(0,0%,100%,0),var(--cds-background,#fff))}.cds--tabs .cds--tab--overflow-nav-button--previous,:host(cds-tabs) .cds--tab--overflow-nav-button--previous,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button--previous{inset-block:0;inset-inline-start:0;position:relative;z-index:1}.cds--tabs .cds--tab--overflow-nav-button--previous:before,:host(cds-tabs) .cds--tab--overflow-nav-button--previous:before,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button--previous:before{block-size:100%;content:"";inline-size:.5rem;inset-inline-end:-.5rem;position:absolute;z-index:1}.cds--tabs .cds--tabs--light .cds--tabs__overflow-indicator--left,:host(cds-tabs) .cds--tabs--light .cds--tabs__overflow-indicator--left,:host(cds-tabs-skeleton) .cds--tabs--light .cds--tabs__overflow-indicator--left{background-image:linear-gradient(to left,hsla(0,0%,100%,0),var(--cds-layer))}.cds--tabs .cds--tabs--light .cds--tabs__overflow-indicator--right,:host(cds-tabs) .cds--tabs--light .cds--tabs__overflow-indicator--right,:host(cds-tabs-skeleton) .cds--tabs--light .cds--tabs__overflow-indicator--right{background-image:linear-gradient(to right,hsla(0,0%,100%,0),var(--cds-layer))}.cds--tabs.cds--tabs--contained .cds--tabs__overflow-indicator--left{background-image:linear-gradient(to left,hsla(0,0%,100%,0),var(--cds-layer-accent))}.cds--tabs.cds--tabs--contained .cds--tabs__overflow-indicator--right{background-image:linear-gradient(to right,hsla(0,0%,100%,0),var(--cds-layer-accent))}@media not all and (resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){.cds--tabs .cds--tabs__overflow-indicator--left,:host(cds-tabs) .cds--tabs__overflow-indicator--left,:host(cds-tabs-skeleton) .cds--tabs__overflow-indicator--left{background-image:linear-gradient(to left,rgba(var(--cds-background,#ffffff),0),var(--cds-background,#fff))}.cds--tabs .cds--tabs__overflow-indicator--right,:host(cds-tabs) .cds--tabs__overflow-indicator--right,:host(cds-tabs-skeleton) .cds--tabs__overflow-indicator--right{background-image:linear-gradient(to right,rgba(var(--cds-background,#ffffff),0),var(--cds-background,#fff))}.cds--tabs.cds--tabs--contained .cds--tabs__overflow-indicator--left{background-image:linear-gradient(to left,rgba(var(--cds-layer-accent),0),var(--cds-layer-accent))}.cds--tabs.cds--tabs--contained .cds--tabs__overflow-indicator--right{background-image:linear-gradient(to right,rgba(var(--cds-layer-accent),0),var(--cds-layer-accent))}}}.cds--tabs .cds--tabs__nav-item-label-wrapper,:host(cds-tabs) .cds--tabs__nav-item-label-wrapper,:host(cds-tabs-skeleton) .cds--tabs__nav-item-label-wrapper{display:flex}.cds--tabs:not(.cds--tabs--contained) .cds--tabs__nav-item-label-wrapper,:not(.cds--tabs--contained):host(cds-tabs) .cds--tabs__nav-item-label-wrapper,:not(.cds--tabs--contained):host(cds-tabs-skeleton) .cds--tabs__nav-item-label-wrapper{inset-block-start:.0625rem;position:relative}.cds--tabs .cds--tabs__nav-item,:host(cds-tabs) .cds--tabs__nav-item,:host(cds-tabs-skeleton) .cds--tabs__nav-item{cursor:pointer;display:flex;flex:1 0 auto;padding:0;transition:background-color 70ms cubic-bezier(.2,0,.38,.9)}.cds--tabs .cds--tabs__nav-item html,:host(cds-tabs) .cds--tabs__nav-item html,:host(cds-tabs-skeleton) .cds--tabs__nav-item html{font-size:100%}.cds--tabs .cds--tabs__nav-item body,:host(cds-tabs) .cds--tabs__nav-item body,:host(cds-tabs-skeleton) .cds--tabs__nav-item body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--tabs .cds--tabs__nav-item code,:host(cds-tabs) .cds--tabs__nav-item code,:host(cds-tabs-skeleton) .cds--tabs__nav-item code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--tabs .cds--tabs__nav-item strong,:host(cds-tabs) .cds--tabs__nav-item strong,:host(cds-tabs-skeleton) .cds--tabs__nav-item strong{font-weight:600}.cds--tabs .cds--tabs__nav-item+.cds--tabs__nav-item,:host(cds-tabs) .cds--tabs__nav-item+.cds--tabs__nav-item,:host(cds-tabs-skeleton) .cds--tabs__nav-item+.cds--tabs__nav-item{margin-inline-start:.0625rem}.cds--tabs.cds--tabs--contained .cds--tabs__nav-item{background-color:var(--cds-layer-accent);box-shadow:-.0625rem 0 0 0 var(--cds-border-strong);margin-inline-start:0}.cds--tabs.cds--tabs--vertical .cds--tabs__nav-item{background-color:var(--cds-layer-01,#f4f4f4);block-size:4rem;border-block-end:1px solid var(--cds-border-subtle);border-inline-end:1px solid var(--cds-border-subtle);box-shadow:inset 3px 0 0 0 var(--cds-border-subtle);flex:none;inline-size:100%;margin-inline-start:0}.cds--tabs.cds--tabs--contained:not(.cds--tabs--vertical) .cds--tabs__nav-item--selected+div+.cds--tabs__nav-item{box-shadow:-.0625rem 0 0 0 transparent}.cds--tabs .cds--tabs__nav-item .cds--tabs__nav-link,:host(cds-tabs) .cds--tabs__nav-item .cds--tabs__nav-link,:host(cds-tabs-skeleton) .cds--tabs__nav-item .cds--tabs__nav-link{transition:color 70ms cubic-bezier(.2,0,.38,.9),border-bottom-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9)}.cds--tabs.cds--tabs--dismissable .cds--tabs__nav-link{padding-inline-end:2.5rem}.cds--tabs.cds--tabs--dismissable.cds--tabs--contained .cds--tabs__nav-link{padding-inline-end:calc(3rem - 1px)}.cds--tabs .cds--tabs__nav-item--close,:host(cds-tabs) .cds--tabs__nav-item--close,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close{align-items:center;display:flex;inset-inline-start:calc(-.75rem - 1px);margin-inline-start:calc(-1.5rem + 1px);position:relative}.cds--tabs:not(.cds--tabs--contained) .cds--tabs__nav-item--close--hidden,:not(.cds--tabs--contained):host(cds-tabs) .cds--tabs__nav-item--close--hidden,:not(.cds--tabs--contained):host(cds-tabs-skeleton) .cds--tabs__nav-item--close--hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;inline-size:.1875rem;position:static;visibility:inherit;white-space:nowrap}.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tabs__nav-item--close--hidden{display:none}.cds--tabs .cds--tabs__nav-item--close-icon,:host(cds-tabs) .cds--tabs__nav-item--close-icon,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:1.5rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;inline-size:1.5rem;margin:0;padding:0;padding-block:.25rem;padding-inline:.25rem;pointer-events:auto;text-align:start;vertical-align:baseline}.cds--tabs .cds--tabs__nav-item--close-icon *,.cds--tabs .cds--tabs__nav-item--close-icon :after,.cds--tabs .cds--tabs__nav-item--close-icon :before,:host(cds-tabs) .cds--tabs__nav-item--close-icon *,:host(cds-tabs) .cds--tabs__nav-item--close-icon :after,:host(cds-tabs) .cds--tabs__nav-item--close-icon :before,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon *,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon :after,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon :before{box-sizing:inherit}.cds--tabs .cds--tabs__nav-item--close-icon::-moz-focus-inner,:host(cds-tabs) .cds--tabs__nav-item--close-icon::-moz-focus-inner,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon::-moz-focus-inner{border:0}.cds--tabs .cds--tabs__nav-item--close-icon svg,:host(cds-tabs) .cds--tabs__nav-item--close-icon svg,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon svg{block-size:1rem;fill:var(--cds-text-secondary,#525252);inline-size:1rem}.cds--tabs .cds--tabs__nav-item--close-icon svg:hover,:host(cds-tabs) .cds--tabs__nav-item--close-icon svg:hover,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon svg:hover{fill:var(--cds-text-primary,#161616)}.cds--tabs .cds--tabs__nav-item--close-icon:hover,:host(cds-tabs) .cds--tabs__nav-item--close-icon:hover,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon:hover{background-color:var(--cds-layer-hover)}.cds--tabs .cds--tabs__nav-item--close-icon:active,.cds--tabs .cds--tabs__nav-item--close-icon:focus,:host(cds-tabs) .cds--tabs__nav-item--close-icon:active,:host(cds-tabs) .cds--tabs__nav-item--close-icon:focus,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon:active,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--tabs .cds--tabs__nav-item--close-icon:active,.cds--tabs .cds--tabs__nav-item--close-icon:focus,:host(cds-tabs) .cds--tabs__nav-item--close-icon:active,:host(cds-tabs) .cds--tabs__nav-item--close-icon:focus,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon:active,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon:focus{outline-style:dotted}}.cds--tabs .cds--tabs__nav-item:hover+.cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon svg,:host(cds-tabs) .cds--tabs__nav-item:hover+.cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon svg,:host(cds-tabs-skeleton) .cds--tabs__nav-item:hover+.cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon svg{fill:var(--cds-text-primary,#161616)}.cds--tabs .cds--tabs__nav-item--close-icon--selected svg,:host(cds-tabs) .cds--tabs__nav-item--close-icon--selected svg,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon--selected svg{fill:var(--cds-text-primary,#161616)}.cds--tabs .cds--tabs__nav-item--close-icon--disabled,.cds--tabs .cds--tabs__nav-item--close-icon--disabled:hover,.cds--tabs .cds--tabs__nav-item:hover+.cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon--disabled,:host(cds-tabs) .cds--tabs__nav-item--close-icon--disabled,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon--disabled{background-color:inherit;cursor:not-allowed}.cds--tabs .cds--tabs__nav-item--close-icon--disabled svg,.cds--tabs .cds--tabs__nav-item--close-icon--disabled:hover svg,.cds--tabs .cds--tabs__nav-item:hover+.cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon--disabled svg,:host(cds-tabs) .cds--tabs__nav-item--close-icon--disabled svg,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon--disabled svg{fill:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--tabs .cds--tabs__nav-item--close-icon--disabled:active,.cds--tabs .cds--tabs__nav-item--close-icon--disabled:focus,.cds--tabs .cds--tabs__nav-item--close-icon--disabled:hover:active,.cds--tabs .cds--tabs__nav-item--close-icon--disabled:hover:focus,.cds--tabs .cds--tabs__nav-item:hover+.cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon--disabled:active,.cds--tabs .cds--tabs__nav-item:hover+.cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon--disabled:focus,:host(cds-tabs) .cds--tabs__nav-item--close-icon--disabled:active,:host(cds-tabs) .cds--tabs__nav-item--close-icon--disabled:focus,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon--disabled:active,:host(cds-tabs-skeleton) .cds--tabs__nav-item--close-icon--disabled:focus{outline:2px solid transparent;outline-offset:-2px}.cds--tabs .cds--tabs__nav-item--icon,:host(cds-tabs) .cds--tabs__nav-item--icon,:host(cds-tabs-skeleton) .cds--tabs__nav-item--icon{align-items:center;display:flex;padding-inline-start:.5rem}.cds--tabs .cds--tabs__nav-item--icon-left,:host(cds-tabs) .cds--tabs__nav-item--icon-left,:host(cds-tabs-skeleton) .cds--tabs__nav-item--icon-left{align-items:center;display:flex;margin-block-start:-2px;padding-inline-end:.5rem}.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--icon{padding-inline-start:var(--cds-layout-density-padding-inline-local)}.cds--tabs .cds--tabs__nav-link,:host(cds-tabs) .cds--tabs__nav-link,:host(cds-tabs-skeleton) .cds--tabs__nav-link{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:2px solid var(--cds-border-subtle);box-sizing:border-box;color:var(--cds-text-secondary,#525252);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:2px solid transparent;outline-offset:-2px;overflow:hidden;padding:0;padding-inline:var(--cds-layout-density-padding-inline-local);text-align:start;text-decoration:none;text-overflow:ellipsis;transition:border 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline;white-space:nowrap}.cds--tabs .cds--tabs__nav-link *,.cds--tabs .cds--tabs__nav-link :after,.cds--tabs .cds--tabs__nav-link :before,:host(cds-tabs) .cds--tabs__nav-link *,:host(cds-tabs) .cds--tabs__nav-link :after,:host(cds-tabs) .cds--tabs__nav-link :before,:host(cds-tabs-skeleton) .cds--tabs__nav-link *,:host(cds-tabs-skeleton) .cds--tabs__nav-link :after,:host(cds-tabs-skeleton) .cds--tabs__nav-link :before{box-sizing:inherit}.cds--tabs .cds--tabs__nav-link::-moz-focus-inner,:host(cds-tabs) .cds--tabs__nav-link::-moz-focus-inner,:host(cds-tabs-skeleton) .cds--tabs__nav-link::-moz-focus-inner{border:0}.cds--tabs .cds--tabs__nav-link:active,.cds--tabs .cds--tabs__nav-link:focus,:host(cds-tabs) .cds--tabs__nav-link:active,:host(cds-tabs) .cds--tabs__nav-link:focus,:host(cds-tabs-skeleton) .cds--tabs__nav-link:active,:host(cds-tabs-skeleton) .cds--tabs__nav-link:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--tabs .cds--tabs__nav-link:active,.cds--tabs .cds--tabs__nav-link:focus,:host(cds-tabs) .cds--tabs__nav-link:active,:host(cds-tabs) .cds--tabs__nav-link:focus,:host(cds-tabs-skeleton) .cds--tabs__nav-link:active,:host(cds-tabs-skeleton) .cds--tabs__nav-link:focus{outline-style:dotted}}.cds--tabs.cds--tabs--contained:not(.cds--tabs--vertical) .cds--tabs__nav-link{border-block-end:0;padding-inline:var(--cds-layout-density-padding-inline-local)}.cds--tabs.cds--tabs--contained:not(.cds--tabs--tall) .cds--tabs__nav-item-label{line-height:2rem}.cds--tabs.cds--tabs--contained .cds--tabs__nav-item-secondary-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);min-block-size:1rem}.cds--tabs.cds--tabs--vertical:not(.cds--tabs--tall) .cds--tabs__nav-item-label{line-height:var(--cds-body-compact-01-line-height)}.cds--tabs.cds--tabs__icon--default .cds--tab--list,.cds--tabs.cds--tabs__icon--lg .cds--tab--list{overflow-x:visible}.cds--tabs .cds--tabs__nav-item--icon-only,:host(cds-tabs) .cds--tabs__nav-item--icon-only,:host(cds-tabs-skeleton) .cds--tabs__nav-item--icon-only{margin-inline-end:.0625rem}.cds--tabs .cds--tabs__nav-item--icon-only,.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--icon-only,:host(cds-tabs) .cds--tabs__nav-item--icon-only,:host(cds-tabs-skeleton) .cds--tabs__nav-item--icon-only{align-items:center;block-size:var(--cds-layout-size-height-local);display:flex;inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0}.cds--tabs .cds--tabs__nav-item--icon-only .cds--tabs__nav-item-label,.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--icon-only .cds--tabs__nav-item-label,:host(cds-tabs) .cds--tabs__nav-item--icon-only .cds--tabs__nav-item-label,:host(cds-tabs-skeleton) .cds--tabs__nav-item--icon-only .cds--tabs__nav-item-label{line-height:0}.cds--tabs:not(.cds--tabs--contained) .cds--tabs__nav-item:not(.cds--tabs__nav-item--selected):not(.cds--tabs__nav-item--disabled):hover,:not(.cds--tabs--contained):host(cds-tabs) .cds--tabs__nav-item:not(.cds--tabs__nav-item--selected):not(.cds--tabs__nav-item--disabled):hover,:not(.cds--tabs--contained):host(cds-tabs-skeleton) .cds--tabs__nav-item:not(.cds--tabs__nav-item--selected):not(.cds--tabs__nav-item--disabled):hover{border-block-end:2px solid var(--cds-border-strong);color:var(--cds-text-primary,#161616)}.cds--tabs.cds--tabs--contained .cds--tabs__nav-item:not(.cds--tabs__nav-item--selected):not(.cds--tabs__nav-item--disabled):not(.cds--tabs__nav-item--hover-off):hover{background-color:var(--cds-layer-accent-hover);color:var(--cds-text-primary,#161616)}.cds--tabs.cds--tabs--vertical .cds--tabs__nav-item:not(.cds--tabs__nav-item--selected):not(.cds--tabs__nav-item--disabled):not(.cds--tabs__nav-item--hover-off):hover{background-color:var(--cds-layer-hover);box-shadow:inset 3px 0 0 0 var(--cds-border-strong)}.cds--tabs .cds--tabs__nav-item--selected,:host(cds-tabs) .cds--tabs__nav-item--selected,:host(cds-tabs-skeleton) .cds--tabs__nav-item--selected{border-block-end:2px solid var(--cds-border-interactive,#0f62fe);transition:color 70ms cubic-bezier(.2,0,.38,.9)}.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected+.cds--tabs__nav-item{box-shadow:none}.cds--tabs.cds--tabs--contained .cds--tabs__nav-item.cds--tabs__nav-item--selected{box-shadow:inset 0 2px 0 0 var(--cds-border-interactive,#0f62fe)}.cds--tabs.cds--tabs--vertical .cds--tabs__nav-item.cds--tabs__nav-item--selected{border-inline:none;box-shadow:inset 3px 0 0 0 var(--cds-border-interactive,#0f62fe)}.cds--tabs .cds--tabs__nav-item--selected,.cds--tabs .cds--tabs__nav-item--selected:active .cds--tabs__nav-link:active,.cds--tabs .cds--tabs__nav-item--selected:focus .cds--tabs__nav-link:focus,.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected,:host(cds-tabs) .cds--tabs__nav-item--selected,:host(cds-tabs) .cds--tabs__nav-item--selected:active .cds--tabs__nav-link:active,:host(cds-tabs) .cds--tabs__nav-item--selected:focus .cds--tabs__nav-link:focus,:host(cds-tabs-skeleton) .cds--tabs__nav-item--selected,:host(cds-tabs-skeleton) .cds--tabs__nav-item--selected:active .cds--tabs__nav-link:active,:host(cds-tabs-skeleton) .cds--tabs__nav-item--selected:focus .cds--tabs__nav-link:focus{color:var(--cds-text-primary,#161616);font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572)}.cds--tabs.cds--tabs--contained:not(.cds--tabs--tall) .cds--tabs__nav-item--selected,.cds--tabs.cds--tabs--contained:not(.cds--tabs--tall) .cds--tabs__nav-item--selected:hover{line-height:2rem}.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected,.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected:hover{background-color:var(--cds-layer)}.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected .cds--tabs__nav-link:active,.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected .cds--tabs__nav-link:focus,.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected:hover .cds--tabs__nav-link:active,.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected:hover .cds--tabs__nav-link:focus{box-shadow:none}.cds--tabs.cds--tabs--light.cds--tabs--contained .cds--tabs__nav-item--selected,.cds--tabs.cds--tabs--light.cds--tabs--contained .cds--tabs__nav-item--selected:hover{background-color:var(--cds-background,#fff)}.cds--tabs .cds--tabs__nav-item--disabled,:host(cds-tabs) .cds--tabs__nav-item--disabled,:host(cds-tabs-skeleton) .cds--tabs__nav-item--disabled{background-color:transparent;border-block-end:2px solid var(--cds-border-subtle);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--tabs .cds--tabs__nav-item--disabled:hover,:host(cds-tabs) .cds--tabs__nav-item--disabled:hover,:host(cds-tabs-skeleton) .cds--tabs__nav-item--disabled:hover{border-block-end:2px solid var(--cds-border-subtle);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--tabs.cds--tabs--contained .cds--tabs__nav-item.cds--tabs__nav-item--disabled,.cds--tabs.cds--tabs--contained .cds--tabs__nav-item.cds--tabs__nav-item--disabled:hover{background-color:var(--cds-button-disabled,#c6c6c6)}.cds--tabs.cds--tabs--vertical .cds--tabs__nav-item.cds--tabs__nav-item--disabled,.cds--tabs.cds--tabs--vertical .cds--tabs__nav-item.cds--tabs__nav-item--disabled:hover{background-color:var(--cds-layer);border-block-end:1px solid var(--cds-border-subtle)}.cds--tabs .cds--tabs__nav-item--disabled:active,.cds--tabs .cds--tabs__nav-item--disabled:focus,:host(cds-tabs) .cds--tabs__nav-item--disabled:active,:host(cds-tabs) .cds--tabs__nav-item--disabled:focus,:host(cds-tabs-skeleton) .cds--tabs__nav-item--disabled:active,:host(cds-tabs-skeleton) .cds--tabs__nav-item--disabled:focus{border-block-end:2px solid var(--cds-border-subtle);outline:none;pointer-events:none}.cds--tabs .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link,:host(cds-tabs) .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link,:host(cds-tabs-skeleton) .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link{border-block-end-color:var(--cds-border-subtle)}.cds--tabs .cds--tabs--light .cds--tabs__nav-item--disabled:hover .cds--tabs__nav-link,:host(cds-tabs) .cds--tabs--light .cds--tabs__nav-item--disabled:hover .cds--tabs__nav-link,:host(cds-tabs-skeleton) .cds--tabs--light .cds--tabs__nav-item--disabled:hover .cds--tabs__nav-link{border-block-end-color:var(--cds-border-subtle)}.cds--tabs .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link:active,.cds--tabs .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link:focus,:host(cds-tabs) .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link:active,:host(cds-tabs) .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link:focus,:host(cds-tabs-skeleton) .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link:active,:host(cds-tabs-skeleton) .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link:focus{border-block-end-color:var(--cds-border-subtle)}.cds--tabs.cds--tabs--contained:not(.cds--tabs--vertical) .cds--tabs__nav-item--disabled{border-block-end:none;color:var(--cds-text-on-color-disabled,#8d8d8d)}.cds--tab-content{padding:var(--cds-layout-density-padding-inline-local)}.cds--tab-content:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--tab-content:focus{outline-style:dotted}}.cds--tabs--contained~.cds--tab-content{background:var(--cds-layer)}.cds--tabs--vertical~.cds--tab-content{grid-column:3/-1;overflow-y:auto}.cds--tabs--vertical~.cds--tab-content .cds--date-picker--fluid .ccdsds--date-picker-input__wrapper .cds--date-picker__input,.cds--tabs--vertical~.cds--tab-content .cds--list-box__wrapper--fluid .cds--list-box,.cds--tabs--vertical~.cds--tab-content .cds--list-box__wrapper--fluid.cds--list-box__wrapper,.cds--tabs--vertical~.cds--tab-content .cds--number-input--fluid .cds--number__control-btn:after,.cds--tabs--vertical~.cds--tab-content .cds--number-input--fluid .cds--number__control-btn:before,.cds--tabs--vertical~.cds--tab-content .cds--number-input--fluid input[type=number],.cds--tabs--vertical~.cds--tab-content .cds--search--fluid .cds--search-input,.cds--tabs--vertical~.cds--tab-content .cds--select--fluid .cds--select-input,.cds--tabs--vertical~.cds--tab-content .cds--text-area--fluid .cds--text-area,.cds--tabs--vertical~.cds--tab-content .cds--text-area--fluid .cds--text-area__wrapper,.cds--tabs--vertical~.cds--tab-content .cds--text-area--fluid .cds--text-area__wrapper[data-invalid] .cds--text-area__divider+.cds--form-requirement,.cds--tabs--vertical~.cds--tab-content .cds--text-input--fluid .cds--text-input{background-color:var(--cds-field-01,#f4f4f4)}.cds--tabs--vertical~.cds--tab-content .cds--list-box__wrapper--fluid .cds--list-box__menu{background-color:var(--cds-layer-01,#f4f4f4)}.cds--tabs--vertical~.cds--tab-content .cds--list-box__menu-item:hover{background-color:var(--cds-layer-hover-02,#e8e8e8)}.cds--tabs--vertical~.cds--tab-content .cds--list-box__menu-item--active{background-color:var(--cds-layer-selected-02,#e0e0e0)}.cds--tabs--vertical~.cds--tab-content .cds--list-box__menu-item--active:hover{background-color:var(--cds-layer-selected-hover-02,#d1d1d1)}.cds--tabs--vertical~.cds--tab-content .cds--number-input--fluid .cds--number__control-btn:hover:after,.cds--tabs--vertical~.cds--tab-content .cds--number-input--fluid .cds--number__control-btn:hover:before{background-color:var(--cds-field-hover)}.cds--tabs--vertical~.cds--tab-content .cds--number-input--fluid .cds--number__control-btn:focus:after,.cds--tabs--vertical~.cds--tab-content .cds--number-input--fluid .cds--number__control-btn:focus:before{border-inline-start:2px solid var(--cds-focus,#0f62fe)}@media (min-width:66rem){.cds--tabs--vertical~.cds--tab-content{grid-column:5/-1}}.cds--tab-content--interactive:focus{outline:none}.cds--tabs.cds--skeleton{cursor:default;pointer-events:none}.cds--skeleton.cds--tabs:not(.cds--tabs--contained) .cds--tabs__nav-link{border-block-end:2px solid var(--cds-skeleton-element,#c6c6c6)}.cds--tabs.cds--skeleton .cds--tabs__nav-link{align-items:center;block-size:100%;display:flex;inline-size:10rem;padding:0 var(--cds-layout-density-padding-inline-local)}.cds--tabs.cds--skeleton .cds--tabs__nav-link span{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;display:block;inline-size:100%;padding:0;pointer-events:none;position:relative}.cds--tabs.cds--skeleton .cds--tabs__nav-link span:active,.cds--tabs.cds--skeleton .cds--tabs__nav-link span:focus,.cds--tabs.cds--skeleton .cds--tabs__nav-link span:hover{border:none;cursor:default;outline:none}.cds--tabs.cds--skeleton .cds--tabs__nav-link span:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--tabs.cds--skeleton .cds--tabs__nav-link span:before{animation:none}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--tabs__nav-item .cds--tabs__nav-item--selected .cds--tabs__nav-item--selected{color:Highlight;outline:1px solid Highlight}}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--tabs .cds--tabs__nav-item--disabled .cds--tabs__nav-link,:host(cds-tabs) .cds--tabs__nav-item--disabled .cds--tabs__nav-link,:host(cds-tabs-skeleton) .cds--tabs__nav-item--disabled .cds--tabs__nav-link{color:GrayText;fill:GrayText}}:host(cds-tabs) .cds--tabs-nav-content-container,:host(cds-tabs-skeleton) .cds--tabs-nav-content-container{block-size:2.5rem;flex:1 1 0%;overflow:scroll;position:relative;scrollbar-width:none}:host(cds-tabs) .cds--tabs-nav-content-container::-webkit-scrollbar,:host(cds-tabs-skeleton) .cds--tabs-nav-content-container::-webkit-scrollbar{display:none}:host(cds-tabs) :where(.cds--tabs-nav-content),:host(cds-tabs-skeleton) :where(.cds--tabs-nav-content){block-size:100%;inset-inline-start:0;position:absolute;transition:inset .11s cubic-bezier(.2,0,.38,.9)}:host(cds-tabs) .cds--tabs-nav,:host(cds-tabs-skeleton) .cds--tabs-nav{display:block;position:absolute}:host(cds-tabs) .cds--tab--overflow-nav-button,:host(cds-tabs-skeleton) .cds--tab--overflow-nav-button{z-index:1}:host(cds-tabs){outline:2px solid transparent;outline-offset:-2px}:host(cds-tabs) .cds--tabs-trigger svg{block-size:auto;inline-size:auto}:host(cds-tabs:focus) .cds--tabs-trigger{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){:host(cds-tabs:focus) .cds--tabs-trigger{outline-style:dotted}}:host(cds-tab){background:transparent;display:flex;inline-size:100%;outline:none}:host(cds-tab) .cds--tabs__nav-link{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:2px solid var(--cds-border-subtle);box-sizing:border-box;color:var(--cds-text-secondary,#525252);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:2px solid transparent;outline-offset:-2px;overflow:hidden;padding:.75rem 1rem .5rem;text-align:start;text-decoration:none;text-overflow:ellipsis;transition:border 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline;white-space:nowrap}:host(cds-tab) .cds--tabs__nav-link *,:host(cds-tab) .cds--tabs__nav-link :after,:host(cds-tab) .cds--tabs__nav-link :before{box-sizing:inherit}:host(cds-tab) .cds--tabs__nav-link::-moz-focus-inner{border:0}:host(cds-tab) .cds--tabs__nav-link:active,:host(cds-tab) .cds--tabs__nav-link:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){:host(cds-tab) .cds--tabs__nav-link:active,:host(cds-tab) .cds--tabs__nav-link:focus{outline-style:dotted}}:host(cds-tab[selected]){background-color:transparent;display:flex;transition:color 70ms cubic-bezier(.2,0,.38,.9)}:host(cds-tab[selected]) .cds--tabs__nav-link{border-block-end:.125rem solid var(--cds-border-interactive,#0f62fe);font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572)}:host(cds-tab[selected]) .cds--tabs__nav-link,:host(cds-tab[selected]) .cds--tabs__nav-link:active,:host(cds-tab[selected]) .cds--tabs__nav-link:focus{color:var(--cds-text-primary,#161616)}:host(cds-tab[selected]):hover{background-color:transparent}:host(cds-tab:hover){background-color:transparent;box-shadow:0 -1px 0 var(--cds-background-hover,hsla(0,0%,55%,.12))}:host(cds-tab:hover) a.cds--tabs__nav-link{border-block-end:2px solid var(--cds-border-strong);color:var(--cds-text-primary,#161616)}:host(cds-tabs[type=contained]) .cds--tabs-nav-content-container{block-size:3rem}:host(cds-tab[type=contained]){background-color:var(--cds-layer-accent-01,#e0e0e0)}:host(cds-tab[type=contained]) a.cds--tabs__nav-link{block-size:3rem;line-height:2rem;padding:.5rem 1rem}:host(cds-tab[type=contained]) a.cds--tabs__nav-link,:host(cds-tab[type=contained]:hover) a.cds--tabs__nav-link{border-block-end:none;box-shadow:-.0625rem 0 0 0 var(--cds-border-strong)}:host(cds-tab[type=contained][hide-divider]) a.cds--tabs__nav-link{box-shadow:-.0625rem 0 0 0 transparent}:host(cds-tab[disabled][role]),:host(cds-tab[disabled][role]:hover){background-color:transparent;box-shadow:none;cursor:not-allowed;outline:none}:host(cds-tab[disabled][role]) .cds--tabs__nav-link,:host(cds-tab[disabled][role]:hover) .cds--tabs__nav-link{border-block-end:2px solid var(--cds-border-disabled,#c6c6c6);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none;pointer-events:none}:host(cds-tab[type=contained][disabled][role]) .cds--tabs__nav-link{background-color:var(--cds-button-disabled,#c6c6c6);border-block-end:none;color:var(--cds-text-on-color-disabled,#8d8d8d)}:host(cds-tab[type=contained][selected]),:host(cds-tab[type=contained][selected]:hover){background-color:var(--cds-layer-01,#f4f4f4)}:host(cds-tab[type=contained][selected]) .cds--tabs__nav-link,:host(cds-tab[type=contained][selected]:hover) .cds--tabs__nav-link{border-block-end:none;box-shadow:inset 0 .125rem 0 0 var(--cds-interactive,#0f62fe);line-height:2rem}:host(cds-tab[type=contained][selected]) .cds--tabs__nav-link:active,:host(cds-tab[type=contained][selected]) .cds--tabs__nav-link:focus,:host(cds-tab[type=contained][selected]:hover) .cds--tabs__nav-link:active,:host(cds-tab[type=contained][selected]:hover) .cds--tabs__nav-link:focus{box-shadow:none}:host(cds-tab[type=contained]:hover){background-color:var(--cds-layer-accent-hover)}:host(cds-tab[disabled][in-focus][selected]),:host(cds-tab[disabled][in-focus][selected]:hover),:host(cds-tab[disabled][selected]),:host(cds-tab[disabled][selected]:hover){background-color:transparent;box-shadow:none;display:flex;outline:2px solid transparent;outline-offset:-2px}:host(cds-tab[disabled][in-focus][selected]) .cds--tabs__nav-link,:host(cds-tab[disabled][in-focus][selected]:hover) .cds--tabs__nav-link,:host(cds-tab[disabled][selected]) .cds--tabs__nav-link,:host(cds-tab[disabled][selected]:hover) .cds--tabs__nav-link{border-block-end:2px solid var(--cds-border-disabled,#c6c6c6);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);line-height:var(--cds-body-short-01-line-height,1.28572)}:host(cds-tab[disabled][in-focus][selected]) .cds--tabs__nav-link:active,:host(cds-tab[disabled][in-focus][selected]) .cds--tabs__nav-link:focus,:host(cds-tab[disabled][in-focus][selected]:hover) .cds--tabs__nav-link:active,:host(cds-tab[disabled][in-focus][selected]:hover) .cds--tabs__nav-link:focus,:host(cds-tab[disabled][selected]) .cds--tabs__nav-link:active,:host(cds-tab[disabled][selected]) .cds--tabs__nav-link:focus,:host(cds-tab[disabled][selected]:hover) .cds--tabs__nav-link:active,:host(cds-tab[disabled][selected]:hover) .cds--tabs__nav-link:focus{border-block-end-width:3px}:host(cds-tabs-skeleton) .cds--tabs-trigger{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:6.25rem;padding:0;pointer-events:none;position:relative}:host(cds-tabs-skeleton) .cds--tabs-trigger:active,:host(cds-tabs-skeleton) .cds--tabs-trigger:focus,:host(cds-tabs-skeleton) .cds--tabs-trigger:hover{border:none;cursor:default;outline:none}:host(cds-tabs-skeleton) .cds--tabs-trigger:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){:host(cds-tabs-skeleton) .cds--tabs-trigger:before{animation:none}}:host(cds-tab-skeleton){margin-inline-start:.125rem}:host(cds-tab-skeleton) .cds--tabs__nav-link{background:var(--cds-skeleton-background,#e8e8e8);block-size:.75rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}:host(cds-tab-skeleton) .cds--tabs__nav-link:active,:host(cds-tab-skeleton) .cds--tabs__nav-link:focus,:host(cds-tab-skeleton) .cds--tabs__nav-link:hover{border:none;cursor:default;outline:none}:host(cds-tab-skeleton) .cds--tabs__nav-link:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){:host(cds-tab-skeleton) .cds--tabs__nav-link:before{animation:none}}:host(cds-tab-skeleton:first-of-type){margin-inline-start:0}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i8csq":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTabSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _tabsScssJs = require("./tabs.scss.js");
var _tabsScssJsDefault = parcelHelpers.interopDefault(_tabsScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of tab.
 */ let CDSTabSkeleton = class CDSTabSkeleton extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)` <div class="${0, _settingsJs.prefix}--tabs__nav-link"></div> `;
    }
};
CDSTabSkeleton.styles = (0, _tabsScssJsDefault.default);
CDSTabSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-tab-skeleton`)
], CDSTabSkeleton);
var CDSTabSkeleton$1 = CDSTabSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./tabs.scss.js":"jJqqz","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9RpfS":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTabsSkeleton$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _tabsScssJs = require("./tabs.scss.js");
var _tabsScssJsDefault = parcelHelpers.interopDefault(_tabsScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Skeleton of tabs.
 */ let CDSTabsSkeleton = class CDSTabsSkeleton extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)`
      <div class="${0, _settingsJs.prefix}--tabs-trigger">
        <span class="${0, _settingsJs.prefix}--tabs-trigger-text"></span>
      </div>
      <ul class="${0, _settingsJs.prefix}--tabs__nav">
        <slot></slot>
      </ul>
    `;
    }
};
CDSTabsSkeleton.styles = (0, _tabsScssJsDefault.default);
CDSTabsSkeleton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-tabs-skeleton`)
], CDSTabsSkeleton);
var CDSTabsSkeleton$1 = CDSTabsSkeleton;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./tabs.scss.js":"jJqqz","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8kUeq":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _clickableTileJs = require("./clickable-tile.js");
var _expandableTileJs = require("./expandable-tile.js");
var _radioTileJs = require("./radio-tile.js");
var _selectableTileJs = require("./selectable-tile.js");
var _tileJs = require("./tile.js");
var _tileGroupJs = require("./tile-group.js");

},{"./clickable-tile.js":"g7Wfx","./expandable-tile.js":"47b2T","./radio-tile.js":"02vAW","./selectable-tile.js":"da87J","./tile.js":"acBO1","./tile-group.js":"gLdAp"}],"g7Wfx":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSClickableTile$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _classMapJs = require("lit/directives/class-map.js");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _linkJs = require("../link/link.js");
var _linkJsDefault = parcelHelpers.interopDefault(_linkJs);
var _sharedEnumsJs = require("../../globals/shared-enums.js");
var _tileScssJs = require("./tile.scss.js");
var _tileScssJsDefault = parcelHelpers.interopDefault(_tileScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ // To Do: Replace with an an icon from `@carbon/icons`
// since the hollow AI Label in `ClickableTile` is not interactive
const aiLabelIcon = (0, _lit.html)` <svg
  class="${(0, _settingsJs.prefix)}--tile--slug-icon"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" y="0.5" width="23" height="23" />
  <path
    d="M13.2436 16H11.5996L10.9276 13.864H7.95164L7.29164 16H5.68364L8.49164 7.624H10.4596L13.2436 16ZM10.5436 12.508L9.46364 9.064H9.40364L8.33564 12.508H10.5436ZM17.9341 16H14.1301V14.728H15.2341V8.896H14.1301V7.624H17.9341V8.896H16.8181V14.728H17.9341V16Z"
    fill="#161616" />
</svg>`;
/**
 * Clickable tile.
 *
 * @element cds-clickable-tile
 */ let CDSClickableTile = class CDSClickableTile extends (0, _linkJsDefault.default) {
    constructor(){
        super(...arguments);
        /**
         * The color scheme.
         */ this.colorScheme = (0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME).REGULAR;
        /**
         * The a11y role for `<a>`.
         */ this.linkRole = "button";
        /**
         * Specify if the `ClickableTile` component should be rendered with rounded corners.
         * Only valid when `ai-label` prop is present
         */ this.hasRoundedCorners = false;
        this.aiLabel = false;
        /**
         * deprecated - remove in v12
         */ this.slug = false;
    }
    get _classes() {
        const { colorScheme, disabled, hasRoundedCorners, aiLabel, slug } = this;
        return (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--link`]: true,
            [`${0, _settingsJs.prefix}--link--disabled`]: disabled,
            [`${0, _settingsJs.prefix}--tile`]: true,
            [`${0, _settingsJs.prefix}--tile--clickable`]: true,
            [`${0, _settingsJs.prefix}--tile--${colorScheme}`]: colorScheme,
            [`${0, _settingsJs.prefix}--tile--slug-rounded`]: (aiLabel || slug) && hasRoundedCorners
        });
    }
    /**
     * If using `slug`, set `ai-label` attribute to true so
     * the styles are applied for slug as well
     *
     * remove in v12
     */ connectedCallback() {
        if (this.slug) {
            this.setAttribute("ai-Label", "");
            this.aiLabel = true;
        }
        super.connectedCallback();
    }
    /**
     * @returns The inner content.
     */ _renderInner() {
        return (0, _lit.html)`
      ${super._renderInner()} ${this.aiLabel || this.slug ? aiLabelIcon : ""}
    `;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
};
CDSClickableTile.styles = (0, _tileScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "color-scheme",
        reflect: true
    })
], CDSClickableTile.prototype, "colorScheme", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "link-role"
    })
], CDSClickableTile.prototype, "linkRole", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "has-rounded-corners"
    })
], CDSClickableTile.prototype, "hasRoundedCorners", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSClickableTile.prototype, "aiLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], CDSClickableTile.prototype, "slug", void 0);
CDSClickableTile = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-clickable-tile`)
], CDSClickableTile);
var CDSClickableTile$1 = CDSClickableTile;

},{"tslib":"gBS4y","lit":"aCmte","lit/directives/class-map.js":"2fQud","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../link/link.js":"7peJx","../../globals/shared-enums.js":"12kea","./tile.scss.js":"qx4kR","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"qx4kR":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--tile-group html,:host(cds-tile-group) html{font-size:100%}.cds--tile-group body,:host(cds-tile-group) body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--tile-group code,:host(cds-tile-group) code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--tile-group strong,:host(cds-tile-group) strong{font-weight:600}.cds--tile,:host(cds-expandable-tile),:host(cds-tile){font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));background-color:var(--cds-layer);display:block;min-block-size:4rem;min-inline-size:8rem;outline:2px solid transparent;outline-offset:-2px;padding:var(--cds-layout-density-padding-inline-local);position:relative}.cds--tile:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--tile:focus{outline-style:dotted}}.cds--tile--light,:host(cds-expandable-tile[color-scheme=light]),:host(cds-tile[color-scheme=light]){background-color:var(--cds-layer-02,#fff)}.cds--tile--clickable,.cds--tile--selectable,:host(cds-clickable-tile) .cds--tile--clickable{border:0;box-sizing:border-box;cursor:pointer;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;padding:0;padding:var(--cds-layout-density-padding-inline-local);transition:.15s cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--tile--clickable *,.cds--tile--clickable :after,.cds--tile--clickable :before,.cds--tile--selectable *,.cds--tile--selectable :after,.cds--tile--selectable :before,:host(cds-clickable-tile) .cds--tile--clickable *,:host(cds-clickable-tile) .cds--tile--clickable :after,:host(cds-clickable-tile) .cds--tile--clickable :before{box-sizing:inherit}.cds--tile--clickable:hover,.cds--tile--selectable:hover{background:var(--cds-layer-hover)}.cds--tile--clickable,:host(cds-clickable-tile) .cds--tile--clickable{color:var(--cds-text-primary,#161616);text-decoration:none}.cds--tile--clickable:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;text-decoration:none}@media screen and (prefers-contrast){.cds--tile--clickable:focus{outline-style:dotted}}.cds--tile--clickable:focus .cds--tile__checkmark,.cds--tile--clickable:hover .cds--tile__checkmark{opacity:1}.cds--tile--expandable::-moz-focus-inner{border:0}.cds--tile--clickable:active,.cds--tile--clickable:hover,.cds--tile--clickable:visited,.cds--tile--clickable:visited:hover{color:var(--cds-text-primary,#161616);text-decoration:none}.cds--tile--clickable.cds--link--disabled,.cds--tile--clickable:hover.cds--link--disabled{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;display:block;padding:var(--cds-layout-density-padding-inline-local)}.cds--tile--clickable .cds--tile--icon,.cds--tile--clickable.cds--link--disabled .cds--tile--disabled-icon{inset-block-end:var(--cds-layout-density-padding-inline-local);inset-inline-end:var(--cds-layout-density-padding-inline-local);position:absolute}.cds--tile--clickable .cds--tile--icon{fill:var(--cds-icon-interactive,#0f62fe)}.cds--tile--clickable.cds--link--disabled .cds--tile--disabled-icon{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--tile--clickable.cds--link--disabled .cds--tile--icon{display:none}.cds--tile--selectable{border:1px solid transparent;padding-inline-end:calc(var(--cds-layout-density-padding-inline-local)*2 + 1rem)}.cds--tile__checkmark{background:transparent;block-size:1rem;border:none;inset-block-start:var(--cds-layout-density-padding-inline-local);inset-inline-end:var(--cds-layout-density-padding-inline-local);opacity:0;position:absolute;transition:.11s cubic-bezier(.2,0,.38,.9)}.cds--tile__checkmark svg{border-radius:50%;fill:var(--cds-icon-secondary,#525252)}.cds--tile__checkmark:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--tile__checkmark:focus{outline-style:dotted}}.cds--tile__checkmark--persistent{opacity:1}.cds--tile__chevron,:host(cds-selectable-tile) .cds--tile__chevron{align-items:center;block-size:calc(var(--cds-layout-density-padding-inline-local)*2 + 1rem);display:flex;inline-size:calc(var(--cds-layout-density-padding-inline-local)*2 + 1rem);inset-block-end:0;inset-inline-end:0;justify-content:center;position:absolute}.cds--tile__chevron svg,:host(cds-selectable-tile) .cds--tile__chevron svg{fill:var(--cds-icon-primary,#161616);transform-origin:center;transition:.11s cubic-bezier(.2,0,.38,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--tile__chevron svg,:host(cds-selectable-tile) .cds--tile__chevron svg{transition:none}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--tile__chevron svg,:host(cds-selectable-tile) .cds--tile__chevron svg{fill:ButtonText}}.cds--tile__chevron--interactive{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:calc(var(--cds-layout-density-padding-inline-local)*2 + 1rem);border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:calc(var(--cds-layout-density-padding-inline-local)*2 + 1rem);inset-block-end:0;inset-inline-end:0;justify-content:center;margin:0;padding:0;position:absolute;text-align:start;vertical-align:baseline}.cds--tile__chevron--interactive *,.cds--tile__chevron--interactive :after,.cds--tile__chevron--interactive :before{box-sizing:inherit}.cds--tile__chevron--interactive::-moz-focus-inner{border:0}.cds--tile__chevron--interactive:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}.cds--tile__chevron--interactive:hover{background-color:var(--cds-layer-hover);cursor:pointer}.cds--tile--expandable,:host(cds-expandable-tile){border:0;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:100%;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);overflow:hidden;position:relative;text-align:start;transition:max-height .15s cubic-bezier(.2,0,.38,.9)}.cds--tile--expandable:hover{background:var(--cds-layer-hover)}.cds--tile--expandable.cds--tile--expandable--interactive{border:none;cursor:default;transition:max-height .15s cubic-bezier(.2,0,.38,.9)}.cds--tile--expandable.cds--tile--expandable--interactive:hover{background-color:var(--cds-layer)}.cds--tile--expandable.cds--tile--expandable--interactive:focus{outline:none}.cds--tile--expandable--interactive:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--tile--expandable--interactive:focus{outline-style:dotted}}.cds--tile-content__below-the-fold,:host(cds-expandable-tile) ::slotted(cds-tile-below-the-fold-content){display:block;opacity:0;transition:opacity .11s cubic-bezier(.2,0,.38,.9),visibility .11s cubic-bezier(.2,0,.38,.9);visibility:hidden}.cds--tile--is-expanded,:host(cds-expandable-tile[expanded]){overflow:visible;transition:max-height .11s cubic-bezier(.2,0,.38,.9)}.cds--tile--is-expanded .cds--tile__chevron svg,:host(cds-expandable-tile[expanded]) .cds--tile__chevron svg{transform:rotate(180deg)}.cds--tile--is-expanded .cds--tile-content__below-the-fold,:host(cds-expandable-tile) .cds--tile--is-expanded ::slotted(cds-tile-below-the-fold-content),:host(cds-expandable-tile):host(cds-expandable-tile[expanded]) ::slotted(cds-tile-below-the-fold-content),:host(cds-expandable-tile[expanded]) .cds--tile-content__below-the-fold{opacity:1;transition:opacity .11s cubic-bezier(.2,0,.38,.9),visibility .11s cubic-bezier(.2,0,.38,.9);visibility:inherit}@media not all and (resolution >= 0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){.cds--tile--is-expanded .cds--tile-content__below-the-fold,:host(cds-expandable-tile) .cds--tile--is-expanded ::slotted(cds-tile-below-the-fold-content),:host(cds-expandable-tile):host(cds-expandable-tile[expanded]) ::slotted(cds-tile-below-the-fold-content),:host(cds-expandable-tile[expanded]) .cds--tile-content__below-the-fold{overflow-y:auto}}}.cds--tile--is-selected{border:1px solid var(--cds-layer-selected-inverse,#161616)}.cds--tile--is-selected .cds--tile__checkmark{opacity:1}.cds--tile--is-selected .cds--tile__checkmark svg{fill:var(--cds-icon-primary,#161616)}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.cds--tile--is-selected .cds--tile__checkmark svg{fill:ButtonText}}.cds--tile-content{block-size:100%;inline-size:100%}.cds--tile-input{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--tile-input:focus+.cds--tile,.cds--tile-input:focus+:host(cds-expandable-tile),.cds--tile-input:focus+:host(cds-tile){outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--tile-input:focus+.cds--tile,.cds--tile-input:focus+:host(cds-expandable-tile),.cds--tile-input:focus+:host(cds-tile){outline-style:dotted}}.cds--tile--disabled.cds--tile--selectable{background-color:var(--cds-layer);color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed}.cds--tile--disabled.cds--tile--selectable.cds--tile--light{background-color:var(--cds-layer-02,#fff)}.cds--tile--disabled.cds--tile--is-selected{border-color:var(--cds-border-disabled,#c6c6c6)}.cds--tile--disabled .cds--tile__checkmark svg{fill:var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--tile--clickable .cds--tile--ai-label-icon,.cds--tile--expandable>div>.cds--ai-label,.cds--tile--expandable>div>.cds--slug,.cds--tile--expandable>div>.cds--tile--inner-decorator>*,.cds--tile>.cds--ai-label,.cds--tile>.cds--slug,.cds--tile>.cds--tile--inner-decorator>*,:host(cds-expandable-tile)>.cds--ai-label,:host(cds-expandable-tile)>.cds--slug,:host(cds-expandable-tile)>.cds--tile--inner-decorator>*,:host(cds-expandable-tile)>div>.cds--ai-label,:host(cds-expandable-tile)>div>.cds--slug,:host(cds-expandable-tile)>div>.cds--tile--inner-decorator>*,:host(cds-tile)>.cds--ai-label,:host(cds-tile)>.cds--slug,:host(cds-tile)>.cds--tile--inner-decorator>*{inset-block-start:1rem;inset-inline-end:1rem;position:absolute}.cds--tile.cds--tile--selectable>.cds--ai-label,.cds--tile.cds--tile--selectable>.cds--slug,.cds--tile.cds--tile--selectable>.cds--tile--inner-decorator>*{inset-inline-end:2.5rem}.cds--tile.cds--tile--selectable.cds--tile--radio>.cds--ai-label,.cds--tile.cds--tile--selectable.cds--tile--radio>.cds--slug,.cds--tile.cds--tile--selectable.cds--tile--radio>.cds--tile--inner-decorator>*{inset-inline-end:1rem;transition:inset-inline-end .11s cubic-bezier(.2,0,.38,.9)}.cds--tile.cds--tile--selectable.cds--tile--radio.cds--tile--is-selected>.cds--ai-label,.cds--tile.cds--tile--selectable.cds--tile--radio.cds--tile--is-selected>.cds--slug,.cds--tile.cds--tile--selectable.cds--tile--radio.cds--tile--is-selected>.cds--tile--inner-decorator>*{inset-inline-end:2.5rem}.cds--tile.cds--tile--clickable>.cds--ai-label,.cds--tile.cds--tile--clickable>.cds--slug,.cds--tile.cds--tile--clickable>.cds--tile--inner-decorator>*{pointer-events:none}.cds--tile--decorator:has(.cds--ai-label).cds--tile,.cds--tile--decorator:has(.cds--tile--ai-label-icon).cds--tile,.cds--tile--slug.cds--tile{background:linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)) 0,var(--cds-ai-aura-start,rgba(69,137,255,.1)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%) padding-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) padding-box,linear-gradient(to bottom,var(--cds-ai-border-start,rgba(166,200,255,.64)),var(--cds-ai-border-end,#78a9ff)) border-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) border-box;border:1px solid transparent;box-shadow:inset 0 -80px 70px -65px var(--cds-ai-inner-shadow,rgba(69,137,255,.1)),0 4px 8px 0 var(--cds-ai-drop-shadow,rgba(15,98,254,.1))}.cds--tile--decorator:has(.cds--ai-label).cds--tile--expandable:hover,.cds--tile--slug.cds--tile--expandable:hover{background:linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)) 0,var(--cds-ai-aura-start,rgba(69,137,255,.1)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%) padding-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) padding-box,linear-gradient(to bottom,var(--cds-ai-border-start,rgba(166,200,255,.64)),var(--cds-ai-border-end,#78a9ff)) border-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) border-box}.cds--tile--decorator.cds--tile--clickable:before,.cds--tile--decorator.cds--tile--selectable:after,.cds--tile--decorator.cds--tile--selectable:before,.cds--tile--slug.cds--tile--clickable:before,.cds--tile--slug.cds--tile--selectable:after,.cds--tile--slug.cds--tile--selectable:before{block-size:100%;content:"";display:block;inline-size:100%;inset-block-start:0;inset-inline-start:0;opacity:0;position:absolute;transition:opacity .11s cubic-bezier(.2,0,.38,.9)}.cds--tile--decorator:has(.cds--ai-label).cds--tile--clickable:before,.cds--tile--decorator:has(.cds--ai-label).cds--tile--selectable:before,.cds--tile--slug.cds--tile--clickable:before,.cds--tile--slug.cds--tile--selectable:before{background:linear-gradient(to top,var(--cds-ai-aura-hover-start,rgba(69,137,255,.32)) 0,15%,var(--cds-ai-aura-hover-end,hsla(0,0%,100%,0)) 50%) padding-box,linear-gradient(to top,var(--cds-ai-aura-hover-background,#edf5ff),var(--cds-ai-aura-hover-background,#edf5ff)) padding-box,linear-gradient(to bottom,var(--cds-ai-border-start,rgba(166,200,255,.64)),var(--cds-ai-border-end,#78a9ff)) border-box,linear-gradient(to top,var(--cds-ai-aura-hover-background,#edf5ff),var(--cds-ai-aura-hover-background,#edf5ff)) border-box;box-shadow:inset 0 -80px 70px -65px var(--cds-ai-inner-shadow,rgba(69,137,255,.1)),0 4px 10px 2px var(--cds-ai-drop-shadow,rgba(15,98,254,.1))}.cds--tile--decorator.cds--tile--clickable:hover:before,.cds--tile--decorator.cds--tile--selectable:hover:before,.cds--tile--slug.cds--tile--clickable:hover:before,.cds--tile--slug.cds--tile--selectable:hover:before{opacity:1}.cds--tile--decorator.cds--tile--clickable:focus,.cds--tile--decorator.cds--tile--selectable:focus,.cds--tile--slug.cds--tile--clickable:focus,.cds--tile--slug.cds--tile--selectable:focus,.cds--tile-input:focus+.cds--tile--decorator.cds--tile,.cds--tile-input:focus+.cds--tile--slug.cds--tile{outline-offset:-1px}.cds--tile--decorator:has(.cds--tile--inner-decorator .cds--ai-label).cds--tile--selectable:after,.cds--tile--slug.cds--tile--selectable:after{background:linear-gradient(to top,var(--cds-ai-aura-start,rgba(69,137,255,.1)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%) padding-box,linear-gradient(to top,var(--cds-layer),var(--cds-layer)) padding-box,linear-gradient(to bottom,var(--cds-border-inverse,#161616),var(--cds-border-inverse,#161616)) border-box,linear-gradient(to top,var(--cds-layer),var(--cds-layer)) border-box;box-shadow:inset 0 -80px 70px -65px var(--cds-ai-inner-shadow,rgba(69,137,255,.1)),0 4px 8px 0 var(--cds-ai-drop-shadow,rgba(15,98,254,.1))}.cds--tile--decorator.cds--tile--selectable:hover:after,.cds--tile--slug.cds--tile--selectable:hover:after{opacity:0}.cds--tile--decorator.cds--tile--is-selected:after,.cds--tile--slug.cds--tile--is-selected:after{opacity:1}.cds--tile--decorator:has(.cds--tile--inner-decorator).cds--tile--is-selected,.cds--tile--slug.cds--tile--is-selected{border-color:var(--cds-border-inverse,#161616)}.cds--tile--decorator.cds--tile--clickable .cds--tile-content,.cds--tile--decorator.cds--tile--selectable .cds--tile-content,.cds--tile--slug.cds--tile--clickable .cds--tile-content,.cds--tile--slug.cds--tile--selectable .cds--tile-content{cursor:pointer;position:relative}.cds--tile--decorator.cds--tile--clickable .cds--tile-content,.cds--tile--decorator.cds--tile--is-selected .cds--tile--inner-decorator>*,.cds--tile--decorator.cds--tile--selectable .cds--tile-content,.cds--tile--decorator.cds--tile--selectable>.cds--tile__checkmark,.cds--tile--slug.cds--tile--clickable .cds--tile-content,.cds--tile--slug.cds--tile--is-selected .cds--ai-label,.cds--tile--slug.cds--tile--is-selected .cds--slug,.cds--tile--slug.cds--tile--selectable .cds--tile-content,.cds--tile--slug.cds--tile--selectable>.cds--tile__checkmark{z-index:1}.cds--tile--decorator.cds--tile--selectable .cds--tile--inner-decorator>:has(>.cds--popover--open),.cds--tile--slug.cds--tile--selectable .cds--ai-label:has(>.cds--popover--open),.cds--tile--slug.cds--tile--selectable .cds--slug:has(>.cds--popover--open){z-index:2}.cds--tile--decorator.cds--tile--selectable>.cds--tile--inner-decorator>*,.cds--tile--decorator.cds--tile--selectable>.cds--tile__checkmark,.cds--tile--slug.cds--tile--selectable>.cds--ai-label,.cds--tile--slug.cds--tile--selectable>.cds--slug,.cds--tile--slug.cds--tile--selectable>.cds--tile__checkmark{z-index:1}.cds--tile--expandable:has(.cds--ai-label>.cds--popover--open),.cds--tile--expandable:has(.cds--slug>.cds--popover--open),.cds--tile--expandable:has(.cds--tile--inner-decorator>*>.cds--popover--open),:has(.cds--ai-label>.cds--popover--open):host(cds-expandable-tile),:has(.cds--slug>.cds--popover--open):host(cds-expandable-tile),:has(.cds--tile--inner-decorator>*>.cds--popover--open):host(cds-expandable-tile){overflow:visible}.cds--tile--clickable .cds--tile--ai-label-icon rect{stroke:var(--cds-icon-primary,#161616)}.cds--tile--clickable .cds--tile--ai-label-icon path{fill:var(--cds-icon-primary,#161616)}.cds--tile--decorator-rounded,.cds--tile--decorator-rounded.cds--tile--clickable:before,.cds--tile--decorator-rounded.cds--tile--selectable:after,.cds--tile--decorator-rounded.cds--tile--selectable:before,.cds--tile--slug-rounded,.cds--tile--slug-rounded.cds--tile--clickable:before,.cds--tile--slug-rounded.cds--tile--selectable:after,.cds--tile--slug-rounded.cds--tile--selectable:before,:host(cds-clickable-tile[ai-label][has-rounded-corners]),:host(cds-expandable-tile[ai-label][has-rounded-corners]),:host(cds-selectable-tile[ai-label][has-rounded-corners]),:host(cds-tile[ai-label][has-rounded-corners]){border-radius:.5rem}.cds--tile--decorator-rounded .cds--tile__chevron,.cds--tile--slug-rounded .cds--tile__chevron,:host(cds-clickable-tile[ai-label][has-rounded-corners]) .cds--tile__chevron,:host(cds-expandable-tile[ai-label][has-rounded-corners]) .cds--tile__chevron,:host(cds-selectable-tile[ai-label][has-rounded-corners]) .cds--tile__chevron,:host(cds-tile[ai-label][has-rounded-corners]) .cds--tile__chevron{border-end-end-radius:.5rem}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--tile--is-selected .cds--tile__checkmark svg,.cds--tile__checkmark svg,.cds--tile__chevron svg,:host(cds-selectable-tile) .cds--tile__chevron svg{fill:ButtonText}}.cds--link,:host(cds-tile) ::slotted(.cds--link){border:0;box-sizing:border-box;color:var(--cds-link-text-color,var(--cds-link-primary,#0f62fe));display:inline-flex;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;outline:none;padding:0;text-decoration:none;transition:color 70ms cubic-bezier(.2,0,.38,.9);vertical-align:baseline}.cds--link *,.cds--link :after,.cds--link :before,:host(cds-tile) ::slotted(.cds--link) *,:host(cds-tile) ::slotted(.cds--link) :after,:host(cds-tile) ::slotted(.cds--link) :before{box-sizing:inherit}.cds--link:hover,:host(cds-tile) :hover::slotted(.cds--link){color:var(--cds-link-hover-text-color,var(--cds-link-primary-hover,#0043ce));text-decoration:underline}.cds--link:active,.cds--link:active:visited,.cds--link:active:visited:hover,:host(cds-tile) :active::slotted(.cds--link){color:var(--cds-link-text-color,var(--cds-link-primary,#0f62fe));outline:1px solid var(--cds-focus,#0f62fe);outline-color:var(--cds-link-focus-text-color,var(--cds-focus,#0f62fe));text-decoration:underline}@media screen and (prefers-contrast){.cds--link:active,.cds--link:active:visited,.cds--link:active:visited:hover,:host(cds-tile) :active::slotted(.cds--link){outline-style:dotted}}.cds--link:focus,:host(cds-tile) :focus::slotted(.cds--link){outline:1px solid var(--cds-focus,#0f62fe);outline-color:var(--cds-link-focus-text-color,var(--cds-focus,#0f62fe));text-decoration:underline}@media screen and (prefers-contrast){.cds--link:focus,:host(cds-tile) :focus::slotted(.cds--link){outline-style:dotted}}.cds--link:visited,:host(cds-tile) :visited::slotted(.cds--link){color:var(--cds-link-text-color,var(--cds-link-primary,#0f62fe))}.cds--link:visited:hover,:host(cds-tile) :visited:hover::slotted(.cds--link){color:var(--cds-link-hover-text-color,var(--cds-link-primary-hover,#0043ce))}.cds--link--disabled,.cds--link--disabled:hover{border:0;box-sizing:border-box;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));cursor:not-allowed;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;padding:0;text-decoration:none;vertical-align:baseline}.cds--link--disabled *,.cds--link--disabled :after,.cds--link--disabled :before,.cds--link--disabled:hover *,.cds--link--disabled:hover :after,.cds--link--disabled:hover :before{box-sizing:inherit}.cds--link.cds--link--visited:visited,:host(cds-tile) .cds--link--visited:visited::slotted(.cds--link){color:var(--cds-link-visited-text-color,var(--cds-link-visited,#8a3ffc))}.cds--link.cds--link--visited:visited:hover,:host(cds-tile) .cds--link--visited:visited:hover::slotted(.cds--link){color:var(--cds-link-hover-text-color,var(--cds-link-primary-hover,#0043ce))}.cds--link.cds--link--inline,:host(cds-tile) .cds--link--inline::slotted(.cds--link){display:inline;text-decoration:underline}.cds--link--disabled.cds--link--inline{text-decoration:underline}.cds--link--sm,.cds--link--sm.cds--link--disabled:hover{font-size:var(--cds-helper-text-01-font-size,.75rem);letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333)}.cds--link--lg,.cds--link--lg.cds--link--disabled:hover{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375)}.cds--link__icon{align-self:center;display:inline-flex;margin-inline-start:.5rem}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{box-shadow:0 0 0 1000px var(--cds-field) inset;-webkit-text-fill-color:var(--cds-text-primary,#161616)}.cds--fieldset{border:0;box-sizing:border-box;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--fieldset *,.cds--fieldset :after,.cds--fieldset :before{box-sizing:inherit}.cds--form-item{align-items:flex-start;display:flex;flex:1 1 auto;flex-direction:column;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--label{color:var(--cds-text-secondary,#525252);display:inline-block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);font-weight:400;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);line-height:1rem;margin-block-end:.5rem;vertical-align:baseline}.cds--label html{font-size:100%}.cds--label body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--label code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--label strong{font-weight:600}.cds--label .cds--toggletip-label{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333)}.cds--label--no-margin{margin-block-end:0}.cds--label+.cds--tooltip{inset-block-start:.2rem;inset-inline-start:.5rem;position:relative}.cds--label+.cds--tooltip .cds--tooltip__trigger{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);inline-size:100%;justify-content:center;letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--label+.cds--tooltip .cds--tooltip__trigger *,.cds--label+.cds--tooltip .cds--tooltip__trigger :after,.cds--label+.cds--tooltip .cds--tooltip__trigger :before{box-sizing:inherit}.cds--label+.cds--tooltip .cds--tooltip__trigger::-moz-focus-inner{border:0}.cds--label+.cds--tooltip .cds--tooltip__trigger:focus{outline:1px solid var(--cds-focus,#0f62fe)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252)}.cds--label+.cds--tooltip .cds--tooltip__trigger svg :hover{fill:var(--cds-icon-primary,#161616)}.cds--label+.cds--toggletip{inset-block-start:.2rem;inset-inline-start:.5rem}.cds--label.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);block-size:.875rem;border:none;box-shadow:none;inline-size:4.6875rem;padding:0;pointer-events:none;position:relative}.cds--label.cds--skeleton:active,.cds--label.cds--skeleton:focus,.cds--label.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--label.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--label.cds--skeleton:before{animation:none}}input[type=number]{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif}.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-error,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus),.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,.cds--combo-box--invalid--focused),.cds--number[data-invalid] input[type=number]:not(:focus),.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),.cds--text-area__wrapper[data-invalid]>.cds--text-area--invalid:not(:focus),.cds--text-input__field-wrapper[data-invalid]>.cds--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper--warn~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box--warning~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--number__input-wrapper--warning~.cds--form-requirement,.cds--select--warning .cds--select-input__wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper--warn~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper--warning>.cds--text-input~.cds--form-requirement,.cds--text-input__field-wrapper--warning~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker--warning~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{display:block;font-weight:400;max-block-size:12.5rem;overflow:visible}.cds--date-picker-input__wrapper--invalid~.cds--form-requirement,.cds--date-picker-input__wrapper~.cds--form-requirement,.cds--list-box[data-invalid]~.cds--form-requirement,.cds--number[data-invalid] .cds--number__input-wrapper~.cds--form-requirement,.cds--select-input__wrapper[data-invalid]~.cds--form-requirement,.cds--text-area__wrapper[data-invalid]~.cds--form-requirement,.cds--text-input__field-wrapper[data-invalid]~.cds--form-requirement,.cds--time-picker--invalid~.cds--form-requirement,.cds--time-picker[data-invalid]~.cds--form-requirement,input[data-invalid]~.cds--form-requirement{color:var(--cds-text-error,#da1e28)}.cds--form--fluid .cds--text-input__field-wrapper--warning,.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]{display:block}.cds--form--fluid input[data-invalid]{outline:none}.cds--form--fluid .cds--form-requirement{margin:0;padding:.5rem 2.5rem .5rem 1rem}input:not(output,[data-invalid]):-moz-ui-invalid{box-shadow:none}.cds--form-requirement{display:none;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin:.25rem 0 0;max-block-size:0;overflow:hidden}.cds--form-requirement html{font-size:100%}.cds--form-requirement body{font-family:IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,sans-serif;font-weight:400;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}.cds--form-requirement code{font-family:IBM Plex Mono,system-ui,-apple-system,BlinkMacSystemFont,\\.SFNSText-Regular,monospace}.cds--form-requirement strong{font-weight:600}.cds--select--inline .cds--form__helper-text{margin-block-start:0}.cds--form__helper-text{color:var(--cds-text-secondary,#525252);font-size:var(--cds-helper-text-01-font-size,.75rem);inline-size:100%;letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);line-height:var(--cds-helper-text-01-line-height,1.33333);margin-block-start:.25rem;opacity:1;z-index:0}.cds--form__helper-text--disabled,.cds--label--disabled,fieldset[disabled] .cds--form__helper-text,fieldset[disabled] .cds--label{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}:host(cds-tile){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}:host(cds-tile-group){background:transparent}:host(cds-tile-group) fieldset{border:none}:host(cds-clickable-tile){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;display:grid;outline:none}:host(cds-clickable-tile) .cds--link--disabled{display:block}:host(cds-clickable-tile) .cds--tile,:host(cds-clickable-tile) :host(cds-expandable-tile),:host(cds-clickable-tile) :host(cds-tile){outline:.125rem solid transparent;padding:1rem}:host(cds-clickable-tile) .cds--tile--clickable{display:block;transition:.15s cubic-bezier(.2,0,.38,.9)}:host(cds-clickable-tile) .cds--tile--clickable:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){:host(cds-clickable-tile) .cds--tile--clickable:focus{outline-style:dotted}}:host(cds-clickable-tile):hover .cds--tile--clickable{color:inherit}:host(cds-clickable-tile) ::slotted(cds-ai-label),:host(cds-clickable-tile) ::slotted(cds-slug){pointer-events:none}:host(cds-radio-tile){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;display:block;margin-block-end:.5rem;outline:none}:host(cds-selectable-tile){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px;display:content;outline:none;position:relative}:host(cds-radio-tile) .cds--tile-input:checked~.cds--tile--selectable .cds--tile__checkmark,:host(cds-selectable-tile) .cds--tile-input:checked~.cds--tile--selectable .cds--tile__checkmark{opacity:1}:host(cds-clickable-tile) ::slotted(*),:host(cds-selectable-tile) ::slotted(*){cursor:pointer;position:relative;z-index:1}:host(cds-expandable-tile){--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}:host(cds-expandable-tile) .cds-ce--expandable-tile--below-the-fold-content{max-block-size:0;transition:max-height .11s cubic-bezier(.2,0,.38,.9)}:host(cds-expandable-tile[expanded]) ::slotted(cds-tile-below-the-fold-content){opacity:1;transition:.11s cubic-bezier(.2,0,.38,.9);visibility:visible}:host(cds-expandable-tile[with-interactive]){cursor:default;transition:max-height .15s cubic-bezier(.2,0,.38,.9)}:host(cds-expandable-tile[with-interactive]):hover{background-color:var(--cds-layer)}:host(cds-expandable-tile[with-interactive]):focus{outline:none}:host(cds-expandable-tile:not([with-interactive])) .cds--tile__chevron{background:none;border:none;cursor:pointer;outline:none}:host(cds-clickable-tile[ai-label]) .cds--tile,:host(cds-clickable-tile[ai-label]) :host(cds-expandable-tile),:host(cds-clickable-tile[ai-label]) :host(cds-tile),:host(cds-expandable-tile[ai-label]),:host(cds-selectable-tile[ai-label]) .cds--tile,:host(cds-selectable-tile[ai-label]) :host(cds-expandable-tile),:host(cds-selectable-tile[ai-label]) :host(cds-tile),:host(cds-tile[ai-label]){background:linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)) 0,var(--cds-ai-aura-start,rgba(69,137,255,.1)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%) padding-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) padding-box,linear-gradient(to bottom,var(--cds-ai-border-start,rgba(166,200,255,.64)),var(--cds-ai-border-end,#78a9ff)) border-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) border-box;border:1px solid transparent;box-shadow:inset 0 -80px 70px -65px var(--cds-ai-inner-shadow,rgba(69,137,255,.1)),0 24px 40px -24px var(--cds-ai-drop-shadow,rgba(15,98,254,.1))}:host(cds-clickable-tile) ::slotted(cds-ai-label),:host(cds-clickable-tile) ::slotted(cds-slug),:host(cds-expandable-tile) ::slotted(cds-ai-label),:host(cds-expandable-tile) ::slotted(cds-slug),:host(cds-selectable-tile) ::slotted(cds-ai-label),:host(cds-selectable-tile) ::slotted(cds-slug),:host(cds-tile) ::slotted(cds-ai-label),:host(cds-tile) ::slotted(cds-slug){inset-block-start:1rem;inset-inline-end:1rem;position:absolute}:host(cds-selectable-tile) ::slotted(cds-ai-label),:host(cds-selectable-tile) ::slotted(cds-slug){inset-inline-end:2.5rem}:host(cds-expandable-tile[ai-label]):hover{background:linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)) 0,var(--cds-ai-aura-start,rgba(69,137,255,.1)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%) padding-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) padding-box,linear-gradient(to bottom,var(--cds-ai-border-start,rgba(166,200,255,.64)),var(--cds-ai-border-end,#78a9ff)) border-box,linear-gradient(to top,var(--cds-layer,var(--cds-ai-popover-background,#fff)),var(--cds-layer,var(--cds-ai-popover-background,#fff))) border-box}:host(cds-clickable-tile[ai-label]) .cds--tile:before,:host(cds-selectable-tile[ai-label]) .cds--tile:after,:host(cds-selectable-tile[ai-label]) .cds--tile:before{block-size:100%;content:"";display:block;inline-size:100%;inset-block-start:0;inset-inline-start:0;opacity:0;position:absolute;transition:opacity .11s cubic-bezier(.2,0,.38,.9)}:host(cds-clickable-tile[ai-label]) .cds--tile:before,:host(cds-selectable-tile[ai-label]) .cds--tile:before{background:linear-gradient(to top,var(--cds-ai-aura-hover-start,rgba(69,137,255,.32)) 0,15%,var(--cds-ai-aura-hover-end,hsla(0,0%,100%,0)) 50%) padding-box,linear-gradient(to top,var(--cds-ai-aura-hover-background,#edf5ff),var(--cds-ai-aura-hover-background,#edf5ff)) padding-box,linear-gradient(to bottom,var(--cds-ai-border-start,rgba(166,200,255,.64)),var(--cds-ai-border-end,#78a9ff)) border-box,linear-gradient(to top,var(--cds-ai-aura-hover-background,#edf5ff),var(--cds-ai-aura-hover-background,#edf5ff)) border-box;box-shadow:inset 0 -80px 70px -65px var(--cds-ai-inner-shadow,rgba(69,137,255,.1))}:host(cds-clickable-tile[ai-label]) .cds--tile:hover:before,:host(cds-selectable-tile[ai-label]) .cds--tile:hover:before{opacity:1}:host(cds-selectable-tile[ai-label]) .cds--tile--is-selected{border:1px solid var(--cds-layer-selected-inverse,#161616)}:host(cds-selectable-tile[ai-label]) .cds--tile--is-selected .cds--tile__checkmark{z-index:1}:host(cds-selectable-tile[ai-label]) .cds--tile--is-selected:after{background:linear-gradient(to top,var(--cds-ai-aura-start,rgba(69,137,255,.1)) 0,15%,var(--cds-ai-aura-end,hsla(0,0%,100%,0)) 50%) padding-box,linear-gradient(to top,var(--cds-layer),var(--cds-layer)) padding-box,linear-gradient(to bottom,var(--cds-border-inverse,#161616),var(--cds-border-inverse,#161616)) border-box,linear-gradient(to top,var(--cds-layer),var(--cds-layer)) border-box;box-shadow:inset 0 -80px 70px -65px var(--cds-ai-inner-shadow,rgba(69,137,255,.1))}:host(cds-expandable-tile[ai-label]){overflow:visible}:host(cds-clickable-tile[ai-label][has-rounded-corners]) .cds--tile__chevron,:host(cds-expandable-tile[ai-label][has-rounded-corners]) .cds--tile__chevron,:host(cds-selectable-tile[ai-label][has-rounded-corners]) .cds--tile__chevron,:host(cds-tile[ai-label][has-rounded-corners]) .cds--tile__chevron{border-end-end-radius:.5rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"47b2T":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSExpandableTile$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _16Js = require("../../icons/chevron--down/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _settingsJs = require("../../globals/settings.js");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _sharedEnumsJs = require("../../globals/shared-enums.js");
var _tileScssJs = require("./tile.scss.js");
var _tileScssJsDefault = parcelHelpers.interopDefault(_tileScssJs);
var _classMapJs = require("lit/directives/class-map.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Expandable tile.
 *
 * @element cds-expandable-tile
 * @fires cds-expandable-tile-beingtoggled
 *   The custom event fired before the expanded state is changed upon a user gesture.
 *   Cancellation of this event stops changing the user-initiated change in expanded state.
 * @fires cds-expandable-tile-toggled - The custom event fired after a the expanded state is changed upon a user gesture.
 */ let CDSExpandableTile = class CDSExpandableTile extends (0, _hostListenerJsDefault1.default)((0, _focusJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * The computed height of the below-the-fold content.
         */ this._belowTheContentHeight = 0;
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
        this._handleClick = ()=>{
            if (!this.withInteractive) this._handleExpand();
        };
        /**
         * The color scheme.
         */ this.colorScheme = (0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME).REGULAR;
        /**
         * `true` to expand this expandable tile.
         */ this.expanded = false;
        /**
         * Specify if the `ExpandableTile` component should be rendered with rounded corners.
         * Only valid when `ai-label` prop is present
         */ this.hasRoundedCorners = false;
        /**
         * `true` to expand this expandable tile.
         */ this.withInteractive = false;
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>{
            var _a, _b;
            return elem.matches !== undefined ? elem.matches((_a = this.constructor) === null || _a === void 0 ? void 0 : _a.aiLabelItem) || // remove reference of slug in v12
            elem.matches((_b = this.constructor) === null || _b === void 0 ? void 0 : _b.slugItem) : false;
        });
        if (hasContent.length > 0) {
            this._hasAILabel = Boolean(hasContent);
            hasContent[0].setAttribute("size", "xs");
        }
        this.requestUpdate();
    }
    /**
     * Handles `slotchange` event on the below-the-fold content.
     *
     * @param event The event.
     */ _handleSlotChangeBelowTheFoldContent(event) {
        this._belowTheContentHeight = event.target.assignedNodes().reduce((acc, item)=>{
            var _a;
            return acc + ((_a = item.offsetHeight) !== null && _a !== void 0 ? _a : 0);
        }, 0);
        if (!this._belowTheContentHeight) {
            const element = getComputedStyle(this.querySelector("cds-tile-below-the-fold-content"));
            this._belowTheContentHeight = parseInt(element.height, 10);
        }
        this.requestUpdate();
    }
    _handleExpand() {
        const expanded = !this.expanded;
        this.focus();
        const init = {
            bubbles: true,
            composed: true,
            detail: {
                expanded
            }
        };
        const constructor = this.constructor;
        const beforeChangeEvent = new CustomEvent(constructor.eventBeforeToggle, Object.assign(Object.assign({}, init), {
            cancelable: true
        }));
        if (this.dispatchEvent(beforeChangeEvent)) {
            this.expanded = expanded;
            const afterChangeEvent = new CustomEvent(constructor.eventToggle, init);
            this.dispatchEvent(afterChangeEvent);
        }
    }
    updated() {
        if (this._hasAILabel) this.setAttribute("ai-label", "");
        else this.removeAttribute("ai-label");
    }
    render() {
        const { expanded, withInteractive, _belowTheContentHeight: belowTheContentHeight, _handleSlotChangeBelowTheFoldContent: handleSlotChangeBelowTheFoldContent } = this;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--tile__chevron`]: true,
            [`${0, _settingsJs.prefix}--tile__chevron--interactive`]: withInteractive
        });
        return (0, _lit.html)`
      <button
        class="${classes}"
        aria-labelledby="above-the-fold-content"
        aria-controls="below-the-fold-content"
        tabindex="0"
        @click="${withInteractive ? this._handleExpand : ""}"
        aria-expanded="${String(Boolean(expanded))}">
        ${(0, _16JsDefault.default)({
            id: "icon"
        })}
      </button>
      <slot name="ai-label" @slotchange="${this._handleSlotChange}"></slot>
      <slot name="slug" @slotchange="${this._handleSlotChange}"></slot>
      <div id="content" class="${0, _settingsJs.prefix}--tile-content">
        <div><slot name="above-the-fold-content"></slot></div>
        <div
          class="${0, _settingsJs.prefix}-ce--expandable-tile--below-the-fold-content"
          style="${(0, _ifDefinedJs.ifDefined)(!expanded ? undefined : `max-height: ${belowTheContentHeight}px`)}">
          <slot @slotchange="${handleSlotChangeBelowTheFoldContent}"></slot>
        </div>
      </div>
    `;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
    /**
     * The name of the custom event fired before the expanded state is changed upon a user gesture.
     * Cancellation of this event stops changing the user-initiated change in expanded state.
     */ static get eventBeforeToggle() {
        return `${0, _settingsJs.prefix}-expandable-tile-beingtoggled`;
    }
    /**
     * The name of the custom event fired after a the expanded state is changed upon a user gesture.
     */ static get eventToggle() {
        return `${0, _settingsJs.prefix}-expandable-tile-toggled`;
    }
};
CDSExpandableTile.styles = (0, _tileScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("click")
], CDSExpandableTile.prototype, "_handleClick", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "color-scheme",
        reflect: true
    })
], CDSExpandableTile.prototype, "colorScheme", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSExpandableTile.prototype, "expanded", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "has-rounded-corners"
    })
], CDSExpandableTile.prototype, "hasRoundedCorners", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "with-interactive"
    })
], CDSExpandableTile.prototype, "withInteractive", void 0);
CDSExpandableTile = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-expandable-tile`)
], CDSExpandableTile);
var CDSExpandableTile$1 = CDSExpandableTile;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/if-defined.js":"hSgrS","../../icons/chevron--down/16.js":"kXGdJ","../../globals/settings.js":"EipuL","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/focus.js":"5k7ow","../../globals/mixins/host-listener.js":"1SMUX","../../globals/shared-enums.js":"12kea","./tile.scss.js":"qx4kR","lit/directives/class-map.js":"2fQud","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"02vAW":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSRadioTile$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _classMapJs = require("lit/directives/class-map.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _settingsJs = require("../../globals/settings.js");
var _selectableTileJs = require("./selectable-tile.js");
var _selectableTileJsDefault = parcelHelpers.interopDefault(_selectableTileJs);
var _16Js = require("../../icons/checkmark--filled/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Single-selectable tile.
 *
 * @element cds-radio-tile
 * @fires cds-radio-tile-selected
 *   The name of the custom event fired after this selectable tile changes its selected state.
 */ let CDSRadioTile = class CDSRadioTile extends (0, _selectableTileJsDefault.default) {
    constructor(){
        super(...arguments);
        /**
         * The `type` attribute of the `<input>`.
         */ this._inputType = "radio";
    }
    /**
     * Handles `change` event on the `<input>` in the shadow DOM.
     */ _handleChange() {
        this.selected = true;
        const { selected, name } = this;
        const { eventRadioChange } = this.constructor;
        this.dispatchEvent(new CustomEvent(eventRadioChange, {
            bubbles: true,
            composed: true,
            detail: {
                selected,
                name
            }
        }));
    }
    render() {
        const { colorScheme, checkmarkLabel, name, selected, value, _inputType: inputType, _handleChange: handleChange } = this;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--tile`]: true,
            [`${0, _settingsJs.prefix}--tile--selectable`]: true,
            [`${0, _settingsJs.prefix}--tile--is-selected`]: selected,
            [`${0, _settingsJs.prefix}--tile--${colorScheme}`]: colorScheme
        });
        return (0, _lit.html)`
      <input
        type="${inputType}"
        id="input"
        class="${0, _settingsJs.prefix}--tile-input"
        tabindex="-1"
        name="${(0, _ifDefinedJs.ifDefined)(name)}"
        value="${(0, _ifDefinedJs.ifDefined)(value)}"
        .checked=${selected}
        @change=${handleChange} />
      <label for="input" class="${classes}" tabindex="0">
        <div class="${0, _settingsJs.prefix}--tile__checkmark">
          ${(0, _16JsDefault.default)({
            children: !checkmarkLabel ? undefined : (0, _lit.svg)`<title>${checkmarkLabel}</title>`
        })}
        </div>
        <div class="${0, _settingsJs.prefix}--tile-content"><slot></slot></div>
      </label>
    `;
    }
    /**
     * The name of the custom event fired after this selectable tile changes its selected state.
     */ static get eventRadioChange() {
        return `${0, _settingsJs.prefix}-radio-tile-selected`;
    }
};
CDSRadioTile = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-radio-tile`)
], CDSRadioTile);
var CDSRadioTile$1 = CDSRadioTile;

},{"tslib":"gBS4y","lit":"aCmte","lit/directives/class-map.js":"2fQud","lit/directives/if-defined.js":"hSgrS","../../globals/settings.js":"EipuL","./selectable-tile.js":"da87J","../../icons/checkmark--filled/16.js":"EwXOT","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"da87J":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectableTile);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _16Js = require("../../icons/checkbox/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _16Js1 = require("../../icons/checkbox--checked--filled/16.js");
var _16JsDefault1 = parcelHelpers.interopDefault(_16Js1);
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _hostListenerJs = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _sharedEnumsJs = require("../../globals/shared-enums.js");
var _tileScssJs = require("./tile.scss.js");
var _tileScssJsDefault = parcelHelpers.interopDefault(_tileScssJs);
var _hostListenerJs1 = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Multi-selectable tile.
 *
 * @element cds-selectable-tile
 * @fires cds-selectable-tile-changed - The custom event fired after this selectable tile changes its selected state.
 */ let CDSSelectableTile = class CDSSelectableTile extends (0, _hostListenerJsDefault.default)((0, _focusJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * The `type` attribute of the `<input>`.
         */ this._inputType = "checkbox";
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
        /**
         * Listener function for keyboard interaction.
         *
         * @param event to get the key pressed
         */ this._handleKeydown = (event)=>{
            var _a, _b;
            const { key } = event;
            if (key === " " || key === "Enter" && !((_a = event.target) === null || _a === void 0 ? void 0 : _a.matches(this.constructor.aiLabelItem)) && !((_b = event.target) === null || _b === void 0 ? void 0 : _b.matches(this.constructor.slugItem))) this.selected = !this.selected;
        };
        /**
         * The color scheme.
         */ this.colorScheme = (0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME).REGULAR;
        /**
         * Specify if the `SeletableTile` component should be rendered with rounded corners.
         * Only valid when `ai-label` prop is present
         */ this.hasRoundedCorners = false;
        /**
         * `true` to show the selected state.
         */ this.selected = false;
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>{
            var _a, _b;
            return elem.matches !== undefined ? elem.matches((_a = this.constructor) === null || _a === void 0 ? void 0 : _a.aiLabelItem) || // remove reference of slug in v12
            elem.matches((_b = this.constructor) === null || _b === void 0 ? void 0 : _b.slugItem) : false;
        });
        if (hasContent.length > 0) {
            this._hasAILabel = Boolean(hasContent);
            hasContent[0].setAttribute("size", "xs");
        }
        this.requestUpdate();
    }
    /**
     * Handles `change` event on the `<input>` in the shadow DOM.
     */ _handleChange() {
        this.selected = this._inputNode.checked;
        const selected = this.selected;
        const { eventChange } = this.constructor;
        this.dispatchEvent(new CustomEvent(eventChange, {
            bubbles: true,
            composed: true,
            detail: {
                selected
            }
        }));
    }
    /**
     * Handles the rendering of the icon.
     */ _renderIcon() {
        const { selected, checkmarkLabel } = this;
        return (0, _lit.html)` ${selected ? (0, _16JsDefault1.default)({
            children: !checkmarkLabel ? undefined : (0, _lit.svg)`<title>${checkmarkLabel}</title>`
        }) : (0, _16JsDefault.default)({
            children: !checkmarkLabel ? undefined : (0, _lit.svg)`<title>${checkmarkLabel}</title>`
        })}`;
    }
    updated() {
        if (this._hasAILabel) this.setAttribute("ai-label", "");
        else this.removeAttribute("ai-label");
    }
    render() {
        const { colorScheme, hasRoundedCorners: hasRoundedCorners, name, selected, value, _inputType: inputType, _handleChange: handleChange, _hasAILabel: hasAILabel } = this;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--tile`]: true,
            [`${0, _settingsJs.prefix}--tile--selectable`]: true,
            [`${0, _settingsJs.prefix}--tile--is-selected`]: selected,
            [`${0, _settingsJs.prefix}--tile--${colorScheme}`]: colorScheme,
            [`${0, _settingsJs.prefix}--tile--slug-rounded`]: hasAILabel && hasRoundedCorners
        });
        return (0, _lit.html)`
      <input
        type="${inputType}"
        id="input"
        class="${0, _settingsJs.prefix}--tile-input"
        tabindex="-1"
        name="${(0, _ifDefinedJs.ifDefined)(name)}"
        value="${(0, _ifDefinedJs.ifDefined)(value)}"
        .checked=${selected}
        @change=${handleChange} />
      <label for="input" class="${classes}" tabindex="0">
        <div
          class="${0, _settingsJs.prefix}--tile__checkmark ${0, _settingsJs.prefix}--tile__checkmark--persistent">
          ${this._renderIcon()}
        </div>
        <div class="${0, _settingsJs.prefix}--tile-content"><slot></slot></div>
      </label>
      <slot name="ai-label" @slotchange="${this._handleSlotChange}"></slot>
      <slot name="slug" @slotchange="${this._handleSlotChange}"></slot>
    `;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
    /**
     * The name of the custom event fired after this selectable tile changes its selected state.
     */ static get eventChange() {
        return `${0, _settingsJs.prefix}-selectable-tile-changed`;
    }
};
CDSSelectableTile.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSSelectableTile.styles = (0, _tileScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("input")
], CDSSelectableTile.prototype, "_inputNode", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("keydown")
], CDSSelectableTile.prototype, "_handleKeydown", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "checkmark-label"
    })
], CDSSelectableTile.prototype, "checkmarkLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "color-scheme",
        reflect: true
    })
], CDSSelectableTile.prototype, "colorScheme", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "has-rounded-corners"
    })
], CDSSelectableTile.prototype, "hasRoundedCorners", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSelectableTile.prototype, "name", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSelectableTile.prototype, "selected", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSelectableTile.prototype, "value", void 0);
CDSSelectableTile = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-selectable-tile`)
], CDSSelectableTile);
var SelectableTile = CDSSelectableTile;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/if-defined.js":"hSgrS","../../icons/checkbox/16.js":"ePBwk","../../icons/checkbox--checked--filled/16.js":"4ozl2","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","../../globals/mixins/host-listener.js":"1SMUX","../../globals/shared-enums.js":"12kea","./tile.scss.js":"qx4kR","../../globals/decorators/host-listener.js":"f95Mj","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ePBwk":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ozl2":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}<path d="M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"></path><path fill="none" d="M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z" data-icon-path="inner-path"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"acBO1":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TILE_COLOR_SCHEME", ()=>(0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME));
parcelHelpers.export(exports, "default", ()=>CDSTile$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _sharedEnumsJs = require("../../globals/shared-enums.js");
var _tileScssJs = require("./tile.scss.js");
var _tileScssJsDefault = parcelHelpers.interopDefault(_tileScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Basic tile.
 *
 * @element cds-tile
 */ let CDSTile = class CDSTile extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * `true` if there is an AI Label.
         */ this._hasAILabel = false;
        /**
         * The color scheme.
         */ this.colorScheme = (0, _sharedEnumsJs.FORM_ELEMENT_COLOR_SCHEME).REGULAR;
        /**
         * Specify if the `Tile` component should be rendered with rounded corners.
         * Only valid when `ai-label` prop is present
         */ this.hasRoundedCorners = false;
    }
    /**
     * Handles `slotchange` event.
     */ _handleSlotChange({ target }) {
        const hasContent = target.assignedNodes().filter((elem)=>elem.matches !== undefined ? elem.matches(this.constructor.aiLabelItem) || // remove reference of slug in v12
            elem.matches(this.constructor.slugItem) : false);
        if (hasContent.length > 0) {
            this._hasAILabel = Boolean(hasContent);
            hasContent[0].setAttribute("size", "xs");
        }
        this.requestUpdate();
    }
    updated() {
        const anchorTag = this.querySelector("a");
        if (anchorTag) {
            anchorTag === null || anchorTag === void 0 || anchorTag.classList.add(`${(0, _settingsJs.prefix)}--link`);
            anchorTag.before(document.createElement("br"));
            anchorTag.before(document.createElement("br"));
        }
        if (this._hasAILabel) this.setAttribute("ai-label", "");
        else this.removeAttribute("ai-label");
    }
    render() {
        return (0, _lit.html)` <slot></slot
      ><slot name="ai-label" @slotchange="${this._handleSlotChange}"></slot
      ><slot name="slug" @slotchange="${this._handleSlotChange}"></slot>`;
    }
    /**
     * A selector that will return the slug item.
     *
     * remove in v12
     */ static get slugItem() {
        return `${0, _settingsJs.prefix}-slug`;
    }
    /**
     * A selector that will return the AI Label item.
     */ static get aiLabelItem() {
        return `${0, _settingsJs.prefix}-ai-label`;
    }
};
CDSTile.styles = (0, _tileScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "color-scheme",
        reflect: true
    })
], CDSTile.prototype, "colorScheme", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "has-rounded-corners"
    })
], CDSTile.prototype, "hasRoundedCorners", void 0);
CDSTile = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-tile`)
], CDSTile);
var CDSTile$1 = CDSTile;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/shared-enums.js":"12kea","./tile.scss.js":"qx4kR","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gLdAp":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSTileGroup$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _radioGroupManagerJs = require("../../globals/internal/radio-group-manager.js");
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _tileScssJs = require("./tile.scss.js");
var _tileScssJsDefault = parcelHelpers.interopDefault(_tileScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Map of navigation direction by key.
 */ const navigationDirectionForKey = {
    ArrowUp: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).BACKWARD,
    Up: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).BACKWARD,
    ArrowDown: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).FORWARD,
    Down: (0, _radioGroupManagerJs.NAVIGATION_DIRECTION).FORWARD
};
/**
 * Tile group.
 *
 * @element cds-tile-group
 * @fires cds-current-radio-tile-selection
 *   The name of the custom event fired after a radio tile changes its selected state.
 * @fires cds-current-selectable-tile-selections
 *   The name of the custom event fired after a selectable tile changes its selected state.
 */ let CDSTileGroup = class CDSTileGroup extends (0, _hostListenerJsDefault1.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * Keyboard listener to ensure keyboard navigation.
         *
         * @param event to get key pressed
         */ this._handleKeydown = (event)=>{
            const { target, key } = event;
            const { radioTiles, selectableTiles } = this;
            const navigationDirection = navigationDirectionForKey[key];
            const tiles = radioTiles.length ? radioTiles : selectableTiles;
            const currentIndex = [
                ...tiles
            ].findIndex((e)=>e == target);
            const nextIndex = currentIndex + navigationDirection;
            const nextSibling = nextIndex !== -1 ? tiles[nextIndex % tiles.length] : tiles[tiles.length - 1];
            if (navigationDirection) {
                event.preventDefault(); // Prevent default (scrolling) behavior
                if (this.radioTiles.length) this._handleKeydownRadio(nextSibling);
                else this._handleKeydownSelectable(event, nextSibling);
            } else if (key === " " || key === "Enter") this._handleKeydownSelectable(event);
        };
        /**
         * Focus listener to focus on selected element upon focusing
         *
         * @param event to get focused
         */ this._handleFocus = (event)=>{
            const { relatedTarget, target } = event;
            if (this.radioTiles.length) {
                if (!this.currentRadioSelection) {
                    target.toggleAttribute("selected");
                    this.currentRadioSelection = target;
                } else if (!(relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.matches(this.constructor.selectorRadioTile)) && target !== this.currentRadioSelection) this.currentRadioSelection.focus();
            }
        };
        this.currentSelections = [];
    }
    _handleRadioClick(event) {
        const { target } = event;
        const { currentRadioSelection } = this;
        const { eventCurrentRadioTileSelection } = this.constructor;
        if (!currentRadioSelection) this.currentRadioSelection = target;
        else if (currentRadioSelection !== target) {
            currentRadioSelection.toggleAttribute("selected");
            this.currentRadioSelection = target;
        }
        this.dispatchEvent(new CustomEvent(eventCurrentRadioTileSelection, {
            bubbles: true,
            composed: true,
            detail: {
                target
            }
        }));
    }
    _handleSelectableClick(event) {
        const { target } = event;
        const { currentSelections } = this;
        const { eventCurrentSelectableTilesSelection } = this.constructor;
        if (!currentSelections.includes(target)) currentSelections.push(target);
        else currentSelections.splice(currentSelections.indexOf(target), 1);
        target.toggleAttribute("selected");
        this.dispatchEvent(new CustomEvent(eventCurrentSelectableTilesSelection, {
            bubbles: true,
            composed: true,
            detail: {
                currentSelections
            }
        }));
        event.stopPropagation();
        event.preventDefault();
    }
    /**
     * Click listener to ensure selectability.
     *
     * @param event click
     */ _handleTileSelect(event) {
        if (this.radioTiles.length) this._handleRadioClick(event);
        else this._handleSelectableClick(event);
    }
    /**
     * Handle keyboard navigation for radio tiles
     *
     * @param nextSibling to focus on
     */ _handleKeydownRadio(nextSibling) {
        const { currentRadioSelection } = this;
        const { eventCurrentRadioTileSelection } = this.constructor;
        if (currentRadioSelection) currentRadioSelection.toggleAttribute("selected");
        nextSibling.focus();
        nextSibling.toggleAttribute("selected");
        this.currentRadioSelection = nextSibling;
        this.dispatchEvent(new CustomEvent(eventCurrentRadioTileSelection, {
            bubbles: true,
            composed: true,
            detail: {
                nextSibling
            }
        }));
    }
    /**
     * Handle keyboard navigation for selectable tiles
     *
     * @param event to get target
     * @param nextSibling to focus on
     */ _handleKeydownSelectable(event, nextSibling) {
        const { target } = event;
        const { currentSelections } = this;
        const { eventCurrentSelectableTilesSelection } = this.constructor;
        if (nextSibling) nextSibling.focus();
        else {
            if (!currentSelections.includes(target)) currentSelections.push(target);
            else currentSelections.splice(currentSelections.indexOf(target), 1);
            this.dispatchEvent(new CustomEvent(eventCurrentSelectableTilesSelection, {
                bubbles: true,
                composed: true,
                detail: {
                    currentSelections
                }
            }));
        }
    }
    firstUpdated() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "group");
        if (!this.radioTiles) this.radioTiles = this.querySelectorAll(this.constructor.selectorRadioTile);
        if (!this.selectableTiles) this.selectableTiles = this.querySelectorAll(this.constructor.selectorSelectableTile);
        if (this.disabled) {
            this.radioTiles.forEach((e)=>e.toggleAttribute("disabled"));
            this.selectableTiles.forEach((e)=>e.toggleAttribute("disabled"));
        }
    }
    render() {
        const { fieldsetClassName, disabled } = this;
        return (0, _lit.html)`
      <fieldset class="${fieldsetClassName}" ?disabled=${disabled}>
        <slot name="legend" class="${0, _settingsJs.prefix}--label"></slot>
        <slot></slot>
      </fieldset>
    `;
    }
    /**
     * A selector that selects a radio tile component.
     */ static get selectorRadioTile() {
        return `${0, _settingsJs.prefix}-radio-tile`;
    }
    /**
     * A selector that selects a selectable tile component.
     */ static get selectorSelectableTile() {
        return `${0, _settingsJs.prefix}-selectable-tile`;
    }
    /**
     * The name of the custom event fired after a radio tile changes its selected state.
     */ static get eventCurrentRadioTileSelection() {
        return `${0, _settingsJs.prefix}-current-radio-tile-selection`;
    }
    /**
     * The name of the custom event fired after a radio tile changes its selected state.
     */ static get eventCurrentSelectableTilesSelection() {
        return `${0, _settingsJs.prefix}-current-selectable-tile-selections`;
    }
};
CDSTileGroup.styles = (0, _tileScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("click")
], CDSTileGroup.prototype, "_handleTileSelect", null);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("keydown")
], CDSTileGroup.prototype, "_handleKeydown", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("focusin")
], CDSTileGroup.prototype, "_handleFocus", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "fieldset-class-name"
    })
], CDSTileGroup.prototype, "fieldsetClassName", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        type: Boolean
    })
], CDSTileGroup.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTileGroup.prototype, "currentRadioSelection", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTileGroup.prototype, "currentSelections", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTileGroup.prototype, "radioTiles", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSTileGroup.prototype, "selectableTiles", void 0);
CDSTileGroup = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-tile-group`)
], CDSTileGroup);
var CDSTileGroup$1 = CDSTileGroup;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/internal/radio-group-manager.js":"jgXqY","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/host-listener.js":"1SMUX","./tile.scss.js":"qx4kR","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"13iRn":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _toggleJs = require("./toggle.js");

},{"./toggle.js":"OJx0N"}],"OJx0N":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TOGGLE_SIZE", ()=>(0, _defsJs.TOGGLE_SIZE));
parcelHelpers.export(exports, "default", ()=>CDSToggle$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _settingsJs = require("../../globals/settings.js");
var _checkboxJs = require("../checkbox/checkbox.js");
var _checkboxJsDefault = parcelHelpers.interopDefault(_checkboxJs);
var _defsJs = require("./defs.js");
var _toggleScssJs = require("./toggle.scss.js");
var _toggleScssJsDefault = parcelHelpers.interopDefault(_toggleScssJs);
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Basic toggle.
 *
 * @element cds-toggle
 * @slot label-text - The label text.
 * @slot checked-text - The text for the checked state.
 * @slot unchecked-text - The text for the unchecked state.
 * @fires cds-toggle-changed - The custom event fired after this changebox changes its checked state.
 */ let CDSToggle = class CDSToggle extends (0, _hostListenerJsDefault1.default)((0, _checkboxJsDefault.default)) {
    constructor(){
        super(...arguments);
        /**
         * Handles `keydown` event on the toggle button.
         */ this._handleKeydown = async (event)=>{
            const { key } = event;
            if (key === " ") this._handleChange();
        };
        /**
         * The text for the checked state.
         */ this.labelA = "";
        /**
         * Hide label text.
         */ this.hideLabel = false;
        /**
         * Read only boolean.
         */ this.readOnly = false;
        /**
         * Toggle size.
         */ this.size = (0, _defsJs.TOGGLE_SIZE).REGULAR;
        /**
         * The text for the unchecked state.
         */ this.labelB = "";
    }
    /**
     * Handles `click` event on the `<button>` in the shadow DOM.
     */ _handleChange() {
        const { checked, indeterminate } = this._checkboxNode;
        if (this.disabled || this.readOnly) return;
        this.checked = !checked;
        this.indeterminate = indeterminate;
        const { eventChange } = this.constructor;
        this.dispatchEvent(new CustomEvent(eventChange, {
            bubbles: true,
            composed: true,
            detail: {
                indeterminate
            }
        }));
    }
    _renderCheckmark() {
        if (this.size !== (0, _defsJs.TOGGLE_SIZE).SMALL) return undefined;
        return (0, _lit.html)`
      <svg
        class="${0, _settingsJs.prefix}--toggle__check"
        width="6px"
        height="5px"
        viewBox="0 0 6 5">
        <path d="M2.2 2.7L5 0 6 1 2.2 5 0 2.7 1 1.5z" />
      </svg>
    `;
    }
    render() {
        const { checked, disabled, labelText, hideLabel, id, name, size, labelA, labelB, value, _handleChange: handleChange } = this;
        const inputClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--toggle__appearance`]: true,
            [`${0, _settingsJs.prefix}--toggle__appearance--${size}`]: size
        });
        const toggleClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--toggle__switch`]: true,
            [`${0, _settingsJs.prefix}--toggle__switch--checked`]: checked
        });
        const stateText = checked ? labelA : labelB;
        return (0, _lit.html)`
      <button
        class="${0, _settingsJs.prefix}--toggle__button"
        role="switch"
        type="button"
        aria-checked=${checked}
        aria-lable=${labelText}
        .checked="${checked}"
        name="${(0, _ifDefinedJs.ifDefined)(name)}"
        value="${(0, _ifDefinedJs.ifDefined)(value)}"
        ?disabled=${disabled}
        id="${id}"></button>
      <label for="${id}" class="${0, _settingsJs.prefix}--toggle__label">
        <span class="${0, _settingsJs.prefix}--toggle__label-text">${labelText}</span>
        <div class="${inputClasses}">
          <div class="${toggleClasses}" @click=${handleChange}>
            ${this._renderCheckmark()}
          </div>
          <span
            ?hidden="${hideLabel}"
            class="${0, _settingsJs.prefix}--toggle__text"
            aria-hidden="true"
            >${stateText}</span
          >
        </div>
      </label>
    `;
    }
    /**
     * The name of the custom event fired after this changebox changes its checked state.
     */ static get eventChange() {
        return `${0, _settingsJs.prefix}-toggle-changed`;
    }
};
CDSToggle.styles = (0, _toggleScssJsDefault.default);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("button")
], CDSToggle.prototype, "_checkboxNode", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("keydown")
], CDSToggle.prototype, "_handleKeydown", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label-a"
    })
], CDSToggle.prototype, "labelA", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        type: Boolean
    })
], CDSToggle.prototype, "hideLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "read-only",
        type: Boolean
    })
], CDSToggle.prototype, "readOnly", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSToggle.prototype, "size", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "label-b"
    })
], CDSToggle.prototype, "labelB", void 0);
CDSToggle = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-toggle`)
], CDSToggle);
var CDSToggle$1 = CDSToggle;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/if-defined.js":"hSgrS","../../globals/settings.js":"EipuL","../checkbox/checkbox.js":"kER9T","./defs.js":"5orv7","./toggle.scss.js":"csray","../../globals/decorators/host-listener.js":"f95Mj","../../globals/mixins/host-listener.js":"1SMUX","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5orv7":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Toggle size.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TOGGLE_SIZE", ()=>TOGGLE_SIZE);
var TOGGLE_SIZE;
(function(TOGGLE_SIZE) {
    /**
     * Regular size.
     */ TOGGLE_SIZE["REGULAR"] = "";
    /**
     * Small size.
     */ TOGGLE_SIZE["SMALL"] = "sm";
})(TOGGLE_SIZE || (TOGGLE_SIZE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"csray":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--toggle{display:inline-block;-webkit-user-select:none;-moz-user-select:none;user-select:none}.cds--toggle__label-text{color:var(--cds-text-secondary,#525252);display:block;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);letter-spacing:var(--cds-label-01-letter-spacing,.32px);line-height:var(--cds-label-01-line-height,1.33333);margin-block-end:1rem}.cds--toggle__button{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--toggle__button:focus{outline:none}.cds--toggle__appearance{align-items:center;-moz-column-gap:.5rem;column-gap:.5rem;cursor:pointer;display:inline-grid;grid-template-columns:max-content max-content}.cds--toggle__switch{background-color:var(--cds-toggle-off,#8d8d8d);block-size:1.5rem;border-radius:.75rem;inline-size:3rem;position:relative;transition:background-color 70ms cubic-bezier(.2,0,1,.9)}.cds--toggle__switch:before{background-color:var(--cds-icon-on-color,#fff);block-size:1.125rem;border-radius:50%;content:"";inline-size:1.125rem;inset-block-start:.1875rem;inset-inline-start:.1875rem;position:absolute;transition:transform 70ms cubic-bezier(.2,0,1,.9)}@media screen and (prefers-reduced-motion:reduce){.cds--toggle__switch:before{transition:none}}.cds--toggle:not(.cds--toggle--disabled):active .cds--toggle__switch:after,.cds--toggle__button:focus+.cds--toggle__label .cds--toggle__switch:after{block-size:calc(100% + .375rem);border:2px solid var(--cds-focus,#0f62fe);border-radius:1rem;content:"";display:block;inline-size:calc(100% + .375rem);margin-block-start:-.1875rem;margin-inline-start:-.1875rem}.cds--toggle__switch--checked{background-color:var(--cds-support-success,#24a148)}.cds--toggle__switch--checked:before{transform:translateX(1.5rem)}.cds--toggle__text{color:var(--cds-text-primary,#161616);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857)}.cds--toggle__appearance--sm .cds--toggle__switch{block-size:1rem;inline-size:2rem}.cds--toggle__appearance--sm .cds--toggle__switch:before{block-size:.625rem;inline-size:.625rem}.cds--toggle__appearance--sm .cds--toggle__switch--checked:before{transform:translateX(1rem)}.cds--toggle__check{block-size:.3125rem;position:absolute;fill:var(--cds-support-success,#24a148);inline-size:.375rem;inset-block-start:.375rem;inset-inline-end:.3125rem;visibility:hidden}.cds--toggle__switch--checked .cds--toggle__check{visibility:visible}.cds--toggle--disabled .cds--toggle__appearance,:host(cds-toggle[disabled]) .cds--toggle__appearance{cursor:not-allowed}.cds--toggle--disabled .cds--toggle__label-text,.cds--toggle--disabled .cds--toggle__text,:host(cds-toggle[disabled]) .cds--toggle__label-text,:host(cds-toggle[disabled]) .cds--toggle__text{color:var(--cds-text-disabled,hsla(0,0%,9%,.25))}.cds--toggle--disabled .cds--toggle__switch,:host(cds-toggle[disabled]) .cds--toggle__switch{background-color:var(--cds-button-disabled,#c6c6c6)}.cds--toggle--disabled .cds--toggle__switch:before,:host(cds-toggle[disabled]) .cds--toggle__switch:before{background-color:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--toggle--disabled .cds--toggle__check,:host(cds-toggle[disabled]) .cds--toggle__check{fill:var(--cds-button-disabled,#c6c6c6)}.cds--toggle--readonly .cds--toggle__appearance,:host(cds-toggle[read-only]) .cds--toggle__appearance{cursor:default}.cds--toggle--readonly .cds--toggle__switch,:host(cds-toggle[read-only]) .cds--toggle__switch{background-color:transparent;border:1px solid var(--cds-icon-disabled,hsla(0,0%,9%,.25))}.cds--toggle--readonly .cds--toggle__switch:before,:host(cds-toggle[read-only]) .cds--toggle__switch:before{background-color:var(--cds-text-primary,#161616);inset-block-start:.125rem;inset-inline-start:.125rem}.cds--toggle--readonly .cds--toggle__check,:host(cds-toggle[read-only]) .cds--toggle__check{fill:var(--cds-background,#fff);inset-block-start:.3125rem;inset-inline-end:.25rem}.cds--toggle--readonly .cds--toggle__text,:host(cds-toggle[read-only]) .cds--toggle__text{cursor:text;-webkit-user-select:text;-moz-user-select:text;user-select:text}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--toggle__switch,.cds--toggle__switch:before{outline:1px solid transparent}.cds--toggle:not(.cds--toggle--disabled):active .cds--toggle__switch,.cds--toggle__button:focus+.cds--toggle__label .cds--toggle__switch{color:Highlight;outline:1px solid Highlight}}.cds--toggle--skeleton{align-items:center;display:flex}.cds--toggle--skeleton .cds--toggle__skeleton-circle{background:var(--cds-skeleton-background,#e8e8e8);block-size:1.125rem;border-radius:50%;inline-size:1.125rem;overflow:hidden;position:relative}.cds--toggle--skeleton .cds--toggle__skeleton-circle:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:200%;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--toggle--skeleton .cds--toggle__skeleton-circle:before{animation:none}}.cds--toggle--skeleton .cds--toggle__skeleton-rectangle{background:var(--cds-skeleton-background,#e8e8e8);block-size:.5rem;border:none;box-shadow:none;inline-size:1.5rem;margin-inline-start:.5rem;padding:0;pointer-events:none;position:relative}.cds--toggle--skeleton .cds--toggle__skeleton-rectangle:active,.cds--toggle--skeleton .cds--toggle__skeleton-rectangle:focus,.cds--toggle--skeleton .cds--toggle__skeleton-rectangle:hover{border:none;cursor:default;outline:none}.cds--toggle--skeleton .cds--toggle__skeleton-rectangle:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--toggle--skeleton .cds--toggle__skeleton-rectangle:before{animation:none}}[dir=rtl] .cds--toggle__switch--checked:before{transform:translateX(-1.5rem)}[dir=rtl] .cds--toggle__appearance--sm .cds--toggle__switch--checked:before{transform:translateX(-1rem)}:host(cds-toggle){outline:none}:host(cds-toggle[disabled]) .cds--toggle__appearance{cursor:not-allowed}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Kuj6":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _tooltipJs = require("./tooltip.js");
var _tooltipContentJs = require("./tooltip-content.js");

},{"./tooltip.js":"5I2D5","./tooltip-content.js":"lAmrJ"}],"1gjBp":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _headerJs = require("./header.js");
var _headerGlobalActionJs = require("./header-global-action.js");
var _headerMenuJs = require("./header-menu.js");
var _headerMenuButtonJs = require("./header-menu-button.js");
var _headerMenuItemJs = require("./header-menu-item.js");
var _headerNameJs = require("./header-name.js");
var _headerNavJs = require("./header-nav.js");
var _headerNavItemJs = require("./header-nav-item.js");
var _headerPanelJs = require("./header-panel.js");
var _headerSideNavItemsJs = require("./header-side-nav-items.js");
var _sideNavJs = require("./side-nav.js");
var _sideNavDividerJs = require("./side-nav-divider.js");
var _sideNavItemsJs = require("./side-nav-items.js");
var _sideNavLinkJs = require("./side-nav-link.js");
var _sideNavMenuJs = require("./side-nav-menu.js");
var _sideNavMenuItemJs = require("./side-nav-menu-item.js");
var _switcherJs = require("./switcher.js");
var _switcherDividerJs = require("./switcher-divider.js");
var _switcherItemJs = require("./switcher-item.js");

},{"./header.js":"bCltV","./header-global-action.js":"bt2tx","./header-menu.js":"ltPbk","./header-menu-button.js":"3iZJy","./header-menu-item.js":"7lqaC","./header-name.js":"85ErU","./header-nav.js":"ltNn5","./header-nav-item.js":"kDEmT","./header-panel.js":"2opJX","./header-side-nav-items.js":"4SV6w","./side-nav.js":"6Kz8T","./side-nav-divider.js":"dsuu6","./side-nav-items.js":"hef8D","./side-nav-link.js":"5cwBS","./side-nav-menu.js":"2Y4Cu","./side-nav-menu-item.js":"jgtSi","./switcher.js":"1XKZj","./switcher-divider.js":"RuuEd","./switcher-item.js":"9porJ"}],"bCltV":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSHeader$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _headerScssJs = require("./header.scss.js");
var _headerScssJsDefault = parcelHelpers.interopDefault(_headerScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Header.
 *
 * @element cds-header
 */ let CDSHeader = class CDSHeader extends (0, _lit.LitElement) {
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "banner");
        super.connectedCallback();
    }
    render() {
        return (0, _lit.html)` <slot></slot> `;
    }
};
CDSHeader.styles = (0, _headerScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
CDSHeader = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-header`)
], CDSHeader);
var CDSHeader$1 = CDSHeader;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","./header.scss.js":"4v21s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4v21s":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '@keyframes cds--hide-feedback{0%{opacity:1;visibility:inherit}to{opacity:0;visibility:hidden}}@keyframes cds--show-feedback{0%{opacity:0;visibility:hidden}to{opacity:1;visibility:inherit}}@keyframes cds--skeleton{0%{opacity:.3;transform:scaleX(0);transform-origin:left}20%{opacity:1;transform:scaleX(1);transform-origin:left}28%{transform:scaleX(1);transform-origin:right}51%{transform:scaleX(0);transform-origin:right}58%{transform:scaleX(0);transform-origin:right}82%{transform:scaleX(1);transform-origin:right}83%{transform:scaleX(1);transform-origin:left}96%{transform:scaleX(0);transform-origin:left}to{opacity:.3;transform:scaleX(0);transform-origin:left}}.cds--layout--size-xs{--cds-layout-size-height-context:var(--cds-layout-size-height-xs,1.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xs{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xs,1.5rem))}.cds--layout-constraint--size__min-xs{--cds-layout-size-height-min:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout-constraint--size__max-xs{--cds-layout-size-height-max:var(--cds-layout-size-height-xs,1.5rem)}.cds--layout--size-sm{--cds-layout-size-height-context:var(--cds-layout-size-height-sm,2rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-sm{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-sm,2rem))}.cds--layout-constraint--size__min-sm{--cds-layout-size-height-min:var(--cds-layout-size-height-sm,2rem)}.cds--layout-constraint--size__max-sm{--cds-layout-size-height-max:var(--cds-layout-size-height-sm,2rem)}.cds--layout--size-md{--cds-layout-size-height-context:var(--cds-layout-size-height-md,2.5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-md{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-md,2.5rem))}.cds--layout-constraint--size__min-md{--cds-layout-size-height-min:var(--cds-layout-size-height-md,2.5rem)}.cds--layout-constraint--size__max-md{--cds-layout-size-height-max:var(--cds-layout-size-height-md,2.5rem)}.cds--layout--size-lg{--cds-layout-size-height-context:var(--cds-layout-size-height-lg,3rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-lg{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-lg,3rem))}.cds--layout-constraint--size__min-lg{--cds-layout-size-height-min:var(--cds-layout-size-height-lg,3rem)}.cds--layout-constraint--size__max-lg{--cds-layout-size-height-max:var(--cds-layout-size-height-lg,3rem)}.cds--layout--size-xl{--cds-layout-size-height-context:var(--cds-layout-size-height-xl,4rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-xl,4rem))}.cds--layout-constraint--size__min-xl{--cds-layout-size-height-min:var(--cds-layout-size-height-xl,4rem)}.cds--layout-constraint--size__max-xl{--cds-layout-size-height-max:var(--cds-layout-size-height-xl,4rem)}.cds--layout--size-2xl{--cds-layout-size-height-context:var(--cds-layout-size-height-2xl,5rem);--cds-layout-size-height:var(--cds-layout-size-height-context)}.cds--layout-constraint--size__default-2xl{--cds-layout-size-height:var(--cds-layout-size-height-context,var(--cds-layout-size-height-2xl,5rem))}.cds--layout-constraint--size__min-2xl{--cds-layout-size-height-min:var(--cds-layout-size-height-2xl,5rem)}.cds--layout-constraint--size__max-2xl{--cds-layout-size-height-max:var(--cds-layout-size-height-2xl,5rem)}.cds--layout--density-condensed{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-condensed,0.5rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-condensed{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-condensed,0.5rem))}.cds--layout-constraint--density__min-condensed{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout-constraint--density__max-condensed{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-condensed,0.5rem)}.cds--layout--density-normal{--cds-layout-density-padding-inline-context:var(--cds-layout-density-padding-inline-normal,1rem);--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context)}.cds--layout-constraint--density__default-normal{--cds-layout-density-padding-inline:var(--cds-layout-density-padding-inline-context,var(--cds-layout-density-padding-inline-normal,1rem))}.cds--layout-constraint--density__min-normal{--cds-layout-density-padding-inline-min:var(--cds-layout-density-padding-inline-normal,1rem)}.cds--layout-constraint--density__max-normal{--cds-layout-density-padding-inline-max:var(--cds-layout-density-padding-inline-normal,1rem)}:root{--cds-layout-size-height-xs:1.5rem;--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;--cds-layout-size-height-xl:4rem;--cds-layout-size-height-2xl:5rem;--cds-layout-size-height-min:0px;--cds-layout-size-height-max:999999999px;--cds-layout-density-padding-inline-condensed:0.5rem;--cds-layout-density-padding-inline-normal:1rem;--cds-layout-density-padding-inline-min:0px;--cds-layout-density-padding-inline-max:999999999px}.cds--assistive-text,.cds--visually-hidden{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--popover-container{display:inline-block}.cds--popover-container:not(.cds--popover--auto-align){position:relative}.cds--popover--high-contrast .cds--popover{--cds-popover-background-color:var(--cds-background-inverse,#393939);--cds-popover-text-color:var(--cds-text-inverse,#fff)}.cds--popover--drop-shadow .cds--popover>.cds--popover-content{filter:drop-shadow(0 2px 2px rgba(0,0,0,.2))}.cds--popover--caret{--cds-popover-offset:0.625rem}.cds--popover{filter:var(--cds-popover-drop-shadow,none);inset:0;pointer-events:none;position:absolute;z-index:6000}.cds--popover-content{--cds-layout-size-height-sm:2rem;--cds-layout-size-height-md:2.5rem;--cds-layout-size-height-lg:3rem;background-color:var(--cds-popover-background-color,var(--cds-layer));border:0;border-radius:var(--cds-popover-border-radius,2px);box-sizing:border-box;color:var(--cds-popover-text-color,var(--cds-text-primary,#161616));display:none;font-family:inherit;font-size:100%;inline-size:-moz-max-content;inline-size:max-content;margin:0;max-inline-size:23rem;padding:0;pointer-events:auto;position:absolute;vertical-align:baseline;z-index:6000}.cds--layout--size-sm .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-sm)}.cds--layout--size-md .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-md)}.cds--layout--size-lg .cds--popover-content{--cds-layout-size-height:var(--cds-layout-size-height-lg)}.cds--popover-content *,.cds--popover-content :after,.cds--popover-content :before{box-sizing:inherit}.cds--popover--open>.cds--popover>.cds--popover-content{display:block}.cds--popover-content:before{content:"";display:none;position:absolute}.cds--popover--open>.cds--popover>.cds--popover-content:before{display:block}.cds--popover--auto-align.cds--popover-caret,.cds--popover-caret{background-color:var(--cds-popover-background-color,var(--cds-layer));display:none;position:absolute;will-change:transform;z-index:6000}.cds--popover--auto-align.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--caret.cds--popover--open>.cds--popover>.cds--popover-caret{display:block}.cds--popover--tab-tip>.cds--popover>.cds--popover-caret{display:none}.cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(100% + var(--cds-popover-offset, 0rem)))}.cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(100% + var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--bottom-end>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-left>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-right>.cds--popover>.cds--popover-content:before,.cds--popover--bottom-start>.cds--popover>.cds--popover-content:before,.cds--popover--bottom>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-start:0;inset-inline:0;transform:translateY(-100%)}.cds--popover--bottom-end>.cds--popover>.cds--popover-caret,.cds--popover--bottom-left>.cds--popover>.cds--popover-caret,.cds--popover--bottom-right>.cds--popover>.cds--popover-caret,.cds--popover--bottom-start>.cds--popover>.cds--popover-caret,.cds--popover--bottom>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-end:0;inset-inline-start:50%;transform:translate(-50%,var(--cds-popover-offset,0))}[dir=rtl] .cds--popover--bottom-end>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-left>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-right>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom-start>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--bottom>.cds--popover>.cds--popover-caret{transform:translate(50%,var(--cds-popover-offset,0))}.cds--popover--bottom-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 100%,50% 0,100% 100%);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{transform:translate(50%,calc(-100% - var(--cds-popover-offset, 0rem)))}.cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-start:0;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:0;inset-inline-start:auto}.cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:0;inset-inline-end:0;transform:translate(var(--cds-popover-offset,0),calc(-100% - var(--cds-popover-offset, 0rem)))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-start:0}.cds--popover--top-end>.cds--popover>.cds--popover-content:before,.cds--popover--top-left>.cds--popover>.cds--popover-content:before,.cds--popover--top-right>.cds--popover>.cds--popover-content:before,.cds--popover--top-start>.cds--popover>.cds--popover-content:before,.cds--popover--top>.cds--popover>.cds--popover-content:before{block-size:var(--cds-popover-offset,0);inset-block-end:0;inset-inline:0;transform:translateY(100%)}.cds--popover--top-end>.cds--popover>.cds--popover-caret,.cds--popover--top-left>.cds--popover>.cds--popover-caret,.cds--popover--top-right>.cds--popover>.cds--popover-caret,.cds--popover--top-start>.cds--popover>.cds--popover-caret,.cds--popover--top>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem);inset-block-start:0;inset-inline-start:50%;transform:translate(-50%,calc(var(--cds-popover-offset, 0rem)*-1))}[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{transform:translate(50%,calc(var(--cds-popover-offset, 0rem)*-1))}.cds--popover--top-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-height,.375rem);clip-path:polygon(0 0,50% 100%,100% 0);inline-size:var(--cds-popover-caret-width,.75rem)}.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),-50%)}.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5*-1 - 16px))}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-start:100%;transform:translate(var(--cds-popover-offset,0),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--right-end>.cds--popover>.cds--popover-content:before,.cds--popover--right-start>.cds--popover>.cds--popover-content:before,.cds--popover--right-top>.cds--popover>.cds--popover-content:before,.cds--popover--right>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-start:0;transform:translateX(-100%)}.cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-start:100%;transform:translate(calc(var(--cds-popover-offset, 0rem) - 100%),-50%)}[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:100%;inset-inline-start:auto}.cds--popover--right-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--right.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 50%,100% 0,100% 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + .1px),-50%)}.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*-.5 - 16px))}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-block-end:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1),calc(var(--cds-popover-offset, 0rem)*.5 + 16px))}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-content{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom>.cds--popover>.cds--popover-content:before,.cds--popover--left-end>.cds--popover>.cds--popover-content:before,.cds--popover--left-start>.cds--popover>.cds--popover-content:before,.cds--popover--left-top>.cds--popover>.cds--popover-content:before,.cds--popover--left>.cds--popover>.cds--popover-content:before{inline-size:var(--cds-popover-offset,0);inset-block:0;inset-inline-end:0;transform:translateX(100%)}.cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,.cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem);inset-block-start:50%;inset-inline-end:100%;transform:translate(calc(var(--cds-popover-offset, 0rem)*-1 + 100%),-50%)}[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret,[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align)>.cds--popover>.cds--popover-caret{inset-inline-end:auto;inset-inline-start:100%}.cds--popover--left-bottom.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-end.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-start.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left-top.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret,.cds--popover--left.cds--popover--auto-align>.cds--popover>.cds--popover-content>.cds--popover-caret{block-size:var(--cds-popover-caret-width,.75rem);clip-path:polygon(0 0,100% 50%,0 100%);inline-size:var(--cds-popover-caret-height,.375rem)}.cds--popover--tab-tip>.cds--popover>.cds--popover-content{border-radius:0}.cds--popover--tab-tip .cds--popover{will-change:filter}.cds--popover--tab-tip__button{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:2rem;justify-content:center;margin:0;padding:0;position:relative;text-align:start;vertical-align:baseline}.cds--popover--tab-tip__button *,.cds--popover--tab-tip__button :after,.cds--popover--tab-tip__button :before{box-sizing:inherit}.cds--popover--tab-tip__button::-moz-focus-inner{border:0}.cds--popover--tab-tip__button:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--popover--tab-tip__button:focus{outline-style:dotted}}.cds--popover--tab-tip__button:hover{background-color:var(--cds-layer-hover)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button{background:var(--cds-layer);box-shadow:0 2px 2px rgba(0,0,0,.2)}.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus):after{background:var(--cds-layer);block-size:2px;content:"";inline-size:100%;inset-block-end:0;position:absolute;z-index:6001}.cds--popover--tab-tip__button svg{fill:var(--cds-icon-primary,#161616)}.cds--tooltip{--cds-popover-offset:12px}.cds--tooltip-content{color:var(--cds-text-inverse,#fff);font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:18rem;padding:var(--cds-tooltip-padding-block,1rem) var(--cds-tooltip-padding-inline,1rem)}.cds--icon-tooltip{--cds-tooltip-padding-block:0.125rem;--cds-popover-caret-width:0.5rem;--cds-popover-caret-height:0.25rem;--cds-popover-offset:0.5rem}.cds--icon-tooltip .cds--tooltip-content{font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572)}.cds--definition-term{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;border-block-end:1px dotted var(--cds-border-strong);border-radius:0;box-sizing:border-box;color:var(--cds-text-primary,#161616);cursor:pointer;display:inline-block;font-family:inherit;font-size:100%;inline-size:100%;margin:0;padding:0;text-align:start;vertical-align:baseline}.cds--definition-term *,.cds--definition-term :after,.cds--definition-term :before{box-sizing:inherit}.cds--definition-term::-moz-focus-inner{border:0}.cds--definition-term:focus{border-block-end-color:var(--cds-border-interactive,#0f62fe);outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.cds--definition-term:focus{outline-style:dotted}}.cds--definition-term:hover{border-block-end-color:var(--cds-border-interactive,#0f62fe)}.cds--definition-tooltip{font-size:var(--cds-body-01-font-size,.875rem);font-weight:var(--cds-body-01-font-weight,400);letter-spacing:var(--cds-body-01-letter-spacing,.16px);line-height:var(--cds-body-01-line-height,1.42857);max-inline-size:11rem;padding:.5rem 1rem}.cds--btn{--cds-layout-size-height-local:clamp(max(var(--cds-layout-size-height-min),var(--cds-layout-size-height-sm)),var(--cds-layout-size-height,var(--cds-layout-size-height-lg)),min(var(--cds-layout-size-height-max),var(--cds-layout-size-height-2xl)));--cds-layout-density-padding-inline-local:clamp(var(--cds-layout-density-padding-inline-min),var(--cds-layout-density-padding-inline,var(--cds-layout-density-padding-inline-normal)),var(--cds-layout-density-padding-inline-max));--temp-1lh:(var(--cds-body-compact-01-line-height,1.28572) * 1em);--temp-expressive-1lh:(var(--cds-body-compact-02-line-height,1.375) * 1em);--temp-padding-block-max:calc((var(--cds-layout-size-height-lg) - var(--temp-1lh))/2 - 0.0625rem);border:0;border-radius:0;box-sizing:border-box;cursor:pointer;display:inline-flex;flex-shrink:0;font-family:inherit;font-size:100%;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);inline-size:-moz-max-content;inline-size:max-content;justify-content:space-between;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);line-height:var(--cds-body-compact-01-line-height,1.28572);margin:0;max-inline-size:20rem;min-block-size:var(--cds-layout-size-height-local);outline:none;padding:0;padding-block:min((var(--cds-layout-size-height-local) - var(--temp-1lh))/2 - .0625rem,var(--temp-padding-block-max));padding-inline:calc(var(--cds-layout-density-padding-inline-local) - .0625rem) calc(var(--cds-layout-density-padding-inline-local)*3 + .9375rem);position:relative;text-align:start;text-decoration:none;transition:background 70ms cubic-bezier(0,0,.38,.9),box-shadow 70ms cubic-bezier(0,0,.38,.9),border-color 70ms cubic-bezier(0,0,.38,.9),outline 70ms cubic-bezier(0,0,.38,.9);vertical-align:baseline;vertical-align:top}.cds--btn *,.cds--btn :after,.cds--btn :before{box-sizing:inherit}.cds--btn.cds--btn--disabled,.cds--btn.cds--btn--disabled:focus,.cds--btn.cds--btn--disabled:hover,.cds--btn:disabled,.cds--btn:focus:disabled,.cds--btn:hover:disabled{background:var(--cds-button-disabled,#c6c6c6);border-color:var(--cds-button-disabled,#c6c6c6);box-shadow:none;color:var(--cds-text-on-color-disabled,#8d8d8d);cursor:not-allowed}.cds--btn .cds--btn__icon{block-size:1rem;flex-shrink:0;inline-size:1rem;inset-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max));inset-inline-end:var(--cds-layout-density-padding-inline-local);margin-block-start:.0625rem;position:absolute}.cds--btn::-moz-focus-inner{border:0;padding:0}.cds--btn--primary{background-color:var(--cds-button-primary,#0f62fe);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--primary:hover{background-color:var(--cds-button-primary-hover,#0050e6)}.cds--btn--primary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--primary:active{background-color:var(--cds-button-primary-active,#002d9c)}.cds--btn--primary .cds--btn__icon,.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--primary:hover,.cds--btn--secondary{color:var(--cds-text-on-color,#fff)}.cds--btn--secondary{background-color:var(--cds-button-secondary,#393939);border:1px solid transparent}.cds--btn--secondary:hover{background-color:var(--cds-button-secondary-hover,#474747)}.cds--btn--secondary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--secondary:active{background-color:var(--cds-button-secondary-active,#6f6f6f)}.cds--btn--secondary .cds--btn__icon,.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--secondary:focus,.cds--btn--secondary:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--tertiary{background-color:transparent;border-color:var(--cds-button-tertiary,#0f62fe);border-style:solid;border-width:1px;color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:hover{background-color:var(--cds-button-tertiary-hover,#0050e6)}.cds--btn--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--tertiary .cds--btn__icon,.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--tertiary:focus,.cds--btn--tertiary:hover{color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary:focus{background-color:var(--cds-button-tertiary,#0f62fe)}.cds--btn--tertiary:active{background-color:var(--cds-button-tertiary-active,#002d9c);border-color:transparent;color:var(--cds-text-inverse,#fff)}.cds--btn--tertiary.cds--btn--disabled,.cds--btn--tertiary.cds--btn--disabled:focus,.cds--btn--tertiary.cds--btn--disabled:hover,.cds--btn--tertiary:disabled,.cds--btn--tertiary:focus:disabled,.cds--btn--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-link-primary,#0f62fe);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--ghost:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--btn--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--ghost .cds--btn__icon,.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--ghost:active,.cds--btn--ghost:hover{color:var(--cds-link-primary-hover,#0043ce)}.cds--btn--ghost:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--btn--ghost.cds--btn--disabled,.cds--btn--ghost.cds--btn--disabled:focus,.cds--btn--ghost.cds--btn--disabled:hover,.cds--btn--ghost:disabled,.cds--btn--ghost:focus:disabled,.cds--btn--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--ghost:not([disabled]) svg{fill:var(--cds-icon-primary,#161616)}.cds--btn--icon-only{block-size:var(--cds-layout-size-height-local);inline-size:var(--cds-layout-size-height-local);justify-content:center;padding:0;padding-block-start:min((var(--cds-layout-size-height-local) - 1rem)/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only>:first-child{min-inline-size:1rem}.cds--btn--icon-only .cds--btn__icon{position:static}.cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon{margin:0}.cds--btn--icon-only.cds--btn--danger--ghost{padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - 1rem)}.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon,.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon{margin-block-start:0}.cds--btn--icon-only.cds--btn--selected{background:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--btn path[data-icon-path=inner-path]{fill:none}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:var(--cds-icon-primary,#161616)}.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon{fill:var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn--ghost.cds--btn--icon-only[disabled],.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper{cursor:not-allowed}.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled]{pointer-events:none}.cds--btn--danger{background-color:var(--cds-button-danger-primary,#da1e28);border:1px solid transparent;color:var(--cds-text-on-color,#fff)}.cds--btn--danger:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger .cds--btn__icon,.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary{background-color:transparent;border-color:var(--cds-button-danger-secondary,#da1e28);border-style:solid;border-width:1px;color:var(--cds-button-danger-secondary,#da1e28)}.cds--btn--danger--tertiary:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--tertiary:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--tertiary .cds--btn__icon,.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--tertiary:hover{border-color:var(--cds-button-danger-hover,#b81921);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:focus{background-color:var(--cds-button-danger-primary,#da1e28);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary:active{background-color:var(--cds-button-danger-active,#750e13);border-color:var(--cds-button-danger-active,#750e13);color:var(--cds-text-on-color,#fff)}.cds--btn--danger--tertiary.cds--btn--disabled,.cds--btn--danger--tertiary.cds--btn--disabled:focus,.cds--btn--danger--tertiary.cds--btn--disabled:hover,.cds--btn--danger--tertiary:disabled,.cds--btn--danger--tertiary:focus:disabled,.cds--btn--danger--tertiary:hover:disabled{background:transparent;color:var(--cds-text-on-color-disabled,#8d8d8d);outline:none}.cds--btn--danger--ghost{background-color:transparent;border:1px solid transparent;color:var(--cds-button-danger-secondary,#da1e28);padding-inline-end:calc(var(--cds-layout-density-padding-inline-local) - .0625rem)}.cds--btn--danger--ghost:hover{background-color:var(--cds-button-danger-hover,#b81921)}.cds--btn--danger--ghost:focus{border-color:var(--cds-button-focus-color,var(--cds-focus,#0f62fe));box-shadow:inset 0 0 0 1px var(--cds-button-focus-color,var(--cds-focus,#0f62fe)),inset 0 0 0 2px var(--cds-background,#fff)}.cds--btn--danger--ghost:active{background-color:var(--cds-button-danger-active,#750e13)}.cds--btn--danger--ghost .cds--btn__icon,.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:currentColor}.cds--btn--danger--ghost .cds--btn__icon{margin-inline-start:.5rem;position:static}.cds--btn--danger--ghost:active,.cds--btn--danger--ghost:hover{color:var(--cds-text-on-color,#fff)}.cds--btn--danger--ghost.cds--btn--disabled,.cds--btn--danger--ghost.cds--btn--disabled:focus,.cds--btn--danger--ghost.cds--btn--disabled:hover,.cds--btn--danger--ghost:disabled,.cds--btn--danger--ghost:focus:disabled,.cds--btn--danger--ghost:hover:disabled{background:transparent;border-color:transparent;color:var(--cds-text-disabled,hsla(0,0%,9%,.25));outline:none}.cds--btn--expressive{font-size:var(--cds-body-compact-02-font-size,1rem);font-weight:var(--cds-body-compact-02-font-weight,400);letter-spacing:var(--cds-body-compact-02-letter-spacing,0);line-height:var(--cds-body-compact-02-line-height,1.375);padding-block:min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh))/2 - .0625rem,var(--temp-padding-block-max))}.cds--btn--icon-only.cds--btn--expressive{padding:12px 13px}.cds--btn.cds--btn--expressive .cds--btn__icon{block-size:1.25rem;inline-size:1.25rem}.cds--btn-set .cds--btn.cds--btn--expressive{max-inline-size:20rem}.cds--btn.cds--skeleton{background:var(--cds-skeleton-background,#e8e8e8);border:none;box-shadow:none;inline-size:9.375rem;padding:0;pointer-events:none;position:relative}.cds--btn.cds--skeleton:active,.cds--btn.cds--skeleton:focus,.cds--btn.cds--skeleton:hover{border:none;cursor:default;outline:none}.cds--btn.cds--skeleton:before{animation:cds--skeleton 3s ease-in-out infinite;background:var(--cds-skeleton-element,#c6c6c6);block-size:100%;content:"";inline-size:100%;inset-inline-start:0;position:absolute;will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.cds--btn.cds--skeleton:before{animation:none}}.cds--btn-set{display:flex}.cds--btn-set--stacked{flex-direction:column}.cds--btn-set .cds--btn{inline-size:100%;max-inline-size:12.25rem}.cds--btn-set .cds--btn:not(:focus){box-shadow:-.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set .cds--btn:first-of-type:not(:focus),.cds--btn-set .cds--btn:focus+.cds--btn{box-shadow:inherit}.cds--btn-set--stacked .cds--btn:not(:focus){box-shadow:0 -.0625rem 0 0 var(--cds-button-separator,#e0e0e0)}.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus){box-shadow:inherit}.cds--btn-set .cds--btn.cds--btn--disabled{box-shadow:-.0625rem 0 0 0 var(--cds-icon-on-color-disabled,#8d8d8d)}.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set--stacked .cds--btn.cds--btn--disabled{box-shadow:0 -.0625rem 0 0 var(--cds-layer-selected-disabled,#8d8d8d)}.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type{box-shadow:none}.cds--btn-set .cds--btn.cds--btn--loading{background-color:transparent;border-color:transparent;box-shadow:none}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--btn:focus{color:Highlight;outline:1px solid Highlight}.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon,.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]){fill:ButtonText}}[dir=rtl] .cds--btn-set .cds--btn:not(:focus){box-shadow:.0625rem 0 0 0 var(--cds-button-separator,#e0e0e0)}.cds--header,:host(cds-header){align-items:center;background-color:var(--cds-background,#fff);block-size:3rem;border:0;border-block-end:1px solid var(--cds-border-subtle);box-sizing:border-box;display:flex;font-family:inherit;font-size:100%;inset-block-start:0;inset-inline:0;margin:0;padding:0;position:fixed;vertical-align:baseline;z-index:8000}.cds--header *,.cds--header :after,.cds--header :before,:host(cds-header) *,:host(cds-header) :after,:host(cds-header) :before{box-sizing:inherit}.cds--header__action{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:3rem;border:.0625rem solid transparent;box-sizing:border-box;cursor:pointer;display:inline-block;display:inline-flex;font-family:inherit;font-size:100%;inline-size:100%;inline-size:3rem;margin:0;padding:0;text-align:start;transition:background-color .11s,border-color .11s;vertical-align:baseline}.cds--header__action *,.cds--header__action :after,.cds--header__action :before{box-sizing:inherit}.cds--header__action::-moz-focus-inner{border:0}@media (max-width:41.98rem){.cds--header__action{min-inline-size:3rem}}.cds--header__global .cds--popover,:host(cds-header) ::slotted(.cds--header__global) .cds--popover{z-index:8001}.cds--header__action>:first-child{margin-block-start:0}.cds--header__action--active>svg.cds--navigation-menu-panel-expand-icon,.cds--header__action>svg.cds--navigation-menu-panel-collapse-icon{display:none}.cds--header__action--active>svg.cds--navigation-menu-panel-collapse-icon{display:inline}.cds--header__action:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12))}.cds--header__action--active{background:var(--cds-layer);border-block-end:1px solid transparent;border-inline-end:1px solid var(--cds-border-subtle);border-inline-start:1px solid var(--cds-border-subtle)}.cds--header__action--active>svg{fill:var(--cds-icon-primary,#161616)}.cds--header__action:focus{border-color:var(--cds-focus,#0f62fe);outline:none}.cds--header__action:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}.cds--header__action.cds--btn--icon-only{align-items:center;justify-content:center}.cds--btn.cds--btn--icon-only.cds--header__action svg{fill:var(--cds-icon-secondary,#525252)}.cds--btn.cds--btn--icon-only.cds--header__action--active svg,.cds--btn.cds--btn--icon-only.cds--header__action:active svg,.cds--btn.cds--btn--icon-only.cds--header__action:hover svg,.cds--header__menu-trigger:hover>svg,.cds--header__menu-trigger>svg{fill:var(--cds-icon-primary,#161616)}.cds--header__menu-toggle{align-items:center;display:flex;justify-content:center}@media (min-width:66rem){.cds--header__menu-toggle__hidden{display:none}}a.cds--header__name{align-items:center;block-size:100%;border:.125rem solid transparent;display:flex;font-size:var(--cds-body-compact-01-font-size,.875rem);font-weight:var(--cds-body-compact-01-font-weight,400);font-weight:600;letter-spacing:var(--cds-body-compact-01-letter-spacing,.16px);letter-spacing:.1px;line-height:var(--cds-body-compact-01-line-height,1.28572);line-height:1.25rem;outline:none;padding:0 2rem 0 1rem;text-decoration:none;transition:border-color .11s;-webkit-user-select:none;-moz-user-select:none;user-select:none}@media (max-width:41.98rem){a.cds--header__name{padding:0 1rem}}a.cds--header__name:focus{border-color:var(--cds-focus,#0f62fe)}.cds--header__name--prefix{font-weight:400}a.cds--header__name,a.cds--header__name:hover{color:var(--cds-text-primary,#161616)}.cds--header__menu-toggle:not(.cds--header__menu-toggle__hidden)~.cds--header__name{padding-inline-start:.5rem}.cds--header__nav,:host(cds-header-nav){block-size:100%;display:none;padding-inline-start:1rem;position:relative}@media (min-width:66rem){.cds--header__nav,:host(cds-header-nav){display:block}}.cds--header__nav:before{background-color:var(--cds-border-subtle);block-size:1.5rem;content:"";display:block;inline-size:.0625rem;inset-block-start:50%;inset-inline-start:0;position:absolute;transform:translateY(-50%)}.cds--header__menu-bar{block-size:100%;border:0;box-sizing:border-box;display:flex;font-family:inherit;font-size:100%;list-style:none;margin:0;padding:0;vertical-align:baseline}.cds--header__menu-bar *,.cds--header__menu-bar :after,.cds--header__menu-bar :before{box-sizing:inherit}a.cds--header__menu-item{align-items:center;background-color:var(--cds-background,#fff);block-size:100%;border:2px solid transparent;color:var(--cds-text-secondary,#525252);display:flex;font-size:.875rem;font-weight:400;letter-spacing:0;line-height:1.125rem;padding:0 1rem;position:relative;text-decoration:none;transition:background-color .11s,border-color .11s,color .11s;-webkit-user-select:none;-moz-user-select:none;user-select:none}a.cds--header__menu-item:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12));color:var(--cds-text-primary,#161616)}.cds--header__action:active,a.cds--header__menu-item:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5));color:var(--cds-text-primary,#161616)}a.cds--header__menu-item:focus{border-color:var(--cds-focus,#0f62fe);outline:none}a.cds--header__menu-item:active>svg,a.cds--header__menu-item:hover>svg{fill:var(--cds-icon-primary,#161616)}.cds--header__menu-item--current,a.cds--header__menu-item[aria-current=page]{color:var(--cds-text-primary,#161616)}.cds--header__menu-item--current:after,a.cds--header__menu-item[aria-current=page]:after{background-color:var(--cds-border-interactive,#0f62fe);block-size:3px;content:"";inline-size:calc(100% + 4px);inset-block-end:-2px;inset-inline-start:-2px;position:absolute}.cds--header__menu-item--current:focus:after,a.cds--header__menu-item[aria-current=page]:focus:after{border:0}.cds--header__submenu .cds--header__menu .cds--header__menu-item--current:after,.cds--header__submenu .cds--header__menu a.cds--header__menu-item[aria-current=page]:after,:host(cds-header-menu) .cds--header__menu .cds--header__menu-item--current:after,:host(cds-header-menu) .cds--header__menu a.cds--header__menu-item[aria-current=page]:after{background-color:var(--cds-border-interactive,#0f62fe);block-size:calc(100% + 4px);inline-size:3px;inset-block-start:-2px;inset-inline-start:-2px}.cds--header__submenu .cds--header__menu .cds--header__menu-item--current:focus:after,.cds--header__submenu .cds--header__menu a.cds--header__menu-item[aria-current=page]:focus:after,:host(cds-header-menu) .cds--header__menu .cds--header__menu-item--current:focus:after,:host(cds-header-menu) .cds--header__menu a.cds--header__menu-item[aria-current=page]:focus:after{background-color:var(--cds-border-interactive,#0f62fe);block-size:calc(100% + 4px);inline-size:5px;inset-block-start:-2px;inset-inline-start:-2px}a.cds--header__menu-item.cds--header__menu-item--current:focus,a.cds--header__menu-item[aria-current=page]:focus{border:2px solid var(--cds-focus,#0f62fe)}.cds--header__submenu,:host(cds-header-menu){position:relative}.cds--header__menu-title[aria-haspopup=true]{position:relative}.cds--header__menu-title[aria-expanded=true]{background-color:var(--cds-layer);color:var(--cds-text-secondary,#525252);z-index:8002}.cds--header__menu-title[aria-expanded=true]>.cds--header__menu-arrow{transform:rotate(180deg)}.cds--header__menu{display:none;list-style:none;margin:0;padding:0}.cds--header__menu-title[aria-expanded=true]+.cds--header__menu{background-color:var(--cds-layer);box-shadow:0 4px 8px 0 rgba(0,0,0,.5);display:flex;flex-direction:column;inline-size:12.5rem;inset-block-end:0;inset-inline-start:0;position:absolute;transform:translateY(100%);z-index:8001}.cds--header__menu-title[aria-expanded=true]+.cds--header__menu .cds--header__menu-item{background-color:var(--cds-layer)}.cds--header__menu-title[aria-expanded=true]+.cds--header__menu .cds--header__menu-item:hover{background-color:var(--cds-layer-hover);color:var(--cds-text-primary,#161616)}.cds--header__menu-title[aria-expanded=true]+.cds--header__menu .cds--header__menu-item:active{background-color:var(--cds-layer-active);color:var(--cds-text-primary,#161616)}.cds--header__menu-title[aria-expanded=true]+.cds--header__menu .cds--header__menu-item.cds--header__menu-item--current{background-color:var(--cds-layer-selected)}.cds--header__menu-title[aria-expanded=true]+.cds--header__menu .cds--header__menu-item.cds--header__menu-item--current:hover{background-color:var(--cds-layer-selected-hover)}.cds--header__menu .cds--header__menu-item{block-size:3rem}.cds--header__menu-arrow{fill:var(--cds-icon-secondary,#525252);margin-inline-start:.5rem;transition:transform .11s,fill .11s}.cds--header__global,:host(cds-header) ::slotted(.cds--header__global){block-size:100%;display:flex;flex:1 1 0%;justify-content:flex-end}.cds--skip-to-content{block-size:1px;border:0;margin:-1px;overflow:hidden;padding:0;position:absolute;clip:rect(0,0,0,0);inline-size:1px;visibility:inherit;white-space:nowrap}.cds--skip-to-content:focus{align-items:center;background-color:var(--cds-background,#fff);block-size:3rem;border:4px solid var(--cds-focus,#0f62fe);display:flex;padding:0 1rem;z-index:9999;clip:auto;color:var(--cds-text-secondary,#525252);inline-size:auto;inset-block-start:0;inset-inline-start:0;outline:none}.cds--header-panel,:host(cds-header-panel){background-color:var(--cds-layer);border:none;color:var(--cds-text-secondary,#525252);inline-size:0;inset-block:3rem 0;inset-inline-end:0;overflow:hidden;position:fixed;transition:width .11s cubic-bezier(.2,0,1,.9);will-change:width;z-index:8000}.cds--header-panel--expanded,:host(cds-header-panel[expanded]){border-inline-end:1px solid var(--cds-border-subtle);border-inline-start:1px solid var(--cds-border-subtle);inline-size:16rem;overflow-y:auto}.cds--switcher,:host(cds-switcher){align-items:center;border:0;box-sizing:border-box;color:var(--cds-text-secondary,#525252);display:flex;flex-direction:column;font-family:inherit;font-size:100%;justify-content:center;margin:0;padding:0;vertical-align:baseline}.cds--switcher *,.cds--switcher :after,.cds--switcher :before,:host(cds-switcher) *,:host(cds-switcher) :after,:host(cds-switcher) :before{box-sizing:inherit}.cds--switcher__item,:host(cds-switcher-item){block-size:2rem;inline-size:100%}.cds--switcher__item:first-child{margin-block-start:1rem}.cds--switcher__item--divider,:host(cds-switcher-divider){background:var(--cds-border-subtle);block-size:1px;border:none;display:block;inline-size:14rem;margin:.5rem 1rem}.cds--switcher__item-link{block-size:2rem;color:var(--cds-text-secondary,#525252);display:block;font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);padding:.375rem 1rem;text-decoration:none}.cds--switcher__item-link:hover:not(.cds--switcher__item-link--selected){background:var(--cds-layer-hover);color:var(--cds-text-primary,#161616);cursor:pointer}.cds--switcher__item-link:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}.cds--switcher__item-link:active{background:var(--cds-layer-active);color:var(--cds-text-primary,#161616)}.cds--switcher__item-link--selected{background:var(--cds-layer-selected);color:var(--cds-text-primary,#161616)}:host(cds-header-nav) .cds-ce--header__divider{background-color:var(--cds-border-subtle);block-size:1.5rem;inline-size:.0625rem;inset-block-start:50%;inset-inline-start:0;position:absolute;transform:translateY(-50%)}:host(cds-header-nav-item){outline:none}:host(cds-header-menu){outline:none}:host(cds-header-menu-item){outline:none}:host(cds-header-menu-item) a.cds--header__menu-item{background-color:var(--cds-layer);block-size:3rem}:host(cds-header-menu-item) a.cds--header__menu-item:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12));color:var(--cds-text-primary,#161616)}:host(cds-header-menu-item) a.cds--header__menu-item:active{background-color:var(--cds-background-active,hsla(0,0%,55%,.5))}:host(cds-header-menu-item) a.cds--header__menu-item--current{background-color:var(--cds-layer-selected)}:host(cds-header-menu-item) a.cds--header__menu-item--current:hover{background-color:var(--cds-layer-selected-hover)}:host(cds-header-menu-item) a.cds--header__menu-item--current:after{background-color:var(--cds-border-interactive,#0f62fe);block-size:100%;content:"";inline-size:3px;inset-block:-.125rem;inset-inline-start:-.125rem;position:absolute}:host(cds-header-global-action) ::slotted(svg){fill:var(--cds-icon-secondary,#525252)}:host(cds-header-global-action):hover ::slotted(svg){fill:var(--cds-icon-primary,#161616)}:host(cds-header-global-action) .cds--popover{z-index:8001}:host(cds-header-menu) a.cds--header__menu-item,:host(cds-header-nav-item) a.cds--header__menu-item{box-sizing:border-box}:host(cds-header-menu-button){display:content;outline:none}@media (min-width:66rem){:host(cds-header-menu-button){display:none}}:host(cds-header-menu-button[collapse-mode=fixed]){display:none}@media (min-width:66rem){:host(cds-header-menu-button[collapse-mode=rail]){display:block}}:host(cds-header-name){block-size:100%;display:content}:host(cds-header-name) a{box-sizing:border-box}:host(cds-switcher-item) a{box-sizing:border-box}:host(cds-switcher-item:first-child){margin-block-start:1rem}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bt2tx":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSHeaderGlobalAction$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _buttonJs = require("../button/button.js");
var _buttonJsDefault = parcelHelpers.interopDefault(_buttonJs);
var _hostListenerJs = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _headerScssJs = require("./header.scss.js");
var _headerScssJsDefault = parcelHelpers.interopDefault(_headerScssJs);
var _settingsJs = require("../../globals/settings.js");
var _defsJs = require("../button/defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2023, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Header global action button
 *
 * @element cds-header-global-action
 */ let CDSHeaderGlobalAction = class CDSHeaderGlobalAction extends (0, _buttonJsDefault.default) {
    connectedCallback() {
        this.tooltipPosition = (0, _defsJs.BUTTON_TOOLTIP_POSITION).BOTTOM;
        super.connectedCallback();
    }
    _handleClick(event) {
        const { disabled } = this;
        if (disabled) event.stopPropagation();
        else {
            const panel = document.querySelector(`#${this.panelId}`);
            // see if there is related panel for header-global-action button first
            // and then set the expanded attr of it accordingly
            if (panel) {
                const expanded = panel.getAttribute("expanded");
                if (expanded) panel.removeAttribute("expanded");
                else panel.setAttribute("expanded", "true");
                const active = !this.active;
                this.active = active;
            }
        }
    }
    updated() {
        if (this._buttonNode) this._buttonNode.classList.add(`${(0, _settingsJs.prefix)}--header__action`);
    }
    shouldUpdate(changedProperties) {
        if (changedProperties.has("active")) {
            if (this.active) {
                this._buttonNode.classList.add(`${(0, _settingsJs.prefix)}--header__action--active`);
                if (this.buttonLabelActive) this.tooltipText = this.buttonLabelActive;
            } else {
                this._buttonNode.classList.remove(`${(0, _settingsJs.prefix)}--header__action--active`);
                if (this.buttonLabelInactive) this.tooltipText = this.buttonLabelInactive;
            }
        }
        return true;
    }
};
CDSHeaderGlobalAction.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSHeaderGlobalAction.styles = (0, _headerScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("button")
], CDSHeaderGlobalAction.prototype, "_buttonNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSHeaderGlobalAction.prototype, "active", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        attribute: "panel-id",
        reflect: true
    })
], CDSHeaderGlobalAction.prototype, "panelId", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "button-label-active"
    })
], CDSHeaderGlobalAction.prototype, "buttonLabelActive", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "button-label-inactive"
    })
], CDSHeaderGlobalAction.prototype, "buttonLabelInactive", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault.default)("click", {
        capture: true
    })
], CDSHeaderGlobalAction.prototype, "_handleClick", null);
CDSHeaderGlobalAction = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-header-global-action`)
], CDSHeaderGlobalAction);
var CDSHeaderGlobalAction$1 = CDSHeaderGlobalAction;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","../button/button.js":"ca52G","../../globals/decorators/host-listener.js":"f95Mj","./header.scss.js":"4v21s","../../globals/settings.js":"EipuL","../button/defs.js":"3XZFP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ltPbk":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSHeaderMenu$1);
var _tslib = require("tslib");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _classMapJs = require("lit/directives/class-map.js");
var _16Js = require("../../icons/chevron--down/16.js");
var _16JsDefault = parcelHelpers.interopDefault(_16Js);
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _hostListenerJs = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _headerScssJs = require("./header.scss.js");
var _headerScssJsDefault = parcelHelpers.interopDefault(_headerScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Header menu.
 *
 * @element cds-header-menu
 * @csspart trigger The trigger button.
 * @csspart trigger-icon The trigger button icon.
 * @csspart menu-body The menu body.
 */ let CDSHeaderMenu = class CDSHeaderMenu extends (0, _hostListenerJsDefault.default)((0, _focusJsDefault.default)((0, _lit.LitElement))) {
    constructor(){
        super(...arguments);
        /**
         * keeps track if header menu has any active submenus
         */ this._hasActiveChildren = false;
        /**
         * `true` if the menu should be expanded.
         */ this.expanded = false;
        /**
         * Applies selected styles to the item if a user sets this to true and `aria-current !== 'page'`.
         */ this.isActive = false;
        /**
         * The content of the trigger button.
         */ this.triggerContent = "";
    }
    /**
     * Handles `click` event handler on this element.
     */ _handleClick() {
        this._handleUserInitiatedToggle();
    }
    /**
     * Handler for the `keydown` event on the trigger button.
     */ _handleKeydownTrigger({ key }) {
        if (key === "Esc" || key === "Escape") this._handleUserInitiatedToggle(false);
    }
    /**
     * Handles user-initiated toggling the open state.
     *
     * @param [force] If specified, forces the open state to the given one.
     */ _handleUserInitiatedToggle(force = !this.expanded) {
        this.expanded = force;
        if (!force) this._topMenuItem.focus();
    }
    /**
     * Handles `blur` event handler on this element.
     */ _handleBlur({ relatedTarget }) {
        if (!this.contains(relatedTarget)) this.expanded = false;
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "listitem");
        const { selectorItem } = this.constructor;
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorItem), (elem)=>{
            if (elem.isActive === true) this._hasActiveChildren = true;
        });
        super.connectedCallback();
    }
    updated(changedProperties) {
        if (changedProperties.has("expanded")) {
            const { selectorItem } = this.constructor;
            const { expanded } = this;
            (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorItem), (elem)=>{
                elem.tabIndex = expanded ? 0 : -1;
            });
        }
    }
    render() {
        const { expanded, isActive, triggerContent, menuLabel, _hasActiveChildren, _handleClick: handleClick } = this;
        const linkClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--header__menu-item`]: true,
            [`${0, _settingsJs.prefix}--header__menu-title`]: true,
            [`${0, _settingsJs.prefix}--header__menu-item--current`]: isActive || _hasActiveChildren && !expanded
        });
        return (0, _lit.html)`
      <a
        part="trigger"
        role="button"
        tabindex="0"
        class="${linkClasses}"
        href="javascript:void 0"
        aria-haspopup="menu"
        aria-expanded="${String(Boolean(expanded))}"
        @click=${handleClick}>
        ${triggerContent}${(0, _16JsDefault.default)({
            part: "trigger-icon",
            class: `${(0, _settingsJs.prefix)}--header__menu-arrow`
        })}
      </a>
      <ul
        part="menu-body"
        class="${0, _settingsJs.prefix}--header__menu"
        aria-label="${(0, _ifDefinedJs.ifDefined)(menuLabel)}">
        <slot></slot>
      </ul>
    `;
    }
    /**
     * A selector that will return the menu items.
     */ static get selectorItem() {
        return `${0, _settingsJs.prefix}-header-menu-item`;
    }
};
CDSHeaderMenu.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSHeaderMenu.styles = (0, _headerScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)('[part="trigger"]')
], CDSHeaderMenu.prototype, "_topMenuItem", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("keydown")
], CDSHeaderMenu.prototype, "_handleKeydownTrigger", null);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("focusout")
], CDSHeaderMenu.prototype, "_handleBlur", null);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSHeaderMenu.prototype, "expanded", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "is-active",
        reflect: true
    })
], CDSHeaderMenu.prototype, "isActive", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "trigger-content"
    })
], CDSHeaderMenu.prototype, "triggerContent", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "menu-label"
    })
], CDSHeaderMenu.prototype, "menuLabel", void 0);
CDSHeaderMenu = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-header-menu`)
], CDSHeaderMenu);
var CDSHeaderMenu$1 = CDSHeaderMenu;

},{"tslib":"gBS4y","lit/directives/if-defined.js":"hSgrS","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/class-map.js":"2fQud","../../icons/chevron--down/16.js":"kXGdJ","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","../../globals/mixins/host-listener.js":"1SMUX","../../globals/decorators/host-listener.js":"f95Mj","../../globals/internal/collection-helpers.js":"4aZkz","./header.scss.js":"4v21s","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3iZJy":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSHeaderMenuButton$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _20Js = require("../../icons/close/20.js");
var _20JsDefault = parcelHelpers.interopDefault(_20Js);
var _20Js1 = require("../../icons/menu/20.js");
var _20JsDefault1 = parcelHelpers.interopDefault(_20Js1);
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _sideNavJs = require("./side-nav.js");
var _headerScssJs = require("./header.scss.js");
var _headerScssJsDefault = parcelHelpers.interopDefault(_headerScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _defsJs = require("./defs.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The trigger button for side nav in header nav.
 *
 * @element cds-header-menu-button
 * @csspart button The button.
 * @csspart toggle-icon The toggle icon.
 * @fires cds-header-menu-button-toggled - The custom event fired after this header menu button is toggled upon a user gesture.
 */ let CDSHeaderMenuButton = class CDSHeaderMenuButton extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if the button should represent its active state.
         */ this.active = false;
        /**
         * The `aria-label` attribute for the button in its active state.
         */ this.buttonLabelActive = "Close navigation menu";
        /**
         * The `aria-label` attribute for the button in its inactive state.
         */ this.buttonLabelInactive = "Open navigation menu";
        /**
         * Collapse mode of the side nav.
         */ this.collapseMode = (0, _defsJs.SIDE_NAV_COLLAPSE_MODE).RESPONSIVE;
        /**
         * `true` if the button should be disabled.
         */ this.disabled = false;
        /**
         * If `true` will style the side nav to sit below the header
         */ this.isNotChildOfHeader = false;
    }
    _handleClick() {
        const active = !this.active;
        this.active = active;
        this.dispatchEvent(new CustomEvent(this.constructor.eventToggle, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: {
                active
            }
        }));
    }
    render() {
        const { active, buttonLabelActive, buttonLabelInactive, disabled, _handleClick: handleClick } = this;
        const buttonLabel = active ? buttonLabelActive : buttonLabelInactive;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--header__action`]: true,
            [`${0, _settingsJs.prefix}--header__menu-trigger`]: true,
            [`${0, _settingsJs.prefix}--header__menu-toggle`]: true,
            [`${0, _settingsJs.prefix}--header__action--active`]: active
        });
        return (0, _lit.html)`
      <button
        part="button"
        class="${classes}"
        ?disabled=${disabled}
        aria-label="${(0, _ifDefinedJs.ifDefined)(buttonLabel)}"
        @click=${handleClick}>
        ${(active ? (0, _20JsDefault.default) : (0, _20JsDefault1.default))({
            slot: "toggle-icon"
        })}
      </button>
    `;
    }
    /**
     * The name of the custom event fired after this header menu button is toggled upon a user gesture.
     */ static get eventToggle() {
        return `${0, _settingsJs.prefix}-header-menu-button-toggled`;
    }
};
CDSHeaderMenuButton.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSHeaderMenuButton.styles = (0, _headerScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSHeaderMenuButton.prototype, "active", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "button-label-active"
    })
], CDSHeaderMenuButton.prototype, "buttonLabelActive", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "button-label-inactive"
    })
], CDSHeaderMenuButton.prototype, "buttonLabelInactive", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "collapse-mode"
    })
], CDSHeaderMenuButton.prototype, "collapseMode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSHeaderMenuButton.prototype, "disabled", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "is-not-child-of-header"
    })
], CDSHeaderMenuButton.prototype, "isNotChildOfHeader", void 0);
CDSHeaderMenuButton = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-header-menu-button`)
], CDSHeaderMenuButton);
var CDSHeaderMenuButton$1 = CDSHeaderMenuButton;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/close/20.js":"4EJkx","../../icons/menu/20.js":"9yyPM","lit/directives/if-defined.js":"hSgrS","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./side-nav.js":"6Kz8T","./header.scss.js":"4v21s","../../globals/decorators/carbon-element.js":"kNhLR","./defs.js":"k5LRh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Kz8T":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SIDE_NAV_COLLAPSE_MODE", ()=>(0, _defsJs.SIDE_NAV_COLLAPSE_MODE));
parcelHelpers.export(exports, "SIDE_NAV_USAGE_MODE", ()=>(0, _defsJs.SIDE_NAV_USAGE_MODE));
parcelHelpers.export(exports, "default", ()=>CDSSideNav$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _classMapJs = require("lit/directives/class-map.js");
var _settingsJs = require("../../globals/settings.js");
var _hostListenerJs = require("../../globals/mixins/host-listener.js");
var _hostListenerJsDefault = parcelHelpers.interopDefault(_hostListenerJs);
var _hostListenerJs1 = require("../../globals/decorators/host-listener.js");
var _hostListenerJsDefault1 = parcelHelpers.interopDefault(_hostListenerJs1);
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _defsJs = require("./defs.js");
var _sideNavScssJs = require("./side-nav.scss.js");
var _sideNavScssJsDefault = parcelHelpers.interopDefault(_sideNavScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Side nav.
 *
 * @element cds-side-nav
 * @fires cds-header-menu-button-toggled
 *   The name of the custom event fired after the header menu button in the document is toggled upon a user gesture.
 */ let CDSSideNav = class CDSSideNav extends (0, _hostListenerJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if this side nav is hovered.
         */ this._hovered = false;
        /**
         * The handle for `transitionend` event listener.
         */ this._hTransition = null;
        /**
         * Handles `${prefix}-header-menu-button-toggle` event on the document.
         */ this._handleButtonToggle = async (event)=>{
            this.expanded = event.detail.active;
        };
        /**
         * Collapse mode of the side nav.
         */ this.collapseMode = (0, _defsJs.SIDE_NAV_COLLAPSE_MODE).RESPONSIVE;
        /**
         * `true` to expand the side nav.
         */ this.expanded = false;
        /**
         * If `true` will style the side nav to sit below the header
         */ this.isNotChildOfHeader = false;
        /**
         * Specify if the side-nav will be persistent above the lg breakpoint
         */ this.isNotPersistent = false;
    }
    /**
     * Cleans the handle for `transitionend` event listener.
     */ _cleanHTransition() {
        if (this._hTransition) this._hTransition = this._hTransition.release();
    }
    /**
     * Force child side nav menus collapsed upon the hover/expanded state of this side nav.
     */ _updatedSideNavMenuForceCollapsedState() {
        const { expanded, _hovered: hovered } = this;
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(this.constructor.selectorMenu), (item)=>{
            item.forceCollapsed = !expanded && !hovered;
        });
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "navigation");
        super.connectedCallback();
    }
    disconnectedCallback() {
        this._cleanHTransition();
        super.disconnectedCallback();
    }
    updated(changedProperties) {
        var _a;
        const doc = this.getRootNode();
        if (changedProperties.has("collapseMode")) (0, _collectionHelpersJs.forEach)(doc.querySelectorAll(this.constructor.selectorButtonToggle), (item)=>{
            item.collapseMode = this.collapseMode;
        });
        if (changedProperties.has("expanded")) {
            const headerItems = doc.querySelectorAll(this.constructor.selectorHeaderItems);
            (0, _collectionHelpersJs.forEach)(doc.querySelectorAll(this.constructor.selectorButtonToggle), (item)=>{
                item.active = this.expanded;
            });
            if (this.expanded) {
                (0, _collectionHelpersJs.forEach)(headerItems, (item)=>{
                    item.setAttribute("tabindex", "-1");
                });
                (_a = this.querySelector(this.constructor.selectorNavItems)) === null || _a === void 0 || _a.focus();
            } else (0, _collectionHelpersJs.forEach)(headerItems, (item)=>{
                item.removeAttribute("tabindex");
            });
        }
        if (changedProperties.has("isNotChildOfHeader")) (0, _collectionHelpersJs.forEach)(doc.querySelectorAll(this.constructor.selectorButtonToggle), (item)=>{
            item.isNotChildOfHeader = this.isNotChildOfHeader;
        });
    }
    /**
     * Handles `blur` event handler on this element.
     *
     * @param event The event.
     * @param event.relatedTarget The event relatedTarget.
     */ _handleFocusOut({ relatedTarget }) {
        const { collapseMode } = this;
        if (collapseMode !== (0, _defsJs.SIDE_NAV_COLLAPSE_MODE).FIXED) {
            if (!this.contains(relatedTarget)) this.expanded = false;
        }
    }
    /**
     * Handles `focus` event handler on this element.
     *
     */ _handleFocusIn() {
        const { collapseMode } = this;
        if (collapseMode !== (0, _defsJs.SIDE_NAV_COLLAPSE_MODE).FIXED) this.expanded = true;
    }
    /**
     * Handles the `mouseover` event for the side nav in rail mode.
     *
     */ _handleNavMouseOver() {
        const { collapseMode } = this;
        if (collapseMode === (0, _defsJs.SIDE_NAV_COLLAPSE_MODE).RAIL) {
            this.expanded = true;
            this._hovered = true;
            this._updatedSideNavMenuForceCollapsedState();
        }
    }
    /**
     * Handles the `mouseout` event for the side nav in rail mode.
     *
     */ _handleNavMouseOut() {
        const { collapseMode } = this;
        if (collapseMode === (0, _defsJs.SIDE_NAV_COLLAPSE_MODE).RAIL) {
            this.expanded = false;
            this._hovered = false;
            this._updatedSideNavMenuForceCollapsedState();
        }
    }
    /**
     * Handles the `click` event for the side nav overlay.
     *
     */ _onOverlayClick() {
        this.expanded = false;
    }
    render() {
        const { collapseMode, expanded, isNotChildOfHeader, isNotPersistent } = this;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--side-nav__navigation`]: true,
            [`${0, _settingsJs.prefix}--side-nav`]: true,
            [`${0, _settingsJs.prefix}--side-nav--expanded`]: expanded,
            [`${0, _settingsJs.prefix}--side-nav--collapsed`]: !expanded && collapseMode === (0, _defsJs.SIDE_NAV_COLLAPSE_MODE).FIXED,
            [`${0, _settingsJs.prefix}--side-nav--rail`]: collapseMode === (0, _defsJs.SIDE_NAV_COLLAPSE_MODE).RAIL,
            [`${0, _settingsJs.prefix}--side-nav--ux`]: !isNotChildOfHeader,
            [`${0, _settingsJs.prefix}--side-nav--hidden`]: isNotPersistent
        });
        const overlayClasses = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--side-nav__overlay`]: true,
            [`${0, _settingsJs.prefix}--side-nav__overlay-active`]: expanded
        });
        return (0, _lit.html)`${this.collapseMode === (0, _defsJs.SIDE_NAV_COLLAPSE_MODE).FIXED ? null : (0, _lit.html)`<div
            class="${overlayClasses}"
            @click=${this._onOverlayClick}></div>`}
      <div
        class="${classes}"
        @mouseover="${this._handleNavMouseOver}"
        @mouseout="${this._handleNavMouseOut}">
        <slot></slot>
      </div>`;
    }
    /**
     * A selector that will return the toggle buttons.
     */ static get selectorButtonToggle() {
        return `${0, _settingsJs.prefix}-header-menu-button`;
    }
    /**
     * A selector that will return the header name + global action elements.
     */ static get selectorHeaderItems() {
        return `${0, _settingsJs.prefix}-header-name, ${0, _settingsJs.prefix}-header-global-action`;
    }
    /**
     * A selector that will return side nav focusable items.
     */ static get selectorNavItems() {
        return `${0, _settingsJs.prefix}-side-nav-menu, ${0, _settingsJs.prefix}-side-nav-menu-item, ${0, _settingsJs.prefix}-side-nav-link`;
    }
    /**
     * A selector that will return side nav menus.
     */ static get selectorMenu() {
        return `${0, _settingsJs.prefix}-side-nav-menu`;
    }
    /**
     * The name of the custom event fired after the header menu button in the document is toggled upon a user gesture.
     */ static get eventButtonToggle() {
        return `${0, _settingsJs.prefix}-header-menu-button-toggled`;
    }
};
CDSSideNav.styles = (0, _sideNavScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("parentRoot:eventButtonToggle")
], CDSSideNav.prototype, "_handleButtonToggle", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true,
        attribute: "collapse-mode"
    })
], CDSSideNav.prototype, "collapseMode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSideNav.prototype, "expanded", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "is-not-child-of-header"
    })
], CDSSideNav.prototype, "isNotChildOfHeader", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "is-not-persistent"
    })
], CDSSideNav.prototype, "isNotPersistent", void 0);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("focusout")
], CDSSideNav.prototype, "_handleFocusOut", null);
(0, _tslib.__decorate)([
    (0, _hostListenerJsDefault1.default)("focusin")
], CDSSideNav.prototype, "_handleFocusIn", null);
CDSSideNav = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-side-nav`)
], CDSSideNav);
var CDSSideNav$1 = CDSSideNav;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","lit/directives/class-map.js":"2fQud","../../globals/settings.js":"EipuL","../../globals/mixins/host-listener.js":"1SMUX","../../globals/decorators/host-listener.js":"f95Mj","../../globals/internal/collection-helpers.js":"4aZkz","./defs.js":"k5LRh","./side-nav.scss.js":"7liTx","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k5LRh":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Collapse modes of side nav.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SIDE_NAV_COLLAPSE_MODE", ()=>SIDE_NAV_COLLAPSE_MODE);
parcelHelpers.export(exports, "SIDE_NAV_USAGE_MODE", ()=>SIDE_NAV_USAGE_MODE);
var SIDE_NAV_COLLAPSE_MODE;
(function(SIDE_NAV_COLLAPSE_MODE) {
    /**
     * Fixed mode.
     * In this mode, side nav is non-collapsible.
     */ SIDE_NAV_COLLAPSE_MODE["FIXED"] = "fixed";
    /**
     * Rail mode.
     * In this mode, side nav can be collapsed to a narrower width ("rail" look) with a toggle button.
     */ SIDE_NAV_COLLAPSE_MODE["RAIL"] = "rail";
    /**
     * Responsive mode.
     * In this mode, side nav sticks in wider screen, and can be completely collapsed with a toggle button in narrower screen.
     */ SIDE_NAV_COLLAPSE_MODE["RESPONSIVE"] = "responsive";
})(SIDE_NAV_COLLAPSE_MODE || (SIDE_NAV_COLLAPSE_MODE = {}));
/**
 * The usage purpose of side nav.
 */ var SIDE_NAV_USAGE_MODE;
(function(SIDE_NAV_USAGE_MODE) {
    /**
     * Regular usage.
     */ SIDE_NAV_USAGE_MODE["REGULAR"] = "";
    /**
     * To represent header nav.
     * In this mode, side nav is hidden when header nav is shown, and side nav is shown then header nav is hidden.
     * This mode can be used only with `SIDE_NAV_COLLAPSE_MODE.REGULAR`.
     */ SIDE_NAV_USAGE_MODE["HEADER_NAV"] = "header-nav";
})(SIDE_NAV_USAGE_MODE || (SIDE_NAV_USAGE_MODE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7liTx":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _lit = require("lit");
var styles = (0, _lit.css)([
    '.cds--layer-one,:root{--cds-layer:var(--cds-layer-01,#f4f4f4);--cds-layer-active:var(--cds-layer-active-01,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-01,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-01,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-01,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-01,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-01,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-01,#a8a8a8);--cds-field:var(--cds-field-01,#f4f4f4);--cds-field-hover:var(--cds-field-hover-01,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-00,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-01,#c6c6c6);--cds-border-strong:var(--cds-border-strong-01,#8d8d8d);--cds-border-tile:var(--cds-border-tile-01,#c6c6c6)}.cds--layer-two{--cds-layer:var(--cds-layer-02,#fff);--cds-layer-active:var(--cds-layer-active-02,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-02,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-02,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-02,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-02,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-02,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-02,#a8a8a8);--cds-field:var(--cds-field-02,#fff);--cds-field-hover:var(--cds-field-hover-02,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-01,#c6c6c6);--cds-border-subtle-selected:var(--cds-border-subtle-selected-02,#c6c6c6);--cds-border-strong:var(--cds-border-strong-02,#8d8d8d);--cds-border-tile:var(--cds-border-tile-02,#a8a8a8)}.cds--layer-three{--cds-layer:var(--cds-layer-03,#f4f4f4);--cds-layer-active:var(--cds-layer-active-03,#c6c6c6);--cds-layer-hover:var(--cds-layer-hover-03,#e8e8e8);--cds-layer-selected:var(--cds-layer-selected-03,#e0e0e0);--cds-layer-selected-hover:var(--cds-layer-selected-hover-03,#d1d1d1);--cds-layer-accent:var(--cds-layer-accent-03,#e0e0e0);--cds-layer-accent-hover:var(--cds-layer-accent-hover-03,#d1d1d1);--cds-layer-accent-active:var(--cds-layer-accent-active-03,#a8a8a8);--cds-field:var(--cds-field-03,#f4f4f4);--cds-field-hover:var(--cds-field-hover-03,#e8e8e8);--cds-border-subtle:var(--cds-border-subtle-02,#e0e0e0);--cds-border-subtle-selected:var(--cds-border-subtle-selected-03,#c6c6c6);--cds-border-strong:var(--cds-border-strong-03,#8d8d8d);--cds-border-tile:var(--cds-border-tile-03,#c6c6c6)}.cds--side-nav{background-color:var(--cds-background,#fff);color:var(--cds-text-secondary,#525252);inline-size:3rem;inset-block:0;inset-inline-start:0;max-inline-size:16rem;overflow:hidden;position:fixed;transition:inline-size .11s cubic-bezier(.2,0,1,.9),transform .11s cubic-bezier(.2,0,1,.9);will-change:inline-size;z-index:8000}.cds--side-nav--ux{inline-size:16rem;inset-block-start:3rem}@media (max-width:65.98rem){.cds--side-nav--ux{inline-size:0}}.cds--side-nav--rail{inline-size:3rem}.cds--side-nav--hidden{inline-size:0}.cds--side-nav--expanded{inline-size:16rem}.cds--side-nav__overlay{background-color:transparent;block-size:0;inline-size:0;inset-block-start:3rem;inset-inline-start:0;opacity:0;position:fixed;transition:opacity .3s cubic-bezier(.5,0,.1,1),background-color .3s cubic-bezier(.5,0,.1,1)}@media (max-width:65.98rem){.cds--side-nav__overlay-active{background-color:var(--cds-overlay,hsla(0,0%,9%,.5));block-size:100vh;inline-size:100vw;opacity:1;transition:opacity .3s cubic-bezier(.5,0,.1,1),background-color .3s cubic-bezier(.5,0,.1,1);z-index:6000}}.cds--header~.cds--side-nav{block-size:calc(100% - 48px);inset-block-start:3rem}.cds--side-nav--fixed{inline-size:16rem}.cds--side-nav--collapsed{inline-size:16rem;transform:translateX(-16rem)}.cds--side-nav__navigation{display:flex;flex-direction:column}.cds--side-nav__items,:host(cds-side-nav-items){border:0;box-sizing:border-box;flex:1 1 0%;font-family:inherit;font-size:100%;margin:0;overflow:hidden;padding:1rem 0 0;vertical-align:baseline}.cds--side-nav__items *,.cds--side-nav__items :after,.cds--side-nav__items :before,:host(cds-side-nav-items) *,:host(cds-side-nav-items) :after,:host(cds-side-nav-items) :before{box-sizing:inherit}.cds--side-nav--expanded .cds--side-nav__items,.cds--side-nav--expanded :host(cds-side-nav-items),.cds--side-nav--fixed .cds--side-nav__items,.cds--side-nav--fixed :host(cds-side-nav-items),.cds--side-nav:hover .cds--side-nav__items,.cds--side-nav:hover :host(cds-side-nav-items){overflow-y:auto}.cds--side-nav--ux .cds--side-nav__items,.cds--side-nav--ux :host(cds-side-nav-items){overflow-y:auto}.cds--side-nav__item,:host(cds-side-nav-link),:host(cds-side-nav-menu){block-size:auto;inline-size:auto;overflow:hidden}.cds--side-nav--ux .cds--side-nav__item,.cds--side-nav--ux :host(cds-side-nav-link),.cds--side-nav--ux :host(cds-side-nav-menu){block-size:auto;inline-size:auto}.cds--side-nav .cds--header__menu-title[aria-expanded=true]:hover,.cds--side-nav a.cds--header__menu-item:hover,.cds--side-nav__item:not(.cds--side-nav__item--active):hover .cds--side-nav__item:not(.cds--side-nav__item--active)>.cds--side-nav__submenu:hover,.cds--side-nav__item:not(.cds--side-nav__item--active):hover :not(.cds--side-nav__item--active):host(cds-side-nav-link)>.cds--side-nav__submenu:hover,.cds--side-nav__item:not(.cds--side-nav__item--active):hover :not(.cds--side-nav__item--active):host(cds-side-nav-menu)>.cds--side-nav__submenu:hover,.cds--side-nav__item:not(.cds--side-nav__item--active)>.cds--side-nav__link:hover,.cds--side-nav__menu a.cds--side-nav__link:not(.cds--side-nav__link--current):not([aria-current=page]):hover,:not(.cds--side-nav__item--active):host(cds-side-nav-link)>.cds--side-nav__link:hover,:not(.cds--side-nav__item--active):host(cds-side-nav-menu)>.cds--side-nav__link:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12));color:var(--cds-text-primary,#161616)}.cds--side-nav__item:not(.cds--side-nav__item--active) .cds--side-nav__menu-item>.cds--side-nav__link:hover>span,.cds--side-nav__item:not(.cds--side-nav__item--active) :host(cds-side-nav-menu-item)>.cds--side-nav__link:hover>span,.cds--side-nav__item:not(.cds--side-nav__item--active)>.cds--side-nav__link:hover>span,:not(.cds--side-nav__item--active):host(cds-side-nav-link) .cds--side-nav__menu-item>.cds--side-nav__link:hover>span,:not(.cds--side-nav__item--active):host(cds-side-nav-link) :host(cds-side-nav-menu-item)>.cds--side-nav__link:hover>span,:not(.cds--side-nav__item--active):host(cds-side-nav-link)>.cds--side-nav__link:hover>span,:not(.cds--side-nav__item--active):host(cds-side-nav-menu) .cds--side-nav__menu-item>.cds--side-nav__link:hover>span,:not(.cds--side-nav__item--active):host(cds-side-nav-menu) :host(cds-side-nav-menu-item)>.cds--side-nav__link:hover>span,:not(.cds--side-nav__item--active):host(cds-side-nav-menu)>.cds--side-nav__link:hover>span{color:var(--cds-text-primary,#161616)}.cds--side-nav__item--large,:host(cds-side-nav-link[large]),:host(cds-side-nav-menu[large]){block-size:auto}.cds--side-nav__divider,:host(cds-side-nav-divider){background-color:var(--cds-border-subtle);block-size:1px;list-style-type:none;margin:.5rem 1rem}.cds--side-nav__divider hr,:host(cds-side-nav-divider) hr{border:none}.cds--side-nav__submenu{align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;block-size:2rem;border:0;box-sizing:border-box;color:var(--cds-text-secondary,#525252);cursor:pointer;display:inline-block;display:flex;font-family:inherit;font-size:100%;font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);inline-size:100%;letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);margin:0;outline:2px solid transparent;outline-offset:-2px;padding:0 1rem;text-align:start;transition:color .11s,background-color .11s,outline .11s;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:baseline}.cds--side-nav__submenu *,.cds--side-nav__submenu :after,.cds--side-nav__submenu :before{box-sizing:inherit}.cds--side-nav__submenu::-moz-focus-inner{border:0}.cds--side-nav__submenu:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12));color:var(--cds-text-primary,#161616)}.cds--side-nav__submenu:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--side-nav__submenu:focus{outline-style:dotted}}.cds--side-nav__submenu-title{overflow:hidden;text-align:start;text-overflow:ellipsis;white-space:nowrap}.cds--side-nav__icon.cds--side-nav__submenu-chevron{display:flex;flex:1;justify-content:flex-end}.cds--side-nav__submenu-chevron>svg{block-size:1rem;inline-size:1rem;transition:transform .11s}.cds--side-nav__submenu[aria-expanded=true] .cds--side-nav__submenu-chevron>svg{transform:rotate(180deg)}.cds--side-nav__item--large .cds--side-nav__submenu,:host(cds-side-nav-link[large]) .cds--side-nav__submenu,:host(cds-side-nav-menu[large]) .cds--side-nav__submenu{block-size:3rem}.cds--side-nav__item--active .cds--side-nav__submenu:hover,:host(cds-side-nav-menu[active]) .cds--side-nav__submenu:hover{background-color:var(--cds-background-selected,hsla(0,0%,55%,.2));color:var(--cds-text-primary,#161616)}.cds--side-nav__item--active .cds--side-nav__submenu[aria-expanded=false],:host(cds-side-nav-menu[active]) .cds--side-nav__submenu[aria-expanded=false]{background-color:var(--cds-background-selected,hsla(0,0%,55%,.2));color:var(--cds-text-primary,#161616);position:relative}.cds--side-nav__item--active .cds--side-nav__submenu[aria-expanded=false]:before,:host(cds-side-nav-menu[active]) .cds--side-nav__submenu[aria-expanded=false]:before{background-color:var(--cds-border-interactive,#0f62fe);content:"";inline-size:3px;inset-block:0;inset-inline-start:0;position:absolute}.cds--side-nav__item--active .cds--side-nav__submenu-title,:host(cds-side-nav-menu[active]) .cds--side-nav__submenu-title{color:var(--cds-text-primary,#161616);font-weight:600}.cds--side-nav__item--active .cds--side-nav__icon>svg,:host(cds-side-nav-menu[active]) .cds--side-nav__icon>svg{fill:var(--cds-icon-primary,#161616)}.cds--side-nav__menu{border:0;box-sizing:border-box;display:block;font-family:inherit;font-size:100%;margin:0;max-block-size:0;padding:0;vertical-align:baseline;visibility:hidden}.cds--side-nav__menu *,.cds--side-nav__menu :after,.cds--side-nav__menu :before{box-sizing:inherit}.cds--side-nav__submenu[aria-expanded=true]+.cds--side-nav__menu{max-block-size:93.75rem;visibility:inherit}.cds--side-nav__menu a.cds--side-nav__link{block-size:2rem;font-weight:400;min-block-size:2rem;padding-inline-start:2rem}.cds--side-nav__item.cds--side-nav__item--icon a.cds--side-nav__link,:host(cds-side-nav-menu):host(cds-side-nav-menu[has-icon]) a.cds--side-nav__link{padding-inline-start:4.5rem}.cds--side-nav__menu a.cds--side-nav__link--current,.cds--side-nav__menu a.cds--side-nav__link[aria-current=page],a.cds--side-nav__link--current{background-color:var(--cds-background-selected,hsla(0,0%,55%,.2))}.cds--side-nav__menu a.cds--side-nav__link--current>span,.cds--side-nav__menu a.cds--side-nav__link[aria-current=page]>span,a.cds--side-nav__link--current>span{color:var(--cds-text-primary,#161616);font-weight:600}.cds--side-nav .cds--header__menu-title[aria-expanded=true]+.cds--header__menu,.cds--side-nav a.cds--header__menu-item,a.cds--side-nav__link{align-items:center;display:flex;font-size:var(--cds-heading-compact-01-font-size,.875rem);font-weight:var(--cds-heading-compact-01-font-weight,600);letter-spacing:var(--cds-heading-compact-01-letter-spacing,.16px);line-height:var(--cds-heading-compact-01-line-height,1.28572);min-block-size:2rem;outline:2px solid transparent;outline-offset:-2px;padding:0 1rem;position:relative;text-decoration:none;transition:color .11s,background-color .11s,outline .11s}.cds--side-nav__item--large a.cds--side-nav__link,:host(cds-side-nav-link[large]) a.cds--side-nav__link,:host(cds-side-nav-menu[large]) a.cds--side-nav__link{block-size:3rem}.cds--side-nav a.cds--header__menu-item .cds--text-truncate-end,a.cds--side-nav__link>.cds--side-nav__link-text{color:var(--cds-text-secondary,#525252);font-size:.875rem;letter-spacing:.1px;line-height:1.25rem;overflow:hidden;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;user-select:none;white-space:nowrap}.cds--side-nav a.cds--header__menu-item:focus,a.cds--side-nav__link:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.cds--side-nav a.cds--header__menu-item:focus,a.cds--side-nav__link:focus{outline-style:dotted}}a.cds--side-nav__link--current,a.cds--side-nav__link[aria-current=page]{background-color:var(--cds-background-selected,hsla(0,0%,55%,.2));font-weight:600}a.cds--side-nav__link--current .cds--side-nav__link-text,a.cds--side-nav__link[aria-current=page] .cds--side-nav__link-text{color:var(--cds-text-primary,#161616)}a.cds--side-nav__link--current:before,a.cds--side-nav__link[aria-current=page]:before{background-color:var(--cds-border-interactive,#0f62fe);content:"";inline-size:3px;inset-block:0;inset-inline-start:0;position:absolute}.cds--side-nav__icon{align-items:center;display:flex;flex:0 0 1rem;justify-content:center}.cds--side-nav__icon:not(.cds--side-nav__submenu-chevron){margin-inline-end:1.5rem}.cds--side-nav__icon>svg{block-size:1rem;fill:var(--cds-icon-secondary,#525252);inline-size:1rem}.cds--side-nav--expanded .cds--side-nav__icon>svg.cds--side-nav-expand-icon,.cds--side-nav__icon>svg.cds--side-nav-collapse-icon{display:none}.cds--side-nav--expanded .cds--side-nav__icon>svg.cds--side-nav-collapse-icon{display:block}.cds--side-nav--fixed .cds--side-nav__submenu,.cds--side-nav--fixed a.cds--side-nav__link{padding-inline-start:1rem}.cds--side-nav--fixed .cds--side-nav__item:not(.cds--side-nav__item--icon) .cds--side-nav__menu a.cds--side-nav__link,.cds--side-nav--fixed :not(.cds--side-nav__item--icon):host(cds-side-nav-link) .cds--side-nav__menu a.cds--side-nav__link,.cds--side-nav--fixed :not(.cds--side-nav__item--icon):host(cds-side-nav-menu) .cds--side-nav__menu a.cds--side-nav__link{padding-inline-start:2rem}@media (max-width:65.98rem){.cds--side-nav .cds--header__nav{display:block}}.cds--side-nav__header-navigation,:host(cds-header-side-nav-items){border:0;box-sizing:border-box;display:none;font-family:inherit;font-size:100%;margin:0;padding:0;vertical-align:baseline}.cds--side-nav__header-navigation *,.cds--side-nav__header-navigation :after,.cds--side-nav__header-navigation :before,:host(cds-header-side-nav-items) *,:host(cds-header-side-nav-items) :after,:host(cds-header-side-nav-items) :before{box-sizing:inherit}@media (max-width:65.98rem){.cds--side-nav__header-navigation,:host(cds-header-side-nav-items){display:block;margin-block-end:2rem;position:relative}}.cds--side-nav__header-divider:after{background:var(--cds-border-subtle);block-size:.0625rem;content:"";inline-size:calc(100% - 32px);inset-block-end:-1rem;inset-inline-start:1rem;position:absolute}.cds--side-nav a.cds--header__menu-item{color:var(--cds-text-secondary,#525252);justify-content:space-between;white-space:nowrap}.cds--side-nav a.cds--header__menu-item[aria-expanded=true]{background-color:transparent}.cds--side-nav .cds--header__menu-title[aria-expanded=true]+.cds--header__menu{background-color:transparent;box-shadow:none;inline-size:100%;inset-block-end:inherit;padding:0;transform:none}.cds--side-nav .cds--header__menu-title[aria-expanded=true]+.cds--header__menu li{inline-size:100%}.cds--side-nav .cds--header__menu-title[aria-expanded=true]+.cds--header__menu a.cds--header__menu-item{font-weight:400;padding-inline-start:4.25rem}.cds--side-nav .cds--header__menu-title[aria-expanded=true]+.cds--header__menu a.cds--header__menu-item:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12));color:var(--cds-text-primary,#161616)}.cds--side-nav .cds--header__menu-title[aria-expanded=true]+.cds--header__menu a.cds--header__menu-item--current:hover{background-color:var(--cds-layer-selected-hover)}.cds--side-nav .cds--side-nav__header-navigation .cds--header__menu-item--current:after,.cds--side-nav .cds--side-nav__header-navigation a.cds--header__menu-item[aria-current=page]:after,.cds--side-nav :host(cds-header-side-nav-items) .cds--header__menu-item--current:after,.cds--side-nav :host(cds-header-side-nav-items) a.cds--header__menu-item[aria-current=page]:after{block-size:calc(100% + 4px);inline-size:3px}.cds--side-nav .cds--header__menu a.cds--header__menu-item{block-size:inherit}.cds--side-nav .cds--header__menu-arrow,.cds--side-nav a.cds--header__menu-item:focus .cds--header__menu-arrow,.cds--side-nav a.cds--header__menu-item:hover .cds--header__menu-arrow{fill:var(--cds-icon-secondary,#525252)}@media (forced-colors:active),screen and (-ms-high-contrast:active){.cds--side-nav .cds--header__menu-arrow,.cds--side-nav a.cds--header__menu-item:focus .cds--header__menu-arrow,.cds--side-nav a.cds--header__menu-item:hover .cds--header__menu-arrow,.cds--side-nav__icon>svg{fill:ButtonText}}:host(cds-side-nav[expanded]) ::slotted(cds-side-nav-items){overflow-y:auto}:host(cds-side-nav-link){block-size:auto;display:block;inline-size:auto;outline:none}:host(cds-side-nav-link) .cds--side-nav__icon{color:var(--cds-text-primary,#161616)}:host(cds-side-nav-link) .cds--side-nav__icon[hidden]{display:none}:host(cds-side-nav-divider){display:block}:host(cds-side-nav-menu){display:block}:host(cds-side-nav-menu) .cds--side-nav__icon[hidden]{display:none}:host(cds-side-nav-menu) .cds--side-nav__menu{margin:0;padding:0}:host(cds-side-nav-menu) .cds--side-nav__submenu[aria-expanded=true]+.cds--side-nav__menu{max-block-size:none}:host(cds-side-nav-menu[active]){color:var(--cds-text-primary,#161616);position:relative}:host(cds-side-nav-menu[active]):before{background-color:var(--cds-border-interactive,#0f62fe);content:"";inline-size:.25rem;inset-block:0;inset-inline-start:0;position:absolute}:host(cds-side-nav-menu[active][expanded]){background-color:inherit;color:inherit;position:inherit}:host(cds-side-nav-menu[active][expanded]):before{content:none}:host(cds-side-nav-menu-item){block-size:auto;display:block;inline-size:auto;outline:none}:host(cds-side-nav-menu-item) a.cds--side-nav__link{block-size:2rem;font-weight:400;min-block-size:2rem;padding-inline-start:2rem}:host(cds-side-nav-menu-item[parent-has-icon]) a.cds--side-nav__link{padding-inline-start:4.5rem}:host(cds-side-nav-item) .cds--side-nav__link:hover,:host(cds-side-nav-menu) .cds--side-nav__submenu:hover,:host(cds-side-nav-menu-item) .cds--side-nav__link:hover{background-color:var(--cds-background-hover,hsla(0,0%,55%,.12));color:var(--cds-text-primary,#161616)}'
]);

},{"lit":"aCmte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7lqaC":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSHeaderMenuItem$1);
var _tslib = require("tslib");
var _settingsJs = require("../../globals/settings.js");
var _headerNavItemJs = require("./header-nav-item.js");
var _headerNavItemJsDefault = parcelHelpers.interopDefault(_headerNavItemJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Header submenu item.
 *
 * @element cds-header-menu-item
 */ let CDSHeaderMenuItem = class CDSHeaderMenuItem extends (0, _headerNavItemJsDefault.default) {
};
CDSHeaderMenuItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-header-menu-item`)
], CDSHeaderMenuItem);
var CDSHeaderMenuItem$1 = CDSHeaderMenuItem;

},{"tslib":"gBS4y","../../globals/settings.js":"EipuL","./header-nav-item.js":"kDEmT","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kDEmT":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSHeaderNavItem$1);
var _tslib = require("tslib");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _headerScssJs = require("./header.scss.js");
var _headerScssJsDefault = parcelHelpers.interopDefault(_headerScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Header nav item.
 *
 * @element cds-header-nav-item
 * @csspart link The link.
 * @csspart title The title.
 */ let CDSHeaderNavItem = class CDSHeaderNavItem extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * Applies selected styles to the item if a user sets this to true and `aria-current !== 'page'`.
         */ this.isActive = false;
        /**
         * As child of <ul>, this element must have role of listitem
         */ this.role = "listitem";
    }
    render() {
        const { ariaCurrent, href, isActive, title, rel, target } = this;
        const linkClass = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--header__menu-item`]: true,
            [`${0, _settingsJs.prefix}--header__menu-item--current`]: isActive && ariaCurrent !== "page"
        });
        return (0, _lit.html)`
      <a
        part="link"
        class="${linkClass}"
        tabindex="0"
        href="${(0, _ifDefinedJs.ifDefined)(href)}"
        rel="${(0, _ifDefinedJs.ifDefined)(rel)}"
        target="${(0, _ifDefinedJs.ifDefined)(target)}">
        <span part="title" class="${0, _settingsJs.prefix}--text-truncate--end"
          ><slot>${title}</slot></span
        >
      </a>
    `;
    }
};
CDSHeaderNavItem.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSHeaderNavItem.styles = (0, _headerScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSHeaderNavItem.prototype, "href", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSHeaderNavItem.prototype, "rel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSHeaderNavItem.prototype, "target", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSHeaderNavItem.prototype, "title", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "is-active"
    })
], CDSHeaderNavItem.prototype, "isActive", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        attribute: "aria-current"
    })
], CDSHeaderNavItem.prototype, "ariaCurrent", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSHeaderNavItem.prototype, "role", void 0);
CDSHeaderNavItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-header-nav-item`)
], CDSHeaderNavItem);
var CDSHeaderNavItem$1 = CDSHeaderNavItem;

},{"tslib":"gBS4y","lit/directives/if-defined.js":"hSgrS","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./header.scss.js":"4v21s","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"85ErU":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSHeaderName$1);
var _tslib = require("tslib");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _headerScssJs = require("./header.scss.js");
var _headerScssJsDefault = parcelHelpers.interopDefault(_headerScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The product name UI in header nav.
 *
 * @element cds-header-name
 * @csspart link The link.
 * @csspart prefix The prefix content.
 */ let CDSHeaderName = class CDSHeaderName extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    render() {
        const { href, prefix: namePrefix } = this;
        const namePrefixPart = !namePrefix ? undefined : (0, _lit.html)`
          <span part="prefix" class="${0, _settingsJs.prefix}--header__name--prefix"
            >${namePrefix}</span
          >
        `;
        return (0, _lit.html)`
      <a part="link" class="${0, _settingsJs.prefix}--header__name" href="${(0, _ifDefinedJs.ifDefined)(href)}"
        >${namePrefixPart}&nbsp;<slot></slot
      ></a>
    `;
    }
};
CDSHeaderName.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSHeaderName.styles = (0, _headerScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSHeaderName.prototype, "href", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSHeaderName.prototype, "prefix", void 0);
CDSHeaderName = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-header-name`)
], CDSHeaderName);
var CDSHeaderName$1 = CDSHeaderName;

},{"tslib":"gBS4y","lit/directives/if-defined.js":"hSgrS","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./header.scss.js":"4v21s","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ltNn5":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSHeaderNav$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _headerScssJs = require("./header.scss.js");
var _headerScssJsDefault = parcelHelpers.interopDefault(_headerScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Header.
 *
 * @element cds-header-nav
 * @csspart menu-body The menu body.
 * @csspart divider The divider.
 */ let CDSHeaderNav = class CDSHeaderNav extends (0, _lit.LitElement) {
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "navigation");
        super.connectedCallback();
    }
    render() {
        const { menuBarLabel } = this;
        return (0, _lit.html)`
      <div part="divider" class="${0, _settingsJs.prefix}-ce--header__divider"></div>
      <ul
        part="menu-body"
        class="${0, _settingsJs.prefix}--header__menu-bar"
        aria-label="${menuBarLabel}">
        <slot></slot>
      </ul>
    `;
    }
};
CDSHeaderNav.styles = (0, _headerScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        attribute: "menu-bar-label"
    })
], CDSHeaderNav.prototype, "menuBarLabel", void 0);
CDSHeaderNav = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-header-nav`)
], CDSHeaderNav);
var CDSHeaderNav$1 = CDSHeaderNav;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","./header.scss.js":"4v21s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2opJX":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSHeaderPanel$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _headerScssJs = require("./header.scss.js");
var _headerScssJsDefault = parcelHelpers.interopDefault(_headerScssJs);
var _settingsJs = require("../../globals/settings.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2023, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Header panel
 *
 * @element cds-header-panel
 */ let CDSHeaderPanel = class CDSHeaderPanel extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)`<slot></slot>`;
    }
};
CDSHeaderPanel.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSHeaderPanel.styles = (0, _headerScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSHeaderPanel.prototype, "expanded", void 0);
CDSHeaderPanel = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-header-panel`)
], CDSHeaderPanel);
var CDSHeaderPanel$1 = CDSHeaderPanel;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","./header.scss.js":"4v21s","../../globals/settings.js":"EipuL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4SV6w":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSHeaderSideNavItems$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _settingsJs = require("../../globals/settings.js");
var _sideNavScssJs = require("./side-nav.scss.js");
var _sideNavScssJsDefault = parcelHelpers.interopDefault(_sideNavScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2023, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Header Side Nav Items section
 *
 * @element cds-header-side-nav-items
 */ let CDSHeaderSideNavItems = class CDSHeaderSideNavItems extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        /**
         * Optionally specify if container will have a bottom divider to differentiate
         * between original sidenav items and header menu items. False by default.
         */ this.hasDivider = false;
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "list");
        super.connectedCallback();
    }
    render() {
        return (0, _lit.html)`<slot></slot>`;
    }
};
CDSHeaderSideNavItems.styles = (0, _sideNavScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        attribute: "has-divider"
    })
], CDSHeaderSideNavItems.prototype, "hasDivider", void 0);
CDSHeaderSideNavItems = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-header-side-nav-items`)
], CDSHeaderSideNavItems);
var CDSHeaderSideNavItems$1 = CDSHeaderSideNavItems;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/settings.js":"EipuL","./side-nav.scss.js":"7liTx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dsuu6":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSideNavDivider$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _sideNavScssJs = require("./side-nav.scss.js");
var _sideNavScssJsDefault = parcelHelpers.interopDefault(_sideNavScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2021, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * A divider in side nav.
 *
 * @element cds-side-nav-divider
 */ let CDSSideNavDivider = class CDSSideNavDivider extends (0, _lit.LitElement) {
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "separator");
        super.connectedCallback();
    }
};
CDSSideNavDivider.styles = (0, _sideNavScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
CDSSideNavDivider = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-side-nav-divider`)
], CDSSideNavDivider);
var CDSSideNavDivider$1 = CDSSideNavDivider;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","./side-nav.scss.js":"7liTx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hef8D":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSideNavItems$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _sideNavScssJs = require("./side-nav.scss.js");
var _sideNavScssJsDefault = parcelHelpers.interopDefault(_sideNavScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Side nav items.
 *
 * @element cds-side-nav-items
 */ let CDSSideNavItems = class CDSSideNavItems extends (0, _lit.LitElement) {
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "list");
        super.connectedCallback();
    }
    render() {
        return (0, _lit.html)`<slot></slot>`;
    }
};
CDSSideNavItems.styles = (0, _sideNavScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
CDSSideNavItems = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-side-nav-items`)
], CDSSideNavItems);
var CDSSideNavItems$1 = CDSSideNavItems;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","../../globals/decorators/carbon-element.js":"kNhLR","./side-nav.scss.js":"7liTx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5cwBS":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSideNavLink$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _ifDefinedJs = require("lit/directives/if-defined.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _sideNavScssJs = require("./side-nav.scss.js");
var _sideNavScssJsDefault = parcelHelpers.interopDefault(_sideNavScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Side nav menu item.
 *
 * @element cds-side-nav-link
 * @slot link - The link.
 * @slot title - The title.
 * @slot title-icon-container - The title icon container.
 */ let CDSSideNavLink = class CDSSideNavLink extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if the menu item should be active.
         */ this.active = false;
        /**
         * Link `href`.
         */ this.href = "";
        /**
         * Specify if this is a large variation of the side nav link
         */ this.large = false;
    }
    /**
     * Handles `slotchange` event on the `<slot>` for the title icon.
     */ _handleSlotChangeTitleIcon({ target }) {
        var _a;
        (_a = this._titleIconContainerNode) === null || _a === void 0 || _a.toggleAttribute("hidden", target.assignedNodes().length === 0);
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "listitem");
        super.connectedCallback();
    }
    render() {
        const { active, href, rel, target, title, _handleSlotChangeTitleIcon: handleSlotChangeTitleIcon } = this;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--side-nav__link`]: true,
            [`${0, _settingsJs.prefix}--side-nav__link--current`]: active
        });
        return (0, _lit.html)`
      <a
        part="link"
        class="${classes}"
        href="${href}"
        rel="${(0, _ifDefinedJs.ifDefined)(rel)}"
        target="${(0, _ifDefinedJs.ifDefined)(target)}">
        <div
          id="title-icon-container"
          part="title-icon-container"
          hidden
          class="${0, _settingsJs.prefix}--side-nav__icon">
          <slot
            name="title-icon"
            @slotchange=${handleSlotChangeTitleIcon}></slot>
        </div>
        <span part="title" class="${0, _settingsJs.prefix}--side-nav__link-text">
          <slot>${title}</slot>
        </span>
      </a>
    `;
    }
};
CDSSideNavLink.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSSideNavLink.styles = (0, _sideNavScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#title-icon-container")
], CDSSideNavLink.prototype, "_titleIconContainerNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSideNavLink.prototype, "active", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSideNavLink.prototype, "href", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSSideNavLink.prototype, "rel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        reflect: true
    })
], CDSSideNavLink.prototype, "target", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSideNavLink.prototype, "large", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSideNavLink.prototype, "title", void 0);
CDSSideNavLink = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-side-nav-link`)
], CDSSideNavLink);
var CDSSideNavLink$1 = CDSSideNavLink;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit/directives/if-defined.js":"hSgrS","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./side-nav.scss.js":"7liTx","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Y4Cu":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSideNavMenu$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _20Js = require("../../icons/chevron--down/20.js");
var _20JsDefault = parcelHelpers.interopDefault(_20Js);
var _settingsJs = require("../../globals/settings.js");
var _collectionHelpersJs = require("../../globals/internal/collection-helpers.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _sideNavScssJs = require("./side-nav.scss.js");
var _sideNavScssJsDefault = parcelHelpers.interopDefault(_sideNavScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Side nav menu.
 *
 * @element cds-side-nav-menu
 * @fires cds-side-nav-menu-beingtoggled
 *   The name of the custom event fired before this side nav menu is being toggled upon a user gesture.
 *   Cancellation of this event stops the user-initiated action of toggling this side nav menu.
 * @fires cds-side-nav-menu-toggled
 *   The name of the custom event fired after this side nav menu is toggled upon a user gesture.
 * @slot title-icon - The icon.
 * @csspart expando The expando.
 * @csspart expando-icon-container The expando icon container.
 * @csspart expando-icon The expando icon.
 * @csspart title The title.
 * @csspart title-icon-container The title icon container.
 * @csspart menu-body The menu body.
 */ let CDSSideNavMenu = class CDSSideNavMenu extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if this menu has an icon.
         */ this._hasIcon = false;
        /**
         * `true` if the menu has active menu item.
         */ this.active = false;
        /**
         * `true` if the menu should be open.
         */ this.expanded = false;
        /**
         * Specify if this is a large variation of the side nav menu
         */ this.large = false;
        /**
         * `true` if the menu should be forced collapsed upon side nav's expanded state.
         */ this.forceCollapsed = false;
        /**
         * The title text.
         */ this.title = "";
    }
    /**
     * Handles user-initiated toggle request of this side nav menu.
     *
     * @param expanded The new expanded state.
     */ _handleUserInitiatedToggle(expanded = !this.expanded) {
        const { eventBeforeToggle, eventToggle } = this.constructor;
        const init = {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: {
                expanded
            }
        };
        if (this.dispatchEvent(new CustomEvent(eventBeforeToggle, init))) {
            this.expanded = expanded;
            this.dispatchEvent(new CustomEvent(eventToggle, init));
        }
    }
    /**
     * Handler for the `click` event on the expando button.
     */ _handleClickExpando() {
        this._handleUserInitiatedToggle();
    }
    /**
     * Handles `slotchange` event on the non-named `<slot>`.
     */ _handleSlotChange({ target }) {
        const { _hasIcon: hasIcon } = this;
        (0, _collectionHelpersJs.forEach)(target.assignedNodes(), (item)=>{
            if (item.nodeType === Node.ELEMENT_NODE) item.toggleAttribute(this.constructor.attribItemHasIcon, hasIcon);
        });
    }
    /**
     * Handles `slotchange` event on the `<slot>` for the title icon.
     */ _handleSlotChangeTitleIcon({ target }) {
        var _a;
        const constructor = this.constructor;
        const hasIcon = target.assignedNodes().length > 0;
        this._hasIcon = hasIcon;
        (_a = this._titleIconContainerNode) === null || _a === void 0 || _a.toggleAttribute("hidden", !hasIcon);
        (0, _collectionHelpersJs.forEach)(this.querySelectorAll(constructor.selectorItem), (item)=>{
            item.toggleAttribute(constructor.attribItemHasIcon, hasIcon);
        });
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "listitem");
        super.connectedCallback();
    }
    updated(changedProperties) {
        if (changedProperties.has("expanded")) {
            const { selectorItem } = this.constructor;
            const { expanded } = this;
            (0, _collectionHelpersJs.forEach)(this.querySelectorAll(selectorItem), (elem)=>{
                elem.tabIndex = expanded ? 0 : -1;
            });
        }
    }
    render() {
        const { expanded, forceCollapsed, title, _handleClickExpando: handleClickExpando, _handleSlotChange: handleSlotChange, _handleSlotChangeTitleIcon: handleSlotChangeTitleIcon } = this;
        return (0, _lit.html)`
      <button
        type="button"
        part="expando"
        aria-haspopup="true"
        aria-expanded="${String(Boolean(expanded && !forceCollapsed))}"
        class="${0, _settingsJs.prefix}--side-nav__submenu"
        @click=${handleClickExpando}>
        <div
          id="title-icon-container"
          part="title-icon-container"
          hidden
          class="${0, _settingsJs.prefix}--side-nav__icon">
          <slot
            name="title-icon"
            @slotchange=${handleSlotChangeTitleIcon}></slot>
        </div>
        <span part="title" class="${0, _settingsJs.prefix}--side-nav__submenu-title"
          >${title}</span
        >
        <div
          part="expando-icon-container"
          class="${0, _settingsJs.prefix}--side-nav__icon ${0, _settingsJs.prefix}--side-nav__icon--small ${0, _settingsJs.prefix}--side-nav__submenu-chevron">
          ${(0, _20JsDefault.default)({
            part: "expando-icon"
        })}
        </div>
      </button>
      <ul part="menu-body" class="${0, _settingsJs.prefix}--side-nav__menu">
        <slot @slotchange=${handleSlotChange}></slot>
      </ul>
    `;
    }
    /**
     * A selector that will return the menu items.
     */ static get selectorItem() {
        return `${0, _settingsJs.prefix}-side-nav-menu-item`;
    }
    /**
     * The name of the custom event fired before this side nav menu is being toggled upon a user gesture.
     * Cancellation of this event stops the user-initiated action of toggling this side nav menu.
     */ static get eventBeforeToggle() {
        return `${0, _settingsJs.prefix}-side-nav-menu-beingtoggled`;
    }
    /**
     * The name of the custom event fired after this side nav menu is toggled upon a user gesture.
     */ static get eventToggle() {
        return `${0, _settingsJs.prefix}-side-nav-menu-toggled`;
    }
};
/**
 * The attribute name of the menu items, that is set if this menu has an icon.
 */ CDSSideNavMenu.attribItemHasIcon = "parent-has-icon";
CDSSideNavMenu.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSSideNavMenu.styles = (0, _sideNavScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.query)("#title-icon-container")
], CDSSideNavMenu.prototype, "_titleIconContainerNode", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSideNavMenu.prototype, "active", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSideNavMenu.prototype, "expanded", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSideNavMenu.prototype, "large", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true,
        attribute: "force-collapsed"
    })
], CDSSideNavMenu.prototype, "forceCollapsed", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSideNavMenu.prototype, "title", void 0);
CDSSideNavMenu = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-side-nav-menu`)
], CDSSideNavMenu);
var CDSSideNavMenu$1 = CDSSideNavMenu;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../icons/chevron--down/20.js":"6r0Ag","../../globals/settings.js":"EipuL","../../globals/internal/collection-helpers.js":"4aZkz","../../globals/mixins/focus.js":"5k7ow","./side-nav.scss.js":"7liTx","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6r0Ag":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lit = require("lit");
var _spreadJs = require("../../globals/directives/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
const svgResultCarbonIcon = ({ children, ...attrs } = {})=>(0, _lit.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, _spreadJsDefault.default)(attrs)}" aria-hidden="true" width="20" height="20" viewBox="0 0 32 32">${children}<path d="M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"></path></svg>`;
exports.default = svgResultCarbonIcon;

},{"lit":"aCmte","../../globals/directives/spread.js":"iXjMk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jgtSi":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSideNavMenuItem$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _sideNavScssJs = require("./side-nav.scss.js");
var _sideNavScssJsDefault = parcelHelpers.interopDefault(_sideNavScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Side nav menu item.
 *
 * @element cds-side-nav-menu-item
 * @csspart link The link.
 * @csspart title The title.
 */ let CDSSideNavMenuItem = class CDSSideNavMenuItem extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * `true` if the menu item should be active.
         */ this.active = false;
        /**
         * Link `href`.
         */ this.href = "";
    }
    shouldUpdate(changedProperties) {
        if (changedProperties.has("active") && this.active) {
            const { selectorMenu } = this.constructor;
            const parent = this.closest(selectorMenu);
            if (parent) parent.active = true;
        }
        return true;
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "button");
        super.connectedCallback();
    }
    render() {
        const { active, href, title } = this;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--side-nav__link`]: true,
            [`${0, _settingsJs.prefix}--side-nav__link--current`]: active
        });
        return (0, _lit.html)`
      <a part="link" class="${classes}" href="${href}">
        <span part="title" class="${0, _settingsJs.prefix}--side-nav__link-text">
          <slot>${title}</slot>
        </span>
      </a>
    `;
    }
    /**
     * A selector that will return the parent menu.
     */ static get selectorMenu() {
        return `${0, _settingsJs.prefix}-side-nav-menu`;
    }
};
CDSSideNavMenuItem.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSSideNavMenuItem.styles = (0, _sideNavScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSideNavMenuItem.prototype, "active", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSideNavMenuItem.prototype, "href", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSideNavMenuItem.prototype, "title", void 0);
CDSSideNavMenuItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-side-nav-menu-item`)
], CDSSideNavMenuItem);
var CDSSideNavMenuItem$1 = CDSSideNavMenuItem;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./side-nav.scss.js":"7liTx","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1XKZj":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSwitcher$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _headerScssJs = require("./header.scss.js");
var _headerScssJsDefault = parcelHelpers.interopDefault(_headerScssJs);
var _settingsJs = require("../../globals/settings.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2023, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Switcher
 *
 * @element cds-switcher
 */ let CDSSwitcher = class CDSSwitcher extends (0, _lit.LitElement) {
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "list");
        super.connectedCallback();
    }
    render() {
        return (0, _lit.html)`<slot></slot>`;
    }
};
CDSSwitcher.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSSwitcher.styles = (0, _headerScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        attribute: "aria-label"
    })
], CDSSwitcher.prototype, "ariaLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        attribute: "aria-labelledby"
    })
], CDSSwitcher.prototype, "ariaLabelledBy", void 0);
CDSSwitcher = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-switcher`)
], CDSSwitcher);
var CDSSwitcher$1 = CDSSwitcher;

},{"tslib":"gBS4y","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","./header.scss.js":"4v21s","../../globals/settings.js":"EipuL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"RuuEd":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSwitcherDivider$1);
var _tslib = require("tslib");
var _lit = require("lit");
var _settingsJs = require("../../globals/settings.js");
var _headerScssJs = require("./header.scss.js");
var _headerScssJsDefault = parcelHelpers.interopDefault(_headerScssJs);
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
/**
 * @license
 *
 * Copyright IBM Corp. 2023, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * A divider in switcher.
 *
 * @element cds-switcher-divider
 */ let CDSSwitcherDivider = class CDSSwitcherDivider extends (0, _lit.LitElement) {
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "separator");
        super.connectedCallback();
    }
};
CDSSwitcherDivider.styles = (0, _headerScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
CDSSwitcherDivider = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-switcher-divider`)
], CDSSwitcherDivider);
var CDSSwitcherDivider$1 = CDSSwitcherDivider;

},{"tslib":"gBS4y","lit":"aCmte","../../globals/settings.js":"EipuL","./header.scss.js":"4v21s","../../globals/decorators/carbon-element.js":"kNhLR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9porJ":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CDSSwitcherItem$1);
var _tslib = require("tslib");
var _classMapJs = require("lit/directives/class-map.js");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _carbonElementJs = require("../../globals/decorators/carbon-element.js");
var _settingsJs = require("../../globals/settings.js");
var _focusJs = require("../../globals/mixins/focus.js");
var _focusJsDefault = parcelHelpers.interopDefault(_focusJs);
var _headerScssJs = require("./header.scss.js");
var _headerScssJsDefault = parcelHelpers.interopDefault(_headerScssJs);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Switcher menu item.
 *
 * @element cds-switcher-item
 */ let CDSSwitcherItem = class CDSSwitcherItem extends (0, _focusJsDefault.default)((0, _lit.LitElement)) {
    constructor(){
        super(...arguments);
        /**
         * Link `href`.
         */ this.href = "";
        /**
         * Specify if this is a large variation of the side nav link
         */ this.selected = false;
        /**
         * Specify if this is a large variation of the side nav link
         */ this.tabIndex = 0;
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "listitem");
        super.connectedCallback();
    }
    render() {
        const { href, selected, ariaLabel, ariaLabelledBy, tabIndex } = this;
        const classes = (0, _classMapJs.classMap)({
            [`${0, _settingsJs.prefix}--switcher__item-link`]: true,
            [`${0, _settingsJs.prefix}--switcher__item-link--selected`]: selected
        });
        return (0, _lit.html)`
      <a
        part="link"
        aria-label="${ariaLabel}"
        aria-labelledby="${ariaLabelledBy}"
        tabindex="${tabIndex}"
        class="${classes}"
        href="${href}">
        <slot></slot>
      </a>
    `;
    }
};
CDSSwitcherItem.shadowRootOptions = Object.assign(Object.assign({}, (0, _lit.LitElement).shadowRootOptions), {
    delegatesFocus: true
});
CDSSwitcherItem.styles = (0, _headerScssJsDefault.default); // `styles` here is a `CSSResult` generated by custom Vite loader
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        attribute: "aria-label"
    })
], CDSSwitcherItem.prototype, "ariaLabel", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: String,
        attribute: "aria-labelledby"
    })
], CDSSwitcherItem.prototype, "ariaLabelledBy", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)()
], CDSSwitcherItem.prototype, "href", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Boolean,
        reflect: true
    })
], CDSSwitcherItem.prototype, "selected", void 0);
(0, _tslib.__decorate)([
    (0, _decoratorsJs.property)({
        type: Number,
        reflect: true,
        attribute: "tab-index"
    })
], CDSSwitcherItem.prototype, "tabIndex", void 0);
CDSSwitcherItem = (0, _tslib.__decorate)([
    (0, _carbonElementJs.carbonElement)(`${(0, _settingsJs.prefix)}-switcher-item`)
], CDSSwitcherItem);
var CDSSwitcherItem$1 = CDSSwitcherItem;

},{"tslib":"gBS4y","lit/directives/class-map.js":"2fQud","lit":"aCmte","lit/decorators.js":"kQrIl","../../globals/decorators/carbon-element.js":"kNhLR","../../globals/settings.js":"EipuL","../../globals/mixins/focus.js":"5k7ow","./header.scss.js":"4v21s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"66ETx":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _floatingMenuJs = require("./floating-menu.js");

},{"./floating-menu.js":"idlk7"}],"5T85f":[function(require,module,exports) {
/**
 * Copyright IBM Corp. 2018, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "baseFontSize", ()=>baseFontSize);
parcelHelpers.export(exports, "breakpoint", ()=>breakpoint);
parcelHelpers.export(exports, "breakpointDown", ()=>breakpointDown);
parcelHelpers.export(exports, "breakpointUp", ()=>breakpointUp);
parcelHelpers.export(exports, "breakpoints", ()=>breakpoints);
parcelHelpers.export(exports, "container", ()=>container);
parcelHelpers.export(exports, "container01", ()=>container01);
parcelHelpers.export(exports, "container02", ()=>container02);
parcelHelpers.export(exports, "container03", ()=>container03);
parcelHelpers.export(exports, "container04", ()=>container04);
parcelHelpers.export(exports, "container05", ()=>container05);
parcelHelpers.export(exports, "em", ()=>em);
parcelHelpers.export(exports, "fluidSpacing", ()=>fluidSpacing);
parcelHelpers.export(exports, "fluidSpacing01", ()=>fluidSpacing01);
parcelHelpers.export(exports, "fluidSpacing02", ()=>fluidSpacing02);
parcelHelpers.export(exports, "fluidSpacing03", ()=>fluidSpacing03);
parcelHelpers.export(exports, "fluidSpacing04", ()=>fluidSpacing04);
parcelHelpers.export(exports, "iconSize", ()=>iconSize);
parcelHelpers.export(exports, "iconSize01", ()=>iconSize01);
parcelHelpers.export(exports, "iconSize02", ()=>iconSize02);
parcelHelpers.export(exports, "layout", ()=>layout);
parcelHelpers.export(exports, "layout01", ()=>layout01);
parcelHelpers.export(exports, "layout02", ()=>layout02);
parcelHelpers.export(exports, "layout03", ()=>layout03);
parcelHelpers.export(exports, "layout04", ()=>layout04);
parcelHelpers.export(exports, "layout05", ()=>layout05);
parcelHelpers.export(exports, "layout06", ()=>layout06);
parcelHelpers.export(exports, "layout07", ()=>layout07);
parcelHelpers.export(exports, "miniUnit", ()=>miniUnit);
parcelHelpers.export(exports, "miniUnits", ()=>miniUnits);
parcelHelpers.export(exports, "px", ()=>px);
parcelHelpers.export(exports, "rem", ()=>rem);
parcelHelpers.export(exports, "size2XLarge", ()=>size2XLarge);
parcelHelpers.export(exports, "sizeLarge", ()=>sizeLarge);
parcelHelpers.export(exports, "sizeMedium", ()=>sizeMedium);
parcelHelpers.export(exports, "sizeSmall", ()=>sizeSmall);
parcelHelpers.export(exports, "sizeXLarge", ()=>sizeXLarge);
parcelHelpers.export(exports, "sizeXSmall", ()=>sizeXSmall);
parcelHelpers.export(exports, "sizes", ()=>sizes);
parcelHelpers.export(exports, "spacing", ()=>spacing);
parcelHelpers.export(exports, "spacing01", ()=>spacing01);
parcelHelpers.export(exports, "spacing02", ()=>spacing02);
parcelHelpers.export(exports, "spacing03", ()=>spacing03);
parcelHelpers.export(exports, "spacing04", ()=>spacing04);
parcelHelpers.export(exports, "spacing05", ()=>spacing05);
parcelHelpers.export(exports, "spacing06", ()=>spacing06);
parcelHelpers.export(exports, "spacing07", ()=>spacing07);
parcelHelpers.export(exports, "spacing08", ()=>spacing08);
parcelHelpers.export(exports, "spacing09", ()=>spacing09);
parcelHelpers.export(exports, "spacing10", ()=>spacing10);
parcelHelpers.export(exports, "spacing11", ()=>spacing11);
parcelHelpers.export(exports, "spacing12", ()=>spacing12);
parcelHelpers.export(exports, "spacing13", ()=>spacing13);
parcelHelpers.export(exports, "unstable_tokens", ()=>unstable_tokens);
var unstable_tokens = [
    // Spacing
    "spacing01",
    "spacing02",
    "spacing03",
    "spacing04",
    "spacing05",
    "spacing06",
    "spacing07",
    "spacing08",
    "spacing09",
    "spacing10",
    "spacing11",
    "spacing12",
    "spacing13",
    // Fluid spacing
    "fluidSpacing01",
    "fluidSpacing02",
    "fluidSpacing03",
    "fluidSpacing04",
    // Containers
    "container01",
    "container02",
    "container03",
    "container04",
    "container05",
    "sizeXSmall",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge",
    "sizeXLarge",
    "size2XLarge",
    // Icon sizes
    "iconSize01",
    "iconSize02",
    // Layout
    // Deprecated
    "layout01",
    "layout02",
    "layout03",
    "layout04",
    "layout05",
    "layout06",
    "layout07"
];
/**
 * Copyright IBM Corp. 2018, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Convert
// Default, Use with em() and rem() functions
var baseFontSize = 16;
/**
 * Convert a given px unit to a rem unit
 * @param {number} px
 * @returns {string}
 */ function rem(px) {
    return "".concat(px / baseFontSize, "rem");
}
/**
 * Convert a given px unit to a em unit
 * @param {number} px
 * @returns {string}
 */ function em(px) {
    return "".concat(px / baseFontSize, "em");
}
/**
 * Convert a given px unit to its string representation
 * @param {number} value - number of pixels
 * @returns {string}
 */ function px(value) {
    return "".concat(value, "px");
}
// Breakpoint
// Initial map of our breakpoints and their values
var breakpoints = {
    sm: {
        width: rem(320),
        columns: 4,
        margin: "0"
    },
    md: {
        width: rem(672),
        columns: 8,
        margin: rem(16)
    },
    lg: {
        width: rem(1056),
        columns: 16,
        margin: rem(16)
    },
    xlg: {
        width: rem(1312),
        columns: 16,
        margin: rem(16)
    },
    max: {
        width: rem(1584),
        columns: 16,
        margin: rem(24)
    }
};
function breakpointUp(name) {
    return "@media (min-width: ".concat(breakpoints[name].width, ")");
}
function breakpointDown(name) {
    return "@media (max-width: ".concat(breakpoints[name].width, ")");
}
function breakpoint() {
    return breakpointUp.apply(void 0, arguments);
}
// Mini-unit
var miniUnit = 8;
function miniUnits(count) {
    return rem(miniUnit * count);
}
// Spacing
var spacing01 = miniUnits(0.25);
var spacing02 = miniUnits(0.5);
var spacing03 = miniUnits(1);
var spacing04 = miniUnits(1.5);
var spacing05 = miniUnits(2);
var spacing06 = miniUnits(3);
var spacing07 = miniUnits(4);
var spacing08 = miniUnits(5);
var spacing09 = miniUnits(6);
var spacing10 = miniUnits(8);
var spacing11 = miniUnits(10);
var spacing12 = miniUnits(12);
var spacing13 = miniUnits(20);
var spacing = [
    spacing01,
    spacing02,
    spacing03,
    spacing04,
    spacing05,
    spacing06,
    spacing07,
    spacing08,
    spacing09,
    spacing10,
    spacing11,
    spacing12,
    spacing13
];
// Fluid spacing
var fluidSpacing01 = 0;
var fluidSpacing02 = "2vw";
var fluidSpacing03 = "5vw";
var fluidSpacing04 = "10vw";
var fluidSpacing = [
    fluidSpacing01,
    fluidSpacing02,
    fluidSpacing03,
    fluidSpacing04
];
// Layout
// Deprecated
var layout01 = miniUnits(2);
var layout02 = miniUnits(3);
var layout03 = miniUnits(4);
var layout04 = miniUnits(6);
var layout05 = miniUnits(8);
var layout06 = miniUnits(12);
var layout07 = miniUnits(20);
var layout = [
    layout01,
    layout02,
    layout03,
    layout04,
    layout05,
    layout06,
    layout07
];
// Container
var container01 = miniUnits(3);
var container02 = miniUnits(4);
var container03 = miniUnits(5);
var container04 = miniUnits(6);
var container05 = miniUnits(8);
var container = [
    container01,
    container02,
    container03,
    container04,
    container05
];
var sizeXSmall = rem(24);
var sizeSmall = rem(32);
var sizeMedium = rem(40);
var sizeLarge = rem(48);
var sizeXLarge = rem(64);
var size2XLarge = rem(80);
var sizes = {
    XSmall: sizeXSmall,
    Small: sizeSmall,
    Medium: sizeMedium,
    Large: sizeLarge,
    XLarge: sizeXLarge,
    "2XLarge": size2XLarge
};
// Icon
var iconSize01 = "1rem";
var iconSize02 = "1.25rem";
var iconSize = [
    iconSize01,
    iconSize02
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["8RSWf"], "8RSWf", "parcelRequireab56")

//# sourceMappingURL=index.a20b76c7.js.map
